(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Plansheet = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var eachOfLimit = require('async.util.eachoflimit');
var withoutIndex = require('async.util.withoutindex');

module.exports = function eachLimit(arr, limit, iterator, cb) {
    return eachOfLimit(limit)(arr, withoutIndex(iterator), cb);
};

},{"async.util.eachoflimit":3,"async.util.withoutindex":14}],2:[function(require,module,exports){
'use strict';

module.exports = function(tasks) {
    function makeCallback(index) {
        function fn() {
            if (tasks.length) {
                tasks[index].apply(null, arguments);
            }
            return fn.next();
        }
        fn.next = function() {
            return (index < tasks.length - 1) ? makeCallback(index + 1) : null;
        };
        return fn;
    }
    return makeCallback(0);
};

},{}],3:[function(require,module,exports){
var once = require('async.util.once');
var noop = require('async.util.noop');
var onlyOnce = require('async.util.onlyonce');
var keyIterator = require('async.util.keyiterator');

module.exports = function eachOfLimit(limit) {
    return function(obj, iterator, cb) {
        cb = once(cb || noop);
        obj = obj || [];
        var nextKey = keyIterator(obj);
        if (limit <= 0) {
            return cb(null);
        }
        var done = false;
        var running = 0;
        var errored = false;

        (function replenish() {
            if (done && running <= 0) {
                return cb(null);
            }

            while (running < limit && !errored) {
                var key = nextKey();
                if (key === null) {
                    done = true;
                    if (running <= 0) {
                        cb(null);
                    }
                    return;
                }
                running += 1;
                iterator(obj[key], key, onlyOnce(function(err) {
                    running -= 1;
                    if (err) {
                        cb(err);
                        errored = true;
                    } else {
                        replenish();
                    }
                }));
            }
        })();
    };
};

},{"async.util.keyiterator":7,"async.util.noop":9,"async.util.once":10,"async.util.onlyonce":11}],4:[function(require,module,exports){
'use strict';
var setImmediate = require('async.util.setimmediate');
var restParam = require('async.util.restparam');

module.exports = function(fn) {
    return restParam(function(args) {
        var callback = args.pop();
        args.push(function() {
            var innerArgs = arguments;
            if (sync) {
                setImmediate(function() {
                    callback.apply(null, innerArgs);
                });
            } else {
                callback.apply(null, innerArgs);
            }
        });
        var sync = true;
        fn.apply(this, args);
        sync = false;
    });
};

},{"async.util.restparam":12,"async.util.setimmediate":13}],5:[function(require,module,exports){
'use strict';

module.exports = Array.isArray || function isArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
};

},{}],6:[function(require,module,exports){
'use strict';

var isArray = require('async.util.isarray');

module.exports = function isArrayLike(arr) {
    return isArray(arr) || (
        // has a positive integer length property
        typeof arr.length === 'number' &&
        arr.length >= 0 &&
        arr.length % 1 === 0
    );
};

},{"async.util.isarray":5}],7:[function(require,module,exports){
'use strict';

var _keys = require('async.util.keys');
var isArrayLike = require('async.util.isarraylike');

module.exports = function keyIterator(coll) {
    var i = -1;
    var len;
    var keys;
    if (isArrayLike(coll)) {
        len = coll.length;
        return function next() {
            i++;
            return i < len ? i : null;
        };
    } else {
        keys = _keys(coll);
        len = keys.length;
        return function next() {
            i++;
            return i < len ? keys[i] : null;
        };
    }
};

},{"async.util.isarraylike":6,"async.util.keys":8}],8:[function(require,module,exports){
'use strict';

module.exports = Object.keys || function keys(obj) {
    var _keys = [];
    for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
            _keys.push(k);
        }
    }
    return _keys;
};

},{}],9:[function(require,module,exports){
'use strict';

module.exports = function noop () {};

},{}],10:[function(require,module,exports){
'use strict';

module.exports = function once(fn) {
    return function() {
        if (fn === null) return;
        fn.apply(this, arguments);
        fn = null;
    };
};

},{}],11:[function(require,module,exports){
'use strict';

module.exports = function only_once(fn) {
    return function() {
        if (fn === null) throw new Error('Callback was already called.');
        fn.apply(this, arguments);
        fn = null;
    };
};

},{}],12:[function(require,module,exports){
'use strict';
module.exports = function restParam(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0);
        var rest = new Array(length);
        for (var index = 0; index < length; index++) {
            rest[index] = arguments[index + startIndex];
        }
        switch (startIndex) {
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
        }
    };
};

},{}],13:[function(require,module,exports){
(function (setImmediate){(function (){
'use strict';

var _setImmediate = typeof setImmediate === 'function' && setImmediate;
var fallback = function(fn) {
    setTimeout(fn, 0);
};

module.exports = function setImmediate(fn) {
    // not a direct alias for IE10 compatibility
    return (_setImmediate || fallback)(fn);
};

}).call(this)}).call(this,require("timers").setImmediate)

},{"timers":545}],14:[function(require,module,exports){
'use strict';

module.exports = function withoutIndex(iterator) {
    return function(value, index, callback) {
        return iterator(value, callback);
    };
};

},{}],15:[function(require,module,exports){
'use strict';

var once = require('async.util.once');
var noop = require('async.util.noop');
var isArray = require('async.util.isarray');
var restParam = require('async.util.restparam');
var ensureAsync = require('async.util.ensureasync');
var iterator = require('async.iterator');

module.exports = function(tasks, cb) {
    cb = once(cb || noop);
    if (!isArray(tasks)) return cb(new Error('First argument to waterfall must be an array of functions'));
    if (!tasks.length) return cb();

    function wrapIterator(iterator) {
        return restParam(function(err, args) {
            if (err) {
                cb.apply(null, [err].concat(args));
            } else {
                var next = iterator.next();
                if (next) {
                    args.push(wrapIterator(next));
                } else {
                    args.push(cb);
                }
                ensureAsync(iterator).apply(null, args);
            }
        });
    }
    wrapIterator(iterator(tasks))();
};

},{"async.iterator":2,"async.util.ensureasync":4,"async.util.isarray":5,"async.util.noop":9,"async.util.once":10,"async.util.restparam":12}],16:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],17:[function(require,module,exports){
/*
 *  big.js v7.0.1
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2025 Michael Mclaughlin
 *  https://github.com/MikeMcl/big.js/LICENCE.md
 */
;(function (GLOBAL) {
  'use strict';
  var Big,


/************************************** EDITABLE DEFAULTS *****************************************/


    // The default values below must be integers within the stated ranges.

    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */
    DP = 20,            // 0 to MAX_DP

    /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */
    RM = 1,             // 0, 1, 2 or 3

    // The maximum value of DP and Big.DP.
    MAX_DP = 1E6,       // 0 to 1000000

    // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6,    // 1 to 1000000

    /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */
    NE = -7,            // 0 to -1000000

    /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
     */
    PE = 21,            // 0 to 1000000

    /*
     * When true, an error will be thrown if a primitive number is passed to the Big constructor,
     * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
     * primitive number without a loss of precision.
     */
    STRICT = false,     // true or false


/**************************************************************************************************/


    // Error messages.
    NAME = '[big.js] ',
    INVALID = NAME + 'Invalid ',
    INVALID_DP = INVALID + 'decimal places',
    INVALID_RM = INVALID + 'rounding mode',
    DIV_BY_ZERO = NAME + 'Division by zero',

    // The shared prototype object.
    P = {},
    UNDEFINED = void 0,
    NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;


  /*
   * Create and return a Big constructor.
   */
  function _Big_() {

    /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */
    function Big(n) {
      var x = this;

      // Enable constructor usage without new.
      if (!(x instanceof Big)) {
        return n === UNDEFINED && arguments.length === 0 ? _Big_() : new Big(n);
      }

      // Duplicate.
      if (n instanceof Big) {
        x.s = n.s;
        x.e = n.e;
        x.c = n.c.slice();
      } else {
        if (typeof n !== 'string') {
          if (Big.strict === true && typeof n !== 'bigint') {
            throw TypeError(INVALID + 'value');
          }

          // Minus zero?
          n = n === 0 && 1 / n < 0 ? '-0' : String(n);
        }

        parse(x, n);
      }

      // Retain a reference to this Big constructor.
      // Shadow Big.prototype.constructor which points to Object.
      x.constructor = Big;
    }

    Big.prototype = P;
    Big.DP = DP;
    Big.RM = RM;
    Big.NE = NE;
    Big.PE = PE;
    Big.strict = STRICT;
    Big.roundDown = 0;
    Big.roundHalfUp = 1;
    Big.roundHalfEven = 2;
    Big.roundUp = 3;

    return Big;
  }


  /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */
  function parse(x, n) {
    var e, i, nl;

    if (!NUMERIC.test(n)) {
      throw Error(INVALID + 'number');
    }

    // Determine sign.
    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;

    // Decimal point?
    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');

    // Exponential form?
    if ((i = n.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +n.slice(i + 1);
      n = n.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = n.length;
    }

    nl = n.length;

    // Determine leading zeros.
    for (i = 0; i < nl && n.charAt(i) == '0';) ++i;

    if (i == nl) {

      // Zero.
      x.c = [x.e = 0];
    } else {

      // Determine trailing zeros.
      for (; nl > 0 && n.charAt(--nl) == '0';);
      x.e = e - i - 1;
      x.c = [];

      // Convert string to array of digits without leading/trailing zeros.
      for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
    }

    return x;
  }


  /*
   * Round Big x to a maximum of sd significant digits using rounding mode rm.
   *
   * x {Big} The Big to round.
   * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
   * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   * [more] {boolean} Whether the result of division was truncated.
   */
  function round(x, sd, rm, more) {
    var xc = x.c;

    if (rm === UNDEFINED) rm = x.constructor.RM;
    if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) {
      throw Error(INVALID_RM);
    }

    if (sd < 1) {
      more =
        rm === 3 && (more || !!xc[0]) || sd === 0 && (
        rm === 1 && xc[0] >= 5 ||
        rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED))
      );

      xc.length = 1;

      if (more) {

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        x.e = x.e - sd + 1;
        xc[0] = 1;
      } else {

        // Zero.
        xc[0] = x.e = 0;
      }
    } else if (sd < xc.length) {

      // xc[sd] is the digit after the digit that may be rounded up.
      more =
        rm === 1 && xc[sd] >= 5 ||
        rm === 2 && (xc[sd] > 5 || xc[sd] === 5 &&
          (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) ||
        rm === 3 && (more || !!xc[0]);

      // Remove any digits after the required precision.
      xc.length = sd;

      // Round up?
      if (more) {

        // Rounding up may mean the previous digit has to be rounded up.
        for (; ++xc[--sd] > 9;) {
          xc[sd] = 0;
          if (sd === 0) {
            ++x.e;
            xc.unshift(1);
            break;
          }
        }
      }

      // Remove trailing zeros.
      for (sd = xc.length; !xc[--sd];) xc.pop();
    }

    return x;
  }


  /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   */
  function stringify(x, doExponential, isNonzero) {
    var e = x.e,
      s = x.c.join(''),
      n = s.length;

    // Exponential notation?
    if (doExponential) {
      s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;

    // Normal notation.
    } else if (e < 0) {
      for (; ++e;) s = '0' + s;
      s = '0.' + s;
    } else if (e > 0) {
      if (++e > n) {
        for (e -= n; e--;) s += '0';
      } else if (e < n) {
        s = s.slice(0, e) + '.' + s.slice(e);
      }
    } else if (n > 1) {
      s = s.charAt(0) + '.' + s.slice(1);
    }

    return x.s < 0 && isNonzero ? '-' + s : s;
  }


  // Prototype/instance methods


  /*
   * Return a new Big whose value is the absolute value of this Big.
   */
  P.abs = function () {
    var x = new this.constructor(this);
    x.s = 1;
    return x;
  };


  /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
   */
  P.cmp = function (y) {
    var isneg,
      x = this,
      xc = x.c,
      yc = (y = new x.constructor(y)).c,
      i = x.s,
      j = y.s,
      k = x.e,
      l = y.e;

    // Either zero?
    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;

    // Signs differ?
    if (i != j) return i;

    isneg = i < 0;

    // Compare exponents.
    if (k != l) return k > l ^ isneg ? 1 : -1;

    j = (k = xc.length) < (l = yc.length) ? k : l;

    // Compare digit by digit.
    for (i = -1; ++i < j;) {
      if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
    }

    // Compare lengths.
    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
  };


  /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */
  P.div = function (y) {
    var x = this,
      Big = x.constructor,
      a = x.c,                  // dividend
      b = (y = new Big(y)).c,   // divisor
      k = x.s == y.s ? 1 : -1,
      dp = Big.DP;

    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }

    // Divisor is zero?
    if (!b[0]) {
      throw Error(DIV_BY_ZERO);
    }

    // Dividend is 0? Return +-0.
    if (!a[0]) {
      y.s = k;
      y.c = [y.e = 0];
      return y;
    }

    var bl, bt, n, cmp, ri,
      bz = b.slice(),
      ai = bl = b.length,
      al = a.length,
      r = a.slice(0, bl),   // remainder
      rl = r.length,
      q = y,                // quotient
      qc = q.c = [],
      qi = 0,
      p = dp + (q.e = x.e - y.e) + 1;    // precision of the result

    q.s = k;
    k = p < 0 ? 0 : p;

    // Create version of divisor with leading zero.
    bz.unshift(0);

    // Add zeros to make remainder as long as divisor.
    for (; rl++ < bl;) r.push(0);

    do {

      // n is how many times the divisor goes into current remainder.
      for (n = 0; n < 10; n++) {

        // Compare divisor and remainder.
        if (bl != (rl = r.length)) {
          cmp = bl > rl ? 1 : -1;
        } else {
          for (ri = -1, cmp = 0; ++ri < bl;) {
            if (b[ri] != r[ri]) {
              cmp = b[ri] > r[ri] ? 1 : -1;
              break;
            }
          }
        }

        // If divisor < remainder, subtract divisor from remainder.
        if (cmp < 0) {

          // Remainder can't be more than 1 digit longer than divisor.
          // Equalise lengths using divisor with extra leading zero?
          for (bt = rl == bl ? b : bz; rl;) {
            if (r[--rl] < bt[rl]) {
              ri = rl;
              for (; ri && !r[--ri];) r[ri] = 9;
              --r[ri];
              r[rl] += 10;
            }
            r[rl] -= bt[rl];
          }

          for (; !r[0];) r.shift();
        } else {
          break;
        }
      }

      // Add the digit n to the result array.
      qc[qi++] = cmp ? n : ++n;

      // Update the remainder.
      if (r[0] && cmp) r[rl] = a[ai] || 0;
      else r = [a[ai]];

    } while ((ai++ < al || r[0] !== UNDEFINED) && k--);

    // Leading zero? Do not remove if result is simply zero (qi == 1).
    if (!qc[0] && qi != 1) {

      // There can't be more than one zero.
      qc.shift();
      q.e--;
      p--;
    }

    // Round?
    if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);

    return q;
  };


  /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */
  P.eq = function (y) {
    return this.cmp(y) === 0;
  };


  /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */
  P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */
  P.gte = function (y) {
    return this.cmp(y) > -1;
  };


  /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */
  P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */
  P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */
  P.minus = P.sub = function (y) {
    var i, j, t, xlty,
      x = this,
      Big = x.constructor,
      a = x.s,
      b = (y = new Big(y)).s;

    // Signs differ?
    if (a != b) {
      y.s = -b;
      return x.plus(y);
    }

    var xc = x.c.slice(),
      xe = x.e,
      yc = y.c,
      ye = y.e;

    // Either zero?
    if (!xc[0] || !yc[0]) {
      if (yc[0]) {
        y.s = -b;
      } else if (xc[0]) {
        y = new Big(x);
      } else {
        y.s = 1;
      }
      return y;
    }

    // Determine which is the bigger number. Prepend zeros to equalise exponents.
    if (a = xe - ye) {

      if (xlty = a < 0) {
        a = -a;
        t = xc;
      } else {
        ye = xe;
        t = yc;
      }

      t.reverse();
      for (b = a; b--;) t.push(0);
      t.reverse();
    } else {

      // Exponents equal. Check digit by digit.
      j = ((xlty = xc.length < yc.length) ? xc : yc).length;

      for (a = b = 0; b < j; b++) {
        if (xc[b] != yc[b]) {
          xlty = xc[b] < yc[b];
          break;
        }
      }
    }

    // x < y? Point xc to the array of the bigger number.
    if (xlty) {
      t = xc;
      xc = yc;
      yc = t;
      y.s = -y.s;
    }

    /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */
    if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;

    // Subtract yc from xc.
    for (b = i; j > a;) {
      if (xc[--j] < yc[j]) {
        for (i = j; i && !xc[--i];) xc[i] = 9;
        --xc[i];
        xc[j] += 10;
      }

      xc[j] -= yc[j];
    }

    // Remove trailing zeros.
    for (; xc[--b] === 0;) xc.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xc[0] === 0;) {
      xc.shift();
      --ye;
    }

    if (!xc[0]) {

      // n - n = +0
      y.s = 1;

      // Result must be zero.
      xc = [ye = 0];
    }

    y.c = xc;
    y.e = ye;

    return y;
  };


  /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */
  P.mod = function (y) {
    var ygtx,
      x = this,
      Big = x.constructor,
      a = x.s,
      b = (y = new Big(y)).s;

    if (!y.c[0]) {
      throw Error(DIV_BY_ZERO);
    }

    x.s = y.s = 1;
    ygtx = y.cmp(x) == 1;
    x.s = a;
    y.s = b;

    if (ygtx) return new Big(x);

    a = Big.DP;
    b = Big.RM;
    Big.DP = Big.RM = 0;
    x = x.div(y);
    Big.DP = a;
    Big.RM = b;

    return this.minus(x.times(y));
  };


  /*
   * Return a new Big whose value is the value of this Big negated.
   */
  P.neg = function () {
    var x = new this.constructor(this);
    x.s = -x.s;
    return x;
  };


  /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */
  P.plus = P.add = function (y) {
    var e, k, t,
      x = this,
      Big = x.constructor;

    y = new Big(y);

    // Signs differ?
    if (x.s != y.s) {
      y.s = -y.s;
      return x.minus(y);
    }

    var xe = x.e,
      xc = x.c,
      ye = y.e,
      yc = y.c;

    // Either zero?
    if (!xc[0] || !yc[0]) {
      if (!yc[0]) {
        if (xc[0]) {
          y = new Big(x);
        } else {
          y.s = x.s;
        }
      }
      return y;
    }

    xc = xc.slice();

    // Prepend zeros to equalise exponents.
    // Note: reverse faster than unshifts.
    if (e = xe - ye) {
      if (e > 0) {
        ye = xe;
        t = yc;
      } else {
        e = -e;
        t = xc;
      }

      t.reverse();
      for (; e--;) t.push(0);
      t.reverse();
    }

    // Point xc to the longer array.
    if (xc.length - yc.length < 0) {
      t = yc;
      yc = xc;
      xc = t;
    }

    e = yc.length;

    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
    for (k = 0; e; xc[e] %= 10) k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;

    // No need to check for zero, as +x + +y != 0 && -x + -y != 0

    if (k) {
      xc.unshift(k);
      ++ye;
    }

    // Remove trailing zeros.
    for (e = xc.length; xc[--e] === 0;) xc.pop();

    y.c = xc;
    y.e = ye;

    return y;
  };


  /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */
  P.pow = function (n) {
    var x = this,
      one = new x.constructor('1'),
      y = one,
      isneg = n < 0;

    if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
      throw Error(INVALID + 'exponent');
    }

    if (isneg) n = -n;

    for (;;) {
      if (n & 1) y = y.times(x);
      n >>= 1;
      if (!n) break;
      x = x.times(x);
    }

    return isneg ? one.div(y) : y;
  };


  /*
   * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
   * significant digits using rounding mode rm, or Big.RM if rm is not specified.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.prec = function (sd, rm) {
    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
      throw Error(INVALID + 'precision');
    }
    return round(new this.constructor(this), sd, rm);
  };


  /*
   * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
   * using rounding mode rm, or Big.RM if rm is not specified.
   * If dp is negative, round to an integer which is a multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.round = function (dp, rm) {
    if (dp === UNDEFINED) dp = 0;
    else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    return round(new this.constructor(this), dp + this.e + 1, rm);
  };


  /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */
  P.sqrt = function () {
    var r, c, t,
      x = this,
      Big = x.constructor,
      s = x.s,
      e = x.e,
      half = new Big('0.5');

    // Zero?
    if (!x.c[0]) return new Big(x);

    // Negative?
    if (s < 0) {
      throw Error(NAME + 'No square root');
    }

    // Estimate.
    s = Math.sqrt(+stringify(x, true, true));

    // Math.sqrt underflow/overflow?
    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
    if (s === 0 || s === 1 / 0) {
      c = x.c.join('');
      if (!(c.length + e & 1)) c += '0';
      s = Math.sqrt(c);
      e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
      r = new Big((s == 1 / 0 ? '5e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
    } else {
      r = new Big(s + '');
    }

    e = r.e + (Big.DP += 4);

    // Newton-Raphson iteration.
    do {
      t = r;
      r = half.times(t.plus(x.div(t)));
    } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));

    return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
  };


  /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */
  P.times = P.mul = function (y) {
    var c,
      x = this,
      Big = x.constructor,
      xc = x.c,
      yc = (y = new Big(y)).c,
      a = xc.length,
      b = yc.length,
      i = x.e,
      j = y.e;

    // Determine sign of result.
    y.s = x.s == y.s ? 1 : -1;

    // Return signed 0 if either 0.
    if (!xc[0] || !yc[0]) {
      y.c = [y.e = 0];
      return y;
    }

    // Initialise exponent of result as x.e + y.e.
    y.e = i + j;

    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
    if (a < b) {
      c = xc;
      xc = yc;
      yc = c;
      j = a;
      a = b;
      b = j;
    }

    // Initialise coefficient array of result with zeros.
    for (c = new Array(j = a + b); j--;) c[j] = 0;

    // Multiply.

    // i is initially xc.length.
    for (i = b; i--;) {
      b = 0;

      // a is yc.length.
      for (j = a + i; j > i;) {

        // Current sum of products at this digit position, plus carry.
        b = c[j] + yc[i] * xc[j - i - 1] + b;
        c[j--] = b % 10;

        // carry
        b = b / 10 | 0;
      }

      c[j] = b;
    }

    // Increment result exponent if there is a final carry, otherwise remove leading zero.
    if (b) ++y.e;
    else c.shift();

    // Remove trailing zeros.
    for (i = c.length; !c[--i];) c.pop();
    y.c = c;

    return y;
  };


  /*
   * Return a string representing the value of this Big in exponential notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.toExponential = function (dp, rm) {
    var x = this,
      n = x.c[0];

    if (dp !== UNDEFINED) {
      if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
        throw Error(INVALID_DP);
      }
      x = round(new x.constructor(x), ++dp, rm);
      for (; x.c.length < dp;) x.c.push(0);
    }

    return stringify(x, true, !!n);
  };


  /*
   * Return a string representing the value of this Big in normal notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */
  P.toFixed = function (dp, rm) {
    var x = this,
      n = x.c[0];

    if (dp !== UNDEFINED) {
      if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
        throw Error(INVALID_DP);
      }
      x = round(new x.constructor(x), dp + x.e + 1, rm);

      // x.e may have changed if the value is rounded up.
      for (dp = dp + x.e + 1; x.c.length < dp;) x.c.push(0);
    }

    return stringify(x, false, !!n);
  };


  /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */
  P.toJSON = P.toString = function () {
    var x = this,
      Big = x.constructor;
    return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
  };


  /*
   * Return the value of this Big as a primitve number.
   */
  P.toNumber = function () {
    var n = +stringify(this, true, true);
    if (this.constructor.strict === true && !this.eq(n.toString())) {
      throw Error(NAME + 'Imprecise conversion');
    }
    return n;
  };


  /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * rounding mode rm, or Big.RM if rm is not specified.
   * Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.toPrecision = function (sd, rm) {
    var x = this,
      Big = x.constructor,
      n = x.c[0];

    if (sd !== UNDEFINED) {
      if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
        throw Error(INVALID + 'precision');
      }
      x = round(new Big(x), sd, rm);
      for (; x.c.length < sd;) x.c.push(0);
    }

    return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
  };


  /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */
  P.valueOf = function () {
    var x = this,
      Big = x.constructor;
    if (Big.strict === true) {
      throw Error(NAME + 'valueOf disallowed');
    }
    return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
  };


  // Export


  Big = _Big_();

  Big['default'] = Big.Big = Big;

  //AMD.
  if (typeof define === 'function' && define.amd) {
    define(function () { return Big; });

  // Node and other CommonJS-like environments that support module.exports.
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = Big;

  //Browser.
  } else {
    GLOBAL.Big = Big;
  }
})(this);

},{}],18:[function(require,module,exports){

},{}],19:[function(require,module,exports){
arguments[4][18][0].apply(exports,arguments)
},{"dup":18}],20:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"base64-js":16,"buffer":20,"ieee754":117}],21:[function(require,module,exports){
module.exports = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Unordered Collection",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "451": "Unavailable For Legal Reasons",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
}

},{}],22:[function(require,module,exports){
/**
* Cache data structure with:
*  - enumerable items
*  - unique hash item access (if none is passed in, one is generated)
*  - size (length) expiration
*  - controllable expiration (e.g. keep in cache longer if older/less likely to change)
*  - time-based expiration
*  - custom expiration based on passed-in function
*
* Also:
*  - built to work well with browserify
*  - pet friendly
*
* @author Steven Velozo <steven@velozo.com>
*/
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libLinkedList = require(`./LinkedList.js`);

class CashMoney extends libFableServiceProviderBase
{
	constructor(pFable, pManifest, pServiceHash)
	{
		if (pFable === undefined)
		{
			super({});
		}
		else
		{
			super(pFable, pManifest, pServiceHash);
		}

        this.serviceType = 'ObjectCache';

		// The map of node objects by hash because Reasons.
		this._HashMap = {};

		this._RecordMap = {};

		this._List = new libLinkedList();

		// If the list gets over maxLength, we will automatically remove nodes on insertion.
		this.maxLength = 0;

		// If cache entries get over this age, they are removed with prune
		this.maxAge = 0;
	}

	get RecordMap()
	{
		return this._RecordMap;
	}

	// Add (or update) a node in the cache
	put(pData, pHash)
	{
		// If the hash of the record exists
		if (this._HashMap.hasOwnProperty(pHash))
		{
			// Just update the hashed records datum
			this._HashMap[pHash].Datum = pData;
			this._RecordMap[pHash] = pData;
			return this._HashMap[pHash].Datum;
		}

		let tmpNode = this._List.push(pData, pHash);
		this._HashMap[tmpNode.Hash] = tmpNode;
		this._RecordMap[pHash] = pData;

		// Automatically prune if over length, but only prune this nodes worth.
		if (this.maxLength > 0   &&   this._List.length > this.maxLength)
		{
			// Pop it off the head of the list
			tmpNode = this._List.pop();
			// Also remove it from the hashmap
			delete this._RecordMap[tmpNode.Hash];
			delete this._HashMap[tmpNode.Hash];
		}

		// Now some expiration properties on the node metadata... namely the birthdate in ms of the node
		tmpNode.Metadata.Created = +new Date();

		return tmpNode.Datum;
	}

	// Read a datum by hash from the cache
	read(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
		{
			return false;
		}

		return this._HashMap[pHash].Datum;
	}

	// Reinvigorate a node based on hash, updating the timestamp and moving it to the head of the list (also removes custom metadata)
	touch(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
		{
			return false;
		}

		// Get the old node out of the list
		let tmpNode = this._List.remove(this._HashMap[pHash]);
		// Remove it from the hash map
		delete this._RecordMap[pHash];
		delete this._HashMap[pHash];

		// Now put it back, fresh.
		return this.put(tmpNode.Datum, tmpNode.Hash);
	}

	// Expire a cached record based on hash
	expire(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
		{
			return false;
		}

		let tmpNode = this._HashMap[pHash];

		// Remove it from the list of cached records
		tmpNode = this._List.remove(tmpNode);
		// Also remove it from the hashmap
		delete this._RecordMap[tmpNode.Hash];
		delete this._HashMap[tmpNode.Hash];

		// Return it in case the consumer wants to do anything with it
		return tmpNode;
	}

	// Prune records from the cached set based on maxAge
	pruneBasedOnExpiration(fComplete, pRemovedRecords)
	{
		let tmpRemovedRecords = (typeof(pRemovedRecords) === 'undefined') ? [] : pRemovedRecords;

		if (this.maxAge < 1)
		{
			return fComplete(tmpRemovedRecords);
		}

		// Now enumerate each record and remove any that are expired
		let tmpNow = +new Date();
		let tmpKeys = Object.keys(this._HashMap);

		for (let i = 0; i < tmpKeys.length; i++)
		{
			// Expire the node if it is older than max age milliseconds
			if (tmpNow - this._HashMap[tmpKeys[i]].Metadata.Created >= this.maxAge)
			{
				tmpRemovedRecords.push(this.expire(tmpKeys[i]));
			}
		}
		fComplete(tmpRemovedRecords);
	}

	// Prune records from the cached set based on maxLength
	pruneBasedOnLength(fComplete, pRemovedRecords)
	{
		let tmpRemovedRecords = (typeof(pRemovedRecords) === 'undefined') ? [] : pRemovedRecords;

		// Pop records off until we have reached maxLength unless it's 0
		if (this.maxLength > 0)
		{
			while (this._List.length > this.maxLength)
			{
				tmpRemovedRecords.push(this._List.pop());
			}
		}

		return fComplete(tmpRemovedRecords);
	}

	// Prune records from the cached set based on passed in pPruneFunction(pDatum, pHash, pNode) -- returning true expires it
	pruneCustom(fComplete, fPruneFunction, pRemovedRecords)
	{
		let tmpRemovedRecords = (typeof(pRemovedRecords) === 'undefined') ? [] : pRemovedRecords;

		let tmpKeys = Object.keys(this._HashMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpNode = this._HashMap[tmpKeys[i]];
			// Expire the node if the passed in function returns true
			if (fPruneFunction(tmpNode.Datum, tmpNode.Hash, tmpNode))
			{
				tmpRemovedRecords.push(this.expire(tmpKeys[i]));
			}
		}
		fComplete(tmpRemovedRecords);
	}

	// Prune the list down to the asserted rules (max age then max length if still too long)
	prune(fComplete)
	{
		let tmpRemovedRecords = [];

		// If there are no cached records, we are done.
		if (this._List.length < 1)
		{
			return fComplete(tmpRemovedRecords);
		}

		// Now prune based on expiration time
		this.pruneBasedOnExpiration((fExpirationPruneComplete)=>
			{
				// Now prune based on length, then return the removed records in the callback.
				this.pruneBasedOnLength(fComplete, tmpRemovedRecords);
			}, tmpRemovedRecords);
	}

	// Get a low level node (including metadata statistics) by hash from the cache
	getNode(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
			return false;

		return this._HashMap[pHash];
	}
}

module.exports = CashMoney;
},{"./LinkedList.js":24,"fable-serviceproviderbase":59}],23:[function(require,module,exports){
/**
* Double Linked List Node
*
* @author Steven Velozo <steven@velozo.com>
* @module CashMoney
*/

/**
* Linked List Node Prototype
*
* @class LinkedListNode
* @constructor
*/

class LinkedListNode
{
	constructor()
	{
		this.Hash = false;
		this.Datum = false;

		// This is where expiration and other elements are stored;
		this.Metadata = {};

		this.LeftNode = false;
		this.RightNode = false;

		// To allow safe specialty operations on nodes
		this.__ISNODE = true;
	}
}

module.exports = LinkedListNode;
},{}],24:[function(require,module,exports){
"use strict"
/**
* Simple double linked list to hold the cache entries in, in order.
*
* @author Steven Velozo <steven@velozo.com>
* @module FeeFiFo
*/

const libLinkedListNode = require('./LinkedList-Node.js');

/**
* Quality Cache Goodness
*
* @class CashMoney
* @constructor
*/

class LinkedList
{
	constructor()
	{
		// Total number of nodes ever processed by this ADT
		this.totalNodes = 0;

		// The length of the set of nodes currently in the list
		this.length = 0;

		this.head = false;
		this.tail = false;
	}

	// Create a node object.
	initializeNode(pDatum, pHash)
	{
		// Don't allow undefined to be added to the list because of reasons
		if (typeof(pDatum) === 'undefined')
			return false;

		this.totalNodes++;

		// Get (or create) a unique hash
		let tmpHash = (typeof(pHash) != 'undefined') ? pHash : `NODE[${this.totalNodes}]`;

		let tmpNode = new libLinkedListNode();

		tmpNode.Hash = tmpHash;
		tmpNode.Datum = pDatum;

		return tmpNode;
	}

	// Add a node to the end (right of tail) of the list.
	append(pDatum, pHash)
	{
		// TODO: Should we check if pDatum is actually a node and do the "right" thing?
		let tmpNode = this.initializeNode(pDatum, pHash);
		if (!tmpNode)
			return false;

		// The list just got longer!
		this.length++;

		// If the list was empty, create a new list from it (it isn't possible to have a tail with no head)
		if (this.length == 1)
		{
			this.head = tmpNode;
			this.tail = tmpNode;
			return tmpNode;
		}

		this.tail.RightNode = tmpNode;
		tmpNode.LeftNode = this.tail;
		this.tail = tmpNode;

		return tmpNode;
	}

	// Append to tail of list (FIFO)
	push(pDatum, pHash)
	{
		return this.append(pDatum, pHash);
	}

	// Add a node to the beginning (left of head) of the list.
	prepend(pDatum, pHash)
	{
		// TODO: Should we check if pDatum is actually a node and do the "right" thing?
		let tmpNode = this.initializeNode(pDatum, pHash);
		if (!tmpNode)
			return false;

		// The list just got longer!
		this.length++;

		// If the list was empty, create a new list from it (it isn't possible to have a tail with no head)
		if (this.length == 1)
		{
			this.head = tmpNode;
			this.tail = tmpNode;
			return tmpNode;
		}

		this.head.LeftNode = tmpNode;
		tmpNode.RightNode = this.head;
		this.head = tmpNode;
		return tmpNode;
	}

	// Remove a node from the list
	remove(pNode)
	{
		if (typeof(pNode) === 'undefined')
			return false;

		if (!pNode.__ISNODE)
			return false;

		this.length--;

		// Last element in list.  Empty it out.
		if (this.length < 1)
		{
			this.head = false;
			this.tail = false;
			return pNode;
		}

		// It's somewhere in the middle, surgically remove it.
		if (pNode.LeftNode && pNode.RightNode)
		{
			pNode.LeftNode.RightNode = pNode.RightNode;
			pNode.RightNode.LeftNode = pNode.LeftNode;

			pNode.RightNode = false;
			pNode.LeftNode = false;
			return pNode;
		}

		// It's the tail
		if (pNode.LeftNode)
		{
			pNode.LeftNode.RightNode = false;
			this.tail = pNode.LeftNode;
			pNode.LeftNode = false;
			return pNode;
		}

		// It must be the head
		pNode.RightNode.LeftNode = false;
		this.head = pNode.RightNode;
		pNode.RightNode = false;
		return pNode;
	}

	// Remove the head of the list (FIFO)
	pop()
	{
		return this.remove(this.head);
	}

	// Enumerate over each node IN ORDER, running the function fAction(pDatum, pHash, fCallback) then calling the function fComplete callback when done
	each(fAction, fComplete)
	{
		if (this.length < 1)
			return fComplete();

		let tmpNode = false;

		let fIterator = (pError)=>
		{
			// If the user passed in a callback with an error, call their callback with the error
			if (pError)
				return fComplete(pError);

			// If there is no node, this must be the initial run.
			if (!tmpNode)
				tmpNode = this.head;
			// Check if we are at the tail of the list
			else if (!tmpNode.RightNode)
				return fComplete();
			// Proceed to the next node
			else
				tmpNode = tmpNode.RightNode;

			// Call the actual action
			// I hate this pattern because long tails eventually cause stack overflows.
			fAction(tmpNode.Datum, tmpNode.Hash, fIterator);
		};

		// Now kick off the iterator
		return fIterator();
	}

	// Seek a specific node, 0 is the index of the first node.
	seek(pNodeIndex)
	{
		if (!pNodeIndex)
			return false;
		if (this.length < 1)
			return false;
		if (pNodeIndex >= this.length)
			return false;

		let tmpNode = this.head;
		for (let i = 0; i < pNodeIndex; i++)
		{
			tmpNode = tmpNode.RightNode;
		}

		return tmpNode;
	}
}

module.exports = LinkedList;
},{"./LinkedList-Node.js":23}],25:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);

},{"./functionApply":26,"./functionCall":27,"./reflectApply":29,"function-bind":106}],26:[function(require,module,exports){
'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;

},{}],27:[function(require,module,exports){
'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;

},{}],28:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var $TypeError = require('es-errors/type');

var $call = require('./functionCall');
var $actualApply = require('./actualApply');

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};

},{"./actualApply":25,"./functionCall":27,"es-errors/type":47,"function-bind":106}],29:[function(require,module,exports){
'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],30:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBindBasic = require('call-bind-apply-helpers');

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};

},{"call-bind-apply-helpers":28,"get-intrinsic":107}],31:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookie = parseCookie;
exports.parse = parseCookie;
exports.stringifyCookie = stringifyCookie;
exports.stringifySetCookie = stringifySetCookie;
exports.serialize = stringifySetCookie;
exports.parseSetCookie = parseSetCookie;
exports.stringifySetCookie = stringifySetCookie;
exports.serialize = stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */
const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */
const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */
const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */
const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */
const maxAgeRegExp = /^-?\d+$/;
const __toString = Object.prototype.toString;
const NullObject = /* @__PURE__ */ (() => {
    const C = function () { };
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */
function parseCookie(str, options) {
    const obj = new NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2)
        return obj;
    const dec = options?.decode || decode;
    let index = 0;
    do {
        const eqIdx = eqIndex(str, index, len);
        if (eqIdx === -1)
            break; // No more cookie pairs.
        const endIdx = endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) {
            obj[key] = dec(valueSlice(str, eqIdx + 1, endIdx));
        }
        index = endIdx + 1;
    } while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */
function stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)) {
        const val = cookie[name];
        if (val === undefined)
            continue;
        if (!cookieNameRegExp.test(name)) {
            throw new TypeError(`cookie name is invalid: ${name}`);
        }
        const value = enc(val);
        if (!cookieValueRegExp.test(value)) {
            throw new TypeError(`cookie val is invalid: ${val}`);
        }
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object"
        ? _name
        : { ..._opts, name: _name, value: String(_val) };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!cookieNameRegExp.test(cookie.name)) {
        throw new TypeError(`argument name is invalid: ${cookie.name}`);
    }
    const value = cookie.value ? enc(cookie.value) : "";
    if (!cookieValueRegExp.test(value)) {
        throw new TypeError(`argument val is invalid: ${cookie.value}`);
    }
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) {
            throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        }
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!domainValueRegExp.test(cookie.domain)) {
            throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        }
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!pathValueRegExp.test(cookie.path)) {
            throw new TypeError(`option path is invalid: ${cookie.path}`);
        }
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) {
            throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        }
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) {
        str += "; HttpOnly";
    }
    if (cookie.secure) {
        str += "; Secure";
    }
    if (cookie.partitioned) {
        str += "; Partitioned";
    }
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string"
            ? cookie.priority.toLowerCase()
            : undefined;
        switch (priority) {
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string"
            ? cookie.sameSite.toLowerCase()
            : cookie.sameSite;
        switch (sameSite) {
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */
function parseSetCookie(str, options) {
    const dec = options?.decode || decode;
    const len = str.length;
    const endIdx = endIndex(str, 0, len);
    const eqIdx = eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1
        ? { name: "", value: dec(valueSlice(str, 0, endIdx)) }
        : {
            name: valueSlice(str, 0, eqIdx),
            value: dec(valueSlice(str, eqIdx + 1, endIdx)),
        };
    let index = endIdx + 1;
    while (index < len) {
        const endIdx = endIndex(str, index, len);
        const eqIdx = eqIndex(str, index, endIdx);
        const attr = eqIdx === -1
            ? valueSlice(str, index, endIdx)
            : valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : valueSlice(str, eqIdx + 1, endIdx);
        switch (attr.toLowerCase()) {
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && maxAgeRegExp.test(val))
                    setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val)
                    break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf()))
                    setCookie.expires = date;
                break;
            case "priority":
                if (!val)
                    break;
                const priority = val.toLowerCase();
                if (priority === "low" ||
                    priority === "medium" ||
                    priority === "high") {
                    setCookie.priority = priority;
                }
                break;
            case "samesite":
                if (!val)
                    break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" ||
                    sameSite === "strict" ||
                    sameSite === "none") {
                    setCookie.sameSite = sameSite;
                }
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */
function endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */
function eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */
function valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */ && code !== 0x09 /* \t */)
            break;
    } while (++start < end);
    while (end > start) {
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */ && code !== 0x09 /* \t */)
            break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */
function decode(str) {
    if (str.indexOf("%") === -1)
        return str;
    try {
        return decodeURIComponent(str);
    }
    catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */
function isDate(val) {
    return __toString.call(val) === "[object Date]";
}

},{}],32:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),Y=_.prototype;return O.prototype=Y,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){Y[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));
},{}],33:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_advancedFormat=t()}(this,(function(){"use strict";return function(e,t){var r=t.prototype,n=r.format;r.format=function(e){var t=this,r=this.$locale();if(!this.isValid())return n.bind(this)(e);var s=this.$utils(),a=(e||"YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g,(function(e){switch(e){case"Q":return Math.ceil((t.$M+1)/3);case"Do":return r.ordinal(t.$D);case"gggg":return t.weekYear();case"GGGG":return t.isoWeekYear();case"wo":return r.ordinal(t.week(),"W");case"w":case"ww":return s.s(t.week(),"w"===e?1:2,"0");case"W":case"WW":return s.s(t.isoWeek(),"W"===e?1:2,"0");case"k":case"kk":return s.s(String(0===t.$H?24:t.$H),"k"===e?1:2,"0");case"X":return Math.floor(t.$d.getTime()/1e3);case"x":return t.$d.getTime();case"z":return"["+t.offsetName()+"]";case"zzz":return"["+t.offsetName("long")+"]";default:return e}}));return n.bind(this)(a)}}}));
},{}],34:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_isoWeek=t()}(this,(function(){"use strict";var e="day";return function(t,i,s){var a=function(t){return t.add(4-t.isoWeekday(),e)},d=i.prototype;d.isoWeekYear=function(){return a(this).year()},d.isoWeek=function(t){if(!this.$utils().u(t))return this.add(7*(t-this.isoWeek()),e);var i,d,n,o,r=a(this),u=(i=this.isoWeekYear(),d=this.$u,n=(d?s.utc:s)().year(i).startOf("year"),o=4-n.isoWeekday(),n.isoWeekday()>4&&(o+=7),n.add(o,e));return r.diff(u,"week")+1},d.isoWeekday=function(e){return this.$utils().u(e)?this.day()||7:this.day(this.day()%7?e:e-7)};var n=d.startOf;d.startOf=function(e,t){var i=this.$utils(),s=!!i.u(t)||t;return"isoweek"===i.p(e)?s?this.date(this.date()-(this.isoWeekday()-1)).startOf("day"):this.date(this.date()-1-(this.isoWeekday()-1)+7).endOf("day"):n.bind(this)(e,t)}}}));
},{}],35:[function(require,module,exports){
!function(r,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(r="undefined"!=typeof globalThis?globalThis:r||self).dayjs_plugin_relativeTime=e()}(this,(function(){"use strict";return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return"function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)}}}));
},{}],36:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_timezone=e()}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,r){var o,a=function(t,n,i){void 0===i&&(i={});var r=new Date(t),o=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",r=t+"|"+i,o=e[r];return o||(o=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[r]=o),o}(n,i);return o.formatToParts(r)},u=function(e,n){for(var i=a(e,n),o=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(o[c]=parseInt(m,10))}var l=o[3],d=24===l?0:l,h=o[0]+"-"+o[1]+"-"+o[2]+" "+d+":"+o[4]+":"+o[5]+":000",v=+e;return(r.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){if(void 0===t&&(t=o),!this.isValid())return this;var n,i=this.utcOffset(),a=this.toDate(),f=a.toLocaleString("en-US",{timeZone:t}),s=u(+a,t);if(!Number(s))n=this.utcOffset(0,e);else if(n=r(f,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(s,!0),e){var m=n.utcOffset();n=n.add(i-m,"minute")}return n.$x.$timezone=t,n},f.offsetName=function(t){var e=this.$x.$timezone||r.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=r(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},r.tz=function(t,e,n){var i=n&&e,a=n||e||o,f=u(+r(),a);if("string"!=typeof t)return r(t).tz(a);var s=r.utc(t,i).valueOf();if(Number.isNaN(s)){var m=r(NaN);return m.$x.$timezone=a,m}var c=function(t,e,n){var i=t-60*e*1e3,r=u(i,n);if(e===r)return[i,e];var o=u(i-=60*(r-e)*1e3,n);return r===o?[i,r]:[t-60*Math.min(r,o)*1e3,Math.max(r,o)]}(s,f,a),l=c[0],d=c[1],h=r(l).utcOffset(d);return h.$x.$timezone=a,h},r.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},r.tz.setDefault=function(t){o=t}}}));
},{}],37:[function(require,module,exports){
!function(t,i){"object"==typeof exports&&"undefined"!=typeof module?module.exports=i():"function"==typeof define&&define.amd?define(i):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_utc=i()}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var r=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),r.call(this,t)};var o=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else o.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s;if(0===u)return this.utc(f);var r=this.clone();if(f)return r.$offset=u,r.$u=!1,r;var o=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();return(r=this.local().add(u+o,t)).$offset=u,r.$x.$localOffset=o,r};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));
},{}],38:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_weekOfYear=t()}(this,(function(){"use strict";var e="week",t="year";return function(i,n,r){var f=n.prototype;f.week=function(i){if(void 0===i&&(i=null),null!==i)return this.add(7*(i-this.week()),"day");var n=this.$locale().yearStart||1;if(11===this.month()&&this.date()>25){var f=r(this).startOf(t).add(1,t).date(n),s=r(this).endOf(e);if(f.isBefore(s))return 1}var a=r(this).startOf(t).date(n).startOf(e).subtract(1,"millisecond"),o=this.diff(a,e,!0);return o<0?r(this).startOf("week").week():Math.ceil(o)},f.weeks=function(e){return void 0===e&&(e=null),this.week(e)}}}));
},{}],39:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_weekday=t()}(this,(function(){"use strict";return function(e,t){t.prototype.weekday=function(e){var t=this.$locale().weekStart||0,i=this.$W,n=(i<t?i+7:i)-t;return this.$utils().u(e)?n:this.subtract(n,"day").add(e,"day")}}}));
},{}],40:[function(require,module,exports){
'use strict';

var callBind = require('call-bind-apply-helpers');
var gOPD = require('gopd');

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;

},{"call-bind-apply-helpers":28,"gopd":112}],41:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

},{}],42:[function(require,module,exports){
'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

},{}],43:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Error;

},{}],44:[function(require,module,exports){
'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

},{}],45:[function(require,module,exports){
'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

},{}],46:[function(require,module,exports){
'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

},{}],47:[function(require,module,exports){
'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

},{}],48:[function(require,module,exports){
'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

},{}],49:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Object;

},{}],50:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

},{}],51:[function(require,module,exports){
module.exports={
    "name": "fable-log",
    "version": "3.0.18",
    "description": "A simple logging wrapper.",
    "main": "source/Fable-Log.js",
    "scripts": {
        "start": "node source/Fable-Log.js",
        "coverage": "npx quack coverage",
        "test": "npx quack test",
        "tests": "npx quack test -g"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "browser": {
        "./source/Fable-Log-DefaultProviders-Node.js": "./source/Fable-Log-DefaultProviders-Web.js"
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/stevenvelozo/fable-log.git"
    },
    "keywords": [
        "logging"
    ],
    "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/fable-log/issues"
    },
    "homepage": "https://github.com/stevenvelozo/fable-log",
    "devDependencies": {
        "quackage": "^1.0.58"
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],52:[function(require,module,exports){
/**
* Base Logger Class
*
*
* @author Steven Velozo <steven@velozo.com>
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;

class BaseLogger extends libFableServiceProviderBase
{
	constructor(pLogStreamSettings, pLogStreamHash)
	{
		super(pLogStreamSettings, pLogStreamHash);
		// This should not possibly be able to be instantiated without a settings object
		this._Settings = (typeof(pLogStreamSettings) == 'object') ? pLogStreamSettings : {};

		this.serviceType = 'Logging-Provider';

		// The base logger does nothing but associate a UUID with itself
		// We added this as the mechanism for tracking loggers to allow multiple simultaneous streams
		// to the same provider.
		this.loggerUUID = this.generateInsecureUUID();

		// Eventually we can use this array to ompute which levels the provider allows.
		// For now it's just used to precompute some string concatenations.
		this.levels = (
			[
				"trace",
				"debug",
				"info",
				"warn",
				"error",
				"fatal"
			]);
	}

	// This is meant to generate programmatically insecure UUIDs to identify loggers
	generateInsecureUUID()
	{
		let tmpDate = new Date().getTime();
		let tmpUUID = 'LOGSTREAM-xxxxxx-yxxxxx'.replace(/[xy]/g,
				(pCharacter) =>
				{
					// Funny algorithm from w3resource that is twister-ish without the deep math and security
					// ..but good enough for unique log stream identifiers
					let tmpRandomData = (tmpDate + Math.random()*16)%16 | 0;
					tmpDate = Math.floor(tmpDate/16);

					return (pCharacter =='x' ? tmpRandomData : (tmpRandomData&0x3|0x8)).toString(16);
				});
		return tmpUUID;
	}

	initialize()
	{
		// No operation.
	}

	trace(pLogText, pLogObject)
	{
		this.write("trace", pLogText, pLogObject);
	}

	debug(pLogText, pLogObject)
	{
		this.write("debug", pLogText, pLogObject);
	}

	info(pLogText, pLogObject)
	{
		this.write("info", pLogText, pLogObject);
	}

	warn(pLogText, pLogObject)
	{
		this.write("warn", pLogText, pLogObject);
	}

	error(pLogText, pLogObject)
	{
		this.write("error", pLogText, pLogObject);
	}

	fatal(pLogText, pLogObject)
	{
		this.write("fatal", pLogText, pLogObject);
	}

	write(pLogLevel, pLogText, pLogObject)
	{
		// The base logger does nothing.
		return true;
	}
}

module.exports = BaseLogger;

},{"fable-serviceproviderbase":59}],53:[function(require,module,exports){
/**
* Default Logger Provider Function
*
*
* @author Steven Velozo <steven@velozo.com>
*/

// Return the providers that are available without extensions loaded
var getDefaultProviders = () =>
{
	let tmpDefaultProviders = {};

	tmpDefaultProviders.console = require('./Fable-Log-Logger-Console.js');

	tmpDefaultProviders.default = tmpDefaultProviders.console;

	return tmpDefaultProviders;
}

module.exports = getDefaultProviders();
},{"./Fable-Log-Logger-Console.js":55}],54:[function(require,module,exports){
module.exports=[
    {
        "loggertype": "console",
        "streamtype": "console",
        "level": "trace"
    }
]
},{}],55:[function(require,module,exports){
let libBaseLogger = require('./Fable-Log-BaseLogger.js');

class ConsoleLogger extends libBaseLogger
{
	constructor(pLogStreamSettings, pFableLog)
	{
		super(pLogStreamSettings);

		this._ShowTimeStamps = ('showtimestamps' in this._Settings) ? (this._Settings.showtimestamps == true) : true;
		this._FormattedTimeStamps = ('formattedtimestamps' in this._Settings) ? (this._Settings.formattedtimestamps == true) : true;

		this._ContextMessage = ('Context' in this._Settings) ? `(${this._Settings.Context})` :
								('Product' in pFableLog._Settings) ? `(${pFableLog._Settings.Product})` :
								'Unnamed_Log_Context';

		// Allow the user to decide what gets output to the console
		this._OutputLogLinesToConsole = ('outputloglinestoconsole' in this._Settings) ? this._Settings.outputloglinestoconsole : true;
		this._OutputObjectsToConsole = ('outputobjectstoconsole' in this._Settings) ? this._Settings.outputobjectstoconsole : true;

		// Precompute the prefix for each level
		this.prefixCache = {};
		for (let i = 0; i <= this.levels.length; i++)
		{
			this.prefixCache[this.levels[i]] = `[${this.levels[i]}] ${this._ContextMessage}: `;

			if (this._ShowTimeStamps)
			{
				// If there is a timestamp we need a to prepend space before the prefixcache string, since the timestamp comes first
				this.prefixCache[this.levels[i]] = ' '+this.prefixCache[this.levels[i]];
			}
		}
	}

	write(pLevel, pLogText, pObject)
	{
		let tmpTimeStamp = '';
		if (this._ShowTimeStamps && this._FormattedTimeStamps)
		{
			tmpTimeStamp = (new Date()).toISOString();
		}
		else if (this._ShowTimeStamps)
		{
			tmpTimeStamp = +new Date();
		}

		let tmpLogLine = `${tmpTimeStamp}${this.prefixCache[pLevel]}${pLogText}`;

		if (this._OutputLogLinesToConsole)
		{
			console.log(tmpLogLine);
		}

		// Write out the object on a separate line if it is passed in
		if (this._OutputObjectsToConsole && (typeof(pObject) !== 'undefined'))
		{
			console.log(JSON.stringify(pObject, null, 2));
		}

		// Provide an easy way to be overridden and be consistent
		return tmpLogLine;
	}
}

module.exports = ConsoleLogger;
},{"./Fable-Log-BaseLogger.js":52}],56:[function(require,module,exports){
const libConsoleLog = require('./Fable-Log-Logger-Console.js');
const libFS = require('fs');
const libPath = require('path');

class SimpleFlatFileLogger extends libConsoleLog
{
	constructor(pLogStreamSettings, pFableLog)
	{
		super(pLogStreamSettings, pFableLog);

		// If a path isn't provided for the logfile, it tries to use the ProductName or Context
		this.logFileRawPath = (this._Settings.hasOwnProperty('path')) ? this._Settings.path : `./${this._ContextMessage}.log`;
		this.logFilePath = libPath.normalize(this.logFileRawPath);

		this.logFileStreamOptions = (this._Settings.hasOwnProperty('fileStreamoptions')) ? this._Settings.fileStreamOptions : (
			{
				"flags": "a",
				"encoding": "utf8"
			})

		this.fileWriter = libFS.createWriteStream(this.logFilePath, this.logFileStreamOptions);

		this.activelyWriting = false;

		this.logLineStrings = [];
		this.logObjectStrings = [];

		this.defaultWriteCompleteCallback = ()=>{};
		this.defaultBufferFlushCallback = ()=>{};
	}

	closeWriter(fCloseComplete)
	{
		let tmpCloseComplete = (typeof(fCloseComplete) == 'function') ? fCloseComplete : ()=>{};
		if (this.fileWriter)
		{
			this.fileWriter.end('\n');
			return this.fileWriter.once('finish', tmpCloseComplete.bind(this));
		}
	}

	completeBufferFlushToLogFile(fFlushComplete)
	{
		this.activelyWriting = false;
		let tmpFlushComplete = (typeof(fFlushComplete) == 'function') ? fFlushComplete : this.defaultBufferFlushCallback;

		if (this.logLineStrings.length > 0)
		{
			this.flushBufferToLogFile(tmpFlushComplete);
		}
		else
		{
			return tmpFlushComplete();
		}
	}

	flushBufferToLogFile(fFlushComplete)
	{
		if (!this.activelyWriting)
		{
			// Only want to be writing one thing at a time....
			this.activelyWriting = true;

			let tmpFlushComplete = (typeof(fFlushComplete) == 'function') ? fFlushComplete : this.defaultBufferFlushCallback;

			// Get the current buffer arrays.  These should always have matching number of elements.
			let tmpLineStrings = this.logLineStrings;
			let tmpObjectStrings = this.logObjectStrings;

			// Reset these to be filled while we process this queue...
			this.logLineStrings = [];
			this.logObjectStrings = [];

			// This is where we will put each line before writing it to the file...
			let tmpConstructedBufferOutputString = '';

			for (let i = 0; i < tmpLineStrings.length; i++)
			{
				// TODO: Windows Newline?   ....... yo no se!
				tmpConstructedBufferOutputString += `${tmpLineStrings[i]}\n`;
				if (tmpObjectStrings[i] !== false)
				{
					tmpConstructedBufferOutputString += `${tmpObjectStrings[i]}\n`;
				}
			}

			if (!this.fileWriter.write(tmpConstructedBufferOutputString, 'utf8'))
			{
				// If the streamwriter returns false, we need to wait for it to drain.
				this.fileWriter.once('drain', this.completeBufferFlushToLogFile.bind(this, tmpFlushComplete));
			}
			else
			{
				return this.completeBufferFlushToLogFile(tmpFlushComplete);
			}
		}
	}

	write(pLevel, pLogText, pObject)
	{
		let tmpLogLine = super.write(pLevel, pLogText, pObject);

		// Use a very simple array as the write buffer
		this.logLineStrings.push(tmpLogLine);

		// Write out the object on a separate line if it is passed in
		if (typeof(pObject) !== 'undefined')
		{
			this.logObjectStrings.push(JSON.stringify(pObject, null, 4));
		}
		else
		{
			this.logObjectStrings.push(false);
		}

		this.flushBufferToLogFile();
	}
}

module.exports = SimpleFlatFileLogger;
},{"./Fable-Log-Logger-Console.js":55,"fs":19,"path":145}],57:[function(require,module,exports){
/**
* Fable Logging Service
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;

const libPackage = require('../package.json');

class FableLog extends libFableServiceProviderBase
{
	constructor(pSettings, pServiceHash)
	{
		super(pSettings, pServiceHash);

		this.serviceType = 'Logging';
		/** @type {Object} */
		this._Package = libPackage;

		let tmpSettings = (typeof(pSettings) === 'object') ? pSettings : {}
		this._Settings = tmpSettings;

		this._Providers = require('./Fable-Log-DefaultProviders-Node.js');

		this._StreamDefinitions = (('LogStreams' in tmpSettings)) ? tmpSettings.LogStreams : require('./Fable-Log-DefaultStreams.json');

		this.logStreams = [];

		// This object gets decorated for one-time instantiated providers that
		//  have multiple outputs, such as bunyan.
		this.logProviders = {};

		// A hash list of the GUIDs for each log stream, so they can't be added to the set more than one time
		this.activeLogStreams = {};

		this.logStreamsTrace = [];
		this.logStreamsDebug = [];
		this.logStreamsInfo = [];
		this.logStreamsWarn = [];
		this.logStreamsError = [];
		this.logStreamsFatal = [];

		this.datumDecorator = (pDatum) => pDatum;

		this.uuid = (typeof(tmpSettings.Product) === 'string') ? tmpSettings.Product : 'Default';
	}

	addLogger(pLogger, pLevel)
	{
		// Bail out if we've already created one.
		if (pLogger.loggerUUID in this.activeLogStreams)
		{
			return false;
		}

		// Add it to the streams and to the mutex
		this.logStreams.push(pLogger);
		this.activeLogStreams[pLogger.loggerUUID] = true;

		// Make sure a kosher level was passed in
		switch (pLevel)
		{
			case 'trace':
				this.logStreamsTrace.push(pLogger);
			case 'debug':
				this.logStreamsDebug.push(pLogger);
			case 'info':
				this.logStreamsInfo.push(pLogger);
			case 'warn':
				this.logStreamsWarn.push(pLogger);
			case 'error':
				this.logStreamsError.push(pLogger);
			case 'fatal':
				this.logStreamsFatal.push(pLogger);
				break;
		}

		return true;
	}

	setDatumDecorator(fDatumDecorator)
	{
		if (typeof(fDatumDecorator) === 'function')
		{
			this.datumDecorator = fDatumDecorator;
		}
		else
		{
			this.datumDecorator = (pDatum) => pDatum;
		}
	}

	trace(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsTrace.length; i++)
		{
			this.logStreamsTrace[i].trace(pMessage, tmpDecoratedDatum);
		}
	}

	debug(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsDebug.length; i++)
		{
			this.logStreamsDebug[i].debug(pMessage, tmpDecoratedDatum);
		}
	}

	info(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsInfo.length; i++)
		{
			this.logStreamsInfo[i].info(pMessage, tmpDecoratedDatum);
		}
	}

	warn(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsWarn.length; i++)
		{
			this.logStreamsWarn[i].warn(pMessage, tmpDecoratedDatum);
		}
	}

	error(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsError.length; i++)
		{
			this.logStreamsError[i].error(pMessage, tmpDecoratedDatum);
		}
	}

	fatal(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsFatal.length; i++)
		{
			this.logStreamsFatal[i].fatal(pMessage, tmpDecoratedDatum);
		}
	}

	initialize()
	{
		// "initialize" each logger as defined in the logging parameters
		for (let i = 0; i < this._StreamDefinitions.length; i++)
		{
			let tmpStreamDefinition = Object.assign({loggertype:'default',streamtype:'console',level:'info'},this._StreamDefinitions[i]);

			if (!(tmpStreamDefinition.loggertype in this._Providers))
			{
				console.log(`Error initializing log stream: bad loggertype in stream definition ${JSON.stringify(tmpStreamDefinition)}`);
			}
			else
			{
				this.addLogger(new this._Providers[tmpStreamDefinition.loggertype](tmpStreamDefinition, this), tmpStreamDefinition.level);
			}
		}

		// Now initialize each one.
		for (let i = 0; i < this.logStreams.length; i++)
		{
			this.logStreams[i].initialize();
		}
	}

	logTime(pMessage, pDatum)
	{
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : 'Time';
		let tmpTime = new Date();
		this.info(`${tmpMessage} ${tmpTime} (epoch ${+tmpTime})`, pDatum);
	}

	// Get a timestamp
	getTimeStamp()
	{
		return +new Date();
	}

	getTimeDelta(pTimeStamp)
	{
		let tmpEndTime = +new Date();
		return tmpEndTime-pTimeStamp;
	}

	// Log the delta between a timestamp, and now with a message
	logTimeDelta(pTimeDelta, pMessage, pDatum)
	{
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : 'Time Measurement';
		let tmpDatum = (typeof(pDatum) === 'object') ? pDatum : {};

		let tmpEndTime = +new Date();

		this.info(`${tmpMessage} logged at (epoch ${+tmpEndTime}) took (${pTimeDelta}ms)`, pDatum);
	}

	logTimeDeltaHuman(pTimeDelta, pMessage, pDatum)
	{
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : 'Time Measurement';

		let tmpEndTime = +new Date();

		let tmpMs = parseInt(pTimeDelta%1000);
		let tmpSeconds = parseInt((pTimeDelta/1000)%60);
		let tmpMinutes = parseInt((pTimeDelta/(1000*60))%60);
		let tmpHours = parseInt(pTimeDelta/(1000*60*60));

		tmpMs = (tmpMs < 10) ? "00"+tmpMs : (tmpMs < 100) ? "0"+tmpMs : tmpMs;
		tmpSeconds = (tmpSeconds < 10) ? "0"+tmpSeconds : tmpSeconds;
		tmpMinutes = (tmpMinutes < 10) ? "0"+tmpMinutes : tmpMinutes;
		tmpHours = (tmpHours < 10) ? "0"+tmpHours : tmpHours;

		this.info(`${tmpMessage} logged at (epoch ${+tmpEndTime}) took (${pTimeDelta}ms) or (${tmpHours}:${tmpMinutes}:${tmpSeconds}.${tmpMs})`, pDatum);
	}

	logTimeDeltaRelative(pStartTime, pMessage, pDatum)
	{
		this.logTimeDelta(this.getTimeDelta(pStartTime), pMessage, pDatum);
	}

	logTimeDeltaRelativeHuman(pStartTime, pMessage, pDatum)
	{
		this.logTimeDeltaHuman(this.getTimeDelta(pStartTime), pMessage, pDatum);
	}
}

module.exports = FableLog;
module.exports.LogProviderBase = require('./Fable-Log-BaseLogger.js');
module.exports.LogProviderConsole = require('./Fable-Log-Logger-Console.js');
module.exports.LogProviderFlatfile = require('./Fable-Log-Logger-SimpleFlatFile.js');

},{"../package.json":51,"./Fable-Log-BaseLogger.js":52,"./Fable-Log-DefaultProviders-Node.js":53,"./Fable-Log-DefaultStreams.json":54,"./Fable-Log-Logger-Console.js":55,"./Fable-Log-Logger-SimpleFlatFile.js":56,"fable-serviceproviderbase":59}],58:[function(require,module,exports){
module.exports={
    "name": "fable-serviceproviderbase",
    "version": "3.0.19",
    "description": "Simple base classes for fable services.",
    "main": "source/Fable-ServiceProviderBase.js",
    "scripts": {
        "start": "node source/Fable-ServiceProviderBase.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p . --noEmit"
    },
    "types": "types/source/Fable-ServiceProviderBase.d.ts",
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase.git"
    },
    "keywords": [
        "entity",
        "behavior"
    ],
    "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase/issues"
    },
    "homepage": "https://github.com/stevenvelozo/fable-serviceproviderbase",
    "devDependencies": {
        "@types/mocha": "^10.0.10",
        "fable": "^3.1.62",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    }
}

},{}],59:[function(require,module,exports){
/**
* Fable Service Base
* @author <steven@velozo.com>
*/

const libPackage = require('../package.json');

class FableServiceProviderBase
{
	/**
	 * The constructor can be used in two ways:
	 * 1) With a fable, options object and service hash (the options object and service hash are optional)a
	 * 2) With an object or nothing as the first parameter, where it will be treated as the options object
	 *
	 * @param {import('fable')|Record<string, any>} [pFable] - (optional) The fable instance, or the options object if there is no fable
	 * @param {Record<string, any>|string} [pOptions] - (optional) The options object, or the service hash if there is no fable
	 * @param {string} [pServiceHash] - (optional) The service hash to identify this service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		/** @type {import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		// Check if a fable was passed in; connect it if so
		if ((typeof(pFable) === 'object') && pFable.isFable)
		{
			this.connectFable(pFable);
		}
		else
		{
			this.fable = false;
		}

		// Initialize the services map if it wasn't passed in
		/** @type {Record<string, any>} */
		this._PackageFableServiceProvider = libPackage;

		// initialize options and UUID based on whether the fable was passed in or not.
		if (this.fable)
		{
			this.UUID = pFable.getUUID();
			this.options = (typeof(pOptions) === 'object') ? pOptions
							: {};
		}
		else
		{
			// With no fable, check to see if there was an object passed into either of the first two
			// Parameters, and if so, treat it as the options object
			this.options = ((typeof(pFable) === 'object') && !pFable.isFable) ? pFable
							: (typeof(pOptions) === 'object') ? pOptions
							: {};
			this.UUID = `CORE-SVC-${Math.floor((Math.random() * (99999 - 10000)) + 10000)}`
		}

		// It's expected that the deriving class will set this
		this.serviceType = `Unknown-${this.UUID}`;

		// The service hash is used to identify the specific instantiation of the service in the services map
		this.Hash = (typeof(pServiceHash) === 'string') ? pServiceHash 
					: (!this.fable && (typeof(pOptions) === 'string')) ? pOptions
					: `${this.UUID}`;
	}

	/**
	 * @param {import('fable')} pFable
	 */
	connectFable(pFable)
	{
		if ((typeof(pFable) !== 'object') || (!pFable.isFable))
		{
			let tmpErrorMessage = `Fable Service Provider Base: Cannot connect to Fable, invalid Fable object passed in.  The pFable parameter was a [${typeof(pFable)}].}`;
			console.log(tmpErrorMessage);
			return new Error(tmpErrorMessage);
		}

		if (!this.fable)
		{
			this.fable = pFable;
		}

		if (!this.log)
		{
			this.log = this.fable.Logging;
		}
		if (!this.services)
		{
			this.services = this.fable.services;
		}

		if (!this.servicesMap)
		{
			this.servicesMap = this.fable.servicesMap;
		}

		return true;
	}

	static isFableService = true;
}

module.exports = FableServiceProviderBase;

// This is left here in case we want to go back to having different code/base class for "core" services
module.exports.CoreServiceProviderBase = FableServiceProviderBase;

},{"../package.json":58}],60:[function(require,module,exports){
module.exports={
  "name": "fable-settings",
  "version": "3.0.17",
  "description": "A simple, tolerant configuration chain.",
  "main": "source/Fable-Settings.js",
  "scripts": {
    "start": "node source/Fable-Settings.js",
    "coverage": "npx quack coverage",
    "test": "npx quack test",
    "build": "npx quack build",
    "docker-dev-build-image": "docker build ./ -f Dockerfile_LUXURYCode -t retold/fable-settings:local",
    "docker-dev-run": "docker run -it -d --name retold-fable-settings-dev -p 30003:8080 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/fable-settings\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" retold/fable-settings:local"
  },
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/fable-retold/fable-settings.git"
  },
  "keywords": [
    "configuration"
  ],
  "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/fable-retold/fable-settings/issues"
  },
  "homepage": "https://github.com/fable-retold/fable-settings",
  "devDependencies": {
    "pict-docuserve": "^1.4.4",
    "quackage": "^1.3.0"
  },
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19",
    "precedent": "^1.0.17"
  }
}

},{}],61:[function(require,module,exports){
module.exports={
	"Product": "ApplicationNameHere",
	"ProductVersion": "0.0.0",

	"ConfigFile": false,

	"LogStreams":
	[
		{
			"level": "trace"
		}
	]
}

},{}],62:[function(require,module,exports){
(function (process){(function (){
/**
* Fable Settings Template Processor
*
* This class allows environment variables to come in via templated expressions, and defaults to be set.
*
*
* @author Steven Velozo <steven@velozo.com>
* @module Fable Settings
*/
const libPrecedent = require('precedent');

class FableSettingsTemplateProcessor
{
	constructor(pDependencies)
	{
        // Use a no-dependencies templating engine to parse out environment variables
		this.templateProcessor = new libPrecedent();

        // TODO: Make the environment variable wrap expression demarcation characters configurable?
		this.templateProcessor.addPattern('${', '}',
			(pTemplateValue)=>
			{
				let tmpTemplateValue = pTemplateValue.trim();

				let tmpSeparatorIndex = tmpTemplateValue.indexOf('|');

				const tmpDefaultValue = tmpSeparatorIndex >= 0 ? tmpTemplateValue.substring(tmpSeparatorIndex+1) : '';

				let tmpEnvironmentVariableName = (tmpSeparatorIndex > -1) ? tmpTemplateValue.substring(0, tmpSeparatorIndex) : tmpTemplateValue;

				if (tmpEnvironmentVariableName in process.env)
				{
					return process.env[tmpEnvironmentVariableName];
				}
				else
				{
					return tmpDefaultValue;
				}
			});
    }

    parseSetting(pString)
    {
        return this.templateProcessor.parseString(pString);
    }
}

module.exports = FableSettingsTemplateProcessor;

}).call(this)}).call(this,require('_process'))

},{"_process":439,"precedent":436}],63:[function(require,module,exports){
/**
* Fable Settings Add-on
*
*
* @author Steven Velozo <steven@velozo.com>
* @module Fable Settings
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;

const libFableSettingsTemplateProcessor = require('./Fable-Settings-TemplateProcessor.js');

class FableSettings extends libFableServiceProviderBase
{
	constructor(pSettings, pServiceHash)
	{
		super(pSettings, pServiceHash);

		this.serviceType = 'SettingsManager';

		this._Package = require('../package.json');

		// Initialize the settings value template processor
		this.settingsTemplateProcessor = new libFableSettingsTemplateProcessor();

		// set straight away so anything that uses it respects the initial setting
		this._configureEnvTemplating(pSettings);

		this.default = this.buildDefaultSettings();

		// Construct a new settings object
		let tmpSettings = this.merge(pSettings, this.buildDefaultSettings());

		// The base settings object (what they were on initialization, before other actors have altered them)
		this.base = JSON.parse(JSON.stringify(tmpSettings));

		if (tmpSettings.DefaultConfigFile)
		{
			try
			{
				// If there is a DEFAULT configuration file, try to load and merge it.
				tmpSettings = this.merge(require(tmpSettings.DefaultConfigFile), tmpSettings);
			}
			catch (pException)
			{
				// Why this?  Often for an app we want settings to work out of the box, but
				// would potentially want to have a config file for complex settings.
				console.log('Fable-Settings Warning: Default configuration file specified but there was a problem loading it.  Falling back to base.');
				console.log('     Loading Exception: '+pException);
			}
		}

		if (tmpSettings.ConfigFile)
		{
			try
			{
				// If there is a configuration file, try to load and merge it.
				tmpSettings = this.merge(require(tmpSettings.ConfigFile), tmpSettings);
			}
			catch (pException)
			{
				// Why this?  Often for an app we want settings to work out of the box, but
				// would potentially want to have a config file for complex settings.
				console.log('Fable-Settings Warning: Configuration file specified but there was a problem loading it.  Falling back to base.');
				console.log('     Loading Exception: '+pException);
			}
		}

		this.settings = tmpSettings;
	}

	// Build a default settings object.  Use the JSON jimmy to ensure it is always a new object.
	buildDefaultSettings()
	{
		return JSON.parse(JSON.stringify(require('./Fable-Settings-Default')));
	}

	// Update the configuration for environment variable templating based on the current settings object
	_configureEnvTemplating(pSettings)
	{
		// default environment variable templating to on
		this._PerformEnvTemplating = !pSettings || pSettings.NoEnvReplacement !== true;
	}

	// Resolve (recursive) any environment variables found in settings object.
	_resolveEnv(pSettings)
	{
		for (const tmpKey in pSettings)
		{
			if (typeof(pSettings[tmpKey]) === 'object')
			{
				this._resolveEnv(pSettings[tmpKey]);
			}
			else if (typeof(pSettings[tmpKey]) === 'string')
			{
				pSettings[tmpKey] = this.settingsTemplateProcessor.parseSetting(pSettings[tmpKey]);
			}
		}
	}

	/**
	 * Check to see if a value is an object (but not an array).
	 */
	_isObject(value)
	{
		return typeof(value) === 'object' && !Array.isArray(value);
	}

	/**
	 * Merge two plain objects. Keys that are objects in both will be merged property-wise.
	 */
	_deepMergeObjects(toObject, fromObject)
	{
		if (!fromObject || !this._isObject(fromObject))
		{
			return;
		}
		Object.keys(fromObject).forEach((key) =>
		{
			const fromValue = fromObject[key];
			if (this._isObject(fromValue))
			{
				const toValue = toObject[key];
				if (toValue && this._isObject(toValue))
				{
					// both are objects, so do a recursive merge
					this._deepMergeObjects(toValue, fromValue);
					return;
				}
			}
			toObject[key] = fromValue;
		});
		return toObject;
	}

	// Merge some new object into the existing settings.
	merge(pSettingsFrom, pSettingsTo)
	{
		// If an invalid settings from object is passed in (e.g. object constructor without passing in anything) this should still work
		let tmpSettingsFrom = (typeof(pSettingsFrom) === 'object') ? pSettingsFrom : {};
		// Default to the settings object if none is passed in for the merge.
		let tmpSettingsTo = (typeof(pSettingsTo) === 'object') ? pSettingsTo : this.settings;

		// do not mutate the From object property values
		let tmpSettingsFromCopy = JSON.parse(JSON.stringify(tmpSettingsFrom));
		tmpSettingsTo = this._deepMergeObjects(tmpSettingsTo, tmpSettingsFromCopy);

		if (this._PerformEnvTemplating)
		{
			this._resolveEnv(tmpSettingsTo);
		}
		// Update env tempating config, since we just updated the config object, and it may have changed
		this._configureEnvTemplating(tmpSettingsTo);

		return tmpSettingsTo;
	}

	// Fill in settings gaps without overwriting settings that are already there
	fill(pSettingsFrom)
	{
		// If an invalid settings from object is passed in (e.g. object constructor without passing in anything) this should still work
		let tmpSettingsFrom = (typeof(pSettingsFrom) === 'object') ? pSettingsFrom : {};

		// do not mutate the From object property values
		let tmpSettingsFromCopy = JSON.parse(JSON.stringify(tmpSettingsFrom));

		this.settings = this._deepMergeObjects(tmpSettingsFromCopy, this.settings);

		return this.settings;
	}
};

// This is for backwards compatibility
function autoConstruct(pSettings)
{
	return new FableSettings(pSettings);
}

module.exports = FableSettings;
module.exports.new = autoConstruct;
},{"../package.json":60,"./Fable-Settings-Default":61,"./Fable-Settings-TemplateProcessor.js":62,"fable-serviceproviderbase":59}],64:[function(require,module,exports){
module.exports={
  "name": "fable-uuid",
  "version": "3.0.15",
  "description": "A simple UUID Generator.",
  "main": "source/Fable-UUID.js",
  "scripts": {
    "start": "node source/Fable-UUID.js",
    "coverage": "npx quack coverage",
    "test": "npx quack test",
    "build": "npx quack build",
    "docker-dev-build-image": "docker build ./ -f Dockerfile_LUXURYCode -t retold/fable-uuid:local",
    "docker-dev-run": "docker run -it -d --name retold-fable-uuid-dev -p 30002:8080 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/fable-uuid\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" retold/fable-uuid:local"
  },
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/fable-retold/fable-uuid.git"
  },
  "keywords": [
    "logging"
  ],
  "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/fable-retold/fable-uuid/issues"
  },
  "browser": {
    "./source/Fable-UUID-Random.js": "./source/Fable-UUID-Random-Browser.js"
  },
  "homepage": "https://github.com/fable-retold/fable-uuid",
  "devDependencies": {
    "pict-docuserve": "^1.4.4",
    "quackage": "^1.3.0"
  },
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19"
  }
}

},{}],65:[function(require,module,exports){
/**
* Random Byte Generator - Browser version
*
*
* @author Steven Velozo <steven@velozo.com>
*/

// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
class RandomBytes
{
	constructor()
	{

		// getRandomValues needs to be invoked in a context where "this" is a Crypto
		// implementation. Also, find the complete implementation of crypto on IE11.
		this.getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      		(typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	}

	// WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	generateWhatWGBytes()
	{
		let tmpBuffer = new Uint8Array(16); // eslint-disable-line no-undef

		this.getRandomValues(tmpBuffer);
		return tmpBuffer;
	}

	// Math.random()-based (RNG)
	generateRandomBytes()
	{
		// If all else fails, use Math.random().  It's fast, but is of unspecified
		// quality.
		let tmpBuffer = new Uint8Array(16); // eslint-disable-line no-undef

		for (let i = 0, tmpValue; i < 16; i++)
		{
			if ((i & 0x03) === 0)
			{
				tmpValue = Math.random() * 0x100000000;
			}

			tmpBuffer[i] = tmpValue >>> ((i & 0x03) << 3) & 0xff;
		}

		return tmpBuffer;
	}

	generate()
	{
		if (this.getRandomValues)
		{
			return this.generateWhatWGBytes();
		}
		else
		{
			return this.generateRandomBytes();
		}
	}
}

module.exports = RandomBytes;

},{}],66:[function(require,module,exports){
/**
* Fable UUID Generator
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;0

const libRandomByteGenerator = require('./Fable-UUID-Random.js')

const libPackage = require('../package.json');

class FableUUID extends libFableServiceProviderBase
{
	constructor(pSettings, pServiceHash)
	{
		super(pSettings, pServiceHash);

		this.serviceType = 'UUID';
		/** @type {Object} */
		this._Package = libPackage;

		// Determine if the module is in "Random UUID Mode" which means just use the random character function rather than the v4 random UUID spec.
		// Note this allows UUIDs of various lengths (including very short ones) although guaranteed uniqueness goes downhill fast.
		this._UUIDModeRandom = (typeof(pSettings) === 'object') && ('UUIDModeRandom' in pSettings) ? (pSettings.UUIDModeRandom == true) : false;
		// These two properties are only useful if we are in Random mode.  Otherwise it generates a v4 spec
		// Length for "Random UUID Mode" is set -- if not set it to 8
		this._UUIDLength = (typeof(pSettings) === 'object') && ('UUIDLength' in pSettings) ? (pSettings.UUIDLength + 0) : 8;
		// Dictionary for "Random UUID Mode"
		this._UUIDRandomDictionary = (typeof(pSettings) === 'object') && ('UUIDDictionary' in pSettings) ? (pSettings.UUIDDictionary + 0) : '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

		this.randomByteGenerator = new libRandomByteGenerator();

		// Lookup table for hex codes
		this._HexLookup = [];
		for (let i = 0; i < 256; ++i)
		{
			this._HexLookup[i] = (i + 0x100).toString(16).substr(1);
		}
	}

	// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
	bytesToUUID(pBuffer)
	{
		let i = 0;
		// join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
		return ([
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], 
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]]
				]).join('');
	}

	// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
	generateUUIDv4()
	{
		let tmpBuffer = new Array(16);
		var tmpRandomBytes = this.randomByteGenerator.generate();

		// Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
		tmpRandomBytes[6] = (tmpRandomBytes[6] & 0x0f) | 0x40;
		tmpRandomBytes[8] = (tmpRandomBytes[8] & 0x3f) | 0x80;

		return this.bytesToUUID(tmpRandomBytes);
	}

	// Simple random UUID generation
	generateRandom()
	{
		let tmpUUID = '';

		for (let i = 0; i < this._UUIDLength; i++)
		{
			tmpUUID += this._UUIDRandomDictionary.charAt(Math.floor(Math.random() * (this._UUIDRandomDictionary.length-1)));
		}

		return tmpUUID;
	}

	// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
	getUUID()
	{
		if (this._UUIDModeRandom)
		{
			return this.generateRandom();
		}
		else
		{
			return this.generateUUIDv4();
		}
	}
}

// This is for backwards compatibility
function autoConstruct(pSettings)
{
	return new FableUUID(pSettings);
}


module.exports = FableUUID;
module.exports.new = autoConstruct;

},{"../package.json":64,"./Fable-UUID-Random.js":65,"fable-serviceproviderbase":59}],67:[function(require,module,exports){
'use strict';

/**
 * Fable Workflow
 *
 * A Fable service provider wrapping the pure WorkflowEngine. Register it on a Fable
 * instance, define workflows from config, give it a context resolver for your data,
 * and drive subjects through their states. The engine is data-model-agnostic: it
 * reaches your data only through the context resolver, so the same engine runs any
 * domain purely from config.
 *
 *   fable.serviceManager.addServiceType('Workflow', require('fable-workflow'));
 *   fable.serviceManager.instantiateServiceProvider('Workflow');
 *   fable.Workflow.defineWorkflow({ Key: 'editorial', States: [...], Transitions: [...] });
 *   fable.Workflow.setContextResolver((pID) => myData[pID]);
 *   fable.Workflow.open('article-1', 'editorial', { ID: 'jan', Entitlements: ['submit'] });
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libWorkflowEngine = require('./Workflow-Engine.js');

class FableWorkflow extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'Workflow';

		this._engine = new libWorkflowEngine(
			{
				resolveAddress: this._buildAddressResolver(),
				contextResolver: (this.options && typeof this.options.ContextResolver === 'function') ? this.options.ContextResolver : null,
				now: (this.options && typeof this.options.Now === 'function') ? this.options.Now : null
			});
	}

	// Address resolution via Manyfest. Prefer the Fable instance's factory; fall back
	// to a standalone Manyfest so the provider also works without a full Fable.
	_buildAddressResolver()
	{
		try
		{
			if (this.fable && typeof this.fable.newManyfest === 'function')
			{
				let tmpManyfest = this.fable.newManyfest();
				return (pContext, pAddress) => tmpManyfest.getValueAtAddress(pContext, pAddress);
			}
		}
		catch (pError) { /* fall through to standalone */ }
		let libManyfest = require('manyfest');
		let tmpManyfestClass = libManyfest.Manyfest || libManyfest;
		let tmpManyfest = new tmpManyfestClass();
		return (pContext, pAddress) => tmpManyfest.getValueAtAddress(pContext, pAddress);
	}

	get engine() { return this._engine; }

	// -- delegated API ---------------------------------------------------------
	setContextResolver(pFunction) { this._engine.setContextResolver(pFunction); return this; }
	defineWorkflow(pDefinition) { return this._engine.defineWorkflow(pDefinition); }
	getWorkflow(pKey) { return this._engine.getWorkflow(pKey); }
	open(pSubjectId, pWorkflowKey, pActor, pAt) { return this._engine.open(pSubjectId, pWorkflowKey, pActor, pAt); }
	emit(pSubjectId, pEvent, pAt) { return this._engine.emit(pSubjectId, pEvent, pAt); }
	advance(pSubjectId, pToState, pActor, pAt) { return this._engine.advance(pSubjectId, pToState, pActor, pAt); }
	reevaluate(pSubjectId, pAt) { return this._engine.reevaluate(pSubjectId, pAt); }
	hydrate(pSubjectId, pWorkflowKey, pEvents) { return this._engine.hydrate(pSubjectId, pWorkflowKey, pEvents); }
	getState(pSubjectId) { return this._engine.getState(pSubjectId); }
	getTimeline(pSubjectId) { return this._engine.getTimeline(pSubjectId); }
	getMetrics(pSubjectId) { return this._engine.getMetrics(pSubjectId); }
	getAvailableExits(pSubjectId) { return this._engine.getAvailableExits(pSubjectId); }
	whatCanAdvance(pActor) { return this._engine.whatCanAdvance(pActor); }
	whoCanActOn(pSubjectId) { return this._engine.whoCanActOn(pSubjectId); }
}

module.exports = FableWorkflow;
module.exports.WorkflowEngine = libWorkflowEngine;
module.exports.WorkflowGuards = require('./Workflow-Guards.js');

},{"./Workflow-Engine.js":68,"./Workflow-Guards.js":69,"fable-serviceproviderbase":59,"manyfest":132}],68:[function(require,module,exports){
'use strict';

/**
 * Workflow-Engine
 *
 * The pure, data-model-agnostic core. It holds workflow definitions (config), an
 * append-only event log per subject, and two materialized projections folded on
 * every event: a metrics rollup (time in state, effort, active, overlap, stalled)
 * and an eligibility set (the currently-open exits with guard-satisfied + the gate).
 * Guard readiness is precomputed on write, so the agency queries are flat reads.
 *
 * The engine never imports a consumer's schema. It reaches data only through a
 * contextResolver(subjectId) -> object that the consumer supplies; guards address
 * into that object. An actor is { ID, Entitlements: [] }.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libWorkflowGuards = require('./Workflow-Guards.js');

class WorkflowEngine
{
	/**
	 * @param {object} [pOptions] - { resolveAddress, contextResolver, now }
	 */
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};
		this._guards = new libWorkflowGuards(tmpOptions.resolveAddress);
		this._now = (typeof tmpOptions.now === 'function') ? tmpOptions.now : () => Date.now();
		this._contextResolver = (typeof tmpOptions.contextResolver === 'function') ? tmpOptions.contextResolver : () => ({});

		this._workflows = {};       // key -> normalized definition
		this._subjects = {};        // subjectId -> record
		this._eventSeq = 0;
		this._agencyIndex = {};     // entitlement (or '*') -> { subjectId: true } with a satisfied exit
	}

	setContextResolver(pFunction) { if (typeof pFunction === 'function') { this._contextResolver = pFunction; } return this; }

	// -- workflow definitions -------------------------------------------------

	defineWorkflow(pDefinition)
	{
		let tmpDefinition = this._normalizeWorkflow(pDefinition);
		this._workflows[tmpDefinition.Key] = tmpDefinition;
		return tmpDefinition;
	}

	getWorkflow(pKey) { return this._workflows[pKey] || null; }

	_normalizeWorkflow(pDefinition)
	{
		if (!pDefinition || !pDefinition.Key) { throw new Error('a workflow definition requires a Key'); }
		let tmpStates = {};
		let tmpInitial = null;
		(pDefinition.States || []).forEach((pState) =>
		{
			if (!pState.Key) { throw new Error('a workflow state requires a Key'); }
			tmpStates[pState.Key] = { Key: pState.Key, Name: pState.Name || pState.Key, IsInitial: !!pState.IsInitial, IsTerminal: !!pState.IsTerminal, Category: pState.Category || null };
			if (pState.IsInitial) { tmpInitial = pState.Key; }
		});
		let tmpStateKeys = Object.keys(tmpStates);
		if (!tmpStateKeys.length) { throw new Error('a workflow requires at least one state'); }
		if (!tmpInitial) { tmpInitial = tmpStateKeys[0]; tmpStates[tmpInitial].IsInitial = true; }

		let tmpTransitions = (pDefinition.Transitions || []).map((pTransition) =>
		{
			if (!tmpStates[pTransition.From]) { throw new Error('transition From references unknown state "' + pTransition.From + '"'); }
			if (!tmpStates[pTransition.To]) { throw new Error('transition To references unknown state "' + pTransition.To + '"'); }
			let tmpGuardError = this._guards.validate(pTransition.Guard);
			if (tmpGuardError) { throw new Error('transition ' + pTransition.From + ' -> ' + pTransition.To + ' has an invalid guard: ' + tmpGuardError); }
			return {
				Key: pTransition.Key || (pTransition.From + '->' + pTransition.To),
				From: pTransition.From,
				To: pTransition.To,
				RequiresEntitlement: pTransition.RequiresEntitlement || null,
				ActorAddress: pTransition.ActorAddress || null,
				Guard: pTransition.Guard || null
			};
		});

		return {
			Key: pDefinition.Key,
			Name: pDefinition.Name || pDefinition.Key,
			AllowParallelStates: !!pDefinition.AllowParallelStates,
			States: tmpStates,
			Initial: tmpInitial,
			Transitions: tmpTransitions
		};
	}

	// -- lifecycle -------------------------------------------------------------

	open(pSubjectId, pWorkflowKey, pActor, pAt)
	{
		let tmpDefinition = this._workflows[pWorkflowKey];
		if (!tmpDefinition) { throw new Error('unknown workflow "' + pWorkflowKey + '"'); }
		if (this._subjects[pSubjectId]) { throw new Error('subject "' + pSubjectId + '" is already open'); }
		let tmpAt = (pAt != null) ? pAt : this._now();

		this._subjects[pSubjectId] =
		{
			SubjectID: pSubjectId,
			WorkflowKey: pWorkflowKey,
			Events: [],
			CurrentStates: [],
			Closed: false,
			Rollup: { OpenedAt: tmpAt, ClosedAt: null, ElapsedMS: 0, ActiveMS: 0, StalledMS: 0, EffortMS: 0, OverlapMS: 0, StateTime: {}, ActorTime: {} },
			Eligibility: [],
			_open: { states: {}, actors: {}, activeCount: 0, activeSince: null }
		};
		this._append(pSubjectId, { Type: 'opened', Actor: _actorID(pActor) }, tmpAt);
		this._enterState(pSubjectId, tmpDefinition.Initial, _actorID(pActor), tmpAt);
		this._recomputeEligibility(pSubjectId, tmpAt);
		return this.getState(pSubjectId);
	}

	/** Low-level append for non-transition events (actor.start/stop, note, prompt, ...). */
	emit(pSubjectId, pEvent, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		if (!tmpRecord) { throw new Error('unknown subject "' + pSubjectId + '"'); }
		let tmpAt = (pAt != null) ? pAt : this._now();
		if (pEvent.Type === 'actor.start') { this._actorStart(pSubjectId, pEvent.Actor, tmpAt); }
		else if (pEvent.Type === 'actor.stop') { this._actorStop(pSubjectId, pEvent.Actor, tmpAt); }
		else { this._append(pSubjectId, pEvent, tmpAt); }
		this._recomputeEligibility(pSubjectId, tmpAt);
		return tmpRecord.Events[tmpRecord.Events.length - 1];
	}

	/**
	 * Attempt a governed transition. Returns { ok, reason?, state? }. Validates the
	 * exit exists, its guard is satisfied (already precomputed), and the actor clears
	 * the gate (entitlement + optional data-derived actor).
	 */
	advance(pSubjectId, pToStateKey, pActor, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		if (!tmpRecord) { return { ok: false, reason: 'unknown subject' }; }
		if (tmpRecord.Closed) { return { ok: false, reason: 'subject is closed' }; }
		let tmpAt = (pAt != null) ? pAt : this._now();
		let tmpActor = pActor || {};
		let tmpEntitlements = tmpActor.Entitlements || [];

		let tmpExit = tmpRecord.Eligibility.find((pExit) => pExit.ToState === pToStateKey);
		if (!tmpExit) { return { ok: false, reason: 'no transition to "' + pToStateKey + '" from the current state' }; }
		if (!tmpExit.GuardSatisfied) { return { ok: false, reason: 'the readiness guard for "' + pToStateKey + '" is not satisfied' }; }
		if (tmpExit.RequiredEntitlement && tmpEntitlements.indexOf(tmpExit.RequiredEntitlement) < 0)
		{
			return { ok: false, reason: 'actor lacks the "' + tmpExit.RequiredEntitlement + '" entitlement' };
		}
		if (tmpExit.ResolvedActor != null && tmpActor.ID !== tmpExit.ResolvedActor)
		{
			return { ok: false, reason: 'only the designated actor may make this move' };
		}

		this._enterState(pSubjectId, pToStateKey, tmpActor.ID || null, tmpAt);
		this._recomputeEligibility(pSubjectId, tmpAt);
		return { ok: true, state: this.getState(pSubjectId) };
	}

	/** Re-fold eligibility after the consumer changes a subject's data. */
	reevaluate(pSubjectId, pAt)
	{
		if (this._subjects[pSubjectId]) { this._recomputeEligibility(pSubjectId, (pAt != null) ? pAt : this._now()); }
	}

	/**
	 * Rebuild a subject from its stored event log, for a server that persists the log
	 * rather than holding the engine in memory. The log is the source of truth; this
	 * replays it to reconstruct the current states and the folded projections, without
	 * appending anything new. After replay, eligibility is recomputed against the current
	 * data (unless the subject is closed) so the agency reads work immediately. Events are
	 * sorted by (At, ID) so an out-of-order fetch still folds correctly.
	 */
	hydrate(pSubjectId, pWorkflowKey, pEvents)
	{
		let tmpDefinition = this._workflows[pWorkflowKey];
		if (!tmpDefinition) { throw new Error('unknown workflow "' + pWorkflowKey + '"'); }
		if (this._subjects[pSubjectId]) { throw new Error('subject "' + pSubjectId + '" is already open'); }

		let tmpEvents = (pEvents || []).slice().sort((pA, pB) => ((pA.At - pB.At) || ((pA.ID || 0) - (pB.ID || 0))));
		let tmpOpenedAt = tmpEvents.length ? tmpEvents[0].At : this._now();

		this._subjects[pSubjectId] =
		{
			SubjectID: pSubjectId,
			WorkflowKey: pWorkflowKey,
			Events: [],
			CurrentStates: [],
			Closed: false,
			Rollup: { OpenedAt: tmpOpenedAt, ClosedAt: null, ElapsedMS: 0, ActiveMS: 0, StalledMS: 0, EffortMS: 0, OverlapMS: 0, StateTime: {}, ActorTime: {} },
			Eligibility: [],
			_open: { states: {}, actors: {}, activeCount: 0, activeSince: null }
		};

		tmpEvents.forEach((pEvent) =>
		{
			this._replayEvent(pSubjectId, pEvent);
			if ((pEvent.ID || 0) > this._eventSeq) { this._eventSeq = pEvent.ID; }
		});

		if (!this._subjects[pSubjectId].Closed) { this._recomputeEligibility(pSubjectId, this._now()); }
		return this.getState(pSubjectId);
	}

	// -- internal folds --------------------------------------------------------

	_append(pSubjectId, pEvent, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		let tmpEvent = Object.assign({ ID: ++this._eventSeq, At: (pAt != null) ? pAt : this._now() }, pEvent);
		tmpRecord.Events.push(tmpEvent);
		return tmpEvent;
	}

	_enterState(pSubjectId, pStateKey, pActorID, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		let tmpDefinition = this._workflows[tmpRecord.WorkflowKey];
		if (!tmpDefinition.AllowParallelStates)
		{
			tmpRecord.CurrentStates.slice().forEach((pState) => this._exitState(pSubjectId, pState, pActorID, pAt));
		}
		if (tmpRecord.CurrentStates.indexOf(pStateKey) < 0) { tmpRecord.CurrentStates.push(pStateKey); }
		tmpRecord._open.states[pStateKey] = pAt;
		this._append(pSubjectId, { Type: 'state.enter', State: pStateKey, Actor: pActorID }, pAt);
		if (tmpDefinition.States[pStateKey].IsTerminal) { this._close(pSubjectId, pActorID, pAt); }
	}

	_exitState(pSubjectId, pStateKey, pActorID, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		let tmpSince = tmpRecord._open.states[pStateKey];
		if (tmpSince != null)
		{
			tmpRecord.Rollup.StateTime[pStateKey] = (tmpRecord.Rollup.StateTime[pStateKey] || 0) + (pAt - tmpSince);
			delete tmpRecord._open.states[pStateKey];
		}
		let tmpIndex = tmpRecord.CurrentStates.indexOf(pStateKey);
		if (tmpIndex >= 0) { tmpRecord.CurrentStates.splice(tmpIndex, 1); }
		this._append(pSubjectId, { Type: 'state.exit', State: pStateKey, Actor: pActorID }, pAt);
	}

	_actorStart(pSubjectId, pActorID, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		if (tmpRecord._open.actors[pActorID] != null) { return; }
		tmpRecord._open.actors[pActorID] = pAt;
		if (tmpRecord._open.activeCount === 0) { tmpRecord._open.activeSince = pAt; }
		tmpRecord._open.activeCount++;
		this._append(pSubjectId, { Type: 'actor.start', Actor: pActorID }, pAt);
	}

	_actorStop(pSubjectId, pActorID, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		let tmpSince = tmpRecord._open.actors[pActorID];
		if (tmpSince == null) { return; }
		let tmpDuration = pAt - tmpSince;
		tmpRecord.Rollup.EffortMS += tmpDuration;
		tmpRecord.Rollup.ActorTime[pActorID] = (tmpRecord.Rollup.ActorTime[pActorID] || 0) + tmpDuration;
		delete tmpRecord._open.actors[pActorID];
		tmpRecord._open.activeCount--;
		if (tmpRecord._open.activeCount === 0 && tmpRecord._open.activeSince != null)
		{
			tmpRecord.Rollup.ActiveMS += (pAt - tmpRecord._open.activeSince);
			tmpRecord._open.activeSince = null;
		}
		tmpRecord.Rollup.OverlapMS = tmpRecord.Rollup.EffortMS - tmpRecord.Rollup.ActiveMS;
		this._append(pSubjectId, { Type: 'actor.stop', Actor: pActorID }, pAt);
	}

	_close(pSubjectId, pActorID, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		if (tmpRecord.Closed) { return; }
		tmpRecord.CurrentStates.slice().forEach((pState) => this._exitState(pSubjectId, pState, pActorID, pAt));
		Object.keys(tmpRecord._open.actors).forEach((pActor) => this._actorStop(pSubjectId, pActor, pAt));
		tmpRecord.Closed = true;
		tmpRecord.Rollup.ClosedAt = pAt;
		tmpRecord.Rollup.ElapsedMS = pAt - tmpRecord.Rollup.OpenedAt;
		tmpRecord.Rollup.StalledMS = Math.max(0, tmpRecord.Rollup.ElapsedMS - tmpRecord.Rollup.ActiveMS);
		tmpRecord.Rollup.OverlapMS = tmpRecord.Rollup.EffortMS - tmpRecord.Rollup.ActiveMS;
		this._append(pSubjectId, { Type: 'closed', Actor: pActorID }, pAt);
		tmpRecord.Eligibility = [];
		this._clearAgency(pSubjectId);
	}

	// Apply one already-recorded event's fold, without appending a new event. This mirrors
	// the accrual the live lifecycle methods do; hydrate() replays the log through it. A
	// round-trip test (build live -> hydrate from the timeline) guards the two against drift.
	_replayEvent(pSubjectId, pEvent)
	{
		let tmpRecord = this._subjects[pSubjectId];
		let tmpAt = pEvent.At;
		switch (pEvent.Type)
		{
			case 'state.enter':
				tmpRecord._open.states[pEvent.State] = tmpAt;
				if (tmpRecord.CurrentStates.indexOf(pEvent.State) < 0) { tmpRecord.CurrentStates.push(pEvent.State); }
				break;
			case 'state.exit':
			{
				let tmpSince = tmpRecord._open.states[pEvent.State];
				if (tmpSince != null)
				{
					tmpRecord.Rollup.StateTime[pEvent.State] = (tmpRecord.Rollup.StateTime[pEvent.State] || 0) + (tmpAt - tmpSince);
					delete tmpRecord._open.states[pEvent.State];
				}
				let tmpIndex = tmpRecord.CurrentStates.indexOf(pEvent.State);
				if (tmpIndex >= 0) { tmpRecord.CurrentStates.splice(tmpIndex, 1); }
				break;
			}
			case 'actor.start':
				if (tmpRecord._open.actors[pEvent.Actor] == null)
				{
					tmpRecord._open.actors[pEvent.Actor] = tmpAt;
					if (tmpRecord._open.activeCount === 0) { tmpRecord._open.activeSince = tmpAt; }
					tmpRecord._open.activeCount++;
				}
				break;
			case 'actor.stop':
			{
				let tmpSince = tmpRecord._open.actors[pEvent.Actor];
				if (tmpSince != null)
				{
					let tmpDuration = tmpAt - tmpSince;
					tmpRecord.Rollup.EffortMS += tmpDuration;
					tmpRecord.Rollup.ActorTime[pEvent.Actor] = (tmpRecord.Rollup.ActorTime[pEvent.Actor] || 0) + tmpDuration;
					delete tmpRecord._open.actors[pEvent.Actor];
					tmpRecord._open.activeCount--;
					if (tmpRecord._open.activeCount === 0 && tmpRecord._open.activeSince != null)
					{
						tmpRecord.Rollup.ActiveMS += (tmpAt - tmpRecord._open.activeSince);
						tmpRecord._open.activeSince = null;
					}
					tmpRecord.Rollup.OverlapMS = tmpRecord.Rollup.EffortMS - tmpRecord.Rollup.ActiveMS;
				}
				break;
			}
			case 'closed':
				tmpRecord.Closed = true;
				tmpRecord.Rollup.ClosedAt = tmpAt;
				tmpRecord.Rollup.ElapsedMS = tmpAt - tmpRecord.Rollup.OpenedAt;
				tmpRecord.Rollup.StalledMS = Math.max(0, tmpRecord.Rollup.ElapsedMS - tmpRecord.Rollup.ActiveMS);
				tmpRecord.Rollup.OverlapMS = tmpRecord.Rollup.EffortMS - tmpRecord.Rollup.ActiveMS;
				break;
			default:
				// opened, exit.became-available, and any custom event carry no fold.
				break;
		}
		tmpRecord.Events.push(pEvent);
	}

	_buildContext(pSubjectId)
	{
		let tmpRecord = this._subjects[pSubjectId];
		let tmpConsumer = this._contextResolver(pSubjectId) || {};
		// Engine-owned namespaces are layered on top so guards can read State / Metrics.
		return Object.assign({}, tmpConsumer,
			{
				State: { Current: tmpRecord.CurrentStates.slice() },
				Metrics: tmpRecord.Rollup
			});
	}

	_recomputeEligibility(pSubjectId, pAt)
	{
		let tmpRecord = this._subjects[pSubjectId];
		if (tmpRecord.Closed) { tmpRecord.Eligibility = []; this._clearAgency(pSubjectId); return; }
		let tmpDefinition = this._workflows[tmpRecord.WorkflowKey];
		let tmpContext = this._buildContext(pSubjectId);

		let tmpPrior = {};
		tmpRecord.Eligibility.forEach((pExit) => { tmpPrior[pExit.Key] = pExit.GuardSatisfied; });

		let tmpNext = [];
		tmpRecord.CurrentStates.forEach((pStateKey) =>
		{
			tmpDefinition.Transitions.filter((pTransition) => pTransition.From === pStateKey).forEach((pTransition) =>
			{
				let tmpSatisfied = this._guards.evaluate(pTransition.Guard, tmpContext);
				let tmpResolvedActor = pTransition.ActorAddress ? this._guards.resolveAddress(tmpContext, pTransition.ActorAddress) : null;
				tmpNext.push(
					{
						Key: pTransition.Key,
						FromState: pTransition.From,
						ToState: pTransition.To,
						GuardSatisfied: !!tmpSatisfied,
						RequiredEntitlement: pTransition.RequiresEntitlement,
						ResolvedActor: (tmpResolvedActor === undefined) ? null : tmpResolvedActor
					});
				if (tmpSatisfied && tmpPrior[pTransition.Key] === false)
				{
					this._append(pSubjectId, { Type: 'exit.became-available', State: pTransition.From, Payload: { ToState: pTransition.To } }, pAt);
				}
			});
		});
		tmpRecord.Eligibility = tmpNext;
		this._reindexAgency(pSubjectId);
	}

	_reindexAgency(pSubjectId)
	{
		this._clearAgency(pSubjectId);
		let tmpRecord = this._subjects[pSubjectId];
		tmpRecord.Eligibility.forEach((pExit) =>
		{
			if (!pExit.GuardSatisfied) { return; }
			let tmpKey = pExit.RequiredEntitlement || '*';
			if (!this._agencyIndex[tmpKey]) { this._agencyIndex[tmpKey] = {}; }
			this._agencyIndex[tmpKey][pSubjectId] = true;
		});
	}

	_clearAgency(pSubjectId)
	{
		Object.keys(this._agencyIndex).forEach((pKey) => { if (this._agencyIndex[pKey]) { delete this._agencyIndex[pKey][pSubjectId]; } });
	}

	// -- reads (the payoff: indexed, no guard evaluation) ----------------------

	getState(pSubjectId)
	{
		let tmpRecord = this._subjects[pSubjectId];
		return tmpRecord ? { SubjectID: pSubjectId, WorkflowKey: tmpRecord.WorkflowKey, CurrentStates: tmpRecord.CurrentStates.slice(), Closed: tmpRecord.Closed } : null;
	}

	getTimeline(pSubjectId) { let tmpRecord = this._subjects[pSubjectId]; return tmpRecord ? tmpRecord.Events.slice() : []; }

	getMetrics(pSubjectId)
	{
		let tmpRecord = this._subjects[pSubjectId];
		if (!tmpRecord) { return null; }
		let tmpMetrics = JSON.parse(JSON.stringify(tmpRecord.Rollup));
		if (!tmpRecord.Closed) { tmpMetrics.ElapsedMS = this._now() - tmpRecord.Rollup.OpenedAt; }
		return tmpMetrics;
	}

	getAvailableExits(pSubjectId) { let tmpRecord = this._subjects[pSubjectId]; return tmpRecord ? tmpRecord.Eligibility.slice() : []; }

	/** Subjects this actor can move forward right now (indexed read; no guard eval). */
	whatCanAdvance(pActor)
	{
		let tmpActor = pActor || {};
		let tmpEntitlements = tmpActor.Entitlements || [];
		let tmpCandidates = {};
		['*'].concat(tmpEntitlements).forEach((pEntitlement) =>
		{
			let tmpMap = this._agencyIndex[pEntitlement];
			if (tmpMap) { Object.keys(tmpMap).forEach((pSubjectId) => { tmpCandidates[pSubjectId] = true; }); }
		});
		return Object.keys(tmpCandidates).filter((pSubjectId) =>
		{
			let tmpRecord = this._subjects[pSubjectId];
			return tmpRecord && tmpRecord.Eligibility.some((pExit) => pExit.GuardSatisfied
				&& (!pExit.RequiredEntitlement || tmpEntitlements.indexOf(pExit.RequiredEntitlement) >= 0)
				&& (pExit.ResolvedActor == null || pExit.ResolvedActor === tmpActor.ID));
		});
	}

	/** Who has agency on this subject at its current stage. */
	whoCanActOn(pSubjectId)
	{
		let tmpRecord = this._subjects[pSubjectId];
		if (!tmpRecord) { return []; }
		return tmpRecord.Eligibility.filter((pExit) => pExit.GuardSatisfied).map((pExit) => (
			{ ToState: pExit.ToState, RequiredEntitlement: pExit.RequiredEntitlement, ResolvedActor: pExit.ResolvedActor }));
	}

	getSubjectIds() { return Object.keys(this._subjects); }
}

function _actorID(pActor) { return (pActor && pActor.ID != null) ? pActor.ID : (pActor != null ? pActor : null); }

module.exports = WorkflowEngine;

},{"./Workflow-Guards.js":69}],69:[function(require,module,exports){
'use strict';

/**
 * Workflow-Guards
 *
 * A guard is a structured condition tree, not a free-text expression. Leaves are
 * { address, op, value }; branches are { all: [...] }, { any: [...] }, { not: ... }.
 * Addresses are resolved against a consumer-supplied context object (so the engine
 * stays ignorant of the data model), and the tree is evaluated in plain JS. This is
 * robust, declarative, validatable, and its data dependencies (the addresses) are
 * trivially extractable for reactive re-evaluation.
 *
 * A null/undefined guard means "no condition", which is always satisfied.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// Reduce a Manyfest wildcard result (e.g. an object keyed by 'Media[0].Type') to a
// flat array of values, so collection conditions can be expressed.
function _wildcardValues(pResolved)
{
	if (Array.isArray(pResolved)) { return pResolved; }
	if (pResolved && typeof pResolved === 'object') { return Object.keys(pResolved).map((pKey) => pResolved[pKey]); }
	return (pResolved === undefined || pResolved === null) ? [] : [pResolved];
}

const _OPERATORS =
{
	'==':  (pA, pB) => pA == pB,
	'===': (pA, pB) => pA === pB,
	'!=':  (pA, pB) => pA != pB,
	'>':   (pA, pB) => Number(pA) > Number(pB),
	'>=':  (pA, pB) => Number(pA) >= Number(pB),
	'<':   (pA, pB) => Number(pA) < Number(pB),
	'<=':  (pA, pB) => Number(pA) <= Number(pB),
	'in':  (pA, pB) => Array.isArray(pB) && pB.indexOf(pA) >= 0,
	'nin': (pA, pB) => Array.isArray(pB) && pB.indexOf(pA) < 0,
	'exists': (pA) => (pA !== undefined && pA !== null),
	'empty':  (pA) => (pA === undefined || pA === null || pA === '' || (Array.isArray(pA) && pA.length === 0)),
	'truthy': (pA) => !!pA,
	'falsy':  (pA) => !pA,
	// Collection (wildcard address) reductions:
	'includesAny': (pA, pB) => { let tmpValues = _wildcardValues(pA); return Array.isArray(pB) && tmpValues.some((pValue) => pB.indexOf(pValue) >= 0); },
	'includesAll': (pA, pB) => { let tmpValues = _wildcardValues(pA); return Array.isArray(pB) && pB.every((pValue) => tmpValues.indexOf(pValue) >= 0); },
	'countGte':    (pA, pB) => _wildcardValues(pA).length >= Number(pB)
};

function _defaultResolveAddress()
{
	let libManyfest = require('manyfest');
	let tmpManyfestClass = libManyfest.Manyfest || libManyfest;
	let tmpManyfest = new tmpManyfestClass();
	return (pContext, pAddress) => tmpManyfest.getValueAtAddress(pContext, pAddress);
}

class WorkflowGuards
{
	/**
	 * @param {function} [pResolveAddress] - (context, address) -> value. Defaults to a
	 *   standalone Manyfest resolver.
	 */
	constructor(pResolveAddress)
	{
		this.resolveAddress = (typeof pResolveAddress === 'function') ? pResolveAddress : _defaultResolveAddress();
	}

	/** Evaluate a guard tree against a context. Returns a boolean. */
	evaluate(pGuard, pContext)
	{
		if (pGuard == null) { return true; }
		if (Array.isArray(pGuard.all)) { return pGuard.all.every((pChild) => this.evaluate(pChild, pContext)); }
		if (Array.isArray(pGuard.any)) { return pGuard.any.some((pChild) => this.evaluate(pChild, pContext)); }
		if (pGuard.not) { return !this.evaluate(pGuard.not, pContext); }

		let tmpOperator = _OPERATORS[pGuard.op || 'truthy'];
		if (!tmpOperator) { return false; }
		let tmpResolved = this.resolveAddress(pContext, pGuard.address);
		return !!tmpOperator(tmpResolved, pGuard.value);
	}

	/** The flat list of addresses a guard depends on (drives reactive re-evaluation). */
	dependencies(pGuard, pAccumulator)
	{
		let tmpAccumulator = pAccumulator || [];
		if (pGuard == null) { return tmpAccumulator; }
		if (Array.isArray(pGuard.all)) { pGuard.all.forEach((pChild) => this.dependencies(pChild, tmpAccumulator)); }
		else if (Array.isArray(pGuard.any)) { pGuard.any.forEach((pChild) => this.dependencies(pChild, tmpAccumulator)); }
		else if (pGuard.not) { this.dependencies(pGuard.not, tmpAccumulator); }
		else if (pGuard.address && tmpAccumulator.indexOf(pGuard.address) < 0) { tmpAccumulator.push(pGuard.address); }
		return tmpAccumulator;
	}

	/** Structural validation. Returns null when valid, else an error string. */
	validate(pGuard)
	{
		if (pGuard == null) { return null; }
		if (Array.isArray(pGuard.all)) { return _firstError(pGuard.all, (pChild) => this.validate(pChild)); }
		if (Array.isArray(pGuard.any)) { return _firstError(pGuard.any, (pChild) => this.validate(pChild)); }
		if (pGuard.not) { return this.validate(pGuard.not); }
		if (!pGuard.address) { return 'guard leaf is missing an address'; }
		let tmpOperator = pGuard.op || 'truthy';
		if (!_OPERATORS[tmpOperator]) { return 'unknown guard operator "' + tmpOperator + '"'; }
		return null;
	}
}

function _firstError(pArray, fCheck)
{
	for (let i = 0; i < pArray.length; i++)
	{
		let tmpError = fCheck(pArray[i]);
		if (tmpError) { return tmpError; }
	}
	return null;
}

module.exports = WorkflowGuards;
module.exports.OPERATORS = Object.keys(_OPERATORS);

},{"manyfest":132}],70:[function(require,module,exports){
module.exports={
  "name": "fable",
  "version": "3.1.85",
  "description": "A service dependency injection, configuration and logging library.",
  "main": "source/Fable.js",
  "scripts": {
    "start": "node source/Fable.js",
    "coverage": "npx quack coverage",
    "test": "npx quack test",
    "build": "npx quack build",
    "prepublishOnly": "npx quack build",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t fable-image:local",
    "docker-dev-run": "docker run -it -d --name fable-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/fable\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" fable-image:local",
    "docker-dev-shell": "docker exec -it fable-dev /bin/bash",
    "tests": "npx quack test -g"
  },
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "browser": {
    "./source/service/Fable-Service-EnvironmentData.js": "./source/service/Fable-Service-EnvironmentData-Web.js",
    "./source/service/Fable-Service-FilePersistence.js": "./source/service/Fable-Service-FilePersistence-Web.js"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/fable-retold/fable.git"
  },
  "keywords": [
    "entity",
    "behavior"
  ],
  "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/fable-retold/fable/issues"
  },
  "homepage": "https://github.com/fable-retold/fable",
  "devDependencies": {
    "pict-docuserve": "^1.4.19",
    "quackage": "^1.3.0"
  },
  "dependencies": {
    "async.eachlimit": "^0.5.2",
    "async.waterfall": "^0.5.2",
    "big.js": "^7.0.1",
    "cachetrax": "^1.0.6",
    "cookie": "^1.1.1",
    "data-arithmatic": "^1.0.7",
    "dayjs": "^1.11.19",
    "fable-log": "^3.0.18",
    "fable-serviceproviderbase": "^3.0.19",
    "fable-settings": "^3.0.17",
    "fable-uuid": "^3.0.15",
    "manyfest": "^1.0.49",
    "simple-get": "^4.0.1"
  }
}

},{}],71:[function(require,module,exports){
/**
* Fable Application Services Support Library
* @author <steven@velozo.com>
*/
// Pre-init services
const libFableSettings = require('fable-settings');
const libFableUUID = require('fable-uuid');
const libFableLog = require('fable-log');

const libPackage = require('../package.json');

const libFableServiceBase = require('fable-serviceproviderbase');

class Fable extends libFableServiceBase.CoreServiceProviderBase
{
	constructor(pSettings)
	{
		super(pSettings);

		// Initialization Phase 0: Set up the lowest level state (fable is a utility service manager at heart)
		this.serviceType = 'ServiceManager';
		/** @type {Object} */
		this._Package = libPackage;

		// An array of the types of services available
		this.serviceTypes = [];
		// A map of instantiated services
		this.servicesMap = {};
		// A map of the default instantiated service by type
		this.services = {};

		// A map of class constructors for services
		this.serviceClasses = {};

		// If we need extra service initialization capabilities
		this.extraServiceInitialization = false;

		// Set how noisy the system is about signaling complexity
		this.LogNoisiness = 0;

		// Initialization Phase 1: Set up the core utility services
		// These are things like power, water, and sewage.  They are required for fable to run (e.g. logging, settings, etc)

		// Instantiate the default Settings Manager
		this.SettingsManager = new libFableSettings(pSettings);
		this.SettingsManager = this.SettingsManager;
		// Instantiate the UUID generator
		this.UUID = new libFableUUID(this.SettingsManager.settings);
		// Instantiate the logging system
		this.Logging = new libFableLog(this.SettingsManager.settings);
		this.Logging.initialize();

		// Initialization Phase 1.5: Instantiate the service manager
		// This is the start actual bootstrapping point for fable.
		// For consistency fable is treated as a service.
		this.ServiceManager = this;
		// TODO: Remove this when Orator and meadow-endpoints are shifted to this new pattern
		this.serviceManager = this;
		// END TODO
		this.connectFable(this);
		// --> Bootstrapping of fable into the Service Manager is complete

		// Initialization Phase 2: Map in the default services.
		// They will then be available in the Default service provider set as well.
		this.connectPreinitServiceProviderInstance(this.UUID);
		this.connectPreinitServiceProviderInstance(this.Logging);
		this.connectPreinitServiceProviderInstance(this.SettingsManager);

		// Initialize and instantiate the default baked-in Data Arithmatic service
		this.addAndInstantiateServiceType('EnvironmentData', require('./services/Fable-Service-EnvironmentData.js'));
		this.addServiceType('Template', require('./services/Fable-Service-Template.js'));
		this.addServiceType('MetaTemplate', require('./services/Fable-Service-MetaTemplate.js'));
		this.addServiceType('Anticipate', require('./services/Fable-Service-Anticipate.js'));
		this.addAndInstantiateServiceType('Dates', require('./services/Fable-Service-DateManipulation.js'));
		this.addAndInstantiateServiceType('DataFormat', require('./services/Fable-Service-DataFormat.js'));
		this.addAndInstantiateServiceType('DataGeneration', require('./services/Fable-Service-DataGeneration.js'));
		this.addAndInstantiateServiceType('Utility', require('./services/Fable-Service-Utility.js'));
		this.addAndInstantiateServiceType('Logic', require('./services/Fable-Service-Logic.js'));
		this.addAndInstantiateServiceType('Math', require('./services/Fable-Service-Math.js'));
		this.addServiceType('ExpressionParser', require('./services/Fable-Service-ExpressionParser.js'));
		this.addServiceType('RestClient', require('./services/Fable-Service-RestClient.js'));
		this.addServiceType('Manifest', require('manyfest'));
		this.addServiceType('ObjectCache', require('cachetrax'));
		this.addAndInstantiateServiceType('ProgressTime', require('./services/Fable-Service-ProgressTime.js'));
		this.addServiceType('ProgressTrackerSet', require('./services/Fable-Service-ProgressTrackerSet.js'));
		this.addServiceType('Operation', require('./services/Fable-Service-Operation.js'));
		this.addServiceType('CSVParser', require('./services/Fable-Service-CSVParser.js'));
		this.addServiceType('FilePersistence', require('./services/Fable-Service-FilePersistence.js'));
	}

	/* State Accessors */
	get isFable()
	{
		return true;
	}

	get settings()
	{
		return this.SettingsManager.settings;
	}

	get settingsManager()
	{
		return this.SettingsManager;
	}

	// For backwards compatibility
	getUUID()
	{
		return this.UUID.getUUID();
	}

	newAnticipate()
	{
		return this.instantiateServiceProviderWithoutRegistration('Anticipate');
	}

	newManyfest(pManifestDefinition)
	{
		return this.instantiateServiceProviderWithoutRegistration('Manifest', pManifestDefinition);
	}

	/* Service Manager Methods */
	addServiceType(pServiceType, pServiceClass)
	{
		if (pServiceType in this.servicesMap)
		{
			//this.log.warn(`Adding a service type [${pServiceType}] that already exists.  This will change the default class prototype for this service.`);
			// This broke command-line utilities that overrode services and wanted to strictly control log output
		}
		else
		{
			// Add the container for instantiated services to go in
			this.servicesMap[pServiceType] = {};

			// Add the type to the list of types
			this.serviceTypes.push(pServiceType);
		}

		// Using the static member of the class is a much more reliable way to check if it is a service class than instanceof
		if ((typeof(pServiceClass) == 'function') && (pServiceClass.isFableService))
		{
			// Add the class to the list of classes
			this.serviceClasses[pServiceType] = pServiceClass;
		}
		else
		{
			// Add the base class to the list of classes
			this.log.error(`Attempted to add service type [${pServiceType}] with an invalid class.  Using base service class, which will not crash but won't provide meaningful services.`);
			this.serviceClasses[pServiceType] = libFableServiceBase;
		}

		return this.serviceClasses[pServiceType];
	}

	addServiceTypeIfNotExists(pServiceType, pServiceClass)
	{
		if (!(pServiceType in this.servicesMap))
		{
			return this.addServiceType(pServiceType, pServiceClass);
		}
		else
		{
			return this.serviceClasses[pServiceType];
		}
	}

	// This is for the services that are meant to run mostly single-instance so need a default at initialization
	addAndInstantiateServiceType(pServiceType, pServiceClass)
	{
		this.addServiceType(pServiceType, pServiceClass);
		return this.instantiateServiceProvider(pServiceType, {}, `${pServiceType}-Default`);
	}

	addAndInstantiateServiceTypeIfNotExists(pServiceType, pServiceClass)
	{
		this.addServiceTypeIfNotExists(pServiceType, pServiceClass);

		if ((!(pServiceType in this.servicesMap)) || (!(pServiceType in this.fable)))
		{
			return this.instantiateServiceProvider(pServiceType, {}, `${pServiceType}-Default`);
		}
		else
		{
			return this[pServiceType];
		}
	}

	addAndInstantiateSingletonService(pServiceType, pOptions, pServiceClass)
	{
		this.addServiceTypeIfNotExists(pServiceType, pServiceClass);

		if ((!(pServiceType in this.servicesMap)) || (!(pServiceType in this.fable)))
		{
			return this.instantiateServiceProvider(pServiceType, pOptions, `${pServiceType}-Default`);
		}
		else
		{
			return this[pServiceType];
		}
	}

	// Some services expect to be overloaded / customized class.
	instantiateServiceProviderFromPrototype(pServiceType, pOptions, pCustomServiceHash, pServicePrototype)
	{
		// Instantiate the service
		let tmpService = new pServicePrototype(this, pOptions, pCustomServiceHash);

		if (this.extraServiceInitialization)
		{
			tmpService = this.extraServiceInitialization(tmpService);
		}

		// Add the service to the service map
		this.servicesMap[pServiceType][tmpService.Hash] = tmpService;

		// If this is the first service of this type, make it the default
		if (!(pServiceType in this.services))
		{
			this.setDefaultServiceInstantiation(pServiceType, tmpService.Hash)
		}

		return tmpService;
	}

	instantiateServiceProvider(pServiceType, pOptions, pCustomServiceHash)
	{
		// Instantiate the service
		let tmpService = this.instantiateServiceProviderWithoutRegistration(pServiceType, pOptions, pCustomServiceHash);

		// Add the service to the service map
		this.servicesMap[pServiceType][tmpService.Hash] = tmpService;

		// If this is the first service of this type, make it the default
		if (!(pServiceType in this.services))
		{
			this.setDefaultServiceInstantiation(pServiceType, tmpService.Hash)
		}

		return tmpService;
	}

	instantiateServiceProviderIfNotExists(pServiceType, pOptions, pCustomServiceHash)
	{
		if (pServiceType in this.services)
		{
			return this.services[pServiceType];
		}
		else
		{
			return this.instantiateServiceProvider(pServiceType, pOptions, pCustomServiceHash);
		}
	}

	// Create a service provider but don't register it to live forever in fable.services
	instantiateServiceProviderWithoutRegistration(pServiceType, pOptions, pCustomServiceHash)
	{
		// Instantiate the service
		let tmpService = new this.serviceClasses[pServiceType](this, pOptions, pCustomServiceHash);
		if (this.extraServiceInitialization)
		{
			tmpService = this.extraServiceInitialization(tmpService);
		}
		return tmpService;
	}

	// Connect an initialized service provider that came before Fable was initialized
	connectPreinitServiceProviderInstance(pServiceInstance)
	{
		let tmpServiceType = pServiceInstance.serviceType;
		let tmpServiceHash = pServiceInstance.Hash;

		// The service should already be instantiated, so just connect it to fable
		pServiceInstance.connectFable(this);

		// Add the service type to the map if it isn't there yet
		if (!(tmpServiceType in this.servicesMap))
		{
			// If the core service hasn't registered itself yet, create the service container for it.
			// This means you couldn't register another with this type unless it was later registered with a constructor class.
			this.servicesMap[tmpServiceType] = {};
		}
		// Add the service to the service map
		this.servicesMap[tmpServiceType][tmpServiceHash] = pServiceInstance;

		// If this is the first service of this type, make it the default
		if (!(tmpServiceType in this.services))
		{
			this.setDefaultServiceInstantiation(tmpServiceType, tmpServiceHash, false);
		}

		return pServiceInstance;
	}

	setDefaultServiceInstantiation(pServiceType, pServiceHash, pOverwriteService)
	{
		// Overwrite services by default, unless told not to
		let tmpOverwriteService = (typeof(pOverwriteService) === 'undefined') ? true : pOverwriteService;
		// Make sure the service exists
		if (pServiceHash in this.servicesMap[pServiceType])
		{
			if (!(pServiceType in this) || tmpOverwriteService)
			{
				this[pServiceType] = this.servicesMap[pServiceType][pServiceHash];
			}
			if (!(pServiceType in this.services) || tmpOverwriteService)
			{
				this.services[pServiceType] = this.servicesMap[pServiceType][pServiceHash];
			}
			return true;
		}

		return false;
	}

	/**
	 * Generate a safe string to use in filenames for a date.  Useful for log file uniqueness and temporary outputs.
	 *
	 * @static
	 * @param {Date} pDate - An optional javascript Date object to generate a datestamp for.
	 * @returns {string} - A string formatted as YYYY-MM-DD-HH-MM-SS
	 */
	static generateFileNameDateStamp(pDate)
	{
		const tmpDate = pDate || new Date();
		const tmpYear = tmpDate.getFullYear();
		const tmpMonth = String(tmpDate.getMonth() + 1).padStart(2, '0');
		const tmpDay = String(tmpDate.getDate()).padStart(2, '0');
		const tmpHour = String(tmpDate.getHours()).padStart(2, '0');
		const tmpMinute = String(tmpDate.getMinutes()).padStart(2, '0');
		const tmpSecond = String(tmpDate.getSeconds()).padStart(2, '0');
		return `${tmpYear}-${tmpMonth}-${tmpDay}-${tmpHour}-${tmpMinute}-${tmpSecond}`;
	}
}

// This is for backwards compatibility
function autoConstruct(pSettings)
{
	return new Fable(pSettings);
}

module.exports = Fable;
module.exports.new = autoConstruct;

module.exports.LogProviderBase = libFableLog.LogProviderBase;
module.exports.ServiceProviderBase = libFableServiceBase;
module.exports.CoreServiceProviderBase = libFableServiceBase.CoreServiceProviderBase;

module.exports.precedent = libFableSettings.precedent;

},{"../package.json":70,"./services/Fable-Service-Anticipate.js":72,"./services/Fable-Service-CSVParser.js":73,"./services/Fable-Service-DataFormat.js":74,"./services/Fable-Service-DataGeneration.js":76,"./services/Fable-Service-DateManipulation.js":77,"./services/Fable-Service-EnvironmentData.js":78,"./services/Fable-Service-ExpressionParser.js":79,"./services/Fable-Service-FilePersistence.js":90,"./services/Fable-Service-Logic.js":91,"./services/Fable-Service-Math.js":92,"./services/Fable-Service-MetaTemplate.js":93,"./services/Fable-Service-Operation.js":97,"./services/Fable-Service-ProgressTime.js":98,"./services/Fable-Service-ProgressTrackerSet.js":100,"./services/Fable-Service-RestClient.js":101,"./services/Fable-Service-Template.js":102,"./services/Fable-Service-Utility.js":103,"cachetrax":22,"fable-log":57,"fable-serviceproviderbase":59,"fable-settings":63,"fable-uuid":66,"manyfest":132}],72:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceAnticipate extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'AsyncAnticipate';

		// The queue of operations waiting to run.
		this.operationQueue = [];
		this.erroredOperations = [];

		this.executingOperationCount = 0;
		this.completedOperationCount = 0;

		this.callDepth = 0;

		this.maxOperations = 1;

		this.lastError = undefined;
		this.waitingFunctions = [];
	}

	checkQueue()
	{
		// This could be combined with the last else if stanza but the logic for errors and non-errors would be blended and more complex to follow so keeping it unrolled.
		if (this.lastError)
		{
			// If there are no operations left, and we have waiting functions, call them.
			for (let i = 0; i < this.waitingFunctions.length; i++)
			{
				//this.log.trace('Calling waiting function.')
				this.waitingFunctions[i](this.lastError);
			}
			// Reset our state
			this.lastError = undefined;
			this.waitingFunctions = [];
		}
		// This checks to see if we need to start any operations.
		else if (this.operationQueue.length > 0 && this.executingOperationCount < this.maxOperations)
		{
			let tmpOperation = this.operationQueue.shift();
			this.executingOperationCount += 1;
			tmpOperation(this.buildAnticipatorCallback());
		}
		else if (this.waitingFunctions.length > 0 && this.executingOperationCount < 1)
		{
			// If there are no operations left, and we have waiting functions, call them.
			for (let i = 0; i < this.waitingFunctions.length; i++)
			{
				//this.log.trace('Calling waiting function.')
				this.waitingFunctions[i](this.lastError);
			}
			// Reset our state
			this.lastError = undefined;
			this.waitingFunctions = [];
		}
	}

	// Expects a function fAsynchronousFunction(fCallback)
	anticipate(fAsynchronousFunction)
	{
		//this.log.trace('Adding a function...')
		this.operationQueue.push(fAsynchronousFunction);
		this.checkQueue();
	}

	buildAnticipatorCallback()
	{
		// This uses closure-scoped state to track the callback state
		let tmpCallbackState = (
			{
				Called: false,
				Error: undefined,
				OperationSet: this
			});
		return hoistedCallback.bind(this);
		function hoistedCallback(pError)
		{
			if (tmpCallbackState.Called)
			{
				// If they call the callback twice, throw an error
				throw new Error("Anticipation async callback called twice...");
			}
			tmpCallbackState.Called = true;
			this.lastError = pError;

			tmpCallbackState.OperationSet.executingOperationCount -= 1;
			tmpCallbackState.OperationSet.completedOperationCount += 1;

			tmpCallbackState.OperationSet.callDepth++;

			// TODO: Figure out a better pattern for chaining templates so the call stack doesn't get abused.
			if (tmpCallbackState.OperationSet.callDepth > 400)
			{
				tmpCallbackState.OperationSet.callDepth = 0;
				setTimeout(tmpCallbackState.OperationSet.checkQueue.bind(this), 0);
			}
			else
			{
				tmpCallbackState.OperationSet.checkQueue();
			}
		}
	}

	wait(fCallback)
	{
		this.waitingFunctions.push(fCallback);
		this.checkQueue();
	}
}

module.exports = FableServiceAnticipate;
},{"fable-serviceproviderbase":59}],73:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
/**
* Parsing CSVs.  Why?  Because it's a thing that needs to be done.
*
* 1. And the other node CSV parsers had issues with the really messy files we had.
*
*
* 2. None of the CSV parsers dealt with and multi-line quoted string columns
*	which are apparently a-ok according to the official spec.
* Plus a lot of them are asynchronous because apparently that's the best way to
* do anything; unfortunately some files have a sequence issue with that.
*
* @class CSVParser
*/
class CSVParser extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'CSVParser';

		this.Header = [];
		this.HeaderFieldNames = [];

		this.Delimiter = ',';
		this.QuoteCharacter = '"';

		this.CleanCharacters = ['\r'];

		this.HeaderLineIndex = 0;
		this.HasHeader = true;
		this.HasSetHeader = false;
		this.EmitHeader = false;

		this.EmitJSON = true;

		this.EscapedQuoteString = '&quot;';

		// Current Line Parsing State
		this.CurrentLine = '';
		this.CurrentRecord = [];

		this.InQuote = false;
		this.InEscapedQuote = false;

		this.LinesParsed = 0;
		this.RowsEmitted = 0;
	}

	marshalRowToJSON(pRowArray)
	{
		if (!Array.isArray(pRowArray))
		{
			return false;
		}

		for (let i = this.HeaderFieldNames.length; i < pRowArray.length; i++)
		{
			this.HeaderFieldNames[i] = `${i}`;
		}

		let tmpObject = {};

		for (let i = 0; i < pRowArray.length; i++)
		{
			tmpObject[this.HeaderFieldNames[i]] = pRowArray[i];
		}

		return tmpObject;
	}

	// Set the header data, for use in marshalling to JSON.
	setHeader (pHeaderArray)
	{
		this.Header = pHeaderArray;

		for (let i = 0; i < this.Header.length; i++)
		{
			if (typeof(this.Header[i]) == 'undefined')
			{
				this.HeaderFieldNames[i] = `${i}`;
			}
			else
			{
				this.HeaderFieldNames[i] = this.Header[i].toString().trim();
			}
		}
	}

	resetRowState()
	{
		this.CurrentRecord = [];
	}

	pushLine()
	{
		for (let i = 0; i < this.CleanCharacters.length; i++)
		{
			this.CurrentLine = this.CurrentLine.replace(this.CleanCharacters[i],'');
		}
		this.CurrentRecord.push(this.CurrentLine);
		this.CurrentLine = '';
	}

	emitRow(pFormatAsJSON)
	{
		let tmpFormatAsJSON = (typeof(pFormatAsJSON) == 'undefined') ? this.EmitJSON : pFormatAsJSON;

		this.RowsEmitted++;
		let tmpCompletedRecord = this.CurrentRecord;
		this.CurrentRecord = [];

		if (tmpFormatAsJSON)
		{
			return this.marshalRowToJSON(tmpCompletedRecord);
		}
		else
		{
			return tmpCompletedRecord;
		}
	}

	parseCSVLine (pLineString)
	{
		this.LinesParsed++;

		for (let i = 0; i < pLineString.length; i++)
		{
			if ((!this.InQuote) && (pLineString[i] == this.Delimiter))
			{
				this.pushLine();
			}
			else if (pLineString[i] == this.QuoteCharacter)
			{
				// If we are in the second part of an escaped quote, ignore it.
				if (this.InEscapedQuote)
				{
					this.InEscapedQuote = false;
				}
				// If we aren't in a quote, enter quote
				else if (!this.InQuote)
				{
					this.InQuote = true;
				}
				// We are in a quote, so peek forward to see if this is an "escaped" quote pair
				else if ((i < pLineString.length) && (pLineString[i+1] == this.QuoteCharacter))
				{
					this.CurrentLine += this.EscapedQuoteString;
					this.InEscapedQuote = true;
				}
				// We are in a quote, this isn't an "escaped" quote pair, so go out of quote mode
				else
				{
					this.InQuote = false;
				}
			}
			else
			{
				this.CurrentLine += pLineString[i];
			}
		}

		// See if we are in a multiline quoted entry -- if not, emit the row.
		if (!this.InQuote)
		{
			// Push the last remaining column from the buffer to the current line.
			this.pushLine();

			// Check to see if there is a header -- and if so, if this is the header row
			if (this.HasHeader && !this.HasSetHeader && (this.RowsEmitted == this.HeaderLineIndex))
			{
				this.HasSetHeader = true;
				// Override the format as json bit
				this.setHeader(this.emitRow(false));

				// No matter what, formatting this as JSON is silly and we don't want to go there anyway.
				if (this.EmitHeader)
				{
					return this.Header;
				}
				else
				{
					return false;
				}
			}
			else
			{
				return this.emitRow();
			}
		}
		else
		{
			return false;
		}
	};
}

module.exports = CSVParser;

},{"fable-serviceproviderbase":59}],74:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
/**
* Data Formatting and Translation Functions
*
* @class DataFormat
*/
class DataFormat extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'DataArithmatic';

		// Regular Expressions (so they don't have to be recompiled every time)
		// These could be defined as static, but I'm not sure if that will work with browserify ... and specifically the QT browser.
		this._Regex_formatterInsertCommas = /.{1,3}/g;
		// Match Function:
		// function(pMatch, pSign, pZeros, pBefore, pDecimal, pAfter)
		// Thoughts about below:   /^([+-]?)(0*)(\d+)(\.(\d+))?$/;
		this._Regex_formatterAddCommasToNumber = /^([-+]?)(0?)(\d+)(.?)(\d+)$/g;
		this._Regex_formatterDollarsRemoveCommas = /,/gi;
		this._Regex_formatterCleanNonAlphaChar = /[^a-zA-Z]/gi;
		this._Regex_formatterCapitalizeEachWord = /([a-zA-Z]+)/g;
		this._Regex_matcherHTMLEntities = /&(#?[a-zA-Z0-9]+);/g;

		// TODO: Potentially pull these in from a configuration.
		// TODO: Use locale data for this if it's defaults all the way down.
		this._Value_MoneySign_Currency = '$';
		this._Value_NaN_Currency = '--';
		this._Value_GroupSeparator_Number = ',';

		this._Value_Prefix_StringHash = 'HSH';
		this._Value_Clean_formatterCleanNonAlpha = '';

		this._UseEngineStringStartsWith = (typeof(String.prototype.startsWith) === 'function');
		this._UseEngineStringEndsWith = (typeof(String.prototype.endsWith) === 'function');

		this._SanitizeObjectKeyRegex = /[^a-zA-Z0-9_]/gi;
		this._SanitizeObjectKeyReplacement = '_';
		this._SanitizeObjectKeyInvalid = 'INVALID';
	}

	/*************************************************************************
	 * String Manipulation and Comparison Functions
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Reverse a string
	 *
	 * @param {string} pString - The string to reverse
	 * @returns {string}
	 */
	stringReverse (pString)
	{
		// TODO: Benchmark if there are faster ways we want to do this with all the newer JS stuff
		//       ... and if it will work with browserify in a clean way.
		return pString.split('').reverse().join('');
	}

	/**
	 * Test if a string starts with a given substring.
	 *
	 * @param {*} pString
	 * @param {*} pSearchString
	 * @param {*} pStartIndex
	 * @returns {boolean}
	 */
	stringStartsWith (pString, pSearchString, pStartIndex)
	{
		if (this._UseEngineStringStartsWith)
		{
			return pString.startsWith(pSearchString, pStartIndex);
		}
		else
		{
			return this.stringStartsWith_Polyfill.call(pString, pSearchString, pStartIndex);
		}
	}

	/**
	 * Check if a string starts with a given substring.  This is a safe polyfill for the ES6 string.startsWith() function.
	 *
	 * @param {*} pSearchString - The string to search for
	 * @param {*} pStartIndex - The index to start the search at
	 * @returns {boolean}
	 */
	stringStartsWith_Polyfill (pSearchString, pStartIndex)
	{
		return this.slice(pStartIndex || 0, pSearchString.length) === pSearchString;
	}

	/**
	 * Test if a string starts with a given substring.
	 *
	 * @param {*} pString
	 * @param {*} pSearchString
	 * @param {*} pEndIndex
	 * @returns {*}
	 */
	stringEndsWith (pString, pSearchString, pEndIndex)
	{
		if (this._UseEngineStringEndsWith)
		{
			return pString.endsWith(pSearchString, pEndIndex);
		}
		else
		{
			return this.stringEndsWith_Polyfill.call(pString, pSearchString, pEndIndex);
		}
	}

	/**
	 * Check if a string starts with a given substring.  This is a safe polyfill for the ES6 string.startsWith() function.
	 *
	 * @param {*} pSearchString - The string to search for
	 * @param {*} pEndIndex - The index to end the search at
	 * @returns {boolean}
	 */
	stringEndsWith_Polyfill (pSearchString, pEndIndex)
	{
		// This works much better than >= because
		// it compensates for NaN:
		if (!(pEndIndex < this.length))
		{
			pEndIndex = this.length;
		}
		else
		{
			pEndIndex |= 0; // round position
		}
		return this.substr(pEndIndex - pSearchString.length, pSearchString.length) === pSearchString;
	}

	/**
	 * Generate an insecure string hash.  Not meant to be secure, just a quick way to generate a hash for a string.  This is not a cryptographic hash.  Additional warranty and disclaimer ... this is not for passwords!
	 *
	 * @param {string} pString
	 * @returns {string}
	 */
	insecureStringHash (pString)
	{
		let tmpHash = 0;
		let tmpStringLength = pString.length;
		let tmpCharacterIndex = 0;

		while (tmpCharacterIndex < tmpStringLength)
		{
			tmpHash = (tmpHash << 5) - tmpHash + pString.charCodeAt(tmpCharacterIndex++) | 0;
		}

		return `${this._Value_Prefix_StringHash}${tmpHash}`;
	}

	capitalizeEachWord (pString)
	{
		return pString.replace(this._Regex_formatterCapitalizeEachWord,
			(pMatch) =>
			{
				return pMatch.charAt(0).toUpperCase() + pMatch.substr(1);
			});
	}

	/**
	 * @param {string} pString - The string to resolve
	 * @return {string} - The input string with all HTML entities resolved to their character counterparts
	 */
	resolveHtmlEntities(pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		return pString.replace(this._Regex_matcherHTMLEntities, (pMatch, pEntity) =>
		{
			switch (pEntity)
			{
				case 'comma':
					return ',';
				case 'amp':
					return '&';
				case 'lt':
					return '<';
				case 'gt':
					return '>';
				case 'times':
					return '×';
				case 'divide':
					return '÷';
				case 'plus':
					return '+';
				case 'minus':
					return '-';
				case 'infin':
					return '∞';
				case 'ang':
					return '∠';
				case 'quot':
					return '"';
				case 'apos':
					return '\'';
				case 'nbsp':
					return ' ';
				case 'copy':
					return '©';
				case 'reg':
					return '®';
				case 'trade':
					return '™';
				case 'euro':
					return '€';
				default:
					if (!pEntity.startsWith('#'))
					{
						return pMatch;
					}
			}
			const tmpNumericalValue = parseInt(pEntity.substring(1), 10);
			return String.fromCharCode(tmpNumericalValue);
		});
	}

	/**
	 * Concatenate a list of strings together. Non-strings are excluded.
	 *
	 * @param {...string} pStrings - The strings to concatenate
	 * @return {string}
	 */
	concatenateStrings (...pStrings)
	{
		return this.joinStrings('', ...pStrings);
	}

	/**
	 * Concatenate a list of strings together. Non-strings are excluded.
	 *
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	concatenateStringsInternal ()
	{
		const pParams = [ ...arguments ];
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.concatenateStrings(...tmpFlattenedArrays);
	}

	/**
	 * Join a list of strings together. Non-strings are excluded.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...string} pStrings - The strings to join
	 * @return {string}
	 */
	joinStrings (pJoin, ...pStrings)
	{
		return pStrings.filter((v) => typeof v === 'string' || typeof v === 'number').join(pJoin);
	}

	/**
	 * Joins a list of strings together. Non-strings are excluded.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	joinStringsInternal()
	{
		const [ pJoinOn, ...pParams ] = arguments;
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.joinStrings(pJoinOn, ...tmpFlattenedArrays);
	}


	/**
	 * Concatenate a list of values together into a string.
	 *
	 * @param {...any} pValues - The strings to concatenate
	 * @return {string}
	 */
	concatenateStringsRaw (...pValues)
	{
		return this.joinStringsRaw('', ...pValues);
	}

	/**
	 * Concatenate a list of values together into a string.
	 *
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	concatenateStringsRawInternal (pValueObjectSetAddress)
	{
		const pParams = [ ...arguments ];
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.concatenateStringsRaw(...tmpFlattenedArrays);
	}

	/**
	 * Join a list of values together into a string.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...any} pValues - The strings to join
	 * @return {string}
	 */
	joinStringsRaw (pJoin, ...pValues)
	{
		return pValues.map(String).join(pJoin);
	}

	/**
	 * Joins a list of values together into a string.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	joinStringsRawInternal ()
	{
		const [ pJoinOn, ...pParams ] = arguments;
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.joinStringsRaw(pJoinOn, ...tmpFlattenedArrays);
	}

	/**
	 * Clean wrapping characters if they exist consistently around the string.  If they do not, the string is returned unchanged.
	 *
	 * @param {string} pWrapCharacter - The character expected as the wrapping character
	 * @param {string} pString - the string to clean
	 * @returns {string}
	 */
	cleanEnclosureWrapCharacters (pWrapCharacter, pString)
	{
		// # Use case from ManyFest DSL:
		//
		// When a boxed property is passed in, it should have quotes of some
		// kind around it.
		//
		// For instance:
		// 		MyValues['Name']
		// 		MyValues["Age"]
		// 		MyValues[`Cost`]
		//
		// This function is necessary to remove the wrapping quotes before object
		// resolution can occur.
		if (pString.startsWith(pWrapCharacter) && pString.endsWith(pWrapCharacter))
		{
			return pString.substring(1, pString.length - 1);
		}
		else
		{
			return pString;
		}
	}

	/**
	 * Clean a string of any non-alpha characters (including numbers)
	 *
	 * @param {*} pString
	 * @returns
	 */
	cleanNonAlphaCharacters (pString)
	{
		if ((typeof(pString) == 'string') && (pString != ''))
		{
			return pString.replace(this._Regex_formatterCleanNonAlphaChar, this._Value_Clean_formatterCleanNonAlpha);
		}

		return '';
	}

	/**
	 * Clean a string of any characters to create a consistent object key.
	 *
	 * @param {string} pString  The string to clean.
	 * @return {string} the cleaned string, or a placeholder if the input is invalid
	 */
	sanitizeObjectKey(pString)
	{
		if (typeof pString !== 'string' || pString.length < 1)
		{
			return this._SanitizeObjectKeyInvalid;
		}
		return pString.replace(this._SanitizeObjectKeyRegex, this._SanitizeObjectKeyReplacement);
	}


	/*************************************************************************
	 * Number Formatting Functions
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Insert commas every 3 characters from the right.  Used by formatterAddCommasToNumber().
	 *
	 * @param {*} pString
	 * @returns {*}
	 */
	formatterInsertCommas (pString)
	{
		// Reverse, because it's easier to do things from the left, given arbitrary digit counts
		let tmpReversed = this.stringReverse(pString);
		// Add commas every three characters
		let tmpReversedWithCommas = tmpReversed.match(this._Regex_formatterInsertCommas).join(',');
		// Reverse again (back to normal direction)
		return this.stringReverse(tmpReversedWithCommas);
	}

	processAddCommasToNumberRegex(pMatch, pSign, pZeros, pBefore, pDecimal, pAfter)
	{
		// If there was no decimal, the last capture grabs the final digit, so
		// we have to put it back together with the 'before' substring
		return pSign + (pDecimal ? this.formatterInsertCommas(pBefore) + pDecimal + pAfter : this.formatterInsertCommas(pBefore + pAfter));
	}

	/**
	 * Add Commas to a Number for readability.
	 *
	 * @param {*} pNumber
	 * @returns {string}
	 */
	/**
	 * Trim whitespace from both ends of a value (stringified first).
	 * @param {any} pValue
	 * @return {string}
	 */
	stringTrim (pValue)
	{
		return (pValue === undefined || pValue === null) ? '' : pValue.toString().trim();
	}

	/**
	 * Trim trailing whitespace (e.g. SQL CHAR(n) padding).
	 * @param {any} pValue
	 * @return {string}
	 */
	stringTrimEnd (pValue)
	{
		return (pValue === undefined || pValue === null) ? '' : pValue.toString().replace(/\s+$/, '');
	}

	/**
	 * Trim leading whitespace.
	 * @param {any} pValue
	 * @return {string}
	 */
	stringTrimStart (pValue)
	{
		return (pValue === undefined || pValue === null) ? '' : pValue.toString().replace(/^\s+/, '');
	}

	/**
	 * Comma-group a numeric string for human reading, preserving the value
	 * VERBATIM (no float round-trip — arbitrary-precision strings group
	 * intact). Compose with TOFIXED for decimal control. Non-numeric
	 * strings pass through unchanged; missing values return ''.
	 * @param {any} pValue
	 * @return {string}
	 */
	addCommasToValue (pValue)
	{
		return (pValue === undefined || pValue === null) ? '' : this.formatterAddCommasToNumber(pValue.toString());
	}

	formatterAddCommasToNumber (pNumber)
	{
		// If the regex doesn't match, `replace` returns the string unmodified
		return (pNumber.toString()).replace
		(
			this._Regex_formatterAddCommasToNumber,
			this.processAddCommasToNumberRegex.bind(this)
		);
	}

	/**
	 * This will take a number and format it as a dollar string.  It will also add commas to the number.  If the number is not a number, it will return '--'.
	 *
	 * @param {*} pValue
	 * @returns {string}
	 */
	formatterDollars (pValue, pPrecision, pRoundingMethod)
	{
		if (isNaN(pValue))
		{
			return this._Value_NaN_Currency;
		}

		if (pValue === null || pValue === undefined)
		{
			return this._Value_NaN_Currency;
		}

		let tmpDollarAmountArbitrary = this.fable.Math.parsePrecise(pValue);
		let tmpPrecision = (typeof(pPrecision) == 'undefined') ? 2 : pPrecision;
		let tmpDollarAmount = this.fable.Math.toFixedPrecise(tmpDollarAmountArbitrary, tmpPrecision, pRoundingMethod);

		// TODO: Get locale data and use that for this stuff.
		return `$${this.formatterAddCommasToNumber(tmpDollarAmount)}`;
	}

	/**
	 * Round a number to a certain number of digits.  If the number is not a number, it will return 0.  If no digits are specified, it will default to 2 significant digits.
	 *
	 * @param {*} pValue
	 * @param {number} pDigits
	 * @returns {string}
	 */
	formatterRoundNumber (pValue, pDigits)
	{
		let tmpDigits = (typeof(pDigits) == 'undefined') ? 2 : pDigits;

		if (isNaN(pValue))
		{
			let tmpZed = 0;
			return tmpZed.toFixed(tmpDigits);
		}

		if (pValue === null || pValue === undefined)
		{
			return '';
		}

		let tmpAmountArbitrary = this.fable.Utility.bigNumber(pValue);
		let tmpValue = tmpAmountArbitrary.toFixed(tmpDigits);

		if (isNaN(tmpValue))
		{
			let tmpZed = 0;
			return tmpZed.toFixed(tmpDigits);
		}
		else
		{
			return tmpValue;
		}
	}


	/**
	 * Generate a reapeating padding string to be appended before or after depending on
	 * which padding function it uses.
	 *
	 * @param {*} pString
	 * @param {number} pTargetLength
	 * @returns {string} pPadString
	 */
	stringGeneratePaddingString(pString, pTargetLength, pPadString)
	{
		let tmpTargetLength = pTargetLength >> 0;
		let tmpPadString = String((typeof pPadString !== 'undefined' ? pPadString : ' '));
		if (pString.length > pTargetLength)
		{
			// No padding string if the source string is already longer than the target length, return an empty string
			return '';
		}
		else
		{
			let tmpPadLength = pTargetLength - pString.length;
			if (tmpPadLength > tmpPadString.length)
			{
				tmpPadString += tmpPadString.repeat(tmpTargetLength / tmpPadString.length);
			}
			return tmpPadString.slice(0, tmpPadLength);
		}
	}

	/**
	 * Pad the start of a string.
	 *
	 * @param {*} pString
	 * @param {number} pTargetLength
	 * @returns {string} pPadString
	 */
	stringPadStart = function(pString, pTargetLength, pPadString)
	{
		let tmpString = pString.toString();
		return this.stringGeneratePaddingString(tmpString, pTargetLength, pPadString) + tmpString;
	}

	/**
	 * Pad the end of a string.
	 *
	 * @param {*} pString
	 * @param {number} pTargetLength
	 * @returns {string} pPadString
	 */
	stringPadEnd = function(pString, pTargetLength, pPadString)
	{
		let tmpString = pString.toString();
		return tmpString + this.stringGeneratePaddingString(tmpString, pTargetLength, pPadString);
	}

	/*************************************************************************
	 * Time Formatting Functions (milliseconds)
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Format a time length in milliseconds into a human readable string.
	 * @param {number} pTimeSpan
	 * @returns {string} - HH:MM:SS.mmm
	 */
	formatTimeSpan(pTimeSpan)
	{
		if (typeof(pTimeSpan) != 'number')
		{
			return '';
		}

		let tmpMs = parseInt(pTimeSpan%1000);
		let tmpSeconds = parseInt((pTimeSpan/1000)%60);
		let tmpMinutes = parseInt((pTimeSpan/(1000*60))%60);
		let tmpHours = parseInt(pTimeSpan/(1000*60*60));

		return `${this.stringPadStart(tmpHours,2,'0')}:${this.stringPadStart(tmpMinutes,2,'0')}:${this.stringPadStart(tmpSeconds,2,'0')}.${this.stringPadStart(tmpMs,3,'0')}`;
	}

	/**
	 * Format the time delta between two times in milliseconds into a human readable string.
	 *
	 * @param {number} pTimeStart
	 * @param {number} pTimeEnd
	 * @returns {string} - HH:MM:SS.mmm
	 */
	formatTimeDelta(pTimeStart, pTimeEnd)
	{
		if ((typeof(pTimeStart) != 'number') || (typeof(pTimeEnd) != 'number'))
		{
			return '';
		}

		return this.formatTimeSpan(pTimeEnd-pTimeStart);
	}

	// THE FOLLOWING TERRIBLE FUNCTIONS ARE FOR QT / WKHTMLTOPDF when luxon and moment don't work so well
	getMonthFromDate (pJavascriptDate)
	{
		var tmpMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		return tmpMonths[pJavascriptDate.getMonth()];
	}

	getMonthAbbreviatedFromDate (pJavascriptDate)
	{
		var tmpMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		return tmpMonths[pJavascriptDate.getMonth()];
	}

	formatMonthDayYearFromDate (pJavascriptDate, pStrict)
	{
		let tmpStrict = (typeof(pStrict) !== 'undefined') ? pStrict : false;

		let tmpMonth = pJavascriptDate.getMonth() + 1;
		let tmpDay = pJavascriptDate.getDate();
		let tmpYear = pJavascriptDate.getFullYear();

		if (tmpStrict)
		{
			tmpMonth = this.stringPadStart(tmpMonth, 2, '0');
			tmpDay = this.stringPadStart(tmpDay, 2, '0');
			tmpYear = this.stringPadStart(tmpYear, 4, '0');
		}

		return `${tmpMonth}/${tmpDay}/${tmpYear}`;
	}

	formatSortableStringFromDate (pDate)
	{
		return pDate.getFullYear()+this.stringPadStart(pDate.getMonth(),2,'0')+this.stringPadStart(pDate.getDate(),2,'0');
	}

	/*************************************************************************
	 * String Tokenization Functions
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Return the string before the matched substring.
	 *
	 * If the substring is not found, the entire string is returned.  This only deals with the *first* match.
	 *
	 * @param {string} pString
	 * @param {string} pMatch
	 * @returns {string}
	 */
	stringBeforeMatch (pString, pMatch)
	{
		return pString.split(pMatch)[0];
	}

	/**
	 * Return the string after the matched substring.
	 *
	 * If the substring is not found, an empty string is returned.  This only deals with the *first* match.
	 *
	 * @param {string} pString
	 * @param {string} pMatch
	 * @returns {string}
	 */
	stringAfterMatch (pString, pMatch)
	{
		let tmpStringSplitLocation = pString.indexOf(pMatch);

		if ((tmpStringSplitLocation < 0) || ((tmpStringSplitLocation + pMatch.length) >= pString.length))
		{
			return '';
		}

		return pString.substring(tmpStringSplitLocation + pMatch.length);
	}

	/**
	 * Count the number of segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} pSeparator
	 * @param {object} pEnclosureStartSymbolMap
	 * @param {object} pEnclosureEndSymbolMap
	 * @returns the count of segments in the string as a number
	 */
	stringCountSegments(pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : { '{': 0, '[': 1, '(': 2 };
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : { '}': 0, ']': 1, ')': 2 };

		if (pString.length < 1)
		{
			return 0;
		}

		let tmpSegmentCount = 1;
		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Increment the segment count
				tmpSegmentCount++;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpSegmentCount;
	}

	/**
	 * Get all segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} pSeparator
	 * @param {object} pEnclosureStartSymbolMap
	 * @param {object} pEnclosureEndSymbolMap
	 * @returns the first segment in the string as a string
	 */
	stringGetSegments(pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		// An empty-string enclosure argument disables enclosure handling
		// entirely (plain split) — expressions cannot pass object literals.
		if (pEnclosureStartSymbolMap === '')
		{
			pEnclosureStartSymbolMap = {};
			pEnclosureEndSymbolMap = {};
		}
		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : { '{': 0, '[': 1, '(': 2, '"':3, "'":4 };
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : { '}': 0, ']': 1, ')': 2, '"':3, "'":4 };

		let tmpCurrentSegmentStart = 0;
		let tmpSegmentList = [];

		if (pString.length < 1)
		{
			return tmpSegmentList;
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart, i));
				tmpCurrentSegmentStart = i+1;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		if (tmpCurrentSegmentStart < tmpString.length)
		{
			tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart));
		}

		return tmpSegmentList;
	}

	/**
	 * Get the first segment in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} pSeparator
	 * @param {object} pEnclosureStartSymbolMap
	 * @param {object} pEnclosureEndSymbolMap
	 * @returns the first segment in the string as a string
	 */
	stringGetFirstSegment(pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : { '{': 0, '[': 1, '(': 2 };
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : { '}': 0, ']': 1, ')': 2 };

		if (pString.length < 1)
		{
			return 0;
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				return tmpString.substring(0, i);
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpString;
	}

	/**
	 * Encodes a string using encodeURIComponent, returning the encoded string.
	 * If the input is not a string, returns the input unchanged.
	 *
	 * @param {string} pString - The string to encode.
	 * @returns {string|*} The encoded string, or the original input if it is not a string.
	 */
	stringEncodeURIComponent (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		return encodeURIComponent(pString);
	}

	/**
	 * Safely decodes a URI component string using decodeURIComponent.
	 * If the input is not a string or decoding fails, returns the original input.
	 *
	 * @param {string} pString - The string to decode.
	 * @returns {string} The decoded string, or the original input if decoding fails.
	 */
	stringDecodeURIComponent (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		try
		{
			return decodeURIComponent(pString);
		}
		catch (e)
		{
			this.fable.Log.error(`Failed to decode URI component: ${pString}`, e);
			return pString; // Return the original string if decoding fails
		}
	}

	/**
	 * Encodes a string so that it can be safely embedded in JavaScript code.
	 * Escapes special characters such as quotes, backslashes, and newlines.
	 *
	 * @param {string} pString - The input string to encode.
	 * @returns {string} The encoded string with special characters escaped.
	 */
	stringEncodeForJavascript (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		//FIXME: missing regexp
		return pString.replace(this._Regex_matcherJavascriptEncode, (pMatch) =>
		{
			switch (pMatch)
			{
				case '"':
					return '\\"';
				case '\'':
					return '\\\'';
				case '\\':
					return '\\\\';
				case '\n':
					return '\\n';
				case '\r':
					return '\\r';
				default:
					return pMatch; // Return the original character if no encoding is needed
			}
		});
	}

	/**
	 * Decodes a JavaScript-escaped string by replacing common escape sequences
	 * (such as \" \\n \\r \\' and \\\\) with their actual character representations.
	 *
	 * @param {string} pString - The string to decode. If not a string, the input is returned as-is.
	 * @returns {string} The decoded string with escape sequences replaced, or the original input if not a string.
	 */
	stringDecodeForJavascript (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		return pString.replace(this._Regex_matcherJavascriptDecode, (pMatch) =>
		{
			switch (pMatch)
			{
				case '\\"':
					return '"';
				case '\\\'':
					return '\'';
				case '\\\\':
					return '\\';
				case '\\n':
					return '\n';
				case '\\r':
					return '\r';
				default:
					return pMatch; // Return the original character if no decoding is needed
			}
		});
	}

	/**
	 * Count the number of enclosures in a string based on the start and end characters.
	 *
	 * If no start or end characters are specified, it will default to parentheses.  If the string is not a string, it will return 0.
	 *
	 * @param {string} pString
	 * @param {string} pEnclosureStart
	 * @param {string} pEnclosureEnd
	 * @returns the count of full in the string
	 */
	stringCountEnclosures (pString, pEnclosureStart, pEnclosureEnd)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;
		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				if (tmpEnclosureDepth == 0)
				{
					tmpEnclosureCount++;
				}
				tmpEnclosureDepth++;
			}
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;
			}
		}

		return tmpEnclosureCount;
	}


	/**
	 * Get the value of the enclosure at the specified index.
	 *
	 * If the index is not a number, it will default to 0.  If the string is not a string, it will return an empty string.  If the enclosure is not found, it will return an empty string.  If the enclosure
	 *
	 * @param {string} pString
	 * @param {number} pEnclosureIndexToGet
	 * @param {string} pEnclosureStart
	 * @param {string}} pEnclosureEnd
	 * @returns {string}
	 */
	stringGetEnclosureValueByIndex (pString, pEnclosureIndexToGet, pEnclosureStart, pEnclosureEnd)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureIndexToGet = (typeof(pEnclosureIndexToGet) == 'number') ? pEnclosureIndexToGet : 0;
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;

		let tmpMatchedEnclosureIndex = false;
		let tmpEnclosedValueStartIndex = 0;
		let tmpEnclosedValueEndIndex = 0;

		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				tmpEnclosureDepth++;

				// Only count enclosures at depth 1, but still this parses both pairs of all of them.
				if (tmpEnclosureDepth == 1)
				{
					tmpEnclosureCount++;
					if (tmpEnclosureIndexToGet == (tmpEnclosureCount - 1))
					{
						// This is the start of *the* enclosure
						tmpMatchedEnclosureIndex = true;
						tmpEnclosedValueStartIndex = i;
					}
				}
			}
			// This is the end of an enclosure
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;

				// Again, only count enclosures at depth 1, but still this parses both pairs of all of them.
				if ((tmpEnclosureDepth == 0) &&
					tmpMatchedEnclosureIndex &&
					(tmpEnclosedValueEndIndex <= tmpEnclosedValueStartIndex))
				{
					tmpEnclosedValueEndIndex = i;
					tmpMatchedEnclosureIndex = false;
				}
			}
		}

		if (tmpEnclosureCount <= tmpEnclosureIndexToGet)
		{
			// Return an empty string if the enclosure is not found
			return '';
		}

		if ((tmpEnclosedValueEndIndex > 0) && (tmpEnclosedValueEndIndex > tmpEnclosedValueStartIndex))
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1, tmpEnclosedValueEndIndex);
		}
		else
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1);
		}
	}


	/**
	 * Remove an enclosure from a string based on the index of the enclosure.
	 *
	 * @param {string} pString
	 * @param {number} pEnclosureIndexToRemove
	 * @param {number} pEnclosureStart
	 * @param {number} pEnclosureEnd
	 * @returns {string}
	 */
	stringRemoveEnclosureByIndex (pString, pEnclosureIndexToRemove, pEnclosureStart, pEnclosureEnd)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureIndexToRemove = (typeof(pEnclosureIndexToRemove) == 'number') ? pEnclosureIndexToRemove : 0;
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;

		let tmpMatchedEnclosureIndex = false;
		let tmpEnclosureStartIndex = 0;
		let tmpEnclosureEndIndex = 0;

		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				tmpEnclosureDepth++;

				if (tmpEnclosureDepth == 1)
				{
					tmpEnclosureCount++;
					if (tmpEnclosureIndexToRemove == (tmpEnclosureCount - 1))
					{
						tmpMatchedEnclosureIndex = true;
						tmpEnclosureStartIndex = i;
					}
				}
			}
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;

				if ((tmpEnclosureDepth == 0) &&
					tmpMatchedEnclosureIndex &&
					(tmpEnclosureEndIndex <= tmpEnclosureStartIndex))
				{
					tmpEnclosureEndIndex = i;
					tmpMatchedEnclosureIndex = false;
				}
			}
		}

		if (tmpEnclosureCount <= tmpEnclosureIndexToRemove)
		{
			return tmpString;
		}

		let tmpReturnString = '';

		if (tmpEnclosureStartIndex > 1)
		{
			tmpReturnString = tmpString.substring(0, tmpEnclosureStartIndex);
		}

		if ((tmpString.length > (tmpEnclosureEndIndex + 1)) && (tmpEnclosureEndIndex > tmpEnclosureStartIndex))
		{
			tmpReturnString += tmpString.substring(tmpEnclosureEndIndex+1);
		}

		return tmpReturnString;
	}
}

module.exports = DataFormat;

},{"fable-serviceproviderbase":59}],75:[function(require,module,exports){
module.exports={
	"DefaultIntegerMinimum": 0,
	"DefaultIntegerMaximum": 9999999,

	"DefaultNumericStringLength": 10,

	"MonthSet": ["January","February","March","April","May","June","July","August","September","October","November","December"],

	"WeekDaySet":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],

	"ColorSet": 
		[
			"Red", "Orange", "Yellow", "Green", "Blue", "Indigo", "Violet", "Pink", "Purple", "Turquoise", "Gold",
			"Lime", "Maroon", "Navy", "Coral", "Teal", "Brown", "White", "Black", "Sky", "Berry",
			"Grey", "Straw", "Silver", "Sapphire"
		],

	"SurNameSet":
		[
			"Smith", "Johnson", "Williams", "Brown", "Jones", "Miller", "Davis", "Garcia", "Rodriguez", "Wilson",
			"Martinez", "Anderson", "Taylor", "Thomas", "Hernandez", "Moore", "Martin", "Jackson", "Thompson", "White",
			"Lopez", "Lee", "Gonzalez", "Harris", "Clark", "Lewis", "Robinson", "Walker", "Perez", "Hall",
			"Young", "Allen", "Sanchez", "Wright", "King", "Scott", "Green", "Baker", "Adams", "Nelson",
			"Hill", "Ramirez", "Campbell", "Mitchell", "Roberts", "Carter", "Phillips", "Evans", "Turner", "Torres",
			"Parker", "Collins", "Edwards", "Stewart", "Flores", "Morris", "Nguyen", "Murphy", "Rivera", "Cook",
			"Rogers", "Morgan", "Peterson", "Cooper", "Reed", "Bailey", "Bell", "Gomez", "Kelly", "Howard",
			"Ward", "Cox", "Diaz", "Richardson", "Wood", "Watson", "Brooks", "Bennett", "Gray", "James",
			"Reyes", "Cruz", "Hughes", "Price", "Myers", "Long", "Foster", "Sanders", "Ross", "Morales",
			"Powell", "Sullivan", "Russell", "Ortiz", "Jenkins", "Gutierrez", "Perry", "Butler", "Barnes", "Fisher"
		],

	"NameSet":
		[
			"Mary", "Patricia", "Jennifer", "Linda", "Elizabeth", "Barbara", "Susan", "Jessica", "Sarah", "Karen",
			"Lisa", "Nancy", "Betty", "Sandra", "Margaret", "Ashley", "Kimberly", "Emily", "Donna", "Michelle",
			"Carol", "Amanda", "Melissa", "Deborah", "Stephanie", "Dorothy", "Rebecca", "Sharon", "Laura", "Cynthia",
			"Amy", "Kathleen", "Angela", "Shirley", "Brenda", "Emma", "Anna", "Pamela", "Nicole", "Samantha",
			"Katherine", "Christine", "Helen", "Debra", "Rachel", "Carolyn", "Janet", "Maria", "Catherine", "Heather",
			"Diane", "Olivia", "Julie", "Joyce", "Victoria", "Ruth", "Virginia", "Lauren", "Kelly", "Christina",
			"Joan", "Evelyn", "Judith", "Andrea", "Hannah", "Megan", "Cheryl", "Jacqueline", "Martha", "Madison",
			"Teresa", "Gloria", "Sara", "Janice", "Ann", "Kathryn", "Abigail", "Sophia", "Frances", "Jean",
			"Alice", "Judy", "Isabella", "Julia", "Grace", "Amber", "Denise", "Danielle", "Marilyn", "Beverly",
			"Charlotte", "Natalie", "Theresa", "Diana", "Brittany", "Doris", "Kayla", "Alexis", "Lori", "Marie",
			"James", "Robert", "John", "Michael", "David", "William", "Richard", "Joseph", "Thomas", "Christopher",
			"Charles", "Daniel", "Matthew", "Anthony", "Mark", "Donald", "Steven", "Andrew", "Paul", "Joshua",
			"Kenneth", "Kevin", "Brian", "George", "Timothy", "Ronald", "Jason", "Edward", "Jeffrey", "Ryan",
			"Jacob", "Gary", "Nicholas", "Eric", "Jonathan", "Stephen", "Larry", "Justin", "Scott", "Brandon",
			"Benjamin", "Samuel", "Gregory", "Alexander", "Patrick", "Frank", "Raymond", "Jack", "Dennis", "Jerry",
			"Tyler", "Aaron", "Jose", "Adam", "Nathan", "Henry", "Zachary", "Douglas", "Peter", "Kyle",
			"Noah", "Ethan", "Jeremy", "Walter", "Christian", "Keith", "Roger", "Terry", "Austin", "Sean",
			"Gerald", "Carl", "Harold", "Dylan", "Arthur", "Lawrence", "Jordan", "Jesse", "Bryan", "Billy",
			"Bruce", "Gabriel", "Joe", "Logan", "Alan", "Juan", "Albert", "Willie", "Elijah", "Wayne",
			"Randy", "Vincent", "Mason", "Roy", "Ralph", "Bobby", "Russell", "Bradley", "Philip", "Eugene"
		]
}
},{}],76:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

/**
 * FableServiceDataGeneration class provides various methods for generating random data.
 *
 * @extends libFableServiceBase
 */
class FableServiceDataGeneration extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'DataGeneration';

		this.defaultData = require('./Fable-Service-DataGeneration-DefaultValues.json');
	}

	/**
	 * Generates a random integer between the specified minimum and maximum values.
	 *
	 * @param {number} pMinimum - The minimum value (inclusive).
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random integer between pMinimum and pMaximum.
	 */
	randomIntegerBetween(pMinimum, pMaximum)
	{
		try
		{
			let tmpMinimum = parseInt(pMinimum, 10);
			let tmpMaximum = parseInt(pMaximum, 10);
			return Math.floor(Math.random() * (tmpMaximum - tmpMinimum)) + tmpMinimum;
		}
		catch (pError)
		{
			this.fable.log.error('Error in randomIntegerBetween', pError, { 'Minimum': pMinimum, 'Maximum': pMaximum });
			return NaN;
		}
	}

	/**
	 * Generates a random integer between 0 (inclusive) and the specified maximum value (exclusive).
	 *
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random integer between 0 and pMaximum.
	 */
	randomIntegerUpTo(pMaximum)
	{
		return this.randomIntegerBetween(0, pMaximum);
	}

	/**
	 * Generates a random integer between 0 (inclusive) and the default maximum value.
	 *
	 * @returns {number} A random integer between 0 and the default maximum value.
	 */
	randomInteger()
	{
		return Math.floor(Math.random() * this.defaultData.DefaultIntegerMaximum);
	}

	/**
	 * Generates a random float between the specified minimum and maximum values.
	 *
	 * @param {number} pMinimum - The minimum value (inclusive).
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random float between pMinimum and pMaximum.
	 */
	randomFloatBetween(pMinimum, pMaximum)
	{
		try
		{
			let tmpMinimum = parseFloat(pMinimum);
			let tmpMaximum = parseFloat(pMaximum);
			return this.fable.Math.addPrecise(this.fable.Math.multiplyPrecise(Math.random(), this.fable.Math.subtractPrecise(tmpMaximum, tmpMinimum)), tmpMinimum);
		}
		catch (pError)
		{
			this.fable.log.error('Error in randomFloatBetween', pError, { 'Minimum': pMinimum, 'Maximum': pMaximum });
			return NaN;
		}
	}

	/**
	 * Generates a random float between 0 (inclusive) and the specified maximum value (exclusive).
	 *
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random float between 0 and pMaximum.
	 */
	randomFloatUpTo(pMaximum)
	{
		return this.randomFloatBetween(0, pMaximum);
	}

	/**
	 * Generates a random float between 0 (inclusive) and 1 (exclusive).
	 *
	 * @returns {number} A random float between 0 and 1.
	 */
	randomFloat()
	{
		return Math.random();
	}

	/**
	 * Generates a random numeric string of the specified length.
	 *
	 * @param {number} pLength - The length of the numeric string.
	 * @param {number} pMaxNumber - The maximum number to generate.
	 * @returns {string} A random numeric string of the specified length.
	 */
	randomNumericString(pLength, pMaxNumber)
	{
		let tmpLength = (typeof(pLength) === 'undefined') ? 10 : pLength;
		let tmpMaxNumber = (typeof(pMaxNumber) === 'undefined') ? 9999999999 : pMaxNumber;

		return this.services.DataFormat.stringPadStart(this.randomIntegerUpTo(tmpMaxNumber), pLength, '0');
	}

	/**
	 * Generates a random month from the default month set.
	 *
	 * @returns {string} A random month.
	 */
	randomMonth()
	{
		return this.defaultData.MonthSet[this.randomIntegerUpTo(this.defaultData.MonthSet.length - 1)];
	}

	/**
	 * Generates a random day of the week from the default week day set.
	 *
	 * @returns {string} A random day of the week.
	 */
	randomDayOfWeek()
	{
		return this.defaultData.WeekDaySet[this.randomIntegerUpTo(this.defaultData.WeekDaySet.length - 1)];
	}

	/**
	 * Generates a random color from the default color set.
	 *
	 * @returns {string} A random color.
	 */
	randomColor()
	{
		return this.defaultData.ColorSet[this.randomIntegerUpTo(this.defaultData.ColorSet.length - 1)];
	}

	/**
	 * Generates a random name from the default name set.
	 *
	 * @returns {string} A random name.
	 */
	randomName()
	{
		return this.defaultData.NameSet[this.randomIntegerUpTo(this.defaultData.NameSet.length - 1)];
	}

	/**
	 * Generates a random surname from the default surname set.
	 *
	 * @returns {string} A random surname.
	 */
	randomSurname()
	{
		return this.defaultData.SurNameSet[this.randomIntegerUpTo(this.defaultData.SurNameSet.length - 1)];
	}
}

module.exports = FableServiceDataGeneration;

},{"./Fable-Service-DataGeneration-DefaultValues.json":75,"fable-serviceproviderbase":59}],77:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
/**
* Date management a la Moment using days.js
*
* @class DateManipulation
*/
class DateManipulation extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash)

		this.serviceType = 'Dates';

		this.dayJS = require('dayjs');

		// Include the `weekOfYear` plugin
		this.plugin_weekOfYear = require('dayjs/plugin/weekOfYear');
		this.dayJS.extend(this.plugin_weekOfYear);
		// Include the `weekday` plugin
		this.plugin_weekday = require('dayjs/plugin/weekday');
		this.dayJS.extend(this.plugin_weekday);
		// Include the `isoWeek` plugin
		this.plugin_isoWeek = require('dayjs/plugin/isoWeek');
		this.dayJS.extend(this.plugin_isoWeek);
		// Include the `timezone` plugin
		this.plugin_timezone = require('dayjs/plugin/timezone');
		this.dayJS.extend(this.plugin_timezone);
		// Include the `relativetime` plugin
		this.plugin_relativetime = require('dayjs/plugin/relativeTime');
		this.dayJS.extend(this.plugin_relativetime);
		// Include the `utc` plugin
		this.plugin_utc = require('dayjs/plugin/utc');
		this.dayJS.extend(this.plugin_utc);
		// Include the `advancedFormat` plugin
		this.plugin_advancedFormat = require('dayjs/plugin/advancedFormat');
		this.dayJS.extend(this.plugin_advancedFormat);

		// A developer can include locales if they want
		// You would do the following:
		// const localeDE = require('dayjs/locale/de');
		// _Fable.Dates.dayJS.locale('de');
	}

	/**
	 * Calculates the difference in milliseconds between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in milliseconds between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateMillisecondDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'millisecond');
	}

	/**
	 * Calculates the difference in seconds between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in seconds between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateSecondDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'second');
	}

	/**
	 * Calculates the difference in minutes between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in minutes between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateMinuteDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'minute');
	}

	/**
	 * Calculates the difference in hours between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in hours between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateHourDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'hour');
	}

	/**
	 * Calculates the difference in days between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in days between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateDayDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'day');
	}

	/**
	 * Calculates the difference in weeks between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in weeks between the two dates. Returns NaN if the start date is invalid.
	 */
	dateWeekDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'week');
	}

	/**
	 * Calculates the difference in months between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in months between the two dates. Returns NaN if the start date is invalid.
	 */
	dateMonthDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'month');
	}

	/**
	 * Calculates the difference in years between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in years between the two dates. Returns NaN if the start date is invalid.
	 */
	dateYearDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'year');
	}

	dateAddMilliseconds(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'millisecond', 'add');
	}

	dateAddSeconds(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'second', 'add');
	}

	dateAddMinutes(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'minute', 'add');
	}

	dateAddHours(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'hour', 'add');
	}

	dateAddDays(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'day', 'add');
	}

	dateAddWeeks(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'week', 'add');
	}

	dateAddMonths(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'month', 'add');
	}

	dateAddYears(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'year', 'add');
	}

	dateMath(pDate, pAmount, pUnit, pOperation)
	{
		try
		{
			let tmpDate = this.dayJS.utc(pDate);

			if (pOperation === 'add')
			{
				tmpDate = tmpDate.add(pAmount, pUnit);
			}
			else if (pOperation === 'subtract')
			{
				tmpDate = tmpDate.subtract(pAmount, pUnit);
			}
			return this.dayJS.utc(tmpDate).toISOString();
		}
		catch (pError)
		{
			return undefined;
		}
	}

	/**
	 * Format a date value with dayjs format tokens, rendered in a timezone.
	 *
	 * Timezone resolution: the explicit parameter wins; otherwise the
	 * dayjs default set via `dayJS.tz.setDefault(...)` (the host
	 * application's configured timezone — e.g. pict apps set this to the
	 * document's project timezone); otherwise the host's local zone.
	 *
	 * @param {string|number|Date} pDateValue - ISO string, epoch millis, or Date
	 * @param {string} pFormat - dayjs format tokens (e.g. 'YYYY-MM-DD h:mm A')
	 * @param {string} [pTimezone] - optional IANA zone override (e.g. 'America/Chicago')
	 * @return {string|undefined} the formatted string, or undefined on an unparseable value
	 */
	formatDate(pDateValue, pFormat, pTimezone)
	{
		try
		{
			let tmpDate = this.dayJS(pDateValue);
			if (!tmpDate.isValid())
			{
				return undefined;
			}
			let tmpFormat = (typeof (pFormat) === 'string' && pFormat.length > 0) ? pFormat : 'YYYY-MM-DD HH:mm:ss';
			tmpDate = (typeof (pTimezone) === 'string' && pTimezone.length > 0) ? tmpDate.tz(pTimezone) : tmpDate.tz();
			return tmpDate.format(tmpFormat);
		}
		catch (pError)
		{
			return undefined;
		}
	}

	dateFromParts(pYear, pMonth, pDay, pHour = 0, pMinute = 0, pSecond = 0, pMillisecond = 0)
	{
		try
		{
			let tmpDate = this.dayJS.utc().year(pYear).month(pMonth - 1).date(pDay).hour(pHour).minute(pMinute).second(pSecond).millisecond(pMillisecond);
			return tmpDate.toISOString();
		}
		catch (pError)
		{
			return undefined;
		}
	}
}

module.exports = DateManipulation;

},{"dayjs":32,"dayjs/plugin/advancedFormat":33,"dayjs/plugin/isoWeek":34,"dayjs/plugin/relativeTime":35,"dayjs/plugin/timezone":36,"dayjs/plugin/utc":37,"dayjs/plugin/weekOfYear":38,"dayjs/plugin/weekday":39,"fable-serviceproviderbase":59}],78:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceEnvironmentData extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'EnvironmentData';

		this.Environment = `node.js`;
	}
}

module.exports = FableServiceEnvironmentData;

},{"fable-serviceproviderbase":59}],79:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

/* Trying a different pattern for this service ...
 *
 * This service is a simple expression parser that can handle math expressions, with magic(tm) lookup of addresses with a manifest.
 *
 * Each method works multiple ways.
 *
 * 1. You can pass in a results object, and, it will put the state for that step outcome into the results object.
 * 2. It always returns the state, and works without the results object.
 *
 *
 * Learned a lot from this npm package: https://www.npmjs.com/package/math-expression-evaluator
 * And its related code at github: https://github.com/bugwheels94/math-expression-evaluator
 *
 * There were two problems with the codebase above...
 *
 * First, the code was very unreadable and determining it was correct or extending it
 * was out of the question.
 *
 * Second, and this is a larger issue, is that we need the expressions to be parsed as
 * arbitrary precision.  When I determined that extending the library to use string-based
 * numbers and an arbitrary precision library as the back-end would have taken a significantly
 * longer amount of time than just writing the parser from scratch... et voila.
 */

class FableServiceExpressionParser extends libFableServiceBase
{
	/**
	 * Constructs a new instance of the ExpressionParser service.
	 * @param {Object} pFable - The Fable object.
	 * @param {Object} pOptions - The options for the service.
	 * @param {string} pServiceHash - The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../Fable.js') & { Math: import('./Fable-Service-Math.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		// The configuration for tokens that the solver recognizes, with precedence and friendly names.
		// Clone the JSON so each instance gets its own tokenMap (require() caches and returns the same object reference).
		this.tokenMap = JSON.parse(JSON.stringify(require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-TokenMap.json')));

		// Keep track of maximum token precedence
		this.tokenMaxPrecedence = 4;
		// This isn't exactly a radix tree but close enough.  It's a map of the first character of the token to the token.
		this.tokenRadix = {};
		let tmpTokenKeys = Object.keys(this.tokenMap);
		for (let i = 0; i < tmpTokenKeys.length; i++)
		{
			let tmpTokenKey = tmpTokenKeys[i];
			let tmpToken = this.tokenMap[tmpTokenKey];

			tmpToken.Token = tmpTokenKey;
			tmpToken.Length = tmpTokenKey.length;

			let tmpTokenStartCharacter = tmpToken.Token[0];
			if (!(tmpTokenStartCharacter in this.tokenRadix))
			{
				// With a token count of 1 and a literal of true, we can assume it being in the radix is the token.
				this.tokenRadix[tmpTokenStartCharacter] = (
					{
						TokenCount: 0,
						Literal: false,
						TokenKeys: [],
						TokenMap: {}
					});
			}

			this.tokenRadix[tmpTokenStartCharacter].TokenCount++;
			if (tmpTokenKey == tmpTokenStartCharacter)
			{
				this.tokenRadix[tmpTokenStartCharacter].Literal = true;
			}
			this.tokenRadix[tmpTokenStartCharacter].TokenMap[tmpToken.Token] = tmpToken;
			this.tokenRadix[tmpTokenStartCharacter].TokenKeys.push(tmpTokenKey);
			this.tokenRadix[tmpTokenStartCharacter].TokenKeys.sort((pLeft, pRight) => pRight.length - pLeft.length);

			if (this.tokenMaxPrecedence < tmpToken.Precedence)
			{
				this.tokenMaxPrecedence = tmpToken.Precedence;
			}
		}

		// The configuration for which functions are available to the solver.
		// Clone the JSON so each instance gets its own functionMap (require() caches and returns the same object reference).
		this.functionMap = JSON.parse(JSON.stringify(require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-FunctionMap.json')));

		this.serviceType = 'ExpressionParser';

		// These are sub-services for the tokenizer, linter, compiler, marshaler and solver.
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Tokenizer', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-TokenizerDirectiveMutation', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer-DirectiveMutation.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Linter', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Linter.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Postfix', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Postfix.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-ValueMarshal', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ValueMarshal.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Solver', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-SolvePostfixedExpression.js'));
		// And the sub-service for the friendly user messaging
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Messaging', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Messaging.js'));


		// This code instantitates these fable services to child objects of this service, but does not pollute the main fable with them.
		this.Tokenizer = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Tokenizer');
		this.Tokenizer.TokenizerDirectiveMutation = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-TokenizerDirectiveMutation');
		this.Linter = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Linter');
		this.Postfix = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Postfix');
		this.ValueMarshal = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-ValueMarshal');
		this.Solver = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Solver');
		this.Messaging = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Messaging');

		// Wire each sub service into this instance of the solver.
		this.Tokenizer.connectExpressionParser(this);
		this.Tokenizer.TokenizerDirectiveMutation.connectExpressionParser(this);
		this.Linter.connectExpressionParser(this);
		this.Postfix.connectExpressionParser(this);
		this.ValueMarshal.connectExpressionParser(this);
		this.Solver.connectExpressionParser(this);
		this.Messaging.connectExpressionParser(this);

		this.GenericManifest = this.fable.newManyfest();

		// This will look for a LogNoisiness on fable (or one that falls in from pict) and if it doesn't exist, set one for this service.
		this.LogNoisiness = ('LogNoisiness' in this.fable) ? this.fable.LogNoisiness : 0;
	}

	/**
	 * Tokenizes the given mathematical expression string.
	 *
	 * @param {string} pExpression - The expression to tokenize.
	 * @param {object} pResultObject - The result object to store the tokenized expression.
	 * @returns {object} - The tokenized expression.
	 */
	tokenize(pExpression, pResultObject)
	{
		return this.Tokenizer.tokenize(pExpression, pResultObject);
	}

	/**
	 * Recompose an expression string from an array of token strings.
	 *
	 * @param {Array<string>} pTokens - The array of token strings to recompose.
	 * @returns {string} - The recomposed expression string.
	 */
	recompose(pTokens)
	{
		return this.Tokenizer.recompose(pTokens);
	}

	/**
	 * Lints a tokenized expression.
	 *
	 * @param {Array} pTokenizedExpression - The tokenized expression to lint.
	 * @param {Object} pResultObject - The result object where we store the linting result.
	 * @returns {Object} - The linting result object.
	 */
	lintTokenizedExpression(pTokenizedExpression, pResultObject)
	{
		return this.Linter.lintTokenizedExpression(pTokenizedExpression, pResultObject);
	}

	/**
	 * Builds a postfix solve list for the given tokenized expression and result object.
	 *
	 * @param {Array} pTokenizedExpression - The tokenized expression.
	 * @param {Object} pResultObject - The result object where the algorithm "shows its work".
	 * @returns {Array} The postfix solve list.
	 */
	buildPostfixedSolveList(pTokenizedExpression, pResultObject)
	{
		return this.Postfix.buildPostfixedSolveList(pTokenizedExpression, pResultObject);
	}

	/**
	 * Substitutes values in tokenized objects.
	 *
	 * This means marshaling data from pDataSource into the array of objects with the passed in Manifest (or a generic manifest) to prepare for solving.
	 *
	 * @param {Array} pTokenizedObjects - The array of tokenized objects.
	 * @param {Object} pDataSource - The data source object.
	 * @param {Object} pResultObject - The result object.
	 * @param {Object} pManifest - The manifest object.
	 * @returns {Object} - The updated result object.
	 */
	substituteValuesInTokenizedObjects(pTokenizedObjects, pDataSource, pResultObject, pManifest)
	{
		return this.ValueMarshal.substituteValuesInTokenizedObjects(pTokenizedObjects, pDataSource, pResultObject, pManifest);
	}

	/**
	 * Solves a postfixed expression Array.
	 *
	 * @param {Array} pPostfixedExpression - The postfixed expression to solve.
	 * @param {object} pDataDestinationObject - The data destination object where data gets marshaled to after solving.
	 * @param {object} pResultObject - The result object where the algorithm "shows its work".
	 * @param {object} pManifest - The manifest object.
	 * @returns {any} The result of the solved expression.
	 */
	solvePostfixedExpression(pPostfixedExpression, pDataDestinationObject, pResultObject, pManifest)
	{
		return this.Solver.solvePostfixedExpression(pPostfixedExpression, pDataDestinationObject, pResultObject, pManifest);
	}

	/**
	 * Add a function to the solver.
	 *
	 * @param {string} pFunctionName
	 * @param {string} pFunctionAddress
	 * @param {string} pFunctionComment
	 * @param {Array<number>} [pAddressParameterIndices] - Optional array of parameter indices that contain addresses/hashes.
	 */
	addSolverFunction(pFunctionName, pFunctionAddress, pFunctionComment, pAddressParameterIndices)
	{
		let tmpFunctionName = (pFunctionName || '').trim().toLowerCase();
		if (this.functionMap.hasOwnProperty(tmpFunctionName))
		{
			this.log.warn(`PictDynamicFormsInformary: Function ${tmpFunctionName} already exists in the solver, overwriting with address [${pFunctionAddress}].`);
			//return false;
		}
		let tmpFunctionEntry = (
		{
			Name: pFunctionComment || `Autogenerated function ${tmpFunctionName}`,
			Address: pFunctionAddress,
		});
		if (Array.isArray(pAddressParameterIndices) && pAddressParameterIndices.length > 0)
		{
			tmpFunctionEntry.AddressParameterIndices = pAddressParameterIndices;
		}
		this.functionMap[tmpFunctionName] = tmpFunctionEntry;
	}

	/**
	 * Prepares the parameters for a SERIES directive by substituting values and applying defaults.
	 *
	 * @param {Array} pParameters
	 * @param {Array} pDefaults
	 * @param {Object} pResultObject
	 * @param {Object} pDataSourceObject
	 * @param {import('manyfest')} [pManifest]
	 */
	_prepareDirectiveParameters(pParameters, pDefaults, pResultObject, pDataSourceObject, pManifest)
	{
		const tmpResults = [];
		for (let i = 0; i < pParameters.length; i++)
		{
			const tmpParameter = pParameters[i];
			let tmpValue = this.fable.Math.parsePrecise(tmpParameter, NaN);
			if (isNaN(tmpValue) && typeof tmpParameter === 'string' && tmpParameter.length > 0)
			{
				const tmpToken = this.fable.ExpressionParser.Postfix.getTokenContainerObject(tmpParameter, 'Token.Symbol');
				this.substituteValuesInTokenizedObjects([tmpToken], pDataSourceObject, pResultObject, pManifest);
				if (tmpToken.Resolved)
				{
					tmpValue = tmpToken.Value;
				}
			}
			if (isNaN(tmpValue) && pDefaults.length > i)
			{
				tmpValue = pDefaults[i];
			}
			tmpResults.push(tmpValue);
		}
		return tmpResults;
	}

	/**
	 * Solves the given expression using the provided data and manifest.
	 *
	 * @param {string} pExpression - The expression to solve.
	 * @param {Record<string, any>} [pDataSourceObject] - (optional) The data source object (e.g. AppData).
	 * @param {Record<string, any>} [pResultObject] - (optional) The result object containing the full postfix expression list, internal variables and solver history.
	 * @param {import('manyfest')} [pManifest] - (optional) The manifest object for dereferencing variables.
	 * @param {Record<string, any>} [pDataDestinationObject] - (optional) The data destination object for where to marshal the result into.
	 * @returns {any} - The result of solving the expression.
	 */
	solve(pExpression, pDataSourceObject, pResultObject, pManifest, pDataDestinationObject)
	{
		let tmpResultsObject = (typeof(pResultObject) === 'object') ? pResultObject : {};
		let tmpDataSourceObject = (typeof(pDataSourceObject) === 'object') ? pDataSourceObject : {};
		let tmpDataDestinationObject = (typeof(pDataDestinationObject) === 'object') ? pDataDestinationObject : {};

		// This is technically a "pre-compile" and we can keep this Results Object around to reuse for better performance.  Not required.
		this.tokenize(pExpression, tmpResultsObject);

		// Lint the tokenized expression to make sure it's valid
		this.lintTokenizedExpression(tmpResultsObject.RawTokens, tmpResultsObject);
		this.buildPostfixedSolveList(tmpResultsObject.RawTokens, tmpResultsObject);

		const tmpManifest = (typeof(pManifest) === 'object') ? pManifest : this.fable.newManyfest();
		if (tmpResultsObject.SolverDirectives.Code == 'SERIES')
		{
			const [ tmpStep , tmpFrom, tmpTo] = this._prepareDirectiveParameters([
				tmpResultsObject.SolverDirectives.Step,
				tmpResultsObject.SolverDirectives.From,
				tmpResultsObject.SolverDirectives.To,
			], [ '1' ], tmpResultsObject, tmpDataSourceObject, tmpManifest);

			if (isNaN(tmpFrom) || isNaN(tmpTo))
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  FROM, TO must be numeric.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}

			// Make sure from/to are not equal
			if (this.fable.Math.comparePrecise(tmpFrom, tmpTo) == 0)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  FROM and TO cannot be equal.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}

			// Make sure that Step is the correct positive/negative based on From and To
			if (this.fable.Math.comparePrecise(tmpStep, '0') == 0)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  STEP cannot be zero.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}
			if (this.fable.Math.comparePrecise(tmpFrom, tmpTo) < 0)
			{
				// From < To so Step must be positive
				if (this.fable.Math.comparePrecise(tmpStep, '0') < 0)
				{
					tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  STEP must be positive when FROM < TO.`);
					this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
					return null;
				}
			}
			else
			{
				// From >= To so Step must be negative
				if (this.fable.Math.comparePrecise(tmpStep, '0') > 0)
				{
					tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  STEP must be negative when FROM >= TO.`);
					this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
					return null;
				}
			}

			// Get the number of iterations we need to perform
			let tmpIterations = parseInt(this.fable.Math.floorPrecise(this.fable.Math.dividePrecise(this.fable.Math.subtractPrecise(tmpTo, tmpFrom), tmpStep)));

			let tmpValueArray = [];

			for (let i = 0; i <= tmpIterations; i++)
			{
				const tmpCurrentValueOfN = this.fable.Math.addPrecise(tmpFrom, this.fable.Math.multiplyPrecise(tmpStep, i.toString()));
				const tmpPreviousValueOfN = (i == 0) ? 'false' : this.fable.Math.addPrecise(tmpFrom, this.fable.Math.multiplyPrecise(tmpStep, (i - 1).toString()));

				// Jimmy up the data source with the current N value, stepIndex and all the other data from the source object
				// This generates a data source object every time on purpose so we can remarshal in values that changed in the destination
				let tmpSeriesStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpSeriesStepDataSourceObject.n = tmpCurrentValueOfN;
				tmpSeriesStepDataSourceObject.prev_n = tmpPreviousValueOfN;
				tmpSeriesStepDataSourceObject.stepIndex = i;

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpSeriesStepDataSourceObject, tmpResultsObject, tmpManifest);

				tmpValueArray.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpValueArray);

			return tmpValueArray;
		}
		else if (tmpResultsObject.SolverDirectives.Code == 'MAP')
		{
			// The values to pull in -- this could be a map but affords better flexibility broken out like this.
			const tmpDirectiveValues = tmpResultsObject.SolverDirectives.Values;
			const tmpDirectiveValueKeys = tmpResultsObject.SolverDirectives.ValueKeys;
			let tmpValueArray = [];

			for (let i = 0; i < tmpDirectiveValueKeys.length; i++)
			{
				const tmpVariableKey = tmpDirectiveValueKeys[i];
				const tmpVariableDescription = tmpDirectiveValues[tmpVariableKey];

				// Get the actual value for this variable's address
				tmpVariableDescription.Value = tmpManifest.getValueByHash(tmpDataSourceObject, tmpVariableDescription.Address);
			}

			// If the first value doesn't have keys, don't do the map.
			if ((tmpDirectiveValueKeys.length < 1) || (tmpDirectiveValues[tmpDirectiveValueKeys[0]].Value == null) || (!Array.isArray(tmpDirectiveValues[tmpDirectiveValueKeys[0]].Value)))
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MAP directive parameters.  The first variable's address must resolve to an array.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return undefined;
			}

			let tmpControllingSet = tmpDirectiveValues[tmpDirectiveValueKeys[0]].Value;

			for (let i = 0; i < tmpControllingSet.length; i++)
			{
				// Jimmy up the data source with the current N value, stepIndex and all the other data from the source object
				// This generates a data source object every time on purpose so we can remarshal in values that changed in the destination
				let tmpSeriesStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpSeriesStepDataSourceObject.stepIndex = i;

				for (let j = 0; j < tmpDirectiveValueKeys.length; j++)
				{
					const tmpVariableKey = tmpDirectiveValueKeys[j];
					if (!Array.isArray(tmpDirectiveValues[tmpVariableKey].Value) || (tmpDirectiveValues[tmpVariableKey].Value.length <= i))
					{
						tmpSeriesStepDataSourceObject[tmpVariableKey] = 0;
					}
					else
					{
						tmpSeriesStepDataSourceObject[tmpVariableKey] = tmpDirectiveValues[tmpVariableKey].Value[i];
					}
					const tmpPreviousValueKey = `prev_${tmpVariableKey}`;
					if (!Array.isArray(tmpDirectiveValues[tmpVariableKey].Value) || (tmpDirectiveValues[tmpVariableKey].Value.length <= i))
					{
						tmpSeriesStepDataSourceObject[tmpPreviousValueKey] = 0;
					}
					else if (i == 0)
					{
						tmpSeriesStepDataSourceObject[tmpPreviousValueKey] = 'false';
					}
					else
					{
						tmpSeriesStepDataSourceObject[tmpPreviousValueKey] = tmpDirectiveValues[tmpVariableKey].Value[i - 1];
					}
				}

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpSeriesStepDataSourceObject, tmpResultsObject, tmpManifest);

				tmpValueArray.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpValueArray);

			return tmpValueArray;
		}
		else if (tmpResultsObject.SolverDirectives.Code == 'MULTIROWMAP')
		{
			// MULTIROWMAP iterates over an array of objects (rows), allowing each expression to reference
			// the current row and any number of previous/future rows via configurable offsets.
			// Optional SERIESSTART and SERIESSTEP control which rows are iterated and in what direction.
			const tmpDirectiveValues = tmpResultsObject.SolverDirectives.Values;
			const tmpDirectiveValueKeys = tmpResultsObject.SolverDirectives.ValueKeys;
			const tmpRowsAddress = tmpResultsObject.SolverDirectives.RowsAddress;
			let tmpValueArray = [];

			// Resolve the rows array from the data source
			let tmpRows = null;
			if (tmpRowsAddress)
			{
				tmpRows = tmpManifest.getValueByHash(tmpDataSourceObject, tmpRowsAddress);
			}

			if (!Array.isArray(tmpRows) || tmpRows.length < 1)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MULTIROWMAP directive parameters.  ROWS FROM address must resolve to a non-empty array.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return undefined;
			}

			// Resolve SeriesStart: default to 0 (first row).  Negative values count from end.
			let tmpSeriesStart = 0;
			if (tmpResultsObject.SolverDirectives.SeriesStart !== null)
			{
				tmpSeriesStart = parseInt(tmpResultsObject.SolverDirectives.SeriesStart);
				if (isNaN(tmpSeriesStart))
				{
					// Try to resolve as a variable from the data source
					let tmpStartToken = this.fable.ExpressionParser.Postfix.getTokenContainerObject(tmpResultsObject.SolverDirectives.SeriesStart, 'Token.Symbol');
					this.substituteValuesInTokenizedObjects([tmpStartToken], tmpDataSourceObject, tmpResultsObject, tmpManifest);
					if (tmpStartToken.Resolved)
					{
						tmpSeriesStart = parseInt(tmpStartToken.Value);
					}
					if (isNaN(tmpSeriesStart))
					{
						tmpSeriesStart = 0;
					}
				}
			}
			// Handle negative start (count from end)
			if (tmpSeriesStart < 0)
			{
				tmpSeriesStart = tmpRows.length + tmpSeriesStart;
			}
			// Clamp to valid range
			tmpSeriesStart = Math.max(0, Math.min(tmpSeriesStart, tmpRows.length - 1));

			// Resolve SeriesStep: default to 1
			let tmpSeriesStep = 1;
			if (tmpResultsObject.SolverDirectives.SeriesStep !== null)
			{
				tmpSeriesStep = parseInt(tmpResultsObject.SolverDirectives.SeriesStep);
				if (isNaN(tmpSeriesStep))
				{
					// Try to resolve as a variable from the data source
					let tmpStepToken = this.fable.ExpressionParser.Postfix.getTokenContainerObject(tmpResultsObject.SolverDirectives.SeriesStep, 'Token.Symbol');
					this.substituteValuesInTokenizedObjects([tmpStepToken], tmpDataSourceObject, tmpResultsObject, tmpManifest);
					if (tmpStepToken.Resolved)
					{
						tmpSeriesStep = parseInt(tmpStepToken.Value);
					}
					if (isNaN(tmpSeriesStep))
					{
						tmpSeriesStep = 1;
					}
				}
			}
			if (tmpSeriesStep === 0)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MULTIROWMAP directive parameters.  SERIESSTEP cannot be zero.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return undefined;
			}

			let tmpStepCounter = 0;
			for (let i = tmpSeriesStart; (tmpSeriesStep > 0) ? (i < tmpRows.length) : (i >= 0); i += tmpSeriesStep)
			{
				// Build the data source for this iteration with the mapped variables
				let tmpRowStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpRowStepDataSourceObject.stepIndex = tmpStepCounter;
				tmpRowStepDataSourceObject.rowIndex = i;

				for (let j = 0; j < tmpDirectiveValueKeys.length; j++)
				{
					const tmpVariableKey = tmpDirectiveValueKeys[j];
					const tmpVariableDescription = tmpDirectiveValues[tmpVariableKey];
					const tmpTargetRowIndex = i + tmpVariableDescription.RowOffset;

					// Check if the target row index is within bounds
					if (tmpTargetRowIndex < 0 || tmpTargetRowIndex >= tmpRows.length)
					{
						// Out of bounds -- use the default value
						tmpRowStepDataSourceObject[tmpVariableKey] = tmpVariableDescription.Default;
					}
					else
					{
						const tmpTargetRow = tmpRows[tmpTargetRowIndex];
						if (tmpVariableDescription.Property === null)
						{
							// No property specified, use the whole row
							tmpRowStepDataSourceObject[tmpVariableKey] = tmpTargetRow;
						}
						else
						{
							// Look up the property on the target row
							let tmpValue = tmpManifest.getValueByHash(tmpTargetRow, tmpVariableDescription.Property);
							if (tmpValue == null)
							{
								tmpValue = tmpVariableDescription.Default;
							}
							tmpRowStepDataSourceObject[tmpVariableKey] = tmpValue;
						}
					}
				}

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpRowStepDataSourceObject, tmpResultsObject, tmpManifest);

				tmpValueArray.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}

				tmpStepCounter++;
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpValueArray);

			return tmpValueArray;
		}
		else if (tmpResultsObject.SolverDirectives.Code == 'MONTECARLO')
		{
			const [ tmpSampleCount ] = this._prepareDirectiveParameters([
				tmpResultsObject.SolverDirectives.SampleCount
			], [ '1' ], tmpResultsObject, tmpDataSourceObject, tmpManifest);

			if (isNaN(tmpSampleCount))
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MONTECARLO directive parameters.  SAMPLECOUNT must be numeric.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}

			let tmpMonteCarloOutput = JSON.parse(JSON.stringify(tmpResultsObject.SolverDirectives));
			tmpMonteCarloOutput.Samples = [];

			// Now go through each variable and prepare its object of values
			let tmpVariableKeys = Object.keys(tmpMonteCarloOutput.Values);
			for (let i = 0; i < tmpVariableKeys.length; i++)
			{
				let tmpVariableKey = tmpVariableKeys[i];
				let tmpVariableDescription = tmpMonteCarloOutput.Values[tmpVariableKey];

				// For each variable, generate its array of sampled values
				tmpVariableDescription.Distribution = {};
				tmpVariableDescription.ValueSequence = [];

				// Resolve the points if they are tokenized expressions
				const tmpResolvedPoints = [];
				for (let j = 0; j < tmpVariableDescription.Points.length; j++)
				{
					let tmpPointToken = tmpVariableDescription.Points[j];
					let tmpPointValue = this.fable.Math.parsePrecise(tmpPointToken, NaN);
					if (isNaN(tmpPointValue) && typeof tmpPointToken === 'string' && tmpPointToken.length > 0)
					{
						tmpPointValue = tmpManifest.getValueByHash(tmpDataSourceObject, tmpPointToken);
						if (!tmpPointValue || (tmpPointValue == null))
						{
							//TODO: Warn?
						}
						else
						{
							tmpResolvedPoints.push(tmpPointValue);
						}

					}
					else
					{
						tmpResolvedPoints.push(tmpPointToken);
					}
				}
				// Now sort the resolved points
				tmpResolvedPoints.sort((a, b) => this.fable.Math.comparePrecise(a, b));
				tmpVariableDescription.ResolvedPoints = tmpResolvedPoints;

				// Just simple linear until we add more easing types in a separate library (refactoring the below out)
				tmpVariableDescription.FirstPoint = tmpVariableDescription.ResolvedPoints[0];
				tmpVariableDescription.DomainRangeStart = tmpVariableDescription.FirstPoint;
				if (tmpVariableDescription.ResolvedPoints.length < 2)
				{
					tmpVariableDescription.LastPoint = tmpVariableDescription.FirstPoint;
				}
				else
				{
					tmpVariableDescription.LastPoint = this.fable.Math.parsePrecise(tmpVariableDescription.ResolvedPoints[tmpVariableDescription.ResolvedPoints.length - 1], NaN);
					if (isNaN(tmpVariableDescription.LastPoint))
					{
						tmpVariableDescription.LastPoint = tmpVariableDescription.FirstPoint;
					}
				}
				tmpVariableDescription.DomainLength = this.fable.Math.subtractPrecise(tmpVariableDescription.LastPoint, tmpVariableDescription.FirstPoint);
				//this.fable.log.trace(`Monte Carlo variable ${tmpVariableKey} has first point ${tmpVariableDescription.FirstPoint}, last point ${tmpVariableDescription.LastPoint}, domain length ${tmpVariableDescription.DomainLength}`);

				// // This generation of data based on the resolved points (and easing type) should be abstracted.  Most require the same rules.
				// tmpVariableDescription.ResolvedPointDomainStarts = [];
				// tmpVariableDescription.DomainTranslationAmount = [];

				// // Get the length of each domain segment and the multiplier for them
				// tmpVariableDescription.DomainLength = this.fable.Math.subtractPrecise(tmpVariableDescription.ResolvedPoints[tmpVariableDescription.ResolvedPoints.length - 1], tmpVariableDescription.ResolvedPoints[0]);
				// tmpVariableDescription.DomainChunkCount = tmpVariableDescription.ResolvedPoints.length;
				// tmpVariableDescription.DomainStart = tmpVariableDescription.ResolvedPoints[0];

				// let tmpCurrentDomainPosition = tmpVariableDescription.DomainStart;
				// let tmpPreviousDomainTranslationAmount = '0';
				// for (let j = 0; j < tmpVariableDescription.ResolvedPoints.length; j++)
				// {
				// 	let tmpResolvedPointValue = tmpVariableDescription.ResolvedPoints[j];
				// 	// Set the resolved point domain start
				// 	tmpVariableDescription.DomainTranslationAmount.push(this.fable.Math.dividePrecise(tmpResolvedPointValue, tmpVariableDescription.DomainLength));
				// 	// Push the previous translation amount as the start of this domain
				// 	tmpVariableDescription.ResolvedPointDomainStarts.push(tmpPreviousDomainTranslationAmount);
				// 	// Calculate the translation amount, for the start of the next domain
				// 	tmpPreviousDomainTranslationAmount = this.fable.Math.addPrecise(tmpPreviousDomainTranslationAmount, tmpVariableDescription.DomainLength);
				// }
			}

			for (let i = 0; i <= Number(tmpSampleCount) - 1; i++)
			{
				// Jimmy up the data source with the current N value, stepIndex and all the other data from the source object
				// This generates a data source object every time on purpose so we can remarshal in values that changed in the destination
				let tmpSeriesStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpSeriesStepDataSourceObject.stepIndex = i;

				// Generate each value from the array of values
				for (let j = 0; j < tmpVariableKeys.length; j++)
				{
					let tmpPointManifestHash = tmpVariableKeys[j];
					let tmpPointManifest = tmpMonteCarloOutput.Values[tmpPointManifestHash];

					// Generate the value for this sample variable
					let tmpPointValue = this.fable.Math.generateValueFromEasingDescription(tmpPointManifest);
					tmpSeriesStepDataSourceObject[tmpVariableKeys[j]] = tmpPointValue;
					tmpPointManifest.ValueSequence.push(tmpPointValue);

					// We keep track of a distribution of generated values here for analysis later
					let tmpDistributionRoundPrecision = tmpPointManifest.DistributionRoundPrecision || 0;
					// Log the value out
					//this.fable.log.info(`Monte Carlo variable ${tmpPointManifestHash} generated value ${tmpPointValue}`);
					let tmpDistributionPointValue = this.fable.Math.roundPrecise(tmpPointValue, tmpDistributionRoundPrecision);
					if (!(tmpDistributionPointValue in tmpPointManifest.Distribution))
					{
						tmpPointManifest.Distribution[tmpDistributionPointValue] = 0;
					}
					tmpPointManifest.Distribution[tmpDistributionPointValue] = tmpPointManifest.Distribution[tmpDistributionPointValue] + 1;
				}

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpSeriesStepDataSourceObject, tmpResultsObject, tmpManifest);
				tmpMonteCarloOutput.Samples.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest ) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpMonteCarloOutput);

			return tmpMonteCarloOutput;
		}
		else // For 'SOLVE' or anything else that didn't work
		{
			// This is where the data from variables gets marshaled into their symbols (from AppData or the like)
			this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpDataSourceObject, tmpResultsObject, pManifest);
			// Finally this is the expr solving method, which returns a string and also marshals it into tmpDataDestinationObject
			return this.solvePostfixedExpression(tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, pManifest);
		}
	}
}

module.exports = FableServiceExpressionParser;

},{"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer-DirectiveMutation.js":81,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer.js":82,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-FunctionMap.json":83,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Linter.js":84,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Messaging.js":85,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Postfix.js":86,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-SolvePostfixedExpression.js":87,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-TokenMap.json":88,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ValueMarshal.js":89,"fable-serviceproviderbase":59}],80:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class ExpressionParserOperationBase extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'ExpressionParserOperationBase';

		this.numberTest = /^-{0,1}\d*\.{0,1}\d+$/;

		this.ExpressionParser = false;
	}

	connectExpressionParser(pExpressionParser)
	{
		this.ExpressionParser = pExpressionParser;
	}

	getTokenType(pToken)
	{
		if (pToken in this.ExpressionParser.tokenMap)
		{
			return `Token.${this.ExpressionParser.tokenMap[pToken].Type}`;
		}
		else if ((pToken.length > 2) && (pToken[0] === '{') && (pToken[pToken.length-1] === '}'))
		{
			return 'Token.StateAddress';
		}
		else if ((pToken.length > 1) && (pToken[0] === '"') && (pToken[pToken.length-1] === '"'))
		{
			return 'Token.String';
		}
		else if (this.numberTest.test(pToken))
		{
			return 'Token.Constant';
		}
		else
		{
			return 'Token.Symbol';
		}
		// Just for documentation sake:
		// There is a fifth token type, VirtualSymbol
		// This is a value that's added during solve and looked up by address in the VirtualSymbol object.
	}

	getTokenContainerObject(pToken, pTokenType)
	{
		return (
			{
				Token: pToken,
				Type: (typeof(pTokenType) === 'undefined') ? this.getTokenType(pToken) : pTokenType,
				Descriptor: (pToken in this.ExpressionParser.tokenMap) ? this.ExpressionParser.tokenMap[pToken] : false
			});
	}
}

module.exports = ExpressionParserOperationBase;
},{"fable-serviceproviderbase":59}],81:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionTokenizerDirectiveMutation extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-TokenizerDirectiveMutation';

		this.directiveTypes = (
			{
				'SOLVE': { Name: 'Solve Expression', Code: 'SOLVE' },
				'SERIES': { Name: 'Series', Code: 'SERIES', From: null, To: null, Step: null },
				'MONTECARLO': { Name: 'Monte Carlo Simulation', SampleCount: '1', Code: 'MONTECARLO', Values: {} },
				'MAP': { Name: 'Map', Code: 'MAP', Values: {}, ValueKeys: [] },
				'MULTIROWMAP': { Name: 'Multi-Row Map', Code: 'MULTIROWMAP', RowsAddress: null, SeriesStart: null, SeriesStep: null, Values: {}, ValueKeys: [] },
			});

		this.defaultDirective = this.directiveTypes.SOLVE;
	}

	parseSeriesDirective(pTokens)
	{
		// This isn't a fancy real parse it's just taking words and stealing values after them.
		let tmpNewSeriesDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.SERIES));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'FROM':
					if ((i + 1) < pTokens.length)
					{
						tmpNewSeriesDirectiveDescription.From = pTokens[i + 1];
					}
					break;

				case 'TO':
					if ((i + 1) < pTokens.length)
					{
						tmpNewSeriesDirectiveDescription.To = pTokens[i + 1];
					}
					break;

				case 'STEP':
					if ((i + 1) < pTokens.length)
					{
						tmpNewSeriesDirectiveDescription.Step = pTokens[i + 1];
					}
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewSeriesDirectiveDescription;
	}

	parseMonteCarloDirective(pTokens)
	{
		// This isn't a fancy real parse it's just taking words and stealing values after them.
		let tmpNewMonteCarloDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.MONTECARLO));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'SAMPLECOUNT':
					if ((i + 1) < pTokens.length)
					{
						tmpNewMonteCarloDirectiveDescription.SampleCount = pTokens[i + 1];
					}
					i = i + 1;
					break;

				case 'VARIABLE':
				case 'VAR':
				case 'V':
					if ((i + 1) < pTokens.length)
					{
						let tmpVariableToken = pTokens[i + 1];
						if (typeof(tmpVariableToken) === 'string' && (tmpVariableToken.length > 0))
						{
							tmpNewMonteCarloDirectiveDescription.Values[tmpVariableToken] =
							{
								Token: tmpVariableToken,
								Easing: 'Linear', // could be parametric, logarithmic, bezier, uniform, normal, etc.
								Points: [] // array of values for points to generate between.
							}
						}
					}
					i = i + 1;
					break;

				case 'POINT':
				case 'PT':
				case 'P':
					if (pTokens.length < i + 2)
					{
						continue;
					}

					let tmpTokenIndexSkip = 2;
					let tmpVariableToken = pTokens[i + 1];
					if (tmpVariableToken in tmpNewMonteCarloDirectiveDescription.Values)
					{
						let tmpVariableValueString = pTokens[i + 2];
						if ((tmpVariableValueString == '-') || (tmpVariableValueString == '+'))
						{
							if (pTokens.length < i + 3)
							{
								continue;
							}
							tmpVariableValueString = tmpVariableValueString + pTokens[i + 3];
							tmpTokenIndexSkip = 3;
						}
						let tmpVariableValue = this.fable.Math.parsePrecise(tmpVariableValueString, NaN);
						if (!isNaN(tmpVariableValue))
						{
							tmpNewMonteCarloDirectiveDescription.Values[tmpVariableToken].Points.push(tmpVariableValue);
						}
					}
					i = i + tmpTokenIndexSkip;
					break;

				case 'EASING':
					if (pTokens.length < i + 2)
					{
						continue;
					}

					tmpVariableToken = pTokens[i + 1];
					let tmpEasingType = pTokens[i + 2].toUpperCase();
					if (tmpVariableToken in tmpNewMonteCarloDirectiveDescription.Values)
					{
						tmpNewMonteCarloDirectiveDescription.Values[tmpVariableToken].Easing = tmpEasingType;
					}
					i = i + 2;
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewMonteCarloDirectiveDescription;
	}

	parseMapDirective(pTokens)
	{
		// This isn't a fancy real parse it's just taking words and stealing values after them.
		let tmpNewMapDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.MAP));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'VARIABLE':
				case 'VAR':
				case 'V':
					if (((i + 3) < pTokens.length) && (pTokens[i+2].toUpperCase() == 'FROM'))
					{
						let tmpVariableToken = pTokens[i + 1];
						if (typeof(tmpVariableToken) === 'string' && (tmpVariableToken.length > 0))
						{
							tmpNewMapDirectiveDescription.ValueKeys.push(tmpVariableToken);
							tmpNewMapDirectiveDescription.Values[tmpVariableToken] =
							{
								Token: tmpVariableToken,
								Address: pTokens[i + 3],
							}
						}
						i = i + 3;
					}
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewMapDirectiveDescription;
	}

	parseMultiRowMapDirective(pTokens)
	{
		// Parse MULTIROWMAP directive tokens.
		// Syntax: MULTIROWMAP ROWS FROM <address> [SERIESSTART <n>] [SERIESSTEP <n>] VAR <name> FROM <property> OFFSET <n> DEFAULT <defaultValue> ...
		// OFFSET defaults to 0 (current row) if not specified.
		// DEFAULT defaults to '0' if not specified.
		// OFFSET 0 = current row, OFFSET -1 = previous row, OFFSET -2 = two rows back, etc.
		// Positive OFFSET values look forward (e.g., OFFSET 1 = next row, OFFSET 2 = two rows ahead).
		// SERIESSTART defaults to 0 (first row). Negative values count from the end (e.g., -2 = second-to-last row).
		// SERIESSTEP defaults to 1. Use -1 to iterate backwards through rows.
		let tmpNewDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.MULTIROWMAP));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'ROWS':
					// Expect ROWS FROM <address>
					if (((i + 2) < pTokens.length) && (pTokens[i + 1].toUpperCase() === 'FROM'))
					{
						tmpNewDirectiveDescription.RowsAddress = pTokens[i + 2];
						i = i + 2;
					}
					break;

				case 'SERIESSTART':
					if ((i + 1) < pTokens.length)
					{
						// Handle negative values which get tokenized as separate - and number tokens
						let tmpStartValue = pTokens[i + 1];
						if ((tmpStartValue === '-') && ((i + 2) < pTokens.length))
						{
							tmpStartValue = '-' + pTokens[i + 2];
							i = i + 2;
						}
						else
						{
							i = i + 1;
						}
						tmpNewDirectiveDescription.SeriesStart = tmpStartValue;
					}
					break;

				case 'SERIESSTEP':
					if ((i + 1) < pTokens.length)
					{
						// Handle negative values which get tokenized as separate - and number tokens
						let tmpStepValue = pTokens[i + 1];
						if ((tmpStepValue === '-') && ((i + 2) < pTokens.length))
						{
							tmpStepValue = '-' + pTokens[i + 2];
							i = i + 2;
						}
						else
						{
							i = i + 1;
						}
						tmpNewDirectiveDescription.SeriesStep = tmpStepValue;
					}
					break;

				case 'VARIABLE':
				case 'VAR':
				case 'V':
					// Expect: VAR <name> FROM <property> [OFFSET <n>] [DEFAULT <defaultValue>]
					if (((i + 3) < pTokens.length) && (pTokens[i + 2].toUpperCase() === 'FROM'))
					{
						let tmpVariableName = pTokens[i + 1];
						let tmpProperty = pTokens[i + 3];

						if (typeof(tmpVariableName) === 'string' && (tmpVariableName.length > 0))
						{
							let tmpVariableDescriptor = {
								Token: tmpVariableName,
								Property: tmpProperty,
								RowOffset: 0,
								Default: '0',
							};

							let tmpCurrentIndex = i + 3;

							// Scan forward for OFFSET and DEFAULT in any order
							while (tmpCurrentIndex + 1 < pTokens.length)
							{
								let tmpNextToken = pTokens[tmpCurrentIndex + 1].toUpperCase();
								if (tmpNextToken === 'OFFSET')
								{
									if (tmpCurrentIndex + 2 < pTokens.length)
									{
										// Handle negative offsets which get tokenized as separate - and number tokens
										let tmpOffsetValue = pTokens[tmpCurrentIndex + 2];
										if ((tmpOffsetValue === '-') && (tmpCurrentIndex + 3 < pTokens.length))
										{
											tmpOffsetValue = '-' + pTokens[tmpCurrentIndex + 3];
											tmpCurrentIndex = tmpCurrentIndex + 3;
										}
										else
										{
											tmpCurrentIndex = tmpCurrentIndex + 2;
										}
										tmpVariableDescriptor.RowOffset = parseInt(tmpOffsetValue);
										if (isNaN(tmpVariableDescriptor.RowOffset))
										{
											tmpVariableDescriptor.RowOffset = 0;
										}
									}
								}
								else if (tmpNextToken === 'DEFAULT')
								{
									if (tmpCurrentIndex + 2 < pTokens.length)
									{
										// Handle negative defaults which get tokenized as separate - and number tokens
										let tmpDefaultValue = pTokens[tmpCurrentIndex + 2];
										if ((tmpDefaultValue === '-') && (tmpCurrentIndex + 3 < pTokens.length))
										{
											tmpDefaultValue = '-' + pTokens[tmpCurrentIndex + 3];
											tmpCurrentIndex = tmpCurrentIndex + 3;
										}
										else
										{
											tmpCurrentIndex = tmpCurrentIndex + 2;
										}
										tmpVariableDescriptor.Default = tmpDefaultValue;
									}
								}
								else
								{
									// Not a recognized sub-keyword for this variable; stop scanning
									break;
								}
							}

							i = tmpCurrentIndex;

							tmpNewDirectiveDescription.ValueKeys.push(tmpVariableName);
							tmpNewDirectiveDescription.Values[tmpVariableName] = tmpVariableDescriptor;
						}
					}
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewDirectiveDescription;
	}

	rewriteTernaryOperators(pResultObject)
	{
		let tmpTokens = pResultObject.RawTokens;

		// Scan right-to-left so nested ternaries (innermost first) are handled correctly.
		for (let i = tmpTokens.length - 1; i >= 0; i--)
		{
			if (tmpTokens[i] !== '?')
			{
				continue;
			}

			// Found a ? token at index i.
			// Walk left to find the start of the condition expression.
			// The condition starts after the previous comma, open parenthesis, assignment operator, or beginning of tokens.
			let tmpConditionStart = 0;
			let tmpParenDepth = 0;
			for (let j = i - 1; j >= 0; j--)
			{
				if (tmpTokens[j] === ')')
				{
					tmpParenDepth++;
				}
				else if (tmpTokens[j] === '(')
				{
					if (tmpParenDepth > 0)
					{
						tmpParenDepth--;
					}
					else
					{
						// We hit an unmatched open paren — condition starts after it
						tmpConditionStart = j + 1;
						break;
					}
				}
				else if (tmpParenDepth === 0)
				{
					let tmpTokenDescriptor = this.ExpressionParser.tokenMap[tmpTokens[j]];
					if (tmpTokenDescriptor && (tmpTokenDescriptor.Type === 'Assignment' || tmpTokens[j] === ','))
					{
						tmpConditionStart = j + 1;
						break;
					}
				}
			}

			// Walk right from ? to find the matching :: at the same parenthesis depth.
			let tmpSeparatorIndex = -1;
			tmpParenDepth = 0;
			for (let j = i + 1; j < tmpTokens.length; j++)
			{
				if (tmpTokens[j] === '(')
				{
					tmpParenDepth++;
				}
				else if (tmpTokens[j] === ')')
				{
					if (tmpParenDepth > 0)
					{
						tmpParenDepth--;
					}
					else
					{
						// Hit closing paren at our depth — no :: found in this group
						break;
					}
				}
				else if (tmpTokens[j] === '::' && tmpParenDepth === 0)
				{
					tmpSeparatorIndex = j;
					break;
				}
			}

			if (tmpSeparatorIndex === -1)
			{
				pResultObject.ExpressionParserLog.push(`ExpressionParser.rewriteTernaryOperators found a ? at token index ${i} with no matching :: separator.`);
				this.log.warn(pResultObject.ExpressionParserLog[pResultObject.ExpressionParserLog.length - 1]);
				continue;
			}

			// Walk right from :: to find the end of the false branch.
			// The false branch ends at the next comma, close parenthesis, or end of tokens at the same depth.
			let tmpFalseBranchEnd = tmpTokens.length;
			tmpParenDepth = 0;
			for (let j = tmpSeparatorIndex + 1; j < tmpTokens.length; j++)
			{
				if (tmpTokens[j] === '(')
				{
					tmpParenDepth++;
				}
				else if (tmpTokens[j] === ')')
				{
					if (tmpParenDepth > 0)
					{
						tmpParenDepth--;
					}
					else
					{
						// Unmatched close paren — false branch ends here
						tmpFalseBranchEnd = j;
						break;
					}
				}
				else if (tmpParenDepth === 0)
				{
					if (tmpTokens[j] === ',')
					{
						tmpFalseBranchEnd = j;
						break;
					}
				}
			}

			// Extract the three segments
			let tmpConditionTokens = tmpTokens.slice(tmpConditionStart, i);
			let tmpTrueBranchTokens = tmpTokens.slice(i + 1, tmpSeparatorIndex);
			let tmpFalseBranchTokens = tmpTokens.slice(tmpSeparatorIndex + 1, tmpFalseBranchEnd);

			// Build the replacement: ternary((condition), trueBranch, falseBranch)
			// The condition is wrapped in its own parentheses to ensure correct
			// precedence grouping when arithmetic appears on both sides of a comparison.
			let tmpReplacementTokens = ['ternary', '(', '('];
			tmpReplacementTokens = tmpReplacementTokens.concat(tmpConditionTokens);
			tmpReplacementTokens.push(')');
			tmpReplacementTokens.push(',');
			tmpReplacementTokens = tmpReplacementTokens.concat(tmpTrueBranchTokens);
			tmpReplacementTokens.push(',');
			tmpReplacementTokens = tmpReplacementTokens.concat(tmpFalseBranchTokens);
			tmpReplacementTokens.push(')');

			// Splice the replacement into the token array
			tmpTokens.splice(tmpConditionStart, tmpFalseBranchEnd - tmpConditionStart, ...tmpReplacementTokens);

			// Adjust i to re-scan from the start of what we just inserted (in case of nested ternaries in the condition)
			i = tmpConditionStart;
		}
	}

	parseDirectives(pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		// Rewrite ternary operators before directive parsing
		this.rewriteTernaryOperators(tmpResults);

		tmpResults.SolverDirectives = this.defaultDirective;
		tmpResults.SolverDirectiveTokens = [];

		if (tmpResults.RawTokens.length < 2)
		{
			tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenizeDirectiveMutation postprocessor received insufficient tokens to process directives.`);
			this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return tmpResults.SolverDirectives;
		}

		// Enumerate each of the tmpResults.RawTokens to see if one of the values in the directiveTypeMap exists and is either at the beginning or after the assignment (= or ?=) operator
		for (let i = 0; i < tmpResults.RawTokens.length; i++)
		{
			let tmpToken = tmpResults.RawTokens[i].toUpperCase();
			if (tmpToken in this.directiveTypes)
			{
				// Check if it's at the beginning or after an assignment operator
				// FIXME: This is hard coded assignment operators which is bad juju
				if ((i === 0) || (tmpResults.RawTokens[i-1] === '=') || (tmpResults.RawTokens[i-1] === '?='))
				{
					// We have a directive!
					tmpResults.SolverDirectives.Type = this.directiveTypes[tmpToken];

					tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenizeDirectiveMutation identified solver directive: ${tmpToken}`);
					//this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);

					// Extract the Directive name and everything else from it up until the : token
					let tmpDirectiveTokenStartIndex = i;
					let tmpDirectiveTokenEndIndex = -1;
					for (let j = tmpDirectiveTokenStartIndex + 1; j < tmpResults.RawTokens.length; j++)
					{
						if (tmpResults.RawTokens[j] === ':')
						{
							tmpDirectiveTokenEndIndex = j;
							break;
						}
					}

					// If the directive token end is not in the expression we don't know what to do
					if (tmpDirectiveTokenEndIndex === -1)
					{
						tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenizeDirectiveMutation could not find the end of the directive token set for directive: ${tmpToken}`);
						this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
						continue;
					}

					// Set the tmpResults.SolverDirectiveTokens to the slice of tokens that represent the directive
					tmpResults.SolverDirectiveTokens = tmpResults.RawTokens.slice(tmpDirectiveTokenStartIndex, tmpDirectiveTokenEndIndex);

					// Remove the directive tokens and the assignment to the left of it from the array of raw tokens
					// the colonoscopy if you will
					tmpResults.RawTokens.splice(0, tmpDirectiveTokenEndIndex + 1);

					// Further parsing based on directive type could go here
					// e.g. parseSeriesDirective for SERIES, etc.
					switch(tmpToken)
					{
						case 'SERIES':
							tmpResults.SolverDirectives = this.parseSeriesDirective(tmpResults.SolverDirectiveTokens);
							break;
						case 'MONTECARLO':
							tmpResults.SolverDirectives = this.parseMonteCarloDirective(tmpResults.SolverDirectiveTokens);
							break;
						case 'MAP':
							tmpResults.SolverDirectives = this.parseMapDirective(tmpResults.SolverDirectiveTokens);
							break;
						case 'MULTIROWMAP':
							tmpResults.SolverDirectives = this.parseMultiRowMapDirective(tmpResults.SolverDirectiveTokens);
							break;
						default:
							// No further parsing needed
							break;
					}
				}
			}
		}

		return tmpResults.SolverDirectives;
	}
}

module.exports = ExpressionTokenizerDirectiveMutation;

},{"./Fable-Service-ExpressionParser-Base.js":80}],82:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionTokenizer extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Tokenizer';
	}

	/**
	 * Recompose an expression string from an array of tokens.
	 *
	 * This is the inverse of tokenize -- it takes an array of token strings
	 * and reconstructs a valid expression string with appropriate spacing.
	 *
	 * @param {Array<string>} pTokens - The array of token strings to recompose.
	 * @return {string} The recomposed expression string.
	 */
	recompose(pTokens)
	{
		if (!Array.isArray(pTokens) || pTokens.length === 0)
		{
			return '';
		}

		let tmpResult = '';

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i];

			if (i > 0)
			{
				let tmpPreviousToken = pTokens[i - 1];

				// Determine if we need a space before this token
				let tmpNeedSpace = true;

				// No space after opening paren
				if (tmpPreviousToken === '(')
				{
					tmpNeedSpace = false;
				}
				// No space before closing paren
				if (tmpToken === ')')
				{
					tmpNeedSpace = false;
				}
				// No space before opening paren when it follows a function name (not an operator or closing paren)
				if (tmpToken === '(' && !(tmpPreviousToken in this.ExpressionParser.tokenMap))
				{
					tmpNeedSpace = false;
				}
				// No space before comma
				if (tmpToken === ',')
				{
					tmpNeedSpace = false;
				}

				if (tmpNeedSpace)
				{
					tmpResult += ' ';
				}
			}

			tmpResult += tmpToken;
		}

		return tmpResult;
	}

	tokenize(pExpression, pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		tmpResults.RawExpression = pExpression;
		tmpResults.SolverDirectives = {};
		tmpResults.RawTokens = [];
		tmpResults.ExpressionParserLog = [];

		if (typeof(pExpression) !== 'string')
		{
			this.log.warn('ExpressionParser.tokenize was passed a non-string expression.');
			return tmpResults.RawTokens;
		}

		/* Tokenize the expression
		 *
		 * Current token types:
		 * 	- Value
		 *    : could be a symbol representation e.g. "x", "depth", "Cost", etc. --- symbol representations are looked up first as manifest hashes
		 *    : could be a number e.g. "5", "3.14159", etc.
		 *    : could be a function name e.g. sin(x), sqrt(3+5) where sin or sqrt are known function names
		 *  - StateAddress
		 *    : these are always wrapped in squiggly brackets
		 *    : e.g. {Moisture.Percentage}, {Ending.Temperature.Fahrenheit}, {AppData.Download.Size}, etc.
		 *  - Token
		 *    : could be an operator e.g. "+", "-", "*", "/"
		 *    : could be a parenthesis e.g. "(", ")"
		 *  - String
		 *    : Wrapped in double quotes e.g. "Hello World", "This is a test", etc.
		 */
		/** @type {any} */
		let tmpCurrentTokenType = false;
		let tmpCurrentToken = '';
		for (let i = 0; i < pExpression.length; i++)
		{
			let tmpCharacter = pExpression[i];

			// [ WHITESPACE ]
			// 1. Space breaks tokens except when we're in an address that's been scoped by a {} or ""
			if ((tmpCharacter === ' ' || tmpCharacter === '\t') && ((tmpCurrentTokenType !== 'StateAddress') && (tmpCurrentTokenType !== 'String')))
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				continue;
			}

			// [ STATE ADDRESS AND STRING BLOCKS ]
			// 2. If we're in an address, we keep going until we hit the closing brace
			if ((tmpCurrentTokenType === 'StateAddress') && (tmpCharacter !== '}'))
			{
				tmpCurrentToken += tmpCharacter;
				continue;
			}
			if ((tmpCurrentTokenType === 'String') && (tmpCharacter !== '"'))
			{
				tmpCurrentToken += tmpCharacter;
				continue;
			}
			// 3. If we're in an address and we hit the closing brace, we close the token, push it and reset
			if ((tmpCurrentTokenType === 'StateAddress') && (tmpCharacter === '}'))
			{
				tmpCurrentToken += tmpCharacter;
				tmpResults.RawTokens.push(tmpCurrentToken);
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				continue;
			}
			if ((tmpCurrentTokenType === 'String') && (tmpCharacter === '"'))
			{
				tmpCurrentToken += tmpCharacter;
				tmpResults.RawTokens.push(tmpCurrentToken);
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				continue;
			}
			// 4. If we're not in an address and we hit a closing brace it's a problem
			//    TODO: Should we just ignore it?  We do at the moment.
			if (tmpCharacter == '}')
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenize found a closing brace without an opening brace in the expression: ${pExpression} at character index ${i}`);
				this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				continue;
			}
			// 5. If we're not in an address and we hit an opening brace, we start an address
			if (tmpCharacter == '{')
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = 'StateAddress';
				tmpCurrentToken = tmpCharacter;
				continue;
			}
			if ((tmpCurrentTokenType !== 'String') && (tmpCharacter == '"'))
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = 'String';
				tmpCurrentToken = tmpCharacter;
				continue;
			}

			// [ TOKENS ]
			if (tmpCharacter in this.ExpressionParser.tokenRadix)
			{
				let tmpTokenRadix = this.ExpressionParser.tokenRadix[tmpCharacter];
				// If the token is a literal and has only one entry, it is a single character token and we can just safely add it.
				if (tmpTokenRadix.TokenCount == 1 && tmpTokenRadix.Literal)
				{
					if (tmpCurrentToken.length > 0)
					{
						tmpResults.RawTokens.push(tmpCurrentToken);
					}
					tmpCurrentToken = '';
					tmpCurrentTokenType = false;
					tmpResults.RawTokens.push(tmpCharacter);
					continue;
				}
				else
				{
					// This one has multiple options, so literals don't matter.  We need to check the token map.
					// The token radix TokenKeys array is sorted longest to shortest
					for (let j = 0; j < tmpTokenRadix.TokenKeys.length; j++)
					{
						let tmpTokenKey = tmpTokenRadix.TokenKeys[j];
						if (pExpression.substr(i, tmpTokenKey.length) == tmpTokenKey)
						{
							if (tmpCurrentToken.length > 0)
							{
								tmpResults.RawTokens.push(tmpCurrentToken);
							}
							tmpCurrentToken = '';
							tmpCurrentTokenType = false;
							tmpResults.RawTokens.push(tmpTokenKey);
							i += tmpTokenKey.length - 1;
							break;
						}
					}
					continue;
				}
			}

			// If it's not an operator, it's a number or address.
			// At the moment we aren't going to gate it on whether it's a valid address or not
			// Just treat anything not a known token on its own as a value identifier

			/* Per this stack overflow article: https://stackoverflow.com/questions/4434076/best-way-to-alphanumeric-check-in-javascript
			 * We could use a regex but it is slower than the charCodeAt method.
			 * This also doesn't solve the problem of unicode characters, but we won't support those for now.
			 */
			// if (pExpression.charAt(i) == '.')
			// {
			// 	console.log('Found a period')
			// }
			// let tmpCharCode = pExpression.charCodeAt(i);
			// // Match that the character code is any of...
			// if (
			// 	// Number [0-9]
			// 	(tmpCharCode > 47 && tmpCharCode < 58)
			// 	// Upper Case
			// 	|| (tmpCharCode > 64 && tmpCharCode < 91)
			// 	// LOWER CASE
			// 	|| (tmpCharCode > 96 && tmpCharCode < 123)
			// 	)
			// {

				// NOTE: Not having this guard makes a lot of interesting things possible.
			tmpCurrentTokenType = 'Value';
			tmpCurrentToken += tmpCharacter;
			// 	continue;
			// }

			// tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenize found an unknown character code ${tmpCharCode} character ${tmpCharacter} in the expression: ${pExpression} at index ${i}`);
			// this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}

		if ((tmpCurrentTokenType) && (tmpCurrentToken.length > 0))
		{
			tmpResults.RawTokens.push(tmpCurrentToken);
		}

		tmpResults.OriginalRawTokens = Array.from(tmpResults.RawTokens);

		// Potentially mutate the tokens based on directives in the tokenized expression
		this.TokenizerDirectiveMutation.parseDirectives(tmpResults);

		return tmpResults.RawTokens;
	}
}

module.exports = ExpressionTokenizer;

},{"./Fable-Service-ExpressionParser-Base.js":80}],83:[function(require,module,exports){
module.exports={
	"sqrt": {
		"Name": "Square Root",
		"Address": "fable.Math.sqrtPrecise"
	},

	"percent": {
		"Name": "Compute Percent (in IS over OF format)",
		"Address": "fable.Math.percentagePrecise"
	},

	"compare": {
		"Name": "Compare",
		"Address": "fable.Math.comparePrecise"
	},

	"abs": {
		"Name": "Absolute Value",
		"Address": "fable.Math.absPrecise"
	},
	"floor": {
		"Name": "Floor Value",
		"Address": "fable.Math.floorPrecise"
	},
	"ceil": {
		"Name": "Ceiling Value",
		"Address": "fable.Math.ceilPrecise"
	},

	"rad": {
		"Name": "Degrees to Radians",
		"Address": "fable.Math.radPrecise"
	},

	"pi": {
		"Name": "Pi",
		"Address": "fable.Math.piPrecise"
	},
	"euler": {
		"Name": "Euler",
		"Address": "fable.Math.eulerPrecise"
	},

	"log": {
		"Name": "Logarithm",
		"Address": "fable.Math.logPrecise"
	},
	"exp": {
		"Name": "Eulers Number to the Power Of N",
		"Address": "fable.Math.expPrecise"
	},


	"sin": {
		"Name": "Sine",
		"Address": "fable.Math.sin"
	},
	"cos": {
		"Name": "Cosine",
		"Address": "fable.Math.cos"
	},
	"tan": {
		"Name": "Tangent",
		"Address": "fable.Math.tan"
	},

	"count": {
		"Name": "Count Set Elements",
		"Address": "fable.Math.countSetElements"
	},
	"countset": {
		"Name": "Count Set Elements",
		"Address": "fable.Math.countSetElements"
	},
	"sortset": {
		"Name": "Sort Set",
		"Address": "fable.Math.sortSetPrecise"
	},
	"bucketset": {
		"Name": "Bucket Set",
		"Address": "fable.Math.bucketSetPrecise"
	},
	"sorthistogram": {
		"Name": "Sort Histogram",
		"Address": "fable.Math.sortHistogramPrecise"
	},
	"sorthistogrambykeys": {
		"Name": "Sort Histogram by Keys",
		"Address": "fable.Math.sortHistogramByKeys"
	},

	"max": {
		"Name": "Maximum",
		"Address": "fable.Math.maxPrecise"
	},
	"min": {
		"Name": "Minimum",
		"Address": "fable.Math.minPrecise"
	},

	"sum": {
		"Name": "Sum",
		"Address": "fable.Math.sumPrecise"
	},

	"avg": {
		"Name": "Average",
		"Address": "fable.Math.averagePrecise"
	},
	"mean": {
		"Name": "Mean",
		"Address": "fable.Math.meanPrecise"
	},
	"median": {
		"Name": "Median",
		"Address": "fable.Math.medianPrecise"
	},
	"mode": {
		"Name": "Mode",
		"Address": "fable.Math.modePrecise"
	},
	"var": {
		"Name": "Variance (Sample)",
		"Address": "fable.Math.variancePrecise"
	},
	"vara": {
		"Name": "Variance (Sample)",
		"Address": "fable.Math.variancePrecise"
	},
	"varp": {
		"Name": "Variance (Population)",
		"Address": "fable.Math.populationVariancePrecise"
	},
	"stdev": {
		"Name": "Standard Deviation (Sample)",
		"Address": "fable.Math.standardDeviationPrecise"
	},
	"stdeva": {
		"Name": "Standard Deviation (Sample)",
		"Address": "fable.Math.standardDeviationPrecise"
	},
	"stdevp": {
		"Name": "Standard Deviation (Population)",
		"Address": "fable.Math.populationStandardDeviationPrecise"
	},
	"round": {
		"Name": "Round",
		"Address": "fable.Math.roundPrecise"
	},
	"tofixed": {
		"Name": "To Fixed",
		"Address": "fable.Math.toFixedPrecise"
	},

	"cumulativesummation": {
		"Name": "Sum each value in a Histogram or Value Map cumulatively, creating or setting a property with the result on each row",
		"Address": "fable.Math.cumulativeSummation"
	},

	"subtractingsummation": {
		"Name": "Subtract each subsequent value in a Histogram or Value Map cumulatively (by default from the first row), creating or setting a property with the result on each row.",
		"Address": "fable.Math.subtractingSummation"
	},

	"iterativeseries": {
		"Name": "Perform an Iterative Series of Mathematical Operations on Set Elements",
		"Address": "fable.Math.iterativeSeries"
	},

	"countsetelements": {
		"Name": "Count Set Elements in a Histogram or Value Map",
		"Address": "fable.Math.countSetElements"
	},

	"getvalue": {
		"Name": "Get Value from Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.getInternalValueByHash",
		"AddressParameterIndices": [0]
	},

	"setvalue": {
		"Name": "Set Value to Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.setInternalValueByHash",
		"AddressParameterIndices": [0]
	},

	"objectkeystoarray": {
		"Name": "Get Array of an Object's keys",
		"Address": "fable.Utility.objectKeysToArray"
	},
	"objectvaluestoarray": {
		"Name": "Get Array of an Object's values",
		"Address": "fable.Utility.objectValuesToArray"
	},
	"generatearrayofobjectsfromsets": {
		"Name": "Generate Array of Objects from Sets",
		"Address": "fable.Utility.generateArrayOfObjectsFromSets"
	},
	"objectvaluessortbyexternalobjectarray": {
		"Name": "Get Array of an Object's values sorted by an external array",
		"Address": "fable.Utility.objectValuesSortByExternalArray"
	},
	"setkeystoarray": {
		"Name": "Get Array of an Object's keys",
		"Address": "fable.Utility.objectKeysToArray"
	},
	"setvaluestoarray": {
		"Name": "Get Array of an Object's values",
		"Address": "fable.Utility.objectValuesToArray"
	},
	"histogramkeystoarray": {
		"Name": "Get Array of an Object's keys",
		"Address": "fable.Utility.objectKeysToArray"
	},
	"histogramvaluestoarray": {
		"Name": "Get Array of an Object's values",
		"Address": "fable.Utility.objectValuesToArray"
	},

	"createarrayfromabsolutevalues": {
		"Name": "Create Array from Absolute Values",
		"Address": "fable.Utility.createArrayFromAbsoluteValues"
	},

	"flatten": {
		"Name": "flatten an array of values",
		"Address": "fable.Utility.flattenArrayOfSolverInputs"
	},

	"findfirstvaluebyexactmatch": {
		"Name": "find + map on array of objects",
		"Address": "fable.Utility.findFirstValueByExactMatchInternal",
		"AddressParameterIndices": [0, 1, 3]
	},

	"findfirstvaluebystringincludes": {
		"Name": "find + map on array of objects",
		"Address": "fable.Utility.findFirstValueByStringIncludesInternal",
		"AddressParameterIndices": [0, 1, 3]
	},

	"match": {
		"Name": "Implementation of sheets MATCH() function",
		"Address": "fable.Utility.findIndexInternal",
		"AddressParameterIndices": [1]
	},

	"resolvehtmlentities": {
		"Name": "resolve HTML entities",
		"Address": "fable.DataFormat.resolveHtmlEntities"
	},

	"concat": {
		"Name": "concatenate an array of values and output a string",
		"Address": "fable.DataFormat.concatenateStringsInternal"
	},

	"concatraw": {
		"Name": "concatenate an array of values and output a string",
		"Address": "fable.DataFormat.concatenateStringsRawInternal"
	},

	"arrayconcat": {
		"Name": "concatenate two or more arrays generating a single output array",
		"Address": "fable.Utility.concatenateArrays"
	},

	"join": {
		"Name": "join an array of values and output a string",
		"Address": "fable.DataFormat.joinStringsInternal"
	},

	"joinraw": {
		"Name": "join an array of values and output a string",
		"Address": "fable.DataFormat.joinStringsRawInternal"
	},

	"if": {
		"Name": "perform a conditional operator on two values, and choose one of two outcomes based on the result",
		"Address": "fable.Logic.checkIf"
	},

	"when": {
		"Name": "perform a 'truthy' check on one value, and return one of two outcomes based on the result",
		"Address": "fable.Logic.when"
	},

	"ternary": {
		"Name": "numeric-aware ternary selection (used by ? :: operator desugaring)",
		"Address": "fable.Logic.ternary"
	},

	"entryinset": {
		"Name": "Entry in Set",
		"Address": "fable.Math.entryInSet"
	},
	"smallestinset": {
		"Name": "Smallest in Set",
		"Address": "fable.Math.smallestInSet"
	},
	"largestinset": {
		"Name": "Largest in Set",
		"Address": "fable.Math.largestInSet"
	},

	"aggregationhistogram": {
		"Name": "Generate a Histogram by Exact Value Aggregation",
		"Address": "fable.Math.histogramAggregationByExactValueFromInternalState"
	},
	"aggregationhistogrambyobject": {
		"Name": "Generate a Histogram by Exact Value Aggregation from Object Property",
		"Address": "fable.Math.histogramAggregationByExactValue"
	},
	"distributionhistogram": {
		"Name": "Generate a Histogram Based on Value Distribution",
		"Address": "fable.Math.histogramDistributionByExactValueFromInternalState"
	},
	"distributionhistogrambyobject": {
		"Name": "Generate a Histogram Based on Value Distribution from Object Property",
		"Address": "fable.Math.histogramDistributionByExactValue"
	},

	"setconcatenate": {
		"Name": "Set Concatenate",
		"Address": "fable.Math.setConcatenate"
	},

	"getvaluearray": {
		"Name": "Get Value Array from Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.createValueArrayByHashParametersFromInternal",
		"AddressParameterIndices": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
	},
	"getvalueobject": {
		"Name": "Get Value Object from Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.createValueObjectByHashParametersFromInternal",
		"AddressParameterIndices": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
	},

	"cleanvaluearray": {
		"Name": "Clean Value Array",
		"Address": "fable.Math.cleanValueArray"
	},
	"cleanvalueobject": {
		"Name": "Clean Value Object",
		"Address": "fable.Math.cleanValueObject"
	},

	"polynomialregression": {
		"Name": "Perform an nth degree Polynomial Regression on a Set of X and Y Values",
		"Address": "fable.Math.polynomialRegression"
	},

	"randominteger": {
		"Name": "Random Integer",
		"Address": "fable.DataGeneration.randomInteger"
	},
	"randomintegerbetween": {
		"Name": "Random Integer Between Two Numbers",
		"Address": "fable.DataGeneration.randomIntegerBetween"
	},
	"randomintegerupto": {
		"Name": "Random Integer",
		"Address": "fable.DataGeneration.randomIntegerUpTo"
	},
	"randomfloat": {
		"Name": "Random Float",
		"Address": "fable.DataGeneration.randomFloat"
	},
	"randomfloatbetween": {
		"Name": "Random Float",
		"Address": "fable.DataGeneration.randomFloatBetween"
	},
	"randomfloatupto": {
		"Name": "Random Float",
		"Address": "fable.DataGeneration.randomFloatUpTo"
	},

	"datemilliseconddifference": {
		"Name": "Date Difference in Milliseconds",
		"Address": "fable.Dates.dateMillisecondDifference"
	},
	"dateseconddifference": {
		"Name": "Date Difference in Seconds",
		"Address": "fable.Dates.dateSecondDifference"
	},
	"dateminutedifference": {
		"Name": "Date Difference in Minutes",
		"Address": "fable.Dates.dateMinuteDifference"
	},
	"datehourdifference": {
		"Name": "Date Difference in Hours",
		"Address": "fable.Dates.dateHourDifference"
	},
	"datedaydifference": {
		"Name": "Date Difference in Days",
		"Address": "fable.Dates.dateDayDifference"
	},
	"dateweekdifference": {
		"Name": "Date Difference in Weeks",
		"Address": "fable.Dates.dateWeekDifference"
	},
	"datemonthdifference": {
		"Name": "Date Difference in Months",
		"Address": "fable.Dates.dateMonthDifference"
	},
	"dateyeardifference": {
		"Name": "Date Difference in Years",
		"Address": "fable.Dates.dateYearDifference"
	},

	"datemathadd": {
		"Name": "Date Math Add",
		"Address": "fable.Dates.dateMath"
	},
	"dateaddmilliseconds": {
		"Name": "Date Add Milliseconds",
		"Address": "fable.Dates.dateAddMilliseconds"
	},
	"dateaddseconds": {
		"Name": "Date Add Seconds",
		"Address": "fable.Dates.dateAddSeconds"
	},
	"dateaddminutes": {
		"Name": "Date Add Minutes",
		"Address": "fable.Dates.dateAddMinutes"
	},
	"dateaddhours": {
		"Name": "Date Add Hours",
		"Address": "fable.Dates.dateAddHours"
	},
	"dateadddays": {
		"Name": "Date Add Days",
		"Address": "fable.Dates.dateAddDays"
	},
	"dateaddweeks": {
		"Name": "Date Add Weeks",
		"Address": "fable.Dates.dateAddWeeks"
	},
	"dateaddmonths": {
		"Name": "Date Add Months",
		"Address": "fable.Dates.dateAddMonths"
	},
	"dateaddyears": {
		"Name": "Date Add Years",
		"Address": "fable.Dates.dateAddYears"
	},

	"datefromparts": {
		"Name": "Date From Parts",
		"Address": "fable.Dates.dateFromParts"
	},

	"slice": {
		"Name": "Slice Array",
		"Address": "fable.Utility.slice"
	},

	"createvalueobjectbyhashes": {
		"Name": "Create Value Object by Hashes",
		"Address": "fable.Utility.createValueObjectByHashes",
		"AddressParameterIndices": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
	},

	"slope": {
		"Name": "Slope of Linear Regression Line (Excel SLOPE equivalent)",
		"Address": "fable.Math.slopePrecise"
	},
	"intercept": {
		"Name": "Y-Intercept of Linear Regression Line (Excel INTERCEPT equivalent)",
		"Address": "fable.Math.interceptPrecise"
	},

	"leastsquares": {
		"Name": "Perform a Least Squares Regression on a Set of Independent Variable Vectors and a Dependent Variable Vector",
		"Address": "fable.Math.leastSquares"
	},
	"linest": {
		"Name": "Perform a Least Squares Regression on a Set of Independent Variable Vectors and a Dependent Variable Vector",
		"Address": "fable.Math.leastSquares"
	},

	"matrixtranspose": {
		"Name": "Transpose a Matrix",
		"Address": "fable.Math.matrixTranspose"
	},
	"matrixmultiply": {
		"Name": "Multiply Two Matrices",
		"Address": "fable.Math.matrixMultiply"
	},
	"matrixvectormultiply": {
		"Name": "Multiply a Matrix by a Vector",
		"Address": "fable.Math.matrixVectorMultiply"
	},
	"matrixinverse": {
		"Name": "Inverse a Matrix",
		"Address": "fable.Math.matrixInverse"
	},
	"gaussianelimination": {
		"Name": "Solve a System of Linear Equations using Gaussian Elimination",
		"Address": "fable.Math.gaussianElimination"
	},
	"predict": {
		"Name": "Predict Y Values from X Values using a Regression Model",
		"Address": "fable.Math.predictFromRegressionModel"
	},

	"stringcountsegments": {
		"Name": "Count Segments in a String",
		"Address": "fable.DataFormat.stringCountSegments"
	},
	"stringgetsegments": {
		"Name": "Get Segments from a String",
		"Address": "fable.DataFormat.stringGetSegments"
	},

	"bezierpoint": {
		"Name": "Evaluate a Point on a Cubic Bezier Curve at Parameter t",
		"Address": "fable.Math.bezierPoint"
	},
	"beziercurvefit": {
		"Name": "Fit a Cubic Bezier Curve to a Set of Data Points",
		"Address": "fable.Math.bezierCurveFit"
	},

	"generateguid": {
		"Name": "Generate a GUID string",
		"Address": "fable.getUUID"
	},
	"isnumeric": {
		"Name": "Is Numeric (1/0; trims strings, empty/text are not numeric)",
		"Address": "fable.Math.isNumeric"
	},
	"tonumber": {
		"Name": "To Number (with fallback for non-numeric values)",
		"Address": "fable.Math.toNumber"
	},
	"aggregationjoinbyobject": {
		"Name": "Collect (join) per-key string values by Exact Value from Object Property",
		"Address": "fable.Math.histogramAggregationJoinByExactValue"
	},
	"trim": {
		"Name": "Trim whitespace from both ends of a value",
		"Address": "fable.DataFormat.stringTrim"
	},
	"rtrim": {
		"Name": "Trim trailing whitespace from a value (e.g. SQL CHAR(n) padding)",
		"Address": "fable.DataFormat.stringTrimEnd"
	},
	"ltrim": {
		"Name": "Trim leading whitespace from a value",
		"Address": "fable.DataFormat.stringTrimStart"
	},
	"addcommas": {
		"Name": "Comma-group a numeric string verbatim (no float coercion; compose with TOFIXED for decimals)",
		"Address": "fable.DataFormat.addCommasToValue"
	},
	"dateformat": {
		"Name": "Format a Date with dayjs tokens in a timezone (explicit param, else the configured default)",
		"Address": "fable.Dates.formatDate"
	},
	"chartticks": {
		"Name": "Compute readable chart axis tick labels (sparse same-length array) from a dense value set",
		"Address": "fable.Math.chartTickLabels"
	},
	"movingaverage": {
		"Name": "Trailing moving average (running average of the N most recent values), nulls during warm-up; optional parallel reset-flags array restarts the window",
		"Address": "fable.Math.movingAverage"
	},
	"setdensity": {
		"Name": "Analyze ordered-set density: natural boundaries (calendar units / nice numeric steps / positions) fitting a budget",
		"Address": "fable.Math.analyzeSetDensity"
	}
}

},{}],84:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionParserLinter extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Linter';
	}

	lintTokenizedExpression(pTokenizedExpression, pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		tmpResults.LinterResults = [];

		// Guard against bad data being passed in
		if (!Array.isArray(pTokenizedExpression))
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression was passed a non-array tokenized expression.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedExpression;
		}
		if (pTokenizedExpression.length < 1)
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression was passed an empty tokenized expression.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedExpression;
		}

		// 1. Check for balanced parenthesis
		let tmpParenthesisDepth = 0;
		// If it is in a state address, we don't care about the parenthesis
		// State addresses are between squiggly brackets
		let tmpInStateAddress = false;
		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if ((pTokenizedExpression[i] === '(') && (!tmpInStateAddress))
			{
				tmpParenthesisDepth++;
			}
			if ((pTokenizedExpression[i] === ')') && (!tmpInStateAddress))
			{
				tmpParenthesisDepth--;
			}

			if (pTokenizedExpression[i] === '{')
			{
				tmpInStateAddress = true;
			}
			if (pTokenizedExpression[i] === '}')
			{
				tmpInStateAddress = false;
			}

			if (tmpParenthesisDepth < 0)
			{
				tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found an unbalanced parenthesis in the tokenized expression at token index ${i}`);
				tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			}
		}
		if (tmpParenthesisDepth > 0)
		{
			// TODO: Should we add the closing parenthesis?
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found an unbalanced parenthesis in the tokenized expression (ended without closing last set of parenthesis) -- appropriate closing parenthesis will be added.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}

		// 2. Check for balanced squiggly braces
		tmpInStateAddress = false;

		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if (pTokenizedExpression[i] === '{')
			{
				tmpInStateAddress = true;
			}
			if ((pTokenizedExpression[i] === '}') && (tmpInStateAddress))
			{
				tmpInStateAddress = false;
			}
			if ((pTokenizedExpression[i] === '}') && (!tmpInStateAddress))
			{
				tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found an unbalanced closing squiggly brace "}" in the tokenized expression at token index ${i}`);
				tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			}

			if (tmpInStateAddress)
			{
				tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found an open squiggly brace in the tokenized expression at index ${i}`);
				tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			}
		}

		// 3. Check for an equality assignment
		let tmpEqualityAssignmentCount = 0;
		let tmpEqualityAssignmentIndex = false;
		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if ((this.ExpressionParser.tokenMap[pTokenizedExpression[i]]) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type === 'Assignment'))
			{
				tmpEqualityAssignmentCount++;
				tmpEqualityAssignmentIndex = i;

				if (tmpEqualityAssignmentCount > 1)
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found multiple equality assignments in the tokenized expression; equality assignment #${tmpEqualityAssignmentCount} operator '${pTokenizedExpression[i]}' at token index ${i}.`);
					tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}
			}
		}
		if (tmpEqualityAssignmentCount < 1)
		{
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found no equality assignment in the tokenized expression.  One called Result will be added automatically.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}

		// 4. Make sure the equality assignment only has a single value on the other side of it
		//    (no, this is not a magical algebraic solver, do your own simplification)
		//    IF there is only one equality assignment (otherwise we don't even lint this because it's syntax errors all the way down)
		if (tmpEqualityAssignmentCount === 1)
		{
			// If there are exactly three tokens, make sure at least one is an assignable-ish address
			// This can still fail, but we aren't linting all the way into the manifest here; just the expression
			if (pTokenizedExpression.length === 3)
			{
				if (
					// The first token in our expression is a potentially assignable symbol
					(this.getTokenType(pTokenizedExpression[0]) === 'Token.StateAddress') || (this.getTokenType(pTokenizedExpression[2]) === 'Token.Symbol')
					// NOTE: For now we are only going to support assignment to the first symbol in the expression, which seems okay.
					// OR the last token in our expression is a potentially assignable symbol
					//|| (this.getTokenType(pTokenizedExpression[2]) === 'Token.StateAddress') || (this.getTokenType(pTokenizedExpression[0]) === 'Token.Symbol')
					)
				{
					tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found a single equality assignment in the tokenized expression with no assignable address on the left side of the assignment.`);
					tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}
			}
		}

		// 5. Check that there are no operators adjacent to each other
		//    This is a simple lint check, not a full-blown syntax check
		let tmpTokenPrevious = false;
		for (let i = 0; i < pTokenizedExpression.length - 1; i++)
		{
			if ((pTokenizedExpression[i] in this.ExpressionParser.tokenMap) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type != 'Parenthesis') && !tmpTokenPrevious)
			{
				tmpTokenPrevious = true;
			}
			else if ((pTokenizedExpression[i] in this.ExpressionParser.tokenMap) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type != 'Parenthesis'))
			{
				// If this isn't a + or - positivity/negativity multiplier, it's an error.
				if ((pTokenizedExpression[i] !== '+') && (pTokenizedExpression[i] !== '-'))
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found an ${pTokenizedExpression[i]} operator adjacent to another operator in the tokenized expression at token index ${i}`);
					tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}
			}
			else
			{
				tmpTokenPrevious = false;
			}
		}

		return tmpResults.LinterResults;
	}
}

module.exports = ExpressionParserLinter;

},{"./Fable-Service-ExpressionParser-Base.js":80}],85:[function(require,module,exports){
const { PE } = require('big.js');
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

/**
 * Represents a user-friendly messaging service for the ExpressionParser compiler output.
 * @class ExpressionParserMessaging
 * @extends libExpressionParserOperationBase
 */
class ExpressionParserMessaging extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Messaging';
	}

	getOperationVirtualSymbolName(pOperationToken)
	{
		return (pOperationToken && ('VirtualSymbolName' in pOperationToken)) ? pOperationToken.VirtualSymbolName 
			: (pOperationToken.Type === 'Token.VirtualSymbol') ? pOperationToken.Token
			: 'NO_VIRTUAL_SYMBOL_NAME_FOUND';
	}

	getVirtualTokenValue(pToken, pOperationResults)
	{
		let tmpVirtualSymbol = this.getOperationVirtualSymbolName(pToken);

		if ((pToken.Type == 'Token.Symbol' || pToken.Type == 'Token.Constant') && (pToken.Value))
		{
			return pToken.Value.toString();
		}

		let tmpVirtualSymbolData = ('VirtualSymbols' in pOperationResults) ? pOperationResults.VirtualSymbols : {};

		if (this.ExpressionParser.GenericManifest.checkAddressExists(tmpVirtualSymbolData, tmpVirtualSymbol))
		{
			let tmpValue = this.ExpressionParser.GenericManifest.getValueAtAddress(tmpVirtualSymbolData, tmpVirtualSymbol);

			if (typeof(tmpValue) === 'object')
			{
				return `{${Object.keys(tmpValue).length} values}`;
			}
			if (Array.isArray(tmpValue))
			{
				return `[${Object.keys(tmpValue).length} values]`;
			}
			return tmpValue;
		}

		return 'NO_VALUE_FOUND';
	}

	getTokenAddressString(pToken)
	{
		return pExpression.Token;
	}

	getTokenSymbolString(pExpressionToken)
	{
		return pExpressionToken.Token;
	}

	getOperationSymbolMessage(pOperation)
	{
		if (!pOperation)
		{
			return 'INVALID_OPERATION';
		}
		let tmpOperationVirtualSymbol = this.getOperationVirtualSymbolName(pOperation);
		let tmpOperationLeftValue = this.getTokenSymbolString(pOperation.LeftValue);
		let tmpOperationSymbol = this.getTokenSymbolString(pOperation.Operation);
		let tmpOperationRightValue = this.getTokenSymbolString(pOperation.RightValue);

		let tmpVirtualSymbolPrefix = tmpOperationVirtualSymbol.substring(0, 3);

		if (tmpOperationSymbol === '=')
		{
			// Assignment operators are special
			return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue}`;
		}

		if (tmpVirtualSymbolPrefix === 'VFE')
		{
			// Virtual Function Expression
			return `${tmpOperationVirtualSymbol} = ${tmpOperationSymbol}(${tmpOperationLeftValue})`;
		}

		return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue} ${tmpOperationSymbol} ${tmpOperationRightValue}`;
	}

	getOperationValueMessage(pOperation, pResultObject)
	{
		if (!pOperation)
		{
			return 'INVALID_OPERATION';
		}
		let tmpOperationVirtualSymbol = this.getOperationVirtualSymbolName(pOperation);
		let tmpOperationLeftValue = this.getVirtualTokenValue(pOperation.LeftValue, pResultObject);
		let tmpOperationSymbol = this.getTokenSymbolString(pOperation.Operation);
		let tmpOperationRightValue = this.getVirtualTokenValue(pOperation.RightValue, pResultObject);

		let tmpVirtualSymbolPrefix = tmpOperationVirtualSymbol.substring(0, 3);

		if (tmpOperationSymbol === '=')
		{
			// Assignment operators are special
			return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue}`;
		}

		if (tmpVirtualSymbolPrefix === 'VFE')
		{
			// Virtual Function Expression
			return `${tmpOperationVirtualSymbol} = ${tmpOperationSymbol}(${tmpOperationLeftValue})`;
		}

		return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue} ${tmpOperationSymbol} ${tmpOperationRightValue}`;
	}

	getOperationOutcomeMessage(pToken, pOperationResults)
	{
		if (!pToken)
		{
			return 'INVALID_TOKEN';
		}
		let tmpOperationVirtualSymbol = this.getOperationVirtualSymbolName(pToken);
		let tmpOperationOutcomeValue = this.getVirtualTokenValue(pToken, pOperationResults);

		return `${tmpOperationVirtualSymbol} = ${tmpOperationOutcomeValue}`;
	}

	logFunctionOutcome(pResultObject)
	{
		if (typeof(pResultObject) !== 'object')
		{
			this.log.error(`Solver results object was not an object.  Cannot log outcome.`);
			return;
		}
		let tmpAssignmentAddress = ('PostfixedAssignmentAddress' in pResultObject) ? pResultObject.PostfixedAssignmentAddress : 'NO_ASSIGNMENT_ADDRESS_FOUND';
		let tmpRawExpression = ('RawExpression' in pResultObject) ? pResultObject.RawExpression : 'NO_EXPRESSION_FOUND';
		let tmpRawResult = ('RawResult' in pResultObject) ? pResultObject.RawResult : 'NO_RESULT_FOUND';

		this.log.info(`Solved f(${tmpAssignmentAddress}) = {${tmpRawExpression}}`);
		for (let i = 0; i < pResultObject.PostfixSolveList.length; i++)
		{
			let tmpToken = pResultObject.PostfixSolveList[i];
			let tmpTokenSymbolMessage = this.getOperationSymbolMessage(tmpToken);
			this.log.info(`${i} Symbols: ${tmpTokenSymbolMessage}`);
			let tmpTokenValueMessage = this.getOperationValueMessage(tmpToken, pResultObject);
			this.log.info(`${i}  Values: ${tmpTokenValueMessage}`);
			let tmpTokenOutcome = this.getOperationOutcomeMessage(tmpToken, pResultObject);
			this.log.info(`${i} Outcome: ${tmpTokenOutcome}`);
		}
		this.log.info(`{${tmpRawExpression}} = ${tmpRawResult}`);
	}

	logFunctionSolve(pResultObject)
	{
		if (typeof(pResultObject) !== 'object')
		{
			this.log.error(`Solver results object was not an object.  Cannot log the solve.`);
			return;
		}
		if (!('PostfixSolveList' in pResultObject) || !Array.isArray(pResultObject.PostfixSolveList))
		{
			this.log.error(`Solver results object did not contain a PostfixSolveList array.  Cannot log the solve.`);
			return;
		}

		for (let i = 0; i < pResultObject.PostfixSolveList.length; i++)
		{
			let tmpToken = pResultObject.PostfixSolveList[i];
			console.log(`${i}: ${tmpToken.VirtualSymbolName} = (${tmpToken.LeftValue.Token}::${tmpToken.LeftValue.Value})  ${tmpToken.Operation.Token}  (${tmpToken.RightValue.Token}::${tmpToken.RightValue.Value}) `)
		}

		this.logFunctionOutcome(pResultObject);
	}
}

module.exports = ExpressionParserMessaging;

},{"./Fable-Service-ExpressionParser-Base.js":80,"big.js":17}],86:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionParserPostfix extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Postfix';
	}

	getPosfixSolveListOperation(pOperation, pLeftValue, pRightValue, pDepthSolveList, pDepthSolveIndex)
	{
		let tmpOperation = ({
			VirtualSymbolName: pOperation.VirtualSymbolName,
			Operation: pOperation,
			LeftValue: pLeftValue,
			RightValue: pRightValue
		});

		let tmpDepthSolveList = Array.isArray(pDepthSolveList) ? pDepthSolveList : false;

		/* These two if blocks are very complex -- they basically provide a
		 * way to deal with recursion that can be expressed to the user in
		 * a meaningful way.
		 * 
		 * The reason we are doing it as such is to show exactly how the
		 * solver resolves the passed-in tokens into a solvable expression.
		 */
		if (!tmpOperation.LeftValue.VirtualSymbolName)
		{
			tmpOperation.LeftValue.VirtualSymbolName = tmpOperation.VirtualSymbolName;
		}
		else
		{
			// We need to set the left value to a virtual symbol instead of the looked up value if it's already used in another operation
			if ('LeftVirtualSymbolName' in tmpOperation.Operation)
			{
				tmpOperation.LeftValue = this.getTokenContainerObject(tmpOperation.Operation.LeftVirtualSymbolName, 'Token.VirtualSymbol');
			}
			else
			{
				tmpOperation.LeftValue = this.getTokenContainerObject(tmpOperation.LeftValue.VirtualSymbolName, 'Token.VirtualSymbol');
			}
		}
		if (!tmpOperation.RightValue.VirtualSymbolName)
		{
			tmpOperation.RightValue.VirtualSymbolName = tmpOperation.VirtualSymbolName;
		}
		else
		{
			// We need to set the right value to a virtual symbol instead of the looked up value if it's already used in another operation
			//if ('LeftVirtualSymbolName' in tmpOperation.RightValue)
			if ('RightVirtualSymbolName' in tmpOperation.Operation)
			{
				tmpOperation.RightValue = this.getTokenContainerObject(tmpOperation.Operation.RightVirtualSymbolName, 'Token.VirtualSymbol');
			}
			else
			{
				tmpOperation.RightValue = this.getTokenContainerObject(tmpOperation.RightValue.VirtualSymbolName, 'Token.VirtualSymbol');
			}
		}

		tmpOperation.Operation.Parsed = true;

		return tmpOperation;
	}

	buildPostfixedSolveList(pTokenizedExpression, pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		tmpResults.PostfixedAssignmentAddress = 'Result'
		tmpResults.PostfixedAssignmentOperator = this.ExpressionParser.tokenMap['=']; // This is the default assignment operator
		tmpResults.PostfixTokenObjects = [];
		tmpResults.PostfixSolveList = [];

		if (pTokenizedExpression.length < 3)
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList was passed a tokenized expression with less than three tokens.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return tmpResults.PostfixTokenObjects;
		}

		// 1. Figure out the Equality Assignment
		let tmpEqualsIndex = -1;
		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if ((this.ExpressionParser.tokenMap[pTokenizedExpression[i]]) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type === 'Assignment'))
			{
				if (tmpEqualsIndex < 0)
				{
					tmpEqualsIndex = i;
					tmpResults.PostfixedAssignmentOperator = this.ExpressionParser.tokenMap[pTokenizedExpression[i]];
				}
				else
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found multiple assignment operators in the tokenized expression; assignment operator '${pTokenizedExpression[i]}' #${tmpEqualsIndex} at token index ${i}.`);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					return tmpResults.PostfixTokenObjects;
				}
			}
		}

		if (tmpEqualsIndex == -1)
		{
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.buildPostfixedSolveList found no equality assignment in the tokenized expression; defaulting to Result`);
			//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}
		else if (tmpEqualsIndex > 1)
		{
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.buildPostfixedSolveList found an equality assignment in the tokenized expression at an unexpected location (token index ${tmpEqualsIndex}); the expression cannot be parsed.`);
			this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}
		else if (tmpEqualsIndex === 0)
		{
			// This is an implicit function -- just go to result and return the value.
			// That is... the user entered something like "= 5 + 3" so we should just return 8, and use the default Result quietly.
		}
		else
		{
			tmpResults.PostfixedAssignmentAddress = pTokenizedExpression[0];
		}

		// 2. Categorize tokens in the expression, put them in the "expression list" as a token object
		for (let i = tmpEqualsIndex + 1; i < pTokenizedExpression.length; i++)
		{
			tmpResults.PostfixTokenObjects.push(this.getTokenContainerObject(pTokenizedExpression[i]));
		}

		// 3. Decorate mathematical parsing depth and detect functions at the same time
		//    Having written this a few times now, it's easier to detect functions *while* parsing depth.
		//    Especially if we want our system to be able to communicate with the user when there is an issue.
		let tmpDepth = 0;
		// The virtual symbol index is used for the abstract interim values that are generated at each step of the solve
		let tmpVirtualParenthesisIndex = 0;
		let tmpSolveLayerStack = [];
		// Kick off the solve layer stack with the first solve set identifier
		tmpSolveLayerStack.push(`SolveSet_${tmpVirtualParenthesisIndex}_D_${tmpDepth}`);
		for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
		{
			// 1. If it's an open parenthesis, set the parenthesis at the current depth and increment the depth
			if (tmpResults.PostfixTokenObjects[i].Token === '(')
			{
				// Set the depth of the open parenthesis to the current solution depth
				tmpResults.PostfixTokenObjects[i].Depth = tmpDepth;
				// Generate the virtual symbol name for user output
				tmpResults.PostfixTokenObjects[i].VirtualSymbolName = `Pr_${tmpVirtualParenthesisIndex}_D_${tmpDepth}`;

				// 1a. Detect if this parenthesis is signaling a function
				//     If the previous token is a Symbol (e.g. it say sin(x) or sqrt(3+5) or something) then the parser will interpret it as a function
				if (i > 0)
				{
					if (tmpResults.PostfixTokenObjects[i-1].Type === 'Token.Symbol')
					{
						// Set the type of this to be a function
						tmpResults.PostfixTokenObjects[i-1].Type = 'Token.Function';
					}
				}

				// Parenthesis manage the solve layer stack
				// For adding a new parenthesis solve layer, we put the parenthesis in the stack we are in and then make all the contained tokens be within the stack of the parenthesis
				tmpResults.PostfixTokenObjects[i].SolveLayerStack = tmpSolveLayerStack[tmpSolveLayerStack.length-1];
				tmpSolveLayerStack.push(tmpResults.PostfixTokenObjects[i].VirtualSymbolName);

				tmpVirtualParenthesisIndex++;
				tmpDepth++;
			}

			// 2. If it's a closed parenthesis, decrease the depth
			else if (tmpResults.PostfixTokenObjects[i].Token === ')')
			{
				tmpDepth--;

				tmpResults.PostfixTokenObjects[i].Depth = tmpDepth;

				// Check to see that the depth of the closed parenthesis is greater than 0
				if (tmpDepth < 0)
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a closing parenthesis at token index ${i} with no corresponding opening parenthesis.`);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}

				// Parenthesis manage the solve layer stack
				// For closing parenthesis solve layer with a close paren, we put it in the same stack as the opening parenthesis.
				// Give the closing parenthesis the same virtual symbol name as the opening parenthesis
				// (do the both above at the same time)
				tmpResults.PostfixTokenObjects[i].VirtualSymbolName = tmpSolveLayerStack.pop();
				tmpResults.PostfixTokenObjects[i].SolveLayerStack = tmpSolveLayerStack[tmpSolveLayerStack.length-1];
			}
			else
			{
				tmpResults.PostfixTokenObjects[i].Depth = tmpDepth;
				tmpResults.PostfixTokenObjects[i].SolveLayerStack = tmpSolveLayerStack[tmpSolveLayerStack.length-1];
			}
		}

		// 4. Walk through the decorated symbols and generate the postfix solve list
		//    We are going to start by creating a map of the solve layers:
		let tmpSolveLayerMap = {};
		let tmpSolveLayerMaxDepth = 0;
		for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
		{
			if (!(tmpResults.PostfixTokenObjects[i].SolveLayerStack in tmpSolveLayerMap))
			{
				tmpSolveLayerMap[tmpResults.PostfixTokenObjects[i].SolveLayerStack] = [];
			}
			tmpSolveLayerMap[tmpResults.PostfixTokenObjects[i].SolveLayerStack].push(tmpResults.PostfixTokenObjects[i]);

			// See what our max depth is.  This is super important to the postfix operation
			// The programmer in me thinks it would be funny to not track this and just use the map key length as the max size, which would work (logically impossible to have a depth > key length) but it would be quite a bit more confusing to grok the algorithm.
			if (tmpResults.PostfixTokenObjects[i].Depth > tmpSolveLayerMaxDepth)
			{
				tmpSolveLayerMaxDepth = tmpResults.PostfixTokenObjects[i].Depth;
			}
		}

		let tmpSolveLayerKeys = Object.keys(tmpSolveLayerMap);
		// Reset the virtual symbol index -- it was used above for uniquenes when creating abstract symbols for parenthesis and layer stacks.
		let tmpVirtualSymbolIndex = 0;
		tmpSolveLayerKeys.sort(
			// Sort the solve layers by depth.
			(pLeftLayer, pRightLayer)=>
			{
				// It is impossible to have a layer with no entries in it.  
				// If that ever happens, the bug is actually above and we actively want this to blow up.
				if (tmpSolveLayerMap[pLeftLayer][0].Depth < tmpSolveLayerMap[pRightLayer][0].Depth)
				{
					return 1;
				}
				if (tmpSolveLayerMap[pLeftLayer][0].Depth > tmpSolveLayerMap[pRightLayer][0].Depth)
				{
					return -1;
				}
				return 0;
			});

		// 5. Generate the postfix solve list
		//    The most important thing is going backwards in the depth order (a la reverse polish).
		//    Specifically not using shunting yard to provide in-depth "show your work" notes
		//    Yes it is possible to do a somewhat similar thing with shunting yard but the code is almost unreadable

		// 5.1 Build the Virtual Symbol Names
		// This maps layer stack addresses (which match parenthesis virtual symbol names) to the resultant value for that layer stack.
		// These values change as it solves but the last assignment is the proper assignment because math only reads forward in a line
		tmpResults.PostfixLayerstackMap = {};
		//FIXME: vet these - do we need a suffix version?
		const unaryEligibleOperationTokens = [ '+', '-' ];
		const unaryOperationPrefixTriggerTypes = [ 'Token.Operator', 'Token.Assignment' ];
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];
			// For each precedence (this isn't strictly required here but makes the outcome for the user more readable)
			for (let tmpPrecedence = 0; tmpPrecedence <= this.ExpressionParser.tokenMaxPrecedence; tmpPrecedence++)
			{
				// Enumerate all tokens in a layer's expression.
				// There is a recursive way to do this, but given the short length of even the most complex equations we're favoring readability.
				for (let i = 0; i < tmpSolveLayerTokens.length; i++)
				{
					const tmpToken = tmpSolveLayerTokens[i];
					if (unaryEligibleOperationTokens.includes(tmpToken.Token) &&
					// promote to unary if:
					// 1. we are the first token in our group
					// 2. we are prefixed by a token type that is incompatible with us being binary
						(i == 0 || unaryOperationPrefixTriggerTypes.includes(tmpSolveLayerTokens[i - 1].Type)))
					{
						//FIXME: slow, but don't break the static data
						tmpToken.Descriptor = JSON.parse(JSON.stringify(tmpToken.Descriptor));
						tmpToken.Descriptor.Precedence = 1;
					}
					//FIXME: handle operators with dynamic precedence (ex. unary vs. bunary + and -)
					// If the token is an operator and at the current precedence, add it to the postfix solve list and mutate the array.
					if ((tmpSolveLayerTokens[i].Type === 'Token.Operator') &&
						(tmpToken.Descriptor.Precedence === tmpPrecedence))
					{
						// If there is a token and nothing else in this layer, then it's an error.
						if (tmpSolveLayerTokens.length === 1)
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a single operator in a solve layer expression at token index ${i}`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}
						// The - at the beginning of an expression is a number line orientation modifier
						else if ((i == 0) && (tmpToken.Token == '-' || tmpToken.Token == '+'))
						{
							tmpToken.VirtualSymbolName = `VNLO_${tmpVirtualSymbolIndex}`;
							tmpResults.PostfixLayerstackMap[tmpToken.SolveLayerStack] = tmpToken.VirtualSymbolName;
							tmpVirtualSymbolIndex++;
						}
						// If the token is at the beginning of the expression and not a number line orientation modifier, it's an error.
						else if ((i == 0) && ((tmpToken.Token != '+') || (tmpToken.Token != '-')))
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found an operator at the beginning of a solve layer expression at token index ${i}`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}
						// If the token is at the end of the expression, it is an error.
						else if (i == tmpSolveLayerTokens.length - 1)
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found an operator at the end of a solve layer expression at token index ${i}`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}

						// The - after an operator or an open parenthesis is also a number line orientation modifier
						else if ((i > 0) && (tmpToken.Token == '-') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							// The number line negation operator is a special case that generates a virtual constant (-1.0) and multiplies it by the next token
							tmpToken.VirtualSymbolName = `VNLO_${tmpVirtualSymbolIndex}`;
							tmpVirtualSymbolIndex++;
						}
						// The + at the beginning is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i == 0) && (tmpToken.Token == '+'))
						{
							continue;
						}
						// The + after an operator or a parenthesis is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i > 0) && (tmpToken.Token == '+') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							continue;
						}

						// If the token is next to another operator it's a parsing error
						else if (((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i+1].Type === 'Token.Operator')) &&
								(tmpSolveLayerTokens[i+1].Token != '-' && tmpSolveLayerTokens[i+1].Token != '+'))
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found an operator at token index ${i} that is not surrounded by two values.`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}

						// Finally add a virtual symbol name to the dang thing.
						else
						{
							tmpToken.VirtualSymbolName = `V_${tmpVirtualSymbolIndex}`;
							tmpResults.PostfixLayerstackMap[tmpToken.SolveLayerStack] = tmpToken.VirtualSymbolName;
							tmpVirtualSymbolIndex++;
						}
					}
					else if ((tmpSolveLayerTokens[i].Type === 'Token.Function') && (tmpPrecedence === 0))
					{
						let tmpToken = tmpSolveLayerTokens[i];
						tmpToken.VirtualSymbolName = `VFE_${tmpVirtualSymbolIndex}`;
						tmpVirtualSymbolIndex++;
						tmpResults.PostfixLayerstackMap[tmpToken.SolveLayerStack] = tmpToken.VirtualSymbolName;
					}
				}
			}
		}

		// 5.15 Generate Virtual Symbol Clusters for Functions and Parenthesis
		//      ... this gets funny because of precedence of operations surrounding them, parenthesis and functions.
		let tmpFunctionCacheLIFOStack = [];
		for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
		{
			let tmpPostfixTokenObject = tmpResults.PostfixTokenObjects[i];

			if (tmpPostfixTokenObject.Type === 'Token.Parenthesis')
			{
				// This is just to track the parenthesis stack level for User feedback
				tmpPostfixTokenObject.ParenthesisStack = tmpPostfixTokenObject.VirtualSymbolName;

				// At the beginning of the  expression, this must be an open parenthesis to be legal.
				if (i == 0)
				{
					tmpPostfixTokenObject.IsFunction = false;
					let tmpVirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpPostfixTokenObject.VirtualSymbolName];
					if (!tmpVirtualSymbolName)
					{
						// ... this parenthesis group has no operators in it; make a virtual symbol name.
						tmpVirtualSymbolName = `VP_${tmpVirtualSymbolIndex}`;
						tmpVirtualSymbolIndex++;
					}
					tmpPostfixTokenObject.VirtualSymbolName = tmpVirtualSymbolName;
					tmpFunctionCacheLIFOStack.push(tmpPostfixTokenObject);
				}
				// If it's an open parenthesis
				else if (tmpPostfixTokenObject.Token === '(')
				{
					// ... supporting a function
					if (tmpResults.PostfixTokenObjects[i-1].Type === 'Token.Function')
					{
						tmpPostfixTokenObject.IsFunction = true;
						tmpPostfixTokenObject.Function = tmpResults.PostfixTokenObjects[i-1];
						let tmpVirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpPostfixTokenObject.VirtualSymbolName];
						if (!tmpVirtualSymbolName)
						{
							// ... this parenthesis group has no operators in it; make a virtual symbol name.
							tmpVirtualSymbolName = `VFP_${tmpVirtualSymbolIndex}`;
							tmpVirtualSymbolIndex++;
						}
						tmpPostfixTokenObject.VirtualSymbolName = tmpVirtualSymbolName;
					}
					else
					{
						tmpPostfixTokenObject.IsFunction = false;
						let tmpVirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpPostfixTokenObject.VirtualSymbolName];
						if (!tmpVirtualSymbolName)
						{
							// This is a parenthesis group with no operators in it; make a virtual symbol name.
							tmpVirtualSymbolName = `VP_${tmpVirtualSymbolIndex}`;
							tmpVirtualSymbolIndex++;
						}
						tmpPostfixTokenObject.VirtualSymbolName = tmpVirtualSymbolName;
					}
					tmpFunctionCacheLIFOStack.push(tmpPostfixTokenObject);
				}
				else if (tmpPostfixTokenObject.Token === ')')
				{
					let tmpOpenParenthesis = tmpFunctionCacheLIFOStack.pop();
					if (!tmpOpenParenthesis)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a closing parenthesis at token index ${i} with no corresponding opening parenthesis.`);
						continue;
					}

					if (tmpOpenParenthesis.IsFunction)
					{
						tmpPostfixTokenObject.IsFunction = true;
						tmpPostfixTokenObject.VirtualSymbolName = tmpOpenParenthesis.Function.VirtualSymbolName;
					}
					else
					{
						tmpPostfixTokenObject.IsFunction = false;
						tmpPostfixTokenObject.VirtualSymbolName = tmpOpenParenthesis.VirtualSymbolName
					}
				}
			}
		}

		// X. Postprocess the parenthesis groups to ensure they respect the order of operations for their boundaries
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpParenthesisStack = [];
			let tmpLastOperator = false;

			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];
			for (let i = 0; i < tmpSolveLayerTokens.length; i++)
			{
				let tmpPostfixTokenObject = tmpSolveLayerTokens[i];

				// Keep track of the last operator
				if (tmpPostfixTokenObject.Type === 'Token.Operator')
				{
					tmpLastOperator = tmpPostfixTokenObject;
				}

				// This is only important to do at the close parenthesis.
				if (tmpPostfixTokenObject.Type === 'Token.Function')
				{
					tmpPostfixTokenObject.PreviousOperator = tmpLastOperator;
				}
				else if ((tmpPostfixTokenObject.Type === 'Token.Parenthesis') && (tmpPostfixTokenObject.Token === '(') && tmpPostfixTokenObject.IsFunction)
				{
					tmpParenthesisStack.push(tmpPostfixTokenObject);
					if (tmpPostfixTokenObject.Function.PreviousOperator)
					{
						tmpPostfixTokenObject.PreviousOperator = tmpPostfixTokenObject.Function.PreviousOperator;
					}
				}
				else if ((tmpPostfixTokenObject.Type === 'Token.Parenthesis') && (tmpPostfixTokenObject.Token === '('))
				{
					tmpPostfixTokenObject.PreviousOperator = tmpLastOperator;
					tmpParenthesisStack.push(tmpPostfixTokenObject);
				}
				else if ((tmpPostfixTokenObject.Type === 'Token.Parenthesis') && (tmpPostfixTokenObject.Token === ')'))
				{
					// This is ultra complex, and binds the order of operations logic to the open parenthesis for the group
					let tmpOpenParenthesis = tmpParenthesisStack.pop();
					if (i < tmpSolveLayerTokens.length - 1)
					{
						for (let j = i + 1; j < tmpSolveLayerTokens.length; j++)
						{
							if (tmpSolveLayerTokens[j].Type === 'Token.Operator')
							{
								tmpOpenParenthesis.NextOperator = tmpSolveLayerTokens[j];
								break;
							}
						}
					}
					if (!tmpOpenParenthesis)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a closing parenthesis at token index ${i} with no corresponding opening parenthesis.`);
						continue;
					}

					if (tmpOpenParenthesis.PreviousOperator && tmpOpenParenthesis.NextOperator)
					{
						if (tmpOpenParenthesis.PreviousOperator.Descriptor.Precedence <= tmpOpenParenthesis.NextOperator.Descriptor.Precedence)
						{
							tmpOpenParenthesis.NextOperator.LeftVirtualSymbolName = tmpOpenParenthesis.PreviousOperator.VirtualSymbolName;
						}
						else
						{
							tmpOpenParenthesis.PreviousOperator.RightVirtualSymbolName = tmpOpenParenthesis.NextOperator.VirtualSymbolName;
						}
					}
				}
				else
				{
					if (!('SolveLayerStack' in tmpPostfixTokenObject))
					{
						// Decorate the solve layer stack for the token
						if (tmpParenthesisStack.length > 0)
						{
							tmpPostfixTokenObject.SolveLayerStack = tmpParenthesisStack[tmpParenthesisStack.length-1].SolveLayerStack;
						}
						else
						{
							tmpPostfixTokenObject.SolveLayerStack = 'Expression_Root';
						}
					}
				}
			}
		}

		// 5.2.9: Make sure the affinity of operators is respecting order of operations.
		//        Walk backwards and forwards, hoisting same value precedence backwards/forwards
		//        across each layer... the precedence change needs to be decreasing to matter
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpLastPrecedence = false;
			let tmpFinalChainToken = false;
			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];

			for (let i = tmpSolveLayerTokens.length-1; i >= 0; i--)
			{
				let tmpToken = tmpSolveLayerTokens[i];

				if (tmpToken.Type === 'Token.Operator')
				{
					if (!tmpFinalChainToken)
					{
						tmpFinalChainToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence > tmpLastPrecedence)
					{
						// This is less imporant than the last precedence, so hoist back the virtual value
						tmpToken.RightVirtualSymbolName = tmpFinalChainToken.VirtualSymbolName;
						//console.log(`Hoisting ${tmpToken.Token} back to ${tmpFinalChainToken.Token}`);
						tmpFinalChainToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence < tmpLastPrecedence)
					{
						tmpFinalChainToken = tmpToken;
					}
					tmpLastPrecedence = tmpToken.Descriptor.Precedence;
				}
			}
			let tmpDecreasingPrecedenceStack = [];
			let tmpLastToken = false;
			for (let i = tmpSolveLayerTokens.length-1; i >= 0; i--)
			{
				let tmpToken = tmpSolveLayerTokens[i];

				if (tmpToken.Type === 'Token.Operator')
				{
					if (!tmpLastToken)
					{
						tmpLastToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence > tmpLastPrecedence)
					{
						// Check and see if this needs to be resolved in the stack
						if (tmpDecreasingPrecedenceStack.length > 0)
						{
							for (let j = tmpDecreasingPrecedenceStack.length-1; j >= 0; j--)
							{
								if (tmpDecreasingPrecedenceStack[j].Descriptor.Precedence >= tmpToken.Descriptor.Precedence)
								{
									//console.log(`Hoisting ${tmpDecreasingPrecedenceStack[j].Token} up to ${tmpToken.Token}`);
									tmpDecreasingPrecedenceStack[j].LeftVirtualSymbolName = tmpToken.VirtualSymbolName;
									tmpDecreasingPrecedenceStack.slice(j, 1);
									break;
								}
							}
						}
						tmpLastToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence < tmpLastPrecedence)
					{
						tmpDecreasingPrecedenceStack.push(tmpLastToken);
						tmpLastToken = tmpToken;
					}
					tmpLastPrecedence = tmpToken.Descriptor.Precedence;
				}
			}
		}

		// 5.3: Generate the Postfix Solve List
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];

			// If this is a layer with one value, presume it's an assignment.
			if (tmpSolveLayerTokens.length === 1)
			{
				// TODO: I think this is correct but with the addition of multiple assignment operators it's less clear.
				let tmpAbstractAssignToken = this.getTokenContainerObject('=');
				tmpAbstractAssignToken.VirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpSolveLayerTokens[0].SolveLayerStack];
				// If this doesn't have a matching solvelayerstack, get the virtual symbol name from the parenthesis group it's in
				if (!tmpAbstractAssignToken.VirtualSymbolName)
				{
					for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
					{
						if (tmpResults.PostfixTokenObjects[i].ParenthesisStack === tmpSolveLayerTokens[0].SolveLayerStack)
						{
							tmpAbstractAssignToken.VirtualSymbolName = tmpResults.PostfixTokenObjects[i].VirtualSymbolName;
							break;
						}
					}
				}
				if (!tmpAbstractAssignToken.VirtualSymbolName)
				{
					tmpAbstractAssignToken.VirtualSymbolName = `V_SingleValue_${tmpVirtualSymbolIndex}`;
					tmpVirtualSymbolIndex++;
				}
				tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpAbstractAssignToken, tmpSolveLayerTokens[0], this.getTokenContainerObject('0.0')));
				continue;
			}

			// For each precedence level in the layer
			for (let tmpPrecedence = 0; tmpPrecedence <= this.ExpressionParser.tokenMaxPrecedence; tmpPrecedence++)
			{
				// Enumerate all tokens in a layer's expression.
				// There is a recursive way to do this, but given the short length of even the most complex equations we're favoring readability.
				for (let i = 0; i < tmpSolveLayerTokens.length; i++)
				{
					// If the token is an operator and at the current precedence, add it to the postfix solve list and mutate the array.
					if ((tmpSolveLayerTokens[i].Type === 'Token.Operator') &&
						(tmpSolveLayerTokens[i].Descriptor.Precedence === tmpPrecedence))
					{
						let tmpToken = tmpSolveLayerTokens[i];
						// The - at the beginning of an expression is a number line orientation modifier
						if ((i == 0) && (tmpToken.Token == '-'))
						{
							// The number line negation operator is a special case that generates a virtual constant (-1.0) and multiplies it by the next token
							// This is an abstract operation that isn't in the expression.
							let tmpAbstractMultiplyToken = this.getTokenContainerObject('*');
							tmpAbstractMultiplyToken.VirtualSymbolName = tmpToken.VirtualSymbolName;
							tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpAbstractMultiplyToken, this.getTokenContainerObject('-1.0'), tmpSolveLayerTokens[i+1]));
						}
						// The - after an operator or an open parenthesis is also a number line orientation modifier
						else if ((i > 0) && (tmpToken.Token == '-') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							// The number line negation operator is a special case that generates a virtual constant (-1.0) and multiplies it by the next token
							let tmpAbstractMultiplyToken = this.getTokenContainerObject('*');
							tmpAbstractMultiplyToken.VirtualSymbolName = tmpToken.VirtualSymbolName;
							tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpAbstractMultiplyToken, this.getTokenContainerObject('-1.0'), tmpSolveLayerTokens[i+1]));
						}
						// The + at the beginning is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i == 0) && (tmpToken.Token == '+'))
						{
							continue;
						}
						// The + after an operator or a parenthesis is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i > 0) && (tmpToken.Token == '+') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							continue;
						}

						// Finally add the dang thing.
						else
						{
							tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpToken, tmpSolveLayerTokens[i-1], tmpSolveLayerTokens[i+1], tmpSolveLayerTokens, i));
						}
					}
					else if ((tmpSolveLayerTokens[i].Type === 'Token.Function') && (tmpPrecedence === 0))
					{
						let tmpToken = tmpSolveLayerTokens[i];
						tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpToken, tmpSolveLayerTokens[i+1], this.getTokenContainerObject('0.0')));
					}
				}
			}
		}

		// 7. Lastly set the assignment address.
		let tmpAbstractAssignToken = ('PostfixedAssignmentOperator' in tmpResults) ? this.getTokenContainerObject(tmpResults.PostfixedAssignmentOperator.Token) : this.getTokenContainerObject('=');
		// The address we are assigning to
		tmpAbstractAssignToken.VirtualSymbolName = tmpResults.PostfixedAssignmentAddress;
		// The address it's coming from
		let tmpSolveResultToken = this.getTokenContainerObject('Result', 'Token.LastResult');
		let tmpFinalAssignmentInstruction = this.getPosfixSolveListOperation(tmpAbstractAssignToken, tmpSolveResultToken, this.getTokenContainerObject('SolverMarshal', 'Token.SolverMarshal'));
		tmpResults.PostfixSolveList.push(tmpFinalAssignmentInstruction);

		return tmpResults.PostfixSolveList;
	}
}

module.exports = ExpressionParserPostfix;

},{"./Fable-Service-ExpressionParser-Base.js":80}],87:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');
const libSetConcatArray = require('../Fable-SetConcatArray.js');

class ExpressionParserSolver extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Solver';
	}

	solvePostfixedExpression(pPostfixedExpression, pDataDestinationObject, pResultObject, pManifest)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		let tmpManifest = (typeof(pManifest) === 'object') ? pManifest : this.fable.newManyfest();

		let tmpDataDestinationObject = (typeof(pDataDestinationObject) === 'object') ? pDataDestinationObject : {};

		// If there was a fable passed in (e.g. the results object was a service or such), we won't decorate
		let tmpPassedInFable = ('fable' in tmpResults);
		if (!tmpPassedInFable)
		{
			tmpResults.fable = this.fable;
		}

		if (!Array.isArray(pPostfixedExpression))
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression was passed a non-array postfixed expression.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return false;
		}
		if (pPostfixedExpression.length < 1)
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression was passed an empty postfixed expression.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return false;
		}

		// This is how the user communication magic happens.
		tmpResults.VirtualSymbols = {};

		for (let i = 0; i < pPostfixedExpression.length; i++)
		{
			// X = SUM(15, SUM(SIN(25), 10), (5 + 2), 3)
			if (pPostfixedExpression[i].Operation.Type === 'Token.SolverInstruction')
			{
				continue;
			}
			let tmpStepResultObject = { ExpressionStep: pPostfixedExpression[i], ExpressionStepIndex: i, ResultsObject: tmpResults, Manifest: tmpManifest};

			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.LastResult')
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpResults.LastResult;
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.LastResult')
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpResults.LastResult;
			}

			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.VirtualSymbol')
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.LeftValue.Token);
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.VirtualSymbol')
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.RightValue.Token);
			}

			// Resolve the parenthesis to their actual values
			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.Parenthesis')
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.LeftValue.VirtualSymbolName);
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.Parenthesis')
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.RightValue.VirtualSymbolName);
			}

			// Virtual Constants
			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.Constant' && !('Value' in tmpStepResultObject.ExpressionStep.LeftValue))
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpStepResultObject.ExpressionStep.LeftValue.Token;
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.Constant' && !('Value' in tmpStepResultObject.ExpressionStep.RightValue))
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpStepResultObject.ExpressionStep.RightValue.Token;
			}

			if (tmpStepResultObject.ExpressionStep.Operation.Type = 'Operator')
			{
				// TODO: This can be optimized.   A lot.  If necessary.  Seems pretty fast honestly for even thousands of operations.  Slowest part is arbitrary precision.
				// An operator always has a left and right value.
				let tmpFunctionAddress;
				// Note: There are easier, passive ways of managing this state.  But this is complex.
				let tmpIsFunction = false;
				if (tmpStepResultObject.ExpressionStep.Operation.Token in this.ExpressionParser.tokenMap)
				{
					tmpFunctionAddress = `ResultsObject.${tmpStepResultObject.ExpressionStep.Operation.Descriptor.Function}`;
				}
				else if (tmpStepResultObject.ExpressionStep.Operation.Token.toLowerCase() in this.ExpressionParser.functionMap)
				{
					tmpIsFunction = true;
					tmpFunctionAddress = `ResultsObject.${this.ExpressionParser.functionMap[tmpStepResultObject.ExpressionStep.Operation.Token.toLowerCase()].Address}`;
				}

				if (tmpIsFunction)
				{
					try
					{
						let tmpResult;
						const tmpFunction = tmpManifest.getValueAtAddress(tmpStepResultObject, tmpFunctionAddress);
						if (typeof tmpFunction === 'function')
						{
							let tmpFunctionBinding = null;
							if (tmpFunctionAddress.includes('.'))
							{
								tmpFunctionBinding = tmpManifest.getValueAtAddress(tmpStepResultObject, tmpFunctionAddress.split('.').slice(0, -1).join('.'));
							}
							let tmpArguments = tmpStepResultObject.ExpressionStep.LeftValue.Value;
							if (!(tmpArguments instanceof libSetConcatArray))
							{
								tmpArguments = [ tmpArguments ];
							}
							else
							{
								tmpArguments = tmpArguments.values;
							}
							tmpResult = tmpFunction.apply(tmpFunctionBinding, tmpArguments);
						}
						tmpManifest.setValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName, tmpResult);
						tmpResults.LastResult = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName);
						//this.log.trace(`   ---> Step ${i}: ${tmpResults.VirtualSymbols[tmpStepResultObject.ExpressionStep.VirtualSymbolName]}`)
					}
					catch (pError)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression failed to solve step ${i} with function ${tmpStepResultObject.ExpressionStep.Operation.Token}: ${pError}`);
						this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1], { Stack: pError.stack });
						return false;
					}
				}
				else
				{
					try
					{
						//this.log.trace(`Solving Step ${i} [${tmpStepResultObject.ExpressionStep.VirtualSymbolName}] --> [${tmpStepResultObject.ExpressionStep.Operation.Token}]: ( ${tmpStepResultObject.ExpressionStep.LeftValue.Value} , ${tmpStepResultObject.ExpressionStep.RightValue.Value} )`);
						tmpManifest.setValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName, tmpManifest.getValueAtAddress(tmpStepResultObject, `${tmpFunctionAddress}(ExpressionStep.LeftValue.Value,ExpressionStep.RightValue.Value)`));
						tmpResults.LastResult = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName);
						//this.log.trace(`   ---> Step ${i}: ${tmpResults.VirtualSymbols[tmpStepResultObject.ExpressionStep.VirtualSymbolName]}`)
					}
					catch (pError)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression failed to solve step ${i} with function ${tmpStepResultObject.ExpressionStep.Operation.Token}: ${pError}`);
						this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1], { Stack: pError.stack });
						return false;
					}
				}

				// Equations don't always solve in virtual symbol order.
				tmpResults.SolverFinalVirtualSymbol = tmpStepResultObject.ExpressionStep.VirtualSymbolName;
			}
		}

		let tmpSolverResultValue = tmpManifest.getValueAtAddress(tmpResults, `VirtualSymbols.${tmpResults.SolverFinalVirtualSymbol}`);

		// Now deal with final assignment(s)
		for (let i = 0; i < pPostfixedExpression.length; i++)
		{
			if (pPostfixedExpression[i].RightValue.Type === 'Token.SolverMarshal')
			{
				// Set the result in the virtual symbols
				tmpManifest.setValueAtAddress(tmpResults.VirtualSymbols, pPostfixedExpression[i].VirtualSymbolName, tmpSolverResultValue);
				// Set the value in the destination object
				if (pPostfixedExpression[i].Operation.Descriptor.OnlyEmpty)
				{
					// If it is only on "empty" values, check if the value is empty before assigning
					if (this.fable.Utility.addressIsNullOrEmpty(tmpDataDestinationObject, pPostfixedExpression[i].VirtualSymbolName))
					{
						tmpManifest.setValueByHash(tmpDataDestinationObject, pPostfixedExpression[i].VirtualSymbolName, tmpSolverResultValue);
					}
				}
				else
				{
					// Otherwise, just assign it.
					tmpManifest.setValueByHash(tmpDataDestinationObject, pPostfixedExpression[i].VirtualSymbolName, tmpSolverResultValue);
				}
			}
		}
		tmpResults.RawResult = tmpSolverResultValue;

		// Clean up the fable reference if we added it to the object.
		if (!tmpPassedInFable)
		{
			delete tmpResults.fable;
		}

		if (typeof(tmpSolverResultValue) === 'object')
		{
			return tmpSolverResultValue;
		}
		else if (typeof(tmpSolverResultValue) !== 'undefined')
		{
			return tmpSolverResultValue.toString();
		}
		else
		{
			return tmpSolverResultValue;
		}
	}
}

module.exports = ExpressionParserSolver;

},{"../Fable-SetConcatArray.js":104,"./Fable-Service-ExpressionParser-Base.js":80}],88:[function(require,module,exports){
module.exports={
	"=":
		{
			"Name": "Assign Value",
			"Token": "=",
			"Function": "fable.Math.assignValue",
			"Precedence": 0,
			"Type": "Assignment"
		},

	":":
		{
			"Name": "Expression Begin",
			"Token": ":",
			"Function": "fable.Math.expressionBegin",
			"Precedence": 0,
			"Type": "Assignment"
		},

	"?=":
		{
			"Name": "Null or Empty Coalescing Assign Value",
			"Token": "?=",
			"Function": "fable.Math.assignValue",
			"OnlyEmpty": true,
			"Precedence": 0,
			"Type": "Assignment"
		},

	"(":
		{
			"Name": "Left Parenthesis",
			"Token": "(",
			"Precedence": 0,
			"Type": "Parenthesis"
		},
	")":
		{
			"Name": "Right Parenthesis",
			"Token": ")",
			"Precedence": 0,
			"Type": "Parenthesis"
		},
	",":
		{
			"Name": "Set Concatenate",
			"Token": ",",
			"Function": "fable.Math.setConcatenate",
			"Precedence": 6,
			"Type": "Operator"
		},

	"*":
		{
			"Name": "Multiply",
			"Token": "*",
			"Function": "fable.Math.multiplyPrecise",
			"Precedence": 3,
			"Type": "Operator"
		},
	"/":
		{
			"Name": "Divide",
			"Token": "/",
			"Function": "fable.Math.dividePrecise",
			"Precedence": 3,
			"Type": "Operator"
		},

	"^":
		{
			"Name": "Exponent",
			"Token": "^",
			"Function": "fable.Math.powerPrecise",
			"Precedence": 2,
			"Type": "Operator"
		},
	"%":
		{
			"Name": "Modulus",
			"Token": "%",
			"Function": "fable.Math.modPrecise",
			"Precedence": 3,
			"Type": "Operator"
		},

	"+":
		{
			"Name": "Add",
			"Token": "+",
			"Function": "fable.Math.addPrecise",
			"Precedence": 4,
			"Type": "Operator"
		},
	"-":
		{
			"Name": "Subtract",
			"Token": "-",
			"Function": "fable.Math.subtractPrecise",
			"Precedence": 4,
			"Type": "Operator"
		},

	">":
		{
			"Name": "Greater Than",
			"Token": ">",
			"Function": "fable.Math.greaterThanOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	">=":
		{
			"Name": "Greater Than or Equal",
			"Token": ">=",
			"Function": "fable.Math.greaterThanOrEqualOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"<":
		{
			"Name": "Less Than",
			"Token": "<",
			"Function": "fable.Math.lessThanOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"<=":
		{
			"Name": "Less Than or Equal",
			"Token": "<=",
			"Function": "fable.Math.lessThanOrEqualOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"==":
		{
			"Name": "Equal",
			"Token": "==",
			"Function": "fable.Math.equalOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"!=":
		{
			"Name": "Not Equal",
			"Token": "!=",
			"Function": "fable.Math.notEqualOperator",
			"Precedence": 5,
			"Type": "Operator"
		},

	"?":
		{
			"Name": "Ternary Condition",
			"Token": "?",
			"Precedence": 0,
			"Type": "Ternary"
		},
	"::":
		{
			"Name": "Ternary Separator",
			"Token": "::",
			"Precedence": 0,
			"Type": "Ternary"
		}
}

},{}],89:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionParserValueMarshal extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-ValueMarshal';
	}

	/**
	 * Substitutes values in tokenized objects based on the provided data source and manifest.
	 *
	 * TODO: Move this to its own file in the "Fable-Service-ExpressionParser" directory.
	 *
	 * @param {Array} pTokenizedObjects - The array of tokenized objects.
	 * @param {Object} pDataSource - The data source object where we pull values from.
	 * @param {Object} pResultObject - The result object where the algorithm shows its work.
	 * @param {Object} pManifest - The manifest object to use for hash resolution.
	 * @returns {Array} - The modified tokenized objects array.
	 */
	substituteValuesInTokenizedObjects(pTokenizedObjects, pDataSource, pResultObject, pManifest)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		if (!Array.isArray(pTokenizedObjects))
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.substituteValuesInTokenizedObjects was passed a non-array tokenized object list.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedObjects;
		}
		if (typeof(pDataSource) !== 'object')
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.substituteValuesInTokenizedObjects either was passed no data source, or was passed a non-object data source.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedObjects;
		}

		let tmpDataSource = pDataSource;

		let tmpManifest = (typeof(pManifest) == 'object') ? pManifest : this.fable.newManyfest(pManifest);

		for (let i = 0; i < pTokenizedObjects.length; i++)
		{
			if (typeof(pTokenizedObjects[i]) !== 'object')
			{
				tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.substituteValuesInTokenizedObjects found a non-object tokenized object at index ${i}`);
				this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				continue;
			}
			let tmpToken = pTokenizedObjects[i];
			if ((pTokenizedObjects[i].Type === 'Token.Symbol') && !tmpToken.Resolved)
			{
				// Symbols always look up values by hash first
				let tmpValue = tmpManifest.getValueByHash(tmpDataSource, tmpToken.Token);
				// if (!tmpValue)
				// {
				// 	// If no hash resolves, try by address.
				// 	tmpValue = tmpManifest.getValueAtAddress(tmpToken.Token, tmpDataSource);
				// }
				if (tmpValue == null)
				{
					tmpToken.Value = tmpValue;
					tmpToken.Resolve = true;
					tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.substituteValuesInTokenizedObjects found no value for the symbol hash or address ${tmpToken.Token} at index ${i}`);
					if (this.LogNoisiness > 1) this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					continue;
				}
				else
				{
					tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpValue}] for the state address ${tmpToken.Token} at index ${i}`);
					if (this.LogNoisiness > 1) this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					if (typeof tmpValue === 'object') // this encapsulates POJOs and arrays
					{
						// this must be checked first, which works around an edge case where bigNumber turns single-element arrays into numbers, which we never want
						tmpToken.Resolved = true;
						tmpToken.Value = tmpValue;
					}
					else
					{
						try
						{
							const tmpValueParsed = new this.fable.Utility.bigNumber(tmpValue);
							tmpToken.Resolved = true;
							tmpToken.Value = tmpValueParsed.toString();
						}
						catch(pError)
						{
							// TODO: Should we allow this to be a function?  Good god the complexity and beauty of that...
							tmpToken.Resolved = true;
							tmpToken.Value = tmpValue;
							tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a non-numeric value for the state address ${tmpToken.Token} at index ${i}; using raw value.`);
							//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
						}
					}
				}
			}
			if ((pTokenizedObjects[i].Type === 'Token.StateAddress') && !tmpToken.Resolved)
			{
				// Symbols are always hashes.  This gracefully works for simple shallow objects because hashes default to the address in Manyfest.
				// Sometimes the token is wrapped in {} to indicate it's a direct address reference... we need to strip those off.
				// e.g., {0x1234abcd...}
				// So we need to strip off the {} if they exist.
				let tmpAddress = tmpToken.Token;
				if ((tmpAddress.startsWith('{')) && (tmpAddress.endsWith('}')))
				{
					tmpAddress = tmpAddress.substring(1, tmpAddress.length-1);
				}
				let tmpValue = tmpManifest.getValueAtAddress(tmpDataSource, tmpAddress);
				if (tmpValue == null)
				{
					tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.substituteValuesInTokenizedObjects found no value for the state address ${tmpToken.Token} at index ${i}`);
					//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					continue;
				}
				else
				{
					//tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpValue}] for the state address ${tmpToken.Token} at index ${i}`);
					//this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					try
					{
						let tmpValueParsed = new this.fable.Utility.bigNumber(tmpValue);
						tmpToken.Resolved = true;
						tmpToken.Value = tmpValueParsed.toString();
					}
					catch(pError)
					{
						// TODO: Should we allow this to be a function?  Good god the complexity and beauty of that...
						tmpToken.Resolved = true;
						tmpToken.Value = tmpValue;
						tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a non-numeric value for the state address ${tmpToken.Token} at index ${i}; using raw value.`);
						//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					}
				}
			}
			if ((pTokenizedObjects[i].Type === 'Token.String') && !tmpToken.Resolved)
			{
				tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpToken.Token}] for the string ${tmpToken.Token} at index ${i}`);
				if (this.LogNoisiness > 1) this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				tmpToken.Resolved = true;
				// Take the quotes off the string
				tmpToken.Value = tmpToken.Token.substring(1, tmpToken.Token.length-1);
			}
			if ((pTokenizedObjects[i].Type === 'Token.Constant') && !tmpToken.Resolved)
			{
				tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpToken.Token}] for the constant ${tmpToken.Token} at index ${i}`);
				if (this.LogNoisiness > 1) this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				try
				{
					let tmpValueParsed = new this.fable.Utility.bigNumber(tmpToken.Token);
					tmpToken.Resolved = true;
					tmpToken.Value = tmpValueParsed.toString();
				}
				catch(pError)
				{
					// This constant has the right symbols but apparently isn't a parsable number.
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.substituteValuesInTokenizedObjects found a non-numeric value for the state address ${tmpToken.Token} at index ${i}`);
					//this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					tmpToken.Resolved = false;
				}
			}
		}

		return pTokenizedObjects;
	}
}

module.exports = ExpressionParserValueMarshal;

},{"./Fable-Service-ExpressionParser-Base.js":80}],90:[function(require,module,exports){
(function (process){(function (){
const libFableServiceBase = require('fable-serviceproviderbase');

const libFS = require('fs');
const libPath = require('path');
const libReadline = require('readline');


class FableServiceFilePersistence extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'FilePersistence';

		if (!('Mode' in this.options))
		{
			this.options.Mode = parseInt('0777', 8) & ~process.umask();
		}

		this.libFS = libFS;
		this.libPath = libPath;
		this.libReadline = libReadline;
	}

	joinPath(...pPathArray)
	{
		// TODO: Fix anything that's using this before changing this to the new true node join
		// return libPath.join(...pPathArray);
		return libPath.resolve(...pPathArray);
	}

	resolvePath(...pPathArray)
	{
		return libPath.resolve(...pPathArray);
	}

	existsSync(pPath)
	{
		return libFS.existsSync(pPath);
	}

	exists(pPath, fCallback)
	{
		let tmpFileExists = this.existsSync(pPath);
		return fCallback(null, tmpFileExists);
	}

	deleteFileSync(pFileName)
	{
		return libFS.unlinkSync(pFileName);
	}

	deleteFolderSync(pFileName)
	{
		return libFS.rmdirSync(pFileName);
	}

	readFileSync(pFilePath, pOptions)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.readFileSync(pFilePath, tmpOptions);
	}

	readFile(pFilePath, pOptions, fCallback)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.readFile(pFilePath, tmpOptions, fCallback);
	}

	readFileCSV(pFilePath, pOptions, fRecordFunction, fCompleteFunction, fErrorFunction)
	{
		let tmpCSVParser = this.fable.instantiateServiceProviderWithoutRegistration('CSVParser', pOptions);
		let tmpRecordFunction = (typeof(fRecordFunction) === 'function') ? fRecordFunction :
			(pRecord) =>
			{
				this.fable.log.trace(`CSV Reader received line ${pRecord}`);
			};
		let tmpCompleteFunction = (typeof(fCompleteFunction) === 'function') ? fCompleteFunction :
			() =>
			{
				this.fable.log.info(`CSV Read of ${pFilePath} complete.`);
			};
		let tmpErrorFunction = (typeof(fErrorFunction) === 'function') ? fErrorFunction :
			(pError) =>
			{
				this.fable.log.error(`CSV Read of ${pFilePath} Error: ${pError}`, pError);
			};

		return this.lineReaderFactory(pFilePath,
			(pLine) =>
			{
				let tmpRecord = tmpCSVParser.parseCSVLine(pLine);
				if (tmpRecord)
				{
					tmpRecordFunction(tmpRecord, pLine);
				}
			}, tmpCompleteFunction, tmpErrorFunction);
	}

	appendFileSync(pFileName, pAppendContent, pOptions)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.appendFileSync(pFileName, pAppendContent, tmpOptions);
	}

	writeFileSync(pFileName, pFileContent, pOptions)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.writeFileSync(pFileName, pFileContent, tmpOptions);
	}

	writeFileSyncFromObject(pFileName, pObject)
	{
		return this.writeFileSync(pFileName, JSON.stringify(pObject, null, 4));
	}

	writeFileSyncFromArray(pFileName, pFileArray)
	{
		if (!Array.isArray(pFileArray))
		{
			this.log.error(`File Persistence Service attempted to write ${pFileName} from array but the expected array was not an array (it was a ${typeof(pFileArray)}).`);
			return Error('Attempted to write ${pFileName} from array but the expected array was not an array (it was a ${typeof(pFileArray)}).');
		}
		else
		{
			for (let i = 0; i < pFileArray.length; i++)
			{
				return this.appendFileSync(pFileName, `${pFileArray[i]}\n`);
			}
		}
	}

	writeFile(pFileName, pFileContent, pOptions, fCallback)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.writeFile(pFileName, pFileContent, tmpOptions, fCallback);
	}

	lineReaderFactory(pFilePath, fOnLine, fOnComplete, fOnError)
	{
		let tmpLineReader = {};

		if (typeof(pFilePath) != 'string')
		{
			return false;
		}

		tmpLineReader.filePath = pFilePath;

		tmpLineReader.fileStream = libFS.createReadStream(tmpLineReader.filePath);

		tmpLineReader.reader = libReadline.createInterface({ input: tmpLineReader.fileStream, crlfDelay: Infinity });

		if (typeof(fOnError) === 'function')
		{
			tmpLineReader.reader.on('error', fOnError);
		}

		tmpLineReader.reader.on('line', (typeof(fOnLine) === 'function') ? fOnLine : () => {});

		if (typeof(fOnComplete) === 'function')
		{
			tmpLineReader.reader.on('close', fOnComplete);
		}

		return tmpLineReader;
	}

	// Folder management
	makeFolderRecursive(pParameters, fCallback)
	{
		let tmpParameters = pParameters;

		if (typeof(pParameters) == 'string')
		{
			tmpParameters = { Path: pParameters };
		}
		else if (typeof(pParameters) !== 'object')
		{
			fCallback(new Error('Parameters object or string not properly passed to recursive folder create.'));
			return false;
		}

		if ((typeof(tmpParameters.Path) !== 'string'))
		{
			fCallback(new Error('Parameters object needs a path to run the folder create operation.'));
			return false;
		}

		if (!('Mode' in tmpParameters))
		{
			tmpParameters.Mode = this.options.Mode;
		}

		// Check if we are just starting .. if so, build the initial state for our recursive function
		if (typeof(tmpParameters.CurrentPathIndex) === 'undefined')
		{
			// Build the tools to start recursing
			tmpParameters.ActualPath = libPath.normalize(tmpParameters.Path);
			tmpParameters.ActualPathParts = tmpParameters.ActualPath.split(libPath.sep);
			tmpParameters.CurrentPathIndex = 0;
			tmpParameters.CurrentPath = '';
		}
		else
		{
			// This is not our first run, so we will continue the recursion.
			// Build the new base path
			if (tmpParameters.CurrentPath == libPath.sep)
			{
				tmpParameters.CurrentPath = tmpParameters.CurrentPath + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex];
			}
			else
			{
				tmpParameters.CurrentPath = tmpParameters.CurrentPath + libPath.sep + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex];
			}

			// Increment the path index
			tmpParameters.CurrentPathIndex++;
		}

		// Check if the path is fully complete
		if (tmpParameters.CurrentPathIndex >= tmpParameters.ActualPathParts.length)
		{
			return fCallback(null);
		}

		// Check if the path exists (and is a folder)
		libFS.open(tmpParameters.CurrentPath + libPath.sep + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex], 'r',
			(pError, pFileDescriptor)=>
			{
				if (pFileDescriptor)
				{
					libFS.closeSync(pFileDescriptor);
				}

				if (pError && pError.code=='ENOENT')
				{
					/* Path doesn't exist, create it */
					libFS.mkdir(tmpParameters.CurrentPath + libPath.sep + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex], tmpParameters.Mode,
						(pCreateError) =>
						{
							if (!pCreateError)
							{
								// We have now created our folder and there was no error -- continue.
								return this.makeFolderRecursive(tmpParameters, fCallback);
							}
							else if (pCreateError.code =='EEXIST')
							{
								// The folder exists -- our dev might be running this in parallel/async/whatnot.
								return this.makeFolderRecursive(tmpParameters, fCallback);
							}
							else
							{
								console.log(pCreateError.code);
								return fCallback(pCreateError);
							}
						});
				}
				else
				{
					return this.makeFolderRecursive(tmpParameters, fCallback);
				}
			});
	}
}

module.exports = FableServiceFilePersistence;

}).call(this)}).call(this,require('_process'))

},{"_process":439,"fable-serviceproviderbase":59,"fs":19,"path":145,"readline":19}],91:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceLogic extends libFableServiceBase
{
	/**
	 * @param {import('../Fable.js')} pFable - The fable object
	 * @param {Record<string, any>} [pOptions] - The options object
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Find the first value in an object that contains a specific value
	 *
	 * @param {string|number} pLeft - The left value to check
	 * @param {string} pComparisonOperator - The comparison operator to use
	 * @param {string|number} pRight - The right value to check
	 * @param {any} pOnTrue - The value to return if the comparison is true
	 * @param {any} [pOnFalse = ''] - The value to return if the comparison is false
	 * @return {any} - The selected value
	 */
	checkIf(pLeft, pComparisonOperator, pRight, pOnTrue, pOnFalse)
	{
		// precise numeric
		// string (non-numeric)
		let tmpMathLeft = this.fable.Math.parsePrecise(pLeft, null);
		let tmpMathRight = this.fable.Math.parsePrecise(pRight, null);
		let tmpCheckResult = false;
		if (tmpMathLeft === null || tmpMathRight === null)
		{
			if (typeof pOnFalse === 'undefined')
			{
				pOnFalse = '';
			}
			switch (pComparisonOperator)
			{
				case '<':
				case 'LT':
					tmpCheckResult = pLeft < pRight;
					break;
				case '<=':
				case 'LTE':
					tmpCheckResult = pLeft <= pRight;
					break;
				case '>':
				case 'GT':
					tmpCheckResult = pLeft > pRight;
					break;
				case '>=':
				case 'GTE':
					tmpCheckResult = pLeft >= pRight;
					break;
				case '==':
					tmpCheckResult = pLeft == pRight;
					break;
				case '===':
					tmpCheckResult = pLeft === pRight;
					break;
				default:
					this.fable.log.warn(`[FableServiceLogic.checkIf] Invalid comparison operator: ${pComparisonOperator}`);
					tmpCheckResult = pLeft == pRight;
			}
		}
		else
		{
			if (typeof pOnFalse === 'undefined')
			{
				pOnFalse = '0';
			}
			switch (pComparisonOperator)
			{
				case '<':
				case 'LT':
					tmpCheckResult = this.fable.Math.ltPrecise(tmpMathLeft, tmpMathRight);
					break;
				case '<=':
				case 'LTE':
					tmpCheckResult = this.fable.Math.ltePrecise(tmpMathLeft, tmpMathRight);
					break;
				case '>':
				case 'GT':
					tmpCheckResult = this.fable.Math.gtPrecise(tmpMathLeft, tmpMathRight);
					break;
				case '>=':
				case 'GTE':
					tmpCheckResult = this.fable.Math.gtePrecise(tmpMathLeft, tmpMathRight);
					break;
				case '==':
					tmpCheckResult = this.fable.Math.comparePreciseWithin(tmpMathLeft, tmpMathRight, '0.000001') == 0;
					break;
				case '===':
					tmpCheckResult = this.fable.Math.comparePrecise(tmpMathLeft, tmpMathRight) == 0;
					break;
				default:
					this.fable.log.warn(`[FableServiceLogic.checkIf] Invalid comparison operator: ${pComparisonOperator}`);
					tmpCheckResult = pLeft == pRight ? pOnTrue : pOnFalse;
			}
		}
		return tmpCheckResult ? pOnTrue : pOnFalse;
	}

	/**
	 * Find the first value in an object that contains a specific value
	 *
	 * @param {any} pCheckForTruthy - The object to check
	 * @param {any} pOnTrue - The value to return if the object is truthy
	 * @param {any} [pOnFalse = ''] - The value to return if the object is falsy
	 * @return {any} - The value from the object
	 */
	when(pCheckForTruthy, pOnTrue, pOnFalse = '')
	{
		if (!pCheckForTruthy)
		{
			return pOnFalse;
		}
		if (Array.isArray(pCheckForTruthy) && pCheckForTruthy.length < 1)
		{
			return pOnFalse;
		}
		if (typeof pCheckForTruthy === 'object' && Object.keys(pCheckForTruthy).length < 1)
		{
			return pOnFalse;
		}
		return pOnTrue;
	}

	/**
	 * Numeric-aware ternary selection for the expression parser.
	 * Treats 0, "0", "", null, undefined, false, NaN, empty arrays, and empty objects as falsy.
	 * Used by the ternary operator desugaring (condition ? trueVal :: falseVal).
	 *
	 * @param {any} pCondition - The condition to evaluate
	 * @param {any} pOnTrue - The value to return if the condition is truthy
	 * @param {any} [pOnFalse = ''] - The value to return if the condition is falsy
	 * @return {any} - The selected value
	 */
	ternary(pCondition, pOnTrue, pOnFalse = '')
	{
		// Standard JS falsy check
		if (!pCondition)
		{
			return pOnFalse;
		}
		// Numeric zero as a string (from comparison operators returning "0")
		if (pCondition === '0')
		{
			return pOnFalse;
		}
		if (Array.isArray(pCondition) && pCondition.length < 1)
		{
			return pOnFalse;
		}
		if (typeof pCondition === 'object' && Object.keys(pCondition).length < 1)
		{
			return pOnFalse;
		}
		return pOnTrue;
	}
}

module.exports = FableServiceLogic;

},{"fable-serviceproviderbase":59}],92:[function(require,module,exports){
/**
 * @file Fable-Service-Math.js
 * @description This file contains the implementation of the FableServiceMath class, which provides simple functions for performing arbitrary precision math operations.
 * @module FableServiceMath
 * @extends libFableServiceBase
 */
const libFableServiceBase = require('fable-serviceproviderbase');
const libSetConcatArray = require('./Fable-SetConcatArray.js');

/**
 * Arbitrary Precision Math Operations
 * @author      Steven Velozo <steven@velozo.com>
 * @description Simple functions that perform arbitrary precision math operations and return string resultant values.  Wraps big.js
 * @class FableServiceMath
 * @extends libFableServiceBase
 */
class FableServiceMath extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'Math';

		this.pi = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679';
		// From NASA: https://apod.nasa.gov/htmltest/gifcity/e.2mil
		this.euler = '2.7182818284590452353602874713526624977572470936999595749669676277240766303535475945713821785251664';
		this.errorReturnValue = NaN;

		//		this.manifest = this.fable.newManyfest();
		this.bigNumber = this.fable.Utility.bigNumber;

		this.ln2Cache = new Map();
	}

	/*
		Pass-through Rounding Method Constants

		Property	   Value   BigDecimal Equiv   Description
		----------     -----   ----------------   -----------
		roundDown      0       ROUND_DOWN         Rounds towards zero. (_I.e. truncate, no rounding._)
		roundHalfUp    1       ROUND_HALF_UP      Rounds towards nearest neighbour. (_If equidistant, rounds away from zero._)
		roundHalfEven  2       ROUND_HALF_EVEN    Rounds towards nearest neighbour. (_If equidistant, rounds towards even neighbour._)
		roundUp        3       ROUND_UP           Rounds positively away from zero. (_Always round up._)
	*/
	get roundDown() { return this.bigNumber.roundDown; }
	get roundHalfUp() { return this.bigNumber.roundHalfUp; }
	get roundHalfEven() { return this.bigNumber.roundHalfEven; }
	get roundUp() { return this.bigNumber.roundUp; }

	/**
	 * Parses a precise number value.
	 *
	 * @param {number} pValue - The value to parse.
	 * @param {any} pNonNumberValue - The value to use if parsing fails.
	 * @returns {string} - The parsed number as a string.
	 */
	parsePrecise(pValue, pNonNumberValue)
	{
		let tmpNumber;

		try
		{
			tmpNumber = new this.bigNumber(pValue);
		}
		catch (pError)
		{
			// TODO: This seems more correct -- we can add a silent or noisy parameter if we want this to export.
			//       Reason: Currently this is absolutely obliterating logs in the data integrations from bad data sources.
			//this.log.warn(`Error parsing number (type ${typeof (pValue)}): ${pError}`);
			tmpNumber = (typeof (pNonNumberValue) === 'undefined') ? "0.0" : pNonNumberValue;
		}

		return tmpNumber ? tmpNumber.toString() : tmpNumber;
	}

	/**
	 * Assigns the given value.  For equals operations in the solver.
	 * @param {*} pValue - The value to be assigned.
	 * @returns {*} The assigned value.
	 */
	assignValue(pValue)
	{
		return pValue;
	}

	/**
	 * Begins an expression with the given value. For performing colon operations in the solver.
	 * @param {*} pValue - The value to begin the expression with.
	 * @returns {*} The begun expression value.
	 */
	expressionBegin(pValue)
	{
		return pValue;
	}

	/**
	 * Calculates the precise percentage of a given value compared to another value.
	 *
	 * @param {number} pIs - The value to calculate the percentage of.
	 * @param {number} pOf - The value to calculate the percentage against.
	 * @returns {string} The precise percentage as a string.
	 */
	percentagePrecise(pIs, pOf)
	{
		let tmpLeftValue = isNaN(pIs) ? 0 : pIs;
		let tmpRightValue = isNaN(pOf) ? 0 : pOf;

		if (tmpRightValue == 0)
		{
			return '0';
		}

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.div(tmpRightValue);
		tmpResult = tmpResult.times(100);
		return tmpResult.toString();
	}

	/**
	 * Concatenates two value sets and returns the result as a string.
	 *
	 * Value sets are comma separated.
	 *
	 * Used for arbitrary precision set generation.
	 *
	 * @param {any} pLeftValue - The left value to append.
	 * @param {any} pRightValue - The right value to append.
	 * @returns {InstanceType<libSetConcatArray>} The concatenated string of the left and right values.
	 */
	setConcatenate(pLeftValue, pRightValue)
	{
		return new libSetConcatArray(pLeftValue, pRightValue);
	}

	/**
	 * Rounds a value to a specified number of decimal places using a specified rounding method.
	 *
	 * @param {number} pValue - The value to be rounded.
	 * @param {number} pDecimals - The number of decimal places to round to.
	 * @param {function} [pRoundingMethod] - The rounding method to use. Defaults to `this.roundHalfUp`.
	 * @returns {string} - The rounded value as a string.
	 */
	roundPrecise(pValue, pDecimals, pRoundingMethod)
	{
		let tmpValue = pValue === false || isNaN(pValue) ? 0 : pValue;
		let tmpDecimals = isNaN(pDecimals) ? 0 : parseInt(pDecimals, 10);
		let tmpRoundingMethod = (typeof (pRoundingMethod) === 'undefined') ? this.roundHalfUp : parseInt(pRoundingMethod, 10);

		try
		{
			let tmpArbitraryValue = new this.bigNumber(tmpValue);
			let tmpResult = tmpArbitraryValue.round(tmpDecimals, tmpRoundingMethod);
			return tmpResult.toString();
		}
		catch
		{
			return this.errorReturnValue;
		}
	}

	/**
	 * Returns a string representation of a number with a specified number of decimals.
	 *
	 * @param {number} pValue - The number to be formatted.
	 * @param {number} pDecimals - The number of decimals to include in the formatted string.
	 * @param {string} [pRoundingMethod] - The rounding method to use. Defaults to 'roundHalfUp'.
	 * @returns {string} - The formatted number as a string.
	 */
	toFixedPrecise(pValue, pDecimals, pRoundingMethod)
	{
		let tmpValue = pValue === false || isNaN(pValue) ? 0 : pValue;
		let tmpDecimals = isNaN(pDecimals) ? 0 : parseInt(pDecimals, 10);
		let tmpRoundingMethod = (typeof (pRoundingMethod) === 'undefined') ? this.roundHalfUp : pRoundingMethod;

		try
		{
			let tmpArbitraryValue = new this.bigNumber(tmpValue);
			let tmpResult = tmpArbitraryValue.toFixed(tmpDecimals, tmpRoundingMethod);
			return tmpResult.toString();
		}
		catch
		{
			return this.errorReturnValue;
		}
	}

	/**
	 * Adds two values precisely.
	 * @param {number|string} pLeftValue - The left value to be added.
	 * @param {number|string} pRightValue - The right value to be added.
	 * @returns {string} - The result of adding the two values as a string.
	 */
	addPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.plus(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Subtracts two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to subtract.
	 * @param {number|string} pRightValue - The right value to subtract.
	 * @returns {string} The result of the subtraction as a string.
	 */
	subtractPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.minus(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the precise power of two numbers.
	 *
	 * @param {number} pLeftValue - The base value.
	 * @param {number} pRightValue - The exponent value.
	 * @returns {string} The result of raising the base value to the exponent value.
	 */
	powerPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : parseInt(pRightValue);
		let tmpResult;
		if (tmpRightValue == Number(pRightValue))
		{
			const tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
			tmpResult = tmpLeftArbitraryValue.pow(tmpRightValue);
		}
		else
		{
			//FIXME: big.js shits itself on non-integer exponents........................
			tmpResult = Math.pow(tmpLeftValue, Number(pRightValue));
		}

		return tmpResult.toString();
	}

	/**
	 * Multiplies two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to multiply.
	 * @param {number|string} pRightValue - The right value to multiply.
	 * @returns {string} The result of the multiplication as a string.
	 */
	multiplyPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.times(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Divides two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to be divided.
	 * @param {number|string} pRightValue - The right value to divide by.
	 * @returns {string} The result of the division as a string.
	 */
	dividePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.div(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the modulus of two values with precision.
	 *
	 * @param {number|string} pLeftValue - The left value.
	 * @param {number|string} pRightValue - The right value.
	 * @returns {string} The result of the modulus operation as a string.
	 */
	modPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.mod(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the square root of a number with precise decimal places.
	 *
	 * @param {number|string} pValue - The number to calculate the square root of.
	 * @returns {string} The square root of the input number as a string.
	 */
	sqrtPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpValue);
		let tmpResult = tmpLeftArbitraryValue.sqrt();
		return tmpResult.toString();
	}

	/**
	 * Calculates the absolute value of a number precisely.
	 *
	 * @param {number|string} pValue - The number to calculate the absolute value of.
	 * @returns {string} The absolute value of the input number as a string.
	 */
	absPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpValue);
		let tmpResult = tmpLeftArbitraryValue.abs();
		return tmpResult.toString();
	}

	/**
	 * Tests whether a value is a numeric decimal string (after trimming).
	 * Empty strings, whitespace, non-numeric text, null and undefined are NOT
	 * numeric; '0' IS. Returns the strings '1' / '0' so the result composes
	 * with the expression grammar's comparison-style truth values.
	 *
	 * Validity is tested with a decimal grammar (sign, digits, optional
	 * fraction, optional exponent) rather than a float round-trip, so
	 * arbitrary-precision values — long mantissas, integers past 2^53,
	 * exponents beyond float range — classify correctly for the string-based
	 * precise math this service does.
	 *
	 * @param {*} pValue - The value to test.
	 * @returns {string} '1' when numeric, '0' otherwise.
	 */
	isNumeric(pValue)
	{
		if (pValue === null || pValue === undefined)
		{
			return '0';
		}
		const tmpString = String(pValue).trim();
		if (tmpString === '')
		{
			return '0';
		}
		return /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(tmpString) ? '1' : '0';
	}

	/**
	 * Validates a value as numeric, with an explicit fallback for anything
	 * that is not (empty strings, text placeholders, null). The numeric
	 * counterpart to isNumeric — together they express "skip or zero-fill
	 * dirty readings while still counting real zeroes".
	 *
	 * PRECISION CONTRACT: when the value IS numeric, the original (trimmed)
	 * string is returned VERBATIM — never round-tripped through a float — so
	 * arbitrary-precision values flow into the precise math untouched
	 * ('1.500' stays '1.500'; 25-digit mantissas keep every digit).
	 *
	 * @param {*} pValue - The value to validate.
	 * @param {number|string} [pFallback=0] - Returned when pValue is not numeric.
	 * @returns {string} The original numeric string (or the fallback) as a string.
	 */
	toNumber(pValue, pFallback)
	{
		if (this.isNumeric(pValue) === '0')
		{
			return (pFallback === undefined || pFallback === null) ? '0' : String(pFallback);
		}
		return String(pValue).trim();
	}

	/**
	 * Calculates the floor of a number precisely.
	 *
	 * @param {string|number} pValue - The number to calculate the floor value of.
	 * @returns {string} The floor value of the input number as a string.
	 */
	floorPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpResult = Math.floor(tmpValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the ceiling of a number precisely.
	 *
	 * @param {number|string} pValue - The number to calculate the ceiling value of.
	 * @returns {string} The ceiling value of the input number as a string.
	 */
	ceilPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpResult = Math.ceil(tmpValue);
		return tmpResult.toString();
	}

	/**
	 * Compares two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {number} - Returns the result of the comparison.
	 */
	comparePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.cmp(tmpRightValue);
	}

	/**
	 * Compares two values precisely within a tolerance.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @param {number|string} pEpsilon - The epsilon value for comparison.
	 * @returns {number} - Returns the result of the comparison.
	 */
	comparePreciseWithin(pLeftValue, pRightValue, pEpsilon)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		const diff = tmpLeftArbitraryValue.minus(tmpRightValue).abs();
		if (diff.lte(pEpsilon))
		{
			return 0;
		}
		if (tmpLeftArbitraryValue.lt(tmpRightValue))
		{
			return -1;
		}
		return 1;
	}

	/**
	 * Determines if the left value is greater than the right value precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - Returns true if the left value is greater than the right value, otherwise returns false.
	 */
	gtPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.gt(tmpRightValue);
	}

	/**
	 * Checks if the left value is greater than or equal to the right value.
	 * If either value is not a number, it is treated as 0.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - True if the left value is greater than or equal to the right value, false otherwise.
	 */
	gtePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.gte(tmpRightValue);
	}

	/**
	 * Determines if the left value is less than the right value precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - Returns true if the left value is less than the right value, otherwise returns false.
	 */
	ltPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.lt(tmpRightValue);
	}

	/**
	 * Determines if the left value is less than or equal to the right value.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - Returns true if the left value is less than or equal to the right value, otherwise returns false.
	 */
	ltePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.lte(tmpRightValue);
	}

	/**
	 * Comparison operator: returns "1" if left > right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left > right, "0" otherwise.
	 */
	greaterThanOperator(pLeftValue, pRightValue)
	{
		return this.gtPrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left >= right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left >= right, "0" otherwise.
	 */
	greaterThanOrEqualOperator(pLeftValue, pRightValue)
	{
		return this.gtePrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left < right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left < right, "0" otherwise.
	 */
	lessThanOperator(pLeftValue, pRightValue)
	{
		return this.ltPrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left <= right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left <= right, "0" otherwise.
	 */
	lessThanOrEqualOperator(pLeftValue, pRightValue)
	{
		return this.ltePrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left == right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left == right, "0" otherwise.
	 */
	equalOperator(pLeftValue, pRightValue)
	{
		return this.comparePrecise(pLeftValue, pRightValue) == 0 ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left != right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left != right, "0" otherwise.
	 */
	notEqualOperator(pLeftValue, pRightValue)
	{
		return this.comparePrecise(pLeftValue, pRightValue) != 0 ? '1' : '0';
	}

	/**
	 * Converts degrees to radians with arbitrary precision.
	 *
	 * @param {number|string} pDegrees - The degrees to convert to radians.
	 * @returns {string} - The converted radians as a string.
	 */
	radPrecise(pDegrees)
	{
		let tmpDegrees = isNaN(pDegrees) ? 0 : pDegrees;

		let tmpDegreesArbitraryValue = new this.bigNumber(tmpDegrees);
		// TODO: Const for pi in arbitrary precision?
		let tmpResult = tmpDegreesArbitraryValue.times(Math.PI).div(180);
		return tmpResult.toString();
	}

	/**
	 * Calculates the value of pi with the specified precision.
	 * If no precision is provided, returns 100 digits after the decimal.
	 *
	 * @param {number|string} [pPrecision] - The precision to use for calculating pi.
	 * @returns {number} - The calculated value of pi.
	 */
	piPrecise(pPrecision)
	{
		if (typeof (pPrecision) === 'undefined')
		{
			return this.pi;
		}
		else
		{
			return this.roundPrecise(this.pi, pPrecision);
		}
	}

	/**
	 * Calculates the value of euler with the specified precision.
	 *
	 * @param {number|string} [pPrecision] - The precision to use for calculating E.
	 * @returns {string} - The calculated value of E.
	 */
	eulerPrecise(pPrecision)
	{
		if (typeof (pPrecision) === 'undefined')
		{
			return this.euler;
		}
		else
		{
			return this.roundPrecise(this.euler, pPrecision);
		}
	}

	/**
	 * Calculates the sine of the given angle in radians.
	 *
	 * @param {number} pRadians - The angle in radians.
	 * @returns {number} The sine of the angle.
	 */
	sin(pRadians)
	{
		let tmpRadians = isNaN(pRadians) ? 0 : pRadians;
		return Math.sin(tmpRadians);
	}

	/**
	 * Calculates the cosine of the given angle in radians.
	 *
	 * @param {number} pRadians - The angle in radians.
	 * @returns {number} The cosine of the angle.
	 */
	cos(pRadians)
	{
		let tmpRadians = isNaN(pRadians) ? 0 : pRadians;
		return Math.cos(tmpRadians);
	}

	/**
	 * Calculates the tangent of an angle in radians.
	 *
	 * @param {number} pRadians - The angle in radians.
	 * @returns {number} The tangent of the angle.
	 */
	tan(pRadians)
	{
		let tmpRadians = isNaN(pRadians) ? 0 : pRadians;
		return Math.tan(tmpRadians);
	}

	/* * * * * * * * * * * * * * * *
	 * Set functions
	 * These are meant to work fine with arrays and more complex set descriptions returned by Manyfest.
	 * Manyfest sometimes returns values as arrays and sometimes as a map of addresses with values depending
	 * on what was requested.
	 *
	 * The following functions will likely be broken into their own service.
	 */

	/**
	 * Counts the number of elements in a set.
	 *
	 * @param {Array|Object|any} pValueSet - The set to count the elements of.
	 * @returns {number} The number of elements in the set.
	 */
	countSetElements(pValueSet)
	{
		if (Array.isArray(pValueSet))
		{
			return pValueSet.length;
		}
		else if (typeof (pValueSet) === 'object')
		{
			return Object.keys(pValueSet).length;
		}
		else if (pValueSet)
		{
			// This is controversial.  Discuss with colleagues!
			return 1;
		}
		return 0;
	}

	/**
	 * Sorts the elements in the given value set in ascending order using the precise parsing and comparison.
	 *
	 * @param {Array|Object} pValueSet - The value set to be sorted.
	 * @returns {Array} - The sorted value set.
	 */
	sortSetPrecise(pValueSet)
	{
		let tmpSortedSet = [];
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				tmpSortedSet.push(this.parsePrecise(pValueSet[i], NaN));
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				tmpSortedSet.push(this.parsePrecise(pValueSet[tmpKeys[i]], NaN));
			}
		}

		tmpSortedSet.sort((pLeft, pRight) => { return this.comparePrecise(pLeft, pRight); });

		return tmpSortedSet;
	}

	/**
	 * Bucketizes a set of values based on a specified bucket size.
	 *
	 * @param {Array|Object} pValueSet - The set of values to be bucketized.
	 * @param {number} [pBucketSize] - The size of each bucket. Optional - If NaN, the values will be bucketized by their value.
	 * @returns {Object} - The bucketized set of values.
	 */
	bucketSetPrecise(pValueSet, pBucketSize)
	{
		let tmpBucketedSet = {};
		let tmpBucketSize = this.parsePrecise(pBucketSize, NaN);

		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				let tmpValue = this.parsePrecise(pValueSet[i], NaN);
				let tmpBucket = tmpValue.toString();
				if (!isNaN(tmpBucketSize))
				{
					tmpBucket = this.dividePrecise(pValueSet[i], tmpBucketSize);
				}
				if (!(tmpBucket in tmpBucketedSet))
				{
					tmpBucketedSet[tmpBucket] = 0;
				}
				tmpBucketedSet[tmpBucket] = tmpBucketedSet[tmpBucket] + 1;
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				let tmpBucket = tmpValue.toString();
				if (!isNaN(tmpBucketSize))
				{
					tmpBucket = this.dividePrecise(pValueSet[i], tmpBucketSize);
				}
				if (!(tmpBucket in tmpBucketedSet))
				{
					tmpBucketedSet[tmpBucket] = 0;
				}
				tmpBucketedSet[tmpBucket] = tmpBucketedSet[tmpBucket] + 1;
			}
		}

		return tmpBucketedSet;
	}

	/**
	 * Calculates the histogram using precise bucket set for the given pValueSet.
	 *
	 * @param {Array<number>} pValueSet - The array of p-values.
	 * @returns {Array<number>} The histogram of the p-values.
	 */
	histogramPrecise(pValueSet)
	{
		return this.bucketSetPrecise(pValueSet);
	}

	/**
	 * Sorts the histogram object in ascending order based on the frequencies of the buckets.
	 *
	 * @param {Object} pHistogram - The histogram object to be sorted.
	 * @returns {Object} - The sorted histogram object.
	 */
	sortHistogramPrecise(pHistogram)
	{
		let tmpSortedHistogram = {};
		let tmpKeys = Object.keys(pHistogram);

		tmpKeys.sort((pLeft, pRight) => { return pHistogram[pLeft] - pHistogram[pRight]; });

		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpSortedHistogram[tmpKeys[i]] = pHistogram[tmpKeys[i]];
		}

		return tmpSortedHistogram;
	}

	/**
	 * Sorts the histogram object in ascending order based on the keys.
	 *
	 * @param {Object} pHistogram - The histogram object to be sorted.
	 * @returns {Object} - The sorted histogram object.
	 */
	sortHistogramByKeys(pHistogram, pDescending)
	{
		let tmpSortedHistogram = {};
		let tmpKeys = Object.keys(pHistogram);
		let tmpDescending = (typeof (pDescending) === 'undefined') ? false : pDescending;

		// Sort tmpKeys by the string comparison
		tmpKeys.sort();

		if (tmpDescending)
		{
			tmpKeys = tmpKeys.reverse();
		}

		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpSortedHistogram[tmpKeys[i]] = pHistogram[tmpKeys[i]];
		}

		return tmpSortedHistogram;
	}

	cleanValueArray(pValueArray, pRemoveZeroes)
	{
		let tmpRemoveZeroes = (typeof (pRemoveZeroes) === 'undefined') ? false : pRemoveZeroes;

		if (!Array.isArray(pValueArray))
		{
			return [];
		}

		let tmpCleanedArray = [];
		for (let i = 0; i < pValueArray.length; i++)
		{
			let tmpValue = this.parsePrecise(pValueArray[i], NaN);
			if (!isNaN(tmpValue) && (!tmpRemoveZeroes || (tmpValue != "0")))
			{
				tmpCleanedArray.push(tmpValue);
			}
		}
		return tmpCleanedArray;
	}

	/**
	 * Calculate the natural log of 2 to a specific precision, for use in the Taylor series.
	 * Cache outcome so it only runs once per precision.
	 * @param {number} pPrecision - The decimal precision to calculate ln(2) to.
	 * @returns
	 */
	arbitraryNaturalLogOfTwo(pPrecision)
	{
		const tmpPrecisionKey = pPrecision | 0;
		const tmpPrecision = new this.bigNumber(tmpPrecisionKey);
		if (this.ln2Cache.has(tmpPrecisionKey))
		{
			return this.ln2Cache.get(tmpPrecisionKey);
		}

		const tmpTwoConstant = new this.bigNumber(2);
		const y = tmpTwoConstant.minus(1).div(tmpTwoConstant.plus(1)); // 1/3
		const y2 = y.mul(y);
		let tmpSummation = new this.bigNumber(0);
		let tmpTermination = y;
		let tmpDenominator = 1;

		// Use a slightly larger precision for this to prevent numeric drift for larger log requirements
		const tmpEpsilon = this.powerPrecise(10, -(tmpPrecision.add(8))); // target tail < 10^-(precision+8)

		for (let i = 0; i < 200000; i++)
		{
			tmpSummation = tmpSummation.plus(tmpTermination.div(tmpDenominator));
			tmpTermination = tmpTermination.mul(y2);
			tmpDenominator += 2;
			if (tmpTermination.abs().div(tmpDenominator).lt(tmpEpsilon))
			{
				break;
			}
		}
		const tmpNaturalLogOfTwo = tmpSummation.mul(2);
		this.ln2Cache.set(tmpPrecisionKey, tmpNaturalLogOfTwo);
		return tmpNaturalLogOfTwo;
	}

	/**
	 * Calculate the natural log of a number to a specific precision using arbitrary precision numbers.
	 * @param {number} pNumberToCompute
	 * @param {number} pPrecision
	 * @returns
	 */
	arbitraryNaturalLog(pNumberToCompute, pPrecision)
	{
		let tmpNumberToCompute = new this.bigNumber(pNumberToCompute);
		let tmpPrecision = new this.bigNumber(pPrecision);

		if (tmpNumberToCompute.lte(0)) throw new Error('ln undefined for non-positive values.');
		if (tmpNumberToCompute.eq(1)) return new this.bigNumber(0);

		// Reduce x to m in ~[0.75, 1.5] by multiplying/dividing by 2
		const TWO = new this.bigNumber(2);
		let k = 0;
		let m = tmpNumberToCompute;

		const tmpUpperBounds = new this.bigNumber('1.5');
		const tmpLowerBounds = new this.bigNumber('0.75');

		while (m.gt(tmpUpperBounds))
		{
			m = m.div(TWO); k += 1;
		}
		while (m.lt(tmpLowerBounds))
		{
			m = m.mul(TWO); k -= 1;
		}

		// ln(m) via atanh/Taylor
		const y = m.minus(1).div(m.plus(1)); // |y| < 1
		const y2 = y.mul(y);

		let tmpSummation = new this.bigNumber(0);
		let tmpSeriesTermination = y; // y^(2j+1)
		let tmpDenominator = 1;

		const tmpEpsilon = this.powerPrecise(10, -(tmpPrecision.add(6))); // target tail < 10^-(precision+6)

		// Iterate until next term contribution is below eps
		for (let i = 0; i < 200000; i++)
		{
			tmpSummation = tmpSummation.plus(tmpSeriesTermination.div(tmpDenominator));
			tmpSeriesTermination = tmpSeriesTermination.mul(y2);
			tmpDenominator += 2;
			// Stop when |tmpSeriesTermination|/tmpDenominator < eps
			if (tmpSeriesTermination.abs().div(tmpDenominator).lt(tmpEpsilon))
			{
				break;
			}
		}
		const tmpNaturalLog = tmpSummation.mul(2);

		// ln(2) once per precision via same series with m=2 (y = 1/3 ==> for faster convergence)
		const tmpPrecisionNaturalLog = this.arbitraryNaturalLogOfTwo(tmpPrecision);

		return tmpNaturalLog.plus(tmpPrecisionNaturalLog.mul(k));
	}

	/**
	 * High-precision natural log using:
	 *  - Argument reduction by powers of 2: x = m * 2^k with m ~ 1
	 *  - atanh series: ln(m) = 2 * sum_{j>=0} y^(2j+1)/(2j+1), y=(m-1)/(m+1), |y|<1
	 *
	 * Converges rapidly when m is close to 1 with arbitrary precision numbers.
	 *
	 * @param {number} pNumberToGenerateLogarithmFor - The number to generate the logarithm for.
	 * @param {number} [pBase] - The base of the logarithm. Defaults to 10.
	 * @param {number} [pPrecision] - The precision of the result. Defaults to 9 decimal places.
	 * @returns {string} - The logarithm of the number to the specified base and precision.
	 */
	logPrecise(pNumberToGenerateLogarithmFor, pBase, pPrecision)
	{
		let tmpBase = (typeof (pBase) === 'undefined') ? this.bigNumber(10) : this.bigNumber(pBase);
		// Default precision is 9 decimal places -- matches Excel's default for LOG function
		const tmpPrecision = (typeof (pPrecision) === 'undefined') ? 9 : pPrecision;
		// Extra precision to avoid rounding errors since we are using a series
		const tmpExtraPrecision = 8;
		const tmpWorkingPrecision = tmpPrecision + tmpExtraPrecision;

		// Store existing precision since this function integrates on a its own precision terms
		const tmpSavedBigDecimalPrecision = this.bigNumber.DP;
		const tmpSavedBigRoundingMethod = this.bigNumber.RM;

		this.bigNumber.DP = tmpWorkingPrecision;
		this.bigNumber.RM = 1; // round half up for the Taylor series

		const N = this.bigNumber(pNumberToGenerateLogarithmFor);
		const B = this.bigNumber(tmpBase);

		// Run domain checks, which Excel also does
		if (N.lte(0))
		{
			this.log.error(`Fable logPrecise Error: Number must be greater than 0; number was ${pNumberToGenerateLogarithmFor}.`);
			return NaN;
		}
		if (B.lte(0) || B.eq(1))
		{
			this.log.error(`Fable logPrecise Error: Base must be greater than 0 and not equal to 1 -- base ${Base} was passed in.`);
			return NaN;
		}

		const tmpNaturalLogOfN = this.arbitraryNaturalLog(N, tmpPrecision);
		const tmpNaturalLogOfB = this.arbitraryNaturalLog(B, tmpPrecision);

		const tmpResult = tmpNaturalLogOfN.div(tmpNaturalLogOfB);

		// Final rounding to requested precision
		let finalResult = tmpResult.toFixed(tmpPrecision);
		this.bigNumber.DP = tmpSavedBigDecimalPrecision;
		this.bigNumber.RM = tmpSavedBigRoundingMethod;
		return finalResult;
	}

	expPrecise(pValue, pDecimalPrecision)
	{
		let tmpValue = isNaN(pValue) ? this.bigNumber(1) : this.bigNumber(pValue);

		// Constants & thresholds (Excel / IEEE-754 double limits) -- this is required to match Excel's behavior
		const tmpDecimalPrecision = (typeof (pDecimalPrecision) === 'undefined') ? 9 : parseInt(pDecimalPrecision, 10);
		const tmpSavedBigDecimalPrecision = this.bigNumber.DP;
		this.bigNumber.DP = tmpDecimalPrecision + 10; // a bit of extra precision for rounding safety (this makes it match excel)

		// ln(2), min/max natural logs before double overflow/underflow
		const tmpNaturalLogOfTwo = new this.bigNumber('0.693147180559945309417232121458176568'); // This is hilarious that we can compute the value above but this is what Excel uses.
		const tmpNaturalLogMaxDouble = new this.bigNumber('709.782712893384'); // ln(1.7976931348623157e308)
		const tmpNaturalLogMinimumValue = new this.bigNumber('-744.4400719213812'); // ln(5e-324)

		// 1. Guard for Overflow / underflow behavior to match Excel
		if (tmpValue.gt(tmpNaturalLogMaxDouble))
		{
			this.bigNumber.DP = tmpSavedBigDecimalPrecision;
			return NaN; // Excel shows #NUM! when result overflows we will use NaN
		}
		if (tmpValue.lt(tmpNaturalLogMinimumValue))
		{
			this.bigNumber.DP = tmpSavedBigDecimalPrecision;
			return new this.bigNumber(0); // Excel underflows to 0
		}

		// 2. Perform Range reduction: x = k*ln2 + r, with r small
		// k = floor(x / ln2)
		let k;
		try
		{
			k = tmpValue.div(tmpNaturalLogOfTwo).round(0, 0 /* RoundDown toward -infinity */); // floor for positives & negatives
		}
		catch(pErrorRounding)
		{
			this.log.error(`Fable expPrecise Error: Rounding error during range reduction for value of ${pValue}.  Error: ${pErrorRounding}`);
			this.bigNumber.DP = tmpSavedBigDecimalPrecision;
			return NaN;
		}
		const r = tmpValue.minus(k.times(tmpNaturalLogOfTwo));

		// Compute exp(r) via Taylor series with Big arithmetic
		// exp(r) = Summation of r^n / n!, n=0..infinity
		// Sum until termination is below tolerance based on decimal precision
		const tmpTolerance = new this.bigNumber(10).pow(-(tmpDecimalPrecision + 2));
		let tmpTermination = new this.bigNumber(1); // r^0/0! = 1
		let tmpSummation = new this.bigNumber(1);
		let n = 1;

		// 3. Multiply incrementally: term *= r / n
		// SOOOOO close to a fractal!
		while (true)
		{
			tmpTermination = tmpTermination.times(r).div(n);
			if (tmpTermination.abs().lt(tmpTolerance)) break;
			tmpSummation = tmpSummation.plus(tmpTermination);
			n++;
			// Hard safety cap for pathological inputs (shouldn’t be possible with step 2's range reduction):
			if (n > 2000)
			{
				this.log.warn(`Fable expPrecise warning: Taylor series failed to converge after 2000 iterations for value of ${pValue}.`);
				break;
			}
		}

		// 4. Recompose: exp(x) = 2^k * exp(r)
		const tmpTwo = new this.bigNumber(2);
		const tmpAbsoluteValueOfK = k.abs().toNumber(); // k is integer; big.js pow requires a JS integer
		let tmpTwoToThePowerOfAbsoluteK = tmpAbsoluteValueOfK === 0 ? new this.bigNumber(1) : tmpTwo.pow(tmpAbsoluteValueOfK);
		const tmpResult = k.gte(0) ? tmpSummation.times(tmpTwoToThePowerOfAbsoluteK) : tmpSummation.div(tmpTwoToThePowerOfAbsoluteK);

		// 5. Restore global decimal precision
		this.bigNumber.DP = tmpSavedBigDecimalPrecision;
		return tmpResult.round(tmpDecimalPrecision).toString();
	}

	cleanValueObject(pValueObject)
	{
		if (typeof (pValueObject) !== 'object')
		{
			return {};
		}

		//TODO: is this right?
		let tmpCleanedObject = {};
		let tmpKeys = Object.keys(pValueObject);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpValue = this.parsePrecise(pValueObject[tmpKeys[i]], NaN);
			if (!isNaN(tmpValue))
			{
				tmpCleanedObject[tmpKeys[i]] = tmpValue;
			}
		}
		return tmpCleanedObject;
	}

	/**
	 * Make a histogram of representative counts for exact values (.tostring() is the keys to count)
	 * @param {Array} pValueSet
	 * @param {string} pValueAddress
	 */
	histogramDistributionByExactValue(pValueObjectSet, pValueAddress, pManifest)
	{
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		let tmpHistogram = {};
		for (let i = 0; i < pValueObjectSet.length; i++)
		{
			// Without a value address, the set elements themselves are counted
			// (plain value sets); with one, count the addressed property.
			let tmpRawValue = pValueAddress
				? this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAddress, pManifest)
				: pValueObjectSet[i];
			if (tmpRawValue === undefined || tmpRawValue === null)
			{
				continue;
			}
			let tmpValue = tmpRawValue.toString();

			if (!(tmpValue in tmpHistogram))
			{
				tmpHistogram[tmpValue] = 0;
			}
			tmpHistogram[tmpValue] = tmpHistogram[tmpValue] + 1;
		}

		return tmpHistogram;
	}

	histogramDistributionByExactValueFromInternalState(pValueObjectSetAddress, pValueAddress)
	{
		if (!pValueObjectSetAddress)
		{
			return {};
		}

		// The expression parser hands the resolved SET, not an address —
		// delegate directly so DISTRIBUTIONHISTOGRAM(set) works.
		if (Array.isArray(pValueObjectSetAddress))
		{
			return this.histogramDistributionByExactValue(pValueObjectSetAddress, pValueAddress);
		}

		let tmpValueObjectSet = this.fable.Utility.getInternalValueByHash(pValueObjectSetAddress);
		return this.histogramDistributionByExactValue(tmpValueObjectSet, pValueAddress);
	}

	/**
	 * Make a histogram of representative counts for exact values (.tostring() is the keys to count)
	 * @param {Array} pValueSet
	 * @param {string} pValueAddress
	 */
	/**
	 * Analyze the density of an ordered value set and find natural boundary
	 * positions that fit a budget — the generic core behind axis ticks, HTML
	 * group headers, timeline scrubbers, and any other "too many labels"
	 * presentation problem.
	 *
	 * Domain handling:
	 *  - Date-like sets: boundaries where values cross calendar units,
	 *    using the finest unit (day, week, month, quarter, year) that fits
	 *    the budget; labels formatted at the unit's natural grain.
	 *  - Numeric sets: boundaries where values cross multiples of a "nice"
	 *    step (1 / 2 / 2.5 / 5 x 10^k) chosen to fit the budget; labels are
	 *    the crossed multiples.
	 *  - Everything else (ordinal): uniform positional boundaries.
	 *
	 * Assumes the set is ordered (an axis/sequence); unordered input
	 * degrades to ordinal handling.
	 *
	 * @param {Array} pValueSet - ordered values, one per position
	 * @param {number} [pMaximumBoundaries=12] - boundary budget (clamped 2..100)
	 * @return {{ SetType: string, Unit: string, Boundaries: Array<{Index: number, Value: any, Label: string}> }}
	 */
	analyzeSetDensity(pValueSet, pMaximumBoundaries)
	{
		let tmpBudget = parseInt(pMaximumBoundaries, 10);
		tmpBudget = (isNaN(tmpBudget)) ? 12 : Math.max(2, Math.min(100, tmpBudget));
		const tmpResult = { SetType: 'ordinal', Unit: 'position', Boundaries: [] };
		if (!Array.isArray(pValueSet) || pValueSet.length < 1)
		{
			return tmpResult;
		}
		if (pValueSet.length <= tmpBudget)
		{
			tmpResult.Boundaries = pValueSet.map((pValue, pIndex) => (
				{ Index: pIndex, Value: pValue, Label: (pValue === undefined || pValue === null) ? '' : pValue.toString() }));
			return tmpResult;
		}

		const tmpNumbers = pValueSet.map((pValue) => this.parsePrecise(pValue, NaN));
		const tmpIsNumericSet = tmpNumbers.every((pNumber) => !isNaN(pNumber));
		const tmpDayJS = this.fable.Dates.dayJS;
		const tmpIsDateSet = !tmpIsNumericSet && pValueSet.every((pValue) =>
			(pValue !== undefined && pValue !== null && pValue !== '') && tmpDayJS(pValue.toString()).isValid());

		if (tmpIsDateSet)
		{
			tmpResult.SetType = 'date';
			const tmpUnitLadder =
			[
				{ Unit: 'day', Key: 'YYYY-MM-DD', Label: 'MMM D' },
				{ Unit: 'week', Key: 'GGGG-WW', Label: 'MMM D' },
				{ Unit: 'month', Key: 'YYYY-MM', Label: 'MMM YYYY' },
				{ Unit: 'quarter', Key: 'YYYY-Q', Label: '[Q]Q YYYY' },
				{ Unit: 'year', Key: 'YYYY', Label: 'YYYY' }
			];
			const tmpParsed = pValueSet.map((pValue) => tmpDayJS(pValue.toString()));
			for (let u = 0; u < tmpUnitLadder.length; u++)
			{
				const tmpBucketKeys = tmpParsed.map((pDate) => pDate.format(tmpUnitLadder[u].Key));
				const tmpDistinct = new Set(tmpBucketKeys).size;
				if (tmpDistinct <= tmpBudget || u === tmpUnitLadder.length - 1)
				{
					tmpResult.Unit = tmpUnitLadder[u].Unit;
					const tmpBoundaryStride = Math.max(1, Math.ceil(tmpDistinct / tmpBudget));
					let tmpSeen = {};
					let tmpBoundaryIndex = -1;
					for (let i = 0; i < pValueSet.length; i++)
					{
						if (tmpBucketKeys[i] in tmpSeen) { continue; }
						tmpSeen[tmpBucketKeys[i]] = true;
						tmpBoundaryIndex++;
						if (tmpBoundaryIndex % tmpBoundaryStride !== 0) { continue; }
						tmpResult.Boundaries.push({ Index: i, Value: pValueSet[i], Label: tmpParsed[i].format(tmpUnitLadder[u].Label) });
					}
					return tmpResult;
				}
			}
		}

		if (tmpIsNumericSet)
		{
			tmpResult.SetType = 'number';
			// Nice step: smallest of {1, 2, 2.5, 5} x 10^k giving <= budget
			// boundary crossings over the value range.
			const tmpMinimum = Math.min(...tmpNumbers);
			const tmpMaximum = Math.max(...tmpNumbers);
			const tmpRange = tmpMaximum - tmpMinimum;
			if (tmpRange > 0)
			{
				const tmpRawStep = tmpRange / tmpBudget;
				const tmpMagnitude = Math.pow(10, Math.floor(Math.log10(tmpRawStep)));
				let tmpStep = 10 * tmpMagnitude;
				for (const tmpNice of [ 1, 2, 2.5, 5 ])
				{
					if (tmpNice * tmpMagnitude >= tmpRawStep) { tmpStep = tmpNice * tmpMagnitude; break; }
				}
				tmpResult.Unit = `step:${tmpStep}`;
				let tmpLastBucket = null;
				for (let i = 0; i < pValueSet.length; i++)
				{
					const tmpBucket = Math.floor(tmpNumbers[i] / tmpStep);
					if (tmpBucket === tmpLastBucket) { continue; }
					tmpLastBucket = tmpBucket;
					const tmpNiceValue = tmpBucket * tmpStep;
					tmpResult.Boundaries.push({ Index: i, Value: pValueSet[i], Label: this.roundPrecise(tmpNiceValue, 6).toString() });
				}
				if (tmpResult.Boundaries.length <= tmpBudget)
				{
					return tmpResult;
				}
				// Non-monotonic data can cross steps many times — degrade.
				tmpResult.Boundaries = [];
			}
		}

		// Ordinal: uniform positional stride.
		tmpResult.SetType = (tmpResult.SetType === 'ordinal') ? 'ordinal' : tmpResult.SetType;
		tmpResult.Unit = 'position';
		const tmpStride = Math.ceil(pValueSet.length / tmpBudget);
		for (let i = 0; i < pValueSet.length; i += tmpStride)
		{
			tmpResult.Boundaries.push({ Index: i, Value: pValueSet[i], Label: (pValueSet[i] === undefined || pValueSet[i] === null) ? '' : pValueSet[i].toString() });
		}
		return tmpResult;
	}

	/**
	 * Chart-shaped projection of analyzeSetDensity: a sparse label array of
	 * the SAME LENGTH as the input ('' at non-boundary positions), dropping
	 * directly into a category chart's labels with alignment preserved.
	 *
	 * @param {Array} pValueSet
	 * @param {number} [pMaximumTicks=12]
	 * @return {Array<string>}
	 */
	chartTickLabels(pValueSet, pMaximumTicks)
	{
		if (!Array.isArray(pValueSet))
		{
			return pValueSet;
		}
		const tmpAnalysis = this.analyzeSetDensity(pValueSet, pMaximumTicks);
		const tmpLabels = new Array(pValueSet.length).fill('');
		for (const tmpBoundary of tmpAnalysis.Boundaries)
		{
			tmpLabels[tmpBoundary.Index] = tmpBoundary.Label;
		}
		return tmpLabels;
	}

	/**
	 * Trailing moving average over an ordered value set — the customer's
	 * "running average of the N most recent results". Positions before a full
	 * window (and the first N-1 after any reset) are null, so a chart line
	 * starts at the first complete window (matches the paper control chart's
	 * blank warm-up).
	 *
	 * Partitioning (e.g. per MixDesign) is done by filtering the set before
	 * calling. `pResetFlags` additionally restarts the average mid-set wherever
	 * a flag is truthy — the WI "restart running average at any point" feature.
	 * The window never reaches across a reset, and the warm-up re-triggers after
	 * one. The marker column can be wired later; the mechanism is here now.
	 *
	 * @param {Array} pValueSet - ordered numeric values (or numeric strings).
	 * @param {number} [pWindow=4] - window size (most-recent N).
	 * @param {number} [pDecimals] - if set, round each average to this many decimals; else full precision.
	 * @param {Array} [pResetFlags] - optional parallel array; a truthy entry restarts the window at that index.
	 * @return {Array} same-length array of trailing averages (null during warm-up / on a non-numeric window).
	 */
	movingAverage(pValueSet, pWindow, pDecimals, pResetFlags)
	{
		// Accept a plain array OR the parser's `RecordSubset[].Field` keyed-object
		// form (values in row/insertion order). Non-collections pass through.
		let tmpValues;
		if (Array.isArray(pValueSet)) { tmpValues = pValueSet; }
		else if (pValueSet && typeof pValueSet === 'object') { tmpValues = Object.values(pValueSet); }
		else { return pValueSet; }
		const tmpWindow = (isNaN(pWindow) || parseInt(pWindow, 10) < 1) ? 4 : parseInt(pWindow, 10);
		const tmpDecimals = (pDecimals === undefined || pDecimals === null || isNaN(pDecimals)) ? null : parseInt(pDecimals, 10);
		let tmpResets = null;
		if (Array.isArray(pResetFlags)) { tmpResets = pResetFlags; }
		else if (pResetFlags && typeof pResetFlags === 'object') { tmpResets = Object.values(pResetFlags); }
		const tmpOutput = new Array(tmpValues.length).fill(null);
		let tmpSegmentStart = 0;
		for (let i = 0; i < tmpValues.length; i++)
		{
			// A truthy reset flag starts a new running-average segment at i.
			if (tmpResets && this._isResetFlag(tmpResets[i]))
			{
				tmpSegmentStart = i;
			}
			const tmpWindowStart = Math.max(tmpSegmentStart, (i - tmpWindow) + 1);
			// Warm-up: not enough points accumulated since the segment start.
			if (((i - tmpWindowStart) + 1) < tmpWindow)
			{
				continue;
			}
			let tmpSum = '0';
			let tmpComplete = true;
			for (let j = tmpWindowStart; j <= i; j++)
			{
				if (this.isNumeric(tmpValues[j]) === '0')
				{
					tmpComplete = false;
					break;
				}
				tmpSum = this.addPrecise(tmpSum, tmpValues[j]);
			}
			if (!tmpComplete)
			{
				continue;
			}
			const tmpAverage = this.dividePrecise(tmpSum, tmpWindow);
			tmpOutput[i] = (tmpDecimals === null) ? tmpAverage : this.roundPrecise(tmpAverage, tmpDecimals);
		}
		return tmpOutput;
	}

	/**
	 * @param {*} pFlag
	 * @return {boolean} true if the value is a running-average reset marker.
	 */
	_isResetFlag(pFlag)
	{
		if (pFlag === undefined || pFlag === null || pFlag === false)
		{
			return false;
		}
		const tmpString = String(pFlag).trim().toLowerCase();
		return tmpString !== '' && tmpString !== '0' && tmpString !== 'false' && tmpString !== 'no';
	}

	/**
	 * Collect (join) per-key string values from a set of objects — the
	 * string-valued sibling of histogramAggregationByExactValue. Returns an
	 * insertion-ordered { key: "v1<separator>v2..." } object, so
	 * OBJECTKEYSTOARRAY / OBJECTVALUESTOARRAY produce aligned parallel
	 * arrays. Values join verbatim (no numeric coercion); undefined/null
	 * values are skipped.
	 *
	 * @param {Array} pValueObjectSet
	 * @param {string} pValueAddress - address of the grouping key on each object
	 * @param {string} pValueJoinAddress - address of the value to collect
	 * @param {string} pSeparator - separator placed between collected values
	 * @param {object} pManifest
	 * @return {Object<string, string>}
	 */
	histogramAggregationJoinByExactValue(pValueObjectSet, pValueAddress, pValueJoinAddress, pSeparator, pManifest)
	{
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress || !pValueJoinAddress)
		{
			return {};
		}

		let tmpSeparator = (typeof (pSeparator) === 'string') ? pSeparator : ',';
		let tmpHistogram = {};
		for (let i = 0; i < pValueObjectSet.length; i++)
		{
			let tmpKey = this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAddress, pManifest);
			if (tmpKey === undefined || tmpKey === null)
			{
				continue;
			}
			tmpKey = tmpKey.toString();
			let tmpValue = this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueJoinAddress, pManifest);
			if (tmpValue === undefined || tmpValue === null)
			{
				continue;
			}
			tmpHistogram[tmpKey] = (tmpKey in tmpHistogram)
				? tmpHistogram[tmpKey] + tmpSeparator + tmpValue.toString()
				: tmpValue.toString();
		}

		return tmpHistogram;
	}

	histogramAggregationByExactValue(pValueObjectSet, pValueAddress, pValueAmountAddress, pManifest)
	{
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress || !pValueAmountAddress)
		{
			return {};
		}

		let tmpHistogram = {};
		for (let i = 0; i < pValueObjectSet.length; i++)
		{
			let tmpValue = this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAddress, pManifest);
			if (typeof(tmpValue) === undefined)
			{
				continue;
			}
			let tmpAmount = this.parsePrecise(this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAmountAddress, pManifest), NaN);

			if (!(tmpValue in tmpHistogram))
			{
				tmpHistogram[tmpValue] = 0;
			}

			if (!isNaN(tmpAmount))
			{
				tmpHistogram[tmpValue] = this.addPrecise(tmpHistogram[tmpValue], tmpAmount);
			}
		}

		return tmpHistogram;
	}

	/**
	 * Aggregates a histogram by exact value from an internal state object.
	 *
	 * @param {string} pValueObjectSetAddress - The address of the internal value object set.
	 * @param {string} pValueAddress - The address of the value to aggregate by.
	 * @param {string} pValueAmountAddress - The address of the amount to aggregate.
	 * @returns {Object} The aggregated histogram object. Returns an empty object if the value object set address is not provided.
	 */
	histogramAggregationByExactValueFromInternalState(pValueObjectSetAddress, pValueAddress, pValueAmountAddress)
	{
		if (!pValueObjectSetAddress)
		{
			return {};
		}

		let tmpValueObjectSet = this.fable.Utility.getInternalValueByHash(pValueObjectSetAddress);
		return this.histogramAggregationByExactValue(tmpValueObjectSet, pValueAddress, pValueAmountAddress);
	}

	/**
	 * Given a value object set (an array of objects), find a specific entry when
	 * sorted by a specific value address.  Supports -1 syntax for last entry.
	 * @param {Array} pValueObjectSet
	 * @param {string} pValueAddress
	 * @param {Object} pManifest
	 */
	entryInSet(pValueObjectSet, pValueAddress, pEntryIndex)
	{
		const tmpEntryIndex = typeof pEntryIndex === 'number' ? pEntryIndex : parseInt(pEntryIndex);
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress)
		{
			return false;
		}

		if (isNaN(tmpEntryIndex) || tmpEntryIndex >= pValueObjectSet.length)
		{
			return false;
		}

		let tmpValueArray = pValueObjectSet.toSorted((pLeft, pRight) => { return this.comparePrecise(pLeft[pValueAddress], pRight[pValueAddress]); });
		let tmpIndex = (tmpEntryIndex < 0) ? tmpValueArray.length + tmpEntryIndex : tmpEntryIndex;
		return tmpValueArray[tmpIndex];
	}

	/**
	 * Finds the smallest value in a set of objects based on a specified value address.
	 *
	 * @param {Object[]} pValueObjectSet - An array of objects to search through.
	 * @param {string} pValueAddress - The key or path used to access the value within each object.
	 * @returns {*} The smallest value found in the set at the specified value address.
	 */
	smallestInSet(pValueObjectSet, pValueAddress)
	{
		return this.entryInSet(pValueObjectSet, pValueAddress, 0);
	}

	/**
	 * Finds the largest value in a set of objects based on a specified value address.
	 *
	 * @param {Object[]} pValueObjectSet - An array of objects to search through.
	 * @param {string} pValueAddress - The address (key or path) within each object to compare values.
	 * @returns {*} The largest value found at the specified address in the set of objects.
	 */
	largestInSet(pValueObjectSet, pValueAddress)
	{
		return this.entryInSet(pValueObjectSet, pValueAddress, -1);
	}

	/**
	 * Expects an array of objects, and an address in each object to sum.  Expects
	 * an address to put the cumulative summation as well.
	 *
	 * @param {Array} pValueObjectSet - The array of objects to perform a cumulative summation on
	 * @param {string} pValueAddress - The address of the column in each object to sum
	 * @param {string} pCumulationResultAddress - The address in each object to put the cumulative summation result
	 * @param {Object} pManifest - The manifest to use for value retrieval and setting
	 * @returns {Array} The updated value object set with cumulative summation results.
	 */
	cumulativeSummation(pValueObjectSet, pValueAddress, pCumulationResultAddress, pManifest)
	{
		return this.iterativeSeries(pValueObjectSet, pValueAddress, pCumulationResultAddress, "1.0", "add", "0.0", true, pManifest);
	}

	/**
	 * Expects an array of objects, and an address in each object to sum.  Expects
	 * an address to put the cumulative summation as well.
	 *
	 * @param {Array} pValueObjectSet - The array of objects to perform a cumulative summation on
	 * @param {string} pValueAddress - The address of the column in each object to sum
	 * @param {string} pCumulationResultAddress - The address in each object to put the cumulative summation result
	 * @param {string} pStartingValue - The (optional) address of the value to start with
	 * @param {Object} pManifest - The manifest to use for value retrieval and setting
	 * @returns {Array} The updated value object set with cumulative summation results.
	 */
	subtractingSummation(pValueObjectSet, pValueAddress, pCumulationResultAddress, pStartingValue, pManifest)
	{
		let tmpProcessFirstRow = true;
		// If the starting value comes from somewhere else, we want to subtract the first row from it.
		if (typeof (pStartingValue) === 'undefined' || pStartingValue === null)
		{
			tmpProcessFirstRow = false;
		}
		return this.iterativeSeries(pValueObjectSet, pValueAddress, pCumulationResultAddress, "1.0", "subtract", pStartingValue, tmpProcessFirstRow, pManifest);
	}

	/**
	 * Expects an array of objects, and an address in each object to perform an iterative mathematical operation on.

	 * @param {Array} pValueObjectSet - The array of objects to perform a cumulative summation on
	 * @param {string} pValueAddress - The address of the column in each object to sum
	 * @param {string} pValueMultiplier - The multiplier to apply to each value before summation
	 * @param {string} pSummationOperation - The operation to perform for summation: +, -, *, / (and some textual equivalents)
	 * @param {string} pCumulationResultAddress - The address in each object to put the cumulative summation result
	 * @param {string} pStartingValue - The address of the value to process from; defaults to the first row
	 * @param {boolean} pProcessFirstRowWithAValue - Whether to process the first row's value from all subsequent rows
	 * @param {Object} pManifest - The manifest to
	 * @returns {Array} The updated value object set with cumulative summation results.
	 */
	iterativeSeries(pValueObjectSet, pValueAddress, pCumulationResultAddress, pValueMultiplier, pSummationOperation, pStartingValue, pProcessFirstRowWithAValue, pManifest)
	{
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress || !pCumulationResultAddress)
		{
			return pValueObjectSet;
		}

		// By default don't subtract the first row from the value
		let tmpProcessFirstRow = (typeof(pProcessFirstRowWithAValue) === 'undefined') ? false : pProcessFirstRowWithAValue;

		let tmpValueMultiplier;
		if (pValueMultiplier && pValueMultiplier !== '')
		{
			tmpValueMultiplier = this.parsePrecise(pValueMultiplier);
		}
		if (isNaN(tmpValueMultiplier))
		{
			tmpValueMultiplier = this.parsePrecise("1.0");
		}

		// Default to start from the current value address
		let tmpSummationValue;
		// This logic ensures we don't default to 0 when pStartingValue is an empty string
		if (pStartingValue || (pStartingValue !== ''))
		{
			tmpSummationValue = this.parsePrecise(pStartingValue);
		}
		if (isNaN(tmpSummationValue) || typeof(pStartingValue) === 'undefined' || pStartingValue === null)
		{
			tmpSummationValue = '';
		}

		for (let i = 0; i < pValueObjectSet.length; i++)
		{
			let tmpValue = this.parsePrecise(this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAddress, pManifest));
			// Since summation might start on a row after the first,
			let tmpFirstRowWithValue = false;
			if ((tmpSummationValue === '') && tmpValue && !isNaN(tmpSummationValue))
			{
				// Try to grab the summation value from the first row with a value
				tmpSummationValue = tmpValue;
				tmpFirstRowWithValue = true;
			}

			// Continue on with the values as they are if the current row doesn't have a change
			if (isNaN(tmpValue))
			{
				this.fable.Utility.setValueByHash(pValueObjectSet[i], pCumulationResultAddress, tmpSummationValue, pManifest);
				continue;
			}

			tmpValue = this.multiplyPrecise(tmpValue, tmpValueMultiplier);

			// Now perform the operation
			if (!tmpFirstRowWithValue || tmpProcessFirstRow)
			{
				switch (pSummationOperation)
				{
					case '+':
					case 'add':
					case 'plus':
					case 'addition':
						tmpSummationValue = this.addPrecise(tmpSummationValue, tmpValue);
						break;

					case '-':
					case 'sub':
					case 'minus':
					case 'subtract':
						tmpSummationValue = this.subtractPrecise(tmpSummationValue, tmpValue);
						break;

					case '*':
					case 'mul':
					case 'times':
					case 'multiply':
						tmpSummationValue = this.multiplyPrecise(tmpSummationValue, tmpValue);
						break;

					case '-':
					case 'div':
					case 'over':
					case 'divide':
						tmpSummationValue = this.dividePrecise(tmpSummationValue, tmpValue);
						break;
				}
			}
			this.fable.Utility.setValueByHash(pValueObjectSet[i], pCumulationResultAddress, tmpSummationValue, pManifest);
		}

		return pValueObjectSet;
	}

	/**
	 * Finds the maximum value from a set of precise values.
	 *
	 * @param {Array|Object} pValueSet - The set of values to find the maximum from.
	 * @returns {number} - The maximum value from the set.
	 */
	maxPrecise(pValueSet)
	{
		let tmpMaxValue = NaN;
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				if (!tmpMaxValue)
				{
					tmpMaxValue = this.parsePrecise(pValueSet[i], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[i], NaN);
					if (this.gtPrecise(tmpComparisonValue, tmpMaxValue))
					{
						tmpMaxValue = tmpComparisonValue;
					}
				}
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				if (!tmpMaxValue)
				{
					tmpMaxValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
					if (this.gtPrecise(tmpComparisonValue, tmpMaxValue))
					{
						tmpMaxValue = tmpComparisonValue;
					}
				}
			}
		}
		return tmpMaxValue;
	}

	/**
	 * Finds the minimum value from a set of values.
	 *
	 * @param {Array|Object} pValueSet - The set of values to find the minimum from.
	 * @returns {number} The minimum value from the set.
	 */
	minPrecise(pValueSet)
	{
		let tmpMinValue = NaN;
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				if (!tmpMinValue)
				{
					tmpMinValue = this.parsePrecise(pValueSet[i], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[i], NaN);
					if (!isNaN(tmpComparisonValue) && this.ltPrecise(tmpComparisonValue, tmpMinValue))
					{
						tmpMinValue = tmpComparisonValue;
					}
				}
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				if (!tmpMinValue)
				{
					tmpMinValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
					if (!isNaN(tmpComparisonValue) && this.ltPrecise(tmpComparisonValue, tmpMinValue))
					{
						tmpMinValue = tmpComparisonValue;
					}
				}
			}
		}
		return tmpMinValue;
	}

	/**
	 * Calculates the precise sum of values in the given value set.
	 *
	 * @param {Array|Object} pValueSet - The value set to calculate the sum from.
	 * @returns {string} The precise sum value as a string.
	 */
	sumPrecise(pValueSet)
	{
		let tmpSumValue = "0.0";
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				let tmpComparisonValue = this.parsePrecise(pValueSet[i], NaN);
				if (!isNaN(tmpComparisonValue))
				{
					tmpSumValue = this.addPrecise(tmpSumValue, tmpComparisonValue);
				}
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpComparisonValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				if (!isNaN(tmpComparisonValue))
				{
					tmpSumValue = this.addPrecise(tmpSumValue, tmpComparisonValue);
				}
			}
		}
		return tmpSumValue;
	}

	/**
	 * Calculates the precise mean of a given value set.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the mean.
	 * @returns {string} The precise mean value as a string.
	 */
	meanPrecise(pValueSet)
	{
		let tmpSumValue = this.sumPrecise(pValueSet);
		let tmpCount = this.countSetElements(pValueSet);
		if (tmpCount == 0)
		{
			return '0.0';
		}
		return this.dividePrecise(tmpSumValue, tmpCount);
	}

	/**
	 * Calculates the average of an array of values precisely.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the average of.
	 * @returns {string} The precise average of the values.
	 */
	averagePrecise(pValueSet)
	{
		return this.meanPrecise(pValueSet);
	}

	/**
	 * Calculates the precise median value of a given value set.
	 *
	 * @param {Array<number>} pValueSet - The array of values to calculate the median from.
	 * @returns {number|string} - The median value of the given value set. If the value set is empty, returns '0.0'.
	 */
	medianPrecise(pValueSet)
	{
		let tmpCount = this.countSetElements(pValueSet);
		// If there are no elements, return 0 ... should this be NaN?
		if (tmpCount == 0)
		{
			return '0.0';
		}

		let tmpSortedValueSet = this.sortSetPrecise(pValueSet);
		let tmpMiddleElement = Math.floor(tmpCount / 2);

		// If the count is odd, return the middle element
		if (tmpCount % 2 == 1)
		{
			return tmpSortedValueSet[tmpMiddleElement];
		}
		// If the count is even, return the average of the two middle elements
		else
		{
			let tmpLeftMiddleValue = tmpSortedValueSet[tmpMiddleElement - 1];
			let tmpRightMiddleValue = tmpSortedValueSet[tmpMiddleElement];
			return this.dividePrecise(this.addPrecise(tmpLeftMiddleValue, tmpRightMiddleValue), 2);
		}
	}

	/**
	 * Calculates the mode (most frequently occurring value) of a given value set using precise mode calculation.
	 *
	 * @param {Array} pValueSet - The array of values to calculate the mode from.
	 * @returns {Array} - An array containing the mode value(s) from the given value set.
	 */
	modePrecise(pValueSet)
	{
		let tmpHistogram = this.bucketSetPrecise(pValueSet);
		let tmpMaxCount = 0;

		// Philosophical question about whether the values should be returned sorted.
		let tmpHistogramValueSet = Object.keys(tmpHistogram);

		let tmpModeValueSet = [];

		for (let i = 0; i < tmpHistogramValueSet.length; i++)
		{
			if (tmpHistogram[tmpHistogramValueSet[i]] > tmpMaxCount)
			{
				tmpMaxCount = tmpHistogram[tmpHistogramValueSet[i]];
				tmpModeValueSet = [tmpHistogramValueSet[i]];
			}
			else if (tmpHistogram[tmpHistogramValueSet[i]] == tmpMaxCount)
			{
				tmpModeValueSet.push(tmpHistogramValueSet[i]);
			}
		}

		return tmpModeValueSet;
	}

	/**
	 * Calculates the variance of a given value set using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the variance from.
	 * @param {boolean} [pIsPopulation=false] - Whether to calculate population variance (true) or sample variance (false).
	 *
	 * @return {string} - The variance of the given value set.
	 */
	variancePrecise(pValueSet, pIsPopulation = false)
	{
		let tmpValueSet = pValueSet;
		if (!Array.isArray(tmpValueSet) && typeof tmpValueSet === 'object')
		{
			tmpValueSet = Object.keys(tmpValueSet).map((pKey) => tmpValueSet[pKey]);
		}
		const tmpMeanValue = this.meanPrecise(tmpValueSet);
		const tmpVarianceSum = tmpValueSet.reduce((pAccumulator, pValue) =>
		{
			const tmpDiff = this.subtractPrecise(pValue, tmpMeanValue);
			const tmpSquaredDiff = this.multiplyPrecise(tmpDiff, tmpDiff);
			return this.addPrecise(pAccumulator, tmpSquaredDiff);
		}, '0.0');
		return this.dividePrecise(tmpVarianceSum, pIsPopulation ? tmpValueSet.length : tmpValueSet.length - 1);
	}

	/**
	 * Calculates the variance of a given population of values using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the variance from.
	 *
	 * @return {string} - The variance of the given value set.
	 */
	populationVariancePrecise(pValueSet)
	{
		return this.variancePrecise(pValueSet, true);
	}

	/**
	 * Calculates the standard deviation of a given value set using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the standard deviation from.
	 * @param {boolean} [pIsPopulation=false] - Whether to calculate population variance (true) or sample variance (false).
	 *
	 * @return {string} - The standard deviation of the given value set.
	 */
	standardDeviationPrecise(pValueSet, pIsPopulation = false)
	{
		return this.sqrtPrecise(this.variancePrecise(pValueSet, pIsPopulation));
	}

	/**
	 * Calculates the standard deviation of a given population of values using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the standard deviation from.
	 *
	 * @return {string} - The standard deviation of the given value set.
	 */
	populationStandardDeviationPrecise(pValueSet)
	{
		return this.standardDeviationPrecise(pValueSet, true);
	}

	/**
	 * Performs an nth degree polynomial regression on the given data points.
	 *
	 * @param {Array<number|string>} pXVector - The x-coordinates of the data points.
	 * @param {Array<number|string>} pYVector - The y-coordinates of the data points.
	 * @param {number} [pDegree=2] - The degree of the polynomial to fit.
	 *
	 * @return {Array<number|string>} The coefficients of the fitted polynomial, starting from the constant term.
	 */
	polynomialRegression(pXVector, pYVector, pDegree = 2)
	{
		const n = pDegree;
		const tmpXMatrix = [];
		const tmpYVector = pYVector;

		// Build Vandermonde matrix
		for (let i = 0; i < pXVector.length; ++i)
		{
			const row = [];
			for (let j = 0; j <= n; j++)
			{
				row.push(this.powerPrecise(pXVector[i], j));
			}
			tmpXMatrix.push(row);
		}

		// Compute coefficients
		const X_T = this.matrixTranspose(tmpXMatrix);
		const XTX = this.matrixMultiply(X_T, tmpXMatrix);
		const XTY = this.matrixMultiply(X_T, tmpYVector.map(v => [v]));
		const XTX_inv = this.matrixInverse(XTX);
		const A = this.matrixMultiply(XTX_inv, XTY);

		// Flatten coefficients
		return A.map((row) => row[0]);
	}

	/**
	 * Compute least squares regression coefficients for multivariable linear interpolation.
	 *
	 * @param {Array<Array<number|string>> | Array<number|string> | string} pIndependentVariableVectors - array of arrays [[x11, x12, ...], [x21, x22, ...], ...] or single array for single variable.
	 * @param {Array<number|string>|string} pDependentVariableVector - array of target values [y1, y2, ...]
	 *
	 * @return {Array<number|string>} - linear coefficients [b0, b1, ..., bn] where y = b0 + b1*x1 + b2*x2 + ... + bn*xn
	 */
	leastSquares(pIndependentVariableVectors, pDependentVariableVector)
	{
		const tmpIndependentVariableVectors = Array.isArray(pIndependentVariableVectors) ? (Array.isArray(pIndependentVariableVectors[0]) ? this.matrixTranspose(pIndependentVariableVectors) : pIndependentVariableVectors.map(value => [value])) : [ [ pIndependentVariableVectors ] ];
		const tmpDependentVariableVector = Array.isArray(pDependentVariableVector) ? pDependentVariableVector : [ pDependentVariableVector ];
		if (tmpIndependentVariableVectors.length  === 1)
		{
			// degenerate case: only one independent variable value, result is just a y-intercept
			return [ tmpDependentVariableVector[0], '0.0' ];
		}
		// Add bias term (intercept)
		const tmpIndependentVariableMatrixWithBiasTerm = tmpIndependentVariableVectors.map(row => [1, ...row]);

		// Compute X^T * X
		const tmpIndependentTermTranpose = this.matrixTranspose(tmpIndependentVariableMatrixWithBiasTerm);
		const tmpDependentTransposeMultiplication = this.matrixMultiply(tmpIndependentTermTranpose, tmpIndependentVariableMatrixWithBiasTerm);

		// Compute X^T * y
		const tmpIndependentTransposeMultiplication = this.matrixVectorMultiply(tmpIndependentTermTranpose, tmpDependentVariableVector);

		// Solve (XtX) * beta = Xty
		const tmpLinearCoefficients = this.gaussianElimination(tmpDependentTransposeMultiplication, tmpIndependentTransposeMultiplication);

		return tmpLinearCoefficients;
	}

	/**
	 * Helper function to transpose a matrix
	 *
	 * @param {Array<Array<number|string>>} pInputMatrix - matrix to transpose
	 *
	 * @return {Array<Array<number|string>>} - transposed matrix
	 */
	matrixTranspose(pInputMatrix)
	{
		return pInputMatrix[0].map((_, i) => pInputMatrix.map((row) => row[i]));
	}

	matrixMultiply(pLHSMatrix, pRHSMatrix)
	{
		const result = Array(pLHSMatrix.length)
			.fill(0)
			.map(() => Array(pRHSMatrix[0].length).fill(0));
		for (let i = 0; i < pLHSMatrix.length; ++i)
		{
			for (let j = 0; j < pRHSMatrix[0].length; ++j)
			{
				for (let k = 0; k < pRHSMatrix.length; ++k)
				{
					result[i][j] = this.addPrecise(result[i][j], this.multiplyPrecise(pLHSMatrix[i][k], pRHSMatrix[k][j]));
				}
			}
		}
		return result;
	}

	/**
	 * @param {Array<Array<number|string>>} pMatrix - matrix to multiply
	 * @param {Array<number|string>} pVector - vector to multiply
	 *
	 * @return {Array<number|string>} - result vector
	 */
	matrixVectorMultiply(pMatrix, pVector)
	{
		const result = Array(pMatrix.length).fill(0);
		for (let i = 0; i < pMatrix.length; ++i)
		{
			for (let j = 0; j < pMatrix[0].length; ++j)
			{
				result[i] = this.addPrecise(result[i], this.multiplyPrecise(pMatrix[i][j], pVector[j]));
			}
		}
		return result;
	}

	/**
	 * Matrix inverse (using Gaussian elimination)
	 *
	 * @param {Array<Array<number|string>>} pMatrix - matrix to invert
	 *
	 * @return {Array<Array<number|string>>} - inverted matrix
	 */
	matrixInverse(pMatrix)
	{
		const n = pMatrix.length;
		const tmpIdentityMatrix = pMatrix.map((row, i) => row.map((_, j) => (i === j ? 1 : 0)));
		const tmpAugmentedMatrix = pMatrix.map((row, i) => row.concat(tmpIdentityMatrix[i]));

		for (let i = 0; i < n; ++i)
		{
			// Pivot
			let maxRow = i;
			for (let k = i + 1; k < n; ++k)
			{
				if (this.gtPrecise(this.absPrecise(tmpAugmentedMatrix[k][i]), this.absPrecise(tmpAugmentedMatrix[maxRow][i])))
				{
					maxRow = k;
				}
			}
			[tmpAugmentedMatrix[i], tmpAugmentedMatrix[maxRow]] = [tmpAugmentedMatrix[maxRow], tmpAugmentedMatrix[i]];

			// divide by pivot
			const tmpPivotValue = tmpAugmentedMatrix[i][i];
			for (let j = 0; j < 2 * n; ++j)
			{
				tmpAugmentedMatrix[i][j] = this.dividePrecise(tmpAugmentedMatrix[i][j], tmpPivotValue);
			}

			// Eliminate other rows
			for (let k = 0; k < n; ++k)
			{
				if (k === i)
				{
					continue;
				}
				const tmpFactor = tmpAugmentedMatrix[k][i];
				for (let j = 0; j < 2 * n; ++j)
				{
					tmpAugmentedMatrix[k][j] = this.subtractPrecise(tmpAugmentedMatrix[k][j], this.multiplyPrecise(tmpFactor, tmpAugmentedMatrix[i][j]));
				}
			}
		}

		// Extract right half (inverse)
		return tmpAugmentedMatrix.map((row) => row.slice(n));
	}


	/**
	 * Compute solution to linear system using Gaussian elimination.
	 *
	 * @param {Array<Array<number|string>>} pCoefficientMatrix - Coefficient matrix
	 * @param {Array<number|string>} pVector - Right-hand side vector
	 *
	 * @return {Array<number|string>} - Solution vector x
	 */
	gaussianElimination(pCoefficientMatrix, pVector)
	{
		// Solve A*x = b using Gaussian elimination
		const n = pCoefficientMatrix.length;
		const tmpAugmentedMatrix = pCoefficientMatrix.map((row, i) => [...row, pVector[i]]);

		for (let i = 0; i < n; ++i)
		{
			// Pivot
			let maxRow = i;
			for (let k = i + 1; k < n; ++k)
			{
				if (this.gtPrecise(this.absPrecise(tmpAugmentedMatrix[k][i]), this.absPrecise(tmpAugmentedMatrix[maxRow][i])))
				{
					maxRow = k;
				}
			}
			const tmpSwapValue = tmpAugmentedMatrix[i];
			tmpAugmentedMatrix[i] = tmpAugmentedMatrix[maxRow];
			tmpAugmentedMatrix[maxRow] = tmpSwapValue;

			// Normalize pivot row
			const tmpPivotValue = tmpAugmentedMatrix[i][i];
			if (this.comparePrecise(tmpPivotValue, 0) == 0)
			{
				throw new Error('Matrix not invertible');
			}
			for (let j = i; j <= n; ++j)
			{
				tmpAugmentedMatrix[i][j] = this.dividePrecise(tmpAugmentedMatrix[i][j], tmpPivotValue);
			}

			// Eliminate other rows
			for (let k = 0; k < n; ++k)
			{
				if (k === i)
				{
					continue;
				}
				const tmpFactor = tmpAugmentedMatrix[k][i];
				for (let j = i; j <= n; ++j)
				{
					tmpAugmentedMatrix[k][j] = this.subtractPrecise(tmpAugmentedMatrix[k][j], this.multiplyPrecise(tmpFactor, tmpAugmentedMatrix[i][j]));
				}
			}
		}

		// Extract solution
		return tmpAugmentedMatrix.map((row) => row[n]);
	}

	generateValueFromEasingDescription(pEasingConfiguration)
	{
		// Branch based on type
		switch (pEasingConfiguration.Easing)
		{
			case 'LINEAR':
			default:
				let tmpDomainRange = pEasingConfiguration.DomainLength;

				if (this.comparePrecise(tmpDomainRange, 0) == 0)
				{
					return this.parsePrecise(pEasingConfiguration.DomainRangeStart);
				}

				// Now, generate a random number and then multiply it to fit in the domain length
				let tmpRandomFraction = Math.random();
				// Scale it to the domain
				let tmpScaledValue = this.multiplyPrecise(tmpRandomFraction, tmpDomainRange);
				// Shift it to the range start
				return this.addPrecise(pEasingConfiguration.DomainRangeStart, tmpScaledValue);
		}
	}

	/**
	 * Predicts the dependent variable using a regression model.
	 *
	 * @param {Array<number|string>} pRegressionCoefficients - The regression coefficients [b0, b1, ..., bn].
	 * @param {Array<number|string>|number|string} pIndependentVariableVector - The independent variable values [x1, x2, ..., xn] or single value for single variable.
	 *
	 * @return {number|string} - The predicted dependent variable value.
	 */
	predictFromRegressionModel(pRegressionCoefficients, pIndependentVariableVector)
	{
		let tmpIndependentVariableVector = pIndependentVariableVector;
		if (!Array.isArray(pIndependentVariableVector))
		{
			tmpIndependentVariableVector = [ pIndependentVariableVector ];
		}
		return pRegressionCoefficients.slice(1).reduce((sum, b, i) =>
			{
				return this.addPrecise(sum, this.multiplyPrecise(b, tmpIndependentVariableVector[i]));
			}, pRegressionCoefficients[0]);
	}

	/**
	 * Resolves paired Y/X value arrays from flexible argument patterns.
	 *
	 * The expression parser's SetConcatArray spreads comma-separated arguments
	 * as individual function parameters.  This helper normalizes three calling
	 * conventions into a clean paired-value result:
	 *
	 *   1. Two arrays:  SLOPE(yArray, xArray)
	 *   2. Spread scalars:  SLOPE(y1,y2,...,yN, x1,x2,...,xN) — split in half
	 *   3. One flat array:  SLOPE([y1,...,yN,x1,...,xN]) — split in half
	 *
	 * Non-numeric values are filtered; only pairs where both Y and X parse
	 * are kept.
	 *
	 * @param {...*} pArguments - Flexible: (yArr, xArr) | (y1,y2,...,x1,x2,...) | (flatArr)
	 *
	 * @return {Object} { cleanX, cleanY, n }
	 */
	cleanPairedValues(...pArguments)
	{
		let tmpYValues;
		let tmpXValues;

		if (pArguments.length === 2 && Array.isArray(pArguments[0]) && Array.isArray(pArguments[1]))
		{
			// Two arrays: SLOPE(yArray, xArray)
			tmpYValues = pArguments[0];
			tmpXValues = pArguments[1];
		}
		else if (pArguments.length === 1 && Array.isArray(pArguments[0]))
		{
			// Single flat array — split in half
			let tmpFlat = pArguments[0];
			let tmpHalf = Math.floor(tmpFlat.length / 2);
			tmpYValues = tmpFlat.slice(0, tmpHalf);
			tmpXValues = tmpFlat.slice(tmpHalf);
		}
		else if (pArguments.length > 2)
		{
			// Many spread scalars from expression parser — split in half
			let tmpHalf = Math.floor(pArguments.length / 2);
			tmpYValues = pArguments.slice(0, tmpHalf);
			tmpXValues = pArguments.slice(tmpHalf);
		}
		else
		{
			// Two scalars or other degenerate input
			tmpYValues = Array.isArray(pArguments[0]) ? pArguments[0] : [pArguments[0]];
			tmpXValues = Array.isArray(pArguments[1]) ? pArguments[1] : [pArguments[1]];
		}

		let tmpPairCount = Math.min(tmpYValues.length, tmpXValues.length);

		let tmpCleanX = [];
		let tmpCleanY = [];

		for (let i = 0; i < tmpPairCount; i++)
		{
			let tmpX = this.parsePrecise(tmpXValues[i], NaN);
			let tmpY = this.parsePrecise(tmpYValues[i], NaN);
			if (!isNaN(tmpX) && !isNaN(tmpY))
			{
				tmpCleanX.push(tmpX);
				tmpCleanY.push(tmpY);
			}
		}

		return { cleanX: tmpCleanX, cleanY: tmpCleanY, n: tmpCleanX.length };
	}

	/**
	 * Calculates the slope of a linear regression line through paired data points.
	 * Equivalent to Excel's SLOPE function.
	 *
	 * Formula: slope = (n * Σ(xy) - Σx * Σy) / (n * Σ(x²) - (Σx)²)
	 *
	 * Calling conventions (all work through the expression parser):
	 *   SLOPE(yArray, xArray)                — two resolved arrays
	 *   SLOPE(y1,y2,...,yN, x1,x2,...,xN)    — inline scalars, split in half
	 *
	 * @param {...*} pArguments - Y values followed by X values (see cleanPairedValues).
	 *
	 * @return {string} The slope of the regression line.
	 */
	slopePrecise(...pArguments)
	{
		let tmpPaired = this.cleanPairedValues(...pArguments);

		if (tmpPaired.n < 2)
		{
			return '0';
		}

		let tmpSumX = '0';
		let tmpSumY = '0';
		let tmpSumXY = '0';
		let tmpSumX2 = '0';

		for (let i = 0; i < tmpPaired.n; i++)
		{
			tmpSumX = this.addPrecise(tmpSumX, tmpPaired.cleanX[i]);
			tmpSumY = this.addPrecise(tmpSumY, tmpPaired.cleanY[i]);
			tmpSumXY = this.addPrecise(tmpSumXY, this.multiplyPrecise(tmpPaired.cleanX[i], tmpPaired.cleanY[i]));
			tmpSumX2 = this.addPrecise(tmpSumX2, this.multiplyPrecise(tmpPaired.cleanX[i], tmpPaired.cleanX[i]));
		}

		// slope = (n * Σ(xy) - Σx * Σy) / (n * Σ(x²) - (Σx)²)
		let tmpNumerator = this.subtractPrecise(this.multiplyPrecise(tmpPaired.n, tmpSumXY), this.multiplyPrecise(tmpSumX, tmpSumY));
		let tmpDenominator = this.subtractPrecise(this.multiplyPrecise(tmpPaired.n, tmpSumX2), this.multiplyPrecise(tmpSumX, tmpSumX));

		if (this.comparePrecise(tmpDenominator, 0) == 0)
		{
			return '0';
		}

		return this.dividePrecise(tmpNumerator, tmpDenominator);
	}

	/**
	 * Calculates the y-intercept of a linear regression line through paired data points.
	 * Equivalent to Excel's INTERCEPT function.
	 *
	 * Formula: intercept = ȳ - slope * x̄
	 *
	 * Calling conventions (all work through the expression parser):
	 *   INTERCEPT(yArray, xArray)                — two resolved arrays
	 *   INTERCEPT(y1,y2,...,yN, x1,x2,...,xN)    — inline scalars, split in half
	 *
	 * @param {...*} pArguments - Y values followed by X values (see cleanPairedValues).
	 *
	 * @return {string} The y-intercept of the regression line.
	 */
	interceptPrecise(...pArguments)
	{
		let tmpPaired = this.cleanPairedValues(...pArguments);

		let tmpSlope = this.slopePrecise(tmpPaired.cleanY, tmpPaired.cleanX);
		let tmpMeanY = this.meanPrecise(tmpPaired.cleanY);
		let tmpMeanX = this.meanPrecise(tmpPaired.cleanX);

		// intercept = ȳ - slope * x̄
		return this.subtractPrecise(tmpMeanY, this.multiplyPrecise(tmpSlope, tmpMeanX));
	}

	/**
	 * Evaluate a point on a cubic bezier curve at parameter t.
	 *
	 * B(t) = (1-t)^3*P0 + 3*(1-t)^2*t*P1 + 3*(1-t)*t^2*P2 + t^3*P3
	 *
	 * @param {number|string} pP0 - First control point value
	 * @param {number|string} pP1 - Second control point value
	 * @param {number|string} pP2 - Third control point value
	 * @param {number|string} pP3 - Fourth control point value
	 * @param {number|string} pT - Parameter t in [0,1]
	 *
	 * @return {string} - The bezier curve value at parameter t
	 */
	bezierPoint(pP0, pP1, pP2, pP3, pT)
	{
		let tmpT = this.parsePrecise(pT, 0);
		let tmpOneMinusT = this.subtractPrecise(1, tmpT);

		// (1-t)^3 * P0
		let tmpTerm0 = this.multiplyPrecise(this.powerPrecise(tmpOneMinusT, 3), pP0);
		// 3 * (1-t)^2 * t * P1
		let tmpTerm1 = this.multiplyPrecise(this.multiplyPrecise(this.multiplyPrecise(3, this.powerPrecise(tmpOneMinusT, 2)), tmpT), pP1);
		// 3 * (1-t) * t^2 * P2
		let tmpTerm2 = this.multiplyPrecise(this.multiplyPrecise(this.multiplyPrecise(3, tmpOneMinusT), this.powerPrecise(tmpT, 2)), pP2);
		// t^3 * P3
		let tmpTerm3 = this.multiplyPrecise(this.powerPrecise(tmpT, 3), pP3);

		return this.addPrecise(this.addPrecise(tmpTerm0, tmpTerm1), this.addPrecise(tmpTerm2, tmpTerm3));
	}

	/**
	 * Fit a cubic bezier curve to a set of data points using least-squares optimization.
	 *
	 * Given arrays of X and Y values representing data points, this function finds the four
	 * control points (P0, P1, P2, P3) of a cubic bezier curve that best fits the data.
	 *
	 * The first and last control points are pinned to the first and last data points.
	 * The interior control points (P1, P2) are found by least-squares minimization of
	 * the squared distances between the data points and the curve.
	 *
	 * Parameter t values are assigned by chord-length parameterization: each data point
	 * gets a t value proportional to its cumulative distance along the polyline.
	 *
	 * @param {Array<number|string>} pXValues - Array of x coordinates
	 * @param {Array<number|string>} pYValues - Array of y coordinates
	 *
	 * @return {Array<Array<string>>} - Four control points as [[x0,y0], [x1,y1], [x2,y2], [x3,y3]]
	 */
	bezierCurveFit(pXValues, pYValues)
	{
		if (!Array.isArray(pXValues) || !Array.isArray(pYValues))
		{
			this.log.warn('bezierCurveFit: pXValues and pYValues must be arrays');
			return [[0, 0], [0, 0], [0, 0], [0, 0]];
		}

		let tmpN = Math.min(pXValues.length, pYValues.length);

		if (tmpN < 2)
		{
			this.log.warn('bezierCurveFit: need at least 2 data points');
			return [[0, 0], [0, 0], [0, 0], [0, 0]];
		}

		// Pin P0 and P3 to the first and last data points
		let tmpP0x = this.parsePrecise(pXValues[0], 0);
		let tmpP0y = this.parsePrecise(pYValues[0], 0);
		let tmpP3x = this.parsePrecise(pXValues[tmpN - 1], 0);
		let tmpP3y = this.parsePrecise(pYValues[tmpN - 1], 0);

		if (tmpN === 2)
		{
			// With only two points, place control points at 1/3 and 2/3 along the line
			let tmpP1x = this.addPrecise(tmpP0x, this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3));
			let tmpP1y = this.addPrecise(tmpP0y, this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3));
			let tmpP2x = this.addPrecise(tmpP0x, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3), 2));
			let tmpP2y = this.addPrecise(tmpP0y, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3), 2));
			return [
				[tmpP0x.toString(), tmpP0y.toString()],
				[tmpP1x.toString(), tmpP1y.toString()],
				[tmpP2x.toString(), tmpP2y.toString()],
				[tmpP3x.toString(), tmpP3y.toString()]
			];
		}

		// Compute chord-length parameterization for t values
		let tmpDistances = [0];
		for (let i = 1; i < tmpN; i++)
		{
			let tmpDx = this.subtractPrecise(pXValues[i], pXValues[i - 1]);
			let tmpDy = this.subtractPrecise(pYValues[i], pYValues[i - 1]);
			let tmpDist = this.sqrtPrecise(this.addPrecise(this.multiplyPrecise(tmpDx, tmpDx), this.multiplyPrecise(tmpDy, tmpDy)));
			tmpDistances.push(this.addPrecise(tmpDistances[i - 1], tmpDist));
		}

		let tmpTotalLength = tmpDistances[tmpN - 1];
		let tmpTValues = [];
		for (let i = 0; i < tmpN; i++)
		{
			if (this.comparePrecise(tmpTotalLength, 0) == 0)
			{
				tmpTValues.push(this.dividePrecise(i, tmpN - 1));
			}
			else
			{
				tmpTValues.push(this.dividePrecise(tmpDistances[i], tmpTotalLength));
			}
		}

		// Build the least-squares system for interior control points P1 and P2.
		// For each data point i with parameter t_i:
		//   B(t_i) = (1-t)^3*P0 + 3*(1-t)^2*t*P1 + 3*(1-t)*t^2*P2 + t^3*P3
		//
		// We want to minimize sum of |DataPoint_i - B(t_i)|^2 over P1 and P2.
		// Let A1(t) = 3*(1-t)^2*t and A2(t) = 3*(1-t)*t^2.
		// Then: A1(t)*P1 + A2(t)*P2 = DataPoint - (1-t)^3*P0 - t^3*P3
		//
		// This gives a 2x2 linear system (solved independently for x and y).

		let tmpC11 = 0, tmpC12 = 0, tmpC22 = 0;
		let tmpRx1 = 0, tmpRx2 = 0;
		let tmpRy1 = 0, tmpRy2 = 0;

		for (let i = 0; i < tmpN; i++)
		{
			let tmpT = tmpTValues[i];
			let tmpOneMinusT = this.subtractPrecise(1, tmpT);

			// Basis functions for P1 and P2
			let tmpA1 = this.multiplyPrecise(this.multiplyPrecise(3, this.powerPrecise(tmpOneMinusT, 2)), tmpT);
			let tmpA2 = this.multiplyPrecise(this.multiplyPrecise(3, tmpOneMinusT), this.powerPrecise(tmpT, 2));

			// Build normal equations: C * [P1; P2] = R
			tmpC11 = this.addPrecise(tmpC11, this.multiplyPrecise(tmpA1, tmpA1));
			tmpC12 = this.addPrecise(tmpC12, this.multiplyPrecise(tmpA1, tmpA2));
			tmpC22 = this.addPrecise(tmpC22, this.multiplyPrecise(tmpA2, tmpA2));

			// Right-hand side: DataPoint - (1-t)^3*P0 - t^3*P3
			let tmpB0 = this.powerPrecise(tmpOneMinusT, 3);
			let tmpB3 = this.powerPrecise(tmpT, 3);

			let tmpResidualX = this.subtractPrecise(this.subtractPrecise(pXValues[i], this.multiplyPrecise(tmpB0, tmpP0x)), this.multiplyPrecise(tmpB3, tmpP3x));
			let tmpResidualY = this.subtractPrecise(this.subtractPrecise(pYValues[i], this.multiplyPrecise(tmpB0, tmpP0y)), this.multiplyPrecise(tmpB3, tmpP3y));

			tmpRx1 = this.addPrecise(tmpRx1, this.multiplyPrecise(tmpA1, tmpResidualX));
			tmpRx2 = this.addPrecise(tmpRx2, this.multiplyPrecise(tmpA2, tmpResidualX));
			tmpRy1 = this.addPrecise(tmpRy1, this.multiplyPrecise(tmpA1, tmpResidualY));
			tmpRy2 = this.addPrecise(tmpRy2, this.multiplyPrecise(tmpA2, tmpResidualY));
		}

		// Solve the 2x2 system: [[C11, C12], [C12, C22]] * [P1, P2] = [R1, R2]
		let tmpDet = this.subtractPrecise(this.multiplyPrecise(tmpC11, tmpC22), this.multiplyPrecise(tmpC12, tmpC12));

		let tmpP1x, tmpP1y, tmpP2x, tmpP2y;

		if (this.comparePrecise(this.absPrecise(tmpDet), '1e-20') < 0)
		{
			// Degenerate case: place control points at 1/3 and 2/3 along the line
			tmpP1x = this.addPrecise(tmpP0x, this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3));
			tmpP1y = this.addPrecise(tmpP0y, this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3));
			tmpP2x = this.addPrecise(tmpP0x, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3), 2));
			tmpP2y = this.addPrecise(tmpP0y, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3), 2));
		}
		else
		{
			tmpP1x = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC22, tmpRx1), this.multiplyPrecise(tmpC12, tmpRx2)), tmpDet);
			tmpP1y = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC22, tmpRy1), this.multiplyPrecise(tmpC12, tmpRy2)), tmpDet);
			tmpP2x = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC11, tmpRx2), this.multiplyPrecise(tmpC12, tmpRx1)), tmpDet);
			tmpP2y = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC11, tmpRy2), this.multiplyPrecise(tmpC12, tmpRy1)), tmpDet);
		}

		return [
			[tmpP0x.toString(), tmpP0y.toString()],
			[tmpP1x.toString(), tmpP1y.toString()],
			[tmpP2x.toString(), tmpP2y.toString()],
			[tmpP3x.toString(), tmpP3y.toString()]
		];
	}
}

module.exports = FableServiceMath;

},{"./Fable-SetConcatArray.js":104,"fable-serviceproviderbase":59}],93:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

/**
* Precedent Meta-Templating
* @author      Steven Velozo <steven@velozo.com>
* @description Process text stream trie and postfix tree, parsing out meta-template expression functions.
*/
const libWordTree = require(`./Fable-Service-MetaTemplate/MetaTemplate-WordTree.js`);
const libStringParser = require(`./Fable-Service-MetaTemplate/MetaTemplate-StringParser.js`);


class FableServiceMetaTemplate extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'MetaTemplate';

		this.WordTree = new libWordTree();

		this.StringParser = new libStringParser(this.fable);

		this.ParseTree = this.WordTree.ParseTree;
	}


	addPattern(pPatternStart, pPatternEnd, pParser, pParserContext)
	{
		return this.WordTree.addPattern(pPatternStart, pPatternEnd, pParser, pParserContext);
	}

	addPatternBoth(pPatternStart, pPatternEnd, pParser, pParserPromise, pParserContext)
	{
		return this.WordTree.addPatternBoth(pPatternStart, pPatternEnd, pParser, pParserPromise, pParserContext);
	}

	/**
	 * Parse a string with the existing parse tree
	 * @method parseString
	 * @param {string} pString - The string to parse
	 * @param {object} pData - Data to pass in as the second argument
	 * @param {function} fCallback - The callback function to call when a pattern is matched
	 * @param {array} pDataContext - The history of data objects already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @return {string} The result from the parser
	 */
	parseString(pString, pData, fCallback, pDataContext, pScope, pState)
	{
		if (this.LogNoisiness > 4)
		{
			this.fable.log.trace(`Metatemplate parsing template string [${pString}] where the callback is a ${typeof(fCallback)}`, {TemplateData:pData});
		}
		return this.StringParser.parseString(pString, this.ParseTree, pData, fCallback, pDataContext, pScope, pState);
	}
}

module.exports = FableServiceMetaTemplate;

},{"./Fable-Service-MetaTemplate/MetaTemplate-StringParser.js":94,"./Fable-Service-MetaTemplate/MetaTemplate-WordTree.js":95,"fable-serviceproviderbase":59}],94:[function(require,module,exports){
/**
* String Parser
* @author      Steven Velozo <steven@velozo.com>
* @description Parse a string, properly processing each matched token in the word tree.
*/

class StringParser
{
	/**
	 * StringParser Constructor
	 */
	constructor(pFable)
	{
		this.fable = pFable;
	}

	/**
	 * Create a fresh parsing state object to work with.
	 * @method newParserState
	 * @param {Object} pParseTree - A node on the parse tree to begin parsing from (usually root)
	 * @return {Object} A new parser state object for running a character parser on
	 * @private
	 */
	newParserState (pParseTree)
	{
		return (
		{
			ParseTree: pParseTree,

			Asynchronous: false,

			Output: '',
			OutputBuffer: '',

			Pattern: {},

			PatternMatch: false,
			PatternMatchEnd: false
		});
	}

	/**
	 * Append a character to the output buffer in the parser state.
	 * This output buffer is used when a potential match is being explored, or a match is being explored.
	 * @method appendOutputBuffer
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	appendOutputBuffer (pCharacter, pParserState)
	{
		pParserState.OutputBuffer += pCharacter;
	}

	/**
	 * Flush the output buffer to the output and clear it.
	 * @method flushOutputBuffer
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	flushOutputBuffer (pParserState)
	{
		pParserState.Output += pParserState.OutputBuffer;
		pParserState.OutputBuffer = '';
	}

	resetOutputBuffer (pParserState)
	{
		// Flush the output buffer.
		this.flushOutputBuffer(pParserState);
		// End pattern mode
		pParserState.Pattern = false;
		pParserState.PatternStartNode = false;
		pParserState.StartPatternMatchComplete = false;
		pParserState.EndPatternMatchBegan = false;
		pParserState.PatternMatch = false;

		return true;
	}

	/**
	 * Parse a character in the buffer.
	 * @method parseCharacter
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @param {any} pData - The data available to the template
	 * @param {Array<any>} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @private
	 */
	parseCharacter (pCharacter, pParserState, pData, pDataContext, pScope, pState)
	{
		// If we are already in a pattern match traversal
		if (pParserState.PatternMatch)
		{
			// If the pattern is still matching the start and we haven't passed the buffer
			if (!pParserState.StartPatternMatchComplete && (pCharacter in pParserState.Pattern))
			{
				pParserState.Pattern = pParserState.Pattern[pCharacter];
				this.appendOutputBuffer(pCharacter, pParserState);
			}
			else if (pParserState.EndPatternMatchBegan)
			{
				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// Flush the output buffer.
					this.appendOutputBuffer(pCharacter, pParserState);
					// If this last character is the end of the pattern, parse it.
					// Run the function
					let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
					if (tmpFunctionContext)
					{
						pParserState.OutputBuffer = pParserState.Pattern.Parse.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
					}
					else
					{
						pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
					}
					return this.resetOutputBuffer(pParserState);
				}
				else if (pCharacter in pParserState.PatternStartNode.PatternEnd)
				{
					// We broke out of the end -- see if this is a new start of the end.
					pParserState.Pattern = pParserState.PatternStartNode.PatternEnd[pCharacter];
					this.appendOutputBuffer(pCharacter, pParserState);
				}
				else
				{
					// Partial end-pattern match aborted -- roll Pattern back to the start node so
					// subsequent characters scan for the end pattern from the beginning again.
					pParserState.EndPatternMatchBegan = false;
					pParserState.Pattern = pParserState.PatternStartNode;
					this.appendOutputBuffer(pCharacter, pParserState);
				}
			}
			else if ('PatternEnd' in pParserState.Pattern)
			{
				if (!pParserState.StartPatternMatchComplete)
				{
					pParserState.StartPatternMatchComplete = true;
					pParserState.PatternStartNode = pParserState.Pattern;
				}

				this.appendOutputBuffer(pCharacter, pParserState);

				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This is the first character of the end pattern.
					pParserState.EndPatternMatchBegan = true;
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// If this last character is the end of the pattern, parse it.
					if ('Parse' in pParserState.Pattern)
					{
						// Run the t*mplate function
						let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
						if (tmpFunctionContext)
						{
							pParserState.OutputBuffer = pParserState.Pattern.Parse.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
						}
						else
						{
							pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
						}
						return this.resetOutputBuffer(pParserState);
					}
				}
			}
			else
			{
				// We are in a pattern start but didn't match one; reset and start trying again from this character.
				this.resetOutputBuffer(pParserState);
			}
		}
		// If we aren't in a pattern match or pattern, and this isn't the start of a new pattern (RAW mode)....
		if (!pParserState.PatternMatch)
		{
			// This may be the start of a new pattern....
			if (pCharacter in pParserState.ParseTree)
			{
				// ... assign the root node as the matched node.
				this.resetOutputBuffer(pParserState);
				this.appendOutputBuffer(pCharacter, pParserState);
				pParserState.Pattern = pParserState.ParseTree[pCharacter];
				pParserState.PatternMatch = true;
				return true;
			}
			else
			{
				this.appendOutputBuffer(pCharacter, pParserState);
			}
		}
		return false;
	}

	/**
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 * @param {function} fCallback - The callback function to call when the parse is complete
	 * @param {array} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 */
	executePatternAsync(pParserState, pData, fCallback, pDataContext, pScope, pState)
	{
		// ... this is the end of a pattern, cut off the end tag and parse it.
		// Trim the start and end tags off the output buffer now
		if (pParserState.Pattern.isAsync)
		{
			// Run the function
			let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
			if (tmpFunctionContext)
			{
				return pParserState.Pattern.ParseAsync.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData,
					(pError, pAsyncOutput) =>
					{
						if (pError)
						{
							this.fable.log.info(`Precedent ERROR: Async template error happened parsing ${pParserState.Pattern.PatternStart} ... ${pParserState.Pattern.PatternEnd}: ${pError}`);
						}

						pParserState.OutputBuffer = pAsyncOutput;
						this.resetOutputBuffer(pParserState);
						return fCallback();
					}, pDataContext, pScope, pState);
			}
			else
			{
				return pParserState.Pattern.ParseAsync(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData,
					(pError, pAsyncOutput) =>
					{
						if (pError)
						{
							this.fable.log.info(`Precedent ERROR: Async template error happened parsing ${pParserState.Pattern.PatternStart} ... ${pParserState.Pattern.PatternEnd}: ${pError}`);
						}

						pParserState.OutputBuffer = pAsyncOutput;
						this.resetOutputBuffer(pParserState);
						return fCallback();
					}, pDataContext, pScope, pState);
			}
		}
		else
		{
			// Run the t*mplate function
			let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
			if (tmpFunctionContext)
			{
				pParserState.OutputBuffer = pParserState.Pattern.Parse.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
			}
			else
			{
				pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
			}
			this.resetOutputBuffer(pParserState);
			return fCallback();
		}
	}


	/**
	 * Parse a character in the buffer.
	 * @method parseCharacterAsync
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 * @param {function} fCallback - The callback function to call when the parse is complete
	 * @param {array} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @private
	 */
	parseCharacterAsync (pCharacter, pParserState, pData, fCallback, pDataContext, pScope, pState)
	{
		// If we are already in a pattern match traversal
		if (pParserState.PatternMatch)
		{
			// If the pattern is still matching the start and we haven't passed the buffer
			if (!pParserState.StartPatternMatchComplete && (pCharacter in pParserState.Pattern))
			{
				pParserState.Pattern = pParserState.Pattern[pCharacter];
				this.appendOutputBuffer(pCharacter, pParserState);
			}
			else if (pParserState.EndPatternMatchBegan)
			{
				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// Flush the output buffer.
					this.appendOutputBuffer(pCharacter, pParserState);
					// If this last character is the end of the pattern, parse it.
					if ('Parse' in pParserState.Pattern)
					{
						return this.executePatternAsync(pParserState, pData, fCallback, pDataContext, pScope, pState);
					}
				}
				else if (pCharacter in pParserState.PatternStartNode.PatternEnd)
				{
					// We broke out of the end -- see if this is a new start of the end.
					pParserState.Pattern = pParserState.PatternStartNode.PatternEnd[pCharacter];
					this.appendOutputBuffer(pCharacter, pParserState);
				}
				else
				{
					// Partial end-pattern match aborted -- roll Pattern back to the start node so
					// subsequent characters scan for the end pattern from the beginning again.
					pParserState.EndPatternMatchBegan = false;
					pParserState.Pattern = pParserState.PatternStartNode;
					this.appendOutputBuffer(pCharacter, pParserState);
				}
			}
			else if ('PatternEnd' in pParserState.Pattern)
			{
				if (!pParserState.StartPatternMatchComplete)
				{
					pParserState.StartPatternMatchComplete = true;
					pParserState.PatternStartNode = pParserState.Pattern;
				}

				this.appendOutputBuffer(pCharacter, pParserState);

				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This is the first character of the end pattern.
					pParserState.EndPatternMatchBegan = true;
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// If this last character is the end of the pattern, parse it.
					if ('Parse' in pParserState.Pattern)
					{
						return this.executePatternAsync(pParserState, pData, fCallback, pDataContext, pScope, pState);
					}
				}
			}
			else
			{
				// We are in a pattern start but didn't match one; reset and start trying again from this character.
				this.resetOutputBuffer(pParserState);
			}
		}
		// If we aren't in a pattern match or pattern, and this isn't the start of a new pattern (RAW mode)....
		else
		{
			// This may be the start of a new pattern....
			if (pCharacter in pParserState.ParseTree)
			{
				// ... assign the root node as the matched node.
				this.resetOutputBuffer(pParserState);
				this.appendOutputBuffer(pCharacter, pParserState);
				pParserState.Pattern = pParserState.ParseTree[pCharacter];
				pParserState.PatternMatch = true;
			}
			else
			{
				this.appendOutputBuffer(pCharacter, pParserState);
			}
		}
		// Without this, templates of all sizes work fine in node.  They do not in the browser.
		// Trying this out without the timout on non asynchronous template flips.
		return fCallback();
	}

	/**
	 * Parse a string for matches, and process any template segments that occur.
	 * @method parseString
	 * @param {string} pString - The string to parse.
	 * @param {Object} pParseTree - The parse tree to begin parsing from (usually root)
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 * @param {function} fCallback - The callback function to call when the parse is complete
	 * @param {array} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 */
	parseString (pString, pParseTree, pData, fCallback, pDataContext, pScope, pState)
	{
		// TODO: There is danger here if a template function attempts to functionally recurse and doesn't pass this in.
		let tmpPreviousDataContext = (Array.isArray(pDataContext)) ? pDataContext : [];
		let tmpDataContext = Array.from(tmpPreviousDataContext);
		tmpDataContext.push(pData)

		if (typeof(fCallback) !== 'function')
		{
			let tmpParserState = this.newParserState(pParseTree);

			for (var i = 0; i < pString.length; i++)
			{
				// TODO: This is not fast.
				this.parseCharacter(pString[i], tmpParserState, pData, tmpDataContext, pScope, pState);
			}

			this.flushOutputBuffer(tmpParserState);

			return tmpParserState.Output;
		}
		else
		{
			// This is the async mode
			let tmpParserState = this.newParserState(pParseTree);
			tmpParserState.Asynchronous = true;

			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			for (let i = 0; i < pString.length; i++)
			{
				tmpAnticipate.anticipate(
					(fCallback) =>
					{
						this.parseCharacterAsync(pString[i], tmpParserState, pData, fCallback, tmpDataContext, pScope, pState);
					});
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					// Flush the remaining data
					this.flushOutputBuffer(tmpParserState);
					return fCallback(pError, tmpParserState.Output);
				});
		}
	}
}

module.exports = StringParser;

},{}],95:[function(require,module,exports){
/**
* Word Tree
* @author      Steven Velozo <steven@velozo.com>
* @description Create a tree (directed graph) of Javascript objects, one character per object.
*/

class WordTree
{
	/**
	 * WordTree Constructor
	 */
	constructor()
	{
		this.ParseTree = {};
	}

	/**
	 * Add a child character to a Parse Tree node
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addChild (pTree, pPattern)
	{
		if (!(pPattern in pTree))
		{
			pTree[pPattern] = {};
		}

		return pTree[pPattern];
	}

	/**
	 * Add a child character to a Parse Tree PatternEnd subtree
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addEndChild (pTree, pPattern)
	{
		if (!('PatternEnd' in pTree))
		{
			pTree.PatternEnd = {};
		}

		pTree.PatternEnd[pPattern] = {};

		return pTree.PatternEnd[pPattern];
	}

	/** Add a Pattern to the Parse Tree with both function parameter types
	 * @method addPatternAll
	 * @param {Object} pPatternStart - The starting string for the pattern (e.g. "${")
	 * @param {string} pPatternEnd - The ending string for the pattern (e.g. "}")
	 * @param {function} fParser - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @param {function} fParserAsync - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @param {Object} pParserContext - The context to pass to the parser function
	 * @return {Object} The leaf parser from the tree
	 */
	addPatternBoth (pPatternStart, pPatternEnd, fParser, fParserAsync, pParserContext)
	{
		if (pPatternStart.length < 1)
		{
			return false;
		}

		if ((typeof(pPatternEnd) === 'string') && (pPatternEnd.length < 1))
		{
			return false;
		}

		let tmpLeaf = this.ParseTree;

		// Add the tree of leaves iteratively
		for (var i = 0; i < pPatternStart.length; i++)
		{
			tmpLeaf = this.addChild(tmpLeaf, pPatternStart[i], i);
		}

		if (!('PatternEnd' in tmpLeaf))
		{
			tmpLeaf.PatternEnd = {};
		}

		let tmpPatternEnd = (typeof(pPatternEnd) === 'string') ? pPatternEnd : pPatternStart;
		for (let i = 0; i < tmpPatternEnd.length; i++)
		{
			tmpLeaf = this.addEndChild(tmpLeaf, tmpPatternEnd[i], i);
		}

		tmpLeaf.PatternStartString = pPatternStart;
		tmpLeaf.PatternEndString = tmpPatternEnd;
		tmpLeaf.Parse = (typeof(fParser) === 'function') ? fParser :
						(typeof(fParser) === 'string') ? (pHash, pData) => { return fParser; } :
						(pHash, pData) => { return pHash; };

		tmpLeaf.ParseAsync = (typeof(fParserAsync) === 'function') ? fParserAsync :
						(typeof(fParserAsync) === 'string') ? (pHash, pData, fCallback) => { return fCallback(null, fParserAsync); } :
						(pHash, pData, fCallback) => { return fCallback(null, tmpLeaf.Parse(pHash, pData)); }

		// A "this" for every object
		if (pParserContext)
		{
			tmpLeaf.ParserContext = pParserContext;
		}

		tmpLeaf.isAsync = true;

		return tmpLeaf;
	}

	/** Add a Pattern to the Parse Tree with both function parameter types
	 * @method addPatternAll
	 * @param {Object} pPatternStart - The starting string for the pattern (e.g. "${")
	 * @param {string} pPatternEnd - The ending string for the pattern (e.g. "}")
	 * @param {function} fParser - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @param {Object} pParserContext - The context to pass to the parser function
	 */
	addPattern (pPatternStart, pPatternEnd, fParser, pParserContext)
	{
		return this.addPatternBoth(pPatternStart, pPatternEnd, fParser, null, pParserContext);
	}
}

module.exports = WordTree;

},{}],96:[function(require,module,exports){
module.exports = (
	{
		"Metadata": {
			"UUID": false,
			"Hash": false,

			"Name": "",
			"Summary": "",

			"Version": 0
		},
		"Status": {
			"Completed": false,
			"StepCount": 1
		},
		"Steps": [],
		"Errors": [],
		"Log": []
	}
);
},{}],97:[function(require,module,exports){
const { PE } = require('big.js');
const libFableServiceBase = require('fable-serviceproviderbase');

const _OperationStatePrototypeString = JSON.stringify(require('./Fable-Service-Operation-DefaultSettings.js'));

class FableOperation extends libFableServiceBase
{

	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Timestamps will just be the long ints
		this.timeStamps = {};

		this.serviceType = 'PhasedOperation';

		this.state = JSON.parse(_OperationStatePrototypeString);

		this.stepMap = {};
		this.stepFunctions = {};

		// Match the service instantiation to the operation.
		this.state.Metadata.Hash = this.Hash;
		this.state.Metadata.UUID = this.UUID;

		this.state.Metadata.Name = (typeof(this.options.Name) == 'string') ? this.options.Name : `Unnamed Operation ${this.state.Metadata.UUID}`;
		this.name = this.state.Metadata.Name;

		this.progressTrackerSet = this.fable.instantiateServiceProviderWithoutRegistration('ProgressTrackerSet');

		this.state.OverallProgressTracker = this.progressTrackerSet.createProgressTracker(`Overall-${this.state.Metadata.UUID}`);

		// This is here to use the pass-through logging functions in the operation itself.
		this.log = this;
	}

	execute(fExecutionCompleteCallback)
	{
		// TODO: Should the same operation be allowed to execute more than one time?
		if (this.state.OverallProgressTracker.StartTimeStamp > 0)
		{
			return fExecutionCompleteCallback(new Error(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} has already been executed!`));
		}

		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		this.progressTrackerSet.setProgressTrackerTotalOperations(this.state.OverallProgressTracker.Hash, this.state.Status.StepCount);
		this.progressTrackerSet.startProgressTracker(this.state.OverallProgressTracker.Hash);
		this.info(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} starting...`);

		for (let i = 0; i < this.state.Steps.length; i++)
		{
			tmpAnticipate.anticipate(
				function(fNext)
				{
					this.fable.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}] ${this.state.Steps[i].Name} starting...`);
					this.progressTrackerSet.startProgressTracker(this.state.Steps[i].ProgressTracker.Hash);
					return fNext();
				}.bind(this));
			// Steps are executed in a custom context with
			tmpAnticipate.anticipate(this.stepFunctions[this.state.Steps[i].GUIDStep].bind(
				{
					log:this,
					fable:this.fable,
					options:this.state.Steps[i].Metadata,
					metadata:this.state.Steps[i].Metadata,
					ProgressTracker:this.progressTrackerSet.getProgressTracker(this.state.Steps[i].ProgressTracker.Hash),
					logProgressTrackerStatus: function()
						{
							return this.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}]: ${this.progressTrackerSet.getProgressTrackerStatusString(this.state.Steps[i].ProgressTracker.Hash)}`);
						}.bind(this),
					OperationState:this.state,
					StepState:this.state.Steps[i]
				}));
			tmpAnticipate.anticipate(
				function(fNext)
				{
					this.progressTrackerSet.endProgressTracker(this.state.Steps[i].ProgressTracker.Hash);
					let tmpStepTimingMessage = this.progressTrackerSet.getProgressTrackerStatusString(this.state.Steps[i].ProgressTracker.Hash);
					this.fable.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}] ${this.state.Steps[i].Name} complete.`);
					this.fable.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}] ${this.state.Steps[i].Name} ${tmpStepTimingMessage}.`);

					this.progressTrackerSet.incrementProgressTracker(this.state.OverallProgressTracker.Hash, 1);
					let tmpOperationTimingMessage = this.progressTrackerSet.getProgressTrackerStatusString(this.state.OverallProgressTracker.Hash);
					this.fable.log.info(`Operation [${this.state.Metadata.UUID}] ${tmpOperationTimingMessage}.`);
					return fNext();
				}.bind(this));
		}

		// Wait for the anticipation to complete
		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.fable.log.error(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} had an error: ${pError}`, pError);
					return fExecutionCompleteCallback(pError);
				}
				this.info(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} complete.`);
				let tmpOperationTimingMessage = this.progressTrackerSet.getProgressTrackerStatusString(this.state.OverallProgressTracker.Hash);
				this.progressTrackerSet.endProgressTracker(this.state.OverallProgressTracker.Hash);
				this.fable.log.info(`Operation [${this.state.Metadata.UUID}] ${tmpOperationTimingMessage}.`);
				return fExecutionCompleteCallback();
			});
	}

	// There are three ways to add steps:
	// 1. As a basic javascript function
	//    --
	//    This is the most basic, java"script" way to add a step.  It will
	//    setup a "this" context that has the following properties:
	//    - log: A reference to the operation's log object

	addStep(fStepFunction, pStepMetadata, pStepName, pStepDescription, pGUIDStep)
	{
		let tmpStep = {};

		// GUID is optional
		tmpStep.GUIDStep = (typeof(pGUIDStep) !== 'undefined') ? pGUIDStep : `STEP-${this.state.Steps.length}-${this.fable.DataGeneration.randomNumericString()}`;


		// Name is optional
		tmpStep.Name = (typeof(pStepName) !== 'undefined') ? pStepName : `Step [${tmpStep.GUIDStep}]`;
		tmpStep.Description = (typeof(pStepDescription) !== 'undefined') ? pStepDescription : `Step execution of ${tmpStep.Name}.`;

		tmpStep.ProgressTracker = this.progressTrackerSet.createProgressTracker(tmpStep.GUIDStep);

		tmpStep.Metadata = (typeof(pStepMetadata) === 'object') ? pStepMetadata : {};

		// There is an array of steps, in the Operation State itself ... push a step there
		this.state.Steps.push(tmpStep);

		this.stepMap[tmpStep.GUIDStep] = tmpStep;

		this.stepFunctions[tmpStep.GUIDStep] = typeof(fStepFunction) == 'function' ? fStepFunction : function (fDone) { return fDone(); };

		this.state.Status.StepCount++;

		return tmpStep;
	}

	setStepTotalOperations(pGUIDStep, pTotalOperationCount)
	{
		if (!(pGUIDStep in this.stepMap))
		{
			return new Error(`Step [${pGUIDStep}] does not exist in operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} when attempting to set total operations to ${pTotalOperationCount}.`);
		}

		this.progressTrackerSet.setProgressTrackerTotalOperations(this.stepMap[pGUIDStep].ProgressTracker.Hash, pTotalOperationCount);
	}

	writeOperationLog(pLogLevel, pLogText, pLogObject)
	{
		this.state.Log.push(`[${new Date().toUTCString()}]-[${pLogLevel}]: ${pLogText}`);

		if (typeof(pLogObject) == 'object')
		{
			this.state.Log.push(JSON.stringify(pLogObject));
		}
	}

	writeOperationErrors(pLogText, pLogObject)
	{
		this.state.Errors.push(`${pLogText}`);

		if (typeof(pLogObject) == 'object')
		{
			this.state.Errors.push(JSON.stringify(pLogObject));
		}
	}

	trace(pLogText, pLogObject)
	{
		this.writeOperationLog('TRACE', pLogText, pLogObject);
		this.fable.log.trace(pLogText, pLogObject);
	}

	debug(pLogText, pLogObject)
	{
		this.writeOperationLog('DEBUG', pLogText, pLogObject);
		this.fable.log.debug(pLogText, pLogObject);
	}

	info(pLogText, pLogObject)
	{
		this.writeOperationLog('INFO', pLogText, pLogObject);
		this.fable.log.info(pLogText, pLogObject);
	}

	warn(pLogText, pLogObject)
	{
		this.writeOperationLog('WARN', pLogText, pLogObject);
		this.fable.log.warn(pLogText, pLogObject);
	}

	error(pLogText, pLogObject)
	{
		this.writeOperationLog('ERROR', pLogText, pLogObject);
		this.writeOperationErrors(pLogText, pLogObject);
		this.fable.log.error(pLogText, pLogObject);
	}

	fatal(pLogText, pLogObject)
	{
		this.writeOperationLog('FATAL', pLogText, pLogObject);
		this.writeOperationErrors(pLogText, pLogObject);
		this.fable.log.fatal(pLogText, pLogObject);
	}
}

module.exports = FableOperation;

},{"./Fable-Service-Operation-DefaultSettings.js":96,"big.js":17,"fable-serviceproviderbase":59}],98:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceProgressTime extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'ProgressTime';

		this.timeStamps = {};
	}

	formatTimeDuration(pTimeDurationInMilliseconds)
	{
		let tmpTimeDuration = typeof(pTimeDurationInMilliseconds) == 'number' ? pTimeDurationInMilliseconds : 0;

		if (pTimeDurationInMilliseconds < 0)
		{
			return 'unknown';
		}

		let tmpTimeDurationString = '';
		if (tmpTimeDuration > 3600000)
		{
			tmpTimeDurationString += Math.floor(tmpTimeDuration/3600000)+'h ';
			tmpTimeDuration = tmpTimeDuration % 3600000;
		}
		if (tmpTimeDuration > 60000)
		{
			tmpTimeDurationString += Math.floor(tmpTimeDuration/60000)+'m ';
			tmpTimeDuration = tmpTimeDuration % 60000;
		}
		if (tmpTimeDuration > 1000)
		{
			tmpTimeDurationString += Math.floor(tmpTimeDuration/1000)+'s ';
			tmpTimeDuration = tmpTimeDuration % 1000;
		}
		tmpTimeDurationString += Math.round(tmpTimeDuration)+'ms';

		return tmpTimeDurationString;
	}

	createTimeStamp(pTimeStampHash)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		this.timeStamps[tmpTimeStampHash] = +new Date();
		return this.timeStamps[tmpTimeStampHash];
	}

	getTimeStampValue(pTimeStampHash)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		return (tmpTimeStampHash in this.timeStamps) ? this.timeStamps[tmpTimeStampHash] : -1;
	}

	updateTimeStampValue(pTimeStampHash, pReferenceTime)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		let tmpReferenceTime = false;

		// This function allows the user to pass in either a reference time in ms, or, a hash of a timestamp.
		if (typeof(pReferenceTime) == 'string')
		{
			tmpReferenceTime = (tmpReference in this.timeStamps) ? this.timeStamps[tmpReference] : false;
		}
		else if (typeof(pReferenceTime) == 'number')
		{
			tmpReferenceTime = pReferenceTime;
		}
		else
		{
			tmpReferenceTime = +new Date();
		}

		if ((tmpTimeStampHash in this.timeStamps) && tmpReferenceTime)
		{
			this.timeStamps[tmpTimeStampHash] = tmpReferenceTime;
			return this.timeStamps[tmpTimeStampHash];
		}
		else
		{
			return -1;
		}
	}

	removeTimeStamp(pTimeStampHash)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		if (tmpTimeStampHash in this.timeStamps)
		{
			delete this.timeStamps[tmpTimeStampHash];
			return true;
		}
		else
		{
			return false;
		}
	}

	getTimeStampDelta(pTimeStampHash, pReferenceTime)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		let tmpReferenceTime = false;

		// This function allows the user to pass in either a reference time in ms, or, a hash of a timestamp.
		if (typeof(pReferenceTime) == 'string')
		{
			tmpReferenceTime = (tmpReference in this.timeStamps) ? this.timeStamps[tmpReference] : false;
		}
		else if (typeof(pReferenceTime) == 'number')
		{
			tmpReferenceTime = pReferenceTime;
		}
		else
		{
			tmpReferenceTime = +new Date();
		}

		if ((tmpTimeStampHash in this.timeStamps) && tmpReferenceTime)
		{
			return tmpReferenceTime-this.timeStamps[tmpTimeStampHash];
		}
		else
		{
			return -1;
		}
	}

	getDurationBetweenTimestamps(pTimeStampHashStart, pTimeStampHashEnd)
	{
		let tmpTimeStampHashStart = (typeof(pTimeStampHashStart) == 'string') ? pTimeStampHashStart : 'Default';
		let tmpTimeStampHashEnd = (typeof(pTimeStampHashEnd) == 'string') ? pTimeStampHashEnd : 'Default';
		if ((tmpTimeStampHashStart in this.timeStamps) && (tmpTimeStampHashEnd in this.timeStamps))
		{
			return this.timeStamps[tmpTimeStampHashEnd]-this.timeStamps[tmpTimeStampHashStart];
		}
		else
		{
			return -1;
		}
	}

	getTimeStampDeltaMessage(pTimeStampHash, pMessage, pReferenceTime)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : `Elapsed for ${tmpTimeStampHash}: `;
		let tmpOperationTime = this.getTimeStampDelta(tmpTimeStampHash, pReferenceTime);

		return `${tmpMessage} ${this.formatTimeDuration(tmpOperationTime)}`;
	}

	logTimeStampDelta(pTimeStampHash, pMessage, pReferenceTime)
	{
		this.fable.log.info(this.getTimeStampDeltaMessage(pTimeStampHash, pMessage, pReferenceTime));
	}
}

module.exports = FableServiceProgressTime;

},{"fable-serviceproviderbase":59}],99:[function(require,module,exports){
class ProgressTracker
{
	constructor(pProgressTrackerSet, pProgressTrackerHash)
	{
		this.progressTrackerSet = pProgressTrackerSet;
		this.progressTrackerHash = pProgressTrackerHash;

		this.data = this.progressTrackerSet.getProgressTrackerData(this.progressTrackerHash);
	}

	updateProgressTracker(pProgressAmount)
	{
		return this.progressTrackerSet.updateProgressTracker(this.progressTrackerHash, pProgressAmount);
	}

	incrementProgressTracker(pProgressIncrementAmount)
	{
		return this.progressTrackerSet.incrementProgressTracker(this.progressTrackerHash, pProgressIncrementAmount);
	}

	setProgressTrackerTotalOperations(pTotalOperationCount)
	{
		return this.progressTrackerSet.setProgressTrackerTotalOperations(this.progressTrackerHash, pTotalOperationCount);
	}

	getProgressTrackerStatusString()
	{
		return this.progressTrackerSet.getProgressTrackerStatusString(this.progressTrackerHash);
	}
}

module.exports = ProgressTracker;
},{}],100:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libProgressTrackerClass = require('./Fable-Service-ProgressTracker/ProgressTracker.js');

class FableServiceProgressTrackerSet extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'ProgressTrackerSet';

		this.progressTrackers = {};

		// Create an internal PorgressTime service to track timestamps
		this.progressTimes = this.fable.instantiateServiceProviderWithoutRegistration('ProgressTime');

		// This timestamp is used and updated by *all* progress trackers.
		this.progressTimes.createTimeStamp('CurrentTime');
	}

	getProgressTracker(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`ProgressTracker ${tmpProgressTrackerHash} does not exist!  Creating a new tracker...`);
			this.createProgressTracker(tmpProgressTrackerHash, 100);
		}

		return new libProgressTrackerClass(this, pProgressTrackerHash);
	}

	getProgressTrackerData(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`ProgressTracker ${tmpProgressTrackerHash} does not exist!  Creating a new tracker...`);
			this.createProgressTracker(tmpProgressTrackerHash, 100);
		}

		return this.progressTrackers[tmpProgressTrackerHash];
	}

	createProgressTracker(pProgressTrackerHash, pTotalOperations)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpTotalOperations = (typeof(pTotalOperations) == 'number') ? pTotalOperations : 100;

		let tmpProgressTracker = (
			{
				Hash: tmpProgressTrackerHash,

				StartTimeHash: `${tmpProgressTrackerHash}-Start`,
				StartTimeStamp: -1,
				CurrentTimeStamp: -1,
				EndTimeHash: `${tmpProgressTrackerHash}-End`,
				EndTimeStamp: -1,

				PercentComplete: -1,
				// If this is set to true, PercentComplete will be calculated as CurrentCount / TotalCount even if it goes over 100%
				AllowTruePercentComplete: false,

				ElapsedTime: -1,
				AverageOperationTime: -1,
				EstimatedCompletionTime: -1,

				TotalCount: tmpTotalOperations,

				CurrentCount:-1
			});

		if (tmpProgressTrackerHash in this.progressTrackers)
		{
			this.fable.log.warn(`ProgressTracker ${tmpProgressTrackerHash} already exists!  Overwriting with a new tracker...`);
			this.progressTimes.removeTimeStamp(tmpProgressTracker.StartTimeHash);
			this.progressTimes.removeTimeStamp(tmpProgressTracker.EndTimeHash);
		}

		this.progressTrackers[tmpProgressTrackerHash] = tmpProgressTracker;

		return tmpProgressTracker;
	}

	setProgressTrackerTotalOperations(pProgressTrackerHash, pTotalOperations)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpTotalOperations = (typeof(pTotalOperations) == 'number') ? pTotalOperations : 100;

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`Attempted to set the total operations of ProgressTracker ${tmpProgressTrackerHash} but it does not exist!  Creating a new tracker...`);
			this.createProgressTracker(tmpProgressTrackerHash, tmpTotalOperations);
		}

		this.progressTrackers[tmpProgressTrackerHash].TotalCount = tmpTotalOperations;

		return this.progressTrackers[tmpProgressTrackerHash];
	}

	startProgressTracker(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This is the only method to lazily create ProgressTrackers now
		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.createProgressTracker(tmpProgressTrackerHash, 100);
		}

		let tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		this.progressTimes.createTimeStamp(this.progressTrackers[tmpProgressTrackerHash].StartTimeHash);
		tmpProgressTracker.StartTimeStamp = this.progressTimes.getTimeStampValue(this.progressTrackers[tmpProgressTrackerHash].StartTimeHash);
		if (tmpProgressTracker.CurrentCount < 0)
		{
			tmpProgressTracker.CurrentCount = 0;
		}

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	endProgressTracker(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.error(`Attempted to end ProgressTracker ${tmpProgressTrackerHash} that does not exist!`);
			return false;
		}

		let tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		this.progressTimes.createTimeStamp(this.progressTrackers[tmpProgressTrackerHash].EndTimeHash);
		tmpProgressTracker.EndTimeStamp = this.progressTimes.getTimeStampValue(this.progressTrackers[tmpProgressTrackerHash].EndTimeHash);

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	solveProgressTrackerStatus(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.error(`Attempted to solve ProgressTracker ${tmpProgressTrackerHash} that does not exist!`);
			return false;
		}

		let tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		if ((tmpProgressTracker.TotalCount < 1) || isNaN(tmpProgressTracker.TotalCount))
		{
			this.fable.log.error(`ProgressTracker ${tmpProgressTracker.Hash} has an invalid total count of operations (${tmpProgressTracker.TotalCount}!  Setting it to the default of 100...`);
			tmpProgressTracker.TotalCount = 100;
		}

		// Compute the percentage of progress that is complete.
		if (tmpProgressTracker.CurrentCount < 1)
		{
			tmpProgressTracker.PercentComplete = 0;
		}
		else
		{
			tmpProgressTracker.PercentComplete = (tmpProgressTracker.CurrentCount / tmpProgressTracker.TotalCount) * 100.0;
		}

		if (!tmpProgressTracker.AllowTruePercentComplete && (tmpProgressTracker.PercentComplete > 100))
		{
			tmpProgressTracker.PercentComplete = 100;
		}

		// Compute the average time per operation
		this.progressTimes.updateTimeStampValue('CurrentTime');
		tmpProgressTracker.CurrentTimeStamp = this.progressTimes.getTimeStampValue('CurrentTime');
		tmpProgressTracker.ElapsedTime = tmpProgressTracker.CurrentTimeStamp - tmpProgressTracker.StartTimeStamp;

		if (tmpProgressTracker.EndTimeStamp > 0)
		{
			tmpProgressTracker.ElapsedTime = tmpProgressTracker.EndTimeStamp - tmpProgressTracker.StartTimeStamp;
		}

		if (tmpProgressTracker.CurrentCount > 0)
		{
			tmpProgressTracker.AverageOperationTime = (tmpProgressTracker.CurrentTimeStamp-tmpProgressTracker.StartTimeStamp) / tmpProgressTracker.CurrentCount;
		}
		else
		{
			tmpProgressTracker.AverageOperationTime = -1;
		}

		// Compute the estimated completion
		if (tmpProgressTracker.AverageOperationTime > 0)
		{
			tmpProgressTracker.EstimatedCompletionTime = Math.max((tmpProgressTracker.TotalCount - tmpProgressTracker.CurrentCount), 0) * tmpProgressTracker.AverageOperationTime;
		}
		else
		{
			tmpProgressTracker.EstimatedCompletionTime = -1;
		}

		return tmpProgressTracker;
	}

	updateProgressTracker(pProgressTrackerHash, pCurrentOperations)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpCurrentOperations = parseInt(pCurrentOperations);

		if (isNaN(tmpCurrentOperations))
		{
			this.fable.log.warn(`Attempted to update ProgressTracker ${tmpProgressTrackerHash} with an invalid number of operations!`)
			return false;
		}

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.createProgressTracker(100, tmpProgressTrackerHash);
		}

		this.progressTrackers[tmpProgressTrackerHash].CurrentCount = tmpCurrentOperations;

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	incrementProgressTracker(pProgressTrackerHash, pOperationIncrementAmount)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpOperationIncrementAmount = parseInt(pOperationIncrementAmount);

		if (isNaN(tmpOperationIncrementAmount))
		{
			tmpOperationIncrementAmount = 1;
		}

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`Attempted to increment ProgressTracker ${tmpProgressTrackerHash} but it did not exist.`);
			return false;
		}

		if (this.progressTrackers[tmpProgressTrackerHash].StartTimeStamp < 1)
		{
			this.fable.log.warn(`Attempted to increment ProgressTracker ${tmpProgressTrackerHash} but it was not started.. starting now.`);
			this.startProgressTracker(tmpProgressTrackerHash);
		}

		this.progressTrackers[tmpProgressTrackerHash].CurrentCount = this.progressTrackers[tmpProgressTrackerHash].CurrentCount + tmpOperationIncrementAmount;

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	getProgressTrackerCompletedOperationCountString(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This call here can mean if we add operations and then immediately get the string, this function runs twice.
		const tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		// The states of a progress tracker:
		if (tmpProgressTracker.CurrentCount < 0)
		{
			return `none`;
		}
		else if (tmpProgressTracker.CurrentCount < 1)
		{
			return `0`;
		}
		else
		{
			return `${tmpProgressTracker.CurrentCount}`;
		}
	}

	getProgressTrackerPercentCompleteString(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This call here can mean if we add operations and then immediately get the string, this function runs twice.
		// TODO: Is there a pattern to avoid this double call that's worth putting in?
		this.solveProgressTrackerStatus(tmpProgressTrackerHash);

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			return `ProgressTracker ${tmpProgressTrackerHash} does not exist!  No stats to display.`;
		}
		else
		{
			const tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

			// The states of a progress tracker:
			// 1. Not started
			if (tmpProgressTracker.StartTimeStamp < 1)
			{
				return `0%`;
			}
			// 2. Started, but no operations completed

			if (tmpProgressTracker.CurrentCount < 1)
			{
				return `0%`;
			}
			// 3. Started, some operations completed
			else if (tmpProgressTracker.EndTimeStamp < 1)
			{
				return `${tmpProgressTracker.PercentComplete.toFixed(3)}%`;
			}
			// 4. Done
			else
			{
				return `${tmpProgressTracker.PercentComplete.toFixed(3)}%`;
			}
		}
	}

	getProgressTrackerStatusString(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This call here can mean if we add operations and then immediately get the string, this function runs twice.
		// TODO: Is there a pattern to avoid this double call that's worth putting in?
		this.solveProgressTrackerStatus(tmpProgressTrackerHash);

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			return `ProgressTracker ${tmpProgressTrackerHash} does not exist!  No stats to display.`;
		}
		else
		{
			const tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

			// The states of a progress tracker:
			// 1. Not started
			if (tmpProgressTracker.StartTimeStamp < 1)
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} has not been started yet.`;
			}
			// 2. Started, but no operations completed

			if ((tmpProgressTracker.CurrentCount < 1) && (tmpProgressTracker.EndTimeStamp < 1))
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} has no completed operations.  ${this.progressTimes.formatTimeDuration(tmpProgressTracker.ElapsedTime)} have elapsed since it was started.`;
			}
			// 3. Started, some operations completed
			else if (tmpProgressTracker.EndTimeStamp < 1)
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} is ${tmpProgressTracker.PercentComplete.toFixed(3)}% completed - ${tmpProgressTracker.CurrentCount} / ${tmpProgressTracker.TotalCount} operations over ${this.progressTimes.formatTimeDuration(tmpProgressTracker.ElapsedTime)} (median ${this.progressTimes.formatTimeDuration(tmpProgressTracker.AverageOperationTime)} per).  Estimated completion: ${this.progressTimes.formatTimeDuration(tmpProgressTracker.EstimatedCompletionTime)}`;			}
			// 4. Done
			else
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} is done.  ${tmpProgressTracker.CurrentCount} / ${tmpProgressTracker.TotalCount} operations were completed in ${this.progressTimes.formatTimeDuration(tmpProgressTracker.ElapsedTime)} (median ${this.progressTimes.formatTimeDuration(tmpProgressTracker.AverageOperationTime)} per).`;
			}
		}
	}

	logProgressTrackerStatus(pProgressTrackerHash)
	{
		this.fable.log.info(this.getProgressTrackerStatusString(pProgressTrackerHash));
	}
}

module.exports = FableServiceProgressTrackerSet;
},{"./Fable-Service-ProgressTracker/ProgressTracker.js":99,"fable-serviceproviderbase":59}],101:[function(require,module,exports){
(function (Buffer){(function (){
const libFableServiceBase = require('fable-serviceproviderbase');

const libSimpleGet = require('simple-get');
const libCookie = require('cookie');
const libHttp = require('http');
const libHttps = require('https');

/**
 * @typedef {Object} RestClientRetryPolicy
 * @property {number} MaxAttempts - Total attempts including the first (1 disables retry).
 * @property {number} InitialDelayMS - Delay before the first retry.
 * @property {number} MaxDelayMS - Ceiling for any single backoff delay.
 * @property {number} BackoffFactor - Multiplier applied to the delay per attempt.
 * @property {number} JitterRatio - Fraction of the delay randomized (0 disables jitter).
 * @property {Array<string>} RetryMethods - HTTP methods considered idempotent, and thus retryable.
 * @property {Array<number>} RetryStatusCodes - Response status codes treated as transient.
 * @property {Array<string>} RetryErrorCodes - Transport error codes treated as transient.
 * @property {boolean} RespectRetryAfter - Honor a Retry-After response header when present.
 * @property {number} MaxRetryAfterMS - Ceiling on a server-supplied Retry-After delay.
 */

/**
 * @typedef {Object} RestClientRetryContext
 * @property {Record<string, any>} Options - The replay options for this request.
 * @property {Error|null} Error - The transport error, when the request never completed.
 * @property {Object} [Response] - The response, when one was received.
 * @property {*} [Body] - The processed body (parsed JSON / string / Buffer), when one was received.
 * @property {RestClientRetryPolicy} Policy - The resolved policy for this request.
 * @property {number} AttemptsMade - Attempts made so far, including this one.
 * @property {number|null} [DelayMS] - Backoff before the pending replay; null when settling.
 */

/**
 * @typedef {Object} RestClientRetrySafetyContext
 * @property {Record<string, any>} Options - The request under consideration. No response exists yet:
 *   safety is a property of the request, not of how it turned out.
 * @property {RestClientRetryPolicy} Policy - The resolved policy for this request.
 */

/**
 * Attempt count used when retry is switched on without an explicit budget
 * (`Retry: true`). One original attempt plus two replays.
 *
 * @type {number}
 */
const ENABLED_RETRY_ATTEMPTS = 3;

/**
 * Chain length at which unkeyed hook registration is called out as probable lifecycle churn. High
 * enough that a legitimately layered application never trips it, low enough to surface a leak long
 * before it matters.
 *
 * @type {number}
 */
const RETRY_HOOK_CHAIN_WARNING_LENGTH = 32;

/**
 * Statuses defined to carry no message body (RFC 7231 §6.3.5, §6.3.6; RFC 7232
 * §4.1). An empty body on one of these is the contract, not a parse failure.
 *
 * @type {Array<number>}
 */
const NO_CONTENT_STATUS_CODES = [ 204, 205, 304 ];

/**
 * The stock retry policy. `MaxAttempts: 1` means retry is OFF by default -- an
 * un-configured client behaves exactly as it always has, with no replay of any
 * kind. Callers opt in per-service, per-client, or per-request.
 *
 * The remaining fields describe what retry looks like ONCE enabled, and stay
 * conservative:
 *   - Only idempotent methods retry; a POST/PUT/PATCH/DELETE retries only when
 *     the caller explicitly marks that request `RetrySafe: true`.
 *   - 500 is NOT retried. A 500 out of meadow is a deterministic server-side
 *     failure (bad SQL, bad filter) that replays identically; the gateway codes
 *     (502/503/504) and 408/425/429 are the genuinely transient ones. An
 *     application that knows better can widen this, or classify on the body.
 *
 * @type {RestClientRetryPolicy}
 */
const DEFAULT_RETRY_POLICY =
{
	MaxAttempts: 1,
	InitialDelayMS: 250,
	MaxDelayMS: 5000,
	BackoffFactor: 2,
	JitterRatio: 0.25,
	RetryMethods: [ 'GET', 'HEAD', 'OPTIONS' ],
	RetryStatusCodes: [ 408, 425, 429, 502, 503, 504 ],
	RetryErrorCodes:
		[
			// ENOTFOUND is deliberately absent -- a name that does not resolve will
			// not resolve on the retry either; EAI_AGAIN covers transient DNS.
			'ECONNRESET', 'ECONNREFUSED', 'ECONNABORTED', 'EPIPE', 'ETIMEDOUT', 'ESOCKETTIMEDOUT',
			'EAI_AGAIN', 'ENETUNREACH', 'ENETRESET', 'EHOSTUNREACH',
			'ERR_STREAM_PREMATURE_CLOSE', 'UND_ERR_SOCKET', 'ERR_SOCKET_CONNECTION_TIMEOUT'
		],
	RespectRetryAfter: true,
	MaxRetryAfterMS: 30000
};

class FableServiceRestClient extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.TraceLog = false;
		if (this.options.TraceLog || this.fable.TraceLog)
		{
			this.TraceLog = true;
		}

		this.dataFormat = this.fable.services.DataFormat;

		this.serviceType = 'RestClient';

		this.cookie = false;

		// This is a function that can be overridden, to allow the management
		// of the request options before they are passed to the request library.
		this.prepareRequestOptions = (pOptions) => { return pOptions; };

		// Optional, UI-agnostic authentication-recovery hook. Default null, so
		// existing server-to-server callers are completely unaffected. When set
		// to an (async) function and a completed response has statusCode 401 on a
		// request that is not itself a replay, the client awaits this hook; a
		// truthy resolution replays the original request exactly once, anything
		// else returns the original 401 to the caller unchanged. The hook never
		// imports app UI -- the app assigns it (e.g. a re-auth modal controller),
		// which is what makes recovery reusable across every Fable consumer.
		this.authenticationRecovery = null;

		// Single-flight state for the recovery hook: a burst of concurrent 401s
		// collapses to exactly one authenticationRecovery() call. Cleared on
		// settle so a later, unrelated expiry re-arms recovery.
		this._authenticationRecoveryPromise = null;

		// Default per-request timeout (ms). Applied in preRequest when a caller
		// does not supply their own. Node 20+ installs a ~5s socket timeout on
		// http.globalAgent that aborts legitimately long-running requests; any
		// explicit `timeout` on the request options takes that default out of
		// play. See the "Request Timeout" test suite for the behaviors covered.
		if (typeof this.options.RequestTimeout === 'number')
		{
			this.defaultRequestTimeout = this.options.RequestTimeout;
		}
		else if (typeof this.fable.settings.RestClientRequestTimeout === 'number')
		{
			this.defaultRequestTimeout = this.fable.settings.RestClientRequestTimeout;
		}
		else
		{
			this.defaultRequestTimeout = 60000;
		}

		// Always install our own http/https agents so every request bypasses
		// http.globalAgent (and its Node 20+ mystery socket timeout). The
		// KeepAlive flag only controls whether keepAlive is enabled on our own
		// agents, not whether we have agents at all. Additional tuning
		// (maxSockets, agent timeout, etc.) flows through KeepAliveAgentOptions.
		let tmpKeepAlive = Boolean(this.options.KeepAlive || this.fable.settings.RestClientKeepAlive);
		let tmpAgentOptions = Object.assign({}, this.options.KeepAliveAgentOptions);
		if (tmpKeepAlive)
		{
			tmpAgentOptions.keepAlive = true;
		}
		this._installHttpAgents(tmpAgentOptions);

		// Service-level retry policy, layered defaults <- fable settings <-
		// constructor options. Any individual request can further override (or
		// disable) this via a `Retry` property on its options object.
		this.retryPolicy = this._buildRetryPolicy(this.fable.settings.RestClientRetry, this.options.Retry);

		// Timer seam so tests (and non-DOM hosts) can drive backoff without
		// wall-clock waits. Signature matches setTimeout(callback, delay).
		this.retryTimerFunction = (fCallback, pDelayMS) => setTimeout(fCallback, pDelayMS);

		// Random source for backoff jitter; overridable for deterministic tests.
		this.retryJitterFunction = () => Math.random();

		// Re-raise seam for exceptions escaping a promise continuation. See
		// _invokeDetached; overridable for tests.
		this.detachedThrowFunction = (pDetachedError) => { setTimeout(() => { throw pDetachedError; }, 0); };

		// Optional, application-supplied outcome classifier. The stock policy can
		// only see the status code and the transport error code; an API that
		// reports failure some other way (a 200 carrying an error field, a
		// vendor-specific envelope) needs the body to make the call. Return
		// 'retry' to treat the outcome as transient, 'settle' to suppress a retry
		// the policy would otherwise take, or null/undefined to defer to the
		// policy. Eligibility still gates everything -- a classifier cannot make a
		// non-idempotent request replayable.
		//
		// Example, for a legacy API that answers 200 with a top-level Error string:
		//   tmpRestClient.retryClassifier = (pContext) =>
		//   {
		//       if (pContext.Body && typeof pContext.Body.Error === 'string')
		//       {
		//           return (/timeout|deadlock|unavailable/i.test(pContext.Body.Error)) ? 'retry' : 'settle';
		//       }
		//       return null;
		//   };
		/** @type {((pContext: RestClientRetryContext) => ('retry'|'settle'|null|undefined))|null} */
		this.retryClassifier = (typeof this.options.RetryClassifier === 'function') ? this.options.RetryClassifier : null;

		// Decision-hook chains. Both are consulted in registration order, ahead of
		// the built-in rule that tails each chain; a hook returns a verdict to
		// decide or nothing to defer to whatever comes after it. Registering is
		// how a library teaches the client about its own routes without every call
		// site having to remember to say so -- pict registers the meadow
		// POST /:Entity/Query route as replayable, and nothing that borrows the
		// client needs to know it did.
		//
		// Safety ("may this be replayed at all") and classification ("was this
		// outcome transient") are kept apart on purpose. Safety is a hard gate
		// above classification, so no classification hook can ever authorize
		// replaying a mutation.
		//
		// Hooks must be synchronous -- they run inline while the outcome is being
		// decided. The lifecycle hooks (onBeforeRetry / onRetryExhausted) are the
		// async ones, because those do work rather than answer questions.
		/** @type {Array<(pContext: RestClientRetrySafetyContext) => (boolean|null|undefined)>} */
		this.retrySafetyHooks = [];
		/** @type {Array<(pContext: RestClientRetryContext) => ('retry'|'settle'|null|undefined)>} */
		this.retryClassifierHooks = [];

		// Lifecycle hooks. Both may be async and are awaited, so a hook can do
		// real work before the replay goes out -- refresh a stream handle or a
		// token, re-sign a URL, bump a metric. The context's `Options` object IS
		// the one about to be replayed, so mutating it (headers, url, body)
		// redirects the retry.
		//
		// onBeforeRetry additionally acts as a veto: resolving exactly false
		// abandons the retry and settles with the outcome in hand.
		/** @type {((pContext: RestClientRetryContext) => any)|null} */
		this.onBeforeRetry = (typeof this.options.OnBeforeRetry === 'function') ? this.options.OnBeforeRetry : null;
		/** @type {((pContext: RestClientRetryContext) => any)|null} */
		this.onRetryExhausted = (typeof this.options.OnRetryExhausted === 'function') ? this.options.OnRetryExhausted : null;
	}

	/**
	 * Register a safety hook: given a request, may it be replayed?
	 *
	 * Return `true` (replayable) or `false` (never replay) to decide, or nothing to defer to the
	 * next hook and finally to the built-in idempotent-method rule. Hooks run in registration
	 * order, ahead of that rule.
	 *
	 * @param {(pContext: RestClientRetrySafetyContext) => (boolean|null|undefined)} fHook - The hook.
	 * @return {() => void} A disposer that removes the hook.
	 */
	addRetrySafetyHook(fHook, pKey)
	{
		return this._registerDecisionHook(this.retrySafetyHooks, fHook, pKey, 'addRetrySafetyHook');
	}

	/**
	 * Register a classification hook: given a settled request, was the outcome transient?
	 *
	 * Return `'retry'` or `'settle'` to decide, or nothing to defer to the next hook and finally
	 * to the built-in status-code and transport-error-code rules.
	 *
	 * @param {(pContext: RestClientRetryContext) => ('retry'|'settle'|null|undefined)} fHook - The hook.
	 * @return {() => void} A disposer that removes the hook.
	 */
	addRetryClassifierHook(fHook, pKey)
	{
		return this._registerDecisionHook(this.retryClassifierHooks, fHook, pKey, 'addRetryClassifierHook');
	}

	/**
	 * Add a hook to a decision chain, keyed so re-registration is idempotent.
	 *
	 * A REST client lives as long as the application; a view that customizes retry behavior lives
	 * as long as its route is mounted. Those lifecycles do not line up, and a view that registers
	 * on mount will register again on every remount -- an unmount-time disposer only helps if it is
	 * reliably called, and a hook written as an inline arrow is a fresh reference each time, so
	 * identity alone cannot deduplicate it.
	 *
	 * Passing a stable `pKey` makes registration idempotent: the entry is replaced in place,
	 * preserving its position in the chain so ordering does not drift across remounts. Unkeyed
	 * registration still appends, for one-shot setup that genuinely runs once.
	 *
	 * @param {Array<{ Key: (string|null), Hook: Function }>} pChain - The chain to register into.
	 * @param {Function} fHook - The hook.
	 * @param {string} [pKey] - Stable identity for the registrant.
	 * @param {string} pMethodName - Caller name, for the error message.
	 * @return {() => void} A disposer that removes this registration.
	 * @private
	 */
	_registerDecisionHook(pChain, fHook, pKey, pMethodName)
	{
		if (typeof fHook !== 'function')
		{
			throw new Error(`RestClient ${pMethodName} requires a function.`);
		}
		const tmpKey = (typeof pKey === 'string' && pKey.length > 0) ? pKey : null;
		const tmpEntry = { Key: tmpKey, Hook: fHook };

		if (tmpKey)
		{
			const tmpExistingIndex = pChain.findIndex((pCandidate) => (pCandidate.Key === tmpKey));
			if (tmpExistingIndex > -1)
			{
				pChain[tmpExistingIndex] = tmpEntry;
				return () =>
				{
					const tmpIndex = pChain.indexOf(tmpEntry);
					if (tmpIndex > -1)
					{
						pChain.splice(tmpIndex, 1);
					}
				};
			}
		}

		pChain.push(tmpEntry);

		// Unkeyed registrations cannot be deduplicated, so a lifecycle mismatch
		// shows up here as unbounded growth. Say so once rather than letting it
		// degrade quietly.
		if (pChain.length === RETRY_HOOK_CHAIN_WARNING_LENGTH)
		{
			this.fable.log.warn(`RestClient ${pMethodName} chain has reached ${pChain.length} entries; a caller is probably registering on a lifecycle the client does not share. Pass a stable key to make registration idempotent.`,
				{ Action: 'RestClientRetryHookChainGrowth', Method: pMethodName, Length: pChain.length });
		}

		return () =>
		{
			const tmpIndex = pChain.indexOf(tmpEntry);
			if (tmpIndex > -1)
			{
				pChain.splice(tmpIndex, 1);
			}
		};
	}

	/**
	 * Run a decision-hook chain, stopping at the first hook that decides. A hook that throws is
	 * logged and treated as a deferral, so broken application code degrades to the built-in rule
	 * rather than breaking every request through the client.
	 *
	 * @param {Array<Function>} pHooks - The chain, in call order.
	 * @param {Object} pContext - The context handed to each hook.
	 * @param {(pVerdict: *) => boolean} fIsDecision - Whether a returned value counts as a decision.
	 * @param {string} pChainName - Name used in the failure log.
	 * @return {*} The deciding verdict, or undefined when every hook deferred.
	 */
	_runDecisionHookChain(pHooks, pContext, fIsDecision, pChainName)
	{
		if (!Array.isArray(pHooks))
		{
			return undefined;
		}
		for (let i = 0; i < pHooks.length; i++)
		{
			let tmpVerdict;
			try
			{
				tmpVerdict = pHooks[i].Hook(pContext);
			}
			catch (pHookError)
			{
				this.fable.log.warn(`RestClient ${pChainName} hook ${i} threw; deferring: ${pHookError.message}`,
					{ Action: 'RestClientRetryHookError', Chain: pChainName, Index: i });
				continue;
			}
			if (fIsDecision(tmpVerdict))
			{
				return tmpVerdict;
			}
		}
		return undefined;
	}

	/**
	 * Invoke a function from inside a promise continuation without letting its
	 * exceptions change shape.
	 *
	 * Delivering a caller's callback from inside a `.then()` turns any exception
	 * it throws into an *unhandled rejection* rather than the ordinary uncaught
	 * exception the synchronous settle path produces. Those are different
	 * channels: services wire them separately, browsers treat them differently,
	 * and the request stalls silently either way. Since whether a request settles
	 * synchronously or through a hook is an implementation detail the caller
	 * cannot see, the failure mode must not depend on it.
	 *
	 * @param {Function} fFunction - The function to invoke.
	 * @return {*} Whatever the function returned, or undefined when it threw.
	 * @private
	 */
	_invokeDetached(fFunction)
	{
		try
		{
			return fFunction();
		}
		catch (pDetachedError)
		{
			this.detachedThrowFunction(pDetachedError);
			return undefined;
		}
	}

	/**
	 * Resolve a lifecycle hook for a single request: a per-request hook wins over
	 * the service-level one, and an explicit `false` opts the request out.
	 *
	 * @param {Record<string, any>} pRequestOptions - The request options.
	 * @param {string} pRequestKey - The per-request option name (e.g. 'OnBeforeRetry').
	 * @param {string} pServiceKey - The service-level property name (e.g. 'onBeforeRetry').
	 * @return {Function|null} The hook to run, or null.
	 */
	_resolveRetryHook(pRequestOptions, pRequestKey, pServiceKey)
	{
		if (pRequestOptions && typeof pRequestOptions[pRequestKey] === 'function')
		{
			return pRequestOptions[pRequestKey];
		}
		if (pRequestOptions && pRequestOptions[pRequestKey] === false)
		{
			return null;
		}
		return (typeof this[pServiceKey] === 'function') ? this[pServiceKey] : null;
	}

	/**
	 * Await a lifecycle hook, isolating the request from anything it does wrong.
	 * A hook that throws or rejects is logged and treated as a no-op, so buggy
	 * instrumentation can never strand a request.
	 *
	 * @param {Function|null} fHook - The resolved hook, or null.
	 * @param {RestClientRetryContext} pContext - The context handed to the hook.
	 * @param {string} pHookName - Name used in the failure log.
	 * @return {Promise<*>} The hook's resolution, or undefined when it failed or was absent.
	 */
	_runRetryHook(fHook, pContext, pHookName)
	{
		if (!fHook)
		{
			return Promise.resolve(undefined);
		}
		let tmpInvocation;
		try
		{
			tmpInvocation = Promise.resolve(fHook(pContext));
		}
		catch (pHookError)
		{
			tmpInvocation = Promise.reject(pHookError);
		}
		return tmpInvocation.then(
			(pResult) => { return pResult; },
			(pHookError) =>
			{
				this.fable.log.warn(`RestClient ${pHookName} hook failed; continuing: ${pHookError.message}`,
					{ Action: 'RestClientRetryHookError', Hook: pHookName });
				return undefined;
			});
	}

	/**
	 * Resolve the classifier for a single request: a per-request RetryClassifier
	 * wins over the service-level one. An explicit `false` opts a request out of
	 * a service-level classifier entirely.
	 *
	 * @param {Record<string, any>} pRequestOptions - The request options.
	 * @return {Function|null} The classifier to run, or null.
	 */
	_resolveRetryClassifier(pRequestOptions)
	{
		if (pRequestOptions && typeof pRequestOptions.RetryClassifier === 'function')
		{
			return pRequestOptions.RetryClassifier;
		}
		if (pRequestOptions && pRequestOptions.RetryClassifier === false)
		{
			return null;
		}
		return (typeof this.retryClassifier === 'function') ? this.retryClassifier : null;
	}

	/**
	 * Run the resolved classifier, if any. A classifier that throws is treated as
	 * having no opinion, so a bug in application code degrades to the stock
	 * policy rather than breaking every request through the client.
	 *
	 * Called once per attempt, including the final one -- its verdict on the last
	 * attempt is what distinguishes a genuinely exhausted retry from an ordinary
	 * completion. Keep classifiers cheap and side-effect free.
	 *
	 * @param {RestClientRetryContext} pContext - The outcome context.
	 * @return {string|null} 'retry', 'settle', or null for no opinion.
	 */
	_classifyRetryOutcome(pContext)
	{
		// Effective chain, most specific first: the per-request classifier, the
		// single-slot `retryClassifier` (kept so pre-chain callers keep working),
		// then every registered hook in registration order. `RetryClassifier:
		// false` on a request opts that request out of all of them.
		const tmpChain = [];
		const tmpRequestOptions = pContext.Options;
		if (tmpRequestOptions && typeof tmpRequestOptions.RetryClassifier === 'function')
		{
			tmpChain.push({ Key: null, Hook: tmpRequestOptions.RetryClassifier });
		}
		else if (!tmpRequestOptions || tmpRequestOptions.RetryClassifier !== false)
		{
			if (typeof this.retryClassifier === 'function')
			{
				tmpChain.push({ Key: null, Hook: this.retryClassifier });
			}
			for (let i = 0; i < this.retryClassifierHooks.length; i++)
			{
				tmpChain.push(this.retryClassifierHooks[i]);
			}
		}

		const tmpVerdict = this._runDecisionHookChain(tmpChain, pContext,
			(pCandidate) => (pCandidate === 'retry' || pCandidate === 'settle'), 'retryClassifier');
		return (typeof tmpVerdict === 'undefined') ? null : tmpVerdict;
	}

	/**
	 * Layer retry configuration fragments onto the stock policy. Each fragment
	 * may be an object of overrides, a number (shorthand for MaxAttempts), or
	 * `false`/`0` (shorthand for "no retries"). Unrecognized fragments are
	 * ignored, so an older config file can never break the client.
	 *
	 * @param {...(Partial<RestClientRetryPolicy>|number|boolean|null|undefined)} pFragments - Overrides applied in order, later winning.
	 * @return {RestClientRetryPolicy} The resolved policy.
	 */
	_buildRetryPolicy(...pFragments)
	{
		let tmpPolicy = Object.assign({}, DEFAULT_RETRY_POLICY);
		for (let i = 0; i < pFragments.length; i++)
		{
			const tmpFragment = pFragments[i];
			if ((tmpFragment === null) || (typeof tmpFragment === 'undefined'))
			{
				continue;
			}
			if (tmpFragment === false)
			{
				tmpPolicy.MaxAttempts = 1;
				continue;
			}
			if (tmpFragment === true)
			{
				tmpPolicy.MaxAttempts = ENABLED_RETRY_ATTEMPTS;
				continue;
			}
			if (typeof tmpFragment === 'number')
			{
				tmpPolicy.MaxAttempts = Math.max(1, tmpFragment);
				continue;
			}
			if (typeof tmpFragment === 'object')
			{
				tmpPolicy = Object.assign(tmpPolicy, tmpFragment);
			}
		}
		if (typeof tmpPolicy.MaxAttempts !== 'number' || tmpPolicy.MaxAttempts < 1)
		{
			tmpPolicy.MaxAttempts = 1;
		}
		return tmpPolicy;
	}

	/**
	 * Layer retry configuration onto this client's policy, in place.
	 *
	 * The public way for a library or application to turn retry on (or tune it) after construction.
	 * Accepts the same forms as the constructor option: an overrides object, a number of attempts,
	 * `true` for the recommended budget, or `false` to disable.
	 *
	 * @param {Partial<RestClientRetryPolicy>|number|boolean} pRetryConfiguration - The overrides.
	 * @return {RestClientRetryPolicy} The resolved policy now in effect.
	 */
	configureRetry(pRetryConfiguration)
	{
		this.retryPolicy = this._buildRetryPolicy(this.retryPolicy, pRetryConfiguration);
		return this.retryPolicy;
	}

	/**
	 * Resolve the effective policy for a single request: the service policy with
	 * any per-request `Retry` override layered on top.
	 *
	 * @param {Record<string, any>} pRequestOptions - The request options (pre- or post-preRequest).
	 * @return {RestClientRetryPolicy} The resolved policy for this request.
	 */
	resolveRetryPolicy(pRequestOptions)
	{
		if (!pRequestOptions || !('Retry' in pRequestOptions))
		{
			return this.retryPolicy;
		}
		return this._buildRetryPolicy(this.retryPolicy, pRequestOptions.Retry);
	}

	/**
	 * Whether a request may be replayed at all. Idempotent methods always may;
	 * anything else requires the caller to assert safety with `RetrySafe: true`
	 * (meadow's POST /:Entity/Query is the motivating case -- a POST purely
	 * because the filter travels in the body). A body we cannot re-send (a
	 * stream, or a Blob/File the caller may already have consumed) is never
	 * replayed regardless.
	 *
	 * @param {Record<string, any>} pRequestOptions - The request options.
	 * @param {RestClientRetryPolicy} pPolicy - The resolved policy.
	 * @return {boolean} True when this request is safe to replay.
	 */
	_isRetryableRequest(pRequestOptions, pPolicy)
	{
		if (!pRequestOptions)
		{
			return false;
		}
		const tmpBody = pRequestOptions.body;
		if (tmpBody && (typeof tmpBody.pipe === 'function' || (typeof Blob !== 'undefined' && tmpBody instanceof Blob)))
		{
			return false;
		}
		// A per-request assertion is the most specific statement there is, so it
		// outranks every hook. This is the override role; it is not how a whole
		// class of endpoints should be described (register a hook for that).
		if (pRequestOptions.RetrySafe === true)
		{
			return true;
		}
		if (pRequestOptions.RetrySafe === false)
		{
			return false;
		}

		const tmpHookVerdict = this._runDecisionHookChain(this.retrySafetyHooks,
			{ Options: pRequestOptions, Policy: pPolicy },
			(pVerdict) => (typeof pVerdict === 'boolean'), 'retrySafety');
		if (typeof tmpHookVerdict === 'boolean')
		{
			return tmpHookVerdict;
		}

		const tmpMethod = (pRequestOptions.method || 'GET').toUpperCase();
		return Array.isArray(pPolicy.RetryMethods) && pPolicy.RetryMethods.indexOf(tmpMethod) > -1;
	}

	/**
	 * Parse a Retry-After header into milliseconds. Handles both the delta-seconds
	 * and the HTTP-date forms defined by RFC 7231 §7.1.3.
	 *
	 * @param {string} pHeaderValue - The raw header value.
	 * @return {number} Milliseconds to wait, or -1 when unparseable.
	 */
	_parseRetryAfter(pHeaderValue)
	{
		if (typeof pHeaderValue !== 'string' || pHeaderValue.length < 1)
		{
			return -1;
		}
		const tmpSeconds = Number(pHeaderValue);
		if (!isNaN(tmpSeconds))
		{
			return Math.max(0, tmpSeconds * 1000);
		}
		const tmpDate = Date.parse(pHeaderValue);
		if (isNaN(tmpDate))
		{
			return -1;
		}
		return Math.max(0, tmpDate - Date.now());
	}

	/**
	 * Decide whether a settled request should be replayed, and how long to wait.
	 *
	 * @param {RestClientRetryPolicy} pPolicy - The resolved policy.
	 * @param {Record<string, any>} pRequestOptions - The replay options (carry the attempt marker).
	 * @param {Error|null} pError - The transport error, if any.
	 * @param {Object} [pResponse] - The response, when one was received.
	 * @param {*} [pBody] - The processed body, when one was received.
	 * @return {number} The delay in milliseconds, or -1 to settle without retrying.
	 */
	_resolveRetryDelay(pPolicy, pRequestOptions, pError, pResponse, pBody)
	{
		return this._evaluateRetryOutcome(pPolicy, pRequestOptions, pError, pResponse, pBody).DelayMS;
	}

	/**
	 * Classify a settled request and decide what happens next. Separating
	 * "was this a transient failure" from "do we have budget left" is what lets
	 * the caller tell a successful replay apart from a genuinely exhausted one --
	 * both reach the settle path, but only the second is a give-up.
	 *
	 * @param {RestClientRetryPolicy} pPolicy - The resolved policy.
	 * @param {Record<string, any>} pRequestOptions - The replay options (carry the attempt marker).
	 * @param {Error|null} pError - The transport error, if any.
	 * @param {Object} [pResponse] - The response, when one was received.
	 * @param {*} [pBody] - The processed body, when one was received.
	 * @return {{ Transient: boolean, DelayMS: number, Exhausted: boolean }} The evaluation.
	 */
	_evaluateRetryOutcome(pPolicy, pRequestOptions, pError, pResponse, pBody)
	{
		const tmpAttemptsMade = (pRequestOptions.__retryAttempt || 0) + 1;
		const tmpSettled = { Transient: false, DelayMS: -1, Exhausted: false };

		// Eligibility is a hard gate that sits above classification: an
		// application classifier can reinterpret an outcome, but it can never make
		// a non-idempotent request safe to replay.
		if (!this._isRetryableRequest(pRequestOptions, pPolicy))
		{
			return tmpSettled;
		}

		let tmpTransient = false;
		const tmpVerdict = this._classifyRetryOutcome(
			{
				Options: pRequestOptions,
				Error: pError,
				Response: pResponse,
				Body: pBody,
				Policy: pPolicy,
				AttemptsMade: tmpAttemptsMade
			});

		if (tmpVerdict === 'settle')
		{
			return tmpSettled;
		}
		else if (tmpVerdict === 'retry')
		{
			tmpTransient = true;
		}
		else if (pResponse && typeof pResponse.statusCode === 'number')
		{
			tmpTransient = Array.isArray(pPolicy.RetryStatusCodes) && pPolicy.RetryStatusCodes.indexOf(pResponse.statusCode) > -1;
		}
		else if (pError)
		{
			// A transport failure with no response at all. Match on the error code
			// where Node gives us one; a bare timeout from simple-get surfaces as a
			// coded ETIMEDOUT so this stays precise rather than retrying everything.
			const tmpCode = pError.code || (pError.cause && pError.cause.code);
			tmpTransient = Array.isArray(pPolicy.RetryErrorCodes) && pPolicy.RetryErrorCodes.indexOf(tmpCode) > -1;
		}

		if (!tmpTransient)
		{
			return tmpSettled;
		}

		if (tmpAttemptsMade >= pPolicy.MaxAttempts)
		{
			// Transient, but out of budget. Only a give-up when replays were
			// enabled at all -- with retry off this is an ordinary completion.
			return { Transient: true, DelayMS: -1, Exhausted: (pPolicy.MaxAttempts > 1) };
		}

		if (pPolicy.RespectRetryAfter && pResponse && pResponse.headers && pResponse.headers['retry-after'])
		{
			const tmpRetryAfterMS = this._parseRetryAfter(pResponse.headers['retry-after']);
			if (tmpRetryAfterMS > -1)
			{
				// A server that tells us when to come back wins over our backoff,
				// but never past the configured ceiling.
				return { Transient: true, DelayMS: Math.min(tmpRetryAfterMS, pPolicy.MaxRetryAfterMS), Exhausted: false };
			}
		}

		const tmpBackoff = pPolicy.InitialDelayMS * Math.pow(pPolicy.BackoffFactor, tmpAttemptsMade - 1);
		const tmpCappedDelay = Math.min(tmpBackoff, pPolicy.MaxDelayMS);
		if (!pPolicy.JitterRatio)
		{
			return { Transient: true, DelayMS: tmpCappedDelay, Exhausted: false };
		}
		// Symmetric jitter around the backoff so a burst of concurrent page reads
		// failing together does not resynchronize on the retry.
		const tmpJitterSpan = tmpCappedDelay * pPolicy.JitterRatio;
		const tmpJittered = tmpCappedDelay - tmpJitterSpan + (this.retryJitterFunction() * tmpJitterSpan * 2);
		return { Transient: true, DelayMS: Math.max(0, Math.round(tmpJittered)), Exhausted: false };
	}

	/**
	 * Initialize HTTP keep-alive agents and wire them into prepareRequestOptions.
	 * Back-compat entry point: always forces keepAlive on. Prefer configuring
	 * the RestClient via the KeepAlive / KeepAliveAgentOptions constructor
	 * options instead of calling this method directly.
	 *
	 * @param {Object} [pAgentOptions] - Additional options passed to the Http/Https Agent constructors (e.g. timeout).
	 */
	initializeKeepAliveAgent(pAgentOptions)
	{
		let tmpAgentOptions = Object.assign({ keepAlive: true }, pAgentOptions);
		this._installHttpAgents(tmpAgentOptions);
	}

	/**
	 * Construct http/https Agents from the given options and wire them into
	 * prepareRequestOptions so every request carries an explicit agent.
	 *
	 * @param {Object} pAgentOptions - Options passed directly to the Http/Https Agent constructors.
	 * @private
	 */
	_installHttpAgents(pAgentOptions)
	{
		this.httpAgent = new libHttp.Agent(pAgentOptions);
		this.httpsAgent = new libHttps.Agent(pAgentOptions);

		// Capture any previously set prepareRequestOptions so we can chain
		let tmpPreviousPrepareRequestOptions = this.prepareRequestOptions;

		this.prepareRequestOptions = (pOptions) =>
		{
			// Mirror simple-get's protocol decision exactly: it routes through
			// the https module if and only if the parsed URL protocol is
			// exactly 'https:'. Everything else — http: URLs, relative URLs
			// (which simple-get treats as no-host http requests), and option
			// objects with no .url at all — goes through the http module.
			// Stamping an httpsAgent on an http request makes Node throw
			// ERR_INVALID_PROTOCOL when http.request validates agent.protocol.
			if (typeof pOptions.url === 'string' && pOptions.url.startsWith('https:'))
			{
				pOptions.agent = this.httpsAgent;
			}
			else
			{
				pOptions.agent = this.httpAgent;
			}
			return tmpPreviousPrepareRequestOptions(pOptions);
		};
	}

	get simpleGet()
	{
		return libSimpleGet;
	}

	/**
	 * Serialize the service-level cookie jar onto the request.
	 *
	 * A cookie header the caller supplied is authoritative and is left alone: a
	 * forwarded caller identity has to be able to travel on a client that also
	 * carries its own bound session, and silently replacing it would run one
	 * caller's request under another's identity. This matches how the rest of
	 * the ecosystem composes cookies (see pict-sessionmanager's
	 * onPrepareCookies, which merges rather than replaces).
	 *
	 * @param {Record<string, any>} pRequestOptions - The request options.
	 * @return {Record<string, any>} The same object, decorated.
	 */
	prepareCookies(pRequestOptions)
	{
		if (this.cookie)
		{
			let tmpCookieObject = this.cookie;
			if (!('headers' in pRequestOptions))
			{
				pRequestOptions.headers = {};
			}
			let tmpCookieKeys = Object.keys(tmpCookieObject);
			if (tmpCookieKeys.length > 0 && !pRequestOptions.headers.cookie)
			{
				let tmpCookiePairs = [];
				for (let i = 0; i < tmpCookieKeys.length; i++)
				{
					tmpCookiePairs.push(libCookie.serialize(tmpCookieKeys[i], tmpCookieObject[tmpCookieKeys[i]]));
				}
				pRequestOptions.headers.cookie = tmpCookiePairs.join('; ');
			}
		}
		return pRequestOptions;
	}

	preRequest(pOptions)
	{
		// Validate the options object
		let tmpOptions = this.prepareCookies(pOptions);

		// Prepend a string to the URL if it exists in the Fable Config. An
		// already-absolute URL is left alone: the prefix exists to complete a
		// relative path, and a library layer that builds its own fully-qualified
		// URLs would otherwise be corrupted by a host application's setting.
		if (('RestClientURLPrefix' in this.fable.settings) && !this._isAbsoluteURL(tmpOptions.url))
		{
			tmpOptions.url = this.fable.settings.RestClientURLPrefix + tmpOptions.url;
		}

		// Apply the default request timeout when the caller hasn't supplied
		// one. Setting any numeric value (including 0) suppresses the Node 20+
		// http.globalAgent ~5s socket timeout.
		if (typeof tmpOptions.timeout !== 'number')
		{
			tmpOptions.timeout = this.defaultRequestTimeout;
		}

		return this.prepareRequestOptions(tmpOptions);
	}

	/**
	 * Whether a URL already carries its own scheme, and so needs no prefixing.
	 *
	 * @private
	 * @param {string} pUrl
	 * @return {boolean}
	 */
	_isAbsoluteURL(pUrl)
	{
		return (typeof pUrl === 'string') && /^[a-z][a-z0-9+.-]*:\/\//i.test(pUrl);
	}

	/**
	 * Extract the hostname from a URL string. Returns null for relative URLs
	 * or anything else that doesn't parse cleanly.
	 *
	 * @private
	 * @param {string} pUrl
	 * @return {string|null}
	 */
	_parseHostname(pUrl)
	{
		if (typeof pUrl !== 'string')
		{
			return null;
		}
		try
		{
			return new URL(pUrl).hostname || null;
		}
		catch (e)
		{
			return null;
		}
	}

	/**
	 * Resolve a Location header against the URL of the request that produced
	 * it. Handles absolute Locations (returned as-is) and RFC 7231-compliant
	 * relative Locations (resolved against the current URL).
	 *
	 * @private
	 * @param {string} pCurrentURL - The URL of the request that produced the redirect.
	 * @param {string} pLocation - The Location header value.
	 * @return {string}
	 */
	_resolveRedirectURL(pCurrentURL, pLocation)
	{
		if (typeof pLocation !== 'string' || pLocation.length === 0)
		{
			return pLocation;
		}
		try
		{
			return new URL(pLocation, pCurrentURL).toString();
		}
		catch (e)
		{
			// Either pCurrentURL is itself relative or pLocation is malformed.
			// Fall back to passing it through verbatim — simple-get's parser
			// will give the next hop a final say.
			return pLocation;
		}
	}

	/**
	 * Build the options object for the next hop of a redirect chain. Applies
	 * the same hop-rewrite rules simple-get does, plus an RFC-correct relative
	 * Location resolution that simple-get itself doesn't do:
	 *   - Resolve the Location against the current URL (absolute or relative).
	 *   - Strip simple-get's URL-derived state (protocol/hostname/port/path/auth)
	 *     so the next hop re-parses the URL cleanly.
	 *   - Drop the host header (re-derived from the new URL by simple-get).
	 *   - Cross-origin: drop cookie + authorization to prevent leak.
	 *   - 301/302 + POST: switch to GET, drop body and content headers.
	 *
	 * @private
	 * @param {Object} pOptions - The options used for the previous hop (post-simple-get mutation).
	 * @param {import('http').IncomingMessage} pResponse - The 3xx response.
	 * @param {string|undefined} pOriginalURL - The URL of the previous hop, captured before simple-get deleted it.
	 * @param {string|null} pOriginalHost - The hostname of the previous hop, for cross-origin detection.
	 * @return {Object}
	 */
	_buildRedirectedOptions(pOptions, pResponse, pOriginalURL, pOriginalHost)
	{
		const tmpNew = Object.assign({}, pOptions);
		tmpNew.url = this._resolveRedirectURL(pOriginalURL, pResponse.headers.location);

		// Strip simple-get's own URL-derived fields so the next call re-parses cleanly.
		delete tmpNew.protocol;
		delete tmpNew.hostname;
		delete tmpNew.port;
		delete tmpNew.path;
		delete tmpNew.auth;

		// We set followRedirects=false on the previous hop to disable
		// simple-get's auto-follow; that's our own internal flag, not caller
		// intent. Drop it so the recursive _executeWithRedirects entry treats
		// the next hop as another redirect-following call.
		delete tmpNew.followRedirects;

		// Headers — clone (don't mutate the caller's) and prune.
		if (tmpNew.headers)
		{
			tmpNew.headers = Object.assign({}, tmpNew.headers);
			delete tmpNew.headers.host;
		}

		// Cross-origin redirect: drop cookie and authorization to prevent leak (matches simple-get #73).
		const tmpRedirectHost = this._parseHostname(tmpNew.url);
		if (tmpRedirectHost !== null && tmpRedirectHost !== pOriginalHost && tmpNew.headers)
		{
			delete tmpNew.headers.cookie;
			delete tmpNew.headers.authorization;
		}

		// 301/302 + POST → GET (matches simple-get #35 and RFC 7231 §6.4.2/6.4.3).
		// Body and content headers come off; 307/308 preserve method/body so we leave them alone.
		if (tmpNew.method === 'POST' && (pResponse.statusCode === 301 || pResponse.statusCode === 302))
		{
			tmpNew.method = 'GET';
			if (tmpNew.headers)
			{
				delete tmpNew.headers['content-length'];
				delete tmpNew.headers['content-type'];
			}
			delete tmpNew.body;
			delete tmpNew.form;
		}

		return tmpNew;
	}

	/**
	 * Dispatch one hop through simple-get, normalizing a timeout into a coded
	 * error before anything downstream classifies it.
	 *
	 * simple-get reports a socket timeout as a bare Error carrying no `code` and
	 * no `cause` (index.js: `cb(new Error('Request timed out'))`), so the
	 * code-based transport matching in _evaluateRetryOutcome can never fire on
	 * it. The underlying request's own `timeout` event is the precise signal, so
	 * classification stays code-based rather than depending on simple-get's
	 * message text; the message is a fallback for transports that never emit the
	 * event (the browser http shim).
	 *
	 * @private
	 * @param {Object} pOptions - The prepared request options.
	 * @param {(err?: Error, res?: import('http').IncomingMessage) => void} fCallback
	 * @return {Object} The underlying request object.
	 */
	_dispatchRequest(pOptions, fCallback)
	{
		let tmpTimedOut = false;
		const tmpRequest = libSimpleGet(pOptions,
			(pError, pResponse) =>
			{
				if (pError && !pError.code && !(pError.cause && pError.cause.code)
					&& (tmpTimedOut || /timed out/i.test(pError.message || '')))
				{
					pError.code = 'ETIMEDOUT';
				}
				return fCallback(pError, pResponse);
			});
		// Prepended because simple-get's own timeout handler settles the
		// (once-wrapped) callback synchronously, so a plain listener would run
		// after the outcome had already been decided.
		if (tmpRequest && typeof tmpRequest.prependListener === 'function')
		{
			tmpRequest.prependListener('timeout', () => { tmpTimedOut = true; });
		}
		return tmpRequest;
	}

	/**
	 * Dispatch a request via simple-get, transparently following 3xx redirects
	 * until a non-redirect response or hard error.
	 *
	 * Why we drive the loop ourselves: simple-get's own redirect path
	 * (index.js lines 50-69) recurses with the original opts.agent intact, so
	 * an http→https redirect ends up calling https.request with an httpAgent
	 * (or vice versa) and Node throws ERR_INVALID_PROTOCOL synchronously.
	 * By disabling simple-get's auto-follow and running prepareRequestOptions
	 * on each hop, the agent gets re-picked to match the new URL's protocol.
	 *
	 * Caller can opt out by setting `followRedirects: false` on options
	 * (matches simple-get's contract) — in that case we hand the 3xx straight
	 * back without following.
	 *
	 * @private
	 * @param {Object} pOptions - Already passed through preRequest on the first call; on recursion, already passed through prepareRequestOptions.
	 * @param {(err?: Error, res?: import('http').IncomingMessage) => void} fCallback
	 */
	_executeWithRedirects(pOptions, fCallback)
	{
		if (pOptions.followRedirects === false)
		{
			return this._dispatchRequest(pOptions, fCallback);
		}

		// Disable simple-get's own redirect loop — we own it from here.
		pOptions.followRedirects = false;
		const tmpOriginalURL = pOptions.url;
		const tmpOriginalHost = this._parseHostname(tmpOriginalURL);

		return this._dispatchRequest(pOptions, (pError, pResponse) =>
		{
			if (pError)
			{
				return fCallback(pError, pResponse);
			}

			if (pResponse.statusCode < 300 || pResponse.statusCode >= 400 || !pResponse.headers.location)
			{
				return fCallback(null, pResponse);
			}

			// 3xx with Location — drain and follow.
			pResponse.resume();

			let tmpRedirectsRemaining = (typeof pOptions.maxRedirects === 'number') ? pOptions.maxRedirects : 10;
			if (tmpRedirectsRemaining <= 0)
			{
				return fCallback(new Error('too many redirects'));
			}

			const tmpNextOptions = this._buildRedirectedOptions(pOptions, pResponse, tmpOriginalURL, tmpOriginalHost);
			tmpNextOptions.maxRedirects = tmpRedirectsRemaining - 1;

			// Re-run the agent picker so the next hop's agent matches the
			// (possibly different) protocol of the redirect target. We do
			// NOT re-run preRequest in full — RestClientURLPrefix and
			// prepareCookies are first-call-only.
			const tmpPreparedNext = this.prepareRequestOptions(tmpNextOptions);

			if (this.TraceLog)
			{
				this.fable.log.debug(`--> redirect ${pResponse.statusCode} to ${tmpPreparedNext.url}`);
			}
			return this._executeWithRedirects(tmpPreparedNext, fCallback);
		});
	}

	executeChunkedRequest(pOptions, fCallback)
	{
		let tmpReplayOptions = this._captureReplayOptions(pOptions);

		let tmpOptions = this.preRequest(pOptions);

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} request to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse)=>
			{
				if (pError)
				{
					return this._completeWithRetry(tmpReplayOptions, pError, pResponse, undefined,
						() => this.executeChunkedRequest(tmpReplayOptions, fCallback), fCallback);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpData = '';

				// A body that stops mid-stream is reportable only here, and only as
				// a transport failure -- see _guardResponseStream for why it hands the
				// retry seam no response.
				let fClaimSettle = this._guardResponseStream(pResponse,
					(pInterruptedError) =>
					{
						return this._completeWithRetry(tmpReplayOptions, pInterruptedError, undefined, undefined,
							() => this.executeChunkedRequest(tmpReplayOptions, fCallback), fCallback);
					});

				pResponse.on('data', (pChunk) =>
					{
						// For JSON, the chunk is the serialized object.
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> ${tmpOptions.method} data chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						tmpData += pChunk;
					});

				pResponse.on('end', ()=>
					{
						if (!fClaimSettle())
						{
							return;
						}
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> ${tmpOptions.method} completed data size ${tmpData.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						return this._completeWithRecovery(tmpReplayOptions, pError, pResponse, tmpData,
							() => this.executeChunkedRequest(tmpReplayOptions, fCallback), fCallback);
					});
			});
	}

	executeChunkedRequestBinary(pOptions, fCallback)
	{
		let tmpReplayOptions = this._captureReplayOptions(pOptions);

		let tmpOptions = this.preRequest(pOptions);

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} request to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		tmpOptions.json = false;
		tmpOptions.encoding = null;

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse)=>
			{
				if (pError)
				{
					return this._completeWithRetry(tmpReplayOptions, pError, pResponse, undefined,
						() => this.executeChunkedRequestBinary(tmpReplayOptions, fCallback), fCallback);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpDataBuffer = false;

				// A body that stops mid-stream is reportable only here, and only as
				// a transport failure -- see _guardResponseStream for why it hands the
				// retry seam no response.
				let fClaimSettle = this._guardResponseStream(pResponse,
					(pInterruptedError) =>
					{
						return this._completeWithRetry(tmpReplayOptions, pInterruptedError, undefined, undefined,
							() => this.executeChunkedRequestBinary(tmpReplayOptions, fCallback), fCallback);
					});

				pResponse.on('data', (pChunk) =>
					{
						// For JSON, the chunk is the serialized object.
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> ${tmpOptions.method} data chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						// TODO: Potentially create a third option that streams this to a file?  So it doesn't have to hold it all in memory.
						if (!tmpDataBuffer)
						{
							tmpDataBuffer = Buffer.from(pChunk);
						}
						else
						{
							tmpDataBuffer = Buffer.concat([tmpDataBuffer, pChunk]);
						}
					});

				pResponse.on('end', ()=>
					{
						if (!fClaimSettle())
						{
							return;
						}
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> ${tmpOptions.method} completed data size ${tmpDataBuffer.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						return this._completeWithRecovery(tmpReplayOptions, pError, pResponse, tmpDataBuffer,
							() => this.executeChunkedRequestBinary(tmpReplayOptions, fCallback), fCallback);
					});
			});
	}

	/**
	 * Snapshot the caller's options BEFORE preRequest mutates them, so a
	 * recovery replay can re-run the same request cleanly. preRequest prepends
	 * RestClientURLPrefix to `url` in place; replaying the already-mutated object
	 * would double-prefix. Replaying from this snapshot re-runs preRequest once.
	 *
	 * `headers` is copied as well: preRequest decorates it in place with the
	 * client's cookie jar, and a replay sharing that object would resend the
	 * cookie of the first attempt instead of the jar as it stands at replay time.
	 *
	 * @param {Object} pOptions - The caller's request options.
	 * @return {Object} A copy safe to re-issue.
	 * @private
	 */
	_captureReplayOptions(pOptions)
	{
		let tmpReplayOptions = Object.assign({}, pOptions);
		if (pOptions && pOptions.headers && (typeof(pOptions.headers) === 'object'))
		{
			tmpReplayOptions.headers = Object.assign({}, pOptions.headers);
		}
		return tmpReplayOptions;
	}

	/**
	 * Invoke the authenticationRecovery hook under a single-flight guard. A burst
	 * of concurrent 401s shares one hook invocation; all await the same promise,
	 * then each replays independently. The shared promise is cleared on settle so
	 * a later, unrelated expiry re-arms recovery. Resolves to a strict boolean
	 * (true only when the hook resolved exactly true); rejects if the hook throws.
	 *
	 * @param {Object} pRequestContext - Context passed to the hook ({ options, response }).
	 * @return {Promise<boolean>}
	 * @private
	 */
	_runAuthenticationRecovery(pRequestContext)
	{
		if (this._authenticationRecoveryPromise)
		{
			return this._authenticationRecoveryPromise;
		}
		let tmpInvocation;
		try
		{
			tmpInvocation = Promise.resolve(this.authenticationRecovery(pRequestContext));
		}
		catch (pError)
		{
			tmpInvocation = Promise.reject(pError);
		}
		this._authenticationRecoveryPromise = tmpInvocation.then(
			(pResult) =>
			{
				this._authenticationRecoveryPromise = null;
				return (pResult === true);
			},
			(pError) =>
			{
				this._authenticationRecoveryPromise = null;
				throw pError;
			});
		return this._authenticationRecoveryPromise;
	}

	/**
	 * Arm terminal-failure listeners on a response stream being accumulated.
	 *
	 * simple-get hands the response over as soon as the headers land, and its
	 * callback is once()-wrapped -- so by the time the body is streaming, the
	 * only channel it has for reporting a failure is already spent. Anything
	 * that goes wrong from that point (a peer reset, the socket our own request
	 * timeout aborts, a premature close) surfaces solely on the response stream,
	 * where the accumulators listen for 'data' and 'end' and nothing else. The
	 * result is not an error but silence: 'end' never fires, the caller's
	 * callback is never called, and the request hangs for as long as the process
	 * lives. Every accumulating path arms this and claims the settle in its
	 * 'end' handler, so exactly one of the two outcomes is delivered.
	 *
	 * Callers hand the resulting error to the retry seam with NO response, on
	 * purpose. A status line describes headers that did arrive, not a body that
	 * never did; letting a truncated response be classified as its own 200 would
	 * decline exactly the replay its transport error code is asking for. The
	 * caller receives the coded error either way.
	 *
	 * @param {Object} pResponse - The response stream being accumulated.
	 * @param {(pError: Error) => void} fOnInterrupted - Settles the request; called at most once, and never once the outcome has been claimed.
	 * @return {() => boolean} Claim function -- true the first time it is called, false once the outcome is already settled.
	 * @private
	 */
	_guardResponseStream(pResponse, fOnInterrupted)
	{
		let tmpSettled = false;

		let fClaimSettle = () =>
		{
			if (tmpSettled)
			{
				return false;
			}
			tmpSettled = true;
			return true;
		};

		let fInterrupted = (pStreamError) =>
		{
			if (!fClaimSettle())
			{
				return;
			}
			// 'aborted' and 'close' carry no error of their own, and a stream
			// error may arrive uncoded; ECONNRESET is what the transport matching
			// in _evaluateRetryOutcome already understands as transient.
			let tmpError = (pStreamError instanceof Error) ? pStreamError : new Error('Response stream closed before the body completed');
			if (!tmpError.code)
			{
				tmpError.code = 'ECONNRESET';
			}
			return fOnInterrupted(tmpError);
		};

		pResponse.on('error', fInterrupted);
		pResponse.on('aborted', () => { return fInterrupted(); });
		// 'close' also fires on a clean response, after 'end' -- the claim taken
		// by the 'end' handler absorbs it.
		pResponse.on('close', () => { return fInterrupted(); });

		return fClaimSettle;
	}

	/**
	 * Shared completion seam for every request path. On a completed 401, with a
	 * recovery hook installed, on a request that is not itself already a replay
	 * and not marked `AuthenticationRecovery: false` (a request the hook issues
	 * itself, which would otherwise wait on the recovery it is part of),
	 * it awaits recovery: on success it replays the request exactly once (via
	 * fReplay, whose pReplayOptions carry the __authRetry marker so the replay can
	 * never re-enter recovery -- a hard one-retry cap); otherwise it delivers the
	 * original response to fCallback unchanged. Every other outcome (2xx, 5xx,
	 * timeout, no hook) passes straight through, so opt-out callers are untouched.
	 *
	 * @param {Object} pReplayOptions - The replay snapshot (also carries the retry marker).
	 * @param {Error|null} pError - The error from the request, if any.
	 * @param {Object} pResponse - The response object (statusCode read here).
	 * @param {*} pBody - The processed body for this path (parsed JSON / string / Buffer).
	 * @param {Function} fReplay - Re-issues the request from pReplayOptions.
	 * @param {Function} fCallback - The caller's callback (pError, pResponse, pBody).
	 * @private
	 */
	_completeWithRecovery(pReplayOptions, pError, pResponse, pBody, fReplay, fCallback)
	{
		if (pResponse && pResponse.statusCode === 401 && typeof this.authenticationRecovery === 'function' && !pReplayOptions.__authRetry && (pReplayOptions.AuthenticationRecovery !== false))
		{
			// Stamp the one-retry marker before recovery so the replay can never
			// itself trigger another recovery pass.
			pReplayOptions.__authRetry = true;
			this._runAuthenticationRecovery({ options: pReplayOptions, response: pResponse }).then(
				(pRecovered) =>
				{
					if (pRecovered === true)
					{
						return this._invokeDetached(() => fReplay());
					}
					return this._invokeDetached(() => fCallback(pError, pResponse, pBody));
				},
				() =>
				{
					// A throwing/rejecting recovery is treated as "not recovered":
					// hand the original 401 back untouched.
					return this._invokeDetached(() => fCallback(pError, pResponse, pBody));
				});
			return;
		}
		return this._completeWithRetry(pReplayOptions, pError, pResponse, pBody, fReplay, fCallback);
	}

	/**
	 * Transient-failure seam. Every request path -- transport error, completed
	 * response, and parse failure -- funnels through here. When the resolved
	 * policy says the failure is transient AND the request is safe to replay,
	 * the request is re-issued after a backoff delay; otherwise the outcome is
	 * handed to the caller exactly as it arrived.
	 *
	 * @param {Object} pReplayOptions - The replay snapshot (also carries the attempt marker).
	 * @param {Error|null} pError - The error from the request, if any.
	 * @param {Object} [pResponse] - The response object, when one was received.
	 * @param {*} [pBody] - The processed body for this path.
	 * @param {Function} fReplay - Re-issues the request from pReplayOptions.
	 * @param {Function} fCallback - The caller's callback (pError, pResponse, pBody).
	 * @private
	 */
	_completeWithRetry(pReplayOptions, pError, pResponse, pBody, fReplay, fCallback)
	{
		const tmpPolicy = this.resolveRetryPolicy(pReplayOptions);
		const tmpAttemptsMade = (pReplayOptions.__retryAttempt || 0) + 1;
		const tmpEvaluation = this._evaluateRetryOutcome(tmpPolicy, pReplayOptions, pError, pResponse, pBody);
		const tmpDelayMS = tmpEvaluation.DelayMS;

		/** @type {RestClientRetryContext} */
		const tmpContext =
		{
			Options: pReplayOptions,
			Error: pError,
			Response: pResponse,
			Body: pBody,
			Policy: tmpPolicy,
			AttemptsMade: tmpAttemptsMade,
			DelayMS: (tmpDelayMS < 0) ? null : tmpDelayMS
		};

		if (tmpDelayMS < 0)
		{
			// Exhaustion is specifically "still failing transiently, no budget
			// left" -- not merely "settled after having retried". A replay that
			// finally succeeded, and any outcome the policy never wanted to retry
			// (a 404, a plain POST), is an ordinary completion.
			if (tmpEvaluation.Exhausted)
			{
				const fExhaustedHook = this._resolveRetryHook(pReplayOptions, 'OnRetryExhausted', 'onRetryExhausted');
				if (fExhaustedHook)
				{
					this._runRetryHook(fExhaustedHook, tmpContext, 'onRetryExhausted').then(
						() => { return this._invokeDetached(() => fCallback(pError, pResponse, pBody)); });
					return;
				}
			}
			else if (tmpPolicy.MaxAttempts > 1 && (pError || (pResponse && pResponse.statusCode >= 400))
				&& this._isRetryableRequest(pReplayOptions, tmpPolicy))
			{
				// Retry was enabled and this request was eligible, yet the failure
				// classified as non-transient. Without this line that decision is
				// indistinguishable from retry never having been configured, which
				// is exactly how a misclassified failure hides.
				this.fable.log.debug(`RestClient not retrying ${pReplayOptions.method || 'GET'} ${pReplayOptions.url}: failure classified as non-transient.`,
					{
						Action: 'RestClientRetryDeclined',
						StatusCode: (pResponse && pResponse.statusCode) || null,
						ErrorCode: (pError && pError.code) || null,
						ErrorMessage: (pError && pError.message) || null
					});
			}
			return fCallback(pError, pResponse, pBody);
		}

		pReplayOptions.__retryAttempt = tmpAttemptsMade;

		const tmpReason = (pResponse && typeof pResponse.statusCode === 'number')
			? `HTTP ${pResponse.statusCode}`
			: `transport error ${(pError && (pError.code || pError.message)) || 'unknown'}`;
		this.fable.log.warn(`RestClient retrying ${pReplayOptions.method || 'GET'} ${pReplayOptions.url} after ${tmpReason} (attempt ${tmpAttemptsMade + 1} of ${tmpPolicy.MaxAttempts}, waiting ${tmpDelayMS}ms).`,
			{
				Action: 'RestClientRetry',
				Attempt: tmpAttemptsMade + 1,
				MaxAttempts: tmpPolicy.MaxAttempts,
				DelayMS: tmpDelayMS,
				StatusCode: (pResponse && pResponse.statusCode) || null,
				ErrorCode: (pError && pError.code) || null
			});

		// The hook runs before the backoff so any refresh work it does is
		// complete by the time the replay leaves. Resolving exactly false vetoes
		// the retry; the outcome in hand is delivered unchanged.
		const fBeforeHook = this._resolveRetryHook(pReplayOptions, 'OnBeforeRetry', 'onBeforeRetry');
		if (!fBeforeHook)
		{
			// No hook: stay off the promise chain entirely. This is the common
			// path, and keeping it synchronous keeps its failure modes identical
			// to a non-retried request's.
			this.retryTimerFunction(() => { fReplay(); }, tmpDelayMS);
			return;
		}
		this._runRetryHook(fBeforeHook, tmpContext, 'onBeforeRetry').then(
			(pHookResult) =>
			{
				if (pHookResult === false)
				{
					// Roll the marker back so the veto does not consume an attempt.
					pReplayOptions.__retryAttempt = tmpAttemptsMade - 1;
					return this._invokeDetached(() => fCallback(pError, pResponse, pBody));
				}
				this.retryTimerFunction(() => { fReplay(); }, tmpDelayMS);
			});
		return;
	}

	executeJSONRequest(pOptions, fCallback)
	{
		pOptions.json = true;

		let tmpReplayOptions = this._captureReplayOptions(pOptions);

		let tmpOptions = this.preRequest(pOptions);

		if (!('headers' in tmpOptions))
		{
			tmpOptions.headers = {};
		}
		/* Automated headers break some APIs
		if (!('Content-Type' in tmpOptions.headers))
		{
			tmpOptions.headers['Content-Type'] = 'application/json';
		}
		*/

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} JSON request to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse)=>
			{
				if (pError)
				{
					return this._completeWithRetry(tmpReplayOptions, pError, pResponse, undefined,
						() => this.executeJSONRequest(tmpReplayOptions, fCallback), fCallback);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> JSON ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpJSONData = '';

				// A body that stops mid-stream is reportable only here, and only as
				// a transport failure -- see _guardResponseStream for why it hands the
				// retry seam no response.
				let fClaimSettle = this._guardResponseStream(pResponse,
					(pInterruptedError) =>
					{
						return this._completeWithRetry(tmpReplayOptions, pInterruptedError, undefined, undefined,
							() => this.executeJSONRequest(tmpReplayOptions, fCallback), fCallback);
					});

				pResponse.on('data', (pChunk) =>
					{
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> JSON ${tmpOptions.method} data chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						tmpJSONData += pChunk;
					});

				pResponse.on('end', ()=>
					{
						if (!fClaimSettle())
						{
							return;
						}
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> JSON ${tmpOptions.method} completed - received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						let tmpParsedJSON;
						if (tmpJSONData.length < 1
							&& ((NO_CONTENT_STATUS_CODES.indexOf(pResponse.statusCode) > -1) || (tmpOptions.method === 'HEAD')))
						{
							// A response DEFINED to carry no body -- those statuses,
							// or any HEAD -- is not a parse failure. Narrowed on
							// purpose: an empty body on a 200 GET still means the
							// response was truncated or the server misbehaved.
							return this._completeWithRecovery(tmpReplayOptions, pError, pResponse, null,
								() => this.executeJSONRequest(tmpReplayOptions, fCallback), fCallback);
						}
						try
						{
							tmpParsedJSON = JSON.parse(tmpJSONData);
						}
						catch (pParseError)
						{
							// A gateway that fails mid-flight often answers with a
							// non-JSON error page, so this path is retry-eligible on
							// the response status (a 200 with garbage is not).
							let tmpStatusCode = pResponse ? pResponse.statusCode : 'unknown';
							let tmpUnparseableError = new Error(`JSON parse failed (HTTP ${tmpStatusCode}): ${tmpJSONData.substring(0, 200)}`);
							return this._completeWithRetry(tmpReplayOptions, tmpUnparseableError, pResponse, null,
								() => this.executeJSONRequest(tmpReplayOptions, fCallback), fCallback);
						}
						return this._completeWithRecovery(tmpReplayOptions, pError, pResponse, tmpParsedJSON,
							() => this.executeJSONRequest(tmpReplayOptions, fCallback), fCallback);
					});
			});
	}

	getJSON(pOptionsOrURL, fCallback)
	{
		let tmpRequestOptions = (typeof(pOptionsOrURL) == 'object') ? pOptionsOrURL : {};
		if (typeof(pOptionsOrURL) == 'string')
		{
			tmpRequestOptions.url = pOptionsOrURL;
		}

		tmpRequestOptions.method = 'GET';

		return this.executeJSONRequest(tmpRequestOptions, fCallback);
	}

	putJSON(pOptions, fCallback)
	{
		if (typeof(pOptions.body) != 'object')
		{
			return fCallback(new Error(`PUT JSON Error Invalid options object`));
		}

		pOptions.method = 'PUT';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	postJSON(pOptions, fCallback)
	{
		if (typeof(pOptions.body) != 'object')
		{
			return fCallback(new Error(`POST JSON Error Invalid options object`));
		}

		pOptions.method = 'POST';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	patchJSON(pOptions, fCallback)
	{
		if (typeof(pOptions.body) != 'object')
		{
			return fCallback(new Error(`PATCH JSON Error Invalid options object`));
		}

		pOptions.method = 'PATCH';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	headJSON(pOptions, fCallback)
	{
		pOptions.method = 'HEAD';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	delJSON(pOptions, fCallback)
	{
		pOptions.method = 'DELETE';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	/**
	 * Upload binary data via POST.
	 *
	 * Accepts Buffer, Blob, or File as the body. In the browser, Blob/File
	 * bodies are converted to Buffer (via ArrayBuffer) before being passed
	 * to simple-get so the stream-http shim can send them correctly.
	 *
	 * The response body is read as a string (servers typically return JSON
	 * status for upload endpoints).
	 *
	 * @param {Record<string, any>} pOptions - Request options (url, body, headers, method)
	 * @param {(pError?: Error, pResponse: any, pBody?: any) => void} fCallback - Callback (pError, pResponse, pBody)
	 * @param {(pProgress: number) => void} [fOnProgress] - Optional progress callback (0.0 to 1.0); called with 1.0 on completion
	 */
	executeBinaryUpload(pOptions, fCallback, fOnProgress)
	{
		// Blob/File → Buffer conversion for simple-get compatibility
		let tmpBody = pOptions.body;

		if (typeof Blob !== 'undefined' && tmpBody instanceof Blob)
		{
			let tmpSelf = this;
			tmpBody.arrayBuffer()
				.then(
					(pArrayBuffer) =>
					{
						pOptions.body = Buffer.from(pArrayBuffer);
						tmpSelf._executeBinaryUploadInternal(pOptions, fCallback, fOnProgress);
					})
				.catch(
					(pError) =>
					{
						return fCallback(pError);
					});
			return;
		}

		// Already a Buffer, string, or stream — proceed directly
		return this._executeBinaryUploadInternal(pOptions, fCallback, fOnProgress);
	}

	/**
	 * Internal binary upload implementation using simple-get.
	 *
	 * @param {Record<string, any>} pOptions - Request options with body already as Buffer
	 * @param {(pError?: Error, pResponse: any, pBody?: any) => void} fCallback - Callback (pError, pResponse, pBody)
	 * @param {(pProgress: number) => void} [fOnProgress] - Optional progress callback (0.0 to 1.0); called with 1.0 on completion
	 * @private
	 */
	_executeBinaryUploadInternal(pOptions, fCallback, fOnProgress)
	{
		let tmpReplayOptions = this._captureReplayOptions(pOptions);

		let tmpOptions = this.preRequest(pOptions);

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} binary upload to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		tmpOptions.json = false;

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse) =>
			{
				if (pError)
				{
					return this._completeWithRetry(tmpReplayOptions, pError, pResponse, undefined,
						() => this._executeBinaryUploadInternal(tmpReplayOptions, fCallback, fOnProgress), fCallback);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> Binary upload ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpData = '';

				// A body that stops mid-stream is reportable only here, and only as
				// a transport failure -- see _guardResponseStream for why it hands the
				// retry seam no response.
				let fClaimSettle = this._guardResponseStream(pResponse,
					(pInterruptedError) =>
					{
						return this._completeWithRetry(tmpReplayOptions, pInterruptedError, undefined, undefined,
							() => this._executeBinaryUploadInternal(tmpReplayOptions, fCallback, fOnProgress), fCallback);
					});

				pResponse.on('data', (pChunk) =>
					{
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> Binary upload ${tmpOptions.method} response chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						tmpData += pChunk;
					});

				pResponse.on('end', () =>
					{
						if (!fClaimSettle())
						{
							return;
						}
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> Binary upload ${tmpOptions.method} completed in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						// Deliver terminally: fire the completion progress only when
						// we actually hand the response back (not when we are about to
						// replay after recovery -- the replay signals its own progress).
						let fDeliver = (pDeliverError, pDeliverResponse, pDeliverBody) =>
						{
							if (typeof fOnProgress === 'function')
							{
								fOnProgress(1.0);
							}
							return fCallback(pDeliverError, pDeliverResponse, pDeliverBody);
						};
						return this._completeWithRecovery(tmpReplayOptions, pError, pResponse, tmpData,
							() => this._executeBinaryUploadInternal(tmpReplayOptions, fCallback, fOnProgress), fDeliver);
					});
			});
	}

	/**
	 * The stock retry policy, as a fresh copy callers can inspect or clone.
	 *
	 * @return {RestClientRetryPolicy} A copy of the default policy.
	 */
	static get DefaultRetryPolicy()
	{
		return Object.assign({}, DEFAULT_RETRY_POLICY);
	}

	getRawText(pOptionsOrURL, fCallback)
	{
		let tmpRequestOptions = (typeof(pOptionsOrURL) == 'object') ? pOptionsOrURL : {};
		if (typeof(pOptionsOrURL) == 'string')
		{
			tmpRequestOptions.url = pOptionsOrURL;
		}

		tmpRequestOptions.method = 'GET';

		return this.executeChunkedRequest(tmpRequestOptions, fCallback);
	}
}

module.exports = FableServiceRestClient;

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":20,"cookie":31,"fable-serviceproviderbase":59,"http":524,"https":116,"simple-get":523}],102:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceTemplate extends libFableServiceBase
{
	// Underscore and lodash have a behavior, _.template, which compiles a
	// string-based template with code snippets into simple executable pieces,
	// with the added twist of returning a precompiled function ready to go.
	//
	// NOTE: This does not implement underscore escape expressions
	// NOTE: This does not implement underscore magic browser variable assignment
	//
	// This is an implementation of that.
	// TODO: Make this use precedent, add configuration, add debugging.
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'Template';

		// These are the exact regex's used in lodash/underscore
		// TODO: Switch this to precedent
		this.Matchers = (
			{
				Evaluate: /<%([\s\S]+?)%>/g,
				Interpolate: /<%=([\s\S]+?)%>/g,
				Escaper: /\\|'|\r|\n|\t|\u2028|\u2029/g,
				Unescaper: /\\(\\|'|r|n|t|u2028|u2029)/g,
				// This is how underscore does it, so we are keeping it for now.
				GuaranteedNonMatch: /.^/
			});

		// This is a helper for the escaper and unescaper functions.
		// Right now we are going to keep what underscore is doing, but, not forever.
		this.templateEscapes = {
			'\\': '\\',
			"'": "'",
			'r': '\r',
			'\r': 'r',
			'n': '\n',
			'\n': 'n',
			't': '\t',
			'\t': 't',
			'u2028': '\u2028',
			'\u2028': 'u2028',
			'u2029': '\u2029',
			'\u2029': 'u2029'
		};

		// This is defined as such to underscore that it is a dynamic programming
		// function on this class.
		this.renderFunction = false;
		this.templateString = false;
	}

	renderTemplate(pData)
	{
		return this.renderFunction(pData);
	}

	templateFunction()
	{
		let fRenderTemplateBound = this.renderTemplate.bind(this);
		return fRenderTemplateBound;
	}

	buildTemplateFunction(pTemplateText, pData)
	{
		// For now this is being kept in a weird form ... this is to mimic the old
		// underscore code until this is rewritten using precedent.
		this.TemplateSource = "__p+='" + pTemplateText
			.replace(this.Matchers.Escaper,
				(pMatch)=>
				{
					return `\\${this.templateEscapes[pMatch]}`;
				})
			.replace(this.Matchers.Interpolate || this.Matchers.GuaranteedNonMatch,
				(pMatch, pCode) =>
				{
					return `'+\n(${decodeURIComponent(pCode)})+\n'`;
				})
			.replace(this.Matchers.Evaluate || this.Matchers.GuaranteedNonMatch,
				(pMatch, pCode) =>
				{
					return `';\n${decodeURIComponent(pCode)}\n;__p+='`;
				}) + `';\n`;


		this.TemplateSource = `with(pTemplateDataObject||{}){\n${this.TemplateSource}}\n`;
		this.TemplateSource = `var __p='';var print=function(){__p+=Array.prototype.join.call(arguments, '')};\n${this.TemplateSource}return __p;\n`;

		this.renderFunction = new Function('pTemplateDataObject', this.TemplateSource);

		if (typeof(pData) != 'undefined')
		{
			return this.renderFunction(pData);
		}

		// Provide the compiled function source as a convenience for build time
		// precompilation.
		this.TemplateSourceCompiled = 'function(obj){\n' + this.TemplateSource + '}';

		return this.templateFunction();
	}
}

module.exports = FableServiceTemplate;

},{"fable-serviceproviderbase":59}],103:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

// TODO: These are still pretty big -- consider the smaller polyfills
const libAsyncWaterfall = require('async.waterfall');
const libAsyncEachLimit = require('async.eachlimit');

const libBigNumber = require('big.js');

class FableServiceUtility extends libFableServiceBase
{
	// Underscore and lodash have a behavior, _.template, which compiles a
	// string-based template with code snippets into simple executable pieces,
	// with the added twist of returning a precompiled function ready to go.
	//
	// NOTE: This does not implement underscore escape expressions
	// NOTE: This does not implement underscore magic browser variable assignment
	//
	// This is an implementation of that.
	// TODO: Make this use precedent, add configuration, add debugging.
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.templates = {};

		// These two functions are used extensively throughout
		this.waterfall = libAsyncWaterfall;
		this.eachLimit = libAsyncEachLimit;

		this.bigNumber = libBigNumber;
	}

	// Underscore and lodash have a behavior, _.extend, which merges objects.
	// Now that es6 gives us this, use the native thingy.
	// Nevermind, the native thing is not stable enough across environments
	// Basic shallow copy
	extend(pDestinationObject, ...pSourceObjects)
	{
		for (let i = 0; i < pSourceObjects.length; i++)
		{
			let tmpSourceObject = pSourceObjects[i];
			if (typeof(tmpSourceObject) === 'object')
			{
				let tmpObjectProperties = Object.keys(tmpSourceObject);
				for (let k = 0; k < tmpObjectProperties.length; k++)
				{
					pDestinationObject[tmpObjectProperties[k]] = tmpSourceObject[tmpObjectProperties[k]];
				}
			}
		}
		return pDestinationObject;
	}

	// Underscore and lodash have a behavior, _.template, which compiles a
	// string-based template with code snippets into simple executable pieces,
	// with the added twist of returning a precompiled function ready to go.
	template(pTemplateText, pData)
	{
		let tmpTemplate = this.fable.instantiateServiceProviderWithoutRegistration('Template');
		return tmpTemplate.buildTemplateFunction(pTemplateText, pData);
	}

	// Build a template function from a template hash, and, register it with the service provider
	buildHashedTemplate(pTemplateHash, pTemplateText, pData)
	{
		let tmpTemplate = this.fable.instantiateServiceProvider('Template', {}, pTemplateHash);
		this.templates[pTemplateHash] = tmpTemplate.buildTemplateFunction(pTemplateText, pData);
		return this.templates[pTemplateHash];
	}

	// This is a safe, modern version of chunk from underscore
	// Algorithm pulled from a mix of these two polyfills:
	// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_chunk
	// https://youmightnotneed.com/lodash
	// This implementation was most tolerant in browsers.  Uglify can fix the rest.
	chunk (pInput, pChunkSize, pChunkCache)
	{
		let tmpInputArray = [...pInput];
		// Note lodash defaults to 1, underscore defaults to 0
		let tmpChunkSize = (typeof(pChunkSize) == 'number') ? pChunkSize : 0;
		let tmpChunkCache = (typeof(pChunkCache) != 'undefined') ? pChunkCache : [];

		if (tmpChunkSize <= 0)
		{
			return tmpChunkCache;
		}

		while (tmpInputArray.length)
		{
			tmpChunkCache.push(tmpInputArray.splice(0, tmpChunkSize));
		}

		return tmpChunkCache;
	}

	/**
	 * Get a value from fable/pict by hash/address
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 */
	getInternalValueByHash(pValueAddress)
	{
		// Get the value from the internal manifest and return it
		return this.getValueByHash(this.fable, pValueAddress);
	}

	/**
	 * Set a value from fable/pict by hash/address
	 *
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {any} pValue - The value to set
	 */
	setInternalValueByHash(pValueAddress, pValue)
	{
		// Get the value from the internal manifest and return it
		return this.setValueByHash(this.fable, pValueAddress, pValue);
	}

	/**
	 * Get a value from an object by hash/address
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value from the object
	 */
	getValueByHash(pObject, pValueAddress, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		// Get the value from the internal manifest and return it
		return tmpManifest.getValueByHash(pObject, pValueAddress);
	}

	/**
	 * Set a value to an object by hash/address
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} pValue - The value to set
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value from the object
	 */
	setValueByHash(pObject, pValueAddress, pValue, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		// Get the value from the internal manifest and return it
		return tmpManifest.setValueByHash(pObject, pValueAddress, pValue);
	}

	/**
	 * Get a value array from an object by hash/address list
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {Array} - The value array built from the hash list
	 */
	createValueArrayByHashes(pObject, pValueHashes, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		if (!Array.isArray(pValueHashes))
		{
			return [];
		}

		let tmpValueArray = [];
		for (let i = 0; i < pValueHashes.length; i++)
		{
			tmpValueArray.push(tmpManifest.getValueByHash(pObject, pValueHashes[i]));
		}

		// Get the value from the internal manifest and return it
		return tmpValueArray;
	}

	slice(pValueArray, pStartIndex, pEndIndex)
	{
		if (!Array.isArray(pValueArray))
		{
			this.fable.log.error('Fable.Math.slice called with non-array value', { pValueArray });
			return [];
		}
		const tmpStartIndex = Number(this.fable.Math.parsePrecise(pStartIndex, '0'));
		const tmpEndIndex = Number(this.fable.Math.parsePrecise(pEndIndex, pValueArray.length.toString()));
		return pValueArray.slice(tmpStartIndex, tmpEndIndex);
	}

	/**
	 * Get a value array by hash/address list from the internal fable/pict state
	 * @param {string} pValueHashes - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {Array} - The value array built from the hash list
	 */
	createValueArrayByHashesFromInternal(pValueHashes, pManifest)
	{
		return this.createValueArrayByHashes(this.fable, pValueHashes, pManifest);
	}

	createValueArrayByHashParametersFromInternal()
	{
		if (arguments.length < 2)
		{
			return [];
		}

		let tmpValueHashes = Array.prototype.slice.call(arguments);
		return this.createValueArrayByHashes(this.fable, tmpValueHashes);
	}

	/**
	 * Get a value object from a list of hash/addressese
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueHashes - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value object built from the hash list
	 */
	createValueObjectByHashes(pObject, pValueHashes, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		if (!Array.isArray(pValueHashes))
		{
			return {};
		}

		let tmpValueObject = {};
		for (let i = 0; i < pValueHashes.length; i++)
		{
			tmpValueObject[pValueHashes[i]] = tmpManifest.getValueByHash(pObject, pValueHashes[i]);
		}

		// Get the value from the internal manifest and return it
		return tmpValueObject;
	}

	/**
	 * Get a value object by hash/address list from the internal fable/pict state
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value object built from the hash list
	 */
	createValueObjectByHashesFromInternal(pValueHashes, pManifest)
	{
		return this.createValueObjectByHashes(this.fable, pValueHashes, pManifest);
	}

	/**
	 * Get a value object by hash/address list as parameters from the internal fable/pict state
	 * @returns {Array} - The value array built from the hash list
	 */
	createValueObjectByHashParametersFromInternal()
	{
		let tmpValueHashes = Array.prototype.slice.call(arguments);
		return this.createValueObjectByHashes(this.fable, tmpValueHashes);
	}


	/**
	 * Check if a value is null or empty
	 * @param {object} pObject - The object to check
	 * @param {string} pValueAddress - The manyfest hash/address to check
	 */
	addressIsNullOrEmpty(pObject, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		// If it doesn't exist, it is null or empty.
		if (!this.manifest.checkAddressExists(pObject, pValueAddress))
		{
			return true;
		}

		// Get the value from the internal manifest and return it
		let tmpValue = this.manifest.getValueByHash(pObject, pValueAddress);
		if (tmpValue === null || tmpValue === '')
		{
			return true;
		}

		return false;
	}

	// Convert objects to arrays of labels or values for solvers
	objectKeysToArray(pObject)
	{
		return Object.keys(pObject);
	}

	// Convert object values to an array of values
	objectValuesToArray(pObject)
	{
		if ((typeof(pObject) !== 'object') || (pObject === null))
		{
			return [];
		}
		let tmpKeys = Object.keys(pObject);
		let tmpValues = [];

		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpValues.push(pObject[tmpKeys[i]]);
		}

		return tmpValues;
	}

	objectValuesSortByExternalArray(pArray, pObjectArray, pDescending, pSearchAddress)
	{
		let tmpDescending = (typeof(pDescending) == 'boolean') ? pDescending :
							((typeof(pDescending) == 'number') && (pDescending == 1)) ? true :
							((typeof(pDescending) == 'string') && (pDescending == '1')) ? true :
							false;
		let tmpManifest = this.fable.newManyfest();

		let tmpSearchAddresses = pSearchAddress;

		if (typeof(tmpSearchAddresses) != 'string')
		{
			// Defaulting to "label"...
			tmpSearchAddresses = 'label';
		}

		let tmpSortHelperArray = [];

		for (let i = 0; i < pArray.length; i++)
		{
			tmpSortHelperArray.push(
				{
					Value: pArray[i],
					SortValue: tmpManifest.getValueByHash(pObjectArray[i], tmpSearchAddresses),
					SortObject: pObjectArray[i]
				});
		}

		let tmpSortedArray = tmpSortHelperArray.sort((pLeft, pRight) =>
		{
			if (pLeft.SortValue < pRight.SortValue)
			{
				return tmpDescending ? 1 : -1;
			}
			if (pLeft.SortValue > pRight.SortValue)
			{
				return tmpDescending ? -1 : 1;
			}
			return 0;
		}).map((pSortHelperArrayObject) => { return pSortHelperArrayObject.Value; });

		return tmpSortedArray;
	}

	// Convert an ISO string to a javascript date object
	// Adapted from https://stackoverflow.com/a/54751179
	//
	// Takes strings like: 2022-11-04T11:34:45.000Z
	//                and: 1986-06-11T09:34:46.012Z+0200
	// ... and converts them into javascript timestamps, following the directions of the timezone stuff.
	//
	// This is not meant to replace the more complex libraries such as moment or luxon.
	// This *is* meant to be a simple, small, and fast way to convert ISO strings to dates in engines
	// with ultra limited JS capabilities where those don't work.
	isoStringToDate (pISOString)
	{
		if (!('Dates' in this.fable))
		{
			this.fable.instantiateServiceProvider('Dates');
		}

		let tmpDate = false;

		try
		{
			tmpDate = this.fable.Dates.dayJS.utc(pISOString);
		}
		catch(pError)
		{
			// TODO: Should this throw?  Doubtful.
			this.fable.log.error(`Could not parse date string ${pISOString} with dayJS.`);
			return false;
		}

		if (tmpDate)
		{
			return tmpDate.toDate();
		}
		else
		{
			return false;
		}
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {array} pObjectArray - The array of objects to search
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByStringIncludes(pObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (!Array.isArray(pObjectArray))
		{
			return undefined;
		}
		for (let i = 0; i < pObjectArray.length; i++)
		{
			let tmpValueToMatch = this.manifest.getValueByHash(pObjectArray[i], pValueToMatchAddress);
			if (tmpValueToMatch && (tmpValueToMatch.includes(pValueToMatch)))
			{
				return this.manifest.getValueByHash(pObjectArray[i], pValueAddress);
			}
		}

		return undefined;
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {string} pFableAddress - The address in the fable object to pull the value from
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByStringIncludesInternal(pFableAddress, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (typeof(pFableAddress) != 'string')
		{
			return undefined;
		}
		let tmpObjectArray = this.manifest.getValueByHash(this.fable, pFableAddress);

		return this.findFirstValueByStringIncludes(tmpObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress);
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {array} pObjectArray - The array of objects to search
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByExactMatch(pObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (!Array.isArray(pObjectArray))
		{
			return undefined;
		}
		for (let i = 0; i < pObjectArray.length; i++)
		{
			let tmpValueToMatch = this.manifest.getValueByHash(pObjectArray[i], pValueToMatchAddress);
			if (tmpValueToMatch && (tmpValueToMatch == pValueToMatch))
			{
				return this.manifest.getValueByHash(pObjectArray[i], pValueAddress);
			}
		}

		return undefined;
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {string} pFableAddress - The address in the fable object to pull the value from
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByExactMatchInternal(pFableAddress, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (typeof(pFableAddress) != 'string')
		{
			return undefined;
		}
		let tmpObjectArray = this.manifest.getValueByHash(this.fable, pFableAddress);

		return this.findFirstValueByExactMatch(tmpObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress);
	}

	/**
	 * Find the index of a value in an array, using the specified search mode.
	 *
	 * @param {any} pValueToFind - The value to find.
	 * @param {Array<any>|string} pSearchArray - The array to search, or the address of such an array.
	 * @param {string|number} [pSearchMode='1'] - The search mode ('0' for exact match, '1' (or default) for searching sorted sets and finding the first value >= the specifid value. '-1' is the same behavior as '1' but sorted descending.
	 *
	 * @returns {number} - The index of the found value, or -1 if not found.
	 */
	findIndexInternal(pValueToFind, pSearchArray, pSearchMode = '1')
	{
		let tmpSearchArray = pSearchArray;
		if (typeof (pSearchArray) === 'string')
		{
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpSearchArray = this.manifest.getValueByHash(this.fable, pSearchArray);
		}

		if (!Array.isArray(tmpSearchArray))
		{
			this.fable.log.error('findIndexInternal called with non-array search array.');
			return -1;
		}

		const tmpIsNumericSearch = this.fable.Math.parsePrecise(pValueToFind, null) !== null;
		let tmpMatchIndex = -1;
		let tmpComparisonFunction;
		if (Number(pSearchMode) === 0)
		{
			// Exact match
			if (tmpIsNumericSearch)
			{
				tmpComparisonFunction = (pCandidate) => this.fable.Math.comparePrecise(pCandidate, pValueToFind) === 0;
			}
			else
			{
				tmpComparisonFunction = (pCandidate) => pCandidate === pValueToFind;
			}
		}
		else if (Number(pSearchMode) === -1)
		{
			// Sorted descending
			if (tmpIsNumericSearch)
			{
				tmpComparisonFunction = (pCandidate) => this.fable.Math.ltePrecise(pCandidate, pValueToFind);
			}
			else
			{
				tmpComparisonFunction = (pCandidate) => pCandidate <= pValueToFind;
			}
		}
		else
		{
			// Sorted ascending
			if (tmpIsNumericSearch)
			{
				tmpComparisonFunction = (pCandidate) => this.fable.Math.gtePrecise(pCandidate, pValueToFind);
			}
			else
			{
				tmpComparisonFunction = (pCandidate) => pCandidate >= pValueToFind;
			}
		}
		for (let i = 0; i < tmpSearchArray.length; i++)
		{
			if (tmpComparisonFunction(tmpSearchArray[i]))
			{
				return i;
			}
		}
		return -1;
	}

	/**
	 * Flatten an array of solver inputs into a single array
	 *
	 * @param {Array<any>} pInputArray - The array of inputs to flatten
	 * @return {Array<any>} - The flattened array
	 */
	flattenArrayOfSolverInputs(pInputArray)
	{
		if (!Array.isArray(pInputArray))
		{
			if (typeof pInputArray === 'object')
			{
				pInputArray = Object.values(pInputArray);
			}
			if (!pInputArray)
			{
				return [];
			}
		}
		const tmpArrayFlattener = (p) =>
		{
			if (Array.isArray(p))
			{
				return p; // .flatMap(tmpArrayFlattener);
			}
			if (typeof p === 'object')
			{
				return Object.values(p);
			}
			return [ p ];
		};
		return pInputArray.flatMap(tmpArrayFlattener);
	}

	generateArrayOfObjectsFromSets()
	{
		// For each argument pair, map data to an array of objects with the first parameter of the pairs as the property name and the second parameter as the array of values
		let tmpResultArray = [];
		if (arguments.length % 2 != 0)
		{
			// Must be pairs
			return tmpResultArray;
		}

		let tmpPropertyNames = [];
		let tmpValueArrays = [];

		for (let i = 0; i < arguments.length; i += 2)
		{
			tmpPropertyNames.push(arguments[i]);
			tmpValueArrays.push(this.objectValuesToArray(arguments[i + 1]));
		}

		for (let h = 0; h < tmpValueArrays.length; h++)
		{
			let tmpValueArray = tmpValueArrays[h];
			let tmpPropertyName = tmpPropertyNames[h];
			if (!Array.isArray(tmpValueArray))
			{
				continue;
			}
			for (let i = 0; i < tmpValueArray.length; i++)
			{
				if (tmpResultArray.length <= i)
				{
					tmpResultArray.push({});
				}

				let tmpObject = tmpResultArray[i];
				if (!tmpObject)
				{
					// This shouldn't be possible
					continue;
				}

				tmpObject[tmpPropertyName] = tmpValueArray[i];
			}
		}

		return tmpResultArray;
	}

	/**
	 * Take a set of arbitrary parameters and build an array from them
	 * @returns {Array} - An array built from the absolute values of the parameters
	 */
	createArrayFromAbsoluteValues()
	{
		let tmpArray = [];
		for (let i = 0; i < arguments.length; i++)
		{
			tmpArray.push(arguments[i]);
		}
		return tmpArray;
	}

	/**
	 * Concatenate multiple arrays into a single array
	 *
	 * @return {Array<any>} - The concatenated array
	 */
	concatenateArrays()
	{
		let tmpResultArray = [];
		for (let i = 0; i < arguments.length; ++i)
		{
			let tmpArray = arguments[i];
			if (Array.isArray(tmpArray))
			{
				tmpResultArray = tmpResultArray.concat(tmpArray);
			}
			else
			{
				this.fable.log.error('Fable.Service.Utility.concatenateArrays called with non-array argument', { index: i, value: tmpArray });
			}
		}
		return tmpResultArray;
	}
}

module.exports = FableServiceUtility;

},{"async.eachlimit":1,"async.waterfall":15,"big.js":17,"fable-serviceproviderbase":59}],104:[function(require,module,exports){

class SetConcatArray
{
	/**
	 * @param {Array<any>|SetConcatArray} pLeftValue - The left value to concatenate.
	 * @param {Array<any>|SetConcatArray} pRightValue - The right value to concatenate.
	 */
	constructor(pLeftValue, pRightValue)
	{
		if (pLeftValue instanceof SetConcatArray)
		{
			this.values = pLeftValue.values.concat([ pRightValue ]);
		}
		else if (pRightValue instanceof SetConcatArray)
		{
			this.values = [ pLeftValue ].concat(pRightValue.values);
		}
		else
		{
			this.values = [ pLeftValue, pRightValue ];
		}
	}
}

module.exports = SetConcatArray;

},{}],105:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],106:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":105}],107:[function(require,module,exports){
'use strict';

var undefined;

var $Object = require('es-object-atoms');

var $Error = require('es-errors');
var $EvalError = require('es-errors/eval');
var $RangeError = require('es-errors/range');
var $ReferenceError = require('es-errors/ref');
var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');
var $URIError = require('es-errors/uri');

var abs = require('math-intrinsics/abs');
var floor = require('math-intrinsics/floor');
var max = require('math-intrinsics/max');
var min = require('math-intrinsics/min');
var pow = require('math-intrinsics/pow');
var round = require('math-intrinsics/round');
var sign = require('math-intrinsics/sign');

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = require('gopd');
var $defineProperty = require('es-define-property');

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = require('get-proto');
var $ObjectGPO = require('get-proto/Object.getPrototypeOf');
var $ReflectGPO = require('get-proto/Reflect.getPrototypeOf');

var $apply = require('call-bind-apply-helpers/functionApply');
var $call = require('call-bind-apply-helpers/functionCall');

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('hasown');
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"call-bind-apply-helpers/functionApply":26,"call-bind-apply-helpers/functionCall":27,"es-define-property":41,"es-errors":43,"es-errors/eval":42,"es-errors/range":44,"es-errors/ref":45,"es-errors/syntax":46,"es-errors/type":47,"es-errors/uri":48,"es-object-atoms":49,"function-bind":106,"get-proto":110,"get-proto/Object.getPrototypeOf":108,"get-proto/Reflect.getPrototypeOf":109,"gopd":112,"has-symbols":113,"hasown":115,"math-intrinsics/abs":134,"math-intrinsics/floor":135,"math-intrinsics/max":137,"math-intrinsics/min":138,"math-intrinsics/pow":139,"math-intrinsics/round":140,"math-intrinsics/sign":141}],108:[function(require,module,exports){
'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;

},{"es-object-atoms":49}],109:[function(require,module,exports){
'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;

},{}],110:[function(require,module,exports){
'use strict';

var reflectGetProto = require('./Reflect.getPrototypeOf');
var originalGetProto = require('./Object.getPrototypeOf');

var getDunderProto = require('dunder-proto/get');

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;

},{"./Object.getPrototypeOf":108,"./Reflect.getPrototypeOf":109,"dunder-proto/get":40}],111:[function(require,module,exports){
'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;

},{}],112:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

},{"./gOPD":111}],113:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":114}],114:[function(require,module,exports){
'use strict';

/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],115:[function(require,module,exports){
'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

},{"function-bind":106}],116:[function(require,module,exports){
var http = require('http')
var url = require('url')

var https = module.exports

for (var key in http) {
  if (http.hasOwnProperty(key)) https[key] = http[key]
}

https.request = function (params, cb) {
  params = validateParams(params)
  return http.request.call(this, params, cb)
}

https.get = function (params, cb) {
  params = validateParams(params)
  return http.get.call(this, params, cb)
}

function validateParams (params) {
  if (typeof params === 'string') {
    params = url.parse(params)
  }
  if (!params.protocol) {
    params.protocol = 'https:'
  }
  if (params.protocol !== 'https:') {
    throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"')
  }
  return params
}

},{"http":524,"url":546}],117:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],118:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],119:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,setImmediate){(function (){
/*!

JSZip v3.10.2 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).JSZip=e()}}(function(){return function s(a,o,h){function u(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof require&&require;if(!e&&t)return t(r,!0);if(l)return l(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return u(t||e)},i,i.exports,s,a,o,h)}return o[r].exports}for(var l="function"==typeof require&&require,e=0;e<h.length;e++)u(h[e]);return u}({1:[function(e,t,r){"use strict";var d=e("./utils"),c=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,h=[],u=0,l=e.length,f=l,c="string"!==d.getTypeOf(e);u<e.length;)f=l-u,n=c?(t=e[u++],r=u<l?e[u++]:0,u<l?e[u++]:0):(t=e.charCodeAt(u++),r=u<l?e.charCodeAt(u++):0,u<l?e.charCodeAt(u++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<f?(15&r)<<2|n>>6:64,o=2<f?63&n:64,h.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,h=0,u="data:";if(e.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(e=e.replace(/[^A-Za-z0-9+/=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=c.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),l[h++]=t,64!==s&&(l[h++]=r),64!==a&&(l[h++]=n);return l}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils");var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}(0|t,e,e.length,0):function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t.charCodeAt(a))];return-1^e}(0|t,e,e.length,0):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n=null;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function h(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},h.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new h("Deflate",e)},r.uncompressWorker=function(){return new h("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function A(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function n(e,t,r,n,i,s){var a,o,h=e.file,u=e.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),c=I.transformTo("string",O.utf8encode(h.name)),d=h.comment,p=I.transformTo("string",s(d)),m=I.transformTo("string",O.utf8encode(d)),_=c.length!==h.name.length,g=m.length!==d.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===i?(C=798,z|=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(e){return 63&(e||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+c,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(n,4)+f+b+p}}var I=e("../utils"),i=e("../stream/GenericWorker"),O=e("../utf8"),B=e("../crc32"),R=e("../signature");function s(e,t,r,n){i.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}I.inherits(s,i),s.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,i.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},s.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=n(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},s.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=n(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:function(e){return R.DATA_DESCRIPTOR+A(e.crc32,4)+A(e.compressedSize,4)+A(e.uncompressedSize,4)}(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},s.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,n=function(e,t,r,n,i){var s=I.transformTo("string",i(n));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(e,2)+A(e,2)+A(t,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:n,meta:{percent:100}})},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},s.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(e){var t=this._sources;if(!i.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},s.prototype.lock=function(){i.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=s},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var u=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),h=0;try{e.forEach(function(e,t){h++;var r=function(e,t){var r=e||t,n=u[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=h}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.10.2",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var u=e("./utils"),i=e("./external"),n=e("./utf8"),s=e("./zipEntries"),a=e("./stream/Crc32Probe"),l=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new a);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,o){var h=this;return o=u.extend(o||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:n.utf8decode}),l.isNode&&l.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):u.prepareContent("the loaded zip file",e,!0,o.optimizedBinaryString,o.base64).then(function(e){var t=new s(o);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(o.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n],s=i.fileNameStr,a=u.resolve(i.fileNameStr);h.file(a,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:o.createFolders}),i.dir||(h.file(a).unsafeOriginalName=s)}return t.zipComment.length&&(h.comment=t.zipComment),h})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=u.getTypeOf(t),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=g(e)),s.createFolders&&(n=_(e))&&b.call(this,n,!0);var a="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string");var o=null;o=t instanceof c||t instanceof l?t:p.isNode&&p.isStream(t)?new m(e,t):u.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var h=new d(e,o,s);this.files[e]=h}var i=e("./utf8"),u=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),f=e("./defaults"),c=e("./compressedObject"),d=e("./zipObject"),o=e("./generate"),p=e("./nodejsUtils"),m=e("./nodejs/NodejsStreamInputAdapter"),_=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""},g=function(e){return"/"!==e.slice(-1)&&(e+="/"),e},b=function(e,t){return t=void 0!==t?t:f.createFolders,e=g(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function h(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n)},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(h(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=b.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=u.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){"use strict";t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(){},lastIndexOfSignature:function(){},readAndCheckSignature:function(){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),h=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new h(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo,e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),u=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function l(e,o){return new a.Promise(function(t,r){var n=[],i=e._internalType,s=e._outputType,a=e._mimeType;e.on("data",function(e,t){n.push(e),o&&o(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return u.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()})}function f(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}f.prototype={accumulate:function(e){return l(this,e)},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=f},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),h=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),u=new Array(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;u[254]=u[254]=1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function l(){n.call(this,"utf-8 encode")}s.utf8encode=function(e){return h.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=h.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return h.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=u[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(h.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(h.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}(t),i=t;n!==t.length&&(h.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=l},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,a){"use strict";var o=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),u=e("./external");function n(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}e("setimmediate"),a.newBlob=function(t,r){a.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var i={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function s(e){var t=65536,r=a.getTypeOf(e),n=!0;if("uint8array"===r?n=i.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=i.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return i.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return i.stringifyByChar(e)}function f(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}a.applyFromCharCode=s;var c={};c.string={string:n,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:s,array:n,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return s(new Uint8Array(e))},array:function(e){return f(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:n,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:n,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:n},a.transformTo=function(e,t){if(t=t||"",!e)return t;a.checkSupport(e);var r=a.getTypeOf(t);return c[r][e](t)},a.resolve=function(e){for(var t=e.split("/"),r=[],n=0;n<t.length;n++){var i=t[n];"."===i||""===i&&0!==n&&n!==t.length-1||(".."===i?r.pop():r.push(i))}return r.join("/")},a.getTypeOf=function(e){if("string"==typeof e)return"string";var t=Object.prototype.toString.call(e);return"[object Array]"===t?"array":o.nodebuffer&&r.isBuffer(e)?"nodebuffer":o.uint8array&&"[object Uint8Array]"===t?"uint8array":o.arraybuffer&&"[object ArrayBuffer]"===t?"arraybuffer":void 0},a.checkSupport=function(e){if(!o[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},a.delay=function(e,t,r){setImmediate(function(){e.apply(r||null,t||[])})},a.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},a.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},a.prepareContent=function(r,e,n,i,s){return u.Promise.resolve(e).then(function(n){return o.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))?void 0!==Blob.prototype.arrayBuffer?n.arrayBuffer():"undefined"!=typeof FileReader?new u.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):u.Promise.reject(new Error(r+" is a Blob, but we have no way of reading it.")):n}).then(function(e){var t=a.getTypeOf(e);return t?("arraybuffer"===t?e=a.transformTo("uint8array",e):"string"===t&&(s?e=h.decode(e):n&&!0!==i&&(e=function(e){return l(e,o.uint8array?new Uint8Array(e.length):new Array(e.length))}(e))),e):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,setimmediate:54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=e("./support");function h(e){this.files=[],this.loadOptions=e}h.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw!this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=h},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),h=e("./compressions"),u=e("./support");function l(e,t){this.options=e,this.loadOptions=t}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in h)if(Object.prototype.hasOwnProperty.call(h,t)&&h[t].magic===e)return h[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=l},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),h=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new h("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new i(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)n.prototype[u[f]]=l;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,l,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(u),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(u,0)};else{var o=new t.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0)}}var h=[];function u(){var e,t;n=!0;for(var r=h.length;r;){for(t=h,h=[],e=-1;++e<r;)t[e]();r=h.length}n=!1}l.exports=function(e){1!==h.push(e)||n||r()}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==u&&d(this,e)}function h(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function f(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return l.reject(t,e)}e===t?l.reject(t,new TypeError("Cannot resolve promise with itself")):l.resolve(t,e)})}function c(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function d(t,e){var r=!1;function n(e){r||(r=!0,l.reject(t,e))}function i(e){r||(r=!0,l.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(u);this.state!==n?f(r,this.state===a?e:t,this.outcome):this.queue.push(new h(r,e,t));return r},h.prototype.callFulfilled=function(e){l.resolve(this.promise,e)},h.prototype.otherCallFulfilled=function(e){f(this.promise,this.onFulfilled,e)},h.prototype.callRejected=function(e){l.reject(this.promise,e)},h.prototype.otherCallRejected=function(e){f(this.promise,this.onRejected,e)},l.resolve=function(e,t){var r=p(c,t);if("error"===r.status)return l.reject(e,r.value);var n=r.value;if(n)d(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},l.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){if(e instanceof this)return e;return l.resolve(new this(u),e)},o.reject=function(e){var t=new this(u);return l.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);var s=new Array(n),a=0,t=-1,o=new this(u);for(;++t<n;)h(e[t],t);return o;function h(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,l.resolve(o,s))},function(e){i||(i=!0,l.reject(o,e))})}},o.race=function(e){var t=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var r=e.length,n=!1;if(!r)return this.resolve([]);var i=-1,s=new this(u);for(;++i<r;)a=e[i],t.resolve(a).then(function(e){n||(n=!0,l.resolve(s,e))},function(e){n||(n=!0,l.reject(s,e))});var a;return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),h=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,c=0,d=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:f,method:d,chunkSize:16384,windowBits:15,memLevel:8,strategy:c,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==l)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?h.string2buf(t.dictionary):"[object ArrayBuffer]"===u.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==l)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=h.string2buf(e):"[object ArrayBuffer]"===u.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==n||(this.onEnd(l),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var c=e("./zlib/inflate"),d=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=d.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=c.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,c.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?h.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new d.Buf8(u),h.next_out=0,h.avail_out=u),(r=c.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=c.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(h.output,h.next_out),s=h.next_out-i,a=p.buf2string(h.output,i),h.next_out=s,h.avail_out=u-s,s&&d.arraySet(h.output,h.output,i,s,0),this.onData(a)):this.onData(d.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0)}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=c.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=d.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var h=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var u=new h.Buf8(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function l(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,h.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}u[254]=u[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new h.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return l(e,e.length)},r.binstring2buf=function(e){for(var t=new h.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=u[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return l(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var h,c=e("../utils/common"),u=e("./trees"),d=e("./adler32"),p=e("./crc32"),n=e("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,i=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(e,t){return e.msg=n[t],t}function T(e){return(e<<1)-(4<e?9:0)}function D(e){for(var t=e.length;0<=--t;)e[t]=0}function F(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(c.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function N(e,t){u._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,F(e.strm)}function U(e,t){e.pending_buf[e.pending++]=t}function P(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function L(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,h=e.strstart>e.w_size-z?e.strstart-(e.w_size-z):0,u=e.window,l=e.w_mask,f=e.prev,c=e.strstart+S,d=u[s+a-1],p=u[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(u[(r=t)+a]===p&&u[r+a-1]===d&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<c);if(n=S-(c-s),s=c-S,a<n){if(e.match_start=t,o<=(a=n))break;d=u[s+a-1],p=u[s+a]}}}while((t=f[t&l])>h&&0!=--i);return a<=e.lookahead?a:e.lookahead}function j(e){var t,r,n,i,s,a,o,h,u,l,f=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=f+(f-z)){for(c.arraySet(e.window,e.window,f,f,0),e.match_start-=f,e.strstart-=f,e.block_start-=f,t=r=e.hash_size;n=e.head[--t],e.head[t]=f<=n?n-f:0,--r;);for(t=r=f;n=e.prev[--t],e.prev[t]=f<=n?n-f:0,--r;);i+=f}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,h=e.strstart+e.lookahead,u=i,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,c.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=d(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),e.lookahead+=r,e.lookahead+e.insert>=x)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+x-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<x)););}while(e.lookahead<z&&0!==e.strm.avail_in)}function Z(e,t){for(var r,n;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r)),e.match_length>=x)if(n=u._tr_tally(e,e.strstart-e.match_start,e.match_length-x),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=x){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function W(e,t){for(var r,n,i;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=x-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===x&&4096<e.strstart-e.match_start)&&(e.match_length=x-1)),e.prev_length>=x&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-x,n=u._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-x),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=x-1,e.strstart++,n&&(N(e,!1),0===e.strm.avail_out))return A}else if(e.match_available){if((n=u._tr_tally(e,0,e.window[e.strstart-1]))&&N(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return A}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=u._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function M(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new c.Buf16(2*w),this.dyn_dtree=new c.Buf16(2*(2*a+1)),this.bl_tree=new c.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new c.Buf16(k+1),this.heap=new c.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new c.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function G(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?C:E,e.adler=2===t.wrap?0:1,t.last_flush=l,u._tr_init(t),m):R(e,_)}function K(e){var t=G(e);return t===m&&function(e){e.window_size=2*e.w_size,D(e.head),e.max_lazy_match=h[e.level].max_lazy,e.good_match=h[e.level].good_length,e.nice_match=h[e.level].nice_length,e.max_chain_length=h[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=x-1,e.match_available=0,e.ins_h=0}(e.state),t}function Y(e,t,r,n,i,s){if(!e)return _;var a=1;if(t===g&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||y<i||r!==v||n<8||15<n||t<0||9<t||s<0||b<s)return R(e,_);8===n&&(n=9);var o=new H;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new c.Buf8(2*o.w_size),o.head=new c.Buf16(o.hash_size),o.prev=new c.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new c.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,K(e)}h=[new M(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(j(e),0===e.lookahead&&t===l)return A;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,N(e,!1),0===e.strm.avail_out))return A;if(e.strstart-e.block_start>=e.w_size-z&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):(e.strstart>e.block_start&&(N(e,!1),e.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(e,t){return Y(e,t,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?_:(e.state.gzhead=t,m):_},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?R(e,_):_;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&t!==f)return R(e,0===e.avail_out?-5:_);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===C)if(2===n.wrap)e.adler=0,U(n,31),U(n,139),U(n,8),n.gzhead?(U(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),U(n,255&n.gzhead.time),U(n,n.gzhead.time>>8&255),U(n,n.gzhead.time>>16&255),U(n,n.gzhead.time>>24&255),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(U(n,255&n.gzhead.extra.length),U(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(U(n,0),U(n,0),U(n,0),U(n,0),U(n,0),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,3),n.status=E);else{var a=v+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=E,P(n,a),0!==n.strstart&&(P(n,e.adler>>>16),P(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending!==n.pending_buf_size));)U(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&F(e),n.pending+2<=n.pending_buf_size&&(U(n,255&e.adler),U(n,e.adler>>8&255),e.adler=0,n.status=E)):n.status=E),0!==n.pending){if(F(e),0===e.avail_out)return n.last_flush=-1,m}else if(0===e.avail_in&&T(t)<=T(r)&&t!==f)return R(e,-5);if(666===n.status&&0!==e.avail_in)return R(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==l&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(j(e),0===e.lookahead)){if(t===l)return A;break}if(e.match_length=0,r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=S){if(j(e),e.lookahead<=S&&t===l)return A;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=x&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+S;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=S-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=x?(r=u._tr_tally(e,1,e.match_length-x),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):h[n.level].func(n,t);if(o!==O&&o!==B||(n.status=666),o===A||o===O)return 0===e.avail_out&&(n.last_flush=-1),m;if(o===I&&(1===t?u._tr_align(n):5!==t&&(u._tr_stored_block(n,0,0,!1),3===t&&(D(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),F(e),0===e.avail_out))return n.last_flush=-1,m}return t!==f?m:n.wrap<=0?1:(2===n.wrap?(U(n,255&e.adler),U(n,e.adler>>8&255),U(n,e.adler>>16&255),U(n,e.adler>>24&255),U(n,255&e.total_in),U(n,e.total_in>>8&255),U(n,e.total_in>>16&255),U(n,e.total_in>>24&255)):(P(n,e.adler>>>16),P(n,65535&e.adler)),F(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?m:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==C&&69!==t&&73!==t&&91!==t&&103!==t&&t!==E&&666!==t?R(e,_):(e.state=null,t===E?R(e,-3):m):_},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,h,u,l=t.length;if(!e||!e.state)return _;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(e.adler=d(e.adler,t,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new c.Buf8(r.w_size),c.arraySet(u,t,l-r.w_size,r.w_size,0),t=u,l=r.w_size),a=e.avail_in,o=e.next_in,h=e.input,e.avail_in=l,e.next_in=0,e.input=t,j(r);r.lookahead>=x;){for(n=r.strstart,i=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+x-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=x-1,j(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,e.next_in=o,e.input=h,e.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,C=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,c=r.window,d=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=m[d&g];t:for(;;){if(d>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else{if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(d&(1<<y)-1)];continue t}if(32&y){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}w=65535&v,(y&=15)&&(p<y&&(d+=z[n++]<<p,p+=8),w+=d&(1<<y)-1,d>>>=y,p-=y),p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=_[d&b];r:for(;;){if(d>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(d&(1<<y)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&v,p<(y&=15)&&(d+=z[n++]<<p,(p+=8)<y&&(d+=z[n++]<<p,p+=8)),h<(k+=d&(1<<y)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=c,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=c[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=c[x++],--y;);x=s-k,S=C}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]))}else{for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]))}break}}break}}while(n<i&&s<o);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=d,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),R=e("./inffast"),T=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function h(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function u(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=h(e,t))!==N&&(e.state=null),r):U}var l,f,c=!0;function j(e){if(c){var t;for(l=new I.Buf32(512),f=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(T(D,e.lens,0,288,l,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;T(F,e.lens,0,32,f,0,e.work,{bits:5}),c=!1}e.lencode=l,e.lenbits=9,e.distcode=f,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(e){return u(e,15)},r.inflateInit2=u,r.inflate=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,f=o,c=h,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){e.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.flags=u,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(d=r.length)&&(d=o),d&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,d,k)),512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,r.length-=d),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}l=u=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}e.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;u>>>=2,l-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if((65535&u)!=(u>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(d=r.length){if(o<d&&(d=o),h<d&&(d=h),0===d)break e;I.arraySet(i,n,s,d,a),o-=d,s+=d,h-=d,a+=d,r.length-=d;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else{if(16===b){for(z=_+2;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u>>>=_,l-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],d=3+(3&u),u>>>=2,l-=2}else if(17===b){for(z=_+3;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=3+(7&(u>>>=_)),u>>>=3,l-=3}else{for(z=_+7;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=11+(127&(u>>>=_)),u>>>=7,l-=7}if(r.have+d>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;d--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=h){e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,R(e,c),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break e;if(d=c-h,r.offset>d){if((d=r.offset-d)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=d>r.wnext?(d-=r.wnext,r.wsize-d):r.wnext-d,d>r.length&&(d=r.length),m=r.window}else m=i,p=a-r.offset,d=r.length;for(h<d&&(d=h),h-=d,r.length-=d;i[a++]=m[p++],--d;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break e;i[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break e;o--,u|=n[s++]<<l,l+=8}if(c-=h,e.total_out+=c,r.total+=c,c&&(e.adler=r.check=r.flags?B(r.check,i,c,a-c):O(r.check,i,c,a-c)),c=h,(r.flags?u:L(u))!==r.check){e.msg="incorrect data check",r.mode=30;break}l=u=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}l=u=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,(r.wsize||c!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,c-e.avail_out)?(r.mode=31,-4):(f-=e.avail_in,c-=e.avail_out,e.total_in+=f,e.total_out+=c,r.total+=c,r.wrap&&c&&(e.adler=r.check=r.flags?B(r.check,i,c,e.next_out-c):O(r.check,i,c,e.next_out-c)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===c||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var h,u,l,f,c,d,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<n;v++)O[t[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return-1;if(0<z&&(0===e||1!==w))return-1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<n;v++)0!==t[r+v]&&(a[B[t[r+v]]++]=v);if(d=0===e?(A=R=a,19):1===e?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,c=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===e&&852<C||2===e&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<d?(m=0,a[v]):a[v]>d?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;i[c+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=t[r+a[v]]}if(k<b&&(E&f)!==l){for(0===S&&(S=k),c+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===e&&852<C||2===e&&592<C)return 1;i[l=E&f]=k<<24|x<<16|c-s|0}}return 0!==E&&(i[c+E]=b-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var i=e("../utils/common"),o=0,h=1;function n(e){for(var t=e.length;0<=--t;)e[t]=0}var s=0,a=29,u=256,l=u+1+a,f=30,c=19,_=2*l+1,g=15,d=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));n(z);var C=new Array(2*f);n(C);var E=new Array(512);n(E);var A=new Array(256);n(A);var I=new Array(a);n(I);var O,B,R,T=new Array(f);function D(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function F(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function N(e){return e<256?E[e]:E[256+(e>>>7)]}function U(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function P(e,t,r){e.bi_valid>d-r?(e.bi_buf|=t<<e.bi_valid&65535,U(e,e.bi_buf),e.bi_buf=t>>d-e.bi_valid,e.bi_valid+=r-d):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function L(e,t,r){P(e,r[2*t],r[2*t+1])}function j(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function Z(e,t,r){var n,i,s=new Array(g+1),a=0;for(n=1;n<=g;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=j(s[o]++,o))}}function W(e){var t;for(t=0;t<l;t++)e.dyn_ltree[2*t]=0;for(t=0;t<f;t++)e.dyn_dtree[2*t]=0;for(t=0;t<c;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*m]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function M(e){8<e.bi_valid?U(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function H(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function G(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&H(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!H(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function K(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?L(e,i,t):(L(e,(s=A[i])+u+1,t),0!==(a=w[s])&&P(e,i-=I[s],a),L(e,s=N(--n),r),0!==(a=k[s])&&P(e,n-=T[s],a)),o<e.last_lit;);L(e,m,t)}function Y(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,h=t.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(e.heap[++e.heap_len]=u=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=u,r=e.heap_len>>1;1<=r;r--)G(e,s,r);for(i=h;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],G(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,G(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,h=t.dyn_tree,u=t.max_code,l=t.stat_desc.static_tree,f=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=g;s++)e.bl_count[s]=0;for(h[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<_;r++)p<(s=h[2*h[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),h[2*n+1]=s,u<n||(e.bl_count[s]++,a=0,d<=n&&(a=c[n-d]),o=h[2*n],e.opt_len+=o*(s+a),f&&(e.static_len+=o*(l[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)u<(i=e.heap[--r])||(h[2*i+1]!==s&&(e.opt_len+=(s-h[2*i+1])*h[2*i],h[2*i+1]=s),n--)}}(e,t),Z(s,u,e.bl_count)}function X(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<h&&i===a||(o<u?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[2*b]++):o<=10?e.bl_tree[2*v]++:e.bl_tree[2*y]++,s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4))}function V(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<h&&i===a)){if(o<u)for(;L(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(L(e,i,e.bl_tree),o--),L(e,b,e.bl_tree),P(e,o-3,2)):o<=10?(L(e,v,e.bl_tree),P(e,o-3,3)):(L(e,y,e.bl_tree),P(e,o-11,7));s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4)}}n(T);var q=!1;function J(e,t,r,n){P(e,(s<<1)+(n?1:0),3),function(e,t,r,n){M(e),n&&(U(e,r),U(e,~r)),i.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r}(e,t,r,!0)}r._tr_init=function(e){q||(function(){var e,t,r,n,i,s=new Array(g+1);for(n=r=0;n<a-1;n++)for(I[n]=r,e=0;e<1<<w[n];e++)A[r++]=n;for(A[r-1]=n,n=i=0;n<16;n++)for(T[n]=i,e=0;e<1<<k[n];e++)E[i++]=n;for(i>>=7;n<f;n++)for(T[n]=i<<7,e=0;e<1<<k[n]-7;e++)E[256+i++]=n;for(t=0;t<=g;t++)s[t]=0;for(e=0;e<=143;)z[2*e+1]=8,e++,s[8]++;for(;e<=255;)z[2*e+1]=9,e++,s[9]++;for(;e<=279;)z[2*e+1]=7,e++,s[7]++;for(;e<=287;)z[2*e+1]=8,e++,s[8]++;for(Z(z,l+1,s),e=0;e<f;e++)C[2*e+1]=5,C[2*e]=j(e,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,c,p)}(),q=!0),e.l_desc=new F(e.dyn_ltree,O),e.d_desc=new F(e.dyn_dtree,B),e.bl_desc=new F(e.bl_tree,R),e.bi_buf=0,e.bi_valid=0,W(e)},r._tr_stored_block=J,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return o;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return h;for(t=32;t<u;t++)if(0!==e.dyn_ltree[2*t])return h;return o}(e)),Y(e,e.l_desc),Y(e,e.d_desc),a=function(e){var t;for(X(e,e.dyn_ltree,e.l_desc.max_code),X(e,e.dyn_dtree,e.d_desc.max_code),Y(e,e.bl_desc),t=c-1;3<=t&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?J(e,t,r,n):4===e.strategy||s===i?(P(e,2+(n?1:0),3),K(e,z,C)):(P(e,4+(n?1:0),3),function(e,t,r,n){var i;for(P(e,t-257,5),P(e,r-1,5),P(e,n-4,4),i=0;i<n;i++)P(e,e.bl_tree[2*S[i]+1],3);V(e,e.dyn_ltree,t-1),V(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),K(e,e.dyn_ltree,e.dyn_dtree)),W(e),n&&M(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(A[r]+u+1)]++,e.dyn_dtree[2*N(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){P(e,2,3),L(e,m,z),function(e){16===e.bi_valid?(U(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):8<=e.bi_valid&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}(e)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){(function(e){!function(r,n){"use strict";if(!r.setImmediate){var i,s,t,a,o=1,h={},u=!1,l=r.document,e=Object.getPrototypeOf&&Object.getPrototypeOf(r);e=e&&e.setTimeout?e:r,i="[object process]"==={}.toString.call(r.process)?function(e){process.nextTick(function(){c(e)})}:function(){if(r.postMessage&&!r.importScripts){var e=!0,t=r.onmessage;return r.onmessage=function(){e=!1},r.postMessage("","*"),r.onmessage=t,e}}()?(a="setImmediate$"+Math.random()+"$",r.addEventListener?r.addEventListener("message",d,!1):r.attachEvent("onmessage",d),function(e){r.postMessage(a+e,"*")}):r.MessageChannel?((t=new MessageChannel).port1.onmessage=function(e){c(e.data)},function(e){t.port2.postMessage(e)}):l&&"onreadystatechange"in l.createElement("script")?(s=l.documentElement,function(e){var t=l.createElement("script");t.onreadystatechange=function(){c(e),t.onreadystatechange=null,s.removeChild(t),t=null},s.appendChild(t)}):function(e){setTimeout(c,0,e)},e.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var n={callback:e,args:t};return h[o]=n,i(o),o++},e.clearImmediate=f}function f(e){delete h[e]}function c(e){if(u)setTimeout(c,0,e);else{var t=h[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}(t)}finally{f(e),u=!1}}}}function d(e){e.source===r&&"string"==typeof e.data&&0===e.data.indexOf(a)&&c(+e.data.slice(a.length))}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[10])(10)});
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],require("timers").setImmediate)

},{"_process":439,"buffer":20,"timers":545}],120:[function(require,module,exports){
/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
 * Copyright (C) 2020 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.9"
/*!
 * lunr.utils
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function () {
    return this
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2020 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.empty

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define(factory)
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();

},{}],121:[function(require,module,exports){
// When a boxed property is passed in, it should have quotes of some
// kind around it.
//
// For instance:
// 		MyValues['Name']
// 		MyValues["Age"]
// 		MyValues[`Cost`]
//
// This function removes the wrapping quotes.
//
// Please note it *DOES NOT PARSE* template literals, so backticks just
// end up doing the same thing as other quote types.
//
// TODO: Should template literals be processed?  If so what state do they have access to?  That should happen here if so.
// TODO: Make a simple class include library with these
/**
 * @param {string} pCharacter - The character to remove from the start and end of the string
 * @param {string} pString - The string to clean
 *
 * @return {string} The cleaned string
 */
const cleanWrapCharacters = (pCharacter, pString) =>
{
	if (pString.startsWith(pCharacter) && pString.endsWith(pCharacter))
	{
		return pString.substring(1, pString.length - 1);
	}
	else
	{
		return pString;
	}
};

module.exports = cleanWrapCharacters;

},{}],122:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');

/**
* Hash Translation
*
* This is a very simple translation table for hashes, which allows the same schema to resolve
* differently based on a loaded translation table.
*
* This is to prevent the requirement for mutating schemas over and over again when we want to
* reuse the structure but look up data elements by different addresses.
*
* One side-effect of this is that a translation table can "override" the built-in hashes, since
* this is always used to resolve hashes before any of the functionCallByHash(pHash, ...) perform
* their lookups by hash.
*
* @class ManyfestHashTranslation
*/
class ManyfestHashTranslation
{
    /**
     * @param {function} [pInfoLog] - (optional) A logging function for info messages
     * @param {function} [pErrorLog] - (optional) A logging function for error messages
     */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) === 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) === 'function') ? pErrorLog : libSimpleLog;

        this.translationTable = {};
	}

    /**
     * @return {number} The number of translations in the table
     */
    translationCount()
    {
        return Object.keys(this.translationTable).length;
    }

    /**
     * @param {object} pTranslation - An object containing source:destination hash pairs to add to the translation table
     */
    addTranslation(pTranslation)
    {
        // This adds a translation in the form of:
        // { "SourceHash": "DestinationHash", "SecondSourceHash":"SecondDestinationHash" }
        if (typeof(pTranslation) != 'object')
        {
            this.logError(`Hash translation addTranslation expected a translation be type object but was passed in ${typeof(pTranslation)}`);
            return false;
        }

        let tmpTranslationSources = Object.keys(pTranslation)

        tmpTranslationSources.forEach(
            (pTranslationSource) =>
            {
                if (typeof(pTranslation[pTranslationSource]) != 'string')
                {
                    this.logError(`Hash translation addTranslation expected a translation destination hash for [${pTranslationSource}] to be a string but the referrant was a ${typeof(pTranslation[pTranslationSource])}`);
                }
                else
                {
                    this.translationTable[pTranslationSource] = pTranslation[pTranslationSource];
                }
            });
    }

    /**
     * @param {string} pTranslationHash - The source hash to remove from the translation table
     */
    removeTranslationHash(pTranslationHash)
    {
        delete this.translationTable[pTranslationHash];
    }

    /**
     * This removes translations.
     * If passed a string, just removes the single one.
     * If passed an object, it does all the source keys.
     *
     * @param {string|object} pTranslation - Either a source hash string to remove, or an object containing source:destination hash pairs to remove
     *
     * @return {boolean} True if the removal was successful, false otherwise
     */
    removeTranslation(pTranslation)
    {
        if (typeof(pTranslation) == 'string')
        {
            this.removeTranslationHash(pTranslation);
            return true;
        }
        else if (typeof(pTranslation) == 'object')
        {
            let tmpTranslationSources = Object.keys(pTranslation)

            tmpTranslationSources.forEach(
                (pTranslationSource) =>
                {
                    this.removeTranslation(pTranslationSource);
                });
            return true;
        }
        else
        {
            this.logError(`Hash translation removeTranslation expected either a string or an object but the passed-in translation was type ${typeof(pTranslation)}`);
            return false;
        }
    }

    clearTranslations()
    {
        this.translationTable = {};
    }

    /**
     * @param {string} pTranslation - The source hash to translate
     *
     * @return {string} The translated hash, or the original if no translation exists
     */
    translate(pTranslation)
    {
        if (pTranslation in this.translationTable)
        {
            return this.translationTable[pTranslation];
        }
        else
        {
            return pTranslation;
        }
    }
}

module.exports = ManyfestHashTranslation;

},{"./Manyfest-LogToConsole.js":123}],123:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/

/**
* Manyfest simple logging shim (for browser and dependency-free running)
*/

const logToConsole = (pLogLine, pLogObject) =>
{
    let tmpLogLine = (typeof(pLogLine) === 'string') ? pLogLine : '';

    console.log(`[Manyfest] ${tmpLogLine}`);

    if (pLogObject) console.log(JSON.stringify(pLogObject));
};

module.exports = logToConsole;
},{}],124:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
const libSimpleLog = require('./Manyfest-LogToConsole.js');
// This is for resolving functions mid-address
const libGetObjectValue = require('./Manyfest-ObjectAddress-GetValue.js');

const fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');

// TODO: Just until this is a fable service.
let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
*
* @class ManyfestObjectAddressResolverCheckAddressExists
*/
class ManyfestObjectAddressResolverCheckAddressExists
{
	/**
	 * @param {function} [pInfoLog] - (optional) Function to use for info logging
	 * @param {function} [pErrorLog] - (optional) Function to use for error logging
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.getObjectValueClass = new libGetObjectValue(this.logInfo, this.logError);
		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	/**
	 * Check if an address exists.
	 *
	 * This is necessary because the getValueAtAddress function is ambiguous on
	 * whether the element/property is actually there or not (it returns
	 * undefined whether the property exists or not).  This function checks for
	 * existance and returns true or false dependent.
	 *
	 * @param {object} pObject - The object to check within
	 * @param {string} pAddress - The address to check for
	 * @param {object} [pRootObject] - (optional) The root object for function resolution context
	 *
	 * @return {boolean} - True if the address exists, false if it does not
	 */
	checkAddressExists(pObject, pAddress, pRootObject)
	{
		// TODO: Should these throw an error?
		// Make sure pObject is an object
		if (typeof(pObject) != 'object') return false;
		// Make sure pAddress is a string
		if (typeof(pAddress) != 'string') return false;

		// Set the root object to the passed-in object if it isn't set yet.  This is expected to be the root object.
		// NOTE: This was added to support functions mid-stream
		let tmpRootObject = (typeof(pRootObject) == 'undefined') ? pObject : pRootObject;

		// DONE: Make this work for things like SomeRootObject.Metadata["Some.People.Use.Bad.Object.Property.Names"]
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		// This is the terminal address string (no more dots so the RECUSION ENDS IN HERE somehow)
		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// Check if the address refers to a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');

			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = pAddress.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(pAddress) > 0))
			{
				let tmpFunctionAddress = pAddress.substring(0, tmpFunctionStartIndex).trim();

				if (((tmpFunctionAddress in pObject)) && (typeof(pObject[tmpFunctionAddress]) == 'function'))
				{
					return true;
				}
				else
				{
					// The address suggests it is a function, but it is not.
					return false;
				}
			}
			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// The "Name" of the Object contained too the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return false;
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Check if the property exists.
					return (tmpBoxedPropertyReference in pObject[tmpBoxedPropertyName]);
				}
				else
				{
					// Use the new in operator to see if the element is in the array
					return (tmpBoxedPropertyNumber in pObject[tmpBoxedPropertyName]);
				}
			}
			else
			{
				// Check if the property exists
				return (pAddress in pObject);
			}
		}
		else
		{
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');

			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = tmpSubObjectName.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(tmpSubObjectName) > 0))
			{
				let tmpFunctionAddress = tmpSubObjectName.substring(0, tmpFunctionStartIndex).trim();
				//tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;

				if (typeof pObject[tmpFunctionAddress] !== 'function')
				{
					// The address suggests it is a function, but it is not.
					return false;
				}

				// Now see if the function has arguments.
				// Implementation notes: * ARGUMENTS MUST SHARE THE SAME ROOT OBJECT CONTEXT *
				let tmpFunctionArguments = _MockFable.DataFormat.stringGetSegments(_MockFable.DataFormat.stringGetEnclosureValueByIndex(tmpSubObjectName.substring(tmpFunctionAddress.length), 0), ',');
				if ((tmpFunctionArguments.length == 0) || (tmpFunctionArguments[0] == ''))
				{
					// No arguments... just call the function (bound to the scope of the object it is contained withing)
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.checkAddressExists(pObject[tmpFunctionAddress].apply(pObject), tmpNewAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							libSimpleLog(`Error calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						libSimpleLog(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
				else
				{
					let tmpArgumentValues = [];



					// Now get the value for each argument
					for (let i = 0; i < tmpFunctionArguments.length; i++)
					{
						// Resolve the values for each subsequent entry
						// NOTE: This is where the resolves get really tricky.  Recursion within recursion.  Programming gom jabbar, yo.
						tmpArgumentValues.push(this.getObjectValueClass.getValueAtAddress(tmpRootObject, tmpFunctionArguments[i]));
					}

					//return this.checkAddressExists(pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues), tmpNewAddress, tmpRootObject);
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.checkAddressExists(pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues), tmpNewAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							libSimpleLog(`Error calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						libSimpleLog(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
			}
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					// Because this is an impossible address, the property doesn't exist
					// TODO: Should we throw an error in this condition?
					return false;
				}

				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Recurse directly into the subobject
					return this.checkAddressExists(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, tmpRootObject);
				}
				else
				{
					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.checkAddressExists(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, tmpRootObject);
				}
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				return false;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				return this.checkAddressExists(pObject[tmpSubObjectName], tmpNewAddress, tmpRootObject);
			}
			else
			{
				// The sub-object doesn't exist, so the address doesn't exist
				return false;
			}
		}
	}
}

module.exports = ManyfestObjectAddressResolverCheckAddressExists;

},{"./Manyfest-CleanWrapCharacters.js":121,"./Manyfest-LogToConsole.js":123,"./Manyfest-ObjectAddress-GetValue.js":126,"./Manyfest-ObjectAddress-Parser.js":127}],125:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');
let fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');
let fParseConditionals = require(`../source/Manyfest-ParseConditionals.js`)

let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver - DeleteValue
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
* TODO: Once we validate this pattern is good to go, break these out into
*       three separate modules.
*
* @class ManyfestObjectAddressResolverDeleteValue
*/
class ManyfestObjectAddressResolverDeleteValue
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	// TODO: Dry me
	/**
	 * @param {string} pAddress - The address being evaluated
	 * @param {object} pRecord - The record being evaluated
	 *
	 * @return {boolean} True if the record passes the filters, false if it does not
	 */
	checkRecordFilters(pAddress, pRecord)
	{
		return fParseConditionals(this, pAddress, pRecord);
	}

	/**
	 * Delete the value of an element at an address
	 *
	 * @param {object} pObject - The object to delete the value from
	 * @param {string} pAddress - The address to delete the value at
	 * @param {string} [pParentAddress] - (optional) The parent address for recursion
	 *
	 * @return {boolean|object|undefined} - True if the value was deleted, false if it could not be deleted, undefined on error
	 */
	deleteValueAtAddress (pObject, pAddress, pParentAddress)
	{
		// Make sure pObject (the object we are meant to be recursing) is an object (which could be an array or object)
		if (typeof(pObject) != 'object') return undefined;
		// Make sure pAddress (the address we are resolving) is a string
		if (typeof(pAddress) != 'string') return undefined;
		// Stash the parent address for later resolution
		let tmpParentAddress = "";
		if (typeof(pParentAddress) == 'string')
		{
			tmpParentAddress = pParentAddress;
		}

		// Use enclosure-aware parser to find the first segment separator
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		// This is the terminal address string (no more dots so the RECUSION ENDS IN HERE somehow)
		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// Check if the address refers to a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');

			// Check for the Object Set Type marker.
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');

			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// The "Name" of the Object contained too the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return false;
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Return the value in the property
					delete pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference];
					return true;
				}
				else
				{
					delete pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber];
					return true;
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				let tmpInputArray = pObject[tmpBoxedPropertyName];
				// Count from the end to the beginning so splice doesn't %&%#$ up the array
				for (let i = tmpInputArray.length - 1; i >= 0; i--)
				{
					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpInputArray[i]);
					if (tmpKeepRecord)
					{
						// Delete elements end to beginning
						tmpInputArray.splice(i, 1);
					}
				}
				return true;
			}
			// The object has been flagged as an object set, so treat it as such
			else if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				delete pObject[tmpObjectPropertyName];
				return true;
			}
			else
			{
				// Now is the point in recursion to return the value in the address
				delete pObject[pAddress];
				return true;
			}
		}
		else
		{
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// BOXED ELEMENTS
			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}
				// Check if the boxed property is an object.
				if (typeof(pObject[tmpBoxedPropertyName]) != 'object')
				{
					return false;
				}
				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// Recurse directly into the subobject
					return this.deleteValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, tmpParentAddress);
				}
				else
				{
					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.deleteValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, tmpParentAddress);
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the array and grab the addresses from there.
				let tmpArrayProperty = pObject[tmpBoxedPropertyName];
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpBoxedPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpArrayProperty.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}[${i}]`;
					let tmpValue = this.deleteValueAtAddress(pObject[tmpBoxedPropertyName][i], tmpNewAddress, tmpPropertyParentAddress);

					tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
				}

				return tmpContainerObject;
			}

			// OBJECT SET
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');
			if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the Object and grab the addresses from there.
				let tmpObjectProperty = pObject[tmpObjectPropertyName];
				let tmpObjectPropertyKeys = Object.keys(tmpObjectProperty);
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpObjectPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpObjectPropertyKeys.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}.${tmpObjectPropertyKeys[i]}`;
					let tmpValue = this.deleteValueAtAddress(pObject[tmpObjectPropertyName][tmpObjectPropertyKeys[i]], tmpNewAddress, tmpPropertyParentAddress);

					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpValue);
					if (tmpKeepRecord)
					{
						tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
					}
				}

				return tmpContainerObject;
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				return undefined;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				return this.deleteValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress);
			}
			else
			{
				// Create a subobject and then pass that
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				pObject[tmpSubObjectName] = {};
				return this.deleteValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress);
			}
		}
	}
};

module.exports = ManyfestObjectAddressResolverDeleteValue;

},{"../source/Manyfest-ParseConditionals.js":130,"./Manyfest-CleanWrapCharacters.js":121,"./Manyfest-LogToConsole.js":123,"./Manyfest-ObjectAddress-Parser.js":127}],126:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');
let fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');
let fParseConditionals = require(`../source/Manyfest-ParseConditionals.js`);

let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver - GetValue
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
* TODO: Once we validate this pattern is good to go, break these out into
*       three separate modules.
*
* @class ManyfestObjectAddressResolverGetValue
*/
class ManyfestObjectAddressResolverGetValue
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	/**
	 * @param {string} pAddress - The address of the record to check
	 * @param {object} pRecord - The record to check against the filters
	 *
	 * @return {boolean} - True if the record passes the filters, false otherwise
	 */
	checkRecordFilters(pAddress, pRecord)
	{
		return fParseConditionals(this, pAddress, pRecord);
	}

	/**
	 * Get the value of an element at an address
	 *
	 * @param {object} pObject - The object to resolve the address against
	 * @param {string} pAddress - The address to resolve
	 * @param {string} [pParentAddress] - (optional) The parent address for back-navigation
	 * @param {object} [pRootObject] - (optional) The root object for function argument resolution
	 *
	 * @return {any} The value at the address, or undefined if not found
	 */
	getValueAtAddress (pObject, pAddress, pParentAddress, pRootObject)
	{
		// Make sure pObject (the object we are meant to be recursing) is an object (which could be an array or object)
		if (typeof(pObject) != 'object')
		{
			return undefined;
		}
		if (pObject === null)
		{
			return undefined;
		}
		// Make sure pAddress (the address we are resolving) is a string
		if (typeof(pAddress) != 'string')
		{
			return undefined;
		}
		// Stash the parent address for later resolution
		let tmpParentAddress = "";
		if (typeof(pParentAddress) == 'string')
		{
			tmpParentAddress = pParentAddress;
		}

		// Set the root object to the passed-in object if it isn't set yet.  This is expected to be the root object.
		let tmpRootObject = (typeof(pRootObject) == 'undefined') ? pObject : pRootObject;

		// DONE: Make this work for things like SomeRootObject.Metadata["Some.People.Use.Bad.Object.Property.Names"]
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		// Adding simple back-navigation in objects
		if (tmpAddressPartBeginning == '')
		{
			// Given an address of "Bundle.Contract.IDContract...Project.IDProject" the ... would be interpreted as two back-navigations from IDContract.
			// When the address is passed in, though, the first . is already eliminated.  So we can count the dots.
			let tmpParentAddressParts = _MockFable.DataFormat.stringGetSegments(tmpParentAddress);

			let tmpBackNavigationCount = 0;

			// Count the number of dots
			for (let i = 0; i < pAddress.length; i++)
			{
				if (pAddress.charAt(i) != '.')
				{
					break;
				}
				tmpBackNavigationCount++;
			}

			let tmpParentAddressLength = tmpParentAddressParts.length - tmpBackNavigationCount;

			if (tmpParentAddressLength < 0)
			{
				// We are trying to back navigate more than we can.
				// TODO: Should this be undefined or should we bank out at the bottom and try to go forward?
				// This seems safest for now.
				return undefined;
			}
			else
			{
				// We are trying to back navigate to a parent object.
				// Recurse with the back-propagated parent address, and, the new address without the back-navigation dots.
				let tmpRecurseAddress = pAddress.slice(tmpBackNavigationCount);
				if (tmpParentAddressLength > 0)
				{
					tmpRecurseAddress = `${tmpParentAddressParts.slice(0, tmpParentAddressLength).join('.')}.${tmpRecurseAddress}`;
				}
				this.logInfo(`Back-navigation detected.  Recursing back to address [${tmpRecurseAddress}]`);
				return this.getValueAtAddress(tmpRootObject, tmpRecurseAddress);
			}
		}

		// This is the terminal address string (no more dots so the RECUSION ENDS IN HERE somehow)
		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// TODO: Optimize this by having these calls only happen when the previous fails.
			// TODO: Alternatively look for all markers in one pass?
			// Check if the address refers to a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');

			// Check for the Object Set Type marker.
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');


			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = pAddress.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(pAddress) > 0))
			{
				let tmpFunctionAddress = pAddress.substring(0, tmpFunctionStartIndex).trim();

				if (typeof pObject[tmpFunctionAddress] !== 'function')
				{
					// The address suggests it is a function, but it is not.
					return false;
				}

				// Now see if the function has arguments.
				// Implementation notes: * ARGUMENTS MUST SHARE THE SAME ROOT OBJECT CONTEXT *
				let tmpFunctionArguments = _MockFable.DataFormat.stringGetSegments(_MockFable.DataFormat.stringGetEnclosureValueByIndex(pAddress.substring(tmpFunctionAddress.length), 0), ',');
				if ((tmpFunctionArguments.length == 0) || (tmpFunctionArguments[0] == ''))
				{
					// No arguments... just call the function (bound to the scope of the object it is contained withing)
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return pObject[tmpFunctionAddress].apply(pObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
				else
				{
					let tmpArgumentValues = [];

					// Now get the value for each argument
					for (let i = 0; i < tmpFunctionArguments.length; i++)
					{
						// Trim whitespace from the argument (e.g. after comma separation: `Book`, `List` --> ` `List``)
						let tmpArgument = tmpFunctionArguments[i].trim();
						// Resolve the values for each subsequent entry
						// Check if the argument value is a string literal or a reference to an address
						if ((tmpArgument.length >= 2)
							&&
							((tmpArgument.charAt(0) == '"')
							|| (tmpArgument.charAt(0) == "'")
							|| (tmpArgument.charAt(0) == "`"))
							&&
							((tmpArgument.charAt(tmpArgument.length-1) == '"')
							|| (tmpArgument.charAt(tmpArgument.length-1) == "'")
							|| (tmpArgument.charAt(tmpArgument.length-1) == "`")))
						{
							// This is a string literal
							tmpArgumentValues.push(tmpArgument.substring(1, tmpArgument.length-1));
						}
						else
						{
							// This is a hash address
							tmpArgumentValues.push(this.getValueAtAddress(tmpRootObject, tmpArgument));
						}
					}

					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
			}
			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// The "Name" of the Object contained too the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return undefined;
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return undefined;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Return the value in the property
					return pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference];
				}
				else
				{
					return pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber];
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				let tmpInputArray = pObject[tmpBoxedPropertyName];
				let tmpOutputArray = [];
				for (let i = 0; i < tmpInputArray.length; i++)
				{
					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpInputArray[i]);
					if (tmpKeepRecord)
					{
						tmpOutputArray.push(tmpInputArray[i]);

					}
				}

				return tmpOutputArray;
			}
			// The object has been flagged as an object set, so treat it as such
			else if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				return pObject[tmpObjectPropertyName];
			}
			else
			{
				// Now is the point in recursion to return the value in the address
				if (typeof(pObject[pAddress]) != 'undefined')
				{
					return pObject[pAddress];
				}
				else
				{
					return undefined;
				}
			}
		}
		else
		{
			//let tmpSubObjectName = pAddress.substring(0, tmpSeparatorIndex);
			//let tmpNewAddress = pAddress.substring(tmpSeparatorIndex+1);
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// BOXED ELEMENTS
			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');

			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = tmpSubObjectName.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(tmpSubObjectName) > 0))
			{
				let tmpFunctionAddress = tmpSubObjectName.substring(0, tmpFunctionStartIndex).trim();
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;

				if (typeof pObject[tmpFunctionAddress] !== 'function')
				{
					// The address suggests it is a function, but it is not.
					return false;
				}

				// Now see if the function has arguments.
				// Implementation notes: * ARGUMENTS MUST SHARE THE SAME ROOT OBJECT CONTEXT *
				let tmpFunctionArguments = _MockFable.DataFormat.stringGetSegments(_MockFable.DataFormat.stringGetEnclosureValueByIndex(tmpSubObjectName.substring(tmpFunctionAddress.length), 0), ',');
				if ((tmpFunctionArguments.length == 0) || (tmpFunctionArguments[0] == ''))
				{
					// No arguments... just call the function (bound to the scope of the object it is contained withing)
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.getValueAtAddress(pObject[tmpFunctionAddress].apply(pObject), tmpNewAddress, tmpParentAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
				else
				{
					let tmpArgumentValues = [];

					// Now get the value for each argument
					for (let i = 0; i < tmpFunctionArguments.length; i++)
					{
						// Trim whitespace from the argument (e.g. after comma separation: `Book`, `List` --> ` `List``)
						let tmpArgument = tmpFunctionArguments[i].trim();
						// Resolve the values for each subsequent entry
						// Check if the argument value is a string literal or a reference to an address
						if ((tmpArgument.length >= 2)
							&&
							((tmpArgument.charAt(0) == '"')
							|| (tmpArgument.charAt(0) == "'")
							|| (tmpArgument.charAt(0) == "`"))
							&&
							((tmpArgument.charAt(tmpArgument.length-1) == '"')
							|| (tmpArgument.charAt(tmpArgument.length-1) == "'")
							|| (tmpArgument.charAt(tmpArgument.length-1) == "`")))
						{
							// This is a string literal
							tmpArgumentValues.push(tmpArgument.substring(1, tmpArgument.length-1));
						}
						else
						{
							// This is a hash address
							tmpArgumentValues.push(this.getValueAtAddress(tmpRootObject, tmpArgument));
						}
					}

					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.getValueAtAddress(pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues), tmpNewAddress, tmpParentAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
			}
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return undefined;
				}
				// Check if the boxed property is an object.
				if (typeof(pObject[tmpBoxedPropertyName]) != 'object')
				{
					return undefined;
				}


				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// Recurse directly into the subobject
					return this.getValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, tmpParentAddress, tmpRootObject);
				}
				else
				{
					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.getValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, tmpParentAddress, tmpRootObject);
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the array and grab the addresses from there.
				let tmpArrayProperty = pObject[tmpBoxedPropertyName];
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpBoxedPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpArrayProperty.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}[${i}]`;
					let tmpValue = this.getValueAtAddress(pObject[tmpBoxedPropertyName][i], tmpNewAddress, tmpPropertyParentAddress, tmpRootObject);

					tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
				}

				return tmpContainerObject;
			}

			// OBJECT SET
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');
			if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the Object and grab the addresses from there.
				let tmpObjectProperty = pObject[tmpObjectPropertyName];
				let tmpObjectPropertyKeys = Object.keys(tmpObjectProperty);
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpObjectPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpObjectPropertyKeys.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}.${tmpObjectPropertyKeys[i]}`;
					let tmpValue = this.getValueAtAddress(pObject[tmpObjectPropertyName][tmpObjectPropertyKeys[i]], tmpNewAddress, tmpPropertyParentAddress, tmpRootObject);

					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpValue);
					if (tmpKeepRecord)
					{
						tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
					}
				}

				return tmpContainerObject;
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				return undefined;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				return this.getValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress, tmpRootObject);
			}
			else
			{
				// Create a subobject and then pass that
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				pObject[tmpSubObjectName] = {};
				return this.getValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress, tmpRootObject);
			}
		}
	}
};

module.exports = ManyfestObjectAddressResolverGetValue;

},{"../source/Manyfest-ParseConditionals.js":130,"./Manyfest-CleanWrapCharacters.js":121,"./Manyfest-LogToConsole.js":123,"./Manyfest-ObjectAddress-Parser.js":127}],127:[function(require,module,exports){
// TODO: This is an inelegant solution to delay the rewrite of Manyfest.

// Fable 3.0 has a service for data formatting that deals well with nested enclosures.

// The Manyfest library predates fable 3.0 and the services structure of it, so the functions
// are more or less pure javascript and as functional as they can be made to be.

// Until we shift Manyfest to be a fable service, these three functions were pulled out of
// fable to aid in parsing functions with nested enclosures.

const DEFAULT_START_SYMBOL_MAP = { '{': 0, '[': 1, '(': 2 };
const DEFAULT_END_SYMBOL_MAP = { '}': 0, ']': 1, ')': 2 };

module.exports = {
	/**
	 * Count the number of segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} [pSeparator]
	 * @param {Record<string, number>} [pEnclosureStartSymbolMap]
	 * @param {Record<string, number>} [pEnclosureEndSymbolMap]
	 *
	 * @return {number} - The number of segments in the string
	 */
	stringCountSegments: (pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : DEFAULT_START_SYMBOL_MAP;
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : DEFAULT_END_SYMBOL_MAP;

		if (tmpString.length < 1)
		{
			return 0;
		}

		let tmpSegmentCount = 1;
		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Increment the segment count
				tmpSegmentCount++;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpSegmentCount;
	},

	/**
	 * Get the first segment in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} [pSeparator]
	 * @param {Record<string, number>} [pEnclosureStartSymbolMap]
	 * @param {Record<string, number>} [pEnclosureEndSymbolMap]
	 *
	 * @return {string} - the first segment in the string as a string
	 */
	stringGetFirstSegment: (pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : DEFAULT_START_SYMBOL_MAP;
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : DEFAULT_END_SYMBOL_MAP;

		if (tmpString.length < 1)
		{
			return '';
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				return tmpString.substring(0, i);
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpString;
	},

	/**
	 * Get all segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} [pSeparator]
	 * @param {Record<string, number>} [pEnclosureStartSymbolMap]
	 * @param {Record<string, number>} [pEnclosureEndSymbolMap]
	 *
	 * @return {Array<string>} - the segments in the string as an array of strings
	 */
	stringGetSegments: (pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : DEFAULT_START_SYMBOL_MAP;
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : DEFAULT_END_SYMBOL_MAP;

		let tmpCurrentSegmentStart = 0;
		let tmpSegmentList = [];

		if (tmpString.length < 1)
		{
			return tmpSegmentList;
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart, i));
				tmpCurrentSegmentStart = i+1;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		if (tmpCurrentSegmentStart < tmpString.length)
		{
			tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart));
		}

		return tmpSegmentList;
	},

	/**
	 * Count the number of enclosures in a string based on the start and end characters.
	 *
	 * If no start or end characters are specified, it will default to parentheses.  If the string is not a string, it will return 0.
	 *
	 * @param {string} pString
	 * @param {string} [pEnclosureStart]
	 * @param {string} [pEnclosureEnd]
	 * @returns the count of full in the string
	 */
	stringCountEnclosures: (pString, pEnclosureStart, pEnclosureEnd) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;
		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				if (tmpEnclosureDepth == 0)
				{
					tmpEnclosureCount++;
				}
				tmpEnclosureDepth++;
			}
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;
			}
		}

		return tmpEnclosureCount;
	},


	/**
	 * Get the value of the enclosure at the specified index.
	 *
	 * If the index is not a number, it will default to 0.  If the string is not a string, it will return an empty string.  If the enclosure is not found, it will return an empty string.  If the enclosure
	 *
	 * @param {string} pString
	 * @param {number} pEnclosureIndexToGet
	 * @param {string} [pEnclosureStart]
	 * @param {string} [pEnclosureEnd]
	 *
	 * @return {string} - The value of the enclosure at the specified index
	 */
	stringGetEnclosureValueByIndex: (pString, pEnclosureIndexToGet, pEnclosureStart, pEnclosureEnd) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureIndexToGet = (typeof(pEnclosureIndexToGet) == 'number') ? pEnclosureIndexToGet : 0;
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;

		let tmpMatchedEnclosureIndex = false;
		let tmpEnclosedValueStartIndex = 0;
		let tmpEnclosedValueEndIndex = 0;

		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				tmpEnclosureDepth++;

				// Only count enclosures at depth 1, but still this parses both pairs of all of them.
				if (tmpEnclosureDepth == 1)
				{
					tmpEnclosureCount++;
					if (tmpEnclosureIndexToGet == (tmpEnclosureCount - 1))
					{
						// This is the start of *the* enclosure
						tmpMatchedEnclosureIndex = true;
						tmpEnclosedValueStartIndex = i;
					}
				}
			}
			// This is the end of an enclosure
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;

				// Again, only count enclosures at depth 1, but still this parses both pairs of all of them.
				if ((tmpEnclosureDepth == 0) &&
					tmpMatchedEnclosureIndex &&
					(tmpEnclosedValueEndIndex <= tmpEnclosedValueStartIndex))
				{
					tmpEnclosedValueEndIndex = i;
					tmpMatchedEnclosureIndex = false;
				}
			}
		}

		if (tmpEnclosureCount <= tmpEnclosureIndexToGet)
		{
			// Return an empty string if the enclosure is not found
			return '';
		}

		if ((tmpEnclosedValueEndIndex > 0) && (tmpEnclosedValueEndIndex > tmpEnclosedValueStartIndex))
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1, tmpEnclosedValueEndIndex);
		}
		else
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1);
		}
	}
}

},{}],128:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');
let fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');

let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver - SetValue
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
*
* @class ManyfestObjectAddressSetValue
*/
class ManyfestObjectAddressSetValue
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	/**
	 * Set the value of an element at an address
	 *
	 * @param {object} pObject - The object to set the value in
	 * @param {string} pAddress - The address to set the value at
	 * @param {any} pValue - The value to set at the address
	 *
	 * @return {boolean} True if the value was set, false otherwise
	 */
	setValueAtAddress (pObject, pAddress, pValue)
	{
		// Make sure pObject is an object
		if (typeof(pObject) != 'object') return false;
		// Make sure pAddress is a string
		if (typeof(pAddress) != 'string') return false;

		// Use enclosure-aware parser to find the first segment separator
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// Check if it's a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');
			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			//
			// Chained bracket elements look like this:
			// 		MyValues[SubObject]['Property']
			// 		MyValues[0]['Name']
			//
			// When we encounter chained brackets, resolve the first bracket pair and recurse with the remainder.
			//
			// Bracket-at-zero elements look like this (from chained bracket recursion):
			// 		['Property']
			// 		[0]
			//
			// The requirements to detect a boxed element are:
			//    1) The start bracket exists
			if ((tmpBracketStartIndex >= 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// Check for any remaining address after the closing bracket (chained brackets or dot paths)
				let tmpRemainingAddress = pAddress.substring(tmpBracketStopIndex + 1);
				if (tmpRemainingAddress.length > 0 && tmpRemainingAddress.charAt(0) === '.')
				{
					// Strip leading dot separator (e.g. [SubObject].Property --> Property)
					tmpRemainingAddress = tmpRemainingAddress.substring(1);
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);
				let tmpIndexIsNumeric = !isNaN(tmpBoxedPropertyNumber);

				// When the bracket is at position 0, there is no property name prefix -- we are
				// accessing a property or index directly on the current object.  This happens when
				// chained bracket resolution recurses with a remainder like ['Property'].
				if (tmpBracketStartIndex === 0)
				{
					if (tmpIndexIsNumeric)
					{
						// Array access at position 0: [0], [1], etc.
						if (!Array.isArray(pObject))
						{
							return false;
						}
						while (pObject.length < (tmpBoxedPropertyNumber + 1))
						{
							pObject.push({});
						}
						if (tmpRemainingAddress.length > 0)
						{
							return this.setValueAtAddress(pObject[tmpBoxedPropertyNumber], tmpRemainingAddress, pValue);
						}
						pObject[tmpBoxedPropertyNumber] = pValue;
						return true;
					}
					else
					{
						// Named property access at position 0: ['Property'], ["Name"], etc.
						tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

						if (tmpRemainingAddress.length > 0)
						{
							if (!(tmpBoxedPropertyReference in pObject) || typeof(pObject[tmpBoxedPropertyReference]) !== 'object')
							{
								pObject[tmpBoxedPropertyReference] = {};
							}
							return this.setValueAtAddress(pObject[tmpBoxedPropertyReference], tmpRemainingAddress, pValue);
						}
						pObject[tmpBoxedPropertyReference] = pValue;
						return true;
					}
				}

				// The "Name" of the Object contained to the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (pObject[tmpBoxedPropertyName] == null)
				{
					if (tmpIndexIsNumeric)
					{
						pObject[tmpBoxedPropertyName] = [];
					}
					else
					{
						pObject[tmpBoxedPropertyName] = {};
					}
				}

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return false;
				}

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					if (!(tmpBoxedPropertyReference in pObject[tmpBoxedPropertyName]))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference] = {};
					}

					// If there is remaining address after this bracket pair, recurse into the resolved subobject
					if (tmpRemainingAddress.length > 0)
					{
						return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpRemainingAddress, pValue);
					}

					// No remaining address -- set the value directly
					pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference] = pValue;
					return true;
				}
				else
				{
					while(pObject[tmpBoxedPropertyName].length < (tmpBoxedPropertyNumber + 1))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName].push({});
					}

					// If there is remaining address after this bracket pair, recurse into the resolved element
					if (tmpRemainingAddress.length > 0)
					{
						return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpRemainingAddress, pValue);
					}

					pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber] = pValue;
					return true;
				}
			}
			else
			{
				// Now is the time in recursion to set the value in the object
				pObject[pAddress] = pValue;
				return true;
			}
		}
		else
		{
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket exists
			if ((tmpBracketStartIndex >= 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// When the bracket is at position 0, there is no property name prefix -- we are
				// accessing a property or index directly on the current object.  This happens when
				// chained bracket resolution recurses with a segment like ['Nested'].
				if (tmpBracketStartIndex === 0)
				{
					let tmpBoxedPropertyReference = tmpSubObjectName.substring(1, tmpBracketStopIndex).trim();
					let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

					if (!isNaN(tmpBoxedPropertyNumber))
					{
						// Array access: [0], [1], etc.
						if (!Array.isArray(pObject))
						{
							return false;
						}
						while (pObject.length < (tmpBoxedPropertyNumber + 1))
						{
							pObject.push({});
						}
						return this.setValueAtAddress(pObject[tmpBoxedPropertyNumber], tmpNewAddress, pValue);
					}
					else
					{
						// Named property access: ['Nested'], ["Name"], etc.
						tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

						if (!(tmpBoxedPropertyReference in pObject) || typeof(pObject[tmpBoxedPropertyReference]) !== 'object')
						{
							pObject[tmpBoxedPropertyReference] = {};
						}
						return this.setValueAtAddress(pObject[tmpBoxedPropertyReference], tmpNewAddress, pValue);
					}
				}

				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);
				let tmpIndexIsNumeric = !isNaN(tmpBoxedPropertyNumber);

				// Check for chained brackets within this segment (e.g. _Object[SubObject]['Nested'])
				// Any remaining address after the first ] within the segment name needs to be
				// prepended to tmpNewAddress so it is not lost during recursion.
				let tmpSegmentRemainder = tmpSubObjectName.substring(tmpBracketStopIndex + 1);
				if (tmpSegmentRemainder.length > 0)
				{
					// Prepend the remainder to the new address
					// e.g. if segment was _Object[SubObject]['Nested'] and newAddress was Deep,
					//      then combined address becomes ['Nested'].Deep
					if (tmpNewAddress.length > 0)
					{
						tmpNewAddress = tmpSegmentRemainder + '.' + tmpNewAddress;
					}
					else
					{
						tmpNewAddress = tmpSegmentRemainder;
					}
					// Strip leading dot if present
					if (tmpNewAddress.charAt(0) === '.')
					{
						tmpNewAddress = tmpNewAddress.substring(1);
					}
				}

				//if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				if (pObject[tmpBoxedPropertyName] == null)
				{
					if (tmpIndexIsNumeric)
					{
						pObject[tmpBoxedPropertyName] = [];
					}
					else
					{
						pObject[tmpBoxedPropertyName] = {};
					}
				}

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) != tmpIndexIsNumeric)
				{
					return false;
				}

				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					if (!(tmpBoxedPropertyReference in pObject[tmpBoxedPropertyName]))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference] = {};
					}

					// Recurse directly into the subobject
					return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, pValue);
				}
				else
				{
					while(pObject[tmpBoxedPropertyName].length < (tmpBoxedPropertyNumber + 1))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName].push({});
					}

					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, pValue);
				}
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				if (!('__ERROR' in pObject))
					pObject['__ERROR'] = {};
				// Put it in an error object so data isn't lost
				pObject['__ERROR'][pAddress] = pValue;
				return false;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				return this.setValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, pValue);
			}
			else
			{
				// Create a subobject and then pass that
				pObject[tmpSubObjectName] = {};
				return this.setValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, pValue);
			}
		}
	}
};

module.exports = ManyfestObjectAddressSetValue;

},{"./Manyfest-CleanWrapCharacters.js":121,"./Manyfest-LogToConsole.js":123,"./Manyfest-ObjectAddress-Parser.js":127}],129:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');

/**
* Object Address Generation
*
* Automagically generate addresses and properties based on a passed-in object,
* to be used for easy creation of schemas.  Meant to simplify the lives of
* developers wanting to create schemas without typing a bunch of stuff.
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
*
* @class ManyfestObjectAddressGeneration
*/
class ManyfestObjectAddressGeneration
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;
	}

	/**
	 * generateAddressses
	 *
	 * This flattens an object into a set of key:value pairs for *EVERY SINGLE
	 * POSSIBLE ADDRESS* in the object.  It can get ... really insane really
	 * quickly.  This is not meant to be used directly to generate schemas, but
	 * instead as a starting point for scripts or UIs.
	 *
	 * This will return a mega set of key:value pairs with all possible schema
	 * permutations and default values (when not an object) and everything else.
	 *
	 * @param {any} pObject - The object to generate addresses for
	 * @param {string} [pBaseAddress] - (optional) The base address to start from
	 * @param {object} [pSchema] - (optional) The schema object to append to
	 *
	 * @return {object} The generated schema object
	 */
	generateAddressses (pObject, pBaseAddress, pSchema)
	{
		let tmpBaseAddress = (typeof(pBaseAddress) == 'string') ? pBaseAddress : '';
		let tmpSchema = (typeof(pSchema) == 'object') ? pSchema : {};

		let tmpObjectType = typeof(pObject);

		let tmpSchemaObjectEntry = (
			{
				Address: tmpBaseAddress,
				Hash: tmpBaseAddress,
				Name: tmpBaseAddress,
				// This is so scripts and UI controls can force a developer to opt-in.
				InSchema: false
			}
		)

		if ((tmpObjectType == 'object') && (pObject == null))
		{
			tmpObjectType = 'undefined';
		}

		switch(tmpObjectType)
		{
			case 'string':
				tmpSchemaObjectEntry.DataType = 'String';
				tmpSchemaObjectEntry.Default = pObject;
				tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
				break;
			case 'number':
			case 'bigint':
				tmpSchemaObjectEntry.DataType = 'Number';
				tmpSchemaObjectEntry.Default = pObject;
				tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
				break;
			case 'undefined':
				tmpSchemaObjectEntry.DataType = 'Any';
				tmpSchemaObjectEntry.Default = pObject;
				tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
				break;
			case 'object':
				if (Array.isArray(pObject))
				{
					tmpSchemaObjectEntry.DataType = 'Array';
					if (tmpBaseAddress != '')
					{
						tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
					}

					for (let i = 0; i < pObject.length; i++)
					{
						this.generateAddressses(pObject[i], `${tmpBaseAddress}[${i}]`, tmpSchema);
					}
				}
				else
				{
					tmpSchemaObjectEntry.DataType = 'Object';
					if (tmpBaseAddress != '')
					{
						tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
						tmpBaseAddress += '.';
					}

					let tmpObjectProperties = Object.keys(pObject);

					for (let i = 0; i < tmpObjectProperties.length; i++)
					{
						this.generateAddressses(pObject[tmpObjectProperties[i]], `${tmpBaseAddress}${tmpObjectProperties[i]}`, tmpSchema);
					}
				}
				break;
			case 'symbol':
			case 'function':
				// Symbols and functions neither recurse nor get added to the schema
				break;
		}

		return tmpSchema;
	}
};

module.exports = ManyfestObjectAddressGeneration;

},{"./Manyfest-LogToConsole.js":123}],130:[function(require,module,exports){
// Given a string, parse out any conditional expressions and set whether or not to keep the record.
//
// For instance:
// 		'files[]<<~?format,==,Thumbnail?~>>'
//      'files[]<<~?format,==,Metadata?~>>'
//      'files[]<<~?size,>,4000?~>>'
//
// The wrapping parts are the <<~? and ?~>> megabrackets.
//
// The function does not need to alter the string -- just check the conditionals within.

// TODO: Consider making this an es6 class

// Let's use indexOf since it is apparently the fastest.
const _ConditionalStanzaStart = '<<~?';
const _ConditionalStanzaStartLength = _ConditionalStanzaStart.length;
const _ConditionalStanzaEnd = '?~>>';
const _ConditionalStanzaEndLength = _ConditionalStanzaEnd.length;

// Ugh dependency injection.  Can't wait to make these all fable services.
//let libObjectAddressCheckAddressExists = new (require('./Manyfest-ObjectAddress-CheckAddressExists.js'))();

// Test the condition of a value in a record
const testCondition = (pManyfest, pRecord, pSearchAddress, pSearchComparator, pValue) =>
{
	switch(pSearchComparator)
	{
		case 'TRUE':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) === true);
		case 'FALSE':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) === false);
		case 'LNGT':
		case 'LENGTH_GREATER_THAN':
			switch(typeof(pManyfest.getValueAtAddress(pRecord, pSearchAddress)))
			{
				case 'string':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length > pValue);
				case 'object':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length > pValue);
				default:
					return false;
					break;
			}
			break;
		case 'LNLT':
		case 'LENGTH_LESS_THAN':
			switch(typeof(pManyfest.getValueAtAddress(pRecord, pSearchAddress)))
			{
				case 'string':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length < pValue);
				case 'object':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length < pValue);
				default:
					return false;
					break;
			}
			break;
		// TODO: Welcome to dependency hell.  This fixes itself when we move to fable services.
		// case 'EX':
		// case 'EXISTS':
		// 	return libObjectAddressCheckAddressExists.checkAddressExists(pRecord, pSearchAddress);
		// 	break;
		// case 'DNEX':
		// case 'DOES_NOT_EXIST':
		// 	return !libObjectAddressCheckAddressExists.checkAddressExists(pRecord, pSearchAddress);
		// 	break;
		case '!=':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) != pValue);
		case '<':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) < pValue);
		case '>':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) > pValue);
		case '<=':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) <= pValue);
		case '>=':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) >= pValue);
		case '===':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) === pValue);
		case '==':
		default:
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) == pValue);
	}
};

const parseConditionals = (pManyfest, pAddress, pRecord) =>
{
	let tmpKeepRecord = true;

	/*
		Algorithm is simple:

		1.  Enuerate start points
		2.  Find stop points within each start point
		3. Check the conditional
	*/
	let tmpStartIndex = pAddress.indexOf(_ConditionalStanzaStart);

	while (tmpStartIndex != -1)
	{
		let tmpStopIndex = pAddress.indexOf(_ConditionalStanzaEnd, tmpStartIndex+_ConditionalStanzaStartLength);

		if (tmpStopIndex != -1)
		{
			let tmpMagicComparisonPatternSet = pAddress.substring(tmpStartIndex+_ConditionalStanzaStartLength, tmpStopIndex).split(',');

			// The address to search for
			let tmpSearchAddress = tmpMagicComparisonPatternSet[0];

			// The copmparison expression (EXISTS as default)
			let tmpSearchComparator = 'EXISTS';
			if (tmpMagicComparisonPatternSet.length > 1)
			{
				tmpSearchComparator = tmpMagicComparisonPatternSet[1];
			}

			// The value to search for
			let tmpSearchValue = false;
			if (tmpMagicComparisonPatternSet.length > 2)
			{
				tmpSearchValue = tmpMagicComparisonPatternSet[2];
			}

			// Process the piece
			tmpKeepRecord = tmpKeepRecord && testCondition(pManyfest, pRecord, tmpSearchAddress, tmpSearchComparator, tmpSearchValue);
			tmpStartIndex = pAddress.indexOf(_ConditionalStanzaStart, tmpStopIndex+_ConditionalStanzaEndLength);
		}
		else
		{
			tmpStartIndex = -1;
		}

	}

	return tmpKeepRecord;
}

module.exports = parseConditionals;

},{}],131:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');

/**
* Schema Manipulation Functions
*
* @class ManyfestSchemaManipulation
*/
class ManyfestSchemaManipulation
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) === 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) === 'function') ? pErrorLog : libSimpleLog;
	}

	/**
     * This translates the default address mappings to something different.
     *
     * For instance you can pass in manyfest schema descriptor object:
     * 	{
	 *	  "Address.Of.a": { "Hash": "a", "Type": "Number" },
	 *	  "Address.Of.b": { "Hash": "b", "Type": "Number" }
	 *  }
     *
     *
     * And then an address mapping (basically a Hash->Address map)
     *  {
     *    "a": "New.Address.Of.a",
     *    "b": "New.Address.Of.b"
     *  }
     *
     * NOTE: This mutates the schema object permanently, altering the base hash.
     *       If there is a collision with an existing address, it can lead to overwrites.
     * TODO: Discuss what should happen on collisions.
	 *
	 * @param {object} pManyfestSchemaDescriptors - The manyfest schema descriptors to resolve address mappings for
	 * @param {object} pAddressMapping - The address mapping object to use for remapping
	 *
	 * @return {boolean} True if successful, false if there was an error
	 */
	resolveAddressMappings(pManyfestSchemaDescriptors, pAddressMapping)
	{
		if (typeof(pManyfestSchemaDescriptors) != 'object')
		{
			this.logError(`Attempted to resolve address mapping but the descriptor was not an object.`);
			return false;
		}

		if (typeof(pAddressMapping) != 'object')
		{
			// No mappings were passed in
			return true;
		}

		// Get the arrays of both the schema definition and the hash mapping
		let tmpManyfestAddresses = Object.keys(pManyfestSchemaDescriptors);
		let tmpHashMapping = {};
		tmpManyfestAddresses.forEach(
			(pAddress) =>
			{
				if ('Hash' in pManyfestSchemaDescriptors[pAddress])
				{
					tmpHashMapping[pManyfestSchemaDescriptors[pAddress].Hash] = pAddress;
				}
			});

		let tmpAddressMappingSet = Object.keys(pAddressMapping);

		tmpAddressMappingSet.forEach(
			(pInputAddress) =>
			{
				let tmpNewDescriptorAddress = pAddressMapping[pInputAddress];
				let tmpOldDescriptorAddress = null;
				let tmpDescriptor;

				// See if there is a matching descriptor either by Address directly or Hash
				if (pInputAddress in pManyfestSchemaDescriptors)
				{
					tmpOldDescriptorAddress = pInputAddress;
				}
				else if (pInputAddress in tmpHashMapping)
				{
					tmpOldDescriptorAddress = tmpHashMapping[pInputAddress];
				}

				// If there was a matching descriptor in the manifest, store it in the temporary descriptor
				if (tmpOldDescriptorAddress)
				{
					tmpDescriptor = pManyfestSchemaDescriptors[tmpOldDescriptorAddress];
					delete pManyfestSchemaDescriptors[tmpOldDescriptorAddress];
				}
				else
				{
					// Create a new descriptor!  Map it to the input address.
					tmpDescriptor = { Hash:pInputAddress };
				}

				// Now re-add the descriptor to the manyfest schema
				pManyfestSchemaDescriptors[tmpNewDescriptorAddress] = tmpDescriptor;
			});

		return true;
	}

	/**
	 * @param {object} pManyfestSchemaDescriptors - The manyfest schema descriptors to resolve address mappings for
	 * @param {object} pAddressMapping - The address mapping object to use for remapping
	 *
	 * @return {object} A new object containing the remapped schema descriptors
	 */
	safeResolveAddressMappings(pManyfestSchemaDescriptors, pAddressMapping)
	{
		// This returns the descriptors as a new object, safely remapping without mutating the original schema Descriptors
		let tmpManyfestSchemaDescriptors = JSON.parse(JSON.stringify(pManyfestSchemaDescriptors));
		this.resolveAddressMappings(tmpManyfestSchemaDescriptors, pAddressMapping);
		return tmpManyfestSchemaDescriptors;
	}

	/**
	 * @param {object} pManyfestSchemaDescriptorsDestination - The destination manyfest schema descriptors
	 * @param {object} pManyfestSchemaDescriptorsSource - The source manyfest schema descriptors
	 *
	 * @return {object} A new object containing the merged schema descriptors
	 */
	mergeAddressMappings(pManyfestSchemaDescriptorsDestination, pManyfestSchemaDescriptorsSource)
	{
		if ((typeof(pManyfestSchemaDescriptorsSource) != 'object') || (typeof(pManyfestSchemaDescriptorsDestination) != 'object'))
		{
			this.logError(`Attempted to merge two schema descriptors but both were not objects.`);
			return false;
		}

		let tmpSource = JSON.parse(JSON.stringify(pManyfestSchemaDescriptorsSource));
		let tmpNewManyfestSchemaDescriptors = JSON.parse(JSON.stringify(pManyfestSchemaDescriptorsDestination));

		// The first passed-in set of descriptors takes precedence.
		let tmpDescriptorAddresses = Object.keys(tmpSource);

		tmpDescriptorAddresses.forEach(
			(pDescriptorAddress) =>
			{
				if (!(pDescriptorAddress in tmpNewManyfestSchemaDescriptors))
				{
					tmpNewManyfestSchemaDescriptors[pDescriptorAddress] = tmpSource[pDescriptorAddress];
				}
			});

		return tmpNewManyfestSchemaDescriptors;
	}
}

module.exports = ManyfestSchemaManipulation;

},{"./Manyfest-LogToConsole.js":123}],132:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
const libFableServiceProviderBase = require('fable-serviceproviderbase');

let libSimpleLog = require('./Manyfest-LogToConsole.js');

let libHashTranslation = require('./Manyfest-HashTranslation.js');
let libObjectAddressCheckAddressExists = require('./Manyfest-ObjectAddress-CheckAddressExists.js');
let libObjectAddressGetValue = require('./Manyfest-ObjectAddress-GetValue.js');
let libObjectAddressSetValue = require('./Manyfest-ObjectAddress-SetValue.js');
let libObjectAddressDeleteValue = require('./Manyfest-ObjectAddress-DeleteValue.js');
let libObjectAddressGeneration = require('./Manyfest-ObjectAddressGeneration.js');
let libSchemaManipulation = require('./Manyfest-SchemaManipulation.js');

const _DefaultConfiguration = { Scope:'DEFAULT', Descriptors: {} }

/**
 * @typedef {{
 *   Hash?: string,
 *   Name?: string,
 *   DataType?: string,
 *   Required?: boolean,
 *   Address?: string,
 *   Description?: string,
 *   [key: string]: any,
 * }} ManifestDescriptor
 */

/**
* Manyfest object address-based descriptions and manipulations.
*
* @class Manyfest
*/
class Manyfest extends libFableServiceProviderBase
{
	constructor(pFable, pManifest, pServiceHash)
	{
		if (pFable === undefined)
		{
			super({});
		}
		else
		{
			super(pFable, pManifest, pServiceHash);
		}

		/** @type {import('fable')} */
		this.fable;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.Hash;
		/** @type {string} */
		this.UUID;

        this.serviceType = 'Manifest';

		// Wire in logging
		this.logInfo = libSimpleLog;
		this.logError = libSimpleLog;

		// Create an object address resolver and map in the functions
		this.objectAddressCheckAddressExists = new libObjectAddressCheckAddressExists(this.logInfo, this.logError);
		this.objectAddressGetValue = new libObjectAddressGetValue(this.logInfo, this.logError);
		this.objectAddressSetValue = new libObjectAddressSetValue(this.logInfo, this.logError);
		this.objectAddressDeleteValue = new libObjectAddressDeleteValue(this.logInfo, this.logError);

		if (!('defaultValues' in this.options))
		{
			this.options.defaultValues = (
				{
					"String": "",
					"Number": 0,
					"Float": 0.0,
					"Integer": 0,
					"PreciseNumber": "0.0",
					"Boolean": false,
					"Binary": 0,
					"DateTime": 0,
					"Array": [],
					"Object": {},
					"Null": null
				});
		}
		if (!('strict' in this.options))
		{
			this.options.strict = false;
		}

		/** @type {string} */
		this.scope = undefined;
		/** @type {Array<string>} */
		this.elementAddresses = undefined;
		/** @type {Record<string, string>} */
		this.elementHashes = undefined;
		/** @type {Record<string, ManifestDescriptor>} */
		this.elementDescriptors = undefined;

		this.reset();

		if (typeof(this.options) === 'object')
		{
			this.loadManifest(this.options);
		}

		this.schemaManipulations = new libSchemaManipulation(this.logInfo, this.logError);
		this.objectAddressGeneration = new libObjectAddressGeneration(this.logInfo, this.logError);

		this.hashTranslations = new libHashTranslation(this.logInfo, this.logError);

		this.numberRegex = /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/;
	}

	/*************************************************************************
	 * Schema Manifest Loading, Reading, Manipulation and Serialization Functions
	 */

	// Reset critical manifest properties
	reset()
	{
		this.scope = 'DEFAULT';
		this.elementAddresses = [];
		this.elementHashes = {};
		this.elementDescriptors = {};
	}

	clone()
	{
		// Make a copy of the options in-place
		let tmpNewOptions = JSON.parse(JSON.stringify(this.options));

		let tmpNewManyfest = new Manyfest(this.fable, tmpNewOptions, this.Hash);
		tmpNewManyfest.logInfo = this.logInfo;
		tmpNewManyfest.logError = this.logError;
		//FIXME: mostly written by co-pilot
		const { Scope, Descriptors, HashTranslations } = this.getManifest();
		tmpNewManyfest.scope = Scope;
		tmpNewManyfest.elementDescriptors = Descriptors;
		tmpNewManyfest.elementAddresses = Object.keys(Descriptors);
		// Rebuild the element hashes
		for (let i = 0; i < tmpNewManyfest.elementAddresses.length; i++)
		{
			let tmpAddress = tmpNewManyfest.elementAddresses[i];
			let tmpDescriptor = tmpNewManyfest.elementDescriptors[tmpAddress];
			tmpNewManyfest.elementHashes[tmpAddress] = tmpAddress;
			if ('Hash' in tmpDescriptor)
			{
				tmpNewManyfest.elementHashes[tmpDescriptor.Hash] = tmpAddress;
			}
		}

		// Import the hash translations
		tmpNewManyfest.hashTranslations.addTranslation(this.hashTranslations.translationTable);

		return tmpNewManyfest;
	}

	// Deserialize a Manifest from a string
	/**
	 * @param {string} pManifestString - The manifest string to deserialize
	 *
	 * @return {Manyfest} The deserialized manifest
	 */
	deserialize(pManifestString)
	{
		// TODO: Add guards for bad manifest string
		this.loadManifest(JSON.parse(pManifestString));
		return this;
	}

	// Load a manifest from an object
	loadManifest(pManifest)
	{
		if (typeof(pManifest) !== 'object')
		{
			this.logError(`(${this.scope}) Error loading manifest; expecting an object but parameter was type ${typeof(pManifest)}.`);
		}

		let tmpManifest = (typeof(pManifest) == 'object') ? pManifest : {};

		let tmpDescriptorKeys = Object.keys(_DefaultConfiguration);

		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			if (!(tmpDescriptorKeys[i] in tmpManifest))
			{
				tmpManifest[tmpDescriptorKeys[i]] = JSON.parse(JSON.stringify(_DefaultConfiguration[tmpDescriptorKeys[i]]));
			}
		}

		if ('Scope' in tmpManifest)
		{
			if (typeof(tmpManifest.Scope) === 'string')
			{
				this.scope = tmpManifest.Scope;
			}
			else
			{
				this.logError(`(${this.scope}) Error loading scope from manifest; expecting a string but property was type ${typeof(tmpManifest.Scope)}.`, tmpManifest);
			}
		}
		else
		{
			this.logError(`(${this.scope}) Error loading scope from manifest object.  Property "Scope" does not exist in the root of the object.`, tmpManifest);
		}

		if ('Descriptors' in tmpManifest)
		{
			if (typeof(tmpManifest.Descriptors) === 'object')
			{
				let tmpDescriptionAddresses = Object.keys(tmpManifest.Descriptors);
				for (let i = 0; i < tmpDescriptionAddresses.length; i++)
				{
					this.addDescriptor(tmpDescriptionAddresses[i], tmpManifest.Descriptors[tmpDescriptionAddresses[i]]);
				}
			}
			else
			{
				this.logError(`(${this.scope}) Error loading description object from manifest object.  Expecting an object in 'Manifest.Descriptors' but the property was type ${typeof(tmpManifest.Descriptors)}.`, tmpManifest);
			}
		}
		else
		{
			this.logError(`(${this.scope}) Error loading object description from manifest object.  Property "Descriptors" does not exist in the root of the Manifest object.`, tmpManifest);
		}

		if ('HashTranslations' in tmpManifest)
		{
			if (typeof(tmpManifest.HashTranslations) === 'object')
			{
				// HashTranslations is serialized as a plain object of source:target pairs
				this.hashTranslations.addTranslation(tmpManifest.HashTranslations);
			}
		}
	}

	/**
	 * Serialize the Manifest to a string
	 *
	 * @return {string} - The serialized manifest
	 */
	serialize()
	{
		return JSON.stringify(this.getManifest());
	}

	/**
	 * @return {{ Scope: string, Descriptors: Record<string, ManifestDescriptor>, HashTranslations: Record<string, string> }} - A copy of the manifest state.
	 */
	getManifest()
	{
		return (
			{
				Scope: this.scope,
				Descriptors: JSON.parse(JSON.stringify(this.elementDescriptors)),
				HashTranslations: JSON.parse(JSON.stringify(this.hashTranslations.translationTable))
			});
	}

	/**
	 * Add a descriptor to the manifest
	 *
	 * @param {string} pAddress - The address of the element to add the descriptor for.
	 * @param {ManifestDescriptor} pDescriptor - The descriptor object to add.
	 */
	addDescriptor(pAddress, pDescriptor)
	{
		if (typeof(pDescriptor) === 'object')
		{
			// Add the Address into the Descriptor if it doesn't exist:
			if (!('Address' in pDescriptor))
			{
				pDescriptor.Address = pAddress;
			}

			if (!(pAddress in this.elementDescriptors))
			{
				this.elementAddresses.push(pAddress);
			}

			// Add the element descriptor to the schema
			this.elementDescriptors[pAddress] = pDescriptor;

			// Always add the address as a hash
			this.elementHashes[pAddress] = pAddress;

			if ('Hash' in pDescriptor)
			{
				// TODO: Check if this is a good idea or not..
				//       Collisions are bound to happen with both representations of the address/hash in here and developers being able to create their own hashes.
				this.elementHashes[pDescriptor.Hash] = pAddress;
			}
			else
			{
				pDescriptor.Hash = pAddress;
			}

			return true;
		}
		else
		{
			this.logError(`(${this.scope}) Error loading object descriptor for address '${pAddress}' from manifest object.  Expecting an object but property was type ${typeof(pDescriptor)}.`);
			return false;
		}
	}

	/**
	 * @param {string} pHash - The hash of the address to resolve.
	 *
	 * @return {ManifestDescriptor} The descriptor for the address
	 */
	getDescriptorByHash(pHash)
	{
		return this.getDescriptor(this.resolveHashAddress(pHash));
	}

	/**
	 * @param {string} pAddress - The address of the element to get the descriptor for.
	 *
	 * @return {ManifestDescriptor} The descriptor for the address
	 */
	getDescriptor(pAddress)
	{
		return this.elementDescriptors[pAddress];
	}

	/**
	 * execute an action function for each descriptor
	 * @param {(d: ManifestDescriptor) => void} fAction - The action function to execute for each descriptor.
	 */
	eachDescriptor(fAction)
	{
        let tmpDescriptorAddresses = Object.keys(this.elementDescriptors);
        for (let i = 0; i < tmpDescriptorAddresses.length; i++)
        {
            fAction(this.elementDescriptors[tmpDescriptorAddresses[i]]);
        }

	}

	/*************************************************************************
	 * Beginning of Object Manipulation (read & write) Functions
	 */
	// Check if an element exists by its hash
	checkAddressExistsByHash (pObject, pHash)
	{
		return this.checkAddressExists(pObject,this.resolveHashAddress(pHash));
	}

	// Check if an element exists at an address
	checkAddressExists (pObject, pAddress)
	{
		return this.objectAddressCheckAddressExists.checkAddressExists(pObject, pAddress);
	}

	/**
	 * Check what role a string plays in this manifest -- whether it is a Hash, an Address, both or neither.
	 *
	 * @param {string} pString - The string to check.
	 *
	 * @return {{ IsHash: boolean, IsAddress: boolean, ResolvedAddress: string|undefined }} The role of the string.
	 */
	checkStringRole(pString)
	{
		if (typeof(pString) !== 'string' || pString.length === 0)
		{
			return { IsHash: false, IsAddress: false, ResolvedAddress: undefined };
		}

		let tmpIsAddress = (pString in this.elementDescriptors);
		let tmpIsHash = (pString in this.elementHashes);
		let tmpResolvedAddress = tmpIsHash ? this.elementHashes[pString] : undefined;

		return (
			{
				IsHash: tmpIsHash,
				IsAddress: tmpIsAddress,
				ResolvedAddress: tmpResolvedAddress
			});
	}

	// Turn a hash into an address, factoring in the translation table.
	resolveHashAddress(pHash)
	{
		let tmpAddress = undefined;

		let tmpInElementHashTable = (pHash in this.elementHashes);
		let tmpInTranslationTable = (pHash in this.hashTranslations.translationTable);

		// The most straightforward: the hash exists, no translations.
		if (tmpInElementHashTable && !tmpInTranslationTable)
		{
			tmpAddress = this.elementHashes[pHash];
		}
		// There is a translation from one hash to another, and, the elementHashes contains the pointer end
		else if (tmpInTranslationTable && (this.hashTranslations.translate(pHash) in this.elementHashes))
		{
			tmpAddress = this.elementHashes[this.hashTranslations.translate(pHash)];
		}
		// Use the level of indirection only in the Translation Table
		else if (tmpInTranslationTable)
		{
			tmpAddress = this.hashTranslations.translate(pHash);
		}
		// Just treat the hash as an address.
		// TODO: Discuss this ... it is magic but controversial
		else
		{
			tmpAddress = pHash;
		}

		return tmpAddress;
	}

	// Get the value of an element by its hash
	getValueByHash (pObject, pHash)
	{
		let tmpValue = this.getValueAtAddress(pObject, this.resolveHashAddress(pHash));

		if (typeof(tmpValue) == 'undefined')
		{
			// Try to get a default if it exists
			tmpValue = this.getDefaultValue(this.getDescriptorByHash(pHash));
		}

		return tmpValue;
	}

	lintAddress(pAddress)
	{
		// Guard against non-string input
		if (typeof(pAddress) != 'string')
		{
			return '';
		}
		let tmpLintedAddress = pAddress.trim();
		// Check for a single trailing . (but not a ..) at the end of the address and remove it.
		// We must not strip '..' because that is back-navigation syntax.
		if (tmpLintedAddress.endsWith('.') && !tmpLintedAddress.endsWith('..'))
		{
			tmpLintedAddress = tmpLintedAddress.slice(0, -1);
		}

		return tmpLintedAddress;
	}

	// Get the value of an element at an address
	getValueAtAddress (pObject, pAddress)
	{
		let tmpLintedAddress = this.lintAddress(pAddress);
		if (tmpLintedAddress == '')
		{
			this.logError(`(${this.scope}) Error getting value at address; address is an empty string.`, pObject);
			return undefined;
		}
		let tmpValue = this.objectAddressGetValue.getValueAtAddress(pObject, tmpLintedAddress);

		if (typeof(tmpValue) == 'undefined')
		{
			// Try to get a default if it exists
			tmpValue = this.getDefaultValue(this.getDescriptor(tmpLintedAddress));
		}

		return tmpValue;
	}

	// Set the value of an element by its hash
	setValueByHash(pObject, pHash, pValue)
	{
		return this.setValueAtAddress(pObject, this.resolveHashAddress(pHash), pValue);
	}

	// Set the value of an element at an address
	setValueAtAddress (pObject, pAddress, pValue)
	{
		let tmpLintedAddress = this.lintAddress(pAddress);
		return this.objectAddressSetValue.setValueAtAddress(pObject, tmpLintedAddress, pValue);
	}

	// Delete the value of an element by its hash
	deleteValueByHash(pObject, pHash)
	{
		return this.deleteValueAtAddress(pObject, this.resolveHashAddress(pHash));
	}

	// Delete the value of an element at an address
	deleteValueAtAddress (pObject, pAddress)
	{
		let tmpLintedAddress = this.lintAddress(pAddress);
		return this.objectAddressDeleteValue.deleteValueAtAddress(pObject, tmpLintedAddress);
	}

	// Validate the consistency of an object against the schema
	validate(pObject)
	{
		let tmpValidationData =
		{
			Error: null,
			Errors: [],
			MissingElements:[]
		};

		if (typeof(pObject) !== 'object')
		{
			tmpValidationData.Error = true;
			tmpValidationData.Errors.push(`Expected passed in object to be type object but was passed in ${typeof(pObject)}`);
		}

		let addValidationError = (pAddress, pErrorMessage) =>
		{
			tmpValidationData.Error = true;
			tmpValidationData.Errors.push(`Element at address "${pAddress}" ${pErrorMessage}.`);
		};

		// Now enumerate through the values and check for anomalies based on the schema
		for (let i = 0; i < this.elementAddresses.length; i++)
		{
			let tmpDescriptor = this.getDescriptor(this.elementAddresses[i]);
			let tmpValueExists = this.checkAddressExists(pObject, tmpDescriptor.Address);
			let tmpValue = this.getValueAtAddress(pObject, tmpDescriptor.Address);

			if ((typeof(tmpValue) == 'undefined') || !tmpValueExists)
			{
				// This will technically mean that `Object.Some.Value = undefined` will end up showing as "missing"
				// TODO: Do we want to do a different message based on if the property exists but is undefined?
				tmpValidationData.MissingElements.push(tmpDescriptor.Address);
				if (tmpDescriptor.Required || this.options.strict)
				{
					addValidationError(tmpDescriptor.Address, 'is flagged REQUIRED but is not set in the object');
				}
			}

			// Now see if there is a data type specified for this element
			if (tmpDescriptor.DataType)
			{
				let tmpElementType = typeof(tmpValue);
				switch(tmpDescriptor.DataType.toString().trim().toLowerCase())
				{
					case 'string':
						if (tmpElementType != 'string')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case "precisenumber":
						if (tmpElementType != 'string')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						else if (!this.numberRegex.test(tmpValue))
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is not a valid number`);
						}
						break;

					case 'number':
						if (tmpElementType != 'number')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case 'integer':
						if (tmpElementType != 'number')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						else
						{
							let tmpValueString = tmpValue.toString();
							if (tmpValueString.indexOf('.') > -1)
							{
								// TODO: Is this an error?
								addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but has a decimal point in the number.`);
							}
						}
						break;

					case 'float':
						if (tmpElementType != 'number')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case 'boolean':
						if (tmpElementType != 'boolean')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case 'datetime':
						let tmpValueDate = new Date(tmpValue);
						if (tmpValueDate.toString() == 'Invalid Date')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is not parsable as a Date by Javascript`);
						}
						break;

					default:
						// Check if this is a string, in the default case
						// Note this is only when a DataType is specified and it is an unrecognized data type.
						if (tmpElementType != 'string')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} (which auto-converted to String because it was unrecognized) but is of the type ${tmpElementType}`);
						}
						break;
				}
			}
		}

		return tmpValidationData;
	}

	/**
	 * Returns a default value, or, the default value for the data type (which is overridable with configuration)
	 *
	 * @param {ManifestDescriptor} pDescriptor - The descriptor definition.
	 */
	getDefaultValue(pDescriptor)
	{
		if (typeof(pDescriptor) != 'object')
		{
			return undefined;
		}

		if ('Default' in pDescriptor)
		{
			return pDescriptor.Default;
		}
		else
		{
			// Default to a null if it doesn't have a type specified.
			// This will ensure a placeholder is created but isn't misinterpreted.
			let tmpDataType = ('DataType' in pDescriptor) ? pDescriptor.DataType : 'String';
			if (tmpDataType in this.options.defaultValues)
			{
				let tmpDefaultValue = this.options.defaultValues[tmpDataType];
				// Return a copy of mutable defaults (Array and Object) to prevent shared state
				if (typeof(tmpDefaultValue) == 'object' && tmpDefaultValue !== null)
				{
					return JSON.parse(JSON.stringify(tmpDefaultValue));
				}
				return tmpDefaultValue;
			}
			else
			{
				// give up and return null
				return null;
			}
		}
	}

	// Enumerate through the schema and populate default values if they don't exist.
	populateDefaults(pObject, pOverwriteProperties)
	{
		return this.populateObject(pObject, pOverwriteProperties,
			// This just sets up a simple filter to see if there is a default set.
			(pDescriptor) =>
			{
				return ('Default' in pDescriptor);
			});
	}

	// Forcefully populate all values even if they don't have defaults.
	// Based on type, this can do unexpected things.
	populateObject(pObject, pOverwriteProperties, fFilter)
	{
		// Automatically create an object if one isn't passed in.
		let tmpObject = (typeof(pObject) === 'object') ? pObject : {};
		// Default to *NOT OVERWRITING* properties
		let tmpOverwriteProperties = (typeof(pOverwriteProperties) == 'undefined') ? false : pOverwriteProperties;
		// This is a filter function, which is passed the schema and allows complex filtering of population
		// The default filter function just returns true, populating everything.
		let tmpFilterFunction = (typeof(fFilter) == 'function') ? fFilter : (pDescriptor) => { return true; };

		this.elementAddresses.forEach(
			(pAddress) =>
			{
				let tmpDescriptor = this.getDescriptor(pAddress);
				// Check the filter function to see if this is an address we want to set the value for.
				if (tmpFilterFunction(tmpDescriptor))
				{
					// If we are overwriting properties OR the property does not exist
					if (tmpOverwriteProperties || !this.checkAddressExists(tmpObject, pAddress))
					{
						this.setValueAtAddress(tmpObject, pAddress, this.getDefaultValue(tmpDescriptor));
					}
				}
			});

		return tmpObject;
	}
};

module.exports = Manyfest;

},{"./Manyfest-HashTranslation.js":122,"./Manyfest-LogToConsole.js":123,"./Manyfest-ObjectAddress-CheckAddressExists.js":124,"./Manyfest-ObjectAddress-DeleteValue.js":125,"./Manyfest-ObjectAddress-GetValue.js":126,"./Manyfest-ObjectAddress-SetValue.js":128,"./Manyfest-ObjectAddressGeneration.js":129,"./Manyfest-SchemaManipulation.js":131,"fable-serviceproviderbase":59}],133:[function(require,module,exports){
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
})(this, (function (exports) { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  function getDefaults() {
    return {
      async: false,
      baseUrl: null,
      breaks: false,
      extensions: null,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      hooks: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: null,
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartypants: false,
      tokenizer: null,
      walkTokens: null,
      xhtml: false
    };
  }
  exports.defaults = getDefaults();
  function changeDefaults(newDefaults) {
    exports.defaults = newDefaults;
  }

  /**
   * Helpers
   */
  var escapeTest = /[&<>"']/;
  var escapeReplace = new RegExp(escapeTest.source, 'g');
  var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
  var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
  var escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  var getEscapeReplacement = function getEscapeReplacement(ch) {
    return escapeReplacements[ch];
  };
  function escape(html, encode) {
    if (encode) {
      if (escapeTest.test(html)) {
        return html.replace(escapeReplace, getEscapeReplacement);
      }
    } else {
      if (escapeTestNoEncode.test(html)) {
        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
      }
    }
    return html;
  }
  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

  /**
   * @param {string} html
   */
  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }
  var caret = /(^|[^\[])\^/g;

  /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */
  function edit(regex, opt) {
    regex = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    var obj = {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(caret, '$1');
        regex = regex.replace(name, val);
        return obj;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
    return obj;
  }
  var nonWordAndColonTest = /[^\w:]/g;
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */
  function cleanUrl(sanitize, base, href) {
    if (sanitize) {
      var prot;
      try {
        prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
      } catch (e) {
        return null;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }
    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }
    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }
    return href;
  }
  var baseUrls = {};
  var justDomain = /^[^:]+:\/*[^/]*$/;
  var protocol = /^([^:]+:)[\s\S]*$/;
  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

  /**
   * @param {string} base
   * @param {string} href
   */
  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (justDomain.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim(base, '/', true);
      }
    }
    base = baseUrls[' ' + base];
    var relativeBase = base.indexOf(':') === -1;
    if (href.substring(0, 2) === '//') {
      if (relativeBase) {
        return href;
      }
      return base.replace(protocol, '$1') + href;
    } else if (href.charAt(0) === '/') {
      if (relativeBase) {
        return href;
      }
      return base.replace(domain, '$1') + href;
    } else {
      return base + href;
    }
  }
  var noopTest = {
    exec: function noopTest() {}
  };
  function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
          curr = offset;
        while (--curr >= 0 && str[curr] === '\\') {
          escaped = !escaped;
        }
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/);
    var i = 0;

    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) {
      cells.shift();
    }
    if (cells.length > 0 && !cells[cells.length - 1].trim()) {
      cells.pop();
    }
    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) {
        cells.push('');
      }
    }
    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
  }

  /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */
  function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) {
      return '';
    }

    // Length of suffix matching the invert condition.
    var suffLen = 0;

    // Step left until we fail to match the invert condition.
    while (suffLen < l) {
      var currChar = str.charAt(l - suffLen - 1);
      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }
    return str.slice(0, l - suffLen);
  }
  function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }
    var l = str.length;
    var level = 0,
      i = 0;
    for (; i < l; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;
        if (level < 0) {
          return i;
        }
      }
    }
    return -1;
  }
  function checkSanitizeDeprecation(opt) {
    if (opt && opt.sanitize && !opt.silent) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
  }

  // copied from https://stackoverflow.com/a/5450113/806777
  /**
   * @param {string} pattern
   * @param {number} count
   */
  function repeatString(pattern, count) {
    if (count < 1) {
      return '';
    }
    var result = '';
    while (count > 1) {
      if (count & 1) {
        result += pattern;
      }
      count >>= 1;
      pattern += pattern;
    }
    return result + pattern;
  }

  function outputLink(cap, link, raw, lexer) {
    var href = link.href;
    var title = link.title ? escape(link.title) : null;
    var text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
      lexer.state.inLink = true;
      var token = {
        type: 'link',
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer.inlineTokens(text)
      };
      lexer.state.inLink = false;
      return token;
    }
    return {
      type: 'image',
      raw: raw,
      href: href,
      title: title,
      text: escape(text)
    };
  }
  function indentCodeCompensation(raw, text) {
    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) {
      return text;
    }
    var indentToCode = matchIndentToCode[1];
    return text.split('\n').map(function (node) {
      var matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }
      var indentInNode = matchIndentInNode[0];
      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }
      return node;
    }).join('\n');
  }

  /**
   * Tokenizer
   */
  var Tokenizer = /*#__PURE__*/function () {
    function Tokenizer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Tokenizer.prototype;
    _proto.space = function space(src) {
      var cap = this.rules.block.newline.exec(src);
      if (cap && cap[0].length > 0) {
        return {
          type: 'space',
          raw: cap[0]
        };
      }
    };
    _proto.code = function code(src) {
      var cap = this.rules.block.code.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ {1,4}/gm, '');
        return {
          type: 'code',
          raw: cap[0],
          codeBlockStyle: 'indented',
          text: !this.options.pedantic ? rtrim(text, '\n') : text
        };
      }
    };
    _proto.fences = function fences(src) {
      var cap = this.rules.block.fences.exec(src);
      if (cap) {
        var raw = cap[0];
        var text = indentCodeCompensation(raw, cap[3] || '');
        return {
          type: 'code',
          raw: raw,
          lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
          text: text
        };
      }
    };
    _proto.heading = function heading(src) {
      var cap = this.rules.block.heading.exec(src);
      if (cap) {
        var text = cap[2].trim();

        // remove trailing #s
        if (/#$/.test(text)) {
          var trimmed = rtrim(text, '#');
          if (this.options.pedantic) {
            text = trimmed.trim();
          } else if (!trimmed || / $/.test(trimmed)) {
            // CommonMark requires space before trailing #s
            text = trimmed.trim();
          }
        }
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[1].length,
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.hr = function hr(src) {
      var cap = this.rules.block.hr.exec(src);
      if (cap) {
        return {
          type: 'hr',
          raw: cap[0]
        };
      }
    };
    _proto.blockquote = function blockquote(src) {
      var cap = this.rules.block.blockquote.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ *>[ \t]?/gm, '');
        var top = this.lexer.state.top;
        this.lexer.state.top = true;
        var tokens = this.lexer.blockTokens(text);
        this.lexer.state.top = top;
        return {
          type: 'blockquote',
          raw: cap[0],
          tokens: tokens,
          text: text
        };
      }
    };
    _proto.list = function list(src) {
      var cap = this.rules.block.list.exec(src);
      if (cap) {
        var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
        var bull = cap[1].trim();
        var isordered = bull.length > 1;
        var list = {
          type: 'list',
          raw: '',
          ordered: isordered,
          start: isordered ? +bull.slice(0, -1) : '',
          loose: false,
          items: []
        };
        bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
        if (this.options.pedantic) {
          bull = isordered ? bull : '[*+-]';
        }

        // Get next list item
        var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");

        // Check if current bullet point can start a new List Item
        while (src) {
          endEarly = false;
          if (!(cap = itemRegex.exec(src))) {
            break;
          }
          if (this.rules.block.hr.test(src)) {
            // End list if bullet was actually HR (possibly move into itemRegex?)
            break;
          }
          raw = cap[0];
          src = src.substring(raw.length);
          line = cap[2].split('\n', 1)[0].replace(/^\t+/, function (t) {
            return ' '.repeat(3 * t.length);
          });
          nextLine = src.split('\n', 1)[0];
          if (this.options.pedantic) {
            indent = 2;
            itemContents = line.trimLeft();
          } else {
            indent = cap[2].search(/[^ ]/); // Find first non-space char
            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
            itemContents = line.slice(indent);
            indent += cap[1].length;
          }
          blankLine = false;
          if (!line && /^ *$/.test(nextLine)) {
            // Items begin with at most one blank line
            raw += nextLine + '\n';
            src = src.substring(nextLine.length + 1);
            endEarly = true;
          }
          if (!endEarly) {
            var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
            var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
            var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
            var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");

            // Check if following lines should be included in List Item
            while (src) {
              rawLine = src.split('\n', 1)[0];
              nextLine = rawLine;

              // Re-align to follow commonmark nesting rules
              if (this.options.pedantic) {
                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
              }

              // End list item if found code fences
              if (fencesBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new heading
              if (headingBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new bullet
              if (nextBulletRegex.test(nextLine)) {
                break;
              }

              // Horizontal rule found
              if (hrRegex.test(src)) {
                break;
              }
              if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) {
                // Dedent if possible
                itemContents += '\n' + nextLine.slice(indent);
              } else {
                // not enough indentation
                if (blankLine) {
                  break;
                }

                // paragraph continuation unless last line was a different block level element
                if (line.search(/[^ ]/) >= 4) {
                  // indented code block
                  break;
                }
                if (fencesBeginRegex.test(line)) {
                  break;
                }
                if (headingBeginRegex.test(line)) {
                  break;
                }
                if (hrRegex.test(line)) {
                  break;
                }
                itemContents += '\n' + nextLine;
              }
              if (!blankLine && !nextLine.trim()) {
                // Check if current line is blank
                blankLine = true;
              }
              raw += rawLine + '\n';
              src = src.substring(rawLine.length + 1);
              line = nextLine.slice(indent);
            }
          }
          if (!list.loose) {
            // If the previous item ended with a blank line, the list is loose
            if (endsWithBlankLine) {
              list.loose = true;
            } else if (/\n *\n *$/.test(raw)) {
              endsWithBlankLine = true;
            }
          }

          // Check for task list items
          if (this.options.gfm) {
            istask = /^\[[ xX]\] /.exec(itemContents);
            if (istask) {
              ischecked = istask[0] !== '[ ] ';
              itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
            }
          }
          list.items.push({
            type: 'list_item',
            raw: raw,
            task: !!istask,
            checked: ischecked,
            loose: false,
            text: itemContents
          });
          list.raw += raw;
        }

        // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
        list.items[list.items.length - 1].raw = raw.trimRight();
        list.items[list.items.length - 1].text = itemContents.trimRight();
        list.raw = list.raw.trimRight();
        var l = list.items.length;

        // Item child tokens handled here at end because we needed to have the final item to trim it first
        for (i = 0; i < l; i++) {
          this.lexer.state.top = false;
          list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
          if (!list.loose) {
            // Check if list should be loose
            var spacers = list.items[i].tokens.filter(function (t) {
              return t.type === 'space';
            });
            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function (t) {
              return /\n.*\n/.test(t.raw);
            });
            list.loose = hasMultipleLineBreaks;
          }
        }

        // Set all items to loose if list is loose
        if (list.loose) {
          for (i = 0; i < l; i++) {
            list.items[i].loose = true;
          }
        }
        return list;
      }
    };
    _proto.html = function html(src) {
      var cap = this.rules.block.html.exec(src);
      if (cap) {
        var token = {
          type: 'html',
          raw: cap[0],
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: cap[0]
        };
        if (this.options.sanitize) {
          var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
          token.type = 'paragraph';
          token.text = text;
          token.tokens = this.lexer.inline(text);
        }
        return token;
      }
    };
    _proto.def = function def(src) {
      var cap = this.rules.block.def.exec(src);
      if (cap) {
        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
        var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
        return {
          type: 'def',
          tag: tag,
          raw: cap[0],
          href: href,
          title: title
        };
      }
    };
    _proto.table = function table(src) {
      var cap = this.rules.block.table.exec(src);
      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1]).map(function (c) {
            return {
              text: c
            };
          }),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
        };
        if (item.header.length === item.align.length) {
          item.raw = cap[0];
          var l = item.align.length;
          var i, j, k, row;
          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }
          l = item.rows.length;
          for (i = 0; i < l; i++) {
            item.rows[i] = splitCells(item.rows[i], item.header.length).map(function (c) {
              return {
                text: c
              };
            });
          }

          // parse child tokens inside headers and cells

          // header child tokens
          l = item.header.length;
          for (j = 0; j < l; j++) {
            item.header[j].tokens = this.lexer.inline(item.header[j].text);
          }

          // cell child tokens
          l = item.rows.length;
          for (j = 0; j < l; j++) {
            row = item.rows[j];
            for (k = 0; k < row.length; k++) {
              row[k].tokens = this.lexer.inline(row[k].text);
            }
          }
          return item;
        }
      }
    };
    _proto.lheading = function lheading(src) {
      var cap = this.rules.block.lheading.exec(src);
      if (cap) {
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1],
          tokens: this.lexer.inline(cap[1])
        };
      }
    };
    _proto.paragraph = function paragraph(src) {
      var cap = this.rules.block.paragraph.exec(src);
      if (cap) {
        var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
        return {
          type: 'paragraph',
          raw: cap[0],
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.text = function text(src) {
      var cap = this.rules.block.text.exec(src);
      if (cap) {
        return {
          type: 'text',
          raw: cap[0],
          text: cap[0],
          tokens: this.lexer.inline(cap[0])
        };
      }
    };
    _proto.escape = function escape$1(src) {
      var cap = this.rules.inline.escape.exec(src);
      if (cap) {
        return {
          type: 'escape',
          raw: cap[0],
          text: escape(cap[1])
        };
      }
    };
    _proto.tag = function tag(src) {
      var cap = this.rules.inline.tag.exec(src);
      if (cap) {
        if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
          this.lexer.state.inLink = true;
        } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
          this.lexer.state.inLink = false;
        }
        if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = true;
        } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = false;
        }
        return {
          type: this.options.sanitize ? 'text' : 'html',
          raw: cap[0],
          inLink: this.lexer.state.inLink,
          inRawBlock: this.lexer.state.inRawBlock,
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
        };
      }
    };
    _proto.link = function link(src) {
      var cap = this.rules.inline.link.exec(src);
      if (cap) {
        var trimmedUrl = cap[2].trim();
        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
          // commonmark requires matching angle brackets
          if (!/>$/.test(trimmedUrl)) {
            return;
          }

          // ending angle bracket cannot be escaped
          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
            return;
          }
        } else {
          // find closing parenthesis
          var lastParenIndex = findClosingBracket(cap[2], '()');
          if (lastParenIndex > -1) {
            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
            var linkLen = start + cap[1].length + lastParenIndex;
            cap[2] = cap[2].substring(0, lastParenIndex);
            cap[0] = cap[0].substring(0, linkLen).trim();
            cap[3] = '';
          }
        }
        var href = cap[2];
        var title = '';
        if (this.options.pedantic) {
          // split pedantic href and title
          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
          if (link) {
            href = link[1];
            title = link[3];
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }
        href = href.trim();
        if (/^</.test(href)) {
          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
            // pedantic allows starting angle bracket without ending angle bracket
            href = href.slice(1);
          } else {
            href = href.slice(1, -1);
          }
        }
        return outputLink(cap, {
          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
        }, cap[0], this.lexer);
      }
    };
    _proto.reflink = function reflink(src, links) {
      var cap;
      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = links[link.toLowerCase()];
        if (!link) {
          var text = cap[0].charAt(0);
          return {
            type: 'text',
            raw: text,
            text: text
          };
        }
        return outputLink(cap, link, cap[0], this.lexer);
      }
    };
    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
      if (prevChar === void 0) {
        prevChar = '';
      }
      var match = this.rules.inline.emStrong.lDelim.exec(src);
      if (!match) return;

      // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
      var nextChar = match[1] || match[2] || '';
      if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
        var lLength = match[0].length - 1;
        var rDelim,
          rLength,
          delimTotal = lLength,
          midDelimTotal = 0;
        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        endReg.lastIndex = 0;

        // Clip maskedSrc to same section of string as src (move to lexer?)
        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
        while ((match = endReg.exec(maskedSrc)) != null) {
          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
          if (!rDelim) continue; // skip single * in __abc*abc__

          rLength = rDelim.length;
          if (match[3] || match[4]) {
            // found another Left Delim
            delimTotal += rLength;
            continue;
          } else if (match[5] || match[6]) {
            // either Left or Right Delim
            if (lLength % 3 && !((lLength + rLength) % 3)) {
              midDelimTotal += rLength;
              continue; // CommonMark Emphasis Rules 9-10
            }
          }

          delimTotal -= rLength;
          if (delimTotal > 0) continue; // Haven't found enough closing delimiters

          // Remove extra characters. *a*** -> *a*
          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
          var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);

          // Create `em` if smallest delimiter has odd char count. *a***
          if (Math.min(lLength, rLength) % 2) {
            var _text = raw.slice(1, -1);
            return {
              type: 'em',
              raw: raw,
              text: _text,
              tokens: this.lexer.inlineTokens(_text)
            };
          }

          // Create 'strong' if smallest delimiter has even char count. **a***
          var text = raw.slice(2, -2);
          return {
            type: 'strong',
            raw: raw,
            text: text,
            tokens: this.lexer.inlineTokens(text)
          };
        }
      }
    };
    _proto.codespan = function codespan(src) {
      var cap = this.rules.inline.code.exec(src);
      if (cap) {
        var text = cap[2].replace(/\n/g, ' ');
        var hasNonSpaceChars = /[^ ]/.test(text);
        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
          text = text.substring(1, text.length - 1);
        }
        text = escape(text, true);
        return {
          type: 'codespan',
          raw: cap[0],
          text: text
        };
      }
    };
    _proto.br = function br(src) {
      var cap = this.rules.inline.br.exec(src);
      if (cap) {
        return {
          type: 'br',
          raw: cap[0]
        };
      }
    };
    _proto.del = function del(src) {
      var cap = this.rules.inline.del.exec(src);
      if (cap) {
        return {
          type: 'del',
          raw: cap[0],
          text: cap[2],
          tokens: this.lexer.inlineTokens(cap[2])
        };
      }
    };
    _proto.autolink = function autolink(src, mangle) {
      var cap = this.rules.inline.autolink.exec(src);
      if (cap) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.url = function url(src, mangle) {
      var cap;
      if (cap = this.rules.inline.url.exec(src)) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          var prevCapZero;
          do {
            prevCapZero = cap[0];
            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + cap[0];
          } else {
            href = cap[0];
          }
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.inlineText = function inlineText(src, smartypants) {
      var cap = this.rules.inline.text.exec(src);
      if (cap) {
        var text;
        if (this.lexer.state.inRawBlock) {
          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        } else {
          text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
        }
        return {
          type: 'text',
          raw: cap[0],
          text: text
        };
      }
    };
    return Tokenizer;
  }();

  /**
   * Block-Level Grammar
   */
  var block = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
  };
  block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
  block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
  block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = _extends({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = _extends({}, block.normal, {
    table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
  });

  block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block.pedantic = _extends({}, block.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });

  /**
   * Inline-Level Grammar
   */
  var inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: 'reflink|nolink(?!\\()',
    emStrong: {
      lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
      //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
      //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
      rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
      rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
    },

    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^([\spunctuation])/
  };

  // list of punctuation marks from CommonMark spec
  // without * and _ to handle the different emphasis markers * and _
  inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
  inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();

  // sequences em should skip over [title](link), `code`, <html>
  inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
  // lookbehind is not available on Safari as of version 16
  // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
  inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
  inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
  inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
  inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
  inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
  inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
  inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
  inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = _extends({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = _extends({}, inline.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = _extends({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  });
  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = _extends({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });

  /**
   * smartypants text replacement
   * @param {string} text
   */
  function smartypants(text) {
    return text
    // em-dashes
    .replace(/---/g, "\u2014")
    // en-dashes
    .replace(/--/g, "\u2013")
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")
    // closing singles & apostrophes
    .replace(/'/g, "\u2019")
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")
    // closing doubles
    .replace(/"/g, "\u201D")
    // ellipses
    .replace(/\.{3}/g, "\u2026");
  }

  /**
   * mangle email addresses
   * @param {string} text
   */
  function mangle(text) {
    var out = '',
      i,
      ch;
    var l = text.length;
    for (i = 0; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }
    return out;
  }

  /**
   * Block Lexer
   */
  var Lexer = /*#__PURE__*/function () {
    function Lexer(options) {
      this.tokens = [];
      this.tokens.links = Object.create(null);
      this.options = options || exports.defaults;
      this.options.tokenizer = this.options.tokenizer || new Tokenizer();
      this.tokenizer = this.options.tokenizer;
      this.tokenizer.options = this.options;
      this.tokenizer.lexer = this;
      this.inlineQueue = [];
      this.state = {
        inLink: false,
        inRawBlock: false,
        top: true
      };
      var rules = {
        block: block.normal,
        inline: inline.normal
      };
      if (this.options.pedantic) {
        rules.block = block.pedantic;
        rules.inline = inline.pedantic;
      } else if (this.options.gfm) {
        rules.block = block.gfm;
        if (this.options.breaks) {
          rules.inline = inline.breaks;
        } else {
          rules.inline = inline.gfm;
        }
      }
      this.tokenizer.rules = rules;
    }

    /**
     * Expose Rules
     */
    /**
     * Static Lex Method
     */
    Lexer.lex = function lex(src, options) {
      var lexer = new Lexer(options);
      return lexer.lex(src);
    }

    /**
     * Static Lex Inline Method
     */;
    Lexer.lexInline = function lexInline(src, options) {
      var lexer = new Lexer(options);
      return lexer.inlineTokens(src);
    }

    /**
     * Preprocessing
     */;
    var _proto = Lexer.prototype;
    _proto.lex = function lex(src) {
      src = src.replace(/\r\n|\r/g, '\n');
      this.blockTokens(src, this.tokens);
      var next;
      while (next = this.inlineQueue.shift()) {
        this.inlineTokens(next.src, next.tokens);
      }
      return this.tokens;
    }

    /**
     * Lexing
     */;
    _proto.blockTokens = function blockTokens(src, tokens) {
      var _this = this;
      if (tokens === void 0) {
        tokens = [];
      }
      if (this.options.pedantic) {
        src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
      } else {
        src = src.replace(/^( *)(\t+)/gm, function (_, leading, tabs) {
          return leading + '    '.repeat(tabs.length);
        });
      }
      var token, lastToken, cutSrc, lastParagraphClipped;
      while (src) {
        if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // newline
        if (token = this.tokenizer.space(src)) {
          src = src.substring(token.raw.length);
          if (token.raw.length === 1 && tokens.length > 0) {
            // if there's a single \n as a spacer, it's terminating the last line,
            // so move it there so that we don't get unecessary paragraph tags
            tokens[tokens.length - 1].raw += '\n';
          } else {
            tokens.push(token);
          }
          continue;
        }

        // code
        if (token = this.tokenizer.code(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          // An indented code block cannot interrupt a paragraph.
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // fences
        if (token = this.tokenizer.fences(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // heading
        if (token = this.tokenizer.heading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // hr
        if (token = this.tokenizer.hr(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // blockquote
        if (token = this.tokenizer.blockquote(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // list
        if (token = this.tokenizer.list(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // html
        if (token = this.tokenizer.html(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // def
        if (token = this.tokenizer.def(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.raw;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else if (!this.tokens.links[token.tag]) {
            this.tokens.links[token.tag] = {
              href: token.href,
              title: token.title
            };
          }
          continue;
        }

        // table (gfm)
        if (token = this.tokenizer.table(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // lheading
        if (token = this.tokenizer.lheading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // top-level paragraph
        // prevent paragraph consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startBlock) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this.options.extensions.startBlock.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
          lastToken = tokens[tokens.length - 1];
          if (lastParagraphClipped && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          lastParagraphClipped = cutSrc.length !== src.length;
          src = src.substring(token.raw.length);
          continue;
        }

        // text
        if (token = this.tokenizer.text(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      this.state.top = true;
      return tokens;
    };
    _proto.inline = function inline(src, tokens) {
      if (tokens === void 0) {
        tokens = [];
      }
      this.inlineQueue.push({
        src: src,
        tokens: tokens
      });
      return tokens;
    }

    /**
     * Lexing/Compiling
     */;
    _proto.inlineTokens = function inlineTokens(src, tokens) {
      var _this2 = this;
      if (tokens === void 0) {
        tokens = [];
      }
      var token, lastToken, cutSrc;

      // String with links masked to avoid interference with em and strong
      var maskedSrc = src;
      var match;
      var keepPrevChar, prevChar;

      // Mask out reflinks
      if (this.tokens.links) {
        var links = Object.keys(this.tokens.links);
        if (links.length > 0) {
          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
              maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
          }
        }
      }
      // Mask out other blocks
      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      }

      // Mask out escaped em & strong delimiters
      while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
      }
      while (src) {
        if (!keepPrevChar) {
          prevChar = '';
        }
        keepPrevChar = false;

        // extensions
        if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this2
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // escape
        if (token = this.tokenizer.escape(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // tag
        if (token = this.tokenizer.tag(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // link
        if (token = this.tokenizer.link(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // reflink, nolink
        if (token = this.tokenizer.reflink(src, this.tokens.links)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // em & strong
        if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // code
        if (token = this.tokenizer.codespan(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // br
        if (token = this.tokenizer.br(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // del (gfm)
        if (token = this.tokenizer.del(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // autolink
        if (token = this.tokenizer.autolink(src, mangle)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // url (gfm)
        if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // text
        // prevent inlineText consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startInline) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this2.options.extensions.startInline.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
          src = src.substring(token.raw.length);
          if (token.raw.slice(-1) !== '_') {
            // Track prevChar before string of ____ started
            prevChar = token.raw.slice(-1);
          }
          keepPrevChar = true;
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      return tokens;
    };
    _createClass(Lexer, null, [{
      key: "rules",
      get: function get() {
        return {
          block: block,
          inline: inline
        };
      }
    }]);
    return Lexer;
  }();

  /**
   * Renderer
   */
  var Renderer = /*#__PURE__*/function () {
    function Renderer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Renderer.prototype;
    _proto.code = function code(_code, infostring, escaped) {
      var lang = (infostring || '').match(/\S*/)[0];
      if (this.options.highlight) {
        var out = this.options.highlight(_code, lang);
        if (out != null && out !== _code) {
          escaped = true;
          _code = out;
        }
      }
      _code = _code.replace(/\n$/, '') + '\n';
      if (!lang) {
        return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
      }
      return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
    }

    /**
     * @param {string} quote
     */;
    _proto.blockquote = function blockquote(quote) {
      return "<blockquote>\n" + quote + "</blockquote>\n";
    };
    _proto.html = function html(_html) {
      return _html;
    }

    /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */;
    _proto.heading = function heading(text, level, raw, slugger) {
      if (this.options.headerIds) {
        var id = this.options.headerPrefix + slugger.slug(raw);
        return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
      }

      // ignore IDs
      return "<h" + level + ">" + text + "</h" + level + ">\n";
    };
    _proto.hr = function hr() {
      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };
    _proto.list = function list(body, ordered, start) {
      var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    }

    /**
     * @param {string} text
     */;
    _proto.listitem = function listitem(text) {
      return "<li>" + text + "</li>\n";
    };
    _proto.checkbox = function checkbox(checked) {
      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
    }

    /**
     * @param {string} text
     */;
    _proto.paragraph = function paragraph(text) {
      return "<p>" + text + "</p>\n";
    }

    /**
     * @param {string} header
     * @param {string} body
     */;
    _proto.table = function table(header, body) {
      if (body) body = "<tbody>" + body + "</tbody>";
      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
    }

    /**
     * @param {string} content
     */;
    _proto.tablerow = function tablerow(content) {
      return "<tr>\n" + content + "</tr>\n";
    };
    _proto.tablecell = function tablecell(content, flags) {
      var type = flags.header ? 'th' : 'td';
      var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
      return tag + content + ("</" + type + ">\n");
    }

    /**
     * span level renderer
     * @param {string} text
     */;
    _proto.strong = function strong(text) {
      return "<strong>" + text + "</strong>";
    }

    /**
     * @param {string} text
     */;
    _proto.em = function em(text) {
      return "<em>" + text + "</em>";
    }

    /**
     * @param {string} text
     */;
    _proto.codespan = function codespan(text) {
      return "<code>" + text + "</code>";
    };
    _proto.br = function br() {
      return this.options.xhtml ? '<br/>' : '<br>';
    }

    /**
     * @param {string} text
     */;
    _proto.del = function del(text) {
      return "<del>" + text + "</del>";
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.link = function link(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = '<a href="' + href + '"';
      if (title) {
        out += ' title="' + title + '"';
      }
      out += '>' + text + '</a>';
      return out;
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.image = function image(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
      if (title) {
        out += " title=\"" + title + "\"";
      }
      out += this.options.xhtml ? '/>' : '>';
      return out;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    return Renderer;
  }();

  /**
   * TextRenderer
   * returns only the textual part of the token
   */
  var TextRenderer = /*#__PURE__*/function () {
    function TextRenderer() {}
    var _proto = TextRenderer.prototype;
    // no need for block level renderers
    _proto.strong = function strong(text) {
      return text;
    };
    _proto.em = function em(text) {
      return text;
    };
    _proto.codespan = function codespan(text) {
      return text;
    };
    _proto.del = function del(text) {
      return text;
    };
    _proto.html = function html(text) {
      return text;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    _proto.link = function link(href, title, text) {
      return '' + text;
    };
    _proto.image = function image(href, title, text) {
      return '' + text;
    };
    _proto.br = function br() {
      return '';
    };
    return TextRenderer;
  }();

  /**
   * Slugger generates header id
   */
  var Slugger = /*#__PURE__*/function () {
    function Slugger() {
      this.seen = {};
    }

    /**
     * @param {string} value
     */
    var _proto = Slugger.prototype;
    _proto.serialize = function serialize(value) {
      return value.toLowerCase().trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
    }

    /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */;
    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
      var slug = originalSlug;
      var occurenceAccumulator = 0;
      if (this.seen.hasOwnProperty(slug)) {
        occurenceAccumulator = this.seen[originalSlug];
        do {
          occurenceAccumulator++;
          slug = originalSlug + '-' + occurenceAccumulator;
        } while (this.seen.hasOwnProperty(slug));
      }
      if (!isDryRun) {
        this.seen[originalSlug] = occurenceAccumulator;
        this.seen[slug] = 0;
      }
      return slug;
    }

    /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */;
    _proto.slug = function slug(value, options) {
      if (options === void 0) {
        options = {};
      }
      var slug = this.serialize(value);
      return this.getNextSafeSlug(slug, options.dryrun);
    };
    return Slugger;
  }();

  /**
   * Parsing & Compiling
   */
  var Parser = /*#__PURE__*/function () {
    function Parser(options) {
      this.options = options || exports.defaults;
      this.options.renderer = this.options.renderer || new Renderer();
      this.renderer = this.options.renderer;
      this.renderer.options = this.options;
      this.textRenderer = new TextRenderer();
      this.slugger = new Slugger();
    }

    /**
     * Static Parse Method
     */
    Parser.parse = function parse(tokens, options) {
      var parser = new Parser(options);
      return parser.parse(tokens);
    }

    /**
     * Static Parse Inline Method
     */;
    Parser.parseInline = function parseInline(tokens, options) {
      var parser = new Parser(options);
      return parser.parseInline(tokens);
    }

    /**
     * Parse Loop
     */;
    var _proto = Parser.prototype;
    _proto.parse = function parse(tokens, top) {
      if (top === void 0) {
        top = true;
      }
      var out = '',
        i,
        j,
        k,
        l2,
        l3,
        row,
        cell,
        header,
        body,
        token,
        ordered,
        start,
        loose,
        itemBody,
        item,
        checked,
        task,
        checkbox,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'space':
            {
              continue;
            }
          case 'hr':
            {
              out += this.renderer.hr();
              continue;
            }
          case 'heading':
            {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }
          case 'code':
            {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }
          case 'table':
            {
              header = '';

              // header
              cell = '';
              l2 = token.header.length;
              for (j = 0; j < l2; j++) {
                cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                  header: true,
                  align: token.align[j]
                });
              }
              header += this.renderer.tablerow(cell);
              body = '';
              l2 = token.rows.length;
              for (j = 0; j < l2; j++) {
                row = token.rows[j];
                cell = '';
                l3 = row.length;
                for (k = 0; k < l3; k++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                    header: false,
                    align: token.align[k]
                  });
                }
                body += this.renderer.tablerow(cell);
              }
              out += this.renderer.table(header, body);
              continue;
            }
          case 'blockquote':
            {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }
          case 'list':
            {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l2 = token.items.length;
              body = '';
              for (j = 0; j < l2; j++) {
                item = token.items[j];
                checked = item.checked;
                task = item.task;
                itemBody = '';
                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);
                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: 'text',
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }
                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }
              out += this.renderer.list(body, ordered, start);
              continue;
            }
          case 'html':
            {
              // TODO parse inline content if parameter markdown=1
              out += this.renderer.html(token.text);
              continue;
            }
          case 'paragraph':
            {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }
          case 'text':
            {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;
              while (i + 1 < l && tokens[i + 1].type === 'text') {
                token = tokens[++i];
                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }
              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    }

    /**
     * Parse Inline Tokens
     */;
    _proto.parseInline = function parseInline(tokens, renderer) {
      renderer = renderer || this.renderer;
      var out = '',
        i,
        token,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'escape':
            {
              out += renderer.text(token.text);
              break;
            }
          case 'html':
            {
              out += renderer.html(token.text);
              break;
            }
          case 'link':
            {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }
          case 'image':
            {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }
          case 'strong':
            {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'em':
            {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'codespan':
            {
              out += renderer.codespan(token.text);
              break;
            }
          case 'br':
            {
              out += renderer.br();
              break;
            }
          case 'del':
            {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'text':
            {
              out += renderer.text(token.text);
              break;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    };
    return Parser;
  }();

  var Hooks = /*#__PURE__*/function () {
    function Hooks(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Hooks.prototype;
    /**
     * Process markdown before marked
     */
    _proto.preprocess = function preprocess(markdown) {
      return markdown;
    }

    /**
     * Process HTML after marked is finished
     */;
    _proto.postprocess = function postprocess(html) {
      return html;
    };
    return Hooks;
  }();
  Hooks.passThroughHooks = new Set(['preprocess', 'postprocess']);

  function onError(silent, async, callback) {
    return function (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if (silent) {
        var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
        if (async) {
          return Promise.resolve(msg);
        }
        if (callback) {
          callback(null, msg);
          return;
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      if (callback) {
        callback(e);
        return;
      }
      throw e;
    };
  }
  function parseMarkdown(lexer, parser) {
    return function (src, opt, callback) {
      if (typeof opt === 'function') {
        callback = opt;
        opt = null;
      }
      var origOpt = _extends({}, opt);
      opt = _extends({}, marked.defaults, origOpt);
      var throwError = onError(opt.silent, opt.async, callback);

      // throw error in case of non string input
      if (typeof src === 'undefined' || src === null) {
        return throwError(new Error('marked(): input parameter is undefined or null'));
      }
      if (typeof src !== 'string') {
        return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
      }
      checkSanitizeDeprecation(opt);
      if (opt.hooks) {
        opt.hooks.options = opt;
      }
      if (callback) {
        var highlight = opt.highlight;
        var tokens;
        try {
          if (opt.hooks) {
            src = opt.hooks.preprocess(src);
          }
          tokens = lexer(src, opt);
        } catch (e) {
          return throwError(e);
        }
        var done = function done(err) {
          var out;
          if (!err) {
            try {
              if (opt.walkTokens) {
                marked.walkTokens(tokens, opt.walkTokens);
              }
              out = parser(tokens, opt);
              if (opt.hooks) {
                out = opt.hooks.postprocess(out);
              }
            } catch (e) {
              err = e;
            }
          }
          opt.highlight = highlight;
          return err ? throwError(err) : callback(null, out);
        };
        if (!highlight || highlight.length < 3) {
          return done();
        }
        delete opt.highlight;
        if (!tokens.length) return done();
        var pending = 0;
        marked.walkTokens(tokens, function (token) {
          if (token.type === 'code') {
            pending++;
            setTimeout(function () {
              highlight(token.text, token.lang, function (err, code) {
                if (err) {
                  return done(err);
                }
                if (code != null && code !== token.text) {
                  token.text = code;
                  token.escaped = true;
                }
                pending--;
                if (pending === 0) {
                  done();
                }
              });
            }, 0);
          }
        });
        if (pending === 0) {
          done();
        }
        return;
      }
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function (src) {
          return lexer(src, opt);
        }).then(function (tokens) {
          return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function () {
            return tokens;
          }) : tokens;
        }).then(function (tokens) {
          return parser(tokens, opt);
        }).then(function (html) {
          return opt.hooks ? opt.hooks.postprocess(html) : html;
        })["catch"](throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        var _tokens = lexer(src, opt);
        if (opt.walkTokens) {
          marked.walkTokens(_tokens, opt.walkTokens);
        }
        var html = parser(_tokens, opt);
        if (opt.hooks) {
          html = opt.hooks.postprocess(html);
        }
        return html;
      } catch (e) {
        return throwError(e);
      }
    };
  }

  /**
   * Marked
   */
  function marked(src, opt, callback) {
    return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    marked.defaults = _extends({}, marked.defaults, opt);
    changeDefaults(marked.defaults);
    return marked;
  };
  marked.getDefaults = getDefaults;
  marked.defaults = exports.defaults;

  /**
   * Use Extension
   */

  marked.use = function () {
    var extensions = marked.defaults.extensions || {
      renderers: {},
      childTokens: {}
    };
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    args.forEach(function (pack) {
      // copy options to new object
      var opts = _extends({}, pack);

      // set async to true if it was set to true before
      opts.async = marked.defaults.async || opts.async || false;

      // ==-- Parse "addon" extensions --== //
      if (pack.extensions) {
        pack.extensions.forEach(function (ext) {
          if (!ext.name) {
            throw new Error('extension name required');
          }
          if (ext.renderer) {
            // Renderer extensions
            var prevRenderer = extensions.renderers[ext.name];
            if (prevRenderer) {
              // Replace extension with func to run new extension but fall back if false
              extensions.renderers[ext.name] = function () {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }
                var ret = ext.renderer.apply(this, args);
                if (ret === false) {
                  ret = prevRenderer.apply(this, args);
                }
                return ret;
              };
            } else {
              extensions.renderers[ext.name] = ext.renderer;
            }
          }
          if (ext.tokenizer) {
            // Tokenizer Extensions
            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
              throw new Error("extension level must be 'block' or 'inline'");
            }
            if (extensions[ext.level]) {
              extensions[ext.level].unshift(ext.tokenizer);
            } else {
              extensions[ext.level] = [ext.tokenizer];
            }
            if (ext.start) {
              // Function to check for start of token
              if (ext.level === 'block') {
                if (extensions.startBlock) {
                  extensions.startBlock.push(ext.start);
                } else {
                  extensions.startBlock = [ext.start];
                }
              } else if (ext.level === 'inline') {
                if (extensions.startInline) {
                  extensions.startInline.push(ext.start);
                } else {
                  extensions.startInline = [ext.start];
                }
              }
            }
          }
          if (ext.childTokens) {
            // Child tokens to be visited by walkTokens
            extensions.childTokens[ext.name] = ext.childTokens;
          }
        });
        opts.extensions = extensions;
      }

      // ==-- Parse "overwrite" extensions --== //
      if (pack.renderer) {
        (function () {
          var renderer = marked.defaults.renderer || new Renderer();
          var _loop = function _loop(prop) {
            var prevRenderer = renderer[prop];
            // Replace renderer with func to run extension, but fall back if false
            renderer[prop] = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              var ret = pack.renderer[prop].apply(renderer, args);
              if (ret === false) {
                ret = prevRenderer.apply(renderer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.renderer) {
            _loop(prop);
          }
          opts.renderer = renderer;
        })();
      }
      if (pack.tokenizer) {
        (function () {
          var tokenizer = marked.defaults.tokenizer || new Tokenizer();
          var _loop2 = function _loop2(prop) {
            var prevTokenizer = tokenizer[prop];
            // Replace tokenizer with func to run extension, but fall back if false
            tokenizer[prop] = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              var ret = pack.tokenizer[prop].apply(tokenizer, args);
              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.tokenizer) {
            _loop2(prop);
          }
          opts.tokenizer = tokenizer;
        })();
      }

      // ==-- Parse Hooks extensions --== //
      if (pack.hooks) {
        (function () {
          var hooks = marked.defaults.hooks || new Hooks();
          var _loop3 = function _loop3(prop) {
            var prevHook = hooks[prop];
            if (Hooks.passThroughHooks.has(prop)) {
              hooks[prop] = function (arg) {
                if (marked.defaults.async) {
                  return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function (ret) {
                    return prevHook.call(hooks, ret);
                  });
                }
                var ret = pack.hooks[prop].call(hooks, arg);
                return prevHook.call(hooks, ret);
              };
            } else {
              hooks[prop] = function () {
                for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }
                var ret = pack.hooks[prop].apply(hooks, args);
                if (ret === false) {
                  ret = prevHook.apply(hooks, args);
                }
                return ret;
              };
            }
          };
          for (var prop in pack.hooks) {
            _loop3(prop);
          }
          opts.hooks = hooks;
        })();
      }

      // ==-- Parse WalkTokens extensions --== //
      if (pack.walkTokens) {
        var _walkTokens = marked.defaults.walkTokens;
        opts.walkTokens = function (token) {
          var values = [];
          values.push(pack.walkTokens.call(this, token));
          if (_walkTokens) {
            values = values.concat(_walkTokens.call(this, token));
          }
          return values;
        };
      }
      marked.setOptions(opts);
    });
  };

  /**
   * Run callback for every token
   */

  marked.walkTokens = function (tokens, callback) {
    var values = [];
    var _loop4 = function _loop4() {
      var token = _step.value;
      values = values.concat(callback.call(marked, token));
      switch (token.type) {
        case 'table':
          {
            for (var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;) {
              var cell = _step2.value;
              values = values.concat(marked.walkTokens(cell.tokens, callback));
            }
            for (var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;) {
              var row = _step3.value;
              for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
                var _cell = _step4.value;
                values = values.concat(marked.walkTokens(_cell.tokens, callback));
              }
            }
            break;
          }
        case 'list':
          {
            values = values.concat(marked.walkTokens(token.items, callback));
            break;
          }
        default:
          {
            if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) {
              // Walk any extensions
              marked.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
                values = values.concat(marked.walkTokens(token[childTokens], callback));
              });
            } else if (token.tokens) {
              values = values.concat(marked.walkTokens(token.tokens, callback));
            }
          }
      }
    };
    for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
      _loop4();
    }
    return values;
  };

  /**
   * Parse Inline
   * @param {string} src
   */
  marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);

  /**
   * Expose
   */
  marked.Parser = Parser;
  marked.parser = Parser.parse;
  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;
  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;
  marked.Tokenizer = Tokenizer;
  marked.Slugger = Slugger;
  marked.Hooks = Hooks;
  marked.parse = marked;
  var options = marked.options;
  var setOptions = marked.setOptions;
  var use = marked.use;
  var walkTokens = marked.walkTokens;
  var parseInline = marked.parseInline;
  var parse = marked;
  var parser = Parser.parse;
  var lexer = Lexer.lex;

  exports.Hooks = Hooks;
  exports.Lexer = Lexer;
  exports.Parser = Parser;
  exports.Renderer = Renderer;
  exports.Slugger = Slugger;
  exports.TextRenderer = TextRenderer;
  exports.Tokenizer = Tokenizer;
  exports.getDefaults = getDefaults;
  exports.lexer = lexer;
  exports.marked = marked;
  exports.options = options;
  exports.parse = parse;
  exports.parseInline = parseInline;
  exports.parser = parser;
  exports.setOptions = setOptions;
  exports.use = use;
  exports.walkTokens = walkTokens;

}));

},{}],134:[function(require,module,exports){
'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;

},{}],135:[function(require,module,exports){
'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;

},{}],136:[function(require,module,exports){
'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

},{}],137:[function(require,module,exports){
'use strict';

/** @type {import('./max')} */
module.exports = Math.max;

},{}],138:[function(require,module,exports){
'use strict';

/** @type {import('./min')} */
module.exports = Math.min;

},{}],139:[function(require,module,exports){
'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;

},{}],140:[function(require,module,exports){
'use strict';

/** @type {import('./round')} */
module.exports = Math.round;

},{}],141:[function(require,module,exports){
'use strict';

var $isNaN = require('./isNaN');

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};

},{"./isNaN":136}],142:[function(require,module,exports){
!function(t,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define("Navigo",[],n):"object"==typeof exports?exports.Navigo=n():t.Navigo=n()}("undefined"!=typeof self?self:this,(function(){return function(){"use strict";var t={407:function(t,n,e){e.d(n,{default:function(){return N}});var o=/([:*])(\w+)/g,r=/\*/g,i=/\/\?/g;function a(t){return void 0===t&&(t="/"),v()?location.pathname+location.search+location.hash:t}function s(t){return t.replace(/\/+$/,"").replace(/^\/+/,"")}function c(t){return"string"==typeof t}function u(t){return t&&t.indexOf("#")>=0&&t.split("#").pop()||""}function h(t){var n=s(t).split(/\?(.*)?$/);return[s(n[0]),n.slice(1).join("")]}function f(t){for(var n={},e=t.split("&"),o=0;o<e.length;o++){var r=e[o].split("=");if(""!==r[0]){var i=decodeURIComponent(r[0]);n[i]?(Array.isArray(n[i])||(n[i]=[n[i]]),n[i].push(decodeURIComponent(r[1]||""))):n[i]=decodeURIComponent(r[1]||"")}}return n}function l(t,n){var e,a=h(s(t.currentLocationPath)),l=a[0],p=a[1],d=""===p?null:f(p),v=[];if(c(n.path)){if(e="(?:/^|^)"+s(n.path).replace(o,(function(t,n,e){return v.push(e),"([^/]+)"})).replace(r,"?(?:.*)").replace(i,"/?([^/]+|)")+"$",""===s(n.path)&&""===s(l))return{url:l,queryString:p,hashString:u(t.to),route:n,data:null,params:d}}else e=n.path;var g=new RegExp(e,""),m=l.match(g);if(m){var y=c(n.path)?function(t,n){return 0===n.length?null:t?t.slice(1,t.length).reduce((function(t,e,o){return null===t&&(t={}),t[n[o]]=decodeURIComponent(e),t}),null):null}(m,v):m.groups?m.groups:m.slice(1);return{url:s(l.replace(new RegExp("^"+t.instance.root),"")),queryString:p,hashString:u(t.to),route:n,data:y,params:d}}return!1}function p(){return!("undefined"==typeof window||!window.history||!window.history.pushState)}function d(t,n){return void 0===t[n]||!0===t[n]}function v(){return"undefined"!=typeof window}function g(t,n){return void 0===t&&(t=[]),void 0===n&&(n={}),t.filter((function(t){return t})).forEach((function(t){["before","after","already","leave"].forEach((function(e){t[e]&&(n[e]||(n[e]=[]),n[e].push(t[e]))}))})),n}function m(t,n,e){var o=n||{},r=0;!function n(){t[r]?Array.isArray(t[r])?(t.splice.apply(t,[r,1].concat(t[r][0](o)?t[r][1]:t[r][2])),n()):t[r](o,(function(t){void 0===t||!0===t?(r+=1,n()):e&&e(o)})):e&&e(o)}()}function y(t,n){void 0===t.currentLocationPath&&(t.currentLocationPath=t.to=a(t.instance.root)),t.currentLocationPath=t.instance._checkForAHash(t.currentLocationPath),n()}function _(t,n){for(var e=0;e<t.instance.routes.length;e++){var o=l(t,t.instance.routes[e]);if(o&&(t.matches||(t.matches=[]),t.matches.push(o),"ONE"===t.resolveOptions.strategy))return void n()}n()}function k(t,n){t.navigateOptions&&(void 0!==t.navigateOptions.shouldResolve&&console.warn('"shouldResolve" is deprecated. Please check the documentation.'),void 0!==t.navigateOptions.silent&&console.warn('"silent" is deprecated. Please check the documentation.')),n()}function O(t,n){!0===t.navigateOptions.force?(t.instance._setCurrent([t.instance._pathToMatchObject(t.to)]),n(!1)):n()}m.if=function(t,n,e){return Array.isArray(n)||(n=[n]),Array.isArray(e)||(e=[e]),[t,n,e]};var w=v(),L=p();function b(t,n){if(d(t.navigateOptions,"updateBrowserURL")){var e=("/"+t.to).replace(/\/\//g,"/"),o=w&&t.resolveOptions&&!0===t.resolveOptions.hash;L?(history[t.navigateOptions.historyAPIMethod||"pushState"](t.navigateOptions.stateObj||{},t.navigateOptions.title||"",o?"#"+e:e),location&&location.hash&&(t.instance.__freezeListening=!0,setTimeout((function(){if(!o){var n=location.hash;location.hash="",location.hash=n}t.instance.__freezeListening=!1}),1))):w&&(window.location.href=t.to)}n()}function A(t,n){var e=t.instance;e.lastResolved()?m(e.lastResolved().map((function(n){return function(e,o){if(n.route.hooks&&n.route.hooks.leave){var r=!1,i=t.instance.matchLocation(n.route.path,t.currentLocationPath,!1);r="*"!==n.route.path?!i:!(t.matches&&t.matches.find((function(t){return n.route.path===t.route.path}))),d(t.navigateOptions,"callHooks")&&r?m(n.route.hooks.leave.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.matches&&t.matches.length>0?1===t.matches.length?t.matches[0]:t.matches:void 0)}})).concat([function(){return o()}])):o()}else o()}})),{},(function(){return n()})):n()}function P(t,n){d(t.navigateOptions,"updateState")&&t.instance._setCurrent(t.matches),n()}var R=[function(t,n){var e=t.instance.lastResolved();if(e&&e[0]&&e[0].route===t.match.route&&e[0].url===t.match.url&&e[0].queryString===t.match.queryString)return e.forEach((function(n){n.route.hooks&&n.route.hooks.already&&d(t.navigateOptions,"callHooks")&&n.route.hooks.already.forEach((function(n){return n(t.match)}))})),void n(!1);n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.before&&d(t.navigateOptions,"callHooks")?m(t.match.route.hooks.before.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.match)}})).concat([function(){return n()}])):n()},function(t,n){d(t.navigateOptions,"callHandler")&&t.match.route.handler(t.match),t.instance.updatePageLinks(),n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.after&&d(t.navigateOptions,"callHooks")&&t.match.route.hooks.after.forEach((function(n){return n(t.match)})),n()}],S=[A,function(t,n){var e=t.instance._notFoundRoute;if(e){t.notFoundHandled=!0;var o=h(t.currentLocationPath),r=o[0],i=o[1],a=u(t.to);e.path=s(r);var c={url:e.path,queryString:i,hashString:a,data:null,route:e,params:""!==i?f(i):null};t.matches=[c],t.match=c}n()},m.if((function(t){return t.notFoundHandled}),R.concat([P]),[function(t,n){t.resolveOptions&&!1!==t.resolveOptions.noMatchWarning&&void 0!==t.resolveOptions.noMatchWarning||console.warn('Navigo: "'+t.currentLocationPath+"\" didn't match any of the registered routes."),n()},function(t,n){t.instance._setCurrent(null),n()}])];function E(){return(E=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}function x(t,n){var e=0;A(t,(function o(){e!==t.matches.length?m(R,E({},t,{match:t.matches[e]}),(function(){e+=1,o()})):P(t,n)}))}function H(t){t.instance.__markAsClean(t)}function j(){return(j=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}var C="[data-navigo]";function N(t,n){var e,o=n||{strategy:"ONE",hash:!1,noMatchWarning:!1,linksSelector:C},r=this,i="/",d=null,w=[],L=!1,A=p(),P=v();function R(t){return t.indexOf("#")>=0&&(t=!0===o.hash?t.split("#")[1]||"/":t.split("#")[0]),t}function E(t){return s(i+"/"+s(t))}function N(t,n,e,o){return t=c(t)?E(t):t,{name:o||s(String(t)),path:t,handler:n,hooks:g(e)}}function U(t,n){if(!r.__dirty){r.__dirty=!0,t=t?s(i)+"/"+s(t):void 0;var e={instance:r,to:t,currentLocationPath:t,navigateOptions:{},resolveOptions:j({},o,n)};return m([y,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S)],e,H),!!e.matches&&e.matches}r.__waiting.push((function(){return r.resolve(t,n)}))}function q(t,n){if(r.__dirty)r.__waiting.push((function(){return r.navigate(t,n)}));else{r.__dirty=!0,t=s(i)+"/"+s(t);var e={instance:r,to:t,navigateOptions:n||{},resolveOptions:n&&n.resolveOptions?n.resolveOptions:o,currentLocationPath:R(t)};m([k,O,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S),b,H],e,H)}}function F(){if(P)return(P?[].slice.call(document.querySelectorAll(o.linksSelector||C)):[]).forEach((function(t){"false"!==t.getAttribute("data-navigo")&&"_blank"!==t.getAttribute("target")?t.hasListenerAttached||(t.hasListenerAttached=!0,t.navigoHandler=function(n){if((n.ctrlKey||n.metaKey)&&"a"===n.target.tagName.toLowerCase())return!1;var e=t.getAttribute("href");if(null==e)return!1;if(e.match(/^(http|https)/)&&"undefined"!=typeof URL)try{var o=new URL(e);e=o.pathname+o.search}catch(t){}var i=function(t){if(!t)return{};var n,e=t.split(","),o={};return e.forEach((function(t){var e=t.split(":").map((function(t){return t.replace(/(^ +| +$)/g,"")}));switch(e[0]){case"historyAPIMethod":o.historyAPIMethod=e[1];break;case"resolveOptionsStrategy":n||(n={}),n.strategy=e[1];break;case"resolveOptionsHash":n||(n={}),n.hash="true"===e[1];break;case"updateBrowserURL":case"callHandler":case"updateState":case"force":o[e[0]]="true"===e[1]}})),n&&(o.resolveOptions=n),o}(t.getAttribute("data-navigo-options"));L||(n.preventDefault(),n.stopPropagation(),r.navigate(s(e),i))},t.addEventListener("click",t.navigoHandler)):t.hasListenerAttached&&t.removeEventListener("click",t.navigoHandler)})),r}function I(t,n,e){var o=w.find((function(n){return n.name===t})),r=null;if(o){if(r=o.path,n)for(var a in n)r=r.replace(":"+a,n[a]);r=r.match(/^\//)?r:"/"+r}return r&&e&&!e.includeRoot&&(r=r.replace(new RegExp("^/"+i),"")),r}function M(t){var n=h(s(t)),o=n[0],r=n[1],i=""===r?null:f(r);return{url:o,queryString:r,hashString:u(t),route:N(o,(function(){}),[e],o),data:null,params:i}}function T(t,n,e){return"string"==typeof n&&(n=z(n)),n?(n.hooks[t]||(n.hooks[t]=[]),n.hooks[t].push(e),function(){n.hooks[t]=n.hooks[t].filter((function(t){return t!==e}))}):(console.warn("Route doesn't exists: "+n),function(){})}function z(t){return"string"==typeof t?w.find((function(n){return n.name===E(t)})):w.find((function(n){return n.handler===t}))}t?i=s(t):console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'),this.root=i,this.routes=w,this.destroyed=L,this.current=d,this.__freezeListening=!1,this.__waiting=[],this.__dirty=!1,this.__markAsClean=function(t){t.instance.__dirty=!1,t.instance.__waiting.length>0&&t.instance.__waiting.shift()()},this.on=function(t,n,o){var r=this;return"object"!=typeof t||t instanceof RegExp?("function"==typeof t&&(o=n,n=t,t=i),w.push(N(t,n,[e,o])),this):(Object.keys(t).forEach((function(n){if("function"==typeof t[n])r.on(n,t[n]);else{var o=t[n],i=o.uses,a=o.as,s=o.hooks;w.push(N(n,i,[e,s],a))}})),this)},this.off=function(t){return this.routes=w=w.filter((function(n){return c(t)?s(n.path)!==s(t):"function"==typeof t?t!==n.handler:String(n.path)!==String(t)})),this},this.resolve=U,this.navigate=q,this.navigateByName=function(t,n,e){var o=I(t,n);return null!==o&&(q(o.replace(new RegExp("^/?"+i),""),e),!0)},this.destroy=function(){this.routes=w=[],A&&window.removeEventListener("popstate",this.__popstateListener),this.destroyed=L=!0},this.notFound=function(t,n){return r._notFoundRoute=N("*",t,[e,n],"__NOT_FOUND__"),this},this.updatePageLinks=F,this.link=function(t){return"/"+i+"/"+s(t)},this.hooks=function(t){return e=t,this},this.extractGETParameters=function(t){return h(R(t))},this.lastResolved=function(){return d},this.generate=I,this.getLinkPath=function(t){return t.getAttribute("href")},this.match=function(t){var n={instance:r,currentLocationPath:t,to:t,navigateOptions:{},resolveOptions:o};return _(n,(function(){})),!!n.matches&&n.matches},this.matchLocation=function(t,n,e){void 0===n||void 0!==e&&!e||(n=E(n));var o={instance:r,to:n,currentLocationPath:n};return y(o,(function(){})),"string"==typeof t&&(t=void 0===e||e?E(t):t),l(o,{name:String(t),path:t,handler:function(){},hooks:{}})||!1},this.getCurrentLocation=function(){return M(s(a(i)).replace(new RegExp("^"+i),""))},this.addBeforeHook=T.bind(this,"before"),this.addAfterHook=T.bind(this,"after"),this.addAlreadyHook=T.bind(this,"already"),this.addLeaveHook=T.bind(this,"leave"),this.getRoute=z,this._pathToMatchObject=M,this._clean=s,this._checkForAHash=R,this._setCurrent=function(t){return d=r.current=t},function(){A&&(this.__popstateListener=function(){r.__freezeListening||U()},window.addEventListener("popstate",this.__popstateListener))}.call(this),F.call(this)}}},n={};function e(o){if(n[o])return n[o].exports;var r=n[o]={exports:{}};return t[o](r,r.exports,e),r.exports}return e.d=function(t,n){for(var o in n)e.o(n,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:n[o]})},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e(407)}().default}));

},{}],143:[function(require,module,exports){
(function (global){(function (){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require('./util.inspect');
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./util.inspect":18}],144:[function(require,module,exports){
var wrappy = require('wrappy')
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}

},{"wrappy":548}],145:[function(require,module,exports){
(function (process){(function (){
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;

}).call(this)}).call(this,require('_process'))

},{"_process":439}],146:[function(require,module,exports){
module.exports={
    "name": "pict-application",
    "version": "1.0.34",
    "description": "Application base class for a pict view-based application",
    "main": "source/Pict-Application.js",
    "scripts": {
        "test": "npx quack test",
        "start": "node source/Pict-Application.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-application-image:local",
        "docker-dev-run": "docker run -it -d --name pict-application-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-application\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-application-image:local",
        "docker-dev-shell": "docker exec -it pict-application-dev /bin/bash",
        "tests": "npx quack test -g",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Application.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-application.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-application/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-application#readme",
    "devDependencies": {
        "@eslint/js": "^9.28.0",
        "browser-env": "^3.3.0",
        "eslint": "^9.28.0",
        "pict": "^1.0.348",
        "pict-docuserve": "^0.1.5",
        "pict-provider": "^1.0.10",
        "pict-view": "^1.0.66",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],147:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase')

const libPackage = require('../package.json');

const defaultPictSettings = (
	{
		Name: 'DefaultPictApplication',

		// The main "viewport" is the view that is used to host our application
		MainViewportViewIdentifier: 'Default-View',
		MainViewportRenderableHash: false,
		MainViewportDestinationAddress: false,
		MainViewportDefaultDataAddress: false,

		// Whether or not we should automatically render the main viewport and other autorender views after we initialize the pict application
		AutoSolveAfterInitialize: true,
		AutoRenderMainViewportViewAfterInitialize: true,
		AutoRenderViewsAfterInitialize: false,
		AutoLoginAfterInitialize: false,
		AutoLoadDataAfterLogin: false,

		ConfigurationOnlyViews: [],

		Manifests: {},
		// The prefix to prepend on all template destination hashes
		IdentifierAddressPrefix: 'PICT-'
	});

/**
 * Base class for pict applications.
 */
class PictApplication extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpCarryOverConfiguration = (typeof(pFable.settings.PictApplicationConfiguration) === 'object') ? pFable.settings.PictApplicationConfiguration : {};
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictSettings)), tmpCarryOverConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;
		/** @type {import('pict') & import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;
		/**
		 * @type {{ [key: string]: any }}
		 */
		this.servicesMap;

		this.serviceType = 'PictApplication';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;
		// Wire in the essential Pict state
		/** @type {Record<string, any>} */
		this.AppData = this.fable.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.fable.Bundle;

		/** @type {number} */
		this.initializeTimestamp;
		/** @type {number} */
		this.lastSolvedTimestamp;
		/** @type {number} */
		this.lastLoginTimestamp;
		/** @type {number} */
		this.lastMarshalFromViewsTimestamp;
		/** @type {number} */
		this.lastMarshalToViewsTimestamp;
		/** @type {number} */
		this.lastAutoRenderTimestamp;
		/** @type {number} */
		this.lastLoadDataTimestamp;

		// Load all the manifests for the application
		let tmpManifestKeys = Object.keys(this.options.Manifests);
		if (tmpManifestKeys.length > 0)
		{
			for (let i = 0; i < tmpManifestKeys.length; i++)
			{
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.fable.instantiateServiceProvider('Manifest', this.options.Manifests[tmpManifestKey], tmpManifestKey);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Solve All Views                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onPreSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing solve() function...`)
		}

		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpProvidersToSolve[i].solve(tmpProvidersToSolve[i]);
		}

		this.onBeforeSolve();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoInitialize)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpViewsToSolve[i].solve();
		}
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));


		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}
		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpProvidersToSolve[i].solveAsync.bind(tmpProvidersToSolve[i]));
		}

		// Walk through any loaded views and solve them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoSolveWithApp)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToSolve[i].solveAsync.bind(tmpViewsToSolve[i]));
		}

		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application Login                        */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loginAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterLoginAsync.bind(this));

		// check and see if we should automatically trigger a data load
		if (this.options.AutoLoadDataAfterLogin)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				if (!this.isLoggedIn())
				{
					return fNext();
				}
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto loading data after login...`);
				}
				//TODO: should data load errors funnel here? this creates a weird coupling between login and data load callbacks
				this.loadDataAsync((pError) =>
				{
					fNext(pError);
				});
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync() complete.`);
				}
				this.lastLoginTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Check if the application state is logged in. Defaults to true. Override this method in your application based on login requirements.
	 *
	 * @return {boolean}
	 */
	isLoggedIn()
	{
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoginAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application LoadData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loadDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoadDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToLoadData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoLoadDataWithApp)
			{
				tmpProvidersToLoadData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToLoadData.sort((a, b) => { return a.options.AutoLoadDataOrdinal - b.options.AutoLoadDataOrdinal; });

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onLoadDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterLoadDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync() complete.`);
				}
				this.lastLoadDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoadDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application SaveData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	saveDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSaveDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSaveData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSaveDataWithApp)
			{
				tmpProvidersToSaveData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSaveData.sort((a, b) => { return a.options.AutoSaveDataOrdinal - b.options.AutoSaveDataOrdinal; });

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onSaveDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterSaveDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync() complete.`);
				}
				this.lastSaveDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSaveDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Initialize Application                   */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			this.onInitialize();

			// Walk through any loaded providers and initialize them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpProvidersToInitialize[i].initialize();
			}

			// Now walk through any loaded views and initialize them as well.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				tmpViewsToInitialize[i].initialize();
			}

			this.onAfterInitialize();
			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving after initialization...`);
				}
				// Solve the template synchronously
				this.solve();
			}
			// Now check and see if we should automatically render as well
			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering after initialization...`);
				}
				// Render the template synchronously
				this.render();
			}
			this.initializeTimestamp = this.fable.log.getTimeStamp();
			this.onCompletionOfInitialize();
			return true;
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync:`);
		}

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning initialization...`);
			}

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));

			// Walk through any loaded providers and solve them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpAnticipate.anticipate(tmpProvidersToInitialize[i].initializeAsync.bind(tmpProvidersToInitialize[i]));
			}

			// Now walk through any loaded views and initialize them as well.
			// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority
			// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				let tmpView = tmpViewsToInitialize[i];
				tmpAnticipate.anticipate(tmpView.initializeAsync.bind(tmpView));
			}

			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			if (this.options.AutoLoginAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto login (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.loginAsync.bind(this));
			}

			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.solveAsync.bind(this));
			}

			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.renderMainViewportAsync.bind(this));
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Error: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.fable.log.getTimeStamp();
					if (this.pict.LogNoisiness > 2)
					{
						this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialization complete.`);
					}
					return tmpCallback();
				});
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return this.onCompletionOfInitializeAsync(tmpCallback);
		}
	}

	/**
	 * @return {boolean}
	 */
	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}


	/**
	 * @return {boolean}
	 */
	onCompletionOfInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onCompletionOfInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onCompletionOfInitializeAsync(fCallback)
	{
		this.onCompletionOfInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data From All Views              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalFromViewsAsync(fCallback)
	{
		this.onBeforeMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalFromViewsAsync(fCallback)
	{
		this.onMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalFromViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalFromViews() function...`)
		}
		this.onBeforeMarshalFromViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpViewsToMarshalFromViews[i].marshalFromView();
		}
		this.onMarshalFromViews();
		this.onAfterMarshalFromViews();
		this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalFromViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewsAsync.bind(this));
		// Walk through any loaded views and marshalFromViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalFromViews[i].marshalFromViewAsync.bind(tmpViewsToMarshalFromViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalFromViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync() complete.`);
				}
				this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalFromViewsAsync(fCallback)
	{
		this.onAfterMarshalFromViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data To All Views                */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalToViewsAsync(fCallback)
	{
		this.onBeforeMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalToViewsAsync(fCallback)
	{
		this.onMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalToViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalToViews() function...`)
		}
		this.onBeforeMarshalToViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpViewsToMarshalToViews[i].marshalToView();
		}
		this.onMarshalToViews();
		this.onAfterMarshalToViews();
		this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalToViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalToViewsAsync.bind(this));
		// Walk through any loaded views and marshalToViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalToViews[i].marshalToViewAsync.bind(tmpViewsToMarshalToViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalToViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync() complete.`);
				}
				this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalToViewsAsync(fCallback)
	{
		this.onAfterMarshalToViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Render View                              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeRenderAsync(fCallback)
	{
		this.onBeforeRender();
		return fCallback();
	}

	/**
	 * @param {string} [pViewIdentifier] - The hash of the view to render. By default, the main viewport view is rendered.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string} [pTemplateDataAddress] - The address where the data for the template is stored.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	render(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] render:`);
		}

		this.onBeforeRender();

		// Now get the view (by hash) from the loaded views
		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not render from View ${tmpViewIdentifier} because it is not a valid view.`);
			return false;
		}

		this.onRender();

		tmpView.render(tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress);

		this.onAfterRender();

		return true;
	}
	/**
	 * @return {boolean}
	 */
	onRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onRenderAsync(fCallback)
	{
		this.onRender();
		return fCallback();
	}

	/**
	 * @param {string|((error?: Error) => void)} pViewIdentifier - The hash of the view to render. By default, the main viewport view is rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderableHash] - The hash of the renderable to render. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderDestinationAddress] - The address where the renderable will be rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pTemplateDataAddress] - The address where the data for the template is stored. (or the callback)
	 * @param {(error?: Error) => void} [fCallback] - The callback, if all other parameters are provided.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	renderAsync(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress, fCallback)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateDataAddress) === 'function') ? pTemplateDataAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pViewIdentifier) === 'function') ? pViewIdentifier :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] renderAsync:`);
		}

		let tmpRenderAnticipate = this.fable.newAnticipate();

		tmpRenderAnticipate.anticipate(this.onBeforeRenderAsync.bind(this));

		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			let tmpErrorMessage = `PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not asynchronously render from View ${tmpViewIdentifier} because it is not a valid view.`;
			if (this.pict.LogNoisiness > 3)
			{
				this.log.error(tmpErrorMessage);
			}
			return tmpCallback(new Error(tmpErrorMessage));
		}

		tmpRenderAnticipate.anticipate(this.onRenderAsync.bind(this));

		tmpRenderAnticipate.anticipate(
			(fNext) =>
			{
				tmpView.renderAsync.call(tmpView, tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress, fNext);
			});

		tmpRenderAnticipate.anticipate(this.onAfterRenderAsync.bind(this));

		return tmpRenderAnticipate.wait(tmpCallback);
	}

	/**
	 * @return {boolean}
	 */
	onAfterRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterRenderAsync(fCallback)
	{
		this.onAfterRender();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	renderMainViewport()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewport:`);
		}

		return this.render();
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderMainViewportAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewportAsync:`);
		}

		return this.renderAsync(fCallback);
	}
	/**
	 * @return {void}
	 */
	renderAutoViews()
	{
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViews...`);
		}
		// Now walk through any loaded views and sort them by the AutoRender ordinal
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpView.render();
			}
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderAutoViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViewsAsync...`);
		}

		// Now walk through any loaded views and sort them by the AutoRender ordinal
		// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpAnticipate.anticipate(tmpView.renderAsync.bind(tmpView));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				this.lastAutoRenderTimestamp = this.fable.log.getTimeStamp();
				if (this.pict.LogNoisiness > 0)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
				}
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	get isPictApplication()
	{
		return true;
	}
}

module.exports = PictApplication;

},{"../package.json":146,"fable-serviceproviderbase":59}],148:[function(require,module,exports){
/**
 * GraphGeometry-Core
 *
 * Pure, dependency-free geometry math for graph canvases. No Fable, no DOM, no
 * Pict. Everything here is deterministic math over plain data, so it is trivial
 * to unit test and reuse outside pict-section-flow.
 *
 * Phase 1a of the pict-section-flow 2.0 plan extracts this verbatim from
 * source/providers/PictProvider-Flow-Geometry.js, preserving behavior exactly.
 * Later phases grow it into shape-aware anchor resolution (rectangle, ellipse,
 * diamond, polygon, stacked-rows for ERD) behind resolveAnchor(); the current
 * rectangular model stays the default.
 *
 * Port Side values (12 positions):
 *
 *   Top edge:    'top-left'     'top'     'top-right'
 *   Left edge:   'left-top'     'left'    'left-bottom'
 *   Right edge:  'right-top'    'right'   'right-bottom'
 *   Bottom edge: 'bottom-left'  'bottom'  'bottom-right'
 *
 * The old 4-value sides ('left', 'right', 'top', 'bottom') map to the middle
 * position on each edge for backward compatibility.
 */
class GraphGeometry
{
	constructor(pConfig)
	{
		let tmpConfig = pConfig || {};

		// Minimum spacing between port centers (px). Reserved padding at the
		// bottom of a node body so port badges never overlap the panel
		// indicator and always leave a gap above the bottom edge.
		this.MinPortSpacing = (typeof tmpConfig.MinPortSpacing === 'number') ? tmpConfig.MinPortSpacing : 16;
		this.PortBottomPadding = (typeof tmpConfig.PortBottomPadding === 'number') ? tmpConfig.PortBottomPadding : 16;
	}

	/**
	 * Extract the edge name from a Side value.
	 *
	 * Maps all 12 positions (and the 4 legacy values) back to the edge they sit
	 * on: 'left', 'right', 'top', or 'bottom'.
	 *
	 * @param {string} pSide - Any valid Side value
	 * @returns {string} The edge: 'left', 'right', 'top', or 'bottom'
	 */
	getEdgeFromSide(pSide)
	{
		switch (pSide)
		{
			case 'left-top':
			case 'left':
			case 'left-bottom':
				return 'left';

			case 'right-top':
			case 'right':
			case 'right-bottom':
				return 'right';

			case 'top-left':
			case 'top':
			case 'top-right':
				return 'top';

			case 'bottom-left':
			case 'bottom':
			case 'bottom-right':
				return 'bottom';

			default:
				return 'right';
		}
	}

	/**
	 * Get the outward unit direction vector for a given side.
	 *
	 * All positions on the same edge share the same direction vector.
	 *
	 * @param {string} pSide - Any valid Side value (12 positions or 4 legacy)
	 * @returns {{dx: number, dy: number}}
	 */
	sideDirection(pSide)
	{
		switch (this.getEdgeFromSide(pSide))
		{
			case 'left':   return { dx: -1, dy: 0 };
			case 'right':  return { dx: 1, dy: 0 };
			case 'top':    return { dx: 0, dy: -1 };
			case 'bottom': return { dx: 0, dy: 1 };
			default:       return { dx: 1, dy: 0 };
		}
	}

	/**
	 * Get the center point of a rectangle's edge. Works for any object with X,
	 * Y, Width, Height properties (nodes, panels, or any rectangular element).
	 *
	 * @param {Object} pRectData - Object with X, Y, Width, Height
	 * @param {string} pSide - 'left', 'right', 'top', 'bottom'
	 * @returns {{x: number, y: number}}
	 */
	getEdgeCenter(pRectData, pSide)
	{
		switch (pSide)
		{
			case 'left':
				return { x: pRectData.X, y: pRectData.Y + pRectData.Height / 2 };
			case 'right':
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
			case 'top':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y };
			case 'bottom':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y + pRectData.Height };
			default:
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
		}
	}

	/**
	 * Calculate a port's local position relative to node origin.
	 *
	 * Supports 12 positions (3 zones per edge). For left/right edges, the body
	 * area below the title bar is divided into vertical zones. For top/bottom
	 * edges, the full width is divided into horizontal zones.
	 *
	 * When pPortCountsBySide is provided, zone fractions are computed
	 * proportionally based on actual port counts (adaptive zones). Otherwise,
	 * fixed 1/3 zones are used for backward compatibility.
	 *
	 * Multiple ports sharing the same Side value distribute evenly within their
	 * zone.
	 *
	 * @param {string} pSide - Side value (any of 12 positions or 4 legacy)
	 * @param {number} pIndex - Index of this port within its Side group
	 * @param {number} pTotal - Total ports with this Side value
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pTitleBarHeight - Height of the node title bar
	 * @param {Object} [pPortCountsBySide] - Optional map of Side to port count
	 *        for all ports on the node. Enables adaptive zone sizing.
	 * @returns {{x: number, y: number}}
	 */
	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pTitleBarHeight, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZone = pPortCountsBySide
			? this._computeAdaptiveZone(pSide, pPortCountsBySide)
			: this._getZoneFromSide(pSide);

		// Use the fixed zone to decide alignment intent (start/center/end)
		// because adaptive zones shift boundaries when neighbouring zones are
		// empty, which would break alignment decisions.
		let tmpFixedZone = this._getZoneFromSide(pSide);

		// Minimum spacing between port centers (px)
		let tmpMinSpacing = this.MinPortSpacing;

		// Reserve space at the bottom of the body so that port badges never
		// overlap the panel-indicator icon (10x10 rect at bottom-right) and
		// always leave a visible gap above the node bottom edge.
		let tmpBottomPad = this.PortBottomPadding;

		// Determine alignment from the fixed zone position:
		//   start zone  (0.000 - 0.333) -> start-align (offset 0)
		//   middle zone (0.333 - 0.667) -> center
		//   end zone    (0.667 - 1.000) -> end-align
		let tmpAlignment = 'start';
		if (tmpFixedZone.start >= 0.5)
		{
			tmpAlignment = 'end';
		}
		else if (tmpFixedZone.start >= 0.17)
		{
			tmpAlignment = 'center';
		}

		if (tmpEdge === 'left' || tmpEdge === 'right')
		{
			let tmpX = (tmpEdge === 'left') ? 0 : pWidth;
			let tmpBodyHeight = pHeight - pTitleBarHeight - tmpBottomPad;
			let tmpZoneStart = pTitleBarHeight + tmpBodyHeight * tmpZone.start;
			let tmpZoneHeight = tmpBodyHeight * (tmpZone.end - tmpZone.start);

			// Use fixed spacing so port gaps stay consistent across cards even
			// when one edge drives the card height beyond what the other needs.
			let tmpSpacing = tmpMinSpacing;
			let tmpGroupHeight = tmpSpacing * (pTotal + 1);
			let tmpSlack = tmpZoneHeight - tmpGroupHeight;
			if (tmpSlack < 0)
			{
				tmpSlack = 0;
			}

			let tmpAlignOffset = 0;
			if (tmpAlignment === 'end')
			{
				tmpAlignOffset = tmpSlack;
			}
			else if (tmpAlignment === 'center')
			{
				tmpAlignOffset = tmpSlack / 2;
			}

			let tmpY = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
			return { x: tmpX, y: tmpY };
		}

		// top or bottom
		let tmpY = (tmpEdge === 'top') ? 0 : pHeight;
		let tmpZoneStart = pWidth * tmpZone.start;
		let tmpZoneWidth = pWidth * (tmpZone.end - tmpZone.start);

		let tmpSpacing = tmpMinSpacing;
		let tmpGroupWidth = tmpSpacing * (pTotal + 1);
		let tmpSlack = tmpZoneWidth - tmpGroupWidth;
		if (tmpSlack < 0)
		{
			tmpSlack = 0;
		}

		let tmpAlignOffset = 0;
		if (tmpAlignment === 'end')
		{
			tmpAlignOffset = tmpSlack;
		}
		else if (tmpAlignment === 'center')
		{
			tmpAlignOffset = tmpSlack / 2;
		}

		let tmpX = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
		return { x: tmpX, y: tmpY };
	}

	/**
	 * Get the zone fraction (start, end) for a Side value.
	 *
	 * Each edge is divided into three zones of equal size:
	 *   start:  0.0 - 0.333
	 *   middle: 0.333 - 0.667
	 *   end:    0.667 - 1.0
	 *
	 * Used as fallback when adaptive zones are not available.
	 *
	 * @param {string} pSide
	 * @returns {{start: number, end: number}}
	 */
	_getZoneFromSide(pSide)
	{
		switch (pSide)
		{
			// Left edge: top, middle, bottom
			case 'left-top':     return { start: 0.0,   end: 0.333 };
			case 'left':         return { start: 0.333, end: 0.667 };
			case 'left-bottom':  return { start: 0.667, end: 1.0 };

			// Right edge: top, middle, bottom
			case 'right-top':    return { start: 0.0,   end: 0.333 };
			case 'right':        return { start: 0.333, end: 0.667 };
			case 'right-bottom': return { start: 0.667, end: 1.0 };

			// Top edge: left, middle, right
			case 'top-left':     return { start: 0.0,   end: 0.333 };
			case 'top':          return { start: 0.333, end: 0.667 };
			case 'top-right':    return { start: 0.667, end: 1.0 };

			// Bottom edge: left, middle, right
			case 'bottom-left':  return { start: 0.0,   end: 0.333 };
			case 'bottom':       return { start: 0.333, end: 0.667 };
			case 'bottom-right': return { start: 0.667, end: 1.0 };

			// Fallback: full range (legacy behavior)
			default:             return { start: 0.0,   end: 1.0 };
		}
	}

	/**
	 * Get the three zone Side keys for a given edge, in order.
	 *
	 * @param {string} pEdge - 'left', 'right', 'top', or 'bottom'
	 * @returns {Array<string>} Three Side keys in start-to-end order
	 */
	_getZoneKeysForEdge(pEdge)
	{
		switch (pEdge)
		{
			case 'left':   return ['left-top', 'left', 'left-bottom'];
			case 'right':  return ['right-top', 'right', 'right-bottom'];
			case 'top':    return ['top-left', 'top', 'top-right'];
			case 'bottom': return ['bottom-left', 'bottom', 'bottom-right'];
			default:       return ['right-top', 'right', 'right-bottom'];
		}
	}

	/**
	 * Compute an adaptive zone fraction for a Side value based on the actual
	 * port distribution across all zones on the same edge.
	 *
	 * Instead of fixed 1/3 splits, zones are sized proportionally to the space
	 * each zone needs (minSpacing * (portCount + 1)). Zones with zero ports
	 * collapse to zero, giving occupied zones more room.
	 *
	 * @param {string} pSide - The Side value to compute a zone for
	 * @param {Object} pPortCountsBySide - Map of Side to number of ports
	 * @returns {{start: number, end: number}}
	 */
	_computeAdaptiveZone(pSide, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZoneKeys = this._getZoneKeysForEdge(tmpEdge);

		let tmpMinSpacing = this.MinPortSpacing;

		// Compute the space each zone needs: minSpacing * (count + 1). The +1
		// provides padding at both ends of the zone.
		let tmpTotalSpace = 0;
		let tmpSpaceByZone = {};
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpCount = pPortCountsBySide[tmpKey] || 0;
			let tmpSpace = (tmpCount > 0) ? (tmpMinSpacing * (tmpCount + 1)) : 0;
			tmpSpaceByZone[tmpKey] = tmpSpace;
			tmpTotalSpace += tmpSpace;
		}

		// If no ports on this edge at all, fall back to fixed zones
		if (tmpTotalSpace === 0)
		{
			return this._getZoneFromSide(pSide);
		}

		// Compute proportional start/end for the requested zone
		let tmpCumulativeStart = 0;
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpFraction = tmpSpaceByZone[tmpKey] / tmpTotalSpace;
			if (tmpKey === pSide)
			{
				return { start: tmpCumulativeStart, end: tmpCumulativeStart + tmpFraction };
			}
			tmpCumulativeStart += tmpFraction;
		}

		// Should not reach here; fall back to fixed zones
		return this._getZoneFromSide(pSide);
	}

	/**
	 * Build a map of Side to port count from an array of port objects.
	 *
	 * Convenience method for callers that need to pass port counts to
	 * getPortLocalPosition or computeMinimumNodeHeight.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @returns {Object} Map of Side value to count
	 */
	buildPortCountsBySide(pPorts)
	{
		let tmpCounts = {};
		if (!pPorts || !Array.isArray(pPorts))
		{
			return tmpCounts;
		}
		for (let i = 0; i < pPorts.length; i++)
		{
			let tmpSide = pPorts[i].Side || (pPorts[i].Direction === 'input' ? 'left' : 'right');
			if (!tmpCounts[tmpSide])
			{
				tmpCounts[tmpSide] = 0;
			}
			tmpCounts[tmpSide]++;
		}
		return tmpCounts;
	}

	/**
	 * Compute the minimum node height required so that all ports (with their
	 * badges) fit within the node boundary.
	 *
	 * Uses adaptive zone sizing: instead of assuming each zone gets a fixed 1/3
	 * of the body, sums the space needed by all occupied zones on each
	 * left/right edge. This produces compact cards whose height scales linearly
	 * with total port count.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @param {number} pTitleBarHeight - Height of the title bar
	 * @returns {number} Minimum node height in pixels (0 if no ports)
	 */
	computeMinimumNodeHeight(pPorts, pTitleBarHeight)
	{
		if (!pPorts || !Array.isArray(pPorts) || pPorts.length === 0)
		{
			return 0;
		}

		let tmpMinSpacing = this.MinPortSpacing;
		let tmpBottomPad = this.PortBottomPadding;

		// Count ports per Side value
		let tmpCountBySide = this.buildPortCountsBySide(pPorts);

		// Sum the space needed per edge (left, right) across all zones. Each
		// zone needs minSpacing * (count + 1) pixels.
		let tmpSpacePerEdge = {};
		for (let tmpSide in tmpCountBySide)
		{
			let tmpEdge = this.getEdgeFromSide(tmpSide);

			// Only left/right edge zones affect required height
			if (tmpEdge !== 'left' && tmpEdge !== 'right')
			{
				continue;
			}

			let tmpCount = tmpCountBySide[tmpSide];
			let tmpZoneSpace = tmpMinSpacing * (tmpCount + 1);

			if (!tmpSpacePerEdge[tmpEdge])
			{
				tmpSpacePerEdge[tmpEdge] = 0;
			}
			tmpSpacePerEdge[tmpEdge] += tmpZoneSpace;
		}

		// The minimum height is titleBar + bottomPad + max edge space
		let tmpMinHeight = 0;
		for (let tmpEdge in tmpSpacePerEdge)
		{
			let tmpRequired = pTitleBarHeight + tmpBottomPad + tmpSpacePerEdge[tmpEdge];
			if (tmpRequired > tmpMinHeight)
			{
				tmpMinHeight = tmpRequired;
			}
		}

		return Math.ceil(tmpMinHeight);
	}
}

module.exports = GraphGeometry;

},{}],149:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libGraphGeometry = require('./GraphGeometry-Core.js');

/**
 * PictProvider-GraphGeometry
 *
 * Thin Fable service wrapper around the dependency-free GraphGeometry core, so
 * apps that already speak the service-provider pattern can register it and reach
 * the same math through dependency injection. All methods delegate to the core;
 * there is no behavior here beyond delegation.
 *
 * Most consumers should require the core directly:
 *   const GraphGeometry = require('pict-provider-graphgeometry').GraphGeometry;
 */
const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderGraphGeometry'
};

class PictProviderGraphGeometry extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderGraphGeometry';

		this.geometry = new libGraphGeometry(this.options);
	}

	getEdgeFromSide(pSide)
	{
		return this.geometry.getEdgeFromSide(pSide);
	}

	sideDirection(pSide)
	{
		return this.geometry.sideDirection(pSide);
	}

	getEdgeCenter(pRectData, pSide)
	{
		return this.geometry.getEdgeCenter(pRectData, pSide);
	}

	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pTitleBarHeight, pPortCountsBySide)
	{
		return this.geometry.getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pTitleBarHeight, pPortCountsBySide);
	}

	buildPortCountsBySide(pPorts)
	{
		return this.geometry.buildPortCountsBySide(pPorts);
	}

	computeMinimumNodeHeight(pPorts, pTitleBarHeight)
	{
		return this.geometry.computeMinimumNodeHeight(pPorts, pTitleBarHeight);
	}

	// Internal zone helpers are exposed for parity with the legacy provider so
	// existing callers and tests that reach them keep working.
	_getZoneFromSide(pSide)
	{
		return this.geometry._getZoneFromSide(pSide);
	}

	_getZoneKeysForEdge(pEdge)
	{
		return this.geometry._getZoneKeysForEdge(pEdge);
	}

	_computeAdaptiveZone(pSide, pPortCountsBySide)
	{
		return this.geometry._computeAdaptiveZone(pSide, pPortCountsBySide);
	}
}

module.exports = PictProviderGraphGeometry;

module.exports.default_configuration = _ProviderConfiguration;

// The dependency-free core, for direct use and unit testing.
module.exports.GraphGeometry = libGraphGeometry;

},{"./GraphGeometry-Core.js":148,"fable-serviceproviderbase":59}],150:[function(require,module,exports){
const libGraphGeometry = require('pict-provider-graphgeometry').GraphGeometry;

/**
 * PathGenerator-Core
 *
 * Pure SVG-path generation math for graph edges: departure/approach points,
 * orthogonal corners, cubic bezier evaluation, multi-handle bezier assembly, and
 * directional geometry. Extracted verbatim from pict-section-flow's PathGenerator
 * service (flow 2.0 Phase 1b); behavior is unchanged.
 *
 * The only outside dependency is a geometry object exposing `sideDirection(side)`
 * (two of the methods need it). Inject one of three ways, in priority order:
 *   1. options.geometryResolver - a function returning a geometry instance at
 *      call time (pict-section-flow passes `() => flowView._GeometryProvider`).
 *   2. options.geometry - a fixed geometry instance.
 *   3. none - a standalone pict-provider-graphgeometry GraphGeometry is created
 *      lazily as the default.
 */
class PathGenerator
{
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};

		this._GeometryResolver = (typeof tmpOptions.geometryResolver === 'function') ? tmpOptions.geometryResolver : null;
		this._Geometry = tmpOptions.geometry || null;
		this._DefaultGeometry = null;
	}

	/**
	 * Resolve the geometry object used for side-direction lookups. Resolver wins
	 * (call-time), then a fixed instance, then a lazily-built default.
	 * @returns {Object} something exposing sideDirection(side)
	 */
	_geometry()
	{
		if (this._GeometryResolver)
		{
			let tmpResolved = this._GeometryResolver();
			if (tmpResolved)
			{
				return tmpResolved;
			}
		}
		if (this._Geometry)
		{
			return this._Geometry;
		}
		if (!this._DefaultGeometry)
		{
			this._DefaultGeometry = new libGraphGeometry();
		}
		return this._DefaultGeometry;
	}

	// ---- Departure / Approach Calculation ----

	/**
	 * Compute departure and approach points from start/end anchors.
	 *
	 * @param {{x: number, y: number, side: string}} pFrom - Start anchor with side
	 * @param {{x: number, y: number, side: string}} pTo - End anchor with side
	 * @param {number} pDepartDist - Distance for departure/approach straight segments
	 * @returns {{departX, departY, approachX, approachY, fromDir, toDir}}
	 */
	computeDepartApproach(pFrom, pTo, pDepartDist)
	{
		let tmpGeometry = this._geometry();

		let tmpFromDir = tmpGeometry.sideDirection(pFrom.side || 'right');
		let tmpToDir = tmpGeometry.sideDirection(pTo.side || 'left');

		return {
			departX: pFrom.x + tmpFromDir.dx * pDepartDist,
			departY: pFrom.y + tmpFromDir.dy * pDepartDist,
			approachX: pTo.x + tmpToDir.dx * pDepartDist,
			approachY: pTo.y + tmpToDir.dy * pDepartDist,
			fromDir: tmpFromDir,
			toDir: tmpToDir
		};
	}

	// ---- Orthogonal Corner Calculation ----

	/**
	 * Compute auto orthogonal corners for an L-shaped or Z-shaped path.
	 *
	 * @returns {{corner1: {x, y}, corner2: {x, y}, midpoint: {x, y}}}
	 */
	computeAutoOrthogonalCorners(pDepartX, pDepartY, pApproachX, pApproachY, pFromDir, pToDir, pMidOffset)
	{
		let tmpOffset = pMidOffset || 0;
		let tmpFromHoriz = Math.abs(pFromDir.dx) > 0;
		let tmpToHoriz = Math.abs(pToDir.dx) > 0;

		let tmpCorner1, tmpCorner2, tmpMidpoint;

		if (tmpFromHoriz && tmpToHoriz)
		{
			// Both horizontal departure/approach: corridor is vertical
			let tmpMidX = (pDepartX + pApproachX) / 2 + tmpOffset;
			tmpCorner1 = { x: tmpMidX, y: pDepartY };
			tmpCorner2 = { x: tmpMidX, y: pApproachY };
			tmpMidpoint = { x: tmpMidX, y: (pDepartY + pApproachY) / 2 };
		}
		else if (!tmpFromHoriz && !tmpToHoriz)
		{
			// Both vertical: corridor is horizontal
			let tmpMidY = (pDepartY + pApproachY) / 2 + tmpOffset;
			tmpCorner1 = { x: pDepartX, y: tmpMidY };
			tmpCorner2 = { x: pApproachX, y: tmpMidY };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: tmpMidY };
		}
		else if (tmpFromHoriz && !tmpToHoriz)
		{
			// Horizontal->Vertical: single L-bend
			tmpCorner1 = { x: pApproachX + tmpOffset, y: pDepartY };
			tmpCorner2 = { x: pApproachX + tmpOffset, y: pApproachY };
			tmpMidpoint = { x: pApproachX + tmpOffset, y: (pDepartY + pApproachY) / 2 };
		}
		else
		{
			// Vertical->Horizontal: single L-bend
			tmpCorner1 = { x: pDepartX, y: pApproachY + tmpOffset };
			tmpCorner2 = { x: pApproachX, y: pApproachY + tmpOffset };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: pApproachY + tmpOffset };
		}

		return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
	}

	// ---- Bezier Evaluation ----

	/**
	 * Evaluate a cubic bezier curve at parameter t.
	 * B(t) = (1-t)^3 P0 + 3(1-t)^2 t P1 + 3(1-t) t^2 P2 + t^3 P3
	 */
	evaluateCubicBezier(pP0, pP1, pP2, pP3, pT)
	{
		let tmpOMT = 1 - pT;
		let tmpOMT2 = tmpOMT * tmpOMT;
		let tmpOMT3 = tmpOMT2 * tmpOMT;
		let tmpT2 = pT * pT;
		let tmpT3 = tmpT2 * pT;

		return {
			x: tmpOMT3 * pP0.x + 3 * tmpOMT2 * pT * pP1.x + 3 * tmpOMT * tmpT2 * pP2.x + tmpT3 * pP3.x,
			y: tmpOMT3 * pP0.y + 3 * tmpOMT2 * pT * pP1.y + 3 * tmpOMT * tmpT2 * pP2.y + tmpT3 * pP3.y
		};
	}

	// ---- SVG Path String Assembly ----

	/**
	 * Build an SVG bezier path string.
	 * Pattern: M start L depart C cp1, cp2, approach L end
	 */
	buildBezierPathString(pStart, pDepart, pCP1, pCP2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1.x} ${pCP1.y}, ${pCP2.x} ${pCP2.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG split bezier path string (two cubic segments through a handle point).
	 * Pattern: M start L depart C cp1a, cp1b, handle C cp2a, cp2b, approach L end
	 */
	buildSplitBezierPathString(pStart, pDepart, pCP1a, pCP1b, pHandle, pCP2a, pCP2b, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1a.x} ${pCP1a.y}, ${pCP1b.x} ${pCP1b.y}, ${pHandle.x} ${pHandle.y} C ${pCP2a.x} ${pCP2a.y}, ${pCP2b.x} ${pCP2b.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG multi-segment bezier path string.
	 * Generates N+1 cubic bezier segments through N handle points, using
	 * Catmull-Rom-to-Bezier conversion for C1 (smooth tangent) continuity.
	 */
	buildMultiBezierPathString(pStart, pDepart, pHandles, pApproach, pEnd, pStartDir, pEndDir)
	{
		// Build the full list of waypoints: depart, handle[0..N-1], approach
		let tmpWaypoints = [pDepart];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push(pApproach);

		let tmpPath = `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y}`;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpFrom = tmpWaypoints[i];
			let tmpTo = tmpWaypoints[i + 1];

			let tmpSegDX = tmpTo.x - tmpFrom.x;
			let tmpSegDY = tmpTo.y - tmpFrom.y;
			let tmpSegLen = Math.sqrt(tmpSegDX * tmpSegDX + tmpSegDY * tmpSegDY);
			if (tmpSegLen < 1)
			{
				tmpSegLen = 1;
			}
			let tmpScale = tmpSegLen * 0.35;

			// Tangent at tmpFrom
			let tmpTanFromX, tmpTanFromY;
			if (i === 0)
			{
				// First segment: use the port departure direction
				tmpTanFromX = pStartDir.dx;
				tmpTanFromY = pStartDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i - 1];
				let tmpNext = tmpWaypoints[i + 1];
				tmpTanFromX = tmpNext.x - tmpPrev.x;
				tmpTanFromY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanFromX * tmpTanFromX + tmpTanFromY * tmpTanFromY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanFromX /= tmpTanLen;
				tmpTanFromY /= tmpTanLen;
			}

			// Tangent at tmpTo
			let tmpTanToX, tmpTanToY;
			if (i === tmpWaypoints.length - 2)
			{
				// Last segment: use the port approach direction (reversed for incoming)
				tmpTanToX = -pEndDir.dx;
				tmpTanToY = -pEndDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i];
				let tmpNext = tmpWaypoints[i + 2];
				tmpTanToX = tmpNext.x - tmpPrev.x;
				tmpTanToY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanToX * tmpTanToX + tmpTanToY * tmpTanToY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanToX /= tmpTanLen;
				tmpTanToY /= tmpTanLen;
			}

			let tmpCP1X = tmpFrom.x + tmpTanFromX * tmpScale;
			let tmpCP1Y = tmpFrom.y + tmpTanFromY * tmpScale;
			let tmpCP2X = tmpTo.x - tmpTanToX * tmpScale;
			let tmpCP2Y = tmpTo.y - tmpTanToY * tmpScale;

			tmpPath += ` C ${tmpCP1X} ${tmpCP1Y}, ${tmpCP2X} ${tmpCP2Y}, ${tmpTo.x} ${tmpTo.y}`;
		}

		tmpPath += ` L ${pEnd.x} ${pEnd.y}`;

		return tmpPath;
	}

	/**
	 * Build an SVG orthogonal (right-angle) path string.
	 * Pattern: M start L depart L corner1 L corner2 L approach L end
	 */
	buildOrthogonalPathString(pStart, pDepart, pCorner1, pCorner2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} L ${pCorner1.x} ${pCorner1.y} L ${pCorner2.x} ${pCorner2.y} L ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	// ---- Directional Geometry ----

	/**
	 * Compute full directional geometry between two port anchors, including
	 * departure/approach points and bezier control points, with facing
	 * detection and adaptive curve offsets.
	 *
	 * @returns {{departX, departY, approachX, approachY, cp1X, cp1Y, cp2X, cp2Y, startDir, endDir}}
	 */
	computeDirectionalGeometry(pStart, pEnd)
	{
		let tmpGeometry = this._geometry();

		let tmpStartDir = tmpGeometry.sideDirection(pStart.side || 'right');
		let tmpEndDir   = tmpGeometry.sideDirection(pEnd.side   || 'left');

		let tmpStraightLen = 20;

		let tmpDepartX = pStart.x + tmpStartDir.dx * tmpStraightLen;
		let tmpDepartY = pStart.y + tmpStartDir.dy * tmpStraightLen;

		let tmpApproachX = pEnd.x + tmpEndDir.dx * tmpStraightLen;
		let tmpApproachY = pEnd.y + tmpEndDir.dy * tmpStraightLen;

		let tmpDX = Math.abs(tmpApproachX - tmpDepartX);
		let tmpDY = Math.abs(tmpApproachY - tmpDepartY);
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);

		let tmpBaseOffset = Math.max(Math.min(tmpDist * 0.4, 180), 30);

		let tmpSameAxis = (tmpStartDir.dx !== 0 && tmpEndDir.dx !== 0) ||
		                  (tmpStartDir.dy !== 0 && tmpEndDir.dy !== 0);

		let tmpFacingEachOther = false;
		if (tmpSameAxis)
		{
			if (tmpStartDir.dx === 1 && tmpEndDir.dx === -1 && pEnd.x >= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dx === -1 && tmpEndDir.dx === 1 && pEnd.x <= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === 1 && tmpEndDir.dy === -1 && pEnd.y >= pStart.y)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === -1 && tmpEndDir.dy === 1 && pEnd.y <= pStart.y)
			{
				tmpFacingEachOther = true;
			}
		}

		let tmpCurveOffset;

		if (tmpFacingEachOther)
		{
			let tmpInlineDist = (tmpStartDir.dx !== 0) ? tmpDX : tmpDY;
			tmpCurveOffset = Math.max(tmpInlineDist * 0.35, 30);
		}
		else if (tmpSameAxis)
		{
			tmpCurveOffset = Math.max(tmpBaseOffset, 60);
		}
		else
		{
			tmpCurveOffset = Math.max(tmpBaseOffset * 0.8, 40);
		}

		let tmpCP1X = tmpDepartX + tmpStartDir.dx * tmpCurveOffset;
		let tmpCP1Y = tmpDepartY + tmpStartDir.dy * tmpCurveOffset;
		let tmpCP2X = tmpApproachX + tmpEndDir.dx * tmpCurveOffset;
		let tmpCP2Y = tmpApproachY + tmpEndDir.dy * tmpCurveOffset;

		return {
			departX: tmpDepartX, departY: tmpDepartY,
			approachX: tmpApproachX, approachY: tmpApproachY,
			cp1X: tmpCP1X, cp1Y: tmpCP1Y,
			cp2X: tmpCP2X, cp2Y: tmpCP2Y,
			startDir: tmpStartDir, endDir: tmpEndDir
		};
	}

	// ---- Distance Utilities ----

	/**
	 * Distance from point (pPX, pPY) to line segment (pAX, pAY)-(pBX, pBY).
	 * Pure math utility, no state.
	 */
	distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		let tmpDX = pBX - pAX;
		let tmpDY = pBY - pAY;
		let tmpLenSq = tmpDX * tmpDX + tmpDY * tmpDY;

		if (tmpLenSq < 0.001)
		{
			// Degenerate segment
			let tmpDPX = pPX - pAX;
			let tmpDPY = pPY - pAY;
			return Math.sqrt(tmpDPX * tmpDPX + tmpDPY * tmpDPY);
		}

		// Project point onto segment, clamped to [0, 1]
		let tmpT = ((pPX - pAX) * tmpDX + (pPY - pAY) * tmpDY) / tmpLenSq;
		if (tmpT < 0) tmpT = 0;
		if (tmpT > 1) tmpT = 1;

		let tmpClosestX = pAX + tmpT * tmpDX;
		let tmpClosestY = pAY + tmpT * tmpDY;
		let tmpDistX = pPX - tmpClosestX;
		let tmpDistY = pPY - tmpClosestY;
		return Math.sqrt(tmpDistX * tmpDistX + tmpDistY * tmpDistY);
	}

	// ---- Auto Midpoint Calculation ----

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between two
	 * port anchors, using the full directional geometry. Evaluates at t=0.5.
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		let tmpGeo = this.computeDirectionalGeometry(pStart, pEnd);

		return this.evaluateCubicBezier(
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			0.5
		);
	}

	/**
	 * Get the auto-calculated midpoint using simple span-based control points.
	 * Uses computeDepartApproach, then span * 0.4 for control point distance.
	 * Evaluates at t=0.5.
	 */
	getAutoMidpointSimple(pFrom, pTo, pDepartDist)
	{
		let tmpDA = this.computeDepartApproach(pFrom, pTo, pDepartDist);

		let tmpSpanX = Math.abs(tmpDA.approachX - tmpDA.departX);
		let tmpSpanY = Math.abs(tmpDA.approachY - tmpDA.departY);
		let tmpSpan = Math.max(tmpSpanX, tmpSpanY, 40);
		let tmpCPDist = tmpSpan * 0.4;

		let tmpP0 = { x: tmpDA.departX, y: tmpDA.departY };
		let tmpP1 = { x: tmpDA.departX + tmpDA.fromDir.dx * tmpCPDist, y: tmpDA.departY + tmpDA.fromDir.dy * tmpCPDist };
		let tmpP2 = { x: tmpDA.approachX + tmpDA.toDir.dx * tmpCPDist, y: tmpDA.approachY + tmpDA.toDir.dy * tmpCPDist };
		let tmpP3 = { x: tmpDA.approachX, y: tmpDA.approachY };

		return this.evaluateCubicBezier(tmpP0, tmpP1, tmpP2, tmpP3, 0.5);
	}
}

module.exports = PathGenerator;

},{"pict-provider-graphgeometry":149}],151:[function(require,module,exports){
/**
 * pict-provider-graphlayout
 *
 * Pure, DOM-free node-placement algorithms and edge-routing themes for graph
 * canvases. These descriptors were extracted verbatim from pict-section-flow
 * (Phase 1b of the flow 2.0 plan); behavior is unchanged. pict-section-flow's
 * Layout service registers them, and Pict-Section-Flow.js re-exports the public
 * subset so the historical export surface is preserved.
 *
 * Layout algorithm descriptors are `{ Name, Label, Apply, DefaultParameters,
 * ParameterSchema }`. Edge-theme descriptors are `{ Name, GeneratePath,
 * AdjustLayout?, ResolveAttachment?, ... }`. Coerce / Rank / PerimeterMath are
 * internal helpers the descriptors depend on, exposed here so existing tests and
 * advanced consumers can reach them.
 *
 * The path-generation math (today pict-section-flow's PathGenerator service)
 * lands here in a follow-up step as a geometry-injected core.
 */

// Layout algorithm descriptors and their helpers
const libLayoutCoerce           = require('./layouts/Layout-Coerce.js');
const libLayoutRank             = require('./layouts/Layout-Rank.js');
const libLayoutCustom           = require('./layouts/Layout-Custom.js');
const libLayoutLayered          = require('./layouts/Layout-Layered.js');
const libLayoutStaggered        = require('./layouts/Layout-Staggered.js');
const libLayoutForcedFromCenter = require('./layouts/Layout-ForcedFromCenter.js');
const libLayoutGrid             = require('./layouts/Layout-Grid.js');
const libLayoutCircular         = require('./layouts/Layout-Circular.js');
const libLayoutTabular          = require('./layouts/Layout-Tabular.js');
const libLayoutColumnar         = require('./layouts/Layout-Columnar.js');

// Edge-routing theme descriptors and their helper
const libEdgePerimeterMath       = require('./edges/Edge-PerimeterMath.js');
const libEdgeBezier              = require('./edges/Edge-Bezier.js');
const libEdgeOrthogonal          = require('./edges/Edge-Orthogonal.js');
const libEdgeStraight            = require('./edges/Edge-Straight.js');
const libEdgeOrthogonalSnap      = require('./edges/Edge-OrthogonalSnap.js');
const libEdgePerimeter           = require('./edges/Edge-Perimeter.js');
const libEdgePerimeterLinear     = require('./edges/Edge-Perimeter-Linear.js');
const libEdgePerimeterOrthogonal = require('./edges/Edge-Perimeter-Orthogonal.js');

// Edge path-generation math (geometry-injected pure core)
const libPathGenerator = require('./PathGenerator-Core.js');

module.exports =
{
	// Edge path-generation math (bezier / orthogonal / multi-handle routing)
	PathGenerator: libPathGenerator,

	Layouts:
	{
		Coerce:           libLayoutCoerce,
		Rank:             libLayoutRank,
		Custom:           libLayoutCustom,
		Layered:          libLayoutLayered,
		Staggered:        libLayoutStaggered,
		ForcedFromCenter: libLayoutForcedFromCenter,
		Grid:             libLayoutGrid,
		Circular:         libLayoutCircular,
		Tabular:          libLayoutTabular,
		Columnar:         libLayoutColumnar
	},

	Edges:
	{
		PerimeterMath:       libEdgePerimeterMath,
		Bezier:              libEdgeBezier,
		Orthogonal:          libEdgeOrthogonal,
		Straight:            libEdgeStraight,
		OrthogonalSnap:      libEdgeOrthogonalSnap,
		Perimeter:           libEdgePerimeter,
		PerimeterLinear:     libEdgePerimeterLinear,
		PerimeterOrthogonal: libEdgePerimeterOrthogonal
	}
};

},{"./PathGenerator-Core.js":150,"./edges/Edge-Bezier.js":152,"./edges/Edge-Orthogonal.js":153,"./edges/Edge-OrthogonalSnap.js":154,"./edges/Edge-Perimeter-Linear.js":155,"./edges/Edge-Perimeter-Orthogonal.js":156,"./edges/Edge-Perimeter.js":157,"./edges/Edge-PerimeterMath.js":158,"./edges/Edge-Straight.js":159,"./layouts/Layout-Circular.js":160,"./layouts/Layout-Coerce.js":161,"./layouts/Layout-Columnar.js":162,"./layouts/Layout-Custom.js":163,"./layouts/Layout-ForcedFromCenter.js":164,"./layouts/Layout-Grid.js":165,"./layouts/Layout-Layered.js":166,"./layouts/Layout-Rank.js":167,"./layouts/Layout-Staggered.js":168,"./layouts/Layout-Tabular.js":169}],152:[function(require,module,exports){
/**
 * Edge-Bezier
 *
 * Default edge theme: smooth cubic bezier between source and target ports,
 * with departure/approach geometry derived from each port's `Side`. This
 * is a thin wrapper around the renderer's pre-existing bezier path
 * generator — selecting it is equivalent to the historical default.
 *
 * Honors per-connection multi-handle waypoints (BezierHandles) when
 * present so user-edited curves still survive.
 */
module.exports =
{
	Name: 'Bezier',
	Label: 'Bezier (smooth)',
	Description: 'Smooth cubic curves with side-aware departures.',

	GeneratePath: function (pContext)
	{
		let tmpHelpers = pContext.Helpers;
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};

		// Preserve user-customized multi-handle bezier waypoints.
		if (tmpData.HandleCustomized)
		{
			let tmpHandles = tmpHelpers.getBezierHandles(tmpData);
			if (tmpHandles.length > 0)
			{
				return tmpHelpers.generateMultiBezier(tmpSrc, tmpTgt, tmpHandles);
			}
		}

		return tmpHelpers.generateBezier(tmpSrc, tmpTgt);
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],153:[function(require,module,exports){
/**
 * Edge-Orthogonal
 *
 * Right-angle (Manhattan) routing between source and target. Reads
 * cleanly for layered DAGs and grid-shaped layouts. Per-connection
 * `OrthoMidOffset` and customized corner overrides are preserved.
 */
module.exports =
{
	Name: 'Orthogonal',
	Label: 'Orthogonal (right-angle)',
	Description: 'Right-angle routing — reads well for DAGs and grids.',

	GeneratePath: function (pContext)
	{
		let tmpHelpers = pContext.Helpers;
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};

		let tmpCorners = null;
		if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
		{
			tmpCorners =
			{
				corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
				corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
			};
		}

		return tmpHelpers.generateOrthogonal(tmpSrc, tmpTgt, tmpCorners, tmpData.OrthoMidOffset || 0);
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],154:[function(require,module,exports){
const libCoerce = require('../layouts/Layout-Coerce.js');

/**
 * Edge-OrthogonalSnap
 *
 * Demonstrates the "edge theme can affect node placement" axis. Same
 * right-angle routing as Edge-Orthogonal, but with an `AdjustLayout`
 * pass that snaps every node's X/Y to a grid so corner segments line
 * up cleanly across the diagram.
 *
 * Trade-off: nodes shift slightly from the layout's natural positions
 * to gain visual alignment. The user opts into this by picking the
 * theme — the layout algorithm itself is unaware.
 */
module.exports =
{
	Name: 'OrthogonalSnap',
	Label: 'Orthogonal (snap to grid)',
	Description: 'Right-angle routing; snaps node positions to a grid for cleaner corner alignment. Demonstrates an edge theme that adjusts node placement.',

	GeneratePath: function (pContext)
	{
		let tmpHelpers = pContext.Helpers;
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};

		let tmpCorners = null;
		if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
		{
			tmpCorners =
			{
				corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
				corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
			};
		}

		return tmpHelpers.generateOrthogonal(tmpSrc, tmpTgt, tmpCorners, tmpData.OrthoMidOffset || 0);
	},

	/**
	 * Snap each node's (X, Y) to the configured grid after the layout
	 * has run. Mutates pNodes in place.
	 *
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {Object} pParameters
	 */
	AdjustLayout: function (pNodes, pConnections, pParameters)
	{
		let tmpGridSize = libCoerce.toFloat((pParameters || {}).GridSize, 20);
		if (tmpGridSize <= 0) return;

		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpNode = pNodes[i];
			if (typeof tmpNode.X !== 'number' || typeof tmpNode.Y !== 'number') continue;
			tmpNode.X = Math.round(tmpNode.X / tmpGridSize) * tmpGridSize;
			tmpNode.Y = Math.round(tmpNode.Y / tmpGridSize) * tmpGridSize;
		}
	},

	DefaultParameters:
	{
		GridSize: 20
	},

	ParameterSchema:
	{
		GridSize: { Type: 'PreciseNumber', Label: 'Grid size', Default: 20, Min: 1, Max: 200 }
	}
};

},{"../layouts/Layout-Coerce.js":161}],155:[function(require,module,exports){
const libPerimeterMath = require('./Edge-PerimeterMath.js');

/**
 * Edge-Perimeter-Linear
 *
 * Perimeter attachment + literal straight line between the two
 * resolved exit points. Reads cleanly for force-directed and circular
 * layouts where the topology already determines edge angles, and the
 * curves of bezier add visual noise.
 */
module.exports =
{
	Name: 'Perimeter-Linear',
	Label: 'Perimeter (linear)',
	Description: 'Each connection exits the node at the perimeter, then runs as a straight line to the other end.',

	GeneratePath: function (pContext)
	{
		let tmpS = pContext.Source;
		let tmpT = pContext.Target;
		return `M ${tmpS.x} ${tmpS.y} L ${tmpT.x} ${tmpT.y}`;
	},

	ResolveAttachment: function (pContext)
	{
		return libPerimeterMath.resolvePerimeterAttachment(pContext);
	},

	DefaultParameters: {},
	ParameterSchema: {}
};

},{"./Edge-PerimeterMath.js":158}],156:[function(require,module,exports){
const libPerimeterMath = require('./Edge-PerimeterMath.js');

/**
 * Edge-Perimeter-Orthogonal
 *
 * Perimeter attachment + right-angle (Manhattan) routing between
 * the two resolved exit points. Best when the layout already has
 * grid-like structure (Grid, Mesh) and you want connections to
 * leave from whichever side faces the partner.
 */
module.exports =
{
	Name: 'Perimeter-Orthogonal',
	Label: 'Perimeter (orthogonal)',
	Description: 'Each connection exits the node at the perimeter, then routes via right-angle segments to the other end.',

	GeneratePath: function (pContext)
	{
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};
		let tmpCorners = null;
		if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
		{
			tmpCorners =
			{
				corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
				corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
			};
		}
		return pContext.Helpers.generateOrthogonal(pContext.Source, pContext.Target, tmpCorners, tmpData.OrthoMidOffset || 0);
	},

	ResolveAttachment: function (pContext)
	{
		return libPerimeterMath.resolvePerimeterAttachment(pContext);
	},

	DefaultParameters: {},
	ParameterSchema: {}
};

},{"./Edge-PerimeterMath.js":158}],157:[function(require,module,exports){
const libPerimeterMath = require('./Edge-PerimeterMath.js');

/**
 * Edge-Perimeter (Bezier)
 *
 * "Smart exit" routing with smooth bezier curves. Each connection
 * exits the node at the perimeter point closest to its target —
 * solves star/hub topologies where many connections share one port.
 *
 * Renders the path as a side-aware bezier (uses the side returned by
 * `ResolveAttachment` so the curve departs in the right direction).
 *
 * See `Edge-Perimeter-Linear` and `Edge-Perimeter-Orthogonal` for the
 * straight-line and right-angle variants.
 */
module.exports =
{
	Name: 'Perimeter',
	Label: 'Perimeter (bezier)',
	Description: 'Each connection exits the node at the perimeter point closest to its target, with smooth bezier curves. Fixes star/hub topologies where many lines share one port.',

	GeneratePath: function (pContext)
	{
		// Honor user-edited bezier handles when the connection is selected
		// and dragged. Without this, the drag handles render but moving
		// them does nothing because Perimeter would always re-emit a
		// fresh side-aware bezier.
		let tmpHelpers = pContext.Helpers;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};
		if (tmpData.HandleCustomized)
		{
			let tmpHandles = tmpHelpers.getBezierHandles(tmpData);
			if (tmpHandles.length > 0)
			{
				return tmpHelpers.generateMultiBezier(pContext.Source, pContext.Target, tmpHandles);
			}
		}
		return tmpHelpers.generateBezier(pContext.Source, pContext.Target);
	},

	ResolveAttachment: function (pContext)
	{
		return libPerimeterMath.resolvePerimeterAttachment(pContext);
	},

	DefaultParameters: {},
	ParameterSchema: {}
};

},{"./Edge-PerimeterMath.js":158}],158:[function(require,module,exports){
/**
 * Edge-PerimeterMath
 *
 * Shared geometry helper for the Perimeter family of edge themes
 * (Perimeter, Perimeter-Linear, Perimeter-Orthogonal). Solves the
 * "where on this node's bounding box should the line attach so it
 * points at the other end" question.
 *
 * The themes themselves only differ in how they render the path
 * between the two attachment points; the attachment math is identical.
 */

/**
 * Resolve a perimeter attachment point for one end of a connection.
 * Traces a line from the node's center toward the other end and returns
 * the first crossing of the node's bounding-box perimeter, plus the
 * `side` of that crossing (so the bezier helper departs in the right
 * direction).
 *
 * @param {Object} pContext - the same shape the renderer passes into
 *        ResolveAttachment (Node, OtherNode, OtherDefaultPosition,
 *        DefaultPosition, …).
 * @returns {{x: number, y: number, side: string}|Object|null}
 *        Returns null when node geometry is missing; returns
 *        DefaultPosition (verbatim) for degenerate same-center cases.
 */
function _resolvePerimeterAttachment(pContext)
{
	let tmpNode = pContext.Node;
	if (!tmpNode || typeof tmpNode.X !== 'number' || typeof tmpNode.Y !== 'number') return null;

	let tmpW = tmpNode.Width || 180;
	let tmpH = tmpNode.Height || 80;
	let tmpCx = tmpNode.X + tmpW / 2;
	let tmpCy = tmpNode.Y + tmpH / 2;

	let tmpAimX, tmpAimY;
	if (pContext.OtherNode && typeof pContext.OtherNode.X === 'number')
	{
		let tmpOW = pContext.OtherNode.Width || 180;
		let tmpOH = pContext.OtherNode.Height || 80;
		tmpAimX = pContext.OtherNode.X + tmpOW / 2;
		tmpAimY = pContext.OtherNode.Y + tmpOH / 2;
	}
	else if (pContext.OtherDefaultPosition)
	{
		tmpAimX = pContext.OtherDefaultPosition.x;
		tmpAimY = pContext.OtherDefaultPosition.y;
	}
	else
	{
		return null;
	}

	let tmpDX = tmpAimX - tmpCx;
	let tmpDY = tmpAimY - tmpCy;

	if (tmpDX === 0 && tmpDY === 0) return pContext.DefaultPosition || null;

	let tmpHalfW = tmpW / 2;
	let tmpHalfH = tmpH / 2;

	let tmpTX = (tmpDX > 0) ? tmpHalfW / tmpDX
		: (tmpDX < 0) ? -tmpHalfW / tmpDX
		: Infinity;
	let tmpTY = (tmpDY > 0) ? tmpHalfH / tmpDY
		: (tmpDY < 0) ? -tmpHalfH / tmpDY
		: Infinity;

	let tmpT, tmpSide;
	if (tmpTX < tmpTY)
	{
		tmpT = tmpTX;
		tmpSide = (tmpDX > 0) ? 'right' : 'left';
	}
	else
	{
		tmpT = tmpTY;
		tmpSide = (tmpDY > 0) ? 'bottom' : 'top';
	}

	return {
		x: tmpCx + tmpT * tmpDX,
		y: tmpCy + tmpT * tmpDY,
		side: tmpSide
	};
}

module.exports =
{
	resolvePerimeterAttachment: _resolvePerimeterAttachment
};

},{}],159:[function(require,module,exports){
/**
 * Edge-Straight
 *
 * Literal straight line from source port to target port. Useful for
 * dense clusters where curves add visual noise, and for force-directed
 * layouts where the topology already determines edge angles.
 */
module.exports =
{
	Name: 'Straight',
	Label: 'Straight line',
	Description: 'Plain straight line between ports.',

	GeneratePath: function (pContext)
	{
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		return `M ${tmpSrc.x} ${tmpSrc.y} L ${tmpTgt.x} ${tmpTgt.y}`;
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],160:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Circular
 *
 * Concentric-ring layout.
 *
 * Two modes, decided by the presence of connections:
 *
 *   With connections: BFS from the root nodes (in-degree 0; or all
 *   nodes if every node has incoming edges). Each BFS depth becomes
 *   one ring. Roots cluster near the center, leaves on the outer rings.
 *
 *   Without connections: all nodes share a single ring with equal
 *   angular spacing.
 *
 * Within each ring, nodes are placed at equal angles starting from
 * `StartAngle` (in degrees, 0 = +X axis), going clockwise or
 * counter-clockwise per `Direction`.
 */
module.exports =
{
	Name: 'Circular',
	Label: 'Circular',
	Description: 'Concentric rings; uses connections for ring assignment when available.',
	DefaultEdgeTheme: 'Perimeter',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing     = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpCenterX     = libCoerce.toFloat(tmpParams.CenterX, 1000);
		let tmpCenterY     = libCoerce.toFloat(tmpParams.CenterY, 750);
		let tmpRingSpacing = libCoerce.toFloat(tmpParams.RingSpacing, 220) * tmpSpacing;
		let tmpInnerRadius = libCoerce.toFloat(tmpParams.InnerRadius, 0) * tmpSpacing;
		let tmpStartAngle  = libCoerce.toFloat(tmpParams.StartAngle, -90);
		let tmpDirection   = (tmpParams.Direction === 'ccw') ? 'ccw' : 'cw';

		let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

		// Build in-degree map and adjacency
		let tmpInDegree = {};
		let tmpAdjacency = {};
		let tmpNodeMap = {};
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpNodeMap[pNodes[i].Hash] = pNodes[i];
			tmpInDegree[pNodes[i].Hash] = 0;
			tmpAdjacency[pNodes[i].Hash] = [];
		}
		for (let i = 0; i < tmpConnections.length; i++)
		{
			let tmpConn = tmpConnections[i];
			if (tmpInDegree.hasOwnProperty(tmpConn.TargetNodeHash))
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
			}
			if (tmpAdjacency.hasOwnProperty(tmpConn.SourceNodeHash))
			{
				tmpAdjacency[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Identify roots
		let tmpRoots = [];
		for (let i = 0; i < pNodes.length; i++)
		{
			if (tmpInDegree[pNodes[i].Hash] === 0)
			{
				tmpRoots.push(pNodes[i].Hash);
			}
		}

		let tmpRings = [];

		if (tmpConnections.length === 0 || tmpRoots.length === 0)
		{
			tmpRings.push(pNodes.map((pNode) => pNode.Hash));
		}
		else
		{
			// BFS by depth
			let tmpVisited = {};
			let tmpCurrent = tmpRoots.slice();
			while (tmpCurrent.length > 0)
			{
				let tmpRing = [];
				let tmpNext = [];
				for (let i = 0; i < tmpCurrent.length; i++)
				{
					let tmpHash = tmpCurrent[i];
					if (tmpVisited[tmpHash]) continue;
					tmpVisited[tmpHash] = true;
					tmpRing.push(tmpHash);

					let tmpChildren = tmpAdjacency[tmpHash] || [];
					for (let j = 0; j < tmpChildren.length; j++)
					{
						if (!tmpVisited[tmpChildren[j]])
						{
							tmpNext.push(tmpChildren[j]);
						}
					}
				}
				if (tmpRing.length > 0) tmpRings.push(tmpRing);
				tmpCurrent = tmpNext;
			}

			let tmpRemaining = [];
			for (let i = 0; i < pNodes.length; i++)
			{
				if (!tmpVisited[pNodes[i].Hash]) tmpRemaining.push(pNodes[i].Hash);
			}
			if (tmpRemaining.length > 0) tmpRings.push(tmpRemaining);
		}

		// Place nodes
		let tmpAngleSign = (tmpDirection === 'cw') ? 1 : -1;
		let tmpStartRad = tmpStartAngle * Math.PI / 180;

		for (let tmpRingIdx = 0; tmpRingIdx < tmpRings.length; tmpRingIdx++)
		{
			let tmpRing = tmpRings[tmpRingIdx];
			let tmpRadius = tmpInnerRadius + tmpRingIdx * tmpRingSpacing;

			if (tmpRing.length === 1 && tmpRingIdx === 0 && tmpInnerRadius === 0)
			{
				let tmpNode = tmpNodeMap[tmpRing[0]];
				if (tmpNode)
				{
					tmpNode.X = tmpCenterX - (tmpNode.Width || 180) / 2;
					tmpNode.Y = tmpCenterY - (tmpNode.Height || 80) / 2;
				}
				continue;
			}

			let tmpAngleStep = (2 * Math.PI) / tmpRing.length;
			for (let i = 0; i < tmpRing.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpRing[i]];
				if (!tmpNode) continue;
				let tmpAngle = tmpStartRad + tmpAngleSign * i * tmpAngleStep;
				let tmpW = tmpNode.Width || 180;
				let tmpH = tmpNode.Height || 80;
				tmpNode.X = tmpCenterX + Math.cos(tmpAngle) * tmpRadius - tmpW / 2;
				tmpNode.Y = tmpCenterY + Math.sin(tmpAngle) * tmpRadius - tmpH / 2;
			}
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		CenterX: 1000,
		CenterY: 750,
		RingSpacing: 220,
		InnerRadius: 0,
		StartAngle: -90,
		Direction: 'cw'
	},

	ParameterSchema:
	{
		Spacing:     { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		CenterX:     { Type: 'PreciseNumber', Label: 'Center X',     Default: 1000, Min: -10000, Max: 10000 },
		CenterY:     { Type: 'PreciseNumber', Label: 'Center Y',     Default: 750,  Min: -10000, Max: 10000 },
		RingSpacing: { Type: 'PreciseNumber', Label: 'Ring spacing', Default: 220,  Min: 1, Max: 5000 },
		InnerRadius: { Type: 'PreciseNumber', Label: 'Inner radius', Default: 0,    Min: 0, Max: 5000 },
		StartAngle:  { Type: 'PreciseNumber', Label: 'Start angle (deg)', Default: -90, Min: -360, Max: 360 },
		Direction:   { Type: 'enum',          Label: 'Direction',    Default: 'cw', Options: ['cw', 'ccw'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Circular',
		Sections:
		[
			{ Name: 'Circular Parameters', Hash: 'PFLCircularSection', Groups: [{ Name: 'Defaults', Hash: 'PFLCircularGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.CenterX':
			{ Name: 'Center X', Hash: 'CenterX', DataType: 'PreciseNumber', Default: 1000, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.CenterY':
			{ Name: 'Center Y', Hash: 'CenterY', DataType: 'PreciseNumber', Default: 750, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.RingSpacing':
			{ Name: 'Ring spacing', Hash: 'RingSpacing', DataType: 'PreciseNumber', Default: 220, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.InnerRadius':
			{ Name: 'Inner radius', Hash: 'InnerRadius', DataType: 'PreciseNumber', Default: 0, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 2, Width: 6, Min: 0, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.StartAngle':
			{ Name: 'Start angle (deg)', Hash: 'StartAngle', DataType: 'PreciseNumber', Default: -90, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 3, Width: 6, Min: -360, Max: 360 } },
			'PictFlowLayoutEditor.Parameters.Direction':
			{
				Name: 'Direction', Hash: 'Direction', DataType: 'String', Default: 'cw',
				PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 3, Width: 6, InputType: 'Option', SelectOptions: [{ Value: 'cw', Name: 'Clockwise' }, { Value: 'ccw', Name: 'Counter-clockwise' }] }
			}
		}
	}
};

},{"./Layout-Coerce.js":161}],161:[function(require,module,exports){
/**
 * Layout-Coerce
 *
 * Tiny coercion helpers for layout-algorithm parameters. Manyfest's
 * `PreciseNumber` DataType stores values as strings (so big.js /
 * fable.ExpressionParser can do arbitrary-precision math on them
 * without float drift). The simulation code in each layout algorithm
 * uses native JS Math, so we coerce at the entry point.
 *
 * Apply functions accept either format (number or string) and use
 * these helpers to normalize.
 */

function _toFloat(pValue, pDefault)
{
	if (typeof pValue === 'number' && !isNaN(pValue)) return pValue;
	if (typeof pValue === 'string' && pValue !== '')
	{
		let tmpNum = parseFloat(pValue);
		if (!isNaN(tmpNum)) return tmpNum;
	}
	return pDefault;
}

function _toInt(pValue, pDefault)
{
	if (typeof pValue === 'number' && !isNaN(pValue)) return Math.floor(pValue);
	if (typeof pValue === 'string' && pValue !== '')
	{
		let tmpNum = parseInt(pValue, 10);
		if (!isNaN(tmpNum)) return tmpNum;
	}
	return pDefault;
}

module.exports =
{
	toFloat: _toFloat,
	toInt: _toInt
};

},{}],162:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Columnar
 *
 * N-column layout with deterministic fill order. Distinct from Grid in
 * two ways:
 *   - Columns is always explicit (no 'auto')
 *   - FillOrder controls whether nodes flow row-first or column-first
 *
 * The column count is `Number` (integer index); spacing/origin values
 * are `PreciseNumber` so they survive solver chains.
 */
module.exports =
{
	Name: 'Columnar',
	Label: 'Columnar (N Columns)',
	Description: 'Explicit N columns; flow row-first or column-first.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing         = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpColumns         = Math.max(1, libCoerce.toInt(tmpParams.Columns, 3));
		let tmpColumnSpacing   = libCoerce.toFloat(tmpParams.ColumnSpacing, 40) * tmpSpacing;
		let tmpRowSpacing      = libCoerce.toFloat(tmpParams.RowSpacing, 40) * tmpSpacing;
		let tmpStartX          = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY          = libCoerce.toFloat(tmpParams.StartY, 100);
		let tmpFillOrder       = (tmpParams.FillOrder === 'column') ? 'column' : 'row';
		let tmpOrderBy         = tmpParams.OrderBy || 'index';

		// Compute cell dimensions from largest node
		let tmpMaxWidth = 0;
		let tmpMaxHeight = 0;
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMaxWidth = Math.max(tmpMaxWidth, pNodes[i].Width || 180);
			tmpMaxHeight = Math.max(tmpMaxHeight, pNodes[i].Height || 80);
		}
		let tmpCellWidth  = tmpMaxWidth + tmpColumnSpacing;
		let tmpCellHeight = tmpMaxHeight + tmpRowSpacing;

		let tmpOrdered = pNodes.slice();
		if (tmpOrderBy === 'hash')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)));
		}
		else if (tmpOrderBy === 'title')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Title || pA.Hash).localeCompare(String(pB.Title || pB.Hash)));
		}

		let tmpRows = Math.ceil(tmpOrdered.length / tmpColumns);

		for (let i = 0; i < tmpOrdered.length; i++)
		{
			let tmpRow;
			let tmpCol;
			if (tmpFillOrder === 'column')
			{
				tmpCol = Math.floor(i / tmpRows);
				tmpRow = i % tmpRows;
			}
			else
			{
				tmpRow = Math.floor(i / tmpColumns);
				tmpCol = i % tmpColumns;
			}
			tmpOrdered[i].X = tmpStartX + tmpCol * tmpCellWidth;
			tmpOrdered[i].Y = tmpStartY + tmpRow * tmpCellHeight;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		Columns: 3,
		ColumnSpacing: 40,
		RowSpacing: 40,
		StartX: 100,
		StartY: 100,
		FillOrder: 'row',
		OrderBy: 'index'
	},

	ParameterSchema:
	{
		Spacing:       { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		Columns:       { Type: 'Number',        Label: 'Columns',        Default: 3,   Min: 1, Max: 50 },
		ColumnSpacing: { Type: 'PreciseNumber', Label: 'Column spacing', Default: 40,  Min: 0, Max: 1000 },
		RowSpacing:    { Type: 'PreciseNumber', Label: 'Row spacing',    Default: 40,  Min: 0, Max: 1000 },
		StartX:        { Type: 'PreciseNumber', Label: 'Start X',        Default: 100, Min: -10000, Max: 10000 },
		StartY:        { Type: 'PreciseNumber', Label: 'Start Y',        Default: 100, Min: -10000, Max: 10000 },
		FillOrder:     { Type: 'enum',          Label: 'Fill order',     Default: 'row', Options: ['row', 'column'] },
		OrderBy:       { Type: 'enum',          Label: 'Order by',       Default: 'index', Options: ['index', 'hash', 'title'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Columnar',
		Sections:
		[
			{ Name: 'Columnar Parameters', Hash: 'PFLColumnarSection', Groups: [{ Name: 'Defaults', Hash: 'PFLColumnarGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.Columns':
			{ Name: 'Columns', Hash: 'Columns', DataType: 'Number', Default: 3, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 1, Width: 6, Min: 1, Max: 50 } },
			'PictFlowLayoutEditor.Parameters.FillOrder':
			{
				Name: 'Fill order', Hash: 'FillOrder', DataType: 'String', Default: 'row',
				PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 1, Width: 6, InputType: 'Option', SelectOptions: [{ Value: 'row', Name: 'Row-first' }, { Value: 'column', Name: 'Column-first' }] }
			},
			'PictFlowLayoutEditor.Parameters.ColumnSpacing':
			{ Name: 'Column spacing', Hash: 'ColumnSpacing', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 2, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.RowSpacing':
			{ Name: 'Row spacing', Hash: 'RowSpacing', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 2, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.StartX':
			{ Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 3, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.StartY':
			{ Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 3, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.OrderBy':
			{
				Name: 'Order by', Hash: 'OrderBy', DataType: 'String', Default: 'index',
				PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 4, Width: 12, InputType: 'Option', SelectOptions: [{ Value: 'index', Name: 'Index' }, { Value: 'hash', Name: 'Hash' }, { Value: 'title', Name: 'Title' }] }
			}
		}
	}
};

},{"./Layout-Coerce.js":161}],163:[function(require,module,exports){
/**
 * Layout-Custom
 *
 * No-op layout algorithm. Preserves the X/Y values currently on each
 * node so users can hand-place nodes without an algorithm clobbering
 * positions on the next render.
 *
 * Selecting "Custom" with auto-apply enabled is effectively a no-op
 * on every structural change — useful as a way to disable the
 * configured algorithm without unsetting it.
 */
module.exports =
{
	Name: 'Custom',
	Label: 'Custom (Hand-placed)',
	Description: 'Preserve hand-placed positions. No automatic arrangement.',
	DefaultEdgeTheme: 'Bezier',

	Apply: function (pNodes, pConnections, pParameters)
	{
		// Intentionally empty — Custom is a no-op.
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],164:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-ForcedFromCenter
 *
 * Force-directed simulation in the Fruchterman-Reingold style:
 *   - Spring (attractive) forces along each connection
 *   - Coulomb-style repulsion between every pair of nodes
 *   - Center-attraction force pulling all nodes toward (CenterX, CenterY)
 *   - Cooling schedule: max displacement per iteration shrinks over time
 *
 * Deterministic by default — initial positions for unplaced nodes are
 * generated from a seedable Mulberry32 PRNG (inline implementation, no
 * new dependencies). Tests pin `Seed` to assert byte-identical output.
 *
 * Performance: O(n^2) per iteration. With Iterations=200 this is fine
 * for ~100 nodes; keep ForcedFromCenter for moderate-sized graphs.
 *
 * Numeric parameters (other than Iterations and Seed) are typed
 * `PreciseNumber` so they round-trip cleanly through the
 * ExpressionParser; the simulation coerces back to JS floats via
 * Layout-Coerce. Iterations and Seed stay `Number` because they're
 * loop counters / bitwise-PRNG state.
 */
module.exports =
{
	Name: 'ForcedFromCenter',
	Label: 'Forced from Center',
	Description: 'Spring + repulsion simulation pulling toward a center point.',
	DefaultEdgeTheme: 'Bezier',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing            = libCoerce.toFloat(tmpParams.Spacing,            1.0);
		let tmpIterations         = libCoerce.toInt(tmpParams.Iterations,         200);
		let tmpCenterX            = libCoerce.toFloat(tmpParams.CenterX,            1000);
		let tmpCenterY            = libCoerce.toFloat(tmpParams.CenterY,            750);
		let tmpSpringLength       = libCoerce.toFloat(tmpParams.SpringLength,       200) * tmpSpacing;
		let tmpSpringStiffness    = libCoerce.toFloat(tmpParams.SpringStiffness,    0.05);
		let tmpRepulsion          = libCoerce.toFloat(tmpParams.Repulsion,          8000);
		let tmpCenterAttraction   = libCoerce.toFloat(tmpParams.CenterAttraction,   0.01);
		let tmpCoolingFactor      = libCoerce.toFloat(tmpParams.CoolingFactor,      0.95);
		let tmpInitialTemperature = libCoerce.toFloat(tmpParams.InitialTemperature, 100);
		let tmpSeed               = libCoerce.toInt(tmpParams.Seed,               42);
		let tmpPreservePositions  = !!tmpParams.PreservePositions;
		let tmpInitialSpread      = libCoerce.toFloat(tmpParams.InitialSpread,      400);

		let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

		// Mulberry32 seeded PRNG — deterministic initial-position generator.
		let tmpRand = _makeMulberry32(tmpSeed >>> 0);

		// Initial positions
		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpNode = pNodes[i];
			let tmpHasPosition = (typeof tmpNode.X === 'number' && typeof tmpNode.Y === 'number');
			if (tmpPreservePositions && tmpHasPosition) continue;
			tmpNode.X = tmpCenterX + (tmpRand() - 0.5) * tmpInitialSpread;
			tmpNode.Y = tmpCenterY + (tmpRand() - 0.5) * tmpInitialSpread;
		}

		// Index nodes by hash for connection lookup
		let tmpNodeMap = {};
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpNodeMap[pNodes[i].Hash] = pNodes[i];
		}

		let tmpTemperature = tmpInitialTemperature;

		for (let tmpIter = 0; tmpIter < tmpIterations; tmpIter++)
		{
			// Force accumulators
			let tmpForceX = new Array(pNodes.length).fill(0);
			let tmpForceY = new Array(pNodes.length).fill(0);

			// Repulsion between every pair of nodes
			for (let i = 0; i < pNodes.length; i++)
			{
				let tmpA = pNodes[i];
				for (let j = i + 1; j < pNodes.length; j++)
				{
					let tmpB = pNodes[j];
					let tmpDX = tmpA.X - tmpB.X;
					let tmpDY = tmpA.Y - tmpB.Y;
					let tmpDistSq = tmpDX * tmpDX + tmpDY * tmpDY;
					if (tmpDistSq < 1) tmpDistSq = 1; // avoid singularities
					let tmpDist = Math.sqrt(tmpDistSq);
					let tmpForce = tmpRepulsion / tmpDistSq;
					let tmpFX = (tmpDX / tmpDist) * tmpForce;
					let tmpFY = (tmpDY / tmpDist) * tmpForce;
					tmpForceX[i] += tmpFX;
					tmpForceY[i] += tmpFY;
					tmpForceX[j] -= tmpFX;
					tmpForceY[j] -= tmpFY;
				}
			}

			// Spring forces along connections
			for (let i = 0; i < tmpConnections.length; i++)
			{
				let tmpConn = tmpConnections[i];
				let tmpSource = tmpNodeMap[tmpConn.SourceNodeHash];
				let tmpTarget = tmpNodeMap[tmpConn.TargetNodeHash];
				if (!tmpSource || !tmpTarget) continue;

				let tmpSourceIdx = pNodes.indexOf(tmpSource);
				let tmpTargetIdx = pNodes.indexOf(tmpTarget);
				if (tmpSourceIdx < 0 || tmpTargetIdx < 0) continue;

				let tmpDX = tmpTarget.X - tmpSource.X;
				let tmpDY = tmpTarget.Y - tmpSource.Y;
				let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				if (tmpDist < 0.0001) tmpDist = 0.0001;

				let tmpDelta = tmpDist - tmpSpringLength;
				let tmpForce = tmpSpringStiffness * tmpDelta;
				let tmpFX = (tmpDX / tmpDist) * tmpForce;
				let tmpFY = (tmpDY / tmpDist) * tmpForce;

				tmpForceX[tmpSourceIdx] += tmpFX;
				tmpForceY[tmpSourceIdx] += tmpFY;
				tmpForceX[tmpTargetIdx] -= tmpFX;
				tmpForceY[tmpTargetIdx] -= tmpFY;
			}

			// Center attraction
			for (let i = 0; i < pNodes.length; i++)
			{
				let tmpNode = pNodes[i];
				tmpForceX[i] += (tmpCenterX - tmpNode.X) * tmpCenterAttraction;
				tmpForceY[i] += (tmpCenterY - tmpNode.Y) * tmpCenterAttraction;
			}

			// Apply forces with temperature clamp
			for (let i = 0; i < pNodes.length; i++)
			{
				let tmpNode = pNodes[i];
				let tmpFX = tmpForceX[i];
				let tmpFY = tmpForceY[i];
				let tmpMag = Math.sqrt(tmpFX * tmpFX + tmpFY * tmpFY);
				if (tmpMag > tmpTemperature)
				{
					tmpFX = (tmpFX / tmpMag) * tmpTemperature;
					tmpFY = (tmpFY / tmpMag) * tmpTemperature;
				}
				tmpNode.X += tmpFX;
				tmpNode.Y += tmpFY;
			}

			tmpTemperature *= tmpCoolingFactor;
		}

		// Round to whole pixels for stable rendering and predictable tests
		for (let i = 0; i < pNodes.length; i++)
		{
			pNodes[i].X = Math.round(pNodes[i].X);
			pNodes[i].Y = Math.round(pNodes[i].Y);
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		Iterations: 200,
		CenterX: 1000,
		CenterY: 750,
		SpringLength: 200,
		SpringStiffness: 0.05,
		Repulsion: 8000,
		CenterAttraction: 0.01,
		CoolingFactor: 0.95,
		InitialTemperature: 100,
		Seed: 42,
		PreservePositions: false,
		InitialSpread: 400
	},

	ParameterSchema:
	{
		Spacing:            { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		Iterations:         { Type: 'Number',        Label: 'Iterations',         Default: 200,   Min: 1,    Max: 2000  },
		CenterX:            { Type: 'PreciseNumber', Label: 'Center X',           Default: 1000,  Min: -10000, Max: 10000 },
		CenterY:            { Type: 'PreciseNumber', Label: 'Center Y',           Default: 750,   Min: -10000, Max: 10000 },
		SpringLength:       { Type: 'PreciseNumber', Label: 'Spring length',      Default: 200,   Min: 1,    Max: 2000  },
		SpringStiffness:    { Type: 'PreciseNumber', Label: 'Spring stiffness',   Default: 0.05,  Min: 0,    Max: 1     },
		Repulsion:          { Type: 'PreciseNumber', Label: 'Repulsion',          Default: 8000,  Min: 0,    Max: 100000 },
		CenterAttraction:   { Type: 'PreciseNumber', Label: 'Center attraction',  Default: 0.01,  Min: 0,    Max: 1     },
		CoolingFactor:      { Type: 'PreciseNumber', Label: 'Cooling factor',     Default: 0.95,  Min: 0.5,  Max: 1     },
		InitialTemperature: { Type: 'PreciseNumber', Label: 'Initial temperature', Default: 100,  Min: 1,    Max: 1000  },
		Seed:               { Type: 'Number',        Label: 'Random seed',        Default: 42,    Min: 0,    Max: 2147483647 },
		PreservePositions:  { Type: 'boolean',       Label: 'Preserve positions', Default: false },
		InitialSpread:      { Type: 'PreciseNumber', Label: 'Initial spread',     Default: 400,   Min: 0,    Max: 5000  }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-ForcedFromCenter',
		Sections:
		[
			{ Name: 'Center', Hash: 'PFLCenterSection', Groups: [{ Name: 'Defaults', Hash: 'PFLCenterGroup' }] },
			{ Name: 'Forces', Hash: 'PFLForcesSection', Groups: [{ Name: 'Defaults', Hash: 'PFLForcesGroup' }] },
			{ Name: 'Simulation', Hash: 'PFLSimSection', Groups: [{ Name: 'Defaults', Hash: 'PFLSimGroup' }] },
			{ Name: 'Initialization', Hash: 'PFLInitSection', Groups: [{ Name: 'Defaults', Hash: 'PFLInitGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.CenterX':
			{ Name: 'Center X', Hash: 'CenterX', DataType: 'PreciseNumber', Default: 1000, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.CenterY':
			{ Name: 'Center Y', Hash: 'CenterY', DataType: 'PreciseNumber', Default: 750, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.CenterAttraction':
			{ Name: 'Center attraction', Hash: 'CenterAttraction', DataType: 'PreciseNumber', Default: 0.01, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 2, Width: 12, Min: 0, Max: 1 } },

			'PictFlowLayoutEditor.Parameters.SpringLength':
			{ Name: 'Spring length', Hash: 'SpringLength', DataType: 'PreciseNumber', Default: 200, PictForm: { Section: 'PFLForcesSection', Group: 'PFLForcesGroup', Row: 1, Width: 6, Min: 1, Max: 2000 } },
			'PictFlowLayoutEditor.Parameters.SpringStiffness':
			{ Name: 'Spring stiffness', Hash: 'SpringStiffness', DataType: 'PreciseNumber', Default: 0.05, PictForm: { Section: 'PFLForcesSection', Group: 'PFLForcesGroup', Row: 1, Width: 6, Min: 0, Max: 1 } },
			'PictFlowLayoutEditor.Parameters.Repulsion':
			{ Name: 'Repulsion', Hash: 'Repulsion', DataType: 'PreciseNumber', Default: 8000, PictForm: { Section: 'PFLForcesSection', Group: 'PFLForcesGroup', Row: 2, Width: 12, Min: 0, Max: 100000 } },

			'PictFlowLayoutEditor.Parameters.Iterations':
			{ Name: 'Iterations', Hash: 'Iterations', DataType: 'Number', Default: 200, PictForm: { Section: 'PFLSimSection', Group: 'PFLSimGroup', Row: 1, Width: 6, Min: 1, Max: 2000 } },
			'PictFlowLayoutEditor.Parameters.CoolingFactor':
			{ Name: 'Cooling factor', Hash: 'CoolingFactor', DataType: 'PreciseNumber', Default: 0.95, PictForm: { Section: 'PFLSimSection', Group: 'PFLSimGroup', Row: 1, Width: 6, Min: 0.5, Max: 1 } },
			'PictFlowLayoutEditor.Parameters.InitialTemperature':
			{ Name: 'Initial temperature', Hash: 'InitialTemperature', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLSimSection', Group: 'PFLSimGroup', Row: 2, Width: 12, Min: 1, Max: 1000 } },

			'PictFlowLayoutEditor.Parameters.Seed':
			{ Name: 'Random seed', Hash: 'Seed', DataType: 'Number', Default: 42, PictForm: { Section: 'PFLInitSection', Group: 'PFLInitGroup', Row: 1, Width: 6, Min: 0, Max: 2147483647 } },
			'PictFlowLayoutEditor.Parameters.InitialSpread':
			{ Name: 'Initial spread', Hash: 'InitialSpread', DataType: 'PreciseNumber', Default: 400, PictForm: { Section: 'PFLInitSection', Group: 'PFLInitGroup', Row: 1, Width: 6, Min: 0, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.PreservePositions':
			{ Name: 'Preserve existing positions', Hash: 'PreservePositions', DataType: 'Boolean', Default: false, PictForm: { Section: 'PFLInitSection', Group: 'PFLInitGroup', Row: 2, Width: 12, InputType: 'Boolean' } }
		}
	}
};

function _makeMulberry32(pSeed)
{
	let tmpState = pSeed >>> 0;
	return function ()
	{
		tmpState = (tmpState + 0x6D2B79F5) >>> 0;
		let tmpT = tmpState;
		tmpT = Math.imul(tmpT ^ (tmpT >>> 15), tmpT | 1);
		tmpT ^= tmpT + Math.imul(tmpT ^ (tmpT >>> 7), tmpT | 61);
		return ((tmpT ^ (tmpT >>> 14)) >>> 0) / 4294967296;
	};
}

},{"./Layout-Coerce.js":161}],165:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Grid
 *
 * Auto-arrange nodes in a roughly-square grid. Cell width and height
 * default to the largest node dimensions plus margins. Column count
 * defaults to ceil(sqrt(n)) when `Columns` is 'auto'.
 *
 * Continuous params (margins, cell sizes, origin) are typed
 * `PreciseNumber` so they survive solver chains; the integer column
 * count and the categorical OrderBy stay `Number` / enum.
 */
module.exports =
{
	Name: 'Grid',
	Label: 'Grid',
	Description: 'Auto-arrange in a roughly-square grid.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing          = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpColumnsParam     = tmpParams.Columns;
		let tmpCellWidthParam   = tmpParams.CellWidth;
		let tmpCellHeightParam  = tmpParams.CellHeight;
		let tmpHorizontalMargin = libCoerce.toFloat(tmpParams.HorizontalMargin, 40) * tmpSpacing;
		let tmpVerticalMargin   = libCoerce.toFloat(tmpParams.VerticalMargin, 40) * tmpSpacing;
		let tmpStartX           = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY           = libCoerce.toFloat(tmpParams.StartY, 100);
		let tmpOrderBy          = tmpParams.OrderBy || 'index';

		let tmpColumns;
		if (tmpColumnsParam === 'auto' || tmpColumnsParam == null || tmpColumnsParam === '')
		{
			tmpColumns = Math.max(1, Math.ceil(Math.sqrt(pNodes.length)));
		}
		else
		{
			tmpColumns = Math.max(1, libCoerce.toInt(tmpColumnsParam, Math.max(1, Math.ceil(Math.sqrt(pNodes.length)))));
		}

		// Compute cell dimensions from largest node if not specified
		let tmpMaxWidth = 0;
		let tmpMaxHeight = 0;
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMaxWidth = Math.max(tmpMaxWidth, pNodes[i].Width || 180);
			tmpMaxHeight = Math.max(tmpMaxHeight, pNodes[i].Height || 80);
		}

		let tmpCellWidth  = (tmpCellWidthParam == null)  ? tmpMaxWidth + tmpHorizontalMargin  : libCoerce.toFloat(tmpCellWidthParam,  tmpMaxWidth + tmpHorizontalMargin);
		let tmpCellHeight = (tmpCellHeightParam == null) ? tmpMaxHeight + tmpVerticalMargin : libCoerce.toFloat(tmpCellHeightParam, tmpMaxHeight + tmpVerticalMargin);

		// Ordered iteration
		let tmpOrdered = pNodes.slice();
		if (tmpOrderBy === 'hash')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)));
		}
		else if (tmpOrderBy === 'title')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Title || pA.Hash).localeCompare(String(pB.Title || pB.Hash)));
		}

		for (let i = 0; i < tmpOrdered.length; i++)
		{
			let tmpRow = Math.floor(i / tmpColumns);
			let tmpCol = i % tmpColumns;
			tmpOrdered[i].X = tmpStartX + tmpCol * tmpCellWidth;
			tmpOrdered[i].Y = tmpStartY + tmpRow * tmpCellHeight;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		Columns: 'auto',
		HorizontalMargin: 40,
		VerticalMargin: 40,
		StartX: 100,
		StartY: 100,
		OrderBy: 'index'
	},

	ParameterSchema:
	{
		Spacing:          { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		Columns:          { Type: 'string',        Label: 'Columns',          Default: 'auto', Description: '"auto" or an integer' },
		CellWidth:        { Type: 'PreciseNumber', Label: 'Cell width',       Description: 'Defaults to largest node width + horizontal margin', Min: 1, Max: 5000 },
		CellHeight:       { Type: 'PreciseNumber', Label: 'Cell height',      Description: 'Defaults to largest node height + vertical margin', Min: 1, Max: 5000 },
		HorizontalMargin: { Type: 'PreciseNumber', Label: 'Horizontal margin', Default: 40, Min: 0, Max: 1000 },
		VerticalMargin:   { Type: 'PreciseNumber', Label: 'Vertical margin',   Default: 40, Min: 0, Max: 1000 },
		StartX:           { Type: 'PreciseNumber', Label: 'Start X',          Default: 100, Min: -10000, Max: 10000 },
		StartY:           { Type: 'PreciseNumber', Label: 'Start Y',          Default: 100, Min: -10000, Max: 10000 },
		OrderBy:          { Type: 'enum',          Label: 'Order by',         Default: 'index', Options: ['index', 'hash', 'title'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Grid',
		Sections:
		[
			{ Name: 'Grid Parameters', Hash: 'PFLGridSection', Groups: [{ Name: 'Defaults', Hash: 'PFLGridGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.Columns':
			{ Name: 'Columns ("auto" or integer)', Hash: 'Columns', DataType: 'String', Default: 'auto', PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 1, Width: 6 } },
			'PictFlowLayoutEditor.Parameters.OrderBy':
			{
				Name: 'Order by', Hash: 'OrderBy', DataType: 'String', Default: 'index',
				PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 1, Width: 6, InputType: 'Option', SelectOptions: [{ Value: 'index', Name: 'Index' }, { Value: 'hash', Name: 'Hash' }, { Value: 'title', Name: 'Title' }] }
			},
			'PictFlowLayoutEditor.Parameters.CellWidth':
			{ Name: 'Cell width (auto = blank)', Hash: 'CellWidth', DataType: 'PreciseNumber', PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.CellHeight':
			{ Name: 'Cell height (auto = blank)', Hash: 'CellHeight', DataType: 'PreciseNumber', PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.HorizontalMargin':
			{ Name: 'Horizontal margin', Hash: 'HorizontalMargin', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 3, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.VerticalMargin':
			{ Name: 'Vertical margin', Hash: 'VerticalMargin', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 3, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.StartX':
			{ Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 4, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.StartY':
			{ Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 4, Width: 6, Min: -10000, Max: 10000 } }
		}
	}
};

},{"./Layout-Coerce.js":161}],166:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');
const libRank = require('./Layout-Rank.js');

/**
 * Layout-Layered
 *
 * Cycle-tolerant left-to-right layered layout.
 *
 * This is the original `autoLayout` behavior of pict-section-flow,
 * extracted into a layout-algorithm descriptor. Calling
 * `_LayoutService.autoLayout(nodes, connections)` with no algorithm
 * argument dispatches here, preserving backwards compatibility.
 *
 * Numeric parameters are typed `PreciseNumber` (big.js-backed strings)
 * so they survive ExpressionParser solver chains without float drift;
 * the simulation coerces back to JS floats at entry via Layout-Coerce.
 */
module.exports =
{
	Name: 'Layered',
	Label: 'Layered (Topological)',
	Description: 'Left-to-right layers based on connection topology.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing           = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpHorizontalSpacing = libCoerce.toFloat(tmpParams.HorizontalSpacing, 250) * tmpSpacing;
		let tmpVerticalSpacing   = libCoerce.toFloat(tmpParams.VerticalSpacing, 120) * tmpSpacing;
		let tmpStartX            = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY            = libCoerce.toFloat(tmpParams.StartY, 100);

		let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

		let tmpNodeMap = {};
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpNodeMap[pNodes[i].Hash] = pNodes[i];
		}

		// Rank the nodes into layers, left to right, with cycle breaking. The
		// shared ranker keeps back-edged graphs (workflows, state machines) from
		// collapsing into one tall column the way plain Kahn's topological sort
		// would. See Layout-Rank.js.
		let tmpLayers = libRank.toRanks(pNodes, tmpConnections);

		// Measure each layer's stacked height so layers can be centered on one
		// shared horizontal axis. Without centering every layer top-aligns at
		// StartY, so a one-node layer beside a five-node layer reads as a
		// diagonal drift down the page instead of a balanced band.
		let tmpLayerHeights = [];
		let tmpMaxLayerHeight = 0;
		for (let l = 0; l < tmpLayers.length; l++)
		{
			let tmpHeight = 0;
			for (let i = 0; i < tmpLayers[l].length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayers[l][i]];
				tmpHeight += (tmpNode && tmpNode.Height) ? tmpNode.Height : 80;
				if (i > 0) tmpHeight += tmpVerticalSpacing;
			}
			tmpLayerHeights.push(tmpHeight);
			if (tmpHeight > tmpMaxLayerHeight) tmpMaxLayerHeight = tmpHeight;
		}

		// Assign positions: one column per layer, each layer vertically centered.
		let tmpCurrentX = tmpStartX;

		for (let tmpLayerIndex = 0; tmpLayerIndex < tmpLayers.length; tmpLayerIndex++)
		{
			let tmpLayer = tmpLayers[tmpLayerIndex];
			let tmpMaxWidth = 0;
			let tmpCurrentY = tmpStartY + ((tmpMaxLayerHeight - tmpLayerHeights[tmpLayerIndex]) / 2);

			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (!tmpNode) continue;

				tmpNode.X = tmpCurrentX;
				tmpNode.Y = tmpCurrentY;

				let tmpWidth = tmpNode.Width || 180;
				let tmpHeight = tmpNode.Height || 80;

				tmpMaxWidth = Math.max(tmpMaxWidth, tmpWidth);
				tmpCurrentY += tmpHeight + tmpVerticalSpacing;
			}

			tmpCurrentX += tmpMaxWidth + tmpHorizontalSpacing;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		HorizontalSpacing: 250,
		VerticalSpacing: 120,
		StartX: 100,
		StartY: 100
	},

	ParameterSchema:
	{
		Spacing:           { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		HorizontalSpacing: { Type: 'PreciseNumber', Label: 'Horizontal spacing', Default: 250, Min: 0, Max: 1000 },
		VerticalSpacing:   { Type: 'PreciseNumber', Label: 'Vertical spacing',   Default: 120, Min: 0, Max: 1000 },
		StartX:            { Type: 'PreciseNumber', Label: 'Start X',            Default: 100, Min: -10000, Max: 10000 },
		StartY:            { Type: 'PreciseNumber', Label: 'Start Y',            Default: 100, Min: -10000, Max: 10000 }
	},

	// Manyfest descriptor catalog consumed by pict-section-form's metacontroller.
	// Descriptor keys are full data paths relative to the marshal destination
	// (default `AppData`); the toolbar binds `AppData.PictFlowLayoutEditor.Parameters`
	// to the active flow's `_FlowData.LayoutParameters` before injecting.
	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Layered',
		Sections:
		[
			{ Name: 'Layered Parameters', Hash: 'PictFlowLayoutSection', Groups: [{ Name: 'Defaults', Hash: 'PictFlowLayoutGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{
				Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 }
			},
			'PictFlowLayoutEditor.Parameters.HorizontalSpacing':
			{
				Name: 'Horizontal spacing', Hash: 'HorizontalSpacing', DataType: 'PreciseNumber', Default: 250,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 1, Width: 6, Min: 0, Max: 1000 }
			},
			'PictFlowLayoutEditor.Parameters.VerticalSpacing':
			{
				Name: 'Vertical spacing', Hash: 'VerticalSpacing', DataType: 'PreciseNumber', Default: 120,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 1, Width: 6, Min: 0, Max: 1000 }
			},
			'PictFlowLayoutEditor.Parameters.StartX':
			{
				Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 2, Width: 6, Min: -10000, Max: 10000 }
			},
			'PictFlowLayoutEditor.Parameters.StartY':
			{
				Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 2, Width: 6, Min: -10000, Max: 10000 }
			}
		}
	}
};

},{"./Layout-Coerce.js":161,"./Layout-Rank.js":167}],167:[function(require,module,exports){
/**
 * Layout-Rank
 *
 * Shared cycle-tolerant topological ranking for the directed layouts
 * (Layered, Staggered).
 *
 * Plain Kahn's topological sort drops every node that participates in a cycle
 * into a single trailing rank. Any graph with back-edges (workflows, state
 * machines: rejections, retries, "send back") therefore collapses into one
 * tall stripe of unranked nodes, which is the historical "auto-layout bunches
 * everything together and is useless" behavior.
 *
 * `toRanks` instead breaks each cycle at its most-resolved node: when a round
 * finds nothing dependency-free but nodes remain, it forces the unassigned
 * node with the fewest unmet predecessors into the next rank and continues.
 * Cyclic graphs then rank left to right the same way a DAG does.
 *
 * Returns an array of ranks; each rank is an array of node Hashes in stable
 * source order. Self-loops are ignored for ranking (they cannot define an
 * order). Callers map Hashes back to node objects themselves.
 */
function toRanks(pNodes, pConnections)
{
	let tmpRanks = [];
	if (!pNodes || pNodes.length === 0)
	{
		return tmpRanks;
	}

	let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

	let tmpInDegree = {};
	let tmpOutEdges = {};
	for (let i = 0; i < pNodes.length; i++)
	{
		tmpInDegree[pNodes[i].Hash] = 0;
		tmpOutEdges[pNodes[i].Hash] = [];
	}

	for (let i = 0; i < tmpConnections.length; i++)
	{
		let tmpConn = tmpConnections[i];
		// A self-loop cannot define a rank order; skip it.
		if (tmpConn.SourceNodeHash === tmpConn.TargetNodeHash)
		{
			continue;
		}
		if (tmpInDegree.hasOwnProperty(tmpConn.TargetNodeHash))
		{
			tmpInDegree[tmpConn.TargetNodeHash]++;
		}
		if (tmpOutEdges.hasOwnProperty(tmpConn.SourceNodeHash))
		{
			tmpOutEdges[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
		}
	}

	let tmpAssigned = {};
	let tmpAssignedCount = 0;

	while (tmpAssignedCount < pNodes.length)
	{
		let tmpRank = [];

		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpHash = pNodes[i].Hash;
			if (!tmpAssigned[tmpHash] && tmpInDegree[tmpHash] <= 0)
			{
				tmpRank.push(tmpHash);
			}
		}

		if (tmpRank.length === 0)
		{
			// Cycle break: nothing is dependency-free, so force the unassigned
			// node with the fewest remaining predecessors (ties keep source
			// order, which keeps the result stable across runs).
			let tmpMinDegree = Infinity;
			let tmpPick = null;
			for (let i = 0; i < pNodes.length; i++)
			{
				let tmpHash = pNodes[i].Hash;
				if (!tmpAssigned[tmpHash] && tmpInDegree[tmpHash] < tmpMinDegree)
				{
					tmpMinDegree = tmpInDegree[tmpHash];
					tmpPick = tmpHash;
				}
			}
			if (tmpPick === null)
			{
				break; // safety; every node is already assigned
			}
			tmpRank.push(tmpPick);
		}

		// Commit the whole rank, then relax its out-edges so the next round
		// sees the successors it just freed.
		for (let i = 0; i < tmpRank.length; i++)
		{
			tmpAssigned[tmpRank[i]] = true;
			tmpAssignedCount++;
		}
		for (let i = 0; i < tmpRank.length; i++)
		{
			let tmpEdges = tmpOutEdges[tmpRank[i]] || [];
			for (let j = 0; j < tmpEdges.length; j++)
			{
				tmpInDegree[tmpEdges[j]]--;
			}
		}

		tmpRanks.push(tmpRank);
	}

	return tmpRanks;
}

/**
 * Flatten ranks to a single ordered list of node Hashes (rank by rank, source
 * order within a rank). Convenience for layouts that walk one sequence.
 */
function toOrder(pNodes, pConnections)
{
	let tmpRanks = toRanks(pNodes, pConnections);
	let tmpOrder = [];
	for (let i = 0; i < tmpRanks.length; i++)
	{
		for (let j = 0; j < tmpRanks[i].length; j++)
		{
			tmpOrder.push(tmpRanks[i][j]);
		}
	}
	return tmpOrder;
}

module.exports =
{
	toRanks: toRanks,
	toOrder: toOrder
};

},{}],168:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');
const libRank = require('./Layout-Rank.js');

/**
 * Layout-Staggered
 *
 * Serpentine "stairstep" layout for directed graphs. It ranks the nodes left
 * to right by connection topology (the same cycle-tolerant ranking the Layered
 * layout uses), then walks that ordered sequence along a band that steps down a
 * few rows and back up, advancing horizontally at every node.
 *
 * The point is vertical-space efficiency: a long directed chain (a workflow, a
 * delivery pipeline, a state machine) laid out purely left to right runs off
 * the right edge of the canvas. Folding it into a stairstep band keeps the
 * left-to-right reading order while using the height of the viewport, so the
 * whole graph frames at a usable zoom.
 *
 * `Rows` sets how deep the band steps before folding back: 2 is a simple
 * zigzag (odd nodes high, even nodes low); 3+ is a deeper stairstep. The row
 * index follows a triangle wave so the band descends and then climbs rather
 * than snapping back to the top between runs.
 *
 * Numeric parameters are typed `PreciseNumber` so they survive ExpressionParser
 * solver chains; Layout-Coerce converts them back to JS floats at entry.
 */
module.exports =
{
	Name: 'Staggered',
	Label: 'Staggered (Stairstep)',
	Description: 'Topological order folded along a serpentine stairstep band.',
	DefaultEdgeTheme: 'Perimeter',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing       = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpRows          = Math.max(1, libCoerce.toInt(tmpParams.Rows, 2));
		let tmpColumnSpacing = libCoerce.toFloat(tmpParams.ColumnSpacing, 80) * tmpSpacing;
		let tmpRowOffset     = libCoerce.toFloat(tmpParams.RowOffset, 150) * tmpSpacing;
		let tmpStartX        = libCoerce.toFloat(tmpParams.StartX, 80);
		let tmpStartY        = libCoerce.toFloat(tmpParams.StartY, 80);

		let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

		let tmpNodeMap = {};
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpNodeMap[pNodes[i].Hash] = pNodes[i];
		}

		let tmpOrder = libRank.toOrder(pNodes, tmpConnections);

		// A uniform column pitch (the widest node plus the spacing) keeps the
		// stairstep diagonal even regardless of individual node widths.
		let tmpMaxWidth = 0;
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMaxWidth = Math.max(tmpMaxWidth, pNodes[i].Width || 180);
		}
		let tmpColumnPitch = tmpMaxWidth + tmpColumnSpacing;

		// Triangle wave: descend (Rows - 1) steps, then climb (Rows - 1) steps.
		let tmpPeriod = (tmpRows > 1) ? (2 * (tmpRows - 1)) : 1;

		for (let i = 0; i < tmpOrder.length; i++)
		{
			let tmpNode = tmpNodeMap[tmpOrder[i]];
			if (!tmpNode) continue;

			let tmpRow;
			if (tmpRows <= 1)
			{
				tmpRow = 0;
			}
			else
			{
				let tmpPhase = i % tmpPeriod;
				tmpRow = (tmpPhase < tmpRows) ? tmpPhase : (tmpPeriod - tmpPhase);
			}

			tmpNode.X = tmpStartX + (i * tmpColumnPitch);
			tmpNode.Y = tmpStartY + (tmpRow * tmpRowOffset);
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		Rows: 2,
		ColumnSpacing: 80,
		RowOffset: 150,
		StartX: 80,
		StartY: 80
	},

	ParameterSchema:
	{
		Spacing:       { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		Rows:          { Type: 'Number',        Label: 'Rows',          Default: 2,   Min: 1, Max: 12 },
		ColumnSpacing: { Type: 'PreciseNumber', Label: 'Column spacing', Default: 80,  Min: 0, Max: 1000 },
		RowOffset:     { Type: 'PreciseNumber', Label: 'Row offset',    Default: 150, Min: 0, Max: 1000 },
		StartX:        { Type: 'PreciseNumber', Label: 'Start X',       Default: 80,  Min: -10000, Max: 10000 },
		StartY:        { Type: 'PreciseNumber', Label: 'Start Y',       Default: 80,  Min: -10000, Max: 10000 }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Staggered',
		Sections:
		[
			{ Name: 'Staggered Parameters', Hash: 'PFLStaggeredSection', Groups: [{ Name: 'Defaults', Hash: 'PFLStaggeredGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLStaggeredSection', Group: 'PFLStaggeredGroup', Row: 0, Width: 6, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.Rows':
			{ Name: 'Rows', Hash: 'Rows', DataType: 'Number', Default: 2, PictForm: { Section: 'PFLStaggeredSection', Group: 'PFLStaggeredGroup', Row: 0, Width: 6, Min: 1, Max: 12 } },
			'PictFlowLayoutEditor.Parameters.ColumnSpacing':
			{ Name: 'Column spacing', Hash: 'ColumnSpacing', DataType: 'PreciseNumber', Default: 80, PictForm: { Section: 'PFLStaggeredSection', Group: 'PFLStaggeredGroup', Row: 1, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.RowOffset':
			{ Name: 'Row offset', Hash: 'RowOffset', DataType: 'PreciseNumber', Default: 150, PictForm: { Section: 'PFLStaggeredSection', Group: 'PFLStaggeredGroup', Row: 1, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.StartX':
			{ Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 80, PictForm: { Section: 'PFLStaggeredSection', Group: 'PFLStaggeredGroup', Row: 2, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.StartY':
			{ Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 80, PictForm: { Section: 'PFLStaggeredSection', Group: 'PFLStaggeredGroup', Row: 2, Width: 6, Min: -10000, Max: 10000 } }
		}
	}
};

},{"./Layout-Coerce.js":161,"./Layout-Rank.js":167}],169:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Tabular
 *
 * Vertical single-column flow. Nodes are stacked top-to-bottom with
 * VerticalSpacing between successive rows.
 */
module.exports =
{
	Name: 'Tabular',
	Label: 'Tabular (Top-to-Bottom)',
	Description: 'Single column, top-to-bottom.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing         = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpStartX          = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY          = libCoerce.toFloat(tmpParams.StartY, 100);
		let tmpVerticalSpacing = libCoerce.toFloat(tmpParams.VerticalSpacing, 40) * tmpSpacing;
		let tmpRowHeightParam  = tmpParams.RowHeight;
		let tmpOrderBy         = tmpParams.OrderBy || 'index';

		let tmpOrdered = pNodes.slice();
		if (tmpOrderBy === 'hash')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)));
		}
		else if (tmpOrderBy === 'title')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Title || pA.Hash).localeCompare(String(pB.Title || pB.Hash)));
		}

		let tmpY = tmpStartY;
		for (let i = 0; i < tmpOrdered.length; i++)
		{
			let tmpNode = tmpOrdered[i];
			tmpNode.X = tmpStartX;
			tmpNode.Y = tmpY;
			let tmpRowHeight = (tmpRowHeightParam == null) ? (tmpNode.Height || 80) : libCoerce.toFloat(tmpRowHeightParam, tmpNode.Height || 80);
			tmpY += tmpRowHeight + tmpVerticalSpacing;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		StartX: 100,
		StartY: 100,
		VerticalSpacing: 40,
		OrderBy: 'index'
	},

	ParameterSchema:
	{
		Spacing:         { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		StartX:          { Type: 'PreciseNumber', Label: 'Start X',          Default: 100, Min: -10000, Max: 10000 },
		StartY:          { Type: 'PreciseNumber', Label: 'Start Y',          Default: 100, Min: -10000, Max: 10000 },
		VerticalSpacing: { Type: 'PreciseNumber', Label: 'Vertical spacing', Default: 40,  Min: 0, Max: 1000 },
		RowHeight:       { Type: 'PreciseNumber', Label: 'Row height',       Description: 'Defaults to each node\'s own height', Min: 1, Max: 5000 },
		OrderBy:         { Type: 'enum',          Label: 'Order by',         Default: 'index', Options: ['index', 'hash', 'title'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Tabular',
		Sections:
		[
			{ Name: 'Tabular Parameters', Hash: 'PFLTabularSection', Groups: [{ Name: 'Defaults', Hash: 'PFLTabularGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.StartX':
			{ Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.StartY':
			{ Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.VerticalSpacing':
			{ Name: 'Vertical spacing', Hash: 'VerticalSpacing', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 2, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.RowHeight':
			{ Name: 'Row height (auto = blank)', Hash: 'RowHeight', DataType: 'PreciseNumber', PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.OrderBy':
			{
				Name: 'Order by', Hash: 'OrderBy', DataType: 'String', Default: 'index',
				PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 3, Width: 12, InputType: 'Option', SelectOptions: [{ Value: 'index', Name: 'Index' }, { Value: 'hash', Name: 'Hash' }, { Value: 'title', Name: 'Title' }] }
			}
		}
	}
};

},{"./Layout-Coerce.js":161}],170:[function(require,module,exports){
/**
 * Pict Provider: Theme
 *
 * Runtime theme manager for Pict applications.  Registers theme bundles
 * (token maps + CSS + SVG + image assets) and applies them by injecting
 * CSS custom properties into a single <style id="pict-theme"> element.
 *
 * Themes can be:
 *   - Single-mode (Modes.Strategy = "single")
 *   - Paired light/dark (Modes.Strategy = "paired")
 *   - System-aware (Modes.Strategy = "system" — paired + auto-pick)
 *
 * Mode is reflected as `theme-light` / `theme-dark` class on <html>.
 *
 * Token resolution path examples:
 *   provider.token('Tokens.Color.Background.Primary') -> raw current value
 *   provider.cssVar('Color.Background.Primary')       -> 'var(--theme-color-background-primary)'
 *   provider.asset('SVG', 'Logo')                     -> SVG string
 *   provider.image('Hero')                            -> image URL / data URL
 *
 * Template expressions registered (when pict has addTemplate):
 *   {~Theme:Tokens.Color.Background.Primary~}    raw value
 *   {~ThemeVar:Color.Background.Primary~}        var(--theme-...) reference
 *   {~ThemeAsset:SVG.Logo~}                      asset content
 *   {~ThemeImage:Hero~}                          image URL
 *
 * Stateless: this provider does not persist anything.  Host applications
 * decide what to apply at boot (from localStorage, server config, etc.).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */
const libPictProvider = require('pict-provider');
const libDiagramAdapter = require('./Theme-Diagram-Adapter.js');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

const STYLE_ELEMENT_ID = 'pict-theme';
const HTML_CLASS_LIGHT = 'theme-light';
const HTML_CLASS_DARK = 'theme-dark';
const CSS_VAR_PREFIX = '--theme-';

class PictProviderTheme extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictProviderTheme';

		this._themes = {};
		this._themeOrder = [];
		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		this._registeredCSSHashes = [];
		this._applyListeners = [];

		// Diagram adapter: helper API for plugging Mermaid (and any
		// future SVG-baking diagram engine) into the theme lifecycle.
		// Exposes the same functions as the standalone require, plus
		// `adaptMermaid(mermaid, options)` bound to this provider.
		let tmpSelf = this;
		this.diagram =
		{
			MERMAID_TOKEN_MAP:           libDiagramAdapter.MERMAID_TOKEN_MAP,
			readCSSVar:                  libDiagramAdapter.readCSSVar,
			getMermaidTokenMap:          libDiagramAdapter.getMermaidTokenMap,
			buildMermaidThemeVariables:  libDiagramAdapter.buildMermaidThemeVariables,
			initializeMermaid:           libDiagramAdapter.initializeMermaid,
			stashMermaidSource:          libDiagramAdapter.stashMermaidSource,
			refreshMermaidDiagrams:      libDiagramAdapter.refreshMermaidDiagrams,
			stripMermaidStyleImportance: libDiagramAdapter.stripMermaidStyleImportance,
			adaptMermaid: function (pMermaid, pOptions)
			{
				return libDiagramAdapter.adaptMermaid(tmpSelf, pMermaid, pOptions);
			}
		};

		// Auto-register the four theme template expressions if the host pict
		// supports addTemplate.  In bare-fable/test contexts this is skipped.
		if (this.pict && typeof this.pict.addTemplate === 'function')
		{
			try
			{
				this.pict.addTemplate(require('./templates/Pict-Template-Theme.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeVar.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeAsset.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeImage.js'));
			}
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: template registration skipped: ' + pError.message);
			}
		}
	}

	// ================================================================
	// Theme registration
	// ================================================================

	/**
	 * Register a theme bundle.  Bundle is the compiled JSON shape (see
	 * the manifest schema documented in the module README and example themes).
	 *
	 * @param {object} pBundle - parsed manifest object
	 * @returns {boolean} true on success
	 */
	registerTheme(pBundle)
	{
		if (!pBundle || typeof pBundle !== 'object')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle is not an object');
			return false;
		}
		if (!pBundle.Hash || typeof pBundle.Hash !== 'string')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle missing required string Hash');
			return false;
		}

		if (!this._themes[pBundle.Hash])
		{
			this._themeOrder.push(pBundle.Hash);
		}
		this._themes[pBundle.Hash] = pBundle;
		return true;
	}

	/**
	 * Get an array of registered theme metadata for building UIs.
	 * @returns {Array<{Hash, Name, Version, Strategy, DefaultMode, Comprehensive}>}
	 */
	listThemes()
	{
		let tmpList = [];
		for (let i = 0; i < this._themeOrder.length; i++)
		{
			let tmpHash = this._themeOrder[i];
			let tmpTheme = this._themes[tmpHash];
			let tmpModes = tmpTheme.Modes || {};
			tmpList.push(
			{
				Hash: tmpTheme.Hash,
				Name: tmpTheme.Name || tmpTheme.Hash,
				Version: tmpTheme.Version || null,
				Strategy: tmpModes.Strategy || 'single',
				DefaultMode: tmpModes.Default || 'light',
				Comprehensive: tmpTheme.Comprehensive !== false
			});
		}
		return tmpList;
	}

	/**
	 * Get the raw stored bundle for a hash.
	 */
	getTheme(pHash)
	{
		return this._themes[pHash] || null;
	}

	// ================================================================
	// Apply / unapply
	// ================================================================

	/**
	 * Apply a theme by hash.  Optionally specify mode ('light', 'dark', 'system').
	 * If pMode is omitted, the theme's Modes.Default is used.
	 *
	 * @param {string} pHash
	 * @param {string} [pMode]
	 * @returns {boolean}
	 */
	applyTheme(pHash, pMode)
	{
		let tmpTheme = this._themes[pHash];
		if (!tmpTheme)
		{
			if (this.log) this.log.warn(`PictProviderTheme.applyTheme: unknown theme hash [${pHash}]`);
			return false;
		}

		// Resolve the effective theme bundle (handle BasedOn inheritance).
		let tmpEffective = this._resolveBundle(tmpTheme);

		let tmpStrategy = (tmpEffective.Modes && tmpEffective.Modes.Strategy) || 'single';
		let tmpDefaultMode = (tmpEffective.Modes && tmpEffective.Modes.Default) || 'light';

		let tmpMode = pMode || tmpDefaultMode;

		// Single-mode themes cannot be put into dark/light/system; clamp.
		if (tmpStrategy === 'single')
		{
			tmpMode = tmpDefaultMode;
		}

		this._activeHash = pHash;
		this._activeMode = tmpMode;

		// Build CSS once, regardless of mode (paired themes emit both blocks
		// and rely on the html class to switch between them).
		let tmpCSS = this._buildThemeCSS(tmpEffective);
		this._injectStyleElement(tmpCSS);

		// Register any auxiliary CSS files declared in the bundle through the
		// Pict CSS cascade so they participate in injectCSS().
		this._registerAuxiliaryCSS(tmpEffective);

		// Set the html class to drive paired-theme variable resolution.
		this._applyMode(tmpMode, tmpStrategy);

		// Notify subscribers (e.g. apps that need to re-color SVG icon palettes
		// from a bundle.IconColors block, swap chart palettes, etc.).
		this._fireApplyListeners(tmpEffective);

		return true;
	}

	/**
	 * Change mode without reapplying the theme.  No-op if no theme is active
	 * or active theme is single-mode.
	 *
	 * @param {string} pMode - 'light' | 'dark' | 'system'
	 */
	setMode(pMode)
	{
		if (!this._activeHash) return false;

		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpStrategy = (tmpTheme.Modes && tmpTheme.Modes.Strategy) || 'single';

		if (tmpStrategy === 'single') return false;

		this._activeMode = pMode;
		this._applyMode(pMode, tmpStrategy);
		this._fireApplyListeners(tmpTheme);
		return true;
	}

	// ================================================================
	// Listener subscription
	// ================================================================

	/**
	 * Subscribe to theme apply / mode-change events.  The callback is
	 * invoked with the effective (BasedOn-resolved) bundle and a context
	 * object: { Hash, Mode, ResolvedMode }.
	 *
	 * Apps use this to re-color SVG icon palettes, swap chart colors,
	 * push tokens into non-CSS consumers (canvas, WebGL), etc.
	 *
	 * Returns a dispose function for symmetry with offApply().
	 */
	onApply(fCallback)
	{
		if (typeof fCallback !== 'function') return function () {};
		this._applyListeners.push(fCallback);
		let tmpSelf = this;
		return function () { tmpSelf.offApply(fCallback); };
	}

	offApply(fCallback)
	{
		let tmpIdx = this._applyListeners.indexOf(fCallback);
		if (tmpIdx >= 0) this._applyListeners.splice(tmpIdx, 1);
	}

	_fireApplyListeners(pBundle)
	{
		if (this._applyListeners.length === 0) return;
		let tmpContext =
		{
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._resolvedMode
		};
		for (let i = 0; i < this._applyListeners.length; i++)
		{
			try { this._applyListeners[i](pBundle, tmpContext); }
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: onApply listener threw: ' + pError.message);
			}
		}
	}

	/**
	 * Remove the injected style element, html class, and any auxiliary CSS.
	 */
	unapplyTheme()
	{
		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode)
			{
				tmpStyleEl.parentNode.removeChild(tmpStyleEl);
			}
			if (document.documentElement && document.documentElement.classList)
			{
				document.documentElement.classList.remove(HTML_CLASS_LIGHT);
				document.documentElement.classList.remove(HTML_CLASS_DARK);
			}
		}

		// Unregister any auxiliary CSS we added.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		return true;
	}

	getActiveTheme()
	{
		// Live-read ResolvedMode so callers in system mode get the current OS
		// preference without the provider having to subscribe to media-query
		// changes.  Snapshot mode (explicit light/dark) returns as-is.
		return {
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._activeHash ? this._currentResolvedMode() : null
		};
	}

	// ================================================================
	// Token / asset accessors
	// ================================================================

	/**
	 * Resolve a token by dot path against the active theme bundle.  Walks
	 * the entire bundle root, so paths can address Tokens, Brand, etc.
	 *
	 * If the value is paired ({Light, Dark}), returns the value at the
	 * currently resolved mode.
	 *
	 * @param {string} pPath - e.g. 'Tokens.Color.Background.Primary'
	 * @returns {string|number|null}
	 */
	token(pPath)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpValue = this._walkPath(tmpTheme, pPath);
		return this._resolveModedValue(tmpValue);
	}

	/**
	 * Returns a CSS `var(--theme-...)` reference for a token under Tokens.
	 * Path is given without the Tokens prefix:
	 *   cssVar('Color.Background.Primary') -> 'var(--theme-color-background-primary)'
	 *
	 * @param {string} pTokenPath
	 * @returns {string}
	 */
	cssVar(pTokenPath)
	{
		return 'var(' + this._cssVarName(pTokenPath) + ')';
	}

	/**
	 * Look up a named asset under SVG, optionally nested (e.g. 'Icons.Foo').
	 * @param {string} pCategory - 'SVG' | 'Image'
	 * @param {string} pName
	 */
	asset(pCategory, pName)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpRoot = tmpTheme[pCategory];
		if (!tmpRoot) return null;
		return this._walkPath(tmpRoot, pName);
	}

	image(pName)
	{
		return this.asset('Image', pName);
	}

	svg(pName)
	{
		return this.asset('SVG', pName);
	}

	// ================================================================
	// Internals
	// ================================================================

	/**
	 * Resolve a bundle's BasedOn chain into a single effective bundle by
	 * deep-merging this bundle onto its base.  Cycle-safe.
	 */
	_resolveBundle(pBundle)
	{
		let tmpChain = [];
		let tmpCurrent = pBundle;
		let tmpSeen = {};
		while (tmpCurrent)
		{
			if (tmpSeen[tmpCurrent.Hash]) break;
			tmpSeen[tmpCurrent.Hash] = true;
			tmpChain.unshift(tmpCurrent);
			let tmpBaseHash = tmpCurrent.BasedOn;
			tmpCurrent = tmpBaseHash ? this._themes[tmpBaseHash] : null;
		}
		if (tmpChain.length === 1) return tmpChain[0];

		let tmpResult = {};
		for (let i = 0; i < tmpChain.length; i++)
		{
			tmpResult = this._deepMerge(tmpResult, tmpChain[i]);
		}
		return tmpResult;
	}

	_deepMerge(pTarget, pSource)
	{
		let tmpResult = Object.assign({}, pTarget);
		let tmpKeys = Object.keys(pSource);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpVal = pSource[tmpKey];
			if (tmpVal !== null
				&& typeof tmpVal === 'object'
				&& !Array.isArray(tmpVal)
				&& tmpResult[tmpKey] !== null
				&& typeof tmpResult[tmpKey] === 'object'
				&& !Array.isArray(tmpResult[tmpKey]))
			{
				tmpResult[tmpKey] = this._deepMerge(tmpResult[tmpKey], tmpVal);
			}
			else
			{
				tmpResult[tmpKey] = tmpVal;
			}
		}
		return tmpResult;
	}

	/**
	 * Walk a dot-path from a starting object.  Returns null if any segment
	 * is missing.  Path segments are matched case-sensitively as authored.
	 */
	_walkPath(pRoot, pPath)
	{
		if (!pRoot || !pPath) return null;
		let tmpSegments = pPath.split('.');
		let tmpNode = pRoot;
		for (let i = 0; i < tmpSegments.length; i++)
		{
			if (tmpNode === null || typeof tmpNode !== 'object') return null;
			tmpNode = tmpNode[tmpSegments[i]];
			if (typeof tmpNode === 'undefined') return null;
		}
		return tmpNode;
	}

	/**
	 * If pValue is a paired-mode object {Light, Dark}, pick the value matching
	 * the current resolved mode.  Otherwise return as-is.
	 *
	 * For system mode this re-reads the OS preference on every call so the
	 * value is always live-correct — no JS listener required to keep it in
	 * sync.  Explicit modes use the snapshotted `_resolvedMode`.
	 */
	_resolveModedValue(pValue)
	{
		if (this._isPairedValue(pValue))
		{
			let tmpMode = this._currentResolvedMode();
			let tmpKey = (tmpMode === 'dark') ? 'Dark' : 'Light';
			return pValue[tmpKey];
		}
		return pValue;
	}

	_isPairedValue(pValue)
	{
		return pValue !== null
			&& typeof pValue === 'object'
			&& !Array.isArray(pValue)
			&& Object.keys(pValue).length > 0
			&& Object.keys(pValue).every((k) => k === 'Light' || k === 'Dark');
	}

	/**
	 * Build the CSS string for a theme.
	 *
	 * Single-mode themes emit one `:root { ... }` block.
	 *
	 * Paired themes emit four blocks, ordered so the CSS cascade resolves
	 * to the right mode without any JS listeners:
	 *
	 *   1) `:root { ...light... }`                                — baseline
	 *   2) `@media (prefers-color-scheme: dark) { :root { ...dark... } }`
	 *                                                            — OS-driven
	 *   3) `.theme-light { ...light... }`                         — explicit override
	 *   4) `.theme-dark  { ...dark... }`                          — explicit override
	 *
	 * Mode = 'system' is "no class on <html>" — the @media rule drives.
	 * Mode = 'light'/'dark' adds the matching class which wins on tie via
	 * source order (same specificity as :root, but later in the file).
	 *
	 * The result: OS toggle moves the page via CSS alone, no DOM listener
	 * needed, no class flipping.  Explicit setMode() flips the class to
	 * lock the page to one mode regardless of OS preference.
	 *
	 * Only values under bundle.Tokens become CSS custom properties.
	 */
	_buildThemeCSS(pTheme)
	{
		let tmpTokens = pTheme.Tokens || {};
		let tmpFlat = this._flattenTokens(tmpTokens, '');

		let tmpStrategy = (pTheme.Modes && pTheme.Modes.Strategy) || 'single';
		let tmpHasPaired = tmpFlat.some((tmpEntry) => this._isPairedValue(tmpEntry.Value));

		let tmpAliasLines = this._buildAliasLines(pTheme.Aliases);

		if (tmpStrategy === 'single' || !tmpHasPaired)
		{
			let tmpCSS = ':root {\n';
			for (let i = 0; i < tmpFlat.length; i++)
			{
				let tmpEntry = tmpFlat[i];
				let tmpVal = this._isPairedValue(tmpEntry.Value)
					? tmpEntry.Value.Light
					: tmpEntry.Value;
				tmpCSS += '\t' + this._cssVarName(tmpEntry.Path) + ': ' + this._formatCSSValue(tmpVal) + ';\n';
			}
			tmpCSS += tmpAliasLines;
			tmpCSS += '}\n';
			return tmpCSS;
		}

		// Paired theme: emit the four-block cascade.
		let tmpLightLines = '';
		let tmpDarkLines = '';
		let tmpFixedLines = '';

		for (let i = 0; i < tmpFlat.length; i++)
		{
			let tmpEntry = tmpFlat[i];
			let tmpVarName = this._cssVarName(tmpEntry.Path);
			if (this._isPairedValue(tmpEntry.Value))
			{
				if (typeof tmpEntry.Value.Light !== 'undefined')
				{
					tmpLightLines += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Light) + ';\n';
				}
				if (typeof tmpEntry.Value.Dark !== 'undefined')
				{
					tmpDarkLines += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Dark) + ';\n';
				}
			}
			else
			{
				// Non-paired tokens (spacing, typography, etc.) live in :root only.
				tmpFixedLines += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value) + ';\n';
			}
		}

		// Block 1: :root holds light values + every non-paired token + aliases.
		// Aliases use var() indirection, so they resolve to the active mode
		// automatically without being duplicated in the dark blocks.
		let tmpCSS = ':root {\n' + tmpLightLines + tmpFixedLines + tmpAliasLines + '}\n';

		// Block 2: @media (prefers-color-scheme: dark) — OS-driven dark override.
		// Only the paired tokens need to flip; fixed tokens and aliases stay
		// the same.  Indented one level for readability.
		let tmpMediaInner = '';
		let tmpDarkLinesIndented = tmpDarkLines.replace(/^\t/gm, '\t\t');
		tmpMediaInner += '\t:root {\n' + tmpDarkLinesIndented + '\t}\n';
		tmpCSS += '@media (prefers-color-scheme: dark) {\n' + tmpMediaInner + '}\n';

		// Block 3: .theme-light — explicit override that locks light regardless of OS.
		tmpCSS += '.' + HTML_CLASS_LIGHT + ' {\n' + tmpLightLines + '}\n';

		// Block 4: .theme-dark — explicit override that locks dark regardless of OS.
		tmpCSS += '.' + HTML_CLASS_DARK + ' {\n' + tmpDarkLines + '}\n';

		return tmpCSS;
	}

	/**
	 * Emit alias lines for legacy CSS variable names that map to token paths
	 * under Tokens.  Each alias becomes:
	 *   --legacy-name: var(--theme-color-...);
	 * Indirection-via-var means paired-mode swap propagates without
	 * needing alias entries duplicated in the .theme-dark block.
	 *
	 * Authored as: { "--legacy-name": "Color.Background.Primary", ... }
	 */
	_buildAliasLines(pAliases)
	{
		if (!pAliases || typeof pAliases !== 'object') return '';
		let tmpKeys = Object.keys(pAliases);
		let tmpOut = '';
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpAlias = tmpKeys[i];
			let tmpTarget = pAliases[tmpAlias];
			if (typeof tmpTarget !== 'string' || tmpTarget.length === 0) continue;
			tmpOut += '\t' + tmpAlias + ': var(' + this._cssVarName(tmpTarget) + ');\n';
		}
		return tmpOut;
	}

	/**
	 * Walk an arbitrary nested token tree and produce a flat list of
	 * { Path: 'color.background.primary', Value: <leaf> } entries.
	 *
	 * Paired-mode objects ({Light, Dark}) and primitive values are leaves.
	 */
	_flattenTokens(pNode, pPathPrefix)
	{
		let tmpResults = [];
		if (pNode === null || typeof pNode !== 'object' || Array.isArray(pNode))
		{
			if (pPathPrefix)
			{
				tmpResults.push({ Path: pPathPrefix, Value: pNode });
			}
			return tmpResults;
		}
		if (this._isPairedValue(pNode))
		{
			tmpResults.push({ Path: pPathPrefix, Value: pNode });
			return tmpResults;
		}
		let tmpKeys = Object.keys(pNode);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpChildPath = pPathPrefix ? (pPathPrefix + '.' + tmpKey) : tmpKey;
			let tmpChild = pNode[tmpKey];
			tmpResults = tmpResults.concat(this._flattenTokens(tmpChild, tmpChildPath));
		}
		return tmpResults;
	}

	/**
	 * 'Color.Background.Primary' -> '--theme-color-background-primary'
	 */
	_cssVarName(pTokenPath)
	{
		return CSS_VAR_PREFIX + pTokenPath.toLowerCase().replace(/\./g, '-');
	}

	_formatCSSValue(pValue)
	{
		if (pValue === null || typeof pValue === 'undefined') return '';
		if (typeof pValue === 'number') return String(pValue);
		return String(pValue);
	}

	_injectStyleElement(pCSS)
	{
		if (typeof document === 'undefined') return;
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = STYLE_ELEMENT_ID;
			document.head.appendChild(tmpStyleEl);
		}
		tmpStyleEl.textContent = pCSS;
	}

	_registerAuxiliaryCSS(pTheme)
	{
		// Clear previously registered auxiliary CSS so stale entries don't pile
		// up when switching themes.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		if (!Array.isArray(pTheme.CSS)) return;
		if (!this.pict || !this.pict.CSSMap || typeof this.pict.CSSMap.addCSS !== 'function') return;

		for (let i = 0; i < pTheme.CSS.length; i++)
		{
			let tmpEntry = pTheme.CSS[i];
			if (!tmpEntry || !tmpEntry.Hash || typeof tmpEntry.Content !== 'string') continue;
			let tmpPriority = (typeof tmpEntry.Priority === 'number') ? tmpEntry.Priority : 500;
			this.pict.CSSMap.addCSS(tmpEntry.Hash, tmpEntry.Content, tmpPriority);
			this._registeredCSSHashes.push(tmpEntry.Hash);
		}
	}

	/**
	 * Apply the requested mode by adjusting the class on <html>.
	 *
	 *   - 'light' / 'dark': the matching class is added so the explicit
	 *     `.theme-light` / `.theme-dark` block in the injected stylesheet
	 *     overrides the @media (prefers-color-scheme) rule.
	 *   - 'system': both classes are cleared so the @media rule drives
	 *     the cascade from the OS preference, with no JS listener needed.
	 *
	 * `_resolvedMode` is snapshotted at apply time so synchronous reads
	 * via `token()` / `getActiveTheme()` return a consistent value.  In
	 * system mode it falls back to `_currentResolvedMode()` for callers
	 * that want a live read on each call.
	 */
	_applyMode(pMode, pStrategy)
	{
		if (pMode === 'system')
		{
			this._resolvedMode = this._readSystemPreference();
			this._clearHTMLClass();
		}
		else
		{
			this._resolvedMode = (pMode === 'dark') ? 'dark' : 'light';
			this._writeHTMLClass(this._resolvedMode);
		}
	}

	_writeHTMLClass(pResolvedMode)
	{
		if (typeof document === 'undefined' || !document.documentElement || !document.documentElement.classList) return;
		let tmpList = document.documentElement.classList;
		if (pResolvedMode === 'dark')
		{
			tmpList.remove(HTML_CLASS_LIGHT);
			tmpList.add(HTML_CLASS_DARK);
		}
		else
		{
			tmpList.remove(HTML_CLASS_DARK);
			tmpList.add(HTML_CLASS_LIGHT);
		}
	}

	_clearHTMLClass()
	{
		if (typeof document === 'undefined' || !document.documentElement || !document.documentElement.classList) return;
		let tmpList = document.documentElement.classList;
		tmpList.remove(HTML_CLASS_LIGHT);
		tmpList.remove(HTML_CLASS_DARK);
	}

	_readSystemPreference()
	{
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'light';
		try
		{
			return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
		}
		catch (pError)
		{
			return 'light';
		}
	}

	/**
	 * The mode currently driving the page.  Mirrors what the user sees:
	 * explicit modes return their literal value; 'system' reads the OS
	 * preference fresh so token() / getActiveTheme() never report a
	 * stale value when the OS toggles between calls.
	 *
	 * @returns {'light'|'dark'}
	 */
	_currentResolvedMode()
	{
		if (this._activeMode === 'system')
		{
			return this._readSystemPreference();
		}
		return (this._resolvedMode === 'dark') ? 'dark' : 'light';
	}
}

PictProviderTheme.default_configuration = _ProviderConfiguration;

module.exports = PictProviderTheme;
module.exports.STYLE_ELEMENT_ID = STYLE_ELEMENT_ID;
module.exports.HTML_CLASS_LIGHT = HTML_CLASS_LIGHT;
module.exports.HTML_CLASS_DARK = HTML_CLASS_DARK;
module.exports.CSS_VAR_PREFIX = CSS_VAR_PREFIX;
module.exports.DiagramAdapter = libDiagramAdapter;

},{"./Theme-Diagram-Adapter.js":171,"./templates/Pict-Template-Theme.js":172,"./templates/Pict-Template-ThemeAsset.js":173,"./templates/Pict-Template-ThemeImage.js":174,"./templates/Pict-Template-ThemeVar.js":175,"pict-provider":177}],171:[function(require,module,exports){
/**
 * Theme Diagram Adapter
 *
 * Helper utilities for plugging diagram renderers (Mermaid today,
 * Excalidraw / chart libraries next) into the pict-provider-theme
 * lifecycle.
 *
 * Why this exists:
 *   Diagram engines like Mermaid bake colors into the SVG at render
 *   time. Once rendered, CSS alone cannot recolor node fills, cluster
 *   backgrounds, or edge stroke ends — those are inline attributes on
 *   <rect>, <path>, <polygon>, etc.  Switching light/dark requires
 *   the engine to re-render with a fresh themeVariables block.
 *
 *   Pre-adapter, every view that hosted a Mermaid block had to:
 *     - read every CSS custom property by hand
 *     - mirror a 20+ key themeVariables object
 *     - wire its own onApply subscription
 *     - stash diagram source on the DOM
 *     - clear data-processed + re-run on theme change
 *
 *   The adapter centralizes all of that.  Section views call
 *   `adapter.adaptMermaid(mermaid, options)` and stop caring about the
 *   token list, the listener, and the refresh dance.
 *
 *  Public API:
 *     buildMermaidThemeVariables(pOverrides)        - read fresh tokens, return mermaid themeVariables
 *     getMermaidTokenMap()                          - canonical {mermaidKey: cssVarName} map
 *     initializeMermaid(mermaid, pOverrides)        - mermaid.initialize() with the right base + themeVariables
 *     refreshMermaidDiagrams(pSelectorOrRoot)       - restore source, clear data-processed, re-run mermaid.run
 *     stashMermaidSource(pNodes)                    - cache source on data-mermaid-source before first run
 *     adaptMermaid(provider, mermaid, pOptions)     - one-shot: initialize + subscribe + return handle
 *     readCSSVar(pName, pFallback, pRoot)           - fresh getComputedStyle read with fallback
 *
 *  All helpers are stateless and safe to call repeatedly.  Subscriptions
 *  return a dispose function the caller can hold onto for teardown.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// Canonical mapping: mermaid themeVariables key -> CSS custom property name -> fallback.
// Fallbacks match the pict-default LIGHT palette so unthemed apps look like
// the default theme rather than a third unrelated palette.
const MERMAID_TOKEN_MAP =
[
	// Primary surfaces (node fills + cluster background)
	{ Key: 'primaryColor',         Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'primaryTextColor',     Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'primaryBorderColor',   Var: '--theme-color-brand-primary',        Fallback: '#3357c7' },
	// Secondary (alt rows, alternate nodes, sequence actor bg)
	{ Key: 'secondaryColor',       Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'secondaryTextColor',   Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'secondaryBorderColor', Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Tertiary (clusters, accent groups)
	{ Key: 'tertiaryColor',        Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'tertiaryTextColor',    Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'tertiaryBorderColor',  Var: '--theme-color-border-light',         Fallback: '#e9e9e9' },
	// Page-level + line + note
	{ Key: 'background',           Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'mainBkg',              Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'secondBkg',            Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'lineColor',            Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'textColor',            Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBkgColor',         Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'noteTextColor',        Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBorderColor',      Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Status (Mermaid uses these for error/warning highlights)
	{ Key: 'errorBkgColor',        Var: '--theme-color-status-error',         Fallback: '#b62828' },
	{ Key: 'errorTextColor',       Var: '--theme-color-text-on-brand',        Fallback: '#ffffff' },
	// Typography
	{ Key: 'fontFamily',           Var: '--theme-typography-family-sans',     Fallback: 'inherit' }
];

/**
 * Read a CSS custom property off pRoot (default: documentElement).
 * Always issues a fresh getComputedStyle so the value reflects the
 * current class state on <html> (theme-light / theme-dark).
 *
 * @param {string} pName     - variable name including '--' prefix
 * @param {string} [pFallback] - returned when the variable is unset/empty
 * @param {Element} [pRoot]  - element to compute style against
 * @returns {string}
 */
function readCSSVar(pName, pFallback, pRoot)
{
	if (typeof window === 'undefined' || typeof document === 'undefined')
	{
		return pFallback || '';
	}
	let tmpRoot = pRoot || document.documentElement;
	if (!tmpRoot)
	{
		return pFallback || '';
	}
	let tmpVal = (getComputedStyle(tmpRoot).getPropertyValue(pName) || '').trim();
	return tmpVal || pFallback || '';
}

/**
 * Returns the canonical {mermaidKey: cssVarName} mapping.  Useful for
 * apps that need to inspect or extend the token list (e.g. to add
 * gantt / sequence / pie-specific tokens for a custom diagram type).
 *
 * @returns {Array<{Key, Var, Fallback}>}
 */
function getMermaidTokenMap()
{
	// Defensive copy so callers can't mutate the canonical list.
	return MERMAID_TOKEN_MAP.map((tmpEntry) => ({ Key: tmpEntry.Key, Var: tmpEntry.Var, Fallback: tmpEntry.Fallback }));
}

/**
 * Read every token in the mermaid map off the current document and
 * return an object suitable for mermaid.initialize({themeVariables}).
 *
 * @param {object} [pOverrides] - extra themeVariables keys to merge on top
 * @returns {object}
 */
function buildMermaidThemeVariables(pOverrides)
{
	let tmpVars = {};
	for (let i = 0; i < MERMAID_TOKEN_MAP.length; i++)
	{
		let tmpEntry = MERMAID_TOKEN_MAP[i];
		tmpVars[tmpEntry.Key] = readCSSVar(tmpEntry.Var, tmpEntry.Fallback);
	}
	if (pOverrides && typeof pOverrides === 'object')
	{
		let tmpKeys = Object.keys(pOverrides);
		for (let j = 0; j < tmpKeys.length; j++)
		{
			tmpVars[tmpKeys[j]] = pOverrides[tmpKeys[j]];
		}
	}
	return tmpVars;
}

/**
 * Call mermaid.initialize() with the canonical pict theme bindings.
 * Safe to call repeatedly; mermaid simply merges new config.
 *
 * @param {object} mermaid - the mermaid module / global
 * @param {object} [pOverrides] - extra themeVariables keys, or { config: ... }
 *                                to override startOnLoad / securityLevel / theme
 * @returns {boolean} true if initialize ran, false if no mermaid available
 */
function initializeMermaid(mermaid, pOverrides)
{
	if (!mermaid || typeof mermaid.initialize !== 'function') { return false; }
	let tmpOverrides = pOverrides || {};
	let tmpThemeOverrides = tmpOverrides.themeVariables;
	let tmpConfigOverrides = tmpOverrides.config || {};
	let tmpVars = buildMermaidThemeVariables(tmpThemeOverrides);
	let tmpConfig = Object.assign(
	{
		startOnLoad: false,
		theme: 'base',
		securityLevel: 'loose'
	}, tmpConfigOverrides,
	{
		themeVariables: tmpVars
	});
	mermaid.initialize(tmpConfig);
	return true;
}

/**
 * Cache each diagram's source text on data-mermaid-source so a later
 * refresh can restore it.  Mermaid replaces textContent with the
 * rendered SVG during run(); without this stash there's no way to
 * re-run.
 *
 * @param {NodeList|Array<Element>} pNodes
 */
function stashMermaidSource(pNodes)
{
	if (!pNodes || pNodes.length < 1) { return; }
	for (let i = 0; i < pNodes.length; i++)
	{
		let tmpEl = pNodes[i];
		if (!tmpEl || typeof tmpEl.getAttribute !== 'function') { continue; }
		if (!tmpEl.hasAttribute('data-mermaid-source'))
		{
			tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
		}
	}
}

/**
 * Restore each pre.mermaid[data-mermaid-source] element to its source
 * text, drop the data-processed flag (mermaid skips elements with that
 * flag set), strip the mermaid-rendered helper class if present, and
 * re-run mermaid against them.
 *
 * @param {string|Element|Document} [pSelectorOrRoot]
 *   - string: querySelectorAll target (defaults to whole document)
 *   - Element: scoped root to search inside
 *   - omitted: whole document
 * @returns {Promise|null} the mermaid.run() promise, or null if no work
 */
function refreshMermaidDiagrams(pSelectorOrRoot)
{
	if (typeof document === 'undefined') { return null; }
	let tmpMermaid = (typeof mermaid !== 'undefined') ? mermaid : null;
	if (!tmpMermaid || typeof tmpMermaid.run !== 'function') { return null; }

	let tmpRendered = _resolveMermaidNodes(pSelectorOrRoot);
	if (!tmpRendered || tmpRendered.length < 1) { return null; }

	for (let i = 0; i < tmpRendered.length; i++)
	{
		let tmpEl = tmpRendered[i];
		let tmpSrc = tmpEl.getAttribute('data-mermaid-source');
		if (tmpSrc !== null) { tmpEl.textContent = tmpSrc; }
		tmpEl.removeAttribute('data-processed');
		if (tmpEl.classList && typeof tmpEl.classList.remove === 'function')
		{
			tmpEl.classList.remove('mermaid-rendered');
		}
	}

	try
	{
		let tmpResult = tmpMermaid.run({ nodes: tmpRendered });
		// After mermaid finishes drawing, strip the !important flags it
		// bakes into per-node inline fill/stroke styles. See
		// stripMermaidStyleImportance() docs for the why.
		if (tmpResult && typeof tmpResult.then === 'function')
		{
			return tmpResult.then(function ()
			{
				stripMermaidStyleImportance(tmpRendered);
				return tmpResult;
			});
		}
		// Synchronous fallback (older mermaid versions).
		stripMermaidStyleImportance(tmpRendered);
		return tmpResult;
	}
	catch (pError)
	{
		// Surface to the caller; they're already wrapping in try/catch in
		// most cases.  Return a rejected promise so .catch() consumers fire.
		return Promise.reject(pError);
	}
}

/**
 * Mermaid 11's flowchart `style X fill:#...` directive emits the fill
 * and stroke inline with `!important`:
 *
 *   <rect class="basic label-container"
 *         style="fill:#e8f5e9 !important;stroke:#43a047 !important"/>
 *
 * Inline `!important` beats external `!important` via specificity, so
 * any theme-aware CSS we write (e.g. `.theme-dark ... { fill: theme-bg
 * !important }`) silently loses no matter how strong its selector.
 * Diagrams keep their Material pastels even in dark themes — light
 * fills with light text = unreadable.
 *
 * Strip just the `!important` flag off mermaid-emitted inline styles
 * after every render.  The fill/stroke values themselves stay intact,
 * so light mode keeps the author-intended palette; in dark mode the
 * external `.theme-dark` CSS now reaches the rect and recolors to a
 * theme-aware background.
 *
 * Must run after every mermaid render — initial + every re-render
 * triggered by a theme change.  `refreshMermaidDiagrams` calls it on
 * re-renders; the initial render in pict-section-content's view calls
 * it via the provider's `diagram.stripMermaidStyleImportance` handle.
 *
 * @param {string|Element|NodeList|Array} [pTarget]
 *   - omitted: scan the whole document
 *   - string: querySelector scope (e.g. '#Pict-Content-Body')
 *   - Element: scan within this element
 *   - NodeList/Array of `pre.mermaid` elements: scan within each
 * @returns {number} count of shapes that had !important stripped
 */
function stripMermaidStyleImportance(pTarget)
{
	if (typeof document === 'undefined') { return 0; }

	let tmpMermaids;
	if (!pTarget)
	{
		tmpMermaids = document.querySelectorAll('pre.mermaid');
	}
	else if (typeof pTarget === 'string')
	{
		let tmpScope = document.querySelector(pTarget);
		tmpMermaids = tmpScope ? tmpScope.querySelectorAll('pre.mermaid') : [];
	}
	else if (pTarget.length !== undefined)
	{
		// NodeList or Array of pre.mermaid elements
		tmpMermaids = pTarget;
	}
	else if (pTarget.querySelectorAll)
	{
		tmpMermaids = pTarget.querySelectorAll('pre.mermaid');
	}
	else
	{
		return 0;
	}

	let tmpStripped = 0;
	for (let i = 0; i < tmpMermaids.length; i++)
	{
		let tmpMerm = tmpMermaids[i];
		if (!tmpMerm || !tmpMerm.querySelectorAll) { continue; }
		let tmpShapes = tmpMerm.querySelectorAll(
			'.node rect[style*="!important"], ' +
			'.node polygon[style*="!important"], ' +
			'.node circle[style*="!important"], ' +
			'.node ellipse[style*="!important"], ' +
			'.node path[style*="!important"], ' +
			'.cluster rect[style*="!important"]'
		);
		for (let j = 0; j < tmpShapes.length; j++)
		{
			let tmpEl = tmpShapes[j];
			let tmpStyle = tmpEl.getAttribute('style') || '';
			if (tmpStyle.indexOf('!important') < 0) { continue; }
			tmpEl.setAttribute('style', tmpStyle.replace(/\s*!important\s*/gi, ''));
			tmpStripped++;
		}
	}
	return tmpStripped;
}

function _resolveMermaidNodes(pSelectorOrRoot)
{
	let tmpSelector = 'pre.mermaid[data-mermaid-source]';
	if (!pSelectorOrRoot)
	{
		return document.querySelectorAll(tmpSelector);
	}
	if (typeof pSelectorOrRoot === 'string')
	{
		// Treat the string as a scope selector; collect mermaid nodes inside it.
		let tmpScope = document.querySelector(pSelectorOrRoot);
		if (!tmpScope) { return []; }
		return tmpScope.querySelectorAll(tmpSelector);
	}
	if (pSelectorOrRoot.querySelectorAll)
	{
		return pSelectorOrRoot.querySelectorAll(tmpSelector);
	}
	return [];
}

/**
 * One-shot: initialize mermaid against the active theme, subscribe to
 * theme apply events, and return a handle the caller can use for
 * teardown / manual refresh.
 *
 *   let tmpHandle = adaptMermaid(pict.providers.Theme, mermaid, {
 *       refreshScope: '#Pict-Content-Body'
 *   });
 *   // ... later, on unload:
 *   tmpHandle.dispose();
 *
 * @param {object} pProvider - pict-provider-theme instance
 * @param {object} pMermaid  - the mermaid module / global
 * @param {object} [pOptions]
 *   @param {string|Element} [pOptions.refreshScope] - passed to refreshMermaidDiagrams
 *   @param {object} [pOptions.themeOverrides]       - extra themeVariables keys
 *   @param {object} [pOptions.configOverrides]      - extra mermaid.initialize() top-level keys
 *   @param {function} [pOptions.onBeforeRefresh]    - called before each refresh; signature (pContext)
 *   @param {function} [pOptions.onAfterRefresh]     - called after each refresh resolves; signature (pContext)
 * @returns {{ dispose: function, refresh: function, reinitialize: function, subscribed: boolean }}
 */
function adaptMermaid(pProvider, pMermaid, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpInitOverrides =
	{
		themeVariables: tmpOptions.themeOverrides,
		config: tmpOptions.configOverrides
	};

	// Always initialize, even if no provider — the static base theme should
	// still pick up whatever CSS variables the page does have.
	initializeMermaid(pMermaid, tmpInitOverrides);

	let tmpRefresh = function (pContext)
	{
		if (typeof tmpOptions.onBeforeRefresh === 'function')
		{
			try { tmpOptions.onBeforeRefresh(pContext || {}); }
			catch (e) { /* swallow; refresh must not be gated on listener errors */ }
		}
		initializeMermaid(pMermaid, tmpInitOverrides);
		let tmpResult = refreshMermaidDiagrams(tmpOptions.refreshScope);
		if (tmpResult && typeof tmpResult.then === 'function' && typeof tmpOptions.onAfterRefresh === 'function')
		{
			tmpResult.then(
				() => { try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ } },
				() => { /* error path: onAfterRefresh still fires so the UI can drop spinners */
					try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ }
				}
			);
		}
		return tmpResult;
	};

	let tmpDispose = function () {};
	let tmpSubscribed = false;
	if (pProvider && typeof pProvider.onApply === 'function')
	{
		tmpDispose = pProvider.onApply(function (pBundle, pContext)
		{
			tmpRefresh(pContext || {});
		});
		tmpSubscribed = true;
	}

	return {
		dispose: function ()
		{
			if (typeof tmpDispose === 'function') { tmpDispose(); }
		},
		refresh: tmpRefresh,
		reinitialize: function () { initializeMermaid(pMermaid, tmpInitOverrides); },
		subscribed: tmpSubscribed
	};
}

module.exports =
{
	MERMAID_TOKEN_MAP: MERMAID_TOKEN_MAP,
	readCSSVar: readCSSVar,
	getMermaidTokenMap: getMermaidTokenMap,
	buildMermaidThemeVariables: buildMermaidThemeVariables,
	initializeMermaid: initializeMermaid,
	stashMermaidSource: stashMermaidSource,
	refreshMermaidDiagrams: refreshMermaidDiagrams,
	stripMermaidStyleImportance: stripMermaidStyleImportance,
	adaptMermaid: adaptMermaid
};

},{}],172:[function(require,module,exports){
/**
 * Pict template expression: {~Theme:Path~}
 *
 * Resolves a token path against the active theme bundle and returns the
 * raw value at the currently resolved mode.  Walks from the bundle root,
 * so paths like 'Tokens.Color.Background.Primary' or 'Brand.Name' work.
 *
 * Returns an empty string if no theme is active or the path is missing.
 */
const libPictTemplate = require('pict-template');

class PictTemplateTheme extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Theme:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.token(tmpPath);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateTheme;

},{"pict-template":363}],173:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeAsset:Category.Name~}
 *
 * Returns the contents of a named SVG (or other) asset from the active
 * theme bundle.  The first path segment is treated as the category
 * (e.g. SVG), the rest as the asset's path within that category.
 *
 *   {~ThemeAsset:SVG.Logo~}        -> bundle.SVG.Logo
 *   {~ThemeAsset:SVG.Icons.Foo~}   -> bundle.SVG.Icons.Foo
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeAsset extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeAsset:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpDot = tmpPath.indexOf('.');
		if (tmpDot < 0) return '';

		let tmpCategory = tmpPath.substring(0, tmpDot);
		let tmpName = tmpPath.substring(tmpDot + 1);

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.asset(tmpCategory, tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeAsset;

},{"pict-template":363}],174:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeImage:Name~}
 *
 * Returns the URL or data URL stored at bundle.Image[Name] in the active
 * theme bundle.  Convenience over {~ThemeAsset:Image.Name~}.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeImage extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeImage:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpName = (pTemplateHash || '').trim();
		if (!tmpName) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.image(tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeImage;

},{"pict-template":363}],175:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeVar:Path~}
 *
 * Returns a CSS `var(--theme-...)` reference for a token path under
 * Tokens.  E.g. {~ThemeVar:Color.Background.Primary~} ->
 * `var(--theme-color-background-primary)`.
 *
 * Useful inside style attributes and in CSS-in-JS contexts where you want
 * the live custom-property reference rather than the resolved value.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeVar extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeVar:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';
		return tmpProvider.cssVar(tmpPath);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeVar;

},{"pict-template":363}],176:[function(require,module,exports){
module.exports={
    "name": "pict-provider",
    "version": "1.0.13",
    "description": "Pict Provider Base Class",
    "main": "source/Pict-Provider.js",
    "scripts": {
        "start": "node source/Pict-Provider.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-provider-image:local",
        "docker-dev-run": "docker run -it -d --name pict-provider-dev -p 24125:8080 -p 30027:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-provider\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-provider-image:local",
        "docker-dev-shell": "docker exec -it pict-provider-dev /bin/bash",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Provider.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-provider.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-provider/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-provider#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "eslint": "^9.39.1",
        "pict": "^1.0.351",
        "pict-docuserve": "^0.1.5",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],177:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictProviderSettings = (
	{
		ProviderIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		AutoLoadDataWithApp: true,
		AutoLoadDataOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		Manifests: {},

		Templates: []
	});

class PictProvider extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictProviderSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.fable;
		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		if (!this.options.ProviderIdentifier)
		{
			this.options.ProviderIdentifier = `AutoProviderID-${this.fable.getUUID()}`;
		}

		this.serviceType = 'PictProvider';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;

		// Wire in the essential Pict application state
		/** @type {Record<string, any>} */
		this.AppData = this.pict.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.pict.Bundle;

		this.initializeTimestamp = false;
		this.lastSolvedTimestamp = false;

		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpDefaultTemplate = this.options.Templates[i];

			if (!tmpDefaultTemplate.hasOwnProperty('Postfix') || !tmpDefaultTemplate.hasOwnProperty('Template'))
			{
				this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-pinitialization.
	 *
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				(pError) =>
				{
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (pError)
					{
						this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization failed: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization complete.`);
					}
					return fCallback();
				})
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-render.
	 *
	 * @return {void}
	 */
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	render()
	{
		return this.onPreRender();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after render.
	 *
	 * @return {void}
	 */
	renderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	solve()
	{
		return this.onPreSolve();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after solve.
	 *
	 * @return {void}
	 */
	solveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 *
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 *
	 * @return {void}
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 *
	 * @return {void}
	 */
	onAfterSaveDataAsync(fCallback)
	{
		return fCallback();
	}
}

module.exports = PictProvider;

},{"../package.json":176,"fable-serviceproviderbase":59}],178:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libNavigo = require('navigo');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Router',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// When true, addRoute() will NOT auto-resolve after each route is added.
	// This is useful in auth-gated SPAs where routes should only resolve after
	// the DOM is ready (e.g. after login).  Can also be set globally via
	// pict.settings.RouterSkipRouteResolveOnAdd — either one enables the skip.
	SkipRouteResolveOnAdd: false,

	// Document title management.  When a DefaultTitle is set (or a per-route title
	// is passed to addRoute), the router keeps document.title in step with the
	// current route: a route with a title renders `<title><TitleSuffix>`, a route
	// without one falls back to DefaultTitle so a title never lingers from the
	// previous page.  All three are empty by default, so with no configuration the
	// router does not touch document.title (fully backward compatible).
	DefaultTitle: '',
	TitleSuffix: ''
}

class PictRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Initialize the navigo router and set the base path to '/'
		this.router = new libNavigo('/', { strategy: 'ONE', hash: true });

		// BEFORE the Routes option is processed below, because that calls addRoute, which writes here.
		// Route pattern -> handler, so renavigate()/reenter() can run a route the router is already on.
		this._routeHandlers = {};
		// Set by the `already` hook every route carries; read by navigate() to report whether the
		// router actually resolved.  See navigate().
		this._lastNavigateDeclined = false;

		if (this.options.Routes)
		{
			for (let i = 0; i < this.options.Routes.length; i++)
			{
				if (this.options.Routes[i].path && this.options.Routes[i].template)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].template);
				}
				else if (this.options.Routes[i].path && this.options.Routes[i].render)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].render);
				}
				else
				{
					this.pict.log.warn(`Route ${i} is missing a render function or template string.`);
				}
			}
		}

		// This is the route to render after load
		this.afterPersistView = '/Manyfest/Overview';

	}

	get currentScope()
	{
		return this.AppData?.ManyfestRecord?.Scope ?? 'Default';
	}

	forwardToScopedRoute(pData)
	{
		this.navigate(`${pData.url}/${this.currentScope}`);
	}

	onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	/**
	 * Compose a document title from a page title and the configured suffix.  An empty page title
	 * falls back to DefaultTitle so a titleless route never inherits the previous page's title.
	 *
	 * @param {string} pTitle - the page-specific title (may be empty)
	 * @returns {string}
	 */
	composeTitle(pTitle)
	{
		let tmpTitle = (typeof pTitle === 'string') ? pTitle : '';
		if (!tmpTitle) { return this.options.DefaultTitle || ''; }
		let tmpSuffix = this.options.TitleSuffix || '';
		return tmpSuffix ? (tmpTitle + tmpSuffix) : tmpTitle;
	}

	/**
	 * Set document.title from a page title (applying the configured suffix).  Public so async / entity
	 * pages can set their title once the record loads, after the route handler has already run.
	 *
	 * @param {string} pTitle - the page-specific title
	 */
	setDocumentTitle(pTitle)
	{
		if (typeof document === 'undefined') { return; }
		document.title = this.composeTitle(pTitle);
	}

	// Whether the router should manage document.title at all: only once a DefaultTitle or TitleSuffix is
	// configured, or a per-route title is supplied.  Keeps the no-configuration path from touching the DOM.
	_managesTitle(pTitle)
	{
		return (pTitle !== undefined) || !!this.options.DefaultTitle || !!this.options.TitleSuffix;
	}

	// Apply a route's title on match.  A per-route title (string or (pData)=>string) wins; a route with no
	// title resets to DefaultTitle so the previous page's title does not linger.
	_applyRouteTitle(pTitle, pData)
	{
		if (typeof document === 'undefined' || !this._managesTitle(pTitle)) { return; }
		let tmpResolved = (typeof pTitle === 'function') ? pTitle(pData) : pTitle;
		document.title = this.composeTitle(tmpResolved);
	}

	/**
	 * Add a route to the router.
	 *
	 * @param {string} pRoute - the route pattern
	 * @param {function|string} pRenderable - a handler function or a template string
	 * @param {string|function} [pTitle] - optional document title for this route: a string, or a
	 *        (pData)=>string resolved on match.  Requires DefaultTitle/TitleSuffix configured (or this
	 *        arg present) for the router to touch document.title.
	 */
	addRoute(pRoute, pRenderable, pTitle, pHooks)
	{
		let tmpHandler = null;
		if (typeof(pRenderable) === 'function')
		{
			tmpHandler = (pData) =>
				{
					this._applyRouteTitle(pTitle, pData);
					return pRenderable(pData);
				};
		}
		else if (typeof(pRenderable) === 'string')
		{
			// Run this as a template, allowing some whack things with functions in template expressions.
			tmpHandler = (pData) =>
				{
					this._applyRouteTitle(pTitle, pData);
					this.pict.parseTemplate(pRenderable, pData, null, this.pict)
				};
		}
		if (tmpHandler)
		{
			// Remember the handler so renavigate() can run it for a route the router is already on.
			// Keyed WITHOUT the leading slash, which is how the underlying router reports a matched
			// route's path -- so a lookup by pattern and a lookup off a live match agree.
			this._routeHandlers[this._routeKey(pRoute)] = tmpHandler;
			this.router.on(pRoute, tmpHandler, this._composeHooks(pRoute, pHooks));
		}
		else
		{
			// renderable isn't usable!
			this.pict.log.warn(`Route ${pRoute} has an invalid renderable.`);
			return;
		}

		// By default, resolve after each route is added (legacy behavior).
		// Applications can skip this by setting SkipRouteResolveOnAdd: true in
		// the provider config JSON, or globally via
		// pict.settings.RouterSkipRouteResolveOnAdd.  Either one will prevent
		// premature route resolution before views are rendered.
		if (!this.options.SkipRouteResolveOnAdd && !this.pict.settings.RouterSkipRouteResolveOnAdd)
		{
			this.resolve();
		}
	}

	/**
	 * Navigate to a given route (set the browser URL string, add to history, trigger router)
	 *
	 * RETURNS WHETHER THE ROUTE ACTUALLY RESOLVED.  Navigating to the route you are already on is a
	 * no-op by design -- the underlying router declines to run the handler again -- and that is usually
	 * right.  What was missing is any way to KNOW: navigate() returned nothing, so a caller could not
	 * tell "went there" from "did nothing", and code that assumed it had moved would leave whatever was
	 * on screen exactly where it was.  This does not change the behaviour, only reports it.
	 *
	 * The answer comes from the router's own signal rather than by comparing URL strings: every route
	 * carries an internal `already` hook (see _composeHooks) that the router fires when it declines.
	 *
	 * Note for asynchronous route hooks: if an application's before-hook resolves asynchronously the
	 * router has not finished by the time this returns, and this reports true (it did not decline).
	 * That is the same answer callers effectively assumed before this existed.
	 *
	 * @param {string} pRoute - The route to navigate to
	 * @param {object} [pOptions] - options for the underlying router (for example
	 *        { updateBrowserURL: false } for an application that writes the URL itself)
	 * @returns {boolean} true when the route resolved, false when the router was already on it
	 */
	navigate(pRoute, pOptions)
	{
		this._lastNavigateDeclined = false;
		if (pOptions) { this.router.navigate(pRoute, pOptions); }
		else { this.router.navigate(pRoute); }
		return !this._lastNavigateDeclined;
	}

	/**
	 * Navigate to a route, and run its handler even if the router is already on it.
	 *
	 * For the legitimate "enter this route again" case: something has rendered over the route without
	 * telling the router (a form opened in place, a modal took the pane), so the router's idea of what
	 * is on screen and what is actually on screen have come apart, and asking to go there again has to
	 * mean something.  Prefer giving that state a route of its own where you can; use this where you
	 * cannot.
	 *
	 * @param {string} pRoute - The route to navigate to
	 * @param {object} [pOptions] - options for the underlying router, as navigate()
	 * @returns {boolean} true when the handler ran, either by navigation or by re-entry
	 */
	renavigate(pRoute, pOptions)
	{
		if (this.navigate(pRoute, pOptions)) { return true; }
		return this.reenter(pRoute);
	}

	/**
	 * Run the handler for the route the router is currently on, without touching history.
	 *
	 * @param {string} [pRoute] - the route pattern to re-enter; defaults to the last resolved route
	 * @returns {boolean} true when a handler was found and run
	 */
	reenter(pRoute)
	{
		let tmpMatch = this.lastMatch();
		let tmpHandler = pRoute ? this._routeHandlers[this._routeKey(pRoute)] : null;
		// A caller re-entering by the URL it navigated to ('/thing/12') is not naming the pattern the
		// handler is stored under ('/thing/:id'), so fall back to whatever the router actually
		// resolved. That is also the no-argument case: re-enter wherever we are.
		if (!tmpHandler && tmpMatch && tmpMatch.route)
		{
			tmpHandler = this._routeHandlers[this._routeKey(tmpMatch.route.path)];
		}
		if (typeof tmpHandler !== 'function') { return false; }
		tmpHandler(tmpMatch || {});
		return true;
	}

	/**
	 * The router's last resolved match, or null.  Handy for a caller that wants to know where it is
	 * without reaching into the underlying router.
	 *
	 * @returns {object|null}
	 */
	lastMatch()
	{
		if (!this.router || typeof this.router.lastResolved !== 'function') { return null; }
		let tmpResolved = this.router.lastResolved();
		return (tmpResolved && tmpResolved[0]) ? tmpResolved[0] : null;
	}

	/**
	 * Build the hook set handed to the underlying router for one route.
	 *
	 * Always installs an `already` hook, which the router fires when it declines to re-run a handler
	 * for the route it is already on.  An application's own `already` hook still runs, after ours.
	 *
	 * @param {string} pRoute - the route pattern
	 * @param {object} [pHooks] - optional before / after / leave / already hooks from the caller
	 * @returns {object}
	 */
	// One spelling for a route, so a pattern given as '/x' and a match reporting 'x' agree.
	_routeKey(pRoute) { return String(pRoute || '').replace(/^\/+/, ''); }

	_composeHooks(pRoute, pHooks)
	{
		let tmpHooks = Object.assign({}, pHooks || {});
		let fCallerAlready = tmpHooks.already;
		tmpHooks.already = (pMatch) =>
		{
			this._lastNavigateDeclined = true;
			if (typeof fCallerAlready === 'function') { fCallerAlready(pMatch); }
		};
		return tmpHooks;
	}

	/**
	 * Navigate to the route currently in the browser's location hash.
	 *
	 * This is useful in auth-gated SPAs: when the user pastes a deep-link
	 * (e.g. #/Books) and then logs in, calling navigateCurrent() will force
	 * the router to fire the handler for whatever hash is already in the URL.
	 * Unlike resolve(), navigate() always triggers the handler even if Navigo
	 * has already "consumed" that URL.
	 *
	 * If the hash is empty or just "#/", this is a no-op and returns false.
	 *
	 * @returns {boolean} true if a route was navigated to, false otherwise
	 */
	navigateCurrent()
	{
		let tmpHash = (typeof (window) !== 'undefined' && window.location) ? window.location.hash : '';
		if (tmpHash && tmpHash.length > 2 && tmpHash !== '#/')
		{
			let tmpRoute = tmpHash.replace(/^#/, '');
			this.navigate(tmpRoute);
			return true;
		}
		return false;
	}

	/**
	 * Trigger the router resolving logic; this is expected to be called after all routes are added (to go to the default route).
	 *
	 */
	resolve()
	{
		this.router.resolve();
	}
}

module.exports = PictRouter;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;
},{"navigo":142,"pict-provider":177}],179:[function(require,module,exports){
'use strict';

// CSS for pict-section-activitygraph. Theme-token driven so it re-themes live. The active control button
// pairs the brand fill with var(--theme-color-text-on-brand) rather than a hardcoded white, so it stays
// readable in themes whose brand is light (e.g. High Contrast dark, where brand is yellow).
module.exports = /*css*/`
.pict-activitygraph { font-family: -apple-system, Segoe UI, Roboto, sans-serif; color: var(--theme-color-text-primary, #2b2d2f); }
.pict-activitygraph .pag-controls { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin-bottom: 14px; }
.pict-activitygraph .pag-group { display: inline-flex; align-items: center; gap: 4px; }
.pict-activitygraph .pag-group-right { margin-left: auto; }
.pict-activitygraph .pag-label { font-size: 11px; color: var(--theme-color-text-secondary, #6c6a60); text-transform: uppercase; letter-spacing: 0.04em; margin: 0 2px 0 10px; }
.pict-activitygraph .pag-btn { font: inherit; font-size: 12px; padding: 4px 11px; border-radius: 6px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #ffffff); color: var(--theme-color-text-secondary, #5b6376); }
.pict-activitygraph .pag-btn:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-primary, #2c3140); }
.pict-activitygraph .pag-btn-on, .pict-activitygraph .pag-btn-on:hover { background: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-on-brand, #ffffff); border-color: transparent; }
.pict-activitygraph .pag-chart { width: 100%; overflow-x: auto; }
.pict-activitygraph .pag-chart svg { display: block; max-width: 100%; height: auto; }
.pict-activitygraph .pag-empty { color: var(--theme-color-text-secondary, #6c6a60); font-style: italic; font-size: 14px; padding: 32px 4px; }
`;

},{}],180:[function(require,module,exports){
'use strict';

/**
 * Pict-ActivityGraph-Renderer
 * ---------------------------
 * Pure data -> SVG string. No DOM, no pict, no side effects, so it is trivially testable and can be
 * rasterized headlessly. The view calls buildSVG(pModel); a test or a screenshot tool can call it too.
 *
 * The layout follows the System Activity whiteboard: time runs top to bottom (one row per period), and
 * each configured domain is a column of horizontal stacked bars (one bar per period, segmented by the
 * StackBy dimension). A separator with a label marks each super-group boundary (quarter for day/week/
 * month granularities, year for quarter). Colors: theme CSS vars (with hex fallbacks) drive text,
 * gridlines and surfaces so it re-themes live in the browser; the stack segments use a fixed categorical
 * palette. Counts are drawn as theme-colored text at the bar ends -- never on the colored fills -- so the
 * label contrast never depends on the segment color (the text-on-brand lesson).
 */

// Categorical palettes. Solid mid hues chosen to read on both light and dark panels. AI = violet to
// match the app's AI-actor convention.
const _TYPE_COLORS =
{
	Created: '#2f9e6e',
	Edited: '#3f7fd0',
	StatusChange: '#d99a2b',
	Completed: '#7a5cd0',
	Commented: '#c85a9c'
};
const _ACTOR_COLORS =
{
	Human: '#3f7fd0',
	AI: '#7a5cd0',
	System: '#8a93a6'
};
const _FALLBACK_SEQUENCE = ['#2f9e6e', '#3f7fd0', '#d99a2b', '#7a5cd0', '#c85a9c', '#4bb3b3', '#b3617a', '#8a93a6'];

// Theme tokens (var chain with a light-theme hex fallback). A headless rasterizer that does not resolve
// var() still gets the fallback if the caller strips `var(--x, ` / `)` down to the hex.
const _C =
{
	text: 'var(--theme-color-text-primary, #2b2d2f)',
	muted: 'var(--theme-color-text-secondary, #6c6a60)',
	border: 'var(--theme-color-border-default, #d8dde6)',
	panel: 'var(--theme-color-background-panel, #ffffff)',
	track: 'var(--theme-color-background-tertiary, #eef1f6)'
};

function _esc(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function _quarterOf(pDayString)
{
	let tmpMonth = parseInt(String(pDayString || '').slice(5, 7), 10) || 1;
	return Math.floor((tmpMonth - 1) / 3) + 1;
}

// The super-group label a row belongs to, or null when the granularity needs no grouping band.
function _superGroup(pDayString, pPeriod)
{
	let tmpYear = String(pDayString || '').slice(0, 4);
	if (pPeriod === 'Day' || pPeriod === 'Week' || pPeriod === 'Month') { return tmpYear + '-Q' + _quarterOf(pDayString); }
	if (pPeriod === 'Quarter') { return tmpYear; }
	return null;
}

function _colorFor(pStackBy, pKey, pIndex)
{
	if (pStackBy === 'ActorKind') { return _ACTOR_COLORS[pKey] || _FALLBACK_SEQUENCE[pIndex % _FALLBACK_SEQUENCE.length]; }
	return _TYPE_COLORS[pKey] || _FALLBACK_SEQUENCE[pIndex % _FALLBACK_SEQUENCE.length];
}

/**
 * pModel:
 *   { Period, StackBy ('ActivityType'|'ActorKind'), Measure ('EventCount'|'Volume'),
 *     LegendPosition ('top-left'|'top-right'|'bottom-left'|'bottom-right'|'none', default 'bottom-right'), Title (chart title; '' omits it, default 'System Activity'),
 *     Columns: [ { Key, Title, Accent } ], Buckets: [ { PeriodStart, PeriodKey, Domain, ActivityType, ActorKind, EventCount, Volume } ] }
 */
function buildSVG(pModel)
{
	let tmpModel = pModel || {};
	let tmpPeriod = tmpModel.Period || 'Week';
	let tmpStackBy = (tmpModel.StackBy === 'ActorKind') ? 'ActorKind' : 'ActivityType';
	let tmpMeasure = (tmpModel.Measure === 'Volume') ? 'Volume' : 'EventCount';
	let tmpColumns = Array.isArray(tmpModel.Columns) && tmpModel.Columns.length ? tmpModel.Columns : [{ Key: 'WorkItems', Title: 'Work Items', Accent: '#e0891e' }, { Key: 'Knowledge', Title: 'Knowledge', Accent: '#3f7fd0' }];
	let tmpBuckets = Array.isArray(tmpModel.Buckets) ? tmpModel.Buckets : [];
	let tmpLegendOptions = { 'top-left': 1, 'top-right': 1, 'bottom-left': 1, 'bottom-right': 1, 'none': 1 };
	let tmpLegendPosition = tmpLegendOptions[tmpModel.LegendPosition] ? tmpModel.LegendPosition : 'bottom-right';
	// Title text; pass an empty string to omit it (e.g. when the host page already has its own heading).
	let tmpTitle = (typeof tmpModel.Title === 'string') ? tmpModel.Title : 'System Activity';

	// --- geometry ---
	const WIDTH = 940;
	const PAD_L = 104;          // period-label gutter
	const PAD_R = 16;
	const TOP = 46;             // title + column headers
	const LEGEND_H = 30;
	const ROW_H = 26;
	const BAR_H = 15;
	const COL_GAP = 26;
	const COUNT_W = 40;         // room for the total label after a bar

	// --- distinct, ordered periods (union across columns), sorted by PeriodStart ---
	let tmpPeriodOrder = [];
	let tmpPeriodSeen = {};
	tmpBuckets.slice().sort((pA, pB) => String(pA.PeriodStart).localeCompare(String(pB.PeriodStart))).forEach((pB) =>
	{
		if (!tmpPeriodSeen[pB.PeriodKey]) { tmpPeriodSeen[pB.PeriodKey] = { PeriodKey: pB.PeriodKey, PeriodStart: pB.PeriodStart }; tmpPeriodOrder.push(tmpPeriodSeen[pB.PeriodKey]); }
	});

	// --- pivot: period -> column -> stackKey -> measure; plus totals + distinct stack keys ---
	let tmpPivot = {};
	let tmpStackKeys = [];
	let tmpStackSeen = {};
	let tmpMaxTotal = 0;
	tmpBuckets.forEach((pB) =>
	{
		let tmpStackKey = String((tmpStackBy === 'ActorKind') ? (pB.ActorKind || 'System') : (pB.ActivityType || 'Other'));
		if (!tmpStackSeen[tmpStackKey]) { tmpStackSeen[tmpStackKey] = true; tmpStackKeys.push(tmpStackKey); }
		let tmpCell = tmpPivot[pB.PeriodKey] || (tmpPivot[pB.PeriodKey] = {});
		let tmpColCell = tmpCell[pB.Domain] || (tmpCell[pB.Domain] = { Total: 0, Segments: {} });
		let tmpValue = Number(pB[tmpMeasure]) || 0;
		tmpColCell.Segments[tmpStackKey] = (tmpColCell.Segments[tmpStackKey] || 0) + tmpValue;
		tmpColCell.Total += tmpValue;
		if (tmpColCell.Total > tmpMaxTotal) { tmpMaxTotal = tmpColCell.Total; }
	});
	tmpStackKeys.sort();
	if (tmpMaxTotal <= 0) { tmpMaxTotal = 1; }

	let tmpColorByKey = {};
	tmpStackKeys.forEach((pKey, pIndex) => { tmpColorByKey[pKey] = _colorFor(tmpStackBy, pKey, pIndex); });

	// --- column x-geometry ---
	let tmpChartWidth = WIDTH - PAD_L - PAD_R;
	let tmpColWidth = (tmpChartWidth - COL_GAP * (tmpColumns.length - 1)) / tmpColumns.length;
	let tmpBarMax = tmpColWidth - COUNT_W;
	let tmpColX = tmpColumns.map((pCol, pIndex) => PAD_L + pIndex * (tmpColWidth + COL_GAP));

	// --- empty state ---
	if (!tmpPeriodOrder.length)
	{
		let tmpH = TOP + 80;
		return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + WIDTH + ' ' + tmpH + '" width="100%" role="img" aria-label="Activity chart, no data">'
			+ '<text x="' + (WIDTH / 2) + '" y="' + (tmpH / 2) + '" text-anchor="middle" font-family="sans-serif" font-size="14" fill="' + _C.muted + '">No activity in this range yet.</text></svg>';
	}

	// Legend placement is configurable (default bottom-right, out of the title's way). When it is not at
	// the top, the chart body starts higher and grows a band at the bottom to hold it.
	let tmpLegendTop = tmpLegendPosition.indexOf('top') === 0;
	let tmpLegendRight = tmpLegendPosition.indexOf('right') >= 0;
	let tmpShowLegend = (tmpLegendPosition !== 'none') && (tmpStackKeys.length > 0);

	// Without a title, reclaim its band so the chart starts higher.
	let tmpTop = tmpTitle ? TOP : (TOP - 22);
	let tmpChartTop = tmpTop + ((tmpShowLegend && tmpLegendTop) ? LEGEND_H : 10);
	const GROUP_H = 22;         // a super-group (quarter/year) gets its own header band, so its label
	                           // never shares a line with the per-row date labels.
	// Count the super-group bands up front so the SVG height accounts for them.
	let tmpGroupCount = 0;
	let tmpScanGroup = null;
	tmpPeriodOrder.forEach((pRow) => { let tmpG = _superGroup(pRow.PeriodStart, tmpPeriod); if (tmpG && tmpG !== tmpScanGroup) { tmpGroupCount += 1; tmpScanGroup = tmpG; } });
	let tmpBodyBottom = tmpChartTop + tmpPeriodOrder.length * ROW_H + tmpGroupCount * GROUP_H;
	let tmpHeight = tmpBodyBottom + ((tmpShowLegend && !tmpLegendTop) ? LEGEND_H : 0) + 16;
	let tmpSVG = [];
	tmpSVG.push('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + WIDTH + ' ' + tmpHeight + '" width="100%" role="img" aria-label="System activity, one bar per ' + _esc(tmpPeriod) + ' stacked by ' + _esc(tmpStackBy) + ', each column scaled 0 to ' + tmpMaxTotal + '" font-family="-apple-system, Segoe UI, Roboto, sans-serif">');

	// title (top-left; omitted when Title is an empty string)
	if (tmpTitle)
	{
		tmpSVG.push('<text x="0" y="' + (tmpTop - 22) + '" font-size="15" font-weight="600" fill="' + _C.text + '">' + _esc(tmpTitle) + '</text>');
	}

	// legend: a swatch + label per stack key, placed per LegendPosition. The total width is measured
	// first so a right-aligned legend ends flush with the chart's right edge.
	if (tmpShowLegend)
	{
		let tmpItems = tmpStackKeys.map((pKey) => ({ Key: pKey, Color: tmpColorByKey[pKey], W: 16 + _esc(pKey).length * 6.8 }));
		let tmpTotalW = tmpItems.reduce((pSum, pItem) => pSum + pItem.W + 16, 0) - 16;
		let tmpLX = tmpLegendRight ? (WIDTH - PAD_R - tmpTotalW) : PAD_L;
		let tmpSwatchY = tmpLegendTop ? (tmpTop - 4) : (tmpBodyBottom + 14);
		let tmpTextY = tmpLegendTop ? (tmpTop + 5) : (tmpBodyBottom + 23);
		tmpItems.forEach((pItem) =>
		{
			tmpSVG.push('<rect x="' + tmpLX.toFixed(1) + '" y="' + tmpSwatchY + '" width="11" height="11" rx="2" fill="' + pItem.Color + '"/>');
			tmpSVG.push('<text x="' + (tmpLX + 16).toFixed(1) + '" y="' + tmpTextY + '" font-size="12" fill="' + _C.muted + '">' + _esc(pItem.Key) + '</text>');
			tmpLX += pItem.W + 16;
		});
	}

	// column headers: accent-colored title (left) + the axis scale (right). Both columns share one global
	// max, so labeling each track's full-width value with the same number makes the shared, comparable
	// 0-to-max scale explicit -- a track that fills the whole width equals that max.
	tmpColumns.forEach((pCol, pIndex) =>
	{
		let tmpX = tmpColX[pIndex];
		tmpSVG.push('<text x="' + tmpX + '" y="' + (tmpChartTop - 8) + '" font-size="13" font-weight="600" fill="' + (pCol.Accent || _C.text) + '">' + _esc(pCol.Title || pCol.Key) + '</text>');
		tmpSVG.push('<rect x="' + tmpX + '" y="' + (tmpChartTop - 4) + '" width="' + Math.max(40, tmpColWidth * 0.4) + '" height="2" fill="' + (pCol.Accent || _C.border) + '"/>');
		tmpSVG.push('<text x="' + (tmpX + tmpBarMax).toFixed(1) + '" y="' + (tmpChartTop - 8) + '" text-anchor="end" font-size="10" fill="' + _C.muted + '">0 to ' + tmpMaxTotal + '</text>');
	});

	// rows (running y, so a super-group header band pushes the rows below it down instead of overlapping)
	let tmpPrevGroup = null;
	let tmpY = tmpChartTop;
	tmpPeriodOrder.forEach((pPeriodRow) =>
	{
		let tmpGroup = _superGroup(pPeriodRow.PeriodStart, tmpPeriod);
		if (tmpGroup && tmpGroup !== tmpPrevGroup)
		{
			// A band of its own: a boundary line, then the group label on its own line above the rows.
			tmpSVG.push('<line x1="0" y1="' + (tmpY + 7) + '" x2="' + (WIDTH - PAD_R) + '" y2="' + (tmpY + 7) + '" stroke="' + _C.border + '" stroke-width="1"/>');
			tmpSVG.push('<text x="0" y="' + (tmpY + 19) + '" font-size="11" font-weight="600" fill="' + _C.muted + '">' + _esc(tmpGroup) + '</text>');
			tmpY += GROUP_H;
			tmpPrevGroup = tmpGroup;
		}
		// period label
		tmpSVG.push('<text x="' + (PAD_L - 12) + '" y="' + (tmpY + BAR_H) + '" text-anchor="end" font-size="11" fill="' + _C.muted + '">' + _esc(pPeriodRow.PeriodKey) + '</text>');

		tmpColumns.forEach((pCol, pColIndex) =>
		{
			let tmpX0 = tmpColX[pColIndex];
			// track
			tmpSVG.push('<rect x="' + tmpX0 + '" y="' + (tmpY + 3) + '" width="' + tmpBarMax + '" height="' + BAR_H + '" rx="3" fill="' + _C.track + '"/>');
			let tmpCell = (tmpPivot[pPeriodRow.PeriodKey] || {})[pCol.Key];
			if (tmpCell && tmpCell.Total > 0)
			{
				let tmpX = tmpX0;
				tmpStackKeys.forEach((pKey) =>
				{
					let tmpValue = tmpCell.Segments[pKey] || 0;
					if (tmpValue <= 0) { return; }
					let tmpW = (tmpValue / tmpMaxTotal) * tmpBarMax;
					tmpSVG.push('<rect x="' + tmpX.toFixed(1) + '" y="' + (tmpY + 3) + '" width="' + tmpW.toFixed(1) + '" height="' + BAR_H + '" fill="' + tmpColorByKey[pKey] + '"><title>' + _esc(pCol.Title + ' ' + pKey + ': ' + tmpValue) + '</title></rect>');
					tmpX += tmpW;
				});
				tmpSVG.push('<text x="' + (tmpX + 6).toFixed(1) + '" y="' + (tmpY + BAR_H) + '" font-size="11" font-weight="600" fill="' + _C.text + '">' + tmpCell.Total + '</text>');
			}
		});
		tmpY += ROW_H;
	});

	tmpSVG.push('</svg>');
	return tmpSVG.join('');
}

module.exports = { buildSVG: buildSVG, _superGroup: _superGroup, _TYPE_COLORS: _TYPE_COLORS, _ACTOR_COLORS: _ACTOR_COLORS };

},{}],181:[function(require,module,exports){
'use strict';

/**
 * pict-section-activitygraph entry.
 *
 * The default export is the view class (with default_configuration hung off it, as every pict-section
 * does), so a host registers it with:
 *   pict.addView('MyActivityGraph', libActivityGraph.default_configuration, libActivityGraph);
 * Override ActivityGraph.Columns / Period / PeriodChangeHandler and the Renderables[].ContentDestination
 * Address in the config to place and wire an instance. The pure SVG renderer is exported as .Renderer for
 * tests and headless rasterization.
 */

const libActivityGraphView = require('./views/PictView-ActivityGraph.js');

module.exports = libActivityGraphView;
module.exports.default_configuration = libActivityGraphView.default_configuration;
module.exports.PictViewActivityGraph = libActivityGraphView;
module.exports.Renderer = require('./Pict-ActivityGraph-Renderer.js');

},{"./Pict-ActivityGraph-Renderer.js":180,"./views/PictView-ActivityGraph.js":182}],182:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libRenderer = require('../Pict-ActivityGraph-Renderer.js');
const libCSS = require('../Pict-ActivityGraph-CSS.js');

/**
 * PictView-ActivityGraph
 * ----------------------
 * Renders a stacked-bar activity timeline (see Pict-ActivityGraph-Renderer for the SVG). The host feeds
 * it buckets with setData(); the built-in controls switch the granularity (Day..Year), the stack
 * dimension (by type / by actor), and the measure (count / volume). Granularity changes call the
 * host-supplied PeriodChangeHandler so the host can refetch that period's rows; the stack + measure
 * toggles just re-render the buckets already in hand (each bucket carries both dimensions).
 *
 * The chart SVG and the controls are computed content, so they are injected with ContentAssignment
 * rather than expressed as data-bound templates -- the same shape the moodboard / histogram sections use
 * for their bespoke visuals. Inline handlers reference this specific instance by its registered Hash, so
 * several instances on one page stay independent.
 */

const _DEFAULTS =
{
	Period: 'Week',
	Periods: ['Day', 'Week', 'Month', 'Quarter', 'Year'],
	StackBy: 'ActivityType',
	Measure: 'EventCount',
	LegendPosition: 'bottom-right',
	Title: 'System Activity',
	Columns: [
		{ Key: 'WorkItems', Title: 'Work Items', Accent: '#e0891e' },
		{ Key: 'Knowledge', Title: 'Knowledge', Accent: '#3f7fd0' }
	]
};

const _ViewConfiguration =
{
	ViewIdentifier: 'Pict-ActivityGraph',
	DefaultRenderable: 'Pict-ActivityGraph-Container',
	DefaultDestinationAddress: '#Pict-ActivityGraph-Container',
	AutoRender: false,
	CSS: libCSS,
	CSSHash: 'Pict-Section-ActivityGraph-CSS',
	ActivityGraph: _DEFAULTS,
	Templates: [
		{
			Hash: 'Pict-ActivityGraph-Container',
			Template: /*html*/`<div class="pict-activitygraph">
	<div class="pag-controls" id="Pict-ActivityGraph-Controls"></div>
	<div class="pag-chart" id="Pict-ActivityGraph-Chart"></div>
</div>`
		}
	],
	Renderables: [
		{
			RenderableHash: 'Pict-ActivityGraph-Container',
			TemplateHash: 'Pict-ActivityGraph-Container',
			ContentDestinationAddress: '#Pict-ActivityGraph-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewActivityGraph extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		let tmpConfig = (this.options && this.options.ActivityGraph) || {};
		this._State =
		{
			Period: tmpConfig.Period || _DEFAULTS.Period,
			Periods: Array.isArray(tmpConfig.Periods) ? tmpConfig.Periods : _DEFAULTS.Periods,
			StackBy: tmpConfig.StackBy || _DEFAULTS.StackBy,
			Measure: tmpConfig.Measure || _DEFAULTS.Measure,
			LegendPosition: tmpConfig.LegendPosition || _DEFAULTS.LegendPosition,
			Title: (typeof tmpConfig.Title === 'string') ? tmpConfig.Title : _DEFAULTS.Title,
			Columns: Array.isArray(tmpConfig.Columns) ? tmpConfig.Columns : _DEFAULTS.Columns,
			Buckets: []
		};
	}

	// The hash a host reaches this instance by (addView name), for inline handlers. Falls back to the
	// view identifier for a single-instance registration.
	get _InstanceHash() { return this.Hash || _ViewConfiguration.ViewIdentifier; }

	// Host API: hand the view a period's buckets. Optionally also set the period (when the host refetched
	// for a new granularity).
	setData(pPayload)
	{
		let tmpPayload = pPayload || {};
		if (tmpPayload.Period) { this._State.Period = tmpPayload.Period; }
		if (Array.isArray(tmpPayload.Columns)) { this._State.Columns = tmpPayload.Columns; }
		this._State.Buckets = Array.isArray(tmpPayload.Buckets) ? tmpPayload.Buckets : (Array.isArray(tmpPayload.Rows) ? tmpPayload.Rows : []);
		this.refresh();
		return this;
	}

	setPeriod(pPeriod)
	{
		if (this._State.Periods.indexOf(pPeriod) < 0) { return; }
		this._State.Period = pPeriod;
		let tmpHandler = (this.options && this.options.ActivityGraph && this.options.ActivityGraph.PeriodChangeHandler);
		if (typeof tmpHandler === 'function')
		{
			// Host refetches the new period's rows and calls setData(); reflect the active button now.
			this._injectControls();
			tmpHandler(pPeriod, this);
			return;
		}
		this.refresh();
	}

	setStackBy(pStackBy)
	{
		this._State.StackBy = (pStackBy === 'ActorKind') ? 'ActorKind' : 'ActivityType';
		this.refresh();
	}

	setMeasure(pMeasure)
	{
		this._State.Measure = (pMeasure === 'Volume') ? 'Volume' : 'EventCount';
		this.refresh();
	}

	_button(pLabel, pActive, pMethod, pArg)
	{
		return '<button class="pag-btn' + (pActive ? ' pag-btn-on' : '') + '" onclick="_Pict.views[\'' + this._InstanceHash + '\'].' + pMethod + '(\'' + pArg + '\')">' + pLabel + '</button>';
	}

	_injectControls()
	{
		let tmpHTML = '<div class="pag-group">';
		this._State.Periods.forEach((pPeriod) => { tmpHTML += this._button(pPeriod, this._State.Period === pPeriod, 'setPeriod', pPeriod); });
		tmpHTML += '</div><div class="pag-group pag-group-right">'
			+ '<span class="pag-label">Stack</span>'
			+ this._button('Type', this._State.StackBy === 'ActivityType', 'setStackBy', 'ActivityType')
			+ this._button('Actor', this._State.StackBy === 'ActorKind', 'setStackBy', 'ActorKind')
			+ '<span class="pag-label">Measure</span>'
			+ this._button('Count', this._State.Measure === 'EventCount', 'setMeasure', 'EventCount')
			+ this._button('Volume', this._State.Measure === 'Volume', 'setMeasure', 'Volume')
			+ '</div>';
		this.pict.ContentAssignment.assignContent('#Pict-ActivityGraph-Controls', tmpHTML);
	}

	_injectChart()
	{
		let tmpSVG = libRenderer.buildSVG(
			{
				Period: this._State.Period,
				StackBy: this._State.StackBy,
				Measure: this._State.Measure,
				LegendPosition: this._State.LegendPosition,
				Title: this._State.Title,
				Columns: this._State.Columns,
				Buckets: this._State.Buckets
			});
		this.pict.ContentAssignment.assignContent('#Pict-ActivityGraph-Chart', tmpSVG);
	}

	refresh()
	{
		this._injectControls();
		this._injectChart();
		return this;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.refresh();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewActivityGraph;
module.exports.default_configuration = _ViewConfiguration;

},{"../Pict-ActivityGraph-CSS.js":179,"../Pict-ActivityGraph-Renderer.js":180,"pict-view":365}],183:[function(require,module,exports){
'use strict';

/**
 * ChecklistModel
 * --------------
 * Pure tree + progress helpers for a checklist. A checklist is a flat list of items linked by
 * ParentKey; these turn that into a nested tree and compute how complete each branch is. No DOM, no
 * provider, no Pict -- just data, so the view and the tests lean on the same math.
 *
 * Progress is hierarchically weighted: each node splits its share of the whole equally among its
 * children. A root is worth 1 / (number of roots); a child is worth its parent's share / (number of
 * siblings). So two top-level items are 50% each, and if one of them holds two children those are
 * 25% each (half of the parent's 50%) no matter how many leaves the other branch carries. A leaf
 * (no children, the only thing with a checkbox) contributes its full weight when done; a group's
 * completion is the mean of its children, so a child counts the same however deep its own subtree runs.
 *
 * Each node carries Weight (its share of the whole, 0..1; leaf weights sum to 1), Fraction (its own
 * completion, 0..1), Percent (Math.round(Fraction * 100), for display), and LeafCount / DoneCount
 * (the raw task tally under it, for the "X of Y" readout).
 */

// Build a nested tree (roots, each with a Children array) from a flat item list. Items are linked by
// ParentKey (null or '' for a root) and ordered by Sort then by their original position. Each returned
// node is a shallow copy of its item plus Children and Depth; the input array is not mutated.
function buildTree(pItems)
{
	let tmpItems = Array.isArray(pItems) ? pItems : [];
	let tmpByParent = {};
	for (let i = 0; i < tmpItems.length; i++)
	{
		let tmpParent = _parentKey(tmpItems[i]);
		if (!tmpByParent[tmpParent]) { tmpByParent[tmpParent] = []; }
		tmpByParent[tmpParent].push({ Item: tmpItems[i], Index: i });
	}

	let fChildrenOf = (pParentKey, pDepth) =>
	{
		let tmpChildren = (tmpByParent[pParentKey] || []).slice()
			.sort((pA, pB) => (_sort(pA.Item) - _sort(pB.Item)) || (pA.Index - pB.Index));
		return tmpChildren.map((pEntry) =>
		{
			let tmpNode = Object.assign({}, pEntry.Item);
			tmpNode.Depth = pDepth;
			tmpNode.Children = fChildrenOf(String(pEntry.Item.Key), pDepth + 1);
			return tmpNode;
		});
	};

	return fChildrenOf('', 0);
}

// Annotate one node and its subtree with IsGroup / LeafCount / DoneCount / Fraction / Percent,
// post-order. A group's Fraction is the mean of its children's, so each child counts the same
// regardless of how many leaves it holds; LeafCount / DoneCount stay the raw task tally.
function annotateProgress(pNode)
{
	if (!pNode.Children || pNode.Children.length === 0)
	{
		pNode.IsGroup = false;
		pNode.LeafCount = 1;
		pNode.DoneCount = pNode.Done ? 1 : 0;
		pNode.Fraction = pNode.Done ? 1 : 0;
		pNode.Percent = pNode.Done ? 100 : 0;
		return pNode;
	}
	pNode.IsGroup = true;
	let tmpLeaves = 0;
	let tmpDone = 0;
	let tmpFractionSum = 0;
	for (let i = 0; i < pNode.Children.length; i++)
	{
		annotateProgress(pNode.Children[i]);
		tmpLeaves += pNode.Children[i].LeafCount;
		tmpDone += pNode.Children[i].DoneCount;
		tmpFractionSum += pNode.Children[i].Fraction;
	}
	pNode.LeafCount = tmpLeaves;
	pNode.DoneCount = tmpDone;
	pNode.Fraction = tmpFractionSum / pNode.Children.length;
	pNode.Percent = Math.round(pNode.Fraction * 100);
	return pNode;
}

// Distribute a node's completion weight down the tree: each node hands its share to its children in
// equal parts. Top-down, so it runs after the tree is built; pWeight is the node's share of the whole.
function assignWeights(pNode, pWeight)
{
	pNode.Weight = pWeight;
	let tmpChildren = pNode.Children || [];
	if (tmpChildren.length)
	{
		let tmpShare = pWeight / tmpChildren.length;
		for (let i = 0; i < tmpChildren.length; i++) { assignWeights(tmpChildren[i], tmpShare); }
	}
	return pNode;
}

// The one call the view uses: a flat item list in, { Roots, Overall } out. The roots split the whole
// 1.0 equally, so Overall completion is the mean of the roots' Fractions (a weighted roll-up), while
// LeafCount / DoneCount stay the raw count for the "X of Y" readout.
function decorate(pItems)
{
	let tmpRoots = buildTree(pItems);
	let tmpRootShare = tmpRoots.length ? (1 / tmpRoots.length) : 0;
	let tmpLeaves = 0;
	let tmpDone = 0;
	let tmpFractionSum = 0;
	for (let i = 0; i < tmpRoots.length; i++)
	{
		annotateProgress(tmpRoots[i]);
		assignWeights(tmpRoots[i], tmpRootShare);
		tmpLeaves += tmpRoots[i].LeafCount;
		tmpDone += tmpRoots[i].DoneCount;
		tmpFractionSum += tmpRoots[i].Fraction;
	}
	let tmpFraction = tmpRoots.length ? (tmpFractionSum / tmpRoots.length) : 0;
	return {
		Roots: tmpRoots,
		Overall:
		{
			Weight: tmpRoots.length ? 1 : 0,
			LeafCount: tmpLeaves,
			DoneCount: tmpDone,
			Fraction: tmpFraction,
			Percent: Math.round(tmpFraction * 100),
			Complete: (tmpLeaves > 0 && tmpDone === tmpLeaves)
		}
	};
}

function _parentKey(pItem) { return (pItem && pItem.ParentKey != null && pItem.ParentKey !== '') ? String(pItem.ParentKey) : ''; }
function _sort(pItem) { return (pItem && typeof pItem.Sort === 'number') ? pItem.Sort : 0; }

module.exports = { buildTree: buildTree, annotateProgress: annotateProgress, assignWeights: assignWeights, decorate: decorate };

},{}],184:[function(require,module,exports){
'use strict';

/**
 * pict-section-checklist entry point.
 *
 * Exports the Checklist view (with its default_configuration) plus the data-provider classes and the
 * tree/progress model, so a host can register the view and, if it wants, subclass the provider to talk
 * to its own backend or reuse the progress math.
 *
 * Typical use (in-memory by default; pass a DataProvider to persist):
 *
 *   const libChecklist = require('pict-section-checklist');
 *   pict.addView('WorkItem-Checklist', Object.assign({}, libChecklist.default_configuration,
 *       { Context: { OwnerType: 'WorkItem', IDOwner: 4012 }, Title: 'Acceptance checks' }),
 *       libChecklist);
 *   pict.views['WorkItem-Checklist'].render();
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libChecklistView = require('./views/PictView-Checklist.js');
const libChecklistProvider = require('./providers/ChecklistProvider-Base.js');
const libChecklistModel = require('./ChecklistModel.js');

module.exports = libChecklistView;
module.exports.default_configuration = libChecklistView.default_configuration;

// The data seam: the interface a host implements to override all reading and writing, and the
// in-memory default the section uses when nothing is wired.
module.exports.ChecklistDataProvider = libChecklistProvider.ChecklistDataProvider;
module.exports.InMemoryChecklistProvider = libChecklistProvider.InMemoryChecklistProvider;
module.exports.normalizeContext = libChecklistProvider.normalizeContext;

// The pure tree + progress helpers, exported for hosts and tests.
module.exports.Model = libChecklistModel;

},{"./ChecklistModel.js":183,"./providers/ChecklistProvider-Base.js":185,"./views/PictView-Checklist.js":186}],185:[function(require,module,exports){
'use strict';

/**
 * ChecklistProvider-Base
 * ----------------------
 * The data seam for pict-section-checklist. A checklist is a List (a title bound to a context) plus a
 * flat set of Items linked by ParentKey. A host overrides this to persist to a real backend; with no
 * override the section uses InMemoryChecklistProvider, so it works entirely in the browser.
 *
 * Record shapes (neutral; a backend provider maps its own rows to and from these):
 *   Context { OwnerType, IDOwner }                          -- what the checklist is attached to
 *   List    { Key, OwnerType, IDOwner, Title }
 *   Item    { Key, ListKey, ParentKey|null, Title, Done, Sort, Notes, Collapsed }
 *
 * Every primitive returns a Promise. Reads return deep copies, so a caller can never mutate the store
 * out from under the provider -- the view holds data, the provider owns truth.
 */

const _DEFAULT_TITLE = 'Checklist';

function normalizeContext(pContext)
{
	let tmpContext = pContext || {};
	return { OwnerType: String(tmpContext.OwnerType || ''), IDOwner: String(tmpContext.IDOwner || '') };
}

// Lowest free Sort within a list (so a new item lands at the end).
function _nextSort(pItemsMap, pListKey)
{
	let tmpMax = -1;
	let tmpKeys = Object.keys(pItemsMap);
	for (let i = 0; i < tmpKeys.length; i++)
	{
		let tmpItem = pItemsMap[tmpKeys[i]];
		if (String(tmpItem.ListKey) === String(pListKey) && typeof tmpItem.Sort === 'number' && tmpItem.Sort > tmpMax) { tmpMax = tmpItem.Sort; }
	}
	return tmpMax + 1;
}

class ChecklistDataProvider
{
	constructor(pOptions)
	{
		this.options = pOptions || {};
		this._now = (typeof this.options.Now === 'function') ? this.options.Now : function () { return Date.now(); };
		let tmpCounter = 0;
		this._key = (typeof this.options.KeyGenerator === 'function') ? this.options.KeyGenerator : (() =>
		{
			tmpCounter++;
			return 'chk_' + this._now().toString(36) + '_' + tmpCounter.toString(36) + '_' + Math.floor(Math.random() * 0x7fffffff).toString(36);
		});
	}

	// ---- primitives (subclasses MUST implement) ----
	getList(pContext) { return Promise.reject(new Error('ChecklistDataProvider.getList not implemented')); }
	updateList(pKey, pPatch) { return Promise.reject(new Error('ChecklistDataProvider.updateList not implemented')); }
	listItems(pListKey) { return Promise.reject(new Error('ChecklistDataProvider.listItems not implemented')); }
	createItem(pItemDraft) { return Promise.reject(new Error('ChecklistDataProvider.createItem not implemented')); }
	updateItem(pKey, pPatch) { return Promise.reject(new Error('ChecklistDataProvider.updateItem not implemented')); }
	deleteItem(pKey) { return Promise.reject(new Error('ChecklistDataProvider.deleteItem not implemented')); }

	// ---- convenience built on the primitives (every provider gets this for free) ----

	/** Load a context in one call: its list plus the list's items. @returns {Promise<{List, Items}>} */
	loadChecklist(pContext)
	{
		return this.getList(pContext).then((pList) =>
		{
			if (!pList) { return { List: null, Items: [] }; }
			return this.listItems(pList.Key).then((pItems) => ({ List: pList, Items: pItems || [] }));
		});
	}
}

/**
 * The default, self-contained provider. Holds lists and items in a plain object so the section works
 * with no backend. Pass a slice of AppData as Store to keep the state observable / serializable.
 */
class InMemoryChecklistProvider extends ChecklistDataProvider
{
	constructor(pOptions)
	{
		super(pOptions);
		let tmpStore = (this.options && this.options.Store) ? this.options.Store : {};
		if (!tmpStore.Lists) { tmpStore.Lists = {}; }
		if (!tmpStore.Items) { tmpStore.Items = {}; }
		this.store = tmpStore;
		this._title = this.options.Title || _DEFAULT_TITLE;
	}

	_clone(pValue) { return (pValue == null) ? pValue : JSON.parse(JSON.stringify(pValue)); }

	getList(pContext)
	{
		let tmpContext = normalizeContext(pContext);
		let tmpExisting = Object.keys(this.store.Lists)
			.map((pKey) => this.store.Lists[pKey])
			.find((pList) => String(pList.OwnerType) === tmpContext.OwnerType && String(pList.IDOwner) === tmpContext.IDOwner);
		if (tmpExisting) { return Promise.resolve(this._clone(tmpExisting)); }
		// First load of a context implicitly creates its (empty) list, so the view always has one.
		let tmpNow = this._now();
		let tmpList = { Key: this._key(), OwnerType: tmpContext.OwnerType, IDOwner: tmpContext.IDOwner, Title: this._title, CreatedAt: tmpNow, UpdatedAt: tmpNow };
		this.store.Lists[tmpList.Key] = tmpList;
		return Promise.resolve(this._clone(tmpList));
	}

	updateList(pKey, pPatch)
	{
		let tmpList = this.store.Lists[pKey];
		if (!tmpList) { return Promise.reject(new Error('updateList: no list ' + pKey)); }
		if (pPatch && Object.prototype.hasOwnProperty.call(pPatch, 'Title')) { tmpList.Title = String(pPatch.Title); }
		tmpList.UpdatedAt = this._now();
		return Promise.resolve(this._clone(tmpList));
	}

	listItems(pListKey)
	{
		let tmpItems = Object.keys(this.store.Items)
			.map((pKey) => this.store.Items[pKey])
			.filter((pItem) => String(pItem.ListKey) === String(pListKey) && !pItem.Deleted)
			.sort((pA, pB) => (pA.Sort - pB.Sort));
		return Promise.resolve(this._clone(tmpItems));
	}

	createItem(pItemDraft)
	{
		let tmpDraft = pItemDraft || {};
		if (!tmpDraft.ListKey || !this.store.Lists[tmpDraft.ListKey]) { return Promise.reject(new Error('createItem requires a ListKey of an existing list')); }
		let tmpNow = this._now();
		let tmpItem =
		{
			Key: tmpDraft.Key || this._key(),
			ListKey: tmpDraft.ListKey,
			ParentKey: (tmpDraft.ParentKey != null && tmpDraft.ParentKey !== '') ? String(tmpDraft.ParentKey) : null,
			Title: (tmpDraft.Title != null) ? String(tmpDraft.Title) : '',
			Done: !!tmpDraft.Done,
			Sort: (typeof tmpDraft.Sort === 'number') ? tmpDraft.Sort : _nextSort(this.store.Items, tmpDraft.ListKey),
			Notes: tmpDraft.Notes ? String(tmpDraft.Notes) : '',
			Collapsed: !!tmpDraft.Collapsed,
			CreatedAt: tmpNow,
			UpdatedAt: tmpNow,
			Deleted: false
		};
		this.store.Items[tmpItem.Key] = tmpItem;
		return Promise.resolve(this._clone(tmpItem));
	}

	updateItem(pKey, pPatch)
	{
		let tmpItem = this.store.Items[pKey];
		if (!tmpItem || tmpItem.Deleted) { return Promise.reject(new Error('updateItem: no item ' + pKey)); }
		let tmpPatch = pPatch || {};
		let tmpAllowed = ['Title', 'Done', 'Sort', 'ParentKey', 'Notes', 'Collapsed'];
		for (let i = 0; i < tmpAllowed.length; i++)
		{
			let tmpField = tmpAllowed[i];
			if (!Object.prototype.hasOwnProperty.call(tmpPatch, tmpField)) { continue; }
			if (tmpField === 'ParentKey') { tmpItem.ParentKey = (tmpPatch.ParentKey != null && tmpPatch.ParentKey !== '') ? String(tmpPatch.ParentKey) : null; }
			else if (tmpField === 'Title' || tmpField === 'Notes') { tmpItem[tmpField] = String(tmpPatch[tmpField]); }
			else if (tmpField === 'Done' || tmpField === 'Collapsed') { tmpItem[tmpField] = !!tmpPatch[tmpField]; }
			else { tmpItem[tmpField] = tmpPatch[tmpField]; }
		}
		tmpItem.UpdatedAt = this._now();
		return Promise.resolve(this._clone(tmpItem));
	}

	deleteItem(pKey)
	{
		// Remove the item and its whole subtree (depth-first collect, then drop).
		let tmpToDelete = {};
		let fCollect = (pItemKey) =>
		{
			tmpToDelete[pItemKey] = true;
			let tmpKeys = Object.keys(this.store.Items);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpChild = this.store.Items[tmpKeys[i]];
				if (tmpChild.ParentKey != null && String(tmpChild.ParentKey) === String(pItemKey) && !tmpToDelete[tmpChild.Key]) { fCollect(tmpChild.Key); }
			}
		};
		if (this.store.Items[pKey]) { fCollect(pKey); }
		Object.keys(tmpToDelete).forEach((pDelKey) => { delete this.store.Items[pDelKey]; });
		return Promise.resolve();
	}
}

module.exports =
{
	ChecklistDataProvider: ChecklistDataProvider,
	InMemoryChecklistProvider: InMemoryChecklistProvider,
	normalizeContext: normalizeContext,
	DEFAULT_TITLE: _DEFAULT_TITLE
};

},{}],186:[function(require,module,exports){
'use strict';

/**
 * PictView-Checklist
 * ------------------
 * An inline-editable, nestable checklist. Mount it on a Context (OwnerType + IDOwner) and it renders
 * that context's one checklist: a title, a tree of items, leaf checkboxes, per-group and overall
 * progress, and a read-only mode.
 *
 * It never touches storage itself: every read and write goes through a ChecklistDataProvider (see
 * providers/ChecklistProvider-Base.js). With nothing wired it uses an InMemoryChecklistProvider backed
 * by a slice of AppData, so it works the moment it mounts; a host swaps in its own provider to persist.
 *
 * Editing is the outliner flow people expect: type a title, Enter adds a sibling below, Tab nests
 * under the item above, Shift+Tab promotes, Backspace on an empty item removes it. A leaf carries a
 * checkbox; an item with children becomes a group that shows the share of its leaves that are done.
 *
 * Rendering follows the pict conventions: data lives in AppData (the active instance's shaped state is
 * published to AppData.ChecklistActive just before each render, so templates read it and the engine
 * bakes the correct per-instance view hash into every inline handler), iteration is {~TS:~} (the item
 * template recurses into its own Children), and every interaction is an inline handler. All colors are
 * theme tokens, so an active pict-section-theme recolors the whole control.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libModal = require('pict-section-modal');

const libChecklistProvider = require('../providers/ChecklistProvider-Base.js');
const libModel = require('../ChecklistModel.js');

const _InMemoryChecklistProvider = libChecklistProvider.InMemoryChecklistProvider;

const _DefaultConfiguration =
{
	ViewIdentifier: 'Checklist',
	DefaultRenderable: 'Checklist-Section',
	DefaultDestinationAddress: '#Checklist-Container',
	AutoRender: false,

	// ---- options a host overrides ----
	// The Context this checklist is bound to (what it is "attached to"). Standalone lists just pick a
	// stable synthetic context.
	Context: { OwnerType: 'Standalone', IDOwner: '1' },
	// The data provider. Null means "make an in-memory one backed by AppData".
	DataProvider: null,
	// Title used when the provider first creates the list for a context.
	Title: 'Checklist',
	// Read-only renders the tree and progress with no editing affordances.
	ReadOnly: false,
	// Show the overall progress bar in the header, and a small progress readout on each group.
	ShowProgress: true,
	ShowGroupProgress: true,
	// Allow renaming the list title inline.
	EditableTitle: true,
	AddPlaceholder: 'Add an item',
	EmptyMessage: 'Nothing here yet. Add the first item below.',
	// Indent per nesting level, in px.
	IndentPixels: 22,

	CSSPriority: 500,
	CSS: /*css*/`
		.pict-checklist { font-family: var(--theme-typography-family-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif); font-size: 14px; color: var(--theme-color-text-primary, #1f2430); container-type: inline-size; }

		.pchk-header { display: flex; align-items: center; gap: 12px; margin-bottom: 8px; }
		.pchk-list-title { font-size: 15px; font-weight: 600; color: var(--theme-color-text-primary, #1f2430); outline: none; border-radius: 4px; padding: 2px 5px; min-width: 40px; }
		.pchk-list-title:focus { background: var(--theme-color-background-tertiary, #eef2f6); }

		.pchk-overall { display: flex; align-items: center; gap: 8px; margin-left: auto; min-width: 170px; }
		.pchk-bar { flex: 1; height: 6px; border-radius: 3px; background: var(--theme-color-background-tertiary, #e7ecf0); overflow: hidden; }
		.pchk-bar-fill { height: 100%; width: 0; background: var(--theme-color-brand-primary, #2880a6); border-radius: 3px; transition: width 0.18s ease; }
		.pict-checklist.pchk-complete .pchk-bar-fill { background: var(--theme-color-status-success, #2e7d4f); }
		.pchk-overall-label { font-size: 12px; color: var(--theme-color-text-secondary, #5b6470); white-space: nowrap; font-variant-numeric: tabular-nums; }

		.pchk-list, .pchk-children { list-style: none; margin: 0; padding: 0; }
		.pchk-children { padding-left: 22px; }
		.pchk-children:empty { display: none; }

		.pchk-row { display: flex; align-items: center; gap: 7px; padding: 3px 4px; border-radius: 6px; }
		.pchk-row:hover { background: var(--theme-color-background-secondary, #f7f9fb); }

		.pchk-caret { width: 18px; height: 18px; flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; color: var(--theme-color-text-muted, #97a1ab); border: none; background: none; padding: 0; font-size: 15px; }
		.pchk-caret:hover { color: var(--theme-color-text-secondary, #5b6470); }
		.pchk-leaf .pchk-caret { visibility: hidden; cursor: default; }
		.pchk-caret-closed { display: none; }
		.pchk-item.pchk-collapsed > .pchk-row > .pchk-caret .pchk-caret-open { display: none; }
		.pchk-item.pchk-collapsed > .pchk-row > .pchk-caret .pchk-caret-closed { display: inline-flex; }

		.pchk-check { width: 18px; height: 18px; flex: 0 0 auto; border: 1.5px solid var(--theme-color-border-strong, #a0a0a0); border-radius: 5px; background: var(--theme-color-background-panel, #fff); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; color: var(--theme-color-text-on-brand, #fff); font-size: 12px; padding: 0; }
		.pchk-group > .pchk-row > .pchk-check { display: none; }
		.pchk-check .pict-icon { opacity: 0; transform: scale(0.5); transition: opacity 0.1s ease, transform 0.1s ease; }
		.pchk-item.pchk-done > .pchk-row > .pchk-check { background: var(--theme-color-brand-primary, #2880a6); border-color: var(--theme-color-brand-primary, #2880a6); }
		.pchk-item.pchk-done > .pchk-row > .pchk-check .pict-icon { opacity: 1; transform: scale(1); }
		.pict-checklist.pchk-readonly .pchk-check { cursor: default; }

		.pchk-title { flex: 1; min-width: 0; outline: none; padding: 2px 4px; border-radius: 4px; line-height: 1.4; word-break: break-word; }
		.pchk-title:focus { background: var(--theme-color-background-tertiary, #eef2f6); box-shadow: inset 0 0 0 2px var(--theme-color-brand-primary, #2880a6); }
		.pchk-item.pchk-done > .pchk-row > .pchk-title { color: var(--theme-color-text-muted, #97a1ab); text-decoration: line-through; }

		.pchk-group-progress { display: inline-flex; align-items: center; gap: 6px; margin-left: 6px; flex: 0 0 auto; }
		.pchk-leaf .pchk-group-progress { display: none; }
		.pchk-minibar { width: 46px; height: 5px; border-radius: 3px; background: var(--theme-color-background-tertiary, #e7ecf0); overflow: hidden; }
		.pchk-minibar-fill { height: 100%; width: 0; background: var(--theme-color-brand-primary, #2880a6); border-radius: 3px; transition: width 0.18s ease; }
		.pchk-item.pchk-group-done > .pchk-row > .pchk-group-progress .pchk-minibar-fill { background: var(--theme-color-status-success, #2e7d4f); }
		.pchk-pct { font-size: 11px; color: var(--theme-color-text-secondary, #5b6470); min-width: 30px; text-align: right; font-variant-numeric: tabular-nums; }

		.pchk-actions { display: inline-flex; gap: 2px; opacity: 0; transition: opacity 0.1s ease; margin-left: 2px; flex: 0 0 auto; }
		.pchk-row:hover .pchk-actions { opacity: 1; }
		.pict-checklist.pchk-readonly .pchk-actions { display: none; }
		.pchk-actions button { border: none; background: none; cursor: pointer; color: var(--theme-color-text-muted, #97a1ab); width: 22px; height: 22px; border-radius: 5px; display: inline-flex; align-items: center; justify-content: center; font-size: 14px; padding: 0; }
		.pchk-actions button:hover { background: var(--theme-color-background-hover, #eef2f6); color: var(--theme-color-text-secondary, #5b6470); }
		.pchk-actions .pchk-del:hover { color: var(--theme-color-status-error, #c0392b); }

		.pchk-add { display: flex; align-items: center; gap: 7px; padding: 5px 4px; margin-top: 2px; }
		.pchk-add-icon { width: 18px; flex: 0 0 auto; display: inline-flex; justify-content: center; color: var(--theme-color-text-muted, #97a1ab); }
		.pchk-add-btn { align-items: center; border: none; background: none; padding: 0; cursor: pointer; border-radius: 4px; }
		.pchk-add-btn:hover { color: var(--theme-color-brand-primary, #2880a6); }
		.pchk-add-input { flex: 1; border: none; outline: none; background: none; font: inherit; color: var(--theme-color-text-primary, #1f2430); padding: 2px 4px; }
		.pchk-add-input::placeholder { color: var(--theme-color-text-muted, #97a1ab); }
		.pict-checklist.pchk-readonly .pchk-add { display: none; }

		.pchk-empty { color: var(--theme-color-text-muted, #97a1ab); font-size: 13px; padding: 8px 4px; }

		/* Touch devices have no hover, so the per-row actions (add sub-item, delete) must always show or
		   they are unreachable -- this is what let deleting fail on a phone. */
		@media (hover: none)
		{
			.pchk-actions { opacity: 1; }
		}

		/* Narrow container (a sidebar rail, a phone-width column): the header must not force horizontal
		   overflow, so drop the wide progress bar to a compact percentage, let the title take the row, and
		   hide the per-group mini-bar (the percentage still shows). Uses container queries so it responds to
		   the checklist's own width, not the viewport -- a docked sidebar is narrow even on a wide screen. */
		@container (max-width: 340px)
		{
			.pchk-header { flex-wrap: wrap; gap: 6px 8px; }
			.pchk-list-title { flex: 1 1 auto; min-width: 0; }
			.pchk-overall { min-width: 0; gap: 6px; }
			.pchk-bar { display: none; }
			.pchk-minibar { display: none; }
			.pchk-children { padding-left: 16px; }
			.pchk-actions { opacity: 1; }
		}
	`,

	Templates:
	[
		{
			Hash: 'Checklist-Section',
			Template: /*html*/`
<div class="{~D:AppData.ChecklistActive.ContainerClass~}" id="Checklist-Root-{~D:AppData.ChecklistActive.ViewHash~}">
	<div class="pchk-header">
		<span class="pchk-list-title" id="{~D:AppData.ChecklistActive.TitleInputId~}" {~D:AppData.ChecklistActive.List.EditAttr~} onkeydown="if (event.key === 'Enter') { event.preventDefault(); this.blur(); }" onblur="_Pict.views['{~D:AppData.ChecklistActive.ViewHash~}'].commitListTitle(this)">{~D:AppData.ChecklistActive.List.Title~}</span>
		{~TS:Checklist-Progress:AppData.ChecklistActive.ProgressSlot~}
	</div>
	<ul class="pchk-list">{~TS:Checklist-Item:AppData.ChecklistActive.Roots~}</ul>
	{~TS:Checklist-Empty:AppData.ChecklistActive.EmptySlot~}
	{~TS:Checklist-Add:AppData.ChecklistActive.AddSlot~}
</div>`
		},
		{
			Hash: 'Checklist-Progress',
			Template: /*html*/`<div class="pchk-overall"><div class="pchk-bar"><div class="pchk-bar-fill" style="width:{~D:Record.Percent~}%"></div></div><span class="pchk-overall-label">{~D:Record.Label~}</span></div>`
		},
		{
			Hash: 'Checklist-Item',
			Template: /*html*/`
<li class="{~D:Record.RowClass~}" data-key="{~D:Record.Key~}">
	<div class="pchk-row">
		<button class="pchk-caret" type="button" title="Collapse / expand" onclick="_Pict.views['{~D:Record.ViewHash~}'].toggleCollapse('{~D:Record.Key~}')"><span class="pchk-caret-open">{~I:ChevronDown~}</span><span class="pchk-caret-closed">{~I:ChevronRight~}</span></button>
		<button class="pchk-check" type="button" title="Toggle done" onclick="_Pict.views['{~D:Record.ViewHash~}'].toggleItem('{~D:Record.Key~}')">{~I:Check~}</button>
		<span class="pchk-title" id="{~D:Record.InputId~}" {~D:Record.EditAttr~} onkeydown="_Pict.views['{~D:Record.ViewHash~}'].onTitleKeydown('{~D:Record.Key~}', event, this)" onblur="_Pict.views['{~D:Record.ViewHash~}'].commitTitle('{~D:Record.Key~}', this)">{~D:Record.Title~}</span>
		<span class="pchk-group-progress"><span class="pchk-minibar"><span class="pchk-minibar-fill" style="width:{~D:Record.Percent~}%"></span></span><span class="pchk-pct">{~D:Record.Percent~}%</span></span>
		<span class="pchk-actions"><button type="button" class="pchk-addchild" title="Add sub-item" onclick="_Pict.views['{~D:Record.ViewHash~}'].addChild('{~D:Record.Key~}')">{~I:Plus~}</button><button type="button" class="pchk-del" title="Delete" onclick="_Pict.views['{~D:Record.ViewHash~}'].confirmDelete('{~D:Record.Key~}')">{~I:Trash~}</button></span>
	</div>
	<ul class="pchk-children">{~TS:Checklist-Item:Record.Children~}</ul>
</li>`
		},
		{
			Hash: 'Checklist-Add',
			Template: /*html*/`<div class="pchk-add"><button type="button" class="pchk-add-icon pchk-add-btn" title="Add an item" onclick="_Pict.views['{~D:Record.ViewHash~}'].addItem()">{~I:Plus~}</button><input class="pchk-add-input" id="{~D:Record.AddInputId~}" type="text" placeholder="{~D:Record.AddPlaceholder~}" autocomplete="off" onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.views['{~D:Record.ViewHash~}'].addItem(); } else if (event.key === 'Escape') { this.value = ''; this.blur(); }"></div>`
		},
		{
			Hash: 'Checklist-Empty',
			Template: /*html*/`<div class="pchk-empty">{~D:Record.Message~}</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Checklist-Section',
			TemplateHash: 'Checklist-Section',
			ContentDestinationAddress: '#Checklist-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewChecklist extends libPictView
{
	onBeforeInitialize()
	{
		this._context = libChecklistProvider.normalizeContext(this.options.Context);
		this._list = null;
		this._items = [];
		this._active = this._emptyActive();
		this._ui = { FocusKey: null };
		this._provider = null;
		return super.onBeforeInitialize();
	}

	_initProvider()
	{
		if (this.options.DataProvider)
		{
			this._provider = this.options.DataProvider;
			return;
		}
		// Default: in-memory, backed by a slice of AppData keyed by this instance so multiple checklists
		// on a page keep separate stores and the data stays observable / serializable.
		if (!this.pict.AppData.ChecklistStores) { this.pict.AppData.ChecklistStores = {}; }
		if (!this.pict.AppData.ChecklistStores[this.Hash]) { this.pict.AppData.ChecklistStores[this.Hash] = {}; }
		this._provider = new _InMemoryChecklistProvider({ Store: this.pict.AppData.ChecklistStores[this.Hash], Title: this.options.Title });
	}

	onAfterInitializeAsync(fCallback)
	{
		this.mount().then(() => fCallback()).catch(() => fCallback());
	}

	// Bring the control fully up: register the modal, wire the data provider, load + paint. The async
	// init calls this for the normal (standalone) case. A host that adds the view DYNAMICALLY -- after
	// the app has initialized, when pict's addView does not run the async lifecycle -- should call
	// initialize() then mount() itself.
	mount()
	{
		this._ensureModal();
		this._initProvider();
		return this._reload();
	}

	onBeforeRender(pRenderable)
	{
		// Publish this instance's shaped state so the templates read it and the engine bakes THIS view's
		// hash into every inline handler (matches the multi-instance pattern in pict-section-comments).
		this.pict.AppData.ChecklistActive = this._active;
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._restoreFocus();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// ---- data flow -------------------------------------------------------------------------------

	_reload()
	{
		if (!this._provider)
		{
			this._list = null; this._items = [];
			this._shape(); this.render();
			return Promise.resolve();
		}
		return this._provider.loadChecklist(this._context).then((pLoaded) =>
		{
			this._list = (pLoaded && pLoaded.List) || null;
			this._items = (pLoaded && pLoaded.Items) || [];
			this._shape();
			this.render();
		}).catch((pError) =>
		{
			if (this.log) { this.log.error('pict-section-checklist load failed: ' + (pError && pError.message), pError); }
		});
	}

	_shape()
	{
		let tmpReadOnly = !!this.options.ReadOnly;
		let tmpEditable = !tmpReadOnly;
		let tmpDecorated = libModel.decorate(this._items);
		let tmpOverall = tmpDecorated.Overall;

		let tmpContainerClass = 'pict-checklist'
			+ (tmpReadOnly ? ' pchk-readonly' : '')
			+ (tmpOverall.Complete ? ' pchk-complete' : '');

		let tmpEditAttr = tmpEditable ? 'contenteditable="true"' : '';
		let tmpTitleEditAttr = (tmpEditable && this.options.EditableTitle !== false) ? 'contenteditable="true"' : '';

		this._active =
		{
			ViewHash: this.Hash,
			Editable: tmpEditable,
			ContainerClass: tmpContainerClass,
			TitleInputId: 'pchk-title-' + this.Hash,
			AddInputId: 'pchk-add-' + this.Hash,
			List:
			{
				Key: this._list ? this._list.Key : '',
				Title: this._list ? (this._list.Title || '') : (this.options.Title || ''),
				EditAttr: tmpTitleEditAttr
			},
			Overall:
			{
				Percent: tmpOverall.Percent,
				DoneCount: tmpOverall.DoneCount,
				LeafCount: tmpOverall.LeafCount,
				Complete: tmpOverall.Complete
			},
			Roots: tmpDecorated.Roots.map((pNode) => this._shapeNode(pNode, tmpEditAttr)),
			// single-element-array slots drive the conditional template sections
			ProgressSlot: (this.options.ShowProgress !== false) ? [{ Percent: tmpOverall.Percent, Label: tmpOverall.DoneCount + ' of ' + tmpOverall.LeafCount + ' · ' + tmpOverall.Percent + '%' }] : [],
			AddSlot: tmpEditable ? [{ ViewHash: this.Hash, AddInputId: 'pchk-add-' + this.Hash, AddPlaceholder: this.options.AddPlaceholder || 'Add an item' }] : [],
			EmptySlot: (tmpDecorated.Roots.length === 0) ? [{ Message: this.options.EmptyMessage || 'Nothing here yet.' }] : []
		};
	}

	_shapeNode(pNode, pEditAttr)
	{
		let tmpRowClass = 'pchk-item'
			+ (pNode.IsGroup ? ' pchk-group' : ' pchk-leaf')
			+ (pNode.Done ? ' pchk-done' : '')
			+ (pNode.Collapsed ? ' pchk-collapsed' : '')
			+ ((pNode.IsGroup && pNode.Percent === 100) ? ' pchk-group-done' : '');
		return {
			ViewHash: this.Hash,
			Key: pNode.Key,
			Title: pNode.Title || '',
			IsGroup: pNode.IsGroup,
			Done: !!pNode.Done,
			Percent: pNode.Percent,
			RowClass: tmpRowClass,
			InputId: 'pchk-input-' + this.Hash + '-' + pNode.Key,
			EditAttr: pEditAttr,
			// A collapsed group hides its children (still in the tree, just not rendered).
			Children: pNode.Collapsed ? [] : (pNode.Children || []).map((pChild) => this._shapeNode(pChild, pEditAttr))
		};
	}

	_emptyActive()
	{
		return { ViewHash: this.Hash, ContainerClass: 'pict-checklist', List: { Title: '', EditAttr: '' }, Overall: { Percent: 0, DoneCount: 0, LeafCount: 0 }, Roots: [], ProgressSlot: [], AddSlot: [], EmptySlot: [] };
	}

	// ---- item helpers (read from the flat list) --------------------------------------------------

	_itemByKey(pKey) { return this._items.find((pItem) => String(pItem.Key) === String(pKey)) || null; }

	_parentKeyOf(pItem) { return (pItem && pItem.ParentKey != null && pItem.ParentKey !== '') ? String(pItem.ParentKey) : ''; }

	_siblingsOf(pItem)
	{
		let tmpParent = this._parentKeyOf(pItem);
		return this._items
			.filter((pOther) => this._parentKeyOf(pOther) === tmpParent)
			.sort((pA, pB) => (pA.Sort - pB.Sort));
	}

	_childrenOf(pKey)
	{
		return this._items
			.filter((pItem) => String(this._parentKeyOf(pItem)) === String(pKey))
			.sort((pA, pB) => (pA.Sort - pB.Sort));
	}

	// ---- interactions ----------------------------------------------------------------------------

	toggleItem(pKey)
	{
		if (this.options.ReadOnly) { return Promise.resolve(); }
		let tmpItem = this._itemByKey(pKey);
		// Only leaves carry a checkbox; ignore a toggle on a group.
		if (!tmpItem || this._childrenOf(pKey).length > 0) { return Promise.resolve(); }
		let tmpNext = !tmpItem.Done;
		return this._provider.updateItem(pKey, { Done: tmpNext })
			.then(() => { this._fire('onItemToggled', { Key: pKey, Done: tmpNext }); return this._reloadAndChange(); });
	}

	toggleCollapse(pKey)
	{
		let tmpItem = this._itemByKey(pKey);
		if (!tmpItem) { return Promise.resolve(); }
		return this._provider.updateItem(pKey, { Collapsed: !tmpItem.Collapsed }).then(() => this._reload());
	}

	addItem()
	{
		if (this.options.ReadOnly || !this._list) { return Promise.resolve(); }
		let tmpInput = (typeof document !== 'undefined') ? document.getElementById(this._active.AddInputId) : null;
		let tmpTitle = tmpInput ? String(tmpInput.value || '').trim() : '';
		// Empty add (the "+" clicked with nothing typed, or Enter on a blank field): just put the cursor in
		// the input. There is one add flow -- type, then Enter or "+" -- so a click never discards typed text.
		if (!tmpTitle) { if (tmpInput) { tmpInput.focus(); } return Promise.resolve(); }
		if (tmpInput) { tmpInput.value = ''; }
		this._ui.FocusKey = '__add__';
		return this._provider.createItem({ ListKey: this._list.Key, ParentKey: null, Title: tmpTitle })
			.then((pItem) => { this._fire('onItemAdded', pItem); return this._reloadAndChange(); });
	}

	addChild(pKey)
	{
		if (this.options.ReadOnly || !this._list) { return Promise.resolve(); }
		let tmpChildren = this._childrenOf(pKey);
		let tmpSort = tmpChildren.length ? (tmpChildren[tmpChildren.length - 1].Sort + 1) : 0;
		return this._provider.createItem({ ListKey: this._list.Key, ParentKey: pKey, Title: '', Sort: tmpSort })
			.then((pItem) =>
			{
				this._ui.FocusKey = pItem.Key;
				// A new child also expands the (now) group so it is visible.
				let tmpParent = this._itemByKey(pKey);
				if (tmpParent && tmpParent.Collapsed) { return this._provider.updateItem(pKey, { Collapsed: false }).then(() => { this._fire('onItemAdded', pItem); return this._reloadAndChange(); }); }
				this._fire('onItemAdded', pItem);
				return this._reloadAndChange();
			});
	}

	addSibling(pKey)
	{
		if (this.options.ReadOnly || !this._list) { return Promise.resolve(); }
		let tmpItem = this._itemByKey(pKey);
		if (!tmpItem) { return this.addItem(); }
		let tmpSiblings = this._siblingsOf(tmpItem);
		let tmpIndex = tmpSiblings.findIndex((pOther) => String(pOther.Key) === String(pKey));
		let tmpNext = (tmpIndex >= 0 && tmpIndex < tmpSiblings.length - 1) ? tmpSiblings[tmpIndex + 1] : null;
		let tmpSort = tmpNext ? ((tmpItem.Sort + tmpNext.Sort) / 2) : (tmpItem.Sort + 1);
		return this._provider.createItem({ ListKey: this._list.Key, ParentKey: tmpItem.ParentKey, Title: '', Sort: tmpSort })
			.then((pItem) => { this._ui.FocusKey = pItem.Key; this._fire('onItemAdded', pItem); return this._reloadAndChange(); });
	}

	commitTitle(pKey, pElement)
	{
		if (this.options.ReadOnly) { return Promise.resolve(); }
		let tmpItem = this._itemByKey(pKey);
		let tmpTitle = pElement ? String(pElement.textContent || '').trim() : '';
		if (!tmpItem || tmpItem.Title === tmpTitle) { return Promise.resolve(); }
		// Keep the local copy current so a following structural action does not re-render the old title.
		tmpItem.Title = tmpTitle;
		return this._provider.updateItem(pKey, { Title: tmpTitle })
			.then(() => { this._fire('onItemEdited', { Key: pKey, Title: tmpTitle }); this._fire('onChange', { Event: 'onItemEdited', Payload: { Key: pKey } }); });
	}

	commitListTitle(pElement)
	{
		if (this.options.ReadOnly || this.options.EditableTitle === false || !this._list) { return Promise.resolve(); }
		let tmpTitle = pElement ? String(pElement.textContent || '').trim() : '';
		if (this._list.Title === tmpTitle) { return Promise.resolve(); }
		this._list.Title = tmpTitle;
		return this._provider.updateList(this._list.Key, { Title: tmpTitle })
			.then(() => { this._fire('onListRenamed', { Key: this._list.Key, Title: tmpTitle }); this._fire('onChange', { Event: 'onListRenamed', Payload: { Title: tmpTitle } }); });
	}

	onTitleKeydown(pKey, pEvent, pElement)
	{
		if (!pEvent) { return; }
		if (pEvent.key === 'Enter' && !pEvent.shiftKey)
		{
			pEvent.preventDefault();
			this.commitTitle(pKey, pElement);
			this.addSibling(pKey);
			return;
		}
		if (pEvent.key === 'Tab')
		{
			pEvent.preventDefault();
			this.commitTitle(pKey, pElement);
			if (pEvent.shiftKey) { this.outdentItem(pKey); } else { this.indentItem(pKey); }
			return;
		}
		if (pEvent.key === 'Backspace' && String(pElement.textContent || '') === '')
		{
			pEvent.preventDefault();
			this._deleteAndFocusPrev(pKey);
		}
	}

	indentItem(pKey)
	{
		if (this.options.ReadOnly) { return Promise.resolve(); }
		let tmpItem = this._itemByKey(pKey);
		if (!tmpItem) { return Promise.resolve(); }
		let tmpSiblings = this._siblingsOf(tmpItem);
		let tmpIndex = tmpSiblings.findIndex((pOther) => String(pOther.Key) === String(pKey));
		if (tmpIndex <= 0) { return Promise.resolve(); }                 // nothing to nest under
		let tmpNewParent = tmpSiblings[tmpIndex - 1];
		let tmpParentChildren = this._childrenOf(tmpNewParent.Key);
		let tmpSort = tmpParentChildren.length ? (tmpParentChildren[tmpParentChildren.length - 1].Sort + 1) : 0;
		this._ui.FocusKey = pKey;
		return this._provider.updateItem(pKey, { ParentKey: tmpNewParent.Key, Sort: tmpSort })
			.then(() => { if (tmpNewParent.Collapsed) { return this._provider.updateItem(tmpNewParent.Key, { Collapsed: false }); } })
			.then(() => this._reloadAndChange());
	}

	outdentItem(pKey)
	{
		if (this.options.ReadOnly) { return Promise.resolve(); }
		let tmpItem = this._itemByKey(pKey);
		if (!tmpItem) { return Promise.resolve(); }
		let tmpParentKey = this._parentKeyOf(tmpItem);
		if (!tmpParentKey) { return Promise.resolve(); }                 // already at the root
		let tmpParent = this._itemByKey(tmpParentKey);
		let tmpGrandKey = tmpParent ? tmpParent.ParentKey : null;
		let tmpSort = tmpParent ? (tmpParent.Sort + 0.5) : 0;            // drop in just after the old parent
		this._ui.FocusKey = pKey;
		return this._provider.updateItem(pKey, { ParentKey: tmpGrandKey, Sort: tmpSort })
			.then(() => this._reloadAndChange());
	}

	confirmDelete(pKey)
	{
		if (this.options.ReadOnly) { return Promise.resolve(); }
		let tmpItem = this._itemByKey(pKey);
		let tmpHasChildren = this._childrenOf(pKey).length > 0;
		let tmpLabel = (tmpItem && tmpItem.Title) ? ('"' + tmpItem.Title + '"') : 'this item';
		let tmpMessage = tmpHasChildren ? ('Delete ' + tmpLabel + ' and everything nested under it?') : ('Delete ' + tmpLabel + '?');
		return this._confirm(tmpMessage, { title: 'Delete item', confirmLabel: 'Delete', dangerous: true })
			.then((pOk) =>
			{
				if (!pOk) { return; }
				return this._provider.deleteItem(pKey).then(() => { this._fire('onItemDeleted', { Key: pKey }); return this._reloadAndChange(); });
			});
	}

	_deleteAndFocusPrev(pKey)
	{
		let tmpItem = this._itemByKey(pKey);
		if (!tmpItem) { return Promise.resolve(); }
		// Only fast-delete an empty leaf via Backspace; a group with children goes through the dialog.
		if (this._childrenOf(pKey).length > 0) { return Promise.resolve(); }
		let tmpSiblings = this._siblingsOf(tmpItem);
		let tmpIndex = tmpSiblings.findIndex((pOther) => String(pOther.Key) === String(pKey));
		let tmpPrev = (tmpIndex > 0) ? tmpSiblings[tmpIndex - 1] : null;
		this._ui.FocusKey = tmpPrev ? tmpPrev.Key : null;
		return this._provider.deleteItem(pKey).then(() => { this._fire('onItemDeleted', { Key: pKey }); return this._reloadAndChange(); });
	}

	// ---- public API ------------------------------------------------------------------------------

	setReadOnly(pReadOnly) { this.options.ReadOnly = !!pReadOnly; this._shape(); this.render(); }

	getItems() { return JSON.parse(JSON.stringify(this._items)); }

	reload() { return this._reload(); }

	// ---- internals -------------------------------------------------------------------------------

	_reloadAndChange() { return this._reload().then(() => this._fire('onChange', { Event: 'onChange' })); }

	_restoreFocus()
	{
		if (!this._ui.FocusKey || typeof document === 'undefined') { return; }
		let tmpId = (this._ui.FocusKey === '__add__') ? this._active.AddInputId : ('pchk-input-' + this.Hash + '-' + this._ui.FocusKey);
		this._ui.FocusKey = null;
		let tmpElement = document.getElementById(tmpId);
		if (!tmpElement) { return; }
		tmpElement.focus();
		if (tmpElement.tagName === 'INPUT') { return; }
		// contenteditable: drop the caret at the end.
		try
		{
			let tmpRange = document.createRange();
			tmpRange.selectNodeContents(tmpElement);
			tmpRange.collapse(false);
			let tmpSelection = window.getSelection();
			tmpSelection.removeAllRanges();
			tmpSelection.addRange(tmpRange);
		}
		catch (pError) { /* selection APIs absent (non-browser) -- focus is enough */ }
	}

	_fire(pName, pPayload)
	{
		let tmpHandler = this.options[pName];
		if (typeof tmpHandler === 'function') { try { tmpHandler(pPayload, this); } catch (pError) { if (this.log) { this.log.error('checklist ' + pName + ' handler threw: ' + (pError && pError.message), pError); } } }
	}

	// Make sure the modal section the delete confirm uses is registered + initialized, so a host gets
	// the dialog for free (mirrors pict-section-comments). A host that already registered it is left alone.
	_ensureModal()
	{
		if (!this.pict.views['Pict-Section-Modal'])
		{
			this.pict.addView('Pict-Section-Modal', libModal.default_configuration, libModal);
		}
		let tmpModalView = this.pict.views['Pict-Section-Modal'];
		if (tmpModalView && typeof document !== 'undefined' && document.body && typeof tmpModalView.initialize === 'function')
		{
			tmpModalView.initialize();
		}
	}

	_confirm(pMessage, pOptions)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function') { return tmpModal.confirm(pMessage, pOptions || {}); }
		// No modal section registered: fall back to resolving true so a host without it is not blocked.
		return Promise.resolve(true);
	}
}

module.exports = PictViewChecklist;
module.exports.default_configuration = _DefaultConfiguration;

},{"../ChecklistModel.js":183,"../providers/ChecklistProvider-Base.js":185,"pict-section-modal":271,"pict-view":365}],187:[function(require,module,exports){
/**
 * Simple syntax highlighter for use with CodeJar.
 *
 * Provides basic keyword/string/number/comment highlighting for common languages.
 * Can be replaced with Prism.js or highlight.js for more sophisticated highlighting
 * by passing a custom highlight function to the view options.
 *
 * @module Pict-Code-Highlighter
 */

// Language definition map
const _LanguageDefinitions = (
{
	'javascript':
	{
		// Combined regex to tokenize: comments, strings, template literals, regex, then everything else
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2|(`(?:[^`\\]|\\.)*?`)|(\/(?![/*])(?:\\.|\[(?:\\.|[^\]])*\]|[^/\\\n])+\/[gimsuvy]*)/g,
		keywords: /\b(async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|export|extends|finally|for|from|function|get|if|import|in|instanceof|let|new|of|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/g,
		builtins: /\b(true|false|null|undefined|NaN|Infinity|console|window|document|Math|JSON|Array|Object|String|Number|Boolean|Date|RegExp|Map|Set|Promise|Error|Symbol|parseInt|parseFloat|require|module|exports)\b/g,
		numbers: /\b(\d+\.?\d*(?:e[+-]?\d+)?|0x[0-9a-fA-F]+|0b[01]+|0o[0-7]+)\b/g
	},
	'json':
	{
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|("(?:[^"\\]|\\.)*")/g,
		keywords: /\b(true|false|null)\b/g,
		numbers: /-?\b\d+\.?\d*(?:e[+-]?\d+)?\b/g
	},
	'html':
	{
		// Tokenizer captures: (1) comments, (2) strings, (3) tags with attributes
		tokenizer: /(<!--[\s\S]*?-->)|(["'])(?:(?!\2|\\).|\\.)*?\2|(<\/?[a-zA-Z][a-zA-Z0-9-]*(?:\s+[a-zA-Z-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*))?)*\s*\/?>)/g,
		// tagToken group index for identifying tag matches
		tagGroupIndex: 3
	},
	'css':
	{
		tokenizer: /(\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		selectors: /([.#]?[a-zA-Z_][\w-]*(?:\s*[>+~]\s*[.#]?[a-zA-Z_][\w-]*)*)\s*\{/g,
		properties: /\b([a-zA-Z-]+)\s*:/g,
		numbers: /\b(\d+\.?\d*)(px|em|rem|%|vh|vw|s|ms|deg|fr)?\b/g,
		keywords: /\b(important|inherit|initial|unset|none|auto|block|inline|flex|grid)\b/g
	},
	'sql':
	{
		tokenizer: /(--[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		keywords: /\b(SELECT|FROM|WHERE|AND|OR|INSERT|INTO|VALUES|UPDATE|SET|DELETE|CREATE|TABLE|DROP|ALTER|ADD|COLUMN|INDEX|JOIN|LEFT|RIGHT|INNER|OUTER|ON|AS|ORDER|BY|GROUP|HAVING|LIMIT|OFFSET|UNION|ALL|DISTINCT|COUNT|SUM|AVG|MIN|MAX|NOT|NULL|IS|IN|BETWEEN|LIKE|EXISTS|CASE|WHEN|THEN|ELSE|END|PRIMARY|KEY|FOREIGN|REFERENCES|CONSTRAINT|DEFAULT|CHECK|UNIQUE|CASCADE|GRANT|REVOKE|COMMIT|ROLLBACK|BEGIN|TRANSACTION|INT|VARCHAR|DATETIME|AUTO_INCREMENT|CURRENT_TIMESTAMP)\b/gi,
		numbers: /\b\d+\.?\d*\b/g
	}
});

// Alias some common language names
_LanguageDefinitions['js'] = _LanguageDefinitions['javascript'];
_LanguageDefinitions['htm'] = _LanguageDefinitions['html'];

/**
 * Escape HTML special characters to prevent XSS when inserting into innerHTML.
 *
 * @param {string} pString - The string to escape
 * @returns {string} The escaped string
 */
function escapeHTML(pString)
{
	return pString
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * Highlight a segment of code that is NOT inside a string or comment.
 * This applies keyword, number, and structural highlighting.
 *
 * @param {string} pCode - The code segment to highlight (already HTML-escaped)
 * @param {object} pLanguageDef - The language definition
 * @returns {string} The highlighted HTML
 */
function highlightCodeSegment(pCode, pLanguageDef)
{
	let tmpResult = pCode;

	// CSS selectors
	if (pLanguageDef.selectors)
	{
		pLanguageDef.selectors.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.selectors, '<span class="function-name">$1</span>{');
	}

	// CSS properties
	if (pLanguageDef.properties)
	{
		pLanguageDef.properties.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.properties, '<span class="property">$1</span>:');
	}

	// Keywords
	if (pLanguageDef.keywords)
	{
		pLanguageDef.keywords.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.keywords, '<span class="keyword">$1</span>');
	}

	// Builtins
	if (pLanguageDef.builtins)
	{
		pLanguageDef.builtins.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.builtins, '<span class="keyword">$1</span>');
	}

	// Numbers (CSS numbers may have units as a capture group, others do not)
	if (pLanguageDef.numbers)
	{
		pLanguageDef.numbers.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.numbers, (pMatch) =>
		{
			return `<span class="number">${pMatch}</span>`;
		});
	}

	return tmpResult;
}

/**
 * Highlight an HTML tag token, applying tag name, attribute name, and attribute value colors.
 *
 * The approach: parse the raw tag into structured pieces first, then build the
 * highlighted output from those pieces. This avoids mixing raw text with HTML span
 * tags, which would cause regex replacements to match span attributes on subsequent passes.
 *
 * @param {string} pTag - The raw (unescaped) tag string
 * @returns {string} The highlighted HTML
 */
function highlightHTMLTag(pTag)
{
	let tmpResult = '';
	let tmpRest = pTag;

	// 1. Extract the opening bracket and tag name: < or </  followed by tagname
	let tmpTagNameMatch = tmpRest.match(/^(<\/?)([a-zA-Z][a-zA-Z0-9-]*)/);
	if (!tmpTagNameMatch)
	{
		// Not a recognizable tag, just escape the whole thing
		return escapeHTML(pTag);
	}

	tmpResult += escapeHTML(tmpTagNameMatch[1]);
	tmpResult += '<span class="tag">' + escapeHTML(tmpTagNameMatch[2]) + '</span>';
	tmpRest = tmpRest.substring(tmpTagNameMatch[0].length);

	// 2. Parse attributes from the remaining text (before the closing > or />)
	// Repeatedly match: whitespace + attr-name + optional =value
	let tmpAttrRegex = /^(\s+)([a-zA-Z-]+)(?:(\s*=\s*)(["'])([^"']*?)\4)?/;
	let tmpAttrMatch;

	while ((tmpAttrMatch = tmpRest.match(tmpAttrRegex)) !== null)
	{
		// Whitespace before the attribute
		tmpResult += tmpAttrMatch[1];
		// Attribute name
		tmpResult += '<span class="attr-name">' + escapeHTML(tmpAttrMatch[2]) + '</span>';

		// If there's an = value part
		if (tmpAttrMatch[3])
		{
			tmpResult += escapeHTML(tmpAttrMatch[3]);
			tmpResult += '<span class="attr-value">' + escapeHTML(tmpAttrMatch[4]) + escapeHTML(tmpAttrMatch[5]) + escapeHTML(tmpAttrMatch[4]) + '</span>';
		}

		tmpRest = tmpRest.substring(tmpAttrMatch[0].length);
	}

	// 3. Whatever remains (whitespace, />, >) — escape it all
	tmpResult += escapeHTML(tmpRest);

	return tmpResult;
}

/**
 * Create a highlight function for a given language.
 *
 * The approach: use a single tokenizer regex to split the code into protected tokens
 * (comments, strings) and code segments. Process each segment independently.
 * This avoids placeholder/sentinel issues entirely.
 *
 * @param {string} pLanguage - The language identifier (e.g. "javascript", "json", "html")
 * @returns {function} A function that takes an element and highlights its textContent
 */
function createHighlighter(pLanguage)
{
	return function highlightElement(pElement)
	{
		let tmpCode = pElement.textContent;
		let tmpLanguageName = (typeof (pLanguage) === 'string') ? pLanguage.toLowerCase() : 'javascript';
		let tmpLanguageDef = _LanguageDefinitions[tmpLanguageName];

		if (!tmpLanguageDef)
		{
			// No highlighting rules for this language; just escape and return
			pElement.innerHTML = escapeHTML(tmpCode);
			return;
		}

		if (!tmpLanguageDef.tokenizer)
		{
			// No tokenizer; just escape and apply keyword highlighting
			pElement.innerHTML = highlightCodeSegment(escapeHTML(tmpCode), tmpLanguageDef);
			return;
		}

		// Split the code into tokens using the tokenizer regex.
		// The tokenizer captures comments and strings as groups.
		// We process everything between matches as code.
		let tmpResult = '';
		let tmpLastIndex = 0;
		let tmpTagGroupIndex = tmpLanguageDef.tagGroupIndex || 0;

		tmpLanguageDef.tokenizer.lastIndex = 0;
		let tmpMatch;

		while ((tmpMatch = tmpLanguageDef.tokenizer.exec(tmpCode)) !== null)
		{
			// Add the code segment before this match
			if (tmpMatch.index > tmpLastIndex)
			{
				let tmpSegment = tmpCode.substring(tmpLastIndex, tmpMatch.index);
				tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
			}

			let tmpFullMatch = tmpMatch[0];

			// Determine token type from capture groups
			// Group 1 is always comments, Group 2+ are strings/template literals/regex
			if (tmpMatch[1])
			{
				// Comment
				tmpResult += `<span class="comment">${escapeHTML(tmpFullMatch)}</span>`;
			}
			else if (tmpTagGroupIndex > 0 && tmpMatch[tmpTagGroupIndex])
			{
				// HTML tag — highlight tag name, attributes, and values
				tmpResult += highlightHTMLTag(tmpFullMatch);
			}
			else
			{
				// String, template literal, or regex
				tmpResult += `<span class="string">${escapeHTML(tmpFullMatch)}</span>`;
			}

			tmpLastIndex = tmpLanguageDef.tokenizer.lastIndex;
		}

		// Add any remaining code after the last match
		if (tmpLastIndex < tmpCode.length)
		{
			let tmpSegment = tmpCode.substring(tmpLastIndex);
			tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
		}

		pElement.innerHTML = tmpResult;
	};
}

module.exports = createHighlighter;
module.exports.LanguageDefinitions = _LanguageDefinitions;

},{}],188:[function(require,module,exports){
module.exports = (
{
	"RenderOnLoad": true,

	"DefaultRenderable": "CodeEditor-Wrap",
	"DefaultDestinationAddress": "#CodeEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "CodeEditor-Container",
			"Template": "<!-- CodeEditor-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "CodeEditor-Wrap",
			"TemplateHash": "CodeEditor-Container",
			"DestinationAddress": "#CodeEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#CodeEditor-Container-Div",

	// Address in AppData or other Pict address space to read/write code content
	"CodeDataAddress": false,

	// The language for syntax highlighting (e.g. "javascript", "html", "css", "json")
	"Language": "javascript",

	// Whether the editor is read-only
	"ReadOnly": false,

	// Tab character: use tab or spaces
	"Tab": "\t",

	// Whether to indent with the same whitespace as the previous line
	"IndentOn": /[({[]$/,

	// Whether to add a closing bracket/paren/brace
	"MoveToNewLine": /^[)}\]]/,

	// Whether to handle the closing character
	"AddClosing": true,

	// Whether to preserve indentation on new lines
	"CatchTab": true,

	// Whether to show line numbers
	"LineNumbers": true,

	// Default code content if no address is provided
	"DefaultCode": "// Enter your code here\n",

	// CSS for the code editor.
	//
	// Every color/font is wired through pict-provider-theme tokens so apps
	// using pict-provider-theme get themed code editor automatically.  Each
	// var() carries its original ATOM-One-Light hex as the fallback so apps
	// without pict-provider-theme installed look exactly as before.
	"CSS": `.pict-code-editor-wrap
{
	display: flex;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.5;
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
}
.pict-code-editor-wrap .pict-code-line-numbers
{
	width: 40px;
	min-width: 40px;
	/* padding-top/bottom are stamped at runtime from the editor's
	   computed padding so row 1 of the gutter aligns with row 1 of
	   the code; only horizontal padding is stylesheet-owned. */
	padding: 0;
	text-align: right;
	background: var(--theme-color-editor-linenumber-background, var(--theme-color-background-secondary, #F5F5F5));
	border-right: 1px solid var(--theme-color-editor-gutter-border, var(--theme-color-border-default, #D0D0D0));
	color: var(--theme-color-editor-linenumber-text, var(--theme-color-text-muted, #999));
	font-size: 13px;
	/* line-height, padding-top, padding-bottom, and font-family are
	   intentionally NOT declared here.  PictSectionCode._syncGutterMetrics()
	   copies them from the editor's computed styles at init and on every
	   editor resize, so the gutter is guaranteed to track the editor.
	   Declaring them in CSS would either be redundant (when matching) or
	   actively wrong (when the editor's metrics diverge — e.g. theme scale
	   changes the editor's font-size).  See codejar-linenumbers for the
	   canonical version of this pattern. */
	user-select: none;
	pointer-events: none;
	box-sizing: border-box;
}
.pict-code-editor-wrap .pict-code-line-numbers span
{
	display: block;
	padding: 0 8px 0 0;
}
.pict-code-editor-wrap .pict-code-editor
{
	margin: 0;
	padding: 10px 10px 10px 8px;
	min-height: 100px;
	flex: 1;
	min-width: 0;
	outline: none;
	tab-size: 4;
	white-space: pre;
	overflow-wrap: normal;
	color: var(--theme-color-text-primary, #383A42);
	background: var(--theme-color-background-panel, #FAFAFA);
	caret-color: var(--theme-color-brand-primary, #526FFF);
	border-radius: 0 4px 4px 0;
}
.pict-code-editor-wrap .pict-code-editor.pict-code-no-line-numbers
{
	padding-left: 10px;
	border-radius: 4px;
}
.pict-code-editor-wrap .pict-code-editor::selection,
.pict-code-editor-wrap .pict-code-editor *::selection
{
	background: var(--theme-color-editor-selection-background, var(--theme-color-selection-background, #B3D4FC));
}
/* Syntax token colors — each class binds to a Color.Syntax.* token from
   pict-provider-theme. Fallback hexes match the One Light palette so apps
   that don't install the theme provider look the same as before. */
.pict-code-editor-wrap .pict-code-editor .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
.pict-code-editor-wrap .pict-code-editor .string        { color: var(--theme-color-syntax-string,      #50A14F); }
.pict-code-editor-wrap .pict-code-editor .number        { color: var(--theme-color-syntax-number,      #986801); }
.pict-code-editor-wrap .pict-code-editor .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
.pict-code-editor-wrap .pict-code-editor .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
.pict-code-editor-wrap .pict-code-editor .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
.pict-code-editor-wrap .pict-code-editor .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
.pict-code-editor-wrap .pict-code-editor .property      { color: var(--theme-color-syntax-property,    #E45649); }
.pict-code-editor-wrap .pict-code-editor .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
.pict-code-editor-wrap .pict-code-editor .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
.pict-code-editor-wrap .pict-code-editor .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
.pict-code-editor-wrap .pict-code-editor .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
.pict-code-editor-wrap .pict-code-editor .type          { color: var(--theme-color-syntax-type,        #C18401); }
.pict-code-editor-wrap .pict-code-editor .variable      { color: var(--theme-color-syntax-variable,    #383A42); }

/* highlight.js class aliases — when host apps render code blocks with
   highlight.js (e.g. markdown previews via CodeJar's hljs integration),
   the output uses .hljs / .hljs-* classes rather than the bare token
   classes pict-section-code emits. Mapping them here lets one stylesheet
   theme both editor surfaces (bare classes) and hljs-rendered surfaces
   without the host needing a separate per-app github.css. Rules are
   intentionally unscoped (no .pict-code-editor-wrap parent) so they
   apply globally wherever hljs paints. */
.hljs                  { color: var(--theme-color-text-primary,         #383A42); background: transparent; }
.hljs-keyword,
.hljs-keyword.hljs-typeof,
.hljs-selector-tag,
.hljs-literal          { color: var(--theme-color-syntax-keyword,       #A626A4); }
.hljs-string,
.hljs-regexp,
.hljs-template-tag,
.hljs-template-variable { color: var(--theme-color-syntax-string,       #50A14F); }
.hljs-number,
.hljs-meta             { color: var(--theme-color-syntax-number,        #986801); }
.hljs-comment,
.hljs-quote            { color: var(--theme-color-syntax-comment,       #A0A1A7); font-style: italic; }
.hljs-operator,
.hljs-link             { color: var(--theme-color-syntax-operator,      #0184BC); }
.hljs-punctuation      { color: var(--theme-color-syntax-punctuation,   #383A42); }
.hljs-function .hljs-title,
.hljs-title.function_,
.hljs-title.class_     { color: var(--theme-color-syntax-function,      #4078F2); }
.hljs-variable,
.hljs-variable.language_,
.hljs-params           { color: var(--theme-color-syntax-variable,      #383A42); }
.hljs-type,
.hljs-class .hljs-title { color: var(--theme-color-syntax-type,         #C18401); }
.hljs-built_in,
.hljs-builtin-name     { color: var(--theme-color-syntax-builtin,       #986801); }
.hljs-attr,
.hljs-property         { color: var(--theme-color-syntax-property,      #E45649); }
.hljs-tag,
.hljs-name             { color: var(--theme-color-syntax-tag,           #E45649); }
.hljs-attribute        { color: var(--theme-color-syntax-attrname,      #986801); }
.hljs-symbol           { color: var(--theme-color-syntax-attrvalue,     #50A14F); }
.hljs-emphasis         { font-style: italic; }
.hljs-strong           { font-weight: bold; }
.hljs-deletion         { color: var(--theme-color-status-error,         #B62828); background: rgba(220, 50, 47, 0.08); }
.hljs-addition         { color: var(--theme-color-status-success,       #2E7A3A); background: rgba(80, 161, 79, 0.10); }
`
});

},{}],189:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libCreateHighlighter = require('./Pict-Code-Highlighter.js');
const _DefaultConfiguration = require('./Pict-Section-Code-DefaultConfiguration.js');

class PictSectionCode extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// The CodeJar instance
		this.codeJar = null;

		// The highlight function (can be overridden)
		this._highlightFunction = null;

		// The current language
		this._language = this.options.Language || 'javascript';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this._codeJarPrototype = null;
		this.targetElement = false;

		// Build the default highlight function for the configured language
		this._highlightFunction = libCreateHighlighter(this._language);

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeJar prototype.  If not passed explicitly, try to find it
	 * as a global (window.CodeJar) or require it from the npm package.
	 *
	 * @param {function} [pCodeJarPrototype] - The CodeJar constructor function
	 * @returns {boolean|void}
	 */
	connectCodeJarPrototype(pCodeJarPrototype)
	{
		if (typeof (pCodeJarPrototype) === 'function')
		{
			this._codeJarPrototype = pCodeJarPrototype;
			return;
		}

		// Try to find CodeJar in global scope
		if (typeof (window) !== 'undefined')
		{
			if (typeof (window.CodeJar) === 'function')
			{
				this.log.trace(`PICT-Code Found CodeJar in window.CodeJar.`);
				this._codeJarPrototype = window.CodeJar;
				return;
			}
		}

		this.log.error(`PICT-Code No CodeJar prototype found. Include codejar via script tag or call connectCodeJarPrototype(CodeJar) explicitly.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Resolve the CodeJar prototype if not already set
		if (!this._codeJarPrototype)
		{
			this.connectCodeJarPrototype();
		}

		if (!this._codeJarPrototype)
		{
			this.log.error(`PICT-Code Cannot initialize editor; no CodeJar prototype available.`);
			return false;
		}

		if (this.codeJar)
		{
			this.log.error(`PICT-Code editor is already initialized!`);
			return false;
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-Code Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Build the editor DOM structure
		this._buildEditorDOM();

		// Get initial code content
		let tmpCode = this._resolveCodeContent();

		// Create the CodeJar options
		let tmpCodeJarOptions = {};
		if (this.options.Tab)
		{
			tmpCodeJarOptions.tab = this.options.Tab;
		}
		if (this.options.IndentOn)
		{
			tmpCodeJarOptions.indentOn = this.options.IndentOn;
		}
		if (this.options.MoveToNewLine)
		{
			tmpCodeJarOptions.moveToNewLine = this.options.MoveToNewLine;
		}
		if (typeof (this.options.AddClosing) !== 'undefined')
		{
			tmpCodeJarOptions.addClosing = this.options.AddClosing;
		}
		if (typeof (this.options.CatchTab) !== 'undefined')
		{
			tmpCodeJarOptions.catchTab = this.options.CatchTab;
		}

		this.customConfigureEditorOptions(tmpCodeJarOptions);

		// Instantiate CodeJar on the editor element
		let tmpEditorElement = this._editorElement;
		this.codeJar = this._codeJarPrototype(tmpEditorElement, this._highlightFunction, tmpCodeJarOptions);

		// CodeJar forces white-space:pre-wrap and overflow-wrap:break-word
		// via inline styles, which causes line wrapping that breaks the
		// line-number alignment.  Override back to non-wrapping so the
		// wrap container scrolls horizontally instead.
		this._resetEditorWrapStyles();

		// Set the initial code
		if (tmpCode)
		{
			this.codeJar.updateCode(tmpCode);
		}

		// Wire up the change handler
		this.codeJar.onUpdate((pCode) =>
		{
			this._updateLineNumbers();
			this.onCodeChange(pCode);
		});

		// Initial line number render
		this._updateLineNumbers();

		// Sync line-numbers vertical position with the editor's scroll.
		//
		// The editor element scrolls internally (CodeJar uses
		// contenteditable + overflow:auto for long content), but the
		// line-numbers div is a sibling with overflow:visible — without
		// this sync the line-numbers content stays glued at the top of
		// the wrap while the editor scrolls underneath it, so "line 1"
		// appears next to whatever line is actually showing.
		//
		// Using `transform: translateY(...)` instead of scrollTop keeps
		// the sync compositor-only (no reflow per scroll event) and
		// avoids needing to change the line-numbers element's overflow
		// from visible.  Passive listener so we don't block scrolling.
		if (this._lineNumbersElement)
		{
			let tmpLineNumbersEl = this._lineNumbersElement;
			tmpEditorElement.addEventListener('scroll', function ()
			{
				tmpLineNumbersEl.style.transform = 'translateY(-' + tmpEditorElement.scrollTop + 'px)';
			}, { passive: true });
		}

		// Sync gutter typographic metrics from the editor.  The gutter
		// must use the editor's exact line-height (and matching padding)
		// or rows drift apart cumulatively.  See _syncGutterMetrics().
		this._syncGutterMetrics();

		// Watch the editor for size changes (window resize affecting
		// flex layout, container resize) and re-sync the gutter so it
		// continues to track the editor.  ResizeObserver fires once per
		// frame at most, so the cost is negligible.
		if (this._lineNumbersElement && typeof (ResizeObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorResizeObserver = new ResizeObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorResizeObserver.observe(tmpEditorElement);
		}

		// Watch for direct style/class mutations on the editor.  Theme
		// providers that toggle scale by swapping a class on the editor,
		// or host code that adjusts editor typography via inline styles,
		// don't necessarily change the editor's box size — so the
		// ResizeObserver above wouldn't see them.  MutationObserver on
		// the attributes catches these cases.
		if (this._lineNumbersElement && typeof (MutationObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorStyleObserver = new MutationObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorStyleObserver.observe(tmpEditorElement,
				{ attributes: true, attributeFilter: ['style', 'class'] });
		}

		// Handle read-only
		if (this.options.ReadOnly)
		{
			tmpEditorElement.setAttribute('contenteditable', 'false');
		}
	}

	/**
	 * Build the editor DOM elements inside the target container.
	 */
	_buildEditorDOM()
	{
		// Clear the target
		this.targetElement.innerHTML = '';

		// Create wrapper
		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-code-editor-wrap';

		// Create line numbers container
		if (this.options.LineNumbers)
		{
			let tmpLineNumbers = document.createElement('div');
			tmpLineNumbers.className = 'pict-code-line-numbers';
			tmpWrap.appendChild(tmpLineNumbers);
			this._lineNumbersElement = tmpLineNumbers;
		}

		// Create the editor element (CodeJar needs a pre or div)
		let tmpEditor = document.createElement('div');
		tmpEditor.className = 'pict-code-editor language-' + this._language;
		if (!this.options.LineNumbers)
		{
			tmpEditor.className += ' pict-code-no-line-numbers';
		}
		tmpWrap.appendChild(tmpEditor);

		this.targetElement.appendChild(tmpWrap);
		this._editorElement = tmpEditor;
		this._wrapElement = tmpWrap;
	}

	/**
	 * Update the line numbers display based on current code content.
	 */
	_updateLineNumbers()
	{
		if (!this.options.LineNumbers || !this._lineNumbersElement || !this._editorElement)
		{
			return;
		}

		let tmpCode = this._editorElement.textContent || '';
		let tmpLineCount = tmpCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += `<span>${i}</span>`;
		}

		this._lineNumbersElement.innerHTML = tmpHTML;

		// Defense-in-depth: every line-count rebuild is also a natural
		// re-sync point.  Cheap (one getComputedStyle + a handful of
		// style writes) and guarantees newly-added spans use the same
		// metrics as the editor at the moment of the rebuild.
		this._syncGutterMetrics();
	}

	/**
	 * Copy typographic metrics from the editor element to the line-numbers
	 * gutter so every gutter row lines up with its corresponding code row.
	 *
	 * The gutter is a sibling element with its own font/line-height
	 * declarations — if any one diverges from the editor (unitless
	 * line-height resolving against a different font-size, host CSS
	 * overriding font-family, theme scale changing the editor's metrics),
	 * the two desync and the drift accumulates with every line.
	 *
	 * The pattern is borrowed from the canonical `codejar-linenumbers`
	 * library (julianpoemp/codejar-linenumbers), which solves the same
	 * class of bug by reading the editor's computed styles at init and
	 * stamping them onto the gutter.  We extend that here by also
	 * re-stamping whenever the editor resizes (see the ResizeObserver in
	 * onAfterInitialRender), so theme scale changes self-heal too.
	 *
	 * Public callers can invoke {@link syncMetrics} to force a re-sync
	 * after any external change that affects editor typography.
	 */
	_syncGutterMetrics()
	{
		if (!this._lineNumbersElement || !this._editorElement)
		{
			return;
		}
		if (typeof (window) === 'undefined' || typeof (window.getComputedStyle) !== 'function')
		{
			return;
		}

		let tmpEditorStyle = window.getComputedStyle(this._editorElement);
		let tmpLineHeight = tmpEditorStyle.lineHeight;

		// `normal` is the spec default — leave the gutter untouched so the
		// stylesheet's declaration wins (we have no number to copy).
		if (tmpLineHeight && tmpLineHeight !== 'normal')
		{
			this._lineNumbersElement.style.lineHeight = tmpLineHeight;
		}

		// Match the editor's vertical padding so row 1 of the gutter sits
		// at the same y-offset as row 1 of the code.
		if (tmpEditorStyle.paddingTop)
		{
			this._lineNumbersElement.style.paddingTop = tmpEditorStyle.paddingTop;
		}
		if (tmpEditorStyle.paddingBottom)
		{
			this._lineNumbersElement.style.paddingBottom = tmpEditorStyle.paddingBottom;
		}

		// Font-family must match so the visual baseline of the digits
		// aligns with the code (different monospace fonts can have
		// different x-heights even at identical line-heights).
		if (tmpEditorStyle.fontFamily)
		{
			this._lineNumbersElement.style.fontFamily = tmpEditorStyle.fontFamily;
		}

		// Dev-time sanity check.  If the gutter's resolved row height
		// disagrees with the editor's, alignment will drift cumulatively.
		// Warn loudly so the regression is caught at the next reload
		// instead of silently accumulating pixels per line.
		if (typeof (console) !== 'undefined' && console.warn)
		{
			let tmpFirstSpan = this._lineNumbersElement.querySelector('span');
			if (tmpFirstSpan)
			{
				let tmpGutterRow = tmpFirstSpan.getBoundingClientRect().height;
				let tmpEditorRow = parseFloat(tmpLineHeight);
				if (tmpGutterRow && tmpEditorRow && Math.abs(tmpGutterRow - tmpEditorRow) > 0.5)
				{
					console.warn('[pict-section-code] gutter/editor row-height mismatch: ' +
						'gutter ' + tmpGutterRow + 'px vs editor ' + tmpEditorRow + 'px — ' +
						'line numbers will drift. Check for CSS overriding ' +
						'.pict-code-line-numbers line-height.');
				}
			}
		}
	}

	/**
	 * Public hook for hosts to force a gutter metrics re-sync after
	 * external typography changes (theme scale, font-size swap, etc.).
	 * The ResizeObserver attached at init handles most cases, but call
	 * this from an app's post-theme-change hook for belt-and-suspenders
	 * coverage.
	 */
	syncMetrics()
	{
		this._syncGutterMetrics();
	}

	/**
	 * Reset inline styles that CodeJar sets on the editor element.
	 *
	 * CodeJar forces white-space:pre-wrap and overflow-wrap:break-word so
	 * long lines wrap visually.  That breaks line-number alignment because
	 * each wrapped visual row is not a logical line.  Resetting to pre /
	 * normal makes the outer .pict-code-editor-wrap scroll horizontally.
	 */
	_resetEditorWrapStyles()
	{
		if (!this._editorElement)
		{
			return;
		}
		this._editorElement.style.whiteSpace = 'pre';
		this._editorElement.style.overflowWrap = 'normal';
	}

	/**
	 * Resolve the initial code content from address or default.
	 *
	 * @returns {string} The code content
	 */
	_resolveCodeContent()
	{
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.CodeDataAddress);
			if (typeof (tmpAddressedData) === 'string')
			{
				return tmpAddressedData;
			}
			else
			{
				this.log.warn(`PICT-Code Address [${this.options.CodeDataAddress}] did not return a string; it was ${typeof (tmpAddressedData)}.`);
			}
		}

		return this.options.DefaultCode || '';
	}

	/**
	 * Hook for subclasses to customize CodeJar options before instantiation.
	 *
	 * @param {object} pOptions - The CodeJar options object to modify
	 */
	customConfigureEditorOptions(pOptions)
	{
		// Override in subclass to tweak options
	}

	/**
	 * Called when the code content changes.  Override in subclasses to handle changes.
	 *
	 * @param {string} pCode - The new code content
	 */
	onCodeChange(pCode)
	{
		// Write back to data address if configured
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.CodeDataAddress, pCode);
		}
	}

	// -- Public API Methods --

	/**
	 * Get the current code content.
	 *
	 * @returns {string} The current code
	 */
	getCode()
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code getCode called before editor initialized.');
			return '';
		}
		return this.codeJar.toString();
	}

	/**
	 * Set the code content.
	 *
	 * @param {string} pCode - The code to set
	 */
	setCode(pCode)
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code setCode called before editor initialized.');
			return;
		}
		this.codeJar.updateCode(pCode);
		this._updateLineNumbers();
	}

	/**
	 * Change the editor language and re-highlight.
	 *
	 * @param {string} pLanguage - The language identifier
	 */
	setLanguage(pLanguage)
	{
		this._language = pLanguage;
		this._highlightFunction = libCreateHighlighter(pLanguage);

		if (this._editorElement)
		{
			// Update the class
			this._editorElement.className = 'pict-code-editor language-' + pLanguage;
			if (!this.options.LineNumbers)
			{
				this._editorElement.className += ' pict-code-no-line-numbers';
			}
		}

		if (this.codeJar)
		{
			// Re-create the editor with the new highlight function
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set a custom highlight function to replace the built-in highlighter.
	 * Useful for integrating Prism.js, highlight.js, or any other library.
	 *
	 * @param {function} pHighlightFunction - A function that takes a DOM element and highlights its textContent
	 */
	setHighlightFunction(pHighlightFunction)
	{
		if (typeof (pHighlightFunction) !== 'function')
		{
			this.log.error('PICT-Code setHighlightFunction requires a function.');
			return;
		}
		this._highlightFunction = pHighlightFunction;

		if (this.codeJar)
		{
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set the read-only state of the editor.
	 *
	 * @param {boolean} pReadOnly - Whether the editor should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this._editorElement)
		{
			this._editorElement.setAttribute('contenteditable', pReadOnly ? 'false' : 'true');
		}
	}

	/**
	 * Destroy the editor and clean up.
	 */
	destroy()
	{
		if (this._editorResizeObserver)
		{
			this._editorResizeObserver.disconnect();
			this._editorResizeObserver = null;
		}
		if (this._editorStyleObserver)
		{
			this._editorStyleObserver.disconnect();
			this._editorStyleObserver = null;
		}
		if (this.codeJar)
		{
			this.codeJar.destroy();
			this.codeJar = null;
		}
	}

	/**
	 * Marshal code content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			let tmpCode = this._resolveCodeContent();
			if (typeof (tmpCode) === 'string')
			{
				this.codeJar.updateCode(tmpCode);
				this._updateLineNumbers();
			}
		}
	}

	/**
	 * Marshal the current code content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			this.onCodeChange(this.codeJar.toString());
		}
	}
}

module.exports = PictSectionCode;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.createHighlighter = libCreateHighlighter;

// Demo bundle for pict-docuserve.  Host apps that embed docuserve and
// want pict-section-code's demos visible in their docs site call
// `require('pict-section-code').registerWithDocuserve(pict)` once at
// app boot.  Silent no-op when Docuserve-Demos isn't installed.
//
// The require here is intentionally eager: browserify needs a static
// `require()` at module-toplevel to trace and bundle the demos source.
// The apparent circular dep (demos/index.js requires THIS module to
// reach the PictSectionCode class) is benign — by the time demos/
// index.js runs, `module.exports = PictSectionCode` has already
// executed, so it sees a usable class.  The `.demos` and
// `.registerWithDocuserve` attachments below run after the require
// returns, so demos/index.js never observes them being undefined.
const libCodeDemos = require('./demos');
module.exports.demos                = libCodeDemos.demos;
module.exports.registerWithDocuserve = libCodeDemos.registerWithDocuserve;

},{"./Pict-Code-Highlighter.js":187,"./Pict-Section-Code-DefaultConfiguration.js":188,"./demos":190,"pict-view":365}],190:[function(require,module,exports){
/**
 * pict-section-code demos
 *
 * Each entry is consumed by pict-docuserve's `Docuserve-Demos` provider.
 * Hosts that want these demos to appear in their docs site call
 * `require('pict-section-code/source/demos').registerWithDocuserve(pict)`
 * once at app boot (typically inside their DocuserveApplication subclass
 * after `super(...)`).
 *
 * Each demo's Mount(pict, container, spec) signature creates a fresh
 * pict-section-code view instance inside the supplied container.  Spec
 * fields are passed through to the view config so a single demo template
 * can express "JavaScript with line numbers", "JSON read-only no
 * gutter", etc. without duplicating the wiring.
 */

const libPictSectionCode = require('../Pict-Section-Code.js');

/**
 * Internal helper: mount a pict-section-code instance into a host
 * container according to the demo spec.  Each call registers a uniquely
 * identified view so multiple demos on the same page coexist cleanly.
 */
function mountCodeEditor(pPict, pContainer, pSpec)
{
	// Tag this mount with an id we can target as the destination.
	let tmpDestId = 'demo-code-' + (pSpec.Hash || 'unnamed') + '-' + Date.now();
	pContainer.innerHTML = '<div id="' + tmpDestId + '"></div>';

	let tmpConfig =
	{
		ViewIdentifier:            'Demo-Code-' + tmpDestId,
		DefaultDestinationAddress: '#' + tmpDestId,
		Templates:
		[
			{ Hash: 'CodeEditor-Container', Template: '<!-- demo code editor renders here -->' }
		],
		Renderables:
		[
			{ RenderableHash: 'CodeEditor-Wrap', TemplateHash: 'CodeEditor-Container', DestinationAddress: '#' + tmpDestId }
		],
		TargetElementAddress: '#' + tmpDestId,
		Language:    pSpec.Language    || 'javascript',
		ReadOnly:    !!pSpec.ReadOnly,
		LineNumbers: pSpec.LineNumbers !== false,
		Tab:         pSpec.Tab         || '\t',
		AddClosing:  pSpec.AddClosing !== false,
		CatchTab:    pSpec.CatchTab   !== false,
		DefaultCode: pSpec.Code        || '// example code\n',
		// AutoRender is intentionally OFF so we can pre-wire CodeJar
		// before the first render fires.  pict-section-code looks for
		// window.CodeJar by default; most hosts bundle CodeJar under
		// window.CodeJarModules.CodeJar (e.g. retold-content-system's
		// codejar-bundle.js), so we wire it explicitly here.
		AutoRender:  false,
		RenderOnLoad: false
	};

	let tmpView = pPict.addView(tmpConfig.ViewIdentifier, tmpConfig, libPictSectionCode);
	if (!tmpView) { return null; }

	// Connect the CodeJar prototype + highlight function from the
	// CodeJarModules global if it's loaded.  Falls back to bare CodeJar
	// if the host published the prototype directly.
	if (typeof window !== 'undefined')
	{
		if (window.CodeJarModules && typeof window.CodeJarModules.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJarModules.CodeJar);
		}
		else if (typeof window.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJar);
		}

		// Wire highlight.js highlighting if the bundle exposes it.
		if (window.CodeJarModules && window.CodeJarModules.hljs)
		{
			let tmpHljs = window.CodeJarModules.hljs;
			let tmpLanguage = tmpConfig.Language;
			tmpView._highlightFunction = function (pElement)
			{
				pElement.removeAttribute('data-highlighted');
				delete pElement.dataset.highlighted;
				pElement.className = pElement.className
					.replace(/\bhljs\b/g, '')
					.replace(/\blanguage-\S+/g, '')
					.trim();
				pElement.classList.add('language-' + tmpLanguage);
				try { tmpHljs.highlightElement(pElement); }
				catch (pErr) { /* swallow — highlighting is best-effort */ }
			};
		}
	}

	try { tmpView.render(); }
	catch (pError) { /* pict-section-code logs its own errors */ }
	return tmpView;
}

const _Demos =
[
	{
		DemoSchemaVersion: 1,
		Hash:        'javascript-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JavaScript editor',
		Description: 'Default pict-section-code configuration — line numbers on, highlight.js for JavaScript, two-space tab.',
		Spec:
		{
			Hash: 'javascript-editor',
			Language: 'javascript',
			LineNumbers: true,
			Tab: '  ',
			Code:
				'// A small example — try editing me.\n' +
				'function fibonacci(n) {\n' +
				'  if (n <= 1) return n;\n' +
				'  return fibonacci(n - 1) + fibonacci(n - 2);\n' +
				'}\n' +
				'\n' +
				'for (let i = 0; i < 10; i++) {\n' +
				'  console.log(`fib(${i}) =`, fibonacci(i));\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "javascript",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "  ",\n' +
					'  "Code": "function fibonacci(n) { … }"\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'json-readonly',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JSON viewer (read-only)',
		Description: 'Read-only mode with line numbers off — useful for embedded "show me the payload" surfaces in dashboards.',
		Spec:
		{
			Hash: 'json-readonly',
			Language: 'json',
			ReadOnly: true,
			LineNumbers: false,
			Code:
				'{\n' +
				'  "version": "1.0.7",\n' +
				'  "syntax": {\n' +
				'    "keyword":  "#A626A4",\n' +
				'    "string":   "#50A14F",\n' +
				'    "number":   "#986801",\n' +
				'    "function": "#4078F2"\n' +
				'  },\n' +
				'  "features": ["highlighting", "line-numbers", "readonly", "themed"]\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "json",\n' +
					'  "ReadOnly": true,\n' +
					'  "LineNumbers": false\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'css-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'CSS editor (4-space tab)',
		Description: 'CSS-flavoured highlighting with a 4-space tab and bracket auto-close turned off — leaner editing for stylesheet snippets.',
		Spec:
		{
			Hash: 'css-editor',
			Language: 'css',
			LineNumbers: true,
			Tab: '    ',
			AddClosing: false,
			Code:
				'/* Theme-aware token usage */\n' +
				'.docuserve-demo-title {\n' +
				'    color: var(--theme-color-text-primary, #3D3229);\n' +
				'    font-size: 1.5em;\n' +
				'    font-weight: 600;\n' +
				'}\n' +
				'\n' +
				'.docuserve-demo-description {\n' +
				'    color: var(--theme-color-text-secondary, #5E5549);\n' +
				'    line-height: 1.55;\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "css",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "    ",\n' +
					'  "AddClosing": false\n' +
					'}'
			}
		]
	}
];

/**
 * Register every pict-section-code demo with the host docuserve app.
 *
 * @param {object} pPict - The Pict instance (typically `this.pict` inside
 *                        a DocuserveApplication subclass).
 * @returns {number} count of demos registered (0 if Docuserve-Demos
 *                   provider isn't present — silent no-op).
 */
function registerWithDocuserve(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers['Docuserve-Demos'])
	{
		return 0;
	}
	return pPict.providers['Docuserve-Demos'].registerAll(_Demos);
}

module.exports = _Demos;
module.exports.demos = _Demos;
module.exports.registerWithDocuserve = registerWithDocuserve;

},{"../Pict-Section-Code.js":189}],191:[function(require,module,exports){
'use strict';

/**
 * pict-section-comments entry point.
 *
 * Exports the Comments view (with its default_configuration) plus the data-provider classes and the
 * content adapter, so a host can register the view and, if it wants, subclass the provider to talk to
 * its own backend or reuse the content rendering.
 *
 * Typical use:
 *
 *   const libComments = require('pict-section-comments');
 *   pict.addView('WorkItem-Comments', Object.assign({}, libComments.default_configuration,
 *       { Context: { OwnerType: 'WorkItem', IDOwner: 4012 }, CurrentUser: { Key: 7, Name: 'Ada' } }),
 *       libComments);
 *   pict.views['WorkItem-Comments'].render();   // in-memory by default; pass a DataProvider to persist
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libCommentsView = require('./views/PictView-Comments.js');
const libCommentProvider = require('./providers/CommentProvider-Base.js');
const libContentAdapter = require('./content/ContentAdapter.js');

module.exports = libCommentsView;
module.exports.default_configuration = libCommentsView.default_configuration;

// The data seam: the interface a host implements to override all reading and writing, and the
// in-memory default the section uses when nothing is wired.
module.exports.CommentDataProvider = libCommentProvider.CommentDataProvider;
module.exports.InMemoryCommentProvider = libCommentProvider.InMemoryCommentProvider;

// Constants and the content adapter, exported for hosts that build on top of the section.
module.exports.ContentAdapter = libContentAdapter;
module.exports.THREAD_STATUS = libCommentProvider.THREAD_STATUS;
module.exports.THREAD_KIND = libCommentProvider.THREAD_KIND;
module.exports.CONTENT_TYPE = libCommentProvider.CONTENT_TYPE;
module.exports.normalizeContext = libCommentProvider.normalizeContext;

},{"./content/ContentAdapter.js":192,"./providers/CommentProvider-Base.js":193,"./views/PictView-Comments.js":194}],192:[function(require,module,exports){
'use strict';

/**
 * ContentAdapter
 * --------------
 * Turns a comment's stored Body into safe display HTML, picking a path from its ContentType. The
 * section supports a spectrum of bodies:
 *
 *   text      a plain comment; escaped, newlines become <br>.
 *   markdown  a lightweight markdown comment (the everyday rich comment, with image drag-in).
 *   rich      a body authored in the full markdown editor pipeline.
 *   json      arbitrary structured content (diagrams, svg); a future adapter renders it. For now it
 *             is shown escaped so nothing breaks.
 *
 * markdown and rich render through the same markdown parser, supplied by the host (the view passes
 * pict-section-content's parseMarkdown). When no parser is wired the adapter falls back to escaped
 * text with line breaks, so a body never renders as raw markup and never injects HTML.
 *
 * This module is pure (it requires nothing), so it is trivial to test and carries no weight into a
 * consumer that only ever shows plain-text comments.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const _CONTENT_TYPE = { Text: 'text', Markdown: 'markdown', Rich: 'rich', Json: 'json' };

// The EditorMode a section is configured with picks the ContentType stamped on new comments.
const _MODE_TO_CONTENT_TYPE =
{
	'text': _CONTENT_TYPE.Text,
	'multiline': _CONTENT_TYPE.Text,
	'markdown': _CONTENT_TYPE.Markdown,
	'rich': _CONTENT_TYPE.Rich
};

function escapeHtml(pText)
{
	if (pText == null) { return ''; }
	return String(pText)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

// Escaped text with line breaks preserved, wrapped so it picks up comment-body styling.
function renderPlain(pBody)
{
	return '<div class="psc-body-text">' + escapeHtml(pBody).replace(/\r?\n/g, '<br>') + '</div>';
}

/**
 * Render a stored body to safe HTML.
 * @param {string} pBody
 * @param {string} pContentType - one of CONTENT_TYPE
 * @param {object} [pHelpers]
 * @param {function(string):string} [pHelpers.parseMarkdown] - markdown -> sanitized HTML (host supplied)
 * @returns {string} HTML safe to assign into the DOM
 */
function renderToHtml(pBody, pContentType, pHelpers)
{
	let tmpHelpers = pHelpers || {};
	let tmpType = pContentType || _CONTENT_TYPE.Text;

	if (tmpType === _CONTENT_TYPE.Markdown || tmpType === _CONTENT_TYPE.Rich)
	{
		if (typeof tmpHelpers.parseMarkdown === 'function')
		{
			// The host's parser (pict-section-content) is responsible for sanitizing embedded HTML.
			return '<div class="psc-body-rich pict-content">' + tmpHelpers.parseMarkdown(String(pBody == null ? '' : pBody)) + '</div>';
		}
		// No parser wired: degrade to escaped text so the body is never unsafe or raw markup.
		return renderPlain(pBody);
	}

	if (tmpType === _CONTENT_TYPE.Json)
	{
		let tmpPretty;
		try { tmpPretty = JSON.stringify((typeof pBody === 'string') ? JSON.parse(pBody) : pBody, null, 2); }
		catch (pError) { tmpPretty = String(pBody == null ? '' : pBody); }
		return '<pre class="psc-body-json"><code>' + escapeHtml(tmpPretty) + '</code></pre>';
	}

	return renderPlain(pBody);
}

/** The ContentType to stamp on a new comment given the section's EditorMode. */
function defaultContentTypeForMode(pEditorMode)
{
	return _MODE_TO_CONTENT_TYPE[pEditorMode] || _CONTENT_TYPE.Text;
}

/** Whether an EditorMode uses the markdown read pipeline (so the view registers the content provider). */
function modeRendersMarkdown(pEditorMode)
{
	let tmpType = defaultContentTypeForMode(pEditorMode);
	return (tmpType === _CONTENT_TYPE.Markdown || tmpType === _CONTENT_TYPE.Rich);
}

module.exports =
{
	escapeHtml: escapeHtml,
	renderToHtml: renderToHtml,
	renderPlain: renderPlain,
	defaultContentTypeForMode: defaultContentTypeForMode,
	modeRendersMarkdown: modeRendersMarkdown,
	CONTENT_TYPE: _CONTENT_TYPE
};

},{}],193:[function(require,module,exports){
'use strict';

/**
 * CommentProvider-Base
 * --------------------
 * The data seam for pict-section-comments. The section view never reads or writes storage
 * directly; it only ever calls a provider. That is what lets a wrapping app override all
 * reading and writing: hand the view an object implementing this interface and the section
 * talks to your backend instead of memory.
 *
 * Two things ship here:
 *
 *   CommentDataProvider   the abstract interface (and a few concrete convenience methods built
 *                         on the primitives, so every provider gets resolve/complete/reopen and
 *                         a batch context load for free).
 *
 *   InMemoryCommentProvider   the default. It keeps everything in a plain store object, so the
 *                             section is fully usable the moment it mounts, with no server. The
 *                             host can pass its own Store object (for example a slice of
 *                             pict.AppData) so the data stays observable and serializable.
 *
 * Record shapes (neutral, not tied to any backend's column names; a real backend's provider maps
 * these to and from its own rows):
 *
 *   Thread  { Key, OwnerType, IDOwner, Anchor|null, Kind, Title, Status, Sort, Author,
 *             CreatedAt, UpdatedAt }
 *   Comment { Key, ThreadKey, ParentKey|null, Author, Body, ContentType, CreatedAt, UpdatedAt,
 *             EditedAt|null, Deleted }
 *
 * A Context is { OwnerType, IDOwner } the broad subject (a Photo, a Media item, a Vision, a
 * file). A Thread optionally carries an Anchor, an opaque locator inside that context (a byte
 * range, a paragraph selector, a point). Anchor null means the official whole-context thread.
 *
 * Every method returns a Promise, so a memory provider and a network provider are
 * interchangeable to the view.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const _THREAD_STATUS = { Open: 'Open', Resolved: 'Resolved', Completed: 'Completed' };
const _THREAD_KIND = { Discussion: 'Discussion', Moderation: 'Moderation', Review: 'Review' };
const _CONTENT_TYPE = { Text: 'text', Markdown: 'markdown', Rich: 'rich', Json: 'json' };

/**
 * Normalize a context argument: accept either { OwnerType, IDOwner } or a thread-like object that
 * already carries those two fields. IDOwner is compared as a string so a numeric 278199 and the
 * string "278199" address the same context.
 */
function normalizeContext(pContext)
{
	let tmpContext = pContext || {};
	return (
	{
		OwnerType: tmpContext.OwnerType != null ? String(tmpContext.OwnerType) : '',
		IDOwner: tmpContext.IDOwner != null ? String(tmpContext.IDOwner) : ''
	});
}

class CommentDataProvider
{
	/**
	 * @param {object} pOptions
	 * @param {function():number} [pOptions.Now] - clock, returns a millisecond timestamp (default Date.now)
	 * @param {function():string}  [pOptions.KeyGenerator] - returns a fresh unique key (default built-in)
	 */
	constructor(pOptions)
	{
		this.options = pOptions || {};
		this._now = (typeof this.options.Now === 'function') ? this.options.Now : function () { return Date.now(); };
		let tmpCounter = 0;
		this._key = (typeof this.options.KeyGenerator === 'function') ? this.options.KeyGenerator : (() =>
		{
			tmpCounter++;
			return 'cmt_' + this._now().toString(36) + '_' + tmpCounter.toString(36) + '_' + Math.floor(Math.random() * 0x7fffffff).toString(36);
		});
	}

	// ---- Primitives (subclasses MUST implement these) ----

	/** @param {object} pContext { OwnerType, IDOwner } @returns {Promise<Array<object>>} */
	listThreads(pContext) { return Promise.reject(new Error('CommentDataProvider.listThreads not implemented')); }
	/** @param {object} pThreadDraft @returns {Promise<object>} the created thread */
	createThread(pThreadDraft) { return Promise.reject(new Error('CommentDataProvider.createThread not implemented')); }
	/** @param {string} pKey @param {object} pPatch @returns {Promise<object>} the updated thread */
	updateThread(pKey, pPatch) { return Promise.reject(new Error('CommentDataProvider.updateThread not implemented')); }
	/** @param {string} pKey @returns {Promise<void>} */
	deleteThread(pKey) { return Promise.reject(new Error('CommentDataProvider.deleteThread not implemented')); }

	/** @param {string} pThreadKey @returns {Promise<Array<object>>} */
	listComments(pThreadKey) { return Promise.reject(new Error('CommentDataProvider.listComments not implemented')); }
	/** @param {object} pCommentDraft @returns {Promise<object>} the created comment */
	createComment(pCommentDraft) { return Promise.reject(new Error('CommentDataProvider.createComment not implemented')); }
	/** @param {string} pKey @param {object} pPatch @returns {Promise<object>} the updated comment */
	updateComment(pKey, pPatch) { return Promise.reject(new Error('CommentDataProvider.updateComment not implemented')); }
	/** @param {string} pKey @returns {Promise<void>} */
	deleteComment(pKey) { return Promise.reject(new Error('CommentDataProvider.deleteComment not implemented')); }

	// ---- Convenience built on the primitives (every provider gets these for free) ----

	/**
	 * Load a whole context in one call: its threads plus the comments under each, keyed by thread.
	 * @param {object} pContext { OwnerType, IDOwner }
	 * @returns {Promise<{ Threads: Array<object>, CommentsByThreadKey: object }>}
	 */
	loadContext(pContext)
	{
		return this.listThreads(pContext).then((pThreads) =>
		{
			let tmpThreads = pThreads || [];
			return Promise.all(tmpThreads.map((pThread) => this.listComments(pThread.Key))).then((pCommentLists) =>
			{
				let tmpByThread = {};
				for (let i = 0; i < tmpThreads.length; i++)
				{
					tmpByThread[tmpThreads[i].Key] = pCommentLists[i] || [];
				}
				return { Threads: tmpThreads, CommentsByThreadKey: tmpByThread };
			});
		});
	}

	/** Mark a thread resolved (kept visible, collapsible). @param {string} pKey @returns {Promise<object>} */
	resolveThread(pKey) { return this.updateThread(pKey, { Status: _THREAD_STATUS.Resolved }); }
	/** Mark a thread completed (the collapse state). @param {string} pKey @returns {Promise<object>} */
	completeThread(pKey) { return this.updateThread(pKey, { Status: _THREAD_STATUS.Completed }); }
	/** Reopen a resolved or completed thread. @param {string} pKey @returns {Promise<object>} */
	reopenThread(pKey) { return this.updateThread(pKey, { Status: _THREAD_STATUS.Open }); }
}

/**
 * The default, self-contained provider. Stores threads and comments in a plain object so the
 * section works with no backend. Reads return deep copies, so a caller can never mutate the store
 * out from under the provider; that keeps the seam honest (the view holds data, the provider owns
 * truth).
 */
class InMemoryCommentProvider extends CommentDataProvider
{
	/**
	 * @param {object} [pOptions]
	 * @param {object} [pOptions.Store] - backing store { Threads:{}, Comments:{} }; pass a slice of
	 *                                     AppData to keep state observable. A fresh one is made if absent.
	 * @param {boolean} [pOptions.HardDeleteComments] - remove instead of soft-delete (default false)
	 */
	constructor(pOptions)
	{
		super(pOptions);
		let tmpStore = (this.options && this.options.Store) ? this.options.Store : {};
		if (!tmpStore.Threads) { tmpStore.Threads = {}; }
		if (!tmpStore.Comments) { tmpStore.Comments = {}; }
		this.store = tmpStore;
		this._hardDeleteComments = !!(this.options && this.options.HardDeleteComments);
	}

	_clone(pValue) { return (pValue == null) ? pValue : JSON.parse(JSON.stringify(pValue)); }

	listThreads(pContext)
	{
		let tmpContext = normalizeContext(pContext);
		let tmpThreads = Object.keys(this.store.Threads)
			.map((pKey) => this.store.Threads[pKey])
			.filter((pThread) => !pThread.Deleted
				&& String(pThread.OwnerType) === tmpContext.OwnerType
				&& String(pThread.IDOwner) === tmpContext.IDOwner)
			.sort((pA, pB) => (pA.Sort - pB.Sort) || (pA.CreatedAt - pB.CreatedAt));
		return Promise.resolve(this._clone(tmpThreads));
	}

	createThread(pThreadDraft)
	{
		let tmpDraft = pThreadDraft || {};
		let tmpContext = normalizeContext(tmpDraft.Context ? tmpDraft.Context : tmpDraft);
		if (!tmpContext.OwnerType || !tmpContext.IDOwner)
		{
			return Promise.reject(new Error('createThread requires a Context (OwnerType + IDOwner)'));
		}
		let tmpNow = this._now();
		let tmpThread =
		{
			Key: tmpDraft.Key || this._key(),
			OwnerType: tmpContext.OwnerType,
			IDOwner: tmpContext.IDOwner,
			Anchor: (tmpDraft.Anchor != null) ? this._clone(tmpDraft.Anchor) : null,
			Kind: tmpDraft.Kind || _THREAD_KIND.Discussion,
			Title: tmpDraft.Title || '',
			Status: tmpDraft.Status || _THREAD_STATUS.Open,
			Sort: (typeof tmpDraft.Sort === 'number') ? tmpDraft.Sort : Object.keys(this.store.Threads).length,
			Author: this._clone(tmpDraft.Author) || null,
			CreatedAt: tmpDraft.CreatedAt || tmpNow,
			UpdatedAt: tmpNow,
			Deleted: false
		};
		this.store.Threads[tmpThread.Key] = tmpThread;
		return Promise.resolve(this._clone(tmpThread));
	}

	updateThread(pKey, pPatch)
	{
		let tmpThread = this.store.Threads[pKey];
		if (!tmpThread || tmpThread.Deleted) { return Promise.reject(new Error('updateThread: no thread ' + pKey)); }
		let tmpPatch = pPatch || {};
		let tmpAllowed = ['Title', 'Status', 'Kind', 'Sort', 'Anchor'];
		for (let i = 0; i < tmpAllowed.length; i++)
		{
			let tmpField = tmpAllowed[i];
			if (Object.prototype.hasOwnProperty.call(tmpPatch, tmpField))
			{
				tmpThread[tmpField] = (tmpField === 'Anchor') ? this._clone(tmpPatch[tmpField]) : tmpPatch[tmpField];
			}
		}
		tmpThread.UpdatedAt = this._now();
		return Promise.resolve(this._clone(tmpThread));
	}

	deleteThread(pKey)
	{
		let tmpThread = this.store.Threads[pKey];
		if (!tmpThread) { return Promise.resolve(); }
		// Drop the thread and every comment under it.
		delete this.store.Threads[pKey];
		let tmpCommentKeys = Object.keys(this.store.Comments);
		for (let i = 0; i < tmpCommentKeys.length; i++)
		{
			if (this.store.Comments[tmpCommentKeys[i]].ThreadKey === pKey)
			{
				delete this.store.Comments[tmpCommentKeys[i]];
			}
		}
		return Promise.resolve();
	}

	listComments(pThreadKey)
	{
		let tmpComments = Object.keys(this.store.Comments)
			.map((pKey) => this.store.Comments[pKey])
			.filter((pComment) => pComment.ThreadKey === pThreadKey && !pComment.Deleted)
			.sort((pA, pB) => (pA.CreatedAt - pB.CreatedAt));
		return Promise.resolve(this._clone(tmpComments));
	}

	createComment(pCommentDraft)
	{
		let tmpDraft = pCommentDraft || {};
		if (!tmpDraft.ThreadKey || !this.store.Threads[tmpDraft.ThreadKey])
		{
			return Promise.reject(new Error('createComment requires a ThreadKey of an existing thread'));
		}
		if (tmpDraft.Body == null || String(tmpDraft.Body).length === 0)
		{
			return Promise.reject(new Error('createComment requires a non-empty Body'));
		}
		let tmpNow = this._now();
		let tmpComment =
		{
			Key: tmpDraft.Key || this._key(),
			ThreadKey: tmpDraft.ThreadKey,
			ParentKey: tmpDraft.ParentKey || null,
			Author: this._clone(tmpDraft.Author) || null,
			Body: String(tmpDraft.Body),
			ContentType: tmpDraft.ContentType || _CONTENT_TYPE.Text,
			CreatedAt: tmpDraft.CreatedAt || tmpNow,
			UpdatedAt: tmpNow,
			EditedAt: null,
			Deleted: false
		};
		this.store.Comments[tmpComment.Key] = tmpComment;
		return Promise.resolve(this._clone(tmpComment));
	}

	updateComment(pKey, pPatch)
	{
		let tmpComment = this.store.Comments[pKey];
		if (!tmpComment || tmpComment.Deleted) { return Promise.reject(new Error('updateComment: no comment ' + pKey)); }
		let tmpPatch = pPatch || {};
		let tmpChanged = false;
		if (Object.prototype.hasOwnProperty.call(tmpPatch, 'Body') && tmpPatch.Body != null)
		{
			tmpComment.Body = String(tmpPatch.Body);
			tmpChanged = true;
		}
		if (Object.prototype.hasOwnProperty.call(tmpPatch, 'ContentType'))
		{
			tmpComment.ContentType = tmpPatch.ContentType;
			tmpChanged = true;
		}
		let tmpNow = this._now();
		if (tmpChanged) { tmpComment.EditedAt = tmpNow; }
		tmpComment.UpdatedAt = tmpNow;
		return Promise.resolve(this._clone(tmpComment));
	}

	deleteComment(pKey)
	{
		let tmpComment = this.store.Comments[pKey];
		if (!tmpComment) { return Promise.resolve(); }
		if (this._hardDeleteComments)
		{
			delete this.store.Comments[pKey];
		}
		else
		{
			tmpComment.Deleted = true;
			tmpComment.UpdatedAt = this._now();
		}
		return Promise.resolve();
	}
}

module.exports = CommentDataProvider;
module.exports.CommentDataProvider = CommentDataProvider;
module.exports.InMemoryCommentProvider = InMemoryCommentProvider;
module.exports.normalizeContext = normalizeContext;
module.exports.THREAD_STATUS = _THREAD_STATUS;
module.exports.THREAD_KIND = _THREAD_KIND;
module.exports.CONTENT_TYPE = _CONTENT_TYPE;

},{}],194:[function(require,module,exports){
'use strict';

/**
 * PictView-Comments
 * -----------------
 * The comments section. Mount it on a Context (OwnerType + IDOwner) and it renders that context's
 * threads and their comments, with composing, replying, editing, deleting, resolving and collapsing,
 * newest or oldest sort, and a read-only mode.
 *
 * It never touches storage itself: every read and write goes through a CommentDataProvider (see
 * providers/CommentProvider-Base.js). With nothing wired it uses an InMemoryCommentProvider backed by
 * a slice of AppData, so it works the moment it mounts; a host swaps in its own provider to persist.
 *
 * Comment bodies render through ContentAdapter: plain text by default, or markdown (rendered with
 * pict-section-content, with image and file drag-in on the composer). The EditorMode picks which.
 *
 * Rendering follows the pict conventions: data lives in AppData (the active instance's shaped state is
 * published to AppData.CommentsActive just before each render, so templates read it and the engine
 * bakes the correct per-instance view hash into every inline handler), iteration is done with {~TS:~},
 * and all interaction is inline onclick / onpaste / ondrop handlers that survive re-renders.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libContent = require('pict-section-content');
const libModal = require('pict-section-modal');
const libMarkdownEditor = require('pict-section-markdowneditor');

const libCommentProvider = require('../providers/CommentProvider-Base.js');
const libContentAdapter = require('../content/ContentAdapter.js');

const _InMemoryCommentProvider = libCommentProvider.InMemoryCommentProvider;
const THREAD_STATUS = libCommentProvider.THREAD_STATUS;

const _DefaultConfiguration =
{
	ViewIdentifier: 'Comments',
	DefaultRenderable: 'Comments-Section',
	DefaultDestinationAddress: '#Comments-Container',
	AutoRender: false,

	// ---- Comments options (a host overrides these) ----
	// The Context this instance is bound to. Required for anything to load or save.
	Context: { OwnerType: '', IDOwner: '' },
	// The data provider. Null means "make an in-memory one backed by AppData".
	DataProvider: null,
	// One level of replies when true; a single flat comment list when false.
	Threaded: true,
	// text | multiline | markdown | rich  (rich currently behaves as markdown; see README)
	EditorMode: 'markdown',
	// Render-only: no composer, no actions.
	ReadOnly: false,
	// Comment order within a thread: 'oldest' or 'newest'.
	SortOrder: 'oldest',
	// Resolved / completed threads start collapsed.
	CollapseCompleted: true,
	// Permission gates the host can flip.
	AllowNewThread: true,
	AllowResolve: true,
	AllowEdit: true,
	AllowDelete: true,
	AllowReply: true,
	// The signed-in user, used as the author of new comments and threads.
	CurrentUser: { Key: '', Name: 'Anonymous', Avatar: '' },
	// Optional uploader for image / file drag-in: function (pFile, fCallback(pError, pURL)).
	ImageUpload: null,
	// CodeMirror 6 modules ({ EditorView, EditorState, extensions }) for the 'rich' EditorMode's full
	// markdown editor. The host provides these (the editor needs them); without them, 'rich' falls back
	// to the 'markdown' composer. Also read from window.CodeMirrorModules if not passed here.
	CodeMirrorModules: null,
	// Header label.
	Title: 'Comments',
	// Empty-state copy.
	EmptyText: 'No comments yet.',

	// Event callbacks (all optional): onThreadCreated, onThreadResolved, onCommentAdded,
	// onCommentEdited, onCommentDeleted, onAnchorActivate, onChange.

	CSSPriority: 500,
	CSS: /*css*/`
.psc { font-family: var(--theme-typography-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif); font-size: 14px; color: var(--theme-color-text-primary, #1f2430); }
.psc-header { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 4px 2px 10px; }
.psc-title { font-weight: 600; font-size: 15px; }
.psc-count { display: inline-block; min-width: 18px; padding: 0 6px; margin-left: 4px; border-radius: 9px; background: var(--theme-color-background-tertiary, #eef2f6); color: var(--theme-color-text-secondary, #5b6470); font-size: 12px; font-weight: 600; text-align: center; }
.psc-header-actions { display: flex; align-items: center; gap: 6px; }
.psc-btn { font: inherit; font-size: 13px; border: 1px solid var(--theme-color-border-default, #d6dde3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2430); border-radius: 6px; padding: 5px 10px; cursor: pointer; line-height: 1; }
.psc-btn:hover { border-color: var(--theme-color-border-strong, #9cb4c8); }
.psc-btn-ghost { border-color: transparent; background: transparent; color: var(--theme-color-text-secondary, #5b6470); padding: 5px 8px; }
.psc-btn-ghost:hover { background: var(--theme-color-background-tertiary, #eef2f6); }
.psc-btn-primary { background: var(--theme-color-brand-primary, #2880a6); border-color: var(--theme-color-brand-primary, #2880a6); color: #fff; }
.psc-btn-primary:hover { filter: brightness(0.95); }
.psc-btn-danger:hover { color: var(--theme-color-status-error, #c0392b); border-color: var(--theme-color-status-error, #c0392b); }
.psc-link { background: none; border: none; padding: 0; font: inherit; font-size: 12px; color: var(--theme-color-text-secondary, #5b6470); cursor: pointer; }
.psc-link:hover { color: var(--theme-color-brand-primary, #2880a6); text-decoration: underline; }

.psc-thread { border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 8px; margin-bottom: 10px; background: var(--theme-color-background-panel, #fff); overflow: hidden; }
.psc-thread-head { display: flex; align-items: center; gap: 8px; padding: 8px 10px; cursor: pointer; user-select: none; background: var(--theme-color-background-secondary, #f7f9fb); }
.psc-thread-head:hover { background: var(--theme-color-background-tertiary, #eef2f6); }
.psc-caret { width: 12px; color: var(--theme-color-text-muted, #97a1ab); transition: transform 0.12s ease; }
.psc-thread.psc-collapsed .psc-caret { transform: rotate(-90deg); }
.psc-thread-title { font-weight: 600; }
.psc-thread-meta { color: var(--theme-color-text-muted, #97a1ab); font-size: 12px; }
.psc-spacer { flex: 1; }
.psc-status-pill { font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 9px; background: var(--theme-color-background-tertiary, #eef2f6); color: var(--theme-color-text-secondary, #5b6470); }
.psc-thread.psc-status-resolved .psc-status-pill, .psc-thread.psc-status-completed .psc-status-pill { background: #e3f4ea; color: #2e7d4f; }
.psc-thread.psc-status-resolved .psc-thread-head, .psc-thread.psc-status-completed .psc-thread-head { background: #f4faf6; }
.psc-anchor-badge { font-size: 11px; padding: 2px 7px; border-radius: 9px; background: #eaf2fb; color: #2667a6; cursor: pointer; }
.psc-anchor-badge:hover { background: #dcebfa; }
.psc-thread-body { padding: 6px 10px 10px; }
.psc-thread.psc-collapsed .psc-thread-body { display: none; }

.psc-comment { display: flex; gap: 10px; padding: 8px 2px; }
.psc-comment + .psc-comment { border-top: 1px solid var(--theme-color-border-light, #f0f3f6); }
.psc-replies { margin-left: 42px; }
.psc-replies .psc-comment { padding: 6px 2px; }
.psc-avatar { flex: 0 0 30px; width: 30px; height: 30px; border-radius: 50%; background: var(--theme-color-brand-primary, #2880a6); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; background-size: cover; background-position: center; }
.psc-comment-main { flex: 1; min-width: 0; }
.psc-comment-head { display: flex; align-items: baseline; gap: 8px; margin-bottom: 2px; }
.psc-author { font-weight: 600; font-size: 13px; }
.psc-time { color: var(--theme-color-text-muted, #97a1ab); font-size: 12px; }
.psc-edited { color: var(--theme-color-text-muted, #97a1ab); font-size: 11px; font-style: italic; }
.psc-body-text { white-space: normal; line-height: 1.5; }
.psc-body-rich { line-height: 1.5; }
.psc-body-rich p:first-child { margin-top: 0; }
.psc-body-rich p:last-child { margin-bottom: 0; }
.psc-body-rich img { max-width: 100%; height: auto; border-radius: 4px; }
.psc-body-json { background: var(--theme-color-background-tertiary, #f4f6f8); border-radius: 6px; padding: 8px 10px; overflow: auto; font-size: 12px; }
.psc-comment-actions { display: flex; gap: 12px; margin-top: 4px; }

.psc-composer { display: flex; flex-direction: column; gap: 6px; margin-top: 8px; }
.psc-input { font: inherit; width: 100%; box-sizing: border-box; resize: vertical; min-height: 38px; padding: 8px 10px; border: 1px solid var(--theme-color-border-default, #d6dde3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: inherit; }
.psc-input:focus { outline: none; border-color: var(--theme-color-brand-primary, #2880a6); }
.psc-input.psc-mono { font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', Menlo, Consolas, monospace); font-size: 13px; }
.psc-input.psc-dragover { border-color: var(--theme-color-brand-primary, #2880a6); border-style: dashed; }
.psc-composer-actions { display: flex; align-items: center; gap: 8px; }
.psc-composer-hint { flex: 1; color: var(--theme-color-text-muted, #97a1ab); font-size: 11px; }

.psc-empty { padding: 18px; text-align: center; color: var(--theme-color-text-muted, #97a1ab); border: 1px dashed var(--theme-color-border-light, #e7ecf0); border-radius: 8px; }
.psc-readonly .psc-thread-head { cursor: pointer; }

/* Rich mode: the inline composer becomes a button that opens the full editor in a modal. */
.psc-add-comment { margin-top: 8px; display: inline-flex; align-items: center; gap: 6px; }
.psc-mde-modal { min-width: 520px; max-width: 78vw; }
.psc-mde-modal .pict-mde-add-segment { display: none; }
.psc-mde-modal .pict-mde { border: 1px solid var(--theme-color-border-default, #d6dde3); border-radius: 6px; padding: 4px; min-height: 160px; }
@media (max-width: 600px) { .psc-mde-modal { min-width: 0; max-width: 100%; } }
`,

	Templates:
	[
		{
			Hash: 'Comments-Section',
			Template: /*html*/`
<div class="psc {~D:AppData.CommentsActive.RootClass~}" id="psc-{~D:AppData.CommentsActive.ViewHash~}">
	<div class="psc-header">
		<div class="psc-title">{~D:AppData.CommentsActive.Title~}<span class="psc-count">{~D:AppData.CommentsActive.ThreadCount~}</span></div>
		<div class="psc-header-actions">
			<button class="psc-btn psc-btn-ghost" title="Toggle sort order" onclick="_Pict.views['{~D:AppData.CommentsActive.ViewHash~}'].toggleSort()">{~D:AppData.CommentsActive.SortLabel~}</button>
			{~TS:Comments-NewButton:AppData.CommentsActive.NewButtonSlot~}
		</div>
	</div>
	<div class="psc-threads">
		{~TS:Comments-Thread:AppData.CommentsActive.Threads~}
	</div>
	{~TS:Comments-Empty:AppData.CommentsActive.EmptySlot~}
</div>`
		},
		{
			Hash: 'Comments-NewButton',
			Template: /*html*/`<button class="psc-btn" onclick="_Pict.views['{~D:AppData.CommentsActive.ViewHash~}'].newDiscussion()">New discussion</button>`
		},
		{
			Hash: 'Comments-Empty',
			Template: /*html*/`<div class="psc-empty">{~D:AppData.CommentsActive.EmptyText~}</div>`
		},
		{
			Hash: 'Comments-Thread',
			Template: /*html*/`
<div class="psc-thread psc-status-{~D:Record.StatusLower~} {~D:Record.CollapseClass~}" id="psc-thread-{~D:Record.ViewHash~}-{~D:Record.Key~}">
	<div class="psc-thread-head" onclick="_Pict.views['{~D:Record.ViewHash~}'].toggleCollapse('{~D:Record.Key~}')">
		<span class="psc-caret">&#9660;</span>
		{~TS:Comments-AnchorBadge:Record.AnchorSlot~}
		<span class="psc-thread-title">{~D:Record.TitleDisplay~}</span>
		<span class="psc-thread-meta">{~D:Record.CommentCount~}</span>
		<span class="psc-spacer"></span>
		<span class="psc-status-pill">{~D:Record.StatusLabel~}</span>
		{~TS:Comments-ThreadActions:Record.ActionSlot~}
	</div>
	<div class="psc-thread-body">
		<div class="psc-comments">
			{~TS:Comments-Comment:Record.Comments~}
		</div>
		{~TS:Comments-Composer:Record.ComposerSlot~}
		{~TS:Comments-AddButton:Record.AddButtonSlot~}
	</div>
</div>`
		},
		{
			Hash: 'Comments-AnchorBadge',
			Template: /*html*/`<span class="psc-anchor-badge" title="Go to location" onclick="event.stopPropagation(); _Pict.views['{~D:Record.ViewHash~}'].activateAnchor('{~D:Record.Key~}')">{~D:Record.AnchorLabel~}</span>`
		},
		{
			Hash: 'Comments-ThreadActions',
			Template: /*html*/`<button class="psc-link" onclick="event.stopPropagation(); _Pict.views['{~D:Record.ViewHash~}'].{~D:Record.ResolveCall~}">{~D:Record.ResolveLabel~}</button>{~TS:Comments-ThreadDelete:Record.DeleteSlot~}`
		},
		{
			Hash: 'Comments-ThreadDelete',
			Template: /*html*/`<button class="psc-link psc-btn-danger" onclick="event.stopPropagation(); _Pict.views['{~D:Record.ViewHash~}'].confirmDeleteThread('{~D:Record.Key~}')">Delete</button>`
		},
		{
			Hash: 'Comments-Comment',
			Template: /*html*/`
<div class="psc-comment" id="psc-comment-{~D:Record.ViewHash~}-{~D:Record.Key~}">
	<div class="psc-avatar" style="{~D:Record.AvatarStyle~}">{~D:Record.Initials~}</div>
	<div class="psc-comment-main">
		<div class="psc-comment-head"><span class="psc-author">{~D:Record.AuthorName~}</span><span class="psc-time">{~D:Record.TimeLabel~}</span>{~TS:Comments-Edited:Record.EditedSlot~}</div>
		{~TS:Comments-Body:Record.ViewSlot~}
		{~TS:Comments-Edit:Record.EditSlot~}
		<div class="psc-comment-actions">{~TS:Comments-CommentAction:Record.ActionSlot~}</div>
		{~TS:Comments-Replies:Record.ReplyWrapSlot~}
		{~TS:Comments-Composer:Record.ReplyComposerSlot~}
	</div>
</div>`
		},
		{
			Hash: 'Comments-Replies',
			Template: /*html*/`<div class="psc-replies">{~TS:Comments-Comment:Record.Replies~}</div>`
		},
		{
			Hash: 'Comments-Edited',
			Template: /*html*/`<span class="psc-edited">edited</span>`
		},
		{
			Hash: 'Comments-Body',
			Template: /*html*/`<div class="psc-comment-body">{~D:Record.BodyHTML~}</div>`
		},
		{
			Hash: 'Comments-Edit',
			Template: /*html*/`
<div class="psc-composer">
	<textarea class="psc-input {~D:Record.InputClass~}" id="{~D:Record.EditInputId~}" rows="3">{~D:Record.BodyRaw~}</textarea>
	<div class="psc-composer-actions">
		<span class="psc-composer-hint">{~D:Record.Hint~}</span>
		<button class="psc-btn psc-btn-ghost" onclick="_Pict.views['{~D:Record.ViewHash~}'].cancelEdit()">Cancel</button>
		<button class="psc-btn psc-btn-primary" onclick="_Pict.views['{~D:Record.ViewHash~}'].submitEdit('{~D:Record.Key~}')">Save</button>
	</div>
</div>`
		},
		{
			Hash: 'Comments-CommentAction',
			Template: /*html*/`<button class="psc-link" onclick="_Pict.views['{~D:Record.ViewHash~}'].{~D:Record.Call~}">{~D:Record.Label~}</button>`
		},
		{
			Hash: 'Comments-Composer',
			Template: /*html*/`
<div class="psc-composer">
	<textarea class="psc-input {~D:Record.InputClass~}" id="{~D:Record.InputId~}" rows="2" placeholder="{~D:Record.Placeholder~}"
		onpaste="_Pict.views['{~D:Record.ViewHash~}'].onComposerPaste(event,'{~D:Record.InputId~}')"
		ondragover="event.preventDefault(); this.classList.add('psc-dragover');"
		ondragleave="this.classList.remove('psc-dragover');"
		ondrop="_Pict.views['{~D:Record.ViewHash~}'].onComposerDrop(event,'{~D:Record.InputId~}')"></textarea>
	<div class="psc-composer-actions">
		<span class="psc-composer-hint">{~D:Record.Hint~}</span>
		{~TS:Comments-ComposerCancel:Record.CancelSlot~}
		<button class="psc-btn psc-btn-primary" onclick="_Pict.views['{~D:Record.ViewHash~}'].{~D:Record.SubmitCall~}">{~D:Record.SubmitLabel~}</button>
	</div>
</div>`
		},
		{
			Hash: 'Comments-ComposerCancel',
			Template: /*html*/`<button class="psc-btn psc-btn-ghost" onclick="_Pict.views['{~D:Record.ViewHash~}'].{~D:Record.CancelCall~}">Cancel</button>`
		},
		{
			Hash: 'Comments-AddButton',
			Template: /*html*/`<button class="psc-btn psc-btn-ghost psc-add-comment" onclick="_Pict.views['{~D:Record.ViewHash~}'].openRichComposer('comment','{~D:Record.ThreadKey~}')">+ Add a comment</button>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Comments-Section',
			TemplateHash: 'Comments-Section',
			ContentDestinationAddress: '#Comments-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewComments extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this._provider = null;
		this._context = libCommentProvider.normalizeContext(this.options.Context);
		this._loaded = { Threads: [], CommentsByThreadKey: {} };
		// Transient UI state (not persisted): collapse overrides, the open editor / reply target, sort.
		this._ui =
		{
			Sort: (this.options.SortOrder === 'newest') ? 'newest' : 'oldest',
			CollapsedThreads: {},
			EditingKey: null,
			ReplyTarget: null,
			FocusInputId: null
		};
		this._state = null;
	}

	onBeforeInitialize()
	{
		this._initProvider();
		this._ensureSupportViews();
		this._initState();
		return super.onBeforeInitialize();
	}

	_initProvider()
	{
		if (this.options.DataProvider)
		{
			this._provider = this.options.DataProvider;
			return;
		}
		// Default: in-memory, backed by a slice of AppData keyed by this instance so multiple sections
		// on a page keep separate stores and the data stays observable / serializable.
		if (!this.pict.AppData.CommentsStores) { this.pict.AppData.CommentsStores = {}; }
		if (!this.pict.AppData.CommentsStores[this.Hash]) { this.pict.AppData.CommentsStores[this.Hash] = {}; }
		this._provider = new _InMemoryCommentProvider({ Store: this.pict.AppData.CommentsStores[this.Hash] });
	}

	// Register the content provider (markdown rendering) and the modal (confirms) once per app.
	_ensureSupportViews()
	{
		if (!this.pict.providers['Pict-Content'])
		{
			this.pict.addProvider('Pict-Content', libContent.PictContentProvider.default_configuration, libContent.PictContentProvider);
		}
		this._contentProvider = this.pict.providers['Pict-Content'];
		// Registering the modal is not enough: it scopes its CSS variables under a
		// .pict-modal-root class it puts on <body> during onBeforeInitialize, so an
		// uninitialized modal renders unstyled dialogs and toasts. Initialize it
		// explicitly when the root class is absent (idempotent in hosts that already did).
		if (!this.pict.views['Pict-Section-Modal'])
		{
			this.pict.addView('Pict-Section-Modal', libModal.default_configuration, libModal);
		}
		let tmpModalView = this.pict.views['Pict-Section-Modal'];
		if (tmpModalView && typeof document !== 'undefined' && document.body
			&& !document.body.classList.contains('pict-modal-root')
			&& typeof tmpModalView.initialize === 'function')
		{
			tmpModalView.initialize();
		}
	}

	_initState()
	{
		// Shape an empty state so a render before data arrives is harmless.
		this._loaded = { Threads: [], CommentsByThreadKey: {} };
		this._shape();
	}

	// ---- Public API ----

	/** (Re)load this context from the provider and render. */
	load() { return this._reload(); }
	refresh() { return this._reload(); }

	/** Point the section at a different context and reload. */
	setContext(pContext)
	{
		this._context = libCommentProvider.normalizeContext(pContext);
		this.options.Context = this._context;
		return this._reload();
	}

	setReadOnly(pReadOnly) { this.options.ReadOnly = !!pReadOnly; this._shape(); this.render(); }
	setSortOrder(pOrder) { this._ui.Sort = (pOrder === 'newest') ? 'newest' : 'oldest'; this._shape(); this.render(); }
	setDataProvider(pProvider) { this._provider = pProvider; return this._reload(); }

	/** Host API: start a thread (for example an anchored note the host creates from a selection). */
	startThread(pSpec)
	{
		let tmpSpec = pSpec || {};
		return this._provider.createThread(Object.assign({ Context: this._context, Author: this._author() }, tmpSpec))
			.then((pThread) => { this._fire('onThreadCreated', pThread); return this._reload().then(() => pThread); });
	}

	// ---- Lifecycle ----

	onAfterInitializeAsync(fCallback)
	{
		this._reload().then(() => fCallback()).catch(() => fCallback());
	}

	onBeforeRender(pRenderable)
	{
		// Publish this instance's shaped state so templates (and the baked-in inline handlers) read it.
		this.pict.AppData.CommentsActive = this._state;
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		// Focus a freshly opened input (composer / reply / edit) once, if asked.
		if (this._ui.FocusInputId)
		{
			let tmpInput = (typeof document !== 'undefined') ? document.getElementById(this._ui.FocusInputId) : null;
			if (tmpInput) { try { tmpInput.focus(); } catch (pError) { /* non-DOM host */ } }
			this._ui.FocusInputId = null;
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// ---- Data flow ----

	_reload()
	{
		if (!this._provider || !this._context.OwnerType || !this._context.IDOwner)
		{
			this._loaded = { Threads: [], CommentsByThreadKey: {} };
			this._shape();
			this.render();
			return Promise.resolve();
		}
		return this._provider.loadContext(this._context).then((pLoaded) =>
		{
			this._loaded = pLoaded || { Threads: [], CommentsByThreadKey: {} };
			this._shape();
			this.render();
		}).catch((pError) =>
		{
			if (this.log) { this.log.error('pict-section-comments load failed: ' + (pError && pError.message), pError); }
		});
	}

	_author()
	{
		let tmpUser = this.options.CurrentUser || {};
		return { Key: tmpUser.Key || '', Name: tmpUser.Name || 'Anonymous', Avatar: tmpUser.Avatar || '' };
	}

	_fire(pName, pPayload)
	{
		if (typeof this.options[pName] === 'function')
		{
			try { this.options[pName](pPayload); } catch (pError) { if (this.log) { this.log.warn('pict-section-comments ' + pName + ' handler threw', pError); } }
		}
		if (pName !== 'onChange' && typeof this.options.onChange === 'function')
		{
			try { this.options.onChange({ Event: pName, Payload: pPayload }); } catch (pError) { /* swallow */ }
		}
	}

	// ---- Shaping: turn loaded data + UI state into the render model on this._state ----

	_isClosed(pStatus) { return (pStatus === THREAD_STATUS.Resolved || pStatus === THREAD_STATUS.Completed); }

	_threadCollapsed(pThread)
	{
		if (Object.prototype.hasOwnProperty.call(this._ui.CollapsedThreads, pThread.Key))
		{
			return !!this._ui.CollapsedThreads[pThread.Key];
		}
		return !!(this.options.CollapseCompleted && this._isClosed(pThread.Status));
	}

	_shape()
	{
		let tmpReadOnly = !!this.options.ReadOnly;
		let tmpThreads = (this._loaded.Threads || []).map((pThread) => this._shapeThread(pThread, tmpReadOnly));

		this._state =
		{
			ViewHash: this.Hash,
			Title: this.options.Title,
			EmptyText: this.options.EmptyText,
			ThreadCount: tmpThreads.length,
			SortLabel: (this._ui.Sort === 'newest') ? 'Newest first' : 'Oldest first',
			RootClass: tmpReadOnly ? 'psc-readonly' : '',
			Threads: tmpThreads,
			EmptySlot: (tmpThreads.length === 0) ? [{ EmptyText: this.options.EmptyText }] : [],
			NewButtonSlot: (!tmpReadOnly && this.options.AllowNewThread) ? [{ ViewHash: this.Hash }] : []
		};
	}

	_shapeThread(pThread, pReadOnly)
	{
		let tmpComments = this._loaded.CommentsByThreadKey[pThread.Key] || [];
		let tmpShapedComments = this._shapeCommentTree(pThread, tmpComments, pReadOnly);
		let tmpCollapsed = this._threadCollapsed(pThread);
		let tmpClosed = this._isClosed(pThread.Status);
		let tmpAnchorLabel = this._anchorLabel(pThread.Anchor);

		return (
		{
			ViewHash: this.Hash,
			Key: pThread.Key,
			StatusLabel: pThread.Status,
			StatusLower: String(pThread.Status || 'Open').toLowerCase(),
			CollapseClass: tmpCollapsed ? 'psc-collapsed' : '',
			TitleDisplay: libContentAdapter.escapeHtml(pThread.Title || (pThread.Anchor ? 'Note' : 'Discussion')),
			CommentCount: this._countComments(tmpComments) + (this._countComments(tmpComments) === 1 ? ' comment' : ' comments'),
			AnchorSlot: tmpAnchorLabel ? [{ ViewHash: this.Hash, Key: pThread.Key, AnchorLabel: libContentAdapter.escapeHtml(tmpAnchorLabel) }] : [],
			ActionSlot: pReadOnly ? [] : [this._threadActionRecord(pThread, tmpClosed)],
			Comments: tmpShapedComments,
			// Non-rich: an inline textarea composer. Rich: a button that opens the full editor in a modal.
			ComposerSlot: (pReadOnly || this._effectiveMode() === 'rich') ? [] : [this._composerRecord('thread', pThread.Key, null, 'Add a comment...', "submitComment('" + pThread.Key + "')", 'Comment', null)],
			AddButtonSlot: (!pReadOnly && this._effectiveMode() === 'rich') ? [{ ViewHash: this.Hash, ThreadKey: pThread.Key }] : []
		});
	}

	_threadActionRecord(pThread, pClosed)
	{
		let tmpResolveLabel = pClosed ? 'Reopen' : 'Resolve';
		let tmpResolveCall = (pClosed ? "reopenThread('" : "resolveThread('") + pThread.Key + "')";
		return (
		{
			ViewHash: this.Hash,
			Key: pThread.Key,
			ResolveLabel: this.options.AllowResolve ? tmpResolveLabel : '',
			ResolveCall: tmpResolveCall,
			DeleteSlot: this.options.AllowDelete ? [{ ViewHash: this.Hash, Key: pThread.Key }] : []
		});
	}

	_shapeCommentTree(pThread, pComments, pReadOnly)
	{
		let tmpOrdered = this._orderComments(pComments);
		if (!this.options.Threaded)
		{
			return tmpOrdered.map((pComment) => this._shapeComment(pThread, pComment, pReadOnly, false));
		}
		// One level of replies: top-level comments carry their direct replies.
		let tmpByParent = {};
		for (let i = 0; i < pComments.length; i++)
		{
			let tmpParent = pComments[i].ParentKey;
			if (tmpParent) { (tmpByParent[tmpParent] = tmpByParent[tmpParent] || []).push(pComments[i]); }
		}
		let tmpTop = tmpOrdered.filter((pComment) => !pComment.ParentKey);
		return tmpTop.map((pComment) =>
		{
			let tmpShaped = this._shapeComment(pThread, pComment, pReadOnly, true);
			let tmpReplies = this._orderRepliesAscending(tmpByParent[pComment.Key] || []);
			tmpShaped.ReplyWrapSlot = tmpReplies.length ? [{ Replies: tmpReplies.map((pReply) => this._shapeComment(pThread, pReply, pReadOnly, false)) }] : [];
			return tmpShaped;
		});
	}

	_orderComments(pComments)
	{
		let tmpSorted = (pComments || []).slice().sort((pA, pB) => pA.CreatedAt - pB.CreatedAt);
		return (this._ui.Sort === 'newest') ? tmpSorted.reverse() : tmpSorted;
	}

	_orderRepliesAscending(pReplies) { return (pReplies || []).slice().sort((pA, pB) => pA.CreatedAt - pB.CreatedAt); }

	_countComments(pComments) { return (pComments || []).filter((pComment) => !pComment.Deleted).length; }

	_shapeComment(pThread, pComment, pReadOnly, pAllowReply)
	{
		let tmpEditing = (this._ui.EditingKey === pComment.Key);
		let tmpReplying = !!(this._ui.ReplyTarget && this._ui.ReplyTarget.ParentKey === pComment.Key);
		let tmpAuthorName = (pComment.Author && pComment.Author.Name) ? pComment.Author.Name : 'Anonymous';
		let tmpAvatar = (pComment.Author && pComment.Author.Avatar) ? pComment.Author.Avatar : '';
		let tmpBodyHTML = libContentAdapter.renderToHtml(pComment.Body, pComment.ContentType, { parseMarkdown: (pMD) => this._parseMarkdown(pMD) });

		let tmpActions = [];
		if (!pReadOnly && pAllowReply && this.options.AllowReply && this.options.Threaded)
		{
			tmpActions.push({ ViewHash: this.Hash, Call: "openReply('" + pThread.Key + "','" + pComment.Key + "')", Label: 'Reply' });
		}
		if (!pReadOnly && this.options.AllowEdit && this._isAuthor(pComment))
		{
			tmpActions.push({ ViewHash: this.Hash, Call: "openEdit('" + pComment.Key + "')", Label: 'Edit' });
		}
		if (!pReadOnly && this.options.AllowDelete && this._isAuthor(pComment))
		{
			tmpActions.push({ ViewHash: this.Hash, Call: "confirmDeleteComment('" + pComment.Key + "')", Label: 'Delete' });
		}

		return (
		{
			ViewHash: this.Hash,
			Key: pComment.Key,
			AuthorName: libContentAdapter.escapeHtml(tmpAuthorName),
			Initials: this._initials(tmpAuthorName),
			AvatarStyle: tmpAvatar ? ("background-image:url('" + encodeURI(tmpAvatar) + "')") : '',
			TimeLabel: this._timeAgo(pComment.CreatedAt),
			EditedSlot: pComment.EditedAt ? [{}] : [],
			BodyHTML: tmpBodyHTML,
			BodyRaw: libContentAdapter.escapeHtml(pComment.Body),
			ViewSlot: tmpEditing ? [] : [{ BodyHTML: tmpBodyHTML }],
			EditSlot: tmpEditing ? [this._editRecord(pComment)] : [],
			ActionSlot: tmpEditing ? [] : tmpActions,
			ReplyWrapSlot: [],
			ReplyComposerSlot: tmpReplying ? [this._composerRecord('reply', pThread.Key, pComment.Key, 'Write a reply...', "submitReply('" + pThread.Key + "','" + pComment.Key + "')", 'Reply', 'cancelReply()')] : []
		});
	}

	_editRecord(pComment)
	{
		return (
		{
			ViewHash: this.Hash,
			Key: pComment.Key,
			EditInputId: 'psc-edit-' + this.Hash + '-' + pComment.Key,
			BodyRaw: libContentAdapter.escapeHtml(pComment.Body),
			InputClass: this._composerInputClass(),
			Hint: this._composerHint()
		});
	}

	_composerRecord(pKind, pThreadKey, pParentKey, pPlaceholder, pSubmitCall, pSubmitLabel, pCancelCall)
	{
		let tmpInputId = 'psc-input-' + this.Hash + '-' + pKind + '-' + (pParentKey || pThreadKey);
		return (
		{
			ViewHash: this.Hash,
			InputId: tmpInputId,
			Placeholder: pPlaceholder,
			SubmitCall: pSubmitCall,
			SubmitLabel: pSubmitLabel,
			InputClass: this._composerInputClass(),
			Hint: this._composerHint(),
			CancelSlot: pCancelCall ? [{ ViewHash: this.Hash, CancelCall: pCancelCall }] : []
		});
	}

	_composerInputClass() { return libContentAdapter.modeRendersMarkdown(this.options.EditorMode) ? 'psc-mono' : ''; }

	_composerHint()
	{
		if (!libContentAdapter.modeRendersMarkdown(this.options.EditorMode)) { return ''; }
		return this.options.ImageUpload ? 'Markdown supported. Drag or paste an image to upload.' : 'Markdown supported.';
	}

	// CodeMirror modules for the 'rich' full editor, from config or the window global.
	_codeMirror()
	{
		if (this.options.CodeMirrorModules) { return this.options.CodeMirrorModules; }
		if (typeof window !== 'undefined' && window.CodeMirrorModules) { return window.CodeMirrorModules; }
		return null;
	}

	// 'rich' needs CodeMirror; without it, fall back to the markdown composer so nothing breaks.
	_effectiveMode()
	{
		if (this.options.EditorMode === 'rich') { return this._codeMirror() ? 'rich' : 'markdown'; }
		return this.options.EditorMode || 'text';
	}

	// ---- Markdown rendering (via pict-section-content) ----

	_parseMarkdown(pMarkdown)
	{
		if (this._contentProvider && typeof this._contentProvider.parseMarkdown === 'function')
		{
			try { return this._contentProvider.parseMarkdown(String(pMarkdown == null ? '' : pMarkdown)); }
			catch (pError) { return libContentAdapter.escapeHtml(pMarkdown); }
		}
		return libContentAdapter.escapeHtml(pMarkdown);
	}

	// ---- Interaction handlers (called from inline template handlers) ----

	toggleSort() { this._ui.Sort = (this._ui.Sort === 'oldest') ? 'newest' : 'oldest'; this._shape(); this.render(); }

	toggleCollapse(pThreadKey)
	{
		let tmpThread = (this._loaded.Threads || []).find((pT) => pT.Key === pThreadKey);
		let tmpCurrent = tmpThread ? this._threadCollapsed(tmpThread) : false;
		this._ui.CollapsedThreads[pThreadKey] = !tmpCurrent;
		this._shape();
		this.render();
	}

	newDiscussion()
	{
		return this._provider.createThread({ Context: this._context, Kind: 'Discussion', Status: THREAD_STATUS.Open, Author: this._author() })
			.then((pThread) =>
			{
				this._fire('onThreadCreated', pThread);
				this._ui.CollapsedThreads[pThread.Key] = false;
				this._ui.FocusInputId = 'psc-input-' + this.Hash + '-thread-' + pThread.Key;
				return this._reload();
			});
	}

	submitComment(pThreadKey)
	{
		let tmpBody = this._inputValue('psc-input-' + this.Hash + '-thread-' + pThreadKey);
		if (!tmpBody) { return Promise.resolve(); }
		return this._provider.createComment(this._newCommentDraft(pThreadKey, null, tmpBody))
			.then((pComment) => { this._fire('onCommentAdded', pComment); return this._reload(); });
	}

	openReply(pThreadKey, pParentKey)
	{
		if (this._effectiveMode() === 'rich') { return this.openRichComposer('reply', pThreadKey, pParentKey); }
		this._ui.ReplyTarget = { ThreadKey: pThreadKey, ParentKey: pParentKey };
		this._ui.FocusInputId = 'psc-input-' + this.Hash + '-reply-' + pParentKey;
		this._shape();
		this.render();
	}

	cancelReply() { this._ui.ReplyTarget = null; this._shape(); this.render(); }

	submitReply(pThreadKey, pParentKey)
	{
		let tmpBody = this._inputValue('psc-input-' + this.Hash + '-reply-' + pParentKey);
		if (!tmpBody) { return Promise.resolve(); }
		return this._provider.createComment(this._newCommentDraft(pThreadKey, pParentKey, tmpBody))
			.then((pComment) => { this._ui.ReplyTarget = null; this._fire('onCommentAdded', pComment); return this._reload(); });
	}

	openEdit(pCommentKey)
	{
		if (this._effectiveMode() === 'rich')
		{
			let tmpComment = this._findComment(pCommentKey);
			return this.openRichComposer('edit', tmpComment ? tmpComment.ThreadKey : null, null, pCommentKey);
		}
		this._ui.EditingKey = pCommentKey; this._ui.FocusInputId = 'psc-edit-' + this.Hash + '-' + pCommentKey; this._shape(); this.render();
	}
	cancelEdit() { this._ui.EditingKey = null; this._shape(); this.render(); }

	submitEdit(pCommentKey)
	{
		let tmpBody = this._inputValue('psc-edit-' + this.Hash + '-' + pCommentKey);
		if (!tmpBody) { return Promise.resolve(); }
		return this._provider.updateComment(pCommentKey, { Body: tmpBody })
			.then((pComment) => { this._ui.EditingKey = null; this._fire('onCommentEdited', pComment); return this._reload(); });
	}

	confirmDeleteComment(pCommentKey)
	{
		return this._confirm('Delete this comment? This cannot be undone.', { title: 'Delete comment', confirmLabel: 'Delete', dangerous: true })
			.then((pOk) =>
			{
				if (!pOk) { return; }
				return this._provider.deleteComment(pCommentKey).then(() => { this._fire('onCommentDeleted', { Key: pCommentKey }); return this._reload(); });
			});
	}

	resolveThread(pThreadKey)
	{
		return this._provider.resolveThread(pThreadKey).then((pThread) => { delete this._ui.CollapsedThreads[pThreadKey]; this._fire('onThreadResolved', pThread); return this._reload(); });
	}

	reopenThread(pThreadKey)
	{
		return this._provider.reopenThread(pThreadKey).then((pThread) => { this._ui.CollapsedThreads[pThreadKey] = false; this._fire('onThreadResolved', pThread); return this._reload(); });
	}

	confirmDeleteThread(pThreadKey)
	{
		return this._confirm('Delete this entire thread and its comments? This cannot be undone.', { title: 'Delete thread', confirmLabel: 'Delete', dangerous: true })
			.then((pOk) =>
			{
				if (!pOk) { return; }
				return this._provider.deleteThread(pThreadKey).then(() => { this._fire('onChange', { Event: 'onThreadDeleted', Payload: { Key: pThreadKey } }); return this._reload(); });
			});
	}

	activateAnchor(pThreadKey)
	{
		let tmpThread = (this._loaded.Threads || []).find((pT) => pT.Key === pThreadKey);
		if (tmpThread && tmpThread.Anchor) { this._fire('onAnchorActivate', tmpThread.Anchor); }
	}

	// ---- Rich mode: compose in the full pict-section-markdowneditor, hosted in a modal ----
	// The editor lives inside a pict-section-modal, outside this section's render cycle, so there is no
	// re-mount churn. One editor instance per comments view, reused across opens.

	openRichComposer(pKind, pThreadKey, pParentKey, pCommentKey)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return Promise.resolve(); }

		let tmpInitial = '';
		let tmpTitle = 'Add a comment';
		let tmpSaveLabel = 'Comment';
		if (pKind === 'reply') { tmpTitle = 'Reply'; tmpSaveLabel = 'Reply'; }
		if (pKind === 'edit')
		{
			tmpTitle = 'Edit comment';
			tmpSaveLabel = 'Save';
			let tmpComment = this._findComment(pCommentKey);
			tmpInitial = tmpComment ? (tmpComment.Body || '') : '';
		}

		let tmpHostId = 'psc-mde-host-' + this._richKey();
		let tmpSelf = this;

		return tmpModal.show(
		{
			title: tmpTitle,
			content: '<div class="psc-mde-modal" id="' + tmpHostId + '"></div>',
			buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'save', Label: tmpSaveLabel, Style: 'primary' } ],
			onOpen: function () { tmpSelf._mountModalEditor(tmpHostId, tmpInitial); }
		}).then(function (pChoice)
		{
			if (pChoice !== 'save') { return; }
			let tmpBody = tmpSelf._readModalEditor();
			if (!tmpBody) { return; }
			if (pKind === 'edit')
			{
				return tmpSelf._provider.updateComment(pCommentKey, { Body: tmpBody, ContentType: 'rich' })
					.then(function (pComment) { tmpSelf._fire('onCommentEdited', pComment); return tmpSelf._reload(); });
			}
			return tmpSelf._provider.createComment(
			{
				ThreadKey: pThreadKey, ParentKey: (pKind === 'reply') ? pParentKey : null,
				Body: tmpBody, ContentType: 'rich', Author: tmpSelf._author()
			}).then(function (pComment) { tmpSelf._fire('onCommentAdded', pComment); return tmpSelf._reload(); });
		});
	}

	_richKey() { return this.Hash.replace(/[^a-zA-Z0-9]/g, ''); }

	_mountModalEditor(pHostId, pInitial)
	{
		let tmpDataKey = this._richKey();
		if (!this.pict.AppData.CommentsRichEditor) { this.pict.AppData.CommentsRichEditor = {}; }
		this.pict.AppData.CommentsRichEditor[tmpDataKey] = { Segments: [ { Content: pInitial || '' } ] };

		// A fresh editor per open. The markdown editor caches its CodeMirror instances, so reusing one
		// view across opens leaves the new modal host empty; tear the previous one down and build anew.
		this._destroyModalEditor();
		this._mdeCounter = (this._mdeCounter || 0) + 1;
		let tmpHash = 'PSC-MDE-' + this.Hash + '-' + this._mdeCounter;
		let tmpEditor = this.pict.addView(tmpHash, this._modalEditorConfiguration(pHostId, tmpDataKey), libMarkdownEditor);
		if (typeof tmpEditor.initialize === 'function' && !tmpEditor.initializeTimestamp) { tmpEditor.initialize(); }
		let tmpCM = this._codeMirror();
		if (tmpCM && typeof tmpEditor.connectCodeMirrorModules === 'function') { tmpEditor.connectCodeMirrorModules(tmpCM); }
		let tmpSelf = this;
		tmpEditor.onImageUpload = function (pFile, pSegmentIndex, fCallback)
		{
			if (typeof tmpSelf.options.ImageUpload === 'function') { tmpSelf.options.ImageUpload(pFile, function (pErr, pURL) { fCallback(pErr, pURL); }); return true; }
			return false;
		};
		this._modalEditor = tmpEditor;
		this._modalEditorHash = tmpHash;
		tmpEditor.render();
	}

	// Tear down the modal editor (its CodeMirror instances) and drop it from the view registry.
	_destroyModalEditor()
	{
		if (!this._modalEditor) { return; }
		try { if (typeof this._modalEditor.destroy === 'function') { this._modalEditor.destroy(); } } catch (pError) { /* ignore */ }
		if (this._modalEditorHash && this.pict.views && this.pict.views[this._modalEditorHash]) { delete this.pict.views[this._modalEditorHash]; }
		this._modalEditor = null;
		this._modalEditorHash = null;
	}

	_modalEditorConfiguration(pHostId, pDataKey)
	{
		return Object.assign({}, libMarkdownEditor.default_configuration,
		{
			ViewIdentifier: 'PSC-MDE-' + this.Hash,
			ContentDataAddress: 'AppData.CommentsRichEditor.' + pDataKey + '.Segments',
			DefaultDestinationAddress: '#' + pHostId,
			TargetElementAddress: '#' + pHostId,
			EnableRichPreview: true,
			DefaultPreviewMode: 'off',
			AutoRender: false,
			ButtonsTL: [],
			Renderables: [ { RenderableHash: 'MarkdownEditor-Wrap', TemplateHash: 'MarkdownEditor-Container', DestinationAddress: '#' + pHostId, ContentDestinationAddress: '#' + pHostId } ]
		});
	}

	_readModalEditor()
	{
		if (this._modalEditor && typeof this._modalEditor.marshalFromView === 'function') { try { this._modalEditor.marshalFromView(); } catch (pError) { /* ignore */ } }
		let tmpData = (this.pict.AppData.CommentsRichEditor || {})[this._richKey()];
		let tmpSegments = (tmpData && tmpData.Segments) ? tmpData.Segments : [];
		return tmpSegments.map(function (pSeg) { return pSeg.Content || ''; }).join('\n\n').trim();
	}

	_findComment(pCommentKey)
	{
		let tmpByThread = this._loaded.CommentsByThreadKey || {};
		let tmpKeys = Object.keys(tmpByThread);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpFound = (tmpByThread[tmpKeys[i]] || []).find(function (pC) { return pC.Key === pCommentKey; });
			if (tmpFound) { return tmpFound; }
		}
		return null;
	}

	// ---- Image / file drag-in for markdown composers ----

	onComposerPaste(pEvent, pInputId)
	{
		if (!this.options.ImageUpload || !libContentAdapter.modeRendersMarkdown(this.options.EditorMode)) { return; }
		let tmpItems = (pEvent.clipboardData && pEvent.clipboardData.items) ? pEvent.clipboardData.items : [];
		for (let i = 0; i < tmpItems.length; i++)
		{
			if (tmpItems[i].kind === 'file')
			{
				let tmpFile = tmpItems[i].getAsFile();
				if (tmpFile) { pEvent.preventDefault(); this._uploadAndInsert(tmpFile, pInputId); }
			}
		}
	}

	onComposerDrop(pEvent, pInputId)
	{
		let tmpTarget = pEvent.target;
		if (tmpTarget && tmpTarget.classList) { tmpTarget.classList.remove('psc-dragover'); }
		if (!this.options.ImageUpload || !libContentAdapter.modeRendersMarkdown(this.options.EditorMode)) { return; }
		let tmpFiles = (pEvent.dataTransfer && pEvent.dataTransfer.files) ? pEvent.dataTransfer.files : [];
		if (tmpFiles.length) { pEvent.preventDefault(); }
		for (let i = 0; i < tmpFiles.length; i++) { this._uploadAndInsert(tmpFiles[i], pInputId); }
	}

	_uploadAndInsert(pFile, pInputId)
	{
		let tmpIsImage = pFile.type && pFile.type.indexOf('image/') === 0;
		this.options.ImageUpload(pFile, (pError, pURL) =>
		{
			if (pError || !pURL) { if (this.log) { this.log.warn('pict-section-comments upload failed', pError); } return; }
			let tmpSnippet = (tmpIsImage ? '![' : '[') + (pFile.name || 'file') + '](' + pURL + ')';
			this._insertAtCursor(pInputId, tmpSnippet);
		});
	}

	_insertAtCursor(pInputId, pText)
	{
		let tmpInput = (typeof document !== 'undefined') ? document.getElementById(pInputId) : null;
		if (!tmpInput) { return; }
		let tmpStart = (typeof tmpInput.selectionStart === 'number') ? tmpInput.selectionStart : tmpInput.value.length;
		let tmpEnd = (typeof tmpInput.selectionEnd === 'number') ? tmpInput.selectionEnd : tmpInput.value.length;
		let tmpInsert = (tmpStart > 0 && tmpInput.value[tmpStart - 1] !== '\n' && tmpInput.value[tmpStart - 1] !== undefined) ? ('\n' + pText + '\n') : (pText + '\n');
		tmpInput.value = tmpInput.value.slice(0, tmpStart) + tmpInsert + tmpInput.value.slice(tmpEnd);
		let tmpCaret = tmpStart + tmpInsert.length;
		try { tmpInput.setSelectionRange(tmpCaret, tmpCaret); tmpInput.focus(); } catch (pError) { /* non-DOM */ }
	}

	// ---- small helpers ----

	_newCommentDraft(pThreadKey, pParentKey, pBody)
	{
		return (
		{
			ThreadKey: pThreadKey,
			ParentKey: pParentKey,
			Body: pBody,
			ContentType: libContentAdapter.defaultContentTypeForMode(this.options.EditorMode),
			Author: this._author()
		});
	}

	_isAuthor(pComment)
	{
		// With no signed-in user key, allow edit/delete (single-user / demo). With a key, restrict to own.
		let tmpUserKey = (this.options.CurrentUser && this.options.CurrentUser.Key) ? String(this.options.CurrentUser.Key) : '';
		if (!tmpUserKey) { return true; }
		let tmpAuthorKey = (pComment.Author && pComment.Author.Key != null) ? String(pComment.Author.Key) : '';
		return (tmpAuthorKey === tmpUserKey);
	}

	_inputValue(pInputId)
	{
		let tmpInput = (typeof document !== 'undefined') ? document.getElementById(pInputId) : null;
		return tmpInput ? String(tmpInput.value || '').trim() : '';
	}

	_confirm(pMessage, pOptions)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function') { return tmpModal.confirm(pMessage, pOptions || {}); }
		// No modal available (headless / test): default to not-confirmed so nothing is destroyed silently.
		return Promise.resolve(false);
	}

	_initials(pName)
	{
		let tmpParts = String(pName || '').trim().split(/\s+/).filter(Boolean);
		if (!tmpParts.length) { return '?'; }
		if (tmpParts.length === 1) { return tmpParts[0].slice(0, 2).toUpperCase(); }
		return (tmpParts[0][0] + tmpParts[tmpParts.length - 1][0]).toUpperCase();
	}

	_anchorLabel(pAnchor)
	{
		if (!pAnchor) { return ''; }
		if (pAnchor.Label) { return String(pAnchor.Label); }
		if (pAnchor.Type === 'ByteRange') { return 'bytes ' + pAnchor.Start + '-' + pAnchor.End; }
		if (pAnchor.Type === 'Paragraph') { return 'paragraph'; }
		if (pAnchor.Type === 'Point') { return 'pin'; }
		return pAnchor.Type ? String(pAnchor.Type) : 'location';
	}

	_timeAgo(pTimestamp)
	{
		if (!pTimestamp) { return ''; }
		let tmpNow = Date.now();
		let tmpDelta = Math.max(0, tmpNow - pTimestamp);
		let tmpSec = Math.floor(tmpDelta / 1000);
		if (tmpSec < 45) { return 'just now'; }
		let tmpMin = Math.floor(tmpSec / 60);
		if (tmpMin < 60) { return tmpMin + 'm ago'; }
		let tmpHour = Math.floor(tmpMin / 60);
		if (tmpHour < 24) { return tmpHour + 'h ago'; }
		let tmpDay = Math.floor(tmpHour / 24);
		if (tmpDay < 7) { return tmpDay + 'd ago'; }
		try { return new Date(pTimestamp).toLocaleDateString(); } catch (pError) { return ''; }
	}
}

module.exports = PictViewComments;
module.exports.default_configuration = _DefaultConfiguration;

},{"../content/ContentAdapter.js":192,"../providers/CommentProvider-Base.js":193,"pict-section-content":196,"pict-section-markdowneditor":261,"pict-section-modal":271,"pict-view":365}],195:[function(require,module,exports){
'use strict';

/**
 * Shared CSS for pict-section-content. Registered by BOTH the provider (so any consumer
 * using parseMarkdown gets code-block + content styling, even without instantiating the view)
 * and the view, under one hash so it injects once. This is the lower-layer home for the
 * code-block line-number gutter layout (.pict-content-code-wrap is a flex row) that used to
 * only ship with the view -- fixing the recurring "line numbers render above the code" bug.
 */
module.exports = /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: var(--theme-color-text-secondary, #5E5549);
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: var(--theme-color-text-primary, #423D37);
			margin: 0.75em 0;
		}
		.pict-content a {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		/* ─── Code blocks ─────────────────────────────────────
		   Background, text color, line-number gutter, and every
		   syntax token route through pict-provider-theme tokens —
		   the same set pict-section-code (the live editor) uses.
		   This way the rendered-preview code blocks look identical
		   to the live editor and re-skin together when the theme
		   switches.  Previous version used the text-primary token
		   as the code background (a TEXT token used as BACKGROUND),
		   which broke in dark mode and any palette where text and
		   background-tertiary diverge.
		*/
		.pict-content pre {
			background:    var(--theme-color-background-tertiary, #F0ECE4);
			color:         var(--theme-color-text-primary,        #3D3229);
			border:        1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
		}
		/* Inline code (single backtick) — slightly differentiated
		   from block code so it doesn't disappear into prose. */
		.pict-content code {
			background:    var(--theme-color-background-secondary, #FAF8F4);
			color:         var(--theme-color-text-primary,         #3D3229);
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
		}
		.pict-content-code-wrap {
			display: flex;
			flex-direction: row;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
			font-size: 14px;
			line-height: 1.5;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			overflow: hidden;
			margin: 1em 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			width: 40px;
			min-width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background:    var(--theme-color-background-secondary, #FAF8F4);
			border-right:  1px solid var(--theme-color-border-default, #DDD6CA);
			color:         var(--theme-color-text-muted,           #8A7F72);
			font-family: inherit;
			font-size: inherit;
			line-height: inherit;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
			color:      var(--theme-color-text-primary,        #3D3229);
			border: none;
			padding: 1.25em 1.25em 1.25em 8px;
			border-radius: 0 6px 6px 0;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
			flex: 1;
			min-width: 0;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		/* Syntax token colors — every class binds to a --theme-color-syntax-*
		   variable, the same tokens pict-section-code (the live editor) uses.
		   Each var() carries an Atom One Light hex as fallback for hosts
		   without a theme provider; themes that DO ship syntax tokens
		   (pict-default, retold-content-system, etc.) drive everything
		   coherently. */
		.pict-content-code-wrap .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
		.pict-content-code-wrap .string        { color: var(--theme-color-syntax-string,      #50A14F); }
		.pict-content-code-wrap .number        { color: var(--theme-color-syntax-number,      #986801); }
		.pict-content-code-wrap .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
		.pict-content-code-wrap .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
		.pict-content-code-wrap .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
		.pict-content-code-wrap .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
		.pict-content-code-wrap .property      { color: var(--theme-color-syntax-property,    #E45649); }
		.pict-content-code-wrap .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
		.pict-content-code-wrap .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
		.pict-content-code-wrap .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
		.pict-content-code-wrap .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
		.pict-content-code-wrap .type          { color: var(--theme-color-syntax-type,        #C18401); }
		.pict-content-code-wrap .variable      { color: var(--theme-color-syntax-variable,    #383A42); }
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-content blockquote {
			border-left: 4px solid var(--theme-color-brand-primary, #2E7D74);
			margin: 1em 0;
			padding: 0.5em 1em;
			background: var(--theme-color-background-secondary, #F7F5F0);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid var(--theme-color-border-default, #DDD6CA);
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-content table td {
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.5em 0.8em;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content table tr:nth-child(even) {
			background: var(--theme-color-background-secondary, #F7F5F0);
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #2A241E);
			text-align: center;
			padding: 1em;
		}
		.pict-content pre.mermaid text,
		.pict-content pre.mermaid .nodeLabel,
		.pict-content pre.mermaid .edgeLabel,
		.pict-content pre.mermaid .label,
		.pict-content pre.mermaid .cluster-label,
		.pict-content pre.mermaid span,
		.pict-content pre.mermaid foreignObject p,
		.pict-content pre.mermaid foreignObject div,
		.pict-content pre.mermaid foreignObject span {
			color: var(--theme-color-text-primary, #2A241E) !important;
			fill: var(--theme-color-text-primary, #2A241E) !important;
		}
		.pict-content pre.mermaid .edgePath .path {
			stroke: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content pre.mermaid .arrowheadPath {
			fill: var(--theme-color-text-secondary, #5E5549) !important;
		}
		/* Dark-mode override for handcrafted mermaid diagrams that bake
		   per-node inline fill colors via 'style X fill:#...' directives
		   (common in architecture / module docs, where pastel layer
		   colors mark visual hierarchy). Mermaid renders those as inline
		   style="fill:#..." SVG attributes — highest specificity, so
		   neither themeVariables nor unflagged CSS can reach them.
		   In light mode the Material pastels read fine; in dark mode the
		   same light fills become a high-contrast island on the dark
		   page with unreadable text. Force the fills back to a theme
		   background so dark-mode reads; light mode is intentionally
		   unmodified so the per-layer hierarchy is preserved there. */
		.theme-dark .pict-content pre.mermaid .node rect,
		.theme-dark .pict-content pre.mermaid .node polygon,
		.theme-dark .pict-content pre.mermaid .node circle,
		.theme-dark .pict-content pre.mermaid .node ellipse,
		.theme-dark .pict-content pre.mermaid .node path,
		.theme-dark .pict-content pre.mermaid .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		/* Mirror of the above for theme mode 'system' — when the user
		   hasn't explicitly picked light or dark, the theme provider
		   leaves <html> without .theme-light/.theme-dark and the CSS
		   variables follow prefers-color-scheme. The .theme-dark-prefixed
		   block above doesn't match in that case, so light pastels would
		   win again on dark OSes. Mirror the rule under the media query,
		   gated by :not(.theme-light) so an explicit light override on a
		   dark OS still wins. */
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-content pre.mermaid .node rect,
			html:not(.theme-light) .pict-content pre.mermaid .node polygon,
			html:not(.theme-light) .pict-content pre.mermaid .node circle,
			html:not(.theme-light) .pict-content pre.mermaid .node ellipse,
			html:not(.theme-light) .pict-content pre.mermaid .node path,
			html:not(.theme-light) .pict-content pre.mermaid .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		/* Excalidraw fence placeholders + rendered SVGs */
		.pict-content .pict-excalidraw-fence {
			display: block;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			padding: 1em;
			margin: 1em 0;
			text-align: center;
		}
		.pict-content .pict-excalidraw-fence svg {
			max-width: 100%;
			height: auto;
		}
		.pict-content .pict-excalidraw-fence-loading {
			color: var(--theme-color-text-secondary, #5E5549);
			font-style: italic;
			font-size: 0.9em;
			padding: 1em;
		}
		.pict-content .pict-excalidraw-fence-error {
			border-color: var(--theme-color-status-error, #D9534F);
			background: var(--theme-color-background-secondary, #FFF5F5);
		}
		.pict-content .pict-excalidraw-fence-error-message {
			color: var(--theme-color-status-error, #D9534F);
			font-family: var(--theme-typography-family-mono, monospace);
			font-size: 0.85em;
			text-align: left;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}

		/* Fullscreen viewer for images and mermaid diagrams (click-to-zoom) */
		.pict-content [data-fullscreen-source] {
			cursor: zoom-in;
			outline: 1px solid transparent;
			outline-offset: 3px;
			border-radius: 4px;
			transition: outline-color 0.15s ease;
		}
		.pict-content [data-fullscreen-source]:hover {
			outline-color: var(--theme-color-brand-primary, #2E7D74);
		}
		/* Code block container with hover-revealed action buttons */
		.pict-content-code-container {
			position: relative;
			display: flex;
			align-items: flex-start;
			gap: 8px;
			margin: 1em 0;
		}
		.pict-content-code-container > .pict-content-code-wrap {
			margin: 0;
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-muted, #5E5549);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
		}
		.pict-content-code-action-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-content-code-action-btn.is-copy-failed {
			background: var(--theme-color-status-error, #B23A3A);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-status-error, #B23A3A);
		}
		.pict-fullscreen-overlay {
			position: fixed;
			inset: 0;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			background: rgba(0, 0, 0, 0.62);
			backdrop-filter: blur(6px);
			-webkit-backdrop-filter: blur(6px);
			color: var(--theme-color-text-primary, #2A241E);
		}
		.pict-fullscreen-overlay[hidden] {
			display: none;
		}
		.pict-fullscreen-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1em;
			height: 48px;
			padding: 0 1em;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-primary, #1A1612);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
			flex: 0 0 auto;
		}
		.pict-fullscreen-title {
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 0.95em;
			font-weight: 600;
			letter-spacing: 0.01em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-controls {
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.pict-fullscreen-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			padding: 0;
			background: transparent;
			border: 1px solid transparent;
			border-radius: 6px;
			color: var(--theme-color-text-muted, #5E5549);
			cursor: pointer;
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		}
		.pict-fullscreen-btn svg {
			display: block;
			width: 16px;
			height: 16px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.75;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-fullscreen-btn:hover {
			background: var(--theme-color-border-light, #EAE3D8);
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-fullscreen-close:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
		}
		.pict-fullscreen-stage {
			flex: 1 1 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			padding: 1.5em;
			cursor: zoom-in;
			touch-action: none;
		}
		.pict-fullscreen-stage.is-zoomed {
			cursor: grab;
		}
		.pict-fullscreen-stage.is-panning {
			cursor: grabbing;
		}
		.pict-fullscreen-content {
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 100%;
			max-height: 100%;
			transform-origin: center center;
			transition: transform 0.05s linear;
			will-change: transform;
		}
		.pict-fullscreen-content > * {
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
		.pict-fullscreen-content .pict-fullscreen-img {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			width: auto;
			height: auto;
			object-fit: contain;
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 12px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 16px;
			border-radius: 6px;
		}
		/* Bespoke inline-SVG diagrams (pict-renderer-graph / excalidraw).  Backdrop
		   uses the diagram's own --diagram-paper so the zoomed copy keeps the same
		   theme as the inline one (the host defines --diagram-* on the overlay). */
		.pict-fullscreen-content .pict-fullscreen-diagram-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--diagram-paper, var(--theme-color-background-panel, #FFFFFF));
			padding: 16px;
			border-radius: 6px;
		}
		/* Same dark-mode fill/stroke override as for inline diagrams, but
		   scoped to the fullscreen-overlay clone — which lives under
		   <body>, NOT inside .pict-content, so the pre.mermaid-scoped
		   rules above don't reach it. */
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		/* ---- video (the video fence, and video files written with the image form) ---- */
		.pict-content-video { margin: 18px 0; }
		.pict-content-video figcaption {
			font-size: 13px;
			color: var(--theme-color-text-secondary, #6B6255);
			margin-top: 6px;
		}
		.pict-content-video-file video,
		video.pict-content-video-inline {
			display: block;
			width: 100%;
			max-width: 100%;
			border-radius: 8px;
			background: #000;
		}
		/* The click-to-load card. It carries the whole clickable area, so a reader is never hunting for a
		   small play button, and it looks like a player rather than a link so nobody wonders what it is. */
		.pict-content-video-card {
			position: relative;
			display: flex;
			align-items: center;
			gap: 14px;
			padding: 16px 18px;
			min-height: 96px;
			text-decoration: none;
			border-radius: 8px;
			overflow: hidden;
			background: var(--theme-color-background-tertiary, #211C17);
			border: 1px solid var(--theme-color-border-default, #5E5549);
			color: var(--theme-color-text-primary, #F0EAE0);
		}
		.pict-content-video-card:hover { border-color: var(--theme-color-brand-primary, #C89B3C); }
		.pict-content-video-poster {
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			opacity: 0.45;
		}
		.pict-content-video-play { position: relative; flex: 0 0 auto; line-height: 0; }
		.pict-content-video-play-bg { fill: #212121; opacity: 0.85; }
		.pict-content-video-card:hover .pict-content-video-play-bg { fill: #cc0000; opacity: 1; }
		.pict-content-video-label { position: relative; display: flex; flex-direction: column; gap: 3px; min-width: 0; }
		.pict-content-video-title {
			font-weight: 600;
			font-size: 15px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.pict-content-video-source { font-size: 12px; color: var(--theme-color-text-secondary, #A69B8B); }
		.pict-content-video-frame {
			display: block;
			width: 100%;
			aspect-ratio: 16 / 9;
			border: 0;
			border-radius: 8px;
			background: #000;
		}
		.pict-content-video-empty figcaption {
			padding: 12px 14px;
			border: 1px dashed var(--theme-color-border-default, #5E5549);
			border-radius: 8px;
			margin-top: 0;
		}
		.pict-fullscreen-content .pict-fullscreen-codewrap {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			margin: 0;
			overflow: auto;
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
	`;

},{}],196:[function(require,module,exports){
// The container for all the Pict-Section-Content related code.

// The main content view class
module.exports = require('./views/Pict-View-Content.js');

// The content provider (markdown parsing, HTML escaping)
module.exports.PictContentProvider = require('./providers/Pict-Provider-Content.js');

// A thin demo view that auto-registers the provider, reads markdown
// from an AppData address, and pushes parsed HTML through the base
// view's displayContent pipeline.  Used by the docuserve playground;
// host applications can pick it up too if they just want "render this
// markdown blob" without writing the parse-and-display glue.
module.exports.PictContentDemoView = require('./views/PictView-Content-Demo.js');

},{"./providers/Pict-Provider-Content.js":197,"./views/Pict-View-Content.js":198,"./views/PictView-Content-Demo.js":199}],197:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libCreateHighlighter = require('pict-section-code').createHighlighter;

const libContentCSS = require('../Pict-Content-CSS.js');

/**
 * Content Provider for Pict Section Content
 *
 * A general-purpose markdown-to-HTML parser with support for:
 * - Headings, paragraphs, lists, blockquotes, horizontal rules
 * - Fenced code blocks with language tags (nested fence support)
 * - Syntax highlighting and line numbers for code blocks (via pict-section-code)
 * - Tables (GFM pipe syntax)
 * - Mermaid diagram blocks
 * - KaTeX math (inline and display)
 * - Bold, italic, inline code, links, images
 *
 * Link resolution is customizable via an optional callback.
 */
class PictContentProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Register the content CSS at the PROVIDER layer. parseMarkdown emits the
		// .pict-content-code-wrap markup (a line-number gutter + a <pre>), and that CSS makes the
		// wrap a flex row so the numbers sit to the LEFT of the code. Consumers like the
		// inline-documentation reader use this provider WITHOUT instantiating the view, so the
		// view's CSS never shipped and the numbers stacked ABOVE the code -- the recurring bug.
		// Registering here fixes it for every consumer; the view uses the same hash, so it still
		// injects only once. (pict CLAUDE.md: providers must addCSS() themselves.)
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Content-CSS', libContentCSS, 500);
		}
	}

	/**
	 * Highlight a code string using pict-section-code's syntax highlighter.
	 * Uses a mock element to interface with the highlighter's DOM-based API.
	 *
	 * @param {string} pCode - The raw code string
	 * @param {string} pLanguage - The language identifier (e.g. "javascript", "html")
	 * @returns {string} The syntax-highlighted HTML
	 */
	highlightCode(pCode, pLanguage)
	{
		if (!pCode)
		{
			return '';
		}

		let tmpHighlighter = libCreateHighlighter(pLanguage);
		// Create a mock element to interface with the highlighter
		let tmpMockElement = { textContent: pCode, innerHTML: '' };
		tmpHighlighter(tmpMockElement);
		return tmpMockElement.innerHTML;
	}

	/**
	 * Generate line number HTML for a code block.
	 *
	 * @param {string} pCode - The raw code string
	 * @returns {string} HTML string with line number spans
	 */
	generateLineNumbers(pCode)
	{
		if (!pCode)
		{
			return '<span>1</span>';
		}

		let tmpLineCount = pCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += '<span>' + i + '</span>';
		}

		return tmpHTML;
	}

	/**
	 * Parse a markdown string into HTML.
	 *
	 * @param {string} pMarkdown - The raw markdown text
	 * @param {Function} [pLinkResolver] - Optional callback for link resolution: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback for image URL resolution: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. Passed through to parseInline() for vocabulary term auto-linking.
	 * @returns {string} The parsed HTML
	 */
	parseMarkdown(pMarkdown, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pMarkdown)
		{
			return '';
		}

		let tmpLines = pMarkdown.split('\n');
		let tmpHTML = [];
		let tmpInCodeBlock = false;
		let tmpCodeFenceLength = 0;
		let tmpCodeLang = '';
		let tmpCodeLines = [];
		let tmpInList = false;
		let tmpListType = '';
		let tmpInBlockquote = false;
		let tmpBlockquoteLines = [];
		let tmpInMathBlock = false;
		let tmpMathLines = [];
		let tmpParagraphLines = [];

		// Helper to flush accumulated paragraph lines into a single <p> tag
		let fFlushParagraph = () =>
		{
			if (tmpParagraphLines.length > 0)
			{
				tmpHTML.push('<p>' + tmpParagraphLines.map((pLine) => { return this.parseInline(pLine, pLinkResolver, pImageResolver, pVocabularyResolver); }).join(' ') + '</p>');
				tmpParagraphLines = [];
			}
		};

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			// Display math blocks ($$...$$) — skip if inside a code block
			if (!tmpInCodeBlock && tmpLine.trim().match(/^\$\$/))
			{
				if (tmpInMathBlock)
				{
					// End math block
					tmpHTML.push('<div class="pict-content-katex-display">' + tmpMathLines.join('\n') + '</div>');
					tmpInMathBlock = false;
					tmpMathLines = [];
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					tmpInMathBlock = true;
				}
				continue;
			}

			if (tmpInMathBlock)
			{
				tmpMathLines.push(tmpLine);
				continue;
			}

			// Code blocks (fenced) — track fence length so ````x```` nests around ```y```
			let tmpFenceMatch = tmpLine.match(/^(`{3,})/);
			if (tmpFenceMatch)
			{
				let tmpFenceLen = tmpFenceMatch[1].length;

				if (tmpInCodeBlock)
				{
					// Only close if the closing fence is at least as long as the opening
					if (tmpFenceLen >= tmpCodeFenceLength && tmpLine.trim() === tmpFenceMatch[1])
					{
						// End code block
						if (tmpCodeLang === 'mermaid')
						{
							// Mermaid diagrams: output raw content for client-side rendering
							tmpHTML.push('<pre class="mermaid">' + tmpCodeLines.join('\n') + '</pre>');
						}
						else if (tmpCodeLang === 'video')
						{
							// Video: one fence, two outcomes, decided by where the video lives.
							// Self-hosted (a relative URL, or a file with a video extension) plays inline;
							// a third-party watch page becomes a click-to-load card. See videoEmbedHTML.
							tmpHTML.push(this.videoEmbedHTML(tmpCodeLines.join('\n')));
						}
						else if (tmpCodeLang === 'excalidraw')
						{
							// Excalidraw scenes: emit a placeholder div with the
							// scene JSON URI-component encoded into a data
							// attribute.  Pict-View-Content's
							// renderExcalidrawDiagrams() swaps these for rendered
							// SVGs once the wrapper bundle is ready.  We don't
							// validate the JSON here — invalid fences just stay
							// as the loading placeholder until the runtime
							// reports the error.
							let tmpRawScene = tmpCodeLines.join('\n');
							let tmpEncoded;
							try { tmpEncoded = encodeURIComponent(tmpRawScene); }
							catch (pErr) { tmpEncoded = ''; }
							tmpHTML.push('<div class="pict-excalidraw-fence" data-scene="' + tmpEncoded + '">' +
								'<div class="pict-excalidraw-fence-loading">Rendering Excalidraw diagram…</div>' +
								'</div>');
						}
						else
						{
							let tmpCodeText = tmpCodeLines.join('\n');
						let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
						let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
						tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code class="language-' + this.escapeHTML(tmpCodeLang) + '">' + tmpHighlightedCode + '</code></pre></div>');
						}
						tmpInCodeBlock = false;
						tmpCodeFenceLength = 0;
						tmpCodeLang = '';
						tmpCodeLines = [];
						continue;
					}
					else
					{
						// Inner fence with fewer backticks — treat as content
						tmpCodeLines.push(tmpLine);
						continue;
					}
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					// Start code block — record fence length
					tmpCodeFenceLength = tmpFenceLen;
					tmpCodeLang = tmpLine.replace(/^`{3,}/, '').trim();
					tmpInCodeBlock = true;
					continue;
				}
			}

			if (tmpInCodeBlock)
			{
				tmpCodeLines.push(tmpLine);
				continue;
			}

			// Blockquotes
			if (tmpLine.match(/^>\s?/))
			{
				if (!tmpInBlockquote)
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					tmpInBlockquote = true;
					tmpBlockquoteLines = [];
				}
				tmpBlockquoteLines.push(tmpLine.replace(/^>\s?/, ''));
				continue;
			}
			else if (tmpInBlockquote)
			{
				tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
				tmpInBlockquote = false;
				tmpBlockquoteLines = [];
			}

			// Horizontal rule
			if (tmpLine.match(/^(-{3,}|\*{3,}|_{3,})\s*$/))
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				tmpHTML.push('<hr>');
				continue;
			}

			// Headings
			let tmpHeadingMatch = tmpLine.match(/^(#{1,6})\s+(.+)/);
			if (tmpHeadingMatch)
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				let tmpLevel = tmpHeadingMatch[1].length;
				let tmpText = this.parseInline(tmpHeadingMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver);
				let tmpID = tmpHeadingMatch[2].toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
				tmpHTML.push('<h' + tmpLevel + ' id="' + tmpID + '">' + tmpText + '</h' + tmpLevel + '>');
				continue;
			}

			// Unordered list items
			let tmpULMatch = tmpLine.match(/^(\s*)[-*+]\s+(.*)/);
			if (tmpULMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ul')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ul>');
					tmpInList = true;
					tmpListType = 'ul';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpULMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Ordered list items
			let tmpOLMatch = tmpLine.match(/^(\s*)\d+\.\s+(.*)/);
			if (tmpOLMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ol')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ol>');
					tmpInList = true;
					tmpListType = 'ol';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpOLMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Indented continuation line of a wrapped list item — fold its
			// content into the last <li> instead of closing the list. Closing
			// here would split a real <ol>/<ul>, and each fragment restarts
			// ordered numbering. A non-indented non-marker line still closes
			// the list (handled below); blank lines never reach this branch.
			if (tmpInList && tmpLine.match(/^\s+\S/) && tmpHTML.length > 0 && tmpHTML[tmpHTML.length - 1].endsWith('</li>'))
			{
				let tmpLastIndex = tmpHTML.length - 1;
				let tmpListItemBody = tmpHTML[tmpLastIndex].slice(0, -'</li>'.length);
				tmpHTML[tmpLastIndex] = tmpListItemBody + ' ' + this.parseInline(tmpLine.trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>';
				continue;
			}

			// Close list if we've left list items
			if (tmpInList && tmpLine.trim() !== '')
			{
				tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
				tmpInList = false;
			}

			// Empty line — flush any accumulated paragraph
			if (tmpLine.trim() === '')
			{
				fFlushParagraph();
				continue;
			}

			// Table detection
			if (tmpLine.match(/^\|/) && i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|[\s-:|]+\|/))
			{
				fFlushParagraph();
				// Close any open list
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}

				let tmpTableHTML = '<table>';

				// Header row
				let tmpHeaders = tmpLine.split('|').filter((pCell) => { return pCell.trim() !== ''; });
				tmpTableHTML += '<thead><tr>';
				for (let h = 0; h < tmpHeaders.length; h++)
				{
					tmpTableHTML += '<th>' + this.parseInline(tmpHeaders[h].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</th>';
				}
				tmpTableHTML += '</tr></thead>';

				// Skip separator row
				i++;

				// Body rows
				tmpTableHTML += '<tbody>';
				while (i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|/))
				{
					i++;
					let tmpCells = tmpLines[i].split('|').filter((pCell) => { return pCell.trim() !== ''; });
					tmpTableHTML += '<tr>';
					for (let c = 0; c < tmpCells.length; c++)
					{
						tmpTableHTML += '<td>' + this.parseInline(tmpCells[c].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</td>';
					}
					tmpTableHTML += '</tr>';
				}
				tmpTableHTML += '</tbody></table>';
				tmpHTML.push(tmpTableHTML);
				continue;
			}

			// Accumulate paragraph lines — consecutive non-blank text lines
			// will be joined into a single <p> tag when flushed
			tmpParagraphLines.push(tmpLine);
		}

		// Flush any remaining accumulated paragraph
		fFlushParagraph();

		// Close any trailing open elements
		if (tmpInList)
		{
			tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
		}
		if (tmpInBlockquote)
		{
			tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
		}
		if (tmpInCodeBlock)
		{
			let tmpCodeText = tmpCodeLines.join('\n');
			let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
			let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
			tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code>' + tmpHighlightedCode + '</code></pre></div>');
		}

		return tmpHTML.join('\n');
	}

	/**
	 * Parse inline markdown elements (bold, italic, code, links, images, KaTeX).
	 *
	 * @param {string} pText - The text to parse
	 * @param {Function} [pLinkResolver] - Optional callback: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. When provided, known vocabulary terms in the rendered text are wrapped in <span class="pict-vocab-term"> with data attributes carrying the popover content.
	 * @returns {string} HTML with inline elements
	 */
	parseInline(pText, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pText)
		{
			return '';
		}

		let tmpResult = pText;

		// Extract inline code spans into placeholders so bold/italic regexes don't mangle their contents
		let tmpCodeSpans = [];
		tmpResult = tmpResult.replace(/`([^`]+)`/g, (pMatch, pCode) =>
		{
			let tmpIndex = tmpCodeSpans.length;
			tmpCodeSpans.push('<code>' + pCode + '</code>');
			return '\x00CODEINLINE' + tmpIndex + '\x00';
		});

		// Inline LaTeX equations ($...$) — must be processed before other inline patterns
		// Match single $ delimiters that aren't adjacent to spaces (to avoid false positives with currency)
		tmpResult = tmpResult.replace(/\$([^\$\s][^\$]*?[^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');
		// Also match single-character inline math like $x$
		tmpResult = tmpResult.replace(/\$([^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');

		// Images
		tmpResult = tmpResult.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (pMatch, pAlt, pSrc) =>
		{
			let tmpSrc = pSrc;
			if (typeof pImageResolver === 'function')
			{
				let tmpResolved = pImageResolver(pSrc, pAlt);
				if (tmpResolved)
				{
					tmpSrc = tmpResolved;
				}
			}
			// A video file written with the image form. Authors reach for `![clip](demo.mp4)` because it is
			// the syntax their fingers know, and an <img> pointed at an mp4 is a broken image icon -- so it
			// renders a player instead. Only a real video EXTENSION qualifies; see hasVideoExtension.
			if (this.hasVideoExtension(tmpSrc) && this.isSafeMediaURL(tmpSrc))
			{
				return '<video class="pict-content-video-inline" controls preload="metadata" src="' + this.escapeHTML(tmpSrc) + '">' +
					'<a href="' + this.escapeHTML(tmpSrc) + '">' + this.escapeHTML(pAlt || 'Download the video') + '</a></video>';
			}
			return '<img src="' + tmpSrc + '" alt="' + pAlt + '">';
		});

		// Links
		tmpResult = tmpResult.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (pMatch, pLinkText, pHref) =>
		{
			if (typeof pLinkResolver === 'function')
			{
				let tmpResolved = pLinkResolver(pHref, pLinkText);
				if (tmpResolved)
				{
					let tmpTarget = tmpResolved.target ? ' target="' + tmpResolved.target + '"' : '';
					let tmpRel = tmpResolved.rel ? ' rel="' + tmpResolved.rel + '"' : '';
					return '<a href="' + tmpResolved.href + '"' + tmpTarget + tmpRel + '>' + pLinkText + '</a>';
				}
			}
			// Default behavior: external links open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return '<a href="' + pHref + '" target="_blank" rel="noopener">' + pLinkText + '</a>';
			}
			return '<a href="' + pHref + '">' + pLinkText + '</a>';
		});

		// Bold
		tmpResult = tmpResult.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
		// Underscore strong only at word boundaries (CommonMark intraword rule) so
		// identifiers / URLs like a__b or foo__bar aren't treated as emphasis.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])__([^_]+?)__(?![A-Za-z0-9_])/g, '$1<strong>$2</strong>');

		// Italic
		tmpResult = tmpResult.replace(/\*([^*]+)\*/g, '<em>$1</em>');
		// Underscore italic only at word boundaries — a single underscore inside a
		// word or a URL (e.g. hello_world in a link href) must NOT become <em>.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])_([^_]+?)_(?![A-Za-z0-9_])/g, '$1<em>$2</em>');

		// Restore inline code spans from placeholders
		tmpResult = tmpResult.replace(/\x00CODEINLINE(\d+)\x00/g, (pMatch, pIndex) =>
		{
			return tmpCodeSpans[parseInt(pIndex)];
		});

		// Vocabulary term auto-linking: scan the rendered text for
		// known vocabulary terms and wrap each first occurrence in a
		// span with data attributes for the popover system. Skips
		// content inside <code>, <a>, <pre>, and <strong> tags to
		// avoid mangling links, code, or already-emphasized text.
		if (typeof pVocabularyResolver === 'function')
		{
			tmpResult = this._applyVocabularyLinks(tmpResult, pVocabularyResolver);
		}

		return tmpResult;
	}

	/**
	 * Scan HTML for vocabulary terms and wrap the first occurrence
	 * of each in a <span class="pict-vocab-term"> element. The
	 * resolver callback is called for each candidate word/phrase
	 * and returns { slug, title, short } if it's a known term.
	 *
	 * Skips content inside HTML tags to avoid breaking links,
	 * code spans, and other markup.
	 *
	 * @param {string} pHTML
	 * @param {Function} pResolver - (word) => {slug, title, short} | null
	 * @returns {string}
	 */
	_applyVocabularyLinks(pHTML, pResolver)
	{
		if (!pHTML || typeof pResolver !== 'function')
		{
			return pHTML;
		}

		// Track which terms we've already linked to avoid duplicate
		// links for the same term appearing multiple times.
		let tmpLinked = {};

		// Split the HTML into segments: tags vs text nodes. We only
		// scan text nodes for vocabulary terms; tags pass through.
		// This regex captures HTML tags as separators.
		let tmpParts = pHTML.split(/(<[^>]+>)/g);

		// Track whether we're inside a tag that should be skipped
		let tmpSkipDepth = 0;
		let tmpSkipTags = ['code', 'a', 'pre', 'span'];

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];

			// Check if this is an HTML tag
			if (tmpPart.charAt(0) === '<')
			{
				// Opening tag?
				let tmpOpenMatch = tmpPart.match(/^<(\w+)/);
				if (tmpOpenMatch && tmpSkipTags.indexOf(tmpOpenMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth++;
				}
				// Closing tag?
				let tmpCloseMatch = tmpPart.match(/^<\/(\w+)/);
				if (tmpCloseMatch && tmpSkipTags.indexOf(tmpCloseMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth = Math.max(0, tmpSkipDepth - 1);
				}
				continue; // Don't modify tags
			}

			// Skip text inside protected elements
			if (tmpSkipDepth > 0) continue;

			// Scan this text node for vocabulary terms. Use word
			// boundary regex to match whole words only.
			tmpParts[i] = tmpPart.replace(/\b([A-Za-z][A-Za-z0-9_-]{1,30})\b/g, (pMatch, pWord) =>
			{
				// Skip very short words and common English words
				if (pWord.length < 3) return pMatch;

				let tmpLower = pWord.toLowerCase();
				if (tmpLinked[tmpLower]) return pMatch; // already linked

				let tmpResult = pResolver(tmpLower);
				if (!tmpResult) return pMatch;

				tmpLinked[tmpLower] = true;
				let tmpShortEsc = (tmpResult.short || '').replace(/"/g, '&quot;');
				return '<span class="pict-vocab-term" data-vocab-slug="' + tmpResult.slug +
					'" data-vocab-title="' + (tmpResult.title || '').replace(/"/g, '&quot;') +
					'" data-vocab-short="' + tmpShortEsc + '">' + pMatch + '</span>';
			});
		}

		return tmpParts.join('');
	}

	/**
	 * The file extensions that mean "these bytes ARE the video", as opposed to a page about one.
	 */
	static get VIDEO_EXTENSIONS()
	{
		return ['mp4', 'webm', 'ogv', 'ogg', 'mov', 'm4v'];
	}

	/**
	 * Recognize a third-party video URL and return { Provider, Embed, Watch }, or null when the URL is not
	 * one this knows how to embed.
	 *
	 * Only YouTube and Vimeo are recognized on purpose: an embed is a third party running code in the
	 * reader's page, so the set of parties allowed to do that is a list, not a guess.
	 *
	 * @param {string} pURL
	 * @returns {Object|null}
	 */
	videoProviderFor(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		let tmpYouTube = tmpURL.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
		if (tmpYouTube)
		{
			// youtube-nocookie.com is the same player without the tracking cookies it would otherwise set
			// the moment the frame loads.
			return {
				Provider: 'YouTube',
				Embed: 'https://www.youtube-nocookie.com/embed/' + tmpYouTube[1] + '?autoplay=1&rel=0',
				Watch: 'https://www.youtube.com/watch?v=' + tmpYouTube[1]
			};
		}
		let tmpVimeo = tmpURL.match(/vimeo\.com\/(?:video\/)?(\d{6,})/);
		if (tmpVimeo)
		{
			return {
				Provider: 'Vimeo',
				Embed: 'https://player.vimeo.com/video/' + tmpVimeo[1] + '?autoplay=1',
				Watch: 'https://vimeo.com/' + tmpVimeo[1]
			};
		}
		return null;
	}

	/**
	 * Is this URL safe to put in an href or a src? Only http(s) and same-document relative URLs are, which
	 * is what keeps a javascript: or data: URL in a document from becoming script when a reader clicks it.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	isSafeMediaURL(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		if (!tmpURL) { return false; }
		if (/^https?:\/\//i.test(tmpURL)) { return true; }
		// A relative or root-relative path: same origin by construction, so it carries the document's own
		// trust. Anything with a scheme that is not http(s) is refused.
		return !/^[A-Za-z][A-Za-z0-9+.-]*:/.test(tmpURL);
	}

	/**
	 * Does this URL end in a video file extension? Strictly the extension, nothing inferred.
	 *
	 * The inline image form uses THIS rather than isDirectVideoURL: in a ```video fence the author has
	 * already said the thing is a video, so a relative URL can be taken at its word, but `![logo](/img/x)`
	 * is an image and treating every extensionless relative source as video would turn the whole media
	 * library into broken players.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	hasVideoExtension(pURL)
	{
		let tmpPath = String(pURL || '').trim().split('?')[0].split('#')[0];
		return PictContentProvider.VIDEO_EXTENSIONS.indexOf((tmpPath.split('.').pop() || '').toLowerCase()) >= 0;
	}

	/**
	 * Does this URL point at video BYTES rather than a page about a video?
	 *
	 * A known video extension says yes. So does any relative URL: those are served by the application
	 * itself, which is how an uploaded recording is addressed (a blob route often carries no extension at
	 * all), and the application does not serve watch pages to its own markdown.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	isDirectVideoURL(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		if (!tmpURL) { return false; }
		if (this.hasVideoExtension(tmpURL)) { return true; }
		return !/^https?:\/\//i.test(tmpURL);
	}

	/**
	 * The HTML for a ```video fence.
	 *
	 * Body shape: the URL on the first non-empty line, then optional `key: value` lines (title, poster).
	 *
	 *     ```video
	 *     https://www.youtube.com/watch?v=abc123
	 *     title: How the deploy pipeline works
	 *     poster: /1.0/Media/42/Blob
	 *     ```
	 *
	 * Two outcomes, decided by where the video lives:
	 *
	 * - Self-hosted (relative URL, or a file with a video extension) renders a plain <video controls
	 *   preload="metadata">. The bytes come from the same place the page did, so there is nothing to
	 *   consent to, and preload="metadata" paints the real first frame as its own thumbnail.
	 * - A third-party watch page renders a CLICK-TO-LOAD card. Nothing is fetched from that party until the
	 *   reader asks for it -- not the player, and not the poster image either, since fetching a thumbnail
	 *   from the provider would leak the reader to them exactly as the player does. A poster is shown only
	 *   when the author supplied one. Without JavaScript the card is still a working link to the video,
	 *   which is what a server-rendered or printed copy of the document falls back to.
	 *
	 * @param {string} pBody - The fence contents
	 * @returns {string} The HTML
	 */
	videoEmbedHTML(pBody)
	{
		let tmpLines = String(pBody || '').split('\n').map((pLine) => { return pLine.trim(); }).filter((pLine) => { return pLine.length > 0; });
		if (!tmpLines.length)
		{
			return '<figure class="pict-content-video pict-content-video-empty"><figcaption>No video URL was given.</figcaption></figure>';
		}
		let tmpURL = tmpLines[0];
		let tmpOptions = {};
		for (let i = 1; i < tmpLines.length; i++)
		{
			let tmpMatch = tmpLines[i].match(/^([A-Za-z][A-Za-z0-9_-]*)\s*:\s*(.*)$/);
			if (tmpMatch) { tmpOptions[tmpMatch[1].toLowerCase()] = tmpMatch[2].trim(); }
		}
		if (!this.isSafeMediaURL(tmpURL))
		{
			return '<figure class="pict-content-video pict-content-video-empty"><figcaption>That video link was not a http(s) or relative URL.</figcaption></figure>';
		}

		let tmpTitle = tmpOptions.title || '';
		let tmpPoster = (tmpOptions.poster && this.isSafeMediaURL(tmpOptions.poster)) ? tmpOptions.poster : '';
		// The caption belongs under a PLAYER, which has nowhere else to say what it is. A card already
		// carries the title inside it, so captioning that one prints the same sentence twice.
		let tmpCaption = tmpTitle ? ('<figcaption>' + this.escapeHTML(tmpTitle) + '</figcaption>') : '';

		if (this.isDirectVideoURL(tmpURL))
		{
			return '<figure class="pict-content-video pict-content-video-file">' +
				'<video controls preload="metadata" src="' + this.escapeHTML(tmpURL) + '"' +
				(tmpPoster ? (' poster="' + this.escapeHTML(tmpPoster) + '"') : '') + '>' +
				'<a href="' + this.escapeHTML(tmpURL) + '">' + this.escapeHTML(tmpTitle || 'Download the video') + '</a>' +
				'</video>' + tmpCaption + '</figure>';
		}

		let tmpProvider = this.videoProviderFor(tmpURL);
		let tmpWatch = tmpProvider ? tmpProvider.Watch : tmpURL;
		let tmpLabel = tmpProvider
			? (tmpProvider.Provider + ' - plays from ' + tmpProvider.Provider + ' when you start it')
			: 'Opens in a new tab';
		// data-embed is what the view swaps in on click. A card with no data-embed (an unrecognized site)
		// stays a link, which is the honest outcome: this cannot promise to embed a page it does not know.
		return '<figure class="pict-content-video pict-content-video-embed"' +
			(tmpProvider ? (' data-embed="' + this.escapeHTML(tmpProvider.Embed) + '"') : '') +
			' data-provider="' + this.escapeHTML(tmpProvider ? tmpProvider.Provider : 'link') + '">' +
			'<a class="pict-content-video-card" href="' + this.escapeHTML(tmpWatch) + '" target="_blank" rel="noopener noreferrer">' +
			(tmpPoster ? ('<img class="pict-content-video-poster" src="' + this.escapeHTML(tmpPoster) + '" alt="">') : '') +
			'<span class="pict-content-video-play" aria-hidden="true">' +
			'<svg viewBox="0 0 68 48" width="54" height="38"><path class="pict-content-video-play-bg" d="M66.5 7.7a8 8 0 0 0-5.6-5.7C55.9.6 34 .6 34 .6s-21.9 0-26.9 1.4a8 8 0 0 0-5.6 5.7A83 83 0 0 0 .1 24a83 83 0 0 0 1.4 16.3 8 8 0 0 0 5.6 5.7c5 1.4 26.9 1.4 26.9 1.4s21.9 0 26.9-1.4a8 8 0 0 0 5.6-5.7A83 83 0 0 0 67.9 24a83 83 0 0 0-1.4-16.3z"/><path d="M27 34V14l18 10z" fill="#fff"/></svg>' +
			'</span>' +
			'<span class="pict-content-video-label">' +
			'<span class="pict-content-video-title">' + this.escapeHTML(tmpTitle || tmpWatch) + '</span>' +
			'<span class="pict-content-video-source">' + this.escapeHTML(tmpLabel) + '</span>' +
			'</span></a></figure>';
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = PictContentProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Pict-Content",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"../Pict-Content-CSS.js":195,"pict-provider":177,"pict-section-code":189}],198:[function(require,module,exports){
const libPictView = require('pict-view');

const libContentCSS = require('../Pict-Content-CSS.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	AutoRender: false,

	// Shared with the provider under one hash so the CSS injects once whether the view, the
	// provider (parseMarkdown), or both are used.
	CSS: libContentCSS,
	CSSHash: 'Pict-Section-Content-CSS',

	Templates:
	[
		{
			Hash: "Pict-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Pict-Content-Body">
	<div class="pict-content-loading">Loading content...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Pict-Content-Display",
			TemplateHash: "Pict-Content-Template",
			DestinationAddress: "#Pict-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class PictContentView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	displayContent(pHTMLContent, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';

		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, pHTMLContent);

		// Scroll to top of content area
		let tmpContentContainer = document.getElementById(tmpContainerID);
		if (tmpContentContainer && tmpContentContainer.parentElement)
		{
			tmpContentContainer.parentElement.scrollTop = 0;
		}

		// Ensure the container carries the `.pict-content` class so the
		// 30+ theme-scoped CSS rules below (`.pict-content a`, `.pict-content
		// h1`, `.pict-content pre`, ...) actually match when a host passes
		// a custom container ID.  Idempotent — re-adding the class is a
		// no-op if it's already there from the host's markup.
		if (tmpContentContainer && !tmpContentContainer.classList.contains('pict-content'))
		{
			tmpContentContainer.classList.add('pict-content');
		}

		// Tag images and code blocks immediately so they're clickable.
		// Mermaid blocks are tagged after mermaid.run() resolves (see below).
		this.enableFullscreenViewers(tmpContainerID, { skipMermaid: true });

		// Post-render: initialize Mermaid diagrams if mermaid is available.
		// Once mermaid finishes, retag so the rendered SVGs are also clickable.
		this.renderMermaidDiagrams(tmpContainerID);

		// Post-render: render ```excalidraw fenced scenes if the
		// pict-section-excalidraw wrapper bundle is loaded.  Each fence
		// becomes a static SVG (with the scene embedded for re-edit by
		// retold-content-system).
		this.renderExcalidrawDiagrams(tmpContainerID);

		// Post-render: make ```video cards for third-party players click-to-load.
		this.hydrateVideoEmbeds(tmpContainerID);

		// Post-render: render KaTeX equations if katex is available
		this.renderKaTeXEquations(tmpContainerID);
	}

	/**
	 * Wire the click-to-load video cards the markdown parser emitted for third-party players.
	 *
	 * Until a reader clicks, nothing has been requested from the provider: no player, no cookies, no
	 * thumbnail, no record that this document was opened. The click is the consent, and only then is the
	 * iframe created. This is the whole reason the card exists rather than an iframe -- an embed that loads
	 * with the page has already told a third party who is reading before anyone chose anything.
	 *
	 * Degrades to a link. With no JavaScript, or before this runs, the card is an anchor to the video, which
	 * is what a server-rendered or printed copy of a document is left with.
	 *
	 * Idempotent: a hydrated figure carries data-hydrated, so a re-render does not double-bind.
	 *
	 * @param {string} [pContainerID]
	 */
	hydrateVideoEmbeds(pContainerID)
	{
		if (typeof document === 'undefined') { return; }
		let tmpContainer = pContainerID ? document.getElementById(String(pContainerID).replace(/^#/, '')) : document;
		if (!tmpContainer) { return; }
		let tmpFigures = tmpContainer.querySelectorAll('.pict-content-video-embed[data-embed]:not([data-hydrated])');
		for (let i = 0; i < tmpFigures.length; i++)
		{
			let tmpFigure = tmpFigures[i];
			tmpFigure.setAttribute('data-hydrated', 'true');
			let tmpCard = tmpFigure.querySelector('.pict-content-video-card');
			if (!tmpCard) { continue; }
			tmpCard.addEventListener('click', (pEvent) =>
			{
				// A modified click is the reader asking for a new tab; leave the anchor to do that.
				if (pEvent.metaKey || pEvent.ctrlKey || pEvent.shiftKey || pEvent.altKey || pEvent.button > 0) { return; }
				pEvent.preventDefault();
				let tmpEmbed = tmpFigure.getAttribute('data-embed') || '';
				if (!tmpEmbed) { return; }
				let tmpFrame = document.createElement('iframe');
				tmpFrame.setAttribute('src', tmpEmbed);
				tmpFrame.setAttribute('title', (tmpFigure.querySelector('.pict-content-video-title') || {}).textContent || 'Video');
				tmpFrame.setAttribute('frameborder', '0');
				tmpFrame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
				tmpFrame.setAttribute('allowfullscreen', 'allowfullscreen');
				// The player gets no referrer: which document someone watched a video from is not the
				// provider's business, and nothing about playback needs it.
				tmpFrame.setAttribute('referrerpolicy', 'no-referrer');
				tmpFrame.className = 'pict-content-video-frame';
				tmpCard.parentNode.replaceChild(tmpFrame, tmpCard);
			});
		}
	}

	/**
	 * Render any `.pict-excalidraw-fence` placeholders inside the container
	 * as static SVGs using the pict-section-excalidraw wrapper bundle's
	 * exportToSvg helper.  Each fence's scene JSON travels through a
	 * URI-component-encoded data-scene attribute (placed there by the
	 * markdown parser in Pict-Provider-Content).
	 *
	 * Gracefully degrades when the wrapper bundle isn't on the page:
	 * leaves the loading placeholder visible with a one-time console hint.
	 * Idempotent — placeholders carry `data-rendered="true"` after the
	 * first pass so re-renders don't double-emit.
	 *
	 * @param {string} [pContainerID]
	 */
	renderExcalidrawDiagrams(pContainerID)
	{
		if (typeof document === 'undefined') return;

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody) return;

		let tmpFences = tmpContentBody.querySelectorAll('.pict-excalidraw-fence:not([data-rendered])');
		if (tmpFences.length < 1) return;

		let tmpVendor = (typeof window !== 'undefined') ? window.PictSectionExcalidrawVendor : null;
		if (!tmpVendor || typeof tmpVendor.exportToSvg !== 'function')
		{
			// Bundle not loaded — leave the placeholder visible.  The host
			// can load the wrapper bundle and call renderExcalidrawDiagrams
			// again, or include the script tag in its HTML shell.
			if (this.log && this.log.warn && !this._excalidrawBundleWarnLogged)
			{
				this.log.warn('pict-excalidraw fence(s) found but pict-section-excalidraw wrapper bundle is not loaded — leaving as placeholders.');
				this._excalidrawBundleWarnLogged = true;
			}
			return;
		}

		for (let i = 0; i < tmpFences.length; i++)
		{
			let tmpFence = tmpFences[i];
			let tmpEncoded = tmpFence.getAttribute('data-scene') || '';
			let tmpJson = '';
			try { tmpJson = decodeURIComponent(tmpEncoded); }
			catch (pErr) { tmpJson = ''; }

			let tmpScene;
			try { tmpScene = JSON.parse(tmpJson); }
			catch (pErr)
			{
				this._renderExcalidrawFenceError(tmpFence, 'Invalid scene JSON: ' + pErr.message);
				continue;
			}

			let tmpExportArgs = {
				elements: tmpScene.elements || [],
				appState: Object.assign({ exportEmbedScene: true }, tmpScene.appState || {}),
				files:    tmpScene.files    || {}
			};

			tmpVendor.exportToSvg(tmpExportArgs).then((pSvgEl) =>
			{
				if (!pSvgEl) return;
				// Style the SVG to fit the fence's content width while preserving aspect.
				pSvgEl.removeAttribute('width');
				pSvgEl.removeAttribute('height');
				pSvgEl.setAttribute('style', 'max-width: 100%; height: auto;');
				tmpFence.innerHTML = '';
				tmpFence.appendChild(pSvgEl);
				tmpFence.setAttribute('data-rendered', 'true');
			}).catch((pErr) =>
			{
				this._renderExcalidrawFenceError(tmpFence,
					'Excalidraw render failed: ' + (pErr && pErr.message ? pErr.message : pErr));
			});
		}
	}

	_renderExcalidrawFenceError(pFence, pMessage)
	{
		pFence.setAttribute('data-rendered', 'true');
		pFence.classList.add('pict-excalidraw-fence-error');
		pFence.innerHTML = '<div class="pict-excalidraw-fence-error-message"></div>';
		// Use textContent on the inner div so any user-supplied error
		// substrings (e.g. parser error positions) can't introduce HTML.
		let tmpMsg = pFence.querySelector('.pict-excalidraw-fence-error-message');
		if (tmpMsg) tmpMsg.textContent = pMessage;
		if (this.log && this.log.warn) this.log.warn('pict-excalidraw fence: ' + pMessage);
	}

	/**
	 * Lazily wire mermaid into the active pict-provider-theme via the
	 * shared Theme-Diagram-Adapter. The adapter handles:
	 *   - mermaid.initialize() with the canonical pict token map
	 *   - onApply subscription (re-init + re-render on theme/mode change)
	 *   - source stashing + data-processed reset for refresh
	 *
	 * Idempotent: the first call binds the adapter, subsequent calls are
	 * no-ops.  When the provider isn't installed, mermaid still gets
	 * initialized once against whatever CSS variables happen to exist.
	 */
	_ensureMermaidAdapter()
	{
		if (this._mermaidAdapter) { return this._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				this._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				// No provider: lazy-require the adapter directly so the
				// static base theme still picks up any CSS vars on :root.
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				this._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			if (this.log && this.log.warn) { this.log.warn('Mermaid theme adapter init failed: ' + pError.message); }
			this._mermaidAdapter = null;
		}
		return this._mermaidAdapter;
	}

	/**
	 * Render any Mermaid diagram blocks in the content area.
	 * Mermaid blocks are `<pre class="mermaid">` elements produced by parseMarkdown.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderMermaidDiagrams(pContainerID)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		let tmpMermaidElements = tmpContentBody.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the Theme-Diagram-Adapter, which initializes
		// mermaid against the active palette and subscribes to onApply so a
		// theme/mode change triggers re-render of every pre.mermaid on the page.
		this._ensureMermaidAdapter();

		// Cache each diagram's source on the element so theme-change
		// re-renders can restore it. Mermaid replaces textContent with
		// the rendered SVG during run(), so we lose the source unless
		// we stash it here first.
		let tmpProviderForStash = this.pict && this.pict.providers && this.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		// mermaid.run() will process all pre.mermaid elements in the container.
		// It returns a promise; once it resolves the inner SVG exists and we
		// can tag the diagrams as fullscreen-clickable.
		try
		{
			let tmpResult = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(() =>
				{
					// Strip mermaid 11's inline !important fill/stroke flags
					// so the view's theme-aware .theme-dark CSS rules can win
					// against the per-node colors mermaid bakes inline.  The
					// adapter strips on every re-render; the initial render
					// runs through mermaid.run() directly so we have to call
					// the strip here too.  Without this the dark-mode rect
					// fill override silently loses to inline `!important`.
					let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
					if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
					{
						tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
					}
					this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
				}).catch((pError) =>
				{
					this.log.error('Mermaid rendering error: ' + (pError && pError.message ? pError.message : pError));
				});
			}
			else
			{
				// Synchronous fallback (older mermaid)
				let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
				if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
				{
					tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
				}
				this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
			}
		}
		catch (pError)
		{
			this.log.error('Mermaid rendering error: ' + pError.message);
		}
	}

	/**
	 * Render KaTeX inline and display math elements in the content area.
	 * Inline: `<span class="pict-content-katex-inline">`
	 * Display: `<div class="pict-content-katex-display">`
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderKaTeXEquations(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		// Render inline math
		let tmpInlineElements = tmpContentBody.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				this.log.warn('KaTeX inline error: ' + pError.message);
			}
		}

		// Render display math
		let tmpDisplayElements = tmpContentBody.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				this.log.warn('KaTeX display error: ' + pError.message);
			}
		}
	}

	/**
	 * Walk the freshly-rendered content and tag images, mermaid diagrams,
	 * and fenced code blocks so they're click-to-fullscreen.  Also installs
	 * a single delegated click listener on the container the first time it
	 * is called for that container.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 * @param {Object} [pOptions] - { skipMermaid: bool, onlyMermaid: bool }
	 */
	enableFullscreenViewers(pContainerID, pOptions)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}
		let tmpOptions = pOptions || {};

		if (!tmpOptions.onlyMermaid)
		{
			// Images
			let tmpImages = tmpContentBody.querySelectorAll('img:not([data-fullscreen-source])');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpImg = tmpImages[i];
				tmpImg.setAttribute('data-fullscreen-source', 'image');
				let tmpAlt = tmpImg.getAttribute('alt');
				if (!tmpAlt)
				{
					let tmpSrc = tmpImg.getAttribute('src') || '';
					tmpAlt = tmpSrc.split('/').pop().split('?')[0] || 'Image';
				}
				tmpImg.setAttribute('data-fullscreen-title', tmpAlt);
			}

			// Code wraps (fenced blocks): do NOT tag for click-to-fullscreen —
			// that would conflict with text selection for copy/paste.
			// Instead wrap each in a container with hover-revealed action
			// buttons (fullscreen + copy) floating to the right.
			let tmpCodeWraps = tmpContentBody.querySelectorAll('.pict-content-code-wrap:not([data-code-actions-wired])');
			for (let i = 0; i < tmpCodeWraps.length; i++)
			{
				this._wireCodeActions(tmpCodeWraps[i]);
			}
		}

		if (!tmpOptions.skipMermaid)
		{
			// Mermaid diagrams (after mermaid.run() has replaced the inner pre)
			let tmpMermaid = tmpContentBody.querySelectorAll('pre.mermaid:not([data-fullscreen-source])');
			for (let i = 0; i < tmpMermaid.length; i++)
			{
				let tmpPre = tmpMermaid[i];
				// Only tag once mermaid has actually rendered an svg into it
				if (tmpPre.querySelector('svg'))
				{
					tmpPre.setAttribute('data-fullscreen-source', 'mermaid');
					tmpPre.setAttribute('data-fullscreen-title', 'Mermaid Diagram');
				}
			}
		}

		// Install delegated click listener once per container.
		if (!tmpContentBody.__pictFullscreenWired)
		{
			tmpContentBody.__pictFullscreenWired = true;
			tmpContentBody.addEventListener('click', (pEvent) =>
			{
				let tmpTarget = pEvent.target;
				while (tmpTarget && tmpTarget !== tmpContentBody && !tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					tmpTarget = tmpTarget.parentElement;
				}
				if (tmpTarget && tmpTarget !== tmpContentBody && tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					pEvent.preventDefault();
					this._openFullscreen(tmpTarget);
				}
			});
		}
	}

	/**
	 * Wrap a fenced code block in a container that holds the existing
	 * .pict-content-code-wrap plus a hover-revealed action column with
	 * fullscreen + copy buttons.  The action column is sticky-positioned
	 * so it follows the page scroll while the user is alongside a long
	 * code block.
	 *
	 * @param {HTMLElement} pCodeWrap - The .pict-content-code-wrap element
	 */
	_wireCodeActions(pCodeWrap)
	{
		if (!pCodeWrap || pCodeWrap.hasAttribute('data-code-actions-wired'))
		{
			return;
		}
		pCodeWrap.setAttribute('data-code-actions-wired', 'true');

		// Determine the fullscreen title from the language tag, if any.
		let tmpCodeEl = pCodeWrap.querySelector('code[class*="language-"]');
		let tmpLang = 'Code';
		if (tmpCodeEl)
		{
			let tmpMatch = (tmpCodeEl.getAttribute('class') || '').match(/language-(\S+)/);
			if (tmpMatch)
			{
				tmpLang = tmpMatch[1] + ' code';
			}
		}
		pCodeWrap.setAttribute('data-code-language', tmpLang);

		// Build the wrapping container.
		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-content-code-container';

		let tmpActions = document.createElement('div');
		tmpActions.className = 'pict-content-code-actions';
		tmpActions.setAttribute('aria-hidden', 'false');

		let tmpFullscreenBtn = document.createElement('button');
		tmpFullscreenBtn.type = 'button';
		tmpFullscreenBtn.className = 'pict-content-code-action-btn';
		tmpFullscreenBtn.setAttribute('aria-label', 'Open code in fullscreen');
		tmpFullscreenBtn.setAttribute('title', 'Open in fullscreen');
		tmpFullscreenBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><polyline points="3 6 3 3 6 3"></polyline><polyline points="13 6 13 3 10 3"></polyline><polyline points="3 10 3 13 6 13"></polyline><polyline points="13 10 13 13 10 13"></polyline></svg>';

		let tmpCopyBtn = document.createElement('button');
		tmpCopyBtn.type = 'button';
		tmpCopyBtn.className = 'pict-content-code-action-btn';
		tmpCopyBtn.setAttribute('aria-label', 'Copy code to clipboard');
		tmpCopyBtn.setAttribute('title', 'Copy code');
		tmpCopyBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5" y="5" width="9" height="9" rx="1.25"></rect><path d="M11 5V3.25A1.25 1.25 0 0 0 9.75 2H3.25A1.25 1.25 0 0 0 2 3.25v6.5A1.25 1.25 0 0 0 3.25 11H5"></path></svg>';

		tmpActions.appendChild(tmpFullscreenBtn);
		tmpActions.appendChild(tmpCopyBtn);

		// Insert the container in the place of the code wrap, then move the
		// code wrap inside it followed by the actions column.
		let tmpParent = pCodeWrap.parentNode;
		tmpParent.insertBefore(tmpContainer, pCodeWrap);
		tmpContainer.appendChild(pCodeWrap);
		tmpContainer.appendChild(tmpActions);

		// Click handlers
		tmpFullscreenBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._openCodeFullscreen(pCodeWrap);
		});
		tmpCopyBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._copyCodeToClipboard(pCodeWrap, tmpCopyBtn);
		});
	}

	/**
	 * Open the fullscreen overlay for a fenced code block.  Reuses the
	 * same overlay singleton as image / mermaid.
	 */
	_openCodeFullscreen(pCodeWrap)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		// Stamp the source attributes the overlay's open() expects.
		pCodeWrap.setAttribute('data-fullscreen-source', 'code');
		pCodeWrap.setAttribute('data-fullscreen-title', pCodeWrap.getAttribute('data-code-language') || 'Code');
		tmpOverlay.open(pCodeWrap);
	}

	/**
	 * Copy the raw text of a code block to the clipboard and briefly flash
	 * a "Copied!" state on the trigger button.
	 */
	_copyCodeToClipboard(pCodeWrap, pButton)
	{
		let tmpCodeEl = pCodeWrap.querySelector('code');
		let tmpText = tmpCodeEl ? tmpCodeEl.textContent : pCodeWrap.textContent;

		let fFlashOk = () =>
		{
			pButton.classList.add('is-copied');
			pButton.setAttribute('title', 'Copied!');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copied');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};
		let fFlashFail = () =>
		{
			pButton.classList.add('is-copy-failed');
			pButton.setAttribute('title', 'Copy failed');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copy-failed');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};

		try
		{
			if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function')
			{
				navigator.clipboard.writeText(tmpText).then(fFlashOk).catch(fFlashFail);
				return;
			}
		}
		catch (e)
		{
			// fall through to legacy fallback
		}

		// Legacy fallback for non-secure contexts.
		try
		{
			let tmpTextarea = document.createElement('textarea');
			tmpTextarea.value = tmpText;
			tmpTextarea.style.position = 'fixed';
			tmpTextarea.style.opacity = '0';
			document.body.appendChild(tmpTextarea);
			tmpTextarea.select();
			let tmpOk = document.execCommand('copy');
			document.body.removeChild(tmpTextarea);
			if (tmpOk) { fFlashOk(); } else { fFlashFail(); }
		}
		catch (e)
		{
			fFlashFail();
		}
	}

	/**
	 * Lazily build the singleton fullscreen overlay element and attach it
	 * to <body>.  Returns the existing instance if already built.
	 */
	_buildFullscreenOverlay()
	{
		if (PictContentView._FullscreenOverlay)
		{
			return PictContentView._FullscreenOverlay;
		}

		let tmpOverlay = document.createElement('div');
		tmpOverlay.className = 'pict-fullscreen-overlay';
		tmpOverlay.setAttribute('role', 'dialog');
		tmpOverlay.setAttribute('aria-modal', 'true');
		tmpOverlay.setAttribute('aria-labelledby', 'pict-fullscreen-title');
		tmpOverlay.setAttribute('hidden', '');
		tmpOverlay.innerHTML = ''
			+ '<div class="pict-fullscreen-titlebar">'
			+   '<span class="pict-fullscreen-title" id="pict-fullscreen-title"></span>'
			+   '<div class="pict-fullscreen-controls">'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-out" aria-label="Zoom out" title="Zoom out"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-reset" aria-label="Reset zoom" title="Reset zoom"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="5"></circle><line x1="8" y1="5" x2="8" y2="11"></line><line x1="5" y1="8" x2="11" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-in" aria-label="Zoom in" title="Zoom in"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line><line x1="8" y1="3" x2="8" y2="13"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn pict-fullscreen-close" data-action="close" aria-label="Close" title="Close (Esc)"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="4" y1="4" x2="12" y2="12"></line><line x1="12" y1="4" x2="4" y2="12"></line></svg></button>'
			+   '</div>'
			+ '</div>'
			+ '<div class="pict-fullscreen-stage">'
			+   '<div class="pict-fullscreen-content"></div>'
			+ '</div>';
		document.body.appendChild(tmpOverlay);

		let tmpState = {
			scale: 1,
			translateX: 0,
			translateY: 0,
			isPanning: false,
			didPan: false,
			currentKind: '',
			panStartX: 0,
			panStartY: 0,
			panOrigX: 0,
			panOrigY: 0,
			pinchInitialDistance: 0,
			pinchInitialScale: 1
		};

		let tmpStage = tmpOverlay.querySelector('.pict-fullscreen-stage');
		let tmpContent = tmpOverlay.querySelector('.pict-fullscreen-content');
		let tmpTitleEl = tmpOverlay.querySelector('.pict-fullscreen-title');

		let fApplyTransform = () =>
		{
			tmpContent.style.transform = 'translate(' + tmpState.translateX + 'px, ' + tmpState.translateY + 'px) scale(' + tmpState.scale + ')';
			tmpStage.classList.toggle('is-zoomed', tmpState.scale > 1.001);
		};

		let fClampScale = (pValue) =>
		{
			if (pValue < 0.5) return 0.5;
			if (pValue > 8) return 8;
			return pValue;
		};

		let fZoomAt = (pNewScale, pAnchorClientX, pAnchorClientY) =>
		{
			let tmpClamped = fClampScale(pNewScale);
			let tmpStageRect = tmpStage.getBoundingClientRect();
			let tmpAnchorX = (pAnchorClientX !== undefined) ? pAnchorClientX : (tmpStageRect.left + tmpStageRect.width / 2);
			let tmpAnchorY = (pAnchorClientY !== undefined) ? pAnchorClientY : (tmpStageRect.top + tmpStageRect.height / 2);
			// Convert anchor into the local coordinate of the content (which is centered)
			let tmpCenterX = tmpStageRect.left + tmpStageRect.width / 2;
			let tmpCenterY = tmpStageRect.top + tmpStageRect.height / 2;
			let tmpDX = tmpAnchorX - tmpCenterX;
			let tmpDY = tmpAnchorY - tmpCenterY;
			let tmpRatio = tmpClamped / tmpState.scale;
			tmpState.translateX = tmpDX - tmpRatio * (tmpDX - tmpState.translateX);
			tmpState.translateY = tmpDY - tmpRatio * (tmpDY - tmpState.translateY);
			tmpState.scale = tmpClamped;
			fApplyTransform();
		};

		let fResetTransform = () =>
		{
			tmpState.scale = 1;
			tmpState.translateX = 0;
			tmpState.translateY = 0;
			fApplyTransform();
		};

		let fClose = () =>
		{
			tmpOverlay.setAttribute('hidden', '');
			tmpContent.innerHTML = '';
			fResetTransform();
			document.documentElement.style.removeProperty('overflow');
			document.removeEventListener('keydown', fKeydown);
		};

		let fKeydown = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pEvent.preventDefault();
				fClose();
			}
			else if (pEvent.key === '+' || pEvent.key === '=')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale + 0.25);
			}
			else if (pEvent.key === '-' || pEvent.key === '_')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale - 0.25);
			}
			else if (pEvent.key === '0')
			{
				pEvent.preventDefault();
				fResetTransform();
			}
		};

		// Backdrop click closes (only when clicking the backdrop itself or
		// the stage area, not the inner content).  Suppress if a
		// drag-to-pan just finished — the pointerup that ended the pan
		// also fires a click event which we must ignore.
		tmpOverlay.addEventListener('click', (pEvent) =>
		{
			if (tmpState.didPan)
			{
				tmpState.didPan = false;
				return;
			}
			if (pEvent.target === tmpOverlay || pEvent.target === tmpStage)
			{
				fClose();
			}
		});

		// Toolbar buttons
		tmpOverlay.querySelectorAll('[data-action]').forEach((pBtn) =>
		{
			pBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpAction = pBtn.getAttribute('data-action');
				if (tmpAction === 'close')
				{
					fClose();
				}
				else if (tmpAction === 'zoom-in')
				{
					fZoomAt(tmpState.scale + 0.25);
				}
				else if (tmpAction === 'zoom-out')
				{
					fZoomAt(tmpState.scale - 0.25);
				}
				else if (tmpAction === 'zoom-reset')
				{
					fResetTransform();
				}
			});
		});

		// Wheel zoom — for images and mermaid diagrams.
		// For code blocks, let the browser handle native scrolling
		// so the user can scroll through long code.
		tmpStage.addEventListener('wheel', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			pEvent.preventDefault();
			let tmpDelta = -pEvent.deltaY;
			let tmpStep = (tmpDelta > 0 ? 1 : -1) * 0.15;
			fZoomAt(tmpState.scale + tmpStep, pEvent.clientX, pEvent.clientY);
		}, { passive: false });

		// Drag-to-pan when zoomed (not for code blocks — they scroll natively)
		tmpStage.addEventListener('pointerdown', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			if (tmpState.scale <= 1.001)
			{
				return;
			}
			if (pEvent.target.closest('.pict-fullscreen-controls'))
			{
				return;
			}
			tmpState.isPanning = true;
			tmpState.panStartX = pEvent.clientX;
			tmpState.panStartY = pEvent.clientY;
			tmpState.panOrigX = tmpState.translateX;
			tmpState.panOrigY = tmpState.translateY;
			tmpStage.setPointerCapture(pEvent.pointerId);
			tmpStage.classList.add('is-panning');
		});
		tmpStage.addEventListener('pointermove', (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.translateX = tmpState.panOrigX + (pEvent.clientX - tmpState.panStartX);
			tmpState.translateY = tmpState.panOrigY + (pEvent.clientY - tmpState.panStartY);
			fApplyTransform();
		});
		let fEndPan = (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.isPanning = false;
			// Flag that a pan just ended so the subsequent click event
			// (which the browser fires after pointerup) does not close
			// the overlay via the backdrop-close handler.
			tmpState.didPan = true;
			tmpStage.classList.remove('is-panning');
			try { tmpStage.releasePointerCapture(pEvent.pointerId); } catch (e) {}
		};
		tmpStage.addEventListener('pointerup', fEndPan);
		tmpStage.addEventListener('pointercancel', fEndPan);

		// Touch pinch zoom
		let tmpActiveTouches = {};
		tmpStage.addEventListener('touchstart', (pEvent) =>
		{
			for (let i = 0; i < pEvent.touches.length; i++)
			{
				let tmpT = pEvent.touches[i];
				tmpActiveTouches[tmpT.identifier] = { x: tmpT.clientX, y: tmpT.clientY };
			}
			if (pEvent.touches.length === 2)
			{
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				tmpState.pinchInitialDistance = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				tmpState.pinchInitialScale = tmpState.scale;
			}
		}, { passive: true });
		tmpStage.addEventListener('touchmove', (pEvent) =>
		{
			if (pEvent.touches.length === 2 && tmpState.pinchInitialDistance > 0)
			{
				pEvent.preventDefault();
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				let tmpRatio = tmpDist / tmpState.pinchInitialDistance;
				let tmpMidX = (tmpA.clientX + tmpB.clientX) / 2;
				let tmpMidY = (tmpA.clientY + tmpB.clientY) / 2;
				fZoomAt(tmpState.pinchInitialScale * tmpRatio, tmpMidX, tmpMidY);
			}
		}, { passive: false });
		tmpStage.addEventListener('touchend', () =>
		{
			tmpActiveTouches = {};
			tmpState.pinchInitialDistance = 0;
		});

		PictContentView._FullscreenOverlay = {
			element: tmpOverlay,
			content: tmpContent,
			titleEl: tmpTitleEl,
			state: tmpState,
			open: (pSourceEl) =>
			{
				let tmpTitle = pSourceEl.getAttribute('data-fullscreen-title') || '';
				tmpTitleEl.textContent = tmpTitle;
				tmpContent.innerHTML = '';

				let tmpKind = pSourceEl.getAttribute('data-fullscreen-source');
				tmpState.currentKind = tmpKind || '';
				let tmpClone;
				if (tmpKind === 'mermaid')
				{
					let tmpSvg = pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-mermaid-svg');
						// Drop mermaid's inline max-width / width / height style so the
						// fullscreen CSS rule actually controls the size.
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'diagram')
				{
					// Inline SVG diagram (bespoke pict-renderer-graph / excalidraw):
					// clone the <svg> and drop its intrinsic sizing so the fullscreen
					// stage controls the dimensions -- same approach as mermaid, but
					// the source element may BE the svg or a wrapper around it.
					let tmpSvg = (String(pSourceEl.tagName).toLowerCase() === 'svg') ? pSourceEl : pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-diagram-svg');
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'image')
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-img');
				}
				else
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-codewrap');
				}
				tmpContent.appendChild(tmpClone);

				// Hide zoom controls for code blocks (they scroll natively)
				let tmpZoomBtns = tmpOverlay.querySelectorAll('[data-action="zoom-in"], [data-action="zoom-out"], [data-action="zoom-reset"]');
				for (let i = 0; i < tmpZoomBtns.length; i++)
				{
					tmpZoomBtns[i].style.display = (tmpKind === 'code') ? 'none' : '';
				}

				fResetTransform();
				tmpOverlay.removeAttribute('hidden');
				document.documentElement.style.overflow = 'hidden';
				document.addEventListener('keydown', fKeydown);
			},
			close: fClose
		};
		return PictContentView._FullscreenOverlay;
	}

	/**
	 * Open the fullscreen overlay for a tagged source element.
	 */
	_openFullscreen(pSourceEl)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		tmpOverlay.open(pSourceEl);
	}

	/**
	 * Show a loading indicator.
	 *
	 * @param {string} [pMessage] - Loading message (defaults to 'Loading content...')
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	showLoading(pMessage, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpMessage = pMessage || 'Loading content...';
		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, '<div class="pict-content-loading">' + tmpMessage + '</div>');
	}
}

module.exports = PictContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"../Pict-Content-CSS.js":195,"pict-provider-theme/source/Theme-Diagram-Adapter.js":171,"pict-view":365}],199:[function(require,module,exports){
// Pict-Section-Content — Demo view
//
// A thin renderable wrapper around the canonical Pict-View-Content view.
// The base view is "lazy" — it shows a Loading placeholder until its host
// application explicitly calls `displayContent(parsedHTML)`.  That works
// fine when an application has its own page logic, but it's awkward for
// the docuserve playground (which doesn't know anything about
// markdown / parseMarkdown).
//
// This demo view bridges that gap:
//   1. Ensures the PictContentProvider is registered with `pict`.
//   2. Reads markdown text from an AppData address (configurable via
//      `MarkdownDataAddress`, e.g. "AppData.ContentDemo.Markdown").
//   3. On every render, parses the markdown via the provider and calls
//      the parent view's `displayContent` to push HTML into the DOM.
//
// Host applications that need anything more elaborate (navigation,
// multiple documents, link resolvers) should keep using the canonical
// Pict-View-Content view directly.  This demo view exists for the
// playground and other "just render this markdown blob" surfaces.

const libPictViewContent = require('./Pict-View-Content.js');
const libPictContentProvider = require('../providers/Pict-Provider-Content.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content-Demo",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	// Where to read the markdown source from. Resolved against the
	// pict instance with simple dot-walking — "AppData.X.Y.Z".
	MarkdownDataAddress: "AppData.ContentDemo.Markdown",

	// AutoRender on, so the playground's wrapper just instantiates the
	// view and the markdown shows up on next tick.
	AutoRender: true,

	// Inherit CSS / Templates / Renderables from the base view so we
	// render into the same #Pict-Content-Container with the same shell.
	CSS: libPictViewContent.default_configuration.CSS,
	Templates: libPictViewContent.default_configuration.Templates,
	Renderables: libPictViewContent.default_configuration.Renderables
};

class PictContentDemoView extends libPictViewContent
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Ensure the content provider is registered. Use a stable hash
		// so repeat instantiation is a no-op.
		let tmpProviderHash = 'Pict-Content';
		if (!this.pict.providers[tmpProviderHash])
		{
			this.pict.addProvider(tmpProviderHash, libPictContentProvider.default_configuration, libPictContentProvider);
		}
	}

	/**
	 * Walk a dotted address ("AppData.X.Y.Z") against the pict instance
	 * and return the value, or null if any segment is missing.
	 */
	_readMarkdownFromAddress()
	{
		let tmpAddress = this.options.MarkdownDataAddress;
		if (!tmpAddress || typeof tmpAddress !== 'string')
		{
			return null;
		}
		let tmpParts = tmpAddress.split('.');
		let tmpCurrent = this.pict;
		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return null;
			}
			tmpCurrent = tmpCurrent[tmpParts[i]];
		}
		return (typeof tmpCurrent === 'string') ? tmpCurrent : null;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		// Pull markdown from AppData and push parsed HTML through the
		// parent view's pipeline (which also wires Mermaid / KaTeX /
		// fullscreen viewers).
		let tmpMarkdown = this._readMarkdownFromAddress();
		let tmpProvider = this.pict.providers['Pict-Content'];
		if (tmpProvider && typeof tmpMarkdown === 'string')
		{
			let tmpHTML = tmpProvider.parseMarkdown(tmpMarkdown);
			this.displayContent(tmpHTML);
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictContentDemoView;

module.exports.default_configuration = _ViewConfiguration;

},{"../providers/Pict-Provider-Content.js":197,"./Pict-View-Content.js":198}],200:[function(require,module,exports){
'use strict';

/**
 * DocHistoryModel - the pure, DOM-free half of pict-section-dochistory.
 *
 * A line differ (no dependency, so the section stays cheap to adopt), plus the small
 * presentation helpers the two views share. Everything here is a pure function over
 * plain data, so it unit-tests with no browser and a host can reuse it directly.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// The documented Source values a Docs Lake emits. An unknown value is not an error: it is
// shown as-is, so a host with its own vocabulary still renders sensibly.
const _SOURCE_LABELS =
{
	platform: 'Edited here',
	github: 'Pulled from the repository',
	merge: 'Merged from both sides',
	agent: 'Written by a tool',
	import: 'Imported'
};

function sourceLabel(pSource)
{
	let tmpSource = String(pSource || '').toLowerCase();
	return _SOURCE_LABELS[tmpSource] || (tmpSource || 'Changed');
}

// A stable css-safe suffix for a Source, so a theme can style the known kinds and anything
// unknown still lands on the neutral base class.
function sourceKind(pSource)
{
	let tmpSource = String(pSource || '').toLowerCase();
	return Object.prototype.hasOwnProperty.call(_SOURCE_LABELS, tmpSource) ? tmpSource : 'other';
}

function splitLines(pText)
{
	if (pText === null || pText === undefined) { return []; }
	let tmpText = String(pText).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	let tmpLines = tmpText.split('\n');
	// A trailing newline is a terminator, not an empty final line.
	if (tmpLines.length && tmpLines[tmpLines.length - 1] === '') { tmpLines.pop(); }
	return tmpLines;
}

/**
 * A line diff between two texts, as an array of
 *   { Kind: 'same' | 'add' | 'del', Text, FromLine, ToLine }
 * in output order. Classic LCS over lines, which is what a person reading prose expects:
 * unchanged paragraphs stay put and only the touched lines are marked.
 *
 * The LCS table is O(n*m), so a guard falls back to a whole-file replace when a pair of
 * documents is large enough that the table would be the expensive part of rendering a diff.
 */
function diffLines(pFrom, pTo, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpMaxCells = Number(tmpOptions.MaxCells) || 4000000;
	let tmpA = splitLines(pFrom);
	let tmpB = splitLines(pTo);

	if ((tmpA.length + 1) * (tmpB.length + 1) > tmpMaxCells)
	{
		let tmpBig = [];
		for (let i = 0; i < tmpA.length; i++) { tmpBig.push({ Kind: 'del', Text: tmpA[i], FromLine: i + 1, ToLine: 0 }); }
		for (let j = 0; j < tmpB.length; j++) { tmpBig.push({ Kind: 'add', Text: tmpB[j], FromLine: 0, ToLine: j + 1 }); }
		return tmpBig;
	}

	// lcs[i][j] = length of the longest common subsequence of tmpA[i:] and tmpB[j:].
	let tmpLCS = new Array(tmpA.length + 1);
	for (let i = tmpA.length; i >= 0; i--)
	{
		tmpLCS[i] = tmpLCS[i] || new Array(tmpB.length + 1).fill(0);
		for (let j = tmpB.length - 1; j >= 0; j--)
		{
			if (i === tmpA.length) { tmpLCS[i][j] = 0; continue; }
			tmpLCS[i][j] = (tmpA[i] === tmpB[j])
				? (tmpLCS[i + 1][j + 1] + 1)
				: Math.max(tmpLCS[i + 1][j], tmpLCS[i][j + 1]);
		}
	}

	let tmpOut = [];
	let a = 0, b = 0;
	while (a < tmpA.length && b < tmpB.length)
	{
		if (tmpA[a] === tmpB[b]) { tmpOut.push({ Kind: 'same', Text: tmpA[a], FromLine: a + 1, ToLine: b + 1 }); a++; b++; }
		else if (tmpLCS[a + 1][b] >= tmpLCS[a][b + 1]) { tmpOut.push({ Kind: 'del', Text: tmpA[a], FromLine: a + 1, ToLine: 0 }); a++; }
		else { tmpOut.push({ Kind: 'add', Text: tmpB[b], FromLine: 0, ToLine: b + 1 }); b++; }
	}
	while (a < tmpA.length) { tmpOut.push({ Kind: 'del', Text: tmpA[a], FromLine: a + 1, ToLine: 0 }); a++; }
	while (b < tmpB.length) { tmpOut.push({ Kind: 'add', Text: tmpB[b], FromLine: 0, ToLine: b + 1 }); b++; }
	return tmpOut;
}

// Added / removed counts for a diff, for the "+3 -1" summary above a diff.
function diffStats(pDiff)
{
	let tmpStats = { Added: 0, Removed: 0, Unchanged: 0 };
	(pDiff || []).forEach((pRow) =>
	{
		if (pRow.Kind === 'add') { tmpStats.Added++; }
		else if (pRow.Kind === 'del') { tmpStats.Removed++; }
		else { tmpStats.Unchanged++; }
	});
	return tmpStats;
}

/**
 * Collapse long runs of unchanged lines, keeping pContext lines either side of every change
 * (the "..." gaps a diff view uses). Returns rows plus { Kind: 'gap', Skipped } markers.
 * pContext of 0 or a negative value means "do not collapse".
 */
function collapseUnchanged(pDiff, pContext)
{
	let tmpDiff = pDiff || [];
	let tmpContext = Number(pContext);
	if (!(tmpContext > 0)) { return tmpDiff.slice(); }

	let tmpKeep = new Array(tmpDiff.length).fill(false);
	for (let i = 0; i < tmpDiff.length; i++)
	{
		if (tmpDiff[i].Kind === 'same') { continue; }
		for (let j = Math.max(0, i - tmpContext); j <= Math.min(tmpDiff.length - 1, i + tmpContext); j++) { tmpKeep[j] = true; }
	}

	let tmpOut = [];
	let tmpSkipped = 0;
	for (let i = 0; i < tmpDiff.length; i++)
	{
		if (tmpKeep[i])
		{
			if (tmpSkipped) { tmpOut.push({ Kind: 'gap', Skipped: tmpSkipped }); tmpSkipped = 0; }
			tmpOut.push(tmpDiff[i]);
		}
		else { tmpSkipped++; }
	}
	if (tmpSkipped) { tmpOut.push({ Kind: 'gap', Skipped: tmpSkipped }); }
	return tmpOut;
}

// "3 minutes ago" / "yesterday" / a plain date once it stops being useful as an interval.
// pNow is injectable so this is testable without freezing the clock.
function relativeDate(pDate, pNow)
{
	if (!pDate) { return ''; }
	let tmpThen = new Date(pDate);
	if (isNaN(tmpThen.getTime())) { return String(pDate); }
	let tmpNow = pNow ? new Date(pNow) : new Date();
	let tmpSeconds = Math.floor((tmpNow.getTime() - tmpThen.getTime()) / 1000);
	if (tmpSeconds < 45) { return 'just now'; }
	if (tmpSeconds < 90) { return 'a minute ago'; }
	let tmpMinutes = Math.floor(tmpSeconds / 60);
	if (tmpMinutes < 60) { return tmpMinutes + ' minutes ago'; }
	let tmpHours = Math.floor(tmpMinutes / 60);
	if (tmpHours < 24) { return tmpHours + (tmpHours === 1 ? ' hour ago' : ' hours ago'); }
	let tmpDays = Math.floor(tmpHours / 24);
	if (tmpDays === 1) { return 'yesterday'; }
	if (tmpDays < 30) { return tmpDays + ' days ago'; }
	return tmpThen.toISOString().slice(0, 10);
}

// A short, human handle for a version. Commit hashes are content addresses, not something
// anyone should have to read, so only the leading characters are ever shown.
function shortCommit(pCommit, pLength)
{
	return String(pCommit || '').slice(0, Number(pLength) || 7);
}

// Escape for safe interpolation into a template. The views build HTML strings, and a
// document's own text (an author's prose, a commit message) must never become markup.
function escapeHTML(pText)
{
	return String((pText === null || pText === undefined) ? '' : pText)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

module.exports = {
	diffLines: diffLines,
	diffStats: diffStats,
	collapseUnchanged: collapseUnchanged,
	splitLines: splitLines,
	sourceLabel: sourceLabel,
	sourceKind: sourceKind,
	relativeDate: relativeDate,
	shortCommit: shortCommit,
	escapeHTML: escapeHTML
};

},{}],201:[function(require,module,exports){
'use strict';

/**
 * pict-section-dochistory entry point.
 *
 * Version history for a document tree: a timeline of versions that says who changed what and
 * from which side, and a rendered line diff between any two of them.
 *
 * Two registerable views, so a host can place them independently (a timeline in a sidebar, a
 * diff in a main pane) rather than accepting one fixed layout:
 *
 *   const libDocHistory = require('pict-section-dochistory');
 *
 *   pict.addView('Doc-Timeline', Object.assign({}, libDocHistory.TimelineView.default_configuration,
 *       {
 *           Path: 'architecture/data-model.md',
 *           onLoadHistory: (pPath, pLimit, fCallback) => myAPI.history(pPath, pLimit, fCallback),
 *           onSelectVersion: (pEvent, pPrevious) =>
 *               pict.views['Doc-Diff'].showDiff(pPrevious ? pPrevious.Commit : '', pEvent.Commit, pEvent.Path)
 *       }), libDocHistory.TimelineView);
 *
 *   pict.addView('Doc-Diff', Object.assign({}, libDocHistory.DiffView.default_configuration,
 *       { onLoadDiff: (pFrom, pTo, pPath, fCallback) => myAPI.diff(pFrom, pTo, pPath, fCallback) }),
 *       libDocHistory.DiffView);
 *
 * The section ships NO transport: both views read through host callbacks, so it carries no
 * assumption about where the history lives or what the backing store is called.
 *
 * The event shape both views understand:
 *
 *   { Commit, Parent, Date, Source, AuthorName, AuthorEmail, IDUser,
 *     UpstreamCommitSHA, IDDocSyncBinding, Message, FilesChanged, PathChange }
 *
 * Source is an open string; platform | github | merge | agent | import get friendly labels and
 * their own style hook, and anything else is shown as given. Unknown extra fields are carried
 * through untouched, so a host can hang its own data off an event and read it back in a callback.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libTimelineView = require('./views/PictView-DocHistoryTimeline.js');
const libDiffView = require('./views/PictView-DocHistoryDiff.js');
const libModel = require('./DocHistoryModel.js');

module.exports =
{
	// The two registerable views. Each carries its own default_configuration.
	TimelineView: libTimelineView,
	DiffView: libDiffView,

	// The pure, DOM-free helpers: the line differ, the collapse-context pass, and the small
	// presentation functions. Exported so a host can reuse them (or diff outside a view) and
	// so they can be tested with no browser.
	Model: libModel
};

},{"./DocHistoryModel.js":200,"./views/PictView-DocHistoryDiff.js":202,"./views/PictView-DocHistoryTimeline.js":203}],202:[function(require,module,exports){
'use strict';

/**
 * PictView-DocHistoryDiff
 * -----------------------
 * The change between two versions of ONE document, rendered as a line diff: removed lines,
 * added lines, and enough unchanged context to read them in. Long unchanged stretches
 * collapse to a gap marker so a one-line edit in a long document does not bury the change.
 *
 * It owns no transport. The host supplies onLoadDiff and this view renders what comes back,
 * so it works over any store that can answer "what did this document look like at these two
 * versions". Pair it with PictView-DocHistoryTimeline by wiring that view's onSelectVersion
 * to this one's showDiff.
 *
 * A binary path (an image, a PDF) has no line diff and says so rather than rendering bytes.
 * A version where the document did not yet exist, or was deleted, is stated in words too.
 *
 * Rendering follows the pict conventions: state is published to AppData before each render,
 * iteration is {~TS:~}, and all colors are theme tokens. Document text is escaped on the way
 * in (DocHistoryModel.escapeHTML), because a diff renders an author's prose, which may
 * legitimately contain markup.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libModel = require('../DocHistoryModel.js');

const _DefaultConfiguration =
{
	ViewIdentifier: 'DocHistory-Diff',
	DefaultRenderable: 'DocHistory-Diff-Section',
	DefaultDestinationAddress: '#DocHistory-Diff-Container',
	AutoRender: false,

	// ---- options a host overrides ----
	// Unchanged lines kept either side of a change. 0 shows the whole document.
	ContextLines: 3,
	// Show original / new line numbers beside each line.
	ShowLineNumbers: true,
	EmptyMessage: 'Pick a version to see what changed.',
	IdenticalMessage: 'Nothing changed in this document in that version.',
	BinaryMessage: 'This is an image or other binary file, so there is no line-by-line comparison.',
	LoadingMessage: 'Loading changes...',

	// ---- rendering ----
	CSS: /*css*/`
		.pdh-diff { display: flex; flex-direction: column; min-height: 0; height: 100%; color: var(--theme-color-text-primary, #2c3140); }
		.pdh-d-head {
			display: flex; align-items: baseline; gap: 10px; padding: 10px 14px;
			border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee);
			font-size: 13px; flex-wrap: wrap;
		}
		.pdh-d-path { font-weight: 600; overflow-wrap: anywhere; }
		.pdh-d-count-add { color: var(--theme-color-status-success, #2e9e5b); font-size: 12px; }
		.pdh-d-count-del { color: var(--theme-color-status-error, #c8452f); font-size: 12px; }
		.pdh-d-note { color: var(--theme-color-text-secondary, #5b6376); font-size: 12px; }
		.pdh-d-body {
			flex: 1; min-height: 0; overflow: auto; margin: 0; padding: 0;
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 12.5px; line-height: 1.55;
		}
		.pdh-d-line { display: flex; align-items: flex-start; white-space: pre-wrap; overflow-wrap: anywhere; }
		.pdh-d-num {
			flex: none; width: 3.2em; padding: 0 6px; text-align: right; user-select: none;
			color: var(--theme-color-text-muted, #98a2ae); background: var(--theme-color-background-tertiary, #f7f9fc);
			border-right: 1px solid var(--theme-color-border-light, #e6e9ee);
		}
		.pdh-d-marker { flex: none; width: 1.6em; text-align: center; user-select: none; color: var(--theme-color-text-muted, #98a2ae); }
		.pdh-d-text { flex: 1; padding-right: 10px; }
		/* Added and removed carry a marker character AND a tint, so the diff is still readable
		   without colour vision. */
		/* Tint from the theme's own status hue at low alpha rather than a fixed pale fill: the
		   row has to read on a dark panel as well as a light one, and the line text keeps the
		   inherited body colour either way. */
		.pdh-d-add { background: color-mix(in srgb, var(--theme-color-status-success, #2e9e5b) 18%, transparent); }
		.pdh-d-add .pdh-d-marker { color: var(--theme-color-status-success, #2e9e5b); }
		.pdh-d-del { background: color-mix(in srgb, var(--theme-color-status-error, #c8452f) 18%, transparent); }
		.pdh-d-del .pdh-d-marker { color: var(--theme-color-status-error, #c8452f); }
		.pdh-d-gap {
			padding: 3px 0 3px 4.8em; color: var(--theme-color-text-muted, #98a2ae);
			background: var(--theme-color-background-tertiary, #f7f9fc);
			border-top: 1px solid var(--theme-color-border-light, #e6e9ee);
			border-bottom: 1px solid var(--theme-color-border-light, #e6e9ee);
			font-size: 11.5px;
		}
		.pdh-d-note-block { padding: 16px 14px; color: var(--theme-color-text-secondary, #5b6376); font-size: 13px; }
		.pdh-d-error { padding: 16px 14px; color: var(--theme-color-status-error, #c8452f); font-size: 13px; }
	`,
	Templates:
	[
		{
			Hash: 'DocHistory-Diff-Section',
			Template: /*html*/`
<div class="pdh-diff">
	{~TS:DocHistory-Diff-Head:AppData.DocHistoryDiffState.HeaderSlot~}
	{~TS:DocHistory-Diff-Loading:AppData.DocHistoryDiffState.LoadingSlot~}
	{~TS:DocHistory-Diff-Error:AppData.DocHistoryDiffState.ErrorSlot~}
	{~TS:DocHistory-Diff-Note:AppData.DocHistoryDiffState.EmptySlot~}
	{~TS:DocHistory-Diff-Note:AppData.DocHistoryDiffState.BinarySlot~}
	{~TS:DocHistory-Diff-Note:AppData.DocHistoryDiffState.IdenticalSlot~}
	<div class="pdh-d-body">{~TS:DocHistory-Diff-Row:AppData.DocHistoryDiffState.Rows~}</div>
</div>`
		},
		{
			Hash: 'DocHistory-Diff-Head',
			Template: /*html*/`<div class="pdh-d-head"><span class="pdh-d-path">{~D:Record.Path~}</span><span class="pdh-d-count-add">+{~D:Record.Added~}</span><span class="pdh-d-count-del">-{~D:Record.Removed~}</span><span class="pdh-d-note">{~D:Record.Note~}</span></div>`
		},
		{
			Hash: 'DocHistory-Diff-Loading',
			Template: /*html*/`<div class="pdh-d-note-block">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'DocHistory-Diff-Error',
			Template: /*html*/`<div class="pdh-d-error">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'DocHistory-Diff-Note',
			Template: /*html*/`<div class="pdh-d-note-block">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'DocHistory-Diff-Row',
			Template: /*html*/`{~TS:DocHistory-Diff-Gap:Record.GapSlot~}{~TS:DocHistory-Diff-Line:Record.LineSlot~}`
		},
		{
			Hash: 'DocHistory-Diff-Gap',
			Template: /*html*/`<div class="pdh-d-gap">{~D:Record.Text~}</div>`
		},
		{
			Hash: 'DocHistory-Diff-Line',
			Template: /*html*/`<div class="{~D:Record.RowClass~}"><span class="pdh-d-num">{~D:Record.FromLine~}</span><span class="pdh-d-num">{~D:Record.ToLine~}</span><span class="pdh-d-marker">{~D:Record.Marker~}</span><span class="pdh-d-text">{~D:Record.Text~}</span></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'DocHistory-Diff-Section',
			TemplateHash: 'DocHistory-Diff-Section',
			DestinationAddress: '#DocHistory-Diff-Container'
		}
	],

	// ---- host callbacks ----
	// REQUIRED. onLoadDiff(pFrom, pTo, pPath, fCallback) -> fCallback(error, {
	//     FromContent, ToContent, Binary, FromExists, ToExists, Changes })
	// FromContent/ToContent are the document's full text at each version (null when it did
	// not exist there, or when the path is binary).
	onLoadDiff: null,
	onError: null
};

class PictViewDocHistoryDiff extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._from = '';
		this._to = '';
		this._path = '';
		this._result = null;
		this._loading = false;
		this._error = '';
	}

	/**
	 * Show the change from pFrom to pTo for pPath. pFrom may be empty (the document's first
	 * version, so everything is an addition). Returns a promise a host can await.
	 */
	showDiff(pFrom, pTo, pPath)
	{
		this._from = String(pFrom || '');
		this._to = String(pTo || '');
		this._path = String(pPath || '');
		this._result = null;
		this._error = '';

		let tmpCallback = this.options.onLoadDiff;
		if (typeof tmpCallback !== 'function')
		{
			this._error = 'This diff view has no onLoadDiff callback wired.';
			this.render();
			return Promise.resolve(null);
		}
		if (!this._to)
		{
			this.render();
			return Promise.resolve(null);
		}

		this._loading = true;
		this.render();
		return new Promise((resolve) =>
		{
			tmpCallback(this._from, this._to, this._path, (pError, pResult) =>
			{
				this._loading = false;
				if (pError)
				{
					this._error = (pError && pError.message) || String(pError);
					if (typeof this.options.onError === 'function') { this.options.onError(pError); }
				}
				else { this._result = pResult || null; }
				this.render();
				resolve(pResult || null);
			});
		});
	}

	// Clear back to the empty state (a host switching documents).
	clear()
	{
		this._from = ''; this._to = ''; this._path = '';
		this._result = null; this._error = ''; this._loading = false;
		this.render();
	}

	// The line diff for the current result, as plain data (also what the template renders).
	diffRows()
	{
		if (!this._result || this._result.Binary) { return []; }
		let tmpDiff = libModel.diffLines(this._result.FromContent, this._result.ToContent);
		return libModel.collapseUnchanged(tmpDiff, this.options.ContextLines);
	}

	_publishState()
	{
		let tmpViewHash = this.Hash;
		let tmpState =
		{
			ViewHash: tmpViewHash,
			Path: libModel.escapeHTML(this._path),
			LoadingSlot: this._loading ? [{ Message: libModel.escapeHTML(this.options.LoadingMessage || '') }] : [],
			ErrorSlot: this._error ? [{ Message: libModel.escapeHTML(this._error) }] : [],
			EmptySlot: [], BinarySlot: [], IdenticalSlot: [], HeaderSlot: [],
			Rows: []
		};

		if (!this._loading && !this._error)
		{
			if (!this._result)
			{
				tmpState.EmptySlot = [{ Message: libModel.escapeHTML(this.options.EmptyMessage || '') }];
			}
			else if (this._result.Binary)
			{
				tmpState.BinarySlot = [{ Message: libModel.escapeHTML(this.options.BinaryMessage || '') }];
			}
			else
			{
				let tmpRows = this.diffRows();
				let tmpStats = libModel.diffStats(tmpRows);
				if (!tmpStats.Added && !tmpStats.Removed)
				{
					tmpState.IdenticalSlot = [{ Message: libModel.escapeHTML(this.options.IdenticalMessage || '') }];
				}
				else
				{
					tmpState.HeaderSlot = [{
						Path: libModel.escapeHTML(this._path),
						Added: tmpStats.Added,
						Removed: tmpStats.Removed,
						// "created" and "removed" say what happened without needing git words.
						Note: libModel.escapeHTML(!this._result.FromExists ? 'this version created the document'
							: (!this._result.ToExists ? 'this version removed the document' : ''))
					}];
					let tmpShowNumbers = !!this.options.ShowLineNumbers;
					tmpState.Rows = tmpRows.map((pRow) =>
					{
						if (pRow.Kind === 'gap')
						{
							return { RowClass: 'pdh-d-gap', Marker: '', FromLine: '', ToLine: '', Text: pRow.Skipped + ' unchanged lines', IsGap: true, GapSlot: [{ Text: pRow.Skipped + ' unchanged lines' }], LineSlot: [] };
						}
						let tmpMarker = (pRow.Kind === 'add') ? '+' : ((pRow.Kind === 'del') ? '-' : ' ');
						return {
							IsGap: false,
							GapSlot: [],
							LineSlot: [{
								RowClass: 'pdh-d-line pdh-d-' + pRow.Kind,
								Marker: tmpMarker,
								FromLine: tmpShowNumbers ? (pRow.FromLine || '') : '',
								ToLine: tmpShowNumbers ? (pRow.ToLine || '') : '',
								// Escaped: this is an author's prose, not markup.
								Text: libModel.escapeHTML(pRow.Text)
							}]
						};
					});
				}
			}
		}

		this.pict.AppData.DocHistoryDiffState = tmpState;
		return tmpState;
	}

	onBeforeRender()
	{
		this._publishState();
		return super.onBeforeRender();
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewDocHistoryDiff;
module.exports.default_configuration = _DefaultConfiguration;

},{"../DocHistoryModel.js":200,"pict-view":365}],203:[function(require,module,exports){
'use strict';

/**
 * PictView-DocHistoryTimeline
 * ---------------------------
 * The list of versions of a document tree, newest first. Each row says WHO changed it, from
 * WHICH side (edited here, pulled from the repository, merged, a tool, an import), when, and
 * what the change was called.
 *
 * It owns no transport. The host supplies onLoadHistory and the view renders whatever comes
 * back, so the same section works over any store that can answer "what versions are there".
 *
 * Selection is the seam to the diff view: clicking a version calls onSelectVersion with the
 * chosen event and the one before it, which is exactly the (from, to) pair a diff needs. A
 * host that wants them side by side registers both views and wires this callback to
 * DiffView.showDiff.
 *
 * Rendering follows the pict conventions: state is published to AppData before each render so
 * the templates read it and the engine bakes this instance's view hash into every inline
 * handler, iteration is {~TS:~}, every interaction is an inline handler, and all colors are
 * theme tokens so an active pict-section-theme recolors the control.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libModel = require('../DocHistoryModel.js');

const _DefaultConfiguration =
{
	ViewIdentifier: 'DocHistory-Timeline',
	DefaultRenderable: 'DocHistory-Timeline-Section',
	DefaultDestinationAddress: '#DocHistory-Timeline-Container',
	AutoRender: false,

	// ---- options a host overrides ----
	// The document this timeline is for. Empty string means the whole tree's history.
	Path: '',
	// Heading above the list. Empty hides the header row entirely.
	Title: 'Version history',
	// How many versions to ask the host for.
	PageSize: 40,
	// Show each version's short content address. Off by default: a hash is a machine's
	// handle, and the audience for a documentation timeline is not reading commit ids.
	ShowCommitHash: false,
	// Show the originating upstream commit for a pulled change (needs ShowCommitHash-style
	// appetite for detail; also off by default).
	ShowUpstreamRef: false,
	EmptyMessage: 'No versions yet. The first edit starts the history.',
	LoadingMessage: 'Loading history...',

	// ---- rendering ----
	CSS: /*css*/`
		.pdh-timeline { display: flex; flex-direction: column; min-height: 0; font-size: 13px; color: var(--theme-color-text-primary, #2c3140); }
		.pdh-timeline-head {
			display: flex; align-items: center; gap: 8px; padding: 10px 14px;
			border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee);
			font-weight: 600;
		}
		.pdh-versions { list-style: none; margin: 0; padding: 0; overflow-y: auto; min-height: 0; flex: 1; }
		.pdh-ver {
			display: block; width: 100%; text-align: left; box-sizing: border-box;
			padding: 10px 14px; border: 0; border-bottom: 1px solid var(--theme-color-border-light, #e6e9ee);
			background: transparent; color: inherit; font: inherit; cursor: pointer;
			border-left: 3px solid transparent;
		}
		.pdh-ver:hover { background: var(--theme-color-background-hover, #f4f6fa); }
		.pdh-ver-selected {
			background: var(--theme-color-background-selected, #eef2ff);
			border-left-color: var(--theme-color-brand-primary, #4f95e8);
		}
		.pdh-ver-line1 { display: flex; align-items: baseline; gap: 8px; }
		.pdh-ver-author { font-weight: 600; }
		.pdh-ver-when { color: var(--theme-color-text-secondary, #5b6376); font-size: 12px; margin-left: auto; white-space: nowrap; }
		.pdh-ver-msg { color: var(--theme-color-text-secondary, #5b6376); margin-top: 3px; overflow-wrap: anywhere; }
		.pdh-ver-meta { display: flex; align-items: center; gap: 6px; margin-top: 5px; flex-wrap: wrap; }
		.pdh-src {
			display: inline-block; padding: 1px 7px; border-radius: 999px; font-size: 11px;
			border: 1px solid var(--theme-color-border-default, #e6e9ee);
			color: var(--theme-color-text-secondary, #5b6376);
		}
		/* The side a change came from. Colour is a hint, never the only signal: the label reads
		   in words, so this stays legible to anyone who cannot separate these hues. */
		.pdh-src-platform { border-color: var(--theme-color-brand-primary, #4f95e8); color: var(--theme-color-brand-primary, #4f95e8); }
		.pdh-src-github { border-color: var(--theme-color-status-info, #2f77c8); color: var(--theme-color-status-info, #2f77c8); }
		.pdh-src-merge { border-color: var(--theme-color-status-warning, #d0902f); color: var(--theme-color-status-warning, #d0902f); }
		.pdh-chip { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }
		.pdh-hash { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }
		.pdh-note { padding: 16px 14px; color: var(--theme-color-text-secondary, #5b6376); }
		.pdh-error { padding: 16px 14px; color: var(--theme-color-status-error, #c8452f); }
	`,
	Templates:
	[
		{
			Hash: 'DocHistory-Timeline-Section',
			Template: /*html*/`
<div class="pdh-timeline">
	{~TS:DocHistory-Timeline-Head:AppData.DocHistoryTimelineState.TitleSlot~}
	{~TS:DocHistory-Timeline-Loading:AppData.DocHistoryTimelineState.LoadingSlot~}
	{~TS:DocHistory-Timeline-Error:AppData.DocHistoryTimelineState.ErrorSlot~}
	{~TS:DocHistory-Timeline-Empty:AppData.DocHistoryTimelineState.EmptySlot~}
	<ul class="pdh-versions">{~TS:DocHistory-Timeline-Version:AppData.DocHistoryTimelineState.Rows~}</ul>
</div>`
		},
		{
			Hash: 'DocHistory-Timeline-Head',
			Template: /*html*/`<div class="pdh-timeline-head">{~D:Record.Title~}</div>`
		},
		{
			Hash: 'DocHistory-Timeline-Loading',
			Template: /*html*/`<div class="pdh-note">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'DocHistory-Timeline-Error',
			Template: /*html*/`<div class="pdh-error">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'DocHistory-Timeline-Empty',
			Template: /*html*/`<div class="pdh-note">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'DocHistory-Timeline-Version',
			Template: /*html*/`
<li><button type="button" class="{~D:Record.RowClass~}" title="{~D:Record.ExactWhen~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].selectIndex({~D:Record.Index~})">
	<span class="pdh-ver-line1"><span class="pdh-ver-author">{~D:Record.Author~}</span><span class="pdh-ver-when">{~D:Record.When~}</span></span>
	<span class="pdh-ver-msg">{~D:Record.Message~}</span>
	<span class="pdh-ver-meta"><span class="pdh-src pdh-src-{~D:Record.SourceKind~}">{~D:Record.SourceLabel~}</span>{~TS:DocHistory-Timeline-Change:Record.ChangeSlot~}{~TS:DocHistory-Timeline-Hash:Record.HashSlot~}{~TS:DocHistory-Timeline-Upstream:Record.UpstreamSlot~}</span>
</button></li>`
		},
		{
			Hash: 'DocHistory-Timeline-Change',
			Template: /*html*/`<span class="pdh-chip">{~D:Record.Label~}</span>`
		},
		{
			Hash: 'DocHistory-Timeline-Hash',
			Template: /*html*/`<span class="pdh-hash">{~D:Record.ShortCommit~}</span>`
		},
		{
			Hash: 'DocHistory-Timeline-Upstream',
			Template: /*html*/`<span class="pdh-hash">from {~D:Record.UpstreamRef~}</span>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'DocHistory-Timeline-Section',
			TemplateHash: 'DocHistory-Timeline-Section',
			DestinationAddress: '#DocHistory-Timeline-Container'
		}
	],

	// ---- host callbacks ----
	// REQUIRED. onLoadHistory(pPath, pLimit, fCallback) -> fCallback(error, { Events: [...], More: bool })
	// An Event is the documented shape:
	//   { Commit, Parent, Date, Source, AuthorName, AuthorEmail, IDUser,
	//     UpstreamCommitSHA, IDDocSyncBinding, Message, FilesChanged, PathChange }
	// Unknown extra fields are carried through untouched.
	onLoadHistory: null,
	// onSelectVersion(pEvent, pPreviousEvent, pPath) - a version was clicked. pPreviousEvent is
	// the next-older version in the list (null for the oldest), so (previous -> event) is the
	// change this version introduced.
	onSelectVersion: null,
	// onError(pError) - the host decides how to surface a failed load; without it the view
	// simply shows its error row.
	onError: null
};

class PictViewDocHistoryTimeline extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._events = [];
		this._selectedCommit = '';
		this._loading = false;
		this._error = '';
		this._loaded = false;
	}

	// The shaped state the templates read, published to one shared address just before each
	// render (the convention this section family uses). Two timelines on one page do not
	// collide: each republishes immediately before its own render, and every inline handler
	// carries that instance's own ViewHash rather than reading the shared slice.
	_publishState()
	{
		let tmpViewHash = this.Hash;
		let tmpRows = this._events.map((pEvent, pIndex) =>
		{
			let tmpSource = pEvent.Source || '';
			return {
				ViewHash: tmpViewHash,
				Index: pIndex,
				RowClass: (this._selectedCommit && pEvent.Commit === this._selectedCommit) ? 'pdh-ver pdh-ver-selected' : 'pdh-ver',
				Commit: pEvent.Commit || '',
				ShortCommit: libModel.shortCommit(pEvent.Commit),
				Selected: (this._selectedCommit && pEvent.Commit === this._selectedCommit),
				Author: libModel.escapeHTML(pEvent.AuthorName || 'Someone'),
				SourceLabel: libModel.escapeHTML(libModel.sourceLabel(tmpSource)),
				SourceKind: libModel.sourceKind(tmpSource),
				When: libModel.escapeHTML(libModel.relativeDate(pEvent.Date)),
				ExactWhen: libModel.escapeHTML(pEvent.Date || ''),
				Message: libModel.escapeHTML(pEvent.Message || ''),
				PathChange: libModel.escapeHTML(pEvent.PathChange || ''),
				FilesChanged: Number(pEvent.FilesChanged) || 0,
				// Optional detail rides in as a zero-or-one slot, so the template stays logic-free.
				ChangeSlot: pEvent.PathChange ? [{ Label: libModel.escapeHTML(pEvent.PathChange) }] : [],
				HashSlot: this.options.ShowCommitHash ? [{ ShortCommit: libModel.shortCommit(pEvent.Commit) }] : [],
				UpstreamSlot: (this.options.ShowUpstreamRef && pEvent.UpstreamCommitSHA)
					? [{ UpstreamRef: libModel.escapeHTML(libModel.shortCommit(pEvent.UpstreamCommitSHA)) }] : []
			};
		});
		let tmpIsEmpty = (!this._loading && !this._error && this._loaded && tmpRows.length === 0);
		this.pict.AppData.DocHistoryTimelineState =
		{
			ViewHash: tmpViewHash,
			Title: libModel.escapeHTML(this.options.Title || ''),
			// Slots render zero or one time through {~TS:~}, which is how this family does a
			// conditional block without putting logic in a template.
			TitleSlot: (this.options.Title && String(this.options.Title).length) ? [{ Title: libModel.escapeHTML(this.options.Title) }] : [],
			LoadingSlot: this._loading ? [{ Message: libModel.escapeHTML(this.options.LoadingMessage || '') }] : [],
			ErrorSlot: this._error ? [{ Message: libModel.escapeHTML(this._error) }] : [],
			EmptySlot: tmpIsEmpty ? [{ Message: libModel.escapeHTML(this.options.EmptyMessage || '') }] : [],
			Rows: tmpRows
		};
		return this.pict.AppData.DocHistoryTimelineState;
	}

	// Point the timeline at a different document (or at '' for the whole tree) and reload.
	setPath(pPath)
	{
		this.options.Path = String(pPath || '');
		this._events = [];
		this._selectedCommit = '';
		this._loaded = false;
		return this.loadHistory();
	}

	// Ask the host for the versions and render them. Returns a promise so a host can await it;
	// errors land in the view rather than escaping as an unhandled rejection.
	loadHistory()
	{
		let tmpCallback = this.options.onLoadHistory;
		if (typeof tmpCallback !== 'function')
		{
			this._error = 'This history view has no onLoadHistory callback wired.';
			this._loading = false;
			this.render();
			return Promise.resolve(null);
		}
		this._loading = true;
		this._error = '';
		this.render();
		return new Promise((resolve) =>
		{
			tmpCallback(this.options.Path || '', Number(this.options.PageSize) || 40, (pError, pResult) =>
			{
				this._loading = false;
				this._loaded = true;
				if (pError)
				{
					this._error = (pError && pError.message) || String(pError);
					if (typeof this.options.onError === 'function') { this.options.onError(pError); }
				}
				else
				{
					this._events = ((pResult && pResult.Events) || []).slice();
					// Default the selection to the newest version so a host that wires a diff
					// pane has something to show the moment the timeline lands.
					if (!this._selectedCommit && this._events.length) { this._selectedCommit = this._events[0].Commit || ''; }
				}
				this.render();
				resolve(pResult || null);
			});
		});
	}

	// The versions currently loaded (newest first), for a host driving its own layout.
	events() { return this._events.slice(); }

	selectedEvent()
	{
		return this._events.filter((pEvent) => pEvent.Commit === this._selectedCommit)[0] || null;
	}

	// Inline handler target: a version row was clicked.
	selectIndex(pIndex)
	{
		let tmpIndex = Number(pIndex);
		let tmpEvent = this._events[tmpIndex];
		if (!tmpEvent) { return; }
		this._selectedCommit = tmpEvent.Commit || '';
		this.render();
		if (typeof this.options.onSelectVersion === 'function')
		{
			// The next entry is the next-older version, so (previous -> selected) is the change
			// this version introduced. Falling back to the event's own Parent keeps that true at
			// the end of a page, where the older version is real but simply not loaded.
			let tmpPrevious = this._events[tmpIndex + 1] || (tmpEvent.Parent ? { Commit: tmpEvent.Parent } : null);
			this.options.onSelectVersion(tmpEvent, tmpPrevious, this.options.Path || '');
		}
	}

	onBeforeRender()
	{
		this._publishState();
		return super.onBeforeRender();
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewDocHistoryTimeline;
module.exports.default_configuration = _DefaultConfiguration;

},{"../DocHistoryModel.js":200,"pict-view":365}],204:[function(require,module,exports){
/**
 * Default configuration for pict-section-excalidraw.
 *
 * Lives in its own file (mirrors pict-section-code) so the configuration —
 * including the (substantial) CSS — can be reasoned about without scrolling
 * past the view's lifecycle code.
 */

// CSS for the excalidraw wrapper.  All colors flow through pict-section-theme
// CSS custom properties (var(--theme-color-*, fallback)) so the control re-tints
// automatically when the app switches themes.  Layout values are local —
// Excalidraw's own chrome owns its internal sizing.
const _CSS = `.pict-excalidraw-wrap
{
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 320px;
	background: var(--theme-color-background-panel, #FFFFFF);
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
	font-family: var(--theme-typography-family-base, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
	color: var(--theme-color-text-primary, #1A1A1A);
}

/* Theme bridge: forward pict tokens into the variables Excalidraw's own
   stylesheet reads.  See vendor/excalidraw/packages/excalidraw/css/ for the
   token names.  We default to the official light palette so Excalidraw renders
   correctly even before a pict theme overrides anything. */
.pict-excalidraw-wrap
{
	--default-bg-color:       var(--theme-color-background-panel,    #FFFFFF);
	--island-bg-color:        var(--theme-color-background-secondary, #FFFFFF);
	--input-bg-color:         var(--theme-color-background-primary,   #FFFFFF);
	--input-border-color:     var(--theme-color-border-default,       #D0D0D0);
	--text-primary-color:     var(--theme-color-text-primary,         #1A1A1A);
	--color-primary:          var(--theme-color-brand-primary,        #6965DB);
	--color-primary-darker:   var(--theme-color-brand-primary-hover,  #5754C4);
	--color-primary-darkest:  var(--theme-color-brand-primary-hover,  #4642B7);
	--color-on-primary-container: var(--theme-color-background-panel, #FFFFFF);
	--button-hover-bg:        var(--theme-color-background-hover,     #F1F0FF);
	--button-active-bg:       var(--theme-color-background-selected,  #E3E2FE);
	--button-active-border:   var(--theme-color-brand-primary,        #6965DB);
	--popup-bg-color:         var(--theme-color-background-panel,     #FFFFFF);
	--popup-border-color:     var(--theme-color-border-default,       #D0D0D0);
	--icon-fill-color:        var(--theme-color-text-primary,         #1A1A1A);
	--shadow-island:          0 0 0 1px var(--theme-color-border-light, rgba(0,0,0,0.06)), 0 2px 6px 0 var(--theme-color-shadow-color, rgba(0,0,0,0.08));
}

/* iframe mode: the iframe element itself owns the entire wrap surface */
.pict-excalidraw-iframe
{
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	min-height: 320px;
	border: 0;
	background: var(--theme-color-background-panel, #FFFFFF);
}

/* react mode: a single inner div that Excalidraw mounts into via createRoot */
.pict-excalidraw-mount
{
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	min-height: 320px;
	position: relative;
}

/* Status / error overlay used by both modes before the third-party lib is
   wired up, or when bundling failed. */
.pict-excalidraw-status
{
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 8px;
	padding: 16px;
	background: var(--theme-color-background-panel, #FFFFFF);
	color: var(--theme-color-text-secondary, #4A4A4A);
	text-align: center;
	font-size: 14px;
	line-height: 1.4;
	z-index: 1;
}
.pict-excalidraw-status code
{
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace);
	font-size: 12px;
	padding: 2px 6px;
	background: var(--theme-color-background-secondary, #F4F4F4);
	border: 1px solid var(--theme-color-border-light, rgba(0,0,0,0.06));
	border-radius: 3px;
}
.pict-excalidraw-status.error
{
	color: var(--theme-color-status-error, #B43B3B);
}
`;

module.exports = ({
	"RenderOnLoad": true,

	"DefaultRenderable": "Excalidraw-Wrap",
	"DefaultDestinationAddress": "#Excalidraw-Container-Div",
	"TargetElementAddress": "#Excalidraw-Container-Div",

	// 'react' or 'iframe'.  React is cleanest for theme conformance; iframe is
	// the right choice if the host app's global CSS is aggressive enough to
	// bleed into Excalidraw and you'd rather pay the postMessage tax than fight
	// it.
	"EmbedMode": "react",

	// Address in AppData (dot-notation) to two-way bind the scene JSON into.
	// Set to false to opt out.
	"DrawingDataAddress": false,

	// 'light' | 'dark' | 'auto'.  'auto' follows the pict-section-theme mode
	// when the provider is present.
	"Theme": "light",

	"ViewModeEnabled": false,
	"ZenModeEnabled":  false,
	"GridModeEnabled": false,
	"LangCode":        "en",

	// Forwarded verbatim to <Excalidraw UIOptions={...}>.  See:
	// https://docs.excalidraw.com/docs/@excalidraw/excalidraw/api/props/ui-options
	"UIOptions": {},

	// Initial scene used when no OnLoad callback / DrawingDataAddress yields
	// anything.
	"InitialData":
	{
		"elements": [],
		"appState": {},
		"files":    {}
	},

	// Base URL the iframe / wrapper looks under for fonts + locales.  Set this
	// to wherever you copied vendor/excalidraw-built/assets/ at deploy time.
	"AssetBaseURL": "./excalidraw-assets/",

	// URL of the iframe host page (iframe mode only).  Defaults to
	// excalidraw-iframe-host.html sitting next to the page that loaded the
	// wrapper bundle.
	"IframeHostURL": "./excalidraw-iframe-host.html",

	// Lazy-loading: if the wrapper bundle isn't already on the page when the
	// view first mounts, fetch it on demand from these URLs.  Saves first-
	// paint cost for pages that don't have a diagram.  Leave null to require
	// the host to load the scripts via <script> tags (default — preserves
	// the existing eager-load behavior).
	//
	//   LazyLoadReactVendorURL: URL to react-vendor.min.js (or any script
	//                            that sets window.React + window.ReactDOM).
	//                            Skip if the host already loads React.
	//   LazyLoadWrapperURL:      URL to excalidraw-wrapper.min.js (or any
	//                            script that sets
	//                            window.PictSectionExcalidrawVendor).
	"LazyLoadReactVendorURL": null,
	"LazyLoadWrapperURL":     null,

	// Callback hooks — see README.  Signatures intentionally use Node-style
	// fCallback(err, value) so they compose with the rest of the Fable/Pict
	// async patterns.
	"OnLoad":   null,
	"OnSave":   null,
	"OnChange": null,

	// Throttle (ms) for the OnChange callback fired during active editing.
	// Excalidraw fires onChange on every pointer move; the wrapper batches.
	"OnChangeThrottleMs": 250,

	"Templates":
	[
		{
			"Hash": "Excalidraw-Container",
			"Template": "<!-- Excalidraw-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "Excalidraw-Wrap",
			"TemplateHash": "Excalidraw-Container",
			"DestinationAddress": "#Excalidraw-Container-Div"
		}
	],

	"CSS": _CSS
});

},{}],205:[function(require,module,exports){
/**
 * pict-section-excalidraw — main entry.
 *
 * Exports a single dispatch view class that picks between the React-mount and
 * iframe implementations at construction time based on the EmbedMode option.
 *
 * Consumers can either:
 *   1. Use the default export and pass EmbedMode in the configuration
 *   2. Pull the explicit implementation classes directly:
 *        const { ReactView, IframeView } = require('pict-section-excalidraw');
 */

const libPictViewClass            = require('pict-view');
const libExcalidrawReactView      = require('./views/PictView-Excalidraw-React.js');
const libExcalidrawIframeView     = require('./views/PictView-Excalidraw-Iframe.js');
const _DefaultConfiguration       = require('./Pict-Section-Excalidraw-DefaultConfiguration.js');

/**
 * Resolve which implementation class the consumer wants based on the merged
 * configuration.  Exposed so the dispatch view and any framework registration
 * helpers can agree on the same selection logic.
 */
function selectImplementation(pOptions)
{
	let tmpMode = ((pOptions && pOptions.EmbedMode) || _DefaultConfiguration.EmbedMode || 'react').toLowerCase();
	if (tmpMode === 'iframe')
	{
		return libExcalidrawIframeView;
	}
	return libExcalidrawReactView;
}

/**
 * PictSectionExcalidraw — thin dispatcher.  Constructs the chosen
 * implementation as a sibling pict-view on the same fable and proxies the
 * public surface onto it.  We don't extend either implementation directly
 * because the embed mode is a runtime decision, not a class-level one.
 */
class PictSectionExcalidraw extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this._ImplementationClass = selectImplementation(tmpOptions);

		// Instantiate the actual implementation view as a peer pict-view.  It
		// gets its own ViewIdentifier (suffixed) so AppData/template scopes
		// don't clash with the dispatcher.
		let tmpImplOptions = Object.assign({}, tmpOptions);
		tmpImplOptions.ViewIdentifier = (tmpOptions.ViewIdentifier || 'PictSectionExcalidraw') + '-Impl';

		this._Implementation = new this._ImplementationClass(pFable, tmpImplOptions, pServiceHash);

		// Public-API proxy: forward every method the implementations expose so
		// consumers can hold a reference to the dispatcher and not care which
		// mode is active.
		let tmpForwardedMethods =
		[
			'getScene', 'setScene', 'exportSvg', 'exportBlob', 'serialize',
			'setTheme', 'setReadOnly', 'load', 'save', 'destroy',
			'getApi', 'connectExcalidrawGlobal', 'isDestroyed',
			'convertMermaidToExcalidraw'
		];
		for (let i = 0; i < tmpForwardedMethods.length; i++)
		{
			let tmpName = tmpForwardedMethods[i];
			this[tmpName] = (...pArgs) =>
			{
				if (typeof this._Implementation[tmpName] === 'function')
				{
					return this._Implementation[tmpName].apply(this._Implementation, pArgs);
				}
				return undefined;
			};
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// The implementation is what actually owns the destination div.  We
		// render it once the dispatcher's own render cycle has fired so the
		// outer container exists.
		if (this._Implementation && typeof this._Implementation.render === 'function')
		{
			if (!this._dispatchedRender)
			{
				this._dispatchedRender = true;
				this._Implementation.render();
			}
		}

		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictSectionExcalidraw;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.ReactView             = libExcalidrawReactView;
module.exports.IframeView            = libExcalidrawIframeView;
module.exports.selectImplementation  = selectImplementation;

// Form-side integration: the `Diagram` InputType (and its provider class) lives
// in pict-section-form under `providers/inputs/Pict-Provider-Input-Diagram.js`,
// not here. The provider lazy-requires this module on the first setMode('edit')
// so consumers that never edit don't pull the Excalidraw vendor bundle.
//
//   const libDiagramInput = require('pict-section-form').DiagramInput;
//   pict.addProvider('Pict-Input-Diagram',
//       libDiagramInput.default_configuration, libDiagramInput);
//
// The Themeify-SVG utility (used to rewrite Excalidraw hex colors to CSS
// variables on save) is now exposed as `require('pict-section-form').themeifySVG`.

},{"./Pict-Section-Excalidraw-DefaultConfiguration.js":204,"./views/PictView-Excalidraw-Iframe.js":206,"./views/PictView-Excalidraw-React.js":207,"pict-view":365}],206:[function(require,module,exports){
/**
 * PictView-Excalidraw-Iframe — iframe embedding of Excalidraw.
 *
 * The destination div hosts an <iframe> pointing at our vendored
 * excalidraw-iframe-host.html.  Communication happens through window.postMessage
 * with a small protocol:
 *
 *   parent -> iframe :  { type: 'pict-excalidraw:init',  payload: { initialData, theme, langCode, viewModeEnabled, ... } }
 *   parent -> iframe :  { type: 'pict-excalidraw:setScene',  payload: { elements, appState, files } }
 *   parent -> iframe :  { type: 'pict-excalidraw:setTheme',  payload: 'light' | 'dark' }
 *   parent -> iframe :  { type: 'pict-excalidraw:setReadOnly', payload: bool }
 *   parent -> iframe :  { type: 'pict-excalidraw:setThemeTokens', payload: { '--theme-color-...': '#xxx', ... } }
 *   parent -> iframe :  { type: 'pict-excalidraw:requestScene', requestId }
 *   parent -> iframe :  { type: 'pict-excalidraw:requestSvg',   requestId, exportOptions }
 *
 *   iframe -> parent :  { type: 'pict-excalidraw:ready' }
 *   iframe -> parent :  { type: 'pict-excalidraw:change',     payload: { elements, appState, files } }
 *   iframe -> parent :  { type: 'pict-excalidraw:sceneReply', requestId, payload }
 *   iframe -> parent :  { type: 'pict-excalidraw:svgReply',   requestId, payload }
 *
 * The iframe runs the same wrapper bundle as the React-mount mode — see
 * excalidraw-iframe-host.html.
 */

const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('../Pict-Section-Excalidraw-DefaultConfiguration.js');

class PictViewExcalidrawIframe extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;
		this.targetElement = false;
		this._iframeElement = null;
		this._wrapElement   = null;
		this._statusElement = null;
		this._iframeReady   = false;

		this._pendingRequests   = Object.create(null);
		this._nextRequestId     = 1;
		this._lastSceneSnapshot = null;
		this._messageListener   = null;

		this._onChangeThrottleHandle = null;
		this._lastSeenChangeSnapshot = null;
		this._currentTheme = this.options.Theme || 'light';

		// Set true by destroy(); gates public API methods + the throttle
		// callback against post-teardown state mutations.
		this._destroyed = false;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		let tmpTargetSet = this.pict.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetSet || tmpTargetSet.length < 1)
		{
			this.log.error(`PICT-Excalidraw (iframe) could not find target [${this.options.TargetElementAddress}].`);
			return false;
		}
		this.targetElement = tmpTargetSet[0];

		this._buildContainerDOM();
		this._wireMessageListener();
		this._mountIframe();
	}

	_buildContainerDOM()
	{
		this.targetElement.innerHTML = '';

		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-excalidraw-wrap pict-excalidraw-wrap-iframe';

		let tmpStatus = document.createElement('div');
		tmpStatus.className = 'pict-excalidraw-status';
		tmpStatus.innerHTML = 'Loading Excalidraw…';
		tmpWrap.appendChild(tmpStatus);

		let tmpIframe = document.createElement('iframe');
		tmpIframe.className = 'pict-excalidraw-iframe';
		tmpIframe.setAttribute('title', 'Excalidraw drawing');
		tmpIframe.setAttribute('allow', 'clipboard-read; clipboard-write');
		tmpWrap.appendChild(tmpIframe);

		this.targetElement.appendChild(tmpWrap);

		this._wrapElement   = tmpWrap;
		this._iframeElement = tmpIframe;
		this._statusElement = tmpStatus;
	}

	_wireMessageListener()
	{
		// MessageEvent is one of the few cases where addEventListener is
		// legitimate — window-level events don't have an inline-handler
		// equivalent.  See pict CLAUDE.md "legitimate exceptions".
		this._messageListener = (pEvent) =>
		{
			if (!pEvent || !pEvent.data || typeof pEvent.data !== 'object') return;
			if (pEvent.source !== (this._iframeElement && this._iframeElement.contentWindow)) return;
			this._handleIframeMessage(pEvent.data);
		};
		window.addEventListener('message', this._messageListener);
	}

	_mountIframe()
	{
		let tmpUrl = this.options.IframeHostURL || './excalidraw-iframe-host.html';
		this._iframeElement.src = tmpUrl;
	}

	_postToIframe(pMessage)
	{
		if (!this._iframeElement || !this._iframeElement.contentWindow) return false;
		this._iframeElement.contentWindow.postMessage(pMessage, '*');
		return true;
	}

	_handleIframeMessage(pData)
	{
		switch (pData.type)
		{
			case 'pict-excalidraw:ready':
				this._iframeReady = true;
				if (this._statusElement) this._statusElement.style.display = 'none';
				this._sendInitMessage();
				return;

			case 'pict-excalidraw:change':
				this._handleChange(pData.payload);
				return;

			case 'pict-excalidraw:sceneReply':
			case 'pict-excalidraw:svgReply':
			case 'pict-excalidraw:blobReply':
			{
				let tmpReq = this._pendingRequests[pData.requestId];
				if (tmpReq)
				{
					clearTimeout(tmpReq.timeout);
					delete this._pendingRequests[pData.requestId];
					tmpReq.resolve(pData.payload);
				}
				return;
			}

			case 'pict-excalidraw:error':
			{
				let tmpReq = pData.requestId && this._pendingRequests[pData.requestId];
				if (tmpReq)
				{
					clearTimeout(tmpReq.timeout);
					delete this._pendingRequests[pData.requestId];
					tmpReq.reject(new Error(pData.message || 'iframe error'));
				}
				else
				{
					this.log.error(`PICT-Excalidraw (iframe) error: ${pData.message}`);
				}
				return;
			}

			default:
				// Unknown message — ignored
				return;
		}
	}

	_sendInitMessage()
	{
		let tmpInitial = this._resolveInitialData();
		this._postToIframe({
			type: 'pict-excalidraw:init',
			payload:
			{
				initialData:     tmpInitial,
				theme:           this._resolveTheme(this._currentTheme),
				langCode:        this.options.LangCode || 'en',
				viewModeEnabled: !!this.options.ViewModeEnabled,
				zenModeEnabled:  !!this.options.ZenModeEnabled,
				gridModeEnabled: !!this.options.GridModeEnabled,
				UIOptions:       this.options.UIOptions || {},
				assetBaseURL:    this.options.AssetBaseURL
			}
		});

		// Push theme tokens into the iframe so its CSS variables resolve.
		this._pushThemeTokens();

		// Deferred OnLoad fires now that the iframe is ready.
		if (typeof this.options.OnLoad === 'function')
		{
			this.load();
		}
	}

	_pushThemeTokens()
	{
		if (typeof document === 'undefined' || !document.documentElement) return;
		// Snapshot the theme variables off documentElement's computed style.
		// We only forward variables we know Excalidraw consumes (the bridge
		// vars baked into the wrap CSS), not the entire theme catalog.
		let tmpVars = [
			'--theme-color-background-panel',
			'--theme-color-background-primary',
			'--theme-color-background-secondary',
			'--theme-color-background-hover',
			'--theme-color-background-selected',
			'--theme-color-border-default',
			'--theme-color-border-light',
			'--theme-color-text-primary',
			'--theme-color-text-secondary',
			'--theme-color-brand-primary',
			'--theme-color-brand-primary-hover',
			'--theme-color-status-error',
			'--theme-color-shadow-color'
		];
		let tmpStyle = window.getComputedStyle(document.documentElement);
		let tmpPayload = {};
		for (let i = 0; i < tmpVars.length; i++)
		{
			let tmpVal = tmpStyle.getPropertyValue(tmpVars[i]).trim();
			if (tmpVal) tmpPayload[tmpVars[i]] = tmpVal;
		}
		this._postToIframe({ type: 'pict-excalidraw:setThemeTokens', payload: tmpPayload });
	}

	_resolveInitialData()
	{
		if (this.options.DrawingDataAddress)
		{
			let tmpFromAppData = this._readAppData(this.options.DrawingDataAddress);
			if (tmpFromAppData && tmpFromAppData.elements) return tmpFromAppData;
		}
		return this.options.InitialData || { elements: [], appState: {}, files: {} };
	}

	_resolveTheme(pTheme)
	{
		if (pTheme === 'auto')
		{
			if (typeof document !== 'undefined' && document.documentElement)
			{
				if (document.documentElement.classList && document.documentElement.classList.contains('theme-mode-dark'))
				{
					return 'dark';
				}
			}
			let tmpThemeProvider = this.pict && this.pict.providers && this.pict.providers.ThemeSection;
			if (tmpThemeProvider && tmpThemeProvider.getCurrentMode)
			{
				let tmpMode = tmpThemeProvider.getCurrentMode();
				if (tmpMode === 'dark') return 'dark';
				if (tmpMode === 'light') return 'light';
			}
			return 'light';
		}
		return (pTheme === 'dark') ? 'dark' : 'light';
	}

	_handleChange(pSnap)
	{
		if (this._destroyed) return;
		this._lastSceneSnapshot = pSnap;
		this._lastSeenChangeSnapshot = pSnap;
		if (this._onChangeThrottleHandle) return;

		let tmpDelay = this.options.OnChangeThrottleMs || 250;
		this._onChangeThrottleHandle = setTimeout(() =>
		{
			this._onChangeThrottleHandle = null;
			if (this._destroyed) return;
			let tmpFinal = this._lastSeenChangeSnapshot;
			if (!tmpFinal) return;

			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, tmpFinal);
			}
			if (typeof this.options.OnChange === 'function')
			{
				try { this.options.OnChange(this, tmpFinal); }
				catch (pErr) { this.log.error(`PICT-Excalidraw OnChange threw: ${pErr && pErr.message}`); }
			}
		}, tmpDelay);
	}

	_readAppData(pAddress)
	{
		if (!pAddress) return null;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.getValueByHash)
			{
				return this.fable.manifest.getValueByHash(this.pict.AppData, tmpRelative);
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length; i++)
			{
				if (tmpCursor == null) return null;
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			return tmpCursor;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw read AppData failed: ${pErr && pErr.message}`);
			return null;
		}
	}

	_writeAppData(pAddress, pValue)
	{
		if (!pAddress) return false;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.setValueByHash)
			{
				this.fable.manifest.setValueByHash(this.pict.AppData, tmpRelative, pValue);
				return true;
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length - 1; i++)
			{
				if (tmpCursor[tmpParts[i]] == null) tmpCursor[tmpParts[i]] = {};
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			tmpCursor[tmpParts[tmpParts.length - 1]] = pValue;
			return true;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw write AppData failed: ${pErr && pErr.message}`);
			return false;
		}
	}

	_request(pType, pExtra)
	{
		let tmpId = (this._nextRequestId++);
		return new Promise((fResolve, fReject) =>
		{
			this._pendingRequests[tmpId] = { resolve: fResolve, reject: fReject };
			this._postToIframe(Object.assign({ type: pType, requestId: tmpId }, pExtra || {}));
			// Safety timeout — 30s (cleared on reply / destroy)
			this._pendingRequests[tmpId].timeout = setTimeout(() =>
			{
				if (this._pendingRequests[tmpId])
				{
					delete this._pendingRequests[tmpId];
					fReject(new Error('iframe request timed out'));
				}
			}, 30000);
		});
	}

	// ---- Public API ---------------------------------------------------------

	getApi() { return null; /* iframe mode hides the live API behind postMessage */ }

	/**
	 * Iframe mode returns the most recent change snapshot synchronously, and
	 * the live scene asynchronously via requestScene().  Most callers want the
	 * sync snapshot — for the freshest one, await requestScene().
	 */
	getScene() { return this._lastSceneSnapshot; }

	requestScene() { return this._request('pict-excalidraw:requestScene'); }

	setScene(pSceneData)
	{
		if (!pSceneData) return false;
		this._postToIframe({ type: 'pict-excalidraw:setScene', payload: pSceneData });
		return true;
	}

	exportSvg(pOpts)
	{
		return this._request('pict-excalidraw:requestSvg', { exportOptions: pOpts || {} });
	}

	exportBlob(pOpts)
	{
		return this._request('pict-excalidraw:requestBlob', { exportOptions: pOpts || {} });
	}

	serialize()
	{
		let tmpScene = this._lastSceneSnapshot;
		if (!tmpScene) return null;
		return JSON.stringify({
			type: 'excalidraw',
			version: 2,
			source: 'pict-section-excalidraw',
			elements: tmpScene.elements || [],
			appState: tmpScene.appState || {},
			files:    tmpScene.files    || {}
		});
	}

	setTheme(pTheme)
	{
		this._currentTheme = pTheme || 'light';
		let tmpResolved = this._resolveTheme(this._currentTheme);
		this._postToIframe({ type: 'pict-excalidraw:setTheme', payload: tmpResolved });
		this._pushThemeTokens();
	}

	setReadOnly(pReadOnly)
	{
		this.options.ViewModeEnabled = !!pReadOnly;
		this._postToIframe({ type: 'pict-excalidraw:setReadOnly', payload: !!pReadOnly });
	}

	load()
	{
		if (typeof this.options.OnLoad === 'function')
		{
			this.options.OnLoad(this, (pErr, pSceneData) =>
			{
				if (pErr) { this.log.error(`PICT-Excalidraw OnLoad error: ${pErr.message || pErr}`); return; }
				if (pSceneData) this.setScene(pSceneData);
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			let tmpScene = this._readAppData(this.options.DrawingDataAddress);
			if (tmpScene) this.setScene(tmpScene);
		}
	}

	save()
	{
		// Iframe mode: prefer the snapshot, but freshen via requestScene if we
		// don't have one yet.
		let tmpResolveAndSave = (pScene) =>
		{
			if (!pScene) return;
			if (typeof this.options.OnSave === 'function')
			{
				this.options.OnSave(this, pScene, (pErr) =>
				{
					if (pErr) this.log.error(`PICT-Excalidraw OnSave error: ${pErr.message || pErr}`);
				});
				return;
			}
			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, pScene);
			}
		};
		if (this._lastSceneSnapshot)
		{
			tmpResolveAndSave(this._lastSceneSnapshot);
			return;
		}
		this.requestScene().then(tmpResolveAndSave).catch((pErr) =>
		{
			this.log.error(`PICT-Excalidraw save scene fetch failed: ${pErr.message || pErr}`);
		});
	}

	/**
	 * Tear down the iframe + message listener + pending request promises.
	 * Idempotent.  After destroy(), public API methods short-circuit so
	 * post-teardown calls don't crash.
	 */
	destroy()
	{
		if (this._destroyed) return;
		this._destroyed = true;

		if (this._onChangeThrottleHandle)
		{
			clearTimeout(this._onChangeThrottleHandle);
			this._onChangeThrottleHandle = null;
		}
		this._lastSeenChangeSnapshot = null;

		if (this._messageListener)
		{
			try { window.removeEventListener('message', this._messageListener); }
			catch (pErr) { /* ignore */ }
			this._messageListener = null;
		}

		// Reject any in-flight request promises so awaiters get a real
		// error instead of waiting 30s for the safety timeout.
		let tmpReqKeys = Object.keys(this._pendingRequests);
		for (let i = 0; i < tmpReqKeys.length; i++)
		{
			let tmpReq = this._pendingRequests[tmpReqKeys[i]];
			if (tmpReq && typeof tmpReq.reject === 'function')
			{
				clearTimeout(tmpReq.timeout);
					try { tmpReq.reject(new Error('view destroyed')); }
				catch (pErr) { /* ignore */ }
			}
		}
		this._pendingRequests = Object.create(null);

		// Force-stop the iframe.  Navigating to about:blank unmounts the
		// React tree inside it cleanly; just nulling our reference would
		// leave the page running until GC.
		if (this._iframeElement)
		{
			try { this._iframeElement.src = 'about:blank'; }
			catch (pErr) { /* ignore */ }
		}

		// Clear the destination DOM so a subsequent re-render starts clean.
		if (this.targetElement && this.targetElement.innerHTML !== undefined)
		{
			try { this.targetElement.innerHTML = ''; }
			catch (pErr) { /* ignore */ }
		}

		this._iframeReady = false;
		this._lastSceneSnapshot = null;
		this._iframeElement = null;
		this._statusElement = null;
		this._wrapElement = null;
		this.targetElement = false;
		this.initialRenderComplete = false;
	}

	/** Whether destroy() has been called. */
	isDestroyed()
	{
		return !!this._destroyed;
	}
}

module.exports = PictViewExcalidrawIframe;
module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":204,"pict-view":365}],207:[function(require,module,exports){
/**
 * PictView-Excalidraw-React — React-mount embedding of Excalidraw.
 *
 * Mirrors the pict-section-code <-> CodeJar pattern: a wrapper script is loaded
 * via <script> tag in the HTML shell that puts React, ReactDOM, and Excalidraw
 * on the window as PictSectionExcalidrawVendor.  This view picks those up at
 * onAfterInitialRender, calls ReactDOM.createRoot on the destination div, and
 * mounts <Excalidraw> with our merged props.
 *
 * Lifecycle:
 *   onBeforeInitialize  -> seed instance fields
 *   onAfterRender       -> inject CSS, run initial-render hook once
 *   onAfterInitialRender-> resolve vendor globals, mount root, fire OnLoad
 *   destroy             -> unmount root, drop references
 *
 * AppData binding mirrors pict-section-code: if DrawingDataAddress is set we
 * read it on load and write it on change (via the OnChange throttle).
 */

const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('../Pict-Section-Excalidraw-DefaultConfiguration.js');

class PictViewExcalidrawReact extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// Vendor globals are resolved lazily on first render so the consumer
		// can either load them via a <script> tag (preferred) or hand them in
		// explicitly via connectExcalidrawGlobal().
		this._vendor = null;

		// React root + the live Excalidraw API handle, both populated on mount.
		this._reactRoot       = null;
		this._excalidrawAPI   = null;
		this.targetElement    = false;
		this._wrapElement     = null;
		this._mountElement    = null;
		this._statusElement   = null;

		// Throttle bookkeeping for the OnChange callback.
		this._onChangeThrottleHandle = null;
		this._lastSeenChangeSnapshot = null;

		// Set when InitialData isn't directly available and we want OnLoad
		// to fire once the excalidrawAPI callback runs.
		this._pendingDeferredLoad = false;

		// Set true by destroy(); gates public methods that touch DOM/React.
		this._destroyed = false;

		// Current theme mirror.  Updated by setTheme() so re-mounts on resize
		// pick the most recent value rather than the original option.
		this._currentTheme = this.options.Theme || 'light';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();
		return super.onBeforeInitialize();
	}

	/**
	 * Connect the vendor globals explicitly.  If not called, the view will
	 * look for window.PictSectionExcalidrawVendor at first render.
	 *
	 * @param {{ React: any, ReactDOM: any, Excalidraw: any,
	 *           exportToSvg?: Function, exportToBlob?: Function,
	 *           serializeAsJSON?: Function }} pVendor
	 */
	connectExcalidrawGlobal(pVendor)
	{
		if (pVendor && pVendor.Excalidraw && pVendor.React && pVendor.ReactDOM)
		{
			this._vendor = pVendor;
			return true;
		}
		return false;
	}

	_resolveVendor()
	{
		if (this._vendor) return this._vendor;
		if (typeof window !== 'undefined' && window.PictSectionExcalidrawVendor)
		{
			let tmpV = window.PictSectionExcalidrawVendor;
			if (tmpV.Excalidraw && tmpV.React && tmpV.ReactDOM)
			{
				this._vendor = tmpV;
				return tmpV;
			}
		}
		return null;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		// Locate the container.  We expect the consumer to have placed a div
		// at TargetElementAddress that we own from here on.
		let tmpTargetSet = this.pict.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetSet || tmpTargetSet.length < 1)
		{
			this.log.error(`PICT-Excalidraw could not find target element [${this.options.TargetElementAddress}].`);
			return false;
		}
		this.targetElement = tmpTargetSet[0];

		this._buildContainerDOM();

		let tmpVendor = this._resolveVendor();
		if (tmpVendor)
		{
			this._mountReact(tmpVendor);
			return;
		}

		// No vendor globals on the page yet.  If lazy-load URLs are configured,
		// inject the scripts on demand; otherwise fail loudly with a status
		// message and a console error so the developer knows what's missing.
		if (this.options.LazyLoadWrapperURL)
		{
			this._renderStatus('Loading Excalidraw…', /* isError */ false);
			this._lazyLoadVendor().then(() =>
			{
				if (this._destroyed) return;
				let tmpReVendor = this._resolveVendor();
				if (tmpReVendor)
				{
					this._mountReact(tmpReVendor);
				}
				else
				{
					this._renderStatus(
						'Excalidraw failed to lazy-load.  Check the network tab for ' +
						'<code>excalidraw-wrapper.min.js</code>.',
						/* isError */ true
					);
				}
			}).catch((pErr) =>
			{
				this.log.error(`PICT-Excalidraw lazy-load failed: ${pErr && pErr.message}`);
				this._renderStatus('Excalidraw lazy-load failed: <code>' +
					((pErr && pErr.message) || 'unknown error') + '</code>',
					/* isError */ true);
			});
			return;
		}

		this._renderStatus(
			'Excalidraw wrapper bundle not loaded.  Include ' +
			'<code>excalidraw-wrapper.min.js</code> via a script tag, set ' +
			'<code>LazyLoadWrapperURL</code> in the view options, or call ' +
			'<code>connectExcalidrawGlobal({React, ReactDOM, Excalidraw})</code>.',
			/* isError */ true
		);
		this.log.error('PICT-Excalidraw vendor bundle not found; cannot mount.');
		return false;
	}

	/**
	 * Inject the configured react-vendor + wrapper scripts and resolve once
	 * window.PictSectionExcalidrawVendor exists.  Idempotent — multiple
	 * views mounting at the same time share a single in-flight load.
	 */
	_lazyLoadVendor()
	{
		if (typeof window === 'undefined') return Promise.reject(new Error('no window'));

		// Already loaded (a previous view kicked it off and it finished).
		if (window.PictSectionExcalidrawVendor) return Promise.resolve();

		// Shared in-flight load.  Stash the promise on window so concurrent
		// view mounts reuse it instead of injecting duplicate <script> tags.
		if (window.__pictExcalidrawLazyLoadPromise)
		{
			return window.__pictExcalidrawLazyLoadPromise;
		}

		let tmpReactURL   = this.options.LazyLoadReactVendorURL;
		let tmpWrapperURL = this.options.LazyLoadWrapperURL;

		let tmpInjectScript = (pUrl) => new Promise((fResolve, fReject) =>
		{
			let tmpScript = document.createElement('script');
			tmpScript.src   = pUrl;
			tmpScript.async = false;
			tmpScript.onload  = () => fResolve();
			tmpScript.onerror = () => fReject(new Error('failed to load ' + pUrl));
			document.head.appendChild(tmpScript);
		});

		let tmpChain = Promise.resolve();
		if (tmpReactURL && !window.React)
		{
			tmpChain = tmpChain.then(() => tmpInjectScript(tmpReactURL));
		}
		tmpChain = tmpChain.then(() => tmpInjectScript(tmpWrapperURL));
		tmpChain = tmpChain.then(() =>
		{
			if (!window.PictSectionExcalidrawVendor)
			{
				throw new Error('wrapper loaded but window.PictSectionExcalidrawVendor was not set');
			}
		}).finally(() =>
		{
			// Clear the in-flight handle whether we succeeded or failed —
			// subsequent retries get a fresh attempt instead of latching on
			// to a rejected promise.
			window.__pictExcalidrawLazyLoadPromise = null;
		});

		window.__pictExcalidrawLazyLoadPromise = tmpChain;
		return tmpChain;
	}

	_buildContainerDOM()
	{
		this.targetElement.innerHTML = '';

		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-excalidraw-wrap pict-excalidraw-wrap-react';

		let tmpMount = document.createElement('div');
		tmpMount.className = 'pict-excalidraw-mount';
		tmpWrap.appendChild(tmpMount);

		let tmpStatus = document.createElement('div');
		tmpStatus.className = 'pict-excalidraw-status';
		tmpStatus.style.display = 'none';
		tmpWrap.appendChild(tmpStatus);

		this.targetElement.appendChild(tmpWrap);

		this._wrapElement   = tmpWrap;
		this._mountElement  = tmpMount;
		this._statusElement = tmpStatus;
	}

	_renderStatus(pMessageHTML, pIsError)
	{
		if (!this._statusElement) return;
		this._statusElement.style.display = 'flex';
		this._statusElement.classList.toggle('error', !!pIsError);
		this._statusElement.innerHTML = pMessageHTML;
	}

	_hideStatus()
	{
		if (!this._statusElement) return;
		this._statusElement.style.display = 'none';
	}

	_mountReact(pVendor)
	{
		let tmpReact     = pVendor.React;
		let tmpReactDOM  = pVendor.ReactDOM;
		let tmpExcalidraw = pVendor.Excalidraw;

		let tmpInitialData = this._resolveInitialData();

		// Resolve theme — 'auto' follows the pict theme provider if present.
		let tmpResolvedTheme = this._resolveTheme(this._currentTheme);

		let tmpProps =
		{
			initialData:     tmpInitialData,
			theme:           tmpResolvedTheme,
			langCode:        this.options.LangCode || 'en',
			viewModeEnabled: !!this.options.ViewModeEnabled,
			zenModeEnabled:  !!this.options.ZenModeEnabled,
			gridModeEnabled: !!this.options.GridModeEnabled,
			UIOptions:       this.options.UIOptions || {},
			// NOTE: the public prop in @excalidraw/excalidraw is
			// `onExcalidrawAPI` (despite some older docs / community
			// wrappers referring to `excalidrawAPI`).  See
			// packages/excalidraw/index.tsx — `excalidrawAPI` is just the
			// shape of the mountPayload object passed through the context.
			onExcalidrawAPI: (pApi) =>
			{
				this._excalidrawAPI = pApi;
				// Now that the API exists, we can satisfy any deferred load.
				if (this._pendingDeferredLoad)
				{
					this._pendingDeferredLoad = false;
					this.load();
				}
			},
			onChange: (pElements, pAppState, pFiles) =>
			{
				this._handleChange(pElements, pAppState, pFiles);
			}
		};

		// Set the EXCALIDRAW_ASSET_PATH global if the bundle hasn't already.
		// Excalidraw uses this to locate fonts + locale chunks.
		if (typeof window !== 'undefined' && this.options.AssetBaseURL && !window.EXCALIDRAW_ASSET_PATH)
		{
			window.EXCALIDRAW_ASSET_PATH = this.options.AssetBaseURL;
		}

		try
		{
			this._reactRoot = tmpReactDOM.createRoot(this._mountElement);
			this._reactRoot.render(
				tmpReact.createElement(tmpExcalidraw, tmpProps)
			);
			this._hideStatus();
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw mount failed: ${pErr && pErr.message}`);
			this._renderStatus('Excalidraw failed to mount: <code>' +
				(pErr && pErr.message ? pErr.message : 'unknown error') +
				'</code>', /* isError */ true);
		}
	}

	_resolveInitialData()
	{
		// 1. Explicit InitialData in options wins for the synchronous mount.
		//    OnLoad fires asynchronously and replaces the scene via setScene
		//    once it resolves.
		// 2. DrawingDataAddress in AppData is read synchronously.
		// 3. The default empty scene falls through otherwise.
		if (this.options.DrawingDataAddress)
		{
			let tmpFromAppData = this._readAppData(this.options.DrawingDataAddress);
			if (tmpFromAppData && tmpFromAppData.elements)
			{
				return tmpFromAppData;
			}
		}

		// Defer OnLoad call until after the API resolves.  We don't have a
		// scene to push synchronously here, so use the InitialData fallback.
		if (typeof this.options.OnLoad === 'function')
		{
			this._pendingDeferredLoad = true;
		}

		return this.options.InitialData ||
			{ elements: [], appState: {}, files: {} };
	}

	_resolveTheme(pTheme)
	{
		if (pTheme === 'auto')
		{
			// Try pict-section-theme's mode (if installed).  The theme
			// provider exposes a current mode via either a provider service
			// or as a CSS class on documentElement — both are tolerated.
			if (typeof document !== 'undefined' && document.documentElement)
			{
				let tmpRoot = document.documentElement;
				if (tmpRoot.classList && tmpRoot.classList.contains('theme-mode-dark'))
				{
					return 'dark';
				}
			}
			let tmpThemeProvider = this.pict && this.pict.providers && this.pict.providers.ThemeSection;
			if (tmpThemeProvider && tmpThemeProvider.getCurrentMode)
			{
				let tmpMode = tmpThemeProvider.getCurrentMode();
				if (tmpMode === 'dark') return 'dark';
				if (tmpMode === 'light') return 'light';
			}
			return 'light';
		}
		return (pTheme === 'dark') ? 'dark' : 'light';
	}

	_handleChange(pElements, pAppState, pFiles)
	{
		// Guard: if we've been torn down, drop the change on the floor.
		// React can fire onChange briefly after unmount in dev mode + once
		// or twice in production during the final flush.
		if (this._destroyed) return;

		// Excalidraw fires onChange on every pointer move.  We throttle the
		// downstream callback + AppData write so consumers see a steady,
		// reasonable rate.
		this._lastSeenChangeSnapshot = { elements: pElements, appState: pAppState, files: pFiles };

		if (this._onChangeThrottleHandle) return;

		let tmpDelay = this.options.OnChangeThrottleMs || 250;
		this._onChangeThrottleHandle = setTimeout(() =>
		{
			this._onChangeThrottleHandle = null;
			if (this._destroyed) return;
			let tmpSnap = this._lastSeenChangeSnapshot;
			if (!tmpSnap) return;

			// Write to AppData if bound
			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, this._cloneScene(tmpSnap));
			}

			// Notify consumer
			if (typeof this.options.OnChange === 'function')
			{
				try { this.options.OnChange(this, this._cloneScene(tmpSnap)); }
				catch (pErr) { this.log.error(`PICT-Excalidraw OnChange threw: ${pErr && pErr.message}`); }
			}
		}, tmpDelay);
	}

	_cloneScene(pSnap)
	{
		// Excalidraw exposes the live arrays — we shallow-clone the shape so
		// consumers can stash a snapshot without seeing it mutate.
		return {
			elements: pSnap.elements ? pSnap.elements.slice() : [],
			appState: pSnap.appState ? Object.assign({}, pSnap.appState) : {},
			files:    pSnap.files    ? Object.assign({}, pSnap.files)    : {}
		};
	}

	_readAppData(pAddress)
	{
		if (!pAddress) return null;
		try
		{
			// Strip the AppData. prefix so the address is relative to the
			// AppData object that we (or fable.manifest) walk into.  Passing
			// "AppData.Drawing" directly with pict.AppData as base would
			// resolve to pict.AppData.AppData.Drawing, which is wrong.
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.getValueByHash)
			{
				return this.fable.manifest.getValueByHash(this.pict.AppData, tmpRelative);
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length; i++)
			{
				if (tmpCursor == null) return null;
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			return tmpCursor;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw read AppData failed: ${pErr && pErr.message}`);
			return null;
		}
	}

	_writeAppData(pAddress, pValue)
	{
		if (!pAddress) return false;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.setValueByHash)
			{
				this.fable.manifest.setValueByHash(this.pict.AppData, tmpRelative, pValue);
				return true;
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length - 1; i++)
			{
				if (tmpCursor[tmpParts[i]] == null) tmpCursor[tmpParts[i]] = {};
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			tmpCursor[tmpParts[tmpParts.length - 1]] = pValue;
			return true;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw write AppData failed: ${pErr && pErr.message}`);
			return false;
		}
	}

	// ---- Public API ---------------------------------------------------------

	/** Return the live Excalidraw imperative API (or null if not yet mounted). */
	getApi()
	{
		return this._excalidrawAPI;
	}

	/** Return the current scene as a plain { elements, appState, files } object. */
	getScene()
	{
		if (!this._excalidrawAPI) return null;
		return {
			elements: this._excalidrawAPI.getSceneElements(),
			appState: this._excalidrawAPI.getAppState(),
			files:    this._excalidrawAPI.getFiles ? this._excalidrawAPI.getFiles() : {}
		};
	}

	/**
	 * Replace the current scene with the supplied data.  Accepts either the
	 * full { elements, appState, files } object or just an elements array.
	 */
	setScene(pSceneData)
	{
		if (!this._excalidrawAPI) return false;
		if (!pSceneData) return false;

		let tmpScene = Array.isArray(pSceneData)
			? { elements: pSceneData, appState: {}, files: {} }
			: pSceneData;

		this._excalidrawAPI.updateScene({
			elements: tmpScene.elements || [],
			appState: tmpScene.appState || {},
			collaborators: new Map()
		});
		if (tmpScene.files && this._excalidrawAPI.addFiles)
		{
			let tmpFilesArr = [];
			let tmpKeys = Object.keys(tmpScene.files);
			for (let i = 0; i < tmpKeys.length; i++) tmpFilesArr.push(tmpScene.files[tmpKeys[i]]);
			if (tmpFilesArr.length) this._excalidrawAPI.addFiles(tmpFilesArr);
		}
		return true;
	}

	/**
	 * Export the current scene as an SVGElement.  Returns a Promise.
	 *
	 * Per-export overrides accept both top-level keys (passed through to
	 * Excalidraw's exportToSvg opts) and the appState-resident export flags
	 * that Excalidraw expects to find on appState (exportEmbedScene,
	 * exportBackground, exportPadding, exportScale, exportWithDarkMode).
	 * We auto-promote the appState ones so callers can write
	 * `view.exportSvg({ exportEmbedScene: true })` without remembering
	 * which key lives where.
	 */
	exportSvg(pOpts)
	{
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.exportToSvg) return Promise.reject(new Error('exportToSvg unavailable'));
		let tmpScene = this.getScene();
		if (!tmpScene) return Promise.reject(new Error('Excalidraw not mounted'));
		let tmpOpts = pOpts || {};
		let tmpAppStateOverrides = this._promoteAppStateExportKeys(tmpOpts);
		return tmpVendor.exportToSvg(Object.assign({
			elements: tmpScene.elements,
			appState: Object.assign({}, tmpScene.appState, tmpAppStateOverrides),
			files:    tmpScene.files
		}, tmpOpts));
	}

	/** Export the current scene as a PNG blob.  Returns a Promise. */
	exportBlob(pOpts)
	{
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.exportToBlob) return Promise.reject(new Error('exportToBlob unavailable'));
		let tmpScene = this.getScene();
		if (!tmpScene) return Promise.reject(new Error('Excalidraw not mounted'));
		let tmpOpts = pOpts || {};
		let tmpAppStateOverrides = this._promoteAppStateExportKeys(tmpOpts);
		return tmpVendor.exportToBlob(Object.assign({
			elements: tmpScene.elements,
			appState: Object.assign({}, tmpScene.appState, tmpAppStateOverrides),
			files:    tmpScene.files,
			mimeType: 'image/png'
		}, tmpOpts));
	}

	/**
	 * Pull out the export-control flags that Excalidraw expects on
	 * appState and return them as a separate object.  Mutates the input
	 * to remove the promoted keys (so they don't double-apply at top level).
	 */
	_promoteAppStateExportKeys(pOpts)
	{
		let tmpKeys = [
			'exportEmbedScene', 'exportBackground', 'exportPadding',
			'exportScale', 'exportWithDarkMode'
		];
		let tmpOut = {};
		for (let i = 0; i < tmpKeys.length; i++)
		{
			if (Object.prototype.hasOwnProperty.call(pOpts, tmpKeys[i]))
			{
				tmpOut[tmpKeys[i]] = pOpts[tmpKeys[i]];
				delete pOpts[tmpKeys[i]];
			}
		}
		return tmpOut;
	}

	/**
	 * Convert a mermaid diagram source string into Excalidraw scene elements,
	 * optionally applying them to the live canvas.
	 *
	 * Uses Excalidraw's bundled @excalidraw/mermaid-to-excalidraw +
	 * convertToExcalidrawElements helpers via the wrapper bundle.
	 *
	 * @param {string} pMermaid - Mermaid source (flowchart, sequence, class, …)
	 * @param {object} [pOpts]
	 * @param {boolean} [pOpts.apply=true] - When true, replaces the current scene
	 *                                        with the converted elements via
	 *                                        setScene().  When false, just
	 *                                        returns the elements without
	 *                                        touching the canvas.
	 * @param {object}  [pOpts.mermaidOptions] - Forwarded to parseMermaidToExcalidraw
	 *                                            (e.g. { fontSize: 16 }).
	 * @returns {Promise<{elements: any[], files: object}>}
	 */
	convertMermaidToExcalidraw(pMermaid, pOpts)
	{
		let tmpOpts = pOpts || {};
		let tmpApply = (tmpOpts.apply !== false);
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.parseMermaidToExcalidraw || !tmpVendor.convertToExcalidrawElements)
		{
			return Promise.reject(new Error('mermaid helpers not available — wrapper bundle out of date?'));
		}
		return tmpVendor.parseMermaidToExcalidraw(pMermaid, tmpOpts.mermaidOptions || {}).then((pParsed) =>
		{
			let tmpSkeleton = (pParsed && pParsed.elements) || [];
			let tmpFiles    = (pParsed && pParsed.files)    || {};
			let tmpElements = tmpVendor.convertToExcalidrawElements(tmpSkeleton);
			if (tmpApply)
			{
				this.setScene({ elements: tmpElements, appState: {}, files: tmpFiles });
			}
			return { elements: tmpElements, files: tmpFiles };
		});
	}

	/** Serialize the current scene as a JSON string compatible with .excalidraw files. */
	serialize()
	{
		let tmpVendor = this._resolveVendor();
		let tmpScene = this.getScene();
		if (!tmpScene) return null;
		if (tmpVendor && tmpVendor.serializeAsJSON)
		{
			return tmpVendor.serializeAsJSON(tmpScene.elements, tmpScene.appState, tmpScene.files, 'local');
		}
		return JSON.stringify({
			type: 'excalidraw',
			version: 2,
			source: 'pict-section-excalidraw',
			elements: tmpScene.elements,
			appState: tmpScene.appState,
			files:    tmpScene.files
		});
	}

	/**
	 * Switch theme.  Accepts 'light', 'dark', or 'auto'.  Re-mounts the React
	 * tree with the new theme prop — Excalidraw doesn't expose a runtime
	 * theme switch on the API.
	 */
	setTheme(pTheme)
	{
		this._currentTheme = pTheme || 'light';
		if (this._excalidrawAPI && this._excalidrawAPI.updateScene)
		{
			let tmpResolved = this._resolveTheme(this._currentTheme);
			this._excalidrawAPI.updateScene({ appState: { theme: tmpResolved } });
		}
	}

	/** Toggle the Excalidraw view-mode flag (read-only). */
	setReadOnly(pReadOnly)
	{
		this.options.ViewModeEnabled = !!pReadOnly;
		if (this._excalidrawAPI && this._excalidrawAPI.updateScene)
		{
			this._excalidrawAPI.updateScene({ appState: { viewModeEnabled: !!pReadOnly } });
		}
	}

	/**
	 * Invoke OnLoad if registered, or read from DrawingDataAddress otherwise,
	 * and apply the result.
	 */
	load()
	{
		if (typeof this.options.OnLoad === 'function')
		{
			this.options.OnLoad(this, (pErr, pSceneData) =>
			{
				if (pErr)
				{
					this.log.error(`PICT-Excalidraw OnLoad error: ${pErr.message || pErr}`);
					return;
				}
				if (pSceneData)
				{
					this.setScene(pSceneData);
				}
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			let tmpScene = this._readAppData(this.options.DrawingDataAddress);
			if (tmpScene) this.setScene(tmpScene);
		}
	}

	/** Invoke OnSave with the current scene, or just write to AppData. */
	save()
	{
		let tmpScene = this.getScene();
		if (!tmpScene) return;
		if (typeof this.options.OnSave === 'function')
		{
			this.options.OnSave(this, tmpScene, (pErr) =>
			{
				if (pErr) this.log.error(`PICT-Excalidraw OnSave error: ${pErr.message || pErr}`);
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			this._writeAppData(this.options.DrawingDataAddress, this._cloneScene(tmpScene));
		}
	}

	/**
	 * Tear down React root + flush pending throttles + clear the destination
	 * DOM.  Idempotent — safe to call twice.  After destroy(), public API
	 * methods that touch DOM/React (getScene, setScene, exportSvg, save,
	 * load, setTheme, setReadOnly) become no-ops via the _destroyed gate.
	 */
	destroy()
	{
		if (this._destroyed) return;
		this._destroyed = true;

		if (this._onChangeThrottleHandle)
		{
			clearTimeout(this._onChangeThrottleHandle);
			this._onChangeThrottleHandle = null;
		}
		this._lastSeenChangeSnapshot = null;
		this._pendingDeferredLoad = false;

		if (this._reactRoot)
		{
			try { this._reactRoot.unmount(); }
			catch (pErr) { this.log.error(`PICT-Excalidraw unmount failed: ${pErr && pErr.message}`); }
			this._reactRoot = null;
		}

		// Clear the destination so a subsequent re-render starts clean.  We
		// own the contents of targetElement from onAfterInitialRender on.
		if (this.targetElement && this.targetElement.innerHTML !== undefined)
		{
			try { this.targetElement.innerHTML = ''; }
			catch (pErr) { /* ignore */ }
		}

		this._excalidrawAPI = null;
		this._wrapElement   = null;
		this._mountElement  = null;
		this._statusElement = null;
		this.targetElement  = false;
		this._vendor        = null;
		this.initialRenderComplete = false;
	}

	/** Whether destroy() has been called. */
	isDestroyed()
	{
		return !!this._destroyed;
	}
}

module.exports = PictViewExcalidrawReact;
module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":204,"pict-view":365}],208:[function(require,module,exports){
// The container for all the Pict-Section-Flow related code.

// The main flow diagram view class
module.exports = require('./views/PictView-Flow.js');

// Node rendering view
module.exports.PictViewFlowNode = require('./views/PictView-Flow-Node.js');

// Toolbar views
module.exports.PictViewFlowToolbar = require('./views/PictView-Flow-Toolbar.js');
module.exports.PictViewFlowFloatingToolbar = require('./views/PictView-Flow-FloatingToolbar.js');

// Services
module.exports.PictServiceFlowInteractionManager = require('./services/PictService-Flow-InteractionManager.js');
module.exports.PictServiceFlowConnectionRenderer = require('./services/PictService-Flow-ConnectionRenderer.js');
module.exports.PictServiceFlowTether = require('./services/PictService-Flow-Tether.js');
module.exports.PictServiceFlowLayout = require('./services/PictService-Flow-Layout.js');
module.exports.PictServiceFlowPathGenerator = require('./services/PictService-Flow-PathGenerator.js');
module.exports.PictServiceFlowViewportManager = require('./services/PictService-Flow-ViewportManager.js');
module.exports.PictServiceFlowSelectionManager = require('./services/PictService-Flow-SelectionManager.js');
module.exports.PictServiceFlowPanelManager = require('./services/PictService-Flow-PanelManager.js');
module.exports.PictServiceFlowDataManager = require('./services/PictService-Flow-DataManager.js');
module.exports.PictServiceFlowConnectionHandleManager = require('./services/PictService-Flow-ConnectionHandleManager.js');
module.exports.PictServiceFlowRenderManager = require('./services/PictService-Flow-RenderManager.js');
module.exports.PictServiceFlowPortRenderer = require('./services/PictService-Flow-PortRenderer.js');

// Providers
module.exports.PictProviderFlowNodeTypes = require('./providers/PictProvider-Flow-NodeTypes.js');
module.exports.PictProviderFlowEventHandler = require('./providers/PictProvider-Flow-EventHandler.js');
module.exports.PictProviderFlowLayouts = require('./providers/PictProvider-Flow-Layouts.js');
module.exports.PictProviderFlowSVGHelpers = require('./providers/PictProvider-Flow-SVGHelpers.js');
module.exports.PictProviderFlowGeometry = require('./providers/PictProvider-Flow-Geometry.js');
module.exports.PictProviderFlowPanelChrome = require('./providers/PictProvider-Flow-PanelChrome.js');
module.exports.PictProviderFlowCSS = require('./providers/PictProvider-Flow-CSS.js');
module.exports.PictProviderFlowIcons = require('./providers/PictProvider-Flow-Icons.js');
module.exports.PictProviderFlowConnectorShapes = require('./providers/PictProvider-Flow-ConnectorShapes.js');

// Layout algorithm and edge-theme descriptors now live in the standalone
// pict-provider-graphlayout module. They are re-exported here unchanged so the
// historical pict-section-flow export surface (LayoutAlgorithms / EdgeThemes) is
// preserved for consumers.
const libPictProviderGraphLayout = require('pict-provider-graphlayout');

// Layout algorithm descriptors (consumers can register custom algorithms via
// _LayoutService.registerAlgorithm({ Name, Apply, DefaultParameters, ParameterSchema }))
module.exports.LayoutAlgorithms =
{
	Custom:           libPictProviderGraphLayout.Layouts.Custom,
	Layered:          libPictProviderGraphLayout.Layouts.Layered,
	ForcedFromCenter: libPictProviderGraphLayout.Layouts.ForcedFromCenter,
	Grid:             libPictProviderGraphLayout.Layouts.Grid,
	Circular:         libPictProviderGraphLayout.Layouts.Circular,
	Tabular:          libPictProviderGraphLayout.Layouts.Tabular,
	Columnar:         libPictProviderGraphLayout.Layouts.Columnar
};

// Edge-theme descriptors (consumers can register custom edge themes via
// _LayoutService.registerEdgeTheme({ Name, GeneratePath, AdjustLayout?, ResolveAttachment?, ... }))
module.exports.EdgeThemes =
{
	Bezier:               libPictProviderGraphLayout.Edges.Bezier,
	Orthogonal:           libPictProviderGraphLayout.Edges.Orthogonal,
	Straight:             libPictProviderGraphLayout.Edges.Straight,
	OrthogonalSnap:       libPictProviderGraphLayout.Edges.OrthogonalSnap,
	Perimeter:            libPictProviderGraphLayout.Edges.Perimeter,
	PerimeterLinear:      libPictProviderGraphLayout.Edges.PerimeterLinear,
	PerimeterOrthogonal:  libPictProviderGraphLayout.Edges.PerimeterOrthogonal
};

// FlowCard base class
module.exports.PictFlowCard = require('./PictFlowCard.js');

// FlowCardPropertiesPanel base class and panel types
module.exports.PictFlowCardPropertiesPanel = require('./PictFlowCardPropertiesPanel.js');
module.exports.FlowCardPropertiesPanelTemplate = require('./panels/FlowCardPropertiesPanel-Template.js');
module.exports.FlowCardPropertiesPanelMarkdown = require('./panels/FlowCardPropertiesPanel-Markdown.js');
module.exports.FlowCardPropertiesPanelForm = require('./panels/FlowCardPropertiesPanel-Form.js');
module.exports.FlowCardPropertiesPanelView = require('./panels/FlowCardPropertiesPanel-View.js');

// Properties panel renderer view
module.exports.PictViewFlowPropertiesPanel = require('./views/PictView-Flow-PropertiesPanel.js');

},{"./PictFlowCard.js":209,"./PictFlowCardPropertiesPanel.js":210,"./panels/FlowCardPropertiesPanel-Form.js":211,"./panels/FlowCardPropertiesPanel-Markdown.js":212,"./panels/FlowCardPropertiesPanel-Template.js":213,"./panels/FlowCardPropertiesPanel-View.js":214,"./providers/PictProvider-Flow-CSS.js":216,"./providers/PictProvider-Flow-ConnectorShapes.js":217,"./providers/PictProvider-Flow-EventHandler.js":218,"./providers/PictProvider-Flow-Geometry.js":219,"./providers/PictProvider-Flow-Icons.js":220,"./providers/PictProvider-Flow-Layouts.js":221,"./providers/PictProvider-Flow-NodeTypes.js":222,"./providers/PictProvider-Flow-PanelChrome.js":224,"./providers/PictProvider-Flow-SVGHelpers.js":226,"./services/PictService-Flow-ConnectionHandleManager.js":229,"./services/PictService-Flow-ConnectionRenderer.js":230,"./services/PictService-Flow-DataManager.js":232,"./services/PictService-Flow-InteractionManager.js":233,"./services/PictService-Flow-Layout.js":234,"./services/PictService-Flow-PanelManager.js":235,"./services/PictService-Flow-PathGenerator.js":236,"./services/PictService-Flow-PortRenderer.js":237,"./services/PictService-Flow-RenderManager.js":238,"./services/PictService-Flow-SelectionManager.js":239,"./services/PictService-Flow-Tether.js":240,"./services/PictService-Flow-ViewportManager.js":241,"./views/PictView-Flow-FloatingToolbar.js":242,"./views/PictView-Flow-Node.js":243,"./views/PictView-Flow-PropertiesPanel.js":244,"./views/PictView-Flow-Toolbar.js":245,"./views/PictView-Flow.js":246,"pict-provider-graphlayout":151}],209:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictFlowCard - Base class for flow diagram cards.
 *
 * Developers create subclasses of PictFlowCard to define reusable node types
 * that appear in the flow palette. Each card describes a discrete operation
 * (e.g. "If-Then-Else", "File Read") with configurable inputs, outputs, and
 * metadata. Pict-Section-Flow uses registered cards to build a palette for
 * the user to drag onto the graph.
 *
 * Configurable properties:
 *   - Title          (string, required) - Display name shown on the node
 *   - Name           (string, optional) - Longer descriptive name
 *   - Code           (string, required) - Short identifier (e.g. "ITE", "SW")
 *   - Description    (string, optional) - Brief explanation of what the card does
 *   - Icon           (string, optional) - Icon identifier or emoji
 *   - PreviewImage   (string, optional) - URL to a preview/thumbnail image
 *   - Documentation  (string, optional) - URL or inline documentation text
 *   - Tooltip        (string, optional) - Hover tooltip text
 *   - Inputs         (array)  - Named input ports, each with:
 *       - Name                 (string)  - Port label
 *       - Side                 (string)  - Port side ('left', 'top', etc.)
 *       - MinimumInputCount    (number)  - Minimum connections accepted (default 0)
 *       - MaximumInputCount    (number)  - Maximum connections accepted (default -1, unlimited)
 *   - Outputs        (array)  - Named output ports
 *   - Enabled        (boolean) - Whether this card is available in the palette
 *   - PropertiesPanel (object, optional) - Configuration for the on-graph properties panel
 *       - PanelType      (string)  - 'Template', 'Markdown', 'Form', or 'View'
 *       - DefaultWidth   (number)  - Panel width (default 300)
 *       - DefaultHeight  (number)  - Panel height (default 200)
 *       - Title          (string)  - Panel title bar text
 *       - Configuration  (object)  - Panel-type-specific configuration
 *   - BodyContent     (object, optional) - Custom content rendered in the node body area
 *       - ContentType    (string)  - 'svg', 'html', or 'canvas'
 *       - Template       (string)  - Pict template string (html/svg only)
 *       - TemplateHash   (string)  - Registered template hash (takes precedence over Template)
 *       - Templates      (array)   - Template definitions to register [{Hash, Template}]
 *       - RenderCallback (function)- Imperative render callback (required for canvas)
 *       - Padding        (number)  - Inner padding in pixels (default 2)
 *   - ShowTypeLabel    (boolean, default true)  - Whether to show the type label/code badge on hover
 *   - PortLabelsOnHover (boolean, default false) - When true, port labels only appear on hover
 *   - PortLabelsVertical (boolean, default false) - When true, port labels render vertically
 *   - PortLabelPadding  (boolean, default false) - When true, port labels have extra padding to avoid overlapping body content
 *   - LabelsInFront     (boolean, default true)  - When true, labels render in front of body content; when false, behind
 *
 * Usage:
 *   class MyCard extends PictFlowCard {
 *     constructor(pFable, pOptions, pServiceHash) {
 *       super(pFable, pOptions, pServiceHash);
 *       this.cardTitle = 'My Card';
 *       this.cardCode = 'MC';
 *       this.cardInputs = [{ Name: 'Data', Side: 'left', MinimumInputCount: 1, MaximumInputCount: 1 }];
 *       this.cardOutputs = [{ Name: 'Result', Side: 'right' }];
 *     }
 *   }
 */
class PictFlowCard extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, PictFlowCard.default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictFlowCard';

		// --- Card metadata ---
		this.cardTitle = (tmpOptions.Title) ? tmpOptions.Title : 'Card';
		this.cardName = (tmpOptions.Name) ? tmpOptions.Name : false;
		this.cardCode = (tmpOptions.Code) ? tmpOptions.Code : '';
		this.cardDescription = (tmpOptions.Description) ? tmpOptions.Description : false;
		this.cardIcon = (tmpOptions.Icon) ? tmpOptions.Icon : false;
		this.cardPreviewImage = (tmpOptions.PreviewImage) ? tmpOptions.PreviewImage : false;
		this.cardDocumentation = (tmpOptions.Documentation) ? tmpOptions.Documentation : false;
		this.cardTooltip = (tmpOptions.Tooltip) ? tmpOptions.Tooltip : false;
		this.cardHelp = (tmpOptions.Help) ? tmpOptions.Help : false;

		// --- Card enabled state ---
		this.cardEnabled = (typeof tmpOptions.Enabled === 'boolean') ? tmpOptions.Enabled : true;

		// --- Card appearance ---
		this.cardTitleBarColor = (tmpOptions.TitleBarColor) ? tmpOptions.TitleBarColor : 'var(--theme-color-text-primary, #2c3e50)';
		this.cardBodyStyle = (tmpOptions.BodyStyle) ? tmpOptions.BodyStyle : {};
		this.cardWidth = (typeof tmpOptions.Width === 'number') ? tmpOptions.Width : 180;
		this.cardHeight = (typeof tmpOptions.Height === 'number') ? tmpOptions.Height : 80;
		this.cardCategory = (tmpOptions.Category) ? tmpOptions.Category : 'General';

		// --- Input and Output port definitions ---
		// Inputs: [{ Name: 'In', Side: 'left', MinimumInputCount: 0, MaximumInputCount: -1 }]
		// Outputs: [{ Name: 'Out', Side: 'right' }]
		this.cardInputs = Array.isArray(tmpOptions.Inputs) ? tmpOptions.Inputs : [];
		this.cardOutputs = Array.isArray(tmpOptions.Outputs) ? tmpOptions.Outputs : [];

		// --- Properties panel configuration ---
		this.cardPropertiesPanel = (tmpOptions.PropertiesPanel && typeof tmpOptions.PropertiesPanel === 'object')
			? tmpOptions.PropertiesPanel
			: null;

		// --- Body content configuration ---
		this.cardBodyContent = (tmpOptions.BodyContent && typeof tmpOptions.BodyContent === 'object')
			? tmpOptions.BodyContent
			: null;

		// --- Label display booleans ---
		this.cardShowTypeLabel = (typeof tmpOptions.ShowTypeLabel === 'boolean') ? tmpOptions.ShowTypeLabel : true;
		this.cardPortLabelsOnHover = (typeof tmpOptions.PortLabelsOnHover === 'boolean') ? tmpOptions.PortLabelsOnHover : false;
		this.cardPortLabelsVertical = (typeof tmpOptions.PortLabelsVertical === 'boolean') ? tmpOptions.PortLabelsVertical : false;
		this.cardPortLabelPadding = (typeof tmpOptions.PortLabelPadding === 'boolean') ? tmpOptions.PortLabelPadding : false;
		this.cardPortLabelsOutside = (typeof tmpOptions.PortLabelsOutside === 'boolean') ? tmpOptions.PortLabelsOutside : false;
		this.cardLabelsInFront = (typeof tmpOptions.LabelsInFront === 'boolean') ? tmpOptions.LabelsInFront : true;
	}

	/**
	 * Generate the node type configuration object for the NodeTypes provider.
	 * This converts the card's properties into the format expected by
	 * PictProviderFlowNodeTypes.registerNodeType().
	 *
	 * @returns {Object} Node type configuration
	 */
	getNodeTypeConfiguration()
	{
		let tmpPorts = [];

		// Build input ports
		for (let i = 0; i < this.cardInputs.length; i++)
		{
			let tmpInput = this.cardInputs[i];
			let tmpPort =
				{
					Hash: null,
					Direction: 'input',
					Side: tmpInput.Side || 'left',
					Label: tmpInput.Name || `In ${i + 1}`,
					MinimumInputCount: (typeof tmpInput.MinimumInputCount === 'number') ? tmpInput.MinimumInputCount : 0,
					MaximumInputCount: (typeof tmpInput.MaximumInputCount === 'number') ? tmpInput.MaximumInputCount : -1
				};
			if (tmpInput.PortType)
			{
				tmpPort.PortType = tmpInput.PortType;
			}
			if (tmpInput.DataType)
			{
				tmpPort.DataType = tmpInput.DataType;
			}
			tmpPorts.push(tmpPort);
		}

		// Build output ports
		for (let i = 0; i < this.cardOutputs.length; i++)
		{
			let tmpOutput = this.cardOutputs[i];
			let tmpOutPort =
				{
					Hash: null,
					Direction: 'output',
					Side: tmpOutput.Side || 'right',
					Label: tmpOutput.Name || `Out ${i + 1}`
				};
			if (tmpOutput.PortType)
			{
				tmpOutPort.PortType = tmpOutput.PortType;
			}
			if (tmpOutput.DataType)
			{
				tmpOutPort.DataType = tmpOutput.DataType;
			}
			tmpPorts.push(tmpOutPort);
		}

		// If no ports were defined, provide sensible defaults
		if (tmpPorts.length === 0)
		{
			tmpPorts.push({ Hash: null, Direction: 'input', Side: 'left', Label: 'In' });
			tmpPorts.push({ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' });
		}

		let tmpResult =
		{
			Hash: this.cardCode,
			Label: this.cardTitle,
			DefaultWidth: this.cardWidth,
			DefaultHeight: this.cardHeight,
			DefaultPorts: tmpPorts,
			TitleBarColor: this.cardTitleBarColor,
			BodyStyle: JSON.parse(JSON.stringify(this.cardBodyStyle)),
			// Extended FlowCard metadata stored alongside the type
			CardMetadata:
			{
				Name: this.cardName,
				Code: this.cardCode,
				Description: this.cardDescription,
				Icon: this.cardIcon,
				PreviewImage: this.cardPreviewImage,
				Documentation: this.cardDocumentation,
				Tooltip: this.cardTooltip,
				Enabled: this.cardEnabled,
				Category: this.cardCategory,
				Help: this.cardHelp
			}
		};

		// Include label display booleans
		tmpResult.ShowTypeLabel = this.cardShowTypeLabel;
		tmpResult.PortLabelsOnHover = this.cardPortLabelsOnHover;
		tmpResult.PortLabelsVertical = this.cardPortLabelsVertical;
		tmpResult.PortLabelPadding = this.cardPortLabelPadding;
		tmpResult.PortLabelsOutside = this.cardPortLabelsOutside;
		tmpResult.LabelsInFront = this.cardLabelsInFront;

		// Include properties panel config if defined
		if (this.cardPropertiesPanel)
		{
			tmpResult.PropertiesPanel = JSON.parse(JSON.stringify(this.cardPropertiesPanel));
		}

		// Include body content config if defined
		if (this.cardBodyContent)
		{
			tmpResult.BodyContent = JSON.parse(JSON.stringify(this.cardBodyContent));
			// RenderCallback cannot be serialized — preserve the original function reference
			if (typeof this.options.BodyContent.RenderCallback === 'function')
			{
				tmpResult.BodyContent.RenderCallback = this.options.BodyContent.RenderCallback;
			}
		}

		return tmpResult;
	}

	/**
	 * Register this card with a FlowView's node type provider.
	 *
	 * @param {Object} pFlowView - The PictViewFlow instance
	 * @returns {boolean} Whether registration succeeded
	 */
	registerWithFlowView(pFlowView)
	{
		if (!pFlowView || !pFlowView._NodeTypeProvider)
		{
			this.log.warn('PictFlowCard registerWithFlowView: no valid FlowView or NodeTypeProvider');
			return false;
		}

		let tmpConfig = this.getNodeTypeConfiguration();
		return pFlowView._NodeTypeProvider.registerNodeType(tmpConfig);
	}
}

module.exports = PictFlowCard;

module.exports.default_configuration =
{
	Title: 'Card',
	Name: false,
	Code: '',
	Description: false,
	Icon: false,
	PreviewImage: false,
	Documentation: false,
	Tooltip: false,
	Inputs: [],
	Outputs: [],
	Enabled: true,
	TitleBarColor: 'var(--theme-color-text-primary, #2c3e50)',
	BodyStyle: {},
	Width: 180,
	Height: 80,
	Category: 'General',
	PropertiesPanel: null,
	BodyContent: null,
	ShowTypeLabel: true,
	PortLabelsOnHover: false,
	PortLabelsVertical: false,
	PortLabelPadding: false,
	PortLabelsOutside: false,
	LabelsInFront: true
};

},{"fable-serviceproviderbase":59}],210:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictFlowCardPropertiesPanel - Base class for flow card property panels.
 *
 * Developers create subclasses to define what UI appears when a user opens
 * the properties panel for a node on the flow graph. Four built-in panel
 * types are provided:
 *
 *   - Template  - Renders pict templates
 *   - Markdown  - Renders markdown via pict-section-content
 *   - Form      - Creates an ephemeral pict-section-form section
 *   - View      - Renders an existing registered pict-view
 *
 * Configurable properties:
 *   - PanelType      (string)  - Panel type identifier
 *   - Title          (string)  - Panel title bar text
 *   - Width          (number)  - Default panel width in pixels
 *   - Height         (number)  - Default panel height in pixels
 *   - Configuration  (object)  - Panel-type-specific configuration
 */
class PictFlowCardPropertiesPanel extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, PictFlowCardPropertiesPanel.default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel';

		// Panel metadata
		this.panelType = tmpOptions.PanelType || 'Base';
		this.panelTitle = tmpOptions.Title || 'Properties';
		this.panelWidth = (typeof tmpOptions.Width === 'number') ? tmpOptions.Width : 300;
		this.panelHeight = (typeof tmpOptions.Height === 'number') ? tmpOptions.Height : 200;

		// Reference to the flow view (set when panel is activated)
		this._FlowView = null;

		// The node data this panel is operating on (set when panel is opened)
		this._NodeData = null;

		// The DOM container element for panel content (set during render)
		this._ContentContainer = null;

		// The panel configuration (panel-type-specific)
		this._Configuration = tmpOptions.Configuration || {};
	}

	/**
	 * Render the panel's content into a DOM container element.
	 * Subclasses MUST override this.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to render into
	 * @param {Object} pNodeData - The node data object (has .Data property)
	 */
	render(pContainer, pNodeData)
	{
		this._ContentContainer = pContainer;
		this._NodeData = pNodeData;
	}

	/**
	 * Marshal data FROM the node's Data object INTO the panel UI.
	 * Called when the panel opens or when data changes externally.
	 *
	 * @param {Object} pNodeData
	 */
	marshalToPanel(pNodeData)
	{
		this._NodeData = pNodeData;
	}

	/**
	 * Marshal data FROM the panel UI INTO the node's Data object.
	 * Called before saving or when the panel is about to close.
	 *
	 * @param {Object} pNodeData
	 */
	marshalFromPanel(pNodeData)
	{
		// Subclasses override
	}

	/**
	 * Called when the panel is being destroyed (closed).
	 * Subclasses should clean up resources.
	 */
	destroy()
	{
		this._ContentContainer = null;
		this._NodeData = null;
	}
}

module.exports = PictFlowCardPropertiesPanel;

module.exports.default_configuration =
{
	PanelType: 'Base',
	Title: 'Properties',
	Width: 300,
	Height: 200,
	Configuration: {}
};

},{"fable-serviceproviderbase":59}],211:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Form
 *
 * Creates an ephemeral pict-section-form section to edit the node's Data object.
 * Uses PictViewFormMetacontroller.injectManifest() to dynamically create form
 * sections at runtime.
 *
 * Note: pict-section-form must be available in the consuming application
 * (it is an optional/peer dependency, not bundled with pict-section-flow).
 *
 * Configuration:
 *   {
 *     PanelType: 'Form',
 *     Configuration: {
 *       Manifest: {
 *         Sections: [...],
 *         Descriptors: {...}
 *       }
 *     }
 *   }
 */
class FlowCardPropertiesPanelForm extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Form';

		this._Metacontroller = null;
		this._InjectedSectionHash = null;
	}

	/**
	 * Render the form into the panel body.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.Manifest)
		{
			pContainer.innerHTML = '<em>No form manifest configured</em>';
			return;
		}

		// Create a unique container ID for the form section
		let tmpContainerID = `pict-flow-panel-form-${pNodeData.Hash}`;
		pContainer.innerHTML = `<div id="${tmpContainerID}"></div>`;

		// Bind the node data to AppData.Record so the form descriptors
		// (which use addresses like Record.Data.SearchString) resolve against
		// the actual node object.
		this.fable.AppData.Record = pNodeData;

		try
		{
			// Look for an existing metacontroller or create one
			if (!this._Metacontroller)
			{
				// Try to find PictFormMetacontroller service type (check both common names)
				let tmpServiceType = null;
				if (this.fable.servicesMap.hasOwnProperty('PictFormMetacontroller'))
				{
					tmpServiceType = 'PictFormMetacontroller';
				}
				else if (this.fable.servicesMap.hasOwnProperty('PictViewFormMetacontroller'))
				{
					tmpServiceType = 'PictViewFormMetacontroller';
				}

				if (tmpServiceType)
				{
					this._Metacontroller = this.fable.instantiateServiceProviderWithoutRegistration(tmpServiceType,
						{
							ViewIdentifier: `FlowPanelForm-${pNodeData.Hash}`,
							DefaultDestinationAddress: `#${tmpContainerID}`,
							AutoRender: false,
							AutoPopulateAfterRender: true,
							AutoSolveBeforeRender: false
						});
				}
			}

			if (this._Metacontroller && typeof this._Metacontroller.injectManifestAndRender === 'function')
			{
				// Create the FormContainer div that the metacontroller's
				// updateMetatemplateInDOM() expects when adding section wrappers.
				// Normally this is created when the metacontroller renders its own
				// metatemplate, but we skip that step since we only need the
				// injected section views, not the metacontroller's own renderable.
				let tmpFormContainerID = `Pict-${this._Metacontroller.UUID}-FormContainer`;
				let tmpContainerEl = pContainer.querySelector(`#${tmpContainerID}`);
				if (tmpContainerEl)
				{
					tmpContainerEl.innerHTML = `<div id="${tmpFormContainerID}" class="pict-form"></div>`;
				}

				// Deep clone the manifest so each panel gets its own copy
				let tmpManifest = JSON.parse(JSON.stringify(this._Configuration.Manifest));
				this._InjectedSectionHash = tmpManifest.Hash || null;

				// Use injectManifestAndRender which properly creates section views,
				// updates the metatemplate in the DOM, and renders each section view
				this._Metacontroller.injectManifestAndRender(tmpManifest);
			}
			else if (this._Metacontroller && typeof this._Metacontroller.injectManifest === 'function')
			{
				// Fallback for older pict-section-form versions: inject the
				// manifest and render each section view individually
				let tmpManifest = JSON.parse(JSON.stringify(this._Configuration.Manifest));
				let tmpViewsToRender = this._Metacontroller.injectManifest(tmpManifest);
				this._InjectedSectionHash = tmpManifest.Hash || null;

				// Create container divs for each section view and render them
				let tmpContainerEl = pContainer.querySelector(`#${tmpContainerID}`);
				if (tmpContainerEl && tmpViewsToRender.length > 0)
				{
					let tmpInnerHTML = '';
					for (let i = 0; i < tmpViewsToRender.length; i++)
					{
						let tmpDestID = tmpViewsToRender[i].options.DefaultDestinationAddress;
						if (tmpDestID && tmpDestID.charAt(0) === '#')
						{
							tmpDestID = tmpDestID.substring(1);
						}
						tmpInnerHTML += `<div id="${tmpDestID}" class="pict-form-view"></div>`;
					}
					tmpContainerEl.innerHTML = tmpInnerHTML;

					for (let i = 0; i < tmpViewsToRender.length; i++)
					{
						tmpViewsToRender[i].render();
					}
				}
			}
			else
			{
				pContainer.innerHTML = '<em>pict-section-form is not available. Install it in your application to use Form panels.</em>';
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-Form render error: ${pError.message}`);
			pContainer.innerHTML = `<em>Form render error: ${pError.message}</em>`;
		}
	}

	marshalFromPanel(pNodeData)
	{
		if (this._Metacontroller && typeof this._Metacontroller.marshalFromView === 'function')
		{
			this._Metacontroller.marshalFromView();
		}
	}

	destroy()
	{
		this._Metacontroller = null;
		this._InjectedSectionHash = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelForm;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Form',
		Configuration:
		{
			Manifest: null
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":210}],212:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Markdown
 *
 * Renders markdown content into the panel body using pict-section-content's
 * PictContentProvider service.  When pict-section-content is installed and its
 * PictContentProvider service type has been registered with the pict instance,
 * full markdown rendering is available (headings, lists, tables, code blocks
 * with syntax highlighting, KaTeX equations, Mermaid diagrams, etc.).
 *
 * If PictContentProvider is not available, the panel falls back to displaying
 * the raw markdown as pre-formatted text.
 *
 * Configuration:
 *   {
 *     PanelType: 'Markdown',
 *     Configuration: {
 *       Markdown: '# Title\nSome **markdown** content'
 *     }
 *   }
 *
 * Or use an address to pull markdown from the node's data:
 *   {
 *     PanelType: 'Markdown',
 *     Configuration: {
 *       MarkdownAddress: 'Data.MarkdownContent'
 *     }
 *   }
 */
class FlowCardPropertiesPanelMarkdown extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Markdown';

		this._ContentProvider = null;
	}

	/**
	 * Render markdown into the panel.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		this._renderMarkdown();
	}

	marshalToPanel(pNodeData)
	{
		super.marshalToPanel(pNodeData);
		this._renderMarkdown();
	}

	_renderMarkdown()
	{
		if (!this._ContentContainer || !this._Configuration) return;

		let tmpMarkdown = '';

		if (this._Configuration.MarkdownAddress && this._NodeData)
		{
			// Resolve markdown from node data using manyfest
			tmpMarkdown = this.fable.manifest.getValueByHash(this._NodeData, this._Configuration.MarkdownAddress) || '';
		}
		else if (this._Configuration.Markdown)
		{
			tmpMarkdown = this._Configuration.Markdown;
		}

		if (!tmpMarkdown)
		{
			this._ContentContainer.innerHTML = '<em>No content</em>';
			return;
		}

		// Use pict-section-content's PictContentProvider for markdown rendering.
		// The consuming application must register the PictContentProvider service
		// type (from pict-section-content) for this to work.
		try
		{
			if (!this._ContentProvider)
			{
				if (this.fable.servicesMap.hasOwnProperty('PictContentProvider'))
				{
					this._ContentProvider = this.fable.instantiateServiceProviderWithoutRegistration('PictContentProvider', {});
				}
			}

			if (this._ContentProvider && typeof this._ContentProvider.parseMarkdown === 'function')
			{
				let tmpHTML = this._ContentProvider.parseMarkdown(tmpMarkdown);
				this._ContentContainer.innerHTML = tmpHTML;

				// Post-render hooks for equations and diagrams
				if (typeof this._ContentProvider.renderKaTeXEquations === 'function')
				{
					this._ContentProvider.renderKaTeXEquations(this._ContentContainer);
				}
				if (typeof this._ContentProvider.renderMermaidDiagrams === 'function')
				{
					this._ContentProvider.renderMermaidDiagrams(this._ContentContainer);
				}
			}
			else
			{
				// PictContentProvider not registered — render as pre-formatted text
				this._ContentContainer.innerHTML = `<pre style="white-space: pre-wrap; font-family: inherit;">${this._escapeHTML(tmpMarkdown)}</pre>`;
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-Markdown render error: ${pError.message}`);
			this._ContentContainer.innerHTML = `<pre style="white-space: pre-wrap; font-family: inherit;">${this._escapeHTML(tmpMarkdown)}</pre>`;
		}
	}

	_escapeHTML(pText)
	{
		let tmpDiv = document.createElement('div');
		tmpDiv.textContent = pText;
		return tmpDiv.innerHTML;
	}

	destroy()
	{
		this._ContentProvider = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelMarkdown;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Markdown',
		Configuration:
		{
			Markdown: '',
			MarkdownAddress: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":210}],213:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Template
 *
 * Renders pict templates into the panel body.
 *
 * Configuration:
 *   {
 *     PanelType: 'Template',
 *     Configuration: {
 *       Templates: [
 *         { Hash: 'my-template', Template: '<div>{~D:Record.Data.SomeValue~}</div>' }
 *       ],
 *       TemplateHash: 'my-template'
 *     }
 *   }
 */
class FlowCardPropertiesPanelTemplate extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Template';

		this._TemplatesRegistered = false;
	}

	/**
	 * Register templates with the pict template provider and render.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.Templates) return;

		// Register templates with pict (only once)
		if (!this._TemplatesRegistered)
		{
			let tmpTemplates = this._Configuration.Templates;
			for (let i = 0; i < tmpTemplates.length; i++)
			{
				if (tmpTemplates[i].Hash && tmpTemplates[i].Template)
				{
					this.fable.TemplateProvider.addTemplate(tmpTemplates[i].Hash, tmpTemplates[i].Template);
				}
			}
			this._TemplatesRegistered = true;
		}

		this._renderTemplate();
	}

	marshalToPanel(pNodeData)
	{
		super.marshalToPanel(pNodeData);
		this._renderTemplate();
	}

	_renderTemplate()
	{
		if (!this._ContentContainer || !this._NodeData) return;

		let tmpTemplateHash = this._Configuration.TemplateHash;
		if (!tmpTemplateHash) return;

		let tmpRecord = this._NodeData;
		let tmpHTML = this.fable.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, [tmpRecord]);
		this._ContentContainer.innerHTML = tmpHTML;
	}
}

module.exports = FlowCardPropertiesPanelTemplate;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Template',
		Configuration:
		{
			Templates: [],
			TemplateHash: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":210}],214:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-View
 *
 * Renders an existing registered pict-view into the panel body.
 * The view's destination is temporarily overridden to render inside
 * the panel container.
 *
 * Configuration:
 *   {
 *     PanelType: 'View',
 *     Configuration: {
 *       ViewHash: 'MyCustomViewIdentifier'
 *     }
 *   }
 */
class FlowCardPropertiesPanelView extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-View';

		this._OriginalDestination = null;
		this._ViewInstance = null;
	}

	/**
	 * Render the referenced pict-view into the panel body.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.ViewHash)
		{
			pContainer.innerHTML = '<em>No ViewHash configured</em>';
			return;
		}

		let tmpViewHash = this._Configuration.ViewHash;

		// Create a unique container ID
		let tmpContainerID = `pict-flow-panel-view-${pNodeData.Hash}`;
		pContainer.innerHTML = `<div id="${tmpContainerID}"></div>`;

		try
		{
			// Look up the view in the pict instance
			let tmpPict = this.pict || this.fable;
			if (tmpPict.views && tmpPict.views[tmpViewHash])
			{
				this._ViewInstance = tmpPict.views[tmpViewHash];

				// Save original destination
				this._OriginalDestination = this._ViewInstance.options.DefaultDestinationAddress;

				// Override destination to our panel container
				this._ViewInstance.options.DefaultDestinationAddress = `#${tmpContainerID}`;

				if (typeof this._ViewInstance.render === 'function')
				{
					this._ViewInstance.render();
				}
			}
			else
			{
				pContainer.innerHTML = `<em>View "${tmpViewHash}" not found</em>`;
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-View render error: ${pError.message}`);
			pContainer.innerHTML = `<em>View render error: ${pError.message}</em>`;
		}
	}

	marshalFromPanel(pNodeData)
	{
		if (this._ViewInstance && typeof this._ViewInstance.marshalFromView === 'function')
		{
			this._ViewInstance.marshalFromView();
		}
	}

	destroy()
	{
		// Restore original destination
		if (this._ViewInstance && this._OriginalDestination)
		{
			this._ViewInstance.options.DefaultDestinationAddress = this._OriginalDestination;
		}

		this._ViewInstance = null;
		this._OriginalDestination = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelView;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'View',
		Configuration:
		{
			ViewHash: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":210}],215:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/**
 * PictProvider-Flow-Background
 *
 * Native canvas background for the flow diagram. The container template ships a
 * default grid; this provider lets a host pick a background through config or
 * ViewState instead of hand-painting the SVG from outside (which moodboard used
 * to do). When no background is configured the provider is a no-op and the
 * template grid stands, so existing diagrams are unchanged.
 *
 * Background shape:
 *   { Style: 'grid' | 'dots' | 'graph' | 'solid' | 'image' | 'none',
 *     Color?: string,        // line / dot color (minor lines for 'graph')
 *     MajorColor?: string,   // 'graph' only: the heavier every-Nth line color
 *     Paper?: string,        // grid/dots/graph: solid fill painted behind the pattern
 *     Image?: string,
 *     GridSize?: number,     // cell spacing (minor cell for 'graph')
 *     MajorEvery?: number,   // 'graph' only: heavier line every N cells (default 10)
 *     DotSize?: number,
 *     LineWidth?: number,    // grid/graph minor line width
 *     MajorLineWidth?: number } // 'graph' major line width
 *
 * Named presets (smaller / lighter / darker dots, grids, blue graph paper,
 * blueprint, ...) live in PRESETS and are fetched with preset(name).
 *
 * The markup generators are pure (string in, string out) and unit tested; only
 * apply() touches the DOM.
 */
const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowBackground'
};

const _DEFAULT_GRID_SIZE = 20;
const _DEFAULT_DOT_SIZE = 2;
const _DEFAULT_DOT_FILL = 'var(--theme-color-text-secondary, #b0b0b0)';
const _DEFAULT_MAJOR_EVERY = 10;
// Concrete fallback line color for 'graph' (var() does not resolve in an SVG
// presentation attribute, and graph lines are drawn with stroke="...").
const _DEFAULT_GRID_LINE = '#cbd5e1';

// Named, ready-to-use backgrounds. preset(name) returns a fresh clone so callers
// can tweak one without mutating the catalog.
const _PRESETS =
{
	'dots':       { Style: 'dots', GridSize: 20, DotSize: 2 },
	'dots-small': { Style: 'dots', GridSize: 14, DotSize: 1 },
	'dots-light': { Style: 'dots', GridSize: 20, DotSize: 2, Color: '#dcdcdc' },
	'dots-dark':  { Style: 'dots', GridSize: 22, DotSize: 2.4, Color: '#64748b' },
	'grid':       { Style: 'grid', GridSize: 20 },
	'grid-fine':  { Style: 'grid', GridSize: 12, Color: '#e2e8f0' },
	// "10-square grid with light and more-light-blue lines": minor light-blue lines
	// every 16px, a heavier sky-blue line every 10 cells, on white paper.
	'graph-blue': { Style: 'graph', GridSize: 16, MajorEvery: 10, Color: '#dbeafe', MajorColor: '#93c5fd', LineWidth: 1, MajorLineWidth: 1.5, Paper: '#ffffff' },
	// Classic dark blueprint: light-blue lines on deep navy paper.
	'blueprint':  { Style: 'graph', GridSize: 16, MajorEvery: 10, Color: '#3b6ea5', MajorColor: '#6fa8dc', LineWidth: 1, MajorLineWidth: 1.5, Paper: '#0f2a4a' },
	'solid':      { Style: 'solid', Color: '#faf7f2' },
	'none':       { Style: 'none' }
};

class PictProviderFlowBackground extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowBackground';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * The pattern element id for a view + style.
	 * @param {string} pViewIdentifier
	 * @param {string} pStyle
	 * @returns {string}
	 */
	patternId(pViewIdentifier, pStyle)
	{
		return `flow-bg-${pStyle}-${pViewIdentifier}`;
	}

	/**
	 * Generate the <pattern> markup for grid/dots backgrounds. Returns '' for
	 * styles that need no pattern (solid, image, none) or when nothing is set.
	 * Pure.
	 * @param {string} pViewIdentifier
	 * @param {Object} pBackground
	 * @returns {string}
	 */
	generatePatternMarkup(pViewIdentifier, pBackground)
	{
		if (!pBackground || !pBackground.Style)
		{
			return '';
		}

		// Optional solid fill painted behind the pattern (paper color). Empty unless set.
		let tmpPaper = function (pW, pH)
		{
			return pBackground.Paper ? `<rect width="${pW}" height="${pH}" fill="${pBackground.Paper}" />` : '';
		};

		if (pBackground.Style === 'grid')
		{
			let tmpSize = (typeof pBackground.GridSize === 'number') ? pBackground.GridSize : _DEFAULT_GRID_SIZE;
			// With no explicit Color the lines inherit the theme via the existing
			// CSS class, matching the template grid; a Color overrides inline.
			let tmpStroke = pBackground.Color ? ` style="stroke:${pBackground.Color}"` : '';
			let tmpWidth = (typeof pBackground.LineWidth === 'number') ? ` stroke-width="${pBackground.LineWidth}"` : '';
			let tmpId = this.patternId(pViewIdentifier, 'grid');
			return `<pattern id="${tmpId}" width="${tmpSize}" height="${tmpSize}" patternUnits="userSpaceOnUse">`
				+ tmpPaper(tmpSize, tmpSize)
				+ `<line x1="${tmpSize}" y1="0" x2="${tmpSize}" y2="${tmpSize}" class="pict-flow-grid-pattern"${tmpStroke}${tmpWidth} />`
				+ `<line x1="0" y1="${tmpSize}" x2="${tmpSize}" y2="${tmpSize}" class="pict-flow-grid-pattern"${tmpStroke}${tmpWidth} />`
				+ `</pattern>`;
		}

		if (pBackground.Style === 'dots')
		{
			let tmpSize = (typeof pBackground.GridSize === 'number') ? pBackground.GridSize : _DEFAULT_GRID_SIZE;
			let tmpDot = (typeof pBackground.DotSize === 'number') ? pBackground.DotSize : _DEFAULT_DOT_SIZE;
			let tmpFill = pBackground.Color ? pBackground.Color : _DEFAULT_DOT_FILL;
			let tmpId = this.patternId(pViewIdentifier, 'dots');
			return `<pattern id="${tmpId}" width="${tmpSize}" height="${tmpSize}" patternUnits="userSpaceOnUse">`
				+ tmpPaper(tmpSize, tmpSize)
				+ `<circle cx="${tmpSize / 2}" cy="${tmpSize / 2}" r="${tmpDot}" fill="${tmpFill}" />`
				+ `</pattern>`;
		}

		if (pBackground.Style === 'graph')
		{
			// Graph paper: a fine minor grid tiled inside a heavier major grid drawn
			// every MajorEvery cells. Two patterns — the major one fills itself with the
			// minor pattern, then strokes the heavier lines on top.
			let tmpMinor = (typeof pBackground.GridSize === 'number') ? pBackground.GridSize : _DEFAULT_GRID_SIZE;
			let tmpMajorEvery = (typeof pBackground.MajorEvery === 'number') ? pBackground.MajorEvery : _DEFAULT_MAJOR_EVERY;
			let tmpMajor = tmpMinor * tmpMajorEvery;
			let tmpMinorColor = pBackground.Color || _DEFAULT_GRID_LINE;
			let tmpMajorColor = pBackground.MajorColor || tmpMinorColor;
			let tmpMinorWidth = (typeof pBackground.LineWidth === 'number') ? pBackground.LineWidth : 1;
			let tmpMajorWidth = (typeof pBackground.MajorLineWidth === 'number') ? pBackground.MajorLineWidth : 1.5;
			let tmpMinorId = this.patternId(pViewIdentifier, 'graph-minor');
			let tmpId = this.patternId(pViewIdentifier, 'graph');

			let tmpMinorPattern = `<pattern id="${tmpMinorId}" width="${tmpMinor}" height="${tmpMinor}" patternUnits="userSpaceOnUse">`
				+ `<line x1="${tmpMinor}" y1="0" x2="${tmpMinor}" y2="${tmpMinor}" stroke="${tmpMinorColor}" stroke-width="${tmpMinorWidth}" />`
				+ `<line x1="0" y1="${tmpMinor}" x2="${tmpMinor}" y2="${tmpMinor}" stroke="${tmpMinorColor}" stroke-width="${tmpMinorWidth}" />`
				+ `</pattern>`;
			let tmpMajorPattern = `<pattern id="${tmpId}" width="${tmpMajor}" height="${tmpMajor}" patternUnits="userSpaceOnUse">`
				+ tmpPaper(tmpMajor, tmpMajor)
				+ `<rect width="${tmpMajor}" height="${tmpMajor}" fill="url(#${tmpMinorId})" />`
				+ `<line x1="${tmpMajor}" y1="0" x2="${tmpMajor}" y2="${tmpMajor}" stroke="${tmpMajorColor}" stroke-width="${tmpMajorWidth}" />`
				+ `<line x1="0" y1="${tmpMajor}" x2="${tmpMajor}" y2="${tmpMajor}" stroke="${tmpMajorColor}" stroke-width="${tmpMajorWidth}" />`
				+ `</pattern>`;
			return tmpMinorPattern + tmpMajorPattern;
		}

		return '';
	}

	/**
	 * Resolve the fill value for the background rect. Pure.
	 *   grid/dots -> url(#pattern); solid -> Color; image -> url(Image);
	 *   none -> 'none'. Returns null when nothing is configured.
	 * @param {string} pViewIdentifier
	 * @param {Object} pBackground
	 * @returns {string|null}
	 */
	resolveFill(pViewIdentifier, pBackground)
	{
		if (!pBackground || !pBackground.Style)
		{
			return null;
		}

		switch (pBackground.Style)
		{
			case 'grid':  return `url(#${this.patternId(pViewIdentifier, 'grid')})`;
			case 'dots':  return `url(#${this.patternId(pViewIdentifier, 'dots')})`;
			case 'graph': return `url(#${this.patternId(pViewIdentifier, 'graph')})`;
			case 'solid': return pBackground.Color || 'transparent';
			case 'image': return pBackground.Image ? `url(${pBackground.Image})` : 'none';
			case 'none':  return 'none';
			default:      return null;
		}
	}

	/**
	 * Resolve the effective background for a flow view: ViewState wins, then the
	 * static option. Returns null/false when none is configured.
	 * @param {Object} pFlowView
	 */
	resolveBackground(pFlowView)
	{
		if (!pFlowView)
		{
			return null;
		}
		let tmpViewStateBackground = (pFlowView._FlowData && pFlowView._FlowData.ViewState)
			? pFlowView._FlowData.ViewState.Background
			: null;
		if (tmpViewStateBackground)
		{
			return tmpViewStateBackground;
		}
		return (pFlowView.options && pFlowView.options.Background) ? pFlowView.options.Background : null;
	}

	/**
	 * Fetch a named background preset as a fresh object (safe to tweak / store on
	 * ViewState). Unknown names return null.
	 * @param {string} pName
	 * @returns {Object|null}
	 */
	preset(pName)
	{
		let tmpPreset = _PRESETS[pName];
		return tmpPreset ? JSON.parse(JSON.stringify(tmpPreset)) : null;
	}

	/**
	 * The available preset names, in catalog order.
	 * @returns {string[]}
	 */
	presetNames()
	{
		return Object.keys(_PRESETS);
	}

	/**
	 * Apply the configured background to the live SVG. No-op when nothing is
	 * configured (the template grid stands). DOM-touching; verified in browser.
	 * @param {Object} [pFlowView]
	 * @returns {boolean} true when a background was applied
	 */
	apply(pFlowView)
	{
		let tmpFlowView = pFlowView || this._FlowView;
		if (!tmpFlowView || !tmpFlowView._SVGElement)
		{
			return false;
		}

		let tmpBackground = this.resolveBackground(tmpFlowView);
		if (!tmpBackground || !tmpBackground.Style)
		{
			return false;
		}

		let tmpViewIdentifier = tmpFlowView.options.ViewIdentifier;
		let tmpSVG = tmpFlowView._SVGElement;

		// Replace any pattern we previously injected, then add the new one.
		let tmpDefs = tmpSVG.querySelector('defs');
		if (tmpDefs)
		{
			let tmpOld = tmpDefs.querySelectorAll('[data-flow-bg-pattern]');
			for (let i = 0; i < tmpOld.length; i++)
			{
				tmpOld[i].remove();
			}
			let tmpMarkup = this.generatePatternMarkup(tmpViewIdentifier, tmpBackground);
			if (tmpMarkup)
			{
				let tmpScratch = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				tmpScratch.innerHTML = tmpMarkup;
				while (tmpScratch.firstChild)
				{
					let tmpChild = tmpScratch.firstChild;
					if (tmpChild.setAttribute)
					{
						tmpChild.setAttribute('data-flow-bg-pattern', 'true');
					}
					tmpDefs.appendChild(tmpChild);
				}
			}
		}

		let tmpFill = this.resolveFill(tmpViewIdentifier, tmpBackground);
		let tmpRect = tmpSVG.querySelector('.pict-flow-grid-background');
		if (tmpRect && tmpFill !== null)
		{
			tmpRect.setAttribute('fill', tmpFill);
		}

		// A solid color also tints the container behind the (transparent) rect.
		let tmpContainer = (typeof tmpSVG.closest === 'function') ? tmpSVG.closest('.pict-flow-svg-container') : null;
		if (tmpContainer)
		{
			tmpContainer.style.backgroundColor = (tmpBackground.Style === 'solid' && tmpBackground.Color) ? tmpBackground.Color : '';
		}

		return true;
	}
}

module.exports = PictProviderFlowBackground;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.PRESETS = _PRESETS;

},{"pict-provider":177}],216:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-CSS
 *
 * Centralized CSS provider for the flow diagram.
 * All flow-related CSS is organized into domain-specific getter methods,
 * providing a single source of truth and enabling future theming.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowCSS'
};

class PictProviderFlowCSS extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowCSS';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ── Container ──────────────────────────────────────────────────────────
	/**
	 * CSS for the flow container, SVG container, panning/connecting cursors, and grid pattern.
	 * @returns {string}
	 */
	getContainerCSS()
	{
		return /*css*/`
		.pict-flow-container {
			/* ── Design Tokens ─────────────────────────────────────
			   Override these custom properties to theme the flow diagram.
			   Node-type classes (.pict-flow-node-{type}) can scope-override
			   any variable for per-type variation.

			   Defaults reference the host application's pict-provider-theme
			   tokens (--theme-color-*) when available, with hardcoded
			   fallbacks so the editor still looks reasonable in unthemed
			   contexts. Internal flow themes (sketch, blueprint, etc.) keep
			   layering on top via .pict-flow-container scoped overrides. */

			/* Text */
			--pf-text-primary: var(--theme-color-text-primary, #2c3e50);
			--pf-text-heading: var(--theme-color-text-primary, #1a252f);
			--pf-text-secondary: var(--theme-color-text-secondary, #7f8c8d);
			--pf-text-tertiary: var(--theme-color-text-muted, #8e99a4);
			--pf-text-placeholder: var(--theme-color-text-placeholder, #95a5a6);

			/* Node */
			--pf-node-body-fill: var(--theme-color-background-panel, #ffffff);
			--pf-node-body-stroke: var(--theme-color-border-default, #d0d4d8);
			--pf-node-body-stroke-hover: var(--theme-color-border-strong, #b0b8c0);
			--pf-node-body-stroke-width: 1;
			--pf-node-body-radius: 8px;
			--pf-node-shadow: drop-shadow(0 1px 3px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.10)));
			--pf-node-shadow-hover: drop-shadow(0 2px 6px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.15)));
			--pf-node-shadow-selected: drop-shadow(0 2px 8px rgba(52, 152, 219, 0.25));
			--pf-node-shadow-dragging: drop-shadow(0 4px 12px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.20)));
			--pf-node-title-fill: var(--theme-color-background-panel, #ffffff);
			--pf-node-title-size: 11.5px;
			--pf-node-title-weight: 600;
			--pf-node-title-bar-color: var(--theme-color-text-primary, #2c3e50);
			--pf-node-type-label-fill: var(--theme-color-text-muted, #a0a8b0);
			--pf-node-selected-stroke: var(--theme-color-brand-primary, #3498db);

			/* Node Variants */
			--pf-node-start-fill: var(--theme-color-background-hover, #eafaf1);
			--pf-node-start-stroke: var(--theme-color-status-success, #27ae60);
			--pf-node-end-fill: var(--theme-color-background-hover, #e8f8f5);
			--pf-node-end-stroke: var(--theme-color-brand-primary, #1abc9c);
			--pf-node-halt-fill: var(--theme-color-background-hover, #fdedec);
			--pf-node-halt-stroke: var(--theme-color-status-error, #e74c3c);
			--pf-node-decision-fill: var(--theme-color-background-hover, #fff9e6);
			--pf-node-decision-stroke: var(--theme-color-status-warning, #f39c12);

			/* ── Color roles ───────────────────────────────────────
			   Generic, theme-aware semantic colors that node types and
			   individual cards opt into via a ColorRole field. The
			   "-soft" variant is the tinted background; the bare role is
			   the title-bar / outline / accent stroke.

			   Hosts can override any of these tokens at .pict-flow-container
			   scope (or at their own scope) without touching JS. Built-in
			   node types resolve their visuals through these tokens, so
			   theming a role automatically retints every card that uses it.

			   Soft tints use color-mix() — supported in Chrome 111+,
			   Safari 16.2+, Firefox 113+. The hardcoded fallbacks keep the
			   editor presentable on older engines. */
			--pf-color-success: var(--theme-color-status-success, #27ae60);
			--pf-color-success-soft: color-mix(in srgb, var(--pf-color-success) 12%, transparent);
			--pf-color-warning: var(--theme-color-status-warning, #f39c12);
			--pf-color-warning-soft: color-mix(in srgb, var(--pf-color-warning) 14%, transparent);
			--pf-color-error: var(--theme-color-status-error, #e74c3c);
			--pf-color-error-soft: color-mix(in srgb, var(--pf-color-error) 12%, transparent);
			--pf-color-info: var(--theme-color-status-info, #3498db);
			--pf-color-info-soft: color-mix(in srgb, var(--pf-color-info) 12%, transparent);
			--pf-color-accent: var(--theme-color-brand-accent, #1abc9c);
			--pf-color-accent-soft: color-mix(in srgb, var(--pf-color-accent) 14%, transparent);
			--pf-color-neutral: var(--theme-color-text-primary, #2c3e50);
			--pf-color-neutral-soft: var(--theme-color-background-panel, #ffffff);
			--pf-color-neutral-onfill: var(--theme-color-background-panel, #ffffff);

			/* Ports */
			--pf-port-input-fill: var(--theme-color-status-info, #3498db);
			--pf-port-output-fill: var(--theme-color-status-success, #2ecc71);
			--pf-port-stroke: var(--theme-color-background-panel, #ffffff);
			--pf-port-stroke-width: 2;
			--pf-port-label-bg: rgba(255, 253, 240, 0.5);
			--pf-port-label-text: var(--theme-color-text-primary, #2c3e50);

			/* Port Type Colors */
			--pf-port-event-in-fill: var(--theme-color-status-info, #3498db);
			--pf-port-event-out-fill: var(--theme-color-status-success, #2ecc71);
			--pf-port-setting-fill: var(--theme-color-status-warning, #e67e22);
			--pf-port-value-fill: var(--theme-color-status-warning, #f1c40f);
			--pf-port-error-fill: var(--theme-color-status-error, #e74c3c);

			/* Connection Type Colors (match source port) */
			--pf-connection-event-in-stroke: var(--theme-color-status-info, #3498db);
			--pf-connection-event-out-stroke: var(--theme-color-status-success, #2ecc71);
			--pf-connection-setting-stroke: var(--theme-color-status-warning, #e67e22);
			--pf-connection-value-stroke: var(--theme-color-status-warning, #f1c40f);
			--pf-connection-error-stroke: var(--theme-color-status-error, #e74c3c);

			/* Connections */
			--pf-connection-stroke: var(--theme-color-border-strong, #95a5a6);
			--pf-connection-stroke-hover: var(--theme-color-text-secondary, #7f8c8d);
			--pf-connection-selected-stroke: var(--theme-color-brand-primary, #3498db);

			/* Panels */
			--pf-panel-bg: var(--theme-color-background-panel, #ffffff);
			--pf-panel-border: var(--theme-color-border-default, #d0d4d8);
			--pf-panel-radius: 8px;
			--pf-panel-shadow: 0 4px 12px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.10)), 0 1px 3px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.06));
			--pf-panel-titlebar-bg: var(--theme-color-background-secondary, #f7f8fa);
			--pf-panel-titlebar-border: var(--theme-color-border-light, #e8eaed);
			--pf-panel-title-color: var(--theme-color-text-primary, #2c3e50);

			/* Tabs */
			--pf-tab-text: var(--theme-color-text-muted, #8e99a4);
			--pf-tab-text-hover: var(--theme-color-text-secondary, #5a6a7a);
			--pf-tab-active-border: var(--pf-node-selected-stroke);
			--pf-resize-handle-hover: var(--theme-color-border-light, #e0e3e6);

			/* Forms & Inputs */
			--pf-input-border: var(--theme-color-border-default, #d5d8dc);
			--pf-input-border-focus: var(--theme-color-focus-outline, #3498db);
			--pf-divider-light: var(--theme-color-border-light, #ecf0f1);
			--pf-divider-medium: var(--theme-color-border-light, #e8eaed);

			/* Buttons */
			--pf-button-border: var(--theme-color-border-default, #bdc3c7);
			--pf-button-hover-border: var(--theme-color-border-strong, #95a5a6);
			--pf-button-hover-bg: var(--theme-color-background-hover, #ecf0f1);
			--pf-button-active-bg: var(--theme-color-background-selected, #d5dbdb);
			--pf-button-danger-text: var(--theme-color-status-error, #e74c3c);
			--pf-button-danger-hover-bg: var(--theme-color-background-hover, #fdedec);
			--pf-button-close-color: var(--theme-color-text-muted, #b0b8c0);

			/* Badges */
			--pf-badge-category-bg: var(--theme-color-background-tertiary, #f0f2f4);
			--pf-badge-category-text: var(--theme-color-text-secondary, #6b7b8d);
			--pf-badge-code-bg: var(--theme-color-background-hover, #eaf2f8);
			--pf-badge-code-text: var(--theme-color-status-info, #2980b9);

			/* Info Panel */
			--pf-port-item-bg: var(--theme-color-background-secondary, #f8f9fa);

			/* Toolbar */
			--pf-toolbar-bg: var(--theme-color-background-panel, #ffffff);
			--pf-toolbar-border: var(--theme-color-border-default, #e0e0e0);

			/* Palette Cards */
			--pf-card-border: var(--theme-color-border-default, #d5d8dc);
			--pf-card-hover-bg: var(--theme-color-background-hover, #eaf2f8);
			--pf-card-hover-shadow: 0 1px 3px rgba(52, 152, 219, 0.15);

			/* Canvas */
			--pf-canvas-bg: var(--theme-color-background-secondary, #fafafa);
			--pf-grid-stroke: var(--theme-color-border-light, #e8e8e8);

			position: relative;
			width: 100%;
			height: 100%;
			min-height: 400px;
			overflow: hidden;
			background-color: var(--pf-canvas-bg);
			border: 1px solid var(--pf-toolbar-border);
			border-radius: 4px;
			display: flex;
			flex-direction: column;
		}
		.pict-flow-svg-container {
			flex: 1;
			min-height: 0;
			position: relative;
		}
		.pict-flow-svg {
			width: 100%;
			height: 100%;
			cursor: default;
			user-select: none;
			-webkit-user-select: none;
		}
		/* The canvas cursor is owned by the CursorManager: it sets data-flow-cursor
		   on the SVG from the interaction state + view mode, and these map the
		   tokens to real cursors. Element-scoped hover cursors (ports, handles,
		   panel chrome, toolbar buttons) still win for their own elements. */
		.pict-flow-svg[data-flow-cursor="grab"] { cursor: grab; }
		.pict-flow-svg[data-flow-cursor="grabbing"] { cursor: grabbing; }
		.pict-flow-svg[data-flow-cursor="crosshair"] { cursor: crosshair; }
		.pict-flow-svg[data-flow-cursor="resize"] { cursor: nwse-resize; }
		.pict-flow-svg[data-flow-cursor="default"] { cursor: default; }
		.pict-flow-grid-pattern line {
			stroke: var(--pf-grid-stroke);
			stroke-width: 0.5;
		}
		`;
	}

	// ── Nodes ──────────────────────────────────────────────────────────────
	/**
	 * CSS for base node styling: body, hover/selected/dragging states, title bar, title text, type label.
	 * @returns {string}
	 */
	getNodeCSS()
	{
		return /*css*/`
		.pict-flow-node {
			cursor: pointer;
			filter: var(--pf-node-shadow);
			transition: filter 0.2s;
		}
		.pict-flow-node:hover {
			filter: var(--pf-node-shadow-hover);
		}
		.pict-flow-node:hover .pict-flow-node-body {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}
		.pict-flow-node.selected {
			filter: var(--pf-node-shadow-selected);
		}
		.pict-flow-node.selected .pict-flow-node-body {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node.dragging {
			opacity: 0.9;
			cursor: grabbing;
			filter: var(--pf-node-shadow-dragging);
		}
		.pict-flow-node-body {
			fill: var(--pf-node-body-fill);
			stroke: var(--pf-node-body-stroke);
			stroke-width: var(--pf-node-body-stroke-width);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
			transition: stroke 0.2s, stroke-width 0.2s;
		}
		.pict-flow-node-title-bar {
			fill: var(--pf-node-title-bar-color);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
		}
		.pict-flow-node-title-bar-bottom {
			fill: var(--pf-node-title-bar-color);
		}
		.pict-flow-node-resize-handle {
			fill: var(--theme-color-brand-primary, #2880a6);
			stroke: var(--theme-color-background-panel, #ffffff);
			stroke-width: 1.5;
			cursor: nwse-resize;
			opacity: 0.85;
		}
		.pict-flow-node-resize-handle:hover { opacity: 1; }
		.pict-flow-marquee {
			fill: var(--theme-color-brand-primary, #2880a6);
			fill-opacity: 0.10;
			stroke: var(--theme-color-brand-primary, #2880a6);
			stroke-width: 1;
			stroke-dasharray: 4 3;
			pointer-events: none;
		}
		.pict-flow-align-guide {
			stroke: #e5397f;
			stroke-width: 1;
			stroke-dasharray: 3 2;
			pointer-events: none;
			shape-rendering: crispEdges;
		}
		.pict-flow-node-title {
			fill: var(--pf-node-title-fill);
			font-size: var(--pf-node-title-size);
			font-weight: var(--pf-node-title-weight);
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			letter-spacing: 0.2px;
			pointer-events: none;
		}
		.pict-flow-node-type-label {
			fill: var(--pf-node-type-label-fill);
			font-size: 9.5px;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			text-transform: uppercase;
			letter-spacing: 0.3px;
			pointer-events: none;
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-type-label {
			opacity: 1;
		}
		.pict-flow-node-card-code {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-card-code {
			opacity: 1;
		}
		/* Title-bar icon: invert SVG paths to white for dark title bars */
		.pict-flow-node-title-icon {
			filter: brightness(0) invert(1);
		}
		`;
	}

	// ── Body Content ──────────────────────────────────────────────────────
	/**
	 * CSS for custom body content in nodes: SVG group, foreignObject, HTML container, canvas.
	 * @returns {string}
	 */
	getBodyContentCSS()
	{
		return /*css*/`
		.pict-flow-node-body-content {
			pointer-events: none;
		}
		.pict-flow-node-body-content-fo {
			overflow: hidden;
		}
		.pict-flow-node-body-content-html {
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 11px;
			color: var(--pf-text-primary);
			pointer-events: auto;
		}
		.pict-flow-node-body-content-canvas {
			display: block;
			pointer-events: auto;
		}
		`;
	}

	// ── Node Variants ──────────────────────────────────────────────────────
	/**
	 * CSS overrides for specific node types: start, end, halt, decision.
	 * @returns {string}
	 */
	getNodeVariantCSS()
	{
		return /*css*/`
		.pict-flow-node-decision .pict-flow-node-body {
			fill: var(--pf-node-decision-fill);
			stroke: var(--pf-node-decision-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-start .pict-flow-node-body {
			fill: var(--pf-node-start-fill);
			stroke: var(--pf-node-start-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-end .pict-flow-node-body {
			fill: var(--pf-node-end-fill);
			stroke: var(--pf-node-end-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-halt .pict-flow-node-body {
			fill: var(--pf-node-halt-fill);
			stroke: var(--pf-node-halt-stroke);
			stroke-width: 1.5;
		}

		/* ── Color-role variants ────────────────────────────────
		   Cards opt into a role via ColorRole on the node-type config or
		   a per-node override. The renderer adds .pict-flow-node-color-{role}
		   to the node group, which pulls fill/stroke/title-bar colors from
		   the --pf-color-* tokens — those in turn track the host's
		   --theme-color-* tokens so light/dark/palette swaps propagate.

		   Roles deliberately don't override .pict-flow-node-body-content-*
		   styling — the body content's visual identity is the consumer's
		   responsibility. */
		.pict-flow-node-color-success .pict-flow-node-body {
			fill: var(--pf-color-success-soft);
			stroke: var(--pf-color-success);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-success .pict-flow-node-title-bar,
		.pict-flow-node-color-success .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-success);
		}
		.pict-flow-node-color-success .pict-flow-node-bracket {
			stroke: var(--pf-color-success);
		}

		.pict-flow-node-color-warning .pict-flow-node-body {
			fill: var(--pf-color-warning-soft);
			stroke: var(--pf-color-warning);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-warning .pict-flow-node-title-bar,
		.pict-flow-node-color-warning .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-warning);
		}
		.pict-flow-node-color-warning .pict-flow-node-bracket {
			stroke: var(--pf-color-warning);
		}

		.pict-flow-node-color-error .pict-flow-node-body {
			fill: var(--pf-color-error-soft);
			stroke: var(--pf-color-error);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-error .pict-flow-node-title-bar,
		.pict-flow-node-color-error .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-error);
		}
		.pict-flow-node-color-error .pict-flow-node-bracket {
			stroke: var(--pf-color-error);
		}

		.pict-flow-node-color-info .pict-flow-node-body {
			fill: var(--pf-color-info-soft);
			stroke: var(--pf-color-info);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-info .pict-flow-node-title-bar,
		.pict-flow-node-color-info .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-info);
		}
		.pict-flow-node-color-info .pict-flow-node-bracket {
			stroke: var(--pf-color-info);
		}

		.pict-flow-node-color-accent .pict-flow-node-body {
			fill: var(--pf-color-accent-soft);
			stroke: var(--pf-color-accent);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-accent .pict-flow-node-title-bar,
		.pict-flow-node-color-accent .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-accent);
		}
		.pict-flow-node-color-accent .pict-flow-node-bracket {
			stroke: var(--pf-color-accent);
		}

		.pict-flow-node-color-neutral .pict-flow-node-body {
			fill: var(--pf-color-neutral-soft);
			stroke: var(--pf-color-neutral);
			stroke-width: 1;
		}
		.pict-flow-node-color-neutral .pict-flow-node-title-bar,
		.pict-flow-node-color-neutral .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-neutral);
		}
		.pict-flow-node-color-neutral .pict-flow-node-bracket {
			stroke: var(--pf-color-neutral);
		}
		`;
	}

	// ── Ports ──────────────────────────────────────────────────────────────
	/**
	 * CSS for port circles: input/output coloring, hover states, labels.
	 * @returns {string}
	 */
	getPortCSS()
	{
		return /*css*/`
		.pict-flow-port {
			cursor: crosshair;
			transition: r 0.15s, filter 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.12));
		}
		.pict-flow-port.input {
			fill: var(--pf-port-input-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port.output {
			fill: var(--pf-port-output-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port:hover {
			r: 7;
			filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.20));
		}
		/* Port type color overrides */
		.pict-flow-port.port-type-event-in {
			fill: var(--pf-port-event-in-fill);
		}
		.pict-flow-port.port-type-event-out {
			fill: var(--pf-port-event-out-fill);
		}
		.pict-flow-port.port-type-setting {
			fill: var(--pf-port-setting-fill);
		}
		.pict-flow-port.port-type-value {
			fill: var(--pf-port-value-fill);
		}
		.pict-flow-port.port-type-error {
			fill: var(--pf-port-error-fill);
		}
		.pict-flow-port-label {
			font-size: 8px;
			font-weight: 600;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			pointer-events: none;
		}
		/* Port label badge background */
		.pict-flow-port-label-bg {
			pointer-events: none;
		}
		/* Port labels on hover: hidden by default, revealed on node hover */
		.pict-flow-node-port-labels-hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover .pict-flow-port-label-bg {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label-bg {
			opacity: 1;
		}

		/* Port-hint beziers — drawn from the badge to the actual dot
		   when an edge theme has rerouted the connection. Hidden by
		   default; PortRenderer / NodeView toggle data-active on hover. */
		.pict-flow-port-hint {
			fill: none;
			stroke: var(--pf-connection-stroke-hover, #3498db);
			stroke-width: 1.75;
			stroke-dasharray: 4 3;
			stroke-linecap: round;
			opacity: 0;
			pointer-events: none;
			transition: opacity 0.18s ease;
		}
		.pict-flow-port-hint[data-active="true"] {
			opacity: 0.7;
		}

		/* ── Layout-algorithm popup: tightened layout + form styling ── */
		.pict-flow-popup-layout-algorithm-row {
			display: flex;
			flex-direction: column;
			gap: 4px;
			padding: 6px 10px 4px;
		}
		.pict-flow-popup-layout-algorithm-row > .pict-flow-popup-settings-label {
			font-size: 10px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			opacity: 0.7;
			margin: 0;
		}
		.pict-flow-popup-layout-algorithm-controls {
			display: flex;
			align-items: stretch;
			gap: 4px;
		}
		.pict-flow-popup-layout-algorithm-select {
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-flow-popup-collapse-toggle {
			flex: 0 0 auto;
			width: 28px;
			padding: 0;
			border: 1px solid var(--pf-button-border, #ccc);
			border-radius: 3px;
			background: var(--pf-toolbar-bg, #fff);
			color: var(--pf-text-secondary, #5a6470);
			cursor: pointer;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s, color 0.15s, border-color 0.15s;
		}
		.pict-flow-popup-collapse-toggle:hover {
			background-color: var(--pf-button-hover-bg, #eef);
			color: var(--pf-text-primary, #2c3e50);
		}
		/* "Open" state: pressed-in look so the user sees that the form
		   below is being driven by this gear. */
		.pict-flow-popup-collapse-toggle[aria-expanded="true"] {
			background-color: var(--pf-button-active-bg, #d6e4f0);
			color: var(--pf-text-primary, #2c3e50);
			border-color: var(--pf-button-hover-border, #3498db);
		}
		.pict-flow-popup-collapse-toggle svg {
			display: block;
		}
		/* Subordinate description text — sits under a control (algorithm
		   dropdown, edge-theme dropdown, etc.) and explains it. Indented
		   from the section's left edge with a faint left rule so the
		   visual hierarchy is unambiguous: SECTION LABEL > control >
		   description. */
		.pict-flow-popup-control-description {
			font-size: 11px;
			line-height: 1.4;
			color: var(--pf-text-secondary, #5a6470);
			padding: 4px 12px 8px 28px;
			margin-left: 14px;
			border-left: 2px solid var(--pf-divider-light, #e6e6e6);
		}

		/* The form host. Acts as the collapsible container around the
		   pict-section-form metacontroller's emitted markup. */
		.pict-flow-popup-layout-form-host {
			margin: 0 10px 8px;
			padding: 8px 10px;
			background: var(--pf-toolbar-bg, #fafafa);
			border: 1px solid var(--pf-button-border, #e0e0e0);
			border-radius: 6px;
			overflow: hidden;
			max-height: 600px;
			transition: max-height 0.22s ease, padding 0.22s ease,
			            margin 0.22s ease, border-color 0.22s ease, opacity 0.18s ease;
			opacity: 1;
		}
		.pict-flow-popup-layout-form-host[data-collapsed="true"] {
			max-height: 0;
			padding-top: 0;
			padding-bottom: 0;
			margin-top: 0;
			margin-bottom: 0;
			border-color: transparent;
			opacity: 0;
		}
		.pict-flow-popup-layout-form-host > div { width: 100%; }

		/* Form contents — make the auto-rendered sections look professional.
		   The section headings stay visible; the redundant per-section
		   "Group: Defaults" h3 is suppressed. */
		.pict-flow-popup-layout-form .pict-form-view {
			display: block;
		}
		.pict-flow-popup-layout-form .pict-form-section {
			margin: 0;
			padding: 0;
		}
		.pict-flow-popup-layout-form .pict-form-section h2 {
			font-size: 10px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			opacity: 0.6;
			margin: 8px 0 4px;
			padding: 0;
			border-bottom: 1px solid var(--pf-button-border, #e6e6e6);
			padding-bottom: 3px;
		}
		.pict-flow-popup-layout-form .pict-form-section:first-child h2,
		.pict-flow-popup-layout-form .pict-form-section h2:first-child {
			margin-top: 0;
		}
		/* Group headings ("Group: Defaults") are noise — every algorithm
		   has exactly one group right now. Hide them. */
		.pict-flow-popup-layout-form .pict-form-section h3 {
			display: none;
		}
		/* Each row of inputs lives in a flat <div> as alternating
		   <span>label</span><input> pairs. Lay them out in a balanced grid. */
		.pict-flow-popup-layout-form .pict-form-section > div > div {
			display: flex;
			flex-wrap: wrap;
			gap: 4px 14px;
			margin: 4px 0;
			align-items: center;
		}
		.pict-flow-popup-layout-form .pict-form-section span {
			font-size: 12px;
			color: var(--pf-text-primary, #2c3e50);
			line-height: 1.4;
			margin: 0;
		}
		.pict-flow-popup-layout-form input[type="number"],
		.pict-flow-popup-layout-form input[type="text"],
		.pict-flow-popup-layout-form select {
			width: 88px;
			padding: 2px 6px;
			border: 1px solid var(--pf-button-border, #ccc);
			border-radius: 3px;
			font-size: 12px;
			line-height: 1.3;
			background: #fff;
			color: var(--pf-text-primary, #2c3e50);
			margin-left: -8px; /* tighten gap between label and its input */
		}
		.pict-flow-popup-layout-form select {
			width: auto;
			min-width: 110px;
		}
		.pict-flow-popup-layout-form input[type="number"]:focus,
		.pict-flow-popup-layout-form input[type="text"]:focus,
		.pict-flow-popup-layout-form select:focus {
			outline: none;
			border-color: var(--pf-button-hover-border, #3498db);
			box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.15);
		}
		.pict-flow-popup-layout-form input[type="checkbox"] {
			margin: 0 4px 0 0;
		}
		`;
	}

	// ── Connections ────────────────────────────────────────────────────────
	/**
	 * CSS for connection paths: base, hover/selected states, hitarea, drag-connection.
	 * @returns {string}
	 */
	getConnectionCSS()
	{
		return /*css*/`
		/* Arrowhead markers use CSS-driven fills so they follow --pf-* tokens
		   (which in turn map to host --theme-color-* tokens). The polygon's
		   fill attribute is the fallback when CSS does not reach the marker. */
		.pict-flow-svg .pict-flow-arrowhead-default {
			fill: var(--pf-connection-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-selected {
			fill: var(--pf-connection-selected-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-tether {
			fill: var(--pf-connection-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-event-in {
			fill: var(--pf-connection-event-in-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-event-out {
			fill: var(--pf-connection-event-out-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-setting {
			fill: var(--pf-connection-setting-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-value {
			fill: var(--pf-connection-value-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-error {
			fill: var(--pf-connection-error-stroke);
		}

		.pict-flow-connection {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 2;
			cursor: pointer;
			transition: stroke 0.15s;
		}
		/* A connection's label (Data.Label), drawn at the midpoint. The white halo (paint-order) keeps it
		   legible where it crosses the line. */
		.pict-flow-connection-label {
			font-size: 12px;
			font-family: inherit;
			fill: var(--pf-text-primary, #2c3e50);
			paint-order: stroke;
			stroke: var(--theme-color-background-primary, #ffffff);
			stroke-width: 3px;
			stroke-linejoin: round;
			pointer-events: none;
			user-select: none;
		}
		.pict-flow-connection:hover {
			stroke: var(--pf-connection-stroke-hover);
			stroke-width: 3;
		}
		.pict-flow-connection.selected {
			stroke: var(--pf-connection-selected-stroke);
			stroke-width: 3;
		}
		/* Connection type color overrides (based on source port type) */
		.pict-flow-connection.conn-type-event-in {
			stroke: var(--pf-connection-event-in-stroke);
		}
		.pict-flow-connection.conn-type-event-out {
			stroke: var(--pf-connection-event-out-stroke);
		}
		.pict-flow-connection.conn-type-setting {
			stroke: var(--pf-connection-setting-stroke);
		}
		.pict-flow-connection.conn-type-value {
			stroke: var(--pf-connection-value-stroke);
		}
		.pict-flow-connection.conn-type-error {
			stroke: var(--pf-connection-error-stroke);
		}
		.pict-flow-connection-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 12;
			cursor: pointer;
		}
		.pict-flow-drag-connection {
			fill: none;
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			stroke-dasharray: 6 3;
			pointer-events: none;
		}
		`;
	}

	// ── Connection Handles ─────────────────────────────────────────────────
	/**
	 * CSS for connection waypoint handles and midpoint handles.
	 * @returns {string}
	 */
	getHandleCSS()
	{
		return /*css*/`
		.pict-flow-connection-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-connection-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Tethers ────────────────────────────────────────────────────────────
	/**
	 * CSS for tether lines, hitareas, handles, and midpoint handles.
	 * @returns {string}
	 */
	getTetherCSS()
	{
		return /*css*/`
		.pict-flow-tether-line {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 1.5;
			stroke-dasharray: 6 4;
			pointer-events: visibleStroke;
			cursor: pointer;
		}
		.pict-flow-tether-line.selected {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-tether-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 10;
			cursor: pointer;
		}
		.pict-flow-tether-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-tether-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Panels ─────────────────────────────────────────────────────────────
	/**
	 * CSS for property panels: foreign object, panel container, titlebar, close button, body, indicator.
	 * @returns {string}
	 */
	getPanelCSS()
	{
		return /*css*/`
		.pict-flow-node-panel-indicator {
			fill: var(--pf-node-selected-stroke);
			stroke: none;
			opacity: 0.6;
			cursor: pointer;
			transition: opacity 0.15s;
		}
		.pict-flow-node-panel-indicator:hover {
			opacity: 1.0;
		}
		.pict-flow-panel-foreign-object {
			overflow: visible;
		}
		.pict-flow-panel {
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-panel-border);
			border-radius: var(--pf-panel-radius);
			box-shadow: var(--pf-panel-shadow);
			display: flex;
			flex-direction: column;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			/* WebKit paints a foreignObject's scrolling HTML content (the .pict-flow-panel-content
			   pane, overflow-y:auto) at the wrong offset when the flow sits inside a position:fixed
			   ancestor -- e.g. the .pict-flow-fullscreen wrapper. The white panel box lands in the
			   right place but its controls slide off to the side (moodboard fullscreen editing in
			   Safari). Promoting the panel to its own layer/stacking context makes WebKit resolve the
			   inner scroll layer against the panel, so box and content line up again. This is a no-op
			   in Chromium / Firefox, which never had the bug. */
			transform: translateZ(0);
		}
		.pict-flow-panel-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 8px 12px;
			background: var(--pf-panel-titlebar-bg);
			border-bottom: 1px solid var(--pf-panel-titlebar-border);
			cursor: grab;
			user-select: none;
			-webkit-user-select: none;
			flex-shrink: 0;
		}
		.pict-flow-panel-titlebar.dragging {
			cursor: grabbing;
		}
		/* While a panel's foreignObject is dragged or resized, its x/y/height are rewritten on every
		   pointermove. A box-shadow on the HTML panel bleeds past the foreignObject box, and that bled
		   region is not in the per-move dirty rect, so the browser smears a copy of the shadow at the
		   old position (the "stuck shadow"). Drop the shadow for the duration of the gesture so there
		   is nothing to leave behind; it returns in place the moment the drag ends. */
		.pict-flow-panel-foreign-object.pict-flow-panel-dragging .pict-flow-panel {
			box-shadow: none;
		}
		.pict-flow-panel-title-text {
			font-weight: 600;
			font-size: 12px;
			color: var(--pf-panel-title-color);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			letter-spacing: 0.1px;
		}
		.pict-flow-panel-close-btn {
			cursor: pointer;
			color: var(--pf-button-close-color);
			font-size: 14px;
			line-height: 1;
			padding: 4px;
			border: none;
			background: none;
			border-radius: 4px;
			transition: background-color 0.15s, color 0.15s;
		}
		.pict-flow-panel-close-btn:hover {
			color: var(--pf-button-danger-text);
			background-color: rgba(231, 76, 60, 0.08);
		}
		.pict-flow-panel-content {
			flex: 1;
			overflow-y: auto;
			min-height: 0;
			padding: 0;
		}
		.pict-flow-panel-tab-pane {
			padding: 10px 12px;
			box-sizing: border-box;
		}
		`;
	}

	// ── Info Panels ────────────────────────────────────────────────────────
	/**
	 * CSS for the info/hover panel and all sub-elements: header, description, badges, sections, ports.
	 * @returns {string}
	 */
	getInfoPanelCSS()
	{
		return /*css*/`
		.pict-flow-info-panel {
			padding: 2px 0;
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-info-panel-header {
			font-size: 13px;
			font-weight: 600;
			margin-bottom: 6px;
			color: var(--pf-text-heading);
		}
		.pict-flow-info-panel-header.with-icon {
			font-size: 14px;
			display: flex;
			align-items: center;
			gap: 6px;
		}
		.pict-flow-info-panel-description {
			font-size: 11px;
			color: var(--pf-text-secondary);
			margin-bottom: 10px;
			line-height: 1.45;
		}
		.pict-flow-info-panel-badges {
			margin-bottom: 10px;
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
		}
		.pict-flow-info-panel-badge {
			display: inline-block;
			padding: 2px 8px;
			border-radius: 4px;
			font-size: 10px;
		}
		.pict-flow-info-panel-badge.category {
			background: var(--pf-badge-category-bg);
			color: var(--pf-badge-category-text);
		}
		.pict-flow-info-panel-badge.code {
			background: var(--pf-badge-code-bg);
			color: var(--pf-badge-code-text);
			font-family: "SF Mono", "Fira Code", monospace;
		}
		.pict-flow-info-panel-section {
			margin-bottom: 8px;
		}
		.pict-flow-info-panel-section-title {
			font-size: 10px;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--pf-text-tertiary);
			margin-bottom: 4px;
			padding-bottom: 2px;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-info-panel-port {
			padding: 3px 8px;
			background: var(--pf-port-item-bg);
			margin-bottom: 3px;
			font-size: 11px;
			border-radius: 3px;
		}
		.pict-flow-info-panel-port.input {
			border-left: 3px solid var(--pf-port-input-fill);
		}
		.pict-flow-info-panel-port.output {
			border-left: 3px solid var(--pf-port-output-fill);
		}
		/* Info panel port type color overrides */
		.pict-flow-info-panel-port.port-type-event-in {
			border-left-color: var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.port-type-event-out {
			border-left-color: var(--pf-port-event-out-fill);
		}
		.pict-flow-info-panel-port.port-type-setting {
			border-left-color: var(--pf-port-setting-fill);
		}
		.pict-flow-info-panel-port.port-type-value {
			border-left-color: var(--pf-port-value-fill);
		}
		.pict-flow-info-panel-port.port-type-error {
			border-left-color: var(--pf-port-error-fill);
		}
		.pict-flow-info-panel-port-constraint {
			color: var(--pf-text-tertiary);
			font-size: 10px;
		}
		/* Port summary section appended below form panels */
		.pict-flow-port-summary {
			margin-top: 12px;
			padding-top: 8px;
			border-top: 1px solid var(--pf-divider-medium);
		}
		.pict-flow-info-panel-port.event {
			border-left: 3px solid var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.value {
			border-left: 3px solid var(--pf-port-value-fill);
		}
		`;
	}

	// ── Node Properties Editor ────────────────────────────────────────────
	/**
	 * CSS for the node properties editor fields used in the Appearance tab.
	 * @returns {string}
	 */
	getNodePropsEditorCSS()
	{
		return /*css*/`
		.pict-flow-node-props-fields {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
		.pict-flow-node-props-field {
			display: flex;
			align-items: center;
			gap: 8px;
		}
		.pict-flow-node-props-label {
			font-size: 11px;
			color: var(--pf-text-secondary);
			min-width: 72px;
			flex-shrink: 0;
		}
		.pict-flow-node-props-input {
			flex: 1;
			padding: 3px 6px;
			border: 1px solid var(--pf-input-border);
			border-radius: 3px;
			font-size: 11px;
			outline: none;
			box-sizing: border-box;
			min-width: 0;
		}
		.pict-flow-node-props-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-node-props-color {
			width: 28px;
			height: 24px;
			padding: 1px;
			cursor: pointer;
			flex: 0 0 28px;
		}

		/* Suppress native number-input spinner buttons on every input
		   inside a properties panel. Panels live inside <foreignObject>;
		   browsers (Chromium / WebKit) render the up/down spinner chrome
		   as native overlays that don't always respect SVG transforms or
		   the parent tab pane's display:none — leaving stale spinner
		   artifacts hanging around when the user switches tabs or pans
		   the diagram. The user can still type numbers; they just don't
		   get clickable spinners. (If we ever want spinners back, build
		   them as real DOM elements next to the input, not native chrome.) */
		.pict-flow-panel input[type="number"] {
			-moz-appearance: textfield;
			appearance: textfield;
		}
		.pict-flow-panel input[type="number"]::-webkit-outer-spin-button,
		.pict-flow-panel input[type="number"]::-webkit-inner-spin-button {
			-webkit-appearance: none;
			appearance: none;
			margin: 0;
		}
		`;
	}

	// ── Panel Tabs & Resize ───────────────────────────────────────────────
	/**
	 * CSS for the tab bar, tab panes, resize handle, and help content.
	 * @returns {string}
	 */
	getPanelTabsCSS()
	{
		return /*css*/`
		.pict-flow-panel-resize-handle {
			height: 6px;
			cursor: ns-resize;
			background: transparent;
			flex-shrink: 0;
			transition: background-color 0.15s;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-panel-resize-handle::after {
			content: '';
			width: 24px;
			height: 2px;
			border-radius: 1px;
			background: var(--pf-resize-handle-hover);
			transition: background-color 0.15s, width 0.15s;
		}
		.pict-flow-panel-resize-handle:hover::after {
			background: var(--pf-button-hover-border);
			width: 32px;
		}
		.pict-flow-panel-tabbar {
			display: flex;
			flex-shrink: 0;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			background: var(--pf-panel-titlebar-bg);
		}
		.pict-flow-panel-tab {
			flex: 1;
			padding: 5px 8px;
			font-size: 11px;
			text-align: center;
			cursor: pointer;
			color: var(--pf-tab-text);
			border-top: 2px solid transparent;
			transition: color 0.15s, border-top-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-panel-tab:hover {
			color: var(--pf-tab-text-hover);
		}
		.pict-flow-panel-tab.active {
			border-top-color: var(--pf-node-selected-stroke);
			color: var(--pf-panel-title-color);
			font-weight: 600;
		}
		.pict-flow-panel-help-content {
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-panel-help-content p {
			margin: 0 0 8px 0;
		}
		`;
	}

	// ── Fullscreen ─────────────────────────────────────────────────────────
	/**
	 * CSS for fullscreen mode.
	 * @returns {string}
	 */
	getFullscreenCSS()
	{
		return /*css*/`
		.pict-flow-fullscreen {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			z-index: 9999;
			border-radius: 0;
			border: none;
			min-height: 100vh;
		}
		.pict-flow-fullscreen .pict-flow-svg {
			min-height: calc(100vh - 50px);
		}
		`;
	}

	// ── Toolbar ────────────────────────────────────────────────────────────
	/**
	 * CSS for the toolbar: buttons, groups, labels, selects.
	 * @returns {string}
	 */
	getToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.5em 0.75em;
			background-color: var(--pf-toolbar-bg);
			border-bottom: 1px solid var(--pf-toolbar-border);
			flex-wrap: wrap;
		}
		.pict-flow-toolbar-group {
			display: flex;
			align-items: center;
			gap: 0.25em;
			padding-right: 0.75em;
			border-right: 1px solid var(--pf-toolbar-border);
		}
		.pict-flow-toolbar-group:last-child {
			border-right: none;
			padding-right: 0;
		}
		/* The host-supplied extra-button group (ToolbarExtraButtons) renders even
		   when empty; collapse it so consumers that pass no buttons see no gap. */
		.pict-flow-toolbar-group:empty {
			display: none;
		}
		.pict-flow-toolbar-btn-active {
			background-color: var(--pf-button-active-bg);
			border-color: var(--pf-button-hover-border);
		}
		/* Toggle-state LED: a status dot in the corner of a toggle button (one marked
		   Toggle:true). Action buttons render no LED; a toggle shows an empty outline
		   when off and a filled green dot when on (the .active class). Works on the
		   docked and floating toolbars. */
		.pict-flow-toolbar-btn, .pict-flow-floating-btn {
			position: relative;
		}
		.pict-flow-toolbar-btn-led {
			display: none;
			position: absolute;
			right: 2px;
			bottom: 2px;
			width: 7px;
			height: 7px;
			box-sizing: border-box;
			border-radius: 50%;
			border: 1.5px solid var(--pf-button-border, #c2cad6);
			background: transparent;
			pointer-events: none;
		}
		.pict-flow-toolbar-btn-toggle .pict-flow-toolbar-btn-led {
			display: block;
		}
		.pict-flow-toolbar-btn-toggle.pict-flow-toolbar-btn-active .pict-flow-toolbar-btn-led {
			background: var(--theme-color-status-success, #27ae60);
			border-color: var(--theme-color-status-success, #27ae60);
		}
		/* An icon-only host button (ToolbarExtraButtons with no Label) renders an empty text span. */
		.pict-flow-toolbar-btn-text:empty {
			display: none;
		}
		.pict-flow-toolbar-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			gap: 0.35em;
			padding: 0.35em 0.65em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
			font-size: 0.85em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-toolbar-btn:focus {
			outline: none;
		}
		.pict-flow-toolbar-btn:hover {
			background-color: var(--pf-button-hover-bg);
			border-color: var(--pf-button-hover-border);
		}
		.pict-flow-toolbar-btn:active {
			background-color: var(--pf-button-active-bg);
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
		}
		.pict-flow-toolbar-btn-text {
			white-space: nowrap;
		}
		.pict-flow-toolbar-btn-chevron {
			display: inline-flex;
			align-items: center;
			margin-left: 0.15em;
		}
		/* Split button — visible as one connected unit; the two halves
		   route to different actions. Used for "Auto" so clicking the
		   icon/text applies the current layout while the chevron half
		   opens the algorithm popup with a generous hit area. */
		.pict-flow-toolbar-btn-split {
			display: inline-flex;
			align-items: stretch;
		}
		.pict-flow-toolbar-btn-split-main {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-right: 1px solid var(--pf-button-border);
			margin-right: -1px; /* collapse the seam between the two buttons */
		}
		.pict-flow-toolbar-btn-split-chevron {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			padding-left: 0.55em;
			padding-right: 0.55em;
		}
		.pict-flow-toolbar-btn-split-chevron .pict-flow-toolbar-btn-chevron {
			margin: 0;
		}
		.pict-flow-toolbar-right {
			margin-left: auto;
			border-right: none;
			padding-right: 0;
		}
		.pict-flow-toolbar-label {
			font-size: 0.8em;
			color: var(--pf-text-secondary);
			margin-right: 0.25em;
		}
		.pict-flow-toolbar-select {
			padding: 0.3em 0.5em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			font-size: 0.85em;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
		}
		`;
	}

	// ── Card Palette ───────────────────────────────────────────────────────
	/**
	 * CSS for the card palette: toggle, body, categories, cards, swatches.
	 * @returns {string}
	 */
	getPaletteCSS()
	{
		return /*css*/`
		.pict-flow-palette-category {
			margin-bottom: 0.5em;
		}
		.pict-flow-palette-category:last-child {
			margin-bottom: 0;
		}
		.pict-flow-palette-category-label {
			font-size: 0.7em;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--pf-text-placeholder);
			margin-bottom: 0.35em;
			padding-bottom: 0.2em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-palette-cards {
			display: flex;
			flex-wrap: wrap;
			gap: 0.35em;
		}
		.pict-flow-palette-card {
			display: inline-flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.6em;
			border: 1px solid var(--pf-card-border);
			border-radius: 4px;
			background-color: var(--pf-panel-bg);
			font-size: 0.8em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
			user-select: none;
			-webkit-user-select: none;
			position: relative;
		}
		.pict-flow-palette-card:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-node-selected-stroke);
			box-shadow: var(--pf-card-hover-shadow);
		}
		.pict-flow-palette-card.disabled {
			opacity: 0.45;
			pointer-events: none;
			cursor: default;
		}
		.pict-flow-palette-card-icon {
			font-size: 1.1em;
			line-height: 1;
		}
		.pict-flow-palette-card-swatch {
			width: 10px;
			height: 10px;
			border-radius: 2px;
			flex-shrink: 0;
		}
		.pict-flow-palette-card-title {
			font-weight: 500;
			color: var(--pf-text-primary);
			white-space: nowrap;
		}
		.pict-flow-palette-card-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
		}
		.pict-flow-toolbar-select.layout-select {
			min-width: 120px;
			max-width: 200px;
		}
		`;
	}

	// ── Popups ────────────────────────────────────────────────────────────
	/**
	 * CSS for toolbar dropdown popups (Add Node, Cards, Layout).
	 * @returns {string}
	 */
	getPopupCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-popup-anchor {
			position: relative;
		}
		.pict-flow-toolbar-popup {
			position: absolute;
			z-index: 1000;
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-card-border);
			border-radius: 6px;
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			min-width: 240px;
			max-height: 80vh;
			overflow-y: auto;
			padding: 0.35em 0;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
		}
		.pict-flow-popup-search-wrapper {
			position: relative;
			padding: 0.4em 0.5em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-popup-search-icon {
			position: absolute;
			left: 0.85em;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none;
			line-height: 1;
			display: flex;
			align-items: center;
		}
		.pict-flow-popup-search {
			width: 100%;
			padding: 0.4em 0.5em 0.4em 2em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-search:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-list-item {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-list-item:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-list-item-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-list-item-label {
			flex: 1;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-list-item-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
			background: var(--pf-badge-category-bg);
			padding: 0.1em 0.4em;
			border-radius: 3px;
		}
		.pict-flow-popup-divider {
			height: 1px;
			background: var(--pf-divider-light);
			margin: 0.25em 0;
		}
		.pict-flow-popup-list-empty {
			text-align: center;
			color: var(--pf-text-placeholder);
			padding: 1.5em 0.75em;
			font-size: 0.9em;
		}
		.pict-flow-popup-layout-save {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-layout-save:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-save-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-input-row {
			display: flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.5em;
		}
		.pict-flow-popup-layout-save-input {
			flex: 1;
			padding: 0.35em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-layout-save-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-save-confirm {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			background: var(--pf-panel-bg);
			cursor: pointer;
			flex-shrink: 0;
			transition: background-color 0.15s, border-color 0.15s;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-confirm:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-row {
			display: flex;
			align-items: center;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-layout-row:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-name {
			flex: 1;
			color: var(--pf-text-primary);
		}
		.pict-flow-popup-layout-delete {
			display: none;
			align-items: center;
			justify-content: center;
			border: none;
			background: none;
			color: var(--pf-button-danger-text);
			cursor: pointer;
			padding: 2px 4px;
			border-radius: 3px;
			line-height: 1;
		}
		.pict-flow-popup-layout-row:hover .pict-flow-popup-layout-delete {
			display: inline-flex;
		}
		.pict-flow-popup-layout-delete:hover {
			background-color: var(--pf-button-danger-hover-bg);
		}
		.pict-flow-popup-settings-section {
			padding: 0.5em 0.75em;
		}
		.pict-flow-popup-settings-label {
			display: block;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--pf-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin-bottom: 0.35em;
		}
		.pict-flow-popup-settings-select {
			width: 100%;
			padding: 0.4em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			background: var(--pf-panel-bg);
			color: var(--pf-text-primary);
			cursor: pointer;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-settings-select:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-settings-slider-row {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.pict-flow-popup-settings-slider {
			flex: 1;
			-webkit-appearance: none;
			appearance: none;
			height: 4px;
			background: var(--pf-input-border);
			border-radius: 2px;
			outline: none;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-webkit-slider-thumb {
			-webkit-appearance: none;
			appearance: none;
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-moz-range-thumb {
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
			border: none;
		}
		.pict-flow-popup-settings-slider-value {
			font-size: 0.85em;
			color: var(--pf-text-secondary);
			min-width: 2.5em;
			text-align: right;
		}
		`;
	}

	// ── Collapsed Toolbar ─────────────────────────────────────────────────
	/**
	 * CSS for the collapsed toolbar state (small expand button in corner).
	 * @returns {string}
	 */
	getCollapsedToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-collapsed {
			position: absolute;
			top: 8px;
			right: 8px;
			z-index: 100;
			display: none;
		}
		.pict-flow-toolbar-collapsed.visible {
			display: block;
		}
		.pict-flow-toolbar-expand-btn {
			width: 36px;
			height: 36px;
			border-radius: 6px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 2px 6px rgba(0,0,0,0.1);
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s, box-shadow 0.15s;
		}
		.pict-flow-toolbar-expand-btn:hover {
			background-color: var(--pf-button-hover-bg);
			box-shadow: 0 2px 8px rgba(0,0,0,0.15);
		}
		`;
	}

	// ── Floating Toolbar ──────────────────────────────────────────────────
	/**
	 * CSS for the floating draggable toolbar.
	 * @returns {string}
	 */
	getFloatingToolbarCSS()
	{
		return /*css*/`
		.pict-flow-floating-toolbar {
			position: absolute;
			z-index: 100;
			display: flex;
			flex-direction: column;
			gap: 2px;
			padding: 4px;
			border-radius: 8px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			pointer-events: auto;
		}
		.pict-flow-floating-grip {
			cursor: grab;
			padding: 4px;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-grip:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-grip:active {
			cursor: grabbing;
		}
		.pict-flow-floating-btn {
			width: 32px;
			height: 32px;
			border: none;
			border-radius: 4px;
			background-color: transparent;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-btn:focus {
			outline: none;
		}
		.pict-flow-floating-btn:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-separator {
			height: 1px;
			background-color: var(--pf-divider-light);
			margin: 2px 4px;
		}
		/* Collapsed floating toolbar — grip-only draggable square */
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-btn,
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-separator {
			display: none;
		}
		.pict-flow-floating-toolbar.collapsed {
			padding: 0;
			border-radius: 6px;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip {
			width: 32px;
			height: 32px;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip span {
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		`;
	}

	// ── Icons ─────────────────────────────────────────────────────────────
	/**
	 * CSS for inline SVG icons in palette cards, toolbar buttons, info panel headers, and panel close buttons.
	 * @returns {string}
	 */
	getIconCSS()
	{
		return /*css*/`
		.pict-flow-icon-svg {
			pointer-events: none;
		}
		.pict-flow-palette-card-icon svg {
			display: inline-block;
			vertical-align: middle;
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
			vertical-align: middle;
		}
		.pict-flow-info-panel-header.with-icon svg {
			display: inline-block;
			vertical-align: middle;
			margin-right: 4px;
		}
		.pict-flow-panel-close-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-panel-close-icon svg {
			display: block;
		}
		.pict-flow-palette-toggle-arrow svg {
			display: block;
		}
		`;
	}

	// ── Bracket Node CSS ──────────────────────────────────────────────────
	/**
	 * CSS for bracket-style node bodies used by sketch/blueprint themes.
	 *
	 * The bracket fill rects share class `.pict-flow-node-body` for fill
	 * inheritance, so these rules must use parent-qualified selectors
	 * (specificity ≥ 0,2,0) to override the base, variant, hover, and
	 * selected rules that set stroke and rx/ry on `.pict-flow-node-body`.
	 *
	 * @returns {string}
	 */
	getBracketNodeCSS()
	{
		return /*css*/`
		/* Bracket outline path */
		.pict-flow-node-bracket {
			fill: none;
			stroke: var(--pf-node-body-stroke);
			stroke-width: 2;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-flow-node.selected .pict-flow-node-bracket {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node:hover .pict-flow-node-bracket {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}

		/* Bracket fill rects: no stroke, no rounded corners.
		   Uses parent-qualified selectors to beat variant rules
		   (e.g. .pict-flow-node-start .pict-flow-node-body). */
		.pict-flow-node .pict-flow-node-bracket-fill,
		.pict-flow-node .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
			rx: 0;
			ry: 0;
		}
		/* Beat hover rule: .pict-flow-node:hover .pict-flow-node-body */
		.pict-flow-node:hover .pict-flow-node-bracket-fill,
		.pict-flow-node:hover .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		/* Beat selected rule: .pict-flow-node.selected .pict-flow-node-body */
		.pict-flow-node.selected .pict-flow-node-bracket-fill,
		.pict-flow-node.selected .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		`;
	}

	// ── Aggregate Methods ──────────────────────────────────────────────────

	/**
	 * Concatenate all domain CSS getters into a single CSS string.
	 * Includes theme overrides if a theme provider is active.
	 * @returns {string}
	 */
	generateCSS()
	{
		let tmpBaseCSS = (
			this.getContainerCSS() +
			this.getNodeCSS() +
			this.getBodyContentCSS() +
			this.getNodeVariantCSS() +
			this.getPortCSS() +
			this.getConnectionCSS() +
			this.getHandleCSS() +
			this.getTetherCSS() +
			this.getPanelCSS() +
			this.getInfoPanelCSS() +
			this.getNodePropsEditorCSS() +
			this.getPanelTabsCSS() +
			this.getBracketNodeCSS() +
			this.getFullscreenCSS() +
			this.getToolbarCSS() +
			this.getPaletteCSS() +
			this.getPopupCSS() +
			this.getCollapsedToolbarCSS() +
			this.getFloatingToolbarCSS() +
			this.getIconCSS()
		);

		// Apply theme overrides if a theme provider exists
		if (this._FlowView && this._FlowView._ThemeProvider)
		{
			let tmpTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpTheme && tmpTheme.CSSVariables && Object.keys(tmpTheme.CSSVariables).length > 0)
			{
				let tmpOverrides = '.pict-flow-container {\n';
				for (let tmpKey in tmpTheme.CSSVariables)
				{
					tmpOverrides += '\t' + tmpKey + ': ' + tmpTheme.CSSVariables[tmpKey] + ';\n';
				}
				tmpOverrides += '}\n';
				tmpBaseCSS += tmpOverrides;
			}
			if (tmpTheme && tmpTheme.AdditionalCSS)
			{
				tmpBaseCSS += tmpTheme.AdditionalCSS;
			}
		}

		return tmpBaseCSS;
	}

	/**
	 * Register all flow CSS with pict's CSSMap service.
	 * Uses correct parameter ordering: (hash, content, priority, provider).
	 * Removes existing CSS first to allow theme re-registration,
	 * then re-injects into the DOM.
	 */
	registerCSS()
	{
		if (this.fable && this.fable.CSSMap)
		{
			// Remove existing CSS first so we can re-register with updated theme overrides
			this.fable.CSSMap.removeCSS('PictSectionFlow-CSS');
			this.fable.CSSMap.addCSS('PictSectionFlow-CSS', this.generateCSS(), 500, 'PictProviderFlowCSS');

			// Supplemental CSS (read-only chrome hiding + content frame), at a
			// priority above the base so the hides win.
			this.fable.CSSMap.removeCSS('PictSectionFlow-Supplemental-CSS');
			this.fable.CSSMap.addCSS('PictSectionFlow-Supplemental-CSS', this._supplementalCSS(), 502, 'PictProviderFlowCSS');

			// Re-inject into the DOM to apply the updated CSS
			this.fable.CSSMap.injectCSS();
		}
		else
		{
			this.log.warn('PictProviderFlowCSS: CSSMap not available; CSS not registered.');
		}
	}

	/**
	 * Register the active renderer's CSS overrides (GeometryCSS + AdditionalCSS).
	 *
	 * The renderer's CSS is registered at priority 501 — one higher than the
	 * base container CSS — so its `.pict-flow-container { --pf-*: ... }`
	 * declarations win the cascade against the equally-specific defaults in
	 * `generateCSS()`. Called by PictView-Flow.setRenderer() after the
	 * Flow-Renderer provider switches its active renderer.
	 *
	 * @param {Object} pRenderer - the active renderer definition (from PictProviderFlowRenderer)
	 */
	registerRendererCSS(pRenderer)
	{
		if (!this.fable || !this.fable.CSSMap) { return; }
		this.fable.CSSMap.removeCSS('PictSectionFlow-Renderer-CSS');
		if (!pRenderer) { this.fable.CSSMap.injectCSS(); return; }

		let tmpCSS = '';
		if (pRenderer.GeometryCSS)   { tmpCSS += pRenderer.GeometryCSS;   }
		if (pRenderer.AdditionalCSS) { tmpCSS += '\n' + pRenderer.AdditionalCSS; }
		if (tmpCSS.trim().length === 0) { this.fable.CSSMap.injectCSS(); return; }

		this.fable.CSSMap.addCSS('PictSectionFlow-Renderer-CSS', tmpCSS, 501, 'PictProviderFlowCSS');
		this.fable.CSSMap.injectCSS();
	}

	/**
	 * Supplemental CSS: hides editing chrome when the container carries the
	 * 'pict-flow-readonly' class (set by PictView-Flow.setReadOnly), and styles
	 * the content-frame rectangle. Replaces the ad-hoc CSS consumers (e.g.
	 * moodboard) used to inject for a read-only look or a board frame.
	 * @returns {string}
	 */
	_supplementalCSS()
	{
		return /*css*/`
		.pict-flow-readonly .pict-flow-port,
		.pict-flow-readonly .pict-flow-port-hint,
		.pict-flow-readonly .pict-flow-node-resize-handle { display: none; }
		.pict-flow-readonly [data-flow-action="add-node"],
		.pict-flow-readonly [data-flow-action="delete-selected"],
		.pict-flow-readonly [data-flow-action="cards-popup"] { display: none; }
		.pict-flow-frame { fill: none; stroke: var(--theme-color-border, #9aa3ab); stroke-width: 1.5; stroke-dasharray: 8 6; pointer-events: none; }
		.pict-flow-frame-handle { fill: var(--theme-color-background-panel, #ffffff); stroke: var(--theme-color-brand-primary, #2e7d74); stroke-width: 1.5; }
		.pict-flow-frame-handle:hover { fill: var(--theme-color-brand-primary, #2e7d74); }
		.pict-flow-frame-handle-n, .pict-flow-frame-handle-s { cursor: ns-resize; }
		.pict-flow-frame-handle-e, .pict-flow-frame-handle-w { cursor: ew-resize; }
		.pict-flow-frame-move-handle { cursor: move; rx: 6; }
		.pict-flow-node-rotate-arm { stroke: var(--theme-color-brand-primary, #2e7d74); stroke-width: 1.5; }
		.pict-flow-node-rotate-handle { fill: var(--theme-color-background-panel, #ffffff); stroke: var(--theme-color-brand-primary, #2e7d74); stroke-width: 1.5; cursor: grab; }
		.pict-flow-node-rotate-handle:hover { fill: var(--theme-color-brand-primary, #2e7d74); }
		.pict-flow-readonly .pict-flow-node-rotate-arm,
		.pict-flow-readonly .pict-flow-node-rotate-handle { display: none; }
		`;
	}
}

module.exports = PictProviderFlowCSS;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":59}],217:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class PictProviderFlowConnectorShapes extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowConnectorShapes';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Default shape configurations — each keyed by a shape identifier
		// _OriginalShapes stores a deep copy for reset when switching themes.
		this._DefaultShapes =
		{
			'port':
			{
				ElementType: 'circle',
				Attributes: { r: '5' },
				ClassName: 'pict-flow-port'
			},
			'panel-indicator':
			{
				ElementType: 'rect',
				Attributes: { rx: '2', ry: '2' },
				ClassName: 'pict-flow-node-panel-indicator'
			},
			'connection-path':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-connection'
			},
			'connection-hitarea':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-connection-hitarea'
			},
			'connection-handle':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-connection-handle'
			},
			'connection-handle-midpoint':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-connection-handle-midpoint'
			},
			'drag-connection':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-drag-connection'
			},
			'tether-path':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-tether-line'
			},
			'tether-hitarea':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-tether-hitarea'
			},
			'tether-handle':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-tether-handle'
			},
			'tether-handle-midpoint':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-tether-handle-midpoint'
			},
			'arrowhead-connection':
			{
				MarkerWidth: '5',
				MarkerHeight: '7',
				RefX: '7.5',
				RefY: '3.5',
				Points: '0 0, 5 3.5, 0 7',
				Fill: 'var(--theme-color-border-default, #95a5a6)'
			},
			'arrowhead-connection-selected':
			{
				MarkerWidth: '5',
				MarkerHeight: '7',
				RefX: '7.5',
				RefY: '3.5',
				Points: '0 0, 5 3.5, 0 7',
				Fill: 'var(--theme-color-status-info, #3498db)'
			},
			'arrowhead-tether':
			{
				MarkerWidth: '4',
				MarkerHeight: '6',
				RefX: '6',
				RefY: '3',
				Points: '0 0, 4 3, 0 6',
				Fill: 'var(--theme-color-border-default, #95a5a6)'
			}
		};

		// Store a deep copy for resetting when switching themes
		this._OriginalShapes = JSON.parse(JSON.stringify(this._DefaultShapes));
	}

	// ── Theme Override Methods ─────────────────────────────────────────────

	/**
	 * Apply theme-specific shape overrides.
	 * Merges the overrides into the active shape configs.
	 * @param {Object} pOverrides - Map of shape key to partial config
	 */
	applyThemeOverrides(pOverrides)
	{
		if (!pOverrides || typeof pOverrides !== 'object')
		{
			return;
		}
		for (let tmpKey in pOverrides)
		{
			if (this._DefaultShapes.hasOwnProperty(tmpKey))
			{
				Object.assign(this._DefaultShapes[tmpKey], pOverrides[tmpKey]);
			}
			else
			{
				this._DefaultShapes[tmpKey] = pOverrides[tmpKey];
			}
		}
	}

	/**
	 * Reset all shape configs to their original defaults.
	 * Called before applying new theme overrides to prevent accumulation.
	 */
	resetToDefaults()
	{
		this._DefaultShapes = JSON.parse(JSON.stringify(this._OriginalShapes));
	}

	/**
	 * Get a shape configuration by key.
	 * @param {string} pShapeKey
	 * @returns {Object|null}
	 */
	getShapeConfig(pShapeKey)
	{
		if (this._DefaultShapes.hasOwnProperty(pShapeKey))
		{
			return this._DefaultShapes[pShapeKey];
		}
		return null;
	}

	/**
	 * Override or add a shape configuration.
	 * Consumers can call this to customize connector shapes without subclassing.
	 * @param {string} pShapeKey
	 * @param {Object} pConfig
	 */
	setShapeConfig(pShapeKey, pConfig)
	{
		this._DefaultShapes[pShapeKey] = pConfig;
	}

	/**
	 * Get all registered shape keys.
	 * @returns {string[]}
	 */
	getShapeKeys()
	{
		return Object.keys(this._DefaultShapes);
	}

	// ---- Factory Methods ----

	/**
	 * Create a port SVG element.
	 * @param {Object} pPortData - Port data with Hash, Direction
	 * @param {{x: number, y: number}} pPosition - Local position within the node group
	 * @param {string} pNodeHash - The owning node hash
	 * @returns {SVGCircleElement}
	 */
	createPortElement(pPortData, pPosition, pNodeHash)
	{
		let tmpConfig = this._DefaultShapes['port'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		let tmpClassName = tmpConfig.ClassName + ' ' + pPortData.Direction;
		if (pPortData.PortType)
		{
			tmpClassName += ' port-type-' + pPortData.PortType;
		}
		tmpElement.setAttribute('class', tmpClassName);
		tmpElement.setAttribute('cx', String(pPosition.x));
		tmpElement.setAttribute('cy', String(pPosition.y));
		// Apply config attributes (r, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-port-hash', pPortData.Hash);
		tmpElement.setAttribute('data-node-hash', pNodeHash);
		tmpElement.setAttribute('data-port-direction', pPortData.Direction);
		if (pPortData.PortType)
		{
			tmpElement.setAttribute('data-port-type', pPortData.PortType);
		}
		tmpElement.setAttribute('data-element-type', 'port');
		return tmpElement;
	}

	/**
	 * Create a panel indicator SVG element.
	 * @param {string} pNodeHash
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @returns {SVGRectElement}
	 */
	createPanelIndicatorElement(pNodeHash, pX, pY, pWidth, pHeight)
	{
		let tmpConfig = this._DefaultShapes['panel-indicator'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('x', String(pX));
		tmpElement.setAttribute('y', String(pY));
		tmpElement.setAttribute('width', String(pWidth));
		tmpElement.setAttribute('height', String(pHeight));
		// Apply config attributes (rx, ry, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-node-hash', pNodeHash);
		tmpElement.setAttribute('data-element-type', 'panel-indicator');
		return tmpElement;
	}

	/**
	 * Create a visible connection path SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pConnectionHash
	 * @param {boolean} pIsSelected
	 * @param {string} pViewIdentifier
	 * @returns {SVGPathElement}
	 */
	createConnectionPathElement(pPath, pConnectionHash, pIsSelected, pViewIdentifier)
	{
		let tmpConfig = this._DefaultShapes['connection-path'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName + (pIsSelected ? ' selected' : ''));
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-connection-hash', pConnectionHash);
		tmpElement.setAttribute('data-element-type', 'connection');

		// Arrow marker
		let tmpMarkerConfig = pIsSelected
			? this._DefaultShapes['arrowhead-connection-selected']
			: this._DefaultShapes['arrowhead-connection'];
		// The marker id follows the naming convention used in generateMarkerDefs
		let tmpMarkerId = pIsSelected
			? ('flow-arrowhead-selected-' + pViewIdentifier)
			: ('flow-arrowhead-' + pViewIdentifier);
		tmpElement.setAttribute('marker-end', 'url(#' + tmpMarkerId + ')');

		return tmpElement;
	}

	/**
	 * Create a connection hit area SVG element (wider invisible path for click targeting).
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pConnectionHash
	 * @returns {SVGPathElement}
	 */
	createConnectionHitAreaElement(pPath, pConnectionHash)
	{
		let tmpConfig = this._DefaultShapes['connection-hitarea'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-connection-hash', pConnectionHash);
		tmpElement.setAttribute('data-element-type', 'connection-hitarea');
		return tmpElement;
	}

	/**
	 * Create a drag handle circle element.
	 * Works for both connection handles and tether handles.
	 * @param {string} pOwnerHash - Connection hash or panel hash
	 * @param {string} pHandleType - e.g. 'ortho-corner1', 'bezier-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pShapeKey - 'connection-handle', 'connection-handle-midpoint', 'tether-handle', 'tether-handle-midpoint'
	 * @returns {SVGCircleElement}
	 */
	createHandleElement(pOwnerHash, pHandleType, pX, pY, pShapeKey)
	{
		let tmpConfig = this._DefaultShapes[pShapeKey] || this._DefaultShapes['connection-handle'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('cx', String(pX));
		tmpElement.setAttribute('cy', String(pY));
		// Apply config attributes (r, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-handle-type', pHandleType);
		return tmpElement;
	}

	/**
	 * Create a complete drag handle element with all data attributes set and
	 * append it to the given layer.  Unifies the handle-creation logic that
	 * was previously duplicated in ConnectionRenderer and TetherService.
	 *
	 * @param {SVGGElement} pLayer - The SVG group to append the handle to
	 * @param {string} pOwnerHash - Connection hash or panel hash
	 * @param {string} pHandleType - e.g. 'ortho-corner1', 'bezier-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pShapeKey - Shape config key ('connection-handle', 'tether-handle-midpoint', etc.)
	 * @param {string} pElementType - data-element-type value ('connection-handle' or 'tether-handle')
	 * @param {string} pOwnerAttrName - data attribute name for the owner ('data-connection-hash' or 'data-panel-hash')
	 * @returns {SVGElement}
	 */
	createFullHandle(pLayer, pOwnerHash, pHandleType, pX, pY, pShapeKey, pElementType, pOwnerAttrName)
	{
		let tmpHandle = this.createHandleElement(pOwnerHash, pHandleType, pX, pY, pShapeKey);
		tmpHandle.setAttribute('data-element-type', pElementType);
		tmpHandle.setAttribute(pOwnerAttrName, pOwnerHash);
		pLayer.appendChild(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Create a temporary drag connection path element.
	 * @param {string} pPath - The SVG path d-string
	 * @returns {SVGPathElement}
	 */
	createDragConnectionElement(pPath)
	{
		let tmpConfig = this._DefaultShapes['drag-connection'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		return tmpElement;
	}

	/**
	 * Create a visible tether path SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pPanelHash
	 * @param {boolean} pIsSelected
	 * @param {string} pViewIdentifier
	 * @returns {SVGPathElement}
	 */
	createTetherPathElement(pPath, pPanelHash, pIsSelected, pViewIdentifier)
	{
		let tmpConfig = this._DefaultShapes['tether-path'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName + (pIsSelected ? ' selected' : ''));
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('marker-end', 'url(#flow-tether-arrowhead-' + pViewIdentifier + ')');
		tmpElement.setAttribute('data-element-type', 'tether');
		tmpElement.setAttribute('data-panel-hash', pPanelHash);
		return tmpElement;
	}

	/**
	 * Create a tether hit area SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pPanelHash
	 * @returns {SVGPathElement}
	 */
	createTetherHitAreaElement(pPath, pPanelHash)
	{
		let tmpConfig = this._DefaultShapes['tether-hitarea'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-element-type', 'tether-hitarea');
		tmpElement.setAttribute('data-panel-hash', pPanelHash);
		return tmpElement;
	}

	/**
	 * Generate SVG marker definition markup for all arrowhead types.
	 * Returns raw SVG markup to be injected into the <defs> section.
	 * @param {string} pViewIdentifier
	 * @returns {string}
	 */
	generateMarkerDefs(pViewIdentifier)
	{
		let tmpConnectionMarker = this._DefaultShapes['arrowhead-connection'];
		let tmpSelectedMarker = this._DefaultShapes['arrowhead-connection-selected'];
		let tmpTetherMarker = this._DefaultShapes['arrowhead-tether'];

		let tmpMarkup = '';

		// Normal connection arrowhead — class-driven fill so the host theme's
		// --theme-color-* tokens (mapped to --pf-connection-stroke etc. in
		// PictProvider-Flow-CSS) flow through automatically. The polygon's
		// `fill` attribute is kept as a fallback for environments that
		// ignore CSS rules on marker children.
		tmpMarkup += '<marker id="flow-arrowhead-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpConnectionMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpConnectionMarker.MarkerHeight + '"'
			+ ' refX="' + tmpConnectionMarker.RefX + '"'
			+ ' refY="' + tmpConnectionMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-default" points="' + tmpConnectionMarker.Points + '" fill="' + tmpConnectionMarker.Fill + '" />'
			+ '</marker>';

		// Per-port-type connection arrowheads
		let tmpPortTypeColors =
		{
			'event-in': 'var(--theme-color-status-info, #3498db)',
			'event-out': 'var(--theme-color-status-success, #2ecc71)',
			'setting': 'var(--theme-color-status-warning, #e67e22)',
			'value': 'var(--theme-color-status-warning, #f1c40f)',
			'error': 'var(--theme-color-status-error, #e74c3c)'
		};

		for (let tmpType in tmpPortTypeColors)
		{
			tmpMarkup += '<marker id="flow-arrowhead-' + tmpType + '-' + pViewIdentifier + '"'
				+ ' markerWidth="' + tmpConnectionMarker.MarkerWidth + '"'
				+ ' markerHeight="' + tmpConnectionMarker.MarkerHeight + '"'
				+ ' refX="' + tmpConnectionMarker.RefX + '"'
				+ ' refY="' + tmpConnectionMarker.RefY + '"'
				+ ' orient="auto" markerUnits="strokeWidth">'
				+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-' + tmpType + '" points="' + tmpConnectionMarker.Points + '" fill="' + tmpPortTypeColors[tmpType] + '" />'
				+ '</marker>';
		}

		// Selected connection arrowhead
		tmpMarkup += '<marker id="flow-arrowhead-selected-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpSelectedMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpSelectedMarker.MarkerHeight + '"'
			+ ' refX="' + tmpSelectedMarker.RefX + '"'
			+ ' refY="' + tmpSelectedMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-selected" points="' + tmpSelectedMarker.Points + '" fill="' + tmpSelectedMarker.Fill + '" />'
			+ '</marker>';

		// Tether arrowhead
		tmpMarkup += '<marker id="flow-tether-arrowhead-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpTetherMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpTetherMarker.MarkerHeight + '"'
			+ ' refX="' + tmpTetherMarker.RefX + '"'
			+ ' refY="' + tmpTetherMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-tether" points="' + tmpTetherMarker.Points + '" fill="' + tmpTetherMarker.Fill + '" />'
			+ '</marker>';

		// Generic per-connection end markers, selectable per connection via Data.SourceMarker /
		// Data.TargetMarker (a host like a moodboard styles its own edges). fill="context-stroke" makes
		// each marker take the connection's own stroke color, so a recolored line recolors its markers.
		tmpMarkup += '<marker id="flow-marker-arrow-end-' + pViewIdentifier + '" markerWidth="10" markerHeight="10" refX="8.5" refY="5" orient="auto" markerUnits="strokeWidth"><path d="M1,1 L9,5 L1,9 z" fill="context-stroke" /></marker>';
		tmpMarkup += '<marker id="flow-marker-arrow-start-' + pViewIdentifier + '" markerWidth="10" markerHeight="10" refX="1.5" refY="5" orient="auto-start-reverse" markerUnits="strokeWidth"><path d="M1,1 L9,5 L1,9 z" fill="context-stroke" /></marker>';
		tmpMarkup += '<marker id="flow-marker-dot-' + pViewIdentifier + '" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto" markerUnits="strokeWidth"><circle cx="4" cy="4" r="3" fill="context-stroke" /></marker>';
		tmpMarkup += '<marker id="flow-marker-square-' + pViewIdentifier + '" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto" markerUnits="strokeWidth"><rect x="1" y="1" width="6" height="6" fill="context-stroke" /></marker>';

		return tmpMarkup;
	}
}

module.exports = PictProviderFlowConnectorShapes;

},{"fable-serviceproviderbase":59}],218:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowEventHandler'
};

/**
 * Event handler provider for the flow diagram.
 * Provides hook points for extensibility - consumers can register handlers
 * for flow events like node selection, movement, connection creation, etc.
 *
 * Supported events:
 * - onNodeSelected(node)              - A node was selected (or null for deselection)
 * - onNodeAdded(node)                 - A new node was added
 * - onNodeRemoved(node)               - A node was removed
 * - onNodeMoved(node)                 - A node was moved to a new position
 * - onConnectionSelected(conn)        - A connection was selected
 * - onConnectionCreated(conn)         - A new connection was created
 * - onConnectionRemoved(conn)         - A connection was removed
 * - onConnectionHandleMoved(conn)     - A connection's drag handle was repositioned
 * - onConnectionModeChanged(conn)     - A connection's line mode was toggled (bezier/orthogonal)
 * - onPanelOpened(panelData)          - A properties panel was opened
 * - onPanelClosed(panelData)          - A properties panel was closed
 * - onPanelMoved(panelData)           - A properties panel was moved
 * - onTetherSelected(panelData)       - A tether line was selected (or null for deselection)
 * - onTetherHandleMoved(panelData)    - A tether's drag handle was repositioned
 * - onTetherModeChanged(panelData)    - A tether's line mode was toggled (bezier/orthogonal)
 * - onLayoutSaved(layoutData)         - A layout snapshot was saved
 * - onLayoutRestored(layoutData)      - A saved layout was restored
 * - onLayoutDeleted(layoutData)       - A saved layout was deleted
 * - onFlowChanged(flowData)           - The flow data changed (catch-all)
 */
class PictProviderFlowEventHandler extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowEventHandler';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Event handler registry
		this._Handlers = {};
	}

	/**
	 * Register an event handler
	 * @param {string} pEventName - The event name (e.g., 'onNodeSelected')
	 * @param {Function} pHandler - The handler function
	 * @param {string} [pHandlerHash] - Optional unique identifier for this handler (for later removal)
	 * @returns {string} The handler hash
	 */
	registerHandler(pEventName, pHandler, pHandlerHash)
	{
		if (typeof pHandler !== 'function')
		{
			this.log.warn(`PictProviderFlowEventHandler registerHandler: handler for '${pEventName}' is not a function`);
			return null;
		}

		if (!this._Handlers[pEventName])
		{
			this._Handlers[pEventName] = [];
		}

		let tmpHash = pHandlerHash || `handler-${this.fable.getUUID()}`;

		this._Handlers[pEventName].push({
			Hash: tmpHash,
			Handler: pHandler
		});

		this.log.trace(`PictProviderFlowEventHandler registered handler '${tmpHash}' for event '${pEventName}'`);

		return tmpHash;
	}

	/**
	 * Remove a specific event handler
	 * @param {string} pEventName - The event name
	 * @param {string} pHandlerHash - The handler hash to remove
	 * @returns {boolean}
	 */
	removeHandler(pEventName, pHandlerHash)
	{
		if (!this._Handlers[pEventName]) return false;

		let tmpIndex = this._Handlers[pEventName].findIndex((pH) => pH.Hash === pHandlerHash);
		if (tmpIndex >= 0)
		{
			this._Handlers[pEventName].splice(tmpIndex, 1);
			return true;
		}

		return false;
	}

	/**
	 * Remove all handlers for a specific event
	 * @param {string} pEventName
	 */
	removeAllHandlers(pEventName)
	{
		if (pEventName)
		{
			this._Handlers[pEventName] = [];
		}
		else
		{
			this._Handlers = {};
		}
	}

	/**
	 * Fire an event, calling all registered handlers
	 * @param {string} pEventName - The event name
	 * @param {*} pEventData - The event data to pass to handlers
	 */
	fireEvent(pEventName, pEventData)
	{
		this.log.trace(`PictProviderFlowEventHandler firing event '${pEventName}'`);

		if (!this._Handlers[pEventName] || this._Handlers[pEventName].length === 0)
		{
			return;
		}

		for (let i = 0; i < this._Handlers[pEventName].length; i++)
		{
			let tmpEntry = this._Handlers[pEventName][i];
			try
			{
				tmpEntry.Handler(pEventData, this._FlowView);
			}
			catch (pError)
			{
				this.log.error(`PictProviderFlowEventHandler error in handler '${tmpEntry.Hash}' for event '${pEventName}': ${pError.message}`);
			}
		}
	}

	/**
	 * Check if any handlers are registered for a specific event
	 * @param {string} pEventName
	 * @returns {boolean}
	 */
	hasHandlers(pEventName)
	{
		return !!(this._Handlers[pEventName] && this._Handlers[pEventName].length > 0);
	}

	/**
	 * Get the count of handlers for a specific event
	 * @param {string} pEventName
	 * @returns {number}
	 */
	getHandlerCount(pEventName)
	{
		if (!this._Handlers[pEventName]) return 0;
		return this._Handlers[pEventName].length;
	}
}

module.exports = PictProviderFlowEventHandler;

module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":177}],219:[function(require,module,exports){
const libPictProviderGraphGeometry = require('pict-provider-graphgeometry');

/**
 * PictProvider-Flow-Geometry
 *
 * Backwards-compatible shim. As of the flow 2.0 plan (Phase 1a) the geometry
 * math lives in the standalone, dependency-free pict-provider-graphgeometry
 * module so it can be reused and unit tested on its own. This subclass keeps the
 * historical `PictProviderFlowGeometry` export and serviceType so the flow
 * service registry, every caller (PortRenderer, Node view, ConnectionRenderer,
 * Tether), and the existing Geometry_tests.js are unaffected. All methods are
 * inherited and delegate to the GraphGeometry core.
 *
 * Port Side values (12 positions) and the full method set are documented in
 * pict-provider-graphgeometry/source/GraphGeometry-Core.js.
 */
class PictProviderFlowGeometry extends libPictProviderGraphGeometry
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowGeometry';
	}
}

module.exports = PictProviderFlowGeometry;

},{"pict-provider-graphgeometry":149}],220:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-Icons
 *
 * Centralized SVG icon provider for the flow diagram.
 * All icons use a duotone style: 2px outline (var(--theme-color-text-primary, #2c3e50)) with
 * subtle filled accent shapes (var(--theme-color-background-secondary, #d5e8f7)).
 *
 * Each icon is registered as a pict template with hash `Flow-Icon-{key}`,
 * making them individually overridable by consumers.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowIcons'
};

// ── Default Icon SVG Markup ────────────────────────────────────────────────
// All icons: viewBox="0 0 24 24", duotone style
// Accent fill: var(--theme-color-background-secondary, #d5e8f7), Stroke: var(--theme-color-text-primary, #2c3e50), Stroke-width: 2
//
// The {FlowIconSize} placeholder is replaced at render time with the
// requested pixel size. Each template is a self-contained <svg> element.

const _DefaultIcons =
{
	// ── FlowCard Icons ─────────────────────────────────────────────────────

	'ITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="6" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="6" cy="18" r="2.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="18" cy="18" r="2.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 9v2M9.5 12.5L6 15.5M14.5 12.5L18 15.5" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'SW': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M3 12h5M16 12h5M14.8 9.2l3.7-5.2M14.8 14.8l3.7 5.2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'EACH': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="14" y="3" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="3" y="14" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="14" y="14" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'FREAD': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M13 2v7h7" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M9 13h6M9 17h4" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'FWRITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M13 2v7h7" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 13v5M9.5 15.5L12 13l2.5 2.5" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'LOG': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="7.5" cy="8" r="1" fill="var(--theme-color-text-primary, #2c3e50)"/><circle cx="7.5" cy="12" r="1" fill="var(--theme-color-text-primary, #2c3e50)"/><circle cx="7.5" cy="16" r="1" fill="var(--theme-color-text-primary, #2c3e50)"/><path d="M11 8h5.5M11 12h5.5M11 16h3.5" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'GET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="6.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-5.15-5.15" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'SET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4.5 1.5L4 16Z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M14 6l3 3" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	// ── UI Icons ───────────────────────────────────────────────────────────

	'edit': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',

	'check': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',

	'background': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'connect': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8 8l8 8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="6" cy="6" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="18" cy="18" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	// Pan / navigate "hand" tool — read-only surfaces use this to toggle pan + zoom on the canvas.
	'pan': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6.5a1.5 1.5 0 0 0-3 0M15 6.5V4.5a1.5 1.5 0 0 0-3 0V6M12 6V5a1.5 1.5 0 0 0-3 0v7M9 12V8.5a1.5 1.5 0 0 0-3 0V14a6 6 0 0 0 6 6h1a5 5 0 0 0 5-5v-4a1.5 1.5 0 0 0-3 0" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	// Crop / view-area frame — a host (e.g. a moodboard) uses this to toggle the content-frame drag handles.
	'frame': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2v16a1 1 0 0 0 1 1h16"/><path d="M2 6h16a1 1 0 0 1 1 1v16"/><rect x="9" y="9" width="6" height="5" rx="1" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="none"/></svg>',

	// Display-style toggles for a presentation surface (moodboard): canvas (a free board of cards),
	// jumbotron (a hero band across the top), background (a full-width backdrop behind content).
	'display-canvas': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><rect x="6" y="7" width="6" height="5" rx="1" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="none"/><rect x="14" y="11" width="5" height="6" rx="1" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="none"/></svg>',
	'display-jumbotron': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><rect x="3" y="4" width="18" height="7" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="none"/><path d="M6 15h8M6 18h12"/></svg>',
	'display-background': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)"/><rect x="8" y="8" width="8" height="8" rx="1" fill="var(--theme-color-background-panel, #ffffff)"/></svg>',

	'fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/></svg>',

	'exit-fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14h6v6"/><path d="M20 10h-6V4"/><path d="M14 10l7-7"/><path d="M3 21l7-7"/></svg>',

	'close': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',

	'chevron-down': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',

	// ── Toolbar & Popup Icons ─────────────────────────────────────────────

	'search': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'cards': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="12" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M6 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="8" height="10" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="13" y="3" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="3" y="15" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="13" y="11" width="8" height="10" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'collapse': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 12h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'expand': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'grip': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="var(--theme-color-text-primary, #2c3e50)"><circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><circle cx="9" cy="19" r="1.5"/><circle cx="15" cy="19" r="1.5"/></svg>',

	'settings': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',

	'plus': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'trash': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'save': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M17 21v-8H7v8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M7 3v5h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'auto-layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="2" y="16" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="14" y="16" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 8v4M6 16v-4h12v4" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'zoom-in': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M11 8v6M8 11h6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'zoom-out': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 11h6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'zoom-fit': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7V3h4"/><path d="M17 3h4v4"/><path d="M21 17v4h-4"/><path d="M7 21H3v-4"/><rect x="7" y="7" width="10" height="10" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)"/></svg>',

	'dock': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="4" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 20V11M8 14l4-4 4 4" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'restore': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',

	'delete-node': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	// ── Fallback ───────────────────────────────────────────────────────────

	'default': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="4" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="12" cy="12" r="2.5" fill="var(--theme-color-text-primary, #2c3e50)"/></svg>'
};

class PictProviderFlowIcons extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowIcons';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Deep copy the default icons
		this._Icons = JSON.parse(JSON.stringify(_DefaultIcons));

		// Merge any additional icons passed via options
		if (pOptions && pOptions.AdditionalIcons && typeof pOptions.AdditionalIcons === 'object')
		{
			let tmpKeys = Object.keys(pOptions.AdditionalIcons);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				this._Icons[tmpKeys[i]] = pOptions.AdditionalIcons[tmpKeys[i]];
			}
		}
	}

	/**
	 * Register all icons as pict templates with hash Flow-Icon-{key}.
	 * Consumers can override any icon by registering a template with
	 * the same hash before the flow view renders.
	 */
	registerIconTemplates()
	{
		if (!this.fable || !this.fable.TemplateProvider)
		{
			this.log.warn('PictProviderFlowIcons: TemplateProvider not available; icon templates not registered.');
			return;
		}

		let tmpKeys = Object.keys(this._Icons);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpHash = 'Flow-Icon-' + tmpKeys[i];

			// Only register if not already present (allow consumer overrides)
			if (!this.fable.TemplateProvider.getTemplate(tmpHash))
			{
				this.fable.TemplateProvider.addTemplate(tmpHash, this._Icons[tmpKeys[i]]);
			}
		}
	}

	/**
	 * Determine if the given icon string is an emoji (legacy) or an icon key.
	 * Returns true if the string contains characters with code points above U+00FF,
	 * indicating emoji or Unicode symbol characters.
	 *
	 * @param {string} pIconValue - The icon value to check
	 * @returns {boolean}
	 */
	isEmojiIcon(pIconValue)
	{
		if (!pIconValue || typeof pIconValue !== 'string')
		{
			return false;
		}

		for (let i = 0; i < pIconValue.length; i++)
		{
			if (pIconValue.charCodeAt(i) > 255)
			{
				return true;
			}
		}

		return false;
	}

	/**
	 * Resolve the icon key to use for a given CardMetadata object.
	 * Tries Icon field first, then Code field, then falls back to 'default'.
	 *
	 * @param {Object} pCardMetadata - The CardMetadata object
	 * @returns {string} The icon key
	 */
	resolveIconKey(pCardMetadata)
	{
		if (!pCardMetadata)
		{
			return 'default';
		}

		// If Icon is a known key, use it
		if (pCardMetadata.Icon && this._Icons.hasOwnProperty(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// If Icon is a non-emoji string, check if it matches a registered template
		if (pCardMetadata.Icon && !this.isEmojiIcon(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// Fall back to Code field
		if (pCardMetadata.Code && this._Icons.hasOwnProperty(pCardMetadata.Code))
		{
			return pCardMetadata.Code;
		}

		return 'default';
	}

	/**
	 * Get the raw SVG markup string for a given icon key, with size applied.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {string} The SVG markup string
	 */
	getIconSVGMarkup(pIconKey, pSize)
	{
		let tmpSize = pSize || 16;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace the size placeholder
		return tmpMarkup.replace(/\{FlowIconSize\}/g, String(tmpSize));
	}

	/**
	 * Render an icon into an SVG canvas context using createElementNS.
	 * Creates a <g> element containing the icon paths, positioned at (pX, pY)
	 * with the given size via a scale transform.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {SVGElement} pParentGroup - The parent SVG group to append to
	 * @param {number} pX - X position (top-left of icon bounding box)
	 * @param {number} pY - Y position (top-left of icon bounding box)
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {SVGGElement|null} The created group element, or null on failure
	 */
	renderIconIntoSVGGroup(pIconKey, pParentGroup, pX, pY, pSize)
	{
		if (!pParentGroup)
		{
			return null;
		}

		let tmpSize = pSize || 16;
		let tmpScale = tmpSize / 24;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace size placeholder (for consistency, though we scale via transform)
		tmpMarkup = tmpMarkup.replace(/\{FlowIconSize\}/g, '24');

		try
		{
			// Create a temporary SVG element to parse the icon markup
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpMarkup;

			// Find the inner SVG (the icon's root <svg> element)
			let tmpInnerSVG = tmpTempSVG.querySelector('svg');
			if (!tmpInnerSVG)
			{
				return null;
			}

			// Create a group to hold the icon content
			let tmpGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
			tmpGroup.setAttribute('transform', 'translate(' + pX + ',' + pY + ') scale(' + tmpScale + ')');
			tmpGroup.setAttribute('pointer-events', 'none');
			tmpGroup.setAttribute('class', 'pict-flow-icon-svg');

			// Move all children from the parsed SVG into the group
			while (tmpInnerSVG.childNodes.length > 0)
			{
				tmpGroup.appendChild(tmpInnerSVG.childNodes[0]);
			}

			pParentGroup.appendChild(tmpGroup);
			return tmpGroup;
		}
		catch (pError)
		{
			this.log.warn('PictProviderFlowIcons renderIconIntoSVGGroup error: ' + pError.message);
			return null;
		}
	}

	/**
	 * Get all registered icon keys.
	 * @returns {Array<string>}
	 */
	getIconKeys()
	{
		return Object.keys(this._Icons);
	}

	/**
	 * Check if a given key has a registered icon.
	 * @param {string} pIconKey
	 * @returns {boolean}
	 */
	hasIcon(pIconKey)
	{
		return this._Icons.hasOwnProperty(pIconKey);
	}

	/**
	 * Register a new icon or override an existing one.
	 * @param {string} pIconKey - The icon key
	 * @param {string} pSVGMarkup - The SVG markup string (must contain {FlowIconSize} placeholders)
	 * @returns {boolean}
	 */
	registerIcon(pIconKey, pSVGMarkup)
	{
		if (!pIconKey || !pSVGMarkup)
		{
			return false;
		}

		this._Icons[pIconKey] = pSVGMarkup;

		// Also update the pict template if TemplateProvider is available
		if (this.fable && this.fable.TemplateProvider)
		{
			this.fable.TemplateProvider.addTemplate('Flow-Icon-' + pIconKey, pSVGMarkup);
		}

		return true;
	}
}

module.exports = PictProviderFlowIcons;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.DefaultIcons = _DefaultIcons;

},{"fable-serviceproviderbase":59}],221:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowLayouts'
};

/**
 * Provider for managing saved flow diagram layouts.
 *
 * Layouts capture the spatial arrangement of nodes and panels on the canvas
 * without storing any card content. When a layout is restored, nodes that
 * still exist are placed at their saved positions and any new nodes are
 * auto-laid-out to the right.
 *
 * ## Persistence
 *
 * By default, layouts are persisted to the browser's `localStorage` using a
 * key derived from the flow view identifier. This means layouts survive page
 * refreshes out of the box.
 *
 * Developers can override the storage backend (e.g., to use a REST API or
 * IndexedDB) by replacing the three storage hook methods on the instance or
 * in a subclass:
 *
 *   - `storageWrite(pLayouts, fCallback)` — persist the full layout array
 *   - `storageRead(fCallback)` — load the persisted layout array
 *   - `storageDelete(fCallback)` — remove all persisted layouts
 *
 * Each callback follows the Node convention: `fCallback(pError, pResult)`.
 *
 * Saved layout data structure:
 * {
 *     Hash: "layout-<UUID>",
 *     Name: "My Layout",
 *     CreatedAt: "2026-02-26T12:00:00.000Z",
 *     NodePositions: { "node-hash": { X, Y, Width, Height } },
 *     PanelPositions: { "node-hash": { X, Y, Width, Height } },
 *     ViewState: { PanX, PanY, Zoom }
 * }
 */
class PictProviderFlowLayouts extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowLayouts';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Storage key for localStorage persistence.
		// Defaults to a key derived from the FlowView identifier, or can be
		// set via options.StorageKey.  Pass `false` to disable localStorage.
		if (pOptions && pOptions.StorageKey !== undefined)
		{
			this._StorageKey = pOptions.StorageKey;
		}
		else if (this._FlowView && this._FlowView.options && this._FlowView.options.ViewIdentifier)
		{
			this._StorageKey = `pict-flow-layouts-${this._FlowView.options.ViewIdentifier}`;
		}
		else
		{
			this._StorageKey = 'pict-flow-layouts';
		}
	}

	/**
	 * Resolve a host-supplied storage backend, if one was passed as the flow's
	 * `LayoutStorage` option: `{ read(cb), write(layouts, cb), delete(cb) }` with
	 * Node-style callbacks. Lets a host wire a REST API / IndexedDB by config
	 * instead of overriding the three storage hooks. Returns null to fall back to
	 * localStorage.
	 * @returns {Object|null}
	 */
	_resolveLayoutStorage()
	{
		let tmpStorage = (this._FlowView && this._FlowView.options) ? this._FlowView.options.LayoutStorage : null;
		return (tmpStorage && typeof tmpStorage === 'object') ? tmpStorage : null;
	}

	// ── Storage Hooks ─────────────────────────────────────────────────────
	// These three methods form the persistence contract.  The default
	// implementation uses localStorage.  Override them on the instance or
	// subclass to use a REST API, IndexedDB, or any other backend.
	//
	// All callbacks follow `fCallback(pError, pResult)`.

	/**
	 * Persist the full array of layout objects.
	 *
	 * Default implementation writes JSON to `localStorage`.
	 *
	 * @param {Array} pLayouts - The array of layout objects to persist
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageWrite(pLayouts, fCallback)
	{
		let tmpStorage = this._resolveLayoutStorage();
		if (tmpStorage && typeof tmpStorage.write === 'function')
		{
			return tmpStorage.write(pLayouts, fCallback);
		}
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.setItem(this._StorageKey, JSON.stringify(pLayouts));
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageWrite error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	/**
	 * Load the persisted array of layout objects.
	 *
	 * Default implementation reads JSON from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError, pLayouts)` where
	 *        pLayouts is an Array (or null/empty if nothing stored)
	 */
	storageRead(fCallback)
	{
		let tmpStorage = this._resolveLayoutStorage();
		if (tmpStorage && typeof tmpStorage.read === 'function')
		{
			return tmpStorage.read(fCallback);
		}
		if (this._StorageKey === false)
		{
			return fCallback(null, []);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				let tmpRaw = localStorage.getItem(this._StorageKey);
				if (tmpRaw)
				{
					let tmpParsed = JSON.parse(tmpRaw);
					if (Array.isArray(tmpParsed))
					{
						return fCallback(null, tmpParsed);
					}
				}
			}
			return fCallback(null, []);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageRead error: ${pError.message}`);
			return fCallback(pError, []);
		}
	}

	/**
	 * Remove all persisted layout data.
	 *
	 * Default implementation removes the key from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageDelete(fCallback)
	{
		let tmpStorage = this._resolveLayoutStorage();
		if (tmpStorage && typeof tmpStorage.delete === 'function')
		{
			return tmpStorage.delete(fCallback);
		}
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.removeItem(this._StorageKey);
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageDelete error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	// ── Initialization ────────────────────────────────────────────────────

	/**
	 * Load persisted layouts and merge them into _FlowData.SavedLayouts.
	 * Layouts already present in _FlowData (e.g., from setFlowData) are
	 * kept; persisted layouts with new hashes are appended.
	 *
	 * Call this after _FlowData is populated.
	 */
	loadPersistedLayouts()
	{
		this.storageRead((pError, pLayouts) =>
		{
			if (pError || !Array.isArray(pLayouts) || pLayouts.length === 0)
			{
				return;
			}

			if (!this._FlowView || !this._FlowView._FlowData)
			{
				return;
			}

			let tmpExisting = this._FlowView._FlowData.SavedLayouts;
			let tmpExistingHashes = {};
			for (let i = 0; i < tmpExisting.length; i++)
			{
				tmpExistingHashes[tmpExisting[i].Hash] = true;
			}

			let tmpAdded = 0;
			for (let i = 0; i < pLayouts.length; i++)
			{
				if (!tmpExistingHashes[pLayouts[i].Hash])
				{
					tmpExisting.push(pLayouts[i]);
					tmpAdded++;
				}
			}

			if (tmpAdded > 0)
			{
				this.log.trace(`PictProviderFlowLayouts loaded ${tmpAdded} persisted layout(s)`);
			}
		});
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Save the current node and panel positions as a named layout.
	 * @param {string} pName - The display name for this layout
	 * @returns {Object} The saved layout entry
	 */
	saveLayout(pName)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts saveLayout: no FlowView reference');
			return null;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayoutHash = `layout-${this.fable.getUUID()}`;
		let tmpNodePositions = {};
		let tmpPanelPositions = {};

		// Capture node positions and per-instance overrides (Title, Style)
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			tmpNodePositions[tmpNode.Hash] =
			{
				X: tmpNode.X,
				Y: tmpNode.Y,
				Width: tmpNode.Width,
				Height: tmpNode.Height,
				Title: tmpNode.Title
			};

			// Only include Style if it has been customized
			if (tmpNode.Style && Object.keys(tmpNode.Style).length > 0)
			{
				tmpNodePositions[tmpNode.Hash].Style = JSON.parse(JSON.stringify(tmpNode.Style));
			}
		}

		// Capture panel positions keyed by NodeHash (panels get new hashes on each open)
		for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
		{
			let tmpPanel = tmpFlowData.OpenPanels[i];
			tmpPanelPositions[tmpPanel.NodeHash] =
			{
				X: tmpPanel.X,
				Y: tmpPanel.Y,
				Width: tmpPanel.Width,
				Height: tmpPanel.Height
			};
		}

		let tmpLayout =
		{
			Hash: tmpLayoutHash,
			Name: pName || 'Untitled Layout',
			CreatedAt: new Date().toISOString(),
			NodePositions: tmpNodePositions,
			PanelPositions: tmpPanelPositions,
			ViewState:
			{
				PanX: tmpFlowData.ViewState.PanX,
				PanY: tmpFlowData.ViewState.PanY,
				Zoom: tmpFlowData.ViewState.Zoom
			}
		};

		tmpFlowData.SavedLayouts.push(tmpLayout);
		this._FlowView.marshalFromView();

		// Persist to storage
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after save: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutSaved', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts saved layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return tmpLayout;
	}

	/**
	 * Restore a saved layout by hash.
	 * Nodes present in the saved layout are placed at their saved positions.
	 * Nodes not in the saved layout are auto-laid-out to the right of the
	 * positioned nodes.
	 * @param {string} pLayoutHash - The hash of the layout to restore
	 * @returns {boolean} Whether the layout was restored
	 */
	restoreLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts restoreLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayout = tmpFlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (!tmpLayout)
		{
			this.log.warn(`PictProviderFlowLayouts restoreLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpMatchedNodes = [];
		let tmpUnmatchedNodes = [];

		// Apply saved positions to matched nodes; collect unmatched ones
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			let tmpSaved = tmpLayout.NodePositions[tmpNode.Hash];

			if (tmpSaved)
			{
				tmpNode.X = tmpSaved.X;
				tmpNode.Y = tmpSaved.Y;
				if (typeof tmpSaved.Width === 'number') tmpNode.Width = tmpSaved.Width;
				if (typeof tmpSaved.Height === 'number') tmpNode.Height = tmpSaved.Height;
				if (typeof tmpSaved.Title === 'string') tmpNode.Title = tmpSaved.Title;
				if (tmpSaved.Style && typeof tmpSaved.Style === 'object')
				{
					tmpNode.Style = JSON.parse(JSON.stringify(tmpSaved.Style));
				}
				tmpMatchedNodes.push(tmpNode);
			}
			else
			{
				tmpUnmatchedNodes.push(tmpNode);
			}
		}

		// Apply saved panel positions (keyed by NodeHash)
		if (tmpLayout.PanelPositions)
		{
			for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
			{
				let tmpPanel = tmpFlowData.OpenPanels[i];
				let tmpSavedPanel = tmpLayout.PanelPositions[tmpPanel.NodeHash];

				if (tmpSavedPanel)
				{
					tmpPanel.X = tmpSavedPanel.X;
					tmpPanel.Y = tmpSavedPanel.Y;
					if (typeof tmpSavedPanel.Width === 'number') tmpPanel.Width = tmpSavedPanel.Width;
					if (typeof tmpSavedPanel.Height === 'number') tmpPanel.Height = tmpSavedPanel.Height;
				}
			}
		}

		// Auto-layout unmatched nodes to the right of positioned nodes
		if (tmpUnmatchedNodes.length > 0 && this._FlowView._LayoutService)
		{
			this._FlowView._LayoutService.autoLayoutSubset(
				tmpUnmatchedNodes,
				tmpMatchedNodes,
				tmpFlowData.Connections
			);
		}

		// Restore view state (camera position)
		if (tmpLayout.ViewState)
		{
			if (typeof tmpLayout.ViewState.PanX === 'number')
			{
				tmpFlowData.ViewState.PanX = tmpLayout.ViewState.PanX;
			}
			if (typeof tmpLayout.ViewState.PanY === 'number')
			{
				tmpFlowData.ViewState.PanY = tmpLayout.ViewState.PanY;
			}
			if (typeof tmpLayout.ViewState.Zoom === 'number')
			{
				tmpFlowData.ViewState.Zoom = tmpLayout.ViewState.Zoom;
			}
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutRestored', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts restored layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return true;
	}

	/**
	 * Delete a saved layout by hash.
	 * @param {string} pLayoutHash - The hash of the layout to delete
	 * @returns {boolean} Whether the layout was deleted
	 */
	deleteLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts deleteLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpIndex = tmpFlowData.SavedLayouts.findIndex(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (tmpIndex < 0)
		{
			this.log.warn(`PictProviderFlowLayouts deleteLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpRemovedLayout = tmpFlowData.SavedLayouts.splice(tmpIndex, 1)[0];
		this._FlowView.marshalFromView();

		// Persist to storage (with the layout removed)
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after delete: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutDeleted', tmpRemovedLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts deleted layout '${tmpRemovedLayout.Name}' (${tmpRemovedLayout.Hash})`);

		return true;
	}

	/**
	 * Get the list of saved layouts.
	 * @returns {Array} Array of saved layout objects
	 */
	getLayouts()
	{
		if (!this._FlowView) return [];
		return this._FlowView._FlowData.SavedLayouts;
	}

	/**
	 * Get a specific saved layout by hash.
	 * @param {string} pLayoutHash
	 * @returns {Object|null}
	 */
	getLayout(pLayoutHash)
	{
		if (!this._FlowView) return null;
		return this._FlowView._FlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		) || null;
	}

	// ── Default layout ─────────────────────────────────────────────────────
	// One saved layout can be marked the default arrangement for a graph. The
	// mark is an IsDefault flag on the layout object, so it rides inside
	// SavedLayouts and persists through both the storage hooks and
	// getFlowData/setFlowData with no storage-shape change.

	/**
	 * Mark a saved layout as the default (clearing any previous default). Pass a
	 * falsy hash to clear the default entirely. Persists the change.
	 * @param {string} pLayoutHash
	 * @returns {boolean} true on success; false if a given hash was not found
	 */
	setDefaultLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts setDefaultLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpFound = false;
		for (let i = 0; i < tmpFlowData.SavedLayouts.length; i++)
		{
			let tmpIsMatch = (!!pLayoutHash && tmpFlowData.SavedLayouts[i].Hash === pLayoutHash);
			tmpFlowData.SavedLayouts[i].IsDefault = tmpIsMatch;
			if (tmpIsMatch) { tmpFound = true; }
		}

		// A falsy hash clears the default (every IsDefault now false); a non-matching hash is an error.
		if (pLayoutHash && !tmpFound)
		{
			this.log.warn(`PictProviderFlowLayouts setDefaultLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		this._FlowView.marshalFromView();
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist default: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutDefaultChanged', this.getDefaultLayout());
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		return true;
	}

	/**
	 * The layout currently marked default, or null if none.
	 * @returns {Object|null}
	 */
	getDefaultLayout()
	{
		if (!this._FlowView) return null;
		return this._FlowView._FlowData.SavedLayouts.find((pLayout) => pLayout.IsDefault === true) || null;
	}

	/**
	 * Restore the default layout if one is set.
	 * @returns {boolean} true if a default existed and was restored
	 */
	applyDefaultLayout()
	{
		let tmpDefault = this.getDefaultLayout();
		if (!tmpDefault)
		{
			return false;
		}
		return this.restoreLayout(tmpDefault.Hash);
	}
}

module.exports = PictProviderFlowLayouts;

module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":177}],222:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// Built-in node types reference theme-aware roles via `ColorRole`. The
// hex `TitleBarColor` / `BodyStyle` values remain as fallbacks for
// rendering paths that bypass CSS (legacy consumers, exports). When a
// role is set, the renderer skips applying those hex attributes — the
// role's CSS class drives the visuals so theme swaps propagate.
const _DefaultNodeTypes =
{
	'default':
	{
		Hash: 'default',
		Label: 'Default',
		DefaultWidth: 180,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' },
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' }
		],
		ColorRole: 'neutral',
		TitleBarColor: 'var(--theme-color-text-primary, #2c3e50)',
		BodyStyle: {}
	},
	'start':
	{
		Hash: 'start',
		Label: 'Start',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' }
		],
		ColorRole: 'success',
		TitleBarColor: 'var(--theme-color-status-success, #27ae60)',
		BodyStyle:
		{
			'fill': 'var(--theme-color-background-hover, #eafaf1)',
			'stroke': 'var(--theme-color-status-success, #27ae60)'
		}
	},
	'end':
	{
		Hash: 'end',
		Label: 'End',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' }
		],
		ColorRole: 'accent',
		TitleBarColor: 'var(--theme-color-brand-primary, #1abc9c)',
		BodyStyle:
		{
			'fill': '#e8f8f5',
			'stroke': 'var(--theme-color-brand-primary, #1abc9c)'
		}
	},
	'halt':
	{
		Hash: 'halt',
		Label: 'Halt',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' }
		],
		ColorRole: 'error',
		TitleBarColor: 'var(--theme-color-status-error, #e74c3c)',
		BodyStyle:
		{
			'fill': 'var(--theme-color-background-hover, #fdedec)',
			'stroke': 'var(--theme-color-status-error, #e74c3c)'
		}
	},
	'decision':
	{
		Hash: 'decision',
		Label: 'Decision',
		DefaultWidth: 200,
		DefaultHeight: 100,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' },
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Yes' },
			{ Hash: null, Direction: 'output', Side: 'bottom', Label: 'No' }
		],
		ColorRole: 'warning',
		TitleBarColor: '#f39c12',
		BodyStyle:
		{
			'fill': '#fff9e6',
			'stroke': '#f39c12'
		}
	}
};

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowNodeTypes'
};

class PictProviderFlowNodeTypes extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowNodeTypes';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Initialize with default node types unless explicitly disabled
		if (pOptions && pOptions.IncludeDefaultNodeTypes === false)
		{
			this._NodeTypes = {};
		}
		else
		{
			this._NodeTypes = JSON.parse(JSON.stringify(_DefaultNodeTypes));
		}

		// Merge any additional node types passed in via options
		if (pOptions && pOptions.AdditionalNodeTypes && typeof pOptions.AdditionalNodeTypes === 'object')
		{
			let tmpAdditionalKeys = Object.keys(pOptions.AdditionalNodeTypes);
			for (let i = 0; i < tmpAdditionalKeys.length; i++)
			{
				let tmpOriginal = pOptions.AdditionalNodeTypes[tmpAdditionalKeys[i]];
				this._NodeTypes[tmpAdditionalKeys[i]] = Object.assign(
					{},
					this._NodeTypes[tmpAdditionalKeys[i]] || {},
					JSON.parse(JSON.stringify(tmpOriginal))
				);
				// Preserve BodyContent.RenderCallback (functions are stripped by JSON serialization)
				if (tmpOriginal.BodyContent && typeof tmpOriginal.BodyContent.RenderCallback === 'function')
				{
					if (!this._NodeTypes[tmpAdditionalKeys[i]].BodyContent)
					{
						this._NodeTypes[tmpAdditionalKeys[i]].BodyContent = {};
					}
					this._NodeTypes[tmpAdditionalKeys[i]].BodyContent.RenderCallback = tmpOriginal.BodyContent.RenderCallback;
				}
			}
		}
	}

	/**
	 * Get a node type configuration by hash
	 * @param {string} pTypeHash - The node type hash
	 * @returns {Object|null} The node type configuration
	 */
	getNodeType(pTypeHash)
	{
		return this._NodeTypes[pTypeHash] || this._NodeTypes['default'];
	}

	/**
	 * Register a new node type or override an existing one
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 * @returns {boolean}
	 */
	registerNodeType(pNodeTypeConfig)
	{
		if (!pNodeTypeConfig || !pNodeTypeConfig.Hash)
		{
			this.log.warn('PictProviderFlowNodeTypes registerNodeType: invalid config (missing Hash)');
			return false;
		}

		this._NodeTypes[pNodeTypeConfig.Hash] = Object.assign(
			{},
			this._NodeTypes[pNodeTypeConfig.Hash] || {},
			pNodeTypeConfig
		);

		return true;
	}

	/**
	 * Remove a node type
	 * @param {string} pTypeHash
	 * @returns {boolean}
	 */
	removeNodeType(pTypeHash)
	{
		if (pTypeHash === 'default')
		{
			this.log.warn('PictProviderFlowNodeTypes: cannot remove the default node type');
			return false;
		}

		if (this._NodeTypes[pTypeHash])
		{
			delete this._NodeTypes[pTypeHash];
			return true;
		}

		return false;
	}

	/**
	 * Get all registered node types
	 * @returns {Object} Map of type hash to type configuration
	 */
	getNodeTypes()
	{
		return JSON.parse(JSON.stringify(this._NodeTypes));
	}

	/**
	 * Get a list of node type hashes
	 * @returns {Array<string>}
	 */
	getNodeTypeList()
	{
		return Object.keys(this._NodeTypes);
	}

	/**
	 * Get all enabled node types that have FlowCard metadata.
	 * Returns only types that are cards and whose Enabled flag is true.
	 * @returns {Array<Object>} Array of node type configurations
	 */
	getEnabledCards()
	{
		let tmpCards = [];
		let tmpKeys = Object.keys(this._NodeTypes);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpType = this._NodeTypes[tmpKeys[i]];
			if (tmpType.CardMetadata)
			{
				if (tmpType.CardMetadata.Enabled !== false)
				{
					tmpCards.push(JSON.parse(JSON.stringify(tmpType)));
				}
			}
		}
		return tmpCards;
	}

	/**
	 * Get all enabled cards grouped by category.
	 * @returns {Object} Map of category name to array of node type configurations
	 */
	getCardsByCategory()
	{
		let tmpCards = this.getEnabledCards();
		let tmpCategories = {};
		for (let i = 0; i < tmpCards.length; i++)
		{
			let tmpCategory = (tmpCards[i].CardMetadata && tmpCards[i].CardMetadata.Category)
				? tmpCards[i].CardMetadata.Category
				: 'General';
			if (!tmpCategories[tmpCategory])
			{
				tmpCategories[tmpCategory] = [];
			}
			tmpCategories[tmpCategory].push(tmpCards[i]);
		}
		return tmpCategories;
	}

	/**
	 * Check whether a node type hash refers to a FlowCard (has CardMetadata).
	 * @param {string} pTypeHash
	 * @returns {boolean}
	 */
	isFlowCard(pTypeHash)
	{
		let tmpType = this._NodeTypes[pTypeHash];
		return !!(tmpType && tmpType.CardMetadata);
	}
}

module.exports = PictProviderFlowNodeTypes;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.DefaultNodeTypes = _DefaultNodeTypes;

},{"pict-provider":177}],223:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowNoise'
};

/**
 * PictProvider-Flow-Noise
 *
 * Deterministic noise/jitter generator for hand-drawn visual effects.
 *
 * Uses seeded pseudo-random number generation so that the same node or
 * connection always receives the same jitter values across re-renders,
 * preventing visual "jumping" while still looking organic.
 */
class PictProviderFlowNoise extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowNoise';
	}

	// ── Hashing / PRNG ────────────────────────────────────────────────────

	/**
	 * Convert a string to a 32-bit integer hash (djb2 algorithm).
	 * @param {string} pStr
	 * @returns {number}
	 */
	hashString(pStr)
	{
		let tmpHash = 5381;
		for (let i = 0; i < pStr.length; i++)
		{
			tmpHash = ((tmpHash << 5) + tmpHash) + pStr.charCodeAt(i);
			tmpHash = tmpHash & tmpHash; // Convert to 32-bit integer
		}
		return tmpHash >>> 0; // Ensure unsigned
	}

	/**
	 * Create a seeded pseudo-random number generator (Mulberry32).
	 * Returns a function that produces deterministic floats in [0, 1).
	 * @param {number} pSeed - 32-bit integer seed
	 * @returns {Function}
	 */
	seededRandom(pSeed)
	{
		let tmpSeed = pSeed | 0;
		return function()
		{
			tmpSeed = tmpSeed + 0x6D2B79F5 | 0;
			let t = Math.imul(tmpSeed ^ tmpSeed >>> 15, 1 | tmpSeed);
			t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
			return ((t ^ t >>> 14) >>> 0) / 4294967296;
		};
	}

	// ── Point Jitter ──────────────────────────────────────────────────────

	/**
	 * Apply random jitter to a point.
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pAmplitude - Maximum offset in pixels
	 * @param {Function} pRNG - Seeded random function
	 * @returns {{x: number, y: number}}
	 */
	jitterPoint(pX, pY, pAmplitude, pRNG)
	{
		if (pAmplitude <= 0)
		{
			return { x: pX, y: pY };
		}
		return {
			x: pX + pAmplitude * (pRNG() - 0.5) * 2,
			y: pY + pAmplitude * (pRNG() - 0.5) * 2
		};
	}

	// ── Bracket Path Generation ───────────────────────────────────────────

	/**
	 * Generate an SVG path `d` string for a bracket-shaped node border.
	 *
	 * Draws true bracket shapes — `[` on the left and `]` on the right —
	 * with NO top/bottom connecting lines.  The serifs (horizontal turns)
	 * extend inward from each corner, giving a distinctive hand-drawn
	 * technical-diagram look that is immediately distinguishable from a
	 * regular rectangle at any zoom level.
	 *
	 * The bracket consists of:
	 * - Left bracket `[`: top serif → vertical left side → bottom serif
	 * - Right bracket `]`: top serif → vertical right side → bottom serif
	 * - Optional title divider line across the full width
	 *
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pSerifLength - Length of corner serifs in px
	 * @param {number} pTitleBarHeight - Height of title bar (0 to skip divider)
	 * @param {number} pAmplitude - Noise amplitude (0 = precise)
	 * @param {string} pSeedString - Hash string for deterministic noise
	 * @returns {string} SVG path d attribute
	 */
	generateBracketPath(pWidth, pHeight, pSerifLength, pTitleBarHeight, pAmplitude, pSeedString)
	{
		let tmpRNG = this.seededRandom(this.hashString(pSeedString || 'default'));
		let tmpS = pSerifLength || 18;
		let tmpW = pWidth;
		let tmpH = pHeight;

		let tmpJ = (pX, pY) =>
		{
			return this.jitterPoint(pX, pY, pAmplitude, tmpRNG);
		};

		// Left bracket `[`: top serif → down left side → bottom serif
		let tmpTL_serif = tmpJ(tmpS, 0);
		let tmpTL_corner = tmpJ(0, 0);
		let tmpBL_corner = tmpJ(0, tmpH);
		let tmpBL_serif = tmpJ(tmpS, tmpH);

		// Right bracket `]`: top serif → down right side → bottom serif
		let tmpTR_serif = tmpJ(tmpW - tmpS, 0);
		let tmpTR_corner = tmpJ(tmpW, 0);
		let tmpBR_corner = tmpJ(tmpW, tmpH);
		let tmpBR_serif = tmpJ(tmpW - tmpS, tmpH);

		let tmpPath = '';

		// Left bracket `[`
		tmpPath += `M ${tmpTL_serif.x.toFixed(1)} ${tmpTL_serif.y.toFixed(1)}`;
		tmpPath += ` L ${tmpTL_corner.x.toFixed(1)} ${tmpTL_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBL_corner.x.toFixed(1)} ${tmpBL_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBL_serif.x.toFixed(1)} ${tmpBL_serif.y.toFixed(1)}`;

		// Right bracket `]`
		tmpPath += ` M ${tmpTR_serif.x.toFixed(1)} ${tmpTR_serif.y.toFixed(1)}`;
		tmpPath += ` L ${tmpTR_corner.x.toFixed(1)} ${tmpTR_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBR_corner.x.toFixed(1)} ${tmpBR_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBR_serif.x.toFixed(1)} ${tmpBR_serif.y.toFixed(1)}`;

		// No horizontal lines — the title bar fill rect provides visual
		// separation via its background color.  The bracket outline is
		// purely the `[` and `]` shapes on the sides.

		return tmpPath;
	}

	// ── Path Jitter (for connections) ─────────────────────────────────────

	/**
	 * Apply jitter to an existing SVG path string by offsetting coordinate
	 * pairs.  The first M and last coordinate pair receive reduced jitter
	 * to keep connections aligned with their port anchors.
	 *
	 * @param {string} pPathString - SVG path d attribute
	 * @param {number} pAmplitude - Noise amplitude (0 = no change)
	 * @param {string} pSeedString - Hash string for deterministic noise
	 * @returns {string} Modified path string
	 */
	jitterPath(pPathString, pAmplitude, pSeedString)
	{
		if (pAmplitude <= 0 || !pPathString)
		{
			return pPathString;
		}

		let tmpRNG = this.seededRandom(this.hashString(pSeedString || 'path'));

		// Parse path into tokens: commands and numbers
		let tmpTokens = pPathString.match(/[MLCQZmlcqz]|[-+]?[0-9]*\.?[0-9]+/g);
		if (!tmpTokens)
		{
			return pPathString;
		}

		// Collect all numeric coordinate indices
		let tmpNumericIndices = [];
		for (let i = 0; i < tmpTokens.length; i++)
		{
			if (/^[-+]?[0-9]*\.?[0-9]+$/.test(tmpTokens[i]))
			{
				tmpNumericIndices.push(i);
			}
		}

		// Process pairs of coordinates (x, y)
		for (let i = 0; i < tmpNumericIndices.length - 1; i += 2)
		{
			let tmpXIdx = tmpNumericIndices[i];
			let tmpYIdx = tmpNumericIndices[i + 1];

			// Reduce jitter for first and last coordinate pairs (port anchors)
			let tmpLocalAmplitude = pAmplitude;
			if (i === 0 || i >= tmpNumericIndices.length - 2)
			{
				tmpLocalAmplitude = pAmplitude * 0.15; // Minimal anchor jitter
			}
			else if (i === 2 || i >= tmpNumericIndices.length - 4)
			{
				tmpLocalAmplitude = pAmplitude * 0.5; // Reduced near anchors
			}

			let tmpX = parseFloat(tmpTokens[tmpXIdx]);
			let tmpY = parseFloat(tmpTokens[tmpYIdx]);
			let tmpJittered = this.jitterPoint(tmpX, tmpY, tmpLocalAmplitude, tmpRNG);

			tmpTokens[tmpXIdx] = tmpJittered.x.toFixed(1);
			tmpTokens[tmpYIdx] = tmpJittered.y.toFixed(1);
		}

		// Reassemble path string with spaces
		let tmpResult = '';
		for (let i = 0; i < tmpTokens.length; i++)
		{
			if (i > 0 && /^[MLCQZmlcqz]$/.test(tmpTokens[i]))
			{
				tmpResult += ' ' + tmpTokens[i];
			}
			else if (i > 0)
			{
				tmpResult += ' ' + tmpTokens[i];
			}
			else
			{
				tmpResult += tmpTokens[i];
			}
		}

		return tmpResult;
	}
}

module.exports = PictProviderFlowNoise;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":59}],224:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-PanelChrome
 *
 * Template-based provider for creating the panel chrome (the foreignObject
 * wrapper, title bar, close button, and body container) for properties panels.
 *
 * Replaces the raw DOM API approach with a configuration template
 * (Flow-PanelChrome-Template) registered in the FlowView's template set.
 */
class PictProviderFlowPanelChrome extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowPanelChrome';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Create a foreignObject containing the panel chrome and empty body container.
	 *
	 * Uses the Flow-PanelChrome-Template registered in the FlowView configuration
	 * to render the inner HTML (title bar, close button, body container), then
	 * attaches event isolation listeners so pointer and wheel events inside the
	 * panel body do not propagate to the SVG interaction layer.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels (Hash, NodeHash, X, Y, Width, Height, Title)
	 * @param {SVGGElement} pPanelsLayer - The SVG <g> for panel foreignObjects
	 * @returns {HTMLDivElement} The panel body container element for content rendering
	 */
	createPanelForeignObject(pPanelData, pPanelsLayer)
	{
		let tmpSVGHelper = this._FlowView._SVGHelperProvider;

		// Create the SVG foreignObject wrapper
		let tmpFO = tmpSVGHelper.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-panel-foreign-object');
		tmpFO.setAttribute('data-panel-hash', pPanelData.Hash);
		tmpFO.setAttribute('data-node-hash', pPanelData.NodeHash || '');
		if (pPanelData.ConnectionHash) { tmpFO.setAttribute('data-connection-hash', pPanelData.ConnectionHash); }
		tmpFO.setAttribute('x', String(pPanelData.X));
		tmpFO.setAttribute('y', String(pPanelData.Y));
		tmpFO.setAttribute('width', String(pPanelData.Width));
		tmpFO.setAttribute('height', String(pPanelData.Height));

		// Render the panel chrome from the configuration template
		let tmpPict = this._FlowView.pict || this._FlowView.fable;
		let tmpTitle = pPanelData.Title || 'Properties';
		let tmpChromeHTML = tmpPict.parseTemplateByHash('Flow-PanelChrome-Template',
			{
				Hash: pPanelData.Hash,
				Title: tmpTitle,
				FlowViewIdentifier: this._FlowView.options.ViewIdentifier
			});

		tmpFO.innerHTML = tmpChromeHTML;

		// Populate the close button icon
		let tmpCloseIcon = tmpFO.querySelector('.pict-flow-panel-close-icon');
		if (tmpCloseIcon && this._FlowView && this._FlowView._IconProvider)
		{
			tmpCloseIcon.innerHTML = this._FlowView._IconProvider.getIconSVGMarkup('close', 12);
		}
		else if (tmpCloseIcon)
		{
			tmpCloseIcon.textContent = '\u2715';
		}

		// Pointer/wheel isolation lives on the inline onpointerdown/onwheel
		// attributes in Flow-PanelChrome-Template — see PictView-Flow.js.

		pPanelsLayer.appendChild(tmpFO);

		// Return the properties tab pane as the body container for content rendering
		let tmpPropertiesPane = tmpFO.querySelector('.pict-flow-panel-tab-pane[data-tab="properties"]');
		return tmpPropertiesPane;
	}
}

module.exports = PictProviderFlowPanelChrome;

},{"fable-serviceproviderbase":59}],225:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowRenderer'
};

/**
 * PictProvider-Flow-Renderer
 *
 * Registry + active-state holder for the FLOW RENDERER axis.
 *
 * A "renderer" answers: *how do we draw a flow* — node body shape, border
 * jitter, connection stroke style, arrowhead style, supplementary CSS for
 * text treatment. It is **independent of color**. Color comes from the
 * active pict-section-theme theme; the renderer only describes the visual
 * vocabulary applied on top of those colors.
 *
 * This is the analogue of `EdgeTheme` for node + arrow + filter treatment.
 * See PictService-Flow-Layout.js for the EdgeTheme pattern this mirrors.
 *
 * ## Renderer shape
 *
 * ```javascript
 * {
 *     Key: 'sketch',
 *     Label: 'Sketch (jittery)',
 *
 *     NodeBodyMode: 'bracket',                       // 'rect' | 'bracket'
 *     BracketConfig: { SerifLength: 20, TitleSeparator: true },
 *
 *     NoiseConfig: {                                 // hand-drawn jitter
 *         Enabled: true,
 *         DefaultLevel: 0.4,
 *         MaxJitterPx: 4,
 *         AffectsNodes: true,
 *         AffectsConnections: true
 *     },
 *
 *     ConnectionConfig: {                            // edge stroke style
 *         StrokeDashArray: null,
 *         StrokeWidth: 1.5,
 *         ArrowheadStyle: 'triangle'
 *     },
 *
 *     ShapeOverrides: {                              // per-shape SVG attrs
 *         'arrowhead-connection':          { Fill: 'var(--theme-color-text-secondary, #555)' },
 *         'arrowhead-connection-selected': { Fill: 'var(--theme-color-brand-primary,  #2255aa)' }
 *     },
 *
 *     GeometryCSS: '',                               // optional :root :root rules for
 *                                                    //   --pf-node-body-stroke-width,
 *                                                    //   --pf-node-body-radius,
 *                                                    //   --pf-node-shadow*,
 *                                                    //   --pf-panel-shadow, --pf-panel-radius,
 *                                                    //   --pf-node-title-size/weight, etc.
 *
 *     AdditionalCSS: ''                              // optional per-renderer extras
 *                                                    //   (font-family swaps, filters, scanlines)
 * }
 * ```
 *
 * ## API
 *
 * ```javascript
 * pict.providers['PictProviderFlowRenderer'].register(key, definition);
 * pict.providers['PictProviderFlowRenderer'].setRenderer('sketch');
 * pict.providers['PictProviderFlowRenderer'].getActiveRenderer();
 * pict.providers['PictProviderFlowRenderer'].getActiveRendererKey();
 * pict.providers['PictProviderFlowRenderer'].getRendererKeys();
 * pict.providers['PictProviderFlowRenderer'].getNoiseLevel();
 * pict.providers['PictProviderFlowRenderer'].setNoiseLevel(0.5);
 * pict.providers['PictProviderFlowRenderer'].getNodeNoiseAmplitude();
 * pict.providers['PictProviderFlowRenderer'].processPathString(d, seed);
 * ```
 *
 * The FlowView wires this provider's GeometryCSS + AdditionalCSS into the
 * CSS cascade on each `setRenderer()` call, plus applies ShapeOverrides
 * through ConnectorShapesProvider (same flow the old monolithic theme used).
 */
class PictProviderFlowRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._ActiveRendererKey = 'clean';
		this._NoiseLevel = 0;
		this._Renderers = {};

		this._registerBuiltInRenderers();
	}

	// ── Registry ──────────────────────────────────────────────────────────

	_registerBuiltInRenderers()
	{
		// 1. Clean — rectangle bodies, soft shadows, no jitter. Modern default.
		this._Renderers['clean'] =
		{
			Key: 'clean',
			Label: 'Clean',
			NodeBodyMode: 'rect',
			BracketConfig: null,
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			ShapeOverrides: {},
			GeometryCSS: `
				.pict-flow-container {
					--pf-node-body-stroke-width: 1.5;
					--pf-node-body-radius:       6px;
					--pf-node-shadow:            drop-shadow(0 1px 3px rgba(0,0,0,0.10));
					--pf-node-shadow-hover:      drop-shadow(0 2px 6px rgba(0,0,0,0.15));
					--pf-node-shadow-selected:   drop-shadow(0 0 6px var(--theme-color-brand-primary, #2255aa));
					--pf-node-shadow-dragging:   drop-shadow(0 4px 10px rgba(0,0,0,0.20));
					--pf-node-title-size:        12px;
					--pf-node-title-weight:      600;
					--pf-panel-radius:           8px;
					--pf-panel-shadow:           0 2px 8px rgba(0,0,0,0.12);
				}
			`,
			AdditionalCSS: ''
		};

		// 2. Bracket — `[ ]` body, no jitter. Sketch-like but precise.
		this._Renderers['bracket'] =
		{
			Key: 'bracket',
			Label: 'Bracket',
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 20,
				TitleSeparator: true
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1.5,
				ArrowheadStyle: 'triangle'
			},
			ShapeOverrides:
			{
				'arrowhead-connection':          { Fill: 'var(--theme-color-text-secondary, #555555)' },
				'arrowhead-connection-selected': { Fill: 'var(--theme-color-brand-primary,  #2255aa)' }
			},
			GeometryCSS: `
				.pict-flow-container {
					--pf-node-body-stroke-width: 1.5;
					--pf-node-body-radius:       0px;
					--pf-node-shadow:            none;
					--pf-node-shadow-hover:      none;
					--pf-node-shadow-selected:   none;
					--pf-node-shadow-dragging:   none;
					--pf-node-title-size:        12px;
					--pf-node-title-weight:      500;
					--pf-panel-radius:           0px;
					--pf-panel-shadow:           2px 2px 0px rgba(0,0,0,0.08);
				}
			`,
			AdditionalCSS: ''
		};

		// 3. Sketch — bracket + jitter on nodes and connections. Hand-drawn.
		this._Renderers['sketch'] =
		{
			Key: 'sketch',
			Label: 'Sketch',
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 20,
				TitleSeparator: true
			},
			NoiseConfig:
			{
				Enabled: true,
				DefaultLevel: 0.4,
				MaxJitterPx: 4,
				AffectsNodes: true,
				AffectsConnections: true
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1.5,
				ArrowheadStyle: 'triangle'
			},
			ShapeOverrides:
			{
				'arrowhead-connection':          { Fill: 'var(--theme-color-text-secondary, #555555)' },
				'arrowhead-connection-selected': { Fill: 'var(--theme-color-brand-primary,  #2255aa)' }
			},
			GeometryCSS: `
				.pict-flow-container {
					--pf-node-body-stroke-width: 1.5;
					--pf-node-body-radius:       0px;
					--pf-node-shadow:            none;
					--pf-node-shadow-hover:      none;
					--pf-node-shadow-selected:   none;
					--pf-node-shadow-dragging:   none;
					--pf-node-title-size:        12px;
					--pf-node-title-weight:      400;
					--pf-panel-radius:           0px;
					--pf-panel-shadow:           2px 2px 0px rgba(0,0,0,0.08);
				}
			`,
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", "Courier", monospace !important;
				}
				.pict-flow-panel-title-text,
				.pict-flow-panel-node-props-title,
				.pict-flow-info-panel {
					font-family: "Courier New", "Courier", monospace !important;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) !important;
				}
			`
		};

		// 4. CRT — rectangular body + neon drop-shadow glow. No jitter, but a
		//    scanline / monospace text treatment for retro vibes.
		this._Renderers['crt'] =
		{
			Key: 'crt',
			Label: 'CRT',
			NodeBodyMode: 'rect',
			BracketConfig: null,
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			ShapeOverrides:
			{
				'arrowhead-connection':          { Fill: 'var(--theme-color-brand-primary, #ff00ff)' },
				'arrowhead-connection-selected': { Fill: 'var(--theme-color-brand-accent,  #00ffff)' }
			},
			GeometryCSS: `
				.pict-flow-container {
					--pf-node-body-stroke-width: 2;
					--pf-node-body-radius:       0px;
					--pf-node-shadow:            drop-shadow(0 0 8px color-mix(in srgb, var(--theme-color-brand-primary, #ff00ff) 40%, transparent));
					--pf-node-shadow-hover:      drop-shadow(0 0 12px color-mix(in srgb, var(--theme-color-brand-primary, #ff00ff) 60%, transparent));
					--pf-node-shadow-selected:   drop-shadow(0 0 16px color-mix(in srgb, var(--theme-color-brand-accent,  #00ffff) 50%, transparent));
					--pf-node-shadow-dragging:   drop-shadow(0 0 20px color-mix(in srgb, var(--theme-color-brand-primary, #ff00ff) 70%, transparent));
					--pf-node-title-size:        11px;
					--pf-node-title-weight:      700;
					--pf-panel-radius:           0px;
					--pf-panel-shadow:           0 0 20px color-mix(in srgb, var(--theme-color-brand-primary, #ff00ff) 30%, transparent);
				}
			`,
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", monospace !important;
					text-transform: uppercase;
					letter-spacing: 0.5px;
				}
				.pict-flow-connection {
					filter: drop-shadow(0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #ff00ff) 40%, transparent));
				}
			`
		};

		// 5. Workstation — chunky 90s OS aesthetic. Rectangle with hard offset
		//    drop-shadow, no jitter, weighty title bar.
		this._Renderers['workstation'] =
		{
			Key: 'workstation',
			Label: 'Workstation',
			NodeBodyMode: 'rect',
			BracketConfig: null,
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			ShapeOverrides:
			{
				'arrowhead-connection':          { Fill: 'var(--theme-color-border-default, #808080)' },
				'arrowhead-connection-selected': { Fill: 'var(--theme-color-focus-outline,  #008080)' }
			},
			GeometryCSS: `
				.pict-flow-container {
					--pf-node-body-stroke-width: 1;
					--pf-node-body-radius:       0px;
					--pf-node-shadow:            drop-shadow(2px 2px 0px var(--theme-color-border-strong, #404040));
					--pf-node-shadow-hover:      drop-shadow(3px 3px 0px var(--theme-color-border-strong, #404040));
					--pf-node-shadow-selected:   drop-shadow(2px 2px 0px var(--theme-color-focus-outline,  #008080));
					--pf-node-shadow-dragging:   drop-shadow(4px 4px 0px var(--theme-color-border-strong, #404040));
					--pf-node-title-size:        11px;
					--pf-node-title-weight:      700;
					--pf-panel-radius:           0px;
					--pf-panel-shadow:           2px 2px 0px var(--theme-color-border-strong, #404040);
				}
			`,
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "MS Sans Serif", "Arial", sans-serif !important;
				}
			`
		};
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Get the active renderer definition.
	 * @returns {Object}
	 */
	getActiveRenderer()
	{
		return this._Renderers[this._ActiveRendererKey] || this._Renderers['clean'];
	}

	/**
	 * Get the active renderer key.
	 * @returns {string}
	 */
	getActiveRendererKey()
	{
		return this._ActiveRendererKey;
	}

	/**
	 * Switch the active renderer. Updates the noise default, applies shape
	 * overrides, and (if available) hands the GeometryCSS + AdditionalCSS
	 * to the FlowView's CSS provider for re-injection.
	 *
	 * @param {string} pRendererKey
	 * @returns {boolean}
	 */
	setRenderer(pRendererKey)
	{
		if (!this._Renderers[pRendererKey])
		{
			this.log.warn(`PictProviderFlowRenderer: renderer '${pRendererKey}' not found`);
			return false;
		}

		this._ActiveRendererKey = pRendererKey;
		let tmpRenderer = this._Renderers[pRendererKey];

		// Apply noise defaults from the renderer
		if (tmpRenderer.NoiseConfig && typeof tmpRenderer.NoiseConfig.DefaultLevel === 'number')
		{
			this._NoiseLevel = tmpRenderer.NoiseConfig.DefaultLevel;
		}
		else
		{
			this._NoiseLevel = 0;
		}

		// Apply shape overrides through the connector-shapes provider
		if (this._FlowView && this._FlowView._ConnectorShapesProvider)
		{
			this._FlowView._ConnectorShapesProvider.resetToDefaults();
			if (tmpRenderer.ShapeOverrides && Object.keys(tmpRenderer.ShapeOverrides).length > 0)
			{
				this._FlowView._ConnectorShapesProvider.applyThemeOverrides(tmpRenderer.ShapeOverrides);
			}
		}

		this.log.trace(`PictProviderFlowRenderer: switched to '${pRendererKey}'`);
		return true;
	}

	/**
	 * Register a custom renderer.
	 * @param {string} pKey
	 * @param {Object} pDefinition
	 */
	register(pKey, pDefinition)
	{
		if (!pKey || !pDefinition)
		{
			this.log.warn('PictProviderFlowRenderer: register requires key and definition');
			return;
		}
		pDefinition.Key = pKey;
		this._Renderers[pKey] = pDefinition;
	}

	/**
	 * Get all registered renderer keys.
	 * @returns {Array<string>}
	 */
	getRendererKeys()
	{
		return Object.keys(this._Renderers);
	}

	// ── Noise APIs (kept on this provider so consumers don't depend on the
	//    legacy Flow-Theme shim) ──────────────────────────────────────────

	/**
	 * Get the current noise level (0 to 1).
	 * @returns {number}
	 */
	getNoiseLevel()
	{
		return this._NoiseLevel;
	}

	/**
	 * Set the noise level (0 to 1).
	 * @param {number} pLevel
	 */
	setNoiseLevel(pLevel)
	{
		this._NoiseLevel = Math.max(0, Math.min(1, pLevel || 0));
	}

	/**
	 * Get the noise amplitude for node bracket rendering.
	 * Returns 0 if the active renderer disables noise for nodes.
	 * @returns {number}
	 */
	getNodeNoiseAmplitude()
	{
		let tmpRenderer = this.getActiveRenderer();
		if (!tmpRenderer || !tmpRenderer.NoiseConfig || !tmpRenderer.NoiseConfig.Enabled || !tmpRenderer.NoiseConfig.AffectsNodes)
		{
			return 0;
		}
		return this._NoiseLevel * (tmpRenderer.NoiseConfig.MaxJitterPx || 3);
	}

	/**
	 * Post-process an SVG path string to apply jitter when the active
	 * renderer enables noise for connections.
	 *
	 * @param {string} pPathString
	 * @param {string} pSeedString
	 * @returns {string}
	 */
	processPathString(pPathString, pSeedString)
	{
		let tmpRenderer = this.getActiveRenderer();
		if (!tmpRenderer || !tmpRenderer.NoiseConfig || !tmpRenderer.NoiseConfig.Enabled || !tmpRenderer.NoiseConfig.AffectsConnections)
		{
			return pPathString;
		}

		let tmpAmplitude = this._NoiseLevel * (tmpRenderer.NoiseConfig.MaxJitterPx || 3);
		if (tmpAmplitude <= 0)
		{
			return pPathString;
		}

		if (this._FlowView && this._FlowView._NoiseProvider)
		{
			return this._FlowView._NoiseProvider.jitterPath(pPathString, tmpAmplitude, pSeedString);
		}

		return pPathString;
	}
}

module.exports = PictProviderFlowRenderer;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":59}],226:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-SVGHelpers
 *
 * Shared SVG element creation utility used by all flow components
 * that need to create SVG namespace elements (nodes, connections, tethers).
 */
class PictProviderFlowSVGHelpers extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowSVGHelpers';
	}

	/**
	 * Create an SVG namespace element.
	 *
	 * @param {string} pTagName - The SVG element tag name (e.g., 'path', 'circle', 'g', 'rect', 'text')
	 * @returns {SVGElement}
	 */
	createSVGElement(pTagName)
	{
		return document.createElementNS('http://www.w3.org/2000/svg', pTagName);
	}

	/**
	 * Create a group whose contents keep a CONSTANT ON-SCREEN size no matter the viewport zoom.
	 *
	 * Everything inside the viewport is drawn in board units and scaled by the viewport transform, which
	 * is right for content and wrong for the grab handles you manipulate content WITH: a 6-unit rotate grip
	 * is 6 screen pixels at 1:1 and well under one pixel on a board zoomed out to see something very wide,
	 * at which point the handle exists but cannot be hit. Interaction chrome should hold still in the one
	 * coordinate system the mouse lives in.
	 *
	 * So the handle geometry goes inside a group anchored at its attach point and counter-scaled by 1/zoom,
	 * with the shapes drawn around the group's own origin. The anchor is kept on the element so
	 * ViewportManager.updateZoomInvariantChrome can rewrite the scale on every pan/zoom without a re-render.
	 * Counter-scaling also rescues the stroke widths, which shrink the same way.
	 *
	 * @param {number} pAnchorX - X of the attach point, in board units.
	 * @param {number} pAnchorY - Y of the attach point, in board units.
	 * @param {number} pZoom - The current viewport zoom.
	 * @returns {SVGGElement}
	 */
	createZoomInvariantGroup(pAnchorX, pAnchorY, pZoom)
	{
		let tmpGroup = this.createSVGElement('g');
		let tmpX = Number(pAnchorX) || 0;
		let tmpY = Number(pAnchorY) || 0;
		tmpGroup.setAttribute('class', 'pict-flow-zoom-invariant');
		tmpGroup.setAttribute('data-zoom-anchor-x', String(tmpX));
		tmpGroup.setAttribute('data-zoom-anchor-y', String(tmpY));
		tmpGroup.setAttribute('transform', this.zoomInvariantTransform(tmpX, tmpY, pZoom));
		return tmpGroup;
	}

	/**
	 * The transform a zoom-invariant group carries: move to the anchor, then undo the viewport scale.
	 * Shared by creation and by the per-zoom refresh so the two can never drift apart.
	 *
	 * @param {number} pAnchorX
	 * @param {number} pAnchorY
	 * @param {number} pZoom
	 * @returns {string}
	 */
	zoomInvariantTransform(pAnchorX, pAnchorY, pZoom)
	{
		let tmpZoom = Number(pZoom);
		// A zero, negative or missing zoom would blow up the reciprocal; fall back to 1 (no counter-scale).
		let tmpInverse = (isFinite(tmpZoom) && tmpZoom > 0) ? (1 / tmpZoom) : 1;
		return 'translate(' + (Number(pAnchorX) || 0) + ', ' + (Number(pAnchorY) || 0) + ') scale(' + tmpInverse + ')';
	}
}

module.exports = PictProviderFlowSVGHelpers;

},{"fable-serviceproviderbase":59}],227:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowStylePresets'
};

/**
 * PictProvider-Flow-StylePresets
 *
 * The preset registry that the flow editor's primary "Style" picker
 * surfaces. Each preset is a curated triple `(ColorTheme, Renderer,
 * EdgeTheme)` that reproduces one of the legacy monolithic themes —
 * but as a composition of the three new axes.
 *
 * A consumer app can:
 *   - Pick a preset by hash → `flowView.setStylePreset('sketch')`
 *   - Override any axis afterward → `flowView.setColorTheme('flow-cyberpunk')`
 *     leaves the renderer + edge theme alone.
 *   - Register their own preset → `pict.providers['PictProviderFlowStylePresets'].register({...})`
 *
 * ## Preset shape
 *
 * ```javascript
 * {
 *     Hash: 'sketch',
 *     Label: 'Sketch',
 *     ColorTheme: 'flow-sketch',     // a pict-section-theme catalog hash
 *     Renderer:   'sketch',          // a PictProviderFlowRenderer key
 *     EdgeTheme:  'bezier',          // a PictService-Flow-Layout edge theme name
 *     NoiseLevel: 0.4,               // optional — overrides renderer default
 *     Description: 'Hand-drawn paper with jittery brackets'
 * }
 * ```
 *
 * ## API
 *
 * ```javascript
 * pict.providers['PictProviderFlowStylePresets'].register(preset);
 * pict.providers['PictProviderFlowStylePresets'].getPreset(hash);
 * pict.providers['PictProviderFlowStylePresets'].getPresetHashes();
 * pict.providers['PictProviderFlowStylePresets'].applyPreset(hash);
 * pict.providers['PictProviderFlowStylePresets'].getActivePresetHash();
 * ```
 *
 * Apply order on `applyPreset()`:
 *   1. ColorTheme  → delegated to pict.providers.Theme.applyTheme()
 *      (skipped if Theme provider isn't installed in the host)
 *   2. Renderer    → delegated to Flow-Renderer.setRenderer()
 *   3. EdgeTheme   → delegated to FlowView.setEdgeTheme()
 *   4. NoiseLevel  → Flow-Renderer.setNoiseLevel() if provided
 *
 * After any *individual* axis change via `flowView.setColorTheme()`,
 * `setRenderer()`, or `setEdgeTheme()`, the active preset becomes `null`
 * (we're in customized state — no single preset describes the combo).
 */
class PictProviderFlowStylePresets extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowStylePresets';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._ActivePresetHash = null;
		this._Presets = {};

		this._registerBuiltInPresets();
	}

	_registerBuiltInPresets()
	{
		const _DEFAULTS =
		[
			{
				Hash: 'modern',
				Label: 'Modern',
				Description: 'Clean modern look — rounded rectangles, soft shadows, bezier connections.',
				ColorTheme: 'flow-modern',
				Renderer:   'clean',
				EdgeTheme:  'bezier'
			},
			{
				Hash: 'sketch',
				Label: 'Sketch',
				Description: 'Hand-drawn paper — bracket nodes with jitter and Courier text.',
				ColorTheme: 'flow-sketch',
				Renderer:   'sketch',
				EdgeTheme:  'bezier',
				NoiseLevel: 0.4
			},
			{
				Hash: 'blueprint',
				Label: 'Blueprint',
				Description: 'Technical drawing on navy — bracket nodes, dashed lines, orthogonal edges.',
				ColorTheme: 'flow-blueprint',
				Renderer:   'bracket',
				EdgeTheme:  'orthogonal'
			},
			{
				Hash: 'mono',
				Label: 'Monochrome',
				Description: 'Pure black on white — clean rectangles, straight lines, no noise.',
				ColorTheme: 'flow-mono',
				Renderer:   'clean',
				EdgeTheme:  'straight'
			},
			{
				Hash: 'retro-80s',
				Label: '80s Retro',
				Description: 'Neon synthwave glow — magenta + cyan with CRT shadow effects.',
				ColorTheme: 'flow-retro-80s',
				Renderer:   'crt',
				EdgeTheme:  'orthogonal'
			},
			{
				Hash: 'retro-90s',
				Label: '90s Retro',
				Description: 'Windows-95 chrome — gray panels with offset shadows on a teal desktop.',
				ColorTheme: 'flow-retro-90s',
				Renderer:   'workstation',
				EdgeTheme:  'orthogonal'
			},
			{
				Hash: 'whiteboard',
				Label: 'Whiteboard',
				Description: 'Minimal whiteboard — colored brackets per node type, gentle jitter.',
				ColorTheme: 'flow-whiteboard',
				Renderer:   'sketch',
				EdgeTheme:  'bezier',
				NoiseLevel: 0.3
			}
		];

		for (let i = 0; i < _DEFAULTS.length; i++)
		{
			this._Presets[_DEFAULTS[i].Hash] = _DEFAULTS[i];
		}
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Register a custom preset.
	 * @param {Object} pPreset - must include Hash, ColorTheme, Renderer, EdgeTheme
	 * @returns {boolean}
	 */
	register(pPreset)
	{
		if (!pPreset || typeof pPreset !== 'object' || !pPreset.Hash)
		{
			this.log.warn('PictProviderFlowStylePresets: register requires a preset object with a Hash');
			return false;
		}
		this._Presets[pPreset.Hash] = pPreset;
		return true;
	}

	/**
	 * Look up a preset by hash.
	 * @param {string} pHash
	 * @returns {Object|null}
	 */
	getPreset(pHash)
	{
		return this._Presets[pHash] || null;
	}

	/**
	 * All registered preset hashes (insertion order).
	 * @returns {Array<string>}
	 */
	getPresetHashes()
	{
		return Object.keys(this._Presets);
	}

	/**
	 * All registered presets as an ordered array (useful for picker UIs).
	 * @returns {Array<Object>}
	 */
	listPresets()
	{
		return Object.values(this._Presets);
	}

	/**
	 * Hash of the currently-active preset, or null when in customized state
	 * (any individual axis was changed since the last setStylePreset call).
	 * @returns {string|null}
	 */
	getActivePresetHash()
	{
		return this._ActivePresetHash;
	}

	/**
	 * Apply a preset by hash. Applies color theme, renderer, edge theme,
	 * and optional noise level in that order.
	 *
	 * @param {string} pHash
	 * @returns {boolean}
	 */
	applyPreset(pHash)
	{
		let tmpPreset = this._Presets[pHash];
		if (!tmpPreset)
		{
			this.log.warn(`PictProviderFlowStylePresets: preset '${pHash}' not found`);
			return false;
		}

		// 1. Color theme — go through the host's pict-provider-theme if installed.
		if (tmpPreset.ColorTheme && this.fable.providers && this.fable.providers.Theme)
		{
			try { this.fable.providers.Theme.applyTheme(tmpPreset.ColorTheme); }
			catch (pErr) { this.log.warn(`PictProviderFlowStylePresets: Theme.applyTheme failed for '${tmpPreset.ColorTheme}' — ${pErr.message}`); }
		}

		// 2. Renderer — go through Flow-Renderer (must be present).
		if (tmpPreset.Renderer && this._FlowView && this._FlowView._RendererProvider)
		{
			this._FlowView._RendererProvider.setRenderer(tmpPreset.Renderer);
		}

		// 3. Edge theme — go through FlowView's existing setEdgeTheme().
		if (tmpPreset.EdgeTheme && this._FlowView && typeof this._FlowView.setEdgeTheme === 'function')
		{
			try { this._FlowView.setEdgeTheme(tmpPreset.EdgeTheme); }
			catch (pErr) { this.log.warn(`PictProviderFlowStylePresets: setEdgeTheme failed for '${tmpPreset.EdgeTheme}' — ${pErr.message}`); }
		}

		// 4. Optional noise override.
		if (typeof tmpPreset.NoiseLevel === 'number' && this._FlowView && this._FlowView._RendererProvider)
		{
			this._FlowView._RendererProvider.setNoiseLevel(tmpPreset.NoiseLevel);
		}

		this._ActivePresetHash = pHash;
		this.log.trace(`PictProviderFlowStylePresets: applied preset '${pHash}'`);
		return true;
	}

	/**
	 * Called by FlowView when a single axis is overridden by the user — this
	 * clears the active-preset tracker so getActivePresetHash() returns null.
	 */
	markCustomized()
	{
		this._ActivePresetHash = null;
	}
}

module.exports = PictProviderFlowStylePresets;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":59}],228:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowTheme'
};

/**
 * PictProvider-Flow-Theme — back-compat shim.
 *
 * Flow's theming system was decomposed into three independent axes:
 *
 *   1. **ColorTheme** — managed by pict-section-theme (the 7 `flow-*`
 *      bundled themes plus any other catalog entries).
 *   2. **Renderer** — managed by PictProviderFlowRenderer (node body
 *      mode, bracket config, noise config, connection stroke,
 *      shape overrides, geometry CSS).
 *   3. **EdgeTheme** — managed by PictService-Flow-Layout's edge themes
 *      (Bezier, Straight, Orthogonal, Perimeter…).
 *
 * The user-facing concept of "Theme" maps to a **StylePreset** —
 * a curated triple `(ColorTheme, Renderer, EdgeTheme)` — registered
 * with PictProviderFlowStylePresets.
 *
 * This shim preserves the legacy API surface (`setTheme`, `getNoiseLevel`,
 * `setNoiseLevel`, `processPathString`, `getNodeNoiseAmplitude`,
 * `getActiveTheme`, `getActiveThemeKey`, `getThemeKeys`, `registerTheme`)
 * so consumer code calling the old methods keeps working unmodified.
 *
 * Every method here delegates to the appropriate new provider — most
 * commonly the Renderer provider (for noise + geometry) or the
 * StylePresets provider (for `setTheme`/`getActiveThemeKey`).
 *
 * New code should use the per-axis APIs directly:
 *
 *   ```javascript
 *   flowView.setStylePreset('sketch');      // primary
 *   flowView.setColorTheme('flow-blueprint');
 *   flowView.setRenderer('bracket');
 *   flowView.setEdgeTheme('orthogonal');
 *   ```
 */
class PictProviderFlowTheme extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowTheme';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ── Helpers ───────────────────────────────────────────────────────────

	_renderer()
	{
		return (this._FlowView && this._FlowView._RendererProvider) || null;
	}

	_presets()
	{
		return (this._FlowView && this._FlowView._StylePresetsProvider) || null;
	}

	// ── Compat API ────────────────────────────────────────────────────────

	/**
	 * Compat: get the active style preset's "theme-shaped" view. Returns
	 * a synthetic object that exposes the legacy properties (NoiseConfig,
	 * NodeBodyMode, etc.) by pulling from the active renderer.
	 * @returns {Object}
	 */
	getActiveTheme()
	{
		let tmpRenderer = this._renderer();
		let tmpPresets = this._presets();
		let tmpPresetHash = tmpPresets ? tmpPresets.getActivePresetHash() : null;
		let tmpR = tmpRenderer ? tmpRenderer.getActiveRenderer() : {};
		return {
			Key:               tmpPresetHash || tmpR.Key || 'modern',
			Label:             tmpR.Label || 'Modern',
			NodeBodyMode:      tmpR.NodeBodyMode,
			BracketConfig:     tmpR.BracketConfig,
			NoiseConfig:       tmpR.NoiseConfig,
			ConnectionConfig:  tmpR.ConnectionConfig,
			ShapeOverrides:    tmpR.ShapeOverrides
		};
	}

	/**
	 * Compat: active style preset hash (or, if customized, the active renderer key).
	 * @returns {string}
	 */
	getActiveThemeKey()
	{
		let tmpPresets = this._presets();
		let tmpHash = tmpPresets ? tmpPresets.getActivePresetHash() : null;
		if (tmpHash) return tmpHash;
		let tmpRenderer = this._renderer();
		return tmpRenderer ? tmpRenderer.getActiveRendererKey() : 'modern';
	}

	/**
	 * Compat: pass through to StylePresets.applyPreset.
	 * @param {string} pThemeKey
	 * @returns {boolean}
	 */
	setTheme(pThemeKey)
	{
		let tmpPresets = this._presets();
		if (!tmpPresets)
		{
			this.log.warn('PictProviderFlowTheme: setTheme() called but StylePresets provider not available');
			return false;
		}
		return tmpPresets.applyPreset(pThemeKey);
	}

	/**
	 * Compat: register a "theme" — translates to a style preset registration.
	 * The legacy shape (CSSVariables / NodeBodyMode / NoiseConfig) is no
	 * longer supported wholesale; callers wanting full custom looks should
	 * register a Renderer and (optionally) a ColorTheme and StylePreset
	 * separately. This shim accepts a minimal preset-style payload:
	 *   { Hash, Label?, ColorTheme, Renderer, EdgeTheme, NoiseLevel? }
	 * @param {string} pKey
	 * @param {Object} pDef
	 */
	registerTheme(pKey, pDef)
	{
		let tmpPresets = this._presets();
		if (!tmpPresets || !pKey || !pDef)
		{
			this.log.warn('PictProviderFlowTheme: registerTheme requires StylePresets provider, a key, and a definition');
			return;
		}
		let tmpPreset = Object.assign({}, pDef, { Hash: pKey });
		tmpPresets.register(tmpPreset);
	}

	/**
	 * Compat: list registered preset hashes.
	 * @returns {Array<string>}
	 */
	getThemeKeys()
	{
		let tmpPresets = this._presets();
		return tmpPresets ? tmpPresets.getPresetHashes() : [];
	}

	// ── Noise + path delegations (preserved verbatim API) ─────────────────

	getNoiseLevel()
	{
		let tmpRenderer = this._renderer();
		return tmpRenderer ? tmpRenderer.getNoiseLevel() : 0;
	}

	setNoiseLevel(pLevel)
	{
		let tmpRenderer = this._renderer();
		if (tmpRenderer) tmpRenderer.setNoiseLevel(pLevel);
	}

	getNodeNoiseAmplitude()
	{
		let tmpRenderer = this._renderer();
		return tmpRenderer ? tmpRenderer.getNodeNoiseAmplitude() : 0;
	}

	processPathString(pPathString, pSeedString)
	{
		let tmpRenderer = this._renderer();
		if (!tmpRenderer) return pPathString;
		return tmpRenderer.processPathString(pPathString, pSeedString);
	}
}

module.exports = PictProviderFlowTheme;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":59}],229:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-ConnectionHandleManager
 *
 * Manages connection handle lifecycle: dragging, adding, removing,
 * and resetting bezier/orthogonal handles on connections and tethers.
 *
 * Extracted from PictView-Flow.js to isolate handle CRUD operations
 * from the main view.
 */
class PictServiceFlowConnectionHandleManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowConnectionHandleManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Update a connection handle position during drag (for real-time feedback).
	 * @param {string} pConnectionHash
	 * @param {string} pHandleType - 'bezier-midpoint', 'bezier-handle-N', 'ortho-corner1', 'ortho-corner2', 'ortho-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateConnectionHandle(pConnectionHash, pHandleType, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};
		tmpConnection.Data.HandleCustomized = true;

		// Multi-handle bezier: handle type is 'bezier-handle-N'
		if (pHandleType && pHandleType.startsWith('bezier-handle-'))
		{
			let tmpIndex = parseInt(pHandleType.replace('bezier-handle-', ''), 10);
			if (!isNaN(tmpIndex) && Array.isArray(tmpConnection.Data.BezierHandles)
				&& tmpIndex < tmpConnection.Data.BezierHandles.length)
			{
				tmpConnection.Data.BezierHandles[tmpIndex].x = pX;
				tmpConnection.Data.BezierHandles[tmpIndex].y = pY;
			}
			this._FlowView._renderSingleConnection(pConnectionHash);
			return;
		}

		switch (pHandleType)
		{
			case 'bezier-midpoint':
				// Legacy single-handle: migrate to BezierHandles array
				if (!Array.isArray(tmpConnection.Data.BezierHandles)
					|| tmpConnection.Data.BezierHandles.length === 0)
				{
					tmpConnection.Data.BezierHandles = [{ x: pX, y: pY }];
				}
				else
				{
					tmpConnection.Data.BezierHandles[0].x = pX;
					tmpConnection.Data.BezierHandles[0].y = pY;
				}
				// Keep legacy fields in sync for backward compat
				tmpConnection.Data.BezierHandleX = pX;
				tmpConnection.Data.BezierHandleY = pY;
				break;

			case 'ortho-corner1':
				tmpConnection.Data.OrthoCorner1X = pX;
				tmpConnection.Data.OrthoCorner1Y = pY;
				break;

			case 'ortho-corner2':
				tmpConnection.Data.OrthoCorner2X = pX;
				tmpConnection.Data.OrthoCorner2Y = pY;
				break;

			case 'ortho-midpoint':
			{
				// Midpoint drag shifts the corridor offset
				let tmpSourcePos = this._FlowView.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
				let tmpTargetPos = this._FlowView.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);
				if (tmpSourcePos && tmpTargetPos)
				{
					let tmpGeom = this._FlowView._ConnectionRenderer._computeDirectionalGeometry(tmpSourcePos, tmpTargetPos);
					let tmpStartDir = tmpGeom.startDir;

					// Compute offset along the corridor axis
					if (Math.abs(tmpStartDir.dx) > Math.abs(tmpStartDir.dy))
					{
						// Horizontal departure — corridor is vertical, shift is along X
						let tmpAutoMidX = (tmpGeom.departX + tmpGeom.approachX) / 2;
						tmpConnection.Data.OrthoMidOffset = pX - tmpAutoMidX;
					}
					else
					{
						// Vertical departure — corridor is horizontal, shift is along Y
						let tmpAutoMidY = (tmpGeom.departY + tmpGeom.approachY) / 2;
						tmpConnection.Data.OrthoMidOffset = pY - tmpAutoMidY;
					}
				}
				break;
			}
		}

		this._FlowView._renderSingleConnection(pConnectionHash);
	}

	/**
	 * Add a bezier handle to a connection at the specified position.
	 * The handle is inserted at the correct index based on which
	 * segment of the curve the click point is closest to.
	 *
	 * @param {string} pConnectionHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	addConnectionHandle(pConnectionHash, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};

		// Ensure BezierHandles array exists (migrate from legacy if needed)
		if (!Array.isArray(tmpConnection.Data.BezierHandles))
		{
			tmpConnection.Data.BezierHandles = [];
			if (tmpConnection.Data.BezierHandleX != null && tmpConnection.Data.BezierHandleY != null)
			{
				tmpConnection.Data.BezierHandles.push({
					x: tmpConnection.Data.BezierHandleX,
					y: tmpConnection.Data.BezierHandleY
				});
			}
		}

		// Ensure bezier mode
		tmpConnection.Data.LineMode = 'bezier';

		let tmpSourcePos = this._FlowView.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
		let tmpTargetPos = this._FlowView.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);

		let tmpInsertIndex = 0;
		if (tmpSourcePos && tmpTargetPos && this._FlowView._ConnectionRenderer)
		{
			tmpInsertIndex = this._FlowView._ConnectionRenderer.computeInsertionIndex(
				tmpConnection.Data.BezierHandles,
				{ x: pX, y: pY },
				tmpSourcePos,
				tmpTargetPos
			);
		}

		tmpConnection.Data.BezierHandles.splice(tmpInsertIndex, 0, { x: pX, y: pY });
		tmpConnection.Data.HandleCustomized = true;

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Remove a bezier handle from a connection by index.
	 *
	 * @param {string} pConnectionHash
	 * @param {number} pIndex - Index in the BezierHandles array
	 */
	removeConnectionHandle(pConnectionHash, pIndex)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection || !tmpConnection.Data) return;

		if (!Array.isArray(tmpConnection.Data.BezierHandles)) return;
		if (pIndex < 0 || pIndex >= tmpConnection.Data.BezierHandles.length) return;

		tmpConnection.Data.BezierHandles.splice(pIndex, 1);

		if (tmpConnection.Data.BezierHandles.length === 0)
		{
			tmpConnection.Data.HandleCustomized = false;
			tmpConnection.Data.BezierHandleX = null;
			tmpConnection.Data.BezierHandleY = null;
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Reset handle positions for all connections/tethers involving a node.
	 * Called when a node moves. Preserves LineMode but resets handle coordinates to auto.
	 * @param {string} pNodeHash
	 */
	resetHandlesForNode(pNodeHash)
	{
		if (!this._FlowView) return;

		// Reset connection handles
		for (let i = 0; i < this._FlowView._FlowData.Connections.length; i++)
		{
			let tmpConn = this._FlowView._FlowData.Connections[i];
			if (tmpConn.SourceNodeHash === pNodeHash || tmpConn.TargetNodeHash === pNodeHash)
			{
				if (tmpConn.Data && tmpConn.Data.HandleCustomized)
				{
					tmpConn.Data.HandleCustomized = false;
					// Clear multi-handle array (current format)
					tmpConn.Data.BezierHandles = [];
					// Clear legacy single-handle fields
					tmpConn.Data.BezierHandleX = null;
					tmpConn.Data.BezierHandleY = null;
					tmpConn.Data.OrthoCorner1X = null;
					tmpConn.Data.OrthoCorner1Y = null;
					tmpConn.Data.OrthoCorner2X = null;
					tmpConn.Data.OrthoCorner2Y = null;
					tmpConn.Data.OrthoMidOffset = 0;
				}
			}
		}

		// Reset tether handles for panels attached to this node
		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.resetHandlesForNode(this._FlowView._FlowData.OpenPanels, pNodeHash);
		}
	}

	/**
	 * Reset tether handle positions for a specific panel.
	 * Called when a panel is dragged.
	 * @param {string} pPanelHash
	 */
	resetHandlesForPanel(pPanelHash)
	{
		if (!this._FlowView) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.resetHandlePositions(tmpPanel);
		}
	}
}

module.exports = PictServiceFlowConnectionHandleManager;

},{"fable-serviceproviderbase":59}],230:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libPerimeterMath = require('pict-provider-graphlayout').Edges.PerimeterMath;

// Chip (port-label badge) geometry — must mirror PortRenderer's badge
// dimensions exactly so hint paths land on the chip's actual outer
// edge instead of where we *guess* it might be.
const _CHIP_HEIGHT       = 12;
const _CHIP_PAD_H        = 5;
const _CHIP_EDGE_PAD     = 1;
const _CHIP_PORT_RADIUS  = 5;
const _CHIP_BORDER_WIDTH = 2;
const _CHIP_PER_CHAR_PX  = 5;

// Port-type → stroke color map. Mirrors the table PortRenderer uses for
// badge borders so the hint bezier matches its port's affinity color.
const PORT_TYPE_COLORS =
{
	'event-in':  'var(--theme-color-status-info, #3498db)',
	'event-out': 'var(--theme-color-status-success, #2ecc71)',
	'setting':   'var(--theme-color-status-warning, #e67e22)',
	'value':     'var(--theme-color-status-warning, #f1c40f)',
	'error':     'var(--theme-color-status-error, #e74c3c)'
};
const PORT_TYPE_DEFAULT_COLOR = 'var(--theme-color-border-default, #95a5a6)';

class PictServiceFlowConnectionRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowConnectionRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render a connection as an SVG path with hit area and optional handles.
	 * @param {Object} pConnection - The connection data
	 * @param {SVGGElement} pConnectionsLayer - The SVG group to append to
	 * @param {boolean} pIsSelected - Whether this connection is selected
	 */
	renderConnection(pConnection, pConnectionsLayer, pIsSelected)
	{
		if (!this._FlowView) return;

		let tmpSourcePos = this._FlowView.getPortPosition(pConnection.SourceNodeHash, pConnection.SourcePortHash);
		let tmpTargetPos = this._FlowView.getPortPosition(pConnection.TargetNodeHash, pConnection.TargetPortHash);

		// Let the active edge theme reshape the attachment points (e.g. a
		// "perimeter" theme that exits whichever side of the node faces the
		// other end). The static port positions are still computed above so
		// themes that don't override fall through unchanged.
		let tmpStaticSourcePos = tmpSourcePos;
		let tmpStaticTargetPos = tmpTargetPos;
		let tmpAttachOverride = this._resolveAttachmentsViaEdgeTheme(pConnection, tmpSourcePos, tmpTargetPos);
		if (tmpAttachOverride.source) tmpSourcePos = tmpAttachOverride.source;
		if (tmpAttachOverride.target) tmpTargetPos = tmpAttachOverride.target;

		// Look up the source port's PortType for connection coloring
		let tmpSourcePortType = null;
		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		if (tmpSourceNode && tmpSourceNode.Ports)
		{
			for (let i = 0; i < tmpSourceNode.Ports.length; i++)
			{
				if (tmpSourceNode.Ports[i].Hash === pConnection.SourcePortHash)
				{
					tmpSourcePortType = tmpSourceNode.Ports[i].PortType || null;
					break;
				}
			}
		}

		if (!tmpSourcePos || !tmpTargetPos) return;

		let tmpData = pConnection.Data || {};
		let tmpPath = this._generatePathViaEdgeTheme(pConnection, tmpSourcePos, tmpTargetPos, tmpData);

		// Apply theme noise post-processing to the path
		if (this._FlowView._ThemeProvider)
		{
			tmpPath = this._FlowView._ThemeProvider.processPathString(tmpPath, pConnection.Hash);
		}

		// Apply stroke-dasharray from theme's ConnectionConfig
		let tmpStrokeDashArray = null;
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.ConnectionConfig && tmpActiveTheme.ConnectionConfig.StrokeDashArray)
			{
				tmpStrokeDashArray = tmpActiveTheme.ConnectionConfig.StrokeDashArray;
			}
		}

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;

		// Build the port-type CSS class suffix for connection coloring
		let tmpConnTypeClass = tmpSourcePortType ? (' conn-type-' + tmpSourcePortType) : '';

		// Determine the arrowhead marker based on port type
		let tmpArrowMarkerId;
		if (pIsSelected)
		{
			tmpArrowMarkerId = 'flow-arrowhead-selected-' + tmpViewIdentifier;
		}
		else if (tmpSourcePortType)
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpSourcePortType + '-' + tmpViewIdentifier;
		}
		else
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpViewIdentifier;
		}

		// Hit area (wider invisible path for easier selection)
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		let tmpPathElement = null;
		if (tmpShapeProvider)
		{
			let tmpHitArea = tmpShapeProvider.createConnectionHitAreaElement(tmpPath, pConnection.Hash);
			pConnectionsLayer.appendChild(tmpHitArea);

			tmpPathElement = tmpShapeProvider.createConnectionPathElement(
				tmpPath, pConnection.Hash, pIsSelected, tmpViewIdentifier);
			if (tmpConnTypeClass)
			{
				tmpPathElement.setAttribute('class',
					(tmpPathElement.getAttribute('class') || '') + tmpConnTypeClass);
			}
			// Override the default arrowhead with the typed one
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');
			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}
			pConnectionsLayer.appendChild(tmpPathElement);
		}
		else
		{
			let tmpHitArea = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpHitArea.setAttribute('class', 'pict-flow-connection-hitarea');
			tmpHitArea.setAttribute('d', tmpPath);
			tmpHitArea.setAttribute('data-connection-hash', pConnection.Hash);
			tmpHitArea.setAttribute('data-element-type', 'connection-hitarea');
			pConnectionsLayer.appendChild(tmpHitArea);

			tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', `pict-flow-connection${tmpConnTypeClass} ${pIsSelected ? 'selected' : ''}`);
			tmpPathElement.setAttribute('d', tmpPath);
			tmpPathElement.setAttribute('data-connection-hash', pConnection.Hash);
			tmpPathElement.setAttribute('data-element-type', 'connection');
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');

			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}

			pConnectionsLayer.appendChild(tmpPathElement);
		}

		// Per-connection host styling (a moodboard styles its own edges): stroke color / width / dash and
		// the end markers, applied only when the connection's Data carries them so default (workflow)
		// connections are untouched. A label, when set, is drawn at the midpoint.
		let tmpHasMarkers = (typeof tmpData.SourceMarker !== 'undefined' || typeof tmpData.TargetMarker !== 'undefined');
		this._applyConnectionStyle(tmpPathElement, tmpData, tmpViewIdentifier);
		this._renderConnectionLabel(pConnection, tmpData, pConnectionsLayer, tmpSourcePos, tmpTargetPos);

		// Render the colored endpoint dot at each end of the connection
		// into the dedicated endpoints layer (sits *above* the nodes
		// layer so the dot doesn't get hidden under the card chrome
		// when an edge theme places it on the node's perimeter).
		// PortRenderer suppresses its own circle for any port that
		// participates in a connection — we own the dot here. Skipped when the
		// connection supplies its own end markers (those own the endpoints).
		let tmpEndpointsLayer = this._FlowView._EndpointsLayer || pConnectionsLayer;
		if (!tmpHasMarkers)
		{
			this._renderEndpointDots(pConnection, tmpEndpointsLayer, tmpSourcePos, tmpTargetPos);
		}

		// When the resolved attachment differs from the card-defined port
		// position (e.g. a Perimeter theme moved the dot to the edge of the
		// card), paint a hidden hint bezier connecting the badge to the
		// dot. CSS reveals it on hover so users can see "this 'In' chip
		// corresponds to that dot up at the top".
		if (this._FlowView._PortHintsLayer)
		{
			this._renderPortHints(pConnection, this._FlowView._PortHintsLayer,
				tmpStaticSourcePos, tmpSourcePos, tmpStaticTargetPos, tmpTargetPos);
		}

		// Render drag handles when selected
		if (pIsSelected)
		{
			this._renderHandles(pConnection, pConnectionsLayer, tmpSourcePos, tmpTargetPos);
		}
	}

	// Apply per-connection host styling to the path element from the connection's Data: StrokeColor,
	// StrokeWidth, StrokeStyle ('solid' | 'dashed' | 'dotted') and SourceMarker / TargetMarker
	// ('none' | 'arrow' | 'dot' | 'square'). Each is applied only when present, so connections that do
	// not carry these keys render exactly as before.
	_applyConnectionStyle(pPathElement, pData, pViewIdentifier)
	{
		if (!pPathElement || !pData || !pPathElement.style) { return; }
		// Stroke color / width / dash go through inline style, NOT SVG presentation attributes: the
		// .pict-flow-connection CSS rule sets stroke + stroke-width, and a stylesheet rule beats a
		// presentation attribute, so an attribute would be silently ignored. Inline style outranks the
		// stylesheet, so the per-connection appearance wins.
		if (pData.StrokeColor) { pPathElement.style.stroke = pData.StrokeColor; }
		if (pData.StrokeWidth) { pPathElement.style.strokeWidth = String(pData.StrokeWidth); }
		if (pData.StrokeStyle)
		{
			pPathElement.style.strokeDasharray = (pData.StrokeStyle === 'dashed') ? '7,5' : ((pData.StrokeStyle === 'dotted') ? '1.5,4' : 'none');
		}
		// Markers are not styled by CSS, so attributes are correct (they reference the marker defs).
		if (typeof pData.TargetMarker !== 'undefined')
		{
			let tmpEnd = this._connectionMarkerId(pData.TargetMarker, 'end', pViewIdentifier);
			if (tmpEnd) { pPathElement.setAttribute('marker-end', 'url(#' + tmpEnd + ')'); }
			else { pPathElement.removeAttribute('marker-end'); }
		}
		if (typeof pData.SourceMarker !== 'undefined')
		{
			let tmpStart = this._connectionMarkerId(pData.SourceMarker, 'start', pViewIdentifier);
			if (tmpStart) { pPathElement.setAttribute('marker-start', 'url(#' + tmpStart + ')'); }
			else { pPathElement.removeAttribute('marker-start'); }
		}
	}

	// Resolve a marker name + end ('start' | 'end') to its SVG marker def id; null for 'none'/unknown.
	_connectionMarkerId(pMarker, pEnd, pViewIdentifier)
	{
		if (pMarker === 'arrow') { return 'flow-marker-arrow-' + pEnd + '-' + pViewIdentifier; }
		if (pMarker === 'dot') { return 'flow-marker-dot-' + pViewIdentifier; }
		if (pMarker === 'square') { return 'flow-marker-square-' + pViewIdentifier; }
		return null;
	}

	// Draw a connection's label (Data.Label) at the midpoint of its endpoints. A white halo (paint-order
	// stroke, set in CSS) keeps it legible over the line. Skipped when there is no label.
	_renderConnectionLabel(pConnection, pData, pLayer, pSourcePos, pTargetPos)
	{
		// Render when a Label key is present (even ''), so a host that edits the label in place has an
		// element to update; a connection with no Label key (a default workflow edge) gets none.
		if (!pData || typeof pData.Label === 'undefined' || !pSourcePos || !pTargetPos) { return; }
		if (!this._FlowView._SVGHelperProvider) { return; }
		let tmpText = this._FlowView._SVGHelperProvider.createSVGElement('text');
		tmpText.setAttribute('class', 'pict-flow-connection-label');
		tmpText.setAttribute('x', String((pSourcePos.x + pTargetPos.x) / 2));
		tmpText.setAttribute('y', String((pSourcePos.y + pTargetPos.y) / 2));
		tmpText.setAttribute('text-anchor', 'middle');
		tmpText.setAttribute('dominant-baseline', 'middle');
		tmpText.setAttribute('data-connection-hash', pConnection.Hash);
		tmpText.textContent = pData.Label;
		pLayer.appendChild(tmpText);
	}

	/**
	 * Append the colored endpoint dots for both ends of a connection
	 * onto the destination layer (absolute coords). Reuses
	 * `ConnectorShapesProvider.createPortElement` so the styling
	 * matches the static port circle exactly.
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer - the endpoints layer (or fallback)
	 * @param {{x: number, y: number}} pSourcePos
	 * @param {{x: number, y: number}} pTargetPos
	 */
	_renderEndpointDots(pConnection, pLayer, pSourcePos, pTargetPos)
	{
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (!tmpShapeProvider) return;

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		if (tmpSourcePort && pSourcePos)
		{
			let tmpDot = tmpShapeProvider.createPortElement(tmpSourcePort, pSourcePos, pConnection.SourceNodeHash);
			tmpDot.setAttribute('data-connection-hash', pConnection.Hash);
			tmpDot.setAttribute('data-connection-end', 'source');
			pLayer.appendChild(tmpDot);
		}
		if (tmpTargetPort && pTargetPos)
		{
			let tmpDot = tmpShapeProvider.createPortElement(tmpTargetPort, pTargetPos, pConnection.TargetNodeHash);
			tmpDot.setAttribute('data-connection-hash', pConnection.Hash);
			tmpDot.setAttribute('data-connection-end', 'target');
			pLayer.appendChild(tmpDot);
		}
	}

	/**
	 * Render the per-end "where did the dot go" hint paths. Drawn into
	 * the port-hints layer (above nodes) but kept opacity:0 by CSS;
	 * PortRenderer/NodeView toggle a `data-active` attribute on hover.
	 *
	 * Skipped when the resolved attachment matches the static port
	 * position (no theme rerouting → no need for a hint).
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer
	 * @param {{x: number, y: number, side?: string}} pStaticSrc - card-defined port position
	 * @param {{x: number, y: number, side?: string}} pSrc - resolved attachment
	 * @param {{x: number, y: number, side?: string}} pStaticTgt
	 * @param {{x: number, y: number, side?: string}} pTgt
	 */
	_renderPortHints(pConnection, pLayer, pStaticSrc, pSrc, pStaticTgt, pTgt)
	{
		let tmpPositionsDiffer = function (pA, pB)
		{
			if (!pA || !pB) return false;
			return (Math.abs(pA.x - pB.x) > 0.5) || (Math.abs(pA.y - pB.y) > 0.5);
		};

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		// Hints are colored by the *other* end's node identity — looking
		// at a hub with 8 hints fanning out, each hint is the color of
		// the spoke that connection terminates at, so you can tell at a
		// glance which line goes where without tracing it. (Mirrors the
		// Ultravisor card-category color model: gray=flow-control,
		// purple=core, orange=data, teal=llm, etc.)
		// Anchor each hint at the chip's outer edge facing the dot
		// (not the port's static position, which sits on the node's
		// edge — visually inside the chip's stripe). The hint ends at
		// the dot but its tail "points at" the chip's center.
		if (pStaticSrc && tmpPositionsDiffer(pStaticSrc, pSrc))
		{
			let tmpChipExit = this._chipEdgeAimingAt(tmpSourcePort, pStaticSrc, pSrc);
			pLayer.appendChild(this._buildPortHintPath(
				tmpChipExit, pSrc,
				pConnection.SourceNodeHash, pConnection.SourcePortHash, pConnection.Hash, 'source',
				this._hintColor(tmpSourcePort, tmpTargetNode)));
		}
		if (pStaticTgt && tmpPositionsDiffer(pStaticTgt, pTgt))
		{
			let tmpChipExit = this._chipEdgeAimingAt(tmpTargetPort, pStaticTgt, pTgt);
			pLayer.appendChild(this._buildPortHintPath(
				tmpChipExit, pTgt,
				pConnection.TargetNodeHash, pConnection.TargetPortHash, pConnection.Hash, 'target',
				this._hintColor(tmpTargetPort, tmpSourceNode)));
		}
	}

	/**
	 * Compute the chip (port-label badge) bounding box for a given
	 * port. The chip is a small rectangle that lives just inside the
	 * node's outer edge, anchored to the port's static position. We
	 * mirror PortRenderer's badge geometry exactly so the hint path
	 * lands on real chip-edge pixels.
	 *
	 * Returns null when we don't have enough info (no label or
	 * unknown side) — caller should fall back to the static position.
	 *
	 * @param {Object|null} pPort
	 * @param {{x: number, y: number, side?: string}} pStaticPos - the
	 *        port's nominal position (returned by getPortPosition); the
	 *        chip extends *inward* from here.
	 * @returns {{X: number, Y: number, Width: number, Height: number}|null}
	 */
	_chipBoundsFor(pPort, pStaticPos)
	{
		if (!pPort || !pStaticPos) return null;
		let tmpSide = pStaticPos.side || pPort.Side || (pPort.Direction === 'input' ? 'left' : 'right');
		let tmpLabel = pPort.Label || '';
		// PortRenderer skips badge rendering entirely when there is no
		// label, so there's nothing for the hint to anchor against.
		if (tmpLabel === '') return null;

		let tmpTextPx = tmpLabel.length * _CHIP_PER_CHAR_PX;
		let tmpWidth = _CHIP_PORT_RADIUS + _CHIP_PAD_H + tmpTextPx + _CHIP_PAD_H + _CHIP_BORDER_WIDTH;
		let tmpHeight = _CHIP_HEIGHT;

		// Chip center sits halfway along the line from the port's static
		// position toward the inside of the node, offset by half the
		// chip's extent in that direction (plus the 1px edge padding
		// PortRenderer leaves between the chip and the node edge).
		let tmpCx, tmpCy;
		if (tmpSide.indexOf('left') === 0)
		{
			tmpCx = pStaticPos.x + tmpWidth / 2 + _CHIP_EDGE_PAD;
			tmpCy = pStaticPos.y;
		}
		else if (tmpSide.indexOf('right') === 0)
		{
			tmpCx = pStaticPos.x - tmpWidth / 2 - _CHIP_EDGE_PAD;
			tmpCy = pStaticPos.y;
		}
		else if (tmpSide.indexOf('top') === 0)
		{
			tmpCx = pStaticPos.x;
			tmpCy = pStaticPos.y + tmpHeight / 2 + _CHIP_EDGE_PAD;
		}
		else if (tmpSide.indexOf('bottom') === 0)
		{
			tmpCx = pStaticPos.x;
			tmpCy = pStaticPos.y - tmpHeight / 2 - _CHIP_EDGE_PAD;
		}
		else
		{
			return null;
		}

		return { X: tmpCx - tmpWidth / 2, Y: tmpCy - tmpHeight / 2, Width: tmpWidth, Height: tmpHeight };
	}

	/**
	 * Resolve the point on the chip's outer perimeter where a line
	 * from the chip's center toward the dot would exit the chip. Used
	 * as the hint's start point so the line visually emerges from the
	 * chip's edge facing the dot, aimed at the chip's center.
	 *
	 * Falls back to the static port position when chip geometry can't
	 * be computed (no label, unknown side).
	 *
	 * @param {Object|null} pPort
	 * @param {{x: number, y: number, side?: string}} pStaticPos
	 * @param {{x: number, y: number}} pDotPos
	 * @returns {{x: number, y: number}}
	 */
	_chipEdgeAimingAt(pPort, pStaticPos, pDotPos)
	{
		let tmpBounds = this._chipBoundsFor(pPort, pStaticPos);
		if (!tmpBounds) return pStaticPos;
		let tmpExit = libPerimeterMath.resolvePerimeterAttachment({
			Node: tmpBounds,
			OtherDefaultPosition: pDotPos
		});
		if (!tmpExit) return pStaticPos;
		return tmpExit;
	}

	/**
	 * Resolve a node's identity color. Looks at the inline node fields
	 * first (per-node overrides win), then the registered node-type
	 * config from the NodeTypeProvider. Returns null when the node has
	 * no opinion — caller should fall back to port-type color.
	 *
	 * @param {Object|null} pNode
	 * @returns {string|null}
	 */
	_resolveNodeIdentityColor(pNode)
	{
		if (!pNode) return null;
		if (pNode.TitleBarColor) return pNode.TitleBarColor;
		if (pNode.BodyStyle && pNode.BodyStyle.stroke) return pNode.BodyStyle.stroke;
		let tmpProvider = this._FlowView ? this._FlowView._NodeTypeProvider : null;
		if (tmpProvider && typeof tmpProvider.getNodeType === 'function' && pNode.Type)
		{
			let tmpType = tmpProvider.getNodeType(pNode.Type);
			if (tmpType)
			{
				if (tmpType.TitleBarColor) return tmpType.TitleBarColor;
				if (tmpType.BodyStyle && tmpType.BodyStyle.stroke) return tmpType.BodyStyle.stroke;
			}
		}
		return null;
	}

	/**
	 * Resolve the hint stroke color. Priority chain:
	 *   1. The OTHER end's node identity color (TitleBarColor /
	 *      BodyStyle.stroke / NodeTypeConfig color) — the strongest
	 *      signal: "this hint terminates at *that* card".
	 *   2. This end's PortType color — semantic-role fallback.
	 *   3. Direction-based default that matches the visible dot color.
	 *   4. Neutral gray.
	 *
	 * @param {Object|null} pPort - this end's port
	 * @param {Object|null} pOtherNode - the node at the other end
	 * @returns {string}
	 */
	_hintColor(pPort, pOtherNode)
	{
		let tmpOtherColor = this._resolveNodeIdentityColor(pOtherNode);
		if (tmpOtherColor) return tmpOtherColor;
		if (pPort && pPort.PortType && PORT_TYPE_COLORS[pPort.PortType])
		{
			return PORT_TYPE_COLORS[pPort.PortType];
		}
		if (pPort && pPort.Direction === 'input')  return PORT_TYPE_COLORS['event-in'];
		if (pPort && pPort.Direction === 'output') return PORT_TYPE_COLORS['event-out'];
		return PORT_TYPE_DEFAULT_COLOR;
	}

	/**
	 * Build a single hint-path SVG element: a soft S-curve from the
	 * card-defined port position to the resolved attachment position.
	 * Tagged with port + node + connection hashes so hover handlers can
	 * find the right hint by attribute.
	 *
	 * @param {{x: number, y: number}} pStart - badge / chip position
	 * @param {{x: number, y: number}} pEnd - actual dot position
	 * @returns {SVGPathElement}
	 */
	_buildPortHintPath(pStart, pEnd, pNodeHash, pPortHash, pConnectionHash, pEndLabel, pStrokeColor)
	{
		let tmpEl = this._FlowView._SVGHelperProvider.createSVGElement('path');

		// Soft S-curve: control points pulled along the perpendicular bisector
		let tmpDX = pEnd.x - pStart.x;
		let tmpDY = pEnd.y - pStart.y;
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
		let tmpBend = Math.min(60, tmpDist * 0.35);
		// Perpendicular unit vector
		let tmpPX = (tmpDist > 0) ? -tmpDY / tmpDist : 0;
		let tmpPY = (tmpDist > 0) ?  tmpDX / tmpDist : 0;
		let tmpCp1X = pStart.x + tmpDX * 0.35 + tmpPX * tmpBend * 0.3;
		let tmpCp1Y = pStart.y + tmpDY * 0.35 + tmpPY * tmpBend * 0.3;
		let tmpCp2X = pStart.x + tmpDX * 0.65 + tmpPX * tmpBend * 0.3;
		let tmpCp2Y = pStart.y + tmpDY * 0.65 + tmpPY * tmpBend * 0.3;
		let tmpD = `M ${pStart.x} ${pStart.y} C ${tmpCp1X} ${tmpCp1Y} ${tmpCp2X} ${tmpCp2Y} ${pEnd.x} ${pEnd.y}`;

		tmpEl.setAttribute('class', 'pict-flow-port-hint');
		tmpEl.setAttribute('d', tmpD);
		tmpEl.setAttribute('data-node-hash', pNodeHash);
		tmpEl.setAttribute('data-port-hash', pPortHash);
		tmpEl.setAttribute('data-connection-hash', pConnectionHash);
		tmpEl.setAttribute('data-connection-end', pEndLabel);
		// Affinity color from port type (matches the badge border color).
		// Inline so PortRenderer's color map stays the single source of
		// truth without dragging CSS variables around per port type.
		if (pStrokeColor)
		{
			tmpEl.setAttribute('stroke', pStrokeColor);
		}
		return tmpEl;
	}

	/**
	 * Compute the departure and approach points plus control points
	 * for a direction-aware bezier between two ports.
	 *
	 * This extracts the intermediate geometry from _generateDirectionalPath
	 * so it can be reused by _getAutoMidpoint and _generateBezierPathWithHandle.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{departX, departY, approachX, approachY, cp1X, cp1Y, cp2X, cp2Y, startDir, endDir}}
	 */
	_computeDirectionalGeometry(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.computeDirectionalGeometry(pStart, pEnd);
	}

	/**
	 * Generate a direction-aware path between two ports.
	 *
	 * The path is composed of three segments:
	 *   1. A short straight "departure" segment leaving the source port
	 *      in its outward direction.
	 *   2. A cubic bezier curve connecting the departure point to an
	 *      "approach" point near the target port.
	 *   3. A short straight "approach" segment arriving at the target
	 *      port aligned with its inward direction.
	 *
	 * @param {{x: number, y: number, side: string}} pStart - Start port position + side
	 * @param {{x: number, y: number, side: string}} pEnd   - End port position + side
	 * @returns {string} SVG path d attribute
	 */
	_generateDirectionalPath(pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Dispatch to an edge theme to generate the path string. Falls back
	 * to the renderer's built-in bezier / orthogonal helpers when no
	 * edge-theme registry is available (older host integrations) or
	 * the resolved theme errors out.
	 *
	 * @param {Object} pConnection
	 * @param {{x: number, y: number, side?: string}} pSourcePos
	 * @param {{x: number, y: number, side?: string}} pTargetPos
	 * @param {Object} pData - connection data (LineMode, custom handles, etc.)
	 * @returns {string} SVG path 'd' attribute
	 */
	_generatePathViaEdgeTheme(pConnection, pSourcePos, pTargetPos, pData)
	{
		let tmpLayoutService = this._FlowView ? this._FlowView._LayoutService : null;
		let tmpTheme = (tmpLayoutService && typeof tmpLayoutService.resolveActiveEdgeTheme === 'function')
			? tmpLayoutService.resolveActiveEdgeTheme(pConnection)
			: null;

		if (!tmpTheme || typeof tmpTheme.GeneratePath !== 'function')
		{
			return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
		}

		let tmpContext =
		{
			Source: pSourcePos,
			Target: pTargetPos,
			Connection: pConnection,
			AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
			AllConnections: this._FlowView._FlowData ? this._FlowView._FlowData.Connections : [],
			FlowView: this._FlowView,
			Helpers: this._buildEdgeThemeHelpers(),
			Parameters: tmpLayoutService.getMergedEdgeThemeParameters(
				tmpTheme.Name,
				(this._FlowView._FlowData && this._FlowView._FlowData.EdgeThemeParameters) || {}
			)
		};

		try
		{
			let tmpPath = tmpTheme.GeneratePath(tmpContext);
			if (typeof tmpPath !== 'string' || tmpPath === '')
			{
				return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
			}
			return tmpPath;
		}
		catch (pError)
		{
			this._FlowView.log.warn(`PictServiceFlowConnectionRenderer edge theme '${tmpTheme.Name}' threw: ${pError.message}`);
			return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
		}
	}

	/**
	 * Resolve per-end attachment overrides via the active edge theme's
	 * optional `ResolveAttachment(context)` hook. The theme can return
	 * `{ x, y, side }` for either end (or null to fall through). Used by
	 * themes like Perimeter that route through the node's bounding box
	 * rather than the static port position.
	 *
	 * @param {Object} pConnection
	 * @param {{x: number, y: number, side?: string}} pSourcePos - default port position
	 * @param {{x: number, y: number, side?: string}} pTargetPos - default port position
	 * @returns {{source: ?Object, target: ?Object}}
	 */
	_resolveAttachmentsViaEdgeTheme(pConnection, pSourcePos, pTargetPos)
	{
		let tmpEmpty = { source: null, target: null };
		let tmpLayoutService = this._FlowView ? this._FlowView._LayoutService : null;
		let tmpTheme = (tmpLayoutService && typeof tmpLayoutService.resolveActiveEdgeTheme === 'function')
			? tmpLayoutService.resolveActiveEdgeTheme(pConnection)
			: null;
		if (!tmpTheme || typeof tmpTheme.ResolveAttachment !== 'function') return tmpEmpty;

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		let tmpParams = tmpLayoutService.getMergedEdgeThemeParameters(
			tmpTheme.Name,
			(this._FlowView._FlowData && this._FlowView._FlowData.EdgeThemeParameters) || {}
		);

		let tmpSrc = null, tmpTgt = null;
		try
		{
			tmpSrc = tmpTheme.ResolveAttachment({
				Node: tmpSourceNode, Port: tmpSourcePort,
				DefaultPosition: pSourcePos,
				Connection: pConnection, IsSource: true,
				OtherNode: tmpTargetNode, OtherPort: tmpTargetPort,
				OtherDefaultPosition: pTargetPos,
				AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
				FlowView: this._FlowView,
				Parameters: tmpParams
			});
			tmpTgt = tmpTheme.ResolveAttachment({
				Node: tmpTargetNode, Port: tmpTargetPort,
				DefaultPosition: pTargetPos,
				Connection: pConnection, IsSource: false,
				OtherNode: tmpSourceNode, OtherPort: tmpSourcePort,
				OtherDefaultPosition: pSourcePos,
				AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
				FlowView: this._FlowView,
				Parameters: tmpParams
			});
		}
		catch (pError)
		{
			this._FlowView.log.warn(`PictServiceFlowConnectionRenderer edge theme '${tmpTheme.Name}' ResolveAttachment threw: ${pError.message}`);
			return tmpEmpty;
		}

		return { source: tmpSrc || null, target: tmpTgt || null };
	}

	/**
	 * Find a port by hash on a node. Returns null if missing.
	 * @param {Object} pNode
	 * @param {string} pPortHash
	 * @returns {Object|null}
	 */
	_findPort(pNode, pPortHash)
	{
		if (!pNode || !Array.isArray(pNode.Ports)) return null;
		for (let i = 0; i < pNode.Ports.length; i++)
		{
			if (pNode.Ports[i].Hash === pPortHash) return pNode.Ports[i];
		}
		return null;
	}

	/**
	 * Path-generation helpers exposed to edge themes via the GeneratePath
	 * context object. Themes can compose these to derive their own routing.
	 *
	 * @returns {Object}
	 */
	_buildEdgeThemeHelpers()
	{
		let tmpRenderer = this;
		return {
			generateBezier: function (pStart, pEnd)
			{
				return tmpRenderer._generateDirectionalPath(pStart, pEnd);
			},
			generateMultiBezier: function (pStart, pEnd, pHandles)
			{
				return tmpRenderer._generateMultiHandleBezierPath(pStart, pEnd, pHandles);
			},
			generateOrthogonal: function (pStart, pEnd, pCorners, pMidOffset)
			{
				return tmpRenderer._generateOrthogonalPath(pStart, pEnd, pCorners || null, pMidOffset || 0);
			},
			getBezierHandles: function (pData)
			{
				return tmpRenderer._getBezierHandles(pData);
			}
		};
	}

	/**
	 * Built-in fallback when no edge theme is registered. Mirrors the
	 * pre-edge-theme dispatch (LineMode → bezier or orthogonal).
	 *
	 * @param {{x: number, y: number, side?: string}} pSourcePos
	 * @param {{x: number, y: number, side?: string}} pTargetPos
	 * @param {Object} pData
	 * @returns {string}
	 */
	_builtInPathFallback(pSourcePos, pTargetPos, pData)
	{
		let tmpData = pData || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpCorners = null;
			if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
			{
				tmpCorners =
				{
					corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
					corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
				};
			}
			return this._generateOrthogonalPath(pSourcePos, pTargetPos, tmpCorners, tmpData.OrthoMidOffset || 0);
		}

		let tmpHandles = this._getBezierHandles(tmpData);
		if (tmpHandles.length > 0)
		{
			return this._generateMultiHandleBezierPath(pSourcePos, pTargetPos, tmpHandles);
		}
		return this._generateDirectionalPath(pSourcePos, pTargetPos);
	}

	/**
	 * Get the bezier handles array from connection data, with backward
	 * compatibility for the legacy BezierHandleX/Y single-handle format.
	 *
	 * @param {Object} pData - Connection.Data
	 * @returns {Array<{x: number, y: number}>} Ordered handle waypoints (may be empty)
	 */
	_getBezierHandles(pData)
	{
		if (!pData || !pData.HandleCustomized)
		{
			return [];
		}

		// New multi-handle format
		if (Array.isArray(pData.BezierHandles) && pData.BezierHandles.length > 0)
		{
			return pData.BezierHandles;
		}

		// Legacy single-handle format
		if (pData.BezierHandleX != null && pData.BezierHandleY != null)
		{
			return [{ x: pData.BezierHandleX, y: pData.BezierHandleY }];
		}

		return [];
	}

	/**
	 * Generate a multi-handle bezier path between two ports.
	 * Delegates to PathGenerator.buildMultiBezierPathString for the
	 * actual SVG path assembly with Catmull-Rom tangent continuity.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Array<{x: number, y: number}>} pHandles - Ordered waypoints
	 * @returns {string} SVG path d attribute
	 */
	_generateMultiHandleBezierPath(pStart, pEnd, pHandles)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildMultiBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			pHandles,
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y },
			tmpGeo.startDir,
			tmpGeo.endDir
		);
	}

	/**
	 * Find which segment of the multi-handle bezier the given click point
	 * is closest to, returning the index at which a new handle should be
	 * inserted into the BezierHandles array.
	 *
	 * Segments are: depart→handle[0], handle[0]→handle[1], ..., handle[N-1]→approach.
	 * Returns 0 for before handle[0], 1 for between handle[0] and handle[1], etc.
	 *
	 * @param {Array<{x: number, y: number}>} pHandles - Current handles
	 * @param {{x: number, y: number}} pClickPoint - Where the user right-clicked
	 * @param {{x: number, y: number, side: string}} pStart - Source port position
	 * @param {{x: number, y: number, side: string}} pEnd - Target port position
	 * @returns {number} Insertion index
	 */
	computeInsertionIndex(pHandles, pClickPoint, pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		// Build the waypoint chain: depart, handle[0..N-1], approach
		let tmpWaypoints = [{ x: tmpGeo.departX, y: tmpGeo.departY }];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push({ x: tmpGeo.approachX, y: tmpGeo.approachY });

		let tmpBestDist = Infinity;
		let tmpBestIndex = 0;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpDist = this._distanceToSegment(
				pClickPoint.x, pClickPoint.y,
				tmpWaypoints[i].x, tmpWaypoints[i].y,
				tmpWaypoints[i + 1].x, tmpWaypoints[i + 1].y
			);

			if (tmpDist < tmpBestDist)
			{
				tmpBestDist = tmpDist;
				tmpBestIndex = i;
			}
		}

		return tmpBestIndex;
	}

	/**
	 * Distance from point (px,py) to line segment (ax,ay)-(bx,by).
	 */
	_distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		return this._FlowView._PathGenerator.distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY);
	}

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between two ports.
	 * Evaluates the cubic bezier at t=0.5.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.getAutoMidpoint(pStart, pEnd);
	}

	/**
	 * Generate an orthogonal (90-degree angles only) path between two ports.
	 *
	 * Path format: M start L depart L corner1 L corner2 L approach L end
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object|null} pCorners - { corner1: {x,y}, corner2: {x,y} } or null for auto
	 * @param {number} pMidOffset - Offset for the auto-calculated corridor position
	 * @returns {string} SVG path d attribute
	 */
	_generateOrthogonalPath(pStart, pEnd, pCorners, pMidOffset)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		let tmpCorner1, tmpCorner2;

		if (pCorners && pCorners.corner1 && pCorners.corner2)
		{
			tmpCorner1 = pCorners.corner1;
			tmpCorner2 = pCorners.corner2;
		}
		else
		{
			let tmpAutoCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
				tmpDA.departX, tmpDA.departY,
				tmpDA.approachX, tmpDA.approachY,
				tmpDA.fromDir, tmpDA.toDir,
				pMidOffset || 0
			);
			tmpCorner1 = tmpAutoCorners.corner1;
			tmpCorner2 = tmpAutoCorners.corner2;
		}

		return this._FlowView._PathGenerator.buildOrthogonalPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpDA.departX, y: tmpDA.departY },
			tmpCorner1,
			tmpCorner2,
			{ x: tmpDA.approachX, y: tmpDA.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Get the full orthogonal geometry for a connection (for handle positioning).
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object} pData - Connection.Data
	 * @returns {{corner1: {x,y}, corner2: {x,y}, midpoint: {x,y}}}
	 */
	getOrthogonalGeometry(pStart, pEnd, pData)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		if (pData && pData.HandleCustomized && pData.OrthoCorner1X != null)
		{
			let tmpCorner1 = { x: pData.OrthoCorner1X, y: pData.OrthoCorner1Y };
			let tmpCorner2 = { x: pData.OrthoCorner2X, y: pData.OrthoCorner2Y };
			let tmpMidpoint =
			{
				x: (tmpCorner1.x + tmpCorner2.x) / 2,
				y: (tmpCorner1.y + tmpCorner2.y) / 2
			};
			return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
		}

		return this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
			tmpDA.departX, tmpDA.departY,
			tmpDA.approachX, tmpDA.approachY,
			tmpDA.fromDir, tmpDA.toDir,
			(pData && pData.OrthoMidOffset) || 0
		);
	}

	/**
	 * Render drag handles for the selected connection.
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer
	 * @param {{x, y, side}} pStart - Source port position
	 * @param {{x, y, side}} pEnd   - Target port position
	 */
	_renderHandles(pConnection, pLayer, pStart, pEnd)
	{
		let tmpData = pConnection.Data || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpGeometry = this.getOrthogonalGeometry(pStart, pEnd, tmpData);

			// Corner 1 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner1',
				tmpGeometry.corner1.x, tmpGeometry.corner1.y, 'pict-flow-connection-handle');

			// Midpoint handle (between corners)
			this._createHandle(pLayer, pConnection.Hash, 'ortho-midpoint',
				tmpGeometry.midpoint.x, tmpGeometry.midpoint.y, 'pict-flow-connection-handle-midpoint');

			// Corner 2 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner2',
				tmpGeometry.corner2.x, tmpGeometry.corner2.y, 'pict-flow-connection-handle');
		}
		else
		{
			// Bezier handles — show one handle per waypoint, or a
			// single auto-midpoint when no custom handles exist.
			let tmpHandles = this._getBezierHandles(tmpData);

			if (tmpHandles.length > 0)
			{
				for (let i = 0; i < tmpHandles.length; i++)
				{
					this._createHandle(pLayer, pConnection.Hash,
						'bezier-handle-' + i,
						tmpHandles[i].x, tmpHandles[i].y,
						'pict-flow-connection-handle');
				}
			}
			else
			{
				let tmpMidpoint = this.getAutoMidpoint(pStart, pEnd);
				this._createHandle(pLayer, pConnection.Hash, 'bezier-midpoint',
					tmpMidpoint.x, tmpMidpoint.y, 'pict-flow-connection-handle');
			}
		}
	}

	/**
	 * Create a single SVG circle handle element.
	 *
	 * @param {SVGGElement} pLayer
	 * @param {string} pConnectionHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pClassName
	 */
	_createHandle(pLayer, pConnectionHash, pHandleType, pX, pY, pClassName)
	{
		if (!this._FlowView._ConnectorShapesProvider) return;

		let tmpShapeKey = (pClassName === 'pict-flow-connection-handle-midpoint')
			? 'connection-handle-midpoint' : 'connection-handle';

		this._FlowView._ConnectorShapesProvider.createFullHandle(
			pLayer, pConnectionHash, pHandleType, pX, pY,
			tmpShapeKey, 'connection-handle', 'data-connection-hash');
	}

	/**
	 * Legacy bezier path for drag connections where we don't have side info.
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string}
	 */
	_generateBezierPath(pStart, pEnd)
	{
		// During drag operations we may not have side info; default to right->left
		let tmpStart = { x: pStart.x, y: pStart.y, side: pStart.side || 'right' };
		let tmpEnd   = { x: pEnd.x,   y: pEnd.y,   side: pEnd.side   || 'left' };
		return this._generateDirectionalPath(tmpStart, tmpEnd);
	}

	/**
	 * Render a temporary drag connection line (used during connection creation)
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {SVGGElement} pLayer - The layer to render into
	 * @param {string} [pStartSide] - The side the source port is on
	 * @returns {SVGPathElement} The created path element
	 */
	renderDragConnection(pStartX, pStartY, pEndX, pEndY, pLayer, pStartSide)
	{
		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		let tmpPathElement;

		if (tmpShapeProvider)
		{
			tmpPathElement = tmpShapeProvider.createDragConnectionElement(tmpPath);
		}
		else
		{
			tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', 'pict-flow-drag-connection');
			tmpPathElement.setAttribute('d', tmpPath);
		}

		pLayer.appendChild(tmpPathElement);

		return tmpPathElement;
	}

	/**
	 * Update a drag connection path
	 * @param {SVGPathElement} pPathElement
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {string} [pStartSide] - The side the source port is on
	 */
	updateDragConnection(pPathElement, pStartX, pStartY, pEndX, pEndY, pStartSide)
	{
		if (!pPathElement) return;

		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		pPathElement.setAttribute('d', tmpPath);
	}
}

module.exports = PictServiceFlowConnectionRenderer;

},{"fable-serviceproviderbase":59,"pict-provider-graphlayout":151}],231:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-CursorManager
 *
 * Owns the canvas pointer cursor as a single, intentional concern. The cursor is
 * a pure function of the interaction state machine (InteractionManager._State)
 * plus the view mode (read-only, read-only navigation, whether panning is
 * enabled). It is applied through ONE chokepoint: a `data-flow-cursor` token
 * attribute on the SVG element, which the CSS maps to a real cursor.
 *
 * This replaces the previous approach (a base `cursor: grab` on the SVG plus
 * `panning` / `connecting` class toggles scattered across the InteractionManager)
 * so cursor behavior is derived from state rather than maintained by hand at
 * every interaction site. Element-scoped hover cursors (ports, handles, panel
 * chrome, toolbar buttons) stay on those elements -- they are correctly scoped
 * and win for their own element regardless of the canvas cursor.
 *
 * To extend: add a state-to-token case in resolveCursor and a CSS rule for the
 * token. The InteractionManager calls update() on every state transition (via
 * its _setState), and the view calls it when the mode changes.
 */
class PictServiceFlowCursorManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowCursorManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Map an interaction state + mode to a cursor token. Pure: no DOM, no side
	 * effects, so it is unit testable.
	 *
	 * @param {Object} pContext - { state, readOnly, navigating, panningEnabled }
	 * @returns {string} a cursor token: 'default' | 'grab' | 'grabbing' | 'crosshair' | 'resize'
	 */
	resolveCursor(pContext)
	{
		let tmpContext = pContext || {};

		switch (tmpContext.state)
		{
			case 'panning':
			case 'dragging-node':
			case 'dragging-panel':
			case 'dragging-handle':
			case 'rotating-node':
				return 'grabbing';

			case 'resizing-node':
			case 'resizing-panel':
				return 'resize';

			case 'connecting':
			case 'marquee':
				return 'crosshair';

			default:
				// Idle: the canvas cursor signals whether the background can be grabbed.
				// Read-only is static unless navigation (the hand toggle) is on; in edit
				// mode the background is grabbable when panning is enabled.
				if (tmpContext.readOnly)
				{
					return tmpContext.navigating ? 'grab' : 'default';
				}
				return tmpContext.panningEnabled ? 'grab' : 'default';
		}
	}

	/**
	 * Gather the current state + mode and apply the resolved cursor token. Called
	 * by the InteractionManager on every state transition and by the view on mode
	 * changes. Safe to call before the SVG exists (no-op).
	 */
	update()
	{
		if (!this._FlowView)
		{
			return;
		}

		let tmpInteractionManager = this._FlowView._InteractionManager;
		let tmpToken = this.resolveCursor(
			{
				state: (tmpInteractionManager && tmpInteractionManager._State) ? tmpInteractionManager._State : 'idle',
				readOnly: (typeof this._FlowView.isReadOnly === 'function') ? this._FlowView.isReadOnly() : false,
				navigating: (typeof this._FlowView.isReadOnlyNavigation === 'function') ? this._FlowView.isReadOnlyNavigation() : false,
				panningEnabled: this._FlowView.options ? (this._FlowView.options.EnablePanning !== false) : true
			});

		this.apply(tmpToken);
	}

	/**
	 * Write the cursor token to the SVG element. The CSS maps
	 * `.pict-flow-svg[data-flow-cursor="<token>"]` to a real cursor.
	 * @param {string} pToken
	 */
	apply(pToken)
	{
		let tmpElement = this._FlowView ? this._FlowView._SVGElement : null;
		if (tmpElement && typeof tmpElement.setAttribute === 'function')
		{
			tmpElement.setAttribute('data-flow-cursor', pToken);
		}
	}
}

module.exports = PictServiceFlowCursorManager;

},{"fable-serviceproviderbase":59}],232:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-DataManager
 *
 * Manages flow data lifecycle: serialization, deserialization, and CRUD
 * operations for nodes and connections.
 *
 * Extracted from PictView-Flow.js to keep the view focused on
 * coordination and lifecycle rather than data manipulation.
 */
class PictServiceFlowDataManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowDataManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Marshaling ----

	/**
	 * Marshal data from AppData into the flow view
	 */
	marshalToView()
	{
		if (!this._FlowView) return;

		if (this._FlowView.options.FlowDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this._FlowView.fable,
				Pict: this._FlowView.pict || this._FlowView.fable,
				AppData: this._FlowView.pict ? this._FlowView.pict.AppData : this._FlowView.fable.AppData,
				Bundle: this._FlowView.Bundle,
				Options: this._FlowView.options
			};
			let tmpData = this._FlowView.fable.manifest.getValueByHash(tmpAddressSpace, this._FlowView.options.FlowDataAddress);
			if (typeof tmpData === 'object' && tmpData !== null)
			{
				this.setFlowData(tmpData);
			}
		}
	}

	/**
	 * Marshal data from the flow view back to AppData
	 */
	marshalFromView()
	{
		if (!this._FlowView) return;

		if (this._FlowView.options.FlowDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this._FlowView.fable,
				Pict: this._FlowView.pict || this._FlowView.fable,
				AppData: this._FlowView.pict ? this._FlowView.pict.AppData : this._FlowView.fable.AppData,
				Bundle: this._FlowView.Bundle,
				Options: this._FlowView.options
			};
			this._FlowView.fable.manifest.setValueByHash(tmpAddressSpace, this._FlowView.options.FlowDataAddress, JSON.parse(JSON.stringify(this._FlowView._FlowData)));
		}
	}

	// ---- Flow Data Get/Set ----

	/**
	 * Get the complete flow data object
	 * @returns {Object} The flow data including nodes, connections, and view state
	 */
	getFlowData()
	{
		if (!this._FlowView) return {};
		return JSON.parse(JSON.stringify(this._FlowView._FlowData));
	}

	/**
	 * Set the complete flow data object and re-render
	 * @param {Object} pFlowData - The flow data to set
	 */
	setFlowData(pFlowData)
	{
		if (!this._FlowView) return;

		if (typeof pFlowData !== 'object' || pFlowData === null)
		{
			this._FlowView.log.warn('PictSectionFlow setFlowData received invalid data');
			return;
		}

		let tmpDefaultAlgorithm = (this._FlowView.options && this._FlowView.options.DefaultLayoutAlgorithm) || 'Custom';
		let tmpDefaultParameters = (this._FlowView.options && this._FlowView.options.DefaultLayoutParameters) || {};
		let tmpDefaultAutoApply = !!(this._FlowView.options && this._FlowView.options.DefaultLayoutAutoApply);
		let tmpDefaultEdgeTheme = (this._FlowView.options && this._FlowView.options.DefaultEdgeTheme) || null;
		let tmpDefaultEdgeThemeParameters = (this._FlowView.options && this._FlowView.options.DefaultEdgeThemeParameters) || {};

		this._FlowView._FlowData = {
			Nodes: Array.isArray(pFlowData.Nodes) ? pFlowData.Nodes : [],
			Connections: Array.isArray(pFlowData.Connections) ? pFlowData.Connections : [],
			OpenPanels: Array.isArray(pFlowData.OpenPanels) ? pFlowData.OpenPanels : [],
			SavedLayouts: Array.isArray(pFlowData.SavedLayouts) ? pFlowData.SavedLayouts : [],
			ViewState: Object.assign(
				{ PanX: 0, PanY: 0, Zoom: 1, SelectedNodeHash: null, SelectedNodeHashes: [], SelectedConnectionHash: null, SelectedTetherHash: null },
				pFlowData.ViewState || {}
			),
			LayoutAlgorithm: (typeof pFlowData.LayoutAlgorithm === 'string' && pFlowData.LayoutAlgorithm !== '') ? pFlowData.LayoutAlgorithm : tmpDefaultAlgorithm,
			LayoutParameters: (pFlowData.LayoutParameters && typeof pFlowData.LayoutParameters === 'object') ? JSON.parse(JSON.stringify(pFlowData.LayoutParameters)) : JSON.parse(JSON.stringify(tmpDefaultParameters)),
			LayoutAutoApply: (typeof pFlowData.LayoutAutoApply === 'boolean') ? pFlowData.LayoutAutoApply : tmpDefaultAutoApply,
			EdgeTheme: (typeof pFlowData.EdgeTheme === 'string' && pFlowData.EdgeTheme !== '') ? pFlowData.EdgeTheme : tmpDefaultEdgeTheme,
			EdgeThemeParameters: (pFlowData.EdgeThemeParameters && typeof pFlowData.EdgeThemeParameters === 'object') ? JSON.parse(JSON.stringify(pFlowData.EdgeThemeParameters)) : JSON.parse(JSON.stringify(tmpDefaultEdgeThemeParameters))
		};

		// Merge any browser-persisted layouts into the newly loaded data
		if (this._FlowView._LayoutProvider)
		{
			this._FlowView._LayoutProvider.loadPersistedLayouts();
		}

		if (this._FlowView.initialRenderComplete)
		{
			this._FlowView.renderFlow();
		}
	}

	// ---- Node CRUD ----

	/**
	 * Add a new node to the flow
	 * @param {string} pType - The node type hash
	 * @param {number} pX - X position
	 * @param {number} pY - Y position
	 * @param {string} [pTitle] - Optional title
	 * @param {Object} [pData] - Optional additional data
	 * @returns {Object} The created node
	 */
	addNode(pType, pX, pY, pTitle, pData)
	{
		if (!this._FlowView) return null;

		let tmpType = pType || this._FlowView.options.DefaultNodeType;
		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpType);

		let tmpNodeHash = `node-${this._FlowView.fable.getUUID()}`;
		let tmpNode =
		{
			Hash: tmpNodeHash,
			Type: tmpType,
			X: pX || 100,
			Y: pY || 100,
			Width: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultWidth) || this._FlowView.options.DefaultNodeWidth,
			Height: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultHeight) || this._FlowView.options.DefaultNodeHeight,
			Title: pTitle || (tmpNodeTypeConfig && tmpNodeTypeConfig.Label) || 'New Node',
			Ports: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultPorts)
				? JSON.parse(JSON.stringify(tmpNodeTypeConfig.DefaultPorts))
				: [
					{ Hash: `port-in-${this._FlowView.fable.getUUID()}`, Direction: 'input', Side: 'left', Label: 'In' },
					{ Hash: `port-out-${this._FlowView.fable.getUUID()}`, Direction: 'output', Side: 'right', Label: 'Out' }
				],
			Data: pData || {}
		};

		// Ensure each port has a unique hash
		for (let i = 0; i < tmpNode.Ports.length; i++)
		{
			if (!tmpNode.Ports[i].Hash)
			{
				tmpNode.Ports[i].Hash = `port-${tmpNode.Ports[i].Direction}-${this._FlowView.fable.getUUID()}`;
			}
		}

		this._FlowView._FlowData.Nodes.push(tmpNode);
		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeAdded', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpNode;
	}

	/**
	 * Remove a node and all its connections
	 * @param {string} pNodeHash - The hash of the node to remove
	 * @returns {boolean} Whether the node was removed
	 */
	removeNode(pNodeHash)
	{
		if (!this._FlowView) return false;

		let tmpNodeIndex = this._FlowView._FlowData.Nodes.findIndex((pNode) => pNode.Hash === pNodeHash);
		if (tmpNodeIndex < 0)
		{
			this._FlowView.log.warn(`PictSectionFlow removeNode: node ${pNodeHash} not found`);
			return false;
		}

		let tmpRemovedNode = this._FlowView._FlowData.Nodes.splice(tmpNodeIndex, 1)[0];

		// Remove all connections involving this node
		this._FlowView._FlowData.Connections = this._FlowView._FlowData.Connections.filter((pConnection) =>
		{
			return pConnection.SourceNodeHash !== pNodeHash && pConnection.TargetNodeHash !== pNodeHash;
		});

		// Close any open panels for this node
		this._FlowView.closePanelForNode(pNodeHash);

		// Clear selection if this node was selected
		if (this._FlowView._FlowData.ViewState.SelectedNodeHash === pNodeHash)
		{
			this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		}

		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeRemoved', tmpRemovedNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}

	// ---- Connection CRUD ----

	/**
	 * Add a connection between two ports
	 * @param {string} pSourceNodeHash
	 * @param {string} pSourcePortHash
	 * @param {string} pTargetNodeHash
	 * @param {string} pTargetPortHash
	 * @param {Object} [pData] - Optional additional data
	 * @returns {Object|false} The created connection, or false if invalid
	 */
	addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData)
	{
		if (!this._FlowView) return false;

		// Validate that both nodes and ports exist
		let tmpSourceNode = this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pSourceNodeHash);
		let tmpTargetNode = this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pTargetNodeHash);

		if (!tmpSourceNode || !tmpTargetNode)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: source or target node not found');
			return false;
		}

		let tmpSourcePort = tmpSourceNode.Ports.find((pPort) => pPort.Hash === pSourcePortHash);
		let tmpTargetPort = tmpTargetNode.Ports.find((pPort) => pPort.Hash === pTargetPortHash);

		if (!tmpSourcePort || !tmpTargetPort)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: source or target port not found');
			return false;
		}

		// Prevent self-connections
		if (pSourceNodeHash === pTargetNodeHash)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: cannot connect a node to itself');
			return false;
		}

		// Check for duplicate connections
		let tmpDuplicate = this._FlowView._FlowData.Connections.find((pConn) =>
		{
			return pConn.SourceNodeHash === pSourceNodeHash
				&& pConn.SourcePortHash === pSourcePortHash
				&& pConn.TargetNodeHash === pTargetNodeHash
				&& pConn.TargetPortHash === pTargetPortHash;
		});
		if (tmpDuplicate)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: duplicate connection');
			return false;
		}

		let tmpConnection =
		{
			Hash: `conn-${this._FlowView.fable.getUUID()}`,
			SourceNodeHash: pSourceNodeHash,
			SourcePortHash: pSourcePortHash,
			TargetNodeHash: pTargetNodeHash,
			TargetPortHash: pTargetPortHash,
			Data: pData || {}
		};

		this._FlowView._FlowData.Connections.push(tmpConnection);
		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionCreated', tmpConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpConnection;
	}

	/**
	 * Remove a connection
	 * @param {string} pConnectionHash - The hash of the connection to remove
	 * @returns {boolean} Whether the connection was removed
	 */
	removeConnection(pConnectionHash)
	{
		if (!this._FlowView) return false;

		let tmpConnectionIndex = this._FlowView._FlowData.Connections.findIndex((pConn) => pConn.Hash === pConnectionHash);
		if (tmpConnectionIndex < 0)
		{
			this._FlowView.log.warn(`PictSectionFlow removeConnection: connection ${pConnectionHash} not found`);
			return false;
		}

		let tmpRemovedConnection = this._FlowView._FlowData.Connections.splice(tmpConnectionIndex, 1)[0];

		// Close any properties panel open for this connection.
		if (typeof this._FlowView.closePanelForConnection === 'function')
		{
			this._FlowView.closePanelForConnection(pConnectionHash);
		}

		if (this._FlowView._FlowData.ViewState.SelectedConnectionHash === pConnectionHash)
		{
			this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		}

		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionRemoved', tmpRemovedConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}
}

module.exports = PictServiceFlowDataManager;

},{"fable-serviceproviderbase":59}],233:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Interaction states for the flow diagram
 */
const INTERACTION_STATES =
{
	IDLE: 'idle',
	DRAGGING_NODE: 'dragging-node',
	DRAGGING_PANEL: 'dragging-panel',
	DRAGGING_HANDLE: 'dragging-handle',
	CONNECTING: 'connecting',
	PANNING: 'panning',
	RESIZING_PANEL: 'resizing-panel',
	RESIZING_NODE: 'resizing-node',
	ROTATING_NODE: 'rotating-node',
	RESIZING_FRAME: 'resizing-frame',
	MOVING_FRAME: 'moving-frame',
	MARQUEE: 'marquee'
};

class PictServiceFlowInteractionManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowInteractionManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._SVGElement = null;
		this._ViewportElement = null;

		// Interaction state
		this._setState(INTERACTION_STATES.IDLE);

		// Drag state
		this._DragNodeHash = null;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragNodeStartX = 0;
		this._DragNodeStartY = 0;

		// Panel drag state
		this._DragPanelHash = null;
		this._DragPanelStartX = 0;
		this._DragPanelStartY = 0;
		this._DragPanelDataStartX = 0;
		this._DragPanelDataStartY = 0;

		// Handle drag state
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;

		// Pan state
		this._PanStartX = 0;
		this._PanStartY = 0;
		this._PanStartPanX = 0;
		this._PanStartPanY = 0;

		// Connection drag state
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
		this._ConnectDragLine = null;

		// Double-click detection
		this._LastClickTime = 0;
		this._LastClickNodeHash = null;
		this._DoubleClickThreshold = 400;

		// Panel resize state
		this._ResizePanelHash = null;
		this._ResizeStartY = 0;
		this._ResizePanelStartHeight = 0;

		// Node resize state (drag a node's bottom-right handle to set Width/Height)
		this._ResizeNodeHash = null;
		this._ResizeNodeStartX = 0;
		this._ResizeNodeStartY = 0;
		this._ResizeNodeStartWidth = 0;
		this._ResizeNodeStartHeight = 0;

		// Content-frame edit state (drag the frame's edge handles to resize, or its move
		// handle to reposition the view-area box).
		this._FrameDragEdge = null;
		this._FrameStart = null;
		this._FrameStartPointerX = 0;
		this._FrameStartPointerY = 0;

		// Double-click detection for connections
		this._LastConnectionClickTime = 0;
		this._LastConnectionClickHash = null;

		// Double-click detection for tethers
		this._LastTetherClickTime = 0;
		this._LastTetherClickHash = null;

		// Double-click detection for handles
		this._LastHandleClickTime = 0;
		this._LastHandleClickHash = null;
		this._LastHandleClickType = null;

		// Bound event handlers (for removeEventListener)
		this._boundOnPointerDown = this._onPointerDown.bind(this);
		this._boundOnPointerMove = this._onPointerMove.bind(this);
		this._boundOnPointerUp = this._onPointerUp.bind(this);
		this._boundOnWheel = this._onWheel.bind(this);
		this._boundOnKeyDown = this._onKeyDown.bind(this);
	}

	/**
	 * Initialize event listeners on the SVG element
	 * @param {SVGSVGElement} pSVGElement
	 * @param {SVGGElement} pViewportElement
	 */
	initialize(pSVGElement, pViewportElement)
	{
		this._SVGElement = pSVGElement;
		this._ViewportElement = pViewportElement;

		if (!this._SVGElement) return;

		// Pointer/wheel/contextmenu live as inline attributes on the SVG
		// template (see Flow-Container-Template in PictView-Flow.js); they
		// route to InteractionManager via the FlowView's bridges. The
		// keydown listener stays document-level because keyboard input
		// has no element-level inline equivalent for the canvas-as-a-whole.
		document.addEventListener('keydown', this._boundOnKeyDown);
	}

	/**
	 * Inline-handler bridge — invoked from the SVG template's
	 * `oncontextmenu` attribute. Prevents the browser context menu and
	 * dispatches to the right bezier-handle action based on what was
	 * right-clicked.
	 *
	 * @param {Event} pEvent
	 */
	handleContextMenu(pEvent)
	{
		pEvent.preventDefault();

		// No edge/handle editing in read-only mode.
		if (this._isReadOnly()) return;

		let tmpTarget = pEvent.target;
		let tmpElementType = this._getElementType(tmpTarget);

		switch (tmpElementType)
		{
			case 'connection':
			case 'connection-hitarea':
				this._addBezierHandle(tmpTarget, pEvent);
				break;

			case 'connection-handle':
				this._removeBezierHandle(tmpTarget);
				break;

			case 'tether':
			case 'tether-hitarea':
				this._addTetherBezierHandle(tmpTarget, pEvent);
				break;

			case 'tether-handle':
				this._removeTetherBezierHandle(tmpTarget);
				break;
		}
	}

	/**
	 * Remove all event listeners. Pointer/wheel/contextmenu listeners live
	 * as inline template attributes and don't need explicit teardown — they
	 * disappear with the SVG element when the FlowView is destroyed.
	 */
	destroy()
	{
		document.removeEventListener('keydown', this._boundOnKeyDown);
	}

	/**
	 * Whether the flow is in read-only / presentation mode. Tolerant of minimal
	 * test harnesses: prefers the view's isReadOnly(), falls back to the option.
	 * @returns {boolean}
	 */
	_isReadOnly()
	{
		if (!this._FlowView) return false;
		if (typeof this._FlowView.isReadOnly === 'function') return !!this._FlowView.isReadOnly();
		return !!(this._FlowView.options && this._FlowView.options.ReadOnly);
	}

	/**
	 * Whether read-only canvas navigation (pan + wheel-zoom) is currently on (the
	 * "hand" toggle). When off, a read-only canvas is static and the wheel scrolls
	 * the page.
	 * @returns {boolean}
	 */
	_isReadOnlyNavigating()
	{
		return !!(this._FlowView && typeof this._FlowView.isReadOnlyNavigation === 'function' && this._FlowView.isReadOnlyNavigation());
	}

	/**
	 * The single interaction-state transition chokepoint. Setting state here keeps
	 * the canvas cursor (and any future state-derived concern) an intentional,
	 * derived property rather than something toggled by hand at each call site.
	 * @param {string} pState - an INTERACTION_STATES value
	 */
	_setState(pState)
	{
		this._State = pState;
		this._updateCursor();
	}

	/**
	 * Ask the CursorManager to re-derive the canvas cursor from the current state
	 * and mode. No-op until the CursorManager and SVG element exist.
	 */
	_updateCursor()
	{
		if (this._FlowView && this._FlowView._CursorManager)
		{
			this._FlowView._CursorManager.update();
		}
	}

	/**
	 * Handle pointer down event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerDown(pEvent)
	{
		if (!this._FlowView) return;

		let tmpTarget = pEvent.target;
		let tmpElementType = this._getElementType(tmpTarget);

		// Check if click is inside a panel content area — let HTML handle its own events
		if (tmpTarget.closest && tmpTarget.closest('.pict-flow-panel-content'))
		{
			return;
		}

		// Capture pointer for smooth dragging (left-click only — right-click
		// needs the real target for contextmenu handle add/remove)
		if (pEvent.button === 0)
		{
			this._SVGElement.setPointerCapture(pEvent.pointerId);
		}

		// Read-only / presentation mode: a reduced dispatch. Selection, node
		// activation (so a host can open a read-only inspector), and panning are
		// allowed; every editing interaction (drag, resize, connect, handle add,
		// panel edit) is inert.
		if (this._isReadOnly())
		{
			// Hand tool on (navigation enabled): a drag anywhere grabs and pans the canvas, including
			// over a card — you are moving the viewport, like the Photoshop hand. No selection here.
			if (this._isReadOnlyNavigating())
			{
				if (pEvent.button === 0 && this._FlowView.options.EnablePanning)
				{
					this._startPanning(pEvent);
				}
				return;
			}

			// Hand off (static): selection + node activation for inspection; the canvas does not move.
			switch (tmpElementType)
			{
				case 'node':
				case 'node-body':
				case 'panel-indicator':
				{
					let tmpNodeHash = this._getNodeHash(tmpTarget);
					if (tmpNodeHash)
					{
						this._FlowView.selectNode(tmpNodeHash);
						let tmpNode = this._FlowView.getNode(tmpNodeHash);
						if (tmpNode && this._FlowView._EventHandlerProvider)
						{
							this._FlowView._EventHandlerProvider.fireEvent('onNodeActivate', tmpNode);
						}
					}
					break;
				}

				case 'connection':
				case 'connection-hitarea':
					this._selectConnection(tmpTarget);
					break;

				case 'tether':
				case 'tether-hitarea':
					this._selectTether(tmpTarget);
					break;

				default:
					break;
			}
			return;
		}

		switch (tmpElementType)
		{
			case 'port':
				this._startConnection(pEvent, tmpTarget);
				break;

			case 'node':
			case 'node-body':
			case 'panel-indicator':
			{
				let tmpNodeHash = this._getNodeHash(tmpTarget);
				let tmpNow = Date.now();

				// Shift-click toggles this node in the multi-selection (no drag, no panel).
				if (tmpNodeHash && this._FlowView.options.EnableMultiSelect && pEvent.shiftKey)
				{
					this._LastClickTime = 0;
					this._LastClickNodeHash = null;
					this._FlowView.toggleNodeSelection(tmpNodeHash);
					break;
				}

				// Check for double-click on same node
				if (tmpNodeHash && tmpNodeHash === this._LastClickNodeHash
					&& (tmpNow - this._LastClickTime) < this._DoubleClickThreshold)
				{
					// Double-click: toggle panel
					this._LastClickTime = 0;
					this._LastClickNodeHash = null;
					this._FlowView.togglePanel(tmpNodeHash);
				}
				else
				{
					// Single click: start node drag
					this._LastClickTime = tmpNow;
					this._LastClickNodeHash = tmpNodeHash;
					this._startNodeDrag(pEvent, tmpTarget);
				}
				break;
			}

			case 'panel-titlebar':
				this._startPanelDrag(pEvent, tmpTarget);
				break;

			case 'panel-resize':
				this._startPanelResize(pEvent, tmpTarget);
				break;

			case 'node-resize':
				this._startNodeResize(pEvent, tmpTarget);
				break;

			case 'node-rotate':
				this._startNodeRotate(pEvent, tmpTarget);
				break;

			case 'frame-resize':
				this._startFrameResize(pEvent, tmpTarget);
				break;

			case 'frame-move':
				this._startFrameMove(pEvent, tmpTarget);
				break;

			case 'panel-close':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				if (tmpPanelHash)
				{
					this._FlowView.closePanel(tmpPanelHash);
				}
				break;
			}

			case 'connection-handle':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on handle to toggle mode
				if (tmpConnectionHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleConnectionLineMode(tmpConnectionHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpConnectionHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, tmpConnectionHash, null, tmpHandleType, false);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'tether':
			case 'tether-hitarea':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same tether to add a handle
				if (tmpPanelHash && tmpPanelHash === this._LastTetherClickHash
					&& (tmpNow - this._LastTetherClickTime) < this._DoubleClickThreshold)
				{
					this._LastTetherClickTime = 0;
					this._LastTetherClickHash = null;
					this._addTetherBezierHandle(tmpTarget, pEvent);
				}
				else
				{
					this._LastTetherClickTime = tmpNow;
					this._LastTetherClickHash = tmpPanelHash;
					this._selectTether(tmpTarget);
				}
				break;
			}

			case 'tether-handle':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on tether handle to toggle mode
				if (tmpPanelHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleTetherLineMode(tmpPanelHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpPanelHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, null, tmpPanelHash, tmpHandleType, true);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'connection':
			case 'connection-hitarea':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same connection to add a handle
				if (tmpConnectionHash && tmpConnectionHash === this._LastConnectionClickHash
					&& (tmpNow - this._LastConnectionClickTime) < this._DoubleClickThreshold)
				{
					this._LastConnectionClickTime = 0;
					this._LastConnectionClickHash = null;
					// When the host configured a connection properties panel, double-click opens it;
					// otherwise keep the default behavior of adding a bezier handle.
					if (this._FlowView.options.ConnectionPropertiesPanel && tmpConnectionHash)
					{
						this._FlowView.toggleConnectionPanel(tmpConnectionHash);
					}
					else
					{
						this._addBezierHandle(tmpTarget, pEvent);
					}
				}
				else
				{
					this._LastConnectionClickTime = tmpNow;
					this._LastConnectionClickHash = tmpConnectionHash;
					this._selectConnection(tmpTarget);
				}
				break;
			}

			default:
				// Click / drag on the empty background.
				if (pEvent.button === 0)
				{
					if (this._FlowView.options.EnableMultiSelect && !pEvent.shiftKey)
					{
						// Plain drag marquee-selects; a click (no drag) clears the selection on release.
						this._startMarquee(pEvent);
					}
					else if (this._FlowView.options.EnablePanning)
					{
						// With multi-select on, shift+drag pans; otherwise this is the normal pan.
						this._startPanning(pEvent);
					}
				}
				break;
		}
	}

	/**
	 * Handle pointer move event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerMove(pEvent)
	{
		if (!this._FlowView) return;

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._onNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._onPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._onHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._onConnectionDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._onPanelResize(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_NODE:
				this._onNodeResize(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_FRAME:
				this._onFrameResize(pEvent);
				break;

			case INTERACTION_STATES.MOVING_FRAME:
				this._onFrameMove(pEvent);
				break;

			case INTERACTION_STATES.ROTATING_NODE:
				this._onNodeRotate(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._onPan(pEvent);
				break;

			case INTERACTION_STATES.MARQUEE:
				this._onMarquee(pEvent);
				break;
		}
	}

	/**
	 * Handle pointer up event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerUp(pEvent)
	{
		if (!this._FlowView) return;

		// Release pointer capture
		if (this._SVGElement.hasPointerCapture && this._SVGElement.hasPointerCapture(pEvent.pointerId))
		{
			this._SVGElement.releasePointerCapture(pEvent.pointerId);
		}

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._endNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._endPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._endHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._endPanelResize(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_NODE:
				this._endNodeResize(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_FRAME:
			case INTERACTION_STATES.MOVING_FRAME:
				this._endFrameEdit(pEvent);
				break;

			case INTERACTION_STATES.ROTATING_NODE:
				this._endNodeRotate(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._endConnection(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._endPanning(pEvent);
				break;

			case INTERACTION_STATES.MARQUEE:
				this._endMarquee(pEvent);
				break;
		}
	}

	/**
	 * Decide what a wheel event should do, from config and modifier keys. Pure
	 * (no DOM, no side effects) so it is unit testable.
	 *
	 * WheelMode 'zoom' (default): wheel zooms; if WheelZoomRequiresModifier is on,
	 *   a plain wheel pans and ctrl/cmd+wheel zooms.
	 * WheelMode 'pan': wheel pans; ctrl/cmd+wheel zooms.
	 * WheelMode 'none': flow ignores the wheel (page scrolls).
	 *
	 * Zoom is gated by EnableZooming and pan by EnablePanning; when the intended
	 * action is disabled the result is 'none' (matching the legacy early return
	 * when zooming was off).
	 *
	 * @param {WheelEvent} pEvent
	 * @returns {{action: string}} action is 'zoom' | 'pan' | 'none'
	 */
	_resolveWheelAction(pEvent)
	{
		let tmpOptions = (this._FlowView && this._FlowView.options) ? this._FlowView.options : {};

		// Read-only has its own wheel policy: by default the wheel scrolls the page
		// (the canvas is static content); only when navigation is toggled on (the
		// hand toggle) does the wheel zoom the canvas.
		if (this._isReadOnly())
		{
			return { action: this._isReadOnlyNavigating() ? 'zoom' : 'none' };
		}

		let tmpWheelMode = tmpOptions.WheelMode || 'zoom';

		if (tmpWheelMode === 'none')
		{
			return { action: 'none' };
		}

		let tmpModifier = !!(pEvent && (pEvent.ctrlKey || pEvent.metaKey));

		let tmpWantZoom;
		if (tmpWheelMode === 'pan')
		{
			tmpWantZoom = tmpModifier;
		}
		else
		{
			tmpWantZoom = tmpOptions.WheelZoomRequiresModifier ? tmpModifier : true;
		}

		if (tmpWantZoom)
		{
			return { action: tmpOptions.EnableZooming ? 'zoom' : 'none' };
		}

		return { action: (tmpOptions.EnablePanning === false) ? 'none' : 'pan' };
	}

	/**
	 * Handle mouse wheel: zoom toward the pointer, pan the canvas, or ignore,
	 * per _resolveWheelAction.
	 * @param {WheelEvent} pEvent
	 */
	_onWheel(pEvent)
	{
		if (!this._FlowView) return;

		let tmpResolved = this._resolveWheelAction(pEvent);
		if (tmpResolved.action === 'none') return;

		pEvent.preventDefault();

		let tmpOptions = this._FlowView.options;

		if (tmpResolved.action === 'zoom')
		{
			let tmpSensitivity = (typeof tmpOptions.WheelZoomSensitivity === 'number') ? tmpOptions.WheelZoomSensitivity : 1;
			let tmpStep = tmpOptions.ZoomStep * tmpSensitivity;
			let tmpDelta = pEvent.deltaY > 0 ? -tmpStep : tmpStep;
			let tmpNewZoom = this._FlowView.viewState.Zoom + tmpDelta;

			// Zoom toward mouse position
			let tmpRect = this._SVGElement.getBoundingClientRect();
			let tmpMouseX = pEvent.clientX - tmpRect.left;
			let tmpMouseY = pEvent.clientY - tmpRect.top;

			this._FlowView.setZoom(tmpNewZoom, tmpMouseX, tmpMouseY);
			return;
		}

		// Pan: wheel scrolls the canvas. Shift+wheel commonly arrives as deltaX.
		let tmpPanSensitivity = (typeof tmpOptions.WheelPanSensitivity === 'number') ? tmpOptions.WheelPanSensitivity : 1;
		if (this._FlowView._ViewportManager && typeof this._FlowView._ViewportManager.panBy === 'function')
		{
			this._FlowView._ViewportManager.panBy(-pEvent.deltaX * tmpPanSensitivity, -pEvent.deltaY * tmpPanSensitivity);
		}
	}

	/**
	 * Handle keyboard events
	 * @param {KeyboardEvent} pEvent
	 */
	_onKeyDown(pEvent)
	{
		if (!this._FlowView) return;

		// Only handle events when the flow is focused/visible
		if (pEvent.key === 'Delete' || pEvent.key === 'Backspace')
		{
			// No deletion in read-only mode.
			if (this._isReadOnly()) return;

			// Don't delete if user is typing in an input or inside a panel
			if (pEvent.target && (pEvent.target.tagName === 'INPUT' || pEvent.target.tagName === 'TEXTAREA' || pEvent.target.tagName === 'SELECT'))
			{
				return;
			}
			if (pEvent.target && pEvent.target.closest && pEvent.target.closest('.pict-flow-panel'))
			{
				return;
			}

			this._FlowView.deleteSelected();
			pEvent.preventDefault();
		}
		else if (pEvent.key === 'Escape')
		{
			if (this._State === INTERACTION_STATES.CONNECTING)
			{
				this._cancelConnection();
			}

			// Exit fullscreen if currently in fullscreen mode
			if (this._FlowView._IsFullscreen)
			{
				this._FlowView.exitFullscreen();
				// Update the toolbar button text
				if (this._FlowView._ToolbarView)
				{
					let tmpFlowViewIdentifier = this._FlowView.options.ViewIdentifier;
					let tmpBtnElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpBtnElements.length > 0)
					{
						tmpBtnElements[0].innerHTML = '&#x26F6; Fullscreen';
					}
				}
				pEvent.preventDefault();
				return;
			}

			this._FlowView.deselectAll();
		}
	}

	// ---- Node Dragging ----

	_startNodeDrag(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableNodeDragging) return;

		let tmpNodeHash = this._getNodeHash(pTarget);
		if (!tmpNodeHash) return;

		// If the grabbed node is part of a multi-selection, drag the whole set; otherwise select just
		// it. (Grabbing a node outside the current selection collapses to that single node.)
		let tmpSelected = this._FlowView.getSelectedNodeHashes ? this._FlowView.getSelectedNodeHashes() : [];
		let tmpIsMulti = this._FlowView.options.EnableMultiSelect && tmpSelected.length > 1 && tmpSelected.indexOf(tmpNodeHash) >= 0;
		if (!tmpIsMulti)
		{
			this._FlowView.selectNode(tmpNodeHash);
			tmpSelected = [tmpNodeHash];
		}

		// Capture each dragged node's start position so one delta applies to all of them.
		this._DragNodes = [];
		for (let i = 0; i < tmpSelected.length; i++)
		{
			let tmpN = this._FlowView.getNode(tmpSelected[i]);
			if (tmpN) { this._DragNodes.push({ Hash: tmpN.Hash, StartX: tmpN.X, StartY: tmpN.Y }); }
		}
		if (this._DragNodes.length === 0) return;

		this._setState(INTERACTION_STATES.DRAGGING_NODE);
		this._DragNodeHash = tmpNodeHash;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;

		for (let i = 0; i < this._DragNodes.length; i++)
		{
			let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${this._DragNodes[i].Hash}"]`);
			if (tmpNodeGroup) { tmpNodeGroup.classList.add('dragging'); }
		}
	}

	_onNodeDrag(pEvent)
	{
		if (!this._DragNodes || this._DragNodes.length === 0) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragStartY) / tmpVS.Zoom;

		// A single-node drag can show alignment guides and snap to other nodes' edges/centers.
		// Multi-drag keeps the rigid group offset (aligning a moving group is ambiguous).
		if (this._DragNodes.length === 1 && this._FlowView.options.EnableAlignmentGuides)
		{
			let tmpHash = this._DragNodes[0].Hash;
			let tmpNode = this._FlowView.getNode(tmpHash);
			let tmpX = this._snapToGrid(this._DragNodes[0].StartX + tmpDX);
			let tmpY = this._snapToGrid(this._DragNodes[0].StartY + tmpDY);
			if (tmpNode)
			{
				let tmpAlign = this._alignmentFor(tmpNode, tmpX, tmpY);
				this._drawGuides(tmpAlign.Guides);
				this._FlowView.updateNodePosition(tmpHash, tmpAlign.X, tmpAlign.Y);
				return;
			}
		}

		for (let i = 0; i < this._DragNodes.length; i++)
		{
			let tmpNewX = this._snapToGrid(this._DragNodes[i].StartX + tmpDX);
			let tmpNewY = this._snapToGrid(this._DragNodes[i].StartY + tmpDY);
			this._FlowView.updateNodePosition(this._DragNodes[i].Hash, tmpNewX, tmpNewY);
		}
	}

	// ---- Alignment guides (single-node drag) ----
	// Compare the dragged node's six reference lines (left / center-x / right and top / center-y /
	// bottom) against every other node's. Within a small threshold the dragged node snaps so the lines
	// coincide, and a guide line is reported spanning both nodes. Returns the (possibly snapped)
	// position plus the guides to draw; a pure computation so it can be unit-tested without a DOM.
	_alignmentFor(pDragNode, pX, pY)
	{
		let tmpZoom = (this._FlowView.viewState && this._FlowView.viewState.Zoom) ? this._FlowView.viewState.Zoom : 1;
		let tmpThreshold = 6 / tmpZoom;
		let tmpDefaultW = this._FlowView.options.DefaultNodeWidth || 180;
		let tmpDefaultH = this._FlowView.options.DefaultNodeHeight || 80;
		let tmpW = (typeof pDragNode.Width === 'number') ? pDragNode.Width : tmpDefaultW;
		let tmpH = (typeof pDragNode.Height === 'number') ? pDragNode.Height : tmpDefaultH;

		let tmpDragV = [ pX, pX + tmpW / 2, pX + tmpW ];   // left, center-x, right
		let tmpDragH = [ pY, pY + tmpH / 2, pY + tmpH ];   // top, center-y, bottom

		let tmpBestV = null;
		let tmpBestH = null;
		let tmpNodes = this._FlowView._FlowData.Nodes || [];

		for (let i = 0; i < tmpNodes.length; i++)
		{
			let tmpO = tmpNodes[i];
			if (tmpO.Hash === pDragNode.Hash) continue;
			let tmpOW = (typeof tmpO.Width === 'number') ? tmpO.Width : tmpDefaultW;
			let tmpOH = (typeof tmpO.Height === 'number') ? tmpO.Height : tmpDefaultH;
			let tmpOtherV = [ tmpO.X, tmpO.X + tmpOW / 2, tmpO.X + tmpOW ];
			let tmpOtherH = [ tmpO.Y, tmpO.Y + tmpOH / 2, tmpO.Y + tmpOH ];

			for (let a = 0; a < tmpDragV.length; a++)
			{
				for (let b = 0; b < tmpOtherV.length; b++)
				{
					let tmpD = Math.abs(tmpDragV[a] - tmpOtherV[b]);
					if (tmpD <= tmpThreshold && (!tmpBestV || tmpD < tmpBestV.Delta))
					{
						tmpBestV = { Delta: tmpD, Pos: tmpOtherV[b], SnapX: pX + (tmpOtherV[b] - tmpDragV[a]), OtherTop: tmpO.Y, OtherBottom: tmpO.Y + tmpOH };
					}
				}
			}
			for (let a = 0; a < tmpDragH.length; a++)
			{
				for (let b = 0; b < tmpOtherH.length; b++)
				{
					let tmpD = Math.abs(tmpDragH[a] - tmpOtherH[b]);
					if (tmpD <= tmpThreshold && (!tmpBestH || tmpD < tmpBestH.Delta))
					{
						tmpBestH = { Delta: tmpD, Pos: tmpOtherH[b], SnapY: pY + (tmpOtherH[b] - tmpDragH[a]), OtherLeft: tmpO.X, OtherRight: tmpO.X + tmpOW };
					}
				}
			}
		}

		let tmpResult = { X: pX, Y: pY, Guides: [] };
		if (tmpBestV)
		{
			tmpResult.X = tmpBestV.SnapX;
			tmpResult.Guides.push({ Type: 'v', Pos: tmpBestV.Pos, A: Math.min(tmpResult.Y, tmpBestV.OtherTop), B: Math.max(tmpResult.Y + tmpH, tmpBestV.OtherBottom) });
		}
		if (tmpBestH)
		{
			tmpResult.Y = tmpBestH.SnapY;
			tmpResult.Guides.push({ Type: 'h', Pos: tmpBestH.Pos, A: Math.min(tmpResult.X, tmpBestH.OtherLeft), B: Math.max(tmpResult.X + tmpW, tmpBestH.OtherRight) });
		}
		return tmpResult;
	}

	_drawGuides(pGuides)
	{
		this._clearGuides();
		if (!pGuides || pGuides.length === 0 || !this._FlowView._ViewportElement) return;
		this._GuideElements = [];
		for (let i = 0; i < pGuides.length; i++)
		{
			let tmpG = pGuides[i];
			let tmpLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
			tmpLine.setAttribute('class', 'pict-flow-align-guide');
			if (tmpG.Type === 'v') { tmpLine.setAttribute('x1', tmpG.Pos); tmpLine.setAttribute('x2', tmpG.Pos); tmpLine.setAttribute('y1', tmpG.A); tmpLine.setAttribute('y2', tmpG.B); }
			else { tmpLine.setAttribute('y1', tmpG.Pos); tmpLine.setAttribute('y2', tmpG.Pos); tmpLine.setAttribute('x1', tmpG.A); tmpLine.setAttribute('x2', tmpG.B); }
			this._FlowView._ViewportElement.appendChild(tmpLine);
			this._GuideElements.push(tmpLine);
		}
	}

	_clearGuides()
	{
		if (this._GuideElements)
		{
			for (let i = 0; i < this._GuideElements.length; i++)
			{
				let tmpEl = this._GuideElements[i];
				if (tmpEl.parentNode) { tmpEl.parentNode.removeChild(tmpEl); }
			}
		}
		this._GuideElements = null;
	}

	// Snap a coordinate or size to the grid when the flow has EnableGridSnap on; otherwise pass through.
	_snapToGrid(pValue)
	{
		if (!this._FlowView.options.EnableGridSnap) { return pValue; }
		// A defined GridSnapSize of 0 means "no snap"; only an absent size falls back to the default.
		let tmpGrid = (typeof this._FlowView.options.GridSnapSize === 'number') ? this._FlowView.options.GridSnapSize : 20;
		if (tmpGrid <= 0) { return pValue; }
		return Math.round(pValue / tmpGrid) * tmpGrid;
	}

	_endNodeDrag(pEvent)
	{		this._clearGuides();

		let tmpDragged = this._DragNodes || [];
		for (let i = 0; i < tmpDragged.length; i++)
		{
			let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${tmpDragged[i].Hash}"]`);
			if (tmpNodeGroup) { tmpNodeGroup.classList.remove('dragging'); }
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			for (let i = 0; i < tmpDragged.length; i++)
			{
				let tmpNode = this._FlowView.getNode(tmpDragged[i].Hash);
				if (tmpNode) { this._FlowView._EventHandlerProvider.fireEvent('onNodeMoved', tmpNode); }
			}
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._setState(INTERACTION_STATES.IDLE);
		this._DragNodeHash = null;
		this._DragNodes = null;
	}

	// ---- Panel Dragging ----

	// Toggle a "gesture in progress" marker on a panel's foreignObject. The panel CSS drops the
	// panel box-shadow while this class is present: dragging/resizing rewrites the foreignObject
	// geometry every pointermove, and the shadow (which bleeds outside the foreignObject box) would
	// otherwise be smeared in place at each old position. No shadow during the gesture means none to
	// leave behind; it returns when the class is removed at the end of the drag.
	_setPanelGestureActive(pPanelHash, pIsActive)
	{
		if (!pPanelHash || !this._FlowView || !this._FlowView._PanelsLayer) { return; }
		let tmpForeignObject = this._FlowView._PanelsLayer.querySelector('[data-panel-hash="' + pPanelHash + '"]');
		if (!tmpForeignObject) { return; }
		if (pIsActive) { tmpForeignObject.classList.add('pict-flow-panel-dragging'); }
		else { tmpForeignObject.classList.remove('pict-flow-panel-dragging'); }
	}

	_startPanelDrag(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._setState(INTERACTION_STATES.DRAGGING_PANEL);
		this._DragPanelHash = tmpPanelHash;
		this._DragPanelStartX = pEvent.clientX;
		this._DragPanelStartY = pEvent.clientY;
		this._DragPanelDataStartX = tmpPanel.X;
		this._DragPanelDataStartY = tmpPanel.Y;
		this._setPanelGestureActive(tmpPanelHash, true);
	}

	_onPanelDrag(pEvent)
	{
		if (!this._DragPanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragPanelStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragPanelStartY) / tmpVS.Zoom;

		let tmpNewX = this._DragPanelDataStartX + tmpDX;
		let tmpNewY = this._DragPanelDataStartY + tmpDY;

		this._FlowView.updatePanelPosition(this._DragPanelHash, tmpNewX, tmpNewY);
	}

	_endPanelDrag(pEvent)
	{
		this._FlowView.marshalFromView();

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragPanelHash);
		if (tmpPanel && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelMoved', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._setPanelGestureActive(this._DragPanelHash, false);
		this._setState(INTERACTION_STATES.IDLE);
		this._DragPanelHash = null;
	}

	// ---- Panel Resizing ----

	_startPanelResize(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._setState(INTERACTION_STATES.RESIZING_PANEL);
		this._ResizePanelHash = tmpPanelHash;
		this._ResizeStartY = pEvent.clientY;
		this._ResizePanelStartHeight = tmpPanel.Height;
		this._setPanelGestureActive(tmpPanelHash, true);
	}

	_onPanelResize(pEvent)
	{
		if (!this._ResizePanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDY = (pEvent.clientY - this._ResizeStartY) / tmpVS.Zoom;
		let tmpNewHeight = Math.max(120, this._ResizePanelStartHeight + tmpDY);

		// Update the panel data
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._ResizePanelHash);
		if (tmpPanel)
		{
			tmpPanel.Height = tmpNewHeight;
		}

		// Update the foreignObject height directly for smooth resizing
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector('[data-panel-hash="' + this._ResizePanelHash + '"]');
			if (tmpFO)
			{
				tmpFO.setAttribute('height', String(tmpNewHeight));
			}
		}
	}

	_endPanelResize(pEvent)
	{
		// Re-render to sync tethers
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._setPanelGestureActive(this._ResizePanelHash, false);
		this._setState(INTERACTION_STATES.IDLE);
		this._ResizePanelHash = null;
	}

	// ---- Node Resizing ----
	// Drag the bottom-right handle (rendered on the selected node when the flow's
	// EnableNodeResizing option is on) to set Width/Height. Deltas are divided by the
	// zoom so the corner tracks the pointer at any zoom level.

	_startNodeResize(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableNodeResizing) return;

		let tmpNodeHash = this._getNodeHash(pTarget);
		if (!tmpNodeHash) return;

		let tmpNode = this._FlowView.getNode(tmpNodeHash);
		if (!tmpNode) return;

		this._setState(INTERACTION_STATES.RESIZING_NODE);
		this._ResizeNodeHash = tmpNodeHash;
		this._ResizeNodeStartX = pEvent.clientX;
		this._ResizeNodeStartY = pEvent.clientY;
		this._ResizeNodeStartWidth = tmpNode.Width || 180;
		this._ResizeNodeStartHeight = tmpNode.Height || 80;
		if (pEvent.stopPropagation) pEvent.stopPropagation();
	}

	_onNodeResize(pEvent)
	{
		if (!this._ResizeNodeHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._ResizeNodeStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._ResizeNodeStartY) / tmpVS.Zoom;

		let tmpMinW = this._FlowView.options.MinimumNodeWidth || 48;
		let tmpMinH = this._FlowView.options.MinimumNodeHeight || 32;

		let tmpNode = this._FlowView.getNode(this._ResizeNodeHash);
		if (!tmpNode) return;

		tmpNode.Width = Math.max(tmpMinW, this._snapToGrid(Math.round(this._ResizeNodeStartWidth + tmpDX)));
		tmpNode.Height = Math.max(tmpMinH, this._snapToGrid(Math.round(this._ResizeNodeStartHeight + tmpDY)));

		// Re-render so the body (and any HTML/image content) reflows to the new size.
		this._FlowView.renderFlow();
	}

	_endNodeResize(pEvent)
	{
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		let tmpNode = this._FlowView.getNode(this._ResizeNodeHash);
		if (tmpNode && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeResized', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._setState(INTERACTION_STATES.IDLE);
		this._ResizeNodeHash = null;
	}

	// ---- Content-frame editing (drag the view-area box) ----

	_startFrameResize(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableFrameEditing) return;
		let tmpFrame = this._FlowView._resolveFrame();
		if (!tmpFrame) return;

		this._setState(INTERACTION_STATES.RESIZING_FRAME);
		this._FrameDragEdge = (pTarget && pTarget.getAttribute) ? pTarget.getAttribute('data-frame-edge') : null;
		this._FrameStart = { X: tmpFrame.X || 0, Y: tmpFrame.Y || 0, Width: tmpFrame.Width, Height: tmpFrame.Height };
		this._FrameStartPointerX = pEvent.clientX;
		this._FrameStartPointerY = pEvent.clientY;
		if (pEvent.stopPropagation) pEvent.stopPropagation();
	}

	_startFrameMove(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableFrameEditing) return;
		let tmpFrame = this._FlowView._resolveFrame();
		if (!tmpFrame) return;

		this._setState(INTERACTION_STATES.MOVING_FRAME);
		this._FrameStart = { X: tmpFrame.X || 0, Y: tmpFrame.Y || 0, Width: tmpFrame.Width, Height: tmpFrame.Height };
		this._FrameStartPointerX = pEvent.clientX;
		this._FrameStartPointerY = pEvent.clientY;
		if (pEvent.stopPropagation) pEvent.stopPropagation();
	}

	_onFrameResize(pEvent)
	{
		if (!this._FrameStart) return;
		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._FrameStartPointerX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._FrameStartPointerY) / tmpVS.Zoom;
		let tmpMin = this._FlowView.options.MinimumFrameSize || 40;
		this._applyFrameEdit(PictServiceFlowInteractionManager.computeFrameResize(this._FrameStart, this._FrameDragEdge, tmpDX, tmpDY, tmpMin));
	}

	_onFrameMove(pEvent)
	{
		if (!this._FrameStart) return;
		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._FrameStartPointerX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._FrameStartPointerY) / tmpVS.Zoom;
		this._applyFrameEdit(
			{
				X: Math.round(this._FrameStart.X + tmpDX),
				Y: Math.round(this._FrameStart.Y + tmpDY),
				Width: this._FrameStart.Width,
				Height: this._FrameStart.Height
			});
	}

	_applyFrameEdit(pBox)
	{
		let tmpFrame = this._FlowView._resolveFrame();
		if (!tmpFrame) return;
		tmpFrame.X = pBox.X;
		tmpFrame.Y = pBox.Y;
		tmpFrame.Width = pBox.Width;
		tmpFrame.Height = pBox.Height;
		this._FlowView._applyFrame();
	}

	_endFrameEdit(pEvent)
	{
		let tmpFrame = this._FlowView._resolveFrame();
		this._FlowView._applyFrame();
		if (typeof this._FlowView.marshalFromView === 'function') this._FlowView.marshalFromView();
		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFrameChanged', tmpFrame);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
		this._setState(INTERACTION_STATES.IDLE);
		this._FrameDragEdge = null;
		this._FrameStart = null;
	}

	/**
	 * Pure box-resize math for the content frame: given the starting box, which edge is being
	 * dragged ('n'|'e'|'s'|'w'), and the pointer delta in content units, return the new box,
	 * clamped to a minimum size with the opposite edge held fixed. Unit tested without a DOM.
	 * @param {Object} pStart - { X, Y, Width, Height }
	 * @param {string} pEdge
	 * @param {number} pDX
	 * @param {number} pDY
	 * @param {number} [pMinSize]
	 * @returns {{X:number, Y:number, Width:number, Height:number}}
	 */
	static computeFrameResize(pStart, pEdge, pDX, pDY, pMinSize)
	{
		let tmpMin = (typeof pMinSize === 'number') ? pMinSize : 40;
		let tmpX = pStart.X;
		let tmpY = pStart.Y;
		let tmpW = pStart.Width;
		let tmpH = pStart.Height;
		switch (pEdge)
		{
			case 'n':
			{
				let tmpNewY = pStart.Y + pDY;
				let tmpNewH = pStart.Height - pDY;
				if (tmpNewH < tmpMin) { tmpNewY = pStart.Y + (pStart.Height - tmpMin); tmpNewH = tmpMin; }
				tmpY = Math.round(tmpNewY);
				tmpH = Math.round(tmpNewH);
				break;
			}
			case 's':
				tmpH = Math.round(Math.max(tmpMin, pStart.Height + pDY));
				break;
			case 'e':
				tmpW = Math.round(Math.max(tmpMin, pStart.Width + pDX));
				break;
			case 'w':
			{
				let tmpNewX = pStart.X + pDX;
				let tmpNewW = pStart.Width - pDX;
				if (tmpNewW < tmpMin) { tmpNewX = pStart.X + (pStart.Width - tmpMin); tmpNewW = tmpMin; }
				tmpX = Math.round(tmpNewX);
				tmpW = Math.round(tmpNewW);
				break;
			}
		}
		return { X: tmpX, Y: tmpY, Width: tmpW, Height: tmpH };
	}

	// ---- Node Rotation ----
	// Drag the grip on the arm above the selected node (rendered when EnableNodeRotation is on) to set
	// the node's Rotation in degrees: the card's top points toward the pointer. Hold Shift to snap to 15
	// degrees. The properties-panel rotation control still works; this is just a second, inline way.

	_startNodeRotate(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableNodeRotation) return;
		if (this._isReadOnly()) return;

		let tmpNodeHash = this._getNodeHash(pTarget);
		if (!tmpNodeHash) return;
		if (!this._FlowView.getNode(tmpNodeHash)) return;

		this._setState(INTERACTION_STATES.ROTATING_NODE);
		this._RotateNodeHash = tmpNodeHash;
		if (pEvent.stopPropagation) pEvent.stopPropagation();
	}

	_onNodeRotate(pEvent)
	{
		if (!this._RotateNodeHash) return;

		let tmpNode = this._FlowView.getNode(this._RotateNodeHash);
		if (!tmpNode) return;

		let tmpCenterX = (tmpNode.X || 0) + (tmpNode.Width || 0) / 2;
		let tmpCenterY = (tmpNode.Y || 0) + (tmpNode.Height || 0) / 2;

		// Pointer in content (SVG) space so pan/zoom do not skew the angle.
		let tmpPoint = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		let tmpAngle = (Math.atan2(tmpPoint.y - tmpCenterY, tmpPoint.x - tmpCenterX) * 180 / Math.PI) + 90;

		// Shift snaps to 15-degree increments.
		if (pEvent.shiftKey) { tmpAngle = Math.round(tmpAngle / 15) * 15; }

		// Normalize to [0, 360).
		tmpAngle = ((Math.round(tmpAngle) % 360) + 360) % 360;
		tmpNode.Rotation = tmpAngle;

		this._FlowView.renderFlow();
	}

	_endNodeRotate(pEvent)
	{
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		let tmpNode = this._FlowView.getNode(this._RotateNodeHash);
		if (tmpNode && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeRotated', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._setState(INTERACTION_STATES.IDLE);
		this._RotateNodeHash = null;
	}

	// ---- Handle Dragging ----

	_startHandleDrag(pEvent, pConnectionHash, pPanelHash, pHandleType, pIsTether)
	{
		this._setState(INTERACTION_STATES.DRAGGING_HANDLE);
		this._DragHandleConnectionHash = pConnectionHash;
		this._DragHandlePanelHash = pPanelHash;
		this._DragHandleType = pHandleType;
		this._DragHandleIsTether = pIsTether;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;	}

	_onHandleDrag(pEvent)
	{
		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		if (this._DragHandleIsTether)
		{
			this._FlowView.updateTetherHandle(
				this._DragHandlePanelHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
		else
		{
			this._FlowView.updateConnectionHandle(
				this._DragHandleConnectionHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
	}

	_endHandleDrag(pEvent)
	{
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);

			if (this._DragHandleIsTether)
			{
				let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragHandlePanelHash);
				if (tmpPanel)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onTetherHandleMoved', tmpPanel);
				}
			}
			else
			{
				let tmpConnection = this._FlowView.getConnection(this._DragHandleConnectionHash);
				if (tmpConnection)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onConnectionHandleMoved', tmpConnection);
				}
			}
		}

		this._setState(INTERACTION_STATES.IDLE);
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;
	}

	// ---- Right-Click Handle Add/Remove ----

	/**
	 * Add a bezier handle to a connection at the right-click position.
	 * @param {Element} pTarget - The SVG element that was right-clicked
	 * @param {MouseEvent} pEvent - The contextmenu event
	 */
	_addBezierHandle(pTarget, pEvent)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		// Select the connection so handle circles are rendered after the re-render
		this._FlowView.selectConnection(tmpConnectionHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addConnectionHandle(tmpConnectionHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a connection.
	 * @param {Element} pTarget - The handle SVG element that was right-clicked
	 */
	_removeBezierHandle(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeConnectionHandle(tmpConnectionHash, tmpIndex);
	}

	/**
	 * Add a bezier handle to a tether.
	 * @param {Element} pTarget - The tether SVG element that was right-clicked or double-clicked
	 * @param {Event} pEvent - The mouse event (for coordinate extraction)
	 */
	_addTetherBezierHandle(pTarget, pEvent)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		// Select the tether so handles render after re-render
		this._FlowView.selectTether(tmpPanelHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addTetherHandle(tmpPanelHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a tether.
	 * @param {Element} pTarget - The tether handle SVG element that was right-clicked
	 */
	_removeTetherBezierHandle(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeTetherHandle(tmpPanelHash, tmpIndex);
	}

	// ---- Line Mode Toggling ----

	_toggleConnectionLineMode(pConnectionHash)
	{
		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};

		let tmpCurrentMode = tmpConnection.Data.LineMode || 'bezier';
		tmpConnection.Data.LineMode = (tmpCurrentMode === 'bezier') ? 'orthogonal' : 'bezier';

		// Reset handle positions when switching modes
		tmpConnection.Data.HandleCustomized = false;
		tmpConnection.Data.BezierHandles = [];
		tmpConnection.Data.BezierHandleX = null;
		tmpConnection.Data.BezierHandleY = null;
		tmpConnection.Data.OrthoCorner1X = null;
		tmpConnection.Data.OrthoCorner1Y = null;
		tmpConnection.Data.OrthoCorner2X = null;
		tmpConnection.Data.OrthoCorner2Y = null;
		tmpConnection.Data.OrthoMidOffset = 0;

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionModeChanged', tmpConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	_toggleTetherLineMode(pPanelHash)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.toggleLineMode(tmpPanel);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onTetherModeChanged', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	// ---- Tether Selection ----

	_selectTether(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (tmpPanelHash)
		{
			this._FlowView.selectTether(tmpPanelHash);
		}
	}

	// ---- Connection Creation ----

	_startConnection(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableConnectionCreation) return;

		let tmpNodeHash = pTarget.getAttribute('data-node-hash');
		let tmpPortHash = pTarget.getAttribute('data-port-hash');
		let tmpPortDirection = pTarget.getAttribute('data-port-direction');

		if (!tmpNodeHash || !tmpPortHash) return;

		// A connection normally starts from an output port; undirected mode lets any port start one.
		if (!this._FlowView.options.EnableUndirectedConnections && tmpPortDirection !== 'output')
		{
			return;
		}

		this._setState(INTERACTION_STATES.CONNECTING);
		this._ConnectSourceNodeHash = tmpNodeHash;
		this._ConnectSourcePortHash = tmpPortHash;

		let tmpPortPos = this._FlowView.getPortPosition(tmpNodeHash, tmpPortHash);
		if (tmpPortPos)
		{
			this._ConnectDragLine = document.createElementNS('http://www.w3.org/2000/svg', 'path');
			this._ConnectDragLine.setAttribute('class', 'pict-flow-drag-connection');
			this._ConnectDragLine.setAttribute('d', `M ${tmpPortPos.x} ${tmpPortPos.y} L ${tmpPortPos.x} ${tmpPortPos.y}`);
			this._FlowView._ViewportElement.appendChild(this._ConnectDragLine);
		}

		pEvent.stopPropagation();
	}

	_onConnectionDrag(pEvent)
	{
		if (!this._ConnectDragLine) return;

		let tmpSourcePos = this._FlowView.getPortPosition(this._ConnectSourceNodeHash, this._ConnectSourcePortHash);
		if (!tmpSourcePos) return;

		let tmpEndCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		let tmpDX = Math.abs(tmpEndCoords.x - tmpSourcePos.x) * 0.5;
		let tmpPath = `M ${tmpSourcePos.x} ${tmpSourcePos.y} C ${tmpSourcePos.x + tmpDX} ${tmpSourcePos.y}, ${tmpEndCoords.x - tmpDX} ${tmpEndCoords.y}, ${tmpEndCoords.x} ${tmpEndCoords.y}`;
		this._ConnectDragLine.setAttribute('d', tmpPath);
	}

	_endConnection(pEvent)
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		let tmpTarget = document.elementFromPoint(pEvent.clientX, pEvent.clientY);
		if (tmpTarget)
		{
			let tmpTargetPortHash = tmpTarget.getAttribute('data-port-hash');
			let tmpTargetNodeHash = tmpTarget.getAttribute('data-node-hash');
			let tmpTargetPortDirection = tmpTarget.getAttribute('data-port-direction');

			// A connection normally completes on an input port; undirected mode lets any port receive it.
			if (tmpTargetPortHash && tmpTargetNodeHash && (this._FlowView.options.EnableUndirectedConnections || tmpTargetPortDirection === 'input'))
			{
				this._FlowView.addConnection(
					this._ConnectSourceNodeHash,
					this._ConnectSourcePortHash,
					tmpTargetNodeHash,
					tmpTargetPortHash
				);
			}
		}

		this._setState(INTERACTION_STATES.IDLE);
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	_cancelConnection()
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		this._setState(INTERACTION_STATES.IDLE);
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	// ---- Panning ----

	_startPanning(pEvent)
	{
		this._FlowView.deselectAll();

		this._setState(INTERACTION_STATES.PANNING);
		this._PanStartX = pEvent.clientX;
		this._PanStartY = pEvent.clientY;
		this._PanStartPanX = this._FlowView.viewState.PanX;
		this._PanStartPanY = this._FlowView.viewState.PanY;
	}

	_onPan(pEvent)
	{
		let tmpDX = pEvent.clientX - this._PanStartX;
		let tmpDY = pEvent.clientY - this._PanStartY;

		this._FlowView.viewState.PanX = this._PanStartPanX + tmpDX;
		this._FlowView.viewState.PanY = this._PanStartPanY + tmpDY;

		this._FlowView.updateViewportTransform();
	}

	_endPanning(pEvent)
	{		this._setState(INTERACTION_STATES.IDLE);
	}

	// ---- Marquee selection (multi-select) ----
	// A rubber-band rectangle drawn in world coordinates (inside the transformed viewport group), so it
	// tracks the nodes under it regardless of pan/zoom. On release every node whose box intersects the
	// rectangle is selected; a rectangle too small to be a deliberate drag is treated as a click that
	// clears the selection.

	_startMarquee(pEvent)
	{
		let tmpStart = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._MarqueeStartX = tmpStart.x;
		this._MarqueeStartY = tmpStart.y;
		this._MarqueeCurrentX = tmpStart.x;
		this._MarqueeCurrentY = tmpStart.y;
		this._setState(INTERACTION_STATES.MARQUEE);

		let tmpRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
		tmpRect.setAttribute('class', 'pict-flow-marquee');
		tmpRect.setAttribute('x', tmpStart.x);
		tmpRect.setAttribute('y', tmpStart.y);
		tmpRect.setAttribute('width', 0);
		tmpRect.setAttribute('height', 0);
		this._MarqueeElement = tmpRect;
		if (this._FlowView._ViewportElement) { this._FlowView._ViewportElement.appendChild(tmpRect); }
	}

	_onMarquee(pEvent)
	{
		if (!this._MarqueeElement) return;
		let tmpCur = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._MarqueeCurrentX = tmpCur.x;
		this._MarqueeCurrentY = tmpCur.y;
		let tmpX = Math.min(this._MarqueeStartX, tmpCur.x);
		let tmpY = Math.min(this._MarqueeStartY, tmpCur.y);
		this._MarqueeElement.setAttribute('x', tmpX);
		this._MarqueeElement.setAttribute('y', tmpY);
		this._MarqueeElement.setAttribute('width', Math.abs(tmpCur.x - this._MarqueeStartX));
		this._MarqueeElement.setAttribute('height', Math.abs(tmpCur.y - this._MarqueeStartY));
	}

	_endMarquee(pEvent)
	{
		let tmpX = Math.min(this._MarqueeStartX, this._MarqueeCurrentX);
		let tmpY = Math.min(this._MarqueeStartY, this._MarqueeCurrentY);
		let tmpW = Math.abs(this._MarqueeCurrentX - this._MarqueeStartX);
		let tmpH = Math.abs(this._MarqueeCurrentY - this._MarqueeStartY);

		if (this._MarqueeElement && this._MarqueeElement.parentNode)
		{
			this._MarqueeElement.parentNode.removeChild(this._MarqueeElement);
		}
		this._MarqueeElement = null;
		this._setState(INTERACTION_STATES.IDLE);

		// Too small to be a deliberate drag: treat as a background click and clear the selection.
		if (tmpW < 4 && tmpH < 4)
		{
			this._FlowView.deselectAll();
			return;
		}

		let tmpHits = [];
		let tmpNodes = this._FlowView._FlowData.Nodes || [];
		let tmpDefaultW = this._FlowView.options.DefaultNodeWidth || 180;
		let tmpDefaultH = this._FlowView.options.DefaultNodeHeight || 80;
		for (let i = 0; i < tmpNodes.length; i++)
		{
			let tmpN = tmpNodes[i];
			let tmpNW = (typeof tmpN.Width === 'number') ? tmpN.Width : tmpDefaultW;
			let tmpNH = (typeof tmpN.Height === 'number') ? tmpN.Height : tmpDefaultH;
			let tmpIntersects = !(tmpN.X > tmpX + tmpW || (tmpN.X + tmpNW) < tmpX || tmpN.Y > tmpY + tmpH || (tmpN.Y + tmpNH) < tmpY);
			if (tmpIntersects) { tmpHits.push(tmpN.Hash); }
		}
		this._FlowView.selectNodes(tmpHits);
	}

	// ---- Connection Selection ----

	_selectConnection(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (tmpConnectionHash)
		{
			this._FlowView.selectConnection(tmpConnectionHash);
		}
	}

	// ---- Utilities ----

	_getElementType(pTarget)
	{
		if (!pTarget) return 'background';

		let tmpType = pTarget.getAttribute ? pTarget.getAttribute('data-element-type') : null;
		if (tmpType) return tmpType;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpType = tmpParent.getAttribute ? tmpParent.getAttribute('data-element-type') : null;
			if (tmpType) return tmpType;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return 'background';
	}

	_getNodeHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-node-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-node-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getPanelHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-panel-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-panel-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getConnectionHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-connection-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-connection-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}
}

module.exports = PictServiceFlowInteractionManager;
module.exports.INTERACTION_STATES = INTERACTION_STATES;

},{"fable-serviceproviderbase":59}],234:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

// Layout algorithm and edge-theme descriptors now live in the standalone
// pict-provider-graphlayout module (flow 2.0 Phase 1b). The variable names below
// are unchanged so the registration logic that follows is untouched.
const libGraphLayout = require('pict-provider-graphlayout');

const libLayoutCustom           = libGraphLayout.Layouts.Custom;
const libLayoutLayered          = libGraphLayout.Layouts.Layered;
const libLayoutStaggered        = libGraphLayout.Layouts.Staggered;
const libLayoutForcedFromCenter = libGraphLayout.Layouts.ForcedFromCenter;
const libLayoutGrid             = libGraphLayout.Layouts.Grid;
const libLayoutCircular         = libGraphLayout.Layouts.Circular;
const libLayoutTabular          = libGraphLayout.Layouts.Tabular;
const libLayoutColumnar         = libGraphLayout.Layouts.Columnar;

const libEdgeBezier              = libGraphLayout.Edges.Bezier;
const libEdgeOrthogonal          = libGraphLayout.Edges.Orthogonal;
const libEdgeStraight            = libGraphLayout.Edges.Straight;
const libEdgeOrthogonalSnap      = libGraphLayout.Edges.OrthogonalSnap;
const libEdgePerimeter           = libGraphLayout.Edges.Perimeter;
const libEdgePerimeterLinear     = libGraphLayout.Edges.PerimeterLinear;
const libEdgePerimeterOrthogonal = libGraphLayout.Edges.PerimeterOrthogonal;

const _BUILTIN_ALGORITHMS =
[
	libLayoutCustom,
	libLayoutLayered,
	libLayoutStaggered,
	libLayoutForcedFromCenter,
	libLayoutGrid,
	libLayoutCircular,
	libLayoutTabular,
	libLayoutColumnar
];

const _BUILTIN_EDGE_THEMES =
[
	libEdgeBezier,
	libEdgeOrthogonal,
	libEdgeStraight,
	libEdgeOrthogonalSnap,
	libEdgePerimeter,
	libEdgePerimeterLinear,
	libEdgePerimeterOrthogonal
];

const _LEGACY_ALGORITHM  = 'Layered';
const _DEFAULT_EDGE_THEME = 'Bezier';

/**
 * PictServiceFlowLayout
 *
 * Layout-algorithm registry and dispatcher. Holds plain descriptor
 * objects (`{ Name, Label, Apply, DefaultParameters, ParameterSchema }`)
 * for every registered layout algorithm, plus the small helpers
 * `snapToGrid` and `centerNodes` and the special-case `autoLayoutSubset`.
 *
 * Algorithms are pure functions over `(nodes, connections, parameters)`
 * that mutate node X/Y in place. Third parties extend the registry via
 * `registerAlgorithm(pDescriptor)`.
 *
 * Note: `_LayoutProvider` (PictProvider-Flow-Layouts.js) is a different
 * concept — it manages **saved layout snapshots** (named position
 * captures the user can restore later). Don't confuse "layouts" (saved
 * snapshots) with "layout algorithms" (procedural arrangement).
 */
class PictServiceFlowLayout extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowLayout';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Legacy spacing fields kept for `autoLayoutSubset` and any
		// external consumer that read them. The Layered algorithm itself
		// pulls spacing from its DefaultParameters.
		this._HorizontalSpacing = 250;
		this._VerticalSpacing = 120;
		this._StartX = 100;
		this._StartY = 100;

		// Algorithm registry: Name → descriptor
		this._Algorithms = {};

		// Edge-theme registry: Name → descriptor
		this._EdgeThemes = {};

		for (let i = 0; i < _BUILTIN_ALGORITHMS.length; i++)
		{
			this.registerAlgorithm(_BUILTIN_ALGORITHMS[i]);
		}
		for (let i = 0; i < _BUILTIN_EDGE_THEMES.length; i++)
		{
			this.registerEdgeTheme(_BUILTIN_EDGE_THEMES[i]);
		}
	}

	// ── Algorithm Registry ────────────────────────────────────────────────

	/**
	 * Register a layout algorithm.
	 * @param {Object} pDescriptor - { Name, Label, Apply, DefaultParameters, ParameterSchema }
	 * @returns {boolean} true if registered, false if invalid
	 */
	registerAlgorithm(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object')
		{
			this.log.warn('PictServiceFlowLayout registerAlgorithm: descriptor must be an object');
			return false;
		}
		if (typeof pDescriptor.Name !== 'string' || pDescriptor.Name === '')
		{
			this.log.warn('PictServiceFlowLayout registerAlgorithm: descriptor.Name is required');
			return false;
		}
		if (typeof pDescriptor.Apply !== 'function')
		{
			this.log.warn(`PictServiceFlowLayout registerAlgorithm: descriptor.Apply for '${pDescriptor.Name}' must be a function`);
			return false;
		}

		this._Algorithms[pDescriptor.Name] = pDescriptor;
		return true;
	}

	/**
	 * Look up a registered algorithm by name.
	 * @param {string} pName
	 * @returns {Object|null}
	 */
	getAlgorithm(pName)
	{
		return this._Algorithms[pName] || null;
	}

	/**
	 * List all registered algorithm names in registration order.
	 * @returns {string[]}
	 */
	getAlgorithmNames()
	{
		return Object.keys(this._Algorithms);
	}

	/**
	 * List all registered algorithm descriptors.
	 * @returns {Object[]}
	 */
	listAlgorithms()
	{
		let tmpKeys = Object.keys(this._Algorithms);
		let tmpResult = [];
		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpResult.push(this._Algorithms[tmpKeys[i]]);
		}
		return tmpResult;
	}

	/**
	 * Build the merged parameter set for an algorithm: default values
	 * with caller-supplied overrides on top.
	 * @param {string} pName
	 * @param {Object} [pOverrides]
	 * @returns {Object}
	 */
	getMergedParameters(pName, pOverrides)
	{
		let tmpAlgo = this.getAlgorithm(pName);
		if (!tmpAlgo) return Object.assign({}, pOverrides || {});
		return Object.assign({}, tmpAlgo.DefaultParameters || {}, pOverrides || {});
	}

	// ── Edge-Theme Registry ──────────────────────────────────────────────

	/**
	 * Register an edge theme.
	 * @param {Object} pDescriptor - { Name, Label, Description, GeneratePath, AdjustLayout?, DefaultParameters?, ParameterSchema? }
	 * @returns {boolean} true if registered, false if invalid
	 */
	registerEdgeTheme(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object')
		{
			this.log.warn('PictServiceFlowLayout registerEdgeTheme: descriptor must be an object');
			return false;
		}
		if (typeof pDescriptor.Name !== 'string' || pDescriptor.Name === '')
		{
			this.log.warn('PictServiceFlowLayout registerEdgeTheme: descriptor.Name is required');
			return false;
		}
		if (typeof pDescriptor.GeneratePath !== 'function')
		{
			this.log.warn(`PictServiceFlowLayout registerEdgeTheme: descriptor.GeneratePath for '${pDescriptor.Name}' must be a function`);
			return false;
		}
		this._EdgeThemes[pDescriptor.Name] = pDescriptor;
		return true;
	}

	/**
	 * Look up a registered edge theme by name.
	 * @param {string} pName
	 * @returns {Object|null}
	 */
	getEdgeTheme(pName)
	{
		return this._EdgeThemes[pName] || null;
	}

	/**
	 * List all registered edge-theme names in registration order.
	 * @returns {string[]}
	 */
	getEdgeThemeNames()
	{
		return Object.keys(this._EdgeThemes);
	}

	/**
	 * List all registered edge-theme descriptors.
	 * @returns {Object[]}
	 */
	listEdgeThemes()
	{
		let tmpKeys = Object.keys(this._EdgeThemes);
		let tmpResult = [];
		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpResult.push(this._EdgeThemes[tmpKeys[i]]);
		}
		return tmpResult;
	}

	/**
	 * Resolve which edge theme should render a given connection. Order:
	 *   1. `Connection.Data.EdgeTheme` (per-connection override)
	 *   2. Per-connection `Connection.Data.LineMode === 'orthogonal'`
	 *      → 'Orthogonal' (back-compat for the existing line-mode flag)
	 *   3. `_FlowData.EdgeTheme` (flow-level)
	 *   4. Active layout's `DefaultEdgeTheme`
	 *   5. The hard fallback ('Bezier')
	 *
	 * Returns null only if even the fallback isn't registered, in which
	 * case the renderer should use its built-in path generators.
	 *
	 * @param {Object} pConnection
	 * @returns {Object|null}
	 */
	resolveActiveEdgeTheme(pConnection)
	{
		let tmpData = (pConnection && pConnection.Data) || {};
		let tmpFlowView = this._FlowView;
		let tmpFlowData = tmpFlowView ? tmpFlowView._FlowData : null;

		if (tmpData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme(tmpData.EdgeTheme);
			if (tmpTheme) return tmpTheme;
		}
		if (tmpData.LineMode === 'orthogonal' && !tmpData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme('Orthogonal');
			if (tmpTheme) return tmpTheme;
		}
		if (tmpFlowData && tmpFlowData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme(tmpFlowData.EdgeTheme);
			if (tmpTheme) return tmpTheme;
		}
		if (tmpFlowData && tmpFlowData.LayoutAlgorithm)
		{
			let tmpAlgo = this.getAlgorithm(tmpFlowData.LayoutAlgorithm);
			if (tmpAlgo && tmpAlgo.DefaultEdgeTheme)
			{
				let tmpTheme = this.getEdgeTheme(tmpAlgo.DefaultEdgeTheme);
				if (tmpTheme) return tmpTheme;
			}
		}
		return this.getEdgeTheme(_DEFAULT_EDGE_THEME);
	}

	/**
	 * Build the merged parameter set for an edge theme.
	 * @param {string} pName
	 * @param {Object} [pOverrides]
	 * @returns {Object}
	 */
	getMergedEdgeThemeParameters(pName, pOverrides)
	{
		let tmpTheme = this.getEdgeTheme(pName);
		if (!tmpTheme) return Object.assign({}, pOverrides || {});
		return Object.assign({}, tmpTheme.DefaultParameters || {}, pOverrides || {});
	}

	// ── Dispatch ──────────────────────────────────────────────────────────

	/**
	 * Apply a registered layout algorithm. Mutates node X/Y in place.
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {string} pAlgorithmName
	 * @param {Object} [pParameters]
	 */
	applyLayout(pNodes, pConnections, pAlgorithmName, pParameters)
	{
		let tmpAlgo = this.getAlgorithm(pAlgorithmName);
		if (!tmpAlgo)
		{
			this.log.warn(`PictServiceFlowLayout applyLayout: unknown algorithm '${pAlgorithmName}', falling back to '${_LEGACY_ALGORITHM}'`);
			tmpAlgo = this.getAlgorithm(_LEGACY_ALGORITHM);
			if (!tmpAlgo) return;
		}
		let tmpMerged = Object.assign({}, tmpAlgo.DefaultParameters || {}, pParameters || {});
		tmpAlgo.Apply(pNodes, pConnections, tmpMerged);
	}

	/**
	 * Auto-layout entry point.
	 *
	 * - Legacy 2-arg form `autoLayout(nodes, connections)` dispatches to
	 *   the Layered algorithm and is byte-for-byte identical to the
	 *   pre-subsystem behavior.
	 * - 3- or 4-arg form `autoLayout(nodes, connections, name, params)`
	 *   dispatches to the named algorithm.
	 *
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {string} [pAlgorithmName] - defaults to the Layered algorithm
	 * @param {Object} [pParameters]
	 */
	autoLayout(pNodes, pConnections, pAlgorithmName, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;
		let tmpName = (typeof pAlgorithmName === 'string' && pAlgorithmName !== '') ? pAlgorithmName : _LEGACY_ALGORITHM;
		this.applyLayout(pNodes, pConnections, tmpName, pParameters);
	}

	// ── Helpers ──────────────────────────────────────────────────────────

	/**
	 * Snap a coordinate to the nearest grid point.
	 * @param {number} pValue
	 * @param {number} pGridSize
	 * @returns {number}
	 */
	snapToGrid(pValue, pGridSize)
	{
		if (!pGridSize || pGridSize <= 0) return pValue;
		return Math.round(pValue / pGridSize) * pGridSize;
	}

	/**
	 * Auto-layout a subset of nodes, positioning them to the right of
	 * any fixed (already-positioned) nodes.
	 *
	 * Used by the saved-layout restore flow (`PictProvider-Flow-Layouts`)
	 * to position nodes that exist in the current flow but were absent
	 * from the saved snapshot.
	 *
	 * **Always runs the Layered algorithm**, regardless of the flow's
	 * configured `LayoutAlgorithm`. Running ForcedFromCenter or another
	 * algorithm on a partial node set would jitter the matched nodes
	 * (which are intentionally fixed). The contract here is "place the
	 * orphans in a sensible default arrangement," not "obey the user's
	 * full-graph algorithm."
	 *
	 * @param {Array} pNodesToLayout - Nodes that need new positions
	 * @param {Array} pFixedNodes - Nodes that already have positions (read-only)
	 * @param {Array} pConnections - All connections in the flow
	 */
	autoLayoutSubset(pNodesToLayout, pFixedNodes, pConnections)
	{
		if (!pNodesToLayout || pNodesToLayout.length === 0) return;

		// Compute the starting X position to the right of all fixed nodes
		let tmpStartX = this._StartX;
		let tmpStartY = this._StartY;

		if (pFixedNodes && pFixedNodes.length > 0)
		{
			let tmpMaxX = -Infinity;

			for (let i = 0; i < pFixedNodes.length; i++)
			{
				let tmpRight = pFixedNodes[i].X + (pFixedNodes[i].Width || 180);
				if (tmpRight > tmpMaxX)
				{
					tmpMaxX = tmpRight;
				}
			}

			tmpStartX = tmpMaxX + this._HorizontalSpacing;
		}

		// Build a set of nodes we are laying out for quick lookup
		let tmpNodeSet = {};
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			tmpNodeSet[pNodesToLayout[i].Hash] = true;
		}

		// Build adjacency information only for nodes in the subset
		let tmpNodeMap = {};
		let tmpInDegree = {};
		let tmpOutEdges = {};

		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			let tmpNode = pNodesToLayout[i];
			tmpNodeMap[tmpNode.Hash] = tmpNode;
			tmpInDegree[tmpNode.Hash] = 0;
			tmpOutEdges[tmpNode.Hash] = [];
		}

		for (let i = 0; i < pConnections.length; i++)
		{
			let tmpConn = pConnections[i];
			let tmpSourceInSubset = tmpNodeSet[tmpConn.SourceNodeHash];
			let tmpTargetInSubset = tmpNodeSet[tmpConn.TargetNodeHash];

			if (tmpSourceInSubset && tmpTargetInSubset)
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
				tmpOutEdges[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Topological sort (Kahn's algorithm)
		let tmpLayers = [];
		let tmpQueue = [];
		let tmpAssigned = {};

		for (let tmpHash in tmpInDegree)
		{
			if (tmpInDegree[tmpHash] === 0)
			{
				tmpQueue.push(tmpHash);
			}
		}

		while (tmpQueue.length > 0)
		{
			let tmpCurrentLayer = [];
			let tmpNextQueue = [];

			for (let i = 0; i < tmpQueue.length; i++)
			{
				let tmpNodeHash = tmpQueue[i];
				if (tmpAssigned[tmpNodeHash]) continue;

				tmpAssigned[tmpNodeHash] = true;
				tmpCurrentLayer.push(tmpNodeHash);

				let tmpEdges = tmpOutEdges[tmpNodeHash] || [];
				for (let j = 0; j < tmpEdges.length; j++)
				{
					let tmpTargetHash = tmpEdges[j];
					tmpInDegree[tmpTargetHash]--;
					if (tmpInDegree[tmpTargetHash] <= 0 && !tmpAssigned[tmpTargetHash])
					{
						tmpNextQueue.push(tmpTargetHash);
					}
				}
			}

			if (tmpCurrentLayer.length > 0)
			{
				tmpLayers.push(tmpCurrentLayer);
			}

			tmpQueue = tmpNextQueue;
		}

		// Handle remaining unassigned nodes (cycles or disconnected)
		let tmpRemainingNodes = [];
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			if (!tmpAssigned[pNodesToLayout[i].Hash])
			{
				tmpRemainingNodes.push(pNodesToLayout[i].Hash);
			}
		}
		if (tmpRemainingNodes.length > 0)
		{
			tmpLayers.push(tmpRemainingNodes);
		}

		// Assign positions based on layers, starting from tmpStartX
		let tmpCurrentX = tmpStartX;

		for (let tmpLayerIndex = 0; tmpLayerIndex < tmpLayers.length; tmpLayerIndex++)
		{
			let tmpLayer = tmpLayers[tmpLayerIndex];
			let tmpMaxWidth = 0;
			let tmpCurrentY = tmpStartY;

			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (!tmpNode) continue;

				tmpNode.X = tmpCurrentX;
				tmpNode.Y = tmpCurrentY;

				let tmpWidth = tmpNode.Width || 180;
				let tmpHeight = tmpNode.Height || 80;

				tmpMaxWidth = Math.max(tmpMaxWidth, tmpWidth);
				tmpCurrentY += tmpHeight + this._VerticalSpacing;
			}

			tmpCurrentX += tmpMaxWidth + this._HorizontalSpacing;
		}
	}

	/**
	 * Center all nodes around a given point.
	 * @param {Array} pNodes
	 * @param {number} pCenterX
	 * @param {number} pCenterY
	 */
	centerNodes(pNodes, pCenterX, pCenterY)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMinX = Math.min(tmpMinX, pNodes[i].X);
			tmpMinY = Math.min(tmpMinY, pNodes[i].Y);
			tmpMaxX = Math.max(tmpMaxX, pNodes[i].X + (pNodes[i].Width || 180));
			tmpMaxY = Math.max(tmpMaxY, pNodes[i].Y + (pNodes[i].Height || 80));
		}

		let tmpCurrentCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCurrentCenterY = (tmpMinY + tmpMaxY) / 2;
		let tmpOffsetX = pCenterX - tmpCurrentCenterX;
		let tmpOffsetY = pCenterY - tmpCurrentCenterY;

		for (let i = 0; i < pNodes.length; i++)
		{
			pNodes[i].X += tmpOffsetX;
			pNodes[i].Y += tmpOffsetY;
		}
	}
}

module.exports = PictServiceFlowLayout;

},{"fable-serviceproviderbase":59,"pict-provider-graphlayout":151}],235:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PanelManager
 *
 * Manages the lifecycle of properties panels in the flow diagram:
 * opening, closing, toggling, and position updates for panels
 * associated with flow nodes.
 */
class PictServiceFlowPanelManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPanelManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Pick an initial panel position that keeps the panel inside the currently visible viewport when it
	 * can. The default is to the right of the node; if that would push the panel off the right edge of
	 * the visible area (a node near the edge -- the panel would clip), flip it to the node's left. The Y
	 * is clamped so the panel does not hang off the top or bottom. Falls back to the right-of-node
	 * placement when the viewport bounds are not measurable (no SVG element, not yet rendered, or a
	 * server-side render with no CTM). The panel is draggable, so this is only the opening position.
	 * @param {Object} pNode - The node the panel anchors to (graph-space X/Y/Width)
	 * @param {number} pWidth - The panel width (graph units)
	 * @param {number} pHeight - The panel height (graph units)
	 * @returns {{X: number, Y: number}}
	 */
	_computePanelPosition(pNode, pWidth, pHeight)
	{
		let tmpGap = 30;
		let tmpRightX = pNode.X + pNode.Width + tmpGap;
		let tmpDefault = { X: tmpRightX, Y: pNode.Y };

		let tmpViewport = this._FlowView ? this._FlowView._ViewportManager : null;
		let tmpSVG = this._FlowView ? this._FlowView._SVGElement : null;
		if (!tmpViewport || !tmpSVG || typeof tmpSVG.getBoundingClientRect !== 'function' || typeof tmpViewport.screenToSVGCoords !== 'function')
		{
			return tmpDefault;
		}

		let tmpRect = tmpSVG.getBoundingClientRect();
		if (!tmpRect || !(tmpRect.width > 0) || !(tmpRect.height > 0)) { return tmpDefault; }

		// The visible canvas in graph coordinates (screenToSVGCoords already undoes pan + zoom).
		let tmpTopLeft = tmpViewport.screenToSVGCoords(tmpRect.left, tmpRect.top);
		let tmpBottomRight = tmpViewport.screenToSVGCoords(tmpRect.right, tmpRect.bottom);
		let tmpVisLeft = Math.min(tmpTopLeft.x, tmpBottomRight.x);
		let tmpVisRight = Math.max(tmpTopLeft.x, tmpBottomRight.x);
		let tmpVisTop = Math.min(tmpTopLeft.y, tmpBottomRight.y);
		let tmpVisBottom = Math.max(tmpTopLeft.y, tmpBottomRight.y);

		// Side selection: right unless it would clip; then the node's left if the panel fits there, else
		// whichever side has more room.
		let tmpX = tmpRightX;
		if (tmpRightX + pWidth > tmpVisRight)
		{
			let tmpLeftX = pNode.X - tmpGap - pWidth;
			if (tmpLeftX >= tmpVisLeft)
			{
				tmpX = tmpLeftX;
			}
			else
			{
				let tmpRoomRight = tmpVisRight - tmpRightX;
				let tmpRoomLeft = (pNode.X - tmpGap) - tmpVisLeft;
				tmpX = (tmpRoomLeft > tmpRoomRight) ? tmpLeftX : tmpRightX;
			}
		}
		// Final clamp into the visible band, but only when the panel actually fits in it (otherwise a
		// panel wider than the viewport would get pinned uselessly to the left edge).
		if ((tmpVisRight - tmpVisLeft) > pWidth) { tmpX = Math.max(tmpVisLeft, Math.min(tmpX, tmpVisRight - pWidth)); }

		let tmpY = pNode.Y;
		if ((tmpVisBottom - tmpVisTop) > pHeight) { tmpY = Math.max(tmpVisTop, Math.min(tmpY, tmpVisBottom - pHeight)); }

		return { X: tmpX, Y: tmpY };
	}

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node was not found
	 */
	openPanel(pNodeHash)
	{
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return false;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);
		if (!tmpNodeTypeConfig) return false;

		// Check if a panel is already open for this node
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting) return tmpExisting;

		let tmpPanelConfig = tmpNodeTypeConfig.PropertiesPanel;
		let tmpPanelHash = `panel-${this.fable.getUUID()}`;
		let tmpWidth, tmpHeight, tmpPanelType, tmpTitle;

		if (tmpPanelConfig)
		{
			tmpWidth = tmpPanelConfig.DefaultWidth || 300;
			tmpHeight = tmpPanelConfig.DefaultHeight || 200;
			tmpPanelType = tmpPanelConfig.PanelType || 'Base';
			tmpTitle = tmpPanelConfig.Title || tmpNodeTypeConfig.Label || 'Properties';
		}
		else
		{
			// No PropertiesPanel configured — open an auto-generated info panel
			tmpWidth = 240;
			tmpHeight = 180;
			tmpPanelType = 'Info';
			tmpTitle = tmpNodeTypeConfig.Label || tmpNode.Title || 'Node Info';
		}

		let tmpPanelPosition = this._computePanelPosition(tmpNode, tmpWidth, tmpHeight);
		let tmpPanelData =
		{
			Hash: tmpPanelHash,
			NodeHash: pNodeHash,
			PanelType: tmpPanelType,
			Title: tmpTitle,
			X: tmpPanelPosition.X,
			Y: tmpPanelPosition.Y,
			Width: tmpWidth,
			Height: tmpHeight
		};

		this._FlowView._FlowData.OpenPanels.push(tmpPanelData);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelOpened', tmpPanelData);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpPanelData;
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		let tmpIndex = this._FlowView._FlowData.OpenPanels.findIndex((pPanel) => pPanel.Hash === pPanelHash);
		if (tmpIndex < 0) return false;

		let tmpRemovedPanel = this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1)[0];

		// Clean up the panel instance
		if (this._FlowView._PropertiesPanelView)
		{
			this._FlowView._PropertiesPanelView.destroyPanel(pPanelHash);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelClosed', tmpRemovedPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		let tmpPanelsToClose = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpPanelsToClose.length === 0) return false;

		for (let i = 0; i < tmpPanelsToClose.length; i++)
		{
			let tmpIndex = this._FlowView._FlowData.OpenPanels.indexOf(tmpPanelsToClose[i]);
			if (tmpIndex >= 0)
			{
				this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1);
			}
			if (this._FlowView._PropertiesPanelView)
			{
				this._FlowView._PropertiesPanelView.destroyPanel(tmpPanelsToClose[i].Hash);
			}
		}

		return true;
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting)
		{
			this.closePanel(tmpExisting.Hash);
			return false;
		}
		return this.openPanel(pNodeHash);
	}

	/**
	 * Open a properties panel for a connection (edge). The panel config comes from the FlowView's
	 * ConnectionPropertiesPanel option (connections are not typed, so one config serves them all);
	 * the panel is placed near the connection's midpoint and tethers to it. Returns false when no
	 * ConnectionPropertiesPanel is configured, so a host that has not opted in keeps the default
	 * edge behavior (double-click adds a bezier handle).
	 * @param {string} pConnectionHash
	 * @returns {Object|false} The panel data, or false
	 */
	openConnectionPanel(pConnectionHash)
	{
		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return false;

		let tmpPanelConfig = this._FlowView.options.ConnectionPropertiesPanel;
		if (!tmpPanelConfig) return false;

		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.ConnectionHash === pConnectionHash);
		if (tmpExisting) return tmpExisting;

		let tmpMidpoint = this._FlowView.getConnectionMidpoint(pConnectionHash) || { x: 0, y: 0 };
		let tmpWidth = tmpPanelConfig.DefaultWidth || 300;
		let tmpHeight = tmpPanelConfig.DefaultHeight || 200;

		let tmpPanelData =
		{
			Hash: `panel-${this.fable.getUUID()}`,
			ConnectionHash: pConnectionHash,
			NodeHash: null,
			PanelType: tmpPanelConfig.PanelType || 'Base',
			Title: tmpPanelConfig.Title || 'Connection',
			X: tmpMidpoint.x + 40,
			Y: tmpMidpoint.y + 20,
			Width: tmpWidth,
			Height: tmpHeight
		};

		this._FlowView._FlowData.OpenPanels.push(tmpPanelData);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelOpened', tmpPanelData);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpPanelData;
	}

	/**
	 * Toggle a properties panel for a connection (open if closed, close if open).
	 * @param {string} pConnectionHash
	 * @returns {Object|false}
	 */
	toggleConnectionPanel(pConnectionHash)
	{
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.ConnectionHash === pConnectionHash);
		if (tmpExisting)
		{
			this.closePanel(tmpExisting.Hash);
			return false;
		}
		return this.openConnectionPanel(pConnectionHash);
	}

	/**
	 * Close all panels for a given connection.
	 * @param {string} pConnectionHash
	 * @returns {boolean}
	 */
	closePanelForConnection(pConnectionHash)
	{
		let tmpPanelsToClose = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.ConnectionHash === pConnectionHash);
		if (tmpPanelsToClose.length === 0) return false;

		for (let i = 0; i < tmpPanelsToClose.length; i++)
		{
			let tmpIndex = this._FlowView._FlowData.OpenPanels.indexOf(tmpPanelsToClose[i]);
			if (tmpIndex >= 0)
			{
				this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1);
			}
			if (this._FlowView._PropertiesPanelView)
			{
				this._FlowView._PropertiesPanelView.destroyPanel(tmpPanelsToClose[i].Hash);
			}
		}

		return true;
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		tmpPanel.X = pX;
		tmpPanel.Y = pY;

		// Reset tether handle positions when panel moves
		this._FlowView._resetHandlesForPanel(pPanelHash);

		// Update the foreignObject position directly for smooth dragging
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector(`[data-panel-hash="${pPanelHash}"]`);
			if (tmpFO)
			{
				tmpFO.setAttribute('x', String(pX));
				tmpFO.setAttribute('y', String(pY));
			}
		}

		// Update the tether for this panel. A node panel refreshes just its node's tethers; a
		// connection panel has no node, so reconcile the panels layer (redraws all tethers, which
		// is where the connection-midpoint tether is recomputed).
		if (tmpPanel.ConnectionHash)
		{
			if (this._FlowView._PropertiesPanelView && this._FlowView._PanelsLayer && this._FlowView._TethersLayer)
			{
				this._FlowView._PropertiesPanelView.renderPanels(this._FlowView._FlowData.OpenPanels, this._FlowView._PanelsLayer, this._FlowView._TethersLayer, this._FlowView._FlowData.ViewState.SelectedTetherHash);
			}
		}
		else
		{
			this._FlowView._renderTethersForNode(tmpPanel.NodeHash);
		}
	}
}

module.exports = PictServiceFlowPanelManager;

},{"fable-serviceproviderbase":59}],236:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libPathGeneratorCore = require('pict-provider-graphlayout').PathGenerator;

/**
 * PictService-Flow-PathGenerator
 *
 * Backwards-compatible shim. The SVG path-generation math now lives in the
 * standalone pict-provider-graphlayout module as a geometry-injected core (flow
 * 2.0 Phase 1b). This service keeps the historical serviceType and the
 * `_FlowView` property, and delegates every method to the core. The core gets a
 * resolver so it reads the live FlowView geometry provider at call time, exactly
 * as the original implementation did.
 *
 * Used by the ConnectionRenderer (port-to-port connections) and the
 * TetherService (panel-to-node tethers).
 */
class PictServiceFlowPathGenerator extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPathGenerator';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		let tmpSelf = this;
		this._Core = new libPathGeneratorCore(
			{
				geometryResolver: function ()
				{
					return tmpSelf._FlowView ? tmpSelf._FlowView._GeometryProvider : null;
				}
			});
	}

	computeDepartApproach(pFrom, pTo, pDepartDist)
	{
		return this._Core.computeDepartApproach(pFrom, pTo, pDepartDist);
	}

	computeAutoOrthogonalCorners(pDepartX, pDepartY, pApproachX, pApproachY, pFromDir, pToDir, pMidOffset)
	{
		return this._Core.computeAutoOrthogonalCorners(pDepartX, pDepartY, pApproachX, pApproachY, pFromDir, pToDir, pMidOffset);
	}

	evaluateCubicBezier(pP0, pP1, pP2, pP3, pT)
	{
		return this._Core.evaluateCubicBezier(pP0, pP1, pP2, pP3, pT);
	}

	buildBezierPathString(pStart, pDepart, pCP1, pCP2, pApproach, pEnd)
	{
		return this._Core.buildBezierPathString(pStart, pDepart, pCP1, pCP2, pApproach, pEnd);
	}

	buildSplitBezierPathString(pStart, pDepart, pCP1a, pCP1b, pHandle, pCP2a, pCP2b, pApproach, pEnd)
	{
		return this._Core.buildSplitBezierPathString(pStart, pDepart, pCP1a, pCP1b, pHandle, pCP2a, pCP2b, pApproach, pEnd);
	}

	buildMultiBezierPathString(pStart, pDepart, pHandles, pApproach, pEnd, pStartDir, pEndDir)
	{
		return this._Core.buildMultiBezierPathString(pStart, pDepart, pHandles, pApproach, pEnd, pStartDir, pEndDir);
	}

	buildOrthogonalPathString(pStart, pDepart, pCorner1, pCorner2, pApproach, pEnd)
	{
		return this._Core.buildOrthogonalPathString(pStart, pDepart, pCorner1, pCorner2, pApproach, pEnd);
	}

	computeDirectionalGeometry(pStart, pEnd)
	{
		return this._Core.computeDirectionalGeometry(pStart, pEnd);
	}

	distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		return this._Core.distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY);
	}

	getAutoMidpoint(pStart, pEnd)
	{
		return this._Core.getAutoMidpoint(pStart, pEnd);
	}

	getAutoMidpointSimple(pFrom, pTo, pDepartDist)
	{
		return this._Core.getAutoMidpointSimple(pFrom, pTo, pDepartDist);
	}
}

module.exports = PictServiceFlowPathGenerator;

},{"fable-serviceproviderbase":59,"pict-provider-graphlayout":151}],237:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PortRenderer
 *
 * Renders port circles, labels, and badges for flow diagram nodes.
 *
 * Extracted from PictView-Flow-Node.js to isolate port rendering logic
 * from node body rendering and layout.
 *
 * Dependencies (all accessed via this._FlowView):
 *   - _GeometryProvider — for getEdgeFromSide, getPortLocalPosition
 *   - _ConnectorShapesProvider — for createPortElement
 *   - _SVGHelperProvider — for createSVGElement
 */
class PictServiceFlowPortRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPortRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render ports for a node.
	 * @param {Object} pNodeData
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {Object} [pNodeTypeConfig] - Node type configuration (for label display options)
	 * @param {number} pNodeTitleBarHeight - Title bar height (for port position offset)
	 */
	renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig, pNodeTitleBarHeight)
	{
		if (!this._FlowView) return;
		if (!pNodeData.Ports || !Array.isArray(pNodeData.Ports)) return;

		let tmpPortLabelsVertical = (pNodeTypeConfig && pNodeTypeConfig.PortLabelsVertical);
		let tmpPortLabelPadding = (pNodeTypeConfig && pNodeTypeConfig.PortLabelPadding);
		let tmpPortLabelsOutside = (pNodeTypeConfig && pNodeTypeConfig.PortLabelsOutside);
		let tmpGeometryProvider = this._FlowView._GeometryProvider;

		// Connected ports get their colored dot drawn by the connection
		// renderer at the actual line attachment (which may have been
		// reshaped by an edge theme like Perimeter). Unconnected ports
		// still draw their dot at the static card-defined position.
		let tmpConnectedPortHashes = this._collectConnectedPortHashes(pNodeData.Hash);

		// Group ports by their Side value (supports all 12 positions)
		let tmpPortsBySide = {};
		for (let i = 0; i < pNodeData.Ports.length; i++)
		{
			let tmpPort = pNodeData.Ports[i];
			let tmpSide = tmpPort.Side || (tmpPort.Direction === 'input' ? 'left' : 'right');
			if (!tmpPortsBySide[tmpSide])
			{
				tmpPortsBySide[tmpSide] = [];
			}
			tmpPortsBySide[tmpSide].push(tmpPort);
		}

		// Build port counts map for adaptive zone sizing
		let tmpPortCountsBySide = {};
		for (let tmpKey in tmpPortsBySide)
		{
			tmpPortCountsBySide[tmpKey] = tmpPortsBySide[tmpKey].length;
		}

		for (let tmpSide in tmpPortsBySide)
		{
			let tmpPorts = tmpPortsBySide[tmpSide];
			// Determine the edge for label positioning
			let tmpEdge = tmpGeometryProvider ? tmpGeometryProvider.getEdgeFromSide(tmpSide) : tmpSide;

			for (let i = 0; i < tmpPorts.length; i++)
			{
				let tmpPort = tmpPorts[i];
				let tmpPosition = this.getPortLocalPosition(tmpSide, i, tmpPorts.length, pWidth, pHeight, pNodeTitleBarHeight, tmpPortCountsBySide);

				// Port label badge — flush against the node edge with no
				// border on the edge side; rendered before the port circle
				// so the circle visually sits on top of the badge
				let tmpLabelElement = null;
				if (tmpPort.Label)
				{
					let tmpPortTypeColorMap =
					{
						'event-in': 'var(--theme-color-status-info, #3498db)',
						'event-out': 'var(--theme-color-status-success, #2ecc71)',
						'setting': 'var(--theme-color-status-warning, #e67e22)',
						'value': 'var(--theme-color-status-warning, #f1c40f)',
						'error': 'var(--theme-color-status-error, #e74c3c)'
					};
					let tmpBorderColor = tmpPort.PortType ? (tmpPortTypeColorMap[tmpPort.PortType] || 'var(--theme-color-border-default, #95a5a6)') : 'var(--theme-color-border-default, #95a5a6)';

					let tmpBadgeHeight = 12;
					let tmpBadgePadH = 5;
					let tmpBadgeBorderW = 2;
					let tmpEdgePad = 1;
					let tmpPortRadius = 5;

					let tmpTextLen = tmpPort.Label.length * 5;
					let tmpBadgeX, tmpBadgeY, tmpBadgeWidth;
					let tmpTextX, tmpTextAnchor;
					let tmpStripeX, tmpStripeY, tmpStripeW, tmpStripeH;
					let tmpBorderPath;

					if (tmpEdge === 'left')
					{
						tmpBadgeWidth = tmpPortRadius + tmpBadgePadH + tmpTextLen + tmpBadgePadH + tmpBadgeBorderW;
						tmpBadgeX = tmpEdgePad;
						tmpBadgeY = tmpPosition.y - tmpBadgeHeight / 2;
						tmpTextX = tmpBadgeX + tmpPortRadius + tmpBadgePadH;
						tmpTextAnchor = 'start';
						tmpStripeX = tmpBadgeX + tmpBadgeWidth - tmpBadgeBorderW;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeBorderW;
						tmpStripeH = tmpBadgeHeight;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}
					else if (tmpEdge === 'right')
					{
						tmpBadgeWidth = tmpBadgeBorderW + tmpBadgePadH + tmpTextLen + tmpBadgePadH + tmpPortRadius;
						tmpBadgeX = pWidth - tmpBadgeWidth - tmpEdgePad;
						tmpBadgeY = tmpPosition.y - tmpBadgeHeight / 2;
						tmpTextX = tmpBadgeX + tmpBadgeBorderW + tmpBadgePadH;
						tmpTextAnchor = 'start';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeBorderW;
						tmpStripeH = tmpBadgeHeight;
						tmpBorderPath = 'M ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}
					else if (tmpEdge === 'top')
					{
						tmpBadgeWidth = tmpTextLen + tmpBadgePadH * 2;
						tmpBadgeX = tmpPosition.x - tmpBadgeWidth / 2;
						tmpBadgeY = tmpEdgePad;
						tmpTextX = tmpPosition.x;
						tmpTextAnchor = 'middle';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY + tmpBadgeHeight - tmpBadgeBorderW;
						tmpStripeW = tmpBadgeWidth;
						tmpStripeH = tmpBadgeBorderW;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY;
					}
					else
					{
						tmpBadgeWidth = tmpTextLen + tmpBadgePadH * 2;
						tmpBadgeX = tmpPosition.x - tmpBadgeWidth / 2;
						tmpBadgeY = pHeight - tmpBadgeHeight - tmpEdgePad;
						tmpTextX = tmpPosition.x;
						tmpTextAnchor = 'middle';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeWidth;
						tmpStripeH = tmpBadgeBorderW;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}

					// Wrap the badge elements in a hoverable group so we can
					// listen for mouseenter/mouseleave on the badge as a
					// whole. Tagged with data-port-hash + data-node-hash so
					// the hover handler can surface this port's hint paths.
					let tmpBadgeGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');
					tmpBadgeGroup.setAttribute('class', 'pict-flow-port-badge');
					tmpBadgeGroup.setAttribute('data-port-hash', tmpPort.Hash);
					tmpBadgeGroup.setAttribute('data-node-hash', pNodeData.Hash);
					this._wirePortHintHover(tmpBadgeGroup, tmpPort.Hash, null);

					// Background rect (cream, no stroke — border drawn separately)
					let tmpBgRect = this._FlowView._SVGHelperProvider.createSVGElement('rect');
					tmpBgRect.setAttribute('class', 'pict-flow-port-label-bg');
					tmpBgRect.setAttribute('x', String(tmpBadgeX));
					tmpBgRect.setAttribute('y', String(tmpBadgeY));
					tmpBgRect.setAttribute('width', String(tmpBadgeWidth));
					tmpBgRect.setAttribute('height', String(tmpBadgeHeight));
					tmpBgRect.setAttribute('fill', 'var(--pf-port-label-bg, rgba(255, 253, 240, 0.5))');
					tmpBadgeGroup.appendChild(tmpBgRect);

					// 3-sided border path (open on the edge-facing side)
					let tmpBorderPathEl = this._FlowView._SVGHelperProvider.createSVGElement('path');
					tmpBorderPathEl.setAttribute('class', 'pict-flow-port-label-bg');
					tmpBorderPathEl.setAttribute('d', tmpBorderPath);
					tmpBorderPathEl.setAttribute('fill', 'none');
					tmpBorderPathEl.setAttribute('stroke', tmpBorderColor);
					tmpBorderPathEl.setAttribute('stroke-width', '0.75');
					tmpBadgeGroup.appendChild(tmpBorderPathEl);

					// Colored stripe on the inner side
					let tmpStripe = this._FlowView._SVGHelperProvider.createSVGElement('rect');
					tmpStripe.setAttribute('class', 'pict-flow-port-label-bg');
					tmpStripe.setAttribute('x', String(tmpStripeX));
					tmpStripe.setAttribute('y', String(tmpStripeY));
					tmpStripe.setAttribute('width', String(tmpStripeW));
					tmpStripe.setAttribute('height', String(tmpStripeH));
					tmpStripe.setAttribute('fill', tmpBorderColor);
					tmpBadgeGroup.appendChild(tmpStripe);

					pGroup.appendChild(tmpBadgeGroup);

					// Text label — appended after circle for z-order
					tmpLabelElement = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpLabelElement.setAttribute('class', 'pict-flow-port-label');
					tmpLabelElement.setAttribute('fill', 'var(--pf-port-label-text, #2c3e50)');
					tmpLabelElement.textContent = tmpPort.Label;
					tmpLabelElement.setAttribute('x', String(tmpTextX));
					tmpLabelElement.setAttribute('y', String(tmpBadgeY + tmpBadgeHeight / 2));
					tmpLabelElement.setAttribute('text-anchor', tmpTextAnchor);
					tmpLabelElement.setAttribute('dominant-baseline', 'central');
				}

				// Port circle (rendered on top of badge background) —
				// only for unconnected ports. Connected ports get their
				// dot painted by the connection renderer at the actual
				// attachment point (so it follows edge-theme overrides).
				if (!tmpConnectedPortHashes[tmpPort.Hash])
				{
					let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
					let tmpCircle;
					if (tmpShapeProvider)
					{
						tmpCircle = tmpShapeProvider.createPortElement(tmpPort, tmpPosition, pNodeData.Hash);
					}
					else
					{
						tmpCircle = this._FlowView._SVGHelperProvider.createSVGElement('circle');
						let tmpPortClass = `pict-flow-port ${tmpPort.Direction}`;
						if (tmpPort.PortType)
						{
							tmpPortClass += ` port-type-${tmpPort.PortType}`;
						}
						tmpCircle.setAttribute('class', tmpPortClass);
						tmpCircle.setAttribute('cx', String(tmpPosition.x));
						tmpCircle.setAttribute('cy', String(tmpPosition.y));
						tmpCircle.setAttribute('r', '5');
						tmpCircle.setAttribute('data-port-hash', tmpPort.Hash);
						tmpCircle.setAttribute('data-node-hash', pNodeData.Hash);
						tmpCircle.setAttribute('data-port-direction', tmpPort.Direction);
						if (tmpPort.PortType)
						{
							tmpCircle.setAttribute('data-port-type', tmpPort.PortType);
						}
						tmpCircle.setAttribute('data-element-type', 'port');
					}
					pGroup.appendChild(tmpCircle);
				}

				// Port label text (on top of everything)
				if (tmpLabelElement)
				{
					pGroup.appendChild(tmpLabelElement);
				}
			}
		}
	}

	/**
	 * Wire mouseenter/mouseleave on a hoverable element so it activates
	 * port-hint paths in the port-hints layer. When `pPortHash` is set,
	 * only hints for that port light up; when `pNodeHash` is set (and
	 * port hash is null), every hint on that node lights up. Static —
	 * no closure-state dependency on the node/port objects themselves.
	 *
	 * @param {SVGElement} pHoverEl
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_wirePortHintHover(pHoverEl, pPortHash, pNodeHash)
	{
		if (!pHoverEl || typeof pHoverEl.setAttribute !== 'function') return;
		if (!this._FlowView || !this._FlowView.options) return;

		// Inline attribute handlers — survive the connection-layer rebuild
		// without leaving stale listeners on detached DOM nodes.
		let tmpFlowViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpHashArg = pPortHash ? ('"' + pPortHash + '", null') : ('null, "' + pNodeHash + '"');
		pHoverEl.setAttribute('onmouseenter',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._activatePortHints(" + tmpHashArg + ")");
		pHoverEl.setAttribute('onmouseleave',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._deactivatePortHints(" + tmpHashArg + ")");
	}

	/**
	 * Build a hash-set of port hashes on the given node that participate
	 * in any connection (either as source or target). Used to suppress
	 * the static port circle so the connection renderer can paint the
	 * dot at the resolved attachment point instead.
	 *
	 * @param {string} pNodeHash
	 * @returns {Object} keyed by port hash → true
	 */
	_collectConnectedPortHashes(pNodeHash)
	{
		let tmpResult = {};
		if (!this._FlowView || !this._FlowView._FlowData || !Array.isArray(this._FlowView._FlowData.Connections))
		{
			return tmpResult;
		}
		let tmpConns = this._FlowView._FlowData.Connections;
		for (let i = 0; i < tmpConns.length; i++)
		{
			let tmpConn = tmpConns[i];
			if (tmpConn.SourceNodeHash === pNodeHash && tmpConn.SourcePortHash)
			{
				tmpResult[tmpConn.SourcePortHash] = true;
			}
			if (tmpConn.TargetNodeHash === pNodeHash && tmpConn.TargetPortHash)
			{
				tmpResult[tmpConn.TargetPortHash] = true;
			}
		}
		return tmpResult;
	}

	/**
	 * Calculate port position relative to node origin.
	 *
	 * Delegates to the geometry provider's getPortLocalPosition method.
	 *
	 * @param {string} pSide - 'left', 'right', 'top', 'bottom' (or compound sides)
	 * @param {number} pIndex - Index of this port on its side
	 * @param {number} pTotal - Total ports on this side
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pNodeTitleBarHeight - Title bar height
	 * @param {Object} [pPortCountsBySide] - Optional map of Side → count for adaptive zones
	 * @returns {{x: number, y: number}}
	 */
	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pNodeTitleBarHeight, pPortCountsBySide)
	{
		return this._FlowView._GeometryProvider.getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pNodeTitleBarHeight, pPortCountsBySide);
	}
}

module.exports = PictServiceFlowPortRenderer;

},{"fable-serviceproviderbase":59}],238:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-RenderManager
 *
 * Orchestrates rendering of the flow diagram: nodes, connections,
 * tethers, panels, SVG marker definitions, and node position updates.
 *
 * Extracted from PictView-Flow.js to isolate rendering orchestration
 * from data management and interaction handling.
 */
class PictServiceFlowRenderManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowRenderManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render the complete flow diagram
	 */
	renderFlow()
	{
		if (!this._FlowView) return;
		if (!this._FlowView._NodesLayer || !this._FlowView._ConnectionsLayer) return;

		// Clear existing SVG content
		while (this._FlowView._NodesLayer.firstChild)
		{
			this._FlowView._NodesLayer.removeChild(this._FlowView._NodesLayer.firstChild);
		}
		while (this._FlowView._ConnectionsLayer.firstChild)
		{
			this._FlowView._ConnectionsLayer.removeChild(this._FlowView._ConnectionsLayer.firstChild);
		}
		if (this._FlowView._EndpointsLayer)
		{
			while (this._FlowView._EndpointsLayer.firstChild) this._FlowView._EndpointsLayer.removeChild(this._FlowView._EndpointsLayer.firstChild);
		}
		if (this._FlowView._PortHintsLayer)
		{
			while (this._FlowView._PortHintsLayer.firstChild) this._FlowView._PortHintsLayer.removeChild(this._FlowView._PortHintsLayer.firstChild);
		}

		// Render connections first (behind nodes)
		for (let i = 0; i < this._FlowView._FlowData.Connections.length; i++)
		{
			let tmpConnection = this._FlowView._FlowData.Connections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConnection.Hash);

			this._FlowView._ConnectionRenderer.renderConnection(
				tmpConnection,
				this._FlowView._ConnectionsLayer,
				tmpIsSelected
			);
		}

		// Render nodes
		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			let tmpSelectedSet = this._FlowView._FlowData.ViewState.SelectedNodeHashes;
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedNodeHash === tmpNode.Hash)
				|| (Array.isArray(tmpSelectedSet) && tmpSelectedSet.indexOf(tmpNode.Hash) >= 0);
			let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);

			// Enrich saved port data with metadata from the node type's DefaultPorts.
			// Saved flow data may not include PortType or may have stale Side values,
			// so we match each port to its DefaultPort counterpart by Label and Direction,
			// then copy over PortType and Side from the authoritative node type definition.
			if (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultPorts && tmpNode.Ports)
			{
				for (let p = 0; p < tmpNode.Ports.length; p++)
				{
					let tmpPort = tmpNode.Ports[p];
					for (let d = 0; d < tmpNodeTypeConfig.DefaultPorts.length; d++)
					{
						let tmpDefault = tmpNodeTypeConfig.DefaultPorts[d];
						if (tmpDefault.Label === tmpPort.Label && tmpDefault.Direction === tmpPort.Direction)
						{
							if (tmpDefault.PortType)
							{
								tmpPort.PortType = tmpDefault.PortType;
							}
							if (tmpDefault.Side)
							{
								tmpPort.Side = tmpDefault.Side;
							}
							break;
						}
					}
				}
			}

			// Dispatch through the renderable-renderer registry. The default
			// 'card' renderer is the node view, so existing diagrams (and
			// ultravisor) render identically; a node type can name a different
			// renderer via its RenderableType field. Fall back to the node view
			// directly when no registry is present (e.g. a minimal test harness).
			let tmpRenderer = (typeof this._FlowView.resolveRenderableRenderer === 'function')
				? this._FlowView.resolveRenderableRenderer(tmpNode, tmpNodeTypeConfig)
				: this._FlowView._NodeView;
			tmpRenderer.renderNode(tmpNode, this._FlowView._NodesLayer, tmpIsSelected, tmpNodeTypeConfig);
		}

		// Render properties panels and tethers
		if (this._FlowView._PropertiesPanelView && this._FlowView._PanelsLayer && this._FlowView._TethersLayer)
		{
			this._FlowView._PropertiesPanelView.renderPanels(
				this._FlowView._FlowData.OpenPanels,
				this._FlowView._PanelsLayer,
				this._FlowView._TethersLayer,
				this._FlowView._FlowData.ViewState.SelectedTetherHash
			);
		}

		// Update viewport transform
		this._FlowView.updateViewportTransform();
	}

	/**
	 * Re-render a single connection (remove and re-add) for smooth drag performance.
	 * @param {string} pConnectionHash
	 */
	renderSingleConnection(pConnectionHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		// Remove existing elements for this connection across all layers
		// where it might live (path / hit-area in connections, dots in
		// endpoints, hint paths in port-hints).
		this._removeConnectionElements(pConnectionHash);

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === pConnectionHash);
		this._FlowView._ConnectionRenderer.renderConnection(tmpConnection, this._FlowView._ConnectionsLayer, tmpIsSelected);
	}

	/**
	 * Re-render a single tether (remove and re-add) for smooth drag performance.
	 * @param {string} pPanelHash
	 */
	renderSingleTether(pPanelHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		// Remove existing tether elements for this panel
		let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${pPanelHash}"]`);
		for (let i = 0; i < tmpExisting.length; i++)
		{
			tmpExisting[i].remove();
		}

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		let tmpNodeData = this._FlowView.getNode(tmpPanel.NodeHash);
		if (!tmpNodeData) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === pPanelHash);
		this._FlowView._TetherService.renderTether(tmpPanel, tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
	}

	/**
	 * Update a single node's position in the SVG without full re-render (for drag performance)
	 * @param {string} pNodeHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateNodePosition(pNodeHash, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;

		if (this._FlowView.options.EnableGridSnap)
		{
			pX = this._FlowView._LayoutService.snapToGrid(pX, this._FlowView.options.GridSnapSize);
			pY = this._FlowView._LayoutService.snapToGrid(pY, this._FlowView.options.GridSnapSize);
		}

		tmpNode.X = pX;
		tmpNode.Y = pY;

		// Reset customized handle positions for connections/tethers involving this node
		this._FlowView._resetHandlesForNode(pNodeHash);

		// Update the node's SVG group transform for smooth dragging. PRESERVE the node's rotation -- a bare
		// translate here flattened a rotated card back to upright the instant you started dragging (matches
		// PictViewFlowNode.nodeTransform: rotate about the node center).
		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${pNodeHash}"]`);
		if (tmpNodeGroup)
		{
			let tmpRotation = (typeof tmpNode.Rotation === 'number') ? tmpNode.Rotation : 0;
			if (tmpRotation)
			{
				let tmpW = (typeof tmpNode.Width === 'number') ? tmpNode.Width : (this._FlowView.options.DefaultNodeWidth || 180);
				let tmpH = (typeof tmpNode.Height === 'number') ? tmpNode.Height : (this._FlowView.options.DefaultNodeHeight || 80);
				tmpNodeGroup.setAttribute('transform', `translate(${pX}, ${pY}) rotate(${tmpRotation} ${tmpW / 2} ${tmpH / 2})`);
			}
			else
			{
				tmpNodeGroup.setAttribute('transform', `translate(${pX}, ${pY})`);
			}
		}

		// Re-render connections that involve this node
		this.renderConnectionsForNode(pNodeHash);

		// Update tethers for any panels attached to this node
		this.renderTethersForNode(pNodeHash);
	}

	/**
	 * Re-render only connections that involve a specific node (for drag performance)
	 * @param {string} pNodeHash
	 */
	renderConnectionsForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		let tmpAffectedConnections = this._FlowView._FlowData.Connections.filter((pConn) =>
		{
			return pConn.SourceNodeHash === pNodeHash || pConn.TargetNodeHash === pNodeHash;
		});

		for (let i = 0; i < tmpAffectedConnections.length; i++)
		{
			let tmpConn = tmpAffectedConnections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConn.Hash);

			// Remove existing connection SVG elements across all layers
			this._removeConnectionElements(tmpConn.Hash);

			// Re-render this connection
			this._FlowView._ConnectionRenderer.renderConnection(tmpConn, this._FlowView._ConnectionsLayer, tmpIsSelected);
		}
	}

	/**
	 * Remove every SVG element tagged with `data-connection-hash="<hash>"`
	 * from any of the layers a connection might write into (connections,
	 * endpoints, port-hints). Centralised so per-connection re-render
	 * paths stay in sync with whatever layers ConnectionRenderer touches.
	 *
	 * @param {string} pConnectionHash
	 */
	_removeConnectionElements(pConnectionHash)
	{
		let tmpLayers =
		[
			this._FlowView._ConnectionsLayer,
			this._FlowView._EndpointsLayer,
			this._FlowView._PortHintsLayer
		];
		for (let i = 0; i < tmpLayers.length; i++)
		{
			let tmpLayer = tmpLayers[i];
			if (!tmpLayer) continue;
			let tmpExisting = tmpLayer.querySelectorAll(`[data-connection-hash="${pConnectionHash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}
		}
	}

	/**
	 * Re-render tethers for panels attached to a specific node (for drag performance).
	 * @param {string} pNodeHash
	 */
	renderTethersForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		let tmpAffectedPanels = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpAffectedPanels.length === 0) return;

		// Remove existing tethers for these panels and re-render via TetherService
		for (let i = 0; i < tmpAffectedPanels.length; i++)
		{
			let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${tmpAffectedPanels[i].Hash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}

			let tmpNodeData = this._FlowView.getNode(tmpAffectedPanels[i].NodeHash);
			if (!tmpNodeData) continue;

			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === tmpAffectedPanels[i].Hash);
			this._FlowView._TetherService.renderTether(tmpAffectedPanels[i], tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
		}
	}

	/**
	 * Re-inject SVG marker definitions (arrowheads).
	 * Called after a theme switch to update arrowhead colors.
	 */
	reinjectMarkerDefs()
	{
		if (!this._FlowView || !this._FlowView._ConnectorShapesProvider || !this._FlowView._SVGElement) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpDefs = this._FlowView._SVGElement.querySelector('defs');
		if (!tmpDefs) return;

		// Remove existing marker elements
		let tmpExistingMarkers = tmpDefs.querySelectorAll('marker');
		for (let i = 0; i < tmpExistingMarkers.length; i++)
		{
			tmpExistingMarkers[i].remove();
		}

		// Re-generate and inject
		let tmpMarkerMarkup = this._FlowView._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
		let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		tmpTempSVG.innerHTML = tmpMarkerMarkup;
		while (tmpTempSVG.firstChild)
		{
			tmpDefs.appendChild(tmpTempSVG.firstChild);
		}
	}
}

module.exports = PictServiceFlowRenderManager;

},{"fable-serviceproviderbase":59}],239:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-SelectionManager
 *
 * Manages selection state for nodes, connections, and tethers in the flow diagram.
 * Handles selecting, deselecting, and deleting selected elements.
 */
class PictServiceFlowSelectionManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowSelectionManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Select a node
	 * @param {string|null} pNodeHash - Hash of the node to select, or null to deselect
	 */
	selectNode(pNodeHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedNodeHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = pNodeHash;
		// Single selection keeps the set in lockstep, so the renderer (which highlights the set) and
		// any multi-select consumer see one consistent picture.
		this._FlowView._FlowData.ViewState.SelectedNodeHashes = pNodeHash ? [pNodeHash] : [];
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pNodeHash !== tmpPreviousSelection)
		{
			let tmpNode = pNodeHash ? this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pNodeHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onNodeSelected', tmpNode);
		}
	}

	/**
	 * The current selection set as an array of node hashes.
	 * @returns {Array<string>}
	 */
	getSelectedNodeHashes()
	{
		let tmpSet = this._FlowView._FlowData.ViewState.SelectedNodeHashes;
		return Array.isArray(tmpSet) ? tmpSet.slice() : [];
	}

	/**
	 * Toggle a node's membership in the selection set (shift-click). The primary SelectedNodeHash
	 * tracks the most recently affected member (or null when the set empties).
	 * @param {string} pNodeHash
	 */
	toggleNodeSelection(pNodeHash)
	{
		if (!pNodeHash) return;
		let tmpVS = this._FlowView._FlowData.ViewState;
		let tmpSet = Array.isArray(tmpVS.SelectedNodeHashes) ? tmpVS.SelectedNodeHashes.slice() : [];
		let tmpIndex = tmpSet.indexOf(pNodeHash);
		if (tmpIndex >= 0)
		{
			tmpSet.splice(tmpIndex, 1);
			tmpVS.SelectedNodeHash = tmpSet.length ? tmpSet[tmpSet.length - 1] : null;
		}
		else
		{
			tmpSet.push(pNodeHash);
			tmpVS.SelectedNodeHash = pNodeHash;
		}
		tmpVS.SelectedNodeHashes = tmpSet;
		tmpVS.SelectedConnectionHash = null;
		tmpVS.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider)
		{
			let tmpNode = tmpVS.SelectedNodeHash ? this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === tmpVS.SelectedNodeHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onNodeSelected', tmpNode);
		}
	}

	/**
	 * Replace the selection set with the given node hashes (marquee result).
	 * @param {Array<string>} pNodeHashes
	 */
	selectNodes(pNodeHashes)
	{
		let tmpVS = this._FlowView._FlowData.ViewState;
		let tmpSet = Array.isArray(pNodeHashes) ? pNodeHashes.slice() : [];
		tmpVS.SelectedNodeHashes = tmpSet;
		tmpVS.SelectedNodeHash = tmpSet.length ? tmpSet[tmpSet.length - 1] : null;
		tmpVS.SelectedConnectionHash = null;
		tmpVS.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider)
		{
			let tmpNode = tmpVS.SelectedNodeHash ? this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === tmpVS.SelectedNodeHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onNodeSelected', tmpNode);
		}
	}

	/**
	 * Select a connection
	 * @param {string|null} pConnectionHash - Hash of the connection to select, or null to deselect
	 */
	selectConnection(pConnectionHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedConnectionHash;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = pConnectionHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pConnectionHash !== tmpPreviousSelection)
		{
			let tmpConnection = pConnectionHash ? this._FlowView._FlowData.Connections.find((pConn) => pConn.Hash === pConnectionHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionSelected', tmpConnection);
		}
	}

	/**
	 * Select a tether by its panel hash.
	 * @param {string|null} pPanelHash - Hash of the panel whose tether to select, or null to deselect
	 */
	selectTether(pPanelHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedTetherHash;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = pPanelHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pPanelHash !== tmpPreviousSelection)
		{
			let tmpPanel = pPanelHash ? this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onTetherSelected', tmpPanel);
		}
	}

	/**
	 * Deselect all nodes and connections
	 */
	deselectAll()
	{
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedNodeHashes = [];
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;
		this._FlowView.renderFlow();
	}

	/**
	 * Delete the current selection: every node in the multi-select set (falling back to the single
	 * SelectedNodeHash), or the selected connection.
	 * @returns {boolean}
	 */
	deleteSelected()
	{
		let tmpVS = this._FlowView._FlowData.ViewState;
		let tmpSet = Array.isArray(tmpVS.SelectedNodeHashes) ? tmpVS.SelectedNodeHashes.slice() : [];
		if (tmpSet.length === 0 && tmpVS.SelectedNodeHash) { tmpSet = [tmpVS.SelectedNodeHash]; }

		if (tmpSet.length > 0)
		{
			tmpVS.SelectedNodeHash = null;
			tmpVS.SelectedNodeHashes = [];
			let tmpRemovedAny = false;
			// removeNode marshals/renders/fires events per call; for a multi-delete that is acceptable
			// (selections are small) and keeps each removal's event semantics intact.
			tmpSet.forEach((pHash) => { if (this._FlowView.removeNode(pHash)) { tmpRemovedAny = true; } });
			return tmpRemovedAny;
		}
		if (tmpVS.SelectedConnectionHash)
		{
			return this._FlowView.removeConnection(tmpVS.SelectedConnectionHash);
		}
		return false;
	}
}

module.exports = PictServiceFlowSelectionManager;

},{"fable-serviceproviderbase":59}],240:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-Tether
 *
 * Centralizes all tether geometry, path generation, handle state management,
 * and SVG rendering for the lines that connect properties panels to their nodes.
 *
 * Delegates to shared providers for:
 *   - SVG element creation (_FlowView._SVGHelperProvider)
 *   - Geometry calculations (_FlowView._GeometryProvider)
 *   - Path string building (_FlowView._PathGenerator)
 *
 * Responsibilities:
 *   - Smart 4-quadrant anchor detection (which edge of the node/panel to connect)
 *   - Bezier and orthogonal path generation
 *   - Auto-midpoint and auto-corner calculations
 *   - Handle position updates during drag
 *   - Handle reset when nodes or panels move
 *   - Line mode toggling (bezier <-> orthogonal)
 *   - SVG element creation for tether lines, hit areas, and drag handles
 */
class PictServiceFlowTether extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowTether';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Anchor Calculation ----

	/**
	 * Determine which node edge and panel edge to connect based on 4-quadrant detection.
	 * Uses the relative position of the panel center to the node center.
	 *
	 * @param {Object} pPanelData - Panel data with X, Y, Width, Height
	 * @param {Object} pNodeData - Node data with X, Y, Width, Height
	 * @returns {{nodeAnchor: {x,y,side}, panelAnchor: {x,y,side}}}
	 */
	getSmartAnchors(pPanelData, pNodeData)
	{
		let tmpNodeCX = pNodeData.X + pNodeData.Width / 2;
		let tmpNodeCY = pNodeData.Y + pNodeData.Height / 2;
		let tmpPanelCX = pPanelData.X + pPanelData.Width / 2;
		let tmpPanelCY = pPanelData.Y + pPanelData.Height / 2;

		let tmpDX = tmpPanelCX - tmpNodeCX;
		let tmpDY = tmpPanelCY - tmpNodeCY;

		let tmpNodeSide, tmpPanelSide;

		if (Math.abs(tmpDX) >= Math.abs(tmpDY))
		{
			// Panel is primarily to the left or right
			if (tmpDX >= 0)
			{
				tmpNodeSide = 'right';
				tmpPanelSide = 'left';
			}
			else
			{
				tmpNodeSide = 'left';
				tmpPanelSide = 'right';
			}
		}
		else
		{
			// Panel is primarily above or below
			if (tmpDY >= 0)
			{
				tmpNodeSide = 'bottom';
				tmpPanelSide = 'top';
			}
			else
			{
				tmpNodeSide = 'top';
				tmpPanelSide = 'bottom';
			}
		}

		let tmpNodeAnchor = this._FlowView._GeometryProvider.getEdgeCenter(pNodeData, tmpNodeSide);
		let tmpPanelAnchor = this._FlowView._GeometryProvider.getEdgeCenter(pPanelData, tmpPanelSide);

		return {
			nodeAnchor: Object.assign(tmpNodeAnchor, { side: tmpNodeSide }),
			panelAnchor: Object.assign(tmpPanelAnchor, { side: tmpPanelSide })
		};
	}

	// ---- Path Generation ----

	/**
	 * Generate a bezier path between two anchor points with directional departure/approach.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {number|null} pHandleX - User-set handle X or null for auto
	 * @param {number|null} pHandleY - User-set handle Y or null for auto
	 * @returns {string} SVG path d attribute
	 */
	generateBezierPath(pFrom, pTo, pHandleX, pHandleY)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		if (pHandleX == null || pHandleY == null)
		{
			// Auto bezier: simple cubic from depart to approach
			let tmpSpanX = Math.abs(tmpApproachX - tmpDepartX);
			let tmpSpanY = Math.abs(tmpApproachY - tmpDepartY);
			let tmpSpan = Math.max(tmpSpanX, tmpSpanY, 40);
			let tmpCPDist = tmpSpan * 0.4;

			let tmpCP1X = tmpDepartX + tmpFromDir.dx * tmpCPDist;
			let tmpCP1Y = tmpDepartY + tmpFromDir.dy * tmpCPDist;
			let tmpCP2X = tmpApproachX + tmpToDir.dx * tmpCPDist;
			let tmpCP2Y = tmpApproachY + tmpToDir.dy * tmpCPDist;

			return this._FlowView._PathGenerator.buildBezierPathString(
				{ x: pFrom.x, y: pFrom.y },
				{ x: tmpDepartX, y: tmpDepartY },
				{ x: tmpCP1X, y: tmpCP1Y },
				{ x: tmpCP2X, y: tmpCP2Y },
				{ x: tmpApproachX, y: tmpApproachY },
				{ x: pTo.x, y: pTo.y }
			);
		}

		// User-set handle: split bezier into two segments through handle
		let tmpCP1aDist = 30;
		let tmpCP1aX = tmpDepartX + tmpFromDir.dx * tmpCP1aDist;
		let tmpCP1aY = tmpDepartY + tmpFromDir.dy * tmpCP1aDist;

		let tmpCP2aDist = 30;
		let tmpCP2aX = tmpApproachX + tmpToDir.dx * tmpCP2aDist;
		let tmpCP2aY = tmpApproachY + tmpToDir.dy * tmpCP2aDist;

		// Tangent at the handle — direction from first segment end to second segment start
		let tmpTangentX = tmpApproachX - tmpDepartX;
		let tmpTangentY = tmpApproachY - tmpDepartY;
		let tmpTangentLen = Math.sqrt(tmpTangentX * tmpTangentX + tmpTangentY * tmpTangentY) || 1;
		tmpTangentX /= tmpTangentLen;
		tmpTangentY /= tmpTangentLen;
		let tmpTangentDist = 25;

		let tmpCP1bX = pHandleX - tmpTangentX * tmpTangentDist;
		let tmpCP1bY = pHandleY - tmpTangentY * tmpTangentDist;
		let tmpCP2bX = pHandleX + tmpTangentX * tmpTangentDist;
		let tmpCP2bY = pHandleY + tmpTangentY * tmpTangentDist;

		return this._FlowView._PathGenerator.buildSplitBezierPathString(
			{ x: pFrom.x, y: pFrom.y },
			{ x: tmpDepartX, y: tmpDepartY },
			{ x: tmpCP1aX, y: tmpCP1aY },
			{ x: tmpCP1bX, y: tmpCP1bY },
			{ x: pHandleX, y: pHandleY },
			{ x: tmpCP2bX, y: tmpCP2bY },
			{ x: tmpCP2aX, y: tmpCP2aY },
			{ x: tmpApproachX, y: tmpApproachY },
			{ x: pTo.x, y: pTo.y }
		);
	}

	/**
	 * Generate an orthogonal (90-degree) path between two anchor points.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Object|null} pCorners - {corner1: {x,y}, corner2: {x,y}} or null for auto
	 * @param {number} pMidOffset - Offset for the corridor midpoint
	 * @returns {string} SVG path d attribute
	 */
	generateOrthogonalPath(pFrom, pTo, pCorners, pMidOffset)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		let tmpCorner1, tmpCorner2;

		if (pCorners && pCorners.corner1 && pCorners.corner2)
		{
			tmpCorner1 = pCorners.corner1;
			tmpCorner2 = pCorners.corner2;
		}
		else
		{
			// Auto-calculate corners based on direction
			let tmpAutoCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pMidOffset);
			tmpCorner1 = tmpAutoCorners.corner1;
			tmpCorner2 = tmpAutoCorners.corner2;
		}

		return this._FlowView._PathGenerator.buildOrthogonalPathString(
			{ x: pFrom.x, y: pFrom.y },
			{ x: tmpDepartX, y: tmpDepartY },
			{ x: tmpCorner1.x, y: tmpCorner1.y },
			{ x: tmpCorner2.x, y: tmpCorner2.y },
			{ x: tmpApproachX, y: tmpApproachY },
			{ x: pTo.x, y: pTo.y }
		);
	}

	// ---- Handle Position Computation ----

	/**
	 * Get auto-calculated bezier midpoint for a tether at t=0.5 on the curve.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pFrom, pTo)
	{
		return this._FlowView._PathGenerator.getAutoMidpointSimple(pFrom, pTo, 20);
	}

	/**
	 * Get full orthogonal geometry including corners and midpoint for handle rendering.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Object} pPanelData - Panel data with tether handle properties
	 * @returns {{corner1: {x,y}, corner2: {x,y}, midpoint: {x,y}}}
	 */
	getOrthoGeometry(pFrom, pTo, pPanelData)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		let tmpCorners;
		if (pPanelData.TetherHandleCustomized && pPanelData.TetherOrthoCorner1X != null)
		{
			tmpCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pPanelData.TetherOrthoMidOffset || 0);
			tmpCorners.corner1 = { x: pPanelData.TetherOrthoCorner1X, y: pPanelData.TetherOrthoCorner1Y };
			tmpCorners.corner2 = { x: pPanelData.TetherOrthoCorner2X, y: pPanelData.TetherOrthoCorner2Y };
		}
		else
		{
			tmpCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pPanelData.TetherOrthoMidOffset || 0);
		}

		let tmpMidpoint =
		{
			x: (tmpCorners.corner1.x + tmpCorners.corner2.x) / 2,
			y: (tmpCorners.corner1.y + tmpCorners.corner2.y) / 2
		};

		return {
			corner1: tmpCorners.corner1,
			corner2: tmpCorners.corner2,
			midpoint: tmpMidpoint
		};
	}

	// ---- Path Generation (high-level) ----

	/**
	 * Generate the SVG path string for a tether based on its panel data and anchors.
	 * @param {Object} pPanelData - Panel data with tether handle properties
	 * @param {Object} pFrom - {x, y, side} panel anchor
	 * @param {Object} pTo - {x, y, side} node anchor
	 * @returns {string} SVG path d attribute
	 */
	generatePath(pPanelData, pFrom, pTo)
	{
		let tmpLineMode = pPanelData.TetherLineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpCorners = null;
			if (pPanelData.TetherHandleCustomized && pPanelData.TetherOrthoCorner1X != null)
			{
				tmpCorners =
				{
					corner1: { x: pPanelData.TetherOrthoCorner1X, y: pPanelData.TetherOrthoCorner1Y },
					corner2: { x: pPanelData.TetherOrthoCorner2X, y: pPanelData.TetherOrthoCorner2Y }
				};
			}
			return this.generateOrthogonalPath(pFrom, pTo, tmpCorners, pPanelData.TetherOrthoMidOffset || 0);
		}
		else
		{
			// Check for multi-handle array first
			let tmpHandles = this._getTetherBezierHandles(pPanelData);
			if (tmpHandles.length > 0)
			{
				return this.generateMultiBezierPath(pFrom, pTo, tmpHandles);
			}

			// Single-handle legacy path
			let tmpHandleX = (pPanelData.TetherHandleCustomized && pPanelData.TetherBezierHandleX != null) ? pPanelData.TetherBezierHandleX : null;
			let tmpHandleY = (pPanelData.TetherHandleCustomized && pPanelData.TetherBezierHandleY != null) ? pPanelData.TetherBezierHandleY : null;
			return this.generateBezierPath(pFrom, pTo, tmpHandleX, tmpHandleY);
		}
	}

	/**
	 * Get the bezier handles array for a tether, respecting the customized flag.
	 * @param {Object} pPanelData
	 * @returns {Array<{x: number, y: number}>}
	 */
	_getTetherBezierHandles(pPanelData)
	{
		if (!pPanelData || !pPanelData.TetherHandleCustomized)
		{
			return [];
		}

		// Multi-handle format
		if (Array.isArray(pPanelData.TetherBezierHandles) && pPanelData.TetherBezierHandles.length > 0)
		{
			return pPanelData.TetherBezierHandles;
		}

		// Legacy single-handle format
		if (pPanelData.TetherBezierHandleX != null && pPanelData.TetherBezierHandleY != null)
		{
			return [{ x: pPanelData.TetherBezierHandleX, y: pPanelData.TetherBezierHandleY }];
		}

		return [];
	}

	/**
	 * Generate a multi-handle bezier path for a tether.
	 * Delegates to PathGenerator.buildMultiBezierPathString.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Array<{x: number, y: number}>} pHandles
	 * @returns {string} SVG path d attribute
	 */
	generateMultiBezierPath(pFrom, pTo, pHandles)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepart = {
			x: pFrom.x + tmpFromDir.dx * tmpDepartDist,
			y: pFrom.y + tmpFromDir.dy * tmpDepartDist
		};
		let tmpApproach = {
			x: pTo.x + tmpToDir.dx * tmpDepartDist,
			y: pTo.y + tmpToDir.dy * tmpDepartDist
		};

		return this._FlowView._PathGenerator.buildMultiBezierPathString(
			pFrom, tmpDepart, pFrom.side, tmpApproach, pTo.side, pTo, pHandles);
	}

	// ---- Handle State Management ----

	/**
	 * Update a tether handle position during drag.
	 * @param {Object} pPanelData - Panel data to update
	 * @param {string} pHandleType - 'bezier-midpoint', 'ortho-corner1', 'ortho-corner2', 'ortho-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateHandlePosition(pPanelData, pHandleType, pX, pY)
	{
		pPanelData.TetherHandleCustomized = true;

		// Multi-handle bezier: handle type is 'bezier-handle-N'
		if (pHandleType && pHandleType.startsWith('bezier-handle-'))
		{
			let tmpIndex = parseInt(pHandleType.replace('bezier-handle-', ''), 10);
			if (!isNaN(tmpIndex) && Array.isArray(pPanelData.TetherBezierHandles)
				&& tmpIndex < pPanelData.TetherBezierHandles.length)
			{
				pPanelData.TetherBezierHandles[tmpIndex].x = pX;
				pPanelData.TetherBezierHandles[tmpIndex].y = pY;
			}
			return;
		}

		switch (pHandleType)
		{
			case 'bezier-midpoint':
				// Migrate to multi-handle array
				if (!Array.isArray(pPanelData.TetherBezierHandles)
					|| pPanelData.TetherBezierHandles.length === 0)
				{
					pPanelData.TetherBezierHandles = [{ x: pX, y: pY }];
				}
				else
				{
					pPanelData.TetherBezierHandles[0].x = pX;
					pPanelData.TetherBezierHandles[0].y = pY;
				}
				// Keep legacy fields in sync
				pPanelData.TetherBezierHandleX = pX;
				pPanelData.TetherBezierHandleY = pY;
				break;

			case 'ortho-corner1':
				pPanelData.TetherOrthoCorner1X = pX;
				pPanelData.TetherOrthoCorner1Y = pY;
				break;

			case 'ortho-corner2':
				pPanelData.TetherOrthoCorner2X = pX;
				pPanelData.TetherOrthoCorner2Y = pY;
				break;

			case 'ortho-midpoint':
				// Store the desired position for offset computation
				pPanelData.TetherOrthoMidOffset = (pPanelData.TetherOrthoMidOffset || 0);
				pPanelData._TetherMidDragX = pX;
				pPanelData._TetherMidDragY = pY;
				break;
		}
	}

	/**
	 * Reset tether handle positions to auto for a single panel.
	 * Preserves TetherLineMode but clears all handle coordinates.
	 * @param {Object} pPanelData - Panel data to reset
	 */
	resetHandlePositions(pPanelData)
	{
		if (pPanelData.TetherHandleCustomized)
		{
			pPanelData.TetherHandleCustomized = false;
			pPanelData.TetherBezierHandles = [];
			pPanelData.TetherBezierHandleX = null;
			pPanelData.TetherBezierHandleY = null;
			pPanelData.TetherOrthoCorner1X = null;
			pPanelData.TetherOrthoCorner1Y = null;
			pPanelData.TetherOrthoCorner2X = null;
			pPanelData.TetherOrthoCorner2Y = null;
			pPanelData.TetherOrthoMidOffset = 0;
		}
	}

	/**
	 * Reset tether handle positions for all panels attached to a node.
	 * Called when a node moves.
	 * @param {Array} pOpenPanels - Array of all open panel data objects
	 * @param {string} pNodeHash - The node hash whose panels should be reset
	 */
	resetHandlesForNode(pOpenPanels, pNodeHash)
	{
		for (let i = 0; i < pOpenPanels.length; i++)
		{
			let tmpPanel = pOpenPanels[i];
			if (tmpPanel.NodeHash === pNodeHash)
			{
				this.resetHandlePositions(tmpPanel);
			}
		}
	}

	/**
	 * Add a bezier handle to a tether at the specified position.
	 * @param {Object} pPanelData - Panel data
	 * @param {number} pX
	 * @param {number} pY
	 * @param {Object} pFrom - Panel anchor {x, y, side}
	 * @param {Object} pTo - Node anchor {x, y, side}
	 */
	addHandle(pPanelData, pX, pY, pFrom, pTo)
	{
		// Ensure bezier mode and multi-handle array
		pPanelData.TetherLineMode = 'bezier';

		if (!Array.isArray(pPanelData.TetherBezierHandles))
		{
			pPanelData.TetherBezierHandles = [];
			// Migrate legacy single-handle if present
			if (pPanelData.TetherBezierHandleX != null && pPanelData.TetherBezierHandleY != null)
			{
				pPanelData.TetherBezierHandles.push({
					x: pPanelData.TetherBezierHandleX,
					y: pPanelData.TetherBezierHandleY
				});
			}
		}

		// Compute insertion index
		let tmpInsertIndex = 0;
		if (this._FlowView._ConnectionRenderer && pFrom && pTo)
		{
			tmpInsertIndex = this._FlowView._ConnectionRenderer.computeInsertionIndex(
				pPanelData.TetherBezierHandles,
				{ x: pX, y: pY },
				pFrom,
				pTo
			);
		}

		pPanelData.TetherBezierHandles.splice(tmpInsertIndex, 0, { x: pX, y: pY });
		pPanelData.TetherHandleCustomized = true;
	}

	/**
	 * Remove a bezier handle from a tether by index.
	 * @param {Object} pPanelData - Panel data
	 * @param {number} pIndex - Index in TetherBezierHandles array
	 */
	removeHandle(pPanelData, pIndex)
	{
		if (!Array.isArray(pPanelData.TetherBezierHandles)) return;
		if (pIndex < 0 || pIndex >= pPanelData.TetherBezierHandles.length) return;

		pPanelData.TetherBezierHandles.splice(pIndex, 1);

		if (pPanelData.TetherBezierHandles.length === 0)
		{
			pPanelData.TetherHandleCustomized = false;
			pPanelData.TetherBezierHandleX = null;
			pPanelData.TetherBezierHandleY = null;
		}
	}

	/**
	 * Toggle tether line mode between bezier and orthogonal.
	 * Resets handle positions on toggle.
	 * @param {Object} pPanelData - Panel data to toggle
	 * @returns {string} The new line mode ('bezier' or 'orthogonal')
	 */
	toggleLineMode(pPanelData)
	{
		let tmpCurrentMode = pPanelData.TetherLineMode || 'bezier';
		pPanelData.TetherLineMode = (tmpCurrentMode === 'bezier') ? 'orthogonal' : 'bezier';

		pPanelData.TetherHandleCustomized = false;
		pPanelData.TetherBezierHandles = [];
		pPanelData.TetherBezierHandleX = null;
		pPanelData.TetherBezierHandleY = null;
		pPanelData.TetherOrthoCorner1X = null;
		pPanelData.TetherOrthoCorner1Y = null;
		pPanelData.TetherOrthoCorner2X = null;
		pPanelData.TetherOrthoCorner2Y = null;
		pPanelData.TetherOrthoMidOffset = 0;

		return pPanelData.TetherLineMode;
	}

	// ---- SVG Rendering ----

	/**
	 * Render a tether from a panel to its node.
	 * Creates SVG path elements for the line and hit area, plus drag handles when selected.
	 *
	 * @param {Object} pPanelData - Panel data with position and tether properties
	 * @param {Object} pNodeData - Node data with position
	 * @param {SVGGElement} pTethersLayer - SVG group to append elements to
	 * @param {boolean} pIsSelected - Whether this tether is currently selected
	 * @param {string} pViewIdentifier - The flow view identifier (for marker URL)
	 */
	renderTether(pPanelData, pNodeData, pTethersLayer, pIsSelected, pViewIdentifier)
	{
		if (!pNodeData) return;

		let tmpAnchors = this.getSmartAnchors(pPanelData, pNodeData);
		let tmpFrom = tmpAnchors.panelAnchor;
		let tmpTo = tmpAnchors.nodeAnchor;

		let tmpPath = this.generatePath(pPanelData, tmpFrom, tmpTo);

		// Hit area and visible tether path
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (tmpShapeProvider)
		{
			let tmpHitArea = tmpShapeProvider.createTetherHitAreaElement(tmpPath, pPanelData.Hash);
			pTethersLayer.appendChild(tmpHitArea);

			let tmpPathElement = tmpShapeProvider.createTetherPathElement(
				tmpPath, pPanelData.Hash, pIsSelected, pViewIdentifier);
			pTethersLayer.appendChild(tmpPathElement);
		}
		else
		{
			let tmpHitArea = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpHitArea.setAttribute('class', 'pict-flow-tether-hitarea');
			tmpHitArea.setAttribute('d', tmpPath);
			tmpHitArea.setAttribute('data-element-type', 'tether-hitarea');
			tmpHitArea.setAttribute('data-panel-hash', pPanelData.Hash);
			pTethersLayer.appendChild(tmpHitArea);

			let tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', `pict-flow-tether-line${pIsSelected ? ' selected' : ''}`);
			tmpPathElement.setAttribute('d', tmpPath);
			tmpPathElement.setAttribute('marker-end', `url(#flow-tether-arrowhead-${pViewIdentifier})`);
			tmpPathElement.setAttribute('data-element-type', 'tether');
			tmpPathElement.setAttribute('data-panel-hash', pPanelData.Hash);
			pTethersLayer.appendChild(tmpPathElement);
		}

		// Render drag handles when selected
		if (pIsSelected)
		{
			this._renderHandles(pPanelData, pTethersLayer, tmpFrom, tmpTo);
		}
	}

	/**
	 * Render drag handles for a selected tether.
	 * @param {Object} pPanelData
	 * @param {SVGGElement} pTethersLayer
	 * @param {Object} pFrom - Panel anchor {x, y, side}
	 * @param {Object} pTo - Node anchor {x, y, side}
	 */
	_renderHandles(pPanelData, pTethersLayer, pFrom, pTo)
	{
		let tmpLineMode = pPanelData.TetherLineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpGeom = this.getOrthoGeometry(pFrom, pTo, pPanelData);

			// Corner 1 handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-corner1',
				tmpGeom.corner1.x, tmpGeom.corner1.y, 'pict-flow-tether-handle');

			// Midpoint handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-midpoint',
				tmpGeom.midpoint.x, tmpGeom.midpoint.y, 'pict-flow-tether-handle-midpoint');

			// Corner 2 handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-corner2',
				tmpGeom.corner2.x, tmpGeom.corner2.y, 'pict-flow-tether-handle');
		}
		else
		{
			// Bezier handles
			let tmpHandles = this._getTetherBezierHandles(pPanelData);

			if (tmpHandles.length > 0)
			{
				// Multi-handle: render each handle as a draggable circle
				for (let i = 0; i < tmpHandles.length; i++)
				{
					this._createHandle(pTethersLayer, pPanelData.Hash, 'bezier-handle-' + i,
						tmpHandles[i].x, tmpHandles[i].y, 'pict-flow-tether-handle');
				}
			}
			else
			{
				// No custom handles: show auto-computed midpoint
				let tmpMid = this.getAutoMidpoint(pFrom, pTo);
				this._createHandle(pTethersLayer, pPanelData.Hash, 'bezier-midpoint',
					tmpMid.x, tmpMid.y, 'pict-flow-tether-handle-midpoint');
			}
		}
	}

	/**
	 * Create a single tether drag handle circle.
	 * @param {SVGGElement} pLayer
	 * @param {string} pPanelHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pClassName
	 */
	_createHandle(pLayer, pPanelHash, pHandleType, pX, pY, pClassName)
	{
		if (!this._FlowView._ConnectorShapesProvider) return;

		let tmpShapeKey = (pClassName === 'pict-flow-tether-handle-midpoint')
			? 'tether-handle-midpoint' : 'tether-handle';

		this._FlowView._ConnectorShapesProvider.createFullHandle(
			pLayer, pPanelHash, pHandleType, pX, pY,
			tmpShapeKey, 'tether-handle', 'data-panel-hash');
	}
}

module.exports = PictServiceFlowTether;

},{"fable-serviceproviderbase":59}],241:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-ViewportManager
 *
 * Manages viewport transforms (pan/zoom), coordinate conversion between
 * screen and SVG space, zoom-to-fit calculations, and fullscreen toggling
 * for the flow diagram.
 */
class PictServiceFlowViewportManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowViewportManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._IsFullscreen = false;
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		if (!this._FlowView._ViewportElement) return;
		let tmpVS = this._FlowView._FlowData.ViewState;
		this._FlowView._ViewportElement.setAttribute('transform',
			`translate(${tmpVS.PanX}, ${tmpVS.PanY}) scale(${tmpVS.Zoom})`
		);
		this.updateZoomInvariantChrome();
	}

	/**
	 * Re-counter-scale the interaction chrome (node resize / rotate grips, frame handles) so it holds a
	 * constant on-screen size across a zoom change.
	 *
	 * This hangs off updateViewportTransform because that is the one place every pan and zoom path already
	 * funnels through, and because zooming does NOT re-render nodes -- it only rewrites the viewport
	 * transform. Without this the handles simply shrink with the board until they are too small to hit,
	 * which is exactly what happens on a board wide enough to need a low zoom to see whole.
	 */
	updateZoomInvariantChrome()
	{
		let tmpViewport = this._FlowView._ViewportElement;
		if (!tmpViewport || typeof tmpViewport.querySelectorAll !== 'function') { return; }
		let tmpHelper = this._FlowView._SVGHelperProvider;
		if (!tmpHelper || typeof tmpHelper.zoomInvariantTransform !== 'function') { return; }
		let tmpZoom = this._FlowView._FlowData.ViewState.Zoom;
		let tmpGroups = tmpViewport.querySelectorAll('.pict-flow-zoom-invariant');
		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpElement = tmpGroups[i];
			tmpElement.setAttribute('transform', tmpHelper.zoomInvariantTransform(
				tmpElement.getAttribute('data-zoom-anchor-x'),
				tmpElement.getAttribute('data-zoom-anchor-y'),
				tmpZoom));
		}
	}

	/**
	 * Pan the viewport by a delta in screen pixels (added to the current pan).
	 * Used by wheel-pan and any consumer that wants to nudge the canvas.
	 * @param {number} pDX
	 * @param {number} pDY
	 */
	panBy(pDX, pDY)
	{
		let tmpVS = this._FlowView._FlowData.ViewState;
		tmpVS.PanX += pDX;
		tmpVS.PanY += pDY;
		this.updateViewportTransform();
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		let tmpNewZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, pZoom));
		let tmpOldZoom = this._FlowView._FlowData.ViewState.Zoom;

		if (typeof pFocusX === 'number' && typeof pFocusY === 'number')
		{
			// Zoom toward focus point
			let tmpVS = this._FlowView._FlowData.ViewState;
			tmpVS.PanX = pFocusX - (pFocusX - tmpVS.PanX) * (tmpNewZoom / tmpOldZoom);
			tmpVS.PanY = pFocusY - (pFocusY - tmpVS.PanY) * (tmpNewZoom / tmpOldZoom);
		}

		this._FlowView._FlowData.ViewState.Zoom = tmpNewZoom;
		this.updateViewportTransform();
	}

	/**
	 * Zoom to fit all nodes in the viewport.
	 * @param {boolean} pAllowZoomIn - when true the fit may scale UP past 1.0 (to MaxZoom) so a small board
	 *   fills the viewport. Default (falsy) keeps the historic behavior: never zoom in past 1.0, so content
	 *   stays true-to-scale and a sparse map does not balloon. Presentation banners opt in.
	 */
	zoomToFit(pAllowZoomIn)
	{
		if (this._FlowView._FlowData.Nodes.length === 0) return;
		if (!this._FlowView._SVGElement) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			tmpMinX = Math.min(tmpMinX, tmpNode.X);
			tmpMinY = Math.min(tmpMinY, tmpNode.Y);
			tmpMaxX = Math.max(tmpMaxX, tmpNode.X + tmpNode.Width);
			tmpMaxY = Math.max(tmpMaxY, tmpNode.Y + tmpNode.Height);
		}

		let tmpPadding = 50;
		let tmpFlowWidth = tmpMaxX - tmpMinX + tmpPadding * 2;
		let tmpFlowHeight = tmpMaxY - tmpMinY + tmpPadding * 2;

		let tmpSVGRect = this._FlowView._SVGElement.getBoundingClientRect();
		let tmpScaleX = tmpSVGRect.width / tmpFlowWidth;
		let tmpScaleY = tmpSVGRect.height / tmpFlowHeight;
		let tmpZoom = Math.min(tmpScaleX, tmpScaleY);
		if (!pAllowZoomIn) { tmpZoom = Math.min(tmpZoom, 1.0); } // Don't zoom in past 1.0 unless the caller opts in
		tmpZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, tmpZoom));

		let tmpCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCenterY = (tmpMinY + tmpMaxY) / 2;

		this._FlowView._FlowData.ViewState.Zoom = tmpZoom;
		this._FlowView._FlowData.ViewState.PanX = (tmpSVGRect.width / 2) - (tmpCenterX * tmpZoom);
		this._FlowView._FlowData.ViewState.PanY = (tmpSVGRect.height / 2) - (tmpCenterY * tmpZoom);

		this.updateViewportTransform();
	}

	/**
	 * Fit the viewport to a content frame box (origin + size in content space),
	 * centering it with a little padding. Mirrors zoomToFit but for a fixed box
	 * rather than the node bounds.
	 * @param {Object} pFrame - { X, Y, Width, Height }
	 * @returns {boolean}
	 */
	fitToFrame(pFrame)
	{
		if (!pFrame || !pFrame.Width || !pFrame.Height) return false;
		if (!this._FlowView._SVGElement) return false;

		let tmpPadding = 20;
		let tmpFrameWidth = pFrame.Width + tmpPadding * 2;
		let tmpFrameHeight = pFrame.Height + tmpPadding * 2;

		let tmpSVGRect = this._FlowView._SVGElement.getBoundingClientRect();
		let tmpScaleX = tmpSVGRect.width / tmpFrameWidth;
		let tmpScaleY = tmpSVGRect.height / tmpFrameHeight;
		let tmpZoom = Math.min(tmpScaleX, tmpScaleY);
		tmpZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, tmpZoom));

		let tmpCenterX = (pFrame.X || 0) + pFrame.Width / 2;
		let tmpCenterY = (pFrame.Y || 0) + pFrame.Height / 2;

		this._FlowView._FlowData.ViewState.Zoom = tmpZoom;
		this._FlowView._FlowData.ViewState.PanX = (tmpSVGRect.width / 2) - (tmpCenterX * tmpZoom);
		this._FlowView._FlowData.ViewState.PanY = (tmpSVGRect.height / 2) - (tmpCenterY * tmpZoom);

		this.updateViewportTransform();
		return true;
	}

	/**
	 * Fit the frame's WIDTH to the container width (vs fitToFrame, which contains the whole
	 * frame and centers it), anchoring the frame's top-left at the container's top-left plus
	 * an optional top margin. Content outside the frame bleeds past the edges on purpose;
	 * vertical overflow is the host's call (a jumbotron clips to the frame height, a
	 * fullscreen / background view lets the user scroll down).
	 * @param {Object} pFrame - { X, Y, Width }
	 * @param {Object} [pOptions] - { TopMargin }
	 * @returns {boolean}
	 */
	fitToFrameWidth(pFrame, pOptions)
	{
		if (!pFrame || !pFrame.Width) return false;
		if (!this._FlowView._SVGElement) return false;

		let tmpRect = this._FlowView._SVGElement.getBoundingClientRect();
		let tmpResult = PictServiceFlowViewportManager.computeFitToWidth(pFrame, tmpRect.width,
			{
				TopMargin: (pOptions && pOptions.TopMargin) || 0,
				MinZoom: this._FlowView.options.MinZoom,
				MaxZoom: this._FlowView.options.MaxZoom
			});

		this._FlowView._FlowData.ViewState.Zoom = tmpResult.Zoom;
		this._FlowView._FlowData.ViewState.PanX = tmpResult.PanX;
		this._FlowView._FlowData.ViewState.PanY = tmpResult.PanY;

		this.updateViewportTransform();
		return true;
	}

	/**
	 * Pure fit-to-width math: zoom so the frame's width equals the container width (clamped to
	 * the view's zoom bounds), and pan so the frame's top-left sits at (0, TopMargin). No DOM,
	 * so it is unit tested directly.
	 * @param {Object} pFrame - { X, Y, Width }
	 * @param {number} pContainerWidth
	 * @param {Object} [pOptions] - { TopMargin, MinZoom, MaxZoom }
	 * @returns {{Zoom:number, PanX:number, PanY:number}}
	 */
	static computeFitToWidth(pFrame, pContainerWidth, pOptions)
	{
		let tmpOptions = pOptions || {};
		let tmpZoom = (pFrame && pFrame.Width > 0 && pContainerWidth > 0) ? (pContainerWidth / pFrame.Width) : 1;
		let tmpMin = (typeof tmpOptions.MinZoom === 'number') ? tmpOptions.MinZoom : 0.05;
		let tmpMax = (typeof tmpOptions.MaxZoom === 'number') ? tmpOptions.MaxZoom : 8;
		tmpZoom = Math.max(tmpMin, Math.min(tmpMax, tmpZoom));
		let tmpTopMargin = tmpOptions.TopMargin || 0;
		return {
			Zoom: tmpZoom,
			PanX: -(((pFrame && pFrame.X) || 0) * tmpZoom),
			PanY: tmpTopMargin - (((pFrame && pFrame.Y) || 0) * tmpZoom)
		};
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		if (!this._FlowView._SVGElement)
		{
			return { x: pScreenX, y: pScreenY };
		}

		let tmpPoint = this._FlowView._SVGElement.createSVGPoint();
		tmpPoint.x = pScreenX;
		tmpPoint.y = pScreenY;

		let tmpCTM = this._FlowView._SVGElement.getScreenCTM();
		if (tmpCTM)
		{
			let tmpInverse = tmpCTM.inverse();
			let tmpTransformed = tmpPoint.matrixTransform(tmpInverse);
			// Account for viewport pan/zoom
			let tmpVS = this._FlowView._FlowData.ViewState;
			return {
				x: (tmpTransformed.x - tmpVS.PanX) / tmpVS.Zoom,
				y: (tmpTransformed.y - tmpVS.PanY) / tmpVS.Zoom
			};
		}

		return { x: pScreenX, y: pScreenY };
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length < 1) return this._IsFullscreen;

		let tmpContainer = tmpContainerElements[0];

		this._IsFullscreen = !this._IsFullscreen;

		if (this._IsFullscreen)
		{
			tmpContainer.classList.add('pict-flow-fullscreen');
		}
		else
		{
			tmpContainer.classList.remove('pict-flow-fullscreen');
		}

		return this._IsFullscreen;
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		if (!this._IsFullscreen) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length > 0)
		{
			tmpContainerElements[0].classList.remove('pict-flow-fullscreen');
		}

		this._IsFullscreen = false;
	}
}

module.exports = PictServiceFlowViewportManager;

},{"fable-serviceproviderbase":59}],242:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-FloatingToolbar',

	DefaultRenderable: 'Flow-FloatingToolbar-Content',
	DefaultDestinationAddress: '#Flow-FloatingToolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	// Host-supplied buttons (mirrors the docked toolbar's ToolbarExtraButtons), so floating mode keeps
	// the same custom buttons. Each entry is { Hash, Icon, Label?, Tooltip?, Active? }.
	ToolbarExtraButtons: [],

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-FloatingToolbar-Template',
			// Inline handlers route to the floating toolbar view via _Pict.views
			// (see _handleButtonClick / _startDrag / _toggleCollapse).
			Template: /*html*/`
<div class="pict-flow-floating-toolbar" id="Flow-FloatingToolbar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-floating-grip" id="Flow-FloatingGrip-{~D:Record.FlowViewIdentifier~}" title="Drag to move · Double-click to collapse"
		onmousedown="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._startDrag(event)"
		ondblclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleGripDoubleClick(event)">
		<span id="Flow-FloatingIcon-grip-{~D:Record.FlowViewIdentifier~}"></span>
	</div>
	<button class="pict-flow-floating-btn" data-flow-action="add-node" title="Add Node"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('add-node')">
		<span id="Flow-FloatingIcon-plus-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="cards-popup" title="Cards"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('cards-popup')">
		<span id="Flow-FloatingIcon-cards-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="delete-selected" title="Delete Selected"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('delete-selected')">
		<span id="Flow-FloatingIcon-trash-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-in" title="Zoom In"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-in')">
		<span id="Flow-FloatingIcon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-out" title="Zoom Out"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-out')">
		<span id="Flow-FloatingIcon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-fit" title="Fit to View"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-fit')">
		<span id="Flow-FloatingIcon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="auto-layout" title="Auto Layout"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('auto-layout')">
		<span id="Flow-FloatingIcon-auto-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="layout-popup" title="Layout"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('layout-popup')">
		<span id="Flow-FloatingIcon-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="fullscreen" title="Toggle Fullscreen"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('fullscreen')">
		<span id="Flow-FloatingIcon-fullscreen-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	{~TS:Flow-FloatingToolbar-Extra-Button:Record.ToolbarExtraButtons~}
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="dock-toolbar" title="Dock Toolbar"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('dock-toolbar')">
		<span id="Flow-FloatingIcon-dock-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
`
		},
		{
			Hash: 'Flow-FloatingToolbar-Extra-Button',
			// Icon-only host button (the floating toolbar is compact). Icon span
			// is filled post-render by _populateIcons (keyed by Hash).
			Template: /*html*/`<button class="pict-flow-floating-btn{~D:Record.ToggleClass~}{~D:Record.ActiveClass~}" title="{~D:Record.Tooltip~}" data-flow-action="extra" data-extra-hash="{~D:Record.Hash~}"
	onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleExtraClick('{~D:Record.Hash~}', this)">
	<span id="Flow-FloatingExtraIcon-{~D:Record.Hash~}-{~D:Record.FlowViewIdentifier~}"></span>
	<span class="pict-flow-toolbar-btn-led" aria-hidden="true"></span>
</button>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-FloatingToolbar-Content',
			TemplateHash: 'Flow-FloatingToolbar-Template',
			DestinationAddress: '#Flow-FloatingToolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowFloatingToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowFloatingToolbar';

		this._ToolbarView = null;
		this._FlowView = null;

		this._IsCollapsed = false;

		this._IsDragging = false;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragStartLeft = 0;
		this._DragStartTop = 0;

		this._BoundMouseMove = null;
		this._BoundMouseUp = null;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		// Stamp the owning view onto each host button so its row resolves.
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (Array.isArray(tmpExtraButtons))
		{
			for (let i = 0; i < tmpExtraButtons.length; i++)
			{
				tmpExtraButtons[i].FlowViewIdentifier = this.options.FlowViewIdentifier;
				// Mirror the docked toolbar so toggle buttons show the same status LED here.
				tmpExtraButtons[i].ToggleClass = tmpExtraButtons[i].Toggle ? ' pict-flow-toolbar-btn-toggle' : '';
				tmpExtraButtons[i].ActiveClass = tmpExtraButtons[i].Active ? ' pict-flow-toolbar-btn-active' : '';
			}
		}
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	/**
	 * Handle a click on a host-supplied (ToolbarExtraButtons) floating button.
	 * Routes to the docked toolbar's _handleExtraAction (the single dispatch
	 * point that fires the FlowView's onToolbarButton hook).
	 *
	 * @param {string} pHash - The button's Hash
	 * @param {HTMLElement} pElement - The clicked button element
	 */
	_handleExtraClick(pHash, pElement)
	{
		if (this._ToolbarView)
		{
			this._ToolbarView._handleExtraAction(pHash, pElement);
		}
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Button clicks and grip drag/dblclick are wired inline in
		// Flow-FloatingToolbar-Template — see _handleButtonClick / _startDrag /
		// _handleGripDoubleClick. Only icon population and option-based
		// pruning happen here.
		this._populateIcons();

		let tmpFloatingToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpFloatingToolbar.length > 0)
		{
			if (this.options.EnableAddNode === false)
			{
				let tmpAddNodeBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="add-node"]');
				if (tmpAddNodeBtn)
				{
					tmpAddNodeBtn.remove();
				}
			}
			if (this.options.EnableCardPalette === false)
			{
				let tmpCardsBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="cards-popup"]');
				if (tmpCardsBtn)
				{
					tmpCardsBtn.remove();
				}
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Handle a click on a floating toolbar action button. Called from the
	 * inline `onclick` handler on each button.
	 *
	 * @param {string} pAction - Value of the button's data-flow-action attr
	 */
	_handleButtonClick(pAction)
	{
		if (pAction === 'dock-toolbar')
		{
			if (this._ToolbarView)
			{
				this._ToolbarView._setToolbarMode('docked');
			}
			return;
		}
		if (this._ToolbarView)
		{
			this._ToolbarView._handleToolbarAction(pAction);
		}
	}

	/**
	 * Handle a double-click on the grip. Toggles collapsed state and
	 * prevents the event from reaching the surrounding canvas. Called
	 * from the inline `ondblclick` handler.
	 *
	 * @param {Event} pEvent
	 */
	_handleGripDoubleClick(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function')
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		this._toggleCollapse();
	}

	/**
	 * Populate SVG icons into all floating toolbar button spans.
	 */
	_populateIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		let tmpIconMap =
		{
			'grip': 'grip',
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto-layout': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'fullscreen': 'fullscreen',
			'dock': 'dock'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-FloatingIcon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 16);
			}
		}

		// Host-supplied extra buttons (keyed by Hash, icon from the button's Icon key).
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (Array.isArray(tmpExtraButtons))
		{
			for (let i = 0; i < tmpExtraButtons.length; i++)
			{
				let tmpExtraIcon = this.pict.ContentAssignment.getElement(`#Flow-FloatingExtraIcon-${tmpExtraButtons[i].Hash}-${tmpFlowViewIdentifier}`);
				if (tmpExtraIcon.length > 0)
				{
					tmpExtraIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpExtraButtons[i].Icon, 16);
				}
			}
		}
	}

	/**
	 * Toggle the floating toolbar between expanded and collapsed (grip-only square) states.
	 */
	_toggleCollapse()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		this._IsCollapsed = !this._IsCollapsed;

		if (this._IsCollapsed)
		{
			tmpToolbar[0].classList.add('collapsed');
		}
		else
		{
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Start dragging the floating toolbar.
	 * @param {MouseEvent} pEvent
	 */
	_startDrag(pEvent)
	{
		pEvent.preventDefault();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		this._IsDragging = true;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._DragStartLeft = tmpEl.offsetLeft;
		this._DragStartTop = tmpEl.offsetTop;

		this._BoundMouseMove = (pMoveEvent) => { this._onDragMove(pMoveEvent); };
		this._BoundMouseUp = () => { this._onDragEnd(); };

		document.addEventListener('mousemove', this._BoundMouseMove);
		document.addEventListener('mouseup', this._BoundMouseUp);
	}

	/**
	 * Handle drag movement.
	 * @param {MouseEvent} pEvent
	 */
	_onDragMove(pEvent)
	{
		if (!this._IsDragging) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		let tmpDeltaX = pEvent.clientX - this._DragStartX;
		let tmpDeltaY = pEvent.clientY - this._DragStartY;

		let tmpNewLeft = this._DragStartLeft + tmpDeltaX;
		let tmpNewTop = this._DragStartTop + tmpDeltaY;

		// Clamp to parent bounds
		let tmpParent = tmpEl.parentElement;
		if (tmpParent)
		{
			let tmpMaxLeft = tmpParent.clientWidth - tmpEl.offsetWidth;
			let tmpMaxTop = tmpParent.clientHeight - tmpEl.offsetHeight;
			tmpNewLeft = Math.max(0, Math.min(tmpNewLeft, tmpMaxLeft));
			tmpNewTop = Math.max(0, Math.min(tmpNewTop, tmpMaxTop));
		}

		tmpEl.style.left = tmpNewLeft + 'px';
		tmpEl.style.top = tmpNewTop + 'px';
	}

	/**
	 * End dragging.
	 */
	_onDragEnd()
	{
		this._IsDragging = false;

		if (this._BoundMouseMove)
		{
			document.removeEventListener('mousemove', this._BoundMouseMove);
			this._BoundMouseMove = null;
		}
		if (this._BoundMouseUp)
		{
			document.removeEventListener('mouseup', this._BoundMouseUp);
			this._BoundMouseUp = null;
		}

		// Save position
		if (this._ToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
			if (tmpToolbar.length > 0)
			{
				this._ToolbarView._FloatingPosition.X = tmpToolbar[0].offsetLeft;
				this._ToolbarView._FloatingPosition.Y = tmpToolbar[0].offsetTop;
			}
		}
	}

	/**
	 * Show the floating toolbar at the saved position.
	 */
	show()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'block';
		}

		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length > 0 && this._ToolbarView)
		{
			tmpToolbar[0].style.left = this._ToolbarView._FloatingPosition.X + 'px';
			tmpToolbar[0].style.top = this._ToolbarView._FloatingPosition.Y + 'px';
		}

		// Restore expanded state when showing
		if (this._IsCollapsed && tmpToolbar.length > 0)
		{
			this._IsCollapsed = false;
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Hide the floating toolbar.
	 */
	hide()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'none';
		}
	}
}

module.exports = PictViewFlowFloatingToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":365}],243:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-NodeRenderer',

	AutoRender: false,

	// Title bar height for nodes
	NodeTitleBarHeight: 22
};

class PictViewFlowNode extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowNode';

		this._FlowView = null;
	}

	/**
	 * Render a node into the nodes SVG layer
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pNodesLayer - The SVG <g> element to append to
	 * @param {boolean} pIsSelected - Whether this node is selected
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	renderNode(pNodeData, pNodesLayer, pIsSelected, pNodeTypeConfig)
	{
		let tmpGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');

		// Build CSS class list with optional per-type modifier classes
		let tmpClassList = `pict-flow-node ${pIsSelected ? 'selected' : ''} pict-flow-node-${pNodeData.Type || 'default'}`;
		if (pNodeTypeConfig)
		{
			if (pNodeTypeConfig.PortLabelsOnHover) tmpClassList += ' pict-flow-node-port-labels-hover';
			if (pNodeTypeConfig.PortLabelsVertical) tmpClassList += ' pict-flow-node-port-labels-vertical';
		}

		// Resolve theme-aware ColorRole. Per-node override wins; falls back
		// to the node type's role. A role of 'none' (or empty string)
		// explicitly opts out — useful when a card wants to keep its
		// hex BodyStyle/TitleBarColor regardless of the host theme.
		let tmpColorRole = (typeof pNodeData.ColorRole !== 'undefined')
			? pNodeData.ColorRole
			: (pNodeTypeConfig && pNodeTypeConfig.ColorRole);
		if (tmpColorRole && tmpColorRole !== 'none')
		{
			tmpClassList += ' pict-flow-node-color-' + tmpColorRole;
		}
		// A host can stamp an extra CSS class onto a node via node.NodeClass (e.g. a moodboard marks a
		// card whose connection points should stay visible on a read-only board). Survives re-renders
		// because it lives on the node data.
		if (typeof pNodeData.NodeClass === 'string' && pNodeData.NodeClass)
		{
			tmpClassList += ' ' + pNodeData.NodeClass;
		}
		tmpGroup.setAttribute('class', tmpClassList);
		tmpGroup.setAttribute('transform', `translate(${pNodeData.X}, ${pNodeData.Y})`);
		tmpGroup.setAttribute('data-node-hash', pNodeData.Hash);
		tmpGroup.setAttribute('data-element-type', 'node');

		// Hover the whole node → activate every port-hint that points
		// at any of this node's ports. Lets the user see *all* of the
		// node's reroute lines at once, not just one badge at a time.
		if (this._FlowView._PortRenderer && typeof this._FlowView._PortRenderer._wirePortHintHover === 'function')
		{
			this._FlowView._PortRenderer._wirePortHintHover(tmpGroup, null, pNodeData.Hash);
		}

		let tmpWidth = pNodeData.Width || 180;
		let tmpHeight = pNodeData.Height || 80;
		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;

		// Ensure node is tall enough for all ports in their zones
		let tmpGeomProvider = this._FlowView._GeometryProvider;
		if (tmpGeomProvider && pNodeData.Ports && pNodeData.Ports.length > 0)
		{
			let tmpMinHeight = tmpGeomProvider.computeMinimumNodeHeight(pNodeData.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Write the adjusted dimensions back to the node data so that
		// connection rendering (which reads pNodeData.Width/Height to
		// compute port positions) uses the same values we render with.
		pNodeData.Width = tmpWidth;
		pNodeData.Height = tmpHeight;

		// Optional rotation (degrees) about the node's center. Applied on top of the position
		// translate so free-form canvases can tilt a card; zero / unset leaves it axis-aligned.
		if (typeof pNodeData.Rotation === 'number' && pNodeData.Rotation)
		{
			tmpGroup.setAttribute('transform', PictViewFlowNode.nodeTransform(pNodeData.X, pNodeData.Y, pNodeData.Rotation, tmpWidth, tmpHeight));
		}

		// Determine node body mode from theme (bracket vs rect)
		let tmpNodeBodyMode = 'rect';
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.NodeBodyMode)
			{
				tmpNodeBodyMode = tmpActiveTheme.NodeBodyMode;
			}
		}

		if (tmpNodeBodyMode === 'bracket')
		{
			this._renderBracketNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}
		else
		{
			this._renderRectNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}

		// Determine if this node has a title-bar icon (FlowCard with CardMetadata)
		let tmpHasTitleIcon = false;
		let tmpTitleIconSize = 12;
		let tmpTitleIconMarginLeft = 8;
		let tmpTitleIconGap = 4;

		if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata)
		{
			let tmpMeta = pNodeTypeConfig.CardMetadata;
			let tmpIconProvider = this._FlowView._IconProvider;
			if (tmpMeta.Icon || tmpIconProvider)
			{
				tmpHasTitleIcon = true;
			}
		}

		// Title text (position adjusts when a title-bar icon is present)
		let tmpTitle = this._FlowView._SVGHelperProvider.createSVGElement('text');
		tmpTitle.setAttribute('class', 'pict-flow-node-title');
		if (tmpHasTitleIcon)
		{
			tmpTitle.setAttribute('x', String(tmpTitleIconMarginLeft + tmpTitleIconSize + tmpTitleIconGap));
			tmpTitle.setAttribute('text-anchor', 'start');
		}
		else
		{
			tmpTitle.setAttribute('x', String(tmpWidth / 2));
			tmpTitle.setAttribute('text-anchor', 'middle');
		}
		tmpTitle.setAttribute('y', String(tmpTitleBarHeight / 2 + 1));
		tmpTitle.setAttribute('dominant-baseline', 'central');
		tmpTitle.textContent = pNodeData.Title || 'Untitled';
		tmpGroup.appendChild(tmpTitle);

		// Determine whether labels should be rendered
		let tmpShowTypeLabel = (!pNodeTypeConfig || pNodeTypeConfig.ShowTypeLabel !== false);
		let tmpLabelsInFront = (!pNodeTypeConfig || pNodeTypeConfig.LabelsInFront !== false);

		// Helper: render type label + code badge + tooltip (the "middle labels")
		let tmpRenderTypeLabels = () =>
		{
			// Type label (below title bar — hover-only for FlowCard nodes via CSS)
			if (tmpShowTypeLabel && pNodeTypeConfig && pNodeTypeConfig.Label && pNodeTypeConfig.Label !== pNodeData.Title)
			{
				let tmpTypeLabel = this._FlowView._SVGHelperProvider.createSVGElement('text');
				tmpTypeLabel.setAttribute('class', 'pict-flow-node-type-label');
				tmpTypeLabel.setAttribute('x', String(tmpWidth / 2));
				tmpTypeLabel.setAttribute('y', String(tmpTitleBarHeight + 16));
				tmpTypeLabel.setAttribute('text-anchor', 'middle');
				tmpTypeLabel.setAttribute('dominant-baseline', 'central');
				tmpTypeLabel.textContent = pNodeTypeConfig.Label;
				tmpGroup.appendChild(tmpTypeLabel);
			}

			// FlowCard metadata: icon in title bar, code badge in body (hover-only via CSS). Skip the
			// title icon entirely when there is no title bar (height 0), e.g. edge-to-edge moodboard
			// cards, otherwise the default fallback glyph paints in the card's top-left corner.
			if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata && tmpTitleBarHeight > 0)
			{
				let tmpMeta = pNodeTypeConfig.CardMetadata;
				let tmpIconProvider = this._FlowView._IconProvider;
				let tmpTitleIconRendered = false;

				// Icon position in title bar (vertically centered)
				let tmpIconX = tmpTitleIconMarginLeft;
				let tmpIconY = (tmpTitleBarHeight - tmpTitleIconSize) / 2;

				if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// SVG icon via the icon provider — rendered into title bar
					let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						tmpResolvedKey, tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon && tmpIconProvider && tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// Emoji icon in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon)
				{
					// No icon provider — text fallback in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}

				// Default fallback icon in title bar
				if (!tmpTitleIconRendered && tmpIconProvider)
				{
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						'default', tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
				}

				// Code badge in body (hover-only via CSS, skipped when ShowTypeLabel is false)
				let tmpBodyCenterY = tmpTitleBarHeight + (tmpHeight - tmpTitleBarHeight) / 2;
				if (tmpShowTypeLabel && tmpMeta.Code)
				{
					let tmpCodeText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpCodeText.setAttribute('class', 'pict-flow-node-card-code');
					tmpCodeText.setAttribute('font-size', '10');
					tmpCodeText.setAttribute('font-family', 'monospace');
					tmpCodeText.setAttribute('fill', 'var(--theme-color-text-secondary, #7f8c8d)');
					tmpCodeText.setAttribute('text-anchor', 'middle');
					tmpCodeText.setAttribute('dominant-baseline', 'central');
					tmpCodeText.setAttribute('pointer-events', 'none');
					tmpCodeText.setAttribute('x', String(tmpWidth / 2));
					tmpCodeText.setAttribute('y', String(tmpBodyCenterY));
					tmpCodeText.textContent = tmpMeta.Code;
					tmpGroup.appendChild(tmpCodeText);
				}

				// Tooltip via SVG <title> element
				if (tmpMeta.Tooltip || tmpMeta.Description)
				{
					let tmpSVGTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
					tmpSVGTitle.textContent = tmpMeta.Tooltip || tmpMeta.Description;
					tmpGroup.appendChild(tmpSVGTitle);
				}
			}
		};

		// Render order depends on LabelsInFront:
		//   true  (default): body content first, then labels + ports (labels on top)
		//   false:           labels + ports first, then body content (content on top)
		if (tmpLabelsInFront)
		{
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}
		else
		{
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}

		// Panel indicator icon (small rect in bottom-right corner)
		if (pNodeTypeConfig && pNodeTypeConfig.PropertiesPanel)
		{
			let tmpIndicatorSize = 10;
			let tmpIndicatorMargin = 4;
			let tmpIndicatorX = tmpWidth - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpIndicatorY = tmpHeight - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
			let tmpIndicator;

			if (tmpShapeProvider)
			{
				tmpIndicator = tmpShapeProvider.createPanelIndicatorElement(
					pNodeData.Hash, tmpIndicatorX, tmpIndicatorY,
					tmpIndicatorSize, tmpIndicatorSize);
			}
			else
			{
				tmpIndicator = this._FlowView._SVGHelperProvider.createSVGElement('rect');
				tmpIndicator.setAttribute('class', 'pict-flow-node-panel-indicator');
				tmpIndicator.setAttribute('x', String(tmpIndicatorX));
				tmpIndicator.setAttribute('y', String(tmpIndicatorY));
				tmpIndicator.setAttribute('width', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('height', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('rx', '2');
				tmpIndicator.setAttribute('ry', '2');
				tmpIndicator.setAttribute('data-node-hash', pNodeData.Hash);
				tmpIndicator.setAttribute('data-element-type', 'panel-indicator');
			}

			let tmpIndicatorTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
			tmpIndicatorTitle.textContent = 'Double-click to open properties';
			tmpIndicator.appendChild(tmpIndicatorTitle);

			tmpGroup.appendChild(tmpIndicator);
		}

		// Resize handle: a small grip at the bottom-right corner, shown only when this node is
		// selected and the flow allows node resizing. Its data-element-type routes pointer-down to
		// the InteractionManager's node-resize path. Appended last so it paints over the body.
		if (pIsSelected && this._FlowView.options && this._FlowView.options.EnableNodeResizing)
		{
			// Anchored at the node's bottom-right corner and counter-scaled, so the grip is the same size
			// to the mouse at any zoom (see createZoomInvariantGroup). Geometry is around the anchor: the
			// handle straddles the corner exactly as it did when it was placed in absolute board units.
			let tmpHandleSize = 14;
			let tmpHandleScaler = this._FlowView._SVGHelperProvider.createZoomInvariantGroup(
				tmpWidth, tmpHeight, this._FlowView._FlowData.ViewState.Zoom);
			let tmpHandle = this._FlowView._SVGHelperProvider.createSVGElement('rect');
			tmpHandle.setAttribute('class', 'pict-flow-node-resize-handle');
			tmpHandle.setAttribute('x', String(-(tmpHandleSize - 4)));
			tmpHandle.setAttribute('y', String(-(tmpHandleSize - 4)));
			tmpHandle.setAttribute('width', String(tmpHandleSize));
			tmpHandle.setAttribute('height', String(tmpHandleSize));
			tmpHandle.setAttribute('rx', '3');
			tmpHandle.setAttribute('data-node-hash', pNodeData.Hash);
			tmpHandle.setAttribute('data-element-type', 'node-resize');
			tmpHandleScaler.appendChild(tmpHandle);
			tmpGroup.appendChild(tmpHandleScaler);
		}

		// Rotate handle: a grip on a short arm above the node, shown when this node is selected, the
		// flow allows rotation, and we are not read-only. Its data-element-type routes pointer-down to
		// the InteractionManager's node-rotate path. Lives in node-local space, so it orbits with the card.
		if (pIsSelected && this._FlowView.options && this._FlowView.options.EnableNodeRotation
			&& !(typeof this._FlowView.isReadOnly === 'function' && this._FlowView.isReadOnly()))
		{
			// Arm and grip share one anchored, counter-scaled group at the top-center of the node, so the
			// whole rotate affordance keeps a constant on-screen size and reach. The arm length has to be
			// counter-scaled along with the grip: a grip that stays 6px while its arm collapses would sit
			// on top of the card. The group still rides the node's own transform, so it orbits with the card.
			let tmpArmLength = 22;
			let tmpRotateScaler = this._FlowView._SVGHelperProvider.createZoomInvariantGroup(
				tmpWidth / 2, 0, this._FlowView._FlowData.ViewState.Zoom);

			let tmpArm = this._FlowView._SVGHelperProvider.createSVGElement('line');
			tmpArm.setAttribute('class', 'pict-flow-node-rotate-arm');
			tmpArm.setAttribute('x1', '0');
			tmpArm.setAttribute('y1', '0');
			tmpArm.setAttribute('x2', '0');
			tmpArm.setAttribute('y2', String(-tmpArmLength));
			tmpArm.setAttribute('data-node-hash', pNodeData.Hash);
			tmpArm.setAttribute('data-element-type', 'node-rotate');
			tmpRotateScaler.appendChild(tmpArm);

			let tmpGrip = this._FlowView._SVGHelperProvider.createSVGElement('circle');
			tmpGrip.setAttribute('class', 'pict-flow-node-rotate-handle');
			tmpGrip.setAttribute('cx', '0');
			tmpGrip.setAttribute('cy', String(-tmpArmLength - 5));
			tmpGrip.setAttribute('r', '6');
			tmpGrip.setAttribute('data-node-hash', pNodeData.Hash);
			tmpGrip.setAttribute('data-element-type', 'node-rotate');
			tmpRotateScaler.appendChild(tmpGrip);

			tmpGroup.appendChild(tmpRotateScaler);
		}

		pNodesLayer.appendChild(tmpGroup);
	}

	/**
	 * Render ports for a node — delegates to the PortRenderer service.
	 * @param {Object} pNodeData
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {Object} [pNodeTypeConfig] - Node type configuration (for label display options)
	 */
	_renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		this._FlowView._PortRenderer.renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig, this.options.NodeTitleBarHeight);
	}

	/**
	 * Render custom body content for a node (svg, html, or canvas).
	 *
	 * Checks for a BodyContent configuration on the node type and renders
	 * the appropriate content type into the node's SVG group.
	 *
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	_renderBodyContent(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		if (!pNodeTypeConfig || !pNodeTypeConfig.BodyContent) return;

		let tmpBodyContent = pNodeTypeConfig.BodyContent;
		let tmpContentType = tmpBodyContent.ContentType;
		if (!tmpContentType) return;

		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;
		let tmpPadding = (typeof tmpBodyContent.Padding === 'number') ? tmpBodyContent.Padding : 2;
		let tmpBodyBounds =
		{
			x: tmpPadding,
			y: tmpTitleBarHeight + tmpPadding,
			width: pWidth - (tmpPadding * 2),
			height: pHeight - tmpTitleBarHeight - (tmpPadding * 2)
		};

		let tmpPict = this._FlowView.pict || this.pict;

		// Register any templates defined in the BodyContent config (once)
		if (tmpBodyContent.Templates && Array.isArray(tmpBodyContent.Templates))
		{
			if (!this._registeredBodyTemplates)
			{
				this._registeredBodyTemplates = new Set();
			}
			for (let i = 0; i < tmpBodyContent.Templates.length; i++)
			{
				let tmpTpl = tmpBodyContent.Templates[i];
				if (tmpTpl.Hash && tmpTpl.Template && !this._registeredBodyTemplates.has(tmpTpl.Hash))
				{
					tmpPict.TemplateProvider.addTemplate(tmpTpl.Hash, tmpTpl.Template, 'PictViewFlowNode-BodyContent');
					this._registeredBodyTemplates.add(tmpTpl.Hash);
				}
			}
		}

		switch (tmpContentType)
		{
			case 'svg':
				this._renderBodyContentSVG(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'html':
				this._renderBodyContentHTML(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'canvas':
				this._renderBodyContentCanvas(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig);
				break;
			default:
				this.log.warn('PictViewFlowNode _renderBodyContent: unknown ContentType [' + tmpContentType + ']');
				break;
		}
	}

	/**
	 * Render SVG body content into a <g> group.
	 */
	_renderBodyContentSVG(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpContentGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');
		tmpContentGroup.setAttribute('class', 'pict-flow-node-body-content');
		tmpContentGroup.setAttribute('transform', `translate(${pBounds.x}, ${pBounds.y})`);

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			// Parse SVG markup into the group via a temporary SVG element
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpRenderedContent;
			while (tmpTempSVG.firstChild)
			{
				tmpContentGroup.appendChild(tmpTempSVG.firstChild);
			}
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpContentGroup, pNodeData, pNodeTypeConfig, pBounds);
		}

		pGroup.appendChild(tmpContentGroup);
	}

	/**
	 * Render HTML body content into a foreignObject.
	 */
	_renderBodyContentHTML(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpDiv = document.createElement('div');
		tmpDiv.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpDiv.setAttribute('class', 'pict-flow-node-body-content-html');

		// Pointer event isolation — prevent node drag/canvas pan.
		// Inline attribute handlers (visible in DOM, no closure leak).
		tmpDiv.setAttribute('onpointerdown', 'event.stopPropagation()');
		tmpDiv.setAttribute('onwheel', 'event.stopPropagation()');

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			tmpDiv.innerHTML = tmpRenderedContent;
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpDiv, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpDiv);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Render canvas body content into a foreignObject.
	 */
	_renderBodyContentCanvas(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpCanvas = document.createElement('canvas');
		tmpCanvas.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpCanvas.setAttribute('class', 'pict-flow-node-body-content-canvas');
		tmpCanvas.width = Math.floor(pBounds.width);
		tmpCanvas.height = Math.floor(pBounds.height);
		tmpCanvas.style.width = '100%';
		tmpCanvas.style.height = '100%';

		// Pointer event isolation — inline attribute handlers.
		tmpCanvas.setAttribute('onpointerdown', 'event.stopPropagation()');
		tmpCanvas.setAttribute('onwheel', 'event.stopPropagation()');

		// Invoke render callback (the primary rendering path for canvas)
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpCanvas, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpCanvas);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Resolve and render a body content template string.
	 * @param {Object} pBodyContent - The BodyContent config
	 * @param {Object} pNodeData - The node data (template record)
	 * @param {Object} pPict - The Pict instance
	 * @returns {string|null} Rendered template content, or null
	 */
	_resolveBodyTemplate(pBodyContent, pNodeData, pPict)
	{
		if (pBodyContent.TemplateHash)
		{
			return pPict.parseTemplateByHash(pBodyContent.TemplateHash, pNodeData);
		}
		if (pBodyContent.Template)
		{
			return pPict.parseTemplate(pBodyContent.Template, pNodeData, null, [pNodeData]);
		}
		return null;
	}

	// ── Node Body Renderers ──────────────────────────────────────────────

	/**
	 * Render the standard rect-based node body (default mode).
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	// Append a CSS fragment to an SVG element's inline style (which wins over the stylesheet), keeping
	// any existing inline style.
	_appendElementStyle(pElement, pStyleFragment)
	{
		let tmpExisting = pElement.getAttribute('style') || '';
		if (tmpExisting && tmpExisting.charAt(tmpExisting.length - 1) !== ';') { tmpExisting += ';'; }
		pElement.setAttribute('style', tmpExisting + pStyleFragment);
	}

	/**
	 * Height of the strip that squares off the bottom corners of the title bar. It must cover the
	 * bottom rounded corners (so the title bar meets the body in a straight seam) but must never reach
	 * the top ones, so it is capped at half the title bar height. Without the cap a corner radius
	 * larger than the title bar (a capsule card: radius 24 on a 22px bar) yields a strip taller than
	 * the whole title bar, which paints over the rounded TOP corners and makes the card read as square
	 * on top and rounded only on the bottom.
	 *
	 * @param {number|null} pCornerRadius - the card corner radius, or null for the theme default
	 * @param {number} pTitleBarHeight - the title bar height in user units
	 * @returns {number}
	 */
	static titleBarBottomStripHeight(pCornerRadius, pTitleBarHeight)
	{
		let tmpRadius = (typeof pCornerRadius === 'number') ? pCornerRadius : 0;
		return Math.min(Math.max(8, tmpRadius), Math.floor(pTitleBarHeight / 2));
	}

	/**
	 * The SVG group transform for a node: a position translate, plus a rotation about the node's
	 * center when a non-zero rotation (degrees) is given.
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pRotation - degrees; 0 / non-number means no rotation
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @returns {string}
	 */
	static nodeTransform(pX, pY, pRotation, pWidth, pHeight)
	{
		let tmpRotation = (typeof pRotation === 'number') ? pRotation : 0;
		if (!tmpRotation)
		{
			return `translate(${pX}, ${pY})`;
		}
		return `translate(${pX}, ${pY}) rotate(${tmpRotation} ${pWidth / 2} ${pHeight / 2})`;
	}

	_renderRectNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// Per-card corner radius (a node-data or node-type override of the theme default), so a card
		// type can read as a rounded rectangle, a capsule, or a sharp box. null leaves the
		// theme/CSS default in place. Set as the --pf-node-body-radius custom property on the node
		// group; the body and title-bar both read it through their `rx: var(--pf-node-body-radius)`,
		// and it inherits to both, so one assignment rounds the whole card.
		let tmpCornerRadius = (typeof pNodeData.CornerRadius === 'number') ? pNodeData.CornerRadius
			: ((pNodeTypeConfig && typeof pNodeTypeConfig.CornerRadius === 'number') ? pNodeTypeConfig.CornerRadius : null);
		if (tmpCornerRadius != null) { this._appendElementStyle(pGroup, '--pf-node-body-radius:' + tmpCornerRadius + 'px'); }

		// Node body (main rectangle)
		let tmpBody = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBody.setAttribute('class', 'pict-flow-node-body');
		tmpBody.setAttribute('x', '0');
		tmpBody.setAttribute('y', '0');
		tmpBody.setAttribute('width', String(pWidth));
		tmpBody.setAttribute('height', String(pHeight));
		tmpBody.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBody.setAttribute('data-element-type', 'node-body');

		// Apply custom styles from node type
		if (pNodeTypeConfig && pNodeTypeConfig.BodyStyle)
		{
			for (let tmpStyleKey in pNodeTypeConfig.BodyStyle)
			{
				tmpBody.setAttribute(tmpStyleKey, pNodeTypeConfig.BodyStyle[tmpStyleKey]);
			}
		}

		// Per-node BodyStyle override (wins over the node-type default).
		// Lets a flow author paint individual cards distinctly without
		// registering a new node type per category.
		if (pNodeData.BodyStyle)
		{
			for (let tmpStyleKey in pNodeData.BodyStyle)
			{
				tmpBody.setAttribute(tmpStyleKey, pNodeData.BodyStyle[tmpStyleKey]);
			}
		}

		// Apply per-instance style overrides (for node-specific editing)
		// These must be applied as inline styles so they override CSS rules
		// (CSS declarations take precedence over SVG presentation attributes).
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBody.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBody);

		// Title bar background (top portion)
		let tmpTitleBar = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBar.setAttribute('class', 'pict-flow-node-title-bar');
		tmpTitleBar.setAttribute('x', '0');
		tmpTitleBar.setAttribute('y', '0');
		tmpTitleBar.setAttribute('width', String(pWidth));
		tmpTitleBar.setAttribute('height', String(pTitleBarHeight));
		tmpTitleBar.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBar.setAttribute('data-element-type', 'node-body');

		// Apply custom title bar color
		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBar.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}
		// Per-node TitleBarColor (wins over node-type default).
		if (pNodeData.TitleBarColor)
		{
			tmpTitleBar.setAttribute('fill', pNodeData.TitleBarColor);
		}
		pGroup.appendChild(tmpTitleBar);

		// Title bar bottom fill: squares off the rounded corners at the bottom of the title bar so it
		// meets the body in a straight seam. See titleBarBottomStripHeight for why it is capped.
		let tmpBottomStripHeight = PictViewFlowNode.titleBarBottomStripHeight(tmpCornerRadius, pTitleBarHeight);
		let tmpTitleBarBottom = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBarBottom.setAttribute('class', 'pict-flow-node-title-bar-bottom');
		tmpTitleBarBottom.setAttribute('x', '0');
		tmpTitleBarBottom.setAttribute('y', String(pTitleBarHeight - tmpBottomStripHeight));
		tmpTitleBarBottom.setAttribute('width', String(pWidth));
		tmpTitleBarBottom.setAttribute('height', String(tmpBottomStripHeight));
		tmpTitleBarBottom.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBarBottom.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBarBottom.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}
		if (pNodeData.TitleBarColor)
		{
			tmpTitleBarBottom.setAttribute('fill', pNodeData.TitleBarColor);
		}

		// Per-instance title bar color override
		// Applied as inline style to override CSS rules.
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleBar.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
			tmpTitleBarBottom.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleBarBottom);
	}

	/**
	 * Render a bracket-style node body (used by sketch/blueprint themes).
	 *
	 * The bracket body consists of:
	 * 1. A fill rect for the body background (no stroke)
	 * 2. A fill rect for the title bar background (no stroke)
	 * 3. A bracket path drawn via the noise provider (outline + title divider)
	 *
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	_renderBracketNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// 1. Body fill rect (background only, no stroke)
		let tmpBodyFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBodyFill.setAttribute('class', 'pict-flow-node-body pict-flow-node-bracket-fill');
		tmpBodyFill.setAttribute('x', '0');
		tmpBodyFill.setAttribute('y', '0');
		tmpBodyFill.setAttribute('width', String(pWidth));
		tmpBodyFill.setAttribute('height', String(pHeight));
		tmpBodyFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBodyFill.setAttribute('data-element-type', 'node-body');

		// Per-instance style overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (tmpInlineStyles.length > 0)
			{
				tmpBodyFill.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBodyFill);

		// 2. Title bar fill rect (background only, no stroke)
		let tmpTitleFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleFill.setAttribute('class', 'pict-flow-node-title-bar pict-flow-node-bracket-title-fill');
		tmpTitleFill.setAttribute('x', '0');
		tmpTitleFill.setAttribute('y', '0');
		tmpTitleFill.setAttribute('width', String(pWidth));
		tmpTitleFill.setAttribute('height', String(pTitleBarHeight));
		tmpTitleFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleFill.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeTypeConfig.TitleBarColor);
		}
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleFill);

		// 3. Bracket path (outline + title divider with optional noise)
		let tmpBracketConfig = { SerifLength: 6, TitleSeparator: true };
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.BracketConfig)
			{
				tmpBracketConfig = Object.assign(tmpBracketConfig, tmpActiveTheme.BracketConfig);
			}
		}

		let tmpAmplitude = 0;
		if (this._FlowView._ThemeProvider)
		{
			tmpAmplitude = this._FlowView._ThemeProvider.getNodeNoiseAmplitude();
		}

		let tmpBracketD = '';
		if (this._FlowView._NoiseProvider)
		{
			tmpBracketD = this._FlowView._NoiseProvider.generateBracketPath(
				pWidth, pHeight,
				tmpBracketConfig.SerifLength,
				tmpBracketConfig.TitleSeparator ? pTitleBarHeight : 0,
				tmpAmplitude,
				pNodeData.Hash
			);
		}

		let tmpBracketPath = this._FlowView._SVGHelperProvider.createSVGElement('path');
		tmpBracketPath.setAttribute('class', 'pict-flow-node-bracket');
		tmpBracketPath.setAttribute('d', tmpBracketD);
		tmpBracketPath.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBracketPath.setAttribute('data-element-type', 'node-body');

		// Per-instance stroke overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBracketPath.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBracketPath);
	}
}

module.exports = PictViewFlowNode;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":365}],244:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-PropertiesPanel',

	AutoRender: false,

	Templates:
	[
		{
			Hash: 'Flow-InfoPanel-Wrapper',
			Template: '<div class="pict-flow-info-panel">{~D:Record.PanelContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Header-Icon',
			Template: '<div class="pict-flow-info-panel-header with-icon">{~D:Record.Icon~} {~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Header',
			Template: '<div class="pict-flow-info-panel-header">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Description',
			Template: '<div class="pict-flow-info-panel-description">{~D:Record.Description~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Badges',
			Template: '<div class="pict-flow-info-panel-badges">{~D:Record.BadgesContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Badge-Category',
			Template: '<span class="pict-flow-info-panel-badge category">{~D:Record.Category~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Badge-Code',
			Template: '<span class="pict-flow-info-panel-badge code">{~D:Record.Code~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Inputs',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">Inputs</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Outputs',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">Outputs</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Input',
			Template: '<div class="pict-flow-info-panel-port input">{~D:Record.Label~}{~D:Record.Constraint~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Output',
			Template: '<div class="pict-flow-info-panel-port output">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Constraint',
			Template: ' <span class="pict-flow-info-panel-port-constraint">{~D:Record.ConstraintText~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Generic',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">{~D:Record.SectionTitle~}</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Event',
			Template: '<div class="pict-flow-info-panel-port event">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Value',
			Template: '<div class="pict-flow-info-panel-port value">{~D:Record.Label~}{~D:Record.DataType~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-DataType',
			Template: ' <span class="pict-flow-info-panel-port-constraint">{~D:Record.DataTypeText~}</span>'
		},
		{
			Hash: 'Flow-NodeProps-Editor',
			// Inline oninput/onpointerdown wired to the FlowView's helper —
			// see PictViewFlow._applyNodePropChange / _stopEvent.
			Template: '<div class="pict-flow-node-props-fields" data-flow-view="{~D:Record.FlowViewIdentifier~}" data-node-hash="{~D:Record.NodeHash~}">'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Title</label><input type="text" class="pict-flow-node-props-input" data-prop="Title" value="{~D:Record.Title~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Width</label><input type="number" class="pict-flow-node-props-input" data-prop="Width" value="{~D:Record.Width~}" min="60" step="10" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Height</label><input type="number" class="pict-flow-node-props-input" data-prop="Height" value="{~D:Record.Height~}" min="40" step="10" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Body Fill</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.BodyFill" value="{~D:Record.BodyFillValue~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Body Stroke</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.BodyStroke" value="{~D:Record.BodyStrokeValue~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Stroke Width</label><input type="number" class="pict-flow-node-props-input" data-prop="Style.BodyStrokeWidth" value="{~D:Record.BodyStrokeWidthValue~}" min="0" max="10" step="0.5" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Title Bar</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.TitleBarColor" value="{~D:Record.TitleBarColorValue~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '</div>'
		}
	]
};

/**
 * PictView-Flow-PropertiesPanel
 *
 * Renders and manages all open properties panels on the flow graph.
 * Panels are SVG foreignObject elements containing HTML, placed inside
 * the viewport group so they zoom/pan with the graph.
 *
 * Responsibilities:
 *   - Reconcile DOM (add new panels, remove closed ones, update positions)
 *   - Render tether lines from each panel to its node
 *   - Manage panel instance cache (PictFlowCardPropertiesPanel subclasses)
 *   - Isolate HTML events from SVG interactions
 */
class PictViewFlowPropertiesPanel extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowPropertiesPanel';

		this._FlowView = null;

		// Cache of active panel instances: Map<panelHash, PictFlowCardPropertiesPanel>
		this._PanelInstances = {};
	}

	/**
	 * Render all open panels and their tethers.
	 *
	 * Uses DOM reconciliation for panels (to preserve live HTML state)
	 * and clear-and-rebuild for tethers (trivial SVG lines).
	 *
	 * @param {Array} pOpenPanels - Array of panel data objects from _FlowData.OpenPanels
	 * @param {SVGGElement} pPanelsLayer - The SVG <g> for panel foreignObjects
	 * @param {SVGGElement} pTethersLayer - The SVG <g> for tether lines
	 * @param {string|null} pSelectedTetherHash - Hash of the selected tether's panel, or null
	 */
	renderPanels(pOpenPanels, pPanelsLayer, pTethersLayer, pSelectedTetherHash)
	{
		if (!pPanelsLayer || !pTethersLayer) return;
		if (!this._FlowView) return;

		let tmpOpenPanels = Array.isArray(pOpenPanels) ? pOpenPanels : [];

		// --- Reconcile panels layer (add new, remove closed, update positions) ---
		let tmpExistingPanelHashes = new Set();
		let tmpExistingForeignObjects = pPanelsLayer.querySelectorAll('.pict-flow-panel-foreign-object');
		for (let i = 0; i < tmpExistingForeignObjects.length; i++)
		{
			tmpExistingPanelHashes.add(tmpExistingForeignObjects[i].getAttribute('data-panel-hash'));
		}

		let tmpDesiredPanelHashes = new Set();
		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			tmpDesiredPanelHashes.add(tmpOpenPanels[i].Hash);
		}

		// Remove panels that are no longer open
		for (let i = 0; i < tmpExistingForeignObjects.length; i++)
		{
			let tmpHash = tmpExistingForeignObjects[i].getAttribute('data-panel-hash');
			if (!tmpDesiredPanelHashes.has(tmpHash))
			{
				tmpExistingForeignObjects[i].remove();
				// Destroy cached instance
				if (this._PanelInstances[tmpHash])
				{
					this._PanelInstances[tmpHash].destroy();
					delete this._PanelInstances[tmpHash];
				}
			}
		}

		// Add or update panels
		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			let tmpPanelData = tmpOpenPanels[i];

			if (tmpExistingPanelHashes.has(tmpPanelData.Hash))
			{
				// Update position of existing panel
				let tmpFO = pPanelsLayer.querySelector(`[data-panel-hash="${tmpPanelData.Hash}"]`);
				if (tmpFO)
				{
					tmpFO.setAttribute('x', String(tmpPanelData.X));
					tmpFO.setAttribute('y', String(tmpPanelData.Y));
					tmpFO.setAttribute('width', String(tmpPanelData.Width));
					tmpFO.setAttribute('height', String(tmpPanelData.Height));
				}
			}
			else
			{
				// Create new panel
				this._createPanelForeignObject(tmpPanelData, pPanelsLayer);
			}
		}

		// --- Clear and rebuild tethers ---
		while (pTethersLayer.firstChild)
		{
			pTethersLayer.removeChild(pTethersLayer.firstChild);
		}

		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			let tmpIsSelected = (pSelectedTetherHash === tmpOpenPanels[i].Hash);
			this._renderTether(tmpOpenPanels[i], pTethersLayer, tmpIsSelected);
		}
	}

	/**
	 * Create a foreignObject containing the panel chrome and content.
	 * Delegates to the PanelChrome provider for template-based chrome creation,
	 * then renders panel content into the body container.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {SVGGElement} pPanelsLayer
	 */
	_createPanelForeignObject(pPanelData, pPanelsLayer)
	{
		let tmpPanelChromeProvider = this._FlowView._PanelChromeProvider;
		if (!tmpPanelChromeProvider) return;

		let tmpBody = tmpPanelChromeProvider.createPanelForeignObject(pPanelData, pPanelsLayer);

		// Render the panel content into the Properties tab pane
		if (tmpBody)
		{
			this._renderPanelContent(pPanelData, tmpBody);
		}

		let tmpFO = pPanelsLayer.querySelector(`[data-panel-hash="${pPanelData.Hash}"]`);
		if (tmpFO)
		{
			// The Appearance tab edits a node's body/title appearance, which a connection (edge) has none
			// of -- so for a connection panel, hide that tab (and the now-single-tab bar) and leave just
			// the connection's own panel. Node panels keep the appearance + help tabs.
			if (pPanelData.ConnectionHash)
			{
				this._hidePanelTabsForConnection(tmpFO);
			}
			else
			{
				// Tab-switching click handlers are inline `onclick=` attributes in Flow-PanelChrome-Template
				// that call FlowView._handlePanelTabClick → switchPanelTab.
				this._renderAppearanceTab(pPanelData, tmpFO);
				this._renderHelpTab(pPanelData, tmpFO);
			}
		}
	}

	// Hide the node-oriented Appearance (and Help) tabs plus the tab bar for a connection panel, so it
	// shows only its single Properties pane with no lone tab.
	_hidePanelTabsForConnection(pForeignObject)
	{
		if (!pForeignObject) { return; }
		let tmpAppearanceTab = pForeignObject.querySelector('.pict-flow-panel-tab[data-tab-target="appearance"]');
		if (tmpAppearanceTab) { tmpAppearanceTab.style.display = 'none'; }
		let tmpAppearancePane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="appearance"]');
		if (tmpAppearancePane) { tmpAppearancePane.style.display = 'none'; }
		let tmpTabbar = pForeignObject.querySelector('.pict-flow-panel-tabbar');
		if (tmpTabbar) { tmpTabbar.style.display = 'none'; }
	}

	/**
	 * Instantiate (or reuse) the panel type implementation and render into the body container.
	 *
	 * @param {Object} pPanelData
	 * @param {HTMLDivElement} pBodyContainer
	 */
	_renderPanelContent(pPanelData, pBodyContainer)
	{
		// Connection (edge) panels resolve their config and data differently from node panels.
		if (pPanelData.ConnectionHash)
		{
			this._renderConnectionPanelContent(pPanelData, pBodyContainer);
			return;
		}

		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		if (!tmpNodeTypeConfig) return;

		// If no PropertiesPanel is configured, render the auto-generated info panel
		if (!tmpNodeTypeConfig.PropertiesPanel)
		{
			this._renderInfoPanelContent(pBodyContainer, tmpNodeData, tmpNodeTypeConfig);
			return;
		}

		let tmpPanelConfig = tmpNodeTypeConfig.PropertiesPanel;
		let tmpPanelType = tmpPanelConfig.PanelType || 'Base';

		// Try to get a registered panel type service
		let tmpServiceName = `PictFlowCardPropertiesPanel-${tmpPanelType}`;
		let tmpInstance = null;

		if (this._PanelInstances[pPanelData.Hash])
		{
			// Reuse existing instance
			tmpInstance = this._PanelInstances[pPanelData.Hash];
		}
		else
		{
			// Create a new instance
			if (this.fable.servicesMap.hasOwnProperty(tmpServiceName))
			{
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration(tmpServiceName, tmpPanelConfig);
			}
			else if (this.fable.servicesMap.hasOwnProperty('PictFlowCardPropertiesPanel'))
			{
				// Fall back to base class
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration('PictFlowCardPropertiesPanel', tmpPanelConfig);
			}

			if (tmpInstance)
			{
				tmpInstance._FlowView = this._FlowView;
				this._PanelInstances[pPanelData.Hash] = tmpInstance;
			}
		}

		if (tmpInstance)
		{
			tmpInstance.render(pBodyContainer, tmpNodeData);
		}

		// After the form renders, append port summary sections showing
		// event inputs, event outputs, and state outputs.
		// SettingsInputs are already visible as form fields above.
		this._renderPortSummary(pBodyContainer, tmpNodeTypeConfig);
	}

	/**
	 * Render the content of a connection (edge) panel. The config is the FlowView's single
	 * ConnectionPropertiesPanel (connections are not typed); the panel-type instance renders
	 * against the connection object, so a Form panel edits Connection.Data.* and a Template panel
	 * renders against the connection.
	 *
	 * @param {Object} pPanelData
	 * @param {HTMLDivElement} pBodyContainer
	 */
	_renderConnectionPanelContent(pPanelData, pBodyContainer)
	{
		let tmpConnectionData = this._FlowView.getConnection(pPanelData.ConnectionHash);
		if (!tmpConnectionData) return;

		let tmpPanelConfig = this._FlowView.options.ConnectionPropertiesPanel;
		if (!tmpPanelConfig)
		{
			pBodyContainer.innerHTML = '<em>No connection properties panel configured.</em>';
			return;
		}

		let tmpPanelType = tmpPanelConfig.PanelType || 'Base';
		let tmpServiceName = `PictFlowCardPropertiesPanel-${tmpPanelType}`;
		let tmpInstance = this._PanelInstances[pPanelData.Hash];

		if (!tmpInstance)
		{
			if (this.fable.servicesMap.hasOwnProperty(tmpServiceName))
			{
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration(tmpServiceName, tmpPanelConfig);
			}
			else if (this.fable.servicesMap.hasOwnProperty('PictFlowCardPropertiesPanel'))
			{
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration('PictFlowCardPropertiesPanel', tmpPanelConfig);
			}
			if (tmpInstance)
			{
				tmpInstance._FlowView = this._FlowView;
				this._PanelInstances[pPanelData.Hash] = tmpInstance;
			}
		}

		if (tmpInstance)
		{
			tmpInstance.render(pBodyContainer, tmpConnectionData);
		}
	}

	/**
	 * Render an auto-generated info panel for nodes without a configured PropertiesPanel.
	 * Shows the node type, description, and a summary of input/output ports with
	 * their connection constraints.
	 *
	 * Uses configuration-based templates from _DefaultConfiguration.Templates
	 * rendered via pict.parseTemplateByHash().
	 *
	 * @param {HTMLDivElement} pContainer
	 * @param {Object} pNodeData
	 * @param {Object} pNodeTypeConfig
	 */
	_renderInfoPanelContent(pContainer, pNodeData, pNodeTypeConfig)
	{
		let tmpMeta = pNodeTypeConfig.CardMetadata || {};
		let tmpPorts = pNodeTypeConfig.DefaultPorts || [];

		let tmpInputs = tmpPorts.filter((pPort) => pPort.Direction === 'input');
		let tmpOutputs = tmpPorts.filter((pPort) => pPort.Direction === 'output');

		let tmpLabel = pNodeTypeConfig.Label || pNodeData.Type;

		// Build content by rendering configuration-based templates
		let tmpContentParts = [];

		// Header
		let tmpIconProvider = this._FlowView._IconProvider;
		if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
		{
			// SVG icon markup for the header
			let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
			let tmpIconMarkup = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 18);
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpIconMarkup, Label: tmpLabel }));
		}
		else if (tmpMeta.Icon)
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpMeta.Icon, Label: tmpLabel }));
		}
		else if (tmpIconProvider)
		{
			// No icon specified — render default fallback
			let tmpDefaultMarkup = tmpIconProvider.getIconSVGMarkup('default', 18);
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpDefaultMarkup, Label: tmpLabel }));
		}
		else
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header', { Label: tmpLabel }));
		}

		// Description
		if (tmpMeta.Description)
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Description', { Description: tmpMeta.Description }));
		}

		// Category + Code badges
		if (tmpMeta.Category || tmpMeta.Code)
		{
			let tmpBadgesContent = '';
			if (tmpMeta.Category)
			{
				tmpBadgesContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Badge-Category', { Category: tmpMeta.Category });
			}
			if (tmpMeta.Code)
			{
				tmpBadgesContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Badge-Code', { Code: tmpMeta.Code });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Badges', { BadgesContent: tmpBadgesContent }));
		}

		// Inputs
		if (tmpInputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpInputs.length; i++)
			{
				let tmpPort = tmpInputs[i];
				let tmpConstraint = this._getPortConstraintHTML(tmpPort);
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Input', { Label: tmpPort.Label || 'In', Constraint: tmpConstraint });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Inputs', { PortsContent: tmpPortsContent }));
		}

		// Outputs
		if (tmpOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpOutputs.length; i++)
			{
				let tmpPort = tmpOutputs[i];
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Output', { Label: tmpPort.Label || 'Out' });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Outputs', { PortsContent: tmpPortsContent }));
		}

		pContainer.innerHTML = this.pict.parseTemplateByHash('Flow-InfoPanel-Wrapper', { PanelContent: tmpContentParts.join('') });
	}

	/**
	 * Render port summary sections below the form panel content.
	 * Shows event inputs, event outputs, and state outputs — the ports
	 * that the form does not cover (since the form only shows SettingsInputs).
	 *
	 * @param {HTMLDivElement} pContainer
	 * @param {Object} pNodeTypeConfig
	 */
	_renderPortSummary(pContainer, pNodeTypeConfig)
	{
		let tmpPorts = pNodeTypeConfig.DefaultPorts || [];
		if (tmpPorts.length === 0) return;

		// Categorize ports by type (settings are already shown as form fields)
		let tmpEventInputs = [];
		let tmpEventOutputs = [];
		let tmpStateOutputs = [];

		for (let i = 0; i < tmpPorts.length; i++)
		{
			let tmpPort = tmpPorts[i];
			let tmpPortType = tmpPort.PortType || '';

			if (tmpPortType === 'event-in')
			{
				tmpEventInputs.push(tmpPort);
			}
			else if (tmpPortType === 'event-out' || tmpPortType === 'error')
			{
				tmpEventOutputs.push(tmpPort);
			}
			else if (tmpPortType === 'value')
			{
				tmpStateOutputs.push(tmpPort);
			}
		}

		// Only render if there are non-settings ports to show
		if (tmpEventInputs.length === 0 && tmpEventOutputs.length === 0 && tmpStateOutputs.length === 0)
		{
			return;
		}

		let tmpSummaryParts = [];

		// Event Inputs
		if (tmpEventInputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpEventInputs.length; i++)
			{
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Event', { Label: tmpEventInputs[i].Label || tmpEventInputs[i].Name || 'Event In' });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'Event Inputs', PortsContent: tmpPortsContent }));
		}

		// Event Outputs
		if (tmpEventOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpEventOutputs.length; i++)
			{
				let tmpPort = tmpEventOutputs[i];
				let tmpLabel = tmpPort.Label || tmpPort.Name || 'Event Out';
				if (tmpPort.PortType === 'error')
				{
					tmpLabel += ' ⚠';
				}
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Event', { Label: tmpLabel });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'Event Outputs', PortsContent: tmpPortsContent }));
		}

		// State Outputs
		if (tmpStateOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpStateOutputs.length; i++)
			{
				let tmpPort = tmpStateOutputs[i];
				let tmpLabel = tmpPort.Label || tmpPort.Name || 'Output';
				let tmpDataType = '';
				if (tmpPort.DataType)
				{
					tmpDataType = this.pict.parseTemplateByHash('Flow-InfoPanel-Port-DataType', { DataTypeText: tmpPort.DataType });
				}
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Value', { Label: tmpLabel, DataType: tmpDataType });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'State Outputs', PortsContent: tmpPortsContent }));
		}

		if (tmpSummaryParts.length > 0)
		{
			// Create a wrapper div for the port summary and append it to the container
			let tmpSummaryDiv = document.createElement('div');
			tmpSummaryDiv.className = 'pict-flow-info-panel pict-flow-port-summary';
			tmpSummaryDiv.innerHTML = tmpSummaryParts.join('');
			pContainer.appendChild(tmpSummaryDiv);
		}
	}

	/**
	 * Build the constraint markup for a port using configuration templates.
	 *
	 * @param {Object} pPort
	 * @returns {string} Rendered constraint HTML or empty string
	 */
	_getPortConstraintHTML(pPort)
	{
		let tmpMin = (typeof pPort.MinimumInputCount === 'number') ? pPort.MinimumInputCount : 0;
		let tmpMax = (typeof pPort.MaximumInputCount === 'number') ? pPort.MaximumInputCount : -1;

		if (tmpMin > 0 || tmpMax > 0)
		{
			let tmpConstraintText = '';
			if (tmpMax < 0)
			{
				tmpConstraintText = `(min ${tmpMin})`;
			}
			else if (tmpMin === tmpMax)
			{
				tmpConstraintText = `(exactly ${tmpMin})`;
			}
			else
			{
				tmpConstraintText = `(${tmpMin}\u2013${tmpMax})`;
			}
			return this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Constraint', { ConstraintText: tmpConstraintText });
		}
		return '';
	}

	/**
	 * Render the Appearance tab content with node property editor fields.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {Element} pForeignObject - The panel's SVG foreignObject element
	 */
	_renderAppearanceTab(pPanelData, pForeignObject)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpAppearancePane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="appearance"]');
		if (!tmpAppearancePane) return;

		// Build the template record with safe defaults for Style values
		let tmpStyle = tmpNodeData.Style || {};

		// Resolve default colors from the node type config or CSS token defaults
		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		let tmpDefaultTitleBarColor = 'var(--theme-color-text-primary, #2c3e50)';
		let tmpDefaultBodyFill = '#ffffff';
		let tmpDefaultBodyStroke = '#d0d4d8';
		if (tmpNodeTypeConfig)
		{
			if (tmpNodeTypeConfig.TitleBarColor) tmpDefaultTitleBarColor = tmpNodeTypeConfig.TitleBarColor;
			if (tmpNodeTypeConfig.BodyStyle)
			{
				if (tmpNodeTypeConfig.BodyStyle.fill) tmpDefaultBodyFill = tmpNodeTypeConfig.BodyStyle.fill;
				if (tmpNodeTypeConfig.BodyStyle.stroke) tmpDefaultBodyStroke = tmpNodeTypeConfig.BodyStyle.stroke;
			}
		}

		let tmpRecord =
		{
			Title: tmpNodeData.Title || '',
			Width: tmpNodeData.Width || 180,
			Height: tmpNodeData.Height || 80,
			BodyFillValue: tmpStyle.BodyFill || tmpDefaultBodyFill,
			BodyStrokeValue: tmpStyle.BodyStroke || tmpDefaultBodyStroke,
			BodyStrokeWidthValue: tmpStyle.BodyStrokeWidth || 1,
			TitleBarColorValue: tmpStyle.TitleBarColor || tmpDefaultTitleBarColor,
			NodeHash: pPanelData.NodeHash,
			FlowViewIdentifier: this._FlowView.options.ViewIdentifier
		};

		// Inputs in the rendered template carry inline oninput/onpointerdown
		// handlers that call the FlowView's _applyNodePropChange — no
		// addEventListener wiring needed here.
		this.pict.ContentAssignment.assignContent(tmpAppearancePane,
			this.pict.parseTemplateByHash('Flow-NodeProps-Editor', tmpRecord));
	}

	/**
	 * Render the Help tab content if help text is defined on the node type.
	 * Shows the Help tab button only when help content is available.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {Element} pForeignObject - The panel's SVG foreignObject element
	 */
	_renderHelpTab(pPanelData, pForeignObject)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		if (!tmpNodeTypeConfig) return;

		let tmpHelpText = (tmpNodeTypeConfig.CardMetadata && tmpNodeTypeConfig.CardMetadata.Help)
			? tmpNodeTypeConfig.CardMetadata.Help
			: null;

		if (!tmpHelpText) return;

		// Show the Help tab button
		let tmpHelpTabButton = pForeignObject.querySelector('.pict-flow-panel-tab[data-tab-target="help"]');
		if (tmpHelpTabButton)
		{
			tmpHelpTabButton.style.display = '';
		}

		// Render help content into the help pane
		let tmpHelpPane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="help"]');
		if (tmpHelpPane)
		{
			tmpHelpPane.innerHTML = '<div class="pict-flow-panel-help-content">' + tmpHelpText + '</div>';
		}
	}

	/**
	 * Switch the visible tab pane within a panel foreignObject. Invoked
	 * from the inline `onclick` handler on tab buttons in
	 * Flow-PanelChrome-Template via FlowView._handlePanelTabClick.
	 *
	 * @param {Element} pTabElement - The clicked tab button
	 */
	switchPanelTab(pTabElement)
	{
		let tmpForeignObject = pTabElement.closest('foreignObject');
		if (!tmpForeignObject) return;

		let tmpTarget = pTabElement.getAttribute('data-tab-target');
		let tmpTabs = tmpForeignObject.querySelectorAll('.pict-flow-panel-tab');
		let tmpPanes = tmpForeignObject.querySelectorAll('.pict-flow-panel-tab-pane');

		for (let i = 0; i < tmpTabs.length; i++)
		{
			tmpTabs[i].classList.remove('active');
		}
		for (let i = 0; i < tmpPanes.length; i++)
		{
			tmpPanes[i].classList.remove('active');
			tmpPanes[i].style.display = 'none';
		}

		pTabElement.classList.add('active');
		let tmpTargetPane = tmpForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="' + tmpTarget + '"]');
		if (tmpTargetPane)
		{
			tmpTargetPane.classList.add('active');
			tmpTargetPane.style.display = 'block';
		}
	}

	/**
	 * Apply a node property change from the properties editor and re-render.
	 *
	 * @param {string} pNodeHash - Hash of the node to update
	 * @param {string} pPropPath - Property path (e.g. 'Title', 'Width', 'Style.BodyFill')
	 * @param {string} pValue - The new value from the input
	 * @param {string} pInputType - The input element type ('text', 'number', 'color')
	 */
	_applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType)
	{
		let tmpNodeData = this._FlowView.getNode(pNodeHash);
		if (!tmpNodeData) return;

		// Parse numeric values
		let tmpValue = pValue;
		if (pInputType === 'number')
		{
			tmpValue = parseFloat(pValue);
			if (isNaN(tmpValue)) return;
		}

		// Apply the value based on the property path
		if (pPropPath === 'Title')
		{
			tmpNodeData.Title = tmpValue;
		}
		else if (pPropPath === 'Width')
		{
			tmpNodeData.Width = tmpValue;
		}
		else if (pPropPath === 'Height')
		{
			tmpNodeData.Height = tmpValue;
		}
		else if (pPropPath.startsWith('Style.'))
		{
			if (!tmpNodeData.Style) tmpNodeData.Style = {};
			let tmpStyleKey = pPropPath.substring(6); // Remove 'Style.' prefix
			tmpNodeData.Style[tmpStyleKey] = tmpValue;
		}

		// Re-render the flow to reflect changes
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		// Fire change event
		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Render a tether from a panel to its node.
	 * Delegates to the TetherService for geometry, path generation, and SVG element creation.
	 *
	 * @param {Object} pPanelData
	 * @param {SVGGElement} pTethersLayer
	 * @param {boolean} pIsSelected
	 */
	_renderTether(pPanelData, pTethersLayer, pIsSelected)
	{
		let tmpTetherService = this._FlowView._TetherService;
		if (!tmpTetherService) return;

		// A connection panel tethers to the edge midpoint; model it as a zero-size anchor at that
		// point so the same tether geometry applies. A node panel tethers to its node.
		let tmpAnchorData;
		if (pPanelData.ConnectionHash)
		{
			let tmpMidpoint = this._FlowView.getConnectionMidpoint(pPanelData.ConnectionHash);
			if (!tmpMidpoint) return;
			tmpAnchorData = { X: tmpMidpoint.x, Y: tmpMidpoint.y, Width: 0, Height: 0 };
		}
		else
		{
			tmpAnchorData = this._FlowView.getNode(pPanelData.NodeHash);
			if (!tmpAnchorData) return;
		}

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		tmpTetherService.renderTether(pPanelData, tmpAnchorData, pTethersLayer, pIsSelected, tmpViewIdentifier);
	}

	/**
	 * Marshal data from all open panels back into their node Data objects.
	 */
	marshalAllFromPanels()
	{
		for (let tmpPanelHash in this._PanelInstances)
		{
			let tmpInstance = this._PanelInstances[tmpPanelHash];
			if (tmpInstance && tmpInstance._NodeData)
			{
				tmpInstance.marshalFromPanel(tmpInstance._NodeData);
			}
		}
	}

	/**
	 * Destroy a specific panel instance and clean up.
	 *
	 * @param {string} pPanelHash
	 */
	destroyPanel(pPanelHash)
	{
		if (this._PanelInstances[pPanelHash])
		{
			this._PanelInstances[pPanelHash].destroy();
			delete this._PanelInstances[pPanelHash];
		}
	}

	/**
	 * Destroy all panel instances.
	 */
	destroyAllPanels()
	{
		for (let tmpPanelHash in this._PanelInstances)
		{
			this._PanelInstances[tmpPanelHash].destroy();
		}
		this._PanelInstances = {};
	}
}

module.exports = PictViewFlowPropertiesPanel;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":365}],245:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-Toolbar',

	DefaultRenderable: 'Flow-Toolbar-Content',
	DefaultDestinationAddress: '#Flow-Toolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	EnablePalette: true,
	EnableAddNode: true,
	EnableCardPalette: true,

	// Host-supplied buttons (set by the FlowView from its own ToolbarExtraButtons option). Each entry
	// is { Hash, Icon, Label?, Tooltip?, Active? }. Rendered as a group via Flow-Toolbar-Extra-Button.
	ToolbarExtraButtons: [],

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-Toolbar-Template',
			// Inline onclick handlers route to the toolbar via the FlowView
			// (the flow toolbar is reachable as ._ToolbarView from the
			// registered FlowView). Each button is responsible for its own
			// action — no event delegation.
			Template: /*html*/`
<div class="pict-flow-toolbar" id="Flow-Toolbar-Bar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="add-node" id="Flow-Toolbar-AddNode-{~D:Record.FlowViewIdentifier~}" title="Add Node"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('add-node')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-plus-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Node</span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="cards-popup" id="Flow-Toolbar-Cards-{~D:Record.FlowViewIdentifier~}" title="Card Palette"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('cards-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-cards-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Cards</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-CardsChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="delete-selected" title="Delete Node"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('delete-selected')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-trash-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="layout-popup" id="Flow-Toolbar-Layout-{~D:Record.FlowViewIdentifier~}" title="Manage saved layouts"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('layout-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-layout-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Layouts</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-LayoutChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<div class="pict-flow-toolbar-btn-split" id="Flow-Toolbar-Auto-{~D:Record.FlowViewIdentifier~}">
			<button class="pict-flow-toolbar-btn pict-flow-toolbar-btn-split-main" data-flow-action="apply-current-layout" title="Apply current layout algorithm"
				onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('apply-current-layout')">
				<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-auto-{~D:Record.FlowViewIdentifier~}"></span>
				<span class="pict-flow-toolbar-btn-text">Auto</span>
			</button>
			<button class="pict-flow-toolbar-btn pict-flow-toolbar-btn-split-chevron" data-flow-action="layout-algorithm-popup" title="Choose layout algorithm"
				onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('layout-algorithm-popup')">
				<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-AutoChevron-{~D:Record.FlowViewIdentifier~}"></span>
			</button>
		</div>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-in" title="Zoom In"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-in')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-out" title="Zoom Out"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-out')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-fit" title="Fit to View"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-fit')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group pict-flow-toolbar-extra">{~TS:Flow-Toolbar-Extra-Button:Record.ToolbarExtraButtons~}</div>
	<div class="pict-flow-toolbar-group pict-flow-toolbar-right">
		<button class="pict-flow-toolbar-btn" data-flow-action="settings-popup" id="Flow-Toolbar-Settings-{~D:Record.FlowViewIdentifier~}" title="Theme Settings"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('settings-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-settings-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="fullscreen" id="Flow-Toolbar-Fullscreen-{~D:Record.FlowViewIdentifier~}" title="Toggle Fullscreen"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('fullscreen')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Fullscreen-Icon-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="toggle-floating" title="Float"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('toggle-floating')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-grip-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="collapse-toolbar" title="Collapse Toolbar"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('collapse-toolbar')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-collapse-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
</div>
<div class="pict-flow-toolbar-collapsed" id="Flow-Toolbar-Collapsed-{~D:Record.FlowViewIdentifier~}">
	<button class="pict-flow-toolbar-expand-btn" data-flow-action="expand-toolbar" title="Expand Toolbar" id="Flow-Toolbar-ExpandBtn-{~D:Record.FlowViewIdentifier~}"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('expand-toolbar')">
		<span id="Flow-Toolbar-Icon-expand-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
<div class="pict-flow-toolbar-popup-anchor" id="Flow-Toolbar-PopupAnchor-{~D:Record.FlowViewIdentifier~}">
</div>
`
		},
		{
			Hash: 'Flow-Toolbar-Extra-Button',
			// Host-supplied button. The icon span is filled post-render by
			// _populateToolbarIcons (keyed by Hash), matching how the built-in
			// button icons are injected. FlowViewIdentifier + ActiveClass are
			// stamped onto each row in render().
			Template: /*html*/`<button class="pict-flow-toolbar-btn{~D:Record.ToggleClass~}{~D:Record.ActiveClass~}" id="Flow-Toolbar-Extra-{~D:Record.Hash~}-{~D:Record.FlowViewIdentifier~}" title="{~D:Record.Tooltip~}" data-flow-action="extra" data-extra-hash="{~D:Record.Hash~}"
	onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleExtraAction('{~D:Record.Hash~}', this)">
	<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-ExtraIcon-{~D:Record.Hash~}-{~D:Record.FlowViewIdentifier~}"></span>
	<span class="pict-flow-toolbar-btn-text">{~D:Record.Label~}</span>
	<span class="pict-flow-toolbar-btn-led" aria-hidden="true"></span>
</button>`
		},
		{
			Hash: 'Flow-AddNode-List',
			// Iteration source is `Record.Rows` — the outer call sets the
			// FlowViewIdentifier on each row so inline handlers resolve their
			// owning view independently. Nested {~D:~} inside {~TS:~}
			// addresses isn't supported by the template engine, so we keep
			// addresses static.
			Template: '{~TS:Flow-AddNode-Row:Record.Rows~}'
		},
		{
			Hash: 'Flow-AddNode-Row',
			Template: '<div class="pict-flow-popup-list-item" data-node-type="{~D:Record.NodeType~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._addNodeFromPopup(this.getAttribute(\'data-node-type\'))">'
				+ '<span class="pict-flow-popup-list-item-icon">{~D:Record.IconHTML~}</span>'
				+ '<span class="pict-flow-popup-list-item-label">{~D:Record.Label~}</span>'
				+ '{~D:Record.CodeBlock~}'
				+ '</div>'
		},
		{
			Hash: 'Flow-Cards-List',
			Template: '{~TS:Flow-Cards-Category:Record.Categories~}'
		},
		{
			Hash: 'Flow-Cards-Category',
			Template: '<div class="pict-flow-palette-category" style="padding:0.35em 0.5em;">'
				+ '<div class="pict-flow-palette-category-label">{~D:Record.Name~}</div>'
				+ '<div class="pict-flow-palette-cards">{~TS:Flow-Cards-Card:Record.Cards~}</div>'
				+ '</div>'
		},
		{
			Hash: 'Flow-Cards-Card',
			// The icon / swatch / code spans are pre-rendered into complete HTML blocks by
			// _buildCardsPopup (a block is '' when its piece is absent). The template can't build them
			// inline: the engine does not parse a nested {~D:~} inside a {~NE:~} (its `~}` terminator
			// collides with the inner tag's), which left the palette showing raw template literals.
			Template: '<div class="pict-flow-palette-card{~D:Record.DisabledClass~}" data-card-type="{~D:Record.CardType~}" title="{~D:Record.Tooltip~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._addCardFromPopup(this.getAttribute(\'data-card-type\'))">'
				+ '{~D:Record.IconBlock~}'
				+ '{~D:Record.SwatchBlock~}'
				+ '<span class="pict-flow-palette-card-title">{~D:Record.Label~}</span>'
				+ '{~D:Record.CodeBlock~}'
				+ '</div>'
		},
		{
			Hash: 'Flow-Layout-List',
			Template: '{~TS:Flow-Layout-Row:Record.Rows~}'
		},
		{
			Hash: 'Flow-Layout-Row',
			Template: '<div class="pict-flow-popup-layout-row" data-layout-hash="{~D:Record.LayoutHash~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._restoreLayoutFromPopup(\'{~D:Record.LayoutHash~}\', event)">'
				+ '<span class="pict-flow-popup-layout-name">{~D:Record.Name~}</span>'
				+ '<button class="pict-flow-popup-layout-delete" title="Delete layout"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._deleteLayoutFromPopup(\'{~D:Record.LayoutHash~}\', event)">'
				+ '{~D:Record.DeleteIconHTML~}</button>'
				+ '</div>'
		},
		{
			Hash: 'Flow-Layout-OptionList',
			Template: '{~TS:Flow-Layout-Option:Record.Options~}'
		},
		{
			Hash: 'Flow-Layout-Option',
			Template: '<option value="{~D:Record.Value~}"{~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>'
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Toolbar-Content',
			TemplateHash: 'Flow-Toolbar-Template',
			DestinationAddress: '#Flow-Toolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowToolbar';

		this._FlowView = null;

		// Toolbar mode state
		this._ToolbarMode = 'docked'; // 'docked' | 'floating' | 'collapsed'
		this._ActivePopup = null;     // 'add-node' | 'cards' | 'layout' | null
		this._FloatingPosition = { X: 80, Y: 80 };
		this._DocumentClickHandler = null;
		this._FloatingToolbarView = null;

		// Layout-algorithm parameter form (pict-section-form metacontroller).
		// Lazily created on first popup open; null until then. Falls back to
		// hand-rolled inputs when PictFormMetacontroller is not registered.
		this._LayoutFormMetacontroller = null;
		this._LayoutFormHostID = null;
		// Whether the parameter form is expanded inside the popup. Persists
		// across popup opens so a user who collapsed it doesn't have to
		// re-collapse on every reopen. Defaults to expanded.
		this._LayoutFormExpanded = true;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		// Stamp the per-row render fields onto each host-supplied button so the
		// Flow-Toolbar-Extra-Button rows resolve their owning view and active
		// state (nested {~D:~} addressing inside {~TS:~} is not supported).
		this._stampExtraButtons();
		// Pass this.options as the template record so {~D:Record.FlowViewIdentifier~}
		// resolves correctly in the toolbar template.
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	/**
	 * Stamp FlowViewIdentifier + ActiveClass onto each ToolbarExtraButtons entry
	 * so the row template can address them.
	 */
	_stampExtraButtons()
	{
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (!Array.isArray(tmpExtraButtons)) return;
		for (let i = 0; i < tmpExtraButtons.length; i++)
		{
			tmpExtraButtons[i].FlowViewIdentifier = this.options.FlowViewIdentifier;
			tmpExtraButtons[i].ActiveClass = tmpExtraButtons[i].Active ? ' pict-flow-toolbar-btn-active' : '';
			// Toggle buttons (stateful on/off, e.g. a pan or connect toggle) get a status LED that the
			// ActiveClass fills; plain action buttons (Toggle falsy) render no LED.
			tmpExtraButtons[i].ToggleClass = tmpExtraButtons[i].Toggle ? ' pict-flow-toolbar-btn-toggle' : '';
			// A label-less (icon-only) button renders an empty text span; CSS (:empty) collapses it.
			if (typeof tmpExtraButtons[i].Label !== 'string') { tmpExtraButtons[i].Label = ''; }
		}
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Click handlers live on each button as inline `onclick` attributes
		// in Flow-Toolbar-Template — they call _handleToolbarAction directly.

		// Populate SVG icons for toolbar buttons
		this._populateToolbarIcons();

		// Remove buttons from DOM based on options
		if (this.options.EnableAddNode === false)
		{
			let tmpAddNodeBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`);
			if (tmpAddNodeBtn.length > 0)
			{
				tmpAddNodeBtn[0].remove();
			}
		}
		if (this.options.EnableCardPalette === false)
		{
			let tmpCardsBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`);
			if (tmpCardsBtn.length > 0)
			{
				tmpCardsBtn[0].remove();
			}
		}
		if (this.options.EnableLayoutMenu === false)
		{
			let tmpAutoBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Auto-${tmpFlowViewIdentifier}`);
			if (tmpAutoBtn.length > 0)
			{
				tmpAutoBtn[0].remove();
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	// ── Icon Population ───────────────────────────────────────────────────

	/**
	 * Populate SVG icons for all toolbar buttons.
	 */
	_populateToolbarIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Map of element ID suffix → icon key
		let tmpIconMap =
		{
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'settings': 'settings',
			'grip': 'grip',
			'collapse': 'collapse',
			'expand': 'expand'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-Toolbar-Icon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 14);
			}
		}

		// Fullscreen icon
		let tmpFullscreenIcon = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
		if (tmpFullscreenIcon.length > 0)
		{
			tmpFullscreenIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup('fullscreen', 14);
		}

		// Chevrons (smaller)
		let tmpCardsChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-CardsChevron-${tmpFlowViewIdentifier}`);
		if (tmpCardsChevron.length > 0)
		{
			tmpCardsChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		let tmpLayoutChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-LayoutChevron-${tmpFlowViewIdentifier}`);
		if (tmpLayoutChevron.length > 0)
		{
			tmpLayoutChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		let tmpAutoChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-AutoChevron-${tmpFlowViewIdentifier}`);
		if (tmpAutoChevron.length > 0)
		{
			tmpAutoChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		// Host-supplied extra buttons (keyed by Hash, icon from the button's Icon key).
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (Array.isArray(tmpExtraButtons))
		{
			for (let i = 0; i < tmpExtraButtons.length; i++)
			{
				let tmpExtraIcon = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-ExtraIcon-${tmpExtraButtons[i].Hash}-${tmpFlowViewIdentifier}`);
				if (tmpExtraIcon.length > 0)
				{
					tmpExtraIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpExtraButtons[i].Icon, 14);
				}
			}
		}
	}

	// ── Popup Management ──────────────────────────────────────────────────

	/**
	 * Open a popup below a trigger button.
	 * @param {string} pType - 'add-node' | 'cards' | 'layout'
	 */
	_openPopup(pType)
	{
		// Toggle off if already open
		if (this._ActivePopup === pType)
		{
			this._closePopup();
			return;
		}

		// Close any existing popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		// Create popup div
		let tmpPopup = document.createElement('div');
		tmpPopup.className = 'pict-flow-toolbar-popup';
		tmpPopup.setAttribute('id', `Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);

		// Build popup content
		switch (pType)
		{
			case 'add-node':
				this._buildAddNodePopup(tmpPopup);
				break;
			case 'cards':
				this._buildCardsPopup(tmpPopup);
				break;
			case 'layout':
				this._buildLayoutPopup(tmpPopup);
				break;
			case 'layout-algorithm':
				this._buildLayoutAlgorithmPopup(tmpPopup);
				break;
			case 'settings':
				this._buildSettingsPopup(tmpPopup);
				break;
		}

		tmpAnchor[0].appendChild(tmpPopup);
		this._ActivePopup = pType;

		// Position the popup below the trigger button
		this._positionPopup(tmpPopup, pType);

		// Click-outside-to-close handler (delayed to avoid catching the opening click)
		setTimeout(() =>
		{
			this._DocumentClickHandler = (pEvent) =>
			{
				if (!tmpPopup.contains(pEvent.target))
				{
					// Check if click was on the trigger button itself (toggle behavior)
					let tmpButton = pEvent.target.closest('[data-flow-action]');
					if (tmpButton)
					{
						let tmpAction = tmpButton.getAttribute('data-flow-action');
						if (tmpAction === pType || tmpAction === pType.replace('-popup', '') + '-popup')
						{
							return; // Let the toggle handle it
						}
					}
					this._closePopup();
				}
			};
			document.addEventListener('click', this._DocumentClickHandler, true);
		}, 0);

		// Focus search input if Add Node popup
		if (pType === 'add-node')
		{
			let tmpSearch = tmpPopup.querySelector('.pict-flow-popup-search');
			if (tmpSearch)
			{
				setTimeout(() => { tmpSearch.focus(); }, 50);
			}
		}
	}

	/**
	 * Close the active popup and clean up.
	 */
	_closePopup()
	{
		if (this._DocumentClickHandler)
		{
			document.removeEventListener('click', this._DocumentClickHandler, true);
			this._DocumentClickHandler = null;
		}

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopup = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopup.length > 0)
		{
			tmpPopup[0].parentNode.removeChild(tmpPopup[0]);
		}

		this._ActivePopup = null;
	}

	/**
	 * Position a popup below its trigger button.
	 * @param {HTMLElement} pPopupDiv
	 * @param {string} pType
	 */
	_positionPopup(pPopupDiv, pType)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Determine which button triggered the popup
		let tmpTriggerSelector;
		switch (pType)
		{
			case 'add-node':
				tmpTriggerSelector = `#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`;
				break;
			case 'cards':
				tmpTriggerSelector = `#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`;
				break;
			case 'layout':
				tmpTriggerSelector = `#Flow-Toolbar-Layout-${tmpFlowViewIdentifier}`;
				break;
			case 'layout-algorithm':
				tmpTriggerSelector = `#Flow-Toolbar-Auto-${tmpFlowViewIdentifier}`;
				break;
			case 'settings':
				tmpTriggerSelector = `#Flow-Toolbar-Settings-${tmpFlowViewIdentifier}`;
				break;
			default:
				return;
		}

		let tmpTriggerElements = this.pict.ContentAssignment.getElement(tmpTriggerSelector);
		if (tmpTriggerElements.length < 1) return;

		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		let tmpTriggerRect = tmpTriggerElements[0].getBoundingClientRect();
		let tmpAnchorRect = tmpAnchor[0].getBoundingClientRect();

		// Left-align the popup under its trigger by default.
		let tmpDesiredLeft = tmpTriggerRect.left;

		// A toolbar popup is position:absolute inside the anchor, which lives inside the flow
		// container -- and that container clips overflow (overflow:hidden). A trigger near the right
		// edge (e.g. the settings gear, which sits in the right-aligned group) would push a
		// left-aligned popup past the container's right edge, where it is sheared off. Clamp the
		// popup so it stays inside the container: pull its right edge in first, then keep its left
		// edge in. This makes the popup right-align to the trigger when it is near the right edge.
		let tmpClipElements = this.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpFlowViewIdentifier}`);
		let tmpClipRect = (tmpClipElements.length > 0) ? tmpClipElements[0].getBoundingClientRect() : null;
		let tmpPopupWidth = pPopupDiv.offsetWidth || 240;
		let tmpEdgeMargin = 6;

		let tmpLeftViewport = tmpDesiredLeft;
		if (tmpClipRect)
		{
			let tmpMaxLeft = tmpClipRect.right - tmpEdgeMargin - tmpPopupWidth;
			if (tmpLeftViewport > tmpMaxLeft) { tmpLeftViewport = tmpMaxLeft; }
			let tmpMinLeft = tmpClipRect.left + tmpEdgeMargin;
			if (tmpLeftViewport < tmpMinLeft) { tmpLeftViewport = tmpMinLeft; }
		}

		pPopupDiv.style.left = (tmpLeftViewport - tmpAnchorRect.left) + 'px';
		pPopupDiv.style.top = '0px';
	}

	// ── Add Node Popup ────────────────────────────────────────────────────

	/**
	 * Build the searchable Add Node popup content via templates with inline
	 * handlers. Search input fires `_filterNodeList` which re-renders the
	 * list section in place.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildAddNodePopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSearchIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('search', 12) : '';

		let tmpListID = `Flow-Toolbar-AddNodeList-${tmpFlowViewIdentifier}`;
		let tmpSearchID = `Flow-Toolbar-AddNodeSearch-${tmpFlowViewIdentifier}`;

		// Stage AppData and render the initial list HTML inline — the popup
		// element isn't in the DOM yet, so we can't look it up via
		// getElementById here. _filterNodeList handles updates after open.
		let tmpInitialListHTML = this._renderNodeListHTML('');

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-search-wrapper">'
			+ '<span class="pict-flow-popup-search-icon">' + tmpSearchIconHTML + '</span>'
			+ '<input id="' + tmpSearchID + '" class="pict-flow-popup-search" type="text" placeholder="Search node types..." '
			+ 'oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._filterNodeList(\'' + tmpListID + '\', this.value)" />'
			+ '</div>'
			+ '<div id="' + tmpListID + '" class="pict-flow-popup-node-list">' + tmpInitialListHTML + '</div>');
	}

	/**
	 * Build the HTML string for the Add Node list filtered by the given
	 * text. Stages AppData and renders the {~TS:~} template into a string;
	 * returns "no matches" markup when nothing matches.
	 *
	 * @param {string} pFilter
	 * @returns {string}
	 */
	_renderNodeListHTML(pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return '';

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpTypes = this._FlowView._NodeTypeProvider.getNodeTypes();
		let tmpTypeKeys = Object.keys(tmpTypes);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpIconProvider = this._FlowView._IconProvider;

		let tmpRows = [];
		for (let i = 0; i < tmpTypeKeys.length; i++)
		{
			let tmpTypeConfig = tmpTypes[tmpTypeKeys[i]];
			let tmpMeta = tmpTypeConfig.CardMetadata || {};
			if (tmpMeta.Enabled === false) continue;

			if (tmpFilter)
			{
				let tmpLabel = (tmpTypeConfig.Label || '').toLowerCase();
				let tmpCode = (tmpMeta.Code || '').toLowerCase();
				let tmpCategory = (tmpMeta.Category || '').toLowerCase();
				if (tmpLabel.indexOf(tmpFilter) < 0 && tmpCode.indexOf(tmpFilter) < 0 && tmpCategory.indexOf(tmpFilter) < 0) continue;
			}

			let tmpIconHTML = '';
			if (tmpIconProvider)
			{
				let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
				tmpIconHTML = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 16);
			}
			let tmpRowCode = tmpMeta.Code || '';
			tmpRows.push(
			{
				NodeType: tmpTypeKeys[i],
				Label: tmpTypeConfig.Label || '',
				IconHTML: tmpIconHTML,
				Code: tmpRowCode,
				// Pre-rendered so the template renders it with {~D:~} (a nested {~D:~} inside {~NE:~} is
				// not parsed by the engine).
				CodeBlock: tmpRowCode ? ('<span class="pict-flow-popup-list-item-code">' + tmpRowCode + '</span>') : '',
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		if (tmpRows.length === 0)
		{
			return '<div class="pict-flow-popup-list-empty">No matching node types</div>';
		}
		return this.pict.parseTemplateByHash('Flow-AddNode-List', { Rows: tmpRows });
	}

	/**
	 * Update the Add Node list contents in response to a search input
	 * change. Called from the inline `oninput` handler. The list element
	 * is already in the DOM by the time this fires.
	 *
	 * @param {string} pListID
	 * @param {string} pFilter
	 */
	_filterNodeList(pListID, pFilter)
	{
		let tmpListEl = document.getElementById(pListID);
		if (!tmpListEl) return;
		this.pict.ContentAssignment.assignContent(tmpListEl, this._renderNodeListHTML(pFilter));
	}

	/**
	 * Inline handler for an Add Node row click. Adds the node at viewport
	 * center and closes the popup.
	 *
	 * @param {string} pNodeType
	 */
	_addNodeFromPopup(pNodeType)
	{
		this._addNodeAtCenter(pNodeType);
		this._closePopup();
	}

	// ── Cards Popup ───────────────────────────────────────────────────────

	/**
	 * Build the Cards popup using templates with inline handlers. Search
	 * input fires `_filterCardsList` which re-renders the categorized list.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildCardsPopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSearchIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('search', 12) : '';

		let tmpListID = `Flow-Toolbar-CardsList-${tmpFlowViewIdentifier}`;
		let tmpSearchID = `Flow-Toolbar-CardsSearch-${tmpFlowViewIdentifier}`;

		// Initial render inline — popup not yet in DOM.
		let tmpInitialListHTML = this._renderCardsListHTML('');

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-search-wrapper">'
			+ '<span class="pict-flow-popup-search-icon">' + tmpSearchIconHTML + '</span>'
			+ '<input id="' + tmpSearchID + '" class="pict-flow-popup-search" type="text" placeholder="Search cards..." '
			+ 'oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._filterCardsList(\'' + tmpListID + '\', this.value)" />'
			+ '</div>'
			+ '<div id="' + tmpListID + '" class="pict-flow-popup-node-list">' + tmpInitialListHTML + '</div>');

		// Focus search input — defer past the popup append.
		setTimeout(() =>
		{
			let tmpSearch = document.getElementById(tmpSearchID);
			if (tmpSearch) tmpSearch.focus();
		}, 50);
	}

	/**
	 * Build the cards-list HTML string for the given filter. Stages
	 * AppData and renders via the {~TS:~} templates; returns "no matches"
	 * markup when nothing matches.
	 *
	 * @param {string} pFilter
	 * @returns {string}
	 */
	_renderCardsListHTML(pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return '';

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpCategories = this._FlowView._NodeTypeProvider.getCardsByCategory();
		let tmpCategoryKeys = Object.keys(tmpCategories);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpIconProvider = this._FlowView._IconProvider;
		let tmpTotalMatchCount = 0;

		let tmpCategoryRecords = [];
		for (let i = 0; i < tmpCategoryKeys.length; i++)
		{
			let tmpCategoryName = tmpCategoryKeys[i];
			let tmpCards = tmpCategories[tmpCategoryName];
			let tmpMatching = [];

			for (let j = 0; j < tmpCards.length; j++)
			{
				let tmpCardConfig = tmpCards[j];
				let tmpMeta = tmpCardConfig.CardMetadata || {};

				if (tmpFilter)
				{
					let tmpLabel = (tmpCardConfig.Label || '').toLowerCase();
					let tmpCode = (tmpMeta.Code || '').toLowerCase();
					let tmpCategory = tmpCategoryName.toLowerCase();
					if (tmpLabel.indexOf(tmpFilter) < 0 && tmpCode.indexOf(tmpFilter) < 0 && tmpCategory.indexOf(tmpFilter) < 0) continue;
				}

				let tmpIconHTML = '';
				let tmpIsEmoji = false;
				if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					tmpIconHTML = tmpIconProvider.getIconSVGMarkup(tmpIconProvider.resolveIconKey(tmpMeta), 14);
				}
				else if (tmpMeta.Icon)
				{
					tmpIsEmoji = true;
				}
				else if (tmpIconProvider)
				{
					tmpIconHTML = tmpIconProvider.getIconSVGMarkup('default', 14);
				}

				// Pre-render each conditional span into a complete HTML block ('' when absent). The
				// template renders these directly with {~D:~}; it cannot wrap them inline because the
				// engine does not parse a nested {~D:~} inside a {~NE:~}.
				let tmpCode = tmpMeta.Code || '';
				let tmpSwatchColor = (!tmpIconHTML && !tmpIsEmoji && tmpCardConfig.TitleBarColor) ? tmpCardConfig.TitleBarColor : '';
				let tmpIconBlock = '';
				if (tmpIconHTML) { tmpIconBlock = '<span class="pict-flow-palette-card-icon">' + tmpIconHTML + '</span>'; }
				else if (tmpIsEmoji) { tmpIconBlock = '<span class="pict-flow-palette-card-icon">' + tmpMeta.Icon + '</span>'; }
				let tmpSwatchBlock = tmpSwatchColor ? ('<span class="pict-flow-palette-card-swatch" style="background-color: ' + tmpSwatchColor + ';"></span>') : '';
				let tmpCodeBlock = tmpCode ? ('<span class="pict-flow-palette-card-code">' + tmpCode + '</span>') : '';

				tmpMatching.push(
				{
					CardType: tmpCardConfig.Hash,
					Label: tmpCardConfig.Label || '',
					Code: tmpCode,
					IconBlock: tmpIconBlock,
					SwatchBlock: tmpSwatchBlock,
					CodeBlock: tmpCodeBlock,
					DisabledClass: (tmpMeta.Enabled === false) ? ' disabled' : '',
					Tooltip: tmpMeta.Tooltip || tmpMeta.Description || '',
					FlowViewIdentifier: tmpFlowViewIdentifier
				});
			}

			if (tmpMatching.length === 0) continue;
			tmpTotalMatchCount += tmpMatching.length;
			tmpCategoryRecords.push(
			{
				Name: tmpCategoryName,
				Cards: tmpMatching,
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		if (tmpTotalMatchCount === 0)
		{
			return '<div class="pict-flow-popup-list-empty">' + (tmpFilter ? 'No matching cards' : 'No card types available') + '</div>';
		}
		return this.pict.parseTemplateByHash('Flow-Cards-List', { Categories: tmpCategoryRecords });
	}

	/**
	 * Inline `oninput` handler — refresh card list with the new filter.
	 */
	_filterCardsList(pListID, pFilter)
	{
		let tmpListEl = document.getElementById(pListID);
		if (!tmpListEl) return;
		this.pict.ContentAssignment.assignContent(tmpListEl, this._renderCardsListHTML(pFilter));
	}

	/**
	 * Inline handler for a card click. Adds the node and closes the popup.
	 *
	 * @param {string} pCardType
	 */
	_addCardFromPopup(pCardType)
	{
		this._addCardFromPalette(pCardType);
		this._closePopup();
	}

	// ── Layout Popup ──────────────────────────────────────────────────────

	/**
	 * Build the Layout popup using templates with inline handlers.
	 *
	 * Layout records (name + hash) are pushed into AppData and iterated via
	 * a {~TS:~} template. The save section is a static fragment with inline
	 * handlers that call the toolbar's helper methods.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildLayoutPopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSaveIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('save', 14) : '✓';
		let tmpDeleteIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('trash', 12) : '×';

		let tmpSaveRowID = `Flow-Toolbar-LayoutSaveRow-${tmpFlowViewIdentifier}`;
		let tmpSaveInputRowID = `Flow-Toolbar-LayoutSaveInputRow-${tmpFlowViewIdentifier}`;
		let tmpSaveInputID = `Flow-Toolbar-LayoutSaveInput-${tmpFlowViewIdentifier}`;
		let tmpListID = `Flow-Toolbar-LayoutList-${tmpFlowViewIdentifier}`;

		// Build layout records for the {~TS:~} iteration
		let tmpLayouts = (this._FlowView && this._FlowView._LayoutProvider)
			? this._FlowView._LayoutProvider.getLayouts() : [];
		let tmpLayoutRecords = [];
		for (let i = 0; i < tmpLayouts.length; i++)
		{
			tmpLayoutRecords.push(
			{
				LayoutHash: tmpLayouts[i].Hash,
				Name: tmpLayouts[i].Name || '',
				DeleteIconHTML: tmpDeleteIconHTML,
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		let tmpListHTML = (tmpLayoutRecords.length === 0)
			? '<div class="pict-flow-popup-list-empty">No saved layouts</div>'
			: this.pict.parseTemplateByHash('Flow-Layout-List', { Rows: tmpLayoutRecords });

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-layout-save-section">'
			+ '<div id="' + tmpSaveRowID + '" class="pict-flow-popup-layout-save"'
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._showLayoutSaveInput(\'' + tmpSaveRowID + '\', \'' + tmpSaveInputRowID + '\', \'' + tmpSaveInputID + '\')">'
			+ '<span class="pict-flow-popup-layout-save-icon">' + tmpSaveIconHTML + '</span>'
			+ '<span>Save Current Layout</span>'
			+ '</div>'
			+ '<div id="' + tmpSaveInputRowID + '" class="pict-flow-popup-layout-save-input-row" style="display:none;">'
			+ '<input id="' + tmpSaveInputID + '" class="pict-flow-popup-layout-save-input" type="text" placeholder="Layout name..."'
			+ ' onclick="event.stopPropagation()"'
			+ ' onkeydown="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleLayoutSaveKey(event, \'' + tmpSaveInputID + '\', \'' + tmpSaveRowID + '\', \'' + tmpSaveInputRowID + '\')" />'
			+ '<button class="pict-flow-popup-layout-save-confirm" title="Save"'
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._confirmLayoutSave(\'' + tmpSaveInputID + '\')">'
			+ tmpSaveIconHTML + '</button>'
			+ '</div>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div id="' + tmpListID + '">' + tmpListHTML + '</div>');
	}

	/**
	 * Inline handler — reveal the layout-name input and focus it.
	 */
	_showLayoutSaveInput(pSaveRowID, pInputRowID, pInputID)
	{
		let tmpRow = document.getElementById(pSaveRowID);
		let tmpInputRow = document.getElementById(pInputRowID);
		let tmpInput = document.getElementById(pInputID);
		if (tmpRow) tmpRow.style.display = 'none';
		if (tmpInputRow) tmpInputRow.style.display = '';
		if (tmpInput)
		{
			tmpInput.value = '';
			setTimeout(() => { tmpInput.focus(); }, 50);
		}
	}

	/**
	 * Inline handler — Enter saves, Escape cancels.
	 */
	_handleLayoutSaveKey(pEvent, pInputID, pSaveRowID, pInputRowID)
	{
		if (pEvent.key === 'Enter')
		{
			pEvent.preventDefault();
			this._confirmLayoutSave(pInputID);
		}
		else if (pEvent.key === 'Escape')
		{
			let tmpRow = document.getElementById(pSaveRowID);
			let tmpInputRow = document.getElementById(pInputRowID);
			if (tmpInputRow) tmpInputRow.style.display = 'none';
			if (tmpRow) tmpRow.style.display = '';
		}
	}

	/**
	 * Inline handler — save the layout under the entered name and rebuild
	 * the popup so the new entry appears.
	 */
	_confirmLayoutSave(pInputID)
	{
		let tmpInput = document.getElementById(pInputID);
		if (!tmpInput) return;
		let tmpName = (tmpInput.value || '').trim();
		if (tmpName === '') return;
		this._FlowView._LayoutProvider.saveLayout(tmpName);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — restore layout when the row (not its delete button)
	 * is clicked.
	 */
	_restoreLayoutFromPopup(pLayoutHash, pEvent)
	{
		if (pEvent && pEvent.target && pEvent.target.closest('.pict-flow-popup-layout-delete')) return;
		this._FlowView._LayoutProvider.restoreLayout(pLayoutHash);
		this._closePopup();
	}

	/**
	 * Inline handler — delete a saved layout and refresh the popup.
	 */
	_deleteLayoutFromPopup(pLayoutHash, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') pEvent.stopPropagation();
		this._FlowView._LayoutProvider.deleteLayout(pLayoutHash);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutPopup(tmpPopupEl);
	}

	// ── Layout Algorithm Popup ────────────────────────────────────────────

	/**
	 * Build the Layout Algorithm popup using templates with inline handlers.
	 * The popup has three logical sections (algorithm chooser, edge-theme
	 * chooser, auto-apply toggle + apply button). Each control's behavior
	 * lives on the toolbar as a helper method called from inline handlers.
	 *
	 * Iterations (algorithm options, edge themes) are template-driven via
	 * AppData arrays.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildLayoutAlgorithmPopup(pContainer)
	{
		if (!this._FlowView || !this._FlowView._LayoutService) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpLayoutService = this._FlowView._LayoutService;
		let tmpCurrentSettings = this._FlowView.getLayoutAlgorithm();
		let tmpAlgoDescriptor = tmpLayoutService.getAlgorithm(tmpCurrentSettings.Algorithm);
		let tmpEdgeSettings = this._FlowView.getEdgeTheme();
		let tmpResolvedEdge = tmpEdgeSettings.Theme;
		let tmpExplicitEdgeOverride = tmpEdgeSettings.Override;
		let tmpDefaultThemeName = (tmpAlgoDescriptor && tmpAlgoDescriptor.DefaultEdgeTheme) || 'Bezier';
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSettingsIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('settings', 13) : '⚙';

		// Build option records for the dropdowns
		let tmpAlgoOptions = tmpLayoutService.listAlgorithms().map((pAlgo) => (
		{
			Value: pAlgo.Name,
			Label: pAlgo.Label || pAlgo.Name,
			SelectedAttr: (pAlgo.Name === tmpCurrentSettings.Algorithm) ? ' selected="selected"' : ''
		}));

		let tmpEdgeOptionRecords = [];
		tmpEdgeOptionRecords.push(
		{
			Value: '__inherit__',
			Label: `Inherit from layout (${tmpDefaultThemeName})`,
			SelectedAttr: !tmpExplicitEdgeOverride ? ' selected="selected"' : ''
		});
		let tmpEdgeThemes = tmpLayoutService.listEdgeThemes();
		for (let i = 0; i < tmpEdgeThemes.length; i++)
		{
			tmpEdgeOptionRecords.push(
			{
				Value: tmpEdgeThemes[i].Name,
				Label: tmpEdgeThemes[i].Label || tmpEdgeThemes[i].Name,
				SelectedAttr: (tmpEdgeThemes[i].Name === tmpExplicitEdgeOverride) ? ' selected="selected"' : ''
			});
		}

		let tmpAlgoOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpAlgoOptions });
		let tmpEdgeOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpEdgeOptionRecords });

		let tmpHasParameters = !!(tmpAlgoDescriptor && (
			(tmpAlgoDescriptor.ParameterManifest && tmpAlgoDescriptor.ParameterManifest.Descriptors) ||
			(tmpAlgoDescriptor.ParameterSchema && Object.keys(tmpAlgoDescriptor.ParameterSchema).length > 0)
		));

		let tmpAlgoDescription = (tmpAlgoDescriptor && tmpAlgoDescriptor.Description)
			? '<div class="pict-flow-popup-control-description">' + tmpAlgoDescriptor.Description + '</div>'
			: '';

		let tmpFormToggleHTML = '';
		if (tmpHasParameters)
		{
			tmpFormToggleHTML = '<button type="button" class="pict-flow-popup-collapse-toggle"'
				+ ' aria-expanded="' + (this._LayoutFormExpanded ? 'true' : 'false') + '"'
				+ ' title="' + (this._LayoutFormExpanded ? 'Hide parameters' : 'Show parameters') + '"'
				+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._toggleLayoutFormCollapsed(this)">'
				+ tmpSettingsIconHTML
				+ '</button>';
		}

		let tmpAutoApplyID = `Flow-Toolbar-AutoApply-${tmpFlowViewIdentifier}`;
		let tmpApplyDisabled = (tmpCurrentSettings.Algorithm === 'Custom') ? ' disabled' : '';
		let tmpApplyTitle = (tmpCurrentSettings.Algorithm === 'Custom') ? ' title="Custom does not auto-position nodes"' : '';

		let tmpEdgeDescriptionHTML = '';
		if (tmpResolvedEdge)
		{
			let tmpResolvedDescriptor = tmpLayoutService.getEdgeTheme(tmpResolvedEdge);
			if (tmpResolvedDescriptor && tmpResolvedDescriptor.Description)
			{
				tmpEdgeDescriptionHTML = '<div class="pict-flow-popup-control-description">' + tmpResolvedDescriptor.Description + '</div>';
			}
		}

		// Place a host div for the parameter form; mount the form into it
		// after the popup is in the DOM (the metacontroller resolves
		// destinations via document.querySelector).
		let tmpParamFormHostID = `Flow-Toolbar-LayoutParamFormHost-${tmpFlowViewIdentifier}`;

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-settings-section pict-flow-popup-layout-algorithm-row">'
			+ '<label class="pict-flow-popup-settings-label">Algorithm</label>'
			+ '<div class="pict-flow-popup-layout-algorithm-controls">'
			+ '<select class="pict-flow-popup-settings-select pict-flow-popup-layout-algorithm-select" data-layout-control="algorithm"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleLayoutAlgoChange(this.value)">'
			+ tmpAlgoOptionsHTML
			+ '</select>'
			+ tmpFormToggleHTML
			+ '</div>'
			+ '</div>'
			+ tmpAlgoDescription
			+ '<div id="' + tmpParamFormHostID + '"></div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section">'
			+ '<label class="pict-flow-popup-settings-label">Edge theme</label>'
			+ '<select class="pict-flow-popup-settings-select" data-layout-control="edge-theme"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleEdgeThemeChange(this.value)">'
			+ tmpEdgeOptionsHTML
			+ '</select>'
			+ '</div>'
			+ tmpEdgeDescriptionHTML
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section" style="display:flex;align-items:center;gap:8px;">'
			+ '<input type="checkbox" id="' + tmpAutoApplyID + '"' + (tmpCurrentSettings.AutoApply ? ' checked="checked"' : '') + ''
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleAutoApplyChange(this.checked)" />'
			+ '<label class="pict-flow-popup-settings-label" for="' + tmpAutoApplyID + '" style="cursor:pointer;">Auto-apply on changes</label>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section" style="padding:4px 8px;">'
			+ '<button class="pict-flow-popup-layout-save-confirm" style="width:100%;padding:6px;"' + tmpApplyDisabled + tmpApplyTitle
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleApplyLayoutNow()">Apply Now</button>'
			+ '</div>');

		// Mount the parameter form (handles its own DOM building /
		// metacontroller). Use pContainer.querySelector — the popup may
		// not be in the document yet, so document.getElementById would miss.
		let tmpFormHostEl = pContainer.querySelector('#' + tmpParamFormHostID);
		if (tmpFormHostEl)
		{
			this._buildLayoutParameterFormSection(tmpFormHostEl, tmpAlgoDescriptor, tmpCurrentSettings);
		}
	}

	/**
	 * Inline handler — switch layout algorithm, refresh popup.
	 */
	_handleLayoutAlgoChange(pName)
	{
		if (!this._FlowView || !this._FlowView._LayoutService) return;
		let tmpAlgo = this._FlowView._LayoutService.getAlgorithm(pName);
		let tmpDefaults = (tmpAlgo && tmpAlgo.DefaultParameters)
			? JSON.parse(JSON.stringify(tmpAlgo.DefaultParameters)) : {};
		this._FlowView.setLayoutAlgorithm(pName, tmpDefaults);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutAlgorithmPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — switch edge theme, refresh popup so descriptions
	 * track the new theme.
	 */
	_handleEdgeThemeChange(pValue)
	{
		if (!this._FlowView) return;
		if (pValue === '__inherit__')
		{
			this._FlowView.setEdgeTheme(null);
		}
		else
		{
			this._FlowView.setEdgeTheme(pValue);
		}

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutAlgorithmPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — toggle auto-apply.
	 */
	_handleAutoApplyChange(pChecked)
	{
		if (!this._FlowView) return;
		this._FlowView.setLayoutAutoApply(pChecked);
	}

	/**
	 * Inline handler — fire the layout (when not Custom).
	 */
	_handleApplyLayoutNow()
	{
		if (!this._FlowView) return;
		let tmpSettings = this._FlowView.getLayoutAlgorithm();
		if (tmpSettings.Algorithm === 'Custom') return;
		this._FlowView.applyCurrentLayout();
	}

	/**
	 * Inline handler — toggle the parameter-form collapse state.
	 */
	_toggleLayoutFormCollapsed(pToggleButton)
	{
		this._LayoutFormExpanded = !this._LayoutFormExpanded;
		pToggleButton.setAttribute('aria-expanded', this._LayoutFormExpanded ? 'true' : 'false');
		pToggleButton.title = this._LayoutFormExpanded ? 'Hide parameters' : 'Show parameters';
		let tmpHost = this._LayoutFormHostID ? document.getElementById(this._LayoutFormHostID) : null;
		if (tmpHost)
		{
			tmpHost.setAttribute('data-collapsed', this._LayoutFormExpanded ? 'false' : 'true');
		}
	}

	/**
	 * Render the parameter form section. When the host app has registered
	 * `PictFormMetacontroller` and the algorithm provides a
	 * `ParameterManifest`, we inject that manifest into a section-form so
	 * the user gets the same Manyfest-driven UX as the rest of the Pict
	 * ecosystem. Otherwise we fall back to schema-driven hand-rolled inputs.
	 *
	 * Data binding: `pict.AppData.PictFlowLayoutEditor.Parameters` is a
	 * mirror of `_FlowData.LayoutParameters`. The form's Informary writes
	 * directly into AppData; a `change`/`input` listener on the popup
	 * pushes those edits back into `_FlowData.LayoutParameters` and (when
	 * the active algorithm is non-Custom) re-applies the layout.
	 *
	 * @param {HTMLElement} pContainer
	 * @param {Object} pAlgoDescriptor - the descriptor for the active algorithm
	 * @param {{ Algorithm: string, Parameters: Object }} pCurrentSettings
	 */
	_buildLayoutParameterFormSection(pContainer, pAlgoDescriptor, pCurrentSettings)
	{
		if (!pAlgoDescriptor) return;

		let tmpHasManifest = !!(pAlgoDescriptor.ParameterManifest && pAlgoDescriptor.ParameterManifest.Descriptors);
		let tmpMetacontrollerType = this._resolveMetacontrollerServiceType();

		if (tmpHasManifest && tmpMetacontrollerType)
		{
			this._mountLayoutParameterMetacontroller(pContainer, pAlgoDescriptor, pCurrentSettings, tmpMetacontrollerType);
			return;
		}

		// Fallback path — schema-driven hand-rolled inputs.
		let tmpSchema = (pAlgoDescriptor.ParameterSchema) ? pAlgoDescriptor.ParameterSchema : {};
		let tmpParamKeys = Object.keys(tmpSchema);
		if (tmpParamKeys.length === 0) return;

		let tmpParamDivider = document.createElement('div');
		tmpParamDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpParamDivider);

		let tmpParamHeader = document.createElement('div');
		tmpParamHeader.className = 'pict-flow-popup-settings-label';
		tmpParamHeader.style.fontWeight = 'bold';
		tmpParamHeader.style.padding = '4px 8px';
		tmpParamHeader.textContent = 'Parameters';
		pContainer.appendChild(tmpParamHeader);

		for (let i = 0; i < tmpParamKeys.length; i++)
		{
			let tmpKey = tmpParamKeys[i];
			let tmpFieldSchema = tmpSchema[tmpKey];
			let tmpCurrentValue = (pCurrentSettings.Parameters && pCurrentSettings.Parameters.hasOwnProperty(tmpKey))
				? pCurrentSettings.Parameters[tmpKey]
				: tmpFieldSchema.Default;

			let tmpRow = document.createElement('div');
			tmpRow.className = 'pict-flow-popup-settings-section';
			tmpRow.style.display = 'flex';
			tmpRow.style.alignItems = 'center';
			tmpRow.style.gap = '8px';

			let tmpRowLabel = document.createElement('label');
			tmpRowLabel.className = 'pict-flow-popup-settings-label';
			tmpRowLabel.textContent = tmpFieldSchema.Label || tmpKey;
			tmpRowLabel.style.flex = '1';
			tmpRow.appendChild(tmpRowLabel);

			let tmpInput = this._buildLayoutParamInput(tmpKey, tmpFieldSchema, tmpCurrentValue);
			tmpRow.appendChild(tmpInput);
			pContainer.appendChild(tmpRow);
		}
	}

	/**
	 * Remove `PictSectionForm-*` views the layout-algorithm popup has
	 * previously registered on the host Pict. Without this, switching
	 * algorithms accumulates dead section views — the metatemplate
	 * generated by the next inject would still reference the old ones.
	 * Idempotent.
	 */
	_evictLayoutFormViews()
	{
		if (!this.pict || !this.pict.views) return;
		let tmpKeys = Object.keys(this.pict.views);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			if (tmpKey.indexOf('PictSectionForm-') === 0 && tmpKey.indexOf('PictFlowLayout') > 0)
			{
				delete this.pict.views[tmpKey];
				continue;
			}
			// Match any previously-injected layout-algorithm section by hash
			// suffix (manifests use unique algorithm-suffixed section names).
			if (tmpKey.indexOf('PictSectionForm-PFL') === 0)
			{
				delete this.pict.views[tmpKey];
			}
		}
		this._LayoutFormMetacontroller = null;
	}

	/**
	 * Look up which form-metacontroller service is registered on the host
	 * Pict instance. pict-section-form has been published under both
	 * 'PictFormMetacontroller' and (older) 'PictViewFormMetacontroller'
	 * names; check both, in that order.
	 * @returns {string|null}
	 */
	_resolveMetacontrollerServiceType()
	{
		if (!this.fable || !this.fable.servicesMap) return null;
		if (this.fable.servicesMap.hasOwnProperty('PictFormMetacontroller'))     return 'PictFormMetacontroller';
		if (this.fable.servicesMap.hasOwnProperty('PictViewFormMetacontroller')) return 'PictViewFormMetacontroller';
		return null;
	}

	/**
	 * Build the parameter form section using a pict-section-form
	 * metacontroller. Creates a host div, binds the active layout
	 * parameters to `pict.AppData.PictFlowLayoutEditor.Parameters`, and
	 * injects the algorithm's `ParameterManifest`. Form-input changes
	 * propagate back to `_FlowData.LayoutParameters` via a single
	 * `change`/`input` listener on the popup container.
	 *
	 * @param {HTMLElement} pContainer
	 * @param {Object} pAlgoDescriptor
	 * @param {{ Algorithm: string, Parameters: Object }} pCurrentSettings
	 * @param {string} pMetacontrollerType - 'PictFormMetacontroller' or 'PictViewFormMetacontroller'
	 */
	_mountLayoutParameterMetacontroller(pContainer, pAlgoDescriptor, pCurrentSettings, pMetacontrollerType)
	{
		let tmpManifest = JSON.parse(JSON.stringify(pAlgoDescriptor.ParameterManifest));
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Section header + divider
		let tmpDivider = document.createElement('div');
		tmpDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpDivider);

		// Form host div — the metacontroller renders into here. Inline
		// onclick stops popup-close propagation; onchange/oninput drive the
		// _FlowData.LayoutParameters writeback (see _pushFormBack).
		let tmpHostID = `Flow-Toolbar-LayoutForm-${tmpFlowViewIdentifier}`;
		this._LayoutFormHostID = tmpHostID;

		let tmpHostDiv = document.createElement('div');
		tmpHostDiv.id = tmpHostID;
		tmpHostDiv.className = 'pict-flow-popup-layout-form-host';
		tmpHostDiv.setAttribute('data-collapsed', this._LayoutFormExpanded ? 'false' : 'true');
		tmpHostDiv.setAttribute('onclick', 'event.stopPropagation()');
		tmpHostDiv.setAttribute('onchange',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView._pushLayoutFormBack('" + pCurrentSettings.Algorithm + "')");
		tmpHostDiv.setAttribute('oninput',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView._pushLayoutFormBack('" + pCurrentSettings.Algorithm + "')");
		pContainer.appendChild(tmpHostDiv);

		// Bind the layout parameters as the data source for the form.
		// `injectManifestAndRender(manifest, _, UUID)` calls
		// `createDistinctManifest` which prepends the UUID to every descriptor
		// address (so re-injecting the same manifest doesn't collide). We use
		// the algorithm name as the UUID, so the form's expected address is
		// `AppData.<Algorithm>.PictFlowLayoutEditor.Parameters.<Key>` —
		// bind there, not at the unprefixed root.
		let tmpScope = pCurrentSettings.Algorithm;
		this.pict.AppData[tmpScope] = this.pict.AppData[tmpScope] || {};
		this.pict.AppData[tmpScope].PictFlowLayoutEditor = this.pict.AppData[tmpScope].PictFlowLayoutEditor || {};
		this.pict.AppData[tmpScope].PictFlowLayoutEditor.Parameters = JSON.parse(JSON.stringify(pCurrentSettings.Parameters || {}));

		// Always recreate the metacontroller per mount. Reusing the same
		// metacontroller across algorithm switches accumulates section views
		// (each switch's manifest gets injected onto the existing roster) and
		// the metatemplate ends up wedging multiple sections into a single
		// shared destination — only the last one survives. Fresh instance per
		// mount keeps the DOM consistent; we also evict the prior
		// `PictSectionForm-*` views from `pict.views` so they GC cleanly.
		this._evictLayoutFormViews();
		try
		{
			this._LayoutFormMetacontroller = this.fable.instantiateServiceProviderWithoutRegistration(
				pMetacontrollerType,
				{
					ViewIdentifier: `Flow-Toolbar-LayoutForm-MC-${tmpFlowViewIdentifier}-${this.fable.getUUID()}`,
					DefaultDestinationAddress: `#${tmpHostID}`,
					AutoRender: false,
					AutoPopulateAfterRender: true,
					AutoSolveBeforeRender: false
				});
		}
		catch (pError)
		{
			this.log.warn(`Failed to instantiate ${pMetacontrollerType}: ${pError.message}`);
			this._LayoutFormMetacontroller = null;
		}

		if (!this._LayoutFormMetacontroller)
		{
			tmpHostDiv.innerHTML = '<em style="padding:8px;display:block;opacity:0.7;">pict-section-form not available; parameter form skipped.</em>';
			return;
		}

		// Establish the form-container div the metacontroller expects.
		let tmpFormContainerID = `Pict-${this._LayoutFormMetacontroller.UUID}-FormContainer`;
		tmpHostDiv.innerHTML = `<div id="${tmpFormContainerID}" class="pict-form pict-flow-popup-layout-form"></div>`;

		try
		{
			// Use `injectManifest` + explicit per-section destination divs +
			// per-section render. Don't use `injectManifestAndRender` —
			// its metatemplate flow ends up wedging multi-section manifests
			// into a single shared destination (each section's render call
			// uses RenderMethod=replace, blowing the others away). The
			// explicit path gives each section its own destination div and
			// renders them independently.
			let tmpInjectFn = (typeof this._LayoutFormMetacontroller.injectManifest === 'function')
				? this._LayoutFormMetacontroller.injectManifest.bind(this._LayoutFormMetacontroller)
				: null;
			if (!tmpInjectFn) throw new Error('Metacontroller exposes neither injectManifest nor injectManifestAndRender');

			// Pass the algorithm name as the section-hash discriminator so
			// re-injecting the same algorithm gets unique view registrations.
			// (createDistinctManifest does the address-prefixing too — see
			// the per-algorithm AppData binding above.)
			let tmpDistinct = (typeof this._LayoutFormMetacontroller.createDistinctManifest === 'function')
				? this._LayoutFormMetacontroller.createDistinctManifest(tmpManifest, pCurrentSettings.Algorithm)
				: tmpManifest;

			let tmpViews = tmpInjectFn(tmpDistinct);

			// Build a destination div per section view, in order, and render each.
			let tmpFormContainerEl = tmpHostDiv.querySelector(`#${tmpFormContainerID}`);
			if (tmpFormContainerEl)
			{
				let tmpInner = '';
				for (let i = 0; i < tmpViews.length; i++)
				{
					let tmpDest = tmpViews[i].options.DefaultDestinationAddress;
					if (tmpDest && tmpDest.charAt(0) === '#') tmpDest = tmpDest.substring(1);
					tmpInner += `<div id="${tmpDest}" class="pict-form-view"></div>`;
				}
				tmpFormContainerEl.innerHTML = tmpInner;
			}
			// Defer render() to the next microtask so the popup has been
			// appended to the DOM by `_openPopup` — pict-section-form
			// resolves destinations via `document.querySelector`, which
			// can't see detached subtrees. (Same workaround the
			// metacontroller's own `injectManifestAndRender` uses.)
			setTimeout(() =>
			{
				for (let i = 0; i < tmpViews.length; i++)
				{
					tmpViews[i].render();
					if (typeof tmpViews[i].marshalToView === 'function')
					{
						tmpViews[i].marshalToView();
					}
				}
			}, 0);
		}
		catch (pError)
		{
			this.log.warn(`PictViewFlowToolbar: layout-form injection failed: ${pError.message}`);
			tmpHostDiv.innerHTML = `<em style="padding:8px;display:block;opacity:0.7;">Form render error: ${pError.message}</em>`;
			return;
		}

		// Form-change writeback runs through the host div's inline
		// onchange/oninput attributes (set above), which call
		// `_pushLayoutFormBack(algorithm)`.
	}

	/**
	 * Inline handler for layout-parameter form changes. Pushes Informary's
	 * write into AppData back into `_FlowData.LayoutParameters` and
	 * re-applies the layout (when non-Custom). De-bounces via microtask so
	 * multi-key edits collapse to a single layout pass.
	 *
	 * @param {string} pAlgorithm
	 */
	_pushLayoutFormBack(pAlgorithm)
	{
		if (this._LayoutFormPushScheduled) return;
		this._LayoutFormPushScheduled = true;
		Promise.resolve().then(() =>
		{
			this._LayoutFormPushScheduled = false;
			if (!this._FlowView) return;
			let tmpScopedRoot = this.pict.AppData[pAlgorithm] || {};
			let tmpEditorParams = (tmpScopedRoot.PictFlowLayoutEditor || {}).Parameters || {};
			let tmpMerged = Object.assign({}, this._FlowView.getLayoutAlgorithm().Parameters || {}, tmpEditorParams);
			this._FlowView.setLayoutAlgorithm(pAlgorithm, tmpMerged);
		});
	}

	/**
	 * Build a single parameter input row for the layout-algorithm popup.
	 * Wires the input's change handler to update the flow's
	 * `LayoutParameters` and re-apply the layout if non-Custom.
	 *
	 * @param {string} pKey
	 * @param {Object} pSchema - { Type: 'number' | 'string' | 'boolean' | 'enum', Default, Options? }
	 * @param {*} pCurrentValue
	 * @returns {HTMLElement}
	 */
	_buildLayoutParamInput(pKey, pSchema, pCurrentValue)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpViewPath = "_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView";
		let tmpKeyEsc = pKey.replace(/'/g, "\\'");
		let tmpInput;

		if (pSchema.Type === 'boolean')
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'checkbox';
			tmpInput.checked = !!pCurrentValue;
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.checked)");
		}
		else if (pSchema.Type === 'enum' && Array.isArray(pSchema.Options))
		{
			tmpInput = document.createElement('select');
			tmpInput.className = 'pict-flow-popup-settings-select';
			for (let i = 0; i < pSchema.Options.length; i++)
			{
				let tmpOpt = document.createElement('option');
				tmpOpt.value = pSchema.Options[i];
				tmpOpt.textContent = pSchema.Options[i];
				if (pSchema.Options[i] === pCurrentValue) tmpOpt.selected = true;
				tmpInput.appendChild(tmpOpt);
			}
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.value)");
		}
		else if (pSchema.Type === 'number' || pSchema.Type === 'Number' || pSchema.Type === 'PreciseNumber')
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'number';
			tmpInput.className = 'pict-flow-popup-settings-input';
			let tmpIsPrecise = (pSchema.Type === 'PreciseNumber');
			if (typeof pSchema.Min === 'number') tmpInput.min = String(pSchema.Min);
			if (typeof pSchema.Max === 'number') tmpInput.max = String(pSchema.Max);
			tmpInput.step = tmpIsPrecise ? 'any' : '1';
			tmpInput.value = (pCurrentValue == null) ? '' : String(pCurrentValue);
			tmpInput.style.width = '90px';
			let tmpPreciseFlag = tmpIsPrecise ? 'true' : 'false';
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutNumberParameter('" + tmpKeyEsc + "', this.value, " + tmpPreciseFlag + ")");
		}
		else
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'text';
			tmpInput.className = 'pict-flow-popup-settings-input';
			tmpInput.value = (pCurrentValue == null) ? '' : String(pCurrentValue);
			tmpInput.style.width = '90px';
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.value)");
		}

		tmpInput.setAttribute('onclick', 'event.stopPropagation()');
		return tmpInput;
	}

	/**
	 * Update a single layout parameter on the flow and re-apply the layout
	 * if the configured algorithm is not 'Custom'.
	 * @param {string} pKey
	 * @param {*} pValue
	 */
	_updateLayoutParameter(pKey, pValue)
	{
		if (!this._FlowView) return;
		let tmpSettings = this._FlowView.getLayoutAlgorithm();
		let tmpParams = Object.assign({}, tmpSettings.Parameters || {});
		tmpParams[pKey] = pValue;
		this._FlowView.setLayoutAlgorithm(tmpSettings.Algorithm, tmpParams);
	}

	/**
	 * Inline-handler helper for numeric parameter inputs. Preserves the
	 * raw string when PreciseNumber so big.js / ExpressionParser can use
	 * it without float round-trip drift.
	 *
	 * @param {string} pKey
	 * @param {string} pRawValue
	 * @param {boolean} pIsPrecise
	 */
	_updateLayoutNumberParameter(pKey, pRawValue, pIsPrecise)
	{
		if (pRawValue === '') return;
		if (pIsPrecise)
		{
			this._updateLayoutParameter(pKey, pRawValue);
			return;
		}
		let tmpNum = parseFloat(pRawValue);
		if (isNaN(tmpNum)) return;
		this._updateLayoutParameter(pKey, tmpNum);
	}

	// ── Settings Popup ───────────────────────────────────────────────────

	/**
	 * Build the Settings popup using a template with inline handlers.
	 *
	 * Theme options are iterated via `{~TS:~}` from AppData. Sliders and
	 * selects fire inline handlers that update the FlowView's theme state.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildSettingsPopup(pContainer)
	{
		if (!this._FlowView) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPresetsProvider = this._FlowView._StylePresetsProvider;
		let tmpRendererProvider = this._FlowView._RendererProvider;
		if (!tmpPresetsProvider || !tmpRendererProvider) return;

		// The single "Style" picker surfaces curated presets — each one bundles
		// a ColorTheme + Renderer + EdgeTheme. Per-axis overrides live behind
		// future "Customize" UI; the toolbar shows the preset list only.
		let tmpPresets = tmpPresetsProvider.listPresets();
		let tmpActivePreset = tmpPresetsProvider.getActivePresetHash();

		let tmpThemeOptions = [];
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpPreset = tmpPresets[i];
			tmpThemeOptions.push(
			{
				Value: tmpPreset.Hash,
				Label: tmpPreset.Label || tmpPreset.Hash,
				SelectedAttr: (tmpPreset.Hash === tmpActivePreset) ? ' selected="selected"' : ''
			});
		}

		let tmpThemeOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpThemeOptions });

		let tmpNoiseLevel = Math.round(tmpRendererProvider.getNoiseLevel() * 100);
		let tmpActiveRenderer = tmpRendererProvider.getActiveRenderer();
		let tmpNoiseEnabled = !!(tmpActiveRenderer && tmpActiveRenderer.NoiseConfig && tmpActiveRenderer.NoiseConfig.Enabled);
		let tmpNoiseDisplay = tmpNoiseEnabled ? '' : 'display:none;';

		let tmpHTML =
			'<div class="pict-flow-popup-settings-section">'
			+ '<label class="pict-flow-popup-settings-label">Theme</label>'
			+ '<select class="pict-flow-popup-settings-select"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleThemeSelectChange(this.value)">'
			+ tmpThemeOptionsHTML
			+ '</select>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section pict-flow-popup-settings-noise" data-settings-type="noise" style="' + tmpNoiseDisplay + '">'
			+ '<label class="pict-flow-popup-settings-label">Noise</label>'
			+ '<div class="pict-flow-popup-settings-slider-row">'
			+ '<input type="range" class="pict-flow-popup-settings-slider" min="0" max="100" value="' + tmpNoiseLevel + '"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onpointerdown="event.stopPropagation()"'
			+ ' oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleNoiseSliderInput(this)" />'
			+ '<span class="pict-flow-popup-settings-slider-value">' + tmpNoiseLevel + '%</span>'
			+ '</div>'
			+ '</div>';

		tmpHTML += this._buildHostSettingsSections();

		this.pict.ContentAssignment.assignContent(pContainer, tmpHTML);
	}

	/**
	 * Host-contributed settings sections. A consumer adds entries to the flow view's
	 * `SettingsSections` option so its own controls (e.g. a whiteboard's background
	 * picker) live in the gear popup instead of a separate panel. Each entry is
	 * `{ Label?, HTML? , Build?(flowView) }`; Build is evaluated at open time so a
	 * section can reflect live state. Returns concatenated section markup ('' when none).
	 * @returns {string}
	 */
	_buildHostSettingsSections()
	{
		let tmpSections = (this._FlowView && this._FlowView.options && Array.isArray(this._FlowView.options.SettingsSections))
			? this._FlowView.options.SettingsSections
			: [];
		let tmpOut = '';
		for (let i = 0; i < tmpSections.length; i++)
		{
			let tmpSection = tmpSections[i];
			let tmpSectionHTML = '';
			if (typeof tmpSection.Build === 'function')
			{
				tmpSectionHTML = tmpSection.Build(this._FlowView) || '';
			}
			else if (typeof tmpSection.HTML === 'string')
			{
				tmpSectionHTML = tmpSection.HTML;
			}
			if (!tmpSectionHTML)
			{
				continue;
			}
			tmpOut += '<div class="pict-flow-popup-divider"></div>'
				+ '<div class="pict-flow-popup-settings-section">'
				+ (tmpSection.Label ? '<label class="pict-flow-popup-settings-label">' + tmpSection.Label + '</label>' : '')
				+ tmpSectionHTML
				+ '</div>';
		}
		return tmpOut;
	}

	/**
	 * Inline handler — apply selected flow theme and refresh the noise
	 * slider visibility (some themes don't expose noise).
	 */
	_handleThemeSelectChange(pThemeKey)
	{
		if (!this._FlowView) return;
		this._FlowView.setTheme(pThemeKey);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._refreshNoiseSlider(tmpPopupEl);
	}

	/**
	 * Inline handler — push slider position into the noise level and
	 * update the percentage label adjacent to it.
	 */
	_handleNoiseSliderInput(pSlider)
	{
		let tmpRaw = parseInt(pSlider.value, 10);
		if (isNaN(tmpRaw)) return;
		let tmpLevel = tmpRaw / 100;
		let tmpValueLabel = pSlider.parentNode ? pSlider.parentNode.querySelector('.pict-flow-popup-settings-slider-value') : null;
		if (tmpValueLabel) tmpValueLabel.textContent = tmpRaw + '%';
		if (this._FlowView) this._FlowView.setNoiseLevel(tmpLevel);
	}

	/**
	 * Show or hide the noise slider based on whether the active theme supports noise.
	 * @param {HTMLElement} pContainer - The settings popup container
	 */
	_refreshNoiseSlider(pContainer)
	{
		let tmpNoiseSection = pContainer.querySelector('[data-settings-type="noise"]');
		if (!tmpNoiseSection) return;

		let tmpRendererProvider = this._FlowView._RendererProvider;
		if (!tmpRendererProvider) { tmpNoiseSection.style.display = 'none'; return; }
		let tmpRenderer = tmpRendererProvider.getActiveRenderer();
		if (tmpRenderer && tmpRenderer.NoiseConfig && tmpRenderer.NoiseConfig.Enabled)
		{
			tmpNoiseSection.style.display = '';
			// Update slider value to reflect renderer default
			let tmpSlider = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider');
			let tmpValueLabel = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider-value');
			if (tmpSlider)
			{
				let tmpLevel = Math.round(tmpRendererProvider.getNoiseLevel() * 100);
				tmpSlider.value = String(tmpLevel);
				if (tmpValueLabel) tmpValueLabel.textContent = tmpLevel + '%';
			}
		}
		else
		{
			tmpNoiseSection.style.display = 'none';
		}
	}

	// ── Toolbar Mode Switching ────────────────────────────────────────────

	/**
	 * Switch between docked, floating, and collapsed modes.
	 * @param {string} pMode - 'docked' | 'floating' | 'collapsed'
	 */
	_setToolbarMode(pMode)
	{
		// Close any active popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpBar = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Bar-${tmpFlowViewIdentifier}`);
		let tmpCollapsed = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Collapsed-${tmpFlowViewIdentifier}`);

		switch (pMode)
		{
			case 'docked':
				// Show toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = '';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;

			case 'floating':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Show floating toolbar
				this._showFloatingToolbar();
				break;

			case 'collapsed':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Show collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.add('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;
		}

		this._ToolbarMode = pMode;
	}

	/**
	 * Lazily create and show the floating toolbar.
	 */
	_showFloatingToolbar()
	{
		if (!this._FlowView) return;

		if (!this._FloatingToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			this._FloatingToolbarView = this.fable.instantiateServiceProviderWithoutRegistration(
				'PictViewFlowFloatingToolbar',
				{
					FlowViewIdentifier: tmpFlowViewIdentifier,
					DefaultDestinationAddress: `#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`,
					EnableAddNode: this.options.EnableAddNode,
					EnableCardPalette: this.options.EnableCardPalette,
					ToolbarExtraButtons: this.options.ToolbarExtraButtons
				}
			);
			this._FloatingToolbarView._ToolbarView = this;
			this._FloatingToolbarView._FlowView = this._FlowView;
			this._FloatingToolbarView.render();
		}

		this._FloatingToolbarView.show();
	}

	// ── Node Placement Helpers ────────────────────────────────────────────

	/**
	 * Add a node at the center of the visible viewport.
	 * @param {string} pNodeType - The node type hash
	 */
	_addNodeAtCenter(pNodeType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;

		// Calculate the center of the visible SVG area
		let tmpSVGContainer = this._FlowView._SVGElement;
		let tmpWidth = tmpSVGContainer ? tmpSVGContainer.clientWidth : 600;
		let tmpHeight = tmpSVGContainer ? tmpSVGContainer.clientHeight : 400;

		let tmpCenterX = (-tmpVS.PanX + tmpWidth / 2) / tmpVS.Zoom;
		let tmpCenterY = (-tmpVS.PanY + tmpHeight / 2) / tmpVS.Zoom;

		// Slight offset to avoid stacking
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpCenterX += (tmpNodeCount % 5) * 30;
		tmpCenterY += (tmpNodeCount % 5) * 30;

		this._FlowView.addNode(pNodeType, tmpCenterX, tmpCenterY);
	}

	/**
	 * Add a node from a palette card click.
	 * @param {string} pCardType - The card type hash
	 */
	_addCardFromPalette(pCardType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;
		let tmpX = (-tmpVS.PanX + 200) / tmpVS.Zoom;
		let tmpY = (-tmpVS.PanY + 200) / tmpVS.Zoom;

		// Offset to avoid overlap
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpX += (tmpNodeCount % 5) * 40;
		tmpY += (tmpNodeCount % 5) * 40;

		this._FlowView.addNode(pCardType, tmpX, tmpY);
	}

	// ── Action Handler ────────────────────────────────────────────────────

	/**
	 * Handle a toolbar action
	 * @param {string} pAction
	 */
	/**
	 * Handle a click on a host-supplied (ToolbarExtraButtons) button. Routes to
	 * the FlowView's onToolbarButton hook with the button hash and the clicked
	 * element (so the host can anchor a popover next to it).
	 *
	 * @param {string} pHash - The button's Hash
	 * @param {HTMLElement} pElement - The clicked button element
	 */
	_handleExtraAction(pHash, pElement)
	{
		if (!this._FlowView) return;
		if (typeof this._FlowView.options.onToolbarButton === 'function')
		{
			this._FlowView.options.onToolbarButton(pHash, pElement);
		}
	}

	_handleToolbarAction(pAction)
	{
		if (!this._FlowView) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		switch (pAction)
		{
			case 'add-node':
				this._openPopup('add-node');
				break;

			case 'delete-selected':
				this._FlowView.deleteSelected();
				break;

			case 'zoom-in':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom + this._FlowView.options.ZoomStep);
				break;

			case 'zoom-out':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom - this._FlowView.options.ZoomStep);
				break;

			case 'zoom-fit':
				this._FlowView.zoomToFit();
				break;

			case 'auto-layout':
				// Legacy alias kept for backward compatibility with any
				// caller still firing 'auto-layout'. The toolbar's "Auto"
				// button now uses 'apply-current-layout' (below).
				this._FlowView.autoLayout();
				break;

			case 'apply-current-layout':
				// Respects whichever algorithm is configured in the
				// Algorithm popup. Falls back to Layered when the
				// configured value is 'Custom' or unset (autoLayout's
				// existing behavior — "do something useful").
				this._FlowView.autoLayout();
				break;

			case 'cards-popup':
				this._openPopup('cards');
				break;

			case 'layout-popup':
				this._openPopup('layout');
				break;

			case 'layout-algorithm-popup':
				this._openPopup('layout-algorithm');
				break;

			case 'apply-layout':
				this._FlowView.applyCurrentLayout();
				break;

			case 'settings-popup':
				this._openPopup('settings');
				break;

			case 'toggle-floating':
				if (this._ToolbarMode === 'floating')
				{
					this._setToolbarMode('docked');
				}
				else
				{
					this._setToolbarMode('floating');
				}
				break;

			case 'collapse-toolbar':
				this._setToolbarMode('collapsed');
				break;

			case 'expand-toolbar':
				this._setToolbarMode('docked');
				break;

			case 'fullscreen':
				{
					let tmpIsFullscreen = this._FlowView.toggleFullscreen();
					let tmpIconProvider = this._FlowView._IconProvider;
					let tmpIconElements = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
					if (tmpIconElements.length > 0 && tmpIconProvider)
					{
						tmpIconElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(
							tmpIsFullscreen ? 'exit-fullscreen' : 'fullscreen', 14);
					}
					let tmpFullscreenBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpFullscreenBtn.length > 0)
					{
						tmpFullscreenBtn[0].setAttribute('title', tmpIsFullscreen ? 'Exit Fullscreen' : 'Toggle Fullscreen');
					}
				}
				break;

			default:
				this.log.warn(`PictViewFlowToolbar: unknown action '${pAction}'`);
				break;
		}
	}
}

module.exports = PictViewFlowToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":365}],246:[function(require,module,exports){
const libPictView = require('pict-view');

const libPictServiceFlowInteractionManager = require('../services/PictService-Flow-InteractionManager.js');
const libPictServiceFlowConnectionRenderer = require('../services/PictService-Flow-ConnectionRenderer.js');
const libPictServiceFlowTether = require('../services/PictService-Flow-Tether.js');
const libPictServiceFlowLayout = require('../services/PictService-Flow-Layout.js');
const libPictServiceFlowPathGenerator = require('../services/PictService-Flow-PathGenerator.js');
const libPictServiceFlowViewportManager = require('../services/PictService-Flow-ViewportManager.js');
const libPictServiceFlowSelectionManager = require('../services/PictService-Flow-SelectionManager.js');
const libPictServiceFlowPanelManager = require('../services/PictService-Flow-PanelManager.js');
const libPictServiceFlowDataManager = require('../services/PictService-Flow-DataManager.js');
const libPictServiceFlowConnectionHandleManager = require('../services/PictService-Flow-ConnectionHandleManager.js');
const libPictServiceFlowRenderManager = require('../services/PictService-Flow-RenderManager.js');
const libPictServiceFlowPortRenderer = require('../services/PictService-Flow-PortRenderer.js');
const libPictServiceFlowCursorManager = require('../services/PictService-Flow-CursorManager.js');

const libPictProviderFlowNodeTypes = require('../providers/PictProvider-Flow-NodeTypes.js');
const libPictProviderFlowEventHandler = require('../providers/PictProvider-Flow-EventHandler.js');
const libPictProviderFlowLayouts = require('../providers/PictProvider-Flow-Layouts.js');
const libPictProviderFlowSVGHelpers = require('../providers/PictProvider-Flow-SVGHelpers.js');
const libPictProviderFlowGeometry = require('../providers/PictProvider-Flow-Geometry.js');
const libPictProviderFlowPanelChrome = require('../providers/PictProvider-Flow-PanelChrome.js');
const libPictProviderFlowCSS = require('../providers/PictProvider-Flow-CSS.js');
const libPictProviderFlowIcons = require('../providers/PictProvider-Flow-Icons.js');
const libPictProviderFlowConnectorShapes = require('../providers/PictProvider-Flow-ConnectorShapes.js');
const libPictProviderFlowTheme = require('../providers/PictProvider-Flow-Theme.js');
const libPictProviderFlowRenderer = require('../providers/PictProvider-Flow-Renderer.js');
const libPictProviderFlowStylePresets = require('../providers/PictProvider-Flow-StylePresets.js');
const libPictProviderFlowNoise = require('../providers/PictProvider-Flow-Noise.js');
const libPictProviderFlowBackground = require('../providers/PictProvider-Flow-Background.js');

const libPictViewFlowNode = require('./PictView-Flow-Node.js');
const libPictViewFlowToolbar = require('./PictView-Flow-Toolbar.js');
const libPictViewFlowFloatingToolbar = require('./PictView-Flow-FloatingToolbar.js');
const libPictViewFlowPropertiesPanel = require('./PictView-Flow-PropertiesPanel.js');

const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');
const libPanelTemplate = require('../panels/FlowCardPropertiesPanel-Template.js');
const libPanelMarkdown = require('../panels/FlowCardPropertiesPanel-Markdown.js');
const libPanelForm = require('../panels/FlowCardPropertiesPanel-Form.js');
const libPanelView = require('../panels/FlowCardPropertiesPanel-View.js');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Pict-Flow',

	DefaultRenderable: 'Flow-Container',
	DefaultDestinationAddress: '#Flow-Container',

	AutoRender: false,

	FlowDataAddress: false,

	TargetElementAddress: '#Flow-SVG-Container',

	// Config profile: expands into a coherent bundle of the options below before
	// your explicit options apply. null/'graph' = the historical behavior; also
	// 'whiteboard', 'moodboard', 'presentation', 'erd'.
	Profile: null,

	EnableToolbar: true,
	EnableAddNode: true,
	EnableCardPalette: true,
	IncludeDefaultNodeTypes: true,
	EnablePanning: true,
	EnableZooming: true,
	EnableNodeDragging: true,
	EnableConnectionCreation: true,
	// When on, a connection can be drawn between ANY two ports (any port can start a drag, any port can
	// receive it), rather than only output -> input. Off by default so directed graphs (workflows) keep
	// their source/target semantics; free-form canvases (a moodboard, whose links are undirected) turn it
	// on so a card's ports connect in any direction.
	EnableUndirectedConnections: false,
	// When on, the selected node shows a bottom-right grip that resizes it by drag. Off by default
	// so existing diagrams are unaffected; free-form canvases (moodboards) turn it on.
	EnableNodeResizing: false,
	// When on, the selected node shows a rotate grip on an arm above it; drag it to set the node's
	// Rotation (degrees), Shift to snap to 15. Off by default; free-form canvases turn it on. The
	// properties panel can still set Rotation directly, so both ways work.
	EnableNodeRotation: false,
	EnableGridSnap: false,
	GridSnapSize: 20,
	// When on, several nodes can be selected at once: shift-click a node to toggle it, drag on the
	// empty canvas to marquee-select (shift+drag pans), and dragging any selected node moves them all.
	// Off by default so single-selection diagrams are unaffected; free-form canvases turn it on.
	EnableMultiSelect: false,
	// When on, dragging a single node shows alignment guide lines (and snaps) as its edges or centers
	// line up with other nodes. Off by default; free-form canvases turn it on.
	EnableAlignmentGuides: false,
	EnableLayoutMenu: true,

	// Read-only / presentation mode. When true, editing interactions are inert
	// (no drag, resize, connect, delete, panel edit); panning, zoom, selection,
	// and node activation still work, and an onNodeActivate event fires on a node
	// click so a host can show a read-only inspector. Toggle at runtime with
	// setReadOnly(). The container also gets a 'pict-flow-readonly' class so chrome
	// (ports, delete affordance, resize grips) can be hidden via CSS.
	ReadOnly: false,

	// Host-supplied toolbar buttons. Each entry is { Hash, Icon, Label?, Tooltip?, Active? } where Icon
	// is a flow icon-provider key (edit, check, background, ...). They render in BOTH the docked and the
	// floating toolbar (so they survive every toolbar mode) and, on click, fire onToolbarButton below.
	// Empty by default, so existing consumers are unaffected.
	ToolbarExtraButtons: [],
	// Fired when a ToolbarExtraButtons button is clicked: onToolbarButton(pHash, pElement). The element
	// lets the host anchor a popover next to the button. Off (false) by default.
	onToolbarButton: false,

	MinZoom: 0.1,
	MaxZoom: 5.0,
	ZoomStep: 0.1,

	// Mouse-wheel behavior. 'zoom' (default) keeps the historical wheel-zoom; set
	// 'pan' so the wheel scrolls the canvas (ctrl/cmd+wheel still zooms), or
	// 'none' to ignore the wheel. WheelZoomRequiresModifier makes a plain wheel
	// pan and only ctrl/cmd+wheel zoom while in 'zoom' mode (tames the
	// "scrolling zooms too fast" feel). Sensitivities scale the per-tick amount.
	WheelMode: 'zoom',
	WheelZoomRequiresModifier: false,
	WheelZoomSensitivity: 1,
	WheelPanSensitivity: 1,

	// Canvas background. false (default) keeps the built-in grid from the
	// container template. Set an object to control it natively:
	//   { Style: 'grid'|'dots'|'solid'|'image'|'none', Color?, Image?, GridSize?, DotSize? }
	// This replaces hand-painting the SVG from a consumer.
	Background: false,

	// Content frame: a dashed "page" rectangle in content space marking the
	// intended bounds (origin + width + preferred end). false (default) draws
	// nothing. Set { Enabled?, X, Y, Width, Height, FitOnLoad? }; fitToFrame()
	// fits it to the viewport (handy for read-only / presentation). Drag-to-resize
	// handles are a later addition.
	Frame: false,

	// Presentation fit. 'contain' (default) keeps the legacy fitToFrame/FitOnLoad
	// behavior. 'width' fits the frame's WIDTH to the container (anchored top-left
	// + FitTopMargin) and keeps it fit as the container resizes — the jumbotron /
	// background / fullscreen presentation. Content outside the frame bleeds.
	FitMode: 'contain',
	FitTopMargin: 0,

	// When true (and not read-only), the content frame gets drag handles: four edge
	// handles to set top/width/height and a move handle to reposition the view-area box.
	EnableFrameEditing: false,
	MinimumFrameSize: 40,

	DefaultNodeType: 'default',
	DefaultNodeWidth: 180,
	DefaultNodeHeight: 80,
	MinimumNodeWidth: 48,
	MinimumNodeHeight: 32,

	// Properties panel for connections (edges). Connections are not typed, so one config serves
	// them all: { PanelType, DefaultWidth, DefaultHeight, Title, Configuration }. When set, a
	// double-click on a connection opens this panel; when false, double-click adds a bezier handle.
	ConnectionPropertiesPanel: false,

	// Layout-algorithm subsystem defaults
	DefaultLayoutAlgorithm: 'Custom',
	DefaultLayoutParameters: {},
	DefaultLayoutAutoApply: false,

	// Saved layouts (named position snapshots). LayoutStorage lets a host wire a
	// server / IndexedDB backend by config instead of overriding the layout
	// provider's methods: { read(cb), write(layouts, cb), delete(cb) } with
	// Node-style cb(err, result). false (default) uses localStorage. When
	// ApplyDefaultLayoutOnLoad is on, the layout marked default is applied once
	// the graph first renders.
	LayoutStorage: false,
	ApplyDefaultLayoutOnLoad: false,

	// Edge-theme subsystem defaults — null = inherit from active layout's
	// `DefaultEdgeTheme` field, with hard fallback to 'Bezier'.
	DefaultEdgeTheme: null,
	DefaultEdgeThemeParameters: {},

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-PanelChrome-Template',
			Template: /*html*/`<div class="pict-flow-panel" xmlns="http://www.w3.org/1999/xhtml"><div class="pict-flow-panel-titlebar" data-element-type="panel-titlebar" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-title-text">{~D:Record.Title~}</span><span class="pict-flow-panel-close-btn" data-element-type="panel-close" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-close-icon"></span></span></div><div class="pict-flow-panel-content" data-panel-hash="{~D:Record.Hash~}" onpointerdown="event.stopPropagation()" onwheel="event.stopPropagation()"><div class="pict-flow-panel-tab-pane active" data-tab="properties" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tab-pane" data-tab="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div><div class="pict-flow-panel-tab-pane" data-tab="appearance" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div></div><div class="pict-flow-panel-resize-handle" data-element-type="panel-resize" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tabbar" data-panel-hash="{~D:Record.Hash~}" onpointerdown="event.stopPropagation()" onwheel="event.stopPropagation()"><div class="pict-flow-panel-tab active" data-tab-target="properties" data-panel-hash="{~D:Record.Hash~}" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Properties</div><div class="pict-flow-panel-tab" data-tab-target="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Help</div><div class="pict-flow-panel-tab" data-tab-target="appearance" data-panel-hash="{~D:Record.Hash~}" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Appearance</div></div></div>`
		},
		{
			Hash: 'Flow-Container-Template',
			// Inline pointer/wheel/contextmenu handlers route to the
			// InteractionManager via the FlowView. Keyboard events stay
			// document-level (no element-level inline equivalent).
			Template: /*html*/`
<div class="pict-flow-container" id="Flow-Wrapper-{~D:Record.ViewIdentifier~}">
	<div id="Flow-Toolbar-{~D:Record.ViewIdentifier~}"></div>
	<div id="Flow-FloatingToolbar-Container-{~D:Record.ViewIdentifier~}" style="display:none;position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:100;"></div>
	<div class="pict-flow-svg-container" id="Flow-SVG-Container-{~D:Record.ViewIdentifier~}">
		<svg class="pict-flow-svg"
			id="Flow-SVG-{~D:Record.ViewIdentifier~}"
			xmlns="http://www.w3.org/2000/svg"
			onpointerdown="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerDown(event)"
			onpointermove="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerMove(event)"
			onpointerup="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerUp(event)"
			onpointerleave="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerUp(event)"
			onwheel="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGWheel(event)"
			oncontextmenu="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGContextMenu(event)">
			<defs>
				<pattern id="flow-grid-{~D:Record.ViewIdentifier~}"
					width="20" height="20" patternUnits="userSpaceOnUse">
					<line x1="20" y1="0" x2="20" y2="20" class="pict-flow-grid-pattern" />
					<line x1="0" y1="20" x2="20" y2="20" class="pict-flow-grid-pattern" />
				</pattern>
			</defs>
			<rect width="10000" height="10000" x="-5000" y="-5000"
				fill="url(#flow-grid-{~D:Record.ViewIdentifier~})"
				class="pict-flow-grid-background" />
			<g class="pict-flow-viewport" id="Flow-Viewport-{~D:Record.ViewIdentifier~}">
				<g class="pict-flow-connections-layer" id="Flow-Connections-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-nodes-layer" id="Flow-Nodes-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-endpoints-layer" id="Flow-Endpoints-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-port-hints-layer" id="Flow-PortHints-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-tethers-layer" id="Flow-Tethers-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-panels-layer" id="Flow-Panels-{~D:Record.ViewIdentifier~}"></g>
			</g>
		</svg>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Container',
			TemplateHash: 'Flow-Container-Template',
			DestinationAddress: '#Flow-Container',
			RenderMethod: 'replace'
		}
	]
};

// Config profiles. Each is a partial option bundle that expands under the
// defaults and beneath the host's explicit options, so a single Profile knob
// gives a coherent setup that the host can still override field by field.
const _PROFILES =
{
	// Directed graph editor (the historical default). Empty so the defaults stand.
	graph: {},

	// Free-form whiteboard: undirected links, resize, multi-select + alignment
	// guides, wheel pans (ctrl/cmd zooms), dotted background, no layout menu.
	whiteboard:
	{
		EnableUndirectedConnections: true,
		EnableNodeResizing: true,
		EnableNodeRotation: true,
		EnableMultiSelect: true,
		EnableAlignmentGuides: true,
		EnableLayoutMenu: false,
		WheelMode: 'pan',
		WheelZoomRequiresModifier: true,
		Background: { Style: 'dots' }
	},

	// Moodboard: free-form content cards, undirected links, no default node types
	// or add-node button, edge-to-edge cards (no title bar), wheel pans.
	moodboard:
	{
		EnableUndirectedConnections: true,
		EnableNodeResizing: true,
		EnableNodeRotation: true,
		EnableAlignmentGuides: true,
		EnableAddNode: false,
		EnableLayoutMenu: false,
		IncludeDefaultNodeTypes: false,
		NodeTitleBarHeight: 0,
		WheelMode: 'pan',
		WheelZoomRequiresModifier: true,
		// Flat, light canvas (no grid) by default; a host can recolor it via setBackground.
		Background: { Style: 'solid', Color: '#f4f6f9' }
	},

	// Read-only presentation surface: no editing, no toolbar; plain wheel pans,
	// ctrl/cmd wheel zooms.
	presentation:
	{
		ReadOnly: true,
		EnableToolbar: false,
		WheelMode: 'pan',
		WheelZoomRequiresModifier: true
	},

	// Entity-relationship diagrams (fleshed out in a later phase). Orthogonal
	// edges read best for ERDs.
	erd:
	{
		DefaultEdgeTheme: 'Orthogonal'
	}
};

class PictViewFlow extends libPictView
{
	/**
	 * Merge a Profile's option bundle between the defaults and the host's
	 * explicit options: defaults < profile < pOptions. Pure (no side effects),
	 * so it is unit testable without constructing the view.
	 * @param {Object} pOptions - the host-supplied options (may name a Profile)
	 * @returns {Object} the fully merged option set
	 */
	static mergeProfileOptions(pOptions)
	{
		let tmpProfileName = (pOptions && pOptions.Profile) ? pOptions.Profile : (_DefaultConfiguration.Profile || 'graph');
		let tmpProfile = _PROFILES[tmpProfileName] || {};
		return Object.assign(
			{},
			JSON.parse(JSON.stringify(_DefaultConfiguration)),
			JSON.parse(JSON.stringify(tmpProfile)),
			pOptions || {});
	}

	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = PictViewFlow.mergeProfileOptions(pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictSectionFlow';

		// ---- Declarative service registry ----
		// Each entry defines a service to register, instantiate, and guard.
		// Optional flags:
		//   NoFlowView  — instantiate without { FlowView: this }
		//   PostInit    — method name to call on the instance after creation
		//   RegisterOnly — only register the type; do not bulk-instantiate
		this._ServiceRegistry =
		[
			// Providers (stateless or config-only — no FlowView needed)
			{ ServiceType: 'PictProviderFlowSVGHelpers',   Library: libPictProviderFlowSVGHelpers,   Property: '_SVGHelperProvider',    NoFlowView: true },
			{ ServiceType: 'PictProviderFlowGeometry',      Library: libPictProviderFlowGeometry,      Property: '_GeometryProvider',     NoFlowView: true },
			{ ServiceType: 'PictProviderFlowNoise',         Library: libPictProviderFlowNoise,         Property: '_NoiseProvider',        NoFlowView: true },

			// Providers (need FlowView)
			//   Renderer + StylePresets must be created before the legacy Theme
			//   shim (which delegates to them) and before CSS PostInit so that
			//   registerCSS() sees an initialized renderer.
			{ ServiceType: 'PictProviderFlowRenderer',      Library: libPictProviderFlowRenderer,      Property: '_RendererProvider' },
			{ ServiceType: 'PictProviderFlowStylePresets',  Library: libPictProviderFlowStylePresets,  Property: '_StylePresetsProvider' },
			{ ServiceType: 'PictProviderFlowTheme',         Library: libPictProviderFlowTheme,         Property: '_ThemeProvider' },
			{ ServiceType: 'PictProviderFlowCSS',           Library: libPictProviderFlowCSS,           Property: '_CSSProvider',          PostInit: 'registerCSS' },
			{ ServiceType: 'PictProviderFlowIcons',         Library: libPictProviderFlowIcons,         Property: '_IconProvider',         PostInit: 'registerIconTemplates' },
			{ ServiceType: 'PictProviderFlowConnectorShapes', Library: libPictProviderFlowConnectorShapes, Property: '_ConnectorShapesProvider' },
			{ ServiceType: 'PictProviderFlowPanelChrome',   Library: libPictProviderFlowPanelChrome,   Property: '_PanelChromeProvider' },
			{ ServiceType: 'PictProviderFlowNodeTypes',     Library: libPictProviderFlowNodeTypes,     Property: '_NodeTypeProvider',   ExtraOptions: () => ({ AdditionalNodeTypes: this.options.NodeTypes, IncludeDefaultNodeTypes: this.options.IncludeDefaultNodeTypes }) },
			{ ServiceType: 'PictProviderFlowEventHandler',  Library: libPictProviderFlowEventHandler,  Property: '_EventHandlerProvider' },
			{ ServiceType: 'PictProviderFlowLayouts',       Library: libPictProviderFlowLayouts,       Property: '_LayoutProvider',       PostInit: 'loadPersistedLayouts' },
			{ ServiceType: 'PictProviderFlowBackground',    Library: libPictProviderFlowBackground,    Property: '_BackgroundProvider' },

			// Services
			{ ServiceType: 'PictServiceFlowPathGenerator',           Library: libPictServiceFlowPathGenerator,           Property: '_PathGenerator' },
			{ ServiceType: 'PictServiceFlowDataManager',             Library: libPictServiceFlowDataManager,             Property: '_DataManager' },
			{ ServiceType: 'PictServiceFlowConnectionHandleManager', Library: libPictServiceFlowConnectionHandleManager, Property: '_ConnectionHandleManager' },
			{ ServiceType: 'PictServiceFlowRenderManager',           Library: libPictServiceFlowRenderManager,           Property: '_RenderManager' },
			{ ServiceType: 'PictServiceFlowPortRenderer',            Library: libPictServiceFlowPortRenderer,            Property: '_PortRenderer' },
			{ ServiceType: 'PictServiceFlowInteractionManager',      Library: libPictServiceFlowInteractionManager,      Property: '_InteractionManager' },
			{ ServiceType: 'PictServiceFlowCursorManager',           Library: libPictServiceFlowCursorManager,           Property: '_CursorManager' },
			{ ServiceType: 'PictServiceFlowConnectionRenderer',      Library: libPictServiceFlowConnectionRenderer,      Property: '_ConnectionRenderer' },
			{ ServiceType: 'PictServiceFlowTether',                  Library: libPictServiceFlowTether,                  Property: '_TetherService' },
			{ ServiceType: 'PictServiceFlowLayout',                  Library: libPictServiceFlowLayout,                  Property: '_LayoutService' },
			{ ServiceType: 'PictServiceFlowViewportManager',         Library: libPictServiceFlowViewportManager,         Property: '_ViewportManager' },
			{ ServiceType: 'PictServiceFlowSelectionManager',        Library: libPictServiceFlowSelectionManager,        Property: '_SelectionManager' },
			{ ServiceType: 'PictServiceFlowPanelManager',            Library: libPictServiceFlowPanelManager,            Property: '_PanelManager' },

			// View types (register only — instantiated with custom config in onAfterInitialRender)
			{ ServiceType: 'PictViewFlowNode',             Library: libPictViewFlowNode,             RegisterOnly: true },
			{ ServiceType: 'PictViewFlowToolbar',          Library: libPictViewFlowToolbar,          RegisterOnly: true },
			{ ServiceType: 'PictViewFlowFloatingToolbar',  Library: libPictViewFlowFloatingToolbar,  RegisterOnly: true },
			{ ServiceType: 'PictViewFlowPropertiesPanel',  Library: libPictViewFlowPropertiesPanel,  RegisterOnly: true },

			// Panel types (register only)
			{ ServiceType: 'PictFlowCardPropertiesPanel',           Library: libPictFlowCardPropertiesPanel,  RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Template',  Library: libPanelTemplate,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Markdown',  Library: libPanelMarkdown,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Form',      Library: libPanelForm,                   RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-View',      Library: libPanelView,                   RegisterOnly: true }
		];

		this._registerServiceTypes();

		// Internal state
		this._FlowData = {
			Nodes: [],
			Connections: [],
			OpenPanels: [],
			SavedLayouts: [],
			ViewState: {
				PanX: 0,
				PanY: 0,
				Zoom: 1,
				SelectedNodeHash: null,
				// The full selection set (multi-select). SelectedNodeHash stays the primary / most
				// recently touched member for backward compatibility; single-select keeps it == [hash].
				SelectedNodeHashes: [],
				SelectedConnectionHash: null,
				SelectedTetherHash: null
			},
			LayoutAlgorithm: this.options.DefaultLayoutAlgorithm || 'Custom',
			LayoutParameters: JSON.parse(JSON.stringify(this.options.DefaultLayoutParameters || {})),
			LayoutAutoApply: !!this.options.DefaultLayoutAutoApply,
			EdgeTheme: this.options.DefaultEdgeTheme || null,
			EdgeThemeParameters: JSON.parse(JSON.stringify(this.options.DefaultEdgeThemeParameters || {}))
		};

		// Re-entrancy guard for the auto-apply event handler
		this._AutoApplyInProgress = false;
		this._AutoApplyHandlerHashes = [];

		this._SVGElement = null;
		this._ViewportElement = null;
		this._NodesLayer = null;
		this._ConnectionsLayer = null;
		this._EndpointsLayer = null;
		this._PortHintsLayer = null;
		this._TethersLayer = null;
		this._PanelsLayer = null;

		this._DataManager = null;
		this._ConnectionHandleManager = null;
		this._RenderManager = null;
		this._PortRenderer = null;

		this._InteractionManager = null;
		this._CursorManager = null;
		this._ConnectionRenderer = null;
		this._TetherService = null;
		this._LayoutService = null;
		this._PathGenerator = null;
		this._ViewportManager = null;
		this._SelectionManager = null;
		this._PanelManager = null;
		this._CSSProvider = null;
		this._IconProvider = null;
		this._ConnectorShapesProvider = null;
		this._ThemeProvider = null;
		this._RendererProvider = null;
		this._StylePresetsProvider = null;
		this._NoiseProvider = null;
		this._SVGHelperProvider = null;
		this._GeometryProvider = null;
		this._PanelChromeProvider = null;
		this._NodeTypeProvider = null;
		this._LayoutProvider = null;
		this._BackgroundProvider = null;
		this._EventHandlerProvider = null;
		this._NodeView = null;
		this._ToolbarView = null;
		this._PropertiesPanelView = null;

		// Registry of renderable renderers keyed by RenderableType. The default
		// 'card' renderer (the node view) is registered once it exists; consumers
		// register additional renderers (shape, sticky, text, image, category,
		// connector) to draw renderables that are not cards.
		this._RenderableRenderers = {};

		// Read-only / presentation flag (runtime; defaults to the option).
		this._ReadOnly = !!this.options.ReadOnly;

		// In read-only, canvas pan + wheel-zoom are OFF by default (the wheel scrolls the page and the
		// canvas reads as static content). A host flips it on with a "hand" toggle via
		// setReadOnlyNavigation. No effect in edit mode.
		this._ReadOnlyNavigation = false;

		this.initialRenderComplete = false;
	}

	_registerServiceTypes()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (!this.fable.servicesMap.hasOwnProperty(tmpEntry.ServiceType))
			{
				this.fable.addServiceType(tmpEntry.ServiceType, tmpEntry.Library);
			}
		}
	}

	/**
	 * Register a renderable renderer under a key. The default 'card' renderer is
	 * the node view; consumers register additional renderers (shape, sticky,
	 * text, image, category, connector) to draw non-card renderables. A renderer
	 * must expose renderNode(node, layerElement, isSelected, typeConfig).
	 * @param {string} pKey
	 * @param {Object} pRenderer
	 * @returns {boolean}
	 */
	registerRenderableRenderer(pKey, pRenderer)
	{
		if (!pKey || !pRenderer)
		{
			return false;
		}
		this._RenderableRenderers[pKey] = pRenderer;
		return true;
	}

	/**
	 * Resolve the renderable renderer for a node. A node type may name its
	 * renderer via the RenderableType field (default 'card'); unknown keys fall
	 * back to the card renderer so existing diagrams are unaffected.
	 * @param {Object} pNode
	 * @param {Object} pNodeTypeConfig
	 * @returns {Object} a renderer exposing renderNode(...)
	 */
	resolveRenderableRenderer(pNode, pNodeTypeConfig)
	{
		// A node may name its renderer directly via pNode.RenderableType (wins), else
		// the node type config's RenderableType, else the default 'card'. The node-level
		// override lets a free-form canvas mint shape/sticky/text renderables without
		// registering a node type for each. Unknown keys fall back to card so existing
		// diagrams are unaffected.
		let tmpKey = 'card';
		if (pNode && typeof pNode.RenderableType === 'string' && pNode.RenderableType)
		{
			tmpKey = pNode.RenderableType;
		}
		else if (pNodeTypeConfig && pNodeTypeConfig.RenderableType)
		{
			tmpKey = pNodeTypeConfig.RenderableType;
		}
		return this._RenderableRenderers[tmpKey] || this._RenderableRenderers['card'] || this._NodeView;
	}

	/**
	 * Apply the configured canvas background to the live SVG. No-op when no
	 * Background is configured (the template grid stands). Safe to call on every
	 * render; idempotent.
	 */
	_applyBackground()
	{
		if (this._BackgroundProvider)
		{
			return this._BackgroundProvider.apply(this);
		}
		return false;
	}

	/**
	 * Set the canvas background and repaint it. Pass an object
	 * { Style, Color?, Image?, GridSize?, DotSize? } or false to clear it back to
	 * the template grid. Stored on ViewState so it travels with the flow data.
	 * @param {Object|false} pBackground
	 */
	setBackground(pBackground)
	{
		this._FlowData.ViewState.Background = pBackground || null;
		return this._applyBackground();
	}

	/**
	 * Whether the flow is in read-only / presentation mode.
	 * @returns {boolean}
	 */
	isReadOnly()
	{
		return !!this._ReadOnly;
	}

	/**
	 * Toggle read-only / presentation mode at runtime. Editing interactions go
	 * inert; the container gets the 'pict-flow-readonly' class so chrome can be
	 * hidden via CSS. Repaints so port/grip visibility updates.
	 * @param {boolean} pReadOnly
	 * @returns {boolean} the new read-only state
	 */
	setReadOnly(pReadOnly)
	{
		this._ReadOnly = !!pReadOnly;
		// Navigation is a read-only concept; leaving read-only clears it.
		if (!this._ReadOnly) { this._ReadOnlyNavigation = false; }
		this._applyReadOnlyClass();
		if (this._CursorManager) { this._CursorManager.update(); }
		if (this.initialRenderComplete)
		{
			this.renderFlow();
		}
		return this._ReadOnly;
	}

	/**
	 * Whether read-only canvas navigation (pan + wheel-zoom) is enabled. When off
	 * (the default in read-only), the wheel scrolls the page and the canvas does
	 * not pan, so it reads as static content.
	 * @returns {boolean}
	 */
	isReadOnlyNavigation()
	{
		return !!this._ReadOnlyNavigation;
	}

	/**
	 * Turn read-only canvas navigation (pan + wheel-zoom) on or off. This is the
	 * "hand" toggle for a presentation surface; it has no effect in edit mode.
	 * @param {boolean} pOn
	 * @returns {boolean} the new navigation state
	 */
	setReadOnlyNavigation(pOn)
	{
		this._ReadOnlyNavigation = !!pOn;
		this._applyReadOnlyClass();
		if (this._CursorManager) { this._CursorManager.update(); }
		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onReadOnlyNavigationChanged', this._ReadOnlyNavigation);
		}
		return this._ReadOnlyNavigation;
	}

	/**
	 * Reflect the read-only flag as a class on the flow container so CSS can hide
	 * editing chrome (ports, delete affordance, resize grips). Internal.
	 */
	_applyReadOnlyClass()
	{
		let tmpWrapper = this.pict.ContentAssignment.getElement(`#Flow-Wrapper-${this.options.ViewIdentifier}`);
		if (tmpWrapper && tmpWrapper.length > 0 && tmpWrapper[0].classList)
		{
			if (this._ReadOnly)
			{
				tmpWrapper[0].classList.add('pict-flow-readonly');
			}
			else
			{
				tmpWrapper[0].classList.remove('pict-flow-readonly');
			}
			// 'navigating' = read-only with pan/zoom enabled; drives the grab cursor.
			if (this._ReadOnly && this._ReadOnlyNavigation)
			{
				tmpWrapper[0].classList.add('pict-flow-navigating');
			}
			else
			{
				tmpWrapper[0].classList.remove('pict-flow-navigating');
			}
		}
	}

	/**
	 * Resolve the effective content frame: ViewState wins, then the option.
	 * @returns {Object|null}
	 */
	_resolveFrame()
	{
		let tmpFrame = (this._FlowData && this._FlowData.ViewState && this._FlowData.ViewState.Frame)
			? this._FlowData.ViewState.Frame
			: this.options.Frame;
		return (tmpFrame && typeof tmpFrame === 'object') ? tmpFrame : null;
	}

	/**
	 * Set (or clear, with false) the content frame and repaint it. Stored on
	 * ViewState so it travels with the flow data.
	 * @param {Object|false} pFrame
	 */
	setFrame(pFrame)
	{
		this._FlowData.ViewState.Frame = (pFrame && typeof pFrame === 'object') ? pFrame : null;
		this._applyFrame();
		return this._FlowData.ViewState.Frame;
	}

	/**
	 * Read the effective content frame (ViewState wins, then the option), or null
	 * when none is set. The public read counterpart to setFrame.
	 * @returns {Object|null}
	 */
	getFrame()
	{
		return this._resolveFrame();
	}

	/**
	 * Toggle the content frame's drag handles at runtime (e.g. an editor turning on
	 * "set the view area"). Repaints the frame so the handles appear / disappear.
	 * @param {boolean} pEnabled
	 * @returns {boolean}
	 */
	setFrameEditing(pEnabled)
	{
		this.options.EnableFrameEditing = !!pEnabled;
		this._applyFrame();
		return this.options.EnableFrameEditing;
	}

	/**
	 * Draw, update, or remove the content-frame rectangle inside the viewport
	 * group (behind the content layers). No-op until the viewport exists.
	 */
	_applyFrame()
	{
		if (!this._ViewportElement) return;

		let tmpId = `Flow-Frame-${this.options.ViewIdentifier}`;
		let tmpExisting = this._ViewportElement.querySelector(`#${tmpId}`);
		let tmpFrame = this._resolveFrame();

		if (!tmpFrame || tmpFrame.Enabled === false || !tmpFrame.Width || !tmpFrame.Height)
		{
			if (tmpExisting) tmpExisting.remove();
			return;
		}

		let tmpRect = tmpExisting;
		if (!tmpRect)
		{
			tmpRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
			tmpRect.setAttribute('id', tmpId);
			tmpRect.setAttribute('class', 'pict-flow-frame');
			// First child of the viewport group: behind connections and nodes.
			this._ViewportElement.insertBefore(tmpRect, this._ViewportElement.firstChild);
		}
		tmpRect.setAttribute('x', tmpFrame.X || 0);
		tmpRect.setAttribute('y', tmpFrame.Y || 0);
		tmpRect.setAttribute('width', tmpFrame.Width);
		tmpRect.setAttribute('height', tmpFrame.Height);

		this._applyFrameHandles(tmpFrame);
	}

	/**
	 * Draw, refresh, or remove the content frame's drag handles. Shown only when
	 * EnableFrameEditing is on and the view is editable: four edge handles (set top /
	 * width / height) and a move handle at the top-left. Rendered on top of the content
	 * (appended last in the viewport) so they are grabbable; their data-element-type routes
	 * pointer-down to the InteractionManager's frame edit paths.
	 * @param {Object} pFrame - the resolved frame ({X,Y,Width,Height})
	 */
	_applyFrameHandles(pFrame)
	{
		if (!this._ViewportElement) return;

		let tmpId = `Flow-FrameHandles-${this.options.ViewIdentifier}`;
		let tmpExisting = this._ViewportElement.querySelector(`#${tmpId}`);
		if (tmpExisting) tmpExisting.remove();

		let tmpEditable = this.options.EnableFrameEditing
			&& !(typeof this.isReadOnly === 'function' && this.isReadOnly())
			&& pFrame && pFrame.Width && pFrame.Height;
		if (!tmpEditable) return;

		let tmpX = pFrame.X || 0;
		let tmpY = pFrame.Y || 0;
		let tmpW = pFrame.Width;
		let tmpH = pFrame.Height;
		let tmpSize = 12;

		let tmpGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
		tmpGroup.setAttribute('id', tmpId);
		tmpGroup.setAttribute('class', 'pict-flow-frame-handles');

		let tmpHandles =
		[
			{ Edge: 'n', Type: 'frame-resize', CX: tmpX + tmpW / 2, CY: tmpY },
			{ Edge: 's', Type: 'frame-resize', CX: tmpX + tmpW / 2, CY: tmpY + tmpH },
			{ Edge: 'e', Type: 'frame-resize', CX: tmpX + tmpW, CY: tmpY + tmpH / 2 },
			{ Edge: 'w', Type: 'frame-resize', CX: tmpX, CY: tmpY + tmpH / 2 },
			{ Edge: 'move', Type: 'frame-move', CX: tmpX, CY: tmpY }
		];
		// Each handle sits in its own anchored, counter-scaled group so it keeps a constant on-screen size
		// however far the board is zoomed out -- a frame is often the widest thing on the canvas, which is
		// precisely when its grips would otherwise be too small to grab. See createZoomInvariantGroup.
		let tmpZoom = this._FlowData.ViewState.Zoom;
		for (let i = 0; i < tmpHandles.length; i++)
		{
			let tmpHandleScaler = this._SVGHelperProvider.createZoomInvariantGroup(tmpHandles[i].CX, tmpHandles[i].CY, tmpZoom);
			let tmpHandle = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
			tmpHandle.setAttribute('class', 'pict-flow-frame-handle pict-flow-frame-handle-' + tmpHandles[i].Edge);
			tmpHandle.setAttribute('x', String(-tmpSize / 2));
			tmpHandle.setAttribute('y', String(-tmpSize / 2));
			tmpHandle.setAttribute('width', String(tmpSize));
			tmpHandle.setAttribute('height', String(tmpSize));
			tmpHandle.setAttribute('rx', '2');
			tmpHandle.setAttribute('data-element-type', tmpHandles[i].Type);
			if (tmpHandles[i].Edge !== 'move')
			{
				tmpHandle.setAttribute('data-frame-edge', tmpHandles[i].Edge);
			}
			tmpHandleScaler.appendChild(tmpHandle);
			tmpGroup.appendChild(tmpHandleScaler);
		}
		this._ViewportElement.appendChild(tmpGroup);
	}

	/**
	 * Fit the viewport to the content frame (zoom + pan so it fills the view).
	 * @returns {boolean}
	 */
	fitToFrame()
	{
		return this._ViewportManager ? this._ViewportManager.fitToFrame(this._resolveFrame()) : false;
	}

	/**
	 * Fit the viewport so the content frame's WIDTH fills the view (anchored top-left + an
	 * optional top margin), letting content bleed past and vertical overflow scroll. This is
	 * the presentation fit a jumbotron / background board uses; fitToFrame() contains instead.
	 * @param {Object} [pOptions] - { TopMargin }
	 * @returns {boolean}
	 */
	fitToWidth(pOptions)
	{
		if (!this._ViewportManager) return false;
		let tmpOptions = pOptions || {};
		if (typeof tmpOptions.TopMargin !== 'number')
		{
			tmpOptions = { TopMargin: this.options.FitTopMargin || 0 };
		}
		return this._ViewportManager.fitToFrameWidth(this._resolveFrame(), tmpOptions);
	}

	/**
	 * When FitMode is 'width', fit the frame to the container width now and keep it fit as the
	 * container resizes (a ResizeObserver, the documented exception to the no-listener rule).
	 * No-op without a frame or when FitMode is not 'width'.
	 */
	_setupFitObserver()
	{
		if (this.options.FitMode !== 'width' || !this._resolveFrame())
		{
			// Not width-fit (e.g. switched back to 'contain'): drop any observer we
			// installed so a stale ResizeObserver does not keep re-fitting the canvas.
			this._teardownFitObserver();
			return;
		}
		this.fitToWidth();
		if ((typeof ResizeObserver !== 'undefined') && this._SVGElement)
		{
			// (Re)observe the CURRENT SVG element. A re-render (e.g. a host toggling presentation mode)
			// can replace the SVG, which would leave a previously-installed observer watching a stale,
			// detached node — so re-point it whenever the observed element has changed.
			if (this._FitObserver && this._FitObservedElement === this._SVGElement) { return; }
			this._teardownFitObserver();
			let tmpSelf = this;
			this._FitObserver = new ResizeObserver(function () { tmpSelf.fitToWidth(); });
			this._FitObserver.observe(this._SVGElement);
			this._FitObservedElement = this._SVGElement;
		}
	}

	/**
	 * Disconnect the width-fit ResizeObserver, if one is installed. Called when a
	 * consumer leaves 'width' FitMode (e.g. a moodboard switching back to canvas)
	 * so the observer stops firing. Safe to call when no observer exists.
	 */
	_teardownFitObserver()
	{
		if (this._FitObserver)
		{
			this._FitObserver.disconnect();
			this._FitObserver = null;
		}
		this._FitObservedElement = null;
	}

	_instantiateServices()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (tmpEntry.RegisterOnly) continue;
			if (this[tmpEntry.Property]) continue;

			let tmpOptions = tmpEntry.NoFlowView ? {} : { FlowView: this };
			if (typeof tmpEntry.ExtraOptions === 'function')
			{
				Object.assign(tmpOptions, tmpEntry.ExtraOptions());
			}

			this[tmpEntry.Property] = this.fable.instantiateServiceProviderWithoutRegistration(tmpEntry.ServiceType, tmpOptions);

			if (tmpEntry.PostInit && typeof this[tmpEntry.Property][tmpEntry.PostInit] === 'function')
			{
				this[tmpEntry.Property][tmpEntry.PostInit]();
			}
		}
	}

	get flowData()
	{
		return this._FlowData;
	}

	get viewState()
	{
		return this._FlowData.ViewState;
	}

	// Backward-compatible getter for InteractionManager direct access
	get _IsFullscreen()
	{
		return this._ViewportManager ? this._ViewportManager._IsFullscreen : false;
	}

	/**
	 * Override render to pass view options as the template record,
	 * so template expressions like {~D:Record.ViewIdentifier~} resolve correctly.
	 */
	render(pRenderableHash, pRenderDestinationAddress)
	{
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		// If no record address is explicitly provided, use this.options as the record
		if (typeof pTemplateRecordAddress === 'function' || typeof pTemplateRecordAddress === 'undefined')
		{
			return super.renderAsync(pRenderableHash, pRenderDestinationAddress, this.options, pRootRenderable, pTemplateRecordAddress || fCallback);
		}
		return super.renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Noise + Renderer + StylePresets + Theme shim must be created before
		// CSS PostInit so registerCSS() sees an initialized renderer + presets.
		this._NoiseProvider          = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowNoise');
		this._RendererProvider       = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowRenderer', { FlowView: this });
		this._StylePresetsProvider   = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowStylePresets', { FlowView: this });
		this._ThemeProvider          = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowTheme',     { FlowView: this });

		// Apply initial style preset / per-axis overrides from options.
		// `Theme` and `StylePreset` are aliases for the same preset-by-hash apply.
		let tmpInitialPreset = this.options.StylePreset || this.options.Theme;
		if (tmpInitialPreset)
		{
			this._StylePresetsProvider.applyPreset(tmpInitialPreset);
		}
		if (this.options.Renderer)
		{
			this._RendererProvider.setRenderer(this.options.Renderer);
			this._StylePresetsProvider.markCustomized();
		}
		if (typeof this.options.NoiseLevel === 'number')
		{
			this._RendererProvider.setNoiseLevel(this.options.NoiseLevel);
		}

		// Instantiate all remaining services (skips Noise/Renderer/StylePresets/Theme
		// since already set above)
		this._instantiateServices();

		// Now that CSSProvider exists, inject the active renderer's GeometryCSS.
		if (this._CSSProvider && typeof this._CSSProvider.registerRendererCSS === 'function')
		{
			this._CSSProvider.registerRendererCSS(this._RendererProvider.getActiveRenderer());
		}

		// Subscribe to the host application's pict-provider-theme so the flow
		// editor's marker arrowhead colors and shape overrides update when the
		// host swaps light/dark or palette themes. CSS variables (--theme-*)
		// re-resolve automatically — only the SVG <marker> defs (which inline
		// fill colors at build time) and ConnectorShapesProvider state need a
		// manual refresh.
		this._subscribeToHostTheme();

		return super.onBeforeInitialize();
	}

	/**
	 * If the host application has registered pict-provider-theme, subscribe
	 * to its onApply hook so we can refresh anything that doesn't pick up
	 * the new --theme-* CSS variables automatically (SVG marker fills,
	 * connector shape overrides). No-op when no host theme provider is
	 * available — the flow editor still functions with its built-in themes.
	 */
	_subscribeToHostTheme()
	{
		let tmpHostTheme = this._resolveHostThemeProvider();
		if (!tmpHostTheme || typeof tmpHostTheme.onApply !== 'function') return;

		this._HostThemeUnsubscribe = tmpHostTheme.onApply(() =>
		{
			if (this._CSSProvider) this._CSSProvider.registerCSS();
			this._reinjectMarkerDefs();
			if (this.initialRenderComplete) this.renderFlow();
		});
	}

	/**
	 * Locate the host's pict-provider-theme instance. It is normally
	 * registered under a stable service hash by the host app; we check
	 * common locations so consumers don't have to wire it manually.
	 * @returns {Object|null}
	 */
	_resolveHostThemeProvider()
	{
		let tmpPict = this.pict;
		if (!tmpPict) return null;
		if (tmpPict.providers)
		{
			let tmpKeys = Object.keys(tmpPict.providers);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpProvider = tmpPict.providers[tmpKeys[i]];
				if (tmpProvider
					&& typeof tmpProvider.onApply === 'function'
					&& typeof tmpProvider.applyTheme === 'function'
					&& typeof tmpProvider.listThemes === 'function')
				{
					return tmpProvider;
				}
			}
		}
		return null;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		let tmpViewIdentifier = this.options.ViewIdentifier;

		// Grab SVG DOM elements
		let tmpSVGElements = this.pict.ContentAssignment.getElement(`#Flow-SVG-${tmpViewIdentifier}`);
		if (tmpSVGElements.length < 1)
		{
			this.log.error(`PictSectionFlow could not find SVG element #Flow-SVG-${tmpViewIdentifier}`);
			return false;
		}
		this._SVGElement = tmpSVGElements[0];

		// Paint a configured background (no-op when none is set; template grid stands).
		this._applyBackground();

		// Reflect read-only mode on the container (drives chrome-hiding CSS).
		this._applyReadOnlyClass();

		// Set the initial canvas cursor from the (idle) state + current mode.
		if (this._CursorManager) { this._CursorManager.update(); }

		let tmpViewportElements = this.pict.ContentAssignment.getElement(`#Flow-Viewport-${tmpViewIdentifier}`);
		if (tmpViewportElements.length > 0)
		{
			this._ViewportElement = tmpViewportElements[0];
		}

		// Draw the content frame, if configured (needs the viewport <g>).
		this._applyFrame();

		let tmpNodesElements = this.pict.ContentAssignment.getElement(`#Flow-Nodes-${tmpViewIdentifier}`);
		if (tmpNodesElements.length > 0)
		{
			this._NodesLayer = tmpNodesElements[0];
		}

		let tmpConnectionsElements = this.pict.ContentAssignment.getElement(`#Flow-Connections-${tmpViewIdentifier}`);
		if (tmpConnectionsElements.length > 0)
		{
			this._ConnectionsLayer = tmpConnectionsElements[0];
		}

		let tmpEndpointsElements = this.pict.ContentAssignment.getElement(`#Flow-Endpoints-${tmpViewIdentifier}`);
		if (tmpEndpointsElements.length > 0)
		{
			this._EndpointsLayer = tmpEndpointsElements[0];
		}

		let tmpPortHintsElements = this.pict.ContentAssignment.getElement(`#Flow-PortHints-${tmpViewIdentifier}`);
		if (tmpPortHintsElements.length > 0)
		{
			this._PortHintsLayer = tmpPortHintsElements[0];
		}

		let tmpTethersElements = this.pict.ContentAssignment.getElement(`#Flow-Tethers-${tmpViewIdentifier}`);
		if (tmpTethersElements.length > 0)
		{
			this._TethersLayer = tmpTethersElements[0];
		}

		let tmpPanelsElements = this.pict.ContentAssignment.getElement(`#Flow-Panels-${tmpViewIdentifier}`);
		if (tmpPanelsElements.length > 0)
		{
			this._PanelsLayer = tmpPanelsElements[0];
		}

		// Ensure all services are initialized (fallback if onBeforeInitialize was skipped)
		this._instantiateServices();

		// Inject marker defs via the connector shapes provider
		// Note: insertAdjacentHTML does not work on SVG elements (wrong namespace),
		// so we parse via a temporary <svg> element to ensure SVG namespace.
		if (this._ConnectorShapesProvider && this._SVGElement)
		{
			let tmpDefs = this._SVGElement.querySelector('defs');
			if (tmpDefs)
			{
				let tmpMarkerMarkup = this._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
				let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				tmpTempSVG.innerHTML = tmpMarkerMarkup;
				while (tmpTempSVG.firstChild)
				{
					tmpDefs.appendChild(tmpTempSVG.firstChild);
				}
			}
		}

		// Setup the toolbar if enabled
		if (this.options.EnableToolbar)
		{
			this._ToolbarView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowToolbar',
				Object.assign({},
					libPictViewFlowToolbar.default_configuration,
					{
						ViewIdentifier: `Flow-Toolbar-${tmpViewIdentifier}`,
						DefaultDestinationAddress: `#Flow-Toolbar-${tmpViewIdentifier}`,
						FlowViewIdentifier: tmpViewIdentifier,
						EnableAddNode: this.options.EnableAddNode,
						EnableCardPalette: this.options.EnableCardPalette,
						ToolbarExtraButtons: this.options.ToolbarExtraButtons
					}
				));
			// Use the toolbar's render method after it's set up
			if (this._ToolbarView && typeof this._ToolbarView.render === 'function')
			{
				this._ToolbarView._FlowView = this;
				this._ToolbarView.render();
			}
		}

		// Setup the node renderer. A consumer can override the node title-bar height (e.g. a moodboard
		// sets it to 0 for edge-to-edge image and note cards) via the flow-level NodeTitleBarHeight
		// option; otherwise the renderer keeps its own default.
		let tmpNodeViewOptions = { ViewIdentifier: `Flow-NodeRenderer-${tmpViewIdentifier}`, AutoRender: false };
		if (typeof this.options.NodeTitleBarHeight === 'number') { tmpNodeViewOptions.NodeTitleBarHeight = this.options.NodeTitleBarHeight; }
		this._NodeView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowNode',
			Object.assign({}, libPictViewFlowNode.default_configuration, tmpNodeViewOptions));
		this._NodeView._FlowView = this;
		// The default renderable renderer. Non-card renderers register alongside it.
		this._RenderableRenderers['card'] = this._NodeView;

		// Setup the properties panel renderer
		this._PropertiesPanelView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowPropertiesPanel',
			Object.assign({},
				libPictViewFlowPropertiesPanel.default_configuration,
				{
					ViewIdentifier: `Flow-PropertiesPanel-${tmpViewIdentifier}`,
					AutoRender: false
				}
			));
		this._PropertiesPanelView._FlowView = this;

		// Bind interaction events
		this._InteractionManager.initialize(this._SVGElement, this._ViewportElement);

		// Wire the auto-apply handler to structural-change events
		this._subscribeAutoApplyHandlers();

		// Load initial flow data if an address is configured
		if (this.options.FlowDataAddress)
		{
			this.marshalToView();
		}

		// Render the initial flow
		this.renderFlow();

		// Optionally snap to the default saved layout once the graph is drawn. A host with an async
		// LayoutStorage that resolves later should call applyDefaultLayout() from its load callback.
		if (this.options.ApplyDefaultLayoutOnLoad && this._LayoutProvider && this._LayoutProvider.getDefaultLayout())
		{
			this._LayoutProvider.applyDefaultLayout();
		}

		// Presentation fit. FitMode 'width' fits the frame to the container width now and on
		// resize; otherwise honor a frame's legacy FitOnLoad (contain). Both need the SVG sized,
		// so this runs after the initial render.
		if (this.options.FitMode === 'width')
		{
			this._setupFitObserver();
		}
		else
		{
			let tmpFrame = this._resolveFrame();
			if (tmpFrame && tmpFrame.FitOnLoad)
			{
				this.fitToFrame();
			}
		}
	}

	// ---- Saved-layout delegations ----
	// A clean view-level API over the layout provider for saving, restoring, and
	// choosing a default arrangement of the same graph. The toolbar uses the
	// provider directly; these are additive.

	saveLayout(pName) { return this._LayoutProvider ? this._LayoutProvider.saveLayout(pName) : null; }
	restoreLayout(pHash) { return this._LayoutProvider ? this._LayoutProvider.restoreLayout(pHash) : false; }
	applyLayout(pHash) { return this.restoreLayout(pHash); }
	deleteLayout(pHash) { return this._LayoutProvider ? this._LayoutProvider.deleteLayout(pHash) : false; }
	getLayouts() { return this._LayoutProvider ? this._LayoutProvider.getLayouts() : []; }
	setDefaultLayout(pHash) { return this._LayoutProvider ? this._LayoutProvider.setDefaultLayout(pHash) : false; }
	getDefaultLayout() { return this._LayoutProvider ? this._LayoutProvider.getDefaultLayout() : null; }
	applyDefaultLayout() { return this._LayoutProvider ? this._LayoutProvider.applyDefaultLayout() : false; }

	// ---- Data Manager Delegations ----

	marshalToView() { return this._DataManager.marshalToView(); }
	marshalFromView() { return this._DataManager.marshalFromView(); }
	getFlowData() { return this._DataManager.getFlowData(); }
	setFlowData(pFlowData) { return this._DataManager.setFlowData(pFlowData); }
	addNode(pType, pX, pY, pTitle, pData) { return this._DataManager.addNode(pType, pX, pY, pTitle, pData); }
	removeNode(pNodeHash) { return this._DataManager.removeNode(pNodeHash); }
	addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData) { return this._DataManager.addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData); }
	removeConnection(pConnectionHash) { return this._DataManager.removeConnection(pConnectionHash); }

	/**
	 * Select a node
	 * @param {string|null} pNodeHash - Hash of the node to select, or null to deselect
	 */
	selectNode(pNodeHash)
	{
		return this._SelectionManager.selectNode(pNodeHash);
	}

	/**
	 * Toggle a node's membership in the selection set (multi-select; shift-click).
	 * @param {string} pNodeHash
	 */
	toggleNodeSelection(pNodeHash)
	{
		return this._SelectionManager.toggleNodeSelection(pNodeHash);
	}

	/**
	 * Replace the selection set with the given node hashes (multi-select; marquee result).
	 * @param {Array<string>} pNodeHashes
	 */
	selectNodes(pNodeHashes)
	{
		return this._SelectionManager.selectNodes(pNodeHashes);
	}

	/**
	 * The current selection set as an array of node hashes.
	 * @returns {Array<string>}
	 */
	getSelectedNodeHashes()
	{
		return this._SelectionManager.getSelectedNodeHashes();
	}

	/**
	 * Select a connection
	 * @param {string|null} pConnectionHash - Hash of the connection to select, or null to deselect
	 */
	selectConnection(pConnectionHash)
	{
		return this._SelectionManager.selectConnection(pConnectionHash);
	}

	/**
	 * Deselect all nodes and connections
	 */
	deselectAll()
	{
		return this._SelectionManager.deselectAll();
	}

	/**
	 * Delete the currently selected node or connection
	 * @returns {boolean}
	 */
	deleteSelected()
	{
		return this._SelectionManager.deleteSelected();
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		return this._ViewportManager.updateViewportTransform();
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		return this._ViewportManager.setZoom(pZoom, pFocusX, pFocusY);
	}

	/**
	 * Zoom to fit all nodes in the viewport.
	 * @param {boolean} pAllowZoomIn - when true the fit may scale up past 1.0 (presentation banners opt in).
	 */
	zoomToFit(pAllowZoomIn)
	{
		return this._ViewportManager.zoomToFit(pAllowZoomIn);
	}

	/**
	 * Apply auto-layout to all nodes.
	 *
	 * Backwards-compatible signature: when called with no arguments,
	 * dispatches to the Layered algorithm with its default parameters
	 * (matching the pre-subsystem behavior).
	 *
	 * If `pAlgorithmName` is provided it is used directly; otherwise the
	 * configured `_FlowData.LayoutAlgorithm` is used (unless that value
	 * is 'Custom' or unset, in which case it falls back to 'Layered').
	 *
	 * @param {string} [pAlgorithmName]
	 * @param {Object} [pParameters]
	 */
	autoLayout(pAlgorithmName, pParameters)
	{
		if (!this._LayoutService) return;

		let tmpName;
		let tmpParams;
		if (typeof pAlgorithmName === 'string' && pAlgorithmName !== '')
		{
			tmpName = pAlgorithmName;
			tmpParams = pParameters || {};
		}
		else
		{
			let tmpConfigured = this._FlowData.LayoutAlgorithm;
			tmpName = (typeof tmpConfigured === 'string' && tmpConfigured !== '' && tmpConfigured !== 'Custom') ? tmpConfigured : 'Layered';
			tmpParams = (tmpName === this._FlowData.LayoutAlgorithm) ? (this._FlowData.LayoutParameters || {}) : {};
		}

		this._LayoutService.autoLayout(this._FlowData.Nodes, this._FlowData.Connections, tmpName, tmpParams);
		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Apply the currently configured layout algorithm to the flow, then
	 * call the active edge theme's `AdjustLayout` callback (if any) to
	 * let the theme adjust node positions for cleaner edge rendering
	 * (e.g. snap to grid, optimize for crossing minimization).
	 *
	 * Reads `_FlowData.LayoutAlgorithm` / `LayoutParameters` /
	 * `EdgeTheme` / `EdgeThemeParameters`. No-op when algorithm is
	 * 'Custom' — but the edge theme's adjustment still runs (so themes
	 * like OrthogonalSnap can snap hand-placed nodes too).
	 */
	applyCurrentLayout()
	{
		if (!this._LayoutService) return;
		let tmpAlgorithm = this._FlowData.LayoutAlgorithm || 'Custom';

		this._AutoApplyInProgress = true;
		try
		{
			if (tmpAlgorithm !== 'Custom')
			{
				this._LayoutService.applyLayout(
					this._FlowData.Nodes,
					this._FlowData.Connections,
					tmpAlgorithm,
					this._FlowData.LayoutParameters || {}
				);
			}

			// Edge-theme post-processing (placement adjustment).
			let tmpEdgeTheme = this._LayoutService.resolveActiveEdgeTheme({});
			if (tmpEdgeTheme && typeof tmpEdgeTheme.AdjustLayout === 'function')
			{
				try
				{
					let tmpEdgeParams = this._LayoutService.getMergedEdgeThemeParameters(
						tmpEdgeTheme.Name,
						this._FlowData.EdgeThemeParameters || {}
					);
					tmpEdgeTheme.AdjustLayout(this._FlowData.Nodes, this._FlowData.Connections, tmpEdgeParams);
				}
				catch (pError)
				{
					this.log.warn(`PictSectionFlow edge theme '${tmpEdgeTheme.Name}' AdjustLayout threw: ${pError.message}`);
				}
			}

			let tmpHadAdjust = !!(tmpEdgeTheme && typeof tmpEdgeTheme.AdjustLayout === 'function');
			let tmpDidLayout = (tmpAlgorithm !== 'Custom');

			if (!tmpDidLayout && !tmpHadAdjust)
			{
				// Custom + theme-without-AdjustLayout → no positions changed.
				// Don't render or fire onFlowChanged.
				return;
			}

			this.renderFlow();
			this.marshalFromView();

			if (this._EventHandlerProvider)
			{
				this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
			}
		}
		finally
		{
			this._AutoApplyInProgress = false;
		}
	}

	/**
	 * Set the active edge theme (and optionally its parameters). Re-runs
	 * the current layout so any `AdjustLayout` callback takes effect.
	 *
	 * @param {string|null} pThemeName - null clears the override (theme
	 *   then resolves via the active layout's `DefaultEdgeTheme`).
	 * @param {Object} [pParameters]
	 */
	setEdgeTheme(pThemeName, pParameters)
	{
		if (!this._LayoutService) return;
		if (pThemeName != null && typeof pThemeName !== 'string') return;

		if (pThemeName)
		{
			let tmpTheme = this._LayoutService.getEdgeTheme(pThemeName);
			if (!tmpTheme)
			{
				this.log.warn(`PictSectionFlow setEdgeTheme: unknown theme '${pThemeName}'`);
				return;
			}
			this._FlowData.EdgeTheme = pThemeName;
			this._FlowData.EdgeThemeParameters = Object.assign({}, tmpTheme.DefaultParameters || {}, pParameters || {});
		}
		else
		{
			this._FlowData.EdgeTheme = null;
			this._FlowData.EdgeThemeParameters = pParameters ? Object.assign({}, pParameters) : {};
		}

		this.applyCurrentLayout();
	}

	/**
	 * Read the currently configured edge theme settings.
	 * Returns the *resolved* active theme (factoring in fallback to the
	 * active layout's `DefaultEdgeTheme`) plus the explicit override
	 * (if any) for round-tripping into UI.
	 *
	 * @returns {{ Theme: string, Override: string|null, Parameters: Object }}
	 */
	getEdgeTheme()
	{
		let tmpResolved = this._LayoutService ? this._LayoutService.resolveActiveEdgeTheme({}) : null;
		return {
			Theme: tmpResolved ? tmpResolved.Name : null,
			Override: this._FlowData.EdgeTheme || null,
			Parameters: JSON.parse(JSON.stringify(this._FlowData.EdgeThemeParameters || {}))
		};
	}

	/**
	 * Set the configured layout algorithm and (optionally) its parameters
	 * and auto-apply flag. Persists to `_FlowData` and applies the layout
	 * immediately when the algorithm is non-Custom.
	 *
	 * @param {string} pAlgorithmName
	 * @param {Object} [pParameters] - merged over the algorithm's defaults
	 * @param {boolean} [pAutoApply] - if provided, also sets `LayoutAutoApply`
	 */
	setLayoutAlgorithm(pAlgorithmName, pParameters, pAutoApply)
	{
		if (!this._LayoutService) return;
		if (typeof pAlgorithmName !== 'string' || pAlgorithmName === '') return;

		let tmpAlgo = this._LayoutService.getAlgorithm(pAlgorithmName);
		if (!tmpAlgo)
		{
			this.log.warn(`PictSectionFlow setLayoutAlgorithm: unknown algorithm '${pAlgorithmName}'`);
			return;
		}

		this._FlowData.LayoutAlgorithm = pAlgorithmName;
		this._FlowData.LayoutParameters = Object.assign({}, tmpAlgo.DefaultParameters || {}, pParameters || {});
		if (typeof pAutoApply === 'boolean')
		{
			this._FlowData.LayoutAutoApply = pAutoApply;
		}

		// Always run applyCurrentLayout so the new layout's `DefaultEdgeTheme`
		// takes effect on connection rendering — even when switching to
		// 'Custom' (which doesn't reposition nodes but does re-render edges).
		this.applyCurrentLayout();
		this.renderFlow();
	}

	/**
	 * Toggle whether the configured layout re-applies on structural changes.
	 * @param {boolean} pAutoApply
	 */
	setLayoutAutoApply(pAutoApply)
	{
		this._FlowData.LayoutAutoApply = !!pAutoApply;
		this.marshalFromView();
	}

	/**
	 * Read the currently configured layout algorithm settings.
	 * @returns {{ Algorithm: string, Parameters: Object, AutoApply: boolean }}
	 */
	getLayoutAlgorithm()
	{
		return {
			Algorithm: this._FlowData.LayoutAlgorithm || 'Custom',
			Parameters: JSON.parse(JSON.stringify(this._FlowData.LayoutParameters || {})),
			AutoApply: !!this._FlowData.LayoutAutoApply
		};
	}

	/**
	 * Subscribe the auto-apply handler to structural-change events. Idempotent.
	 * Only structural events trigger re-layout — `onNodeMoved` is intentionally
	 * NOT subscribed so user drags are never clobbered until the next add/remove.
	 */
	_subscribeAutoApplyHandlers()
	{
		if (!this._EventHandlerProvider) return;
		if (this._AutoApplyHandlerHashes.length > 0) return;

		let tmpEvents = ['onNodeAdded', 'onNodeRemoved', 'onConnectionCreated', 'onConnectionRemoved'];
		for (let i = 0; i < tmpEvents.length; i++)
		{
			let tmpHash = this._EventHandlerProvider.registerHandler(tmpEvents[i], () =>
			{
				if (this._AutoApplyInProgress) return;
				if (!this._FlowData.LayoutAutoApply) return;
				if (!this._FlowData.LayoutAlgorithm || this._FlowData.LayoutAlgorithm === 'Custom') return;
				this.applyCurrentLayout();
			});
			if (tmpHash) this._AutoApplyHandlerHashes.push({ Event: tmpEvents[i], Hash: tmpHash });
		}
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		return this._ViewportManager.toggleFullscreen();
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		return this._ViewportManager.exitFullscreen();
	}

	// ── Theme / Renderer / Style-Preset API ─────────────────────────────
	//
	// Three axes you can drive independently:
	//   - ColorTheme — delegates to pict-provider-theme (a pict-section-theme
	//                  catalog hash like 'flow-sketch' or 'pict-default')
	//   - Renderer   — delegates to PictProviderFlowRenderer (controls
	//                  bracket/rect node body, jitter, shadows, fonts)
	//   - EdgeTheme  — delegates to PictService-Flow-Layout (Bezier /
	//                  Straight / Orthogonal / Perimeter / …; see
	//                  PictView-Flow.setEdgeTheme below)
	//
	// Most users pick a curated combo via `setStylePreset()` — the preset
	// applies all three axes in order. Per-axis overrides mark the active
	// preset as 'customized' (getStylePreset returns null afterward).
	//
	// For backwards-compatibility, `setTheme()` / `getThemeKey()` continue
	// to work as aliases for `setStylePreset()` / `getStylePreset()`.

	/**
	 * Apply a named style preset — sets ColorTheme, Renderer, EdgeTheme
	 * (and optional NoiseLevel) in one call.
	 * @param {string} pPresetHash
	 */
	setStylePreset(pPresetHash)
	{
		if (!this._StylePresetsProvider)
		{
			this.log.warn('PictSectionFlow setStylePreset: StylePresets provider not available');
			return;
		}
		let tmpApplied = this._StylePresetsProvider.applyPreset(pPresetHash);
		if (!tmpApplied) { return; }
		this._refreshAfterStyleChange();
		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onStylePresetChanged', pPresetHash);
			// Back-compat — old code listens for 'onThemeChanged'
			this._EventHandlerProvider.fireEvent('onThemeChanged', pPresetHash);
		}
	}

	/**
	 * Hash of the active style preset, or null when in customized state.
	 * @returns {string|null}
	 */
	getStylePreset()
	{
		return this._StylePresetsProvider ? this._StylePresetsProvider.getActivePresetHash() : null;
	}

	/**
	 * Override just the color theme — delegates to pict-provider-theme.
	 * @param {string} pThemeHash - a pict-section-theme catalog hash
	 */
	setColorTheme(pThemeHash)
	{
		if (this.fable.providers && this.fable.providers.Theme)
		{
			try { this.fable.providers.Theme.applyTheme(pThemeHash); }
			catch (pErr) { this.log.warn(`PictSectionFlow setColorTheme: applyTheme failed — ${pErr.message}`); return; }
		}
		else
		{
			this.log.warn('PictSectionFlow setColorTheme: pict-provider-theme not available in host');
			return;
		}
		if (this._StylePresetsProvider) { this._StylePresetsProvider.markCustomized(); }
		this._refreshAfterStyleChange();
		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onColorThemeChanged', pThemeHash);
		}
	}

	/**
	 * The active color theme hash (from pict-provider-theme).
	 * @returns {string|null}
	 */
	getColorThemeKey()
	{
		if (this.fable.providers && this.fable.providers.Theme && typeof this.fable.providers.Theme.getActiveTheme === 'function')
		{
			let tmpActive = this.fable.providers.Theme.getActiveTheme();
			if (tmpActive && tmpActive.Hash) { return tmpActive.Hash; }
		}
		return null;
	}

	/**
	 * Override just the renderer — controls node body shape, jitter, shadows.
	 * @param {string} pRendererKey
	 */
	setRenderer(pRendererKey)
	{
		if (!this._RendererProvider)
		{
			this.log.warn('PictSectionFlow setRenderer: Renderer provider not available');
			return;
		}
		let tmpApplied = this._RendererProvider.setRenderer(pRendererKey);
		if (!tmpApplied) { return; }
		if (this._StylePresetsProvider) { this._StylePresetsProvider.markCustomized(); }
		this._refreshAfterStyleChange();
		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onRendererChanged', pRendererKey);
		}
	}

	/**
	 * The active renderer key.
	 * @returns {string}
	 */
	getRendererKey()
	{
		return this._RendererProvider ? this._RendererProvider.getActiveRendererKey() : 'clean';
	}

	/**
	 * Set the noise level (0 to 1) and re-render. Noise applies only when
	 * the active renderer enables it (see Renderer.NoiseConfig).
	 * @param {number} pLevel - 0 = precise, 1 = maximum wobble
	 */
	setNoiseLevel(pLevel)
	{
		if (this._RendererProvider)
		{
			this._RendererProvider.setNoiseLevel(pLevel);
		}
		else if (this._ThemeProvider)
		{
			this._ThemeProvider.setNoiseLevel(pLevel);
		}
		if (this.initialRenderComplete) { this.renderFlow(); }
	}

	/**
	 * Current noise level (0 to 1).
	 * @returns {number}
	 */
	getNoiseLevel()
	{
		if (this._RendererProvider) { return this._RendererProvider.getNoiseLevel(); }
		if (this._ThemeProvider)    { return this._ThemeProvider.getNoiseLevel(); }
		return 0;
	}

	/**
	 * @deprecated since the 3-axis refactor — use setStylePreset() instead.
	 * Kept as an alias for back-compat with existing host apps and views.
	 * @param {string} pPresetHash
	 */
	setTheme(pPresetHash)
	{
		this.setStylePreset(pPresetHash);
	}

	/**
	 * @deprecated since the 3-axis refactor — use getStylePreset() instead.
	 * Returns the active preset hash (or null if customized).
	 * @returns {string|null}
	 */
	getThemeKey()
	{
		return this.getStylePreset();
	}

	/**
	 * Common refresh path used by all axis-change methods.
	 * Re-registers the renderer CSS, re-injects marker defs (arrowhead colors
	 * may have shifted with the new theme), and full-renders the flow.
	 * @private
	 */
	_refreshAfterStyleChange()
	{
		if (this._CSSProvider && typeof this._CSSProvider.registerRendererCSS === 'function' && this._RendererProvider)
		{
			this._CSSProvider.registerRendererCSS(this._RendererProvider.getActiveRenderer());
		}
		if (this._CSSProvider) { this._CSSProvider.registerCSS(); }
		this._reinjectMarkerDefs();
		if (this.initialRenderComplete) { this.renderFlow(); }
	}

	_reinjectMarkerDefs() { return this._RenderManager.reinjectMarkerDefs(); }

	/**
	 * Get a node by hash
	 * @param {string} pNodeHash
	 * @returns {Object|null}
	 */
	getNode(pNodeHash)
	{
		return this._FlowData.Nodes.find((pNode) => pNode.Hash === pNodeHash) || null;
	}

	/**
	 * Get a connection by hash
	 * @param {string} pConnectionHash
	 * @returns {Object|null}
	 */
	getConnection(pConnectionHash)
	{
		return this._FlowData.Connections.find((pConn) => pConn.Hash === pConnectionHash) || null;
	}

	/**
	 * Select a tether by its panel hash.
	 * @param {string|null} pPanelHash - Hash of the panel whose tether to select, or null to deselect
	 */
	selectTether(pPanelHash)
	{
		return this._SelectionManager.selectTether(pPanelHash);
	}

	// ---- Connection Handle Manager Delegations ----

	updateConnectionHandle(pConnectionHash, pHandleType, pX, pY) { return this._ConnectionHandleManager.updateConnectionHandle(pConnectionHash, pHandleType, pX, pY); }
	addConnectionHandle(pConnectionHash, pX, pY) { return this._ConnectionHandleManager.addConnectionHandle(pConnectionHash, pX, pY); }
	removeConnectionHandle(pConnectionHash, pIndex) { return this._ConnectionHandleManager.removeConnectionHandle(pConnectionHash, pIndex); }
	_resetHandlesForNode(pNodeHash) { return this._ConnectionHandleManager.resetHandlesForNode(pNodeHash); }
	_resetHandlesForPanel(pPanelHash) { return this._ConnectionHandleManager.resetHandlesForPanel(pPanelHash); }

	/**
	 * Add a bezier handle to a tether at the specified SVG position.
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	addTetherHandle(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		let tmpNode = this.getNode(tmpPanel.NodeHash);
		if (!tmpNode) return;

		let tmpAnchors = this._TetherService.getSmartAnchors(tmpPanel, tmpNode);

		this._TetherService.addHandle(tmpPanel, pX, pY, tmpAnchors.panelAnchor, tmpAnchors.nodeAnchor);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Remove a bezier handle from a tether by index.
	 * @param {string} pPanelHash
	 * @param {number} pIndex
	 */
	removeTetherHandle(pPanelHash, pIndex)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		this._TetherService.removeHandle(tmpPanel, pIndex);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Update a tether handle position during drag (for real-time feedback).
	 * Delegates state update to the TetherService.
	 * @param {string} pPanelHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateTetherHandle(pPanelHash, pHandleType, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._TetherService)
		{
			this._TetherService.updateHandlePosition(tmpPanel, pHandleType, pX, pY);
		}

		this._renderSingleTether(pPanelHash);
	}

	/**
	 * Get a port's absolute position in SVG coordinates.
	 *
	 * For left and right side ports, positioning is offset below the title bar
	 * so that connection endpoints match the rendered port circles.
	 *
	 * @param {string} pNodeHash
	 * @param {string} pPortHash
	 * @returns {{x: number, y: number, side: string}|null}
	 */
	getPortPosition(pNodeHash, pPortHash)
	{
		let tmpNode = this.getNode(pNodeHash);
		if (!tmpNode) return null;

		let tmpPort = tmpNode.Ports.find((p) => p.Hash === pPortHash);
		if (!tmpPort) return null;

		// Count ports on the same side (matching both direction and side)
		let tmpSameSidePorts = tmpNode.Ports.filter((p) => p.Side === tmpPort.Side);
		let tmpPortIndex = tmpSameSidePorts.indexOf(tmpPort);
		let tmpPortCount = tmpSameSidePorts.length;

		let tmpTitleBarHeight = (this._NodeView && this._NodeView.options.NodeTitleBarHeight) || 28;

		// Use the adjusted node height that accounts for minimum port
		// spacing.  Connections render before nodes, so the node renderer
		// may not have written back its adjusted height yet.
		let tmpHeight = tmpNode.Height || 80;
		if (this._GeometryProvider && tmpNode.Ports && tmpNode.Ports.length > 0)
		{
			let tmpMinHeight = this._GeometryProvider.computeMinimumNodeHeight(tmpNode.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Build port counts map for adaptive zone sizing
		let tmpPortCountsBySide = this._GeometryProvider.buildPortCountsBySide(tmpNode.Ports);

		let tmpLocal = this._GeometryProvider.getPortLocalPosition(tmpPort.Side, tmpPortIndex, tmpPortCount, tmpNode.Width, tmpHeight, tmpTitleBarHeight, tmpPortCountsBySide);

		return { x: tmpNode.X + tmpLocal.x, y: tmpNode.Y + tmpLocal.y, side: tmpPort.Side || 'right' };
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		return this._ViewportManager.screenToSVGCoords(pScreenX, pScreenY);
	}

	// ---- Render Manager Delegations ----

	renderFlow() { return this._RenderManager.renderFlow(); }
	_renderSingleConnection(pConnectionHash) { return this._RenderManager.renderSingleConnection(pConnectionHash); }
	_renderSingleTether(pPanelHash) { return this._RenderManager.renderSingleTether(pPanelHash); }
	updateNodePosition(pNodeHash, pX, pY) { return this._RenderManager.updateNodePosition(pNodeHash, pX, pY); }
	_renderConnectionsForNode(pNodeHash) { return this._RenderManager.renderConnectionsForNode(pNodeHash); }
	_renderTethersForNode(pNodeHash) { return this._RenderManager.renderTethersForNode(pNodeHash); }

	// ---- Properties Panel Management ----

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node has no PropertiesPanel config
	 */
	openPanel(pNodeHash)
	{
		return this._PanelManager.openPanel(pNodeHash);
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		return this._PanelManager.closePanel(pPanelHash);
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		return this._PanelManager.closePanelForNode(pNodeHash);
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		return this._PanelManager.togglePanel(pNodeHash);
	}

	/**
	 * Open a properties panel for a connection (edge). Requires the ConnectionPropertiesPanel
	 * option; returns false otherwise.
	 * @param {string} pConnectionHash
	 * @returns {Object|false}
	 */
	openConnectionPanel(pConnectionHash)
	{
		return this._PanelManager.openConnectionPanel(pConnectionHash);
	}

	/**
	 * Toggle a properties panel for a connection.
	 * @param {string} pConnectionHash
	 * @returns {Object|false}
	 */
	toggleConnectionPanel(pConnectionHash)
	{
		return this._PanelManager.toggleConnectionPanel(pConnectionHash);
	}

	/**
	 * Close all panels for a given connection.
	 * @param {string} pConnectionHash
	 * @returns {boolean}
	 */
	closePanelForConnection(pConnectionHash)
	{
		return this._PanelManager.closePanelForConnection(pConnectionHash);
	}

	/**
	 * The midpoint of a connection in SVG coordinates, averaged from its two endpoint ports. Used
	 * to place and tether a connection's properties panel. Returns null if the connection or
	 * either port can not be resolved.
	 * @param {string} pConnectionHash
	 * @returns {{x: number, y: number}|null}
	 */
	getConnectionMidpoint(pConnectionHash)
	{
		let tmpConnection = this.getConnection(pConnectionHash);
		if (!tmpConnection) return null;
		let tmpSource = this.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
		let tmpTarget = this.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);
		if (!tmpSource || !tmpTarget) return null;
		// A connection renders as a curve, so the straight-line average of its endpoints sits OFF the
		// line (the panel tether would point into empty space). Prefer the true midpoint of the rendered
		// path -- getPointAtLength at half its length, which is genuinely on the line. Fall back to the
		// endpoint average when the path element or SVG geometry is unavailable (e.g. server-side render).
		if (this._SVGElement && typeof this._SVGElement.querySelector === 'function')
		{
			let tmpPathElement = this._SVGElement.querySelector('.pict-flow-connection[data-connection-hash="' + pConnectionHash + '"]');
			if (tmpPathElement && typeof tmpPathElement.getTotalLength === 'function' && typeof tmpPathElement.getPointAtLength === 'function')
			{
				try
				{
					let tmpLength = tmpPathElement.getTotalLength();
					if (tmpLength > 0)
					{
						let tmpPoint = tmpPathElement.getPointAtLength(tmpLength / 2);
						return { x: tmpPoint.x, y: tmpPoint.y };
					}
				}
				catch (pError) { /* fall through to the straight-line midpoint */ }
			}
		}
		return { x: (tmpSource.x + tmpTarget.x) / 2, y: (tmpSource.y + tmpTarget.y) / 2 };
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		return this._PanelManager.updatePanelPosition(pPanelHash, pX, pY);
	}

	// ── Inline-handler bridges (called from template onclick/oninput attrs)

	/**
	 * Handle a click on a panel tab button. Stops propagation so the
	 * underlying SVG doesn't see it, then delegates to the properties
	 * panel view for the actual visibility toggle.
	 *
	 * @param {Element} pTabElement
	 * @param {Event} pEvent
	 */
	_handlePanelTabClick(pTabElement, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function')
		{
			pEvent.stopPropagation();
		}
		if (this._PropertiesPanelView)
		{
			this._PropertiesPanelView.switchPanelTab(pTabElement);
		}
	}

	/**
	 * Apply a node property change driven from the appearance editor's
	 * inline `oninput` handler. Stops propagation, then delegates to the
	 * properties panel view.
	 *
	 * @param {string} pNodeHash
	 * @param {string} pPropPath
	 * @param {string} pValue
	 * @param {string} pInputType - 'text' | 'number' | 'color'
	 * @param {Event} [pEvent]
	 */
	_applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function')
		{
			pEvent.stopPropagation();
		}
		if (this._PropertiesPanelView)
		{
			this._PropertiesPanelView._applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType);
		}
	}

	/**
	 * Inline-handler bridge — light up port-hint paths matching the given
	 * port (and optionally node) hash. Called from inline `onmouseenter`
	 * on port badges; see PictService-Flow-PortRenderer._wirePortHintHover.
	 *
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_activatePortHints(pPortHash, pNodeHash)
	{
		this._togglePortHints(pPortHash, pNodeHash, true);
	}

	/**
	 * Inline-handler bridge — clear port-hint highlights.
	 *
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_deactivatePortHints(pPortHash, pNodeHash)
	{
		this._togglePortHints(pPortHash, pNodeHash, false);
	}

	_togglePortHints(pPortHash, pNodeHash, pActive)
	{
		let tmpScope = this._SVGElement || document;
		let tmpSelector = pPortHash
			? '.pict-flow-port-hint[data-port-hash="' + pPortHash + '"]'
			: '.pict-flow-port-hint[data-node-hash="' + pNodeHash + '"]';
		let tmpHints = tmpScope.querySelectorAll(tmpSelector);
		for (let i = 0; i < tmpHints.length; i++)
		{
			if (pActive)
			{
				tmpHints[i].setAttribute('data-active', 'true');
			}
			else
			{
				tmpHints[i].removeAttribute('data-active');
			}
		}
	}

	// ── SVG inline pointer/wheel bridges ─────────────────────────────────

	_handleSVGPointerDown(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerDown(pEvent);
	}

	_handleSVGPointerMove(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerMove(pEvent);
	}

	_handleSVGPointerUp(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerUp(pEvent);
	}

	_handleSVGWheel(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onWheel(pEvent);
	}

	_handleSVGContextMenu(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager.handleContextMenu(pEvent);
	}
}

module.exports = PictViewFlow;

// default_configuration is intentionally NOT exported. Pict's addView merges a
// view's default_configuration UNDER the host's options, which would make those
// now-explicit defaults override Profile values. Defaults are applied inside the
// constructor via mergeProfileOptions (defaults < profile < host) so Profile
// works as a real config knob. Inspect resolved defaults with
// PictViewFlow.mergeProfileOptions({}).

// Config profiles (graph/whiteboard/moodboard/presentation/erd), exposed so
// consumers can inspect or extend them.
module.exports.Profiles = _PROFILES;

},{"../PictFlowCardPropertiesPanel.js":210,"../panels/FlowCardPropertiesPanel-Form.js":211,"../panels/FlowCardPropertiesPanel-Markdown.js":212,"../panels/FlowCardPropertiesPanel-Template.js":213,"../panels/FlowCardPropertiesPanel-View.js":214,"../providers/PictProvider-Flow-Background.js":215,"../providers/PictProvider-Flow-CSS.js":216,"../providers/PictProvider-Flow-ConnectorShapes.js":217,"../providers/PictProvider-Flow-EventHandler.js":218,"../providers/PictProvider-Flow-Geometry.js":219,"../providers/PictProvider-Flow-Icons.js":220,"../providers/PictProvider-Flow-Layouts.js":221,"../providers/PictProvider-Flow-NodeTypes.js":222,"../providers/PictProvider-Flow-Noise.js":223,"../providers/PictProvider-Flow-PanelChrome.js":224,"../providers/PictProvider-Flow-Renderer.js":225,"../providers/PictProvider-Flow-SVGHelpers.js":226,"../providers/PictProvider-Flow-StylePresets.js":227,"../providers/PictProvider-Flow-Theme.js":228,"../services/PictService-Flow-ConnectionHandleManager.js":229,"../services/PictService-Flow-ConnectionRenderer.js":230,"../services/PictService-Flow-CursorManager.js":231,"../services/PictService-Flow-DataManager.js":232,"../services/PictService-Flow-InteractionManager.js":233,"../services/PictService-Flow-Layout.js":234,"../services/PictService-Flow-PanelManager.js":235,"../services/PictService-Flow-PathGenerator.js":236,"../services/PictService-Flow-PortRenderer.js":237,"../services/PictService-Flow-RenderManager.js":238,"../services/PictService-Flow-SelectionManager.js":239,"../services/PictService-Flow-Tether.js":240,"../services/PictService-Flow-ViewportManager.js":241,"./PictView-Flow-FloatingToolbar.js":242,"./PictView-Flow-Node.js":243,"./PictView-Flow-PropertiesPanel.js":244,"./PictView-Flow-Toolbar.js":245,"pict-view":365}],247:[function(require,module,exports){
// The container for all the Pict-Section-InlineDocumentation related code.

// The main inline documentation provider (primary API surface)
module.exports = require('./providers/Pict-Provider-InlineDocumentation.js');

// Exported views for advanced usage
module.exports.InlineDocumentationLayoutView = require('./views/Pict-View-InlineDocumentation-Layout.js');
module.exports.InlineDocumentationContentView = require('./views/Pict-View-InlineDocumentation-Content.js');
module.exports.InlineDocumentationNavView = require('./views/Pict-View-InlineDocumentation-Nav.js');
module.exports.InlineDocumentationTopicManagerView = require('./views/Pict-View-InlineDocumentation-TopicManager.js');

},{"./providers/Pict-Provider-InlineDocumentation.js":248,"./views/Pict-View-InlineDocumentation-Content.js":249,"./views/Pict-View-InlineDocumentation-Layout.js":250,"./views/Pict-View-InlineDocumentation-Nav.js":251,"./views/Pict-View-InlineDocumentation-TopicManager.js":252}],248:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;
const libPictSectionModal = require('pict-section-modal');
const libPictSectionMarkdownEditor = require('pict-section-markdowneditor');
const libLunr = require('lunr');

const libViewLayout = require('../views/Pict-View-InlineDocumentation-Layout.js');
const libViewContent = require('../views/Pict-View-InlineDocumentation-Content.js');
const libViewNav = require('../views/Pict-View-InlineDocumentation-Nav.js');
const libViewTopicManager = require('../views/Pict-View-InlineDocumentation-TopicManager.js');

// Image files the reader displays directly (as an <img>) rather than parsing as markdown.
// The server serves each with its real image/* MimeType, so the browser renders it, SVG included.
const _IMAGE_EXTENSIONS = { png: true, jpg: true, jpeg: true, gif: true, svg: true, webp: true, bmp: true, ico: true };

// The extension of a doc path's last segment, lower-cased, or '' when it carries none.
function _pathExtension(pPath)
{
	let tmpMatch = String(pPath || '').match(/\.([a-z0-9]+)$/i);
	return tmpMatch ? tmpMatch[1].toLowerCase() : '';
}

/**
 * Inline Documentation Provider
 *
 * The primary API for embedding a documentation browser in a Pict application.
 * Instantiates all necessary views and sub-providers, manages documentation
 * state, and exposes methods for loading documents and navigating topics.
 */
class InlineDocumentationProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({},
			JSON.parse(JSON.stringify(_DefaultConfiguration)),
			pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this._ContentCache = {};
		this._ActiveTooltipBindings = [];
		this._tooltipHelpLinkHandler = null;

		// Instantiate the content provider for markdown parsing
		this._ContentProvider = this.pict.addProviderSingleton('Pict-Content', libPictContentProvider.default_configuration, libPictContentProvider);

		// Register views
		this.pict.addViewSingleton('InlineDoc-Layout', libViewLayout.default_configuration, libViewLayout);
		this.pict.addViewSingleton('InlineDoc-Content', libViewContent.default_configuration, libViewContent);
		this.pict.addViewSingleton('InlineDoc-Nav', libViewNav.default_configuration, libViewNav);
		this.pict.addViewSingleton('InlineDoc-TopicManager', libViewTopicManager.default_configuration, libViewTopicManager);

		// Register pict-section-modal if not already present (needed by topic manager)
		if (!this.pict.views['Pict-Section-Modal'])
		{
			this.pict.addViewSingleton('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);
		}

		// Register the markdown editor for edit mode
		let tmpEditorConfig = JSON.parse(JSON.stringify(libPictSectionMarkdownEditor.default_configuration));
		tmpEditorConfig.DefaultDestinationAddress = '#InlineDoc-Editor-Container';
		tmpEditorConfig.TargetElementAddress = '#InlineDoc-Editor-Container';
		tmpEditorConfig.ContentDataAddress = 'AppData.InlineDocumentation.EditorSegments';
		tmpEditorConfig.DefaultPreviewMode = 'off';
		tmpEditorConfig.Renderables =
		[
			{
				RenderableHash: 'MarkdownEditor-Wrap',
				TemplateHash: 'MarkdownEditor-Container',
				ContentDestinationAddress: '#InlineDoc-Editor-Container'
			}
		];
		this.pict.addViewSingleton('InlineDoc-MarkdownEditor', tmpEditorConfig, libPictSectionMarkdownEditor);
	}

	/**
	 * Initialize the inline documentation system.
	 *
	 * Sets up application state, loads sidebar navigation and optionally
	 * topic definitions, then renders the layout.
	 *
	 * @param {Object} [pOptions] - Options: { DocsBaseURL, TopicsURL, ContainerAddress, VocabularyResolver }
	 * @param {Function} [fCallback] - Callback when initialization is complete
	 */
	initializeDocumentation(pOptions, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpOptions = pOptions || {};

		// Initialize application state
		if (!this.pict.AppData.InlineDocumentation)
		{
			this.pict.AppData.InlineDocumentation = {};
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.DocsBaseURL = tmpOptions.DocsBaseURL || tmpState.DocsBaseURL || '';
		tmpState.CurrentPath = '';
		tmpState.CurrentRoute = '';
		tmpState.SidebarGroups = tmpState.SidebarGroups || [];
		tmpState.Topic = null;
		tmpState.Topics = tmpState.Topics || {};
		tmpState.NavigationHistory = [];

		// Navigation outline state
		tmpState.NavCollapsed = true;
		tmpState.CollapsedGroups = {};
		tmpState.ActiveDocumentHeadings = [];
		tmpState.NavFilterText = '';

		// Full-text search state
		tmpState.SearchIndexLoaded = false;
		tmpState.SearchQuery = '';
		tmpState.SearchResults = [];

		// "Show non-document files" preference. The tree lists documents by default; when the
		// host enables the toggle (AssetToggleEnabled), the reader can reveal asset files
		// (images, ...) and the choice is remembered per browser.
		tmpState.AssetToggleEnabled = (tmpOptions.AssetToggleEnabled !== undefined)
			? !!tmpOptions.AssetToggleEnabled
			: (tmpState.AssetToggleEnabled || false);
		tmpState.ShowAssetFiles = this._readShowAssetFilesPref();

		// Whether the tree shows the active document's headings as an in-document outline beneath
		// it. Defaults on; a host that wants a files-only tree passes ShowDocumentHeadings: false.
		tmpState.ShowDocumentHeadings = (tmpOptions.ShowDocumentHeadings !== undefined)
			? !!tmpOptions.ShowDocumentHeadings
			: (tmpState.ShowDocumentHeadings !== false);

		// External link resolution — paths starting with / in the
		// sidebar are cross-module references. ExternalDocBaseURL
		// is prepended to make them full URLs opened in a new tab.
		tmpState.ExternalDocBaseURL = tmpOptions.ExternalDocBaseURL || '';

		// Edit mode state — read from pOptions if provided
		if (tmpOptions.EditEnabled !== undefined)
		{
			tmpState.EditEnabled = !!tmpOptions.EditEnabled;
		}
		else
		{
			tmpState.EditEnabled = tmpState.EditEnabled || false;
		}
		tmpState.Editing = false;
		tmpState.EditingPath = '';
		tmpState.EditingContent = '';
		tmpState.TooltipEditMode = false;

		// Store the onSave callback if provided
		if (typeof tmpOptions.onSave === 'function')
		{
			this._onSave = tmpOptions.onSave;
		}

		// Store the vocabulary resolver if provided. Forwarded as the 4th arg to the content
		// provider's parseMarkdown() at this module's docs-viewer render call sites, so known
		// product terms get wrapped in .pict-vocab-term spans for a hover popover. (pWord) =>
		// { slug, title, short } | null.
		if (typeof tmpOptions.VocabularyResolver === 'function')
		{
			this._VocabularyResolver = tmpOptions.VocabularyResolver;
		}

		// Store the structure-management callbacks if provided. Each is optional and
		// purely additive: the Nav view only shows the matching affordance (New Folder,
		// New Doc, rename/delete, drag reorder/move) when its callback is present, so a
		// host that wires none of them gets exactly today's read-only browser.
		//   onCreateFolder(pParentPath, pName, fCallback)
		//   onCreateDocument(pParentPath, pName, fCallback)
		//   onDeleteNode(pPath, pNodeType, fCallback)
		//   onMoveNode(pFromPath, pToPath, fCallback)   (move into a folder, and rename)
		//   onReorder(pParentPath, pOrderedNames, fCallback)
		if (typeof tmpOptions.onCreateFolder === 'function') { this._onCreateFolder = tmpOptions.onCreateFolder; }
		if (typeof tmpOptions.onCreateDocument === 'function') { this._onCreateDocument = tmpOptions.onCreateDocument; }
		if (typeof tmpOptions.onDeleteNode === 'function') { this._onDeleteNode = tmpOptions.onDeleteNode; }
		if (typeof tmpOptions.onMoveNode === 'function') { this._onMoveNode = tmpOptions.onMoveNode; }
		if (typeof tmpOptions.onReorder === 'function') { this._onReorder = tmpOptions.onReorder; }

		// Store the onTopicsSave callback if provided
		if (typeof tmpOptions.onTopicsSave === 'function')
		{
			this._onTopicsSave = tmpOptions.onTopicsSave;
		}

		// Store the onImageUpload callback if provided
		if (typeof tmpOptions.onImageUpload === 'function')
		{
			this._onImageUpload = tmpOptions.onImageUpload;
			this._wireEditorImageUpload();
		}

		// Topic manager enabled state
		// If explicitly set, use that; otherwise track EditEnabled
		if (tmpOptions.TopicManagerEnabled !== undefined)
		{
			tmpState.TopicManagerEnabled = !!tmpOptions.TopicManagerEnabled;
			this._topicManagerExplicitlySet = true;
		}
		else
		{
			tmpState.TopicManagerEnabled = tmpState.EditEnabled || false;
			this._topicManagerExplicitlySet = false;
		}

		// Optionally override the layout container address
		if (tmpOptions.ContainerAddress)
		{
			let tmpLayoutView = this.pict.views['InlineDoc-Layout'];
			if (tmpLayoutView && tmpLayoutView.options && tmpLayoutView.options.Renderables)
			{
				for (let i = 0; i < tmpLayoutView.options.Renderables.length; i++)
				{
					tmpLayoutView.options.Renderables[i].ContentDestinationAddress = tmpOptions.ContainerAddress;
				}
			}
		}

		// Load sidebar, topics, and search index in parallel
		let tmpPending = 2;
		if (tmpOptions.SearchIndexURL) tmpPending++;

		let tmpSelf = this;
		let tmpFinish = () =>
		{
			tmpPending--;
			if (tmpPending <= 0)
			{
				// Mark sidebar items as external based on ExternalDocBaseURL
				tmpSelf._markExternalSidebarItems();

				// Render the layout (which contains nav and content containers)
				tmpSelf.pict.views['InlineDoc-Layout'].render();
				// Render the navigation
				tmpSelf.pict.views['InlineDoc-Nav'].render();

				return tmpCallback();
			}
		};

		this._loadSidebar(tmpFinish);
		this._loadTopics(tmpOptions.TopicsURL, tmpFinish);

		if (tmpOptions.SearchIndexURL)
		{
			this._loadSearchIndex(tmpOptions.SearchIndexURL, tmpFinish);
		}
	}

	/**
	 * Load and display a markdown document.
	 *
	 * Fetches the document relative to DocsBaseURL, parses it to HTML via
	 * pict-section-content, and displays it in the content view.
	 *
	 * @param {string} pPath - Relative document path (e.g. 'getting-started.md')
	 * @param {Function} [fCallback] - Callback receiving (error, htmlContent)
	 */
	loadDocument(pPath, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};

		if (!pPath)
		{
			return tmpCallback('No document path provided');
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpContentView = this.pict.views['InlineDoc-Content'];

		// Parse anchor from path (e.g. 'page.md#section-heading')
		let tmpAnchor = '';
		let tmpPath = pPath;
		let tmpHashIndex = tmpPath.indexOf('#');
		if (tmpHashIndex >= 0)
		{
			tmpAnchor = tmpPath.substring(tmpHashIndex + 1);
			tmpPath = tmpPath.substring(0, tmpHashIndex);
		}

		// Only add .md when the path carries no extension of its own. A path that already
		// names a file type (README.md, guides/layer-model.svg, ...) is served as-is, so an
		// image is not turned into a 404 by an appended .md.
		let tmpExtension = _pathExtension(tmpPath);
		if (!tmpExtension)
		{
			tmpPath = tmpPath + '.md';
			tmpExtension = 'md';
		}

		// Update state
		tmpState.CurrentPath = tmpPath;
		tmpState.NavigationHistory.push(tmpPath);

		// Render the content view template (creates the container element)
		tmpContentView.render();

		let tmpURL = (tmpState.DocsBaseURL || '') + tmpPath;

		// An image is displayed directly (the server serves its image/* bytes) — there is no
		// markdown to parse, so show it in an image viewer instead of fetching + parsing.
		if (_IMAGE_EXTENSIONS[tmpExtension])
		{
			tmpContentView.displayContent(this._buildImageViewerHTML(tmpURL, tmpPath));
			tmpState.NavCollapsed = true;
			tmpState.NavFilterText = '';
			tmpState.SearchQuery = '';
			tmpState.SearchResults = [];
			this.pict.views['InlineDoc-Nav'].render();
			return tmpCallback(null, '');
		}

		// Show loading indicator
		tmpContentView.showLoading();

		// Fetch the document
		this._fetchDocument(tmpURL, (pError, pHTML) =>
		{
			if (pError)
			{
				tmpContentView.displayContent(this._getErrorPageHTML(tmpPath));
				return tmpCallback(pError);
			}

			tmpContentView.displayContent(pHTML);

			// Scroll to anchor if specified
			if (tmpAnchor)
			{
				this._scrollToAnchor(tmpAnchor);
			}

			// Collapse the nav outline and clear search/filter
			tmpState.NavCollapsed = true;
			tmpState.NavFilterText = '';
			tmpState.SearchQuery = '';
			tmpState.SearchResults = [];
			this.pict.views['InlineDoc-Nav'].render();

			return tmpCallback(null, pHTML);
		});
	}

	/**
	 * The content-area HTML for viewing an image document: the image itself (the server serves
	 * its bytes with the right image/* type, so SVG renders too), captioned with its path and a
	 * link to open the raw file in a new tab.
	 *
	 * @param {string} pURL - The image's source URL (DocsBaseURL + path)
	 * @param {string} pPath - The lake path (for the caption / filename)
	 * @returns {string} HTML string for displayContent
	 */
	_buildImageViewerHTML(pURL, pPath)
	{
		let fEscape = (pText) => String(pText == null ? '' : pText)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		let tmpName = String(pPath || '').slice(String(pPath || '').lastIndexOf('/') + 1);
		return '<div class="pict-inline-doc-image-view">'
			+ '<img class="pict-inline-doc-image" src="' + fEscape(pURL) + '" alt="' + fEscape(tmpName) + '" />'
			+ '<div class="pict-inline-doc-image-caption">'
			+ '<span class="pict-inline-doc-image-name">' + fEscape(pPath) + '</span>'
			+ '<a class="pict-inline-doc-image-open" href="' + fEscape(pURL) + '" target="_blank" rel="noopener">Open original</a>'
			+ '</div></div>';
	}

	/**
	 * Set the active topic, filtering navigation to that topic's documents.
	 *
	 * @param {string} pTopicKey - The topic key (TopicCode from pict_documentation_topics.json)
	 */
	setTopic(pTopicKey)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicKey || !tmpState.Topics || !tmpState.Topics[pTopicKey])
		{
			this.log.warn(`InlineDocumentation: Topic [${pTopicKey}] not found.`);
			return;
		}

		tmpState.Topic = pTopicKey;

		// Re-render navigation with topic filter
		this.pict.views['InlineDoc-Nav'].render();
	}

	/**
	 * Load and display a topic's help document by TopicCode.
	 *
	 * Looks up the topic in the pict_documentation_topics.json format,
	 * sets it as active, and loads its TopicHelpFilePath.
	 *
	 * @param {string} pTopicCode - The TopicCode (e.g. 'BOOKSHOP-BOOKLIST')
	 * @param {Function} [fCallback] - Callback receiving (error, htmlContent)
	 */
	loadTopicDocument(pTopicCode, fCallback)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			this.log.warn(`InlineDocumentation: Topic [${pTopicCode}] not found.`);
			if (typeof fCallback === 'function')
			{
				return fCallback('Topic not found');
			}
			return;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];
		tmpState.Topic = pTopicCode;

		// Re-render navigation
		this.pict.views['InlineDoc-Nav'].render();

		// Load the topic's help file
		let tmpPath = tmpTopic.TopicHelpFilePath || '';
		if (tmpPath)
		{
			this.loadDocument(tmpPath, fCallback);
		}
	}

	/**
	 * Clear the active topic, showing full navigation.
	 */
	clearTopic()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.Topic = null;

		// Re-render navigation without filter
		this.pict.views['InlineDoc-Nav'].render();
	}

	/**
	 * Add a new topic definition at runtime.
	 *
	 * @param {string} pTopicCode - Unique topic code
	 * @param {Object} pTopicDefinition - Topic object: { TopicCode, TopicHelpFilePath, TopicTitle, Routes }
	 */
	addTopic(pTopicCode, pTopicDefinition)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode)
		{
			this.log.warn('InlineDocumentation: addTopic requires a TopicCode.');
			return;
		}

		if (!tmpState.Topics)
		{
			tmpState.Topics = {};
		}

		let tmpDefinition = Object.assign({ TopicCode: pTopicCode }, pTopicDefinition || {});
		tmpState.Topics[pTopicCode] = tmpDefinition;
	}

	/**
	 * Add a route pattern to an existing topic.
	 *
	 * @param {string} pTopicCode - The topic to add the route to
	 * @param {string} pRoutePattern - Route pattern (e.g. '/settings', '/admin/*')
	 */
	addRouteToTopic(pTopicCode, pRoutePattern)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			this.log.warn(`InlineDocumentation: Topic [${pTopicCode}] not found for addRouteToTopic.`);
			return;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];

		if (!tmpTopic.Routes)
		{
			tmpTopic.Routes = [];
		}

		if (tmpTopic.Routes.indexOf(pRoutePattern) < 0)
		{
			tmpTopic.Routes.push(pRoutePattern);
		}
	}

	/**
	 * Get a list of all topics in a UI-friendly array format.
	 *
	 * @returns {Array} Array of { TopicCode, TopicTitle, TopicHelpFilePath, RouteCount }
	 */
	getTopicList()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpResult = [];

		if (!tmpState || !tmpState.Topics)
		{
			return tmpResult;
		}

		let tmpTopicCodes = Object.keys(tmpState.Topics);

		for (let i = 0; i < tmpTopicCodes.length; i++)
		{
			let tmpTopic = tmpState.Topics[tmpTopicCodes[i]];
			tmpResult.push(
			{
				TopicCode: tmpTopicCodes[i],
				TopicTitle: tmpTopic.TopicTitle || tmpTopic.Name || tmpTopicCodes[i],
				TopicHelpFilePath: tmpTopic.TopicHelpFilePath || '',
				RouteCount: (tmpTopic.Routes && Array.isArray(tmpTopic.Routes)) ? tmpTopic.Routes.length : 0
			});
		}

		return tmpResult;
	}

	/**
	 * Update an existing topic definition.
	 *
	 * Merges only the properties present in pUpdates into the topic.
	 *
	 * @param {string} pTopicCode - The topic to update
	 * @param {Object} pUpdates - Properties to merge: { TopicTitle, TopicHelpFilePath, Routes }
	 * @returns {boolean} True if updated, false if topic not found
	 */
	updateTopic(pTopicCode, pUpdates)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			return false;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];
		let tmpUpdates = pUpdates || {};

		if (tmpUpdates.hasOwnProperty('TopicTitle'))
		{
			tmpTopic.TopicTitle = tmpUpdates.TopicTitle;
		}
		if (tmpUpdates.hasOwnProperty('TopicHelpFilePath'))
		{
			tmpTopic.TopicHelpFilePath = tmpUpdates.TopicHelpFilePath;
		}
		if (tmpUpdates.hasOwnProperty('Routes'))
		{
			tmpTopic.Routes = tmpUpdates.Routes;
		}

		return true;
	}

	/**
	 * Remove a topic definition.
	 *
	 * If the removed topic is the currently active topic, clears it.
	 *
	 * @param {string} pTopicCode - The topic to remove
	 * @returns {boolean} True if removed, false if topic not found
	 */
	removeTopic(pTopicCode)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			return false;
		}

		delete tmpState.Topics[pTopicCode];

		// Clear active topic if it was the one removed
		if (tmpState.Topic === pTopicCode)
		{
			tmpState.Topic = null;
		}

		return true;
	}

	/**
	 * Remove a specific route pattern from a topic.
	 *
	 * @param {string} pTopicCode - The topic to modify
	 * @param {string} pRoutePattern - The route pattern to remove
	 * @returns {boolean} True if removed, false if not found
	 */
	removeRouteFromTopic(pTopicCode, pRoutePattern)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			return false;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];

		if (!tmpTopic.Routes || !Array.isArray(tmpTopic.Routes))
		{
			return false;
		}

		let tmpIndex = tmpTopic.Routes.indexOf(pRoutePattern);

		if (tmpIndex < 0)
		{
			return false;
		}

		tmpTopic.Routes.splice(tmpIndex, 1);
		return true;
	}

	/**
	 * Persist the current topics via the onTopicsSave callback.
	 *
	 * If no onTopicsSave handler was provided, succeeds locally.
	 *
	 * @param {Function} [fCallback] - Callback receiving (error)
	 */
	saveTopics(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (typeof this._onTopicsSave === 'function')
		{
			this._onTopicsSave(tmpState.Topics, (pError) =>
			{
				if (pError)
				{
					this.log.warn(`InlineDocumentation: Topics save failed: ${pError}`);
					return tmpCallback(pError);
				}
				return tmpCallback(null);
			});
		}
		else
		{
			// No save handler — succeed locally
			return tmpCallback(null);
		}
	}

	/**
	 * Enable or disable the topic manager UI.
	 *
	 * When enabled, management buttons appear in the navigation toolbar.
	 *
	 * @param {boolean} pEnabled - Whether topic management is available
	 */
	setTopicManagerEnabled(pEnabled)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.TopicManagerEnabled = !!pEnabled;

		// Re-render navigation to show/hide management buttons
		let tmpNavView = this.pict.views['InlineDoc-Nav'];
		if (tmpNavView)
		{
			tmpNavView.render();
		}
	}

	// -- Wildcard builder helpers --

	/**
	 * Split a route into segments with wildcard pattern options.
	 *
	 * For a route like '/books/detail/5', returns:
	 * [
	 *   { Segment: 'books',  Path: '/books',         WildcardPattern: '/books/*',         Index: 0 },
	 *   { Segment: 'detail', Path: '/books/detail',   WildcardPattern: '/books/detail/*',   Index: 1 },
	 *   { Segment: '5',      Path: '/books/detail/5', WildcardPattern: '/books/detail/5/*', Index: 2 }
	 * ]
	 *
	 * @param {string} pRoute - The route to split
	 * @returns {Array} Array of segment objects
	 */
	getRouteSegments(pRoute)
	{
		if (!pRoute || typeof pRoute !== 'string')
		{
			return [];
		}

		// Strip leading slash and split
		let tmpClean = pRoute.replace(/^\//, '');
		if (!tmpClean)
		{
			return [];
		}

		let tmpParts = tmpClean.split('/');
		let tmpSegments = [];

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPath = '/' + tmpParts.slice(0, i + 1).join('/');
			tmpSegments.push(
			{
				Segment: tmpParts[i],
				Path: tmpPath,
				WildcardPattern: tmpPath + '/*',
				Index: i
			});
		}

		return tmpSegments;
	}

	/**
	 * Build a wildcard pattern from a route at a given segment index.
	 *
	 * The wildcard replaces everything after the segment at pSegmentIndex.
	 * For '/books/detail/5' with index 1, returns '/books/detail/*'.
	 *
	 * @param {string} pRoute - The route
	 * @param {number} pSegmentIndex - The segment index (0-based) where the wildcard starts after
	 * @returns {string} The wildcard pattern, or empty string if invalid
	 */
	buildWildcardPattern(pRoute, pSegmentIndex)
	{
		let tmpSegments = this.getRouteSegments(pRoute);

		if (tmpSegments.length < 1 || pSegmentIndex < 0 || pSegmentIndex >= tmpSegments.length)
		{
			return '';
		}

		return tmpSegments[pSegmentIndex].WildcardPattern;
	}

	/**
	 * Get all topics whose Routes match a given route.
	 *
	 * Unlike resolveHelpForRoute (which returns only the best match),
	 * this returns all matching topic codes — useful when multiple
	 * documents are relevant to the same route.
	 *
	 * @param {string} pRoute - The application route
	 * @returns {Array} Array of { TopicCode, Pattern, MatchLength } objects, sorted by match length descending
	 */
	getTopicsForRoute(pRoute)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpMatches = [];

		if (!pRoute || !tmpState.Topics)
		{
			return tmpMatches;
		}

		let tmpTopicCodes = Object.keys(tmpState.Topics);

		for (let i = 0; i < tmpTopicCodes.length; i++)
		{
			let tmpTopic = tmpState.Topics[tmpTopicCodes[i]];

			if (!tmpTopic.Routes || !Array.isArray(tmpTopic.Routes))
			{
				continue;
			}

			for (let j = 0; j < tmpTopic.Routes.length; j++)
			{
				let tmpPattern = tmpTopic.Routes[j];

				if (!tmpPattern)
				{
					continue;
				}

				let tmpMatchLength = 0;
				let tmpIsMatch = false;

				if (tmpPattern.endsWith('/*'))
				{
					let tmpPrefix = tmpPattern.slice(0, -2);
					if (pRoute === tmpPrefix || pRoute.indexOf(tmpPrefix + '/') === 0)
					{
						tmpIsMatch = true;
						tmpMatchLength = tmpPrefix.length;
					}
				}
				else
				{
					if (pRoute === tmpPattern)
					{
						tmpIsMatch = true;
						tmpMatchLength = tmpPattern.length;
					}
				}

				if (tmpIsMatch)
				{
					tmpMatches.push({ TopicCode: tmpTopicCodes[i], Pattern: tmpPattern, MatchLength: tmpMatchLength });
				}
			}
		}

		// Sort by match length descending (best match first)
		tmpMatches.sort((a, b) => b.MatchLength - a.MatchLength);

		return tmpMatches;
	}

	/**
	 * Change the documentation base URL.
	 *
	 * @param {string} pURL - The new base URL
	 */
	setDocsBaseURL(pURL)
	{
		if (!this.pict.AppData.InlineDocumentation)
		{
			this.pict.AppData.InlineDocumentation = {};
		}
		this.pict.AppData.InlineDocumentation.DocsBaseURL = pURL || '';
		// Clear cache when base URL changes
		this._ContentCache = {};
	}

	/**
	 * Get the navigation history.
	 *
	 * @returns {Array} Array of visited document paths
	 */
	getNavigationHistory()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		return (tmpState && tmpState.NavigationHistory) ? tmpState.NavigationHistory : [];
	}

	/**
	 * Navigate back to the previous document.
	 *
	 * @param {Function} [fCallback] - Callback when navigation is complete
	 */
	navigateBack(fCallback)
	{
		let tmpHistory = this.getNavigationHistory();

		if (tmpHistory.length < 2)
		{
			return;
		}

		// Remove current page
		tmpHistory.pop();
		// Get previous page
		let tmpPreviousPath = tmpHistory.pop();

		this.loadDocument(tmpPreviousPath, fCallback);
	}

	// -- Edit mode --

	/**
	 * Enable or disable edit permissions.
	 *
	 * When enabled, a pencil icon appears in the content area allowing
	 * the user to toggle into edit mode.
	 *
	 * @param {boolean} pEnabled - Whether edit mode is available
	 */
	setEditEnabled(pEnabled)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.EditEnabled = !!pEnabled;

		// If TopicManagerEnabled was not explicitly configured, mirror EditEnabled
		if (!this._topicManagerExplicitlySet)
		{
			tmpState.TopicManagerEnabled = !!pEnabled;

			// Re-render navigation to show/hide management buttons
			let tmpNavView = this.pict.views['InlineDoc-Nav'];
			if (tmpNavView)
			{
				tmpNavView.render();
			}
		}

		// Re-render content view to show/hide edit toolbar
		let tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView)
		{
			tmpContentView.renderEditToolbar();
		}
	}

	/**
	 * Toggle between view and edit mode.
	 */
	toggleEdit()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (tmpState.Editing)
		{
			this.cancelEdit();
		}
		else
		{
			this.beginEdit();
		}
	}

	/**
	 * Enter edit mode for the current document.
	 *
	 * Retrieves the raw markdown from cache and displays it in the markdown editor.
	 */
	beginEdit()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpState.EditEnabled || !tmpState.CurrentPath)
		{
			return;
		}

		// Get the raw markdown from cache
		let tmpURL = (tmpState.DocsBaseURL || '') + tmpState.CurrentPath;
		let tmpCacheEntry = this._ContentCache[tmpURL];
		let tmpMarkdown = (tmpCacheEntry && tmpCacheEntry.markdown) ? tmpCacheEntry.markdown : '';

		tmpState.Editing = true;
		tmpState.EditingPath = tmpState.CurrentPath;
		tmpState.EditingContent = tmpMarkdown;

		// Show the editor
		let tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView)
		{
			tmpContentView.showEditor(tmpMarkdown);
		}
	}

	/**
	 * Cancel editing and restore the rendered view.
	 */
	cancelEdit()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		tmpState.Editing = false;
		tmpState.EditingPath = '';
		tmpState.EditingContent = '';
		tmpState.EditorSegments = [];

		// Restore the rendered content
		let tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView)
		{
			tmpContentView.hideEditor();

			// Re-display the cached HTML
			let tmpURL = (tmpState.DocsBaseURL || '') + tmpState.CurrentPath;
			let tmpCacheEntry = this._ContentCache[tmpURL];
			if (tmpCacheEntry && tmpCacheEntry.html)
			{
				tmpContentView.displayContent(tmpCacheEntry.html);
			}
		}
	}

	/**
	 * Save the current edits.
	 *
	 * Reads the markdown editor content, calls the onSave callback provided by the
	 * host app, re-parses the markdown, and returns to view mode.
	 *
	 * @param {Function} [fCallback] - Callback receiving (error)
	 */
	saveEdit(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpContentView = this.pict.views['InlineDoc-Content'];

		if (!tmpState.Editing)
		{
			return tmpCallback('Not in edit mode');
		}

		// Read content from the markdown editor
		// First marshal editor state to data, then read from the data address
		let tmpMarkdown = '';
		let tmpEditorView = this.pict.views['InlineDoc-MarkdownEditor'];
		if (tmpEditorView && typeof tmpEditorView.marshalFromView === 'function')
		{
			tmpEditorView.marshalFromView();
		}
		if (tmpState.EditorSegments && tmpState.EditorSegments.length > 0)
		{
			tmpMarkdown = tmpState.EditorSegments[0].Content || '';
		}

		let tmpPath = tmpState.EditingPath;
		let tmpURL = (tmpState.DocsBaseURL || '') + tmpPath;

		let tmpSaveData = { Path: tmpPath, Content: tmpMarkdown };

		let tmpFinishSave = () =>
		{
			// Re-parse the markdown and update cache
			let tmpHTML = this._ContentProvider.parseMarkdown(
				tmpMarkdown,
				this._createLinkResolver(),
				this._createImageResolver(tmpURL),
				this._VocabularyResolver);
			this._ContentCache[tmpURL] = { html: tmpHTML, markdown: tmpMarkdown };

			// Exit edit mode
			tmpState.Editing = false;
			tmpState.EditingPath = '';
			tmpState.EditingContent = '';
			tmpState.EditorSegments = [];

			// Display the updated content
			if (tmpContentView)
			{
				tmpContentView.hideEditor();
				tmpContentView.displayContent(tmpHTML);
			}

			return tmpCallback(null);
		};

		// Call the onSave callback if provided
		if (typeof this._onSave === 'function')
		{
			this._onSave(tmpSaveData, (pError) =>
			{
				if (pError)
				{
					this.log.warn(`InlineDocumentation: Save failed: ${pError}`);
					return tmpCallback(pError);
				}
				tmpFinishSave();
			});
		}
		else
		{
			// No save handler — just update locally
			tmpFinishSave();
		}
	}

	// -- Route-based help --

	/**
	 * Find the best-matching topic for a given route.
	 *
	 * Iterates all topics looking for ones with a Routes array. Supports
	 * exact match and wildcard suffix (e.g. "/books/store/*" matches
	 * "/books/store/123"). Returns the TopicCode with the longest matching
	 * route pattern, or null if no match.
	 *
	 * @param {string} pRoute - The application route (e.g. '/books/store/5')
	 * @returns {string|null} The TopicCode of the best match, or null
	 */
	resolveHelpForRoute(pRoute)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pRoute || !tmpState.Topics)
		{
			return null;
		}

		let tmpBestMatch = null;
		let tmpBestLength = -1;

		let tmpTopicCodes = Object.keys(tmpState.Topics);

		for (let i = 0; i < tmpTopicCodes.length; i++)
		{
			let tmpTopic = tmpState.Topics[tmpTopicCodes[i]];

			if (!tmpTopic.Routes || !Array.isArray(tmpTopic.Routes))
			{
				continue;
			}

			for (let j = 0; j < tmpTopic.Routes.length; j++)
			{
				let tmpPattern = tmpTopic.Routes[j];

				if (!tmpPattern)
				{
					continue;
				}

				let tmpMatches = false;
				let tmpMatchLength = 0;

				if (tmpPattern.endsWith('/*'))
				{
					// Wildcard suffix — match if route starts with prefix
					let tmpPrefix = tmpPattern.slice(0, -2);
					if (pRoute === tmpPrefix || pRoute.indexOf(tmpPrefix + '/') === 0)
					{
						tmpMatches = true;
						tmpMatchLength = tmpPrefix.length;
					}
				}
				else
				{
					// Exact match
					if (pRoute === tmpPattern)
					{
						tmpMatches = true;
						tmpMatchLength = tmpPattern.length;
					}
				}

				if (tmpMatches && tmpMatchLength > tmpBestLength)
				{
					tmpBestMatch = tmpTopicCodes[i];
					tmpBestLength = tmpMatchLength;
				}
			}
		}

		return tmpBestMatch;
	}

	/**
	 * Navigate help to the topic matching a given route.
	 *
	 * Convenience method: resolves the route to a topic, then loads it.
	 * If no topic matches, does nothing.
	 *
	 * @param {string} pRoute - The application route
	 * @param {Function} [fCallback] - Callback receiving (error, htmlContent)
	 * @returns {boolean} True if a matching topic was found
	 */
	navigateToRoute(pRoute, fCallback)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.CurrentRoute = pRoute || '';

		let tmpTopicCode = this.resolveHelpForRoute(pRoute);

		if (tmpTopicCode)
		{
			this.loadTopicDocument(tmpTopicCode, fCallback);
			return true;
		}

		return false;
	}

	// -- Tooltip placeholders --

	/**
	 * Enable or disable tooltip edit mode.
	 *
	 * When enabled, all tooltip placeholders are visible and clickable
	 * for content editors to author tooltip content. When disabled,
	 * only placeholders with content show tooltips on hover.
	 *
	 * Automatically re-scans tooltips after toggling.
	 *
	 * @param {boolean} pEnabled - Whether tooltip edit mode is active
	 */
	setTooltipEditMode(pEnabled)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpState)
		{
			return;
		}

		tmpState.TooltipEditMode = !!pEnabled;
		this.scanTooltips();
	}

	/**
	 * Get the tooltip content for a key from the active topic.
	 *
	 * Looks up the currently active topic's Tooltips hash for the
	 * given key and returns the Content string, or null if not found.
	 *
	 * @param {string} pTooltipKey - The tooltip key (from data-d-tooltip attribute)
	 * @returns {string|null} The tooltip content, or null
	 */
	getTooltipContent(pTooltipKey)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTooltipKey || !tmpState || !tmpState.Topic || !tmpState.Topics)
		{
			return null;
		}

		let tmpTopic = tmpState.Topics[tmpState.Topic];

		if (!tmpTopic || !tmpTopic.Tooltips || !tmpTopic.Tooltips[pTooltipKey])
		{
			return null;
		}

		return tmpTopic.Tooltips[pTooltipKey].Content || null;
	}

	/**
	 * Set tooltip content for a key on the active topic.
	 *
	 * Lazily creates the Tooltips hash on the topic if needed.
	 * Passing null or empty string removes the tooltip entry.
	 *
	 * @param {string} pTooltipKey - The tooltip key
	 * @param {string|null} pContent - The markdown content, or null to remove
	 * @returns {boolean} True if set, false if no active topic
	 */
	setTooltipContent(pTooltipKey, pContent)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTooltipKey || !tmpState || !tmpState.Topic || !tmpState.Topics)
		{
			return false;
		}

		let tmpTopic = tmpState.Topics[tmpState.Topic];

		if (!tmpTopic)
		{
			return false;
		}

		if (!pContent)
		{
			// Remove the entry
			if (tmpTopic.Tooltips && tmpTopic.Tooltips[pTooltipKey])
			{
				delete tmpTopic.Tooltips[pTooltipKey];
			}
			return true;
		}

		// Lazily create Tooltips hash
		if (!tmpTopic.Tooltips)
		{
			tmpTopic.Tooltips = {};
		}

		tmpTopic.Tooltips[pTooltipKey] = { Content: pContent };
		return true;
	}

	/**
	 * Remove all active tooltip bindings from the DOM.
	 *
	 * Destroys tooltip handles, removes click listeners, removes
	 * injected icons, and restores original element state.
	 */
	clearTooltipBindings()
	{
		for (let i = 0; i < this._ActiveTooltipBindings.length; i++)
		{
			let tmpBinding = this._ActiveTooltipBindings[i];

			// Destroy the modal tooltip handle
			if (tmpBinding.TooltipHandle && typeof tmpBinding.TooltipHandle.destroy === 'function')
			{
				tmpBinding.TooltipHandle.destroy();
			}

			// Remove click handler
			if (tmpBinding.ClickHandler && tmpBinding.Element)
			{
				tmpBinding.Element.removeEventListener('click', tmpBinding.ClickHandler);
			}

			// Remove injected icon
			if (tmpBinding.InjectedIcon && tmpBinding.InjectedIcon.parentNode)
			{
				tmpBinding.InjectedIcon.parentNode.removeChild(tmpBinding.InjectedIcon);
			}

			// Remove edit-mode CSS classes
			if (tmpBinding.Element)
			{
				tmpBinding.Element.classList.remove(
					'pict-inline-doc-tooltip-edit-target',
					'pict-inline-doc-tooltip-empty');
			}

			// Restore original display for hidden icon spans
			if (tmpBinding.OriginalDisplay !== undefined && tmpBinding.Element)
			{
				tmpBinding.Element.style.display = tmpBinding.OriginalDisplay;
			}
		}

		this._ActiveTooltipBindings = [];

		// Remove document-level help link handler
		if (this._tooltipHelpLinkHandler && typeof document !== 'undefined')
		{
			document.removeEventListener('click', this._tooltipHelpLinkHandler);
			this._tooltipHelpLinkHandler = null;
		}
	}

	/**
	 * Scan the document for tooltip placeholder elements and wire them up.
	 *
	 * Finds all elements with data-d-tooltip attributes and:
	 * - In normal mode: attaches hover tooltips for those with content
	 * - In edit mode: adds visual indicators and click-to-edit handlers
	 *
	 * Call this after your application views render.
	 */
	scanTooltips()
	{
		this.clearTooltipBindings();

		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpState)
		{
			return;
		}

		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpElements = document.querySelectorAll('[data-d-tooltip]');
		let tmpEditMode = tmpState.TooltipEditMode || false;

		for (let i = 0; i < tmpElements.length; i++)
		{
			let tmpElement = tmpElements[i];
			let tmpKey = tmpElement.getAttribute('data-d-tooltip');

			if (!tmpKey)
			{
				continue;
			}

			let tmpContent = this.getTooltipContent(tmpKey);
			let tmpIsIcon = tmpElement.hasAttribute('data-d-tooltip-icon');

			let tmpBinding =
			{
				Element: tmpElement,
				Key: tmpKey,
				Type: tmpIsIcon ? 'icon' : 'attribute',
				TooltipHandle: null,
				ClickHandler: null,
				InjectedIcon: null,
				OriginalDisplay: undefined
			};

			if (tmpEditMode)
			{
				this._wireTooltipEditMode(tmpElement, tmpKey, tmpContent, tmpIsIcon, tmpBinding, tmpModal);
			}
			else
			{
				this._wireTooltipNormalMode(tmpElement, tmpKey, tmpContent, tmpIsIcon, tmpBinding, tmpModal);
			}

			this._ActiveTooltipBindings.push(tmpBinding);
		}

		// Install document-level click delegation for help: links in tooltips
		this._installTooltipHelpLinkHandler();
	}

	/**
	 * Install a document-level click handler for help links inside tooltips.
	 *
	 * Tooltip elements are created/destroyed dynamically by the modal system,
	 * so we use event delegation on the document to catch clicks on
	 * [rel^="pict-inline-doc-help:"] links wherever they appear.
	 */
	_installTooltipHelpLinkHandler()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		// Remove existing handler if any
		if (this._tooltipHelpLinkHandler)
		{
			document.removeEventListener('click', this._tooltipHelpLinkHandler);
		}

		let tmpSelf = this;

		this._tooltipHelpLinkHandler = (pEvent) =>
		{
			let tmpTarget = pEvent.target;

			// Walk up to find the link element
			while (tmpTarget && tmpTarget !== document)
			{
				if (tmpTarget.tagName === 'A' && tmpTarget.getAttribute('rel') && tmpTarget.getAttribute('rel').indexOf('pict-inline-doc-help:') === 0)
				{
					pEvent.preventDefault();
					pEvent.stopPropagation();

					let tmpPath = tmpTarget.getAttribute('rel').replace('pict-inline-doc-help:', '');
					tmpSelf.loadDocument(tmpPath);
					return;
				}
				tmpTarget = tmpTarget.parentNode;
			}
		};

		document.addEventListener('click', this._tooltipHelpLinkHandler);
	}

	/**
	 * Wire a tooltip element for normal (non-edit) mode.
	 *
	 * @param {HTMLElement} pElement - The placeholder element
	 * @param {string} pKey - The tooltip key
	 * @param {string|null} pContent - The tooltip content (or null)
	 * @param {boolean} pIsIcon - Whether this is an icon-type placeholder
	 * @param {Object} pBinding - The binding tracking object
	 * @param {Object} pModal - The modal view instance
	 */
	_wireTooltipNormalMode(pElement, pKey, pContent, pIsIcon, pBinding, pModal)
	{
		if (pIsIcon)
		{
			if (pContent)
			{
				// Inject an icon and attach tooltip
				let tmpIcon = this._createTooltipIcon(pElement);
				pBinding.InjectedIcon = tmpIcon;

				if (pModal && pModal.richTooltip)
				{
					let tmpHTML = this._ContentProvider.parseMarkdown(pContent, this._createTooltipLinkResolver());
					pBinding.TooltipHandle = pModal.richTooltip(pElement, tmpHTML, { interactive: true, maxWidth: '350px' });
				}
			}
			else
			{
				// No content — hide the span
				pBinding.OriginalDisplay = pElement.style.display;
				pElement.style.display = 'none';
			}
		}
		else
		{
			// Attribute tooltip
			if (pContent && pModal && pModal.richTooltip)
			{
				let tmpHTML = this._ContentProvider.parseMarkdown(pContent, this._createTooltipLinkResolver());
				pBinding.TooltipHandle = pModal.richTooltip(pElement, tmpHTML, { interactive: true, maxWidth: '350px' });
			}
			// No content = do nothing, element stays as-is
		}
	}

	/**
	 * Wire a tooltip element for edit mode.
	 *
	 * @param {HTMLElement} pElement - The placeholder element
	 * @param {string} pKey - The tooltip key
	 * @param {string|null} pContent - The tooltip content (or null)
	 * @param {boolean} pIsIcon - Whether this is an icon-type placeholder
	 * @param {Object} pBinding - The binding tracking object
	 * @param {Object} pModal - The modal view instance
	 */
	_wireTooltipEditMode(pElement, pKey, pContent, pIsIcon, pBinding, pModal)
	{
		// Add edit-mode indicator class
		pElement.classList.add('pict-inline-doc-tooltip-edit-target');

		if (pIsIcon)
		{
			// Always show icon in edit mode
			let tmpIcon = this._createTooltipIcon(pElement);
			pBinding.InjectedIcon = tmpIcon;

			if (!pContent)
			{
				pElement.classList.add('pict-inline-doc-tooltip-empty');
			}
		}

		// Click handler to open editor
		let tmpSelf = this;
		let tmpClickHandler = (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			tmpSelf._showTooltipEditor(pKey);
		};

		pElement.addEventListener('click', tmpClickHandler);
		pBinding.ClickHandler = tmpClickHandler;
	}

	/**
	 * Create and inject a tooltip icon element into a span.
	 *
	 * @param {HTMLElement} pElement - The span element to inject into
	 * @returns {HTMLElement} The created icon element
	 */
	_createTooltipIcon(pElement)
	{
		let tmpIcon = document.createElement('span');
		tmpIcon.className = 'pict-inline-doc-tooltip-icon';

		// Check for custom icon class
		let tmpCustomClass = pElement.getAttribute('data-d-tooltip-icon');
		if (tmpCustomClass && tmpCustomClass !== '')
		{
			tmpIcon.className += ' ' + tmpCustomClass;
		}
		else
		{
			tmpIcon.innerHTML = '&#x2753;';
		}

		pElement.appendChild(tmpIcon);
		return tmpIcon;
	}

	/**
	 * Show the tooltip content editor modal.
	 *
	 * @param {string} pTooltipKey - The tooltip key to edit
	 */
	_showTooltipEditor(pTooltipKey)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];

		if (!tmpModal)
		{
			return;
		}

		let tmpCurrentContent = this.getTooltipContent(pTooltipKey) || '';
		let tmpSelf = this;

		let tmpEditorHTML = '<div class="pict-inline-doc-tm-form-group">';
		tmpEditorHTML += '<label class="pict-inline-doc-tm-form-label">Tooltip Key</label>';
		tmpEditorHTML += '<div style="font-family:monospace;font-size:0.85em;color:var(--theme-color-text-muted, #8A7F72);padding:0.3em 0;">' + this._escapeTooltipHTML(pTooltipKey) + '</div>';
		tmpEditorHTML += '</div>';
		tmpEditorHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpEditorHTML += '<label class="pict-inline-doc-tm-form-label">Content (Markdown)</label>';
		tmpEditorHTML += '<textarea class="pict-inline-doc-tooltip-editor-textarea" id="InlineDoc-Tooltip-Editor-Textarea">' + this._escapeTooltipHTML(tmpCurrentContent) + '</textarea>';
		tmpEditorHTML += '</div>';
		tmpEditorHTML += '<div class="pict-inline-doc-tooltip-preview-label">Preview</div>';
		tmpEditorHTML += '<div class="pict-inline-doc-tooltip-preview" id="InlineDoc-Tooltip-Editor-Preview"></div>';

		tmpModal.show(
		{
			title: 'Edit Tooltip',
			content: tmpEditorHTML,
			closeable: true,
			width: '480px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				let tmpTextarea = document.getElementById('InlineDoc-Tooltip-Editor-Textarea');
				let tmpPreview = document.getElementById('InlineDoc-Tooltip-Editor-Preview');

				if (tmpTextarea && tmpPreview)
				{
					// Initial preview
					let tmpLinkResolver = tmpSelf._createTooltipLinkResolver();
					let tmpInitialHTML = tmpCurrentContent ? tmpSelf._ContentProvider.parseMarkdown(tmpCurrentContent, tmpLinkResolver) : '<span style="color:var(--theme-color-text-muted, #8A7F72);">No content yet.</span>';
					tmpPreview.innerHTML = tmpInitialHTML;

					// Live preview on input
					tmpTextarea.addEventListener('input', () =>
					{
						let tmpValue = tmpTextarea.value.trim();
						if (tmpValue)
						{
							tmpPreview.innerHTML = tmpSelf._ContentProvider.parseMarkdown(tmpValue, tmpLinkResolver);
						}
						else
						{
							tmpPreview.innerHTML = '<span style="color:var(--theme-color-text-muted, #8A7F72);">No content yet.</span>';
						}
					});

					tmpTextarea.focus();
				}
			}
		}).then((pResult) =>
		{
			if (pResult === 'save')
			{
				let tmpTextarea = document.getElementById('InlineDoc-Tooltip-Editor-Textarea');
				let tmpNewContent = tmpTextarea ? tmpTextarea.value.trim() : '';

				tmpSelf.setTooltipContent(pTooltipKey, tmpNewContent || null);
				tmpSelf.saveTopics();
				tmpSelf.scanTooltips();

				if (tmpModal.toast)
				{
					tmpModal.toast('Tooltip saved.', { type: 'success' });
				}
			}
		});
	}

	/**
	 * Escape HTML for safe insertion into tooltip editor.
	 *
	 * @param {string} pText - Text to escape
	 * @returns {string} Escaped text
	 */
	_escapeTooltipHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	// -- Image upload --

	/**
	 * Wire the onImageUpload handler onto the markdown editor view.
	 *
	 * Overrides the editor's onImageUpload method so that when a user
	 * drops or pastes an image, it is routed through the host app's
	 * onImageUpload callback with the current document path for context.
	 *
	 * The host callback signature is:
	 *   onImageUpload(pFile, pDocumentPath, fCallback)
	 * where fCallback is fCallback(pError, pRelativeURL).
	 */
	_wireEditorImageUpload()
	{
		let tmpSelf = this;
		let tmpEditorView = this.pict.views['InlineDoc-MarkdownEditor'];

		if (!tmpEditorView)
		{
			return;
		}

		tmpEditorView.onImageUpload = (pFile, pSegmentIndex, fCallback) =>
		{
			if (typeof tmpSelf._onImageUpload !== 'function')
			{
				return false;
			}

			let tmpState = tmpSelf.pict.AppData.InlineDocumentation;
			let tmpDocumentPath = (tmpState && tmpState.EditingPath) ? tmpState.EditingPath : '';

			tmpSelf._onImageUpload(pFile, tmpDocumentPath, (pError, pURL) =>
			{
				if (pError)
				{
					tmpSelf.log.warn(`InlineDocumentation: Image upload failed: ${pError}`);
				}
				fCallback(pError, pURL);
			});

			return true;
		};
	}

	/**
	 * Scroll the content area to a heading that matches an anchor string.
	 *
	 * Looks for headings (h1-h6) in the content body whose text, when
	 * slugified, matches the anchor. Uses the standard GitHub-style
	 * slugification: lowercase, spaces to hyphens, strip non-alphanumeric.
	 *
	 * @param {string} pAnchor - The anchor string (without #)
	 */
	_scrollToAnchor(pAnchor)
	{
		if (typeof document === 'undefined' || !pAnchor)
		{
			return;
		}

		// Delay slightly to ensure content is rendered
		setTimeout(() =>
		{
			let tmpContentBody = document.getElementById('InlineDoc-Content-Body');
			if (!tmpContentBody)
			{
				return;
			}

			let tmpSlug = pAnchor.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

			// Check for an element with a matching id first
			let tmpTarget = tmpContentBody.querySelector('#' + CSS.escape(tmpSlug));

			// If no id match, search heading text
			if (!tmpTarget)
			{
				let tmpHeadings = tmpContentBody.querySelectorAll('h1, h2, h3, h4, h5, h6');
				for (let i = 0; i < tmpHeadings.length; i++)
				{
					let tmpHeadingText = tmpHeadings[i].textContent || '';
					let tmpHeadingSlug = tmpHeadingText.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
					if (tmpHeadingSlug === tmpSlug)
					{
						tmpTarget = tmpHeadings[i];
						break;
					}
				}
			}

			if (tmpTarget)
			{
				tmpTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		}, 50);
	}

	// ================================================================
	// Full-text search
	// ================================================================

	/**
	 * Load a lunr.js keyword index from a URL.
	 *
	 * The index file is the same format generated by Indoctrinate's
	 * generate_keyword_index command: { LunrIndex, Documents, DocumentCount }.
	 *
	 * @param {string} pURL - URL to the retold-keyword-index.json file
	 * @param {Function} [fCallback] - Callback when done
	 */
	_loadSearchIndex(pURL, fCallback)
	{
		let tmpCallback = (typeof fCallback === 'function') ? fCallback : () => {};
		let tmpSelf = this;

		if (typeof fetch === 'undefined')
		{
			return tmpCallback();
		}

		fetch(pURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.json();
			})
			.then((pIndexData) =>
			{
				if (!pIndexData || !pIndexData.LunrIndex || !pIndexData.Documents)
				{
					if (tmpSelf.log) tmpSelf.log.info('InlineDocumentation: No keyword index found; search unavailable.');
					return tmpCallback();
				}

				try
				{
					tmpSelf._LunrIndex = libLunr.Index.load(pIndexData.LunrIndex);
					tmpSelf._SearchDocuments = pIndexData.Documents;

					let tmpState = tmpSelf.pict.AppData.InlineDocumentation;
					if (tmpState)
					{
						tmpState.SearchIndexLoaded = true;
					}

					if (tmpSelf.log) tmpSelf.log.info('InlineDocumentation: Search index loaded (' + (pIndexData.DocumentCount || 0) + ' documents).');
				}
				catch (pError)
				{
					if (tmpSelf.log) tmpSelf.log.warn('InlineDocumentation: Error hydrating lunr index: ' + pError);
				}

				return tmpCallback();
			})
			.catch((pError) =>
			{
				if (tmpSelf.log) tmpSelf.log.warn('InlineDocumentation: Error loading search index: ' + pError);
				return tmpCallback();
			});
	}

	/**
	 * Search the loaded lunr index.
	 *
	 * @param {string} pQuery - The search query
	 * @returns {Array} Array of { Key, Title, Group, DocPath, Score }
	 */
	search(pQuery)
	{
		if (!this._LunrIndex || !this._SearchDocuments || !pQuery || !pQuery.trim())
		{
			return [];
		}

		let tmpResults = [];

		try
		{
			let tmpLunrResults = this._LunrIndex.search(pQuery);

			for (let i = 0; i < tmpLunrResults.length; i++)
			{
				let tmpRef = tmpLunrResults[i].ref;
				let tmpScore = tmpLunrResults[i].score;
				let tmpDoc = this._SearchDocuments[tmpRef];

				if (!tmpDoc)
				{
					continue;
				}

				tmpResults.push(
				{
					Key: tmpRef,
					Title: tmpDoc.Title || tmpRef,
					Group: tmpDoc.Group || '',
					Module: tmpDoc.Module || '',
					DocPath: tmpDoc.DocPath || tmpRef,
					Score: tmpScore
				});
			}
		}
		catch (pError)
		{
			if (this.log) this.log.warn('InlineDocumentation: Search error: ' + pError);
		}

		return tmpResults;
	}

	// ================================================================
	// External link resolution (catalog-based)
	// ================================================================

	/**
	 * Check if a path is an external reference.
	 *
	 * Paths that started with / in the sidebar are cross-module
	 * references. They get normalized during parsing (leading /
	 * stripped), but they contain 2+ path segments (group/module/).
	 * Simple filenames like README.md are local.
	 *
	 * An ExternalDocBaseURL must be configured for this to return true.
	 *
	 * @param {string} pPath - The normalized document path
	 * @returns {boolean}
	 */
	isExternalPath(pPath)
	{
		if (!pPath) return false;

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState || !tmpState.ExternalDocBaseURL) return false;

		// Paths with 2+ segments (e.g., pict/pict/, fable/fable/)
		// are cross-module references. Simple filenames are local.
		let tmpPath = pPath.replace(/^\.\//, '').replace(/^\//, '');
		let tmpParts = tmpPath.split('/').filter((p) => p.length > 0);
		return tmpParts.length >= 2;
	}

	/**
	 * Resolve an external path to a full URL.
	 *
	 * @param {string} pPath - The document path
	 * @returns {string|null} The external URL, or null if not external
	 */
	resolveExternalURL(pPath)
	{
		if (!this.isExternalPath(pPath)) return null;

		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpBaseURL = (tmpState && tmpState.ExternalDocBaseURL) || '';
		if (!tmpBaseURL) return null;

		let tmpPath = pPath.replace(/^\.\//, '').replace(/^\//, '');
		return tmpBaseURL + tmpPath;
	}

	/**
	 * After sidebar is loaded, mark items that are external
	 * references with External: true and ExternalURL.
	 */
	_markExternalSidebarItems()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState || !tmpState.ExternalDocBaseURL) return;

		let tmpGroups = tmpState.SidebarGroups || [];
		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpItems = tmpGroups[i].Items || [];
			for (let j = 0; j < tmpItems.length; j++)
			{
				let tmpItem = tmpItems[j];
				if (this.isExternalPath(tmpItem.Path))
				{
					tmpItem.External = true;
					tmpItem.ExternalURL = this.resolveExternalURL(tmpItem.Path);
				}
			}
		}
	}

	/**
	 * Extract h2 and h3 headings from the rendered content body.
	 *
	 * Queries #InlineDoc-Content-Body for heading elements, extracts
	 * their text, generates slugified IDs for anchor scrolling, and
	 * stores the results in AppData for the nav outline.
	 *
	 * @returns {Array} Array of { Text, Slug, Level }
	 */
	_extractHeadings()
	{
		let tmpHeadings = [];

		if (typeof document === 'undefined')
		{
			return tmpHeadings;
		}

		let tmpContentBody = document.getElementById('InlineDoc-Content-Body');
		if (!tmpContentBody)
		{
			return tmpHeadings;
		}

		let tmpElements = tmpContentBody.querySelectorAll('h2, h3');

		for (let i = 0; i < tmpElements.length; i++)
		{
			let tmpElement = tmpElements[i];
			let tmpText = (tmpElement.textContent || '').trim();
			let tmpLevel = parseInt(tmpElement.tagName.substring(1), 10);
			let tmpSlug = tmpText.toLowerCase()
				.replace(/[^a-z0-9\s-]/g, '')
				.replace(/\s+/g, '-')
				.replace(/-+/g, '-');

			// Assign the ID to the heading element if not already set
			// so scrollIntoView can find it
			if (!tmpElement.id)
			{
				tmpElement.id = tmpSlug;
			}

			tmpHeadings.push({ Text: tmpText, Slug: tmpSlug, Level: tmpLevel });
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (tmpState)
		{
			tmpState.ActiveDocumentHeadings = tmpHeadings;
		}

		return tmpHeadings;
	}

	// -- Internal methods --

	/**
	 * Fetch a markdown document and convert it to HTML.
	 *
	 * @param {string} pURL - The URL to fetch
	 * @param {Function} fCallback - Callback receiving (error, htmlContent)
	 */
	_fetchDocument(pURL, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};

		if (!pURL)
		{
			return tmpCallback('No URL provided', '');
		}

		// Check cache
		if (this._ContentCache[pURL])
		{
			return tmpCallback(null, this._ContentCache[pURL].html);
		}

		fetch(pURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					return tmpCallback('Document not found', '');
				}

				let tmpHTML = this._ContentProvider.parseMarkdown(
					pMarkdown,
					this._createLinkResolver(),
					this._createImageResolver(pURL),
					this._VocabularyResolver);
				this._ContentCache[pURL] = { html: tmpHTML, markdown: pMarkdown };
				return tmpCallback(null, tmpHTML);
			})
			.catch((pError) =>
			{
				this.log.warn(`InlineDocumentation: Error fetching [${pURL}]: ${pError}`);
				return tmpCallback(pError, '');
			});
	}

	/**
	 * Create a link resolver that converts internal doc links to provider API calls.
	 *
	 * Internal links (relative .md paths) get converted to javascript:void(0) with
	 * a data attribute so the content view's click handler can intercept them and
	 * call loadDocument().
	 *
	 * @returns {Function} A link resolver callback
	 */
	_createLinkResolver()
	{
		return (pHref, pLinkText) =>
		{
			// Only intercept internal markdown links
			if (pHref.match(/^https?:\/\//))
			{
				// External link — open in new tab
				return { href: pHref, target: '_blank', rel: 'noopener' };
			}

			// help: prefix — internal documentation link (e.g. help:book-list.md#section)
			if (pHref.match(/^help:/))
			{
				let tmpHelpPath = pHref.replace(/^help:/, '');
				return {
					href: 'javascript:void(0)',
					target: '',
					rel: 'pict-inline-doc-link:' + tmpHelpPath
				};
			}

			// Internal doc link — mark for interception. Strip a route-style prefix ("#/page/foo.md")
			// so the rel carries a clean doc path; otherwise loadDocument() reads the leading "#" as an
			// anchor delimiter and fails to resolve the document (body cross-links would 404).
			let tmpPath = pHref.replace(/^#\/page\//, '').replace(/^#\//, '').replace(/^\.\//, '').replace(/^\//, '');
			return {
				href: 'javascript:void(0)',
				// Use a data attribute for the click handler
				// The content view will wire up click interception
				target: '',
				rel: 'pict-inline-doc-link:' + tmpPath
			};
		};
	}

	/**
	 * Create a link resolver for tooltip content.
	 *
	 * Handles help:path.md#anchor links that open documents in the help
	 * panel. These links get a special rel attribute so click handlers
	 * can intercept them.
	 *
	 * External links open in a new tab. All other links are treated as
	 * help: links within the tooltip context.
	 *
	 * @returns {Function} A link resolver callback
	 */
	_createTooltipLinkResolver()
	{
		return (pHref, pLinkText) =>
		{
			// External links — open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return { href: pHref, target: '_blank', rel: 'noopener' };
			}

			// Strip help: prefix if present
			let tmpPath = pHref.replace(/^help:/, '');
			// Clean relative prefixes
			tmpPath = tmpPath.replace(/^\.\//, '').replace(/^\//, '');

			return {
				href: 'javascript:void(0)',
				target: '',
				rel: 'pict-inline-doc-help:' + tmpPath
			};
		};
	}

	/**
	 * Create an image resolver closure.
	 *
	 * @param {string} pDocURL - The URL the document was fetched from
	 * @returns {Function} An image resolver callback
	 */
	_createImageResolver(pDocURL)
	{
		let tmpBaseDir = '';
		if (pDocURL)
		{
			let tmpLastSlash = pDocURL.lastIndexOf('/');
			if (tmpLastSlash >= 0)
			{
				tmpBaseDir = pDocURL.substring(0, tmpLastSlash + 1);
			}
		}

		return (pSrc, pAlt) =>
		{
			if (pSrc.match(/^https?:\/\//) || pSrc.match(/^data:/) || pSrc.match(/^\//))
			{
				return pSrc;
			}
			return tmpBaseDir + pSrc;
		};
	}

	// ── "show non-document files" preference (persisted per browser) ──────────
	_showAssetFilesStorageKey() { return 'pict-inline-doc-show-asset-files'; }
	_readShowAssetFilesPref()
	{
		try { return (typeof localStorage !== 'undefined') && localStorage.getItem(this._showAssetFilesStorageKey()) === '1'; }
		catch (pError) { return false; }
	}
	_writeShowAssetFilesPref(pOn)
	{
		try { if (typeof localStorage !== 'undefined') { localStorage.setItem(this._showAssetFilesStorageKey(), pOn ? '1' : '0'); } }
		catch (pError) { /* storage unavailable - the choice just does not persist */ }
	}

	/**
	 * Flip the "show non-document files" preference, persist it, and reload the tree so the asset
	 * files appear or disappear. The Nav toolbar toggle calls this.
	 */
	toggleAssetFiles()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.ShowAssetFiles = !tmpState.ShowAssetFiles;
		this._writeShowAssetFilesPref(tmpState.ShowAssetFiles);
		this.reloadSidebar();
	}

	/**
	 * Load and parse _sidebar.md from the docs base URL.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	_loadSidebar(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpDocsBase = tmpState.DocsBaseURL || '';
		// When the reader is showing asset files, ask the server for the full tree; otherwise it
		// returns documents only (a server that does not honor the param simply returns everything).
		let tmpQuery = tmpState.ShowAssetFiles ? '?files=all' : '';

		fetch(tmpDocsBase + '_sidebar.md' + tmpQuery)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('InlineDocumentation: No _sidebar.md found.');
					return tmpCallback();
				}

				tmpState.SidebarGroups = this._parseSidebarMarkdown(pMarkdown);
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`InlineDocumentation: Error loading _sidebar.md: ${pError}`);
				return tmpCallback();
			});
	}

	// ================================================================
	// Structure management (folders, move, reorder, delete)
	// ================================================================

	/**
	 * Which structure affordances the host has wired. The Nav view reads this to
	 * decide which controls to show; an unwired host gets a read-only browser.
	 *
	 * @returns {{ create:boolean, delete:boolean, move:boolean, reorder:boolean, any:boolean }}
	 */
	getStructureCapabilities()
	{
		let tmpCreate = (typeof this._onCreateFolder === 'function') || (typeof this._onCreateDocument === 'function');
		let tmpDelete = (typeof this._onDeleteNode === 'function');
		let tmpMove = (typeof this._onMoveNode === 'function');
		let tmpReorder = (typeof this._onReorder === 'function');
		return {
			create: tmpCreate,
			createFolder: (typeof this._onCreateFolder === 'function'),
			createDocument: (typeof this._onCreateDocument === 'function'),
			delete: tmpDelete,
			move: tmpMove,
			reorder: tmpReorder,
			any: tmpCreate || tmpDelete || tmpMove || tmpReorder
		};
	}

	/**
	 * Reload the sidebar from the server and re-render the navigation. Called after
	 * a structure change persists so the tree reflects the server's authoritative
	 * order/shape (the drag is optimistic; this makes it real).
	 *
	 * @param {Function} [fCallback] - Callback when the reload completes
	 */
	reloadSidebar(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		this._loadSidebar(() =>
		{
			this._markExternalSidebarItems();
			let tmpNavView = this.pict.views['InlineDoc-Nav'];
			if (tmpNavView)
			{
				tmpNavView.render();
			}
			return tmpCallback();
		});
	}

	// Small toast helper (falls back to a log if the modal is not present).
	_structureToast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
		else if (this.log)
		{
			this.log.info('InlineDocumentation: ' + pMessage);
		}
	}

	// Run a host structure callback, then reload the sidebar on success (or toast the
	// error). Shared by every request* method below so the persist-then-refetch flow
	// is identical for create/delete/move/reorder.
	_runStructureOp(fOp, pSuccessMessage, fCallback)
	{
		let tmpSelf = this;
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		fOp((pError) =>
		{
			if (pError)
			{
				tmpSelf._structureToast((pError && pError.message) || String(pError), 'error');
				return tmpCallback(pError);
			}
			tmpSelf.reloadSidebar(() =>
			{
				if (pSuccessMessage) { tmpSelf._structureToast(pSuccessMessage, 'success'); }
				return tmpCallback(null);
			});
		});
	}

	requestCreateFolder(pParentPath, pName, fCallback)
	{
		if (typeof this._onCreateFolder !== 'function') { return; }
		let tmpParent = pParentPath || '';
		this._runStructureOp((fDone) => this._onCreateFolder(tmpParent, pName, fDone), 'Folder created.', fCallback);
	}

	requestCreateDocument(pParentPath, pName, fCallback)
	{
		if (typeof this._onCreateDocument !== 'function') { return; }
		let tmpParent = pParentPath || '';
		this._runStructureOp((fDone) => this._onCreateDocument(tmpParent, pName, fDone), 'Document created.', fCallback);
	}

	requestDeleteNode(pPath, pNodeType, fCallback)
	{
		if (typeof this._onDeleteNode !== 'function' || !pPath) { return; }
		this._runStructureOp((fDone) => this._onDeleteNode(pPath, pNodeType || 'file', fDone), 'Deleted.', fCallback);
	}

	requestMoveNode(pFromPath, pToPath, fCallback)
	{
		if (typeof this._onMoveNode !== 'function' || !pFromPath || !pToPath || pFromPath === pToPath) { return; }
		this._runStructureOp((fDone) => this._onMoveNode(pFromPath, pToPath, fDone), 'Moved.', fCallback);
	}

	requestReorder(pParentPath, pOrderedNames, fCallback)
	{
		if (typeof this._onReorder !== 'function' || !Array.isArray(pOrderedNames)) { return; }
		let tmpParent = pParentPath || '';
		this._runStructureOp((fDone) => this._onReorder(tmpParent, pOrderedNames, fDone), '', fCallback);
	}

	/**
	 * Load topic definitions from a JSON file.
	 *
	 * Expected format:
	 *   {
	 *     "getting-started": {
	 *       "Name": "Getting Started",
	 *       "Documents": ["README.md", "getting-started.md"]
	 *     }
	 *   }
	 *
	 * @param {string} [pTopicsURL] - URL to fetch topics from (defaults to DocsBaseURL + '_topics.json')
	 * @param {Function} fCallback - Callback when done
	 */
	_loadTopics(pTopicsURL, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpDocsBase = tmpState.DocsBaseURL || '';

		let tmpURL = pTopicsURL || (tmpDocsBase + '_topics.json');

		fetch(tmpURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.json();
			})
			.then((pTopics) =>
			{
				if (pTopics)
				{
					tmpState.Topics = pTopics;
					this.log.info(`InlineDocumentation: Topics loaded (${Object.keys(pTopics).length} topics).`);
				}
				else
				{
					this.log.info('InlineDocumentation: No _topics.json found.');
				}
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.info(`InlineDocumentation: No topics loaded (${pError}).`);
				return tmpCallback();
			});
	}

	/**
	 * Parse _sidebar.md into a navigation structure.
	 *
	 * Returns an array of group objects:
	 *   [{ Name, Key, Path, Items: [{ Name, Path }] }]
	 *
	 * @param {string} pMarkdown - Raw _sidebar.md content
	 * @returns {Array} Parsed sidebar groups
	 */
	_parseSidebarMarkdown(pMarkdown)
	{
		let tmpGroups = [];
		let tmpCurrentGroup = null;
		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			if (!tmpLine.trim())
			{
				continue;
			}

			let tmpIndentMatch = tmpLine.match(/^(\s*)/);
			let tmpIndent = tmpIndentMatch ? tmpIndentMatch[1].length : 0;
			let tmpContent = tmpLine.trim();

			let tmpListMatch = tmpContent.match(/^[-*+]\s+(.*)/);
			if (!tmpListMatch)
			{
				continue;
			}

			let tmpItemContent = tmpListMatch[1].trim();
			let tmpLinkMatch = tmpItemContent.match(/^\[([^\]]+)\]\(([^)]+)\)/);

			// A link whose target ends in '/' is a FOLDER reference, not a document:
			// the server can emit `- [Label](real/folder/path/)` so the client knows a
			// folder's real (possibly relabeled, possibly empty) path for structure ops.
			// Everything else keeps working: a folder rendered as a plain `- Label` with
			// no link still parses as a pathless folder (older sidebars, backward compat).
			let tmpIsFolderLink = tmpLinkMatch && /\/$/.test(tmpLinkMatch[2].trim());
			let tmpFolderPath = tmpIsFolderLink ? this._normalizePath(tmpLinkMatch[2].trim().replace(/\/+$/, '')) : '';

			if (tmpIndent < 2)
			{
				// Top-level item — group header
				if (tmpIsFolderLink)
				{
					tmpCurrentGroup = {
						Name: tmpLinkMatch[1].trim(),
						Key: tmpLinkMatch[1].trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
						Path: '',
						FolderPath: tmpFolderPath,
						Items: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
				else if (tmpLinkMatch)
				{
					let tmpName = tmpLinkMatch[1].trim();
					let tmpPath = tmpLinkMatch[2].trim();

					tmpCurrentGroup = {
						Name: tmpName,
						Key: tmpName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
						Path: this._normalizePath(tmpPath),
						Items: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
				else
				{
					tmpCurrentGroup = {
						Name: tmpItemContent,
						Key: tmpItemContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
						Path: '',
						Items: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
			}
			else if (tmpCurrentGroup)
			{
				// Indented item — a document (link), a folder reference (trailing-slash
				// link), or a legacy sub-folder (no link) within the current group.
				// Capture the nesting Level from the indentation so the nav can render
				// real hierarchy.
				let tmpLevel = Math.max(0, Math.floor((tmpIndent - 2) / 2));
				if (tmpIsFolderLink)
				{
					tmpCurrentGroup.Items.push({
						Name: tmpLinkMatch[1].trim(),
						Path: '',
						FolderPath: tmpFolderPath,
						Level: tmpLevel,
						IsFolder: true
					});
				}
				else if (tmpLinkMatch)
				{
					tmpCurrentGroup.Items.push({
						Name: tmpLinkMatch[1].trim(),
						Path: this._normalizePath(tmpLinkMatch[2].trim()),
						Level: tmpLevel
					});
				}
				else
				{
					tmpCurrentGroup.Items.push({
						Name: tmpItemContent,
						Path: '',
						Level: tmpLevel,
						IsFolder: true
					});
				}
			}
		}

		// Make sub-folder nodes actionable: resolve each folder's first
		// descendant document (the items are in depth-first order, so scan
		// forward until we leave the folder's subtree) so clicking the folder
		// opens its first child.
		for (let g = 0; g < tmpGroups.length; g++)
		{
			let tmpItems = tmpGroups[g].Items || [];
			for (let a = 0; a < tmpItems.length; a++)
			{
				if (!tmpItems[a].IsFolder) { continue; }
				for (let b = a + 1; b < tmpItems.length; b++)
				{
					if ((tmpItems[b].Level || 0) <= (tmpItems[a].Level || 0)) { break; }
					if (tmpItems[b].Path) { tmpItems[a].FirstChildPath = tmpItems[b].Path; break; }
				}
			}
		}

		return tmpGroups;
	}

	/**
	 * Normalize a document path from sidebar links.
	 * Strips leading slashes and ./ prefixes.
	 *
	 * @param {string} pPath - The raw path
	 * @returns {string} The normalized path
	 */
	_normalizePath(pPath)
	{
		if (!pPath)
		{
			return '';
		}
		return pPath.replace(/^\.\//, '').replace(/^\//, '');
	}

	/**
	 * Get an error page HTML block for a missing document.
	 *
	 * @param {string} pPath - The path that was not found
	 * @returns {string} HTML to display
	 */
	_getErrorPageHTML(pPath)
	{
		let tmpPath = this._ContentProvider.escapeHTML(pPath || 'unknown');
		return '<div class="pict-inline-doc-not-found">'
			+ '<h2>Page Not Found</h2>'
			+ '<p>The document <code>' + tmpPath + '</code> could not be loaded.</p>'
			+ '</div>';
	}
}

const _DefaultConfiguration =
{
	ProviderIdentifier: "Pict-InlineDocumentation",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

module.exports = InlineDocumentationProvider;

module.exports.default_configuration = _DefaultConfiguration;

},{"../views/Pict-View-InlineDocumentation-Content.js":249,"../views/Pict-View-InlineDocumentation-Layout.js":250,"../views/Pict-View-InlineDocumentation-Nav.js":251,"../views/Pict-View-InlineDocumentation-TopicManager.js":252,"lunr":120,"pict-provider":177,"pict-section-content":196,"pict-section-markdowneditor":261,"pict-section-modal":271}],249:[function(require,module,exports){
const libPictContentView = require('pict-section-content');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-Content",

	DefaultRenderable: "InlineDoc-Content-Display",
	DefaultContentDestinationAddress: "#InlineDoc-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc-content {
			padding: 1em 1.25em;
			max-width: 100%;
			word-wrap: break-word;
			overflow-wrap: break-word;
		}
		.pict-inline-doc-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 150px;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.95em;
		}
		.pict-inline-doc-content h1 {
			font-size: 1.75em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-inline-doc-content h2 {
			font-size: 1.35em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding-bottom: 0.2em;
			margin-top: 1.25em;
		}
		.pict-inline-doc-content h3 {
			font-size: 1.15em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-top: 1em;
		}
		.pict-inline-doc-content h4, .pict-inline-doc-content h5, .pict-inline-doc-content h6 {
			color: var(--theme-color-text-secondary, #5E5549);
			margin-top: 0.8em;
		}
		.pict-inline-doc-content p {
			line-height: 1.65;
			color: var(--theme-color-text-primary, #423D37);
			margin: 0.6em 0;
		}
		.pict-inline-doc-content a {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
			cursor: pointer;
		}
		.pict-inline-doc-content a:hover {
			text-decoration: underline;
		}
		/* Code blocks: bg + text both flow from background/text tokens
		   so they re-skin coherently across themes. (Previous version
		   paired background-tertiary with text-on-brand — both light
		   in most palettes, producing invisible text.) */
		.pict-inline-doc-content pre {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			color:      var(--theme-color-text-primary,        #3D3229);
			padding: 1em;
			border-radius: 5px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.85em;
			max-width: 100%;
		}
		.pict-inline-doc-content code {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			padding: 0.15em 0.35em;
			border-radius: 3px;
			font-size: 0.85em;
			color: var(--theme-color-brand-accent, #9E6B47);
		}
		.pict-inline-doc-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-inline-doc-content blockquote {
			border-left: 3px solid var(--theme-color-brand-primary, #2E7D74);
			margin: 0.8em 0;
			padding: 0.4em 0.8em;
			background: var(--theme-color-background-secondary, #F7F5F0);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-inline-doc-content blockquote p {
			margin: 0.2em 0;
		}
		.pict-inline-doc-content ul, .pict-inline-doc-content ol {
			padding-left: 1.8em;
			line-height: 1.7;
		}
		.pict-inline-doc-content li {
			margin: 0.2em 0;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-inline-doc-content hr {
			border: none;
			border-top: 1px solid var(--theme-color-border-default, #DDD6CA);
			margin: 1.5em 0;
		}
		.pict-inline-doc-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 0.8em 0;
			display: block;
			overflow-x: auto;
		}
		.pict-inline-doc-content table th {
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.5em 0.7em;
			text-align: left;
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-content table td {
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.4em 0.7em;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-inline-doc-content table tr:nth-child(even) {
			background: var(--theme-color-background-secondary, #F7F5F0);
		}
		.pict-inline-doc-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-inline-doc-not-found {
			text-align: center;
			padding: 2em 1em;
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-inline-doc-not-found h2 {
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1.3em;
			border-bottom: none;
		}
		.pict-inline-doc-not-found code {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			padding: 0.15em 0.35em;
			border-radius: 3px;
			font-size: 0.85em;
			color: var(--theme-color-brand-accent, #9E6B47);
		}
		/* Code block action buttons (copy, fullscreen) from pict-section-content */
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-secondary, #5E5549);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-edit-toolbar {
			display: none;
			align-items: center;
			gap: 0.4em;
			padding: 0.4em 0.6em;
			margin-bottom: 0.5em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-size: 0.8em;
		}
		.pict-inline-doc-edit-toolbar.visible {
			display: flex;
		}
		.pict-inline-doc-edit-toolbar .edit-label {
			color: var(--theme-color-text-muted, #8A7F72);
			margin-right: auto;
		}
		.pict-inline-doc-edit-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			padding: 0.25em 0.6em;
			border: 1px solid var(--theme-color-border-default, #D4A373);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.9em;
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-edit-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-edit-btn.primary {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-edit-btn.primary:hover {
			background: var(--theme-color-brand-primary-hover, #266D65);
		}
		.pict-inline-doc-edit-btn .btn-icon {
			margin-right: 0.3em;
		}
		#InlineDoc-Editor-Container {
			min-height: 300px;
		}
		/* Tooltip placeholder: edit mode indicators */
		[data-d-tooltip].pict-inline-doc-tooltip-edit-target {
			outline: 1px dashed var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
			cursor: pointer;
			position: relative;
		}
		[data-d-tooltip].pict-inline-doc-tooltip-edit-target:not([data-d-tooltip-icon])::after {
			content: '?';
			position: absolute;
			top: -6px;
			right: -6px;
			width: 14px;
			height: 14px;
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-radius: 50%;
			font-size: 9px;
			line-height: 14px;
			text-align: center;
			font-weight: 700;
			pointer-events: none;
		}
		/* Tooltip placeholder: default icon */
		.pict-inline-doc-tooltip-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 16px;
			height: 16px;
			font-size: 12px;
			color: var(--theme-color-brand-primary, #2E7D74);
			cursor: pointer;
			vertical-align: middle;
		}
		/* Empty icon tooltip in edit mode */
		.pict-inline-doc-tooltip-empty .pict-inline-doc-tooltip-icon {
			opacity: 0.4;
			outline: 1px dashed var(--theme-color-text-muted, #8A7F72);
			outline-offset: 1px;
			border-radius: 50%;
		}
		/* Tooltip editor textarea in modal */
		.pict-inline-doc-tooltip-editor-textarea {
			width: 100%;
			min-height: 120px;
			padding: 0.6em;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.85em;
			line-height: 1.5;
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			resize: vertical;
			box-sizing: border-box;
		}
		.pict-inline-doc-tooltip-editor-textarea:focus {
			outline: none;
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 0 0 2px rgba(46, 125, 116, 0.15);
		}
		.pict-inline-doc-tooltip-preview {
			margin-top: 0.5em;
			padding: 0.5em 0.7em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-size: 0.9em;
			min-height: 2em;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-tooltip-preview-label {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			margin-bottom: 0.3em;
		}
		/* Image document view (an svg/png/... opened from the tree) */
		.pict-inline-doc-image-view {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 0.75em;
			padding: 1.5em;
		}
		.pict-inline-doc-image-view .pict-inline-doc-image {
			max-width: 100%;
			height: auto;
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 6px;
			background: var(--theme-color-background-panel, #FDFCFA);
		}
		.pict-inline-doc-image-caption {
			display: flex;
			align-items: center;
			gap: 1em;
			font-size: 0.85em;
			color: var(--theme-color-text-muted, #8A7F72);
		}
		.pict-inline-doc-image-name {
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
		}
		.pict-inline-doc-image-open {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
		}
		.pict-inline-doc-image-open:hover {
			text-decoration: underline;
		}
	`,

	Templates:
	[
		{
			Hash: "InlineDoc-Content-Template",
			Template: /*html*/`
<div class="pict-inline-doc-edit-toolbar" id="InlineDoc-Edit-Toolbar">
	<span class="edit-label" id="InlineDoc-Edit-Label">View mode</span>
	<button class="pict-inline-doc-edit-btn" id="InlineDoc-Edit-Toggle" title="Edit this document"><span class="btn-icon"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 1.5l3 3L5 14H2v-3z"/><line x1="9" y1="4" x2="12" y2="7"/></svg></span> Edit</button>
	<button class="pict-inline-doc-edit-btn primary" id="InlineDoc-Edit-Save" style="display:none"><span class="btn-icon"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,8 6.5,11.5 13,4.5"/></svg></span> Save</button>
	<button class="pict-inline-doc-edit-btn" id="InlineDoc-Edit-Cancel" style="display:none"><span class="btn-icon"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg></span> Cancel</button>
</div>
<div class="pict-inline-doc-content pict-content" id="InlineDoc-Content-Body">
	<div class="pict-inline-doc-content-loading">Loading...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "InlineDoc-Content-Display",
			TemplateHash: "InlineDoc-Content-Template",
			ContentDestinationAddress: "#InlineDoc-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class InlineDocumentationContentView extends libPictContentView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender()
	{
		this.renderEditToolbar();
		return super.onAfterRender();
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 */
	displayContent(pHTMLContent)
	{
		super.displayContent(pHTMLContent, 'InlineDoc-Content-Body');

		// Wire up click interception for internal doc links
		this._wireInternalLinks();

		// Update the edit toolbar state
		this.renderEditToolbar();
	}

	/**
	 * Show a loading indicator.
	 */
	showLoading()
	{
		super.showLoading('Loading...', 'InlineDoc-Content-Body');
	}

	/**
	 * Show or hide the edit toolbar based on EditEnabled state.
	 */
	renderEditToolbar()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpToolbar = document.getElementById('InlineDoc-Edit-Toolbar');
		if (!tmpToolbar)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState)
		{
			return;
		}

		if (tmpState.EditEnabled && tmpState.CurrentPath)
		{
			tmpToolbar.classList.add('visible');
		}
		else
		{
			tmpToolbar.classList.remove('visible');
		}

		// Update button visibility based on editing state
		let tmpToggleBtn = document.getElementById('InlineDoc-Edit-Toggle');
		let tmpSaveBtn = document.getElementById('InlineDoc-Edit-Save');
		let tmpCancelBtn = document.getElementById('InlineDoc-Edit-Cancel');
		let tmpLabel = document.getElementById('InlineDoc-Edit-Label');

		if (tmpState.Editing)
		{
			if (tmpToggleBtn) { tmpToggleBtn.style.display = 'none'; }
			if (tmpSaveBtn) { tmpSaveBtn.style.display = ''; }
			if (tmpCancelBtn) { tmpCancelBtn.style.display = ''; }
			if (tmpLabel) { tmpLabel.textContent = 'Editing: ' + (tmpState.EditingPath || ''); }
		}
		else
		{
			if (tmpToggleBtn) { tmpToggleBtn.style.display = ''; }
			if (tmpSaveBtn) { tmpSaveBtn.style.display = 'none'; }
			if (tmpCancelBtn) { tmpCancelBtn.style.display = 'none'; }
			if (tmpLabel) { tmpLabel.textContent = tmpState.CurrentPath || 'View mode'; }
		}

		// Re-wire click handlers (DOM may have been recreated by render)
		this._wireEditToolbar();
	}

	/**
	 * Show the markdown editor with the raw markdown content.
	 *
	 * @param {string} pMarkdown - The raw markdown to edit
	 */
	showEditor(pMarkdown)
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('InlineDoc-Content-Body');
		if (!tmpContainer)
		{
			return;
		}

		// Create a container for the markdown editor view to render into
		tmpContainer.innerHTML = '<div id="InlineDoc-Editor-Container"></div>';

		// Set up the editor segments data for the markdown editor
		if (!this.pict.AppData.InlineDocumentation)
		{
			this.pict.AppData.InlineDocumentation = {};
		}
		this.pict.AppData.InlineDocumentation.EditorSegments = [{ Content: pMarkdown || '' }];

		// Render the markdown editor view into the container
		let tmpEditorView = this.pict.views['InlineDoc-MarkdownEditor'];
		if (tmpEditorView)
		{
			tmpEditorView.render();
		}

		this.renderEditToolbar();
	}

	/**
	 * Hide the textarea editor.
	 */
	hideEditor()
	{
		// The editor will be replaced by displayContent, but update toolbar state
		this.renderEditToolbar();
	}

	/**
	 * Wire click handlers for the edit toolbar buttons.
	 */
	_wireEditToolbar()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];

		let tmpToggleBtn = document.getElementById('InlineDoc-Edit-Toggle');
		if (tmpToggleBtn)
		{
			tmpToggleBtn.addEventListener('click', () =>
			{
				if (tmpProvider)
				{
					tmpProvider.beginEdit();
				}
			});
		}

		let tmpSaveBtn = document.getElementById('InlineDoc-Edit-Save');
		if (tmpSaveBtn)
		{
			tmpSaveBtn.addEventListener('click', () =>
			{
				if (tmpProvider)
				{
					tmpProvider.saveEdit();
				}
			});
		}

		let tmpCancelBtn = document.getElementById('InlineDoc-Edit-Cancel');
		if (tmpCancelBtn)
		{
			tmpCancelBtn.addEventListener('click', () =>
			{
				if (tmpProvider)
				{
					tmpProvider.cancelEdit();
				}
			});
		}
	}

	/**
	 * Wire click handlers on internal documentation links.
	 *
	 * Links with rel="pict-inline-doc-link:path" are intercepted and
	 * routed through the provider's loadDocument() method.
	 */
	_wireInternalLinks()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('InlineDoc-Content-Body');
		if (!tmpContainer)
		{
			return;
		}

		let tmpLinks = tmpContainer.querySelectorAll('a[rel^="pict-inline-doc-link:"]');
		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];

		for (let i = 0; i < tmpLinks.length; i++)
		{
			let tmpLink = tmpLinks[i];
			let tmpRel = tmpLink.getAttribute('rel');
			let tmpPath = tmpRel.replace('pict-inline-doc-link:', '');

			// Check if this is a cross-module link that should open externally
			if (tmpProvider && typeof tmpProvider.isExternalPath === 'function' && tmpProvider.isExternalPath(tmpPath))
			{
				let tmpExternalURL = tmpProvider.resolveExternalURL(tmpPath);
				if (tmpExternalURL)
				{
					tmpLink.setAttribute('href', tmpExternalURL);
					tmpLink.setAttribute('target', '_blank');
					tmpLink.setAttribute('rel', 'noopener');
					continue;
				}
			}

			tmpLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				if (tmpProvider)
				{
					tmpProvider.loadDocument(tmpPath);
				}
			});
		}
	}
}

module.exports = InlineDocumentationContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-section-content":196}],250:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-Layout",

	DefaultRenderable: "InlineDoc-Layout-Container",
	DefaultContentDestinationAddress: "#InlineDoc-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc {
			display: flex;
			flex-direction: row;
			width: 100%;
			height: 100%;
			min-height: 300px;
			font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
			font-size: 15px;
			color: var(--theme-color-text-primary, #423D37);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 6px;
			overflow: hidden;
		}
		.pict-inline-doc-nav-container {
			width: var(--pict-inline-doc-nav-width, 240px);
			min-width: 160px;
			max-width: 640px;
			border-right: 1px solid var(--theme-color-border-default, #E5DED4);
			background: var(--theme-color-background-secondary, #F7F5F0);
			overflow-y: auto;
			flex-shrink: 0;
		}
		.pict-inline-doc-resizer {
			flex: 0 0 6px;
			width: 6px;
			margin: 0 -3px;
			z-index: 2;
			cursor: col-resize;
			background: transparent;
			transition: background 0.12s ease;
		}
		.pict-inline-doc-resizer:hover,
		.pict-inline-doc-resizer.pict-inline-doc-resizing {
			background: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-content-container {
			flex: 1;
			overflow-y: auto;
			overflow-x: hidden;
			min-width: 0;
		}
		.pict-inline-doc-nav-container.pict-inline-doc-nav-hidden {
			display: none;
		}
		/* Whole-panel collapse: shrink the nav to a thin strip showing only the
		   expand chevron, handing the freed width back to the content. The Nav
		   view toggles .pict-inline-doc-nav-collapsed on the container. width is
		   !important so it beats any inline width left by the drag-resizer. */
		.pict-inline-doc-nav-container.pict-inline-doc-nav-collapsed {
			width: 40px !important;
			min-width: 40px;
		}
		.pict-inline-doc-nav-container.pict-inline-doc-nav-collapsed + .pict-inline-doc-resizer {
			display: none;
		}
		.pict-inline-doc-nav-collapsed .pict-inline-doc-nav-collapsed-header {
			flex-direction: column;
			padding: 0.6em 0;
			justify-content: flex-start;
		}
		.pict-inline-doc-nav-collapsed .pict-inline-doc-nav-current-title,
		.pict-inline-doc-nav-collapsed .pict-inline-doc-nav-search-icon {
			display: none;
		}
		/* Compact mode: stack nav above content when container is narrow */
		.pict-inline-doc.pict-inline-doc-compact {
			flex-direction: column;
		}
		.pict-inline-doc.pict-inline-doc-compact .pict-inline-doc-nav-container {
			width: 100%;
			min-width: 0;
			max-width: none;
			border-right: none;
			border-bottom: 1px solid var(--theme-color-border-default, #E5DED4);
			overflow-y: visible;
			flex-shrink: 0;
		}
		.pict-inline-doc.pict-inline-doc-compact .pict-inline-doc-resizer {
			display: none;
		}
	`,

	Templates:
	[
		{
			Hash: "InlineDoc-Layout-Template",
			Template: /*html*/`
<div class="pict-inline-doc">
	<div class="pict-inline-doc-nav-container" id="InlineDoc-Nav-Container"></div>
	<div class="pict-inline-doc-resizer" id="InlineDoc-Resizer" title="Drag to resize the navigation"></div>
	<div class="pict-inline-doc-content-container" id="InlineDoc-Content-Container"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "InlineDoc-Layout-Container",
			TemplateHash: "InlineDoc-Layout-Template",
			ContentDestinationAddress: "#InlineDoc-Container",
			RenderMethod: "replace"
		}
	]
};

class InlineDocumentationLayoutView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender()
	{
		// Inject all view CSS into the PICT-CSS style element
		this.pict.CSSMap.injectCSS();

		// Restore any saved nav width, then make the nav/content divider draggable
		this._restoreNavWidth();
		this._wireNavResizer();

		// Watch for size changes and toggle compact mode
		this._setupCompactModeObserver();

		return super.onAfterRender();
	}

	/**
	 * Make the divider between the nav and the content draggable so the reader
	 * can widen or narrow the navigation. The width lives in a CSS custom
	 * property on the layout container and is persisted to localStorage.
	 */
	_wireNavResizer()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpResizer = document.getElementById('InlineDoc-Resizer');
		let tmpContainer = document.querySelector('.pict-inline-doc');
		let tmpNav = document.getElementById('InlineDoc-Nav-Container');
		if (!tmpResizer || !tmpContainer || !tmpNav)
		{
			return;
		}

		let tmpMin = 160;
		let tmpMax = 640;
		let tmpSelf = this;

		tmpResizer.addEventListener('mousedown', (pDownEvent) =>
		{
			pDownEvent.preventDefault();
			let tmpStartX = pDownEvent.clientX;
			let tmpStartWidth = tmpNav.offsetWidth;

			tmpResizer.classList.add('pict-inline-doc-resizing');
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			// A drag needs document-level move/up tracking; both listeners are
			// removed on release, so nothing leaks across renders.
			let fMove = (pMoveEvent) =>
			{
				let tmpWidth = tmpStartWidth + (pMoveEvent.clientX - tmpStartX);
				tmpWidth = Math.max(tmpMin, Math.min(tmpMax, tmpWidth));
				tmpContainer.style.setProperty('--pict-inline-doc-nav-width', tmpWidth + 'px');
			};
			let fUp = () =>
			{
				document.removeEventListener('mousemove', fMove);
				document.removeEventListener('mouseup', fUp);
				tmpResizer.classList.remove('pict-inline-doc-resizing');
				document.body.style.userSelect = '';
				document.body.style.cursor = '';
				tmpSelf._persistNavWidth(tmpContainer.style.getPropertyValue('--pict-inline-doc-nav-width'));
			};

			document.addEventListener('mousemove', fMove);
			document.addEventListener('mouseup', fUp);
		});
	}

	_persistNavWidth(pWidth)
	{
		try
		{
			if (pWidth && typeof localStorage !== 'undefined')
			{
				localStorage.setItem('pict-inline-doc-nav-width', pWidth);
			}
		}
		catch (pError) { /* storage unavailable — the width just won't persist */ }
	}

	_restoreNavWidth()
	{
		try
		{
			if (typeof localStorage === 'undefined')
			{
				return;
			}
			let tmpSaved = localStorage.getItem('pict-inline-doc-nav-width');
			if (!tmpSaved)
			{
				return;
			}
			let tmpContainer = document.querySelector('.pict-inline-doc');
			if (tmpContainer)
			{
				tmpContainer.style.setProperty('--pict-inline-doc-nav-width', tmpSaved);
			}
		}
		catch (pError) { /* ignore */ }
	}

	/**
	 * Set up a ResizeObserver to toggle compact mode when the container
	 * is too narrow for a side-by-side nav + content layout.
	 *
	 * Below the threshold, the nav switches to a horizontal top bar.
	 */
	_setupCompactModeObserver()
	{
		if (typeof document === 'undefined' || typeof ResizeObserver === 'undefined')
		{
			return;
		}

		let tmpContainer = document.querySelector('.pict-inline-doc');
		if (!tmpContainer)
		{
			return;
		}

		// Clean up any previous observer
		if (this._resizeObserver)
		{
			this._resizeObserver.disconnect();
		}

		let tmpCompactThreshold = 550;

		this._resizeObserver = new ResizeObserver((pEntries) =>
		{
			for (let i = 0; i < pEntries.length; i++)
			{
				let tmpWidth = pEntries[i].contentRect.width;

				if (tmpWidth < tmpCompactThreshold)
				{
					tmpContainer.classList.add('pict-inline-doc-compact');
				}
				else
				{
					tmpContainer.classList.remove('pict-inline-doc-compact');
				}
			}
		});

		this._resizeObserver.observe(tmpContainer);

		// Also do an immediate check
		let tmpWidth = tmpContainer.offsetWidth;
		if (tmpWidth > 0 && tmpWidth < tmpCompactThreshold)
		{
			tmpContainer.classList.add('pict-inline-doc-compact');
		}
	}
}

module.exports = InlineDocumentationLayoutView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],251:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-Nav",

	DefaultRenderable: "InlineDoc-Nav-Display",
	DefaultContentDestinationAddress: "#InlineDoc-Nav-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc-nav {
			display: flex;
			flex-direction: column;
			height: 100%;
		}
		.pict-inline-doc-nav-collapsed-header {
			display: flex;
			align-items: center;
			padding: 0.5em 0.8em;
			cursor: pointer;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			background: var(--theme-color-background-secondary, #F7F5F0);
			user-select: none;
		}
		.pict-inline-doc-nav-collapsed-header:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
		}
		.pict-inline-doc-nav-chevron {
			font-size: 0.6em;
			transition: transform 0.2s ease;
			color: var(--theme-color-text-muted, #8A7F72);
			display: inline-flex;
			align-items: center;
			margin-right: 0.5em;
		}
		.pict-inline-doc-nav-chevron.expanded {
			transform: rotate(90deg);
		}
		.pict-inline-doc-nav-current-title {
			font-size: 0.9em;
			font-weight: 500;
			color: var(--theme-color-text-primary, #3D3229);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			flex: 1;
		}
		.pict-inline-doc-nav-outline {
			display: none;
			overflow-y: auto;
		}
		.pict-inline-doc-nav-outline.expanded {
			display: block;
		}
		.pict-inline-doc-nav-filter {
			padding: 0.3em 0.6em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
		}
		.pict-inline-doc-nav-filter input {
			width: 100%;
			box-sizing: border-box;
			padding: 0.3em 0.5em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			font-size: 0.85em;
			outline: none;
		}
		.pict-inline-doc-nav-filter input:focus {
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-group {
			margin-bottom: 0;
		}
		.pict-inline-doc-nav-group-header {
			display: flex;
			align-items: center;
			padding: 0.4em 0.8em;
			font-weight: 600;
			font-size: 0.7em;
			color: var(--theme-color-text-secondary, #5E5549);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			cursor: pointer;
			user-select: none;
		}
		.pict-inline-doc-nav-group-header:hover {
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-nav-group-toggle {
			margin-right: 0.35em;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 0.85em;
			height: 0.85em;
			color: currentColor;
			transition: transform 0.15s ease;
		}
		.pict-inline-doc-nav-group-toggle svg {
			width: 100%;
			height: 100%;
			display: block;
		}
		.pict-inline-doc-nav-group-toggle.collapsed {
			transform: rotate(-90deg);
		}
		.pict-inline-doc-nav-group.collapsed .pict-inline-doc-nav-group-items {
			display: none;
		}
		.pict-inline-doc-nav-folder-toggle {
			margin-right: 0.15em;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 0.8em;
			height: 0.8em;
			vertical-align: -0.1em;
			opacity: 0.6;
			cursor: pointer;
			transition: transform 0.15s ease, opacity 0.1s ease;
		}
		.pict-inline-doc-nav-folder-toggle svg {
			width: 100%;
			height: 100%;
			display: block;
		}
		.pict-inline-doc-nav-folder-toggle:hover {
			opacity: 1;
		}
		.pict-inline-doc-nav-folder-toggle.collapsed {
			transform: rotate(-90deg);
		}
		.pict-inline-doc-nav-item {
			display: block;
			padding: 0.25em 0.8em 0.25em calc(1.6em + var(--doc-nav-level, 0) * 0.85em);
			color: var(--theme-color-text-secondary, #5E5549);
			text-decoration: none;
			font-size: 0.85em;
			cursor: pointer;
			border-left: 3px solid transparent;
			transition: background 0.1s ease, border-color 0.1s ease;
		}
		.pict-inline-doc-nav-item:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
		}
		.pict-inline-doc-nav-folder {
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-nav-folder-icon {
			margin-right: 0.4em;
			vertical-align: -0.12em;
			opacity: 0.65;
		}
		.pict-inline-doc-nav-file-icon {
			margin-right: 0.4em;
			vertical-align: -0.12em;
			opacity: 0.55;
		}
		.pict-inline-doc-nav-section-dot {
			margin-right: 0.4em;
			vertical-align: -0.12em;
			opacity: 0.3;
		}
		.pict-inline-doc-nav-item.active {
			background: var(--theme-color-background-hover, #E8E3D8);
			color: var(--theme-color-brand-primary, #2E7D74);
			border-left-color: var(--theme-color-brand-primary, #2E7D74);
			font-weight: 500;
		}
		.pict-inline-doc-nav-heading {
			display: block;
			padding: 0.15em 0.8em 0.15em calc(2.4em + var(--doc-nav-level, 0) * 0.85em);
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.78em;
			cursor: pointer;
			border-left: 3px solid transparent;
			transition: background 0.1s ease, color 0.1s ease;
		}
		.pict-inline-doc-nav-heading:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-inline-doc-nav-heading.h3 {
			padding-left: calc(3.2em + var(--doc-nav-level, 0) * 0.85em);
			font-size: 0.72em;
		}
		/* Search icon in collapsed header */
		.pict-inline-doc-nav-search-icon {
			display: inline-flex;
			align-items: center;
			color: var(--theme-color-text-muted, #8A7F72);
			opacity: 0.5;
			transition: opacity 0.2s;
			flex-shrink: 0;
			margin-left: 0.3em;
		}
		.pict-inline-doc-nav-search-icon:hover {
			opacity: 1;
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		/* Search results section */
		.pict-inline-doc-nav-search-results {
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding: 0.3em 0;
		}
		.pict-inline-doc-nav-search-status {
			padding: 0.2em 0.8em;
			font-size: 0.7em;
			color: var(--theme-color-text-muted, #8A7F72);
			text-transform: uppercase;
			letter-spacing: 0.03em;
		}
		.pict-inline-doc-nav-search-result {
			display: flex;
			align-items: baseline;
			padding: 0.25em 0.8em 0.25em 1.2em;
			cursor: pointer;
			font-size: 0.82em;
			color: var(--theme-color-text-primary, #3D3229);
			text-decoration: none;
			transition: background 0.1s ease;
			gap: 0.5em;
		}
		.pict-inline-doc-nav-search-result:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
		}
		.pict-inline-doc-nav-search-result-title {
			flex: 1;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.pict-inline-doc-nav-search-result-group {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			white-space: nowrap;
		}
		/* External link indicator */
		.pict-inline-doc-nav-item-external {
			color: var(--theme-color-text-muted, #8A7F72);
		}
		.pict-inline-doc-nav-item-external:hover {
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-external-icon {
			display: inline;
			margin-left: 0.3em;
			opacity: 0.5;
			vertical-align: -0.05em;
		}
		.pict-inline-doc-nav-topic-badge {
			display: inline-block;
			margin: 0.5em 1em;
			padding: 0.3em 0.7em;
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-radius: 4px;
			font-size: 0.8em;
			font-weight: 500;
		}
		.pict-inline-doc-nav-topic-clear {
			margin-left: 0.5em;
			cursor: pointer;
			opacity: 0.8;
		}
		.pict-inline-doc-nav-topic-clear:hover {
			opacity: 1;
		}
		.pict-inline-doc-nav-toolbar {
			display: flex;
			align-items: center;
			gap: 0.3em;
			padding: 0.3em 1em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
		}
		.pict-inline-doc-nav-toolbar-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.9em;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-nav-toolbar-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			border-color: var(--theme-color-border-default, #C4BDB3);
		}
		.pict-inline-doc-nav-toolbar-btn.accent {
			border-color: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-toolbar-btn.accent:hover {
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-nav-toolbar-btn.active {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-toolbar-btn.active:hover {
			background: var(--theme-color-brand-primary-hover, #266D65);
		}
		.pict-inline-doc-nav-toolbar-spacer {
			flex: 1;
		}
		/* Structure management: per-node hover actions (rename / delete) */
		.pict-inline-doc-nav-item,
		.pict-inline-doc-nav-group-header {
			position: relative;
		}
		.pict-inline-doc-nav-node-actions {
			position: absolute;
			right: 0.35em;
			top: 50%;
			transform: translateY(-50%);
			display: none;
			align-items: center;
			gap: 0.1em;
		}
		.pict-inline-doc-nav-item:hover > .pict-inline-doc-nav-node-actions,
		.pict-inline-doc-nav-group-header:hover > .pict-inline-doc-nav-node-actions {
			display: inline-flex;
		}
		.pict-inline-doc-nav-node-action {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 1.4em;
			height: 1.4em;
			border-radius: 3px;
			color: var(--theme-color-text-muted, #8A7F72);
			background: var(--theme-color-background-panel, #fff);
			cursor: pointer;
			opacity: 0.85;
		}
		.pict-inline-doc-nav-node-action:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
			color: var(--theme-color-text-primary, #3D3229);
			opacity: 1;
		}
		.pict-inline-doc-nav-node-action.danger:hover {
			color: var(--theme-color-status-error, #B3261E);
		}
		/* Drag-and-drop reorder / move affordances */
		.pict-inline-doc-nav-item[draggable="true"],
		.pict-inline-doc-nav-group-header[draggable="true"] {
			cursor: grab;
		}
		.pict-inline-doc-nav-dragging {
			opacity: 0.45;
		}
		.pict-inline-doc-nav-drop-into {
			background: var(--theme-color-background-hover, #E8E3D8) !important;
			outline: 1px dashed var(--theme-color-brand-primary, #2E7D74);
			outline-offset: -1px;
		}
		.pict-inline-doc-nav-drop-before {
			box-shadow: inset 0 2px 0 0 var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-drop-after {
			box-shadow: inset 0 -2px 0 0 var(--theme-color-brand-primary, #2E7D74);
		}
	`,

	Templates:
	[
		{
			Hash: "InlineDoc-Nav-Template",
			Template: /*html*/`<div class="pict-inline-doc-nav" id="InlineDoc-Nav-Body"></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "InlineDoc-Nav-Display",
			TemplateHash: "InlineDoc-Nav-Template",
			ContentDestinationAddress: "#InlineDoc-Nav-Container",
			RenderMethod: "replace"
		}
	]
};

class InlineDocumentationNavView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender()
	{
		this._renderNavigation();
		return super.onAfterRender();
	}

	/**
	 * Build and inject the navigation HTML into the nav body.
	 */
	_renderNavigation()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('InlineDoc-Nav-Body');
		if (!tmpContainer)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState)
		{
			return;
		}

		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];
		// The active document's headings render as sub-items (an in-document outline) beneath it.
		// A host can turn that off (ShowDocumentHeadings: false) to keep the tree to files + folders
		// only; leaving headings out here also keeps them out of the filter match below.
		let tmpHeadings = [];
		if (tmpState.ShowDocumentHeadings !== false && tmpProvider && typeof tmpProvider._extractHeadings === 'function')
		{
			tmpHeadings = tmpProvider._extractHeadings();
		}

		let tmpCurrentPath = tmpState.CurrentPath || '';
		let tmpIsCollapsed = tmpState.NavCollapsed !== false;
		let tmpFilterText = tmpState.NavFilterText || '';
		let tmpCurrentDocName = this._resolveCurrentDocName(tmpState, tmpCurrentPath);

		// Reflect the collapsed state on the nav CONTAINER (the layout owns its
		// width). Collapsing then shrinks the whole panel to a thin strip and hands
		// the freed width back to the content, instead of hiding the outline while
		// the container stays full-width.
		let tmpNavContainer = document.getElementById('InlineDoc-Nav-Container');
		if (tmpNavContainer)
		{
			tmpNavContainer.classList.toggle('pict-inline-doc-nav-collapsed', tmpIsCollapsed);
		}

		let tmpHTML = '';

		let tmpSearchQuery = tmpState.SearchQuery || '';
		let tmpSearchResults = tmpState.SearchResults || [];

		// 1. Collapsed header with search icon
		let tmpChevronClass = 'pict-inline-doc-nav-chevron' + (tmpIsCollapsed ? '' : ' expanded');
		tmpHTML += '<div class="pict-inline-doc-nav-collapsed-header">';
		tmpHTML += '<span class="' + tmpChevronClass + '" id="InlineDoc-Nav-CollapseToggle">';
		tmpHTML += '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,3 11,8 6,13"/></svg>';
		tmpHTML += '</span>';
		tmpHTML += '<span class="pict-inline-doc-nav-current-title" id="InlineDoc-Nav-TitleToggle">' + this._escapeHTML(tmpCurrentDocName) + '</span>';
		tmpHTML += '<span class="pict-inline-doc-nav-search-icon" id="InlineDoc-Nav-SearchBtn" title="Search documentation">';
		tmpHTML += '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="7" r="4.5"/><line x1="10.5" y1="10.5" x2="14" y2="14"/></svg>';
		tmpHTML += '</span>';
		tmpHTML += '</div>';

		// 2. Outline body
		let tmpOutlineClass = 'pict-inline-doc-nav-outline' + (tmpIsCollapsed ? '' : ' expanded');
		tmpHTML += '<div class="' + tmpOutlineClass + '" id="InlineDoc-Nav-Outline">';

		// Search / filter input
		let tmpPlaceholder = tmpState.SearchIndexLoaded ? 'Search documentation...' : 'Filter...';
		tmpHTML += '<div class="pict-inline-doc-nav-filter">';
		tmpHTML += '<input type="text" id="InlineDoc-Nav-FilterInput" placeholder="' + tmpPlaceholder + '" value="' + this._escapeHTML(tmpSearchQuery || tmpFilterText) + '" />';
		tmpHTML += '</div>';

		// Search results (when full-text search is active)
		if (tmpSearchResults.length > 0 && tmpSearchQuery)
		{
			tmpHTML += '<div class="pict-inline-doc-nav-search-results">';
			tmpHTML += '<div class="pict-inline-doc-nav-search-status">' + tmpSearchResults.length + ' result' + (tmpSearchResults.length !== 1 ? 's' : '') + '</div>';
			for (let i = 0; i < tmpSearchResults.length && i < 15; i++)
			{
				let tmpResult = tmpSearchResults[i];
				tmpHTML += '<a class="pict-inline-doc-nav-search-result" data-search-path="' + this._escapeHTML(tmpResult.DocPath) + '">';
				tmpHTML += '<span class="pict-inline-doc-nav-search-result-title">' + this._escapeHTML(tmpResult.Title) + '</span>';
				if (tmpResult.Group)
				{
					tmpHTML += '<span class="pict-inline-doc-nav-search-result-group">' + this._escapeHTML(tmpResult.Group) + '</span>';
				}
				tmpHTML += '</a>';
			}
			tmpHTML += '</div>';
		}

		// Topic badge
		tmpHTML += this._renderTopicBadge(tmpState);

		// Toolbar
		tmpHTML += this._renderToolbar(tmpState);

		// Group tree
		tmpHTML += this._renderGroupTree(tmpState, tmpCurrentPath, tmpHeadings, tmpFilterText);

		tmpHTML += '</div>';

		tmpContainer.innerHTML = tmpHTML;

		// Wire up click handlers
		this._wireClickHandlers(tmpContainer);
	}

	/**
	 * Resolve the display name for the currently loaded document.
	 *
	 * Searches SidebarGroups for a matching item name; falls back to the path.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @param {string} pCurrentPath - The current document path
	 * @returns {string} The resolved document name
	 */
	_resolveCurrentDocName(pState, pCurrentPath)
	{
		if (!pCurrentPath)
		{
			return 'Documentation';
		}

		let tmpGroups = pState.SidebarGroups || [];

		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpGroup = tmpGroups[i];

			// Check if the group itself matches
			if (tmpGroup.Path && tmpGroup.Path === pCurrentPath)
			{
				return tmpGroup.Name || pCurrentPath;
			}

			let tmpItems = tmpGroup.Items || [];
			for (let j = 0; j < tmpItems.length; j++)
			{
				if (tmpItems[j].Path === pCurrentPath)
				{
					return tmpItems[j].Name || pCurrentPath;
				}
			}
		}

		return pCurrentPath;
	}

	/**
	 * Render the topic badge HTML if a topic is active.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @returns {string} HTML string for the topic badge, or empty string
	 */
	_renderTopicBadge(pState)
	{
		let tmpActiveTopic = pState.Topic;

		if (!tmpActiveTopic || !pState.Topics || !pState.Topics[tmpActiveTopic])
		{
			return '';
		}

		let tmpTopicDef = pState.Topics[tmpActiveTopic];
		let tmpTopicName = tmpTopicDef.TopicTitle || tmpTopicDef.Name || tmpActiveTopic;

		let tmpHTML = '<div class="pict-inline-doc-nav-topic-badge">'
			+ this._escapeHTML(tmpTopicName)
			+ '<span class="pict-inline-doc-nav-topic-clear" id="InlineDoc-Nav-ClearTopic">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">'
			+ '<line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/>'
			+ '</svg></span>'
			+ '</div>';

		return tmpHTML;
	}

	/**
	 * The host-wired structure capabilities (create/delete/move/reorder). Falls back
	 * to an all-false shape when the provider or the API is unavailable, so callers
	 * can read it unconditionally.
	 *
	 * @returns {object} capability flags
	 */
	_structureCaps()
	{
		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];
		if (tmpProvider && typeof tmpProvider.getStructureCapabilities === 'function')
		{
			return tmpProvider.getStructureCapabilities();
		}
		return { create: false, createFolder: false, createDocument: false, delete: false, move: false, reorder: false, any: false };
	}

	/**
	 * Render the toolbar HTML: structure controls (New Folder / New Doc) when the
	 * host wired them, plus the topic-management controls when TopicManagerEnabled.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @returns {string} HTML string for the toolbar, or empty string
	 */
	_renderToolbar(pState)
	{
		let tmpCaps = this._structureCaps();

		if (!pState.TopicManagerEnabled && !tmpCaps.any && !pState.AssetToggleEnabled)
		{
			return '';
		}

		let tmpHTML = '<div class="pict-inline-doc-nav-toolbar">';

		// Structure buttons — only the ones the host actually wired.
		if (tmpCaps.createFolder)
		{
			tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn" id="InlineDoc-Nav-NewFolder" title="New folder">'
				+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
				+ '<path d="M1.5 4.5a1 1 0 0 1 1-1h3.2l1.3 1.4h5.5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z"/>'
				+ '<line x1="8" y1="7" x2="8" y2="11"/><line x1="6" y1="9" x2="10" y2="9"/>'
				+ '</svg></button>';
		}
		if (tmpCaps.createDocument)
		{
			tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn" id="InlineDoc-Nav-NewDoc" title="New document">'
				+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
				+ '<path d="M4 2.5H9L12 5.5V13.5H4Z"/><polyline points="9 2.5 9 5.5 12 5.5"/>'
				+ '<line x1="8" y1="8" x2="8" y2="11.5"/><line x1="6.25" y1="9.75" x2="9.75" y2="9.75"/>'
				+ '</svg></button>';
		}

		// "Show non-document files" toggle (host opt-in). Placed after the structure buttons so it
		// appears in both the read-only and topic-manager toolbars.
		tmpHTML += this._assetToggleButtonHTML(pState);

		if (!pState.TopicManagerEnabled)
		{
			tmpHTML += '<span class="pict-inline-doc-nav-toolbar-spacer"></span>';
			tmpHTML += '</div>';
			return tmpHTML;
		}

		tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn" id="InlineDoc-Nav-ManageTopics" title="Manage Topics">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
			+ '<circle cx="8" cy="8" r="2.5"/>'
			+ '<path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41"/>'
			+ '</svg></button>';

		if (pState.CurrentRoute)
		{
			tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn accent" id="InlineDoc-Nav-BindTopic" title="Bind topic to current route">'
				+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
				+ '<path d="M6.5 9.5a3.5 3.5 0 005 0l2-2a3.5 3.5 0 00-5-5l-1 1"/>'
				+ '<path d="M9.5 6.5a3.5 3.5 0 00-5 0l-2 2a3.5 3.5 0 005 5l1-1"/>'
				+ '</svg></button>';
		}

		let tmpTooltipEditActive = pState.TooltipEditMode ? ' active' : '';
		tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn' + tmpTooltipEditActive + '" id="InlineDoc-Nav-TooltipEditMode" title="Toggle tooltip edit mode">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
			+ '<path d="M14 10a1.5 1.5 0 01-1.5 1.5H4l-3 3V3A1.5 1.5 0 012.5 1.5h10A1.5 1.5 0 0114 3z"/>'
			+ '</svg></button>';

		tmpHTML += '<span class="pict-inline-doc-nav-toolbar-spacer"></span>';
		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * The "show / hide non-document files" toolbar toggle, rendered only when the host opted in
	 * (AssetToggleEnabled). Active styling reflects the current preference; the click handler in
	 * _wireClickHandlers flips it through the provider.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @returns {string} HTML for the toggle button, or ''
	 */
	_assetToggleButtonHTML(pState)
	{
		if (!pState.AssetToggleEnabled)
		{
			return '';
		}
		let tmpActive = pState.ShowAssetFiles ? ' active' : '';
		let tmpTitle = pState.ShowAssetFiles ? 'Hide non-document files' : 'Show non-document files';
		return '<button class="pict-inline-doc-nav-toolbar-btn' + tmpActive + '" id="InlineDoc-Nav-ToggleAssetFiles" title="' + tmpTitle + '">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
			+ '<rect x="2" y="3" width="12" height="10" rx="1"/><circle cx="5.5" cy="6.5" r="1"/><path d="M2.5 11l3.2-3 2.3 2 2-1.6 3.5 3"/>'
			+ '</svg></button>';
	}

	/**
	 * Drag attributes for a movable / reorderable node. Emitted only when the host
	 * wired move or reorder and the node has a real path.
	 *
	 * @param {string} pPath - The node's real lake path
	 * @param {string} pType - 'file' or 'folder'
	 * @param {object} pCaps - Structure capabilities
	 * @returns {string} An attribute fragment (leading space) or ''
	 */
	_dragAttrs(pPath, pType, pCaps)
	{
		if (!pPath || (!pCaps.move && !pCaps.reorder))
		{
			return '';
		}
		return ' draggable="true" data-node-path="' + this._escapeHTML(pPath) + '" data-node-type="' + pType + '"';
	}

	/**
	 * Per-node hover actions (rename / delete), gated by capabilities. Requires a
	 * real path; a legacy pathless folder gets no actions.
	 *
	 * @param {string} pPath - The node's real lake path
	 * @param {string} pType - 'file' or 'folder'
	 * @param {object} pCaps - Structure capabilities
	 * @returns {string} HTML for the actions cluster, or ''
	 */
	_nodeActionsHTML(pPath, pType, pCaps)
	{
		if (!pPath || (!pCaps.move && !pCaps.delete))
		{
			return '';
		}
		// Actions carry their own data-action-path / data-action-type (NOT data-node-path)
		// so the drag / reorder queries, which select real nodes by [data-node-path], never
		// match these buttons.
		let tmpHTML = '<span class="pict-inline-doc-nav-node-actions">';
		if (pCaps.move)
		{
			tmpHTML += '<span class="pict-inline-doc-nav-node-action" data-action="rename" data-action-path="' + this._escapeHTML(pPath) + '" data-action-type="' + pType + '" title="Rename">'
				+ '<svg width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 2.5l2 2L6 12l-2.5.5L4 10z"/></svg>'
				+ '</span>';
		}
		if (pCaps.delete)
		{
			tmpHTML += '<span class="pict-inline-doc-nav-node-action danger" data-action="delete" data-action-path="' + this._escapeHTML(pPath) + '" data-action-type="' + pType + '" title="Delete">'
				+ '<svg width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="2.5 4 13.5 4"/><path d="M5.5 4V2.8h5V4M6.5 7v4M9.5 7v4M4 4l0.7 9h6.6L12 4"/></svg>'
				+ '</span>';
		}
		tmpHTML += '</span>';
		return tmpHTML;
	}

	/**
	 * Build the group/item/heading tree HTML.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @param {string} pCurrentPath - The current document path
	 * @param {Array} pHeadings - Array of { Text, Slug, Level } from _extractHeadings
	 * @param {string} pFilterText - The current filter text
	 * @returns {string} HTML string for the group tree
	 */
	_renderGroupTree(pState, pCurrentPath, pHeadings, pFilterText)
	{
		let tmpCaps = this._structureCaps();
		let tmpHTML = '';
		let tmpGroups = pState.SidebarGroups || [];
		let tmpActiveTopic = pState.Topic;
		let tmpTopicDocuments = null;
		let tmpFilterLower = (pFilterText || '').toLowerCase();

		// Resolve topic document filter
		if (tmpActiveTopic && pState.Topics && pState.Topics[tmpActiveTopic])
		{
			let tmpTopicDef = pState.Topics[tmpActiveTopic];

			if (tmpTopicDef.TopicHelpFilePath)
			{
				tmpTopicDocuments = [tmpTopicDef.TopicHelpFilePath];
			}
			else if (tmpTopicDef.Documents)
			{
				tmpTopicDocuments = tmpTopicDef.Documents;
			}
			else
			{
				tmpTopicDocuments = [];
			}
		}

		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpGroup = tmpGroups[i];
			let tmpGroupItems = tmpGroup.Items || [];

			// Apply topic filter
			if (tmpTopicDocuments)
			{
				tmpGroupItems = tmpGroupItems.filter((pItem) =>
				{
					return tmpTopicDocuments.indexOf(pItem.Path) >= 0;
				});

				let tmpGroupMatches = tmpTopicDocuments.indexOf(tmpGroup.Path) >= 0;

				if (tmpGroupItems.length < 1 && !tmpGroupMatches)
				{
					continue;
				}
			}

			// Apply text filter — match item names AND headings of the active document
			if (tmpFilterLower)
			{
				tmpGroupItems = tmpGroupItems.filter((pItem) =>
				{
					if ((pItem.Name || '').toLowerCase().indexOf(tmpFilterLower) >= 0)
					{
						return true;
					}
					// For the active document, also check heading text
					if (pItem.Path === pCurrentPath && pHeadings.length > 0)
					{
						for (let h = 0; h < pHeadings.length; h++)
						{
							if ((pHeadings[h].Text || '').toLowerCase().indexOf(tmpFilterLower) >= 0)
							{
								return true;
							}
						}
					}
					return false;
				});

				let tmpGroupNameMatches = (tmpGroup.Name || '').toLowerCase().indexOf(tmpFilterLower) >= 0;

				if (tmpGroupItems.length < 1 && !tmpGroupNameMatches)
				{
					continue;
				}
			}

			let tmpGroupKey = tmpGroup.Key || tmpGroup.Name || ('group-' + i);
			let tmpIsGroupCollapsed = pState.CollapsedGroups && pState.CollapsedGroups[tmpGroupKey];
			let tmpGroupClass = 'pict-inline-doc-nav-group' + (tmpIsGroupCollapsed ? ' collapsed' : '');
			let tmpToggleClass = 'pict-inline-doc-nav-group-toggle' + (tmpIsGroupCollapsed ? ' collapsed' : '');

			// A top-level group is a root node: a folder (its real FolderPath) or a
			// root document (its Path). Drag attrs on the header enable root reorder /
			// drop-into-folder; the hover actions enable rename/delete of the top node.
			let tmpGroupPath = tmpGroup.FolderPath || tmpGroup.Path || '';
			let tmpGroupType = tmpGroup.FolderPath ? 'folder' : 'file';

			tmpHTML += '<div class="' + tmpGroupClass + '" data-group="' + this._escapeHTML(tmpGroupKey) + '">';
			tmpHTML += '<div class="pict-inline-doc-nav-group-header"' + this._dragAttrs(tmpGroupPath, tmpGroupType, tmpCaps) + '>';
			tmpHTML += '<span class="' + tmpToggleClass + '" aria-hidden="true">'
				+ '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" '
				+ 'stroke-linecap="round" stroke-linejoin="round">'
				+ '<polyline points="3 6 8 11 13 6"/>'
				+ '</svg></span>';
			tmpHTML += this._escapeHTML(tmpGroup.Name);
			tmpHTML += this._nodeActionsHTML(tmpGroupPath, tmpGroupType, tmpCaps);
			tmpHTML += '</div>';

			tmpHTML += '<div class="pict-inline-doc-nav-group-items">';

			// If the group itself has a path, show it as the first item
			if (tmpGroup.Path)
			{
				let tmpActive = (pCurrentPath === tmpGroup.Path) ? ' active' : '';
				tmpHTML += '<a class="pict-inline-doc-nav-item' + tmpActive
					+ '" data-doc-path="' + this._escapeHTML(tmpGroup.Path) + '"'
					+ this._dragAttrs(tmpGroup.Path, 'file', tmpCaps) + '>'
					+ this._fileIconSVG()
					+ this._escapeHTML(tmpGroup.Name)
					+ this._nodeActionsHTML(tmpGroup.Path, 'file', tmpCaps)
					+ '</a>';

				// If this is the active item, render heading sub-items
				if (pCurrentPath === tmpGroup.Path)
				{
					tmpHTML += this._renderHeadingSubItems(pHeadings, tmpFilterLower, 0);
				}
			}

			// Folders collapse by hiding their descendants. The item list is flat (each row carries
			// its own Level for indent), so a collapsed folder is applied as a path prefix: any later
			// row whose path starts with it is skipped. Folder paths carry a trailing slash, so the
			// prefix match stops at the directory boundary and never catches a sibling.
			let tmpHidePrefixes = [];
			for (let j = 0; j < tmpGroupItems.length; j++)
			{
				let tmpItem = tmpGroupItems[j];
				let tmpIndent = ' style="--doc-nav-level:' + (tmpItem.Level || 0) + '"';

				let tmpItemKey = tmpItem.Path || tmpItem.FolderPath || '';
				let tmpHiddenUnderFolder = false;
				for (let h = 0; h < tmpHidePrefixes.length; h++)
				{
					if (tmpItemKey && tmpItemKey.indexOf(tmpHidePrefixes[h]) === 0) { tmpHiddenUnderFolder = true; break; }
				}
				if (tmpHiddenUnderFolder) { continue; }

				// Sub-folder node (no document of its own). Indent it by its
				// level and, when it has descendants, make it clickable so it
				// opens its first child document; mark it with a folder glyph.
				// A real FolderPath (trailing-slash sidebar link) makes it a drag
				// source, a drop target, and rename/delete-able.
				if (!tmpItem.Path)
				{
					let tmpFolderPath = tmpItem.FolderPath || '';
					let tmpFolderDrag = this._dragAttrs(tmpFolderPath, 'folder', tmpCaps);
					let tmpFolderActions = this._nodeActionsHTML(tmpFolderPath, 'folder', tmpCaps);
					let tmpFolderCollapsed = !!(pState.CollapsedFolders && pState.CollapsedFolders[tmpFolderPath]);
					if (tmpItem.FirstChildPath)
					{
						// Folders are navigational shortcuts to their first child; the
						// child item carries the active highlight, so the folder doesn't.
						// The chevron collapses the folder (hides its descendants) without
						// navigating -- its click is stopped in _wireClickHandlers.
						let tmpFolderToggle = '<span class="pict-inline-doc-nav-folder-toggle' + (tmpFolderCollapsed ? ' collapsed' : '')
							+ '" data-folder-toggle="' + this._escapeHTML(tmpFolderPath) + '" title="Collapse or expand this folder">'
							+ '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 8 11 13 6"/></svg>'
							+ '</span>';
						tmpHTML += '<a class="pict-inline-doc-nav-item pict-inline-doc-nav-folder'
							+ '" data-doc-path="' + this._escapeHTML(tmpItem.FirstChildPath) + '"' + tmpIndent + tmpFolderDrag + '>'
							+ tmpFolderToggle
							+ this._folderIconSVG()
							+ this._escapeHTML(tmpItem.Name)
							+ tmpFolderActions
							+ '</a>';
						// A collapsed folder hides every later row under its path.
						if (tmpFolderCollapsed) { tmpHidePrefixes.push(tmpFolderPath); }
					}
					else
					{
						// An empty folder (marker-only) still gets its path, so it is a
						// valid drop target and can be renamed / removed.
						tmpHTML += '<span class="pict-inline-doc-nav-item pict-inline-doc-nav-folder"' + tmpIndent + tmpFolderDrag + '>'
							+ this._folderIconSVG()
							+ this._escapeHTML(tmpItem.Name)
							+ tmpFolderActions
							+ '</span>';
					}
					continue;
				}

				if (tmpItem.External && tmpItem.ExternalURL)
				{
					// External link — opens in a new tab
					tmpHTML += '<a class="pict-inline-doc-nav-item pict-inline-doc-nav-item-external'
						+ '" data-external-url="' + this._escapeHTML(tmpItem.ExternalURL) + '"' + tmpIndent + '>'
						+ this._fileIconSVG()
						+ this._escapeHTML(tmpItem.Name)
						+ '<svg class="pict-inline-doc-nav-external-icon" width="0.75em" height="0.75em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h4"/><polyline points="8,2 14,2 14,8"/><line x1="14" y1="2" x2="7" y2="9"/></svg>'
						+ '</a>';
				}
				else
				{
					let tmpActive = (pCurrentPath === tmpItem.Path) ? ' active' : '';
					tmpHTML += '<a class="pict-inline-doc-nav-item' + tmpActive
						+ '" data-doc-path="' + this._escapeHTML(tmpItem.Path) + '"' + tmpIndent
						+ this._dragAttrs(tmpItem.Path, 'file', tmpCaps) + '>'
						+ this._fileIconSVG()
						+ this._escapeHTML(tmpItem.Name)
						+ this._nodeActionsHTML(tmpItem.Path, 'file', tmpCaps)
						+ '</a>';

					// If this is the active item, render heading sub-items
					if (pCurrentPath === tmpItem.Path)
					{
						tmpHTML += this._renderHeadingSubItems(pHeadings, tmpFilterLower, tmpItem.Level || 0);
					}
				}
			}

			tmpHTML += '</div>';
			tmpHTML += '</div>';
		}

		return tmpHTML;
	}

	/**
	 * A small folder glyph for sub-folder nav nodes. Uses currentColor so it
	 * follows the theme like the other inline nav icons.
	 *
	 * @returns {string} inline SVG HTML
	 */
	_folderIconSVG()
	{
		return '<svg class="pict-inline-doc-nav-folder-icon" width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1.5 5a1 1 0 0 1 1-1h3.2l1.3 1.4h5.5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z"/></svg>';
	}

	/**
	 * A small document glyph (a page with a folded corner) for markdown file
	 * nodes. Same footprint as the folder glyph so files and folders line up at
	 * the same depth.
	 *
	 * @returns {string} inline SVG HTML
	 */
	_fileIconSVG()
	{
		return '<svg class="pict-inline-doc-nav-file-icon" width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2.5H9L12 5.5V13.5H4Z"/><polyline points="9 2.5 9 5.5 12 5.5"/></svg>';
	}

	/**
	 * A small filled dot marking an in-document section (a heading sub-item shown
	 * beneath the active document). currentColor + low opacity keeps it quiet.
	 *
	 * @returns {string} inline SVG HTML
	 */
	_sectionDotSVG()
	{
		return '<svg class="pict-inline-doc-nav-section-dot" width="0.85em" height="0.85em" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="2.3" fill="currentColor"/></svg>';
	}

	/**
	 * Render heading sub-items (h2 and h3) beneath the active nav item.
	 *
	 * @param {Array} pHeadings - Array of { Text, Slug, Level }
	 * @param {string} pFilterText - Lowercase filter text
	 * @returns {string} HTML string for heading sub-items
	 */
	_renderHeadingSubItems(pHeadings, pFilterText, pBaseLevel)
	{
		if (!pHeadings || pHeadings.length < 1)
		{
			return '';
		}

		// Indent the headings relative to their (possibly nested) parent
		// document item, so they line up one notch under it at any tree depth.
		let tmpLevelStyle = ' style="--doc-nav-level:' + (pBaseLevel || 0) + '"';
		let tmpHTML = '';

		for (let i = 0; i < pHeadings.length; i++)
		{
			let tmpHeading = pHeadings[i];
			let tmpText = tmpHeading.Text || '';

			// Apply filter
			if (pFilterText && tmpText.toLowerCase().indexOf(pFilterText) < 0)
			{
				continue;
			}

			let tmpLevelClass = (tmpHeading.Level === 3) ? ' h3' : '';
			tmpHTML += '<a class="pict-inline-doc-nav-heading' + tmpLevelClass
				+ '" data-heading-slug="' + this._escapeHTML(tmpHeading.Slug) + '"' + tmpLevelStyle + '>'
				+ this._sectionDotSVG()
				+ this._escapeHTML(tmpText)
				+ '</a>';
		}

		return tmpHTML;
	}

	/**
	 * Wire click handlers on navigation items, group headers, and controls.
	 *
	 * @param {HTMLElement} pContainer - The nav container element
	 */
	_wireClickHandlers(pContainer)
	{
		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];
		let tmpState = this.pict.AppData.InlineDocumentation;

		let tmpSelf = this;

		// Collapse toggle (chevron)
		let tmpCollapseToggle = pContainer.querySelector('#InlineDoc-Nav-CollapseToggle');
		if (tmpCollapseToggle)
		{
			tmpCollapseToggle.addEventListener('click', () =>
			{
				if (tmpState)
				{
					tmpState.NavCollapsed = !tmpState.NavCollapsed;
				}
				tmpSelf._renderNavigation();
			});
		}

		// Title click also toggles
		let tmpTitleToggle = pContainer.querySelector('#InlineDoc-Nav-TitleToggle');
		if (tmpTitleToggle)
		{
			tmpTitleToggle.addEventListener('click', () =>
			{
				if (tmpState)
				{
					tmpState.NavCollapsed = !tmpState.NavCollapsed;
				}
				tmpSelf._renderNavigation();
			});
		}

		// Search icon — expands outline and focuses search input
		let tmpSearchBtn = pContainer.querySelector('#InlineDoc-Nav-SearchBtn');
		if (tmpSearchBtn)
		{
			tmpSearchBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				if (tmpState)
				{
					tmpState.NavCollapsed = false;
				}
				tmpSelf._renderNavigation();

				let tmpInput = document.getElementById('InlineDoc-Nav-FilterInput');
				if (tmpInput)
				{
					tmpInput.focus();
				}
			});
		}

		// Search / filter input
		let tmpFilterInput = pContainer.querySelector('#InlineDoc-Nav-FilterInput');
		if (tmpFilterInput)
		{
			let tmpDebounceTimer = null;

			tmpFilterInput.addEventListener('input', (pEvent) =>
			{
				let tmpValue = pEvent.target.value || '';

				if (tmpState)
				{
					tmpState.NavFilterText = tmpValue;
				}

				// If search index is loaded, debounce full-text search
				if (tmpState && tmpState.SearchIndexLoaded && tmpProvider && typeof tmpProvider.search === 'function')
				{
					if (tmpDebounceTimer) clearTimeout(tmpDebounceTimer);
					tmpDebounceTimer = setTimeout(() =>
					{
						tmpState.SearchQuery = tmpValue;
						tmpState.SearchResults = tmpValue.trim() ? tmpProvider.search(tmpValue) : [];
						tmpSelf._renderNavigation();

						let tmpNewInput = document.getElementById('InlineDoc-Nav-FilterInput');
						if (tmpNewInput)
						{
							tmpNewInput.focus();
							let tmpLen = tmpNewInput.value.length;
							tmpNewInput.setSelectionRange(tmpLen, tmpLen);
						}
					}, 250);
				}
				else
				{
					// No search index — immediate client-side filter only
					tmpSelf._renderNavigation();

					let tmpNewInput = document.getElementById('InlineDoc-Nav-FilterInput');
					if (tmpNewInput)
					{
						tmpNewInput.focus();
						let tmpLen = tmpNewInput.value.length;
						tmpNewInput.setSelectionRange(tmpLen, tmpLen);
					}
				}
			});
		}

		// Search result clicks
		let tmpSearchResults = pContainer.querySelectorAll('.pict-inline-doc-nav-search-result[data-search-path]');
		for (let i = 0; i < tmpSearchResults.length; i++)
		{
			let tmpResult = tmpSearchResults[i];
			tmpResult.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpPath = tmpResult.getAttribute('data-search-path');
				if (tmpProvider && tmpPath)
				{
					if (tmpState)
					{
						tmpState.SearchQuery = '';
						tmpState.SearchResults = [];
						tmpState.NavFilterText = '';
					}
					tmpProvider.loadDocument(tmpPath);
				}
			});
		}

		// External links — open in new tab
		let tmpExternalLinks = pContainer.querySelectorAll('[data-external-url]');
		for (let i = 0; i < tmpExternalLinks.length; i++)
		{
			let tmpExtLink = tmpExternalLinks[i];
			tmpExtLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpURL = tmpExtLink.getAttribute('data-external-url');
				if (tmpURL)
				{
					window.open(tmpURL, '_blank');
				}
			});
		}

		// Document links
		let tmpLinks = pContainer.querySelectorAll('.pict-inline-doc-nav-item[data-doc-path]');
		for (let i = 0; i < tmpLinks.length; i++)
		{
			let tmpLink = tmpLinks[i];
			tmpLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpPath = tmpLink.getAttribute('data-doc-path');
				if (tmpProvider && tmpPath)
				{
					// Clear filter when navigating
					if (tmpState)
					{
						tmpState.NavFilterText = '';
					}
					tmpProvider.loadDocument(tmpPath);
				}
			});
		}

		// Heading links
		let tmpHeadingLinks = pContainer.querySelectorAll('.pict-inline-doc-nav-heading[data-heading-slug]');
		for (let i = 0; i < tmpHeadingLinks.length; i++)
		{
			let tmpHeadingLink = tmpHeadingLinks[i];
			tmpHeadingLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpSlug = tmpHeadingLink.getAttribute('data-heading-slug');
				if (tmpProvider && tmpSlug)
				{
					tmpProvider._scrollToAnchor(tmpSlug);
				}
			});
		}

		// Group collapse toggle
		let tmpHeaders = pContainer.querySelectorAll('.pict-inline-doc-nav-group-header');
		for (let i = 0; i < tmpHeaders.length; i++)
		{
			let tmpHeader = tmpHeaders[i];
			tmpHeader.addEventListener('click', () =>
			{
				let tmpGroup = tmpHeader.parentElement;
				if (tmpGroup)
				{
					tmpGroup.classList.toggle('collapsed');

					// Persist collapse state
					let tmpGroupKey = tmpGroup.getAttribute('data-group');
					if (tmpState && tmpGroupKey)
					{
						if (!tmpState.CollapsedGroups)
						{
							tmpState.CollapsedGroups = {};
						}
						let tmpToggle = tmpGroup.querySelector('.pict-inline-doc-nav-group-toggle');
						if (tmpGroup.classList.contains('collapsed'))
						{
							tmpState.CollapsedGroups[tmpGroupKey] = true;
							if (tmpToggle)
							{
								tmpToggle.classList.add('collapsed');
							}
						}
						else
						{
							delete tmpState.CollapsedGroups[tmpGroupKey];
							if (tmpToggle)
							{
								tmpToggle.classList.remove('collapsed');
							}
						}
					}
				}
			});
		}

		// Sub-folder collapse toggle. Clicking the chevron must not navigate (the folder row is a
		// link to its first child) or bubble to the group header, so it stops both. The item list is
		// flat, so collapsing re-renders the nav (descendants are skipped on rebuild); preserve the
		// scroll position so collapsing a deep folder does not jump the sidebar to the top.
		let tmpFolderToggles = pContainer.querySelectorAll('[data-folder-toggle]');
		for (let i = 0; i < tmpFolderToggles.length; i++)
		{
			let tmpFolderToggle = tmpFolderToggles[i];
			tmpFolderToggle.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				pEvent.preventDefault();
				if (!tmpState) { return; }
				let tmpFolderPath = tmpFolderToggle.getAttribute('data-folder-toggle');
				if (!tmpFolderPath) { return; }
				if (!tmpState.CollapsedFolders) { tmpState.CollapsedFolders = {}; }
				if (tmpState.CollapsedFolders[tmpFolderPath]) { delete tmpState.CollapsedFolders[tmpFolderPath]; }
				else { tmpState.CollapsedFolders[tmpFolderPath] = true; }
				let tmpOutline = document.getElementById('InlineDoc-Nav-Outline');
				let tmpScrollTop = tmpOutline ? tmpOutline.scrollTop : 0;
				tmpSelf._renderNavigation();
				let tmpOutlineAfter = document.getElementById('InlineDoc-Nav-Outline');
				if (tmpOutlineAfter) { tmpOutlineAfter.scrollTop = tmpScrollTop; }
			});
		}

		// Topic clear button
		let tmpClearBtn = pContainer.querySelector('#InlineDoc-Nav-ClearTopic');
		if (tmpClearBtn && tmpProvider)
		{
			tmpClearBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpProvider.clearTopic();
			});
		}

		// Topic manager button
		let tmpManageBtn = pContainer.querySelector('#InlineDoc-Nav-ManageTopics');
		if (tmpManageBtn)
		{
			tmpManageBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpTopicManagerView = this.pict.views['InlineDoc-TopicManager'];
				if (tmpTopicManagerView)
				{
					tmpTopicManagerView.showTopicManager();
				}
			});
		}

		// Show / hide non-document (asset) files toggle
		let tmpAssetToggleBtn = pContainer.querySelector('#InlineDoc-Nav-ToggleAssetFiles');
		if (tmpAssetToggleBtn)
		{
			tmpAssetToggleBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpDocProvider = this.pict.providers['Pict-InlineDocumentation'];
				if (tmpDocProvider && typeof tmpDocProvider.toggleAssetFiles === 'function')
				{
					tmpDocProvider.toggleAssetFiles();
				}
			});
		}

		// Tooltip edit mode toggle
		let tmpTooltipEditBtn = pContainer.querySelector('#InlineDoc-Nav-TooltipEditMode');
		if (tmpTooltipEditBtn)
		{
			tmpTooltipEditBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpDocProvider = this.pict.providers['Pict-InlineDocumentation'];
				if (tmpDocProvider)
				{
					let tmpCurrentState = this.pict.AppData.InlineDocumentation;
					tmpDocProvider.setTooltipEditMode(!tmpCurrentState.TooltipEditMode);
				}
			});
		}

		// Bind topic to route button
		let tmpBindBtn = pContainer.querySelector('#InlineDoc-Nav-BindTopic');
		if (tmpBindBtn)
		{
			tmpBindBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpTopicManagerView = this.pict.views['InlineDoc-TopicManager'];
				if (tmpTopicManagerView)
				{
					tmpTopicManagerView.showBindTopicToRoute();
				}
			});
		}

		// Structure management: toolbar create buttons, per-node rename/delete, drag reorder/move.
		this._wireStructureHandlers(pContainer);
		this._wireDragDrop(pContainer);
	}

	// ─── structure management wiring ─────────────────────────────────────
	_provider() { return this.pict.providers['Pict-InlineDocumentation']; }
	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_dirname(pPath) { let p = String(pPath || ''); let i = p.lastIndexOf('/'); return i >= 0 ? p.slice(0, i) : ''; }
	_basename(pPath) { let p = String(pPath || ''); let i = p.lastIndexOf('/'); return i >= 0 ? p.slice(i + 1) : p; }

	/**
	 * Prompt for a single line of text via the modal (no native prompt()). Resolves
	 * to the trimmed value, or null if cancelled / empty.
	 */
	_promptForName(pTitle, pLabel, pDefault, pPlaceholder)
	{
		let tmpModal = this._modal();
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			return Promise.resolve(null);
		}
		let tmpDefault = this._escapeHTML(pDefault || '');
		let tmpContent = '<p style="margin:0 0 0.4em">' + this._escapeHTML(pLabel || 'Name') + '</p>'
			+ '<input type="text" id="InlineDoc-Structure-Prompt" class="pict-input" style="width:100%;box-sizing:border-box;padding:0.4em 0.5em" '
			+ 'value="' + tmpDefault + '" placeholder="' + this._escapeHTML(pPlaceholder || '') + '" '
			+ 'onkeydown="if(event.key===\'Enter\'){event.preventDefault();}" />';
		return tmpModal.show(
			{
				title: pTitle || 'Name',
				content: tmpContent,
				closeable: true,
				width: '420px',
				buttons:
				[
					{ Hash: 'cancel', Label: 'Cancel' },
					{ Hash: 'ok', Label: 'OK', Style: 'primary' }
				],
				onOpen: () =>
				{
					let tmpInput = document.getElementById('InlineDoc-Structure-Prompt');
					if (tmpInput) { tmpInput.focus(); tmpInput.select(); }
				}
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return null; }
				let tmpInput = document.getElementById('InlineDoc-Structure-Prompt');
				let tmpValue = tmpInput ? String(tmpInput.value || '').trim() : '';
				return tmpValue || null;
			});
	}

	/**
	 * Wire the toolbar create buttons and the per-node rename / delete actions.
	 *
	 * @param {HTMLElement} pContainer - The nav container element
	 */
	_wireStructureHandlers(pContainer)
	{
		let tmpSelf = this;
		let tmpProvider = this._provider();
		if (!tmpProvider) { return; }

		// New Folder
		let tmpNewFolderBtn = pContainer.querySelector('#InlineDoc-Nav-NewFolder');
		if (tmpNewFolderBtn)
		{
			tmpNewFolderBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpSelf._promptForName('New folder', 'Folder name (a path like guides/setup nests it):', '', 'folder-name').then((pName) =>
				{
					if (pName) { tmpProvider.requestCreateFolder('', pName); }
				});
			});
		}

		// New Document
		let tmpNewDocBtn = pContainer.querySelector('#InlineDoc-Nav-NewDoc');
		if (tmpNewDocBtn)
		{
			tmpNewDocBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpSelf._promptForName('New document', 'Document name (.md is added if omitted):', '', 'my-document').then((pName) =>
				{
					if (pName) { tmpProvider.requestCreateDocument('', pName); }
				});
			});
		}

		// Rename / Delete actions on every node
		let tmpActions = pContainer.querySelectorAll('.pict-inline-doc-nav-node-action[data-action]');
		for (let i = 0; i < tmpActions.length; i++)
		{
			let tmpAction = tmpActions[i];
			tmpAction.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				let tmpKind = tmpAction.getAttribute('data-action');
				let tmpPath = tmpAction.getAttribute('data-action-path');
				let tmpType = tmpAction.getAttribute('data-action-type') || 'file';
				if (!tmpPath) { return; }
				if (tmpKind === 'rename')
				{
					let tmpParent = tmpSelf._dirname(tmpPath);
					let tmpOldName = tmpSelf._basename(tmpPath);
					tmpSelf._promptForName('Rename', 'New name:', tmpOldName, '').then((pName) =>
					{
						if (!pName) { return; }
						let tmpNewName = pName.replace(/^\/+|\/+$/g, '');
						if (!tmpNewName || tmpNewName === tmpOldName) { return; }
						let tmpNewPath = tmpParent ? (tmpParent + '/' + tmpNewName) : tmpNewName;
						tmpProvider.requestMoveNode(tmpPath, tmpNewPath);
					});
				}
				else if (tmpKind === 'delete')
				{
					let tmpModal = tmpSelf._modal();
					let tmpName = tmpSelf._basename(tmpPath);
					let tmpMessage = (tmpType === 'folder')
						? ('Delete the folder "' + tmpName + '" and everything inside it? This cannot be undone.')
						: ('Delete "' + tmpName + '"? This cannot be undone.');
					if (tmpModal && typeof tmpModal.confirm === 'function')
					{
						tmpModal.confirm(tmpMessage, { title: 'Delete', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true }).then((pOk) =>
						{
							if (pOk) { tmpProvider.requestDeleteNode(tmpPath, tmpType); }
						});
					}
					else
					{
						tmpProvider.requestDeleteNode(tmpPath, tmpType);
					}
				}
			});
		}
	}

	/**
	 * Collect the ordered basenames of every node sharing a parent, in DOM order
	 * (deduped by path so a group whose header and inner item share a path counts
	 * once). Used to persist a drag reorder.
	 *
	 * @param {HTMLElement} pContainer - The nav container
	 * @param {string} pParent - The parent path ('' for root)
	 * @returns {Array<string>} Ordered basenames
	 */
	_gatherSiblingNames(pContainer, pParent)
	{
		let tmpNodes = pContainer.querySelectorAll('[data-node-path]');
		let tmpNames = [];
		let tmpSeen = {};
		for (let i = 0; i < tmpNodes.length; i++)
		{
			let tmpPath = tmpNodes[i].getAttribute('data-node-path');
			if (!tmpPath || this._dirname(tmpPath) !== pParent) { continue; }
			if (tmpSeen[tmpPath]) { continue; }
			tmpSeen[tmpPath] = true;
			tmpNames.push(this._basename(tmpPath));
		}
		return tmpNames;
	}

	/**
	 * Wire HTML5 drag-and-drop: reorder within a parent (-> requestReorder) and drop
	 * onto a folder to move into it (-> requestMoveNode). Optimistic visual cues; the
	 * server rewrite + reloadSidebar make it authoritative.
	 *
	 * @param {HTMLElement} pContainer - The nav container element
	 */
	_wireDragDrop(pContainer)
	{
		let tmpSelf = this;
		let tmpProvider = this._provider();
		if (!tmpProvider) { return; }
		let tmpCaps = this._structureCaps();
		if (!tmpCaps.move && !tmpCaps.reorder) { return; }

		let tmpDraggables = pContainer.querySelectorAll('[data-node-path][draggable="true"]');
		let fClearMarks = () =>
		{
			let tmpMarked = pContainer.querySelectorAll('.pict-inline-doc-nav-drop-into, .pict-inline-doc-nav-drop-before, .pict-inline-doc-nav-drop-after');
			for (let i = 0; i < tmpMarked.length; i++)
			{
				tmpMarked[i].classList.remove('pict-inline-doc-nav-drop-into', 'pict-inline-doc-nav-drop-before', 'pict-inline-doc-nav-drop-after');
			}
		};

		for (let i = 0; i < tmpDraggables.length; i++)
		{
			let tmpEl = tmpDraggables[i];

			tmpEl.addEventListener('dragstart', (pEvent) =>
			{
				let tmpPath = tmpEl.getAttribute('data-node-path');
				tmpSelf._dragState =
				{
					Path: tmpPath,
					Type: tmpEl.getAttribute('data-node-type') || 'file',
					Parent: tmpSelf._dirname(tmpPath),
					Name: tmpSelf._basename(tmpPath)
				};
				tmpEl.classList.add('pict-inline-doc-nav-dragging');
				if (pEvent.dataTransfer)
				{
					pEvent.dataTransfer.effectAllowed = 'move';
					try { pEvent.dataTransfer.setData('text/plain', tmpPath); } catch (pErr) { /* IE guard */ }
				}
			});

			tmpEl.addEventListener('dragend', () =>
			{
				tmpEl.classList.remove('pict-inline-doc-nav-dragging');
				fClearMarks();
				tmpSelf._dragState = null;
			});

			tmpEl.addEventListener('dragover', (pEvent) =>
			{
				let tmpDrag = tmpSelf._dragState;
				if (!tmpDrag) { return; }
				let tmpTargetPath = tmpEl.getAttribute('data-node-path');
				let tmpTargetType = tmpEl.getAttribute('data-node-type') || 'file';
				let tmpMode = tmpSelf._dropModeFor(tmpDrag, tmpTargetPath, tmpTargetType, pEvent, tmpEl, tmpCaps);
				if (!tmpMode) { return; }
				pEvent.preventDefault();
				if (pEvent.dataTransfer) { pEvent.dataTransfer.dropEffect = 'move'; }
				tmpEl.classList.remove('pict-inline-doc-nav-drop-into', 'pict-inline-doc-nav-drop-before', 'pict-inline-doc-nav-drop-after');
				tmpEl.classList.add('pict-inline-doc-nav-drop-' + tmpMode);
			});

			tmpEl.addEventListener('dragleave', () =>
			{
				tmpEl.classList.remove('pict-inline-doc-nav-drop-into', 'pict-inline-doc-nav-drop-before', 'pict-inline-doc-nav-drop-after');
			});

			tmpEl.addEventListener('drop', (pEvent) =>
			{
				let tmpDrag = tmpSelf._dragState;
				if (!tmpDrag) { return; }
				let tmpTargetPath = tmpEl.getAttribute('data-node-path');
				let tmpTargetType = tmpEl.getAttribute('data-node-type') || 'file';
				let tmpMode = tmpSelf._dropModeFor(tmpDrag, tmpTargetPath, tmpTargetType, pEvent, tmpEl, tmpCaps);
				pEvent.preventDefault();
				pEvent.stopPropagation();
				fClearMarks();
				if (!tmpMode) { return; }

				if (tmpMode === 'into')
				{
					// Move the dragged node into the target folder (keeping its basename).
					let tmpDestination = tmpTargetPath + '/' + tmpDrag.Name;
					tmpProvider.requestMoveNode(tmpDrag.Path, tmpDestination);
					return;
				}

				// Reorder within the shared parent: rebuild the sibling name list with the
				// dragged node repositioned before/after the target, then persist.
				let tmpNames = tmpSelf._gatherSiblingNames(pContainer, tmpDrag.Parent);
				let tmpFromIdx = tmpNames.indexOf(tmpDrag.Name);
				let tmpTargetName = tmpSelf._basename(tmpTargetPath);
				if (tmpFromIdx < 0) { return; }
				tmpNames.splice(tmpFromIdx, 1);
				let tmpTargetIdx = tmpNames.indexOf(tmpTargetName);
				if (tmpTargetIdx < 0) { return; }
				let tmpInsertIdx = (tmpMode === 'after') ? tmpTargetIdx + 1 : tmpTargetIdx;
				tmpNames.splice(tmpInsertIdx, 0, tmpDrag.Name);
				tmpProvider.requestReorder(tmpDrag.Parent, tmpNames);
			});
		}
	}

	/**
	 * Decide the drop mode for a hovered target: 'into' (move into a folder),
	 * 'before' / 'after' (reorder within the same parent), or null (not a valid drop).
	 */
	_dropModeFor(pDrag, pTargetPath, pTargetType, pEvent, pTargetEl, pCaps)
	{
		if (!pTargetPath || pTargetPath === pDrag.Path) { return null; }
		// Never drop a folder into itself or a descendant.
		if (pDrag.Type === 'folder' && (pTargetPath === pDrag.Path || pTargetPath.indexOf(pDrag.Path + '/') === 0)) { return null; }

		// Drop onto a different folder that is not already this node's parent -> move in.
		if (pCaps.move && pTargetType === 'folder' && pTargetPath !== pDrag.Parent)
		{
			return 'into';
		}

		// Same-parent nodes -> reorder (before/after by pointer position).
		if (pCaps.reorder && this._dirname(pTargetPath) === pDrag.Parent)
		{
			let tmpRect = pTargetEl.getBoundingClientRect();
			let tmpMidpoint = tmpRect.top + (tmpRect.height / 2);
			return (pEvent.clientY >= tmpMidpoint) ? 'after' : 'before';
		}

		return null;
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - Text to escape
	 * @returns {string} Escaped text
	 */
	_escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = InlineDocumentationNavView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],252:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-TopicManager",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc-tm-topic-list {
			max-height: 400px;
			overflow-y: auto;
			margin: 0 -0.5em;
		}
		.pict-inline-doc-tm-topic-item {
			display: flex;
			align-items: center;
			padding: 0.6em 0.8em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-topic-item:hover {
			background: var(--theme-color-background-secondary, #F5F0E8);
		}
		.pict-inline-doc-tm-topic-item:last-child {
			border-bottom: none;
		}
		.pict-inline-doc-tm-topic-info {
			flex: 1;
			min-width: 0;
		}
		.pict-inline-doc-tm-topic-title {
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
			font-size: 0.95em;
		}
		.pict-inline-doc-tm-topic-meta {
			font-size: 0.8em;
			color: var(--theme-color-text-muted, #8A7F72);
			margin-top: 0.15em;
		}
		.pict-inline-doc-tm-topic-actions {
			display: flex;
			gap: 0.3em;
			flex-shrink: 0;
		}
		.pict-inline-doc-tm-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.85em;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-tm-action-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			border-color: var(--theme-color-border-default, #C4BDB3);
		}
		.pict-inline-doc-tm-action-btn.danger:hover {
			background: var(--theme-color-background-tertiary, #FDE8E8);
			border-color: var(--theme-color-status-error, #E57373);
			color: var(--theme-color-status-error, #C62828);
		}
		.pict-inline-doc-tm-new-topic {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0.7em;
			margin-top: 0.5em;
			border: 1px dashed var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			color: var(--theme-color-brand-primary, #2E7D74);
			font-size: 0.9em;
			font-weight: 500;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-tm-new-topic:hover {
			background: var(--theme-color-background-hover, #F0F9F7);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-empty {
			text-align: center;
			padding: 2em 1em;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.9em;
		}
		.pict-inline-doc-tm-form-group {
			margin-bottom: 0.8em;
		}
		.pict-inline-doc-tm-form-label {
			display: block;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--theme-color-text-secondary, #5E5549);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			margin-bottom: 0.3em;
		}
		.pict-inline-doc-tm-form-input {
			width: 100%;
			padding: 0.45em 0.6em;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			box-sizing: border-box;
		}
		.pict-inline-doc-tm-form-input:focus {
			outline: none;
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 0 0 2px rgba(46, 125, 116, 0.15);
		}
		.pict-inline-doc-tm-form-input[readonly] {
			background: var(--theme-color-background-secondary, #F5F0E8);
			color: var(--theme-color-text-muted, #8A7F72);
		}
		.pict-inline-doc-tm-form-hint {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			margin-top: 0.2em;
		}
		.pict-inline-doc-tm-routes-section {
			margin-top: 0.5em;
		}
		.pict-inline-doc-tm-route-chips {
			display: flex;
			flex-wrap: wrap;
			gap: 0.3em;
			margin-bottom: 0.5em;
		}
		.pict-inline-doc-tm-route-chip {
			display: inline-flex;
			align-items: center;
			padding: 0.2em 0.5em;
			background: var(--theme-color-background-hover, #E8E3D8);
			border-radius: 12px;
			font-size: 0.82em;
			color: var(--theme-color-text-primary, #3D3229);
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
		}
		.pict-inline-doc-tm-route-chip-remove {
			margin-left: 0.4em;
			cursor: pointer;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.9em;
			line-height: 1;
		}
		.pict-inline-doc-tm-route-chip-remove:hover {
			color: var(--theme-color-status-error, #C62828);
		}
		.pict-inline-doc-tm-route-actions {
			display: flex;
			flex-wrap: wrap;
			gap: 0.3em;
		}
		.pict-inline-doc-tm-route-action-btn {
			display: inline-flex;
			align-items: center;
			padding: 0.25em 0.5em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.8em;
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-route-action-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-tm-route-action-btn.accent {
			border-color: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-route-action-btn.accent:hover {
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-tm-route-input-row {
			display: none;
			align-items: center;
			gap: 0.3em;
			margin-top: 0.4em;
		}
		.pict-inline-doc-tm-route-input-row.visible {
			display: flex;
		}
		.pict-inline-doc-tm-route-input {
			flex: 1;
			padding: 0.35em 0.5em;
			font-size: 0.85em;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
		}
		.pict-inline-doc-tm-route-input:focus {
			outline: none;
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-wc-container {
			padding: 0.5em 0;
		}
		.pict-inline-doc-tm-wc-label {
			font-size: 0.85em;
			color: var(--theme-color-text-secondary, #5E5549);
			margin-bottom: 0.6em;
		}
		.pict-inline-doc-tm-wc-segments {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 0.15em;
			margin-bottom: 0.8em;
		}
		.pict-inline-doc-tm-wc-slash {
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1.1em;
			font-weight: 300;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
		}
		.pict-inline-doc-tm-wc-segment {
			display: inline-flex;
			align-items: center;
			padding: 0.4em 0.7em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-primary, #3D3229);
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.9em;
			cursor: pointer;
			transition: background 0.15s, border-color 0.15s, opacity 0.15s;
			user-select: none;
		}
		.pict-inline-doc-tm-wc-segment:hover {
			border-color: var(--theme-color-brand-primary, #2E7D74);
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-tm-wc-segment.selected {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-wc-segment.after-wildcard {
			opacity: 0.35;
			border-style: dashed;
			cursor: default;
		}
		.pict-inline-doc-tm-wc-segment.after-wildcard:hover {
			border-color: var(--theme-color-border-default, #DDD6CA);
			background: var(--theme-color-background-panel,    #fff);
		}
		.pict-inline-doc-tm-wc-wildcard-star {
			display: inline-flex;
			align-items: center;
			padding: 0.4em 0.6em;
			color: var(--theme-color-brand-primary, #2E7D74);
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 1.1em;
			font-weight: 700;
		}
		.pict-inline-doc-tm-wc-preview {
			padding: 0.5em 0.7em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-tm-wc-preview-label {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			margin-bottom: 0.3em;
		}
		.pict-inline-doc-tm-bind-route-display {
			padding: 0.5em 0.7em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-bottom: 0.8em;
		}
		.pict-inline-doc-tm-bind-topic-list {
			max-height: 250px;
			overflow-y: auto;
			margin-bottom: 0.6em;
		}
		.pict-inline-doc-tm-bind-topic-option {
			display: flex;
			align-items: center;
			padding: 0.5em 0.6em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-bind-topic-option:hover {
			background: var(--theme-color-background-secondary, #F5F0E8);
		}
		.pict-inline-doc-tm-bind-topic-option.selected {
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-tm-bind-radio {
			width: 16px;
			height: 16px;
			border: 2px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 50%;
			margin-right: 0.6em;
			flex-shrink: 0;
			position: relative;
		}
		.pict-inline-doc-tm-bind-topic-option.selected .pict-inline-doc-tm-bind-radio {
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-bind-topic-option.selected .pict-inline-doc-tm-bind-radio::after {
			content: '';
			position: absolute;
			top: 3px;
			left: 3px;
			width: 6px;
			height: 6px;
			background: var(--theme-color-brand-primary, #2E7D74);
			border-radius: 50%;
		}
		.pict-inline-doc-tm-bind-route-type {
			display: flex;
			gap: 0.5em;
			margin-bottom: 0.5em;
		}
		.pict-inline-doc-tm-bind-route-type-btn {
			flex: 1;
			padding: 0.5em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.85em;
			text-align: center;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-tm-bind-route-type-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-tm-bind-route-type-btn.selected {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-sidebar-list {
			max-height: 300px;
			overflow-y: auto;
		}
		.pict-inline-doc-tm-sidebar-item {
			padding: 0.4em 0.6em;
			cursor: pointer;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-sidebar-item:hover {
			background: var(--theme-color-background-secondary, #F5F0E8);
		}
		.pict-inline-doc-tm-sidebar-item .path {
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.85em;
			color: var(--theme-color-text-muted, #8A7F72);
			margin-left: 0.5em;
		}
		.pict-inline-doc-tm-validation-error {
			color: var(--theme-color-status-error, #C62828);
			font-size: 0.8em;
			margin-top: 0.3em;
		}
	`,

	Templates: [],
	Renderables: []
};

class InlineDocumentationTopicManagerView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Get the modal view instance if available.
	 *
	 * @returns {Object|null} The PictSectionModal view, or null
	 */
	_getModal()
	{
		return this.pict.views['PictSectionModal'] || this.pict.views['Pict-Section-Modal'] || null;
	}

	/**
	 * Get the inline documentation provider.
	 *
	 * @returns {Object|null} The provider instance
	 */
	_getProvider()
	{
		return this.pict.providers['Pict-InlineDocumentation'] || null;
	}

	// -- Topic List --

	/**
	 * Show the topic manager modal with the full topic list.
	 */
	showTopicManager()
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal)
		{
			this.log.warn('InlineDocumentation TopicManager: Pict-Section-Modal view is not registered.');
			return;
		}

		if (!tmpProvider)
		{
			return;
		}

		let tmpTopics = tmpProvider.getTopicList();
		let tmpContent = this._buildTopicListHTML(tmpTopics);

		tmpModal.show(
		{
			title: 'Manage Topics',
			content: tmpContent,
			closeable: true,
			width: '520px',
			buttons:
			[
				{ Hash: 'close', Label: 'Close', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireTopicListHandlers(pDialog);
			}
		});
	}

	/**
	 * Build the HTML for the topic list modal.
	 *
	 * @param {Array} pTopics - Array from getTopicList()
	 * @returns {string} HTML content
	 */
	_buildTopicListHTML(pTopics)
	{
		if (!pTopics || pTopics.length < 1)
		{
			return '<div class="pict-inline-doc-tm-empty">No topics defined yet.</div>'
				+ '<div class="pict-inline-doc-tm-new-topic" data-action="new-topic">+ New Topic</div>';
		}

		let tmpHTML = '<div class="pict-inline-doc-tm-topic-list">';

		for (let i = 0; i < pTopics.length; i++)
		{
			let tmpTopic = pTopics[i];
			tmpHTML += '<div class="pict-inline-doc-tm-topic-item" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '">';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-info">';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-title">' + this._escapeHTML(tmpTopic.TopicTitle) + '</div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-meta">';
			tmpHTML += this._escapeHTML(tmpTopic.TopicCode);
			if (tmpTopic.TopicHelpFilePath)
			{
				tmpHTML += ' &middot; ' + this._escapeHTML(tmpTopic.TopicHelpFilePath);
			}
			tmpHTML += ' &middot; ' + tmpTopic.RouteCount + ' route' + (tmpTopic.RouteCount !== 1 ? 's' : '');
			tmpHTML += '</div>';
			tmpHTML += '</div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-actions">';
			tmpHTML += '<button class="pict-inline-doc-tm-action-btn" data-action="edit" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '" title="Edit"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 1.5l3 3L5 14H2v-3z"/><line x1="9" y1="4" x2="12" y2="7"/></svg></button>';
			tmpHTML += '<button class="pict-inline-doc-tm-action-btn danger" data-action="delete" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '" title="Delete"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg></button>';
			tmpHTML += '</div>';
			tmpHTML += '</div>';
		}

		tmpHTML += '</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-new-topic" data-action="new-topic">+ New Topic</div>';

		return tmpHTML;
	}

	/**
	 * Wire click handlers for the topic list modal.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 */
	_wireTopicListHandlers(pDialog)
	{
		let tmpSelf = this;
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		// Edit buttons
		let tmpEditBtns = pDialog.querySelectorAll('[data-action="edit"]');
		for (let i = 0; i < tmpEditBtns.length; i++)
		{
			tmpEditBtns[i].addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpCode = tmpEditBtns[i].getAttribute('data-topic-code');
				// Dismiss the list modal, then open editor
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() => { tmpSelf.showTopicEditor(tmpCode); }, 250);
			});
		}

		// Delete buttons
		let tmpDeleteBtns = pDialog.querySelectorAll('[data-action="delete"]');
		for (let i = 0; i < tmpDeleteBtns.length; i++)
		{
			tmpDeleteBtns[i].addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpCode = tmpDeleteBtns[i].getAttribute('data-topic-code');

				if (tmpModal && tmpModal.confirm)
				{
					tmpModal.confirm(
						'Are you sure you want to delete the topic "' + tmpCode + '"?',
						{ title: 'Delete Topic', dangerous: true }
					).then((pConfirmed) =>
					{
						if (pConfirmed && tmpProvider)
						{
							tmpProvider.removeTopic(tmpCode);
							tmpProvider.saveTopics();

							// Re-render nav
							let tmpNavView = tmpSelf.pict.views['InlineDoc-Nav'];
							if (tmpNavView)
							{
								tmpNavView.render();
							}

							if (tmpModal.toast)
							{
								tmpModal.toast('Topic deleted.', { type: 'success' });
							}

							// Re-open the list
							setTimeout(() => { tmpSelf.showTopicManager(); }, 250);
						}
					});
				}
			});
		}

		// New topic button
		let tmpNewBtn = pDialog.querySelector('[data-action="new-topic"]');
		if (tmpNewBtn)
		{
			tmpNewBtn.addEventListener('click', () =>
			{
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() => { tmpSelf.showTopicEditor(null); }, 250);
			});
		}
	}

	// -- Topic Editor --

	/**
	 * Show the topic editor modal for creating or editing a topic.
	 *
	 * @param {string|null} pTopicCode - Topic code to edit, or null for new
	 */
	showTopicEditor(pTopicCode)
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpIsNew = !pTopicCode;
		let tmpTopic = null;

		if (pTopicCode && tmpState.Topics && tmpState.Topics[pTopicCode])
		{
			// Clone for editing
			tmpTopic = JSON.parse(JSON.stringify(tmpState.Topics[pTopicCode]));
		}
		else
		{
			tmpTopic =
			{
				TopicCode: '',
				TopicTitle: '',
				TopicHelpFilePath: '',
				Routes: []
			};
		}

		let tmpContent = this._buildTopicEditorHTML(tmpTopic, tmpIsNew);

		// Track editor routes state in closure
		let tmpEditorRoutes = tmpTopic.Routes ? tmpTopic.Routes.slice() : [];

		tmpModal.show(
		{
			title: tmpIsNew ? 'New Topic' : 'Edit Topic',
			content: tmpContent,
			closeable: true,
			width: '500px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireTopicEditorHandlers(pDialog, tmpTopic, tmpIsNew, tmpEditorRoutes);
			}
		}).then((pResult) =>
		{
			if (pResult === 'save')
			{
				this._handleTopicEditorSave(tmpTopic, tmpIsNew, tmpEditorRoutes);
			}
			else
			{
				// Return to list on cancel
				setTimeout(() => { this.showTopicManager(); }, 250);
			}
		});
	}

	/**
	 * Build the HTML for the topic editor form.
	 *
	 * @param {Object} pTopic - The topic data
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @returns {string} HTML content
	 */
	_buildTopicEditorHTML(pTopic, pIsNew)
	{
		let tmpHTML = '';

		// Topic Code
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Topic Code</label>';
		if (pIsNew)
		{
			tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-code" value="" placeholder="MY-TOPIC-CODE" />';
			tmpHTML += '<div class="pict-inline-doc-tm-form-hint">Uppercase letters, numbers, and hyphens only.</div>';
		}
		else
		{
			tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-code" value="' + this._escapeHTML(pTopic.TopicCode) + '" readonly />';
		}
		tmpHTML += '<div class="pict-inline-doc-tm-validation-error" id="tm-editor-code-error"></div>';
		tmpHTML += '</div>';

		// Topic Title
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Title</label>';
		tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-title" value="' + this._escapeHTML(pTopic.TopicTitle || pTopic.Name || '') + '" placeholder="My Topic Title" />';
		tmpHTML += '<div class="pict-inline-doc-tm-validation-error" id="tm-editor-title-error"></div>';
		tmpHTML += '</div>';

		// Help File Path
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Help Document</label>';
		tmpHTML += '<div style="display:flex;gap:0.3em;align-items:center;">';
		tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-helpfile" value="' + this._escapeHTML(pTopic.TopicHelpFilePath || '') + '" placeholder="help-topic.md" style="flex:1;" />';
		tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn" id="tm-editor-browse-sidebar" title="Browse sidebar documents">Browse</button>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		// Routes
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Routes</label>';
		tmpHTML += '<div class="pict-inline-doc-tm-routes-section">';
		tmpHTML += '<div class="pict-inline-doc-tm-route-chips" id="tm-editor-route-chips">';
		tmpHTML += this._buildRouteChipsHTML(pTopic.Routes || []);
		tmpHTML += '</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-route-actions">';
		tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn" id="tm-editor-add-route">+ Add Route</button>';

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (tmpState && tmpState.CurrentRoute)
		{
			tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn accent" id="tm-editor-add-current-route">+ Current Route</button>';
			tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn accent" id="tm-editor-build-wildcard">Build Wildcard</button>';
		}

		tmpHTML += '</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-route-input-row" id="tm-editor-route-input-row">';
		tmpHTML += '<input type="text" class="pict-inline-doc-tm-route-input" id="tm-editor-route-input" placeholder="/my/route" />';
		tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn accent" id="tm-editor-route-input-add">Add</button>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * Build HTML for route chips.
	 *
	 * @param {Array} pRoutes - Array of route pattern strings
	 * @returns {string} HTML for the chips
	 */
	_buildRouteChipsHTML(pRoutes)
	{
		if (!pRoutes || pRoutes.length < 1)
		{
			return '<span style="font-size:0.8em;color:var(--theme-color-text-muted, #8A7F72);">No routes bound.</span>';
		}

		let tmpHTML = '';
		for (let i = 0; i < pRoutes.length; i++)
		{
			tmpHTML += '<span class="pict-inline-doc-tm-route-chip">';
			tmpHTML += this._escapeHTML(pRoutes[i]);
			tmpHTML += '<span class="pict-inline-doc-tm-route-chip-remove" data-route="' + this._escapeHTML(pRoutes[i]) + '">&times;</span>';
			tmpHTML += '</span>';
		}
		return tmpHTML;
	}

	/**
	 * Refresh the route chips in an open editor dialog.
	 *
	 * @param {Array} pRoutes - Current routes array
	 */
	_refreshRouteChips(pRoutes)
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('tm-editor-route-chips');
		if (tmpContainer)
		{
			tmpContainer.innerHTML = this._buildRouteChipsHTML(pRoutes);
			this._wireRouteChipRemoveHandlers(pRoutes);
		}
	}

	/**
	 * Wire remove handlers on route chips.
	 *
	 * @param {Array} pRoutes - The mutable routes array
	 */
	_wireRouteChipRemoveHandlers(pRoutes)
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpSelf = this;
		let tmpRemoveBtns = document.querySelectorAll('.pict-inline-doc-tm-route-chip-remove');
		for (let i = 0; i < tmpRemoveBtns.length; i++)
		{
			tmpRemoveBtns[i].addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpRoute = tmpRemoveBtns[i].getAttribute('data-route');
				let tmpIdx = pRoutes.indexOf(tmpRoute);
				if (tmpIdx >= 0)
				{
					pRoutes.splice(tmpIdx, 1);
				}
				tmpSelf._refreshRouteChips(pRoutes);
			});
		}
	}

	/**
	 * Wire all handlers for the topic editor form.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 * @param {Object} pTopic - The topic data
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @param {Array} pEditorRoutes - Mutable routes array for this editor session
	 */
	_wireTopicEditorHandlers(pDialog, pTopic, pIsNew, pEditorRoutes)
	{
		let tmpSelf = this;
		let tmpProvider = this._getProvider();
		let tmpState = this.pict.AppData.InlineDocumentation;

		// Route chip remove handlers
		this._wireRouteChipRemoveHandlers(pEditorRoutes);

		// Add Route button — show input row
		let tmpAddRouteBtn = document.getElementById('tm-editor-add-route');
		if (tmpAddRouteBtn)
		{
			tmpAddRouteBtn.addEventListener('click', () =>
			{
				let tmpRow = document.getElementById('tm-editor-route-input-row');
				if (tmpRow)
				{
					tmpRow.classList.toggle('visible');
					let tmpInput = document.getElementById('tm-editor-route-input');
					if (tmpInput)
					{
						tmpInput.focus();
					}
				}
			});
		}

		// Add route from text input
		let tmpRouteInputAddBtn = document.getElementById('tm-editor-route-input-add');
		if (tmpRouteInputAddBtn)
		{
			tmpRouteInputAddBtn.addEventListener('click', () =>
			{
				let tmpInput = document.getElementById('tm-editor-route-input');
				if (tmpInput && tmpInput.value.trim())
				{
					let tmpRoute = tmpInput.value.trim();
					if (tmpRoute.charAt(0) !== '/')
					{
						tmpRoute = '/' + tmpRoute;
					}
					if (pEditorRoutes.indexOf(tmpRoute) < 0)
					{
						pEditorRoutes.push(tmpRoute);
						tmpSelf._refreshRouteChips(pEditorRoutes);
					}
					tmpInput.value = '';
				}
			});
		}

		// Enter key on route input
		let tmpRouteInput = document.getElementById('tm-editor-route-input');
		if (tmpRouteInput)
		{
			tmpRouteInput.addEventListener('keydown', (pEvent) =>
			{
				if (pEvent.key === 'Enter')
				{
					pEvent.preventDefault();
					if (tmpRouteInputAddBtn)
					{
						tmpRouteInputAddBtn.click();
					}
				}
			});
		}

		// Add Current Route button
		let tmpAddCurrentBtn = document.getElementById('tm-editor-add-current-route');
		if (tmpAddCurrentBtn && tmpState && tmpState.CurrentRoute)
		{
			tmpAddCurrentBtn.addEventListener('click', () =>
			{
				let tmpRoute = tmpState.CurrentRoute;
				if (pEditorRoutes.indexOf(tmpRoute) < 0)
				{
					pEditorRoutes.push(tmpRoute);
					tmpSelf._refreshRouteChips(pEditorRoutes);
				}
			});
		}

		// Build Wildcard button
		let tmpWildcardBtn = document.getElementById('tm-editor-build-wildcard');
		if (tmpWildcardBtn && tmpProvider && tmpState && tmpState.CurrentRoute)
		{
			tmpWildcardBtn.addEventListener('click', () =>
			{
				let tmpModal = tmpSelf._getModal();
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() =>
				{
					tmpSelf.showWildcardBuilder(tmpState.CurrentRoute, (pPattern) =>
					{
						if (pPattern && pEditorRoutes.indexOf(pPattern) < 0)
						{
							pEditorRoutes.push(pPattern);
						}
						// Re-open the editor
						tmpSelf._reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes);
					});
				}, 250);
			});
		}

		// Browse Sidebar button
		let tmpBrowseBtn = document.getElementById('tm-editor-browse-sidebar');
		if (tmpBrowseBtn)
		{
			tmpBrowseBtn.addEventListener('click', () =>
			{
				let tmpModal = tmpSelf._getModal();
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() =>
				{
					tmpSelf._showSidebarPicker((pPath) =>
					{
						if (pPath)
						{
							pTopic.TopicHelpFilePath = pPath;
						}
						tmpSelf._reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes);
					});
				}, 250);
			});
		}
	}

	/**
	 * Re-open the topic editor after returning from a sub-flow (wildcard builder, sidebar picker).
	 *
	 * Captures current form values from the DOM before the modal was dismissed,
	 * then reconstructs the editor with updated state.
	 *
	 * @param {Object} pTopic - The topic data (may have been updated by sub-flow)
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @param {Array} pEditorRoutes - Current routes for this editor session
	 */
	_reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes)
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			return;
		}

		// Rebuild the topic from whatever was captured
		let tmpContent = this._buildTopicEditorHTML(
		{
			TopicCode: pTopic.TopicCode,
			TopicTitle: pTopic.TopicTitle,
			TopicHelpFilePath: pTopic.TopicHelpFilePath,
			Routes: pEditorRoutes
		}, pIsNew);

		tmpModal.show(
		{
			title: pIsNew ? 'New Topic' : 'Edit Topic',
			content: tmpContent,
			closeable: true,
			width: '500px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireTopicEditorHandlers(pDialog, pTopic, pIsNew, pEditorRoutes);
			}
		}).then((pResult) =>
		{
			if (pResult === 'save')
			{
				this._handleTopicEditorSave(pTopic, pIsNew, pEditorRoutes);
			}
			else
			{
				setTimeout(() => { this.showTopicManager(); }, 250);
			}
		});
	}

	/**
	 * Handle saving from the topic editor.
	 *
	 * Reads form values, validates, and persists.
	 *
	 * @param {Object} pTopic - The original topic data
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @param {Array} pEditorRoutes - Current routes from the editor
	 */
	_handleTopicEditorSave(pTopic, pIsNew, pEditorRoutes)
	{
		let tmpProvider = this._getProvider();
		let tmpModal = this._getModal();
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpProvider)
		{
			return;
		}

		// Read form values from DOM (they're still present briefly during dismiss)
		let tmpCode = '';
		let tmpTitle = '';
		let tmpHelpFile = '';

		if (typeof document !== 'undefined')
		{
			let tmpCodeInput = document.getElementById('tm-editor-code');
			let tmpTitleInput = document.getElementById('tm-editor-title');
			let tmpHelpInput = document.getElementById('tm-editor-helpfile');

			if (tmpCodeInput) { tmpCode = tmpCodeInput.value.trim(); }
			if (tmpTitleInput) { tmpTitle = tmpTitleInput.value.trim(); }
			if (tmpHelpInput) { tmpHelpFile = tmpHelpInput.value.trim(); }
		}

		// Validation
		let tmpErrors = [];

		if (pIsNew)
		{
			if (!tmpCode)
			{
				tmpErrors.push('Topic Code is required.');
			}
			else if (!/^[A-Z0-9][A-Z0-9-]*$/.test(tmpCode))
			{
				tmpErrors.push('Topic Code must use uppercase letters, numbers, and hyphens only.');
			}
			else if (tmpState.Topics && tmpState.Topics[tmpCode])
			{
				tmpErrors.push('A topic with code "' + tmpCode + '" already exists.');
			}
		}
		else
		{
			tmpCode = pTopic.TopicCode;
		}

		if (!tmpTitle)
		{
			tmpErrors.push('Title is required.');
		}

		if (tmpErrors.length > 0)
		{
			if (tmpModal && tmpModal.toast)
			{
				tmpModal.toast(tmpErrors.join(' '), { type: 'error' });
			}
			// Re-open editor with current values
			pTopic.TopicTitle = tmpTitle;
			pTopic.TopicHelpFilePath = tmpHelpFile;
			if (pIsNew)
			{
				pTopic.TopicCode = tmpCode;
			}
			setTimeout(() => { this._reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes); }, 300);
			return;
		}

		// Apply changes
		if (pIsNew)
		{
			tmpProvider.addTopic(tmpCode,
			{
				TopicCode: tmpCode,
				TopicTitle: tmpTitle,
				TopicHelpFilePath: tmpHelpFile,
				Routes: pEditorRoutes
			});
		}
		else
		{
			tmpProvider.updateTopic(tmpCode,
			{
				TopicTitle: tmpTitle,
				TopicHelpFilePath: tmpHelpFile,
				Routes: pEditorRoutes
			});
		}

		tmpProvider.saveTopics();

		// Re-render nav
		let tmpNavView = this.pict.views['InlineDoc-Nav'];
		if (tmpNavView)
		{
			tmpNavView.render();
		}

		if (tmpModal && tmpModal.toast)
		{
			tmpModal.toast('Topic saved.', { type: 'success' });
		}

		// Return to topic list
		setTimeout(() => { this.showTopicManager(); }, 300);
	}

	// -- Wildcard Builder --

	/**
	 * Show the wildcard builder modal.
	 *
	 * Displays route segments as clickable blocks and lets the user
	 * visually choose where the wildcard starts.
	 *
	 * @param {string} pCurrentRoute - The route to build a pattern for
	 * @param {Function} fOnSelect - Callback receiving the selected pattern (or null on cancel)
	 */
	showWildcardBuilder(pCurrentRoute, fOnSelect)
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			if (typeof fOnSelect === 'function') { fOnSelect(null); }
			return;
		}

		let tmpSegments = tmpProvider.getRouteSegments(pCurrentRoute);

		if (tmpSegments.length < 1)
		{
			if (tmpModal.toast)
			{
				tmpModal.toast('No route segments to build a wildcard from.', { type: 'error' });
			}
			if (typeof fOnSelect === 'function') { fOnSelect(null); }
			return;
		}

		// Default selection: last segment before end (or first if only one)
		let tmpSelectedIndex = Math.max(0, tmpSegments.length - 2);
		let tmpContent = this._buildWildcardBuilderHTML(tmpSegments, pCurrentRoute, tmpSelectedIndex);

		tmpModal.show(
		{
			title: 'Build Wildcard Pattern',
			content: tmpContent,
			closeable: true,
			width: '520px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'exact', Label: 'Use Exact Route' },
				{ Hash: 'pattern', Label: 'Use Pattern', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireWildcardBuilderHandlers(pDialog, tmpSegments, tmpSelectedIndex);
			}
		}).then((pResult) =>
		{
			if (pResult === 'pattern')
			{
				// Get the current selection
				let tmpPreview = (typeof document !== 'undefined') ? document.getElementById('tm-wc-preview-value') : null;
				let tmpPattern = tmpPreview ? tmpPreview.textContent : tmpSegments[tmpSelectedIndex].WildcardPattern;
				if (typeof fOnSelect === 'function') { fOnSelect(tmpPattern); }
			}
			else if (pResult === 'exact')
			{
				if (typeof fOnSelect === 'function') { fOnSelect(pCurrentRoute); }
			}
			else
			{
				if (typeof fOnSelect === 'function') { fOnSelect(null); }
			}
		});
	}

	/**
	 * Build the HTML for the wildcard builder.
	 *
	 * @param {Array} pSegments - Segment objects from getRouteSegments()
	 * @param {string} pCurrentRoute - The original route
	 * @param {number} pSelectedIndex - The initially selected segment index
	 * @returns {string} HTML content
	 */
	_buildWildcardBuilderHTML(pSegments, pCurrentRoute, pSelectedIndex)
	{
		let tmpHTML = '<div class="pict-inline-doc-tm-wc-container">';

		tmpHTML += '<div class="pict-inline-doc-tm-wc-label">Click a segment to set the wildcard boundary. Everything after the selected segment will match any path.</div>';

		tmpHTML += '<div class="pict-inline-doc-tm-wc-segments" id="tm-wc-segments">';

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpClass = 'pict-inline-doc-tm-wc-segment';
			if (i === pSelectedIndex)
			{
				tmpClass += ' selected';
			}
			else if (i > pSelectedIndex)
			{
				tmpClass += ' after-wildcard';
			}

			tmpHTML += '<span class="pict-inline-doc-tm-wc-slash">/</span>';
			tmpHTML += '<span class="' + tmpClass + '" data-segment-index="' + i + '">';
			tmpHTML += this._escapeHTML(pSegments[i].Segment);
			tmpHTML += '</span>';
		}

		tmpHTML += '<span class="pict-inline-doc-tm-wc-slash">/</span>';
		tmpHTML += '<span class="pict-inline-doc-tm-wc-wildcard-star" id="tm-wc-star">*</span>';

		tmpHTML += '</div>';

		tmpHTML += '<div class="pict-inline-doc-tm-wc-preview-label">Pattern</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-wc-preview" id="tm-wc-preview-value">';
		tmpHTML += this._escapeHTML(pSegments[pSelectedIndex].WildcardPattern);
		tmpHTML += '</div>';

		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * Wire click handlers for the wildcard builder segments.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 * @param {Array} pSegments - Segment objects
	 * @param {number} pInitialIndex - Initially selected index
	 */
	_wireWildcardBuilderHandlers(pDialog, pSegments, pInitialIndex)
	{
		let tmpSelectedIndex = pInitialIndex;

		let tmpUpdateSelection = (pNewIndex) =>
		{
			tmpSelectedIndex = pNewIndex;
			let tmpSegmentEls = pDialog.querySelectorAll('.pict-inline-doc-tm-wc-segment');
			for (let i = 0; i < tmpSegmentEls.length; i++)
			{
				let tmpIdx = parseInt(tmpSegmentEls[i].getAttribute('data-segment-index'), 10);
				tmpSegmentEls[i].classList.remove('selected', 'after-wildcard');
				if (tmpIdx === pNewIndex)
				{
					tmpSegmentEls[i].classList.add('selected');
				}
				else if (tmpIdx > pNewIndex)
				{
					tmpSegmentEls[i].classList.add('after-wildcard');
				}
			}

			let tmpPreview = pDialog.querySelector('#tm-wc-preview-value');
			if (tmpPreview)
			{
				tmpPreview.textContent = pSegments[pNewIndex].WildcardPattern;
			}
		};

		let tmpSegmentEls = pDialog.querySelectorAll('.pict-inline-doc-tm-wc-segment');
		for (let i = 0; i < tmpSegmentEls.length; i++)
		{
			tmpSegmentEls[i].addEventListener('click', () =>
			{
				let tmpIdx = parseInt(tmpSegmentEls[i].getAttribute('data-segment-index'), 10);
				tmpUpdateSelection(tmpIdx);
			});
		}
	}

	// -- Bind Topic to Route --

	/**
	 * Show the quick-bind flow for connecting a topic to the current route.
	 */
	showBindTopicToRoute()
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState || !tmpState.CurrentRoute)
		{
			if (tmpModal.toast)
			{
				tmpModal.toast('No current route to bind to.', { type: 'error' });
			}
			return;
		}

		let tmpCurrentRoute = tmpState.CurrentRoute;
		let tmpTopics = tmpProvider.getTopicList();
		let tmpContent = this._buildBindHTML(tmpCurrentRoute, tmpTopics);

		// Track selection state
		let tmpSelectedTopicCode = null;
		let tmpRouteType = 'exact'; // 'exact' or 'wildcard'

		tmpModal.show(
		{
			title: 'Bind Topic to Route',
			content: tmpContent,
			closeable: true,
			width: '480px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'bind', Label: 'Bind Route', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireBindHandlers(pDialog, tmpTopics, tmpCurrentRoute,
					(pCode) => { tmpSelectedTopicCode = pCode; },
					(pType) => { tmpRouteType = pType; }
				);
			}
		}).then((pResult) =>
		{
			if (pResult !== 'bind' || !tmpSelectedTopicCode)
			{
				return;
			}

			if (tmpSelectedTopicCode === '__NEW__')
			{
				// Open new topic editor with current route pre-filled
				this.showTopicEditor(null);
				return;
			}

			if (tmpRouteType === 'wildcard')
			{
				// Open wildcard builder, then bind
				this.showWildcardBuilder(tmpCurrentRoute, (pPattern) =>
				{
					if (pPattern)
					{
						tmpProvider.addRouteToTopic(tmpSelectedTopicCode, pPattern);
						tmpProvider.saveTopics();

						let tmpNavView = this.pict.views['InlineDoc-Nav'];
						if (tmpNavView) { tmpNavView.render(); }

						if (tmpModal.toast)
						{
							tmpModal.toast('Route bound to topic.', { type: 'success' });
						}
					}
				});
			}
			else
			{
				// Exact match bind
				tmpProvider.addRouteToTopic(tmpSelectedTopicCode, tmpCurrentRoute);
				tmpProvider.saveTopics();

				let tmpNavView = this.pict.views['InlineDoc-Nav'];
				if (tmpNavView) { tmpNavView.render(); }

				if (tmpModal.toast)
				{
					tmpModal.toast('Route bound to topic.', { type: 'success' });
				}
			}
		});
	}

	/**
	 * Build the HTML for the bind-topic-to-route modal.
	 *
	 * @param {string} pCurrentRoute - The current route
	 * @param {Array} pTopics - Topic list
	 * @returns {string} HTML content
	 */
	_buildBindHTML(pCurrentRoute, pTopics)
	{
		let tmpHTML = '';

		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-display">' + this._escapeHTML(pCurrentRoute) + '</div>';

		// Route type selection
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Route Match Type</label>';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-type">';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-type-btn selected" data-route-type="exact">Exact Match</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-type-btn" data-route-type="wildcard">Wildcard Pattern</div>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		// Topic selection
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Select Topic</label>';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-topic-list">';

		for (let i = 0; i < pTopics.length; i++)
		{
			let tmpTopic = pTopics[i];
			tmpHTML += '<div class="pict-inline-doc-tm-bind-topic-option" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '">';
			tmpHTML += '<div class="pict-inline-doc-tm-bind-radio"></div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-info">';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-title">' + this._escapeHTML(tmpTopic.TopicTitle) + '</div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-meta">' + this._escapeHTML(tmpTopic.TopicCode) + '</div>';
			tmpHTML += '</div>';
			tmpHTML += '</div>';
		}

		// Create new option
		tmpHTML += '<div class="pict-inline-doc-tm-bind-topic-option" data-topic-code="__NEW__">';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-radio"></div>';
		tmpHTML += '<div class="pict-inline-doc-tm-topic-info">';
		tmpHTML += '<div class="pict-inline-doc-tm-topic-title" style="color:var(--theme-color-brand-primary, #2E7D74);">+ Create New Topic</div>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		tmpHTML += '</div>';
		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * Wire handlers for the bind-topic-to-route modal.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 * @param {Array} pTopics - Topic list
	 * @param {string} pCurrentRoute - The current route
	 * @param {Function} fOnTopicSelect - Called with selected topic code
	 * @param {Function} fOnRouteTypeSelect - Called with 'exact' or 'wildcard'
	 */
	_wireBindHandlers(pDialog, pTopics, pCurrentRoute, fOnTopicSelect, fOnRouteTypeSelect)
	{
		// Topic selection
		let tmpTopicOptions = pDialog.querySelectorAll('.pict-inline-doc-tm-bind-topic-option');
		for (let i = 0; i < tmpTopicOptions.length; i++)
		{
			tmpTopicOptions[i].addEventListener('click', () =>
			{
				// Deselect all
				for (let j = 0; j < tmpTopicOptions.length; j++)
				{
					tmpTopicOptions[j].classList.remove('selected');
				}
				tmpTopicOptions[i].classList.add('selected');
				fOnTopicSelect(tmpTopicOptions[i].getAttribute('data-topic-code'));
			});
		}

		// Route type selection
		let tmpRouteTypeBtns = pDialog.querySelectorAll('.pict-inline-doc-tm-bind-route-type-btn');
		for (let i = 0; i < tmpRouteTypeBtns.length; i++)
		{
			tmpRouteTypeBtns[i].addEventListener('click', () =>
			{
				for (let j = 0; j < tmpRouteTypeBtns.length; j++)
				{
					tmpRouteTypeBtns[j].classList.remove('selected');
				}
				tmpRouteTypeBtns[i].classList.add('selected');
				fOnRouteTypeSelect(tmpRouteTypeBtns[i].getAttribute('data-route-type'));
			});
		}
	}

	// -- Sidebar Picker --

	/**
	 * Show a sidebar document picker modal.
	 *
	 * @param {Function} fOnSelect - Callback receiving the selected path (or null)
	 */
	_showSidebarPicker(fOnSelect)
	{
		let tmpModal = this._getModal();
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpModal)
		{
			if (typeof fOnSelect === 'function') { fOnSelect(null); }
			return;
		}

		let tmpGroups = (tmpState && tmpState.SidebarGroups) ? tmpState.SidebarGroups : [];
		let tmpContent = this._buildSidebarPickerHTML(tmpGroups);

		tmpModal.show(
		{
			title: 'Select Document',
			content: tmpContent,
			closeable: true,
			width: '400px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' }
			],
			onOpen: (pDialog) =>
			{
				let tmpItems = pDialog.querySelectorAll('.pict-inline-doc-tm-sidebar-item');
				for (let i = 0; i < tmpItems.length; i++)
				{
					tmpItems[i].addEventListener('click', () =>
					{
						let tmpPath = tmpItems[i].getAttribute('data-path');
						if (tmpModal.dismissModals)
						{
							tmpModal.dismissModals();
						}
						if (typeof fOnSelect === 'function') { fOnSelect(tmpPath); }
					});
				}
			}
		}).then((pResult) =>
		{
			if (pResult === 'cancel' || pResult === null)
			{
				if (typeof fOnSelect === 'function') { fOnSelect(null); }
			}
		});
	}

	/**
	 * Build the HTML for the sidebar document picker.
	 *
	 * @param {Array} pGroups - SidebarGroups array
	 * @returns {string} HTML content
	 */
	_buildSidebarPickerHTML(pGroups)
	{
		let tmpHTML = '<div class="pict-inline-doc-tm-sidebar-list">';
		let tmpHasItems = false;

		for (let i = 0; i < pGroups.length; i++)
		{
			let tmpGroup = pGroups[i];

			if (tmpGroup.Path)
			{
				tmpHasItems = true;
				tmpHTML += '<div class="pict-inline-doc-tm-sidebar-item" data-path="' + this._escapeHTML(tmpGroup.Path) + '">';
				tmpHTML += this._escapeHTML(tmpGroup.Name);
				tmpHTML += '<span class="path">' + this._escapeHTML(tmpGroup.Path) + '</span>';
				tmpHTML += '</div>';
			}

			let tmpItems = tmpGroup.Items || [];
			for (let j = 0; j < tmpItems.length; j++)
			{
				if (tmpItems[j].Path)
				{
					tmpHasItems = true;
					tmpHTML += '<div class="pict-inline-doc-tm-sidebar-item" data-path="' + this._escapeHTML(tmpItems[j].Path) + '">';
					tmpHTML += this._escapeHTML(tmpItems[j].Name);
					tmpHTML += '<span class="path">' + this._escapeHTML(tmpItems[j].Path) + '</span>';
					tmpHTML += '</div>';
				}
			}
		}

		if (!tmpHasItems)
		{
			tmpHTML += '<div class="pict-inline-doc-tm-empty">No sidebar documents found.</div>';
		}

		tmpHTML += '</div>';
		return tmpHTML;
	}

	// -- Utilities --

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - Text to escape
	 * @returns {string} Escaped text
	 */
	_escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = InlineDocumentationTopicManagerView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],253:[function(require,module,exports){
module.exports = (
{
	"RenderOnLoad": true,

	"DefaultRenderable": "Login-Container",
	"DefaultDestinationAddress": "#Pict-Login-Container",

	"TargetElementAddress": "#Pict-Login-Container",

	// ----- Endpoint Configuration -----
	// Defaults match orator-authentication routes.
	// Override these to point at any custom backend.
	"LoginEndpoint": "/1.0/Authenticate",
	// "POST" sends JSON body { UserName, Password }.
	// "GET"  appends /:username/:password to LoginEndpoint.
	"LoginMethod": "POST",
	"LogoutEndpoint": "/1.0/Deauthenticate",
	"CheckSessionEndpoint": "/1.0/CheckSession",
	"OAuthProvidersEndpoint": "/1.0/OAuth/Providers",
	"OAuthBeginEndpoint": "/1.0/OAuth/Begin",

	// Passwordless "magic link" sign-in. Request emails a one-time link; Verify consumes its token.
	// Defaults match the plansheet / orator-authentication magic-link routes; override for any backend.
	"MagicLinkRequestEndpoint": "/1.0/Login/MagicLink/Request",
	"MagicLinkVerifyEndpoint": "/1.0/Login/MagicLink/Verify",

	// ----- Behavior -----
	"CheckSessionOnLoad": true,
	"ShowOAuthProviders": false,
	// When true, the card offers a "sign in with a link instead" toggle beneath the password form.
	"ShowMagicLink": false,

	// ----- Data Address -----
	// Where session state is stored in the Pict address space.
	"SessionDataAddress": "AppData.Session",

	// ----- Templates -----
	"Templates":
	[
		{
			"Hash": "Pict-Login-Template-Wrapper",
			"Template": "<div class=\"pict-login-card\"><div id=\"pict-login-error\" class=\"pict-login-error\" style=\"display:none\"></div><div id=\"pict-login-form-area\"></div><div id=\"pict-login-oauth-area\"></div><div id=\"pict-login-status-area\" style=\"display:none\"></div></div>"
		},
		{
			"Hash": "Pict-Login-Template-Form",
			"Template": "<form id=\"pict-login-form\" class=\"pict-login-form\"><label class=\"pict-login-label\" for=\"pict-login-username\">Username</label><input class=\"pict-login-input\" type=\"text\" id=\"pict-login-username\" name=\"username\" autocomplete=\"username\" placeholder=\"Enter username\" /><label class=\"pict-login-label\" for=\"pict-login-password\">Password</label><input class=\"pict-login-input\" type=\"password\" id=\"pict-login-password\" name=\"password\" autocomplete=\"current-password\" placeholder=\"Enter password\" /><button class=\"pict-login-submit\" type=\"submit\">Log In</button></form>"
		},
		{
			"Hash": "Pict-Login-Template-MagicToggle",
			"Template": "<div class=\"pict-login-alt\"><button type=\"button\" class=\"pict-login-altlink\" id=\"pict-login-show-magic\">Email me a sign-in link instead</button></div>"
		},
		{
			"Hash": "Pict-Login-Template-MagicForm",
			"Template": "<form id=\"pict-login-magic-form\" class=\"pict-login-form\"><label class=\"pict-login-label\" for=\"pict-login-magic-email\">Email</label><input class=\"pict-login-input\" type=\"email\" id=\"pict-login-magic-email\" name=\"email\" autocomplete=\"email\" placeholder=\"you@example.com\" /><button class=\"pict-login-submit\" type=\"submit\">Email me a sign-in link</button><div class=\"pict-login-alt\"><button type=\"button\" class=\"pict-login-altlink\" id=\"pict-login-show-password\">Use a password instead</button></div></form>"
		},
		{
			"Hash": "Pict-Login-Template-MagicSent",
			"Template": "<div class=\"pict-login-sent\"><div class=\"pict-login-sent-title\">Check your email</div><div class=\"pict-login-sent-body\">If an account matches that address, a one-time sign-in link is on its way. It expires shortly and can be used once.</div><div class=\"pict-login-alt\"><button type=\"button\" class=\"pict-login-altlink\" id=\"pict-login-magic-again\">Use a different email</button></div></div>"
		},
		{
			"Hash": "Pict-Login-Template-Status",
			"Template": "<div class=\"pict-login-status\"><span class=\"pict-login-dot pict-login-dot--on\"></span><span class=\"pict-login-user-label\">Logged in as <strong id=\"pict-login-display-name\"></strong></span><span class=\"pict-login-user-id\" id=\"pict-login-display-id\"></span><button class=\"pict-login-logout-btn\" id=\"pict-login-logout\" type=\"button\">Log out</button></div>"
		},
		{
			"Hash": "Pict-Login-Template-OAuthProviders",
			"Template": "<div class=\"pict-login-oauth\"><div class=\"pict-login-oauth-divider\"><span>or sign in with</span></div><div class=\"pict-login-oauth-buttons\" id=\"pict-login-oauth-buttons\"></div></div>"
		},
		{
			"Hash": "Pict-Login-Template-Error",
			"Template": "<div class=\"pict-login-error-message\">{~D:Record.Message~}</div>"
		}
	],

	// ----- Renderables -----
	"Renderables":
	[
		{
			"RenderableHash": "Login-Container",
			"TemplateHash": "Pict-Login-Template-Wrapper",
			"DestinationAddress": "#Pict-Login-Container"
		}
	],

	// ----- CSS -----
	"CSS": `.pict-login-card
{
	max-width: 400px;
	margin: 2rem auto;
	background: var(--theme-color-background-panel, #fff);
	border: 1px solid var(--theme-color-border-default, #D4A373);
	border-top: 4px solid var(--theme-color-brand-primary, #E76F51);
	border-radius: 6px;
	padding: 1.5rem;
	box-shadow: 0 2px 8px rgba(38,70,83,0.08);
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
	color: var(--theme-color-text-primary, #264653);
}

/* ----- Form ----- */
.pict-login-form
{
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}
.pict-login-label
{
	font-weight: 600;
	font-size: 0.85rem;
	color: var(--theme-color-text-primary, #264653);
}
.pict-login-input
{
	border: 1px solid var(--theme-color-border-light, #D4C4A8);
	background: var(--theme-color-background-secondary, #FFFCF7);
	padding: 0.55rem 0.7rem;
	border-radius: 4px;
	font-size: 0.9rem;
	color: var(--theme-color-text-primary, #264653);
	width: 100%;
	box-sizing: border-box;
}
.pict-login-input:focus
{
	outline: none;
	border-color: var(--theme-color-brand-primary, #E76F51);
	box-shadow: 0 0 0 2px rgba(231,111,81,0.15);
}
.pict-login-submit
{
	background: var(--theme-color-brand-primary, #E76F51);
	color: var(--theme-color-text-on-brand, #fff);
	border: none;
	padding: 0.6rem 1.25rem;
	border-radius: 4px;
	font-size: 0.9rem;
	font-weight: 600;
	cursor: pointer;
	margin-top: 0.25rem;
}
.pict-login-submit:hover
{
	background: var(--theme-color-brand-primary-hover, #C45A3E);
}
.pict-login-submit:disabled
{
	opacity: 0.6;
	cursor: not-allowed;
}

/* ----- Error ----- */
.pict-login-error
{
	background: var(--theme-color-background-tertiary, #FDECEA);
	border: 1px solid var(--theme-color-brand-primary, #E76F51);
	color: var(--theme-color-status-error, #8B2500);
	border-radius: 4px;
	padding: 0.6rem 0.8rem;
	font-size: 0.85rem;
	margin-bottom: 0.75rem;
}

/* ----- Logged-In Status ----- */
.pict-login-status
{
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}
.pict-login-dot
{
	width: 10px;
	height: 10px;
	border-radius: 50%;
	flex-shrink: 0;
}
.pict-login-dot--on
{
	background: var(--theme-color-status-success, #2A9D8F);
	box-shadow: 0 0 4px rgba(42,157,143,0.5);
}
.pict-login-dot--off
{
	background: var(--theme-color-text-muted, #999);
}
.pict-login-user-label
{
	font-size: 0.9rem;
}
.pict-login-user-id
{
	background: var(--theme-color-text-primary, #264653);
	color: var(--theme-color-text-on-brand, #FAEDCD);
	font-size: 0.7rem;
	font-weight: 700;
	padding: 0.15rem 0.5rem;
	border-radius: 9999px;
}
.pict-login-logout-btn
{
	margin-left: auto;
	background: var(--theme-color-text-primary, #264653);
	color: var(--theme-color-text-on-brand, #FAEDCD);
	border: none;
	padding: 0.4rem 1rem;
	border-radius: 4px;
	font-size: 0.8rem;
	font-weight: 600;
	cursor: pointer;
}
.pict-login-logout-btn:hover
{
	background: var(--theme-color-text-primary, #1A3340);
}

/* ----- OAuth ----- */
.pict-login-oauth
{
	margin-top: 1rem;
}
.pict-login-oauth-divider
{
	display: flex;
	align-items: center;
	gap: 0.75rem;
	margin-bottom: 0.75rem;
	color: var(--theme-color-text-muted, #999);
	font-size: 0.8rem;
}
.pict-login-oauth-divider::before,
.pict-login-oauth-divider::after
{
	content: '';
	flex: 1;
	height: 1px;
	background: var(--theme-color-border-light, #D4C4A8);
}
.pict-login-oauth-buttons
{
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}
.pict-login-oauth-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	padding: 0.55rem 1rem;
	border-radius: 4px;
	font-size: 0.85rem;
	font-weight: 600;
	cursor: pointer;
	text-decoration: none;
	border: 1px solid var(--theme-color-border-light, #D4C4A8);
	background: var(--theme-color-background-panel, #fff);
	color: var(--theme-color-text-primary, #264653);
}
.pict-login-oauth-btn:hover
{
	background: var(--theme-color-background-secondary, #F5F0E8);
}
.pict-login-oauth-btn--google
{
	border-color: #4285F4;
	color: #4285F4;
}
.pict-login-oauth-btn--google:hover
{
	background: #EBF2FE;
}
.pict-login-oauth-btn--microsoft
{
	border-color: #00A4EF;
	color: #00A4EF;
}
.pict-login-oauth-btn--microsoft:hover
{
	background: #E6F6FE;
}

/* ----- Magic link (passwordless) ----- */
.pict-login-alt
{
	margin-top: 0.75rem;
	text-align: center;
}
.pict-login-altlink
{
	background: none;
	border: none;
	padding: 0.25rem;
	font-size: 0.8rem;
	font-weight: 600;
	color: var(--theme-color-brand-primary, #E76F51);
	cursor: pointer;
	text-decoration: underline;
}
.pict-login-altlink:hover
{
	color: var(--theme-color-brand-primary-hover, #C45A3E);
}
.pict-login-sent
{
	text-align: center;
	padding: 0.5rem 0;
}
.pict-login-sent-title
{
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 0.4rem;
	color: var(--theme-color-text-primary, #264653);
}
.pict-login-sent-body
{
	font-size: 0.85rem;
	color: var(--theme-color-text-muted, #666);
	line-height: 1.4;
}
`
});

},{}],254:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('./Pict-Section-Login-DefaultConfiguration.js');

class PictSectionLogin extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// --- State ---
		this.authenticated = false;
		this.sessionData = null;
		this.oauthProviders = [];
		this.magicLinkMode = false;

		this.initialRenderComplete = false;
	}

	// ===== Lifecycle Hooks =====

	onBeforeInitialize()
	{
		return super.onBeforeInitialize();
	}

	onAfterRender(pRenderable)
	{
		// Inject all registered CSS into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Populate the form (or status) into the wrapper placeholders
		this._updateView();

		if (this.options.CheckSessionOnLoad)
		{
			this.checkSession();
		}

		if (this.options.ShowOAuthProviders)
		{
			this.loadOAuthProviders();
		}
	}

	// ===== Public API =====

	/**
	 * Authenticate with username and password.
	 *
	 * @param {string} pUsername - The username / login ID
	 * @param {string} pPassword - The password
	 * @param {function} [fCallback] - Optional callback(pError, pSessionData)
	 */
	login(pUsername, pPassword, fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		this._clearError();

		let tmpFetchOptions = {};
		let tmpURL = this.options.LoginEndpoint;

		if (this.options.LoginMethod === 'GET')
		{
			tmpURL = tmpURL + '/' + encodeURIComponent(pUsername) + '/' + encodeURIComponent(pPassword);
			tmpFetchOptions.method = 'GET';
		}
		else
		{
			tmpFetchOptions.method = 'POST';
			tmpFetchOptions.headers = { 'Content-Type': 'application/json' };
			tmpFetchOptions.body = JSON.stringify({ UserName: pUsername, Password: pPassword });
		}

		fetch(tmpURL, tmpFetchOptions)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then((pData) =>
			{
				if (pData && pData.LoggedIn)
				{
					this.authenticated = true;
					this.sessionData = pData;
					this._storeSessionData(pData);
					this._updateView();
					this.onLoginSuccess(pData);
					this._solveApp();
					return fCallback(null, pData);
				}
				else
				{
					let tmpError = (pData && pData.Error) ? pData.Error : 'Authentication failed.';
					this._displayError(tmpError);
					this.onLoginFailed(tmpError);
					return fCallback(tmpError);
				}
			})
			.catch((pError) =>
			{
				let tmpMessage = 'Login request failed.';
				this.log.error('PictSectionLogin login error: ' + pError.message);
				this._displayError(tmpMessage);
				this.onLoginFailed(tmpMessage);
				return fCallback(tmpMessage);
			});
	}

	/**
	 * End the current session.
	 *
	 * @param {function} [fCallback] - Optional callback(pError)
	 */
	logout(fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		fetch(this.options.LogoutEndpoint)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then(() =>
			{
				this.authenticated = false;
				this.sessionData = null;
				this._storeSessionData(null);
				this._updateView();
				this.onLogout();
				this._solveApp();
				return fCallback(null);
			})
			.catch((pError) =>
			{
				this.log.error('PictSectionLogin logout error: ' + pError.message);
				// Clear local state even if network failed
				this.authenticated = false;
				this.sessionData = null;
				this._storeSessionData(null);
				this._updateView();
				this.onLogout();
				this._solveApp();
				return fCallback(pError.message);
			});
	}

	/**
	 * Check whether an existing session is active (e.g. from a cookie).
	 *
	 * @param {function} [fCallback] - Optional callback(pError, pSessionData)
	 */
	checkSession(fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		fetch(this.options.CheckSessionEndpoint)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then((pData) =>
			{
				if (pData && pData.LoggedIn)
				{
					this.authenticated = true;
					this.sessionData = pData;
					this._storeSessionData(pData);
					this._updateView();
				}
				this.onSessionChecked(pData);
				this._solveApp();
				return fCallback(null, pData);
			})
			.catch((pError) =>
			{
				this.log.error('PictSectionLogin checkSession error: ' + pError.message);
				this.onSessionChecked(null);
				return fCallback(pError.message);
			});
	}

	/**
	 * Fetch available OAuth providers and render buttons.
	 *
	 * @param {function} [fCallback] - Optional callback(pError, pProviders)
	 */
	loadOAuthProviders(fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		fetch(this.options.OAuthProvidersEndpoint)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then((pData) =>
			{
				if (pData && Array.isArray(pData.Providers))
				{
					this.oauthProviders = pData.Providers;
					this._renderOAuthButtons();
				}
				return fCallback(null, this.oauthProviders);
			})
			.catch((pError) =>
			{
				this.log.warn('PictSectionLogin loadOAuthProviders: ' + pError.message);
				return fCallback(pError.message);
			});
	}

	// ===== Magic Link (passwordless) =====

	/**
	 * Request a one-time sign-in link by email. The backend is anti-enumeration (it always reports
	 * success), so the UI always shows the neutral "check your email" state and never reveals whether
	 * an account exists.
	 *
	 * @param {string} pEmail - The email address to send the link to
	 * @param {function} [fCallback] - Optional callback(pError, pData)
	 */
	requestMagicLink(pEmail, fCallback)
	{
		if (typeof (fCallback) !== 'function') { fCallback = () => {}; }
		this._clearError();

		fetch(this.options.MagicLinkRequestEndpoint,
			{ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ Email: pEmail }) })
			.then((pResponse) => pResponse.json())
			.then((pData) =>
			{
				this._showMagicSent();
				this.onMagicLinkSent(pData || {});
				return fCallback(null, pData);
			})
			.catch((pError) =>
			{
				this.log.error('PictSectionLogin requestMagicLink error: ' + pError.message);
				this._displayError('Could not request a sign-in link.');
				return fCallback(pError.message);
			});
	}

	/**
	 * Verify a magic-link token (from the clicked link's route) and sign in. On a 2FA account the
	 * server returns a challenge envelope instead of a session; that is handed to onMagicLinkChallenge
	 * so the host can run its second-factor step.
	 *
	 * @param {string} pToken - The one-time token carried by the link
	 * @param {function} [fCallback] - Optional callback(pError, pData)
	 */
	verifyMagicLink(pToken, fCallback)
	{
		if (typeof (fCallback) !== 'function') { fCallback = () => {}; }
		this._clearError();

		fetch(this.options.MagicLinkVerifyEndpoint,
			{ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ Token: pToken }) })
			.then((pResponse) => pResponse.json())
			.then((pData) =>
			{
				if (pData && pData.LoggedIn)
				{
					this.authenticated = true;
					this.sessionData = pData;
					this._storeSessionData(pData);
					this._updateView();
					this.onLoginSuccess(pData);
					this._solveApp();
					return fCallback(null, pData);
				}
				if (pData && pData.Challenge)
				{
					this.onMagicLinkChallenge(pData);
					return fCallback(null, pData);
				}
				let tmpError = (pData && pData.Error) ? pData.Error : 'This sign-in link is no longer valid.';
				this._displayError(tmpError);
				this.onLoginFailed(tmpError);
				return fCallback(tmpError);
			})
			.catch((pError) =>
			{
				this.log.error('PictSectionLogin verifyMagicLink error: ' + pError.message);
				let tmpMessage = 'Could not verify the sign-in link.';
				this._displayError(tmpMessage);
				this.onLoginFailed(tmpMessage);
				return fCallback(tmpMessage);
			});
	}

	/**
	 * Switch the card to the magic-link (email) form.
	 */
	showMagicLinkForm()
	{
		this.magicLinkMode = true;
		this._clearError();
		let tmpAreaElements = this.services.ContentAssignment.getElement('#pict-login-form-area');
		if (tmpAreaElements && tmpAreaElements.length > 0) { this._renderFormArea(tmpAreaElements[0]); }
	}

	/**
	 * Switch the card back to the password form.
	 */
	showPasswordForm()
	{
		this.magicLinkMode = false;
		this._clearError();
		let tmpAreaElements = this.services.ContentAssignment.getElement('#pict-login-form-area');
		if (tmpAreaElements && tmpAreaElements.length > 0) { this._renderFormArea(tmpAreaElements[0]); }
	}

	// ===== Overridable Hooks =====
	// Developers override these for custom post-login/logout behavior.

	/**
	 * Called after a successful login.
	 * @param {object} pSessionData - The session data from the server
	 */
	onLoginSuccess(pSessionData)
	{
		// Override in subclass or instance
	}

	/**
	 * Called after a failed login attempt.
	 * @param {string} pError - The error message
	 */
	onLoginFailed(pError)
	{
		// Override in subclass or instance
	}

	/**
	 * Called after a successful logout.
	 */
	onLogout()
	{
		// Override in subclass or instance
	}

	/**
	 * Called after a session check completes.
	 * @param {object|null} pSessionData - The session data, or null on error
	 */
	onSessionChecked(pSessionData)
	{
		// Override in subclass or instance
	}

	/**
	 * Called after a magic-link request was sent (the neutral "check your email" state is already shown).
	 * @param {object} pData - The server response
	 */
	onMagicLinkSent(pData)
	{
		// Override in subclass or instance
	}

	/**
	 * Called when verifying a magic link returns a second-factor challenge instead of a session.
	 * The host runs its 2FA step with the challenge envelope (ChallengeToken, Channel, ...).
	 * @param {object} pChallenge - The challenge envelope from the server
	 */
	onMagicLinkChallenge(pChallenge)
	{
		// Override in subclass or instance
	}

	// ===== Internal Helpers =====

	/**
	 * Wire up DOM event handlers on the login form and logout button.
	 */
	_wireFormEvents()
	{
		let tmpFormElements = this.services.ContentAssignment.getElement('#pict-login-form');
		if (tmpFormElements && tmpFormElements.length > 0)
		{
			let tmpForm = tmpFormElements[0];
			tmpForm.addEventListener('submit', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpUsernameInput = tmpForm.querySelector('#pict-login-username');
				let tmpPasswordInput = tmpForm.querySelector('#pict-login-password');

				let tmpUsername = tmpUsernameInput ? tmpUsernameInput.value : '';
				let tmpPassword = tmpPasswordInput ? tmpPasswordInput.value : '';

				if (!tmpUsername)
				{
					this._displayError('Please enter a username.');
					return;
				}

				this.login(tmpUsername, tmpPassword);
			});
		}

		let tmpShowMagicElements = this.services.ContentAssignment.getElement('#pict-login-show-magic');
		if (tmpShowMagicElements && tmpShowMagicElements.length > 0)
		{
			tmpShowMagicElements[0].addEventListener('click', () =>
			{
				this.showMagicLinkForm();
			});
		}

		let tmpLogoutElements = this.services.ContentAssignment.getElement('#pict-login-logout');
		if (tmpLogoutElements && tmpLogoutElements.length > 0)
		{
			tmpLogoutElements[0].addEventListener('click', () =>
			{
				this.logout();
			});
		}
	}

	/**
	 * Render the password form (plus the magic-link toggle when ShowMagicLink is set) or the magic-link
	 * form into the form area, then wire its events. Mode is driven by this.magicLinkMode.
	 */
	_renderFormArea(pFormArea)
	{
		if (this.magicLinkMode)
		{
			pFormArea.innerHTML = this.pict.parseTemplateByHash('Pict-Login-Template-MagicForm', {});
			this._wireMagicEvents();
			return;
		}
		let tmpHTML = this.pict.parseTemplateByHash('Pict-Login-Template-Form', {});
		if (this.options.ShowMagicLink)
		{
			tmpHTML += this.pict.parseTemplateByHash('Pict-Login-Template-MagicToggle', {});
		}
		pFormArea.innerHTML = tmpHTML;
		this._wireFormEvents();
	}

	/**
	 * Wire the magic-link form submit and its "use a password instead" toggle.
	 */
	_wireMagicEvents()
	{
		let tmpFormElements = this.services.ContentAssignment.getElement('#pict-login-magic-form');
		if (tmpFormElements && tmpFormElements.length > 0)
		{
			let tmpForm = tmpFormElements[0];
			tmpForm.addEventListener('submit', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpEmailInput = tmpForm.querySelector('#pict-login-magic-email');
				let tmpEmail = tmpEmailInput ? String(tmpEmailInput.value || '').trim() : '';
				if (!tmpEmail || tmpEmail.indexOf('@') < 1)
				{
					this._displayError('Please enter a valid email.');
					return;
				}
				this.requestMagicLink(tmpEmail);
			});

			let tmpBack = tmpForm.querySelector('#pict-login-show-password');
			if (tmpBack)
			{
				tmpBack.addEventListener('click', () =>
				{
					this.showPasswordForm();
				});
			}
		}
	}

	/**
	 * Replace the form area with the neutral "check your email" state.
	 */
	_showMagicSent()
	{
		let tmpAreaElements = this.services.ContentAssignment.getElement('#pict-login-form-area');
		if (!tmpAreaElements || tmpAreaElements.length < 1) { return; }
		let tmpArea = tmpAreaElements[0];
		tmpArea.innerHTML = this.pict.parseTemplateByHash('Pict-Login-Template-MagicSent', {});
		let tmpAgain = tmpArea.querySelector('#pict-login-magic-again');
		if (tmpAgain)
		{
			tmpAgain.addEventListener('click', () =>
			{
				this.showMagicLinkForm();
			});
		}
	}

	/**
	 * Show an error message in the error area.
	 * @param {string} pMessage - The error text
	 */
	_displayError(pMessage)
	{
		let tmpErrorElements = this.services.ContentAssignment.getElement('#pict-login-error');
		if (tmpErrorElements && tmpErrorElements.length > 0)
		{
			let tmpErrorEl = tmpErrorElements[0];
			tmpErrorEl.textContent = pMessage;
			tmpErrorEl.style.display = 'block';
		}
	}

	/**
	 * Hide the error area.
	 */
	_clearError()
	{
		let tmpErrorElements = this.services.ContentAssignment.getElement('#pict-login-error');
		if (tmpErrorElements && tmpErrorElements.length > 0)
		{
			let tmpErrorEl = tmpErrorElements[0];
			tmpErrorEl.textContent = '';
			tmpErrorEl.style.display = 'none';
		}
	}

	/**
	 * Re-render the view to reflect current authentication state.
	 * Shows the login form when unauthenticated, or the status bar when authenticated.
	 */
	_updateView()
	{
		let tmpFormAreaElements = this.services.ContentAssignment.getElement('#pict-login-form-area');
		let tmpStatusAreaElements = this.services.ContentAssignment.getElement('#pict-login-status-area');
		let tmpOAuthAreaElements = this.services.ContentAssignment.getElement('#pict-login-oauth-area');

		if (this.authenticated && this.sessionData)
		{
			// --- Authenticated: show status, hide form ---
			if (tmpFormAreaElements && tmpFormAreaElements.length > 0)
			{
				tmpFormAreaElements[0].style.display = 'none';
			}
			if (tmpOAuthAreaElements && tmpOAuthAreaElements.length > 0)
			{
				tmpOAuthAreaElements[0].style.display = 'none';
			}
			if (tmpStatusAreaElements && tmpStatusAreaElements.length > 0)
			{
				let tmpStatusArea = tmpStatusAreaElements[0];
				tmpStatusArea.style.display = 'block';

				// Render the status template
				let tmpStatusHTML = this.pict.parseTemplateByHash('Pict-Login-Template-Status', {});
				tmpStatusArea.innerHTML = tmpStatusHTML;

				// Populate display values
				let tmpDisplayName = '';
				let tmpDisplayID = '';

				if (this.sessionData.UserRecord)
				{
					tmpDisplayName = this.sessionData.UserRecord.FullName
						|| this.sessionData.UserRecord.LoginID
						|| this.sessionData.UserRecord.Email
						|| '';
					tmpDisplayID = this.sessionData.UserRecord.IDUser || this.sessionData.UserID || '';
				}
				else if (this.sessionData.UserID)
				{
					tmpDisplayID = this.sessionData.UserID;
				}

				let tmpNameElements = tmpStatusArea.querySelectorAll('#pict-login-display-name');
				if (tmpNameElements.length > 0)
				{
					tmpNameElements[0].textContent = tmpDisplayName;
				}

				let tmpIDElements = tmpStatusArea.querySelectorAll('#pict-login-display-id');
				if (tmpIDElements.length > 0)
				{
					if (tmpDisplayID)
					{
						tmpIDElements[0].textContent = 'ID ' + tmpDisplayID;
					}
					else
					{
						tmpIDElements[0].style.display = 'none';
					}
				}

				// Wire logout button
				let tmpLogoutBtn = tmpStatusArea.querySelector('#pict-login-logout');
				if (tmpLogoutBtn)
				{
					tmpLogoutBtn.addEventListener('click', () =>
					{
						this.logout();
					});
				}
			}
			this._clearError();
		}
		else
		{
			// --- Unauthenticated: show form, hide status ---
			if (tmpStatusAreaElements && tmpStatusAreaElements.length > 0)
			{
				tmpStatusAreaElements[0].style.display = 'none';
				tmpStatusAreaElements[0].innerHTML = '';
			}
			if (tmpFormAreaElements && tmpFormAreaElements.length > 0)
			{
				let tmpFormArea = tmpFormAreaElements[0];
				tmpFormArea.style.display = 'block';

				// Re-render the form (password or magic-link) if nothing is rendered yet.
				if (!tmpFormArea.querySelector('#pict-login-form')
					&& !tmpFormArea.querySelector('#pict-login-magic-form')
					&& !tmpFormArea.querySelector('.pict-login-sent'))
				{
					this._renderFormArea(tmpFormArea);
				}
			}
			if (tmpOAuthAreaElements && tmpOAuthAreaElements.length > 0)
			{
				if (this.options.ShowOAuthProviders && this.oauthProviders.length > 0)
				{
					tmpOAuthAreaElements[0].style.display = 'block';
				}
				else
				{
					tmpOAuthAreaElements[0].style.display = 'none';
				}
			}
		}
	}

	/**
	 * Render OAuth provider buttons into the OAuth area.
	 */
	_renderOAuthButtons()
	{
		let tmpOAuthAreaElements = this.services.ContentAssignment.getElement('#pict-login-oauth-area');
		if (!tmpOAuthAreaElements || tmpOAuthAreaElements.length < 1)
		{
			return;
		}

		if (!this.oauthProviders || this.oauthProviders.length < 1)
		{
			tmpOAuthAreaElements[0].style.display = 'none';
			return;
		}

		// Render the OAuth container template
		let tmpOAuthHTML = this.pict.parseTemplateByHash('Pict-Login-Template-OAuthProviders', {});
		tmpOAuthAreaElements[0].innerHTML = tmpOAuthHTML;
		tmpOAuthAreaElements[0].style.display = 'block';

		// Build individual provider buttons
		let tmpButtonContainer = tmpOAuthAreaElements[0].querySelector('#pict-login-oauth-buttons');
		if (!tmpButtonContainer)
		{
			return;
		}

		let tmpButtonsHTML = '';
		for (let i = 0; i < this.oauthProviders.length; i++)
		{
			let tmpProvider = this.oauthProviders[i];
			let tmpName = tmpProvider.Name || 'provider';
			let tmpBeginURL = tmpProvider.BeginURL || (this.options.OAuthBeginEndpoint + '/' + tmpName);
			let tmpDisplayName = tmpName.charAt(0).toUpperCase() + tmpName.slice(1);
			let tmpCSSModifier = tmpName.toLowerCase();

			tmpButtonsHTML += '<a class="pict-login-oauth-btn pict-login-oauth-btn--' + tmpCSSModifier + '" href="' + tmpBeginURL + '">Sign in with ' + tmpDisplayName + '</a>';
		}

		tmpButtonContainer.innerHTML = tmpButtonsHTML;
	}

	/**
	 * Store session data at the configured Pict address.
	 * @param {object|null} pData - Session data to store
	 */
	_storeSessionData(pData)
	{
		if (this.options.SessionDataAddress)
		{
			let tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.pict.AppData,
				Bundle: this.pict.Bundle
			};
			this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.SessionDataAddress, pData);
		}
	}

	/**
	 * Trigger a solve on the PictApplication if one exists.
	 */
	_solveApp()
	{
		if (this.pict && this.pict.PictApplication && typeof (this.pict.PictApplication.solve) === 'function')
		{
			this.pict.PictApplication.solve();
		}
	}
}

module.exports = PictSectionLogin;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Section-Login-DefaultConfiguration.js":253,"pict-view":365}],255:[function(require,module,exports){
/**
 * Pict-MDE-CodeMirror: Helper module for PictSectionMarkdownEditor
 *
 * Handles CodeMirror editor instance creation, extension configuration,
 * keyboard shortcuts, paste handling, and the data URI collapse extension.
 */

/**
 * Attach CodeMirror editor creation methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Create a CodeMirror editor instance inside a container element.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to mount the editor in
	 * @param {number} pSegmentIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	pView._createEditorInContainer = function _createEditorInContainer(pContainer, pSegmentIndex, pContent)
	{
		let tmpCM = pView._codeMirrorModules;

		// Build the extensions array
		let tmpExtensions = [];

		// Keyboard shortcuts for formatting, inter-segment navigation, and image paste handling
		// IMPORTANT: Must be added BEFORE consumer extensions (e.g. basicSetup) so that
		// our domEventHandlers fire before CM6's internal keymap handlers.
		tmpExtensions.push(
			tmpCM.EditorView.domEventHandlers(
			{
				keydown: (pEvent, pEditorView) =>
				{
					// Ctrl/Cmd + B = bold
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'b')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'bold');
						return true;
					}
					// Ctrl/Cmd + I = italic
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'i')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'italic');
						return true;
					}
					// Ctrl/Cmd + E = inline code
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'e')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'code');
						return true;
					}

				},
				paste: (pEvent, pEditorView) =>
				{
					// Check clipboard for image data
					let tmpItems = pEvent.clipboardData && pEvent.clipboardData.items;
					if (!tmpItems)
					{
						return false;
					}
					for (let i = 0; i < tmpItems.length; i++)
					{
						// Paste: a clipboard item is not a File yet, so the type is tested directly.
						if (tmpItems[i].type.startsWith('image/') || tmpItems[i].type.startsWith('video/'))
						{
							pEvent.preventDefault();
							let tmpFile = tmpItems[i].getAsFile();
							if (tmpFile)
							{
								pView._processImageFile(tmpFile, pSegmentIndex);
							}
							return true;
						}
					}
					return false;
				},
				drop: (pEvent, pEditorView) =>
				{
					// Intercept image file drops at the CodeMirror level to prevent
					// the browser from inserting the image as a raw DOM element.
					// Without this, both CodeMirror's default drop behavior AND the
					// container-level handler fire, causing rendering artifacts.
					if (pView._dragSourceIndex >= 0)
					{
						return false; // segment-reorder drag, not a file drop
					}
					if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
					{
						return false;
					}
					let tmpFile = pEvent.dataTransfer.files[0];
					if (pView._isEmbeddableFile(tmpFile))
					{
						pEvent.preventDefault();
						pEvent.stopPropagation();
						pView._processImageFile(tmpFile, pSegmentIndex);
						// Clean up the dragover visual indicator on the container
						let tmpContainer = pEditorView.dom.closest('.pict-mde-segment-editor');
						if (tmpContainer)
						{
							tmpContainer.classList.remove('pict-mde-image-dragover');
						}
						return true;
					}
					return false;
				}
			})
		);

		// Add consumer-provided extensions (e.g. basicSetup, markdown())
		if (tmpCM.extensions && Array.isArray(tmpCM.extensions))
		{
			tmpExtensions = tmpExtensions.concat(tmpCM.extensions);
		}

		// Wrap long lines instead of scrolling horizontally. Markdown is prose, and
		// a horizontally-scrolling editor in a narrow pane is unusable. On by
		// default; a consumer can disable it with LineWrapping: false.
		if (pView.options.LineWrapping !== false)
		{
			tmpExtensions.push(tmpCM.EditorView.lineWrapping);
		}

		// Update listener for content changes, focus, and cursor tracking
		tmpExtensions.push(
			tmpCM.EditorView.updateListener.of((pUpdate) =>
			{
				if (pUpdate.docChanged)
				{
					pView._onSegmentContentChange(pSegmentIndex, pUpdate.state.doc.toString());
				}

				// Track focus changes to toggle the active class
				if (pUpdate.focusChanged)
				{
					if (pUpdate.view.hasFocus)
					{
						pView._setActiveSegment(pSegmentIndex);
						// Position sidebar at cursor on focus
						pView._updateSidebarPosition(pSegmentIndex);
					}
					else
					{
						// Small delay so clicking a sidebar button doesn't immediately deactivate
						setTimeout(() =>
						{
							if (pView._activeSegmentIndex === pSegmentIndex)
							{
								// Check if focus moved to another segment or truly left
								let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
								if (tmpSegEl && !tmpSegEl.contains(document.activeElement))
								{
									pView._clearActiveSegment(pSegmentIndex);
									pView._resetSidebarPosition(pSegmentIndex);
								}
							}
						}, 100);
					}
				}

				// Track cursor/selection changes to move the sidebar
				if (pUpdate.selectionSet && pUpdate.view.hasFocus)
				{
					pView._updateSidebarPosition(pSegmentIndex);
				}
			})
		);

		// Collapse long data URIs in image markdown so the editor is readable
		let tmpCollapseExtension = pView._buildDataURICollapseExtension();
		if (tmpCollapseExtension)
		{
			tmpExtensions.push(tmpCollapseExtension);
		}

		// Make read-only if configured
		if (pView.options.ReadOnly)
		{
			tmpExtensions.push(tmpCM.EditorState.readOnly.of(true));
			tmpExtensions.push(tmpCM.EditorView.editable.of(false));
		}

		// Allow consumer to customize extensions
		tmpExtensions = pView.customConfigureExtensions(tmpExtensions, pSegmentIndex);

		let tmpState = tmpCM.EditorState.create(
		{
			doc: pContent || '',
			extensions: tmpExtensions
		});

		let tmpEditorView = new tmpCM.EditorView(
		{
			state: tmpState,
			parent: pContainer
		});

		pView._segmentEditors[pSegmentIndex] = tmpEditorView;

		// -- Inter-segment arrow-key navigation --
		// Use a capture-phase DOM listener so we intercept ArrowDown/ArrowUp
		// BEFORE CodeMirror's internal keymap handlers process them.
		tmpEditorView.contentDOM.addEventListener('keydown', function (pEvent)
		{
			if (pEvent.key !== 'ArrowDown' && pEvent.key !== 'ArrowUp')
			{
				return;
			}
			// Don't interfere if a modifier key is held (selection, etc.)
			if (pEvent.shiftKey || pEvent.ctrlKey || pEvent.metaKey || pEvent.altKey)
			{
				return;
			}

			let tmpState = tmpEditorView.state;
			let tmpCursorPos = tmpState.selection.main.head;
			let tmpLine = tmpState.doc.lineAt(tmpCursorPos);
			let tmpColumnOffset = tmpCursorPos - tmpLine.from;

			if (pEvent.key === 'ArrowDown')
			{
				// Only navigate when cursor is on the very last line
				if (tmpLine.to < tmpState.doc.length)
				{
					return; // not on last line — let CM handle it
				}

				// Find next segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpOrderedIndices.length - 1)
				{
					return; // last segment — nowhere to go
				}

				let tmpNextInternalIndex = tmpOrderedIndices[tmpLogicalIndex + 1];
				let tmpNextEditor = pView._segmentEditors[tmpNextInternalIndex];
				if (!tmpNextEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the next editor and place cursor on the first line
				let tmpFirstLine = tmpNextEditor.state.doc.line(1);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpFirstLine.to - tmpFirstLine.from);
				tmpNextEditor.focus();
				tmpNextEditor.dispatch({ selection: { anchor: tmpFirstLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpNextInternalIndex);
			}
			else if (pEvent.key === 'ArrowUp')
			{
				// Only navigate when cursor is on the very first line
				if (tmpLine.number > 1)
				{
					return; // not on first line — let CM handle it
				}

				// Find previous segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex <= 0)
				{
					return; // first segment — nowhere to go
				}

				let tmpPrevInternalIndex = tmpOrderedIndices[tmpLogicalIndex - 1];
				let tmpPrevEditor = pView._segmentEditors[tmpPrevInternalIndex];
				if (!tmpPrevEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the previous editor and place cursor on the last line
				let tmpLastLine = tmpPrevEditor.state.doc.line(tmpPrevEditor.state.doc.lines);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpLastLine.to - tmpLastLine.from);
				tmpPrevEditor.focus();
				tmpPrevEditor.dispatch({ selection: { anchor: tmpLastLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpPrevInternalIndex);
			}
		}, true); // <-- capture phase

		// -- Capture-phase drop listener for image files --
		// Safari processes native contenteditable drops before CodeMirror's
		// bubble-phase domEventHandlers fire, which can insert a raw <img>
		// element into the editor DOM.  A capture-phase listener fires first
		// and lets us preventDefault() before the browser acts.
		tmpEditorView.contentDOM.addEventListener('drop', function (pEvent)
		{
			if (pView._dragSourceIndex >= 0)
			{
				return; // segment-reorder drag
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}
			let tmpFile = pEvent.dataTransfer.files[0];
			if (pView._isEmbeddableFile(tmpFile))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
				// Clean up the dragover visual indicator
				let tmpEditorEl = pView._resolveInstanceElement(`PictMDE-SegmentEditor-${pSegmentIndex}`);
				if (tmpEditorEl)
				{
					tmpEditorEl.classList.remove('pict-mde-image-dragover');
				}
			}
		}, true); // <-- capture phase
	};

	/**
	 * Build a CodeMirror extension that visually collapses long data URIs
	 * inside markdown image syntax.
	 *
	 * The extension uses Decoration.replace() to hide the long base64 portion
	 * and show a compact widget instead, e.g. "data:image/jpeg;base64...28KB".
	 * The actual document content is unchanged -- only the visual display
	 * is affected.
	 *
	 * Returns null if the required CodeMirror modules (Decoration, ViewPlugin,
	 * WidgetType) are not available.
	 *
	 * @returns {object|null} A CodeMirror ViewPlugin extension, or null
	 */
	pView._buildDataURICollapseExtension = function _buildDataURICollapseExtension()
	{
		let tmpCM = pView._codeMirrorModules;

		// All three classes are required -- degrade gracefully if not available
		if (!tmpCM || !tmpCM.Decoration || !tmpCM.ViewPlugin || !tmpCM.WidgetType)
		{
			return null;
		}

		let tmpDecoration = tmpCM.Decoration;
		let tmpViewPlugin = tmpCM.ViewPlugin;
		let tmpWidgetType = tmpCM.WidgetType;

		// Minimum data URI length before collapsing (short URIs are left alone)
		let tmpMinLength = 200;

		// Widget class: renders the collapsed placeholder inline
		class DataURIWidget extends tmpWidgetType
		{
			constructor(pLabel)
			{
				super();
				this.label = pLabel;
			}

			toDOM()
			{
				let tmpSpan = document.createElement('span');
				tmpSpan.className = 'pict-mde-data-uri-collapsed';
				tmpSpan.textContent = this.label;
				tmpSpan.title = 'Data URI (click to expand in image preview below)';
				return tmpSpan;
			}

			eq(pOther)
			{
				return this.label === pOther.label;
			}
		}

		/**
		 * Scan the visible ranges of the document for data URIs inside image
		 * markdown and build a DecorationSet that replaces the long portion.
		 *
		 * Pattern:  ![alt](data:image/TYPE;base64,LONGSTRING)
		 *
		 * We keep "![alt](data:image/TYPE;base64," visible and replace only the
		 * long base64 payload plus the closing ")" with a compact widget.
		 */
		function buildDecorations(pEditorView)
		{
			let tmpDecorations = [];
			let tmpDoc = pEditorView.state.doc;

			for (let tmpVisRange of pEditorView.visibleRanges)
			{
				let tmpFrom = tmpVisRange.from;
				let tmpTo = tmpVisRange.to;
				let tmpText = tmpDoc.sliceString(tmpFrom, tmpTo);

				// Match: ![...](data:image/...;base64,...) -- we need positions of the base64 payload
				let tmpRegex = /!\[[^\]]*\]\(data:([^;]+);base64,/g;
				let tmpMatch;

				while ((tmpMatch = tmpRegex.exec(tmpText)) !== null)
				{
					// tmpMatch[0] is "![alt](data:image/png;base64,"
					// tmpMatch[1] is the MIME subtype, e.g. "image/png"
					let tmpPayloadStart = tmpFrom + tmpMatch.index + tmpMatch[0].length;

					// Find the closing parenthesis -- scan forward from payloadStart
					let tmpPayloadEnd = -1;
					let tmpSearchFrom = tmpPayloadStart;
					let tmpDocLength = tmpDoc.length;

					// Scan character by character in the document for the closing ')'
					// We need to handle this carefully since the payload could be huge
					// and span beyond the visible range.
					// Search up to 5MB worth of characters (way more than any realistic image).
					let tmpMaxScan = Math.min(tmpDocLength, tmpSearchFrom + 5 * 1024 * 1024);
					let tmpChunkSize = 4096;

					for (let tmpPos = tmpSearchFrom; tmpPos < tmpMaxScan; tmpPos += tmpChunkSize)
					{
						let tmpEnd = Math.min(tmpPos + tmpChunkSize, tmpMaxScan);
						let tmpChunk = tmpDoc.sliceString(tmpPos, tmpEnd);
						let tmpParenIdx = tmpChunk.indexOf(')');
						if (tmpParenIdx >= 0)
						{
							tmpPayloadEnd = tmpPos + tmpParenIdx;
							break;
						}
					}

					if (tmpPayloadEnd < 0)
					{
						// No closing paren found -- skip this match
						continue;
					}

					// Calculate the payload length (base64 data between comma and closing paren)
					let tmpPayloadLength = tmpPayloadEnd - tmpPayloadStart;

					if (tmpPayloadLength < tmpMinLength)
					{
						// Too short to bother collapsing
						continue;
					}

					// Build a human-readable size label
					let tmpSizeBytes = Math.round(tmpPayloadLength * 0.75); // base64 to bytes approx
					let tmpSizeLabel;
					if (tmpSizeBytes >= 1024 * 1024)
					{
						tmpSizeLabel = (tmpSizeBytes / (1024 * 1024)).toFixed(1) + 'MB';
					}
					else if (tmpSizeBytes >= 1024)
					{
						tmpSizeLabel = Math.round(tmpSizeBytes / 1024) + 'KB';
					}
					else
					{
						tmpSizeLabel = tmpSizeBytes + 'B';
					}

					let tmpMimeType = tmpMatch[1] || 'image';
					let tmpWidgetLabel = `\u2026${tmpSizeLabel})`;

					// Replace from the start of the base64 payload to after the closing paren
					let tmpWidget = tmpDecoration.replace(
					{
						widget: new DataURIWidget(tmpWidgetLabel)
					});

					tmpDecorations.push(tmpWidget.range(tmpPayloadStart, tmpPayloadEnd + 1));
				}
			}

			return tmpDecoration.set(tmpDecorations, true);
		}

		// Create the ViewPlugin
		let tmpPlugin = tmpViewPlugin.fromClass(
			class
			{
				constructor(pEditorView)
				{
					this.decorations = buildDecorations(pEditorView);
				}

				update(pUpdate)
				{
					if (pUpdate.docChanged || pUpdate.viewportChanged)
					{
						this.decorations = buildDecorations(pUpdate.view);
					}
				}
			},
			{
				decorations: (pPlugin) => pPlugin.decorations
			}
		);

		return tmpPlugin;
	};
};

},{}],256:[function(require,module,exports){
/**
 * Pict-MDE-DragAndReorder: Helper module for PictSectionMarkdownEditor
 *
 * Handles segment drag-and-drop reordering, active segment management,
 * sidebar cursor-tracking positioning, and hidden-preview state maintenance
 * across reorder operations.
 */

/**
 * Attach drag/reorder and active-segment methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Wire drag-and-drop events on a segment element for reorder via the drag handle.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireSegmentDragEvents = function _wireSegmentDragEvents(pSegmentElement, pSegmentIndex)
	{
		let tmpHandle = pSegmentElement.querySelector('.pict-mde-drag-handle');
		if (!tmpHandle)
		{
			return;
		}

		// The drag handle is the draggable element
		tmpHandle.addEventListener('dragstart', (pEvent) =>
		{
			pView._dragSourceIndex = pSegmentIndex;
			pEvent.dataTransfer.effectAllowed = 'move';
			pEvent.dataTransfer.setData('text/plain', String(pSegmentIndex));
			// Add a dragging class to the container so CSS can disable pointer-events
			// on CodeMirror editors (preventing them from intercepting the drop event)
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.add('pict-mde-dragging');
			}
			setTimeout(() =>
			{
				pSegmentElement.style.opacity = '0.4';
			}, 0);
		});

		tmpHandle.addEventListener('dragend', () =>
		{
			pSegmentElement.style.opacity = '';
			pView._dragSourceIndex = -1;
			pView._clearAllDropIndicators();
			// Remove the dragging class from the container
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.remove('pict-mde-dragging');
			}
		});

		// Drop target: the whole segment row. We determine above/below from mouse Y.
		pSegmentElement.addEventListener('dragover', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'move';

			// Clear all indicators first, then set the correct one
			pView._clearAllDropIndicators();

			// Determine if cursor is in the top or bottom half of this segment
			let tmpRect = pSegmentElement.getBoundingClientRect();
			let tmpMidY = tmpRect.top + (tmpRect.height / 2);
			if (pEvent.clientY < tmpMidY)
			{
				pSegmentElement.classList.add('pict-mde-drag-over-top');
			}
			else
			{
				pSegmentElement.classList.add('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if we're actually leaving the element (not entering a child)
			if (!pSegmentElement.contains(pEvent.relatedTarget))
			{
				pSegmentElement.classList.remove('pict-mde-drag-over-top');
				pSegmentElement.classList.remove('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('drop', (pEvent) =>
		{
			pEvent.preventDefault();

			let tmpDropBelow = pSegmentElement.classList.contains('pict-mde-drag-over-bottom');
			pView._clearAllDropIndicators();

			let tmpSourceIndex = pView._dragSourceIndex;
			if (tmpSourceIndex < 0 || tmpSourceIndex === pSegmentIndex)
			{
				return;
			}

			pView._reorderSegment(tmpSourceIndex, pSegmentIndex, tmpDropBelow);
		});
	};

	/**
	 * Clear all drop indicator classes from all segments.
	 */
	pView._clearAllDropIndicators = function _clearAllDropIndicators()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}
		let tmpAllSegments = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpAllSegments.length; i++)
		{
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-top');
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-bottom');
		}
	};

	/**
	 * Reorder a segment from one position to another via drag.
	 *
	 * @param {number} pFromInternalIndex - The internal index of the dragged segment
	 * @param {number} pToInternalIndex - The internal index of the drop target
	 * @param {boolean} pDropBelow - Whether the drop was on the bottom half of the target
	 */
	pView._reorderSegment = function _reorderSegment(pFromInternalIndex, pToInternalIndex, pDropBelow)
	{
		let tmpFromLogical = pView._getLogicalIndex(pFromInternalIndex);
		let tmpToLogical = pView._getLogicalIndex(pToInternalIndex);

		if (tmpFromLogical < 0 || tmpToLogical < 0)
		{
			pView.log.warn(`PICT-MarkdownEditor _reorderSegment: could not resolve logical indices (from=${tmpFromLogical}, to=${tmpToLogical}).`);
			return;
		}

		if (tmpFromLogical === tmpToLogical)
		{
			return;
		}

		// Marshal all editor content back to data before manipulating the array
		pView._marshalAllEditorsToData();

		let tmpSegments = pView._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length < 2)
		{
			return;
		}

		// Calculate the target insertion index
		let tmpInsertAt = pDropBelow ? tmpToLogical + 1 : tmpToLogical;

		// Adjust for the removal shifting indices down
		if (tmpFromLogical < tmpInsertAt)
		{
			tmpInsertAt--;
		}

		// If the insert position equals the source, no move needed
		if (tmpInsertAt === tmpFromLogical)
		{
			return;
		}

		// Perform the reorder: remove from old position, insert at new
		let tmpMoved = tmpSegments.splice(tmpFromLogical, 1)[0];
		tmpSegments.splice(tmpInsertAt, 0, tmpMoved);

		// Explicitly write the reordered array back to the data address
		pView._setSegmentsToData(tmpSegments);

		// Reorder per-segment hidden preview state to follow the moved segment
		pView._reorderHiddenPreviewState(tmpFromLogical, tmpInsertAt);

		// Reorder per-segment tab states to follow the moved segment
		pView._reorderSegmentTabStates(tmpFromLogical, tmpInsertAt);

		pView._buildEditorUI();
	};

	/**
	 * Reorder the hidden preview state after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderHiddenPreviewState = function _reorderHiddenPreviewState(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		// Build an ordered array of hidden-state booleans
		let tmpKeys = Object.keys(pView._hiddenPreviewSegments).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(!!pView._hiddenPreviewSegments[i]);
		}

		// Perform the same splice on the states array
		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		// Rebuild the hidden map
		pView._hiddenPreviewSegments = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i])
			{
				pView._hiddenPreviewSegments[i] = true;
			}
		}
	};

	/**
	 * Swap the hidden preview state of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapHiddenPreviewState = function _swapHiddenPreviewState(pIndexA, pIndexB)
	{
		let tmpAHidden = !!pView._hiddenPreviewSegments[pIndexA];
		let tmpBHidden = !!pView._hiddenPreviewSegments[pIndexB];

		if (tmpBHidden) { pView._hiddenPreviewSegments[pIndexA] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexA]; }

		if (tmpAHidden) { pView._hiddenPreviewSegments[pIndexB] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexB]; }
	};

	/**
	 * Reorder the segment tab states after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderSegmentTabStates = function _reorderSegmentTabStates(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		let tmpKeys = Object.keys(pView._segmentTabStates).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(pView._segmentTabStates[i] || 'editor');
		}

		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		pView._segmentTabStates = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i] !== 'editor')
			{
				pView._segmentTabStates[i] = tmpStates[i];
			}
		}
	};

	/**
	 * Swap the segment tab states of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapSegmentTabStates = function _swapSegmentTabStates(pIndexA, pIndexB)
	{
		let tmpA = pView._segmentTabStates[pIndexA] || 'editor';
		let tmpB = pView._segmentTabStates[pIndexB] || 'editor';

		if (tmpB !== 'editor') { pView._segmentTabStates[pIndexA] = tmpB; }
		else { delete pView._segmentTabStates[pIndexA]; }

		if (tmpA !== 'editor') { pView._segmentTabStates[pIndexB] = tmpA; }
		else { delete pView._segmentTabStates[pIndexB]; }
	};

	// -- Active Segment Management --

	/**
	 * Set a segment as the active (focused) segment.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._setActiveSegment = function _setActiveSegment(pSegmentIndex)
	{
		// Clear previous active
		if (pView._activeSegmentIndex >= 0 && pView._activeSegmentIndex !== pSegmentIndex)
		{
			let tmpPrevEl = pView._resolveInstanceElement(`PictMDE-Segment-${pView._activeSegmentIndex}`);
			if (tmpPrevEl)
			{
				tmpPrevEl.classList.remove('pict-mde-active');
			}
		}

		pView._activeSegmentIndex = pSegmentIndex;

		let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.add('pict-mde-active');
		}
	};

	/**
	 * Clear the active state from a segment (on blur).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._clearActiveSegment = function _clearActiveSegment(pSegmentIndex)
	{
		if (pView._activeSegmentIndex === pSegmentIndex)
		{
			pView._activeSegmentIndex = -1;
		}

		let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.remove('pict-mde-active');
		}

		// Reset sidebar back to sticky when segment is no longer active
		pView._resetSidebarPosition(pSegmentIndex);
	};

	// -- Sidebar Cursor Tracking --

	/**
	 * Update the sidebar formatting-buttons position so they float next to the
	 * cursor / selection in the active segment.
	 *
	 * When a segment is active and has a cursor, we switch the sidebar-actions
	 * from sticky positioning to absolute, offset to align with the cursor line.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateSidebarPosition = function _updateSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			return;
		}

		// Get the cursor position in the editor
		let tmpCursorPos = tmpEditor.state.selection.main.head;
		let tmpCursorCoords = tmpEditor.coordsAtPos(tmpCursorPos);
		if (!tmpCursorCoords)
		{
			// If we can't get coords, revert to sticky
			pView._resetSidebarPosition(pSegmentIndex);
			return;
		}

		// Calculate the offset relative to the segment element
		let tmpSegmentRect = tmpSegmentEl.getBoundingClientRect();
		let tmpOffsetTop = tmpCursorCoords.top - tmpSegmentRect.top;

		// Clamp so the sidebar buttons don't go above the segment or below it
		let tmpSidebarHeight = tmpQuadrantTR.offsetHeight || 0;
		let tmpSegmentHeight = tmpSegmentEl.offsetHeight || 0;
		let tmpMaxOffset = Math.max(0, tmpSegmentHeight - tmpSidebarHeight);
		tmpOffsetTop = Math.max(0, Math.min(tmpOffsetTop, tmpMaxOffset));

		// Apply the cursor-relative positioning
		tmpQuadrantTR.classList.add('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.setProperty('--pict-mde-sidebar-top', `${tmpOffsetTop}px`);
	};

	/**
	 * Reset the sidebar back to default sticky positioning (no cursor tracking).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._resetSidebarPosition = function _resetSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		tmpQuadrantTR.classList.remove('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.removeProperty('--pict-mde-sidebar-top');
	};
};

},{}],257:[function(require,module,exports){
/**
 * Pict-MDE-Formatting: Helper module for PictSectionMarkdownEditor
 *
 * Handles markdown formatting operations (bold, italic, code, heading, link)
 * applied to selections or at the cursor position in CodeMirror editors.
 */

// Markdown formatting definitions: wrapper characters for toggle-style formatting
const _FormattingMap =
{
	bold: { wrap: '**' },
	italic: { wrap: '*' },
	code: { wrap: '`' },
	heading: { prefix: '# ' },
	link: { before: '[', after: '](url)' }
};

/**
 * Attach formatting methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Apply markdown formatting to the selection (or insert formatting at cursor)
	 * in a specific segment.
	 *
	 * If text is selected, wraps it.  If no selection, inserts the formatting
	 * markers and places the cursor between them.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pFormatType - One of: 'bold', 'italic', 'code', 'heading', 'link'
	 */
	pView.applyFormatting = function applyFormatting(pSegmentIndex, pFormatType)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpFormat = _FormattingMap[pFormatType];
		if (!tmpFormat)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: unknown format type "${pFormatType}".`);
			return;
		}

		let tmpState = tmpEditor.state;
		let tmpSelection = tmpState.selection.main;
		let tmpFrom = tmpSelection.from;
		let tmpTo = tmpSelection.to;
		let tmpHasSelection = (tmpFrom !== tmpTo);
		let tmpSelectedText = tmpHasSelection ? tmpState.sliceDoc(tmpFrom, tmpTo) : '';

		let tmpChanges;
		let tmpCursorPos;

		if (tmpFormat.wrap)
		{
			// Toggle-style: wrap selection or insert empty wrapper
			let tmpWrap = tmpFormat.wrap;
			if (tmpHasSelection)
			{
				// Check if already wrapped — if so, unwrap
				let tmpBefore = tmpState.sliceDoc(Math.max(0, tmpFrom - tmpWrap.length), tmpFrom);
				let tmpAfter = tmpState.sliceDoc(tmpTo, Math.min(tmpState.doc.length, tmpTo + tmpWrap.length));

				if (tmpBefore === tmpWrap && tmpAfter === tmpWrap)
				{
					// Unwrap
					tmpChanges = [
						{ from: tmpFrom - tmpWrap.length, to: tmpFrom, insert: '' },
						{ from: tmpTo, to: tmpTo + tmpWrap.length, insert: '' }
					];
					tmpCursorPos = tmpFrom - tmpWrap.length;
					tmpEditor.dispatch(
					{
						changes: tmpChanges,
						selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
					});
					return;
				}

				// Wrap the selection
				let tmpInsert = tmpWrap + tmpSelectedText + tmpWrap;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
				});
			}
			else
			{
				// No selection: insert empty wrapper and place cursor inside
				let tmpInsert = tmpWrap + tmpWrap;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}
		else if (tmpFormat.prefix)
		{
			// Line-prefix style (headings)
			let tmpLine = tmpState.doc.lineAt(tmpFrom);
			let tmpLineText = tmpLine.text;

			// Toggle: if line already starts with the prefix, remove it; otherwise add
			if (tmpLineText.startsWith(tmpFormat.prefix))
			{
				tmpChanges = { from: tmpLine.from, to: tmpLine.from + tmpFormat.prefix.length, insert: '' };
			}
			else
			{
				tmpChanges = { from: tmpLine.from, insert: tmpFormat.prefix };
			}
			tmpEditor.dispatch({ changes: tmpChanges });
		}
		else if (tmpFormat.before && tmpFormat.after)
		{
			// Surround style (links)
			if (tmpHasSelection)
			{
				let tmpInsert = tmpFormat.before + tmpSelectedText + tmpFormat.after;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				// Place cursor on the "url" part
				tmpCursorPos = tmpFrom + tmpFormat.before.length + tmpSelectedText.length + 2;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + 3 }
				});
			}
			else
			{
				let tmpInsert = tmpFormat.before + tmpFormat.after;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpFormat.before.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}

		// Re-focus the editor after clicking a sidebar button
		tmpEditor.focus();
	};
};

},{}],258:[function(require,module,exports){
/**
 * Pict-MDE-ImageHandling: Helper module for PictSectionMarkdownEditor
 *
 * Handles image operations: file picker, file processing (hook or base64
 * fallback), markdown insertion, preview thumbnail rendering, and
 * drag-and-drop for image files onto the editor.
 */

/**
 * Attach image handling methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Open a file picker to select an image for insertion into a segment.
	 * Called by the sidebar image button onclick handler.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView.openImagePicker = function openImagePicker(pSegmentIndex)
	{
		let tmpFileInput = pView._resolveInstanceElement(`PictMDE-ImageInput-${pSegmentIndex}`);
		if (!tmpFileInput)
		{
			pView.log.warn(`PICT-MarkdownEditor openImagePicker: file input not found for segment ${pSegmentIndex}.`);
			return;
		}

		// Wire the change handler fresh each time (in case it was already used)
		tmpFileInput.onchange = () =>
		{
			if (tmpFileInput.files && tmpFileInput.files.length > 0)
			{
				pView._processImageFile(tmpFileInput.files[0], pSegmentIndex);
			}
			// Reset the input so the same file can be re-selected
			tmpFileInput.value = '';
		};

		tmpFileInput.click();
	};

	/**
	 * Is this a file the editor can put into a document -- an image or a video?
	 *
	 * One test, used by every entry point (picker, drag, paste), so a file that can be dropped can also be
	 * pasted and vice versa. Anything else is ignored: a dropped PDF is not something markdown can show.
	 *
	 * @param {File} pFile
	 * @returns {boolean}
	 */
	pView._isEmbeddableFile = function _isEmbeddableFile(pFile)
	{
		if (!pFile || !pFile.type) { return false; }
		return pFile.type.startsWith('image/') || pFile.type.startsWith('video/');
	};

	/**
	 * Process an image or video File object from any input method (picker, drag, paste).
	 *
	 * If the consumer has overridden onImageUpload and it returns true, the consumer handles the upload and
	 * calls the callback with a URL. Otherwise the file is converted to a base64 data URI inline.
	 *
	 * NOTE for consumers: onImageUpload now receives VIDEO files as well as images. It always had the File,
	 * so a consumer that cares can branch on pFile.type; the hook was not split in two because a second hook
	 * would mean video silently doing nothing until every consumer implemented it.
	 *
	 * A video is inserted as a `video` fence rather than the image form, because an uploaded file is usually
	 * addressed by a blob route with no extension -- and the renderer can only read "this is a video" off an
	 * extension. The fence says it outright.
	 *
	 * @param {File} pFile - The image or video File object
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._processImageFile = function _processImageFile(pFile, pSegmentIndex)
	{
		if (!pView._isEmbeddableFile(pFile))
		{
			pView.log.warn(`PICT-MarkdownEditor _processImageFile: not an image or video file (type: ${pFile ? pFile.type : 'null'}).`);
			return;
		}

		let tmpIsVideo = pFile.type.startsWith('video/');
		let tmpAltText = pFile.name ? pFile.name.replace(/\.[^.]+$/, '') : (tmpIsVideo ? 'video' : 'image');

		// Check if the consumer wants to handle the upload
		let tmpCallback = (pError, pURL) =>
		{
			if (pError)
			{
				pView.log.error(`PICT-MarkdownEditor image upload error: ${pError}`);
				return;
			}
			if (pURL)
			{
				if (tmpIsVideo) { pView._insertVideoMarkdown(pSegmentIndex, pURL, tmpAltText); }
				else { pView._insertImageMarkdown(pSegmentIndex, pURL, tmpAltText); }
			}
		};

		let tmpHandled = pView.onImageUpload(pFile, pSegmentIndex, tmpCallback);

		if (tmpHandled)
		{
			// Consumer is handling the upload asynchronously
			return;
		}

		// Default: convert to base64 data URI
		if (typeof (FileReader) === 'undefined')
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader not available in this environment.`);
			return;
		}

		// A video has no inline fallback worth having: a base64 data URI of a recording is megabytes of text
		// pasted into the document, which bloats every save and read of it from then on. Without a consumer
		// upload handler there is nowhere to put it, so say so rather than wedging the document.
		if (tmpIsVideo)
		{
			pView.log.warn('PICT-MarkdownEditor: a video needs an upload handler (onImageUpload) -- inlining one as a data URI would embed megabytes of base64 in the document.');
			return;
		}

		let tmpReader = new FileReader();
		tmpReader.onload = () =>
		{
			pView._insertImageMarkdown(pSegmentIndex, tmpReader.result, tmpAltText);
		};
		tmpReader.onerror = () =>
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader error.`);
		};
		tmpReader.readAsDataURL(pFile);
	};

	/**
	 * Insert a `video` fence at the cursor position in a segment editor.
	 *
	 * The fence rather than the image form: an uploaded recording is usually addressed by a blob route with
	 * no file extension, and the renderer reads "this is a video" off the extension. The fence states it.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The video URL
	 * @param {string} [pTitle] - The title line (default: 'video')
	 */
	pView._insertVideoMarkdown = function _insertVideoMarkdown(pSegmentIndex, pURL, pTitle)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertVideoMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpTitle = pTitle || 'video';
		// Sits on its own lines: a fence has to start at the beginning of a line to be a fence at all.
		let tmpInsert = '\n```video\n' + pURL + '\ntitle: ' + tmpTitle + '\n```\n';

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});
		tmpEditor.focus();
	};

	/**
	 * Insert markdown image syntax at the cursor position in a segment editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The image URL (data URI or remote URL)
	 * @param {string} [pAltText] - The alt text (default: 'image')
	 */
	pView._insertImageMarkdown = function _insertImageMarkdown(pSegmentIndex, pURL, pAltText)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertImageMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpAlt = pAltText || 'image';
		let tmpInsert = `![${tmpAlt}](${pURL})`;

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});

		tmpEditor.focus();

		// Update the image preview area for this segment
		pView._updateImagePreviews(pSegmentIndex);
	};

	/**
	 * Scan the content of a segment for markdown image references and render
	 * preview thumbnails in the preview area below the editor.
	 *
	 * Matches the pattern ![alt](url) and creates <img> elements for each.
	 * The preview area is hidden when there are no images.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateImagePreviews = function _updateImagePreviews(pSegmentIndex)
	{
		let tmpPreviewEl = pView._resolveInstanceElement(`PictMDE-ImagePreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		// Match markdown image syntax: ![alt text](url)
		let tmpImageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
		let tmpMatches = [];
		let tmpMatch;
		while ((tmpMatch = tmpImageRegex.exec(tmpContent)) !== null)
		{
			tmpMatches.push(
			{
				alt: tmpMatch[1] || 'image',
				url: tmpMatch[2]
			});
		}

		if (tmpMatches.length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		// Build preview HTML
		let tmpHTML = '';
		for (let i = 0; i < tmpMatches.length; i++)
		{
			let tmpAlt = tmpMatches[i].alt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
			let tmpResolvedURL = pView._resolveImageURL(tmpMatches[i].url);
			let tmpURL = tmpResolvedURL.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
			tmpHTML += `<div class="pict-mde-image-preview-item"><img src="${tmpURL}" alt="${tmpAlt}" /><span class="pict-mde-image-preview-label">${tmpAlt}</span></div>`;
		}

		tmpPreviewEl.innerHTML = tmpHTML;
		tmpPreviewEl.classList.add('pict-mde-has-images');
	};

	/**
	 * Wire drag-and-drop events for image files on a segment editor container.
	 *
	 * These events are separate from the segment-reorder drag events.
	 * File drags are distinguished from segment reorder drags by checking
	 * dataTransfer.types for 'Files' and ensuring _dragSourceIndex is -1.
	 *
	 * @param {HTMLElement} pEditorContainer - The .pict-mde-segment-editor element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireImageDragEvents = function _wireImageDragEvents(pEditorContainer, pSegmentIndex)
	{
		pEditorContainer.addEventListener('dragover', (pEvent) =>
		{
			// Only handle file drags, not segment-reorder drags
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.types || pEvent.dataTransfer.types.indexOf('Files') < 0)
			{
				return;
			}
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'copy';
			pEditorContainer.classList.add('pict-mde-image-dragover');
		});

		pEditorContainer.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if actually leaving the element
			if (!pEditorContainer.contains(pEvent.relatedTarget))
			{
				pEditorContainer.classList.remove('pict-mde-image-dragover');
			}
		});

		pEditorContainer.addEventListener('drop', (pEvent) =>
		{
			pEditorContainer.classList.remove('pict-mde-image-dragover');

			// Only handle file drops, not segment-reorder drops
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}

			let tmpFile = pEvent.dataTransfer.files[0];
			if (pView._isEmbeddableFile(tmpFile))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
			}
		});
	};
};

},{}],259:[function(require,module,exports){
/**
 * Pict-MDE-RichPreview: Helper module for PictSectionMarkdownEditor
 *
 * Handles rich content preview rendering via pict-section-content:
 * markdown-to-HTML parsing, mermaid diagram rendering, KaTeX math
 * rendering, and the full rendered-view toggle.
 */

const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;

/**
 * Attach rich preview methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Get the pict-section-content provider instance for markdown parsing.
	 * Lazily instantiated on first use.
	 *
	 * @returns {object} The PictContentProvider instance
	 */
	pView._getContentProvider = function _getContentProvider()
	{
		if (!pView._contentProvider)
		{
			pView._contentProvider = new libPictContentProvider(pView.fable, {}, 'Pict-Content-Provider-MDE');
		}
		return pView._contentProvider;
	};

	/**
	 * Render the raw markdown content of a segment into the rich preview area
	 * using pict-section-content's parseMarkdown() provider method.
	 *
	 * The rendered HTML includes syntax-highlighted code blocks, mermaid diagram
	 * placeholders, KaTeX math placeholders, headings, lists, tables, etc.
	 *
	 * After setting innerHTML, post-render hooks call mermaid.run() and
	 * katex.render() to activate diagrams and equations (if those libraries
	 * are available on window -- loaded by the consumer via CDN).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateRichPreviews = function _updateRichPreviews(pSegmentIndex)
	{
		if (!pView.options.EnableRichPreview)
		{
			return;
		}

		let tmpPreviewEl = pView._resolveInstanceElement(`PictMDE-RichPreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		if (!tmpContent || tmpContent.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Use pict-section-content's provider to parse the raw markdown into HTML.
		// If a Vocabulary provider is registered on the pict instance,
		// pass its resolver so vocabulary terms auto-link in the preview.
		let tmpProvider = pView._getContentProvider();
		let tmpVocabResolver = null;
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.getResolver === 'function')
		{
			tmpVocabResolver = pView.pict.providers.Vocabulary.getResolver();
		}
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpContent, null, null, tmpVocabResolver);

		if (!tmpRenderedHTML || tmpRenderedHTML.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Wrap the rendered HTML in a pict-content container so that
		// pict-section-content's CSS classes take effect
		let tmpPreviewID = `PictMDE-RichPreviewBody-${pSegmentIndex}`;
		tmpPreviewEl.innerHTML = `<div class="pict-content" id="${tmpPreviewID}">${tmpRenderedHTML}</div>`;
		tmpPreviewEl.classList.add('pict-mde-has-rich-preview');

		// Wire vocabulary popover hover handlers if the provider is available
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.wirePopovers === 'function')
		{
			pView.pict.providers.Vocabulary.wirePopovers('#' + tmpPreviewID);
		}

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpPreviewEl.querySelectorAll('img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation counter for stale-render protection (mermaid is async)
		let tmpGeneration = (pView._richPreviewGenerations[pSegmentIndex] || 0) + 1;
		pView._richPreviewGenerations[pSegmentIndex] = tmpGeneration;

		// Post-render: call mermaid.run() for mermaid diagram elements
		pView._postRenderMermaid(tmpPreviewID, pSegmentIndex, tmpGeneration);

		// Post-render: call katex.render() for KaTeX math elements
		pView._postRenderKaTeX(tmpPreviewID);
	};

	/**
	 * Lazily bind the shared Theme-Diagram-Adapter for mermaid.  The
	 * adapter handles mermaid.initialize() against the active pict
	 * theme, subscribes to onApply, and re-renders existing diagrams
	 * when the theme/mode changes.  Idempotent.
	 *
	 * Falls back to a direct-require path when no theme provider is
	 * installed — the static base theme still picks up any CSS
	 * variables on :root.
	 */
	pView._ensureMermaidAdapter = function _ensureMermaidAdapter()
	{
		if (pView._mermaidAdapter) { return pView._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				pView._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				pView._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid theme adapter init failed: ${pError.message || pError}`);
			pView._mermaidAdapter = null;
		}
		return pView._mermaidAdapter;
	};

	/**
	 * Post-render hook: render Mermaid diagrams in the preview container.
	 * Uses the same approach as pict-section-content's renderMermaidDiagrams().
	 *
	 * @param {string} pContainerID - The container element ID
	 * @param {number} pSegmentIndex - The segment index (for stale-render protection)
	 * @param {number} pGeneration - The generation counter value
	 */
	pView._postRenderMermaid = function _postRenderMermaid(pContainerID, pSegmentIndex, pGeneration)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainer = pView._resolveInstanceElement(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		let tmpMermaidElements = tmpContainer.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the shared Theme-Diagram-Adapter so mermaid
		// follows the active palette and re-renders when the theme/mode
		// changes (manual toggle or OS-driven via prefers-color-scheme).
		pView._ensureMermaidAdapter();

		// Cache each diagram's source on the element. mermaid.run()
		// replaces textContent with the rendered SVG; the cache lets
		// the adapter's refresh re-run without re-parsing markdown.
		let tmpProviderForStash = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		try
		{
			let tmpPromise = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpPromise && typeof tmpPromise.catch === 'function')
			{
				tmpPromise.catch((pError) =>
				{
					// Check stale-render: rendered view uses _renderedViewGeneration,
					// per-segment previews use _richPreviewGenerations
					let tmpCurrentGen = (pSegmentIndex === -1)
						? pView._renderedViewGeneration
						: pView._richPreviewGenerations[pSegmentIndex];
					if (tmpCurrentGen !== pGeneration)
					{
						return; // stale render -- a newer update has replaced us
					}
					pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
				});
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
		}
	};

	/**
	 * Post-render hook: render KaTeX inline and display math in the preview container.
	 * Uses the same approach as pict-section-content's renderKaTeXEquations().
	 *
	 * @param {string} pContainerID - The container element ID
	 */
	pView._postRenderKaTeX = function _postRenderKaTeX(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainer = pView._resolveInstanceElement(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		// Render inline math: <span class="pict-content-katex-inline">
		let tmpInlineElements = tmpContainer.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX inline error: ${pError.message || pError}`);
			}
		}

		// Render display math: <div class="pict-content-katex-display">
		let tmpDisplayElements = tmpContainer.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX display error: ${pError.message || pError}`);
			}
		}
	};

	/**
	 * Simple HTML escape for error messages in the rich preview.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string}
	 */
	pView._escapeHTMLForPreview = function _escapeHTMLForPreview(pText)
	{
		return pText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	};

	// -- Rendered View (full document preview) --

	/**
	 * Toggle between the editing view (CodeMirror segments) and a fully rendered
	 * view of the combined markdown output using pict-section-content.
	 *
	 * @param {boolean} [pRendered] - If provided, set to this value; otherwise toggle
	 */
	pView.toggleRenderedView = function toggleRenderedView(pRendered)
	{
		if (typeof (pRendered) === 'boolean')
		{
			pView._renderedViewActive = pRendered;
		}
		else
		{
			pView._renderedViewActive = !pView._renderedViewActive;
		}

		if (pView._renderedViewActive)
		{
			pView._renderRenderedView();
		}
		else
		{
			pView._restoreEditingView();
		}
	};

	/**
	 * Switch to the rendered view: marshal all editors, combine all segment
	 * content, render to HTML via pict-section-content, and replace the
	 * container contents with the rendered output.
	 */
	pView._renderRenderedView = function _renderRenderedView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		// Marshal current editor content back to data before switching
		pView._marshalAllEditorsToData();

		// Combine all segments into a single markdown document
		let tmpSegments = pView._getSegmentsFromData();
		let tmpCombinedContent = '';
		if (tmpSegments && tmpSegments.length > 0)
		{
			let tmpParts = [];
			for (let i = 0; i < tmpSegments.length; i++)
			{
				tmpParts.push(tmpSegments[i].Content || '');
			}
			tmpCombinedContent = tmpParts.join('\n\n');
		}

		// Destroy existing CodeMirror editors
		for (let tmpIdx in pView._segmentEditors)
		{
			if (pView._segmentEditors[tmpIdx])
			{
				pView._segmentEditors[tmpIdx].destroy();
			}
		}
		pView._segmentEditors = {};

		// Render the combined markdown via pict-section-content
		let tmpProvider = pView._getContentProvider();
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpCombinedContent);

		// Build the rendered view container
		let tmpRenderedViewID = 'PictMDE-RenderedView';
		tmpContainer.innerHTML = `<div class="pict-mde-rendered-view" id="${tmpRenderedViewID}"><div class="pict-content">${tmpRenderedHTML || ''}</div></div>`;
		tmpContainer.classList.add('pict-mde-rendered-mode');

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpContainer.querySelectorAll('.pict-mde-rendered-view img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation for stale-render protection
		pView._renderedViewGeneration++;
		let tmpGeneration = pView._renderedViewGeneration;

		// Post-render hooks for mermaid diagrams and KaTeX equations
		let tmpContentContainer = tmpContainer.querySelector(`#${tmpRenderedViewID} .pict-content`);
		if (tmpContentContainer)
		{
			let tmpContentID = 'PictMDE-RenderedViewContent';
			tmpContentContainer.id = tmpContentID;

			pView._postRenderMermaid(tmpContentID, -1, tmpGeneration);
			pView._postRenderKaTeX(tmpContentID);
		}
	};

	/**
	 * Switch back from rendered view to the editing view: rebuild the
	 * full editor UI from the data.
	 */
	pView._restoreEditingView = function _restoreEditingView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		tmpContainer.classList.remove('pict-mde-rendered-mode');
		pView._buildEditorUI();
	};
};

},{"pict-provider-theme/source/Theme-Diagram-Adapter.js":171,"pict-section-content":196}],260:[function(require,module,exports){
module.exports = (
{
	"DefaultRenderable": "MarkdownEditor-Wrap",
	"DefaultDestinationAddress": "#MarkdownEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "MarkdownEditor-Container",
			"Template": /*html*/`<div class="pict-mde" id="PictMDE-Container"></div>`
		},
		{
			"Hash": "MarkdownEditor-Segment",
			"Template": /*html*/`<div class="pict-mde-segment" id="PictMDE-Segment-{~D:Record.SegmentIndex~}" data-segment-index="{~D:Record.SegmentIndex~}">
	<div class="pict-mde-left-controls">
		<div class="pict-mde-quadrant-tl"></div>
		<div class="pict-mde-quadrant-bl"></div>
	</div>
	<div class="pict-mde-drag-handle" draggable="true" title="Drag to reorder"></div>
	<div class="pict-mde-segment-body">
		<div class="pict-mde-tab-bar" id="PictMDE-TabBar-{~D:Record.SegmentIndex~}">
			<button type="button" class="pict-mde-tab pict-mde-tab-active" data-tab="editor" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'editor')">Edit</button>
			<button type="button" class="pict-mde-tab" data-tab="preview" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'preview')">Preview</button>
		</div>
		<div class="pict-mde-segment-editor" id="PictMDE-SegmentEditor-{~D:Record.SegmentIndex~}"></div>
		<div class="pict-mde-preview-pane" id="PictMDE-PreviewPane-{~D:Record.SegmentIndex~}">
			<div class="pict-mde-image-preview" id="PictMDE-ImagePreview-{~D:Record.SegmentIndex~}"></div>
			<div class="pict-mde-rich-preview" id="PictMDE-RichPreview-{~D:Record.SegmentIndex~}"></div>
		</div>
	</div>
	<div class="pict-mde-sidebar" id="PictMDE-Sidebar-{~D:Record.SegmentIndex~}">
		<div class="pict-mde-quadrant-tr"></div>
		<div class="pict-mde-quadrant-br"></div>
		<input type="file" accept="image/*" class="pict-mde-image-input" id="PictMDE-ImageInput-{~D:Record.SegmentIndex~}" style="display:none" />
	</div>
</div>`
		},
		{
			"Hash": "MarkdownEditor-AddSegment",
			"Template": /*html*/`<div class="pict-mde-add-segment">
	<button type="button" class="pict-mde-btn-add" onclick="{~D:Record.ViewIdentifier~}.addSegment()">+ Add Segment</button>
</div>`
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "MarkdownEditor-Wrap",
			"TemplateHash": "MarkdownEditor-Container",
			"DestinationAddress": "#MarkdownEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#MarkdownEditor-Container-Div",

	// Address in AppData to read/write the segments array
	// The data at this address should be an array of objects, each with a "Content" property
	// e.g. AppData.Document.Segments = [ { Content: "# Hello" }, { Content: "Some text" } ]
	"ContentDataAddress": false,

	// Whether the editor should be read-only
	"ReadOnly": false,

	// Whether to show rich content previews (rendered markdown with syntax-highlighted
	// code, mermaid diagrams, KaTeX equations, tables, etc. via pict-section-content).
	// Requires the consumer to load the mermaid and/or katex libraries via CDN
	// for diagram/equation rendering; code highlighting works without CDN scripts.
	"EnableRichPreview": true,

	// Default preview layout mode: "off", "bottom", "side", "tabbed"
	//   off       — no preview (default)
	//   bottom    — preview below the editor
	//   side      — editor and preview side-by-side
	//   tabbed    — per-segment tabs switching between editor and preview
	"DefaultPreviewMode": "off",

	// Base URL prepended to relative image URLs in image and rich previews.
	// Set this to the directory-level path (e.g. "/content/") so that images
	// referenced by filename in the markdown resolve correctly.
	// Absolute URLs (starting with /, http://, https://, data:) are left as-is.
	"ImageBaseURL": "",

	// ---- Quadrant button definitions ----
	// Each quadrant is an array of button objects:
	//   HTML   — innerHTML for the button
	//   Action — method name, optionally "method:arg" (receives segment index as first param)
	//   Class  — additional CSS class(es) appended to the base class
	//   Title  — tooltip text
	//
	// Consumers can override any quadrant to add, remove, or reorder buttons.
	// Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	// Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.

	// Quadrant button HTML is parsed through Pict's template engine before
	// being assigned as innerHTML, so `{~I:Name~}` template tags resolve
	// to themable SVG icons from pict.providers.Icon.  Typographic
	// formatting buttons (Bold / Italic / Inline-code / Heading / Link)
	// stay as stylized letters — that's the markdown-editor convention.
	"ButtonsTL":
	[
		{ "HTML": "{~I:Close~}",    "Action": "removeSegment",    "Class": "pict-mde-btn-remove",    "Title": "Remove Segment" }
	],

	"ButtonsBL":
	[
		{ "HTML": "{~I:ArrowUp~}",   "Action": "moveSegmentUp",     "Class": "pict-mde-btn-move",     "Title": "Move Up" },
		{ "HTML": "{~I:ArrowDown~}", "Action": "moveSegmentDown",   "Class": "pict-mde-btn-move",     "Title": "Move Down" },
		{ "HTML": "{~I:Settings~}",  "Action": "toggleControls",    "Class": "pict-mde-btn-linenums", "Title": "Toggle Controls" },
		{ "HTML": "{~I:Eye~}",       "Action": "cyclePreviewMode",  "Class": "pict-mde-btn-preview",  "Title": "Cycle Preview Mode" }
	],

	"ButtonsTR":
	[
		{ "HTML": "<b>B</b>",            "Action": "applyFormatting:bold",     "Class": "", "Title": "Bold (Ctrl+B)" },
		{ "HTML": "<i>I</i>",            "Action": "applyFormatting:italic",   "Class": "", "Title": "Italic (Ctrl+I)" },
		{ "HTML": "<code>&lt;&gt;</code>","Action": "applyFormatting:code",    "Class": "", "Title": "Inline Code (Ctrl+E)" },
		{ "HTML": "#",                   "Action": "applyFormatting:heading",  "Class": "", "Title": "Heading" },
		{ "HTML": "[&thinsp;]",          "Action": "applyFormatting:link",     "Class": "", "Title": "Link" },
		{ "HTML": "{~I:Image~}",         "Action": "openImagePicker",          "Class": "pict-mde-sidebar-btn-image", "Title": "Insert Image" }
	],

	"ButtonsBR":
	[
	],

	// CSS for the markdown editor
	"CSS": /*css*/`
/* ---- Container ---- */
.pict-mde
{
	font-family: var(--theme-typography-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif);
	font-size: 14px;
}

/* ---- Segment row: left-controls | drag-handle | editor body | sidebar ---- */
.pict-mde-segment
{
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	margin-bottom: 6px;
	min-height: 48px;
	transition: background-color 0.15s ease;
}

/* ---- Left controls column ---- */
.pict-mde-left-controls
{
	flex: 0 0 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 2px 0;
}

/* ---- Left-side quadrants ---- */
.pict-mde-quadrant-tl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	position: sticky;
	top: 2px;
	z-index: 2;
}
.pict-mde-quadrant-bl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	position: sticky;
	bottom: 2px;
	z-index: 2;
}

/* ---- Left-side buttons (shared base) ---- */
.pict-mde-left-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	color: var(--theme-color-text-muted, #888);
	line-height: 1;
	font-family: inherit;
	opacity: 0;
	transition: opacity 0.15s ease;
}
.pict-mde-segment:hover .pict-mde-left-btn,
.pict-mde-segment.pict-mde-active .pict-mde-left-btn
{
	opacity: 1;
}
.pict-mde-left-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-btn-remove:hover
{
	color: var(--theme-color-status-error, #CC3333);
}
.pict-mde-btn-linenums
{
	font-size: 11px;
	font-weight: 600;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}
/* Highlight when controls are active */
.pict-mde.pict-mde-controls-on .pict-mde-btn-linenums
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-btn-preview
{
	font-size: 11px;
}
/* Preview button: highlight when any preview mode is active */
.pict-mde.pict-mde-preview-bottom .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-side .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-tabbed .pict-mde-btn-preview
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
/* Dim preview button when mode is off */
.pict-mde.pict-mde-preview-off .pict-mde-btn-preview
{
	color: var(--theme-color-border-default, #CCC);
}

/* ---- Drag handle (simple grey bar) ---- */
.pict-mde-drag-handle
{
	flex: 0 0 8px;
	cursor: grab;
	background: var(--theme-color-background-tertiary, #EDEDED);
	transition: background-color 0.15s ease;
	user-select: none;
}
.pict-mde-drag-handle:active
{
	cursor: grabbing;
}
.pict-mde-drag-handle:hover
{
	background: var(--theme-color-border-default, #C8C8C8);
}

/* ---- Editor body (middle column) ---- */
.pict-mde-segment-body
{
	flex: 1 1 0%;
	min-width: 0;
	overflow: hidden;
	background: var(--theme-color-background-panel, #FFFFFF);
	transition: background-color 0.15s ease;
}
.pict-mde-segment-editor
{
	min-height: 48px;
}

/* ---- Image preview area below the editor ---- */
.pict-mde-image-preview
{
	display: none;
}
.pict-mde-image-preview.pict-mde-has-images
{
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 8px 12px;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
}
.pict-mde-image-preview img
{
	max-width: 200px;
	max-height: 150px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	object-fit: contain;
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-image-preview-item
{
	position: relative;
	display: inline-block;
}
.pict-mde-image-preview-label
{
	display: block;
	font-size: 10px;
	color: var(--theme-color-text-muted, #999);
	margin-top: 2px;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* ---- Rich content preview area (rendered via pict-section-content) ---- */
.pict-mde-rich-preview
{
	display: none;
}
.pict-mde-rich-preview.pict-mde-has-rich-preview
{
	display: block;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-panel, #FCFCFC);
	overflow: hidden;
}
/* Constrain images in the rich preview even if pict-section-content CSS loads late */
.pict-mde-rich-preview img
{
	max-width: 100%;
	height: auto;
}
/* ---- Preview layout modes ---- */

/* Tab bar: hidden by default, shown only in tabbed mode */
.pict-mde-tab-bar
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-tab-bar
{
	display: flex;
	gap: 0;
	border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-tab
{
	padding: 4px 12px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	color: var(--theme-color-text-muted, #888);
	border-bottom: 2px solid transparent;
	font-family: inherit;
}
.pict-mde-tab:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-tab.pict-mde-tab-active
{
	color: var(--theme-color-brand-primary, #4A90D9);
	border-bottom-color: var(--theme-color-brand-primary, #4A90D9);
}

/* Off mode: hide all preview panes and tab bars */
.pict-mde.pict-mde-preview-off .pict-mde-preview-pane
{
	display: none;
}
.pict-mde.pict-mde-preview-off .pict-mde-tab-bar
{
	display: none;
}
/* Legacy class alias for backward compatibility */
.pict-mde.pict-mde-previews-hidden .pict-mde-preview-pane
{
	display: none;
}

/* Bottom mode: vertical stacking (default flex-column behavior) */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}

/* Side-by-side mode: editor and preview side by side */
.pict-mde.pict-mde-preview-side .pict-mde-segment-body
{
	display: flex;
	flex-direction: row;
}
.pict-mde.pict-mde-preview-side .pict-mde-segment-editor
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: hidden;
}
.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: auto;
	border-left: 1px solid var(--theme-color-border-light, #EDEDED);
}
/* Side-by-side: remove top borders since preview is beside, not below */
.pict-mde.pict-mde-preview-side .pict-mde-rich-preview.pict-mde-has-rich-preview
{
	border-top: none;
}
.pict-mde.pict-mde-preview-side .pict-mde-image-preview.pict-mde-has-images
{
	border-top: none;
}

/* Tabbed mode: default hides preview, shows editor */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-preview-pane
{
	display: none;
}
/* Tabbed mode: when showing preview, hide editor and show preview */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-segment-editor
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-preview-pane
{
	display: block;
}

/* Per-segment preview hide: only applies in bottom and side modes */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane,
.pict-mde.pict-mde-preview-side .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane
{
	display: none;
}
/* Constrain the pict-content inside the preview to fit the segment */
.pict-mde-rich-preview .pict-content
{
	padding: 12px;
	max-width: none;
	margin: 0;
	font-size: 13px;
}
/* Reduce heading sizes in the preview to be proportional */
.pict-mde-rich-preview .pict-content h1
{
	font-size: 1.4em;
	margin-top: 0;
}
.pict-mde-rich-preview .pict-content h2
{
	font-size: 1.2em;
	margin-top: 0.75em;
}
.pict-mde-rich-preview .pict-content h3
{
	font-size: 1.1em;
	margin-top: 0.6em;
}

/* ---- Rendered view (full document preview mode) ---- */
.pict-mde-rendered-view
{
	padding: 16px 20px;
	background: var(--theme-color-background-panel, #FFFFFF);
	min-height: 120px;
}
.pict-mde-rendered-view .pict-content
{
	max-width: none;
	margin: 0;
}
/* Hide the add-segment button in rendered mode */
.pict-mde.pict-mde-rendered-mode .pict-mde-add-segment
{
	display: none;
}

/* Focused / active editor gets subtle warm background */
.pict-mde-segment.pict-mde-active .pict-mde-segment-body
{
	background: var(--theme-color-background-secondary, #FAFAF5);
}
.pict-mde-segment.pict-mde-active .pict-mde-drag-handle
{
	background: var(--theme-color-border-strong, #9CB4C8);
}

/* ---- Right sidebar column ---- */
.pict-mde-sidebar
{
	flex: 0 0 30px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;
}

/* ---- Right-side quadrants ---- */
.pict-mde-quadrant-tr
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease, top 0.1s ease;
	position: sticky;
	top: 0;
}
.pict-mde-quadrant-br
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease;
	position: sticky;
	bottom: 0;
}

/* Active segment always shows its right-side quadrants */
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 1;
}
/* When no segment is active, hovering shows both left + right controls */
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 1;
}

/* ---- Controls-hidden mode: right quadrants show faintly on hover ---- */
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-br
{
	opacity: 0;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 0.3;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 0.3;
}

/* When JS sets a cursor-relative offset, switch TR from sticky to absolute positioning */
.pict-mde-quadrant-tr.pict-mde-sidebar-at-cursor
{
	position: absolute;
	top: var(--pict-mde-sidebar-top, 0px);
}

/* ---- Right-side buttons (shared base) ---- */
.pict-mde-sidebar-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 22px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	border-radius: 3px;
	color: var(--theme-color-text-secondary, #666);
	line-height: 1;
	font-family: inherit;
}
.pict-mde-sidebar-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-sidebar-btn b
{
	font-size: 13px;
	font-weight: 700;
}
.pict-mde-sidebar-btn i
{
	font-size: 13px;
	font-style: italic;
}
.pict-mde-sidebar-btn code
{
	font-size: 10px;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}

/* ---- Add segment button ---- */
.pict-mde-add-segment
{
	margin-top: 6px;
	padding-left: 30px;
}
.pict-mde-btn-add
{
	display: block;
	width: 100%;
	padding: 7px;
	border: 2px dashed var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	background: transparent;
	color: var(--theme-color-text-muted, #999);
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
}
.pict-mde-btn-add:hover
{
	border-color: var(--theme-color-brand-primary, #4A90D9);
	color: var(--theme-color-brand-primary, #4A90D9);
	background: rgba(74, 144, 217, 0.04);
}

/* ---- Image drag-over indicator ---- */
.pict-mde-segment-editor.pict-mde-image-dragover
{
	outline: 2px dashed var(--theme-color-brand-primary, #4A90D9);
	outline-offset: -2px;
}

/* ---- Drag-in-progress: prevent CodeMirror from intercepting drop events ---- */
.pict-mde.pict-mde-dragging .pict-mde-segment-editor
{
	pointer-events: none;
}

/* ---- Drop target indicators for drag reorder ---- */
.pict-mde-segment.pict-mde-drag-over-top
{
	box-shadow: 0 -2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-segment.pict-mde-drag-over-bottom
{
	box-shadow: 0 2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}

/* ---- CodeMirror overrides inside segments ---- */
.pict-mde-segment-editor .cm-editor
{
	border: none;
}
.pict-mde-segment-editor .cm-editor .cm-scroller
{
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.6;
}
.pict-mde-segment-editor .cm-editor.cm-focused
{
	outline: none;
}
.pict-mde-segment-editor .cm-editor .cm-content
{
	padding: 8px 12px;
	min-height: 36px;
}
.pict-mde-segment-editor .cm-editor .cm-gutters
{
	background: var(--theme-color-background-secondary, #F8F8F8);
	border-right: 1px solid var(--theme-color-border-light, #E8E8E8);
	color: var(--theme-color-text-muted, #BBB);
}

/* ---- Collapsed data URI widget ---- */
.pict-mde-data-uri-collapsed
{
	display: inline;
	background: var(--theme-color-background-tertiary, #F0F0F0);
	color: var(--theme-color-text-muted, #888);
	font-size: 11px;
	padding: 1px 4px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
	cursor: default;
	white-space: nowrap;
}

/* ---- Line number / controls toggle: gutters hidden by default ---- */
.pict-mde .cm-editor .cm-gutters
{
	display: none;
}
.pict-mde.pict-mde-controls-on .cm-editor .cm-gutters
{
	display: flex;
}

/* ============================================
   RESPONSIVE: Tablet / Phone (max-width: 768px)
   ============================================ */
@media (max-width: 768px)
{
	/* Prevent any horizontal overflow in the editor */
	.pict-mde
	{
		overflow-x: hidden;
		max-width: 100%;
	}

	/* Reduce the left controls column width */
	.pict-mde-left-controls
	{
		flex: 0 0 16px;
	}
	.pict-mde-left-btn
	{
		width: 16px;
		height: 18px;
		font-size: 10px;
	}

	/* Make left-side buttons always visible on touch (no hover) */
	.pict-mde-left-btn
	{
		opacity: 0.6;
	}

	/* Narrow the drag handle */
	.pict-mde-drag-handle
	{
		flex: 0 0 5px;
	}

	/* Shrink the right sidebar column */
	.pict-mde-sidebar
	{
		flex: 0 0 24px;
	}
	.pict-mde-sidebar-btn
	{
		width: 20px;
		height: 20px;
		font-size: 11px;
	}

	/* Make right sidebar buttons always visible (touch devices) */
	.pict-mde-quadrant-tr,
	.pict-mde-quadrant-br
	{
		opacity: 0.7;
	}
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
	{
		opacity: 1;
	}

	/* Reduce CodeMirror content padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 6px 6px;
	}

	/* Reduce font size slightly for more content on screen */
	.pict-mde-segment-editor .cm-editor .cm-scroller
	{
		font-size: 13px;
	}

	/* Add segment button: reduce left margin */
	.pict-mde-add-segment
	{
		padding-left: 21px;
	}

	/* Side-by-side: fall back to vertical stacking on narrow screens */
	.pict-mde.pict-mde-preview-side .pict-mde-segment-body
	{
		flex-direction: column;
	}
	.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
	{
		border-left: none;
		border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	}

	/* Tab bar: smaller on tablet */
	.pict-mde-tab
	{
		padding: 3px 8px;
		font-size: 11px;
	}

	/* Rich preview: less padding */
	.pict-mde-rich-preview .pict-content
	{
		padding: 8px;
		font-size: 12px;
	}

	/* Image previews: smaller max dimensions */
	.pict-mde-image-preview img
	{
		max-width: 120px;
		max-height: 100px;
	}

	/* Rendered view: less padding */
	.pict-mde-rendered-view
	{
		padding: 10px 8px;
	}
}

/* ============================================
   RESPONSIVE: Small phone (max-width: 480px)
   ============================================ */
@media (max-width: 480px)
{
	/* Wrap segment so left controls flow to the top as a horizontal bar */
	.pict-mde-segment
	{
		flex-wrap: wrap;
	}

	/* Left controls become a horizontal toolbar at the top of the segment */
	.pict-mde-left-controls
	{
		flex: 0 0 100%;
		flex-direction: row;
		justify-content: flex-start;
		gap: 2px;
		padding: 3px 4px;
		order: -1;
		background: var(--theme-color-background-secondary, #F5F5F5);
		border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	}
	.pict-mde-left-btn
	{
		width: 24px;
		height: 24px;
		font-size: 12px;
		opacity: 0.7;
	}

	/* Left quadrants flow horizontally */
	.pict-mde-quadrant-tl,
	.pict-mde-quadrant-bl
	{
		flex-direction: row;
		gap: 2px;
		position: static;
	}

	/* Segment body: explicit basis so it fills the wrapped row */
	.pict-mde-segment-body
	{
		flex: 1 1 calc(100% - 20px);
	}

	/* Hide drag handle on very small screens */
	.pict-mde-drag-handle
	{
		display: none;
	}

	/* Right sidebar: further shrink */
	.pict-mde-sidebar
	{
		flex: 0 0 20px;
	}
	.pict-mde-sidebar-btn
	{
		width: 18px;
		height: 18px;
		font-size: 10px;
	}

	/* Add segment: no left offset since controls are at top */
	.pict-mde-add-segment
	{
		padding-left: 0;
	}

	/* Even tighter CodeMirror padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 4px 4px;
	}
}
`
});

},{}],261:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libPictSectionContent = require('pict-section-content');
const _DefaultConfiguration = require('./Pict-Section-MarkdownEditor-DefaultConfiguration.js');

// Helper modules
const libFormatting = require('./Pict-MDE-Formatting.js');
const libImageHandling = require('./Pict-MDE-ImageHandling.js');
const libDragAndReorder = require('./Pict-MDE-DragAndReorder.js');
const libRichPreview = require('./Pict-MDE-RichPreview.js');
const libCodeMirror = require('./Pict-MDE-CodeMirror.js');

class PictSectionMarkdownEditor extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// CodeMirror prototype references (injected by consumer or found on window)
		this._codeMirrorModules = null;

		// Map of segment index to CodeMirror EditorView instance
		this._segmentEditors = {};

		// Internal segment counter (monotonically increasing for unique IDs)
		this._segmentCounter = 0;

		// The view identifier used for onclick handlers in templates
		this._viewCallIdentifier = false;

		// Currently active (focused) segment index, or -1
		this._activeSegmentIndex = -1;

		// Drag state for reorder
		this._dragSourceIndex = -1;

		// Whether controls (line numbers + right sidebar) are currently visible
		this._controlsVisible = true;

		// Current preview layout mode: "off", "bottom", "side", "tabbed"
		this._previewMode = this.options.DefaultPreviewMode || 'off';

		// Last non-off preview layout, for togglePreview() backward compatibility
		this._lastPreviewLayout = 'bottom';

		// Per-segment tab state in tabbed mode (keyed by logical index; "editor" or "preview")
		this._segmentTabStates = {};

		// Set of logical segment indices where preview has been individually hidden
		this._hiddenPreviewSegments = {};

		// Debounce timers for image preview updates (keyed by segment index)
		this._imagePreviewTimers = {};

		// Debounce timers for rich content preview updates (keyed by segment index)
		this._richPreviewTimers = {};

		// Generation counters for mermaid async rendering (keyed by segment index)
		this._richPreviewGenerations = {};

		// Content provider for markdown-to-HTML rendering in rich previews
		// (pict-section-content provides parseMarkdown, code highlighting, etc.)
		this._contentProvider = null;

		// Whether the rendered (read-mode) view is currently active
		this._renderedViewActive = false;

		// Generation counter for rendered view mermaid async rendering
		this._renderedViewGeneration = 0;

		// Attach helper modules
		libFormatting.attach(this);
		libImageHandling.attach(this);
		libDragAndReorder.attach(this);
		libRichPreview.attach(this);
		libCodeMirror.attach(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElement = false;

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeMirror modules.  The consumer must pass an object with:
	 *   - EditorView: the EditorView class
	 *   - EditorState: the EditorState class
	 *   - extensions: an array of extensions to use (e.g. basicSetup, markdown(), etc.)
	 *
	 * If not called explicitly, the view will attempt to find them on window.CodeMirrorModules.
	 *
	 * @param {object} [pCodeMirrorModules] - The CodeMirror modules object
	 * @returns {boolean|void}
	 */
	connectCodeMirrorModules(pCodeMirrorModules)
	{
		if (pCodeMirrorModules && typeof (pCodeMirrorModules) === 'object')
		{
			if (typeof (pCodeMirrorModules.EditorView) === 'function' && typeof (pCodeMirrorModules.EditorState) === 'function')
			{
				this._codeMirrorModules = pCodeMirrorModules;
				return;
			}
		}

		// Try to find CodeMirror modules in global scope
		if (typeof (window) !== 'undefined')
		{
			if (window.CodeMirrorModules && typeof (window.CodeMirrorModules.EditorView) === 'function')
			{
				this.log.trace(`PICT-MarkdownEditor Found CodeMirror modules on window.CodeMirrorModules.`);
				this._codeMirrorModules = window.CodeMirrorModules;
				return;
			}
		}

		this.log.error(`PICT-MarkdownEditor No CodeMirror modules found. Provide them via connectCodeMirrorModules() or set window.CodeMirrorModules.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		else
		{
			// A re-render means the host re-created our destination element (an
			// editor shown/hidden, or remounted into a fresh container). The
			// targetElement cached on the first render is now detached, so a
			// rebuild would write segments into an orphaned node. Re-resolve the
			// live target and rebuild into it from the current segment data.
			this._remountEditorUI();
		}

		// Inject CSS from all registered views (after onAfterInitialRender so
		// that pict-section-content's CSS is registered before injection)
		this.pict.CSSMap.injectCSS();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Re-resolve the target element from TargetElementAddress and rebuild the
	 * editor UI into it. Called on re-render so the editor survives the host
	 * replacing its destination element (which would otherwise leave
	 * this.targetElement pointing at a detached node and the live container empty).
	 */
	_remountEditorUI()
	{
		if (!this._codeMirrorModules)
		{
			return;
		}

		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			return;
		}

		this.targetElement = tmpTargetElementSet[0];
		this._buildEditorUI();
	}

	onAfterInitialRender()
	{
		// Resolve CodeMirror modules if not already set
		if (!this._codeMirrorModules)
		{
			this.connectCodeMirrorModules();
		}

		if (!this._codeMirrorModules)
		{
			this.log.error(`PICT-MarkdownEditor Cannot initialize; no CodeMirror modules available.`);
			return false;
		}

		// Register pict-section-content's CSS for rich preview rendering.
		// This ensures the rendered markdown (headings, code blocks, tables, etc.)
		// is styled correctly inside the preview area.
		if (this.options.EnableRichPreview)
		{
			let tmpContentViewConfig = libPictSectionContent.default_configuration;
			if (tmpContentViewConfig && tmpContentViewConfig.CSS)
			{
				this.pict.CSSMap.addCSS('Pict-Content-View', tmpContentViewConfig.CSS);
			}
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-MarkdownEditor Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Determine the view call identifier for onclick handlers
		this._viewCallIdentifier = this._resolveViewCallIdentifier();

		// Build the editor UI
		this._buildEditorUI();
	}

	/**
	 * Resolve how the view can be referenced from global onclick handlers.
	 * Returns a string like "_Pict.views['MyViewHash']" — bracket syntax
	 * is required so view hashes containing hyphens (e.g.
	 * "ContentEditor-MarkdownEditor") parse correctly. Dot access
	 * (`_Pict.views.X-Y`) is read as subtraction by the JS parser and
	 * the onclick silently no-ops.
	 *
	 * @returns {string}
	 */
	_resolveViewCallIdentifier()
	{
		let tmpViews = this.pict.views;
		for (let tmpViewHash in tmpViews)
		{
			if (tmpViews[tmpViewHash] === this)
			{
				return `_Pict.views['${tmpViewHash}']`;
			}
		}
		return `_Pict.servicesMap.PictView['${this.Hash}']`;
	}

	/**
	 * Get the .pict-mde container element.  Always does a fresh DOM lookup
	 * because pict's async render pipeline can replace the element between calls.
	 *
	 * @returns {HTMLElement|null}
	 */
	_getContainerElement()
	{
		if (this.targetElement)
		{
			let tmpContainer = this.targetElement.querySelector('.pict-mde');
			if (tmpContainer)
			{
				return tmpContainer;
			}
		}
		return this.targetElement || null;
	}

	/**
	 * Resolve one of THIS editor instance's elements by its raw PictMDE id, scoped to this
	 * instance's container.
	 *
	 * The segment/preview/editor elements all carry fixed ids (PictMDE-Segment-0, ...). Several
	 * markdown editors can share one page -- the Drafting Kit loops editor mounts three at once, one
	 * per loop -- and they all emit that same id space, so a document-wide getElementById would
	 * resolve the FIRST instance's element and the editors would bleed into each other. Scoping every
	 * lookup to the instance's own .pict-mde container keeps the instances independent without
	 * needing to make the ids globally unique.
	 *
	 * Falls back to a document-wide lookup only when no container is resolved yet (e.g. pre-mount),
	 * which preserves the original single-instance behavior for the entity-form and Docs Lake editors.
	 *
	 * @param {string} pElementID - the element id, e.g. `PictMDE-Segment-3`
	 * @returns {HTMLElement|null}
	 */
	_resolveInstanceElement(pElementID)
	{
		let tmpContainer = this._getContainerElement();
		if (tmpContainer && typeof tmpContainer.querySelector === 'function')
		{
			return tmpContainer.querySelector('#' + pElementID);
		}
		return document.getElementById(pElementID);
	}

	/**
	 * Resolve a URL relative to the configured ImageBaseURL.
	 *
	 * Absolute URLs (starting with /, http://, https://, data:) are returned
	 * unchanged.  Relative URLs are prepended with this.options.ImageBaseURL.
	 *
	 * @param {string} pURL - The URL to resolve
	 * @returns {string} The resolved URL
	 */
	_resolveImageURL(pURL)
	{
		if (!pURL || !this.options.ImageBaseURL)
		{
			return pURL;
		}

		// Leave absolute URLs alone
		if (pURL.startsWith('/') || pURL.startsWith('http://') || pURL.startsWith('https://') || pURL.startsWith('data:'))
		{
			return pURL;
		}

		let tmpBase = this.options.ImageBaseURL;
		// Ensure base ends with /
		if (tmpBase && !tmpBase.endsWith('/'))
		{
			tmpBase += '/';
		}

		return tmpBase + pURL;
	}

	/**
	 * Build the full editor UI: render existing segments from data and the add-segment button.
	 */
	_buildEditorUI()
	{
		let tmpContainer = this._getContainerElement();

		// Ensure the container has the pict-mde class (the template's wrapper
		// may have been replaced by pict's async render pipeline)
		if (tmpContainer && !tmpContainer.classList.contains('pict-mde'))
		{
			tmpContainer.classList.add('pict-mde');
		}

		// Destroy existing editors before clearing
		for (let tmpIdx in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIdx])
			{
				this._segmentEditors[tmpIdx].destroy();
			}
		}

		tmpContainer.innerHTML = '';

		// Restore toggle states on the container after clearing
		tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
		tmpContainer.classList.add('pict-mde-preview-' + this._previewMode);
		if (this._controlsVisible)
		{
			tmpContainer.classList.add('pict-mde-controls-on');
		}
		else
		{
			tmpContainer.classList.add('pict-mde-controls-hidden');
		}

		// Load existing segments from data address, or start with one empty segment
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length === 0)
		{
			tmpSegments = [{ Content: '' }];
			this._setSegmentsToData(tmpSegments);
		}

		this._segmentCounter = 0;
		this._segmentEditors = {};

		for (let i = 0; i < tmpSegments.length; i++)
		{
			this._renderSegment(tmpContainer, i, tmpSegments[i].Content || '');
		}

		this._renderAddButton(tmpContainer);
	}

	/**
	 * Render a single segment into the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 * @param {number} pIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	_renderSegment(pContainer, pIndex, pContent)
	{
		let tmpSegmentIndex = this._segmentCounter++;

		let tmpRecord =
		{
			SegmentIndex: tmpSegmentIndex,
			SegmentDisplayIndex: pIndex + 1,
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-Segment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpSegmentElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpSegmentElement);

		// Build quadrant buttons from configuration arrays
		this._buildQuadrantButtons(tmpSegmentElement, tmpSegmentIndex);

		// Restore per-segment preview hidden state (tracked by logical index)
		if (this._hiddenPreviewSegments[pIndex])
		{
			tmpSegmentElement.classList.add('pict-mde-preview-hidden');
		}

		// Restore per-segment tab state in tabbed mode
		if (this._previewMode === 'tabbed' && this._segmentTabStates[pIndex] === 'preview')
		{
			tmpSegmentElement.classList.add('pict-mde-tab-showing-preview');
			let tmpTabBar = tmpSegmentElement.querySelector('.pict-mde-tab-bar');
			if (tmpTabBar)
			{
				let tmpEditorTab = tmpTabBar.querySelector('[data-tab="editor"]');
				let tmpPreviewTab = tmpTabBar.querySelector('[data-tab="preview"]');
				if (tmpEditorTab) { tmpEditorTab.classList.remove('pict-mde-tab-active'); }
				if (tmpPreviewTab) { tmpPreviewTab.classList.add('pict-mde-tab-active'); }
			}
		}

		// Wire up drag-and-drop on the drag handle
		this._wireSegmentDragEvents(tmpSegmentElement, tmpSegmentIndex);

		// Create the CodeMirror editor in the segment editor container
		let tmpEditorContainer = this._resolveInstanceElement(`PictMDE-SegmentEditor-${tmpSegmentIndex}`);
		if (tmpEditorContainer)
		{
			this._createEditorInContainer(tmpEditorContainer, tmpSegmentIndex, pContent);

			// Wire image drag-and-drop on the editor container
			this._wireImageDragEvents(tmpEditorContainer, tmpSegmentIndex);

			// Render image previews for existing content
			if (pContent)
			{
				this._updateImagePreviews(tmpSegmentIndex);
				this._updateRichPreviews(tmpSegmentIndex);
			}
		}
	}

	/**
	 * Build buttons in all four quadrants (TL, BL, TR, BR) from the
	 * configuration arrays.  Each button config has:
	 *   HTML   — innerHTML
	 *   Action — "methodName" or "methodName:arg"
	 *   Class  — additional CSS class(es)
	 *   Title  — tooltip text
	 *
	 * Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	 * Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	_buildQuadrantButtons(pSegmentElement, pSegmentIndex)
	{
		let tmpQuadrants =
		[
			{ key: 'ButtonsTL', selector: '.pict-mde-quadrant-tl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsBL', selector: '.pict-mde-quadrant-bl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsTR', selector: '.pict-mde-quadrant-tr', baseClass: 'pict-mde-sidebar-btn' },
			{ key: 'ButtonsBR', selector: '.pict-mde-quadrant-br', baseClass: 'pict-mde-sidebar-btn' }
		];

		let tmpSelf = this;

		for (let q = 0; q < tmpQuadrants.length; q++)
		{
			let tmpQuadrant = tmpQuadrants[q];
			let tmpContainer = pSegmentElement.querySelector(tmpQuadrant.selector);
			if (!tmpContainer)
			{
				continue;
			}

			let tmpButtons = this.options[tmpQuadrant.key];
			if (!Array.isArray(tmpButtons))
			{
				continue;
			}

			for (let b = 0; b < tmpButtons.length; b++)
			{
				let tmpBtnConfig = tmpButtons[b];

				let tmpButton = document.createElement('button');
				tmpButton.type = 'button';
				tmpButton.className = tmpQuadrant.baseClass;
				if (tmpBtnConfig.Class)
				{
					tmpButton.className += ' ' + tmpBtnConfig.Class;
				}
				// Run the button HTML through Pict's template engine so
				// `{~I:Name~}` tags expand into themable SVG icons from
				// pict.providers.Icon.  Plain HTML strings (e.g. the
				// stylized `<b>B</b>` formatting buttons) pass through
				// unchanged — the parser is a no-op when no template tags
				// are present.
				let tmpHTML = tmpBtnConfig.HTML || '';
				if (tmpHTML && typeof (this.pict.parseTemplate) === 'function')
				{
					tmpHTML = this.pict.parseTemplate(tmpHTML, {});
				}
				tmpButton.innerHTML = tmpHTML;
				tmpButton.title = tmpBtnConfig.Title || '';

				// Parse the action string: "methodName" or "methodName:arg"
				let tmpAction = tmpBtnConfig.Action || '';
				let tmpMethod = tmpAction;
				let tmpArg = null;
				let tmpColonIndex = tmpAction.indexOf(':');
				if (tmpColonIndex >= 0)
				{
					tmpMethod = tmpAction.substring(0, tmpColonIndex);
					tmpArg = tmpAction.substring(tmpColonIndex + 1);
				}

				// Build the click handler
				(function (pMethod, pArg, pSegIdx)
				{
					tmpButton.addEventListener('click', () =>
					{
						if (typeof (tmpSelf[pMethod]) === 'function')
						{
							if (pArg !== null)
							{
								tmpSelf[pMethod](pSegIdx, pArg);
							}
							else
							{
								tmpSelf[pMethod](pSegIdx);
							}
						}
						else
						{
							tmpSelf.log.warn(`PICT-MarkdownEditor _buildQuadrantButtons: method "${pMethod}" not found.`);
						}
					});
				})(tmpMethod, tmpArg, pSegmentIndex);

				tmpContainer.appendChild(tmpButton);
			}
		}
	}


	/**
	 * Hook for subclasses to customize the CodeMirror extensions before editor creation.
	 *
	 * @param {Array} pExtensions - The extensions array to modify
	 * @param {number} pSegmentIndex - The segment index
	 * @returns {Array} The modified extensions array
	 */
	customConfigureExtensions(pExtensions, pSegmentIndex)
	{
		return pExtensions;
	}

	/**
	 * Render the "Add Segment" button at the bottom of the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 */
	_renderAddButton(pContainer)
	{
		let tmpRecord =
		{
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-AddSegment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpButtonElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpButtonElement);
	}

	/**
	 * Hook for consumers to handle image uploads.
	 *
	 * Override this in a subclass or consumer to upload images to a server/CDN.
	 * Return true to indicate you are handling the upload asynchronously.
	 * Call fCallback(null, url) on success, or fCallback(error) on failure.
	 * Return false/undefined to fall back to base64 data URI inline.
	 *
	 * @param {File} pFile - The image File object
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {function} fCallback - Callback: fCallback(pError, pURL)
	 * @returns {boolean} true if handling the upload, false to use base64 default
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		// Override in subclass or consumer
		return false;
	}

	// -- Controls Toggle (line numbers + right sidebar) --

	/**
	 * Toggle controls (line number gutters and right sidebar formatting
	 * buttons) on or off for all segments.
	 *
	 * When controls are hidden the right-side quadrants (TR, BR) appear
	 * faintly on hover but are otherwise invisible, and CodeMirror line
	 * number gutters are hidden.
	 *
	 * This method is called by the quadrant button system with the segment
	 * index as the first argument — it ignores that argument and uses only
	 * the optional boolean.
	 *
	 * @param {number|boolean} [pSegmentIndexOrVisible] - Segment index (ignored) or boolean
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleControls(pSegmentIndexOrVisible, pVisible)
	{
		// When called from a quadrant button, first arg is segment index (number).
		// When called programmatically, first arg may be a boolean.
		let tmpVisible = pVisible;
		if (typeof (pSegmentIndexOrVisible) === 'boolean')
		{
			tmpVisible = pSegmentIndexOrVisible;
		}

		if (typeof (tmpVisible) === 'boolean')
		{
			this._controlsVisible = tmpVisible;
		}
		else
		{
			this._controlsVisible = !this._controlsVisible;
		}

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			if (this._controlsVisible)
			{
				tmpContainer.classList.add('pict-mde-controls-on');
				tmpContainer.classList.remove('pict-mde-controls-hidden');
			}
			else
			{
				tmpContainer.classList.remove('pict-mde-controls-on');
				tmpContainer.classList.add('pict-mde-controls-hidden');
			}
		}
	}

	/**
	 * Toggle line numbers on or off for all segments.
	 * Backward-compatible alias for toggleControls().
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleLineNumbers(pVisible)
	{
		this.toggleControls(pVisible);
	}

	// -- Preview Toggle --

	/**
	 * Toggle rich previews on or off for all segments globally.
	 *
	 * When hidden globally, individual segment overrides are preserved
	 * so that restoring global visibility returns to the per-segment state.
	 *
	 * Backward compatible: toggles between "off" and the last-used preview layout.
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	togglePreview(pVisible)
	{
		if (typeof (pVisible) === 'boolean')
		{
			if (pVisible)
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
		else
		{
			if (this._previewMode === 'off')
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
	}

	/**
	 * Set the preview layout mode.
	 *
	 * @param {string} pMode - One of "off", "bottom", "side", "tabbed"
	 */
	setPreviewMode(pMode)
	{
		let tmpValidModes = ['off', 'bottom', 'side', 'tabbed'];
		if (tmpValidModes.indexOf(pMode) < 0)
		{
			this.log.warn(`PICT-MarkdownEditor setPreviewMode: unknown mode "${pMode}".`);
			return;
		}

		// Remember the last non-off mode for toggle restore
		if (pMode !== 'off')
		{
			this._lastPreviewLayout = pMode;
		}

		this._previewMode = pMode;

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
			tmpContainer.classList.add('pict-mde-preview-' + pMode);
		}

		// When switching to a visible preview mode, trigger preview renders
		// for all segments to ensure they are up to date
		if (pMode !== 'off')
		{
			let tmpOrderedIndices = this._getOrderedSegmentIndices();
			for (let i = 0; i < tmpOrderedIndices.length; i++)
			{
				this._updateRichPreviews(tmpOrderedIndices[i]);
				this._updateImagePreviews(tmpOrderedIndices[i]);
			}
		}
	}

	/**
	 * Cycle through preview layout modes: off → bottom → side → tabbed → off.
	 *
	 * Accepts a segment index as first argument (ignored) for compatibility
	 * with the quadrant button system.
	 *
	 * @param {number} [pSegmentIndex] - Ignored; present for quadrant button compat
	 */
	cyclePreviewMode(pSegmentIndex)
	{
		let tmpModeOrder = ['off', 'bottom', 'side', 'tabbed'];
		let tmpCurrentIndex = tmpModeOrder.indexOf(this._previewMode);
		let tmpNextIndex = (tmpCurrentIndex + 1) % tmpModeOrder.length;
		this.setPreviewMode(tmpModeOrder[tmpNextIndex]);
	}

	/**
	 * Switch a segment between editor and preview tabs (tabbed mode).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pTab - "editor" or "preview"
	 */
	switchSegmentTab(pSegmentIndex, pTab)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		this._segmentTabStates[tmpLogicalIndex] = pTab;

		let tmpSegmentEl = this._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		// Toggle the preview-showing class on the segment
		if (pTab === 'preview')
		{
			tmpSegmentEl.classList.add('pict-mde-tab-showing-preview');
			// Trigger preview render when switching to preview tab
			this._updateRichPreviews(pSegmentIndex);
			this._updateImagePreviews(pSegmentIndex);
		}
		else
		{
			tmpSegmentEl.classList.remove('pict-mde-tab-showing-preview');
		}

		// Update tab bar active state
		let tmpTabBar = this._resolveInstanceElement(`PictMDE-TabBar-${pSegmentIndex}`);
		if (tmpTabBar)
		{
			let tmpTabs = tmpTabBar.querySelectorAll('.pict-mde-tab');
			for (let i = 0; i < tmpTabs.length; i++)
			{
				if (tmpTabs[i].getAttribute('data-tab') === pTab)
				{
					tmpTabs[i].classList.add('pict-mde-tab-active');
				}
				else
				{
					tmpTabs[i].classList.remove('pict-mde-tab-active');
				}
			}
		}
	}

	/**
	 * Toggle the rich preview for a single segment.
	 *
	 * This adds/removes the .pict-mde-preview-hidden class on the
	 * individual segment element, independent of the global toggle.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleSegmentPreview(pSegmentIndex, pVisible)
	{
		// Convert internal index to logical index for persistent tracking
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpCurrentlyHidden = !!this._hiddenPreviewSegments[tmpLogicalIndex];

		if (typeof (pVisible) === 'boolean')
		{
			tmpCurrentlyHidden = !pVisible;
		}
		else
		{
			tmpCurrentlyHidden = !tmpCurrentlyHidden;
		}

		if (tmpCurrentlyHidden)
		{
			this._hiddenPreviewSegments[tmpLogicalIndex] = true;
		}
		else
		{
			delete this._hiddenPreviewSegments[tmpLogicalIndex];
		}

		let tmpSegmentEl = this._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegmentEl)
		{
			if (tmpCurrentlyHidden)
			{
				tmpSegmentEl.classList.add('pict-mde-preview-hidden');
			}
			else
			{
				tmpSegmentEl.classList.remove('pict-mde-preview-hidden');
				// Render preview content when making it visible
				this._updateRichPreviews(pSegmentIndex);
				this._updateImagePreviews(pSegmentIndex);
			}
		}
	}

	// -- Segment Data Management --

	/**
	 * Get the segments array from the configured data address.
	 *
	 * @returns {Array|null}
	 */
	_getSegmentsFromData()
	{
		if (!this.options.ContentDataAddress)
		{
			return null;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		let tmpData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.ContentDataAddress);

		if (Array.isArray(tmpData))
		{
			return tmpData;
		}

		return null;
	}

	/**
	 * Write the segments array to the configured data address.
	 *
	 * @param {Array} pSegments - The segments array
	 */
	_setSegmentsToData(pSegments)
	{
		if (!this.options.ContentDataAddress)
		{
			return;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.ContentDataAddress, pSegments);
	}

	/**
	 * Called when a segment's content changes in the CodeMirror editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pContent - The new content
	 */
	_onSegmentContentChange(pSegmentIndex, pContent)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		if (tmpLogicalIndex < tmpSegments.length)
		{
			tmpSegments[tmpLogicalIndex].Content = pContent;
		}

		this.onContentChange(tmpLogicalIndex, pContent);

		// Debounce image preview updates (500ms) to avoid thrashing on every keystroke
		let tmpSelf = this;
		if (this._imagePreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._imagePreviewTimers[pSegmentIndex]);
		}
		this._imagePreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateImagePreviews(pSegmentIndex);
			delete tmpSelf._imagePreviewTimers[pSegmentIndex];
		}, 500);

		// Debounce rich content preview updates (mermaid / KaTeX) at 500ms
		if (this._richPreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._richPreviewTimers[pSegmentIndex]);
		}
		this._richPreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateRichPreviews(pSegmentIndex);
			delete tmpSelf._richPreviewTimers[pSegmentIndex];
		}, 500);
	}

	/**
	 * Hook for subclasses to respond to content changes.
	 *
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {string} pContent - The new content
	 */
	onContentChange(pSegmentIndex, pContent)
	{
		// Override in subclass
	}

	/**
	 * Get the logical (ordered) index for an internal segment index.
	 *
	 * @param {number} pInternalIndex - The internal segment index
	 * @returns {number} The logical index, or -1 if not found
	 */
	_getLogicalIndex(pInternalIndex)
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return -1;
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			let tmpIndex = parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10);
			if (tmpIndex === pInternalIndex)
			{
				return i;
			}
		}

		return -1;
	}

	/**
	 * Get the ordered list of internal segment indices from the DOM.
	 *
	 * @returns {Array<number>}
	 */
	_getOrderedSegmentIndices()
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return [];
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		let tmpIndices = [];
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			tmpIndices.push(parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10));
		}
		return tmpIndices;
	}

	// -- Public API --

	/**
	 * Add a new empty segment at the end.
	 *
	 * @param {string} [pContent] - Optional initial content for the new segment
	 */
	addSegment(pContent)
	{
		let tmpContent = (typeof (pContent) === 'string') ? pContent : '';

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			tmpSegments = [];
		}
		tmpSegments.push({ Content: tmpContent });
		this._setSegmentsToData(tmpSegments);

		this._buildEditorUI();
	}

	/**
	 * Remove a segment by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	removeSegment(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: segment index ${pSegmentIndex} not found.`);
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length <= 1)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: cannot remove the last segment.`);
			return;
		}

		if (this._segmentEditors[pSegmentIndex])
		{
			this._segmentEditors[pSegmentIndex].destroy();
			delete this._segmentEditors[pSegmentIndex];
		}

		tmpSegments.splice(tmpLogicalIndex, 1);
		this._setSegmentsToData(tmpSegments);

		// Update per-segment hidden preview state after removal
		let tmpNewHidden = {};
		for (let tmpKey in this._hiddenPreviewSegments)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx] = true;
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx - 1] = true;
			}
			// tmpIdx === tmpLogicalIndex is the removed segment; skip it
		}
		this._hiddenPreviewSegments = tmpNewHidden;

		// Update per-segment tab states after removal
		let tmpNewTabStates = {};
		for (let tmpKey in this._segmentTabStates)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx] = this._segmentTabStates[tmpKey];
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx - 1] = this._segmentTabStates[tmpKey];
			}
		}
		this._segmentTabStates = tmpNewTabStates;

		this._buildEditorUI();
	}

	/**
	 * Move a segment up by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentUp(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex <= 0)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex - 1];
		tmpSegments[tmpLogicalIndex - 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex - 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex - 1);

		this._buildEditorUI();
	}

	/**
	 * Move a segment down by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentDown(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpSegments.length - 1)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex + 1];
		tmpSegments[tmpLogicalIndex + 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex + 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex + 1);

		this._buildEditorUI();
	}

	/**
	 * Get the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @returns {string} The segment content
	 */
	getSegmentContent(pLogicalIndex)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			return '';
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			return tmpEditor.state.doc.toString();
		}

		return '';
	}

	/**
	 * Set the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @param {string} pContent - The content to set
	 */
	setSegmentContent(pLogicalIndex, pContent)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			this.log.warn(`PICT-MarkdownEditor setSegmentContent: index ${pLogicalIndex} out of range.`);
			return;
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			tmpEditor.dispatch(
			{
				changes:
				{
					from: 0,
					to: tmpEditor.state.doc.length,
					insert: pContent
				}
			});
		}
	}

	/**
	 * Get the total number of segments.
	 *
	 * @returns {number}
	 */
	getSegmentCount()
	{
		return this._getOrderedSegmentIndices().length;
	}

	/**
	 * Get all content from all segments joined together.
	 *
	 * @param {string} [pSeparator] - The separator between segments (default: "\n\n")
	 * @returns {string}
	 */
	getAllContent(pSeparator)
	{
		let tmpSeparator = (typeof (pSeparator) === 'string') ? pSeparator : '\n\n';
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		let tmpParts = [];

		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor)
			{
				tmpParts.push(tmpEditor.state.doc.toString());
			}
		}

		return tmpParts.join(tmpSeparator);
	}

	/**
	 * Marshal all editor contents back into the data address.
	 */
	_marshalAllEditorsToData()
	{
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor && i < tmpSegments.length)
			{
				tmpSegments[i].Content = tmpEditor.state.doc.toString();
			}
		}
	}

	/**
	 * Set the read-only state of all editors.
	 *
	 * @param {boolean} pReadOnly - Whether editors should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this.initialRenderComplete)
		{
			this._marshalAllEditorsToData();
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.initialRenderComplete && this.options.ContentDataAddress)
		{
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal the current editor content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		this._marshalAllEditorsToData();
	}

	/**
	 * Destroy all editors and clean up.
	 */
	destroy()
	{
		for (let tmpIndex in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIndex])
			{
				this._segmentEditors[tmpIndex].destroy();
			}
		}
		this._segmentEditors = {};

		// Clear rich preview debounce timers
		for (let tmpIndex in this._richPreviewTimers)
		{
			clearTimeout(this._richPreviewTimers[tmpIndex]);
		}
		this._richPreviewTimers = {};
		this._richPreviewGenerations = {};
		this._segmentTabStates = {};
	}
}

module.exports = PictSectionMarkdownEditor;

module.exports.default_configuration = _DefaultConfiguration;

// Form-side integration: the `RichText` InputType (and its provider class) lives
// in pict-section-form under `providers/inputs/Pict-Provider-Input-RichText.js`,
// not here. The provider lazy-requires this module on the first setMode('edit')
// so consumers that never edit don't pull CodeMirror.
//
//   const libRichTextInput = require('pict-section-form').RichTextInput;
//   pict.addProvider('Pict-Input-RichText',
//       libRichTextInput.default_configuration, libRichTextInput);

},{"./Pict-MDE-CodeMirror.js":255,"./Pict-MDE-DragAndReorder.js":256,"./Pict-MDE-Formatting.js":257,"./Pict-MDE-ImageHandling.js":258,"./Pict-MDE-RichPreview.js":259,"./Pict-Section-MarkdownEditor-DefaultConfiguration.js":260,"pict-section-content":196,"pict-view":365}],262:[function(require,module,exports){
/**
 * Pict-Modal-Confirm
 *
 * Builds confirm and double-confirm dialog DOM, returns Promises.
 */
class PictModalConfirm
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a single-step confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmLabel, cancelLabel, dangerous)
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is provided, user must type it to enable the confirm button.
	 * Otherwise, first click changes button text, second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel)
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultDoubleConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDoubleConfirmDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Build a standard confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpBtnStyle = pOptions.dangerous ? 'danger' : 'primary';

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				'<p>' + this._escapeHTML(pMessage) + '</p>' +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--' + tmpBtnStyle + '" data-action="confirm">' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpConfirmBtn.addEventListener('click', () => { tmpDismiss(true); });

		tmpDialog._dismiss = tmpDismiss;
		tmpDialog._focusTarget = tmpCancelBtn;

		return tmpDialog;
	}

	/**
	 * Build a double-confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDoubleConfirmDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpHasPhrase = (typeof pOptions.confirmPhrase === 'string') && (pOptions.confirmPhrase.length > 0);

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		let tmpBodyContent = '<p>' + this._escapeHTML(pMessage) + '</p>';

		if (tmpHasPhrase)
		{
			let tmpPromptText = pOptions.phrasePrompt.replace('{phrase}', pOptions.confirmPhrase);
			tmpBodyContent +=
				'<div class="pict-modal-confirm-prompt">' + this._escapeHTML(tmpPromptText) + '</div>' +
				'<input type="text" class="pict-modal-confirm-input" autocomplete="off" spellcheck="false" />';
		}

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				tmpBodyContent +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--danger" data-action="confirm" disabled>' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });

		if (tmpHasPhrase)
		{
			// Phrase-based: enable confirm button when input matches
			let tmpInput = tmpDialog.querySelector('.pict-modal-confirm-input');
			tmpInput.addEventListener('input', () =>
			{
				tmpConfirmBtn.disabled = (tmpInput.value !== pOptions.confirmPhrase);
			});
			tmpConfirmBtn.addEventListener('click', () =>
			{
				if (!tmpConfirmBtn.disabled)
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpInput;
		}
		else
		{
			// Two-click: first click changes label, second click confirms
			let tmpClickCount = 0;
			let tmpOriginalLabel = pOptions.confirmLabel;
			tmpConfirmBtn.disabled = false;

			tmpConfirmBtn.addEventListener('click', () =>
			{
				tmpClickCount++;
				if (tmpClickCount === 1)
				{
					tmpConfirmBtn.textContent = 'Click again to confirm';
				}
				else
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpCancelBtn;
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show a dialog element: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {function} fResolve - Promise resolver (for overlay click dismiss)
	 */
	_showDialog(pDialog, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'confirm'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(false); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track active modal
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus
		if (pDialog._focusTarget)
		{
			pDialog._focusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pDialog._dismiss(false);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);
	}

	/**
	 * Dismiss a dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult - Value to resolve the promise with
	 * @param {function} fResolve - Promise resolver
	 */
	_dismissDialog(pDialog, pResult, fResolve)
	{
		// Prevent double-dismiss
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		// Remove keyboard handler
		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		// Animate out
		pDialog.classList.remove('pict-modal-visible');

		// Remove from active modals
		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		// Update overlay click handler to point to new topmost modal
		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		// Hide overlay
		this._modal._overlay.hide();

		// Remove from DOM after transition
		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		// Resolve promise
		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalConfirm;

},{}],263:[function(require,module,exports){
/**
 * Pict-Modal-Dropdown
 *
 * Anchor-positioned menu that behaves like a dropdown / popover. Handy for:
 *   - nav menus that hang off a header link or button
 *   - "split button" style addenda (a primary action paired with a chevron
 *     that opens a list of related/alternate actions)
 *   - any "more options" affordance where a full modal would be heavy
 *
 * Differences from the modal Window helper:
 *   - No backdrop overlay — the rest of the page stays interactive.
 *   - Positioned next to the anchor element, not centered.
 *   - Auto-flips above when there isn't room below; clamps inside the viewport.
 *   - Click outside or Escape dismisses (matches native menu conventions).
 *
 * Usage:
 *     modal.dropdown(anchorEl, {
 *         items:
 *         [
 *             { Hash: 'edit',   Label: 'Edit'                    },
 *             { Hash: 'rename', Label: 'Rename...'                },
 *             { Separator: true                                   },
 *             { Hash: 'delete', Label: 'Delete', Style: 'danger'  },
 *             { Hash: 'archive',Label: 'Archive', Disabled: true,
 *               Tooltip: 'Already archived'                       }
 *         ],
 *         align: 'left'        // 'left' | 'right' (relative to anchor)
 *     }).then((pChoice) => { ... });
 *
 * Returns a Promise that resolves with `{ Hash, Item }` on selection or
 * `null` on dismiss.
 */
class PictModalDropdown
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._activeMenu = null;
	}

	/**
	 * Open a dropdown menu anchored to an element.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   a rect-like { left, top, width, height } anchor (handy for context menus).
	 * @param {object} pOptions
	 * @param {Array}    pOptions.items     - [{ Hash, Label, Style?, Disabled?, Tooltip?, Icon?, Separator? }]
	 * @param {string}   [pOptions.ContentHTML] - Free-form HTML body for the popover, rendered
	 *   verbatim via innerHTML INSTEAD of building a menu from items[]. When set, the element is
	 *   a plain anchored popover (no role=menu / keyboard item nav); outside-click, Escape,
	 *   auto-flip and reposition still apply. Sanitize untrusted content. items is ignored.
	 * @param {string}   [pOptions.align]   - 'left'|'right'|'center' (default 'left')
	 * @param {string}   [pOptions.position]- 'auto'|'below'|'above' (default 'auto')
	 * @param {string}   [pOptions.minWidth]- CSS minWidth (default: anchor width if known, else '160px')
	 * @param {string}   [pOptions.maxWidth]- CSS maxWidth (default unset; the base menu caps at 360px,
	 *   the --content variant uncaps — set this for wide rich-content popovers)
	 * @param {string}   [pOptions.maxHeight]- CSS maxHeight (default '60vh')
	 * @param {string}   [pOptions.className]- extra class(es) for the menu element
	 * @param {boolean}  [pOptions.closeOnSelect] - default true (no-op in ContentHTML mode)
	 * @param {function} [pOptions.onSelect]- called with (Hash, Item) on selection
	 * @param {function} [pOptions.onClose] - called after dismiss
	 * @returns {Promise<{Hash: string, Item: object}|null>}
	 */
	dropdown(pAnchor, pOptions)
	{
		let tmpOptions = Object.assign(
			{
				align:         'left',
				position:      'auto',
				maxHeight:     '60vh',
				closeOnSelect: true,
			},
			pOptions || {});

		let tmpAnchorEl = this._resolveAnchor(pAnchor);
		let tmpAnchorRect = this._anchorRect(pAnchor, tmpAnchorEl);
		if (!tmpAnchorRect) { return Promise.resolve(null); }

		// Re-opening the same menu is a no-op; closing-then-reopening is a
		// caller decision (just call dismissDropdown() first).
		if (this._activeMenu && this._activeMenu.anchor === tmpAnchorEl)
		{
			return this._activeMenu.promise;
		}

		// Only one dropdown at a time keeps focus / keyboard handling sane.
		this.dismissAll();

		let tmpItems = Array.isArray(tmpOptions.items) ? tmpOptions.items : [];

		let tmpResolveOuter;
		let tmpPromise = new Promise((fResolve) => { tmpResolveOuter = fResolve; });

		let tmpMenu = this._buildMenu(tmpItems, tmpOptions);
		document.body.appendChild(tmpMenu);
		this._positionMenu(tmpMenu, tmpAnchorRect, tmpOptions);

		// Animate in on the next frame.
		void tmpMenu.offsetHeight;
		tmpMenu.classList.add('pict-modal-visible');

		let tmpDismiss = (pResult) =>
		{
			if (tmpMenu._dismissed) { return; }
			tmpMenu._dismissed = true;
			document.removeEventListener('mousedown', tmpOutsideHandler, true);
			document.removeEventListener('keydown', tmpKeyHandler, true);
			window.removeEventListener('resize', tmpRepositionHandler);
			window.removeEventListener('scroll', tmpRepositionHandler, true);
			tmpMenu.classList.remove('pict-modal-visible');
			setTimeout(() =>
				{
					if (tmpMenu.parentNode) { tmpMenu.parentNode.removeChild(tmpMenu); }
				}, 180);
			if (this._activeMenu && this._activeMenu.element === tmpMenu) { this._activeMenu = null; }
			if (typeof tmpOptions.onClose === 'function') { tmpOptions.onClose(pResult); }
			tmpResolveOuter(pResult);
		};

		// Wire item clicks (each item element carries a data-hash; separators
		// and disabled items are skipped).
		let tmpItemEls = tmpMenu.querySelectorAll('[data-pict-modal-dropdown-item]');
		for (let i = 0; i < tmpItemEls.length; i++)
		{
			let tmpEl = tmpItemEls[i];
			tmpEl.addEventListener('click', (pEvent) =>
				{
					if (tmpEl.hasAttribute('data-disabled')) { return; }
					pEvent.stopPropagation();
					let tmpIdx = parseInt(tmpEl.getAttribute('data-index'), 10);
					let tmpItem = tmpItems[tmpIdx];
					let tmpHash = tmpEl.getAttribute('data-hash');
					if (typeof tmpOptions.onSelect === 'function')
					{
						tmpOptions.onSelect(tmpHash, tmpItem);
					}
					if (tmpOptions.closeOnSelect !== false) { tmpDismiss({ Hash: tmpHash, Item: tmpItem }); }
				});
		}

		// Click anywhere outside the menu (and outside the anchor) → dismiss.
		// Use mousedown/capture so we beat any per-element click handlers.
		let tmpOutsideHandler = (pEvent) =>
		{
			if (tmpMenu.contains(pEvent.target)) { return; }
			if (tmpAnchorEl && tmpAnchorEl.contains && tmpAnchorEl.contains(pEvent.target)) { return; }
			tmpDismiss(null);
		};
		document.addEventListener('mousedown', tmpOutsideHandler, true);

		// Esc dismisses; arrow keys navigate items (skipping disabled/separator).
		let tmpKeyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape') { pEvent.stopPropagation(); tmpDismiss(null); return; }
			if (pEvent.key === 'ArrowDown' || pEvent.key === 'ArrowUp')
			{
				pEvent.preventDefault();
				this._focusNeighbor(tmpMenu, pEvent.key === 'ArrowDown' ? 1 : -1);
			}
			else if (pEvent.key === 'Enter' || pEvent.key === ' ')
			{
				let tmpFocused = document.activeElement;
				if (tmpFocused && tmpMenu.contains(tmpFocused) && tmpFocused.hasAttribute('data-pict-modal-dropdown-item'))
				{
					pEvent.preventDefault();
					tmpFocused.click();
				}
			}
		};
		document.addEventListener('keydown', tmpKeyHandler, true);

		// Reposition on viewport resize / scroll so the menu doesn't drift
		// off the anchor.
		let tmpRepositionHandler = () =>
		{
			let tmpRect = this._anchorRect(pAnchor, tmpAnchorEl);
			if (tmpRect) { this._positionMenu(tmpMenu, tmpRect, tmpOptions); }
		};
		window.addEventListener('resize', tmpRepositionHandler);
		window.addEventListener('scroll', tmpRepositionHandler, true);

		// Move keyboard focus to the first enabled item so arrows / Enter work
		// without an extra click.
		setTimeout(() => { this._focusFirstEnabled(tmpMenu); }, 0);

		this._activeMenu = { element: tmpMenu, anchor: tmpAnchorEl, promise: tmpPromise, dismiss: tmpDismiss };

		return tmpPromise;
	}

	/**
	 * Dismiss the currently-open dropdown (if any).
	 */
	dismissAll()
	{
		if (this._activeMenu)
		{
			let tmpDismiss = this._activeMenu.dismiss;
			this._activeMenu = null;
			tmpDismiss(null);
		}
	}

	// ─────────────────────────────────────────────
	//  Internals
	// ─────────────────────────────────────────────

	_resolveAnchor(pAnchor)
	{
		if (!pAnchor) { return null; }
		if (typeof pAnchor === 'string') { return document.querySelector(pAnchor); }
		if (pAnchor.nodeType === 1) { return pAnchor; }
		// rect-like — no element to attach focus / outside-click ignore to,
		// but that's fine, the caller knows what they're doing.
		return null;
	}

	_anchorRect(pAnchor, pAnchorEl)
	{
		if (pAnchorEl && typeof pAnchorEl.getBoundingClientRect === 'function')
		{
			return pAnchorEl.getBoundingClientRect();
		}
		if (pAnchor && typeof pAnchor === 'object'
			&& typeof pAnchor.left === 'number' && typeof pAnchor.top === 'number')
		{
			return {
				left:   pAnchor.left,
				top:    pAnchor.top,
				width:  pAnchor.width  || 0,
				height: pAnchor.height || 0,
				right:  pAnchor.left + (pAnchor.width  || 0),
				bottom: pAnchor.top  + (pAnchor.height || 0),
			};
		}
		return null;
	}

	/**
	 * True when the value is usable as ContentHTML — a primitive string or a
	 * boxed String object (some template engines hand back `new String(...)`,
	 * which is `typeof 'object'` and would otherwise slip past the guard).
	 *
	 * @param {*} pValue
	 * @returns {boolean}
	 */
	_isContentHTML(pValue)
	{
		return (typeof pValue === 'string') || (pValue instanceof String);
	}

	_buildMenu(pItems, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpMenu = document.createElement('div');
		tmpMenu.className = 'pict-modal-dropdown';
		// Free-form content popovers carry a modifier so the host can reset the
		// menu-item chrome (padding / max-width) and style the body itself.
		if (this._isContentHTML(pOptions.ContentHTML)) { tmpMenu.className += ' pict-modal-dropdown--content'; }
		if (pOptions.className) { tmpMenu.className += ' ' + pOptions.className; }
		tmpMenu.id = 'pict-modal-dropdown-' + tmpId;
		tmpMenu.style.maxHeight = pOptions.maxHeight;
		if (pOptions.maxWidth) { tmpMenu.style.maxWidth = pOptions.maxWidth; }

		// ContentHTML mode: render the caller's HTML verbatim instead of building
		// a menu from items[]. This is a free-form anchored popover (e.g. a rich
		// info card, or a pre-rendered template menu) — not a role=menu list, so
		// we skip the menu role and the per-item keyboard semantics. Outside-click
		// / Escape / auto-flip / reposition all still apply from dropdown().
		if (this._isContentHTML(pOptions.ContentHTML))
		{
			tmpMenu.innerHTML = pOptions.ContentHTML;
			return tmpMenu;
		}

		tmpMenu.setAttribute('role', 'menu');

		let tmpHtml = '';
		for (let i = 0; i < pItems.length; i++)
		{
			let tmpItem = pItems[i];
			if (tmpItem.Separator)
			{
				tmpHtml += '<div class="pict-modal-dropdown-separator" role="separator"></div>';
				continue;
			}
			if (tmpItem.Header)
			{
				tmpHtml += '<div class="pict-modal-dropdown-header">'
					+ this._escapeHTML(tmpItem.Header) + '</div>';
				continue;
			}
			let tmpCls = 'pict-modal-dropdown-item';
			if (tmpItem.Style)    { tmpCls += ' pict-modal-dropdown-item--' + tmpItem.Style; }
			if (tmpItem.Disabled) { tmpCls += ' pict-modal-dropdown-item--disabled'; }
			let tmpAttrs = ''
				+ ' data-pict-modal-dropdown-item'
				+ ' data-index="' + i + '"'
				+ ' data-hash="'  + this._escapeHTML(tmpItem.Hash || '') + '"'
				+ ' role="menuitem"'
				+ ' tabindex="-1"';
			if (tmpItem.Disabled) { tmpAttrs += ' aria-disabled="true" data-disabled'; }
			if (tmpItem.Tooltip)  { tmpAttrs += ' title="' + this._escapeHTML(tmpItem.Tooltip) + '"'; }
			let tmpIcon = tmpItem.Icon ? '<span class="pict-modal-dropdown-item-icon">' + tmpItem.Icon + '</span>' : '';
			let tmpHint = tmpItem.Hint ? '<span class="pict-modal-dropdown-item-hint">' + this._escapeHTML(tmpItem.Hint) + '</span>' : '';
			tmpHtml += '<div class="' + tmpCls + '"' + tmpAttrs + '>'
				+ tmpIcon
				+ '<span class="pict-modal-dropdown-item-label">' + this._escapeHTML(tmpItem.Label || '') + '</span>'
				+ tmpHint
				+ '</div>';
		}

		tmpMenu.innerHTML = tmpHtml;
		return tmpMenu;
	}

	_positionMenu(pMenu, pAnchorRect, pOptions)
	{
		// Apply min-width before measuring so the menu's natural size accounts
		// for the constraint.
		let tmpMinWidth = pOptions.minWidth
			|| (pAnchorRect.width >= 80 ? Math.ceil(pAnchorRect.width) + 'px' : '160px');
		pMenu.style.minWidth = tmpMinWidth;

		// Measure after attaching.
		let tmpMenuRect = pMenu.getBoundingClientRect();
		let tmpVw = window.innerWidth || document.documentElement.clientWidth;
		let tmpVh = window.innerHeight || document.documentElement.clientHeight;
		let tmpGap = 4; // breathing room between anchor and menu

		// Vertical: prefer below; flip above when not enough room and there's
		// more above. 'below'/'above' overrides force the side.
		let tmpRoomBelow = tmpVh - pAnchorRect.bottom - tmpGap;
		let tmpRoomAbove = pAnchorRect.top - tmpGap;
		let tmpPlaceAbove;
		if      (pOptions.position === 'above') { tmpPlaceAbove = true; }
		else if (pOptions.position === 'below') { tmpPlaceAbove = false; }
		else { tmpPlaceAbove = (tmpMenuRect.height > tmpRoomBelow) && (tmpRoomAbove > tmpRoomBelow); }

		// Cap height to whichever side we landed on so the menu can scroll
		// internally instead of running off the screen.
		let tmpCap = Math.max(80, (tmpPlaceAbove ? tmpRoomAbove : tmpRoomBelow) - 8);
		pMenu.style.maxHeight = tmpCap + 'px';

		// Horizontal alignment to the anchor, then clamp inside the viewport.
		let tmpLeft;
		if (pOptions.align === 'right')
		{
			tmpLeft = pAnchorRect.right - tmpMenuRect.width;
		}
		else if (pOptions.align === 'center')
		{
			tmpLeft = pAnchorRect.left + (pAnchorRect.width - tmpMenuRect.width) / 2;
		}
		else
		{
			tmpLeft = pAnchorRect.left;
		}
		tmpLeft = Math.min(tmpLeft, tmpVw - tmpMenuRect.width - 4);
		tmpLeft = Math.max(4, tmpLeft);

		let tmpTop;
		if (tmpPlaceAbove)
		{
			tmpTop = Math.max(4, pAnchorRect.top - tmpMenuRect.height - tmpGap);
			pMenu.classList.add('pict-modal-dropdown--above');
		}
		else
		{
			tmpTop = pAnchorRect.bottom + tmpGap;
			pMenu.classList.remove('pict-modal-dropdown--above');
		}

		pMenu.style.left = Math.round(tmpLeft) + 'px';
		pMenu.style.top  = Math.round(tmpTop)  + 'px';
	}

	_focusFirstEnabled(pMenu)
	{
		let tmpItems = pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])');
		if (tmpItems.length) { tmpItems[0].focus(); }
	}

	_focusNeighbor(pMenu, pDirection)
	{
		let tmpItems = Array.prototype.slice.call(
			pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])'));
		if (!tmpItems.length) { return; }
		let tmpActive = document.activeElement;
		let tmpIdx = tmpItems.indexOf(tmpActive);
		let tmpNext = (tmpIdx === -1)
			? (pDirection > 0 ? 0 : tmpItems.length - 1)
			: (tmpIdx + pDirection + tmpItems.length) % tmpItems.length;
		tmpItems[tmpNext].focus();
	}

	_escapeHTML(pText)
	{
		if (typeof pText !== 'string') { return ''; }
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalDropdown;

},{}],264:[function(require,module,exports){
/**
 * Pict-Modal-Overlay
 *
 * Manages a shared backdrop overlay element appended to document.body.
 * Reference-counted — created on first modal open, removed when last closes.
 */
class PictModalOverlay
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._element = null;
		this._refCount = 0;
	}

	/**
	 * Show the overlay (incrementing reference count).
	 * Creates the DOM element on first call.
	 *
	 * @param {function} [fOnClick] - Optional click handler (e.g. dismiss topmost modal)
	 */
	show(fOnClick)
	{
		this._refCount++;

		if (!this._element)
		{
			this._element = document.createElement('div');
			this._element.className = 'pict-modal-overlay';
			document.body.appendChild(this._element);

			// Force reflow so the transition animates
			void this._element.offsetHeight;
			this._element.classList.add('pict-modal-visible');
		}

		if (fOnClick)
		{
			// Store the latest click handler (for the topmost modal)
			this._currentClickHandler = fOnClick;
			this._element.onclick = (pEvent) =>
			{
				if (pEvent.target === this._element && this._currentClickHandler)
				{
					this._currentClickHandler();
				}
			};
		}
	}

	/**
	 * Update the overlay click handler (e.g. when topmost modal changes).
	 *
	 * @param {function} [fOnClick] - New click handler
	 */
	updateClickHandler(fOnClick)
	{
		this._currentClickHandler = fOnClick || null;
	}

	/**
	 * Hide the overlay (decrementing reference count).
	 * Removes the DOM element when reference count reaches zero.
	 */
	hide()
	{
		this._refCount--;

		if (this._refCount <= 0)
		{
			this._refCount = 0;
			if (this._element)
			{
				this._element.classList.remove('pict-modal-visible');
				let tmpElement = this._element;
				// Remove after transition
				setTimeout(() =>
				{
					if (tmpElement.parentNode)
					{
						tmpElement.parentNode.removeChild(tmpElement);
					}
				}, 220);
				this._element = null;
				this._currentClickHandler = null;
			}
		}
	}

	/**
	 * Force-remove the overlay regardless of reference count.
	 */
	destroy()
	{
		this._refCount = 0;
		if (this._element && this._element.parentNode)
		{
			this._element.parentNode.removeChild(this._element);
		}
		this._element = null;
		this._currentClickHandler = null;
	}
}

module.exports = PictModalOverlay;

},{}],265:[function(require,module,exports){
/**
 * Pict-Modal-Panel
 *
 * Adds resizable and collapsible panel behavior to any DOM element.
 * Follows the handler composition pattern used by the other modal
 * handlers (confirm, window, toast, tooltip).
 *
 * Usage:
 *   let handle = modal.panel('#my-panel', { position: 'right', width: 340 });
 *   handle.toggle();
 *   handle.destroy();
 */
class PictModalPanel
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._panels = [];
	}

	/**
	 * Attach resizable/collapsible panel behavior to an element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Panel options
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	create(pTargetSelector, pOptions)
	{
		let tmpDefaults = (this._modal && this._modal.options && this._modal.options.DefaultPanelOptions) || {};
		let tmpOptions = Object.assign({},
			{
				position: 'right',
				width: 340,
				minWidth: 200,
				maxWidth: 600,
				collapsible: true,
				collapsed: false,
				persist: false,
				persistKey: '',
				onResize: null,
				onToggle: null
			},
			tmpDefaults,
			pOptions);

		if (typeof document === 'undefined') return this._nullHandle();

		let tmpTarget = document.querySelector(pTargetSelector);
		if (!tmpTarget) return this._nullHandle();

		let tmpId = this._modal._nextId();
		let tmpIsRight = tmpOptions.position === 'right';
		let tmpIsCollapsed = false;
		let tmpCurrentWidth = tmpOptions.width;
		let tmpDestroyed = false;

		// Restore persisted state
		if (tmpOptions.persist && tmpOptions.persistKey)
		{
			try
			{
				let tmpStored = localStorage.getItem('pict-panel-' + tmpOptions.persistKey);
				if (tmpStored)
				{
					let tmpParsed = JSON.parse(tmpStored);
					if (typeof tmpParsed.width === 'number') tmpCurrentWidth = tmpParsed.width;
					if (typeof tmpParsed.collapsed === 'boolean') tmpOptions.collapsed = tmpParsed.collapsed;
				}
			}
			catch (e) { /* ignore */ }
		}

		// Apply classes and initial width
		tmpTarget.classList.add('pict-panel');
		tmpTarget.classList.add(tmpIsRight ? 'pict-panel-right' : 'pict-panel-left');
		tmpTarget.style.width = tmpCurrentWidth + 'px';

		// Remove display:none if present — panel uses width collapse instead
		if (tmpTarget.style.display === 'none')
		{
			tmpTarget.style.display = '';
		}

		// ── Create the edge container ───────────────────────
		let tmpEdge = document.createElement('div');
		tmpEdge.className = 'pict-panel-edge ' + (tmpIsRight ? 'pict-panel-edge-right' : 'pict-panel-edge-left');

		// Resize handle
		let tmpResize = document.createElement('div');
		tmpResize.className = 'pict-panel-resize';
		tmpEdge.appendChild(tmpResize);

		// Collapse tab (chevron SVG)
		let tmpTab = null;
		if (tmpOptions.collapsible)
		{
			tmpTab = document.createElement('div');
			tmpTab.className = 'pict-panel-tab';
			tmpTab.title = 'Toggle panel';
			tmpEdge.appendChild(tmpTab);
		}

		// Insert edge as a sibling so it is not clipped by the
		// panel's own overflow (e.g. overflow-y: auto for scrolling).
		// Right panels: edge goes BEFORE the panel (left side).
		// Left panels: edge goes AFTER the panel (right side).
		if (tmpTarget.parentNode)
		{
			if (tmpIsRight)
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget);
			}
			else
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget.nextSibling);
			}
		}
		else
		{
			tmpTarget.insertBefore(tmpEdge, tmpTarget.firstChild);
		}

		// ── Chevron lookup via pict.providers.Icon ──────────
		// Both directions come from the core registry (`{~I:ChevronLeft~}`
		// / `{~I:ChevronRight~}`).  Resolved per-render so a theme that
		// re-registers the chevron variant picks up automatically.  Empty
		// fallback in the unlikely case pict is missing the Icon provider
		// (very old pict versions; current minimum is 1.0.368).
		let tmpPictHandle = (typeof (window) !== 'undefined' && window.pict) ? window.pict : null;
		let tmpIcon = (pName) => (tmpPictHandle && typeof (tmpPictHandle.icon) === 'function')
			? tmpPictHandle.icon(pName)
			: '';

		let tmpUpdateChevron = () =>
		{
			if (!tmpTab) return;
			let tmpChevronRight = tmpIcon('ChevronRight');
			let tmpChevronLeft  = tmpIcon('ChevronLeft');
			if (tmpIsRight)
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronLeft : tmpChevronRight;
			}
			else
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronRight : tmpChevronLeft;
			}
		};

		// ── Persist helper ──────────────────────────────────
		let tmpPersist = () =>
		{
			if (!tmpOptions.persist || !tmpOptions.persistKey) return;
			try
			{
				localStorage.setItem('pict-panel-' + tmpOptions.persistKey,
					JSON.stringify({ width: tmpCurrentWidth, collapsed: tmpIsCollapsed }));
			}
			catch (e) { /* ignore */ }
		};

		// ── Collapse / expand ───────────────────────────────
		let tmpCollapse = () =>
		{
			if (tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(true);
		};

		let tmpExpand = () =>
		{
			if (!tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = false;
			tmpEdge.classList.remove('pict-panel-edge-collapsed');
			tmpTarget.classList.remove('pict-panel-collapsed');
			tmpTarget.style.width = tmpCurrentWidth + 'px';
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(false);
		};

		let tmpToggle = () =>
		{
			if (tmpIsCollapsed) tmpExpand();
			else tmpCollapse();
		};

		let tmpSetWidth = (pWidth) =>
		{
			if (tmpDestroyed) return;
			let tmpWidth = Math.max(tmpOptions.minWidth, Math.min(tmpOptions.maxWidth, pWidth));
			tmpCurrentWidth = tmpWidth;
			if (!tmpIsCollapsed)
			{
				tmpTarget.style.width = tmpWidth + 'px';
			}
			tmpPersist();
			if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpWidth);
		};

		// ── Tab click ───────────────────────────────────────
		if (tmpTab)
		{
			tmpTab.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpToggle();
			});
		}

		// ── Resize drag ─────────────────────────────────────
		let tmpOnMouseDown = (pEvent) =>
		{
			if (tmpIsCollapsed) return;
			pEvent.preventDefault();

			let tmpStartX = pEvent.clientX;
			let tmpStartWidth = tmpTarget.offsetWidth;

			tmpResize.classList.add('dragging');
			tmpTarget.style.transition = 'none';
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			let tmpOnMouseMove = (pMoveEvent) =>
			{
				let tmpDelta = tmpIsRight
					? (tmpStartX - pMoveEvent.clientX)
					: (pMoveEvent.clientX - tmpStartX);
				let tmpNewWidth = Math.max(tmpOptions.minWidth,
					Math.min(tmpOptions.maxWidth, tmpStartWidth + tmpDelta));
				tmpTarget.style.width = tmpNewWidth + 'px';
			};

			let tmpOnMouseUp = (pUpEvent) =>
			{
				document.removeEventListener('mousemove', tmpOnMouseMove);
				document.removeEventListener('mouseup', tmpOnMouseUp);

				tmpResize.classList.remove('dragging');
				tmpTarget.style.transition = '';
				document.body.style.userSelect = '';
				document.body.style.cursor = '';

				// Capture the final width
				tmpCurrentWidth = tmpTarget.offsetWidth;
				tmpPersist();
				if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpCurrentWidth);
			};

			document.addEventListener('mousemove', tmpOnMouseMove);
			document.addEventListener('mouseup', tmpOnMouseUp);
		};

		tmpResize.addEventListener('mousedown', tmpOnMouseDown);

		// ── Initial state ───────────────────────────────────
		tmpUpdateChevron();

		if (tmpOptions.collapsed)
		{
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
		}

		// ── Destroy ─────────────────────────────────────────
		let tmpDestroy = () =>
		{
			if (tmpDestroyed) return;
			tmpDestroyed = true;

			tmpResize.removeEventListener('mousedown', tmpOnMouseDown);
			if (tmpEdge.parentNode) tmpEdge.remove();
			tmpTarget.classList.remove('pict-panel', 'pict-panel-right', 'pict-panel-left', 'pict-panel-collapsed');
			tmpTarget.style.width = '';
			tmpTarget.style.transition = '';

			let tmpIdx = this._panels.indexOf(tmpHandle);
			if (tmpIdx >= 0) this._panels.splice(tmpIdx, 1);
		};

		// ── Return handle ───────────────────────────────────
		let tmpHandle =
		{
			id: tmpId,
			collapse: tmpCollapse,
			expand: tmpExpand,
			toggle: tmpToggle,
			setWidth: tmpSetWidth,
			destroy: tmpDestroy
		};

		this._panels.push(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Return a no-op handle for server-side or missing-element cases.
	 */
	_nullHandle()
	{
		return {
			id: 0,
			collapse: () => {},
			expand: () => {},
			toggle: () => {},
			setWidth: () => {},
			destroy: () => {}
		};
	}

	/**
	 * Destroy all active panels.
	 */
	destroyAll()
	{
		let tmpPanels = this._panels.slice();
		for (let i = 0; i < tmpPanels.length; i++)
		{
			tmpPanels[i].destroy();
		}
	}
}

module.exports = PictModalPanel;

},{}],266:[function(require,module,exports){
/**
 * Pict-Modal-Shell — viewport-managing layout system for top / right /
 * bottom / left panels around a center.
 *
 * # What this is for
 *
 * Most apps grow a chrome of stacked bars: a topbar, sometimes a
 * sub-nav, sometimes a bottom status bar, often a left sidebar, maybe
 * a right inspector. Each one has its own collapse / resize / persist
 * concerns, and apps end up reinventing the layout glue + the chrome
 * controls per-app.
 *
 * The Shell solves this once. The host calls `modal.shell(viewport)`,
 * adds panels in the order they should stack from each edge, and the
 * Shell manages:
 *
 *   - DOM structure (a flex tree wrapping the viewport)
 *   - Layout placement (multiple panels per side, each in registration order)
 *   - Collapse / expand chrome (a thin tab strip when collapsed)
 *   - Resize chrome (drag handle on the inner edge)
 *   - Pinned (in-flow) vs overlay (absolutely-positioned) panels
 *   - Persistence (per-panel collapsed + size, scoped by host or custom key)
 *   - Center destination (the workspace area between all panels)
 *
 * # Usage
 *
 *   let tmpShell = modal.shell('#App-Container', { PersistenceKey: 'my-app' });
 *
 *   tmpShell.addPanel({
 *       Hash: 'topbar', Side: 'top', Mode: 'fixed', Size: 60,
 *       ContentDestinationId: 'App-TopBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'statusbar', Side: 'bottom', Mode: 'fixed', Size: 28,
 *       ContentDestinationId: 'App-StatusBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'sidebar', Side: 'left', Mode: 'resizable', Size: 280,
 *       MinSize: 180, MaxSize: 480, Title: 'Modules',
 *       ContentDestinationId: 'App-Sidebar'
 *   });
 *
 *   let tmpCenter = tmpShell.center({ ContentDestinationId: 'App-Workspace' });
 *
 *   // Render into the destinations the same way as any other Pict view.
 *   pict.ContentAssignment.assignContent('#App-Sidebar', tmpHTML);
 *
 * # Panel options
 *
 *   Hash:                 unique id within the shell (auto-generated if omitted).
 *                         Used as the localStorage key suffix and for getPanel().
 *   Side:                 'top' | 'right' | 'bottom' | 'left'.
 *   Mode:                 'fixed' (no chrome), 'collapsible' (collapse tab),
 *                         'resizable' (collapse tab + drag handle).
 *   Position:             'pinned' (default; takes layout space) or 'overlay'
 *                         (absolutely positioned over the center / siblings).
 *   Scope:                'shell' (default) | 'center'.
 *                         When 'shell', the panel mounts in one of the
 *                         outer rows / side stacks (Side decides which).
 *                         When 'center', the panel mounts INSIDE the
 *                         center column instead — useful for bars that
 *                         should align with the content area only, not
 *                         span across the sidebars.  Only Side='top' and
 *                         Side='bottom' are supported with Scope='center'.
 *                         The center auto-switches to a flex-column
 *                         layout so the content destination + inner
 *                         panels stack vertically.
 *   Size:                 initial px (height for top/bottom, width for left/right).
 *                         Default: 200 for sides, 60 for top/bottom.
 *   MinSize, MaxSize:     drag clamp for resizable panels.
 *   Collapsed:            initial state. Persisted state overrides this.
 *   CollapsedSize:        px the panel becomes when collapsed (default 24).
 *   Title:                shown in the collapse tab.
 *   Icon:                 optional inline SVG / HTML for the collapse tab.
 *   ContentDestinationId: id given to the inner content div so the host can
 *                         reach it via #ContentDestinationId selectors.
 *   ContentView:          ViewIdentifier (string) of a registered Pict view
 *                         that owns this panel's content. When set, the
 *                         shell auto-renders the view once at panel creation
 *                         (so the destination is filled before the user
 *                         opens the panel) AND again on every expand
 *                         transition (so freshly-streamed state shows up).
 *                         Centralises the "I created a panel — now I have
 *                         to remember to render the view into it" boilerplate.
 *   Persist:              default true; pass false to skip save/load for this
 *                         panel even when the shell has persistence enabled.
 *   Hidden:               default false. When true, the collapsed state has
 *                         NO visible chrome — no collapse tab, no edge
 *                         affordance, the panel root is display: none. The
 *                         only way to reveal it is a programmatic
 *                         expand()/toggle() from elsewhere (e.g. a topbar
 *                         gear). Mode still controls the EXPANDED chrome —
 *                         pass Mode: 'resizable' to keep the drag handle
 *                         while open, then vanish on collapse.
 *   OnExpand, OnCollapse: callbacks that fire ONLY on transitions
 *                         (collapsed→expanded or expanded→collapsed).
 *                         Cleaner than OnToggle which fires for both
 *                         directions and forces callers to inspect the
 *                         bool. OnToggle is kept for back-compat.
 *
 * # Persistence
 *
 *   Storage key:  'pict-modal-shell:' + <PersistenceKey or hostname or 'default'>
 *   Value shape:  { Version: 1, Panels: { <hash>: { Collapsed: bool, Size: number } } }
 */

const STORAGE_PREFIX = 'pict-modal-shell:';
const SCHEMA_VERSION = 1;
const DEFAULT_COLLAPSED_SIZE = 24;
const DEFAULT_SIZE_SIDE = 240;
const DEFAULT_SIZE_TOPBOTTOM = 60;

class PictModalShell
{
	constructor(pModalSection, pViewportEl, pOptions)
	{
		this._modal = pModalSection;
		this._viewport = pViewportEl;
		this._options = pOptions || {};
		this._panels = [];
		this._panelsByHash = {};
		this._centerDestinationEl = null;
		this._idCounter = 0;
		this._activeDrag = null;
		this._persistenceEnabled = (this._options.Persistence !== false);
		this._persistenceKey = this._persistenceEnabled
			? this._resolvePersistenceKey(this._options.PersistenceKey)
			: null;

		// Build the wrapper DOM inside the viewport.
		this._buildSkeleton();
	}

	// ────────────────────────────────────────────────────────────────
	//  Public API
	// ────────────────────────────────────────────────────────────────

	addPanel(pConfig)
	{
		let tmpPanel = new ShellPanel(this, pConfig || {});
		this._panels.push(tmpPanel);
		this._panelsByHash[tmpPanel.Hash] = tmpPanel;
		this._mountPanel(tmpPanel);
		// Render the bound ContentView once now so the destination has
		// content even before the user opens the panel. This is the
		// "create" half of the unified create-and-popup pattern — hosts
		// no longer need to chase down each panel and call view.render()
		// manually after addPanel().
		tmpPanel._renderContentView();
		return tmpPanel;
	}

	getPanel(pHash) { return this._panelsByHash[pHash] || null; }

	getPanels() { return this._panels.slice(); }

	/**
	 * Convenience for cross-view popup triggers. Equivalent to
	 * `shell.getPanel(hash).popup()`. Silently no-ops when the hash
	 * doesn't match a registered panel (so callers don't have to
	 * null-check during boot races).
	 */
	openPanel(pHash)
	{
		let tmpPanel = this._panelsByHash[pHash];
		if (tmpPanel) { tmpPanel.popup(); }
		return tmpPanel || null;
	}

	/**
	 * Configure the center area. Optional; if never called, the center
	 * still exists but has no host-supplied destination id (host can
	 * still reach it via .pict-modal-shell-center).
	 */
	center(pOptions)
	{
		pOptions = pOptions || {};
		if (pOptions.ContentDestinationId)
		{
			// Remove any previously-created destination so center() is
			// idempotent across reconfigurations.  We don't blow away
			// the whole center via innerHTML='' anymore: Scope:'center'
			// panels mounted by earlier addPanel() calls need to stay
			// in place.  Find the right insertion point so the
			// destination sits between any top-scoped panels and any
			// bottom-scoped panels.
			if (this._centerDestinationEl && this._centerDestinationEl.parentNode === this._centerEl)
			{
				this._centerEl.removeChild(this._centerDestinationEl);
			}
			let tmpInner = document.createElement('div');
			tmpInner.id = pOptions.ContentDestinationId;
			tmpInner.className = 'pict-modal-shell-center-content';
			let tmpFirstBottomScoped = null;
			let tmpChildren = this._centerEl.children;
			for (let i = 0; i < tmpChildren.length; i++)
			{
				let tmpCandidate = tmpChildren[i];
				if (tmpCandidate.classList && tmpCandidate.classList.contains('pict-modal-shell-panel-bottom'))
				{
					tmpFirstBottomScoped = tmpCandidate;
					break;
				}
			}
			if (tmpFirstBottomScoped)
			{
				this._centerEl.insertBefore(tmpInner, tmpFirstBottomScoped);
			}
			else
			{
				this._centerEl.appendChild(tmpInner);
			}
			this._centerDestinationEl = tmpInner;
		}
		return this._centerEl;
	}

	getCenterEl() { return this._centerEl; }

	destroy()
	{
		for (let i = 0; i < this._panels.length; i++) { this._panels[i].destroy(true); }
		this._panels = [];
		this._panelsByHash = {};
		if (this._wrapperEl && this._wrapperEl.parentNode)
		{
			this._wrapperEl.parentNode.removeChild(this._wrapperEl);
		}
		this._detachDragHandlers();
	}

	// ────────────────────────────────────────────────────────────────
	//  Persistence
	// ────────────────────────────────────────────────────────────────

	_resolvePersistenceKey(pUserKey)
	{
		if (typeof pUserKey === 'string' && pUserKey.length > 0) return STORAGE_PREFIX + pUserKey;
		try
		{
			if (typeof window !== 'undefined' && window.location && window.location.hostname)
			{
				return STORAGE_PREFIX + window.location.hostname;
			}
		}
		catch (pErr) { /* fall through */ }
		return STORAGE_PREFIX + 'default';
	}

	_loadState()
	{
		if (!this._persistenceKey) return null;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return null;
			let tmpRaw = tmpStore.getItem(this._persistenceKey);
			if (!tmpRaw) return null;
			let tmpParsed = JSON.parse(tmpRaw);
			if (!tmpParsed || tmpParsed.Version !== SCHEMA_VERSION) return null;
			return (tmpParsed.Panels && typeof tmpParsed.Panels === 'object') ? tmpParsed.Panels : {};
		}
		catch (pErr) { return null; }
	}

	_loadPanelState(pHash)
	{
		let tmpAll = this._loadState();
		if (!tmpAll) return null;
		return tmpAll[pHash] || null;
	}

	_savePanelState(pHash, pState)
	{
		if (!this._persistenceKey) return;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return;
			let tmpAll = this._loadState() || {};
			tmpAll[pHash] = pState;
			tmpStore.setItem(this._persistenceKey, JSON.stringify(
			{
				Version: SCHEMA_VERSION,
				Panels: tmpAll,
				SavedAt: new Date().toISOString()
			}));
		}
		catch (pErr) { /* swallow */ }
	}

	// ────────────────────────────────────────────────────────────────
	//  DOM scaffolding
	// ────────────────────────────────────────────────────────────────

	_buildSkeleton()
	{
		// Wipe whatever was inside the viewport — the host opted into
		// the shell taking ownership of layout.
		this._viewport.innerHTML = '';
		this._viewport.classList.add('pict-modal-shell-host');

		this._wrapperEl = document.createElement('div');
		this._wrapperEl.className = 'pict-modal-shell';

		this._topRow = document.createElement('div');
		this._topRow.className = 'pict-modal-shell-row pict-modal-shell-row-top';
		this._wrapperEl.appendChild(this._topRow);

		this._middleRow = document.createElement('div');
		this._middleRow.className = 'pict-modal-shell-row pict-modal-shell-row-middle';
		this._wrapperEl.appendChild(this._middleRow);

		this._leftStack = document.createElement('div');
		this._leftStack.className = 'pict-modal-shell-side pict-modal-shell-side-left';
		this._middleRow.appendChild(this._leftStack);

		this._centerEl = document.createElement('div');
		this._centerEl.className = 'pict-modal-shell-center';
		this._middleRow.appendChild(this._centerEl);

		this._rightStack = document.createElement('div');
		this._rightStack.className = 'pict-modal-shell-side pict-modal-shell-side-right';
		this._middleRow.appendChild(this._rightStack);

		this._bottomRow = document.createElement('div');
		this._bottomRow.className = 'pict-modal-shell-row pict-modal-shell-row-bottom';
		this._wrapperEl.appendChild(this._bottomRow);

		// Overlay layer for overlay-position panels (absolute over middle row)
		this._overlayLayer = document.createElement('div');
		this._overlayLayer.className = 'pict-modal-shell-overlay-layer';
		this._middleRow.appendChild(this._overlayLayer);

		this._viewport.appendChild(this._wrapperEl);
	}

	_mountPanel(pPanel)
	{
		if (pPanel.Position === 'overlay')
		{
			this._overlayLayer.appendChild(pPanel.El);
			return;
		}
		if (pPanel.Scope === 'center')
		{
			// Center-scoped panels mount inside the center column.
			// The column switches to flex-column so the content
			// destination + the panel(s) stack vertically.
			this._centerEl.classList.add('pict-modal-shell-center-with-inner-panel');
			if (pPanel.Side === 'top')
			{
				// Top-scoped panels go above the content destination.
				// If center() hasn't run yet, this still works — we
				// insert before whatever's first (or just append to an
				// empty center, which leaves us above any subsequent
				// content destination).
				this._centerEl.insertBefore(pPanel.El, this._centerEl.firstChild);
			}
			else
			{
				// Side === 'bottom' (the Scope guard already filtered
				// left/right).  Append to the bottom of the center.
				this._centerEl.appendChild(pPanel.El);
			}
			return;
		}
		let tmpHost;
		if      (pPanel.Side === 'top')    tmpHost = this._topRow;
		else if (pPanel.Side === 'bottom') tmpHost = this._bottomRow;
		else if (pPanel.Side === 'left')   tmpHost = this._leftStack;
		else if (pPanel.Side === 'right')  tmpHost = this._rightStack;
		else                               tmpHost = this._wrapperEl;
		tmpHost.appendChild(pPanel.El);
	}

	// ────────────────────────────────────────────────────────────────
	//  Drag (resize) machinery — shared across all resizable panels.
	// ────────────────────────────────────────────────────────────────

	_attachDragStart(pPanel, pEvent)
	{
		pEvent.preventDefault();
		let tmpAxis = (pPanel.Side === 'top' || pPanel.Side === 'bottom') ? 'y' : 'x';
		this._activeDrag =
		{
			Panel:       pPanel,
			Axis:        tmpAxis,
			StartCoord:  (tmpAxis === 'x') ? pEvent.clientX : pEvent.clientY,
			StartSize:   pPanel.Size,
			Direction:   (pPanel.Side === 'left' || pPanel.Side === 'top') ? 1 : -1,
			PendingSize: null,
			RAFId:       0
		};
		document.body.classList.add(tmpAxis === 'x' ? 'pict-modal-shell-dragging-x' : 'pict-modal-shell-dragging-y');
		// Suppress the panel's collapse/expand width/height transition for
		// the duration of the drag — without this, every pointermove kicks
		// off a fresh 140ms transition that stacks up and renders the
		// resize as visibly laggy ("choppy"). With the transition off the
		// panel snaps to each new size in the same frame as the pointer.
		pPanel.El.classList.add('pict-modal-shell-panel-resizing');
		// Capture the pointer so dragging works even when the cursor leaves
		// the resize handle (otherwise the user has to keep the cursor
		// exactly on the 6 px strip — feels twitchy).
		try { pEvent.target.setPointerCapture && pEvent.target.setPointerCapture(pEvent.pointerId); }
		catch (pErr) { /* not supported in old browsers — fine */ }
		document.addEventListener('pointermove', this._onDragMove);
		document.addEventListener('pointerup',   this._onDragEnd);
	}

	// Pointer events fire at the device's input rate (often 240 Hz+ on
	// modern trackpads / mice) but we only paint at the display's refresh
	// rate (60–120 Hz). Coalesce multiple pointermoves per frame into a
	// single setSize() call via requestAnimationFrame — this drops the
	// per-frame work to one DOM mutation regardless of pointer rate.
	_onDragMove = (pEvent) =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		let tmpCoord = (tmpD.Axis === 'x') ? pEvent.clientX : pEvent.clientY;
		let tmpDelta = (tmpCoord - tmpD.StartCoord) * tmpD.Direction;
		tmpD.PendingSize = tmpD.StartSize + tmpDelta;
		if (!tmpD.RAFId)
		{
			let tmpSelf = this;
			tmpD.RAFId = (typeof window !== 'undefined' && window.requestAnimationFrame)
				? window.requestAnimationFrame(function () { tmpSelf._flushDrag(); })
				: setTimeout(function () { tmpSelf._flushDrag(); }, 16);
		}
	};

	_flushDrag()
	{
		let tmpD = this._activeDrag;
		if (!tmpD) return;
		tmpD.RAFId = 0;
		if (tmpD.PendingSize !== null)
		{
			tmpD.Panel.setSize(tmpD.PendingSize);
			tmpD.PendingSize = null;
		}
	}

	_onDragEnd = () =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		// Flush any pending pointermove that hadn't painted yet so the
		// final size matches the actual cursor position, not the last
		// rAF-aligned value.
		if (tmpD.PendingSize !== null) { this._flushDrag(); }
		if (tmpD.RAFId && typeof window !== 'undefined' && window.cancelAnimationFrame)
		{
			window.cancelAnimationFrame(tmpD.RAFId);
		}
		document.body.classList.remove('pict-modal-shell-dragging-x');
		document.body.classList.remove('pict-modal-shell-dragging-y');
		tmpD.Panel.El.classList.remove('pict-modal-shell-panel-resizing');
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
		// Persist final size.
		tmpD.Panel._persist();
		this._activeDrag = null;
	};

	_detachDragHandlers()
	{
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
	}
}

// ════════════════════════════════════════════════════════════════════
//  ShellPanel — one panel within a Shell
// ════════════════════════════════════════════════════════════════════

class ShellPanel
{
	constructor(pShell, pConfig)
	{
		this._shell = pShell;
		this._config = pConfig;

		this.Hash = pConfig.Hash || ('panel-' + ++pShell._idCounter);
		this.Side = (pConfig.Side === 'right' || pConfig.Side === 'bottom' || pConfig.Side === 'left') ? pConfig.Side : 'top';
		this.Mode = (pConfig.Mode === 'collapsible' || pConfig.Mode === 'resizable') ? pConfig.Mode : 'fixed';
		this.Position = (pConfig.Position === 'overlay') ? 'overlay' : 'pinned';
		// Scope: 'center' opts the panel into the center column instead
		// of the shell's outer rows.  Only valid for Side='top'/'bottom'
		// (left/right inside center would need a separate axis we don't
		// support).  Invalid combinations silently fall back to 'shell'.
		this.Scope = (pConfig.Scope === 'center'
				&& (this.Side === 'top' || this.Side === 'bottom'))
			? 'center'
			: 'shell';
		this.Title = pConfig.Title || '';
		this.Icon  = pConfig.Icon  || '';
		this.MinSize = (typeof pConfig.MinSize === 'number') ? pConfig.MinSize : 40;
		this.MaxSize = (typeof pConfig.MaxSize === 'number') ? pConfig.MaxSize : 1200;
		// `Hidden: true` is a panel that has NO visible chrome in its collapsed
		// state — no collapse tab sliver, no resize handle, no edge marker, and
		// (via CSS) display: none on the panel root. The only way to reveal it
		// is a programmatic expand()/toggle() called from elsewhere in the app
		// (e.g. a gear button in the topbar). Useful when the host wants a
		// fully-shaped panel but doesn't want an always-visible affordance for
		// discovering it. The Mode is still honoured for the EXPANDED state —
		// pass Mode: 'resizable' to keep the drag handle while the panel is
		// open, while still vanishing entirely when collapsed.
		this.Hidden = !!pConfig.Hidden;
		this.CollapsedSize = (typeof pConfig.CollapsedSize === 'number')
			? pConfig.CollapsedSize
			: (this.Hidden ? 0 : DEFAULT_COLLAPSED_SIZE);
		this.PersistEnabled = pShell._persistenceEnabled && (pConfig.Persist !== false);

		let tmpDefaultSize = (this.Side === 'left' || this.Side === 'right') ? DEFAULT_SIZE_SIDE : DEFAULT_SIZE_TOPBOTTOM;
		this.Size = (typeof pConfig.Size === 'number') ? pConfig.Size : tmpDefaultSize;
		this.Collapsed = !!pConfig.Collapsed;

		// Persisted state overrides initial Size/Collapsed.
		if (this.PersistEnabled)
		{
			let tmpSaved = pShell._loadPanelState(this.Hash);
			if (tmpSaved)
			{
				if (typeof tmpSaved.Size === 'number') this.Size = tmpSaved.Size;
				if (typeof tmpSaved.Collapsed === 'boolean') this.Collapsed = tmpSaved.Collapsed;
			}
		}
		this._clampSize();

		// Build the panel DOM.
		this._buildEl(pConfig);
		this._applySize();
		this._applyCollapsedClass();

		// Responsive drawer — at narrow viewports, flip a docked side
		// panel into a "top drawer" by adding a class to the middle row
		// that toggles flex-direction from row to column. The panel
		// stretches to full width and trades its inline `width` for a
		// configurable drawer `height`. The user's collapse/expand
		// keeps working: collapsed in drawer mode just gives the panel
		// height: 0 (so only the collapse tab remains visible at the
		// top of the content), expanded restores the drawer height.
		// Pass `0` or omit to disable. Mirrors retold-remote's
		// `.content-editor-body { flex-direction: column }` pattern.
		this.ResponsiveDrawer = (typeof pConfig.ResponsiveDrawer === 'number'
			&& pConfig.ResponsiveDrawer > 0)
				? pConfig.ResponsiveDrawer : 0;
		// Drawer height — applied as `height` to the panel in drawer
		// mode. CSS units (px / vh / %) accepted. Default 33vh which
		// gives the panel roughly a third of the viewport height and
		// leaves comfortable room for the workspace below.
		this.DrawerHeight = (typeof pConfig.DrawerHeight === 'string' && pConfig.DrawerHeight)
			? pConfig.DrawerHeight : '33vh';
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
		if (this.ResponsiveDrawer > 0)
		{
			this._wireResponsiveDrawer();
		}
	}

	// ───────────── public ─────────────

	getContentEl() { return this._contentEl; }

	/**
	 * Returns the currently-bound ContentView Pict view instance, or
	 * null if no ContentView is configured / the view isn't registered
	 * yet.
	 */
	getContentView()
	{
		if (!this._config.ContentView) return null;
		let tmpPict = this._shell._modal && this._shell._modal.pict;
		if (!tmpPict || !tmpPict.views) return null;
		return tmpPict.views[this._config.ContentView] || null;
	}

	collapse() { this._setCollapsed(true);  }
	expand()   { this._setCollapsed(false); }
	toggle()   { this._setCollapsed(!this.Collapsed); }

	/**
	 * Unified "show this panel" affordance — this is the shared
	 * codepath every popup trigger should funnel through. Behavior:
	 *
	 *   - If collapsed → expand (which fires OnExpand + re-renders the
	 *     ContentView via the shared transition machinery).
	 *   - If already open → re-render the ContentView (so any newly-
	 *     streamed state is visible) AND briefly flash the panel
	 *     border so the user notices that the existing panel just
	 *     received attention. Avoids the "I clicked a button but
	 *     nothing happened" feeling when the panel was already open.
	 *
	 * Idempotent — safe to call from any number of triggers without
	 * stacking effects.
	 */
	popup()
	{
		if (this.Collapsed)
		{
			this._setCollapsed(false);
		}
		else
		{
			// Already open — refresh content + flash for attention.
			this._renderContentView();
			this._flash();
		}
	}

	setSize(pSize)
	{
		if (typeof pSize !== 'number' || !isFinite(pSize)) return;
		this.Size = pSize;
		this._clampSize();
		this._applySize();
	}

	destroy(pSkipFromShell)
	{
		this._unwireResponsiveDrawer();
		if (this.El && this.El.parentNode) this.El.parentNode.removeChild(this.El);
		if (!pSkipFromShell)
		{
			let tmpIdx = this._shell._panels.indexOf(this);
			if (tmpIdx >= 0) this._shell._panels.splice(tmpIdx, 1);
			delete this._shell._panelsByHash[this.Hash];
		}
	}

	// ───────────── internals ─────────────

	_clampSize()
	{
		if (this.Size < this.MinSize) this.Size = this.MinSize;
		if (this.Size > this.MaxSize) this.Size = this.MaxSize;
	}

	// Responsive drawer — sets up a matchMedia listener for
	// `(max-width: <ResponsiveDrawer>px)`. Each crossing flips the
	// shell's middle row between row layout (wide) and column layout
	// (narrow) by toggling the `pict-modal-shell-drawer-active` class
	// on the middle row. The matching CSS makes side panels expand to
	// full width with a fixed `DrawerHeight`, becoming top/bottom
	// drawers above/below the workspace center. Collapsed in drawer
	// mode collapses to height: 0, leaving only the collapse tab.
	//
	// This pattern is the conventional "responsive sidebar" approach
	// (used by retold-remote's content editor) — the user keeps their
	// sidebar accessible at narrow widths but it gives the workspace
	// room to breathe.
	_wireResponsiveDrawer()
	{
		if (typeof window === 'undefined' || !window.matchMedia) return;

		this._mediaQuery = window.matchMedia('(max-width: ' + this.ResponsiveDrawer + 'px)');

		// Apply the drawer height as a CSS variable on the panel
		// element so the static CSS rules can read it. Doing this once
		// here avoids per-event JS style writes.
		if (this.El) { this.El.style.setProperty('--pict-modal-drawer-height', this.DrawerHeight); }

		let tmpSelf = this;
		this._mediaQueryHandler = function (pEvent)
		{
			let tmpNarrow = (pEvent && typeof pEvent.matches === 'boolean')
				? pEvent.matches
				: tmpSelf._mediaQuery.matches;
			tmpSelf._setDrawerMode(tmpNarrow);
		};

		// Apply the current state immediately (handles the case where the
		// page loads already-narrow). Newer browsers use addEventListener;
		// older ones use addListener.
		if (this._mediaQuery.addEventListener)
		{
			this._mediaQuery.addEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.addListener)
		{
			this._mediaQuery.addListener(this._mediaQueryHandler);
		}
		this._mediaQueryHandler({ matches: this._mediaQuery.matches });

		// Belt + suspenders: also listen to window resize and re-sync.
		// `matchMedia.change` is supposed to be reliable on every
		// boundary crossing, but in real-world testing (esp. when the
		// user is dragging DevTools to resize the inner viewport, or
		// going through fast successive crossings) we've seen the
		// change event silently miss. A plain resize listener is
		// cheap and the handler is idempotent — if matches state
		// hasn't actually changed the body of `_setDrawerMode` is a
		// no-op (it short-circuits when classes are already correct).
		this._resizeHandler = function ()
		{
			tmpSelf._setDrawerMode(tmpSelf._mediaQuery.matches);
		};
		window.addEventListener('resize', this._resizeHandler);
	}

	_unwireResponsiveDrawer()
	{
		if (this._resizeHandler && typeof window !== 'undefined')
		{
			window.removeEventListener('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
		if (!this._mediaQuery || !this._mediaQueryHandler) return;
		if (this._mediaQuery.removeEventListener)
		{
			this._mediaQuery.removeEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.removeListener)
		{
			this._mediaQuery.removeListener(this._mediaQueryHandler);
		}
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
	}

	// Toggle drawer mode by adding / removing a class on the shell's
	// middle row. The CSS rule for `.pict-modal-shell-drawer-active`
	// flips flex-direction column, makes side panels full-width, and
	// applies the panel's `--pict-modal-drawer-height` for sizing.
	// Also tags the panel itself so per-panel CSS can target it.
	// Re-applies the inline size at the end so the wide-mode crossing
	// gets a clean width back (drawer mode forced width: 100% via CSS
	// !important; the inline style was stale).
	_setDrawerMode(pDrawer)
	{
		if (!this._shell || !this._shell._middleRow) return;
		// Idempotent — short-circuit when the panel's drawer state
		// already matches the target. Keeps the resize-event fallback
		// (which fires constantly during drag-resize) from doing
		// pointless DOM thrash + style re-application every frame.
		let tmpCurrentlyDrawer = !!(this.El
			&& this.El.classList.contains('pict-modal-shell-panel-drawer'));
		if (tmpCurrentlyDrawer === !!pDrawer) return;
		if (pDrawer)
		{
			this._shell._middleRow.classList.add('pict-modal-shell-drawer-active');
			if (this.El) { this.El.classList.add('pict-modal-shell-panel-drawer'); }
		}
		else
		{
			// Only remove the row-level class if NO other panel still
			// wants drawer mode. Multi-panel hosts can safely each opt
			// in independently this way.
			let tmpStillNarrow = false;
			let tmpPanels = this._shell._panels || [];
			for (let i = 0; i < tmpPanels.length; i++)
			{
				let tmpP = tmpPanels[i];
				if (tmpP !== this
					&& tmpP._mediaQuery
					&& tmpP._mediaQuery.matches
					&& tmpP.ResponsiveDrawer > 0)
				{
					tmpStillNarrow = true;
					break;
				}
			}
			if (!tmpStillNarrow)
			{
				this._shell._middleRow.classList.remove('pict-modal-shell-drawer-active');
			}
			if (this.El) { this.El.classList.remove('pict-modal-shell-panel-drawer'); }
		}
		// Re-apply inline size. In drawer mode the CSS !important
		// rule overrides this anyway, but on the wide crossing we
		// need the inline width to be correct so the panel shows up
		// at its proper docked / collapsed-docked size rather than
		// inheriting any stale state.
		this._applySize();
	}

	_buildEl(pConfig)
	{
		let tmpRoot = document.createElement('div');
		tmpRoot.className = 'pict-modal-shell-panel pict-modal-shell-panel-' + this.Side
			+ ' pict-modal-shell-panel-mode-' + this.Mode
			+ (this.Position === 'overlay' ? ' pict-modal-shell-panel-overlay' : '')
			+ (this.Hidden ? ' pict-modal-shell-panel-hidden' : '');
		tmpRoot.setAttribute('data-shell-panel-hash', this.Hash);
		tmpRoot.setAttribute('data-shell-panel-side', this.Side);
		tmpRoot.setAttribute('data-shell-panel-mode', this.Mode);

		// Content area — hosts render their stuff into the inner #id div.
		let tmpContentWrap = document.createElement('div');
		tmpContentWrap.className = 'pict-modal-shell-panel-content';
		this._contentEl = document.createElement('div');
		if (pConfig.ContentDestinationId)
		{
			this._contentEl.id = pConfig.ContentDestinationId;
		}
		this._contentEl.className = 'pict-modal-shell-panel-content-inner';
		tmpContentWrap.appendChild(this._contentEl);
		tmpRoot.appendChild(tmpContentWrap);

		// Collapse tab — shown when collapsible / resizable. Lives at the
		// inner edge so it's always reachable when the panel is collapsed.
		// Hidden panels skip the tab entirely — the only path back from
		// collapsed → expanded is a programmatic expand() / toggle() call
		// from the host (e.g. a topbar gear button).
		if ((this.Mode === 'collapsible' || this.Mode === 'resizable') && !this.Hidden)
		{
			this._collapseTab = document.createElement('button');
			this._collapseTab.type = 'button';
			this._collapseTab.className = 'pict-modal-shell-panel-collapse-tab';
			this._collapseTab.setAttribute('aria-label',
				(this.Title ? 'Toggle ' + this.Title : 'Toggle panel'));
			this._collapseTab.title = this.Title || 'Toggle';
			this._collapseTab.innerHTML = ''
				+ (this.Icon ? '<span class="pict-modal-shell-panel-collapse-tab-icon">' + this.Icon + '</span>' : '')
				+ (this.Title ? '<span class="pict-modal-shell-panel-collapse-tab-title">' + this._escape(this.Title) + '</span>' : '');
			let tmpSelf = this;
			this._collapseTab.addEventListener('click', function () { tmpSelf.toggle(); });
			tmpRoot.appendChild(this._collapseTab);
		}

		// Resize handle — only when resizable. Positioned via CSS based
		// on side.
		if (this.Mode === 'resizable')
		{
			this._resizeHandle = document.createElement('div');
			this._resizeHandle.className = 'pict-modal-shell-panel-resize-handle';
			this._resizeHandle.setAttribute('aria-hidden', 'true');
			let tmpSelf = this;
			this._resizeHandle.addEventListener('pointerdown', function (pEvent)
			{
				if (tmpSelf.Collapsed) return;
				tmpSelf._shell._attachDragStart(tmpSelf, pEvent);
			});
			tmpRoot.appendChild(this._resizeHandle);
		}

		this.El = tmpRoot;
	}

	_applySize()
	{
		let tmpEffective = this.Collapsed ? this.CollapsedSize : this.Size;
		if (this.Side === 'left' || this.Side === 'right')
		{
			this.El.style.width = tmpEffective + 'px';
			this.El.style.height = '';
		}
		else
		{
			this.El.style.height = tmpEffective + 'px';
			this.El.style.width = '';
		}
	}

	_applyCollapsedClass()
	{
		if (this.Collapsed) this.El.classList.add('pict-modal-shell-panel-collapsed');
		else this.El.classList.remove('pict-modal-shell-panel-collapsed');
	}

	_setCollapsed(pBool)
	{
		if (this.Collapsed === !!pBool) return;
		let tmpWasCollapsed = this.Collapsed;
		this.Collapsed = !!pBool;
		this._applyCollapsedClass();
		this._applySize();
		this._persist();

		// Transition-specific hooks fire BEFORE OnToggle so OnExpand
		// callers can mutate state (e.g. set focus, re-fetch data) and
		// have it reflected by any OnToggle observer that runs after.
		if (tmpWasCollapsed && !this.Collapsed)
		{
			// collapsed → expanded. Render the bound ContentView so
			// freshly-streamed state shows up the moment the panel
			// becomes visible (replaces the manual view.render() dance
			// hosts used to do in their own runAction-style helpers).
			this._renderContentView();
			this._fireHook('OnExpand');
		}
		else if (!tmpWasCollapsed && this.Collapsed)
		{
			this._fireHook('OnCollapse');
		}

		// Back-compat: OnToggle still fires for both directions.
		this._fireHook('OnToggle', this.Collapsed);
	}

	_fireHook(pName, pArg)
	{
		let tmpFn = this._config[pName];
		if (typeof tmpFn !== 'function') return;
		try
		{
			if (typeof pArg !== 'undefined') { tmpFn(pArg, this); }
			else                             { tmpFn(this); }
		}
		catch (pErr) { /* host hook failure must not break the panel */ }
	}

	/**
	 * Render the bound ContentView (if any) into this panel's
	 * destination. Called by the shell on panel creation + on every
	 * collapsed→expanded transition + by popup() when re-flashing an
	 * already-open panel. Silently no-ops when no ContentView is
	 * configured or the view isn't registered yet (boot races).
	 */
	_renderContentView()
	{
		let tmpView = this.getContentView();
		if (tmpView && typeof tmpView.render === 'function')
		{
			try { tmpView.render(); }
			catch (pErr) { /* view render failure shouldn't break the panel chrome */ }
		}
	}

	/**
	 * Briefly highlight the panel — used by popup() when called on an
	 * already-open panel so the user sees that their click landed.
	 * The class is removed after the CSS animation completes; safe to
	 * re-trigger (timeouts overlap, last one wins on the trailing edge).
	 */
	_flash()
	{
		if (!this.El) return;
		this.El.classList.add('pict-modal-shell-panel-flash');
		let tmpSelf = this;
		clearTimeout(this._flashTimer);
		this._flashTimer = setTimeout(function ()
		{
			if (tmpSelf.El) tmpSelf.El.classList.remove('pict-modal-shell-panel-flash');
		}, 700);
	}

	_persist()
	{
		if (!this.PersistEnabled) return;
		this._shell._savePanelState(this.Hash,
		{
			Collapsed: this.Collapsed,
			Size: this.Size
		});
	}

	_escape(pStr)
	{
		return String(pStr || '')
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

// ════════════════════════════════════════════════════════════════════
//  Module exports — used internally by Pict-Section-Modal.shell()
// ════════════════════════════════════════════════════════════════════

class PictModalShellManager
{
	constructor(pModalSection)
	{
		this._modal = pModalSection;
		this._shellsByViewport = new WeakMap();
	}

	/**
	 * Idempotent — calling shell() twice with the same viewport returns
	 * the same instance.
	 */
	shell(pViewportSelectorOrEl, pOptions)
	{
		let tmpEl = (typeof pViewportSelectorOrEl === 'string')
			? document.querySelector(pViewportSelectorOrEl)
			: pViewportSelectorOrEl;
		if (!tmpEl)
		{
			throw new Error('Pict-Modal-Shell.shell: viewport not found for ' + pViewportSelectorOrEl);
		}
		let tmpExisting = this._shellsByViewport.get(tmpEl);
		if (tmpExisting) return tmpExisting;
		let tmpShell = new PictModalShell(this._modal, tmpEl, pOptions);
		this._shellsByViewport.set(tmpEl, tmpShell);
		return tmpShell;
	}
}

module.exports = PictModalShellManager;
module.exports.PictModalShell = PictModalShell;
module.exports.ShellPanel = ShellPanel;
module.exports.STORAGE_PREFIX = STORAGE_PREFIX;
module.exports.SCHEMA_VERSION = SCHEMA_VERSION;

},{}],267:[function(require,module,exports){
/**
 * Pict-Modal-Toast
 *
 * Manages toast notification elements with auto-dismiss and stacking.
 */
class PictModalToast
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._containers = {};
	}

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message text
	 * @param {object} [pOptions] - Options (type, duration, position, dismissible, allowHTML)
	 * @param {boolean} [pOptions.allowHTML=false] - When true, render pMessage as raw HTML instead of escaping it. Only pass trusted markup.
	 * @returns {{ dismiss: function }} Handle with dismiss method
	 */
	toast(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultToastOptions, pOptions);
		let tmpContainer = this._getContainer(tmpOptions.position);
		let tmpId = this._modal._nextId();

		let tmpToast = document.createElement('div');
		tmpToast.className = 'pict-modal-toast pict-modal-toast--' + tmpOptions.type;
		tmpToast.id = 'pict-modal-toast-' + tmpId;

		// Escape by default; render raw markup only when the caller opts in with allowHTML (trusted content).
		let tmpMessageMarkup = (tmpOptions.allowHTML === true) ? pMessage : this._escapeHTML(pMessage);
		let tmpContent = '<span class="pict-modal-toast-message">' + tmpMessageMarkup + '</span>';

		if (tmpOptions.dismissible)
		{
			tmpContent += '<button class="pict-modal-toast-dismiss" aria-label="Dismiss">&times;</button>';
		}

		tmpToast.innerHTML = tmpContent;

		// Create handle
		let tmpDismissed = false;
		let tmpTimeoutHandle = null;

		let tmpDismiss = () =>
		{
			if (tmpDismissed)
			{
				return;
			}
			tmpDismissed = true;

			if (tmpTimeoutHandle)
			{
				clearTimeout(tmpTimeoutHandle);
			}

			// Exit animation
			tmpToast.classList.remove('pict-modal-visible');
			tmpToast.classList.add('pict-modal-toast-exit');

			// Remove from active list
			this._modal._activeToasts = this._modal._activeToasts.filter(
				(pEntry) => { return pEntry.element !== tmpToast; }
			);

			// Remove from DOM after transition
			setTimeout(() =>
			{
				if (tmpToast.parentNode)
				{
					tmpToast.parentNode.removeChild(tmpToast);
				}
				this._cleanupContainer(tmpOptions.position);
			}, 220);
		};

		let tmpHandle = { dismiss: tmpDismiss };

		// Wire dismiss button
		if (tmpOptions.dismissible)
		{
			let tmpDismissBtn = tmpToast.querySelector('.pict-modal-toast-dismiss');
			if (tmpDismissBtn)
			{
				tmpDismissBtn.addEventListener('click', tmpDismiss);
			}
		}

		// Append to container
		tmpContainer.appendChild(tmpToast);

		// Track
		let tmpEntry =
		{
			element: tmpToast,
			dismiss: tmpDismiss,
			handle: tmpHandle
		};
		this._modal._activeToasts.push(tmpEntry);

		// Animate in
		void tmpToast.offsetHeight;
		tmpToast.classList.add('pict-modal-visible');

		// Auto-dismiss
		if (tmpOptions.duration > 0)
		{
			tmpTimeoutHandle = setTimeout(tmpDismiss, tmpOptions.duration);
		}

		return tmpHandle;
	}

	/**
	 * Get or create a toast container for the given position.
	 *
	 * @param {string} pPosition - Position key (e.g. 'top-right')
	 * @returns {HTMLElement}
	 */
	_getContainer(pPosition)
	{
		if (this._containers[pPosition])
		{
			return this._containers[pPosition];
		}

		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-modal-toast-container pict-modal-toast-container--' + pPosition;
		document.body.appendChild(tmpContainer);
		this._containers[pPosition] = tmpContainer;

		return tmpContainer;
	}

	/**
	 * Remove a container if it has no more toasts.
	 *
	 * @param {string} pPosition
	 */
	_cleanupContainer(pPosition)
	{
		let tmpContainer = this._containers[pPosition];
		if (tmpContainer && tmpContainer.children.length === 0)
		{
			if (tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
			delete this._containers[pPosition];
		}
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissAll()
	{
		let tmpToasts = this._modal._activeToasts.slice();
		for (let i = 0; i < tmpToasts.length; i++)
		{
			tmpToasts[i].dismiss();
		}
	}

	/**
	 * Destroy all containers.
	 */
	destroy()
	{
		this.dismissAll();
		let tmpPositions = Object.keys(this._containers);
		for (let i = 0; i < tmpPositions.length; i++)
		{
			let tmpContainer = this._containers[tmpPositions[i]];
			if (tmpContainer && tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
		}
		this._containers = {};
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalToast;

},{}],268:[function(require,module,exports){
/**
 * Pict-Modal-Tooltip
 *
 * Manages simple text and rich HTML tooltips with positioning and auto-flip.
 */
class PictModalTooltip
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options (position, delay, maxWidth)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	tooltip(pElement, pText, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pText, false, tmpOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Attach a pinnable rich HTML tooltip to an element.
	 *
	 * Behaves like richTooltip() on hover/focus, but a click on the element
	 * toggles a pinned state: while pinned the tooltip stays open (it does not
	 * hide on mouseleave/focusout) and follows its anchor on scroll/resize.
	 * This is opt-in sugar over richTooltip() with `{ pinnable: true }` — the
	 * default tooltip()/richTooltip() behavior is unchanged.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive, startPinned, onPinChange)
	 * @returns {{ destroy: function, pin: function, unpin: function, isPinned: function }} Handle
	 */
	pinnableTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions, { pinnable: true });
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Internal: attach tooltip event listeners to an element.
	 *
	 * @param {HTMLElement} pElement
	 * @param {string} pContent
	 * @param {boolean} pIsHTML
	 * @param {object} pOptions
	 * @returns {{ destroy: function }}
	 */
	_attachTooltip(pElement, pContent, pIsHTML, pOptions)
	{
		let tmpTooltipElement = null;
		let tmpShowTimeout = null;
		let tmpHideTimeout = null;
		let tmpDestroyed = false;
		let tmpId = this._modal._nextId();

		// Pin state — only meaningful when pOptions.pinnable is set. A pinned
		// tooltip stays visible (transient hide is suppressed) and follows its
		// anchor on scroll/resize.
		let tmpPinned = false;

		let tmpShow = () =>
		{
			if (tmpDestroyed || tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement = document.createElement('div');
			tmpTooltipElement.className = 'pict-modal-tooltip pict-modal-tooltip--' + pOptions.position;
			tmpTooltipElement.id = 'pict-modal-tooltip-' + tmpId;
			tmpTooltipElement.setAttribute('role', 'tooltip');
			tmpTooltipElement.style.maxWidth = pOptions.maxWidth;

			if (pOptions.interactive)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-interactive');
			}

			// Optional consumer-supplied class(es) on the tooltip element, e.g.
			// to theme the bubble + arrow by overriding the --pict-modal-tooltip-*
			// custom properties for a specific tooltip.
			if (pOptions.className)
			{
				let tmpExtraClasses = String(pOptions.className).split(/\s+/);
				for (let i = 0; i < tmpExtraClasses.length; i++)
				{
					if (tmpExtraClasses[i])
					{
						tmpTooltipElement.classList.add(tmpExtraClasses[i]);
					}
				}
			}

			// Arrow
			let tmpArrow = document.createElement('div');
			tmpArrow.className = 'pict-modal-tooltip-arrow';

			// Content
			let tmpContentDiv = document.createElement('div');
			if (pIsHTML)
			{
				tmpContentDiv.innerHTML = pContent;
			}
			else
			{
				tmpContentDiv.textContent = pContent;
			}

			tmpTooltipElement.appendChild(tmpArrow);
			tmpTooltipElement.appendChild(tmpContentDiv);
			document.body.appendChild(tmpTooltipElement);

			// Set aria-describedby on target
			pElement.setAttribute('aria-describedby', tmpTooltipElement.id);

			// Position
			this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);

			// Animate in — but only paint when the anchor is actually rendered.
			// A pinned / startPinned tooltip whose anchor lives in a hidden
			// container (e.g. an inactive tab panel) would otherwise show at the
			// clamped corner as an orphan. It is revealed later by tmpReposition
			// once the anchor gains a layout box (see the ResizeObserver below).
			void tmpTooltipElement.offsetHeight;
			if (this._isElementRendered(pElement))
			{
				tmpTooltipElement.classList.add('pict-modal-visible');
			}

			// Track
			this._modal._activeTooltips.push(
			{
				element: tmpTooltipElement,
				targetElement: pElement,
				destroy: tmpDestroy
			});

			// For interactive tooltips, allow hovering over the tooltip itself
			if (pOptions.interactive && tmpTooltipElement)
			{
				tmpTooltipElement.addEventListener('mouseenter', () =>
				{
					if (tmpHideTimeout)
					{
						clearTimeout(tmpHideTimeout);
						tmpHideTimeout = null;
					}
				});
				tmpTooltipElement.addEventListener('mouseleave', () =>
				{
					if (!tmpPinned)
					{
						tmpHide();
					}
				});
			}

			// Reflect pinned state on a freshly-(re)created element.
			if (tmpPinned && tmpTooltipElement)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-pinned');
			}
		};

		let tmpHide = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement.classList.remove('pict-modal-visible');
			let tmpEl = tmpTooltipElement;
			tmpTooltipElement = null;

			// Remove aria
			pElement.removeAttribute('aria-describedby');

			// Remove from tracking
			this._modal._activeTooltips = this._modal._activeTooltips.filter(
				(pEntry) => { return pEntry.element !== tmpEl; }
			);

			setTimeout(() =>
			{
				if (tmpEl.parentNode)
				{
					tmpEl.parentNode.removeChild(tmpEl);
				}
			}, 220);
		};

		let tmpOnMouseEnter = () =>
		{
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
				tmpHideTimeout = null;
			}
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnMouseLeave = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// A pinned tooltip stays open regardless of pointer.
			if (tmpPinned)
			{
				return;
			}
			// Small delay before hiding to allow moving to interactive tooltip
			if (pOptions.interactive)
			{
				tmpHideTimeout = setTimeout(tmpHide, 100);
			}
			else
			{
				tmpHide();
			}
		};

		let tmpOnFocusIn = () =>
		{
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnFocusOut = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// A pinned tooltip stays open regardless of focus.
			if (tmpPinned)
			{
				return;
			}
			tmpHide();
		};

		// -- Pin lifecycle (opt-in via pOptions.pinnable) --

		// Keep a pinned tooltip glued to its anchor as the page scrolls/resizes.
		// The element is position:fixed and portaled to <body>, so it does not
		// move with the document on its own. When the anchor scrolls out of the
		// viewport we fade the tooltip out (without dropping the pin) and bring
		// it back when the anchor returns.
		let tmpResizeObserver = null;
		let tmpReposition = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}
			let tmpRect = pElement.getBoundingClientRect();
			// Rendered (has a layout box) AND within the viewport. A hidden anchor
			// (display:none, or inside a hidden tab panel) has no box, so the
			// tooltip is hidden rather than stranded at the clamped corner.
			let tmpInView = this._isElementRendered(pElement)
				&& (tmpRect.bottom > 0) && (tmpRect.top < window.innerHeight)
				&& (tmpRect.right > 0) && (tmpRect.left < window.innerWidth);
			if (tmpInView)
			{
				this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);
				tmpTooltipElement.classList.add('pict-modal-visible');
			}
			else
			{
				tmpTooltipElement.classList.remove('pict-modal-visible');
			}
		};

		let tmpAddRepositionListeners = () =>
		{
			// `true` (capture) so scrolls inside any nested container reposition too.
			window.addEventListener('scroll', tmpReposition, true);
			window.addEventListener('resize', tmpReposition);
			// A ResizeObserver on the anchor catches it being shown/hidden (e.g. a
			// tab panel toggling display) — transitions the window scroll/resize
			// listeners miss — so a pinned tooltip appears the moment its anchor
			// gains a layout box and hides again when it loses one.
			if (typeof ResizeObserver !== 'undefined')
			{
				tmpResizeObserver = new ResizeObserver(() => tmpReposition());
				tmpResizeObserver.observe(pElement);
			}
		};

		let tmpRemoveRepositionListeners = () =>
		{
			window.removeEventListener('scroll', tmpReposition, true);
			window.removeEventListener('resize', tmpReposition);
			if (tmpResizeObserver)
			{
				tmpResizeObserver.disconnect();
				tmpResizeObserver = null;
			}
		};

		let tmpPin = () =>
		{
			if (tmpPinned || tmpDestroyed)
			{
				return;
			}
			tmpPinned = true;
			if (!tmpTooltipElement)
			{
				tmpShow();
			}
			if (tmpTooltipElement)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-pinned');
			}
			tmpAddRepositionListeners();
			if (typeof pOptions.onPinChange === 'function')
			{
				pOptions.onPinChange(true, pElement);
			}
		};

		let tmpUnpin = () =>
		{
			if (!tmpPinned)
			{
				return;
			}
			tmpPinned = false;
			tmpRemoveRepositionListeners();
			if (tmpTooltipElement)
			{
				tmpTooltipElement.classList.remove('pict-modal-tooltip-pinned');
			}
			tmpHide();
			if (typeof pOptions.onPinChange === 'function')
			{
				pOptions.onPinChange(false, pElement);
			}
		};

		let tmpOnClick = (pEvent) =>
		{
			if (pEvent)
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
			}
			if (tmpPinned)
			{
				tmpUnpin();
			}
			else
			{
				tmpPin();
			}
		};

		// Attach listeners
		pElement.addEventListener('mouseenter', tmpOnMouseEnter);
		pElement.addEventListener('mouseleave', tmpOnMouseLeave);
		pElement.addEventListener('focusin', tmpOnFocusIn);
		pElement.addEventListener('focusout', tmpOnFocusOut);
		if (pOptions.pinnable)
		{
			pElement.addEventListener('click', tmpOnClick);
		}

		let tmpDestroy = () =>
		{
			if (tmpDestroyed)
			{
				return;
			}
			tmpDestroyed = true;

			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
			}
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
			}

			tmpRemoveRepositionListeners();
			tmpPinned = false;
			tmpHide();

			pElement.removeEventListener('mouseenter', tmpOnMouseEnter);
			pElement.removeEventListener('mouseleave', tmpOnMouseLeave);
			pElement.removeEventListener('focusin', tmpOnFocusIn);
			pElement.removeEventListener('focusout', tmpOnFocusOut);
			if (pOptions.pinnable)
			{
				pElement.removeEventListener('click', tmpOnClick);
			}
		};

		// Optionally render already-pinned (explicit consumer opt-in).
		if (pOptions.pinnable && pOptions.startPinned)
		{
			tmpPin();
		}

		return {
			destroy: tmpDestroy,
			pin: tmpPin,
			unpin: tmpUnpin,
			isPinned: () => { return tmpPinned; }
		};
	}

	/**
	 * Position a tooltip element relative to the target element.
	 * Flips direction if the tooltip would overflow the viewport.
	 *
	 * @param {HTMLElement} pTooltip
	 * @param {HTMLElement} pTarget
	 * @param {string} pPosition - 'top', 'bottom', 'left', 'right'
	 */
	_positionTooltip(pTooltip, pTarget, pPosition)
	{
		let tmpTargetRect = pTarget.getBoundingClientRect();
		let tmpTooltipRect = pTooltip.getBoundingClientRect();
		let tmpGap = 8;

		let tmpPosition = pPosition;

		// Flip if needed
		if (tmpPosition === 'top' && tmpTargetRect.top < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'bottom';
		}
		else if (tmpPosition === 'bottom' && (window.innerHeight - tmpTargetRect.bottom) < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'top';
		}
		else if (tmpPosition === 'left' && tmpTargetRect.left < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'right';
		}
		else if (tmpPosition === 'right' && (window.innerWidth - tmpTargetRect.right) < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'left';
		}

		// Update class for arrow direction
		pTooltip.className = pTooltip.className.replace(/pict-modal-tooltip--\w+/, 'pict-modal-tooltip--' + tmpPosition);

		let tmpTop = 0;
		let tmpLeft = 0;

		switch (tmpPosition)
		{
			case 'top':
				tmpTop = tmpTargetRect.top - tmpTooltipRect.height - tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'bottom':
				tmpTop = tmpTargetRect.bottom + tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'left':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.left - tmpTooltipRect.width - tmpGap;
				break;
			case 'right':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.right + tmpGap;
				break;
		}

		// Clamp to viewport
		tmpLeft = Math.max(4, Math.min(tmpLeft, window.innerWidth - tmpTooltipRect.width - 4));
		tmpTop = Math.max(4, Math.min(tmpTop, window.innerHeight - tmpTooltipRect.height - 4));

		pTooltip.style.top = tmpTop + 'px';
		pTooltip.style.left = tmpLeft + 'px';
	}

	/**
	 * Whether an element is currently rendered (has a layout box). Returns false
	 * for a display:none element or one inside a display:none ancestor (e.g. an
	 * inactive tab panel) — in which case a pinned tooltip should stay hidden
	 * until the anchor reappears.
	 *
	 * @param {HTMLElement} pElement
	 * @returns {boolean}
	 */
	_isElementRendered(pElement)
	{
		return !!(pElement && typeof pElement.getClientRects === 'function' && pElement.getClientRects().length > 0);
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissAll()
	{
		let tmpTooltips = this._modal._activeTooltips.slice();
		for (let i = 0; i < tmpTooltips.length; i++)
		{
			tmpTooltips[i].destroy();
		}
	}
}

module.exports = PictModalTooltip;

},{}],269:[function(require,module,exports){
/**
 * Pict-Modal-Window
 *
 * Builds custom floating modal windows with arbitrary content and buttons.
 */
class PictModalWindow
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options
	 * @param {string} [pOptions.title] - Dialog title
	 * @param {string} [pOptions.content] - HTML content for the body
	 * @param {Array} [pOptions.buttons] - Array of { Hash, Label, Style }
	 * @param {boolean} [pOptions.closeable] - Whether the close button and overlay dismiss are enabled
	 * @param {string} [pOptions.width] - CSS width value
	 * @param {boolean} [pOptions.unbounded] - If true, removes the default 90vh/90vw viewport cap. The dialog will grow with its content and may extend beyond the viewport.
	 * @param {function} [pOptions.onOpen] - Called after dialog is shown, receives dialog element
	 * @param {function} [pOptions.onClose] - Called after dialog is dismissed
	 * @returns {Promise<string|null>} Resolves with clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultModalOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions, fResolve);
			this._showDialog(tmpDialog, tmpOptions, fResolve);
		});
	}

	/**
	 * Build the modal dialog element.
	 *
	 * @param {object} pOptions
	 * @param {function} fResolve
	 * @returns {HTMLElement}
	 */
	_buildDialog(pOptions, fResolve)
	{
		let tmpId = this._modal._nextId();

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = pOptions.width;

		// Header
		let tmpHeaderHTML = '';
		if (pOptions.title || pOptions.closeable)
		{
			tmpHeaderHTML = '<div class="pict-modal-dialog-header">';
			tmpHeaderHTML += '<span class="pict-modal-dialog-title">' + this._escapeHTML(pOptions.title) + '</span>';
			if (pOptions.closeable)
			{
				tmpHeaderHTML += '<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>';
			}
			tmpHeaderHTML += '</div>';
		}

		// Body
		let tmpBodyHTML = '<div class="pict-modal-dialog-body">' + (pOptions.content || '') + '</div>';

		// Footer with buttons
		let tmpFooterHTML = '';
		if (pOptions.buttons && pOptions.buttons.length > 0)
		{
			tmpFooterHTML = '<div class="pict-modal-dialog-footer">';
			for (let i = 0; i < pOptions.buttons.length; i++)
			{
				let tmpButton = pOptions.buttons[i];
				let tmpBtnClass = 'pict-modal-btn';
				if (tmpButton.Style)
				{
					tmpBtnClass += ' pict-modal-btn--' + tmpButton.Style;
				}
				tmpFooterHTML += '<button class="' + tmpBtnClass + '" data-hash="' + this._escapeHTML(tmpButton.Hash) + '">' +
					this._escapeHTML(tmpButton.Label) + '</button>';
			}
			tmpFooterHTML += '</div>';
		}

		tmpDialog.innerHTML = tmpHeaderHTML + tmpBodyHTML + tmpFooterHTML;

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve, pOptions);
		};

		// Wire close button
		if (pOptions.closeable)
		{
			let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
			if (tmpCloseBtn)
			{
				tmpCloseBtn.addEventListener('click', () => { tmpDismiss(null); });
			}
		}

		// Wire action buttons
		let tmpActionButtons = tmpDialog.querySelectorAll('[data-hash]');
		for (let i = 0; i < tmpActionButtons.length; i++)
		{
			let tmpBtn = tmpActionButtons[i];
			tmpBtn.addEventListener('click', () =>
			{
				tmpDismiss(tmpBtn.getAttribute('data-hash'));
			});
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show the dialog: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {object} pOptions
	 * @param {function} fResolve
	 */
	_showDialog(pDialog, pOptions, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'window'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses && pOptions.closeable)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(null); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus first button or close button
		let tmpFocusTarget = pDialog.querySelector('.pict-modal-btn') || pDialog.querySelector('.pict-modal-dialog-close');
		if (tmpFocusTarget)
		{
			tmpFocusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape' && pOptions.closeable)
			{
				pDialog._dismiss(null);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);

		// onOpen callback
		if (typeof pOptions.onOpen === 'function')
		{
			pOptions.onOpen(pDialog);
		}
	}

	/**
	 * Dismiss the dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult
	 * @param {function} fResolve
	 * @param {object} pOptions
	 */
	_dismissDialog(pDialog, pResult, fResolve, pOptions)
	{
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		pDialog.classList.remove('pict-modal-visible');

		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		this._modal._overlay.hide();

		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		if (typeof pOptions.onClose === 'function')
		{
			pOptions.onClose(pResult);
		}

		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalWindow;

},{}],270:[function(require,module,exports){
module.exports = (
{
	"AutoInitialize": true,
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ViewIdentifier": "Pict-Section-Modal",

	"OverlayClickDismisses": true,

	"DefaultConfirmOptions":
	{
		"title": "Confirm",
		"confirmLabel": "OK",
		"cancelLabel": "Cancel",
		"dangerous": false,
		"unbounded": false
	},

	"DefaultDoubleConfirmOptions":
	{
		"title": "Are you sure?",
		"confirmLabel": "Confirm",
		"cancelLabel": "Cancel",
		"phrasePrompt": "Type \"{phrase}\" to confirm:",
		"confirmPhrase": "",
		"unbounded": false
	},

	"DefaultModalOptions":
	{
		"title": "",
		"content": "",
		"buttons": [],
		"closeable": true,
		"width": "480px",
		"unbounded": false
	},

	"DefaultTooltipOptions":
	{
		"position": "top",
		"delay": 200,
		"maxWidth": "300px",
		"interactive": false,
		"pinnable": false,
		"startPinned": false
	},

	"DefaultToastOptions":
	{
		"type": "info",
		"duration": 3000,
		"position": "top-right",
		"dismissible": true,
		"allowHTML": false
	},

	"DefaultPanelOptions":
	{
		"position": "right",
		"width": 340,
		"minWidth": 200,
		"maxWidth": 600,
		"collapsible": true,
		"collapsed": false,
		"persist": false,
		"persistKey": ""
	},

	"Templates": [],
	"Renderables": [],

	"CSS": /*css*/`
/* pict-section-modal */
.pict-modal-root
{
	/* Defaults are routed through pict-provider-theme tokens so apps
	   using the theme provider get themed modals automatically.  Each
	   var() carries its original hex as the fallback so apps that don't
	   install pict-provider-theme look exactly as before.  Apps may
	   still override any --pict-modal-* var directly to layer over the
	   theme-driven defaults. */

	/* Overlay */
	--pict-modal-overlay-bg: rgba(0, 0, 0, 0.5);

	/* Dialog */
	--pict-modal-bg:                  var(--theme-color-background-panel,  #ffffff);
	--pict-modal-fg:                  var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-border:              var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-border-radius:       8px;
	--pict-modal-shadow:              0 4px 24px rgba(0, 0, 0, 0.15);
	--pict-modal-header-bg:           var(--theme-color-background-secondary, #f5f5f5);
	--pict-modal-header-fg:           var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-header-border:       var(--theme-color-border-default,    #e0e0e0);

	/* Buttons */
	--pict-modal-btn-bg:              var(--theme-color-background-secondary, #e0e0e0);
	--pict-modal-btn-fg:              var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-btn-hover-bg:        var(--theme-color-background-hover,  #d0d0d0);
	--pict-modal-btn-primary-bg:      var(--theme-color-brand-primary,     #2563eb);
	--pict-modal-btn-primary-fg:      var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-primary-hover-bg:var(--theme-color-brand-primary-hover,#1d4ed8);
	--pict-modal-btn-danger-bg:       var(--theme-color-status-error,      #dc2626);
	--pict-modal-btn-danger-fg:       var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-danger-hover-bg: var(--theme-color-status-error,      #b91c1c);
	--pict-modal-btn-border-radius:   4px;

	/* Toast */
	--pict-modal-toast-bg:            var(--theme-color-background-panel,  #333333);
	--pict-modal-toast-fg:            var(--theme-color-text-primary,      #ffffff);
	--pict-modal-toast-success-bg:    var(--theme-color-status-success,    #16a34a);
	--pict-modal-toast-warning-bg:    var(--theme-color-status-warning,    #d97706);
	--pict-modal-toast-error-bg:      var(--theme-color-status-error,      #dc2626);
	--pict-modal-toast-info-bg:       var(--theme-color-status-info,       #2563eb);
	--pict-modal-toast-border-radius: 6px;
	--pict-modal-toast-shadow:        0 2px 12px rgba(0, 0, 0, 0.15);

	/* Tooltip */
	--pict-modal-tooltip-bg:          var(--theme-color-background-tertiary,#1a1a1a);
	--pict-modal-tooltip-fg:          var(--theme-color-text-primary,      #ffffff);
	--pict-modal-tooltip-border-radius:4px;
	--pict-modal-tooltip-shadow:      0 2px 8px rgba(0, 0, 0, 0.15);
	--pict-modal-tooltip-pinned-ring: var(--theme-color-brand-primary, #2E7D74);

	/* Dropdown */
	--pict-modal-dropdown-bg:                 var(--theme-color-background-panel,  #ffffff);
	--pict-modal-dropdown-fg:                 var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-border:             var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-dropdown-border-radius:      6px;
	--pict-modal-dropdown-shadow:             0 6px 18px rgba(0, 0, 0, 0.18);
	--pict-modal-dropdown-item-hover-bg:      var(--theme-color-background-hover,  rgba(37, 99, 235, 0.10));
	--pict-modal-dropdown-item-hover-fg:      var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-item-disabled-fg:   var(--theme-color-text-muted,        #9aa0a6);
	--pict-modal-dropdown-separator:          var(--theme-color-border-light,      #e8e8e8);
	--pict-modal-dropdown-header-fg:          var(--theme-color-text-secondary,    #6b7280);
	--pict-modal-dropdown-danger-fg:          var(--theme-color-status-error,      #dc2626);
	--pict-modal-dropdown-primary-fg:         var(--theme-color-brand-primary,     #2563eb);

	/* Typography */
	--pict-modal-font-family:         var(--theme-typography-family-sans,  system-ui, -apple-system, sans-serif);
	--pict-modal-font-size:           14px;
	--pict-modal-title-font-size:     16px;

	/* Animation */
	--pict-modal-transition-duration: 200ms;
}

/* Overlay */
.pict-modal-overlay
{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: var(--pict-modal-overlay-bg);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
}

.pict-modal-overlay.pict-modal-visible
{
	opacity: 1;
}

/* Dialog */
.pict-modal-dialog
{
	position: fixed;
	z-index: 1010;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) translateY(-20px);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;

	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;

	background: var(--pict-modal-bg);
	color: var(--pict-modal-fg);
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-border-radius);
	box-shadow: var(--pict-modal-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
}

.pict-modal-dialog.pict-modal-visible
{
	opacity: 1;
	transform: translate(-50%, -50%) translateY(0);
}

/* Unbounded modifier — lets callers opt out of the 90vh/90vw viewport cap.
   Use with caution: content taller than the viewport will push buttons
   below the fold. */
.pict-modal-dialog.pict-modal-dialog--unbounded
{
	max-height: none;
	max-width: none;
}

.pict-modal-dialog-header
{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	background: var(--pict-modal-header-bg);
	color: var(--pict-modal-header-fg);
	border-bottom: 1px solid var(--pict-modal-header-border);
	border-radius: var(--pict-modal-border-radius) var(--pict-modal-border-radius) 0 0;
}

.pict-modal-dialog-title
{
	font-size: var(--pict-modal-title-font-size);
	font-weight: 600;
}

.pict-modal-dialog-close
{
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: var(--pict-modal-fg);
	padding: 0 4px;
	line-height: 1;
	opacity: 0.6;
}

.pict-modal-dialog-close:hover
{
	opacity: 1;
}

.pict-modal-dialog-body
{
	padding: 16px;
	overflow-y: auto;
	flex: 1;
}

.pict-modal-dialog-footer
{
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid var(--pict-modal-border);
}

/* Buttons */
.pict-modal-btn
{
	padding: 8px 16px;
	border: none;
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	cursor: pointer;
	background: var(--pict-modal-btn-bg);
	color: var(--pict-modal-btn-fg);
	transition: background var(--pict-modal-transition-duration) ease;
}

.pict-modal-btn:hover
{
	background: var(--pict-modal-btn-hover-bg);
}

.pict-modal-btn:disabled
{
	opacity: 0.5;
	cursor: not-allowed;
}

.pict-modal-btn--primary
{
	background: var(--pict-modal-btn-primary-bg);
	color: var(--pict-modal-btn-primary-fg);
}

.pict-modal-btn--primary:hover
{
	background: var(--pict-modal-btn-primary-hover-bg);
}

.pict-modal-btn--danger
{
	background: var(--pict-modal-btn-danger-bg);
	color: var(--pict-modal-btn-danger-fg);
}

.pict-modal-btn--danger:hover
{
	background: var(--pict-modal-btn-danger-hover-bg);
}

/* Double confirm input */
.pict-modal-confirm-input
{
	width: 100%;
	padding: 8px 12px;
	margin-top: 12px;
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	box-sizing: border-box;
}

.pict-modal-confirm-input:focus
{
	outline: 2px solid var(--pict-modal-btn-primary-bg);
	outline-offset: -1px;
}

.pict-modal-confirm-prompt
{
	margin-top: 12px;
	font-size: 13px;
	color: var(--pict-modal-fg);
	opacity: 0.7;
}

/* Toast container */
.pict-modal-toast-container
{
	position: fixed;
	z-index: 1030;
	display: flex;
	flex-direction: column;
	gap: 8px;
	pointer-events: none;
	max-width: 400px;
}

.pict-modal-toast-container--top-right
{
	top: 16px;
	right: 16px;
}

.pict-modal-toast-container--top-left
{
	top: 16px;
	left: 16px;
}

.pict-modal-toast-container--bottom-right
{
	bottom: 16px;
	right: 16px;
}

.pict-modal-toast-container--bottom-left
{
	bottom: 16px;
	left: 16px;
}

.pict-modal-toast-container--top-center
{
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
}

.pict-modal-toast-container--bottom-center
{
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
}

/* Toast */
.pict-modal-toast
{
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	border-radius: var(--pict-modal-toast-border-radius);
	box-shadow: var(--pict-modal-toast-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	background: var(--pict-modal-toast-bg);
	color: var(--pict-modal-toast-fg);
	pointer-events: auto;
	opacity: 0;
	transform: translateX(100%);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-toast.pict-modal-visible
{
	opacity: 1;
	transform: translateX(0);
}

.pict-modal-toast.pict-modal-toast-exit
{
	opacity: 0;
	transform: translateX(100%);
}

.pict-modal-toast--info
{
	background: var(--pict-modal-toast-info-bg);
}

.pict-modal-toast--success
{
	background: var(--pict-modal-toast-success-bg);
}

.pict-modal-toast--warning
{
	background: var(--pict-modal-toast-warning-bg);
}

.pict-modal-toast--error
{
	background: var(--pict-modal-toast-error-bg);
}

.pict-modal-toast-message
{
	flex: 1;
}

.pict-modal-toast-dismiss
{
	background: none;
	border: none;
	color: inherit;
	font-size: 18px;
	cursor: pointer;
	padding: 0 2px;
	line-height: 1;
	opacity: 0.7;
}

.pict-modal-toast-dismiss:hover
{
	opacity: 1;
}

/* Tooltip */
.pict-modal-tooltip
{
	position: fixed;
	z-index: 1020;
	padding: 6px 10px;
	border-radius: var(--pict-modal-tooltip-border-radius);
	box-shadow: var(--pict-modal-tooltip-shadow);
	background: var(--pict-modal-tooltip-bg);
	color: var(--pict-modal-tooltip-fg);
	font-family: var(--pict-modal-font-family);
	font-size: 13px;
	pointer-events: none;
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
	white-space: normal;
	word-wrap: break-word;
}

.pict-modal-tooltip.pict-modal-tooltip-interactive
{
	pointer-events: auto;
}

.pict-modal-tooltip.pict-modal-visible
{
	opacity: 1;
}

/* Pinned tooltips stay open and can be interacted with; a subtle ring
   distinguishes a pinned tooltip from a transient hover tooltip. */
.pict-modal-tooltip.pict-modal-tooltip-pinned
{
	pointer-events: auto;
	box-shadow: var(--pict-modal-tooltip-shadow), 0 0 0 1px var(--pict-modal-tooltip-pinned-ring);
}

.pict-modal-tooltip-arrow
{
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--pict-modal-tooltip-bg);
	transform: rotate(45deg);
}

.pict-modal-tooltip--top .pict-modal-tooltip-arrow
{
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--bottom .pict-modal-tooltip-arrow
{
	top: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--left .pict-modal-tooltip-arrow
{
	right: -4px;
	top: 50%;
	margin-top: -4px;
}

.pict-modal-tooltip--right .pict-modal-tooltip-arrow
{
	left: -4px;
	top: 50%;
	margin-top: -4px;
}

/* ── Dropdown ─────────────────────────────────────────────────────────
   Anchor-positioned menu (no overlay). Used for nav menus and
   "split button" addenda — see Pict-Modal-Dropdown.js.
*/
.pict-modal-dropdown
{
	position: fixed;
	z-index: 1025;
	min-width: 160px;
	max-width: 360px;
	max-height: 60vh;
	overflow-y: auto;
	background: var(--pict-modal-dropdown-bg);
	color: var(--pict-modal-dropdown-fg);
	border: 1px solid var(--pict-modal-dropdown-border);
	border-radius: var(--pict-modal-dropdown-border-radius);
	box-shadow: var(--pict-modal-dropdown-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	padding: 4px 0;
	opacity: 0;
	transform: translateY(-4px);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

/* Free-form content popovers keep the dropdown chrome (bg / border / shadow /
   flip / dismiss) but hand sizing + inner padding to the injected content, so a
   pre-rendered template menu or a wide rich card isn't boxed by the menu
   defaults. Cap width per-call via the maxWidth option. */
.pict-modal-dropdown.pict-modal-dropdown--content
{
	max-width: none;
	padding: 0;
}

.pict-modal-dropdown.pict-modal-dropdown--above { transform: translateY(4px); }

.pict-modal-dropdown.pict-modal-visible
{
	opacity: 1;
	transform: translateY(0);
}

.pict-modal-dropdown-item
{
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 14px;
	cursor: pointer;
	user-select: none;
	color: inherit;
	outline: none;
}

.pict-modal-dropdown-item:hover,
.pict-modal-dropdown-item:focus
{
	background: var(--pict-modal-dropdown-item-hover-bg);
	color: var(--pict-modal-dropdown-item-hover-fg);
}

.pict-modal-dropdown-item--disabled
{
	cursor: not-allowed;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--disabled:hover,
.pict-modal-dropdown-item--disabled:focus
{
	background: transparent;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--primary { color: var(--pict-modal-dropdown-primary-fg); }
.pict-modal-dropdown-item--danger  { color: var(--pict-modal-dropdown-danger-fg); }

.pict-modal-dropdown-item-icon
{
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
}

.pict-modal-dropdown-item-icon svg { width: 100%; height: 100%; display: block; }

.pict-modal-dropdown-item-label { flex: 1 1 auto; min-width: 0; }

.pict-modal-dropdown-item-hint
{
	flex: 0 0 auto;
	font-size: 11px;
	opacity: 0.6;
	margin-left: 12px;
}

.pict-modal-dropdown-separator
{
	height: 1px;
	background: var(--pict-modal-dropdown-separator);
	margin: 4px 0;
}

.pict-modal-dropdown-header
{
	padding: 6px 14px 2px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: var(--pict-modal-dropdown-header-fg);
}

/* ── Resizable / Collapsible Panels ──────────────── */
.pict-panel
{
	position: relative;
	transition: width 0.2s ease;
	flex-shrink: 0;
	overflow: visible;
}
.pict-panel-collapsed
{
	width: 0 !important;
	min-width: 0 !important;
	overflow: visible;
}
.pict-panel-collapsed > *:not(.pict-panel-edge)
{
	display: none;
}

/* Edge container — zero-width flex sibling of the panel.
   Sits next to the panel in the flex layout; children
   use absolute positioning to overlap the panel boundary. */
.pict-panel-edge
{
	position: relative;
	width: 0;
	flex-shrink: 0;
	z-index: 50;
	overflow: visible;
}

/* Resize handle — thin strip on the panel boundary */
.pict-panel-resize
{
	position: absolute;
	top: 0;
	bottom: 0;
	width: 4px;
	cursor: col-resize;
	background: transparent;
	transition: background 0.15s, width 0.15s;
}
.pict-panel-edge-right .pict-panel-resize
{
	right: 0;
	border-right: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-edge-left .pict-panel-resize
{
	left: 0;
	border-left: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-resize:hover,
.pict-panel-edge:hover .pict-panel-resize
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 0.5;
}
.pict-panel-resize.dragging
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 1;
	transition: none;
}
.pict-panel-edge-collapsed .pict-panel-resize
{
	display: none;
}

/* Collapse tab — tucked sliver at rest, slides out on hover */
.pict-panel-tab
{
	position: absolute;
	top: 8px;
	width: 8px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: var(--pict-panel-border, #DDD6CA);
	border: 1px solid var(--pict-panel-border, #DDD6CA);
	cursor: pointer;
	color: var(--pict-panel-fg, #8A7F72);
	font-size: 10px;
	line-height: 1;
	opacity: 0.5;
	transition: opacity 0.25s, width 0.2s ease, height 0.2s ease, left 0.2s ease, right 0.2s ease, background 0.2s;
	z-index: 51;
}
.pict-panel-edge:hover .pict-panel-tab,
.pict-panel-tab:hover
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}
/* Right panel: tab to the left of the edge */
.pict-panel-edge-right .pict-panel-tab
{
	right: 0;
	border-right: none;
	border-radius: 4px 0 0 4px;
}
.pict-panel-edge-right:hover .pict-panel-tab,
.pict-panel-edge-right .pict-panel-tab:hover
{
	right: 0;
}
/* Left panel: tab to the right of the edge */
.pict-panel-edge-left .pict-panel-tab
{
	left: 0;
	border-left: none;
	border-radius: 0 4px 4px 0;
}
.pict-panel-edge-left:hover .pict-panel-tab,
.pict-panel-edge-left .pict-panel-tab:hover
{
	left: 0;
}
/* When collapsed — more visible */
.pict-panel-edge-collapsed .pict-panel-tab
{
	width: 10px;
	height: 28px;
	opacity: 0.6;
}
.pict-panel-edge-collapsed .pict-panel-tab:hover,
.pict-panel-edge-collapsed:hover .pict-panel-tab
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}

/* ───────────────────────────────────────────────────────────────────
 *  Pict-Modal-Shell — viewport-managing layout for top / right /
 *  bottom / left panels around a center.
 * ───────────────────────────────────────────────────────────────── */

.pict-modal-shell-host { display: block; height: 100%; min-height: 0; }
.pict-modal-shell
{
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
	position: relative;
	color: var(--pict-modal-fg, var(--theme-color-text-primary, #1a1a1a));
	background: var(--theme-color-background-primary, transparent);
}
.pict-modal-shell-row { display: flex; min-width: 0; min-height: 0; }
/* "First added = at the edge" convention is held by reversing the
   flex-direction on the bottom row + right side. That way, for ALL
   four sides, calling addPanel() N times stacks panel #1 against
   the viewport edge, panel #2 just inside it, panel #3 further in,
   and so on. Without these reverses, top + left worked that way but
   bottom + right inverted (first-added at content side, last-added
   at edge), which surprised callers. */
.pict-modal-shell-row-top    { flex: 0 0 auto; flex-direction: column; }
.pict-modal-shell-row-bottom { flex: 0 0 auto; flex-direction: column-reverse; }
.pict-modal-shell-row-middle
{
	flex: 1 1 0;
	flex-direction: row;
	min-height: 0;
	position: relative;
}
.pict-modal-shell-side
{
	display: flex;
	flex: 0 0 auto;
	min-height: 0;
}
.pict-modal-shell-side-left  { flex-direction: row; }
.pict-modal-shell-side-right { flex-direction: row-reverse; }
.pict-modal-shell-center
{
	flex: 1 1 0;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
}
.pict-modal-shell-center-content
{
	min-height: 100%;
}
/* Center column gains this class when at least one Scope:'center'
   panel is added.  The center stops scrolling internally — that job
   moves to the content destination — and switches to a vertical flex
   so the destination and any inner panels stack cleanly. */
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel
{
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-center-content
{
	flex: 1 1 0;
	min-height: 0;
	overflow: auto;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-panel
{
	flex: 0 0 auto;
	width: 100%;
}

/* Panels — base */
.pict-modal-shell-panel
{
	/* How far the collapse-tab's panel-bg "merge bar" extends INTO
	   the panel past the tab's geometric edge. Painted via box-shadow
	   on the tab (no DOM impact), it masks any 1px theme border on an
	   inner element, content padding offset, or resize-handle hover
	   bleed in the strip between the tab's panel-facing edge and the
	   first real pixel of panel content. Consumers can bump this for
	   themes with thicker (2+px) inner borders. */
	--pict-modal-collapse-tab-merge: 2px;
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: inherit;
	min-width: 0;
	min-height: 0;
	transition: width 140ms ease, height 140ms ease;
}
.pict-modal-shell-panel-content
{
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	overflow: auto;
}
/* Fixed-mode panels are pure chrome (topbars, status rows). Their
   content should fit the configured Size exactly — never scroll. The
   1px border that .pict-modal-shell-panel-mode-fixed adds on the
   inner edge shaves 1px off the content's available height, which
   then triggers a sliver-scrollbar on any inner widget with
   min-height matching the panel Size. overflow:hidden here suppresses
   that without affecting resizable/collapsible panels (sidebars,
   drawers) where scrollable content is the whole point. */
.pict-modal-shell-panel-mode-fixed > .pict-modal-shell-panel-content
{
	overflow: hidden;
}
.pict-modal-shell-panel-content-inner
{
	min-height: 100%;
}
/* Panel boundary — fixed-mode panels get a hairline border for explicit
   demarcation. Collapsible / resizable panels DROP the boundary border
   (background contrast separates them from the center anyway) so the
   collapse tab can pull out cleanly without a hairline cutting across
   it. The host stylesheet still gets full control via the panel's own
   background. */
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-top    { border-bottom: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-bottom { border-top:    1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-left   { border-right:  1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-right  { border-left:   1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }

/* Resize handle — absolute on the inner edge of each panel. */
.pict-modal-shell-panel-resize-handle
{
	position: absolute;
	background: transparent;
	z-index: 5;
	transition: background-color 120ms ease;
}
/* Resize handle hover — use the active brand's mode-aware primary
   color (set by pict-section-theme's Brand provider as
   --brand-color-primary-mode) so the resize affordance picks up the
   app's wordmark color. Falls back to the theme's brand-primary
   token if no brand is registered. */
.pict-modal-shell-panel-resize-handle:hover
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.4;
}
.pict-modal-shell-panel-left   .pict-modal-shell-panel-resize-handle { right: -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-right  .pict-modal-shell-panel-resize-handle { left:  -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-top    .pict-modal-shell-panel-resize-handle { bottom:-3px; left: 0; right: 0; height: 6px; cursor: row-resize; }
.pict-modal-shell-panel-bottom .pict-modal-shell-panel-resize-handle { top:   -3px; left: 0; right: 0; height: 6px; cursor: row-resize; }

/* Collapse tab — slim sliver flush on the panel's OUTER boundary
   (where the resize handle sits), modelled on retold-content-system's
   sidebar tab. At rest it's a 6×28 px sliver; hover expands to
   18×36 px without overlapping the panel's own content. The tab is
   positioned with its center on the boundary so half pokes into the
   adjacent area — the only place we can safely take over without
   stepping on app UI inside the panel. Title text only renders in the
   collapsed state where there's room for it. */
.pict-modal-shell-panel-collapse-tab
{
	position: absolute;
	display: flex;            /* not inline-flex — avoids baseline alignment quirks */
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #d0d7de));
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: var(--theme-color-text-muted, #6b7280);
	font: inherit;
	font-size: 10px;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	cursor: pointer;
	z-index: 50;
	opacity: 0.55;
	padding: 0;
	box-sizing: border-box;
	line-height: 0;          /* keep child boxes from inflating around the rotated chevron */
	/* Geometry (width/height/right/left) is intentionally NOT animated.
	   Sliding the tab's outer edge inward on hover-out makes it look like
	   the tab is "sliding into" the panel content — weird visual.
	   Snapping the size change instead, and animating only the appearance
	   (opacity/color/shadow), gives a clean fade-in/out with no boundary
	   weirdness. */
	transition: opacity 160ms ease,
	            background-color 160ms ease, color 160ms ease,
	            border-color 160ms ease, box-shadow 160ms ease;
}
/* Hover state pulls accent color from the active brand (mode-aware,
   so it's legible in both light + dark) with theme brand-primary as
   fallback. The whole point of brand colors is that they show up
   across the app's chrome. */
.pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab
{
	opacity: 1;
	color:        var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Drop shadow casts AWAY from the panel so the tab feels pulled out
   (extension of the panel) rather than floating across the boundary.
   The tab itself is now positioned fully OUTSIDE the panel boundary
   (see the per-side rules below), so we don't need a merge-bar shadow
   to mask any in-panel overlap — only the drop shadow remains. */
.pict-modal-shell-panel-left:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left    > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-right:hover   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right   > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: -3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-top:hover     > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top     > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-bottom:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom  > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.18);
}

/* Per-side base positioning — the tab lives entirely OUTSIDE the
   panel's outer boundary.  Its panel-facing edge touches the boundary
   (offset = -tabThickness) and the rest of the tab pokes out into the
   adjacent area (center / sibling panel).  Border on the panel-facing
   edge is dropped so the tab looks attached to the panel rather than
   floating beside it.
   Why fully-outside?  Earlier iterations had the tab straddling the
   boundary (1px inside + 4px outside) with a panel-bg-colored merge-bar
   masking the in-panel half — that worked geometrically but visually
   read as "tab pinned into the panel," and any rendering inside the
   panel (especially custom borders or hover bleeds) could clip against
   the in-panel half.  Fully-external positioning eliminates the overlap
   class of bugs and lets the tab live entirely in the adjacent area
   where there's no app content to step on. */
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab
{
	right: -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 0 4px 4px 0;
	border-left: 0;
}
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab
{
	left:  -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 4px 0 0 4px;
	border-right: 0;
}
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab
{
	bottom: -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 0 0 4px 4px;
	border-top: 0;
}
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab
{
	top:    -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 4px 4px 0 0;
	border-bottom: 0;
}

/* Hover: tab grows OUTWARD into the adjacent area.  The panel-facing
   edge stays glued to the boundary (offset = -tabThickness), so the
   tab still looks attached on hover — only its outer dimension grows.
   For side panels the height also grows (28 → 36) downward; for top
   /bottom panels the width grows (28 → 36) — see the next block for
   the perpendicular-axis offsets. */
.pict-modal-shell-panel-left:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; right: -18px;
}
.pict-modal-shell-panel-right:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; left: -18px;
}
.pict-modal-shell-panel-top:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; bottom: -18px;
}
.pict-modal-shell-panel-bottom:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; top: -18px;
}

.pict-modal-shell-panel-collapse-tab-title { display: none; white-space: nowrap; }

/* Auto-generated chevron glyph inside the tab — only visible once the
   tab is wide / tall enough to show it (i.e. hover state, or when the
   panel is collapsed). Direction follows side + state.
   Sized 5×5 (down from 6) so even with rotation the visual stays
   well clear of the tab's overflow:hidden bounds at 18×36 hover and
   the 24px collapsed tab strip width. flex-shrink:0 ensures the
   pseudo never collapses to zero in tight tab dimensions. */
.pict-modal-shell-panel-collapse-tab::before
{
	content: '';
	display: block;
	width: 5px; height: 5px;
	flex-shrink: 0;
	opacity: 0;
	border-right: 1.5px solid currentColor;
	border-bottom: 1.5px solid currentColor;
	transform: rotate(135deg);
	transform-origin: center center;
	transition: opacity 160ms ease, transform 160ms ease;
}
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab::before,
.pict-modal-shell-panel-collapse-tab:hover::before,
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	opacity: 1;
}
.pict-modal-shell-panel-right                                       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-top                                         > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }
.pict-modal-shell-panel-bottom                                      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(135deg); }
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed        > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed     > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }

/* Collapsed state — content disappears, only the collapse tab remains. */
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-content
{
	display: none;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed
{
	/* When collapsed, side panels rotate the title for vertical reading. */
	overflow: hidden;
}
/* When collapsed: the entire panel becomes the tab strip — full width
   for sides, full height for top/bottom — with the title visible
   vertically (sides) or horizontally (top/bottom). The little sliver
   tab on the boundary disappears (we don't need it anymore — clicking
   anywhere on the panel toggles it back open). */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed
{
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	/* Promote the tab to FILL the collapsed panel (not just hug its
	   content) so the centered chevron + title group sits in the middle
	   of the panel. Without explicit width/height: 100%, the position:
	   absolute element shrinks to its natural content size and the
	   group ends up flush at the top of the panel — where the chevron
	   gets clipped by the topbar. */
	position: absolute !important;
	top: 0 !important; right: 0 !important; bottom: 0 !important; left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	border: 0;
	border-radius: 0;
	background: transparent;
	opacity: 0.85;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 4px;        /* keeps chevron + title clear of edges */
	box-shadow: none;
	color: var(--theme-color-text-muted, #6b7280);
	box-sizing: border-box;
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	background: var(--theme-color-background-hover, var(--pict-modal-bg, #fff));
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: none;
}
/* Side panels (collapsed): rotate the title for vertical reading. */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed  > .pict-modal-shell-panel-collapse-tab
{
	writing-mode: vertical-rl;
	text-orientation: mixed;
}
.pict-modal-shell-panel-collapsed .pict-modal-shell-panel-collapse-tab-title
{
	display: inline;
}

/* Hidden panels — when Hidden:true is passed to addPanel, the collapsed
   state has zero footprint: no collapse tab (the tab is never built),
   the panel root is display:none, and the resize handle vanishes. The
   only path to the open state is a programmatic expand()/toggle() from
   somewhere else in the app (e.g. a topbar gear button). When expanded,
   the panel renders normally — so resize/drag handles continue to work
   while the panel is open. */
.pict-modal-shell-panel-hidden.pict-modal-shell-panel-collapsed
{
	display: none !important;
}

/* Overlay panels — float over the middle row instead of taking layout
   space. The overlay layer is positioned absolutely inside the middle
   row; individual overlay panels stack with positive z-index. */
.pict-modal-shell-overlay-layer
{
	position: absolute;
	inset: 0;
	pointer-events: none;
	z-index: 10;
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel
{
	pointer-events: auto;
	position: absolute;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-left   { left:   0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-right  { right:  0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-top    { top:    0; left: 0; right: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-bottom { bottom: 0; left: 0; right: 0; }

/* ─────────────────────────────────────────────────────────────────
   Responsive drawer mode — .pict-modal-shell-drawer-active toggles
   onto the middle row when any panel with ResponsiveDrawer crosses
   below its breakpoint. Flips the row's flex-direction from row to
   column, stacking side panels above the center and stretching them
   to full width. Each opted-in panel itself gets the
   .pict-modal-shell-panel-drawer class so per-panel rules below
   target only the drawer-mode panels (right + non-drawer panels in
   the same row are unaffected). The drawer height is read from a
   per-panel --pict-modal-drawer-height CSS variable (default
   33vh, set in JS from the DrawerHeight option).
   ───────────────────────────────────────────────────────────────── */
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active
{
	flex-direction: column;
	/* The drawer tab lives outside the drawer's bottom edge — ancestor
	   chain MUST allow it to escape clip. */
	overflow: visible;
}
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active .pict-modal-shell-side
{
	/* Side stacks stretch full-width and lay out their panels as a
	   horizontal row of stacked drawers (so two drawers from the same
	   side don't end up overlapping). overflow: visible so the
	   per-panel tab can extend below the side stack into the workspace. */
	width: 100% !important;
	flex-direction: column;
	overflow: visible;
}
/* The drawer-tagged panel itself: kill the inline width set by
   _applySize (we override with !important since the inline style has
   higher specificity than a class selector), then size by height
   from the CSS variable. Resize handle is hidden in drawer mode
   because horizontal dragging doesn't translate to vertical sizing
   and the user already has the collapse tab to dismiss / restore.

   padding-bottom reserves an 18px strip at the bottom of the panel
   for the tab. The tab sits INSIDE the drawer's footprint — never
   below it — so the workspace header below the drawer is never in
   the same vertical band as the tab. (Previously the tab hung
   below the drawer's bottom edge into the workspace's top padding;
   that made the tab visually compete with the workspace header,
   even when the tab box-model bounds technically cleared the
   header.) box-sizing: border-box so the padding eats from the
   33vh, not adding to it. */
.pict-modal-shell-panel-drawer
{
	width: 100% !important;
	max-width: 100% !important;
	height: var(--pict-modal-drawer-height, 33vh);
	transition: height 140ms ease;
	padding-bottom: 18px;
	box-sizing: border-box;
	overflow: visible !important;
	/* Clip the panel bg to its CONTENT area only — the 18px
	   padding-bottom reserve (where the tab lives) becomes
	   transparent, so the middle row's primary background shows
	   through. Without this the reserve would render with the
	   panel's chrome bg, creating a visible "strip" between the
	   drawer content above and the workspace below — the tab would
	   look like it's sitting on its own miscoloured band rather
	   than at the seam between drawer and workspace. */
	background-clip: content-box;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed
{
	/* Collapsed = "just the tab strip is visible". 18px matches the
	   panel's tab reserve so the height is consistent across states.
	   When this is 0 the tab would have nowhere to render and the
	   user couldn't reopen the drawer. */
	height: 18px !important;
	padding-bottom: 0 !important;
	/* Drop the panel's bg in collapsed state — without this the 18px
	   strip shows the --pict-modal-bg (panel chrome) which doesn't
	   match the workspace --theme-color-background-primary below it,
	   creating a visible "drawer band" around the tab that breaks the
	   illusion of the tab belonging to the workspace area. With
	   transparent bg the middle row's primary background shows
	   through, the strip blends with the workspace, and the tab pill
	   reads as a free-floating handle. */
	background: transparent !important;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
/* The drawer's collapse tab is a horizontal pill protruding from the
   bottom of the drawer (rather than the inner edge of a side panel).
   Override the side-panel positioning rules from above so the tab
   always sits at the drawer's bottom-center seam, in both expanded
   and collapsed states. The expand-from-zero affordance: when
   collapsed (height: 0), the tab still hangs below "where the
   drawer would be" — a small handle the user can click to pull
   the drawer back down. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	position: absolute !important;
	/* Anchored to the panel's BOTTOM edge — the tab lives INSIDE the
	   drawer's footprint (in the 18px reserve at the bottom), never
	   below it into the workspace. This means the workspace below
	   the drawer is never sharing a vertical band with the tab, so
	   the workspace header doesn't optically compete with it.
	   bottom: 4px aligns the tab's top edge exactly with the panel's
	   CONTENT-AREA bottom (panel.height − padding-bottom 18px). With
	   border-top: 0 on the tab, the seam between the drawer content
	   above and the tab body is invisible — they share --pict-modal-bg
	   and merge into one shape, the tab reading as a labelled
	   extension of the drawer hanging downward. Collapsed state
	   keeps the smaller offset (overridden below) because its panel
	   has no padding-bottom, so the math doesn't apply. */
	top: auto !important;
	bottom: 4px !important;
	left: 50% !important;
	right: auto !important;
	transform: translate(-50%, 0) !important;
	width: 64px !important;
	height: 14px !important;
	/* CRITICAL: border-box + padding: 0 — the collapsed-state base
	   rule inherits "padding: 12px 4px" (so the chevron clears the
	   edges of a tab that fills a 24px-wide side strip). In drawer
	   mode the tab is a 14px tall pill, NOT a strip-fill, so that
	   12px vertical padding would balloon the tab's outer height to
	   ~38px and crash into the workspace header text. The chevron
	   is centered via flex anyway. */
	box-sizing: border-box !important;
	padding: 0 !important;
	/* Rounded BOTTOM corners + no top border — the tab looks like a
	   traditional drawer-handle/tab hanging from above. Its rounded
	   bottom curves face the workspace (the "open downward" affordance
	   for a top drawer). border-top: 0 lets the tab visually merge
	   with whatever's directly above it inside the panel (sidebar
	   content when expanded, the panel background when collapsed). */
	border-radius: 0 0 8px 8px;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #cfd5dd));
	border-top: 0;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #fff));
	opacity: 0.95;
	z-index: 20;
	/* The default side-panel hover-grow values would yank the tab off
	   to the wrong spot in drawer mode — neutralise. */
	display: flex;
	align-items: center;
	justify-content: center;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	opacity: 1;
	width: 96px !important;
	/* height stays at 14px — the tab is anchored with bottom, so any
	   height growth would push the tab's TOP edge UPWARD past the
	   space available above it. In EXPANDED state that crashes into
	   the drawer content above; in COLLAPSED state it crashes into
	   the topbar's brand stripes. Width-only growth (64 to 96, +50%)
	   still gives the "tab is reaching toward me" affordance without
	   the encroachment. */
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
/* Collapsed-state bottom-offset override. Expanded panels have an
   18px padding-bottom reserve, and "bottom: 4px" anchors the tab's
   top edge exactly at the content-area boundary (so it merges
   visually with the drawer above). Collapsed panels have
   padding-bottom: 0 and a total height of 18px — "bottom: 4px"
   there would put the tab's top at the panel's actual top edge,
   crashing the (border-top: 0) tab into the topbar. The smaller
   "bottom: 2px" keeps the 14px tab vertically centered in the 18px
   strip with 2px margins on either side. */
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	bottom: 2px !important;
}
/* Chevron inside the tab: point UP when expanded (the drawer
   collapses UP / out of view, so the arrow indicates "click me to
   send the drawer up"), DOWN when collapsed (the drawer expands DOWN
   into view). Rotations come from the existing top-panel chevron
   table: rotate(-135deg) → UP arrow, rotate(45deg) → DOWN arrow. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(-135deg) !important;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(45deg) !important;
}
/* The collapse tab's existing title-text span is hidden when reduced
   to a pill — there's no horizontal room. The chevron alone reads
   correctly. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-title,
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-icon
{
	display: none;
}

/* Drag-active state — disable text selection + change cursor globally
   so resize feels solid even when the cursor briefly leaves the handle. */
.pict-modal-shell-dragging-x, .pict-modal-shell-dragging-y { user-select: none; }
.pict-modal-shell-dragging-x * { cursor: col-resize !important; }
.pict-modal-shell-dragging-y * { cursor: row-resize !important; }

/* Per-panel resize-active state — kills the panel's collapse/expand
   width/height transition for the duration of a drag. Without this,
   every pointermove starts a fresh 140 ms transition and the resize
   visibly lags behind the cursor ("choppy"). With it disabled the
   panel snaps to the new size on the same frame as the pointer, which
   feels native. */
.pict-modal-shell-panel-resizing { transition: none !important; }
.pict-modal-shell-panel-resizing > .pict-modal-shell-panel-resize-handle
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.5;
}

/* Panel popup-attention flash — fires when popup() is called on an
   already-open panel. Brief brand-colored inset glow so the user sees
   that their click landed even though the panel didn't change shape.
   Class is added by the shell, auto-removed after ~700 ms. */
@keyframes pict-modal-shell-panel-flash
{
	0%   { box-shadow: inset 0 0 0 0 transparent; }
	30%  { box-shadow: inset 0 0 0 3px var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)); }
	100% { box-shadow: inset 0 0 0 0 transparent; }
}
.pict-modal-shell-panel-flash
{
	animation: pict-modal-shell-panel-flash 600ms ease-out;
}
`
});

},{}],271:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictModalOverlay = require('./Pict-Modal-Overlay.js');
const libPictModalConfirm = require('./Pict-Modal-Confirm.js');
const libPictModalWindow = require('./Pict-Modal-Window.js');
const libPictModalToast = require('./Pict-Modal-Toast.js');
const libPictModalTooltip = require('./Pict-Modal-Tooltip.js');
const libPictModalPanel = require('./Pict-Modal-Panel.js');
const libPictModalDropdown = require('./Pict-Modal-Dropdown.js');
const libPictModalShell = require('./Pict-Modal-Shell.js');

const _DefaultConfiguration = require('./Pict-Section-Modal-DefaultConfiguration.js');

class PictSectionModal extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this._activeModals = [];
		this._activeTooltips = [];
		this._activeToasts = [];
		this._idCounter = 0;

		this._overlay = new libPictModalOverlay(this);
		this._confirm = new libPictModalConfirm(this);
		this._window = new libPictModalWindow(this);
		this._toast = new libPictModalToast(this);
		this._tooltip = new libPictModalTooltip(this);
		this._panel = new libPictModalPanel(this);
		this._dropdown = new libPictModalDropdown(this);
		this._shell = new libPictModalShell(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Ensure the root class is on the body for CSS variable scoping
		if (typeof document !== 'undefined' && document.body)
		{
			if (!document.body.classList.contains('pict-modal-root'))
			{
				document.body.classList.add('pict-modal-root');
			}
		}

		return super.onBeforeInitialize();
	}

	/**
	 * Generate a unique ID for DOM elements.
	 *
	 * @returns {number}
	 */
	_nextId()
	{
		this._idCounter++;
		return this._idCounter;
	}

	// -- Confirm API --

	/**
	 * Show a confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmLabel, cancelLabel, dangerous }
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		return this._confirm.confirm(pMessage, pOptions);
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is set, the user must type it to enable the confirm button.
	 * If no confirmPhrase, the first click changes the button text and the second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel }
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		return this._confirm.doubleConfirm(pMessage, pOptions);
	}

	// -- Modal Window API --

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options { title, content, buttons, closeable, width, onOpen, onClose }
	 * @returns {Promise<string|null>} Resolves with the clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		return this._window.show(pOptions);
	}

	// -- Tooltip API --

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options { position, delay, maxWidth }
	 * @returns {{ destroy: function }}
	 */
	tooltip(pElement, pText, pOptions)
	{
		return this._tooltip.tooltip(pElement, pText, pOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive }
	 * @returns {{ destroy: function }}
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.richTooltip(pElement, pHTMLContent, pOptions);
	}

	/**
	 * Attach a pinnable rich HTML tooltip to an element. Hover/focus behaves
	 * like richTooltip(); a click on the element toggles a pinned state that
	 * keeps the tooltip open and follows the anchor on scroll/resize.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive, startPinned, onPinChange }
	 * @returns {{ destroy: function, pin: function, unpin: function, isPinned: function }}
	 */
	pinnableTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.pinnableTooltip(pElement, pHTMLContent, pOptions);
	}

	// -- Toast API --

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message
	 * @param {object} [pOptions] - Options { type, duration, position, dismissible }
	 * @returns {{ dismiss: function }}
	 */
	toast(pMessage, pOptions)
	{
		return this._toast.toast(pMessage, pOptions);
	}

	// -- Dropdown API --

	/**
	 * Open an anchor-positioned dropdown menu (no backdrop, click-outside
	 * dismisses). Useful for nav menus and split-button addenda. Pass
	 * `ContentHTML` instead of `items` to render a free-form anchored popover
	 * (rich card, pre-rendered template menu) with the same dismiss/flip behavior.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   { left, top, width, height } rect for context-menu style anchoring.
	 * @param {object} pOptions - { items | ContentHTML, align, position, minWidth,
	 *   maxWidth, maxHeight, className, closeOnSelect, onSelect, onClose }
	 * @returns {Promise<{Hash, Item}|null>} Selection or null on dismiss
	 *   (always resolves null in ContentHTML mode).
	 */
	dropdown(pAnchor, pOptions)
	{
		return this._dropdown.dropdown(pAnchor, pOptions);
	}

	/**
	 * Dismiss any open dropdown.
	 */
	dismissDropdowns()
	{
		this._dropdown.dismissAll();
	}

	// -- Panel API --

	/**
	 * Attach resizable/collapsible panel behavior to a DOM element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Options { position, width, minWidth, maxWidth, collapsible, collapsed, persist, persistKey, onResize, onToggle }
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	panel(pTargetSelector, pOptions)
	{
		return this._panel.create(pTargetSelector, pOptions);
	}

	// -- Shell API --

	/**
	 * Get (or create) a layout shell for a viewport. Idempotent.
	 *
	 * The shell takes ownership of the viewport's contents and manages
	 * top / right / bottom / left panel placement plus a center area.
	 * See Pict-Modal-Shell.js for full panel-config semantics.
	 *
	 * @param {string|HTMLElement} pViewport - selector or element of the
	 *   container the shell should fill (commonly the app's root div).
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.Persistence=true]   - autosave panel state to localStorage
	 * @param {string}  [pOptions.PersistenceKey=null]- override scope (default: hostname)
	 * @returns {PictModalShell}
	 */
	shell(pViewport, pOptions)
	{
		return this._shell.shell(pViewport, pOptions);
	}

	// -- Cleanup API --

	/**
	 * Dismiss all open modals.
	 */
	dismissModals()
	{
		let tmpModals = this._activeModals.slice();
		for (let i = tmpModals.length - 1; i >= 0; i--)
		{
			tmpModals[i].dismiss(null);
		}
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissTooltips()
	{
		this._tooltip.dismissAll();
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissToasts()
	{
		this._toast.dismissAll();
	}

	/**
	 * Dismiss everything: modals, tooltips, and toasts.
	 */
	dismissAll()
	{
		this.dismissModals();
		this.dismissTooltips();
		this.dismissToasts();
		this.dismissDropdowns();
	}

	/**
	 * Clean up all DOM elements when the view is destroyed.
	 */
	/**
	 * Destroy all active panels.
	 */
	destroyPanels()
	{
		this._panel.destroyAll();
	}

	destroy()
	{
		this.dismissAll();
		this.destroyPanels();
		this._overlay.destroy();
		this._toast.destroy();
		if (typeof super.destroy === 'function') { return super.destroy(); }
	}
}

module.exports = PictSectionModal;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Modal-Confirm.js":262,"./Pict-Modal-Dropdown.js":263,"./Pict-Modal-Overlay.js":264,"./Pict-Modal-Panel.js":265,"./Pict-Modal-Shell.js":266,"./Pict-Modal-Toast.js":267,"./Pict-Modal-Tooltip.js":268,"./Pict-Modal-Window.js":269,"./Pict-Section-Modal-DefaultConfiguration.js":270,"pict-view":365}],272:[function(require,module,exports){
'use strict';

/**
 * pict-section-moodboard entry point.
 *
 * Exports the Moodboard view (with its default_configuration) plus the card classes, the image and
 * sticker sources, and the note palette, so a host can register the view and, if it wants, reuse or
 * subclass the cards or supply its own image / sticker libraries.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libMoodboardView = require('./views/PictView-Moodboard.js');

module.exports = libMoodboardView;
module.exports.default_configuration = libMoodboardView.default_configuration;
module.exports.MoodImageCard = require('./cards/MoodImage-Card.js');
module.exports.MoodDrawingCard = require('./cards/MoodDrawing-Card.js');
module.exports.MoodNoteCard = require('./cards/MoodNote-Card.js');
module.exports.MoodTextCard = require('./cards/MoodText-Card.js');
module.exports.MoodStickerCard = require('./cards/MoodSticker-Card.js');
module.exports.MoodConnectorCard = require('./cards/MoodConnector-Card.js');
module.exports.ImageSource = require('./sources/ImageSource-Base.js');
module.exports.StickerSource = require('./sources/StickerSource-Base.js');
module.exports.NOTE_COLORS = libMoodboardView.NOTE_COLORS;

},{"./cards/MoodConnector-Card.js":273,"./cards/MoodDrawing-Card.js":274,"./cards/MoodImage-Card.js":275,"./cards/MoodNote-Card.js":276,"./cards/MoodSticker-Card.js":277,"./cards/MoodText-Card.js":278,"./sources/ImageSource-Base.js":279,"./sources/StickerSource-Base.js":280,"./views/PictView-Moodboard.js":281}],273:[function(require,module,exports){
'use strict';

/**
 * MoodConnector: a small "edge node" / anchor you place on the board and link with lines.
 *
 * Unlike the content cards (which are chrome-less and have no ports), a connector keeps a left input
 * and a right output port, so you can drag from one connector's port to another's to draw a
 * connection line. The board's connections (pict-section-flow edges) serialize with the rest of the
 * board, so the lines persist. Move it like any card; double-click for its label + rotation.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;

class MoodConnectorCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				Title: 'Connector',
				Name: 'Connector',
				Code: 'MoodConnector',
				Description: 'A connection point. Drag from its port to another connector to draw a line.',
				Category: 'Moodboard',
				Width: 96,
				Height: 30,
				CornerRadius: 15,
				ColorRole: 'none',
				TitleBarColor: 'transparent',
				BodyStyle: { fill: 'var(--theme-color-background-panel, #ffffff)' },
				// One input (left) + one output (right) so connectors can be chained either direction.
				Inputs: [ { Name: 'In', Side: 'left' } ],
				Outputs: [ { Name: 'Out', Side: 'right' } ],
				ShowTypeLabel: false,
				BodyContent:
				{
					ContentType: 'html',
					Padding: 0,
					TemplateHash: 'Moodboard-Connector-Body',
					Templates:
					[
						{
							Hash: 'Moodboard-Connector-Body',
							Template: /*html*/`<div class="mb-connector" data-ph="link">{~D:Record.Data.Label~}</div>`
						}
					]
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 250,
					DefaultHeight: 170,
					Title: 'Connector',
					Configuration:
					{
						TemplateHash: 'Moodboard-Connector-Panel',
						Templates:
						[
							{
								Hash: 'Moodboard-Connector-Panel',
								Template: /*html*/`
<div class="mbp">
	<label class="mbp-label">Label</label>
	<input class="mbp-input" value="{~D:Record.Data.Label~}" placeholder="(optional)" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectorLabel('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Rotation</label>
	<input class="mbp-range" type="range" min="-180" max="180" step="1" value="{~D:Record.Rotation~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setRotation('{~D:Record.Hash~}', this.value)">
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = MoodConnectorCard;

},{"pict-section-flow":208}],274:[function(require,module,exports){
'use strict';

/**
 * MoodDrawing: a moodboard card that embeds a gallery image or drawing and stays linked to its source.
 *
 * Unlike MoodImage (a static <img> snapshot rendered inside an HTML foreignObject), a drawing card:
 *   - remembers WHERE it came from (Data.SourceId) so it can be refreshed from the source (a re-saved
 *     drawing, a replaced blob) through the panel's "Update from source" button, and
 *   - renders into the board's OWN SVG rather than a foreignObject -- a native <image> element for a
 *     raster source, or the drawing's actual vector inlined (Data.SvgMarkup) for an SVG source. That is
 *     what "projected into the proper svg" means: the drawing lives in the whiteboard's SVG coordinate
 *     space (crisp at any zoom, part of a serialized/exported board), not bolted on through foreignObject.
 *
 * Data shape:
 *   Data.DrawingUrl - the source's URL (a direct URL or a data URL). Clean base (no cache-bust params).
 *   Data.SourceId   - the gallery item id it is linked to (opaque; the board's ImageSource owns it).
 *   Data.SourceName - a friendly name for the linked source (shown in the panel).
 *   Data.IsSvg      - true when the source is an SVG (drives the inline-vector path).
 *   Data.SvgMarkup  - the sanitized inner SVG markup, inlined so the vector projects into the board SVG.
 *   Data.SvgViewBox - the source SVG's viewBox (so the inlined vector scales to the card box).
 *   Data.Fit        - 'contain' (default; a drawing usually wants to show whole) or 'cover'.
 *   Data.Rev        - a cache-bust revision bumped on refresh so a replaced blob re-loads.
 *
 * The board (PictView-Moodboard) drives all of this: setDrawingSource / refreshDrawing / setDrawingFit.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;

const _SVG_NS = 'http://www.w3.org/2000/svg';
const _XLINK_NS = 'http://www.w3.org/1999/xlink';

// Append the cache-bust revision so a source whose bytes were replaced in place re-loads. Data URLs are
// already self-contained, so they are left alone.
function _revUrl(pUrl, pRev)
{
	if (!pUrl || !pRev) { return pUrl || ''; }
	if (pUrl.indexOf('data:') === 0) { return pUrl; }
	return pUrl + ((pUrl.indexOf('?') >= 0) ? '&' : '?') + '_r=' + pRev;
}

// The SVG body render (see pict-section-flow PictView-Flow-Node._renderBodyContentSVG): builds the
// linked drawing directly into the node's SVG content <g>. Runs on every node render; it only reads
// node Data (the fetch that fills SvgMarkup happens once, in the board, on pick / refresh).
function renderDrawingBody(pContentGroup, pNodeData, pNodeTypeConfig, pBounds)
{
	if (typeof document === 'undefined' || !pContentGroup) { return; }
	let tmpData = (pNodeData && pNodeData.Data) ? pNodeData.Data : {};
	let tmpWidth = Math.max(1, (pBounds && pBounds.width) ? pBounds.width : 1);
	let tmpHeight = Math.max(1, (pBounds && pBounds.height) ? pBounds.height : 1);
	let tmpPAR = (tmpData.Fit === 'cover') ? 'xMidYMid slice' : 'xMidYMid meet';

	// Inlined vector: the drawing's own SVG, projected into the board SVG as true vector.
	if (tmpData.SvgMarkup)
	{
		let tmpInner = document.createElementNS(_SVG_NS, 'svg');
		tmpInner.setAttribute('class', 'mb-drawing mb-drawing-svg');
		tmpInner.setAttribute('x', '0');
		tmpInner.setAttribute('y', '0');
		tmpInner.setAttribute('width', String(tmpWidth));
		tmpInner.setAttribute('height', String(tmpHeight));
		tmpInner.setAttribute('preserveAspectRatio', tmpPAR);
		if (tmpData.SvgViewBox) { tmpInner.setAttribute('viewBox', tmpData.SvgViewBox); }
		tmpInner.innerHTML = tmpData.SvgMarkup;
		pContentGroup.appendChild(tmpInner);
		return;
	}

	// Linked raster (or an SVG we could not inline): a native <image>, still inside the board SVG.
	if (tmpData.DrawingUrl)
	{
		let tmpHref = _revUrl(tmpData.DrawingUrl, tmpData.Rev);
		let tmpImage = document.createElementNS(_SVG_NS, 'image');
		tmpImage.setAttribute('class', 'mb-drawing mb-drawing-image');
		tmpImage.setAttribute('x', '0');
		tmpImage.setAttribute('y', '0');
		tmpImage.setAttribute('width', String(tmpWidth));
		tmpImage.setAttribute('height', String(tmpHeight));
		tmpImage.setAttribute('preserveAspectRatio', tmpPAR);
		tmpImage.setAttribute('href', tmpHref);
		// xlink:href for renderers that predate SVG2 href on <image>.
		tmpImage.setAttributeNS(_XLINK_NS, 'xlink:href', tmpHref);
		pContentGroup.appendChild(tmpImage);
		return;
	}

	// Empty: a dashed placeholder so the card is visible before a source is picked.
	let tmpRect = document.createElementNS(_SVG_NS, 'rect');
	tmpRect.setAttribute('class', 'mb-drawing-empty');
	tmpRect.setAttribute('x', '0.5');
	tmpRect.setAttribute('y', '0.5');
	tmpRect.setAttribute('width', String(Math.max(1, tmpWidth - 1)));
	tmpRect.setAttribute('height', String(Math.max(1, tmpHeight - 1)));
	pContentGroup.appendChild(tmpRect);
	let tmpText = document.createElementNS(_SVG_NS, 'text');
	tmpText.setAttribute('class', 'mb-drawing-empty-label');
	tmpText.setAttribute('x', String(tmpWidth / 2));
	tmpText.setAttribute('y', String(tmpHeight / 2));
	tmpText.setAttribute('text-anchor', 'middle');
	tmpText.setAttribute('dominant-baseline', 'middle');
	tmpText.textContent = 'Pick a drawing';
	pContentGroup.appendChild(tmpText);
}

class MoodDrawingCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				Title: 'Drawing',
				Name: 'Drawing',
				Code: 'MoodDrawing',
				Description: 'A gallery image or drawing, linked to its source. Update it from the source; it renders as SVG.',
				Category: 'Moodboard',
				Width: 260,
				Height: 200,
				CornerRadius: 8,
				ColorRole: 'none',
				BodyStyle: { fill: 'var(--theme-color-background-tertiary, #eef1f4)' },
				Inputs: [],
				Outputs: [],
				ShowTypeLabel: false,
				// Rendered into the board's own SVG (a native <image> or inlined vector), not a foreignObject,
				// so the drawing projects into the whiteboard SVG. renderDrawingBody does the imperative build.
				BodyContent:
				{
					ContentType: 'svg',
					Padding: 0,
					RenderCallback: renderDrawingBody
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 280,
					DefaultHeight: 380,
					Title: 'Drawing',
					Configuration:
					{
						TemplateHash: 'Moodboard-Drawing-Panel',
						Templates:
						[
							{
								Hash: 'Moodboard-Drawing-Panel',
								Template: /*html*/`
<div class="mbp">
	<label class="mbp-label">Drawing</label>
	<button class="mbp-btn" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].openPickerForCard('{~D:Record.Hash~}', 'drawing')">Pick from gallery</button>
	<div class="mbp-drawingsource {~D:Record.Data._SourceShow~}">
		<div class="mbp-hint">Linked to <b>{~D:Record.Data.SourceName~}</b></div>
		<button class="mbp-btn" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].refreshDrawing('{~D:Record.Hash~}')">Update from source</button>
	</div>
	<label class="mbp-label">Fit</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setDrawingFit('{~D:Record.Hash~}', this.value)">
		<option value="contain" {~D:Record.Data.FitContainSel~}>Contain (show all)</option>
		<option value="cover" {~D:Record.Data.FitCoverSel~}>Cover (fill the tile)</option>
	</select>
	<label class="mbp-label">Rotation</label>
	<input class="mbp-range" type="range" min="-180" max="180" step="1" value="{~D:Record.Rotation~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setRotation('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Connection points</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectMode('{~D:Record.Hash~}', this.value)">
		<option value="off" {~D:Record.Data.ConnectOffSel~}>Off</option>
		<option value="edit" {~D:Record.Data.ConnectEditSel~}>While editing</option>
		<option value="always" {~D:Record.Data.ConnectAlwaysSel~}>Always (show to viewers)</option>
	</select>
	<div class="mbp-hint">A drawing stays linked to the gallery item you picked. "Update from source" re-pulls the latest.</div>
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = MoodDrawingCard;

},{"pict-section-flow":208}],275:[function(require,module,exports){
'use strict';

/**
 * MoodImage: a moodboard image tile.
 *
 * A pict-section-flow card with no ports. Its body is an <img> filling the card edge to edge (the
 * moodboard sets NodeTitleBarHeight 0). The image source lives in Data.ImageUrl (a direct URL or a
 * base64 data URL); object-fit comes from Data.Fit ('cover' default, or 'contain'). You move the
 * tile on the canvas and change its source and fit through the on-graph properties panel.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;

class MoodImageCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				Title: 'Image',
				Name: 'Image',
				Code: 'MoodImage',
				Description: 'An image tile. Move it on the canvas, drag a corner to resize.',
				Category: 'Moodboard',
				Width: 240,
				Height: 200,
				CornerRadius: 8,
				ColorRole: 'none',
				BodyStyle: { fill: 'var(--theme-color-background-tertiary, #eef1f4)' },
				Inputs: [],
				Outputs: [],
				ShowTypeLabel: false,
				BodyContent:
				{
					ContentType: 'html',
					Padding: 0,
					TemplateHash: 'Moodboard-Image-Body',
					Templates:
					[
						{
							Hash: 'Moodboard-Image-Body',
							Template: /*html*/`<img class="mb-image mb-image-{~D:Record.Data.Fit~}" src="{~D:Record.Data.ImageUrl~}" alt="" draggable="false">`
						}
					]
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 280,
					DefaultHeight: 360,
					Title: 'Image',
					Configuration:
					{
						TemplateHash: 'Moodboard-Image-Panel',
						Templates:
						[
							{
								Hash: 'Moodboard-Image-Panel',
								Template: /*html*/`
<div class="mbp">
	<label class="mbp-label">Image</label>
	<button class="mbp-btn" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].openPickerForCard('{~D:Record.Hash~}', 'image')">Pick from library</button>
	<label class="mbp-label">Image URL</label>
	<input class="mbp-input" value="{~D:Record.Data.ImageUrl~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setImageUrl('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Fit</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setFit('{~D:Record.Hash~}', this.value)">
		<option value="cover">Cover (fill the tile)</option>
		<option value="contain">Contain (show all)</option>
	</select>
	<label class="mbp-label">Rotation</label>
	<input class="mbp-range" type="range" min="-180" max="180" step="1" value="{~D:Record.Rotation~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setRotation('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Connection points</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectMode('{~D:Record.Hash~}', this.value)">
		<option value="off" {~D:Record.Data.ConnectOffSel~}>Off</option>
		<option value="edit" {~D:Record.Data.ConnectEditSel~}>While editing</option>
		<option value="always" {~D:Record.Data.ConnectAlwaysSel~}>Always (show to viewers)</option>
	</select>
	<div class="mbp-hint">Drag a dot onto another card to link them. The toolbar button or pressing C toggles the selected card.</div>
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = MoodImageCard;

},{"pict-section-flow":208}],276:[function(require,module,exports){
'use strict';

/**
 * MoodNote: a moodboard sticky note.
 *
 * A pict-section-flow card with no ports. Its color comes from the per-node Style (BodyFill +
 * TitleBarColor set to the same swatch so the whole card reads as one). The body is a read-only
 * display; you move the note on the canvas and edit it (text + color) through its on-graph
 * properties panel (double-click), which calls back into the moodboard view by node hash.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;

class MoodNoteCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				Title: 'Note',
				Name: 'Note',
				Code: 'MoodNote',
				Description: 'A sticky note. Move it on the canvas; double-click to edit text and color.',
				Category: 'Moodboard',
				Width: 200,
				Height: 160,
				CornerRadius: 8,
				ColorRole: 'none',
				TitleBarColor: '#ffe08a',
				BodyStyle: { fill: '#ffe08a' },
				Inputs: [],
				Outputs: [],
				ShowTypeLabel: false,
				BodyContent:
				{
					ContentType: 'html',
					Padding: 0,
					TemplateHash: 'Moodboard-Note-Body',
					Templates:
					[
						{
							Hash: 'Moodboard-Note-Body',
							Template: /*html*/`<div class="mb-note" data-ph="Write a note" style="font-family:{~D:Record.Data.FontFamilyCss~};font-weight:{~D:Record.Data.FontWeight~};color:{~D:Record.Data.TextColor~};font-size:{~D:Record.Data.FontSizeCss~}">{~D:Record.Data.Text~}</div>`
						}
					]
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 260,
					DefaultHeight: 400,
					Title: 'Note',
					Configuration:
					{
						TemplateHash: 'Moodboard-Note-Panel',
						Templates:
						[
							{
								Hash: 'Moodboard-Note-Panel',
								Template: /*html*/`
<div class="mbp">
	<label class="mbp-label">Text</label>
	<textarea class="mbp-input mbp-textarea" placeholder="Write a note" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].editText('{~D:Record.Hash~}', this.value)">{~D:Record.Data.Text~}</textarea>
	<label class="mbp-label">Color</label>
	<div class="mbp-swatches">
		<button class="mbp-swatch" style="background:#ffe08a" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setNoteColor('{~D:Record.Hash~}','#ffe08a')"></button>
		<button class="mbp-swatch" style="background:#ffb3c1" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setNoteColor('{~D:Record.Hash~}','#ffb3c1')"></button>
		<button class="mbp-swatch" style="background:#a8d8ff" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setNoteColor('{~D:Record.Hash~}','#a8d8ff')"></button>
		<button class="mbp-swatch" style="background:#b7e4c7" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setNoteColor('{~D:Record.Hash~}','#b7e4c7')"></button>
		<button class="mbp-swatch" style="background:#d8c2ff" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setNoteColor('{~D:Record.Hash~}','#d8c2ff')"></button>
		<button class="mbp-swatch" style="background:#ffd6a5" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setNoteColor('{~D:Record.Hash~}','#ffd6a5')"></button>
		<button class="mbp-swatch" style="background:#e6e6e6" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setNoteColor('{~D:Record.Hash~}','#e6e6e6')"></button>
	</div>
	<label class="mbp-label">Font</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setFontFamily('{~D:Record.Hash~}', this.value)">
		<option value="">Default</option>
		<option value="sans">Sans</option>
		<option value="serif">Serif</option>
		<option value="mono">Mono</option>
		<option value="rounded">Rounded</option>
		<option value="condensed">Condensed</option>
	</select>
	<label class="mbp-label">Weight</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setFontWeight('{~D:Record.Hash~}', this.value)">
		<option value="">Default</option>
		<option value="300">Light</option>
		<option value="400">Regular</option>
		<option value="500">Medium</option>
		<option value="700">Bold</option>
		<option value="900">Black</option>
	</select>
	<label class="mbp-label">Size</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setFontSize('{~D:Record.Hash~}', this.value)">
		<option value="">Default</option>
		<option value="13">Small</option>
		<option value="16">Medium</option>
		<option value="22">Large</option>
		<option value="30">Huge</option>
	</select>
	<label class="mbp-label">Text color</label>
	<div class="mbp-swatches">
		<button class="mbp-swatch" style="background:#1f2430" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#1f2430')"></button>
		<button class="mbp-swatch" style="background:#5b6470" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#5b6470')"></button>
		<button class="mbp-swatch" style="background:#ffffff" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#ffffff')"></button>
		<button class="mbp-swatch" style="background:#2880a6" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#2880a6')"></button>
		<button class="mbp-swatch" style="background:#c0392b" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#c0392b')"></button>
		<button class="mbp-swatch" style="background:#2e7d32" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#2e7d32')"></button>
		<input type="color" class="mbp-textcolor" title="Custom text color" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}', this.value)">
	</div>
	<label class="mbp-label">Rotation</label>
	<input class="mbp-range" type="range" min="-180" max="180" step="1" value="{~D:Record.Rotation~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setRotation('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Connection points</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectMode('{~D:Record.Hash~}', this.value)">
		<option value="off" {~D:Record.Data.ConnectOffSel~}>Off</option>
		<option value="edit" {~D:Record.Data.ConnectEditSel~}>While editing</option>
		<option value="always" {~D:Record.Data.ConnectAlwaysSel~}>Always (show to viewers)</option>
	</select>
	<div class="mbp-hint">Drag a dot onto another card to link them. The toolbar button or pressing C toggles the selected card.</div>
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = MoodNoteCard;

},{"pict-section-flow":208}],277:[function(require,module,exports){
'use strict';

/**
 * MoodSticker: a moodboard sticker.
 *
 * Like MoodImage but with no card chrome: a transparent <img> (a PNG or SVG cutout) that floats on
 * the board, kept to its aspect ratio inside a small, resizable box. Its source lives in
 * Data.StickerUrl (a direct URL or a base64 / data URL). You move it on the canvas, drag a corner to
 * resize, and change its source through the on-graph properties panel. Stickers come from the
 * board's StickerSource (a built-in set plus, in a host app, an uploaded library).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;

class MoodStickerCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				Title: 'Sticker',
				Name: 'Sticker',
				Code: 'MoodSticker',
				Description: 'A sticker cutout. Move it on the canvas, drag a corner to resize.',
				Category: 'Moodboard',
				Width: 120,
				Height: 120,
				CornerRadius: 0,
				ColorRole: 'none',
				TitleBarColor: 'transparent',
				BodyStyle: { fill: 'transparent' },
				Inputs: [],
				Outputs: [],
				ShowTypeLabel: false,
				BodyContent:
				{
					ContentType: 'html',
					Padding: 0,
					TemplateHash: 'Moodboard-Sticker-Body',
					Templates:
					[
						{
							Hash: 'Moodboard-Sticker-Body',
							Template: /*html*/`<img class="mb-sticker" src="{~D:Record.Data.StickerUrl~}" alt="" draggable="false">`
						}
					]
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 260,
					DefaultHeight: 330,
					Title: 'Sticker',
					Configuration:
					{
						TemplateHash: 'Moodboard-Sticker-Panel',
						Templates:
						[
							{
								Hash: 'Moodboard-Sticker-Panel',
								Template: /*html*/`
<div class="mbp">
	<label class="mbp-label">Sticker</label>
	<button class="mbp-btn" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].openPickerForCard('{~D:Record.Hash~}', 'sticker')">Pick a sticker</button>
	<label class="mbp-label">Sticker URL</label>
	<input class="mbp-input" value="{~D:Record.Data.StickerUrl~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setStickerUrl('{~D:Record.Hash~}', this.value)">
	<div class="mbp-stickercolors {~D:Record.Data._ColorShow~}">
		<label class="mbp-label">Colors</label>
		<div class="mbp-colorset">
			<input type="color" class="mbp-color" title="Primary color" value="{~D:Record.Data.ColorPrimary~}" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setStickerColor('{~D:Record.Hash~}', 'pri', this.value)">
			<input type="color" class="mbp-color mbp-sec {~D:Record.Data._SecColorShow~}" title="Secondary color" value="{~D:Record.Data.ColorSecondary~}" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setStickerColor('{~D:Record.Hash~}', 'sec', this.value)">
		</div>
	</div>
	<label class="mbp-label">Rotation</label>
	<input class="mbp-range" type="range" min="-180" max="180" step="1" value="{~D:Record.Rotation~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setRotation('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Connection points</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectMode('{~D:Record.Hash~}', this.value)">
		<option value="off" {~D:Record.Data.ConnectOffSel~}>Off</option>
		<option value="edit" {~D:Record.Data.ConnectEditSel~}>While editing</option>
		<option value="always" {~D:Record.Data.ConnectAlwaysSel~}>Always (show to viewers)</option>
	</select>
	<div class="mbp-hint">Drag a dot onto another card to link them. The toolbar button or pressing C toggles the selected card.</div>
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = MoodStickerCard;

},{"pict-section-flow":208}],278:[function(require,module,exports){
'use strict';

/**
 * MoodText: a big-type text statement, the kind that dominates a moodboard ("live deliberately"
 * set giant between the photos). Unlike a MoodNote it has no card background, bold centered type,
 * and a font that scales with the card box (CSS container units) unless a fixed size is set.
 *
 * The card body is a read-only display; you move it on the canvas and edit it through its on-graph
 * properties panel (double-click), which carries the text plus parameters (font size). The panel
 * calls back into the moodboard view by node hash through AppData.Moodboard.ViewID.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;

class MoodTextCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				Title: 'Text',
				Name: 'Text',
				Code: 'MoodText',
				Description: 'A big-type statement. Resize the card to scale the words, or set a fixed size.',
				Category: 'Moodboard',
				Width: 360,
				Height: 120,
				CornerRadius: 8,
				ColorRole: 'none',
				TitleBarColor: 'transparent',
				BodyStyle: { fill: 'transparent' },
				Inputs: [],
				Outputs: [],
				ShowTypeLabel: false,
				BodyContent:
				{
					ContentType: 'html',
					Padding: 0,
					TemplateHash: 'Moodboard-Text-Body',
					Templates:
					[
						{
							Hash: 'Moodboard-Text-Body',
							Template: /*html*/`<div class="mb-text" data-ph="Big text" style="font-family:{~D:Record.Data.FontFamilyCss~};font-weight:{~D:Record.Data.FontWeight~};color:{~D:Record.Data.TextColor~};font-size:{~D:Record.Data.FontSizeCss~}">{~D:Record.Data.Text~}</div>`
						}
					]
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 280,
					DefaultHeight: 400,
					Title: 'Text',
					Configuration:
					{
						TemplateHash: 'Moodboard-Text-Panel',
						Templates:
						[
							{
								Hash: 'Moodboard-Text-Panel',
								Template: /*html*/`
<div class="mbp">
	<label class="mbp-label">Text</label>
	<textarea class="mbp-input mbp-textarea" placeholder="Big text" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].editText('{~D:Record.Hash~}', this.value)">{~D:Record.Data.Text~}</textarea>
	<label class="mbp-label">Font size</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setFontSize('{~D:Record.Hash~}', this.value)">
		<option value="">Auto (fit the card)</option>
		<option value="28">Small</option>
		<option value="44">Medium</option>
		<option value="68">Large</option>
		<option value="104">Display</option>
	</select>
	<label class="mbp-label">Font</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setFontFamily('{~D:Record.Hash~}', this.value)">
		<option value="">Default</option>
		<option value="sans">Sans</option>
		<option value="serif">Serif</option>
		<option value="mono">Mono</option>
		<option value="rounded">Rounded</option>
		<option value="condensed">Condensed</option>
	</select>
	<label class="mbp-label">Weight</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setFontWeight('{~D:Record.Hash~}', this.value)">
		<option value="">Default</option>
		<option value="300">Light</option>
		<option value="400">Regular</option>
		<option value="500">Medium</option>
		<option value="700">Bold</option>
		<option value="900">Black</option>
	</select>
	<label class="mbp-label">Text color</label>
	<div class="mbp-swatches">
		<button class="mbp-swatch" style="background:#1f2430" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#1f2430')"></button>
		<button class="mbp-swatch" style="background:#5b6470" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#5b6470')"></button>
		<button class="mbp-swatch" style="background:#ffffff" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#ffffff')"></button>
		<button class="mbp-swatch" style="background:#2880a6" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#2880a6')"></button>
		<button class="mbp-swatch" style="background:#c0392b" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#c0392b')"></button>
		<button class="mbp-swatch" style="background:#2e7d32" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}','#2e7d32')"></button>
		<input type="color" class="mbp-textcolor" title="Custom text color" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setTextColor('{~D:Record.Hash~}', this.value)">
	</div>
	<label class="mbp-label">Rotation</label>
	<input class="mbp-range" type="range" min="-180" max="180" step="1" value="{~D:Record.Rotation~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setRotation('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Connection points</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectMode('{~D:Record.Hash~}', this.value)">
		<option value="off" {~D:Record.Data.ConnectOffSel~}>Off</option>
		<option value="edit" {~D:Record.Data.ConnectEditSel~}>While editing</option>
		<option value="always" {~D:Record.Data.ConnectAlwaysSel~}>Always (show to viewers)</option>
	</select>
	<div class="mbp-hint">Drag a dot onto another card to link them. The toolbar button or pressing C toggles the selected card.</div>
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = MoodTextCard;

},{"pict-section-flow":208}],279:[function(require,module,exports){
'use strict';

/**
 * MoodboardImageSource: the gallery's pluggable image backend.
 *
 * The moodboard gallery does not know where images come from. It asks a source for its fields
 * (so it can build filter / sort / search controls) and for a list of images matching a query.
 * This base class is the built-in, stand-alone source: an in-memory collection of image records,
 * each carrying a Url (a direct URL or a base64 data URL) and a metadata bag. It is what a board
 * uses when no host source is supplied, so everything works on built-ins.
 *
 * An embedding application replaces it (options.ImageSource) with one that serves its own library
 * (for plansheet, the Media blobs) and declares its own metadata fields; the gallery then filters,
 * sorts, and searches over whatever that source exposes. A host source only has to implement
 * getFields(), list(query, callback), and (optionally) add() and upload().
 *
 * Field shape: { Key, Label, Type: 'string'|'enum'|'number'|'date', Searchable?, Filterable?, Sortable? }.
 * 'Name' is a top-level field on each record; every other field reads from record.Metadata[Key].
 *
 * Query shape: { Search: string, Filters: { <Key>: value }, Sort: { Field, Direction: 'asc'|'desc' } }.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const _DEFAULT_FIELDS =
[
	{ Key: 'Name',    Label: 'Name',  Type: 'string', Searchable: true,  Sortable: true },
	{ Key: 'Type',    Label: 'Type',  Type: 'enum',   Filterable: true,  Sortable: true, Searchable: true },
	{ Key: 'AddedAt', Label: 'Added', Type: 'date',   Sortable: true }
];

let _IdCounter = 0;

class MoodboardImageSource
{
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};
		this._Items = [];
		this._Fields = Array.isArray(tmpOptions.Fields) ? tmpOptions.Fields : _DEFAULT_FIELDS;
		if (Array.isArray(tmpOptions.Items))
		{
			tmpOptions.Items.forEach((pItem) => this.add(pItem));
		}
	}

	/**
	 * The metadata fields this source exposes. The gallery builds its controls from this list.
	 */
	getFields() { return this._Fields; }

	/**
	 * Distinct values for an enum field, for building a filter dropdown.
	 */
	getFilterOptions(pKey)
	{
		let tmpSeen = {};
		let tmpValues = [];
		for (let i = 0; i < this._Items.length; i++)
		{
			let tmpValue = this._fieldValue(this._Items[i], pKey);
			if (tmpValue !== '' && tmpValue != null && !tmpSeen[tmpValue])
			{
				tmpSeen[tmpValue] = true;
				tmpValues.push(tmpValue);
			}
		}
		tmpValues.sort();
		return tmpValues;
	}

	/**
	 * Add an image record. Deduplicates by Url. Returns the stored record (with an Id).
	 * @param {Object} pRecord - { Url, Name?, Thumbnail?, Metadata? }
	 */
	add(pRecord)
	{
		if (!pRecord || !pRecord.Url) { return null; }
		let tmpExisting = this._Items.find((pItem) => pItem.Url === pRecord.Url);
		if (tmpExisting) { return tmpExisting; }

		let tmpRecord =
		{
			Id: pRecord.Id || ('img-' + (++_IdCounter)),
			Url: pRecord.Url,
			Name: pRecord.Name || 'image',
			Thumbnail: pRecord.Thumbnail || pRecord.Url,
			Metadata: Object.assign({}, pRecord.Metadata)
		};
		this._Items.push(tmpRecord);
		return tmpRecord;
	}

	/**
	 * Store an uploaded file. The base source keeps the data URL in memory; a host overrides this to
	 * push the bytes to its own store and hand back a record whose Url points there.
	 * @param {File} pFile
	 * @param {string} pDataUrl - the file read as a base64 data URL
	 * @param {Function} fCallback - function(error, record)
	 */
	upload(pFile, pDataUrl, fCallback)
	{
		let tmpRecord = this.add(
			{
				Url: pDataUrl,
				Name: (pFile && pFile.name) || 'image',
				Metadata: { Type: (pFile && pFile.type) || 'image', SizeBytes: (pFile && pFile.size) || 0, AddedAt: Date.now() }
			});
		if (typeof fCallback === 'function') { fCallback(null, tmpRecord); }
		return tmpRecord;
	}

	/**
	 * Return the images matching a query (search, filters, sort). Node-style callback plus a direct
	 * return so callers can use whichever is convenient.
	 */
	list(pQuery, fCallback)
	{
		let tmpQuery = pQuery || {};
		let tmpItems = this._Items.slice();

		let tmpSearch = (tmpQuery.Search || '').trim().toLowerCase();
		if (tmpSearch)
		{
			tmpItems = tmpItems.filter((pItem) => this._searchableText(pItem).indexOf(tmpSearch) >= 0);
		}

		let tmpFilters = tmpQuery.Filters || {};
		Object.keys(tmpFilters).forEach((pKey) =>
		{
			let tmpValue = tmpFilters[pKey];
			if (tmpValue === '' || tmpValue == null) { return; }
			tmpItems = tmpItems.filter((pItem) => String(this._fieldValue(pItem, pKey)) === String(tmpValue));
		});

		if (tmpQuery.Sort && tmpQuery.Sort.Field)
		{
			let tmpField = tmpQuery.Sort.Field;
			let tmpDir = (tmpQuery.Sort.Direction === 'desc') ? -1 : 1;
			tmpItems.sort((pA, pB) =>
			{
				let tmpAV = this._fieldValue(pA, tmpField);
				let tmpBV = this._fieldValue(pB, tmpField);
				if (tmpAV < tmpBV) { return -1 * tmpDir; }
				if (tmpAV > tmpBV) { return 1 * tmpDir; }
				return 0;
			});
		}

		if (typeof fCallback === 'function') { fCallback(null, tmpItems); }
		return tmpItems;
	}

	_fieldValue(pItem, pKey)
	{
		if (pKey === 'Name') { return pItem.Name || ''; }
		return (pItem.Metadata && pItem.Metadata[pKey] != null) ? pItem.Metadata[pKey] : '';
	}

	_searchableText(pItem)
	{
		let tmpParts = [pItem.Name || ''];
		this._Fields.filter((pField) => pField.Searchable).forEach((pField) =>
		{
			tmpParts.push(String(this._fieldValue(pItem, pField.Key)));
		});
		return tmpParts.join(' ').toLowerCase();
	}
}

module.exports = MoodboardImageSource;
module.exports.DEFAULT_FIELDS = _DEFAULT_FIELDS;

},{}],280:[function(require,module,exports){
'use strict';

/**
 * MoodboardStickerSource: the sticker gallery's pluggable backend.
 *
 * Stickers are media just like gallery images (a Url, a Name, a Metadata bag), so this reuses the
 * ImageSource base wholesale (getFields / list / add / upload / getFilterOptions) and only changes
 * what a sticker source seeds: a small built-in set of cutout shapes, so the sticker gallery is
 * useful the moment a board mounts with no host source.
 *
 * An embedding application replaces it (options.StickerSource) with one that serves its own sticker
 * library (for plansheet, the Sticker entity blobs) and can merge those on top of, or instead of,
 * these built-ins. A host source only has to implement getFields(), list(query, callback), and
 * (optionally) add() and upload() -- the same contract as ImageSource.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libImageSource = require('./ImageSource-Base.js');

// Inline SVG cutouts as data URLs, so the module ships a usable starter set with no network or asset
// files. encodeURIComponent keeps the markup safe inside a data URI (handles #, spaces, quotes).
function _svgDataUrl(pSvg)
{
	return 'data:image/svg+xml,' + encodeURIComponent(pSvg);
}

const _BUILTIN_STICKERS =
[
	{
		Id: 'sticker-star', Name: 'Star',
		Url: _svgDataUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#f5b301"><path d="M12 2l2.9 6.1 6.7.7-5 4.5 1.4 6.6L12 17.9 6 20.4l1.4-6.6-5-4.5 6.7-.7z"/></svg>'),
		Metadata: { Type: 'sticker' }
	},
	{
		Id: 'sticker-heart', Name: 'Heart',
		Url: _svgDataUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#e84d6a"><path d="M12 21s-7.5-4.9-10-9.3C.4 8.8 1.8 5 5.2 5c2.1 0 3.4 1.3 4.3 2.6h0C10.4 6.3 11.7 5 13.8 5c3.4 0 4.8 3.8 3.2 6.7C19.5 16.1 12 21 12 21z"/></svg>'),
		Metadata: { Type: 'sticker' }
	},
	{
		Id: 'sticker-sparkle', Name: 'Sparkle',
		Url: _svgDataUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#8e5cff"><path d="M12 2c.6 4.3 3.7 7.4 8 8-4.3.6-7.4 3.7-8 8-.6-4.3-3.7-7.4-8-8 4.3-.6 7.4-3.7 8-8z"/></svg>'),
		Metadata: { Type: 'sticker' }
	},
	{
		Id: 'sticker-arrow', Name: 'Arrow',
		Url: _svgDataUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2c3340"><path d="M4 11h11.2l-4.6-4.6L12 5l7 7-7 7-1.4-1.4 4.6-4.6H4z"/></svg>'),
		Metadata: { Type: 'sticker' }
	},
	{
		Id: 'sticker-check', Name: 'Check',
		Url: _svgDataUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2e9e5b"><circle cx="12" cy="12" r="10"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'),
		Metadata: { Type: 'sticker' }
	},
	{
		Id: 'sticker-bubble', Name: 'Speech bubble',
		Url: _svgDataUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2880a6"><path d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg>'),
		Metadata: { Type: 'sticker' }
	}
];

class MoodboardStickerSource extends libImageSource
{
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};
		// Seed the built-in stickers unless the host supplies its own Items.
		if (!Array.isArray(tmpOptions.Items))
		{
			tmpOptions = Object.assign({}, tmpOptions, { Items: _BUILTIN_STICKERS });
		}
		super(tmpOptions);
	}
}

module.exports = MoodboardStickerSource;
module.exports.BUILTIN_STICKERS = _BUILTIN_STICKERS;

},{"./ImageSource-Base.js":279}],281:[function(require,module,exports){
'use strict';

/**
 * Moodboard: a free-form canvas of draggable, resizable image tiles, sticky notes, big text, stickers,
 * and connectors.
 *
 * It is a thin layer over pict-section-flow. The flow supplies the whole interface: ONE thin toolbar
 * (with its native docked / draggable / collapsible modes) carries adding (the card palette), delete,
 * zoom, fit, and fullscreen; this view adds two host-facing toolbar buttons through the flow's
 * ToolbarExtraButtons extension -- a board-background button (opens a small popover) and whatever
 * Edit / Done button the host supplies -- plus the per-card properties panels where every setting
 * lives (note color and font, image fit, a library picker, connector label, rotation). There is no
 * hand-rolled chrome: no separate control bar, no viewer bar, no custom fullscreen.
 *
 * A content card (image / note / text / sticker) is chrome-less and port-less; a connector keeps two
 * ports so you can draw lines between connectors. Images are stored on each node as Data.ImageUrl --
 * stand-alone that is a base64 data URL kept in the board JSON (a board is self-contained); a host can
 * pass an ImageSource / StickerSource that serves bytes from its own store. The board serializes
 * through the flow's getFlowData / setFlowData (Nodes + Connections + ViewState).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');

// Editing chrome stripped out of a baked crop (see bakeCropToSVG). These are the flow's manipulation
// affordances -- node resize / rotate grips, the crop frame and its handles, connection ports -- which are
// tools for composing the board, never part of the picture it produces.
const _BAKE_STRIPPED_SELECTOR = [
	'.pict-flow-node-resize-handle',
	'.pict-flow-node-rotate-arm',
	'.pict-flow-node-rotate-handle',
	'.pict-flow-zoom-invariant',
	'.pict-flow-frame',
	'.pict-flow-frame-handles',
	'.pict-flow-frame-handle',
	'.pict-flow-port'
].join(', ');
const libPictSectionFlow = require('pict-section-flow');
const libMoodImageCard = require('../cards/MoodImage-Card.js');
const libMoodDrawingCard = require('../cards/MoodDrawing-Card.js');
const libMoodNoteCard = require('../cards/MoodNote-Card.js');
const libMoodTextCard = require('../cards/MoodText-Card.js');
const libMoodStickerCard = require('../cards/MoodSticker-Card.js');
// The connector card is no longer offered in the palette (edges are drawn between card ports now), but
// it stays registered so boards saved with the older connector nodes still render them correctly.
const libMoodConnectorCard = require('../cards/MoodConnector-Card.js');
const libImageSource = require('../sources/ImageSource-Base.js');
const libStickerSource = require('../sources/StickerSource-Base.js');

// A small, friendly note palette. The first entry is the default for a new note.
const _NOTE_COLORS = ['#ffe08a', '#ffb3c1', '#a8d8ff', '#b7e4c7', '#d8c2ff', '#ffd6a5', '#e6e6e6'];

// Curated board-background swatches: paper neutrals, soft tints, and one near-black for a dark board.
// A custom-color input and a "no background" option sit beside them in the gear Appearance section.
const _BACKGROUND_COLORS = ['#ffffff', '#faf7f2', '#f1f5f9', '#eef2ff', '#ecfdf5', '#fef2f2', '#fdf4ff', '#111827'];

// The display modes, shown in the toolbar's display-mode dropdown (one button whose icon is the current
// mode; the menu lists these with an icon + label). Add a mode here and it appears in the menu -- the
// toolbar stays one button, not one-per-mode. Each Icon is a flow icon key.
const _DISPLAY_MODES =
[
	{ Key: 'canvas', Label: 'Canvas', Hint: 'Plain free-form board', Icon: 'display-canvas' },
	{ Key: 'jumbotron', Label: 'Jumbotron', Hint: 'Hero band at the top', Icon: 'display-jumbotron' },
	{ Key: 'background', Label: 'Background', Hint: 'Full-width backdrop', Icon: 'display-background' }
];
function _displayMode(pKey) { return _DISPLAY_MODES.find((pMode) => pMode.Key === pKey) || _DISPLAY_MODES[0]; }

// Curated, web-safe font stacks for note + text cards (no web-font loading -- these resolve to fonts
// already on the machine). The panel select passes a key; setFontFamily resolves it to the stack.
// The option keys in the card panels must stay in sync with these.
const _FONT_FAMILIES =
{
	'': '',
	'sans': "'Helvetica Neue', Helvetica, Arial, sans-serif",
	'serif': "Georgia, 'Times New Roman', Times, serif",
	'mono': "'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace",
	'rounded': "'Trebuchet MS', 'Segoe UI', system-ui, sans-serif",
	'condensed': "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif"
};

// Curated text-color swatches for note + text cards (ink, gray, white, and a few accents). A custom
// color input sits beside them in each card's panel.
const _TEXT_COLORS = ['#1f2430', '#5b6470', '#ffffff', '#2880a6', '#c0392b', '#2e7d32', '#b8860b'];

// Twelve connection anchors: three evenly spaced down each side, none on the corners. These are
// pict-section-flow's built-in twelve port-side names (the flow positions each in its third of the
// edge), so a card's links can attach right where they should. All are output ports; undirected
// connections (EnableUndirectedConnections) let any anchor link to any other.
const _CONNECT_SIDES = ['left-top', 'left', 'left-bottom', 'right-top', 'right', 'right-bottom', 'top-left', 'top', 'top-right', 'bottom-left', 'bottom', 'bottom-right'];

// The properties panel for a connection (double-click a link to open it). Like a card's panel, it is a
// Template panel rendered against the connection record, so its controls bind Record.Data.* and call the
// view's setConnection* methods. Edits the line color, width, style, the marker at each end, and a label.
const _CONNECTION_PANEL =
{
	PanelType: 'Template',
	DefaultWidth: 250,
	DefaultHeight: 360,
	Title: 'Connection',
	Configuration:
	{
		TemplateHash: 'Moodboard-Connection-Panel',
		Templates:
		[
			{
				Hash: 'Moodboard-Connection-Panel',
				Template: /*html*/`
<div class="mbp">
	<label class="mbp-label">Color</label>
	<input type="color" class="mbp-color" value="{~D:Record.Data.StrokeColor~}" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectionColor('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Width</label>
	<input class="mbp-range" type="range" min="1" max="8" step="1" value="{~D:Record.Data.StrokeWidth~}" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectionWidth('{~D:Record.Hash~}', this.value)">
	<label class="mbp-label">Line</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectionLineStyle('{~D:Record.Hash~}', this.value)">
		<option value="solid" {~D:Record.Data.StyleSolidSel~}>Solid</option>
		<option value="dashed" {~D:Record.Data.StyleDashedSel~}>Dashed</option>
		<option value="dotted" {~D:Record.Data.StyleDottedSel~}>Dotted</option>
	</select>
	<label class="mbp-label">Curve</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectionCurve('{~D:Record.Hash~}', this.value)">
		<option value="Bezier" {~D:Record.Data.CurveBezierSel~}>Curved</option>
		<option value="Orthogonal" {~D:Record.Data.CurveElbowSel~}>Elbow</option>
		<option value="Straight" {~D:Record.Data.CurveStraightSel~}>Straight</option>
	</select>
	<label class="mbp-label">Start end</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectionSourceMarker('{~D:Record.Hash~}', this.value)">
		<option value="none" {~D:Record.Data.SrcNoneSel~}>None</option>
		<option value="arrow" {~D:Record.Data.SrcArrowSel~}>Arrow</option>
		<option value="dot" {~D:Record.Data.SrcDotSel~}>Dot</option>
		<option value="square" {~D:Record.Data.SrcSquareSel~}>Square</option>
	</select>
	<label class="mbp-label">Finish end</label>
	<select class="mbp-input" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectionTargetMarker('{~D:Record.Hash~}', this.value)">
		<option value="none" {~D:Record.Data.TgtNoneSel~}>None</option>
		<option value="arrow" {~D:Record.Data.TgtArrowSel~}>Arrow</option>
		<option value="dot" {~D:Record.Data.TgtDotSel~}>Dot</option>
		<option value="square" {~D:Record.Data.TgtSquareSel~}>Square</option>
	</select>
	<label class="mbp-label">Label</label>
	<input class="mbp-input" value="{~D:Record.Data.Label~}" placeholder="(optional)" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].setConnectionLabel('{~D:Record.Hash~}', this.value)">
</div>`
			}
		]
	}
};

const _ViewConfiguration =
{
	ViewIdentifier: 'Moodboard',
	DefaultRenderable: 'Moodboard-Container',
	DefaultDestinationAddress: '#Moodboard-Container',
	CSS: /*css*/`
		.mb-root { position: relative; display: flex; flex-direction: column; height: 100%; min-height: 0; }
		.mb-canvas { position: relative; flex: 1; min-height: 0; overflow: hidden; }
		.mb-canvas.mb-dropping::after { content: "Drop images here"; position: absolute; inset: 10px; border: 2px dashed var(--theme-color-brand-primary, #2880a6); border-radius: 10px; display: flex; align-items: center; justify-content: center; color: var(--theme-color-brand-primary, #2880a6); font-weight: 600; pointer-events: none; background: rgba(40,128,166,0.06); }
		.mb-flow { position: absolute; inset: 0; }
		/* The flow container defaults to min-height: 400px (it expects to be a full-page editor); inside a
		   short embedded board that overflows the canvas and spills over the content below. Pin it to the
		   canvas so the board stays inside its banner. */
		.mb-root .pict-flow-container { min-height: 0; }
		.mb-sticker { width: 100%; height: 100%; object-fit: contain; pointer-events: none; user-select: none; -webkit-user-drag: none; }
		/* A sticker is a cutout, not a card: drop the flow's default white node body + border so only the
		   transparent image shows (the type class beats the flow's .pict-flow-node-body fill by specificity). */
		.mb-root .pict-flow-node-MoodSticker .pict-flow-node-body { fill: transparent; stroke: none; }
		/* A connector ("edge node"): a small dashed pill with visible ports you drag from to draw lines. */
		.mb-connector { width: 100%; height: 100%; box-sizing: border-box; display: flex; align-items: center; justify-content: center; padding: 0 8px; font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); overflow: hidden; white-space: nowrap; }
		.mb-connector:empty::before { content: attr(data-ph); opacity: 0.5; }
		.mb-root .pict-flow-node-MoodConnector .pict-flow-node-body { fill: var(--theme-color-background-panel, #ffffff); stroke: var(--theme-color-border-default, #c2cad6); stroke-width: 1; stroke-dasharray: 3 2; }
		/* The flow draws a small "has a panel" indicator dot on every node; on a moodboard it reads as a
		   stray handle (and adds a second box next to the resize handle when selected). Drop it -- cards
		   are edited by double-clicking them open. */
		.mb-root .pict-flow-node-panel-indicator { display: none; }

		/* Trim pict-section-flow's one toolbar to what a moodboard needs: hide the layout/auto group and
		   the theme (gear) popup. Cards, delete, zoom, fit, fullscreen, dock/float, and collapse stay. The
		   floating (draggable) toolbar lists its layout buttons individually, so hide those by action too. */
		.mb-root .pict-flow-toolbar-group:has([data-flow-action="layout-popup"]) { display: none; }
		/* The gear (settings) popup holds the moodboard's Appearance section (board color + backdrop margin)
		   in edit mode; hide it only on a read-only board (a viewer changes nothing). */
		.mb-readonly [data-flow-action="settings-popup"] { display: none; }
		.mb-root .pict-flow-floating-toolbar [data-flow-action="auto-layout"],
		.mb-root .pict-flow-floating-toolbar [data-flow-action="layout-popup"] { display: none; }

		/* Read-only display (Editable:false): a navigation-only toolbar (no card-delete), live pan + zoom
		   so a viewer can look around, and the toolbar collapsed into a corner that fades in on hover so
		   the board is uncluttered until you reach for it. Editing interactions stay off via the flow's
		   own flags, so the canvas navigates but cannot be changed. */
		.mb-readonly [data-flow-action="delete-selected"] { display: none; }
		/* Connection dots are an editing affordance: hide them on a read-only board -- unless the card was
		   set to "always" (NodeClass mb-conn-always), which keeps them visible to viewers. The connecting
		   lines render in both cases. */
		.mb-readonly .pict-flow-port { display: none; }
		.mb-readonly .mb-conn-always .pict-flow-port { display: block; }
		.mb-readonly .pict-flow-toolbar-collapsed { opacity: 0; transition: opacity 0.15s ease; }
		.mb-readonly:hover .pict-flow-toolbar-collapsed,
		.mb-readonly .pict-flow-toolbar-collapsed:focus-within { opacity: 1; }
		.mb-readonly .mb-canvas { cursor: grab; }
		.mb-readonly .mb-canvas:active { cursor: grabbing; }
		/* The dashed view-area frame is an editing guide (the box jumbotron / background fit the width
		   of); hide it on any read-only board so a viewer never sees the guide. The frame DATA still
		   drives the width-fit -- only the rect is hidden. */
		.mb-readonly .pict-flow-frame { display: none; }
		/* A selected card keeps its selection glow + stroke in the flow's chrome; on a read-only board a
		   viewer should not see that editing affordance (e.g. a card that was selected when the board was
		   saved). Suppress the selection chrome so the display reads as finished content. */
		.mb-readonly .pict-flow-node.selected { filter: none; }
		.mb-readonly .pict-flow-node.selected .pict-flow-node-body { stroke: none; stroke-width: 0; }

		/* Presentation display styles (jumbotron / background): a read-only, width-fit hero band or
		   full-width backdrop. The host owns the chrome (a style picker outside the board), so hide the
		   flow's own toolbar entirely, and present a plain (non-grab) cursor since the surface is fixed
		   width-fit, not freely pannable -- a tall background scrolls the page. */
		.mb-presentation .pict-flow-toolbar,
		.mb-presentation .pict-flow-floating-toolbar,
		.mb-presentation .pict-flow-toolbar-collapsed { display: none; }
		/* pict-section-flow toggles the collapsed toolbar visible with a .visible class on hover
		   (.pict-flow-toolbar-collapsed.visible sets display block), which ties the collapsed-toolbar hide
		   above on specificity (both 0,2,0) and wins on source order -- so the small "expand toolbar" button
		   leaks onto a presentation board when the pointer is over it. Repeat the hide with the .visible class
		   attached (0,3,0) so it wins outright and the button stays hidden. NOTE: no backticks in this comment
		   -- the whole CSS block is a JS template literal, so a backtick here would terminate it early. */
		.mb-presentation .pict-flow-toolbar-collapsed.visible { display: none; }
		/* ...but once expanded to full screen, bring the docked toolbar back so its fullscreen button is
		   the way back OUT (a presentation board has no other chrome; the host Expand control is behind the
		   fullscreen overlay). The .pict-flow-fullscreen wrapper class is an ancestor of the toolbar, so
		   this more-specific rule wins over the hide above. */
		.mb-presentation .pict-flow-fullscreen .pict-flow-toolbar { display: flex; }
		.mb-presentation .mb-canvas { cursor: default; }
		/* A jumbotron clips to its band height; a background fills its host container. The host sizes the
		   .mb-canvas (the band / backdrop height) -- the board fits the frame WIDTH inside it. */

		/* Appearance controls (board color + backdrop margin) live in the flow toolbar's own gear popup via
		   the SettingsSections hook -- no bespoke box. These tune the controls inside that native popup. */
		.mb-gear-field { display: flex; flex-direction: column; gap: 5px; margin: 2px 0; }
		.mb-gear-sub { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }
		.mb-gear-swatches { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
		.mb-gear-swatch { width: 20px; height: 20px; border-radius: 5px; border: 1px solid rgba(0,0,0,0.15); cursor: pointer; padding: 0; }
		.mb-gear-swatch:hover { transform: scale(1.1); }
		.mb-gear-color { width: 22px; height: 22px; padding: 0; border: 1px solid rgba(0,0,0,0.15); border-radius: 5px; background: none; cursor: pointer; }
		.mb-gear-none { position: relative; background: var(--theme-color-background-panel, #fff); }
		.mb-gear-none::after { content: ""; position: absolute; left: 2px; right: 2px; top: 50%; height: 2px; margin-top: -1px; background: #e23b4b; transform: rotate(-45deg); }
		.mb-gear-margin { width: 70px; padding: 4px 6px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 5px; font-size: 12px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }

		/* Display-mode dropdown: one toolbar button opens this list of modes. Reuses the flow toolbar's own
		   popup + list-item classes (so it matches the Cards / Layout menus); these just add the per-row
		   hint line and the current-mode mark. */
		/* The menu is appended to document.body (outside .pict-flow), so the flow popup's --pf-* vars are
		   undefined there and its background resolves to transparent. Re-supply the vars it reads so its own
		   panel background, border, and text colors apply at body level. */
		.mb-display-menu
		{
			min-width: 234px;
			--pf-panel-bg: var(--theme-color-background-panel, #ffffff);
			--pf-card-border: var(--theme-color-border-default, #dfe3ea);
			--pf-text: var(--theme-color-text-primary, #1f2733);
			--pf-hover-bg: var(--theme-color-background-secondary, #eef2f7);
		}
		.mb-display-menu .pict-flow-popup-list-item-label { display: flex; flex-direction: column; line-height: 1.25; font-weight: 600; }
		.mb-display-menu-hint { font-size: 11px; font-weight: 400; color: var(--theme-color-text-secondary, #8a93a5); }
		.mb-display-menu-current { background: var(--theme-color-background-secondary, #eef2f7); }
		.mb-display-menu-current .pict-flow-popup-list-item-icon { color: var(--theme-color-brand-primary, #2880a6); }

		/* A moodboard has a flat, light canvas (no dark flow grid). */
		/* canvas background is native to pict-section-flow now (moodboard profile + setBackground) */
		/* Moodboard cards fill edge to edge: no title text, no ports, transparent note text area. */
		.pict-flow-node-MoodImage .pict-flow-node-title,
		.pict-flow-node-MoodNote .pict-flow-node-title,
		.pict-flow-node-MoodText .pict-flow-node-title,
		.pict-flow-node-MoodSticker .pict-flow-node-title { display: none; }
		/* Connection ports show as small dots only when a card opts in (its panel adds them); the dots are
		   for editing, so hide them on a read-only board (the connecting lines still render). Port labels
		   stay hidden either way -- moodboard ports are unlabeled anchors. */
		.pict-flow-node-MoodImage .pict-flow-port-label, .pict-flow-node-MoodDrawing .pict-flow-port-label, .pict-flow-node-MoodNote .pict-flow-port-label, .pict-flow-node-MoodText .pict-flow-port-label, .pict-flow-node-MoodSticker .pict-flow-port-label { display: none; }
		.mb-readonly .pict-flow-port { display: none; }
		.mb-image { width: 100%; height: 100%; display: block; border-radius: 8px; object-fit: cover; }
		.mb-image-cover { object-fit: cover; }
		.mb-image-contain { object-fit: contain; }
		/* Drawing card: a gallery image / drawing rendered into the board SVG (a native <image>, or the
		   inlined vector for an SVG source). Empty state is a dashed placeholder until a source is picked. */
		.mb-drawing { display: block; }
		.mb-drawing-empty { fill: none; stroke: var(--theme-color-border-default, #c2cad6); stroke-width: 1; stroke-dasharray: 4 3; rx: 6px; ry: 6px; }
		.mb-drawing-empty-label { fill: var(--theme-color-text-secondary, #8a93a5); font-size: 12px; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; }
		.mb-note { width: 100%; height: 100%; box-sizing: border-box; padding: 10px; font-family: inherit; font-size: 13px; line-height: 1.35; color: #3a3320; overflow: hidden; white-space: pre-wrap; word-break: break-word; }
		.mb-note:empty::before { content: attr(data-ph); color: rgba(0,0,0,0.35); }
		.mb-text:empty::before { content: attr(data-ph); color: var(--theme-color-text-secondary, rgba(0,0,0,0.35)); }

		/* Big-type Text card: bold, transparent (floats), centered; the font scales with the card box
		   (CSS container units) unless a fixed size is set. Make the card bigger and the words grow. */
		.pict-flow-node-MoodText .pict-flow-node-body-content-html { container-type: size; width: 100%; height: 100%; }
		.mb-text { width: 100%; height: 100%; box-sizing: border-box; padding: 4px 10px; display: flex; align-items: center; justify-content: center; text-align: center; font-family: inherit; font-weight: 800; line-height: 1.04; letter-spacing: -0.015em; color: var(--theme-color-text-primary, #1d2230); font-size: min(64cqh, 12cqw); overflow: hidden; white-space: pre-wrap; word-break: break-word; }
		.pict-flow-node-MoodText .pict-flow-node-body { fill: transparent !important; stroke: none !important; }
		.pict-flow-node-MoodText .pict-flow-node-title-bar, .pict-flow-node-MoodText .pict-flow-node-title-bar-bottom { fill: transparent !important; }
		.pict-flow-node-MoodText { filter: none !important; }

		/* Card bodies are display-only so the whole card drags; editing happens in the properties panel. */
		.pict-flow-node-MoodImage .pict-flow-node-body-content-html,
		.pict-flow-node-MoodNote .pict-flow-node-body-content-html,
		.pict-flow-node-MoodText .pict-flow-node-body-content-html,
		.pict-flow-node-MoodSticker .pict-flow-node-body-content-html,
		.pict-flow-node-MoodConnector .pict-flow-node-body-content-html { pointer-events: none; }

		/* Properties panel (double-click a card to open it). */
		.mbp { display: flex; flex-direction: column; gap: 6px; padding: 10px 12px; font-size: 13px; max-height: 100%; overflow-y: auto; box-sizing: border-box; }
		.mbp-label { font-size: 11px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.03em; }
		.mbp-input { width: 100%; box-sizing: border-box; padding: 6px 8px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; font-size: 13px; font-family: inherit; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.mbp-textarea { min-height: 72px; resize: vertical; line-height: 1.3; }
		.mbp-range { width: 100%; box-sizing: border-box; margin: 2px 0; }
		.mbp-swatches { display: flex; gap: 6px; flex-wrap: wrap; }
		.mbp-swatch { width: 22px; height: 22px; border-radius: 50%; border: 1px solid rgba(0,0,0,0.15); cursor: pointer; padding: 0; }
		.mbp-swatch:hover { transform: scale(1.12); }
		.mbp-textcolor { width: 24px; height: 24px; padding: 0; border: 1px solid rgba(0,0,0,0.15); border-radius: 50%; background: none; cursor: pointer; }
		.mbp-color { width: 100%; height: 30px; padding: 2px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; background: var(--theme-color-background-panel, #fff); cursor: pointer; box-sizing: border-box; }
		/* Sticker color overrides: the whole row is hidden until a recolorable library shape is placed; the
		   second swatch shows only for a duotone (phosphor) shape. Driven by Data._ColorShow/_SecColorShow. */
		.mbp-stickercolors { display: none; flex-direction: column; gap: 6px; }
		.mbp-stickercolors.mbp-show { display: flex; }
		.mbp-colorset { display: flex; gap: 8px; align-items: center; }
		.mbp-colorset .mbp-color { width: auto; flex: 1; }
		.mbp-colorset .mbp-sec { display: none; }
		.mbp-colorset .mbp-sec.mbp-show { display: block; }
		/* Drawing card: the "linked source" block (name + Update from source) shows once a source is set. */
		.mbp-drawingsource { display: none; flex-direction: column; gap: 6px; }
		.mbp-drawingsource.mbp-show { display: flex; }
		/* A panel action button (e.g. "Pick from library", "Pick a sticker"). */
		.mbp-btn { align-self: flex-start; padding: 5px 10px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #222); cursor: pointer; font-size: 12px; }
		.mbp-btn:hover { background: var(--theme-color-background-hover, #f2f2f2); }
		/* Small helper text under a panel control (e.g. how to use connection points). */
		.mbp-hint { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a5); line-height: 1.35; }

		/* Gallery picker overlay (built from whatever fields the image source declares). Fixed + above the
		   flow fullscreen so picking an image works while editing full screen. */
		.mb-gallery { display: none; position: fixed; inset: 0; z-index: 10001; align-items: center; justify-content: center; }
		.mb-gallery-open .mb-gallery { display: flex; }
		.mb-gallery::before { content: ""; position: absolute; inset: 0; background: rgba(20,28,40,0.35); }
		.mb-gallery-panel { position: relative; width: min(760px, 92%); max-height: 86%; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #dfe3ea); border-radius: 12px; box-shadow: 0 18px 50px rgba(20,30,50,0.22); display: flex; flex-direction: column; overflow: hidden; }
		.mb-gallery-head { display: flex; align-items: center; justify-content: space-between; padding: 13px 16px; border-bottom: 1px solid var(--theme-color-border-default, #eceff3); }
		.mb-gallery-title { font-weight: 600; font-size: 15px; color: var(--theme-color-text-primary, #222); }
		.mb-gallery-controls { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; padding: 12px 16px; border-bottom: 1px solid var(--theme-color-border-default, #eceff3); }
		.mb-gallery-search { min-width: 200px; flex: 1; padding: 0.4em 0.6em; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 6px; font-size: 0.9em; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.mb-gallery-filter, .mb-gallery-sortlbl { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); display: inline-flex; gap: 5px; align-items: center; }
		.mb-gallery-filter select, .mb-gallery-sort { padding: 5px 6px; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 6px; font-size: 13px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.mb-gallery-btn { padding: 0.25em 0.6em; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #222); cursor: pointer; font-size: 0.85em; }
		.mb-gallery-btn:hover { background: var(--theme-color-background-hover, #f2f2f2); }
		.mb-gallery-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 10px; padding: 16px; overflow: auto; }
		.mb-gallery-item { display: flex; flex-direction: column; padding: 0; border: 1px solid var(--theme-color-border-default, #e4e8ef); border-radius: 8px; background: var(--theme-color-background-secondary, #f7f8fb); cursor: pointer; overflow: hidden; text-align: left; }
		.mb-gallery-item:hover { border-color: var(--theme-color-brand-primary, #2880a6); }
		.mb-gallery-item img { width: 100%; height: 92px; object-fit: cover; display: block; background: var(--theme-color-background-secondary, #e9edf2); }
		.mb-gallery-item-name { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); padding: 4px 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		/* Sticker mode: compact, square tiles with the cutout shrunk to fit (not a stretched
		   thumbnail). box-sizing keeps the padding inside the tile width so the image never overflows. */
		.mb-gallery-mode-sticker .mb-gallery-grid { grid-template-columns: repeat(auto-fill, minmax(86px, 1fr)); }
		.mb-gallery-mode-sticker .mb-gallery-item { align-items: center; }
		.mb-gallery-mode-sticker .mb-gallery-item img { width: 100%; aspect-ratio: 1 / 1; height: auto; box-sizing: border-box; padding: 14px; object-fit: contain; background: transparent; }
		.mb-gallery-mode-sticker .mb-gallery-item-name { width: 100%; text-align: center; padding: 4px 6px 6px; white-space: normal; line-height: 1.25; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
		.mb-gallery-empty { grid-column: 1 / -1; text-align: center; color: var(--theme-color-text-secondary, #8a93a5); padding: 44px 16px; }
	`,
	Templates:
	[
		{
			Hash: 'Moodboard-Container',
			Template: /*html*/`
<div class="mb-root" id="MB-Root-{~D:AppData.Moodboard.ViewID~}">
	<div class="mb-canvas" id="MB-Canvas-{~D:AppData.Moodboard.ViewID~}"
		ondragover="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].onDragOver(event)"
		ondragleave="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].onDragLeave(event)"
		ondrop="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].onDrop(event)">
		<div class="mb-flow" id="MB-Flow-{~D:AppData.Moodboard.ViewID~}"></div>
	</div>
	<div class="mb-gallery" id="MB-Gallery-{~D:AppData.Moodboard.ViewID~}"></div>
</div>`
		},
		{
			Hash: 'Moodboard-Gallery',
			Template: /*html*/`
<div class="mb-gallery-panel">
	<div class="mb-gallery-head">
		<span class="mb-gallery-title">{~D:AppData.Moodboard.Gallery.Title~}</span>
		<button class="mb-gallery-btn" onclick="document.getElementById('MB-GalleryUpload-{~D:AppData.Moodboard.ViewID~}').click()">Upload</button>
		<input type="file" id="MB-GalleryUpload-{~D:AppData.Moodboard.ViewID~}" accept="{~D:AppData.Moodboard.Gallery.UploadAccept~}" style="display:none" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].uploadToGallery(this.files); this.value='';">
		<button class="mb-gallery-btn" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].closeGallery()">Close</button>
	</div>
	<div class="mb-gallery-controls">
		<input class="mb-gallery-search" placeholder="{~D:AppData.Moodboard.Gallery.SearchPlaceholder~}" oninput="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].onGallerySearch(this.value)">
		{~TS:Moodboard-Gallery-Filter:AppData.Moodboard.Gallery.FilterFields~}
		<label class="mb-gallery-sortlbl">Sort
			<select class="mb-gallery-sort" onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].onGallerySort(this.value)"><option value="">none</option>{~TS:Moodboard-Gallery-Sort-Option:AppData.Moodboard.Gallery.SortFields~}</select>
		</label>
		<button class="mb-gallery-btn mb-gallery-dir" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].onGallerySortDir()">{~D:AppData.Moodboard.Gallery.SortDirLabel~}</button>
	</div>
	<div class="mb-gallery-grid" id="MB-Gallery-Grid-{~D:AppData.Moodboard.ViewID~}"></div>
</div>`
		},
		{
			Hash: 'Moodboard-Gallery-Filter',
			Template: /*html*/`<label class="mb-gallery-filter">{~D:Record.Label~}<select onchange="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].onGalleryFilter('{~D:Record.Key~}', this.value)"><option value="">All</option>{~TS:Moodboard-Gallery-Filter-Option:Record.Options~}</select></label>`
		},
		{ Hash: 'Moodboard-Gallery-Filter-Option', Template: /*html*/`<option value="{~D:Record.Value~}">{~D:Record.Value~}</option>` },
		{ Hash: 'Moodboard-Gallery-Sort-Option', Template: /*html*/`<option value="{~D:Record.Key~}">{~D:Record.Label~}</option>` },
		{
			Hash: 'Moodboard-Gallery-Grid',
			Template: /*html*/`{~TS:Moodboard-Gallery-Item:AppData.Moodboard.Gallery.Items~}{~TS:Moodboard-Gallery-Empty:AppData.Moodboard.Gallery.EmptySlot~}`
		},
		{
			Hash: 'Moodboard-Gallery-Item',
			Template: /*html*/`<button class="mb-gallery-item" title="{~D:Record.Name~}" onclick="_Pict.views['{~D:AppData.Moodboard.ViewID~}'].pickFromGallery('{~D:Record.Id~}')"><img src="{~D:Record.Thumbnail~}" alt="" draggable="false"><span class="mb-gallery-item-name">{~D:Record.Name~}</span></button>`
		},
		{ Hash: 'Moodboard-Gallery-Empty', Template: /*html*/`<div class="mb-gallery-empty">{~D:AppData.Moodboard.Gallery.EmptyMessage~}</div>` }
	],
	Renderables:
	[
		{ RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Moodboard-Container', RenderMethod: 'replace' }
	]
};

class PictViewMoodboard extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._FlowView = null;
		// A board set before the flow sub-view exists (a host can call setBoard right after render(), but
		// the flow is built later in onAfterRender) is stashed here and applied once the flow is ready.
		this._PendingBoard = null;
		this._AddCount = 0;
		// An embedding app can supply an image source (its own gallery + metadata); otherwise the
		// built-in base source keeps a base64 collection so the gallery works stand-alone.
		this._ImageSource = (pOptions && pOptions.ImageSource) ? pOptions.ImageSource : new libImageSource();
		// A host can supply its own sticker library (options.StickerSource); otherwise the built-in source
		// ships a small set of cutout shapes so stickers work stand-alone.
		this._StickerSource = (pOptions && pOptions.StickerSource) ? pOptions.StickerSource : new libStickerSource();
		// A host can supply a distinct source for the Drawing card's picker (options.DrawingSource) -- its
		// own drawings collection (for plansheet, the team's Excalidraw drawings, plus this board's gallery).
		// It uses the same source interface as ImageSource. Without one, the drawing picker falls back to the
		// image source so a stand-alone board still works.
		this._DrawingSource = (pOptions && pOptions.DrawingSource) ? pOptions.DrawingSource : null;
		// When the library picker is opened from a card's properties panel, the chosen image / sticker is
		// applied to THIS node (rather than adding a new card).
		this._PickerTargetHash = null;
		// Whether the "set view area" frame drag-handles are currently on (edit mode).
		this._FrameEditing = false;
		// A display style set before the flow sub-view exists (mirrors _PendingBoard) — applied once the
		// flow is ready. { Style, TopMargin }.
		this._PendingDisplayStyle = null;
		this._boundOnPaste = this._onPaste.bind(this);
	}

	onBeforeInitialize()
	{
		this._initState();
		return super.onBeforeInitialize();
	}

	_initState()
	{
		if (!this.pict.AppData.Moodboard)
		{
			this.pict.AppData.Moodboard =
			{
				ViewID: this.options.ViewIdentifier,
				NoteColors: _NOTE_COLORS.map((pColor) => ({ Color: pColor }))
			};
		}
		this.pict.AppData.Moodboard.ViewID = this.options.ViewIdentifier;
	}

	// Claim the shared AppData.Moodboard.ViewID BEFORE the container template parses, so this instance's
	// template IDs (MB-Root- / MB-Flow- / MB-Canvas-<ViewID>) and inline handlers resolve to THIS instance.
	// Several moodboards can be registered on one Pict (a profile banner + a vision board); whichever is
	// rendering must own the ID at parse time -- doing it only in onAfterRender is too late (the template
	// already rendered with whatever instance set the shared ViewID last, painting the wrong container).
	onBeforeRender(pRenderable)
	{
		this._initState();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		// The active (on-screen) board owns the shared AppData.Moodboard.ViewID, so its card panels and
		// background popover (which reference it) target this instance when several moodboards are
		// registered on one Pict (the Moodboard section plus per-user profile boards).
		if (this.pict.AppData.Moodboard) { this.pict.AppData.Moodboard.ViewID = this.options.ViewIdentifier; }
		this._ensureFlowView();
		// Establish the flow's presentation behavior for the current display style (canvas / jumbotron /
		// background) BEFORE the editable-vs-read-only chrome below: a presentation style reports as
		// non-editable (see _isEditable), so this must run first for the mb-readonly class + toolbar mode
		// to match.
		this._applyDisplayStyle();
		// Mark the root read-only so the CSS gives a navigation-only, collapsed-on-hover toolbar and a
		// non-editable canvas.
		let tmpRoot = document.getElementById('MB-Root-' + this.options.ViewIdentifier);
		if (tmpRoot) { if (this._isEditable()) { tmpRoot.classList.remove('mb-readonly'); } else { tmpRoot.classList.add('mb-readonly'); } }
		// Set the host's Edit / Done buttons on the flow toolbar (and, read-only, collapse it into the
		// corner). Deferred until the flow toolbar exists.
		this._setupToolbarSoon();
		if (this._isEditable())
		{
			// Clipboard paste of an image is a window-level event with no inline equivalent; wire once.
			if (!this._PasteWired)
			{
				document.addEventListener('paste', this._boundOnPaste);
				this._PasteWired = true;
			}
			// The "c" hotkey toggles connection points on the selected card(s). Window-level keydown with
			// no inline equivalent; wire once. Ignored while typing in a field or when nothing is selected.
			if (!this._ConnectKeyWired)
			{
				this._boundOnConnectKey = this._boundOnConnectKey || ((pEvent) =>
				{
					if (pEvent.key !== 'c' && pEvent.key !== 'C') { return; }
					if (pEvent.metaKey || pEvent.ctrlKey || pEvent.altKey) { return; }
					if (!this._isEditable() || !document.getElementById('MB-Root-' + this.options.ViewIdentifier)) { return; }
					let tmpFocus = document.activeElement;
					if (tmpFocus && (tmpFocus.tagName === 'INPUT' || tmpFocus.tagName === 'TEXTAREA' || tmpFocus.tagName === 'SELECT' || tmpFocus.isContentEditable)) { return; }
					if (this._selectedHashes().length === 0) { return; }
					this.toggleConnectPoints();
					pEvent.preventDefault();
				});
				document.addEventListener('keydown', this._boundOnConnectKey);
				this._ConnectKeyWired = true;
			}
		}
		else
		{
			// Read-only: re-fit the board when the window resizes so a fitted display stays fitted (window
			// resize has no inline equivalent; wire once).
			if (!this._ResizeWired)
			{
				this._boundOnResize = this._boundOnResize || (() =>
				{
					if (this._isEditable()) { return; }
					// A framed read-only board (presentation chrome, or a plain canvas with a view-area
					// frame) is width-fit, and the flow's own ResizeObserver owns re-fitting it, so the
					// moodboard does NOT contain-fit on resize (that would fight the width-fit). Only an
					// unframed read-only canvas re-fits here.
					if (this._isPresentationStyle()) { return; }
					this.fitBoard();
				});
				window.addEventListener('resize', this._boundOnResize);
				this._ResizeWired = true;
			}
			// A double-click on a card in read-only mode notifies the host (options.onCardActivate) with
			// the node hash, so an app can act on it (e.g. drop into edit and open that card's panel)
			// without the viewer itself being editable. Re-bound each render (the root is recreated).
			if (typeof this.options.onCardActivate === 'function' && tmpRoot)
			{
				this._boundOnCardActivate = this._boundOnCardActivate || ((pEvent) =>
				{
					let tmpGroup = (pEvent.target && pEvent.target.closest) ? pEvent.target.closest('[data-node-hash]') : null;
					let tmpHash = tmpGroup ? tmpGroup.getAttribute('data-node-hash') : null;
					if (tmpHash) { this.options.onCardActivate(tmpHash); }
				});
				tmpRoot.removeEventListener('dblclick', this._boundOnCardActivate);
				tmpRoot.addEventListener('dblclick', this._boundOnCardActivate);
			}
		}
		// Paint the saved board background (if any) onto the canvas (both modes).
		this._applyBackgroundSoon();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	// Fit the board into view. A read-only board whose author framed a view area fits that frame's WIDTH
	// to the container -- the configured visible area, content bleeding past the edges -- regardless of the
	// chosen chrome (a presentation style always carries a frame; a plain canvas only if one was drawn). A
	// board with no view-area frame contains every card with a little padding instead (zoomToFit pads 50px).
	// Used on load (both modes) and when a read-only board's window resizes.
	fitBoard()
	{
		if (!this._FlowView) { return; }
		// Presentation styles (jumbotron / background) fit the WIDTH of the view-area frame -- that frame IS
		// the crop the author chose. A plain canvas always fits its CONTENT (zoom to fill), even if a frame
		// was drawn, so a viewer sees the whole board zoomed in rather than the content tiny inside an unused
		// frame.
		if (!this._isEditable() && this._isPresentationStyle())
		{
			if (typeof this._FlowView.fitToWidth === 'function') { this._FlowView.fitToWidth(); return; }
		}
		// A read-only presentation that opts in (options.FitZoomIn -- e.g. a profile / vision banner framing
		// its content) lets the fit scale a small board UP to fill the banner. The editable canvas and every
		// other consumer keep the historic "never zoom in past 1.0" fit so a sparse board stays true-to-scale.
		let tmpAllowZoomIn = (this.options.FitZoomIn === true) && !this._isEditable();
		if (typeof this._FlowView.zoomToFit === 'function') { this._FlowView.zoomToFit(tmpAllowZoomIn); }
	}

	// True once a board set via setBoard has finished applying to the live flow (not still pending nor
	// mid-mount). A host reads this before capturing getBoard() on a fast open->close so it never persists a
	// not-yet-loaded (empty) board over real content.
	isBoardReady()
	{
		return !!(this._FlowView && this._FlowView.initialRenderComplete && !this._PendingBoard);
	}

	// True when this board has no content to show (no cards). Pass a loaded board object to test it
	// directly -- a host checking a just-fetched row before deciding whether to mount -- or call it with no
	// argument to test the live board. isBoardReady reports load-completion; this reports emptiness.
	isBoardEmpty(pBoard)
	{
		let tmpBoard = (typeof pBoard !== 'undefined' && pBoard !== null) ? pBoard : this.getBoard();
		return PictViewMoodboard.boardIsEmpty(tmpBoard);
	}

	// ── flow toolbar custom buttons (background + the host's Edit / Done) ──────
	// The moodboard contributes its editing controls (the display-style toggle, set-view-area, connections)
	// to the flow toolbar (editable only). The host can supply more (an Edit / Done button) via
	// options.ToolbarButtons. The board color + backdrop margin live in the flow gear (SettingsSections).
	_buildToolbarButtons(pEditable)
	{
		let tmpButtons = [];
		if (pEditable)
		{
			// One display-mode button: its icon is the CURRENT mode and it opens a dropdown of the modes
			// (icon + label). Picking one stores that style; the board itself stays the editable canvas
			// while you work, and the chosen mode shows when you view. One button scales to any number of
			// modes (the menu grows, the bar does not). The view-area frame + backdrop margin (gear) tune it.
			let tmpMode = _displayMode(this._displayStyle());
			tmpButtons.push({ Hash: 'mb-display', Icon: tmpMode.Icon, Tooltip: 'Display mode: ' + tmpMode.Label });
			// Toggles the "set view area" frame handles — the box a jumbotron / background display fits the
			// width of. Active mirrors _FrameEditing.
			tmpButtons.push({ Hash: 'mb-frame', Icon: 'frame', Toggle: true, Tooltip: 'Set the view area (the box a jumbotron / background fits)', Active: !!this._FrameEditing });
			// Toggles connection points on the selected card(s); Active is kept in sync with the selection
			// by _updateConnectButton so it reads like a checkbox for the current card.
			tmpButtons.push({ Hash: 'mb-connect', Icon: 'connect', Toggle: true, Tooltip: 'Connection points on the selected card (C)' });
		}
		else
		{
			// Read-only display: a Photoshop-style "hand" toggle. Off (default) the canvas is static and
			// the wheel scrolls the page; on, you drag to pan and wheel to zoom. Active mirrors the flow's
			// read-only navigation state.
			tmpButtons.push({ Hash: 'mb-navigate', Icon: 'pan', Toggle: true, Tooltip: 'Pan and zoom (drag to move, wheel to zoom)', Active: !!(this._FlowView && typeof this._FlowView.isReadOnlyNavigation === 'function' && this._FlowView.isReadOnlyNavigation()) });
		}
		let tmpHostButtons = Array.isArray(this.options.ToolbarButtons) ? this.options.ToolbarButtons : [];
		return tmpButtons.concat(tmpHostButtons);
	}

	// Routed from the flow's onToolbarButton hook. The style toggles set the display style, Connections
	// toggles the selection's points, Set-view-area flips the frame handles; everything else is a host
	// button, forwarded to options.onToolbarButton.
	onToolbarButton(pHash, pElement)
	{
		if (pHash === 'mb-display') { this.openDisplayMenu(pElement); return; }
		if (pHash === 'mb-connect') { this.toggleConnectPoints(); return; }
		if (pHash === 'mb-frame') { this.toggleFrameEditing(); return; }
		if (pHash === 'mb-navigate') { this.toggleNavigate(); return; }
		if (typeof this.options.onToolbarButton === 'function') { this.options.onToolbarButton(pHash, pElement); }
	}

	// The read-only "hand" toggle: flips the flow's native read-only navigation (pan + wheel-zoom). Off,
	// the wheel scrolls the page and the board is static; on, drag pans and the wheel zooms.
	toggleNavigate()
	{
		if (!this._FlowView || typeof this._FlowView.setReadOnlyNavigation !== 'function') { return; }
		this._FlowView.setReadOnlyNavigation(!this._FlowView.isReadOnlyNavigation());
		this._updateNavigateButton();
	}

	_updateNavigateButton()
	{
		if (!this._FlowView || !this._FlowView._ToolbarView) { return; }
		let tmpButtons = this._FlowView.options.ToolbarExtraButtons || [];
		let tmpButton = tmpButtons.find((pButton) => pButton.Hash === 'mb-navigate');
		if (!tmpButton) { return; }
		let tmpActive = !!(typeof this._FlowView.isReadOnlyNavigation === 'function' && this._FlowView.isReadOnlyNavigation());
		if (tmpButton.Active === tmpActive) { return; }
		tmpButton.Active = tmpActive;
		if (typeof this._FlowView._ToolbarView.render === 'function') { this._FlowView._ToolbarView.render(); }
	}

	// Push the current button set onto the flow toolbar and pick its mode for a read-only board. Deferred
	// + polled, since the flow's toolbar sub-view is created asynchronously after the flow renders.
	//
	// Read-only mode: a pure viewer (no host buttons) gets the smallest collapsed toolbar, tucked in the
	// corner and fading in on hover -- out of the way until you reach for it. The owner of the board has
	// an Edit button, so its toolbar stays docked, keeping that one action one click away. An editable
	// board is left in its default (docked) mode so the user can float / collapse it themselves.
	_setupToolbarSoon()
	{
		let tmpSelf = this;
		let tmpTries = 0;
		let fSetup = function ()
		{
			let tmpToolbar = (tmpSelf._FlowView && tmpSelf._FlowView._ToolbarView) ? tmpSelf._FlowView._ToolbarView : null;
			if (!tmpToolbar)
			{
				if (++tmpTries < 90 && typeof requestAnimationFrame === 'function') { requestAnimationFrame(fSetup); }
				return;
			}
			tmpSelf._syncToolbarButtons(tmpToolbar);
			if (!tmpSelf._isEditable() && typeof tmpToolbar._setToolbarMode === 'function')
			{
				// Read-only starts COLLAPSED: the toolbar tucks into the corner and fades in on hover (see the
				// .mb-readonly .pict-flow-toolbar-collapsed CSS), so a view-mode board is clean by default.
				if (tmpToolbar._ToolbarMode !== 'collapsed') { tmpToolbar._setToolbarMode('collapsed'); }
			}
		};
		if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(fSetup); } else { setTimeout(fSetup, 50); }
	}

	// Reconcile the flow toolbar's extra buttons with the current options (the host can change
	// ToolbarButtons per mount -- e.g. an Edit button only on a board the viewer owns). Re-renders the
	// toolbar only when the button set actually changed (by hash), so it does not reset collapsed mode.
	_syncToolbarButtons(pToolbar)
	{
		if (!this._FlowView || !pToolbar) { return; }
		let tmpButtons = this._buildToolbarButtons(this._isEditable());
		let tmpNewKey = tmpButtons.map((pButton) => pButton.Hash).join(',');
		let tmpOldKey = (pToolbar.options.ToolbarExtraButtons || []).map((pButton) => pButton.Hash).join(',');
		if (tmpNewKey === tmpOldKey) { return; }
		this._FlowView.options.ToolbarExtraButtons = tmpButtons;
		pToolbar.options.ToolbarExtraButtons = tmpButtons;
		if (pToolbar._FloatingToolbarView) { pToolbar._FloatingToolbarView.options.ToolbarExtraButtons = tmpButtons; }
		if (typeof pToolbar.render === 'function') { pToolbar.render(); }
	}

	// ── board background ───────────────────────────────────────────────────────
	// Stored on the board's ViewState so it round-trips through the flow's getFlowData / setFlowData
	// (which deep-clones and Object.assign-merges ViewState, preserving extra keys). Painted on the
	// moodboard's own .mb-canvas, so it shows under the cards on both editable and read-only boards.
	_boardBackground()
	{
		let tmpVS = (this._FlowView && this._FlowView._FlowData) ? this._FlowView._FlowData.ViewState : null;
		if (tmpVS && tmpVS.Background && tmpVS.Background.Color) { return tmpVS.Background.Color; }
		// Legacy boards stored a flat ViewState.BackgroundColor.
		if (tmpVS && tmpVS.BackgroundColor) { return tmpVS.BackgroundColor; }
		if (this._PendingBoard && this._PendingBoard.ViewState)
		{
			if (this._PendingBoard.ViewState.Background && this._PendingBoard.ViewState.Background.Color) { return this._PendingBoard.ViewState.Background.Color; }
			if (this._PendingBoard.ViewState.BackgroundColor) { return this._PendingBoard.ViewState.BackgroundColor; }
		}
		return '';
	}

	// Resolve a host THEME color token to a CONCRETE value. The flow paints the board background as an SVG
	// <rect> fill, and SVG presentation attributes do NOT resolve var(), so the board default cannot be a raw
	// var() -- it has to be read off the cascade with getComputedStyle and handed over as a literal color.
	// Reads from the board's own element so a theme scoped to a wrapper (not :root) still resolves; returns
	// the first token that has a value, else the fallback.
	_resolveThemeColor(pVars, pFallback)
	{
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') { return pFallback; }
		let tmpEl = (this._FlowView && this._FlowView._SVGElement) ? this._FlowView._SVGElement : null;
		if (!tmpEl && typeof document !== 'undefined') { tmpEl = document.getElementById('MB-Root-' + this.options.ViewIdentifier) || document.body; }
		if (!tmpEl) { return pFallback; }
		let tmpStyle = window.getComputedStyle(tmpEl);
		let tmpVars = Array.isArray(pVars) ? pVars : [pVars];
		for (let i = 0; i < tmpVars.length; i++)
		{
			let tmpValue = (tmpStyle.getPropertyValue(tmpVars[i]) || '').trim();
			if (tmpValue) { return tmpValue; }
		}
		return pFallback;
	}

	// The board canvas color when the author has not picked one: the host theme's surface color, so a board
	// follows a light / dark theme by default instead of a baked light gray.
	_defaultBoardBackground()
	{
		return this._resolveThemeColor([ '--theme-color-background-secondary', '--theme-color-background-primary' ], '#f4f6f9');
	}

	// Editing-only chrome that must never survive into a bake: the per-node grips, the crop frame and its
	// handles, and the connection ports. All of it is UI for manipulating the board, not board content.
	// (Kept as one selector so the bake and any future consumer agree on what "chrome" means.)
	get _BakeStrippedSelector()
	{
		return _BAKE_STRIPPED_SELECTOR;
	}

	// Bake a fixed crop of the board to a standalone, STATIC SVG string -- the input for a lightweight decoration
	// (a plan-sheet top-bar backdrop, say) that renders with zero flow engine and no interaction. It clones the two
	// live art layers (the nodes and their connectors) in BOARD coordinates, drops every editing-only layer (ports,
	// tethers, panels, the grid) and any selection state, and reframes the result to the crop rectangle. Image tiles
	// keep their <img>/<image> hrefs, so an INLINE copy of the returned SVG loads them like any image (a data-URI
	// background would sandbox and block those -- inline is the intended host). pCrop is { X, Y, Width, Height } in
	// board coordinates. Returns '' when there is nothing to bake. Direct DOM + XMLSerializer is the one honest way
	// to serialize an SVG subtree; this is a bake, not a render cycle, so it does not go through ContentAssignment.
	bakeCropToSVG(pCrop)
	{
		if (typeof document === 'undefined' || typeof XMLSerializer === 'undefined') { return ''; }
		let tmpSVG = (this._FlowView && this._FlowView._SVGElement) ? this._FlowView._SVGElement : null;
		if (!tmpSVG) { return ''; }
		// Default the crop to the board's own view-area FRAME -- the box the author already composes within for a
		// jumbotron / background, exposed by the flow as getFrame(). So "set the view area, then bake it" needs no
		// second coordinate system: the frame the user sees IS the crop that ships.
		let tmpSource = pCrop || (typeof this._FlowView.getFrame === 'function' ? this._FlowView.getFrame() : null);
		if (!tmpSource) { return ''; }
		let tmpCrop =
		{
			X: Number(tmpSource.X) || 0, Y: Number(tmpSource.Y) || 0,
			Width: Number(tmpSource.Width) || 0, Height: Number(tmpSource.Height) || 0
		};
		if (tmpCrop.Width <= 0 || tmpCrop.Height <= 0) { return ''; }

		let tmpNS = 'http://www.w3.org/2000/svg';
		let tmpOut = document.createElementNS(tmpNS, 'svg');
		tmpOut.setAttribute('xmlns', tmpNS);
		tmpOut.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
		tmpOut.setAttribute('viewBox', tmpCrop.X + ' ' + tmpCrop.Y + ' ' + tmpCrop.Width + ' ' + tmpCrop.Height);
		// A sensible default for a bar backdrop -- fit the composed crop, centered, so the host theme fills any gap.
		// The host is free to override preserveAspectRatio when it inlines the SVG.
		tmpOut.setAttribute('preserveAspectRatio', 'xMidYMid meet');

		// Board background: the author's picked color, or the theme default. It stays as whatever _boardBackground
		// returns -- a literal, OR a var() chain -- and because the bake is consumed INLINE, a var() still resolves
		// against the host's light/dark cascade. That is how the backdrop follows the theme for free.
		let tmpBg = this._boardBackground();
		if (tmpBg)
		{
			let tmpRect = document.createElementNS(tmpNS, 'rect');
			tmpRect.setAttribute('x', String(tmpCrop.X));
			tmpRect.setAttribute('y', String(tmpCrop.Y));
			tmpRect.setAttribute('width', String(tmpCrop.Width));
			tmpRect.setAttribute('height', String(tmpCrop.Height));
			tmpRect.setAttribute('fill', tmpBg);
			tmpOut.appendChild(tmpRect);
		}

		// Clone the connectors then the nodes (draw order), each in board coordinates. NOT the .pict-flow-viewport
		// wrapper -- its transform is the live pan/zoom, which the crop viewBox replaces.
		['pict-flow-connections-layer', 'pict-flow-nodes-layer'].forEach((pClass) =>
		{
			let tmpLayer = tmpSVG.querySelector('.' + pClass);
			if (!tmpLayer) { return; }
			let tmpClone = tmpLayer.cloneNode(true);
			if (typeof tmpClone.querySelectorAll === 'function')
			{
				tmpClone.querySelectorAll('.selected').forEach((pEl) => pEl.classList.remove('selected'));
				// Selection chrome is a tool for editing, not part of the art: a card that happened to be
				// selected when the crop was taken would otherwise bake its resize grip and rotate arm into
				// the finished picture.
				tmpClone.querySelectorAll(_BAKE_STRIPPED_SELECTOR).forEach((pEl) => pEl.remove());
				// STRIP EVERY id. cloneNode copies them, and a bake is meant to be inlined into the SAME
				// document as the live board -- which would then hold two elements per id. The flow resolves
				// its own layers by id, so the duplicates hijack those lookups and the editor starts drawing
				// into the static copy sitting in the decoration instead of onto its own canvas. Ids carry no
				// meaning in a bake (nothing scripts it, nothing links to it), so they simply go.
				tmpClone.querySelectorAll('[id]').forEach((pEl) => pEl.removeAttribute('id'));
			}
			if (typeof tmpClone.removeAttribute === 'function') { tmpClone.removeAttribute('id'); }
			tmpOut.appendChild(tmpClone);
		});

		return new XMLSerializer().serializeToString(tmpOut);
	}

	// Establish a LOCKED crop frame at a fixed aspect ratio (Width / Height) -- the "fixed crop area the author
	// arranges art within but does not set", for a decoration bake (a plan-sheet top-bar backdrop, whose aspect is
	// wide and short). Sizes the frame to the current content's width so existing art is framed, falling back to a
	// default, and centers it on the content. The host shows this as a guide -- setFrame renders the outline -- WITHOUT
	// enabling the resize handles (toggleFrameEditing), so the shape stays locked; the author composes, then a plain
	// bakeCropToSVG() bakes exactly this frame. pOptions.Width overrides the derived width. Returns the frame, or null.
	setCropFrame(pAspect, pOptions)
	{
		if (!this._FlowView || typeof this._FlowView.setFrame !== 'function') { return null; }
		let tmpAspect = Number(pAspect) || 0;
		if (tmpAspect <= 0) { return null; }
		let tmpOpts = pOptions || {};
		let tmpNodes = (this._FlowView._FlowData && Array.isArray(this._FlowView._FlowData.Nodes)) ? this._FlowView._FlowData.Nodes : [];
		let tmpBox = null;
		tmpNodes.forEach((pNode) =>
		{
			let tmpX = Number(pNode.X) || 0, tmpY = Number(pNode.Y) || 0;
			let tmpW = Number(pNode.Width) || 0, tmpH = Number(pNode.Height) || 0;
			if (!tmpBox) { tmpBox = { MinX: tmpX, MinY: tmpY, MaxX: tmpX + tmpW, MaxY: tmpY + tmpH }; return; }
			tmpBox.MinX = Math.min(tmpBox.MinX, tmpX); tmpBox.MinY = Math.min(tmpBox.MinY, tmpY);
			tmpBox.MaxX = Math.max(tmpBox.MaxX, tmpX + tmpW); tmpBox.MaxY = Math.max(tmpBox.MaxY, tmpY + tmpH);
		});
		let tmpWidth = Number(tmpOpts.Width) || (tmpBox ? (tmpBox.MaxX - tmpBox.MinX) : 0) || 900;
		let tmpHeight = tmpWidth / tmpAspect;
		let tmpCenterX = tmpBox ? ((tmpBox.MinX + tmpBox.MaxX) / 2) : (tmpWidth / 2);
		let tmpCenterY = tmpBox ? ((tmpBox.MinY + tmpBox.MaxY) / 2) : (tmpHeight / 2);
		let tmpFrame = { Enabled: true, X: tmpCenterX - tmpWidth / 2, Y: tmpCenterY - tmpHeight / 2, Width: tmpWidth, Height: tmpHeight };
		return this._FlowView.setFrame(tmpFrame);
	}

	// The board background is now native to pict-section-flow (setBackground / ViewState.Background).
	// Migrate any legacy ViewState.BackgroundColor onto the native shape, point the flow's DEFAULT (the
	// fallback when nothing is on ViewState) at the resolved theme color, then ask the flow to repaint.
	// resolveBackground prefers ViewState.Background, so an author's pick still wins; refreshed every apply,
	// so a theme switch recolors an unpainted board.
	_applyBackground()
	{
		if (!this._FlowView) { return; }
		let tmpVS = this._FlowView._FlowData ? this._FlowView._FlowData.ViewState : null;
		if (tmpVS && tmpVS.BackgroundColor && !tmpVS.Background) { tmpVS.Background = { Style: 'solid', Color: tmpVS.BackgroundColor }; }
		this._FlowView.options.Background = { Style: 'solid', Color: this._defaultBoardBackground() };
		if (typeof this._FlowView._applyBackground === 'function') { this._FlowView._applyBackground(); }
	}

	// Paint now and again after the flow settles -- a render can recreate the canvas after the immediate
	// paint, so a deferred second pass makes the background stick regardless of the host's mount timing.
	_applyBackgroundSoon()
	{
		this._applyBackground();
		let tmpSelf = this;
		if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(function () { requestAnimationFrame(function () { tmpSelf._applyBackground(); }); }); }
		else { setTimeout(function () { tmpSelf._applyBackground(); }, 32); }
	}

	// The gear Appearance control. A real color is stored on ViewState.Background (it wins over the theme
	// default); an empty string ("No background") CLEARS the stored color so the board falls back to the
	// host theme surface, rather than baking a fixed gray.
	setBackgroundColor(pColor)
	{
		if (!this._FlowView) { return; }
		let tmpVS = this._FlowView._FlowData ? this._FlowView._FlowData.ViewState : null;
		if (typeof pColor === 'string' && pColor)
		{
			if (typeof this._FlowView.setBackground === 'function') { this._FlowView.setBackground({ Style: 'solid', Color: pColor }); }
		}
		else
		{
			if (tmpVS) { delete tmpVS.Background; delete tmpVS.BackgroundColor; }
			this._applyBackground();
		}
		this._emitChange();
	}

	// A board is editable unless the host opts out with Editable:false (a read-only display: a teammate's
	// profile, a hub thumbnail). Editability is INDEPENDENT of the display style: while editing you always
	// get the free canvas (see _effectiveStyle), and the chosen jumbotron / background only takes visual
	// effect in view mode.
	_isEditable() { return this.options.Editable !== false; }

	// Toggle edit vs view (read-only) mode at runtime. Editable boards drag/resize/rotate/connect cards on
	// the free canvas; view boards render the stored display style read-only. Keeps the edit-only flow
	// flags in sync and re-renders; _applyDisplayStyle (run from onAfterRender) drives the flow ReadOnly +
	// FitMode for the resulting effective style.
	setEditable(pEditable)
	{
		this.options.Editable = (pEditable !== false);
		this.closeDisplayMenu();
		this._applyEditableToFlow();
		this.render();
		return this.options.Editable;
	}

	// Push the current options.Editable onto the flow sub-view: its read-only flag, the per-interaction
	// enables, and the toolbar's extra-button set. Does NOT re-render the moodboard -- setEditable renders
	// after calling this, and _afterBoardApplied re-applies the display style, so a repaint is the caller's
	// job. Split out so a board load can re-assert the configured mode (this view is a reused singleton
	// whose flow may still be set for a previous board) without the full re-render setEditable does.
	_applyEditableToFlow()
	{
		if (!this._FlowView) { return; }
		// Flip the flow's read-only + edit flags (a canvas board follows Editable; _applyDisplayStyle
		// re-confirms read-only for a presentation effective style after render).
		if (typeof this._FlowView.setReadOnly === 'function') { this._FlowView.setReadOnly(!this.options.Editable); }
		this._FlowView.options.EnableCardPalette = this.options.Editable;
		this._FlowView.options.EnableConnectionCreation = this.options.Editable;
		this._FlowView.options.EnableNodeDragging = this.options.Editable;
		this._FlowView.options.EnableNodeResizing = this.options.Editable;
		this._FlowView.options.EnableGridSnap = this.options.Editable;
		this._FlowView.options.EnableAlignmentGuides = this.options.Editable;
		// Swap the toolbar's extra buttons to this mode's set authoritatively, so a flow re-render does
		// not paint the previous mode's buttons before the deferred toolbar sync catches up (the
		// view -> edit transition otherwise kept showing the read-only navigate button).
		let tmpButtons = this._buildToolbarButtons(this.options.Editable);
		this._FlowView.options.ToolbarExtraButtons = tmpButtons;
		if (this._FlowView._ToolbarView)
		{
			this._FlowView._ToolbarView.options.ToolbarExtraButtons = tmpButtons;
			if (this._FlowView._ToolbarView._FloatingToolbarView) { this._FlowView._ToolbarView._FloatingToolbarView.options.ToolbarExtraButtons = tmpButtons; }
		}
	}

	// ── display style (canvas / jumbotron / background) ─────────────────────────
	// How the board presents WHEN VIEWED. 'canvas' (default) is the plain board; 'jumbotron' and
	// 'background' are width-fit presentation surfaces that fit the WIDTH of the defined view-area frame
	// to the container (content bleeds past) — a jumbotron is a hero band whose height is the frame's
	// scaled height, a background is a full-width backdrop honoring a top margin. The style + its margin
	// ride on the flow ViewState so they persist (getFlowData deep-clones ViewState; setFlowData preserves
	// extra keys, exactly like the native Frame). Editing is decoupled: while editable the board is always
	// the free canvas (you arrange + set the view area), so the style is authored, not entered.

	// The stored display style, defaulting to 'canvas'. Reads the flow ViewState, then a board / style
	// stashed before the flow existed. This is what the style toggle reflects and what view mode renders.
	_displayStyle()
	{
		let tmpVS = (this._FlowView && this._FlowView._FlowData) ? this._FlowView._FlowData.ViewState : null;
		let tmpStyle = (tmpVS && tmpVS.DisplayStyle) ? tmpVS.DisplayStyle : null;
		if (!tmpStyle && this._PendingBoard && this._PendingBoard.ViewState && this._PendingBoard.ViewState.DisplayStyle) { tmpStyle = this._PendingBoard.ViewState.DisplayStyle; }
		if (!tmpStyle && this._PendingDisplayStyle && this._PendingDisplayStyle.Style) { tmpStyle = this._PendingDisplayStyle.Style; }
		return (tmpStyle === 'jumbotron' || tmpStyle === 'background') ? tmpStyle : 'canvas';
	}

	// The style the board actually PRESENTS as: the free canvas while editing (so you can drag + frame),
	// the stored style when viewing. The stored style is left untouched while editing.
	_effectiveStyle() { return this._isEditable() ? 'canvas' : this._displayStyle(); }

	// True when the board is presenting as a width-fit surface right now (only in view mode).
	_isPresentationStyle() { let tmpStyle = this._effectiveStyle(); return tmpStyle === 'jumbotron' || tmpStyle === 'background'; }

	// True when the board carries a usable view-area frame -- the box the author framed as the visible area.
	// A read-only board with one is fit to that frame's width (the configured visible area) no matter the
	// display chrome, so "view mode respects the visible area" holds for a plain canvas too, not just a
	// jumbotron / background. Matches the existence check _ensureFrame uses (a frame needs Width + Height).
	_hasViewAreaFrame()
	{
		let tmpFrame = (this._FlowView && typeof this._FlowView.getFrame === 'function') ? this._FlowView.getFrame() : null;
		return !!(tmpFrame && tmpFrame.Width > 0 && tmpFrame.Height > 0);
	}

	// Public read of the stored display style + background top margin, for a host that sizes the board's
	// container (a jumbotron band, a background backdrop) and reacts to onDisplayStyleChanged.
	getDisplayStyle() { return this._displayStyle(); }
	getDisplayTopMargin() { return this._displayTopMargin(); }
	getEffectiveDisplayStyle() { return this._effectiveStyle(); }

	// The presentation top margin (background only): where a host's overlaying content begins. Same lookup
	// order as the style so it rides ViewState through getBoard / setBoard.
	_displayTopMargin()
	{
		let tmpVS = (this._FlowView && this._FlowView._FlowData) ? this._FlowView._FlowData.ViewState : null;
		if (tmpVS && typeof tmpVS.DisplayStyleTopMargin === 'number') { return tmpVS.DisplayStyleTopMargin; }
		if (this._PendingBoard && this._PendingBoard.ViewState && typeof this._PendingBoard.ViewState.DisplayStyleTopMargin === 'number') { return this._PendingBoard.ViewState.DisplayStyleTopMargin; }
		if (this._PendingDisplayStyle && typeof this._PendingDisplayStyle.TopMargin === 'number') { return this._PendingDisplayStyle.TopMargin; }
		return 0;
	}

	// The jumbotron band height OVERRIDE (jumbotron only; 0 = auto, i.e. the scaled view-area frame height).
	// Same lookup order as the margin so it rides ViewState through getBoard / setBoard.
	_displayHeight()
	{
		let tmpVS = (this._FlowView && this._FlowView._FlowData) ? this._FlowView._FlowData.ViewState : null;
		if (tmpVS && typeof tmpVS.DisplayStyleHeight === 'number') { return tmpVS.DisplayStyleHeight; }
		if (this._PendingBoard && this._PendingBoard.ViewState && typeof this._PendingBoard.ViewState.DisplayStyleHeight === 'number') { return this._PendingBoard.ViewState.DisplayStyleHeight; }
		return 0;
	}

	// Set (and persist) the stored display style. pOptions.TopMargin (number) sets the background margin.
	// Stores on the flow ViewState, re-applies the effective presentation, refreshes the toolbar's style
	// toggle, and emits a change so a host autosaves. While editing this just records the choice (the board
	// stays the canvas); it takes visual effect in view mode.
	setDisplayStyle(pStyle, pOptions)
	{
		let tmpStyle = (pStyle === 'jumbotron' || pStyle === 'background') ? pStyle : 'canvas';
		let tmpOptions = pOptions || {};
		if (!this._FlowView || !this._FlowView._FlowData)
		{
			// Flow not ready yet: stash and apply once it exists (see _applyDisplayStyle).
			this._PendingDisplayStyle = { Style: tmpStyle, TopMargin: (typeof tmpOptions.TopMargin === 'number') ? tmpOptions.TopMargin : undefined };
			return tmpStyle;
		}
		let tmpVS = this._FlowView._FlowData.ViewState;
		tmpVS.DisplayStyle = tmpStyle;
		if (typeof tmpOptions.TopMargin === 'number') { tmpVS.DisplayStyleTopMargin = tmpOptions.TopMargin; }
		else if (typeof tmpVS.DisplayStyleTopMargin !== 'number') { tmpVS.DisplayStyleTopMargin = 0; }
		this._PendingDisplayStyle = null;
		this._applyDisplayStyle();
		this._updateDisplayButton();
		this._emitChange();
		return tmpStyle;
	}

	// Set just the background top margin -- where overlaying content begins (the gear control). Re-applies
	// + persists.
	setDisplayMargin(pValue)
	{
		let tmpNum = parseInt(pValue, 10);
		let tmpMargin = isNaN(tmpNum) ? 0 : Math.max(0, tmpNum);
		if (this._FlowView && this._FlowView._FlowData) { this._FlowView._FlowData.ViewState.DisplayStyleTopMargin = tmpMargin; }
		else if (this._PendingDisplayStyle) { this._PendingDisplayStyle.TopMargin = tmpMargin; }
		this._applyDisplayStyle();
		this._emitChange();
		return tmpMargin;
	}

	// Set the jumbotron band height override (the gear control; 0 / blank = auto = scaled frame height).
	// Re-applies + persists, then re-emits the display style so the host re-sizes the band.
	setDisplayHeight(pValue)
	{
		let tmpNum = parseInt(pValue, 10);
		let tmpHeight = isNaN(tmpNum) ? 0 : Math.max(0, tmpNum);
		if (this._FlowView && this._FlowView._FlowData) { this._FlowView._FlowData.ViewState.DisplayStyleHeight = tmpHeight; }
		this._applyDisplayStyle();
		this._emitChange();
		return tmpHeight;
	}

	// Establish the flow sub-view's behavior for the current EFFECTIVE style. Idempotent and cheap — run
	// from onAfterRender on every render, from setDisplayStyle / setDisplayMargin, and after a board loads.
	// A presentation effective style goes read-only + width-fit (anchored at the top margin) over a view-
	// area frame with the flow's width-fit ResizeObserver; the canvas effective style restores contain-fit,
	// drops the observer, and follows Editable for read-only.
	_applyDisplayStyle()
	{
		if (!this._FlowView || !this._FlowView._FlowData) { return; }
		// Land a style stashed before the flow existed onto the (now present) ViewState.
		if (this._PendingDisplayStyle)
		{
			let tmpVSPending = this._FlowView._FlowData.ViewState;
			tmpVSPending.DisplayStyle = this._PendingDisplayStyle.Style;
			if (typeof this._PendingDisplayStyle.TopMargin === 'number') { tmpVSPending.DisplayStyleTopMargin = this._PendingDisplayStyle.TopMargin; }
			this._PendingDisplayStyle = null;
		}

		let tmpEffective = this._effectiveStyle();
		let tmpRoot = document.getElementById('MB-Root-' + this.options.ViewIdentifier);

		// The "set view area" handles are an edit-mode affordance; off whenever the board is not editable.
		if (!this._isEditable() && this._FrameEditing && typeof this._FlowView.setFrameEditing === 'function') { this._FrameEditing = false; this._FlowView.setFrameEditing(false); }

		// A presentation style (jumbotron / background) always fits a view-area frame, seeding one from the
		// content bounds if the author drew none. A plain canvas honors only a frame actually drawn. Either
		// way, a READ-ONLY board with a view-area frame becomes a width-fit presentation surface -- the
		// configured visible area -- so view mode respects it regardless of the chosen chrome.
		let tmpPresentation = (tmpEffective === 'jumbotron' || tmpEffective === 'background');
		if (tmpPresentation) { this._ensureFrame(); }
		let tmpWidthFit = !this._isEditable() && this._hasViewAreaFrame();

		if (tmpWidthFit)
		{
			// The board art is width-fit FLUSH at the top of its surface (FitTopMargin 0). The display
			// margin is NOT a board offset -- a host that overlays content on a backdrop applies it as the
			// content's top inset (where the overlaying content starts), read from onDisplayStyleChanged.
			this._FlowView.options.FitMode = 'width';
			this._FlowView.options.FitTopMargin = 0;
			if (typeof this._FlowView.setReadOnly === 'function' && !this._FlowView.isReadOnly()) { this._FlowView.setReadOnly(true); }
			if (typeof this._FlowView._setupFitObserver === 'function') { this._FlowView._setupFitObserver(); }
		}
		else
		{
			this._FlowView.options.FitMode = 'contain';
			if (typeof this._FlowView._teardownFitObserver === 'function') { this._FlowView._teardownFitObserver(); }
			let tmpReadOnly = !this._isEditable();
			if (typeof this._FlowView.setReadOnly === 'function' && this._FlowView.isReadOnly() !== tmpReadOnly) { this._FlowView.setReadOnly(tmpReadOnly); }
		}

		// Root classes reflect how the board actually displays: a width-fit framed view (presentation chrome
		// or a plain canvas honoring its view area) hides the editing chrome + the dashed guide; an editable
		// or unframed canvas keeps them. The chrome-specific classes still track the explicit style.
		if (tmpRoot)
		{
			tmpRoot.classList.toggle('mb-presentation', tmpWidthFit);
			tmpRoot.classList.toggle('mb-style-jumbotron', tmpEffective === 'jumbotron');
			tmpRoot.classList.toggle('mb-style-background', tmpEffective === 'background');
		}
		this._emitDisplayStyleChanged();
	}

	// Notify a host (options.onDisplayStyleChanged) when the effective presentation changes, so it can size
	// the board's container (a jumbotron band, a background backdrop, the plain box). Fired from
	// _applyDisplayStyle but de-duplicated, so it only fires on a real change, not every render.
	_emitDisplayStyleChanged()
	{
		let tmpEffective = this._effectiveStyle();
		let tmpMargin = this._displayTopMargin();
		// Report the RESOLVED board color (author pick, else the theme surface) so a host that paints the
		// board's own element for a behind-content backdrop can match it -- the flow's internal SVG fill does
		// not composite reliably when the board is an absolute full-bleed layer.
		let tmpBackground = this._boardBackground() || this._defaultBoardBackground();
		let tmpKey = tmpEffective + ':' + tmpMargin + ':' + tmpBackground;
		if (tmpKey === this._LastDisplayStyleKey) { return; }
		this._LastDisplayStyleKey = tmpKey;
		if (typeof this.options.onDisplayStyleChanged === 'function')
		{
			this.options.onDisplayStyleChanged(
				{
					style: this._displayStyle(),
					effectiveStyle: tmpEffective,
					editable: this._isEditable(),
					topMargin: tmpMargin,
					backgroundColor: tmpBackground,
					jumbotronHeight: this.jumbotronHeight()
				});
		}
	}

	// Point the single display-mode toolbar button's icon + tooltip at the current stored mode, and
	// re-render the toolbar only when it actually changed.
	_updateDisplayButton()
	{
		if (!this._FlowView || !this._FlowView._ToolbarView) { return; }
		let tmpButton = (this._FlowView.options.ToolbarExtraButtons || []).find((b) => b.Hash === 'mb-display');
		if (!tmpButton) { return; }
		let tmpMode = _displayMode(this._displayStyle());
		if (tmpButton.Icon === tmpMode.Icon) { return; }
		tmpButton.Icon = tmpMode.Icon;
		tmpButton.Tooltip = 'Display mode: ' + tmpMode.Label;
		if (typeof this._FlowView._ToolbarView.render === 'function')
		{
			this._FlowView._ToolbarView.render();
			if (this._FlowView._ToolbarView._FloatingToolbarView && typeof this._FlowView._ToolbarView._FloatingToolbarView.render === 'function') { this._FlowView._ToolbarView._FloatingToolbarView.render(); }
		}
	}

	// ── display-mode dropdown (one toolbar button -> a popout list of modes) ─────
	// A flow-styled dropdown (reuses the flow toolbar's own popup + list-item classes, so it matches the
	// Cards / Layout menus) anchored under the display-mode button. Each row is the mode's icon + label;
	// the current mode is marked. Picking one sets the style and closes. Scales to any number of modes.
	openDisplayMenu(pAnchor)
	{
		if (this._DisplayMenuEl) { this.closeDisplayMenu(); return; }
		if (typeof document === 'undefined') { return; }
		let tmpIcons = (this._FlowView && this._FlowView._IconProvider) ? this._FlowView._IconProvider : null;
		let tmpCurrent = this._displayStyle();
		let tmpMenu = document.createElement('div');
		tmpMenu.className = 'pict-flow-toolbar-popup mb-display-menu';
		let tmpHTML = '';
		for (let i = 0; i < _DISPLAY_MODES.length; i++)
		{
			let tmpMode = _DISPLAY_MODES[i];
			let tmpIconHTML = tmpIcons ? tmpIcons.getIconSVGMarkup(tmpMode.Icon, 16) : '';
			let tmpCurrentClass = (tmpMode.Key === tmpCurrent) ? ' mb-display-menu-current' : '';
			tmpHTML += '<div class="pict-flow-popup-list-item mb-display-menu-item' + tmpCurrentClass + '" onclick="_Pict.views[\'' + this.options.ViewIdentifier + '\'].pickDisplayStyle(\'' + tmpMode.Key + '\')">'
				+ '<span class="pict-flow-popup-list-item-icon">' + tmpIconHTML + '</span>'
				+ '<span class="pict-flow-popup-list-item-label">' + tmpMode.Label + '<span class="mb-display-menu-hint">' + tmpMode.Hint + '</span></span>'
				+ '</div>';
		}
		tmpMenu.innerHTML = tmpHTML;
		document.body.appendChild(tmpMenu);
		this._DisplayMenuEl = tmpMenu;
		// Anchor it under the button (position:fixed; the popup CSS default is absolute, overridden inline).
		tmpMenu.style.position = 'fixed';
		if (pAnchor && typeof pAnchor.getBoundingClientRect === 'function')
		{
			let tmpRect = pAnchor.getBoundingClientRect();
			let tmpViewportWidth = (typeof window !== 'undefined' && window.innerWidth) ? window.innerWidth : 1024;
			let tmpLeft = Math.max(8, Math.min(tmpRect.left, tmpViewportWidth - 252));
			tmpMenu.style.left = tmpLeft + 'px';
			tmpMenu.style.top = (tmpRect.bottom + 4) + 'px';
		}
		this._wireDisplayMenuDismiss(pAnchor);
	}

	pickDisplayStyle(pStyle)
	{
		this.closeDisplayMenu();
		this.setDisplayStyle(pStyle);
	}

	closeDisplayMenu()
	{
		if (this._DisplayMenuEl && this._DisplayMenuEl.parentNode) { this._DisplayMenuEl.parentNode.removeChild(this._DisplayMenuEl); }
		this._DisplayMenuEl = null;
		this._unwireDisplayMenuDismiss();
	}

	// Outside-click + Escape dismissal for the display-mode dropdown (window-level events with no inline
	// equivalent; torn down on close). Ignores clicks on the trigger button (its onclick toggles).
	_wireDisplayMenuDismiss(pAnchor)
	{
		if (this._DisplayMenuDismissWired) { return; }
		let tmpSelf = this;
		this._boundDisplayMenuOutside = function (pEvent)
		{
			if (tmpSelf._DisplayMenuEl && tmpSelf._DisplayMenuEl.contains(pEvent.target)) { return; }
			if (pAnchor && pEvent.target && pAnchor.contains && pAnchor.contains(pEvent.target)) { return; }
			if (pEvent.target && pEvent.target.closest && pEvent.target.closest('[data-extra-hash="mb-display"]')) { return; }
			tmpSelf.closeDisplayMenu();
		};
		this._boundDisplayMenuEsc = function (pEvent) { if (pEvent.key === 'Escape') { tmpSelf.closeDisplayMenu(); } };
		if (typeof setTimeout === 'function') { setTimeout(function () { if (tmpSelf._DisplayMenuDismissWired) { document.addEventListener('mousedown', tmpSelf._boundDisplayMenuOutside); } }, 0); }
		document.addEventListener('keydown', this._boundDisplayMenuEsc);
		this._DisplayMenuDismissWired = true;
	}

	_unwireDisplayMenuDismiss()
	{
		if (!this._DisplayMenuDismissWired) { return; }
		if (this._boundDisplayMenuOutside) { document.removeEventListener('mousedown', this._boundDisplayMenuOutside); }
		if (this._boundDisplayMenuEsc) { document.removeEventListener('keydown', this._boundDisplayMenuEsc); }
		this._DisplayMenuDismissWired = false;
	}

	// The gear "Appearance" section (rendered into the flow toolbar's native settings popup via the flow's
	// SettingsSections hook): the board canvas color, plus the backdrop top margin when the background style
	// is chosen. Built at open time so it reflects live state. No bespoke popover -- it reuses the flow's
	// own gear popup styling.
	_buildAppearanceSection()
	{
		let tmpViewID = this.options.ViewIdentifier;
		let tmpColor = this._boardBackground() || '';
		let tmpSwatches = _BACKGROUND_COLORS.map((pColor) =>
			'<button class="mb-gear-swatch" style="background:' + pColor + '" title="Board color ' + pColor + '" onclick="_Pict.views[\'' + tmpViewID + '\'].setBackgroundColor(\'' + pColor + '\')"></button>').join('');
		let tmpHTML = '<div class="mb-gear-field"><span class="mb-gear-sub">Board color</span><div class="mb-gear-swatches">'
			+ tmpSwatches
			+ '<input type="color" class="mb-gear-color" title="Pick a color" value="' + (tmpColor || this._defaultBoardBackground()) + '" onchange="_Pict.views[\'' + tmpViewID + '\'].setBackgroundColor(this.value)">'
			+ '<button class="mb-gear-swatch mb-gear-none" title="No background" onclick="_Pict.views[\'' + tmpViewID + '\'].setBackgroundColor(\'\')"></button>'
			+ '</div></div>';
		// Background: the margin sets WHERE THE OVERLAYING CONTENT BEGINS (the board art shows above it),
		// not an offset of the board art itself.
		if (this._displayStyle() === 'background')
		{
			tmpHTML += '<div class="mb-gear-field"><span class="mb-gear-sub">Content starts at (px)</span>'
				+ '<input type="number" class="mb-gear-margin" min="0" max="900" step="8" value="' + this._displayTopMargin() + '" onchange="_Pict.views[\'' + tmpViewID + '\'].setDisplayMargin(this.value)"></div>';
		}
		// Jumbotron: an explicit band height; blank / 0 = auto (the scaled view-area frame height).
		if (this._displayStyle() === 'jumbotron')
		{
			tmpHTML += '<div class="mb-gear-field"><span class="mb-gear-sub">Band height (blank = auto)</span>'
				+ '<input type="number" class="mb-gear-margin" min="0" max="900" step="10" placeholder="auto" value="' + (this._displayHeight() || '') + '" onchange="_Pict.views[\'' + tmpViewID + '\'].setDisplayHeight(this.value)"></div>';
		}
		return tmpHTML;
	}

	// ── view-area frame (the box jumbotron / background fit the WIDTH of) ─────────
	// The frame is native to pict-section-flow (ViewState.Frame); these delegate to the flow and persist
	// (the frame rides ViewState through getBoard / setBoard, and a frame drag also fires the flow's
	// onFlowChanged which the moodboard re-emits for autosave).
	setFrame(pFrame)
	{
		if (!this._FlowView || typeof this._FlowView.setFrame !== 'function') { return null; }
		let tmpFrame = this._FlowView.setFrame(pFrame);
		// A read-only framed board (presentation or a plain canvas with a view area) re-fits immediately.
		if (!this._isEditable() && this._hasViewAreaFrame()) { this.fitBoard(); }
		this._emitChange();
		return tmpFrame;
	}

	getFrame() { return (this._FlowView && typeof this._FlowView.getFrame === 'function') ? this._FlowView.getFrame() : null; }

	setFrameEditing(pEnabled)
	{
		if (!this._FlowView || typeof this._FlowView.setFrameEditing !== 'function') { return false; }
		this._FrameEditing = !!pEnabled;
		return this._FlowView.setFrameEditing(this._FrameEditing);
	}

	// Ensure a view-area frame exists, seeding one from the content bounds when the board has none. The
	// seeded frame is what a presentation style fits to (and what the "set view area" handles edit).
	_ensureFrame()
	{
		if (!this._FlowView) { return null; }
		let tmpFrame = (typeof this._FlowView.getFrame === 'function') ? this._FlowView.getFrame() : null;
		if (tmpFrame && tmpFrame.Width && tmpFrame.Height) { return tmpFrame; }
		let tmpNodes = (this._FlowView._FlowData && Array.isArray(this._FlowView._FlowData.Nodes)) ? this._FlowView._FlowData.Nodes : [];
		let tmpSeed = PictViewMoodboard.computeContentFrame(tmpNodes, 40);
		if (typeof this._FlowView.setFrame === 'function') { this._FlowView.setFrame(tmpSeed); }
		return tmpSeed;
	}

	// The "set view area" toolbar toggle (edit mode): seed a frame from the content if none exists, then
	// turn the flow's frame drag-handles on / off so the author can size the box jumbotron / background
	// fit to. The handles + the dashed frame guide only show on an editable canvas board.
	toggleFrameEditing()
	{
		if (!this._FlowView || !this._isEditable()) { return; }
		let tmpOn = !this._FrameEditing;
		if (tmpOn) { this._ensureFrame(); }
		this.setFrameEditing(tmpOn);
		this._updateFrameButton();
	}

	_updateFrameButton()
	{
		if (!this._FlowView || !this._FlowView._ToolbarView) { return; }
		let tmpButtons = this._FlowView.options.ToolbarExtraButtons || [];
		let tmpButton = tmpButtons.find((pButton) => pButton.Hash === 'mb-frame');
		if (!tmpButton) { return; }
		if (tmpButton.Active === this._FrameEditing) { return; }
		tmpButton.Active = this._FrameEditing;
		if (typeof this._FlowView._ToolbarView.render === 'function') { this._FlowView._ToolbarView.render(); }
		if (this._FlowView._ToolbarView._FloatingToolbarView && typeof this._FlowView._ToolbarView._FloatingToolbarView.render === 'function') { this._FlowView._ToolbarView._FloatingToolbarView.render(); }
	}

	// Pure: a view-area frame enclosing every node box plus a uniform padding (a sensible default box for
	// an empty board). No DOM, so it is unit tested.
	static computeContentFrame(pNodes, pPadding)
	{
		let tmpPadding = (typeof pPadding === 'number') ? pPadding : 40;
		let tmpNodes = Array.isArray(pNodes) ? pNodes : [];
		if (tmpNodes.length === 0)
		{
			return { X: 0, Y: 0, Width: 960, Height: 540, Enabled: true };
		}
		let tmpMinX = Infinity, tmpMinY = Infinity, tmpMaxX = -Infinity, tmpMaxY = -Infinity;
		for (let i = 0; i < tmpNodes.length; i++)
		{
			let tmpNode = tmpNodes[i] || {};
			let tmpX = (typeof tmpNode.X === 'number') ? tmpNode.X : 0;
			let tmpY = (typeof tmpNode.Y === 'number') ? tmpNode.Y : 0;
			let tmpW = (typeof tmpNode.Width === 'number') ? tmpNode.Width : 0;
			let tmpH = (typeof tmpNode.Height === 'number') ? tmpNode.Height : 0;
			tmpMinX = Math.min(tmpMinX, tmpX);
			tmpMinY = Math.min(tmpMinY, tmpY);
			tmpMaxX = Math.max(tmpMaxX, tmpX + tmpW);
			tmpMaxY = Math.max(tmpMaxY, tmpY + tmpH);
		}
		return {
			X: Math.round(tmpMinX - tmpPadding),
			Y: Math.round(tmpMinY - tmpPadding),
			Width: Math.round((tmpMaxX - tmpMinX) + tmpPadding * 2),
			Height: Math.round((tmpMaxY - tmpMinY) + tmpPadding * 2),
			Enabled: true
		};
	}

	// Pure: the on-screen height of a width-fit frame at a given container width (frame.Height scaled by
	// container / frame width). A host sizes a jumbotron band to this. No DOM, so it is unit tested.
	static computeScaledFrameHeight(pFrame, pContainerWidth)
	{
		if (!pFrame || !pFrame.Width || !pFrame.Height || !pContainerWidth) { return 0; }
		return Math.round(pFrame.Height * (pContainerWidth / pFrame.Width));
	}

	// Pure: true when a board carries no content -- no card nodes. ViewState (pan / zoom) is not content,
	// and a Connection joins two node ports so it cannot exist without nodes, so only Nodes decide it. A
	// host reads this to decide whether to mount the board at all: an empty board shown read-only is just
	// an empty box. Distinct from isBoardReady (load-completion). No DOM, so it is unit tested.
	static boardIsEmpty(pBoard)
	{
		if (!pBoard) { return true; }
		let tmpNodes = Array.isArray(pBoard.Nodes) ? pBoard.Nodes : [];
		return tmpNodes.length === 0;
	}

	// The current jumbotron band height for this board's container width. An explicit override (the gear
	// "Band height" control) wins; otherwise it is the scaled view-area frame height. A host reads this to
	// size a hero band; returns 0 when there is no override and no frame / canvas yet.
	jumbotronHeight()
	{
		let tmpOverride = this._displayHeight();
		if (tmpOverride > 0) { return tmpOverride; }
		let tmpFrame = this.getFrame();
		let tmpWidth = 0;
		if (this._FlowView && this._FlowView._SVGElement && typeof this._FlowView._SVGElement.getBoundingClientRect === 'function')
		{
			tmpWidth = this._FlowView._SVGElement.getBoundingClientRect().width;
		}
		return PictViewMoodboard.computeScaledFrameHeight(tmpFrame, tmpWidth);
	}

	_ensureFlowView()
	{
		let tmpID = this.options.ViewIdentifier;
		let tmpContainer = '#MB-Flow-' + tmpID;
		if (!this._FlowView)
		{
			let tmpNodeTypes = {};
			// The connector is registered with Enabled:false: it stays a known node type so older boards
			// with connector nodes still render, but it is hidden from the card palette (edges are drawn
			// between card ports now, opted in from each card's panel).
			[ new libMoodImageCard(this.fable, {}, 'Moodboard-ImageCard'), new libMoodDrawingCard(this.fable, {}, 'Moodboard-DrawingCard'), new libMoodNoteCard(this.fable, {}, 'Moodboard-NoteCard'), new libMoodTextCard(this.fable, {}, 'Moodboard-TextCard'), new libMoodStickerCard(this.fable, {}, 'Moodboard-StickerCard'), new libMoodConnectorCard(this.fable, { Enabled: false }, 'Moodboard-ConnectorCard') ].forEach((pCard) =>
			{
				let tmpConfig = pCard.getNodeTypeConfiguration();
				tmpNodeTypes[tmpConfig.Hash] = tmpConfig;
			});

			// Read-only display (Editable:false) turns off every editing interaction so a board shows as a
			// static picture (a teammate's profile, a hub thumbnail); pan + zoom stay on so a viewer can
			// look around. Editing leaves them all on.
			let tmpEditable = this._isEditable();
			this._FlowView = this.pict.addView('MB-FlowView-' + tmpID,
				{
					ViewIdentifier: 'MB-FlowView-' + tmpID,
					DefaultRenderable: 'Flow-Container',
					DefaultDestinationAddress: tmpContainer,
					AutoRender: false,
					// ONE toolbar -- the flow's own. The card palette ("Cards") is the add path (editable
					// only); delete, zoom, fit, fullscreen, dock/float, and collapse come free. Node-adding
					// (the "Node" button) and layouts stay off; the gear and layout group are hidden in CSS.
					// Flow 2.0 moodboard profile: undirected links, edge-to-edge cards (no title
					// bar), wheel pans / ctrl+wheel zooms (the scroll-too-fast fix), and a flat
					// canvas background. ReadOnly drives the flow's native non-editable mode
					// (interaction gating + chrome hiding) for display boards, replacing the old
					// mb-readonly CSS reliance.
					Profile: 'moodboard',
					ReadOnly: !tmpEditable,
					EnableToolbar: true,
					EnableCardPalette: tmpEditable,
					EnableAddNode: false,
					EnableLayoutMenu: false,
					IncludeDefaultNodeTypes: false,
					// A card opts into connection ports from its properties panel; then you drag from one
					// card's port to another's to link them. Links are undirected (any port to any port).
					EnableConnectionCreation: tmpEditable,
					EnableUndirectedConnections: true,
					EnableNodeDragging: tmpEditable,
					EnableNodeResizing: tmpEditable,
					EnablePanning: true,
					EnableZooming: true,
					EnableGridSnap: tmpEditable,
					GridSnapSize: 10,
					// Plain drag pans (a moodboard is a canvas you move around), rather than marquee-select.
					EnableMultiSelect: false,
					EnableAlignmentGuides: tmpEditable,
					NodeTitleBarHeight: 0,
					DefaultNodeType: 'MoodNote',
					NodeTypes: tmpNodeTypes,
					// Double-click a link to style it (color, width, line style, the marker at each end, a label).
					ConnectionPropertiesPanel: _CONNECTION_PANEL,
					// Host-facing toolbar buttons: the moodboard's editing controls (display-style toggle,
					// set-view-area, connections; editable only) plus whatever the host supplies (Edit /
					// Done). Clicks route through onToolbarButton below.
					ToolbarExtraButtons: this._buildToolbarButtons(tmpEditable),
					onToolbarButton: (pHash, pElement) => this.onToolbarButton(pHash, pElement),
					// The board color + backdrop margin live in the flow toolbar's own gear popup (no bespoke
					// box) via the flow's SettingsSections hook; built at open time so it reflects live state.
					SettingsSections: [ { Label: 'Appearance', Build: () => this._buildAppearanceSection() } ],
					Renderables: [ { RenderableHash: 'Flow-Container', TemplateHash: 'Flow-Container-Template', DestinationAddress: tmpContainer, RenderMethod: 'replace' } ]
				},
				libPictSectionFlow);
			// addView after the app has booted instantiates the view but does NOT run its initialize
			// lifecycle, so the flow's service managers (_DataManager / _RenderManager) and providers are
			// never wired and the board cannot paint -- it stayed empty until a second, warm visit.
			// Initialize it explicitly (pict-view guards against double-initialize).
			if (typeof this._FlowView.initialize === 'function' && !this._FlowView.initializeTimestamp)
			{
				this._FlowView.initialize();
			}
		}
		this._FlowView.initialRenderComplete = false;
		this._FlowView.render();

		// Apply a board that a host set before the flow existed (see setBoard) -- this is what makes a
		// freshly-mounted board paint its cards on the first render instead of staying empty until a
		// second visit. Deferred until the flow is render-complete.
		if (this._PendingBoard) { this._applyPendingBoard(); }

		// Keep the board to a single open editor (see _keepOnlyPanel) and strip default ports from
		// palette-added content cards (see _onNodeAdded). Wire once, after the flow's services exist.
		if (!this._PanelHandlerWired && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.registerHandler('onPanelOpened', (pPanelData) => this._keepOnlyPanel(pPanelData ? pPanelData.Hash : null));
			// Structural changes (drag, resize, add, delete) flow through onFlowChanged; re-emit them so a
			// host can autosave. Panel edits that bypass onFlowChanged call _emitChange directly.
			this._FlowView._EventHandlerProvider.registerHandler('onFlowChanged', () => this._emitChange());
			// A card added from the palette gets the flow's default in + out ports; content cards are
			// chrome-less and port-less (only a connector keeps ports), so strip them.
			this._FlowView._EventHandlerProvider.registerHandler('onNodeAdded', (pNode) => this._onNodeAdded(pNode));
			// Keep the toolbar "Connections" button in sync with whichever card is selected.
			this._FlowView._EventHandlerProvider.registerHandler('onNodeSelected', () => this._updateConnectButton());
			// Give a freshly drawn link a sensible default appearance (a thin gray line with an arrow at
			// the finish end) so it looks intentional before anyone opens its panel.
			this._FlowView._EventHandlerProvider.registerHandler('onConnectionCreated', (pConn) => this._onConnectionCreated(pConn));
			// The inline rotate handle writes node.Rotation + re-renders the card, but an already-open
			// properties panel keeps its once-rendered body, so its Rotation slider goes stale. Push the new
			// angle back into the open panel's slider so the handle and the panel stay in two-way sync.
			this._FlowView._EventHandlerProvider.registerHandler('onNodeRotated', (pNode) => this._syncPanelRotation(pNode));
			this._PanelHandlerWired = true;
		}
	}

	// Push a node's current rotation into its open properties panel slider. The flow renders a panel's body
	// once, so a rotate-handle drag (which writes node.Rotation + re-renders the card) would otherwise leave
	// the slider showing the old angle. Only one moodboard panel is open at a time (_keepOnlyPanel), so the
	// single .mbp-range is the right one.
	_syncPanelRotation(pNode)
	{
		if (typeof document === 'undefined' || !this._FlowView) { return; }
		let tmpNode = (pNode && typeof pNode === 'object') ? pNode : (typeof this._FlowView.getNode === 'function' ? this._FlowView.getNode(pNode) : null);
		if (!tmpNode) { return; }
		let tmpRoot = document.getElementById('MB-Root-' + this.options.ViewIdentifier);
		let tmpRange = tmpRoot ? tmpRoot.querySelector('.mbp-range') : null;
		if (tmpRange) { tmpRange.value = (typeof tmpNode.Rotation === 'number') ? tmpNode.Rotation : 0; }
	}

	// Strip the flow's default ports from a palette-added content card (a connector keeps its ports).
	_onNodeAdded(pNode)
	{
		if (!pNode || pNode.Type === 'MoodConnector') { return; }
		if (Array.isArray(pNode.Ports) && pNode.Ports.length)
		{
			pNode.Ports = [];
			if (this._FlowView && typeof this._FlowView.renderFlow === 'function') { this._FlowView.renderFlow(); }
		}
		// A sticker card is empty art until you pick one, and from the palette you always then want to
		// pick -- so open the picker straight away (targeting this card) instead of making the panel and
		// its "Pick a sticker" button a second and third step. Skip it when the card already carries art:
		// the gallery's own placement path (_addStickerCard) adds the node with a StickerUrl, so picking
		// from the gallery must not reopen the gallery.
		if (pNode.Type === 'MoodSticker' && pNode.Hash && !(pNode.Data && pNode.Data.StickerUrl))
		{
			this.openPickerForCard(pNode.Hash, 'sticker');
		}
		// A drawing card is empty until you pick a gallery item -- from the palette you always then want to
		// pick, so open the picker straight away (targeting this card). Skip it when the card already carries
		// a source (the gallery placement path adds the node already linked, see _addDrawingCard).
		if (pNode.Type === 'MoodDrawing' && pNode.Hash && !(pNode.Data && (pNode.Data.DrawingUrl || pNode.Data.SvgMarkup)))
		{
			this.openPickerForCard(pNode.Hash, 'drawing');
		}
	}

	// Notify a host (options.onBoardChanged) that the board changed, handing it the current board so it
	// can persist. Hosts should debounce; this can fire rapidly during a drag.
	_emitChange()
	{
		if (typeof this.options.onBoardChanged === 'function')
		{
			this.options.onBoardChanged(this.getBoard());
		}
	}

	_nextPosition()
	{
		// Cascade new cards from the upper-left of the visible canvas so several adds do not stack.
		let tmpStep = (this._AddCount % 8) * 26;
		this._AddCount++;
		let tmpVS = this._FlowView ? this._FlowView.viewState : { PanX: 0, PanY: 0, Zoom: 1 };
		return { x: (60 - tmpVS.PanX) / tmpVS.Zoom + tmpStep, y: (60 - tmpVS.PanY) / tmpVS.Zoom + tmpStep };
	}

	// A moodboard edits one card at a time. The flow lets several panels stack up (open one per
	// double-click); here we keep only the most recently opened so the board does not fill with
	// editors. Driven by the flow's onPanelOpened event so it covers both adds and double-clicks.
	_keepOnlyPanel(pKeepHash)
	{
		if (this._PanelGuard || !this._FlowView || !this._FlowView.flowData) return;
		this._PanelGuard = true;
		let tmpPanels = (this._FlowView.flowData.OpenPanels || []).slice();
		tmpPanels.forEach((pPanel) => { if (pPanel.Hash !== pKeepHash) { this._FlowView.closePanel(pPanel.Hash); } });
		this._PanelGuard = false;
	}

	setConnectorLabel(pNodeHash, pValue)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		tmpNode.Data.Label = pValue;
		let tmpEl = this._cardElement(pNodeHash, '.mb-connector');
		if (tmpEl) { tmpEl.textContent = pValue; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// ---- Adding image cards (drag-and-drop + paste; the palette adds empty cards you fill in a panel) ----

	addImage(pUrl, pMeta)
	{
		if (!this._FlowView || !pUrl) return;
		let tmpMeta = pMeta || {};
		// Register the image with the source so the gallery can show and reuse it (deduped by URL).
		if (this._ImageSource && typeof this._ImageSource.add === 'function')
		{
			this._ImageSource.add(
				{
					Url: pUrl,
					Name: tmpMeta.Name || this._urlName(pUrl),
					Metadata: { Type: tmpMeta.Type || 'image', SizeBytes: tmpMeta.SizeBytes || 0, AddedAt: tmpMeta.AddedAt || Date.now() }
				});
		}
		let tmpPos = this._nextPosition();
		let tmpNode = this._FlowView.addNode('MoodImage', tmpPos.x, tmpPos.y, '', { ImageUrl: pUrl, Fit: 'cover' });
		if (tmpNode)
		{
			tmpNode.Ports = []; // addNode defaults to one In + one Out; a moodboard content card has neither
			this._FlowView.selectNode(tmpNode.Hash);
			this._FlowView.renderFlow();
			this._FlowView.marshalFromView();
			this._sizeCardToImage(tmpNode.Hash, pUrl);
		}
		if (this._galleryState().Open) { this._refreshGalleryGrid(); }
	}

	_urlName(pUrl)
	{
		if (!pUrl) return 'image';
		if (pUrl.indexOf('data:') === 0) return 'pasted image';
		let tmpClean = pUrl.split('?')[0].split('#')[0];
		let tmpName = tmpClean.substring(tmpClean.lastIndexOf('/') + 1);
		return tmpName || pUrl;
	}

	addImageFiles(pFileList)
	{
		if (!pFileList) return;
		let tmpFiles = Array.prototype.slice.call(pFileList).filter((pFile) => pFile && pFile.type && pFile.type.indexOf('image/') === 0);
		tmpFiles.forEach((pFile) => this._readFileAsImage(pFile));
	}

	_readFileAsImage(pFile)
	{
		let tmpSelf = this;
		let tmpReader = new FileReader();
		tmpReader.onload = function (pEvent)
		{
			let tmpMeta = { Name: pFile.name, Type: pFile.type || 'image', SizeBytes: pFile.size || 0, AddedAt: Date.now() };
			// A host with an upload hook stores the bytes and hands back a reference; otherwise the
			// base64 data URL goes straight onto the board (and into the built-in source).
			if (tmpSelf._ImageSource && typeof tmpSelf._ImageSource.upload === 'function')
			{
				tmpSelf._ImageSource.upload(pFile, pEvent.target.result, function (pErr, pRef)
				{
					tmpSelf.addImage((pRef && pRef.Url) ? pRef.Url : pEvent.target.result, tmpMeta);
				});
			}
			else
			{
				tmpSelf.addImage(pEvent.target.result, tmpMeta);
			}
		};
		tmpReader.readAsDataURL(pFile);
	}

	// ---- Editing (called from each card's on-graph properties panel) ----
	// The panels carry the real editor (a textarea plus parameters: font size, note color, image fit
	// and URL, a library picker). The card body is a read-only display. These setters write the node
	// data and update the already-rendered card in place. They deliberately do NOT call renderFlow,
	// because a full re-render would also re-render the open panel and drop the textarea's focus
	// mid-keystroke; marshalFromView keeps the persisted board in sync without touching the DOM the user
	// is typing into.

	_cardElement(pNodeHash, pSelector)
	{
		let tmpGroup = document.querySelector('#MB-Flow-' + this.options.ViewIdentifier + ' [data-node-hash="' + pNodeHash + '"]');
		return tmpGroup ? tmpGroup.querySelector(pSelector) : null;
	}

	editText(pNodeHash, pText)
	{
		if (!this._FlowView) return;
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;
		if (!tmpNode.Data) tmpNode.Data = {};
		tmpNode.Data.Text = pText;
		let tmpField = this._cardElement(pNodeHash, '.mb-note, .mb-text');
		if (tmpField) { tmpField.textContent = pText; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	setFontSize(pNodeHash, pValue)
	{
		if (!this._FlowView) return;
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;
		if (!tmpNode.Data) tmpNode.Data = {};
		let tmpNum = parseInt(pValue, 10);
		if (pValue && !isNaN(tmpNum) && tmpNum > 0)
		{
			tmpNode.Data.FontSize = tmpNum;
			tmpNode.Data.FontSizeCss = tmpNum + 'px';
		}
		else
		{
			// Empty / "Auto" clears the fixed size so the type scales with the card box again.
			tmpNode.Data.FontSize = null;
			tmpNode.Data.FontSizeCss = '';
		}
		let tmpField = this._cardElement(pNodeHash, '.mb-note, .mb-text');
		if (tmpField) { tmpField.style.fontSize = tmpNode.Data.FontSizeCss; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// Curated font controls on note + text cards: family (from _FONT_FAMILIES), weight, and text color.
	// Each stores its value on the node Data and updates the live card element so the change feels
	// immediate, then marshals + emits for autosave (mirrors setNoteColor / setFontSize).
	setFontFamily(pNodeHash, pKey)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		let tmpKey = (typeof pKey === 'string') ? pKey : '';
		let tmpStack = _FONT_FAMILIES[tmpKey] || '';
		tmpNode.Data.FontFamily = tmpKey;
		tmpNode.Data.FontFamilyCss = tmpStack;
		let tmpField = this._cardElement(pNodeHash, '.mb-note, .mb-text');
		if (tmpField) { tmpField.style.fontFamily = tmpStack; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	setFontWeight(pNodeHash, pValue)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		let tmpWeight = parseInt(pValue, 10);
		tmpNode.Data.FontWeight = (pValue && !isNaN(tmpWeight)) ? tmpWeight : '';
		let tmpField = this._cardElement(pNodeHash, '.mb-note, .mb-text');
		if (tmpField) { tmpField.style.fontWeight = tmpNode.Data.FontWeight === '' ? '' : String(tmpNode.Data.FontWeight); }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	setTextColor(pNodeHash, pColor)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		tmpNode.Data.TextColor = (typeof pColor === 'string') ? pColor : '';
		let tmpField = this._cardElement(pNodeHash, '.mb-note, .mb-text');
		if (tmpField) { tmpField.style.color = tmpNode.Data.TextColor; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	setNoteColor(pNodeHash, pColor)
	{
		if (!this._FlowView || !pColor) return;
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;
		if (!tmpNode.Data) tmpNode.Data = {};
		tmpNode.Data.Color = pColor;
		tmpNode.Style = { BodyFill: pColor, TitleBarColor: pColor };
		let tmpBody = this._cardElement(pNodeHash, '.pict-flow-node-body');
		if (tmpBody) { tmpBody.style.fill = pColor; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	setFit(pNodeHash, pFit)
	{
		if (!this._FlowView) return;
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;
		if (!tmpNode.Data) tmpNode.Data = {};
		tmpNode.Data.Fit = (pFit === 'contain') ? 'contain' : 'cover';
		let tmpImg = this._cardElement(pNodeHash, '.mb-image');
		if (tmpImg) { tmpImg.className = 'mb-image mb-image-' + tmpNode.Data.Fit; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	setImageUrl(pNodeHash, pUrl)
	{
		if (!this._FlowView) return;
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;
		if (!tmpNode.Data) tmpNode.Data = {};
		tmpNode.Data.ImageUrl = pUrl;
		// A card picked or uploaded into may never have had a Fit set, and .mb-image carries no default
		// object-fit, so the picture used to stretch to the box. Default it to cover and size the tile
		// to the photo's own shape.
		if (!tmpNode.Data.Fit) { tmpNode.Data.Fit = 'cover'; }
		let tmpImg = this._cardElement(pNodeHash, '.mb-image');
		if (tmpImg) { tmpImg.setAttribute('src', pUrl || ''); tmpImg.className = 'mb-image mb-image-' + tmpNode.Data.Fit; }
		this._sizeCardToImage(pNodeHash, pUrl);
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// Resize an image card to its picture's natural aspect ratio so the photo is not squished into the
	// fixed default box. Loads the image off-screen to read its dimensions, then (only for a card still
	// at the image default footprint, so a tile the user has deliberately sized keeps its shape) sets
	// Width/Height to the same aspect with the long side at a sensible size, and re-renders.
	_sizeCardToImage(pNodeHash, pUrl)
	{
		if (typeof Image === 'undefined' || !pUrl) { return; }
		let tmpSelf = this;
		let tmpProbe = new Image();
		tmpProbe.onload = function ()
		{
			let tmpNaturalW = tmpProbe.naturalWidth, tmpNaturalH = tmpProbe.naturalHeight;
			if (!tmpNaturalW || !tmpNaturalH || !tmpSelf._FlowView) { return; }
			let tmpNode = tmpSelf._FlowView.getNode(pNodeHash);
			if (!tmpNode) { return; }
			// Only auto-fit a card still at the MoodImage default (240x200); respect a resized tile.
			if (Number(tmpNode.Width) !== 240 || Number(tmpNode.Height) !== 200) { return; }
			let tmpLong = 280;
			if (tmpNaturalW >= tmpNaturalH)
			{
				tmpNode.Width = tmpLong;
				tmpNode.Height = Math.max(80, Math.round(tmpLong * tmpNaturalH / tmpNaturalW));
			}
			else
			{
				tmpNode.Height = tmpLong;
				tmpNode.Width = Math.max(80, Math.round(tmpLong * tmpNaturalW / tmpNaturalH));
			}
			if (typeof tmpSelf._FlowView.renderFlow === 'function') { tmpSelf._FlowView.renderFlow(); }
			tmpSelf._FlowView.marshalFromView();
			tmpSelf._emitChange();
		};
		tmpProbe.src = pUrl;
	}

	// ---- Drawing cards (a gallery image / drawing, linked to its source, rendered into the board SVG) ----

	// Link a drawing card to a gallery item and paint it. Stores the source id (so it can be refreshed),
	// renders it as a native <image> straight away, and -- when the source is an SVG -- kicks off a fetch
	// that replaces the <image> with the inlined vector (see _loadInlineSvg) so it projects into the SVG.
	setDrawingSource(pNodeHash, pItem)
	{
		if (!this._FlowView || !pItem) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		let tmpUrl = pItem.Url || '';
		tmpNode.Data.SourceId = (typeof pItem.Id !== 'undefined') ? pItem.Id : null;
		tmpNode.Data.SourceName = pItem.Name || this._urlName(tmpUrl);
		tmpNode.Data.DrawingUrl = tmpUrl;
		tmpNode.Data.IsSvg = this._looksLikeSvg(pItem);
		// A freshly linked source starts without inlined vector; if it is an SVG, _loadInlineSvg fills it in.
		tmpNode.Data.SvgMarkup = '';
		tmpNode.Data.SvgViewBox = '';
		tmpNode.Data.Rev = 0;
		// A drawing (a diagram) usually wants to show whole, so default Fit to contain the first time.
		if (tmpNode.Data.Fit !== 'cover' && tmpNode.Data.Fit !== 'contain') { tmpNode.Data.Fit = 'contain'; }
		this._stampDrawingFlags(tmpNode);
		this._sizeCardToDrawing(pNodeHash, tmpUrl);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();
		this._emitChange();
		if (tmpNode.Data.IsSvg) { this._loadInlineSvg(pNodeHash, tmpUrl, 0); }
	}

	// Re-pull the linked source (a re-saved drawing, a replaced blob). Bumps a revision so the browser
	// re-loads, re-fetches the vector for an SVG, and (if the source exposes getItem) refreshes the URL /
	// name too. With nothing linked yet, this is the "pick a source" affordance.
	refreshDrawing(pNodeHash)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode || !tmpNode.Data) { return; }
		let tmpData = tmpNode.Data;
		if ((tmpData.SourceId == null || tmpData.SourceId === '') && !tmpData.DrawingUrl)
		{
			this.openPickerForCard(pNodeHash, 'drawing');
			return;
		}
		let tmpSelf = this;
		let tmpRev = ((typeof tmpData.Rev === 'number') ? tmpData.Rev : 0) + 1;
		let fApply = function (pItem)
		{
			let tmpNodeNow = tmpSelf._FlowView ? tmpSelf._FlowView.getNode(pNodeHash) : null;
			if (!tmpNodeNow || !tmpNodeNow.Data) { return; }
			let tmpDataNow = tmpNodeNow.Data;
			if (pItem)
			{
				if (pItem.Url) { tmpDataNow.DrawingUrl = pItem.Url; }
				if (pItem.Name) { tmpDataNow.SourceName = pItem.Name; }
				if (tmpSelf._looksLikeSvg(pItem)) { tmpDataNow.IsSvg = true; }
			}
			tmpDataNow.Rev = tmpRev;
			// Drop the stale inline so the card re-renders as <image>, then re-inline if the source is SVG.
			tmpDataNow.SvgMarkup = '';
			tmpDataNow.SvgViewBox = '';
			tmpSelf._stampDrawingFlags(tmpNodeNow);
			tmpSelf._FlowView.renderFlow();
			tmpSelf._FlowView.marshalFromView();
			tmpSelf._emitChange();
			if (tmpDataNow.IsSvg) { tmpSelf._loadInlineSvg(pNodeHash, tmpDataNow.DrawingUrl, tmpRev); }
			tmpSelf._toast('Updated from source');
		};
		let tmpSource = this._DrawingSource || this._ImageSource;
		if (tmpSource && typeof tmpSource.getItem === 'function' && tmpData.SourceId != null && tmpData.SourceId !== '')
		{
			Promise.resolve(tmpSource.getItem(tmpData.SourceId)).then(function (pItem) { fApply(pItem || null); }).catch(function () { fApply(null); });
		}
		else { fApply(null); }
	}

	// Cover / contain for a drawing card. Updates the rendered element's preserveAspectRatio in place (the
	// SVG body reads Fit at render time) without a full re-render, then persists.
	setDrawingFit(pNodeHash, pFit)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		tmpNode.Data.Fit = (pFit === 'cover') ? 'cover' : 'contain';
		this._stampDrawingFlags(tmpNode);
		let tmpEl = this._cardElement(pNodeHash, '.mb-drawing');
		if (tmpEl) { tmpEl.setAttribute('preserveAspectRatio', (tmpNode.Data.Fit === 'cover') ? 'xMidYMid slice' : 'xMidYMid meet'); }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// Stand-alone placement (no target card): add a drawing card already linked to a gallery item. The node
	// is seeded with the source URL so the palette's onNodeAdded (see _onNodeAdded) does not re-open the
	// picker on top of it; setDrawingSource then fills in the rest (id, name, SVG inline, sizing).
	_addDrawingCard(pItem)
	{
		if (!this._FlowView || !pItem) { return; }
		let tmpPos = this._nextPosition();
		let tmpNode = this._FlowView.addNode('MoodDrawing', tmpPos.x, tmpPos.y, '', { DrawingUrl: (pItem.Url || '') });
		if (tmpNode)
		{
			tmpNode.Ports = [];
			this._FlowView.selectNode(tmpNode.Hash);
			this._FlowView.renderFlow();
			this._FlowView.marshalFromView();
			this.setDrawingSource(tmpNode.Hash, pItem);
		}
		if (this._galleryState().Open) { this._refreshGalleryGrid(); }
	}

	// Panel state stamped onto node Data (persisted, like the connect-mode selects): the Fit select's
	// current option and whether the "linked source" block shows.
	_stampDrawingFlags(pNode)
	{
		if (!pNode || !pNode.Data) { return; }
		let tmpData = pNode.Data;
		let tmpFit = (tmpData.Fit === 'cover') ? 'cover' : 'contain';
		tmpData.FitContainSel = (tmpFit === 'contain') ? 'selected' : '';
		tmpData.FitCoverSel = (tmpFit === 'cover') ? 'selected' : '';
		tmpData._SourceShow = (((tmpData.SourceId != null) && (tmpData.SourceId !== '')) || tmpData.DrawingUrl) ? 'mbp-show' : '';
	}

	// Is this gallery item an SVG (so it should be inlined as vector)? Reads the source's mime, the file
	// name / original name, and the URL (a data: URL or a .svg path).
	_looksLikeSvg(pItem)
	{
		if (!pItem) { return false; }
		let tmpMeta = pItem.Metadata || {};
		let tmpMime = String(tmpMeta.MimeType || tmpMeta.Mime || '').toLowerCase();
		if (tmpMime.indexOf('svg') >= 0) { return true; }
		let fEndsSvg = function (pStr) { let tmpS = String(pStr || '').toLowerCase().split('?')[0].split('#')[0]; return (tmpS.length >= 4) && (tmpS.slice(-4) === '.svg'); };
		if (fEndsSvg(pItem.Name) || fEndsSvg(tmpMeta.OriginalFileName)) { return true; }
		let tmpUrl = String(pItem.Url || '').toLowerCase();
		if (tmpUrl.indexOf('data:image/svg') === 0) { return true; }
		if (fEndsSvg(tmpUrl)) { return true; }
		return false;
	}

	// Fetch an SVG source and inline its (sanitized) vector onto the card so it projects into the board's
	// SVG. Guards against a superseding refresh (rev mismatch); on any failure the <image> fallback stays.
	_loadInlineSvg(pNodeHash, pUrl, pRev)
	{
		if (typeof fetch === 'undefined' || !pUrl) { return; }
		let tmpSelf = this;
		let tmpFetchUrl = pUrl;
		if (pRev && pUrl.indexOf('data:') !== 0) { tmpFetchUrl = pUrl + ((pUrl.indexOf('?') >= 0) ? '&' : '?') + '_r=' + pRev; }
		let tmpPromise;
		try { tmpPromise = fetch(tmpFetchUrl, { credentials: 'same-origin' }); }
		catch (pErr) { return; }
		Promise.resolve(tmpPromise)
			.then(function (pResponse) { if (!pResponse || !pResponse.ok) { throw new Error('http ' + (pResponse ? pResponse.status : '?')); } return pResponse.text(); })
			.then(function (pText)
			{
				let tmpNode = (tmpSelf._FlowView && typeof tmpSelf._FlowView.getNode === 'function') ? tmpSelf._FlowView.getNode(pNodeHash) : null;
				if (!tmpNode || !tmpNode.Data) { return; }
				// A newer refresh may have superseded this fetch; only apply if the revision still matches.
				let tmpCurrentRev = (typeof tmpNode.Data.Rev === 'number') ? tmpNode.Data.Rev : 0;
				if ((pRev || 0) !== tmpCurrentRev) { return; }
				let tmpPrepared = tmpSelf._prepareSvg(pText, pNodeHash);
				if (!tmpPrepared || !tmpPrepared.Inner) { return; }
				tmpNode.Data.SvgMarkup = tmpPrepared.Inner;
				tmpNode.Data.SvgViewBox = tmpPrepared.ViewBox || '';
				if (typeof tmpSelf._FlowView.renderFlow === 'function') { tmpSelf._FlowView.renderFlow(); }
				tmpSelf._FlowView.marshalFromView();
				tmpSelf._emitChange();
			})
			.catch(function () { /* keep the <image> fallback already on the card */ });
	}

	// Parse, sanitize, and id-namespace an SVG document, returning its inner markup + viewBox for inlining.
	// Sanitize drops scripts / foreignObjects and strips event handlers + external references; namespacing
	// prefixes every id (and its url(#..) / href="#.." references) so two inlined drawings never collide.
	_prepareSvg(pText, pNodeHash)
	{
		if (!pText || typeof DOMParser === 'undefined') { return null; }
		if (pText.length > 524288) { return null; }
		let tmpDoc;
		try { tmpDoc = new DOMParser().parseFromString(pText, 'image/svg+xml'); }
		catch (pErr) { return null; }
		if (!tmpDoc || (tmpDoc.getElementsByTagName('parsererror').length > 0)) { return null; }
		let tmpSvg = tmpDoc.documentElement;
		if (!tmpSvg || String(tmpSvg.nodeName).toLowerCase() !== 'svg') { return null; }

		let tmpAll = tmpSvg.getElementsByTagName('*');
		let tmpRemove = [];
		for (let i = 0; i < tmpAll.length; i++)
		{
			let tmpEl = tmpAll[i];
			let tmpTag = String(tmpEl.nodeName).toLowerCase();
			if (tmpTag === 'script' || tmpTag === 'foreignobject') { tmpRemove.push(tmpEl); continue; }
			let tmpAttrs = Array.prototype.slice.call(tmpEl.attributes || []);
			for (let a = 0; a < tmpAttrs.length; a++)
			{
				let tmpName = tmpAttrs[a].name;
				let tmpLower = tmpName.toLowerCase();
				let tmpVal = tmpAttrs[a].value;
				if (tmpLower.indexOf('on') === 0) { tmpEl.removeAttribute(tmpName); continue; }
				if ((tmpLower === 'href' || tmpLower === 'xlink:href') && tmpVal && tmpVal.charAt(0) !== '#' && tmpVal.indexOf('data:') !== 0)
				{
					tmpEl.removeAttribute(tmpName);
				}
			}
		}
		for (let r = 0; r < tmpRemove.length; r++) { if (tmpRemove[r].parentNode) { tmpRemove[r].parentNode.removeChild(tmpRemove[r]); } }

		let tmpPrefix = 'mbd' + String(pNodeHash || '').replace(/[^a-zA-Z0-9]/g, '') + '-';
		let tmpIdNodes = tmpSvg.querySelectorAll('[id]');
		let tmpIdMap = {};
		let tmpKeys = [];
		for (let n = 0; n < tmpIdNodes.length; n++)
		{
			let tmpOld = tmpIdNodes[n].getAttribute('id');
			if (!tmpOld || tmpIdMap[tmpOld]) { continue; }
			tmpIdMap[tmpOld] = tmpPrefix + tmpOld;
			tmpKeys.push(tmpOld);
			tmpIdNodes[n].setAttribute('id', tmpIdMap[tmpOld]);
		}
		if (tmpKeys.length)
		{
			let tmpRefNodes = tmpSvg.getElementsByTagName('*');
			for (let m = 0; m < tmpRefNodes.length; m++)
			{
				let tmpEl = tmpRefNodes[m];
				let tmpAttrs = Array.prototype.slice.call(tmpEl.attributes || []);
				for (let a = 0; a < tmpAttrs.length; a++)
				{
					let tmpName = tmpAttrs[a].name;
					let tmpLower = tmpName.toLowerCase();
					let tmpVal = tmpAttrs[a].value;
					if (!tmpVal) { continue; }
					let tmpNew = tmpVal;
					for (let k = 0; k < tmpKeys.length; k++)
					{
						let tmpOld = tmpKeys[k];
						let tmpTo = tmpIdMap[tmpOld];
						tmpNew = tmpNew.split('url(#' + tmpOld + ')').join('url(#' + tmpTo + ')');
						tmpNew = tmpNew.split("url('#" + tmpOld + "')").join("url('#" + tmpTo + "')");
						tmpNew = tmpNew.split('url("#' + tmpOld + '")').join('url("#' + tmpTo + '")');
						if ((tmpLower === 'href' || tmpLower === 'xlink:href') && (tmpVal === '#' + tmpOld)) { tmpNew = '#' + tmpTo; }
					}
					if (tmpNew !== tmpVal) { tmpEl.setAttribute(tmpName, tmpNew); }
				}
			}
		}

		let tmpViewBox = tmpSvg.getAttribute('viewBox') || '';
		if (!tmpViewBox)
		{
			let tmpW = parseFloat(tmpSvg.getAttribute('width'));
			let tmpH = parseFloat(tmpSvg.getAttribute('height'));
			if (tmpW > 0 && tmpH > 0) { tmpViewBox = '0 0 ' + tmpW + ' ' + tmpH; }
		}

		let tmpInner = '';
		try
		{
			let tmpSerializer = new XMLSerializer();
			for (let c = 0; c < tmpSvg.childNodes.length; c++) { tmpInner += tmpSerializer.serializeToString(tmpSvg.childNodes[c]); }
		}
		catch (pErr) { return null; }
		if (!tmpInner || tmpInner.length > 262144) { return null; }
		return { Inner: tmpInner, ViewBox: tmpViewBox };
	}

	// Resize a drawing card to its source's natural aspect (mirrors _sizeCardToImage; drawing default box).
	_sizeCardToDrawing(pNodeHash, pUrl)
	{
		if (typeof Image === 'undefined' || !pUrl) { return; }
		let tmpSelf = this;
		let tmpProbe = new Image();
		tmpProbe.onload = function ()
		{
			let tmpNaturalW = tmpProbe.naturalWidth, tmpNaturalH = tmpProbe.naturalHeight;
			if (!tmpNaturalW || !tmpNaturalH || !tmpSelf._FlowView) { return; }
			let tmpNode = tmpSelf._FlowView.getNode(pNodeHash);
			if (!tmpNode) { return; }
			// Only auto-fit a card still at the MoodDrawing default (260x200); respect a resized tile.
			if (Number(tmpNode.Width) !== 260 || Number(tmpNode.Height) !== 200) { return; }
			let tmpLong = 300;
			if (tmpNaturalW >= tmpNaturalH)
			{
				tmpNode.Width = tmpLong;
				tmpNode.Height = Math.max(80, Math.round(tmpLong * tmpNaturalH / tmpNaturalW));
			}
			else
			{
				tmpNode.Height = tmpLong;
				tmpNode.Width = Math.max(80, Math.round(tmpLong * tmpNaturalW / tmpNaturalH));
			}
			if (typeof tmpSelf._FlowView.renderFlow === 'function') { tmpSelf._FlowView.renderFlow(); }
			tmpSelf._FlowView.marshalFromView();
			tmpSelf._emitChange();
		};
		tmpProbe.src = pUrl;
	}

	setStickerUrl(pNodeHash, pUrl, pMeta)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		tmpNode.Data.StickerUrl = pUrl;
		// Picking a library shape carries its identity + colors so the panel can offer color overrides.
		if (pMeta) { this._stampStickerMeta(tmpNode, pMeta); }
		let tmpImg = this._cardElement(pNodeHash, '.mb-sticker');
		if (tmpImg) { tmpImg.setAttribute('src', pUrl || ''); }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// Carry a picked shape's identity + colors onto the node so its panel can offer color overrides. A
	// non-shape sticker (upload / built-in) gets no shape fields, so its color controls stay hidden.
	_stampStickerMeta(pNode, pMeta)
	{
		if (pNode && pNode.Data && pMeta && typeof pMeta.ShapeCollection === 'string' && pMeta.ShapeCollection)
		{
			pNode.Data.ShapeCollection = pMeta.ShapeCollection;
			pNode.Data.ShapeName = pMeta.ShapeName || '';
			pNode.Data.Duotone = !!pMeta.Duotone;
			if (typeof pNode.Data.ColorPrimary !== 'string' || !pNode.Data.ColorPrimary) { pNode.Data.ColorPrimary = pMeta.ColorPrimary || '#1f3a52'; }
			if (typeof pNode.Data.ColorSecondary !== 'string' || !pNode.Data.ColorSecondary) { pNode.Data.ColorSecondary = pMeta.ColorSecondary || '#9cc0e0'; }
		}
		this._stampStickerColorFlags(pNode);
	}

	// The panel reads these as show-classes (default hidden, so a non-shape or legacy sticker shows no
	// color controls): the whole color row appears only for a library shape; the second (silhouette) color
	// only for a duotone shape.
	_stampStickerColorFlags(pNode)
	{
		if (!pNode || !pNode.Data) { return; }
		pNode.Data._ColorShow = pNode.Data.ShapeCollection ? 'mbp-show' : '';
		pNode.Data._SecColorShow = (pNode.Data.ShapeCollection && pNode.Data.Duotone) ? 'mbp-show' : '';
	}

	// Override a placed library-shape sticker's color(s). Rebuilds the recolored URL through the sticker
	// source (which owns the shape-library URL convention) and swaps the card image in place.
	setStickerColor(pNodeHash, pSlot, pColor)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode || !tmpNode.Data || !tmpNode.Data.ShapeCollection) { return; }
		if (pSlot === 'sec') { tmpNode.Data.ColorSecondary = pColor; }
		else { tmpNode.Data.ColorPrimary = pColor; }
		let tmpUrl = (this._StickerSource && typeof this._StickerSource.recolorURL === 'function')
			? this._StickerSource.recolorURL(tmpNode.Data.ShapeCollection, tmpNode.Data.ShapeName, { pri: tmpNode.Data.ColorPrimary, sec: tmpNode.Data.ColorSecondary })
			: tmpNode.Data.StickerUrl;
		if (tmpUrl) { tmpNode.Data.StickerUrl = tmpUrl; }
		let tmpImg = this._cardElement(pNodeHash, '.mb-sticker');
		if (tmpImg) { tmpImg.setAttribute('src', tmpNode.Data.StickerUrl || ''); }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// Rotation is a node-level property (the flow renderer rotates the whole card group about its
	// center). Update the group's transform in place so the slider feels live without a re-render.
	setRotation(pNodeHash, pValue)
	{
		if (!this._FlowView) return;
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;
		let tmpDeg = parseInt(pValue, 10);
		tmpNode.Rotation = isNaN(tmpDeg) ? 0 : tmpDeg;
		let tmpGroup = document.querySelector('#MB-Flow-' + this.options.ViewIdentifier + ' [data-node-hash="' + pNodeHash + '"]');
		if (tmpGroup)
		{
			let tmpW = (typeof tmpNode.Width === 'number') ? tmpNode.Width : 200;
			let tmpH = (typeof tmpNode.Height === 'number') ? tmpNode.Height : 160;
			let tmpTransform = 'translate(' + tmpNode.X + ', ' + tmpNode.Y + ')';
			if (tmpNode.Rotation) { tmpTransform += ' rotate(' + tmpNode.Rotation + ' ' + (tmpW / 2) + ' ' + (tmpH / 2) + ')'; }
			tmpGroup.setAttribute('transform', tmpTransform);
		}
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// A card's connection points have three states (set from its panel or, on/off, from the toolbar
	// button + the "c" hotkey): 'off' (no anchors), 'edit' (twelve anchors shown while editing -- the
	// default), and 'always' (anchors shown to viewers too, via the node's NodeClass). When on, the card
	// shows twelve dots you drag between to link cards. Turning it off drops the anchors and any links
	// that used them. The Data.Connect*Sel strings are what the panel <select> binds its current option
	// to, so reopening the panel reflects the state.
	setConnectMode(pNodeHash, pMode)
	{
		if (!this._FlowView) { return; }
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) { return; }
		if (!tmpNode.Data) { tmpNode.Data = {}; }
		let tmpMode = (pMode === 'always') ? 'always' : ((pMode === 'off') ? 'off' : 'edit');
		if (tmpMode === 'off')
		{
			tmpNode.Ports = [];
			tmpNode.NodeClass = '';
			// Drop any links that touched this node (their anchors are gone).
			if (this._FlowView.flowData && Array.isArray(this._FlowView.flowData.Connections))
			{
				this._FlowView.flowData.Connections = this._FlowView.flowData.Connections.filter((pConn) => pConn.SourceNodeHash !== pNodeHash && pConn.TargetNodeHash !== pNodeHash);
			}
		}
		else
		{
			let tmpSelf = this;
			tmpNode.Ports = _CONNECT_SIDES.map((pSide) => ({ Hash: 'mbport-' + pSide + '-' + tmpSelf.fable.getUUID(), Direction: 'output', Side: pSide, Label: '' }));
			// 'always' stamps a class so the dots stay visible on a read-only board (see the CSS).
			tmpNode.NodeClass = (tmpMode === 'always') ? 'mb-conn-always' : '';
		}
		tmpNode.Data.ConnectMode = tmpMode;
		tmpNode.Data.ConnectOffSel = (tmpMode === 'off') ? 'selected' : '';
		tmpNode.Data.ConnectEditSel = (tmpMode === 'edit') ? 'selected' : '';
		tmpNode.Data.ConnectAlwaysSel = (tmpMode === 'always') ? 'selected' : '';
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();
		this._updateConnectButton();
		this._emitChange();
	}

	// The toolbar "Connections" button + the "c" hotkey flip the selected card(s) between off and the
	// default on-state (edit). 'always' is only reachable from the panel select. Toggling several at once
	// turns them all on if any is off, otherwise all off.
	toggleConnectPoints()
	{
		if (!this._FlowView || !this._isEditable()) { return; }
		let tmpHashes = this._selectedHashes();
		if (tmpHashes.length === 0)
		{
			this._toast('Select a card first to toggle its connection points.');
			return;
		}
		let tmpSelf = this;
		let tmpAnyOff = tmpHashes.some((pHash) =>
		{
			let tmpNode = tmpSelf._FlowView.getNode(pHash);
			return !tmpNode || !tmpNode.Data || !tmpNode.Data.ConnectMode || tmpNode.Data.ConnectMode === 'off';
		});
		let tmpTarget = tmpAnyOff ? 'edit' : 'off';
		tmpHashes.forEach((pHash) => this.setConnectMode(pHash, tmpTarget));
	}

	// The current selection as an array of node hashes (the flow's multi-select set, or the single one).
	_selectedHashes()
	{
		if (this._FlowView && typeof this._FlowView.getSelectedNodeHashes === 'function')
		{
			let tmpSet = this._FlowView.getSelectedNodeHashes();
			if (tmpSet && tmpSet.length) { return tmpSet; }
		}
		let tmpPrimary = (this._FlowView && this._FlowView.viewState) ? this._FlowView.viewState.SelectedNodeHash : null;
		return tmpPrimary ? [tmpPrimary] : [];
	}

	// Reflect the selected card's connection state on the toolbar "Connections" button (pressed when the
	// selection has points on), so the toolbar control reads like a checkbox for the current card.
	_updateConnectButton()
	{
		if (!this._FlowView || !this._FlowView._ToolbarView) { return; }
		let tmpButtons = this._FlowView.options.ToolbarExtraButtons || [];
		let tmpButton = tmpButtons.find((pButton) => pButton.Hash === 'mb-connect');
		if (!tmpButton) { return; }
		let tmpSelf = this;
		let tmpActive = this._selectedHashes().some((pHash) =>
		{
			let tmpNode = tmpSelf._FlowView.getNode(pHash);
			return tmpNode && tmpNode.Data && tmpNode.Data.ConnectMode && tmpNode.Data.ConnectMode !== 'off';
		});
		if (tmpButton.Active === tmpActive) { return; }
		tmpButton.Active = tmpActive;
		if (typeof this._FlowView._ToolbarView.render === 'function') { this._FlowView._ToolbarView.render(); }
		if (this._FlowView._ToolbarView._FloatingToolbarView && typeof this._FlowView._ToolbarView._FloatingToolbarView.render === 'function') { this._FlowView._ToolbarView._FloatingToolbarView.render(); }
	}

	// A non-blocking toast via the host's pict-section-modal, if present (absent in the stand-alone demo).
	_toast(pMessage)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: 'info' }); }
	}

	// ── connection (link) appearance ────────────────────────────────────────────
	// A new link gets a sensible default look so it reads as intentional; double-clicking it opens the
	// connection panel to change color / width / line style / the marker at each end / a label.

	_onConnectionCreated(pConnection)
	{
		if (!pConnection || typeof pConnection !== 'object' || !this._FlowView) { return; }
		if (!pConnection.Data) { pConnection.Data = {}; }
		// Already styled (e.g. a link loaded from a saved board) -- leave it alone.
		if (typeof pConnection.Data.TargetMarker !== 'undefined') { return; }
		let tmpDefaults = this._connectionDefaults();
		pConnection.Data.StrokeColor = tmpDefaults.StrokeColor;
		pConnection.Data.StrokeWidth = tmpDefaults.StrokeWidth;
		pConnection.Data.StrokeStyle = tmpDefaults.StrokeStyle;
		pConnection.Data.SourceMarker = tmpDefaults.SourceMarker;
		pConnection.Data.TargetMarker = tmpDefaults.TargetMarker;
		pConnection.Data.Label = '';
		if (tmpDefaults.EdgeTheme) { pConnection.Data.EdgeTheme = tmpDefaults.EdgeTheme; }
		this._stampConnectionSelects(pConnection.Data);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// The default style for a NEWLY drawn link. A host (plansheet) can push a per-Drafting-Kit style via the
	// ConnectionDefaults option or setConnectionDefaults(); missing keys fall back to the built-in neutral link.
	_connectionDefaults()
	{
		let tmpKit = (this.options && this.options.ConnectionDefaults) ? this.options.ConnectionDefaults : {};
		return {
			StrokeColor: tmpKit.StrokeColor || '#5b6376',
			StrokeWidth: (typeof tmpKit.StrokeWidth === 'number') ? tmpKit.StrokeWidth : 2,
			StrokeStyle: tmpKit.StrokeStyle || 'solid',
			SourceMarker: tmpKit.SourceMarker || 'none',
			TargetMarker: tmpKit.TargetMarker || 'arrow',
			EdgeTheme: tmpKit.EdgeTheme || ''
		};
	}

	// Push a per-kit default connection style at runtime (after the view exists). The curve (EdgeTheme) is set
	// flow-level so it applies to every link; stroke + markers apply to each newly drawn link (a per-link
	// override on a saved link still wins). A host calls this when a kit-scoped board opens.
	setConnectionDefaults(pDefaults)
	{
		this.options.ConnectionDefaults = pDefaults || {};
		let tmpCurve = this.options.ConnectionDefaults.EdgeTheme;
		if (tmpCurve && this._FlowView && typeof this._FlowView.setEdgeTheme === 'function') { this._FlowView.setEdgeTheme(tmpCurve); }
	}

	// Find a connection by hash, mutate its Data, refresh its panel-select bindings, and re-render.
	_updateConnection(pConnectionHash, pMutate)
	{
		if (!this._FlowView || !this._FlowView.flowData) { return; }
		let tmpConnection = (this._FlowView.flowData.Connections || []).find((pConn) => pConn.Hash === pConnectionHash);
		if (!tmpConnection) { return; }
		if (!tmpConnection.Data) { tmpConnection.Data = {}; }
		pMutate(tmpConnection.Data);
		this._stampConnectionSelects(tmpConnection.Data);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// Keep the 'selected' strings the connection panel <select>s bind to in step with the Data values.
	_stampConnectionSelects(pData)
	{
		pData.StyleSolidSel = (pData.StrokeStyle === 'solid') ? 'selected' : '';
		pData.StyleDashedSel = (pData.StrokeStyle === 'dashed') ? 'selected' : '';
		pData.StyleDottedSel = (pData.StrokeStyle === 'dotted') ? 'selected' : '';
		let fStampMarker = function (pValue, pPrefix)
		{
			pData[pPrefix + 'NoneSel'] = (pValue === 'none') ? 'selected' : '';
			pData[pPrefix + 'ArrowSel'] = (pValue === 'arrow') ? 'selected' : '';
			pData[pPrefix + 'DotSel'] = (pValue === 'dot') ? 'selected' : '';
			pData[pPrefix + 'SquareSel'] = (pValue === 'square') ? 'selected' : '';
		};
		fStampMarker(pData.SourceMarker, 'Src');
		fStampMarker(pData.TargetMarker, 'Tgt');
		// Curve type rides Data.EdgeTheme (the flow's per-connection edge-theme override); default Bezier.
		let tmpCurve = pData.EdgeTheme || 'Bezier';
		pData.CurveBezierSel = (tmpCurve === 'Bezier') ? 'selected' : '';
		pData.CurveElbowSel = (tmpCurve === 'Orthogonal') ? 'selected' : '';
		pData.CurveStraightSel = (tmpCurve === 'Straight') ? 'selected' : '';
	}

	setConnectionColor(pConnectionHash, pColor) { this._updateConnection(pConnectionHash, (pData) => { pData.StrokeColor = pColor; }); }
	setConnectionWidth(pConnectionHash, pWidth) { this._updateConnection(pConnectionHash, (pData) => { let tmpNum = parseInt(pWidth, 10); pData.StrokeWidth = (!isNaN(tmpNum) && tmpNum > 0) ? tmpNum : 2; }); }
	setConnectionLineStyle(pConnectionHash, pStyle) { this._updateConnection(pConnectionHash, (pData) => { pData.StrokeStyle = (pStyle === 'dashed' || pStyle === 'dotted') ? pStyle : 'solid'; }); }
	setConnectionSourceMarker(pConnectionHash, pMarker) { this._updateConnection(pConnectionHash, (pData) => { pData.SourceMarker = pMarker; }); }
	setConnectionTargetMarker(pConnectionHash, pMarker) { this._updateConnection(pConnectionHash, (pData) => { pData.TargetMarker = pMarker; }); }
	setConnectionCurve(pConnectionHash, pCurve) { this._updateConnection(pConnectionHash, (pData) => { pData.EdgeTheme = (pCurve === 'Orthogonal' || pCurve === 'Straight') ? pCurve : 'Bezier'; }); }

	// The label updates in place (no full re-render) so typing keeps the panel input's focus; the empty
	// label element is always rendered for a styled link, so it exists to update.
	setConnectionLabel(pConnectionHash, pLabel)
	{
		if (!this._FlowView || !this._FlowView.flowData) { return; }
		let tmpConnection = (this._FlowView.flowData.Connections || []).find((pConn) => pConn.Hash === pConnectionHash);
		if (!tmpConnection) { return; }
		if (!tmpConnection.Data) { tmpConnection.Data = {}; }
		tmpConnection.Data.Label = pLabel;
		let tmpLabelEl = document.querySelector('#MB-Flow-' + this.options.ViewIdentifier + ' .pict-flow-connection-label[data-connection-hash="' + pConnectionHash + '"]');
		if (tmpLabelEl) { tmpLabelEl.textContent = pLabel; }
		this._FlowView.marshalFromView();
		this._emitChange();
	}

	// ---- Drag-and-drop + paste (add new image cards) ----

	onDragOver(pEvent)
	{
		if (!this._isEditable()) { return; }
		pEvent.preventDefault();
		let tmpCanvas = document.getElementById('MB-Canvas-' + this.options.ViewIdentifier);
		if (tmpCanvas) tmpCanvas.classList.add('mb-dropping');
	}

	onDragLeave(pEvent)
	{
		let tmpCanvas = document.getElementById('MB-Canvas-' + this.options.ViewIdentifier);
		if (tmpCanvas) tmpCanvas.classList.remove('mb-dropping');
	}

	onDrop(pEvent)
	{
		if (!this._isEditable()) { return; }
		pEvent.preventDefault();
		let tmpCanvas = document.getElementById('MB-Canvas-' + this.options.ViewIdentifier);
		if (tmpCanvas) tmpCanvas.classList.remove('mb-dropping');

		let tmpData = pEvent.dataTransfer;
		if (!tmpData) return;
		if (tmpData.files && tmpData.files.length > 0)
		{
			this.addImageFiles(tmpData.files);
			return;
		}
		// A dragged image or link from another page arrives as a URL.
		let tmpUrl = tmpData.getData('text/uri-list') || tmpData.getData('text/plain');
		if (tmpUrl && /^https?:\/\//i.test(tmpUrl.trim())) { this.addImage(tmpUrl.trim()); }
	}

	_onPaste(pEvent)
	{
		// Only act when this moodboard is on screen and editable.
		if (!this._isEditable()) { return; }
		if (!document.getElementById('MB-Root-' + this.options.ViewIdentifier)) return;
		let tmpItems = (pEvent.clipboardData && pEvent.clipboardData.items) ? pEvent.clipboardData.items : null;
		if (!tmpItems) return;
		for (let i = 0; i < tmpItems.length; i++)
		{
			let tmpItem = tmpItems[i];
			if (tmpItem.type && tmpItem.type.indexOf('image/') === 0)
			{
				let tmpFile = tmpItem.getAsFile();
				if (tmpFile) { this._readFileAsImage(tmpFile); pEvent.preventDefault(); }
			}
		}
	}

	// ---- Library picker (opened from an Image / Sticker card's properties panel) ----
	// The picker builds itself from whatever fields the source declares (getFields), so a host source
	// with custom metadata gets custom filter/sort controls for free. Search is re-applied to the grid
	// only (the controls are not re-rendered) so the search box keeps focus while typing.

	_galleryState()
	{
		let tmpMb = this.pict.AppData.Moodboard;
		if (!tmpMb.Gallery)
		{
			tmpMb.Gallery = { Open: false, Mode: 'image', Title: 'Image gallery', SearchPlaceholder: 'Search images', EmptyMessage: '', UploadAccept: 'image/*', Query: { Search: '', Filters: {}, Sort: { Field: null, Direction: 'asc' } }, SortDirLabel: 'Asc', FilterFields: [], SortFields: [], Items: [], EmptySlot: [{}] };
		}
		return tmpMb.Gallery;
	}

	_activeGallerySource()
	{
		let tmpMode = this._galleryState().Mode;
		if (tmpMode === 'sticker') { return this._StickerSource; }
		if (tmpMode === 'drawing') { return this._DrawingSource || this._ImageSource; }
		return this._ImageSource;
	}

	// Open the picker for a specific card: a pick (or an upload) sets the chosen image / sticker onto
	// THIS node, rather than adding a new card. Called from the Image / Sticker properties panels.
	openPickerForCard(pNodeHash, pMode)
	{
		this._PickerTargetHash = pNodeHash;
		this.openGallery(pMode);
	}

	openGallery(pMode)
	{
		let tmpGallery = this._galleryState();
		// 'drawing' shares the image source (a drawing is a gallery item like any other) but titles the
		// picker for the drawing card and routes the pick to setDrawingSource (see pickFromGallery).
		let tmpMode = (pMode === 'sticker') ? 'sticker' : (pMode === 'drawing') ? 'drawing' : 'image';
		let tmpIsSticker = (tmpMode === 'sticker');
		tmpGallery.Open = true;
		tmpGallery.Mode = tmpMode;
		tmpGallery.Title = tmpIsSticker ? 'Stickers' : (tmpMode === 'drawing') ? 'Pick a drawing or image' : 'Image gallery';
		tmpGallery.SearchPlaceholder = tmpIsSticker ? 'Search stickers' : (tmpMode === 'drawing') ? 'Search drawings and images' : 'Search images';
		tmpGallery.EmptyMessage = tmpIsSticker
			? 'No stickers here yet. Upload a PNG or SVG and it shows up here to reuse.'
			: (tmpMode === 'drawing')
				? 'No drawings or images yet. Make one in Drawings, or upload an image here (you can also drop / paste one on the board).'
				: 'No images here yet. Upload a file (or drop / paste one on the board) and it shows up here to reuse.';
		tmpGallery.UploadAccept = tmpIsSticker ? 'image/svg+xml,image/png' : 'image/*';
		// Fresh query each open so a search / filter from the other mode does not leak across.
		tmpGallery.Query = { Search: '', Filters: {}, Sort: { Field: null, Direction: 'asc' } };
		tmpGallery.SortDirLabel = 'Asc';

		let tmpSource = this._activeGallerySource();
		let tmpFields = (tmpSource && tmpSource.getFields) ? tmpSource.getFields() : [];
		tmpGallery.FilterFields = tmpFields.filter((pField) => pField.Filterable).map((pField) =>
			({ Key: pField.Key, Label: pField.Label, Options: (tmpSource.getFilterOptions ? tmpSource.getFilterOptions(pField.Key) : []).map((pValue) => ({ Value: pValue })) }));
		tmpGallery.SortFields = tmpFields.filter((pField) => pField.Sortable).map((pField) => ({ Key: pField.Key, Label: pField.Label }));

		this.pict.ContentAssignment.assignContent('#MB-Gallery-' + this.options.ViewIdentifier, this.pict.parseTemplateByHash('Moodboard-Gallery', { ViewID: this.options.ViewIdentifier }));
		let tmpRoot = document.getElementById('MB-Root-' + this.options.ViewIdentifier);
		if (tmpRoot) { tmpRoot.classList.add('mb-gallery-open'); tmpRoot.classList.toggle('mb-gallery-mode-sticker', tmpMode === 'sticker'); }
		this._refreshGalleryGrid();
	}

	closeGallery()
	{
		this._galleryState().Open = false;
		this._PickerTargetHash = null;
		let tmpRoot = document.getElementById('MB-Root-' + this.options.ViewIdentifier);
		if (tmpRoot) { tmpRoot.classList.remove('mb-gallery-open'); }
	}

	_refreshGalleryGrid()
	{
		let tmpGallery = this._galleryState();
		// list() may return an array (the built-in base source) or a Promise (a host source backed by a
		// remote store); Promise.resolve handles both, so a remote gallery renders the same way.
		let tmpSource = this._activeGallerySource();
		let tmpResult = (tmpSource && tmpSource.list) ? tmpSource.list(tmpGallery.Query) : [];
		Promise.resolve(tmpResult).then((pItems) =>
		{
			let tmpItems = Array.isArray(pItems) ? pItems : [];
			tmpGallery.Items = tmpItems;
			tmpGallery.EmptySlot = tmpItems.length ? [] : [{}];
			this.pict.ContentAssignment.assignContent('#MB-Gallery-Grid-' + this.options.ViewIdentifier, this.pict.parseTemplateByHash('Moodboard-Gallery-Grid', { ViewID: this.options.ViewIdentifier }));
		});
	}

	onGallerySearch(pValue) { this._galleryState().Query.Search = pValue || ''; this._refreshGalleryGrid(); }
	onGalleryFilter(pKey, pValue) { this._galleryState().Query.Filters[pKey] = pValue; this._refreshGalleryGrid(); }
	onGallerySort(pField) { this._galleryState().Query.Sort.Field = pField || null; this._refreshGalleryGrid(); }

	onGallerySortDir()
	{
		let tmpGallery = this._galleryState();
		tmpGallery.Query.Sort.Direction = (tmpGallery.Query.Sort.Direction === 'asc') ? 'desc' : 'asc';
		tmpGallery.SortDirLabel = (tmpGallery.Query.Sort.Direction === 'asc') ? 'Asc' : 'Desc';
		let tmpBtn = document.querySelector('#MB-Gallery-' + this.options.ViewIdentifier + ' .mb-gallery-dir');
		if (tmpBtn) { tmpBtn.textContent = tmpGallery.SortDirLabel; }
		this._refreshGalleryGrid();
	}

	// Pick an item: set it onto the card whose panel opened the picker. (With no target -- the
	// stand-alone demo -- fall back to adding a new card.)
	pickFromGallery(pId)
	{
		let tmpGallery = this._galleryState();
		// The tile onclick passes the id as a string (it is quoted in the template), but a host source can
		// key items by a number (plansheet's IDMedia); compare as strings so a numeric id still matches.
		let tmpItem = (tmpGallery.Items || []).find((pItem) => String(pItem.Id) === String(pId));
		if (!tmpItem) { return; }
		if (this._PickerTargetHash)
		{
			if (tmpGallery.Mode === 'sticker') { this.setStickerUrl(this._PickerTargetHash, tmpItem.Url, tmpItem.Metadata); }
			else if (tmpGallery.Mode === 'drawing') { this.setDrawingSource(this._PickerTargetHash, tmpItem); }
			else { this.setImageUrl(this._PickerTargetHash, tmpItem.Url); }
			this.closeGallery();
			return;
		}
		if (tmpGallery.Mode === 'sticker') { this._addStickerCard(tmpItem.Url, Object.assign({ Name: tmpItem.Name }, tmpItem.Metadata)); }
		else if (tmpGallery.Mode === 'drawing') { this._addDrawingCard(tmpItem); }
		else { this.addImage(tmpItem.Url, Object.assign({ Name: tmpItem.Name }, tmpItem.Metadata)); }
	}

	// Upload from the picker's own button. With a target card, store the bytes (via the source, if any),
	// register it in the library for reuse, and set it onto the target. With no target, add a new card.
	uploadToGallery(pFileList)
	{
		let tmpMode = this._galleryState().Mode;
		let tmpTarget = this._PickerTargetHash;
		if (!tmpTarget)
		{
			if (tmpMode === 'sticker') { this._addStickerFiles(pFileList); } else { this.addImageFiles(pFileList); }
			return;
		}
		let tmpFile = pFileList && pFileList[0];
		if (!tmpFile) { return; }
		let tmpSelf = this;
		let tmpSource = (tmpMode === 'sticker') ? this._StickerSource : this._ImageSource;
		let tmpReader = new FileReader();
		tmpReader.onload = function (pEvent)
		{
			let tmpMeta = { Name: tmpFile.name, Type: tmpFile.type || tmpMode, SizeBytes: tmpFile.size || 0, AddedAt: Date.now() };
			let fAssign = function (pUrl, pRef)
			{
				if (tmpSource && typeof tmpSource.add === 'function') { tmpSource.add({ Url: pUrl, Name: tmpMeta.Name, Metadata: { Type: tmpMeta.Type, SizeBytes: tmpMeta.SizeBytes, AddedAt: tmpMeta.AddedAt } }); }
				if (tmpMode === 'sticker') { tmpSelf.setStickerUrl(tmpTarget, pUrl); }
				else if (tmpMode === 'drawing') { tmpSelf.setDrawingSource(tmpTarget, { Id: (pRef && pRef.Id != null) ? pRef.Id : null, Name: tmpMeta.Name, Url: pUrl, Metadata: { MimeType: tmpFile.type || '', OriginalFileName: tmpFile.name || '' } }); }
				else { tmpSelf.setImageUrl(tmpTarget, pUrl); }
				tmpSelf.closeGallery();
			};
			if (tmpSource && typeof tmpSource.upload === 'function')
			{
				tmpSource.upload(tmpFile, pEvent.target.result, function (pErr, pRef) { if (pErr) { return; } fAssign((pRef && pRef.Url) ? pRef.Url : pEvent.target.result, pRef); });
			}
			else { fAssign(pEvent.target.result, null); }
		};
		tmpReader.readAsDataURL(tmpFile);
	}

	// Stand-alone fallbacks (no host, no target): add a new sticker card from a URL or file. The primary
	// path is the palette (an empty sticker card) + the panel picker; these keep the demo self-contained.
	_addStickerCard(pUrl, pMeta)
	{
		if (!this._FlowView || !pUrl) { return; }
		let tmpMeta = pMeta || {};
		if (this._StickerSource && typeof this._StickerSource.add === 'function')
		{
			this._StickerSource.add({ Url: pUrl, Name: tmpMeta.Name || this._urlName(pUrl), Metadata: { Type: tmpMeta.Type || 'sticker', SizeBytes: tmpMeta.SizeBytes || 0, AddedAt: tmpMeta.AddedAt || Date.now() } });
		}
		let tmpPos = this._nextPosition();
		let tmpNode = this._FlowView.addNode('MoodSticker', tmpPos.x, tmpPos.y, '', { StickerUrl: pUrl });
		if (tmpNode)
		{
			tmpNode.Ports = [];
			this._stampStickerMeta(tmpNode, tmpMeta);
			this._FlowView.selectNode(tmpNode.Hash);
			this._FlowView.renderFlow();
			this._FlowView.marshalFromView();
		}
		if (this._galleryState().Open) { this._refreshGalleryGrid(); }
	}

	_addStickerFiles(pFileList)
	{
		if (!pFileList) { return; }
		// Stickers are cutouts: PNG (transparency) or SVG. Other image types are ignored.
		let tmpFiles = Array.prototype.slice.call(pFileList).filter((pFile) => pFile && pFile.type && (pFile.type === 'image/png' || pFile.type === 'image/svg+xml'));
		let tmpSelf = this;
		tmpFiles.forEach(function (pFile)
		{
			let tmpReader = new FileReader();
			tmpReader.onload = function (pEvent)
			{
				let tmpMeta = { Name: pFile.name, Type: pFile.type || 'sticker', SizeBytes: pFile.size || 0, AddedAt: Date.now() };
				if (tmpSelf._StickerSource && typeof tmpSelf._StickerSource.upload === 'function')
				{
					tmpSelf._StickerSource.upload(pFile, pEvent.target.result, function (pErr, pRef) { if (pErr) { return; } tmpSelf._addStickerCard((pRef && pRef.Url) ? pRef.Url : pEvent.target.result, tmpMeta); });
				}
				else { tmpSelf._addStickerCard(pEvent.target.result, tmpMeta); }
			};
			tmpReader.readAsDataURL(pFile);
		});
	}

	// ---- Persistence ----

	getBoard()
	{
		// A board still waiting to apply (the flow's data-manager service has not wired up yet) means the live
		// flow is empty. Report the PENDING board instead, so a host autosave that fires during the load
		// window persists the real content rather than overwriting it with an empty board (the content-loss
		// race). Once it applies, _PendingBoard is cleared and the live flow is authoritative.
		if (this._PendingBoard) { return JSON.parse(JSON.stringify(this._PendingBoard)); }
		if (!this._FlowView) { return { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } }; }
		let tmpBoard = this._FlowView.getFlowData();
		// A saved board is content (cards + viewport), not transient editor state: drop any open
		// properties panels so reopening a board does not restore a clutter of editors.
		if (tmpBoard && tmpBoard.OpenPanels) { tmpBoard = Object.assign({}, tmpBoard, { OpenPanels: [] }); }
		return tmpBoard;
	}

	setBoard(pBoard)
	{
		if (!pBoard) { return; }
		// The flow sub-view is built in onAfterRender (_ensureFlowView), and its data manager is an
		// injected SERVICE that wires up asynchronously after addView -- so the flow can report
		// initialRenderComplete while _DataManager (what setFlowData needs) is still null. A host
		// typically calls setBoard right after render(), before that service exists, so the board stayed
		// empty until a second, warm visit. Stash the board and apply it the moment _DataManager is ready.
		this._PendingBoard = pBoard;
		if (this._FlowView && this._FlowView._DataManager && this._FlowView.initialRenderComplete)
		{
			this._PendingBoard = null;
			this._FlowView.setFlowData(pBoard);
			this._FlowView.renderFlow();
			this._afterBoardApplied();
			return;
		}
		if (this._FlowView) { this._applyPendingBoard(); }
	}

	// Shared tail for both board-load paths: re-establish the display style (a loaded presentation board
	// flips to read-only width-fit, so rebuild the chrome; a canvas board just re-applies cheaply), paint
	// the background, and fit. setFlowData does not fire onFlowChanged, so loading stays save-silent.
	_afterBoardApplied()
	{
		// Re-assert this instance's configured edit/read-only mode. A moodboard view is often a reused
		// singleton (a host mounts one editable + one read-only instance across many boards), so its flow
		// read-only + interaction flags may still be set for a previous board. Re-applying options.Editable
		// here means a board always loads in the mode it was mounted for -- a read-only board never opens
		// editable, and an editable one is never left read-only. _applyDisplayStyle (below) re-confirms
		// read-only for a presentation effective style after this runs.
		this._applyEditableToFlow();
		// A board (re)load is often the host swapping our read-only <-> editable instance. Each instance keeps
		// its own display-style de-dup key, so the editable instance can stay SILENT about being 'canvas'
		// while the host is still laid out for the read-only instance's 'background' backdrop -- leaving the
		// detail content over the editor (z-index -1) and swallowing clicks on the board. Clear the key so the
		// effective style is reported fresh on every board load and the host re-lays-out for this instance.
		this._LastDisplayStyleKey = null;
		if (this._isPresentationStyle())
		{
			// Rebuild the moodboard chrome for the read-only presentation mode; onAfterRender's
			// _applyDisplayStyle establishes the flow FitMode / frame / observer + paints the background.
			this.render();
		}
		else
		{
			this._applyDisplayStyle();
			this._applyBackgroundSoon();
		}
		this._fitSoon();
		this._fullscreenOnEditSoon();
	}

	// Auto-enter the flow's fullscreen when an editable board mounts and the host asked for it
	// (options.FullscreenOnEdit) -- editing a whiteboard is a focused, full-viewport activity. Deferred and
	// polled so the flow wrapper exists.
	//
	// This view is a reused singleton: a host mounts ONE editable instance across many boards and swaps it
	// out (read-only view) on "Done" -- but that swap only wipes our container, it does not call any unmount
	// hook, so the flow's _IsFullscreen flag survives from the previous edit while the OLD wrapper (and its
	// .pict-flow-fullscreen class) is gone. So the flag alone is not trustworthy: reconcile it against the
	// live DOM. If this fresh wrapper is already fullscreen we are done; if the flag is stale-true but this
	// wrapper is not fullscreen, drop the stale flag first so the toggle actually re-enters.
	_fullscreenOnEditSoon()
	{
		if (!(this.options.FullscreenOnEdit && this._isEditable() && this._FlowView)) { return; }
		let tmpSelf = this;
		let tmpTries = 0;
		let fGo = function ()
		{
			if (!tmpSelf._isEditable() || !tmpSelf._FlowView) { return; }
			let tmpWrapper = (typeof document !== 'undefined') ? document.getElementById('Flow-Wrapper-' + tmpSelf._FlowView.options.ViewIdentifier) : null;
			if (!tmpWrapper)
			{
				if (++tmpTries < 60 && typeof requestAnimationFrame === 'function') { requestAnimationFrame(fGo); }
				return;
			}
			let tmpWrapperFullscreen = tmpWrapper.classList.contains('pict-flow-fullscreen');
			// Already fullscreen on this wrapper -- a re-applied board, nothing to do.
			if (tmpSelf._FlowView._IsFullscreen && tmpWrapperFullscreen) { return; }
			// Stale flag left true by a previous edit whose wrapper is gone: clear it so the toggle re-enters.
			if (tmpSelf._FlowView._IsFullscreen && !tmpWrapperFullscreen && typeof tmpSelf._FlowView.exitFullscreen === 'function') { tmpSelf._FlowView.exitFullscreen(); }
			if (typeof tmpSelf._FlowView.toggleFullscreen === 'function')
			{
				tmpSelf._FlowView.toggleFullscreen();
				tmpSelf.fitBoard();
			}
		};
		if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(fGo); } else { setTimeout(fGo, 32); }
	}

	// Fit the board's content into view on mount (both modes) so nothing is clipped and you never land
	// zoomed in hard. Deferred a couple of frames so the canvas has its final size.
	_fitSoon()
	{
		let tmpSelf = this;
		let fFit = function () { tmpSelf.fitBoard(); };
		if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(function () { requestAnimationFrame(fFit); }); }
		else { setTimeout(fFit, 32); }
	}

	// Apply a board stashed by setBoard once the flow's data-manager service is wired. Polls a bounded
	// number of animation frames (the service injection lags the flow's render).
	_applyPendingBoard()
	{
		if (!this._PendingBoard || !this._FlowView) { return; }
		let tmpSelf = this;
		let tmpTries = 0;
		let fApply = function ()
		{
			if (!tmpSelf._PendingBoard || !tmpSelf._FlowView) { return; }
			if (tmpSelf._FlowView._DataManager && tmpSelf._FlowView.initialRenderComplete)
			{
				let tmpBoard = tmpSelf._PendingBoard;
				tmpSelf._PendingBoard = null;
				try { tmpSelf._FlowView.setFlowData(tmpBoard); tmpSelf._FlowView.renderFlow(); tmpSelf._afterBoardApplied(); }
				catch (pErr) { /* flow torn down mid-flight */ }
				return;
			}
			if (++tmpTries < 120)
			{
				if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(fApply); }
				else { setTimeout(fApply, 16); }
			}
		};
		if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(fApply); }
		else { setTimeout(fApply, 16); }
	}

	onBeforeUnload()
	{
		if (this._PasteWired)
		{
			document.removeEventListener('paste', this._boundOnPaste);
			this._PasteWired = false;
		}
		if (this._ConnectKeyWired && this._boundOnConnectKey)
		{
			document.removeEventListener('keydown', this._boundOnConnectKey);
			this._ConnectKeyWired = false;
		}
		// Drop the flow's width-fit ResizeObserver (a presentation board installs one) so it does not
		// outlive the view.
		if (this._FlowView && typeof this._FlowView._teardownFitObserver === 'function') { this._FlowView._teardownFitObserver(); }
		// This view is a reusable singleton (a host swaps one editable + one read-only instance across many
		// boards), so leave no presentation state on the shared flow. Drop out of fullscreen: the editor's
		// FullscreenOnEdit enters it and nothing else clears it, so without this the NEXT edit sees a stale
		// fullscreen bit (_fullscreenOnEditSoon early-returns on it) and never re-expands. Turn off the
		// frame-edit handles and close the display menu for the same reason.
		if (this._FlowView && typeof this._FlowView.exitFullscreen === 'function') { this._FlowView.exitFullscreen(); }
		if (this._FrameEditing && this._FlowView && typeof this._FlowView.setFrameEditing === 'function') { this._FrameEditing = false; this._FlowView.setFrameEditing(false); }
		this.closeDisplayMenu();
	}
}

module.exports = PictViewMoodboard;
module.exports.default_configuration = _ViewConfiguration;
module.exports.NOTE_COLORS = _NOTE_COLORS;

},{"../cards/MoodConnector-Card.js":273,"../cards/MoodDrawing-Card.js":274,"../cards/MoodImage-Card.js":275,"../cards/MoodNote-Card.js":276,"../cards/MoodSticker-Card.js":277,"../cards/MoodText-Card.js":278,"../sources/ImageSource-Base.js":279,"../sources/StickerSource-Base.js":280,"pict-section-flow":208,"pict-view":365}],282:[function(require,module,exports){
// The container for all the Pict-Section-Navigation related code.

// The navigation provider (primary API surface — holds the navigation graph and
// registers the render-type views).
const PictProviderNavigation = require('./providers/Pict-Provider-Navigation.js');

// The render-type views (also auto-registered by the provider).
const PictViewNavigationHub = require('./views/PictView-Navigation-Hub.js');
const PictViewNavigationSidebar = require('./views/PictView-Navigation-Sidebar.js');
const PictViewNavigationPalette = require('./views/PictView-Navigation-Palette.js');
const PictViewNavigationList = require('./views/PictView-Navigation-List.js');

module.exports = PictProviderNavigation;

module.exports.PictProviderNavigation = PictProviderNavigation;
module.exports.PictViewNavigationHub = PictViewNavigationHub;
module.exports.PictViewNavigationSidebar = PictViewNavigationSidebar;
module.exports.PictViewNavigationPalette = PictViewNavigationPalette;
module.exports.PictViewNavigationList = PictViewNavigationList;

},{"./providers/Pict-Provider-Navigation.js":283,"./views/PictView-Navigation-Hub.js":284,"./views/PictView-Navigation-List.js":285,"./views/PictView-Navigation-Palette.js":286,"./views/PictView-Navigation-Sidebar.js":287}],283:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libViewHub = require('../views/PictView-Navigation-Hub.js');
const libViewSidebar = require('../views/PictView-Navigation-Sidebar.js');
const libViewPalette = require('../views/PictView-Navigation-Palette.js');
const libViewList = require('../views/PictView-Navigation-List.js');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Navigation',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// Where the navigation state lives in AppData (graph + transient query/active state).
	StateAddress: 'PictNavigation',

	// The navigation graph (a JSON tree of category/item nodes). May also be supplied
	// later via setNavigationGraph(). See the README for the node shape.
	NavigationGraph: [],

	// Optional host navigation handler: OnNavigate(pNode) is called when an item is
	// activated. When absent, navigate() falls back to setting window.location.hash for
	// hash-style routes.
	OnNavigate: null
};

/**
 * Navigation Provider
 *
 * Owns the navigation graph (a JSON tree of categories and items) and all the
 * search / filter / activate logic the render-type views share. Registers the
 * four render-type views (hub, sidebar, palette, list) so a single addProvider()
 * gives you everything; each view reads this provider by hash.
 */
class PictNavigationProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		/** @type {Record<string, any>} */
		this.options;

		// Optional host navigation handler.
		this.onNavigate = (typeof this.options.OnNavigate === 'function') ? this.options.OnNavigate : null;

		// Initialize state (graph + transient query/active) in AppData.
		const tmpState = this._state();
		tmpState.Graph = this._normalizeNodes(Array.isArray(this.options.NavigationGraph) ? this.options.NavigationGraph : [], '');
		if (typeof tmpState.Query !== 'string') tmpState.Query = '';
		if (typeof tmpState.ShowAdvanced !== 'boolean') tmpState.ShowAdvanced = false;
		if (typeof tmpState.ActiveHash === 'undefined') tmpState.ActiveHash = null;

		// Register the render-type views (idempotent singletons).
		this.pict.addViewSingleton('Navigation-Hub', libViewHub.default_configuration, libViewHub);
		this.pict.addViewSingleton('Navigation-Sidebar', libViewSidebar.default_configuration, libViewSidebar);
		this.pict.addViewSingleton('Navigation-Palette', libViewPalette.default_configuration, libViewPalette);
		this.pict.addViewSingleton('Navigation-List', libViewList.default_configuration, libViewList);

		// A dedicated palette instance for the ⌘K launcher overlay — its own local query
		// (so quick-jumping never disturbs a docked sidebar) rendered into the overlay card.
		this.pict.addViewSingleton('Navigation-Launcher', Object.assign({}, libViewPalette.default_configuration,
			{
				ViewIdentifier: 'Navigation-Launcher',
				NavigationProviderHash: this.options.ProviderIdentifier,
				UseLocalQuery: true,
				ShowFooter: true,
				SearchPlaceholder: 'Jump to anywhere…  (type to search)',
				DefaultDestinationAddress: '#PictNavLauncher-Card',
				Renderables:
				[
					{ RenderableHash: 'Navigation-Palette-Wrap', TemplateHash: 'Navigation-Palette-Container', DestinationAddress: '#PictNavLauncher-Card', RenderType: 'replace' }
				]
			}), libViewPalette);

		// Launcher overlay state.
		this._launcherOpen = false;
		this._hotkeyBound = false;
		this._hotkeyUnbind = null;

		// Optional global item filter — a host gate (e.g. session visibility) applied to
		// EVERY render (lists, sidebar, launcher), on top of any per-call Scope/Filter.
		this._globalFilter = null;

		// Shared CSS for all render types (themeable via --theme-color-* with fallbacks).
		if (this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Navigation-Shared-CSS', PictNavigationProvider.SharedCSS, 500);
		}
	}

	// ── Render-type metadata ───────────────────────────────────────────────────

	/**
	 * The render types this provider can produce, in display order. Each entry is
	 * { Key, Label, Layout, Icon, Blurb }. Layout is 'page' (renders as a home screen)
	 * or 'rail' (a persistent docked sidebar). Hosts build their style chooser from this
	 * rather than hard-coding the list.
	 *
	 * @returns {Array<{Key:string, Label:string, Layout:string, Icon:string, Blurb:string}>}
	 */
	getRenderTypes()
	{
		return PictNavigationProvider.RenderTypes.map((pType) => Object.assign({}, pType));
	}

	/** 'page' (home screen) or 'rail' (persistent docked sidebar) for a render type. */
	getRenderTypeLayout(pRenderType)
	{
		const tmpType = PictNavigationProvider.RenderTypes.find((pType) => pType.Key === pRenderType);
		return tmpType ? tmpType.Layout : 'page';
	}

	/** True when the render type is a persistent docked sidebar rather than a home screen. */
	isRailRenderType(pRenderType)
	{
		return this.getRenderTypeLayout(pRenderType) === 'rail';
	}

	/** The navigation state object in AppData. */
	_state()
	{
		const tmpAddress = this.options.StateAddress || 'PictNavigation';
		if (!this.pict.AppData[tmpAddress] || typeof this.pict.AppData[tmpAddress] !== 'object')
		{
			this.pict.AppData[tmpAddress] = {};
		}
		return this.pict.AppData[tmpAddress];
	}

	// ── Graph ────────────────────────────────────────────────────────────────

	/**
	 * Replace the navigation graph. Accepts an array of category nodes; each node may
	 * carry { Hash, Name, Description, Blurb, Icon, Accent, Route, Keywords, Advanced,
	 * Secondary, Children }. The tree is normalized (every node gets a Hash; Children
	 * defaults to []).
	 *
	 * @param {Array<Object>} pGraph
	 */
	setNavigationGraph(pGraph)
	{
		this._state().Graph = this._normalizeNodes(Array.isArray(pGraph) ? pGraph : [], '');
		return this.getNavigationGraph();
	}

	/** @returns {Array<Object>} the normalized navigation graph. */
	getNavigationGraph()
	{
		return this._state().Graph || [];
	}

	_normalizeNodes(pNodes, pParentHash)
	{
		const tmpResult = [];
		for (let i = 0; i < pNodes.length; i++)
		{
			const tmpNode = Object.assign({}, pNodes[i]);
			if (!tmpNode.Hash)
			{
				tmpNode.Hash = (pParentHash ? (pParentHash + '.') : '') + this.slugify(tmpNode.Name || ('node-' + i));
			}
			tmpNode.Children = this._normalizeNodes(Array.isArray(tmpNode.Children) ? tmpNode.Children : [], tmpNode.Hash);
			tmpNode.IsLeaf = (tmpNode.Children.length === 0);
			tmpResult.push(tmpNode);
		}
		return tmpResult;
	}

	slugify(pName)
	{
		return String(pName == null ? '' : pName).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
	}

	// ── Query / state ────────────────────────────────────────────────────────

	setQuery(pQuery) { this._state().Query = String(pQuery == null ? '' : pQuery); return this; }
	getQuery() { return this._state().Query || ''; }

	setShowAdvanced(pShow) { this._state().ShowAdvanced = !!pShow; return this; }
	getShowAdvanced() { return !!this._state().ShowAdvanced; }

	/**
	 * Set (or clear with null) a global item-visibility filter applied to every render —
	 * lists, the docked sidebar, and the launcher. A predicate (item, category) => boolean;
	 * items returning false are hidden everywhere. Use for session/role-based gating.
	 */
	setGlobalFilter(pFilter) { this._globalFilter = (typeof pFilter === 'function') ? pFilter : null; return this; }
	getGlobalFilter() { return this._globalFilter; }

	setActive(pHash) { this._state().ActiveHash = pHash || null; return this; }
	getActive() { return this._state().ActiveHash || null; }

	/** Find a node anywhere in the tree by Hash. */
	getNodeByHash(pHash)
	{
		let tmpFound = null;
		const fWalk = (pNodes) =>
		{
			for (let i = 0; i < pNodes.length && !tmpFound; i++)
			{
				if (pNodes[i].Hash === pHash) { tmpFound = pNodes[i]; return; }
				fWalk(pNodes[i].Children || []);
			}
		};
		fWalk(this.getNavigationGraph());
		return tmpFound;
	}

	/** Find a leaf node whose Route matches pRoute (leading '#' ignored on both sides). */
	getNodeByRoute(pRoute)
	{
		if (!pRoute) return null;
		const fNormalize = (pValue) => String(pValue == null ? '' : pValue).replace(/^#/, '');
		const tmpTarget = fNormalize(pRoute);
		if (!tmpTarget) return null;
		let tmpFound = null;
		const fWalk = (pNodes) =>
		{
			for (let i = 0; i < pNodes.length && !tmpFound; i++)
			{
				if (pNodes[i].Route && fNormalize(pNodes[i].Route) === tmpTarget) { tmpFound = pNodes[i]; return; }
				fWalk(pNodes[i].Children || []);
			}
		};
		fWalk(this.getNavigationGraph());
		return tmpFound;
	}

	/** Mark the node matching pRoute active (or clear active if none matches). Returns the node. */
	setActiveByRoute(pRoute)
	{
		const tmpNode = this.getNodeByRoute(pRoute);
		this.setActive(tmpNode ? tmpNode.Hash : null);
		return tmpNode;
	}

	// ── Search / filter ──────────────────────────────────────────────────────

	/** Every whitespace-separated token of the (lowercased) query must appear in the node's text. */
	matchesNode(pNode, pQuery)
	{
		if (!pQuery) return true;
		const tmpHay = ((pNode.Name || '') + ' ' + (pNode.Description || '') + ' ' + (pNode.Keywords || '')).toLowerCase();
		return pQuery.split(/\s+/).filter(Boolean).every((pTok) => tmpHay.indexOf(pTok) >= 0);
	}

	/** Does pNeedle begin a word in pHay (at the start, or after a non-alphanumeric)? Both already lowercased. */
	_hasWordStart(pHay, pNeedle)
	{
		if (!pNeedle) return false;
		let tmpFrom = 0;
		for (;;)
		{
			const tmpAt = pHay.indexOf(pNeedle, tmpFrom);
			if (tmpAt < 0) return false;
			if (tmpAt === 0 || /[^a-z0-9]/.test(pHay.charAt(tmpAt - 1))) return true;
			tmpFrom = tmpAt + 1;
		}
	}

	/**
	 * Relevance score for ranking search results (higher = better). A match in the TITLE (Name)
	 * ALWAYS outranks a match that is only in the Description/Keywords — the two live in separate
	 * bands (title band starts at 10000; the body band is capped below it), so the title-vs-body
	 * ordering can never be inverted by a long query racking up description hits. Within the title
	 * band, a tighter match scores higher — exact > prefix > word-start > substring — plus a
	 * coverage term (how much of the title the query spans) so e.g. "project" ranks the "Projects"
	 * screen above "Project Activity". pQuery is expected already trimmed + lowercased, as
	 * matchesNode receives it; callers should only score nodes that matchesNode() accepts.
	 *
	 * @param {Object} pNode - a leaf node ({ Name, Description, Keywords, ... })
	 * @param {string} pQuery - the trimmed, lowercased query
	 * @returns {number}
	 */
	scoreNode(pNode, pQuery)
	{
		if (!pQuery) return 0;
		const tmpName = String(pNode.Name == null ? '' : pNode.Name).toLowerCase();
		const tmpDesc = String(pNode.Description == null ? '' : pNode.Description).toLowerCase();
		const tmpKeys = String(pNode.Keywords == null ? '' : pNode.Keywords).toLowerCase();
		const tmpTokens = pQuery.split(/\s+/).filter(Boolean);

		// ── Title (Name) quality — 0 means no title hit ──
		let tmpTitle = 0;
		const tmpNameAt = tmpName.indexOf(pQuery);
		if (tmpName === pQuery) tmpTitle = 1000;                        // exact title
		else if (tmpNameAt === 0) tmpTitle = 600;                       // title starts with the whole query
		else if (this._hasWordStart(tmpName, pQuery)) tmpTitle = 420;   // query starts a word in the title
		else if (tmpNameAt >= 0) tmpTitle = 260;                        // query appears somewhere in the title
		if (tmpTitle > 0)
		{
			// Coverage: the more of the title the query spans, the more specific the match
			// ("project" covers most of "Projects" but little of "Project Activity").
			tmpTitle += Math.round((pQuery.length / Math.max(tmpName.length, 1)) * 200);
		}
		// Per-token title hits keep multi-word queries title-weighted.
		tmpTokens.forEach((pTok) =>
		{
			if (this._hasWordStart(tmpName, pTok)) tmpTitle += 90;
			else if (tmpName.indexOf(pTok) >= 0) tmpTitle += 55;
		});

		// ── Description + Keywords quality — bounded strictly below the title band ──
		let tmpBody = 0;
		if (tmpDesc.indexOf(pQuery) >= 0) tmpBody += 60;
		if (tmpKeys.indexOf(pQuery) >= 0) tmpBody += 40;
		tmpTokens.forEach((pTok) =>
		{
			if (tmpDesc.indexOf(pTok) >= 0) tmpBody += 18;
			if (tmpKeys.indexOf(pTok) >= 0) tmpBody += 10;
		});
		if (tmpBody > 900) tmpBody = 900;

		// Title band (>= 10000) always beats the body-only band (< 1000).
		return (tmpTitle > 0) ? (10000 + tmpTitle + tmpBody) : tmpBody;
	}

	/** Stable, relevance-descending sort of leaf nodes for a query (ties keep authored graph order). */
	_rankNodes(pNodes, pGetNode, pQuery)
	{
		if (!pQuery || !Array.isArray(pNodes) || pNodes.length < 2) return pNodes;
		return pNodes
			.map((pEntry, pIndex) => ({ Entry: pEntry, Score: this.scoreNode(pGetNode(pEntry), pQuery), Ordinal: pIndex }))
			.sort((pA, pB) => (pB.Score - pA.Score) || (pA.Ordinal - pB.Ordinal))
			.map((pWrapped) => pWrapped.Entry);
	}

	/**
	 * Categories (top-level nodes) with their leaf items filtered by the current — or
	 * supplied — query + showAdvanced. Advanced items are hidden while browsing but an
	 * active query reveals matching ones. Empty categories are dropped. This is the
	 * primary data source for the hub / sidebar / list views.
	 *
	 * Pass `Scope` (an array of category hashes) to pre-filter to a subset of the graph —
	 * the basis for topic / pre-filtered nav pages. Pass `Filter` (a predicate
	 * (item, category) => boolean) to gate individual items (e.g. session-based visibility).
	 *
	 * @param {{Query?: string, ShowAdvanced?: boolean, Scope?: Array<string>, Filter?: Function}} [pOptions]
	 * @returns {Array<Object>} [ { ...category, Items: [filtered children] } ]
	 */
	getFilteredCategories(pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpQuery = (typeof tmpOptions.Query === 'string' ? tmpOptions.Query : this.getQuery()).trim().toLowerCase();
		const tmpShowAdvanced = (typeof tmpOptions.ShowAdvanced === 'boolean') ? tmpOptions.ShowAdvanced : this.getShowAdvanced();
		const tmpScope = Array.isArray(tmpOptions.Scope) ? tmpOptions.Scope : null;
		const tmpFilter = (typeof tmpOptions.Filter === 'function') ? tmpOptions.Filter : null;
		const tmpGlobalFilter = this._globalFilter;

		const tmpResult = [];
		this.getNavigationGraph().forEach((pCategory) =>
		{
			if (tmpScope && tmpScope.indexOf(pCategory.Hash) < 0) return;
			let tmpItems = (pCategory.Children || []).filter((pItem) =>
				(!tmpGlobalFilter || tmpGlobalFilter(pItem, pCategory)) &&
				(!tmpFilter || tmpFilter(pItem, pCategory)) &&
				(tmpShowAdvanced || !pItem.Advanced || (tmpQuery && this.matchesNode(pItem, tmpQuery))) &&
				this.matchesNode(pItem, tmpQuery));
			if (tmpItems.length === 0) return;
			// When searching, rank items within the category (title before description); browsing keeps authored order.
			tmpItems = this._rankNodes(tmpItems, (pItem) => pItem, tmpQuery);
			tmpResult.push(Object.assign({}, pCategory, { Items: tmpItems }));
		});
		return tmpResult;
	}

	/**
	 * A flat, query-filtered list of leaf items across all categories (advanced included
	 * once a query is present). Used by the command-palette view.
	 *
	 * Pass `Scope` / `Filter` (same semantics as getFilteredCategories) to pre-filter.
	 *
	 * @param {string} [pQuery]
	 * @param {{Scope?: Array<string>, Filter?: Function}} [pOptions]
	 * @returns {Array<{Item: Object, Category: Object}>}
	 */
	searchFlat(pQuery, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpQuery = (typeof pQuery === 'string' ? pQuery : this.getQuery()).trim().toLowerCase();
		const tmpScope = Array.isArray(tmpOptions.Scope) ? tmpOptions.Scope : null;
		const tmpFilter = (typeof tmpOptions.Filter === 'function') ? tmpOptions.Filter : null;
		const tmpGlobalFilter = this._globalFilter;
		const tmpResult = [];
		this.getNavigationGraph().forEach((pCategory) =>
		{
			if (tmpScope && tmpScope.indexOf(pCategory.Hash) < 0) return;
			(pCategory.Children || []).forEach((pItem) =>
			{
				if (tmpGlobalFilter && !tmpGlobalFilter(pItem, pCategory)) return;
				if (tmpFilter && !tmpFilter(pItem, pCategory)) return;
				if (this.matchesNode(pItem, tmpQuery)) tmpResult.push({ Item: pItem, Category: pCategory });
			});
		});
		// Rank: title matches before description/keyword matches, tighter matches first (ties keep graph order).
		return this._rankNodes(tmpResult, (pEntry) => pEntry.Item, tmpQuery);
	}

	// ── Render helpers ───────────────────────────────────────────────────────

	escapeHTML(pStr)
	{
		return String(pStr == null ? '' : pStr).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	/** HTML-escape, then wrap query tokens in <mark> for match highlighting. */
	highlight(pText, pQuery)
	{
		let tmpOut = this.escapeHTML(pText);
		const tmpQuery = (pQuery || '').trim();
		if (!tmpQuery) return tmpOut;
		tmpQuery.split(/\s+/).filter(Boolean).forEach((pTok) =>
		{
			const tmpEsc = pTok.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			tmpOut = tmpOut.replace(new RegExp('(' + tmpEsc + ')', 'ig'), '<mark class="pict-nav-mark">$1</mark>');
		});
		return tmpOut;
	}

	// ── Navigation ───────────────────────────────────────────────────────────

	/**
	 * Activate a navigation node. Resolves a hash to its node, marks it active, then
	 * hands off to the host OnNavigate handler if one is configured; otherwise falls
	 * back to hash-route navigation for `Route` values that start with '#'.
	 *
	 * @param {Object|string} pNodeOrHash
	 */
	navigate(pNodeOrHash)
	{
		const tmpNode = (typeof pNodeOrHash === 'string') ? this.getNodeByHash(pNodeOrHash) : pNodeOrHash;
		if (!tmpNode)
		{
			this.log.warn(`PictNavigation.navigate: node not found for [${pNodeOrHash}].`);
			return;
		}
		this.setActive(tmpNode.Hash);
		this.log.info(`PictNavigation: navigate -> ${tmpNode.Name} (${tmpNode.Route || tmpNode.Hash})`);

		// A navigation always dismisses the launcher overlay if it was open.
		if (this.isLauncherOpen()) { this.closeLauncher(); }

		if (typeof this.onNavigate === 'function')
		{
			this.onNavigate(tmpNode);
			return;
		}
		if (typeof tmpNode.Route === 'string' && tmpNode.Route.charAt(0) === '#' && typeof window !== 'undefined' && window.location)
		{
			window.location.hash = tmpNode.Route.replace(/^#/, '');
		}
	}

	/**
	 * Convenience: point a render-type view at a destination and render it. pRenderType
	 * is 'Hub' | 'Sidebar' | 'Palette' | 'List' (the view hash suffix).
	 *
	 * Pass `pOptions.Scope` (category-hash array) / `pOptions.Filter` (item predicate) to
	 * render a pre-filtered subset. Both are always applied (defaulting to none) so a prior
	 * scoped render does not leak into an unscoped one on the same shared view.
	 *
	 * @param {string} pRenderType
	 * @param {string} [pDestinationAddress]
	 * @param {{Scope?: Array<string>, Filter?: Function}} [pOptions]
	 */
	render(pRenderType, pDestinationAddress, pOptions)
	{
		const tmpView = this.pict.views['Navigation-' + pRenderType];
		if (!tmpView)
		{
			this.log.warn(`PictNavigation.render: unknown render type [${pRenderType}].`);
			return null;
		}
		if (pDestinationAddress)
		{
			tmpView.options.DefaultDestinationAddress = pDestinationAddress;
			if (Array.isArray(tmpView.options.Renderables))
			{
				tmpView.options.Renderables.forEach((pRenderable) => { pRenderable.DestinationAddress = pDestinationAddress; });
			}
		}
		const tmpOptions = pOptions || {};
		tmpView.options.Scope = Array.isArray(tmpOptions.Scope) ? tmpOptions.Scope : null;
		tmpView.options.Filter = (typeof tmpOptions.Filter === 'function') ? tmpOptions.Filter : null;
		tmpView.render();
		return tmpView;
	}

	/**
	 * Render the Sidebar render type in DOCKED mode (rail only, no detail pane) into a
	 * destination — the persistent-application-sidebar form. Item clicks navigate the host.
	 * Returns the docked sidebar view (call .syncActive() on it after external navigations).
	 *
	 * @param {string} pDestinationAddress
	 */
	renderSidebarDocked(pDestinationAddress)
	{
		// A dedicated docked instance (ShowDetail false) distinct from the two-pane 'Navigation-Sidebar'.
		if (!this.pict.views['Navigation-Sidebar-Docked'])
		{
			this.pict.addViewSingleton('Navigation-Sidebar-Docked', Object.assign({}, libViewSidebar.default_configuration,
				{
					ViewIdentifier: 'Navigation-Sidebar-Docked',
					NavigationProviderHash: this.options.ProviderIdentifier,
					ShowDetail: false,
					DefaultDestinationAddress: pDestinationAddress || '#Navigation-Container',
					Renderables:
					[
						{ RenderableHash: 'Navigation-Sidebar-Wrap', TemplateHash: 'Navigation-Sidebar-Container', DestinationAddress: pDestinationAddress || '#Navigation-Container', RenderType: 'replace' }
					]
				}), libViewSidebar);
		}
		return this.render('Sidebar-Docked', pDestinationAddress);
	}

	// ── Command-palette launcher overlay ───────────────────────────────────────

	/** Ensure the body-level launcher overlay container exists (backdrop + centered card). */
	_ensureLauncherDOM()
	{
		if (typeof document === 'undefined') return;
		if (document.getElementById('PictNavLauncher')) return;
		// Body-level overlay chrome — a documented exception to the "no direct DOM" rule
		// (same category as a popover/tooltip; there is no renderable destination for it yet).
		const tmpContainer = document.createElement('div');
		tmpContainer.id = 'PictNavLauncher';
		tmpContainer.className = 'pict-nav-launcher';
		document.body.appendChild(tmpContainer);
		const tmpProviderRef = `_Pict.providers['${this.options.ProviderIdentifier}']`;
		this.pict.ContentAssignment.assignContent('#PictNavLauncher',
			`<div class="pict-nav-launcher-backdrop" onclick="${tmpProviderRef}.closeLauncher()"></div>` +
			`<div class="pict-nav-launcher-card" id="PictNavLauncher-Card" role="dialog" aria-modal="true" aria-label="Jump to"></div>`);
	}

	/** Open the command-palette launcher overlay (fresh, empty query) and focus its input. */
	openLauncher()
	{
		this._ensureLauncherDOM();
		const tmpView = this.pict.views['Navigation-Launcher'];
		if (tmpView)
		{
			tmpView._localQuery = '';
			tmpView.render();
		}
		this.pict.CSSMap.injectCSS();
		this.pict.ContentAssignment.addClass('#PictNavLauncher', 'is-open');
		this._launcherOpen = true;
		// Focus the search input on the next tick (after the overlay is painted/visible).
		const fFocus = () =>
		{
			const tmpInput = this.pict.ContentAssignment.getElement('#PictNavLauncher input');
			if (tmpInput && tmpInput[0] && typeof tmpInput[0].focus === 'function') { tmpInput[0].focus(); }
		};
		if (typeof setTimeout === 'function') { setTimeout(fFocus, 0); } else { fFocus(); }
		return this;
	}

	/** Hide the launcher overlay. */
	closeLauncher()
	{
		this.pict.ContentAssignment.removeClass('#PictNavLauncher', 'is-open');
		this._launcherOpen = false;
		return this;
	}

	toggleLauncher() { return this._launcherOpen ? this.closeLauncher() : this.openLauncher(); }

	isLauncherOpen() { return !!this._launcherOpen; }

	/**
	 * Install a single, safe global keydown handler for the launcher:
	 *   • Cmd/Ctrl+K  → toggle the launcher overlay (the Slack/Linear quick-switcher key)
	 *   • Escape      → close the launcher (only when it is open; otherwise left alone)
	 * Idempotent; returns an unbind function. This is a documented exception to the
	 * "no addEventListener" rule — a browser-level global shortcut has no inline equivalent.
	 *
	 * @returns {Function} unbind
	 */
	bindLauncherHotkey()
	{
		if (typeof document === 'undefined') { return () => {}; }
		if (this._hotkeyBound) { return this._hotkeyUnbind; }
		const fHandler = (pEvent) =>
		{
			if (!pEvent) return;
			const tmpKey = (pEvent.key || '').toLowerCase();
			if ((pEvent.metaKey || pEvent.ctrlKey) && !pEvent.altKey && tmpKey === 'k')
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				this.toggleLauncher();
				return;
			}
			if (tmpKey === 'escape' && this.isLauncherOpen())
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				this.closeLauncher();
			}
		};
		// Capture phase so we intercept before focused inputs (e.g. the palette's own keydown).
		document.addEventListener('keydown', fHandler, true);
		this._hotkeyBound = true;
		this._hotkeyUnbind = () =>
		{
			document.removeEventListener('keydown', fHandler, true);
			this._hotkeyBound = false;
			this._hotkeyUnbind = null;
		};
		this.log.info('PictNavigation: launcher hotkey bound (Cmd/Ctrl+K opens, Escape closes).');
		return this._hotkeyUnbind;
	}
}

/* The render types this section can produce, in display order. Layout 'page' renders
   as a home screen; 'rail' is a persistent docked sidebar. Hosts read this to build a
   navigation-style chooser without hard-coding the list. */
PictNavigationProvider.RenderTypes =
[
	{ Key: 'Sidebar', Label: 'Sidebar', Layout: 'rail', Icon: 'Menu', Blurb: 'A persistent docked rail on the left.' },
	{ Key: 'Hub', Label: 'Hub', Layout: 'page', Icon: 'Home', Blurb: 'Categorized cards — a settings home.' },
	{ Key: 'List', Label: 'List', Layout: 'page', Icon: 'More', Blurb: 'A scannable grouped list.' },
	{ Key: 'Palette', Label: 'Command Palette', Layout: 'page', Icon: 'Search', Blurb: 'A ⌘K-style search list.' }
];

/* Shared, themeable styling for every render type. Colors come from the pict theme
   tokens (--theme-color-*) with neutral fallbacks so the views look right with or
   without a theme provider. */
PictNavigationProvider.SharedCSS = /*css*/`
.pict-nav { color: var(--theme-color-text-primary, #1f2733); font-size: 14px; }
.pict-nav *, .pict-nav *::before, .pict-nav *::after { box-sizing: border-box; }
.pict-nav-mark { background: var(--theme-color-status-warning, #f2c94c); color: inherit; border-radius: 2px; padding: 0 1px; }

/* Search field */
.pict-nav-search { position: relative; }
.pict-nav-search input {
	width: 100%; font: inherit; font-size: 0.95rem; padding: 0.55rem 0.7rem 0.55rem 2.1rem;
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px;
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-search input:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 18%, transparent); }
.pict-nav-search .pict-nav-search-ic { position: absolute; left: 0.7rem; top: 50%; transform: translateY(-50%);
	color: var(--theme-color-text-muted, #6b7686); pointer-events: none; }

/* Advanced toggle — right-aligned under the search box, with a little top + right
   breathing room so "Show advanced" doesn't crowd the search box's right edge. */
.pict-nav-adv { display: flex; justify-content: flex-end; align-items: center; gap: 0.4rem; font-size: 0.8rem;
	color: var(--theme-color-text-secondary, #45505f); cursor: pointer; user-select: none;
	padding: 0.4rem 0.35rem 0 0; }

/* Icon chip */
.pict-nav-ic { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 38px; height: 38px; border-radius: 9px; background: var(--theme-color-background-tertiary, #eceef2); }

/* Empty state */
.pict-nav-empty { text-align: center; color: var(--theme-color-text-muted, #6b7686); padding: 2.5rem 1rem; }

/* Command-palette launcher overlay (⌘K). The card hosts the palette render type. */
.pict-nav-launcher { position: fixed; inset: 0; z-index: 6000; display: none; }
.pict-nav-launcher.is-open { display: block; }
.pict-nav-launcher-backdrop { position: absolute; inset: 0;
	background: color-mix(in srgb, var(--theme-color-text-primary, #1f2733) 42%, transparent); }
.pict-nav-launcher-card { position: absolute; left: 50%; top: 13vh; transform: translateX(-50%);
	width: min(660px, 94vw); animation: pict-nav-launcher-in 0.12s ease-out; }
.pict-nav-launcher-card .pict-nav-pl { max-height: 68vh; }
@keyframes pict-nav-launcher-in { from { opacity: 0; transform: translate(-50%, -6px); } to { opacity: 1; transform: translate(-50%, 0); } }
`;

module.exports = PictNavigationProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"../views/PictView-Navigation-Hub.js":284,"../views/PictView-Navigation-List.js":285,"../views/PictView-Navigation-Palette.js":286,"../views/PictView-Navigation-Sidebar.js":287,"pict-provider":177}],284:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: HUB
 *
 * Categorized cards with inline descriptions and a live search. The "settings home"
 * pattern — best for discoverability and always-visible help.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-Hub",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowAdvancedToggle": true,
	"SearchPlaceholder": "Search…",

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-Hub-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-Hub-Container", "Template": html`<div class="pict-nav-hub-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-Hub-Wrap",
			"TemplateHash": "Navigation-Hub-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-hub-head { display: flex; gap: 0.75rem; align-items: center; margin-bottom: 1.25rem; }
.pict-nav-hub-head .pict-nav-search { flex: 1 1 auto; }
.pict-nav-hub-cat { margin-bottom: 1.9rem; }
.pict-nav-hub-cat-head { display: flex; align-items: baseline; gap: 0.55rem; margin-bottom: 0.8rem; padding-bottom: 0.4rem; border-bottom: 2px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-hub-cat.is-secondary .pict-nav-hub-cat-head { border-bottom-style: dashed; }
.pict-nav-hub-cat-head h3 { font-size: 1.12rem; font-weight: 700; margin: 0; color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-hub-cat-ic { color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-hub-cat-blurb { color: var(--theme-color-text-muted, #6b7686); font-size: 0.84rem; }
.pict-nav-hub-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 0.8rem; }
.pict-nav-hub-card { display: flex; gap: 0.8rem; align-items: flex-start; padding: 0.95rem 1rem; text-decoration: none; color: inherit;
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 11px;
	transition: box-shadow .14s ease, transform .14s ease, border-color .14s ease; }
.pict-nav-hub-card:hover { box-shadow: 0 8px 20px color-mix(in srgb, var(--theme-color-shadow-color, rgba(15,23,42,0.12)) 80%, transparent);
	transform: translateY(-2px); border-color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-hub-card .pict-nav-ic { color: var(--theme-color-brand-primary, #156dd1); font-size: 1.4rem; display: inline-flex; align-items: center; }
.pict-nav-hub-card-text { min-width: 0; }
.pict-nav-hub-card-name { display: block; font-weight: 650; line-height: 1.15; }
.pict-nav-hub-card-desc { display: block; font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 3px; line-height: 1.38; }
.pict-nav-adv-pill { font-size: 0.6rem; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 7px; margin-left: 6px; vertical-align: middle; }
`
};

class PictViewNavigationHub extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	_resultsAddress()
	{
		return '#PictNav-Hub-Results-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-search">
					<span class="pict-nav-search-ic">${this.pict.icon('Search')}</span>
					<input type="text" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(tmpProvider.getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" />
				</div>` : '';
			const tmpAdvanced = this.options.ShowAdvancedToggle ? `
				<label class="pict-nav-adv"><input type="checkbox" ${tmpProvider.getShowAdvanced() ? 'checked' : ''} onchange="${tmpHandler}.onToggleAdvanced(this.checked)" /> Show advanced</label>` : '';
			const tmpShell = `<div class="pict-nav pict-nav-hub">
				<div class="pict-nav-hub-head">${tmpSearch}${tmpAdvanced}</div>
				<div id="${this._resultsAddress().slice(1)}" class="pict-nav-hub-results"></div>
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaint();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild the (search-filtered) results area without disturbing the search input. */
	repaint()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = tmpProvider.getQuery();
		const tmpCategories = tmpProvider.getFilteredCategories({ Scope: this.options.Scope, Filter: this.options.Filter });

		let tmpHTML = '';
		tmpCategories.forEach((pCategory) =>
		{
			const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
			tmpHTML += `<section class="pict-nav-hub-cat ${pCategory.Secondary ? 'is-secondary' : ''}">
				<header class="pict-nav-hub-cat-head"><span class="pict-nav-hub-cat-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span><h3>${tmpProvider.escapeHTML(pCategory.Name)}</h3>${pCategory.Blurb ? `<span class="pict-nav-hub-cat-blurb">${tmpProvider.escapeHTML(pCategory.Blurb)}</span>` : ''}</header>
				<div class="pict-nav-hub-grid">`;
			pCategory.Items.forEach((pItem) =>
			{
				const tmpAccent = pItem.Accent || pCategory.Accent;
				const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
				tmpHTML += `<a class="pict-nav-hub-card" href="${pItem.Route ? tmpProvider.escapeHTML(pItem.Route) : '#'}" onclick="return ${tmpHandler}.activate('${pItem.Hash}', event)">
					<span class="pict-nav-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
					<span class="pict-nav-hub-card-text"><span class="pict-nav-hub-card-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}${pItem.Advanced ? '<span class="pict-nav-adv-pill">adv</span>' : ''}</span>${pItem.Description ? `<span class="pict-nav-hub-card-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
				</a>`;
			});
			tmpHTML += `</div></section>`;
		});
		if (tmpCategories.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">Nothing matches your search.</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._resultsAddress(), tmpHTML);
	}

	onSearch(pValue)
	{
		this.navigationProvider.setQuery(pValue);
		this.repaint();
	}

	onToggleAdvanced(pChecked)
	{
		this.navigationProvider.setShowAdvanced(pChecked);
		this.repaint();
	}

	activate(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.navigate(pHash);
		return false;
	}
}

module.exports = PictViewNavigationHub;
module.exports.default_configuration = default_configuration;

},{"pict-view":365}],285:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: LIST
 *
 * A scannable single-column, grouped settings list (iOS / Stripe-settings style):
 * each category is a rounded "group" card whose rows carry a name, a one-line
 * description and a chevron. Best for a top-to-bottom directory where every setting
 * gets an inline explanation. Shares the live search + advanced toggle of the hub.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-List",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowAdvancedToggle": true,
	"SearchPlaceholder": "Search…",

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-List-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-List-Container", "Template": html`<div class="pict-nav-list-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-List-Wrap",
			"TemplateHash": "Navigation-List-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-list-wrap { max-width: 780px; margin: 0 auto; }
.pict-nav-list-head { margin-bottom: 1.1rem; }
.pict-nav-list-head .pict-nav-search { flex: 1 1 auto; }
.pict-nav-list-head-row { display: flex; gap: 0.75rem; align-items: center; }
.pict-nav-list-group { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0);
	border-radius: 12px; overflow: hidden; margin-bottom: 1.1rem; }
.pict-nav-list-group.is-secondary { opacity: 0.96; }
.pict-nav-list-group-head { display: flex; align-items: center; gap: 0.6rem; padding: 0.8rem 1.1rem;
	background: var(--theme-color-background-tertiary, #eceef2); border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-list-group-head h3 { font-size: 1rem; font-weight: 700; margin: 0; color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-list-group-ic { color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-list-group-blurb { color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; margin-left: auto; text-align: right; }
.pict-nav-list-row { display: flex; align-items: center; gap: 0.9rem; padding: 0.8rem 1.1rem; text-decoration: none; color: inherit;
	border-top: 1px solid var(--theme-color-border-light, #e8ebf0); transition: background .12s ease; }
.pict-nav-list-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.pict-nav-list-row .pict-nav-ic { width: 34px; height: 34px; color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; display: inline-flex; align-items: center; justify-content: center; }
.pict-nav-list-row-text { min-width: 0; }
.pict-nav-list-row-name { display: block; font-weight: 600; line-height: 1.15; }
.pict-nav-list-row-desc { display: block; font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 1px; line-height: 1.35; }
.pict-nav-list-chev { margin-left: auto; color: var(--theme-color-text-muted, #6b7686); }
.pict-nav-adv-pill { font-size: 0.6rem; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 7px; margin-left: 6px; vertical-align: middle; }
`
};

class PictViewNavigationList extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	_resultsAddress()
	{
		return '#PictNav-List-Results-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-search">
					<span class="pict-nav-search-ic">${this.pict.icon('Search')}</span>
					<input type="text" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(tmpProvider.getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" />
				</div>` : '';
			const tmpAdvanced = this.options.ShowAdvancedToggle ? `
				<label class="pict-nav-adv"><input type="checkbox" ${tmpProvider.getShowAdvanced() ? 'checked' : ''} onchange="${tmpHandler}.onToggleAdvanced(this.checked)" /> Show advanced</label>` : '';
			const tmpShell = `<div class="pict-nav pict-nav-list">
				<div class="pict-nav-list-wrap">
					<div class="pict-nav-list-head">
						<div class="pict-nav-list-head-row">${tmpSearch}</div>
						${tmpAdvanced}
					</div>
					<div id="${this._resultsAddress().slice(1)}" class="pict-nav-list-results"></div>
				</div>
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaint();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild the (search-filtered) results area without disturbing the search input. */
	repaint()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = tmpProvider.getQuery();
		const tmpCategories = tmpProvider.getFilteredCategories({ Scope: this.options.Scope, Filter: this.options.Filter });

		let tmpHTML = '';
		tmpCategories.forEach((pCategory) =>
		{
			const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
			tmpHTML += `<section class="pict-nav-list-group ${pCategory.Secondary ? 'is-secondary' : ''}">
				<header class="pict-nav-list-group-head"><span class="pict-nav-list-group-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span><h3>${tmpProvider.escapeHTML(pCategory.Name)}</h3>${pCategory.Blurb ? `<span class="pict-nav-list-group-blurb">${tmpProvider.escapeHTML(pCategory.Blurb)}</span>` : ''}</header>`;
			pCategory.Items.forEach((pItem) =>
			{
				const tmpAccent = pItem.Accent || pCategory.Accent;
				const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
				tmpHTML += `<a class="pict-nav-list-row" href="${pItem.Route ? tmpProvider.escapeHTML(pItem.Route) : '#'}" onclick="return ${tmpHandler}.activate('${pItem.Hash}', event)">
					<span class="pict-nav-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
					<span class="pict-nav-list-row-text"><span class="pict-nav-list-row-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}${pItem.Advanced ? '<span class="pict-nav-adv-pill">adv</span>' : ''}</span>${pItem.Description ? `<span class="pict-nav-list-row-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
					<span class="pict-nav-list-chev">${this.pict.icon('ChevronRight')}</span>
				</a>`;
			});
			tmpHTML += `</section>`;
		});
		if (tmpCategories.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">Nothing matches your filter.</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._resultsAddress(), tmpHTML);
	}

	onSearch(pValue)
	{
		this.navigationProvider.setQuery(pValue);
		this.repaint();
	}

	onToggleAdvanced(pChecked)
	{
		this.navigationProvider.setShowAdvanced(pChecked);
		this.repaint();
	}

	activate(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.navigate(pHash);
		return false;
	}
}

module.exports = PictViewNavigationList;
module.exports.default_configuration = default_configuration;

},{"pict-view":365}],286:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: PALETTE
 *
 * A command-palette / ⌘K-style search list. A search box at the top filters a flat,
 * keyboard-navigable list of items (↑/↓ to move, Enter to open, Esc to clear). When the
 * search is empty the full directory is shown grouped by category; once a query is typed
 * the results collapse to a flat list with a per-row category tag. Rendered inline inside
 * its container (not a fixed overlay) so the host can position it.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-Palette",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowFooter": true,
	"SearchPlaceholder": "Search configuration, tools, analytics…",

	// When true the view keeps its own query string instead of the provider's shared
	// query state. The command-palette launcher overlay sets this so quick-jumping
	// never disturbs a docked sidebar / inline render that is sharing the provider.
	"UseLocalQuery": false,

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-Palette-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-Palette-Container", "Template": html`<div class="pict-nav-pl-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-Palette-Wrap",
			"TemplateHash": "Navigation-Palette-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-pl { display: flex; flex-direction: column; max-height: 76vh;
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0);
	border-radius: 14px; box-shadow: 0 18px 50px color-mix(in srgb, var(--theme-color-shadow-color, rgba(15,23,42,0.18)) 85%, transparent); overflow: hidden; }
.pict-nav-pl-head { display: flex; align-items: center; gap: 0.75rem; padding: 0.95rem 1.15rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-pl-head .pict-nav-pl-ic-search { color: var(--theme-color-text-muted, #6b7686); font-size: 1.05rem; display: inline-flex; align-items: center; }
.pict-nav-pl-head input { flex: 1 1 auto; border: none; outline: none; background: transparent; font: inherit; font-size: 1.18rem; color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-pl-head input::placeholder { color: var(--theme-color-text-muted, #6b7686); }
.pict-nav-pl-esc { font-size: 0.6rem; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 2px 8px; flex: 0 0 auto; }
.pict-nav-pl-results { overflow: auto; padding: 0.4rem; }
.pict-nav-pl-cat { font-size: 0.67rem; font-weight: 800; text-transform: uppercase; letter-spacing: .07em; color: var(--theme-color-text-muted, #6b7686); padding: 0.7rem 0.75rem 0.25rem; }
.pict-nav-pl-row { display: flex; align-items: center; gap: 0.85rem; padding: 0.55rem 0.75rem; border-radius: 9px; cursor: pointer; scroll-margin: 8px; }
.pict-nav-pl-row.hl { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, transparent); }
.pict-nav-pl-row .pict-nav-ic { width: 32px; height: 32px; font-size: 1.15rem; display: inline-flex; align-items: center; justify-content: center; }
.pict-nav-pl-text { min-width: 0; }
.pict-nav-pl-name { font-weight: 600; }
.pict-nav-pl-desc { display: block; font-size: 0.79rem; color: var(--theme-color-text-muted, #6b7686); line-height: 1.25; margin-top: 1px; }
.pict-nav-pl-tag { margin-left: auto; flex: 0 0 auto; font-size: 0.67rem; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 9px; white-space: nowrap; }
.pict-nav-pl-row.hl .pict-nav-pl-tag { display: none; }
.pict-nav-pl-enter { margin-left: auto; flex: 0 0 auto; font-size: 0.72rem; font-weight: 700; color: var(--theme-color-brand-primary, #156dd1); opacity: 0; }
.pict-nav-pl-row.hl .pict-nav-pl-enter { opacity: 1; }
.pict-nav-pl-adv-pill { font-size: 0.6rem; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 7px; margin-left: 6px; vertical-align: middle; }
.pict-nav-pl-foot { border-top: 1px solid var(--theme-color-border-light, #e8ebf0); padding: 0.5rem 0.95rem; font-size: 0.72rem;
	color: var(--theme-color-text-muted, #6b7686); display: flex; gap: 1.2rem; flex-wrap: wrap; }
.pict-nav-pl-foot kbd { background: var(--theme-color-background-tertiary, #eceef2); border-radius: 4px; padding: 0 5px; font: inherit; font-weight: 700; }
`
};

class PictViewNavigationPalette extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Keyboard-highlight index into the currently-visible rows.
		this._highlightIndex = 0;
		// Flat list of { Item, Category } for the currently-rendered rows (set during repaint).
		this._rows = [];
		// Local query string, used only when UseLocalQuery is set (launcher overlay).
		this._localQuery = '';
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	/** The active query — local to this view, or the provider's shared query. */
	_getQuery()
	{
		return this.options.UseLocalQuery ? (this._localQuery || '') : this.navigationProvider.getQuery();
	}

	_setQuery(pValue)
	{
		if (this.options.UseLocalQuery) { this._localQuery = String(pValue == null ? '' : pValue); }
		else { this.navigationProvider.setQuery(pValue); }
	}

	_resultsAddress()
	{
		return '#PictNav-Palette-Results-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-pl-head">
					<span class="pict-nav-pl-ic-search">${this.pict.icon('Search')}</span>
					<input type="text" autocomplete="off" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(this._getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" onkeydown="${tmpHandler}.onKey(event)" />
					<span class="pict-nav-pl-esc">esc</span>
				</div>` : '';
			const tmpFooter = this.options.ShowFooter ? `
				<div class="pict-nav-pl-foot"><span><kbd>↑</kbd> <kbd>↓</kbd> navigate</span><span><kbd>↵</kbd> open</span><span><kbd>esc</kbd> clear</span></div>` : '';
			const tmpShell = `<div class="pict-nav pict-nav-pl">
				${tmpSearch}
				<div id="${this._resultsAddress().slice(1)}" class="pict-nav-pl-results"></div>
				${tmpFooter}
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaint();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild ONLY the results region without disturbing the search input. */
	repaint()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = this._getQuery();

		this._rows = [];
		let tmpHTML = '';

		const fRenderRow = (pItem, pCategory, pFlat) =>
		{
			const tmpIdx = this._rows.length;
			this._rows.push({ Item: pItem, Category: pCategory });
			const tmpAccent = pItem.Accent || pCategory.Accent;
			const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
			const tmpTail = pFlat
				? `<span class="pict-nav-pl-tag">${tmpProvider.escapeHTML(pCategory.Name)}</span><span class="pict-nav-pl-enter">↵ open</span>`
				: `<span class="pict-nav-pl-enter">↵ open</span>`;
			return `<div class="pict-nav-pl-row" data-idx="${tmpIdx}" onmousemove="${tmpHandler}.setHighlight(${tmpIdx})" onclick="${tmpHandler}.openIndex(${tmpIdx})">
				<span class="pict-nav-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
				<span class="pict-nav-pl-text"><span class="pict-nav-pl-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}${pItem.Advanced ? '<span class="pict-nav-pl-adv-pill">adv</span>' : ''}</span>${pItem.Description ? `<span class="pict-nav-pl-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
				${tmpTail}
			</div>`;
		};

		if (!tmpQuery)
		{
			// Empty query: full directory, grouped by category with a header before each group. The palette is a
			// jump-to-anywhere surface with no advanced toggle of its own, so it always lists advanced items too
			// (ShowAdvanced: true); the query branch below already ignores the advanced gate via searchFlat.
			const tmpCategories = tmpProvider.getFilteredCategories({ Query: tmpQuery, Scope: this.options.Scope, Filter: this.options.Filter, ShowAdvanced: true });
			tmpCategories.forEach((pCategory) =>
			{
				tmpHTML += `<div class="pict-nav-pl-cat">${tmpProvider.escapeHTML(pCategory.Name)}</div>`;
				pCategory.Items.forEach((pItem) => { tmpHTML += fRenderRow(pItem, pCategory, false); });
			});
		}
		else
		{
			// Active query: flat list across all categories, each row tagged with its category.
			const tmpMatches = tmpProvider.searchFlat(tmpQuery, { Scope: this.options.Scope, Filter: this.options.Filter });
			tmpMatches.forEach((pMatch) => { tmpHTML += fRenderRow(pMatch.Item, pMatch.Category, true); });
		}

		if (this._rows.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">No matches. Try another word.</div>`;
		}

		this.pict.ContentAssignment.assignContent(this._resultsAddress(), tmpHTML);
		this._highlightIndex = 0;
		this._paintHighlight();
	}

	/** Toggle the `hl` class so the row at _highlightIndex is highlighted, and scroll it into view. */
	_paintHighlight()
	{
		const tmpRows = this.pict.ContentAssignment.getElement(this._resultsAddress() + ' .pict-nav-pl-row');
		if (!tmpRows) return;
		for (let i = 0; i < tmpRows.length; i++)
		{
			const tmpRow = tmpRows[i];
			if (!tmpRow || !tmpRow.classList) continue;
			tmpRow.classList.toggle('hl', i === this._highlightIndex);
		}
		const tmpActive = tmpRows[this._highlightIndex];
		if (tmpActive && typeof tmpActive.scrollIntoView === 'function')
		{
			tmpActive.scrollIntoView({ block: 'nearest' });
		}
	}

	onKey(pEvent)
	{
		if (!pEvent) return;
		const tmpMax = this._rows.length - 1;
		switch (pEvent.key)
		{
			case 'ArrowDown':
				pEvent.preventDefault();
				this._highlightIndex = Math.min(this._highlightIndex + 1, tmpMax);
				this._paintHighlight();
				break;
			case 'ArrowUp':
				pEvent.preventDefault();
				this._highlightIndex = Math.max(this._highlightIndex - 1, 0);
				this._paintHighlight();
				break;
			case 'Enter':
				pEvent.preventDefault();
				this.openIndex(this._highlightIndex);
				break;
			case 'Escape':
				pEvent.preventDefault();
				if (pEvent.target) { pEvent.target.value = ''; }
				this.onSearch('');
				break;
			default:
				break;
		}
	}

	setHighlight(pIndex)
	{
		this._highlightIndex = pIndex;
		this._paintHighlight();
	}

	openIndex(pIndex)
	{
		const tmpRow = this._rows[pIndex];
		if (tmpRow)
		{
			this.navigationProvider.navigate(tmpRow.Item.Hash);
		}
	}

	onSearch(pValue)
	{
		this._setQuery(pValue);
		this.repaint();
	}
}

module.exports = PictViewNavigationPalette;
module.exports.default_configuration = default_configuration;

},{"pict-view":365}],287:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: SIDEBAR
 *
 * A persistent grouped left rail with always-visible help and a detail pane on the
 * right. Selecting an item in the rail shows its detail (it does NOT navigate away);
 * the detail pane's "Open" button performs the actual navigation. The "search-first
 * sidebar" pattern — best for dense settings areas where you want a stable map of
 * everything on the left and contextual explanation on the right.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-Sidebar",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowAdvancedToggle": true,
	"SearchPlaceholder": "Search…",

	// ShowDetail true  → standalone two-pane home screen (rail + a detail pane that
	//                    explains the selected item; the detail's Open button navigates).
	// ShowDetail false → docked mode: just the rail, sized to fill its container, for use
	//                    as a persistent application sidebar. Clicking an item navigates
	//                    the host immediately (the host's main area is the "detail").
	"ShowDetail": true,

	"WelcomeHeading": "Configuration",
	"WelcomeBlurb": "Search or pick an area from the left. Each entry explains what it does.",

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-Sidebar-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-Sidebar-Container", "Template": html`<div class="pict-nav-sb-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-Sidebar-Wrap",
			"TemplateHash": "Navigation-Sidebar-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-sb-layout { display: flex; height: 100%; min-height: 360px; }
.pict-nav-sb-rail { flex: 0 0 330px; width: 330px; display: flex; flex-direction: column; min-height: 0;
	background: var(--theme-color-background-panel, #fff); border-right: 1px solid var(--theme-color-border-light, #e8ebf0); }
/* Docked mode: the rail is the whole thing (no detail pane), filling its host container. */
.pict-nav-sb-docked, .pict-nav-sb-docked .pict-nav-sb-layout { height: 100%; min-height: 0; }
.pict-nav-sb-docked .pict-nav-sb-rail { flex: 1 1 auto; width: 100%; border-right: none; }
.pict-nav-sb-rail-head { padding: 0.75rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-sb-rail-body { flex: 1 1 auto; overflow: auto; padding: 0.5rem 0.5rem 2rem; min-height: 0; }
.pict-nav-sb-group { margin-bottom: 0.35rem; }
.pict-nav-sb-group-head { display: flex; align-items: center; gap: 0.5rem; padding: 0.55rem 0.55rem 0.35rem;
	font-size: 0.72rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em;
	color: var(--theme-color-text-muted, #6b7686); cursor: pointer; user-select: none; }
.pict-nav-sb-group-head .pict-nav-sb-cat-ic { display: inline-flex; align-items: center; }
.pict-nav-sb-group-head .pict-nav-sb-chev { margin-left: auto; display: inline-flex; align-items: center;
	transition: transform 0.15s ease; }
.pict-nav-sb-group.collapsed .pict-nav-sb-chev { transform: rotate(-90deg); }
.pict-nav-sb-group.collapsed .pict-nav-sb-items { display: none; }
.pict-nav-sb-item { display: flex; gap: 0.6rem; align-items: flex-start; padding: 0.5rem 0.55rem;
	border-radius: 8px; text-decoration: none; color: inherit; }
.pict-nav-sb-item:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.pict-nav-sb-item.is-active { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, transparent);
	box-shadow: inset 3px 0 0 var(--theme-color-brand-primary, #156dd1); }
.pict-nav-sb-item .pict-nav-sb-item-ic { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 26px; height: 26px; border-radius: 7px; background: var(--theme-color-background-tertiary, #eceef2);
	color: var(--theme-color-brand-primary, #156dd1); margin-top: 1px; font-size: 1rem; }
.pict-nav-sb-item-text { min-width: 0; }
.pict-nav-sb-item-name { display: block; font-weight: 600; font-size: 0.9rem; line-height: 1.15; }
.pict-nav-sb-item-desc { display: block; font-size: 0.76rem; color: var(--theme-color-text-muted, #6b7686); line-height: 1.32; margin-top: 1px; }

.pict-nav-sb-main { flex: 1 1 auto; min-width: 0; overflow: auto; padding: 2.5rem 3rem;
	color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-sb-detail { max-width: 640px; }
.pict-nav-sb-detail-cat { font-size: 0.78rem; margin-bottom: 1rem; }
.pict-nav-sb-detail-head { display: flex; gap: 1.1rem; align-items: center; }
.pict-nav-sb-detail-ic { flex: 0 0 auto; width: 64px; height: 64px; border-radius: 16px; display: flex;
	align-items: center; justify-content: center; font-size: 1.7rem; background: var(--theme-color-background-tertiary, #eceef2);
	color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-sb-detail-title { font-size: 1.5rem; font-weight: 700; margin: 0 0 0.25rem; line-height: 1.15; }
.pict-nav-sb-detail-sub { color: var(--theme-color-text-muted, #6b7686); margin: 0; }
.pict-nav-sb-detail-actions { margin-top: 1.75rem; display: flex; align-items: center; gap: 0.85rem; flex-wrap: wrap; }
.pict-nav-sb-open { display: inline-flex; align-items: center; gap: 0.4rem; font: inherit; font-weight: 650; cursor: pointer;
	padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
	background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-text-on-brand, #fff); }
.pict-nav-sb-open:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 88%, #000); }
.pict-nav-sb-detail-route { font-size: 0.78rem; color: var(--theme-color-text-muted, #6b7686); }
.pict-nav-sb-detail-route code { background: var(--theme-color-background-tertiary, #eceef2); border-radius: 4px; padding: 1px 5px; }
.pict-nav-sb-adv-tag { font-size: 0.62rem; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b7686); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 999px; padding: 1px 8px; margin-left: 0.6rem; vertical-align: middle; }

.pict-nav-sb-welcome { max-width: 640px; }
.pict-nav-sb-welcome h1 { display: flex; align-items: center; gap: 0.5rem; font-size: 1.7rem; font-weight: 700; margin: 0 0 0.4rem; }
.pict-nav-sb-welcome h1 .pict-nav-sb-welcome-ic { color: var(--theme-color-brand-primary, #156dd1); display: inline-flex; }
.pict-nav-sb-welcome-sub { color: var(--theme-color-text-muted, #6b7686); font-size: 1.05rem; margin: 0 0 1.25rem; }
.pict-nav-sb-welcome hr { border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); margin: 0 0 1rem; }
.pict-nav-sb-welcome-cat { display: flex; gap: 0.6rem; align-items: center; padding: 0.5rem 0; }
.pict-nav-sb-welcome-cat .pict-nav-sb-welcome-cat-ic { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 34px; height: 34px; border-radius: 9px; background: var(--theme-color-background-tertiary, #eceef2); }
.pict-nav-sb-welcome-cat-blurb { color: var(--theme-color-text-muted, #6b7686); font-size: 0.84rem; }
`
};

class PictViewNavigationSidebar extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	_railAddress()
	{
		return '#PictNav-Sidebar-Rail-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	_detailAddress()
	{
		return '#PictNav-Sidebar-Detail-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-search">
					<span class="pict-nav-search-ic">${this.pict.icon('Search')}</span>
					<input type="text" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(tmpProvider.getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" />
				</div>` : '';
			const tmpAdvanced = this.options.ShowAdvancedToggle ? `
				<label class="pict-nav-adv"><input type="checkbox" ${tmpProvider.getShowAdvanced() ? 'checked' : ''} onchange="${tmpHandler}.onToggleAdvanced(this.checked)" /> Show advanced</label>` : '';
			const tmpDocked = !this.options.ShowDetail;
			const tmpDetail = tmpDocked ? '' : `<main id="${this._detailAddress().slice(1)}" class="pict-nav-sb-main"></main>`;
			const tmpShell = `<div class="pict-nav pict-nav-sb${tmpDocked ? ' pict-nav-sb-docked' : ''}">
				<div class="pict-nav-sb-layout">
					<aside class="pict-nav-sb-rail">
						<div class="pict-nav-sb-rail-head">${tmpSearch}${tmpAdvanced}</div>
						<div id="${this._railAddress().slice(1)}" class="pict-nav-sb-rail-body"></div>
					</aside>
					${tmpDetail}
				</div>
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaintRail();
			if (!tmpDocked) { this.repaintDetail(); }
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild the grouped rail body without disturbing the search input above it. */
	repaintRail()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = tmpProvider.getQuery();
		const tmpActiveHash = tmpProvider.getActive();
		const tmpCategories = tmpProvider.getFilteredCategories({ Scope: this.options.Scope, Filter: this.options.Filter });
		const tmpChevron = this.pict.icon('ChevronDown');

		let tmpHTML = '';
		tmpCategories.forEach((pCategory) =>
		{
			const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
			// A category can render collapsed by default (pCategory.Collapsed); an active search, or holding the
			// currently-active item, forces it open -- so navigating within a collapsed-by-default group (e.g. the
			// Settings group) does not fold it up under you on the repaint that follows the navigation.
			const tmpHoldsActive = !!tmpActiveHash && (pCategory.Items || []).some((pItem) => pItem.Hash === tmpActiveHash);
			const tmpCollapsed = (pCategory.Collapsed && !tmpQuery && !tmpHoldsActive) ? ' collapsed' : '';
			tmpHTML += `<div class="pict-nav-sb-group${tmpCollapsed}">
				<div class="pict-nav-sb-group-head" onclick="this.parentNode.classList.toggle('collapsed')">
					<span class="pict-nav-sb-cat-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span>
					<span>${tmpProvider.escapeHTML(pCategory.Name)}</span>
					<span class="pict-nav-sb-chev">${tmpChevron}</span>
				</div>
				<div class="pict-nav-sb-items">`;
			pCategory.Items.forEach((pItem) =>
			{
				const tmpAccent = pItem.Accent || pCategory.Accent;
				const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
				const tmpActive = (tmpActiveHash === pItem.Hash) ? ' is-active' : '';
				// Docked rail navigates immediately; two-pane shows the item in the detail pane.
				const tmpClick = this.options.ShowDetail ? 'select' : 'activate';
				tmpHTML += `<a class="pict-nav-sb-item${tmpActive}" href="${pItem.Route ? tmpProvider.escapeHTML(pItem.Route) : '#'}" title="${tmpProvider.escapeHTML(pItem.Description)}" onclick="return ${tmpHandler}.${tmpClick}('${pItem.Hash}', event)">
					<span class="pict-nav-sb-item-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
					<span class="pict-nav-sb-item-text"><span class="pict-nav-sb-item-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}</span>${pItem.Description ? `<span class="pict-nav-sb-item-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
				</a>`;
			});
			tmpHTML += `</div></div>`;
		});
		if (tmpCategories.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">No matches.</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._railAddress(), tmpHTML);
	}

	/** Rebuild the right-hand detail pane for the active node, or the welcome screen. */
	repaintDetail()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpActiveHash = tmpProvider.getActive();
		const tmpNode = tmpActiveHash ? tmpProvider.getNodeByHash(tmpActiveHash) : null;

		let tmpHTML;
		if (tmpNode)
		{
			const tmpIcStyle = tmpNode.Accent ? ` style="color:${tmpNode.Accent}"` : '';
			const tmpRoute = tmpNode.Route ? tmpProvider.escapeHTML(tmpNode.Route) : '';
			tmpHTML = `<div class="pict-nav-sb-detail">
				<div class="pict-nav-sb-detail-head">
					<span class="pict-nav-sb-detail-ic"${tmpIcStyle}>${tmpNode.Icon ? this.pict.icon(tmpNode.Icon) : ''}</span>
					<div>
						<h1 class="pict-nav-sb-detail-title">${tmpProvider.escapeHTML(tmpNode.Name)}${tmpNode.Advanced ? '<span class="pict-nav-sb-adv-tag">Advanced</span>' : ''}</h1>
						${tmpNode.Description ? `<p class="pict-nav-sb-detail-sub">${tmpProvider.escapeHTML(tmpNode.Description)}</p>` : ''}
					</div>
				</div>
				<div class="pict-nav-sb-detail-actions">
					<button type="button" class="pict-nav-sb-open" onclick="${tmpHandler}.activate('${tmpNode.Hash}', event)">${this.pict.icon('ExternalLink')} Open ${tmpProvider.escapeHTML(tmpNode.Name)}</button>
					${tmpRoute ? `<span class="pict-nav-sb-detail-route">Route: <code>${tmpRoute}</code></span>` : ''}
				</div>
			</div>`;
		}
		else
		{
			let tmpCats = '';
			tmpProvider.getNavigationGraph().forEach((pCategory) =>
			{
				const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
				tmpCats += `<div class="pict-nav-sb-welcome-cat">
					<span class="pict-nav-sb-welcome-cat-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span>
					<span><strong>${tmpProvider.escapeHTML(pCategory.Name)}</strong>${pCategory.Blurb ? ` <span class="pict-nav-sb-welcome-cat-blurb">— ${tmpProvider.escapeHTML(pCategory.Blurb)}</span>` : ''}</span>
				</div>`;
			});
			tmpHTML = `<div class="pict-nav-sb-welcome">
				<h1><span class="pict-nav-sb-welcome-ic">${this.pict.icon('Settings')}</span><span>${tmpProvider.escapeHTML(this.options.WelcomeHeading)}</span></h1>
				<p class="pict-nav-sb-welcome-sub">${tmpProvider.escapeHTML(this.options.WelcomeBlurb)}</p>
				<hr/>${tmpCats}</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._detailAddress(), tmpHTML);
	}

	/** Select an item: show its detail and move the active highlight. Does NOT navigate. */
	select(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.setActive(pHash);
		this.repaintRail();
		this.repaintDetail();
		return false;
	}

	/** Navigate to a node (the detail pane's "Open" button, or a docked-rail item click). */
	activate(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.navigate(pHash);
		// In docked mode the rail stays put — move the active highlight to the clicked item.
		this.syncActive();
		return false;
	}

	/**
	 * Re-paint the rail so its active highlight matches the provider's active node. Call
	 * this from the host after an external navigation (URL change, ⌘K launcher) so a
	 * docked sidebar reflects the current route.
	 */
	syncActive()
	{
		this.repaintRail();
		return this;
	}

	onSearch(pValue)
	{
		this.navigationProvider.setQuery(pValue);
		this.repaintRail();
	}

	onToggleAdvanced(pChecked)
	{
		this.navigationProvider.setShowAdvanced(pChecked);
		this.repaintRail();
	}
}

module.exports = PictViewNavigationSidebar;
module.exports.default_configuration = default_configuration;

},{"pict-view":365}],288:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;
const css = String.raw;

const hatchScale = 1000;

function buildHatchPattern(color, bounds)
{
	const scaleFactor = bounds.x > bounds.y ? bounds.x : bounds.y;
	const scale = scaleFactor / hatchScale;
	const svg = /*html*/`
		<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
			<pattern id="hatch" width="9" height="1" patternUnits="userSpaceOnUse" patternTransform="rotate(45) scale(${ scale })">
				<rect x="0" y="0" width="3" height="1" fill="${ color }" fill-opacity="30%"/>
			</pattern>
		</svg>
	`;
	return "url('data:image/svg+xml;utf8, " + encodeURIComponent(svg) + "#hatch') !important;";
}

const default_configuration = 
{
	"RenderOnLoad": true,
	"DefaultRenderable": "OpenSeaDragon-Wrap",
	"DefaultDestinationAddress": "#OpenSeaDragon-Container-Div",
	"EnableAnnotation": false,
	"DisableFullscreen": true,
	"DisableButtons": false,
	"PrefixUrl": '/',
	"TileSources": {},
	"ViewAddress": 'PictSectionOpenSeaDragon',
	"OSDASViewAddress": 'PictSectionOpenSeaDragonAnnotationSelector',
	"Colors": {
		"red": "red",
		"green": "green",
		"blue": "blue"
	},
	"Annotations": [],
	"DrawModeLabel": "Annotation",
	"HatchModeLabel": "Hatching",
	"Templates": [
		{
			"Hash": "OpenSeaDragon-Container",
			"Template": html`
				<div class="osd-container-wrapper" id="OSD-Containers-Wrapper">
					<div id="OpenSeaDragon-Element" class="osd-default"></div>
					<div id="OSD-Toolbar" class="osd-height-zero osd-toolbar">
						<div id="DrawingToolbar" class="osd-drawing-toolbar"></div>
						<div id="ColorPickerToolbar" class="osd-color-picker-toolbar"></div>
					</div>
					<div id="DrawingModeToggle" class="osd-height-zero osd-drawmode-toggle-box">
					</div>
				</div>
				<div id="OSD-SVG-Sandbox" class="osd-sandbox"></div>
				<style id="ColorOverrides"></style>
				<style id="SelectedColorOverride"></style>
				<style id="OSDGeneralStyling">
					.osd-drawmode-toggle-box {
						display: flex;
					}
					.osd-drawmode-text {
						font-size: 17px;
						font-family: Lato,sans-serif;
						margin-left: 5px;
						margin-right: 5px;
					}
					.osd-drawmode-switch {
						position: relative;
						display: inline-block;
						width: 40px;
						height: 20px;
						background-color: rgba(0, 0, 0, 0.25);
						border-radius: 20px;
						transition: all 0.3s;
						cursor: pointer;
					}
					.osd-drawmode-switch::after {
						content: '';
						position: absolute;
						width: 18px;
						height: 18px;
						border-radius:50%;
						background-color: white;
						top: 1px;
						left: 1px;
						transition: all 0.3s;
					}
					.osd-drawmode-checkbox:checked + .osd-drawmode-switch::after {
						left : 20px;
					}
					.osd-drawmode-checkbox:checked + .osd-drawmode-switch {
						background-color: var(--theme-color-brand-primary, #7983ff);
					}
					.osd-drawmode-checkbox {
						display : none;
					}
					.osd-hatchmode-toggle-box {
						display: flex;
					}
					.osd-hatchmode-text {
						font-size: 17px;
						font-family: Lato,sans-serif;
						margin-left: 5px;
						margin-right: 5px;
					}
					.osd-hatchmode-switch {
						position: relative;
						display: inline-block;
						width: 40px;
						height: 20px;
						background-color: rgba(0, 0, 0, 0.25);
						border-radius: 20px;
						transition: all 0.3s;
						cursor: pointer;
						margin-left: 20px;
					}
					.osd-hatchmode-switch::after {
						content: '';
						position: absolute;
						width: 18px;
						height: 18px;
						border-radius:50%;
						background-color: white;
						top: 1px;
						left: 1px;
						transition: all 0.3s;
					}
					.osd-hatchmode-checkbox:checked + .osd-hatchmode-switch::after {
						left : 20px;
					}
					.osd-hatchmode-checkbox:checked + .osd-hatchmode-switch {
						background-color: var(--theme-color-brand-primary, #7983ff);
					}
					.osd-hatchmode-checkbox {
						display : none;
					}
					.osd-sandbox {
						pointer-events: none; 
						width: 100vw; 
						height: 100vh; 
						top:0; left:0; 
						background-color: transparent; 
						position: absolute;
					}
					.osd-container-wrapper {
						width: 100%; 
						height: 100%; 
						display: flex; 
						flex-direction: column;
					}
					.osd-drawing-toolbar {
						min-width: 320px;
					}
					.osd-color-picker-toolbar {
						display: flex; 
						flex-direction: row;
					}
					.osd-default {
						margin-left: 20px; 
						height: 100%;
						width: calc(100% - 25px);
					}
					.osd-color-active {
						background-color: rgba(0, 0, 0, 0.3) !important;
					}
					.osd-with-annotations {
						height: calc(100% - 55px) !important;
					}
					.osd-height-zero {
						height: 0px !important;
					}
					.osd-width-zero {
						width: 0px !important;
					}
					.osd-color-button-class {
						margin:4px 4px 4px 0;
						background-color: transparent;
						cursor: pointer;
						border-radius: 4px;
						padding: 8px;
						width: 45px;
						height: 45px;
						border: 0px;
					}
					.osd-color-button-class:hover {
						background-color:rgba(0,0,0,0.05);
					}
					.osd-toolbar {
						height: 55px;
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
					}
					.osd-annotations-panel-open {
						width: 80% !important
					}
					.osd-color-subcircle {
						display: block;
						height: 20px;
						width: 20px;
						border: 1px solid black;
						border-radius: 50%;
						margin: auto;
					}
				</style>
			`
		}
	],

	"Renderables": [
		{
			"RenderableHash": "OpenSeaDragon-Wrap",
			"TemplateHash": "OpenSeaDragon-Container",
			"DestinationAddress": "#OpenSeaDragon-Container-Div",
			"RenderType": "replace"
		}
	],

	"TargetElementAddress": "#OpenSeaDragon-Container-Div"
};

class PictSectionOpenSeaDragon extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
		this.triggerRender = false;
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElementAddress = false;
	}

	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		this.hatchMode = false;
		let tmpTargetElementSet = this.services.ContentAssignment.getElement('#OpenSeaDragon-Element');
		if (tmpTargetElementSet.length < 1)
		{
			this.log.error(`Could not find target element [#OpenSeaDragon-Element] for OpenSeaDragon!  Rendering won't function properly.`);
			this.targetElement = false;
			return false;
		}
		else
		{
			this.targetElement = tmpTargetElementSet[0];
		}
		let tmpToolbarElementSet = this.services.ContentAssignment.getElement('#DrawingToolbar');
		if (tmpToolbarElementSet.length < 1)
		{
			this.log.error(`Could not find target element [#DrawingToolbar] for Annotator Toolbar!  Annotations won't function properly.`);
			this.toolbarElement = false;
			return false;
		}
		else
		{
			this.toolbarElement = tmpToolbarElementSet[0];
		}

		// Settings for configuring OpenSeaDragon.
		this.osdSettings = 
		{
			element: this.targetElement,
			prefixUrl: this.options.PrefixUrl,
			tileSources: this.options.TileSources,
			showFullPageControl: !this.options.DisableFullscreen,
			showZoomControl: !this.options.DisableButtons,
			showHomeControl: !this.options.DisableButtons
		};

		// Color formatter for Annotorious. Works with the styleClass attribute and the color class system which is config based.
		this.format = (annotation) => {
			return 'pict-osd-' + (annotation?.underlying?.target?.styleClass || (this.hatchMode ? this.color + '-hatched' : this.color) || 'red');
		};

		this.customConfigureViewerSettings();

		// Instantiate the OpenSeaDragon element.
		if (this.viewer)
		{
			this.viewer.destroy();
		}

		// Annotorious (and its plugin globals: Annotorious, SelectorPack, BetterPolygon, ...) is required by
		// default. Pass { Annotorious: false } in the view options to run as a plain OpenSeaDragon deep-zoom
		// viewer with no annotation layer, so a host need not load the Annotorious globals at all. Existing
		// consumers that do not set the flag are unaffected.
		this.annotoriousEnabled = (this.options.Annotorious !== false);
		// We only need to instantiate Annotorious if a set of annotations were passed in, or annotation editing is enabled.
		this.editingEnabled = this.annotoriousEnabled && this.options.EnableAnnotation && this.toolbarElement;

		this.viewer = OpenSeadragon(this.osdSettings);
		this.viewer.addHandler('open', () => {
			// Inject a stylesheet based on the set of colors passed into the component.
			let colorStyles = '';
			if (Object.keys(this.options?.Colors)?.length)
			{
				this.colorSet = this.options.Colors;
				for (let color of Object.keys(this.colorSet))
				{
					colorStyles += css`
						.pict-osd-${ color } > * {
							stroke: ${ this.colorSet[color] } !important;
							stroke-width: 2 !important;
						}
						.pict-osd-fill-${ color } {
							fill: ${ this.colorSet[color] } !important;
						}
						.pict-osd-${ color }-hatched > * {
							stroke: ${ this.colorSet[color] } !important;
							stroke-width: 2 !important;
							fill: ${ buildHatchPattern(this.colorSet[color], this.viewer?.world?.getItemAt(0)?.getContentSize() || { x: hatchScale, y: hatchScale }) }
						}
					`;
				}
			}
			else
			{
				this.assignColor('red');
				colorStyles += css`
					.pict-osd-red > * {
						stroke: red !important;
						stroke-width: 2 !important;
					}
				`;
			}
			this.pict.ContentAssignment.assignContent('#ColorOverrides', colorStyles);
			// If a custom color set was passed via config, add those custom colors to the toolbar if editing is enabled.
			if (this.colorSet && this.editingEnabled)
			{
				let colorSelectorTemplate = ``;
				for (let color of Object.keys(this.colorSet))
				{
					colorSelectorTemplate += html`
						<button type="button" class="osd-color-button-class" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.assignColor('${ color }')" id="ColorSelector${ color }">
							<div title="Color ${ color }" style="background-color: ${ this.colorSet[color] };" class="osd-color-subcircle"></div>
						</button>
					`;
				}
				this.pict.ContentAssignment.assignContent('#ColorPickerToolbar', `
					${ colorSelectorTemplate }
				`);
				this.assignColor(Object.keys(this.colorSet)[0]);
			}
			else
			{
				this.assignColor('red');
			}
		});

		if (this.annotoriousEnabled && (this.editingEnabled || this.options.Annotations?.length))
		{
			this.AnnotationsPanel = this.pict.views?.[this.options.OSDASViewAddress];
			if (!this.AnnotationsPanel)
			{
				this.triggerRender = true;
			}
			if (this.AnnotationsPanel && this.triggerRender)
			{
				this.triggerRender = false;
				this.AnnotationsPanel.render();
			}

			// Settings for configuring Annotorious.
			this.annoSettings = {
				allowEmpty: true,
				disableEditor: !this.editingEnabled,
				disableSelect: !this.editingEnabled
			};

			if (this.annotator){
				this.annotator.destroy();
			}

			// Instantiate Annotorious.
			this.annotator = OpenSeadragon.Annotorious(this.viewer, this.annoSettings);	

			// Apply the custom color formatter.
			this.annotator.formatters = [this.format];

			// Instantiate Annotorious Plugins.
			Annotorious.SelectorPack(this.annotator, 
			{
				tools: ['circle', 'ellipse', 'rect', 'freehand', 'polygon', 'line']
			});
			Annotorious.BetterPolygon(this.annotator);
			
			if (Annotorious.PictPack)
			{
				Annotorious.PictPack(this.annotator);
			}

			// If editing is enabled, reflow the ui to include the editing toolbar.
			if (this.editingEnabled)
			{
				this.pict.ContentAssignment.addClass('#OpenSeaDragon-Element', 'osd-with-annotations');
				this.pict.ContentAssignment.removeClass('#OSD-Toolbar', 'osd-height-zero');
				this.pict.ContentAssignment.removeClass('#DrawingModeToggle', 'osd-height-zero');
				Annotorious.Toolbar(this.annotator, this.toolbarElement, { withMouse: true, withTooltip:false });
			}

			//Inject any annotations passed via config.
			if (this.options.Annotations?.length)
			{
				for (let a of this.options.Annotations)
				{
					this.annotator.addAnnotation(a);
				}
				this.AnnotationsPanel?.updateAnnotationsPanel();
			}

			// Apply hooks for the annotation events.
			this.annotator.on('createAnnotation', (annotation, overrideID) => { this.annotationCreationHook(annotation, overrideID) });
			this.annotator.on('selectAnnotation', (annotation, element) => { this.annotationSelectionHook(annotation, element); });
			this.annotator.on('updateAnnotation', (annotation, previousState) => { this.annotationUpdateHook(annotation, previousState); });
			this.annotator.on('deleteAnnotation', (annotation) => { this.annotationDeleteHook(annotation); });
			this.annotator.on('createSelection', async (selection) => { this.selectionCreateHook(selection) });
			this.viewer.addHandler('canvas-double-click', (event) => { this.canvasDoubleClickHook(event); });

			if (this.editingEnabled)
			{
				const drawingModeTemplate = html`
					<input title="Toggle ${ this.options?.DrawModeLabel || 'Annotation' }" type="checkbox" id="osd-drawmode-toggle" class="osd-drawmode-checkbox" checked onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.toggleDrawingMode()"/>  
					<label for="osd-drawmode-toggle" class="osd-drawmode-switch"></label>
			 		<span title="Toggle ${ this.options?.DrawModeLabel || 'Annotation' }" class="osd-drawmode-text"> ${ this.options?.DrawModeLabel || 'Annotation' } </span>
					<input title="Toggle ${ this.options?.HatchModeLabel || 'Hatching' }" type="checkbox" id="osd-hatchmode-toggle" class="osd-hatchmode-checkbox" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.toggleHatchMode()"/>  
					<label for="osd-hatchmode-toggle" class="osd-hatchmode-switch"></label>
			 		<span title="Toggle ${ this.options?.HatchModeLabel || 'Hatching' }" class="osd-hatchmode-text"> ${ this.options?.HatchModeLabel || 'Hatching' } </span>`;
				this.pict.ContentAssignment.assignContent('#DrawingModeToggle', `
					${ drawingModeTemplate }
				`);
				const arrowToolButton = html`
					<button type="button" class="a9s-toolbar-btn arrow" title="Arrow" aria-label="Create a Arrow annotation" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.selectDrawingTool(event, 'arrow')">
						<span class="a9s-toolbar-btn-inner">
							<svg viewBox="0 0 70 50">
								<g>
									<path d="M 12 47 L 55 14 L 52 10 L 60 10 L 60 18 L 55 14 Z"></path>
									<g class="handles">
										<circle cx="12" cy="47" r="5"></circle>
									</g>
								</g>
							</svg>
						</span>
					</button>`;
				this.pict.ContentAssignment.appendContent('#DrawingToolbar .a9s-toolbar', arrowToolButton);
				this.annotator.disableEditor = false;
			}
		}
		else if (this.annotoriousEnabled)
		{
			// Instantiate Annotorious then destroy it in case there's any left over state that needs to be cleared.
			this.annotator = OpenSeadragon.Annotorious(this.viewer, {
				disableEditor: true,
				disableSelect: true
			});	
			this.annotator.destroy();
		}
	}

	// Set a new tile source. Can optionally rerender the component as well.
	setTileSources(tileSources, reRender)
	{
		this.options.TileSources = tileSources;
		if (reRender)
		{
			this.render();
		}
	}

	// Set an Annotation set. Can optionally rerender component as well.
	setAnnotations(annotations, reRender)
	{
		if (this.annotator) { this.annotator.clearAnnotations(); }
		this.options.Annotations = annotations;
		if (reRender)
		{
			this.render();
		}
	}

	/**
	 * This is expected to be overloaded with anything that needs to be added to the OpenSeaDragon configuration.
	 */
	customConfigureViewerSettings ()
	{
		// This can be overloaded to tweak this.osdSettings and this.annoSettings.
	}

	// Sets the current drawing color for annotations.
	assignColor (color)
	{
		this.color = color;
		if (this.colorSet)
		{
			for (let tempColor of Object.keys(this.colorSet))
			{
				this.pict.ContentAssignment.removeClass(`#ColorSelector${ tempColor }`, 'osd-color-active');
			}
		}

		// Set the active color in the toolbar.
		this.pict.ContentAssignment.addClass(`#ColorSelector${ color }`, 'osd-color-active');

		// Override the annotator drawing styles based on the selected color.
		this.pict.ContentAssignment.assignContent('#SelectedColorOverride', css`
			.a9s-annotation.editable.selected > g > * {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
			.a9s-selection > g > path {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
			.a9s-selection > * {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
		`);
	}

	/**
	 * @spec focuses the viewport on the referenced annotation, if one exists
	 * @param { number | string } annotationID - the id of an annotation
	 * @returns {void}
	 */
	focusOnAnnotation(annotationID)
	{
		this.log.debug(`[focusOnAnnotation] id[${annotationID}]`);
		if (!annotationID)
		{
			this.log.warn('[focusOnAnnotation] no id provided, cannot focus on the associated element');
			return;
		}
		this.annotator.fitBoundsWithConstraints(annotationID);
	}

	/**
	 * @param {object} point - something like an OpenSeaDragon.Point, anything with an x and y property
	 */
	focusOnPoint(point)
	{
		let vp = this.viewer.viewport.viewerElementToViewportCoordinates(point);
		this.viewer.viewport.panTo(vp);
		// TODO should we re-apply constraints here? Not sure it's needed...
	}

	// Hook that runs when an annotation gets selected. By default, this just stores the style of the annotation element as part of the annotation.
	annotationCreationHook (annotation, overrideID)
	{
		if (annotation?.target){
			annotation.stylesheet = this.hatchMode ? 
			{
				"type": "CssStylesheet",
				"value": css`
					.${ this.color }-hatched > * { 
						stroke: ${ this.colorSet?.[this.color] } !important;
						stroke-width: 2 !important; 
						fill: ${ buildHatchPattern(this.colorSet?.[this.color], this.viewer?.world?.getItemAt(0)?.getContentSize() || { x: hatchScale, y: hatchScale }) }
					}
				`
			} :
			{
				"type": "CssStylesheet",
				"value": css`
					.${ this.color } > * { 
						stroke: ${ this.colorSet?.[this.color] } !important;
						stroke-width: 2 !important; 
					}
				`
			};
			annotation.target.styleClass = this.hatchMode ? `${ this.color }-hatched` : this.color;
		}
		this.AnnotationsPanel?.updateAnnotationsPanel();
	}

	// Hook that runs when an annotation gets selected. By default, this just sets the current color to whatever the selected annotation is.
	annotationSelectionHook (annotation, element)
	{
		this.assignColor(annotation?.target?.styleClass?.replace('-hatched', '') || 'red');
		if (annotation?.target?.styleClass?.includes('hatched'))
		{
			document.querySelector('#osd-hatchmode-toggle').checked = true;
			this.hatchMode = true;
		}
		else
		{
			document.querySelector('#osd-hatchmode-toggle').checked = false;
			this.hatchMode = false;
		}
		this.releaseAnnotations();
		this.focusOnAnnotation(annotation.id);
	}

	// Hook that runs when an annotation gets updated. By default this is used for updating the state of the comments side bar.
	annotationUpdateHook (annotation, previousState)
	{
		if (this.annotator?.disableEditor)
		{
			setTimeout(()=>
			{
				this.AnnotationsPanel?.updateAnnotationsPanel();
			}, 10);
		}
		else
		{
			this.AnnotationsPanel?.updateAnnotationsPanel();
		}
	}

	// Hook that runs when an annotation gets delete. By default this is used for updating the state of the comments side bar.
	annotationDeleteHook (annotation)
	{
		this.AnnotationsPanel?.updateAnnotationsPanel();
	}

	/**
	 * @spec handles the createSelection event.
	 * @param {object} selection - selection object from Annotorious API
	 */
	async selectionCreateHook (selection)
	{
		if (this.annotator.disableEditor)
		{
			// note: this updateSelected is async
			this.annotator.updateSelected(selection, true);
		}
		/**
		 * ideal: focus on selection so user can better interact with it in the viewport.
		 * Issue is, the selection doesn't yet have an ID, so cannot tell
		 * Annotorious to adjust the viewport for us.
		 * this.focusOnAnnotation(selection.id);
		 */
	}

	/**
	 *
	 * @returns {boolean} value of "current zoom >= max zoom (configured for osd)"
	 */
	maxZoomReached ()
	{
		const maxZoom = this.viewer.viewport.getMaxZoom();
		const zoom = this.viewer.viewport.getZoom(true);
		return zoom >= maxZoom;
	}

	/**
	 * @spec focuses on the point where the user double clicked.
	 * @spec we only refocus when maxZoom has been reached to avoid clashing with single click zoom behavior
	 * @param {object} event
	 */
	canvasDoubleClickHook (event)
	{
		if (this.maxZoomReached())
		{
			this.focusOnPoint(event.position);
		}
	}

	// Toggles the annotator between "drawing only" mode and "commenting" mode.
	toggleDrawingMode ()
	{
		if (this.annotator)
		{
			this.annotator.disableEditor = !this.annotator.disableEditor;
		}
	}

	// Toggle on/off the hatch fill mode.
	toggleHatchMode ()
	{
		this.hatchMode = !this.hatchMode;
	}

	selectDrawingTool(event, id)
	{
		this.toolbarElement.querySelector('.a9s-toolbar-btn.active')?.classList.remove('active');
		const button = event.target.closest('button');
		if (!button?.classList.contains('active'))
		{
			button.classList.add('active');
		}
		this.annotator.setDrawingTool(id);
      	this.annotator.setDrawingEnabled(true);
	}

	// Passes an annotation selection event onto the annotator plus does some extra handling to scroll it into view.
	selectAnnotation(id)
	{
		if (this.editingEnabled)
		{
			this.annotator.selectAnnotation(id);
		}
		for (let a of this.captureAnnotations())
		{
			if (a.id === id)
			{
				this.annotationSelectionHook(a);
			}
		}

		// Pan/Zoom the OSD controller to the annotation that is being selected.
		this.annotator.fitBoundsWithConstraints(id);
	}

	// Adds a connecting line between a comment and an element.
	connectAnnotation(id)
	{
		let isSelectionOpen = this.annotator.getSelected();
		if (isSelectionOpen) {
			this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
			return;
		}
		const safeID = id.replaceAll('#', '');
		this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
		const commentElement = this.pict.ContentAssignment.getElement(`#OSD-Comment-${ safeID }`);
		const annotationElement = this.pict.ContentAssignment.getElement(`[data-id="${ id }"]`);
		if (!commentElement?.[0] || !annotationElement?.[0])
		{
			this.log.warn('An expected element was missing, cannot render annotation connection with id: ', id);
			return;
		}
		const osdElementPosition = this?.viewer?.element?.getBoundingClientRect();
		const commentPosition = commentElement?.[0]?.getBoundingClientRect();
		let annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
		const isInView = () => 
		{
			return annotationPosition.top >= osdElementPosition.top &&
				   annotationPosition.left >= osdElementPosition.left &&
				   annotationPosition.left + annotationPosition.width <= osdElementPosition.left + osdElementPosition.width &&
				   annotationPosition.height + annotationPosition.height <= osdElementPosition.height + osdElementPosition.height;
		};
		const performGraphics = () => 
		{
			annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
			let colorClass = '';
			let fillClass = '';
			for (let a of this.captureAnnotations())
			{
				if (a.id === id)
				{
					colorClass = 'pict-osd-' + a?.target?.styleClass;
					fillClass = 'pict-osd-fill-' + a?.target?.styleClass;
				}
			}
			const lineTemplate = html`
				<style>
					.osd-connector-svg {
						z-index: 9999999;
						width: 100%;
						height: 100%;
					}
					.osd-connector-rect.osd-connector-specific {
						stroke: transparent !important;
					}
					.osd-connector-line.osd-connector-specific {
						stroke-width: 2.5 !important;
					}
				</style>
				<svg class="${ colorClass } osd-connector-svg">
					<rect class="osd-connector-rect osd-connector-specific" fill="rgb(255, 234, 0, 0.2)" x="${ annotationPosition.left }" y="${ annotationPosition.top }" width="${ annotationPosition.width }" height="${ annotationPosition.height }" />
					<line class="osd-connector-line osd-connector-specific" x1="${ commentPosition.left + 5  }" y1="${ commentPosition.top + 5 }" x2="${ annotationPosition.left + annotationPosition.width/2 }" y2="${ annotationPosition.top + annotationPosition.height/2 }" id="line1"/>
					<circle class="${ fillClass }" cx="${ annotationPosition.left + annotationPosition.width/2 }" cy="${ annotationPosition.top + annotationPosition.height/2 }" r="5" />
				</svg>`;

			const triggeringElement = this.pict.ContentAssignment.getElement(`#OSD-Comment-Outer-${ safeID }`);
			isSelectionOpen = this.annotator.getSelected();
			// Only render the svg elements if the user is still hovering and selection is not being edited.
			if (triggeringElement?.[0]?.matches(':hover') && !isSelectionOpen) {
				this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, lineTemplate);
			}
			else if (isSelectionOpen)
			{
				this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
			}
		}
		if (!isInView())
		{
			this.annotator.panTo(id);
			setTimeout(()=>
			{
				annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
				if (!isInView())
				{
					this.annotator.fitBoundsWithConstraints(id);
					setTimeout(()=>
					{
						performGraphics();
					}, 500);
				}
				else
				{
					performGraphics();
				}
			}, 1000)
		}
		else
		{
			performGraphics();
		}
	}

	// Removes any connecting lines between a comments and annotations.
	releaseAnnotations()
	{
		this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
	}

	/*
	 * Captures the current viewport relative to the overall image.
	 */
	captureViewport ()
	{
		if (this.viewer){
			return this.viewer.viewport.getBounds();
		}
		this.log.error('OpenSeaDragon is not initialized for some reason, giving back null.');
		return null;
	}

	/*
	 * Captures the annotation objects for the currently annotated image.
	 */
	captureAnnotations ()
	{
		if (this.annotator){
			return this.annotator.getAnnotations();
		}
		return [];
	}
		
}

module.exports = PictSectionOpenSeaDragon;
module.exports.default_configuration = default_configuration;


},{"pict-view":365}],289:[function(require,module,exports){
// The container for all the Pict-Section-Picker related code.
//
// pict-section-picker is a themeable, pict-native searchable select / combobox: a jQuery- and
// select2-free widget supporting single & multi select, search, server pagination, categorized
// groups and creatable entries. It is driven by a host-agnostic async DataProvider, and ships a
// built-in adapter for the pict EntityProvider (Meadow entities) for the common case.

// The picker provider (primary API surface — registers the widget view + CSS, and exposes
// createPicker() / data-source adapters).
const PictProviderPicker = require('./providers/Pict-Provider-Picker.js');

// The widget view (also auto-registered by the provider).
const PictViewPicker = require('./views/PictView-Picker.js');

module.exports = PictProviderPicker;

module.exports.PictProviderPicker = PictProviderPicker;
module.exports.PictViewPicker = PictViewPicker;

module.exports.default_configuration = PictProviderPicker.default_configuration;

},{"./providers/Pict-Provider-Picker.js":290,"./views/PictView-Picker.js":291}],290:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewPicker = require('../views/PictView-Picker.js');

// Themeable widget CSS. Registered once (by hash) regardless of how many picker instances exist.
// Host apps brand by defining the --theme-color-* tokens; the hardcoded values are fallbacks.
const _PickerCSS = /*css*/`
.pps { position: relative; width: 100%; box-sizing: border-box; }
.pps *, .pps *::before, .pps *::after { box-sizing: border-box; }
.pps-control { display: flex; align-items: center; gap: 0.5rem; width: 100%; cursor: pointer; font: inherit; font-size: 0.92rem;
	padding: 0.45rem 0.7rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); text-align: left; }
.pps-control:hover { border-color: var(--theme-color-border-strong, #c2c9d2); }
.pps.pps-open .pps-control { border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.pps-valuearea { flex: 1 1 auto; min-width: 0; }
.pps-value { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-value.pps-placeholder { color: var(--theme-color-text-muted, #6b7686); }
.pps-chevron { flex: 0 0 auto; display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; transition: transform 0.15s ease; }
.pps.pps-open .pps-chevron { transform: rotate(180deg); }
/* Read-only: render the resolved selection as plain, non-interactive text (no border / chevron / clear /
   dropdown). Used by read-only form views; the value text inherits the surrounding field styling. */
.pps-readonly .pps-control { border-color: transparent; background: transparent; padding-left: 0; padding-right: 0; cursor: default; pointer-events: none; }
.pps-readonly .pps-control:hover { border-color: transparent; box-shadow: none; }
.pps-readonly .pps-chevron, .pps-readonly .pps-clear, .pps-readonly .pps-chip-x { display: none; }
.pps-readonly .pps-pop, .pps-readonly .pps-backdrop { display: none; }
/* Clearable (AllowClear): the inline × next to the value (mirrors the chip ×) and the pinned "Any" row. */
.pps-clear { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.78rem; border-radius: 4px; padding: 0.1rem;
	color: var(--theme-color-text-muted, #6b7686); opacity: 0.7; }
.pps-clear:hover { opacity: 1; background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 22%, transparent); }
.pps-clear-option { border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pps-clear-option .pps-option-label { color: var(--theme-color-text-muted, #6b7686); font-style: italic; }

/* Multi-select chips. The control hosts a wrapping row of removable tags + a muted placeholder. */
.pps-multi .pps-control { align-items: flex-start; }
.pps-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 0.3rem; min-width: 0; }
.pps-chips-ph { color: var(--theme-color-text-muted, #6b7686);
	/* The placeholder is the ONLY chips-row child that is free text, so it is the one thing that can
	   force the control taller than a line. Single-select truncates (.pps-value above); multi did not,
	   so a long label wrapped and knocked neighbouring filters out of vertical alignment. Truncate to
	   match: min-width:0 lets it shrink inside the flex row, and it never wraps. */
	min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-chip { display: inline-flex; align-items: center; gap: 0.3rem; max-width: 100%; font-size: 0.82rem; line-height: 1.4;
	padding: 0.1rem 0.2rem 0.1rem 0.5rem; border-radius: 6px;
	background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, transparent);
	color: var(--theme-color-brand-primary, #156dd1); }
.pps-chip-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-chip-x { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.78rem; border-radius: 4px; padding: 0.1rem; opacity: 0.7; }
.pps-chip-x:hover { opacity: 1; background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 22%, transparent); }

/* Preview-card ⓘ — the opt-in affordance next to a selected value / chip. Stays clickable in
   read-only mode (where the control itself has pointer-events: none). */
.pps-card-info { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.82rem; padding: 0 0.1rem; opacity: 0.5; color: var(--theme-color-text-muted, #6b7686); }
.pps-card-info:hover { opacity: 1; color: var(--theme-color-brand-primary, #156dd1); }
.pps-readonly .pps-card-info { pointer-events: auto; }

/* EntityTag badge — a small code/number pill shown next to an option / chip / selected value (the
   select2 EntitySelector "tag" parity). Ordering (before/after the label) is driven by the TagLast
   option in the view's render state. */
.pps-tag { flex: 0 0 auto; display: inline-flex; align-items: center; font-size: 0.74rem; font-weight: 600; line-height: 1.25;
	padding: 0.05rem 0.4rem; border-radius: 5px; white-space: nowrap;
	background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
.pps-valuebox { display: flex; align-items: center; gap: 0.4rem; min-width: 0; }
.pps-valuebox .pps-value { min-width: 0; }
/* A long label wraps up to OptionLabelLines lines (--pps-option-lines, set on the list) and then ends in an
   ellipsis; the full text stays in the row's title tooltip. */
.pps-option-label { min-width: 0; overflow: hidden; overflow-wrap: anywhere; display: -webkit-box; -webkit-box-orient: vertical;
	-webkit-line-clamp: var(--pps-option-lines, 3); line-clamp: var(--pps-option-lines, 3); }
/* A row found by its ID (SearchByID): a muted "<Entity> #<ID>" after the label, in the open list only. */
.pps-option-idmatch { flex: 0 0 auto; margin-left: 0.5rem; font-size: 0.78rem; white-space: nowrap; color: var(--theme-color-text-muted, #6b7686); }

/* Transparent full-viewport backdrop: closes on outside click (no document listener). Only present
   while OPEN — otherwise a fixed full-viewport layer would swallow every click on the page. When open,
   the control is raised above it so its chips/× stay clickable; the dropdown sits above both. */
.pps-backdrop { position: fixed; inset: 0; z-index: 0; display: none; }
.pps.pps-open .pps-backdrop { display: block; }
.pps.pps-open .pps-control { position: relative; z-index: 1; }
/* Default anchoring: absolute against the control's own box (.pps is position:relative), so the panel
   rides page scroll for free — no measuring, no listeners. Works because a typical form row sets no
   overflow to clip it. */
.pps-pop { position: absolute; z-index: 40; top: calc(100% + 0.3rem); left: 0; right: 0; min-width: 200px; display: none; }
.pps.pps-open .pps-pop { display: block; }
/* Portal fallback, applied by the view when a clipping ancestor would cut the panel: it moves the pop to
   <body> and places it in DOCUMENT coords. Still absolute (not fixed) so it rides scroll like the
   default. On <body> it's outside the .pps.pps-open rule, so visibility keys off pps-pop-open — which
   also keeps a stray/orphaned portaled pop hidden. */
.pps-pop.pps-pop-portal { position: absolute; right: auto; display: none; }
.pps-pop.pps-pop-portal.pps-pop-open { display: block; }
.pps-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(60vh, 360px);
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
.pps-search { flex: 0 0 auto; display: flex; align-items: center; gap: 0.4rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pps-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
.pps-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.pps-list { flex: 1 1 auto; overflow-y: auto; padding: 0.25rem; }
.pps-option { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.9rem;
	padding: 0.45rem 0.6rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.pps-option:hover, .pps-option.pps-highlight { background: var(--theme-color-background-tertiary, #eceef2); }
.pps-option.pps-selected { color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
.pps-option-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); }
.pps-option-check.pps-hidden { visibility: hidden; }
.pps-empty { padding: 0.7rem 0.6rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.86rem; text-align: center; }
.pps-loading { padding: 0.6rem; text-align: center; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; }
.pps-more { display: block; width: calc(100% - 0.5rem); margin: 0.25rem; padding: 0.4rem; cursor: pointer; font: inherit; font-size: 0.85rem;
	border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; background: transparent; color: var(--theme-color-brand-primary, #156dd1); }
.pps-more:hover { background: var(--theme-color-background-tertiary, #eceef2); }

/* Category header (groups) + creatable "Create …" row. */
.pps-group { padding: 0.45rem 0.6rem 0.2rem; font-size: 0.72rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); }
.pps-create { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.9rem;
	padding: 0.45rem 0.6rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
.pps-create:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.pps-create-ic { flex: 0 0 auto; display: inline-flex; }

/* Field decoration (opt-in): the ⚙ toggle in the search row + the field chooser panel between search and
   list. The chooser mount stays empty (collapsed) until opened. */
.pps-decorate-btn { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.82rem;
	padding: 0.15rem; border: none; border-radius: 5px; background: transparent; color: var(--theme-color-text-muted, #6b7686); opacity: 0.7; }
.pps-decorate-btn:hover { opacity: 1; background: var(--theme-color-background-tertiary, #eceef2); }
.pps-decorate-btn.pps-decorate-on { color: var(--theme-color-brand-primary, #156dd1); opacity: 1; }
.pps-decorate-btn.pps-decorate-open { background: var(--theme-color-background-tertiary, #eceef2); opacity: 1; }
.pps-decorate-panel:empty { display: none; }
.pps-decorate { flex: 0 0 auto; max-height: 11rem; overflow-y: auto; padding: 0.5rem 0.7rem;
	border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-tertiary, #f4f6f9); }
.pps-decorate-title { font-size: 0.7rem; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.4rem; }
.pps-decorate-list { display: flex; flex-direction: column; gap: 0.05rem; }
.pps-decorate-opt { display: flex; align-items: center; gap: 0.45rem; cursor: pointer; font-size: 0.86rem; color: var(--theme-color-text-primary, #1f2733); padding: 0.15rem 0.1rem; }
.pps-decorate-opt:hover { color: var(--theme-color-brand-primary, #156dd1); }
.pps-decorate-opt input { flex: 0 0 auto; cursor: pointer; margin: 0; }
.pps-decorate-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-decorate-empty { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.1rem; }

/* Form-input adapter (pict-section-picker/form): the picker host fills its row like the host's
   native inputs (width:100% forces it to wrap below the label span + fill, matching a scalar input). */
.pps-form-host { flex: 1 1 100%; min-width: 0; width: 100%; }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Section-Picker',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// Opt-in fleet default: when true, every picker this provider creates closes any open sibling on
	// open (at most one dropdown on the page — select2 parity). Off by default so existing hosts see
	// no behavior change; a per-picker SingleActivePicker in createPicker's config overrides it.
	SingleActivePicker: false,
};

/**
 * The pict-section-picker provider — the primary API surface. Registers the widget CSS once and
 * creates/manages picker view instances.
 */
class PictProviderPicker extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Back-off bookkeeping, keyed by picker hash. On the provider (page-lived), not the DataProvider
		// closure, which createEntityPicker rebuilds on every marshal-driven re-mount.
		/** @type {Record<string, {Dropped: boolean, Term: string|null}>} */
		this.backOffState = {};

		// Hash of the picker whose dropdown is open (opt-in SingleActivePicker). A hash, not a view, and
		// provider-scoped so two pict instances on a page can't cross-close.
		/** @type {string|false} */
		this.currentOpenPickerHash = false;

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Picker-CSS', _PickerCSS, 500);
		}
	}

	/**
	 * Create (or reconfigure + reuse) a picker widget instance.
	 *
	 * @param {string} pPickerHash - A unique hash/id for this picker; the widget renders its control
	 *   into the DOM element `#<pPickerHash>` unless a DestinationAddress is given.
	 * @param {Record<string, any>} pConfig - Picker configuration:
	 *   - DestinationAddress {string} - CSS selector to render into (default `#<pPickerHash>`).
	 *   - ValueAddress {string} - AppData address the selection is read from / written to.
	 *   - Mode {'single'} - selection mode (multi/categories/creatable land in later phases).
	 *   - Placeholder {string} - text shown when nothing is selected.
	 *   - Searchable {boolean} - show the search box (default true).
	 *   - Options {Array<{Value:any, Text:string}>} - static option list.
	 *   - OnChange {function} - optional callback invoked with the new value after a selection.
	 *   - SingleActivePicker {boolean} - opt-in: opening this picker closes any open sibling
	 *     (defaults from the provider's own SingleActivePicker option).
	 * @return {any} The picker view instance.
	 */
	createPicker(pPickerHash, pConfig)
	{
		const tmpConfig = Object.assign(
			{
				DestinationAddress: `#${pPickerHash}`,
				Mode: 'single',
				Searchable: true,
				Placeholder: 'Select…',
				Options: [],
				// Seed the provider-level fleet default; an explicit per-picker value overrides it.
				SingleActivePicker: !!this.options.SingleActivePicker,
			},
			pConfig || {},
			// PickerProvider lets the view reach provider-scoped bookkeeping (the single-active slot)
			// without guessing the service hash this provider was registered under.
			{ PickerHash: pPickerHash, PickerProvider: this });

		if (this.pict.views[pPickerHash])
		{
			Object.assign(this.pict.views[pPickerHash].options, tmpConfig);
			return this.pict.views[pPickerHash];
		}
		return this.pict.addView(pPickerHash, tmpConfig, libPictViewPicker);
	}

	/**
	 * Build the Meadow FoxHound filter for a search term across one or more fields.
	 *
	 * The term is tokenized on whitespace and the per-token clauses are AND'd (concatenated) — so
	 * "john smith" matches a record with those words in any order / across fields, mirroring the
	 * legacy select2 behavior. Per token: single field → `FBV~Field~LK~%token%`; multiple fields →
	 * the LIKEs are OR'd inside a paren group (`FOP…FCP`) so the OR can't bleed into a sibling AND
	 * base filter. Each token is `encodeURIComponent`-wrapped exactly as pict-section-recordset does,
	 * so the structural `~` separators stay literal in the URL path while the value is escaped.
	 *
	 * @param {Array<string>} pSearchFields - The entity fields to LIKE-match.
	 * @param {string} pTerm - The (raw) search term; whitespace-delimited into AND'd tokens.
	 * @return {string} The FoxHound filter stanza(s), or '' for an all-whitespace/empty term.
	 */
	buildSearchFilter(pSearchFields, pTerm)
	{
		const tmpTokens = String(pTerm == null ? '' : pTerm).split(/\s+/).map((pToken) => pToken.trim()).filter((pToken) => pToken.length > 0);
		if (tmpTokens.length === 0) { return ''; }
		const fTokenClause = (pToken) =>
		{
			const tmpEncoded = encodeURIComponent(`%${pToken}%`);
			if (pSearchFields.length === 1)
			{
				return `FBV~${pSearchFields[0]}~LK~${tmpEncoded}`;
			}
			const tmpInner = pSearchFields.map((pField, pIndex) => `${pIndex === 0 ? 'FBV' : 'FBVOR'}~${pField}~LK~${tmpEncoded}`).join('~');
			return `FOP~0~(~0~${tmpInner}~FCP~0~)~0`;
		};
		// Concatenated stanzas AND together, so every token must match somewhere.
		return tmpTokens.map(fTokenClause).join('~');
	}

	/**
	 * Build an async picker DataProvider backed by a Meadow entity (via `pict.EntityProvider`).
	 * Returns a `(searchTerm, page) => Promise<{ results:[{Value,Text,Record}], hasMore }>` function —
	 * the exact contract PictViewPicker consumes for server search + pagination.
	 *
	 * @param {Record<string, any>} pConfig - Entity source configuration:
	 *   - Entity {string} (required) - the Meadow entity name (e.g. `Author`).
	 *   - SearchFields {Array<string>} - fields to LIKE-search (default `['Name']`).
	 *   - ValueField {string} - record field used as the option Value (default `ID<Entity>`).
	 *   - TextField {string} - record field used as the option Text (default `Name`).
	 *   - TextTemplate {string} - optional pict template rendered against the whole record for the option
	 *       Text (overrides TextField; composes with JoinEntity). Lets a host show a composed, disambiguated
	 *       label, e.g. `{~DWTF:Record.NameFull:...~} ({~D:Record.Email~})`.
	 *   - PageSize {number} - records per page (default 20).
	 *   - Sort {string} - optional field to sort ascending (adds `FSF~<field>~ASC~0`).
	 *   - PriorityValues {Array<any>|function} - optional pin-to-top: value-ids (or a `() => ids |
	 *       Promise<ids>` resolver) to float to the top of the FIRST unfiltered page, in the given order.
	 *       BROWSE-only — a search term defers entirely to natural relevance so a pin never hides a typed-for
	 *       record. The resolver is memoized per provider instance (it may hit the network — e.g. "this line
	 *       item's project's prime contractor"); pinned ids are held out of the natural flow (NIN) so they
	 *       never double on a later page, and pinned rows are fetched + composed under the same scope + cull.
	 *   - BaseFilter {string|Array<string>|Object|function} - optional always-applied FoxHound filter
	 *     (AND), e.g. `FBV~IDCustomer~EQ~1`. May be a **function** `(searchTerm, page) => string|string[]|Object`
	 *     evaluated on every search — the generic hook for host-injected CONTEXTUAL scoping (project,
	 *     tenant, spec-year, …). The module stays agnostic; the host supplies the closure.
	 *     The object form `{ Filters, BackOffFilters }` (each a string or array of stanzas) splits the
	 *     scope into a MANDATORY set and a BACK-OFF set: both are applied together first, and when the
	 *     first page of a search comes back EMPTY the request is retried once WITHOUT the back-off set —
	 *     so a host can narrow aggressively ("this project's items") yet auto-widen instead of showing
	 *     "No matches" when the narrow scope has none. Later pages of the same search stay widened so
	 *     "Load more" pages the set the user is actually looking at.
	 *   - MapRecord {function} - optional `(record) => {Value, Text}` mapper (overrides Value/TextField).
	 *   - JoinEntity {string} - optional second entity to JOIN for a compound display (e.g. a `LineItem`
	 *     shown with its `Project`). Each searched row must carry the FK (`JoinField`). Because Meadow
	 *     can't join in one read, this is fetch-then-merge: after the primary page resolves, the unique
	 *     FK ids drive ONE `FBL~ID{JoinEntity}~INN~<ids>` request, and the joined display field is
	 *     stitched onto each row (as `Record.JoinName` / `Record.JoinRecord`) + composed into the Text.
	 *   - JoinField {string} - the FK column ON THE SEARCHED ROW pointing at JoinEntity (default `ID{JoinEntity}`).
	 *   - JoinEntityValueField {string} - the PK column on JoinEntity to match (default `ID{JoinEntity}`).
	 *   - JoinEntityDisplayField {string} - the JoinEntity field to display (default `Name`).
	 *   - JoinEntityFirst {boolean} - put the joined value first in the compound (default `true`):
	 *     `JoinName - baseText`; when `false`, `baseText - JoinName`.
	 *   - JoinSeparator {string} - the compound separator (default `' - '`).
	 *   - EntityTag {string} - optional record field whose value becomes a `Tag` badge on each option
	 *     (e.g. a `LineItem`'s `ItemNumber`). The picker view renders it as a styled badge alongside the
	 *     label (ordering via the picker's `TagLast` option). Composes with JoinEntity (tag is outermost).
	 *   - EntityTags {Array<string|{Field:string, Label?:string, Template?:string}>} - a SET of extra
	 *     fields rendered as multiple disambiguation chips (e.g. `['ISBN', { Field: 'PublicationYear',
	 *     Label: 'Year' }]`). A string spec shows the raw value; an object spec can prefix a `Label`
	 *     (`"Year: 2000"`) or render a `Template` against the whole record. Renders as `Tags` (an array)
	 *     alongside the optional single `Tag`.
	 * @param {string} [pStateKey] - Key (the picker hash) under which the back-off bookkeeping is held on
	 *   the provider, so it survives this closure being rebuilt on re-mount. Omit for closure-local state.
	 * @return {(pSearchTerm: string, pPage: number) => Promise<{results: Array<any>, hasMore: boolean}>}
	 */
	createEntityDataProvider(pConfig, pStateKey)
	{
		const tmpEntity = pConfig.Entity;
		const tmpSearchFields = (Array.isArray(pConfig.SearchFields) && pConfig.SearchFields.length > 0) ? pConfig.SearchFields : [ 'Name' ];
		const tmpValueField = pConfig.ValueField || `ID${tmpEntity}`;
		const tmpTextField = pConfig.TextField || 'Name';
		const tmpPageSize = pConfig.PageSize || 20;
		const tmpSort = pConfig.Sort || false;
		const tmpBaseFilterConfig = pConfig.BaseFilter || '';
		const tmpMapRecord = (typeof pConfig.MapRecord === 'function') ? pConfig.MapRecord : false;
		const tmpJoinConfig = this._resolveJoinConfig(pConfig);
		const tmpEntityTagField = pConfig.EntityTag || false;
		const tmpEntityTagFields = Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false;
		const tmpTextTemplate = pConfig.TextTemplate || false;
		// Search by ID (on unless SearchByID is false): a search that is only a number also finds the record
		// with that ID, pinned to the top of the first page; `#<number>` finds the ID only.
		const tmpSearchByID = (pConfig.SearchByID !== false);
		const tmpIDField = pConfig.SearchIDField || `ID${tmpEntity}`;
		const fParseIDSearch = (pSearchTerm) =>
		{
			if (!tmpSearchByID)
			{
				return null;
			}
			const tmpMatch = /^(#?)(\d+)$/.exec(String(pSearchTerm == null ? '' : pSearchTerm).trim());
			if (!tmpMatch)
			{
				return null;
			}
			return { ID: tmpMatch[2], Only: (tmpMatch[1] === '#') };
		};
		// The muted marker on a row found by its ID: `<Entity> #<ID>`. IDMatchLabel is a word to use in place
		// of the entity name, or `(record, id) => text`.
		const fIDMatchLabel = (pRecord, pID) =>
		{
			const tmpLabelConfig = pConfig.IDMatchLabel;
			if (typeof tmpLabelConfig === 'function')
			{
				try
				{
					return tmpLabelConfig(pRecord, pID);
				}
				catch (pError)
				{
					this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] IDMatchLabel() threw; using the default.`, pError);
				}
			}
			return `${(typeof tmpLabelConfig === 'string' && tmpLabelConfig) ? tmpLabelConfig : tmpEntity} #${pID}`;
		};
		const fToOption = (pRecord, pMarkIDMatch) =>
		{
			const tmpOption = tmpMapRecord
				? tmpMapRecord(pRecord)
				: this._composeOption(pRecord, tmpValueField, tmpTextField, tmpJoinConfig, tmpEntityTagField, tmpTextTemplate, tmpEntityTagFields);
			if (pMarkIDMatch && tmpOption)
			{
				tmpOption.IDMatch = fIDMatchLabel(pRecord, pRecord[tmpIDField]);
			}
			return tmpOption;
		};

		// Back-off state: after a page-0 search comes back empty and is retried without the back-off set,
		// later pages of the SAME term stay widened (a new page-0 resets it). Held on the provider by hash
		// so it survives this closure's marshal-time rebuild; no key (direct API use) = closure-local.
		const tmpBackOff = pStateKey
			? (this.backOffState[pStateKey] = this.backOffState[pStateKey] || { Dropped: false, Term: null })
			: { Dropped: false, Term: null };

		// Pin-to-top: an optional set of value-ids — or a `() => ids | Promise<ids>` resolver — that float
		// to the top of the FIRST unfiltered page. A BROWSE-only affordance: with a search term, the query
		// defers entirely to natural relevance so the pin never hides a typed-for record. The pinned ids are
		// resolved ONCE per provider instance (the resolver may hit the network — e.g. "this line item's
		// project's prime contractor"), kept OUT of the natural flow (NIN) so they never double on a later
		// page, and their rows are fetched + composed exactly like the rest (honoring the scope + cull).
		const tmpPriorityConfig = pConfig.PriorityValues || false;
		let tmpPriorityIDsPromise = null;
		const fResolvePriorityIDs = () =>
		{
			if (tmpPriorityIDsPromise) { return tmpPriorityIDsPromise; }
			let tmpResolved = [];
			try { tmpResolved = (typeof tmpPriorityConfig === 'function') ? tmpPriorityConfig() : tmpPriorityConfig; }
			catch (pError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] PriorityValues resolver threw; ignoring pin-to-top.`, pError); tmpResolved = []; }
			tmpPriorityIDsPromise = Promise.resolve(tmpResolved)
				.then((pIDs) => (Array.isArray(pIDs) ? pIDs : []).filter((pID) => (pID !== undefined) && (pID !== null) && (pID !== '')))
				.catch((pError) => { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] PriorityValues resolver rejected; ignoring pin-to-top.`, pError); return []; });
			return tmpPriorityIDsPromise;
		};
		// Fetch + compose the pinned rows themselves — one INN read under the mandatory scope (so an
		// out-of-scope or already-culled pin never appears), ordered by the resolver's id order. `pPinField`
		// is the column the ids are in: the ValueField for PriorityValues, the ID field for a search by ID.
		const fFetchPriorityOptions = (pPriorityIDs, pScopeFilter, pPinField, pMarkIDMatch) => new Promise((resolve) =>
		{
			const tmpStanzas = [];
			if (pScopeFilter) { tmpStanzas.push(pScopeFilter); }
			tmpStanzas.push(`FBL~${pPinField}~INN~${pPriorityIDs.map((pID) => encodeURIComponent(pID)).join(',')}`);
			if (tmpSort) { tmpStanzas.push(`FSF~${tmpSort}~ASC~0`); }
			this.pict.EntityProvider.getEntitySetPage(tmpEntity, tmpStanzas.filter(Boolean).join('~'), 0, pPriorityIDs.length,
				(pError, pRecords) =>
				{
					if (pError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] pin-to-top fetch failed; skipping.`, pError); return resolve([]); }
					this._decorateRecordsWithJoin(Array.isArray(pRecords) ? pRecords : [], tmpJoinConfig).then((pDecorated) =>
					{
						const tmpByID = {};
						for (let i = 0; i < pDecorated.length; i++) { tmpByID[String(pDecorated[i][pPinField])] = pDecorated[i]; }
						const tmpOptions = pPriorityIDs
							.map((pID) => tmpByID[String(pID)])
							.filter((pRecord) => !!pRecord)
							.map((pRecord) => fToOption(pRecord, pMarkIDMatch));
						return resolve(tmpOptions);
					});
				});
		});

		// One page of the natural (non-pinned) query. `pPriorityIDs` is empty except on an unfiltered browse
		// with a pin configured, or a search by ID — where those ids (in `pPinField`) are excluded here (NIN)
		// and prepended in fFinish.
		const fRunQuery = (pSearchTerm, pPage, pPriorityIDs, pPinField) => new Promise((resolve, reject) =>
		{
			if (!this.pict.EntityProvider || typeof this.pict.EntityProvider.getEntitySetPage !== 'function')
			{
				return reject(new Error('Pict-Section-Picker: pict.EntityProvider is not available for entity-backed pickers.'));
			}

			// Resolve the base filter at SEARCH time. A function form lets the host inject contextual
			// scoping (e.g. "only this project's line items") without the module knowing the context;
			// it can return a single stanza, an array of stanzas, a `{ Filters, BackOffFilters }` split,
			// or nothing.
			let tmpBaseFilter = tmpBaseFilterConfig;
			if (typeof tmpBaseFilterConfig === 'function')
			{
				try { tmpBaseFilter = tmpBaseFilterConfig(pSearchTerm, pPage); }
				catch (pScopeError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] BaseFilter() threw; ignoring contextual scope.`, pScopeError); tmpBaseFilter = ''; }
			}
			const tmpScope = this._normalizeBaseFilter(tmpBaseFilter);
			const tmpIDSearch = fParseIDSearch(pSearchTerm);

			const tmpPageIndex = (pPage || 0);
			if (tmpPageIndex === 0) { tmpBackOff.Dropped = false; tmpBackOff.Term = null; }
			const tmpCarryWidened = tmpBackOff.Dropped && (tmpBackOff.Term === (pSearchTerm || ''));
			const tmpApplyBackOff = !!tmpScope.BackOffFilter && !tmpCarryWidened;

			const fComposeFilter = (pIncludeBackOff) =>
			{
				const tmpStanzas = [];
				if (tmpScope.Filter) { tmpStanzas.push(tmpScope.Filter); }
				if (pIncludeBackOff && tmpScope.BackOffFilter) { tmpStanzas.push(tmpScope.BackOffFilter); }
				if (tmpIDSearch && tmpIDSearch.Only)
				{
					tmpStanzas.push(`FBV~${tmpIDField}~EQ~${tmpIDSearch.ID}`);
				}
				else if (pSearchTerm)
				{
					tmpStanzas.push(this.buildSearchFilter(tmpSearchFields, pSearchTerm));
				}
				// Pin-to-top: keep the pinned rows OUT of the natural flow so they appear only at the top
				// (prepended in fFinish), never doubled on a later page.
				if (pPriorityIDs.length > 0) { tmpStanzas.push(`FBL~${pPinField}~NIN~${pPriorityIDs.map((pID) => encodeURIComponent(pID)).join(',')}`); }
				if (tmpSort) { tmpStanzas.push(`FSF~${tmpSort}~ASC~0`); }
				return tmpStanzas.filter(Boolean).join('~');
			};

			const fFinish = (pRecords) =>
			{
				const tmpList = Array.isArray(pRecords) ? pRecords : [];
				// JoinEntity (when configured): one INN fetch for the joined rows, stitched onto each
				// searched row, before mapping — so the option Text can show the compound display.
				this._decorateRecordsWithJoin(tmpList, tmpJoinConfig).then((pDecorated) =>
				{
					// A `#<number>` search returns only ID matches, so every row carries the marker.
					const tmpResults = pDecorated.map((pRecord) => fToOption(pRecord, !!(tmpIDSearch && tmpIDSearch.Only)));
					// hasMore: a full page came back, so there is (probably) another. Avoids a Count round-trip.
					// Pin-to-top: on the first browse page, prepend the pinned options ahead of the natural
					// results (which excluded them via NIN above).
					if (pPriorityIDs.length < 1 || tmpPageIndex !== 0)
					{
						return resolve({ results: tmpResults, hasMore: (tmpList.length >= tmpPageSize) });
					}
					return fFetchPriorityOptions(pPriorityIDs, tmpScope.Filter, pPinField, !!(tmpIDSearch && !tmpIDSearch.Only)).then((pPinned) =>
						resolve({ results: pPinned.concat(tmpResults), hasMore: (tmpList.length >= tmpPageSize) }));
				});
			};

			const tmpCursor = tmpPageIndex * tmpPageSize;
			this.pict.EntityProvider.getEntitySetPage(tmpEntity, fComposeFilter(tmpApplyBackOff), tmpCursor, tmpPageSize,
				(pError, pRecords) =>
				{
					if (pError) { return reject(pError); }
					const tmpList = Array.isArray(pRecords) ? pRecords : [];
					// Back-off retry: an EMPTY first page under the back-off set means the narrow scope has
					// nothing — auto-widen by retrying once without it, instead of stranding the user on
					// "No matches" for options that exist just outside the preferred scope.
					if (tmpList.length < 1 && tmpApplyBackOff && tmpPageIndex === 0)
					{
						tmpBackOff.Dropped = true;
						tmpBackOff.Term = (pSearchTerm || '');
						return this.pict.EntityProvider.getEntitySetPage(tmpEntity, fComposeFilter(false), tmpCursor, tmpPageSize,
							(pRetryError, pRetryRecords) =>
							{
								if (pRetryError) { return reject(pRetryError); }
								return fFinish(pRetryRecords);
							});
					}
					return fFinish(tmpList);
				});
		});

		// A bare-number search pins the record with that ID. Otherwise, with no pin configured, the plain
		// per-page provider; with one, resolve the pinned ids first (browse only — a search term defers
		// entirely to natural relevance) and run the query with them.
		return (pSearchTerm, pPage) =>
		{
			const tmpIDSearch = fParseIDSearch(pSearchTerm);
			if (tmpIDSearch && !tmpIDSearch.Only)
			{
				return fRunQuery(pSearchTerm, pPage, [ tmpIDSearch.ID ], tmpIDField);
			}
			if (pSearchTerm || !tmpPriorityConfig)
			{
				return fRunQuery(pSearchTerm, pPage, [], tmpValueField);
			}
			return fResolvePriorityIDs().then((pIDs) => fRunQuery(pSearchTerm, pPage, pIDs, tmpValueField));
		};
	}

	/**
	 * Normalize a resolved BaseFilter value into `{ Filter, BackOffFilter }` joined-stanza strings.
	 * Accepts the historical string / array forms (all-mandatory, no back-off) and the object form
	 * `{ Filters, BackOffFilters }` where each side is itself a string or array of stanzas.
	 *
	 * @param {any} pResolved - The BaseFilter config value, or a BaseFilter function's return value.
	 * @return {{Filter: string, BackOffFilter: string}}
	 */
	_normalizeBaseFilter(pResolved)
	{
		const fJoin = (pValue) => Array.isArray(pValue) ? pValue.filter(Boolean).join('~') : (pValue || '');
		if (pResolved && typeof pResolved === 'object' && !Array.isArray(pResolved))
		{
			return { Filter: fJoin(pResolved.Filters), BackOffFilter: fJoin(pResolved.BackOffFilters) };
		}
		return { Filter: fJoin(pResolved), BackOffFilter: '' };
	}

	/**
	 * Resolve the JoinEntity options off an entity-source config into a normalized internal shape, or
	 * `false` when no JoinEntity is configured. Centralizes the defaults so the DataProvider and the
	 * ResolveValue builders agree.
	 *
	 * @param {Record<string, any>} pConfig
	 * @return {false | {Entity:string, FKColumn:string, PKColumn:string, DisplayField:string, First:boolean, Separator:string}}
	 */
	_resolveJoinConfig(pConfig)
	{
		if (!pConfig || !pConfig.JoinEntity) { return false; }
		return {
			Entity: pConfig.JoinEntity,
			// The FK on the SEARCHED row, and the PK it points at on the join entity (the INN column).
			FKColumn: pConfig.JoinField || `ID${pConfig.JoinEntity}`,
			PKColumn: pConfig.JoinEntityValueField || `ID${pConfig.JoinEntity}`,
			DisplayField: pConfig.JoinEntityDisplayField || 'Name',
			// Default join-first (mirrors the documented select2 EntitySelector default).
			First: (pConfig.JoinEntityFirst !== false),
			Separator: (typeof pConfig.JoinSeparator === 'string') ? pConfig.JoinSeparator : ' - ',
		};
	}

	/**
	 * Compose a compound display from a base text + a joined value, honoring ordering + separator.
	 * Falls back to just the base text when there is no joined value.
	 *
	 * @param {any} pBaseText @param {any} pJoinText @param {boolean} pFirst @param {string} pSeparator
	 * @return {any}
	 */
	_composeJoinedText(pBaseText, pJoinText, pFirst, pSeparator)
	{
		if (pJoinText === undefined || pJoinText === null || pJoinText === '') { return pBaseText; }
		const tmpBase = (pBaseText === undefined || pBaseText === null) ? '' : pBaseText;
		return pFirst ? `${pJoinText}${pSeparator}${tmpBase}` : `${tmpBase}${pSeparator}${pJoinText}`;
	}

	/**
	 * Build the picker option `{ Value, Text, Record[, Tag] }` from a (possibly join-decorated) record:
	 * the Text honors any JoinEntity compound, and a Tag badge is added from `pTagField` when set. Shared
	 * by the DataProvider (per page row) and the ResolveValue (pre-bound value) so they stay consistent.
	 *
	 * @param {any} pRecord @param {string} pValueField @param {string} pTextField
	 * @param {false | Record<string, any>} pJoinConfig @param {string|false} pTagField
	 * @return {{Value:any, Text:any, Record:any, Tag?:any}}
	 */
	_composeOption(pRecord, pValueField, pTextField, pJoinConfig, pTagField, pTextTemplate, pTagFields)
	{
		// The option label is either a single field (pTextField) or — when a TextTemplate is configured — a
		// template rendered against the whole record, so a host can show a composed, disambiguated display
		// (e.g. "Brian Smith (brian@…)") instead of one ambiguous column. JoinEntity still wraps the result.
		const tmpBaseText = pTextTemplate
			? this.pict.parseTemplate(pTextTemplate, pRecord)
			: pRecord[pTextField];
		const tmpText = pJoinConfig
			? this._composeJoinedText(tmpBaseText, pRecord.JoinName, pJoinConfig.First, pJoinConfig.Separator)
			: tmpBaseText;
		const tmpOption = { Value: pRecord[pValueField], Text: tmpText, Record: pRecord };
		if (pTagField) { tmpOption.Tag = pRecord[pTagField]; }
		// EntityTags: a set of extra fields rendered as disambiguation chips (e.g. a book's ISBN + Year).
		if (Array.isArray(pTagFields) && pTagFields.length > 0)
		{
			tmpOption.Tags = pTagFields
				.map((pSpec) => this._composeTagValue(pSpec, pRecord))
				.filter((pTag) => (pTag !== undefined && pTag !== null && pTag !== ''));
		}
		return tmpOption;
	}

	/**
	 * Resolve one EntityTags spec to a chip string. A spec is either a field name (`'ISBN'` → the raw
	 * value) or an object `{ Field, Label, Template }`: `Template` renders against the whole record;
	 * `Label` prefixes the value (`"Year: 2000"`) — useful when several numeric chips would be ambiguous.
	 *
	 * @param {string|Record<string, any>} pSpec @param {any} pRecord
	 * @return {any}
	 */
	_composeTagValue(pSpec, pRecord)
	{
		if (typeof pSpec === 'string')
		{
			return pRecord[pSpec];
		}
		if (pSpec && typeof pSpec === 'object')
		{
			let tmpValue = pSpec.Template ? this.pict.parseTemplate(pSpec.Template, pRecord) : pRecord[pSpec.Field];
			if (tmpValue === undefined || tmpValue === null || tmpValue === '') { return ''; }
			return pSpec.Label ? `${pSpec.Label}: ${tmpValue}` : tmpValue;
		}
		return '';
	}

	/**
	 * Fetch-then-merge the join entity for a page of searched records. Collects the unique FK ids the
	 * rows carry (`JoinConfig.FKColumn`), issues ONE `FBL~{PKColumn}~INN~<ids>` request against the join
	 * entity, and stitches `JoinRecord` + `JoinName` onto each searched row. Resolves the (mutated) same
	 * array; on any error or when there's nothing to join, resolves the records un-decorated (the Text
	 * gracefully degrades to the base field).
	 *
	 * @param {Array<any>} pRecords @param {false | Record<string, any>} pJoinConfig
	 * @return {Promise<Array<any>>}
	 */
	_decorateRecordsWithJoin(pRecords, pJoinConfig)
	{
		return new Promise((resolve) =>
		{
			if (!pJoinConfig || !Array.isArray(pRecords) || pRecords.length < 1 || !this.pict.EntityProvider) { return resolve(pRecords); }
			const tmpIDs = [];
			const tmpSeen = {};
			for (let i = 0; i < pRecords.length; i++)
			{
				const tmpID = pRecords[i][pJoinConfig.FKColumn];
				if (tmpID !== undefined && tmpID !== null && tmpID !== '' && !tmpSeen[tmpID]) { tmpSeen[tmpID] = true; tmpIDs.push(tmpID); }
			}
			if (tmpIDs.length < 1) { return resolve(pRecords); }
			const tmpFilter = `FBL~${pJoinConfig.PKColumn}~INN~${tmpIDs.join(',')}`;
			this.pict.EntityProvider.getEntitySetPage(pJoinConfig.Entity, tmpFilter, 0, tmpIDs.length,
				(pError, pJoinRecords) =>
				{
					if (pError)
					{
						this.pict.log.warn(`Pict-Section-Picker [${pJoinConfig.Entity}] join fetch failed; showing un-joined text.`, pError);
						return resolve(pRecords);
					}
					const tmpMap = {};
					const tmpJoinList = Array.isArray(pJoinRecords) ? pJoinRecords : [];
					for (let i = 0; i < tmpJoinList.length; i++) { tmpMap[tmpJoinList[i][pJoinConfig.PKColumn]] = tmpJoinList[i]; }
					for (let i = 0; i < pRecords.length; i++)
					{
						const tmpJoinRecord = tmpMap[pRecords[i][pJoinConfig.FKColumn]];
						if (tmpJoinRecord) { pRecords[i].JoinRecord = tmpJoinRecord; pRecords[i].JoinName = tmpJoinRecord[pJoinConfig.DisplayField]; }
					}
					return resolve(pRecords);
				});
		});
	}

	/**
	 * Build a `ResolveValue(value) => Promise<{Value,Text}>` for an entity-backed picker, so a
	 * pre-bound ID resolves to its display text on first render (fetched + cached by `getEntity`).
	 *
	 * @param {Record<string, any>} pConfig - Same shape as {@link createEntityDataProvider}.
	 * @return {(pValue: any) => Promise<any>}
	 */
	createEntityResolveValue(pConfig)
	{
		const tmpEntity = pConfig.Entity;
		const tmpValueField = pConfig.ValueField || `ID${tmpEntity}`;
		const tmpTextField = pConfig.TextField || 'Name';
		const tmpMapRecord = (typeof pConfig.MapRecord === 'function') ? pConfig.MapRecord : false;
		const tmpJoinConfig = this._resolveJoinConfig(pConfig);
		const tmpEntityTagField = pConfig.EntityTag || false;
		const tmpEntityTagFields = Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false;
		const tmpTextTemplate = pConfig.TextTemplate || false;

		return (pValue) => new Promise((resolve) =>
		{
			if (pValue === undefined || pValue === null || pValue === '' || !this.pict.EntityProvider)
			{
				return resolve(null);
			}
			this.pict.EntityProvider.getEntity(tmpEntity, pValue,
				(pError, pRecord) =>
				{
					if (pError || !pRecord) { return resolve(null); }
					const fFinish = () =>
					{
						if (tmpMapRecord) { return resolve(tmpMapRecord(pRecord)); }
						return resolve(this._composeOption(pRecord, tmpValueField, tmpTextField, tmpJoinConfig, tmpEntityTagField, tmpTextTemplate, tmpEntityTagFields));
					};
					// JoinEntity: resolve the single joined record (cached getEntity) for the compound label.
					const tmpFK = tmpJoinConfig ? pRecord[tmpJoinConfig.FKColumn] : null;
					if (!tmpJoinConfig || tmpFK === undefined || tmpFK === null || tmpFK === '') { return fFinish(); }
					this.pict.EntityProvider.getEntity(tmpJoinConfig.Entity, tmpFK,
						(pJoinError, pJoinRecord) =>
						{
							if (!pJoinError && pJoinRecord) { pRecord.JoinRecord = pJoinRecord; pRecord.JoinName = pJoinRecord[tmpJoinConfig.DisplayField]; }
							return fFinish();
						});
				});
		});
	}

	/**
	 * Create a picker backed by a Meadow entity — the high-level entry point for the real
	 * lims/config/bridge entity pickers. Wires a server DataProvider + ResolveValue from `pConfig`
	 * and delegates to {@link createPicker}. Any picker option (DestinationAddress, ValueAddress,
	 * Placeholder, OnChange, …) may also be supplied and is passed through.
	 *
	 * @param {string} pPickerHash - Unique hash/id for this picker.
	 * @param {Record<string, any>} pConfig - {@link createEntityDataProvider} config + picker options.
	 * @return {any} The picker view instance.
	 */
	createEntityPicker(pPickerHash, pConfig)
	{
		const tmpConfig = Object.assign({}, pConfig);
		// Key the back-off state by picker hash so it survives this rebuild (hosts re-mount every marshal).
		tmpConfig.DataProvider = this.createEntityDataProvider(pConfig, pPickerHash);
		if (!tmpConfig.ResolveValue) { tmpConfig.ResolveValue = this.createEntityResolveValue(pConfig); }
		return this.createPicker(pPickerHash, tmpConfig);
	}
}

module.exports = PictProviderPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../views/PictView-Picker.js":291,"pict-provider":177}],291:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * HTML-escape a value so it is safe both inside a double-quoted attribute and as element text content.
 * Option values / labels can carry characters like the inch mark (`1"`) or an apostrophe that would
 * otherwise terminate an attribute or an inline handler string. Every user value the templates drop into
 * an attribute or a text node is passed through this; the value a handler actually operates on is read
 * back — the browser decodes it — from a `data-` attribute rather than being inlined into the onclick.
 * @param {any} pValue
 * @return {string}
 */
function escapeHTML(pValue)
{
	return String((pValue === null || pValue === undefined) ? '' : pValue)
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * The theme custom properties the widget paints from. Copied onto a portaled panel so it keeps the
 * host's theme after it stops inheriting from a scoped container (see _portalPop / _restorePop).
 * @type {Array<string>}
 */
const _THEME_TOKENS =
[
	'--theme-color-brand-primary', '--theme-color-text-primary', '--theme-color-text-secondary',
	'--theme-color-text-muted', '--theme-color-border-default', '--theme-color-border-light',
	'--theme-color-border-strong', '--theme-color-background-primary', '--theme-color-background-panel',
	'--theme-color-background-tertiary',
];

/**
 * Record columns never offered as field-decoration choices — the common Meadow audit/system columns. The
 * value + text fields and any host `DecorationIgnoreFields` are layered on top of these at runtime.
 * @type {Array<string>}
 */
const _DECORATION_IGNORE_DEFAULT =
[
	'Deleted', 'DeleteDate', 'DeletingIDUser', 'CreateDate', 'CreatingIDUser',
	'UpdateDate', 'UpdatingIDUser', 'ExternalSyncDate',
];
/** localStorage key prefix for the per-entity field-decoration choice (client-only, no server state). */
const _DECORATION_KEY_PREFIX = 'PictSectionPicker.Decoration.';

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'Pict-Section-Picker-View',

	AutoInitialize: false,
	AutoRender: false,
	AutoSolveWithApp: false,

	DefaultRenderable: 'Pict-Section-Picker-Renderable',

	// Per-instance options (supplied by PictProviderPicker.createPicker):
	PickerHash: false,
	DestinationAddress: false,
	ValueAddress: false,
	// 'single' (scalar value) or 'multi' (array of values, rendered as removable chips).
	Mode: 'single',
	Placeholder: 'Select…',
	Searchable: true,
	Options: [],
	// EntityTag badge ordering: false → badge before the label (the select2 default), true → after.
	// The per-option Tag value rides on each source row (`{Value, Text, Tag}`); the entity adapter
	// stamps it from an `EntityTag` field name. With no Tag on a row, no badge renders.
	TagLast: false,
	// Async data source (Phase 2): DataProvider(searchTerm, page) => Promise<{ results:[{Value,Text}], hasMore }>.
	// When a function, the widget searches + paginates through it instead of the static Options list.
	DataProvider: false,
	PageSize: 20,
	// Async only: minimum trimmed search length before a server query fires (browse-on-open + new
	// search). 0 = always query (the common default). >0 suppresses the request below the threshold.
	MinimumSearchLength: 0,
	// Optional ResolveValue(value) => Promise<{Value,Text}> to resolve the display text of a pre-set
	// value in async mode (e.g. fetch the entity for a bound ID so the control shows its name).
	ResolveValue: false,
	// Multi mode extra bindings (the EntitySelectorMultiple contract). All optional; ValueAddress
	// always holds the array of values. These mirror it as a csv string and as the full record list.
	StringArrayValueAddress: false,
	SelectedValuesAddress: false,
	// Creatable (Phase 4): OnCreate(searchTerm) => {Value,Text} | Promise<{Value,Text}>. When set, a
	// "Create …" row appears for a non-empty search term that doesn't exactly match an existing option.
	OnCreate: false,
	// Creatable: when true, the "Create …" row is pinned at the top of the open list whatever the search
	// says — empty or an exact match included — so creating needs no typing (OnCreate then gets '').
	CreateAlwaysVisible: false,
	// The "Create …" row's text. A string, or a function (searchTerm) => string. Rendered as text; a blank
	// result or a throw falls back to the default ('Create "<term>"', or 'Create new' with no term).
	CreateLabel: false,
	// Clearable (single mode): when true, the dropdown gets a pinned "Any" row at the top and the
	// control grows an inline × while a value is selected — either empties the selection and fires
	// OnChange(null, null). Filters are the natural fit ("Any" = no constraint); multi mode already
	// clears via its chips, so the option is ignored there.
	AllowClear: false,
	ClearLabel: 'Any',
	// The text shown when the list has no options for the current search. A string, or a function
	// (searchTerm) => string asked again on every empty render, so a host can say why the list is empty
	// (e.g. its own scope narrowed it). Rendered as text; an empty result or a throw falls back to the default.
	EmptyLabel: 'No matches',
	// How many lines a long option label may wrap to in the open list before it ends in an ellipsis (the
	// full text stays in the row's tooltip). 1 keeps every row on one line; 0 lets labels wrap without limit.
	OptionLabelLines: 3,

	// When true, render the resolved selection as plain, non-interactive text (no dropdown / chevron /
	// clear) — for read-only form views. The host sets PictForm.ReadOnly; the form-input passes it through.
	ReadOnly: false,

	// Opt-in: opening this picker closes any other open picker that ALSO opted in (at most one dropdown
	// on the page — select2-style). Off by default so hosts that tolerate stacked dropdowns see no
	// behavior change, and a picker left off is neither closed by nor closes a participant. Usually
	// enabled fleet-wide via the provider's SingleActivePicker option (createPicker seeds it).
	SingleActivePicker: false,

	// The Meadow entity this picker selects from. Set automatically by createEntityPicker; a custom-
	// DataProvider host may pass it to opt into entity-aware affordances (preview cards, field decoration).
	Entity: false,
	// Field decoration (opt-in). When true AND the picker is entity-aware — an `Entity` name is set and its
	// result rows carry a full `Record` — a small ⚙ in the search row lets the user pin extra record fields
	// onto every option row as tag badges ("VendorCode: 12345"), to tell same-named entities apart. The
	// choice is remembered in localStorage keyed by Entity (so it follows the user to every picker of that
	// entity) and never leaves the browser. `DecorationIgnoreFields` drops fields from the chooser, on top
	// of the value/text fields and the common audit columns, which are always hidden.
	AllowFieldDecoration: false,
	DecorationIgnoreFields: [],

	// Values that mean "nothing is selected" for DISPLAY, on top of undefined/null/''. The widget still
	// stores and returns whatever it was given — this only decides whether the control paints the
	// placeholder instead of the raw value, so a host's sentinel never has to become a data change.
	// The pict-section-form adapter seeds it with [0] for a Number/Integer/Float descriptor, whose
	// pristine marshal value is manyfest's DataType default 0 rather than ''. A sentinel that DOES
	// resolve to a real source row (a static option literally valued 0) is a genuine selection and is
	// shown normally.
	EmptyValues: [],

	Templates:
	[
		{
			// The whole widget: control box + (transparent) backdrop + dropdown. The dropdown lives in
			// the DOM whether open or closed (toggled by the .pps-open class) so open/close needs no
			// re-render. The option list re-renders on its own for search (keeps the input focused).
			// The control is a div (role=combobox) not a button so multi-mode chips can carry their own
			// remove buttons without nesting <button> elements.
			Hash: 'Pict-Section-Picker-Control',
			Template: /*html*/`
	<div class="pps{~NE:Record.IsMulti^ pps-multi~}{~NE:Record.ReadOnly^ pps-readonly~}" id="PPS_{~D:Record.PickerHash~}">
		<div class="pps-control" role="combobox" tabindex="0" aria-haspopup="listbox" onclick="_Pict.views['{~D:Record.PickerHash~}'].toggle(event)" onkeydown="_Pict.views['{~D:Record.PickerHash~}'].onControlKey(event)">
			<div class="pps-valuearea" id="PPS_Value_{~D:Record.PickerHash~}">{~T:Pict-Section-Picker-ValueArea~}</div>
			{~TS:Pict-Section-Picker-ClearX:Record.ClearSlot~}
			<span class="pps-chevron">{~I:ChevronDown~}</span>
		</div>
		<div class="pps-backdrop" onclick="_Pict.views['{~D:Record.PickerHash~}'].closeFromBackdrop(event)"></div>
		<div class="pps-pop" id="PPS_Pop_{~D:Record.PickerHash~}">
			<div class="pps-panel">
				{~TS:Pict-Section-Picker-Search:Record.SearchSlot~}
				<div class="pps-decorate-panel" id="PPS_Decorate_{~D:Record.PickerHash~}">{~T:Pict-Section-Picker-DecoratePanel~}</div>
				<div class="pps-list" id="PPS_List_{~D:Record.PickerHash~}" style="--pps-option-lines: {~D:Record.OptionLabelLines~}">
					{~T:Pict-Section-Picker-List~}
				</div>
			</div>
		</div>
	</div>
`
		},
		{
			// The control's value display: single-mode value span OR multi-mode chips, chosen by the
			// single-element-array slots so we never render both.
			Hash: 'Pict-Section-Picker-ValueArea',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-Single:Record.SingleSlot~}
	{~TS:Pict-Section-Picker-Multi:Record.MultiSlot~}
`
		},
		{
			// The inline clear × (AllowClear) — a control-level adornment between the value area and
			// the chevron, so it centers next to the text (the value area's children stack as blocks).
			// It sits OUTSIDE #PPS_Value_, so the targeted repaint can't refresh it — and its presence
			// tracks the VALUE. _shapeSignature() therefore includes it, which forces setValue onto a
			// full render whenever it would appear or disappear. stopPropagation so clearing
			// never bubbles into the control's open/close toggle — mirrors the multi-chip remove ×.
			Hash: 'Pict-Section-Picker-ClearX',
			Template: /*html*/`
	<span class="pps-clear" title="Clear" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].clearValue()">{~I:Close~}</span>
`
		},
		{
			Hash: 'Pict-Section-Picker-Single',
			Template: /*html*/`
	<span class="pps-valuebox">{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-value{~NE:Record.NoValue^ pps-placeholder~}">{~D:Record.DisplayTextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-CardInfo:Record.CardSlot~}</span>
`
		},
		{
			// Multi-mode: the selected chips, plus a placeholder slot when nothing is selected.
			Hash: 'Pict-Section-Picker-Multi',
			Template: /*html*/`
	<span class="pps-chips">{~TS:Pict-Section-Picker-Chip:Record.Chips~}{~TS:Pict-Section-Picker-Placeholder:Record.PlaceholderSlot~}</span>
`
		},
		{
			Hash: 'Pict-Section-Picker-Placeholder',
			Template: /*html*/`
	<span class="pps-chips-ph">{~D:Record.Placeholder~}</span>
`
		},
		{
			// One selected chip with an inline remove button. stopPropagation on the × so removing a
			// chip never bubbles up to the control's open/close toggle.
			Hash: 'Pict-Section-Picker-Chip',
			Template: /*html*/`
	<span class="pps-chip">{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-chip-text" title="{~D:Record.TextAttr~}">{~D:Record.TextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-CardInfo:Record.CardSlot~}<span class="pps-chip-x" data-pps-valuekey="{~D:Record.ValueKeyAttr~}" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].removeChipFromElement(this)">{~I:Close~}</span></span>
`
		},
		{
			// Search box — its own template (gated by the single-element-array SearchSlot) because
			// {~NE:~} does not recursively parse nested {~I:~}/{~D:~} tags.
			Hash: 'Pict-Section-Picker-Search',
			Template: /*html*/`
	<div class="pps-search">
		<span class="pps-search-ic">{~I:Search~}</span>
		<input type="text" id="PPS_Search_{~D:Record.PickerHash~}" placeholder="Search…" autocomplete="off" oninput="_Pict.views['{~D:Record.PickerHash~}'].search(this.value)" onkeydown="_Pict.views['{~D:Record.PickerHash~}'].onSearchKey(event)">
		{~TS:Pict-Section-Picker-DecorateToggle:Record.DecorateSlot~}
	</div>
`
		},
		{
			Hash: 'Pict-Section-Picker-List',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-ClearOption:Record.ClearOptionSlot~}
	{~TS:Pict-Section-Picker-Create:Record.CreateSlot~}
	{~TS:Pict-Section-Picker-Group:Record.Groups~}
	{~TS:Pict-Section-Picker-Empty:Record.EmptySlot~}
	{~NE:Record.Loading^<div class="pps-loading">Loading…</div>~}
	{~TS:Pict-Section-Picker-More:Record.MoreSlot~}
`
		},
		{
			Hash: 'Pict-Section-Picker-Empty',
			Template: /*html*/`<div class="pps-empty">{~D:Record.Label~}</div>`
		},
		{
			// The pinned "Any" row (AllowClear, single mode) — selecting it empties the selection.
			// It shows the check when nothing is selected (i.e. "Any" is the active state).
			Hash: 'Pict-Section-Picker-ClearOption',
			Template: /*html*/`
	<button type="button" class="pps-option pps-clear-option{~NE:Record.Selected^ pps-selected~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].clearValue()">
		<span class="pps-option-check{~NE:Record.NotSelected^ pps-hidden~}">{~I:Check~}</span>
		<span class="pps-option-label">{~D:Record.Label~}</span>
	</button>
`
		},
		{
			// A category: an optional header (single-element-array HeaderSlot) followed by its options.
			// With no categories everything lands in one unlabeled group, so the list path is uniform.
			Hash: 'Pict-Section-Picker-Group',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-GroupHeader:Record.HeaderSlot~}
	{~TS:Pict-Section-Picker-Option:Record.Options~}
`
		},
		{
			Hash: 'Pict-Section-Picker-GroupHeader',
			Template: /*html*/`
	<div class="pps-group">{~D:Record.Label~}</div>
`
		},
		{
			// "Create <term>" row — its own template (single-element-array CreateSlot), so the nested
			// {~I:~}/{~D:~} tags parse (unlike inside an {~NE:~}).
			Hash: 'Pict-Section-Picker-Create',
			Template: /*html*/`
	<button type="button" class="pps-create" onclick="_Pict.views['{~D:Record.PickerHash~}'].createFromSearch()"><span class="pps-create-ic">{~I:Plus~}</span><span class="pps-create-label">{~D:Record.Label~}</span></button>
`
		},
		{
			// "Load more" — its own template (single-element-array MoreSlot) for the same nested-tag
			// reason as the search box.
			Hash: 'Pict-Section-Picker-More',
			Template: /*html*/`
	<button type="button" class="pps-more" onclick="_Pict.views['{~D:Record.PickerHash~}'].loadMore()">Load more</button>
`
		},
		{
			Hash: 'Pict-Section-Picker-Option',
			Template: /*html*/`
	<button type="button" class="pps-option{~NE:Record.Selected^ pps-selected~}{~NE:Record.Highlight^ pps-highlight~}" data-pps-valuekey="{~D:Record.ValueKeyAttr~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].selectFromElement(this)">
		<span class="pps-option-check{~NE:Record.NotSelected^ pps-hidden~}">{~I:Check~}</span>
		{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-option-label" title="{~D:Record.TextAttr~}">{~D:Record.TextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-IDMatch:Record.IDMatchSlot~}
	</button>
`
		},
		{
			Hash: 'Pict-Section-Picker-IDMatch',
			Template: /*html*/`<span class="pps-option-idmatch">{~D:Record.Label~}</span>`
		},
		{
			// EntityTag badge — a small code/number pill rendered before or after the label via the
			// TagBeforeSlot / TagAfterSlot single-element-array slots on each option / chip / value record.
			Hash: 'Pict-Section-Picker-Tag',
			Template: /*html*/`
		<span class="pps-tag">{~D:Record.Tag~}</span>
`
		},
		{
			// Preview-card ⓘ trigger — a small affordance next to a selected value / chip that opens the
			// entity's registered preview card (RecordSetCardManager, a soft dependency). Gated to a
			// single-element-array CardSlot so it renders only when a card exists for the picker's Entity;
			// stopPropagation so it never toggles the control or removes a chip.
			Hash: 'Pict-Section-Picker-CardInfo',
			Template: /*html*/`
		<span class="pps-card-info" title="Preview" data-pps-entity="{~D:Record.EntityAttr~}" data-pps-value="{~D:Record.ValueAttr~}" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].openCardFromElement(this)">{~I:Info~}</span>
`
		},
		{
			// Field-decoration ⚙ (AllowFieldDecoration) — a trailing button in the search row that opens the
			// field chooser. Rendered via the single-element-array DecorateSlot so it appears only when the
			// feature is enabled + eligible. stopPropagation so it never bubbles into the control toggle.
			Hash: 'Pict-Section-Picker-DecorateToggle',
			Template: /*html*/`<button type="button" id="PPS_DecorateBtn_{~D:Record.PickerHash~}" class="pps-decorate-btn{~NE:Record.HasFields^ pps-decorate-on~}{~NE:Record.Open^ pps-decorate-open~}" title="Show extra fields on each row" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].toggleDecorate(event)">{~I:Settings~}</button>`
		},
		{
			// The field chooser — rendered into #PPS_Decorate_ between the search row and the list. Empty
			// (collapsed) unless the chooser is open; DecoratePanelSlot carries the candidate fields.
			Hash: 'Pict-Section-Picker-DecoratePanel',
			Template: /*html*/`{~TS:Pict-Section-Picker-DecorateInner:Record.DecoratePanelSlot~}`
		},
		{
			Hash: 'Pict-Section-Picker-DecorateInner',
			Template: /*html*/`
		<div class="pps-decorate">
			<div class="pps-decorate-title">Show extra fields on each row</div>
			<div class="pps-decorate-list">{~TS:Pict-Section-Picker-DecorateField:Record.Fields~}{~NE:Record.NoFields^<div class="pps-decorate-empty">No extra fields to show yet.</div>~}</div>
		</div>
`
		},
		{
			// One checkbox row in the chooser. The label wraps the input so a click anywhere toggles it.
			Hash: 'Pict-Section-Picker-DecorateField',
			Template: /*html*/`<label class="pps-decorate-opt"><input type="checkbox"{~NE:Record.Checked^ checked~} data-pps-field="{~D:Record.FieldAttr~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].toggleDecorateFieldFromElement(this)"><span class="pps-decorate-name">{~D:Record.FieldAttr~}</span></label>`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'Pict-Section-Picker-Renderable',
			TemplateHash: 'Pict-Section-Picker-Control',
			RenderMethod: 'replace',
		},
	],
};

class PictViewPicker extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Render the control into the host-supplied destination, and read state from this picker's
		// AppData slot (keyed by hash so many pickers can share the global templates).
		this.options.DefaultDestinationAddress = this.options.DestinationAddress || `#${this.options.PickerHash}`;
		this._StateAddress = `AppData.PictSectionPicker.${this.options.PickerHash}`;
		this.options.DefaultTemplateRecordAddress = this._StateAddress;
		if (Array.isArray(this.options.Renderables) && this.options.Renderables[0])
		{
			this.options.Renderables[0].ContentDestinationAddress = this.options.DefaultDestinationAddress;
		}

		// Transient UI state (the data lives in AppData; these drive a single picker's interaction).
		this._open = false;
		this._search = '';
		this._highlight = -1;
		// Async-mode state (Phase 2): accumulated results across pages + paging/loading flags.
		this._loadedResults = [];
		this._page = 0;
		this._hasMore = false;
		this._loading = false;
		this._loaded = false;
		this._searchTimer = null;
		this._selectedText = null;
		// Anchoring: true while portaled to <body>, false while CSS-anchored. Decided per open (see the
		// "Dropdown anchoring & render states" note below).
		this._portaled = false;
		// _shapeSignature() of the current paint, stamped by onAfterRender (null until first render).
		this._renderedShape = null;
		// Multi-mode state: the authoritative {Value,Text} for each selected value, keyed by String(Value),
		// so a chip keeps its label even after the search results that produced it have scrolled away.
		this._values = [];
		this._selectedRecords = {};

		// Field-decoration (opt-in) state: the chosen extra fields (loaded from localStorage) + the chooser's
		// open flag + a lazily-resolved storage backend. Load before the first _buildState so the initial
		// paint already carries any remembered decorations.
		this._decorationOpen = false;
		this._decorationFields = [];
		this._decorationStore = null;
		this._loadDecorationFields();

		// Populate the AppData state slot now so the template Record (resolved from
		// DefaultTemplateRecordAddress) reflects it on the very first render — pict resolves the
		// Record before onBeforeRender runs.
		try { this._buildState(); } catch (pError) { /* AppData/value not ready — onBeforeRender will build it */ }

		// Async mode: resolve the display text of pre-set bound value(s) (e.g. fetch the entity for an ID).
		if (this._isAsync() && typeof this.options.ResolveValue === 'function')
		{
			this._resolveInitialValues();
		}
	}

	/** @return {boolean} True when a DataProvider function is configured (async/server mode). */
	_isAsync()
	{
		return (typeof this.options.DataProvider === 'function');
	}

	/** @return {boolean} True when the picker is in multi-select (chips) mode. */
	_isMulti()
	{
		return (this.options.Mode === 'multi');
	}

	/** @return {Record<string, any>} The AppData state slot for this picker. */
	_state()
	{
		this.pict.AppData.PictSectionPicker = this.pict.AppData.PictSectionPicker || {};
		this.pict.AppData.PictSectionPicker[this.options.PickerHash] = this.pict.AppData.PictSectionPicker[this.options.PickerHash] || {};
		return this.pict.AppData.PictSectionPicker[this.options.PickerHash];
	}

	/**
	 * True when a value should be PAINTED as "nothing selected" — undefined/null/'', or one of the
	 * host's configured `EmptyValues` sentinels. Display-only: `_value` / getValue() keep the raw value,
	 * so nothing here rewrites the host's model.
	 *
	 * The sentinel yields to reality: one that matches a real source row (a static option literally
	 * valued 0, say) is a genuine selection and renders normally. Entity pickers skip the async resolve
	 * for a sentinel entirely — there is no entity #0 to fetch.
	 * @param {any} pValue @return {boolean}
	 */
	_isEmptyValue(pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '') { return true; }
		const tmpEmptyValues = this.options.EmptyValues;
		if (!Array.isArray(tmpEmptyValues) || tmpEmptyValues.length < 1) { return false; }
		if (!tmpEmptyValues.some((pEmpty) => String(pEmpty) === String(pValue))) { return false; }
		return !this._lookupRecord(pValue);
	}

	/** Resolve display text for any pre-bound value(s) via the async ResolveValue hook, then repaint. */
	_resolveInitialValues()
	{
		const tmpResolveOne = (pValue) =>
		{
			if (this._isEmptyValue(pValue)) { return; }
			Promise.resolve(this.options.ResolveValue(pValue)).then((pResolved) =>
			{
				if (pResolved && pResolved.Text)
				{
					if (this._isMulti())
					{
						this._selectedRecords[String(pValue)] = { Value: pResolved.Value !== undefined ? pResolved.Value : pValue, Text: pResolved.Text, Tag: pResolved.Tag, Tags: pResolved.Tags };
						this._renderValue();
					}
					else
					{
						this._selectedText = pResolved.Text;
						this.render();
					}
				}
			}).catch(() => { /* leave the raw value showing */ });
		};

		if (this._isMulti())
		{
			this.getValue().forEach(tmpResolveOne);
		}
		else
		{
			tmpResolveOne(this.getValue());
		}
	}

	/**
	 * @return {any} The current selection: a scalar in single mode, or an array of values in multi mode
	 *   (normalizing a csv string or scalar at the bound address into an array).
	 */
	getValue()
	{
		const tmpRaw = this.options.ValueAddress
			? this.pict.manifest.getValueAtAddress(this.pict, this.options.ValueAddress)
			: (this._isMulti() ? this._values : this._value);
		if (!this._isMulti())
		{
			return tmpRaw;
		}
		if (tmpRaw === undefined || tmpRaw === null || tmpRaw === '') { return []; }
		if (Array.isArray(tmpRaw)) { return tmpRaw; }
		if (typeof tmpRaw === 'string') { return tmpRaw.split(',').filter((pPart) => pPart !== ''); }
		return [ tmpRaw ];
	}

	/**
	 * Persist the selection to the bound address(es). Single mode writes the scalar; multi mode writes
	 * the array to ValueAddress and mirrors it to the optional csv / records addresses.
	 * @param {any} pValue - The new value (scalar in single mode, array in multi mode).
	 */
	_setValue(pValue)
	{
		if (!this._isMulti())
		{
			this._value = pValue;
			if (this.options.ValueAddress)
			{
				this.pict.manifest.setValueAtAddress(this.pict, this.options.ValueAddress, pValue);
			}
			return;
		}

		const tmpArray = Array.isArray(pValue) ? pValue : [];
		this._values = tmpArray;
		if (this.options.ValueAddress)
		{
			this.pict.manifest.setValueAtAddress(this.pict, this.options.ValueAddress, tmpArray);
		}
		if (this.options.StringArrayValueAddress)
		{
			this.pict.manifest.setValueAtAddress(this.pict, this.options.StringArrayValueAddress, tmpArray.join(','));
		}
		if (this.options.SelectedValuesAddress)
		{
			const tmpRecords = tmpArray.map((pVal) => this._selectedRecords[String(pVal)] || { Value: pVal, Text: String(pVal) });
			this.pict.manifest.setValueAtAddress(this.pict, this.options.SelectedValuesAddress, tmpRecords);
		}
	}

	/**
	 * Public: set the picker's value programmatically (e.g. when a host form marshals data into it).
	 * Accepts a scalar (single mode) or an array / csv string (multi mode), seeds display text for any
	 * unknown values (from the source rows, else async ResolveValue), then repaints.
	 * @param {any} pValue
	 * @return {PictViewPicker} this
	 */
	setValue(pValue)
	{
		if (this._isMulti())
		{
			let tmpArray = pValue;
			if (tmpArray === undefined || tmpArray === null || tmpArray === '') { tmpArray = []; }
			else if (typeof tmpArray === 'string') { tmpArray = tmpArray.split(',').filter((pPart) => pPart !== ''); }
			else if (!Array.isArray(tmpArray)) { tmpArray = [ tmpArray ]; }
			// Seed the {Value,Text} records BEFORE persisting, so the SelectedValuesAddress mirror that
			// _setValue writes carries real labels (not String(value) fallbacks). Mirrors select()'s
			// seed-then-persist order.
			this._seedSelectedRecords(tmpArray);
			this._setValue(tmpArray);
		}
		else
		{
			this._setValue(pValue);
			this._selectedText = null;
			this._seedSelectedRecords(this._isEmptyValue(pValue) ? [] : [ pValue ]);
		}
		this._reflectValue();
		return this;
	}

	/**
	 * Reflect a programmatic setValue into the DOM. Full render when the widget isn't live yet, or when
	 * _shapeSignature() shows something outside the value area / list changed; otherwise just repaint
	 * those two (the list's checkmark tracks the value). The targeted path is what lets a form marshal
	 * re-seed on every solve without tearing down the search box (losing focus) or orphaning a portal.
	 * select()/clearValue() keep their own full renders — this is only the setValue path.
	 */
	_reflectValue()
	{
		const tmpLive = (typeof document !== 'undefined') && !!document.getElementById(`PPS_${this.options.PickerHash}`);
		if (!tmpLive || (this._shapeSignature() !== this._renderedShape)) { this.render(); return; }
		this._renderValue();
		this._renderList();
	}

	/**
	 * Signature of the render-affecting state the targeted refresh CANNOT repaint — the three things that
	 * render outside #PPS_Value_ / #PPS_List_: the root's pps-multi/pps-readonly classes, the search box,
	 * and the inline clear × (gated on value presence, so it moves with no config change). _reflectValue
	 * full-renders when this changes. Extend it if the control template grows another such slot.
	 * @return {string}
	 */
	_shapeSignature()
	{
		const tmpMulti = this._isMulti();
		const tmpValue = tmpMulti ? undefined : this.getValue();
		const tmpHasValue = !this._isEmptyValue(tmpValue);
		return [
			tmpMulti,
			!!this.options.ReadOnly,
			!!this.options.Searchable,
			(!tmpMulti && this.options.AllowClear === true && tmpHasValue),
		].join('|');
	}

	/**
	 * Ensure each value has a {Value,Text} in _selectedRecords — from the current source rows when
	 * present, else (async mode) fetched via ResolveValue and painted in when it resolves.
	 * @param {Array<any>} pValues
	 */
	_seedSelectedRecords(pValues)
	{
		pValues.forEach((pVal) =>
		{
			if (this._isEmptyValue(pVal) || this._selectedRecords[String(pVal)]) { return; }
			const tmpRow = this._sourceRows().find((pRow) => String(pRow.Value) === String(pVal));
			if (tmpRow)
			{
				this._selectedRecords[String(pVal)] = { Value: tmpRow.Value, Text: tmpRow.Text, Tag: tmpRow.Tag, Tags: tmpRow.Tags };
				return;
			}
			if (this._isAsync() && typeof this.options.ResolveValue === 'function')
			{
				Promise.resolve(this.options.ResolveValue(pVal)).then((pResolved) =>
				{
					if (pResolved && pResolved.Text)
					{
						this._selectedRecords[String(pVal)] = { Value: pResolved.Value !== undefined ? pResolved.Value : pVal, Text: pResolved.Text, Tag: pResolved.Tag, Tags: pResolved.Tags };
						if (!this._isMulti()) { this._selectedText = pResolved.Text; }
						this._renderValue();
					}
				}).catch(() => { /* leave the raw value showing */ });
			}
		});
	}

	/** @return {Array<{Value:any, Text:string, Tag?:any}>} The current option source rows (async results or static Options). */
	_sourceRows()
	{
		if (this._isAsync()) { return this._loadedResults; }
		return Array.isArray(this.options.Options) ? this.options.Options : [];
	}

	/**
	 * Build the EntityTag before/after render slots for a record. Accepts a single tag value OR an array
	 * of them (the `Tags` multi-badge form), so a record can carry several disambiguation chips (e.g. a
	 * book's ISBN + year). Empty/blank entries are dropped; a tag-less record renders no badge. The slot
	 * is a per-tag `{Tag}` array, and the value/chip/option templates already iterate it with `{~TS:~}`.
	 * @param {any} pTags - a tag value, or an array of tag values.
	 * @param {boolean} pTagLast
	 * @return {{TagBeforeSlot:Array<any>, TagAfterSlot:Array<any>}}
	 */
	_tagSlots(pTags, pTagLast)
	{
		const tmpList = Array.isArray(pTags)
			? pTags
			: ((pTags !== undefined && pTags !== null && pTags !== '') ? [ pTags ] : []);
		const tmpSlot = tmpList
			.filter((pTag) => (pTag !== undefined && pTag !== null && pTag !== ''))
			.map((pTag) => ({ Tag: pTag }));
		return {
			TagBeforeSlot: (tmpSlot.length > 0 && !pTagLast) ? tmpSlot : [],
			TagAfterSlot: (tmpSlot.length > 0 && pTagLast) ? tmpSlot : [],
		};
	}

	/**
	 * The tag(s) to render for a record — the multi-badge `Tags` array when present, else the single
	 * `Tag` (back-compat). Centralizes the precedence used by every `_tagSlots` call site.
	 * @param {any} pRecord
	 * @return {any}
	 */
	_recordTags(pRecord)
	{
		if (!pRecord) { return undefined; }
		return (pRecord.Tags !== undefined) ? pRecord.Tags : pRecord.Tag;
	}

	// --- Field decoration (opt-in): let the user pin extra record fields onto each option row ---

	/** @return {boolean} The decoration affordance is available: opted in, interactive, and namespaced. */
	_decorationEnabled()
	{
		return (this.options.AllowFieldDecoration === true) && !this.options.ReadOnly && !!this._decorationKey();
	}

	/** localStorage key — per Entity, so a field pinned on one Organization picker shows on them all;
	 *  falls back to the picker hash when no Entity is set. @return {string} */
	_decorationKey()
	{
		if (this.options.Entity) { return `${_DECORATION_KEY_PREFIX}${this.options.Entity}`; }
		return this.options.PickerHash ? `${_DECORATION_KEY_PREFIX}${this.options.PickerHash}` : '';
	}

	/** Lazily resolve a storage backend: window.localStorage in a browser, an in-memory shim otherwise
	 *  (unit tests / SSR), mirroring the pict-section-recordset persistence idiom. */
	_decorationStorage()
	{
		if (this._decorationStore) { return this._decorationStore; }
		if ((typeof window === 'object') && window && (typeof window.localStorage === 'object') && window.localStorage)
		{
			this._decorationStore = window.localStorage;
		}
		else
		{
			const tmpMemory = {};
			this._decorationStore = {
				getItem: (pKey) => ((pKey in tmpMemory) ? tmpMemory[pKey] : null),
				setItem: (pKey, pValue) => { tmpMemory[pKey] = String(pValue); },
				removeItem: (pKey) => { delete tmpMemory[pKey]; },
			};
		}
		return this._decorationStore;
	}

	/** Read the persisted decoration field list for this picker's entity into _decorationFields. */
	_loadDecorationFields()
	{
		this._decorationFields = [];
		if (this.options.AllowFieldDecoration !== true) { return; }
		const tmpKey = this._decorationKey();
		if (!tmpKey) { return; }
		try
		{
			const tmpRaw = this._decorationStorage().getItem(tmpKey);
			const tmpParsed = tmpRaw ? JSON.parse(tmpRaw) : [];
			if (Array.isArray(tmpParsed)) { this._decorationFields = tmpParsed.filter((pField) => ((typeof pField === 'string') && pField)); }
		}
		catch (pError) { this._decorationFields = []; }
	}

	/** Persist the current decoration field list under this picker's entity key. */
	_saveDecorationFields()
	{
		const tmpKey = this._decorationKey();
		if (!tmpKey) { return; }
		try { this._decorationStorage().setItem(tmpKey, JSON.stringify(this._decorationFields)); }
		catch (pError) { /* storage full / disabled — the in-session choice still applies */ }
	}

	/** Field names hidden from the chooser: the common audit columns + the host's DecorationIgnoreFields +
	 *  the value/text fields (already shown as the row's value + label). @return {Set<string>} */
	_decorationIgnoreSet()
	{
		const tmpSet = new Set(_DECORATION_IGNORE_DEFAULT);
		const tmpHostIgnore = Array.isArray(this.options.DecorationIgnoreFields) ? this.options.DecorationIgnoreFields : [];
		tmpHostIgnore.forEach((pField) => { if (pField) { tmpSet.add(String(pField)); } });
		if (this.options.ValueField) { tmpSet.add(String(this.options.ValueField)); }
		else if (this.options.Entity) { tmpSet.add(`ID${this.options.Entity}`); }
		tmpSet.add(this.options.TextField ? String(this.options.TextField) : 'Name');
		return tmpSet;
	}

	/** Candidate decoration fields: the union of keys across the loaded rows' `Record` objects, minus the
	 *  ignore set, sorted. Empty until a result page carries records. @return {Array<string>} */
	_decorationCandidateFields()
	{
		const tmpKeys = {};
		this._sourceRows().forEach((pRow) =>
		{
			const tmpRecord = pRow && pRow.Record;
			if (tmpRecord && (typeof tmpRecord === 'object')) { Object.keys(tmpRecord).forEach((pKey) => { tmpKeys[pKey] = true; }); }
		});
		const tmpIgnore = this._decorationIgnoreSet();
		return Object.keys(tmpKeys).filter((pKey) => !tmpIgnore.has(pKey)).sort();
	}

	/** The decoration chips for an option: "Field: value" for each chosen field present on its `Record`.
	 *  @param {any} pOption @return {Array<string>|null} */
	_decorationTagsFor(pOption)
	{
		if (!this._decorationEnabled() || (this._decorationFields.length === 0)) { return null; }
		const tmpRecord = pOption && pOption.Record;
		if (!tmpRecord || (typeof tmpRecord !== 'object')) { return null; }
		const tmpTags = this._decorationFields
			.map((pField) => { const tmpValue = tmpRecord[pField]; return ((tmpValue !== undefined && tmpValue !== null && tmpValue !== '') ? `${pField}: ${tmpValue}` : null); })
			.filter((pTag) => (pTag !== null));
		return (tmpTags.length > 0) ? tmpTags : null;
	}

	/** The row's own EntityTag(s) plus the user's decoration chips (decorations last). @param {any} pOption */
	_combinedTags(pOption)
	{
		const tmpBase = this._recordTags(pOption);
		const tmpDecoration = this._decorationTagsFor(pOption);
		if (!tmpDecoration) { return tmpBase; }
		const tmpBaseList = Array.isArray(tmpBase) ? tmpBase : ((tmpBase !== undefined && tmpBase !== null && tmpBase !== '') ? [ tmpBase ] : []);
		return tmpBaseList.concat(tmpDecoration);
	}

	/** Toggle the field chooser open/closed (the ⚙ in the search row); repaints just the chooser + button. */
	toggleDecorate(pEvent)
	{
		if (pEvent && (typeof pEvent.stopPropagation === 'function')) { pEvent.stopPropagation(); }
		if (!this._decorationEnabled()) { return; }
		this._decorationOpen = !this._decorationOpen;
		this._renderDecorate();
		this._syncDecorateToggle();
	}

	/** Add/remove a field from the decoration set, persist, and repaint the option list + chooser. */
	toggleDecorateField(pField)
	{
		if (!pField) { return; }
		const tmpIndex = this._decorationFields.indexOf(pField);
		if (tmpIndex >= 0) { this._decorationFields.splice(tmpIndex, 1); }
		else { this._decorationFields.push(pField); }
		this._saveDecorationFields();
		this._renderList();
		this._renderDecorate();
		this._syncDecorateToggle();
	}

	/** Re-render only the chooser panel (mirrors _renderList — targeted, keeps the search input focused). */
	_renderDecorate()
	{
		if (typeof document === 'undefined') { return; }
		if (!document.getElementById(`PPS_Decorate_${this.options.PickerHash}`)) { return; }
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-DecoratePanel', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_Decorate_${this.options.PickerHash}`, tmpHTML);
	}

	/** Reflect the on/open state onto the ⚙ button without rebuilding the search row (which holds focus). */
	_syncDecorateToggle()
	{
		if (typeof document === 'undefined') { return; }
		const tmpBtn = document.getElementById(`PPS_DecorateBtn_${this.options.PickerHash}`);
		if (!tmpBtn) { return; }
		tmpBtn.classList.toggle('pps-decorate-on', (this._decorationFields.length > 0));
		tmpBtn.classList.toggle('pps-decorate-open', !!this._decorationOpen);
	}

	/**
	 * The empty-list text for the current search: the EmptyLabel string, or what an EmptyLabel function
	 * returns for the search term. A blank result or a throw falls back to the default.
	 *
	 * @return {string} The label, unescaped.
	 */
	_resolveEmptyLabel()
	{
		const tmpDefault = 'No matches';
		let tmpLabel = this.options.EmptyLabel;
		if (typeof tmpLabel === 'function')
		{
			try
			{
				tmpLabel = tmpLabel(this._search || '');
			}
			catch (pError)
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] EmptyLabel() threw; showing the default.`, pError);
				tmpLabel = '';
			}
		}
		return (typeof tmpLabel === 'string' && tmpLabel.length > 0) ? tmpLabel : tmpDefault;
	}

	/**
	 * The "Create …" row's text for a search term: the CreateLabel string, or what a CreateLabel function
	 * returns for the term. A blank result or a throw falls back to the default.
	 *
	 * @param {string} pTerm - The trimmed search term ('' when nothing is typed).
	 * @return {string} The label, unescaped.
	 */
	_resolveCreateLabel(pTerm)
	{
		const tmpDefault = (pTerm.length > 0) ? `Create “${pTerm}”` : 'Create new';
		let tmpLabel = this.options.CreateLabel;
		if (typeof tmpLabel === 'function')
		{
			try
			{
				tmpLabel = tmpLabel(pTerm);
			}
			catch (pError)
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] CreateLabel() threw; showing the default.`, pError);
				tmpLabel = '';
			}
		}
		return (typeof tmpLabel === 'string' && tmpLabel.length > 0) ? tmpLabel : tmpDefault;
	}

	/**
	 * The `--pps-option-lines` value for the open list, from OptionLabelLines: a whole number of lines, or
	 * `none` (0 / false) for no limit. Anything unusable falls back to the default.
	 *
	 * @return {string}
	 */
	_optionLabelLines()
	{
		const tmpLines = this.options.OptionLabelLines;
		if (tmpLines === 0 || tmpLines === false)
		{
			return 'none';
		}
		const tmpCount = parseInt(tmpLines, 10);
		return (tmpCount >= 1) ? String(tmpCount) : String(_DEFAULT_CONFIGURATION.OptionLabelLines);
	}

	/**
	 * (Re)compute the picker's render state into AppData: the displayed value / chips + the
	 * (search-filtered) option list with selected/highlight flags.
	 */
	_buildState()
	{
		const tmpState = this._state();
		const tmpAsync = this._isAsync();
		const tmpMulti = this._isMulti();
		const tmpSearch = (this._search || '').toLowerCase();

		// Source rows: async = the accumulated server results (already filtered server-side);
		// static = the configured Options, filtered locally by the search term.
		const tmpStatic = Array.isArray(this.options.Options) ? this.options.Options : [];
		const tmpSource = tmpAsync
			? this._loadedResults
			: tmpStatic.filter((pOption) => !tmpSearch || String(pOption.Text).toLowerCase().includes(tmpSearch));

		// Membership set used to flag options as selected (multi: every value; single: the one value).
		const tmpSelectedKeys = new Set((tmpMulti ? this.getValue() : [ this.getValue() ])
			.filter((pVal) => !this._isEmptyValue(pVal))
			.map((pVal) => String(pVal)));

		const tmpTagLast = !!this.options.TagLast;
		tmpState.Options = tmpSource.map((pOption, pIndex) =>
		{
			const tmpIsSelected = tmpSelectedKeys.has(String(pOption.Value));
			return Object.assign({
				PickerHash: this.options.PickerHash,
				ValueKey: String(pOption.Value),
				ValueKeyAttr: escapeHTML(String(pOption.Value)),
				Text: pOption.Text,
				TextAttr: escapeHTML(pOption.Text),
				Selected: tmpIsSelected,
				NotSelected: !tmpIsSelected,
				Highlight: (pIndex === this._highlight),
				IDMatchSlot: pOption.IDMatch ? [ { Label: escapeHTML(String(pOption.IDMatch)) } ] : [],
			}, this._tagSlots(this._combinedTags(pOption), tmpTagLast));
		});

		// Cluster options into categories (preserving order), keyed by each source row's optional Group.
		// With no Group fields everything lands in one unlabeled group, so the renderer has one path.
		const tmpGroups = [];
		const tmpGroupIndex = {};
		tmpState.Options.forEach((pOption, pIndex) =>
		{
			const tmpLabel = (tmpSource[pIndex] && tmpSource[pIndex].Group) ? String(tmpSource[pIndex].Group) : '';
			if (!(tmpLabel in tmpGroupIndex))
			{
				tmpGroupIndex[tmpLabel] = tmpGroups.length;
				tmpGroups.push({ Label: tmpLabel, HeaderSlot: tmpLabel ? [ { Label: tmpLabel } ] : [], Options: [] });
			}
			tmpGroups[tmpGroupIndex[tmpLabel]].Options.push(pOption);
		});
		tmpState.Groups = tmpGroups;

		// Creatable: offer "Create <term>" for a non-empty search that doesn't exactly match a known row, or
		// always when CreateAlwaysVisible pins the row.
		const tmpTerm = (this._search || '').trim();
		const tmpCanCreate = (typeof this.options.OnCreate === 'function')
			&& ((this.options.CreateAlwaysVisible === true)
				|| (tmpTerm.length > 0 && !this._sourceRows().some((pRow) => String(pRow.Text).trim().toLowerCase() === tmpTerm.toLowerCase())));
		tmpState.CreateSlot = tmpCanCreate
			? [ { PickerHash: this.options.PickerHash, Term: tmpTerm, TermAttr: escapeHTML(tmpTerm), Label: escapeHTML(this._resolveCreateLabel(tmpTerm)) } ]
			: [];

		tmpState.PickerHash = this.options.PickerHash;
		tmpState.IsMulti = tmpMulti;
		tmpState.Placeholder = this.options.Placeholder;
		tmpState.Searchable = !!this.options.Searchable;
		tmpState.ReadOnly = !!this.options.ReadOnly;
		tmpState.OptionLabelLines = this._optionLabelLines();

		// Clearable (AllowClear, single mode): the pinned "Any" dropdown row — checked when nothing is
		// selected ("Any" is the active state) — and the control's inline × while a value is selected.
		const tmpAllowClear = (!tmpMulti && this.options.AllowClear === true);
		const tmpClearableValue = tmpMulti ? undefined : this.getValue();
		const tmpClearableHasValue = !this._isEmptyValue(tmpClearableValue);
		tmpState.ClearOptionSlot = tmpAllowClear
			? [ { PickerHash: this.options.PickerHash, Label: this.options.ClearLabel || 'Any', Selected: !tmpClearableHasValue, NotSelected: tmpClearableHasValue } ]
			: [];
		tmpState.ClearSlot = (tmpAllowClear && tmpClearableHasValue) ? [ { PickerHash: this.options.PickerHash } ] : [];
		// Field decoration (opt-in): the ⚙ toggle rides in the search row; the chooser panel renders between
		// search and list. Both are single-element-array slots gated on the feature being enabled + eligible.
		const tmpDecorate = this._decorationEnabled();
		const tmpDecorateFields = (tmpDecorate && this._decorationOpen) ? this._decorationCandidateFields() : [];
		tmpState.DecoratePanelSlot = (tmpDecorate && this._decorationOpen)
			? [ {
				PickerHash: this.options.PickerHash,
				Fields: tmpDecorateFields.map((pField) => ({ PickerHash: this.options.PickerHash, Field: pField, FieldAttr: escapeHTML(pField), Checked: (this._decorationFields.indexOf(pField) >= 0) })),
				NoFields: (tmpDecorateFields.length === 0),
			} ]
			: [];
		// Single-element-array conditionals (render the search box / "Load more" only when applicable).
		tmpState.SearchSlot = this.options.Searchable
			? [ {
				PickerHash: this.options.PickerHash,
				DecorateSlot: tmpDecorate ? [ { PickerHash: this.options.PickerHash, HasFields: (this._decorationFields.length > 0), Open: !!this._decorationOpen } ] : [],
			} ]
			: [];
		tmpState.Loading = !!this._loading;
		tmpState.IsEmpty = (tmpState.Options.length === 0 && !this._loading && !tmpCanCreate);
		tmpState.EmptySlot = tmpState.IsEmpty ? [ { Label: escapeHTML(this._resolveEmptyLabel()) } ] : [];
		tmpState.HasMore = !!(tmpAsync && this._hasMore && !this._loading);
		tmpState.MoreSlot = tmpState.HasMore ? [ { PickerHash: this.options.PickerHash } ] : [];

		// Preview-card affordance (opt-in): a small ⓘ next to the selected value / chips that opens the
		// entity's registered preview card. Active only when the host registered a RecordSetCardManager
		// (soft dependency) that has a card for this picker's Entity, and the picker didn't opt out
		// (RecordCard !== false). Otherwise the picker renders exactly as before.
		const tmpCardManager = this.pict.providers.RecordSetCardManager;
		const tmpCardEntity = this.options.Entity;
		const tmpCardEnabled = !!(tmpCardManager && tmpCardEntity && (this.options.RecordCard !== false) && (typeof tmpCardManager.hasCard === 'function') && tmpCardManager.hasCard(tmpCardEntity));

		// The single/multi value-area is rendered via single-element-array slots; each slot's element
		// IS the Record for its sub-template, so it must carry everything that template references.
		if (tmpMulti)
		{
			// A sentinel inside the array is dropped from the chip list, so a Number-typed multi picker
			// marshalling in as a lone 0 shows the placeholder rather than a "0" chip.
			const tmpValues = this.getValue().filter((pVal) => !this._isEmptyValue(pVal));
			const tmpNoValue = (tmpValues.length === 0);
			const tmpChips = tmpValues.map((pVal) =>
			{
				const tmpRecord = this._lookupRecord(pVal);
				return Object.assign(
					{ PickerHash: this.options.PickerHash, ValueKey: String(pVal), ValueKeyAttr: escapeHTML(String(pVal)), Text: tmpRecord ? tmpRecord.Text : String(pVal), TextAttr: escapeHTML(tmpRecord ? tmpRecord.Text : String(pVal)), CardSlot: tmpCardEnabled ? [ { PickerHash: this.options.PickerHash, Entity: tmpCardEntity, EntityAttr: escapeHTML(tmpCardEntity), Value: String(pVal), ValueAttr: escapeHTML(String(pVal)) } ] : [] },
					this._tagSlots(this._recordTags(tmpRecord), tmpTagLast));
			});
			tmpState.SingleSlot = [];
			tmpState.MultiSlot = [ {
				PickerHash: this.options.PickerHash,
				Chips: tmpChips,
				PlaceholderSlot: tmpNoValue ? [ { Placeholder: this.options.Placeholder } ] : [],
			} ];
		}
		else
		{
			const tmpValue = this.getValue();
			const tmpHasValue = !this._isEmptyValue(tmpValue);
			const tmpSelected = tmpHasValue ? this._lookupRecord(tmpValue) : null;
			// No value → the placeholder, never a stale _selectedText left over from a prior selection.
			const tmpDisplayText = !tmpHasValue ? this.options.Placeholder
				: (tmpSelected ? tmpSelected.Text : (this._selectedText || String(tmpValue)));
			tmpState.SingleSlot = [ Object.assign({
				PickerHash: this.options.PickerHash,
				DisplayText: tmpDisplayText,
				DisplayTextAttr: escapeHTML(tmpDisplayText),
				NoValue: !tmpHasValue,
				CardSlot: (tmpCardEnabled && tmpHasValue) ? [ { PickerHash: this.options.PickerHash, Entity: tmpCardEntity, EntityAttr: escapeHTML(tmpCardEntity), Value: String(tmpValue), ValueAttr: escapeHTML(String(tmpValue)) } ] : [],
			}, this._tagSlots(this._recordTags(tmpSelected), tmpTagLast)) ];
			tmpState.MultiSlot = [];
		}
		return tmpState;
	}

	/**
	 * Find the {Value,Text} record for a value: the stored selection record (authoritative for chips /
	 * async), else a row in the current source (static Options or loaded results).
	 * @param {any} pValue
	 * @return {{Value:any, Text:string, Tag?:any}|null}
	 */
	_lookupRecord(pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '') { return null; }
		const tmpStored = this._selectedRecords[String(pValue)];
		if (tmpStored) { return tmpStored; }
		return this._sourceRows().find((pOption) => String(pOption.Value) === String(pValue)) || null;
	}

	/**
	 * Load a page of results from the async DataProvider, accumulating (append) or replacing the list.
	 * @param {number} pPage - zero-based page index.
	 * @param {boolean} pAppend - true to append (Load more), false to replace (new search / first open).
	 */
	_loadPage(pPage, pAppend)
	{
		if (!this._isAsync()) { return; }
		// Minimum-search-length gate: below the threshold, don't hit the server. First page only
		// (browse-on-open + new search); "Load more" always already has an at-length term.
		const tmpMinLength = this.options.MinimumSearchLength || 0;
		if (tmpMinLength > 0 && !pAppend && pPage === 0 && (this._search || '').trim().length < tmpMinLength)
		{
			this._loadedResults = [];
			this._hasMore = false;
			this._page = 0;
			this._loaded = true;
			this._loading = false;
			this._renderList();
			return;
		}
		this._loading = true;
		this._renderList();
		const tmpSearchAtRequest = this._search;
		Promise.resolve()
			.then(() => this.options.DataProvider(this._search, pPage))
			.then((pResult) =>
			{
				// Drop a stale first-page response if the search term changed while it was in flight.
				if (!pAppend && pPage === 0 && tmpSearchAtRequest !== this._search) { return; }
				const tmpResults = (pResult && Array.isArray(pResult.results)) ? pResult.results : [];
				this._loadedResults = pAppend ? this._loadedResults.concat(tmpResults) : tmpResults;
				this._hasMore = !!(pResult && pResult.hasMore);
				this._page = pPage;
				this._loaded = true;
				this._loading = false;
				this._renderList();
			})
			.catch((pError) =>
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] DataProvider error.`, pError);
				this._loading = false;
				this._renderList();
			});
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		// A closed picker's full render paints an empty search box, and the view outlives a mount (the same
		// PickerHash hands this instance back), so a term kept from before would filter unseen.
		if (!this._open)
		{
			this._search = '';
		}
		this._buildState();
		return super.onBeforeRender(pRenderable);
	}

	/** Toggle the dropdown open/closed. */
	toggle(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		return this._open ? this.close() : this.open();
	}

	/** Keyboard on the control: open the dropdown on Enter / Space / ArrowDown. */
	onControlKey(pEvent)
	{
		if (pEvent.key === 'Enter' || pEvent.key === ' ' || pEvent.key === 'ArrowDown')
		{
			pEvent.preventDefault();
			if (!this._open) { this.open(); }
		}
		else if (pEvent.key === 'Escape')
		{
			this.close();
		}
	}

	/** Open the dropdown and focus the search box. With the opt-in SingleActivePicker option, closes
	 *  any open sibling picker first — one active dropdown per page. */
	open()
	{
		this._claimActivePicker();
		this._open = true;
		this._highlight = -1;
		this._paintOpen();
		this._applyAnchorMode();
		if (this._isAsync() && !this._loaded) { this._loadPage(0, false); }
		const tmpSearch = /** @type {HTMLInputElement} */ (document.getElementById(`PPS_Search_${this.options.PickerHash}`));
		if (tmpSearch) { tmpSearch.focus(); tmpSearch.select(); }
	}

	/** Take the provider's single-active slot, closing whichever sibling holds it. Opt-in only (an off
	 *  picker neither claims nor is closed). The slot holds a hash on the provider, so two pict instances
	 *  sharing this module can't cross-close. */
	_claimActivePicker()
	{
		const tmpProvider = this.options.PickerProvider;
		if (!this.options.SingleActivePicker || !tmpProvider) { return; }
		const tmpOpenHash = tmpProvider.currentOpenPickerHash;
		if (tmpOpenHash && tmpOpenHash !== this.options.PickerHash)
		{
			const tmpOpenView = this.pict.views[tmpOpenHash];
			if (tmpOpenView && typeof tmpOpenView.close === 'function') { tmpOpenView.close(); }
		}
		tmpProvider.currentOpenPickerHash = this.options.PickerHash;
	}

	/*
	 * Dropdown anchoring & render states
	 * ----------------------------------
	 * Anchoring (picked per open by _applyAnchorMode -> _shouldPortal):
	 *   CSS      : .pps-pop is absolute inside the widget and rides page scroll for free. Default.
	 *   Portaled : moved to <body> in document coords when a clipping ancestor (overflow != visible)
	 *              would actually cut it. Still absolute, so it rides scroll too; carries the control's
	 *              --theme-color-* across since it left any scoped container.
	 * Open  : _open -> pps-open on the root, pps-pop-open on the pop (a portaled pop is outside the
	 *         root's .pps-open rule, so it needs its own class to show).
	 * Render: full render() rebuilds the widget; setValue uses the targeted _reflectValue (value area +
	 *         list only) unless _shapeSignature() shows something outside them changed.
	 * _popElement finds the pop in either place; _markClosed is the single close funnel.
	 */

	/** The pop wherever it lives (in-widget or portaled). By position not id: a re-render can briefly
	 *  leave two sharing the id, and the in-widget copy is the live one. @return {HTMLElement|null} */
	_popElement()
	{
		if (typeof document === 'undefined') { return null; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpInWidget = tmpRoot ? /** @type {HTMLElement} */ (tmpRoot.querySelector('.pps-pop')) : null;
		if (tmpInWidget) { return tmpInWidget; }
		return /** @type {HTMLElement} */ (document.querySelector(`body > [id="PPS_Pop_${this.options.PickerHash}"]`));
	}

	/** Pick this open's anchoring (see states above): portal when _shouldPortal finds a clipping ancestor
	 *  that would cut the panel, else CSS. Judged from the control, which never moves — a portaled panel
	 *  has no clipping ancestors, so testing it would flip-flop. */
	_applyAnchorMode()
	{
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpPop = this._popElement();
		if (!tmpPop) { return; }
		const tmpControl = tmpRoot ? /** @type {HTMLElement} */ (tmpRoot.querySelector('.pps-control')) : null;
		this._portaled = !!tmpControl && this._shouldPortal(tmpControl);
		if (this._portaled) { this._portalPop(tmpPop); }
		else { this._restorePop(tmpPop); }
		// A portaled pop is hidden until pps-pop-open is set (it's outside the root's .pps-open rule).
		tmpPop.classList.toggle('pps-pop-open', !!this._open);
	}

	/** Move the panel to <body> and place it against the control in document coords (viewport rect +
	 *  scroll), flipping above when room below is short. Width is pinned since it no longer inherits the
	 *  widget's. @param {HTMLElement} pPop */
	_portalPop(pPop)
	{
		if (typeof document === 'undefined') { return; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpControl = tmpRoot ? tmpRoot.querySelector('.pps-control') : null;
		if (!tmpControl) { return; }
		// Sweep any stale portaled copy a prior re-render left on <body> (same id) before adopting this one.
		document.querySelectorAll(`body > [id="PPS_Pop_${this.options.PickerHash}"]`)
			.forEach((pNode) => { if (pNode !== pPop) { pNode.remove(); } });
		if (pPop.parentElement !== document.body) { document.body.appendChild(pPop); }
		pPop.classList.add('pps-pop-portal');

		// Carry the resolved --theme-color-* across: on <body> the panel has left any scoped container, so
		// without this it would fall back to the hex defaults. Skip empty reads — pinning "" would defeat
		// the var(--token, #hex) fallback for tokens the host never defined.
		if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function')
		{
			const tmpComputed = window.getComputedStyle(tmpControl);
			_THEME_TOKENS.forEach((pToken) =>
			{
				const tmpValue = tmpComputed.getPropertyValue(pToken);
				if (tmpValue && tmpValue.trim() !== '') { pPop.style.setProperty(pToken, tmpValue.trim()); }
			});
		}

		const tmpRect = tmpControl.getBoundingClientRect();
		const tmpGap = 5;
		const tmpMargin = 8;
		const tmpIdeal = 360;
		const tmpWidth = Math.max(200, Math.round(tmpRect.width));
		const tmpSpaceBelow = window.innerHeight - tmpRect.bottom - tmpGap - tmpMargin;
		const tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		const tmpBelow = (tmpSpaceBelow >= tmpIdeal) || (tmpSpaceBelow >= tmpSpaceAbove);
		const tmpPanel = /** @type {HTMLElement} */ (pPop.querySelector('.pps-panel'));

		pPop.style.width = `${tmpWidth}px`;
		pPop.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.left, window.innerWidth - tmpWidth - tmpMargin)) + window.scrollX)}px`;
		pPop.style.bottom = 'auto';
		// Document coords (viewport rect + scroll): absolute against <body>, so one placement is enough.
		pPop.style.top = tmpBelow
			? `${Math.round(tmpRect.bottom + tmpGap + window.scrollY)}px`
			: `${Math.round(tmpRect.top - tmpGap + window.scrollY)}px`;
		if (!tmpBelow) { pPop.style.transform = 'translateY(-100%)'; }
		else { pPop.style.transform = ''; }
		if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(0, Math.round(Math.min(tmpBelow ? tmpSpaceBelow : tmpSpaceAbove, tmpIdeal)))}px`; }
	}

	/** Re-home a portaled panel and drop everything the portal wrote. Doubles as the orphan sweeper: if a
	 *  re-render already put a fresh panel in the widget, the portaled one is stale and gets discarded.
	 *  @param {HTMLElement} pPop */
	_restorePop(pPop)
	{
		if (typeof document === 'undefined' || !pPop) { return; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		if (pPop.parentElement === document.body)
		{
			if (!tmpRoot) { pPop.remove(); return; }
			// A re-render already put a fresh panel in the widget — this portaled one is a leftover.
			if (tmpRoot.querySelector('.pps-pop') && tmpRoot.querySelector('.pps-pop') !== pPop) { pPop.remove(); return; }
			tmpRoot.appendChild(pPop);
		}
		pPop.classList.remove('pps-pop-portal');
		// Clear the inline offsets, or they'd override the stylesheet and strand the panel.
		pPop.style.top = '';
		pPop.style.left = '';
		pPop.style.right = '';
		pPop.style.bottom = '';
		pPop.style.width = '';
		pPop.style.transform = '';
		// Drop the copied tokens so back in the widget it inherits them live again.
		_THEME_TOKENS.forEach((pToken) => pPop.style.removeProperty(pToken));
		const tmpPanel = /** @type {HTMLElement} */ (pPop.querySelector('.pps-panel'));
		if (tmpPanel) { tmpPanel.style.maxHeight = ''; }
	}

	/** Portal when ANY clipping ancestor would actually cut the panel (_clipBites) — an overflow ancestor
	 *  alone isn't enough, but a roomy inner clipper doesn't excuse a tighter one further out.
	 *  @param {HTMLElement} pControl @return {boolean} */
	_shouldPortal(pControl)
	{
		// Walk every clipper outward, not just the nearest: _clippingAncestor starts from parentElement,
		// so re-feeding it the clipper it returned continues the walk.
		let tmpClipper = this._clippingAncestor(pControl);
		while (tmpClipper)
		{
			if (this._clipBites(pControl, tmpClipper)) { return true; }
			tmpClipper = this._clippingAncestor(tmpClipper);
		}
		return false;
	}

	/** Nearest ancestor (up to, not including, body) with an overflow clip on any axis, or null. Stops at
	 *  body because the document's own scroll is what the absolute anchoring rides on, not a clip.
	 *  @param {HTMLElement} pElement @return {HTMLElement|null} */
	_clippingAncestor(pElement)
	{
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') { return null; }
		let tmpNode = pElement ? pElement.parentElement : null;
		while (tmpNode && tmpNode.nodeType === 1 && tmpNode !== document.body)
		{
			const tmpStyle = window.getComputedStyle(tmpNode);
			if (tmpStyle && [ tmpStyle.overflow, tmpStyle.overflowX, tmpStyle.overflowY ].some((pValue) => pValue && pValue !== 'visible'))
			{
				return /** @type {HTMLElement} */ (tmpNode);
			}
			tmpNode = tmpNode.parentElement;
		}
		return null;
	}

	/** True when the control has any overflow-clipping ancestor. Thin boolean over _clippingAncestor;
	 *  the anchor decision uses _shouldPortal, which also weighs whether the clip reaches the panel.
	 *  @param {HTMLElement} pElement @return {boolean} */
	_hasClippingAncestor(pElement) { return !!this._clippingAncestor(pElement); }

	/** Would the clipper cut the panel if it opened in place? The CSS path always opens downward and never
	 *  flips, so project that worst-case box (control bottom + gap, up to max height) and test whether any
	 *  edge falls outside the clipper. 1px slack avoids a needless portal on a flush edge.
	 *  @param {HTMLElement} pControl @param {HTMLElement} pClipper @return {boolean} */
	_clipBites(pControl, pClipper)
	{
		if (!pControl || !pClipper || typeof pControl.getBoundingClientRect !== 'function'
			|| typeof pClipper.getBoundingClientRect !== 'function') { return true; }
		const tmpControlRect = pControl.getBoundingClientRect();
		const tmpClipRect = pClipper.getBoundingClientRect();
		const tmpGap = 5;
		const tmpIdeal = 360;
		const tmpSlack = 1;
		const tmpPanelTop = tmpControlRect.bottom + tmpGap;
		const tmpPanelBottom = tmpPanelTop + tmpIdeal;
		const tmpWidth = Math.max(200, tmpControlRect.width);
		const tmpPanelLeft = tmpControlRect.left;
		const tmpPanelRight = tmpControlRect.left + tmpWidth;
		return (tmpPanelBottom > tmpClipRect.bottom + tmpSlack)
			|| (tmpPanelTop < tmpClipRect.top - tmpSlack)
			|| (tmpPanelLeft < tmpClipRect.left - tmpSlack)
			|| (tmpPanelRight > tmpClipRect.right + tmpSlack);
	}

	/** The single close funnel (close, single-mode select, clearValue, createFromSearch): clears open
	 *  state, the provider's active-picker slot, and the results cache so nothing leaks a stale reference. */
	_markClosed()
	{
		this._open = false;
		this._highlight = -1;
		this._decorationOpen = false;
		const tmpProvider = this.options.PickerProvider;
		if (tmpProvider && tmpProvider.currentOpenPickerHash === this.options.PickerHash) { tmpProvider.currentOpenPickerHash = false; }
		// Bring a portaled panel home, so a closed picker never leaves a stray on <body>.
		if (this._portaled) { this._restorePop(this._popElement()); this._portaled = false; }
		// Drop the accumulated pages so the next open re-queries — BaseFilter is resolved per query
		// because the host's scope shifts underneath the picker (a "Show All" toggle, a dependent pick),
		// so caching across a close would serve the old scope. Matches the legacy select2 re-query.
		this._loaded = false;
		this._loadedResults = [];
		this._page = 0;
		this._hasMore = false;
		// Back-off state spans only page 0 -> "load more" in one session, so release it here too.
		if (tmpProvider && tmpProvider.backOffState) { delete tmpProvider.backOffState[this.options.PickerHash]; }
	}


	/** Async mode: load + append the next page of results. */
	loadMore()
	{
		if (this._isAsync() && this._hasMore && !this._loading)
		{
			this._loadPage(this._page + 1, true);
		}
	}

	/** Close the dropdown. */
	close()
	{
		this._markClosed();
		this._paintOpen();
	}

	/**
	 * Close from the transparent backdrop, and pass the click through to whatever
	 * the user actually aimed at.
	 *
	 * The backdrop is a full-viewport layer, so while a picker is open EVERY click
	 * elsewhere on the page lands on it and is consumed closing the dropdown. The
	 * button underneath never sees it, and the interaction reads as "the first
	 * click did nothing" — measured on a filter bar, the Apply handler recorded
	 * zero calls on the first click and one on the second. A dropdown dismissing
	 * itself should not also cost the click that dismissed it.
	 *
	 * The backdrop is display:none the moment the widget is painted closed, so
	 * elementFromPoint then returns the real target rather than the backdrop.
	 *
	 * @param {MouseEvent} pEvent - The backdrop click.
	 */
	closeFromBackdrop(pEvent)
	{
		this.close();
		if (!pEvent || (typeof document === 'undefined') || (typeof document.elementFromPoint !== 'function'))
		{
			return;
		}
		const tmpTarget = document.elementFromPoint(pEvent.clientX, pEvent.clientY);
		// Nothing meaningful under the cursor (or the backdrop somehow survived) —
		// closing was the whole intent.
		if (!tmpTarget || tmpTarget === document.body || tmpTarget === document.documentElement
			|| (tmpTarget.classList && tmpTarget.classList.contains('pps-backdrop')))
		{
			return;
		}
		if (typeof tmpTarget.click === 'function') { tmpTarget.click(); }
	}

	/** Opt-in teardown for a host that drops the view (pict-view has no destroy hook). _markClosed already
	 *  releases the single-active slot, re-homes/removes a portaled panel, and clears the back-off entry;
	 *  the un-destroyed case is harmless since a stray portaled pop stays hidden without pps-pop-open. */
	destroy()
	{
		this._markClosed();
		this._paintOpen();
		// Belt-and-suspenders: if the widget root was detached mid-teardown, take any stray pop with us.
		if (typeof document !== 'undefined')
		{
			const tmpStray = document.querySelector(`body > [id="PPS_Pop_${this.options.PickerHash}"]`);
			if (tmpStray) { tmpStray.remove(); }
		}
	}

	/** Reflect open/closed on the root (pps-open) and on the pop (pps-pop-open) — a portaled pop is outside
	 *  the root's rule, so it needs the class directly, which also keeps a stray one hidden. */
	_paintOpen()
	{
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		if (tmpRoot) { tmpRoot.classList.toggle('pps-open', !!this._open); }
		const tmpPop = this._popElement();
		if (tmpPop) { tmpPop.classList.toggle('pps-pop-open', !!this._open); }
	}

	/** Re-render only the option list (keeps the search input + its focus intact). */
	_renderList()
	{
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-List', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_List_${this.options.PickerHash}`, tmpHTML);
	}

	/** Re-render only the control's value area (the value span or the chips) — used in multi mode so
	 *  toggling a selection updates the chips without tearing down the open dropdown + search box. */
	_renderValue()
	{
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-ValueArea', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_Value_${this.options.PickerHash}`, tmpHTML);
	}

	/** @param {string} pValue - Filter the option list by this search term. */
	search(pValue)
	{
		this._search = pValue || '';
		this._highlight = -1;
		if (this._isAsync())
		{
			// Debounce server searches; reset to page 0.
			if (this._searchTimer) { clearTimeout(this._searchTimer); }
			this._searchTimer = setTimeout(() => { this._loadPage(0, false); }, 220);
		}
		else
		{
			this._renderList();
		}
	}

	/** Keyboard navigation within the search box: arrows highlight, Enter selects, Escape closes. */
	onSearchKey(pEvent)
	{
		const tmpOptions = this._state().Options || [];
		if (pEvent.key === 'ArrowDown')
		{
			pEvent.preventDefault();
			this._highlight = Math.min(this._highlight + 1, tmpOptions.length - 1);
			this._renderList();
		}
		else if (pEvent.key === 'ArrowUp')
		{
			pEvent.preventDefault();
			this._highlight = Math.max(this._highlight - 1, 0);
			this._renderList();
		}
		else if (pEvent.key === 'Enter')
		{
			pEvent.preventDefault();
			if (this._highlight >= 0 && tmpOptions[this._highlight])
			{
				this.select(tmpOptions[this._highlight].ValueKey);
			}
			else if ((this._state().CreateSlot || []).length > 0 && (this._search || '').trim().length > 0)
			{
				this.createFromSearch();
			}
		}
		else if (pEvent.key === 'Escape')
		{
			pEvent.preventDefault();
			this.close();
		}
	}

	/**
	 * Read a `data-` attribute off a clicked element. The option / chip / card / decorate handlers carry
	 * the value they operate on in a data attribute instead of inlining it into the onclick string, so a
	 * value containing a quote (e.g. `1"`) can never break the attribute or the handler; the browser has
	 * already decoded the attribute back to the raw value by the time we read it here.
	 * @param {any} pElement - the clicked DOM element (`this` inside the inline handler).
	 * @param {string} pAttribute - the data attribute to read.
	 * @return {string|null}
	 */
	_readElementData(pElement, pAttribute)
	{
		return (pElement && typeof pElement.getAttribute === 'function') ? pElement.getAttribute(pAttribute) : null;
	}

	/** Option-row click shim: select the value carried in `data-pps-valuekey`. @param {any} pElement */
	selectFromElement(pElement)
	{
		const tmpValueKey = this._readElementData(pElement, 'data-pps-valuekey');
		if (tmpValueKey !== null) { this.select(tmpValueKey); }
	}

	/** Chip-× click shim: remove the value carried in `data-pps-valuekey`. @param {any} pElement */
	removeChipFromElement(pElement)
	{
		const tmpValueKey = this._readElementData(pElement, 'data-pps-valuekey');
		if (tmpValueKey !== null) { this.removeChip(tmpValueKey); }
	}

	/** Preview-card ⓘ click shim: open the card for the entity/value carried in data attributes. @param {any} pElement */
	openCardFromElement(pElement)
	{
		const tmpManager = this.pict.providers.RecordSetCardManager;
		if (!tmpManager || typeof tmpManager.openCard !== 'function') { return; }
		tmpManager.openCard(this._readElementData(pElement, 'data-pps-entity'), this._readElementData(pElement, 'data-pps-value'), pElement);
	}

	/** Field-decoration checkbox click shim: toggle the field carried in `data-pps-field`. @param {any} pElement */
	toggleDecorateFieldFromElement(pElement)
	{
		const tmpField = this._readElementData(pElement, 'data-pps-field');
		if (tmpField !== null) { this.toggleDecorateField(tmpField); }
	}

	/**
	 * Select an option. Single mode: set the value + close. Multi mode: toggle the value in/out of the
	 * selection, keep the dropdown open, and refocus the search box for rapid multi-pick.
	 * @param {string} pValueKey - String(Value) of the option.
	 */
	select(pValueKey)
	{
		const tmpOption = this._sourceRows().find((pOption) => String(pOption.Value) === String(pValueKey));
		if (!tmpOption) { return; }

		if (!this._isMulti())
		{
			this._selectedText = tmpOption.Text;
			this._selectedRecords[String(tmpOption.Value)] = { Value: tmpOption.Value, Text: tmpOption.Text, Tag: tmpOption.Tag, Tags: tmpOption.Tags };
			this._setValue(tmpOption.Value);
			this._search = '';
			this._markClosed();
			this.render();
			if (typeof this.options.OnChange === 'function')
			{
				this.options.OnChange(tmpOption.Value, tmpOption);
			}
			return;
		}

		// Multi: toggle membership.
		const tmpValues = this.getValue().slice();
		const tmpIndex = tmpValues.findIndex((pVal) => String(pVal) === String(pValueKey));
		if (tmpIndex >= 0)
		{
			tmpValues.splice(tmpIndex, 1);
			delete this._selectedRecords[String(pValueKey)];
		}
		else
		{
			tmpValues.push(tmpOption.Value);
			this._selectedRecords[String(pValueKey)] = { Value: tmpOption.Value, Text: tmpOption.Text, Tag: tmpOption.Tag, Tags: tmpOption.Tags };
		}
		this._setValue(tmpValues);
		this._renderValue();
		this._renderList();
		if (typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(tmpValues, this.getSelectedRecords());
		}
		// Focus AFTER OnChange: a host that re-marshals inside its handler re-renders the widget and would
		// blow away a focus set before it. onAfterRender also restores focus while open, covering the
		// re-render that does happen; this covers the common case where it does not.
		const tmpSearch = document.getElementById(`PPS_Search_${this.options.PickerHash}`);
		if (tmpSearch) { tmpSearch.focus(); }
	}

	/**
	 * Clearable (AllowClear, single mode): empty the selection — from the control's inline × or the
	 * pinned "Any" dropdown row. Closing mirrors select() (clearing IS a selection: "Any"), and
	 * OnChange(null, null) fires only when there was a value to clear, so clicking "Any" while
	 * already empty just closes the dropdown.
	 */
	clearValue()
	{
		if (this._isMulti()) { return; }
		const tmpValue = this.getValue();
		const tmpHadValue = !this._isEmptyValue(tmpValue);
		this._selectedText = null;
		this._setValue(null);
		this._search = '';
		this._markClosed();
		this.render();
		if (tmpHadValue && typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(null, null);
		}
	}

	/** @return {Array<{Value:any, Text:string}>} The full record list for the current multi selection. */
	getSelectedRecords()
	{
		return this.getValue().map((pVal) => this._selectedRecords[String(pVal)] || { Value: pVal, Text: String(pVal) });
	}

	/**
	 * Creatable: build a new option from the current search term via OnCreate, then select it (single:
	 * set + close; multi: add a chip). The created record is inserted into the source list so it shows
	 * as a normal, checked option.
	 */
	createFromSearch()
	{
		const tmpTerm = (this._search || '').trim();
		if ((!tmpTerm && this.options.CreateAlwaysVisible !== true) || typeof this.options.OnCreate !== 'function') { return; }
		Promise.resolve(this.options.OnCreate(tmpTerm)).then((pRecord) =>
		{
			if (!pRecord || pRecord.Value === undefined || pRecord.Value === null) { return; }
			// Make the new record part of the source so the list can render it like any other option.
			if (this._isAsync())
			{
				if (!this._loadedResults.some((pRow) => String(pRow.Value) === String(pRecord.Value))) { this._loadedResults.unshift(pRecord); }
			}
			else if (Array.isArray(this.options.Options) && !this.options.Options.some((pRow) => String(pRow.Value) === String(pRecord.Value)))
			{
				this.options.Options.unshift(pRecord);
			}
			this._selectedRecords[String(pRecord.Value)] = { Value: pRecord.Value, Text: pRecord.Text, Tag: pRecord.Tag };

			if (this._isMulti())
			{
				const tmpValues = this.getValue().slice();
				if (!tmpValues.some((pVal) => String(pVal) === String(pRecord.Value))) { tmpValues.push(pRecord.Value); }
				this._setValue(tmpValues);
				this._search = '';
				this._highlight = -1;
				this._renderValue();
				this._renderList();
				const tmpSearchBox = /** @type {HTMLInputElement} */ (document.getElementById(`PPS_Search_${this.options.PickerHash}`));
				if (tmpSearchBox) { tmpSearchBox.value = ''; tmpSearchBox.focus(); }
				if (typeof this.options.OnChange === 'function') { this.options.OnChange(tmpValues, this.getSelectedRecords()); }
			}
			else
			{
				this._selectedText = pRecord.Text;
				this._setValue(pRecord.Value);
				this._search = '';
				this._markClosed();
				this.render();
				if (typeof this.options.OnChange === 'function') { this.options.OnChange(pRecord.Value, pRecord); }
			}
		}).catch((pError) =>
		{
			this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] OnCreate error.`, pError);
		});
	}

	/** Multi mode: remove a selected value (chip ×). Keeps the dropdown state as-is. */
	removeChip(pValueKey)
	{
		const tmpValues = this.getValue().filter((pVal) => String(pVal) !== String(pValueKey));
		delete this._selectedRecords[String(pValueKey)];
		this._setValue(tmpValues);
		this._renderValue();
		if (this._open) { this._renderList(); }
		if (typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(tmpValues, this.getSelectedRecords());
		}
	}

	/** @param {import('pict-view').Renderable} pRenderable */
	onAfterRender(pRenderable)
	{
		if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		// Stamp the painted shape so a later setValue knows if a targeted refresh still fits (_reflectValue).
		this._renderedShape = this._shapeSignature();
		this._paintOpen();
		// A render while open rebuilds a fresh in-widget pop and orphans any portaled one; re-anchoring
		// sweeps the orphan and re-portals, then we restore the search focus the render dropped.
		if (this._open)
		{
			this._applyAnchorMode();
			const tmpSearch = document.getElementById(`PPS_Search_${this.options.PickerHash}`);
			if (tmpSearch && document.activeElement !== tmpSearch) { tmpSearch.focus(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = PictViewPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":365}],292:[function(require,module,exports){
'use strict';

/**
 * pict-section-prompteditor
 *
 * A self-contained Pict section for crafting, curating, and generating AI
 * prompts as a team:
 *
 *   - prompts are markdown, organized by prompt type into segments
 *     (context / request / success criteria and friends), with fixed-preamble
 *     segments for locked team standards
 *   - word list matrices ([["Tyrannosaurus", 3], ["Diplodocus", 1]]) drive the
 *     {~WordListEntry:Dinosaurs~} template expression by weighted random
 *   - any pict template expression works inside a prompt; generation runs the
 *     assembled markdown through the real pict template engine
 *   - generate as many concrete prompts as you like, browse them rendered,
 *     download them as a zip of markdown files
 *   - state is in-memory by default; implement PromptDataProvider to map the
 *     section onto your own back end
 *
 * The default export is the view class, registered like any pict view:
 *
 *   const libPromptEditor = require('pict-section-prompteditor');
 *   pict.addView('PromptEditor', Object.assign({}, libPromptEditor.default_configuration,
 *     { DefaultDestinationAddress: '#My-Container' }), libPromptEditor);
 *   pict.views['PromptEditor'].render();
 */

const libPromptEditorView = require('./views/PictView-PromptEditor.js');
const libProvider = require('./providers/PromptProvider-Base.js');
const libTypes = require('./types/PromptEditor-DefaultTypes.js');
const libCompiler = require('./compiler/PromptCompiler.js');
const libZip = require('./zip/PromptZip.js');
const libWordListTemplate = require('./templates/Pict-Template-WordListEntry.js');

module.exports = libPromptEditorView;
module.exports.default_configuration = libPromptEditorView.default_configuration;

// The data seam: the interface a host implements + the in-memory default.
module.exports.PromptDataProvider = libProvider.PromptDataProvider;
module.exports.InMemoryPromptProvider = libProvider.InMemoryPromptProvider;
module.exports.normalizeEntries = libProvider.normalizeEntries;

// Prompt types: the built-ins and the helpers the view uses to resolve them.
module.exports.DefaultPromptTypes = libTypes.DefaultPromptTypes;
module.exports.resolvePromptTypes = libTypes.resolvePromptTypes;
module.exports.getPromptType = libTypes.getPromptType;

// The compiler and zip utilities, for hosts generating outside the view.
module.exports.PromptCompiler = libCompiler;
module.exports.PromptZip = libZip;

// The template expression class (registered automatically by the view; exposed
// for hosts that want {~WordListEntry:~} active before any section mounts).
module.exports.PictTemplateWordListEntry = libWordListTemplate;
module.exports.weightedPick = libWordListTemplate.weightedPick;

},{"./compiler/PromptCompiler.js":293,"./providers/PromptProvider-Base.js":294,"./templates/Pict-Template-WordListEntry.js":295,"./types/PromptEditor-DefaultTypes.js":296,"./views/PictView-PromptEditor.js":297,"./zip/PromptZip.js":298}],293:[function(require,module,exports){
'use strict';

/**
 * PromptCompiler: a prompt record + its type --> markdown.
 *
 * Two stages, deliberately separate:
 *
 *   assembleSource() stitches the segments into one markdown document, fixed
 *   preambles included, template expressions left intact. This is the SOURCE
 *   of a prompt -- what you version, diff, and collaborate on.
 *
 *   generate() runs that source through the pict template engine with the
 *   word lists in the parse data, so {~WordListEntry:Name~} resolves by
 *   weighted random and every other pict expression works too (the prompt
 *   record itself is addressable: {~D:Prompt.Title~}). Each call is one
 *   concrete generation; call it as many times as you like.
 */

/**
 * Filesystem-friendly slug for zip entry names.
 * @param {string} pText
 * @returns {string}
 */
function slug(pText)
{
	return String(pText || '').toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
		.slice(0, 60) || 'prompt';
}

/**
 * Assemble a prompt's markdown source from its type's segments.
 *
 * Segment headings (## Context and friends) are on by default; a prompt that
 * carries IncludeSegmentHeadings: false compiles bare segment bodies instead,
 * so the author decides per prompt whether the structure shows in the output.
 * The document title heading stays governed by the IncludeTitleHeading option.
 *
 * @param {object} pPrompt - the prompt record
 * @param {object} pType - the resolved prompt type
 * @param {object} [pOptions] - { IncludeTitleHeading: true, SegmentHeadingLevel: 2 }
 * @returns {string} markdown with template expressions intact
 */
function assembleSource(pPrompt, pType, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpIncludeTitle = (typeof tmpOptions.IncludeTitleHeading === 'undefined') ? true : !!tmpOptions.IncludeTitleHeading;
	let tmpIncludeSegmentHeadings = !(pPrompt && pPrompt.IncludeSegmentHeadings === false);
	let tmpHeading = '#'.repeat(Math.max(1, Math.min(6, Number(tmpOptions.SegmentHeadingLevel) || 2)));
	let tmpSegments = (pType && Array.isArray(pType.Segments)) ? pType.Segments : [];
	let tmpBodies = (pPrompt && pPrompt.Segments) ? pPrompt.Segments : {};

	let tmpParts = [];
	if (tmpIncludeTitle && pPrompt && pPrompt.Title)
	{
		tmpParts.push('# ' + String(pPrompt.Title).trim());
	}

	for (let i = 0; i < tmpSegments.length; i++)
	{
		let tmpSegment = tmpSegments[i];
		let tmpBody = tmpSegment.Fixed ? String(tmpSegment.Body || '') : String(tmpBodies[tmpSegment.Key] || '');
		tmpBody = tmpBody.trim();
		if (!tmpBody)
		{
			if (tmpSegment.Optional || tmpSegment.Fixed) { continue; }
			tmpBody = '(nothing written for this segment yet)';
		}
		tmpParts.push(tmpIncludeSegmentHeadings
			? (tmpHeading + ' ' + String(tmpSegment.Name || tmpSegment.Key) + '\n\n' + tmpBody)
			: tmpBody);
	}

	return tmpParts.join('\n\n') + '\n';
}

/**
 * Build the { lowercased name -> Entries } map generate() feeds the
 * {~WordListEntry:~} expression.
 * @param {Array} pWordLists - word list records
 * @returns {object}
 */
function wordListMap(pWordLists)
{
	let tmpMap = {};
	(pWordLists || []).forEach((pList) =>
	{
		let tmpName = String(pList.Name || '').trim().toLowerCase();
		if (tmpName) { tmpMap[tmpName] = pList.Entries || []; }
	});
	return tmpMap;
}

/**
 * One concrete generation: parse the assembled source through the pict
 * template engine with the word lists riding in the data record.
 * @param {object} pPict - the pict instance (its template engine does the work)
 * @param {object} pPrompt - the prompt record
 * @param {object} pType - the resolved prompt type
 * @param {Array} pWordLists - word list records in play
 * @param {object} [pOptions] - assembleSource options + { RandomFunction }
 * @returns {string} resolved markdown
 */
function generate(pPict, pPrompt, pType, pWordLists, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpSource = assembleSource(pPrompt, pType, tmpOptions);
	let tmpData =
	{
		Prompt: pPrompt,
		__PromptEditorWordLists: wordListMap(pWordLists),
		__PromptEditorRandom: (typeof tmpOptions.RandomFunction === 'function') ? tmpOptions.RandomFunction : undefined
	};
	return pPict.parseTemplate(tmpSource, tmpData, null, []);
}

/**
 * The zip entry filename for one generated prompt.
 * @param {object} pGenerated - the generated record
 * @returns {string}
 */
function generatedFileName(pGenerated)
{
	let tmpSequence = String(Number(pGenerated.Sequence) || 0).padStart(3, '0');
	return slug(pGenerated.PromptTitle) + '-' + tmpSequence + '.md';
}

module.exports = { assembleSource, generate, wordListMap, slug, generatedFileName };

},{}],294:[function(require,module,exports){
'use strict';

/**
 * The data seam for pict-section-prompteditor.
 *
 * PromptDataProvider is the interface a host implements to map prompts, word
 * lists, and generated output onto its own back end (a REST API, meadow
 * entities, local storage, whatever). InMemoryPromptProvider is the default:
 * everything lives in a plain object store (usually a node of pict AppData),
 * so the section works with no server at all.
 *
 * Three record families:
 *
 *   WordList   { Key, Name, Entries: [[word, weight], ...], CreatedAt, UpdatedAt }
 *     A curated word matrix. Weights default to 1; an entry's chance of being
 *     drawn by {~WordListEntry:Name~} is weight / sum(weights).
 *
 *   Prompt     { Key, Title, TypeKey, Segments: { segmentKey: markdown },
 *                IncludeSegmentHeadings, Author, Meta, CreatedAt, UpdatedAt }
 *     A crafted prompt. Segments hold the markdown for each of the prompt
 *     type's segments, keyed by segment Key. IncludeSegmentHeadings (default
 *     true) decides whether the compiler writes the ## segment headings above
 *     each body in the assembled output. Meta is an opaque object the
 *     provider round-trips untouched -- the seam where a host hangs ratings,
 *     version pointers, or anything else.
 *
 *   Generated  { Key, PromptKey, PromptTitle, TypeKey, Markdown, Sequence,
 *                Author, GeneratedAt }
 *     One concrete generation of a prompt: the assembled markdown with every
 *     template expression (word lists included) resolved.
 *
 * All primitives return Promises so a remote provider drops in cleanly.
 */

/**
 * Normalize a word list's Entries into [[word, weight], ...] pairs. Accepts
 * pairs, bare strings, or {Word, Weight} objects; weights default to 1 and
 * coerce to a non-negative number.
 * @param {Array} pEntries
 * @returns {Array<Array>}
 */
function normalizeEntries(pEntries)
{
	if (!Array.isArray(pEntries)) { return []; }
	let tmpOut = [];
	for (let i = 0; i < pEntries.length; i++)
	{
		let tmpEntry = pEntries[i];
		let tmpWord = '';
		let tmpWeight = 1;
		if (Array.isArray(tmpEntry))
		{
			tmpWord = String(tmpEntry[0] == null ? '' : tmpEntry[0]);
			tmpWeight = (typeof tmpEntry[1] === 'undefined' || tmpEntry[1] === null || tmpEntry[1] === '') ? 1 : Number(tmpEntry[1]);
		}
		else if (tmpEntry && typeof tmpEntry === 'object')
		{
			tmpWord = String(tmpEntry.Word == null ? '' : tmpEntry.Word);
			tmpWeight = (typeof tmpEntry.Weight === 'undefined' || tmpEntry.Weight === null || tmpEntry.Weight === '') ? 1 : Number(tmpEntry.Weight);
		}
		else
		{
			tmpWord = String(tmpEntry == null ? '' : tmpEntry);
		}
		if (!isFinite(tmpWeight) || tmpWeight < 0) { tmpWeight = 1; }
		tmpOut.push([tmpWord, tmpWeight]);
	}
	return tmpOut;
}

class PromptDataProvider
{
	constructor(pOptions)
	{
		this.options = pOptions || {};
		this._now = (typeof this.options.Now === 'function') ? this.options.Now : Date.now;
		let tmpCounter = 0;
		this._key = (typeof this.options.KeyGenerator === 'function') ? this.options.KeyGenerator : (pPrefix) =>
		{
			tmpCounter++;
			return (pPrefix || 'pe') + '_' + this._now().toString(36) + '_' + tmpCounter.toString(36) + '_' + Math.floor(Math.random() * 1679616).toString(36);
		};
	}

	/* eslint-disable no-unused-vars */
	// ---- word lists ---------------------------------------------------------
	listWordLists() { return Promise.reject(new Error('listWordLists not implemented')); }
	createWordList(pDraft) { return Promise.reject(new Error('createWordList not implemented')); }
	updateWordList(pKey, pPatch) { return Promise.reject(new Error('updateWordList not implemented')); }
	deleteWordList(pKey) { return Promise.reject(new Error('deleteWordList not implemented')); }

	// ---- prompts ------------------------------------------------------------
	listPrompts() { return Promise.reject(new Error('listPrompts not implemented')); }
	createPrompt(pDraft) { return Promise.reject(new Error('createPrompt not implemented')); }
	updatePrompt(pKey, pPatch) { return Promise.reject(new Error('updatePrompt not implemented')); }
	deletePrompt(pKey) { return Promise.reject(new Error('deletePrompt not implemented')); }

	// ---- generated output ---------------------------------------------------
	listGenerated(pPromptKey) { return Promise.reject(new Error('listGenerated not implemented')); }
	createGenerated(pDraft) { return Promise.reject(new Error('createGenerated not implemented')); }
	deleteGenerated(pKey) { return Promise.reject(new Error('deleteGenerated not implemented')); }
	clearGenerated(pPromptKey) { return Promise.reject(new Error('clearGenerated not implemented')); }
	/* eslint-enable no-unused-vars */

	// ---- conveniences built on the primitives -------------------------------
	/**
	 * Load everything the section renders, in one call.
	 * @returns {Promise<{WordLists: Array, Prompts: Array, Generated: Array}>}
	 */
	loadAll()
	{
		return Promise.all([this.listWordLists(), this.listPrompts(), this.listGenerated()])
			.then((pResults) => ({ WordLists: pResults[0], Prompts: pResults[1], Generated: pResults[2] }));
	}

	/**
	 * Find a word list by Name (trimmed, case-insensitive). The lookup the
	 * {~WordListEntry:Name~} expression leans on.
	 * @param {string} pName
	 * @returns {Promise<object|null>}
	 */
	getWordListByName(pName)
	{
		let tmpWanted = String(pName || '').trim().toLowerCase();
		return this.listWordLists().then((pLists) =>
			pLists.find((pList) => String(pList.Name || '').trim().toLowerCase() === tmpWanted) || null);
	}
}

class InMemoryPromptProvider extends PromptDataProvider
{
	constructor(pOptions)
	{
		super(pOptions);
		// The store is usually a node of pict AppData (so state is observable
		// and survives view re-renders); a fresh object works fine too.
		let tmpStore = (this.options && this.options.Store) ? this.options.Store : {};
		if (!tmpStore.WordLists) { tmpStore.WordLists = {}; }
		if (!tmpStore.Prompts) { tmpStore.Prompts = {}; }
		if (!tmpStore.Generated) { tmpStore.Generated = {}; }
		this.store = tmpStore;
	}

	_clone(pValue) { return (pValue == null) ? pValue : JSON.parse(JSON.stringify(pValue)); }

	// ---- word lists ---------------------------------------------------------
	listWordLists()
	{
		let tmpLists = Object.values(this.store.WordLists).map((pList) => this._clone(pList));
		tmpLists.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
		return Promise.resolve(tmpLists);
	}

	createWordList(pDraft)
	{
		let tmpDraft = pDraft || {};
		let tmpName = String(tmpDraft.Name || '').trim();
		if (!tmpName) { return Promise.reject(new Error('A word list needs a Name.')); }
		let tmpNow = this._now();
		let tmpList =
		{
			Key: tmpDraft.Key || this._key('wl'),
			Name: tmpName,
			Entries: normalizeEntries(tmpDraft.Entries),
			CreatedAt: tmpNow,
			UpdatedAt: tmpNow
		};
		this.store.WordLists[tmpList.Key] = tmpList;
		return Promise.resolve(this._clone(tmpList));
	}

	updateWordList(pKey, pPatch)
	{
		let tmpList = this.store.WordLists[pKey];
		if (!tmpList) { return Promise.reject(new Error('No word list with Key ' + pKey)); }
		let tmpPatch = pPatch || {};
		if (typeof tmpPatch.Name !== 'undefined')
		{
			let tmpName = String(tmpPatch.Name || '').trim();
			if (!tmpName) { return Promise.reject(new Error('A word list needs a Name.')); }
			tmpList.Name = tmpName;
		}
		if (typeof tmpPatch.Entries !== 'undefined') { tmpList.Entries = normalizeEntries(tmpPatch.Entries); }
		tmpList.UpdatedAt = this._now();
		return Promise.resolve(this._clone(tmpList));
	}

	deleteWordList(pKey)
	{
		delete this.store.WordLists[pKey];
		return Promise.resolve();
	}

	// ---- prompts ------------------------------------------------------------
	listPrompts()
	{
		let tmpPrompts = Object.values(this.store.Prompts).map((pPrompt) => this._clone(pPrompt));
		tmpPrompts.sort((pA, pB) => (pB.UpdatedAt || 0) - (pA.UpdatedAt || 0));
		return Promise.resolve(tmpPrompts);
	}

	createPrompt(pDraft)
	{
		let tmpDraft = pDraft || {};
		if (!tmpDraft.TypeKey) { return Promise.reject(new Error('A prompt needs a TypeKey.')); }
		let tmpNow = this._now();
		let tmpPrompt =
		{
			Key: tmpDraft.Key || this._key('pr'),
			Title: String(tmpDraft.Title || 'Untitled prompt'),
			TypeKey: String(tmpDraft.TypeKey),
			Segments: (tmpDraft.Segments && typeof tmpDraft.Segments === 'object') ? this._clone(tmpDraft.Segments) : {},
			IncludeSegmentHeadings: (tmpDraft.IncludeSegmentHeadings === false) ? false : true,
			Author: tmpDraft.Author || null,
			Meta: (typeof tmpDraft.Meta === 'undefined') ? {} : this._clone(tmpDraft.Meta),
			CreatedAt: tmpNow,
			UpdatedAt: tmpNow
		};
		this.store.Prompts[tmpPrompt.Key] = tmpPrompt;
		return Promise.resolve(this._clone(tmpPrompt));
	}

	updatePrompt(pKey, pPatch)
	{
		let tmpPrompt = this.store.Prompts[pKey];
		if (!tmpPrompt) { return Promise.reject(new Error('No prompt with Key ' + pKey)); }
		let tmpPatch = pPatch || {};
		if (typeof tmpPatch.Title !== 'undefined') { tmpPrompt.Title = String(tmpPatch.Title); }
		if (typeof tmpPatch.TypeKey !== 'undefined') { tmpPrompt.TypeKey = String(tmpPatch.TypeKey); }
		if (typeof tmpPatch.Segments !== 'undefined') { tmpPrompt.Segments = this._clone(tmpPatch.Segments || {}); }
		if (typeof tmpPatch.IncludeSegmentHeadings !== 'undefined') { tmpPrompt.IncludeSegmentHeadings = (tmpPatch.IncludeSegmentHeadings === false) ? false : true; }
		if (typeof tmpPatch.Meta !== 'undefined') { tmpPrompt.Meta = this._clone(tmpPatch.Meta); }
		tmpPrompt.UpdatedAt = this._now();
		return Promise.resolve(this._clone(tmpPrompt));
	}

	deletePrompt(pKey)
	{
		delete this.store.Prompts[pKey];
		// Generated output belongs to its prompt; remove it alongside.
		for (let tmpGenKey of Object.keys(this.store.Generated))
		{
			if (this.store.Generated[tmpGenKey].PromptKey === pKey) { delete this.store.Generated[tmpGenKey]; }
		}
		return Promise.resolve();
	}

	// ---- generated output ---------------------------------------------------
	listGenerated(pPromptKey)
	{
		let tmpGenerated = Object.values(this.store.Generated)
			.filter((pGen) => !pPromptKey || pGen.PromptKey === pPromptKey)
			.map((pGen) => this._clone(pGen));
		// Ordered like a file listing: the prompt with the most recent
		// generation first, and within a prompt the files in sequence order
		// (001 at the top), matching the names they get in the zip.
		let tmpLatestByPrompt = {};
		tmpGenerated.forEach((pGen) =>
		{
			let tmpStamp = pGen.GeneratedAt || 0;
			if (!(pGen.PromptKey in tmpLatestByPrompt) || tmpStamp > tmpLatestByPrompt[pGen.PromptKey]) { tmpLatestByPrompt[pGen.PromptKey] = tmpStamp; }
		});
		tmpGenerated.sort((pA, pB) =>
			(tmpLatestByPrompt[pB.PromptKey] - tmpLatestByPrompt[pA.PromptKey])
			|| String(pA.PromptKey).localeCompare(String(pB.PromptKey))
			|| (pA.Sequence || 0) - (pB.Sequence || 0)
			|| (pA.GeneratedAt || 0) - (pB.GeneratedAt || 0));
		return Promise.resolve(tmpGenerated);
	}

	createGenerated(pDraft)
	{
		let tmpDraft = pDraft || {};
		if (!tmpDraft.PromptKey) { return Promise.reject(new Error('Generated output needs a PromptKey.')); }
		let tmpGenerated =
		{
			Key: tmpDraft.Key || this._key('gen'),
			PromptKey: tmpDraft.PromptKey,
			PromptTitle: String(tmpDraft.PromptTitle || ''),
			TypeKey: String(tmpDraft.TypeKey || ''),
			Markdown: String(tmpDraft.Markdown || ''),
			Sequence: Number(tmpDraft.Sequence) || 0,
			Author: tmpDraft.Author || null,
			GeneratedAt: this._now()
		};
		this.store.Generated[tmpGenerated.Key] = tmpGenerated;
		return Promise.resolve(this._clone(tmpGenerated));
	}

	deleteGenerated(pKey)
	{
		delete this.store.Generated[pKey];
		return Promise.resolve();
	}

	clearGenerated(pPromptKey)
	{
		for (let tmpKey of Object.keys(this.store.Generated))
		{
			if (!pPromptKey || this.store.Generated[tmpKey].PromptKey === pPromptKey) { delete this.store.Generated[tmpKey]; }
		}
		return Promise.resolve();
	}
}

module.exports = { PromptDataProvider, InMemoryPromptProvider, normalizeEntries };

},{}],295:[function(require,module,exports){
'use strict';

const libPictTemplate = require('pict-template');

/**
 * The {~WordListEntry:Name~} template expression (short form {~WLE:Name~}).
 *
 * Resolves to one entry drawn from the named word list by weighted random:
 * an entry's chance is weight / sum(weights). With Dinosaurs holding
 * [["Tyrannosaurus", 3], ["Diplodocus", 1]], the expression renders
 * Tyrannosaurus 75% of the time and Diplodocus 25%.
 *
 * Word lists are found two ways, in order:
 *
 *   1. The data record: a generation run passes the lists in the parse data as
 *      __PromptEditorWordLists ({ lowercased name -> Entries }) along with an
 *      optional __PromptEditorRandom function. This is what the prompt editor
 *      view does, and it keeps multiple editor instances exact: each
 *      generation resolves against precisely the lists it was given.
 *
 *   2. The pict-level registry: any prompt editor view (or a host) can push a
 *      resolver function onto pict.__PictSectionPromptEditorResolvers, so the
 *      expression also works in ordinary application templates once a section
 *      is mounted. Resolvers take the lowercased list name and return Entries
 *      or null.
 *
 * A second optional parameter is the default for a miss:
 * {~WordListEntry:Dinosaurs:a large lizard~} renders the default when the list
 * does not resolve (or has nothing drawable). The split is on the first colon,
 * so defaults may contain colons; an empty default ({~WLE:Name:~}) renders
 * nothing on a miss. With no default, a miss renders the expression back out
 * literally, so a typo is visible in the generated prompt instead of silently
 * vanishing. Each occurrence draws independently; two references to the same
 * list in one prompt can (and should be able to) land on different words.
 */

/**
 * Draw one word from [[word, weight], ...] by weighted random. Entries with a
 * non-positive weight never draw. Returns null for an empty or all-zero list.
 * @param {Array<Array>} pEntries
 * @param {function} [pRandom] - returns [0, 1); defaults to Math.random
 * @returns {string|null}
 */
function weightedPick(pEntries, pRandom)
{
	if (!Array.isArray(pEntries) || !pEntries.length) { return null; }
	let tmpRandom = (typeof pRandom === 'function') ? pRandom : Math.random;
	let tmpTotal = 0;
	for (let i = 0; i < pEntries.length; i++)
	{
		let tmpWeight = Number(pEntries[i][1]);
		if (isFinite(tmpWeight) && tmpWeight > 0) { tmpTotal += tmpWeight; }
	}
	if (tmpTotal <= 0) { return null; }
	let tmpRoll = tmpRandom() * tmpTotal;
	for (let i = 0; i < pEntries.length; i++)
	{
		let tmpWeight = Number(pEntries[i][1]);
		if (!isFinite(tmpWeight) || tmpWeight <= 0) { continue; }
		tmpRoll -= tmpWeight;
		if (tmpRoll < 0) { return String(pEntries[i][0]); }
	}
	// Floating point edge: the roll landed exactly on the total.
	for (let i = pEntries.length - 1; i >= 0; i--)
	{
		if (Number(pEntries[i][1]) > 0) { return String(pEntries[i][0]); }
	}
	return null;
}

class PictTemplateWordListEntry extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~WordListEntry:', '~}');
		this.addPattern('{~WLE:', '~}');
	}

	render(pTemplateHash, pRecord)
	{
		let tmpBody = String(pTemplateHash || '').trim();
		if (!tmpBody) { return ''; }

		// {~WordListEntry:ListName:Default~} -- everything after the FIRST colon
		// is the default rendered when the list does not resolve (or resolves
		// with nothing drawable). The default may contain colons, and may be
		// empty: {~WLE:Name:~} renders nothing on a miss. With no default at
		// all, a miss echoes the expression so a typo stays findable.
		let tmpListName = tmpBody;
		let tmpDefault = null;
		let tmpColon = tmpBody.indexOf(':');
		if (tmpColon > -1)
		{
			tmpListName = tmpBody.slice(0, tmpColon).trim();
			tmpDefault = tmpBody.slice(tmpColon + 1).trim();
		}
		if (!tmpListName) { return (tmpDefault === null) ? '' : tmpDefault; }
		let tmpWanted = tmpListName.toLowerCase();
		let tmpMiss = (tmpDefault === null) ? ('{~WordListEntry:' + tmpListName + '~}') : tmpDefault;

		let tmpEntries = null;
		let tmpRandom = null;

		// 1. Lists riding in the parse data (a generation run).
		if (pRecord && pRecord.__PromptEditorWordLists && pRecord.__PromptEditorWordLists[tmpWanted])
		{
			tmpEntries = pRecord.__PromptEditorWordLists[tmpWanted];
		}
		if (pRecord && typeof pRecord.__PromptEditorRandom === 'function')
		{
			tmpRandom = pRecord.__PromptEditorRandom;
		}

		// 2. The pict-level resolver registry (mounted sections, host overrides).
		if (!tmpEntries && this.pict && Array.isArray(this.pict.__PictSectionPromptEditorResolvers))
		{
			for (let i = 0; i < this.pict.__PictSectionPromptEditorResolvers.length; i++)
			{
				let tmpResolved = null;
				try { tmpResolved = this.pict.__PictSectionPromptEditorResolvers[i](tmpWanted); }
				catch (pError) { tmpResolved = null; }
				if (tmpResolved && tmpResolved.length) { tmpEntries = tmpResolved; break; }
			}
		}

		if (!tmpEntries || !tmpEntries.length)
		{
			return tmpMiss;
		}

		let tmpWord = weightedPick(tmpEntries, tmpRandom);
		return (tmpWord === null) ? tmpMiss : tmpWord;
	}
}

module.exports = PictTemplateWordListEntry;
module.exports.template_hash = 'WordListEntry';
module.exports.weightedPick = weightedPick;

},{"pict-template":363}],296:[function(require,module,exports){
'use strict';

/**
 * Built-in prompt types.
 *
 * A prompt type is a named arrangement of segments. Each segment:
 *
 *   {
 *     Key:      stable identifier; a prompt's Segments object is keyed by this
 *     Name:     the heading the compiler writes (## Name)
 *     Guidance: one line shown to the author about what belongs here
 *     Fixed:    true for locked text (a team preamble); Body below is used and
 *               the section renders it read-only instead of an editor
 *     Body:     the fixed text (only read when Fixed is true)
 *     Optional: empty optional segments are skipped at compile time; empty
 *               required segments compile with a placeholder note
 *   }
 *
 * These cover the common shapes of working with an AI pair. They are defaults,
 * not a registry: pass your own array as the PromptTypes option and it replaces
 * this set entirely. To extend instead of replace, spread DefaultPromptTypes
 * into your own array.
 */

const DefaultPromptTypes =
[
	{
		Key: 'feature-request',
		Name: 'Feature Request',
		Description: 'Ask for a new capability: what exists, what you want, and how you will know it worked.',
		Segments:
		[
			{ Key: 'context', Name: 'Context', Guidance: 'What exists today, where it lives, and anything the reader needs to know cold.' },
			{ Key: 'request', Name: 'Request', Guidance: 'The capability you want, stated plainly.' },
			{ Key: 'success-criteria', Name: 'Success Criteria', Guidance: 'Observable outcomes that prove it works.' }
		]
	},
	{
		Key: 'bug-report',
		Name: 'Bug Report',
		Description: 'Report something broken with enough signal to reproduce and fix it.',
		Segments:
		[
			{ Key: 'context', Name: 'Context', Guidance: 'The system, version, and environment where the problem shows.' },
			{ Key: 'observed', Name: 'Observed Behavior', Guidance: 'What actually happens, including exact errors.' },
			{ Key: 'expected', Name: 'Expected Behavior', Guidance: 'What should happen instead.' },
			{ Key: 'reproduction', Name: 'Reproduction', Guidance: 'Steps that make it happen, numbered.', Optional: true }
		]
	},
	{
		Key: 'research',
		Name: 'Research',
		Description: 'Send the AI to learn something and come back with a usable answer.',
		Segments:
		[
			{ Key: 'context', Name: 'Context', Guidance: 'Why you are asking and what you already know.' },
			{ Key: 'question', Name: 'Question', Guidance: 'The question, sharp enough to answer.' },
			{ Key: 'constraints', Name: 'Constraints', Guidance: 'Boundaries: scope, sources, time period, format.', Optional: true },
			{ Key: 'deliverable', Name: 'Deliverable', Guidance: 'The shape of the answer you want back.' }
		]
	},
	{
		Key: 'code-review',
		Name: 'Code Review',
		Description: 'Ask for a review with the focus stated up front.',
		Segments:
		[
			{ Key: 'context', Name: 'Context', Guidance: 'What the change does and why it exists.' },
			{ Key: 'focus', Name: 'Focus', Guidance: 'What kind of problems matter most here.' },
			{ Key: 'out-of-scope', Name: 'Out of Scope', Guidance: 'What not to spend attention on.', Optional: true }
		]
	},
	{
		Key: 'freeform',
		Name: 'Freeform',
		Description: 'One open segment, no structure imposed.',
		Segments:
		[
			{ Key: 'body', Name: 'Prompt', Guidance: 'Anything goes.' }
		]
	}
];

/**
 * Resolve the effective prompt type set from the view options: a provided
 * array wins outright; null/undefined means the defaults.
 * @param {Array|null} pConfigured
 * @returns {Array}
 */
function resolvePromptTypes(pConfigured)
{
	if (Array.isArray(pConfigured) && pConfigured.length) { return pConfigured; }
	return DefaultPromptTypes;
}

/**
 * Find a type by Key within a resolved set, with a freeform-style fallback so
 * a prompt whose type was removed by the host still renders and compiles.
 * @param {Array} pTypes
 * @param {string} pTypeKey
 * @returns {object}
 */
function getPromptType(pTypes, pTypeKey)
{
	let tmpFound = (pTypes || []).find((pType) => pType.Key === pTypeKey);
	if (tmpFound) { return tmpFound; }
	return (
	{
		Key: pTypeKey || 'unknown',
		Name: (pTypeKey ? pTypeKey : 'Unknown type'),
		Description: 'This prompt type is not in the configured set; editing the raw segments.',
		Segments: [{ Key: 'body', Name: 'Prompt', Guidance: 'Anything goes.' }]
	});
}

module.exports = { DefaultPromptTypes, resolvePromptTypes, getPromptType };

},{}],297:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libPictSectionContent = require('pict-section-content');
const libPictSectionModal = require('pict-section-modal');
const libPictSectionPicker = require('pict-section-picker');
const libMarkdownEditor = require('pict-section-markdowneditor');

const libProvider = require('../providers/PromptProvider-Base.js');
const libTypes = require('../types/PromptEditor-DefaultTypes.js');
const libCompiler = require('../compiler/PromptCompiler.js');
const libZip = require('../zip/PromptZip.js');
const libWordListTemplate = require('../templates/Pict-Template-WordListEntry.js');

/**
 * pict-section-prompteditor -- craft, curate, generate.
 *
 * One section, three surfaces:
 *
 *   Prompts     a list of crafted prompts and an editor: title, prompt type,
 *               one markdown segment per type segment (fixed preambles render
 *               locked), template expression insertion, per-segment preview,
 *               a full pict-section-markdowneditor in a modal for rich edits,
 *               and a generate bar.
 *
 *   Word lists  the matrices behind {~WordListEntry:Name~}: words with
 *               weights (default 1), live percentage per entry.
 *
 *   Generated   every generation, rendered and browsable, downloadable as a
 *               zip of markdown files.
 *
 * State lives behind a PromptDataProvider; the default is in-memory in
 * AppData, keyed per instance, so the section works with no server and
 * multiple sections coexist on one page.
 */

const _DefaultConfiguration =
{
	ViewIdentifier: 'PromptEditor',

	DefaultRenderable: 'PromptEditor-Section',
	DefaultDestinationAddress: '#PromptEditor-Container',

	AutoRender: false,

	// ---- options a host overrides -------------------------------------------
	// The data seam; null means the in-memory default (AppData-backed).
	DataProvider: null,
	// The prompt type set; null means DefaultPromptTypes. Pass your own array
	// to replace the built-ins outright.
	PromptTypes: null,
	// Stamped onto prompts and generated output the user creates.
	CurrentUser: { Key: '', Name: 'Anonymous' },
	// Render-only: no creation, editing, generation, or deletion.
	ReadOnly: false,
	// The random source for weighted draws; null means Math.random.
	RandomFunction: null,
	// CodeMirror 6 modules for the rich editor modal; null falls back to
	// window.CodeMirrorModules; absent entirely hides the rich edit button.
	CodeMirrorModules: null,

	// Compile shape.
	IncludeTitleHeading: true,
	SegmentHeadingLevel: 2,

	// Generation + download.
	GenerateDefaultCount: 5,
	GenerateMaxCount: 100,
	ZipFileName: 'prompts.zip',

	Title: 'Prompt Editor',

	// Event hooks (all optional): a host wires these to autosave, audit,
	// ratings, collaboration -- whatever sits on top.
	onPromptSaved: null,
	onPromptDeleted: null,
	onWordListSaved: null,
	onWordListDeleted: null,
	onGenerated: null,
	onChange: null,

	CSSPriority: 500,
	CSS: /*css*/`
		.pspe { font-size: 14px; color: var(--theme-color-text-primary, #1f2430); }
		.pspe-header { display: flex; align-items: center; gap: 14px; margin-bottom: 12px; flex-wrap: wrap; }
		/* Structural titles take the theme's optional display face + treatment.
		   The fallbacks (inherit / none / normal / 650) keep the look unchanged
		   for hosts whose theme does not define a display family. A host whose
		   brand carries one (e.g. a drafting/engraving face) gets it here with
		   no app-side override. */
		.pspe-title { font-size: 16px; margin-right: auto;
			font-family: var(--theme-typography-family-display, inherit);
			text-transform: var(--theme-typography-display-transform, none);
			letter-spacing: var(--theme-typography-display-tracking, normal);
			font-weight: var(--theme-typography-display-weight, 650); }
		.pspe-tabs { display: flex; gap: 4px; }
		.pspe-tab {
			font: inherit; font-size: 13px; padding: 6px 12px; cursor: pointer;
			border: 1px solid var(--theme-color-border-default, #d6dde3);
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-secondary, #5b6470); border-radius: 8px;
			font-family: var(--theme-typography-family-display, inherit);
			text-transform: var(--theme-typography-display-transform, none);
			letter-spacing: var(--theme-typography-display-tracking, normal);
		}
		.pspe-tab-on { background: var(--theme-color-brand-primary, #2880a6); border-color: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); }
		.pspe-tab-count { opacity: 0.75; font-size: 11px; margin-left: 4px; }

		.pspe-btn {
			font: inherit; font-size: 13px; padding: 6px 12px; cursor: pointer; border-radius: 8px;
			border: 1px solid var(--theme-color-border-default, #d6dde3);
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #1f2430);
		}
		.pspe-btn:hover { background: var(--theme-color-background-hover, #eef2f6); }
		.pspe-btn-primary { background: var(--theme-color-brand-primary, #2880a6); border-color: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); }
		.pspe-btn-primary:hover { filter: brightness(0.95); background: var(--theme-color-brand-primary, #2880a6); }
		.pspe-btn-danger { color: var(--theme-color-status-error, #c0392b); }
		.pspe-btn-sm { font-size: 12px; padding: 3px 9px; }

		.pspe-split { display: flex; gap: 10px; align-items: flex-start; }
		/* Width is owned by the pict-section-modal panel handle (resizable,
		   collapsible, persisted); flex-basis auto lets the inline width rule. */
		.pspe-rail { flex: 0 0 auto; min-width: 0; display: flex; flex-direction: column; gap: 8px; box-sizing: border-box; }
		/* The panel's edge (resize strip + collapse tab) is a zero-width flex
		   sibling whose children span its height; align-items: flex-start above
		   would collapse it to zero height and leave nothing to grab. */
		.pspe-split > .pict-panel-edge { align-self: stretch; }
		.pspe-main { flex: 1; min-width: 0; }
		.pspe-rail-list { display: flex; flex-direction: column; gap: 4px; }
		.pspe-rail-item {
			text-align: left; font: inherit; font-size: 13px; cursor: pointer; padding: 8px 10px;
			border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 8px;
			background: var(--theme-color-background-panel, #fff); color: inherit;
		}
		.pspe-rail-item:hover { border-color: var(--theme-color-border-default, #d6dde3); }
		.pspe-rail-item-on { border-color: var(--theme-color-brand-primary, #2880a6); box-shadow: 0 0 0 1px var(--theme-color-brand-primary, #2880a6) inset; }
		.pspe-rail-item-name { font-weight: 600; display: block; }
		.pspe-rail-item-sub { font-size: 11.5px; color: var(--theme-color-text-muted, #97a1ab); display: block; margin-top: 1px; }
		.pspe-empty { color: var(--theme-color-text-muted, #97a1ab); font-size: 13px; padding: 14px 4px; }

		.pspe-input, .pspe-select {
			font: inherit; font-size: 13px; padding: 7px 9px; box-sizing: border-box;
			border: 1px solid var(--theme-color-border-default, #d6dde3); border-radius: 7px;
			background: var(--theme-color-background-panel, #fff); color: inherit;
		}
		.pspe-input:focus, .pspe-select:focus, .pspe-textarea:focus { outline: none; border-color: var(--theme-color-brand-primary, #2880a6); }
		.pspe-editor-head { display: flex; gap: 8px; align-items: center; margin-bottom: 12px; flex-wrap: wrap; }
		.pspe-editor-title { flex: 1; min-width: 200px; font-weight: 650; font-size: 15px; }
		.pspe-type-desc { font-size: 12px; color: var(--theme-color-text-muted, #97a1ab); margin: -6px 0 12px; }
		.pspe-editor-opts { margin: -4px 0 12px; }
		.pspe-editor-opt { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; color: var(--theme-color-text-muted, #97a1ab); cursor: pointer; user-select: none; }

		.pspe-segment {
			border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 10px;
			background: var(--theme-color-background-panel, #fff); padding: 12px 14px; margin-bottom: 10px;
		}
		.pspe-segment-head { display: flex; align-items: baseline; gap: 8px; margin-bottom: 6px; flex-wrap: wrap; }
		.pspe-segment-name { font-size: 13.5px;
			font-family: var(--theme-typography-family-display, inherit);
			text-transform: var(--theme-typography-display-transform, none);
			letter-spacing: var(--theme-typography-display-tracking, normal);
			font-weight: var(--theme-typography-display-weight, 650); }
		.pspe-segment-guidance { font-size: 12px; color: var(--theme-color-text-muted, #97a1ab); margin-right: auto; }
		.pspe-pill {
			font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.04em; padding: 1px 8px; border-radius: 999px;
			background: var(--theme-color-background-tertiary, #eef2f6); color: var(--theme-color-text-secondary, #5b6470);
		}
		.pspe-textarea {
			width: 100%; box-sizing: border-box; min-height: 84px; resize: vertical; font-size: 13px;
			font-family: var(--theme-typography-family-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
			padding: 8px 10px; border: 1px solid var(--theme-color-border-default, #d6dde3); border-radius: 7px;
			background: var(--theme-color-background-panel, #fff); color: inherit; line-height: 1.5;
		}
		.pspe-segment-tools { display: flex; gap: 8px; align-items: center; margin-top: 6px; flex-wrap: wrap; }
		.pspe-insert-picker { min-width: 190px; font-size: 12px; }
		.pspe-segment-preview { border: 1px dashed var(--theme-color-border-light, #e7ecf0); border-radius: 7px; padding: 4px 12px; margin-top: 8px; }
		.pspe-fixed-body { border-left: 3px solid var(--theme-color-border-default, #d6dde3); padding: 2px 12px; color: var(--theme-color-text-secondary, #5b6470); }
		.pspe-md p:first-child { margin-top: 6px; } .pspe-md p:last-child { margin-bottom: 6px; }
		.pspe-md pre { background: var(--theme-color-background-secondary, #f7f9fb); padding: 8px 10px; border-radius: 6px; overflow-x: auto; }
		/* Markdown images size to the column instead of spilling out of it (a
		   full-resolution screenshot otherwise renders at natural size and only
		   its top-left corner shows). enableFullscreenViewers tags each image
		   data-fullscreen-source for click-to-zoom; flag that affordance. */
		.pspe-md img { max-width: 100%; height: auto; }
		.pspe-md img[data-fullscreen-source] { cursor: zoom-in; }

		.pspe-generate {
			display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-top: 14px; padding: 11px 14px;
			border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 10px;
			background: var(--theme-color-background-secondary, #f7f9fb);
		}
		.pspe-generate-count { width: 70px; }
		.pspe-generate-note { font-size: 12px; color: var(--theme-color-text-muted, #97a1ab); margin-left: auto; }
		.pspe-preview-panel { margin-top: 12px; }
		.pspe-preview-head { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; flex-wrap: wrap; }
		.pspe-preview-title { font-size: 13.5px;
			font-family: var(--theme-typography-family-display, inherit);
			text-transform: var(--theme-typography-display-transform, none);
			letter-spacing: var(--theme-typography-display-tracking, normal);
			font-weight: var(--theme-typography-display-weight, 650); }
		.pspe-preview-note { font-size: 12px; color: var(--theme-color-text-muted, #97a1ab); margin-right: auto; }
		.pspe-btn-on, .pspe-btn-on:hover { background: var(--theme-color-brand-primary, #2880a6); border-color: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); }
		.pspe-preview-raw {
			margin: 0; padding: 12px 16px; white-space: pre-wrap; word-break: break-word; font-size: 12.5px; line-height: 1.55;
			font-family: var(--theme-typography-family-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
		}

		.pspe-entry-table { width: 100%; border-collapse: collapse; }
		.pspe-entry-table th { text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #97a1ab); padding: 4px 6px; }
		.pspe-entry-table td { padding: 3px 6px; }
		.pspe-entry-word { width: 100%; }
		.pspe-entry-weight { width: 70px; }
		.pspe-entry-pct { font-size: 12px; color: var(--theme-color-text-secondary, #5b6470); white-space: nowrap; font-variant-numeric: tabular-nums; }

		.pspe-gen-toolbar { display: flex; gap: 8px; align-items: center; margin-bottom: 10px; flex-wrap: wrap; }
		.pspe-gen-note { font-size: 12.5px; color: var(--theme-color-text-secondary, #5b6470); margin-right: auto; }
		.pspe-viewer {
			border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 10px;
			background: var(--theme-color-background-panel, #fff); padding: 6px 16px;
		}
		.pspe-viewer-tools { display: flex; gap: 8px; justify-content: flex-end; padding: 8px 0 2px; }

		.pspe-rich-host { min-height: 320px; }

		/* Read mode: a header strip (type + browse actions) above the assembled
		   prompt rendered as one markdown document. */
		.pspe-reader-head { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; flex-wrap: wrap; }
		.pspe-reader-type { font-size: 12.5px; color: var(--theme-color-text-muted, #97a1ab); margin-right: auto;
			font-family: var(--theme-typography-family-display, inherit);
			text-transform: var(--theme-typography-display-transform, none);
			letter-spacing: var(--theme-typography-display-tracking, normal); }
		.pspe-reader-body { padding: 4px 18px; }
		.pspe-reader-body h1:first-child, .pspe-reader-body h2:first-child { margin-top: 8px; }
	`,

	Templates:
	[
		{
			Hash: 'PromptEditor-Section',
			Template: /*html*/`
<div class="pspe">
	<div class="pspe-header">
		<div class="pspe-title">{~D:AppData.PromptEditorActive.Title~}</div>
		{~TS:PromptEditor-Tab:AppData.PromptEditorActive.Tabs~}
	</div>
	{~TS:PromptEditor-PromptsPane:AppData.PromptEditorActive.PromptsPaneSlot~}
	{~TS:PromptEditor-WordListsPane:AppData.PromptEditorActive.WordListsPaneSlot~}
	{~TS:PromptEditor-GeneratedPane:AppData.PromptEditorActive.GeneratedPaneSlot~}
</div>`
		},
		{ Hash: 'PromptEditor-Tab', Template: /*html*/`<button class="pspe-tab {~D:Record.OnClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].selectTab('{~D:Record.Key~}')">{~D:Record.Label~}<span class="pspe-tab-count">{~D:Record.Count~}</span></button>` },

		// ---- prompts pane ----------------------------------------------------
		{
			Hash: 'PromptEditor-PromptsPane',
			Template: /*html*/`
<div class="pspe-split">
	<div class="pspe-rail" id="pspe-rail-{~D:Record.ViewHash~}-prompts">
		{~TS:PromptEditor-NewPromptButton:Record.NewSlot~}
		<div class="pspe-rail-list">
			{~TS:PromptEditor-PromptListItem:Record.Prompts~}
		</div>
		{~TS:PromptEditor-EmptyNote:Record.EmptySlot~}
	</div>
	<div class="pspe-main">
		{~TS:PromptEditor-PromptReader:Record.ReaderSlot~}
		{~TS:PromptEditor-PromptEditorPanel:Record.EditorSlot~}
		{~TS:PromptEditor-EmptyNote:Record.NoSelectionSlot~}
	</div>
</div>`
		},
		{ Hash: 'PromptEditor-NewPromptButton', Template: /*html*/`<button class="pspe-btn pspe-btn-primary" onclick="_Pict.views['{~D:Record.ViewHash~}'].newPrompt()">+ New prompt</button>` },
		{ Hash: 'PromptEditor-EmptyNote', Template: /*html*/`<div class="pspe-empty">{~D:Record.Text~}</div>` },
		{
			Hash: 'PromptEditor-PromptListItem',
			Template: /*html*/`
<button class="pspe-rail-item {~D:Record.OnClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].selectPrompt('{~D:Record.Key~}')">
	<span class="pspe-rail-item-name" id="pspe-prname-{~D:Record.ViewHash~}-{~D:Record.Key~}">{~D:Record.Title~}</span>
	<span class="pspe-rail-item-sub">{~D:Record.TypeName~}</span>
</button>`
		},
		{
			Hash: 'PromptEditor-PromptReader',
			Template: /*html*/`
<div class="pspe-reader">
	<div class="pspe-reader-head">
		<span class="pspe-reader-type">{~D:Record.TypeName~}</span>
		{~TS:PromptEditor-ReaderActions:Record.ActionsSlot~}
	</div>
	<div class="pspe-viewer pspe-md pspe-reader-body" id="pspe-reader-body-{~D:Record.ViewHash~}">{~D:Record.MarkdownHtml~}</div>
</div>`
		},
		{
			Hash: 'PromptEditor-ReaderActions',
			Template: /*html*/`<button class="pspe-btn pspe-btn-sm" title="Copy the assembled prompt as markdown" onclick="_Pict.views['{~D:Record.ViewHash~}'].copyActivePromptMarkdown()">Copy markdown</button><button class="pspe-btn pspe-btn-sm" title="Duplicate this prompt" onclick="_Pict.views['{~D:Record.ViewHash~}'].duplicatePrompt()">Duplicate</button><button class="pspe-btn pspe-btn-sm pspe-btn-primary" onclick="_Pict.views['{~D:Record.ViewHash~}'].editActivePrompt()">Edit</button>`
		},
		{
			Hash: 'PromptEditor-PromptEditorPanel',
			Template: /*html*/`
<div class="pspe-editor-head">
	<input class="pspe-input pspe-editor-title" value="{~D:Record.Title~}" placeholder="Prompt title"
		oninput="_Pict.views['{~D:Record.ViewHash~}'].cachePromptTitle(this.value)"
		onchange="_Pict.views['{~D:Record.ViewHash~}'].savePromptTitle()">
	<select class="pspe-select" onchange="_Pict.views['{~D:Record.ViewHash~}'].setPromptType(this.value)">
		{~TS:PromptEditor-TypeOption:Record.TypeOptions~}
	</select>
	{~TS:PromptEditor-ReadToggle:Record.ReadToggleSlot~}
	{~TS:PromptEditor-PromptActions:Record.ActionsSlot~}
</div>
<div class="pspe-type-desc">{~D:Record.TypeDescription~}</div>
{~TS:PromptEditor-EditorOptions:Record.OptionsSlot~}
{~TS:PromptEditor-Segment:Record.Segments~}
{~TS:PromptEditor-GenerateBar:Record.GenerateSlot~}
{~TS:PromptEditor-PreviewPanel:Record.PreviewPanelSlot~}`
		},
		{
			Hash: 'PromptEditor-PreviewPanel',
			Template: /*html*/`
<div class="pspe-preview-panel">
	<div class="pspe-preview-head">
		<span class="pspe-preview-title">Preview roll</span>
		<span class="pspe-preview-note">one unsaved generation</span>
		<button class="pspe-btn pspe-btn-sm{~D:Record.FormattedOnClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].setPreviewMode('rendered')">Formatted</button>
		<button class="pspe-btn pspe-btn-sm{~D:Record.RawOnClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].setPreviewMode('raw')">Markdown</button>
		<button class="pspe-btn pspe-btn-sm" onclick="_Pict.views['{~D:Record.ViewHash~}'].copyPreview()">Copy</button>
		<button class="pspe-btn pspe-btn-sm" onclick="_Pict.views['{~D:Record.ViewHash~}'].previewOnce()">Reroll</button>
		<button class="pspe-btn pspe-btn-sm" onclick="_Pict.views['{~D:Record.ViewHash~}'].closePreview()">Close</button>
	</div>
	{~TS:PromptEditor-PreviewRendered:Record.RenderedSlot~}
	{~TS:PromptEditor-PreviewRaw:Record.RawSlot~}
</div>`
		},
		{ Hash: 'PromptEditor-PreviewRendered', Template: /*html*/`<div class="pspe-viewer pspe-md">{~D:Record.MarkdownHtml~}</div>` },
		{ Hash: 'PromptEditor-PreviewRaw', Template: /*html*/`<pre class="pspe-viewer pspe-preview-raw">{~D:Record.MarkdownEscaped~}</pre>` },
		{ Hash: 'PromptEditor-TypeOption', Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>` },
		{
			Hash: 'PromptEditor-ReadToggle',
			Template: /*html*/`<button class="pspe-btn pspe-btn-sm" title="Back to reading view" onclick="_Pict.views['{~D:Record.ViewHash~}'].readActivePrompt()">Done</button>`
		},
		{
			Hash: 'PromptEditor-PromptActions',
			Template: /*html*/`<button class="pspe-btn pspe-btn-sm" title="Duplicate this prompt" onclick="_Pict.views['{~D:Record.ViewHash~}'].duplicatePrompt()">Duplicate</button><button class="pspe-btn pspe-btn-sm pspe-btn-danger" onclick="_Pict.views['{~D:Record.ViewHash~}'].deletePrompt()">Delete</button>`
		},
		{
			Hash: 'PromptEditor-EditorOptions',
			Template: /*html*/`
<div class="pspe-editor-opts">
	<label class="pspe-editor-opt" title="When off, the assembled prompt is just the segment bodies, no ## headings above them.">
		<input type="checkbox" {~D:Record.SegmentHeadingsChecked~}
			onchange="_Pict.views['{~D:Record.ViewHash~}'].setSegmentHeadings(this.checked)">
		Segment headings in the output
	</label>
</div>`
		},
		{
			Hash: 'PromptEditor-Segment',
			Template: /*html*/`
<div class="pspe-segment">
	<div class="pspe-segment-head">
		<span class="pspe-segment-name">{~D:Record.Name~}</span>
		<span class="pspe-segment-guidance">{~D:Record.Guidance~}</span>
		{~TS:PromptEditor-SegmentPill:Record.PillSlot~}
	</div>
	{~TS:PromptEditor-SegmentFixed:Record.FixedSlot~}
	{~TS:PromptEditor-SegmentEdit:Record.EditSlot~}
	{~TS:PromptEditor-SegmentPreview:Record.PreviewSlot~}
</div>`
		},
		{ Hash: 'PromptEditor-SegmentPill', Template: /*html*/`<span class="pspe-pill">{~D:Record.Label~}</span>` },
		{ Hash: 'PromptEditor-SegmentFixed', Template: /*html*/`<div class="pspe-fixed-body pspe-md">{~D:Record.BodyHtml~}</div>` },
		{
			Hash: 'PromptEditor-SegmentEdit',
			Template: /*html*/`
<textarea class="pspe-textarea" id="{~D:Record.TextareaId~}" placeholder="{~D:Record.Placeholder~}"
	oninput="_Pict.views['{~D:Record.ViewHash~}'].cacheSegment('{~D:Record.SegmentKey~}', this.value)"
	onchange="_Pict.views['{~D:Record.ViewHash~}'].saveSegment('{~D:Record.SegmentKey~}')">{~D:Record.Body~}</textarea>
<div class="pspe-segment-tools">
	<div class="pspe-insert-picker" id="pspe-ins-{~D:Record.ViewHash~}-{~D:Record.SegmentKey~}"></div>
	<button class="pspe-btn pspe-btn-sm" onclick="_Pict.views['{~D:Record.ViewHash~}'].toggleSegmentPreview('{~D:Record.SegmentKey~}')">{~D:Record.PreviewLabel~}</button>
	{~TS:PromptEditor-SegmentRichButton:Record.RichSlot~}
</div>`
		},
		{ Hash: 'PromptEditor-SegmentRichButton', Template: /*html*/`<button class="pspe-btn pspe-btn-sm" onclick="_Pict.views['{~D:Record.ViewHash~}'].openRichEditor('{~D:Record.SegmentKey~}')">Open in editor</button>` },
		{ Hash: 'PromptEditor-SegmentPreview', Template: /*html*/`<div class="pspe-segment-preview pspe-md">{~D:Record.BodyHtml~}</div>` },
		{
			Hash: 'PromptEditor-GenerateBar',
			Template: /*html*/`
<div class="pspe-generate">
	<input type="number" min="1" max="{~D:Record.MaxCount~}" class="pspe-input pspe-generate-count" value="{~D:Record.Count~}"
		onchange="_Pict.views['{~D:Record.ViewHash~}'].setGenerateCount(this.value)">
	<button class="pspe-btn pspe-btn-primary" onclick="_Pict.views['{~D:Record.ViewHash~}'].generatePrompts()">Generate</button>
	<button class="pspe-btn" onclick="_Pict.views['{~D:Record.ViewHash~}'].previewOnce()">Preview one</button>
	<span class="pspe-generate-note">{~D:Record.Note~}</span>
</div>`
		},

		// ---- word lists pane -------------------------------------------------
		{
			Hash: 'PromptEditor-WordListsPane',
			Template: /*html*/`
<div class="pspe-split">
	<div class="pspe-rail" id="pspe-rail-{~D:Record.ViewHash~}-wordlists">
		{~TS:PromptEditor-NewWordListButton:Record.NewSlot~}
		<div class="pspe-rail-list">
			{~TS:PromptEditor-WordListItem:Record.WordLists~}
		</div>
		{~TS:PromptEditor-EmptyNote:Record.EmptySlot~}
	</div>
	<div class="pspe-main">
		{~TS:PromptEditor-WordListDetail:Record.DetailSlot~}
		{~TS:PromptEditor-EmptyNote:Record.NoSelectionSlot~}
	</div>
</div>`
		},
		{ Hash: 'PromptEditor-NewWordListButton', Template: /*html*/`<button class="pspe-btn pspe-btn-primary" onclick="_Pict.views['{~D:Record.ViewHash~}'].newWordList()">+ New word list</button>` },
		{
			Hash: 'PromptEditor-WordListItem',
			Template: /*html*/`
<button class="pspe-rail-item {~D:Record.OnClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].selectWordList('{~D:Record.Key~}')">
	<span class="pspe-rail-item-name" id="pspe-wlname-{~D:Record.ViewHash~}-{~D:Record.Key~}">{~D:Record.Name~}</span>
	<span class="pspe-rail-item-sub" id="pspe-wlsub-{~D:Record.ViewHash~}-{~D:Record.Key~}">{~D:Record.Summary~}</span>
</button>`
		},
		{
			Hash: 'PromptEditor-WordListDetail',
			Template: /*html*/`
<div class="pspe-editor-head">
	<input class="pspe-input pspe-editor-title" value="{~D:Record.Name~}" placeholder="Word list name"
		oninput="_Pict.views['{~D:Record.ViewHash~}'].cacheWordListName(this.value)"
		onchange="_Pict.views['{~D:Record.ViewHash~}'].saveWordListName()">
	<button class="pspe-btn pspe-btn-sm pspe-btn-danger" onclick="_Pict.views['{~D:Record.ViewHash~}'].deleteWordList()">Delete</button>
</div>
<div class="pspe-type-desc">Reference it in any segment as <code>{~D:Record.ExpressionExample~}</code>. Weights set each word's share of the draws.</div>
<table class="pspe-entry-table">
	<thead><tr><th>Word</th><th>Weight</th><th>Share</th><th></th></tr></thead>
	<tbody>{~TS:PromptEditor-WordListEntryRow:Record.Entries~}</tbody>
</table>
<div class="pspe-segment-tools">
	<button class="pspe-btn pspe-btn-sm" onclick="_Pict.views['{~D:Record.ViewHash~}'].addWordListEntry()">+ Add word</button>
</div>`
		},
		{
			Hash: 'PromptEditor-WordListEntryRow',
			Template: /*html*/`
<tr>
	<td><input class="pspe-input pspe-entry-word" value="{~D:Record.Word~}" placeholder="word or phrase"
		oninput="_Pict.views['{~D:Record.ViewHash~}'].cacheEntryWord({~D:Record.Index~}, this.value)"
		onchange="_Pict.views['{~D:Record.ViewHash~}'].saveEntries()"></td>
	<td><input type="number" min="0" step="1" class="pspe-input pspe-entry-weight" value="{~D:Record.Weight~}"
		oninput="_Pict.views['{~D:Record.ViewHash~}'].cacheEntryWeight({~D:Record.Index~}, this.value)"
		onchange="_Pict.views['{~D:Record.ViewHash~}'].saveEntries()"></td>
	<td class="pspe-entry-pct" id="pspe-pct-{~D:Record.ViewHash~}-{~D:Record.Index~}">{~D:Record.Percent~}</td>
	<td><button class="pspe-btn pspe-btn-sm pspe-btn-danger" title="Remove" onclick="_Pict.views['{~D:Record.ViewHash~}'].removeWordListEntry({~D:Record.Index~})">×</button></td>
</tr>`
		},

		// ---- generated pane ----------------------------------------------------
		{
			Hash: 'PromptEditor-GeneratedPane',
			Template: /*html*/`
<div class="pspe-gen-toolbar">
	<span class="pspe-gen-note">{~D:Record.Note~}</span>
	{~TS:PromptEditor-GeneratedTools:Record.ToolsSlot~}
</div>
<div class="pspe-split">
	<div class="pspe-rail" id="pspe-rail-{~D:Record.ViewHash~}-generated">
		<div class="pspe-rail-list">
			{~TS:PromptEditor-GeneratedRow:Record.Generated~}
		</div>
		{~TS:PromptEditor-EmptyNote:Record.EmptySlot~}
	</div>
	<div class="pspe-main">
		{~TS:PromptEditor-GeneratedViewer:Record.ViewerSlot~}
		{~TS:PromptEditor-EmptyNote:Record.NoSelectionSlot~}
	</div>
</div>`
		},
		{
			Hash: 'PromptEditor-GeneratedTools',
			Template: /*html*/`<button class="pspe-btn pspe-btn-primary" onclick="_Pict.views['{~D:Record.ViewHash~}'].downloadZip()">Download zip</button><button class="pspe-btn pspe-btn-danger" onclick="_Pict.views['{~D:Record.ViewHash~}'].clearGenerated()">Clear all</button>`
		},
		{
			Hash: 'PromptEditor-GeneratedRow',
			Template: /*html*/`
<button class="pspe-rail-item {~D:Record.OnClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].selectGenerated('{~D:Record.Key~}')">
	<span class="pspe-rail-item-name">{~D:Record.FileName~}</span>
	<span class="pspe-rail-item-sub">{~D:Record.Sub~}</span>
</button>`
		},
		{
			Hash: 'PromptEditor-GeneratedViewer',
			Template: /*html*/`
<div class="pspe-viewer-tools">
	<button class="pspe-btn pspe-btn-sm" onclick="_Pict.views['{~D:Record.ViewHash~}'].copyGenerated()">Copy markdown</button>
	<button class="pspe-btn pspe-btn-sm pspe-btn-danger" onclick="_Pict.views['{~D:Record.ViewHash~}'].deleteGenerated()">Delete</button>
</div>
<div class="pspe-viewer pspe-md">{~D:Record.MarkdownHtml~}</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PromptEditor-Section',
			TemplateHash: 'PromptEditor-Section',
			ContentDestinationAddress: '#PromptEditor-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewPromptEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		// Function options do not survive the JSON clone of defaults; restore.
		['DataProvider', 'PromptTypes', 'RandomFunction', 'CodeMirrorModules',
			'onPromptSaved', 'onPromptDeleted', 'onWordListSaved', 'onWordListDeleted', 'onGenerated', 'onChange']
			.forEach((pKey) => { if (pOptions && typeof pOptions[pKey] !== 'undefined') { tmpOptions[pKey] = pOptions[pKey]; } });
		super(pFable, tmpOptions, pServiceHash);

		this._provider = null;
		this._types = libTypes.resolvePromptTypes(this.options.PromptTypes);
		this._loaded = { WordLists: [], Prompts: [], Generated: [] };
		this._ui =
		{
			Tab: 'prompts',
			ActivePromptKey: null,
			ActiveWordListKey: null,
			ActiveGeneratedKey: null,
			GenerateCount: this.options.GenerateDefaultCount,
			PreviewSegments: {},
			Preview: null,
			PreviewMode: 'rendered',
			// Browsing a prompt shows it read-only (the assembled markdown, no
			// segment boxes); 'edit' swaps in the segment editor. Selecting a
			// prompt lands on 'read'; creating/duplicating/previewing enters 'edit'.
			PromptMode: 'read'
		};
		this._state = {};
		this._richEditorViewHash = null;
		this._entriesSaveTimer = null;
		this._railPanelHandle = null;
	}

	// ---- lifecycle -----------------------------------------------------------
	onBeforeInitialize()
	{
		this._initProvider();
		this._ensureSupportViews();
		this._registerTemplateExpression();
		return super.onBeforeInitialize();
	}

	onAfterInitializeAsync(fCallback)
	{
		this.load().then(() => fCallback()).catch(() => { this._shape(); this.render(); fCallback(); });
	}

	onBeforeRender(pRenderable)
	{
		this.pict.AppData.PromptEditorActive = this._state;
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._mountInsertPickers();
		this._mountRailPanel();
		this._enhanceReaderMedia();
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// After the read view paints the assembled markdown, hand its body to the
	// content view so images (and fenced code) gain click-to-zoom and a copy
	// affordance -- the same treatment pict-section-content gives a document.
	// Re-run every render: the reader DOM is replaced each time, so the image
	// tagging and the delegated click listener must be re-applied to the fresh
	// element. Skip the mermaid scan (prompts do not render live diagrams).
	_enhanceReaderMedia()
	{
		if (this._ui.Tab !== 'prompts' || !this._isPromptReadMode()) { return; }
		if (typeof document === 'undefined') { return; }
		let tmpContentView = this._contentView();
		let tmpBodyId = 'pspe-reader-body-' + this.Hash;
		if (!tmpContentView || !document.getElementById(tmpBodyId)) { return; }
		// A progressive enhancement -- a failure here must never break the reader.
		try { tmpContentView.enableFullscreenViewers(tmpBodyId, { skipMermaid: true }); }
		catch (pError) { this.log.warn('PromptEditor: reader media enhancement failed: ' + pError.message); }
	}

	// The list rail is a pict-section-modal panel: draggable resize handle,
	// collapse tab, width and collapsed state persisted per section. One
	// persist key covers all three tabs so the rail feels like one control.
	// Re-attached after every render (the render replaces the rail's DOM).
	_mountRailPanel()
	{
		let tmpModal = this._modal();
		if (!tmpModal || typeof tmpModal.panel !== 'function' || typeof document === 'undefined') { return; }
		let tmpRailId = 'pspe-rail-' + this.Hash + '-' + this._ui.Tab;
		if (!document.getElementById(tmpRailId)) { return; }
		if (this._railPanelHandle)
		{
			try { this._railPanelHandle.destroy(); }
			catch (pError) { /* the prior rail's DOM is already gone */ }
			this._railPanelHandle = null;
		}
		this._railPanelHandle = tmpModal.panel('#' + tmpRailId,
		{
			position: 'left',
			width: 320,
			minWidth: 200,
			maxWidth: 560,
			collapsible: true,
			persist: true,
			persistKey: 'pspe-rail-' + this.Hash
		});
	}

	// One searchable picker (pict-section-picker) per editable segment, rendered
	// into the host div the segment template provides. createPicker is
	// re-entrant -- it merges config into an existing view -- so every section
	// render refreshes the option list and the OnChange closure, then repaints.
	_mountInsertPickers()
	{
		let tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || typeof document === 'undefined') { return; }
		if (this._ui.Tab !== 'prompts' || this.options.ReadOnly || this._ui.PromptMode === 'read') { return; }
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		if (!this.pict.AppData.PromptEditorInsertPick) { this.pict.AppData.PromptEditorInsertPick = {}; }
		let tmpType = libTypes.getPromptType(this._types, tmpPrompt.TypeKey);
		let tmpOptions = this._loaded.WordLists.map((pList) => ({ Value: pList.Name, Text: pList.Name }));
		let tmpSelf = this;
		(tmpType.Segments || []).forEach((pSegment) =>
		{
			if (pSegment.Fixed) { return; }
			let tmpHostId = 'pspe-ins-' + this.Hash + '-' + pSegment.Key;
			if (!document.getElementById(tmpHostId)) { return; }
			let tmpPickerHash = 'PromptEditor-Ins-' + this.Hash + '-' + pSegment.Key;
			let tmpPickerView = tmpPickerProvider.createPicker(tmpPickerHash,
			{
				DestinationAddress: '#' + tmpHostId,
				ValueAddress: 'AppData.PromptEditorInsertPick.' + tmpPickerHash,
				Placeholder: 'Insert word list…',
				Options: tmpOptions,
				OnChange: (pValue) =>
				{
					if (!pValue) { return; }
					tmpSelf.insertWordList(pSegment.Key, pValue, 'pspe-seg-' + tmpSelf.Hash + '-' + pSegment.Key);
					// This control is an action, not a value holder: reset to the
					// placeholder once the picker finishes its own select cycle.
					setTimeout(() =>
					{
						try { tmpPickerView.setValue(null); }
						catch (pError) { /* the picker was re-rendered away; nothing to reset */ }
					}, 0);
				}
			});
			tmpPickerView.render();
		});
	}

	// ---- wiring --------------------------------------------------------------
	_initProvider()
	{
		if (this.options.DataProvider)
		{
			this._provider = this.options.DataProvider;
			return;
		}
		if (!this.pict.AppData.PromptEditorStores) { this.pict.AppData.PromptEditorStores = {}; }
		if (!this.pict.AppData.PromptEditorStores[this.Hash]) { this.pict.AppData.PromptEditorStores[this.Hash] = {}; }
		this._provider = new libProvider.InMemoryPromptProvider({ Store: this.pict.AppData.PromptEditorStores[this.Hash] });
	}

	_ensureSupportViews()
	{
		// Markdown rendering for previews and the generated browser.
		if (!this._contentProvider())
		{
			this.pict.addProvider('Pict-Content',
				libPictSectionContent.PictContentProvider.default_configuration,
				libPictSectionContent.PictContentProvider);
		}
		// The content VIEW carries enableFullscreenViewers: after the reader
		// renders the assembled prompt markdown we hand it the reader body so
		// its images become click-to-zoom. The view shares the provider's CSS
		// hash, so registering it injects no additional styles. AutoRender is
		// false on the view, so this never tries to paint a destination.
		if (!this._contentView())
		{
			this.pict.addView('Pict-Content', libPictSectionContent.default_configuration, libPictSectionContent);
		}
		// Confirm dialogs, toasts, and the rich editor host. Registering is not
		// enough: the modal scopes its CSS variables under a .pict-modal-root
		// class it puts on <body> during onBeforeInitialize, so an uninitialized
		// modal renders unstyled dialogs and toasts. Initialize it explicitly
		// when the root class is absent (idempotent in hosts that already did).
		if (!this.pict.views['Pict-Section-Modal'])
		{
			this.pict.addView('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);
		}
		let tmpModalView = this.pict.views['Pict-Section-Modal'];
		if (tmpModalView && typeof document !== 'undefined' && document.body
			&& !document.body.classList.contains('pict-modal-root')
			&& typeof tmpModalView.initialize === 'function')
		{
			tmpModalView.initialize();
		}
		// The searchable insert-word-list control on each segment.
		if (!this.pict.providers['Pict-Section-Picker'])
		{
			this.pict.addProvider('Pict-Section-Picker', libPictSectionPicker.default_configuration, libPictSectionPicker);
		}
		// The modal's panel collapse tab resolves its chevron through the
		// window.pict global (the framework convention); expose it for hosts
		// that only set window._Pict, or the tab renders without a glyph.
		if (typeof window !== 'undefined' && !window.pict)
		{
			window.pict = this.pict;
		}
	}

	_registerTemplateExpression()
	{
		// Register {~WordListEntry:~} once per pict instance, then add this
		// view's word lists as a resolver so the expression works in ordinary
		// application templates too (not just generation runs).
		if (!this.pict.__PictSectionPromptEditorTemplateRegistered && typeof this.pict.addTemplate === 'function')
		{
			try { this.pict.addTemplate(libWordListTemplate); this.pict.__PictSectionPromptEditorTemplateRegistered = true; }
			catch (pError) { this.log.warn('PromptEditor: WordListEntry template registration failed: ' + pError.message); }
		}
		if (!Array.isArray(this.pict.__PictSectionPromptEditorResolvers)) { this.pict.__PictSectionPromptEditorResolvers = []; }
		this.pict.__PictSectionPromptEditorResolvers.push((pNameLower) =>
		{
			let tmpList = (this._loaded.WordLists || []).find((pList) => String(pList.Name || '').trim().toLowerCase() === pNameLower);
			return tmpList ? tmpList.Entries : null;
		});
	}

	_contentProvider()
	{
		let tmpCandidates = ['Pict-Content', 'Content'];
		for (let i = 0; i < tmpCandidates.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpCandidates[i]];
			if (tmpProvider && typeof tmpProvider.parseMarkdown === 'function') { return tmpProvider; }
		}
		return null;
	}

	// The pict-section-content VIEW (distinct from its provider) supplies
	// enableFullscreenViewers -- image/code click-to-zoom over a container.
	_contentView()
	{
		let tmpCandidates = ['Pict-Content', 'Content'];
		for (let i = 0; i < tmpCandidates.length; i++)
		{
			let tmpView = this.pict.views[tmpCandidates[i]];
			if (tmpView && typeof tmpView.enableFullscreenViewers === 'function') { return tmpView; }
		}
		return null;
	}

	_modal() { return this.pict.views['Pict-Section-Modal']; }

	_toast(pMessage, pType)
	{
		let tmpModal = this._modal();
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'info' }); }
	}

	_fire(pHook, pPayload)
	{
		if (typeof this.options[pHook] === 'function')
		{
			try { this.options[pHook](pPayload); } catch (pError) { /* a host hook throwing must not break the section */ }
		}
		if (pHook !== 'onChange' && typeof this.options.onChange === 'function')
		{
			try { this.options.onChange({ Event: pHook.replace(/^on/, ''), Payload: pPayload }); } catch (pError) { /* same */ }
		}
	}

	// ---- public API ------------------------------------------------------------
	load()
	{
		return this._provider.loadAll().then((pAll) =>
		{
			this._loaded = pAll;
			// Keep selections honest after a reload.
			if (this._ui.ActivePromptKey && !this._findPrompt(this._ui.ActivePromptKey)) { this._ui.ActivePromptKey = null; }
			if (!this._ui.ActivePromptKey && this._loaded.Prompts.length) { this._ui.ActivePromptKey = this._loaded.Prompts[0].Key; }
			if (this._ui.ActiveWordListKey && !this._findWordList(this._ui.ActiveWordListKey)) { this._ui.ActiveWordListKey = null; }
			if (!this._ui.ActiveWordListKey && this._loaded.WordLists.length) { this._ui.ActiveWordListKey = this._loaded.WordLists[0].Key; }
			if (this._ui.ActiveGeneratedKey && !this._findGenerated(this._ui.ActiveGeneratedKey)) { this._ui.ActiveGeneratedKey = null; }
			if (!this._ui.ActiveGeneratedKey && this._loaded.Generated.length) { this._ui.ActiveGeneratedKey = this._loaded.Generated[0].Key; }
			this._shape();
			this.render();
		});
	}

	refresh() { return this.load(); }

	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = !!pReadOnly;
		this._shape();
		this.render();
	}

	/* Replace the selectable prompt-type set (the cascade behind the type dropdown) and repaint. The
	   type list is cached as this._types at construction; a host that updates its shape library
	   mid-session calls this so the dropdown reflects the new set without a full page reload. */
	setPromptTypes(pTypes)
	{
		this.options.PromptTypes = pTypes || null;
		this._types = libTypes.resolvePromptTypes(this.options.PromptTypes);
		this._shape();
		this.render();
	}

	setDataProvider(pProvider)
	{
		this._provider = pProvider || null;
		if (!this._provider) { this._initProvider(); }
		return this.load();
	}

	// ---- lookups ---------------------------------------------------------------
	_findPrompt(pKey) { return this._loaded.Prompts.find((pPrompt) => pPrompt.Key === pKey) || null; }
	_findWordList(pKey) { return this._loaded.WordLists.find((pList) => pList.Key === pKey) || null; }
	_findGenerated(pKey) { return this._loaded.Generated.find((pGenerated) => pGenerated.Key === pKey) || null; }
	_activePrompt() { return this._findPrompt(this._ui.ActivePromptKey); }
	_activeWordList() { return this._findWordList(this._ui.ActiveWordListKey); }
	_activeType() { let tmpPrompt = this._activePrompt(); return tmpPrompt ? libTypes.getPromptType(this._types, tmpPrompt.TypeKey) : null; }

	_renderMarkdown(pMarkdown)
	{
		let tmpMarkdown = String(pMarkdown || '');
		let tmpProvider = this._contentProvider();
		if (tmpProvider)
		{
			try { return tmpProvider.parseMarkdown(tmpMarkdown, null, null, null) || ''; }
			catch (pError) { /* fall through to the escaped form */ }
		}
		let tmpEscaped = tmpMarkdown.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		return '<pre>' + tmpEscaped + '</pre>';
	}

	_escapeHtml(pText)
	{
		return String(pText == null ? '' : pText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	_wordListTotal(pList)
	{
		return ((pList && pList.Entries) || []).reduce((pSum, pEntry) =>
		{
			let tmpWeight = Number(pEntry[1]);
			return pSum + ((isFinite(tmpWeight) && tmpWeight > 0) ? tmpWeight : 0);
		}, 0);
	}

	_entryShare(pWeight, pTotal)
	{
		let tmpWeight = Number(pWeight);
		return (pTotal > 0 && isFinite(tmpWeight) && tmpWeight > 0)
			? (Math.round((tmpWeight / pTotal) * 1000) / 10) + '%'
			: '0%';
	}

	// Live update of the share chips and the rail summary after a weight edit,
	// via targeted DOM writes. Deliberately NOT a re-render: replacing the pane
	// would destroy the input mid-interaction (spinner clicks, typing focus).
	_refreshShareCells()
	{
		let tmpList = this._activeWordList();
		if (!tmpList) { return; }
		let tmpEntries = tmpList.Entries || [];
		let tmpTotal = this._wordListTotal(tmpList);
		for (let i = 0; i < tmpEntries.length; i++)
		{
			this.pict.ContentAssignment.assignContent('#pspe-pct-' + this.Hash + '-' + i, this._entryShare(tmpEntries[i][1], tmpTotal));
		}
		this.pict.ContentAssignment.assignContent('#pspe-wlsub-' + this.Hash + '-' + tmpList.Key,
			this._escapeHtml(tmpEntries.length + ' words · total weight ' + tmpTotal));
	}

	_scheduleEntriesSave()
	{
		if (this._entriesSaveTimer) { clearTimeout(this._entriesSaveTimer); }
		this._entriesSaveTimer = setTimeout(() => { this._entriesSaveTimer = null; this.saveEntries(); }, 400);
	}

	_copyToClipboard(pText, pLabel)
	{
		if (typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.writeText)
		{
			this._toast('Clipboard is not available here.', 'info');
			return;
		}
		navigator.clipboard.writeText(String(pText == null ? '' : pText))
			.then(() => this._toast((pLabel || 'Markdown') + ' copied.', 'success'))
			.catch(() => this._toast('Copy failed.', 'error'));
	}

	_ago(pStamp)
	{
		let tmpDelta = Date.now() - Number(pStamp || 0);
		if (!isFinite(tmpDelta) || tmpDelta < 0) { return ''; }
		let tmpMinutes = Math.floor(tmpDelta / 60000);
		if (tmpMinutes < 1) { return 'just now'; }
		if (tmpMinutes < 60) { return tmpMinutes + 'm ago'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		if (tmpHours < 24) { return tmpHours + 'h ago'; }
		return Math.floor(tmpHours / 24) + 'd ago';
	}

	// ---- shape: loaded + ui --> the render model -------------------------------
	_shape()
	{
		let tmpReadOnly = !!this.options.ReadOnly;
		let tmpState =
		{
			ViewHash: this.Hash,
			Title: this.options.Title,
			Tabs:
			[
				{ ViewHash: this.Hash, Key: 'prompts', Label: 'Prompts', Count: this._loaded.Prompts.length, OnClass: (this._ui.Tab === 'prompts') ? 'pspe-tab-on' : '' },
				{ ViewHash: this.Hash, Key: 'wordlists', Label: 'Word Lists', Count: this._loaded.WordLists.length, OnClass: (this._ui.Tab === 'wordlists') ? 'pspe-tab-on' : '' },
				{ ViewHash: this.Hash, Key: 'generated', Label: 'Generated', Count: this._loaded.Generated.length, OnClass: (this._ui.Tab === 'generated') ? 'pspe-tab-on' : '' }
			],
			PromptsPaneSlot: [],
			WordListsPaneSlot: [],
			GeneratedPaneSlot: []
		};

		if (this._ui.Tab === 'prompts') { tmpState.PromptsPaneSlot = [this._shapePromptsPane(tmpReadOnly)]; }
		else if (this._ui.Tab === 'wordlists') { tmpState.WordListsPaneSlot = [this._shapeWordListsPane(tmpReadOnly)]; }
		else { tmpState.GeneratedPaneSlot = [this._shapeGeneratedPane(tmpReadOnly)]; }

		this._state = tmpState;
	}

	// A prompt is browsed read-only (the assembled markdown) unless the caller
	// flipped it into 'edit'. A globally ReadOnly section keeps its own preview
	// path (the pReadOnly branch of _shapePromptEditor), so this only governs the
	// editable library's browse-vs-edit swap.
	_isPromptReadMode() { return !this.options.ReadOnly && this._ui.PromptMode !== 'edit'; }

	_shapePromptsPane(pReadOnly)
	{
		let tmpActive = this._activePrompt();
		let tmpPane =
		{
			ViewHash: this.Hash,
			NewSlot: pReadOnly ? [] : [{ ViewHash: this.Hash }],
			Prompts: this._loaded.Prompts.map((pPrompt) => (
			{
				ViewHash: this.Hash,
				Key: pPrompt.Key,
				Title: pPrompt.Title || 'Untitled prompt',
				TypeName: libTypes.getPromptType(this._types, pPrompt.TypeKey).Name + ' · ' + this._ago(pPrompt.UpdatedAt),
				OnClass: (tmpActive && tmpActive.Key === pPrompt.Key) ? 'pspe-rail-item-on' : ''
			})),
			EmptySlot: this._loaded.Prompts.length ? [] : [{ Text: 'No prompts yet.' }],
			ReaderSlot: [],
			EditorSlot: [],
			NoSelectionSlot: []
		};
		if (tmpActive && this._isPromptReadMode()) { tmpPane.ReaderSlot = [this._shapePromptReader(tmpActive)]; }
		else if (tmpActive) { tmpPane.EditorSlot = [this._shapePromptEditor(tmpActive, pReadOnly)]; }
		else { tmpPane.NoSelectionSlot = [{ Text: pReadOnly ? 'Nothing to show.' : 'Create a prompt to start crafting.' }]; }
		return tmpPane;
	}

	// The read model: the whole prompt compiled to one markdown document (the
	// same source the compiler versions and generation rolls), rendered as
	// content with a compact header carrying the type and browse actions.
	_shapePromptReader(pPrompt)
	{
		let tmpType = libTypes.getPromptType(this._types, pPrompt.TypeKey);
		return (
		{
			ViewHash: this.Hash,
			TypeName: tmpType.Name,
			ActionsSlot: this.options.ReadOnly ? [] : [{ ViewHash: this.Hash }],
			MarkdownHtml: this._renderMarkdown(this._assembleSource(pPrompt))
		});
	}

	// The whole prompt compiled to one markdown document -- the same source the
	// compiler versions and generation rolls. Shared by the reader (rendered to
	// HTML) and Copy markdown (handed to the clipboard verbatim).
	_assembleSource(pPrompt)
	{
		if (!pPrompt) { return ''; }
		let tmpType = libTypes.getPromptType(this._types, pPrompt.TypeKey);
		return libCompiler.assembleSource(pPrompt, tmpType,
			{
				IncludeTitleHeading: this.options.IncludeTitleHeading,
				SegmentHeadingLevel: this.options.SegmentHeadingLevel
			});
	}

	_shapePromptEditor(pPrompt, pReadOnly)
	{
		let tmpType = libTypes.getPromptType(this._types, pPrompt.TypeKey);
		let tmpHasRichEditor = !pReadOnly && !!(this.options.CodeMirrorModules || (typeof window !== 'undefined' && window.CodeMirrorModules));

		let tmpSegments = (tmpType.Segments || []).map((pSegment) =>
		{
			let tmpBody = String((pPrompt.Segments || {})[pSegment.Key] || '');
			let tmpPreviewKey = pPrompt.Key + ':' + pSegment.Key;
			let tmpPreviewOn = !!this._ui.PreviewSegments[tmpPreviewKey];
			let tmpPills = [];
			if (pSegment.Fixed) { tmpPills.push({ Label: 'fixed' }); }
			if (pSegment.Optional) { tmpPills.push({ Label: 'optional' }); }
			let tmpShaped =
			{
				ViewHash: this.Hash,
				SegmentKey: pSegment.Key,
				Name: pSegment.Name || pSegment.Key,
				Guidance: pSegment.Guidance || '',
				PillSlot: tmpPills,
				FixedSlot: [],
				EditSlot: [],
				PreviewSlot: []
			};
			if (pSegment.Fixed)
			{
				tmpShaped.FixedSlot = [{ BodyHtml: this._renderMarkdown(pSegment.Body || '') }];
				return tmpShaped;
			}
			if (pReadOnly)
			{
				tmpShaped.PreviewSlot = [{ BodyHtml: this._renderMarkdown(tmpBody || '*(empty)*') }];
				return tmpShaped;
			}
			tmpShaped.EditSlot =
			[{
				ViewHash: this.Hash,
				SegmentKey: pSegment.Key,
				TextareaId: 'pspe-seg-' + this.Hash + '-' + pSegment.Key,
				Body: tmpBody,
				Placeholder: 'Markdown. Pict template expressions welcome, like {~WordListEntry:ListName~}.',
				PreviewLabel: tmpPreviewOn ? 'Hide preview' : 'Preview',
				RichSlot: tmpHasRichEditor ? [{ ViewHash: this.Hash, SegmentKey: pSegment.Key }] : []
			}];
			if (tmpPreviewOn)
			{
				tmpShaped.PreviewSlot = [{ BodyHtml: this._renderMarkdown(tmpBody || '*(empty)*') }];
			}
			return tmpShaped;
		});

		let tmpGeneratedForPrompt = this._loaded.Generated.filter((pGenerated) => pGenerated.PromptKey === pPrompt.Key).length;
		return (
		{
			ViewHash: this.Hash,
			Title: pPrompt.Title || '',
			TypeDescription: tmpType.Description || '',
			TypeOptions: this._types.map((pTypeOption) => (
			{
				Value: pTypeOption.Key,
				Label: pTypeOption.Name,
				SelectedAttr: (pTypeOption.Key === pPrompt.TypeKey) ? 'selected' : ''
			})),
			ReadToggleSlot: pReadOnly ? [] : [{ ViewHash: this.Hash }],
			ActionsSlot: pReadOnly ? [] : [{ ViewHash: this.Hash }],
			OptionsSlot: pReadOnly ? [] :
			[{
				ViewHash: this.Hash,
				SegmentHeadingsChecked: (pPrompt.IncludeSegmentHeadings === false) ? '' : 'checked'
			}],
			Segments: tmpSegments,
			GenerateSlot: pReadOnly ? [] :
			[{
				ViewHash: this.Hash,
				Count: this._ui.GenerateCount,
				MaxCount: this.options.GenerateMaxCount,
				Note: tmpGeneratedForPrompt ? (tmpGeneratedForPrompt + ' generated from this prompt so far') : 'Each generation rolls the word lists fresh.'
			}],
			PreviewPanelSlot: (this._ui.Preview && this._ui.Preview.PromptKey === pPrompt.Key)
				? [{
					ViewHash: this.Hash,
					FormattedOnClass: (this._ui.PreviewMode !== 'raw') ? ' pspe-btn-on' : '',
					RawOnClass: (this._ui.PreviewMode === 'raw') ? ' pspe-btn-on' : '',
					RenderedSlot: (this._ui.PreviewMode !== 'raw') ? [{ MarkdownHtml: this._renderMarkdown(this._ui.Preview.Markdown) }] : [],
					RawSlot: (this._ui.PreviewMode === 'raw') ? [{ MarkdownEscaped: this._escapeHtml(this._ui.Preview.Markdown) }] : []
				}]
				: []
		});
	}

	_shapeWordListsPane(pReadOnly)
	{
		let tmpActive = this._activeWordList();
		let tmpPane =
		{
			ViewHash: this.Hash,
			NewSlot: pReadOnly ? [] : [{ ViewHash: this.Hash }],
			WordLists: this._loaded.WordLists.map((pList) => (
			{
				ViewHash: this.Hash,
				Key: pList.Key,
				Name: pList.Name,
				Summary: (pList.Entries || []).length + ' words · total weight ' + this._wordListTotal(pList),
				OnClass: (tmpActive && tmpActive.Key === pList.Key) ? 'pspe-rail-item-on' : ''
			})),
			EmptySlot: this._loaded.WordLists.length ? [] : [{ Text: 'No word lists yet.' }],
			DetailSlot: [],
			NoSelectionSlot: []
		};
		if (tmpActive && !pReadOnly)
		{
			let tmpTotal = this._wordListTotal(tmpActive);
			tmpPane.DetailSlot =
			[{
				ViewHash: this.Hash,
				Key: tmpActive.Key,
				Name: tmpActive.Name,
				ExpressionExample: '{~WordListEntry:' + tmpActive.Name + '~}',
				Entries: (tmpActive.Entries || []).map((pEntry, pIndex) => (
				{
					ViewHash: this.Hash,
					Index: pIndex,
					Word: pEntry[0],
					Weight: pEntry[1],
					Percent: this._entryShare(pEntry[1], tmpTotal)
				}))
			}];
		}
		else if (tmpActive && pReadOnly)
		{
			tmpPane.NoSelectionSlot = [{ Text: tmpActive.Name + ': ' + (tmpActive.Entries || []).map((pEntry) => pEntry[0] + ' (' + pEntry[1] + ')').join(', ') }];
		}
		else
		{
			tmpPane.NoSelectionSlot = [{ Text: pReadOnly ? 'Nothing to show.' : 'Create a word list to template against.' }];
		}
		return tmpPane;
	}

	_shapeGeneratedPane(pReadOnly)
	{
		let tmpActive = this._findGenerated(this._ui.ActiveGeneratedKey);
		let tmpPane =
		{
			ViewHash: this.Hash,
			Note: this._loaded.Generated.length
				? (this._loaded.Generated.length + ' generated prompt' + (this._loaded.Generated.length === 1 ? '' : 's') + ', in file order. The zip holds them all as markdown files.')
				: 'Generate from a prompt and the output lands here.',
			ToolsSlot: (this._loaded.Generated.length && !pReadOnly) ? [{ ViewHash: this.Hash }] : [],
			Generated: this._loaded.Generated.map((pGenerated) => (
			{
				ViewHash: this.Hash,
				Key: pGenerated.Key,
				FileName: libCompiler.generatedFileName(pGenerated),
				Sub: (pGenerated.PromptTitle || 'untitled') + ' · ' + this._ago(pGenerated.GeneratedAt),
				OnClass: (tmpActive && tmpActive.Key === pGenerated.Key) ? 'pspe-rail-item-on' : ''
			})),
			EmptySlot: this._loaded.Generated.length ? [] : [{ Text: 'Nothing generated yet.' }],
			ViewerSlot: [],
			NoSelectionSlot: []
		};
		if (tmpActive)
		{
			tmpPane.ViewerSlot = [{ ViewHash: this.Hash, MarkdownHtml: this._renderMarkdown(tmpActive.Markdown) }];
		}
		else if (this._loaded.Generated.length)
		{
			tmpPane.NoSelectionSlot = [{ Text: 'Pick a generated prompt to read it.' }];
		}
		return tmpPane;
	}

	_reshape() { this._shape(); this.render(); }

	// ---- tab + selection handlers ------------------------------------------------
	selectTab(pTab) { this._ui.Tab = pTab; this._reshape(); }
	selectPrompt(pKey)
	{
		if (this._ui.ActivePromptKey !== pKey) { this._ui.Preview = null; }
		this._ui.ActivePromptKey = pKey;
		// Picking a prompt in the rail is browsing: land on the read view.
		this._ui.PromptMode = 'read';
		this._reshape();
	}

	// The reader's Edit button; swap the segment editor in for the active prompt.
	editActivePrompt()
	{
		if (this.options.ReadOnly) { return; }
		this._ui.PromptMode = 'edit';
		this._reshape();
	}

	// Copy the assembled prompt markdown (headings + segments, template
	// expressions left literal) so it can be pasted straight into a runner.
	copyActivePromptMarkdown()
	{
		this._copyToClipboard(this._assembleSource(this._activePrompt()), 'Prompt markdown');
	}

	// The editor's Done button; back to the read view, dropping any preview roll.
	readActivePrompt()
	{
		this._ui.PromptMode = 'read';
		this._ui.Preview = null;
		this._reshape();
	}
	selectWordList(pKey) { this._ui.ActiveWordListKey = pKey; this._reshape(); }
	selectGenerated(pKey) { this._ui.ActiveGeneratedKey = pKey; this._reshape(); }

	// ---- prompt handlers -----------------------------------------------------------
	newPrompt()
	{
		let tmpTypeKey = this._types.length ? this._types[0].Key : 'freeform';
		this._provider.createPrompt({ TypeKey: tmpTypeKey, Title: 'Untitled prompt', Author: this.options.CurrentUser })
			.then((pPrompt) =>
			{
				this._ui.ActivePromptKey = pPrompt.Key;
				// A fresh prompt opens ready to write in, not in the read view.
				this._ui.PromptMode = 'edit';
				this._fire('onPromptSaved', pPrompt);
				return this.load();
			})
			.catch((pError) => this._toast('Could not create the prompt: ' + pError.message, 'error'));
	}

	cachePromptTitle(pValue)
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		tmpPrompt.Title = pValue;
		// Mirror into the rail in place; no re-render while typing.
		this.pict.ContentAssignment.assignContent('#pspe-prname-' + this.Hash + '-' + tmpPrompt.Key, this._escapeHtml(pValue || 'Untitled prompt'));
	}

	savePromptTitle()
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		this._provider.updatePrompt(tmpPrompt.Key, { Title: tmpPrompt.Title })
			.then((pSaved) => { this._fire('onPromptSaved', pSaved); })
			.catch((pError) => this._toast('Title save failed: ' + pError.message, 'error'));
	}

	setPromptType(pTypeKey)
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		// Non-destructive: segment bodies stay keyed in the prompt; switching
		// types changes which segments show and compile.
		tmpPrompt.TypeKey = pTypeKey;
		this._provider.updatePrompt(tmpPrompt.Key, { TypeKey: pTypeKey })
			.then((pSaved) => { this._fire('onPromptSaved', pSaved); this._reshape(); })
			.catch((pError) => this._toast('Type change failed: ' + pError.message, 'error'));
	}

	duplicatePrompt()
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		this._provider.createPrompt(
			{
				TypeKey: tmpPrompt.TypeKey,
				Title: tmpPrompt.Title + ' (copy)',
				Segments: JSON.parse(JSON.stringify(tmpPrompt.Segments || {})),
				IncludeSegmentHeadings: tmpPrompt.IncludeSegmentHeadings !== false,
				Meta: JSON.parse(JSON.stringify(tmpPrompt.Meta || {})),
				Author: this.options.CurrentUser
			})
			.then((pCopy) =>
			{
				this._ui.ActivePromptKey = pCopy.Key;
				// A copy is made to be changed; open it in the editor.
				this._ui.PromptMode = 'edit';
				this._fire('onPromptSaved', pCopy);
				return this.load();
			})
			.catch((pError) => this._toast('Duplicate failed: ' + pError.message, 'error'));
	}

	deletePrompt()
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		let tmpModal = this._modal();
		let fDelete = () => this._provider.deletePrompt(tmpPrompt.Key)
			.then(() => { this._fire('onPromptDeleted', tmpPrompt); this._ui.ActivePromptKey = null; return this.load(); })
			.catch((pError) => this._toast('Delete failed: ' + pError.message, 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Delete "' + (tmpPrompt.Title || 'this prompt') + '" and everything generated from it?', { title: 'Delete prompt?', confirmLabel: 'Delete', dangerous: true })
				.then((pOk) => { if (pOk) { fDelete(); } });
		}
		else { fDelete(); }
	}

	// ---- segment handlers ----------------------------------------------------------
	cacheSegment(pSegmentKey, pValue)
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		if (!tmpPrompt.Segments) { tmpPrompt.Segments = {}; }
		tmpPrompt.Segments[pSegmentKey] = pValue;
	}

	saveSegment(pSegmentKey)
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		this._provider.updatePrompt(tmpPrompt.Key, { Segments: tmpPrompt.Segments })
			.then((pSaved) => { this._fire('onPromptSaved', pSaved); })
			.catch((pError) => this._toast('Segment save failed: ' + pError.message, 'error'));
	}

	// The per-prompt "segment headings in the output" toggle: saves with the
	// prompt, and the compiler reads it on every assemble (preview, generate,
	// zip). No re-render needed - the checkbox itself holds the new state -
	// but an open preview re-rolls so what you see matches what you would get.
	setSegmentHeadings(pChecked)
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		tmpPrompt.IncludeSegmentHeadings = !!pChecked;
		this._provider.updatePrompt(tmpPrompt.Key, { IncludeSegmentHeadings: !!pChecked })
			.then((pSaved) =>
			{
				this._fire('onPromptSaved', pSaved);
				if (this._ui.Preview && this._ui.Preview.PromptKey === tmpPrompt.Key) { this.previewOnce(); }
			})
			.catch((pError) => this._toast('Save failed: ' + pError.message, 'error'));
	}

	toggleSegmentPreview(pSegmentKey)
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		let tmpPreviewKey = tmpPrompt.Key + ':' + pSegmentKey;
		this._ui.PreviewSegments[tmpPreviewKey] = !this._ui.PreviewSegments[tmpPreviewKey];
		this._reshape();
	}

	// Insert {~WordListEntry:Name~} at the caret of the segment's textarea.
	insertWordList(pSegmentKey, pListName, pTextareaId)
	{
		if (!pListName) { return; }
		let tmpExpression = '{~WordListEntry:' + pListName + '~}';
		let tmpTextarea = (typeof document !== 'undefined') ? document.getElementById(pTextareaId) : null;
		if (tmpTextarea)
		{
			let tmpStart = (typeof tmpTextarea.selectionStart === 'number') ? tmpTextarea.selectionStart : tmpTextarea.value.length;
			let tmpEnd = (typeof tmpTextarea.selectionEnd === 'number') ? tmpTextarea.selectionEnd : tmpStart;
			tmpTextarea.value = tmpTextarea.value.slice(0, tmpStart) + tmpExpression + tmpTextarea.value.slice(tmpEnd);
			tmpTextarea.focus();
			tmpTextarea.selectionStart = tmpTextarea.selectionEnd = tmpStart + tmpExpression.length;
			this.cacheSegment(pSegmentKey, tmpTextarea.value);
		}
		else
		{
			let tmpPrompt = this._activePrompt();
			if (!tmpPrompt) { return; }
			this.cacheSegment(pSegmentKey, String((tmpPrompt.Segments || {})[pSegmentKey] || '') + tmpExpression);
		}
		this.saveSegment(pSegmentKey);
	}

	// The full pict-section-markdowneditor, hosted in a modal, editing one segment.
	openRichEditor(pSegmentKey)
	{
		let tmpPrompt = this._activePrompt();
		let tmpModal = this._modal();
		if (!tmpPrompt || !tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpModules = this.options.CodeMirrorModules || ((typeof window !== 'undefined') ? window.CodeMirrorModules : null);
		if (!tmpModules)
		{
			this._toast('The rich editor needs CodeMirror; the inline editor still works.', 'info');
			return;
		}

		// The rich editor reads segments from a fable-manifest address; keep it
		// bracket-free by keying a dedicated AppData node on a sanitized hash.
		let tmpRichKey = 'PromptEditorRich_' + String(this.Hash).replace(/[^A-Za-z0-9_]/g, '_');
		if (!this.pict.AppData[tmpRichKey]) { this.pict.AppData[tmpRichKey] = {}; }
		this.pict.AppData[tmpRichKey].Segments = [{ Content: String((tmpPrompt.Segments || {})[pSegmentKey] || '') }];
		this._richDataKey = tmpRichKey;

		if (!this._richEditorViewHash)
		{
			this._richEditorViewHash = 'PromptEditor-MDE-' + this.Hash;
			this.pict.addView(this._richEditorViewHash, Object.assign({}, libMarkdownEditor.default_configuration,
			{
				ViewIdentifier: this._richEditorViewHash,
				AutoRender: false,
				DefaultDestinationAddress: '#pspe-rich-host-' + this.Hash,
				// The editor builds its UI into TargetElementAddress directly
				// (separate from the renderable destination).
				TargetElementAddress: '#pspe-rich-host-' + this.Hash,
				ContentDataAddress: 'AppData.' + tmpRichKey + '.Segments',
				DefaultPreviewMode: 'side'
			}), libMarkdownEditor);
		}

		let tmpEditor = this.pict.views[this._richEditorViewHash];
		let tmpSelf = this;
		tmpModal.show(
		{
			title: 'Edit segment',
			content: '<div class="pspe-rich-host" id="pspe-rich-host-' + this.Hash + '"></div>',
			width: '860px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: function ()
			{
				try
				{
					tmpEditor.connectCodeMirrorModules(tmpModules);
					tmpEditor.render();
					tmpEditor.marshalToView();
				}
				catch (pError) { tmpSelf._toast('Rich editor failed to start: ' + pError.message, 'error'); }
			}
		}).then((pChoice) =>
		{
			if (pChoice !== 'save') { return; }
			try { tmpEditor.marshalFromView(); } catch (pError) { /* fall back to whatever is in AppData */ }
			let tmpSegments = (tmpSelf.pict.AppData[tmpSelf._richDataKey] || {}).Segments || [];
			let tmpContent = tmpSegments.map((pSegment) => String(pSegment.Content || '')).join('\n\n');
			tmpSelf.cacheSegment(pSegmentKey, tmpContent);
			tmpSelf.saveSegment(pSegmentKey);
			tmpSelf._reshape();
		});
	}

	// ---- generation -------------------------------------------------------------------
	setGenerateCount(pValue)
	{
		let tmpCount = Math.max(1, Math.min(this.options.GenerateMaxCount, Number(pValue) || 1));
		this._ui.GenerateCount = tmpCount;
	}

	_generateOnce(pPrompt, pType)
	{
		return libCompiler.generate(this.pict, pPrompt, pType, this._loaded.WordLists,
			{
				IncludeTitleHeading: this.options.IncludeTitleHeading,
				SegmentHeadingLevel: this.options.SegmentHeadingLevel,
				RandomFunction: (typeof this.options.RandomFunction === 'function') ? this.options.RandomFunction : undefined
			});
	}

	generatePrompts()
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		let tmpType = libTypes.getPromptType(this._types, tmpPrompt.TypeKey);
		let tmpCount = this._ui.GenerateCount;
		let tmpExisting = this._loaded.Generated.filter((pGenerated) => pGenerated.PromptKey === tmpPrompt.Key).length;

		let tmpCreates = [];
		for (let i = 0; i < tmpCount; i++)
		{
			tmpCreates.push(this._provider.createGenerated(
				{
					PromptKey: tmpPrompt.Key,
					PromptTitle: tmpPrompt.Title,
					TypeKey: tmpPrompt.TypeKey,
					Markdown: this._generateOnce(tmpPrompt, tmpType),
					Sequence: tmpExisting + i + 1,
					Author: this.options.CurrentUser
				}));
		}
		Promise.all(tmpCreates)
			.then((pBatch) =>
			{
				this._fire('onGenerated', pBatch);
				this._toast('Generated ' + pBatch.length + ' prompt' + (pBatch.length === 1 ? '' : 's') + '.', 'success');
				this._ui.Tab = 'generated';
				if (pBatch.length) { this._ui.ActiveGeneratedKey = pBatch[0].Key; }
				return this.load();
			})
			.catch((pError) => this._toast('Generation failed: ' + pError.message, 'error'));
	}

	// Roll the active prompt once, without saving, into the preview panel below
	// the editor. Rolling again replaces it; closing clears it; switching
	// prompts drops it.
	previewOnce()
	{
		let tmpPrompt = this._activePrompt();
		if (!tmpPrompt) { return; }
		let tmpType = libTypes.getPromptType(this._types, tmpPrompt.TypeKey);
		// The preview roll lives under the segment editor; rolling implies editing.
		this._ui.PromptMode = 'edit';
		this._ui.Preview = { PromptKey: tmpPrompt.Key, Markdown: this._generateOnce(tmpPrompt, tmpType) };
		this._reshape();
	}

	closePreview()
	{
		this._ui.Preview = null;
		this._reshape();
	}

	// 'rendered' shows the formatted markdown; 'raw' shows the source. The
	// choice is sticky for the session.
	setPreviewMode(pMode)
	{
		this._ui.PreviewMode = (pMode === 'raw') ? 'raw' : 'rendered';
		this._reshape();
	}

	copyPreview()
	{
		if (!this._ui.Preview) { return; }
		this._copyToClipboard(this._ui.Preview.Markdown, 'Prompt');
	}

	// ---- word list handlers ----------------------------------------------------------
	newWordList()
	{
		let tmpBase = 'New word list';
		let tmpName = tmpBase;
		let tmpNumber = 2;
		while (this._loaded.WordLists.some((pList) => pList.Name === tmpName)) { tmpName = tmpBase + ' ' + tmpNumber++; }
		this._provider.createWordList({ Name: tmpName, Entries: [['', 1]] })
			.then((pList) =>
			{
				this._ui.ActiveWordListKey = pList.Key;
				this._ui.Tab = 'wordlists';
				this._fire('onWordListSaved', pList);
				return this.load();
			})
			.catch((pError) => this._toast('Could not create the word list: ' + pError.message, 'error'));
	}

	cacheWordListName(pValue)
	{
		let tmpList = this._activeWordList();
		if (!tmpList) { return; }
		tmpList.Name = pValue;
		// Mirror into the rail in place; no re-render while typing.
		this.pict.ContentAssignment.assignContent('#pspe-wlname-' + this.Hash + '-' + tmpList.Key, this._escapeHtml(pValue));
	}

	saveWordListName()
	{
		let tmpList = this._activeWordList();
		if (!tmpList) { return; }
		this._provider.updateWordList(tmpList.Key, { Name: tmpList.Name })
			.then((pSaved) => { this._fire('onWordListSaved', pSaved); })
			.catch((pError) => this._toast('Rename failed: ' + pError.message, 'error'));
	}

	deleteWordList()
	{
		let tmpList = this._activeWordList();
		if (!tmpList) { return; }
		let tmpModal = this._modal();
		let fDelete = () => this._provider.deleteWordList(tmpList.Key)
			.then(() => { this._fire('onWordListDeleted', tmpList); this._ui.ActiveWordListKey = null; return this.load(); })
			.catch((pError) => this._toast('Delete failed: ' + pError.message, 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Delete the word list "' + tmpList.Name + '"? Prompts referencing it will show the expression unresolved.', { title: 'Delete word list?', confirmLabel: 'Delete', dangerous: true })
				.then((pOk) => { if (pOk) { fDelete(); } });
		}
		else { fDelete(); }
	}

	// Value edits never re-render: a render replaces the DOM and destroys the
	// input mid-interaction (number spinners fire change on every click, so a
	// render-on-save makes the arrows unusable). Cache + targeted share refresh
	// on input, debounced persist; structural changes (add/remove) re-render.
	cacheEntryWord(pIndex, pValue)
	{
		let tmpList = this._activeWordList();
		if (tmpList && tmpList.Entries[pIndex]) { tmpList.Entries[pIndex][0] = pValue; }
		this._scheduleEntriesSave();
	}

	cacheEntryWeight(pIndex, pValue)
	{
		let tmpList = this._activeWordList();
		if (tmpList && tmpList.Entries[pIndex]) { tmpList.Entries[pIndex][1] = pValue; }
		this._refreshShareCells();
		this._scheduleEntriesSave();
	}

	saveEntries()
	{
		if (this._entriesSaveTimer) { clearTimeout(this._entriesSaveTimer); this._entriesSaveTimer = null; }
		let tmpList = this._activeWordList();
		if (!tmpList) { return Promise.resolve(); }
		return this._provider.updateWordList(tmpList.Key, { Entries: tmpList.Entries })
			.then((pSaved) =>
			{
				// Adopt the normalized entries (weights coerced) and refresh the
				// shares in place. The inputs themselves are left alone so typing
				// in progress is never clobbered.
				tmpList.Entries = pSaved.Entries;
				this._fire('onWordListSaved', pSaved);
				this._refreshShareCells();
			})
			.catch((pError) => this._toast('Save failed: ' + pError.message, 'error'));
	}

	addWordListEntry()
	{
		let tmpList = this._activeWordList();
		if (!tmpList) { return; }
		tmpList.Entries.push(['', 1]);
		this._reshape();
		this.saveEntries();
	}

	removeWordListEntry(pIndex)
	{
		let tmpList = this._activeWordList();
		if (!tmpList) { return; }
		tmpList.Entries.splice(pIndex, 1);
		this._reshape();
		this.saveEntries();
	}

	// ---- generated handlers -------------------------------------------------------------
	deleteGenerated()
	{
		let tmpGenerated = this._findGenerated(this._ui.ActiveGeneratedKey);
		if (!tmpGenerated) { return; }
		this._provider.deleteGenerated(tmpGenerated.Key)
			.then(() => { this._ui.ActiveGeneratedKey = null; return this.load(); })
			.catch((pError) => this._toast('Delete failed: ' + pError.message, 'error'));
	}

	clearGenerated()
	{
		let tmpModal = this._modal();
		let fClear = () => this._provider.clearGenerated()
			.then(() => { this._ui.ActiveGeneratedKey = null; return this.load(); })
			.catch((pError) => this._toast('Clear failed: ' + pError.message, 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Remove every generated prompt? The source prompts stay.', { title: 'Clear generated?', confirmLabel: 'Clear', dangerous: true })
				.then((pOk) => { if (pOk) { fClear(); } });
		}
		else { fClear(); }
	}

	copyGenerated()
	{
		let tmpGenerated = this._findGenerated(this._ui.ActiveGeneratedKey);
		if (!tmpGenerated) { return; }
		this._copyToClipboard(tmpGenerated.Markdown, 'Markdown');
	}

	downloadZip()
	{
		let tmpFiles = this._loaded.Generated.map((pGenerated) => (
		{
			Name: libCompiler.generatedFileName(pGenerated),
			Content: pGenerated.Markdown
		}));
		if (!tmpFiles.length) { this._toast('Nothing generated yet.', 'info'); return; }
		libZip.buildZip(tmpFiles)
			.then((pBlob) => libZip.downloadBlob(pBlob, this.options.ZipFileName))
			.then(() => this._toast('Zip on the way: ' + tmpFiles.length + ' file' + (tmpFiles.length === 1 ? '' : 's') + '.', 'success'))
			.catch((pError) => this._toast('Zip failed: ' + pError.message, 'error'));
	}
}

module.exports = PictViewPromptEditor;
module.exports.default_configuration = _DefaultConfiguration;

},{"../compiler/PromptCompiler.js":293,"../providers/PromptProvider-Base.js":294,"../templates/Pict-Template-WordListEntry.js":295,"../types/PromptEditor-DefaultTypes.js":296,"../zip/PromptZip.js":298,"pict-section-content":196,"pict-section-markdowneditor":261,"pict-section-modal":271,"pict-section-picker":289,"pict-view":365}],298:[function(require,module,exports){
'use strict';

/**
 * Zip packaging for generated prompts: a folder of markdown files in a single
 * download. jszip does the byte work; this wraps the two seams the section
 * needs (build a zip from named files, hand a blob to the browser as a
 * download) and stays usable from node tests via the nodebuffer type.
 */

function _getJSZip()
{
	if (typeof window !== 'undefined' && window.JSZip) { return window.JSZip; }
	try { return require('jszip'); }
	catch (pError) { return null; }
}

/**
 * Build a zip from [{ Name, Content }] entries. Duplicate names get a numeric
 * suffix so every entry survives.
 * @param {Array<{Name: string, Content: string}>} pFiles
 * @param {object} [pOptions] - { Type: 'blob' | 'nodebuffer' (default 'blob') }
 * @returns {Promise<Blob|Buffer>}
 */
function buildZip(pFiles, pOptions)
{
	let tmpJSZip = _getJSZip();
	if (!tmpJSZip) { return Promise.reject(new Error('jszip is not available')); }
	let tmpType = (pOptions && pOptions.Type) || 'blob';
	let tmpZip = new tmpJSZip();
	let tmpSeen = {};
	(pFiles || []).forEach((pFile) =>
	{
		let tmpName = String(pFile.Name || 'file.md');
		if (tmpSeen[tmpName])
		{
			let tmpDot = tmpName.lastIndexOf('.');
			let tmpBase = (tmpDot > 0) ? tmpName.slice(0, tmpDot) : tmpName;
			let tmpExt = (tmpDot > 0) ? tmpName.slice(tmpDot) : '';
			tmpName = tmpBase + '-' + (tmpSeen[pFile.Name] + 1) + tmpExt;
		}
		tmpSeen[pFile.Name] = (tmpSeen[pFile.Name] || 0) + 1;
		tmpZip.file(tmpName, String(pFile.Content || ''));
	});
	return tmpZip.generateAsync({ type: tmpType });
}

/**
 * Hand a blob to the browser as a named download.
 * @param {Blob} pBlob
 * @param {string} pFileName
 */
function downloadBlob(pBlob, pFileName)
{
	if (typeof document === 'undefined') { return; }
	let tmpURL = URL.createObjectURL(pBlob);
	let tmpAnchor = document.createElement('a');
	tmpAnchor.href = tmpURL;
	tmpAnchor.download = pFileName || 'prompts.zip';
	document.body.appendChild(tmpAnchor);
	tmpAnchor.click();
	document.body.removeChild(tmpAnchor);
	setTimeout(() => URL.revokeObjectURL(tmpURL), 1000);
}

module.exports = { buildZip, downloadBlob };

},{"jszip":119}],299:[function(require,module,exports){

// pict-section-tabbar — a compact, host-agnostic tab-bar control.
//
// ONE small, professional tab control: underline-active tabs with optional FontAwesome icons, submenu groups,
// pin zones, and configurable overflow — a pure string-builder plus a tiny runtime, with no framework dependency.
//
// A tab def is either a LEAF (navigates on click) or a GROUP (a def with a `Children` array — renders as a
// dropdown submenu; picking a child navigates and the group tab then reads active and shows a "Group ▸ Child"
// breadcrumb). Any top-level def may carry `Pin: 'left'|'center'|'right'` to park it in a zone of the bar.
//
// CONFIGURABLE (per bar, via container modifier classes — see containerClass()):
//   Overflow strategy — how top-level tabs behave when they don't all fit:
//     .hltabs--menu   : overflow LEAF tabs collapse into a "More ▾" dropdown (recommended).
//                       Group tabs stay put (they are their own dropdowns).
//     .hltabs--wrap   : tabs wrap onto additional rows.
//     .hltabs--scroll : the row scrolls horizontally (the default).
//   Display mode:
//     (default)          : icon + label.
//     .hltabs--icon-only : icon only (labels are still read out / shown in the dropdowns).
//     .hltabs--text-only : label only.
//
// It is intentionally NOT a pict-view — a tab host may be a pict view OR a plain provider — so it exports cheap,
// host-agnostic pieces: TABBAR_CSS, TABBAR_TEMPLATES (the `HL-TabBar-Item` pict template, which just injects each
// record's pre-built HTML), buildTabs() (shapes tab defs into render records), containerClass() (builds the
// modifier class string), renderTabsHTML() (a whole-bar HTML string for plain providers), and layout() (the
// runtime: opens/closes dropdowns and, for `.hltabs--menu`, moves overflow leaves into "More ▾").
//
// A host either:
//   (A) pict view — spread TABBAR_CSS + TABBAR_TEMPLATES into the view, render
//       `<div class="{~containerClass~}">{~TS:HL-TabBar-Item:Record.Tabs~}</div>`, build `Record.Tabs` via
//       buildTabs(), and call layout() from onAfterRender; OR
//   (B) plain string host — inject TABBAR_CSS once, assign renderTabsHTML(...) into your container, and call
//       layout() after each paint.
// layout() is needed for the `menu` overflow strategy and to bind the dropdown runtime (groups also open via the
// module-init runtime, but calling layout() is recommended).

const TABBAR_CSS = /*css*/`
	.hltabs { position: relative; display: flex; align-items: stretch; gap: 0.1rem; margin: 0; padding: 0;
		border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); }
	.hltab { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.4rem; white-space: nowrap;
		cursor: pointer; border: none; background: transparent; font: inherit; font-size: 0.85rem; font-weight: 500; line-height: 1.2;
		color: var(--theme-color-text-secondary, #45505f); padding: 0.55rem 0.9rem; border-bottom: 2px solid transparent; margin-bottom: -1px;
		transition: color 0.12s ease, border-color 0.12s ease, background 0.12s ease; }
	.hltab:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-secondary, #f0f2f6); }
	.hltab:focus-visible { outline: 2px solid var(--theme-color-brand-primary, #5650e6); outline-offset: -2px; }
	.hltab .icon { font-size: 0.92em; opacity: 0.8; }
	.hltab.is-active { color: var(--theme-color-brand-primary, #5650e6); font-weight: 650; border-bottom-color: var(--theme-color-brand-primary, #5650e6); }
	.hltab.is-active .icon { opacity: 1; }
	.hltab.is-overflow, .hltabs-group.is-overflow { display: none; }

	/* --- Pin zones: park a top-level item to the center or right of the bar. The first center/right item opens a
	   flex gap; everything after it rides along in that zone. Left is the natural order (no marker). --- */
	.hltabs-zone-center, .hltabs-zone-right { margin-left: auto; }

	/* --- Group (submenu) tab: an inline dropdown, same visual family as "More". --- */
	.hltabs-group { position: relative; flex: 0 0 auto; display: inline-flex; align-items: stretch; }
	.hltab-groupbtn .hltabs-more-caret { font-size: 0.72em; opacity: 0.6; margin-left: 0.1rem; }
	.hltabs-crumb { opacity: 0.65; font-weight: 500; }
	.hltabs-crumb-sep { font-size: 0.65em; opacity: 0.5; margin: 0 0.2rem; }
	.hltabs-more.is-open .hltabs-more-caret, .hltabs-group.is-open .hltabs-more-caret { transform: rotate(180deg); }

	/* --- Overflow: scroll --- */
	.hltabs--scroll { flex-wrap: nowrap; overflow-x: auto; overflow-y: hidden; scrollbar-width: thin; -webkit-overflow-scrolling: touch; }
	.hltabs--scroll::-webkit-scrollbar { height: 6px; }
	.hltabs--scroll::-webkit-scrollbar-thumb { background: var(--theme-color-border-default, #d7dce3); border-radius: 3px; }

	/* --- Overflow: wrap --- */
	.hltabs--wrap { flex-wrap: wrap; }

	/* --- Overflow: menu (JS-managed; overflow-x clipped so a too-wide row never scrolls the page, overflow-y
	   visible so the "More"/group dropdowns can escape below the bar) --- */
	.hltabs--menu { flex-wrap: nowrap; overflow-x: clip; overflow-y: visible; }
	.hltabs-more { position: relative; flex: 0 0 auto; margin-left: auto; display: inline-flex; align-items: stretch; }
	.hltabs-more-btn { display: inline-flex; align-items: center; gap: 0.35rem; white-space: nowrap; cursor: pointer; border: none; background: transparent;
		font: inherit; font-size: 0.85rem; font-weight: 500; line-height: 1.2; color: var(--theme-color-text-secondary, #45505f);
		padding: 0.55rem 0.8rem; border-bottom: 2px solid transparent; margin-bottom: -1px; }
	.hltabs-more-btn:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-secondary, #f0f2f6); }
	.hltabs-more-btn.is-active { color: var(--theme-color-brand-primary, #5650e6); border-bottom-color: var(--theme-color-brand-primary, #5650e6); }
	.hltabs-more-btn .icon { font-size: 0.9em; opacity: 0.85; }
	.hltabs-more-caret { transition: transform 0.15s ease; }
	/* Dropdown panel — shared by "More" and group tabs. position:FIXED so it escapes the tab row's overflow-x:clip
	   (which contains the row) instead of being clipped by it; the runtime (_HLTabBar._position) sets top/left under
	   the trigger on open and clamps it into the viewport. */
	.hltabs-menu { position: fixed; top: 0; left: 0; z-index: 2000; min-width: 12rem; max-height: 70vh; overflow-y: auto;
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px;
		box-shadow: 0 8px 24px rgba(20, 27, 39, 0.14); padding: 0.3rem; display: none; }
	.hltabs-more.is-open > .hltabs-menu, .hltabs-group.is-open > .hltabs-menu { display: block; }
	.hltabs-menu-item { display: flex; width: 100%; align-items: center; gap: 0.55rem; white-space: nowrap; text-align: left; cursor: pointer;
		border: none; background: transparent; font: inherit; font-size: 0.85rem; color: var(--theme-color-text-secondary, #45505f); padding: 0.45rem 0.6rem; border-radius: 6px; }
	.hltabs-menu-item:hover { background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-primary, #1f2733); }
	.hltabs-menu-item.is-active { color: var(--theme-color-brand-primary, #5650e6); font-weight: 650; }
	.hltabs-menu-item .icon { font-size: 0.92em; opacity: 0.85; }
	/* Menu items always show their label, even when the bar itself is icon-only. */
	.hltabs-menu .hltab-label { position: static; width: auto; height: auto; overflow: visible; clip: auto; white-space: nowrap; }

	/* --- Display: icon-only (labels visually hidden for tabs that HAVE an icon, so nothing goes unlabelled) --- */
	.hltabs--icon-only .hltab.has-icon .hltab-label,
	.hltabs--icon-only .hltabs-more-label { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
	.hltabs--icon-only .hltab.has-icon { padding: 0.55rem 0.7rem; }

	/* --- Display: text-only --- */
	.hltabs--text-only .hltab .icon, .hltabs--text-only .hltabs-more-btn > .icon:first-child { display: none; }

	/* --- Folded group in the "More" menu: a small section label above the group's children (moved from the
	   group's own dropdown when the bar is too narrow to show the group inline). --- */
	.hltabs-menu-grouplabel { padding: 0.35rem 0.6rem 0.15rem; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); }
	.hltabs-menu-grouplabel:not(:first-child) { margin-top: 0.25rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); padding-top: 0.45rem; }
`;

const TABBAR_TEMPLATES =
[
	{
		// Each record carries its own pre-built HTML (leaf button OR group dropdown) — pict {~D:~} injects it raw.
		Hash: 'HL-TabBar-Item',
		Template: /*html*/`{~D:Record.HTML~}`
	}
];

function _escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
}

// --- HTML builders (shared by the pict-template path and the string path) --------------------------------

/** A leaf tab button. pExtraClass parks it in a pin zone (or is ''). */
function _leafHTML(pDef, pActiveKey, pOnClick, pExtraClass)
{
	const tmpIcon = pDef.Icon ? `<span class="icon"><i class="${ _escapeHTML(pDef.Icon) }"></i></span>` : '';
	const tmpActive = (String(pActiveKey) === String(pDef.Key)) ? 'is-active' : '';
	const tmpHasIcon = pDef.Icon ? 'has-icon' : '';
	const tmpExtra = pExtraClass ? (' ' + pExtraClass) : '';
	const tmpOnClick = (typeof pOnClick === 'function') ? pOnClick(pDef) : '';
	return `<button type="button" class="hltab ${ tmpActive } ${ tmpHasIcon }${ tmpExtra }" data-tabkey="${ _escapeHTML(pDef.Key) }" title="${ _escapeHTML(pDef.Label) }" onclick="${ tmpOnClick }">${ tmpIcon }<span class="hltab-label">${ _escapeHTML(pDef.Label) }</span></button>`;
}

/** One item inside a group's dropdown. */
function _menuItemHTML(pChild, pActiveKey, pOnClick)
{
	const tmpIcon = pChild.Icon ? `<span class="icon"><i class="${ _escapeHTML(pChild.Icon) }"></i></span>` : '';
	const tmpActive = (String(pActiveKey) === String(pChild.Key)) ? 'is-active' : '';
	const tmpOnClick = (typeof pOnClick === 'function') ? pOnClick(pChild) : '';
	return `<button type="button" class="hltabs-menu-item ${ tmpActive }" data-tabkey="${ _escapeHTML(pChild.Key) }" title="${ _escapeHTML(pChild.Label) }" onclick="${ tmpOnClick }">${ tmpIcon }<span class="hltab-label">${ _escapeHTML(pChild.Label) }</span></button>`;
}

/** A group (submenu) tab: a dropdown button + its menu. Active (and breadcrumbed) when one of its children is. */
function _groupHTML(pDef, pActiveKey, pOnClick, pExtraClass)
{
	const tmpChildren = Array.isArray(pDef.Children) ? pDef.Children : [];
	const tmpActiveChild = tmpChildren.find((pChild) => String(pChild.Key) === String(pActiveKey)) || null;
	const tmpIcon = pDef.Icon ? `<span class="icon"><i class="${ _escapeHTML(pDef.Icon) }"></i></span>` : '';
	const tmpHasIcon = pDef.Icon ? 'has-icon' : '';
	const tmpActive = tmpActiveChild ? 'is-active' : '';
	const tmpExtra = pExtraClass ? (' ' + pExtraClass) : '';
	// Active-child breadcrumb ("Group ▸ Child") on the group button; otherwise just the group label.
	const tmpLabelInner = tmpActiveChild
		? `<span class="hltabs-crumb">${ _escapeHTML(pDef.Label) }</span><i class="fas fa-angle-right hltabs-crumb-sep"></i>${ _escapeHTML(tmpActiveChild.Label) }`
		: _escapeHTML(pDef.Label);
	const tmpMenu = tmpChildren.map((pChild) => _menuItemHTML(pChild, pActiveKey, pOnClick)).join('');
	return `<div class="hltabs-group ${ tmpActive }${ tmpExtra }" data-groupkey="${ _escapeHTML(pDef.Key) }">`
		+ `<button type="button" class="hltab hltab-groupbtn ${ tmpActive } ${ tmpHasIcon }" title="${ _escapeHTML(pDef.Label) }" onclick="if(window._HLTabBar){window._HLTabBar.toggleGroup(this);}return false;">`
		+ `${ tmpIcon }<span class="hltab-label">${ tmpLabelInner }</span><span class="icon hltabs-more-caret"><i class="fas fa-chevron-down"></i></span>`
		+ `</button>`
		+ `<div class="hltabs-menu hltabs-group-menu">${ tmpMenu }</div>`
		+ `</div>`;
}

/** Full markup for one top-level item (leaf or group). */
function _itemHTML(pDef, pActiveKey, pOnClick, pExtraClass)
{
	if (pDef && Array.isArray(pDef.Children) && pDef.Children.length)
	{
		return _groupHTML(pDef, pActiveKey, pOnClick, pExtraClass);
	}
	return _leafHTML(pDef, pActiveKey, pOnClick, pExtraClass);
}

/** Stable-order top-level defs by pin zone (left → center → right); mark the first center/right item so CSS can
 *  open the flex gap. Returns [{ def, zoneClass }] in render order. */
function _orderByPin(pTabDefs)
{
	const tmpDefs = Array.isArray(pTabDefs) ? pTabDefs : [];
	const fRank = (pPin) => (pPin === 'right') ? 2 : ((pPin === 'center') ? 1 : 0);
	const tmpIndexed = tmpDefs.map((pDef, pIndex) => ({ def: pDef, index: pIndex, rank: fRank(pDef && pDef.Pin) }));
	tmpIndexed.sort((pA, pB) => (pA.rank - pB.rank) || (pA.index - pB.index));
	let tmpSeenCenter = false;
	let tmpSeenRight = false;
	return tmpIndexed.map((pEntry) =>
	{
		let tmpZoneClass = '';
		if ((pEntry.rank === 1) && !tmpSeenCenter) { tmpSeenCenter = true; tmpZoneClass = 'hltabs-zone-center'; }
		else if ((pEntry.rank === 2) && !tmpSeenRight) { tmpSeenRight = true; tmpZoneClass = 'hltabs-zone-right'; }
		return { def: pEntry.def, zoneClass: tmpZoneClass };
	});
}

/**
 * Shape tab definitions into the render records the shared item template consumes. Each record carries its
 * pre-built `HTML` (the item template injects it raw). Legacy fields (Label/Icon/…) are kept for any consumer
 * still referencing them, but the shared template only needs HTML.
 * @param {Array<{Key:String, Label:String, Icon?:String, Children?:Array, Pin?:String}>} pTabDefs
 * @param {String} pActiveKey - the currently-active tab's Key (may match a group's child).
 * @param {(pTab:Object)=>String} pOnClick - returns the onclick JS for a leaf/child tab (e.g. the host's setTab call).
 * @return {Array<Object>}
 */
function buildTabs(pTabDefs, pActiveKey, pOnClick)
{
	return _orderByPin(pTabDefs).map((pEntry) =>
	{
		const tmpDef = pEntry.def;
		const tmpIsGroup = !!(tmpDef && Array.isArray(tmpDef.Children) && tmpDef.Children.length);
		const tmpActive = tmpIsGroup
			? (tmpDef.Children.some((pChild) => String(pChild.Key) === String(pActiveKey)))
			: (String(pActiveKey) === String(tmpDef.Key));
		return {
			Key: tmpDef.Key,
			IsGroup: tmpIsGroup,
			HTML: _itemHTML(tmpDef, pActiveKey, pOnClick, pEntry.zoneClass),
			// Legacy fields (leaf only) — harmless for groups; retained for backward compatibility.
			Label: tmpDef.Label,
			Icon: tmpDef.Icon || '',
			ActiveClass: tmpActive ? 'is-active' : '',
			IconClass: tmpDef.Icon ? 'has-icon' : '',
			OnClick: (!tmpIsGroup && (typeof pOnClick === 'function')) ? pOnClick(tmpDef) : '',
		};
	});
}

/**
 * Build the container class string from options: { overflow: 'menu'|'wrap'|'scroll', display: 'both'|'icon'|'text' }.
 * @param {{overflow?:String, display?:String}} [pOptions]
 * @return {String}
 */
function containerClass(pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpClasses = [ 'hltabs' ];
	const tmpOverflow = tmpOptions.overflow || 'scroll';
	tmpClasses.push((tmpOverflow === 'menu') ? 'hltabs--menu' : (tmpOverflow === 'wrap') ? 'hltabs--wrap' : 'hltabs--scroll');
	if (tmpOptions.display === 'icon') { tmpClasses.push('hltabs--icon-only'); }
	else if (tmpOptions.display === 'text') { tmpClasses.push('hltabs--text-only'); }
	return tmpClasses.join(' ');
}

/**
 * Render a complete tab bar as an HTML STRING — for hosts that build their DOM as strings (plain providers)
 * rather than pict templates. Same tabs/options as buildTabs + containerClass. The onClick expression is a
 * controlled JS string (single-quoted), placed verbatim in the onclick attribute.
 * @param {Array} pTabDefs @param {String} pActiveKey @param {(pTab:Object)=>String} pOnClick
 * @param {{overflow?:String, display?:String}} [pOptions]
 * @return {String}
 */
function renderTabsHTML(pTabDefs, pActiveKey, pOnClick, pOptions)
{
	const tmpItems = _orderByPin(pTabDefs).map((pEntry) => _itemHTML(pEntry.def, pActiveKey, pOnClick, pEntry.zoneClass)).join('');
	return `<div class="${ containerClass(pOptions) }">${ tmpItems }</div>`;
}

// --- Runtime (browser): dropdown open/close (groups + "More") and the `menu` overflow partition -----------

/** Install the shared dropdown runtime (a single global so only one dropdown — group or More — is open at a
 *  time, with outside-click / scroll / Escape closing it) and the resize→relayout schedule. Idempotent. */
function _ensureRuntime()
{
	if (typeof window === 'undefined') { return null; }
	if (window._HLTabBar) { return window._HLTabBar; }
	const RT =
	{
		_open: null,
		close()
		{
			if (RT._open) { if (RT._open.classList) { RT._open.classList.remove('is-open'); } RT._open = null; }
		},
		toggle(pWrap)
		{
			if (!pWrap) { return; }
			const tmpWasOpen = pWrap.classList.contains('is-open');
			RT.close();
			if (!tmpWasOpen) { pWrap.classList.add('is-open'); RT._open = pWrap; RT._position(pWrap); }
		},
		toggleGroup(pButton) { RT.toggle((pButton && pButton.closest) ? pButton.closest('.hltabs-group') : null); },
		/** The dropdown is position:fixed so it escapes the tab row's overflow-x:clip (and never clips at the view
		 *  edge). Anchor it under its trigger: right-zone groups + the "More" menu right-align to the trigger's right
		 *  edge (they sit at the far right); everything else left-aligns. Then clamp into the viewport. It closes on
		 *  scroll/resize, so a single position on open is enough. */
		_position(pWrap)
		{
			const tmpMenu = pWrap.querySelector(':scope > .hltabs-menu');
			const tmpTrigger = pWrap.querySelector(':scope > button');
			if (!tmpMenu || !tmpTrigger) { return; }
			const tmpRect = tmpTrigger.getBoundingClientRect();
			const tmpViewport = document.documentElement.clientWidth;
			const tmpMargin = 8;
			tmpMenu.style.top = Math.round(tmpRect.bottom + 3) + 'px';
			const tmpWidth = tmpMenu.offsetWidth;   // measured now that .is-open made it display:block
			const tmpRightAlign = pWrap.classList.contains('hltabs-zone-right') || pWrap.classList.contains('hltabs-more');
			let tmpLeft = tmpRightAlign ? (tmpRect.right - tmpWidth) : tmpRect.left;
			if ((tmpLeft + tmpWidth) > (tmpViewport - tmpMargin)) { tmpLeft = tmpViewport - tmpMargin - tmpWidth; }
			if (tmpLeft < tmpMargin) { tmpLeft = tmpMargin; }
			tmpMenu.style.left = Math.round(tmpLeft) + 'px';
			tmpMenu.style.right = 'auto';
		},
	};
	window._HLTabBar = RT;
	let tmpScheduled = false;
	const fSchedule = () =>
	{
		if (tmpScheduled) { return; }
		tmpScheduled = true;
		window.requestAnimationFrame(() => { tmpScheduled = false; layout(); });
	};
	window.addEventListener('resize', fSchedule);
	document.addEventListener('click', (pEvent) => { if (RT._open && !RT._open.contains(pEvent.target)) { RT.close(); } }, true);
	window.addEventListener('scroll', () => { if (RT._open) { RT.close(); } }, true);
	document.addEventListener('keydown', (pEvent) => { if (pEvent.key === 'Escape') { RT.close(); } });
	return RT;
}

function _buildMenuItemFromTab(pTab)
{
	const tmpItem = document.createElement('button');
	tmpItem.type = 'button';
	tmpItem.className = 'hltabs-menu-item';
	tmpItem.innerHTML = pTab.innerHTML;   // icon + label, cloned from the tab
	if (pTab.classList.contains('is-active')) { tmpItem.classList.add('is-active'); }
	tmpItem.addEventListener('click', () => { const tmpRT = _ensureRuntime(); if (tmpRT) { tmpRT.close(); } pTab.click(); });
	return tmpItem;
}

function _buildMore()
{
	const tmpWrap = document.createElement('div');
	tmpWrap.className = 'hltabs-more';
	const tmpButton = document.createElement('button');
	tmpButton.type = 'button';
	tmpButton.className = 'hltabs-more-btn';
	tmpButton.setAttribute('title', 'More tabs');
	tmpButton.innerHTML = '<span class="icon"><i class="fas fa-ellipsis"></i></span><span class="hltabs-more-label">More</span><span class="icon hltabs-more-caret"><i class="fas fa-chevron-down"></i></span>';
	tmpButton.addEventListener('click', (pEvent) => { pEvent.stopPropagation(); const tmpRT = _ensureRuntime(); if (tmpRT) { tmpRT.toggle(tmpWrap); } });
	const tmpMenu = document.createElement('div');
	tmpMenu.className = 'hltabs-menu';
	tmpWrap.appendChild(tmpButton);
	tmpWrap.appendChild(tmpMenu);
	return tmpWrap;
}

/** Move a folded top-level item into the "More" menu. A leaf becomes one menu item; a GROUP becomes a small
 *  section label + its child items (cloned from the group's own dropdown so their inline-onclick navigation is
 *  preserved), so the whole group stays reachable from More. */
function _appendFoldedToMenu(pItem, pMenu)
{
	if (pItem.classList.contains('hltabs-group'))
	{
		const tmpButton = pItem.querySelector(':scope > .hltab-groupbtn');
		const tmpLabel = document.createElement('div');
		tmpLabel.className = 'hltabs-menu-grouplabel';
		tmpLabel.textContent = (tmpButton && tmpButton.getAttribute('title')) || '';
		pMenu.appendChild(tmpLabel);
		const tmpChildren = pItem.querySelectorAll(':scope > .hltabs-group-menu > .hltabs-menu-item');
		Array.prototype.forEach.call(tmpChildren, (pChild) =>
		{
			const tmpClone = pChild.cloneNode(true);   // inline onclick (navigation) survives the clone
			tmpClone.addEventListener('click', () => { const tmpRT = _ensureRuntime(); if (tmpRT) { tmpRT.close(); } });
			pMenu.appendChild(tmpClone);
		});
	}
	else
	{
		pMenu.appendChild(_buildMenuItemFromTab(pItem));
	}
}

/** Partition one `.hltabs--menu` bar: when the tabs don't all fit, collapse the overflowing ones into a "More ▾"
 *  dropdown — LEAVES and GROUPS alike (a folded group lists its children under a label in the menu). The active
 *  tab is never folded; folding runs over the rest right-to-left (the left-cluster groups first, then the pinned
 *  zone last) until the row fits. Fit is tested by SUM-OF-WIDTHS, not element positions: a pinned (margin-left:auto)
 *  item sits at the right edge and its leading gap is empty slack, so a position-based test would falsely read
 *  "overflowing" forever; summing widths ignores where the auto-margin distributes that slack. */
function _layoutMenuBar(pBar)
{
	const tmpRT = _ensureRuntime();
	if (tmpRT) { tmpRT.close(); }
	const tmpPriorMore = pBar.querySelector(':scope > .hltabs-more');
	if (tmpPriorMore) { pBar.removeChild(tmpPriorMore); }
	// Top-level items = leaf tabs (.hltab, but NOT the group buttons which are .hltab inside .hltabs-group) + groups.
	const tmpItems = Array.prototype.filter.call(pBar.children, (pChild) => pChild.classList
		&& (pChild.classList.contains('hltabs-group') || (pChild.classList.contains('hltab') && !pChild.classList.contains('hltab-groupbtn'))));
	tmpItems.forEach((pItem) => pItem.classList.remove('is-overflow'));
	if (tmpItems.length === 0) { return; }
	const tmpAvailable = pBar.clientWidth;
	if (tmpAvailable <= 0) { return; }   // not laid out yet — a later render/resize will fix it

	let tmpGap = parseFloat(getComputedStyle(pBar).columnGap || getComputedStyle(pBar).gap || '0');
	if (!(tmpGap >= 0)) { tmpGap = 0; }
	const tmpWidths = tmpItems.map((pItem) => pItem.offsetWidth);
	const tmpOverflow = new Set();
	// Total row width for the currently-visible items (+ the More button when present). Auto-margins only add
	// empty slack, so sum-of-widths ≤ clientWidth is the true "fits" test.
	const fFits = (pMoreW) =>
	{
		let tmpCount = 0;
		let tmpWidth = 0;
		for (let i = 0; i < tmpItems.length; i++) { if (!tmpOverflow.has(i)) { tmpWidth += tmpWidths[i]; tmpCount++; } }
		if (pMoreW > 0) { tmpWidth += pMoreW; tmpCount++; }
		return (tmpWidth + tmpGap * Math.max(0, tmpCount - 1)) <= (tmpAvailable + 1);
	};
	if (fFits(0)) { return; }   // it all fits — no "More"

	// Build "More" and park it at the END of the left cluster (before the first pinned item), so a right-pinned
	// tab stays pinned right and "More" reads where the folded tabs used to be.
	const fIsZoned = (pItem) => pItem.classList.contains('hltabs-zone-right') || pItem.classList.contains('hltabs-zone-center');
	const tmpMore = _buildMore();
	const tmpFirstZoned = tmpItems.find((pItem) => fIsZoned(pItem));
	if (tmpFirstZoned)
	{
		// Park "More" at the end of the left cluster, before the pinned item. `.hltabs-more` carries
		// margin-left:auto (which pushes it right when it's the LAST child); cancel it here so it doesn't fight the
		// pinned item's own auto-margin and get shoved off the right edge — the pinned item still floats right.
		tmpMore.style.marginLeft = '0';
		pBar.insertBefore(tmpMore, tmpFirstZoned);
	}
	else { pBar.appendChild(tmpMore); }
	const tmpMoreW = tmpMore.offsetWidth;
	const tmpMenu = tmpMore.querySelector('.hltabs-menu');

	// Fold order: right-to-left over the left-cluster items first (the ones that squeeze), then the pinned
	// (center/right-zone) items last, and NEVER the active tab.
	const tmpLeft = [];
	const tmpZoned = [];
	tmpItems.forEach((pItem, pIndex) => { (fIsZoned(pItem) ? tmpZoned : tmpLeft).push(pIndex); });
	const tmpFoldOrder = tmpLeft.slice().reverse().concat(tmpZoned.slice().reverse())
		.filter((pIndex) => !tmpItems[pIndex].classList.contains('is-active'));

	for (let i = 0; (i < tmpFoldOrder.length) && !fFits(tmpMoreW); i++)
	{
		const tmpIndex = tmpFoldOrder[i];
		tmpOverflow.add(tmpIndex);
		tmpItems[tmpIndex].classList.add('is-overflow');
		_appendFoldedToMenu(tmpItems[tmpIndex], tmpMenu);
	}
	if (!tmpMenu.children.length) { pBar.removeChild(tmpMore); }
}

/**
 * (Re)partition every `.hltabs--menu` bar under pRoot and ensure the dropdown runtime is bound. Hosts call this
 * from onAfterRender. No overflow work for scroll/wrap bars (pure CSS) — but it still installs the runtime.
 * @param {Document|Element} [pRoot]
 */
function layout(pRoot)
{
	if (typeof document === 'undefined') { return; }
	_ensureRuntime();
	const tmpRoot = pRoot || document;
	const tmpBars = tmpRoot.querySelectorAll ? tmpRoot.querySelectorAll('.hltabs--menu') : [];
	Array.prototype.forEach.call(tmpBars, (pBar) => _layoutMenuBar(pBar));
}

// Install the dropdown runtime as soon as the module loads in a browser, so group tabs toggle even for hosts
// that never call layout() (e.g. scroll/wrap plain-provider bars).
_ensureRuntime();

module.exports = { TABBAR_CSS, TABBAR_TEMPLATES, buildTabs, containerClass, renderTabsHTML, layout };

},{}],300:[function(require,module,exports){
/**
 * pict-section-theme — entry point.
 *
 * Bundles every Retold-ecosystem theme and exposes five reusable views:
 *
 *   - Theme-Picker      : a custom dropdown listing every registered theme,
 *                         grouped by category, with inline SVG mode-glyphs.
 *                         Switches the active theme on change.
 *   - Theme-ModeToggle  : a 3-button toggle for Light / Dark / System mode.
 *                         Disables itself when the active theme is single-mode.
 *   - Theme-ScaleSelect : a dropdown of viewport scale presets (75% – 200%).
 *                         Independent of theme bundles — applied via CSS
 *                         `zoom` on <html> + a `--theme-scale` custom prop.
 *   - Theme-Button      : an embeddable SVG topbar button that, when clicked,
 *                         opens a pict-section-modal containing the picker,
 *                         the mode toggle, and the scale select. Designed to
 *                         drop into any application chrome.
 *   - Theme-BrandStrip  : the per-app brand signature (icon + name + two
 *                         color stripes). Driven by libThemeBrand which the
 *                         host configures via the `Brand` option.
 *
 * # Recommended consumption (Pict provider)
 *
 * Add the section as a Pict provider — it self-bootstraps on construction:
 *
 *     const libPictSectionTheme = require('pict-section-theme');
 *
 *     pict.addProvider('Theme-Section',
 *     {
 *         ApplyDefault: 'retold-default',
 *         DefaultMode:  'system',
 *         DefaultScale: 1.0,
 *         Brand:        libRetoldManagerBrand
 *     }, libPictSectionTheme);
 *
 * That single addProvider call:
 *   - Ensures `pict.providers.Theme` (the underlying pict-provider-theme
 *     runtime) exists.
 *   - Registers every theme in the runtime registry — bundled starter set
 *     plus anything the host registered via `Catalog.register()`.
 *   - Adds Theme-Picker / Theme-ModeToggle / Theme-ScaleSelect /
 *     Theme-Button / Theme-BrandStrip to `pict.views[...]`.
 *   - Hydrates persisted choices from localStorage; otherwise applies the
 *     supplied `ApplyDefault` / `DefaultMode` / `DefaultScale`.
 *   - Wires the `onApply` save handler so subsequent user picks persist.
 *   - Applies the supplied Brand block if one was provided.
 *
 * # Runtime theme registration
 *
 * The bundled starter set lives in `themes/_catalog.js`. To add custom
 * themes (e.g. a host app's own brand palette, or a remote bundle from
 * a "theme garden") use the registry:
 *
 *     const libCatalog = require('pict-section-theme').Catalog;
 *     libCatalog.register({ Hash: 'my-theme', Bundle: require('./mine.json'), Category: 'App' });
 *     // Or, async, from a URL:
 *     await libCatalog.registerFromURL('https://garden.example.com/themes/foo.json');
 *
 * Themes registered before `addProvider()` runs are picked up
 * automatically. Themes registered after must be manually pushed via
 * `pict.providers.Theme.registerTheme(bundle)`.
 *
 * # Persistence
 *
 * Persisting active theme + mode + scale to localStorage is on by
 * default. Storage key is scoped to `window.location.hostname` so apps
 * on different hosts keep independent state. Override with
 * `PersistenceKey: 'my-app'`. Pass `Persistence: false` to disable.
 *
 * A saved entry takes precedence over `ApplyDefault` — once a user has
 * picked a theme, reloads honour that pick instead of the host's
 * default. If the saved theme hash is no longer in the registry (theme
 * removed, app downgraded), the bootstrap falls back to `ApplyDefault`
 * cleanly.
 *
 * # Legacy API
 *
 * `install(pict, options)` and `registerCatalog(pict)` are still
 * exported as thin shims that delegate to the provider — existing apps
 * keep working without changes.
 */

'use strict';

const libPictProvider = require('pict-provider');
const libPictProviderTheme = require('pict-provider-theme');

const libPickerView = require('./views/PictView-Theme-Picker.js');
const libModeToggleView = require('./views/PictView-Theme-ModeToggle.js');
const libScaleSelectView = require('./views/PictView-Theme-ScaleSelect.js');
const libButtonView = require('./views/PictView-Theme-Button.js');
const libBrandStripView = require('./views/PictView-Theme-BrandStrip.js');
const libBrandMarkView = require('./views/PictView-Theme-Brand-Mark.js');
const libTopBarView = require('./views/PictView-Theme-TopBar.js');
const libBottomBarView = require('./views/PictView-Theme-BottomBar.js');

const libThemePersistence = require('./Theme-Persistence.js');
const libThemeScale = require('./Theme-Scale.js');
const libThemeBrand = require('./Theme-Brand.js');
// Theme-Logo (the deterministic name → SVG generator) is intentionally
// NOT required here. It's a build-time tool used by
// `pict-section-theme-brand` to precompute brand blocks into a host's
// package.json — there's no reason for it to ride along in the runtime
// bundle every host ships. Hosts that want runtime generation can
// `require('pict-section-theme/source/Theme-Logo.js')` directly; that
// keeps the import explicit and the cost opt-in.

const libCatalog = require('./themes/_catalog.js');

// View registry: short-name → { lib, hash } where hash is the
// ViewIdentifier the view registers under in pict.views[...].
const _Views =
{
	Picker:      { lib: libPickerView,      hash: 'Theme-Picker' },
	ModeToggle:  { lib: libModeToggleView,  hash: 'Theme-ModeToggle' },
	ScaleSelect: { lib: libScaleSelectView, hash: 'Theme-ScaleSelect' },
	Button:      { lib: libButtonView,      hash: 'Theme-Button' },
	BrandStrip:  { lib: libBrandStripView,  hash: 'Theme-BrandStrip' },
	BrandMark:   { lib: libBrandMarkView,   hash: 'Theme-Brand-Mark' },
	TopBar:      { lib: libTopBarView,      hash: 'Theme-TopBar' },
	BottomBar:   { lib: libBottomBarView,   hash: 'Theme-BottomBar' }
};

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme-Section',

	// Don't auto-fire the standard pict-provider initialize chain — we do
	// our setup work synchronously in the constructor so consumers can
	// use the views immediately after addProvider() returns.
	AutoInitialize: false,

	// Bootstrap config — same shape as the legacy install() options.
	ApplyDefault:    null,    // theme hash to apply at boot
	DefaultMode:     null,    // 'light' | 'dark' | 'system' | null (theme's default)
	DefaultScale:    null,    // 0.75 .. 2.0 — viewport scale
	Persistence:     true,
	PersistenceKey:  null,    // null → window.location.hostname
	RegisterCatalog: true,
	Views:           null,    // null → all views; or array of short-names
	ViewOptions:     null,    // { Picker: { ... }, ... } per-view overrides
	Brand:           null,    // { Name, Icon, Colors: { Primary, ... } }
	ProviderOptions: null     // pict-provider-theme overrides if a host wants them
};

// ── Helpers ──────────────────────────────────────────────────────────────

/**
 * Iterate the runtime registry and call provider.registerTheme() for each
 * entry. Safe to call before or after addProvider — the runtime's
 * registerTheme is idempotent on repeat hashes.
 *
 * @param {object} pPict - a Pict instance with the Theme runtime attached
 * @returns {number} count of themes registered
 */
function registerCatalog(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers.Theme)
	{
		if (pPict && pPict.log && pPict.log.warn)
		{
			pPict.log.warn('pict-section-theme.registerCatalog: pict.providers.Theme not found — register the runtime first');
		}
		return 0;
	}
	let tmpProvider = pPict.providers.Theme;
	let tmpEntries = libCatalog.list();
	let tmpCount = 0;
	for (let i = 0; i < tmpEntries.length; i++)
	{
		if (tmpProvider.registerTheme(tmpEntries[i].Bundle))
		{
			tmpCount++;
		}
	}
	return tmpCount;
}

/**
 * Return the registry as picker-friendly metadata (no Bundle payload).
 *
 * @returns {Array<{Hash, Name, Category, Strategy, DefaultMode, IsDefault}>}
 */
function listCatalog()
{
	let tmpEntries = libCatalog.list();
	let tmpList = [];
	for (let i = 0; i < tmpEntries.length; i++)
	{
		let tmpEntry = tmpEntries[i];
		let tmpBundle = tmpEntry.Bundle || {};
		let tmpModes = tmpBundle.Modes || {};
		tmpList.push(
		{
			Hash: tmpEntry.Hash,
			Name: tmpBundle.Name || tmpEntry.Hash,
			Category: tmpEntry.Category || 'Other',
			Strategy: tmpModes.Strategy || 'single',
			DefaultMode: tmpModes.Default || 'light',
			IsDefault: !!tmpEntry.IsDefault
		});
	}
	return tmpList;
}

// Resolve the canonical fallback theme hash from the catalog: the entry
// flagged IsDefault, or — if no entry is flagged — the first registered
// entry, or null if the catalog is empty. Used as the last-resort boot
// theme when nothing else resolved (no ApplyDefault, no saved state, or
// a saved hash that's been removed from the catalog).
function _resolveCatalogDefault()
{
	let tmpEntries = libCatalog.list();
	if (!tmpEntries || tmpEntries.length === 0) return null;
	for (let i = 0; i < tmpEntries.length; i++)
	{
		if (tmpEntries[i].IsDefault) return tmpEntries[i].Hash;
	}
	return tmpEntries[0].Hash;
}

// ── Bootstrap routine ────────────────────────────────────────────────────
// Shared between the provider class (new path) and the install() function
// (legacy path). Performs the actual wiring against a Pict instance.
function _bootstrap(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme: requires a Pict instance');
	}
	let tmpOptions = pOptions || {};

	// 1. Theme runtime — only add if not already attached (hosts with
	//    a custom runtime, e.g. retold-remote's V2 bridge, pre-register).
	if (!pPict.providers || !pPict.providers.Theme)
	{
		let tmpRuntimeOpts = Object.assign({},
			libPictProviderTheme.default_configuration, tmpOptions.ProviderOptions || {});
		pPict.addProvider('Theme', tmpRuntimeOpts, libPictProviderTheme);
	}

	// 2. Catalog — every entry from the runtime registry, unless the host
	//    asked to skip (RegisterCatalog: false).
	if (tmpOptions.RegisterCatalog !== false)
	{
		registerCatalog(pPict);
	}

	// 3. Views — default all five; pass an array to subset.
	let tmpViewNames = Array.isArray(tmpOptions.Views) ? tmpOptions.Views : Object.keys(_Views);
	for (let i = 0; i < tmpViewNames.length; i++)
	{
		let tmpEntry = _Views[tmpViewNames[i]];
		if (!tmpEntry)
		{
			if (pPict.log && pPict.log.warn)
			{
				pPict.log.warn('pict-section-theme: unknown view name "' + tmpViewNames[i] + '" — skipped');
			}
			continue;
		}
		if (pPict.views && pPict.views[tmpEntry.hash])
		{
			// Already registered — skip silently.
			continue;
		}
		let tmpViewOpts = Object.assign({},
			tmpEntry.lib.default_configuration,
			(tmpOptions.ViewOptions && tmpOptions.ViewOptions[tmpViewNames[i]]) || {});
		pPict.addView(tmpEntry.hash, tmpViewOpts, tmpEntry.lib);
	}

	// 4. Persistence + initial apply.
	let tmpProvider = pPict.providers.Theme;
	let tmpPersistenceEnabled = (tmpOptions.Persistence !== false);
	let tmpPersistenceKey = null;

	let tmpBootHash  = tmpOptions.ApplyDefault || null;
	let tmpBootMode  = tmpOptions.DefaultMode  || null;
	let tmpBootScale = (typeof tmpOptions.DefaultScale === 'number') ? tmpOptions.DefaultScale : null;

	if (tmpPersistenceEnabled && tmpProvider)
	{
		tmpPersistenceKey = libThemePersistence.resolveKey(tmpOptions.PersistenceKey);

		let tmpSaved = libThemePersistence.load(tmpPersistenceKey);
		if (tmpSaved
			&& tmpSaved.ThemeHash
			&& typeof tmpProvider.getTheme === 'function'
			&& tmpProvider.getTheme(tmpSaved.ThemeHash))
		{
			tmpBootHash = tmpSaved.ThemeHash;
			if (tmpSaved.Mode)  { tmpBootMode  = tmpSaved.Mode; }
			if (tmpSaved.Scale) { tmpBootScale = tmpSaved.Scale; }
		}
		else if (tmpSaved && tmpSaved.Scale)
		{
			tmpBootScale = tmpSaved.Scale;
		}

		// Single save snapshot — both the provider listener and the scale
		// listener call this so any change persists the full set.
		let tmpSaveCurrent = function ()
		{
			let tmpActive = (typeof tmpProvider.getActiveTheme === 'function')
				? tmpProvider.getActiveTheme() : { Hash: null, Mode: null };
			libThemePersistence.save(tmpPersistenceKey,
			{
				ThemeHash: tmpActive.Hash,
				Mode:      tmpActive.Mode,
				Scale:     libThemeScale.getActive()
			});
		};

		tmpProvider.onApply(tmpSaveCurrent);
		libThemeScale.onChange(tmpSaveCurrent);
	}

	// If nothing resolved a theme hash (no ApplyDefault, no saved state, or
	// a saved hash that's no longer in the registry), fall back to the
	// catalog's canonical default (IsDefault: true) so the host always
	// boots with CSS variables populated. Without this fallback an app
	// configured without ApplyDefault — or one whose ApplyDefault hash
	// was removed — paints unstyled (token references resolve to their
	// inline fallback colors, which are intentionally bland) until the
	// user manually picks something from the picker.
	if (tmpProvider && (!tmpBootHash || (typeof tmpProvider.getTheme === 'function' && !tmpProvider.getTheme(tmpBootHash))))
	{
		let tmpFallback = _resolveCatalogDefault();
		if (tmpFallback)
		{
			tmpBootHash = tmpFallback;
			if (pPict.log && pPict.log.info)
			{
				pPict.log.info('pict-section-theme: no theme resolved at boot — falling back to catalog default "' + tmpFallback + '"');
			}
		}
	}

	if (tmpBootHash && tmpProvider)
	{
		tmpProvider.applyTheme(tmpBootHash, tmpBootMode);
	}
	if (tmpBootScale !== null)
	{
		libThemeScale.applyScale(tmpBootScale);
	}

	// 5. Brand — host-supplied app identity. Apply LAST so the BrandStrip
	//    view's first paint sees the CSS custom properties.
	if (tmpOptions.Brand)
	{
		libThemeBrand.applyBrand(tmpOptions.Brand);
	}

	// Stash the resolved key on the provider for debugging + so the host
	// can clear it via clearPersistence() for a "reset to defaults"
	// affordance.
	if (tmpProvider && tmpPersistenceKey)
	{
		tmpProvider._persistenceKey = tmpPersistenceKey;
	}

	return tmpProvider;
}

// ── PictProvider class ───────────────────────────────────────────────────
// The recommended entry point. `pict.addProvider('Theme-Section',
// options, PictSectionThemeProvider)` self-bootstraps the whole module
// (runtime + catalog + views + persistence + apply + brand) inside the
// constructor — no follow-up install() call required.
class PictSectionThemeProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictSectionTheme';

		// pict-provider sets `this.pict` for us via super() above. Run the
		// bootstrap synchronously so the views, theme runtime, and applied
		// theme are all in place before addProvider() returns.
		_bootstrap(this.pict, this.options);
	}

	/**
	 * Embed theme controls into a host-supplied container.
	 *
	 * The Theme-Button view ships a popover that hosts the picker + mode
	 * toggle + scale select — convenient for "drop a theme menu in the
	 * topbar" but not for apps that already have a settings surface and
	 * want the controls inline there. `mount()` writes the destination
	 * divs each theme view expects into the supplied container, then
	 * calls render() on each requested view.
	 *
	 * Important: each theme view has a SINGLE default destination id
	 * (e.g. `#Theme-Picker`). Mounting overrides where the view paints —
	 * once mount() is called, the picker / toggle / scale destinations
	 * live inside the supplied container. Combining a mount() with a
	 * Theme-Button popover that ALSO hosts these views causes duplicate
	 * destination ids and undefined behaviour; pick one host per view.
	 *
	 * @param {object} pOptions
	 * @param {string|HTMLElement} pOptions.Container - CSS selector or element
	 * @param {Array<string>} [pOptions.Views] - short names; default ['Picker','ModeToggle','ScaleSelect']
	 * @param {string} [pOptions.WrapperClass] - class added to the outer wrapper div
	 * @returns {object|null} { container, viewsRendered } on success, null if the container can't be resolved
	 */
	mount(pOptions)
	{
		let tmpOpts = pOptions || {};
		let tmpContainer = tmpOpts.Container;
		if (!tmpContainer) { return null; }
		let tmpEl = (typeof tmpContainer === 'string')
			? (this.pict && this.pict.ContentAssignment
				? this.pict.ContentAssignment.getElement(tmpContainer)
				: document.querySelector(tmpContainer))
			: tmpContainer;
		// ContentAssignment.getElement returns an array-like; normalise to one node.
		if (tmpEl && tmpEl.length && !tmpEl.tagName) { tmpEl = tmpEl[0]; }
		if (!tmpEl)
		{
			if (this.pict && this.pict.log && this.pict.log.warn)
			{
				this.pict.log.warn('pict-section-theme.mount: container not found for ' + tmpContainer);
			}
			return null;
		}

		let tmpRequested = Array.isArray(tmpOpts.Views) && tmpOpts.Views.length
			? tmpOpts.Views
			: ['Picker', 'ModeToggle', 'ScaleSelect'];

		// Build a wrapper that carries one row per requested view; each row
		// contains the destination div the view's render() will write into.
		let tmpRows = [];
		let tmpRendered = [];
		for (let i = 0; i < tmpRequested.length; i++)
		{
			let tmpEntry = _Views[tmpRequested[i]];
			if (!tmpEntry) { continue; }
			let tmpDestSel = tmpEntry.lib.default_configuration.DefaultDestinationAddress || '';
			let tmpDestId = tmpDestSel.replace(/^#/, '');
			if (!tmpDestId) { continue; }
			tmpRows.push(
				'<div class="pict-theme-mount-row pict-theme-mount-row-' + tmpEntry.hash.toLowerCase() + '">'
					+ '<div id="' + tmpDestId + '"></div>'
				+ '</div>');
			tmpRendered.push(tmpEntry.hash);
		}

		let tmpWrapperClass = 'pict-theme-mount' + (tmpOpts.WrapperClass ? ' ' + tmpOpts.WrapperClass : '');
		tmpEl.innerHTML = '<div class="' + tmpWrapperClass + '">' + tmpRows.join('') + '</div>';

		// Render each requested view. Each render() targets the destination
		// id we just stamped into the wrapper.
		for (let i = 0; i < tmpRendered.length; i++)
		{
			let tmpView = this.pict.views[tmpRendered[i]];
			if (tmpView && typeof tmpView.render === 'function')
			{
				try { tmpView.render(); }
				catch (pErr) { /* a view render failure shouldn't break the host */ }
			}
		}

		return { container: tmpEl, viewsRendered: tmpRendered };
	}
}

// ── Legacy install() ─────────────────────────────────────────────────────
// Thin shim for apps that already call install(); delegates to the same
// bootstrap routine the provider runs.
function install(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme.install: first arg must be a Pict instance');
	}
	return _bootstrap(pPict, pOptions || {});
}

/**
 * Drop the saved theme state for this app's storage key. The next
 * install() (or page reload / addProvider) falls back to ApplyDefault.
 *
 * @param {object} pPict - the pict instance
 * @returns {boolean} true if anything was cleared
 */
function clearPersistence(pPict)
{
	let tmpKey = (pPict && pPict.providers && pPict.providers.Theme && pPict.providers.Theme._persistenceKey)
		|| libThemePersistence.resolveKey(null);
	return libThemePersistence.clear(tmpKey);
}

// ── Exports ──────────────────────────────────────────────────────────────
// Default export = the provider class so apps can do:
//   pict.addProvider('Theme-Section', { ... }, libPictSectionTheme);
//
// Named exports preserved so legacy callers keep working unchanged.
module.exports = PictSectionThemeProvider;
module.exports.default_configuration = _ProviderConfiguration;

module.exports.Provider = libPictProviderTheme;             // the runtime class
module.exports.PictSectionThemeProvider = PictSectionThemeProvider;
module.exports.PickerView = libPickerView;
module.exports.ModeToggleView = libModeToggleView;
module.exports.ButtonView = libButtonView;
module.exports.ScaleSelectView = libScaleSelectView;
module.exports.BrandStripView = libBrandStripView;
module.exports.BrandMarkView = libBrandMarkView;
module.exports.TopBarView = libTopBarView;
module.exports.BottomBarView = libBottomBarView;
module.exports.Catalog = libCatalog;                        // the registry singleton
module.exports.Brand = libThemeBrand;                       // the brand helper module
module.exports.Scale = libThemeScale;                       // the scale helper module
module.exports.Persistence = libThemePersistence;           // the persistence helper module
// Theme-Logo is exposed as a sub-module path, not a top-level field —
// see the comment near the imports above.
module.exports.registerCatalog = registerCatalog;
module.exports.listCatalog = listCatalog;
module.exports.install = install;
module.exports.clearPersistence = clearPersistence;

},{"./Theme-Brand.js":301,"./Theme-Persistence.js":303,"./Theme-Scale.js":304,"./themes/_catalog.js":308,"./views/PictView-Theme-BottomBar.js":350,"./views/PictView-Theme-Brand-Mark.js":351,"./views/PictView-Theme-BrandStrip.js":352,"./views/PictView-Theme-Button.js":353,"./views/PictView-Theme-ModeToggle.js":354,"./views/PictView-Theme-Picker.js":355,"./views/PictView-Theme-ScaleSelect.js":356,"./views/PictView-Theme-TopBar.js":357,"pict-provider":177,"pict-provider-theme":170}],301:[function(require,module,exports){
/**
 * Theme-Brand — app-level brand identity (icon + colors) that overlays
 * the active theme.
 *
 * # What this is for
 *
 * The active *theme* describes how UI surfaces look (panel colors,
 * borders, text, status). The active *brand* describes which APP the
 * user is in. retold-facto, retold-manager, and ultravisor can share
 * the same theme but each carries its own visual signature: a small
 * icon and two brand colors that show up in a stripe under the nav
 * (and optionally tinge link underlines, header accents, etc. when
 * the active theme opts to reference them).
 *
 * Brand is host-supplied (passed to pict-section-theme.install() as
 * `Brand: {...}` or applied later via this module's `applyBrand()`)
 * and NOT user-pickable — it's the app's wordmark. It's also not
 * persisted; the host config drives it on every boot.
 *
 * # Brand shape
 *
 * Two equivalent forms — pick whichever reads better in your app.
 *
 * ## Recommended: nested form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:   { Light: '#0044cc', Dark: '#6b8eff' },   // both required
 *       Secondary: { Light: '#c75033', Dark: '#ff8a6b' }    // both required
 *     },
 *     Tagline: 'Optional short tagline'
 *   }
 *
 * This mirrors how theme JSONs already structure their Tokens.Color.*
 * trees, makes the "explicit light + dark variants" contract obvious,
 * and means your brand and your theme look consistent in source.
 *
 * ## Legacy: flat form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:        '#0066ff',                // required
 *       Secondary:      '#ff6600',                // required
 *       PrimaryLight:   '#3388ff',                // optional, light-mode tint
 *       PrimaryDark:    '#0044cc',                // optional, dark-mode tint
 *       SecondaryLight: '#ff8833',
 *       SecondaryDark:  '#cc4400'
 *     }
 *   }
 *
 * The flat form's `Primary` / `Secondary` are mode-agnostic constants
 * (used for the `--brand-color-primary` / `-secondary` CSS variables);
 * the *Light / *Dark fields drive the mode-aware variants. When the
 * Light / Dark fields are omitted, the base Primary / Secondary
 * doubles for both modes. Both forms land on the same six output CSS
 * variables — see "CSS variables emitted" below.
 *
 * Icon shape: inline SVG markup, OR a data URL, OR a remote / app-served
 * URL. IconType is optional and auto-detected from the value.
 *
 * # CSS variables emitted
 *
 *   :root {
 *     --brand-color-primary:           <Primary>
 *     --brand-color-secondary:         <Secondary>
 *     --brand-color-primary-light:     <PrimaryLight or Primary>
 *     --brand-color-primary-dark:      <PrimaryDark or Primary>
 *     --brand-color-secondary-light:   <SecondaryLight or Secondary>
 *     --brand-color-secondary-dark:    <SecondaryDark or Secondary>
 *     --brand-color-primary-mode:      <Primary OR PrimaryLight in :root>
 *     --brand-color-secondary-mode:    <Secondary OR SecondaryLight in :root>
 *     --brand-name:                    "<Name>"
 *   }
 *   .theme-dark {
 *     --brand-color-primary-mode:      <PrimaryDark or Primary>
 *     --brand-color-secondary-mode:    <SecondaryDark or Secondary>
 *   }
 *
 * The `*-mode` variables are the ones theme/host CSS should reach for
 * when they want a brand color that automatically swaps for dark mode
 * (parallel to how --theme-color-* works). The plain Primary/Secondary
 * are constants that ignore the mode toggle — useful for the brand
 * stripe itself, where the brand should look the same in both modes.
 *
 * # Listener pattern
 *
 * Mirrors Theme-Scale: subscribe via `onBrandChange(cb)`, dispose by
 * calling the returned function. The BrandStrip view uses this to
 * re-render when the host changes brand at runtime (rare, but used by
 * test harnesses + multi-tenant hosts).
 */

const STYLE_ELEMENT_ID = 'pict-brand';
const FAVICON_LINK_ID = 'pict-brand-favicon';
const FAVICON_DARK_LINK_ID = 'pict-brand-favicon-dark';

let _activeBrand = null;
let _listeners = [];

function _isInlineSVG(pIcon)
{
	return (typeof pIcon === 'string') && /^\s*<svg[\s>]/i.test(pIcon);
}

function _isImageURL(pIcon)
{
	if (typeof pIcon !== 'string') return false;
	return /^(data:|https?:|\/|\.\.?\/)/.test(pIcon);
}

function _detectIconType(pBrand)
{
	if (pBrand && typeof pBrand.IconType === 'string') return pBrand.IconType;
	if (!pBrand || !pBrand.Icon) return null;
	if (_isInlineSVG(pBrand.Icon)) return 'svg';
	if (_isImageURL(pBrand.Icon)) return 'image';
	return null;
}

// Resolve a "color slot" to { Light, Dark, Base } regardless of input
// shape. Supported inputs:
//   - "string"                        → all three equal that string
//   - { Light, Dark }                 → Base = Light, others as given
//   - { Light, Dark, Base }           → Base explicit
//   - missing                         → null (caller decides how to fail)
function _resolveColorSlot(pSlot)
{
	if (typeof pSlot === 'string' && pSlot.length > 0)
	{
		return { Light: pSlot, Dark: pSlot, Base: pSlot };
	}
	if (pSlot && typeof pSlot === 'object')
	{
		let tmpLight = (typeof pSlot.Light === 'string' && pSlot.Light.length > 0) ? pSlot.Light : null;
		let tmpDark  = (typeof pSlot.Dark  === 'string' && pSlot.Dark.length  > 0) ? pSlot.Dark  : null;
		// Need at least one variant present.
		if (!tmpLight && !tmpDark) return null;
		// Fill missing variant from the other side. Base defaults to
		// the light variant (matches the legacy flat-form semantics).
		tmpLight = tmpLight || tmpDark;
		tmpDark  = tmpDark  || tmpLight;
		let tmpBase = (typeof pSlot.Base === 'string' && pSlot.Base.length > 0) ? pSlot.Base : tmpLight;
		return { Light: tmpLight, Dark: tmpDark, Base: tmpBase };
	}
	return null;
}

function _normalize(pBrand)
{
	if (!pBrand || typeof pBrand !== 'object') return null;
	let tmpColors = pBrand.Colors || {};

	// Brand colors accept TWO forms — flat or nested:
	//
	//   FLAT (legacy):
	//     Colors: {
	//       Primary:        '#e54b1e',     // required (the mode-agnostic value)
	//       Secondary:      '#1e9aa0',     // required
	//       PrimaryLight:   '#e54b1e',     // optional fallback to Primary
	//       PrimaryDark:    '#ff7a4a',     // optional fallback to Primary
	//       SecondaryLight: '#1e9aa0',     // optional fallback to Secondary
	//       SecondaryDark:  '#5fc5cb'      // optional fallback to Secondary
	//     }
	//
	//   NESTED (recommended):
	//     Colors: {
	//       Primary:   { Light: '#e54b1e', Dark: '#ff7a4a' },  // both required
	//       Secondary: { Light: '#1e9aa0', Dark: '#5fc5cb' }   // both required
	//     }
	//
	// The nested form mirrors how themes already structure their
	// Tokens.Color.* trees and makes the "this brand needs explicit
	// light + dark variants" contract obvious. Either form lands on
	// the same six --brand-color-* CSS variables.
	let tmpPriSlot = _resolveColorSlot(tmpColors.Primary);
	let tmpSecSlot = _resolveColorSlot(tmpColors.Secondary);
	if (!tmpPriSlot || !tmpSecSlot) return null;

	// Legacy flat-form fields override the resolved slot's Light/Dark
	// (so a host passing both forms gets the most explicit one).
	let tmpPriLight = tmpColors.PrimaryLight   || tmpPriSlot.Light;
	let tmpPriDark  = tmpColors.PrimaryDark    || tmpPriSlot.Dark;
	let tmpSecLight = tmpColors.SecondaryLight || tmpSecSlot.Light;
	let tmpSecDark  = tmpColors.SecondaryDark  || tmpSecSlot.Dark;

	return {
		Hash:    pBrand.Hash || 'brand',
		Name:    pBrand.Name || pBrand.Hash || 'Brand',
		Icon:    pBrand.Icon || null,
		IconType: _detectIconType(pBrand),
		Tagline: (typeof pBrand.Tagline === 'string') ? pBrand.Tagline : null,
		// Optional favicon assets. Each can be: inline `<svg>` markup, a
		// data URL, or a regular URL. When both Favicon and FaviconDark
		// are supplied, paired light/dark <link rel="icon"> tags are
		// emitted with prefers-color-scheme media queries; otherwise a
		// single <link> covers both modes.
		Favicon:     pBrand.Favicon     || null,
		FaviconDark: pBrand.FaviconDark || null,
		Colors:
		{
			Primary:        tmpPriSlot.Base,
			Secondary:      tmpSecSlot.Base,
			PrimaryLight:   tmpPriLight,
			PrimaryDark:    tmpPriDark,
			SecondaryLight: tmpSecLight,
			SecondaryDark:  tmpSecDark
		}
	};
}

// Encode an inline `<svg>` blob into a data URL safe for an <img src> /
// <link href> attribute. Falls through if the input already looks like
// a URL (data:, http:, /, ./, ../).
function _faviconHref(pIcon)
{
	if (!pIcon || typeof pIcon !== 'string') return null;
	if (_isInlineSVG(pIcon))
	{
		// percent-encode SVG markup. Don't encode '#' or '&' minimally;
		// the safe path is to encode aggressively then unescape spaces.
		let tmpEncoded = encodeURIComponent(pIcon).replace(/'/g, '%27').replace(/"/g, '%22');
		return 'data:image/svg+xml;charset=utf-8,' + tmpEncoded;
	}
	if (_isImageURL(pIcon)) return pIcon;
	return null;
}

function _removeFaviconLinks()
{
	if (typeof document === 'undefined') return;
	[FAVICON_LINK_ID, FAVICON_DARK_LINK_ID].forEach((pID) =>
	{
		let tmpEl = document.getElementById(pID);
		if (tmpEl && tmpEl.parentNode) tmpEl.parentNode.removeChild(tmpEl);
	});
}

function _injectFaviconLinks(pBrand)
{
	if (typeof document === 'undefined') return;
	_removeFaviconLinks();

	let tmpLight = _faviconHref(pBrand.Favicon);
	let tmpDark  = _faviconHref(pBrand.FaviconDark);
	if (!tmpLight && !tmpDark) return;

	let tmpHasPair = !!(tmpLight && tmpDark);

	if (tmpLight)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpLight;
		if (/^data:image\/svg\+xml/.test(tmpLight)) tmpLink.type = 'image/svg+xml';
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: light)';
		document.head.appendChild(tmpLink);
	}

	if (tmpDark)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_DARK_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpDark;
		if (/^data:image\/svg\+xml/.test(tmpDark)) tmpLink.type = 'image/svg+xml';
		// If we have a light variant, the dark link's media query handles
		// the swap; otherwise it serves both modes.
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: dark)';
		document.head.appendChild(tmpLink);
	}
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

// Escape so the brand name can ride along inside the CSS `content`-style
// `--brand-name` value as a quoted string.
function _cssQuote(pStr)
{
	return '"' + String(pStr || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
}

function _buildCSS(pBrand)
{
	let tmpC = pBrand.Colors;
	let tmpRoot = ':root {\n'
		+ '\t--brand-color-primary:         ' + tmpC.Primary + ';\n'
		+ '\t--brand-color-secondary:       ' + tmpC.Secondary + ';\n'
		+ '\t--brand-color-primary-light:   ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-primary-dark:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-light: ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-color-secondary-dark:  ' + tmpC.SecondaryDark + ';\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-name:                  ' + _cssQuote(pBrand.Name) + ';\n'
		+ '}\n';
	// Dark-mode overrides for the *-mode variables only.
	let tmpDark = '.theme-dark {\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryDark + ';\n'
		+ '}\n';
	return tmpRoot + tmpDark;
}

/**
 * Apply (or replace) the active brand. Pass `null` to clear.
 *
 * @param {object|null} pBrand
 * @returns {object|null} the normalized active brand (or null on clear)
 */
function applyBrand(pBrand)
{
	let tmpPrev = _activeBrand;

	if (pBrand === null)
	{
		_activeBrand = null;
		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
		}
		_removeFaviconLinks();
		_fireChange(null, tmpPrev);
		return null;
	}

	let tmpNorm = _normalize(pBrand);
	if (!tmpNorm)
	{
		// Bad input — keep current brand, no-op.
		if (typeof console !== 'undefined' && console.warn)
		{
			console.warn('Theme-Brand.applyBrand: bad brand object — needs Colors.Primary + Colors.Secondary as strings.');
		}
		return _activeBrand;
	}

	_activeBrand = tmpNorm;
	_injectStyleElement(_buildCSS(tmpNorm));
	_injectFaviconLinks(tmpNorm);
	_fireChange(tmpNorm, tmpPrev);
	return tmpNorm;
}

function getActive()
{
	return _activeBrand;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNew, pOld)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNew, pOld); }
		catch (pErr) { /* swallow — listener failure must not break callers */ }
	}
}

/**
 * Reset to no-brand state and detach the injected style. Tests use this;
 * runtime hosts rarely need it.
 */
function reset()
{
	applyBrand(null);
	_listeners = [];
}

module.exports =
{
	applyBrand:      applyBrand,
	getActive:       getActive,
	onChange:        onChange,
	offChange:       offChange,
	reset:           reset,
	STYLE_ELEMENT_ID:      STYLE_ELEMENT_ID,
	FAVICON_LINK_ID:       FAVICON_LINK_ID,
	FAVICON_DARK_LINK_ID:  FAVICON_DARK_LINK_ID
};

},{}],302:[function(require,module,exports){
/**
 * Theme-Icons — single source of truth for the inline SVG glyphs the
 * theme section uses (sun, moon, system / monitor, plus a chevron for
 * dropdown triggers).
 *
 * Every icon:
 *   - Is a self-contained SVG string suitable for direct DOM insertion
 *     (innerHTML, template substitution, or pict-section-modal's
 *     `Icon: <html>` field on dropdown items).
 *   - Uses `currentColor` for stroke so it picks up the surrounding
 *     text colour from the active theme (light + dark both look right
 *     without per-mode swaps).
 *   - Has `aria-hidden="true"` so screen readers ignore the decorative
 *     glyph and rely on the surrounding label / aria-label instead.
 *
 * The shapes are intentionally line-art (stroke-based, fill="none") so
 * they read at very small sizes (12–16 px) without going muddy. The
 * "system" icon is a stylised display (rectangle + stand) rather than
 * the unicode 🖥 to keep visual weight consistent with sun + moon.
 *
 * Need a different size? Pass `pSizePx` to any of the iconXxx() helpers
 * and the wrapper SVG's width/height are emitted with that value. The
 * default is 14 px which matches the mode toggle's existing visual.
 */

const _DEFAULT_SIZE_PX = 14;

function _wrap(pSizePx, pInner)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	return '<svg class="pict-theme-icon"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 24 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ pInner
		+ '</svg>';
}

/**
 * Sun glyph — central disc + 8 radial rays. Communicates "light mode"
 * universally. Slightly chunkier disc than the typical Feather sun so
 * it still reads at 12 px.
 */
function iconSun(pSizePx)
{
	return _wrap(pSizePx,
		'<circle cx="12" cy="12" r="4"/>'
		+ '<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>');
}

/**
 * Moon glyph — clean crescent (one continuous filled-look path drawn
 * as a stroke). Avoids the brittle thin-crescent unicode characters
 * that fall back to weird outline glyphs in some system fonts.
 */
function iconMoon(pSizePx)
{
	return _wrap(pSizePx,
		'<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>');
}

/**
 * System / display glyph — a small monitor with a stand. Communicates
 * "follow the OS preference" without ambiguity (a monitor is universal
 * UI for system settings, more than the gear icon would be).
 */
function iconSystem(pSizePx)
{
	return _wrap(pSizePx,
		'<rect x="2" y="4" width="20" height="14" rx="2"/>'
		+ '<path d="M8 21h8M12 18v3"/>');
}

/**
 * Composite: a sun + moon side-by-side, sized so the two icons fit in
 * the same horizontal footprint as a single icon. Used in the picker
 * to indicate a paired (Light + Dark) theme without needing two
 * separate visual columns.
 */
function iconPaired(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	// Each half uses currentColor; the sun is rendered slightly smaller
	// in the left half and the moon in the right half by abusing the
	// viewBox width.
	return '<svg class="pict-theme-icon pict-theme-icon-paired"'
		+ ' width="' + (tmpSize * 1.6) + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 38 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		// Sun on the left (centred at 8,12, radius 3)
		+ '<circle cx="8" cy="12" r="3"/>'
		+ '<path d="M8 4v1.5M8 18.5V20M2.5 12H4M12 12h1.5M4.1 7.1l1 1M11.1 7.1l-1 1M4.1 16.9l1-1M11.1 16.9l-1-1"/>'
		// Moon on the right (mirrored crescent, centred near x=28)
		+ '<path d="M33 13.5A6.5 6.5 0 1 1 26 6a5 5 0 0 0 7 7.5z"/>'
		+ '</svg>';
}

/**
 * Down-chevron used by dropdown triggers. Sized to sit alongside body
 * text (10 px default).
 */
function iconChevronDown(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : 10;
	return '<svg class="pict-theme-icon pict-theme-icon-chevron"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 12 12" fill="none"'
		+ ' stroke="currentColor" stroke-width="1.6"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ '<path d="M3 4.5l3 3 3-3"/>'
		+ '</svg>';
}

/**
 * Pick the right capability icon for a theme based on its mode strategy.
 * Returns the composite paired glyph for paired themes, sun for light-only,
 * moon for dark-only.
 *
 * @param {string} pStrategy - 'single' or 'system'/'paired'
 * @param {string} pDefaultMode - 'light' or 'dark' (only consulted for single)
 * @param {number} [pSizePx]
 */
function iconForTheme(pStrategy, pDefaultMode, pSizePx)
{
	if (pStrategy === 'single')
	{
		return (pDefaultMode === 'dark') ? iconMoon(pSizePx) : iconSun(pSizePx);
	}
	return iconPaired(pSizePx);
}

module.exports =
{
	iconSun:         iconSun,
	iconMoon:        iconMoon,
	iconSystem:      iconSystem,
	iconPaired:      iconPaired,
	iconChevronDown: iconChevronDown,
	iconForTheme:    iconForTheme,
	DEFAULT_SIZE_PX: _DEFAULT_SIZE_PX
};

},{}],303:[function(require,module,exports){
/**
 * Theme-Persistence — reads and writes the user's selected theme + mode
 * to the browser's localStorage so a reload restores the same look.
 *
 * pict-provider-theme is intentionally stateless — host applications
 * decide what to apply at boot. This module is the small, opt-out-able
 * layer that pict-section-theme.install() uses to make "remember my
 * theme" the default behaviour without forcing every consumer to wire
 * it themselves.
 *
 * # Storage shape
 *
 * Every entry is a single JSON object under one key:
 *
 *   localStorage["pict-section-theme:<scope>"] =
 *     {
 *       Version:   1,
 *       ThemeHash: "retold-manager",
 *       Mode:      "dark",
 *       Scale:     1.25,
 *       SavedAt:   "2026-05-09T21:00:00.000Z"
 *     }
 *
 * Version-tagged so future schema changes can be migrated cleanly;
 * mismatched versions are treated as "no saved entry" and the host
 * application's defaults take over. Older entries that pre-date the
 * Scale field are still valid — Scale is optional and load() returns
 * null for it when absent (caller defaults to 1.0).
 *
 * # Scope (the <scope> portion of the key)
 *
 * Determined in this priority order:
 *   1. The string the host passed in (`PersistenceKey: 'my-app'`) —
 *      use this when one host serves multiple logical apps from the
 *      same origin and they shouldn't share theme state.
 *   2. window.location.hostname when running in a browser.
 *   3. The literal 'default' as a last-ditch fallback (Node, sandbox,
 *      mid-SSR, etc.).
 *
 * # Failure modes
 *
 * - localStorage missing (SSR, Safari private mode, blocked) →
 *   load() returns null, save() returns false, no exception.
 * - Quota exceeded → save() returns false silently; the in-memory
 *   active theme is unaffected.
 * - JSON parse error or version mismatch → load() returns null so the
 *   caller falls back to ApplyDefault.
 *
 * Nothing here throws — persistence failures must NEVER crash the host
 * application's boot path.
 */

const STORAGE_PREFIX = 'pict-section-theme:';
const SCHEMA_VERSION = 1;

function _getStorage()
{
	try
	{
		if (typeof window !== 'undefined' && window.localStorage)
		{
			return window.localStorage;
		}
	}
	catch (pErr) { /* SecurityError in some contexts */ }
	return null;
}

function _autoScope()
{
	try
	{
		if (typeof window !== 'undefined' && window.location && window.location.hostname)
		{
			return window.location.hostname;
		}
	}
	catch (pErr) { /* fall through */ }
	return 'default';
}

/**
 * Resolve the full localStorage key for this app's theme state.
 *
 * @param {string|null} pUserKey - Host-supplied scope override; falsy
 *   values trigger the auto-scope fallback (hostname → 'default').
 * @returns {string} the fully-qualified localStorage key.
 */
function resolveKey(pUserKey)
{
	let tmpScope = (typeof pUserKey === 'string' && pUserKey.length > 0)
		? pUserKey
		: _autoScope();
	return STORAGE_PREFIX + tmpScope;
}

/**
 * Read the saved theme state for a key.  Returns null if nothing is
 * stored, the storage is unavailable, or the entry's schema version
 * doesn't match.
 *
 * @param {string} pKey - the resolved storage key
 * @returns {{ThemeHash: string, Mode: string|null, Scale: number|null}|null}
 */
function load(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return null;

	let tmpRaw;
	try { tmpRaw = tmpStore.getItem(pKey); }
	catch (pErr) { return null; }
	if (!tmpRaw) return null;

	let tmpParsed;
	try { tmpParsed = JSON.parse(tmpRaw); }
	catch (pErr) { return null; }

	if (!tmpParsed || typeof tmpParsed !== 'object') return null;
	if (tmpParsed.Version !== SCHEMA_VERSION) return null;
	if (typeof tmpParsed.ThemeHash !== 'string' || tmpParsed.ThemeHash.length === 0) return null;

	let tmpScale = null;
	if (typeof tmpParsed.Scale === 'number' && isFinite(tmpParsed.Scale) && tmpParsed.Scale > 0)
	{
		tmpScale = tmpParsed.Scale;
	}

	return {
		ThemeHash: tmpParsed.ThemeHash,
		Mode:      (typeof tmpParsed.Mode === 'string' && tmpParsed.Mode.length > 0)
			? tmpParsed.Mode
			: null,
		Scale:     tmpScale
	};
}

/**
 * Persist the active theme + mode for this key.  No-ops gracefully
 * when storage is unavailable or quota is exceeded.
 *
 * @param {string} pKey
 * @param {{ThemeHash: string, Mode?: string, Scale?: number}} pState
 * @returns {boolean} true on success, false otherwise
 */
function save(pKey, pState)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	if (!pState || typeof pState.ThemeHash !== 'string' || pState.ThemeHash.length === 0) return false;

	let tmpEntry =
	{
		Version:   SCHEMA_VERSION,
		ThemeHash: pState.ThemeHash,
		Mode:      (typeof pState.Mode === 'string' && pState.Mode.length > 0) ? pState.Mode : null,
		Scale:     (typeof pState.Scale === 'number' && isFinite(pState.Scale) && pState.Scale > 0)
			? pState.Scale
			: null,
		SavedAt:   new Date().toISOString()
	};

	try { tmpStore.setItem(pKey, JSON.stringify(tmpEntry)); return true; }
	catch (pErr) { return false; }
}

/**
 * Remove the saved theme state for a key.  Useful for "reset to
 * defaults" actions.
 */
function clear(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	try { tmpStore.removeItem(pKey); return true; }
	catch (pErr) { return false; }
}

module.exports =
{
	resolveKey: resolveKey,
	load:       load,
	save:       save,
	clear:      clear,
	STORAGE_PREFIX: STORAGE_PREFIX,
	SCHEMA_VERSION: SCHEMA_VERSION
};

},{}],304:[function(require,module,exports){
/**
 * Theme-Scale — viewport scale (zoom) selector independent of theme bundles.
 *
 * Scale is a *user preference*, not a property of any particular theme:
 * the user might want Cyberpunk-at-1.25x or Retold-Manager-at-0.85x.
 * Pict-provider-theme is intentionally bundle-shaped (Tokens / SVG /
 * Image), so scale lives here at the section layer alongside Mode.
 *
 * # Apply mechanism
 *
 * Two outputs feed cooperating CSS:
 *
 *   1. `html { zoom: <scale>; }` — works for legacy stylesheets that
 *      use `px` everywhere (most Retold apps including retold-manager).
 *      Browsers (Chromium-based + Firefox 126+ + Safari) all honour
 *      `zoom` on root.
 *
 *   2. `:root { --theme-scale: <scale>; }` — exposed for stylesheets
 *      that want to opt into explicit `calc(... * var(--theme-scale))`
 *      sizing. Keeps the value addressable from JS too via
 *      `getComputedStyle(document.documentElement).getPropertyValue(...)`.
 *
 * Both are written into a single `<style id="pict-theme-scale">` element
 * appended to `<head>` after the theme provider's own style element so
 * scale wins last. Re-applying just rewrites this one element's text.
 *
 * # Listener pattern
 *
 * Mirrors pict-provider-theme.onApply(): subscribers receive the new
 * scale value plus the previous value and a return-able `dispose`
 * function. The persistence wiring in pict-section-theme.install()
 * uses this to autosave whenever the scale changes.
 *
 * # Stateless across instances
 *
 * No singleton state — each browser window has one DOM, so the module
 * tracks active scale via a module-level variable, but exposes
 * `getActive()` for callers that want to query it. `applyScale()` is
 * idempotent: applying the same value re-injects the same CSS (cheap
 * no-op).
 */

const STYLE_ELEMENT_ID = 'pict-theme-scale';
const CSS_VAR_NAME = '--theme-scale';
const DEFAULT_SCALE = 1.0;
const MIN_SCALE = 0.5;
const MAX_SCALE = 3.0;

// Curated list of presets. Hosts that want a different range can pass
// a custom `Presets` array to the ScaleSelect view; this default covers
// the readability common cases without overwhelming the dropdown.
const PRESETS =
[
	{ Value: 0.75, Label: 'Tiny (75%)' },
	{ Value: 0.85, Label: 'Small (85%)' },
	{ Value: 1.00, Label: 'Default (100%)' },
	{ Value: 1.15, Label: 'Comfortable (115%)' },
	{ Value: 1.25, Label: 'Large (125%)' },
	{ Value: 1.50, Label: 'Huge (150%)' },
	{ Value: 1.75, Label: 'Extra Huge (175%)' },
	{ Value: 2.00, Label: 'Massive (200%)' }
];

let _activeScale = DEFAULT_SCALE;
let _listeners = [];

function _clamp(pValue)
{
	let tmpNum = Number(pValue);
	if (!isFinite(tmpNum) || tmpNum <= 0) return DEFAULT_SCALE;
	if (tmpNum < MIN_SCALE) return MIN_SCALE;
	if (tmpNum > MAX_SCALE) return MAX_SCALE;
	return tmpNum;
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

function _buildCSS(pScale)
{
	// `zoom` on <html> scales everything (px + rem + layout). The
	// `--theme-scale` custom property exposes the same value to any CSS
	// that wants to react explicitly via calc().
	return ':root {\n'
		+ '\t' + CSS_VAR_NAME + ': ' + pScale + ';\n'
		+ '}\n'
		+ 'html {\n'
		+ '\tzoom: ' + pScale + ';\n'
		+ '}\n';
}

/**
 * Apply a viewport scale.
 *
 * @param {number} pScale - desired multiplier (e.g. 1.0, 1.25). Values
 *   outside [MIN_SCALE, MAX_SCALE] are clamped; non-finite values
 *   reset to DEFAULT_SCALE.
 * @returns {number} the actually-applied scale (after clamping).
 */
function applyScale(pScale)
{
	let tmpPrev = _activeScale;
	let tmpNext = _clamp(pScale);
	_activeScale = tmpNext;
	_injectStyleElement(_buildCSS(tmpNext));
	if (tmpPrev !== tmpNext) { _fireChange(tmpNext, tmpPrev); }
	return tmpNext;
}

function getActive()
{
	return _activeScale;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNewScale, pOldScale)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNewScale, pOldScale); }
		catch (pErr) { /* listener failures must not break callers */ }
	}
}

/**
 * Reset to default scale and remove the injected style element. Useful
 * for tests + "reset to defaults" affordances.
 */
function reset()
{
	_activeScale = DEFAULT_SCALE;
	if (typeof document !== 'undefined')
	{
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
	}
	_listeners = [];
}

module.exports =
{
	applyScale: applyScale,
	getActive:  getActive,
	onChange:   onChange,
	offChange:  offChange,
	reset:      reset,

	PRESETS:        PRESETS,
	DEFAULT_SCALE:  DEFAULT_SCALE,
	MIN_SCALE:      MIN_SCALE,
	MAX_SCALE:      MAX_SCALE,
	STYLE_ELEMENT_ID: STYLE_ELEMENT_ID,
	CSS_VAR_NAME:     CSS_VAR_NAME
};

},{}],305:[function(require,module,exports){
module.exports={
	"Hash": "1970s-console",
	"Name": "1970s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Amber phosphor on brown-black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A1000",
				"Secondary": "#140C00",
				"Tertiary": "#1E1400",
				"Panel": "#1C1200",
				"Viewer": "#100A00",
				"Hover": "#2A1C00",
				"Selected": "#3A2800",
				"Thumb": "#140C00"
			},
			"Text": {
				"Primary": "#FFAA00",
				"Secondary": "#DD8800",
				"Muted": "#AA6600",
				"Dim": "#884400",
				"Placeholder": "#663300"
			},
			"Brand": {
				"Accent": "#FFCC00",
				"AccentHover": "#FFDD44"
			},
			"Border": {
				"Default": "#2A1800",
				"Light": "#3A2200"
			},
			"Status": {
				"Danger": "#FF4400",
				"DangerMuted": "#AA3300"
			},
			"Scrollbar": {
				"Track": "#2A1800",
				"Hover": "#3A2800"
			},
			"Selection": {
				"Background": "rgba(255, 204, 0, 0.2)"
			},
			"Focus": {
				"Outline": "#FFCC00"
			},
			"Syntax": {
				"Keyword":     "#FFB000",
				"String":      "#FFD080",
				"Number":      "#FFB000",
				"Comment":     "#806020",
				"Operator":    "#FFB000",
				"Punctuation": "#FFD080",
				"Function":    "#FFB000",
				"Variable":    "#FFE090",
				"Type":        "#FFB000",
				"Builtin":     "#FFB000",
				"Property":    "#FF6E40",
				"Tag":         "#FF6E40",
				"AttrName":    "#FFB000",
				"AttrValue":   "#FFD080"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', 'Lucida Console', monospace",
				"Mono": "'Courier New', 'Lucida Console', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#DD8800",
		"Accent": "#FFCC00",
		"Muted": "#884400",
		"Light": "#1E1400",
		"WarmBeige": "#201800",
		"TealTint": "#1A1000",
		"Lavender": "#1C1200",
		"AmberTint": "#221800",
		"PdfFill": "#201000",
		"PdfText": "#FF4400"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.405Z",
	"CompilerVersion": 1
}
},{}],306:[function(require,module,exports){
module.exports={
	"Hash": "1980s-console",
	"Name": "1980s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Green phosphor on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#001200",
				"Secondary": "#000E00",
				"Tertiary": "#001600",
				"Panel": "#001400",
				"Viewer": "#000A00",
				"Hover": "#002200",
				"Selected": "#003800",
				"Thumb": "#000E00"
			},
			"Text": {
				"Primary": "#00FF00",
				"Secondary": "#00CC00",
				"Muted": "#009900",
				"Dim": "#006600",
				"Placeholder": "#004400"
			},
			"Brand": {
				"Accent": "#00FF66",
				"AccentHover": "#44FF88"
			},
			"Border": {
				"Default": "#002A00",
				"Light": "#003A00"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#AA0000"
			},
			"Scrollbar": {
				"Track": "#002A00",
				"Hover": "#004400"
			},
			"Selection": {
				"Background": "rgba(0, 255, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF66"
			},
			"Syntax": {
				"Keyword":     "#00FF00",
				"String":      "#90FF90",
				"Number":      "#FFFF00",
				"Comment":     "#208020",
				"Operator":    "#00FF00",
				"Punctuation": "#90FF90",
				"Function":    "#00FF00",
				"Variable":    "#C0FFC0",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF4040",
				"Tag":         "#FF4040",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#90FF90"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#00CC00",
		"Accent": "#00FF66",
		"Muted": "#006600",
		"Light": "#001600",
		"WarmBeige": "#001A00",
		"TealTint": "#001200",
		"Lavender": "#001400",
		"AmberTint": "#001800",
		"PdfFill": "#140000",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],307:[function(require,module,exports){
module.exports={
	"Hash": "1990s-website",
	"Name": "1990s Web Site",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Blue links on grey, beveled Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#C0C0C0",
				"Secondary": "#B0B0B0",
				"Tertiary": "#A8A8A8",
				"Panel": "#B8B8B8",
				"Viewer": "#D0D0D0",
				"Hover": "#B8B8D0",
				"Selected": "#000080",
				"Thumb": "#B0B0B0"
			},
			"Text": {
				"Primary": "#000000",
				"Secondary": "#000080",
				"Muted": "#404040",
				"Dim": "#606060",
				"Placeholder": "#808080"
			},
			"Brand": {
				"Accent": "#0000FF",
				"AccentHover": "#0000CC"
			},
			"Border": {
				"Default": "#808080",
				"Light": "#A0A0A0"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#990000"
			},
			"Scrollbar": {
				"Track": "#808080",
				"Hover": "#606060"
			},
			"Selection": {
				"Background": "rgba(0, 0, 128, 0.3)"
			},
			"Focus": {
				"Outline": "#0000FF"
			},
			"Syntax": {
				"Keyword":     "#0000FF",
				"String":      "#008000",
				"Number":      "#A52A2A",
				"Comment":     "#808080",
				"Operator":    "#000080",
				"Punctuation": "#000000",
				"Function":    "#0000A0",
				"Variable":    "#000000",
				"Type":        "#A52A2A",
				"Builtin":     "#A52A2A",
				"Property":    "#800080",
				"Tag":         "#800080",
				"AttrName":    "#A52A2A",
				"AttrValue":   "#008000"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Times New Roman', Times, serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#000080",
		"Accent": "#0000FF",
		"Muted": "#606060",
		"Light": "#A8A8A8",
		"WarmBeige": "#B0B0B0",
		"TealTint": "#A0A0A0",
		"Lavender": "#ABABD0",
		"AmberTint": "#B8B0A0",
		"PdfFill": "#C0A0A0",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],308:[function(require,module,exports){
/**
 * Theme Registry — runtime registry of every theme available to
 * pict-section-theme.
 *
 * Bundled "starter set" themes are pre-registered at module load time
 * via static `require()` so browserify can resolve and inline each JSON
 * at bundle time. Beyond the starter set, consumers can register
 * additional theme bundles at runtime — useful for:
 *
 *   - Loading themes the host app authored (e.g. an app's own brand
 *     palette that isn't shipped with this module).
 *   - Pulling themes from a remote "theme garden" via
 *     `registerFromURL()` (CDN-hosted curated bundles).
 *   - Tooling / playgrounds that mutate the registry as the user
 *     iterates.
 *
 * Module exports a singleton instance, so all consumers operate on the
 * same set. Use `register({Hash, Bundle, Category, IsDefault})` to add
 * themes, `list()` to enumerate them, `get(hash)` for direct lookup,
 * `unregister(hash)` to remove.
 *
 * Each entry shape:
 *
 *   {
 *     Hash:       <string>      // matches bundle.Hash; used by the picker
 *     Bundle:     <object>      // theme JSON, ready for provider.registerTheme()
 *     Category:   <string>      // grouping label for the picker UI
 *     IsDefault:  <bool?>       // true for the canonical ecosystem default
 *     Source:     <string?>     // 'starter' | URL | host-supplied tag
 *   }
 *
 * Backwards-compat:
 *   - The instance is iterable (Symbol.iterator), exposes `.length`,
 *     and supports numeric indexing `[i]` so legacy code that treated
 *     the catalog as an array continues to work without changes.
 */
'use strict';

class ThemeRegistry
{
	constructor()
	{
		this._themes = new Map();      // Hash → entry, insertion-ordered
		this._loadStarterSet();
	}

	// ── Bundled starter set ──────────────────────────────────────────────
	// Each `require()` is a literal string so browserify inlines the JSON
	// at build time. Adding a new bundled theme: drop the JSON in this
	// folder and append a row here. Runtime additions go via register()
	// from anywhere else in the codebase.
	_loadStarterSet()
	{
		const STARTER =
		[
			// Framework defaults
			// retold-default is the canonical ecosystem default (IsDefault).
			// pict-default is retained for backwards compatibility with any
			// consumer that explicitly opts in by Hash; it's no longer the
			// default theme returned when the picker resolves "the default".
			{ Hash: 'retold-default',     Category: 'Default',  IsDefault: true,  Bundle: require('./retold-default.json') },
			{ Hash: 'pict-default',       Category: 'Default',  Bundle: require('./pict-default.json') },
			{ Hash: 'retold-mono',        Category: 'Default',  Bundle: require('./retold-mono.json') },

			// App-extracted themes (named after their host app)
			{ Hash: 'retold-manager',                Category: 'App',  Bundle: require('./retold-manager.json') },
			{ Hash: 'retold-content-system',         Category: 'App',  Bundle: require('./retold-content-system.json') },
			{ Hash: 'retold-labs',                   Category: 'App',  Bundle: require('./retold-labs.json') },
			{ Hash: 'retold-labs-cyberpunk',         Category: 'App',  Bundle: require('./retold-labs-cyberpunk.json') },
			{ Hash: 'retold-labs-retro',             Category: 'App',  Bundle: require('./retold-labs-retro.json') },
			{ Hash: 'ultravisor-desert-dusk',        Category: 'App',  Bundle: require('./ultravisor-desert-dusk.json') },
			{ Hash: 'ultravisor-desert-day',         Category: 'App',  Bundle: require('./ultravisor-desert-day.json') },
			{ Hash: 'ultravisor-desert-sunset',      Category: 'App',  Bundle: require('./ultravisor-desert-sunset.json') },
			{ Hash: 'ultravisor-professional-light', Category: 'App',  Bundle: require('./ultravisor-professional-light.json') },
			{ Hash: 'ultravisor-professional-dark',  Category: 'App',  Bundle: require('./ultravisor-professional-dark.json') },
			{ Hash: 'ultravisor-desert-canyon',      Category: 'App',  Bundle: require('./ultravisor-desert-canyon.json') },

			// Paired light/dark themes
			{ Hash: 'ocean',              Category: 'Paired',   Bundle: require('./ocean.json') },
			{ Hash: 'playground-corp',    Category: 'Paired',   Bundle: require('./playground-corp.json') },

			// Flow themes (originally pict-section-flow's internal presets; now first-class
			// pict-section-theme entries so other apps can adopt the same color identity)
			{ Hash: 'flow-modern',        Category: 'Flow',     Bundle: require('./flow-modern.json') },
			{ Hash: 'flow-sketch',        Category: 'Flow',     Bundle: require('./flow-sketch.json') },
			{ Hash: 'flow-blueprint',     Category: 'Flow',     Bundle: require('./flow-blueprint.json') },
			{ Hash: 'flow-mono',          Category: 'Flow',     Bundle: require('./flow-mono.json') },
			{ Hash: 'flow-retro-80s',     Category: 'Flow',     Bundle: require('./flow-retro-80s.json') },
			{ Hash: 'flow-retro-90s',     Category: 'Flow',     Bundle: require('./flow-retro-90s.json') },
			{ Hash: 'flow-whiteboard',    Category: 'Flow',     Bundle: require('./flow-whiteboard.json') },

			// Greys (low-light single-mode themes)
			{ Hash: 'twilight',           Category: 'Grey',     Bundle: require('./twilight.json') },
			{ Hash: 'night',              Category: 'Grey',     Bundle: require('./night.json') },
			{ Hash: 'evening',            Category: 'Grey',     Bundle: require('./evening.json') },
			{ Hash: 'afternoon',          Category: 'Grey',     Bundle: require('./afternoon.json') },
			{ Hash: 'daylight',           Category: 'Grey',     Bundle: require('./daylight.json') },

			// Fun / period palettes
			{ Hash: 'cyberpunk',          Category: 'Fun',      Bundle: require('./cyberpunk.json') },
			{ Hash: 'synthwave',          Category: 'Fun',      Bundle: require('./synthwave.json') },
			{ Hash: 'neo-tokyo',          Category: 'Fun',      Bundle: require('./neo-tokyo.json') },
			{ Hash: 'solarized-dark',     Category: 'Fun',      Bundle: require('./solarized-dark.json') },
			{ Hash: 'forest',             Category: 'Fun',      Bundle: require('./forest.json') },
			{ Hash: 'hotdog',             Category: 'Fun',      Bundle: require('./hotdog.json') },
			{ Hash: '1970s-console',      Category: 'Fun',      Bundle: require('./1970s-console.json') },
			{ Hash: '1980s-console',      Category: 'Fun',      Bundle: require('./1980s-console.json') },
			{ Hash: '1990s-website',      Category: 'Fun',      Bundle: require('./1990s-website.json') },
			{ Hash: 'early-2000s',        Category: 'Fun',      Bundle: require('./early-2000s.json') },

			// Retro workstation palettes — extracted from retold-databeacon's
			// original built-in theme set; period-platform-themed pairs.
			{ Hash: 'databeacon-nineteen-97', Category: 'Retro', Bundle: require('./databeacon-nineteen-97.json') },
			{ Hash: 'databeacon-mac-classic', Category: 'Retro', Bundle: require('./databeacon-mac-classic.json') },
			{ Hash: 'databeacon-next',        Category: 'Retro', Bundle: require('./databeacon-next.json') },
			{ Hash: 'databeacon-beos',        Category: 'Retro', Bundle: require('./databeacon-beos.json') },
			{ Hash: 'databeacon-sgi',         Category: 'Retro', Bundle: require('./databeacon-sgi.json') },

			// Diagnostics / utility
			{ Hash: 'mobile-debug',       Category: 'Debug',    Bundle: require('./mobile-debug.json') }
		];

		for (let i = 0; i < STARTER.length; i++)
		{
			let tmpEntry = Object.assign({}, STARTER[i], { Source: STARTER[i].Source || 'starter' });
			this._themes.set(tmpEntry.Hash, tmpEntry);
		}
	}

	// ── Public API ───────────────────────────────────────────────────────

	/**
	 * Register a theme. Re-registering an existing hash overwrites cleanly.
	 *
	 * @param {{Hash, Bundle, Category?, IsDefault?, Source?}} pEntry
	 * @returns {object} the stored entry
	 */
	register(pEntry)
	{
		if (!pEntry || typeof pEntry !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry must be an object');
		}
		if (typeof pEntry.Hash !== 'string' || pEntry.Hash.length === 0)
		{
			throw new Error('ThemeRegistry.register: entry.Hash is required');
		}
		if (!pEntry.Bundle || typeof pEntry.Bundle !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry.Bundle is required');
		}
		let tmpStored = Object.assign({ Source: 'host' }, pEntry);
		this._themes.set(pEntry.Hash, tmpStored);
		return tmpStored;
	}

	/**
	 * Remove a theme by hash. Returns true if anything was removed.
	 * @param {string} pHash
	 * @returns {boolean}
	 */
	unregister(pHash)
	{
		return this._themes.delete(pHash);
	}

	/**
	 * Look up a single theme entry by hash.
	 * @param {string} pHash
	 * @returns {object|undefined}
	 */
	get(pHash)
	{
		return this._themes.get(pHash);
	}

	has(pHash)
	{
		return this._themes.has(pHash);
	}

	/**
	 * Snapshot of every registered entry, in registration order.
	 * @returns {Array<object>}
	 */
	list()
	{
		return Array.from(this._themes.values());
	}

	/**
	 * Drop every registered entry. Mostly useful in tests; production
	 * consumers should prefer `unregister()` per hash.
	 */
	clear()
	{
		this._themes.clear();
	}

	/**
	 * Re-load the bundled starter set. No-op if the starter set is
	 * already registered (re-registering replaces, so this is safe to
	 * call any time).
	 */
	loadStarterSet()
	{
		this._loadStarterSet();
	}

	/**
	 * Number of registered themes.
	 * @returns {number}
	 */
	get count()
	{
		return this._themes.size;
	}

	/**
	 * Async fetch + register from a URL. Used by the future "online theme
	 * garden" — the URL must serve a JSON bundle compatible with
	 * pict-provider-theme's `registerTheme()` shape.
	 *
	 * @param {string} pURL
	 * @param {{Category?, IsDefault?, Hash?}} [pMetadata] - override metadata
	 * @returns {Promise<object>} the registered entry
	 */
	async registerFromURL(pURL, pMetadata)
	{
		if (typeof fetch !== 'function')
		{
			throw new Error('ThemeRegistry.registerFromURL: fetch is not available in this environment');
		}
		let tmpResponse = await fetch(pURL);
		if (!tmpResponse.ok)
		{
			throw new Error('ThemeRegistry.registerFromURL: HTTP ' + tmpResponse.status + ' for ' + pURL);
		}
		let tmpBundle = await tmpResponse.json();
		if (!tmpBundle || typeof tmpBundle !== 'object' || typeof tmpBundle.Hash !== 'string')
		{
			throw new Error('ThemeRegistry.registerFromURL: payload missing Hash');
		}
		let tmpMeta = pMetadata || {};
		return this.register(
		{
			Hash: tmpMeta.Hash || tmpBundle.Hash,
			Bundle: tmpBundle,
			Category: tmpMeta.Category || 'Garden',
			IsDefault: !!tmpMeta.IsDefault,
			Source: pURL
		});
	}

	// ── Array-like compatibility ─────────────────────────────────────────
	// Older code iterated the catalog as an array (`for (let i = 0; i <
	// CATALOG.length; i++) ... CATALOG[i]`). Preserve those usages without
	// requiring a refactor: the iterator + length + numeric proxy give
	// `Array.isArray(registry)` returns false, but everything that reads
	// keeps working. New code should prefer `list()` / `get()`.

	get length()
	{
		return this._themes.size;
	}

	[Symbol.iterator]()
	{
		return this._themes.values();
	}
}

// Singleton — every consumer gets the same registry.
const _Registry = new ThemeRegistry();

// Numeric-index proxy: `registry[0]` returns the first entry, matching
// the legacy "catalog as array" shape. Wraps the singleton so existing
// `tmpEntry = _CATALOG[i]` loops keep working.
const _IndexedRegistry = new Proxy(_Registry,
{
	get(pTarget, pProp, pReceiver)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			let tmpIdx = parseInt(pProp, 10);
			let tmpList = pTarget.list();
			return tmpList[tmpIdx];
		}
		return Reflect.get(pTarget, pProp, pReceiver);
	},
	has(pTarget, pProp)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			return parseInt(pProp, 10) < pTarget.length;
		}
		return Reflect.has(pTarget, pProp);
	}
});

module.exports = _IndexedRegistry;
module.exports.ThemeRegistry = ThemeRegistry;

},{"./1970s-console.json":305,"./1980s-console.json":306,"./1990s-website.json":307,"./afternoon.json":309,"./cyberpunk.json":310,"./databeacon-beos.json":311,"./databeacon-mac-classic.json":312,"./databeacon-next.json":313,"./databeacon-nineteen-97.json":314,"./databeacon-sgi.json":315,"./daylight.json":316,"./early-2000s.json":317,"./evening.json":318,"./flow-blueprint.json":319,"./flow-modern.json":320,"./flow-mono.json":321,"./flow-retro-80s.json":322,"./flow-retro-90s.json":323,"./flow-sketch.json":324,"./flow-whiteboard.json":325,"./forest.json":326,"./hotdog.json":327,"./mobile-debug.json":328,"./neo-tokyo.json":329,"./night.json":330,"./ocean.json":331,"./pict-default.json":332,"./playground-corp.json":333,"./retold-content-system.json":334,"./retold-default.json":335,"./retold-labs-cyberpunk.json":336,"./retold-labs-retro.json":337,"./retold-labs.json":338,"./retold-manager.json":339,"./retold-mono.json":340,"./solarized-dark.json":341,"./synthwave.json":342,"./twilight.json":343,"./ultravisor-desert-canyon.json":344,"./ultravisor-desert-day.json":345,"./ultravisor-desert-dusk.json":346,"./ultravisor-desert-sunset.json":347,"./ultravisor-professional-dark.json":348,"./ultravisor-professional-light.json":349}],309:[function(require,module,exports){
module.exports={
	"Hash": "afternoon",
	"Name": "Afternoon",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Warm light grey, softer contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8E4E0",
				"Secondary": "#DAD6D2",
				"Tertiary": "#D0CCC8",
				"Panel": "#DDD9D5",
				"Viewer": "#F0ECE8",
				"Hover": "#CCC8C4",
				"Selected": "#B8B4B0",
				"Thumb": "#DAD6D2"
			},
			"Text": {
				"Primary": "#2A2A2A",
				"Secondary": "#404040",
				"Muted": "#707070",
				"Dim": "#909090",
				"Placeholder": "#B0B0B0"
			},
			"Brand": {
				"Accent": "#555555",
				"AccentHover": "#333333"
			},
			"Border": {
				"Default": "#C0BCB8",
				"Light": "#D0CCC8"
			},
			"Status": {
				"Danger": "#AA3333",
				"DangerMuted": "#886655"
			},
			"Scrollbar": {
				"Track": "#B8B4B0",
				"Hover": "#A0A09C"
			},
			"Selection": {
				"Background": "rgba(85, 85, 85, 0.2)"
			},
			"Focus": {
				"Outline": "#555555"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#666666",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Georgia, 'Times New Roman', serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#404040",
		"Accent": "#555555",
		"Muted": "#909090",
		"Light": "#D0CCC8",
		"WarmBeige": "#DAD6D2",
		"TealTint": "#CCC8C4",
		"Lavender": "#D2D0CE",
		"AmberTint": "#D8D2C8",
		"PdfFill": "#D8C8C0",
		"PdfText": "#AA3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],310:[function(require,module,exports){
module.exports={
	"Hash": "cyberpunk",
	"Name": "Cyberpunk",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Electric green on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0E0A",
				"Secondary": "#060806",
				"Tertiary": "#0E120E",
				"Panel": "#0C100C",
				"Viewer": "#040604",
				"Hover": "#142014",
				"Selected": "#1A3A1A",
				"Thumb": "#060806"
			},
			"Text": {
				"Primary": "#C8FFC8",
				"Secondary": "#A0D8A0",
				"Muted": "#608860",
				"Dim": "#406040",
				"Placeholder": "#305030"
			},
			"Brand": {
				"Accent": "#00FF41",
				"AccentHover": "#44FF77"
			},
			"Border": {
				"Default": "#1A2A1A",
				"Light": "#224022"
			},
			"Status": {
				"Danger": "#FF3333",
				"DangerMuted": "#AA2222"
			},
			"Scrollbar": {
				"Track": "#1A2A1A",
				"Hover": "#2A4A2A"
			},
			"Selection": {
				"Background": "rgba(0, 255, 65, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF41"
			},
			"Syntax": {
				"Keyword":     "#FF00FF",
				"String":      "#00FF41",
				"Number":      "#FFFF00",
				"Comment":     "#406040",
				"Operator":    "#00FFFF",
				"Punctuation": "#A0D8A0",
				"Function":    "#FF00FF",
				"Variable":    "#C8FFC8",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF3333",
				"Tag":         "#FF3333",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#00FF41"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Lucida Console', 'Courier New', monospace",
				"Mono": "'Lucida Console', 'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#A0D8A0",
		"Accent": "#00FF41",
		"Muted": "#406040",
		"Light": "#0E120E",
		"WarmBeige": "#101610",
		"TealTint": "#0C140C",
		"Lavender": "#0E120E",
		"AmberTint": "#141810",
		"PdfFill": "#181010",
		"PdfText": "#FF3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],311:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-beos",
	"Name": "DataBeacon \u2014 BeOS",
	"Version": "0.0.1",
	"Description": "BeOS palette \u2014 cool teals with orange accents. Light: sky-blue desktop. Dark: deep ocean panels with cyan highlights.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#e0e8ec",
					"Dark": "#0a1a22"
				},
				"Secondary": {
					"Light": "#c8d6de",
					"Dark": "#102530"
				},
				"Tertiary": {
					"Light": "#d4dfe5",
					"Dark": "#0d1f29"
				},
				"Panel": {
					"Light": "#f0f4f6",
					"Dark": "#142430"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#1b313f"
				},
				"Hover": {
					"Light": "#d7dee2",
					"Dark": "#091820"
				},
				"Selected": {
					"Light": "#c2d4da",
					"Dark": "#19353e"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				},
				"Secondary": {
					"Light": "#40525e",
					"Dark": "#7a98a8"
				},
				"Muted": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				},
				"Placeholder": {
					"Light": "#95a5ae",
					"Dark": "#3a4e59"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a1a22"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"PrimaryHover": {
					"Light": "#4e98aa",
					"Dark": "#80ccdc"
				},
				"Accent": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"AccentHover": {
					"Light": "#4e98aa",
					"Dark": "#80ccdc"
				}
			},
			"Border": {
				"Default": {
					"Light": "#8ba3b0",
					"Dark": "#466070"
				},
				"Light": {
					"Light": "#b5c5ce",
					"Dark": "#283d49"
				},
				"Strong": {
					"Light": "#6f828c",
					"Dark": "#384c59"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				},
				"Warning": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Error": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"Info": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#c8d6de",
					"Dark": "#102530"
				},
				"Thumb": {
					"Light": "#7c929f",
					"Dark": "#4d6574"
				},
				"Hover": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#aac4cc",
					"Dark": "#254a54"
				},
				"Text": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"String": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				},
				"Number": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Comment": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				},
				"Operator": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"Punctuation": {
					"Light": "#40525e",
					"Dark": "#7a98a8"
				},
				"Function": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"Variable": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				},
				"Type": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Builtin": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Property": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"Tag": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"AttrName": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"AttrValue": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "BeOS",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],312:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-mac-classic",
	"Name": "DataBeacon \u2014 Mac Classic",
	"Version": "0.0.1",
	"Description": "Mac OS 8/9 Platinum palette \u2014 soft greys with sky blue accents. Light: classic Mac platinum. Dark: charcoal panels with the same blue accent family.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#dddddd",
					"Dark": "#202020"
				},
				"Secondary": {
					"Light": "#cccccc",
					"Dark": "#2a2a2a"
				},
				"Tertiary": {
					"Light": "#d4d4d4",
					"Dark": "#252525"
				},
				"Panel": {
					"Light": "#f0f0f0",
					"Dark": "#2e2e2e"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#3a3a3a"
				},
				"Hover": {
					"Light": "#d4d4d4",
					"Dark": "#1e1e1e"
				},
				"Selected": {
					"Light": "#c0cce3",
					"Dark": "#2b3748"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#dddddd"
				},
				"Secondary": {
					"Light": "#444444",
					"Dark": "#b0b0b0"
				},
				"Muted": {
					"Light": "#777777",
					"Dark": "#777777"
				},
				"Placeholder": {
					"Light": "#9a9a9a",
					"Dark": "#585858"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a0a0a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"PrimaryHover": {
					"Light": "#60a0ff",
					"Dark": "#80b8ff"
				},
				"Accent": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"AccentHover": {
					"Light": "#60a0ff",
					"Dark": "#80b8ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#999999",
					"Dark": "#555555"
				},
				"Light": {
					"Light": "#bbbbbb",
					"Dark": "#3a3a3a"
				},
				"Strong": {
					"Light": "#7a7a7a",
					"Dark": "#444444"
				}
			},
			"Status": {
				"Success": {
					"Light": "#339933",
					"Dark": "#60cc60"
				},
				"Warning": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Error": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"Info": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#cccccc",
					"Dark": "#2a2a2a"
				},
				"Thumb": {
					"Light": "#888888",
					"Dark": "#666666"
				},
				"Hover": {
					"Light": "#777777",
					"Dark": "#777777"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#aabfe7",
					"Dark": "#344867"
				},
				"Text": {
					"Light": "#000000",
					"Dark": "#dddddd"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"String": {
					"Light": "#339933",
					"Dark": "#60cc60"
				},
				"Number": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Comment": {
					"Light": "#777777",
					"Dark": "#777777"
				},
				"Operator": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"Punctuation": {
					"Light": "#444444",
					"Dark": "#b0b0b0"
				},
				"Function": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"Variable": {
					"Light": "#000000",
					"Dark": "#dddddd"
				},
				"Type": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Builtin": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Property": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"Tag": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"AttrName": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"AttrValue": {
					"Light": "#339933",
					"Dark": "#60cc60"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Mac Classic",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],313:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-next",
	"Name": "DataBeacon \u2014 NeXT",
	"Version": "0.0.1",
	"Description": "NeXTSTEP palette \u2014 stone backgrounds with rich purple accents. Light: warm stone. Dark: deep aubergine with lavender highlights.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#e8e6dd",
					"Dark": "#1a1420"
				},
				"Secondary": {
					"Light": "#d6d3c8",
					"Dark": "#221a2c"
				},
				"Tertiary": {
					"Light": "#dfdcd2",
					"Dark": "#1e1726"
				},
				"Panel": {
					"Light": "#f5f3ed",
					"Dark": "#251c2e"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#2f253a"
				},
				"Hover": {
					"Light": "#dedcd4",
					"Dark": "#18131e"
				},
				"Selected": {
					"Light": "#d1c7d2",
					"Dark": "#352a42"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				},
				"Secondary": {
					"Light": "#4c465a",
					"Dark": "#b8b4c6"
				},
				"Muted": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				},
				"Placeholder": {
					"Light": "#a09ba5",
					"Dark": "#585263"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#1a1420"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"PrimaryHover": {
					"Light": "#8557c0",
					"Dark": "#c8aef0"
				},
				"Accent": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"AccentHover": {
					"Light": "#8557c0",
					"Dark": "#c8aef0"
				}
			},
			"Border": {
				"Default": {
					"Light": "#9a96a6",
					"Dark": "#5e5468"
				},
				"Light": {
					"Light": "#c1bec1",
					"Dark": "#3c3444"
				},
				"Strong": {
					"Light": "#7b7884",
					"Dark": "#4b4353"
				}
			},
			"Status": {
				"Success": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				},
				"Warning": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Error": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"Info": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d6d3c8",
					"Dark": "#221a2c"
				},
				"Thumb": {
					"Light": "#8a8597",
					"Dark": "#6c6478"
				},
				"Hover": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#bfb0c9",
					"Dark": "#4a3b5d"
				},
				"Text": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"String": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				},
				"Number": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Comment": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				},
				"Operator": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"Punctuation": {
					"Light": "#4c465a",
					"Dark": "#b8b4c6"
				},
				"Function": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"Variable": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				},
				"Type": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Builtin": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Property": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"Tag": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"AttrName": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"AttrValue": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "NeXT",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],314:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-nineteen-97",
	"Name": "DataBeacon \u2014 1997 (Win95/98)",
	"Version": "0.0.1",
	"Description": "Windows 95/98 retro palette \u2014 beige + navy + maroon. Light: classic Win95 desktop. Dark: indigo-grey background with sky/coral accents.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ece9d8",
					"Dark": "#1e1e2e"
				},
				"Secondary": {
					"Light": "#d8d3b8",
					"Dark": "#26263a"
				},
				"Tertiary": {
					"Light": "#e2dec8",
					"Dark": "#222234"
				},
				"Panel": {
					"Light": "#fffbf0",
					"Dark": "#2a2a3a"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#343450"
				},
				"Hover": {
					"Light": "#e2dfcf",
					"Dark": "#1c1c2c"
				},
				"Selected": {
					"Light": "#c1bfc8",
					"Dark": "#2f3553"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				},
				"Secondary": {
					"Light": "#4a4a4a",
					"Dark": "#b8b6a8"
				},
				"Muted": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				},
				"Placeholder": {
					"Light": "#a1a09a",
					"Dark": "#5c5b58"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#1a1a1a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"PrimaryHover": {
					"Light": "#0000cc",
					"Dark": "#a0b8ff"
				},
				"Accent": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"AccentHover": {
					"Light": "#0000cc",
					"Dark": "#a0b8ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#808080",
					"Dark": "#4e4e68"
				},
				"Light": {
					"Light": "#b6b4ac",
					"Dark": "#36364b"
				},
				"Strong": {
					"Light": "#666666",
					"Dark": "#3e3e53"
				}
			},
			"Status": {
				"Success": {
					"Light": "#008000",
					"Dark": "#80ff80"
				},
				"Warning": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Error": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"Info": {
					"Light": "#000080",
					"Dark": "#80c0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d8d3b8",
					"Dark": "#26263a"
				},
				"Thumb": {
					"Light": "#7d7d7d",
					"Dark": "#66656c"
				},
				"Hover": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#a09ebb",
					"Dark": "#3d4770"
				},
				"Text": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"String": {
					"Light": "#008000",
					"Dark": "#80ff80"
				},
				"Number": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Comment": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				},
				"Operator": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"Punctuation": {
					"Light": "#4a4a4a",
					"Dark": "#b8b6a8"
				},
				"Function": {
					"Light": "#000080",
					"Dark": "#80c0ff"
				},
				"Variable": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				},
				"Type": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Builtin": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Property": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"Tag": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"AttrName": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"AttrValue": {
					"Light": "#008000",
					"Dark": "#80ff80"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "1997 (Win95/98)",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],315:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-sgi",
	"Name": "DataBeacon \u2014 SGI",
	"Version": "0.0.1",
	"Description": "SGI Indy / IRIX palette \u2014 magenta with cyan highlights. Light: signature SGI grey. Dark: deep workstation black with the same hot magenta.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#c8c8c8",
					"Dark": "#1a1a1a"
				},
				"Secondary": {
					"Light": "#b8b8b8",
					"Dark": "#232323"
				},
				"Tertiary": {
					"Light": "#c0c0c0",
					"Dark": "#1e1e1e"
				},
				"Panel": {
					"Light": "#dcdcdc",
					"Dark": "#252525"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#2e2e2e"
				},
				"Hover": {
					"Light": "#c0c0c0",
					"Dark": "#181818"
				},
				"Selected": {
					"Light": "#c8a9bb",
					"Dark": "#432635"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				},
				"Secondary": {
					"Light": "#4a4a4a",
					"Dark": "#a8a8a8"
				},
				"Muted": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				},
				"Placeholder": {
					"Light": "#8d8d8d",
					"Dark": "#515151"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a0a0a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"PrimaryHover": {
					"Light": "#e040a0",
					"Dark": "#ff80c8"
				},
				"Accent": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"AccentHover": {
					"Light": "#e040a0",
					"Dark": "#ff80c8"
				}
			},
			"Border": {
				"Default": {
					"Light": "#808080",
					"Dark": "#505050"
				},
				"Light": {
					"Light": "#a4a4a4",
					"Dark": "#353535"
				},
				"Strong": {
					"Light": "#666666",
					"Dark": "#404040"
				}
			},
			"Status": {
				"Success": {
					"Light": "#208040",
					"Dark": "#50d080"
				},
				"Warning": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Error": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"Info": {
					"Light": "#3080c0",
					"Dark": "#60c0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#b8b8b8",
					"Dark": "#232323"
				},
				"Thumb": {
					"Light": "#777777",
					"Dark": "#606060"
				},
				"Hover": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#c892b0",
					"Dark": "#63304a"
				},
				"Text": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"String": {
					"Light": "#208040",
					"Dark": "#50d080"
				},
				"Number": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Comment": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				},
				"Operator": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"Punctuation": {
					"Light": "#4a4a4a",
					"Dark": "#a8a8a8"
				},
				"Function": {
					"Light": "#3080c0",
					"Dark": "#60c0ff"
				},
				"Variable": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				},
				"Type": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Builtin": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Property": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"Tag": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"AttrName": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"AttrValue": {
					"Light": "#208040",
					"Dark": "#50d080"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "SGI",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],316:[function(require,module,exports){
module.exports={
	"Hash": "daylight",
	"Name": "Daylight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Bright white, dark text Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FFFFFF",
				"Secondary": "#F0F0F0",
				"Tertiary": "#E8E8E8",
				"Panel": "#F5F5F5",
				"Viewer": "#FAFAFA",
				"Hover": "#E0E0E0",
				"Selected": "#C8C8C8",
				"Thumb": "#F0F0F0"
			},
			"Text": {
				"Primary": "#1A1A1A",
				"Secondary": "#333333",
				"Muted": "#666666",
				"Dim": "#888888",
				"Placeholder": "#AAAAAA"
			},
			"Brand": {
				"Accent": "#444444",
				"AccentHover": "#222222"
			},
			"Border": {
				"Default": "#D0D0D0",
				"Light": "#E0E0E0"
			},
			"Status": {
				"Danger": "#CC0000",
				"DangerMuted": "#884444"
			},
			"Scrollbar": {
				"Track": "#C0C0C0",
				"Hover": "#A0A0A0"
			},
			"Selection": {
				"Background": "rgba(68, 68, 68, 0.2)"
			},
			"Focus": {
				"Outline": "#444444"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#444444",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Segoe UI', system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#333333",
		"Accent": "#444444",
		"Muted": "#888888",
		"Light": "#E8E8E8",
		"WarmBeige": "#F0F0F0",
		"TealTint": "#E0E0E0",
		"Lavender": "#EBEBEB",
		"AmberTint": "#F0EDE8",
		"PdfFill": "#F0E0E0",
		"PdfText": "#CC0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],317:[function(require,module,exports){
module.exports={
	"Hash": "early-2000s",
	"Name": "Early 2000s Web",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Teal and silver, Web 2.0 Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8F4F8",
				"Secondary": "#D0E8EE",
				"Tertiary": "#C0DDE6",
				"Panel": "#D8EEF2",
				"Viewer": "#F0F8FA",
				"Hover": "#B0D4E0",
				"Selected": "#88C4D8",
				"Thumb": "#D0E8EE"
			},
			"Text": {
				"Primary": "#1A3A4A",
				"Secondary": "#2A4A5A",
				"Muted": "#5A7A8A",
				"Dim": "#7A9AAA",
				"Placeholder": "#9ABACA"
			},
			"Brand": {
				"Accent": "#0099CC",
				"AccentHover": "#00AADD"
			},
			"Border": {
				"Default": "#A0C8D8",
				"Light": "#B8D8E4"
			},
			"Status": {
				"Danger": "#CC3300",
				"DangerMuted": "#994422"
			},
			"Scrollbar": {
				"Track": "#A0C8D8",
				"Hover": "#88B8CC"
			},
			"Selection": {
				"Background": "rgba(0, 153, 204, 0.2)"
			},
			"Focus": {
				"Outline": "#0099CC"
			},
			"Syntax": {
				"Keyword":     "#1A4080",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#333333",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Verdana, Geneva, Tahoma, sans-serif",
				"Mono": "'Lucida Console', Monaco, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#2A4A5A",
		"Accent": "#0099CC",
		"Muted": "#7A9AAA",
		"Light": "#C0DDE6",
		"WarmBeige": "#D0E8EE",
		"TealTint": "#B0D8E4",
		"Lavender": "#C8DCE6",
		"AmberTint": "#D8E0D0",
		"PdfFill": "#E0C8C0",
		"PdfText": "#CC3300"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],318:[function(require,module,exports){
module.exports={
	"Hash": "evening",
	"Name": "Evening",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Medium grey, transitional Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#484848",
				"Secondary": "#3C3C3C",
				"Tertiary": "#424242",
				"Panel": "#454545",
				"Viewer": "#363636",
				"Hover": "#525252",
				"Selected": "#606060",
				"Thumb": "#3C3C3C"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#D0D0D0",
				"Muted": "#A0A0A0",
				"Dim": "#888888",
				"Placeholder": "#707070"
			},
			"Brand": {
				"Accent": "#C0C0C0",
				"AccentHover": "#E0E0E0"
			},
			"Border": {
				"Default": "#585858",
				"Light": "#606060"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#585858",
				"Hover": "#686868"
			},
			"Selection": {
				"Background": "rgba(192, 192, 192, 0.25)"
			},
			"Focus": {
				"Outline": "#C0C0C0"
			},
			"Syntax": {
				"Keyword":     "#B894FF",
				"String":      "#A8D8B0",
				"Number":      "#FFB880",
				"Comment":     "#8A8A8A",
				"Operator":    "#7EC0FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFCC80",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB880",
				"Builtin":     "#FFB880",
				"Property":    "#FF9494",
				"Tag":         "#FF9494",
				"AttrName":    "#FFB880",
				"AttrValue":   "#A8D8B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0D0D0",
		"Accent": "#C0C0C0",
		"Muted": "#888888",
		"Light": "#424242",
		"WarmBeige": "#484848",
		"TealTint": "#3E3E3E",
		"Lavender": "#444444",
		"AmberTint": "#4A4640",
		"PdfFill": "#4A3C3C",
		"PdfText": "#FF6666"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],319:[function(require,module,exports){
module.exports={
	"Hash": "flow-blueprint",
	"Name": "Flow Blueprint",
	"Version": "0.0.1",
	"Description": "Technical-drawing aesthetic — white-on-navy with yellow selection. Single-mode (always dark blueprint).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1a3a6a",
				"Secondary": "#142e54",
				"Tertiary":  "rgba(255,255,255,0.1)",
				"Panel":     "#1a3a6a",
				"Hover":     "rgba(255,255,255,0.06)",
				"Selected":  "rgba(255,221,68,0.18)"
			},
			"Text": {
				"Primary":   "#ffffff",
				"Secondary": "rgba(255,255,255,0.7)",
				"Muted":     "rgba(255,255,255,0.5)",
				"OnBrand":   "#0d2244"
			},
			"Brand": {
				"Primary":      "#ffdd44",
				"PrimaryHover": "#ffe978",
				"Accent":       "#88ffbb"
			},
			"Border": {
				"Default": "rgba(255,255,255,0.6)",
				"Light":   "rgba(255,255,255,0.15)",
				"Strong":  "#ffffff"
			},
			"Status": {
				"Success": "#88ffbb",
				"Warning": "#ffdd44",
				"Error":   "#ff8888",
				"Info":    "#88bbff"
			},
			"Scrollbar": {
				"Track": "rgba(255,255,255,0.05)",
				"Thumb": "rgba(255,255,255,0.3)",
				"Hover": "rgba(255,255,255,0.5)"
			},
			"Focus": {
				"Outline": "#ffdd44"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.4)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Blueprint",
		"Tagline": "Technical drawing on navy"
	}
}

},{}],320:[function(require,module,exports){
module.exports={
	"Hash": "flow-modern",
	"Name": "Flow Modern",
	"Version": "0.0.1",
	"Description": "The default modern look for pict-section-flow — clean, theme-neutral. Paired light/dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ecf0f1", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#eef3f7", "Dark": "#2a2a2a" },
				"Selected":  { "Light": "#dde7f3", "Dark": "#2a3550" }
			},
			"Text": {
				"Primary":   { "Light": "#2c3e50", "Dark": "#ededed" },
				"Secondary": { "Light": "#7f8c8d", "Dark": "#bdbdbd" },
				"Muted":     { "Light": "#95a5a6", "Dark": "#888888" },
				"OnBrand":   { "Light": "#ffffff", "Dark": "#1a1a1a" }
			},
			"Brand": {
				"Primary":      { "Light": "#2255aa", "Dark": "#5b8aff" },
				"PrimaryHover": { "Light": "#1a4488", "Dark": "#7ba4ff" },
				"Accent":       { "Light": "#1abc9c", "Dark": "#4fd1b5" }
			},
			"Border": {
				"Default": { "Light": "#bdc3c7", "Dark": "#3a3a3a" },
				"Light":   { "Light": "#ecf0f1", "Dark": "#2c2c2c" },
				"Strong":  { "Light": "#95a5a6", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#27ae60", "Dark": "#5fc377" },
				"Warning": { "Light": "#f39c12", "Dark": "#f0b84a" },
				"Error":   { "Light": "#e74c3c", "Dark": "#ff7373" },
				"Info":    { "Light": "#3498db", "Dark": "#5fb4ff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#ecf0f1", "Dark": "#1f1f1f" },
				"Thumb": { "Light": "#bdc3c7", "Dark": "#3f3f3f" },
				"Hover": { "Light": "#95a5a6", "Dark": "#5a5a5a" }
			},
			"Focus": {
				"Outline": { "Light": "#2255aa", "Dark": "#5b8aff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			}
		}
	},
	"Brand": {
		"Name": "Flow Modern",
		"Tagline": "Clean modern flow editor look"
	}
}

},{}],321:[function(require,module,exports){
module.exports={
	"Hash": "flow-mono",
	"Name": "Flow Mono",
	"Version": "0.0.1",
	"Description": "High-contrast monochrome flow editor look. Paired light/dark — pure black on white or white on black.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#000000" },
				"Secondary": { "Light": "#f0f0f0", "Dark": "#1a1a1a" },
				"Tertiary":  { "Light": "#e0e0e0", "Dark": "#262626" },
				"Panel":     { "Light": "#ffffff", "Dark": "#000000" },
				"Hover":     { "Light": "#eeeeee", "Dark": "#1f1f1f" },
				"Selected":  { "Light": "#dddddd", "Dark": "#333333" }
			},
			"Text": {
				"Primary":   { "Light": "#000000", "Dark": "#ffffff" },
				"Secondary": { "Light": "#444444", "Dark": "#cccccc" },
				"Muted":     { "Light": "#888888", "Dark": "#888888" },
				"OnBrand":   { "Light": "#ffffff", "Dark": "#000000" }
			},
			"Brand": {
				"Primary":      { "Light": "#444444", "Dark": "#bbbbbb" },
				"PrimaryHover": { "Light": "#222222", "Dark": "#dddddd" },
				"Accent":       { "Light": "#666666", "Dark": "#999999" }
			},
			"Border": {
				"Default": { "Light": "#000000", "Dark": "#ffffff" },
				"Light":   { "Light": "#cccccc", "Dark": "#333333" },
				"Strong":  { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#000000", "Dark": "#ffffff" },
				"Warning": { "Light": "#000000", "Dark": "#ffffff" },
				"Error":   { "Light": "#000000", "Dark": "#ffffff" },
				"Info":    { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#f0f0f0", "Dark": "#1a1a1a" },
				"Thumb": { "Light": "#888888", "Dark": "#888888" },
				"Hover": { "Light": "#444444", "Dark": "#cccccc" }
			},
			"Focus": {
				"Outline": { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.25)", "Dark": "rgba(255, 255, 255, 0.25)" }
			}
		}
	},
	"Brand": {
		"Name": "Flow Mono",
		"Tagline": "Monochrome ink-on-paper"
	}
}

},{}],322:[function(require,module,exports){
module.exports={
	"Hash": "flow-retro-80s",
	"Name": "Flow Retro 80s",
	"Version": "0.0.1",
	"Description": "Neon-on-purple synthwave aesthetic for the flow editor. Single-mode (always dark) — '80s arcade glow.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#0a0015",
				"Secondary": "#1a0a2e",
				"Tertiary":  "#2a0a4e",
				"Panel":     "#1a0a2e",
				"Hover":     "#2a0a4e",
				"Selected":  "#3a1466"
			},
			"Text": {
				"Primary":   "#00ffff",
				"Secondary": "#ff66ff",
				"Muted":     "#9966cc",
				"OnBrand":   "#0a0015"
			},
			"Brand": {
				"Primary":      "#ff00ff",
				"PrimaryHover": "#ff66ff",
				"Accent":       "#00ffff"
			},
			"Border": {
				"Default": "#ff00ff",
				"Light":   "#2a0a4e",
				"Strong":  "#ff00ff"
			},
			"Status": {
				"Success": "#00ff66",
				"Warning": "#ffdd44",
				"Error":   "#ff4477",
				"Info":    "#00ffff"
			},
			"Scrollbar": {
				"Track": "#1a0a2e",
				"Thumb": "#ff00ff",
				"Hover": "#ff66ff"
			},
			"Focus": {
				"Outline": "#00ffff"
			},
			"Shadow": {
				"Color": "rgba(255, 0, 255, 0.4)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Retro 80s",
		"Tagline": "Neon synthwave glow"
	}
}

},{}],323:[function(require,module,exports){
module.exports={
	"Hash": "flow-retro-90s",
	"Name": "Flow Retro 90s",
	"Version": "0.0.1",
	"Description": "Windows-95 aesthetic — gray panels, navy title bars, teal desktop. Single-mode (always its specific palette).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#008080",
				"Secondary": "#c0c0c0",
				"Tertiary":  "#d0d0d0",
				"Panel":     "#c0c0c0",
				"Hover":     "#d0d0d0",
				"Selected":  "#a8c8e0"
			},
			"Text": {
				"Primary":   "#000000",
				"Secondary": "#404040",
				"Muted":     "#606060",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#000080",
				"PrimaryHover": "#0000a0",
				"Accent":       "#008000"
			},
			"Border": {
				"Default": "#808080",
				"Light":   "#a0a0a0",
				"Strong":  "#404040"
			},
			"Status": {
				"Success": "#008000",
				"Warning": "#808000",
				"Error":   "#800000",
				"Info":    "#000080"
			},
			"Scrollbar": {
				"Track": "#c0c0c0",
				"Thumb": "#808080",
				"Hover": "#404040"
			},
			"Focus": {
				"Outline": "#008080"
			},
			"Shadow": {
				"Color": "#404040"
			}
		}
	},
	"Brand": {
		"Name": "Flow Retro 90s",
		"Tagline": "Workstation chrome from the 90s"
	}
}

},{}],324:[function(require,module,exports){
module.exports={
	"Hash": "flow-sketch",
	"Name": "Flow Sketch",
	"Version": "0.0.1",
	"Description": "Warm-paper sketch aesthetic for the flow editor. Single-mode (always light) — sketches live on paper.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#fffef5",
				"Secondary": "#faf8ed",
				"Tertiary":  "#f0ece0",
				"Panel":     "#fffef5",
				"Hover":     "#f4f0e2",
				"Selected":  "#e8dfc8"
			},
			"Text": {
				"Primary":   "#333333",
				"Secondary": "#555555",
				"Muted":     "#888888",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#2255aa",
				"PrimaryHover": "#1a4488",
				"Accent":       "#c47b5a"
			},
			"Border": {
				"Default": "#444444",
				"Light":   "#ccccaa",
				"Strong":  "#222222"
			},
			"Status": {
				"Success": "#55aa77",
				"Warning": "#d4a040",
				"Error":   "#c44836",
				"Info":    "#5577bb"
			},
			"Scrollbar": {
				"Track": "#f0ece0",
				"Thumb": "#c5c0a8",
				"Hover": "#9e9a82"
			},
			"Focus": {
				"Outline": "#2255aa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.08)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Sketch",
		"Tagline": "Hand-drawn paper aesthetic"
	}
}

},{}],325:[function(require,module,exports){
module.exports={
	"Hash": "flow-whiteboard",
	"Name": "Flow Whiteboard",
	"Version": "0.0.1",
	"Description": "Minimal whiteboard aesthetic — transparent fills with colored brackets per node type. Single-mode (light).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#ffffff",
				"Secondary": "#fafafa",
				"Tertiary":  "#f5f5f5",
				"Panel":     "#ffffff",
				"Hover":     "#f0f0f0",
				"Selected":  "#e0eaff"
			},
			"Text": {
				"Primary":   "#333333",
				"Secondary": "#555555",
				"Muted":     "#999999",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#2255aa",
				"PrimaryHover": "#1a4488",
				"Accent":       "#1abc9c"
			},
			"Border": {
				"Default": "#888888",
				"Light":   "#cccccc",
				"Strong":  "#555555"
			},
			"Status": {
				"Success": "#27ae60",
				"Warning": "#f39c12",
				"Error":   "#e74c3c",
				"Info":    "#3498db"
			},
			"Scrollbar": {
				"Track": "#f5f5f5",
				"Thumb": "#cccccc",
				"Hover": "#888888"
			},
			"Focus": {
				"Outline": "#2255aa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.06)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Whiteboard",
		"Tagline": "Minimal whiteboard sketching"
	}
}

},{}],326:[function(require,module,exports){
module.exports={
	"Hash": "forest",
	"Name": "Forest",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Deep greens and earth browns Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A2018",
				"Secondary": "#141A12",
				"Tertiary": "#1E2620",
				"Panel": "#1C221A",
				"Viewer": "#101410",
				"Hover": "#283828",
				"Selected": "#344834",
				"Thumb": "#141A12"
			},
			"Text": {
				"Primary": "#D0DCC8",
				"Secondary": "#B0C4A8",
				"Muted": "#809878",
				"Dim": "#607858",
				"Placeholder": "#486040"
			},
			"Brand": {
				"Accent": "#6AAF5C",
				"AccentHover": "#88CC78"
			},
			"Border": {
				"Default": "#2A3A28",
				"Light": "#3A4A38"
			},
			"Status": {
				"Danger": "#CC4422",
				"DangerMuted": "#884422"
			},
			"Scrollbar": {
				"Track": "#2A3A28",
				"Hover": "#3A4A38"
			},
			"Selection": {
				"Background": "rgba(106, 175, 92, 0.25)"
			},
			"Focus": {
				"Outline": "#6AAF5C"
			},
			"Syntax": {
				"Keyword":     "#D4E157",
				"String":      "#A5D6A7",
				"Number":      "#FFB74D",
				"Comment":     "#5D6F58",
				"Operator":    "#80CBC4",
				"Punctuation": "#A8C8A0",
				"Function":    "#FFCC80",
				"Variable":    "#C8E6C9",
				"Type":        "#FFB74D",
				"Builtin":     "#FFB74D",
				"Property":    "#FF8A65",
				"Tag":         "#FF8A65",
				"AttrName":    "#FFB74D",
				"AttrValue":   "#A5D6A7"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#B0C4A8",
		"Accent": "#6AAF5C",
		"Muted": "#607858",
		"Light": "#1E2620",
		"WarmBeige": "#22281E",
		"TealTint": "#1A221A",
		"Lavender": "#1E2420",
		"AmberTint": "#262218",
		"PdfFill": "#261A18",
		"PdfText": "#CC4422"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],327:[function(require,module,exports){
module.exports={
	"Hash": "hotdog",
	"Name": "Hotdog",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Red and mustard yellow, garish Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#8B0000",
				"Secondary": "#6B0000",
				"Tertiary": "#7B0000",
				"Panel": "#750000",
				"Viewer": "#550000",
				"Hover": "#AA1111",
				"Selected": "#BB3300",
				"Thumb": "#6B0000"
			},
			"Text": {
				"Primary": "#FFD700",
				"Secondary": "#FFC000",
				"Muted": "#CC9900",
				"Dim": "#AA7700",
				"Placeholder": "#886600"
			},
			"Brand": {
				"Accent": "#FFD700",
				"AccentHover": "#FFEE44"
			},
			"Border": {
				"Default": "#AA2222",
				"Light": "#BB3333"
			},
			"Status": {
				"Danger": "#FFFF00",
				"DangerMuted": "#CCCC00"
			},
			"Scrollbar": {
				"Track": "#AA2222",
				"Hover": "#CC3333"
			},
			"Selection": {
				"Background": "rgba(255, 215, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFD700"
			},
			"Syntax": {
				"Keyword":     "#FFD800",
				"String":      "#FFFFFF",
				"Number":      "#FFD800",
				"Comment":     "#9C2828",
				"Operator":    "#FFD800",
				"Punctuation": "#FFFFFF",
				"Function":    "#FFD800",
				"Variable":    "#FFFFFF",
				"Type":        "#FFD800",
				"Builtin":     "#FFD800",
				"Property":    "#FFD800",
				"Tag":         "#FFD800",
				"AttrName":    "#FFD800",
				"AttrValue":   "#FFFFFF"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Impact, 'Arial Black', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFC000",
		"Accent": "#FFD700",
		"Muted": "#AA7700",
		"Light": "#7B0000",
		"WarmBeige": "#800000",
		"TealTint": "#6B0000",
		"Lavender": "#780000",
		"AmberTint": "#7A1000",
		"PdfFill": "#6B0000",
		"PdfText": "#FFFF00"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],328:[function(require,module,exports){
module.exports={
	"Hash": "mobile-debug",
	"Name": "Mobile Container Debug",
	"Category": "Debug",
	"Version": "0.0.1",
	"Description": "Unique color per container for layout debugging Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FF0000",
				"Secondary": "#00CCCC",
				"Tertiary": "#00AA00",
				"Panel": "#FFAA00",
				"Viewer": "#333333",
				"Hover": "rgba(255, 255, 255, 0.2)",
				"Selected": "rgba(255, 255, 255, 0.3)",
				"Thumb": "#AA00AA"
			},
			"Text": {
				"Primary": "#FFFFFF",
				"Secondary": "#EEEEEE",
				"Muted": "#CCCCCC",
				"Dim": "#AAAAAA",
				"Placeholder": "#888888"
			},
			"Brand": {
				"Accent": "#FFFF00",
				"AccentHover": "#FFFF88"
			},
			"Border": {
				"Default": "#FFFFFF",
				"Light": "#CCCCCC"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#CC4444"
			},
			"Scrollbar": {
				"Track": "#888888",
				"Hover": "#AAAAAA"
			},
			"Selection": {
				"Background": "rgba(255, 255, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFFF00"
			},
			"Syntax": {
				"Keyword":     "#A626A4",
				"String":      "#50A14F",
				"Number":      "#986801",
				"Comment":     "#A0A1A7",
				"Operator":    "#0184BC",
				"Punctuation": "#383A42",
				"Function":    "#4078F2",
				"Variable":    "#383A42",
				"Type":        "#C18401",
				"Builtin":     "#986801",
				"Property":    "#E45649",
				"Tag":         "#E45649",
				"AttrName":    "#986801",
				"AttrValue":   "#50A14F"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFFFFF",
		"Accent": "#FFFF00",
		"Muted": "#CCCCCC",
		"Light": "#333333",
		"WarmBeige": "#FFAA00",
		"TealTint": "#00CCCC",
		"Lavender": "#AA00AA",
		"AmberTint": "#FFAA00",
		"PdfFill": "#FF4444",
		"PdfText": "#FFFFFF"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],329:[function(require,module,exports){
module.exports={
	"Hash": "neo-tokyo",
	"Name": "Neo-Tokyo",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Neon pink on dark navy Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0D0D2B",
				"Secondary": "#080820",
				"Tertiary": "#121235",
				"Panel": "#0F0F28",
				"Viewer": "#060615",
				"Hover": "#1A1A42",
				"Selected": "#2A1845",
				"Thumb": "#080820"
			},
			"Text": {
				"Primary": "#E8E0F0",
				"Secondary": "#D0C8E0",
				"Muted": "#9088A8",
				"Dim": "#6860A0",
				"Placeholder": "#504888"
			},
			"Brand": {
				"Accent": "#FF2D8A",
				"AccentHover": "#FF5AA0"
			},
			"Border": {
				"Default": "#2A2050",
				"Light": "#382868"
			},
			"Status": {
				"Danger": "#FF4466",
				"DangerMuted": "#AA3355"
			},
			"Scrollbar": {
				"Track": "#2A2050",
				"Hover": "#3A3068"
			},
			"Selection": {
				"Background": "rgba(255, 45, 138, 0.25)"
			},
			"Focus": {
				"Outline": "#FF2D8A"
			},
			"Syntax": {
				"Keyword":     "#FF4E9F",
				"String":      "#A1FFCE",
				"Number":      "#FFD93D",
				"Comment":     "#807A9E",
				"Operator":    "#7DF9FF",
				"Punctuation": "#C0BCEB",
				"Function":    "#FFCC80",
				"Variable":    "#E0D8FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF6E6E",
				"Tag":         "#FF6E6E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#A1FFCE"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0C8E0",
		"Accent": "#FF2D8A",
		"Muted": "#6860A0",
		"Light": "#121235",
		"WarmBeige": "#141438",
		"TealTint": "#100E30",
		"Lavender": "#141232",
		"AmberTint": "#1A1228",
		"PdfFill": "#1A1028",
		"PdfText": "#FF4466"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],330:[function(require,module,exports){
module.exports={
	"Hash": "night",
	"Name": "Night",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Near-black, minimal contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0A0A",
				"Secondary": "#060606",
				"Tertiary": "#0E0E0E",
				"Panel": "#0C0C0C",
				"Viewer": "#040404",
				"Hover": "#161616",
				"Selected": "#252525",
				"Thumb": "#060606"
			},
			"Text": {
				"Primary": "#888888",
				"Secondary": "#707070",
				"Muted": "#555555",
				"Dim": "#444444",
				"Placeholder": "#333333"
			},
			"Brand": {
				"Accent": "#666666",
				"AccentHover": "#808080"
			},
			"Border": {
				"Default": "#1A1A1A",
				"Light": "#222222"
			},
			"Status": {
				"Danger": "#AA4444",
				"DangerMuted": "#663333"
			},
			"Scrollbar": {
				"Track": "#1A1A1A",
				"Hover": "#2A2A2A"
			},
			"Selection": {
				"Background": "rgba(102, 102, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#666666"
			},
			"Syntax": {
				"Keyword":     "#C28FFF",
				"String":      "#B0E0B0",
				"Number":      "#FFA070",
				"Comment":     "#888888",
				"Operator":    "#80C8FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFD080",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF9090",
				"Tag":         "#FF9090",
				"AttrName":    "#FFB870",
				"AttrValue":   "#B0E0B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#707070",
		"Accent": "#666666",
		"Muted": "#444444",
		"Light": "#0E0E0E",
		"WarmBeige": "#121212",
		"TealTint": "#0C0C0C",
		"Lavender": "#101010",
		"AmberTint": "#141210",
		"PdfFill": "#141010",
		"PdfText": "#AA4444"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],331:[function(require,module,exports){
module.exports={
	"Hash": "ocean",
	"Name": "Ocean",
	"Version": "0.0.1",
	"Description": "Cool blue-greens (180-235°) with warm coral / amber punctuation (5-30°). Paired light/dark; feels like sea + sun on the horizon.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#f4f9fb", "Dark": "#0e1820" },
				"Secondary": { "Light": "#e8f1f5", "Dark": "#15212b" },
				"Tertiary":  { "Light": "#dde9ee", "Dark": "#1f2c38" },
				"Panel":     { "Light": "#ffffff", "Dark": "#1a2632" },
				"Hover":     { "Light": "#e0eef3", "Dark": "#26323f" },
				"Selected":  { "Light": "#c8e1ea", "Dark": "#1e3a48" }
			},
			"Text": {
				"Primary":     { "Light": "#0e2832", "Dark": "#e1ecf0" },
				"Secondary":   { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Muted":       { "Light": "#6c828b", "Dark": "#7a8e96" },
				"Placeholder": { "Light": "#90a4ad", "Dark": "#5a6e76" }
			},
			"Brand": {
				"Primary":      { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"PrimaryHover": { "Light": "#0a6371", "Dark": "#6dd4e2" },
				"Accent":       { "Light": "#e8a050", "Dark": "#f0b878" }
			},
			"Border": {
				"Default": { "Light": "#c0d5dc", "Dark": "#2c3d49" },
				"Light":   { "Light": "#d8e6ec", "Dark": "#1f2c38" },
				"Strong":  { "Light": "#90b0bc", "Dark": "#4a6470" }
			},
			"Status": {
				"Success": { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"Warning": { "Light": "#d68910", "Dark": "#f0b020" },
				"Error":   { "Light": "#c93a3a", "Dark": "#ff6464" },
				"Info":    { "Light": "#0e7c8a", "Dark": "#4dc4d4" }
			},
			"Data": {
				"1": { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"2": { "Light": "#e8a050", "Dark": "#f0b878" },
				"3": { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"4": { "Light": "#c93a3a", "Dark": "#ff6464" },
				"5": { "Light": "#b07bac", "Dark": "#cda6cf" },
				"6": { "Light": "#d68910", "Dark": "#f0b020" },
				"7": { "Light": "#5a7f9e", "Dark": "#82a0c4" },
				"8": { "Light": "#6c828b", "Dark": "#a8c0c8" }
			},
			"Scrollbar": {
				"Track": { "Light": "#dde9ee", "Dark": "#15212b" },
				"Thumb": { "Light": "#a8c2cc", "Dark": "#324658" },
				"Hover": { "Light": "#7a99a4", "Dark": "#506876" }
			},
			"Selection": {
				"Background": { "Light": "#c8e1ea", "Dark": "#1e3a48" },
				"Text":       { "Light": "#0e2832", "Dark": "#e1ecf0" }
			},
			"Focus": {
				"Outline": { "Light": "#0e7c8a", "Dark": "#4dc4d4" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(14, 40, 50, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"String":      { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"Number":      { "Light": "#d68910", "Dark": "#f0b020" },
				"Comment":     { "Light": "#90a4ad", "Dark": "#5a6e76" },
				"Operator":    { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Punctuation": { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Function":    { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"Variable":    { "Light": "#0e2832", "Dark": "#e1ecf0" },
				"Type":        { "Light": "#e8a050", "Dark": "#f0b878" },
				"Builtin":     { "Light": "#d68910", "Dark": "#f0b020" },
				"Property":    { "Light": "#c93a3a", "Dark": "#ff6464" },
				"Tag":         { "Light": "#c93a3a", "Dark": "#ff6464" },
				"AttrName":    { "Light": "#d68910", "Dark": "#f0b020" },
				"AttrValue":   { "Light": "#1f8a52", "Dark": "#4dc97a" }
			},
			"Editor": {
				"LineNumberBackground": { "Light": "#e8f1f5", "Dark": "#15212b" },
				"LineNumberText":       { "Light": "#90a4ad", "Dark": "#5a6e76" },
				"CurrentLineHighlight": { "Light": "#e0eef3", "Dark": "#26323f" },
				"SelectionBackground":  { "Light": "#c8e1ea", "Dark": "#1e3a48" },
				"GutterBorder":         { "Light": "#d8e6ec", "Dark": "#1f2c38" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Ocean",
		"Tagline": "Cool waters, warm sun"
	}
}

},{}],332:[function(require,module,exports){
module.exports={
	"Hash": "pict-default",
	"Name": "Pict Default",
	"Version": "0.0.1",
	"Description": "The reference paired light/dark theme for pict-based applications. Neutral palette suitable for any app; dark mode is mid-grey rather than pure black to reduce eye strain.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ebebeb", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#f0f0f0", "Dark": "#2a2a2a" },
				"Selected":  { "Light": "#e0eaff", "Dark": "#2a3550" }
			},
			"Text": {
				"Primary":     { "Light": "#1a1a1a", "Dark": "#ededed" },
				"Secondary":   { "Light": "#454545", "Dark": "#bdbdbd" },
				"Muted":       { "Light": "#6b6b6b", "Dark": "#888888" },
				"Placeholder": { "Light": "#9a9a9a", "Dark": "#6a6a6a" }
			},
			"Brand": {
				"Primary":      { "Light": "#3357c7", "Dark": "#6b8eff" },
				"PrimaryHover": { "Light": "#2848b3", "Dark": "#88a4ff" },
				"Accent":       { "Light": "#c75033", "Dark": "#ff8a6b" }
			},
			"Border": {
				"Default": { "Light": "#d6d6d6", "Dark": "#3a3a3a" },
				"Light":   { "Light": "#e9e9e9", "Dark": "#2c2c2c" },
				"Strong":  { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"Warning": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"Error":   { "Light": "#b62828", "Dark": "#ff7373" },
				"Info":    { "Light": "#1f6fb5", "Dark": "#5fb4ff" }
			},
			"Data": {
				"1": { "Light": "#3357c7", "Dark": "#6b8eff" },
				"2": { "Light": "#c75033", "Dark": "#ff8a6b" },
				"3": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"4": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"5": { "Light": "#6b3aac", "Dark": "#b08eff" },
				"6": { "Light": "#1f6fb5", "Dark": "#5fb4ff" },
				"7": { "Light": "#c63a8e", "Dark": "#ff7fb6" },
				"8": { "Light": "#6b6b6b", "Dark": "#bdbdbd" }
			},
			"Scrollbar": {
				"Track": { "Light": "#ebebeb", "Dark": "#1f1f1f" },
				"Thumb": { "Light": "#c2c2c2", "Dark": "#3f3f3f" },
				"Hover": { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Selection": {
				"Background": { "Light": "#bcd2ff", "Dark": "#3a4f7a" },
				"Text":       { "Light": "#1a1a1a", "Dark": "#ededed" }
			},
			"Focus": {
				"Outline": { "Light": "#3357c7", "Dark": "#6b8eff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			},
			"Editor": {
				"LineNumberBackground": { "Light": "#f5f5f5", "Dark": "#1f1f1f" },
				"LineNumberText":       { "Light": "#9a9a9a", "Dark": "#6a6a6a" },
				"CurrentLineHighlight": { "Light": "#f0f0f0", "Dark": "#2a2a2a" },
				"SelectionBackground":  { "Light": "#bcd2ff", "Dark": "#3a4f7a" },
				"GutterBorder":         { "Light": "#e9e9e9", "Dark": "#2c2c2c" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Pict",
		"Tagline": "A JavaScript MVC framework for building web applications."
	},
	"CSS": [
		{
			"Hash": "pict-default-brand-accents",
			"Priority": 600,
			"Content": "/* pict-default — subtle brand-aware accents.\n   Falls back gracefully to theme-color tokens when no brand is registered,\n   so non-branded apps still look right. */\na { text-decoration-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, currentColor)); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 2px solid var(--brand-color-primary-mode, var(--theme-color-border-default, transparent)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-light, transparent)); padding-bottom: 4px; }"
		}
	]
}

},{}],333:[function(require,module,exports){
module.exports={
	"Hash": "playground-corp",
	"Name": "Playground Corp",
	"Version": "0.0.1",
	"Description": "A different paired starter — corporate teal palette, rounder corners.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#fbfbfd", "Dark": "#0e1416" },
				"Secondary": { "Light": "#eef3f6", "Dark": "#152024" },
				"Tertiary":  { "Light": "#dde7ec", "Dark": "#1e2c30" },
				"Panel":     { "Light": "#ffffff", "Dark": "#162126" },
				"Hover":     { "Light": "#e5edf1", "Dark": "#1d292e" }
			},
			"Text": {
				"Primary":     { "Light": "#0a1d22", "Dark": "#e3edf0" },
				"Secondary":   { "Light": "#3a5b65", "Dark": "#a8c0c8" },
				"Muted":       { "Light": "#647e87", "Dark": "#7a929a" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Brand": {
				"Primary":      { "Light": "#117a8b", "Dark": "#3ec0d4" },
				"PrimaryHover": { "Light": "#0e6271", "Dark": "#5fd0e0" },
				"Accent":       { "Light": "#d97706", "Dark": "#fb923c" }
			},
			"Border": {
				"Default": { "Light": "#cfdce1", "Dark": "#2c3a3f" },
				"Strong":  { "Light": "#86a3ac", "Dark": "#4d5e64" }
			},
			"Status": {
				"Success": { "Light": "#0f7a52", "Dark": "#34d399" },
				"Warning": { "Light": "#b45309", "Dark": "#fbbf24" },
				"Error":   { "Light": "#9f1239", "Dark": "#fb7185" },
				"Info":    { "Light": "#1e6fbe", "Dark": "#60a5fa" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Inter, system-ui, sans-serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.25rem"
			},
			"Weight": {
				"Regular": "400",
				"Bold": "700"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "14px",
			"LG": "20px",
			"XL": "28px"
		},
		"Radius": {
			"SM": "4px",
			"MD": "10px",
			"LG": "16px"
		}
	},
	"Brand": {
		"Name": "Corp"
	},
	"Aliases": {
		"--pict-modal-overlay-bg":          "Color.Background.Tertiary",
		"--pict-modal-bg":                  "Color.Background.Panel",
		"--pict-modal-fg":                  "Color.Text.Primary",
		"--pict-modal-border":              "Color.Border.Default",
		"--pict-modal-shadow":              "Color.Border.Strong",
		"--pict-modal-header-bg":           "Color.Background.Secondary",
		"--pict-modal-header-fg":           "Color.Text.Primary",
		"--pict-modal-header-border":       "Color.Border.Default",
		"--pict-modal-btn-bg":              "Color.Background.Secondary",
		"--pict-modal-btn-fg":              "Color.Text.Primary",
		"--pict-modal-btn-hover-bg":        "Color.Background.Hover",
		"--pict-modal-btn-primary-bg":      "Color.Brand.Primary",
		"--pict-modal-btn-primary-fg":      "Color.Text.OnBrand",
		"--pict-modal-btn-primary-hover-bg":"Color.Brand.PrimaryHover",
		"--pict-modal-btn-danger-bg":       "Color.Status.Error",
		"--pict-modal-btn-danger-fg":       "Color.Text.OnBrand",
		"--pict-modal-btn-danger-hover-bg": "Color.Status.Error",
		"--pict-modal-toast-bg":            "Color.Background.Panel",
		"--pict-modal-toast-fg":            "Color.Text.Primary",
		"--pict-modal-toast-shadow":        "Color.Border.Strong",
		"--pict-modal-toast-success-bg":    "Color.Status.Success",
		"--pict-modal-toast-error-bg":      "Color.Status.Error",
		"--pict-modal-toast-warning-bg":    "Color.Status.Warning",
		"--pict-modal-toast-info-bg":       "Color.Status.Info",
		"--pict-modal-tooltip-bg":          "Color.Background.Tertiary",
		"--pict-modal-tooltip-fg":          "Color.Text.Primary",
		"--pict-modal-font-family":         "Typography.Family.Sans",

		"--pict-um-bg":          "Color.Background.Panel",
		"--pict-um-fg":          "Color.Text.Primary",
		"--pict-um-muted":       "Color.Text.Muted",
		"--pict-um-accent":      "Color.Brand.Primary",
		"--pict-um-border":      "Color.Border.Default",
		"--pict-um-border-soft": "Color.Border.Light",
		"--pict-um-input-bg":    "Color.Background.Primary",
		"--pict-um-pill-bg":     "Color.Background.Tertiary",
		"--pict-um-font":        "Typography.Family.Sans"
	}
}

},{}],334:[function(require,module,exports){
module.exports={
	"Hash": "retold-content-system",
	"Name": "Retold Content System",
	"Version": "0.0.1",
	"Description": "Default palette for the Retold Content System editor — warm beige with teal accents. Light side preserves the original retold-content-system.css palette verbatim; dark side keeps the teal accent and warms the backgrounds into a deep walnut/charcoal range so dark mode reads as the same family of values rather than a generic dark theme.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#F5F3EE", "Dark": "#1F1B17" },
				"Secondary": { "Light": "#FAF8F4", "Dark": "#2A251F" },
				"Tertiary":  { "Light": "#F0EDE8", "Dark": "#332D26" },
				"Panel":     { "Light": "#FFFFFF", "Dark": "#26221C" },
				"Hover":     { "Light": "#EDE9E3", "Dark": "#383028" },
				"Selected":  { "Light": "#DCE9E7", "Dark": "#1E3833" }
			},
			"Text": {
				"Primary":     { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Secondary":   { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Muted":       { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Placeholder": { "Light": "#A89E91", "Dark": "#6E6457" },
				"OnBrand":     { "Light": "#FFFFFF", "Dark": "#1F1B17" }
			},
			"Brand": {
				"Primary":      { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"PrimaryHover": { "Light": "#3A9E92", "Dark": "#65CBBE" },
				"Accent":       { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"AccentHover":  { "Light": "#3A9E92", "Dark": "#65CBBE" }
			},
			"Border": {
				"Default": { "Light": "#DDD6CA", "Dark": "#3F362C" },
				"Light":   { "Light": "#E8E2D7", "Dark": "#33291F" },
				"Strong":  { "Light": "#C4BDB0", "Dark": "#5A4F40" }
			},
			"Status": {
				"Success": { "Light": "#7BC47F", "Dark": "#8FD493" },
				"Warning": { "Light": "#E8A94D", "Dark": "#F0BE6E" },
				"Error":   { "Light": "#D9534F", "Dark": "#E87B78" },
				"Info":    { "Light": "#5DA6C7", "Dark": "#7FBDD8" }
			},
			"Data": {
				"1": { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"2": { "Light": "#E8A94D", "Dark": "#F0BE6E" },
				"3": { "Light": "#7BC47F", "Dark": "#8FD493" },
				"4": { "Light": "#D9534F", "Dark": "#E87B78" },
				"5": { "Light": "#A07ACC", "Dark": "#BCA0DC" },
				"6": { "Light": "#5DA6C7", "Dark": "#7FBDD8" },
				"7": { "Light": "#C46B8A", "Dark": "#D8919E" },
				"8": { "Light": "#8A7F72", "Dark": "#B8AFA4" }
			},
			"Scrollbar": {
				"Track": { "Light": "#F5F0E8", "Dark": "#26221C" },
				"Thumb": { "Light": "#C4BDB0", "Dark": "#4A4036" },
				"Hover": { "Light": "#8A7F72", "Dark": "#6A5F50" }
			},
			"Selection": {
				"Background": { "Light": "#CDE3E0", "Dark": "#2E5B55" },
				"Text":       { "Light": "#3D3229", "Dark": "#E8DCC8" }
			},
			"Focus": {
				"Outline": { "Light": "#2E7D74", "Dark": "#4FB3A6" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(61, 50, 41, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#A0532E", "Dark": "#E89A6E" },
				"String":      { "Light": "#3F8A52", "Dark": "#8FD493" },
				"Number":      { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Comment":     { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Operator":    { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"Punctuation": { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Function":    { "Light": "#2E5E96", "Dark": "#7FBDD8" },
				"Variable":    { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Type":        { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Builtin":     { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Property":    { "Light": "#A0532E", "Dark": "#E89A6E" },
				"Tag":         { "Light": "#A0532E", "Dark": "#E89A6E" },
				"AttrName":    { "Light": "#A86B00", "Dark": "#E8A94D" },
				"AttrValue":   { "Light": "#3F8A52", "Dark": "#8FD493" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth":    "250px",
			"TopbarHeight":    "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Content",
		"Tagline": "Author content for the Retold ecosystem."
	}
}

},{}],335:[function(require,module,exports){
module.exports={
	"Hash": "retold-default",
	"Name": "Retold Default",
	"Version": "0.0.1",
	"Description": "The canonical paired light/dark theme for the Retold ecosystem. Neutral palette suitable for any retold-based app; dark mode is mid-grey rather than pure black to reduce eye strain.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#1a1a1a"
				},
				"Secondary": {
					"Light": "#f5f5f5",
					"Dark": "#242424"
				},
				"Tertiary": {
					"Light": "#ebebeb",
					"Dark": "#2e2e2e"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#222222"
				},
				"Hover": {
					"Light": "#f0f0f0",
					"Dark": "#2a2a2a"
				},
				"Selected": {
					"Light": "#e0eaff",
					"Dark": "#2a3550"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1a1a",
					"Dark": "#ededed"
				},
				"Secondary": {
					"Light": "#454545",
					"Dark": "#bdbdbd"
				},
				"Muted": {
					"Light": "#6b6b6b",
					"Dark": "#888888"
				},
				"Placeholder": {
					"Light": "#9a9a9a",
					"Dark": "#6a6a6a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#3357c7",
					"Dark": "#6b8eff"
				},
				"PrimaryHover": {
					"Light": "#2848b3",
					"Dark": "#88a4ff"
				},
				"Accent": {
					"Light": "#c75033",
					"Dark": "#ff8a6b"
				}
			},
			"Border": {
				"Default": {
					"Light": "#d6d6d6",
					"Dark": "#3a3a3a"
				},
				"Light": {
					"Light": "#e9e9e9",
					"Dark": "#2c2c2c"
				},
				"Strong": {
					"Light": "#a0a0a0",
					"Dark": "#5a5a5a"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e7a3a",
					"Dark": "#5fc377"
				},
				"Warning": {
					"Light": "#a86b00",
					"Dark": "#f0b84a"
				},
				"Error": {
					"Light": "#b62828",
					"Dark": "#ff7373"
				},
				"Info": {
					"Light": "#1f6fb5",
					"Dark": "#5fb4ff"
				}
			},
			"Data": {
				"1": {
					"Light": "#3357c7",
					"Dark": "#6b8eff"
				},
				"2": {
					"Light": "#c75033",
					"Dark": "#ff8a6b"
				},
				"3": {
					"Light": "#2e7a3a",
					"Dark": "#5fc377"
				},
				"4": {
					"Light": "#a86b00",
					"Dark": "#f0b84a"
				},
				"5": {
					"Light": "#6b3aac",
					"Dark": "#b08eff"
				},
				"6": {
					"Light": "#1f6fb5",
					"Dark": "#5fb4ff"
				},
				"7": {
					"Light": "#c63a8e",
					"Dark": "#ff7fb6"
				},
				"8": {
					"Light": "#6b6b6b",
					"Dark": "#bdbdbd"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ebebeb",
					"Dark": "#1f1f1f"
				},
				"Thumb": {
					"Light": "#c2c2c2",
					"Dark": "#3f3f3f"
				},
				"Hover": {
					"Light": "#a0a0a0",
					"Dark": "#5a5a5a"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#bcd2ff",
					"Dark": "#3a4f7a"
				},
				"Text": {
					"Light": "#1a1a1a",
					"Dark": "#ededed"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#3357c7",
					"Dark": "#6b8eff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#a626a4",
					"Dark": "#c678dd"
				},
				"String": {
					"Light": "#50a14f",
					"Dark": "#98c379"
				},
				"Number": {
					"Light": "#986801",
					"Dark": "#d19a66"
				},
				"Comment": {
					"Light": "#a0a1a7",
					"Dark": "#7f848e"
				},
				"Operator": {
					"Light": "#0184bc",
					"Dark": "#56b6c2"
				},
				"Punctuation": {
					"Light": "#383a42",
					"Dark": "#abb2bf"
				},
				"Function": {
					"Light": "#4078f2",
					"Dark": "#61afef"
				},
				"Variable": {
					"Light": "#383a42",
					"Dark": "#e06c75"
				},
				"Type": {
					"Light": "#c18401",
					"Dark": "#e5c07b"
				},
				"Builtin": {
					"Light": "#986801",
					"Dark": "#d19a66"
				},
				"Property": {
					"Light": "#e45649",
					"Dark": "#e06c75"
				},
				"Tag": {
					"Light": "#e45649",
					"Dark": "#e06c75"
				},
				"AttrName": {
					"Light": "#986801",
					"Dark": "#d19a66"
				},
				"AttrValue": {
					"Light": "#50a14f",
					"Dark": "#98c379"
				}
			},
			"Editor": {
				"LineNumberBackground": {
					"Light": "#f5f5f5",
					"Dark": "#1f1f1f"
				},
				"LineNumberText": {
					"Light": "#9a9a9a",
					"Dark": "#6a6a6a"
				},
				"CurrentLineHighlight": {
					"Light": "#f0f0f0",
					"Dark": "#2a2a2a"
				},
				"SelectionBackground": {
					"Light": "#bcd2ff",
					"Dark": "#3a4f7a"
				},
				"GutterBorder": {
					"Light": "#e9e9e9",
					"Dark": "#2c2c2c"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Retold",
		"Tagline": "What is software if not a tool to tell stories."
	},
	"CSS": [
		{
			"Hash": "retold-default-brand-accents",
			"Priority": 600,
			"Content": "/* pict-default \u2014 subtle brand-aware accents.\n   Falls back gracefully to theme-color tokens when no brand is registered,\n   so non-branded apps still look right. */\na { text-decoration-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, currentColor)); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 2px solid var(--brand-color-primary-mode, var(--theme-color-border-default, transparent)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-light, transparent)); padding-bottom: 4px; }"
		}
	]
}
},{}],336:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs-cyberpunk",
	"Name": "Retold Labs Cyberpunk",
	"Version": "0.0.1",
	"Description": "retold-labs’ neon \"cyberpunk\" identity — cyan/magenta on near-black (dark) or violet on light. Preserves the original cyberpunk-light / cyberpunk-dark palettes verbatim.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#eae8f0",
					"Dark": "#0a0a12"
				},
				"Secondary": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Tertiary": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Panel": {
					"Light": "#f4f2fa",
					"Dark": "#1a1628"
				},
				"Sidebar": {
					"Light": "#1e1430",
					"Dark": "#06060e"
				},
				"Hover": {
					"Light": "rgba(130, 0, 200, 0.06)",
					"Dark": "rgba(0, 255, 255, 0.08)"
				},
				"Selected": {
					"Light": "rgba(138, 0, 212, 0.10)",
					"Dark": "rgba(0, 229, 255, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				},
				"Secondary": {
					"Light": "#4a3868",
					"Dark": "#b0a8c8"
				},
				"Muted": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"Placeholder": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"OnBrand": {
					"Light": "#d0c8e0",
					"Dark": "#d0c8e0"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"PrimaryHover": {
					"Light": "#b040f0",
					"Dark": "#60f0ff"
				},
				"Accent": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"AccentHover": {
					"Light": "#b040f0",
					"Dark": "#60f0ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Light": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Strong": {
					"Light": "#2a2040",
					"Dark": "#1a1430"
				}
			},
			"Status": {
				"Success": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				},
				"Warning": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Error": {
					"Light": "#c82050",
					"Dark": "#ff3860"
				},
				"Info": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Thumb": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Hover": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(138, 0, 212, 0.10)",
					"Dark": "rgba(0, 229, 255, 0.12)"
				},
				"Text": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(26, 16, 40, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"String": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				},
				"Number": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Comment": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"Operator": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"Punctuation": {
					"Light": "#4a3868",
					"Dark": "#b0a8c8"
				},
				"Function": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"Variable": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				},
				"Type": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Builtin": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Property": {
					"Light": "#c82050",
					"Dark": "#ff3860"
				},
				"Tag": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"AttrName": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"AttrValue": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],337:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs-retro",
	"Name": "Retold Labs Retro",
	"Version": "0.0.1",
	"Description": "retold-labs’ \"retro\" identity — amber/green phosphor on dark or sepia/olive on light. Preserves the original retro-light / retro-dark palettes verbatim.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#f5f0e0",
					"Dark": "#0c0c08"
				},
				"Secondary": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Tertiary": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Panel": {
					"Light": "#faf6e8",
					"Dark": "#1e1e14"
				},
				"Sidebar": {
					"Light": "#3a3020",
					"Dark": "#080804"
				},
				"Hover": {
					"Light": "rgba(140, 80, 20, 0.06)",
					"Dark": "rgba(255, 176, 0, 0.08)"
				},
				"Selected": {
					"Light": "rgba(140, 80, 20, 0.10)",
					"Dark": "rgba(255, 176, 0, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				},
				"Secondary": {
					"Light": "#5c4a30",
					"Dark": "#a09870"
				},
				"Muted": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"Placeholder": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"OnBrand": {
					"Light": "#d8c8a0",
					"Dark": "#c8b870"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"PrimaryHover": {
					"Light": "#b06820",
					"Dark": "#ffc840"
				},
				"Accent": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"AccentHover": {
					"Light": "#b06820",
					"Dark": "#ffc840"
				}
			},
			"Border": {
				"Default": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Light": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Strong": {
					"Light": "#4a4030",
					"Dark": "#1a1a10"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Warning": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Error": {
					"Light": "#a03020",
					"Dark": "#e04030"
				},
				"Info": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Thumb": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Hover": {
					"Light": "#8a7450",
					"Dark": "#706848"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(140, 80, 20, 0.10)",
					"Dark": "rgba(255, 176, 0, 0.12)"
				},
				"Text": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(46, 36, 24, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"String": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Number": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Comment": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"Operator": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"Punctuation": {
					"Light": "#5c4a30",
					"Dark": "#a09870"
				},
				"Function": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"Variable": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				},
				"Type": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Builtin": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Property": {
					"Light": "#a03020",
					"Dark": "#e04030"
				},
				"Tag": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"AttrName": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"AttrValue": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],338:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs",
	"Name": "Retold Labs",
	"Version": "0.0.1",
	"Description": "retold-labs’ original \"professional\" identity — warm beige with teal accents and a deep teal sidebar. Light side preserves professional-light verbatim; dark side preserves professional-dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#faf6f0",
					"Dark": "#14201e"
				},
				"Secondary": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Tertiary": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#1e3532"
				},
				"Sidebar": {
					"Light": "#1a3a3a",
					"Dark": "#0e1a18"
				},
				"Hover": {
					"Light": "rgba(13, 138, 138, 0.06)",
					"Dark": "rgba(45, 212, 191, 0.08)"
				},
				"Selected": {
					"Light": "rgba(13, 138, 138, 0.10)",
					"Dark": "rgba(45, 212, 191, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				},
				"Secondary": {
					"Light": "#5c4f3d",
					"Dark": "#a8bfb8"
				},
				"Muted": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"Placeholder": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"OnBrand": {
					"Light": "#c8dcd8",
					"Dark": "#c8dcd8"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"PrimaryHover": {
					"Light": "#14b8a6",
					"Dark": "#5eead4"
				},
				"Accent": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"AccentHover": {
					"Light": "#14b8a6",
					"Dark": "#5eead4"
				}
			},
			"Border": {
				"Default": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Light": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Strong": {
					"Light": "#2a5454",
					"Dark": "#1e3a36"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				},
				"Warning": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Error": {
					"Light": "#c9442e",
					"Dark": "#f87171"
				},
				"Info": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Thumb": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Hover": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(13, 138, 138, 0.10)",
					"Dark": "rgba(45, 212, 191, 0.12)"
				},
				"Text": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(44, 36, 22, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.45)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"String": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				},
				"Number": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Comment": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"Operator": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"Punctuation": {
					"Light": "#5c4f3d",
					"Dark": "#a8bfb8"
				},
				"Function": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"Variable": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				},
				"Type": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Builtin": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Property": {
					"Light": "#c9442e",
					"Dark": "#f87171"
				},
				"Tag": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"AttrName": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"AttrValue": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],339:[function(require,module,exports){
module.exports={
	"Hash": "retold-manager",
	"Name": "Retold Manager",
	"Description": "Default palette for the Retold Manager application — GitHub-style dark on slate with a parallel light variant. Dark side mirrors retold-manager.css's original colors verbatim; light side is a sympathetic translation tuned for daytime use. The retold-manager.css :root block proxies its --color-* names through these --theme-color-* tokens (with the original hexes as fallbacks), so this theme drives the whole app cleanly and other catalog themes still skin most of it.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#f6f8fa", "Dark": "#0e1116" },
				"Secondary": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Tertiary":  { "Light": "#e4e8ec", "Dark": "#1c2128" },
				"Panel":     { "Light": "#ffffff", "Dark": "#161b22" },
				"PanelAlt":  { "Light": "#f0f3f6", "Dark": "#1c2128" },
				"Hover":     { "Light": "#eaeef2", "Dark": "#1c2128" },
				"Selected":  { "Light": "#dbe7ff", "Dark": "#243454" }
			},
			"Border": {
				"Default":   { "Light": "#d0d7de", "Dark": "#30363d" },
				"Light":     { "Light": "#e1e4e8", "Dark": "#21262d" },
				"Strong":    { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Brand": {
				"Primary":      { "Light": "#0969da", "Dark": "#2f81f7" },
				"PrimaryHover": { "Light": "#0550ae", "Dark": "#1f6feb" },
				"Accent":       { "Light": "#0969da", "Dark": "#2f81f7" },
				"AccentHover":  { "Light": "#0550ae", "Dark": "#1f6feb" }
			},
			"Text": {
				"Primary":     { "Light": "#1f2328", "Dark": "#e6edf3" },
				"Secondary":   { "Light": "#3b424a", "Dark": "#c9d1d9" },
				"Muted":       { "Light": "#656d76", "Dark": "#8b949e" },
				"Placeholder": { "Light": "#8c959f", "Dark": "#6e7681" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#1a7f37", "Dark": "#3fb950" },
				"Danger":  { "Light": "#cf222e", "Dark": "#f85149" },
				"Warning": { "Light": "#9a6700", "Dark": "#d29922" },
				"Error":   { "Light": "#cf222e", "Dark": "#f85149" },
				"Info":    { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Data": {
				"1": { "Light": "#0969da", "Dark": "#2f81f7" },
				"2": { "Light": "#cf222e", "Dark": "#f85149" },
				"3": { "Light": "#1a7f37", "Dark": "#3fb950" },
				"4": { "Light": "#9a6700", "Dark": "#d29922" },
				"5": { "Light": "#8250df", "Dark": "#a371f7" },
				"6": { "Light": "#bf3989", "Dark": "#db61a2" },
				"7": { "Light": "#1b7c83", "Dark": "#39c5cf" },
				"8": { "Light": "#656d76", "Dark": "#8b949e" }
			},
			"Scrollbar": {
				"Track": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Thumb": { "Light": "#c1c8cf", "Dark": "#30363d" },
				"Hover": { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Selection": {
				"Background": { "Light": "#cfe6ff", "Dark": "#243454" },
				"Text":       { "Light": "#1f2328", "Dark": "#e6edf3" }
			},
			"Focus": {
				"Outline": { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#cf222e", "Dark": "#ff7b72" },
				"String":      { "Light": "#0a3069", "Dark": "#a5d6ff" },
				"Number":      { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Comment":     { "Light": "#6e7781", "Dark": "#8b949e" },
				"Operator":    { "Light": "#cf222e", "Dark": "#ff7b72" },
				"Punctuation": { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Function":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"Variable":    { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Type":        { "Light": "#953800", "Dark": "#ffa657" },
				"Builtin":     { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Property":    { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Tag":         { "Light": "#116329", "Dark": "#7ee787" },
				"AttrName":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"AttrValue":   { "Light": "#0a3069", "Dark": "#a5d6ff" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, \"SF Pro\", \"Segoe UI\", sans-serif",
				"Mono": "ui-monospace, \"SF Mono\", Menlo, Monaco, \"Courier New\", monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "280px",
			"TopbarHeight":    "44px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],340:[function(require,module,exports){
module.exports={
	"Hash": "retold-mono",
	"Name": "Retold Mono",
	"Version": "0.0.2",
	"Description": "High-contrast monochrome theme — black on white in light mode, white on black in dark mode. Useful for print, simple admin tooling, and as a paired-mode reference theme that proves the toggle works on something visually unmistakable.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#000000" },
				"Secondary": { "Light": "#f0f0f0", "Dark": "#101010" },
				"Tertiary":  { "Light": "#e2e2e2", "Dark": "#1c1c1c" },
				"Panel":     { "Light": "#ffffff", "Dark": "#000000" },
				"Hover":     { "Light": "#ebebeb", "Dark": "#1a1a1a" },
				"Selected":  { "Light": "#d6d6d6", "Dark": "#2a2a2a" }
			},
			"Text": {
				"Primary":     { "Light": "#000000", "Dark": "#ffffff" },
				"Secondary":   { "Light": "#222222", "Dark": "#dddddd" },
				"Muted":       { "Light": "#555555", "Dark": "#aaaaaa" },
				"Placeholder": { "Light": "#888888", "Dark": "#777777" }
			},
			"Brand": {
				"Primary":      { "Light": "#000000", "Dark": "#ffffff" },
				"PrimaryHover": { "Light": "#222222", "Dark": "#dddddd" },
				"Accent":       { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Border": {
				"Default": { "Light": "#888888", "Dark": "#666666" },
				"Light":   { "Light": "#cccccc", "Dark": "#333333" },
				"Strong":  { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#000000", "Dark": "#ffffff" },
				"Warning": { "Light": "#000000", "Dark": "#ffffff" },
				"Error":   { "Light": "#000000", "Dark": "#ffffff" },
				"Info":    { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Data": {
				"1": { "Light": "#000000", "Dark": "#ffffff" },
				"2": { "Light": "#262626", "Dark": "#e0e0e0" },
				"3": { "Light": "#404040", "Dark": "#c0c0c0" },
				"4": { "Light": "#595959", "Dark": "#a0a0a0" },
				"5": { "Light": "#737373", "Dark": "#808080" },
				"6": { "Light": "#8c8c8c", "Dark": "#737373" },
				"7": { "Light": "#a6a6a6", "Dark": "#595959" },
				"8": { "Light": "#bfbfbf", "Dark": "#404040" }
			},
			"Scrollbar": {
				"Track": { "Light": "#e0e0e0", "Dark": "#101010" },
				"Thumb": { "Light": "#888888", "Dark": "#666666" },
				"Hover": { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Selection": {
				"Background": { "Light": "#000000", "Dark": "#ffffff" },
				"Text":       { "Light": "#ffffff", "Dark": "#000000" }
			},
			"Focus": {
				"Outline": { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.18)", "Dark": "rgba(255, 255, 255, 0.18)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#000000", "Dark": "#ffffff" },
				"String":      { "Light": "#555555", "Dark": "#cccccc" },
				"Number":      { "Light": "#000000", "Dark": "#ffffff" },
				"Comment":     { "Light": "#888888", "Dark": "#888888" },
				"Operator":    { "Light": "#000000", "Dark": "#ffffff" },
				"Punctuation": { "Light": "#444444", "Dark": "#bbbbbb" },
				"Function":    { "Light": "#000000", "Dark": "#ffffff" },
				"Variable":    { "Light": "#000000", "Dark": "#ffffff" },
				"Type":        { "Light": "#222222", "Dark": "#dddddd" },
				"Builtin":     { "Light": "#222222", "Dark": "#dddddd" },
				"Property":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"Tag":         { "Light": "#000000", "Dark": "#ffffff" },
				"AttrName":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"AttrValue":   { "Light": "#555555", "Dark": "#cccccc" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Times New Roman, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "600",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.15",
				"Normal": "1.4",
				"Loose": "1.65"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "0",
			"MD": "0",
			"LG": "0",
			"XL": "0",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 0 var(--theme-color-shadow-color)",
			"MD": "0 2px 0 var(--theme-color-shadow-color)",
			"LG": "0 4px 0 var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "0ms",
			"Normal": "0ms",
			"Slow": "0ms"
		}
	},
	"Brand": {
		"Name": "Retold Mono",
		"Tagline": "Black on white. White on black. Nothing else."
	},
	"CSS": [
		{
			"Hash": "retold-mono-brand-accents",
			"Priority": 600,
			"Content": "/* retold-mono — keeps the all-monochrome aesthetic but lets brand colors\n   in for narrow accent moments. The thick rule under H1 is brand primary;\n   the hair rule under H2 is brand secondary. Without a brand registered\n   they fall back to mono black/grey. */\na { text-decoration-color: var(--brand-color-primary-mode, currentColor); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 3px solid var(--brand-color-primary-mode, var(--theme-color-text-primary, #000)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-default, #888)); padding-bottom: 4px; }"
		}
	]
}

},{}],341:[function(require,module,exports){
module.exports={
	"Hash": "solarized-dark",
	"Name": "Solarized Dark",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Schoonover's classic palette Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#002B36",
				"Secondary": "#073642",
				"Tertiary": "#003B4A",
				"Panel": "#00303C",
				"Viewer": "#001E28",
				"Hover": "#0A4858",
				"Selected": "#155868",
				"Thumb": "#073642"
			},
			"Text": {
				"Primary": "#FDF6E3",
				"Secondary": "#EEE8D5",
				"Muted": "#93A1A1",
				"Dim": "#839496",
				"Placeholder": "#657B83"
			},
			"Brand": {
				"Accent": "#268BD2",
				"AccentHover": "#45A0E0"
			},
			"Border": {
				"Default": "#0A4050",
				"Light": "#125868"
			},
			"Status": {
				"Danger": "#DC322F",
				"DangerMuted": "#AA2A28"
			},
			"Scrollbar": {
				"Track": "#0A4050",
				"Hover": "#125868"
			},
			"Selection": {
				"Background": "rgba(38, 139, 210, 0.25)"
			},
			"Focus": {
				"Outline": "#268BD2"
			},
			"Syntax": {
				"Keyword":     "#859900",
				"String":      "#2AA198",
				"Number":      "#D33682",
				"Comment":     "#586E75",
				"Operator":    "#268BD2",
				"Punctuation": "#93A1A1",
				"Function":    "#B58900",
				"Variable":    "#FDF6E3",
				"Type":        "#B58900",
				"Builtin":     "#CB4B16",
				"Property":    "#268BD2",
				"Tag":         "#268BD2",
				"AttrName":    "#B58900",
				"AttrValue":   "#2AA198"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Source Code Pro', 'Fira Code', monospace",
				"Mono": "'Source Code Pro', 'Fira Code', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#EEE8D5",
		"Accent": "#268BD2",
		"Muted": "#839496",
		"Light": "#003B4A",
		"WarmBeige": "#073642",
		"TealTint": "#004050",
		"Lavender": "#003848",
		"AmberTint": "#0A3A30",
		"PdfFill": "#0A3028",
		"PdfText": "#DC322F"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],342:[function(require,module,exports){
module.exports={
	"Hash": "synthwave",
	"Name": "Synthwave",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Purple and pink neon Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A0A2E",
				"Secondary": "#140824",
				"Tertiary": "#200E38",
				"Panel": "#1C0C32",
				"Viewer": "#100620",
				"Hover": "#2A1848",
				"Selected": "#3A2060",
				"Thumb": "#140824"
			},
			"Text": {
				"Primary": "#E8C0F8",
				"Secondary": "#D0A8E8",
				"Muted": "#9878B8",
				"Dim": "#7858A8",
				"Placeholder": "#584088"
			},
			"Brand": {
				"Accent": "#FF71CE",
				"AccentHover": "#FF99DD"
			},
			"Border": {
				"Default": "#302050",
				"Light": "#402868"
			},
			"Status": {
				"Danger": "#FF4488",
				"DangerMuted": "#AA3366"
			},
			"Scrollbar": {
				"Track": "#302050",
				"Hover": "#402868"
			},
			"Selection": {
				"Background": "rgba(255, 113, 206, 0.25)"
			},
			"Focus": {
				"Outline": "#FF71CE"
			},
			"Syntax": {
				"Keyword":     "#FF6AD5",
				"String":      "#FFE066",
				"Number":      "#FF6AD5",
				"Comment":     "#9C8AC1",
				"Operator":    "#26F0F1",
				"Punctuation": "#C8B6E2",
				"Function":    "#26F0F1",
				"Variable":    "#FFE0FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF477E",
				"Tag":         "#FF477E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#FFE066"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Trebuchet MS', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0A8E8",
		"Accent": "#FF71CE",
		"Muted": "#7858A8",
		"Light": "#200E38",
		"WarmBeige": "#221040",
		"TealTint": "#1A0C30",
		"Lavender": "#1E0E36",
		"AmberTint": "#241028",
		"PdfFill": "#241020",
		"PdfText": "#FF4488"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],343:[function(require,module,exports){
module.exports={
	"Hash": "twilight",
	"Name": "Twilight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Dark grey, low light. Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format. Single-mode (no light/dark bifurcation). Aliases preserve the legacy `--retold-*` variable names so existing CSS keeps working through the migration.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1E1E1E",
				"Secondary": "#181818",
				"Tertiary": "#252525",
				"Panel": "#202020",
				"Viewer": "#141414",
				"Hover": "#2E2E2E",
				"Selected": "#404040",
				"Thumb": "#181818"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#C8C8C8",
				"Muted": "#909090",
				"Dim": "#707070",
				"Placeholder": "#585858"
			},
			"Brand": {
				"Accent": "#A0A0A0",
				"AccentHover": "#C0C0C0"
			},
			"Border": {
				"Default": "#333333",
				"Light": "#404040"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#404040",
				"Hover": "#505050"
			},
			"Selection": {
				"Background": "rgba(160, 160, 160, 0.25)"
			},
			"Focus": {
				"Outline": "#A0A0A0"
			},
			"Syntax": {
				"Keyword":     "#B58FFF",
				"String":      "#9CDFB0",
				"Number":      "#FFB870",
				"Comment":     "#6E6E6E",
				"Operator":    "#7CC5FF",
				"Punctuation": "#C0C0C0",
				"Function":    "#FFD080",
				"Variable":    "#E0E0E0",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF8B8B",
				"Tag":         "#FF8B8B",
				"AttrName":    "#FFB870",
				"AttrValue":   "#9CDFB0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#C8C8C8",
		"Accent": "#A0A0A0",
		"Muted": "#707070",
		"Light": "#252525",
		"WarmBeige": "#2A2A2A",
		"TealTint": "#222222",
		"Lavender": "#282828",
		"AmberTint": "#2E2A24",
		"PdfFill": "#2E2224",
		"PdfText": "#E06060"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],344:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-canyon",
	"Name": "Ultravisor — Desert Canyon",
	"Version": "0.0.1",
	"Description": "Vibrant desert palette — orange brand and teal accents on deep canyon-brown backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#18120e",
				"Secondary": "#221a14",
				"Tertiary":  "#2e2018",
				"Panel":     "#221a14",
				"Hover":     "#3a2a1e",
				"Selected":  "#3a2a1e"
			},
			"Text": {
				"Primary":     "#d8c8b0",
				"Secondary":   "#e8d8c0",
				"Muted":       "#a09080",
				"Placeholder": "#685040",
				"OnBrand":     "#18120e"
			},
			"Brand": {
				"Primary":      "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent":       "#18a0a0",
				"AccentHover":  "#30b0b0"
			},
			"Border": {
				"Default": "#3a2a1e",
				"Light":   "#2e2018",
				"Strong":  "#4a3a2e"
			},
			"Status": {
				"Success": "#18a0a0",
				"Warning": "#e0c870",
				"Error":   "#e05830",
				"Info":    "#18a0a0"
			},
			"Scrollbar": {
				"Track": "#221a14",
				"Thumb": "#3a2a1e",
				"Hover": "#4a3a2e"
			},
			"Selection": {
				"Background": "#3a2a1e",
				"Text":       "#e8d8c0"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#221a14",
				"LineNumberText":       "#685040",
				"CurrentLineHighlight": "#2e2018",
				"SelectionBackground":  "#3a2a1e",
				"GutterBorder":         "#2e2018"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],345:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-day",
	"Name": "Ultravisor — Desert Day",
	"Version": "0.0.1",
	"Description": "Ultravisor's warm light palette — cream backgrounds, deep walnut text, teal accents. Single-mode light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#faf6f0",
				"Secondary": "#f0e6d6",
				"Tertiary":  "#e8ddd0",
				"Panel":     "#ffffff",
				"Hover":     "#f0e6d6",
				"Selected":  "#e8ddd0"
			},
			"Text": {
				"Primary":     "#3d2b1f",
				"Secondary":   "#2e1e14",
				"Muted":       "#8a7560",
				"Placeholder": "#a09080",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#5c3d2e",
				"PrimaryHover": "#7a5040",
				"Accent":       "#3a8a8c",
				"AccentHover":  "#2a7070"
			},
			"Border": {
				"Default": "#e0d0b8",
				"Light":   "#e8ddd0",
				"Strong":  "#c8b8a0"
			},
			"Status": {
				"Success": "#5a7a30",
				"Warning": "#b08020",
				"Error":   "#a03040",
				"Info":    "#3a8a8c"
			},
			"Scrollbar": {
				"Track": "#f0e6d6",
				"Thumb": "#d0c0a8",
				"Hover": "#c0b098"
			},
			"Selection": {
				"Background": "#e8ddd0",
				"Text":       "#2e1e14"
			},
			"Focus": {
				"Outline": "#c2703e"
			},
			"Shadow": {
				"Color": "rgba(92, 61, 46, 0.10)"
			},
			"Syntax": {
				"Keyword":     "#A0532E",
				"String":      "#3F8A52",
				"Number":      "#A86B00",
				"Comment":     "#8A7F72",
				"Operator":    "#2E7D74",
				"Punctuation": "#5E5549",
				"Function":    "#2E5E96",
				"Variable":    "#3D3229",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#A0532E",
				"Tag":         "#A0532E",
				"AttrName":    "#A86B00",
				"AttrValue":   "#3F8A52"
			},
			"Editor": {
				"LineNumberBackground": "#f0e6d6",
				"LineNumberText":       "#a09080",
				"CurrentLineHighlight": "#f5ede0",
				"SelectionBackground":  "#e8ddd0",
				"GutterBorder":         "#e0d0b8"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],346:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-dusk",
	"Name": "Ultravisor — Desert Dusk",
	"Version": "0.0.1",
	"Description": "Ultravisor's original default — warm tan brand on muted dark desert backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1a1714",
				"Secondary": "#252018",
				"Tertiary":  "#302818",
				"Panel":     "#252018",
				"Hover":     "#3a3028",
				"Selected":  "#3a3028"
			},
			"Text": {
				"Primary":     "#c8b8a0",
				"Secondary":   "#d8c8a8",
				"Muted":       "#907860",
				"Placeholder": "#706050",
				"OnBrand":     "#FFFFFF"
			},
			"Brand": {
				"Primary":      "#c4956a",
				"PrimaryHover": "#d4a57a",
				"Accent":       "#4a9090",
				"AccentHover":  "#5aacac"
			},
			"Border": {
				"Default": "#3a3028",
				"Light":   "#302818",
				"Strong":  "#4a4038"
			},
			"Status": {
				"Success": "#8a9a5a",
				"Warning": "#c0a050",
				"Error":   "#b04050",
				"Info":    "#4a9090"
			},
			"Scrollbar": {
				"Track": "#252018",
				"Thumb": "#3a3028",
				"Hover": "#4a4038"
			},
			"Selection": {
				"Background": "#3a3028",
				"Text":       "#d8c8a8"
			},
			"Focus": {
				"Outline": "#c4956a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#252018",
				"LineNumberText":       "#706050",
				"CurrentLineHighlight": "#302818",
				"SelectionBackground":  "#3a3028",
				"GutterBorder":         "#302818"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],347:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-sunset",
	"Name": "Ultravisor — Desert Sunset",
	"Version": "0.0.1",
	"Description": "Ultravisor's golden-hour palette — orange brand on rust-warmed dark backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1e1610",
				"Secondary": "#2a2018",
				"Tertiary":  "#342818",
				"Panel":     "#2a2018",
				"Hover":     "#3a2e22",
				"Selected":  "#3a2e22"
			},
			"Text": {
				"Primary":     "#d4c4aa",
				"Secondary":   "#e0d0b8",
				"Muted":       "#8a7560",
				"Placeholder": "#6a5840",
				"OnBrand":     "#1e1610"
			},
			"Brand": {
				"Primary":      "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent":       "#2a8a8a",
				"AccentHover":  "#3a9a9a"
			},
			"Border": {
				"Default": "#3a2e22",
				"Light":   "#342818",
				"Strong":  "#4a3e32"
			},
			"Status": {
				"Success": "#6a9a3a",
				"Warning": "#d4a46a",
				"Error":   "#c44e2a",
				"Info":    "#2a8a8a"
			},
			"Scrollbar": {
				"Track": "#2a2018",
				"Thumb": "#3a2e22",
				"Hover": "#4a3e32"
			},
			"Selection": {
				"Background": "#3a2e22",
				"Text":       "#e0d0b8"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#2a2018",
				"LineNumberText":       "#6a5840",
				"CurrentLineHighlight": "#342818",
				"SelectionBackground":  "#3a2e22",
				"GutterBorder":         "#342818"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],348:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-professional-dark",
	"Name": "Ultravisor — Professional Dark",
	"Version": "0.0.1",
	"Description": "Dark modern palette — slate-blue text on inky surfaces, sky-blue brand. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#111318",
				"Secondary": "#1a1d24",
				"Tertiary":  "#22252e",
				"Panel":     "#1a1d24",
				"Hover":     "#282c34",
				"Selected":  "#282c34"
			},
			"Text": {
				"Primary":     "#c8cdd5",
				"Secondary":   "#e0e4ea",
				"Muted":       "#8b92a0",
				"Placeholder": "#5a6070",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#60a5fa",
				"PrimaryHover": "#93c5fd",
				"Accent":       "#60a5fa",
				"AccentHover":  "#93c5fd"
			},
			"Border": {
				"Default": "#282c34",
				"Light":   "#22252e",
				"Strong":  "#3a3f4a"
			},
			"Status": {
				"Success": "#34d399",
				"Warning": "#fbbf24",
				"Error":   "#f87171",
				"Info":    "#60a5fa"
			},
			"Scrollbar": {
				"Track": "#1a1d24",
				"Thumb": "#282c34",
				"Hover": "#3a3f4a"
			},
			"Selection": {
				"Background": "#1e2230",
				"Text":       "#e0e4ea"
			},
			"Focus": {
				"Outline": "#60a5fa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#1a1d24",
				"LineNumberText":       "#5a6070",
				"CurrentLineHighlight": "#22252e",
				"SelectionBackground":  "#1e2230",
				"GutterBorder":         "#22252e"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],349:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-professional-light",
	"Name": "Ultravisor — Professional Light",
	"Version": "0.0.1",
	"Description": "Bright modern palette — slate text on near-white backgrounds, royal-blue brand. Single-mode light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#f5f6f8",
				"Secondary": "#ffffff",
				"Tertiary":  "#e4e7ec",
				"Panel":     "#ffffff",
				"Hover":     "#f0f1f4",
				"Selected":  "#e4e7ec"
			},
			"Text": {
				"Primary":     "#2d3748",
				"Secondary":   "#1a202c",
				"Muted":       "#6b7280",
				"Placeholder": "#9ca3af",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#3b82f6",
				"PrimaryHover": "#2563eb",
				"Accent":       "#3b82f6",
				"AccentHover":  "#2563eb"
			},
			"Border": {
				"Default": "#e2e5ea",
				"Light":   "#eceef2",
				"Strong":  "#c8cdd5"
			},
			"Status": {
				"Success": "#10b981",
				"Warning": "#f59e0b",
				"Error":   "#ef4444",
				"Info":    "#3b82f6"
			},
			"Scrollbar": {
				"Track": "#f0f1f4",
				"Thumb": "#d1d5db",
				"Hover": "#b0b5bd"
			},
			"Selection": {
				"Background": "#dbeafe",
				"Text":       "#1a202c"
			},
			"Focus": {
				"Outline": "#3b82f6"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.06)"
			},
			"Syntax": {
				"Keyword":     "#A0532E",
				"String":      "#3F8A52",
				"Number":      "#A86B00",
				"Comment":     "#8A7F72",
				"Operator":    "#2E7D74",
				"Punctuation": "#5E5549",
				"Function":    "#2E5E96",
				"Variable":    "#3D3229",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#A0532E",
				"Tag":         "#A0532E",
				"AttrName":    "#A86B00",
				"AttrValue":   "#3F8A52"
			},
			"Editor": {
				"LineNumberBackground": "#f5f6f8",
				"LineNumberText":       "#9ca3af",
				"CurrentLineHighlight": "#f0f1f4",
				"SelectionBackground":  "#dbeafe",
				"GutterBorder":         "#e2e5ea"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],350:[function(require,module,exports){
/**
 * Theme-BottomBar — standard application footer row.
 *
 * The bottom-row counterpart to Theme-TopBar: a thin status / chrome bar
 * that sits at the absolute bottom of the application shell. Three
 * zones — status text on the left, info indicators in the middle, and
 * action buttons / toggles on the right.
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ Status text          [── Info slot (flex) ──]      [actions]   │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Renders into `#Theme-BottomBar` by default.
 *
 * Three slots host views drop content into:
 *   - `#Theme-BottomBar-Status`  — short status / state line (left)
 *   - `#Theme-BottomBar-Info`    — center info: connection, version,
 *                                  ambient indicators
 *   - `#Theme-BottomBar-Actions` — log toggle, debug controls, etc.
 *
 * Top border uses `--brand-color-secondary-mode` so the bottombar gets
 * a brand-tinted edge that's visually distinct from the topbar's
 * primary-color stripe.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BottomBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BottomBar',
	DefaultRenderable: 'Theme-BottomBar-Renderable',

	// ViewIdentifier of a host view that fills #Theme-BottomBar-Status.
	StatusView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Info.
	InfoView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Actions.
	ActionsView: null,

	// Height of the bar in pixels. Drives the min-height on the chrome
	// row so it fills the panel cleanly even when the parent chain
	// (pict-section-modal shell uses min-height: 100% on its panel
	// content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 32,

	Templates:
	[
		{
			Hash: 'Theme-BottomBar-Template',
			Template: /*html*/`
<div class="pict-theme-bottombar">
	<div class="pict-theme-bottombar-status" id="Theme-BottomBar-Status"></div>
	<div class="pict-theme-bottombar-info" id="Theme-BottomBar-Info"></div>
	<div class="pict-theme-bottombar-actions" id="Theme-BottomBar-Actions"></div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BottomBar-Renderable',
			TemplateHash: 'Theme-BottomBar-Template',
			ContentDestinationAddress: '#Theme-BottomBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-bottombar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 32). A fixed px value avoids the
	   percent-height resolution trap the pict-section-modal shell sets
	   up — see the comment on Theme-TopBar's CSS for the full story. */
	min-height: 32px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-secondary, transparent);
	font-size: var(--theme-typography-size-xs, 12px);
	color: var(--theme-color-text-secondary, #4a5568);
	/* Single medium brand-primary stripe at the top of the bottombar.
	   The topbar carries the full two-stripe identifier; on the
	   bottombar (which is only 32px tall) a single 2px primary line is
	   enough to seat the brand colour at the bottom of the page
	   without competing for visual weight against the content row. */
	border-top: 2px solid var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
.pict-theme-bottombar-status {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 50%;
}
.pict-theme-bottombar-info {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	min-width: 0;
	overflow: hidden;
}
.pict-theme-bottombar-actions {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
}`,
	CSSPriority: 500
};

class PictViewThemeBottomBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-bottombar
		// — see the matching block in Theme-TopBar's onAfterRender for why.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-bottombar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		let tmpRenderSlot = (pIdentifier) =>
		{
			if (!pIdentifier) return;
			let tmpView = this.pict.views[pIdentifier];
			if (tmpView) { tmpView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-BottomBar: slot view "' + pIdentifier + '" not registered');
			}
		};
		tmpRenderSlot(this.options.StatusView);
		tmpRenderSlot(this.options.InfoView);
		tmpRenderSlot(this.options.ActionsView);

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Mirrors Theme-TopBar's setNavView / setUserView — call from a
	// router callback to swap the bottom bar's slot content as the
	// route changes (different status formats per page, etc.).

	setStatusView(pViewIdentifier)  { this._setSlotView('StatusView',  '#Theme-BottomBar-Status',  pViewIdentifier); }
	setInfoView(pViewIdentifier)    { this._setSlotView('InfoView',    '#Theme-BottomBar-Info',    pViewIdentifier); }
	setActionsView(pViewIdentifier) { this._setSlotView('ActionsView', '#Theme-BottomBar-Actions', pViewIdentifier); }

	_setSlotView(pOptionKey, pDestSelector, pViewIdentifier)
	{
		this.options[pOptionKey] = pViewIdentifier || null;
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-BottomBar: view "' + pViewIdentifier + '" not registered');
		}
	}
}

module.exports = PictViewThemeBottomBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],351:[function(require,module,exports){
/**
 * Theme-Brand-Mark — single-row inline brand mark (icon + name).
 *
 * The drop-in counterpart to Theme-BrandStrip for apps that put the
 * brand wordmark *inside* their topbar (next to action buttons) rather
 * than as a multi-row chrome below the nav.
 *
 * Layout:
 *
 *   ┌─────────────────────────┐
 *   │ [icon]  App Name        │
 *   └─────────────────────────┘
 *
 * Colors come from the brand's primary/secondary; the icon (when SVG
 * with `stroke="currentColor"`) inherits `--brand-color-primary-mode`,
 * which auto-swaps between PrimaryLight (default mode) and PrimaryDark
 * (`.theme-dark`).
 *
 * Reads from libThemeBrand and re-renders on `onChange`. Renders an
 * empty span when no brand is registered.
 *
 * Drop-in destination: `<div id="Theme-Brand-Mark"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Brand-Mark',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Brand-Mark',
	DefaultRenderable: 'Theme-Brand-Mark-Renderable',

	// Optional: when false the icon is omitted (text-only wordmark).
	ShowIcon: true,
	// Optional: when false the name is omitted (icon-only mark).
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-Brand-Mark-Template',
			Template: /*html*/`{~TS:Theme-Brand-Mark-Body-Template:AppData.PictSectionTheme.BrandMark.BodySlot~}`
		},
		{
			Hash: 'Theme-Brand-Mark-Body-Template',
			Template: /*html*/`
<span class="pict-theme-brand-mark" title="{~D:Record.Tooltip~}">
	{~TS:Theme-Brand-Mark-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-Brand-Mark-IconImg-Template:Record.IconImgSlot~}
	{~TS:Theme-Brand-Mark-Name-Template:Record.NameSlot~}
</span>`
		},
		{
			// Inline SVG: trusted markup; let it ride. SVG icons that
			// reference `currentColor` inherit `--brand-color-primary-mode`.
			Hash: 'Theme-Brand-Mark-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			Hash: 'Theme-Brand-Mark-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		},
		{
			Hash: 'Theme-Brand-Mark-Name-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-name">{~D:Record.Name~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Brand-Mark-Renderable',
			TemplateHash: 'Theme-Brand-Mark-Template',
			ContentDestinationAddress: '#Theme-Brand-Mark',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brand-mark {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	/* line-height: 1 collapses the inherited ~1.2 line-box around the
	   name glyphs. Without this the inline-flex container is taller
	   than its visible content, the line-box adds asymmetric space
	   above the caps, and the whole mark looks pushed up vs.
	   neighbouring buttons that sit on standard 12px-text baselines. */
	line-height: 1;
	color: var(--brand-color-primary-mode, var(--theme-color-text-primary, #1a1a1a));
	user-select: none;
}
.pict-theme-brand-mark-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	color: currentColor;
}
.pict-theme-brand-mark-icon img,
.pict-theme-brand-mark-icon svg {
	width: 100%;
	height: 100%;
	display: block;
}
.pict-theme-brand-mark-name {
	/* Font size dropped from 15 → 14 so the brand name reads closer
	   to the typical 12px action-button text height; bigger glyphs
	   reaching higher into the row are why the mark looked optically
	   high. The 2px brand-secondary underline keeps the mark feeling
	   distinctly branded; padding-bottom: 1px was an asymmetric nudge
	   that shifted the visual center up — removed. */
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.4px;
	border-bottom: 2px solid var(--brand-color-secondary-mode, transparent);
	white-space: nowrap;
}
/* Compact form — at narrow viewports the brand mark collapses to
   icon-only. The icon alone still reads as the brand (the deterministic
   logo is designed to be recognisable without the wordmark) and freeing
   up the wordmark's width keeps the nav buttons reachable on tablet /
   small-laptop widths. The threshold matches the topbar's compact
   breakpoint in Theme-TopBar. */
@media (max-width: 720px) {
	.pict-theme-brand-mark-name {
		display: none;
	}
}`,
	CSSPriority: 500
};

class PictViewThemeBrandMark extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandMark = { BodySlot: [] };
			return;
		}

		// Single-element array slot drives the {~TS:~} render. Empty
		// slots for icon-img/icon-svg/name suppress those sub-templates.
		let tmpShowIcon = (this.options.ShowIcon !== false);
		let tmpShowName = (this.options.ShowName !== false);

		let tmpIconSVGSlot = (tmpShowIcon && tmpBrand.IconType === 'svg' && tmpBrand.Icon)
			? [{ IconHTML: tmpBrand.Icon }] : [];
		let tmpIconImgSlot = (tmpShowIcon && tmpBrand.IconType === 'image' && tmpBrand.Icon)
			? [{ IconURL: tmpBrand.Icon }] : [];
		let tmpNameSlot = (tmpShowName && tmpBrand.Name)
			? [{ Name: tmpBrand.Name }] : [];

		this.pict.AppData.PictSectionTheme.BrandMark =
		{
			BodySlot:
			[{
				Tooltip: tmpBrand.Tagline || tmpBrand.Name || '',
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot,
				NameSlot:    tmpNameSlot
			}]
		};
	}
}

module.exports = PictViewThemeBrandMark;
module.exports.default_configuration = _ViewConfiguration;

},{"../Theme-Brand.js":301,"pict-view":365}],352:[function(require,module,exports){
/**
 * Theme-BrandStrip — the subtle two-line brand signature that sits
 * under the application's navigation.
 *
 * Layout:
 *
 *   ┌─────────────────────────────────────────────────────────────┐
 *   │ [icon]  App Name                                            │
 *   │ ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ │  ← primary stripe (3× tall)
 *   │ ─────────────────────────────────────────────────────────── │  ← secondary stripe (1× tall)
 *   └─────────────────────────────────────────────────────────────┘
 *
 * The icon + name row is colored using the brand's primary color (and
 * the secondary as an underline accent on the name). Clicking the row
 * does nothing by default — hosts that want it to navigate or open a
 * dropdown can pass an `OnClickName` hook in the view options.
 *
 * Reads the active brand from libThemeBrand. Subscribes to
 * libThemeBrand.onChange so swapping the brand at runtime updates the
 * strip immediately. Renders nothing (an empty span) when no brand is
 * registered.
 *
 * Drop-in destination: `<div id="Theme-BrandStrip"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BrandStrip',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BrandStrip',
	DefaultRenderable: 'Theme-BrandStrip-Renderable',

	// Stripe heights in pixels. Primary is conventionally 3× secondary,
	// per the design brief, but exposed here so hosts can tune.
	PrimaryStripeHeight: 3,
	SecondaryStripeHeight: 1,

	// When false, the icon + name row is omitted and only the two
	// stripes render. Useful for very tight chrome where the brand
	// name is already in the topbar.
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-BrandStrip-Template',
			Template: /*html*/`
{~TS:Theme-BrandStrip-Body-Template:AppData.PictSectionTheme.BrandStrip.BodySlot~}`
		},
		{
			Hash: 'Theme-BrandStrip-Body-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip" title="{~D:Record.Tooltip~}">
	{~TS:Theme-BrandStrip-NameRow-Template:Record.NameRowSlot~}
	<div class="pict-theme-brandstrip-stripes">
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-primary"
		     style="height: {~D:Record.PrimaryHeight~}px;"></div>
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-secondary"
		     style="height: {~D:Record.SecondaryHeight~}px;"></div>
	</div>
</div>`
		},
		{
			Hash: 'Theme-BrandStrip-NameRow-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip-row">
	{~TS:Theme-BrandStrip-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-BrandStrip-IconImg-Template:Record.IconImgSlot~}
	<span class="pict-theme-brandstrip-name">{~D:Record.Name~}</span>
</div>`
		},
		{
			// SVG icon: leading <svg> markup is trusted (host-supplied,
			// not user-supplied) so we let it through verbatim. Theme-Icons
			// SVGs use stroke="currentColor" so they pick up the brand
			// primary color from the row's `color: var(--brand-color-primary)`.
			Hash: 'Theme-BrandStrip-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			// <img> icon: src can be a data URL or a regular URL.
			Hash: 'Theme-BrandStrip-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BrandStrip-Renderable',
			TemplateHash: 'Theme-BrandStrip-Template',
			ContentDestinationAddress: '#Theme-BrandStrip',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brandstrip {
	display: flex;
	flex-direction: column;
	gap: 4px;
	user-select: none;
}
.pict-theme-brandstrip-row {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px 4px;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--brand-color-primary, var(--theme-color-text-muted, #6b6b6b));
}
.pict-theme-brandstrip-name {
	border-bottom: 2px solid var(--brand-color-secondary, transparent);
	padding-bottom: 1px;
}
.pict-theme-brandstrip-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px; height: 16px;
	color: var(--brand-color-primary, currentColor);
}
.pict-theme-brandstrip-icon img,
.pict-theme-brandstrip-icon svg {
	width: 100%; height: 100%;
	display: block;
}
.pict-theme-brandstrip-stripes {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.pict-theme-brandstrip-stripe {
	width: 100%;
}
.pict-theme-brandstrip-stripe-primary {
	background: var(--brand-color-primary, transparent);
}
.pict-theme-brandstrip-stripe-secondary {
	background: var(--brand-color-secondary, transparent);
}`,
	CSSPriority: 500
};

class PictViewThemeBrandStrip extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		// No brand → empty BodySlot → renderable emits nothing.
		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandStrip = { BodySlot: [] };
			return;
		}

		let tmpShowName = (this.options.ShowName !== false);

		// Pick the right per-icon-type slot. Only one of these will be
		// non-empty so the template renders the right element.
		let tmpIconSVGSlot = [];
		let tmpIconImgSlot = [];
		if (tmpBrand.IconType === 'svg' && tmpBrand.Icon)
		{
			tmpIconSVGSlot = [{ IconHTML: tmpBrand.Icon }];
		}
		else if (tmpBrand.IconType === 'image' && tmpBrand.Icon)
		{
			tmpIconImgSlot = [{ IconURL: tmpBrand.Icon }];
		}

		let tmpNameRowSlot = tmpShowName
			? [{
				Name: tmpBrand.Name,
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot
			}]
			: [];

		let tmpTooltip = tmpBrand.Name + (tmpBrand.Tagline ? ' — ' + tmpBrand.Tagline : '');

		this.pict.AppData.PictSectionTheme.BrandStrip =
		{
			BodySlot:
			[{
				Tooltip: tmpTooltip,
				NameRowSlot: tmpNameRowSlot,
				PrimaryHeight: this.options.PrimaryStripeHeight || 3,
				SecondaryHeight: this.options.SecondaryStripeHeight || 1
			}]
		};
	}
}

PictViewThemeBrandStrip.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeBrandStrip;

},{"../Theme-Brand.js":301,"pict-view":365}],353:[function(require,module,exports){
/**
 * Theme-Button — an embeddable SVG button (sun/moon glyph) suitable for
 * application top bars. Clicking it opens a pict-section-modal popup
 * containing the Theme-Picker dropdown and the Theme-ModeToggle.
 *
 * Drop-in destination: `<div id="Theme-Button"></div>`. The button itself
 * is a tiny self-contained SVG that picks its color from the theme via
 * `currentColor` so it inherits the surrounding text color.
 *
 * Requires `pict-section-modal` to be registered (under the view hash
 * `Pict-Section-Modal` by default). If it isn't, clicking the button
 * falls back to a `console.warn` and a no-op.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Button',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Button',
	DefaultRenderable: 'Theme-Button-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Identifiers of the picker / toggle / scale views that the popup
	// will mount. Each one is optional — if a view isn't registered the
	// matching row is silently skipped (no broken DOM placeholders).
	PickerViewHash: 'Theme-Picker',
	ModeToggleViewHash: 'Theme-ModeToggle',
	ScaleSelectViewHash: 'Theme-ScaleSelect',

	// Visible button label / title (tooltip).
	Title: 'Theme',
	AriaLabel: 'Open theme menu',

	// Modal title.
	ModalTitle: 'Theme',

	// Modal width (CSS).
	ModalWidth: '320px',

	Templates:
	[
		{
			Hash: 'Theme-Button-Template',
			// SVG sourced from the shared Theme-Icons module so the
			// topbar glyph matches the picker + mode toggle exactly.
			Template: /*html*/`
<button type="button"
        class="pict-theme-button"
        aria-label="{~D:AppData.PictSectionTheme.Button.AriaLabel~}"
        title="{~D:AppData.PictSectionTheme.Button.Title~}"
        onclick="_Pict.views['Theme-Button'].openMenu();">
	${libThemeIcons.iconSun(16)}
</button>`
		},
		{
			Hash: 'Theme-Button-Modal-Template',
			Template: /*html*/`
<div class="pict-theme-button-menu">
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Theme</label>
		<div id="Theme-Picker"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Mode</label>
		<div id="Theme-ModeToggle"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Scale</label>
		<div id="Theme-ScaleSelect"></div>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Button-Renderable',
			TemplateHash: 'Theme-Button-Template',
			ContentDestinationAddress: '#Theme-Button',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	/* Sized to match a typical 12px-font / 6px-12px-padding text button
	   (~28px tall) so this drops cleanly into a topbar row alongside
	   action buttons without standing taller and crashing the row's
	   visual rhythm. Squareish — width matches height for the icon. */
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-button:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-brand-primary, #2563eb);
	border-color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-button-icon { width: 16px; height: 16px; }
.pict-theme-button-menu { display: flex; flex-direction: column; gap: 14px; }
.pict-theme-button-menu-row { display: flex; flex-direction: column; gap: 6px; }
.pict-theme-button-menu-label {
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

class PictViewThemeButton extends libPictView
{
	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the theme menu in a modal.
	 */
	openMenu()
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined')
			{
				console.warn('Theme-Button: pict-section-modal view not found at "'
					+ (this.options.ModalViewHash || 'Pict-Section-Modal')
					+ '" — cannot open theme menu.');
			}
			return null;
		}

		let tmpHTML = this.pict.parseTemplateByHash('Theme-Button-Modal-Template', {});

		let tmpSelf = this;
		return tmpModal.show(
		{
			title: this.options.ModalTitle || 'Theme',
			content: tmpHTML,
			width: this.options.ModalWidth || '320px',
			closeable: true,
			buttons: [],
			onOpen: function ()
			{
				// Mount the picker + toggle into the freshly-created
				// modal DOM. The views look up their own destinations
				// so a simple render() is enough.
				tmpSelf._mountSubViews();
			}
		});
	}

	// ================================================================
	// Internals
	// ================================================================

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	_mountSubViews()
	{
		let tmpPicker = this.pict.views[this.options.PickerViewHash || 'Theme-Picker'];
		if (tmpPicker)
		{
			tmpPicker.render();
		}
		let tmpToggle = this.pict.views[this.options.ModeToggleViewHash || 'Theme-ModeToggle'];
		if (tmpToggle)
		{
			tmpToggle.render();
		}
		let tmpScale = this.pict.views[this.options.ScaleSelectViewHash || 'Theme-ScaleSelect'];
		if (tmpScale)
		{
			tmpScale.render();
		}
	}

	_refreshAppData()
	{
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Button =
		{
			Title: this.options.Title || 'Theme',
			AriaLabel: this.options.AriaLabel || 'Open theme menu'
		};
	}
}

PictViewThemeButton.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeButton;

},{"../Theme-Icons.js":302,"pict-view":365}],354:[function(require,module,exports){
/**
 * Theme-ModeToggle — three-segment toggle for Light / Dark / System mode.
 *
 * Calls `provider.setMode(...)` on click. Greys itself out (and the
 * Dark / System buttons) when the active theme is single-mode (since
 * single-mode themes ignore mode requests internally).
 *
 * Like the Picker, subscribes to `provider.onApply` so the active button
 * highlight stays in sync with theme changes from elsewhere.
 *
 * Drop-in destination: `<div id="Theme-ModeToggle"></div>`.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ModeToggle',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ModeToggle',
	DefaultRenderable: 'Theme-ModeToggle-Renderable',

	ProviderHash: 'Theme',

	// Allow hosts to relabel buttons (i18n). Order is fixed.
	Labels:
	{
		Light:  'Light',
		Dark:   'Dark',
		System: 'System'
	},

	// Show the inline sun / moon / monitor SVG icons next to the labels.
	ShowIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-ModeToggle-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-wrap">
	<div class="pict-theme-modetoggle{~NE:AppData.PictSectionTheme.ModeToggle.Disabled^ pict-theme-modetoggle-disabled~}"
	     role="group" aria-label="Color mode"
	     title="{~D:AppData.PictSectionTheme.ModeToggle.WrapTitle~}">
		{~TS:Theme-ModeToggle-Button-Template:AppData.PictSectionTheme.ModeToggle.Buttons~}
	</div>
	{~TS:Theme-ModeToggle-LockedNote-Template:AppData.PictSectionTheme.ModeToggle.LockedNoteSlot~}
</div>`
		},
		{
			Hash: 'Theme-ModeToggle-Button-Template',
			Template: /*html*/`
<button type="button"
        class="pict-theme-modetoggle-btn{~NE:Record.Active^ pict-theme-modetoggle-btn-active~}{~NE:Record.LockedOut^ pict-theme-modetoggle-btn-lockedout~}"
        title="{~D:Record.Title~}"
        aria-pressed="{~D:Record.Active~}"
        aria-disabled="{~D:Record.LockedOut~}"
        onclick="_Pict.views['Theme-ModeToggle'].pickMode('{~D:Record.Mode~}');">
	{~TS:Theme-ModeToggle-Icon-Light:Record.IconLight~}{~TS:Theme-ModeToggle-Icon-Dark:Record.IconDark~}{~TS:Theme-ModeToggle-Icon-System:Record.IconSystem~}<span class="pict-theme-modetoggle-label">{~D:Record.Label~}</span>
</button>`
		},
		{
			Hash: 'Theme-ModeToggle-LockedNote-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-locked-note" role="note">
	<svg class="pict-theme-modetoggle-locked-icon" viewBox="0 0 24 24" fill="none"
	     stroke="currentColor" stroke-width="2" stroke-linecap="round"
	     stroke-linejoin="round" aria-hidden="true">
		<rect x="4" y="11" width="16" height="9" rx="2"/>
		<path d="M8 11V7a4 4 0 0 1 8 0v4"/>
	</svg>
	<span>{~D:Record.Message~}</span>
</div>`
		},
		// Icon templates pull SVG markup from the shared Theme-Icons
		// module so the picker, toggle, and topbar button stay visually
		// consistent — change the glyph in one place, every consumer
		// updates.
		{
			Hash: 'Theme-ModeToggle-Icon-Light',
			Template: libThemeIcons.iconSun()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-Dark',
			Template: libThemeIcons.iconMoon()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-System',
			Template: libThemeIcons.iconSystem()
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ModeToggle-Renderable',
			TemplateHash: 'Theme-ModeToggle-Template',
			ContentDestinationAddress: '#Theme-ModeToggle',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-modetoggle-wrap { display: inline-flex; flex-direction: column; gap: 6px; }
.pict-theme-modetoggle {
	display: inline-flex;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	border-radius: 6px;
	overflow: hidden;
	background: var(--theme-color-background-secondary, #fbfbfc);
	font-size: 12px;
}
.pict-theme-modetoggle-btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 4px 10px;
	border: 0;
	background: transparent;
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	border-right: 1px solid var(--theme-color-border-default, #cfd5dd);
	transition: background-color 120ms ease, color 120ms ease;
}
.pict-theme-modetoggle-btn:last-child { border-right: 0; }
.pict-theme-modetoggle-btn:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-text-primary, #1f2933);
}
.pict-theme-modetoggle-btn-active {
	background: var(--theme-color-brand-primary, #2563eb);
	color: var(--theme-color-text-on-brand, #ffffff);
}
.pict-theme-modetoggle-btn-active:hover {
	background: var(--theme-color-brand-primary-hover, #1e54cc);
	color: var(--theme-color-text-on-brand, #ffffff);
}
/* When the active theme is single-mode the entire group becomes
   non-interactive. The locked-out buttons (the ones the theme cannot
   switch to) get a strikethrough so the cause is unmistakable; the
   active button stays styled normally so users can still see which
   mode the theme IS using. */
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn {
	pointer-events: none;
	cursor: not-allowed;
}
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn-lockedout {
	opacity: 0.45;
	text-decoration: line-through;
	text-decoration-thickness: 1.5px;
}
/* Icons come from Theme-Icons.js with explicit width/height baked into
   the <svg>. We only need to nudge their vertical alignment with the
   button label. */
.pict-theme-modetoggle .pict-theme-icon {
	display: inline-block; vertical-align: -2px;
}
.pict-theme-modetoggle-label { line-height: 1; }
.pict-theme-modetoggle-locked-note {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 11px;
	line-height: 1.3;
	color: var(--theme-color-text-muted, #6b6b6b);
	padding: 0 2px;
}
.pict-theme-modetoggle-locked-icon {
	width: 12px; height: 12px;
	flex: 0 0 12px;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

// The icon SVGs themselves live as templates above (Theme-ModeToggle-Icon-*).
// Per CLAUDE.md "AppData stores data, not HTML" — we drive icon selection
// with one-or-zero element arrays (`Record.IconLight = [{}]` to render the
// Light icon, `[]` to skip it). Each template is keyed off `Record.Mode`.

class PictViewThemeModeToggle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — flip mode on the active theme. Single-mode themes
	 * silently ignore (the toggle is shown disabled in that case anyway).
	 */
	pickMode(pMode)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;
		let tmpOk = tmpProvider.setMode(pMode);

		if (tmpOk && typeof this.options.OnModeChange === 'function')
		{
			try { this.options.OnModeChange(pMode); }
			catch (pErr) { /* host hook failure */ }
		}

		// setMode fires onApply listeners which trigger our own re-render.
		// If single-mode rejected the change, force a re-render so the UI
		// state is still consistent.
		if (!tmpOk)
		{
			this.render();
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : null;
		let tmpActiveMode = (tmpActive && tmpActive.Mode) || 'light';

		// Detect single-mode (Strategy === 'single') so we can lock the
		// toggle and surface the reason the buttons aren't responding.
		let tmpDisabled = false;
		let tmpLockedToMode = null;
		let tmpThemeName = null;
		if (tmpActive && tmpActive.Hash && tmpProvider && typeof tmpProvider.getTheme === 'function')
		{
			let tmpBundle = tmpProvider.getTheme(tmpActive.Hash);
			let tmpStrategy = (tmpBundle && tmpBundle.Modes && tmpBundle.Modes.Strategy) || 'single';
			tmpDisabled = (tmpStrategy === 'single');
			if (tmpDisabled)
			{
				tmpLockedToMode = (tmpBundle.Modes && tmpBundle.Modes.Default) || tmpActiveMode || 'light';
				tmpThemeName = tmpBundle.Name || tmpBundle.Hash || 'this theme';
			}
		}

		let tmpLabels = this.options.Labels || _ViewConfiguration.Labels;
		let tmpShowIcons = (this.options.ShowIcons !== false);

		// Use one-or-zero element arrays to drive each icon template so
		// the icon SVG never gets stuffed into AppData as a raw string.
		let tmpModeRows =
		[
			{ Mode: 'light',  Label: tmpLabels.Light  || 'Light' },
			{ Mode: 'dark',   Label: tmpLabels.Dark   || 'Dark' },
			{ Mode: 'system', Label: tmpLabels.System || 'System' }
		];
		let tmpButtons = [];
		for (let i = 0; i < tmpModeRows.length; i++)
		{
			let tmpRow = tmpModeRows[i];
			let tmpIsActive = (tmpActiveMode === tmpRow.Mode);
			// "Locked out" = single-mode theme AND this button is not the
			// mode the theme is fixed to. The active button keeps normal
			// styling so users can still see which mode is in use.
			let tmpLockedOut = tmpDisabled && (tmpRow.Mode !== tmpLockedToMode);
			let tmpTitle;
			if (tmpLockedOut)
			{
				let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
				tmpTitle = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode — pick a different theme to switch.';
			}
			else
			{
				tmpTitle = tmpRow.Label + ' mode';
			}
			tmpButtons.push(
			{
				Mode: tmpRow.Mode,
				Label: tmpRow.Label,
				Title: tmpTitle,
				Active: tmpIsActive,
				LockedOut: tmpLockedOut,
				IconLight:  (tmpShowIcons && tmpRow.Mode === 'light')  ? [{}] : [],
				IconDark:   (tmpShowIcons && tmpRow.Mode === 'dark')   ? [{}] : [],
				IconSystem: (tmpShowIcons && tmpRow.Mode === 'system') ? [{}] : []
			});
		}

		// One-or-zero element array drives the locked-note template
		// (per CLAUDE.md "single-element-array trick"). Empty array →
		// note skipped entirely.
		let tmpLockedNoteSlot = [];
		let tmpWrapTitle = '';
		if (tmpDisabled)
		{
			let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
			let tmpMessage = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode';
			tmpLockedNoteSlot = [{ Message: tmpMessage }];
			tmpWrapTitle = tmpMessage + ' — pick a different theme to switch modes.';
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ModeToggle =
		{
			ActiveMode: tmpActiveMode,
			Disabled: tmpDisabled,
			LockedToMode: tmpLockedToMode,
			ThemeName: tmpThemeName,
			Buttons: tmpButtons,
			LockedNoteSlot: tmpLockedNoteSlot,
			WrapTitle: tmpWrapTitle
		};
	}
}

PictViewThemeModeToggle.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeModeToggle;

},{"../Theme-Icons.js":302,"pict-view":365}],355:[function(require,module,exports){
/**
 * Theme-Picker — a custom dropdown that lists every theme registered
 * with the Theme provider, grouped by category.
 *
 * Renders as a trigger button showing the active theme name + a chevron.
 * Click → opens a `pict-section-modal` dropdown menu where each row is
 * the theme name plus an inline SVG glyph indicating the modes the
 * theme supports (sun for light-only, moon for dark-only, sun+moon for
 * paired). This is why we ditched the native <select>: option elements
 * can't render SVG, only plain text, and the unicode crescent
 * substitutes that earlier looked like dental glyphs.
 *
 * Subscribes to `provider.onApply` so a theme switch from elsewhere
 * (the modal-tucked picker, a hotkey, persistence restore) keeps the
 * trigger button in sync.
 *
 * Drop-in destination: `<div id="Theme-Picker"></div>`.
 *
 * # Modal section dependency
 *
 * Requires pict-section-modal to be registered (the dropdown popover
 * is a modal-section feature, not a hand-rolled DOM widget). When
 * pict-section-theme.install() is used, the host always has the modal
 * section available because Theme-Button needs it too. If you add this
 * view manually without the modal section, the trigger button will
 * still render but clicking it logs a warning and no-ops.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

// AppData address used to surface picker state to templates.
const APPDATA_ADDRESS = 'PictSectionTheme.Picker';

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Picker',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Picker',
	DefaultRenderable: 'Theme-Picker-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Optional categories block — array describing the optgroup order.
	// If omitted we discover categories from the provider's themes in
	// first-seen order.
	Categories: null,

	// Show the per-row mode-capability glyph (sun / moon / sun+moon) as
	// the leading icon on each dropdown item. Default on. Pass false if
	// you want a plainer menu.
	ShowModeIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-Picker-Template',
			// Trigger button that mirrors a native <select>'s look but
			// can carry SVG content. Clicking opens the modal dropdown.
			Template: /*html*/`
<button type="button" class="pict-theme-picker"
        title="{~D:AppData.PictSectionTheme.Picker.TriggerTooltip~}"
        onclick="_Pict.views['Theme-Picker'].openMenu(this);">
	{~TS:Theme-Picker-Trigger-Glyph:AppData.PictSectionTheme.Picker.TriggerGlyphSlot~}
	<span class="pict-theme-picker-name">{~D:AppData.PictSectionTheme.Picker.ActiveLabel~}</span>
	<span class="pict-theme-picker-chevron">{~D:AppData.PictSectionTheme.Picker.ChevronHTML~}</span>
</button>`
		},
		{
			// Wrapped in a 1-or-0 element array so the trigger glyph is
			// optional (ShowModeIcons: false → empty slot, no leading
			// icon). Per CLAUDE.md "AppData stores data, not HTML".
			Hash: 'Theme-Picker-Trigger-Glyph',
			Template: /*html*/`<span class="pict-theme-picker-trigger-glyph">{~D:Record.IconHTML~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Picker-Renderable',
			TemplateHash: 'Theme-Picker-Template',
			ContentDestinationAddress: '#Theme-Picker',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-picker {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-width: 200px;
	max-width: 100%;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
	text-align: left;
	transition: border-color 120ms ease, box-shadow 120ms ease;
}
.pict-theme-picker:hover { border-color: var(--theme-color-text-muted, #6b6b6b); }
.pict-theme-picker:focus, .pict-theme-picker:focus-visible {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.pict-theme-picker .pict-theme-picker-name {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pict-theme-picker .pict-theme-picker-chevron {
	color: var(--theme-color-text-muted, #6b6b6b);
	display: inline-flex;
	align-items: center;
}
.pict-theme-picker-trigger-glyph {
	display: inline-flex; align-items: center;
	color: var(--theme-color-text-muted, #6b6b6b);
}

/* Skin the modal-dropdown items with cleaner spacing for our glyphs. */
.pict-theme-picker-menu .pict-modal-dropdown-item-icon {
	width: 28px;
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	color: var(--theme-color-text-muted, #6b6b6b);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active {
	background: var(--theme-color-background-selected, #e0eaff);
	color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active .pict-modal-dropdown-item-icon {
	color: var(--theme-color-brand-primary, #2563eb);
}`,
	CSSPriority: 500
};

class PictViewThemePicker extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		// Defensive resubscribe: onAfterInitialize attempts this once, but if the
		// Theme provider wasn't yet registered at that moment (a real race when
		// docuserve wires the Theme-Section after some views have already been
		// instantiated), the initial subscribe silently no-ops and the picker
		// never re-renders on applyTheme.  The internal guard makes this cheap
		// when we're already subscribed.
		this._subscribeToProvider();
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the rich dropdown menu via pict-section-modal.
	 * @param {HTMLElement} pAnchor - the trigger button (click target)
	 */
	openMenu(pAnchor)
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-Picker: pict-section-modal not registered — cannot open menu.');
			}
			return null;
		}

		let tmpItems = this._buildMenuItems();
		let tmpSelf = this;
		return tmpModal.dropdown(pAnchor,
		{
			items: tmpItems,
			align: 'left',
			minWidth: '260px',
			maxHeight: '60vh',
			className: 'pict-theme-picker-menu',
			closeOnSelect: true,
			onSelect: function (pHash) { tmpSelf.pick(pHash); }
		});
	}

	/**
	 * Apply the picked theme. Public so external callers can drive the
	 * picker programmatically too (hotkeys, tests, etc.).
	 */
	pick(pHash)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;

		// Preserve the current user-facing mode if the new theme
		// supports modes. Single-mode themes will clamp internally.
		let tmpActive = tmpProvider.getActiveTheme();
		let tmpMode = tmpActive ? tmpActive.Mode : null;

		let tmpOk = tmpProvider.applyTheme(pHash, tmpMode);

		if (tmpOk && typeof this.options.OnPick === 'function')
		{
			try { this.options.OnPick(pHash); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	/**
	 * Build the modal-dropdown `items` array from the registered themes
	 * + the catalog's category metadata. One Header row per category,
	 * one item per theme with a leading SVG capability glyph.
	 */
	_buildMenuItems()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		let tmpCatalog = this._loadCatalog();
		let tmpCategoryByHash = {};
		let tmpCategoryOrder = [];
		if (Array.isArray(this.options.Categories))
		{
			tmpCategoryOrder = this.options.Categories.slice();
		}
		for (let i = 0; i < tmpCatalog.length; i++)
		{
			let tmpEntry = tmpCatalog[i];
			let tmpCat = tmpEntry.Category || 'Other';
			tmpCategoryByHash[tmpEntry.Hash] = tmpCat;
			if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
		}

		let tmpBuckets = {};
		for (let i = 0; i < tmpThemes.length; i++)
		{
			let tmpTheme = tmpThemes[i];
			let tmpCat = tmpCategoryByHash[tmpTheme.Hash] || 'Other';
			if (!tmpBuckets[tmpCat])
			{
				tmpBuckets[tmpCat] = [];
				if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
			}
			tmpBuckets[tmpCat].push(tmpTheme);
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpItems = [];
		for (let i = 0; i < tmpCategoryOrder.length; i++)
		{
			let tmpCat = tmpCategoryOrder[i];
			if (!tmpBuckets[tmpCat] || tmpBuckets[tmpCat].length === 0) continue;
			tmpItems.push({ Header: tmpCat });
			for (let j = 0; j < tmpBuckets[tmpCat].length; j++)
			{
				let tmpTheme = tmpBuckets[tmpCat][j];
				let tmpIcon = tmpShowIcons
					? libThemeIcons.iconForTheme(tmpTheme.Strategy, tmpTheme.DefaultMode, 14)
					: '';
				tmpItems.push(
				{
					Hash: tmpTheme.Hash,
					Label: tmpTheme.Name || tmpTheme.Hash,
					Icon: tmpIcon,
					Style: (tmpTheme.Hash === tmpActiveHash) ? 'active' : null,
					Tooltip: this._capabilityLabel(tmpTheme)
				});
			}
		}

		return tmpItems;
	}

	_capabilityLabel(pTheme)
	{
		let tmpStrategy = pTheme.Strategy || 'single';
		if (tmpStrategy === 'single')
		{
			let tmpMode = pTheme.DefaultMode || 'light';
			return (pTheme.Name || pTheme.Hash) + ' — '
				+ (tmpMode === 'dark' ? 'dark only' : 'light only');
		}
		return (pTheme.Name || pTheme.Hash) + ' — light + dark';
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		// Find the active theme's metadata for the trigger glyph.
		let tmpActiveTheme = null;
		for (let i = 0; i < tmpThemes.length; i++)
		{
			if (tmpThemes[i].Hash === tmpActiveHash) { tmpActiveTheme = tmpThemes[i]; break; }
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpTriggerGlyphSlot = [];
		if (tmpShowIcons && tmpActiveTheme)
		{
			tmpTriggerGlyphSlot = [{
				IconHTML: libThemeIcons.iconForTheme(tmpActiveTheme.Strategy, tmpActiveTheme.DefaultMode, 14)
			}];
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Picker =
		{
			ActiveHash: tmpActiveHash,
			ActiveLabel: tmpActiveTheme ? (tmpActiveTheme.Name || tmpActiveTheme.Hash) : 'Choose a theme',
			TriggerTooltip: tmpActiveTheme
				? this._capabilityLabel(tmpActiveTheme) + ' — click to change'
				: 'Choose a theme',
			TriggerGlyphSlot: tmpTriggerGlyphSlot,
			ChevronHTML: libThemeIcons.iconChevronDown(10)
		};
		this.pict.AppData.PictSectionTheme.AllThemes = tmpThemes;
	}

	_loadCatalog()
	{
		try { return require('../themes/_catalog.js'); }
		catch (pError) { return []; }
	}
}

PictViewThemePicker.default_configuration = _ViewConfiguration;
PictViewThemePicker.APPDATA_ADDRESS = APPDATA_ADDRESS;

module.exports = PictViewThemePicker;

},{"../Theme-Icons.js":302,"../themes/_catalog.js":308,"pict-view":365}],356:[function(require,module,exports){
/**
 * Theme-ScaleSelect — dropdown that picks a viewport scale (zoom).
 *
 * Independent of the active theme bundle: scale is a per-user
 * preference stored alongside ThemeHash + Mode in localStorage. Reads
 * presets from the Theme-Scale helper (or a host-supplied `Presets`
 * array). Subscribes to Theme-Scale.onChange so external scale changes
 * (the persisted boot apply, hotkeys, other code) keep the dropdown's
 * selected option in sync.
 *
 * Drop-in destination: `<div id="Theme-ScaleSelect"></div>`.
 */

const libPictView = require('pict-view');
const libThemeScale = require('../Theme-Scale.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ScaleSelect',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ScaleSelect',
	DefaultRenderable: 'Theme-ScaleSelect-Renderable',

	// Optional override of the preset list. Each entry: { Value: <number>, Label: <string> }.
	// When omitted we use libThemeScale.PRESETS.
	Presets: null,

	Templates:
	[
		{
			Hash: 'Theme-ScaleSelect-Template',
			Template: /*html*/`
<select class="pict-theme-scaleselect"
        title="{~D:AppData.PictSectionTheme.ScaleSelect.Tooltip~}"
        onchange="_Pict.views['Theme-ScaleSelect'].pickScale(parseFloat(this.value));">
	{~TS:Theme-ScaleSelect-Option-Template:AppData.PictSectionTheme.ScaleSelect.Options~}
</select>`
		},
		{
			Hash: 'Theme-ScaleSelect-Option-Template',
			Template: /*html*/`
<option value="{~D:Record.Value~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ScaleSelect-Renderable',
			TemplateHash: 'Theme-ScaleSelect-Template',
			ContentDestinationAddress: '#Theme-ScaleSelect',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-scaleselect {
	min-width: 180px;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
}
.pict-theme-scaleselect:focus {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}`,
	CSSPriority: 500
};

class PictViewThemeScaleSelect extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromScale = null;
	}

	onAfterInitialize()
	{
		this._subscribeToScale();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onchange handler — apply a new scale and let the listener re-render.
	 * @param {number} pScale
	 */
	pickScale(pScale)
	{
		let tmpApplied = libThemeScale.applyScale(pScale);
		if (typeof this.options.OnScaleChange === 'function')
		{
			try { this.options.OnScaleChange(tmpApplied); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpApplied;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToScale()
	{
		if (this._unsubscribeFromScale) return;
		let tmpSelf = this;
		this._unsubscribeFromScale = libThemeScale.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpPresets = Array.isArray(this.options.Presets) ? this.options.Presets : libThemeScale.PRESETS;
		let tmpActive = libThemeScale.getActive();

		// "Closest" match — the saved scale may be a custom value (e.g.
		// 1.10 from a hotkey nudge) that doesn't exactly equal any preset.
		// We highlight the nearest option so the dropdown still reflects
		// roughly where the user is.
		let tmpClosestIdx = 0;
		let tmpClosestDelta = Infinity;
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpDelta = Math.abs(tmpPresets[i].Value - tmpActive);
			if (tmpDelta < tmpClosestDelta) { tmpClosestDelta = tmpDelta; tmpClosestIdx = i; }
		}

		let tmpOptions = [];
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpEntry = tmpPresets[i];
			tmpOptions.push(
			{
				Value: tmpEntry.Value,
				Label: tmpEntry.Label,
				Selected: (i === tmpClosestIdx)
			});
		}

		let tmpTooltip = 'Viewport scale — currently '
			+ Math.round(tmpActive * 100) + '%';

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ScaleSelect =
		{
			ActiveScale: tmpActive,
			Tooltip: tmpTooltip,
			Options: tmpOptions
		};
	}
}

PictViewThemeScaleSelect.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeScaleSelect;

},{"../Theme-Scale.js":304,"pict-view":365}],357:[function(require,module,exports){
/**
 * Theme-TopBar — standard application chrome row.
 *
 * Provides the boilerplate every Pict / retold app remakes: a flex row
 * with three zones — brand mark on the left, navigation in the middle,
 * configuration / user widgets on the right (with the theme button
 * pinned at the far edge).
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ [Brand-Mark]   [── Nav slot (flex-grow) ──]   [User-slot] [⚙]  │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Auto-mounts:
 *   - Theme-Brand-Mark in the brand slot (skip via MountBrandMark: false)
 *   - Theme-Button at the far right of the user area (skip via
 *     MountThemeButton: false)
 *
 * Host fills two empty slots via standard Pict view destinations:
 *   - `#Theme-TopBar-Nav`  — primary navigation / action buttons
 *   - `#Theme-TopBar-User` — app-specific user-area widgets (account,
 *                            log toggle, custom indicators)
 *
 * Renders into `#Theme-TopBar` by default. The host's layout shell
 * provides that destination — typically the top panel of a
 * pict-section-modal Shell.
 *
 * The bottom border uses `--brand-color-primary-mode` so the topbar
 * carries a thin brand stripe that auto-swaps with light/dark mode.
 *
 * Each app's nav / user-area views can stay app-specific; this view
 * eliminates the chrome boilerplate around them.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-TopBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-TopBar',
	DefaultRenderable: 'Theme-TopBar-Renderable',

	// When false, the host is responsible for mounting Theme-Brand-Mark
	// itself (or skipping the brand entirely).
	MountBrandMark: true,
	// When false, Theme-Button is not auto-mounted into the user slot.
	// Useful when the host wants to position the button somewhere else
	// or when no theme picker is desired.
	MountThemeButton: true,
	// ViewIdentifier of a host-supplied view that fills the nav slot
	// (#Theme-TopBar-Nav). Typical convention: a small per-app view
	// rendering primary action buttons / nav links / breadcrumbs.
	NavView: null,
	// ViewIdentifier of a host-supplied view that fills the user-area
	// slot (#Theme-TopBar-User). Theme-Button still auto-mounts at the
	// far edge — this view fills the slot before it.
	UserView: null,

	// Height of the bar in pixels. Drives the min-height on the
	// chrome row so it fills the panel cleanly even when the parent
	// chain (pict-section-modal shell uses min-height: 100% on its
	// panel content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 56,

	// Horizontal alignment of items inside the nav slot. The slot
	// itself stretches (flex: 1) between brand mark and user area;
	// this option controls where the nav content sits within that
	// stretched space. Default 'right' so action buttons hug the
	// user-area / theme button cluster (the convention every
	// retold-* app converged on). Override to 'left' to put the nav
	// flush against the brand, or 'center' to centre it across the
	// row. Maps to justify-content: flex-end / flex-start / center.
	NavAlign: 'right',

	// Viewport width (px) below which the topbar collapses to compact
	// mode: nav + user-area widgets hide, a burger button shows in
	// their place. Clicking the burger opens a pict-section-modal
	// popup with a clone of the nav + user DOM, so every action stays
	// reachable.
	//
	// Default 900px — the conventional "narrow desktop / small laptop"
	// cut-off where a topbar with ~4 nav buttons + a brand mark + a
	// user-area cluster genuinely starts crowding. Most users will
	// resize a window to this range (drag a split-pane, dock a window
	// next to another app, etc.); 600px would only trigger at true
	// mobile widths most desktop users never hit.
	//
	// Conventional ladder for picking a value:
	//   ~1024px  large breakpoint — nav-heavy apps with 6+ buttons
	//    ~900px  default — "narrow desktop window" (recommended)
	//    ~768px  tablet portrait — minimal-nav apps
	//    ~600px  mobile-only — single-button toolbars
	//        0   disable compact mode entirely
	CompactBreakpoint: 900,

	Templates:
	[
		{
			Hash: 'Theme-TopBar-Template',
			// The burger button is hidden by default and the regular nav /
			// user-slot are visible — flipped by the media query in CSS
			// at the CompactBreakpoint (default 600px). On click the
			// burger opens a pict-section-modal popup containing a clone
			// of the existing #Theme-TopBar-Nav + #Theme-TopBar-User DOM
			// — host apps don't need to provide a separate burger view.
			Template: /*html*/`
<div class="pict-theme-topbar">
	<div class="pict-theme-topbar-mark"><div id="Theme-Brand-Mark"></div></div>
	<div class="pict-theme-topbar-nav" id="Theme-TopBar-Nav"></div>
	<div class="pict-theme-topbar-user">
		<div class="pict-theme-topbar-user-slot" id="Theme-TopBar-User"></div>
		<div class="pict-theme-topbar-user-button"><div id="Theme-Button"></div></div>
		<button type="button" class="pict-theme-topbar-burger"
			aria-label="More navigation"
			title="Menu"
			onclick="_Pict.views['Theme-TopBar'].openBurgerMenu();">
			<svg width="20" height="20" viewBox="0 0 24 24" fill="none"
				stroke="currentColor" stroke-width="2"
				stroke-linecap="round" stroke-linejoin="round"
				aria-hidden="true">
				<path d="M3 6h18M3 12h18M3 18h18"/>
			</svg>
		</button>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-TopBar-Renderable',
			TemplateHash: 'Theme-TopBar-Template',
			ContentDestinationAddress: '#Theme-TopBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-topbar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 56). Avoids the percent-height resolution
	   trap: pict-section-modal's panel destination uses min-height: 100%
	   on its inner div, which means a child's height: 100% / min-height:
	   100% resolves against the parent's *property* (auto), not its
	   resolved size — and collapses the row to its content. A fixed px
	   value gives align-items: center real space to centre into. */
	min-height: 56px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-panel, transparent);
	/* Brand stripes are drawn by .pict-theme-topbar::after as an absolute
	   element overlaying the bottom 5px of the row. Using ::after rather
	   than border-bottom + box-shadow lets us put a transparent gap
	   between the two stripes (border / box-shadow can't draw gaps).
	   Position relative so the ::after positions to this row. */
	position: relative;
}
/* Two-stripe brand identifier at the bottom of the topbar:
     4px brand-primary (thicker — the dominant identifier)
     2px transparent gap (clearly readable separation)
     3px brand-secondary (thinner than primary but still substantial)
   Earlier iterations used 1–2px stripes; both read clearly at light
   mode but dark-mode secondary colors are often desaturated (lifted)
   so the eye can miss a thin band against a dark background. The
   current sizes push the secondary above the perception threshold
   regardless of palette. Stripes overlay the bottom 9px of the row;
   content (which centres in the full row via align-items: center)
   keeps its visual position. */
.pict-theme-topbar::after {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 9px;
	pointer-events: none;
	background: linear-gradient(
		to bottom,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 0,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 4px,
		transparent 4px,
		transparent 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 9px
	);
}
.pict-theme-topbar-mark {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
}
.pict-theme-topbar-nav {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	/* Default to right-aligning nav items inside the stretched slot —
	   the convention retold-* apps converged on. Overridden per-instance
	   from the NavAlign option in onAfterRender. */
	justify-content: flex-end;
	gap: 8px;
	min-width: 0;
	/* Horizontally scrollable when the nav overflows (narrow viewports
	   with many buttons) — better than overflow:hidden which would
	   silently clip buttons offscreen. The vertical axis stays clipped
	   so a tall accidental child doesn't blow up the row height. A
	   proper overflow menu is a future enhancement; this gets us safe
	   degradation today. */
	overflow-x: auto;
	overflow-y: hidden;
	/* Hide the scrollbar by default; modern browsers pick up the
	   trackpad scroll without it. Apps wanting a visible scrollbar
	   can override at higher specificity. */
	scrollbar-width: none;
}
.pict-theme-topbar-nav::-webkit-scrollbar { display: none; }
/* Active-route indicator. The convention every host app should follow:
   put aria-current="page" on the button (or anchor) representing the
   current route. The W3C-standard attribute reads correctly to screen
   readers and gets a brand-tinted highlight here. Apps that already
   ship their own active styling can override these rules — they're
   keyed off attribute selectors so no class collision is possible. */
.pict-theme-topbar-nav [aria-current="page"],
.pict-theme-topbar-user [aria-current="page"] {
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	background: var(--theme-color-background-hover, rgba(37, 99, 235, 0.08));
}
.pict-theme-topbar-user {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-slot {
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-button {
	display: flex;
	align-items: center;
}
/* Burger button — hidden by default; the media query (or the inline
   per-instance JS that swaps it via CompactBreakpoint) shows it once
   the viewport drops below the host's compact threshold. Sized to
   match Theme-Button (28×28) so the row's rhythm is preserved. */
.pict-theme-topbar-burger {
	display: none;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-topbar-burger:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Burger menu popup — applied to the cloned nav + user DOM inside
   pict-section-modal. The cloned children inherit their original
   styling (action buttons, badges, etc.) so the popup looks visually
   consistent with what was on the topbar. */
.pict-theme-burger-menu {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.pict-theme-burger-menu-section {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
/* Cloned children render as a vertical stack inside the popup — flip
   the horizontal flex layouts to column so each button takes a full
   row instead of cramming side-by-side at narrow width. */
.pict-theme-burger-menu .rm-topbar-nav,
.pict-theme-burger-menu .rm-topbar-user,
.pict-theme-burger-menu [class*="-topbar-nav"],
.pict-theme-burger-menu [class*="-topbar-user"] {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 6px;
}
.pict-theme-burger-menu button { width: 100%; text-align: left; }
.pict-theme-burger-menu .rm-topbar-nav-divider,
.pict-theme-burger-menu [class*="divider"] { display: none; }
/* Compact mode — defaults to a 900px breakpoint. The onAfterRender
   handler injects a per-instance <style> rule when the host passes a
   different CompactBreakpoint, so this @media block is the fallback
   for hosts that accept the default. */
@media (max-width: 900px) {
	.pict-theme-topbar-nav            { display: none !important; }
	.pict-theme-topbar-user-slot      { display: none !important; }
	.pict-theme-topbar-burger         { display: inline-flex; }
	/* In wide mode the flex-1 nav slot pushes the user-area to the
	   right edge. With the nav hidden the user-area would collapse
	   left of the now-empty middle; the auto-margin re-creates the
	   "push right" effect so the theme button + burger stay flush
	   against the right edge of the topbar. */
	.pict-theme-topbar-user           { margin-left: auto; }
}`,
	CSSPriority: 500
};

class PictViewThemeTopBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-topbar.
		// Using inline style so each instance can carry its own size
		// (different apps will pick different heights) without us having
		// to inject per-instance <style> blocks.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-topbar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		// Per-instance CompactBreakpoint. CSS @media rules can't reference
		// JS option values, so when the host overrides the default 600px
		// we inject a single-rule <style> with the chosen breakpoint and
		// !important to win over the static media query. Set to 0 to
		// disable compact mode entirely (the burger stays hidden).
		this._applyCompactBreakpoint();

		// Translate NavAlign ('left' | 'right' | 'center') to the matching
		// justify-content. Right is the default (and already in the static
		// CSS), but the inline style wins so an explicit option always
		// takes precedence over the cached stylesheet.
		if (typeof document !== 'undefined' && this.options.NavAlign)
		{
			let tmpJustify = ({
				left:   'flex-start',
				right:  'flex-end',
				center: 'center'
			})[this.options.NavAlign];
			if (tmpJustify)
			{
				let tmpNav = document.querySelector('.pict-theme-topbar-nav');
				if (tmpNav) { tmpNav.style.justifyContent = tmpJustify; }
			}
		}

		// Auto-mount the standard pieces. Host can opt out via the view
		// options (MountBrandMark / MountThemeButton).
		if (this.options.MountBrandMark !== false)
		{
			let tmpBrandMark = this.pict.views['Theme-Brand-Mark'];
			if (tmpBrandMark) { tmpBrandMark.render(); }
		}
		if (this.options.NavView)
		{
			let tmpNavView = this.pict.views[this.options.NavView];
			if (tmpNavView) { tmpNavView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: NavView "' + this.options.NavView + '" not registered');
			}
		}
		if (this.options.UserView)
		{
			let tmpUserView = this.pict.views[this.options.UserView];
			if (tmpUserView) { tmpUserView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: UserView "' + this.options.UserView + '" not registered');
			}
		}
		if (this.options.MountThemeButton !== false)
		{
			let tmpThemeButton = this.pict.views['Theme-Button'];
			if (tmpThemeButton) { tmpThemeButton.render(); }
		}

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Apps with chrome that morphs between routes (e.g. breadcrumb-style
	// navigation that differs by section) call setNavView / setUserView
	// from their router callback. The new view is rendered into the
	// matching slot and the option is persisted so subsequent re-renders
	// of the topbar (theme switches, etc.) keep the new view mounted.

	/**
	 * Swap the NavView (slot at `#Theme-TopBar-Nav`) at runtime.
	 * @param {string|null} pViewIdentifier
	 *   View hash to mount, or null to clear the slot.
	 */
	setNavView(pViewIdentifier)
	{
		this.options.NavView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-Nav', this.options.NavView);
	}

	/**
	 * Swap the UserView (slot at `#Theme-TopBar-User`) at runtime.
	 * @param {string|null} pViewIdentifier
	 */
	setUserView(pViewIdentifier)
	{
		this.options.UserView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-User', this.options.UserView);
	}

	_mountSlot(pDestSelector, pViewIdentifier)
	{
		// Clear the slot first — handles both the clear-only case
		// (pViewIdentifier is null) and the swap case (gives the
		// new view a clean slate when its renderable doesn't use
		// `replace` mode).
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-TopBar: view "' + pViewIdentifier + '" not registered');
		}
	}

	// ─── Compact mode + burger menu ──────────────────────────────────────
	// At narrow widths the nav + user-area slots collapse into a single
	// burger button that opens a pict-section-modal popup with the
	// cloned nav + user DOM. The default breakpoint is 600px; hosts that
	// want a different value pass CompactBreakpoint in ViewOptions.

	_applyCompactBreakpoint()
	{
		if (typeof document === 'undefined') return;
		// Default value of 900 lives in the static CSS @media block; we
		// only need to inject when the host explicitly overrode it.
		let tmpBreakpoint = this.options.CompactBreakpoint;
		if (tmpBreakpoint === undefined || tmpBreakpoint === null) return;
		if (tmpBreakpoint === 900) return;  // matches default — no override needed

		let tmpStyleId = 'pict-theme-topbar-compact-' + this.UUID;
		let tmpStyleEl = document.getElementById(tmpStyleId);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = tmpStyleId;
			document.head.appendChild(tmpStyleEl);
		}

		// 0 (or any non-positive value) disables compact mode by emitting
		// a never-matching media rule. The static CSS still has the 600px
		// rule, so we override it with a more-specific selector + the
		// chosen breakpoint. Specificity-wise the inline rule wins
		// because it's emitted after the static CSS and has !important
		// matching the static rule's importance.
		if (typeof tmpBreakpoint !== 'number' || tmpBreakpoint <= 0)
		{
			// Disable: force compact selectors to never apply by giving
			// the burger display: none unconditionally at all widths.
			tmpStyleEl.textContent =
				'.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'.pict-theme-topbar-burger         { display: none !important; }\n' +
				'.pict-theme-topbar-user           { margin-left: 0 !important; }\n';
		}
		else
		{
			tmpStyleEl.textContent =
				'@media (max-width: ' + tmpBreakpoint + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: none !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: none !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: inline-flex !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: auto !important; }\n' +
				'}\n' +
				'@media (min-width: ' + (tmpBreakpoint + 1) + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: none !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: 0 !important; }\n' +
				'}\n';
		}
	}

	/**
	 * Open the burger / overflow menu. Clones the current contents of
	 * `#Theme-TopBar-Nav` and `#Theme-TopBar-User` into a
	 * pict-section-modal popup so every action stays reachable at narrow
	 * widths. The cloned buttons keep their inline `onclick` handlers
	 * (those reference globals like `_Pict.PictApplication.*`, which
	 * resolve at click-time regardless of where the DOM lives).
	 *
	 * Override on the instance (`view.openBurgerMenu = function() {...}`)
	 * to customise the popup contents — e.g. emit a per-app menu view
	 * instead of cloning the topbar DOM.
	 */
	openBurgerMenu()
	{
		if (typeof document === 'undefined') return null;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-TopBar: pict-section-modal not registered — burger menu unavailable.');
			}
			return null;
		}

		let tmpSections = [];
		let tmpNav = document.querySelector('#Theme-TopBar-Nav');
		let tmpUser = document.querySelector('#Theme-TopBar-User');
		if (tmpNav && tmpNav.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpNav.innerHTML + '</div>');
		}
		if (tmpUser && tmpUser.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpUser.innerHTML + '</div>');
		}
		if (tmpSections.length === 0)
		{
			tmpSections.push('<div class="pict-theme-burger-menu-empty">No menu items configured.</div>');
		}

		let tmpHTML = '<div class="pict-theme-burger-menu">' + tmpSections.join('') + '</div>';

		return tmpModal.show(
		{
			title:    'Menu',
			content:  tmpHTML,
			width:    '280px',
			closeable: true,
			buttons:  []
		});
	}
}

module.exports = PictViewThemeTopBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],358:[function(require,module,exports){
'use strict';

// The shared Workspace shell + generic-content CSS (the `.pw-*` family, promoted out of ProjectWorkspace so it is
// no longer a side-effect of whichever workspace paints first). Entity-specific styling (maps, staffing, logos,
// label managers, …) stays in each workspace config's `CSSExtra`. The tab-bar CSS comes from pict-section-tabbar.

const libTabBar = require('pict-section-tabbar');

const WORKSPACE_CSS = /*css*/`
	.pw-wrap { padding: 1.25rem 1.5rem 2rem; }
	.pw-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin: 0 0 1rem; flex-wrap: wrap; }
	.pw-head-id { min-width: 0; }
	.pw-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); margin: 0; }
	.pw-title { font-size: 1.5rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
	.pw-subtitle { font-size: 0.86rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.3rem 0 0; }
	.pw-head-actions, .pw-head-btns { display: inline-flex; gap: 0.4rem; flex: 0 0 auto; align-items: center; flex-wrap: wrap; }
	.pw-btn { font-size: 0.82rem; font-weight: 600; padding: 0.42rem 0.85rem; border-radius: 7px; border: 1px solid var(--theme-color-border-medium, #d5dbe3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); cursor: pointer; display: inline-flex; align-items: center; gap: 0.4rem; text-decoration: none; }
	.pw-btn:hover { border-color: var(--theme-color-brand-primary, #5650e6); color: var(--theme-color-text-primary, #1f2733); text-decoration: none; }
	.pw-btn.is-link { background: var(--theme-color-brand-primary, #5650e6); border-color: var(--theme-color-brand-primary, #5650e6); color: #fff; }
	.pw-btn.is-link:hover { color: #fff; opacity: 0.94; }
	.pw-btn.is-light { background: var(--theme-color-background-secondary, #f0f2f6); }
	.pw-btn.is-danger { color: var(--theme-color-status-danger, #c0392b); border-color: var(--theme-color-status-danger, #c0392b); background: transparent; }
	.pw-back { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); white-space: nowrap; align-self: center; }
	.pw-back:hover { color: var(--theme-color-brand-primary, #5650e6); }

	.pw-tabnav { border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); margin: 0.6rem 0 0; }
	.pw-panel { border: 1px solid var(--theme-color-border-default, #d7dce3); border-top: none; border-radius: 0 0 8px 8px; background: var(--theme-color-background-panel, #fff); padding: 1.4rem 1.5rem; min-height: 12rem; }
	.pw-panel.pw-panel-standalone { border-top: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }

	.pw-state { padding: 1.6rem 0.4rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
	.pw-empty { text-align: center; color: var(--theme-color-text-muted, #8a94a3); padding: 2.2rem 0; }
	.pw-empty .fa-inbox, .pw-empty .fa-circle-info { font-size: 1.6rem; opacity: 0.5; }
	.pw-empty p { margin-top: 0.5rem; font-size: 0.9rem; }
	.pw-error { font-size: 0.88rem; color: var(--theme-color-status-danger, #c0392b); }
	.pw-spinner { display: inline-block; width: 1.4rem; height: 1.4rem; border: 3px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: pw-spin 0.8s linear infinite; vertical-align: middle; }
	.pw-spinner-inline { width: 1rem; height: 1rem; border-width: 2px; }
	@keyframes pw-spin { to { transform: rotate(360deg); } }

	/* Overview field groups */
	.pw-group { margin: 0 0 1.4rem; }
	.pw-group:last-child { margin-bottom: 0; }
	.pw-group-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-brand-primary, #5650e6);
		background: var(--theme-color-background-selected, #eef1f8); padding: 0.35rem 0.7rem; border-radius: 6px; margin: 0 0 0.7rem; display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; }
	.pw-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr)); gap: 0.85rem 1.4rem; }
	.pw-field.pw-field-wide { grid-column: 1 / -1; }
	.pw-field-label { display: block; font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.1rem; }
	.pw-field-value { font-size: 1.02rem; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); word-break: break-word; }
	.pw-field-value.pw-field-mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.82rem; font-weight: 500; }
	.pw-desc { white-space: pre-wrap; font-weight: 500; font-size: 0.98rem; color: var(--theme-color-text-primary, #1f2733); }

	/* Generic related-data tables (childlist / render) */
	.pw-toolbar { display: flex; gap: 0.5rem; margin-bottom: 0.9rem; align-items: center; flex-wrap: wrap; }
	.pw-tablewrap { overflow-x: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
	.pw-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.86rem; }
	.pw-table thead th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); white-space: nowrap; }
	.pw-table tbody td { padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; color: var(--theme-color-text-secondary, #45505f); }
	.pw-table tbody tr:last-child td { border-bottom: none; }
	.pw-table tbody tr:hover td { background: var(--theme-color-background-secondary, #f7f9fb); }
	.pw-table .pw-num { text-align: right; font-variant-numeric: tabular-nums; }
	.pw-cell-strong { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
	.pw-muted { color: var(--theme-color-text-muted, #8a94a3); }
	.pw-row-actions { white-space: nowrap; text-align: right; }
	.pw-row-actions .pw-btn { padding: 0.2rem 0.5rem; font-size: 0.74rem; margin-left: 0.25rem; }
	.pw-embed-host { min-height: 4rem; }
	.pw-status-pill { font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.14rem 0.55rem; border-radius: 999px; background: var(--theme-color-background-selected, #eef1f8); color: var(--theme-color-brand-primary, #5650e6); }

	${ libTabBar.TABBAR_CSS }
`;

module.exports = { WORKSPACE_CSS };

},{"pict-section-tabbar":299}],359:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libTabBar = require('pict-section-tabbar');

// The base association-editor from pict-section-recordset (used for kind:'assoc' tabs) is an OPTIONAL peer: a host
// that uses assoc tabs installs pict-section-recordset; without it, assoc tabs degrade gracefully. The require is
// built from a computed path so the bundler + typechecker treat it as a runtime-only, optional dependency.
let libRecordSetAssociationEditor = null;
try { libRecordSetAssociationEditor = require([ 'pict-section-recordset', 'source/views/associate/RecordSet-AssociationEditor.js' ].join('/')); }
catch (pError) { /* assoc tabs unavailable without pict-section-recordset */ }

// Host-settable defaults. These let an application wire the framework ONCE (next to `setDefaultDestination`)
// instead of threading the same value through every workspace config:
//   - DEFAULT_REST_CLIENT_NAME: which fable service speaks to the record API. A host that registers its client
//     under a name other than `RestClient` (and may also have a differently-based `RestClient` registered) sets
//     this so the base resolves the right one — otherwise the read hits the wrong base URL.
//   - libRecordSetAssociationEditor: the base association editor. The optional require above is written as a
//     computed path so bundlers/typecheckers treat pict-section-recordset as runtime-only; some bundlers
//     (e.g. browserify) will not include a computed require at all, leaving it null and breaking every assoc
//     tab. `setAssociationEditorLib()` lets such a host inject the editor it already bundles.
let DEFAULT_REST_CLIENT_NAME = 'RestClient';
function setDefaultRestClientName(pName) { if (pName && (typeof pName === 'string')) { DEFAULT_REST_CLIENT_NAME = pName; } }
function setAssociationEditorLib(pLib) { if (pLib) { libRecordSetAssociationEditor = pLib; } }

/**
 * pict-section-workspace base provider — owns everything every entity workspace shares: the REST + format helpers,
 * the GUID-bridge loader, tab routing, permissions, the shell render (header + tab bar + body panel), and the four
 * tab content-kind resolvers (render / embed / assoc / childlist). A concrete workspace is either the base + a
 * declarative config (registered by the factory) or a thin subclass that adds bespoke `render:` tab methods.
 *
 * Config is read from `this.workspaceConfig` — the factory sets `options.WorkspaceConfig`; a subclass may override
 * the getter. See Pict-Section-Workspace.js for the config schema.
 */
class PictSectionWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._record = null;
		this._id = 0;
		this._activeTab = null;
		this._mode = 'view';
		this._assocRenderQueue = Promise.resolve();
	}

	// --- config + identity -----------------------------------------------------------------------------------
	get workspaceConfig() { return this.options.WorkspaceConfig || {}; }
	get identifier() { return this.workspaceConfig.Identifier; }
	get entityName() { return this.workspaceConfig.Entity.Name; }
	get idField() { return this.workspaceConfig.Entity.IDField || `ID${this.entityName}`; }
	get collection() { return this.workspaceConfig.Entity.Collection || `${this.entityName}s`; }
	get guidField() { return this.workspaceConfig.Entity.GUIDField || `GUID${this.entityName}`; }
	readEndpoint(pID) { const fn = this.workspaceConfig.Entity.ReadEndpoint; return fn ? fn(pID) : `${this.entityName}/${pID}`; }
	/** URL segment for the workspace routes (#/<prefix>/Workspace/…). Defaults to the entity name; a config may
	 *  override it when the route noun differs from the entity (e.g. PhysicalAsset records under #/Asset/Workspace). */
	get routePrefix() { return this.workspaceConfig.RoutePrefix || this.entityName; }

	get containerSelector() { return `#${this.identifier}-Container`; }
	get bodySelector() { return `#${this.identifier}-Body`; }
	get view() { return this.pict.views[this.identifier]; }
	get record() { return this._record || {}; }
	get idRecord() { return this._id; }

	get state()
	{
		const tmpKey = this.identifier;
		if (!this.pict.AppData[tmpKey]) { this.pict.AppData[tmpKey] = { Loading: false, Message: '', Tab: '' }; }
		return this.pict.AppData[tmpKey];
	}

	// --- REST + helpers --------------------------------------------------------------------------------------
	/** Name of the fable service that speaks to the record API (getJSON/putJSON/postJSON). Override per workspace
	 *  via config `RestClientName`, or app-wide via `setDefaultRestClientName()`; defaults to `RestClient`. Falls
	 *  back to a couple of common names so a host that registered its client under a different name still resolves. */
	get restClientName() { return this.workspaceConfig.RestClientName || DEFAULT_REST_CLIENT_NAME; }
	get restClient()
	{
		const tmpFable = this.pict.fable || {};
		return tmpFable[this.restClientName] || tmpFable.RestClient || tmpFable.HeadlightRestClient || this.pict.RestClient || this.pict.HeadlightRestClient || null;
	}
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	/** Shared display formatter — the currency/percent/number/id/date/bool switch every workspace overview used. */
	_formatValue(pValue, pFormat)
	{
		if (pValue === null || pValue === undefined || pValue === '') { return '—'; }
		switch (pFormat)
		{
		case 'currency': { const tmpN = Number(pValue); return isNaN(tmpN) ? String(pValue) : `$${tmpN.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`; }
		case 'percent': { const tmpN = Number(pValue); return isNaN(tmpN) ? String(pValue) : `${tmpN}%`; }
		case 'number': { const tmpN = Number(pValue); return isNaN(tmpN) ? String(pValue) : tmpN.toLocaleString(); }
		case 'date': { const tmpS = String(pValue); return (tmpS.indexOf('T') > -1) ? tmpS.slice(0, 10) : tmpS; }
		case 'bool': return (pValue === true || pValue === 1 || pValue === '1') ? 'Yes' : 'No';
		default: return String(pValue);
		}
	}

	// --- permissions -----------------------------------------------------------------------------------------
	get permissions() { return this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService); }
	can(pEntity, pAction)
	{
		const tmpSvc = this.permissions;
		if (!tmpSvc || (typeof tmpSvc.can !== 'function')) { return true; }
		return !!tmpSvc.can(pEntity, pAction);
	}
	/** Default: fail-open until the capability map is ready, then require <Entity>-Read. A config can override. */
	canRead()
	{
		const tmpCfg = this.workspaceConfig.Permissions || {};
		if (typeof tmpCfg.Read === 'function') { return !!tmpCfg.Read(this); }
		const tmpSvc = this.permissions;
		if (!tmpSvc || !tmpSvc.currentUserReady || !tmpSvc.currentUserReady()) { return true; }
		return this.can(this.entityName, 'Read');
	}

	// --- load ------------------------------------------------------------------------------------------------
	/** True in edit or create mode — used to swap the tab body for the configured EditContent (a CRUD form host). */
	get isEditing() { return (this._mode === 'edit') || (this._mode === 'create'); }
	get mode() { return this._mode; }

	async loadAsync(pID, pTab, pMode)
	{
		this._id = parseInt(pID, 10) || 0;
		this._mode = (pMode === 'edit') ? 'edit' : 'view';
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Message = '';
		this._activeTab = this._normalizeTab(pTab);
		tmpState.Tab = this._activeTab;
		this.renderWorkspace();
		try
		{
			const tmpRecord = await this._getJSON(this.readEndpoint(this._id));
			if (!tmpRecord || !tmpRecord[this.idField]) { throw new Error(`${this.entityName} ${this._id} not found.`); }
			this._record = tmpRecord;
			this._resolvedCards = {};
			if (typeof this['hydrateAsync'] === 'function') { await this['hydrateAsync'](tmpRecord); }
			tmpState.Loading = false;
			this.renderWorkspace();
			this._resolveCardsAsync();   // best-effort; re-renders the overview when related names arrive
			await this._enterTab(this.isEditing ? '__edit__' : this._activeTab);
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the ${this.entityName.toLowerCase()}: ${(pError && pError.message) || pError}`;
			this.renderWorkspace();
		}
	}

	async openByGUIDAsync(pGUID, pMode)
	{
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Message = '';
		this._mode = (pMode === 'edit') ? 'edit' : 'view';
		this.renderWorkspace();
		const tmpRows = await this._getJSON(`${this.collection}/FilteredTo/FBV~${this.guidField}~EQ~${encodeURIComponent(pGUID)}`);
		const tmpRecord = (Array.isArray(tmpRows) && tmpRows.length > 0) ? tmpRows[0] : null;
		if (!tmpRecord)
		{
			this._record = null;
			tmpState.Loading = false;
			tmpState.Message = `No ${this.entityName.toLowerCase()} found for ${pGUID}.`;
			this.renderWorkspace();
			return;
		}
		return this.loadAsync(tmpRecord[this.idField], this._activeTab, this._mode);
	}

	/** Enter CREATE mode (no record). Subclasses implement hydrateCreateAsync(pArg) to seed the working form. */
	async startCreateAsync(pArg)
	{
		this._id = 0;
		this._mode = 'create';
		this._record = {};
		this._resolvedCards = {};
		const tmpState = this.state;
		tmpState.Loading = false; tmpState.Message = ''; tmpState.Tab = this._activeTab;
		if (typeof this['hydrateCreateAsync'] === 'function') { await this['hydrateCreateAsync'](pArg); }
		this.renderWorkspace();
		await this._enterTab('__edit__');
	}

	// --- tabs ------------------------------------------------------------------------------------------------
	get tabDefs() { return this.workspaceConfig.Tabs || []; }
	/** Tab defs for RENDERING: resolves any function-valued Label against `this` (dynamic labels, e.g. "Projects (N)"). */
	_resolvedTabDefs()
	{
		const fResolve = (pTab) =>
		{
			const tmpTab = Object.assign({}, pTab);
			if (typeof tmpTab.Label === 'function') { try { tmpTab.Label = tmpTab.Label(this); } catch (pError) { tmpTab.Label = ''; } }
			if (Array.isArray(tmpTab.Children)) { tmpTab.Children = tmpTab.Children.map(fResolve); }
			return tmpTab;
		};
		return this.tabDefs.map(fResolve);
	}
	_leafTabs()
	{
		const tmpOut = [];
		for (const tmpTab of this.tabDefs)
		{
			if (Array.isArray(tmpTab.Children) && tmpTab.Children.length) { tmpOut.push(...tmpTab.Children); }
			else { tmpOut.push(tmpTab); }
		}
		return tmpOut;
	}
	validTabKeys() { return this._leafTabs().map((pTab) => pTab.Key); }
	defaultTab() { const tmpLeaves = this._leafTabs(); return tmpLeaves.length ? tmpLeaves[0].Key : ''; }
	_normalizeTab(pTab) { const tmpKeys = this.validTabKeys(); return (tmpKeys.indexOf(pTab) > -1) ? pTab : this.defaultTab(); }
	_activeLeaf() { return this._leafTabs().find((pTab) => pTab.Key === this._activeTab) || null; }

	navigateTab(pTab)
	{
		if (this._id && (typeof window !== 'undefined') && window.location) { window.location.hash = `#/${this.routePrefix}/Workspace/${this._id}/${pTab}`; }
		else { this.setTab(pTab); }
	}
	openTabAsync(pID, pTab)
	{
		const tmpID = parseInt(pID, 10);
		if (this._record && (Number(this._record[this.idField]) === tmpID) && !this.state.Loading) { return Promise.resolve(this.setTab(pTab)); }
		return Promise.resolve(this.loadAsync(tmpID, pTab));
	}
	setTab(pTab)
	{
		this._activeTab = this._normalizeTab(pTab);
		this.state.Tab = this._activeTab;
		this.renderWorkspace();
		return this._enterTab(this._activeTab);
	}
	async _enterTab(pTab)
	{
		// '__edit__' is the pseudo-tab for the edit/create body — its OnEnter lives on EditContent.
		const tmpLeaf = (pTab === '__edit__') ? { Key: '__edit__', OnEnter: (this.workspaceConfig.EditContent || {}).OnEnter } : this._leafTabs().find((t) => t.Key === pTab);
		if (tmpLeaf && tmpLeaf.OnEnter)
		{
			const tmpFn = (typeof tmpLeaf.OnEnter === 'function') ? tmpLeaf.OnEnter : this[tmpLeaf.OnEnter];
			if (typeof tmpFn === 'function') { try { await tmpFn.call(this, this); } catch (pError) { this.pict.log.warn(`${this.identifier}: OnEnter(${pTab}) failed: ${(pError && pError.message) || pError}`); } }
		}
	}

	// --- render ----------------------------------------------------------------------------------------------
	renderWorkspace()
	{
		if (!this.view) { return; }
		const tmpCfg = this.workspaceConfig;
		const tmpState = this.state;
		if (!this.canRead()) { this.pict.ContentAssignment.assignContent(this.containerSelector, `<div class="pw-wrap"><div class="pw-empty"><i class="fas fa-lock"></i><p>You don’t have access to ${this._esc(this.entityName)} records.</p></div></div>`); return; }
		// Create mode has no record yet (the form is the body), so it renders even without one.
		if (tmpState.Loading && !this._record && (this._mode !== 'create')) { this.pict.ContentAssignment.assignContent(this.containerSelector, `<div class="pw-wrap"><div class="pw-state"><span class="pw-spinner pw-spinner-inline"></span> Loading…</div></div>`); return; }
		if (tmpState.Message && !this._record && (this._mode !== 'create')) { this.pict.ContentAssignment.assignContent(this.containerSelector, `<div class="pw-wrap"><div class="pw-state">${this._esc(tmpState.Message)}</div></div>`); return; }

		const tmpRec = this.record;
		const tmpHead = tmpCfg.Header || {};
		const tmpTitle = tmpHead.Title ? tmpHead.Title(tmpRec, this) : (tmpRec.Name || `${this.entityName} ${this._id}`);
		const tmpEyebrow = (typeof tmpHead.Eyebrow === 'function') ? tmpHead.Eyebrow(tmpRec, this) : (tmpHead.Eyebrow || this.entityName);
		const tmpSubtitle = tmpHead.Subtitle ? tmpHead.Subtitle(tmpRec, this) : '';
		const tmpExtra = (typeof tmpHead.Extra === 'function') ? (tmpHead.Extra(this) || '') : '';
		// Edit/Create with a configured EditContent: no tab bar — the edit body (a form host) IS the whole panel.
		const tmpEditBody = this.isEditing && this.workspaceConfig.EditContent;
		const tmpTabs = tmpEditBody ? '' : libTabBar.renderTabsHTML(this._resolvedTabDefs(), this._activeTab,
			(pTab) => `_Pict.providers.${this.identifier}.navigateTab('${pTab.Key}')`, { overflow: 'menu' });

		const tmpHTML = `
			<div class="pw-wrap">
				<div class="pw-head">
					<div class="pw-head-id">
						<p class="pw-eyebrow">${this._esc(tmpEyebrow)}</p>
						<h1 class="pw-title">${this._escTitle(tmpTitle)}</h1>
						${tmpSubtitle ? `<div class="pw-subtitle">${this._escTitle(tmpSubtitle)}</div>` : ''}
					</div>
					<div class="pw-head-actions">${this._headerActionsHTML()}${tmpExtra}</div>
				</div>
				${tmpEditBody ? '' : `<div class="pw-tabnav">${tmpTabs}</div>`}
				<div class="pw-panel${tmpEditBody ? ' pw-panel-standalone' : ''}" id="${this.identifier}-Body"></div>
			</div>`;
		this.pict.ContentAssignment.assignContent(this.containerSelector, tmpHTML);
		libTabBar.layout(document);
		// Post-header hook (e.g. mount a QR thumbnail canvas into a header slot painted by Header.Extra).
		if (typeof tmpHead.AfterRender === 'function') { try { tmpHead.AfterRender(this); } catch (pError) { /* decorative */ } }
		this._renderActiveBody();
	}

	/** Titles/subtitles may already contain intentional markup (a status pill); allow it through but escape plain strings. */
	_escTitle(pValue) { return (typeof pValue === 'string' && /<[a-z]/i.test(pValue)) ? pValue : this._esc(pValue); }

	_headerActionsHTML()
	{
		const tmpActions = (this.workspaceConfig.Header && this.workspaceConfig.Header.Actions) || [];
		const tmpBtns = tmpActions.map((pAction) =>
		{
			if (pAction.When && !pAction.When(this)) { return ''; }
			const tmpIcon = pAction.Icon ? `<i class="${this._esc(pAction.Icon)}"></i>` : '';
			const tmpStyle = pAction.Style ? ` ${pAction.Style}` : '';
			const tmpTag = /^https?:|^#\//.test(pAction.OnClick || '') ? 'a' : 'button';
			const tmpAttr = (tmpTag === 'a') ? `href="${this._esc(pAction.OnClick)}"` : `onclick="_Pict.providers.${this.identifier}.${pAction.OnClick}"`;
			return `<${tmpTag} class="pw-btn${tmpStyle}" ${tmpAttr}>${tmpIcon}<span>${this._esc(pAction.Label)}</span></${tmpTag}>`;
		}).join('');
		const tmpList = (this.workspaceConfig.Header && this.workspaceConfig.Header.ListRoute);
		// The list Back link is a view-mode affordance — edit/create modes use their own Cancel action.
		const tmpBack = (tmpList && !this.isEditing) ? `<a class="pw-back" href="${this._esc(tmpList)}"><i class="fas fa-arrow-left"></i> Back</a>` : '';
		return `${tmpBtns}${tmpBack}`;
	}

	backToList() { const tmpList = (this.workspaceConfig.Header && this.workspaceConfig.Header.ListRoute); if (tmpList && typeof window !== 'undefined') { window.location.hash = tmpList; } }
	/** Default Edit action — the generic PSRS edit form for entities without a bespoke edit workspace. */
	goToEdit() { const tmpG = this.record[this.guidField]; if (tmpG && typeof window !== 'undefined') { window.location.hash = `#/PSRS/${this.entityName}/Edit/${tmpG}`; } }
	goToList() { this.backToList(); }

	/** Re-paint only the active tab body (used after a tab's own async load completes). */
	repaintBody() { this._renderActiveBody(); }

	_renderActiveBody()
	{
		const tmpBody = this.bodySelector;
		// Edit/Create mode with a configured EditContent: the edit body replaces the tab body entirely.
		const tmpLeaf = (this.isEditing && this.workspaceConfig.EditContent)
			? { Key: '__edit__', Content: this.workspaceConfig.EditContent }
			: this._activeLeaf();
		if (!tmpLeaf) { this.pict.ContentAssignment.assignContent(tmpBody, ''); return; }
		const tmpContent = tmpLeaf.Content || { kind: 'overview' };
		// Exit every embed view whose tab is not the active one, so a stale embed doesn't linger.
		this._exitInactiveEmbeds(tmpLeaf);
		switch (tmpContent.kind)
		{
		case 'overview': this._renderOverview(tmpBody); break;
		case 'render': this._renderBespoke(tmpLeaf, tmpContent, tmpBody); break;
		case 'embed': this._renderEmbed(tmpLeaf, tmpContent, tmpBody); break;
		case 'assoc': this._renderAssoc(tmpLeaf, tmpContent, tmpBody); break;
		case 'childlist': this._renderChildList(tmpLeaf, tmpContent, tmpBody); break;
		default: this.pict.ContentAssignment.assignContent(tmpBody, `<div class="pw-empty"><p>Unknown tab.</p></div>`);
		}
	}

	/** Resolve FieldGroups Card fields (FK → related record) to display names, then re-render the overview. */
	async _resolveCardsAsync()
	{
		const tmpGroups = this.workspaceConfig.FieldGroups || [];
		const tmpTargets = [];
		for (const tmpGroup of tmpGroups)
		{
			for (const tmpField of (tmpGroup.Fields || []))
			{
				const tmpID = this._record ? this._record[tmpField.Key] : null;
				if (tmpField.Card && (tmpID != null) && (Number(tmpID) > 0)) { tmpTargets.push({ Key: tmpField.Key, RecordSet: tmpField.Card, ID: tmpID }); }
			}
		}
		if (!tmpTargets.length) { return; }
		await Promise.all(tmpTargets.map(async (pTarget) =>
		{
			const tmpRec = await this._getJSON(`${pTarget.RecordSet}/${pTarget.ID}`);
			if (tmpRec && !tmpRec.Error) { this._resolvedCards[pTarget.Key] = tmpRec.Name || tmpRec.DisplayName || tmpRec.Title || String(pTarget.ID); }
		}));
		if (this._activeLeaf() && (this._activeLeaf().Content || {}).kind === 'overview') { this._renderOverview(this.bodySelector); }
	}

	// --- content kind: overview (FieldGroups) ----------------------------------------------------------------
	_renderOverview(pBodySel)
	{
		const tmpGroups = this.workspaceConfig.FieldGroups || [];
		const tmpRec = this.record;
		if (!tmpGroups.length) { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><i class="fas fa-circle-info"></i><p>No overview configured.</p></div>`); return; }
		const tmpHTML = tmpGroups.map((pGroup) =>
		{
			const tmpFields = (pGroup.Fields || []).map((pField) =>
			{
				let tmpVal;
				if (typeof pField.Value === 'function') { tmpVal = pField.Value(tmpRec, this); }
				else if (pField.Card && this._resolvedCards && this._resolvedCards[pField.Key] !== undefined) { tmpVal = this._resolvedCards[pField.Key]; }
				else { tmpVal = this._formatValue(tmpRec[pField.Key], pField.Format); }
				const tmpCls = `pw-field${pField.Wide ? ' pw-field-wide' : ''}`;
				const tmpValCls = `pw-field-value${pField.Mono ? ' pw-field-mono' : ''}`;
				return `<div class="${tmpCls}"><span class="pw-field-label">${this._esc(pField.Label)}</span><div class="${tmpValCls}">${this._escTitle(tmpVal)}</div></div>`;
			}).join('');
			return `<div class="pw-group"><div class="pw-group-head"><span>${this._esc(pGroup.Name)}</span></div><div class="pw-grid">${tmpFields}</div></div>`;
		}).join('');
		this.pict.ContentAssignment.assignContent(pBodySel, tmpHTML);
	}

	// --- content kind: render (bespoke) ----------------------------------------------------------------------
	_renderBespoke(pLeaf, pContent, pBodySel)
	{
		const tmpFn = (typeof pContent.ref === 'function') ? pContent.ref
			: ((this.workspaceConfig.Renderers && this.workspaceConfig.Renderers[pContent.ref]) || this[pContent.ref]);
		if (typeof tmpFn !== 'function') { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><p>Missing renderer: ${this._esc(pContent.ref)}</p></div>`); return; }
		try
		{
			const tmpOut = tmpFn.call(this, this, pBodySel);
			if (typeof tmpOut === 'string') { this.pict.ContentAssignment.assignContent(pBodySel, tmpOut); }
		}
		catch (pError) { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-error">Render failed: ${this._esc((pError && pError.message) || pError)}</div>`); }
	}

	// --- content kind: embed (host a full view via openInto) -------------------------------------------------
	_embedRefs() { const tmpOut = []; for (const tmpLeaf of this._leafTabs()) { if (tmpLeaf.Content && tmpLeaf.Content.kind === 'embed') { tmpOut.push(tmpLeaf); } } return tmpOut; }
	_embedTarget(pContent) { return (pContent.style === 'provider') ? this.pict.providers[pContent.ref] : this.pict.views[pContent.ref]; }
	_exitInactiveEmbeds(pActiveLeaf)
	{
		for (const tmpLeaf of this._embedRefs())
		{
			if (tmpLeaf.Key === (pActiveLeaf && pActiveLeaf.Key)) { continue; }
			const tmpTarget = this._embedTarget(tmpLeaf.Content);
			if (tmpTarget && typeof tmpTarget.exitEmbed === 'function') { try { tmpTarget.exitEmbed(); } catch (pError) { /* best-effort */ } }
		}
	}
	_renderEmbed(pLeaf, pContent, pBodySel)
	{
		const tmpHost = `${this.identifier}-Embed-${pLeaf.Key}`;
		this.pict.ContentAssignment.assignContent(pBodySel, `<div id="${tmpHost}" class="pw-embed-host"></div>`);
		const tmpTarget = this._embedTarget(pContent);
		if (!tmpTarget || typeof tmpTarget.openInto !== 'function') { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><p>Embedded view “${this._esc(pContent.ref)}” is not available.</p></div>`); return; }
		try
		{
			if (pContent.style === 'provider') { tmpTarget.openInto(...(pContent.args || []), this._id, `#${tmpHost}`); }
			else { tmpTarget.openInto(this._id, `#${tmpHost}`); }
		}
		catch (pError) { this.pict.log.warn(`${this.identifier}: embed ${pContent.ref} failed: ${(pError && pError.message) || pError}`); }
	}

	// --- content kind: assoc (RecordSet association editor) --------------------------------------------------
	_renderAssoc(pLeaf, pContent, pBodySel)
	{
		const tmpHost = `${this.identifier}-Assoc-${pLeaf.Key}`;
		this.pict.ContentAssignment.assignContent(pBodySel, `<div id="${tmpHost}"></div>`);
		const tmpManager = this.pict.providers.RecordSetAssociationManager;
		// Resolve the editor lib first: a config `editorLib` (registered via EditorLibs) wins, otherwise the base
		// editor (the optional pict-section-recordset peer, or whatever `setAssociationEditorLib` injected). Gate on
		// the RESOLVED lib — not the module-level var — so an injected/per-tab editor works even when the optional
		// require did not resolve (e.g. a bundler dropped the computed require).
		const tmpLib = (pContent.editorLib && this.pict.__workspaceEditorLibs && this.pict.__workspaceEditorLibs[pContent.editorLib]) || libRecordSetAssociationEditor;
		if (!tmpLib || !tmpManager || (typeof tmpManager.getAssociation !== 'function') || !tmpManager.getAssociation(pContent.ref))
		{
			this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><p>Association “${this._esc(pContent.ref)}” is not registered.</p></div>`); return;
		}
		const tmpHash = `${this.identifier}-AssocEditor-${pContent.ref}`;
		let tmpEditor = this.pict.views[tmpHash];
		if (!tmpEditor)
		{
			this.pict.addView(tmpHash, Object.assign({}, tmpLib.default_configuration,
				{ ViewIdentifier: tmpHash, AssociationHash: pContent.ref, ThisRecordSet: pContent.thisRecordSet || this.entityName, DefaultDestinationAddress: `#${tmpHost}`, PickerMode: pContent.pickerMode || 'single' },
				pContent.editorOptions || {}), tmpLib);
			tmpEditor = this.pict.views[tmpHash];
		}
		tmpEditor.options.ThisID = this._id;
		tmpEditor.options.DefaultDestinationAddress = `#${tmpHost}`;
		this._assocRenderQueue = this._assocRenderQueue
			.then(() => tmpEditor.renderEditor())
			.catch((pError) => { this.pict.log.warn(`${this.identifier}: assoc ${pContent.ref} render failed: ${(pError && pError.message) || pError}`); });
	}

	// --- content kind: childlist (FK children grid) ----------------------------------------------------------
	async _renderChildList(pLeaf, pContent, pBodySel)
	{
		this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-state"><span class="pw-spinner pw-spinner-inline"></span> Loading…</div>`);
		const tmpParentField = pContent.parentField || this.idField;
		const tmpCollection = pContent.collection || `${pContent.ref}s`;
		const tmpFilter = `${tmpCollection}/FilteredTo/FBV~${tmpParentField}~EQ~${this._id}~FBV~Deleted~EQ~0/0/${pContent.cap || 500}`;
		const tmpRows = (await this._getJSON(tmpFilter)) || [];
		if (this._activeTab !== pLeaf.Key) { return; }   // user moved on
		const tmpCols = pContent.columns || [ { Key: 'Name', Label: 'Name' } ];
		if (!tmpRows.length) { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><i class="fas fa-inbox"></i><p>${this._esc(pContent.empty || `No ${(pContent.ref || 'record').toLowerCase()} records.`)}</p></div>`); return; }
		const tmpHead = tmpCols.map((pCol) => `<th${pCol.Num ? ' class="pw-num"' : ''}>${this._esc(pCol.Label)}</th>`).join('');
		const tmpBody = tmpRows.map((pRow) => `<tr>${tmpCols.map((pCol, pIdx) =>
		{
			const tmpVal = this._formatValue(pRow[pCol.Key], pCol.Format);
			const tmpCls = (pIdx === 0) ? 'pw-cell-strong' : (pCol.Num ? 'pw-num' : (pCol.Muted ? 'pw-muted' : ''));
			return `<td${tmpCls ? ` class="${tmpCls}"` : ''}>${this._escTitle(tmpVal)}</td>`;
		}).join('')}</tr>`).join('');
		this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-tablewrap"><table class="pw-table"><thead><tr>${tmpHead}</tr></thead><tbody>${tmpBody}</tbody></table></div>`);
	}
}

// Host-config hooks (also re-exported from the factory index next to `setDefaultDestination`).
PictSectionWorkspaceProvider.setDefaultRestClientName = setDefaultRestClientName;
PictSectionWorkspaceProvider.setAssociationEditorLib = setAssociationEditorLib;

module.exports = PictSectionWorkspaceProvider;

},{"pict-provider":177,"pict-section-tabbar":299}],360:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * pict-section-workspace base view — a thin shell. It paints one container div and hands all rendering to the matching
 * provider (same Identifier), which string-renders the header + tab bar + active tab body into it. The factory
 * builds this view's default_configuration (Identifier, container template, shared + extra CSS).
 */
class PictSectionWorkspaceView extends libPictView
{
	get provider() { return this.pict.providers[this.options.ViewIdentifier]; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider && (typeof tmpProvider.renderWorkspace === 'function')) { tmpProvider.renderWorkspace(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = PictSectionWorkspaceView;

},{"pict-view":365}],361:[function(require,module,exports){
'use strict';

/**
 * pict-section-workspace — a declarative, config-driven tabbed workspace for a single entity record.
 *
 * A workspace config:
 *   {
 *     Identifier, Ordinal,
 *     Entity:  { Name, IDField?, Collection?, GUIDField?, ReadEndpoint?(id) },
 *     Header:  { Eyebrow, Title(rec), Subtitle?(rec), Actions:[{Label,Icon?,Style?,OnClick,When?(prov)}], ListRoute },
 *     Permissions?: { Read?(prov) },                              // default: <Entity>-Read, fail-open until ready
 *     Tabs:    [ { Key, Label, Icon?, Pin?, Children?:[…leaf], Content:{kind,ref,…}, OnEnter? } ],
 *     FieldGroups?: [ { Name, Fields:[{Key,Label,Wide?,Mono?,Format?,Value?(rec,prov)}] } ],   // for kind:'overview'
 *     Renderers?: { <ref>: (prov, hostSelector) => htmlString|void },                          // for kind:'render'
 *     ProviderClass?, ViewClass?,   // subclass overrides (bespoke methods live here)
 *     CSSExtra?, EditorLibs?: { <name>: assocEditorLib },
 *     Create?: { Route }, Edit?: { Route },
 *   }
 *
 * Content kinds per tab leaf:
 *   overview   — FieldGroups grid (the base owns it)
 *   render     — Content.ref is a Renderers[ref] fn or a provider method name; paints into the tab body
 *   embed      — Content.ref is a ViewIdentifier hosted via openInto/exitEmbed (style:'provider' → a provider host,
 *                with Content.args prepended before the record id)
 *   assoc      — Content.ref is a RecordSetAssociationManager association hash; editorLib names an EditorLibs entry
 *   childlist  — Content.ref is the child Entity; {collection?, parentField?, columns:[{Key,Label,Num?,Format?}], cap?, empty?}
 */

const PictSectionWorkspaceProvider = require('./Pict-Section-Workspace-Provider.js');
const PictSectionWorkspaceView = require('./Pict-Section-Workspace-View.js');
const { WORKSPACE_CSS } = require('./Pict-Section-Workspace-CSS.js');

// Where the workspace view mounts by default. Override per workspace via config `DestinationAddress`, or set a
// global default with the exported `setDefaultDestination()`.
let DEFAULT_DESTINATION = '#Pict-Application-Container';
function setDefaultDestination(pSelector) { if (pSelector) { DEFAULT_DESTINATION = pSelector; } }

// App-wide config hooks that live on the provider module (symmetric with setDefaultDestination):
//   setDefaultRestClientName(name) — the fable service the base uses for record reads/writes (default 'RestClient').
//   setAssociationEditorLib(lib)   — inject the RecordSet association editor when the optional computed require did
//                                    not resolve in the host's bundle (keeps kind:'assoc' tabs working).
const setDefaultRestClientName = PictSectionWorkspaceProvider.setDefaultRestClientName;
const setAssociationEditorLib = PictSectionWorkspaceProvider.setAssociationEditorLib;

/** Register a workspace's provider + view pair with a pict application. */
function createWorkspace(pPict, pConfig)
{
	const tmpId = pConfig.Identifier;
	const tmpDest = pConfig.DestinationAddress || DEFAULT_DESTINATION;
	const tmpProviderClass = pConfig.ProviderClass || PictSectionWorkspaceProvider;
	const tmpViewClass = pConfig.ViewClass || PictSectionWorkspaceView;

	if (pConfig.EditorLibs) { pPict.__workspaceEditorLibs = Object.assign(pPict.__workspaceEditorLibs || {}, pConfig.EditorLibs); }

	pPict.addProvider(tmpId,
		{ ProviderIdentifier: tmpId, AutoInitialize: true, AutoInitializeOrdinal: pConfig.Ordinal || 230, WorkspaceConfig: pConfig },
		tmpProviderClass);

	pPict.addView(tmpId,
		{
			ViewIdentifier: tmpId,
			DefaultRenderable: `${tmpId}-Wrap`,
			DefaultDestinationAddress: tmpDest,
			AutoRender: false,
			CSS: WORKSPACE_CSS + (pConfig.CSSExtra || ''),
			// The container template, plus any ExtraTemplates a workspace needs registered so its bespoke
			// `render` tabs can paint them via pict.parseTemplateByHash (e.g. a migrated workspace reusing its
			// original per-tab templates + shared controller templates verbatim).
			Templates: [ { Hash: `${tmpId}-Template`, Template: `<div id="${tmpId}-Container"></div>` } ].concat(pConfig.ExtraTemplates || []),
			Renderables: [ { RenderableHash: `${tmpId}-Wrap`, TemplateHash: `${tmpId}-Template`, DestinationAddress: tmpDest, RenderMethod: 'replace' } ],
		},
		tmpViewClass);

	return { Identifier: tmpId };
}

/**
 * Register the standard workspace bridge routes on the app router. pRouter is the application's router provider
 * instance (exposes .pictRouter, .currentView, ._renderRouteView, .pict). Emits:
 *   /<Entity>/Workspace/:ID            /<Entity>/Workspace/:ID/:Tab
 *   /PSRS/<Entity>/View/:GUIDRecord    (+ optional Edit/Create bridges)
 * The :Tab whitelist is derived from the live config so it can never drift from the tab manifest.
 */
function registerWorkspaceRoutes(pRouter, pConfig)
{
	const tmpEntity = pConfig.Entity.Name;
	const tmpPrefix = pConfig.RoutePrefix || tmpEntity;   // workspace-route noun (defaults to the entity name)
	const tmpId = pConfig.Identifier;
	const tmpRouter = pRouter.pictRouter;
	const fProvider = () => pRouter.pict.providers[tmpId];

	tmpRouter.addRoute(`/${tmpPrefix}/Workspace/:ID`, (pRouteData) =>
	{
		pRouter.currentView = tmpId;
		pRouter._renderRouteView(tmpId);
		const tmpP = fProvider(); if (tmpP) { tmpP.loadAsync(parseInt(pRouteData.data.ID, 10)); }
	});

	tmpRouter.addRoute(`/${tmpPrefix}/Workspace/:ID/:Tab`, (pRouteData) =>
	{
		const tmpP = fProvider();
		const tmpTargetID = parseInt(pRouteData.data.ID, 10);
		const tmpMounted = (pRouter.currentView === tmpId) && tmpP && (Number(tmpP.idRecord) === tmpTargetID);
		pRouter.currentView = tmpId;
		if (!tmpMounted) { pRouter._renderRouteView(tmpId); }
		if (tmpP) { tmpP.openTabAsync(tmpTargetID, pRouteData.data.Tab); }
	});

	tmpRouter.addRoute(`/PSRS/${tmpEntity}/View/:GUIDRecord`, (pRouteData) =>
	{
		pRouter.currentView = tmpId;
		pRouter._renderRouteView(tmpId);
		const tmpP = fProvider(); if (tmpP) { tmpP.openByGUIDAsync(pRouteData.data.GUIDRecord); }
	});

	// Edit → open the workspace (read for now) unless the config routes it elsewhere.
	if (pConfig.Edit && pConfig.Edit.Route === 'workspace')
	{
		tmpRouter.addRoute(`/PSRS/${tmpEntity}/Edit/:GUIDRecord`, (pRouteData) =>
		{
			pRouter.currentView = tmpId;
			pRouter._renderRouteView(tmpId);
			const tmpP = fProvider(); if (tmpP) { tmpP.openByGUIDAsync(pRouteData.data.GUIDRecord, 'edit'); }
		});
	}

	// Create → enter create mode (startCreateAsync). Optional CloneRoute passes a source GUID to clone from.
	if (pConfig.Create && pConfig.Create.Route)
	{
		tmpRouter.addRoute(pConfig.Create.Route, () =>
		{
			pRouter.currentView = tmpId;
			pRouter._renderRouteView(tmpId);
			const tmpP = fProvider(); if (tmpP) { tmpP.startCreateAsync(null); }
		});
		if (pConfig.Create.CloneRoute)
		{
			tmpRouter.addRoute(pConfig.Create.CloneRoute, (pRouteData) =>
			{
				pRouter.currentView = tmpId;
				pRouter._renderRouteView(tmpId);
				const tmpP = fProvider(); if (tmpP) { tmpP.startCreateAsync((pRouteData.data && pRouteData.data.GUIDRecord) || null); }
			});
		}
	}
}

module.exports = {
	createWorkspace,
	registerWorkspaceRoutes,
	setDefaultDestination,
	setDefaultRestClientName,
	setAssociationEditorLib,
	PictSectionWorkspaceProvider,
	PictSectionWorkspaceView,
	WORKSPACE_CSS,
	// Legacy aliases (the framework was extracted from the Headlight config app) — kept so existing subclasses
	// that `extends HeadlightWorkspaceBaseProvider` keep resolving after adopting the published package.
	HeadlightWorkspaceBaseProvider: PictSectionWorkspaceProvider,
	HeadlightWorkspaceBaseView: PictSectionWorkspaceView,
};

},{"./Pict-Section-Workspace-CSS.js":358,"./Pict-Section-Workspace-Provider.js":359,"./Pict-Section-Workspace-View.js":360}],362:[function(require,module,exports){
module.exports={
    "name": "pict-template",
    "version": "1.0.15",
    "description": "Pict Template Base Class",
    "main": "source/Pict-Template.js",
    "scripts": {
        "start": "node source/Pict-Template.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Template.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "pict": "^1.0.348",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],363:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

/** @typedef {import('pict') & {
 *     [key: string]: any, // represent services for now as a workaround
 * }} Pict */
/**
 * @class PictTemplateExpression
 * @classdesc The PictTemplateExpression class is a service provider for the pict anti-framework that provides template rendering services.
 */
class PictTemplateExpression extends libFableServiceBase
{
	/**
	 * @param {Pict} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.fable;

		/** @type {Pict} */
		this.pict = this.fable;

		this.serviceType = 'PictTemplate';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		return fCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}

	/**
	 * Provide a match criteria for a template expression.  Anything between these two values is returned as the template hash.
	 *
	 * @param {string} pMatchStart - The string pattern to start a match in the template trie
	 * @param {string} pMatchEnd  - The string pattern to stop a match in the trie acyclic graph
	 *
	 * @return {void}
	 */
	addPattern(pMatchStart, pMatchEnd)
	{
		return this.pict.MetaTemplate.addPatternBoth(pMatchStart, pMatchEnd, this.render, this.renderAsync, this);
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} pRecord - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		return this.pict.resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState);
	}
}

module.exports = PictTemplateExpression;
module.exports.template_hash = 'Default';

},{"../package.json":362,"fable-serviceproviderbase":59}],364:[function(require,module,exports){
module.exports={
    "name": "pict-view",
    "version": "1.0.68",
    "description": "Pict View Base Class",
    "main": "source/Pict-View.js",
    "scripts": {
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "start": "node source/Pict-View.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-view-image:local",
        "docker-dev-run": "docker run -it -d --name pict-view-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-view\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-view-image:local",
        "docker-dev-shell": "docker exec -it pict-view-dev /bin/bash",
        "types": "tsc -p .",
        "lint": "eslint source/**"
    },
    "types": "types/source/Pict-View.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.1",
        "pict": "^1.0.363",
        "quackage": "^1.0.65",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable": "^3.1.67",
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],365:[function(require,module,exports){

const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictViewSettings = (
	{
		DefaultRenderable: false,
		DefaultDestinationAddress: false,
		DefaultTemplateRecordAddress: false,

		ViewIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called as soon as it's added.
		AutoRender: true,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		CSSHash: false,
		CSS: false,
		CSSProvider: false,
		CSSPriority: 500,

		Templates: [],

		DefaultTemplates: [],

		Renderables: [],

		Manifests: {}
	});

/** @typedef {(error?: Error) => void} ErrorCallback */
/** @typedef {number | boolean} PictTimestamp */

/**
 * @typedef {'replace' | 'append' | 'prepend' | 'append_once' | 'virtual-assignment'} RenderMethod
 */
/**
 * @typedef {Object} Renderable
 *
 * @property {string} RenderableHash - A unique hash for the renderable.
 * @property {string} TemplateHash - The hash of the template to use for rendering this renderable.
 * @property {string} [DefaultTemplateRecordAddress] - The default address for resolving the data record for this renderable.
 * @property {string} [ContentDestinationAddress] - The default address (DOM CSS selector) for rendering the content of this renderable.
 * @property {RenderMethod} [RenderMethod=replace] - The method to use when projecting the renderable to the DOM ('replace', 'append', 'prepend', 'append_once', 'virtual-assignment').
 * @property {string} [TestAddress] - The address to use for testing the renderable.
 * @property {string} [TransactionHash] - The transaction hash for the root renderable.
 * @property {string} [RootRenderableViewHash] - The hash of the root renderable.
 * @property {string} [Content] - The rendered content for this renderable, if applicable.
 */

/**
 * Represents a view in the Pict ecosystem.
 */
class PictView extends libFableServiceBase
{
	/**
	 * @param {any} pFable - The Fable object that this service is attached to.
	 * @param {any} [pOptions] - (optional) The options for this service.
	 * @param {string} [pServiceHash] - (optional) The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictViewSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		//FIXME: add types to fable and ancillaries
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {String} */
		this.UUID;
		/** @type {String} */
		this.Hash;
		/** @type {any} */
		this.log;

		const tmpHashIsUUID = this.Hash === this.UUID;
		//NOTE: since many places are using the view UUID as the HTML element ID, we prefix it to avoid starting with a number
		this.UUID = `V-${this.UUID}`;
		if (tmpHashIsUUID)
		{
			this.Hash = this.UUID;
		}

		if (!this.options.ViewIdentifier)
		{
			this.options.ViewIdentifier = `AutoViewID-${this.fable.getUUID()}`;
		}
		this.serviceType = 'PictView';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
		// Convenience and consistency naming
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict = this.fable;
		// Wire in the essential Pict application state
		this.AppData = this.pict.AppData;
		this.Bundle = this.pict.Bundle;

		/** @type {PictTimestamp} */
		this.initializeTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastSolvedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastRenderedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalFromViewTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalToViewTimestamp = false;

		this.pict.instantiateServiceProviderIfNotExists('TransactionTracking');

		// Load all templates from the array in the options
		// Templates are in the form of {Hash:'Some-Template-Hash',Template:'Template content',Source:'TemplateSource'}
		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpTemplate = this.options.Templates[i];

			if (!('Hash' in tmpTemplate) || !('Template' in tmpTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Template ${i} in the options array.`, tmpTemplate);
			}
			else
			{
				if (!tmpTemplate.Source)
				{
					tmpTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template, tmpTemplate.Source);
			}
		}

		// Load all default templates from the array in the options
		// Templates are in the form of {Prefix:'',Postfix:'-List-Row',Template:'Template content',Source:'TemplateSourceString'}
		for (let i = 0; i < this.options.DefaultTemplates.length; i++)
		{
			let tmpDefaultTemplate = this.options.DefaultTemplates[i];

			if (!('Postfix' in tmpDefaultTemplate) || !('Template' in tmpDefaultTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}

		// Load the CSS if it's available
		if (this.options.CSS)
		{
			let tmpCSSHash = this.options.CSSHash ? this.options.CSSHash : `View-${this.options.ViewIdentifier}`;
			let tmpCSSProvider = this.options.CSSProvider ? this.options.CSSProvider : tmpCSSHash;
			this.pict.CSSMap.addCSS(tmpCSSHash, this.options.CSS, tmpCSSProvider, this.options.CSSPriority);
		}

		// Load all renderables
		// Renderables are launchable renderable instructions with templates
		// They look as such: {Identifier:'ContentEntry', TemplateHash:'Content-Entry-Section-Main', ContentDestinationAddress:'#ContentSection', RecordAddress:'AppData.Content.DefaultText', ManifestTransformation:'ManyfestHash', ManifestDestinationAddress:'AppData.Content.DataToTransformContent'}
		// The only parts that are necessary are Identifier and Template
		// A developer can then do render('ContentEntry') and it just kinda works.  Or they can override the ContentDestinationAddress
		/** @type {Record<String, Renderable>} */
		this.renderables = {};
		for (let i = 0; i < this.options.Renderables.length; i++)
		{
			/** @type {Renderable} */
			let tmpRenderable = this.options.Renderables[i];
			this.addRenderable(tmpRenderable);
		}
	}

	/**
	 * Adds a renderable to the view.
	 *
	 * @param {string | Renderable} pRenderableHash - The hash of the renderable, or a renderable object.
	 * @param {string} [pTemplateHash] - (optional) The hash of the template for the renderable.
	 * @param {string} [pDefaultTemplateRecordAddress] - (optional) The default data address for the template.
	 * @param {string} [pDefaultDestinationAddress] - (optional) The default destination address for the renderable.
	 * @param {RenderMethod} [pRenderMethod=replace] - (optional) The method to use when rendering the renderable (ex. 'replace').
	 */
	addRenderable(pRenderableHash, pTemplateHash, pDefaultTemplateRecordAddress, pDefaultDestinationAddress, pRenderMethod)
	{
		/** @type {Renderable} */
		let tmpRenderable;

		if (typeof(pRenderableHash) == 'object')
		{
			// The developer passed in the renderable as an object.
			// Use theirs instead!
			tmpRenderable = pRenderableHash;
		}
		else
		{
			/** @type {RenderMethod} */
			let tmpRenderMethod = (typeof(pRenderMethod) !== 'string') ? pRenderMethod : 'replace';
			tmpRenderable = (
				{
					RenderableHash: pRenderableHash,
					TemplateHash: pTemplateHash,
					DefaultTemplateRecordAddress: pDefaultTemplateRecordAddress,
					ContentDestinationAddress: pDefaultDestinationAddress,
					RenderMethod: tmpRenderMethod
				});
		}

		if ((typeof(tmpRenderable.RenderableHash) != 'string') || (typeof(tmpRenderable.TemplateHash) != 'string'))
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Renderable; RenderableHash or TemplateHash are invalid.`, tmpRenderable);
		}
		else
		{
			if (this.pict.LogNoisiness > 0)
			{
				this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} adding renderable [${tmpRenderable.RenderableHash}] pointed to template ${tmpRenderable.TemplateHash}.`);
			}

			this.renderables[tmpRenderable.RenderableHash] = tmpRenderable;
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is initialized.
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized.
	 */
	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * Performs view initialization.
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * Performs view initialization (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				/** @param {Error} pError */
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization failed: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization complete.`);
					}
					return fCallback();
				});
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Render                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeRender:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.onBeforeRender(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProject(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProjectAsync(fCallback, pRenderable)
	{
		this.onBeforeProject(pRenderable);
		return fCallback();
	}

	/**
	 * Builds the render options for a renderable.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = {Valid: true};
		tmpRenderOptions.RenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
								(typeof (this.options.DefaultRenderable) == 'string') ?
								this.options.DefaultRenderable : false;
		if (!tmpRenderOptions.RenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not find a suitable RenderableHash ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.Renderable = this.renderables[tmpRenderOptions.RenderableHash];
		if (!tmpRenderOptions.Renderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.DestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
			(typeof (tmpRenderOptions.Renderable.ContentDestinationAddress) === 'string') ? tmpRenderOptions.Renderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : false;
		if (!tmpRenderOptions.DestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address (param ${pRenderDestinationAddress}).`);
			tmpRenderOptions.Valid = false;
		}

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRenderOptions.RecordAddress = 'Passed in as object';
			tmpRenderOptions.Record = pTemplateRecordAddress;
		}
		else
		{
			tmpRenderOptions.RecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderOptions.Renderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderOptions.Renderable.DefaultTemplateRecordAddress :
				(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;
			tmpRenderOptions.Record = (typeof (tmpRenderOptions.RecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRenderOptions.RecordAddress) : undefined;
		}

		return tmpRenderOptions;
	}

	/**
	 * Assigns the content to the destination address.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {Renderable} pRenderable - The renderable to render.
	 * @param {string} pRenderDestinationAddress - The address where the renderable will be rendered.
	 * @param {string} pContent - The content to render.
	 * @returns {boolean} - Returns true if the content was assigned successfully.
	 * @memberof PictView
	 */
	assignRenderContent(pRenderable, pRenderDestinationAddress, pContent)
	{
		return this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderDestinationAddress, pContent, pRenderable.TestAddress);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		return this.renderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable);
	}

	/**
	 * Render a renderable from this view, providing a specifici scope for the template.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	renderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;
		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it is not a valid renderable.`);
			return false;
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
					(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
					(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return false;
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return false;
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		// Execute the developer-overridable pre-render behavior
		this.onBeforeRender(tmpRenderable);

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] render:`);
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Render of Renderable[${tmpRenderableHash}] to Destination [${tmpRenderable.ContentDestinationAddress}]...`);
		}
		// Generate the content output from the template and data
		tmpRenderable.Content = this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord, null, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${tmpRenderableHash}] content length ${tmpRenderable.Content.length} to Destination [${tmpRenderable.ContentDestinationAddress}] using render method [${tmpRenderable.RenderMethod}].`);
		}

		this.onBeforeProject(tmpRenderable);
		this.onProject(tmpRenderable);

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			this.onAfterProject(tmpRenderable);

			// Execute the developer-overridable post-render behavior
			this.onAfterRender(tmpRenderable);
		}

		return true;
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		return this.renderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;

		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pRootRenderable) === 'function') ? pRootRenderable :
							null;

		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`));
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress : (typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`));
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return tmpCallback(new Error(`Could not render ${tmpRenderableHash}`));
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] renderAsync:`);
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Asynchronous Render (callback-style)...`);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		tmpAnticipate.anticipate(
			(fOnBeforeRenderCallback) =>
			{
				this.onBeforeRenderAsync(fOnBeforeRenderCallback, tmpRenderable);
			});

		tmpAnticipate.anticipate(
			(fAsyncTemplateCallback) =>
			{
				// Render the template (asynchronously)
				this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord,
					(pError, pContent) =>
					{
						if (pError)
						{
							this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderableHash} (param ${pRenderableHash}) because it did not parse the template.`, pError);
							return fAsyncTemplateCallback(pError);
						}
						tmpRenderable.Content = pContent;

						return fAsyncTemplateCallback();
					}, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });
			});

		tmpAnticipate.anticipate((fNext) =>
		{
			this.onBeforeProjectAsync(fNext, tmpRenderable);
		});
		tmpAnticipate.anticipate((fNext) =>
		{
			this.onProjectAsync(fNext, tmpRenderable);
		});

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterProjectAsync(fNext, tmpRenderable);
			});

			// Execute the developer-overridable post-render behavior
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterRenderAsync(fNext, tmpRenderable);
			});
		}

		tmpAnticipate.wait(tmpCallback);
	}

	/**
	 * Renders the default renderable.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	renderDefaultAsync(fCallback)
	{
		// Render the default renderable
		this.renderAsync(fCallback);
	}

	/**
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRender(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return this.basicRenderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRenderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record, null, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable }));
			return true;
		}
		else
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`);
			return false;
		}
	}

	/**
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		return this.basicRenderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		const tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record,
				/**
				 * @param {Error} [pError] - The error that occurred during template parsing.
				 * @param {string} [pContent] - The content that was rendered from the template.
				 */
				(pError, pContent) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderOptions.RenderableHash} because it did not parse the template.`, pError);
						return tmpCallback(pError);
					}

					this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, pContent);
					return tmpCallback();
				}, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable });
		}
		else
		{
			let tmpErrorMessage = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`;
			this.log.error(tmpErrorMessage);
			return tmpCallback(new Error(tmpErrorMessage));
		}
	}

	/**
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onProject:`);
		}
		if (pRenderable.RenderMethod === 'virtual-assignment')
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pRenderable.TransactionHash, { ViewHash: this.Hash, Renderable: pRenderable }, 'Deferred-Post-Content-Assignment');
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${pRenderable.RenderableHash}] content length ${pRenderable.Content.length} to Destination [${pRenderable.ContentDestinationAddress}] using Async render method ${pRenderable.RenderMethod}.`);
		}

		// Assign the content to the destination address
		this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderable.ContentDestinationAddress, pRenderable.Content, pRenderable.TestAddress);

		this.lastRenderedTimestamp = this.pict.log.getTimeStamp();
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {(error?: Error, content?: string) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that is being projected.
	 */
	onProjectAsync(fCallback, pRenderable)
	{
		this.onProject(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender:`);
		}
		if (pRenderable && pRenderable.RootRenderableViewHash === this.Hash)
		{
			const tmpTransactionQueue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const tmpEvent of tmpTransactionQueue)
			{
				const tmpView = this.pict.views[tmpEvent.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${tmpEvent.Data.ViewHash}.`);
					continue;
				}
				tmpView.onAfterProject();

				// Execute the developer-overridable post-render behavior
				tmpView.onAfterRender(tmpEvent.Data.Renderable);
			}
			// Queue is drained and nested child renders have each cleaned up
			// their own transactions; remove this root render's entry from
			// the tracking map so it does not leak.
			this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		// NOTE: this.onAfterRender(pRenderable) will itself clear the
		// transaction queue and unregister the transaction if this view is
		// the root renderable - see onAfterRender above. So by the time the
		// loop below runs, the queue is already empty and there is nothing
		// to drain. Keeping the async queue walk here defensively in case
		// future subclasses override onAfterRender in ways that skip the
		// drain, but the common path is now "sync drain, async no-op".
		this.onAfterRender(pRenderable);
		const tmpAnticipate = this.fable.newAnticipate();
		const tmpIsRootRenderable = pRenderable && pRenderable.RootRenderableViewHash === this.Hash;
		if (tmpIsRootRenderable)
		{
			const queue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const event of queue)
			{
				/** @type {PictView} */
				const tmpView = this.pict.views[event.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRenderAsync: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${event.Data.ViewHash}.`);
					continue;
				}
				tmpAnticipate.anticipate(tmpView.onAfterProjectAsync.bind(tmpView));
				tmpAnticipate.anticipate((fNext) =>
				{
					tmpView.onAfterRenderAsync(fNext, event.Data.Renderable);
				});

				// Execute the developer-overridable post-render behavior
			}
		}
		return tmpAnticipate.wait((pError) =>
		{
			// Nested virtual-assignment children have now settled their own
			// onAfterRenderAsync chains (and unregistered their own
			// transactions along the way). Ensure this root render's entry
			// is also gone - unregisterTransaction is a no-op if the sync
			// onAfterRender above already removed it, so this is safe to
			// call unconditionally on the root path.
			if (tmpIsRootRenderable && pRenderable && pRenderable.TransactionHash)
			{
				this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
			}
			return fCallback(pError);
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProjectAsync(fCallback, pRenderable)
	{
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Solver                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is solved.
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is solved.
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * Performs view solving and triggers lifecycle hooks.
	 *
	 * @return {boolean} - True if the view was solved successfully, false otherwise.
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeSolve();
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Performs view solving and triggers lifecycle hooks (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after the view is solved.
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal From View                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	onBeforeMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalFromViewAsync(fCallback)
	{
		this.onBeforeMarshalFromView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view.
	 */
	onMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalFromViewAsync(fCallback)
	{

		this.onMarshalFromView();
		return fCallback();
	}

	/**
	 * Marshals data from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalFromView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalFromView();
		this.onMarshalFromView();
		this.onAfterMarshalFromView();
		this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalFromViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalFromViewAsync() complete.`);
				}
				this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view.
	 */
	onAfterMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalFromViewAsync(fCallback)
	{
		this.onAfterMarshalFromView();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal To View                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled into the view.
	 */
	onBeforeMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalToViewAsync(fCallback)
	{
		this.onBeforeMarshalToView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view.
	 */
	onMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalToViewAsync(fCallback)
	{
		this.onMarshalToView();
		return fCallback();
	}

	/**
	 * Marshals data into the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalToView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalToView();
		this.onMarshalToView();
		this.onAfterMarshalToView();
		this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalToViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');


		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}
		tmpAnticipate.anticipate(this.onBeforeMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalToViewAsync() complete.`);
				}
				this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view.
	 */
	onAfterMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalToViewAsync(fCallback)
	{
		this.onAfterMarshalToView();
		return fCallback();
	}

	/** @return {boolean} - True if the object is a PictView. */
	get isPictView()
	{
		return true;
	}
}

module.exports = PictView;

},{"../package.json":364,"fable-serviceproviderbase":59}],366:[function(require,module,exports){
module.exports={
  "name": "pict",
  "version": "1.0.402",
  "description": "Pict browser library.",
  "main": "source/Pict.js",
  "scripts": {
    "start": "node source/Pict.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "coverage": "npx quack coverage",
    "build": "npx quack build",
    "prepublishOnly": "npx quack build",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-image:local",
    "docker-dev-run": "docker run -it -d --name pict-dev -p 37447:8080 -p 19506:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-image:local",
    "docker-dev-shell": "docker exec -it pict-dev /bin/bash",
    "lint": "eslint source/**/*.js test/**/*.js",
    "types": "tsc -p ."
  },
  "files": [
    "source/",
    "dist/",
    "types/"
  ],
  "types": "types/source/Pict.d.ts",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/fable-retold/pict.git"
  },
  "author": "steven velozo <steven@velozo.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/fable-retold/pict/issues"
  },
  "homepage": "https://github.com/fable-retold/pict#readme",
  "devDependencies": {
    "@eslint/js": "^9.39.1",
    "@types/jquery": "^3.5.33",
    "@types/sinon": "^17.0.4",
    "eslint": "^9.39.1",
    "globals": "^16.5.0",
    "pict-docuserve": "^1.4.19",
    "quackage": "^1.3.0",
    "sinon": "^20.0.0",
    "typescript": "^5.9.3"
  },
  "dependencies": {
    "cachetrax": "^1.0.6",
    "fable": "^3.1.85",
    "pict-application": "^1.0.34",
    "pict-provider": "^1.0.13",
    "pict-template": "^1.0.15",
    "pict-view": "^1.0.68"
  }
}

},{}],367:[function(require,module,exports){
// This assumes Pict has been required in the browser. Delcare these as globals so linter can do its job.
/* global Pict, _Pict: writeable */

/**
 * Simple function to load a pict Application
 *
 * @param {import('pict-application')} [pPictApplication] - The pict application to load.
 * @param {number} [pLogNoisiness] - The log noisiness level.
 */
module.exports = function (pPictApplication, pLogNoisiness)
{
	let tmpLogNoisiness = (typeof(pLogNoisiness) == 'undefined') ? 0 : pLogNoisiness;

	// Set up a basal pict on the window object
	if (pPictApplication && typeof pPictApplication['default_configuration'] === 'object' && ('pict_configuration' in pPictApplication['default_configuration']))
	{
		window._Pict = new Pict(pPictApplication['default_configuration'].pict_configuration);
	}
	else
	{
		window._Pict = new Pict();
	}

	window._Pict.LogNoisiness = tmpLogNoisiness;

	let tmpApplicationHash = 'DefaultApplication';
	let tmpDefaultConfiguration = {};

	if ('default_configuration' in pPictApplication)
	{
		tmpDefaultConfiguration = pPictApplication.default_configuration;

		if ('Hash' in tmpDefaultConfiguration && typeof tmpDefaultConfiguration.Hash === 'string')
		{
			tmpApplicationHash = tmpDefaultConfiguration.Hash;
		}
	}
	_Pict.log.info(`Loading the pict application [${tmpApplicationHash}] and associated views.`);

	_Pict.addApplication(tmpApplicationHash, tmpDefaultConfiguration, pPictApplication);

	_Pict.PictApplication.initializeAsync(
		function (pError)
		{
			if (pError)
			{
				console.log('Error initializing the pict application: '+pError)
			}
			_Pict.log.info('Loading the Application and associated views.');
		});
}

},{}],368:[function(require,module,exports){

/**
 * Provide a safe on document ready function (without needing a framework like jquery)
 *
 * @param {function} fCallback - The function to call when the document is ready
 */
module.exports = function (fCallback)
{
	if (!document)
	{
		console.log('No document object found; no initialization happening.');
		return;
	}
	// In case the document is already rendered
	if (document.readyState!='loading') fCallback();
	// Modern browsers have event listener capabilities
	else if (document.addEventListener) document.addEventListener('DOMContentLoaded', function() { fCallback(); });
	//@ts-ignore IE <= 8 and ... other abominations
	else document.attachEvent('onreadystatechange', function() { if (document.readyState=='complete') fCallback(); });
}

},{}],369:[function(require,module,exports){

const libFableServiceBase = require('fable').ServiceProviderBase;

const defaultConfiguration = (
	{
		// This is the address for the <script /> tag that contains the CSS.
		CSSElementAddress: '#PICT-CSS'
	}
)

class PictCSS extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {{ ContentAssignment: import('./Pict-Content-Assignment') }} */
		this.services;
		/** @type {import('fable')} */
		this.fable;

		// No merging of options necessary
		if (typeof(this.options.CSSElementAddress) === 'undefined')
		{
			this.options.CSSElementAddress = defaultConfiguration.CSSElementAddress;
		}

		this.inlineCSSMap = {};

		// Dirty flag for injectCSS(): only rewrite the <style> element when a
		// fragment was actually added/removed/changed. Views call injectCSS() on
		// every render, and the DOM write (innerHTML of the full concatenated CSS)
		// forces the browser to reparse the whole stylesheet and repaint -- doing
		// that on every navigation paints a brief unstyled flash. Start dirty so
		// the first injectCSS() always writes.
		this._cssDirty = true;

		this.fable.addSolverFunction(this.fable.expressionParser, 'createcsscolorrgbfromnumeric', this.createCssColorRGBFromNumeric.bind(this), 'Create a CSS color from RGB components');
	}

	// Add a CSS fragment to the CSS map (each view can have its own CSS fragment)
	// Hash is shared across all views, so if 10 views all load the "My-Table-View" fragment, it will only be loaded once.
	addCSS(pHash, pContent, pPriority, pProvider)
	{
		let tmpPriority = (typeof(pPriority) !== 'undefined') ? pPriority : 1000;
		let tmpProvidor = (typeof(pProvider) === 'string') ? pProvider : 'Unknown';
		// Only mark dirty when the fragment is new or its content/priority actually
		// changed, so a view re-registering identical CSS does not force a rewrite.
		let tmpExisting = this.inlineCSSMap[pHash];
		if (!tmpExisting || tmpExisting.Content !== pContent || tmpExisting.Priority !== tmpPriority)
		{
			this._cssDirty = true;
		}
		this.inlineCSSMap[pHash] = { Hash: pHash, Content: pContent, Provider: tmpProvidor, Priority:tmpPriority };
	}

	removeCSS(pHash)
	{
		if (this.inlineCSSMap[pHash])
		{
			this._cssDirty = true;
		}
		delete this.inlineCSSMap[pHash];
	}

	createCssColorRGBFromNumeric(pRed, pGreen, pBlue)
	{
		// 1. cast red, green and blue to floating point numbers
		// 2. If the numbers are all three less than or equal to 1.0, multiply each by 255 and round to the nearest integer.
		// 2a. If any of the numbers are greater than 1.0, round each to the nearest integer and make sure it's less than or equal to 255.
		// 3. Return a #RRGGBB string.
		let tmpRed = parseFloat(pRed);
		let tmpGreen = parseFloat(pGreen);
		let tmpBlue = parseFloat(pBlue);
		if (isNaN(tmpRed) || isNaN(tmpGreen) || isNaN(tmpBlue))
		{
			return '#000000';
		}
		if (tmpRed <= 1.0 && tmpGreen <= 1.0 && tmpBlue <= 1.0)
		{
			tmpRed = Math.round(tmpRed * 255);
			tmpGreen = Math.round(tmpGreen * 255);
			tmpBlue = Math.round(tmpBlue * 255);
		}
		// If they are less than or equal to 255, cast them to integers and round them.
		else if (tmpRed <= 255 && tmpGreen <= 255 && tmpBlue <= 255)
		{
			tmpRed = Math.round(tmpRed);
			tmpGreen = Math.round(tmpGreen);
			tmpBlue = Math.round(tmpBlue);
		}
		// Otherwise get the maximum of the three and quantize them to 255
		else
		{
			let tmpMax = Math.max(Math.max(tmpRed, tmpGreen), tmpBlue);
			tmpRed = Math.round((tmpRed / tmpMax) * 255);
			tmpGreen = Math.round((tmpGreen / tmpMax) * 255);
			tmpBlue = Math.round((tmpBlue / tmpMax) * 255);
		}
		tmpRed = Math.abs(tmpRed);
		tmpGreen = Math.abs(tmpGreen);
		tmpBlue = Math.abs(tmpBlue);
		let tmpRedHex = tmpRed.toString(16).padStart(2, '0');
		let tmpGreenHex = tmpGreen.toString(16).padStart(2, '0');
		let tmpBlueHex = tmpBlue.toString(16).padStart(2, '0');
		return `#${tmpRedHex}${tmpGreenHex}${tmpBlueHex}`;
	}

	generateCSS()
	{
		let tmpCSS = '';
		let tmpCSSHashes = Object.keys(this.inlineCSSMap);
		// Sort the hashes by Priority
		tmpCSSHashes.sort((a, b) => { return this.inlineCSSMap[a].Priority - this.inlineCSSMap[b].Priority; });
		for (let i = 0; i < tmpCSSHashes.length; i++)
		{
			let tmpCSSFragment = this.inlineCSSMap[tmpCSSHashes[i]];
			let tmpCSSComment = tmpCSSFragment.Hash;
			if (tmpCSSFragment.Hash != tmpCSSFragment.Provider)
			{
				tmpCSSComment = `${tmpCSSComment} from ${tmpCSSFragment.Provider}`;
			}
			tmpCSS += `/* ${tmpCSSComment} */\n${tmpCSSFragment.Content}\n`;
		}
		return tmpCSS;
	}

	// Inject the CSS into the magic DOM element for it.
	// Skips the DOM write when nothing has changed since the last injection (see
	// the _cssDirty notes in the constructor) -- this is what keeps per-render
	// injectCSS() calls from reparsing the whole stylesheet and flickering on
	// navigation. Pass pForceInjection = true to write unconditionally, e.g. if a
	// caller mutated inlineCSSMap directly instead of using addCSS()/removeCSS().
	injectCSS(pForceInjection)
	{
		if (!pForceInjection && !this._cssDirty)
		{
			return;
		}
		this._cssDirty = false;
		this.services.ContentAssignment.assignContent(this.options.CSSElementAddress, this.generateCSS());
	}
}

module.exports = PictCSS;

},{"fable":71}],370:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

/**
 * Class for moving content around in the DOM.
 */
class PictContentAssignment extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable library instance.
	 * @param {any} [pOptions] - The options for the service.
	 * @param {string} [pServiceHash] - The hash of services.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;
		/** @type {any} */
		this.fable;

		this.serviceType = 'PictContentAssignment';

		this.manifest = pFable.newManyfest();

		// Check to see if we are running in a browser
		this.inBrowser = false;
		this.hasDocument = false;
		if (typeof (window) == 'object')
		{
			this.inBrowser = true;
			// Now check that the browser has a document object
			if ((typeof (window.document) != 'undefined') && (typeof (window.document.querySelectorAll) == 'function'))
			{
				this.hasDocument = true;
			}
		}

		// If we're in a browser, check to see if jQuery is available.
		this.hasJquery = false;
		this.jQuery = false;
		if (this.inBrowser && typeof (window.jQuery) !== 'undefined')
		{
			this.hasJquery = true;
		}

		/**
		 * Set this to override the default mechanism for setting the content of a DOM element.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to set.
		 */
		this.customAssignFunction = null;
		/**
		 * Set this to override the default mechanism for prepend content to a DOM element.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to prepend.
		 */
		this.customPrependFunction = null;
		/**
		 * Set this to override the default mechanism for appending content to a DOM element.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to append.
		 */
		this.customAppendFunction = null;
		/**
		 * Set this to override the default mechanism for appending content to a DOM element.
		 *
		 * @type {(pBeforeAddress: string|HTMLElement, pContent: string) => void}
		 * @param {string|HTMLElement} pBeforeAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to append.
		 */
		this.customInsertBeforeFunction = null;
		/**
		 * Set this to override the default mechanism for appending content to a DOM element.
		 *
		 * @type {(pAfterAddress: string|HTMLElement, pContent: string) => void}
		 * @param {string|HTMLElement} pAfterAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to append.
		 */
		this.customInsertAfterFunction = null;

		/**
		 * Set this to override the default mechanism for reading content from the DOM.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @return {string} - The content of the element.
		 */
		this.customReadFunction = null;
		/**
		 * Set this to override the default mechanism for getting elements.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @return {Array<any>} - The matched elements.
		 */
		this.customGetElementFunction = null;

		// API Consumers can also craft their own attribute read function
		this.customReadAttributeFunction = null;
		// API Consumers can also craft their own attribute set function
		this.customSetAttributeFunction = null;
		// API Consumers can also craft their own attribute remove function
		this.customRemoveAttributeFunction = null;

		// API Consumers can also craft their own class read function
		this.customReadClassFunction = null;
		// API Consumers can also craft their own class set function
		this.customSetClassFunction = null;
		// API Consumers can also craft their own class remove function
		this.customRemoveClassFunction = null;
	}

	/**
	 * Get an element from the DOM.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @return {Array<any>} - The matched elements.
	 */
	getElement(pAddress)
	{
		if (this.customGetElementFunction)
		{
			return this.customGetElementFunction(pAddress);
		}
		else if (this.hasJquery)
		{
			let tmpElements = window.jQuery(pAddress);
			if (tmpElements.length == 0)
			{
				return [];
			}
			// TODO: This isn't the most efficient method, but it is the most compatible.
			let tmpElementSet = [];
			for (let i = 0; i < tmpElements.length; i++)
			{
				tmpElementSet.push(tmpElements[i]);
			}
			return tmpElementSet;
		}
		else if (this.inBrowser && this.hasDocument)
		{
			// convert from NodeList to Array for consistent return type
			const tmpElements = window.document.querySelectorAll(pAddress);
			let tmpElementSet = [];
			for (let i = 0; i < tmpElements.length; i++)
			{
				tmpElementSet.push(tmpElements[i]);
			}
			return tmpElementSet;
		}
		else
		{
			// Just log it out for now
			this.log.trace(`PICT Content GET ELEMENT for [${pAddress}] will return empty because none of the browser methods are available`);
			return [];
		}
	}

	/**
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string|boolean} pContent - The content to assign.
	 * @return {void}
	 */
	assignContent(pAddress, pContent)
	{
		if (this.customAssignFunction)
		{
			return this.customAssignFunction(pAddress, pContent);
		}
		else if (this.hasJquery)
		{
			// Get the element(s)
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				const tmpElement = tmpTargetElementSet[i];
				switch (tmpElement.tagName)
				{
					case 'INPUT':
						if (tmpElement instanceof HTMLInputElement && tmpElement.type == 'checkbox')
						{
							tmpElement.checked = Boolean(pContent);
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
						if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLSelectElement || tmpElement instanceof HTMLTextAreaElement)
						{
							tmpElement.value = String(pContent);
						}
						break;
					case 'SCRIPT':
						if (tmpElement instanceof HTMLScriptElement)
						{
							tmpElement.text = String(pContent);
						}
						break;
					default:
						tmpElement.innerHTML = String(pContent);
				}
			}
		}
		else if (this.inBrowser && this.hasDocument)
		{
			// Get the element(s)
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				const tmpElement = tmpTargetElementSet[i];
				switch (tmpTargetElementSet[i].tagName)
				{
					case 'INPUT':
						if (tmpElement instanceof HTMLInputElement && tmpElement.type == 'checkbox')
						{
							tmpElement.checked = Boolean(pContent);
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
						if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLSelectElement || tmpElement instanceof HTMLTextAreaElement)
						{
							tmpElement.value = String(pContent);
						}
						break;
					case 'SCRIPT':
						if (tmpElement instanceof HTMLScriptElement)
						{
							tmpElement.text = String(pContent);
						}
						break;
					default:
						tmpElement.innerHTML = String(pContent);
				}
			}
		}
		else
		{
			// Just log it out for now
			this.log.trace(`PICT Content ASSIGN to [${pAddress}]:`, pContent);
		}
	}

	/**
	 * Append content to an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to append.
	 */
	appendContent(pAddress, pContent)
	{
		if (this.customAppendFunction)
		{
			return this.customAppendFunction(pAddress, pContent);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.append(pContent);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("beforeend", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content APPEND to [${pAddress}]:`, pContent);
		}
	}

	/**
	 * Insert content before an element. The new content will be a sibling of the target element.
	 *
	 * @param {string|HTMLElement} pBeforeAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to insert.
	 */
	insertContentBefore(pBeforeAddress, pContent)
	{
		if (this.customInsertBeforeFunction)
		{
			return this.customInsertBeforeFunction(pBeforeAddress, pContent);
		}
		else if (this.hasJquery)
		{
			window.jQuery(pContent).insertBefore(pBeforeAddress);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pBeforeAddress === 'string' ? window.document.querySelectorAll(pBeforeAddress) : [ pBeforeAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("beforebegin", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content INSERT BEFORE [${pBeforeAddress}]:`, pContent);
		}
	}

	/**
	 * Insert content after an element. The new content will be a sibling of the target element.
	 *
	 * @param {string|HTMLElement} pAfterAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to insert.
	 */
	insertContentAfter(pAfterAddress, pContent)
	{
		if (this.customInsertAfterFunction)
		{
			return this.customInsertAfterFunction(pAfterAddress, pContent);
		}
		else if (this.hasJquery)
		{
			window.jQuery(pContent).insertAfter(pAfterAddress);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAfterAddress === 'string' ? window.document.querySelectorAll(pAfterAddress) : [ pAfterAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("afterend", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content INSERT AFTER [${pAfterAddress}]:`, pContent);
		}
	}

	/**
	 * Prepend content to an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to prepend.
	 */
	prependContent(pAddress, pContent)
	{
		if (this.customAppendFunction)
		{
			return this.customPrependFunction(pAddress, pContent);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.prepend(pContent);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("afterbegin", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content PREPEND in [${pAddress}]:`, pContent);
		}
	}

	/**
	 * Project content into a destination address based on a render method -- as the views do.
	 * Valid render methods are:
	 * - append: Append the content to the destination address.
	 * - prepend: Prepend the content to the destination address.
	 * - append_once: Append the content to the destination address only if it doesn't already exist in the test address.
	 * - replace: Replace the content of the destination address with the new content.
	 * @param {string} pRenderMethod
	 * @param {string} pDestinationAddress
	 * @param {string} pContent
	 * @param {string} pTestAddress
	 * @returns Result of the content assignment.
	 */
	projectContent(pRenderMethod, pDestinationAddress, pContent, pTestAddress)
	{
		// Assign the content to the destination address
		switch(pRenderMethod)
		{
			case 'virtual-assignment':
				return this.manifest.setValueByHash(this.fable, pDestinationAddress, pContent);
			case 'append':
				return this.appendContent(pDestinationAddress, pContent);
			case 'prepend':
				return this.prependContent(pDestinationAddress, pContent);
			case 'append_once':
			{
				if (typeof(pTestAddress) == 'string' && pTestAddress.length > 0)
				{
					let tmpExistingContent = this.getElement(pTestAddress);
					if (tmpExistingContent.length < 1)
					{
						return this.appendContent(pDestinationAddress, pContent);
					}
					break;
				}
				// Without a test address, preserve the "once" guarantee by
				// treating a non-empty destination as "already populated."
				// (The previous fallback ran getElement on the destination
				// container itself, which virtually always exists, so
				// append_once silently became a no-op whenever TestAddress
				// was omitted.)
				let tmpDestinationContent = this.readContent(pDestinationAddress);
				if (tmpDestinationContent == null || String(tmpDestinationContent).trim() === '')
				{
					return this.appendContent(pDestinationAddress, pContent);
				}
				break;
			}
			case 'replace':
				// TODO: Should this be the default?
				/* falls through */
			default:
				return this.assignContent(pDestinationAddress, pContent);
		}
	}

	/**
	 * Read content from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 *
	 * TODO: return {boolean|string|number|string[]} - The content of the element.
	 * @return {string|boolean} - The content of the element.
	 */
	readContent(pAddress)
	{
		if (this.customReadFunction)
		{
			return this.customReadFunction(pAddress);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			switch (tmpTargetElement.prop('tagName'))
				{
					case 'INPUT':
						if (tmpTargetElement.attr('type') == 'checkbox')
						{
							return tmpTargetElement.prop('checked');
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
					{
						//FIXME: masking types to simplify the expressed return value, for now
						/** @type {any} */
						const value = tmpTargetElement.val();
						return value;
					}
					case 'SCRIPT':
						return tmpTargetElement.text();
					default:
						return tmpTargetElement.html();
				}
		}
		else if (this.inBrowser && this.hasDocument)
		{
			let tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];
			if (tmpTargetElementSet.length < 1)
			{
				return null;
			}
			else if (tmpTargetElementSet.length == 1)
			{
				const tmpElement = tmpTargetElementSet[0];
				switch (tmpElement.tagName)
				{
					case 'INPUT':
						if (tmpElement instanceof HTMLInputElement && tmpElement.type == 'checkbox')
						{
							return tmpElement.checked;
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
						if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLSelectElement || tmpElement instanceof HTMLTextAreaElement)
						{
							return tmpElement.value;
						}
						/* falls through */
					case 'SCRIPT':
						if (tmpElement instanceof HTMLScriptElement)
						{
							return tmpElement.text;
						}
						/* falls through */
					default:
						return tmpElement.innerHTML;
				}
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content READ from [${pAddress}]...`);
			return '';
		}
	}

	/**
	 * Add a class to an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string|string[]} pClass - The class to add.
	 */
	addClass(pAddress, pClass)
	{
		if (this.customSetClassFunction)
		{
			return this.customSetClassFunction(pAddress, pClass);
		}
		else if (this.hasJquery)
		{
			// Get the element
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.addClass(pClass);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				if (Array.isArray(pClass))
				{
					for (const tmpClass of pClass)
					{
						tmpTargetElementSet[i].classList.add(tmpClass);
					}
				}
				else
				{
					tmpTargetElementSet[i].classList.add(pClass);
				}
			}
		}
		else
		{
			this.log.trace(`PICT Content ADDCLASS to [${pAddress}]:`, pClass);
		}
	}

	/**
	 * Remove a class from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string|string[]} pClass - The class to remove.
	 */
	removeClass(pAddress, pClass)
	{
		if (this.customRemoveClassFunction)
		{
			return this.customRemoveClassFunction(pAddress, pClass);
		}
		else if (this.hasJquery)
		{
			// Get the element
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.removeClass(pClass);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				if (Array.isArray(pClass))
				{
					for (const tmpClass of pClass)
					{
						tmpTargetElementSet[i].classList.remove(tmpClass);
					}
				}
				else
				{
					tmpTargetElementSet[i].classList.remove(pClass);
				}
			}
		}
		else
		{
			this.log.trace(`PICT Content REMOVECLASS from [${pAddress}]:`, pClass);
		}
	}

	/**
	 * Read an attribute from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pAttribute - The attribute name to read.
	 */
	readAttribute(pAddress, pAttribute)
	{
		if (this.customReadAttributeFunction)
		{
			return this.customReadAttributeFunction(pAddress, pAttribute);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			return tmpTargetElement.attr(pAttribute);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].getAttribute(pAttribute);
			}
			return tmpTargetElementSet;
		}
		else
		{
			this.log.trace(`PICT Content READATTRIBUTE from [${pAddress}]:`, pAttribute);
		}
	}

	/**
	 * Set an attribute on an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pAttribute - The attribute name to set.
	 * @param {string} pValue - The value to set.
	 */
	setAttribute(pAddress, pAttribute, pValue)
	{
		if (this.customSetAttributeFunction)
		{
			return this.customSetAttributeFunction(pAddress, pAttribute, pValue);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.attr(pAttribute, pValue);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].setAttribute(pAttribute, pValue);
			}
		}
		else
		{
			this.log.trace(`PICT Content SETATTRIBUTE for [${pAddress}] ATTRIBUTE [${pAttribute}]:`, pValue);
		}
	}

	/**
	 * Remove an attribute from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pAttribute - The attribute name to remove.
	 */
	removeAttribute(pAddress, pAttribute)
	{
		if (this.customRemoveAttributeFunction)
		{
			return this.customRemoveAttributeFunction(pAddress, pAttribute);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.removeAttr(pAttribute);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].removeAttribute(pAttribute);
			}
		}
		else
		{
			this.log.trace(`PICT Content REMOVEATTRIBUTE for [${pAddress}] ATTRIBUTE [${pAttribute}]`);
		}
	}

	/**
	 * Check if an element has a class.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pClass - The class to toggle.
	 *
	 * @return {boolean} - Whether the element has the class. If multiple elements are matched, returns true if any have the class.
	 */
	hasClass(pAddress, pClass)
	{
		if (this.customReadClassFunction)
		{
			return this.customReadClassFunction(pAddress, pClass);
		}
		if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			return tmpTargetElement.hasClass(pClass);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				if (tmpTargetElementSet[i].classList.contains(pClass))
				{
					return true;
				}
			}
			return false;
		}
		else
		{
			this.log.trace(`PICT Content HASCLASS for [${pAddress}] CLASS [${pClass}]:`);
			return false;
		}
	}

	/**
	 * Toggle a class on or off an element
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pClass - The class to check for.
	 */
	toggleClass(pAddress, pClass)
	{
		if (this.hasClass(pAddress, pClass))
		{
			this.removeClass(pAddress, pClass);
		}
		else
		{
			this.addClass(pAddress, pClass);
		}
	}
}

module.exports = PictContentAssignment;

},{"fable":71}],371:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

class PictDataProvider extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & import('./Pict')} */
		this.fable;

		this.serviceType = 'PictDataProvider';
	}

	/**
	 * @param {string} pAddress - The address of the data to retrieve
	 * @param {object} [pData] - (optional) The record to provide to the address resolver
	 */
	getDataByAddress(pAddress, pData)
	{
		let tmpData = (typeof(pData) === 'undefined') ? {} : pData;

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.fable.AppData,
			Bundle: this.fable.Bundle,
			Record: tmpData,
		};
		return this.fable.manifest.getValueByHash(tmpAddressSpace, pAddress);
	}
}

module.exports = PictDataProvider;

},{"fable":71}],372:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

// Minimum meadow-endpoints version, per major, that serves the body-driven
// POST /:Entity/Query read route. The route was added in 2.1.0 and 4.1.0 but
// never shipped on the 3.x line or 4.0.x — so support is NOT monotonic across
// majors and a flat ">= x" comparison would be wrong. Used only as a fallback
// when the server does not advertise an explicit Capabilities flag.
const QUERY_ENDPOINT_MIN_VERSION_BY_MAJOR =
{
	2: '2.1.0',
	4: '4.1.0'
};

/**
 * Meadow routes that are reads despite arriving as a POST. `POST /:Entity/Query` carries its filter
 * in the body purely to escape URI length limits; it mutates nothing. Registered with the REST
 * client as a safety hook so the fact lives with the route rather than with each call site.
 *
 * @type {RegExp}
 */
const MEADOW_READ_ROUTE_PATTERN = /\/Query(?:$|[/?])/;

class PictMeadowEntityProvider extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('./Pict') & { settings: any } & { newAnticipate: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.serviceType = 'PictMeadowProvider';

		if (this.fable.settings.PictDefaultURLPrefix)
		{
			this.options.urlPrefix = this.fable.settings.PictDefaultURLPrefix;
		}
		else if (!this.options.urlPrefix)
		{
			this.options.urlPrefix = '/1.0/';
		}

		if (!this.options.downloadBatchSize)
		{
			if (typeof this.fable.settings.PictDefaultDownloadBatchSize === 'number')
			{
				this.options.downloadBatchSize = this.fable.settings.PictDefaultDownloadBatchSize;
			}
			else
			{
				this.options.downloadBatchSize = 100;
			}
		}

		if (typeof this.options.downloadPageConcurrency !== 'number')
		{
			this.options.downloadPageConcurrency = (typeof this.fable.settings.PictDefaultDownloadPageConcurrency === 'number')
				? this.fable.settings.PictDefaultDownloadPageConcurrency
				: 4;
		}

		if (typeof this.options.maxBundleConcurrency !== 'number')
		{
			this.options.maxBundleConcurrency = (typeof this.fable.settings.PictDefaultMaxBundleConcurrency === 'number')
				? this.fable.settings.PictDefaultMaxBundleConcurrency
				: 8;
		}

		//@ts-ignore - FIXME - remove once we have fable types
		this.restClient = this.fable.RestClient ?? this.fable.instantiateServiceProviderWithoutRegistration('RestClient');

		/** @type {Record<string, import('cachetrax')>} */
		this.recordCache = {};
		/** @type {Record<string, import('cachetrax')>} */
		this.recordSetCache = {};

		this.entityColumnTranslations = (
			{
				CreatingIDUser: 'User',
				UpdatingIDUser: 'User',
				DeletingIDUser: 'User'
			});

		/** @type {(pOptions: Record<string, any>) => Record<string, any>} */
		this.prepareRequestOptions = (pOptions) => { return pOptions; };

		/**
		 * After buildBundleWaves() is called by gatherDataFromServer(), this
		 * property holds the computed wave schedule for inspection/debugging.
		 * @type {Array<Array<{Index: number, Step: Record<string, any>}>>|null}
		 */
		this.lastBundleWaves = null;

		// Master switch for the body-driven POST /:Entity/Query transport. When
		// false the provider always uses the legacy GET reads (no capability
		// probe is ever issued). Defaults on; opt out via option or setting.
		if (typeof this.options.UseQueryEndpoint === 'boolean')
		{
			this.useQueryEndpoint = this.options.UseQueryEndpoint;
		}
		else if (typeof this.fable.settings.PictMeadowUseQueryEndpoint === 'boolean')
		{
			this.useQueryEndpoint = this.fable.settings.PictMeadowUseQueryEndpoint;
		}
		else
		{
			this.useQueryEndpoint = true;
		}

		/**
		 * Retry configuration handed to the RestClient on every read this provider
		 * issues. `null` (the default) inherits whatever policy the RestClient was
		 * built with -- and the RestClient default is no retry at all, so reads
		 * behave exactly as they always have until an application opts in here or
		 * at the fable layer. Accepts anything the RestClient policy builder
		 * accepts: an overrides object, a number (max attempts), true to enable
		 * with the recommended budget, or false to disable.
		 * @type {Record<string, any>|number|boolean|null}
		 */
		if (typeof this.options.ReadRetry !== 'undefined')
		{
			this.readRetryConfiguration = this.options.ReadRetry;
		}
		else if (typeof this.fable.settings.PictMeadowReadRetry !== 'undefined')
		{
			this.readRetryConfiguration = this.fable.settings.PictMeadowReadRetry;
		}
		else
		{
			this.readRetryConfiguration = null;
		}

		/**
		 * Optional outcome classifier passed through to the RestClient on every
		 * read. Needed where an API reports failure in the body rather than the
		 * status code; see FableServiceRestClient.retryClassifier.
		 *
		 * Set it as a provider option or assign it directly
		 * (`pict.EntityProvider.readRetryClassifier = fn`). It deliberately has no
		 * settings key -- fable's settings merge drops function values, so a
		 * classifier can only ever arrive programmatically.
		 * @type {Function|null}
		 */
		this.readRetryClassifier = (typeof this.options.ReadRetryClassifier === 'function') ? this.options.ReadRetryClassifier : null;

		this._legacyRetrySafeStamping = false;
		this._registerReadSafetyHook();
		this._registerReadClassifierHook();
		if (this.readRetryConfiguration !== null && typeof this.restClient.configureRetry === 'function')
		{
			// The policy belongs on the client for the same reason the safety hook
			// does: everything reading through it should behave the same way.
			this.restClient.configureRetry(this.readRetryConfiguration);
		}

		/**
		 * Per-(urlPrefix, entity) capability cache. Different entities can resolve
		 * to different backend services (and thus different meadow-endpoints
		 * versions) behind the same urlPrefix, so support is cached per entity.
		 * @type {Record<string, { SupportsQuery: boolean, Metadata: (Record<string, any>|null) }>}
		 */
		this.endpointCapabilityCache = {};
		/**
		 * In-flight capability probes, keyed identically to the cache, so
		 * concurrent reads of the same entity collapse onto a single Schema probe.
		 * @type {Record<string, Array<(pError: Error|null, pSupportsQuery: boolean) => void>>}
		 */
		this.endpointCapabilityInflight = {};
		/**
		 * Per-(urlPrefix, entity) cache of the `<Entity>/Schema` response BODY,
		 * so every consumer of the schema shares one round-trip. The capability
		 * probe and pict-section-recordset's record-schema load both read the
		 * same URL; without a shared cache each has its own single-flight and the
		 * identical schema is fetched twice per recordset.
		 * @type {Record<string, Record<string, any>>}
		 */
		this.entitySchemaCache = {};
		/**
		 * In-flight schema fetches, keyed identically to the cache, so concurrent
		 * consumers collapse onto a single request.
		 * @type {Record<string, Array<(pError: Error|null, pSchema: Record<string, any>|null) => void>>}
		 */
		this.entitySchemaInflight = {};
	}

	/**
	 * Fetch (and cache) an entity's `<Entity>/Schema` body, shared across every
	 * consumer. Concurrent callers for the same (urlPrefix, entity) collapse onto
	 * one request; a successful fetch also primes the capability cache, so a
	 * later `resolveEntityQuerySupport` resolves without a probe.
	 *
	 * Failures are not cached — they resolve with the error for this call but
	 * leave the key re-fetchable, matching the capability probe's retry posture.
	 *
	 * @param {string} pEntity - The entity name.
	 * @param {string} [pURLPrefix] - The URL prefix in play.
	 * @param {(pError: Error|null, pSchema: Record<string, any>|null) => void} fCallback - Completion callback.
	 * @return {void}
	 */
	getEntitySchema(pEntity, pURLPrefix, fCallback)
	{
		const tmpKey = this._capabilityKey(pEntity, pURLPrefix);
		if (tmpKey in this.entitySchemaCache)
		{
			return fCallback(null, this.entitySchemaCache[tmpKey]);
		}
		if (this.entitySchemaInflight[tmpKey])
		{
			this.entitySchemaInflight[tmpKey].push(fCallback);
			return;
		}
		this.entitySchemaInflight[tmpKey] = [ fCallback ];
		/** @type {Record<string, any>} */
		let tmpOptions = ({ url: `${pURLPrefix || this.options.urlPrefix}${pEntity}/Schema` });
		tmpOptions = this._decorateReadRequestOptions(this.prepareRequestOptions(tmpOptions));
		this.restClient.getJSON(tmpOptions,
			(pError, pResponse, pBody) =>
			{
				if (!pError && pBody)
				{
					this.entitySchemaCache[tmpKey] = pBody;
					// One fetch serves both purposes.
					try { this.primeEntityCapabilityFromSchema(pEntity, pBody, pURLPrefix); }
					catch (pPrimeError) { /* capability stays unresolved; the probe can retry */ }
				}
				const tmpCallbacks = this.entitySchemaInflight[tmpKey];
				delete this.entitySchemaInflight[tmpKey];
				for (let i = 0; i < tmpCallbacks.length; i++)
				{
					tmpCallbacks[i](pError || null, pError ? null : pBody);
				}
			});
	}

	/**
	 * Compute the capability cache key for an (entity, urlPrefix) pair.
	 *
	 * @param {string} pEntity - The entity name.
	 * @param {string} [pURLPrefix] - The URL prefix in play (defaults to the provider default).
	 * @return {string} The cache key.
	 */
	_capabilityKey(pEntity, pURLPrefix)
	{
		return `${pURLPrefix || this.options.urlPrefix}::${pEntity}`;
	}

	/**
	 * Major-version-aware check of whether a meadow-endpoints version string
	 * serves the POST /:Entity/Query route. Support is keyed off the major
	 * version (see QUERY_ENDPOINT_MIN_VERSION_BY_MAJOR) because the route was
	 * backported to 2.1.0 and added in 4.1.0, but absent on 3.x and 4.0.x.
	 *
	 * @param {string} pVersion - A semver string (e.g. '4.1.0').
	 * @return {boolean} True if the version is known to serve the Query route.
	 */
	isMeadowEndpointsVersionQueryCapable(pVersion)
	{
		if (typeof pVersion !== 'string')
		{
			return false;
		}
		const tmpParts = pVersion.split('.').map((pPart) => { return parseInt(pPart, 10); });
		if (tmpParts.length < 1 || isNaN(tmpParts[0]))
		{
			return false;
		}
		const tmpMajor = tmpParts[0];
		const tmpMinimum = QUERY_ENDPOINT_MIN_VERSION_BY_MAJOR[tmpMajor];
		if (!tmpMinimum)
		{
			return false;
		}
		const tmpMinimumParts = tmpMinimum.split('.').map((pPart) => { return parseInt(pPart, 10); });
		// Lexicographic compare of [major, minor, patch] with missing parts as 0.
		for (let i = 0; i < 3; i++)
		{
			const tmpHave = isNaN(tmpParts[i]) ? 0 : tmpParts[i];
			const tmpNeed = isNaN(tmpMinimumParts[i]) ? 0 : tmpMinimumParts[i];
			if (tmpHave > tmpNeed)
			{
				return true;
			}
			if (tmpHave < tmpNeed)
			{
				return false;
			}
		}
		return true;
	}

	/**
	 * Decide, from a Schema endpoint response body, whether the serving
	 * meadow-endpoints supports the POST /:Entity/Query route. An explicit
	 * Capabilities flag wins when present; otherwise fall back to a
	 * major-version-aware check of the advertised meadow-endpoints version.
	 * Servers that advertise nothing (older deployments) are unsupported.
	 *
	 * @param {Record<string, any>} pSchemaBody - The Schema endpoint response body.
	 * @return {boolean} True if POST /:Entity/Query is supported.
	 */
	evaluateQueryEndpointSupport(pSchemaBody)
	{
		if (!pSchemaBody || typeof pSchemaBody !== 'object')
		{
			return false;
		}
		const tmpMetadata = pSchemaBody.RetoldMetadata;
		if (!tmpMetadata || typeof tmpMetadata !== 'object')
		{
			return false;
		}
		if (tmpMetadata.Capabilities && typeof tmpMetadata.Capabilities.QueryEndpoint === 'boolean')
		{
			return tmpMetadata.Capabilities.QueryEndpoint;
		}
		const tmpVersion = tmpMetadata.PackageVersions && tmpMetadata.PackageVersions['meadow-endpoints'];
		if (typeof tmpVersion === 'string')
		{
			return this.isMeadowEndpointsVersionQueryCapable(tmpVersion);
		}
		return false;
	}

	/**
	 * Seed the capability cache for an entity from a Schema response the caller
	 * already has in hand (e.g. pict-section-recordset fetches the schema during
	 * initialization). Avoids a redundant capability probe.
	 *
	 * @param {string} pEntity - The entity name.
	 * @param {Record<string, any>} pSchemaBody - The Schema endpoint response body.
	 * @param {string} [pURLPrefix] - The URL prefix the schema was fetched from.
	 * @return {boolean} The resolved support value now cached.
	 */
	primeEntityCapabilityFromSchema(pEntity, pSchemaBody, pURLPrefix)
	{
		const tmpSupportsQuery = this.evaluateQueryEndpointSupport(pSchemaBody);
		this.endpointCapabilityCache[this._capabilityKey(pEntity, pURLPrefix)] =
			{
				SupportsQuery: tmpSupportsQuery,
				Metadata: (pSchemaBody && pSchemaBody.RetoldMetadata) || null
			};
		return tmpSupportsQuery;
	}

	/**
	 * Resolve whether POST /:Entity/Query is usable for an entity, probing the
	 * Schema endpoint once and caching the result per (urlPrefix, entity).
	 * Concurrent calls for the same key collapse onto a single probe.
	 *
	 * Probe failures (network/parse) are NOT cached — they resolve to false (GET
	 * fallback) for this call but allow a later retry, so a transient blip does
	 * not permanently disable the faster transport for the session. A successful
	 * probe of an older server (no metadata) caches false and never re-probes.
	 *
	 * @param {string} pEntity - The entity name.
	 * @param {string} pURLPrefix - The URL prefix in play.
	 * @param {(pError: Error|null, pSupportsQuery: boolean) => void} fCallback - Completion callback.
	 * @return {void}
	 */
	resolveEntityQuerySupport(pEntity, pURLPrefix, fCallback)
	{
		if (!this.useQueryEndpoint)
		{
			return fCallback(null, false);
		}
		const tmpKey = this._capabilityKey(pEntity, pURLPrefix);
		if (tmpKey in this.endpointCapabilityCache)
		{
			return fCallback(null, this.endpointCapabilityCache[tmpKey].SupportsQuery);
		}
		if (this.endpointCapabilityInflight[tmpKey])
		{
			this.endpointCapabilityInflight[tmpKey].push(fCallback);
			return;
		}
		this.endpointCapabilityInflight[tmpKey] = [ fCallback ];

		// Shared schema fetch: if another consumer already loaded (or is loading)
		// this entity's schema, no second request is made.
		this.getEntitySchema(pEntity, pURLPrefix,
			(pError, pBody) =>
			{
				let tmpSupportsQuery = false;
				if (!pError)
				{
					try
					{
						tmpSupportsQuery = this.evaluateQueryEndpointSupport(pBody);
					}
					catch (pEvaluateError)
					{
						tmpSupportsQuery = false;
					}
					// Only cache on a clean probe; transient errors stay re-probeable.
					this.endpointCapabilityCache[tmpKey] =
						{
							SupportsQuery: tmpSupportsQuery,
							Metadata: (pBody && pBody.RetoldMetadata) || null
						};
				}
				else
				{
					this.log.warn(`EntityProvider capability probe for [${pEntity}] failed; falling back to GET reads: ${pError}`);
				}
				const tmpCallbacks = this.endpointCapabilityInflight[tmpKey];
				delete this.endpointCapabilityInflight[tmpKey];
				for (let i = 0; i < tmpCallbacks.length; i++)
				{
					tmpCallbacks[i](null, tmpSupportsQuery);
				}
			});
	}

	/**
	 * Render a filter expression for inclusion in an error or log message. A
	 * chunked ID read carries thousands of IDs in its filter; embedding it whole
	 * produces multi-kilobyte Error messages that propagate into alerting.
	 *
	 * @param {string} pMeadowFilterExpression - The filter expression.
	 * @return {string} The filter, elided past the message length budget.
	 */
	_describeFilter(pMeadowFilterExpression)
	{
		const tmpBudget = (typeof this.options.filterMessageLengthBudget === 'number') ? this.options.filterMessageLengthBudget : 300;
		if (typeof pMeadowFilterExpression !== 'string' || pMeadowFilterExpression.length <= tmpBudget)
		{
			return pMeadowFilterExpression;
		}
		return `${pMeadowFilterExpression.substring(0, tmpBudget)}… (${pMeadowFilterExpression.length} chars)`;
	}

	/**
	 * Validate a write response before its body is trusted as a saved record.
	 *
	 * The write methods historically inspected only the transport error, so a 4xx/5xx rejection
	 * arrived at the caller as a success whose "record" was really an error envelope. Every caller
	 * in practice branches on the error argument, so a rejected write silently read as a completed
	 * one. Transport errors pass through unchanged.
	 *
	 * @param {string} pOperation - Verb used in the message, e.g. 'creating'.
	 * @param {string} pEntityType - The entity type.
	 * @param {string} pTarget - Identifier for the message (record id, count, ...).
	 * @param {Error|null} pError - The transport error, if any.
	 * @param {Object} [pResponse] - The response.
	 * @param {*} [pBody] - The parsed body.
	 * @return {Error|null} The failure, or null when the write was accepted.
	 */
	_validateEntityWriteResponse(pOperation, pEntityType, pTarget, pError, pResponse, pBody)
	{
		if (pError)
		{
			this.log.error(`Error ${pOperation} ${pEntityType} record ${pTarget}: ${pError.message}`);
			return pError;
		}

		if (pResponse && pResponse.statusCode && pResponse.statusCode >= 400)
		{
			this.log.error(`Error ${pOperation} ${pEntityType} record ${pTarget}: ${pResponse.statusCode} ${pResponse.statusMessage}`);
			return new Error(`Error ${pOperation} ${pEntityType} record ${pTarget}: ${pResponse.statusCode} ${JSON.stringify(pBody || {}).substring(0, 300)}`);
		}

		return null;
	}

	/**
	 * Validate a page read response before its body is trusted as records.
	 *
	 * A 2xx whose body is not an array is a failure, not an empty page. The legacy API reports
	 * errors as HTTP 200 with an `{ Error: ... }` envelope, and treating that as "no records"
	 * silently drops rows out of an assembled entity set — the caller sees fewer records than the
	 * matching Count and no error at all. The unpaged read path has always checked this; the paged
	 * and single-page paths did not.
	 *
	 * @param {string} pEntity - The entity name, for the message.
	 * @param {string} pMeadowFilterExpression - The filter, for the message.
	 * @param {Error|null} pDownloadError - The transport error, if any.
	 * @param {Object} [pDownloadResponse] - The response.
	 * @param {*} [pDownloadBody] - The parsed body.
	 * @param {string} [pPageDescription] - Optional `[begin/cap]` stanza for the message.
	 * @return {Error|null} The failure, or null when the body is a usable record array.
	 */
	_validateEntityPageResponse(pEntity, pMeadowFilterExpression, pDownloadError, pDownloadResponse, pDownloadBody, pPageDescription)
	{
		const tmpPageStanza = pPageDescription ? ` ${pPageDescription}` : '';
		const tmpDescribedFilter = this._describeFilter(pMeadowFilterExpression);

		if (pDownloadError)
		{
			return pDownloadError;
		}

		if (pDownloadResponse && pDownloadResponse.statusCode && pDownloadResponse.statusCode >= 400)
		{
			this.log.error(`Error getting entity set of [${pEntity}] filtered to [${tmpDescribedFilter}]${tmpPageStanza}: ${pDownloadResponse.statusCode} ${pDownloadResponse.statusMessage}`);
			return new Error(`Error getting entity set of [${pEntity}] filtered to [${tmpDescribedFilter}]${tmpPageStanza}: ${pDownloadResponse.statusCode} ${JSON.stringify(pDownloadBody || {})}`);
		}

		if (!Array.isArray(pDownloadBody))
		{
			const tmpStatusCode = (pDownloadResponse && pDownloadResponse.statusCode) ? pDownloadResponse.statusCode : 'no response';
			this.log.error(`Error getting entity set of [${pEntity}] filtered to [${tmpDescribedFilter}]${tmpPageStanza}: ${tmpStatusCode} response body was not a record array.`);
			return new Error(`Error getting entity set of [${pEntity}] filtered to [${tmpDescribedFilter}]${tmpPageStanza}: ${tmpStatusCode} response body was not a record array: ${JSON.stringify(pDownloadBody || {}).substring(0, 300)}`);
		}

		return null;
	}

	/**
	 * Stamp read-resilience metadata onto an outbound read request. Every read
	 * this provider issues is non-mutating -- including the POST /:Entity/Query
	 * reads, which are POSTs only so the filter can travel in the body -- so they
	 * are all explicitly marked safe for the RestClient to replay.
	 *
	 * @param {Record<string, any>} pRequestOptions - The request options object.
	 * @return {Record<string, any>} The same object, decorated.
	 */
	_decorateReadRequestOptions(pRequestOptions)
	{
		if (this._legacyRetrySafeStamping)
		{
			// Talking to a RestClient predating the safety-hook chain.
			pRequestOptions.RetrySafe = true;
		}
		if (this.readRetryConfiguration !== null)
		{
			pRequestOptions.Retry = this.readRetryConfiguration;
		}
		return pRequestOptions;
	}

	/**
	 * Teach the REST client, once, which meadow routes are replayable reads.
	 *
	 * `POST /:Entity/Query` is a read; it is a POST only so the filter can travel in the body. That
	 * is a property of the route, not of any individual call, so it is registered as a safety hook
	 * rather than stamped onto each request. Anything sharing this client -- pict-section-recordset
	 * reaches straight for `EntityProvider.restClient` -- inherits it without knowing it exists.
	 *
	 * Registration is idempotent per client, so several providers on one client register once.
	 *
	 * @return {void}
	 */
	_registerReadSafetyHook()
	{
		if (!this.restClient || (typeof this.restClient.addRetrySafetyHook !== 'function'))
		{
			// An older RestClient without the hook chain; the per-request RetrySafe
			// flag below is the fallback for that case.
			this._legacyRetrySafeStamping = true;
			return;
		}
		// Keyed, so several providers on one client leave exactly one copy of this
		// stateless rule rather than one per provider.
		this.restClient.addRetrySafetyHook(
			(pContext) =>
			{
				const tmpURL = (pContext && pContext.Options && pContext.Options.url) || '';
				return MEADOW_READ_ROUTE_PATTERN.test(tmpURL) ? true : undefined;
			}, 'PictMeadowReadSafety');
	}

	/**
	 * Register the provider's outcome classifier with the REST client.
	 *
	 * The hook delegates to `this.readRetryClassifier` at call time rather than capturing it, so a
	 * classifier assigned after construction -- which is the normal case, since fable settings
	 * cannot carry a function -- still takes effect, and everything sharing the client gets it.
	 *
	 * @return {void}
	 */
	_registerReadClassifierHook()
	{
		if (!this.restClient || (typeof this.restClient.addRetryClassifierHook !== 'function'))
		{
			return;
		}
		// Keyed per provider rather than per client: the safety rule above is
		// stateless and one copy serves everyone, but this hook delegates to a
		// specific provider's classifier, so two providers sharing a client must
		// each keep their own entry.
		this.restClient.addRetryClassifierHook(
			(pContext) =>
			{
				return (typeof this.readRetryClassifier === 'function') ? this.readRetryClassifier(pContext) : undefined;
			}, `PictMeadowReadClassifier::${this.UUID}`);
	}

	/**
	 * Decorate a GET read expressed as a bare URL. GET is already replayable under
	 * the RestClient's stock policy, so the URL is passed through untouched unless
	 * this provider carries its own retry configuration to apply -- which keeps the
	 * call shape (and every consumer spying on it) exactly as it was.
	 *
	 * @param {string} pURL - The read URL.
	 * @return {string|Record<string, any>} The URL, or an options object carrying the retry override.
	 */
	_decorateReadURL(pURL)
	{
		if (this.readRetryConfiguration === null && !this._legacyRetrySafeStamping)
		{
			return pURL;
		}
		return this._decorateReadRequestOptions({ url: pURL });
	}

	/**
	 * Normalize a step Projection into lite-read shaping. `Lite` and
	 * `LiteExtended` both map to a lite read; `LiteExtended` with no
	 * ExtraColumns degrades to a plain Lite read.
	 *
	 * @param {Record<string, any>} [pProjection] - Optional { Mode:'Lite'|'LiteExtended', ExtraColumns:[...] }.
	 * @return {{ ExtraColumns: string|null }|null} Lite-read shaping, or null for a full read.
	 */
	_resolveLiteProjection(pProjection)
	{
		if (!pProjection || (pProjection.Mode !== 'Lite' && pProjection.Mode !== 'LiteExtended'))
		{
			return null;
		}
		const tmpExtraColumns = (Array.isArray(pProjection.ExtraColumns) && pProjection.ExtraColumns.length > 0)
			? pProjection.ExtraColumns.join(',')
			: null;
		return { ExtraColumns: tmpExtraColumns };
	}

	/**
	 * Build the POST /:Entity/Query request body for a filtered read.
	 *
	 * @param {string} pMeadowFilterExpression - The meadow filter string (may be empty).
	 * @param {number|null} [pBegin] - Pagination start cursor.
	 * @param {number|null} [pCap] - Pagination page size.
	 * @param {Record<string, any>} [pProjection] - Optional { Mode:'Lite'|'LiteExtended', ExtraColumns:[...] }.
	 * @return {Record<string, any>} The request body envelope.
	 */
	_buildQueryReadBody(pMeadowFilterExpression, pBegin, pCap, pProjection)
	{
		/** @type {Record<string, any>} */
		const tmpBody = {};
		if (pMeadowFilterExpression)
		{
			tmpBody.Filter = pMeadowFilterExpression;
		}
		if (typeof pBegin === 'number')
		{
			tmpBody.Begin = pBegin;
		}
		if (typeof pCap === 'number')
		{
			tmpBody.Cap = pCap;
		}
		const tmpLiteProjection = this._resolveLiteProjection(pProjection);
		if (tmpLiteProjection)
		{
			// Lite/LiteExtended GET reads map to a Lite Query read; ExtraColumns
			// carries the LiteExtended column list when present.
			tmpBody.Lite = true;
			if (tmpLiteProjection.ExtraColumns)
			{
				tmpBody.ExtraColumns = tmpLiteProjection.ExtraColumns;
			}
		}
		return tmpBody;
	}

	/**
	 * Read a page of an entity set, using POST /:Entity/Query when supported and
	 * falling back to the legacy GET read otherwise. The callback mirrors
	 * restClient.getJSON exactly: (pError, pResponse, pBody).
	 *
	 * @param {string} pEntity - The entity name.
	 * @param {string} pMeadowFilterExpression - The meadow filter string (may be empty).
	 * @param {number|null} pBegin - Pagination start cursor (null for unpaged).
	 * @param {number|null} pCap - Pagination page size (null for unpaged).
	 * @param {Record<string, any>} pReadOptions - { SupportsQuery, URLPrefix, Postfix, Projection }.
	 * @param {(pError: Error|null, pResponse: any, pBody: any) => void} fCallback - Completion callback.
	 * @return {void}
	 */
	_readEntityPage(pEntity, pMeadowFilterExpression, pBegin, pCap, pReadOptions, fCallback)
	{
		const tmpURLPrefix = (pReadOptions && pReadOptions.URLPrefix) || this.options.urlPrefix;
		const tmpPostfix = (pReadOptions && pReadOptions.Postfix) || '';
		const tmpProjection = pReadOptions ? pReadOptions.Projection : null;

		if (tmpProjection && tmpProjection.Mode === 'Distinct' && Array.isArray(tmpProjection.Columns) && tmpProjection.Columns.length > 0)
		{
			if (pReadOptions && pReadOptions.SupportsQuery)
			{
				const tmpDistinctBody = this._buildQueryReadBody(pMeadowFilterExpression, pBegin, pCap, null);
				tmpDistinctBody.Distinct = true;
				tmpDistinctBody.Columns = tmpProjection.Columns.join(',');
				return this.restClient.postJSON(this._decorateReadRequestOptions({ url: `${tmpURLPrefix}${pEntity}s/Query${tmpPostfix}`, body: tmpDistinctBody }), fCallback);
			}
			const tmpDistinctFilterStanza = pMeadowFilterExpression ? `/FilteredTo/${pMeadowFilterExpression}` : '';
			const tmpDistinctPageStanza = (typeof pBegin === 'number' && typeof pCap === 'number') ? `/${pBegin}/${pCap}` : '';
			const tmpDistinctURL = `${tmpURLPrefix}${pEntity}s/Distinct/${tmpProjection.Columns.join(',')}${tmpDistinctFilterStanza}${tmpDistinctPageStanza}${tmpPostfix}`;
			return this.restClient.getJSON(this._decorateReadURL(tmpDistinctURL), fCallback);
		}

		if (pReadOptions && pReadOptions.SupportsQuery)
		{
			const tmpRequestOptions = this._decorateReadRequestOptions(
				{
					url: `${tmpURLPrefix}${pEntity}s/Query${tmpPostfix}`,
					body: this._buildQueryReadBody(pMeadowFilterExpression, pBegin, pCap, tmpProjection)
				});
			return this.restClient.postJSON(tmpRequestOptions, fCallback);
		}

		const tmpFilterStanza = pMeadowFilterExpression ? `/FilteredTo/${pMeadowFilterExpression}` : '';
		const tmpLiteProjection = this._resolveLiteProjection(tmpProjection);
		const tmpProjectionStanza = tmpLiteProjection
			? (tmpLiteProjection.ExtraColumns ? `/LiteExtended/${tmpLiteProjection.ExtraColumns}` : '/Lite')
			: '';
		const tmpPageStanza = (typeof pBegin === 'number' && typeof pCap === 'number') ? `/${pBegin}/${pCap}` : '';
		const tmpURL = `${tmpURLPrefix}${pEntity}s${tmpProjectionStanza}${tmpFilterStanza}${tmpPageStanza}${tmpPostfix}`;
		return this.restClient.getJSON(this._decorateReadURL(tmpURL), fCallback);
	}

	/**
	 * Read the count of an entity set, using POST /:Entity/Query (Count mode)
	 * when supported and the legacy GET Count otherwise. The callback mirrors
	 * restClient.getJSON: (pError, pResponse, pBody) where pBody carries .Count.
	 *
	 * @param {string} pEntity - The entity name.
	 * @param {string} pMeadowFilterExpression - The meadow filter string (may be empty).
	 * @param {Record<string, any>} pReadOptions - { SupportsQuery, URLPrefix, Postfix }.
	 * @param {(pError: Error|null, pResponse: any, pBody: any) => void} fCallback - Completion callback.
	 * @return {void}
	 */
	_readEntityCount(pEntity, pMeadowFilterExpression, pReadOptions, fCallback)
	{
		const tmpURLPrefix = (pReadOptions && pReadOptions.URLPrefix) || this.options.urlPrefix;
		const tmpPostfix = (pReadOptions && pReadOptions.Postfix) || '';

		if (pReadOptions && pReadOptions.SupportsQuery)
		{
			const tmpBody = this._buildQueryReadBody(pMeadowFilterExpression, null, null, null);
			tmpBody.Count = true;
			const tmpRequestOptions = this._decorateReadRequestOptions(
				{
					url: `${tmpURLPrefix}${pEntity}s/Query${tmpPostfix}`,
					body: tmpBody
				});
			return this.restClient.postJSON(tmpRequestOptions, fCallback);
		}

		const tmpFilterStanza = pMeadowFilterExpression ? `/FilteredTo/${pMeadowFilterExpression}` : '';
		const tmpURL = `${tmpURLPrefix}${pEntity}s/Count${tmpFilterStanza}${tmpPostfix}`;
		return this.restClient.getJSON(this._decorateReadURL(tmpURL), fCallback);
	}

	/**
	 * Compute the cache bucket key for an entity, optionally namespaced by a scope.
	 * A non-empty scope yields an isolated bucket (`Entity::Scope`) so scoped/partial
	 * (e.g. Lite) records never touch the global `Entity` cache that full-record
	 * consumers ({~E:~}, read views, pickers) rely on. Empty scope === today's key.
	 * @param {string} pEntity - The entity name.
	 * @param {string} [pScope] - Optional cache scope.
	 * @return {string} The cache bucket key.
	 */
	_cacheKey(pEntity, pScope)
	{
		return pScope ? `${pEntity}::${pScope}` : pEntity;
	}

	/**
	 * @param {string} pEntity - The name of the entity to initialize the cache for
	 * @param {string} [pScope] - Optional cache scope to namespace the bucket.
	 */
	initializeCache(pEntity, pScope = '')
	{
		const tmpCacheKey = this._cacheKey(pEntity, pScope);
		// This should not be happening as often as it's happening.
		if (!(tmpCacheKey in this.recordCache))
		{
			//@ts-ignore - FIXME - remove once we have fable types
			this.recordCache[tmpCacheKey] = this.fable.instantiateServiceProviderWithoutRegistration('ObjectCache');
			// TODO: Make this a configuration?
			// For now cache for 30 seconds.
			this.recordCache[tmpCacheKey].maxAge = 30000;
			this.recordCache[tmpCacheKey].maxLength = 10000;

			this.fable.Bundle[tmpCacheKey] = this.recordCache[tmpCacheKey].RecordMap;
		}
		// This should not be happening as often as it's happening.
		if (!(tmpCacheKey in this.recordSetCache))
		{
			//@ts-ignore - FIXME - remove once we have fable types
			this.recordSetCache[tmpCacheKey] = this.fable.instantiateServiceProviderWithoutRegistration('ObjectCache');
			// TODO: Make this a configuration?
			// For now cache for 10 seconds.
			this.recordSetCache[tmpCacheKey].maxAge = 10000;
			this.recordSetCache[tmpCacheKey].maxLength = 100;
		}
	}

	/**
	 * Clear every cache bucket (record + record-set + Bundle map) belonging to a
	 * scope. Recordset lists call this at the start of each load (fresh prefetch,
	 * no stale list data) and on CRUD invalidation.
	 * @param {string} pScope - The cache scope to clear.
	 */
	clearScope(pScope)
	{
		if (!pScope)
		{
			return;
		}
		const tmpSuffix = `::${pScope}`;
		for (const tmpKey of Object.keys(this.recordCache))
		{
			if (tmpKey.endsWith(tmpSuffix))
			{
				delete this.recordCache[tmpKey];
				delete this.fable.Bundle[tmpKey];
			}
		}
		for (const tmpKey of Object.keys(this.recordSetCache))
		{
			if (tmpKey.endsWith(tmpSuffix))
			{
				delete this.recordSetCache[tmpKey];
			}
		}
	}

	/**
	 * @param {object} pEntityInformation - The entity information object.
	 * @param {object} pContext - The context object to use when parsing the filter template and assigning the results to the destination.
	 * @param {() => void} fCallback - The callback function to call when the operation is complete, which should take an optional error as its first parameter.
	 */
	gatherEntitySetCount(pEntityInformation, pContext, fCallback)
	{
		pEntityInformation.CountOnly = true;
		return this.gatherEntitySet(pEntityInformation, pContext, fCallback);
	}

	/**
	 * @param {Record<string, any>} pEntityInformation - The entity information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing the filter template and assigning the results to the destination.
	 * @param {(pError?: Error) => void} fCallback - The callback function to call when the operation is complete, which should take an optional error as its first parameter and the record set or count as its second parameter.
	 */
	gatherEntitySet(pEntityInformation, pContext, fCallback)
	{
		// First sanity check the pEntityInformation
		if (!('Entity' in pEntityInformation) || (typeof(pEntityInformation.Entity) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain an Entity string.`);
			return fCallback();
		}
		if (!('Destination' in pEntityInformation) || (typeof(pEntityInformation.Destination) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Destination string.`);
			return fCallback();
		}
		if (!('Filter' in pEntityInformation) || (typeof(pEntityInformation.Filter) != 'string'))
		{
			pEntityInformation.Filter = '';
		}
		if (!('FilterData' in pEntityInformation) || (typeof(pEntityInformation.FilterData) != 'object'))
		{
			pEntityInformation.FilterData = {};
		}
		pContext.StepData = pEntityInformation.FilterData;
		if (!('RecordStartCursor' in pEntityInformation) || (typeof(pEntityInformation.RecordStartCursor) != 'number'))
		{
			pEntityInformation.RecordStartCursor = 0;
		}
		//TODO: consider ChunkSize for cases when AllRecords is set and we want to control the to-server page size
		if (!('PageSize' in pEntityInformation) || (typeof(pEntityInformation.PageSize) != 'number'))
		{
			//TODO: this is a safety measure to try and not break things when we release this pict version; should be a lower value
			pEntityInformation.PageSize = 10000;
		}
		if (!('AllRecords' in pEntityInformation) || (typeof(pEntityInformation.AllRecords) != 'boolean'))
		{
			pEntityInformation.AllRecords = false;
		}

		let tmpRecordStartCursor = null;
		let tmpPageSize = null;
		if (pEntityInformation.PageSize)
		{
			tmpRecordStartCursor = pEntityInformation.RecordStartCursor;
			tmpPageSize = pEntityInformation.PageSize;
		}
		// Parse the filter template
		const tmpFilterString = this.fable.parseTemplate(pEntityInformation.Filter, pContext);

		const tmpFilterLengthThreshold = (typeof this.options.largeFilterStringWarningThreshold === 'number') ? this.options.largeFilterStringWarningThreshold : 100000;
		if (tmpFilterString.length > tmpFilterLengthThreshold)
		{
			this.log.warn(`EntityBundleRequest filter for [${pEntityInformation.Entity}] expanded to ${tmpFilterString.length} characters from a ${pEntityInformation.Filter.length} character template.`);
		}

		// Create a callback function to handle receiving the record set
		const fRecordFetchComplete = (pError, pRecordSet) =>
		{
			if (pError)
			{
				if (pEntityInformation.Projection && pEntityInformation.Projection.Mode === 'Distinct')
				{
					this.log.warn(`EntityBundleRequest distinct read for [${pEntityInformation.Entity}] failed (${pError}); falling back to a full record read.`);
					const tmpFallbackInformation = Object.assign({}, pEntityInformation);
					delete tmpFallbackInformation.Projection;
					return this.gatherEntitySet(tmpFallbackInformation, pContext, fCallback);
				}
				this.log.error(`EntityBundleRequest request Error getting entity set for [${pEntityInformation.Entity}] with filter [${tmpFilterString}]: ${pError}`, pError);
				return fCallback(pError);
			}

			if (pEntityInformation.CountOnly)
			{
				this.log.trace(`EntityBundleRequest counted ${pRecordSet} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]${!pEntityInformation.CountOnly && !pEntityInformation.AllRecords ? ` [${tmpRecordStartCursor}/${tmpPageSize}]` : ''}`);

				this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, pRecordSet);
			}
			// Now assign it back to the destination; because this is not view specific it doesn't use the manifests from them (to deal with scope overlap with subgrids).
			else if (pEntityInformation.SingleRecord)
			{
				this.log.trace(`EntityBundleRequest found ${pRecordSet.length} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]${!pEntityInformation.CountOnly && !pEntityInformation.AllRecords ? ` [${tmpRecordStartCursor}/${tmpPageSize}]` : ''}`);

				if (pRecordSet.length > 1)
				{
					this.log.warn(`EntityBundleRequest found more than one record for ${pEntityInformation.Entity} filtered to [${tmpFilterString}] but SingleRecord is true; setting the first record.`);
				}
				if (pRecordSet.length < 1)
				{
					this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, false);
				}
				this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, pRecordSet[0]);
			}
			else
			{
				this.log.trace(`EntityBundleRequest found ${pRecordSet.length} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]${!pEntityInformation.CountOnly && !pEntityInformation.AllRecords ? ` [${tmpRecordStartCursor}/${tmpPageSize}]` : ''}`);

				this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, pRecordSet);
			}

			return fCallback();
		};
		if (pEntityInformation.CountOnly)
		{
			this.getEntitySetRecordCount(pEntityInformation.Entity, tmpFilterString, fRecordFetchComplete, pEntityInformation.Postfix, pEntityInformation.URLPrefix);
		}
		else if (tmpPageSize && !pEntityInformation.AllRecords)
		{
			this.getEntitySetPage(pEntityInformation.Entity, tmpFilterString, tmpRecordStartCursor, tmpPageSize, fRecordFetchComplete, pEntityInformation.Postfix, pEntityInformation.URLPrefix, { Scope: pEntityInformation.Scope, Projection: pEntityInformation.Projection });
		}
		else
		{
			this.getEntitySet(pEntityInformation.Entity, tmpFilterString, fRecordFetchComplete, pEntityInformation.Postfix, pEntityInformation);
		}
	}

	/**
	 * @param {Record<string, any>} pDestinationEntity - The destination entity to map the join results to.
	 * @param {Record<string, any>} pCustomRequestInformation - The custom request information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing templates and resolving addresses.
	 */
	mapJoinSingleDestination(pDestinationEntity, pCustomRequestInformation, pContext)
	{
		const tmpSourceEntities = this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.JoinRecordSetAddress);
		if (!Array.isArray(tmpSourceEntities))
		{
			throw new Error(`EntityBundleRequest failed to map join because the source [${pCustomRequestInformation.JoinRecordSetAddress}] did not return an array.`);
		}

		const tmpSourceLookup = {};
		for (const tmpSourceEntity of tmpSourceEntities)
		{
			const tmpSourceJoinValue = tmpSourceEntity[pCustomRequestInformation.JoinValue];
			tmpSourceLookup[tmpSourceJoinValue] = tmpSourceEntity;
		}

		for (const tmpSourceEntity of tmpSourceEntities)
		{
			if (!tmpSourceEntity)
			{
				this.log.error(`EntityBundleRequest failed to map join because the source entity was not found in the source lookup.`);
				continue;
			}
			if (pCustomRequestInformation.BucketBy || pCustomRequestInformation.BucketByTemplate)
			{
				const tmpBucketValues = [];
				if (pCustomRequestInformation.BucketBy)
				{
					const tmpBucketByKeys = Array.isArray(pCustomRequestInformation.BucketBy) ? pCustomRequestInformation.BucketBy : [pCustomRequestInformation.BucketBy];
					for (const tmpBucketByKey of tmpBucketByKeys)
					{
						const tmpBucketValue = this.fable.manifest.getValueByHash(tmpSourceEntity, tmpBucketByKey);
						tmpBucketValues.push(tmpBucketValue);
					}
				}
				else
				{
					const tmpBucketByTemplates = Array.isArray(pCustomRequestInformation.BucketByTemplate) ? pCustomRequestInformation.BucketByTemplate : [pCustomRequestInformation.BucketByTemplate];
					for (const tmpBucketByTemplate of tmpBucketByTemplates)
					{
						const tmpBucketValue = this.fable.parseTemplate(tmpBucketByTemplate, tmpSourceEntity);
						if (tmpBucketValue)
						{
							tmpBucketValues.push(tmpBucketValue);
						}
					}
				}
				if (tmpBucketValues.length < 1)
				{
					if (this.fable.LogNoisiness > 0)
					{
						this.log.warn(`EntityBundleRequest failed to map join because no bucket values were found.`, { pCustomRequestInformation, tmpSourceEntity });
					}
				}
				else
				{
					const tmpBucketAddress = `${pCustomRequestInformation.RecordDestinationAddress}.${tmpBucketValues.join('.')}`;
					if (pCustomRequestInformation.SingleRecord)
					{
						//TODO: warn if there is a collision?
						this.fable.manifest.setValueByHash(pDestinationEntity, tmpBucketAddress, tmpSourceEntity);
					}
					else
					{
						let tmpBucketArray = this.fable.manifest.getValueByHash(pDestinationEntity, tmpBucketAddress, tmpSourceEntity);
						if (!tmpBucketArray)
						{
							tmpBucketArray = [];
							this.fable.manifest.setValueByHash(pDestinationEntity, tmpBucketAddress, tmpBucketArray);
						}
						tmpBucketArray.push(tmpSourceEntity);
					}
				}
			}
			else if (pCustomRequestInformation.SingleRecord)
			{
				if (pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] && this.fable.LogNoisiness > 1)
				{
					this.fable.log.warn(`EntityBundleRequest found more than one record for [${pCustomRequestInformation.RecordDestinationAddress}] in mapJoin mapped as SingleRecord.`);
				}
				pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = tmpSourceEntity;
			}
			else
			{
				pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] || [];
				pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress].push(tmpSourceEntity);
			}
		}
		return [pDestinationEntity];
	}

	/**
	 * @param {Record<string, any>} pCustomRequestInformation - The custom request information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing templates and resolving addresses.
	 */
	mapJoin(pCustomRequestInformation, pContext)
	{
		const tmpSingleDestinationEntity = pCustomRequestInformation.DestinationRecordAddress ? this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.DestinationRecordAddress) : null;
		const tmpDestinationEntities = pCustomRequestInformation.DestinationRecordSetAddress ? this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.DestinationRecordSetAddress) : null;
		if (!Array.isArray(tmpDestinationEntities) && !tmpSingleDestinationEntity)
		{
			throw new Error(`EntityBundleRequest failed to map join because the destination [${pCustomRequestInformation.DestinationRecordSetAddress}] did not return an array.`);
		}
		if (tmpSingleDestinationEntity)
		{
			return this.mapJoinSingleDestination(tmpSingleDestinationEntity, pCustomRequestInformation, pContext);
		}

		const tmpJoinEntities = this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.Joins);
		if (!Array.isArray(tmpJoinEntities))
		{
			throw new Error(`EntityBundleRequest failed to map join because the join [${pCustomRequestInformation.Joins}] did not return an array.`);
		}
		const tmpSourceEntities = this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.JoinRecordSetAddress);
		if (!Array.isArray(tmpSourceEntities))
		{
			throw new Error(`EntityBundleRequest failed to map join because the source [${pCustomRequestInformation.JoinRecordSetAddress}] did not return an array.`);
		}

		const tmpLHSJoinKey = pCustomRequestInformation.JoinJoinValueLHS || pCustomRequestInformation.DestinationJoinValue;
		const tmpRHSJoinKey = pCustomRequestInformation.JoinJoinValueRHS || pCustomRequestInformation.JoinValue;
		const tmpDestinationLookup = {};
		const tmpSourceLookup = {};
		const tmpJoinMap = {};
		for (const tmpDestinationEntity of tmpDestinationEntities || [])
		{
			const tmpDestinationJoinValue = tmpDestinationEntity[pCustomRequestInformation.DestinationJoinValue];
			tmpDestinationLookup[tmpDestinationJoinValue] = tmpDestinationEntity;
		}
		for (const tmpSourceEntity of tmpSourceEntities)
		{
			const tmpSourceJoinValue = tmpSourceEntity[pCustomRequestInformation.JoinValue];
			tmpSourceLookup[tmpSourceJoinValue] = tmpSourceEntity;
		}

		for (const tmpJoinEntity of tmpJoinEntities)
		{
			const tmpLHSJoinValue = tmpJoinEntity[tmpLHSJoinKey];
			const tmpRHSJoinValue = tmpJoinEntity[tmpRHSJoinKey];
			tmpJoinMap[tmpLHSJoinValue] = tmpJoinMap[tmpLHSJoinValue] || new Set();
			tmpJoinMap[tmpLHSJoinValue].add(tmpRHSJoinValue);
		}

		for (const tmpLHSJoinValue of Object.keys(tmpJoinMap))
		{
			const tmpRHSJoinValues = Array.from(tmpJoinMap[tmpLHSJoinValue]);
			const tmpDestinationEntity = tmpDestinationLookup[tmpLHSJoinValue];
			if (!tmpDestinationEntity)
			{
				this.log.error(`EntityBundleRequest failed to map join because the LHS join value [${tmpLHSJoinValue}] was not found in the destination lookup.`);
				continue;
			}
			for (const tmpRHSJoinValue of tmpRHSJoinValues)
			{
				const tmpSourceEntity = tmpSourceLookup[tmpRHSJoinValue];
				if (!tmpSourceEntity)
				{
					this.log.error(`EntityBundleRequest failed to map join because the RHS join value [${tmpRHSJoinValue}] was not found in the source lookup.`);
					continue;
				}
				if (pCustomRequestInformation.BucketBy || pCustomRequestInformation.BucketByTemplate)
				{
					const tmpBucketValues = [];
					if (pCustomRequestInformation.BucketBy)
					{
						const tmpBucketByKeys = Array.isArray(pCustomRequestInformation.BucketBy) ? pCustomRequestInformation.BucketBy : [pCustomRequestInformation.BucketBy];
						for (const tmpBucketByKey of tmpBucketByKeys)
						{
							const tmpBucketValue = this.fable.manifest.getValueByHash(tmpSourceEntity, tmpBucketByKey);
							tmpBucketValues.push(tmpBucketValue);
						}
					}
					else
					{
						const tmpBucketByTemplates = Array.isArray(pCustomRequestInformation.BucketByTemplate) ? pCustomRequestInformation.BucketByTemplate : [pCustomRequestInformation.BucketByTemplate];
						for (const tmpBucketByTemplate of tmpBucketByTemplates)
						{
							const tmpBucketValue = this.fable.parseTemplate(tmpBucketByTemplate, tmpSourceEntity);
							tmpBucketValues.push(tmpBucketValue);
						}
					}
					if (!tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress])
					{
						tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = {};
					}
					const tmpBucketAddress = `${pCustomRequestInformation.RecordDestinationAddress}.${tmpBucketValues.join('.')}`;
					if (pCustomRequestInformation.SingleRecord)
					{
						//TODO: warn if there is a collision?
						this.fable.manifest.setValueByHash(tmpDestinationEntity, tmpBucketAddress, tmpSourceEntity);
					}
					else
					{
						let tmpBucketArray = this.fable.manifest.getValueByHash(tmpDestinationEntity, tmpBucketAddress, tmpSourceEntity);
						if (!tmpBucketArray)
						{
							tmpBucketArray = [];
							this.fable.manifest.setValueByHash(tmpDestinationEntity, tmpBucketAddress, tmpBucketArray);
						}
						tmpBucketArray.push(tmpSourceEntity);
					}
				}
				else if (pCustomRequestInformation.SingleRecord)
				{
					if (tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] && this.fable.LogNoisiness > 1)
					{
						this.fable.log.warn(`EntityBundleRequest found more than one record for [${pCustomRequestInformation.RecordDestinationAddress}] in mapJoin mapped as SingleRecord.`);
					}
					tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = tmpSourceEntity;
				}
				else
				{
					tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] || [];
					tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress].push(tmpSourceEntity);
				}
			}
		}
		return tmpDestinationEntities;
	}

	/**
	 * ExampleConfig:
	 * {
	 *      "InputRecordsetAddress": "AppData.DocumentData.ReportData.Observations[]<<~?ObservationType,==,WalbecNDTRollerTests?~>>",
	 *      "OutputRecordsetAddress": "AppData.DocumentData.ReportData.FormData.ADDTests",
	 * 		"OutputRecordsetAddressMapping":
	 *      {
	 * 			"InputRecord.Tags[],AnyContains,HR": "AppData.DocumentData.ReportData.FormData.HRTests",
	 * 			"InputRecord.Tags[],AnyContains,CR": "AppData.DocumentData.ReportData.FormData.CRTests",
	 * 			"InputRecord.Tags[],AnyContains,IR": "AppData.DocumentData.ReportData.FormData.IRTests"
	 *      },
	 * 		"RecordPrototypeAddress": "OutputRecordSet[]<<~?IDObservation,==,{~D:InputRecord.IDObservation~}?~>>",
	 * 		"RecordFieldMapping":
	 *      {
	 * 			"AppData.DocumentData.ReportData.FormData.HRTests":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.Temp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.Density",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.Offset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          },
	 * 			"AppData.DocumentData.ReportData.FormData.CRTests":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.CRTemp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.CRDensity",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.CROffset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          },
	 * 			"AppData.DocumentData.ReportData.FormData.IRTests":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.IRTemp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.IRDensity",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.IROffset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          },
	 *          "Default":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.ADDTemp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.ADDDensity",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.ADDOffset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          }
	 *      }
	 * }
	 *
	 * @param {Record<string, any>} pConfiguration - The configuration object for the dataset projection.
	 * @param {Record<string, any>} pContext - The context object to use when parsing the record prototype template and resolving the output recordset address mapping.
	 */
	projectDataset(pConfiguration, pContext)
	{
		let tmpInputRecordset = this.fable.manifest.getValueByHash(pContext, pConfiguration.InputRecordsetAddress);
		if (tmpInputRecordset == null || typeof tmpInputRecordset !== 'object')
		{
			throw new Error(`EntityBundleRequest failed to project dataset because the input recordset [${pConfiguration.InputRecordsetAddress}] did not return an valid object.`);
		}
		if (!Array.isArray(tmpInputRecordset))
		{
			tmpInputRecordset = [ tmpInputRecordset ];
		}
		let tmpDefaultOutputRecordset = this.fable.manifest.getValueByHash(pContext, pConfiguration.OutputRecordsetAddress);
		if (!tmpDefaultOutputRecordset)
		{
			tmpDefaultOutputRecordset = [];
			this.fable.manifest.setValueByHash(pContext, pConfiguration.OutputRecordsetAddress, tmpDefaultOutputRecordset);
		}
		for (const tmpInputRecord of tmpInputRecordset)
		{
			let tmpOutputRecordset = tmpDefaultOutputRecordset;
			let tmpOutputRecordsetAddressOverride;
			if (typeof pConfiguration.OutputRecordsetAddressMapping === 'object')
			{
				tmpOutputRecordsetAddressOverride = this._resolveOutputRecordsetAddressMapping(pConfiguration, pContext, tmpInputRecord);
				if (tmpOutputRecordsetAddressOverride)
				{
					tmpOutputRecordset = this.fable.manifest.getValueByHash(pContext, tmpOutputRecordsetAddressOverride);
					if (!tmpOutputRecordset)
					{
						tmpOutputRecordset = [];
						this.fable.manifest.setValueByHash(pContext, tmpOutputRecordsetAddressOverride, tmpOutputRecordset);
					}
				}
				if (!tmpOutputRecordset || !Array.isArray(tmpOutputRecordset))
				{
					tmpOutputRecordset = tmpDefaultOutputRecordset;
				}
			}
			const tmpPrototypeAddress = this.fable.parseTemplate(pConfiguration.RecordPrototypeAddress, Object.assign({ InputRecord: tmpInputRecord }, pContext));
			const tmpRecordPrototype = this.fable.manifest.getValueByHash(Object.assign({ InputRecord: tmpInputRecord, OutputRecordset: tmpOutputRecordset }, pContext), tmpPrototypeAddress);
			let tmpOutputRecord = { };
			if (Array.isArray(tmpRecordPrototype) && tmpRecordPrototype.length > 0)
			{
				tmpOutputRecord = tmpRecordPrototype[0];
			}
			else
			{
				tmpOutputRecordset.push(tmpOutputRecord);
			}
			let tmpRecordFieldMapping = pConfiguration.RecordFieldMapping[tmpOutputRecordsetAddressOverride] || pConfiguration.RecordFieldMapping.Default;
			if (!tmpRecordFieldMapping)
			{
				tmpRecordFieldMapping = pConfiguration.RecordFieldMapping[Object.keys(pConfiguration.RecordFieldMapping)[0]];
			}
			if (!tmpRecordFieldMapping)
			{
				throw new Error(`EntityBundleRequest failed to project dataset because the record field mapping for [${tmpOutputRecordsetAddressOverride}] did not return a mapping.`);
			}
			for (const tmpInputFieldAddress of Object.keys(tmpRecordFieldMapping))
			{
				const tmpOutputFieldAddress = tmpRecordFieldMapping[tmpInputFieldAddress];
				const tmpInputFieldValue = this.fable.manifest.getValueByHash(Object.assign({ InputRecord: tmpInputRecord }, pContext), tmpInputFieldAddress);
				this.fable.manifest.setValueByHash(Object.assign({ OutputRecord: tmpOutputRecord }, pContext), tmpOutputFieldAddress, tmpInputFieldValue);
			}
		}
	}

	/**
	 * @param {Record<string, any>} pConfiguration - The configuration object for the dataset projection.
	 * @param {Record<string, any>} pContext - The context object to use when resolving the output recordset address mapping.
	 * @param {Record<string, any>} pInputRecord - The input record to use when resolving the output recordset address mapping.
	 *
	 * @return {string|null} - The resolved output recordset address, or null if no mapping was found.
	 */
	_resolveOutputRecordsetAddressMapping(pConfiguration, pContext, pInputRecord)
	{
		const tmpAddressSpace = Object.assign({ InputRecord: pInputRecord }, pContext);
		for (const tmpRule of Object.keys(pConfiguration.OutputRecordsetAddressMapping))
		{
			const [ tmpLHSAddress, tmpOperator, tmpMatchValue ] = tmpRule.split(',');
			const tmpLHS = this.fable.manifest.getValueByHash(tmpAddressSpace, tmpLHSAddress);
			if (!tmpLHS)
			{
				if (this.fable.LogNoisiness > 0)
				{
					this.log.warn(`EntityBundleRequest failed to project dataset because the LHS address [${tmpLHSAddress}] did not return a value.`);
				}
				continue;
			}
			switch (tmpOperator)
			{
				case 'AnyContains':
					if (!Array.isArray(tmpLHS))
					{
						//TODO: consider making this use objects as well?
						this.log.error(`EntityBundleRequest failed to project dataset because the LHS address [${tmpLHSAddress}] did not return an array.`);
						continue;
					}
					for (const tmpLHSValue of tmpLHS)
					{
						if (String(tmpLHSValue).includes(tmpMatchValue))
						{
							return pConfiguration.OutputRecordsetAddressMapping[tmpRule];
						}
					}
			}
		}
		return null;
	}

	/**
	 * @param {Record<string, any>} pCustomRequestInformation - The custom request information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing templates and resolving addresses.
	 * @param {(pError?: Error) => void} fCallback - The callback function to call when the operation is complete, which should take an optional error as its first parameter and the data set as its second parameter.
	 */
	gatherCustomDataSet(pCustomRequestInformation, pContext, fCallback)
	{
		// First sanity check the pCustomRequestInformation
		if (!('URL' in pCustomRequestInformation) || (typeof(pCustomRequestInformation.URL) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the stanza did not contain a URL string.`);
			return fCallback();
		}
		if (!('URLData' in pCustomRequestInformation) || (typeof(pCustomRequestInformation.URLData) != 'object'))
		{
			pCustomRequestInformation.URLData = {};
		}
		pContext.StepData = pCustomRequestInformation.URLData;
		// Parse the filter template
		const tmpURLTemplateString = this.fable.parseTemplate(pCustomRequestInformation.URL, pContext);
		if (tmpURLTemplateString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the entity Filter did not return a string for FilterBy`)
		}

		let tmpURLPrefix = '';
		// This will only be true if the "Host" is set.
		const tmpCustomURIHost = pCustomRequestInformation.Host ? pCustomRequestInformation.Host : false;
		// If "Host" is set, protocol and port are optional.
		const tmpCustomURIProtocol = pCustomRequestInformation.Protocol ? pCustomRequestInformation.Protocol : 'https';
		const tmpCustomURIPort = pCustomRequestInformation.Port ? pCustomRequestInformation.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.fable.EntityProvider.options.urlPrefix;
		}

		// Now get the records
		/** @type {(pError: Error | null, pResponse: any, pData: any) => void} */
		const callback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting data set for [${pCustomRequestInformation.Entity}] with filter [${tmpURLTemplateString}]: ${pError}`, pError);
				return fCallback(pError);
			}

			this.log.trace(`EntityBundleRequest completed request for ${pCustomRequestInformation.Entity} filtered to [${tmpURLTemplateString}]`);

			// Since this is a templated endpoint it can be used for logging etc.
			if (pCustomRequestInformation.Destination)
			{
				this.fable.manifest.setValueByHash(pContext, pCustomRequestInformation.Destination, pData);
			}

			return fCallback();
		};

		/** @type {Record<string, any>} */
		let tmpOptions = (
			{
				url: `${tmpURLPrefix}${tmpURLTemplateString}`
			});
		tmpOptions = this.fable.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.fable.EntityProvider.restClient.getJSON(tmpOptions, callback);
	}

	/**
	 * Local version of gatherDataFromServer that only support synchronous operations.
	 *
	 * @param {Array<Record<string, any>>} pEntitiesBundleDescription - The entity bundle description object.
	 */
	processBundle(pEntitiesBundleDescription)
	{
		if (!Array.isArray(pEntitiesBundleDescription))
		{
			this.log.error(`EntityBundleRequest failed to parse entity bundle request because the input was not an array.`);
			throw new Error('EntityBundleRequest failed to parse entity bundle request because the input was not an array.');
		}

		const tmpStateStack = [];
		let tmpState = {};

		for (const tmpEntityBundleEntry of pEntitiesBundleDescription)
		{
			try
			{
				switch (tmpEntityBundleEntry.Type)
				{
					case 'SetStateAddress':
						tmpStateStack.push(tmpState);
						tmpState = this.fable.manifest.getValueByHash(this.fable, tmpEntityBundleEntry.StateAddress);
						if (typeof tmpState === 'undefined')
						{
							tmpState = {};
							this.fable.manifest.setValueByHash(this.fable, tmpEntityBundleEntry.StateAddress, tmpState);
						}
						break;
					case 'PopState':
						if (tmpStateStack.length > 0)
						{
							tmpState = tmpStateStack.pop();
						}
						else
						{
							this.log.warn(`EntityBundleRequest encountered a PopState without a matching SetStateAddress.`);
						}
						break;
					case 'MapJoin':
						this.mapJoin(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
						break;
					case 'ProjectDataset':
						this.projectDataset(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
						break;
					default:
						this.log.error(`EntityBundleRequest encountered an unsupported type [${tmpEntityBundleEntry.Type}] in the entity bundle description.`);
				}
			}
			catch (pError)
			{
				this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, { Stack: pError.stack });
			}
		}
	}

	/**
	 * Gather data from the server returning a promise when it is complete.
	 *
	 * @param {Array<Record<string, any>>} pEntitiesBundleDescription - The entity bundle description object.
	 * @param {(error?: Error) => void} fCallback - The callback function to call when the data gathering is complete.
	 */
	/**
	 * Extract the set of destination addresses that a bundle step depends on.
	 *
	 * Scans the step's Filter, URL, and data-address properties for template
	 * references of the form:
	 *   - {~PJU:..^Field^SomeAddress~}  (primary-key join/unique)
	 *   - {~D:SomeAddress.Field~}        (data-address lookup)
	 *
	 * Also inspects MapJoin/ProjectDataset address properties for references
	 * to destinations produced by earlier steps.
	 *
	 * @param {Record<string, any>} pStep - A single entity bundle step.
	 * @return {Set<string>} - The set of destination address prefixes this step references.
	 */
	extractStepDependencies(pStep)
	{
		const tmpDependencies = new Set();

		// Collect all string fields that may contain template expressions
		const tmpTemplateFields = [];
		if (typeof pStep.Filter === 'string')
		{
			tmpTemplateFields.push(pStep.Filter);
		}
		if (typeof pStep.URL === 'string')
		{
			tmpTemplateFields.push(pStep.URL);
		}
		if (typeof pStep.BucketByTemplate === 'string')
		{
			tmpTemplateFields.push(pStep.BucketByTemplate);
		}

		/**
		 * Add a dependency address, stripping the Record. prefix if present.
		 * The Record. prefix is used in PJU/D templates because the template
		 * parser receives a context object with Record as a root property,
		 * but the actual data address is everything after Record.
		 *
		 * @param {string} pValue - The raw address from the template or step config.
		 */
		const addDependency = (pValue) =>
		{
			if (typeof pValue === 'string' && pValue.startsWith('Record.'))
			{
				tmpDependencies.add(pValue.substring('Record.'.length));
			}
			else
			{
				tmpDependencies.add(pValue);
			}
		};

		// Parse template references from Filter/URL strings
		for (const tmpField of tmpTemplateFields)
		{
			// Match {~PJU:..^Field^Address.Path~} — the address is after the last ^
			// Address characters include alphanumerics, dots, brackets, hyphens (e.g. State[Step-1])
			const tmpPJUMatches = tmpField.matchAll(/\^([^~}^]+)~\}/g);
			for (const tmpMatch of tmpPJUMatches)
			{
				addDependency(tmpMatch[1]);
			}
			// Match {~D:Address.Path.Field~}
			const tmpDMatches = tmpField.matchAll(/\{~D:([^~}]+)~\}/g);
			for (const tmpMatch of tmpDMatches)
			{
				addDependency(tmpMatch[1]);
			}
		}

		// MapJoin steps reference data from prior steps via address properties
		if (pStep.Type === 'MapJoin')
		{
			if (typeof pStep.DestinationRecordSetAddress === 'string')
			{
				addDependency(pStep.DestinationRecordSetAddress);
			}
			if (typeof pStep.DestinationRecordAddress === 'string')
			{
				addDependency(pStep.DestinationRecordAddress);
			}
			if (typeof pStep.Joins === 'string')
			{
				addDependency(pStep.Joins);
			}
			if (typeof pStep.JoinRecordSetAddress === 'string')
			{
				addDependency(pStep.JoinRecordSetAddress);
			}
		}

		// ProjectDataset steps reference input recordset addresses
		if (pStep.Type === 'ProjectDataset')
		{
			if (typeof pStep.InputRecordsetAddress === 'string')
			{
				// Strip any manyfest filter expression from the address
				const tmpCleanAddress = pStep.InputRecordsetAddress.split('[]')[0];
				addDependency(tmpCleanAddress);
			}
		}
		return tmpDependencies;
	}

	/**
	 * Build execution waves from a bundle description by analyzing inter-step
	 * dependencies. Steps within the same wave have no data dependencies on
	 * each other and can execute concurrently. Waves execute sequentially.
	 *
	 * SetStateAddress and PopState steps act as wave barriers — they always
	 * start a new wave and execute alone.
	 *
	 * @param {Array<Record<string, any>>} pEntitiesBundleDescription - The entity bundle description.
	 * @return {Array<Array<{Index: number, Step: Record<string, any>}>>} - An array of waves, each wave an array of {Index, Step} objects.
	 */
	buildBundleWaves(pEntitiesBundleDescription)
	{
		// First, annotate each step with its dependencies and destination
		const tmpAnnotatedSteps = [];
		for (let i = 0; i < pEntitiesBundleDescription.length; i++)
		{
			const tmpStep = pEntitiesBundleDescription[i];
			// MapJoin and ProjectDataset are synchronous steps that mutate records
			// in-place, creating implicit data dependencies that can't be reliably
			// detected from the step config alone. Force them to run sequentially.
			const tmpIsSyncMutation = (tmpStep.Type === 'MapJoin' || tmpStep.Type === 'ProjectDataset');
			tmpAnnotatedSteps.push({
				Index: i,
				Step: tmpStep,
				Destination: typeof tmpStep.Destination === 'string' ? tmpStep.Destination : null,
				Dependencies: this.extractStepDependencies(tmpStep),
				IsBarrier: (tmpStep.Type === 'SetStateAddress' || tmpStep.Type === 'PopState'),
				// Allow individual steps to opt out of parallel execution.
				// Sync mutation steps are always sequential unless explicitly overridden.
				ForceSequential: tmpIsSyncMutation ? (tmpStep.Parallel !== true) : (tmpStep.Parallel === false)
			});
		}

		const tmpWaves = [];
		const tmpResolved = new Set();
		const tmpRemaining = new Set(tmpAnnotatedSteps.map((pEntry) => { return pEntry.Index; }));

		while (tmpRemaining.size > 0)
		{
			const tmpWave = [];

			// Process steps in original order to find candidates for this wave
			for (const tmpIdx of tmpRemaining)
			{
				const tmpEntry = tmpAnnotatedSteps[tmpIdx];

				// Barrier steps always run alone in their own wave
				if (tmpEntry.IsBarrier)
				{
					if (tmpWave.length === 0)
					{
						tmpWave.push(tmpEntry);
					}
					// If we already have steps in this wave, the barrier starts the next wave
					break;
				}

				// If this wave already contains a barrier, stop adding
				if (tmpWave.length > 0 && tmpWave[0].IsBarrier)
				{
					break;
				}

				// Check if all dependencies are resolved
				let tmpDepsResolved = true;
				for (const tmpDep of tmpEntry.Dependencies)
				{
					// Check if any resolved destination is a prefix of (or equal to) this dependency
					let tmpFoundResolved = false;
					for (const tmpResolvedDest of tmpResolved)
					{
						if (tmpDep === tmpResolvedDest || tmpDep.startsWith(tmpResolvedDest + '.'))
						{
							tmpFoundResolved = true;
							break;
						}
					}
					if (tmpFoundResolved)
					{
						continue;
					}

					// Check if any unresolved step (remaining or current wave) produces this dependency.
					// If so, we cannot run this step yet.
					let tmpProducedByUnresolved = false;
					for (const tmpOtherIdx of tmpRemaining)
					{
						if (tmpOtherIdx === tmpEntry.Index)
						{
							continue;
						}
						const tmpOther = tmpAnnotatedSteps[tmpOtherIdx];
						if (tmpOther.Destination && (tmpDep === tmpOther.Destination || tmpDep.startsWith(tmpOther.Destination + '.')))
						{
							tmpProducedByUnresolved = true;
							break;
						}
					}
					// Also check steps already added to this wave
					if (!tmpProducedByUnresolved)
					{
						for (const tmpWaveEntry of tmpWave)
						{
							if (tmpWaveEntry.Destination && (tmpDep === tmpWaveEntry.Destination || tmpDep.startsWith(tmpWaveEntry.Destination + '.')))
							{
								tmpProducedByUnresolved = true;
								break;
							}
						}
					}
					if (tmpProducedByUnresolved)
					{
						tmpDepsResolved = false;
						break;
					}
					// Dependency refers to data not produced by any step (e.g. pre-seeded AppData);
					// treat as already available
				}

				if (!tmpDepsResolved)
				{
					continue;
				}

				// If this step forces sequential, it must be alone in its wave
				if (tmpEntry.ForceSequential)
				{
					if (tmpWave.length === 0)
					{
						tmpWave.push(tmpEntry);
						break;
					}
					// Otherwise skip it for now — it will be alone in a future wave
					continue;
				}

				tmpWave.push(tmpEntry);
			}

			// Safety valve: if we made no progress, force the next remaining step
			// to avoid an infinite loop (e.g. circular or unresolvable dependency)
			if (tmpWave.length === 0)
			{
				const tmpNextIdx = tmpRemaining.values().next().value;
				tmpWave.push(tmpAnnotatedSteps[tmpNextIdx]);
			}

			tmpWaves.push(tmpWave.map((pEntry) => { return { Index: pEntry.Index, Step: pEntry.Step }; }));

			for (const tmpEntry of tmpWave)
			{
				tmpRemaining.delete(tmpEntry.Index);
				if (tmpEntry.Destination)
				{
					tmpResolved.add(tmpEntry.Destination);
				}
			}
		}

		return tmpWaves;
	}

	gatherDataFromServer(pEntitiesBundleDescription, fCallback)
	{
		if (!Array.isArray(pEntitiesBundleDescription))
		{
			this.log.error(`EntityBundleRequest failed to parse entity bundle request because the input was not an array.`);
			return fCallback(new Error('EntityBundleRequest failed to parse entity bundle request because the input was not an array.'));
		}

		const tmpStateStack = [];
		let tmpState = {};

		// Build execution waves from the bundle description
		const tmpWaves = this.buildBundleWaves(pEntitiesBundleDescription);
		this.lastBundleWaves = tmpWaves;

		// The maximum number of concurrent requests per wave
		const tmpMaxConcurrency = (typeof this.options.maxBundleConcurrency === 'number') ? this.options.maxBundleConcurrency : 8;

		const tmpSlowStepThreshold = (typeof this.options.slowBundleStepWarningThreshold === 'number') ? this.options.slowBundleStepWarningThreshold : 2000;

		// Execute waves sequentially; steps within each wave run concurrently
		let tmpWaveIndex = 0;

		const fExecuteNextWave = () =>
		{
			if (tmpWaveIndex >= tmpWaves.length)
			{
				return fCallback();
			}

			const tmpWave = tmpWaves[tmpWaveIndex];
			tmpWaveIndex++;

			let tmpWaveAnticipate = this.fable.newAnticipate();
			tmpWaveAnticipate.maxOperations = Math.min(tmpWave.length, tmpMaxConcurrency);

			for (let w = 0; w < tmpWave.length; w++)
			{
				const tmpEntityBundleEntry = tmpWave[w].Step;
				tmpWaveAnticipate.anticipate(
					(fNext) =>
					{
						const tmpStepStartTime = Date.now();
						const fStepComplete = (pStepError) =>
						{
							const tmpStepElapsed = Date.now() - tmpStepStartTime;
							if (tmpStepElapsed > tmpSlowStepThreshold)
							{
								this.log.warn(`EntityBundleRequest step [${tmpEntityBundleEntry.Type || 'MeadowEntity'}]${tmpEntityBundleEntry.Entity ? ` for [${tmpEntityBundleEntry.Entity}]` : ''} took ${tmpStepElapsed}ms (destination [${tmpEntityBundleEntry.Destination || tmpEntityBundleEntry.StateAddress || ''}]).`);
							}
							return fNext(pStepError);
						};
						try
						{
							switch (tmpEntityBundleEntry.Type)
							{
								case 'SetStateAddress':
									tmpStateStack.push(tmpState);
									tmpState = this.fable.manifest.getValueByHash(this.fable, tmpEntityBundleEntry.StateAddress);
									if (typeof tmpState === 'undefined')
									{
										tmpState = {};
										this.fable.manifest.setValueByHash(this.fable, tmpEntityBundleEntry.StateAddress, tmpState);
									}
									return fStepComplete();
								case 'PopState':
									if (tmpStateStack.length > 0)
									{
										tmpState = tmpStateStack.pop();
									}
									else
									{
										this.log.warn(`EntityBundleRequest encountered a PopState without a matching SetStateAddress.`);
									}
									return fStepComplete();
								case 'Custom':
									return this.gatherCustomDataSet(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry), fStepComplete);
								case 'MapJoin':
									this.mapJoin(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
									return fStepComplete();
								case 'ProjectDataset':
									this.projectDataset(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
									return fStepComplete();
								// This is the default case, for a meadow entity set or single entity
								case 'MeadowEntityCount':
									return this.gatherEntitySetCount(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry), fStepComplete);
								case 'MeadowEntity':
								default:
									return this.gatherEntitySet(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry), fStepComplete);
							}
						}
						catch (pError)
						{
							this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, { Stack: pError.stack });
							return fStepComplete();
						}
					});
			}

			tmpWaveAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, { Stack: pError.stack });
						return fCallback(pError);
					}
					return fExecuteNextWave();
				});
		};

		fExecuteNextWave();
	}

	/**
	 * Creates a wrapper state object to allow referencing common global state in addition to flow-state.
	 *
	 * @param {Record<string, any>} pState - The state object to prepare.
	 * @param {any} [pStepConfiguration] - (optional) The step configuration object provided in the config, if any.
	 * @return {Record<string, any>} - The prepared state object.
	 */
	prepareState(pState, pStepConfiguration)
	{
		return {
			State: pState,
			AppData: this.fable.AppData,
			Bundle: this.fable.Bundle,
			Pict: this.fable,
			Fable: this.fable,
			StepConfiguration: pStepConfiguration,
		};
	}

	/**
	 * @param {string} pEntity - The name of the entity to get.
	 * @param {string|number} pIDRecord - The ID of the record to get.
	 * @param {(pError?: Error, pRecord?: any) => void} fCallback - The callback function to call when the operation is complete.
	 */
	getEntity(pEntity, pIDRecord, fCallback, pScope = '')
	{
		this.initializeCache(pEntity, pScope);
		const tmpCacheKey = this._cacheKey(pEntity, pScope);
		// Discard anything from the cache that has expired or is over size.
		this.recordCache[tmpCacheKey].prune(
			function ()
			{
				let tmpPossibleRecord = this.recordCache[tmpCacheKey].read(pIDRecord);

				if (tmpPossibleRecord)
				{
					return fCallback(null, tmpPossibleRecord);
				}

				let tmpOptions = (
					{
						url: `${this.options.urlPrefix}${pEntity}/${pIDRecord}`
					});
				tmpOptions = this._decorateReadRequestOptions(this.prepareRequestOptions(tmpOptions));

				return this.restClient.getJSON(tmpOptions,
					(pError, pResponse, pBody) =>
					{
						/*
						 * FIXME: This breaks entity reads for nonexistent records. Putting this back for now until we can audit and fix all the places that may rely on this.
						if (pResponse && pResponse.statusCode && pResponse.statusCode >= 400)
						{
							this.log.error(`Error getting entity [${pEntity}] with ID [${pIDRecord}] from url [${tmpOptions.url}]: ${pResponse.statusCode} ${pResponse.statusMessage}`);
							return fCallback(new Error(`Error getting entity [${pEntity}] with ID [${pIDRecord}] from url [${tmpOptions.url}]: ${pResponse.statusCode} ${JSON.stringify(pBody || {})}`));
						}
						*/
						if (pBody)
						{
							this.recordCache[tmpCacheKey].put(pBody, pIDRecord);
						}
						return fCallback(pError, pBody);
					});
			}.bind(this));
	}

	/**
	 * For a given list of objects, cache connected entity records (use lazy loading of pages and not count requests).
	 *
	 * @param {Array} pRecordSet - An array of objects to check cache on joined records for, and, get/cache the records as needed.
	 * @param {Array} pIDListToCache - An array of property strings that are the ID fields to cache connected records for.
	 * @param {Array} pEntityListToCache - An array of entity names, which can override the speculative entity name derived from the ID field name.
	 * @param {boolean} pLiteRecords - If true, only cache lite records (ID and Name fields).
	 *
	 * @return {void}
	 */
	cacheConnectedEntityRecordsWithoutCount(pRecordSet, pIDListToCache, pEntityListToCache, pLiteRecords, fCallback, pScope = '')
	{
		//FIXME: pLiteRecords is ignored?
		if (!Array.isArray(pRecordSet) || pRecordSet.length < 1)
		{
			return fCallback();
		}

		if (!Array.isArray(pIDListToCache) || pIDListToCache.length < 1)
		{
			return fCallback();
		};

		const tmpAnticipate = this.fable.newAnticipate();

		const tmpEntityListToCache = pEntityListToCache || [];
		tmpAnticipate.maxOperations = 10;
		for (let i = 0; i < pIDListToCache.length; i++)
		{
			const tmpEntityIDSourceField = pIDListToCache[i];
			// If an entity name override is provided, use it, otherwise speculate the joined entity name ID field from the source ID field name.
			const tmpEntityName = tmpEntityListToCache[i] || tmpEntityIDSourceField.replace(/^ID/, '');
			const tmpIDField = `ID${tmpEntityName}`;

			// Make a set of IDs to fetch for this entity.
			const tmpEntityIDsToFetch = new Set();

			// Initialize the cache
			this.initializeCache(tmpEntityName, pScope);
			const tmpCacheKey = this._cacheKey(tmpEntityName, pScope);
			// Prune expired entries BEFORE reading: read() does not check TTL, so an
			// expired-but-unpruned entry reads as a hit and we'd wrongly skip the batch
			// fetch, only for the per-row getEntity (which prunes first) to miss and
			// fetch each one individually. prune is synchronous.
			this.recordCache[tmpCacheKey].prune(() => {});

			// First pass: gather IDs to fetch
			for (const tmpRecord of pRecordSet)
			{
				const tmpIDValue = tmpRecord[tmpEntityIDSourceField];
				if (tmpIDValue)
				{
					const tmpCachedRecord = this.recordCache[tmpCacheKey].read(tmpIDValue);
					if (!tmpCachedRecord)
					{
						tmpEntityIDsToFetch.add(tmpIDValue);
					}
				}
			}

			// Now if there are records to fetch, do the request.
			if (tmpEntityIDsToFetch.size > 0)
			{
				tmpAnticipate.anticipate(
					function (fRequestComplete)
					{
						const tmpIDRecordsArray = Array.from(tmpEntityIDsToFetch);
						this.getEntitySetByIDListChunked(tmpEntityName, tmpIDRecordsArray, { NoCount: true, Scope: pScope }, fRequestComplete);
					}.bind(this));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`cacheConnectedEntityRecords error gathering connected entity records: ${pError}`, { Stack: pError.stack });
					return fCallback(pError);
				}
				return fCallback();
			});
	}

	/**
	 * Fetch a set of entity records by primary-key ID list, chunking the meadow IN
	 * filter into requests.
	 *
	 * Chunk size is capability-aware: the legacy GET read embeds the IN-list in
	 * the URL, so it is chunked small (ConnectedEntityIDChunkSize, default 200) to
	 * keep the URL under HTTP/2 header-size limits — oversized URLs trip a
	 * connection-level reset that takes sibling multiplexed requests down with it.
	 * When the endpoint serves POST /:Entity/Query the IN-list rides in the body
	 * (no URI limit), so a much larger chunk is used (ConnectedEntityIDQueryChunkSize,
	 * default 5000) — bounding response size rather than URL length, and collapsing
	 * what used to be many small requests into one (or a few). Records are cached
	 * as a side effect of getEntitySet; the callback returns no data.
	 *
	 * @param {string} pEntityName - The entity name (e.g. 'Project').
	 * @param {Array<number|string>} pIDRecordsArray - The primary-key IDs to fetch.
	 * @param {Object} pOptions - Options passed through to getEntitySet (Scope, NoCount, URLPrefix, etc).
	 * @param {(error?: Error) => void} fCallback - Completion callback.
	 *
	 * @return {void}
	 */
	getEntitySetByIDListChunked(pEntityName, pIDRecordsArray, pOptions, fCallback)
	{
		if (!Array.isArray(pIDRecordsArray) || pIDRecordsArray.length < 1)
		{
			return fCallback();
		}

		const tmpOptions = pOptions || {};

		// Resolve transport capability once (cached; getEntitySet reuses it) so the
		// chunk size matches the transport. The probe URL prefix matches the one
		// getEntitySet will read from tmpOptions.URLPrefix.
		this.resolveEntityQuerySupport(pEntityName, tmpOptions.URLPrefix,
			(pSupportError, pSupportsQuery) =>
			{
				const tmpChunkSize = pSupportsQuery
					? ((this.options && this.options.ConnectedEntityIDQueryChunkSize) || 5000)
					: ((this.options && this.options.ConnectedEntityIDChunkSize) || 200);

				const tmpAnticipate = this.fable.newAnticipate();

				for (let i = 0; i < pIDRecordsArray.length; i += tmpChunkSize)
				{
					const tmpIDChunk = pIDRecordsArray.slice(i, i + tmpChunkSize);
					tmpAnticipate.anticipate(
						function (fChunkComplete)
						{
							const tmpMeadowFilterExpression = `FBL~ID${pEntityName}~INN~${tmpIDChunk.join(',')}`;
							this.getEntitySet(pEntityName, tmpMeadowFilterExpression,
								(pError) =>
								{
									if (pError)
									{
										this.log.error(`getEntitySetByIDListChunked error getting connected entity records for [${pEntityName}] with IDs [${tmpIDChunk.join(',')}]: ${pError}`, { Stack: pError.stack });
										return fChunkComplete(pError);
									}
									return fChunkComplete();
								}, null, tmpOptions);
						}.bind(this));
				}

				tmpAnticipate.wait(fCallback);
			});
	}

	/**
	 * For a given list of objects, cache connected entity records.
	 *
	 * @param {Array} pRecordSet - An array of objects to check cache on joined records for, and, get/cache the records as needed.
	 * @param {Array} pIDListToCache - An array of property strings that are the ID fields to cache connected records for.
	 * @param {Array} pEntityListToCache - An array of entity names, which can override the speculative entity name derived from the ID field name.
	 * @param {boolean} pLiteRecords - If true, only cache lite records (ID and Name fields).
	 *
	 * @return {void}
	 */
	cacheConnectedEntityRecords(pRecordSet, pIDListToCache, pEntityListToCache, pLiteRecords, fCallback, pScope = '')
	{
		//FIXME: pLiteRecords is ignored?
		if (!Array.isArray(pRecordSet) || pRecordSet.length < 1)
		{
			return fCallback();
		}

		if (!Array.isArray(pIDListToCache) || pIDListToCache.length < 1)
		{
			return fCallback();
		};

		const tmpAnticipate = this.fable.newAnticipate();

		const tmpEntityListToCache = pEntityListToCache || [];

		for (let i = 0; i < pIDListToCache.length; i++)
		{
			const tmpEntityIDSourceField = pIDListToCache[i];
			// If an entity name override is provided, use it, otherwise speculate the joined entity name ID field from the source ID field name.
			const tmpEntityName = tmpEntityListToCache[i] || tmpEntityIDSourceField.replace(/^ID/, '');
			const tmpIDField = `ID${tmpEntityName}`;

			// Make a set of IDs to fetch for this entity.
			const tmpEntityIDsToFetch = new Set();

			// Initialize the cache
			this.initializeCache(tmpEntityName, pScope);
			const tmpCacheKey = this._cacheKey(tmpEntityName, pScope);
			// Prune expired entries BEFORE reading: read() does not check TTL, so an
			// expired-but-unpruned entry reads as a hit and we'd wrongly skip the batch
			// fetch, only for the per-row getEntity (which prunes first) to miss and
			// fetch each one individually. prune is synchronous.
			this.recordCache[tmpCacheKey].prune(() => {});

			// First pass: gather IDs to fetch
			for (const tmpRecord of pRecordSet)
			{
				const tmpIDValue = tmpRecord[tmpEntityIDSourceField];
				if (tmpIDValue)
				{
					const tmpCachedRecord = this.recordCache[tmpCacheKey].read(tmpIDValue);
					if (!tmpCachedRecord)
					{
						tmpEntityIDsToFetch.add(tmpIDValue);
					}
				}
			}

			// Now if there are records to fetch, do the request.
			if (tmpEntityIDsToFetch.size > 0)
			{
				tmpAnticipate.anticipate(
					function (fRequestComplete)
					{
						const tmpIDRecordsArray = Array.from(tmpEntityIDsToFetch);
						this.getEntitySetByIDListChunked(tmpEntityName, tmpIDRecordsArray, { Scope: pScope }, fRequestComplete);
					}.bind(this));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`cacheConnectedEntityRecords error gathering connected entity records: ${pError}`, { Stack: pError.stack });
					return fCallback(pError);
				}
				return fCallback();
			});
	}

	/**
	 * Cache an array of records, likely from a meadow endpoint
	 *
	 * @param {string} pEntity - The entity type to cache individual records for
	 * @param {Array<Record<string, any>>} pRecordSet - An array of records to cache
	 */
	cacheIndividualEntityRecords(pEntity, pRecordSet, pScope = '')
	{
		this.initializeCache(pEntity, pScope);
		const tmpCacheKey = this._cacheKey(pEntity, pScope);

		const tmpEntitySet = pRecordSet;

		if (Array.isArray(tmpEntitySet) && tmpEntitySet.length > 0)
		{
			// Cache each record individually.
			// This code is here because the downstream getEntitySet function uses this to load records, so both are covered here.
			const tmpSpeculativeRecordIDColumn = `ID${pEntity}`;
			if (tmpEntitySet[0] && typeof tmpEntitySet[0] === 'object' && tmpSpeculativeRecordIDColumn in tmpEntitySet[0])
			{
				for (let i = 0; i < tmpEntitySet.length; i++)
				{
					const tmpRecord = tmpEntitySet[i];
					const tmpIDRecord = tmpRecord[tmpSpeculativeRecordIDColumn];
					if (tmpIDRecord)
					{
						this.recordCache[tmpCacheKey].put(tmpRecord, tmpIDRecord);
					}
				}
			}
		}
	}

	/**
	 * @param {string} pEntity - The name of the entity to get.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {number} pRecordStartCursor - The starting cursor for record pagination.
	 * @param {number} pRecordCount - The number of records to return for pagination.
	 * @param {(pError?: Error, pEntitySet?: Array<Record<string, any>>) => void} fCallback - The callback function to call when the operation is complete.
	 * @param {string} [postfix] - Optional, adds a postfix string to the url.
	 * @param {string} [pURLPrefix] - Optional per-request URL prefix; overrides the provider default (e.g. a private-data-lake route).
	 * @param {Record<string, any>} [pOptions] - Optional { Scope, Projection }: cache scope and Lite/LiteExtended projection.
	 */
	getEntitySetPage(pEntity, pMeadowFilterExpression, pRecordStartCursor, pRecordCount, fCallback, postfix = '', pURLPrefix = '', pOptions = {})
	{
		const tmpScope = (pOptions && pOptions.Scope) ? pOptions.Scope : '';
		// Per-request URL prefix override (positional, e.g. a private-data-lake route);
		// also accepted via pOptions.URLPrefix. Falls back to the provider default.
		const tmpURLPrefix = pURLPrefix || (pOptions && pOptions.URLPrefix) || this.options.urlPrefix;
		// LiteExtended projection: fetch only ID/GUID/owner/update + the requested
		// ExtraColumns (drops blob columns). Used by scoped list fetches to avoid the
		// heavy full-record payload.
		const tmpProjection = (pOptions && pOptions.Projection) ? pOptions.Projection : null;

		this.resolveEntityQuerySupport(pEntity, tmpURLPrefix,
			(pSupportError, pSupportsQuery) =>
			{
				this._readEntityPage(pEntity, pMeadowFilterExpression, pRecordStartCursor, pRecordCount,
					{ SupportsQuery: pSupportsQuery, URLPrefix: tmpURLPrefix, Postfix: postfix || '', Projection: tmpProjection },
					(pDownloadError, pDownloadResponse, pDownloadBody) =>
					{
						const tmpPageError = this._validateEntityPageResponse(pEntity, pMeadowFilterExpression,
							pDownloadError, pDownloadResponse, pDownloadBody, `[${pRecordStartCursor}/${pRecordCount}]`);
						if (tmpPageError)
						{
							return fCallback(tmpPageError);
						}

						// Do not cache projected (Lite/partial) records in the entity cache — a
						// partial record would shadow the full record for other consumers
						// (row-click View, {~E:~}). Projected fetches are rendered straight from
						// the list state and never need to be in the entity cache.
						if (!tmpProjection)
						{
							this.cacheIndividualEntityRecords(pEntity, pDownloadBody, tmpScope);
						}

						return fCallback(null, pDownloadBody);
					});
			});
	}

	/**
	 * @param {string} pEntity - The name of the entity to get the count of.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {(pError?: Error, pRecordCount?: number) => void} fCallback - The callback function to call when the operation is complete.
	 * @param {string} [postfix] - Optional, adds a postfix string to the count url
	 * @param {string} [pURLPrefix] - Optional per-request URL prefix; overrides the provider default.
	 */
	getEntitySetRecordCount(pEntity, pMeadowFilterExpression, fCallback, postfix = '', pURLPrefix = '')
	{
		this.resolveEntityQuerySupport(pEntity, pURLPrefix,
			(pSupportError, pSupportsQuery) =>
			{
				this._readEntityCount(pEntity, pMeadowFilterExpression,
					{ SupportsQuery: pSupportsQuery, URLPrefix: pURLPrefix || '', Postfix: postfix || '' },
					(pError, pResponse, pBody) =>
					{
						if (pResponse && pResponse.statusCode && pResponse.statusCode >= 400)
						{
							this.log.error(`Error getting entity count of [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${pResponse.statusCode} ${pResponse.statusMessage}`);
							return fCallback(new Error(`Error getting entity count of [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${pResponse.statusCode} ${JSON.stringify(pBody || {})}`));
						}
						if (pError)
						{
							this.log.error(`Error getting entity count of [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${pError}`);
							return fCallback(pError);
						}
						let tmpRecordCount = 0;
						if (pBody && pBody.Count)
						{
							tmpRecordCount = pBody.Count;
						}
						return fCallback(pError, tmpRecordCount);
					});
			});
	}

	/**
	 * @param {string} pEntity - The name of the entity to get.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {(pError?: Error, pEntitySet?: Array<Record<string, any>>) => void} fCallback - The callback function to call when the operation is complete.
	 */
	getEntitySetWithAutoCaching(pEntity, pMeadowFilterExpression, fCallback)
	{
		let tmpAnticipate = this.fable.newAnticipate();

		let tmpRequestState = {Entity: pEntity, MeadowFilterExpression: pMeadowFilterExpression, EntitySet: null};

		tmpAnticipate.anticipate(
			function(fNext)
			{
				this.getEntitySet(pEntity, pMeadowFilterExpression,
					(pError, pEntitySet) =>
					{
						if (pError)
						{
							this.log.error(`getEntitySetWithAutoCaching error getting entity set for [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${pError}`, { Stack: pError.stack });
							return fNext(pError);
						}
						tmpRequestState.EntitySet = pEntitySet;
						return fNext();
					});
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Now see if we can infer some entities from this set to cache individual records for.
				if ((typeof(tmpRequestState.EntitySet) == 'object') && Array.isArray(tmpRequestState.EntitySet) && (tmpRequestState.EntitySet.length > 0))
				{
					// Look at each column and if it starts with `ID` and is longer than `ID` then speculate it is an entity join.
					const tmpFirstRecord = tmpRequestState.EntitySet[0];
					const tmpIDColumnsToCache = [];
					const tmpEntityNamesToCache = [];
					for (const tmpColumnName of Object.keys(tmpFirstRecord))
					{
						if ((tmpColumnName.startsWith('ID')) && (tmpColumnName.length > 2))
						{
							// Speculate this is an entity join.
							tmpIDColumnsToCache.push(tmpColumnName);
							const tmpSpeculatedEntityName = tmpColumnName.substring(2);
							tmpEntityNamesToCache.push(tmpSpeculatedEntityName);
						}
						// Mutate any `CreatingIDUser`, `UpdatingIDUser`, `DeletingIDUser` to the proper entiity
						else if (tmpColumnName in this.entityColumnTranslations)
						{
							tmpIDColumnsToCache.push(tmpColumnName);
							tmpEntityNamesToCache.push(this.entityColumnTranslations[tmpColumnName]);
						}
					}

					if (tmpIDColumnsToCache.length > 0)
					{
						return this.cacheConnectedEntityRecords(
							tmpRequestState.EntitySet,
							tmpIDColumnsToCache,
							tmpEntityNamesToCache,
							false,
							(pError) =>
							{
								if (pError)
								{
									this.log.error(`getEntitySetWithAutoCaching error caching connected entity records for [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${pError}`, { Stack: pError.stack });
									return fNext(pError);
								}
								return fNext();
							});
					}
					else
					{
						return fNext();
					}
				}
				else
				{
					return fNext();
				}
			}.bind(this));

		tmpAnticipate.wait(
			function (pError)
			{
				if (pError)
				{
					this.log.error(`getEntitySetWithAutoCaching error gathering entity set for [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${pError}`, { Stack: pError.stack });
					return fCallback(pError);
				}
				return fCallback(null, tmpRequestState.EntitySet);
			}.bind(this));
	}

	/**
	 * @param {string} pEntity - The entity to get a set of.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {(pError?: Error, pEntitySet?: Array) => void} fCallback - The callback to call when the request is complete.
	 * @param {string} [postfix] - Optional, adds a postfix string to all calls made.
	 * @param {Record<string, any>} [pOptions] - Optional, per-call options (e.g. { DownloadPageConcurrency: 1, Projection: { Mode: 'LiteExtended', ExtraColumns: [...] } }).
	 *
	 * @return {void}
	 */
	getEntitySet(pEntity, pMeadowFilterExpression, fCallback, postfix = '', pOptions = {})
	{
		const tmpURLPrefix = pOptions.URLPrefix || this.options.urlPrefix;
		const tmpScope = (pOptions && pOptions.Scope) ? pOptions.Scope : '';
		const tmpProjection = (pOptions && pOptions.Projection) ? pOptions.Projection : null;
		this.initializeCache(pEntity, tmpScope);
		const tmpCacheKey = this._cacheKey(pEntity, tmpScope);

		// Resolve transport capability once for the whole read (count + every
		// page share the same SupportsQuery flag). The legacy GET reads embed the
		// filter (and any large IN-list) in the URI, which is exactly the long-URI
		// failure POST /:Entity/Query avoids when the server supports it.
		this.resolveEntityQuerySupport(pEntity, tmpURLPrefix,
			(pSupportError, pSupportsQuery) =>
			{
				const tmpReadOptions = { SupportsQuery: pSupportsQuery, URLPrefix: tmpURLPrefix, Postfix: postfix || '', Projection: tmpProjection };

				// Discard anything from the cache that has expired or is over size.
				this.recordSetCache[tmpCacheKey].prune(
					function ()
					{
						let tmpPossibleRecords = this.recordSetCache[tmpCacheKey].read(pMeadowFilterExpression);

						if (tmpPossibleRecords)
						{
							return fCallback(null, tmpPossibleRecords);
						}
						if (pOptions.NoCount)
						{
							// Lazily load until we hit a not full page rather than using couns.
							// Does not respect parallelization.
							const pageSize = 250;
							let page = 0;
							let returnSet = [];
							const recursiveCallback = (pDownloadError, pDownloadResponse, pDownloadBody) =>
							{
								// A transport-level failure (e.g. connection reset, expired TLS
								// cert) calls back with no response, so guard every pDownloadResponse
								// deref and surface the underlying error rather than throwing a
								// TypeError on the missing statusCode.
								if (pDownloadError || (pDownloadResponse && pDownloadResponse.statusCode && pDownloadResponse.statusCode >= 400) || !Array.isArray(pDownloadBody))
								{
									const tmpStatusCode = pDownloadResponse ? pDownloadResponse.statusCode : 'no response';
									const tmpStatusDetail = pDownloadError ? (pDownloadError.message || pDownloadError) : (pDownloadResponse ? pDownloadResponse.statusMessage : '');
									this.log.error(`Error getting entity set of [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${tmpStatusCode} ${tmpStatusDetail}`);
									return fCallback(pDownloadError || new Error(`Error getting entity set of [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]: ${tmpStatusCode} ${JSON.stringify(pDownloadBody || {})}`), []);
								}

								returnSet = returnSet.concat(pDownloadBody);

								if (pDownloadBody?.length < pageSize)
								{
									// Do not cache projected (partial) records — see getEntitySetPage.
									if (!tmpProjection)
									{
										this.recordSetCache[tmpCacheKey].put(returnSet, pMeadowFilterExpression);
										this.cacheIndividualEntityRecords(pEntity, returnSet, tmpScope);
									}
									fCallback(null, returnSet);
								}
								else
								{
									page += 1;
									this._readEntityPage(pEntity, pMeadowFilterExpression, page * pageSize, pageSize, tmpReadOptions, recursiveCallback);
								}
							};
							return this._readEntityPage(pEntity, pMeadowFilterExpression, page * pageSize, pageSize, tmpReadOptions, recursiveCallback);
						}
						return this.getEntitySetRecordCount(pEntity, pMeadowFilterExpression,
							(pRecordCountError, pRecordCount) =>
							{
								if (pRecordCountError)
								{
									return fCallback(pRecordCountError);
								}
								let tmpRecordCount = pRecordCount;

								if (isNaN(pRecordCount))
								{
									this.log.error(`Entity count did not return a number for [${pEntity}] filtered to [${this._describeFilter(pMeadowFilterExpression)}]... something is fatally wrong from the server accessed in getEntitySet call.`);
									return fCallback(new Error('Entity count did not return a number in getEntitySet.'));
								}

								let tmpDownloadBatchSize = this.options.downloadBatchSize;
								if (tmpProjection && tmpProjection.Mode === 'Distinct')
								{
									// A distinct read returns at most one narrow row per distinct value;
									// fetch it as a single page (the row count bounds the distinct count)
									// rather than paging, which is unstable without a server-side sort.
									tmpDownloadBatchSize = Math.max(tmpRecordCount, 1);
								}
								const tmpPageCount = Math.ceil(tmpRecordCount / tmpDownloadBatchSize);

								const tmpLargeSetThreshold = (typeof this.options.largeRecordSetWarningThreshold === 'number') ? this.options.largeRecordSetWarningThreshold : 25000;
								if (tmpRecordCount > tmpLargeSetThreshold)
								{
									const tmpGatherShape = (tmpProjection && tmpProjection.Mode === 'Distinct')
										? `distinct [${tmpProjection.Columns.join(',')}] values from ${tmpRecordCount} [${pEntity}] rows`
										: `ALL ${tmpRecordCount} [${pEntity}] records (${tmpPageCount} pages of ${tmpDownloadBatchSize})`;
									this.log.warn(`EntityBundleRequest gathering ${tmpGatherShape} for filter [${pMeadowFilterExpression.length > 300 ? `${pMeadowFilterExpression.substring(0, 300)}…` : pMeadowFilterExpression}] into memory.`);
								}

								// Build an indexed array of page descriptors to preserve ordering
								const tmpPages = [];
								for (let i = 0; i < tmpPageCount; i++)
								{
									tmpPages.push({
										Index: i,
										Begin: i * tmpDownloadBatchSize,
										Records: null
									});
								}

								// Fetch pages concurrently and reassemble in order.
								// Per-call DownloadPageConcurrency overrides the provider-level default.
								const tmpPageConcurrency = (typeof pOptions.DownloadPageConcurrency === 'number')
									? pOptions.DownloadPageConcurrency
									: ((typeof this.options.downloadPageConcurrency === 'number') ? this.options.downloadPageConcurrency : 4);
								this.fable.Utility.eachLimit(tmpPages, tmpPageConcurrency,
									(pPage, fDownloadCallback) =>
									{
										this._readEntityPage(pEntity, pMeadowFilterExpression, pPage.Begin, tmpDownloadBatchSize, tmpReadOptions,
											(pDownloadError, pDownloadResponse, pDownloadBody) =>
											{
												const tmpPageError = this._validateEntityPageResponse(pEntity, pMeadowFilterExpression,
													pDownloadError, pDownloadResponse, pDownloadBody, `[${pPage.Begin}/${tmpDownloadBatchSize}]`);
												if (tmpPageError)
												{
													return fDownloadCallback(tmpPageError);
												}
												pPage.Records = pDownloadBody;
												return fDownloadCallback();
											});
									},
									(pFullDownloadError) =>
									{
										// Reassemble pages in index order to maintain consistent ordering
										let tmpEntitySet = [];
										for (let i = 0; i < tmpPages.length; i++)
										{
											if (Array.isArray(tmpPages[i].Records))
											{
												tmpEntitySet = tmpEntitySet.concat(tmpPages[i].Records);
											}
										}

										// Do not cache projected (partial) records — see getEntitySetPage.
										if (!tmpProjection)
										{
											if (tmpEntitySet)
											{
												this.recordSetCache[tmpCacheKey].put(tmpEntitySet, pMeadowFilterExpression);
											}

											this.cacheIndividualEntityRecords(pEntity, tmpEntitySet, tmpScope);
										}

										return fCallback(pFullDownloadError, tmpEntitySet);
									})
							}, postfix, pOptions.URLPrefix);
					}.bind(this));
			});
	}

	////////////////////////////////////////////////////////////////////////////////
	// Entity Creation and Update Methods
	/**
	 * @param {string} pEntityType - The type of the entity to format the URL for.
	 *
	 * @return {string} - The formatted URL for the given entity type.
	 */
	formatUrl(pEntityType)
	{
		return `${this.options.urlPrefix}${pEntityType}`;
	}


	/**
	 * Create a new entity record.
	 *
	 * @param {string} pEntityType - The entity type to create.
	 * @param {Record<string, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: Record<string, any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	createEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});

		this.restClient.postJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				const tmpWriteError = this._validateEntityWriteResponse('creating', pEntityType, '', pError, pResponse, pBody);
				if (tmpWriteError)
				{
					return fCallback(tmpWriteError, pBody);
				}
				this.log.info(`Created ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				return fCallback(null, pBody);
			});
	}

	/**
	 * Update an entity record.
	 *
	 * @param {string} pEntityType - The entity type to create.
	 * @param {Record<string, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: Record<string, any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	updateEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				const tmpWriteError = this._validateEntityWriteResponse('updating', pEntityType, '', pError, pResponse, pBody);
				if (tmpWriteError)
				{
					return fCallback(tmpWriteError, pBody);
				}
				this.log.info(`Updated ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				return fCallback(null, pBody);
			});
	}

	/**
	 * Upsert an entity record.
	 *
	 * @param {String} pEntityType - The entity type to be upserted.
	 * @param {Object<String, any>} pRecord - The record to upsert.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upsert`),
				body: pRecord
			});

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				const tmpWriteError = this._validateEntityWriteResponse('upserting', pEntityType, '', pError, pResponse, pBody);
				if (tmpWriteError)
				{
					return fCallback(tmpWriteError, pBody);
				}
				this.log.info(`Upserted ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				return fCallback(null, pBody);
			});
	}

	/**
	 * Upsert a array of entity records.
	 *
	 * @param {string} pEntityType - The entity type to be upserted.
	 * @param {Array<Record<string, any>>} pRecords - The records to upsert.
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntities(pEntityType, pRecords, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upserts`),
				body: pRecords
			});

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				const tmpWriteError = this._validateEntityWriteResponse('upserting', pEntityType, 'set', pError, pResponse, pBody);
				if (tmpWriteError)
				{
					return fCallback(tmpWriteError, pBody);
				}
				this.log.info(`Upserted multiple ${pEntityType} records (count: ${Array.isArray(pBody) ? pBody.length : 0})`);
				return fCallback(null, pBody);
			});
	}

	/**
	 * Delete an entity record.
	 *
	 * @param {string} pEntityType - The entity type to create.
	 * @param {string | Number} pIDRecord - The ID of the record to delete.
	 * @param {(pError?: Error, pResult?: Record<string, any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	deleteEntity(pEntityType, pIDRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/${pIDRecord}`),
			});

		this.restClient.delJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				const tmpWriteError = this._validateEntityWriteResponse('deleting', pEntityType, `ID ${pIDRecord}`, pError, pResponse, pBody);
				if (tmpWriteError)
				{
					return fCallback(tmpWriteError, pBody);
				}
				this.log.info(`Deleted ${pEntityType} record ID ${pIDRecord}`);
				return fCallback(null, pBody);
			});
	}
}

module.exports = PictMeadowEntityProvider;

},{"fable":71}],373:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

class PictTemplateAudit extends libFableServiceBase
{
	/**
	 * @param {import('pict')} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.serviceType = 'PictTemplateAudit';

		/** @type {import('pict') & { TemplateDebug?: boolean, TemplateDebugStack?: boolean }} */
		this.fable;

		// Array of root-level audit trees
		this.auditLog = [];
	}

	prepareAuditing()
	{
		// Install method wrappers on the Pict instance
		this._installWrappers();
	}

	/**
	 * Install audit wrappers around the 6 parseTemplate* methods on the Pict instance.
	 * Each wrapper checks this.fable.TemplateDebug and delegates to the original when disabled.
	 *
	 * @private
	 */
	_installWrappers()
	{
		let tmpPict = this.fable;
		let tmpAudit = this;

		// Save references to original methods
		this._originalParseTemplate = tmpPict.parseTemplate.bind(tmpPict);
		this._originalParseTemplateByHash = tmpPict.parseTemplateByHash.bind(tmpPict);
		this._originalParseTemplateSet = tmpPict.parseTemplateSet.bind(tmpPict);
		this._originalParseTemplateSetByHash = tmpPict.parseTemplateSetByHash.bind(tmpPict);
		this._originalParseTemplateSetWithPayload = tmpPict.parseTemplateSetWithPayload.bind(tmpPict);
		this._originalParseTemplateSetWithPayloadByHash = tmpPict.parseTemplateSetWithPayloadByHash.bind(tmpPict);

		// -- parseTemplate wrapper --
		tmpPict.parseTemplate = function _auditParseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState);
			}

			let tmpAuditPrep = tmpAudit.prepareState(pState, pTemplateString.substring(0, 80));
			let tmpState = tmpAuditPrep.state;
			let tmpAuditContext = tmpAudit.beginAudit(tmpState, tmpAuditPrep.identifier, 'parseTemplate', pData);

			if (typeof fCallback === 'function')
			{
				let tmpWrappedCallback = function _auditCallback(pError, pResult)
				{
					tmpAudit.endAudit(tmpState, tmpAuditContext);
					return fCallback(pError, pResult);
				};
				return tmpAudit._originalParseTemplate(pTemplateString, pData, tmpWrappedCallback, pContextArray, pScope, tmpState);
			}
			else
			{
				let tmpResult = tmpAudit._originalParseTemplate(pTemplateString, pData, null, pContextArray, pScope, tmpState);
				tmpAudit.endAudit(tmpState, tmpAuditContext);
				return tmpResult;
			}
		};

		// -- parseTemplateByHash wrapper --
		tmpPict.parseTemplateByHash = function _auditParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState);
			}

			let tmpState = tmpAudit.setHashHint(pState, pTemplateHash);
			return tmpAudit._originalParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, tmpState);
		};

		// -- parseTemplateSet wrapper --
		tmpPict.parseTemplateSet = function _auditParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState);
			}

			let tmpAuditPrep = tmpAudit.prepareState(pState, pTemplateString.substring(0, 80));
			let tmpState = tmpAuditPrep.state;
			let tmpAuditContext = tmpAudit.beginAudit(tmpState, tmpAuditPrep.identifier, 'parseTemplateSet', pDataSet);

			if (typeof fCallback === 'function')
			{
				let tmpWrappedCallback = function _auditSetCallback(pError, pResult)
				{
					tmpAudit.endAudit(tmpState, tmpAuditContext);
					return fCallback(pError, pResult);
				};
				return tmpAudit._originalParseTemplateSet(pTemplateString, pDataSet, tmpWrappedCallback, pContextArray, pScope, tmpState);
			}
			else
			{
				let tmpResult = tmpAudit._originalParseTemplateSet(pTemplateString, pDataSet, null, pContextArray, pScope, tmpState);
				tmpAudit.endAudit(tmpState, tmpAuditContext);
				return tmpResult;
			}
		};

		// -- parseTemplateSetByHash wrapper --
		tmpPict.parseTemplateSetByHash = function _auditParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState);
			}

			let tmpState = tmpAudit.setHashHint(pState, pTemplateHash);
			return tmpAudit._originalParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, tmpState);
		};

		// -- parseTemplateSetWithPayload wrapper --
		tmpPict.parseTemplateSetWithPayload = function _auditParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, fCallback, pContextArray, pScope, pState);
			}

			let tmpAuditPrep = tmpAudit.prepareState(pState, pTemplateString.substring(0, 80));
			let tmpState = tmpAuditPrep.state;
			let tmpAuditContext = tmpAudit.beginAudit(tmpState, tmpAuditPrep.identifier, 'parseTemplateSetWithPayload', pDataSet);

			if (typeof fCallback === 'function')
			{
				let tmpWrappedCallback = function _auditSetPayloadCallback(pError, pResult)
				{
					tmpAudit.endAudit(tmpState, tmpAuditContext);
					return fCallback(pError, pResult);
				};
				return tmpAudit._originalParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, tmpWrappedCallback, pContextArray, pScope, tmpState);
			}
			else
			{
				let tmpResult = tmpAudit._originalParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, null, pContextArray, pScope, tmpState);
				tmpAudit.endAudit(tmpState, tmpAuditContext);
				return tmpResult;
			}
		};

		// -- parseTemplateSetWithPayloadByHash wrapper --
		tmpPict.parseTemplateSetWithPayloadByHash = function _auditParseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, pState);
			}

			let tmpState = tmpAudit.setHashHint(pState, pTemplateHash);
			return tmpAudit._originalParseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, tmpState);
		};
	}

	unwrapTemplateFunctions()
	{
		let tmpPict = this.fable;

		if (this._originalParseTemplate && typeof(this._originalParseTemplate) === 'function')
		{
			tmpPict.parseTemplate = this._originalParseTemplate;
			this._originalParseTemplate = null;
		}

		if (this._originalParseTemplateByHash && typeof(this._originalParseTemplateByHash) === 'function')
		{
			tmpPict.parseTemplateByHash = this._originalParseTemplateByHash;
			this._originalParseTemplateByHash = null;
		}

		if (this._originalParseTemplateSet && typeof(this._originalParseTemplateSet) === 'function')
		{
			tmpPict.parseTemplateSet = this._originalParseTemplateSet;
			this._originalParseTemplateSet = null;
		}

		if (this._originalParseTemplateSetByHash && typeof(this._originalParseTemplateSetByHash) === 'function')
		{
			tmpPict.parseTemplateSetByHash = this._originalParseTemplateSetByHash;
			this._originalParseTemplateSetByHash = null;
		}

		if (this._originalParseTemplateSetWithPayload && typeof(this._originalParseTemplateSetWithPayload) === 'function')
		{
			tmpPict.parseTemplateSetWithPayload = this._originalParseTemplateSetWithPayload;
			this._originalParseTemplateSetWithPayload = null;
		}
	}

	/**
	 * Begin an audit node for template processing.
	 *
	 * @param {any} pState - The state object threading through template processing
	 * @param {string} pTemplateIdentifier - Hash or preview of the template
	 * @param {string} pEntrypoint - Name of the entry function
	 * @param {any} pData - The data passed to the template
	 *
	 * @return {object|null} The audit context, or null if auditing is disabled
	 */
	beginAudit(pState, pTemplateIdentifier, pEntrypoint, pData)
	{
		if (!this.fable.TemplateDebug)
		{
			return null;
		}

		let tmpAuditNode =
		{
			TemplateHash: pTemplateIdentifier,
			Entrypoint: pEntrypoint,
			StartTime: Date.now(),
			FinishTime: null,
			Duration: null,
			DataSize: (typeof pData === 'object' && pData !== null) ? JSON.stringify(pData).length : 0,
			StackTrace: null,
			ChildTemplates: []
		};

		if (this.fable.TemplateDebugStack)
		{
			tmpAuditNode.StackTrace = new Error().stack;
		}

		if (pState && pState._TemplateAuditParent)
		{
			// Child template -- append to parent
			pState._TemplateAuditParent.ChildTemplates.push(tmpAuditNode);
		}
		else
		{
			// Root-level template call
			this.auditLog.push(tmpAuditNode);
		}

		let tmpPreviousParent = (pState && pState._TemplateAuditParent) ? pState._TemplateAuditParent : null;
		if (pState)
		{
			pState._TemplateAuditParent = tmpAuditNode;
		}

		return { AuditNode: tmpAuditNode, PreviousParent: tmpPreviousParent };
	}

	/**
	 * End an audit node for template processing.
	 *
	 * @param {any} pState - The state object threading through template processing
	 * @param {object} pAuditContext - The object returned by beginAudit
	 */
	endAudit(pState, pAuditContext)
	{
		if (!pAuditContext)
		{
			return;
		}
		pAuditContext.AuditNode.FinishTime = Date.now();
		pAuditContext.AuditNode.Duration = pAuditContext.AuditNode.FinishTime - pAuditContext.AuditNode.StartTime;

		if (pState)
		{
			pState._TemplateAuditParent = pAuditContext.PreviousParent;
		}
	}

	/**
	 * Prepare pState for auditing, auto-creating if needed.
	 * Also consumes any _TemplateAuditHashHint to resolve the identifier.
	 *
	 * @param {any} pState - The current state object (may be null/undefined)
	 * @param {string} pFallbackIdentifier - Fallback identifier if no hash hint is set
	 *
	 * @return {{ state: any, identifier: string }} The prepared state and resolved identifier
	 */
	prepareState(pState, pFallbackIdentifier)
	{
		let tmpState = pState;
		if (this.fable.TemplateDebug && !tmpState)
		{
			tmpState = {};
		}

		let tmpIdentifier = pFallbackIdentifier;
		if (tmpState && tmpState._TemplateAuditHashHint)
		{
			tmpIdentifier = tmpState._TemplateAuditHashHint;
			delete tmpState._TemplateAuditHashHint;
		}

		return { state: tmpState, identifier: tmpIdentifier };
	}

	/**
	 * Set a hash hint on pState so the next audit node uses the hash name.
	 *
	 * @param {any} pState - The current state object (may be null/undefined)
	 * @param {string} pHash - The template hash to use as the identifier
	 *
	 * @return {any} The state object (auto-created if needed)
	 */
	setHashHint(pState, pHash)
	{
		let tmpState = pState;
		if (this.fable.TemplateDebug)
		{
			if (!tmpState) { tmpState = {}; }
			tmpState._TemplateAuditHashHint = pHash;
		}
		return tmpState;
	}

	/**
	 * Clear the audit log.
	 */
	clear()
	{
		this.auditLog = [];
	}

	/**
	 * Get a summary of the audit log.
	 *
	 * @return {object} Summary statistics
	 */
	getSummary()
	{
		let tmpTotalCalls = 0;
		let tmpTotalDuration = 0;
		let tmpMaxDepth = 0;

		let fWalkNode = (pNode, pDepth) =>
		{
			tmpTotalCalls++;
			tmpTotalDuration += (pNode.Duration || 0);
			if (pDepth > tmpMaxDepth)
			{
				tmpMaxDepth = pDepth;
			}
			for (let i = 0; i < pNode.ChildTemplates.length; i++)
			{
				fWalkNode(pNode.ChildTemplates[i], pDepth + 1);
			}
		};

		for (let i = 0; i < this.auditLog.length; i++)
		{
			fWalkNode(this.auditLog[i], 0);
		}

		return {
			RootCalls: this.auditLog.length,
			TotalCalls: tmpTotalCalls,
			TotalDuration: tmpTotalDuration,
			MaxDepth: tmpMaxDepth
		};
	}
}

module.exports = PictTemplateAudit;

/** @type {Record<string, any>} */
PictTemplateAudit.default_configuration = {};

},{"fable":71}],374:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

class PictTemplateProvider extends libFableServiceBase
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.serviceType = 'PictTemplateProvider';

		this.templates = {};
		this.templateSources = {};

		// Default templates are stored by prefix.
		// The longest prefix match is used.
		// Case sensitive.
		this.defaultTemplates = [];

		/**
		 * @type {(hash?: string) => { template: string, source: string }?} loadTemplateFunction - The function to load a template
		 */
		this.loadTemplateFunction = () => { return null; };
	}

	/**
	 * Add a template to the provider.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 * @param {String} pTemplate - The template
	 * @param {String} [pTemplateSource] - (optional) The source of the template
	 */
	addTemplate(pTemplateHash, pTemplate, pTemplateSource)
	{
		this.templates[pTemplateHash] = pTemplate;

		if (typeof(pTemplateSource) == 'string')
		{
			this.templateSources[pTemplateHash] = pTemplateSource;
		}
		else
		{
			this.templateSources[pTemplateHash] = `Direct addTemplate('${pTemplateHash}') function load into PictTemplateProvider [${this.UUID}]::[${this.Hash}]`;
		}
	}

	/**
	 * Add a default template to the provider.
	 *
	 * @param {String} pPrefix - The prefix of the template identifier.
	 * @param {String} pPostfix - The postfix of the template identifier.
	 * @param {String} pTemplate - The template
	 * @param {String} [pSource] - (optional) The source of the template
	 */
	addDefaultTemplate(pPrefix, pPostfix, pTemplate, pSource)
	{
		let tmpSource = (typeof(pSource) == 'string') ? pSource : `Direct addDefaultTemplate('${pPrefix}','${pPostfix}',..) function load into PictTemplateProvider [${this.UUID}]::[${this.Hash}]`
		let tmpDefaultTemplate = {
			prefix: pPrefix,
			postfix: pPostfix,
			template: pTemplate,
			source: tmpSource
		};
		if (typeof(pTemplate) != 'string')
		{
			this.log.error('PictTemplateProvider.addDefaultTemplate: pTemplate is not a string.');
		}
		this.defaultTemplates.push(tmpDefaultTemplate);
	}

	/**
	 * Attempt to populate a template to a default template if it matches a given hash.
	 *
	 * Default templates are managed by postfix and prefix.  The use case is things like titles, headers, list
	 * wrappers, rows, etc.
	 *
	 * So we might have a default template for a list wrapper and it should expect "-ListWrap" as the postfix.
	 * And we might have a default template for a list row and it should expect "-ListRow" as the postfix.
	 * The list might have a "-ListTitle", or we might have shared titles and it would just be "-Title".
	 *
	 * The idea is to allow fallbacks on defaults.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 * @return {string} - The template, or false if not found
	 */
	checkDefaultTemplateHash(pTemplateHash)
	{
		for (let i = 0; i < this.defaultTemplates.length; i++)
		{
			if ((pTemplateHash.indexOf(this.defaultTemplates[i].postfix) == pTemplateHash.length - this.defaultTemplates[i].postfix.length)
				&& (pTemplateHash.indexOf(this.defaultTemplates[i].prefix) == 0))
			{
				this.templates[pTemplateHash] = this.defaultTemplates[i].template;
				this.templateSources[pTemplateHash] = `Auto created in checkDefaultTemplateHash('${pTemplateHash}') function by PictTemplateProvider [${this.UUID}]::[${this.Hash}] from [${this.defaultTemplates[i].prefix}]...[${this.defaultTemplates[i].postfix}]`;
				return this.templates[pTemplateHash];
			}
		}
		return null;
	}

	/**
	 * Get a template by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 * @return {String} - The template, or false if not found
	 */
	getTemplate(pTemplateHash)
	{
		// TODO: Optimize this.
		// If the template doesn't exist, try to load it with the loading function
		if (!(pTemplateHash in this.templates))
		{
			this.loadTemplate(pTemplateHash);
		}
		// If the loading function fails, try to load it from the default templates
		if (!(pTemplateHash in this.templates))
		{
			this.checkDefaultTemplateHash(pTemplateHash);
		}
		if ((pTemplateHash in this.templates))
		{
			return this.templates[pTemplateHash];
		}
		return null;
	}

	/**
	 * Load a template by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 */
	loadTemplate(pTemplateHash)
	{
		let tmpTemplate = this.loadTemplateFunction(pTemplateHash);

		if (tmpTemplate)
		{
			this.templates[pTemplateHash] = tmpTemplate.template;
			this.templateSources[pTemplateHash] = `Loaded in loadTemplate('${pTemplateHash}') function by PictTemplateProvider [${this.UUID}]::[${this.Hash}] from [${tmpTemplate.source}]`;

		}

		return tmpTemplate;
	}
}

module.exports = PictTemplateProvider;

},{"fable":71}],375:[function(require,module,exports){
(function (setImmediate){(function (){
/**
 * @author <steven@velozo.com>
 */
const libFableServiceTransactionTracking = require(`./services/Fable-Service-TransactionTracking.js`);

/**
 * @typedef {{
 *    UUID: string,
 *    settings: any,
 *    fable: Fable,
 *    servicesMap: any,
 *    addAndInstantiateServiceType: (hash: string, prototype: any) => any,
 *    addServiceTypeIfNotExists: (hash: string, prototype: any) => any,
 *    addServiceType: (hash: string, prototype: any) => any,
 *    instantiateServiceProvider: (hash: string, options?: any, prototype?: any) => any,
 *    instantiateServiceProviderWithoutRegistration: (hash: string) => any,
 *    instantiateServiceProviderFromPrototype: (pServiceType: string, pOptions?: any, pCustomServiceHash?: string, pServicePrototype?: any) => any,
 *    getUUID: () => string,
 *    Utility:
 *    {
 *				extend: (pObject: any, ...pExtension: any[]) => any,
 *				eachLimit: (pArray: any[], pLimit: number, pIterator: (pRecord: any, fRecordCallback: () => void) => void, fCallback: (pError: any) => void) => void,
 *    },
 *    MetaTemplate: any,
 * }} Fable
 */
/** @type {{ new(...args: any[]): Fable }} */
const libFable = require('fable');

const libPackage = require('../package.json');
const libProviderFilterManager = require('./providers/Provider-Filter-Manager.js');
const libProviderDataBroker = require('./providers/Provider-DataBroker.js');
const libProviderIcon = require('./providers/Provider-Icon.js');

const PictTemplateProvider = require('./Pict-Template-Provider.js');
const PictTemplateAudit = require('./Pict-Template-Audit.js');
const PictContentAssignment = require('./Pict-Content-Assignment.js');
const PictDataProvider = require('./Pict-DataProvider.js');
const PictCSS = require('./Pict-CSS.js');
const PictMeadowEntityProvider = require('./Pict-Meadow-EntityProvider.js');

/**
 * Pict management object.
 */
class Pict extends libFable {
	/**
	 * @param {Object<String, any>} pSettings - The settings for the Pict instance.
	 */
	constructor(pSettings) {
		super(pSettings);

		/** @type {any} */
		this.settings;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		this.isBrowser = new Function(
			"try {return (this===window);} catch(pError) {return false;}",
		);

		/** @type {Object} */
		this._PackageFable = this._Package;
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		this.browserAddress = "window._Pict";
		if ("BrowserAddress" in this.settings) {
			this.browserAddress = this.settings.BrowserAddress;
		}
		this.children = [];

		/** @type {import('pict-application')} */
		this.PictApplication = null;
		// shim types from fable until we export types properly
		/** @type {any} */
		this.log;
		//NOTE: This needs to come before any other providers which may instantiate a rest client so we don't proliferate them
		this.instantiateServiceProvider("RestClient");
		/**
		 * The templateProvider provides a basic key->template mapping with default fallback capabilities
		 *
		 * @type {PictTemplateProvider}
		 */
		this.TemplateProvider = null;
		this.addAndInstantiateServiceType("TemplateProvider", PictTemplateProvider);
		/**
		 * The template audit provider.
		 *
		 * @type {PictTemplateAudit}
		 */
		this.TemplateAudit = null;
		this.addAndInstantiateServiceType("TemplateAudit", PictTemplateAudit);
		/**
		 * The meadow entity provider.
		 *
		 * @type {PictMeadowEntityProvider}
		 */
		this.EntityProvider = null;
		this.addAndInstantiateServiceType(
			"EntityProvider",
			PictMeadowEntityProvider,
		);
		/**
		 * The data provider.
		 *
		 * @type {PictDataProvider}
		 */
		this.DataProvider = null;
		this.addAndInstantiateServiceType("DataProvider", PictDataProvider);

		this.addServiceTypeIfNotExists('TransactionTracking', libFableServiceTransactionTracking);
		/**
		 * The content assignment module.
		 *
		 * @type {PictContentAssignment}
		 */
		this.ContentAssignment = null;
		this.expressionParser = this.instantiateServiceProvider("ExpressionParser");
		this.addAndInstantiateServiceType(
			"ContentAssignment",
			PictContentAssignment,
		);
		/**
		 * The CSS module.
		 *
		 * @type {PictCSS}
		 * @public
		 */
		this.CSSMap = null;
		this.addAndInstantiateServiceType("CSSMap", PictCSS);

		this.addServiceType("PictTemplate", require("pict-template"));
		this.instantiateServiceProvider("MetaTemplate");
		this.instantiateServiceProvider("DataGeneration");

		this.manifest = this.instantiateServiceProvider("Manifest");

		/** @type {Record<string, any>} */
		this.AppData = {};
		if ("DefaultAppData" in this.fable.settings)
		{
			this.AppData = this.fable.settings.DefaultAppData;
		}

		/** @type {Record<string, any>} */
		// Added for transitory data like chart data caches
		this.TempData = {};

		/** @type {Record<string, any>} */
		this.Bundle = {};
		if ("DefaultBundle" in this.fable.settings)
		{
			this.Bundle = this.fable.settings.DefaultBundle;
		}

		// Log noisness goes from 0 - 5, where 5 is show me everything.
		this.LogNoisiness = 0;
		// Although we have log noisiness, sometimes we need control flow without all the other noise for hard to diagnose interpreters.
		this.LogControlFlow = false;
		// And an easy way to be introspective about data at various locations
		this.LogControlFlowWatchAddressList = [];

		// Template auditing -- when enabled, builds a tree of template processing info
		this.TemplateDebug = false;
		// Secondary flag to capture real Error().stack traces (expensive, off by default)
		this.TemplateDebugStack = false;

		// Load manifest sets
		if (this.settings.Manifests) {
			this.loadManifestSet(this.settings.Manifests);
		}

		this._DefaultPictTemplatesInitialized = false;
		this.initializePictTemplateEngine();

		this.addServiceType("PictView", require("pict-view"));
		this.addServiceType("PictProvider", require("pict-provider"));
		this.addServiceType("PictApplication", require("pict-application"));

		// Expose the named views directly, through a convenience accessor
		/** @type {{ FilterManager: libProviderFilterManager, [key: string]: any }} */
		this.providers = this.servicesMap.PictProvider;
		this.views = this.servicesMap.PictView;

		this.addProvider('FilterManager', {}, libProviderFilterManager);
		this.addProvider('DataBroker', {}, libProviderDataBroker);
		this.addProvider('Icon', {}, libProviderIcon);
	}

	/**
	 * Convenience accessor for the built-in icon registry — equivalent to
	 * `pict.providers.Icon.get(name, opts)`.  Always returns a string
	 * (never throws, never undefined); a missing icon emits a visible
	 * question-mark glyph so the gap is obvious in the UI.
	 *
	 * @param {string} pName     PascalCase icon name, or an alias.
	 * @param {object} [pOpts]   { variant, size, class, ariaLabel }
	 * @returns {string}
	 */
	icon(pName, pOpts)
	{
		if (!this.providers || !this.providers.Icon)
		{
			return '';
		}
		return this.providers.Icon.get(pName, pOpts);
	}

	/**
	 * Load manifests in as Hashed services
	 *
	 * @param {Object<String, String>} pManifestSet - The manifest set to load.
	 */
	loadManifestSet(pManifestSet) {
		if (typeof pManifestSet != "object") {
			this.log.warn(
				`PICT [${this.UUID}] could not load Manifest Set; pManifestSet was not an object.`,
			);
			return;
		}
		let tmpManifestKeys = Object.keys(pManifestSet);
		if (tmpManifestKeys.length > 0) {
			for (let i = 0; i < tmpManifestKeys.length; i++) {
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.instantiateServiceProvider(
					"Manifest",
					pManifestSet[tmpManifestKey],
					tmpManifestKey,
				);
			}
		}
	}

	/**
	 * Add a template expression to the template engine from the PictTemplate service.
	 *
	 * @template {new (...args: any[]) => any} T
	 * @param {T} pTemplatePrototype - The prototype class for the template expression
	 *
	 * @return {InstanceType<T>} the service instance, or null if the prototype was invalid
	 */
	addTemplate(pTemplatePrototype) {
		if (typeof pTemplatePrototype != "function") {
			this.log.warn(
				`PICT [${this.UUID}] could not add Template; pTemplatePrototype was not a class it was ${typeof pTemplatePrototype}.`,
			);
			return null;
		}

		let tmpTemplateHash = pTemplatePrototype["template_hash"];

		if (this.LogNoisiness > 1) {
			this.log.info(`PICT-ControlFlow addTemplate [${tmpTemplateHash}]`);
		}

		return this.instantiateServiceProviderFromPrototype(
			"PictTemplate",
			{},
			tmpTemplateHash,
			pTemplatePrototype,
		);
	}

	/**
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @template {new (...args: any[]) => any} [T=typeof import('pict-view')]
	 * @param {String} pViewHash - The hash of the view.
	 * @param {Object<String, any>} [pOptions] - The options for the view.
	 * @param {T} [pViewPrototype] - The prototype for the view.
	 *
	 * @return {InstanceType<T>} The view instance.
	 */
	addView(pViewHash, pOptions, pViewPrototype) {
		let tmpOptions = typeof pOptions == "object" ? pOptions : {};
		let tmpViewHash =
			typeof pViewHash == "string" ? pViewHash : this.fable.getUUID();
		// This is here to change how the value is managed by webpack
		let tmpViewPrototype = pViewPrototype;

		if (this.LogControlFlow) {
			if (this.LogNoisiness > 1) {
				this.log.info(`PICT-ControlFlow addView [${tmpViewHash}]:`, {
					Options: tmpOptions,
				});
			} else {
				this.log.info(`PICT-ControlFlow addView [${tmpViewHash}]`);
			}
		}

		if (tmpViewPrototype) {
			// If the prototype has a default_configuration, it will be merged with options.
			const tmpDefaultViewConfiguration =
				tmpViewPrototype["default_configuration"];
			if (tmpDefaultViewConfiguration) {
				tmpOptions = this.fable.Utility.extend(
					{},
					JSON.parse(JSON.stringify(tmpDefaultViewConfiguration)),
					tmpOptions,
				);
			}
			return this.instantiateServiceProviderFromPrototype(
				"PictView",
				tmpOptions,
				tmpViewHash,
				tmpViewPrototype,
			);
		} else {
			return this.instantiateServiceProvider(
				"PictView",
				tmpOptions,
				tmpViewHash,
			);
		}
	}

	/**
	 * Add a view unless one already exists, then return that one.
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pViewHash - The hash of the view.
	 * @param {Object<String, any>} [pOptions] - The options for the view.
	 * @param {any} [pViewPrototype] - The prototype for the view.
	 * @return {any} The view instance.
	 */
	addViewSingleton(pViewHash, pOptions, pViewPrototype)
	{
		if (pViewHash in this.views)
		{
			return this.views[pViewHash];
		}
		return this.addView(pViewHash, pOptions, pViewPrototype);
	}

	/**
	 * Add a provider unless one already exists, then return that one.
	 *
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pProviderHash - The hash of the provider.
	 * @param {Object<String, any>} [pOptions] - The options for the provider.
	 * @param {any} [pProviderPrototype] - The prototype for the provider.
	 *
	 * FIXME: refer to PictProvider here once it has a type definition
	 *
	 * @return {any} The provider instance.
	 */
	addProviderSingleton(pProviderHash, pOptions, pProviderPrototype) {
		if (pProviderHash in this.providers) {
			return this.providers[pProviderHash];
		}
		return this.addProvider(pProviderHash, pOptions, pProviderPrototype);
	}

	/**
	 * @return {libFableServiceTransactionTracking}
	 */
	newTransactionTracker()
	{
		return this.instantiateServiceProviderWithoutRegistration('TransactionTracking');
	}

	/**
	 * Add an Expression Parser function to the solver.
	 *
	 * @param {Object} pExpressionParser - The expresssion parser to add the function to
	 * @param {string} pFunctionName - The name of the function
	 * @param {string} pFunctionAddress - The address of the function
	 * @param {string} pFunctionComment - A comment about the function
	 */
	addSolverFunction(pExpressionParser, pFunctionName, pFunctionAddress, pFunctionComment)
	{
		let tmpFunctionName = (pFunctionName || '').trim().toLowerCase();
		let tmpExpressionParser = pExpressionParser;
		if (!tmpExpressionParser || typeof(tmpExpressionParser) !== 'object' || !tmpExpressionParser.functionMap)
		{
			tmpExpressionParser = this.expressionParser;
		}
		if (tmpExpressionParser.functionMap.hasOwnProperty(tmpFunctionName))
		{
			this.log.warn(`Pict: Function ${tmpFunctionName} already exists in the solver, overwriting with address [${pFunctionAddress}].`);
			//return false;
		}
		tmpExpressionParser.functionMap[tmpFunctionName] = (
		{
			Name: pFunctionComment || `Autogenerated PICT function ${tmpFunctionName}`,
			Address: pFunctionAddress,
		});

		return tmpExpressionParser.functionMap[tmpFunctionName];
	}

	/**
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pProviderHash - The hash of the provider.
	 * @param {Object<String, any>} [pOptions] - The options for the provider.
	 * @param {any} [pProviderPrototype] - The prototype for the provider.
	 *
	 * FIXME: refer to PictProvider here once it has a type definition
	 *
	 * @return {any} The provider instance.
	 */
	addProvider(pProviderHash, pOptions, pProviderPrototype) {
		let tmpOptions = typeof pOptions == "object" ? pOptions : {};
		let tmpProviderHash =
			typeof pProviderHash == "string" ? pProviderHash : this.fable.getUUID();

		if (this.LogControlFlow) {
			if (this.LogNoisiness > 1) {
				this.log.info(`PICT-ControlFlow addProvider [${tmpProviderHash}]:`, {
					Options: tmpOptions,
				});
			} else {
				this.log.info(`PICT-ControlFlow addProvider [${tmpProviderHash}]`);
			}
		}

		if (typeof pProviderPrototype != "undefined") {
			// If the prototype has a default_configuration, it will be merged with options.
			if ("default_configuration" in pProviderPrototype) {
				tmpOptions = this.fable.Utility.extend(
					{},
					pProviderPrototype.default_configuration,
					tmpOptions,
				);
			}
			return this.instantiateServiceProviderFromPrototype(
				"PictProvider",
				tmpOptions,
				tmpProviderHash,
				pProviderPrototype,
			);
		} else {
			return this.instantiateServiceProvider(
				"PictProvider",
				tmpOptions,
				tmpProviderHash,
			);
		}
	}

	/**
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pApplicationHash - The hash of the application.
	 * @param {Object} [pOptions] - The options for the application.
	 * @param {any} [pApplicationPrototype] - The prototype for the application.
	 *
	 * FIXME: refer to PictApplication here once it has a type definition
	 *
	 * @return {any} The application instance.
	 */
	addApplication(pApplicationHash, pOptions, pApplicationPrototype) {
		let tmpOptions = typeof pOptions == "object" ? pOptions : {};
		let tmpApplicationHash =
			typeof pApplicationHash == "string"
				? pApplicationHash
				: this.fable.getUUID();

		if (this.LogControlFlow) {
			if (this.LogNoisiness > 1) {
				this.log.info(
					`PICT-ControlFlow addApplication [${tmpApplicationHash}]:`,
					{ Options: tmpOptions },
				);
			} else {
				this.log.info(
					`PICT-ControlFlow addApplication [${tmpApplicationHash}]`,
				);
			}
		}

		if (typeof pApplicationPrototype != "undefined") {
			// If the prototype has a default_configuration, it will be merged with options.
			if ("default_configuration" in pApplicationPrototype) {
				tmpOptions = this.fable.Utility.extend(
					{},
					pApplicationPrototype.default_configuration,
					tmpOptions,
				);
			}

			return this.instantiateServiceProviderFromPrototype(
				"PictApplication",
				tmpOptions,
				tmpApplicationHash,
				pApplicationPrototype,
			);
		} else {
			return this.instantiateServiceProvider(
				"PictApplication",
				tmpOptions,
				tmpApplicationHash,
			);
		}
	}

	/**
	 * Attach the default template engine renderers.
	 *
	 * TODO: Move this to a one-time service
	 *
	 * @private
	 */
	initializePictTemplateEngine() {
		if (!this._DefaultPictTemplatesInitialized) {
			// Just looking up data in the application state template expression
			//{~Data:AppData.Some.Value.to.Render~}
			//{~D:AppData.Some.Value.to.Render~}
			this.addTemplate(require(`./templates/Pict-Template-Data.js`));

			this.addTemplate(require(`./templates/Pict-Template-DataWithTemplateFallback.js`));

			this.addTemplate(require(`./templates/Pict-Template-DataWithAbsoluteFallback.js`));

			this.addTemplate(require(`./templates/Pict-Template-TemplateByReference.js`));

			this.addTemplate(require(`./templates/Pict-Template-TemplateFromAddress.js`));

			this.addTemplate(require(`./templates/Pict-Template-TemplateByTypes.js`));

			this.addTemplate(require(`./templates/Pict-Template-DataValueByKey.js`));

			this.addTemplate(require(`./templates/Pict-Template-View.js`));

			this.addTemplate(require(`./templates/data/Pict-Template-DataEncodeJavascriptString.js`));

			// HTML Comment Start and End based on truthiness ... if the value is false, the comment shows up.
			// {~HtmlCommentStart:Some.Address~} gives you "<!--"
			// {~HCS:Some.Address~} gives you "<!--"
			this.addTemplate(
				require(`./templates/data/Pict-Template-HtmlCommentStart.js`),
			);
			// {~HtmlCommentEnd:Some.Address~} gives you "-->"
			// {~HCE:Some.Address~} gives you "-->"
			this.addTemplate(
				require(`./templates/data/Pict-Template-HtmlCommentEnd.js`),
			);

			// Know the in-browser reference for Pict when appropriate
			this.addTemplate(require(`./templates/Pict-Template-Self.js`));

			// Built-in icon glyph by PascalCase name.
			//   {~Icon:Home~}              default variant
			//   {~Icon:Folder:Filled~}     explicit variant
			//   {~I:Spreadsheet~}          short alias
			//   {~I:File:Filled~}          short + variant
			// Backed by pict.providers.Icon — host modules register
			// additional glyphs via pict.providers.Icon.registerSet().
			this.addTemplate(require(`./templates/Pict-Template-Icon.js`));

			// Look up an entity template expression
			// {~Entity:Book^AppData.Some.Address.IDBook^Render-Book-Template~}
			// {~E:Book^AppData.Some.Address.IDBook^Render-Book-Template~}
			// ...meaning GET BOOK with IDBook FROM AppData.Some.Address.IDBook and render it to Render-Book-Template
			this.addTemplate(require(`./templates/Pict-Template-Entity.js`));

			// Child Template Expressions
			// {~T:Template:AddressOfData~}
			this.addTemplate(require(`./templates/Pict-Template-Template.js`));
			this.addTemplate(require(`./templates/Pict-Template-TemplateByDataAddress.js`));
			// Inline Template Expression -- parse the contents as a template at runtime
			// {<TEMPLATED CONTENT HERE, {~D:AppData.SomeValue~}.>}
			this.addTemplate(require(`./templates/Pict-Template-InlineTemplate.js`));
			// Function Expression -- call a function by address with addressed arguments
			// {~Function:Pict.providers.X.makeThing:Record.X:Record.Y~}  /  {~F:...~}
			this.addTemplate(require(`./templates/Pict-Template-Function.js`));
			// Addressed Template Expression -- resolve an address to a template string and render it
			// {[AppData.MyTemplate]}
			this.addTemplate(require(`./templates/Pict-Template-AddressedTemplate.js`));
			// {~SBR:AppData.Equation:AppData.HomeworkRectangleSize:AppData.HomeworkManifest~}
			this.addTemplate(require(`./templates/Pict-Template-SolveByReference.js`));
			this.addTemplate(require(`./templates/Pict-Template-Solve.js`));
			// {~TS:Template:AddressOfDataSet~}
			this.addTemplate(require(`./templates/Pict-Template-TemplateSet.js`));
			// {~TVS:Template:AddressOfDataSet~}
			this.addTemplate(
				require(`./templates/Pict-Template-TemplateValueSet.js`),
			);
			this.addTemplate(
				require(`./templates/Pict-Template-TemplateSetWithPayload.js`),
			);
			this.addTemplate(require(`./templates/Pict-Template-TemplateFromMap.js`));
			this.addTemplate(
				require(`./templates/Pict-Template-TemplateSetFromMap.js`),
			);

			// Logical Branching Template Expressions
			// {~TemplateIf:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^AppData.Some.Address2.IDBook~}
			// {~TIf:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^AppData.Some.Address2.IDBook~}
			this.addTemplate(
				require(`./templates/logic/Pict-Template-TemplateIf.js`),
			);
			// {~TemplateIfAbsolute:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^Absolute_Value~}
			// {~TIfAbs:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^Absolute_Value~}
			this.addTemplate(
				require(`./templates/logic/Pict-Template-TemplateIfAbsolute.js`),
			);
			// {~NotEmpty:AppData.Some.Address^Absolute Value~}
			this.addTemplate(require(`./templates/logic/Pict-Template-NotEmpty.js`));

			// Data Manipulation Templates
			this.addTemplate(require(`./templates/data/Pict-Template-DataJson.js`));
			this.addTemplate(
				require(`./templates/data/Pict-Template-PascalCaseIdentifier.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateOnlyFormat.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateOnlyYMD.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateTimeFormat.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateTimeYMD.js`),
			);
			this.addTemplate(require(`./templates/data/Pict-Template-Digits.js`));
			this.addTemplate(require(`./templates/data/Pict-Template-Dollars.js`));

			this.addTemplate(require(`./templates/data/Pict-Template-Join.js`));
			this.addTemplate(require(`./templates/data/Pict-Template-JoinUnique.js`));
			this.addTemplate(
				require(`./templates/data/Pict-Template-PluckJoinUnique.js`),
			);

			// Data Generation Templates
			this.addTemplate(
				require(`./templates/data-generation/Pict-Template-RandomNumber.js`),
			);
			this.addTemplate(
				require(
					`./templates/data-generation/Pict-Template-RandomNumberString.js`,
				),
			);

			// Debugging Templates
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-Breakpoint.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-LogStatement.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-LogValue.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-LogValueTree.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-DataValueTree.js`),
			);

			this._DefaultPictTemplatesInitialized = true;
		}
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * TODO: re-home this in the data broker
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} [pRecord] - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		let tmpContextArray = (Array.isArray(pContextArray)) ? pContextArray : [ this ];
		let tmpScope = pScope || this;
		let tmpRootDataObject = typeof(pRootDataObject) === 'object' && pRootDataObject != null ? pRootDataObject : {};

		tmpRootDataObject.Fable = this;
		tmpRootDataObject.Pict = this;
		tmpRootDataObject.AppData = this.AppData;
		tmpRootDataObject.TempData = this.TempData;
		tmpRootDataObject.Bundle = this.Bundle;
		tmpRootDataObject.Context = tmpContextArray;
		tmpRootDataObject.Record = pRecord;
		tmpRootDataObject.Scope = tmpScope;
		tmpRootDataObject.__State = pState;

		return this.manifest.getValueByHash(tmpRootDataObject, pAddress);
	}

	/**
	 * Set a value from a nested object using a dot notation string.
	 *
	 * TODO: re-home this in the data broker
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {any} pRecord - The record to resolve
	 * @param {any} pValue - The value to set at the given address
	 * @param {Array<any>} [pContextArray] - The context array to resolve
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	setStateValueAtAddress(pAddress, pRecord, pValue, pContextArray, pScope)
	{
		let tmpContextArray = (Array.isArray(pContextArray)) ? pContextArray : [ this ];
		let tmpScope = pScope || this;
		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this,
			AppData: this.AppData,
			TempData: this.TempData,
			Bundle: this.Bundle,
			Context: tmpContextArray,
			Record: pRecord,
			Scope: tmpScope,
		};
		return this.manifest.setValueByHash(tmpAddressSpace, pAddress, pValue);
	}

	/**
	 * Parse a template.
	 *
	 * @param {String} pTemplateString - The template string to parse
	 * @param {Object} pData - The data to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState)
	{
		let tmpData = typeof pData === "object" ? pData : {};
		let tmpContextArray = Array.isArray(pContextArray) ? pContextArray : [ this ];
		let tmpScope = pScope || this;
		let tmpParseUUID;
		if (this.LogControlFlow) {
			tmpParseUUID = this.fable.getUUID();
			this.log.info(
				`PICT-ControlFlow parseTemplate ${tmpParseUUID} [${pTemplateString.substring(0, 50).replace("\n", "\\n")}...${pTemplateString.length}] (fCallback: ${typeof fCallback}) with data size [${JSON.stringify(tmpData).length}]`,
			);
			if (this.LogNoisiness > 1) {
				this.log.info(
					`PICT-ControlFlow parseTemplate ${tmpParseUUID} template:\n${pTemplateString}`,
				);
			}
			if (this.LogControlFlowWatchAddressList.length > 0) {
				for (let i = 0; i < this.LogControlFlowWatchAddressList.length; i++) {
					this.log.info(
						`PICT-ControlFlow parseTemplate ${tmpParseUUID} Watch Value: [${this.LogControlFlowWatchAddressList[i]}]=>[${this.resolveStateFromAddress(this.LogControlFlowWatchAddressList[i], tmpData)}]`,
					);
				}
			}
		}

		if (typeof fCallback === "function") {
			this.MetaTemplate.parseString(
				pTemplateString,
				tmpData,
				(pError, pParsedTemplate) => {
					if (this.LogControlFlow && this.LogNoisiness > 1) {
						this.log.info(
							`PICT-ControlFlow parseTemplate ${tmpParseUUID} Template Async Return Value:\n${pParsedTemplate}`,
						);
					}
					return fCallback(pError, pParsedTemplate);
				},
				tmpContextArray,
				tmpScope,
				pState,
			);
		} else {
			let tmpResult = this.MetaTemplate.parseString(
				pTemplateString,
				tmpData,
				null,
				tmpContextArray,
				tmpScope,
				pState,
			);
			if (this.LogControlFlow && this.LogNoisiness > 1) {
				this.log.info(
					`PICT-ControlFlow parseTemplate ${tmpParseUUID} Template Return Value:\n${tmpResult}`,
				);
			}
			return tmpResult;
		}
	}

	/**
	 * Parse a template by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template to parse
	 * @param {Object} pData - The data to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState)
	{
		let tmpTemplateString = this.TemplateProvider.getTemplate(pTemplateHash);

		// TODO: Unsure if returning empty is always the right behavior -- if it isn't we will use config to set the behavior
		if (!tmpTemplateString) {
			tmpTemplateString = "";
		}

		return this.parseTemplate(
			tmpTemplateString,
			pData,
			fCallback,
			pContextArray,
			pScope,
			pState,
		);
	}

	/**
	 * Parse a template set.
	 *
	 * @param {String} pTemplateString - The template string to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template set is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
	{
		// TODO: This will need streaming -- for now janky old string append does the trick
		let tmpValue = "";
		if (typeof fCallback == "function") {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				let tmpIterationCount = 0;
				this.Utility.eachLimit(
					pDataSet,
					1,
					(pRecord, fRecordTemplateCallback) => {
						return this.parseTemplate(
							pTemplateString,
							pRecord,
							(pError, pTemplateResult) => {
								tmpValue += pTemplateResult;
								tmpIterationCount++;
								// Yield to the event loop every 100 iterations to prevent
								// stack overflow on large data sets when templates resolve synchronously
								if (tmpIterationCount % 100 === 0)
								{
									setImmediate(fRecordTemplateCallback);
								}
								else
								{
									fRecordTemplateCallback();
								}
							},
							pContextArray,
							pScope,
							pState,
						);
					},
					(pError) => {
						return fCallback(pError, tmpValue);
					},
				);
			} else {
				return fCallback(
					Error("Pict: Template Set: pDataSet is not an array or object."),
					"",
				);
			}
		} else {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				if (Array.isArray(pDataSet)) {
					for (let i = 0; i < pDataSet.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							pDataSet[i],
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				} else {
					let tmpKeys = Object.keys(pDataSet);
					for (let i = 0; i < tmpKeys.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							pDataSet[tmpKeys[i]],
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				}

				return tmpValue;
			} else {
				return "";
			}
		}
	}

	/**
	 * Parse a template set by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState)
	{
		let tmpTemplateString = this.TemplateProvider.getTemplate(pTemplateHash);

		// TODO: Unsure if returning empty is always the right behavior -- if it isn't we will use config to set the behavior
		if (!tmpTemplateString) {
			tmpTemplateString = "";
		}

		return this.parseTemplateSet(
			tmpTemplateString,
			pDataSet,
			fCallback,
			pContextArray,
			pScope,
			pState,
		);
	}


	/**
	 * Parse a template set.
	 *
	 * @param {String} pTemplateString - The template string to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template set is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
	{
		// TODO: This will need streaming -- for now janky old string append does the trick
		let tmpValue = "";
		if (typeof fCallback == "function") {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				let tmpIterationCount = 0;
				this.Utility.eachLimit(
					pDataSet,
					1,
					(pRecord, fRecordTemplateCallback) => {
						return this.parseTemplate(
							pTemplateString,
							{ Data: pRecord, Payload: pPayload },
							(pError, pTemplateResult) => {
								tmpValue += pTemplateResult;
								tmpIterationCount++;
								// Yield to the event loop every 100 iterations to prevent
								// stack overflow on large data sets when templates resolve synchronously
								if (tmpIterationCount % 100 === 0)
								{
									setImmediate(fRecordTemplateCallback);
								}
								else
								{
									fRecordTemplateCallback();
								}
							},
							pContextArray,
							pScope,
							pState,
						);
					},
					(pError) => {
						return fCallback(pError, tmpValue);
					},
				);
			} else {
				return fCallback(
					Error("Pict: Template Set: pDataSet is not an array or object."),
					"",
				);
			}
		} else {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				if (Array.isArray(pDataSet)) {
					for (let i = 0; i < pDataSet.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							{ Data: pDataSet[i], Payload: pPayload },
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				} else {
					let tmpKeys = Object.keys(pDataSet);
					for (let i = 0; i < tmpKeys.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							{ Data: pDataSet[tmpKeys[i]], Payload: pPayload },
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				}

				return tmpValue;
			} else {
				return "";
			}
		}
	}

	/**
	 * Parse a template set by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Object} pPayload - The payload to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
	{
		let tmpTemplateString = this.TemplateProvider.getTemplate(pTemplateHash);

		// TODO: Unsure if returning empty is always the right behavior -- if it isn't we will use config to set the behavior
		if (!tmpTemplateString) {
			tmpTemplateString = "";
		}

		return this.parseTemplateSetWithPayload(
			tmpTemplateString,
			pDataSet,
			pPayload,
			fCallback,
			pContextArray,
			pScope,
			pState,
		);
	}
}

module.exports = Pict;
module.exports.ServiceProviderBase = require('fable-serviceproviderbase');

module.exports.PictApplicationClass = require("pict-application");

module.exports.PictViewClass = require("pict-view");
module.exports.PictProviderClass = require("pict-provider");
module.exports.PictTemplateClass = require("pict-template");

module.exports.EnvironmentLog = require("./environments/Pict-Environment-Log.js");
module.exports.EnvironmentObject = require("./environments/Pict-Environment-Object.js");
module.exports.FilterClauseBase = require('./filters/FilterClauseBase.js');
module.exports.FilterClauseLocal = require('./filters/FilterClauseLocal.js');
module.exports.FilterClauseInternalJoin = require('./filters/FilterClauseInternalJoin.js');
module.exports.FilterClauseExternalJoin = require('./filters/FilterClauseExternalJoin.js');

// This is to help understand the type of enivironement we're executing in
module.exports.isBrowser = new Function(
	"try {return (this===window);} catch(pError) {return false;}",
);

module.exports.safeOnDocumentReady = require(
	`./Pict-Browser-SafeOnDocumentReady.js`,
);
module.exports.safeLoadPictApplication = require(`./Pict-Browser-SafeLoad.js`);

}).call(this)}).call(this,require("timers").setImmediate)

},{"../package.json":366,"./Pict-Browser-SafeLoad.js":367,"./Pict-Browser-SafeOnDocumentReady.js":368,"./Pict-CSS.js":369,"./Pict-Content-Assignment.js":370,"./Pict-DataProvider.js":371,"./Pict-Meadow-EntityProvider.js":372,"./Pict-Template-Audit.js":373,"./Pict-Template-Provider.js":374,"./environments/Pict-Environment-Log.js":376,"./environments/Pict-Environment-Object.js":377,"./filters/FilterClauseBase.js":379,"./filters/FilterClauseExternalJoin.js":380,"./filters/FilterClauseInternalJoin.js":381,"./filters/FilterClauseLocal.js":382,"./providers/Provider-DataBroker.js":384,"./providers/Provider-Filter-Manager.js":385,"./providers/Provider-Icon.js":386,"./services/Fable-Service-TransactionTracking.js":387,"./templates/Pict-Template-AddressedTemplate.js":388,"./templates/Pict-Template-Data.js":389,"./templates/Pict-Template-DataValueByKey.js":390,"./templates/Pict-Template-DataWithAbsoluteFallback.js":391,"./templates/Pict-Template-DataWithTemplateFallback.js":392,"./templates/Pict-Template-Entity.js":393,"./templates/Pict-Template-Function.js":394,"./templates/Pict-Template-Icon.js":395,"./templates/Pict-Template-InlineTemplate.js":396,"./templates/Pict-Template-Self.js":397,"./templates/Pict-Template-Solve.js":398,"./templates/Pict-Template-SolveByReference.js":399,"./templates/Pict-Template-Template.js":400,"./templates/Pict-Template-TemplateByDataAddress.js":401,"./templates/Pict-Template-TemplateByReference.js":402,"./templates/Pict-Template-TemplateByTypes.js":403,"./templates/Pict-Template-TemplateFromAddress.js":404,"./templates/Pict-Template-TemplateFromMap.js":405,"./templates/Pict-Template-TemplateSet.js":406,"./templates/Pict-Template-TemplateSetFromMap.js":407,"./templates/Pict-Template-TemplateSetWithPayload.js":408,"./templates/Pict-Template-TemplateValueSet.js":409,"./templates/Pict-Template-View.js":410,"./templates/data-generation/Pict-Template-RandomNumber.js":411,"./templates/data-generation/Pict-Template-RandomNumberString.js":412,"./templates/data/Pict-Template-DataEncodeJavascriptString.js":413,"./templates/data/Pict-Template-DataJson.js":414,"./templates/data/Pict-Template-DateOnlyFormat.js":415,"./templates/data/Pict-Template-DateOnlyYMD.js":416,"./templates/data/Pict-Template-DateTimeFormat.js":417,"./templates/data/Pict-Template-DateTimeYMD.js":418,"./templates/data/Pict-Template-Digits.js":419,"./templates/data/Pict-Template-Dollars.js":420,"./templates/data/Pict-Template-HtmlCommentEnd.js":421,"./templates/data/Pict-Template-HtmlCommentStart.js":422,"./templates/data/Pict-Template-Join.js":423,"./templates/data/Pict-Template-JoinUnique.js":424,"./templates/data/Pict-Template-PascalCaseIdentifier.js":425,"./templates/data/Pict-Template-PluckJoinUnique.js":426,"./templates/debugging/Pict-Template-Breakpoint.js":427,"./templates/debugging/Pict-Template-DataValueTree.js":428,"./templates/debugging/Pict-Template-LogStatement.js":429,"./templates/debugging/Pict-Template-LogValue.js":430,"./templates/debugging/Pict-Template-LogValueTree.js":431,"./templates/logic/Pict-Template-NotEmpty.js":432,"./templates/logic/Pict-Template-TemplateIf.js":434,"./templates/logic/Pict-Template-TemplateIfAbsolute.js":435,"fable":71,"fable-serviceproviderbase":59,"pict-application":147,"pict-provider":177,"pict-template":363,"pict-view":365,"timers":545}],376:[function(require,module,exports){
/**
* Pict browser shim loader
* @author <steven@velozo.com>
*
* This was born after writing about 10 views and copying basically the same
* mock environment read/write functions into the test harnesses.  It allows
* mocks or other types of communications back-and-forth to be configured
* as an environment for views and applications.
*
* To use this:
*
* 1. Construct a pict object in your favorite fashion:
*        let _Pict = new libPict({...Environment})
* 2. Require this; it's exported as a static subobject of the pict library,
*    so you can do:
*        const libPictEnvironmentLog = require('pict').EnvironmentLog;
* 3. Create an object that is your custom read data.  Any key that is requested
*    but missing will return empty.
*        const tmpContentMap = { '#SomeElement': 'SomeValue' };
* 4. Pass your pict through this to get the custom functions mapped into the ContentAssignment service:
*        let tmpMockEnvironment = new libPictEnvironmentLog(_Pict, tmpContentMap);
* 5. Now you can use your pict as normal, and it will log all of the read/write events out and keep a log of when they occurred.
*/
class PictEnvironmentLog
{
	/**
	 * @typedef {import('../Pict')} Pict
	 */
	/**
	 * @param {Pict} pPict - The pict object to attach the custom read/write functions to.
	 * @param {Object<String, any>} pContentMap - The content map to use for custom reads.
	 */
	constructor(pPict, pContentMap)
	{
		this.contentMap = (typeof(pContentMap) == 'object') ? pContentMap : {};

		this.pict = pPict;

		// If this is set to false, we won't keep an array-based log of every read, assignment, append or get.
		this.truncateContentLength = 256;
		this.storeEventLog = true;
		// Where to store each event type
		this.eventLog = {};
		this.eventLog.GetElement = [];
		this.eventLog.Read = [];
		this.eventLog.Prepend = [];
		this.eventLog.Append = [];
		this.eventLog.Assign = [];

		this.pict.ContentAssignment.customGetElementFunction = this.customGetElementFunction.bind(this);
		this.pict.ContentAssignment.customReadFunction = this.customReadFunction.bind(this);
		this.pict.ContentAssignment.customAppendFunction = this.customAppendFunction.bind(this);
		this.pict.ContentAssignment.customPrependFunction = this.customPrependFunction.bind(this)
		this.pict.ContentAssignment.customAssignFunction = this.customAssignFunction.bind(this);

		this.pict.ContentAssignment.customReadAttributeFunction = this.customReadAttributeFunction.bind(this);
		this.pict.ContentAssignment.customSetAttributeFunction = this.customSetAttributeFunction.bind(this);
	}

	/**
	 * Create an event log entry.
	 *
	 * @param {string} pAddress - The address of the event.
	 * @param {string} [pContent] - The content of the event.
	 */
	createEventLogEntry(pAddress, pContent)
	{
		let tmpContent = (typeof(pContent) == 'undefined') ? '' : pContent;
		return (
			{
				TimeStamp:this.pict.log.getTimeStamp(),
				Hash: pAddress,
				Content: tmpContent
			});
	}

	/**
	 * Custom GetElement function.
	 *
	 * @param {string} pAddress - The address of the element.
	 */
	customGetElementFunction(pAddress)
	{
		if (this.storeEventLog) this.eventLog.GetElement.push(this.createEventLogEntry(pAddress));
		this.pict.log.info(`Mocking an GET of Address -> [${pAddress}]`);
		return '';
	}

	/**
	 * Custom Read function.
	 *
	 * @param {string} pAddress - The address of the element.
	 */
	customReadFunction(pAddress)
	{
		if (this.storeEventLog) this.eventLog.Read.push(this.createEventLogEntry(pAddress));
		this.pict.log.info(`Mocking an READ from Address -> [${pAddress}]`);
		if (pAddress in this.contentMap)
		{
			// The data is in the content map!
			return this.contentMap[pAddress];
		}
		this.pict.log.warn(`Mock read from Address ${pAddress} did not find a value in the content map.`);
		return '';
	}

	/**
	 * Custom Append function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pContent - The content to append.
	 */
	customAppendFunction(pAddress, pContent)
	{
		if (this.storeEventLog) this.eventLog.Append.push(this.createEventLogEntry(pAddress, pContent));
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	/**
	 * Custom Prepend function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pContent - The content to prepend.
	 */
	customPrependFunction(pAddress, pContent)
	{
		if (this.storeEventLog) this.eventLog.Prepend.push(this.createEventLogEntry(pAddress, pContent));
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	/**
	 * Custom Assign function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pContent - The content to assign.
	 */
	customAssignFunction(pAddress, pContent)
	{
		if (this.storeEventLog) this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pContent));
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	/**
	 * Custom Read Attribute function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pAttribute - The attribute to read.
	 */
	customReadAttributeFunction(pAddress, pAttribute)
	{
		this.pict.log.info(`Mocking an READ ATTRIBUTE from Address -> [${pAddress}]`, {Attribute: pAttribute});
		return '';
	}

	/**
	 * Custom Set Attribute function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pAttribute - The attribute to set.
	 */
	customSetAttributeFunction(pAddress, pAttribute, pContent)
	{
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an SET ATTRIBUTE to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Attribute: pAttribute, Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an SET ATTRIBUTE to Address -> [${pAddress}]`, {Attribute: pAttribute, Content: pContent});
		}
		return '';
	}
}

module.exports = PictEnvironmentLog;

},{}],377:[function(require,module,exports){
/**
* Pict browser shim loader with Object statefulness for the environement
* @author <steven@velozo.com>
*
* This was born after writing about 10 views and copying basically the same
* mock environment read/write functions into the test harnesses.  It allows
* mocks or other types of communications back-and-forth to be configured
* as an environment for views and applications.
*
* To use this:
*
* 1. Construct a pict object in your favorite fashion:
*        let _Pict = new libPict({...Environment})
* 2. Require this; it's exported as a static subobject of the pict library,
*    so you can do:
*        const libPictEnvironmentLog = require('pict').EnvironmentLog;
* 3. Create an object that is your custom read data.  Any key that is requested
*    but missing will return empty.
*        const tmpContentMap = { '#SomeElement': 'SomeValue' };
* 4. Pass your pict through this to get the custom functions mapped into the ContentAssignment service:
*        let tmpMockEnvironment = new libPictEnvironmentLog(_Pict, tmpContentMap);
* 5. Now you can use your pict as normal, and it will log all of the read/write events out and keep a log of when they occurred.
*/
class PictEnvironmentObject
{
	/**
	 * @typedef {import('../Pict')} Pict
	 */
	/**
	 * @param {Pict} pPict - The pict object to attach the custom read/write functions to.q
	 * @param {Object<String, any>} pContentMap - The content map to use for custom reads.
	 */
	constructor(pPict, pContentMap)
	{
		this.contentMap = (typeof(pContentMap) == 'object') ? pContentMap : {};

		this.contentMap._ATTRIBUTE_MAP = {};
		this.contentMap._CLASS_MAP = {};

		this.pict = pPict;

		// If this is set to false, we won't keep an array-based log of every read, assignment, append or get.
		this.truncateContentLength = 256;
		this.storeEventLog = true;
		// Where to store each event type
		this.eventLog = {};
		this.eventLog.GetElement = [];
		this.eventLog.Read = [];
		this.eventLog.Prepend = [];
		this.eventLog.Append = [];
		this.eventLog.Assign = [];
		this.eventLog.ReadAttribute = [];
		this.eventLog.SetAttribute = [];
		this.eventLog.RemoveAttribute = [];
		this.eventLog.ReadClass = [];
		this.eventLog.SetClass = [];
		this.eventLog.RemoveClass = [];

		this.pict.ContentAssignment.customGetElementFunction = this.customGetElementFunction.bind(this);
		this.pict.ContentAssignment.customReadFunction = this.customReadFunction.bind(this);
		this.pict.ContentAssignment.customAppendFunction = this.customAppendFunction.bind(this);
		this.pict.ContentAssignment.customPrependFunction = this.customPrependFunction.bind(this)
		this.pict.ContentAssignment.customAssignFunction = this.customAssignFunction.bind(this);
		this.pict.ContentAssignment.customReadAttributeFunction = this.customReadAttributeFunction.bind(this);
		this.pict.ContentAssignment.customSetAttributeFunction = this.customSetAttributeFunction.bind(this);
		this.pict.ContentAssignment.customRemoveAttributeFunction = this.customRemoveAttributeFunction.bind(this);
		this.pict.ContentAssignment.customReadClassFunction = this.customReadClassFunction.bind(this);
		this.pict.ContentAssignment.customSetClassFunction = this.customSetClassFunction.bind(this);
		this.pict.ContentAssignment.customRemoveClassFunction = this.customRemoveClassFunction.bind(this);
	}

	createEventLogEntry(pAddress, pContent)
	{
		let tmpContent = (typeof(pContent) == 'undefined') ? '' : pContent;
		return (
			{
				TimeStamp:this.pict.log.getTimeStamp(),
				Hash: pAddress,
				Content: tmpContent
			});
	}

	customGetElementFunction (pAddress)
	{
		if (this.storeEventLog)
		{
			this.eventLog.GetElement.push(this.createEventLogEntry(pAddress));
		}

		this.pict.log.info(`Mocking an GET of Address -> [${pAddress}]`);
		return '';
	}

	customReadFunction (pAddress)
	{
		if (this.storeEventLog)
		{
			this.eventLog.Read.push(this.createEventLogEntry(pAddress));
		}

		this.pict.log.info(`Mocking an READ from Address -> [${pAddress}]`);
		if (pAddress in this.contentMap)
		{
			// The data is in the content map!
			return this.contentMap[pAddress];
		}
		this.pict.log.warn(`Mock read from Address ${pAddress} did not find a value in the content map.`);
		return '';
	}

	customAppendFunction (pAddress, pContent)
	{
		this.contentMap[pAddress] = (typeof(this.contentMap[pAddress]) == 'undefined') ? pContent : this.contentMap[pAddress] + pContent;

		if (this.storeEventLog)
		{
			this.eventLog.Append.push(this.createEventLogEntry(pAddress, pContent));
		}

		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}
	customPrependFunction (pAddress, pContent)
	{
		this.contentMap[pAddress] = (typeof(this.contentMap[pAddress]) == 'undefined') ? pContent : pContent + this.contentMap[pAddress];

		if (this.storeEventLog)
		{
			this.eventLog.Prepend.push(this.createEventLogEntry(pAddress, pContent));
		}

		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	customAssignFunction (pAddress, pContent)
	{
		this.contentMap[pAddress] = pContent;

		if (this.storeEventLog)
		{
			this.eventLog.Prepend.push(this.createEventLogEntry(pAddress, pContent));
		}

		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	initializeAttributeMapLocation(pAddress, pAttribute)
	{
		if (!(pAddress in this.contentMap._ATTRIBUTE_MAP))
		{
			this.contentMap._ATTRIBUTE_MAP[pAddress] = {};
		}
		if (!(pAttribute in this.contentMap._ATTRIBUTE_MAP[pAddress]))
		{
			this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute] = false;
		}
	}

	initializeClassMapLocation(pAddress)
	{
		if (!(pAddress in this.contentMap._CLASS_MAP))
		{
			this.contentMap._CLASS_MAP[pAddress] = [];
		}
	}

	customReadAttributeFunction (pAddress, pAttribute)
	{
		this.initializeAttributeMapLocation(pAddress, pAttribute);

		let tmpContent = this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute];

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pAttribute));
		}

		if (tmpContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ATTRIBUTE READ for Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: tmpContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ATTRIBUTE READ for Address -> [${pAddress}]::[${pAttribute}]`, {Content: tmpContent});
		}
		return tmpContent;
	}

	customSetAttributeFunction (pAddress, pAttribute, pValue)
	{
		this.initializeAttributeMapLocation(pAddress, pAttribute);

		this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute] = pValue;

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pAttribute));
		}

		if (pValue.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ATTRIBUTE SET for Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pValue.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ATTRIBUTE SET for Address -> [${pAddress}]::[${pAttribute}]`, {Content: pValue});
		}
		return pValue;
	}

	customRemoveAttributeFunction (pAddress, pAttribute)
	{
		this.initializeAttributeMapLocation(pAddress, pAttribute);

		let tmpContent = this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute];

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pAttribute));
		}

		if (tmpContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ATTRIBUTE REMOVE for Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: tmpContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ATTRIBUTE REMOVE for Address -> [${pAddress}]::[${pAttribute}]`, {Content: tmpContent});
		}

		delete this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute];

		return true;
	}

	customReadClassFunction (pAddress, pClass)
	{
		this.initializeClassMapLocation(pAddress);

		const tmpContent = this.contentMap._CLASS_MAP[pAddress].indexOf(pClass) > -1;

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pClass));
		}
		this.pict.log.info(`Mocking an CLASS READ for Address -> [${pAddress}]::[${pClass}]`, {Content: tmpContent});

		return tmpContent;
	}

	customSetClassFunction (pAddress, pClass)
	{
		this.initializeClassMapLocation(pAddress);

		let tmpContent = this.contentMap._CLASS_MAP[pAddress];

		if (this.contentMap._CLASS_MAP[pAddress].indexOf(pClass) == -1)
		{
			this.contentMap._CLASS_MAP[pAddress].push(pClass);
		}

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pClass));
		}
		this.pict.log.info(`Mocking an CLASS SET for Address -> [${pAddress}]::[${pClass}]`, {Content: tmpContent.join(' ')});

		return tmpContent;
	}

	customRemoveClassFunction (pAddress, pClass)
	{
		this.initializeClassMapLocation(pAddress);

		let tmpContent = this.contentMap._CLASS_MAP[pAddress];

		this.contentMap._CLASS_MAP[pAddress].splice(pClass);

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pClass));
		}
		this.pict.log.info(`Mocking an CLASS REMOVE for Address -> [${pAddress}]::[${pClass}]`, {Content: tmpContent.join(' ')});

		return tmpContent;
	}
}

module.exports = PictEnvironmentObject;

},{}],378:[function(require,module,exports){

/**
 * @typedef {{
 *   ValueTemplate?: string,
 *   Value?: string,
 *   CoreEntity: string,
 *   Instruction: string,
 *   Operator: string,
 *   Fields: string[],
 * }} FilterConnection
 *
 * @typedef {{
 *   GUID: string,
 *   Filters: Array<Record<string, any>>,
 *   JoinConfig?: FilterConnection,
 * 	 Ordinal?: number,
 * 	 Junction?: string,
 * 	 GroupOpen?: boolean,
 *   GroupJunction?: string,
 *   GroupClose?: boolean
 * }} PreparedFilter
 * 
 * * @typedef {{
 *   PreparedFilters?: Array<PreparedFilter>,
 *   Junction?: string,
 *   Ordinal?: number,
 *   GUIDGroup: string
 * }} FilterGroup
 *
 * @typedef {{
 *   Entity: string,
 * 	 Groups: Array<FilterGroup>,
 *   Filter: string,
 *   ResultDestinationAddress: string,
 *   Mode?: 'Count' | 'Records',
 *   RecordOffset?: number,
 *   PageSize?: number,
 *   FilterConfiguration: Array<Record<string, any>>,
 *   PreparedFilters: Array<PreparedFilter>,
 *   BundleConfig?: Array<Record<string, any>>,
 *   UserFilters?: Array<string>,
 * 	 Postfix?: string,
 * 	 Scope?: string,
 * 	 Projection?: Record<string, any>,
 * }} FilterState
 *
 * @typedef { 'None' |
 * 'Match' | 'StringMatch' | 'DateMatch' | 'NumericMatch' |
 * 'Range' | 'StringRange' | 'DateRange' | 'NumericRange' |
 * 'DistinctSelectedValueList' |
 * 'InternalJoinMatch' | 'InternalJoinStringMatch' | 'InternalJoinNumericMatch' | 'InternalJoinDateMatch' |
 * 'InternalJoinRange' | 'InternalJoinStringRange' | 'InternalJoinNumericRange' | 'InternalJoinDateRange'  | 'InternalJoinSelectedValue' | 'InternalJoinSelectedValueList' |
 * 'ExternalJoinMatch' | 'ExternalJoinStringMatch' | 'ExternalJoinNumericMatch' | 'ExternalJoinDateMatch' |
 * 'ExternalJoinRange' | 'ExternalJoinStringRange' | 'ExternalJoinNumericRange' | 'ExternalJoinDateRange' | 'ExternalJoinSelectedValue' | 'ExternalJoinSelectedValueList' } FilterType
 */

class FilterMeadowStanzaTokenGenerator
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		this.fable = pFable;
		this.pict = pFable;
		this.log = pFable.log;
	}

	/**
	 * @param {FilterState} pFilterState
	 */
	generateMeadowFilterStanzas(pFilterState)
	{
		let tmpResult = [];
		pFilterState.UserFilters = [];
		const groupedFilterStates = {};
		if (Array.isArray(pFilterState.Groups))
		{
			for (let g of pFilterState.Groups)
			{
				groupedFilterStates[g.GUIDGroup] =
				Object.assign({
					PreparedFilters: [],
					Junction: 'AND',
					Ordinal: 0
				}, g);
			}
		}
		for (const tmpFilterConfig of pFilterState.FilterConfiguration || [])
		{
			if (tmpFilterConfig.Enabled === false)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.info(`Skipping disabled filter configuration: ${tmpFilterConfig.Type}`, { FilterConfig: tmpFilterConfig });
				}
				continue;
			}
			/** @type {PreparedFilter} */
			const tmpFilterResult = { GUID: this.pict.getUUID(), Filters: [], Ordinal: tmpFilterConfig.Ordinal || 0, Junction: tmpFilterConfig.Junction || 'AND' };
			const tmpValuesArray = Array.isArray(tmpFilterConfig.Values) ? tmpFilterConfig.Values : tmpFilterConfig.Value != null && tmpFilterConfig.Value != '' && (tmpFilterConfig.Type != 'ExternalJoinDateMatch' || tmpFilterConfig.Value != 0) ? [ tmpFilterConfig.Value ] : [];
			let tmpFilterByColumns;
			switch (tmpFilterConfig.Type)
			{
				case 'ExternalJoinSelectedValue':
				case 'ExternalJoinSelectedValueList':
					tmpFilterByColumns = [ tmpFilterConfig.ExternalFilterTableLookupColumn || `ID${tmpFilterConfig.ExternalFilterByTable}` ];
					// fall through
				case 'ExternalJoinMatch':
				case 'ExternalJoinStringMatch':
				case 'ExternalJoinDateMatch':
				case 'ExternalJoinNumericMatch':
					/*
					  "Values": [ "John", "Jane" ],
					  "ExternalFilterByColumns": [ "Name" ],
					  "ExactMatch": false,

					  "CoreConnectionColumn": "IDBook",

					  "JoinTable": "BookAuthorJoin",
					  "JoinTableExternalConnectionColumn": "IDAuthor",
					  "JoinTableCoreConnectionColumn": "IDBook",

					  "ExternalFilterByTable": "Author",
					  "ExternalFilterByTableConnectionColumn": "IDAuthor",
					 */
					if (!tmpFilterByColumns)
					{
						tmpFilterByColumns = tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]);
					}
					for (const tmpField of tmpFilterByColumns)
					{
						for (const tmpValue of tmpValuesArray)
						{
							const tmpFilter =
							{
								Index: -1,
								Entity: tmpFilterConfig.ExternalFilterByTable,
								Instruction: 'FBVOR',
								Field: tmpField,
							};
							if (tmpFilterConfig.ExactMatch || (typeof tmpFilterConfig.ExactMatch === 'undefined' &&
									(tmpFilterConfig.Type == 'ExternalJoinNumericMatch' || tmpFilterConfig.Type == 'ExternalJoinDateMatch' || tmpFilterConfig.Type == 'ExternalJoinSelectedValue' || tmpFilterConfig.Type == 'ExternalJoinSelectedValueList')))
							{
								//TODO: optimize this to use in-list, but requires restructuring of this code
								tmpFilter.Operator = 'EQ';
								tmpFilter.Value = tmpValue;
							}
							else
							{
								tmpFilter.Operator = 'LK';
								tmpFilter.Value = `%25${tmpValue}%25`; //FIXME: point of URI encoding needs to be addressed
							}
							tmpFilterResult.Filters.push(tmpFilter);
						}
					}
					if (!tmpFilterConfig.JoinTable)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTable, cannot filter join table.`, { FilterConfig: tmpFilterConfig });
						break;
					}
					if (!tmpFilterConfig.JoinTableExternalConnectionColumn)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTableExternalConnectionColumn, cannot filter join table [${tmpFilterConfig.JoinTable}].`);
						break;
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						tmpFilterResult.Filters.push(
						{
							Index: 0,
							Fulcrum: true,
							Entity: tmpFilterConfig.JoinTable,
							Instruction: 'FBL',
							Field: tmpFilterConfig.JoinTableExternalConnectionColumn,
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.ExternalFilterByTableConnectionColumn || tmpFilterConfig.JoinTableExternalConnectionColumn}^Record.State[Step-1]~}`,
						});
						if (tmpFilterConfig.PolyJoinRemoteType)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Fulcrum: true,
								Entity: tmpFilterConfig.JoinTable,
								Instruction: 'FBV',
								Field: tmpFilterConfig.PolyJoinRemoteColumn || 'RemoteType',
								Operator: 'EQ',
								ValueTemplate: tmpFilterConfig.PolyJoinRemoteType,
							});
						}
						if (!tmpFilterConfig.CoreConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing CoreConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							CoreEntity: pFilterState.Entity,
							Instruction: 'FBLOR',
							Fields: [ tmpFilterConfig.CoreConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinTableCoreConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'ExternalJoinStringRange':
				case 'ExternalJoinNumericRange':
				case 'ExternalJoinDateRange':
				case 'ExternalJoinRange':
					if (!tmpFilterConfig.Values || (tmpFilterConfig.Values.Start == null && tmpFilterConfig.Values.End == null))
					{
						break;
					}

					// do not honor '0' for dates
					if (tmpFilterConfig.Type == 'ExternalJoinDateRange')
					{
						if ((!tmpFilterConfig.Values.Start || tmpFilterConfig.Values.Start == '0') &&
								(!tmpFilterConfig.Values.End || tmpFilterConfig.Values.End == '0'))
						{
							break;
						}
					}

					for (const tmpField of tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]))
					{
						const hasStartValue = tmpFilterConfig.Values && tmpFilterConfig.Values.Start && (tmpFilterConfig.Type != 'ExternalJoinDateRange' || tmpFilterConfig.Values.Start != '0');
						const hasEndValue = tmpFilterConfig.Values && tmpFilterConfig.Values.End && (tmpFilterConfig.Type != 'ExternalJoinDateRange' || tmpFilterConfig.Values.End != '0');
						if (hasStartValue)
						{
							// Range is `(Start <= field <= End)` — both bounds AND'd; per-
							// group serializer wraps the stanzas in a single paren group,
							// so no OpenParen needed here. See the matching note in the
							// core Range case below.
							tmpFilterResult.Filters.push(
							{
								Index: -1,
								Entity: tmpFilterConfig.ExternalFilterByTable,
								Instruction: 'FBV',
								CloseParen: false,
								Field: tmpField,
								Operator: tmpFilterConfig.StartExclusive ? 'GT' : 'GE',
								Value: tmpFilterConfig.Values.Start,
							});
						}
						if (hasEndValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: -1,
								Entity: tmpFilterConfig.ExternalFilterByTable,
								Instruction: 'FBV',
								CloseParen: false,
								Field: tmpField,
								Operator: tmpFilterConfig.EndExclusive ? 'LT' : 'LE',
								Value: tmpFilterConfig.Values.End,
							});
						}
					}
					if (!tmpFilterConfig.JoinTable)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTable, cannot filter join table.`, { FilterConfig: tmpFilterConfig });
						break;
					}
					if (!tmpFilterConfig.JoinTableExternalConnectionColumn)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTableExternalConnectionColumn, cannot filter join table [${tmpFilterConfig.JoinTable}].`);
						break;
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						tmpFilterResult.Filters.push(
						{
							Index: 0,
							Fulcrum: true,
							Entity: tmpFilterConfig.JoinTable,
							Instruction: 'FBL',
							Field: tmpFilterConfig.JoinTableExternalConnectionColumn,
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.ExternalFilterByTableConnectionColumn || tmpFilterConfig.JoinTableExternalConnectionColumn}^Record.State[Step-1]~}`,
						});
						if (tmpFilterConfig.PolyJoinRemoteType)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Fulcrum: true,
								Entity: tmpFilterConfig.JoinTable,
								Instruction: 'FBV',
								Field: tmpFilterConfig.PolyJoinRemoteColumn || 'RemoteType',
								Operator: 'EQ',
								ValueTemplate: tmpFilterConfig.PolyJoinRemoteType,
							});
						}
						if (!tmpFilterConfig.CoreConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing CoreConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						if (!tmpFilterConfig.JoinTableCoreConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing JoinTableCoreConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							CoreEntity: pFilterState.Entity,
							Instruction: 'FBLOR',
							Fields: [ tmpFilterConfig.CoreConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinTableCoreConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'StringRange':
				case 'DateRange':
				case 'NumericRange':
				case 'Range':
					if (!tmpFilterConfig.Values || (tmpFilterConfig.Values.Start == null && tmpFilterConfig.Values.End == null))
					{
						break;
					}

					// do not honor '0' for dates
					if (tmpFilterConfig.Type == 'DateRange')
					{
						if ((!tmpFilterConfig.Values.Start || tmpFilterConfig.Values.Start == '0') &&
								(!tmpFilterConfig.Values.End || tmpFilterConfig.Values.End == '0'))
						{
							break;
						}
					}
					/*
					  "Values":
					  {
						  "Start": "2023-01-01T00:00:00Z",
						  "End": "2024-01-01T00:00:00Z"
					  },
					  "FilterByColumn": "CreateDate",
					 */
					for (const tmpField of tmpFilterConfig.FilterByColumns || (tmpFilterConfig.FilterByColumn ? [ tmpFilterConfig.FilterByColumn ] : [ 'Name' ]))
					{
						const hasStartValue = tmpFilterConfig.Values && tmpFilterConfig.Values.Start && (tmpFilterConfig.Type != 'DateRange' || tmpFilterConfig.Values.Start != '0');
						const hasEndValue = tmpFilterConfig.Values && tmpFilterConfig.Values.End && (tmpFilterConfig.Type != 'DateRange' || tmpFilterConfig.Values.End != '0');
						if (hasStartValue)
						{
							// Range is `(Start <= field <= End)` — both bounds AND'd. No
							// OpenParen here; the per-group serializer already wraps the
							// stanzas in one paren group, and meadow-endpoints' filter
							// parser rejects further nesting (`FOP(FOP(...))` 404s on the
							// /1.0/PrivateDataLake/* routes).
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								CoreEntity: true,
								Entity: pFilterState.Entity,
								Instruction: 'FBV',
								Field: tmpField,
								CloseParen: false,
								Operator: tmpFilterConfig.StartExclusive ? 'GT' : 'GE',
								Value: tmpFilterConfig.Values.Start,
							});
						}
						if (hasEndValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								CoreEntity: true,
								Entity: pFilterState.Entity,
								Instruction: 'FBV',
								CloseParen: false,
								Field: tmpField,
								Operator: tmpFilterConfig.EndExclusive ? 'LT' : 'LE',
								Value: tmpFilterConfig.Values.End,
							});
						}
					}
					break;
				case 'StringMatch':
				case 'DateMatch':
				case 'NumericMatch':
				case 'Match':
					/*
					  "Values": [ "John", "Jane" ],
					  "FilterByColumn": "Name",
					  "ExactMatch": false,
					 */
					for (const tmpField of tmpFilterConfig.FilterByColumns || (tmpFilterConfig.FilterByColumn ? [ tmpFilterConfig.FilterByColumn ] : [ 'Name' ]))
					{
						for (const tmpValue of tmpValuesArray)
						{
							const tmpFilter =
							{
								Index: 0,
								CoreEntity: true,
								Entity: pFilterState.Entity,
								Instruction: 'FBVOR',
								Field: tmpField,
							};
							// don't use like for numbers
							if (tmpFilterConfig.ExactMatch || (typeof tmpFilterConfig.ExactMatch === 'undefined' &&
									(tmpFilterConfig.Type == 'NumericMatch' || tmpFilterConfig.Type == 'DateMatch')))
							{
								tmpFilter.Operator = 'EQ';
								tmpFilter.Value = tmpValue;
							}
							else
							{
								tmpFilter.Operator = 'LK';
								tmpFilter.Value = `%25${tmpValue}%25`; //FIXME: figure out a cleaner way to do URL encoding for these - probably, should be downstream, but isn't currently
							}
							tmpFilterResult.Filters.push(tmpFilter);
						}
					}
					break;
				case 'DistinctSelectedValueList':
					/*
					  "Values": [ "1/4\" Chip", "MFG'D Sand" ],
					  "FilterByColumn": "Product",

					  Equality against selected distinct values of a column on the CORE
					  entity (no join) — an OR-chain of EQ stanzas the per-group serializer
					  wraps in ONE paren group. NOT FBL~INN: the server parser comma-splits
					  FBL list values, which corrupts string values containing commas.
					 */
					for (const tmpField of tmpFilterConfig.FilterByColumns || (tmpFilterConfig.FilterByColumn ? [ tmpFilterConfig.FilterByColumn ] : [ 'Name' ]))
					{
						for (const tmpValue of tmpValuesArray)
						{
							if (tmpValue == null)
							{
								continue;
							}
							// The server tokenizes the (URI-decoded) filter string on '~', so a
							// value containing a literal '~' is unrepresentable in the syntax.
							if (typeof tmpValue === 'string' && tmpValue.indexOf('~') >= 0)
							{
								this.log.warn(`DistinctSelectedValueList value contains '~' (unrepresentable in the meadow filter syntax); skipping value.`, { Field: tmpField, Value: tmpValue });
								continue;
							}
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								CoreEntity: true,
								Entity: pFilterState.Entity,
								Instruction: 'FBVOR',
								Field: tmpField,
								Operator: 'EQ',
								Value: encodeURIComponent(tmpValue),
							});
						}
					}
					break;
				case 'InternalJoinStringRange':
				case 'InternalJoinNumericRange':
				case 'InternalJoinDateRange':
				case 'InternalJoinRange':
					if (!tmpFilterConfig.Values || (tmpFilterConfig.Values.Start == null && tmpFilterConfig.Values.End == null))
					{
						break;
					}

					// do not honor '0' for dates
					if (tmpFilterConfig.Type == 'InternalJoinDateRange')
					{
						if ((!tmpFilterConfig.Values.Start || tmpFilterConfig.Values.Start == '0') &&
								(!tmpFilterConfig.Values.End || tmpFilterConfig.Values.End == '0'))
						{
							break;
						}
					}

					for (const tmpField of tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]))
					{
						const hasStartValue = tmpFilterConfig.Values && tmpFilterConfig.Values.Start && (tmpFilterConfig.Type != 'InternalJoinDateRange' || tmpFilterConfig.Values.Start != '0');
						const hasEndValue = tmpFilterConfig.Values && tmpFilterConfig.Values.End && (tmpFilterConfig.Type != 'InternalJoinDateRange' || tmpFilterConfig.Values.End != '0');
						if (hasStartValue)
						{
							// Range bounds AND'd within the per-group paren wrap.
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Entity: tmpFilterConfig.RemoteTable,
								Instruction: 'FBV',
								Field: tmpField,
								CloseParen: false,
								Operator: tmpFilterConfig.StartExclusive ? 'GT' : 'GE',
								Value: tmpFilterConfig.Values.Start,
							});
						}
						if (hasEndValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Entity: tmpFilterConfig.RemoteTable,
								Instruction: 'FBV',
								CloseParen: false,
								Field: tmpField,
								Operator: tmpFilterConfig.EndExclusive ? 'LT' : 'LE',
								Value: tmpFilterConfig.Values.End,
							});
						}
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						if (!tmpFilterConfig.JoinInternalConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing JoinInternalConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							Instruction: 'FBLOR',
							CoreEntity: pFilterState.Entity,
							Fields: [ tmpFilterConfig.JoinInternalConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinExternalConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'InternalJoinSelectedValue':
				case 'InternalJoinSelectedValueList':
					tmpFilterByColumns = [ tmpFilterConfig.ExternalFilterTableLookupColumn || `ID${tmpFilterConfig.RemoteTable}` ];
					// fall through
				case 'InternalJoinMatch':
				case 'InternalJoinStringMatch':
				case 'InternalJoinDateMatch':
				case 'InternalJoinNumericMatch':
					/*
					  "Values": [ "Bob" ],
                      "RemoteTable": "User",
                      "ExternalFilterByColumns": [ "NameFirst", "NameLast" ],
                      "JoinExternalConnectionColumn": "IDUser",
                      "JoinInternalConnectionColumn": "CreatingIDUser",
					 */
					if (!tmpFilterByColumns)
					{
						tmpFilterByColumns = tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]);
					}
					for (const tmpField of tmpFilterByColumns)
					{
						for (const tmpValue of tmpValuesArray)
						{
							const tmpFilter =
							{
								Index: 0,
								Entity: tmpFilterConfig.RemoteTable,
								Instruction: 'FBVOR',
								Field: tmpField,
							};
							if (tmpFilterConfig.ExactMatch || (typeof tmpFilterConfig.ExactMatch === 'undefined' &&
									(tmpFilterConfig.Type == 'InternalJoinNumericMatch' || tmpFilterConfig.Type == 'InternalJoinDateMatch' || tmpFilterConfig.Type == 'InternalJoinSelectedValue' || tmpFilterConfig.Type == 'InternalJoinSelectedValueList')))
							{
								//TODO: optimize this to use in-list, but requires restructuring of this code
								tmpFilter.Operator = 'EQ';
								tmpFilter.Value = tmpValue;
							}
							else
							{
								tmpFilter.Operator = 'LK';
								tmpFilter.Value = `%25${tmpValue}%25`;
							}
							tmpFilterResult.Filters.push(tmpFilter);
						}
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						if (!tmpFilterConfig.JoinInternalConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing JoinInternalConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							Instruction: 'FBLOR',
							CoreEntity: pFilterState.Entity,
							Fields: [ tmpFilterConfig.JoinInternalConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinExternalConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'RawFilter':
					if (!tmpFilterConfig.Value)
					{
						this.log.warn(`RawFilter configuration missing Value, not adding filter.`, { FilterConfig: tmpFilterConfig });
						break;
					}
					pFilterState.UserFilters.push(tmpFilterConfig.Value);
					break;
				default:
					this.log.warn(`Unknown filter type ${tmpFilterConfig.Type} in filter configuration.`, { FilterConfig: tmpFilterConfig });
			}
			// Per-clause URLPrefix knob: the remote-table resolution requests (the join lookup
			// against RemoteTable) otherwise inherit the recordset entity provider's URLPrefix.
			// When a clause's remote entity lives at a different API root than the recordset
			// (e.g. a lake-backed recordset joining to a main-API entity), set URLPrefix on the
			// clause to resolve the join there. The core-entity (recordset) request is unaffected.
			if (tmpFilterConfig.URLPrefix)
			{
				for (const tmpRemoteResolutionFilter of tmpFilterResult.Filters)
				{
					tmpRemoteResolutionFilter.URLPrefix = tmpFilterConfig.URLPrefix;
				}
			}
			// Non-core join-resolution steps are consumed only by a PJU pluck of a
			// single connection column; record it so the compiled step can project
			// the read to that column instead of materializing full records.
			for (const tmpRemoteResolutionFilter of tmpFilterResult.Filters)
			{
				if (tmpRemoteResolutionFilter.CoreEntity)
				{
					continue;
				}
				if (tmpRemoteResolutionFilter.Index === -1)
				{
					tmpRemoteResolutionFilter.PluckColumn = tmpFilterConfig.ExternalFilterByTableConnectionColumn || tmpFilterConfig.JoinTableExternalConnectionColumn;
				}
				else if (tmpRemoteResolutionFilter.Index === 0)
				{
					tmpRemoteResolutionFilter.PluckColumn = tmpFilterConfig.JoinTable ? tmpFilterConfig.JoinTableCoreConnectionColumn : tmpFilterConfig.JoinExternalConnectionColumn;
				}
			}
			if (tmpFilterResult.Filters.length > 0)
			{
				if (tmpFilterConfig.GUIDGroup)
				{
					if (groupedFilterStates[tmpFilterConfig.GUIDGroup])
					{
						groupedFilterStates[tmpFilterConfig.GUIDGroup].PreparedFilters.push(tmpFilterResult);
					}
					else
					{
						groupedFilterStates[tmpFilterConfig.GUIDGroup] = 
						{
							PreparedFilters: [tmpFilterResult],
							Junction: 'AND',
							Ordinal: 0
						};
					}
				}
				else
				{
					tmpResult.push(tmpFilterResult);
				}
			}
		}
		const sortSet = (arr) =>
		{
			for (let x = 0; x < arr.length; x++)
			{
				arr[x].Ordinal = arr[x].Ordinal || 0;
			}
			return arr.sort((a, b) => 
			{
				if (a.Ordinal > b.Ordinal)
				{
					return 1;
				}
				else if (b.Ordinal > a.Ordinal)
				{
					return -1;
				}
				return 0;
			});
		};
		const spreadGroupings = (arr) =>
		{
			const outputSet = [];
			for (const group of arr)
			{
				if (group.PreparedFilters)
				{
					group.PreparedFilters[0].GroupOpen = true;
					group.PreparedFilters[0].GroupJunction = group.Junction;
					group.PreparedFilters[group.PreparedFilters.length - 1].GroupClose = true;
					for (let x = 0; x < group.PreparedFilters.length; x++)
					{
						outputSet.push(group.PreparedFilters[x]);
					}
				}
				else
				{
					outputSet.push(group);
				}
			}
			return outputSet;
		};
		for (let g of Object.keys(groupedFilterStates))
		{
			if (groupedFilterStates[g].PreparedFilters?.length)
			{
				groupedFilterStates[g].PreparedFilters = sortSet(groupedFilterStates[g].PreparedFilters);
			}
			tmpResult.push(groupedFilterStates[g]);
		}
		tmpResult = spreadGroupings(sortSet(tmpResult));
		pFilterState.PreparedFilters = tmpResult;
	}

	/**
	 * @param {FilterState} pFilterState
	 */
	linkPreparedFilters(pFilterState)
	{
		const tmpGroupedStanzas = [];
		for (const tmpPreparedFilter of pFilterState.PreparedFilters || [])
		{
			if (tmpPreparedFilter.JoinConfig)
			{
				const tmpSubGroup = tmpPreparedFilter.Filters;
				const tmpJoinConfig = tmpPreparedFilter.JoinConfig;
				for (const tmpField of tmpJoinConfig.Fields || [])
				{
					const tmpStanza =
					{
						Index: 1,
						CoreEntity: true,
						Entity: tmpPreparedFilter.JoinConfig.CoreEntity,
						Instruction: tmpPreparedFilter.JoinConfig.Instruction || 'FBVOR',
						Field: tmpField,
						Operator: tmpJoinConfig.Operator,
						Value: tmpJoinConfig.Value,
						ValueTemplate: tmpJoinConfig.ValueTemplate,
					};
					tmpSubGroup.push(tmpStanza);
				}
				tmpGroupedStanzas.push(tmpSubGroup);
			}
			else
			{
				tmpGroupedStanzas.push(tmpPreparedFilter.Filters);
			}
		}
		return tmpGroupedStanzas;
	}

	/**
	 * Generate a computed index for each filter in the meadow filter stanzas such that the overall address space is non-overlapping and stable.
	 *
	 * @param {FilterState} pFilterState
	 */
	normalizeMeadowFilterStanzas(pFilterState)
	{
		let tmpTotalIndexCount = 0;
		for (const tmpFilterGroup of pFilterState.PreparedFilters)
		{
			const tmpLocalIndices = new Set();
			tmpFilterGroup.Filters.sort((a, b) => a.Index - b.Index);
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (!tmpFilter.CoreEntity)
				{
					tmpLocalIndices.add(tmpFilter.Index);
				}
			}
			tmpTotalIndexCount += tmpLocalIndices.size;
		}

		let tmpComputedIndex = -tmpTotalIndexCount - 1;

		for (const tmpFilterGroup of pFilterState.PreparedFilters)
		{
			let tmpCurrentIndex = null;
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (tmpFilter.Index !== tmpCurrentIndex)
				{
					++tmpComputedIndex;
					tmpCurrentIndex = tmpFilter.Index;
				}
				tmpFilter.ComputedIndex = tmpComputedIndex;
			}
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (tmpFilter.ValueTemplate)
				{
					tmpFilter.ValueTemplate = tmpFilter.ValueTemplate.replace(/\[([^\]]+)\]/g, (match) =>
					{
						const tmpLocalIndex = match.substring(5, match.length - 1);
						const tmpGlobalIndex = tmpFilterGroup.Filters.find((f) => f.Index == tmpLocalIndex)?.ComputedIndex;
						if (tmpGlobalIndex == null)
						{
							throw new Error(`Filter index ${tmpLocalIndex} not found in group filters.`);
						}
						return match.replace(tmpLocalIndex, tmpGlobalIndex);
					});
				}
			}
		}
	}

	/**
	 * @param {FilterState} pFilterState
	 */
	compileMeadowFilterStanzas(pFilterState)
	{
		const tmpBundleConfig = [];
		//TODO: mathematically solve the number line
		// planned synthesized syntax for running on the server
		// FBV-3_Author~Name~LK~%25Ann%25~FBL-2_BookAuthorJoin~IDAuthor~INN~{~PJU:,^State[Step-3]^IDAuthor~}~FBV-1~User~NameFirst~LK~%25Bob%25~FBVOR-1~User~NameLast~LK~%25Bob%25~FBV~CreateDate~GT~2023-01-01T00:00:00Z~FBV~CreateDate~LT~2024-01-01T00:00:00Z~FBL~IDBook~INN~{~PJU:,^State[Step-2]^IDBook~}
		if (!pFilterState.Filter)
		{
			pFilterState.Filter = `${pFilterState.Entity || 'Unknown'}-${this.pict.getUUID()}`;
		}
		tmpBundleConfig.push(
		{
			Type: 'SetStateAddress',
			StateAddress: `Bundle[${pFilterState.Filter}]`,
		});
		const tmpGroupedFilters = {};
		const tmpGroupedFilterKeys = [];
		const tmpGroupedCoreFilters = [];
		const tmpGroupedCoreFilterKeys = [];
		let tmpCoreEntity;
		const tmpCoreFilterStrings = [];
		for (const tmpFilterGroup of pFilterState.PreparedFilters)
		{
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (tmpFilter.CoreEntity)
				{
					tmpCoreEntity = tmpFilter.Entity;
					const tmpFilterGUID = `${tmpFilterGroup.GUID}-${tmpFilter.ComputedIndex}`;
					if (!tmpGroupedCoreFilterKeys.find((v) => v == tmpFilterGUID))
					{
						tmpGroupedCoreFilterKeys.push(tmpFilterGUID);
					}
					if (!tmpGroupedCoreFilters[tmpFilterGUID])
					{
						tmpGroupedCoreFilters[tmpFilterGUID] = { Stanzas: [], ComputedIndex: tmpFilter.ComputedIndex, Entity: tmpFilter.Entity, Junction: tmpFilterGroup.Junction || 'AND', GroupOpen: tmpFilterGroup.GroupOpen || false, GroupJunction: tmpFilterGroup.GroupJunction || 'AND', GroupClose: tmpFilterGroup.GroupClose || false };
					}
					tmpGroupedCoreFilters[tmpFilterGUID].Stanzas.push(this._compileSimpleFilterToString(tmpFilter));
				}
				else
				{
					const tmpFilterGroupGUID = `${tmpFilterGroup.GUID}-${tmpFilter.ComputedIndex}`;
					if (!tmpGroupedFilterKeys.find((v) => v == tmpFilterGroupGUID))
					{
						tmpGroupedFilterKeys.push(tmpFilterGroupGUID);
					}
					if (!tmpGroupedFilters[tmpFilterGroupGUID])
					{
						tmpGroupedFilters[tmpFilterGroupGUID] = { Stanzas: [], ComputedIndex: tmpFilter.ComputedIndex, Entity: tmpFilter.Entity, URLPrefix: tmpFilter.URLPrefix, PluckColumn: tmpFilter.PluckColumn };
					}
					tmpGroupedFilters[tmpFilterGroupGUID].Stanzas.push(this._compileSimpleFilterToString(tmpFilter));
				}
			}
		}
		for (const tmpFilterGroupKey of tmpGroupedFilterKeys)
		{
			tmpGroupedFilters[tmpFilterGroupKey].Stanzas = tmpGroupedFilters[tmpFilterGroupKey].Stanzas.filter((f) => f.length > 0);
			if (tmpGroupedFilters[tmpFilterGroupKey].Stanzas.length > 0)
			{
				const tmpResolutionStep =
					{
						Type: 'MeadowEntity',
						AllRecords: true,
						Entity: tmpGroupedFilters[tmpFilterGroupKey].Entity,
						URLPrefix: tmpGroupedFilters[tmpFilterGroupKey].URLPrefix,
						Filter: tmpGroupedFilters[tmpFilterGroupKey].Stanzas.join('~'),
						Destination: `State[Step${tmpGroupedFilters[tmpFilterGroupKey].ComputedIndex}]`,
					};
				if (tmpGroupedFilters[tmpFilterGroupKey].PluckColumn)
				{
					tmpResolutionStep.Projection = { Mode: 'Distinct', Columns: [ tmpGroupedFilters[tmpFilterGroupKey].PluckColumn ] };
				}
				tmpBundleConfig.push(tmpResolutionStep);
			}
		}
		for (const tmpCoreFilterKey of tmpGroupedCoreFilterKeys)
		{
			tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas = tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas.filter((f) => f.length > 0);
			if (tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas.length > 0)
			{
				let stringConstruct = '';
				if (tmpGroupedCoreFilters[tmpCoreFilterKey].GroupOpen)
				{
					stringConstruct += tmpGroupedCoreFilters[tmpCoreFilterKey].GroupJunction == 'OR' ? 'FOPOR~0~(~0~' : 'FOP~0~(~0~';
				}
				stringConstruct += [ tmpGroupedCoreFilters[tmpCoreFilterKey].Junction == 'OR' ? 'FOPOR~0~(~0' : 'FOP~0~(~0', ...tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas, 'FCP~0~)~0'].join('~');
				if (tmpGroupedCoreFilters[tmpCoreFilterKey].GroupClose)
				{
					stringConstruct += '~FCP~0~)~0'
				}
				tmpCoreFilterStrings.push(stringConstruct);
			}
		}
		if (!tmpCoreEntity)
		{
			tmpCoreEntity = pFilterState.Entity;
		}
		const tmpCoreLoadStep =
		{
			Type: pFilterState.Mode === 'Count' ? 'MeadowEntityCount' : 'MeadowEntity',
			Entity: tmpCoreEntity,
			Filter: tmpCoreFilterStrings.join('~'),
			AllRecords: typeof pFilterState.PageSize === 'undefined',
			RecordStartCursor: pFilterState.RecordOffset,
			Postfix: pFilterState.Postfix || '',
			Scope: pFilterState.Scope || '',
			Projection: pFilterState.Projection,
			PageSize: pFilterState.PageSize,
			Destination: pFilterState.ResultDestinationAddress,
		};
		if (pFilterState.UserFilters.length > 0)
		{
			let tmpAllSorts = '';
			let tmpFilter = '';
			for (const tmpUserFilter of pFilterState.UserFilters)
			{
				let tmpSorts;
				let tmpSanitizedUserFilter = tmpUserFilter;
				if (pFilterState.Mode === 'Count')
				{
					tmpSanitizedUserFilter = this._sanitizeFilterForCount(tmpUserFilter);
				}
				else
				{
					[ tmpSanitizedUserFilter, tmpSorts ] = this._extractSortsFromFilter(tmpUserFilter);
					if (tmpSorts)
					{
						if (tmpAllSorts.length > 0)
						{
							tmpAllSorts += '~';
						}
						tmpAllSorts += tmpSorts;
					}
					if (!tmpSanitizedUserFilter)
					{
						continue;
					}
				}
				if (!tmpSanitizedUserFilter)
				{
					continue;
				}
				if (tmpFilter.length > 0)
				{
					tmpFilter += '~';
				}
				// The user-filter and core-filter strings already carry their
				// own paren grouping from the per-group serializer above (the
				// `FOP(stanzas)` wrap at line 822). Wrapping a SECOND time here
				// produces `FOP(FOP(...))` which meadow-endpoints'
				// MeadowEndpoints dialect (used by the lake's
				// /PrivateDataLake/* routes) treats as malformed — the route
				// 404s instead of filtering. The right shape is one paren per
				// logical group, concatenated flat at the top level.
				tmpFilter += tmpSanitizedUserFilter;
			}
			if (tmpCoreLoadStep.Filter)
			{
				if (tmpFilter.length > 0)
				{
					tmpFilter += '~';
				}
				tmpFilter += tmpCoreLoadStep.Filter;
			}
			if (tmpAllSorts)
			{
				if (tmpFilter.length > 0)
				{
					tmpFilter += '~';
				}
				tmpFilter += tmpAllSorts;
			}
			tmpCoreLoadStep.Filter = tmpFilter;
		}
		tmpBundleConfig.push(tmpCoreLoadStep);
		pFilterState.BundleConfig = tmpBundleConfig;
	}

	/**
	 * @param {string} pFilter
	 *
	 * @return {string}
	 */
	_sanitizeFilterForCount(pFilter)
	{
		if (!pFilter || typeof pFilter !== 'string')
		{
			return pFilter;
		}

		let tmpMicroStanzas = pFilter.split('~');
		for (let i = 0; i < tmpMicroStanzas.length; i += 4)
		{
			if (tmpMicroStanzas[i] === 'FSF')
			{
				tmpMicroStanzas = tmpMicroStanzas.slice(0, i).concat(tmpMicroStanzas.slice(i + 4));
				i -= 4; // adjust for removed elements
			}
		}
		return tmpMicroStanzas.join('~');
	}

	/**
	 * @param {string} pFilter
	 *
	 * @return {Array<string>}
	 */
	_extractSortsFromFilter(pFilter)
	{
		if (!pFilter || typeof pFilter !== 'string')
		{
			return [ pFilter, '' ];
		}

		let tmpSortStanzas = [];
		let tmpMicroStanzas = pFilter.split('~');
		for (let i = 0; i < tmpMicroStanzas.length; i += 4)
		{
			if (tmpMicroStanzas[i] === 'FSF')
			{
				tmpSortStanzas.push(tmpMicroStanzas.slice(i, i + 4).join('~'));
				tmpMicroStanzas = tmpMicroStanzas.slice(0, i).concat(tmpMicroStanzas.slice(i + 4));
				i -= 4; // adjust for removed elements
			}
		}
		return [ tmpMicroStanzas.join('~'), tmpSortStanzas.join('~') ];
	}

	_compileSimpleFilterToString(pFilter)
	{
		let tmpFilterString = `${pFilter.Instruction}`;
		tmpFilterString += `~${pFilter.Field}`;
		tmpFilterString += `~${pFilter.Operator}`;
		if (pFilter.ValueTemplate)
		{
			tmpFilterString += `~${pFilter.ValueTemplate}`;
		}
		else
		{
			tmpFilterString += `~${pFilter.Value || ''}`;
		}
		if (pFilter.OpenParen)
		{
			tmpFilterString = `${ pFilter.OpenParenOr ? 'FOPOR' : 'FOP' }~0~(~0~${tmpFilterString}`;
		}
		if (pFilter.CloseParen)
		{
			tmpFilterString = `${tmpFilterString}~FCP~0~)~0`;
		}
		return tmpFilterString;
	}
}

module.exports = FilterMeadowStanzaTokenGenerator;

},{}],379:[function(require,module,exports){

/**
 * @typedef {{
 *    Type: 'None'
 * } | {
 *    Type: 'Match' | 'StringMatch' | 'DateMatch' | 'NumericMatch',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    FilterByColumn: string,
 * } | {
 *    Type: 'Range' | 'StringRange' | 'DateRange' | 'NumericRange',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    FilterByColumn: string,
 * } | {
 *    Type: 'InternalJoinMatch' | 'InternalJoinStringMatch' | 'InternalJoinNumericMatch' | 'InternalJoinDateMatch',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    RemoteTable: string,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    JoinExternalConnectionColumn: string,
 *    JoinInternalConnectionColumn: string,
 * } | {
 *    Type: 'InternalJoinSelectedValue' | 'InternalJoinSelectedValueList',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    RemoteTable: string,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    ExternalFilterTableLookupColumn?: string,
 *    JoinExternalConnectionColumn: string,
 *    JoinInternalConnectionColumn: string,
 * } | {
 *    Type: 'InternalJoinRange' | 'InternalJoinStringRange' | 'InternalJoinNumericRange' | 'InternalJoinDateRange',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    RemoteTable: string,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    JoinExternalConnectionColumn: string,
 *    JoinInternalConnectionColumn: string,
 * } | {
 *    Type: 'ExternalJoinMatch' | 'ExternalJoinStringMatch' | 'ExternalJoinNumericMatch' | 'ExternalJoinDateMatch',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    CoreConnectionColumn: string,
 *    JoinTable: string,
 *    JoinTableExternalConnectionColumn: string,
 *    JoinTableCoreConnectionColumn: string,
 *    ExternalFilterByTable: string,
 *    ExternalFilterByTableConnectionColumn: string,
 * 	  PolyJoinRemoteType: string,
 *    PolyJoinRemoteColumn: string
 * } | {
 *    Type: 'ExternalJoinRange' | 'ExternalJoinStringRange' | 'ExternalJoinNumericRange' | 'ExternalJoinDateRange',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    CoreConnectionColumn: string,
 *    JoinTable: string,
 *    JoinTableExternalConnectionColumn: string,
 *    JoinTableCoreConnectionColumn: string,
 *    ExternalFilterByTable: string,
 *    ExternalFilterByTableConnectionColumn: string,
 * 	  PolyJoinRemoteType: string,
 *    PolyJoinRemoteColumn: string
 * } | {
 *    Type: 'ExternalJoinSelectedValue' | 'ExternalJoinSelectedValueList',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    CoreConnectionColumn: string,
 *    JoinTable: string,
 *    JoinTableExternalConnectionColumn: string,
 *    JoinTableCoreConnectionColumn: string,
 *    ExternalFilterByTable: string,
 *    ExternalFilterTableLookupColumn?: string,
 *    ExternalFilterByTableConnectionColumn: string,
 * 	  PolyJoinRemoteType: string,
 *    PolyJoinRemoteColumn: string
 * }} FilterClauseConfig
 */

class FilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		this.fable = pFable;
		this.pict = pFable;
		this.log = pFable.log;

		/** @type {import('./Filter.js').FilterType} */
		this._type = 'None';
		/** @type {string[] | number[] | { Start?: string | number, End?: string | number }} */
		this.values = [];
	}


	/**
	 * @param {import('./Filter.js').FilterType} pType
	 */
	set type(pType)
	{
		this._type = pType;
		if (pType.includes('Range'))
		{
			if (typeof this.values !== 'object' || this.values === null || Array.isArray(this.values))
			{
				this.values = { Start: undefined, End: undefined };
			}
		}
		else
		{
			if (!Array.isArray(this.values))
			{
				this.values = [];
			}
		}
	}

	/**
	 * @return {import('./Filter.js').FilterType}
	 */
    get type()
    {
        return this._type;
    }

	/**
	 * @return {FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		return { Type: 'None' };
	}
}

module.exports = FilterClauseBase;

},{}],380:[function(require,module,exports){

const libFilterClauseBase = require('./FilterClauseBase.js');

/**
 * Manage filter state for a filter that works on a one level of indirect direct join.
 */
class FilterClauseExternalJoin extends libFilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		super(pFable);

		/** @type {import('./Filter.js').FilterType} */
		this.type = 'ExternalJoinMatch';
		/** @type {string[] | number[] | { Start?: string | number, End?: string | number }} */
		this.values = [];
		/** @type {boolean?} */
		this.exactMatch;
		/** @type {boolean?} */
		this.startExclusive;
		/** @type {boolean?} */
		this.endExclusive;
		/** @type {string?} */
		this.externalFilterByColumn;
		/** @type {string[]?} */
		this.externalFilterByColumns;
		/** @type {string} */
		this.coreConnectionColumn = '';
		/** @type {string} */
		this.joinTable = '';
		/** @type {string} */
		this.joinTableExternalConnectionColumn = '';
		/** @type {string} */
		this.joinTableCoreConnectionColumn = '';
		/** @type {string} */
		this.externalFilterByTable = '';
		/** @type {string} */
		this.externalFilterTableLookupColumn = '';
		/** @type {string} */
		this.externalFilterByTableConnectionColumn = '';
		/** @type {string} */
		this.polyJoinRemoteType = '';
		/** @type {string} */
		this.polyJoinRemoteColumn = '';
	}

	/**
	 * @return {import('./FilterClauseBase.js').FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		switch (this.type)
		{
			case 'ExternalJoinMatch':
			case 'ExternalJoinStringMatch':
			case 'ExternalJoinDateMatch':
			case 'ExternalJoinNumericMatch':
				return {
					Type: this.type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					CoreConnectionColumn: this.coreConnectionColumn,
					JoinTable: this.joinTable,
					JoinTableExternalConnectionColumn: this.joinTableExternalConnectionColumn,
					JoinTableCoreConnectionColumn: this.joinTableCoreConnectionColumn,
					ExternalFilterByTable: this.externalFilterByTable,
					ExternalFilterByTableConnectionColumn: this.externalFilterByTableConnectionColumn,
					PolyJoinRemoteType: this.polyJoinRemoteType,
					PolyJoinRemoteColumn: this.polyJoinRemoteColumn
				};
			case 'ExternalJoinRange':
			case 'ExternalJoinStringRange':
			case 'ExternalJoinDateRange':
			case 'ExternalJoinNumericRange':
				return {
					Type: this.type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					CoreConnectionColumn: this.coreConnectionColumn,
					JoinTable: this.joinTable,
					JoinTableExternalConnectionColumn: this.joinTableExternalConnectionColumn,
					JoinTableCoreConnectionColumn: this.joinTableCoreConnectionColumn,
					ExternalFilterByTable: this.externalFilterByTable,
					ExternalFilterByTableConnectionColumn: this.externalFilterByTableConnectionColumn,
					PolyJoinRemoteType: this.polyJoinRemoteType,
					PolyJoinRemoteColumn: this.polyJoinRemoteColumn
				};
			case 'ExternalJoinSelectedValue':
			case 'ExternalJoinSelectedValueList':
				return {
					Type: this.type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					CoreConnectionColumn: this.coreConnectionColumn,
					JoinTable: this.joinTable,
					JoinTableExternalConnectionColumn: this.joinTableExternalConnectionColumn,
					JoinTableCoreConnectionColumn: this.joinTableCoreConnectionColumn,
					ExternalFilterByTable: this.externalFilterByTable,
					ExternalFilterTableLookupColumn: this.externalFilterTableLookupColumn,
					ExternalFilterByTableConnectionColumn: this.externalFilterByTableConnectionColumn,
					PolyJoinRemoteType: this.polyJoinRemoteType,
					PolyJoinRemoteColumn: this.polyJoinRemoteColumn
				};
			default:
				throw new Error(`Unsupported filter type: ${this.type}`);
		}
	}
}

module.exports = FilterClauseExternalJoin;

},{"./FilterClauseBase.js":379}],381:[function(require,module,exports){

const libFilterClauseBase = require('./FilterClauseBase.js');

/**
 * Manage filter state for a filter that works on a one level of indirect direct join.
 */
class FilterClauseInternalJoin extends libFilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		super(pFable);

		/** @type {import('./Filter.js').FilterType} */
		this.type = 'None';
		/** @type {string[] | number[] | { Start?: string | number, End?: string | number }} */
		this.values = [];
		/** @type {boolean?} */
		this.exactMatch;
		/** @type {boolean?} */
		this.startExclusive;
		/** @type {boolean?} */
		this.endExclusive;
		/** @type {string} */
		this.remoteTable = '';
		/** @type {string?} */
		this.externalFilterByColumn;
		/** @type {string[]?} */
		this.externalFilterByColumns;
		/** @type {string?} */
		this.externalFilterTableLookupColumn;
		/** @type {string} */
		this.joinExternalConnectionColumn = '';
		/** @type {string} */
		this.joinInternalConnectionColumn = '';
	}

	/**
	 * @return {import('./FilterClauseBase.js').FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		switch (this._type)
		{
			case 'InternalJoinMatch':
			case 'InternalJoinStringMatch':
			case 'InternalJoinDateMatch':
			case 'InternalJoinNumericMatch':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					RemoteTable: this.remoteTable,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					JoinExternalConnectionColumn: this.joinExternalConnectionColumn,
					JoinInternalConnectionColumn: this.joinInternalConnectionColumn,
				};
			case 'InternalJoinSelectedValue':
			case 'InternalJoinSelectedValueList':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					RemoteTable: this.remoteTable,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					ExternalFilterTableLookupColumn: this.externalFilterTableLookupColumn,
					JoinExternalConnectionColumn: this.joinExternalConnectionColumn,
					JoinInternalConnectionColumn: this.joinInternalConnectionColumn,
				};
			case 'InternalJoinRange':
			case 'InternalJoinStringRange':
			case 'InternalJoinDateRange':
			case 'InternalJoinNumericRange':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					RemoteTable: this.remoteTable,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					JoinExternalConnectionColumn: this.joinExternalConnectionColumn,
					JoinInternalConnectionColumn: this.joinInternalConnectionColumn,
				};
			default:
				throw new Error(`Unsupported filter type: ${this.type}`);
		}
	}
}

module.exports = FilterClauseInternalJoin;

},{"./FilterClauseBase.js":379}],382:[function(require,module,exports){

const libFilterClauseBase = require('./FilterClauseBase.js');

/**
 * Manage filter state for a filter that only works on fields local to the table.
 */
class FilterClauseLocal extends libFilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		super(pFable);

		/** @type {import('./Filter.js').FilterType} */
		this._type = 'Match';
		/** @type {string} */
		this.filterByColumn;
		/** @type {boolean?} */
		this.exactMatch;
		/** @type {boolean?} */
		this.startExclusive;
		/** @type {boolean?} */
		this.endExclusive;
	}

	/**
	 * @return {import('./FilterClauseBase.js').FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		switch (this._type)
		{
			case 'Match':
			case 'StringMatch':
			case 'DateMatch':
			case 'NumericMatch':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					FilterByColumn: this.filterByColumn,
				};
			case 'Range':
			case 'StringRange':
			case 'DateRange':
			case 'NumericRange':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					FilterByColumn: this.filterByColumn,
				};
			default:
				throw new Error(`Unsupported filter type: ${this.type}`);
		}
	}
}

module.exports = FilterClauseLocal;

},{"./FilterClauseBase.js":379}],383:[function(require,module,exports){
/**
 * Built-in icon set for Pict-Provider-Icon.
 *
 * Every glyph is a full <svg> string with `viewBox="0 0 24 24"` and uses
 * `currentColor` for paint so it picks up surrounding text color (and
 * therefore the active theme).  Width/height are intentionally NOT set
 * on the <svg> — the provider's CSS sizes them via `font-size` so
 * consumers can scale with the natural font cascade or via an `em`-aware
 * `style="font-size:20px"` from a one-off `pict.icon('X', { size: 20 })`.
 *
 * Variants:
 *   - Outline  (default)  — single-stroke, hollow.  Lucide-style.
 *   - Filled              — solid currentColor fill, no stroke.  Used when
 *                            the filled visual is meaningfully distinct
 *                            (closed-shape icons mostly — see _DEFAULTS).
 *
 * Adding more variants (TwoTone, Duotone, custom illustrative sets) is
 * just another key on the exported map plus a corresponding `registerSet`
 * call from a host or section-module.  No core change required.
 *
 * Naming convention: PascalCase canonical names.  Aliases live in
 * Provider-Icon.js (Gear -> Settings, House -> Home, X -> Close, etc.)
 * so consumers don't fight over naming.
 */

const _OutlineDefaults =
{
	// File system
	'Folder': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18V9a1.5 1.5 0 0 0-1.5-1.5h-7L10.5 6H4.5A1.5 1.5 0 0 0 3 7.5z"/></svg>',
	'FolderOpen': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18v-7H3"/><path d="M3 7.5h7L11.5 9h8A1.5 1.5 0 0 1 21 10.5"/></svg>',
	'File': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>',
	'FileText': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="14" y2="17"/></svg>',
	'Spreadsheet': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="1.5"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="14" x2="21" y2="14"/><line x1="9" y1="4" x2="9" y2="20"/></svg>',
	'Image': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.5"/><path d="m21 16-5-5L7 20"/></svg>',
	'Code': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>',

	// Chevrons (open shapes — Outline only makes sense)
	'ChevronUp':    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 15 12 9 18 15"/></svg>',
	'ChevronDown':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',
	'ChevronLeft':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"/></svg>',
	'ChevronRight': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>',

	// Arrows (open shapes)
	'ArrowUp':    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>',
	'ArrowDown':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>',
	'ArrowLeft':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>',
	'ArrowRight': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',

	// Actions
	'Save': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>',
	'Close':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
	'Check':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
	'Plus':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
	'Minus':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
	'Edit':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>',
	'Trash':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>',
	'Copy':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
	'Share':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5"  r="3"/><circle cx="6"  cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59"  y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51"  x2="8.59"  y2="10.49"/></svg>',
	'Search': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
	'Refresh':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>',
	'Download':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>',
	'Upload': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
	'Link':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>',
	'ExternalLink':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>',

	// Status
	'Info':    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
	'Warning': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
	'Error':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9"  x2="9"  y2="15"/><line x1="9"  y1="9"  x2="15" y2="15"/></svg>',
	'Success': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',

	// UI chrome
	'Home':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1v-9.5z"/></svg>',
	'Settings': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',
	'Menu':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6"  x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>',
	'More':     '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><circle cx="5"  cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/></svg>',
	'Eye':      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
	'EyeOff':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>',
	'Lock':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
	'User':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
	'Help':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
};

// Filled variants — only where the filled visual is meaningfully distinct
// from the outline.  Open-shape icons (Chevrons, Arrows, Close, Plus) have
// no Filled variant; lookup falls back to Outline.
const _FilledVariants =
{
	'Folder':     '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M3 7.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18V9a1.5 1.5 0 0 0-1.5-1.5h-7L10.5 6H4.5A1.5 1.5 0 0 0 3 7.5z"/></svg>',
	'FolderOpen': '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M3 8a1 1 0 0 1 1-1h6.5l2 2H20a1 1 0 0 1 1 1v8.5A1.5 1.5 0 0 1 19.5 20h-15A1.5 1.5 0 0 1 3 18.5V8z" fill-opacity="0.92"/></svg>',
	'File':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-.5 7V3.5L19.5 9.5H14a.5.5 0 0 1-.5-.5z"/></svg>',
	'FileText':   '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-.5 7V3.5L19.5 9.5H14a.5.5 0 0 1-.5-.5zM8 12.4a.6.6 0 0 1 .6-.6h6.8a.6.6 0 0 1 0 1.2H8.6a.6.6 0 0 1-.6-.6zm0 4a.6.6 0 0 1 .6-.6h4.8a.6.6 0 0 1 0 1.2H8.6a.6.6 0 0 1-.6-.6z"/></svg>',
	'Spreadsheet':'<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M4 4h16a1.5 1.5 0 0 1 1.5 1.5v13A1.5 1.5 0 0 1 20 20H4a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 4 4zm5 1.2H4.2v3.6H9V5.2zm10.8 0H10.2v3.6h9.6V5.2zM9 9.7H4.2v3.6H9V9.7zm10.8 0H10.2v3.6h9.6V9.7zM9 14.2H4.2v4.6H9v-4.6zm10.8 0H10.2v4.6h9.6v-4.6z"/></svg>',
	'Home':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M11.3 2.2a1 1 0 0 1 1.4 0l9 7.5a1 1 0 0 1 .3.7V20a1 1 0 0 1-1 1h-5a.5.5 0 0 1-.5-.5V14a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 1-.5.5H4a1 1 0 0 1-1-1v-9.5a1 1 0 0 1 .3-.7l8-7.6z"/></svg>',
	'Settings':   '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M19.43 12.98c.04-.32.07-.65.07-.98s-.03-.66-.07-.98l2.11-1.65a.5.5 0 0 0 .12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1a7.3 7.3 0 0 0-1.69-.98l-.38-2.65A.49.49 0 0 0 14 2h-4a.49.49 0 0 0-.49.42l-.38 2.65a7.6 7.6 0 0 0-1.69.98l-2.49-1a.51.51 0 0 0-.61.22l-2 3.46a.493.493 0 0 0 .12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65a.5.5 0 0 0-.12.64l2 3.46a.5.5 0 0 0 .61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65A.49.49 0 0 0 10 22h4a.49.49 0 0 0 .49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46a.5.5 0 0 0-.12-.64l-2.11-1.65zM12 15.5A3.5 3.5 0 1 1 12 8.5a3.5 3.5 0 0 1 0 7z"/></svg>',
	'Trash':      '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M9 3a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0 0 1H5v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h.5a.5.5 0 0 0 0-1H16V4a1 1 0 0 0-1-1H9zm1 5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5z"/></svg>',
	'User':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><circle cx="12" cy="7" r="4"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1H4z"/></svg>',
	'Lock':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 5a3 3 0 0 1 6 0v3H9V7z"/></svg>',
	'Info':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-.99 5.99a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM10.5 11h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V12h-1.5a.5.5 0 0 1 0-1z"/></svg>',
	'Warning':    '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM11.5 9a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0V9zM12 17.5a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8z"/></svg>'
};

module.exports =
{
	Outline: _OutlineDefaults,
	Filled:  _FilledVariants
};

},{}],384:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Provider-DataBroker',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictDataBrokerProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('../Pict.js')} */
		this.pict;

		this.marshalDestination = 'AppData';
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 */
	getValue(pHash)
	{
		return this.getValueByHash(pHash);
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 */
	getValueByHash(pHash)
	{
		return this.pict.manifest.getValueByHash(this.getMarshalDestinationObject(), pHash);
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 * @param {any} pValue - The value to set.
	 */
	setValue(pHash, pValue)
	{
		return this.setValueByHash(pHash, pValue);
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 * @param {any} pValue - The value to set.
	 */
	setValueByHash(pHash, pValue)
	{
		return this.pict.manifest.setValueByHash(this.getMarshalDestinationObject(), pHash, pValue);
	}

	/**
	 * @return {string} - The address of the marshal destination.
	 */
	get marshalDestination()
	{
		return this._marshalDestination;
	}

	/**
	 * @param {string} pMarshalDestinationAddress - The address of the marshal destination.
	 */
	set marshalDestination(pMarshalDestinationAddress)
	{
		this._marshalDestination = pMarshalDestinationAddress;
	}

	/**
	 * @return {Record<string, any>} - The marshal destination object.
	 */
	get marshalDestinationObject()
	{
		const tmpMarshalDestinationAddress = this.marshalDestination;
		if (!tmpMarshalDestinationAddress)
		{
			throw new Error(`Attempt to access marshal destination object with no marshal destination set.`);
		}
		//TODO: figure out a clean way to cache this object that sanely invalidates if the destination changes
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestinationAddress);
		if (!tmpMarshalDestinationObject)
		{
			this.log.error(`Data Broker bootstrapping missing object at marshal destination address: ${tmpMarshalDestinationAddress}`);
			this.pict.setStateValueAtAddress(tmpMarshalDestinationAddress, null, {});
			tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestinationAddress);
			if (!tmpMarshalDestinationObject)
			{
				throw new Error(`Attempt to access marshal destination object with no marshal destination set.`);
			}
		}
		return tmpMarshalDestinationObject;
	}

	getMarshalDestinationObject()
	{
		return this.marshalDestinationObject;
	}

	/**
	 * @param {string} [pOverrideMarshalDestination] - Optional override for the marshal destination address.
	 */
	resolveMarshalDestinationObject(pOverrideMarshalDestination)
	{
		const tmpMarshalDestinationAddress = pOverrideMarshalDestination || this.marshalDestination;
		if (!tmpMarshalDestinationAddress)
		{
			throw new Error(`Attempt to resolve marshal destination object with no marshal destination set.`);
		}
		let tmpMarshalDestinationObject;
		if (pOverrideMarshalDestination)
		{
			tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(pOverrideMarshalDestination);
			if (!tmpMarshalDestinationObject)
			{
				this.log.error(`Data Broker bootstrapping missing object at marshal destination address: ${tmpMarshalDestinationAddress}`);
				this.pict.setStateValueAtAddress(tmpMarshalDestinationAddress, null, {});
			}
		}
		else
		{
			tmpMarshalDestinationObject = this.getMarshalDestinationObject();
		}
		return tmpMarshalDestinationObject;
	}
}

module.exports = PictDataBrokerProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":177}],385:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libFilter = require('../filters/Filter.js');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-FilterManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictRecordSetFilterManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('../Pict.js')} */
		this.pict;

		this.filters = {};
		this.filterCriteria = {};
	}

	/**
	 * @param {string} pFilterHash
	 * @param {Record<string, any>} pFilterConfig
	 *
	 * @return {void}
	 */
	addFilter(pFilterHash, pFilterConfig)
	{
		if (!pFilterHash || typeof pFilterHash !== 'string')
		{
			this.log.error('Invalid filter hash provided. It must be a non-empty string.');
			return;
		}
		if (!pFilterConfig || typeof pFilterConfig !== 'object' || !pFilterConfig.Type)
		{
			this.log.error('Invalid filter configuration provided. It must be an object with a Type property.');
			return;
		}
		const tmpFilterConfig = JSON.parse(JSON.stringify(pFilterConfig));
		if (tmpFilterConfig.Hash && tmpFilterConfig.Hash !== pFilterHash)
		{
			this.log.warn(`Filter configuration hash mismatch: provided ${tmpFilterConfig.Hash}, expected ${pFilterHash}. Overriding with provided hash.`);
		}
		tmpFilterConfig.Hash = pFilterHash;
		this.filters[tmpFilterConfig.Hash] = tmpFilterConfig;
	}

	/**
	 * @param {string} pFilterCriteriaHash
	 * @param {Record<string, any>} pFilterCriteriaConfig
	 *
	 * @return {void}
	 */
	addFilterCriteria(pFilterCriteriaHash, pFilterCriteriaConfig)
	{
		if (!pFilterCriteriaHash || typeof pFilterCriteriaHash !== 'string')
		{
			this.log.error('Invalid filter criteria hash provided. It must be a non-empty string.');
			return;
		}
		if (!pFilterCriteriaConfig || !Array.isArray(pFilterCriteriaConfig))
		{
			this.log.error('Invalid filter criteria configuration provided. It must be an array of filter clauses.');
			return;
		}
		const tmpFilterCriteriaConfig = JSON.parse(JSON.stringify(pFilterCriteriaConfig));
		this.filterCriteria[pFilterCriteriaHash] = tmpFilterCriteriaConfig;
	}

	/**
	 * @param {string} pFilterHash
	 * @return {Record<string, any> | undefined}
	 */
	getFilter(pFilterHash)
	{
		return this.filters[pFilterHash];
	}

	/**
	 * @param {string} pFilterCriteriaHash
	 * @return {Record<string, any> | undefined}
	 */
	getFilterCriteria(pFilterCriteriaHash)
	{
		return this.filterCriteria[pFilterCriteriaHash];
	}

	/**
	 * Run a filter configuration against a filter experience and return ALL matched records.
	 *
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordsByFilter(pFilterConfiguration, pFilterExperience, fCallback)
	{
		return this.loadRecordsByFilterUsingProvider(this.pict.EntityProvider, pFilterConfiguration, pFilterExperience, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return ALL matched records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordsByFilterUsingProvider(pEntityProvider, pFilterConfiguration, pFilterExperience, fCallback)
	{
		if (!pEntityProvider || typeof pEntityProvider.gatherDataFromServer !== 'function')
		{
			return fCallback(new Error('loadRecordsByFilter: Missing or invalid EntityProvider.'));
		}
		/** @type {import('../filters/Filter.js').FilterState} */
		const tmpState = JSON.parse(JSON.stringify(pFilterExperience));
		tmpState.Mode = 'Records';
		tmpState.FilterConfiguration = pFilterConfiguration;
		const tmpFilter = new libFilter(this.pict);
		tmpFilter.generateMeadowFilterStanzas(tmpState);
		tmpFilter.linkPreparedFilters(tmpState);
		tmpFilter.normalizeMeadowFilterStanzas(tmpState);
		tmpFilter.compileMeadowFilterStanzas(tmpState);
		pEntityProvider.gatherDataFromServer(tmpState.BundleConfig, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {number | string | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | string | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordPageByFilter(pFilterConfiguration, pFilterExperience, pRecordOffset, pPageSize, fCallback)
	{
		return this.loadRecordPageByFilterUsingProvider(this.pict.EntityProvider, pFilterConfiguration, pFilterExperience, pRecordOffset, pPageSize, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {number | string | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | string | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordPageByFilterUsingProvider(pEntityProvider, pFilterConfiguration, pFilterExperience, pRecordOffset, pPageSize, fCallback)
	{
		if (!pEntityProvider || typeof pEntityProvider.gatherDataFromServer !== 'function')
		{
			return fCallback(new Error('loadRecordPageByFilter: Missing or invalid EntityProvider.'));
		}
		const tmpCallback = typeof pRecordOffset === 'function' ? pRecordOffset : typeof pPageSize === 'function' ? pPageSize : fCallback;
		let tmpRecordOffset = typeof pRecordOffset === 'function' ? 0 : parseInt(String(pRecordOffset));
		if (isNaN(tmpRecordOffset) || tmpRecordOffset < 0)
		{
			tmpRecordOffset = 0;
		}
		let tmpPageSize = typeof pPageSize === 'function' ? 0 : parseInt(String(pPageSize));
		if (isNaN(tmpPageSize) || tmpPageSize < 0)
		{
			//TODO: this is a safety measure to try and not break things when we release this pict version; should be a lower value
			tmpPageSize = 10000;
		}
		/** @type {import('../filters/Filter.js').FilterState} */
		const tmpState = JSON.parse(JSON.stringify(pFilterExperience));
		tmpState.Mode = 'Records';
		tmpState.RecordOffset = tmpRecordOffset;
		tmpState.PageSize = tmpPageSize;
		tmpState.FilterConfiguration = pFilterConfiguration;
		const tmpFilter = new libFilter(this.pict);
		tmpFilter.generateMeadowFilterStanzas(tmpState);
		tmpFilter.linkPreparedFilters(tmpState);
		tmpFilter.normalizeMeadowFilterStanzas(tmpState);
		tmpFilter.compileMeadowFilterStanzas(tmpState);
		pEntityProvider.gatherDataFromServer(tmpState.BundleConfig, tmpCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return the count of records.
	 *
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	countRecordsByFilter(pFilterConfiguration, pFilterExperience, fCallback)
	{
		return this.countRecordsByFilterUsingProivider(this.pict.EntityProvider, pFilterConfiguration, pFilterExperience, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return the count of records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	countRecordsByFilterUsingProivider(pEntityProvider, pFilterConfiguration, pFilterExperience, fCallback)
	{
		/** @type {import('../filters/Filter.js').FilterState} */
		const tmpState = JSON.parse(JSON.stringify(pFilterExperience));
		tmpState.Mode = 'Count';
		tmpState.FilterConfiguration = pFilterConfiguration;
		const tmpFilter = new libFilter(this.pict);
		tmpFilter.generateMeadowFilterStanzas(tmpState);
		tmpFilter.linkPreparedFilters(tmpState);
		tmpFilter.normalizeMeadowFilterStanzas(tmpState);
		tmpFilter.compileMeadowFilterStanzas(tmpState);
		pEntityProvider.gatherDataFromServer(tmpState.BundleConfig, fCallback);
	}

	/**
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilter(pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		return this.executeFilterUsingProvider(this.pict.EntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback);
	}

	/**
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilterUsingProvider(pEntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		if (!pEntityProvider || typeof pEntityProvider.gatherDataFromServer !== 'function')
		{
			return fCallback(new Error('executeFilter: Missing or invalid EntityProvider.'));
		}
		const tmpFilterConfiguration = this.pict.resolveStateFromAddress(pFilterConfigurationAddress);
		if (!Array.isArray(tmpFilterConfiguration))
		{
			return fCallback(new Error(`Filter configuration at address ${pFilterConfigurationAddress} is not an array.`));
		}
		const tmpFilterExperience = this.pict.resolveStateFromAddress(pFilterExperienceAddress);
		if (!tmpFilterExperience || typeof tmpFilterExperience !== 'object')
		{
			return fCallback(new Error(`Filter experience at address ${pFilterExperienceAddress} is not an object.`));
		}
		return this.loadRecordsByFilterUsingProvider(pEntityProvider, tmpFilterConfiguration, tmpFilterExperience, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {number | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	executeFilterPage(pFilterConfigurationAddress, pFilterExperienceAddress, pRecordOffset, pPageSize, fCallback)
	{
		return this.executeFilterPageUsingProvider(this.pict.EntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, pRecordOffset, pPageSize, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {number | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	executeFilterPageUsingProvider(pEntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, pRecordOffset, pPageSize, fCallback)
	{
		const tmpCallback = typeof pRecordOffset === 'function' ? pRecordOffset : typeof pPageSize === 'function' ? pPageSize : fCallback;
		const tmpFilterConfiguration = this.pict.resolveStateFromAddress(pFilterConfigurationAddress);
		if (!Array.isArray(tmpFilterConfiguration))
		{
			return tmpCallback(new Error(`Filter configuration at address ${pFilterConfigurationAddress} is not an array.`));
		}
		const tmpFilterExperience = this.pict.resolveStateFromAddress(pFilterExperienceAddress);
		if (!tmpFilterExperience || typeof tmpFilterExperience !== 'object')
		{
			return tmpCallback(new Error(`Filter experience at address ${pFilterExperienceAddress} is not an object.`));
		}
		return this.loadRecordPageByFilterUsingProvider(pEntityProvider, tmpFilterConfiguration, tmpFilterExperience, pRecordOffset, pPageSize, fCallback);
	}

	/**
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilterCount(pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		return this.executeFilterCountUsingProvider(this.pict.EntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback);
	}

	/**
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilterCountUsingProvider(pEntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		const tmpFilterConfiguration = this.pict.resolveStateFromAddress(pFilterConfigurationAddress);
		if (!Array.isArray(tmpFilterConfiguration))
		{
			return fCallback(new Error(`Filter configuration at address ${pFilterConfigurationAddress} is not an array.`));
		}
		const tmpFilterExperience = this.pict.resolveStateFromAddress(pFilterExperienceAddress);
		if (!tmpFilterExperience || typeof tmpFilterExperience !== 'object')
		{
			return fCallback(new Error(`Filter experience at address ${pFilterExperienceAddress} is not an object.`));
		}
		return this.countRecordsByFilterUsingProivider(pEntityProvider, tmpFilterConfiguration, tmpFilterExperience, fCallback);
	}
}

module.exports = PictRecordSetFilterManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"../filters/Filter.js":378,"pict-provider":177}],386:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const _BuiltInIcons   = require('./Pict-Icons-Base.js');

/**
 * Pict-Provider-Icon — the central icon registry.
 *
 * Every glyph is an SVG string with `currentColor`-driven paint, so icons
 * inherit text color from the surrounding context and re-skin automatically
 * when the active theme changes.  The provider also injects a small base
 * stylesheet so `font-size` on a parent scales icons natively — no SVG
 * width/height juggling.
 *
 * Public surface:
 *   pict.icon(name [, opts])                    convenience shortcut
 *   pict.providers.Icon.get(name [, opts])      same, via the provider
 *   pict.providers.Icon.has(name [, variant])
 *   pict.providers.Icon.register(name, svg [, opts])
 *   pict.providers.Icon.registerSet(byVariant)
 *
 * Template tag (registered by Pict-Template-Icon.js):
 *   {~Icon:Home~}              default variant
 *   {~Icon:Folder:Filled~}     explicit variant
 *   {~I:Spreadsheet~}          short alias
 *   {~I:File:Filled~}          short + variant
 *
 * Extension pattern — pict-section-* modules call `registerSet()` at boot
 * to plug in section-specific icons (file-type glyphs, language marks,
 * etc.) without forking core.
 *
 * Lookup order on miss:
 *   1. exact (name, variant)
 *   2. (name, defaultVariant) for that name
 *   3. (name, Outline) — the global default variant
 *   4. inline question-mark glyph + log warning; never throws
 */

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Provider-Icon',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// Variant used when {~Icon:Name~} is asked for with no explicit
	// variant *and* no per-name default exists.
	DefaultVariant: 'Outline',

	// Default extra class applied to every emitted icon wrapper.  Apps
	// override per-call via opts.class.  Always also gets 'pict-icon'.
	DefaultIconClass: 'pict-icon',

	// Default font-size when caller passes { size: N }.  Icons sized via
	// `em` (1em x 1em on the inner <svg>) so font-size drives dimensions.
	DefaultSize: null,

	// Auto-register the bundled base icon set during construction.  Apps
	// that want a completely custom set can set this false and seed via
	// registerSet() after construction.
	RegisterBaseIcons: true
};

// PascalCase aliases — let consumers reach for the name they remember
// first.  Resolved at lookup time, so registering 'Settings' makes 'Gear'
// resolve to it automatically.  Kept short on purpose; expansive aliasing
// is the host's job, not core's.
const _Aliases =
{
	Gear:       'Settings',
	Cog:        'Settings',
	House:      'Home',
	X:          'Close',
	Cross:      'Close',
	Hamburger:  'Menu',
	Pencil:     'Edit',
	Bin:        'Trash',
	Magnifier:  'Search',
	Reload:     'Refresh',
	Person:     'User',
	Padlock:    'Lock'
};

// Minimal CSS — sizes the icon via the parent's font cascade, no SVG
// width/height baked in.  Themes recolor through currentColor; consumers
// can layer additional class rules on top.
const _ProviderCSS = (
	'.pict-icon { display: inline-flex; align-items: center; justify-content: center; vertical-align: -0.125em; flex-shrink: 0; line-height: 0; color: inherit; }' +
	'.pict-icon > svg { width: 1em; height: 1em; display: block; }'
);

// Inline fallback emitted when a requested icon is missing entirely.
// Visible (not invisible) so the misconfiguration is obvious in the UI
// the first time it surfaces.
const _MissingGlyph = (
	'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
	'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
	'<circle cx="12" cy="12" r="10"/>' +
	'<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>' +
	'<line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
);

class PictProviderIcon extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('../Pict.js')} */
		this.pict;

		// Registry shape:  { [variant]: { [name]: svgString } }
		this._registry = {};

		// Per-name default variant.  Set by the first register() call for
		// that name unless a later call passes { default: true }.
		this._defaultsByName = {};

		// Register base icons (Outline + Filled) before anyone can ask
		// for them.
		if (this.options.RegisterBaseIcons)
		{
			this.registerSet(_BuiltInIcons);
		}

		// Inject the base stylesheet.  CSSMap dedupes by hash so this is
		// safe even if multiple Pict instances register their own Icon
		// providers (single-tenant in browsers, but worth honoring).
		if (this.pict && this.pict.CSSMap && typeof (this.pict.CSSMap.addCSS) === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Provider-Icon-CSS', _ProviderCSS, 100);
		}
	}

	/**
	 * Register a single glyph.  First call for a (name) sets the default
	 * variant for that name unless an explicit variant is passed; subsequent
	 * calls add more variants without changing the default.
	 *
	 * @param {string} pName    PascalCase icon name (e.g. 'FileFolder')
	 * @param {string} pSvg     Full <svg>...</svg> string (no width/height)
	 * @param {object} [pOpts]  { variant: 'Outline'|'Filled'|... , default: bool, force: bool }
	 * @returns {boolean}       true on success, false if a (name, variant)
	 *                           already exists and { force: true } wasn't set.
	 */
	register(pName, pSvg, pOpts)
	{
		if (typeof (pName) !== 'string' || pName.length < 1)
		{
			this.log.warn('Pict-Provider-Icon.register requires a non-empty name.');
			return false;
		}
		if (typeof (pSvg) !== 'string' || pSvg.indexOf('<svg') < 0)
		{
			this.log.warn('Pict-Provider-Icon.register requires an SVG string for [' + pName + '].');
			return false;
		}

		let tmpOpts = pOpts || {};
		let tmpVariant = tmpOpts.variant || this.options.DefaultVariant;
		let tmpForce   = !!tmpOpts.force;
		let tmpDefault = !!tmpOpts.default;

		if (!this._registry[tmpVariant])
		{
			this._registry[tmpVariant] = {};
		}
		if (this._registry[tmpVariant][pName] && !tmpForce)
		{
			this.log.warn('Pict-Provider-Icon: refusing to overwrite [' + pName + ':' + tmpVariant
				+ '] (pass { force: true } to replace).');
			return false;
		}
		this._registry[tmpVariant][pName] = pSvg;

		// First registration for this name → it becomes the default,
		// regardless of which variant it was registered under.  This is
		// what "default is first registered" means in practice.
		if (!this._defaultsByName[pName] || tmpDefault)
		{
			this._defaultsByName[pName] = tmpVariant;
		}
		return true;
	}

	/**
	 * Bulk register a whole icon set, keyed by variant.
	 *
	 *   registerSet({ Outline: { Home: '<svg/>', Folder: '<svg/>' },
	 *                 Filled:  { Home: '<svg/>' } });
	 *
	 * Per-name defaults follow registration order — the first variant
	 * containing a given name becomes that name's default.
	 *
	 * @param {Record<string, Record<string, string>>} pByVariant
	 * @param {object} [pOpts] { force: bool }
	 */
	registerSet(pByVariant, pOpts)
	{
		if (!pByVariant || typeof (pByVariant) !== 'object')
		{
			return;
		}
		let tmpForce = !!(pOpts && pOpts.force);
		let tmpVariants = Object.keys(pByVariant);
		for (let v = 0; v < tmpVariants.length; v++)
		{
			let tmpVariant = tmpVariants[v];
			let tmpIcons = pByVariant[tmpVariant];
			if (!tmpIcons) continue;
			let tmpNames = Object.keys(tmpIcons);
			for (let n = 0; n < tmpNames.length; n++)
			{
				let tmpName = tmpNames[n];
				this.register(tmpName, tmpIcons[tmpName], { variant: tmpVariant, force: tmpForce });
			}
		}
	}

	/**
	 * @param {string} pName
	 * @param {string} [pVariant]
	 * @returns {boolean}
	 */
	has(pName, pVariant)
	{
		let tmpResolved = _Aliases[pName] || pName;
		if (pVariant)
		{
			return !!(this._registry[pVariant] && this._registry[pVariant][tmpResolved]);
		}
		return !!this._defaultsByName[tmpResolved];
	}

	/**
	 * Return the wrapped icon HTML for `pName`.  Always returns a string
	 * — never throws and never returns undefined, so it's safe to embed
	 * in template output unchecked.
	 *
	 * @param {string} pName     PascalCase icon name, or an alias
	 * @param {object} [pOpts]   { variant, size, class, ariaLabel }
	 * @returns {string}
	 */
	get(pName, pOpts)
	{
		let tmpName = (typeof (pName) === 'string') ? pName.trim() : '';
		if (tmpName.length < 1)
		{
			this.log.warn('Pict-Provider-Icon.get called with empty name.');
			return this._wrap(_MissingGlyph, pOpts);
		}
		// Alias resolution — Gear → Settings, etc.
		let tmpResolved = _Aliases[tmpName] || tmpName;
		let tmpOpts = pOpts || {};
		let tmpRequestedVariant = tmpOpts.variant;

		// 1. exact match for explicitly-requested variant
		if (tmpRequestedVariant && this._registry[tmpRequestedVariant] && this._registry[tmpRequestedVariant][tmpResolved])
		{
			return this._wrap(this._registry[tmpRequestedVariant][tmpResolved], tmpOpts);
		}
		// 2. per-name default variant
		let tmpNameDefault = this._defaultsByName[tmpResolved];
		if (tmpNameDefault && this._registry[tmpNameDefault] && this._registry[tmpNameDefault][tmpResolved])
		{
			if (tmpRequestedVariant)
			{
				// Fell back from a requested-but-missing variant — log so
				// the gap is visible in dev, but still emit a glyph.
				this.log.trace('Pict-Provider-Icon: variant [' + tmpRequestedVariant + '] missing for ['
					+ tmpResolved + '], using [' + tmpNameDefault + '].');
			}
			return this._wrap(this._registry[tmpNameDefault][tmpResolved], tmpOpts);
		}
		// 3. global default variant
		let tmpGlobal = this.options.DefaultVariant;
		if (this._registry[tmpGlobal] && this._registry[tmpGlobal][tmpResolved])
		{
			return this._wrap(this._registry[tmpGlobal][tmpResolved], tmpOpts);
		}
		// 4. missing — show a question-mark glyph so the gap surfaces
		this.log.warn('Pict-Provider-Icon: unknown icon [' + tmpName + ']'
			+ (tmpRequestedVariant ? ' (variant ' + tmpRequestedVariant + ')' : '') + '.');
		return this._wrap(_MissingGlyph, tmpOpts);
	}

	/**
	 * @private
	 * @param {string} pSvg
	 * @param {object} [pOpts] { size, class, ariaLabel }
	 * @returns {string}
	 */
	_wrap(pSvg, pOpts)
	{
		let tmpOpts = pOpts || {};
		let tmpClass = this.options.DefaultIconClass;
		if (typeof (tmpOpts.class) === 'string' && tmpOpts.class.length > 0)
		{
			tmpClass += ' ' + tmpOpts.class;
		}
		let tmpStyle = '';
		if (typeof (tmpOpts.size) === 'number' && tmpOpts.size > 0)
		{
			tmpStyle = ' style="font-size:' + tmpOpts.size + 'px"';
		}
		else if (typeof (tmpOpts.size) === 'string' && tmpOpts.size.length > 0)
		{
			tmpStyle = ' style="font-size:' + tmpOpts.size + '"';
		}
		// aria-hidden default true — most icons are decorative.  Caller
		// passes ariaLabel to attach a label and flip aria-hidden off.
		let tmpAria = ' aria-hidden="true"';
		if (typeof (tmpOpts.ariaLabel) === 'string' && tmpOpts.ariaLabel.length > 0)
		{
			tmpAria = ' role="img" aria-label="' + tmpOpts.ariaLabel.replace(/"/g, '&quot;') + '"';
		}
		return '<span class="' + tmpClass + '"' + tmpStyle + tmpAria + '>' + pSvg + '</span>';
	}
}

module.exports = PictProviderIcon;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./Pict-Icons-Base.js":383,"pict-provider":177}],387:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/** @typedef {{ TimeStamp: Date, Category: string, Message: string }} TransactionLogEntry */
/** @typedef {{ Timestamp: number, Data: any, Type: string }} TransactionQueueItem */
/** @typedef {{ TransactionKey: string, Events: Record<string, Record<string, boolean>>, Log: Array<TransactionLogEntry>, TransactionQueue: Array<TransactionQueueItem> }} TransactionInfo */

/*
 * Provides transaction tracking with keys and events, allowing us to block repeat attempts.
 * Once the shape is solidified, will move it back to the fable codebase
 */
class TransactionTracking extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../Pict') & { addAndInstantiateSingletonService: (hash: string, options: any, prototype: any) => any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		/**
		 * @type {Record<string, TransactionInfo>}
		 */
		this.transactionMap = {};
	}

	/**
	 * @return {Record<string, TransactionInfo>}
	 */
	get transactions()
	{
		return this.transactionMap;
	}

	/**
	 * @param {string} pKey
	 * @param {string} pMessage
	 * @param {string} [pCategory='General']
	 */
	logToTransaction(pKey, pMessage, pCategory)
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking logToTransaction key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		let tmpCategory = typeof(pCategory) === 'string' ? pCategory : 'General';

		this.transactionMap[pKey].Log.push({TimeStamp: new Date(), Category:tmpCategory, Message:pMessage});

		//this.log.trace(`TransactionTracking logToTransaction [${pKey}]: (${tmpCategory}) ${pMessage}`);

		return true;
	}

	/**
	 * @param {string} pKey
	 *
	 * @return {TransactionInfo}
	 */
	registerTransaction(pKey)
	{
		if (this.transactionMap[pKey] != null)
		{
			//this.log.warn(`TransactionTracking registerTransaction key [${pKey}] already exists... returning existing transaction.`);
			return this.transactionMap[pKey];
		}

		this.transactionMap[pKey] = (
			{
				TransactionKey: pKey,
				Events: {},
				Log: [],
				TransactionQueue: [],
			});
		return this.transactionMap[pKey];
	}

	/**
	 * Remove a transaction from the tracking map. Safe to call on a key that
	 * no longer exists (returns false without side effects).
	 *
	 * Guarded: logs a warning and refuses to delete if the transaction still
	 * has a non-empty queue - that would indicate the caller is unregistering
	 * prematurely with work still pending. Callers who have explicitly
	 * drained or discarded the queue can pass pForce=true to bypass the
	 * guard.
	 *
	 * Note that the existing `finalizeTransaction` /
	 * `eventTransactionAsyncOperationComplete` pathways in pict-section-form
	 * manage their own map cleanup directly on the `transactions` getter;
	 * this method is the canonical API for any other caller that needs to
	 * remove a transaction entry.
	 *
	 * @param {string} pKey - The transaction key to unregister.
	 * @param {boolean} [pForce] - If true, unregister even if the queue is
	 *     not empty. Use only when the caller has explicitly drained or
	 *     discarded the queue state.
	 *
	 * @return {boolean} true if an entry was removed, false otherwise.
	 */
	unregisterTransaction(pKey, pForce)
	{
		const tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			return false;
		}
		if (!pForce && tmpTransaction.TransactionQueue && tmpTransaction.TransactionQueue.length > 0)
		{
			this.log.warn(`TransactionTracking unregisterTransaction [${pKey}] refused: queue has ${tmpTransaction.TransactionQueue.length} item(s) still pending. Pass pForce=true if you explicitly want to discard them.`);
			return false;
		}
		delete this.transactionMap[pKey];
		return true;
	}

	/**
	 * @param {string} pKey
	 * @param {any} pData
	 * @param {string} [pType='Entry']
	 *
	 * @return {number} the current queue size
	 */
	pushToTransactionQueue(pKey, pData, pType = 'Entry')
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking pushToTransactionQueue key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		tmpTransaction.TransactionQueue.push({ Timestamp: Date.now(), Data: pData, Type: pType });
		this.logToTransaction(pKey, `Pushed data to transaction queue`, 'Queue');

		return tmpTransaction.TransactionQueue.length;
	}

	/**
	 * Returns the transaction queue with wrapping metadata.
	 *
	 * @param {string} pKey
	 *
	 * @return {Array<TransactionQueueItem>}
	 */
	checkTransactionQueue(pKey)
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking checkTransactionQueue key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		if (tmpTransaction.TransactionQueue == null)
		{
			tmpTransaction.TransactionQueue = [];
		}

		this.logToTransaction(pKey, `Checked transaction queue`, 'Queue');

		return tmpTransaction.TransactionQueue;
	}

	/**
	 * Returns an array of object registered in the transaction queue for a given transaction ID.
	 *
	 * @param {string} pKey
	 *
	 * @return {Array<any>}
	 */
	getTransactionQueue(pKey)
	{
		const tmpQueue = this.checkTransactionQueue(pKey);
		return tmpQueue.map((item) => item.Data);
	}

	/**
	 * @param {string} pKey
	 *
	 * @return {Array<TransactionQueueItem>}
	 */
	clearTransactionQueue(pKey)
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking clearTransactionQueue key [${pKey}] does not exist; skipping...`);
			return;
		}

		const tmpQueue = tmpTransaction.TransactionQueue;
		tmpTransaction.TransactionQueue = [];
		this.logToTransaction(pKey, `Cleared transaction queue`, 'Queue');

		return tmpQueue;
	}

	/**
	 * @param {string} pKey
	 * @param {string} pEvent
	 * @param {string} [pHash='']
	 *
	 * @return {boolean} true if the event is new, false if it has already been registered
	 */
	checkEvent(pKey, pEvent, pHash)
	{
		let tmpHash = (typeof(pHash) === 'string') ? pHash : '';
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking checkTransactionEvent event [${pEvent}]->[${tmpHash}] key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		if (tmpTransaction.Events[pEvent] == null)
		{
			tmpTransaction.Events[pEvent] = {};
		}
		if (tmpHash in tmpTransaction.Events[pEvent])
		{
			//this.log.warn(`TransactionTracking checkTransactionEvent event [${pEvent}]->[${tmpHash}] key [${pKey}] firing a second time...`);
			this.logToTransaction(pKey, `Event [${pEvent}]->[${tmpHash}] already exists in transaction [${pKey}]`, 'Event');
			return false;
		}
		else
		{
			//this.log.warn(`TransactionTracking checkTransactionEvent event [${pEvent}]->[${tmpHash}] key [${pKey}] firing a first time...`);
			this.logToTransaction(pKey, `Event [${pEvent}]->[${tmpHash}] registered in transaction [${pKey}]`, 'Event');
			tmpTransaction.Events[pEvent][tmpHash] = true;
			return true;
		}
	}
}

module.exports = TransactionTracking;

/** @type {Record<string, any>} */
TransactionTracking.default_configuration = { };

},{"fable-serviceproviderbase":59}],388:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Addressed Template expression.
 *
 *   {[AppData.MyTemplate]}
 *
 * Looks up the value at the given address (resolved through the same
 * scope as {~D:~} -- Record, AppData, Pict, Bundle, Context, Scope,
 * TempData, __State) and renders it as a template against the current
 * Record/Context/Scope/State.  Pairs with the inline template `{<...>}`:
 *
 *   {<inline body, parsed at runtime>}
 *   {[AppData.PathToTemplateString]}     <- body is *stored* at the address
 *
 * If the address does not resolve, or resolves to a non-string, a warning
 * is logged that names the address and the full expression, and the
 * expression renders as ''.
 */
class PictTemplateProviderAddressedTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{[', ']}');
	}

	/**
	 * Render the addressed template: resolve the address to a template
	 * string and parse it against the current scope.
	 *
	 * @param {string} pTemplateHash - The address (what's between `{[` and `]}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template, or '' when the address can't be resolved to a string.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpAddress = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRender]::[${tmpAddress}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRender]::[${tmpAddress}]`);
		}

		if (tmpAddress.length < 1)
		{
			this.log.warn(`Pict: Addressed Template Render: No address provided in expression [{[${pTemplateHash}]}]`);
			return '';
		}

		let tmpTemplate = this.resolveStateFromAddress(tmpAddress, tmpRecord, pContextArray, null, pScope, pState);

		if (tmpTemplate == null)
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] did not resolve for expression [{[${pTemplateHash}]}]`);
			return '';
		}

		if (typeof (tmpTemplate) !== 'string')
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] resolved to a non-string (${typeof tmpTemplate}) for expression [{[${pTemplateHash}]}]`);
			return '';
		}

		if (tmpTemplate.length < 1)
		{
			return '';
		}

		return this.pict.parseTemplate(tmpTemplate, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Render the addressed template asynchronously.
	 *
	 * @param {string} pTemplateHash - The address (what's between `{[` and `]}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpAddress = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRenderAsync]::[${tmpAddress}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRenderAsync]::[${tmpAddress}]`);
		}

		if (tmpAddress.length < 1)
		{
			this.log.warn(`Pict: Addressed Template Render: No address provided in expression [{[${pTemplateHash}]}]`);
			return tmpCallback(null, '');
		}

		let tmpTemplate = this.resolveStateFromAddress(tmpAddress, tmpRecord, pContextArray, null, pScope, pState);

		if (tmpTemplate == null)
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] did not resolve for expression [{[${pTemplateHash}]}]`);
			return tmpCallback(null, '');
		}

		if (typeof (tmpTemplate) !== 'string')
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] resolved to a non-string (${typeof tmpTemplate}) for expression [{[${pTemplateHash}]}]`);
			return tmpCallback(null, '');
		}

		if (tmpTemplate.length < 1)
		{
			return tmpCallback(null, '');
		}

		this.pict.parseTemplate(tmpTemplate, pRecord,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderAddressedTemplate;
module.exports.template_hash = 'AddressedTemplate';

},{"pict-template":363}],389:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderData extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Data:', '~}');
		this.addPattern('{~D:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content or an optional default value.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpDefaultValue = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpDefaultValue = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);
		}
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof(tmpValue) == 'undefined') || (tmpValue === ''))
		{
			return tmpDefaultValue;
		}
		return tmpValue;
	}
}

module.exports = PictTemplateProviderData;

},{"pict-template":363}],390:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDataValueByKey extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataValueByKey:', '~}');
		this.addPattern('{~DVBK:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpHashArray = tmpHash.split(':');

		if (tmpHashArray.length < 2)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] failed because there were not two stanzas in the expression [${pTemplateHash}]`);
			return '';
		}

		let tmpDefaultValue = '';
		if (tmpHashArray.length > 2)
		{
			tmpDefaultValue = tmpHashArray[2];
		}

		let tmpValueObject = this.resolveStateFromAddress(tmpHashArray[0], tmpRecord, pContextArray, null, pScope, pState);
		let tmpValueAddress = this.resolveStateFromAddress(tmpHashArray[1], tmpRecord, pContextArray, null, pScope, pState);
		let tmpValue = this.pict.manifest.getValueByHash(tmpValueObject, tmpValueAddress);
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof(tmpValue) == 'undefined'))
		{
			return tmpDefaultValue;
		}
		return tmpValue;
	}
}

module.exports = PictTemplateProviderDataValueByKey;

},{"pict-template":363}],391:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderData extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataWithAbsoluteFallback:', '~}');
		this.addPattern('{~DWAF:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content or an optional default template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpAbsoluteFallbackValue = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpAbsoluteFallbackValue = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				// If a value is found, return it
				return tmpValue;
			}
		}
		// If the value is not found or is undefined, use the fallback value.
		return tmpAbsoluteFallbackValue;
	}

	/**
	 * Render a template expression asynchronously, returning a string with the resulting content or an optional fallback template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to be called with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void} The result is passed to the callback function
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpAbsoluteFallbackValue = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpAbsoluteFallbackValue = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				return tmpCallback(null, tmpValue);
			}
		}
		// If the value is not found or is undefined, use the fallback value
		return tmpCallback(null, tmpAbsoluteFallbackValue);
	}

}

module.exports = PictTemplateProviderData;

},{"pict-template":363}],392:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderData extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataWithTemplateFallback:', '~}');
		this.addPattern('{~DWTF:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content or an optional default template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpTemplateFallbackAddress = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpTemplateFallbackAddress = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				// If a value is found, return it
				return tmpValue;
			}
		}
		// If the value is not found or is undefined, try to use the fallback template
		const tmpFallbackTemplate = this.pict.parseTemplateByHash(tmpTemplateFallbackAddress, tmpRecord, null, pContextArray, pScope, pState);
		if (tmpFallbackTemplate == null || tmpFallbackTemplate === '')
		{
			this.log.warn(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - No fallback template found at address: ${tmpTemplateFallbackAddress}`);
			// If no fallback template is found, return an empty string
			return '';
		}
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Using fallback template from address: ${tmpTemplateFallbackAddress}`);
		}
		return tmpFallbackTemplate;
	}

	/**
	 * Render a template expression asynchronously, returning a string with the resulting content or an optional fallback template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to be called with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void} The result is passed to the callback function
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpTemplateFallbackAddress = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpTemplateFallbackAddress = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				return tmpCallback(null, tmpValue);
			}
		}
		// If the value is not found or is undefined, try to use the fallback template
		this.pict.parseTemplateByHash(tmpTemplateFallbackAddress, tmpRecord, (pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				if (pValue == null || pValue === '')
				{
					this.log.warn(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - No fallback template found at address: ${tmpTemplateFallbackAddress}`);
					// If no fallback template is found, return an empty string
					return tmpCallback(null, '');
				}
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Using fallback template from address: ${tmpTemplateFallbackAddress}`);
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}

}

module.exports = PictTemplateProviderData;

},{"pict-template":363}],393:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderEntity extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~E:', '~}');
		this.addPattern('{~Entity:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		// TODO: Better messaging
		this.log.error(`Pict: Entity Render [${pTemplateHash}]: Render called in a non-asynchronous fashion.  This should not happen.`);
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fEntityRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fEntityRender]::[${tmpHash}]`);
		}

		let tmpEntity;
		/** @type {string|number} */
		let tmpEntityID = '';
		let tmpEntityTemplate;

		// This expression requires 2 parts -- a third is optional, and, if present, is the template to render to.
		let tmpAddressParts = tmpHash.split('^');

		if (tmpAddressParts.length < 2)
		{
			this.log.warn(`Pict: Entity Render: Entity or entity ID not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		tmpEntity = tmpAddressParts[0].trim();
		tmpEntityID = tmpAddressParts[1].trim();
		tmpEntityTemplate = tmpAddressParts[2].trim();

		if (!isNaN(Number(tmpEntityID)))
		{
			try
			{
				tmpEntityID = parseInt(String(tmpEntityID));
			}
			catch
			{
				this.log.warn(`Pict: Entity Render: Could not parse entity ID.`);
				tmpEntityID = 0;
			}
		}
		else
		{
			// This is an address, so we need to get the value at the address
			tmpEntityID = this.resolveStateFromAddress(String(tmpEntityID), tmpData, pContextArray, null, pScope, pState);
		}

		// No Entity or EntityID
		if (!tmpEntity || !tmpEntityID)
		{
			this.log.warn(`Pict: Entity Render: Entity or entity ID not resolved for [${tmpHash}]  Entity: ${tmpEntity} ID: ${tmpEntityID}`);
			return tmpCallback(null, '');
		}

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`Pict: Entity Render: Entity [${tmpEntity}] with ID [${tmpEntityID}] as template [${tmpEntityTemplate}] from [${tmpHash}]`);
		}

		// Now try to get the entity
		this.pict.EntityProvider.getEntity(tmpEntity, tmpEntityID,
			function (pError, pRecord)
			{
				if (pError)
				{
					this.log.error(`Pict: Entity Render: Error getting entity [${tmpEntity}] with ID [${tmpEntityID}] for [${tmpHash}]: ${pError}`, pError);
					return tmpCallback(pError, '');
				}

				// Now render the template
				if (tmpEntityTemplate)
				{
					this.pict.parseTemplateByHash(tmpEntityTemplate, pRecord, tmpCallback, pContextArray, pScope, pState);
				}
				else
				{
					tmpCallback(null, '');
				}
			}.bind(this));
	}
}

module.exports = PictTemplateProviderEntity;

},{"pict-template":363}],394:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Function template expression.
 *
 *   {~Function:Pict.providers.SomeProvider.makeThing:Record.X:Record.Y~}
 *   {~F:Pict.providers.SomeProvider.makeThing:Record.X:Record.Y~}
 *
 * First parameter is the address of a function to call (resolved with
 * `pict.resolveStateFromAddress` against the usual root: Record, AppData,
 * Pict, Bundle, Context, Scope, TempData, __State).  Each subsequent
 * `:`-separated parameter is itself an address whose resolved value is
 * passed as an argument to the function.  Arity is dynamic.
 *
 * Returns whatever the function returns (coerced to '' when null /
 * undefined).  If the address does not resolve to a function, a warning is
 * logged that names the address and the full template expression, and the
 * expression renders as ''.  If the function throws, the error is logged
 * and the expression renders as ''.
 *
 * `this` is bound to the address's parent object so instance methods work
 * naturally:  `Pict.providers.X.go(...)` invokes with `this === Pict.providers.X`.
 */
class PictTemplateProviderFunction extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Function:', '~}');
		this.addPattern('{~F:', '~}');
	}

	/**
	 * Render the Function expression: call the resolved function with the
	 * resolved arguments and return its result.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The function's return value, stringified by the template engine; '' if the function is missing or throws.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fFunctionRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fFunctionRender]::[${tmpHash}]`);
		}

		let tmpParts = tmpHash.split(':');
		let tmpFunctionAddress = (tmpParts.length > 0) ? tmpParts[0].trim() : '';

		if (tmpFunctionAddress.length < 1)
		{
			this.log.warn(`Pict: Function Render: No function address provided in template [{~Function:${tmpHash}~}]`);
			return '';
		}

		let tmpFunction = this.resolveStateFromAddress(tmpFunctionAddress, tmpRecord, pContextArray, null, pScope, pState);

		if (typeof (tmpFunction) !== 'function')
		{
			this.log.warn(`Pict: Function Render: Function not found at address [${tmpFunctionAddress}] for template [{~Function:${tmpHash}~}]`);
			return '';
		}

		// Resolve `this` to the function's parent so instance methods bind naturally.
		let tmpThis = null;
		let tmpLastDot = tmpFunctionAddress.lastIndexOf('.');
		if (tmpLastDot > 0)
		{
			let tmpParentAddress = tmpFunctionAddress.substring(0, tmpLastDot);
			tmpThis = this.resolveStateFromAddress(tmpParentAddress, tmpRecord, pContextArray, null, pScope, pState);
		}

		let tmpArguments = [];
		for (let i = 1; i < tmpParts.length; i++)
		{
			tmpArguments.push(this.resolveStateFromAddress(tmpParts[i], tmpRecord, pContextArray, null, pScope, pState));
		}

		try
		{
			let tmpResult = tmpFunction.apply(tmpThis, tmpArguments);
			if (tmpResult == null)
			{
				return '';
			}
			return tmpResult;
		}
		catch (pError)
		{
			this.log.warn(`Pict: Function Render: Error invoking function at [${tmpFunctionAddress}] for template [{~Function:${tmpHash}~}]: ${pError.message}`);
			return '';
		}
	}
}

module.exports = PictTemplateProviderFunction;
module.exports.template_hash = 'Function';

},{"pict-template":363}],395:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Icon template tag — emits a themable SVG icon by PascalCase name.
 *
 *   {~Icon:Home~}              → default variant for 'Home'
 *   {~Icon:Folder:Filled~}     → explicit variant
 *   {~I:Spreadsheet~}          → short alias of {~Icon:~}
 *   {~I:File:Filled~}          → short + variant
 *
 * The plugin is a thin shim over the `Icon` provider — all the registry
 * + lookup + variant-fallback logic lives there.  See Provider-Icon.js
 * for registration, alias resolution, and per-name defaults.
 *
 * Sizing happens at the CSS layer: icons are wrapped in `<span class="pict-icon">`
 * whose inner svg is `1em × 1em`.  To resize, set `font-size` on the
 * parent (e.g. a button) — no template-side sizing needed for the common
 * case.  One-off sizing still works through the JS API:
 * `pict.icon('Save', { size: 20 })`.
 */
class PictTemplateProviderIcon extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Icon:', '~}');
		this.addPattern('{~I:',    '~}');
	}

	/**
	 * @param {string} pTemplateHash - Body of the tag (the bit between the
	 *                                  opening pattern and the closing `~}`).
	 *                                  Either "Name" or "Name:Variant".
	 * @returns {string}
	 */
	render(pTemplateHash)
	{
		let tmpBody = (pTemplateHash || '').trim();
		if (tmpBody.length < 1)
		{
			return '';
		}
		let tmpName = tmpBody;
		let tmpVariant = null;
		let tmpColon = tmpBody.indexOf(':');
		if (tmpColon > -1)
		{
			tmpName    = tmpBody.slice(0, tmpColon).trim();
			tmpVariant = tmpBody.slice(tmpColon + 1).trim();
		}

		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Icon;
		if (!tmpProvider || typeof (tmpProvider.get) !== 'function')
		{
			// Provider missing — should never happen in a normally-booted
			// Pict app, but degrade silently rather than emit something
			// that looks like a template tag.
			return '';
		}

		let tmpOpts = tmpVariant ? { variant: tmpVariant } : undefined;
		return tmpProvider.get(tmpName, tmpOpts);
	}
}

module.exports = PictTemplateProviderIcon;

},{"pict-template":363}],396:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Inline Template expression.
 *
 * Captures its raw contents (verbatim, including any other pict template
 * tags) and processes them as a template at runtime.  At render time the
 * captured string is fed back through `pict.parseTemplate(...)` with the
 * same Record/Context/Scope/State that was active at the outer scope.
 *
 *   {<TEMPLATED CONTENT HERE, {~D:AppData.SomeValue~}.>}
 *
 * Direct nesting of `{<...>}` inside another `{<...>}` is not supported;
 * the first `>}` closes the outer block.  Wrap the inner literal in a
 * registered template hash and reference it with `{~T:Hash~}` for that.
 */
class PictTemplateProviderInlineTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{<', '>}');
	}

	/**
	 * Render an inline template expression, returning a string with the
	 * processed template content.
	 *
	 * @param {string} pTemplateBody - The raw inline template body (what was between `{<` and `>}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateBody, pRecord, pContextArray, pScope, pState)
	{
		let tmpBody = (typeof (pTemplateBody) === 'string') ? pTemplateBody : '';

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fInlineTemplateRender]::[${tmpBody}] with tmpData:`, pRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fInlineTemplateRender]::[${tmpBody}]`);
		}

		if (tmpBody.length < 1)
		{
			return '';
		}

		return this.pict.parseTemplate(tmpBody, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Render an inline template expression, delivering the result to a callback.
	 *
	 * @param {string} pTemplateBody - The raw inline template body (what was between `{<` and `>}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateBody, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpBody = (typeof (pTemplateBody) === 'string') ? pTemplateBody : '';
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fInlineTemplateRenderAsync]::[${tmpBody}] with tmpData:`, pRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fInlineTemplateRenderAsync]::[${tmpBody}]`);
		}

		if (tmpBody.length < 1)
		{
			return tmpCallback(null, '');
		}

		this.pict.parseTemplate(tmpBody, pRecord,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderInlineTemplate;
module.exports.template_hash = 'InlineTemplate';

},{"pict-template":363}],397:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderSelf extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Pict', '~}');
		this.addPattern('{~P', '~}');
		this.addPattern('{~p', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.pict.browserAddress;
	}
}

module.exports = PictTemplateProviderSelf;

},{"pict-template":363}],398:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderSolve extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Solve:', '~}');
		this.addPattern('{~S:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pSolveParams - The solver parameters.
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pSolveParams, pRecord, pContextArray, pScope, pState)
	{
		// {~S:ROUND(250*0.4129+Width,3):AppData.HomeworkRectangleSize:AppData.HomeworkManifest~}
		const [ tmpEquation, tmpRecordAddress, tmpManifestAddress ] = pSolveParams.trim().split(':', 3);
		const tmpContextualRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Solve [fTemplateRender]::[${pSolveParams}] with tmpData:`, tmpContextualRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Solve [fTemplateRender]::[${pSolveParams}]`);
		}

		if (!tmpEquation)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: Solve: Equation not found for [${tmpEquation}]`);
			}
			return '';
		}
		const tmpRecord = (tmpRecordAddress && this.pict.resolveStateFromAddress(tmpRecordAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || tmpContextualRecord;
		const tmpManifest = (tmpManifestAddress && this.pict.resolveStateFromAddress(tmpManifestAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || this.pict.manifest;
		const expressionParser = this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
		const tmpResultObject = { };
		return expressionParser.solve(tmpEquation, tmpRecord, tmpResultObject, tmpManifest, tmpRecord);
	}
}

module.exports = PictTemplateProviderSolve;

},{"pict-template":363}],399:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderSolveByReference extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~SolveByReference:', '~}');
		this.addPattern('{~SBR:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pSolveParams - The solver parameters.
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pSolveParams, pRecord, pContextArray, pScope, pState)
	{
		// {~SBR:AppData.Equation:AppData.HomeworkRectangleSize:AppData.HomeworkManifest~}
		const [ tmpEquationAddress, tmpRecordAddress, tmpManifestAddress ] = pSolveParams.trim().split(':', 3);
		const tmpContextualRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT SolveByReference [fTemplateRender]::[${pSolveParams}] with tmpData:`, tmpContextualRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT SolveByReference [fTemplateRender]::[${pSolveParams}]`);
		}

		const tmpEquation = this.pict.resolveStateFromAddress(tmpEquationAddress, tmpContextualRecord, pContextArray, null, pScope, pState);
		if (!tmpEquation)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: SolveByReference: Equation not found for [${tmpEquationAddress}]`);
			}
			return '';
		}
		const tmpRecord = (tmpRecordAddress && this.pict.resolveStateFromAddress(tmpRecordAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || tmpContextualRecord;
		const tmpManifest = (tmpManifestAddress && this.pict.resolveStateFromAddress(tmpManifestAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || this.pict.manifest;
		const expressionParser = this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
		const tmpResultObject = { };
		return expressionParser.solve(tmpEquation, tmpRecord, tmpResultObject, tmpManifest, tmpRecord);
	}
}

module.exports = PictTemplateProviderSolveByReference;

},{"pict-template":363}],400:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Template:', '~}');
		this.addPattern('{~T:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplate;

},{"pict-template":363}],401:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateByDataAddress extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateByDataAddress:', '~}');
		this.addPattern('{~TBDA:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateDataAddress - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateDataAddress, pRecord, pContextArray, pScope, pState)
	{
		let tmpDataAddress = pTemplateDataAddress.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRender]::[${tmpDataAddress}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRender]::[${tmpDataAddress}]`);
		}

		let tmpTemplateDataAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpDataAddress.indexOf(':');
		tmpTemplateDataAddress = tmpDataAddress.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpDataAddress.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateDataAddress = tmpDataAddress;
		}

		// No template hash
		if (!tmpTemplateDataAddress)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpDataAddress}]`);
			return '';
		}

		let tmpTemplate = this.pict.resolveStateFromAddress(tmpTemplateDataAddress, pRecord, pContextArray, null, pScope, pState);
		if (!tmpTemplate)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: Template Render: Template not found for [${tmpTemplateDataAddress}]`);
			}
			tmpTemplate = '';
		}
		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplate(tmpTemplate, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplate(tmpTemplate, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateDataAddress - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateDataAddress, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpDataAddress = pTemplateDataAddress.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRenderAsync]::[${tmpDataAddress}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRenderAsync]::[${tmpDataAddress}]`);
		}

		let tmpTemplateDataAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpDataAddress.indexOf(':');
		tmpTemplateDataAddress = tmpDataAddress.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpDataAddress.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateDataAddress = tmpDataAddress;
		}

		// No template hash
		if (!tmpTemplateDataAddress)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpDataAddress}]`);
			return tmpCallback(null, '');
		}

		let tmpTemplate = this.pict.resolveStateFromAddress(tmpTemplateDataAddress, pRecord, pContextArray, null, pScope, pState) || '';
		if (!tmpTemplate)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: Template Render: Template not found for [${tmpTemplateDataAddress}]`);
			}
			tmpTemplate = '';
		}
		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplate(tmpTemplate, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplate(tmpTemplate, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateByDataAddress;

},{"pict-template":363}],402:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateByReference:', '~}');
		this.addPattern('{~TBR:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpTemplateHashReferenceLocation;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHashReferenceLocation = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHashReferenceLocation = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHashReferenceLocation)
		{
			this.log.warn(`Pict: Template Render: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now look up the template by the reference
		let tmpTemplateHash = this.resolveStateFromAddress(tmpTemplateHashReferenceLocation, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateHashReferenceLocation;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHashReferenceLocation = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHashReferenceLocation = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHashReferenceLocation)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now look up the template by the reference
		let tmpTemplateHash = this.resolveStateFromAddress(tmpTemplateHashReferenceLocation, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplate;

},{"pict-template":363}],403:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateByTypes extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateByType:', '~}');
		this.addPattern('{~TBT:', '~}');
	}

	/**
	 * Render a template expression if it's in the passed-in types, otherwise falling back to a fallback template, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpAddressToTest;
		let tmpDataTypesToTest;
		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpFallbackTemplate;

		// This is {~TBT:AppData.Some.Address.To.Test:string,number:SomeTemplate:FallbackTemplate~}
		let tmpTemplateHashes = tmpHash.trim().split(':');

		if (tmpTemplateHashes.length < 3)
		{
			return '';
		}

		tmpAddressToTest = tmpTemplateHashes[0];
		tmpDataTypesToTest = tmpTemplateHashes[1].split(',');
		tmpTemplateHash = tmpTemplateHashes[2];

		if (tmpTemplateHashes.length > 3)
		{
			tmpAddressOfData = tmpTemplateHashes[3];
		}

		if (tmpTemplateHashes.length > 4)
		{
			tmpFallbackTemplate = tmpTemplateHashes[4];
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			return '';
		}

		let tmpRecord = pRecord;
		if (tmpAddressOfData)
		{
			tmpRecord = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);
		}

		const tmpValueAtAddress = this.resolveStateFromAddress(tmpAddressToTest, tmpData, pContextArray, null, pScope, pState);
		/** @type {string} */
		let tmpTypeOfDataAtAddress = typeof tmpValueAtAddress;
		if (tmpTypeOfDataAtAddress == 'object' && Array.isArray(tmpValueAtAddress))
		{
			tmpTypeOfDataAtAddress = 'array';
		}
		if (tmpDataTypesToTest.indexOf(tmpTypeOfDataAtAddress) === -1)
		{
			// Type not found, use the fallback template if we have one.
			if (tmpFallbackTemplate)
			{
				tmpTemplateHash = tmpFallbackTemplate;
			}
			else
			{
				return '';
			}
		}

		// No address was provided, just render the template with what this template has.
		return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpAddressToTest;
		let tmpDataTypesToTest;
		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpFallbackTemplate;

		// This is {~TBT:AppData.Some.Address.To.Test:string,number:SomeTemplate:FallbackTemplate~}
		let tmpTemplateHashes = tmpHash.trim().split(':');

		if (tmpTemplateHashes.length < 3)
		{
			return fCallback(null, '');
		}

		tmpAddressToTest = tmpTemplateHashes[0];
		tmpDataTypesToTest = tmpTemplateHashes[1].split(',');
		tmpTemplateHash = tmpTemplateHashes[2];

		if (tmpTemplateHashes.length > 3)
		{
			tmpAddressOfData = tmpTemplateHashes[3];
		}

		if (tmpTemplateHashes.length > 4)
		{
			tmpFallbackTemplate = tmpTemplateHashes[4];
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			return fCallback(null, '');
		}

		let tmpRecord = pRecord;
		if (tmpAddressOfData)
		{
			tmpRecord = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);
		}

		const tmpValueAtAddress = this.resolveStateFromAddress(tmpAddressToTest, tmpData, pContextArray, null, pScope, pState);
		/** @type {string} */
		let tmpTypeOfDataAtAddress = typeof tmpValueAtAddress;
		if (tmpTypeOfDataAtAddress == 'object' && Array.isArray(tmpValueAtAddress))
		{
			tmpTypeOfDataAtAddress = 'array';
		}
		if (tmpDataTypesToTest.indexOf(tmpTypeOfDataAtAddress) === -1)
		{
			// Type not found, use the fallback template if we have one.
			if (tmpFallbackTemplate)
			{
				tmpTemplateHash = tmpFallbackTemplate;
			}
			else
			{
				return fCallback(null, '');
			}
		}

		// No address was provided, just render the template with what this template has.
		this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderTemplateByTypes;

},{"pict-template":363}],404:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateFromAddress extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateFromAddress:', '~}');
		this.addPattern('{~TFA:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpTemplateContentAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateContentAddress = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateContentAddress = tmpHash;
		}

		// No template hash
		if (!tmpTemplateContentAddress)
		{
			this.log.warn(`Pict: Template Render: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now look up the template by the reference
		let tmpTemplateContent = this.resolveStateFromAddress(tmpTemplateContentAddress, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateContent)
		{
			this.log.warn(`Pict: Template Render: Template not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplate(tmpTemplateContent, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplate(tmpTemplateContent, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateContentAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateContentAddress = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateContentAddress = tmpHash;
		}

		// No template hash
		if (!tmpTemplateContentAddress)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now look up the template by the reference
		let tmpTemplateContent = this.resolveStateFromAddress(tmpTemplateContentAddress, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateContent)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplate(tmpTemplateContent, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplate(tmpTemplateContent, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateFromAddress;

},{"pict-template":363}],405:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateFromMap extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TFM:', '~}');
		this.addPattern('{~TemplateFromMap:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRender]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return ''
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return '';
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMap Render: Map not resolved for [${tmpHash}]`);
			return '';
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			return this.pict.parseTemplateByHash(tmpTemplateFromMapHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateByHash(tmpTemplateFromMapHash, tmpData, null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMap Render: Map not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from TemplateFromMaps
			this.pict.parseTemplateByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateFromMap;

},{"pict-template":363}],406:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateSet extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateSet:', '~}');
		this.addPattern('{~TS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfData;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 2)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0]
		tmpAddressOfData = tmpTemplateHashPart[1];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateSet;

},{"pict-template":363}],407:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateSetFromMap extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TSFM:', '~}');
		this.addPattern('{~TemplateSetFromMap:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRender]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return '';
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return '';
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMap Render: Map not resolved for [${tmpHash}]`);
			return '';
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			return this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData, null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMapSet Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMapSet Render: Map not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from TemplateFromMaps
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateSetFromMap;

},{"pict-template":363}],408:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateSetWithPayload extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateSetWithPayload:', '~}');
		this.addPattern('{~TSWP:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}] with record:`, pRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpAddressOfPayload;

		// This is just a simple 3 part hash (template, address of set, address of payload)
		let tmpTemplateHashes = tmpHash.trim().split(':');
		if (tmpTemplateHashes.length < 3)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return ``;
		}
		tmpTemplateHash = tmpTemplateHashes[0];
		tmpAddressOfData = tmpTemplateHashes[1];
		tmpAddressOfPayload = tmpTemplateHashes[2];

		let tmpData = this.resolveStateFromAddress(tmpAddressOfData, pRecord, pContextArray, null, pScope, pState);
		if (!tmpData)
		{
			tmpData = pRecord;
		}
		if (!tmpData)
		{
			tmpData = {};
		}

		let tmpPayloadData = this.resolveStateFromAddress(tmpAddressOfPayload, pRecord, pContextArray, null, pScope, pState);
		if (!tmpPayloadData)
		{
			tmpPayloadData = pRecord;
		}
		if (!tmpPayloadData)
		{
			tmpPayloadData = {};
		}

		return this.pict.parseTemplateSetWithPayloadByHash(tmpTemplateHash, tmpData, tmpPayloadData, null, pContextArray, pScope, pState);
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRenderAsync]::[${tmpHash}]`);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpAddressOfPayload;

		// This is just a simple 3 part hash (template, address of set, address of payload)
		let tmpTemplateHashes = tmpHash.trim().split(':');
		if (tmpTemplateHashes.length < 3)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}
		tmpTemplateHash = tmpTemplateHashes[0];
		tmpAddressOfData = tmpTemplateHashes[1];
		tmpAddressOfPayload = tmpTemplateHashes[2];

		let tmpData = this.resolveStateFromAddress(tmpAddressOfData, pRecord, pContextArray, null, pScope, pState);
		if (!tmpData)
		{
			tmpData = pRecord;
		}
		if (!tmpData)
		{
			tmpData = {};
		}

		let tmpPayloadData = this.resolveStateFromAddress(tmpAddressOfPayload, pRecord, pContextArray, null, pScope, pState);
		if (!tmpPayloadData)
		{
			tmpPayloadData = pRecord;
		}
		if (!tmpPayloadData)
		{
			tmpPayloadData = {};
		}

		this.pict.parseTemplateSetWithPayloadByHash(tmpTemplateHash, tmpData, tmpPayloadData,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderTemplateSetWithPayload;

},{"pict-template":363}],409:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateValueSet extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateValueSet:', '~}');
		this.addPattern('{~TVS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i] });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, tmpData, null, pContextArray, pScope, pState);
		}
	}
	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfData;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 2)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0]
		tmpAddressOfData = tmpTemplateHashPart[1];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpData[tmpValueKeys[i]] });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateValueSet;

},{"pict-template":363}],410:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderView extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~V:', '~}');
		this.addPattern('{~View:', '~}');


		if (!('__TemplateOutputCache' in this.pict))
		{
			this.pict.__TemplateOutputCache = {};
		}
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		const tmpViewHash = pTemplateHash.trim();
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: View Template Render: View not found for [${tmpViewHash}]`);
			return '';
		}

		let tmpRenderGUID = this.pict.getUUID();

		/** @type {import('pict-view')} */
		const tmpView = this.pict.views[tmpViewHash];

		tmpView.render('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState ? pState.RootRenderable : undefined);

		let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
		// TODO: Uncomment this when we like how it's working
		//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

		return tmpResult;
	}

	/**
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to call with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpViewHash = pTemplateHash.trim();
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: View Template Render: View not found for [${tmpViewHash}]`);
			return fCallback(null, '');
		}

		let tmpRenderGUID = this.pict.getUUID();

		const tmpView = this.pict.views[tmpViewHash];

		return tmpView.renderAsync('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState ? pState.RootRenderable : undefined,
			(pError, pResult) =>
			{
				if (pError)
				{
					this.log.warn(`Pict: View Template Render: Error rendering view [${tmpViewHash}]`, pError);
					return fCallback(pError, '');
				}

				let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
				// TODO: Uncomment this when we like how it's working
				//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

				return fCallback(null, tmpResult);
			});
	}
}

module.exports = PictTemplateProviderView;

},{"pict-template":363}],411:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderRandomNumber extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~RandomNumber:', '~}');
		this.addPattern('{~RN:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fRandomNumber]::[${tmpHash}]`);
		}

		let tmpMinimumNumber = 0;
		let tmpMaxNumber = 9999999;

		if (tmpHash.length > 0)
		{
			let tmpHashParts = tmpHash.split(',');
			if (tmpHashParts.length > 0)
			{
				try
				{
					tmpMinimumNumber = parseInt(tmpHashParts[0]);
				}
				catch
				{
					tmpMinimumNumber = 0;
				}
			}
			if (tmpHashParts.length > 1)
			{
				try
				{
					tmpMaxNumber = parseInt(tmpHashParts[1]);
				}
				catch
				{
					tmpMaxNumber = 9999999;
				}

			}
		}

		return this.fable.DataGeneration.randomIntegerBetween(tmpMinimumNumber, tmpMaxNumber);
	}
}

module.exports = PictTemplateProviderRandomNumber;

},{"pict-template":363}],412:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderRandomNumberString extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~RandomNumberString:', '~}');
		this.addPattern('{~RNS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fRandomNumberString]::[${tmpHash}]`);
		}

		let tmpStringLength = 4;
		let tmpMaxNumber = 9999;

		if (tmpHash.length > 0)
		{
			let tmpHashParts = tmpHash.split(',');
			if (tmpHashParts.length > 0)
			{
				try
				{
					tmpStringLength = parseInt(tmpHashParts[0]);
				}
				catch
				{
					tmpStringLength = 4;
				}
			}
			if (tmpHashParts.length > 1)
			{
				try
				{
					tmpMaxNumber = parseInt(tmpHashParts[1]);
				}
				catch
				{
					tmpMaxNumber = 9999;
				}
			}
		}

		return this.fable.DataGeneration.randomNumericString(tmpStringLength, tmpMaxNumber);
	}
}

module.exports = PictTemplateProviderRandomNumberString;

},{"pict-template":363}],413:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDataEncodeJavascriptString extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataEncodeJavascriptString:', '~}');
		this.addPattern('{~DEJS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}]`);
		}

		let tmpDataToEncode = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);

		return this.pict.DataFormat.stringEncodeForJavascript(tmpDataToEncode);
	}
}

module.exports = PictTemplateProviderDataEncodeJavascriptString;

},{"pict-template":363}],414:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderJSONOutput extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataJson:', '~}');
		this.addPattern('{~DJ:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}]`);
		}

		let tmpDataToStringify = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);

		if (!tmpDataToStringify)
		{
			tmpDataToStringify = pRecord;
		}

		return JSON.stringify(tmpDataToStringify);
	}
}

module.exports = PictTemplateProviderJSONOutput;

},{"pict-template":363}],415:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateOnlyFormat extends libPictTemplate
{
	/**
	 * @param {import('fable')} pFable - The Fable Framework instance
	 * @param {any} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateOnlyFormat:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValueSet = tmpHash.split('^');

		if (tmpDateValueSet.length < 2)
		{
			this.log.error(`PICT Template [fDateOnlyFormat]::[${tmpHash}] did not have a valid format string and date.`);
			return '';
		}

		let tmpDateValue = this.resolveStateFromAddress(tmpDateValueSet[0], tmpData, pContextArray, null, pScope, pState);

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateOnlyFormat]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateOnlyFormat]::[${tmpHash}]`);
		}

		// Because this is "Date Only", we force the time to be UTC 00:00:00 and go with the date part only.
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);

		return tmpDayJS.format(tmpDateValueSet[1]);
	}
}

module.exports = PictTemplateProviderDateOnlyFormat;

/*
# DEAR DEAD CODE DIARY:

```javascript

```
*/


},{"pict-template":363}],416:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateOnlyYMD extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateOnlyYMD:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);


		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}]`);
		}

		// A missing value must render as empty — dayjs.utc(undefined) is NOW,
		// which silently writes today's date into absent date fields.
		if (tmpDateValue === undefined || tmpDateValue === null || tmpDateValue === '')
		{
			return '';
		}

		// Because this is "Date Only", we force the time to be UTC 00:00:00 and go with the date part only.
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);

		if (!tmpDayJS.isValid())
		{
			return '';
		}

		//FIXME: this is kind of wacked out; -62167219200000 is the unix ms timestamp for 0000-01-01 00:00:00 UTC
		//       not even sure showing negative is right; showing the era is probably better (BCE vs CE)
		//const prefix = tmpDayJS.valueOf() < -62167219200000 ? '-' : '';
		const tmpPrefix = '';

		return tmpPrefix + tmpDayJS.format('YYYY-MM-DD');
	}
}

module.exports = PictTemplateProviderDateOnlyYMD;

},{"pict-template":363}],417:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateTimeFormat extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateTimeFormat:', '~}');
		this.addPattern('{~DateFormat:', '~}'); // for backwards compatibility
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValueSet = tmpHash.split('^');

		if (tmpDateValueSet.length < 2)
		{
			this.log.error(`PICT Template [fDateTimeFormat]::[${tmpHash}] did not have a valid format string and date.`);
			return '';
		}

		let tmpDateValue = this.resolveStateFromAddress(tmpDateValueSet[0], tmpData, pContextArray, null, pScope, pState);

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateTimeFormat]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateTimeFormat]::[${tmpHash}]`);
		}

		// TODO: Modularize this
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);
		try
		{
			// Try to cast the day to be a specific timezone if one is set for the app
			if (this.pict.options.Timezone)
			{
				tmpDayJS = tmpDayJS.tz(this.pict.options.Timezone);
			}
			else
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
		}
		catch
		{
			//this.log.error(`Error casting date passed timezone using tz .. casting to the browser guess which is [${this.fable.Dates.dayJS.tz.guess()}].`);
			// Day.js will try to guess the user's timezone for us
			try
			{
				tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
			}
			catch (pError)
			{
				this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
			}
		}

		return tmpDayJS.format(tmpDateValueSet[1]);
	}
}

module.exports = PictTemplateProviderDateTimeFormat;

/*
# DEAR DEAD CODE DIARY:

```javascript

```
*/


},{"pict-template":363}],418:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateTimeYMD extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateTimeYMD:', '~}');
		this.addPattern('{~DateYMD:', '~}'); // for backwards compatibility
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);


		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}]`);
		}

		// TODO: Modularize this
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);
		try
		{
			// Try to cast the day to be a specific timezone if one is set for the app
			if (this.pict.options.Timezone)
			{
				tmpDayJS = tmpDayJS.tz(this.pict.options.Timezone);
			}
			else
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
		}
		catch
		{
			//this.log.error(`Error casting timezone using tz .. casting to the browser guess which is [${this.fable.Dates.dayJS.tz.guess()}].`);
			// Day.js will try to guess the user's timezone for us
			try
			{
				tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
			}
			catch (pError)
			{
				this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
			}
		}

		return tmpDayJS.format('YYYY-MM-DD');
	}
}

module.exports = PictTemplateProviderDateTimeYMD;

},{"pict-template":363}],419:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDigits extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~Digits:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDigits]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDigits]::[${tmpHash}]`);
		}

		let tmpColumnData = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		return this.fable.DataFormat.formatterAddCommasToNumber(this.fable.DataFormat.formatterRoundNumber(tmpColumnData, 2));
	}
}

module.exports = PictTemplateProviderDigits;

},{"pict-template":363}],420:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDollars extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~Dollars:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDollars]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDollars]::[${tmpHash}]`);
		}

		let tmpColumnData = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		return this.fable.DataFormat.formatterDollars(tmpColumnData);
	}
}

module.exports = PictTemplateProviderDollars;

},{"pict-template":363}],421:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderHTMLCommandEnd extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~HtmlCommentEnd:', '~}');
		this.addPattern('{~HCE:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpValue = false;
		const [ tmpValueAddress, tmpPolarityStr ] = tmpHash.split(':');
		if (tmpValueAddress != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpValueAddress, tmpRecord, pContextArray, null, pScope, pState);
		}
		const tmpPolarity = tmpPolarityStr != null ? tmpPolarityStr === '1' || tmpPolarityStr.toLowerCase() === 'true' || tmpPolarityStr.toLowerCase() === 't' : false;
		if (Boolean(tmpValue) == tmpPolarity)
		{
			return ' -->';
		}
		return '';
	}
}

module.exports = PictTemplateProviderHTMLCommandEnd;

},{"pict-template":363}],422:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderHTMLCommandStart extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~HtmlCommentStart:', '~}');
		this.addPattern('{~HCS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpValue = false;
		const [ tmpValueAddress, tmpPolarityStr ] = tmpHash.split(':');
		if (tmpValueAddress != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpValueAddress, tmpRecord, pContextArray, null, pScope, pState);
		}
		const tmpPolarity = tmpPolarityStr != null ? tmpPolarityStr === '1' || tmpPolarityStr.toLowerCase() === 'true' || tmpPolarityStr.toLowerCase() === 't' : false;
		if (Boolean(tmpValue) == tmpPolarity)
		{
			return '<!-- ';
		}
		return '';
	}
}

module.exports = PictTemplateProviderHTMLCommandStart;

},{"pict-template":363}],423:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderJoin extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~Join:', '~}');
		this.addPattern('{~J:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Join [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Join [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 2)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();

		let tmpValueList = [];
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope, pState);
			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					tmpValueList.push(tmpValueSet[j]);
				}
			}
			else if (tmpValueSet)
			{
				tmpValueList.push(tmpValueSet);
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderJoin;

},{"pict-template":363}],424:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderJoinUnique extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~JoinUnique:', '~}');
		this.addPattern('{~JU:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Join Unique [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Join Unique [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 2)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();

		let tmpValueList = [];
		let tmpValueMap = {};
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope, pState);

			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					if (!(tmpValueSet[j] in tmpValueMap))
					{
						tmpValueMap[tmpValueSet[j]] = true;
						tmpValueList.push(tmpValueSet[j]);
					}
				}
			}
			else if (tmpValueSet)
			{
				if (!(tmpValueSet in tmpValueMap))
				{
					tmpValueMap[tmpValueSet] = true;
					tmpValueList.push(tmpValueSet);
				}
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderJoinUnique;

},{"pict-template":363}],425:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderPascalCaseIdentifier extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~PascalCaseIdentifier:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fPascalCaseIdentifier]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fPascalCaseIdentifier]::[${tmpHash}]`);
		}

		let tmpValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof (tmpValue) == 'undefined'))
		{
			return '';
		}
		return this.pict.DataFormat.cleanNonAlphaCharacters(this.pict.DataFormat.capitalizeEachWord(tmpValue));
	}
}

module.exports = PictTemplateProviderPascalCaseIdentifier;

/*
# DEAR DEAD CODE DIARY:

```javascript

```
*/


},{"pict-template":363}],426:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderPluckJoinUnique extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~PluckJoinUnique:', '~}');
		this.addPattern('{~PJU:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 3)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();
		let tmpAddress = tmpDataAddresses.shift();

		let tmpValueList = [];
		let tmpValueMap = {};
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope, pState);

			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				// This one only works on arrays of objects.
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					if ((tmpValueSet[j] === null) || (typeof(tmpValueSet) !== 'object'))
					{
						continue;
					}
					let tmpValue = this.pict.manifest.getValueByHash(tmpValueSet[j], tmpAddress);
					if (!(tmpValue in tmpValueMap))
					{
						tmpValueMap[tmpValue] = true;
						tmpValueList.push(tmpValue);
					}
				}
			}
			else if (tmpValueSet)
			{
				if (!(tmpValueSet in tmpValueMap))
				{
					tmpValueMap[tmpValueSet] = true;
					tmpValueList.push(tmpValueSet);
				}
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderPluckJoinUnique;

},{"pict-template":363}],427:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderBreakpoint extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Breakpoint', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpError = new Error(`PICT Template Breakpoint: ${tmpHash}`);
		this.log.trace(`PICT Template Breakpoint: ${tmpHash}`, tmpError.stack);
		//throw tmpError;
		debugger; // eslint-disable-line no-debugger
		return '';
	}

}

module.exports = PictTemplateProviderBreakpoint;

},{"pict-template":363}],428:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDataValueTree extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataTree:', '~}');
		this.addPattern('{~DT:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		tmpData.TemplateHash = pTemplateHash.trim();

		tmpData.ValueTreeParameters = tmpData.TemplateHash.split('^');
		if (tmpData.ValueTreeParameters.length < 1)
		{
			return '';
		}
		tmpData.ResolvedValue = this.resolveStateFromAddress(tmpData.ValueTreeParameters[0], tmpData, pContextArray, null, pScope, pState);
		tmpData.ResolvedValueType = typeof (tmpData.ResolvedValue);

		try
		{
			tmpData.TreeMaxDepth = (tmpData.ValueTreeParameters.length < 2) ? 1 : parseInt(tmpData.ValueTreeParameters[1]);
		}
		catch
		{
			tmpData.TreeMaxDepth = 1;
		}

		let tmpPictObjectWrapTemplate = this.pict.TemplateProvider.getTemplate('PICT-Object-Wrap');
		if (!tmpPictObjectWrapTemplate)
		{
			// This template is here because it is a default template.  Users can override this template by providing their own as PICT-Object-Wrap
			tmpPictObjectWrapTemplate = `<div class="PICT PICTObjectSet">{~D:Record.ObjectValueTree~}</div>`;
		}

		if (tmpData.ResolvedValueType == 'object')
		{
			tmpData.ObjectValueTree = this.dataValueTreeObjectSet(tmpData.ResolvedValue, tmpData.ResolvedValue, 0, tmpData.TreeMaxDepth, pContextArray, pScope);
		}
		else
		{
			this.log.trace(`PICT Template Log Value Tree: [${tmpData.TemplateHash}] resolved data is not an object.`, tmpData.ResolvedValue);
			tmpData.ObjectValueTree = tmpData.ResolveValue;
		}

		return this.pict.parseTemplate(tmpPictObjectWrapTemplate, tmpData, null, pContextArray, pScope, pState);
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {Object} pObject - The object to be rendered as a value tree
	 * @param {Object} pRootObject - The root object for the value tree, used to provide context
	 * @param {number} pCurrentDepth - The current depth in the value tree
	 * @param {number} pMaxDepth - The maximum depth to render in the value tree
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	dataValueTreeObjectSet(pObject, pRootObject, pCurrentDepth, pMaxDepth, pContextArray, pScope, pState)
	{
		let tmpTemplateResult = '';

		if (typeof (pObject) !== 'object')
		{
			return tmpTemplateResult;
		}

		let tmpObjectValueKeys = Object.keys(pObject);

		let tmpPictObjectBranchTemplate = this.pict.TemplateProvider.getTemplate('PICT-Object-Branch');
		if (!tmpPictObjectBranchTemplate)
		{
			// This template is here because it is a default template.  Users can override this template by providing their own as PICT-Object-Branch
			tmpPictObjectBranchTemplate = `
<div class="PICTObjectBranchDepth_{~D:Record.CurrentDepth~}"><div class="PICTObjectBranch">{~D:Record.BranchKey~}</div><div class="PICTObjectBranchValue">{~D:Record.BranchValue~}</div></div>
`
		}

		for (let i = 0; i < tmpObjectValueKeys.length; i++)
		{
			let tmpBranchType = typeof (pObject[tmpObjectValueKeys[i]]);

			let tmpBranchValue = '';

			switch (tmpBranchType)
			{
				case 'object':
					if (pCurrentDepth + 1 > pMaxDepth)
					{
						tmpBranchValue = '...';
					}
					else
					{
						tmpBranchValue = this.dataValueTreeObjectSet(pObject[tmpObjectValueKeys[i]], pRootObject, pCurrentDepth + 1, pMaxDepth, pContextArray, pScope);
					}
					break;

				default:
					tmpBranchValue = pObject[tmpObjectValueKeys[i]];
					break;
			}

			let tmpDataValue =
			{
				AppData: this.pict.AppData,
				Bundle: this.pict.Bundle,

				RootContainer: pRootObject,

				Container: pObject,
				BranchEntryCount: tmpObjectValueKeys.length,

				BranchIndex: i,
				BranchKey: tmpObjectValueKeys[i],
				BranchValue: tmpBranchValue,
				BranchDataType: tmpBranchType,

				CurrentDepth: pCurrentDepth,
				MaxDepth: pMaxDepth
			};
			tmpTemplateResult += this.pict.parseTemplate(tmpPictObjectBranchTemplate, tmpDataValue, null, pContextArray, pScope, pState);
		}

		return tmpTemplateResult;
	}
}

module.exports = PictTemplateProviderDataValueTree;

},{"pict-template":363}],429:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderLogStatement extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~LogStatement:', '~}');
		this.addPattern('{~LS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		this.log.trace(`PICT Template Log Message: ${tmpHash}`);
		return '';
	}
}

module.exports = PictTemplateProviderLogStatement;

},{"pict-template":363}],430:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderLogValue extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~LogValue:', '~}');
		this.addPattern('{~LV:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		let tmpValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		let tmpValueType = typeof (tmpValue);
		if ((tmpValue == null) || (tmpValueType == 'undefined'))
		{
			this.log.trace(`PICT Template Log Value: [${tmpHash}] is ${tmpValueType}.`);
		}
		else if (tmpValueType == 'object')
		{
			this.log.trace(`PICT Template Log Value: [${tmpHash}] is an object.`, tmpValue);
		}
		else
		{
			this.log.trace(`PICT Template Log Value: [${tmpHash}] is a ${tmpValueType} = [${tmpValue}]`);
		}
		return '';
	}
}

module.exports = PictTemplateProviderLogValue;

},{"pict-template":363}],431:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderLogValueTree extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~LogValueTree:', '~}');
		this.addPattern('{~LVT:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		tmpData.TemplateHash = pTemplateHash.trim();

		tmpData.ValueTreeParameters = tmpData.TemplateHash.split('^');
		if (tmpData.ValueTreeParameters.length < 1)
		{
			return '';
		}
		tmpData.ResolvedValue = this.resolveStateFromAddress(tmpData.ValueTreeParameters[0], tmpData, pContextArray, null, pScope, pState);
		tmpData.ResolvedValueType = typeof (tmpData.ResolvedValue);


		try
		{
			tmpData.TreeMaxDepth = (tmpData.ValueTreeParameters.length < 2) ? 1 : parseInt(tmpData.ValueTreeParameters[1]);
		}
		catch
		{
			tmpData.TreeMaxDepth = 1;
		}

		if (tmpData.ResolvedValueType == 'object')
		{
			this.logValueTreeObjectSet(tmpData.ResolvedValue, tmpData.ValueTreeParameters[0], tmpData.ResolvedValue, 0, tmpData.TreeMaxDepth);
		}
		else
		{
			this.log.trace(`PICT Template Log Value Tree: [${tmpData.TemplateHash}] resolved data is not an object.`, tmpData.ResolvedValue);
		}

		return '';
	}
	logValueTreeObjectSet = (pObject, pBaseAddress, pRootObject, pCurrentDepth, pMaxDepth) =>
	{
		let tmpTemplateResult = '';

		if (typeof (pObject) !== 'object')
		{
			return tmpTemplateResult;
		}

		let tmpObjectValueKeys = Object.keys(pObject);

		for (let i = 0; i < tmpObjectValueKeys.length; i++)
		{
			let tmpBranchType = typeof (pObject[tmpObjectValueKeys[i]]);
			let tmpBranchValue = '';

			switch (tmpBranchType)
			{
				case 'object':
					tmpBranchValue = '...';
					break;

				default:
					tmpBranchValue = pObject[tmpObjectValueKeys[i]];
					break;
			}
			this.log.trace(`[${pBaseAddress}.${tmpObjectValueKeys[i]}] (${tmpBranchType}):  ${tmpBranchValue}`);

			if (pCurrentDepth + 1 > pMaxDepth)
			{
				return '';
			}
			else if (tmpBranchType == 'object')
			{
				tmpBranchValue = this.logValueTreeObjectSet(pObject[tmpObjectValueKeys[i]], `${pBaseAddress}.${tmpObjectValueKeys[i]}`, pRootObject, pCurrentDepth + 1, pMaxDepth);
			}
		}

		return '';
	};
}

module.exports = PictTemplateProviderLogValueTree;

},{"pict-template":363}],432:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderNotEmpty extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~NotEmpty:', '~}');
		this.addPattern('{~NE:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fNotEmptyRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PICT Template [fNotEmptyRender]::[${tmpHash}]`);
		}

		let tmpHashParts = tmpHash.split('^');

		// For now just check truthiness.  Not sure if this is grand.
		if (this.resolveStateFromAddress(tmpHashParts[0], tmpData, pContextArray, null, pScope, pState))
		{
			return tmpHashParts[1];
		}

		return '';
	}
}

module.exports = PictTemplateProviderNotEmpty;

},{"pict-template":363}],433:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateIfBase extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	compareValues (pValueLeft, pOperator, pValueRight)
	{
		switch(pOperator)
		{
			case 'TRUE':
				return (pValueLeft === true);
			case 'FALSE':
				return (pValueLeft === false);
			case 'LNGT':
			case 'LENGTH_GREATER_THAN':
				switch(typeof(pValueLeft))
				{
					case 'string':
						return (pValueLeft.length > pValueRight);
					case 'object':
						return (pValueLeft.length > pValueRight);
					default:
						return false;
				}
			case 'LNLT':
			case 'LENGTH_LESS_THAN':
				switch(typeof(pValueLeft))
				{
					case 'string':
						return (pValueLeft.length < pValueRight);
					case 'object':
						return (pValueLeft.length < pValueRight);
					default:
						return false;
				}
			case '!==':
				return (pValueLeft !== pValueRight);
			case '!=':
				return (pValueLeft != pValueRight);
			case '<':
				return (pValueLeft < pValueRight);
			case '>':
				return (pValueLeft > pValueRight);
			case '<=':
				return (pValueLeft <= pValueRight);
			case '>=':
				return (pValueLeft >= pValueRight);
			case '===':
				return (pValueLeft === pValueRight);
			case '==':
				return (pValueLeft == pValueRight);
			default:
				return false;
		}
	}
}

module.exports = PictTemplateProviderTemplateIfBase;

},{"pict-template":363}],434:[function(require,module,exports){
const libPictTemplateIf = require('./Pict-Template-TemplateIf-Base.js');

class PictTemplateProviderTemplateIf extends libPictTemplateIf
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateIf:', '~}');
		this.addPattern('{~TIf:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return '';
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return '';
		}

		// Now look up the data at the comparison location
		try
		{
			let tmpComparisonResult = this.compareValues(
				this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState),
				tmpComparisonParts[1],
				this.resolveStateFromAddress(tmpComparisonParts[2], tmpData, pContextArray, null, pScope, pState));

			if (!tmpComparisonResult)
			{
				return '';
			}
			if (!tmpAddressOfData)
			{
				// No address was provided, just render the template with what this template has.
				return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
			}
			else
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return '';
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now look up the data at the comparison location
		try
		{
			// This is the only thing that's different from the absolute value function above.  Collapse these.
			let tmpComparisonResult = this.compareValues(
				this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState),
				tmpComparisonParts[1],
				this.resolveStateFromAddress(tmpComparisonParts[2], tmpData, pContextArray, null, pScope, pState));

			if (!tmpComparisonResult)
			{
				return tmpCallback(null, '');
			}
			if (!tmpAddressOfData)
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
			else
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return tmpCallback(pError, '');
		}
	}
}

module.exports = PictTemplateProviderTemplateIf;

},{"./Pict-Template-TemplateIf-Base.js":433}],435:[function(require,module,exports){
const libPictTemplateIf = require('./Pict-Template-TemplateIf-Base.js');

class PictTemplateProviderTemplateIfAbsolute extends libPictTemplateIf
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateIfAbsolute:', '~}');
		this.addPattern('{~TIfAbs:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return '';
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return '';
		}

		// Now look up the data at the comparison location
		try
		{
			let tmpComparisonResult = this.compareValues(this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState), tmpComparisonParts[1], tmpComparisonParts[2]);
			if (!tmpComparisonResult)
			{
				return '';
			}
			if (!tmpAddressOfData)
			{
				// No address was provided, just render the template with what this template has.
				return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
			}
			else
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return '';
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now look up the data at the comparison location
		try
		{
			let tmpComparisonResult = this.compareValues(this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState), tmpComparisonParts[1], tmpComparisonParts[2]);
			if (!tmpComparisonResult)
			{
				return tmpCallback(null, '');
			}
			if (!tmpAddressOfData)
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
			else
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return tmpCallback(pError, '');
		}
	}
}

module.exports = PictTemplateProviderTemplateIfAbsolute;

},{"./Pict-Template-TemplateIf-Base.js":433}],436:[function(require,module,exports){
/**
* Precedent Meta-Templating
*
* @license     MIT
*
* @author      Steven Velozo <steven@velozo.com>
*
* @description Process text streams, parsing out meta-template expressions.
*/
var libWordTree = require(`./WordTree.js`);
var libStringParser = require(`./StringParser.js`);

class Precedent
{
	/**
	 * Precedent Constructor
	 */
	constructor()
	{
		this.WordTree = new libWordTree();

		this.StringParser = new libStringParser();

		this.ParseTree = this.WordTree.ParseTree;
	}

	/**
	 * Add a Pattern to the Parse Tree
	 * @method addPattern
	 * @param {Object} pTree - A node on the parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @param {number} pIndex - callback function
	 * @return {bool} True if adding the pattern was successful
	 */
	addPattern(pPatternStart, pPatternEnd, pParser)
	{
		return this.WordTree.addPattern(pPatternStart, pPatternEnd, pParser);
	}

	/**
	 * Parse a string with the existing parse tree
	 * @method parseString
	 * @param {string} pString - The string to parse
	 * @param {object} pData - Data to pass in as the second argument
	 * @return {string} The result from the parser
	 */
	parseString(pString, pData)
	{
		return this.StringParser.parseString(pString, this.ParseTree, pData);
	}
}

module.exports = Precedent;

},{"./StringParser.js":437,"./WordTree.js":438}],437:[function(require,module,exports){
/**
* String Parser
* @author      Steven Velozo <steven@velozo.com>
* @description Parse a string, properly processing each matched token in the word tree.
*/

class StringParser
{
	/**
	 * StringParser Constructor
	 */
	constructor()
	{
	}

	/**
	 * Create a fresh parsing state object to work with.
	 * @method newParserState
	 * @param {Object} pParseTree - A node on the parse tree to begin parsing from (usually root)
	 * @return {Object} A new parser state object for running a character parser on
	 * @private
	 */
	newParserState (pParseTree)
	{
		return (
		{
			ParseTree: pParseTree,

			Asynchronous: false,

			Output: '',
			OutputBuffer: '',

			Pattern: {},

			PatternMatch: false,
			PatternMatchEnd: false
		});
	}

	/**
	 * Append a character to the output buffer in the parser state.
	 * This output buffer is used when a potential match is being explored, or a match is being explored.
	 * @method appendOutputBuffer
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	appendOutputBuffer (pCharacter, pParserState)
	{
		pParserState.OutputBuffer += pCharacter;
	}

	/**
	 * Flush the output buffer to the output and clear it.
	 * @method flushOutputBuffer
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	flushOutputBuffer (pParserState)
	{
		pParserState.Output += pParserState.OutputBuffer;
		pParserState.OutputBuffer = '';
	}

	resetOutputBuffer (pParserState)
	{
		// Flush the output buffer.
		this.flushOutputBuffer(pParserState);
		// End pattern mode
		pParserState.Pattern = false;
		pParserState.PatternStartNode = false;
		pParserState.StartPatternMatchComplete = false;
		pParserState.EndPatternMatchBegan = false;
		pParserState.PatternMatch = false;

		return true;
	}

	/**
	 * Parse a character in the buffer.
	 * @method parseCharacter
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	parseCharacter (pCharacter, pParserState, pData)
	{
		// If we are already in a pattern match traversal
		if (pParserState.PatternMatch)
		{
			// If the pattern is still matching the start and we haven't passed the buffer
			if (!pParserState.StartPatternMatchComplete && pParserState.Pattern.hasOwnProperty(pCharacter))
			{
				pParserState.Pattern = pParserState.Pattern[pCharacter];
				this.appendOutputBuffer(pCharacter, pParserState);
			}
			else if (pParserState.EndPatternMatchBegan)
			{
				if (pParserState.Pattern.PatternEnd.hasOwnProperty(pCharacter))
				{
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// Flush the output buffer.
					this.appendOutputBuffer(pCharacter, pParserState);
					// If this last character is the end of the pattern, parse it.
					if (pParserState.Pattern.hasOwnProperty('Parse'))
					{
						// Run the function
						pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData);
						return this.resetOutputBuffer(pParserState);
					}
				}
				else if (pParserState.PatternStartNode.PatternEnd.hasOwnProperty(pCharacter))
				{
					// We broke out of the end -- see if this is a new start of the end.
					pParserState.Pattern = pParserState.PatternStartNode.PatternEnd[pCharacter];
					this.appendOutputBuffer(pCharacter, pParserState);
				}
				else
				{
					pParserState.EndPatternMatchBegan = false;
					this.appendOutputBuffer(pCharacter, pParserState);
				}
			}
			else if (pParserState.Pattern.hasOwnProperty('PatternEnd'))
			{
				if (!pParserState.StartPatternMatchComplete)
				{
					pParserState.StartPatternMatchComplete = true;
					pParserState.PatternStartNode = pParserState.Pattern;
				}

				this.appendOutputBuffer(pCharacter, pParserState);

				if (pParserState.Pattern.PatternEnd.hasOwnProperty(pCharacter))
				{
					// This is the first character of the end pattern.
					pParserState.EndPatternMatchBegan = true;
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// If this last character is the end of the pattern, parse it.
					if (pParserState.Pattern.hasOwnProperty('Parse'))
					{
						// Run the t*mplate function
						pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData);
						return this.resetOutputBuffer(pParserState);
					}
				}
			}
			else
			{
				// We are in a pattern start but didn't match one; reset and start trying again from this character.
				this.resetOutputBuffer(pParserState);
			}
		}
		// If we aren't in a pattern match or pattern, and this isn't the start of a new pattern (RAW mode)....
		if (!pParserState.PatternMatch)
		{
			// This may be the start of a new pattern....
			if (pParserState.ParseTree.hasOwnProperty(pCharacter))
			{
				// ... assign the root node as the matched node.
				this.resetOutputBuffer(pParserState);
				this.appendOutputBuffer(pCharacter, pParserState);
				pParserState.Pattern = pParserState.ParseTree[pCharacter];
				pParserState.PatternMatch = true;
				return true;
			}
			else
			{
				this.appendOutputBuffer(pCharacter, pParserState);
			}
		}
		return false;
	}

	/**
	 * Parse a string for matches, and process any template segments that occur.
	 * @method parseString
	 * @param {string} pString - The string to parse.
	 * @param {Object} pParseTree - The parse tree to begin parsing from (usually root)
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 */
	parseString (pString, pParseTree, pData)
	{
		let tmpParserState = this.newParserState(pParseTree);

		for (var i = 0; i < pString.length; i++)
		{
			this.parseCharacter(pString[i], tmpParserState, pData);
		}

		this.flushOutputBuffer(tmpParserState);

		return tmpParserState.Output;
	}
}

module.exports = StringParser;

},{}],438:[function(require,module,exports){
/**
* Word Tree
* @author      Steven Velozo <steven@velozo.com>
* @description Create a tree (directed graph) of Javascript objects, one character per object.
*/

class WordTree
{
	/**
	 * WordTree Constructor
	 */
	constructor()
	{
		this.ParseTree = {};
	}

	/**
	 * Add a child character to a Parse Tree node
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addChild (pTree, pPattern)
	{
		if (!pTree.hasOwnProperty(pPattern))
		{
			pTree[pPattern] = {};
		}

		return pTree[pPattern];
	}

	/**
	 * Add a child character to a Parse Tree PatternEnd subtree
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addEndChild (pTree, pPattern)
	{
		if (!pTree.hasOwnProperty('PatternEnd'))
		{
			pTree.PatternEnd = {};
		}

		pTree.PatternEnd[pPattern] = {};

		return pTree.PatternEnd[pPattern];
	}

	/** Add a Pattern to the Parse Tree
	 * @method addPattern
	 * @param {Object} pPatternStart - The starting string for the pattern (e.g. "${")
	 * @param {string} pPatternEnd - The ending string for the pattern (e.g. "}")
	 * @param {function} fParser - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @return {bool} True if adding the pattern was successful
	 */
	addPattern (pPatternStart, pPatternEnd, fParser)
	{
		if (pPatternStart.length < 1)
		{
			return false;
		}

		if ((typeof(pPatternEnd) === 'string') && (pPatternEnd.length < 1))
		{
			return false;
		}

		let tmpLeaf = this.ParseTree;

		// Add the tree of leaves iteratively
		for (var i = 0; i < pPatternStart.length; i++)
		{
			tmpLeaf = this.addChild(tmpLeaf, pPatternStart[i], i);
		}

		if (!tmpLeaf.hasOwnProperty('PatternEnd'))
		{
			tmpLeaf.PatternEnd = {};
		}

		let tmpPatternEnd = (typeof(pPatternEnd) === 'string') ? pPatternEnd : pPatternStart;
		for (let i = 0; i < tmpPatternEnd.length; i++)
		{
			tmpLeaf = this.addEndChild(tmpLeaf, tmpPatternEnd[i], i);
		}

		tmpLeaf.PatternStartString = pPatternStart;
		tmpLeaf.PatternEndString = tmpPatternEnd;
		tmpLeaf.Parse = (typeof(fParser) === 'function') ? fParser :
						(typeof(fParser) === 'string') ? () => { return fParser; } :
						(pData) => { return pData; };

		return true;
	}
}

module.exports = WordTree;

},{}],439:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],440:[function(require,module,exports){
(function (global){(function (){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],441:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986',
    WHATWG: 'WHATWG'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        },
        WHATWG: function (value) {
            return replace.call(value, percentTwenties, '+');
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986,
    WHATWG: Format.WHATWG
};

},{}],442:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":441,"./parse":443,"./stringify":444}],443:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf;
var fromCharCode = String.fromCharCode;

var isPlainContainer = function isPlainContainer(value) {
    if (!value || typeof value !== 'object') {
        return false;
    }
    if (isArray(value)) {
        return true;
    }
    var proto = getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};

var emptyCopyOf = function emptyCopyOf(value) {
    if (isArray(value)) {
        var arr = [];
        arr.length = value.length;
        return arr;
    }
    return getPrototypeOf(value) === null ? { __proto__: null } : {};
};

// `merge` and `compact` modify the containers they are given, so copy the caller's arrays and plain objects first
var copyInput = function copyInput(input) {
    var copies = getSideChannel();
    var result = {};
    var queue = [{ source: input, target: result }];

    for (var i = 0; i < queue.length; ++i) {
        var source = queue[i].source;
        var target = queue[i].target;
        var keys = Object.keys(source);
        for (var j = 0; j < keys.length; ++j) {
            var value = source[keys[j]];
            // `target[key] =` would invoke the `__proto__` setter. `setProperty` stores that key as data.
            if (isPlainContainer(value)) {
                if (!copies.has(value)) {
                    var copy = emptyCopyOf(value);
                    copies.set(value, copy);
                    queue[queue.length] = { source: value, target: copy };
                }
                utils.setProperty(target, keys[j], copies.get(value));
            } else {
                utils.setProperty(target, keys[j], value);
            }
        }
    }

    return result;
};

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        var c = parseInt(numberStr, 10);
        if (c > 0xFFFF && c <= 0x10FFFF) {
            // `String.fromCodePoint` is not available in every supported engine, so build the surrogate pair by hand
            c -= 0x10000;
            return fromCharCode(0xD800 | (c >> 10), 0xDC00 | (c & 0x3FF));
        }
        return fromCharCode(c);
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while (commaIndex > -1) {
                commaCount += 1;
                if (commaCount >= options.arrayLimit) {
                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                }
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }

    if (
        options.throwOnLimitExceeded
        && currentArrayLength >= options.arrayLimit
        && currentArrayLength > 0
    ) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        // `[]` belongs to the key, so look for it at the split point, not anywhere in the part
        var isEmptyBracketKey = pos > 1 && part.slice(pos - 2, pos) === '[]';

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) && (options.duplicates === 'combine' || isEmptyBracketKey) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = utils.maybeMap(val, function (value) {
                return value ? interpretNumericEntities(String(value)) : value;
            });
        }

        if (isEmptyBracketKey) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            val = utils.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || isEmptyBracketKey)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects,
                    options.throwOnLimitExceeded
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var stripWrappingBrackets = function stripWrappingBrackets(key) {
    return key.charAt(0) === '[' && key.charAt(key.length - 1) === ']' ? key.slice(1, -1) : key;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects,
                        options.throwOnLimitExceeded
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = stripWrappingBrackets(root);
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/gi, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj[0] = leaf;
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

// Behaves like `key.replace(/\.([^.[]+)/g, '[$1]')`, but only rewrites a dot
// that sits at bracket depth 0. A literal dot already inside a `[...]` segment
// is left untouched instead of corrupting the key (e.g. "outer[a.b]"). (#617)
var topLevelDotsToBrackets = function topLevelDotsToBrackets(key) {
    var result = '';
    var depth = 0;
    for (var i = 0; i < key.length; i += 1) {
        var cu = key.charCodeAt(i);
        if (cu === 0x5B) { // '['
            depth += 1;
            result += '[';
        } else if (cu === 0x5D) { // ']'
            if (depth > 0) {
                depth -= 1;
            }
            result += ']';
        } else if (
            cu === 0x2E // '.'
            && depth === 0
            && i + 1 < key.length
            && key.charCodeAt(i + 1) !== 0x2E // not another '.'
            && key.charCodeAt(i + 1) !== 0x5B // not '['
        ) {
            var start = i + 1;
            var j = start;
            while (j < key.length && key.charCodeAt(j) !== 0x2E && key.charCodeAt(j) !== 0x5B) {
                j += 1;
            }
            result += '[' + key.slice(start, j) + ']';
            i = j - 1;
        } else {
            result += key.charAt(i);
        }
    }
    return result;
};

// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? topLevelDotsToBrackets(originalKey) : originalKey;

    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        // `parseObject` strips one wrapping bracket pair, so guard the key it will store ("[toString]" -> "toString")
        if (!options.plainObjects && has.call(Object.prototype, stripWrappingBrackets(key))) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var segments = [];

    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        segments[segments.length] = parent;
    }

    var n = key.length;
    var open = first;
    var collected = 0;

    while (open >= 0 && collected < options.depth) {
        var level = 1;
        var i = open + 1;
        var close = -1;

        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while (i < n && close < 0) {
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) { // '['
                level += 1;
            } else if (cu === 0x5D) { // ']'
                level -= 1;
                if (level === 0) {
                    close = i; // found matching close; loop will exit by condition
                }
            }
            i += 1;
        }

        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }

        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, content) && !options.allowPrototypes) {
            return;
        }

        segments[segments.length] = seg;
        collected += 1;

        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }

    if (open >= 0) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        segments[segments.length] = '[' + key.slice(open) + ']';
    }

    return segments;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : copyInput(str);
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

},{"./utils":445,"side-channel":521}],444:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    depth: Infinity,
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel,
    depth,
    currentDepth
) {
    var obj = object;

    if (currentDepth > depth) {
        throw new RangeError('Input depth exceeded depth option of ' + depth);
    }

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;

    if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return formatter(encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix);
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, function (v) {
                return v == null ? v : encoder(v, defaults.encoder, charset, 'value', format);
            });
        }
        objKeys = [{ value: obj.length > 0 ? utils.toCoercible(obj).join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) {
        return formatter(encoder && !encodeValuesOnly ? encoder(adjustedPrefix, defaults.encoder, charset, 'key', format) : adjustedPrefix) + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel,
            depth,
            currentDepth + 1
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (has.call(arrayPrefixGenerators, opts.arrayFormat)) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        // a copy: `sort` below must not reorder the caller's array, and nested
        // levels take their key order from the sorted copy
        filter = options.filter.slice();
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (typeof key === 'undefined' || key === null) {
            continue;
        }

        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }

        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);

        pushToArray(keys, stringify(
            value,
            encodedKey,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel,
            options.depth,
            0
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93' + options.delimiter;
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":441,"./utils":445,"side-channel":521}],445:[function(require,module,exports){
'use strict';

var formats = require('./formats');
var getSideChannel = require('side-channel');
var defineProperty = require('es-define-property');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

// Track containers produced by a `strictMerge` conflict wrap, and their current max numeric index,
// so repeated conflicts on one path append instead of nesting a new wrapper each time
var conflictChannel = getSideChannel();

var markConflict = function markConflict(obj, maxIndex) {
    conflictChannel.set(obj, maxIndex);
    return obj;
};

var isConflict = function isConflict(obj) {
    return conflictChannel.has(obj);
};

var getConflictIndex = function getConflictIndex(obj) {
    return conflictChannel.get(obj);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && defineProperty) {
        defineProperty(obj, key, {
            configurable: true,
            enumerable: true,
            value: value,
            writable: true
        });
    } else {
        obj[key] = value;
    }
};

var maxNumericIndex = function maxNumericIndex(obj, min) {
    var max = min;
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; ++i) {
        var num = parseInt(keys[i], 10);
        if (String(num) === keys[i] && num > max) {
            max = num;
        }
    }

    return max;
};

// parsed arrays stay sparse until `compact`, so `length` would count the holes left by indices like `a[19]`
var countElements = function countElements(arr) {
    var count = 0;
    for (var i = 0; i < arr.length; ++i) {
        if (has.call(arr, i)) {
            count += 1;
        }
    }
    return count;
};

var limitedPair = function limitedPair(first, second, options) {
    var pair = [first, second];
    if (options && typeof options.arrayLimit === 'number' && pair.length > options.arrayLimit) {
        if (options.throwOnLimitExceeded) {
            throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        }
        return markOverflow(arrayToObject(pair, options), 1);
    }
    return pair;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && countElements(target) >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) {
                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                }
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge && isConflict(target)) {
                var nextConflict = getConflictIndex(target) + 1;
                if (
                    options.throwOnLimitExceeded
                    && typeof options.arrayLimit === 'number'
                    && nextConflict >= options.arrayLimit
                ) {
                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                }
                target[nextConflict] = source;
                markConflict(target, nextConflict);
            } else if (options && options.strictMerge) {
                var conflict = limitedPair(target, source, options);
                return isArray(conflict) ? markConflict(conflict, 1) : conflict;
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return limitedPair(target, source, options);
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
        if (isConflict(target)) {
            // the array may have grown past its last conflict, so continue after its last index
            markConflict(mergeTarget, target.length - 1);
        }
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        if (options && typeof options.arrayLimit === 'number' && countElements(target) > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            return markOverflow(arrayToObject(target, options), target.length - 1);
        }
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            setProperty(acc, key, merge(acc[key], value, options));
        } else {
            setProperty(acc, key, value);
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, maxNumericIndex(acc, getMaxIndex(source)));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }
        if (isConflict(acc)) {
            var conflictKey = parseInt(key, 10);
            if (String(conflictKey) === key && conflictKey > getConflictIndex(acc)) {
                markConflict(acc, conflictKey);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        setProperty(acc, key, source[key]);
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    // With no `%` there is no escape to expand, in either charset: `unescape` has
    // nothing to match, and `decodeURIComponent` is the identity on such a string
    // (and cannot throw). So only `+` -> ' ' remains, and often not even that.
    if (typeof str === 'string' && str.indexOf('%') === -1) {
        return str.indexOf('+') === -1 ? str : str.replace(/\+/g, ' ');
    }

    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var hasToPrimitive = typeof Symbol === 'function' && typeof Symbol.toPrimitive === 'symbol';
var arrayJoin = Array.prototype.join;
var arrayToString = Array.prototype.toString;
var objectToString = Object.prototype.toString;

// an object with no callable toString (eg, from JSON, or null-prototype) would make String() or join() throw,
// so it becomes its primitive valueOf or else Object.prototype.toString; arrays are walked like join walks them,
// copied only once an element changes, with an array already being joined becoming '' as engines do for cycles
var toCoercible = function toCoercible(value, joining) {
    if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
        return value;
    }
    if (hasToPrimitive && value[Symbol.toPrimitive] != null) {
        return value;
    }
    if (isArray(value) && value.toString === arrayToString && value.join === arrayJoin) {
        var ancestors = joining || getSideChannel();
        if (ancestors.has(value)) {
            return '';
        }
        ancestors.set(value, true);
        var copy;
        for (var i = 0; i < value.length; i += 1) {
            var item = value[i];
            var coerced = toCoercible(item, ancestors);
            if (!copy && coerced !== item) {
                copy = [];
                for (var j = 0; j < i; j += 1) {
                    copy[j] = value[j];
                }
            }
            if (copy) {
                copy[i] = coerced;
            }
        }
        ancestors['delete'](value);
        return copy || value;
    }
    if (typeof value.toString === 'function') {
        return value;
    }
    var valueOf = value.valueOf;
    if (typeof valueOf === 'function') {
        var primitive = valueOf.call(value);
        if (!primitive || (typeof primitive !== 'object' && typeof primitive !== 'function')) {
            return String(primitive);
        }
    }
    return objectToString.call(value);
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(toCoercible(str));
    }

    if (charset === 'iso-8859-1') {
        // `escape` leaves `+` untouched, but a literal `+` is decoded back to a space,
        // so it must be percent-encoded to round-trip (the utf-8 path already does this).
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        }).replace(/\+/g, '%2B');
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        if (j + limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || (c === 0x7E && format !== formats.WHATWG) // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
                || (format === formats.WHATWG && c === 0x2A) // *
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            var next = segment.charCodeAt(i + 1);
            if (c <= 0xDBFF && next >= 0xDC00 && next <= 0xDFFF) {
                i += 1;
                c = 0x10000 + (((c & 0x3FF) << 10) | (next & 0x3FF));

                arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                    + hexTable[0x80 | ((c >> 12) & 0x3F)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
            } else {
                // a lone surrogate has no UTF-8 encoding; like `URLSearchParams` and `TextEncoder`, emit U+FFFD
                arr[arr.length] = '%EF%BF%BD';
            }
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = getSideChannel();

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = { obj: obj, prop: key };
                refs.set(val, true);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        if (throwOnLimitExceeded) {
            throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        }
        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
        // collection appended to an already-overflowed object is flattened
        // rather than nested under a single index
        var bValues = isArray(b) ? b : [b];
        var newIndex = getMaxIndex(a);
        for (var i = 0; i < bValues.length; ++i) {
            newIndex += 1;
            a[newIndex] = bValues[i];
        }
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) {
            throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        }
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge,
    setProperty: setProperty,
    toCoercible: toCoercible
};

},{"./formats":441,"es-define-property":41,"side-channel":521}],446:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],447:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],448:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":446,"./encode":447}],449:[function(require,module,exports){
// The container for all the Pict-Section-Flow related code.

// The main flow diagram view class
module.exports = require('./views/PictView-Flow.js');

// Node rendering view
module.exports.PictViewFlowNode = require('./views/PictView-Flow-Node.js');

// Toolbar views
module.exports.PictViewFlowToolbar = require('./views/PictView-Flow-Toolbar.js');
module.exports.PictViewFlowFloatingToolbar = require('./views/PictView-Flow-FloatingToolbar.js');

// Services
module.exports.PictServiceFlowInteractionManager = require('./services/PictService-Flow-InteractionManager.js');
module.exports.PictServiceFlowConnectionRenderer = require('./services/PictService-Flow-ConnectionRenderer.js');
module.exports.PictServiceFlowTether = require('./services/PictService-Flow-Tether.js');
module.exports.PictServiceFlowLayout = require('./services/PictService-Flow-Layout.js');
module.exports.PictServiceFlowPathGenerator = require('./services/PictService-Flow-PathGenerator.js');
module.exports.PictServiceFlowViewportManager = require('./services/PictService-Flow-ViewportManager.js');
module.exports.PictServiceFlowSelectionManager = require('./services/PictService-Flow-SelectionManager.js');
module.exports.PictServiceFlowPanelManager = require('./services/PictService-Flow-PanelManager.js');
module.exports.PictServiceFlowDataManager = require('./services/PictService-Flow-DataManager.js');
module.exports.PictServiceFlowConnectionHandleManager = require('./services/PictService-Flow-ConnectionHandleManager.js');
module.exports.PictServiceFlowRenderManager = require('./services/PictService-Flow-RenderManager.js');
module.exports.PictServiceFlowPortRenderer = require('./services/PictService-Flow-PortRenderer.js');

// Providers
module.exports.PictProviderFlowNodeTypes = require('./providers/PictProvider-Flow-NodeTypes.js');
module.exports.PictProviderFlowEventHandler = require('./providers/PictProvider-Flow-EventHandler.js');
module.exports.PictProviderFlowLayouts = require('./providers/PictProvider-Flow-Layouts.js');
module.exports.PictProviderFlowSVGHelpers = require('./providers/PictProvider-Flow-SVGHelpers.js');
module.exports.PictProviderFlowGeometry = require('./providers/PictProvider-Flow-Geometry.js');
module.exports.PictProviderFlowPanelChrome = require('./providers/PictProvider-Flow-PanelChrome.js');
module.exports.PictProviderFlowCSS = require('./providers/PictProvider-Flow-CSS.js');
module.exports.PictProviderFlowIcons = require('./providers/PictProvider-Flow-Icons.js');
module.exports.PictProviderFlowConnectorShapes = require('./providers/PictProvider-Flow-ConnectorShapes.js');

// Layout algorithm descriptors (consumers can register custom algorithms via
// _LayoutService.registerAlgorithm({ Name, Apply, DefaultParameters, ParameterSchema }))
module.exports.LayoutAlgorithms =
{
	Custom:           require('./providers/layouts/Layout-Custom.js'),
	Layered:          require('./providers/layouts/Layout-Layered.js'),
	ForcedFromCenter: require('./providers/layouts/Layout-ForcedFromCenter.js'),
	Grid:             require('./providers/layouts/Layout-Grid.js'),
	Circular:         require('./providers/layouts/Layout-Circular.js'),
	Tabular:          require('./providers/layouts/Layout-Tabular.js'),
	Columnar:         require('./providers/layouts/Layout-Columnar.js')
};

// Edge-theme descriptors (consumers can register custom edge themes via
// _LayoutService.registerEdgeTheme({ Name, GeneratePath, AdjustLayout?, ResolveAttachment?, ... }))
module.exports.EdgeThemes =
{
	Bezier:               require('./providers/edges/Edge-Bezier.js'),
	Orthogonal:           require('./providers/edges/Edge-Orthogonal.js'),
	Straight:             require('./providers/edges/Edge-Straight.js'),
	OrthogonalSnap:       require('./providers/edges/Edge-OrthogonalSnap.js'),
	Perimeter:            require('./providers/edges/Edge-Perimeter.js'),
	PerimeterLinear:      require('./providers/edges/Edge-Perimeter-Linear.js'),
	PerimeterOrthogonal:  require('./providers/edges/Edge-Perimeter-Orthogonal.js')
};

// FlowCard base class
module.exports.PictFlowCard = require('./PictFlowCard.js');

// FlowCardPropertiesPanel base class and panel types
module.exports.PictFlowCardPropertiesPanel = require('./PictFlowCardPropertiesPanel.js');
module.exports.FlowCardPropertiesPanelTemplate = require('./panels/FlowCardPropertiesPanel-Template.js');
module.exports.FlowCardPropertiesPanelMarkdown = require('./panels/FlowCardPropertiesPanel-Markdown.js');
module.exports.FlowCardPropertiesPanelForm = require('./panels/FlowCardPropertiesPanel-Form.js');
module.exports.FlowCardPropertiesPanelView = require('./panels/FlowCardPropertiesPanel-View.js');

// Properties panel renderer view
module.exports.PictViewFlowPropertiesPanel = require('./views/PictView-Flow-PropertiesPanel.js');

},{"./PictFlowCard.js":450,"./PictFlowCardPropertiesPanel.js":451,"./panels/FlowCardPropertiesPanel-Form.js":452,"./panels/FlowCardPropertiesPanel-Markdown.js":453,"./panels/FlowCardPropertiesPanel-Template.js":454,"./panels/FlowCardPropertiesPanel-View.js":455,"./providers/PictProvider-Flow-CSS.js":456,"./providers/PictProvider-Flow-ConnectorShapes.js":457,"./providers/PictProvider-Flow-EventHandler.js":458,"./providers/PictProvider-Flow-Geometry.js":459,"./providers/PictProvider-Flow-Icons.js":460,"./providers/PictProvider-Flow-Layouts.js":461,"./providers/PictProvider-Flow-NodeTypes.js":462,"./providers/PictProvider-Flow-PanelChrome.js":464,"./providers/PictProvider-Flow-SVGHelpers.js":466,"./providers/edges/Edge-Bezier.js":469,"./providers/edges/Edge-Orthogonal.js":470,"./providers/edges/Edge-OrthogonalSnap.js":471,"./providers/edges/Edge-Perimeter-Linear.js":472,"./providers/edges/Edge-Perimeter-Orthogonal.js":473,"./providers/edges/Edge-Perimeter.js":474,"./providers/edges/Edge-Straight.js":476,"./providers/layouts/Layout-Circular.js":477,"./providers/layouts/Layout-Columnar.js":479,"./providers/layouts/Layout-Custom.js":480,"./providers/layouts/Layout-ForcedFromCenter.js":481,"./providers/layouts/Layout-Grid.js":482,"./providers/layouts/Layout-Layered.js":483,"./providers/layouts/Layout-Tabular.js":486,"./services/PictService-Flow-ConnectionHandleManager.js":487,"./services/PictService-Flow-ConnectionRenderer.js":488,"./services/PictService-Flow-DataManager.js":489,"./services/PictService-Flow-InteractionManager.js":490,"./services/PictService-Flow-Layout.js":491,"./services/PictService-Flow-PanelManager.js":492,"./services/PictService-Flow-PathGenerator.js":493,"./services/PictService-Flow-PortRenderer.js":494,"./services/PictService-Flow-RenderManager.js":495,"./services/PictService-Flow-SelectionManager.js":496,"./services/PictService-Flow-Tether.js":497,"./services/PictService-Flow-ViewportManager.js":498,"./views/PictView-Flow-FloatingToolbar.js":499,"./views/PictView-Flow-Node.js":500,"./views/PictView-Flow-PropertiesPanel.js":501,"./views/PictView-Flow-Toolbar.js":502,"./views/PictView-Flow.js":503}],450:[function(require,module,exports){
arguments[4][209][0].apply(exports,arguments)
},{"dup":209,"fable-serviceproviderbase":59}],451:[function(require,module,exports){
arguments[4][210][0].apply(exports,arguments)
},{"dup":210,"fable-serviceproviderbase":59}],452:[function(require,module,exports){
arguments[4][211][0].apply(exports,arguments)
},{"../PictFlowCardPropertiesPanel.js":451,"dup":211}],453:[function(require,module,exports){
arguments[4][212][0].apply(exports,arguments)
},{"../PictFlowCardPropertiesPanel.js":451,"dup":212}],454:[function(require,module,exports){
arguments[4][213][0].apply(exports,arguments)
},{"../PictFlowCardPropertiesPanel.js":451,"dup":213}],455:[function(require,module,exports){
arguments[4][214][0].apply(exports,arguments)
},{"../PictFlowCardPropertiesPanel.js":451,"dup":214}],456:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-CSS
 *
 * Centralized CSS provider for the flow diagram.
 * All flow-related CSS is organized into domain-specific getter methods,
 * providing a single source of truth and enabling future theming.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowCSS'
};

class PictProviderFlowCSS extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowCSS';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ── Container ──────────────────────────────────────────────────────────
	/**
	 * CSS for the flow container, SVG container, panning/connecting cursors, and grid pattern.
	 * @returns {string}
	 */
	getContainerCSS()
	{
		return /*css*/`
		.pict-flow-container {
			/* ── Design Tokens ─────────────────────────────────────
			   Override these custom properties to theme the flow diagram.
			   Node-type classes (.pict-flow-node-{type}) can scope-override
			   any variable for per-type variation.

			   Defaults reference the host application's pict-provider-theme
			   tokens (--theme-color-*) when available, with hardcoded
			   fallbacks so the editor still looks reasonable in unthemed
			   contexts. Internal flow themes (sketch, blueprint, etc.) keep
			   layering on top via .pict-flow-container scoped overrides. */

			/* Text */
			--pf-text-primary: var(--theme-color-text-primary, #2c3e50);
			--pf-text-heading: var(--theme-color-text-primary, #1a252f);
			--pf-text-secondary: var(--theme-color-text-secondary, #7f8c8d);
			--pf-text-tertiary: var(--theme-color-text-muted, #8e99a4);
			--pf-text-placeholder: var(--theme-color-text-placeholder, #95a5a6);

			/* Node */
			--pf-node-body-fill: var(--theme-color-background-panel, #ffffff);
			--pf-node-body-stroke: var(--theme-color-border-default, #d0d4d8);
			--pf-node-body-stroke-hover: var(--theme-color-border-strong, #b0b8c0);
			--pf-node-body-stroke-width: 1;
			--pf-node-body-radius: 8px;
			--pf-node-shadow: drop-shadow(0 1px 3px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.10)));
			--pf-node-shadow-hover: drop-shadow(0 2px 6px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.15)));
			--pf-node-shadow-selected: drop-shadow(0 2px 8px rgba(52, 152, 219, 0.25));
			--pf-node-shadow-dragging: drop-shadow(0 4px 12px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.20)));
			--pf-node-title-fill: var(--theme-color-background-panel, #ffffff);
			--pf-node-title-size: 11.5px;
			--pf-node-title-weight: 600;
			--pf-node-title-bar-color: var(--theme-color-text-primary, #2c3e50);
			--pf-node-type-label-fill: var(--theme-color-text-muted, #a0a8b0);
			--pf-node-selected-stroke: var(--theme-color-brand-primary, #3498db);

			/* Node Variants */
			--pf-node-start-fill: var(--theme-color-background-hover, #eafaf1);
			--pf-node-start-stroke: var(--theme-color-status-success, #27ae60);
			--pf-node-end-fill: var(--theme-color-background-hover, #e8f8f5);
			--pf-node-end-stroke: var(--theme-color-brand-primary, #1abc9c);
			--pf-node-halt-fill: var(--theme-color-background-hover, #fdedec);
			--pf-node-halt-stroke: var(--theme-color-status-error, #e74c3c);
			--pf-node-decision-fill: var(--theme-color-background-hover, #fff9e6);
			--pf-node-decision-stroke: var(--theme-color-status-warning, #f39c12);

			/* ── Color roles ───────────────────────────────────────
			   Generic, theme-aware semantic colors that node types and
			   individual cards opt into via a ColorRole field. The
			   "-soft" variant is the tinted background; the bare role is
			   the title-bar / outline / accent stroke.

			   Hosts can override any of these tokens at .pict-flow-container
			   scope (or at their own scope) without touching JS. Built-in
			   node types resolve their visuals through these tokens, so
			   theming a role automatically retints every card that uses it.

			   Soft tints use color-mix() — supported in Chrome 111+,
			   Safari 16.2+, Firefox 113+. The hardcoded fallbacks keep the
			   editor presentable on older engines. */
			--pf-color-success: var(--theme-color-status-success, #27ae60);
			--pf-color-success-soft: color-mix(in srgb, var(--pf-color-success) 12%, transparent);
			--pf-color-warning: var(--theme-color-status-warning, #f39c12);
			--pf-color-warning-soft: color-mix(in srgb, var(--pf-color-warning) 14%, transparent);
			--pf-color-error: var(--theme-color-status-error, #e74c3c);
			--pf-color-error-soft: color-mix(in srgb, var(--pf-color-error) 12%, transparent);
			--pf-color-info: var(--theme-color-status-info, #3498db);
			--pf-color-info-soft: color-mix(in srgb, var(--pf-color-info) 12%, transparent);
			--pf-color-accent: var(--theme-color-brand-accent, #1abc9c);
			--pf-color-accent-soft: color-mix(in srgb, var(--pf-color-accent) 14%, transparent);
			--pf-color-neutral: var(--theme-color-text-primary, #2c3e50);
			--pf-color-neutral-soft: var(--theme-color-background-panel, #ffffff);
			--pf-color-neutral-onfill: var(--theme-color-background-panel, #ffffff);

			/* Ports */
			--pf-port-input-fill: var(--theme-color-status-info, #3498db);
			--pf-port-output-fill: var(--theme-color-status-success, #2ecc71);
			--pf-port-stroke: var(--theme-color-background-panel, #ffffff);
			--pf-port-stroke-width: 2;
			--pf-port-label-bg: rgba(255, 253, 240, 0.5);
			--pf-port-label-text: var(--theme-color-text-primary, #2c3e50);

			/* Port Type Colors */
			--pf-port-event-in-fill: var(--theme-color-status-info, #3498db);
			--pf-port-event-out-fill: var(--theme-color-status-success, #2ecc71);
			--pf-port-setting-fill: var(--theme-color-status-warning, #e67e22);
			--pf-port-value-fill: var(--theme-color-status-warning, #f1c40f);
			--pf-port-error-fill: var(--theme-color-status-error, #e74c3c);

			/* Connection Type Colors (match source port) */
			--pf-connection-event-in-stroke: var(--theme-color-status-info, #3498db);
			--pf-connection-event-out-stroke: var(--theme-color-status-success, #2ecc71);
			--pf-connection-setting-stroke: var(--theme-color-status-warning, #e67e22);
			--pf-connection-value-stroke: var(--theme-color-status-warning, #f1c40f);
			--pf-connection-error-stroke: var(--theme-color-status-error, #e74c3c);

			/* Connections */
			--pf-connection-stroke: var(--theme-color-border-strong, #95a5a6);
			--pf-connection-stroke-hover: var(--theme-color-text-secondary, #7f8c8d);
			--pf-connection-selected-stroke: var(--theme-color-brand-primary, #3498db);

			/* Panels */
			--pf-panel-bg: var(--theme-color-background-panel, #ffffff);
			--pf-panel-border: var(--theme-color-border-default, #d0d4d8);
			--pf-panel-radius: 8px;
			--pf-panel-shadow: 0 4px 12px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.10)), 0 1px 3px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.06));
			--pf-panel-titlebar-bg: var(--theme-color-background-secondary, #f7f8fa);
			--pf-panel-titlebar-border: var(--theme-color-border-light, #e8eaed);
			--pf-panel-title-color: var(--theme-color-text-primary, #2c3e50);

			/* Tabs */
			--pf-tab-text: var(--theme-color-text-muted, #8e99a4);
			--pf-tab-text-hover: var(--theme-color-text-secondary, #5a6a7a);
			--pf-tab-active-border: var(--pf-node-selected-stroke);
			--pf-resize-handle-hover: var(--theme-color-border-light, #e0e3e6);

			/* Forms & Inputs */
			--pf-input-border: var(--theme-color-border-default, #d5d8dc);
			--pf-input-border-focus: var(--theme-color-focus-outline, #3498db);
			--pf-divider-light: var(--theme-color-border-light, #ecf0f1);
			--pf-divider-medium: var(--theme-color-border-light, #e8eaed);

			/* Buttons */
			--pf-button-border: var(--theme-color-border-default, #bdc3c7);
			--pf-button-hover-border: var(--theme-color-border-strong, #95a5a6);
			--pf-button-hover-bg: var(--theme-color-background-hover, #ecf0f1);
			--pf-button-active-bg: var(--theme-color-background-selected, #d5dbdb);
			--pf-button-danger-text: var(--theme-color-status-error, #e74c3c);
			--pf-button-danger-hover-bg: var(--theme-color-background-hover, #fdedec);
			--pf-button-close-color: var(--theme-color-text-muted, #b0b8c0);

			/* Badges */
			--pf-badge-category-bg: var(--theme-color-background-tertiary, #f0f2f4);
			--pf-badge-category-text: var(--theme-color-text-secondary, #6b7b8d);
			--pf-badge-code-bg: var(--theme-color-background-hover, #eaf2f8);
			--pf-badge-code-text: var(--theme-color-status-info, #2980b9);

			/* Info Panel */
			--pf-port-item-bg: var(--theme-color-background-secondary, #f8f9fa);

			/* Toolbar */
			--pf-toolbar-bg: var(--theme-color-background-panel, #ffffff);
			--pf-toolbar-border: var(--theme-color-border-default, #e0e0e0);

			/* Palette Cards */
			--pf-card-border: var(--theme-color-border-default, #d5d8dc);
			--pf-card-hover-bg: var(--theme-color-background-hover, #eaf2f8);
			--pf-card-hover-shadow: 0 1px 3px rgba(52, 152, 219, 0.15);

			/* Canvas */
			--pf-canvas-bg: var(--theme-color-background-secondary, #fafafa);
			--pf-grid-stroke: var(--theme-color-border-light, #e8e8e8);

			position: relative;
			width: 100%;
			height: 100%;
			min-height: 400px;
			overflow: hidden;
			background-color: var(--pf-canvas-bg);
			border: 1px solid var(--pf-toolbar-border);
			border-radius: 4px;
			display: flex;
			flex-direction: column;
		}
		.pict-flow-svg-container {
			flex: 1;
			min-height: 0;
			position: relative;
		}
		.pict-flow-svg {
			width: 100%;
			height: 100%;
			cursor: grab;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-svg.panning {
			cursor: grabbing;
		}
		.pict-flow-svg.connecting {
			cursor: crosshair;
		}
		.pict-flow-grid-pattern line {
			stroke: var(--pf-grid-stroke);
			stroke-width: 0.5;
		}
		`;
	}

	// ── Nodes ──────────────────────────────────────────────────────────────
	/**
	 * CSS for base node styling: body, hover/selected/dragging states, title bar, title text, type label.
	 * @returns {string}
	 */
	getNodeCSS()
	{
		return /*css*/`
		.pict-flow-node {
			cursor: pointer;
			filter: var(--pf-node-shadow);
			transition: filter 0.2s;
		}
		.pict-flow-node:hover {
			filter: var(--pf-node-shadow-hover);
		}
		.pict-flow-node:hover .pict-flow-node-body {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}
		.pict-flow-node.selected {
			filter: var(--pf-node-shadow-selected);
		}
		.pict-flow-node.selected .pict-flow-node-body {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node.dragging {
			opacity: 0.9;
			cursor: grabbing;
			filter: var(--pf-node-shadow-dragging);
		}
		.pict-flow-node-body {
			fill: var(--pf-node-body-fill);
			stroke: var(--pf-node-body-stroke);
			stroke-width: var(--pf-node-body-stroke-width);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
			transition: stroke 0.2s, stroke-width 0.2s;
		}
		.pict-flow-node-title-bar {
			fill: var(--pf-node-title-bar-color);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
		}
		.pict-flow-node-title-bar-bottom {
			fill: var(--pf-node-title-bar-color);
		}
		.pict-flow-node-resize-handle {
			fill: var(--theme-color-brand-primary, #2880a6);
			stroke: var(--theme-color-background-panel, #ffffff);
			stroke-width: 1.5;
			cursor: nwse-resize;
			opacity: 0.85;
		}
		.pict-flow-node-resize-handle:hover { opacity: 1; }
		.pict-flow-marquee {
			fill: var(--theme-color-brand-primary, #2880a6);
			fill-opacity: 0.10;
			stroke: var(--theme-color-brand-primary, #2880a6);
			stroke-width: 1;
			stroke-dasharray: 4 3;
			pointer-events: none;
		}
		.pict-flow-align-guide {
			stroke: #e5397f;
			stroke-width: 1;
			stroke-dasharray: 3 2;
			pointer-events: none;
			shape-rendering: crispEdges;
		}
		.pict-flow-node-title {
			fill: var(--pf-node-title-fill);
			font-size: var(--pf-node-title-size);
			font-weight: var(--pf-node-title-weight);
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			letter-spacing: 0.2px;
			pointer-events: none;
		}
		.pict-flow-node-type-label {
			fill: var(--pf-node-type-label-fill);
			font-size: 9.5px;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			text-transform: uppercase;
			letter-spacing: 0.3px;
			pointer-events: none;
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-type-label {
			opacity: 1;
		}
		.pict-flow-node-card-code {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-card-code {
			opacity: 1;
		}
		/* Title-bar icon: invert SVG paths to white for dark title bars */
		.pict-flow-node-title-icon {
			filter: brightness(0) invert(1);
		}
		`;
	}

	// ── Body Content ──────────────────────────────────────────────────────
	/**
	 * CSS for custom body content in nodes: SVG group, foreignObject, HTML container, canvas.
	 * @returns {string}
	 */
	getBodyContentCSS()
	{
		return /*css*/`
		.pict-flow-node-body-content {
			pointer-events: none;
		}
		.pict-flow-node-body-content-fo {
			overflow: hidden;
		}
		.pict-flow-node-body-content-html {
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 11px;
			color: var(--pf-text-primary);
			pointer-events: auto;
		}
		.pict-flow-node-body-content-canvas {
			display: block;
			pointer-events: auto;
		}
		`;
	}

	// ── Node Variants ──────────────────────────────────────────────────────
	/**
	 * CSS overrides for specific node types: start, end, halt, decision.
	 * @returns {string}
	 */
	getNodeVariantCSS()
	{
		return /*css*/`
		.pict-flow-node-decision .pict-flow-node-body {
			fill: var(--pf-node-decision-fill);
			stroke: var(--pf-node-decision-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-start .pict-flow-node-body {
			fill: var(--pf-node-start-fill);
			stroke: var(--pf-node-start-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-end .pict-flow-node-body {
			fill: var(--pf-node-end-fill);
			stroke: var(--pf-node-end-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-halt .pict-flow-node-body {
			fill: var(--pf-node-halt-fill);
			stroke: var(--pf-node-halt-stroke);
			stroke-width: 1.5;
		}

		/* ── Color-role variants ────────────────────────────────
		   Cards opt into a role via ColorRole on the node-type config or
		   a per-node override. The renderer adds .pict-flow-node-color-{role}
		   to the node group, which pulls fill/stroke/title-bar colors from
		   the --pf-color-* tokens — those in turn track the host's
		   --theme-color-* tokens so light/dark/palette swaps propagate.

		   Roles deliberately don't override .pict-flow-node-body-content-*
		   styling — the body content's visual identity is the consumer's
		   responsibility. */
		.pict-flow-node-color-success .pict-flow-node-body {
			fill: var(--pf-color-success-soft);
			stroke: var(--pf-color-success);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-success .pict-flow-node-title-bar,
		.pict-flow-node-color-success .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-success);
		}
		.pict-flow-node-color-success .pict-flow-node-bracket {
			stroke: var(--pf-color-success);
		}

		.pict-flow-node-color-warning .pict-flow-node-body {
			fill: var(--pf-color-warning-soft);
			stroke: var(--pf-color-warning);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-warning .pict-flow-node-title-bar,
		.pict-flow-node-color-warning .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-warning);
		}
		.pict-flow-node-color-warning .pict-flow-node-bracket {
			stroke: var(--pf-color-warning);
		}

		.pict-flow-node-color-error .pict-flow-node-body {
			fill: var(--pf-color-error-soft);
			stroke: var(--pf-color-error);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-error .pict-flow-node-title-bar,
		.pict-flow-node-color-error .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-error);
		}
		.pict-flow-node-color-error .pict-flow-node-bracket {
			stroke: var(--pf-color-error);
		}

		.pict-flow-node-color-info .pict-flow-node-body {
			fill: var(--pf-color-info-soft);
			stroke: var(--pf-color-info);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-info .pict-flow-node-title-bar,
		.pict-flow-node-color-info .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-info);
		}
		.pict-flow-node-color-info .pict-flow-node-bracket {
			stroke: var(--pf-color-info);
		}

		.pict-flow-node-color-accent .pict-flow-node-body {
			fill: var(--pf-color-accent-soft);
			stroke: var(--pf-color-accent);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-accent .pict-flow-node-title-bar,
		.pict-flow-node-color-accent .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-accent);
		}
		.pict-flow-node-color-accent .pict-flow-node-bracket {
			stroke: var(--pf-color-accent);
		}

		.pict-flow-node-color-neutral .pict-flow-node-body {
			fill: var(--pf-color-neutral-soft);
			stroke: var(--pf-color-neutral);
			stroke-width: 1;
		}
		.pict-flow-node-color-neutral .pict-flow-node-title-bar,
		.pict-flow-node-color-neutral .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-neutral);
		}
		.pict-flow-node-color-neutral .pict-flow-node-bracket {
			stroke: var(--pf-color-neutral);
		}
		`;
	}

	// ── Ports ──────────────────────────────────────────────────────────────
	/**
	 * CSS for port circles: input/output coloring, hover states, labels.
	 * @returns {string}
	 */
	getPortCSS()
	{
		return /*css*/`
		.pict-flow-port {
			cursor: crosshair;
			transition: r 0.15s, filter 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.12));
		}
		.pict-flow-port.input {
			fill: var(--pf-port-input-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port.output {
			fill: var(--pf-port-output-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port:hover {
			r: 7;
			filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.20));
		}
		/* Port type color overrides */
		.pict-flow-port.port-type-event-in {
			fill: var(--pf-port-event-in-fill);
		}
		.pict-flow-port.port-type-event-out {
			fill: var(--pf-port-event-out-fill);
		}
		.pict-flow-port.port-type-setting {
			fill: var(--pf-port-setting-fill);
		}
		.pict-flow-port.port-type-value {
			fill: var(--pf-port-value-fill);
		}
		.pict-flow-port.port-type-error {
			fill: var(--pf-port-error-fill);
		}
		.pict-flow-port-label {
			font-size: 8px;
			font-weight: 600;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			pointer-events: none;
		}
		/* Port label badge background */
		.pict-flow-port-label-bg {
			pointer-events: none;
		}
		/* Port labels on hover: hidden by default, revealed on node hover */
		.pict-flow-node-port-labels-hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover .pict-flow-port-label-bg {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label-bg {
			opacity: 1;
		}

		/* Port-hint beziers — drawn from the badge to the actual dot
		   when an edge theme has rerouted the connection. Hidden by
		   default; PortRenderer / NodeView toggle data-active on hover. */
		.pict-flow-port-hint {
			fill: none;
			stroke: var(--pf-connection-stroke-hover, #3498db);
			stroke-width: 1.75;
			stroke-dasharray: 4 3;
			stroke-linecap: round;
			opacity: 0;
			pointer-events: none;
			transition: opacity 0.18s ease;
		}
		.pict-flow-port-hint[data-active="true"] {
			opacity: 0.7;
		}

		/* ── Layout-algorithm popup: tightened layout + form styling ── */
		.pict-flow-popup-layout-algorithm-row {
			display: flex;
			flex-direction: column;
			gap: 4px;
			padding: 6px 10px 4px;
		}
		.pict-flow-popup-layout-algorithm-row > .pict-flow-popup-settings-label {
			font-size: 10px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			opacity: 0.7;
			margin: 0;
		}
		.pict-flow-popup-layout-algorithm-controls {
			display: flex;
			align-items: stretch;
			gap: 4px;
		}
		.pict-flow-popup-layout-algorithm-select {
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-flow-popup-collapse-toggle {
			flex: 0 0 auto;
			width: 28px;
			padding: 0;
			border: 1px solid var(--pf-button-border, #ccc);
			border-radius: 3px;
			background: var(--pf-toolbar-bg, #fff);
			color: var(--pf-text-secondary, #5a6470);
			cursor: pointer;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s, color 0.15s, border-color 0.15s;
		}
		.pict-flow-popup-collapse-toggle:hover {
			background-color: var(--pf-button-hover-bg, #eef);
			color: var(--pf-text-primary, #2c3e50);
		}
		/* "Open" state: pressed-in look so the user sees that the form
		   below is being driven by this gear. */
		.pict-flow-popup-collapse-toggle[aria-expanded="true"] {
			background-color: var(--pf-button-active-bg, #d6e4f0);
			color: var(--pf-text-primary, #2c3e50);
			border-color: var(--pf-button-hover-border, #3498db);
		}
		.pict-flow-popup-collapse-toggle svg {
			display: block;
		}
		/* Subordinate description text — sits under a control (algorithm
		   dropdown, edge-theme dropdown, etc.) and explains it. Indented
		   from the section's left edge with a faint left rule so the
		   visual hierarchy is unambiguous: SECTION LABEL > control >
		   description. */
		.pict-flow-popup-control-description {
			font-size: 11px;
			line-height: 1.4;
			color: var(--pf-text-secondary, #5a6470);
			padding: 4px 12px 8px 28px;
			margin-left: 14px;
			border-left: 2px solid var(--pf-divider-light, #e6e6e6);
		}

		/* The form host. Acts as the collapsible container around the
		   pict-section-form metacontroller's emitted markup. */
		.pict-flow-popup-layout-form-host {
			margin: 0 10px 8px;
			padding: 8px 10px;
			background: var(--pf-toolbar-bg, #fafafa);
			border: 1px solid var(--pf-button-border, #e0e0e0);
			border-radius: 6px;
			overflow: hidden;
			max-height: 600px;
			transition: max-height 0.22s ease, padding 0.22s ease,
			            margin 0.22s ease, border-color 0.22s ease, opacity 0.18s ease;
			opacity: 1;
		}
		.pict-flow-popup-layout-form-host[data-collapsed="true"] {
			max-height: 0;
			padding-top: 0;
			padding-bottom: 0;
			margin-top: 0;
			margin-bottom: 0;
			border-color: transparent;
			opacity: 0;
		}
		.pict-flow-popup-layout-form-host > div { width: 100%; }

		/* Form contents — make the auto-rendered sections look professional.
		   The section headings stay visible; the redundant per-section
		   "Group: Defaults" h3 is suppressed. */
		.pict-flow-popup-layout-form .pict-form-view {
			display: block;
		}
		.pict-flow-popup-layout-form .pict-form-section {
			margin: 0;
			padding: 0;
		}
		.pict-flow-popup-layout-form .pict-form-section h2 {
			font-size: 10px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			opacity: 0.6;
			margin: 8px 0 4px;
			padding: 0;
			border-bottom: 1px solid var(--pf-button-border, #e6e6e6);
			padding-bottom: 3px;
		}
		.pict-flow-popup-layout-form .pict-form-section:first-child h2,
		.pict-flow-popup-layout-form .pict-form-section h2:first-child {
			margin-top: 0;
		}
		/* Group headings ("Group: Defaults") are noise — every algorithm
		   has exactly one group right now. Hide them. */
		.pict-flow-popup-layout-form .pict-form-section h3 {
			display: none;
		}
		/* Each row of inputs lives in a flat <div> as alternating
		   <span>label</span><input> pairs. Lay them out in a balanced grid. */
		.pict-flow-popup-layout-form .pict-form-section > div > div {
			display: flex;
			flex-wrap: wrap;
			gap: 4px 14px;
			margin: 4px 0;
			align-items: center;
		}
		.pict-flow-popup-layout-form .pict-form-section span {
			font-size: 12px;
			color: var(--pf-text-primary, #2c3e50);
			line-height: 1.4;
			margin: 0;
		}
		.pict-flow-popup-layout-form input[type="number"],
		.pict-flow-popup-layout-form input[type="text"],
		.pict-flow-popup-layout-form select {
			width: 88px;
			padding: 2px 6px;
			border: 1px solid var(--pf-button-border, #ccc);
			border-radius: 3px;
			font-size: 12px;
			line-height: 1.3;
			background: #fff;
			color: var(--pf-text-primary, #2c3e50);
			margin-left: -8px; /* tighten gap between label and its input */
		}
		.pict-flow-popup-layout-form select {
			width: auto;
			min-width: 110px;
		}
		.pict-flow-popup-layout-form input[type="number"]:focus,
		.pict-flow-popup-layout-form input[type="text"]:focus,
		.pict-flow-popup-layout-form select:focus {
			outline: none;
			border-color: var(--pf-button-hover-border, #3498db);
			box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.15);
		}
		.pict-flow-popup-layout-form input[type="checkbox"] {
			margin: 0 4px 0 0;
		}
		`;
	}

	// ── Connections ────────────────────────────────────────────────────────
	/**
	 * CSS for connection paths: base, hover/selected states, hitarea, drag-connection.
	 * @returns {string}
	 */
	getConnectionCSS()
	{
		return /*css*/`
		/* Arrowhead markers use CSS-driven fills so they follow --pf-* tokens
		   (which in turn map to host --theme-color-* tokens). The polygon's
		   fill attribute is the fallback when CSS does not reach the marker. */
		.pict-flow-svg .pict-flow-arrowhead-default {
			fill: var(--pf-connection-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-selected {
			fill: var(--pf-connection-selected-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-tether {
			fill: var(--pf-connection-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-event-in {
			fill: var(--pf-connection-event-in-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-event-out {
			fill: var(--pf-connection-event-out-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-setting {
			fill: var(--pf-connection-setting-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-value {
			fill: var(--pf-connection-value-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-error {
			fill: var(--pf-connection-error-stroke);
		}

		.pict-flow-connection {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 2;
			cursor: pointer;
			transition: stroke 0.15s;
		}
		/* A connection's label (Data.Label), drawn at the midpoint. The white halo (paint-order) keeps it
		   legible where it crosses the line. */
		.pict-flow-connection-label {
			font-size: 12px;
			font-family: inherit;
			fill: var(--pf-text-primary, #2c3e50);
			paint-order: stroke;
			stroke: var(--theme-color-background-primary, #ffffff);
			stroke-width: 3px;
			stroke-linejoin: round;
			pointer-events: none;
			user-select: none;
		}
		.pict-flow-connection:hover {
			stroke: var(--pf-connection-stroke-hover);
			stroke-width: 3;
		}
		.pict-flow-connection.selected {
			stroke: var(--pf-connection-selected-stroke);
			stroke-width: 3;
		}
		/* Connection type color overrides (based on source port type) */
		.pict-flow-connection.conn-type-event-in {
			stroke: var(--pf-connection-event-in-stroke);
		}
		.pict-flow-connection.conn-type-event-out {
			stroke: var(--pf-connection-event-out-stroke);
		}
		.pict-flow-connection.conn-type-setting {
			stroke: var(--pf-connection-setting-stroke);
		}
		.pict-flow-connection.conn-type-value {
			stroke: var(--pf-connection-value-stroke);
		}
		.pict-flow-connection.conn-type-error {
			stroke: var(--pf-connection-error-stroke);
		}
		.pict-flow-connection-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 12;
			cursor: pointer;
		}
		.pict-flow-drag-connection {
			fill: none;
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			stroke-dasharray: 6 3;
			pointer-events: none;
		}
		`;
	}

	// ── Connection Handles ─────────────────────────────────────────────────
	/**
	 * CSS for connection waypoint handles and midpoint handles.
	 * @returns {string}
	 */
	getHandleCSS()
	{
		return /*css*/`
		.pict-flow-connection-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-connection-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Tethers ────────────────────────────────────────────────────────────
	/**
	 * CSS for tether lines, hitareas, handles, and midpoint handles.
	 * @returns {string}
	 */
	getTetherCSS()
	{
		return /*css*/`
		.pict-flow-tether-line {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 1.5;
			stroke-dasharray: 6 4;
			pointer-events: visibleStroke;
			cursor: pointer;
		}
		.pict-flow-tether-line.selected {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-tether-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 10;
			cursor: pointer;
		}
		.pict-flow-tether-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-tether-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Panels ─────────────────────────────────────────────────────────────
	/**
	 * CSS for property panels: foreign object, panel container, titlebar, close button, body, indicator.
	 * @returns {string}
	 */
	getPanelCSS()
	{
		return /*css*/`
		.pict-flow-node-panel-indicator {
			fill: var(--pf-node-selected-stroke);
			stroke: none;
			opacity: 0.6;
			cursor: pointer;
			transition: opacity 0.15s;
		}
		.pict-flow-node-panel-indicator:hover {
			opacity: 1.0;
		}
		.pict-flow-panel-foreign-object {
			overflow: visible;
		}
		.pict-flow-panel {
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-panel-border);
			border-radius: var(--pf-panel-radius);
			box-shadow: var(--pf-panel-shadow);
			display: flex;
			flex-direction: column;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
		}
		.pict-flow-panel-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 8px 12px;
			background: var(--pf-panel-titlebar-bg);
			border-bottom: 1px solid var(--pf-panel-titlebar-border);
			cursor: grab;
			user-select: none;
			-webkit-user-select: none;
			flex-shrink: 0;
		}
		.pict-flow-panel-titlebar.dragging {
			cursor: grabbing;
		}
		.pict-flow-panel-title-text {
			font-weight: 600;
			font-size: 12px;
			color: var(--pf-panel-title-color);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			letter-spacing: 0.1px;
		}
		.pict-flow-panel-close-btn {
			cursor: pointer;
			color: var(--pf-button-close-color);
			font-size: 14px;
			line-height: 1;
			padding: 4px;
			border: none;
			background: none;
			border-radius: 4px;
			transition: background-color 0.15s, color 0.15s;
		}
		.pict-flow-panel-close-btn:hover {
			color: var(--pf-button-danger-text);
			background-color: rgba(231, 76, 60, 0.08);
		}
		.pict-flow-panel-content {
			flex: 1;
			overflow-y: auto;
			min-height: 0;
			padding: 0;
		}
		.pict-flow-panel-tab-pane {
			padding: 10px 12px;
			box-sizing: border-box;
		}
		`;
	}

	// ── Info Panels ────────────────────────────────────────────────────────
	/**
	 * CSS for the info/hover panel and all sub-elements: header, description, badges, sections, ports.
	 * @returns {string}
	 */
	getInfoPanelCSS()
	{
		return /*css*/`
		.pict-flow-info-panel {
			padding: 2px 0;
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-info-panel-header {
			font-size: 13px;
			font-weight: 600;
			margin-bottom: 6px;
			color: var(--pf-text-heading);
		}
		.pict-flow-info-panel-header.with-icon {
			font-size: 14px;
			display: flex;
			align-items: center;
			gap: 6px;
		}
		.pict-flow-info-panel-description {
			font-size: 11px;
			color: var(--pf-text-secondary);
			margin-bottom: 10px;
			line-height: 1.45;
		}
		.pict-flow-info-panel-badges {
			margin-bottom: 10px;
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
		}
		.pict-flow-info-panel-badge {
			display: inline-block;
			padding: 2px 8px;
			border-radius: 4px;
			font-size: 10px;
		}
		.pict-flow-info-panel-badge.category {
			background: var(--pf-badge-category-bg);
			color: var(--pf-badge-category-text);
		}
		.pict-flow-info-panel-badge.code {
			background: var(--pf-badge-code-bg);
			color: var(--pf-badge-code-text);
			font-family: "SF Mono", "Fira Code", monospace;
		}
		.pict-flow-info-panel-section {
			margin-bottom: 8px;
		}
		.pict-flow-info-panel-section-title {
			font-size: 10px;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--pf-text-tertiary);
			margin-bottom: 4px;
			padding-bottom: 2px;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-info-panel-port {
			padding: 3px 8px;
			background: var(--pf-port-item-bg);
			margin-bottom: 3px;
			font-size: 11px;
			border-radius: 3px;
		}
		.pict-flow-info-panel-port.input {
			border-left: 3px solid var(--pf-port-input-fill);
		}
		.pict-flow-info-panel-port.output {
			border-left: 3px solid var(--pf-port-output-fill);
		}
		/* Info panel port type color overrides */
		.pict-flow-info-panel-port.port-type-event-in {
			border-left-color: var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.port-type-event-out {
			border-left-color: var(--pf-port-event-out-fill);
		}
		.pict-flow-info-panel-port.port-type-setting {
			border-left-color: var(--pf-port-setting-fill);
		}
		.pict-flow-info-panel-port.port-type-value {
			border-left-color: var(--pf-port-value-fill);
		}
		.pict-flow-info-panel-port.port-type-error {
			border-left-color: var(--pf-port-error-fill);
		}
		.pict-flow-info-panel-port-constraint {
			color: var(--pf-text-tertiary);
			font-size: 10px;
		}
		/* Port summary section appended below form panels */
		.pict-flow-port-summary {
			margin-top: 12px;
			padding-top: 8px;
			border-top: 1px solid var(--pf-divider-medium);
		}
		.pict-flow-info-panel-port.event {
			border-left: 3px solid var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.value {
			border-left: 3px solid var(--pf-port-value-fill);
		}
		`;
	}

	// ── Node Properties Editor ────────────────────────────────────────────
	/**
	 * CSS for the node properties editor fields used in the Appearance tab.
	 * @returns {string}
	 */
	getNodePropsEditorCSS()
	{
		return /*css*/`
		.pict-flow-node-props-fields {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
		.pict-flow-node-props-field {
			display: flex;
			align-items: center;
			gap: 8px;
		}
		.pict-flow-node-props-label {
			font-size: 11px;
			color: var(--pf-text-secondary);
			min-width: 72px;
			flex-shrink: 0;
		}
		.pict-flow-node-props-input {
			flex: 1;
			padding: 3px 6px;
			border: 1px solid var(--pf-input-border);
			border-radius: 3px;
			font-size: 11px;
			outline: none;
			box-sizing: border-box;
			min-width: 0;
		}
		.pict-flow-node-props-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-node-props-color {
			width: 28px;
			height: 24px;
			padding: 1px;
			cursor: pointer;
			flex: 0 0 28px;
		}

		/* Suppress native number-input spinner buttons on every input
		   inside a properties panel. Panels live inside <foreignObject>;
		   browsers (Chromium / WebKit) render the up/down spinner chrome
		   as native overlays that don't always respect SVG transforms or
		   the parent tab pane's display:none — leaving stale spinner
		   artifacts hanging around when the user switches tabs or pans
		   the diagram. The user can still type numbers; they just don't
		   get clickable spinners. (If we ever want spinners back, build
		   them as real DOM elements next to the input, not native chrome.) */
		.pict-flow-panel input[type="number"] {
			-moz-appearance: textfield;
			appearance: textfield;
		}
		.pict-flow-panel input[type="number"]::-webkit-outer-spin-button,
		.pict-flow-panel input[type="number"]::-webkit-inner-spin-button {
			-webkit-appearance: none;
			appearance: none;
			margin: 0;
		}
		`;
	}

	// ── Panel Tabs & Resize ───────────────────────────────────────────────
	/**
	 * CSS for the tab bar, tab panes, resize handle, and help content.
	 * @returns {string}
	 */
	getPanelTabsCSS()
	{
		return /*css*/`
		.pict-flow-panel-resize-handle {
			height: 6px;
			cursor: ns-resize;
			background: transparent;
			flex-shrink: 0;
			transition: background-color 0.15s;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-panel-resize-handle::after {
			content: '';
			width: 24px;
			height: 2px;
			border-radius: 1px;
			background: var(--pf-resize-handle-hover);
			transition: background-color 0.15s, width 0.15s;
		}
		.pict-flow-panel-resize-handle:hover::after {
			background: var(--pf-button-hover-border);
			width: 32px;
		}
		.pict-flow-panel-tabbar {
			display: flex;
			flex-shrink: 0;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			background: var(--pf-panel-titlebar-bg);
		}
		.pict-flow-panel-tab {
			flex: 1;
			padding: 5px 8px;
			font-size: 11px;
			text-align: center;
			cursor: pointer;
			color: var(--pf-tab-text);
			border-top: 2px solid transparent;
			transition: color 0.15s, border-top-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-panel-tab:hover {
			color: var(--pf-tab-text-hover);
		}
		.pict-flow-panel-tab.active {
			border-top-color: var(--pf-node-selected-stroke);
			color: var(--pf-panel-title-color);
			font-weight: 600;
		}
		.pict-flow-panel-help-content {
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-panel-help-content p {
			margin: 0 0 8px 0;
		}
		`;
	}

	// ── Fullscreen ─────────────────────────────────────────────────────────
	/**
	 * CSS for fullscreen mode.
	 * @returns {string}
	 */
	getFullscreenCSS()
	{
		return /*css*/`
		.pict-flow-fullscreen {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			z-index: 9999;
			border-radius: 0;
			border: none;
			min-height: 100vh;
		}
		.pict-flow-fullscreen .pict-flow-svg {
			min-height: calc(100vh - 50px);
		}
		`;
	}

	// ── Toolbar ────────────────────────────────────────────────────────────
	/**
	 * CSS for the toolbar: buttons, groups, labels, selects.
	 * @returns {string}
	 */
	getToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.5em 0.75em;
			background-color: var(--pf-toolbar-bg);
			border-bottom: 1px solid var(--pf-toolbar-border);
			flex-wrap: wrap;
		}
		.pict-flow-toolbar-group {
			display: flex;
			align-items: center;
			gap: 0.25em;
			padding-right: 0.75em;
			border-right: 1px solid var(--pf-toolbar-border);
		}
		.pict-flow-toolbar-group:last-child {
			border-right: none;
			padding-right: 0;
		}
		/* The host-supplied extra-button group (ToolbarExtraButtons) renders even
		   when empty; collapse it so consumers that pass no buttons see no gap. */
		.pict-flow-toolbar-group:empty {
			display: none;
		}
		.pict-flow-toolbar-btn-active {
			background-color: var(--pf-button-active-bg);
			border-color: var(--pf-button-hover-border);
		}
		/* An icon-only host button (ToolbarExtraButtons with no Label) renders an empty text span. */
		.pict-flow-toolbar-btn-text:empty {
			display: none;
		}
		.pict-flow-toolbar-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			gap: 0.35em;
			padding: 0.35em 0.65em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
			font-size: 0.85em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-toolbar-btn:focus {
			outline: none;
		}
		.pict-flow-toolbar-btn:hover {
			background-color: var(--pf-button-hover-bg);
			border-color: var(--pf-button-hover-border);
		}
		.pict-flow-toolbar-btn:active {
			background-color: var(--pf-button-active-bg);
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
		}
		.pict-flow-toolbar-btn-text {
			white-space: nowrap;
		}
		.pict-flow-toolbar-btn-chevron {
			display: inline-flex;
			align-items: center;
			margin-left: 0.15em;
		}
		/* Split button — visible as one connected unit; the two halves
		   route to different actions. Used for "Auto" so clicking the
		   icon/text applies the current layout while the chevron half
		   opens the algorithm popup with a generous hit area. */
		.pict-flow-toolbar-btn-split {
			display: inline-flex;
			align-items: stretch;
		}
		.pict-flow-toolbar-btn-split-main {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-right: 1px solid var(--pf-button-border);
			margin-right: -1px; /* collapse the seam between the two buttons */
		}
		.pict-flow-toolbar-btn-split-chevron {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			padding-left: 0.55em;
			padding-right: 0.55em;
		}
		.pict-flow-toolbar-btn-split-chevron .pict-flow-toolbar-btn-chevron {
			margin: 0;
		}
		.pict-flow-toolbar-right {
			margin-left: auto;
			border-right: none;
			padding-right: 0;
		}
		.pict-flow-toolbar-label {
			font-size: 0.8em;
			color: var(--pf-text-secondary);
			margin-right: 0.25em;
		}
		.pict-flow-toolbar-select {
			padding: 0.3em 0.5em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			font-size: 0.85em;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
		}
		`;
	}

	// ── Card Palette ───────────────────────────────────────────────────────
	/**
	 * CSS for the card palette: toggle, body, categories, cards, swatches.
	 * @returns {string}
	 */
	getPaletteCSS()
	{
		return /*css*/`
		.pict-flow-palette-category {
			margin-bottom: 0.5em;
		}
		.pict-flow-palette-category:last-child {
			margin-bottom: 0;
		}
		.pict-flow-palette-category-label {
			font-size: 0.7em;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--pf-text-placeholder);
			margin-bottom: 0.35em;
			padding-bottom: 0.2em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-palette-cards {
			display: flex;
			flex-wrap: wrap;
			gap: 0.35em;
		}
		.pict-flow-palette-card {
			display: inline-flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.6em;
			border: 1px solid var(--pf-card-border);
			border-radius: 4px;
			background-color: var(--pf-panel-bg);
			font-size: 0.8em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
			user-select: none;
			-webkit-user-select: none;
			position: relative;
		}
		.pict-flow-palette-card:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-node-selected-stroke);
			box-shadow: var(--pf-card-hover-shadow);
		}
		.pict-flow-palette-card.disabled {
			opacity: 0.45;
			pointer-events: none;
			cursor: default;
		}
		.pict-flow-palette-card-icon {
			font-size: 1.1em;
			line-height: 1;
		}
		.pict-flow-palette-card-swatch {
			width: 10px;
			height: 10px;
			border-radius: 2px;
			flex-shrink: 0;
		}
		.pict-flow-palette-card-title {
			font-weight: 500;
			color: var(--pf-text-primary);
			white-space: nowrap;
		}
		.pict-flow-palette-card-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
		}
		.pict-flow-toolbar-select.layout-select {
			min-width: 120px;
			max-width: 200px;
		}
		`;
	}

	// ── Popups ────────────────────────────────────────────────────────────
	/**
	 * CSS for toolbar dropdown popups (Add Node, Cards, Layout).
	 * @returns {string}
	 */
	getPopupCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-popup-anchor {
			position: relative;
		}
		.pict-flow-toolbar-popup {
			position: absolute;
			z-index: 1000;
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-card-border);
			border-radius: 6px;
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			min-width: 240px;
			max-height: 80vh;
			overflow-y: auto;
			padding: 0.35em 0;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
		}
		.pict-flow-popup-search-wrapper {
			position: relative;
			padding: 0.4em 0.5em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-popup-search-icon {
			position: absolute;
			left: 0.85em;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none;
			line-height: 1;
			display: flex;
			align-items: center;
		}
		.pict-flow-popup-search {
			width: 100%;
			padding: 0.4em 0.5em 0.4em 2em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-search:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-list-item {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-list-item:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-list-item-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-list-item-label {
			flex: 1;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-list-item-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
			background: var(--pf-badge-category-bg);
			padding: 0.1em 0.4em;
			border-radius: 3px;
		}
		.pict-flow-popup-divider {
			height: 1px;
			background: var(--pf-divider-light);
			margin: 0.25em 0;
		}
		.pict-flow-popup-list-empty {
			text-align: center;
			color: var(--pf-text-placeholder);
			padding: 1.5em 0.75em;
			font-size: 0.9em;
		}
		.pict-flow-popup-layout-save {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-layout-save:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-save-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-input-row {
			display: flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.5em;
		}
		.pict-flow-popup-layout-save-input {
			flex: 1;
			padding: 0.35em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-layout-save-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-save-confirm {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			background: var(--pf-panel-bg);
			cursor: pointer;
			flex-shrink: 0;
			transition: background-color 0.15s, border-color 0.15s;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-confirm:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-row {
			display: flex;
			align-items: center;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-layout-row:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-name {
			flex: 1;
			color: var(--pf-text-primary);
		}
		.pict-flow-popup-layout-delete {
			display: none;
			align-items: center;
			justify-content: center;
			border: none;
			background: none;
			color: var(--pf-button-danger-text);
			cursor: pointer;
			padding: 2px 4px;
			border-radius: 3px;
			line-height: 1;
		}
		.pict-flow-popup-layout-row:hover .pict-flow-popup-layout-delete {
			display: inline-flex;
		}
		.pict-flow-popup-layout-delete:hover {
			background-color: var(--pf-button-danger-hover-bg);
		}
		.pict-flow-popup-settings-section {
			padding: 0.5em 0.75em;
		}
		.pict-flow-popup-settings-label {
			display: block;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--pf-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin-bottom: 0.35em;
		}
		.pict-flow-popup-settings-select {
			width: 100%;
			padding: 0.4em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			background: var(--pf-panel-bg);
			color: var(--pf-text-primary);
			cursor: pointer;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-settings-select:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-settings-slider-row {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.pict-flow-popup-settings-slider {
			flex: 1;
			-webkit-appearance: none;
			appearance: none;
			height: 4px;
			background: var(--pf-input-border);
			border-radius: 2px;
			outline: none;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-webkit-slider-thumb {
			-webkit-appearance: none;
			appearance: none;
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-moz-range-thumb {
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
			border: none;
		}
		.pict-flow-popup-settings-slider-value {
			font-size: 0.85em;
			color: var(--pf-text-secondary);
			min-width: 2.5em;
			text-align: right;
		}
		`;
	}

	// ── Collapsed Toolbar ─────────────────────────────────────────────────
	/**
	 * CSS for the collapsed toolbar state (small expand button in corner).
	 * @returns {string}
	 */
	getCollapsedToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-collapsed {
			position: absolute;
			top: 8px;
			right: 8px;
			z-index: 100;
			display: none;
		}
		.pict-flow-toolbar-collapsed.visible {
			display: block;
		}
		.pict-flow-toolbar-expand-btn {
			width: 36px;
			height: 36px;
			border-radius: 6px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 2px 6px rgba(0,0,0,0.1);
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s, box-shadow 0.15s;
		}
		.pict-flow-toolbar-expand-btn:hover {
			background-color: var(--pf-button-hover-bg);
			box-shadow: 0 2px 8px rgba(0,0,0,0.15);
		}
		`;
	}

	// ── Floating Toolbar ──────────────────────────────────────────────────
	/**
	 * CSS for the floating draggable toolbar.
	 * @returns {string}
	 */
	getFloatingToolbarCSS()
	{
		return /*css*/`
		.pict-flow-floating-toolbar {
			position: absolute;
			z-index: 100;
			display: flex;
			flex-direction: column;
			gap: 2px;
			padding: 4px;
			border-radius: 8px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			pointer-events: auto;
		}
		.pict-flow-floating-grip {
			cursor: grab;
			padding: 4px;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-grip:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-grip:active {
			cursor: grabbing;
		}
		.pict-flow-floating-btn {
			width: 32px;
			height: 32px;
			border: none;
			border-radius: 4px;
			background-color: transparent;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-btn:focus {
			outline: none;
		}
		.pict-flow-floating-btn:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-separator {
			height: 1px;
			background-color: var(--pf-divider-light);
			margin: 2px 4px;
		}
		/* Collapsed floating toolbar — grip-only draggable square */
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-btn,
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-separator {
			display: none;
		}
		.pict-flow-floating-toolbar.collapsed {
			padding: 0;
			border-radius: 6px;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip {
			width: 32px;
			height: 32px;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip span {
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		`;
	}

	// ── Icons ─────────────────────────────────────────────────────────────
	/**
	 * CSS for inline SVG icons in palette cards, toolbar buttons, info panel headers, and panel close buttons.
	 * @returns {string}
	 */
	getIconCSS()
	{
		return /*css*/`
		.pict-flow-icon-svg {
			pointer-events: none;
		}
		.pict-flow-palette-card-icon svg {
			display: inline-block;
			vertical-align: middle;
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
			vertical-align: middle;
		}
		.pict-flow-info-panel-header.with-icon svg {
			display: inline-block;
			vertical-align: middle;
			margin-right: 4px;
		}
		.pict-flow-panel-close-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-panel-close-icon svg {
			display: block;
		}
		.pict-flow-palette-toggle-arrow svg {
			display: block;
		}
		`;
	}

	// ── Bracket Node CSS ──────────────────────────────────────────────────
	/**
	 * CSS for bracket-style node bodies used by sketch/blueprint themes.
	 *
	 * The bracket fill rects share class `.pict-flow-node-body` for fill
	 * inheritance, so these rules must use parent-qualified selectors
	 * (specificity ≥ 0,2,0) to override the base, variant, hover, and
	 * selected rules that set stroke and rx/ry on `.pict-flow-node-body`.
	 *
	 * @returns {string}
	 */
	getBracketNodeCSS()
	{
		return /*css*/`
		/* Bracket outline path */
		.pict-flow-node-bracket {
			fill: none;
			stroke: var(--pf-node-body-stroke);
			stroke-width: 2;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-flow-node.selected .pict-flow-node-bracket {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node:hover .pict-flow-node-bracket {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}

		/* Bracket fill rects: no stroke, no rounded corners.
		   Uses parent-qualified selectors to beat variant rules
		   (e.g. .pict-flow-node-start .pict-flow-node-body). */
		.pict-flow-node .pict-flow-node-bracket-fill,
		.pict-flow-node .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
			rx: 0;
			ry: 0;
		}
		/* Beat hover rule: .pict-flow-node:hover .pict-flow-node-body */
		.pict-flow-node:hover .pict-flow-node-bracket-fill,
		.pict-flow-node:hover .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		/* Beat selected rule: .pict-flow-node.selected .pict-flow-node-body */
		.pict-flow-node.selected .pict-flow-node-bracket-fill,
		.pict-flow-node.selected .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		`;
	}

	// ── Aggregate Methods ──────────────────────────────────────────────────

	/**
	 * Concatenate all domain CSS getters into a single CSS string.
	 * Includes theme overrides if a theme provider is active.
	 * @returns {string}
	 */
	generateCSS()
	{
		let tmpBaseCSS = (
			this.getContainerCSS() +
			this.getNodeCSS() +
			this.getBodyContentCSS() +
			this.getNodeVariantCSS() +
			this.getPortCSS() +
			this.getConnectionCSS() +
			this.getHandleCSS() +
			this.getTetherCSS() +
			this.getPanelCSS() +
			this.getInfoPanelCSS() +
			this.getNodePropsEditorCSS() +
			this.getPanelTabsCSS() +
			this.getBracketNodeCSS() +
			this.getFullscreenCSS() +
			this.getToolbarCSS() +
			this.getPaletteCSS() +
			this.getPopupCSS() +
			this.getCollapsedToolbarCSS() +
			this.getFloatingToolbarCSS() +
			this.getIconCSS()
		);

		// Apply theme overrides if a theme provider exists
		if (this._FlowView && this._FlowView._ThemeProvider)
		{
			let tmpTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpTheme && tmpTheme.CSSVariables && Object.keys(tmpTheme.CSSVariables).length > 0)
			{
				let tmpOverrides = '.pict-flow-container {\n';
				for (let tmpKey in tmpTheme.CSSVariables)
				{
					tmpOverrides += '\t' + tmpKey + ': ' + tmpTheme.CSSVariables[tmpKey] + ';\n';
				}
				tmpOverrides += '}\n';
				tmpBaseCSS += tmpOverrides;
			}
			if (tmpTheme && tmpTheme.AdditionalCSS)
			{
				tmpBaseCSS += tmpTheme.AdditionalCSS;
			}
		}

		return tmpBaseCSS;
	}

	/**
	 * Register all flow CSS with pict's CSSMap service.
	 * Uses correct parameter ordering: (hash, content, priority, provider).
	 * Removes existing CSS first to allow theme re-registration,
	 * then re-injects into the DOM.
	 */
	registerCSS()
	{
		if (this.fable && this.fable.CSSMap)
		{
			// Remove existing CSS first so we can re-register with updated theme overrides
			this.fable.CSSMap.removeCSS('PictSectionFlow-CSS');
			this.fable.CSSMap.addCSS('PictSectionFlow-CSS', this.generateCSS(), 500, 'PictProviderFlowCSS');
			// Re-inject into the DOM to apply the updated CSS
			this.fable.CSSMap.injectCSS();
		}
		else
		{
			this.log.warn('PictProviderFlowCSS: CSSMap not available; CSS not registered.');
		}
	}

	/**
	 * Register the active renderer's CSS overrides (GeometryCSS + AdditionalCSS).
	 *
	 * The renderer's CSS is registered at priority 501 — one higher than the
	 * base container CSS — so its `.pict-flow-container { --pf-*: ... }`
	 * declarations win the cascade against the equally-specific defaults in
	 * `generateCSS()`. Called by PictView-Flow.setRenderer() after the
	 * Flow-Renderer provider switches its active renderer.
	 *
	 * @param {Object} pRenderer - the active renderer definition (from PictProviderFlowRenderer)
	 */
	registerRendererCSS(pRenderer)
	{
		if (!this.fable || !this.fable.CSSMap) { return; }
		this.fable.CSSMap.removeCSS('PictSectionFlow-Renderer-CSS');
		if (!pRenderer) { this.fable.CSSMap.injectCSS(); return; }

		let tmpCSS = '';
		if (pRenderer.GeometryCSS)   { tmpCSS += pRenderer.GeometryCSS;   }
		if (pRenderer.AdditionalCSS) { tmpCSS += '\n' + pRenderer.AdditionalCSS; }
		if (tmpCSS.trim().length === 0) { this.fable.CSSMap.injectCSS(); return; }

		this.fable.CSSMap.addCSS('PictSectionFlow-Renderer-CSS', tmpCSS, 501, 'PictProviderFlowCSS');
		this.fable.CSSMap.injectCSS();
	}
}

module.exports = PictProviderFlowCSS;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":59}],457:[function(require,module,exports){
arguments[4][217][0].apply(exports,arguments)
},{"dup":217,"fable-serviceproviderbase":59}],458:[function(require,module,exports){
arguments[4][218][0].apply(exports,arguments)
},{"dup":218,"pict-provider":177}],459:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-Geometry
 *
 * Shared geometry utilities for the flow diagram.
 * Provides direction vectors and edge center calculations used by
 * connections, tethers, and other flow components.
 *
 * Port Side values (12 positions):
 *
 *   Top edge:    'top-left'     'top'     'top-right'
 *   Left edge:   'left-top'     'left'    'left-bottom'
 *   Right edge:  'right-top'    'right'   'right-bottom'
 *   Bottom edge: 'bottom-left'  'bottom'  'bottom-right'
 *
 * The old 4-value sides ('left', 'right', 'top', 'bottom') map to
 * the middle position on each edge for backward compatibility.
 */
class PictProviderFlowGeometry extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowGeometry';
	}

	/**
	 * Extract the edge name from a Side value.
	 *
	 * Maps all 12 positions (and the 4 legacy values) back to
	 * the edge they sit on: 'left', 'right', 'top', or 'bottom'.
	 *
	 * @param {string} pSide - Any valid Side value
	 * @returns {string} The edge: 'left', 'right', 'top', or 'bottom'
	 */
	getEdgeFromSide(pSide)
	{
		switch (pSide)
		{
			case 'left-top':
			case 'left':
			case 'left-bottom':
				return 'left';

			case 'right-top':
			case 'right':
			case 'right-bottom':
				return 'right';

			case 'top-left':
			case 'top':
			case 'top-right':
				return 'top';

			case 'bottom-left':
			case 'bottom':
			case 'bottom-right':
				return 'bottom';

			default:
				return 'right';
		}
	}

	/**
	 * Get the outward unit direction vector for a given side.
	 *
	 * All positions on the same edge share the same direction vector.
	 *
	 * @param {string} pSide - Any valid Side value (12 positions or 4 legacy)
	 * @returns {{dx: number, dy: number}}
	 */
	sideDirection(pSide)
	{
		switch (this.getEdgeFromSide(pSide))
		{
			case 'left':   return { dx: -1, dy: 0 };
			case 'right':  return { dx: 1, dy: 0 };
			case 'top':    return { dx: 0, dy: -1 };
			case 'bottom': return { dx: 0, dy: 1 };
			default:       return { dx: 1, dy: 0 };
		}
	}

	/**
	 * Get the center point of a rectangle's edge.
	 * Works for any object with X, Y, Width, Height properties
	 * (nodes, panels, or any rectangular element).
	 *
	 * @param {Object} pRectData - Object with X, Y, Width, Height
	 * @param {string} pSide - 'left', 'right', 'top', 'bottom'
	 * @returns {{x: number, y: number}}
	 */
	getEdgeCenter(pRectData, pSide)
	{
		switch (pSide)
		{
			case 'left':
				return { x: pRectData.X, y: pRectData.Y + pRectData.Height / 2 };
			case 'right':
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
			case 'top':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y };
			case 'bottom':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y + pRectData.Height };
			default:
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
		}
	}

	/**
	 * Calculate a port's local position relative to node origin.
	 *
	 * Supports 12 positions (3 zones per edge).  For left/right edges,
	 * the body area below the title bar is divided into vertical zones.
	 * For top/bottom edges, the full width is divided into horizontal zones.
	 *
	 * When pPortCountsBySide is provided, zone fractions are computed
	 * proportionally based on actual port counts (adaptive zones).
	 * Otherwise, fixed 1/3 zones are used for backward compatibility.
	 *
	 * Multiple ports sharing the same Side value distribute evenly within
	 * their zone.
	 *
	 * @param {string} pSide - Side value (any of 12 positions or 4 legacy)
	 * @param {number} pIndex - Index of this port within its Side group
	 * @param {number} pTotal - Total ports with this Side value
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pTitleBarHeight - Height of the node title bar
	 * @param {Object} [pPortCountsBySide] - Optional map of Side → port count
	 *        for all ports on the node.  Enables adaptive zone sizing.
	 * @returns {{x: number, y: number}}
	 */
	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pTitleBarHeight, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZone = pPortCountsBySide
			? this._computeAdaptiveZone(pSide, pPortCountsBySide)
			: this._getZoneFromSide(pSide);

		// Use the fixed zone to decide alignment intent (start/center/end)
		// because adaptive zones shift boundaries when neighbouring zones
		// are empty, which would break alignment decisions.
		let tmpFixedZone = this._getZoneFromSide(pSide);

		// Minimum spacing between port centers (px)
		let tmpMinSpacing = 16;

		// Reserve space at the bottom of the body so that port badges
		// never overlap the panel-indicator icon (10×10 rect at bottom-right)
		// and always leave a visible gap above the node bottom edge.
		let tmpBottomPad = 16;

		// Determine alignment from the fixed zone position:
		//   start zone  (0.000 – 0.333) → start-align (offset 0)
		//   middle zone (0.333 – 0.667) → center
		//   end zone    (0.667 – 1.000) → end-align
		let tmpAlignment = 'start';
		if (tmpFixedZone.start >= 0.5)
		{
			tmpAlignment = 'end';
		}
		else if (tmpFixedZone.start >= 0.17)
		{
			tmpAlignment = 'center';
		}

		if (tmpEdge === 'left' || tmpEdge === 'right')
		{
			let tmpX = (tmpEdge === 'left') ? 0 : pWidth;
			let tmpBodyHeight = pHeight - pTitleBarHeight - tmpBottomPad;
			let tmpZoneStart = pTitleBarHeight + tmpBodyHeight * tmpZone.start;
			let tmpZoneHeight = tmpBodyHeight * (tmpZone.end - tmpZone.start);

			// Use fixed spacing so port gaps stay consistent across cards
			// even when one edge drives the card height beyond what the
			// other needs.
			let tmpSpacing = tmpMinSpacing;
			let tmpGroupHeight = tmpSpacing * (pTotal + 1);
			let tmpSlack = tmpZoneHeight - tmpGroupHeight;
			if (tmpSlack < 0)
			{
				tmpSlack = 0;
			}

			let tmpAlignOffset = 0;
			if (tmpAlignment === 'end')
			{
				tmpAlignOffset = tmpSlack;
			}
			else if (tmpAlignment === 'center')
			{
				tmpAlignOffset = tmpSlack / 2;
			}

			let tmpY = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
			return { x: tmpX, y: tmpY };
		}

		// top or bottom
		let tmpY = (tmpEdge === 'top') ? 0 : pHeight;
		let tmpZoneStart = pWidth * tmpZone.start;
		let tmpZoneWidth = pWidth * (tmpZone.end - tmpZone.start);

		let tmpSpacing = tmpMinSpacing;
		let tmpGroupWidth = tmpSpacing * (pTotal + 1);
		let tmpSlack = tmpZoneWidth - tmpGroupWidth;
		if (tmpSlack < 0)
		{
			tmpSlack = 0;
		}

		let tmpAlignOffset = 0;
		if (tmpAlignment === 'end')
		{
			tmpAlignOffset = tmpSlack;
		}
		else if (tmpAlignment === 'center')
		{
			tmpAlignOffset = tmpSlack / 2;
		}

		let tmpX = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
		return { x: tmpX, y: tmpY };
	}

	/**
	 * Get the zone fraction (start, end) for a Side value.
	 *
	 * Each edge is divided into three zones of equal size:
	 *   start:  0.0 — 0.333
	 *   middle: 0.333 — 0.667
	 *   end:    0.667 — 1.0
	 *
	 * Used as fallback when adaptive zones are not available.
	 *
	 * @param {string} pSide
	 * @returns {{start: number, end: number}}
	 */
	_getZoneFromSide(pSide)
	{
		switch (pSide)
		{
			// Left edge: top, middle, bottom
			case 'left-top':     return { start: 0.0,   end: 0.333 };
			case 'left':         return { start: 0.333, end: 0.667 };
			case 'left-bottom':  return { start: 0.667, end: 1.0 };

			// Right edge: top, middle, bottom
			case 'right-top':    return { start: 0.0,   end: 0.333 };
			case 'right':        return { start: 0.333, end: 0.667 };
			case 'right-bottom': return { start: 0.667, end: 1.0 };

			// Top edge: left, middle, right
			case 'top-left':     return { start: 0.0,   end: 0.333 };
			case 'top':          return { start: 0.333, end: 0.667 };
			case 'top-right':    return { start: 0.667, end: 1.0 };

			// Bottom edge: left, middle, right
			case 'bottom-left':  return { start: 0.0,   end: 0.333 };
			case 'bottom':       return { start: 0.333, end: 0.667 };
			case 'bottom-right': return { start: 0.667, end: 1.0 };

			// Fallback: full range (legacy behavior)
			default:             return { start: 0.0,   end: 1.0 };
		}
	}

	/**
	 * Get the three zone Side keys for a given edge, in order.
	 *
	 * @param {string} pEdge - 'left', 'right', 'top', or 'bottom'
	 * @returns {Array<string>} Three Side keys in start-to-end order
	 */
	_getZoneKeysForEdge(pEdge)
	{
		switch (pEdge)
		{
			case 'left':   return ['left-top', 'left', 'left-bottom'];
			case 'right':  return ['right-top', 'right', 'right-bottom'];
			case 'top':    return ['top-left', 'top', 'top-right'];
			case 'bottom': return ['bottom-left', 'bottom', 'bottom-right'];
			default:       return ['right-top', 'right', 'right-bottom'];
		}
	}

	/**
	 * Compute an adaptive zone fraction for a Side value based on the
	 * actual port distribution across all zones on the same edge.
	 *
	 * Instead of fixed 1/3 splits, zones are sized proportionally to the
	 * space each zone needs (minSpacing * (portCount + 1)).  Zones with
	 * zero ports collapse to zero, giving occupied zones more room.
	 *
	 * @param {string} pSide - The Side value to compute a zone for
	 * @param {Object} pPortCountsBySide - Map of Side → number of ports
	 * @returns {{start: number, end: number}}
	 */
	_computeAdaptiveZone(pSide, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZoneKeys = this._getZoneKeysForEdge(tmpEdge);

		let tmpMinSpacing = 16;

		// Compute the space each zone needs: minSpacing * (count + 1)
		// The +1 provides padding at both ends of the zone.
		let tmpTotalSpace = 0;
		let tmpSpaceByZone = {};
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpCount = pPortCountsBySide[tmpKey] || 0;
			let tmpSpace = (tmpCount > 0) ? (tmpMinSpacing * (tmpCount + 1)) : 0;
			tmpSpaceByZone[tmpKey] = tmpSpace;
			tmpTotalSpace += tmpSpace;
		}

		// If no ports on this edge at all, fall back to fixed zones
		if (tmpTotalSpace === 0)
		{
			return this._getZoneFromSide(pSide);
		}

		// Compute proportional start/end for the requested zone
		let tmpCumulativeStart = 0;
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpFraction = tmpSpaceByZone[tmpKey] / tmpTotalSpace;
			if (tmpKey === pSide)
			{
				return { start: tmpCumulativeStart, end: tmpCumulativeStart + tmpFraction };
			}
			tmpCumulativeStart += tmpFraction;
		}

		// Should not reach here; fall back to fixed zones
		return this._getZoneFromSide(pSide);
	}

	/**
	 * Build a map of Side → port count from an array of port objects.
	 *
	 * Convenience method for callers that need to pass port counts
	 * to getPortLocalPosition or computeMinimumNodeHeight.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @returns {Object} Map of Side value → count
	 */
	buildPortCountsBySide(pPorts)
	{
		let tmpCounts = {};
		if (!pPorts || !Array.isArray(pPorts))
		{
			return tmpCounts;
		}
		for (let i = 0; i < pPorts.length; i++)
		{
			let tmpSide = pPorts[i].Side || (pPorts[i].Direction === 'input' ? 'left' : 'right');
			if (!tmpCounts[tmpSide])
			{
				tmpCounts[tmpSide] = 0;
			}
			tmpCounts[tmpSide]++;
		}
		return tmpCounts;
	}

	/**
	 * Compute the minimum node height required so that all ports
	 * (with their badges) fit within the node boundary.
	 *
	 * Uses adaptive zone sizing: instead of assuming each zone gets
	 * a fixed 1/3 of the body, sums the space needed by all occupied
	 * zones on each left/right edge.  This produces compact cards
	 * whose height scales linearly with total port count.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @param {number} pTitleBarHeight - Height of the title bar
	 * @returns {number} Minimum node height in pixels (0 if no ports)
	 */
	computeMinimumNodeHeight(pPorts, pTitleBarHeight)
	{
		if (!pPorts || !Array.isArray(pPorts) || pPorts.length === 0)
		{
			return 0;
		}

		let tmpMinSpacing = 16;
		let tmpBottomPad = 16;

		// Count ports per Side value
		let tmpCountBySide = this.buildPortCountsBySide(pPorts);

		// Sum the space needed per edge (left, right) across all zones.
		// Each zone needs minSpacing * (count + 1) pixels.
		let tmpSpacePerEdge = {};
		for (let tmpSide in tmpCountBySide)
		{
			let tmpEdge = this.getEdgeFromSide(tmpSide);

			// Only left/right edge zones affect required height
			if (tmpEdge !== 'left' && tmpEdge !== 'right')
			{
				continue;
			}

			let tmpCount = tmpCountBySide[tmpSide];
			let tmpZoneSpace = tmpMinSpacing * (tmpCount + 1);

			if (!tmpSpacePerEdge[tmpEdge])
			{
				tmpSpacePerEdge[tmpEdge] = 0;
			}
			tmpSpacePerEdge[tmpEdge] += tmpZoneSpace;
		}

		// The minimum height is titleBar + bottomPad + max edge space
		let tmpMinHeight = 0;
		for (let tmpEdge in tmpSpacePerEdge)
		{
			let tmpRequired = pTitleBarHeight + tmpBottomPad + tmpSpacePerEdge[tmpEdge];
			if (tmpRequired > tmpMinHeight)
			{
				tmpMinHeight = tmpRequired;
			}
		}

		return Math.ceil(tmpMinHeight);
	}
}

module.exports = PictProviderFlowGeometry;

},{"fable-serviceproviderbase":59}],460:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-Icons
 *
 * Centralized SVG icon provider for the flow diagram.
 * All icons use a duotone style: 2px outline (var(--theme-color-text-primary, #2c3e50)) with
 * subtle filled accent shapes (var(--theme-color-background-secondary, #d5e8f7)).
 *
 * Each icon is registered as a pict template with hash `Flow-Icon-{key}`,
 * making them individually overridable by consumers.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowIcons'
};

// ── Default Icon SVG Markup ────────────────────────────────────────────────
// All icons: viewBox="0 0 24 24", duotone style
// Accent fill: var(--theme-color-background-secondary, #d5e8f7), Stroke: var(--theme-color-text-primary, #2c3e50), Stroke-width: 2
//
// The {FlowIconSize} placeholder is replaced at render time with the
// requested pixel size. Each template is a self-contained <svg> element.

const _DefaultIcons =
{
	// ── FlowCard Icons ─────────────────────────────────────────────────────

	'ITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="6" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="6" cy="18" r="2.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="18" cy="18" r="2.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 9v2M9.5 12.5L6 15.5M14.5 12.5L18 15.5" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'SW': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M3 12h5M16 12h5M14.8 9.2l3.7-5.2M14.8 14.8l3.7 5.2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'EACH': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="14" y="3" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="3" y="14" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="14" y="14" width="7" height="7" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'FREAD': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M13 2v7h7" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M9 13h6M9 17h4" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'FWRITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M13 2v7h7" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 13v5M9.5 15.5L12 13l2.5 2.5" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'LOG': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="7.5" cy="8" r="1" fill="var(--theme-color-text-primary, #2c3e50)"/><circle cx="7.5" cy="12" r="1" fill="var(--theme-color-text-primary, #2c3e50)"/><circle cx="7.5" cy="16" r="1" fill="var(--theme-color-text-primary, #2c3e50)"/><path d="M11 8h5.5M11 12h5.5M11 16h3.5" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'GET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="6.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-5.15-5.15" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'SET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4.5 1.5L4 16Z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M14 6l3 3" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	// ── UI Icons ───────────────────────────────────────────────────────────

	'edit': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',

	'check': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',

	'background': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'connect': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8 8l8 8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="6" cy="6" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="18" cy="18" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/></svg>',

	'exit-fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14h6v6"/><path d="M20 10h-6V4"/><path d="M14 10l7-7"/><path d="M3 21l7-7"/></svg>',

	'close': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',

	'chevron-down': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',

	// ── Toolbar & Popup Icons ─────────────────────────────────────────────

	'search': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'cards': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="12" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M6 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="8" height="10" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="13" y="3" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="3" y="15" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="13" y="11" width="8" height="10" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'collapse': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 12h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'expand': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'grip': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="var(--theme-color-text-primary, #2c3e50)"><circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><circle cx="9" cy="19" r="1.5"/><circle cx="15" cy="19" r="1.5"/></svg>',

	'settings': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3" fill="var(--theme-color-background-secondary, #d5e8f7)"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',

	'plus': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'trash': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'save': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M17 21v-8H7v8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M7 3v5h8" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'auto-layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="2" y="16" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="14" y="16" width="8" height="6" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 8v4M6 16v-4h12v4" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'zoom-in': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M11 8v6M8 11h6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'zoom-out': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 11h6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'zoom-fit': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7V3h4"/><path d="M17 3h4v4"/><path d="M21 17v4h-4"/><path d="M7 21H3v-4"/><rect x="7" y="7" width="10" height="10" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)"/></svg>',

	'dock': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="4" rx="1.5" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M12 20V11M8 14l4-4 4 4" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	'restore': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',

	'delete-node': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/></svg>',

	// ── Fallback ───────────────────────────────────────────────────────────

	'default': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="4" fill="var(--theme-color-background-secondary, #d5e8f7)" stroke="var(--theme-color-text-primary, #2c3e50)" stroke-width="2"/><circle cx="12" cy="12" r="2.5" fill="var(--theme-color-text-primary, #2c3e50)"/></svg>'
};

class PictProviderFlowIcons extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowIcons';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Deep copy the default icons
		this._Icons = JSON.parse(JSON.stringify(_DefaultIcons));

		// Merge any additional icons passed via options
		if (pOptions && pOptions.AdditionalIcons && typeof pOptions.AdditionalIcons === 'object')
		{
			let tmpKeys = Object.keys(pOptions.AdditionalIcons);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				this._Icons[tmpKeys[i]] = pOptions.AdditionalIcons[tmpKeys[i]];
			}
		}
	}

	/**
	 * Register all icons as pict templates with hash Flow-Icon-{key}.
	 * Consumers can override any icon by registering a template with
	 * the same hash before the flow view renders.
	 */
	registerIconTemplates()
	{
		if (!this.fable || !this.fable.TemplateProvider)
		{
			this.log.warn('PictProviderFlowIcons: TemplateProvider not available; icon templates not registered.');
			return;
		}

		let tmpKeys = Object.keys(this._Icons);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpHash = 'Flow-Icon-' + tmpKeys[i];

			// Only register if not already present (allow consumer overrides)
			if (!this.fable.TemplateProvider.getTemplate(tmpHash))
			{
				this.fable.TemplateProvider.addTemplate(tmpHash, this._Icons[tmpKeys[i]]);
			}
		}
	}

	/**
	 * Determine if the given icon string is an emoji (legacy) or an icon key.
	 * Returns true if the string contains characters with code points above U+00FF,
	 * indicating emoji or Unicode symbol characters.
	 *
	 * @param {string} pIconValue - The icon value to check
	 * @returns {boolean}
	 */
	isEmojiIcon(pIconValue)
	{
		if (!pIconValue || typeof pIconValue !== 'string')
		{
			return false;
		}

		for (let i = 0; i < pIconValue.length; i++)
		{
			if (pIconValue.charCodeAt(i) > 255)
			{
				return true;
			}
		}

		return false;
	}

	/**
	 * Resolve the icon key to use for a given CardMetadata object.
	 * Tries Icon field first, then Code field, then falls back to 'default'.
	 *
	 * @param {Object} pCardMetadata - The CardMetadata object
	 * @returns {string} The icon key
	 */
	resolveIconKey(pCardMetadata)
	{
		if (!pCardMetadata)
		{
			return 'default';
		}

		// If Icon is a known key, use it
		if (pCardMetadata.Icon && this._Icons.hasOwnProperty(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// If Icon is a non-emoji string, check if it matches a registered template
		if (pCardMetadata.Icon && !this.isEmojiIcon(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// Fall back to Code field
		if (pCardMetadata.Code && this._Icons.hasOwnProperty(pCardMetadata.Code))
		{
			return pCardMetadata.Code;
		}

		return 'default';
	}

	/**
	 * Get the raw SVG markup string for a given icon key, with size applied.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {string} The SVG markup string
	 */
	getIconSVGMarkup(pIconKey, pSize)
	{
		let tmpSize = pSize || 16;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace the size placeholder
		return tmpMarkup.replace(/\{FlowIconSize\}/g, String(tmpSize));
	}

	/**
	 * Render an icon into an SVG canvas context using createElementNS.
	 * Creates a <g> element containing the icon paths, positioned at (pX, pY)
	 * with the given size via a scale transform.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {SVGElement} pParentGroup - The parent SVG group to append to
	 * @param {number} pX - X position (top-left of icon bounding box)
	 * @param {number} pY - Y position (top-left of icon bounding box)
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {SVGGElement|null} The created group element, or null on failure
	 */
	renderIconIntoSVGGroup(pIconKey, pParentGroup, pX, pY, pSize)
	{
		if (!pParentGroup)
		{
			return null;
		}

		let tmpSize = pSize || 16;
		let tmpScale = tmpSize / 24;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace size placeholder (for consistency, though we scale via transform)
		tmpMarkup = tmpMarkup.replace(/\{FlowIconSize\}/g, '24');

		try
		{
			// Create a temporary SVG element to parse the icon markup
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpMarkup;

			// Find the inner SVG (the icon's root <svg> element)
			let tmpInnerSVG = tmpTempSVG.querySelector('svg');
			if (!tmpInnerSVG)
			{
				return null;
			}

			// Create a group to hold the icon content
			let tmpGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
			tmpGroup.setAttribute('transform', 'translate(' + pX + ',' + pY + ') scale(' + tmpScale + ')');
			tmpGroup.setAttribute('pointer-events', 'none');
			tmpGroup.setAttribute('class', 'pict-flow-icon-svg');

			// Move all children from the parsed SVG into the group
			while (tmpInnerSVG.childNodes.length > 0)
			{
				tmpGroup.appendChild(tmpInnerSVG.childNodes[0]);
			}

			pParentGroup.appendChild(tmpGroup);
			return tmpGroup;
		}
		catch (pError)
		{
			this.log.warn('PictProviderFlowIcons renderIconIntoSVGGroup error: ' + pError.message);
			return null;
		}
	}

	/**
	 * Get all registered icon keys.
	 * @returns {Array<string>}
	 */
	getIconKeys()
	{
		return Object.keys(this._Icons);
	}

	/**
	 * Check if a given key has a registered icon.
	 * @param {string} pIconKey
	 * @returns {boolean}
	 */
	hasIcon(pIconKey)
	{
		return this._Icons.hasOwnProperty(pIconKey);
	}

	/**
	 * Register a new icon or override an existing one.
	 * @param {string} pIconKey - The icon key
	 * @param {string} pSVGMarkup - The SVG markup string (must contain {FlowIconSize} placeholders)
	 * @returns {boolean}
	 */
	registerIcon(pIconKey, pSVGMarkup)
	{
		if (!pIconKey || !pSVGMarkup)
		{
			return false;
		}

		this._Icons[pIconKey] = pSVGMarkup;

		// Also update the pict template if TemplateProvider is available
		if (this.fable && this.fable.TemplateProvider)
		{
			this.fable.TemplateProvider.addTemplate('Flow-Icon-' + pIconKey, pSVGMarkup);
		}

		return true;
	}
}

module.exports = PictProviderFlowIcons;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.DefaultIcons = _DefaultIcons;

},{"fable-serviceproviderbase":59}],461:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowLayouts'
};

/**
 * Provider for managing saved flow diagram layouts.
 *
 * Layouts capture the spatial arrangement of nodes and panels on the canvas
 * without storing any card content. When a layout is restored, nodes that
 * still exist are placed at their saved positions and any new nodes are
 * auto-laid-out to the right.
 *
 * ## Persistence
 *
 * By default, layouts are persisted to the browser's `localStorage` using a
 * key derived from the flow view identifier. This means layouts survive page
 * refreshes out of the box.
 *
 * Developers can override the storage backend (e.g., to use a REST API or
 * IndexedDB) by replacing the three storage hook methods on the instance or
 * in a subclass:
 *
 *   - `storageWrite(pLayouts, fCallback)` — persist the full layout array
 *   - `storageRead(fCallback)` — load the persisted layout array
 *   - `storageDelete(fCallback)` — remove all persisted layouts
 *
 * Each callback follows the Node convention: `fCallback(pError, pResult)`.
 *
 * Saved layout data structure:
 * {
 *     Hash: "layout-<UUID>",
 *     Name: "My Layout",
 *     CreatedAt: "2026-02-26T12:00:00.000Z",
 *     NodePositions: { "node-hash": { X, Y, Width, Height } },
 *     PanelPositions: { "node-hash": { X, Y, Width, Height } },
 *     ViewState: { PanX, PanY, Zoom }
 * }
 */
class PictProviderFlowLayouts extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowLayouts';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Storage key for localStorage persistence.
		// Defaults to a key derived from the FlowView identifier, or can be
		// set via options.StorageKey.  Pass `false` to disable localStorage.
		if (pOptions && pOptions.StorageKey !== undefined)
		{
			this._StorageKey = pOptions.StorageKey;
		}
		else if (this._FlowView && this._FlowView.options && this._FlowView.options.ViewIdentifier)
		{
			this._StorageKey = `pict-flow-layouts-${this._FlowView.options.ViewIdentifier}`;
		}
		else
		{
			this._StorageKey = 'pict-flow-layouts';
		}
	}

	// ── Storage Hooks ─────────────────────────────────────────────────────
	// These three methods form the persistence contract.  The default
	// implementation uses localStorage.  Override them on the instance or
	// subclass to use a REST API, IndexedDB, or any other backend.
	//
	// All callbacks follow `fCallback(pError, pResult)`.

	/**
	 * Persist the full array of layout objects.
	 *
	 * Default implementation writes JSON to `localStorage`.
	 *
	 * @param {Array} pLayouts - The array of layout objects to persist
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageWrite(pLayouts, fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.setItem(this._StorageKey, JSON.stringify(pLayouts));
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageWrite error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	/**
	 * Load the persisted array of layout objects.
	 *
	 * Default implementation reads JSON from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError, pLayouts)` where
	 *        pLayouts is an Array (or null/empty if nothing stored)
	 */
	storageRead(fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null, []);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				let tmpRaw = localStorage.getItem(this._StorageKey);
				if (tmpRaw)
				{
					let tmpParsed = JSON.parse(tmpRaw);
					if (Array.isArray(tmpParsed))
					{
						return fCallback(null, tmpParsed);
					}
				}
			}
			return fCallback(null, []);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageRead error: ${pError.message}`);
			return fCallback(pError, []);
		}
	}

	/**
	 * Remove all persisted layout data.
	 *
	 * Default implementation removes the key from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageDelete(fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.removeItem(this._StorageKey);
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageDelete error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	// ── Initialization ────────────────────────────────────────────────────

	/**
	 * Load persisted layouts and merge them into _FlowData.SavedLayouts.
	 * Layouts already present in _FlowData (e.g., from setFlowData) are
	 * kept; persisted layouts with new hashes are appended.
	 *
	 * Call this after _FlowData is populated.
	 */
	loadPersistedLayouts()
	{
		this.storageRead((pError, pLayouts) =>
		{
			if (pError || !Array.isArray(pLayouts) || pLayouts.length === 0)
			{
				return;
			}

			if (!this._FlowView || !this._FlowView._FlowData)
			{
				return;
			}

			let tmpExisting = this._FlowView._FlowData.SavedLayouts;
			let tmpExistingHashes = {};
			for (let i = 0; i < tmpExisting.length; i++)
			{
				tmpExistingHashes[tmpExisting[i].Hash] = true;
			}

			let tmpAdded = 0;
			for (let i = 0; i < pLayouts.length; i++)
			{
				if (!tmpExistingHashes[pLayouts[i].Hash])
				{
					tmpExisting.push(pLayouts[i]);
					tmpAdded++;
				}
			}

			if (tmpAdded > 0)
			{
				this.log.trace(`PictProviderFlowLayouts loaded ${tmpAdded} persisted layout(s)`);
			}
		});
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Save the current node and panel positions as a named layout.
	 * @param {string} pName - The display name for this layout
	 * @returns {Object} The saved layout entry
	 */
	saveLayout(pName)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts saveLayout: no FlowView reference');
			return null;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayoutHash = `layout-${this.fable.getUUID()}`;
		let tmpNodePositions = {};
		let tmpPanelPositions = {};

		// Capture node positions and per-instance overrides (Title, Style)
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			tmpNodePositions[tmpNode.Hash] =
			{
				X: tmpNode.X,
				Y: tmpNode.Y,
				Width: tmpNode.Width,
				Height: tmpNode.Height,
				Title: tmpNode.Title
			};

			// Only include Style if it has been customized
			if (tmpNode.Style && Object.keys(tmpNode.Style).length > 0)
			{
				tmpNodePositions[tmpNode.Hash].Style = JSON.parse(JSON.stringify(tmpNode.Style));
			}
		}

		// Capture panel positions keyed by NodeHash (panels get new hashes on each open)
		for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
		{
			let tmpPanel = tmpFlowData.OpenPanels[i];
			tmpPanelPositions[tmpPanel.NodeHash] =
			{
				X: tmpPanel.X,
				Y: tmpPanel.Y,
				Width: tmpPanel.Width,
				Height: tmpPanel.Height
			};
		}

		let tmpLayout =
		{
			Hash: tmpLayoutHash,
			Name: pName || 'Untitled Layout',
			CreatedAt: new Date().toISOString(),
			NodePositions: tmpNodePositions,
			PanelPositions: tmpPanelPositions,
			ViewState:
			{
				PanX: tmpFlowData.ViewState.PanX,
				PanY: tmpFlowData.ViewState.PanY,
				Zoom: tmpFlowData.ViewState.Zoom
			}
		};

		tmpFlowData.SavedLayouts.push(tmpLayout);
		this._FlowView.marshalFromView();

		// Persist to storage
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after save: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutSaved', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts saved layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return tmpLayout;
	}

	/**
	 * Restore a saved layout by hash.
	 * Nodes present in the saved layout are placed at their saved positions.
	 * Nodes not in the saved layout are auto-laid-out to the right of the
	 * positioned nodes.
	 * @param {string} pLayoutHash - The hash of the layout to restore
	 * @returns {boolean} Whether the layout was restored
	 */
	restoreLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts restoreLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayout = tmpFlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (!tmpLayout)
		{
			this.log.warn(`PictProviderFlowLayouts restoreLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpMatchedNodes = [];
		let tmpUnmatchedNodes = [];

		// Apply saved positions to matched nodes; collect unmatched ones
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			let tmpSaved = tmpLayout.NodePositions[tmpNode.Hash];

			if (tmpSaved)
			{
				tmpNode.X = tmpSaved.X;
				tmpNode.Y = tmpSaved.Y;
				if (typeof tmpSaved.Width === 'number') tmpNode.Width = tmpSaved.Width;
				if (typeof tmpSaved.Height === 'number') tmpNode.Height = tmpSaved.Height;
				if (typeof tmpSaved.Title === 'string') tmpNode.Title = tmpSaved.Title;
				if (tmpSaved.Style && typeof tmpSaved.Style === 'object')
				{
					tmpNode.Style = JSON.parse(JSON.stringify(tmpSaved.Style));
				}
				tmpMatchedNodes.push(tmpNode);
			}
			else
			{
				tmpUnmatchedNodes.push(tmpNode);
			}
		}

		// Apply saved panel positions (keyed by NodeHash)
		if (tmpLayout.PanelPositions)
		{
			for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
			{
				let tmpPanel = tmpFlowData.OpenPanels[i];
				let tmpSavedPanel = tmpLayout.PanelPositions[tmpPanel.NodeHash];

				if (tmpSavedPanel)
				{
					tmpPanel.X = tmpSavedPanel.X;
					tmpPanel.Y = tmpSavedPanel.Y;
					if (typeof tmpSavedPanel.Width === 'number') tmpPanel.Width = tmpSavedPanel.Width;
					if (typeof tmpSavedPanel.Height === 'number') tmpPanel.Height = tmpSavedPanel.Height;
				}
			}
		}

		// Auto-layout unmatched nodes to the right of positioned nodes
		if (tmpUnmatchedNodes.length > 0 && this._FlowView._LayoutService)
		{
			this._FlowView._LayoutService.autoLayoutSubset(
				tmpUnmatchedNodes,
				tmpMatchedNodes,
				tmpFlowData.Connections
			);
		}

		// Restore view state (camera position)
		if (tmpLayout.ViewState)
		{
			if (typeof tmpLayout.ViewState.PanX === 'number')
			{
				tmpFlowData.ViewState.PanX = tmpLayout.ViewState.PanX;
			}
			if (typeof tmpLayout.ViewState.PanY === 'number')
			{
				tmpFlowData.ViewState.PanY = tmpLayout.ViewState.PanY;
			}
			if (typeof tmpLayout.ViewState.Zoom === 'number')
			{
				tmpFlowData.ViewState.Zoom = tmpLayout.ViewState.Zoom;
			}
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutRestored', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts restored layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return true;
	}

	/**
	 * Delete a saved layout by hash.
	 * @param {string} pLayoutHash - The hash of the layout to delete
	 * @returns {boolean} Whether the layout was deleted
	 */
	deleteLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts deleteLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpIndex = tmpFlowData.SavedLayouts.findIndex(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (tmpIndex < 0)
		{
			this.log.warn(`PictProviderFlowLayouts deleteLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpRemovedLayout = tmpFlowData.SavedLayouts.splice(tmpIndex, 1)[0];
		this._FlowView.marshalFromView();

		// Persist to storage (with the layout removed)
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after delete: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutDeleted', tmpRemovedLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts deleted layout '${tmpRemovedLayout.Name}' (${tmpRemovedLayout.Hash})`);

		return true;
	}

	/**
	 * Get the list of saved layouts.
	 * @returns {Array} Array of saved layout objects
	 */
	getLayouts()
	{
		if (!this._FlowView) return [];
		return this._FlowView._FlowData.SavedLayouts;
	}

	/**
	 * Get a specific saved layout by hash.
	 * @param {string} pLayoutHash
	 * @returns {Object|null}
	 */
	getLayout(pLayoutHash)
	{
		if (!this._FlowView) return null;
		return this._FlowView._FlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		) || null;
	}
}

module.exports = PictProviderFlowLayouts;

module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":177}],462:[function(require,module,exports){
arguments[4][222][0].apply(exports,arguments)
},{"dup":222,"pict-provider":177}],463:[function(require,module,exports){
arguments[4][223][0].apply(exports,arguments)
},{"dup":223,"fable-serviceproviderbase":59}],464:[function(require,module,exports){
arguments[4][224][0].apply(exports,arguments)
},{"dup":224,"fable-serviceproviderbase":59}],465:[function(require,module,exports){
arguments[4][225][0].apply(exports,arguments)
},{"dup":225,"fable-serviceproviderbase":59}],466:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-SVGHelpers
 *
 * Shared SVG element creation utility used by all flow components
 * that need to create SVG namespace elements (nodes, connections, tethers).
 */
class PictProviderFlowSVGHelpers extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowSVGHelpers';
	}

	/**
	 * Create an SVG namespace element.
	 *
	 * @param {string} pTagName - The SVG element tag name (e.g., 'path', 'circle', 'g', 'rect', 'text')
	 * @returns {SVGElement}
	 */
	createSVGElement(pTagName)
	{
		return document.createElementNS('http://www.w3.org/2000/svg', pTagName);
	}
}

module.exports = PictProviderFlowSVGHelpers;

},{"fable-serviceproviderbase":59}],467:[function(require,module,exports){
arguments[4][227][0].apply(exports,arguments)
},{"dup":227,"fable-serviceproviderbase":59}],468:[function(require,module,exports){
arguments[4][228][0].apply(exports,arguments)
},{"dup":228,"fable-serviceproviderbase":59}],469:[function(require,module,exports){
arguments[4][152][0].apply(exports,arguments)
},{"dup":152}],470:[function(require,module,exports){
arguments[4][153][0].apply(exports,arguments)
},{"dup":153}],471:[function(require,module,exports){
arguments[4][154][0].apply(exports,arguments)
},{"../layouts/Layout-Coerce.js":478,"dup":154}],472:[function(require,module,exports){
arguments[4][155][0].apply(exports,arguments)
},{"./Edge-PerimeterMath.js":475,"dup":155}],473:[function(require,module,exports){
arguments[4][156][0].apply(exports,arguments)
},{"./Edge-PerimeterMath.js":475,"dup":156}],474:[function(require,module,exports){
arguments[4][157][0].apply(exports,arguments)
},{"./Edge-PerimeterMath.js":475,"dup":157}],475:[function(require,module,exports){
arguments[4][158][0].apply(exports,arguments)
},{"dup":158}],476:[function(require,module,exports){
arguments[4][159][0].apply(exports,arguments)
},{"dup":159}],477:[function(require,module,exports){
arguments[4][160][0].apply(exports,arguments)
},{"./Layout-Coerce.js":478,"dup":160}],478:[function(require,module,exports){
arguments[4][161][0].apply(exports,arguments)
},{"dup":161}],479:[function(require,module,exports){
arguments[4][162][0].apply(exports,arguments)
},{"./Layout-Coerce.js":478,"dup":162}],480:[function(require,module,exports){
arguments[4][163][0].apply(exports,arguments)
},{"dup":163}],481:[function(require,module,exports){
arguments[4][164][0].apply(exports,arguments)
},{"./Layout-Coerce.js":478,"dup":164}],482:[function(require,module,exports){
arguments[4][165][0].apply(exports,arguments)
},{"./Layout-Coerce.js":478,"dup":165}],483:[function(require,module,exports){
arguments[4][166][0].apply(exports,arguments)
},{"./Layout-Coerce.js":478,"./Layout-Rank.js":484,"dup":166}],484:[function(require,module,exports){
arguments[4][167][0].apply(exports,arguments)
},{"dup":167}],485:[function(require,module,exports){
arguments[4][168][0].apply(exports,arguments)
},{"./Layout-Coerce.js":478,"./Layout-Rank.js":484,"dup":168}],486:[function(require,module,exports){
arguments[4][169][0].apply(exports,arguments)
},{"./Layout-Coerce.js":478,"dup":169}],487:[function(require,module,exports){
arguments[4][229][0].apply(exports,arguments)
},{"dup":229,"fable-serviceproviderbase":59}],488:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libPerimeterMath = require('../providers/edges/Edge-PerimeterMath.js');

// Chip (port-label badge) geometry — must mirror PortRenderer's badge
// dimensions exactly so hint paths land on the chip's actual outer
// edge instead of where we *guess* it might be.
const _CHIP_HEIGHT       = 12;
const _CHIP_PAD_H        = 5;
const _CHIP_EDGE_PAD     = 1;
const _CHIP_PORT_RADIUS  = 5;
const _CHIP_BORDER_WIDTH = 2;
const _CHIP_PER_CHAR_PX  = 5;

// Port-type → stroke color map. Mirrors the table PortRenderer uses for
// badge borders so the hint bezier matches its port's affinity color.
const PORT_TYPE_COLORS =
{
	'event-in':  'var(--theme-color-status-info, #3498db)',
	'event-out': 'var(--theme-color-status-success, #2ecc71)',
	'setting':   'var(--theme-color-status-warning, #e67e22)',
	'value':     'var(--theme-color-status-warning, #f1c40f)',
	'error':     'var(--theme-color-status-error, #e74c3c)'
};
const PORT_TYPE_DEFAULT_COLOR = 'var(--theme-color-border-default, #95a5a6)';

class PictServiceFlowConnectionRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowConnectionRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render a connection as an SVG path with hit area and optional handles.
	 * @param {Object} pConnection - The connection data
	 * @param {SVGGElement} pConnectionsLayer - The SVG group to append to
	 * @param {boolean} pIsSelected - Whether this connection is selected
	 */
	renderConnection(pConnection, pConnectionsLayer, pIsSelected)
	{
		if (!this._FlowView) return;

		let tmpSourcePos = this._FlowView.getPortPosition(pConnection.SourceNodeHash, pConnection.SourcePortHash);
		let tmpTargetPos = this._FlowView.getPortPosition(pConnection.TargetNodeHash, pConnection.TargetPortHash);

		// Let the active edge theme reshape the attachment points (e.g. a
		// "perimeter" theme that exits whichever side of the node faces the
		// other end). The static port positions are still computed above so
		// themes that don't override fall through unchanged.
		let tmpStaticSourcePos = tmpSourcePos;
		let tmpStaticTargetPos = tmpTargetPos;
		let tmpAttachOverride = this._resolveAttachmentsViaEdgeTheme(pConnection, tmpSourcePos, tmpTargetPos);
		if (tmpAttachOverride.source) tmpSourcePos = tmpAttachOverride.source;
		if (tmpAttachOverride.target) tmpTargetPos = tmpAttachOverride.target;

		// Look up the source port's PortType for connection coloring
		let tmpSourcePortType = null;
		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		if (tmpSourceNode && tmpSourceNode.Ports)
		{
			for (let i = 0; i < tmpSourceNode.Ports.length; i++)
			{
				if (tmpSourceNode.Ports[i].Hash === pConnection.SourcePortHash)
				{
					tmpSourcePortType = tmpSourceNode.Ports[i].PortType || null;
					break;
				}
			}
		}

		if (!tmpSourcePos || !tmpTargetPos) return;

		let tmpData = pConnection.Data || {};
		let tmpPath = this._generatePathViaEdgeTheme(pConnection, tmpSourcePos, tmpTargetPos, tmpData);

		// Apply theme noise post-processing to the path
		if (this._FlowView._ThemeProvider)
		{
			tmpPath = this._FlowView._ThemeProvider.processPathString(tmpPath, pConnection.Hash);
		}

		// Apply stroke-dasharray from theme's ConnectionConfig
		let tmpStrokeDashArray = null;
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.ConnectionConfig && tmpActiveTheme.ConnectionConfig.StrokeDashArray)
			{
				tmpStrokeDashArray = tmpActiveTheme.ConnectionConfig.StrokeDashArray;
			}
		}

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;

		// Build the port-type CSS class suffix for connection coloring
		let tmpConnTypeClass = tmpSourcePortType ? (' conn-type-' + tmpSourcePortType) : '';

		// Determine the arrowhead marker based on port type
		let tmpArrowMarkerId;
		if (pIsSelected)
		{
			tmpArrowMarkerId = 'flow-arrowhead-selected-' + tmpViewIdentifier;
		}
		else if (tmpSourcePortType)
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpSourcePortType + '-' + tmpViewIdentifier;
		}
		else
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpViewIdentifier;
		}

		// Hit area (wider invisible path for easier selection)
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		let tmpPathElement = null;
		if (tmpShapeProvider)
		{
			let tmpHitArea = tmpShapeProvider.createConnectionHitAreaElement(tmpPath, pConnection.Hash);
			pConnectionsLayer.appendChild(tmpHitArea);

			tmpPathElement = tmpShapeProvider.createConnectionPathElement(
				tmpPath, pConnection.Hash, pIsSelected, tmpViewIdentifier);
			if (tmpConnTypeClass)
			{
				tmpPathElement.setAttribute('class',
					(tmpPathElement.getAttribute('class') || '') + tmpConnTypeClass);
			}
			// Override the default arrowhead with the typed one
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');
			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}
			pConnectionsLayer.appendChild(tmpPathElement);
		}
		else
		{
			let tmpHitArea = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpHitArea.setAttribute('class', 'pict-flow-connection-hitarea');
			tmpHitArea.setAttribute('d', tmpPath);
			tmpHitArea.setAttribute('data-connection-hash', pConnection.Hash);
			tmpHitArea.setAttribute('data-element-type', 'connection-hitarea');
			pConnectionsLayer.appendChild(tmpHitArea);

			tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', `pict-flow-connection${tmpConnTypeClass} ${pIsSelected ? 'selected' : ''}`);
			tmpPathElement.setAttribute('d', tmpPath);
			tmpPathElement.setAttribute('data-connection-hash', pConnection.Hash);
			tmpPathElement.setAttribute('data-element-type', 'connection');
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');

			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}

			pConnectionsLayer.appendChild(tmpPathElement);
		}

		// Per-connection host styling (a moodboard styles its own edges): stroke color / width / dash and
		// the end markers, applied only when the connection's Data carries them so default (workflow)
		// connections are untouched. A label, when set, is drawn at the midpoint.
		let tmpHasMarkers = (typeof tmpData.SourceMarker !== 'undefined' || typeof tmpData.TargetMarker !== 'undefined');
		this._applyConnectionStyle(tmpPathElement, tmpData, tmpViewIdentifier);
		this._renderConnectionLabel(pConnection, tmpData, pConnectionsLayer, tmpSourcePos, tmpTargetPos);

		// Render the colored endpoint dot at each end of the connection
		// into the dedicated endpoints layer (sits *above* the nodes
		// layer so the dot doesn't get hidden under the card chrome
		// when an edge theme places it on the node's perimeter).
		// PortRenderer suppresses its own circle for any port that
		// participates in a connection — we own the dot here. Skipped when the
		// connection supplies its own end markers (those own the endpoints).
		let tmpEndpointsLayer = this._FlowView._EndpointsLayer || pConnectionsLayer;
		if (!tmpHasMarkers)
		{
			this._renderEndpointDots(pConnection, tmpEndpointsLayer, tmpSourcePos, tmpTargetPos);
		}

		// When the resolved attachment differs from the card-defined port
		// position (e.g. a Perimeter theme moved the dot to the edge of the
		// card), paint a hidden hint bezier connecting the badge to the
		// dot. CSS reveals it on hover so users can see "this 'In' chip
		// corresponds to that dot up at the top".
		if (this._FlowView._PortHintsLayer)
		{
			this._renderPortHints(pConnection, this._FlowView._PortHintsLayer,
				tmpStaticSourcePos, tmpSourcePos, tmpStaticTargetPos, tmpTargetPos);
		}

		// Render drag handles when selected
		if (pIsSelected)
		{
			this._renderHandles(pConnection, pConnectionsLayer, tmpSourcePos, tmpTargetPos);
		}
	}

	// Apply per-connection host styling to the path element from the connection's Data: StrokeColor,
	// StrokeWidth, StrokeStyle ('solid' | 'dashed' | 'dotted') and SourceMarker / TargetMarker
	// ('none' | 'arrow' | 'dot' | 'square'). Each is applied only when present, so connections that do
	// not carry these keys render exactly as before.
	_applyConnectionStyle(pPathElement, pData, pViewIdentifier)
	{
		if (!pPathElement || !pData || !pPathElement.style) { return; }
		// Stroke color / width / dash go through inline style, NOT SVG presentation attributes: the
		// .pict-flow-connection CSS rule sets stroke + stroke-width, and a stylesheet rule beats a
		// presentation attribute, so an attribute would be silently ignored. Inline style outranks the
		// stylesheet, so the per-connection appearance wins.
		if (pData.StrokeColor) { pPathElement.style.stroke = pData.StrokeColor; }
		if (pData.StrokeWidth) { pPathElement.style.strokeWidth = String(pData.StrokeWidth); }
		if (pData.StrokeStyle)
		{
			pPathElement.style.strokeDasharray = (pData.StrokeStyle === 'dashed') ? '7,5' : ((pData.StrokeStyle === 'dotted') ? '1.5,4' : 'none');
		}
		// Markers are not styled by CSS, so attributes are correct (they reference the marker defs).
		if (typeof pData.TargetMarker !== 'undefined')
		{
			let tmpEnd = this._connectionMarkerId(pData.TargetMarker, 'end', pViewIdentifier);
			if (tmpEnd) { pPathElement.setAttribute('marker-end', 'url(#' + tmpEnd + ')'); }
			else { pPathElement.removeAttribute('marker-end'); }
		}
		if (typeof pData.SourceMarker !== 'undefined')
		{
			let tmpStart = this._connectionMarkerId(pData.SourceMarker, 'start', pViewIdentifier);
			if (tmpStart) { pPathElement.setAttribute('marker-start', 'url(#' + tmpStart + ')'); }
			else { pPathElement.removeAttribute('marker-start'); }
		}
	}

	// Resolve a marker name + end ('start' | 'end') to its SVG marker def id; null for 'none'/unknown.
	_connectionMarkerId(pMarker, pEnd, pViewIdentifier)
	{
		if (pMarker === 'arrow') { return 'flow-marker-arrow-' + pEnd + '-' + pViewIdentifier; }
		if (pMarker === 'dot') { return 'flow-marker-dot-' + pViewIdentifier; }
		if (pMarker === 'square') { return 'flow-marker-square-' + pViewIdentifier; }
		return null;
	}

	// Draw a connection's label (Data.Label) at the midpoint of its endpoints. A white halo (paint-order
	// stroke, set in CSS) keeps it legible over the line. Skipped when there is no label.
	_renderConnectionLabel(pConnection, pData, pLayer, pSourcePos, pTargetPos)
	{
		// Render when a Label key is present (even ''), so a host that edits the label in place has an
		// element to update; a connection with no Label key (a default workflow edge) gets none.
		if (!pData || typeof pData.Label === 'undefined' || !pSourcePos || !pTargetPos) { return; }
		if (!this._FlowView._SVGHelperProvider) { return; }
		let tmpText = this._FlowView._SVGHelperProvider.createSVGElement('text');
		tmpText.setAttribute('class', 'pict-flow-connection-label');
		tmpText.setAttribute('x', String((pSourcePos.x + pTargetPos.x) / 2));
		tmpText.setAttribute('y', String((pSourcePos.y + pTargetPos.y) / 2));
		tmpText.setAttribute('text-anchor', 'middle');
		tmpText.setAttribute('dominant-baseline', 'middle');
		tmpText.setAttribute('data-connection-hash', pConnection.Hash);
		tmpText.textContent = pData.Label;
		pLayer.appendChild(tmpText);
	}

	/**
	 * Append the colored endpoint dots for both ends of a connection
	 * onto the destination layer (absolute coords). Reuses
	 * `ConnectorShapesProvider.createPortElement` so the styling
	 * matches the static port circle exactly.
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer - the endpoints layer (or fallback)
	 * @param {{x: number, y: number}} pSourcePos
	 * @param {{x: number, y: number}} pTargetPos
	 */
	_renderEndpointDots(pConnection, pLayer, pSourcePos, pTargetPos)
	{
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (!tmpShapeProvider) return;

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		if (tmpSourcePort && pSourcePos)
		{
			let tmpDot = tmpShapeProvider.createPortElement(tmpSourcePort, pSourcePos, pConnection.SourceNodeHash);
			tmpDot.setAttribute('data-connection-hash', pConnection.Hash);
			tmpDot.setAttribute('data-connection-end', 'source');
			pLayer.appendChild(tmpDot);
		}
		if (tmpTargetPort && pTargetPos)
		{
			let tmpDot = tmpShapeProvider.createPortElement(tmpTargetPort, pTargetPos, pConnection.TargetNodeHash);
			tmpDot.setAttribute('data-connection-hash', pConnection.Hash);
			tmpDot.setAttribute('data-connection-end', 'target');
			pLayer.appendChild(tmpDot);
		}
	}

	/**
	 * Render the per-end "where did the dot go" hint paths. Drawn into
	 * the port-hints layer (above nodes) but kept opacity:0 by CSS;
	 * PortRenderer/NodeView toggle a `data-active` attribute on hover.
	 *
	 * Skipped when the resolved attachment matches the static port
	 * position (no theme rerouting → no need for a hint).
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer
	 * @param {{x: number, y: number, side?: string}} pStaticSrc - card-defined port position
	 * @param {{x: number, y: number, side?: string}} pSrc - resolved attachment
	 * @param {{x: number, y: number, side?: string}} pStaticTgt
	 * @param {{x: number, y: number, side?: string}} pTgt
	 */
	_renderPortHints(pConnection, pLayer, pStaticSrc, pSrc, pStaticTgt, pTgt)
	{
		let tmpPositionsDiffer = function (pA, pB)
		{
			if (!pA || !pB) return false;
			return (Math.abs(pA.x - pB.x) > 0.5) || (Math.abs(pA.y - pB.y) > 0.5);
		};

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		// Hints are colored by the *other* end's node identity — looking
		// at a hub with 8 hints fanning out, each hint is the color of
		// the spoke that connection terminates at, so you can tell at a
		// glance which line goes where without tracing it. (Mirrors the
		// Ultravisor card-category color model: gray=flow-control,
		// purple=core, orange=data, teal=llm, etc.)
		// Anchor each hint at the chip's outer edge facing the dot
		// (not the port's static position, which sits on the node's
		// edge — visually inside the chip's stripe). The hint ends at
		// the dot but its tail "points at" the chip's center.
		if (pStaticSrc && tmpPositionsDiffer(pStaticSrc, pSrc))
		{
			let tmpChipExit = this._chipEdgeAimingAt(tmpSourcePort, pStaticSrc, pSrc);
			pLayer.appendChild(this._buildPortHintPath(
				tmpChipExit, pSrc,
				pConnection.SourceNodeHash, pConnection.SourcePortHash, pConnection.Hash, 'source',
				this._hintColor(tmpSourcePort, tmpTargetNode)));
		}
		if (pStaticTgt && tmpPositionsDiffer(pStaticTgt, pTgt))
		{
			let tmpChipExit = this._chipEdgeAimingAt(tmpTargetPort, pStaticTgt, pTgt);
			pLayer.appendChild(this._buildPortHintPath(
				tmpChipExit, pTgt,
				pConnection.TargetNodeHash, pConnection.TargetPortHash, pConnection.Hash, 'target',
				this._hintColor(tmpTargetPort, tmpSourceNode)));
		}
	}

	/**
	 * Compute the chip (port-label badge) bounding box for a given
	 * port. The chip is a small rectangle that lives just inside the
	 * node's outer edge, anchored to the port's static position. We
	 * mirror PortRenderer's badge geometry exactly so the hint path
	 * lands on real chip-edge pixels.
	 *
	 * Returns null when we don't have enough info (no label or
	 * unknown side) — caller should fall back to the static position.
	 *
	 * @param {Object|null} pPort
	 * @param {{x: number, y: number, side?: string}} pStaticPos - the
	 *        port's nominal position (returned by getPortPosition); the
	 *        chip extends *inward* from here.
	 * @returns {{X: number, Y: number, Width: number, Height: number}|null}
	 */
	_chipBoundsFor(pPort, pStaticPos)
	{
		if (!pPort || !pStaticPos) return null;
		let tmpSide = pStaticPos.side || pPort.Side || (pPort.Direction === 'input' ? 'left' : 'right');
		let tmpLabel = pPort.Label || '';
		// PortRenderer skips badge rendering entirely when there is no
		// label, so there's nothing for the hint to anchor against.
		if (tmpLabel === '') return null;

		let tmpTextPx = tmpLabel.length * _CHIP_PER_CHAR_PX;
		let tmpWidth = _CHIP_PORT_RADIUS + _CHIP_PAD_H + tmpTextPx + _CHIP_PAD_H + _CHIP_BORDER_WIDTH;
		let tmpHeight = _CHIP_HEIGHT;

		// Chip center sits halfway along the line from the port's static
		// position toward the inside of the node, offset by half the
		// chip's extent in that direction (plus the 1px edge padding
		// PortRenderer leaves between the chip and the node edge).
		let tmpCx, tmpCy;
		if (tmpSide.indexOf('left') === 0)
		{
			tmpCx = pStaticPos.x + tmpWidth / 2 + _CHIP_EDGE_PAD;
			tmpCy = pStaticPos.y;
		}
		else if (tmpSide.indexOf('right') === 0)
		{
			tmpCx = pStaticPos.x - tmpWidth / 2 - _CHIP_EDGE_PAD;
			tmpCy = pStaticPos.y;
		}
		else if (tmpSide.indexOf('top') === 0)
		{
			tmpCx = pStaticPos.x;
			tmpCy = pStaticPos.y + tmpHeight / 2 + _CHIP_EDGE_PAD;
		}
		else if (tmpSide.indexOf('bottom') === 0)
		{
			tmpCx = pStaticPos.x;
			tmpCy = pStaticPos.y - tmpHeight / 2 - _CHIP_EDGE_PAD;
		}
		else
		{
			return null;
		}

		return { X: tmpCx - tmpWidth / 2, Y: tmpCy - tmpHeight / 2, Width: tmpWidth, Height: tmpHeight };
	}

	/**
	 * Resolve the point on the chip's outer perimeter where a line
	 * from the chip's center toward the dot would exit the chip. Used
	 * as the hint's start point so the line visually emerges from the
	 * chip's edge facing the dot, aimed at the chip's center.
	 *
	 * Falls back to the static port position when chip geometry can't
	 * be computed (no label, unknown side).
	 *
	 * @param {Object|null} pPort
	 * @param {{x: number, y: number, side?: string}} pStaticPos
	 * @param {{x: number, y: number}} pDotPos
	 * @returns {{x: number, y: number}}
	 */
	_chipEdgeAimingAt(pPort, pStaticPos, pDotPos)
	{
		let tmpBounds = this._chipBoundsFor(pPort, pStaticPos);
		if (!tmpBounds) return pStaticPos;
		let tmpExit = libPerimeterMath.resolvePerimeterAttachment({
			Node: tmpBounds,
			OtherDefaultPosition: pDotPos
		});
		if (!tmpExit) return pStaticPos;
		return tmpExit;
	}

	/**
	 * Resolve a node's identity color. Looks at the inline node fields
	 * first (per-node overrides win), then the registered node-type
	 * config from the NodeTypeProvider. Returns null when the node has
	 * no opinion — caller should fall back to port-type color.
	 *
	 * @param {Object|null} pNode
	 * @returns {string|null}
	 */
	_resolveNodeIdentityColor(pNode)
	{
		if (!pNode) return null;
		if (pNode.TitleBarColor) return pNode.TitleBarColor;
		if (pNode.BodyStyle && pNode.BodyStyle.stroke) return pNode.BodyStyle.stroke;
		let tmpProvider = this._FlowView ? this._FlowView._NodeTypeProvider : null;
		if (tmpProvider && typeof tmpProvider.getNodeType === 'function' && pNode.Type)
		{
			let tmpType = tmpProvider.getNodeType(pNode.Type);
			if (tmpType)
			{
				if (tmpType.TitleBarColor) return tmpType.TitleBarColor;
				if (tmpType.BodyStyle && tmpType.BodyStyle.stroke) return tmpType.BodyStyle.stroke;
			}
		}
		return null;
	}

	/**
	 * Resolve the hint stroke color. Priority chain:
	 *   1. The OTHER end's node identity color (TitleBarColor /
	 *      BodyStyle.stroke / NodeTypeConfig color) — the strongest
	 *      signal: "this hint terminates at *that* card".
	 *   2. This end's PortType color — semantic-role fallback.
	 *   3. Direction-based default that matches the visible dot color.
	 *   4. Neutral gray.
	 *
	 * @param {Object|null} pPort - this end's port
	 * @param {Object|null} pOtherNode - the node at the other end
	 * @returns {string}
	 */
	_hintColor(pPort, pOtherNode)
	{
		let tmpOtherColor = this._resolveNodeIdentityColor(pOtherNode);
		if (tmpOtherColor) return tmpOtherColor;
		if (pPort && pPort.PortType && PORT_TYPE_COLORS[pPort.PortType])
		{
			return PORT_TYPE_COLORS[pPort.PortType];
		}
		if (pPort && pPort.Direction === 'input')  return PORT_TYPE_COLORS['event-in'];
		if (pPort && pPort.Direction === 'output') return PORT_TYPE_COLORS['event-out'];
		return PORT_TYPE_DEFAULT_COLOR;
	}

	/**
	 * Build a single hint-path SVG element: a soft S-curve from the
	 * card-defined port position to the resolved attachment position.
	 * Tagged with port + node + connection hashes so hover handlers can
	 * find the right hint by attribute.
	 *
	 * @param {{x: number, y: number}} pStart - badge / chip position
	 * @param {{x: number, y: number}} pEnd - actual dot position
	 * @returns {SVGPathElement}
	 */
	_buildPortHintPath(pStart, pEnd, pNodeHash, pPortHash, pConnectionHash, pEndLabel, pStrokeColor)
	{
		let tmpEl = this._FlowView._SVGHelperProvider.createSVGElement('path');

		// Soft S-curve: control points pulled along the perpendicular bisector
		let tmpDX = pEnd.x - pStart.x;
		let tmpDY = pEnd.y - pStart.y;
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
		let tmpBend = Math.min(60, tmpDist * 0.35);
		// Perpendicular unit vector
		let tmpPX = (tmpDist > 0) ? -tmpDY / tmpDist : 0;
		let tmpPY = (tmpDist > 0) ?  tmpDX / tmpDist : 0;
		let tmpCp1X = pStart.x + tmpDX * 0.35 + tmpPX * tmpBend * 0.3;
		let tmpCp1Y = pStart.y + tmpDY * 0.35 + tmpPY * tmpBend * 0.3;
		let tmpCp2X = pStart.x + tmpDX * 0.65 + tmpPX * tmpBend * 0.3;
		let tmpCp2Y = pStart.y + tmpDY * 0.65 + tmpPY * tmpBend * 0.3;
		let tmpD = `M ${pStart.x} ${pStart.y} C ${tmpCp1X} ${tmpCp1Y} ${tmpCp2X} ${tmpCp2Y} ${pEnd.x} ${pEnd.y}`;

		tmpEl.setAttribute('class', 'pict-flow-port-hint');
		tmpEl.setAttribute('d', tmpD);
		tmpEl.setAttribute('data-node-hash', pNodeHash);
		tmpEl.setAttribute('data-port-hash', pPortHash);
		tmpEl.setAttribute('data-connection-hash', pConnectionHash);
		tmpEl.setAttribute('data-connection-end', pEndLabel);
		// Affinity color from port type (matches the badge border color).
		// Inline so PortRenderer's color map stays the single source of
		// truth without dragging CSS variables around per port type.
		if (pStrokeColor)
		{
			tmpEl.setAttribute('stroke', pStrokeColor);
		}
		return tmpEl;
	}

	/**
	 * Compute the departure and approach points plus control points
	 * for a direction-aware bezier between two ports.
	 *
	 * This extracts the intermediate geometry from _generateDirectionalPath
	 * so it can be reused by _getAutoMidpoint and _generateBezierPathWithHandle.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{departX, departY, approachX, approachY, cp1X, cp1Y, cp2X, cp2Y, startDir, endDir}}
	 */
	_computeDirectionalGeometry(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.computeDirectionalGeometry(pStart, pEnd);
	}

	/**
	 * Generate a direction-aware path between two ports.
	 *
	 * The path is composed of three segments:
	 *   1. A short straight "departure" segment leaving the source port
	 *      in its outward direction.
	 *   2. A cubic bezier curve connecting the departure point to an
	 *      "approach" point near the target port.
	 *   3. A short straight "approach" segment arriving at the target
	 *      port aligned with its inward direction.
	 *
	 * @param {{x: number, y: number, side: string}} pStart - Start port position + side
	 * @param {{x: number, y: number, side: string}} pEnd   - End port position + side
	 * @returns {string} SVG path d attribute
	 */
	_generateDirectionalPath(pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Dispatch to an edge theme to generate the path string. Falls back
	 * to the renderer's built-in bezier / orthogonal helpers when no
	 * edge-theme registry is available (older host integrations) or
	 * the resolved theme errors out.
	 *
	 * @param {Object} pConnection
	 * @param {{x: number, y: number, side?: string}} pSourcePos
	 * @param {{x: number, y: number, side?: string}} pTargetPos
	 * @param {Object} pData - connection data (LineMode, custom handles, etc.)
	 * @returns {string} SVG path 'd' attribute
	 */
	_generatePathViaEdgeTheme(pConnection, pSourcePos, pTargetPos, pData)
	{
		let tmpLayoutService = this._FlowView ? this._FlowView._LayoutService : null;
		let tmpTheme = (tmpLayoutService && typeof tmpLayoutService.resolveActiveEdgeTheme === 'function')
			? tmpLayoutService.resolveActiveEdgeTheme(pConnection)
			: null;

		if (!tmpTheme || typeof tmpTheme.GeneratePath !== 'function')
		{
			return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
		}

		let tmpContext =
		{
			Source: pSourcePos,
			Target: pTargetPos,
			Connection: pConnection,
			AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
			AllConnections: this._FlowView._FlowData ? this._FlowView._FlowData.Connections : [],
			FlowView: this._FlowView,
			Helpers: this._buildEdgeThemeHelpers(),
			Parameters: tmpLayoutService.getMergedEdgeThemeParameters(
				tmpTheme.Name,
				(this._FlowView._FlowData && this._FlowView._FlowData.EdgeThemeParameters) || {}
			)
		};

		try
		{
			let tmpPath = tmpTheme.GeneratePath(tmpContext);
			if (typeof tmpPath !== 'string' || tmpPath === '')
			{
				return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
			}
			return tmpPath;
		}
		catch (pError)
		{
			this._FlowView.log.warn(`PictServiceFlowConnectionRenderer edge theme '${tmpTheme.Name}' threw: ${pError.message}`);
			return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
		}
	}

	/**
	 * Resolve per-end attachment overrides via the active edge theme's
	 * optional `ResolveAttachment(context)` hook. The theme can return
	 * `{ x, y, side }` for either end (or null to fall through). Used by
	 * themes like Perimeter that route through the node's bounding box
	 * rather than the static port position.
	 *
	 * @param {Object} pConnection
	 * @param {{x: number, y: number, side?: string}} pSourcePos - default port position
	 * @param {{x: number, y: number, side?: string}} pTargetPos - default port position
	 * @returns {{source: ?Object, target: ?Object}}
	 */
	_resolveAttachmentsViaEdgeTheme(pConnection, pSourcePos, pTargetPos)
	{
		let tmpEmpty = { source: null, target: null };
		let tmpLayoutService = this._FlowView ? this._FlowView._LayoutService : null;
		let tmpTheme = (tmpLayoutService && typeof tmpLayoutService.resolveActiveEdgeTheme === 'function')
			? tmpLayoutService.resolveActiveEdgeTheme(pConnection)
			: null;
		if (!tmpTheme || typeof tmpTheme.ResolveAttachment !== 'function') return tmpEmpty;

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		let tmpParams = tmpLayoutService.getMergedEdgeThemeParameters(
			tmpTheme.Name,
			(this._FlowView._FlowData && this._FlowView._FlowData.EdgeThemeParameters) || {}
		);

		let tmpSrc = null, tmpTgt = null;
		try
		{
			tmpSrc = tmpTheme.ResolveAttachment({
				Node: tmpSourceNode, Port: tmpSourcePort,
				DefaultPosition: pSourcePos,
				Connection: pConnection, IsSource: true,
				OtherNode: tmpTargetNode, OtherPort: tmpTargetPort,
				OtherDefaultPosition: pTargetPos,
				AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
				FlowView: this._FlowView,
				Parameters: tmpParams
			});
			tmpTgt = tmpTheme.ResolveAttachment({
				Node: tmpTargetNode, Port: tmpTargetPort,
				DefaultPosition: pTargetPos,
				Connection: pConnection, IsSource: false,
				OtherNode: tmpSourceNode, OtherPort: tmpSourcePort,
				OtherDefaultPosition: pSourcePos,
				AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
				FlowView: this._FlowView,
				Parameters: tmpParams
			});
		}
		catch (pError)
		{
			this._FlowView.log.warn(`PictServiceFlowConnectionRenderer edge theme '${tmpTheme.Name}' ResolveAttachment threw: ${pError.message}`);
			return tmpEmpty;
		}

		return { source: tmpSrc || null, target: tmpTgt || null };
	}

	/**
	 * Find a port by hash on a node. Returns null if missing.
	 * @param {Object} pNode
	 * @param {string} pPortHash
	 * @returns {Object|null}
	 */
	_findPort(pNode, pPortHash)
	{
		if (!pNode || !Array.isArray(pNode.Ports)) return null;
		for (let i = 0; i < pNode.Ports.length; i++)
		{
			if (pNode.Ports[i].Hash === pPortHash) return pNode.Ports[i];
		}
		return null;
	}

	/**
	 * Path-generation helpers exposed to edge themes via the GeneratePath
	 * context object. Themes can compose these to derive their own routing.
	 *
	 * @returns {Object}
	 */
	_buildEdgeThemeHelpers()
	{
		let tmpRenderer = this;
		return {
			generateBezier: function (pStart, pEnd)
			{
				return tmpRenderer._generateDirectionalPath(pStart, pEnd);
			},
			generateMultiBezier: function (pStart, pEnd, pHandles)
			{
				return tmpRenderer._generateMultiHandleBezierPath(pStart, pEnd, pHandles);
			},
			generateOrthogonal: function (pStart, pEnd, pCorners, pMidOffset)
			{
				return tmpRenderer._generateOrthogonalPath(pStart, pEnd, pCorners || null, pMidOffset || 0);
			},
			getBezierHandles: function (pData)
			{
				return tmpRenderer._getBezierHandles(pData);
			}
		};
	}

	/**
	 * Built-in fallback when no edge theme is registered. Mirrors the
	 * pre-edge-theme dispatch (LineMode → bezier or orthogonal).
	 *
	 * @param {{x: number, y: number, side?: string}} pSourcePos
	 * @param {{x: number, y: number, side?: string}} pTargetPos
	 * @param {Object} pData
	 * @returns {string}
	 */
	_builtInPathFallback(pSourcePos, pTargetPos, pData)
	{
		let tmpData = pData || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpCorners = null;
			if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
			{
				tmpCorners =
				{
					corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
					corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
				};
			}
			return this._generateOrthogonalPath(pSourcePos, pTargetPos, tmpCorners, tmpData.OrthoMidOffset || 0);
		}

		let tmpHandles = this._getBezierHandles(tmpData);
		if (tmpHandles.length > 0)
		{
			return this._generateMultiHandleBezierPath(pSourcePos, pTargetPos, tmpHandles);
		}
		return this._generateDirectionalPath(pSourcePos, pTargetPos);
	}

	/**
	 * Get the bezier handles array from connection data, with backward
	 * compatibility for the legacy BezierHandleX/Y single-handle format.
	 *
	 * @param {Object} pData - Connection.Data
	 * @returns {Array<{x: number, y: number}>} Ordered handle waypoints (may be empty)
	 */
	_getBezierHandles(pData)
	{
		if (!pData || !pData.HandleCustomized)
		{
			return [];
		}

		// New multi-handle format
		if (Array.isArray(pData.BezierHandles) && pData.BezierHandles.length > 0)
		{
			return pData.BezierHandles;
		}

		// Legacy single-handle format
		if (pData.BezierHandleX != null && pData.BezierHandleY != null)
		{
			return [{ x: pData.BezierHandleX, y: pData.BezierHandleY }];
		}

		return [];
	}

	/**
	 * Generate a multi-handle bezier path between two ports.
	 * Delegates to PathGenerator.buildMultiBezierPathString for the
	 * actual SVG path assembly with Catmull-Rom tangent continuity.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Array<{x: number, y: number}>} pHandles - Ordered waypoints
	 * @returns {string} SVG path d attribute
	 */
	_generateMultiHandleBezierPath(pStart, pEnd, pHandles)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildMultiBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			pHandles,
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y },
			tmpGeo.startDir,
			tmpGeo.endDir
		);
	}

	/**
	 * Find which segment of the multi-handle bezier the given click point
	 * is closest to, returning the index at which a new handle should be
	 * inserted into the BezierHandles array.
	 *
	 * Segments are: depart→handle[0], handle[0]→handle[1], ..., handle[N-1]→approach.
	 * Returns 0 for before handle[0], 1 for between handle[0] and handle[1], etc.
	 *
	 * @param {Array<{x: number, y: number}>} pHandles - Current handles
	 * @param {{x: number, y: number}} pClickPoint - Where the user right-clicked
	 * @param {{x: number, y: number, side: string}} pStart - Source port position
	 * @param {{x: number, y: number, side: string}} pEnd - Target port position
	 * @returns {number} Insertion index
	 */
	computeInsertionIndex(pHandles, pClickPoint, pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		// Build the waypoint chain: depart, handle[0..N-1], approach
		let tmpWaypoints = [{ x: tmpGeo.departX, y: tmpGeo.departY }];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push({ x: tmpGeo.approachX, y: tmpGeo.approachY });

		let tmpBestDist = Infinity;
		let tmpBestIndex = 0;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpDist = this._distanceToSegment(
				pClickPoint.x, pClickPoint.y,
				tmpWaypoints[i].x, tmpWaypoints[i].y,
				tmpWaypoints[i + 1].x, tmpWaypoints[i + 1].y
			);

			if (tmpDist < tmpBestDist)
			{
				tmpBestDist = tmpDist;
				tmpBestIndex = i;
			}
		}

		return tmpBestIndex;
	}

	/**
	 * Distance from point (px,py) to line segment (ax,ay)-(bx,by).
	 */
	_distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		return this._FlowView._PathGenerator.distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY);
	}

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between two ports.
	 * Evaluates the cubic bezier at t=0.5.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.getAutoMidpoint(pStart, pEnd);
	}

	/**
	 * Generate an orthogonal (90-degree angles only) path between two ports.
	 *
	 * Path format: M start L depart L corner1 L corner2 L approach L end
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object|null} pCorners - { corner1: {x,y}, corner2: {x,y} } or null for auto
	 * @param {number} pMidOffset - Offset for the auto-calculated corridor position
	 * @returns {string} SVG path d attribute
	 */
	_generateOrthogonalPath(pStart, pEnd, pCorners, pMidOffset)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		let tmpCorner1, tmpCorner2;

		if (pCorners && pCorners.corner1 && pCorners.corner2)
		{
			tmpCorner1 = pCorners.corner1;
			tmpCorner2 = pCorners.corner2;
		}
		else
		{
			let tmpAutoCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
				tmpDA.departX, tmpDA.departY,
				tmpDA.approachX, tmpDA.approachY,
				tmpDA.fromDir, tmpDA.toDir,
				pMidOffset || 0
			);
			tmpCorner1 = tmpAutoCorners.corner1;
			tmpCorner2 = tmpAutoCorners.corner2;
		}

		return this._FlowView._PathGenerator.buildOrthogonalPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpDA.departX, y: tmpDA.departY },
			tmpCorner1,
			tmpCorner2,
			{ x: tmpDA.approachX, y: tmpDA.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Get the full orthogonal geometry for a connection (for handle positioning).
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object} pData - Connection.Data
	 * @returns {{corner1: {x,y}, corner2: {x,y}, midpoint: {x,y}}}
	 */
	getOrthogonalGeometry(pStart, pEnd, pData)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		if (pData && pData.HandleCustomized && pData.OrthoCorner1X != null)
		{
			let tmpCorner1 = { x: pData.OrthoCorner1X, y: pData.OrthoCorner1Y };
			let tmpCorner2 = { x: pData.OrthoCorner2X, y: pData.OrthoCorner2Y };
			let tmpMidpoint =
			{
				x: (tmpCorner1.x + tmpCorner2.x) / 2,
				y: (tmpCorner1.y + tmpCorner2.y) / 2
			};
			return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
		}

		return this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
			tmpDA.departX, tmpDA.departY,
			tmpDA.approachX, tmpDA.approachY,
			tmpDA.fromDir, tmpDA.toDir,
			(pData && pData.OrthoMidOffset) || 0
		);
	}

	/**
	 * Render drag handles for the selected connection.
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer
	 * @param {{x, y, side}} pStart - Source port position
	 * @param {{x, y, side}} pEnd   - Target port position
	 */
	_renderHandles(pConnection, pLayer, pStart, pEnd)
	{
		let tmpData = pConnection.Data || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpGeometry = this.getOrthogonalGeometry(pStart, pEnd, tmpData);

			// Corner 1 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner1',
				tmpGeometry.corner1.x, tmpGeometry.corner1.y, 'pict-flow-connection-handle');

			// Midpoint handle (between corners)
			this._createHandle(pLayer, pConnection.Hash, 'ortho-midpoint',
				tmpGeometry.midpoint.x, tmpGeometry.midpoint.y, 'pict-flow-connection-handle-midpoint');

			// Corner 2 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner2',
				tmpGeometry.corner2.x, tmpGeometry.corner2.y, 'pict-flow-connection-handle');
		}
		else
		{
			// Bezier handles — show one handle per waypoint, or a
			// single auto-midpoint when no custom handles exist.
			let tmpHandles = this._getBezierHandles(tmpData);

			if (tmpHandles.length > 0)
			{
				for (let i = 0; i < tmpHandles.length; i++)
				{
					this._createHandle(pLayer, pConnection.Hash,
						'bezier-handle-' + i,
						tmpHandles[i].x, tmpHandles[i].y,
						'pict-flow-connection-handle');
				}
			}
			else
			{
				let tmpMidpoint = this.getAutoMidpoint(pStart, pEnd);
				this._createHandle(pLayer, pConnection.Hash, 'bezier-midpoint',
					tmpMidpoint.x, tmpMidpoint.y, 'pict-flow-connection-handle');
			}
		}
	}

	/**
	 * Create a single SVG circle handle element.
	 *
	 * @param {SVGGElement} pLayer
	 * @param {string} pConnectionHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pClassName
	 */
	_createHandle(pLayer, pConnectionHash, pHandleType, pX, pY, pClassName)
	{
		if (!this._FlowView._ConnectorShapesProvider) return;

		let tmpShapeKey = (pClassName === 'pict-flow-connection-handle-midpoint')
			? 'connection-handle-midpoint' : 'connection-handle';

		this._FlowView._ConnectorShapesProvider.createFullHandle(
			pLayer, pConnectionHash, pHandleType, pX, pY,
			tmpShapeKey, 'connection-handle', 'data-connection-hash');
	}

	/**
	 * Legacy bezier path for drag connections where we don't have side info.
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string}
	 */
	_generateBezierPath(pStart, pEnd)
	{
		// During drag operations we may not have side info; default to right->left
		let tmpStart = { x: pStart.x, y: pStart.y, side: pStart.side || 'right' };
		let tmpEnd   = { x: pEnd.x,   y: pEnd.y,   side: pEnd.side   || 'left' };
		return this._generateDirectionalPath(tmpStart, tmpEnd);
	}

	/**
	 * Render a temporary drag connection line (used during connection creation)
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {SVGGElement} pLayer - The layer to render into
	 * @param {string} [pStartSide] - The side the source port is on
	 * @returns {SVGPathElement} The created path element
	 */
	renderDragConnection(pStartX, pStartY, pEndX, pEndY, pLayer, pStartSide)
	{
		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		let tmpPathElement;

		if (tmpShapeProvider)
		{
			tmpPathElement = tmpShapeProvider.createDragConnectionElement(tmpPath);
		}
		else
		{
			tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', 'pict-flow-drag-connection');
			tmpPathElement.setAttribute('d', tmpPath);
		}

		pLayer.appendChild(tmpPathElement);

		return tmpPathElement;
	}

	/**
	 * Update a drag connection path
	 * @param {SVGPathElement} pPathElement
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {string} [pStartSide] - The side the source port is on
	 */
	updateDragConnection(pPathElement, pStartX, pStartY, pEndX, pEndY, pStartSide)
	{
		if (!pPathElement) return;

		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		pPathElement.setAttribute('d', tmpPath);
	}
}

module.exports = PictServiceFlowConnectionRenderer;

},{"../providers/edges/Edge-PerimeterMath.js":475,"fable-serviceproviderbase":59}],489:[function(require,module,exports){
arguments[4][232][0].apply(exports,arguments)
},{"dup":232,"fable-serviceproviderbase":59}],490:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Interaction states for the flow diagram
 */
const INTERACTION_STATES =
{
	IDLE: 'idle',
	DRAGGING_NODE: 'dragging-node',
	DRAGGING_PANEL: 'dragging-panel',
	DRAGGING_HANDLE: 'dragging-handle',
	CONNECTING: 'connecting',
	PANNING: 'panning',
	RESIZING_PANEL: 'resizing-panel',
	RESIZING_NODE: 'resizing-node',
	MARQUEE: 'marquee'
};

class PictServiceFlowInteractionManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowInteractionManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._SVGElement = null;
		this._ViewportElement = null;

		// Interaction state
		this._State = INTERACTION_STATES.IDLE;

		// Drag state
		this._DragNodeHash = null;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragNodeStartX = 0;
		this._DragNodeStartY = 0;

		// Panel drag state
		this._DragPanelHash = null;
		this._DragPanelStartX = 0;
		this._DragPanelStartY = 0;
		this._DragPanelDataStartX = 0;
		this._DragPanelDataStartY = 0;

		// Handle drag state
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;

		// Pan state
		this._PanStartX = 0;
		this._PanStartY = 0;
		this._PanStartPanX = 0;
		this._PanStartPanY = 0;

		// Connection drag state
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
		this._ConnectDragLine = null;

		// Double-click detection
		this._LastClickTime = 0;
		this._LastClickNodeHash = null;
		this._DoubleClickThreshold = 400;

		// Panel resize state
		this._ResizePanelHash = null;
		this._ResizeStartY = 0;
		this._ResizePanelStartHeight = 0;

		// Node resize state (drag a node's bottom-right handle to set Width/Height)
		this._ResizeNodeHash = null;
		this._ResizeNodeStartX = 0;
		this._ResizeNodeStartY = 0;
		this._ResizeNodeStartWidth = 0;
		this._ResizeNodeStartHeight = 0;

		// Double-click detection for connections
		this._LastConnectionClickTime = 0;
		this._LastConnectionClickHash = null;

		// Double-click detection for tethers
		this._LastTetherClickTime = 0;
		this._LastTetherClickHash = null;

		// Double-click detection for handles
		this._LastHandleClickTime = 0;
		this._LastHandleClickHash = null;
		this._LastHandleClickType = null;

		// Bound event handlers (for removeEventListener)
		this._boundOnPointerDown = this._onPointerDown.bind(this);
		this._boundOnPointerMove = this._onPointerMove.bind(this);
		this._boundOnPointerUp = this._onPointerUp.bind(this);
		this._boundOnWheel = this._onWheel.bind(this);
		this._boundOnKeyDown = this._onKeyDown.bind(this);
	}

	/**
	 * Initialize event listeners on the SVG element
	 * @param {SVGSVGElement} pSVGElement
	 * @param {SVGGElement} pViewportElement
	 */
	initialize(pSVGElement, pViewportElement)
	{
		this._SVGElement = pSVGElement;
		this._ViewportElement = pViewportElement;

		if (!this._SVGElement) return;

		// Pointer/wheel/contextmenu live as inline attributes on the SVG
		// template (see Flow-Container-Template in PictView-Flow.js); they
		// route to InteractionManager via the FlowView's bridges. The
		// keydown listener stays document-level because keyboard input
		// has no element-level inline equivalent for the canvas-as-a-whole.
		document.addEventListener('keydown', this._boundOnKeyDown);
	}

	/**
	 * Inline-handler bridge — invoked from the SVG template's
	 * `oncontextmenu` attribute. Prevents the browser context menu and
	 * dispatches to the right bezier-handle action based on what was
	 * right-clicked.
	 *
	 * @param {Event} pEvent
	 */
	handleContextMenu(pEvent)
	{
		pEvent.preventDefault();

		let tmpTarget = pEvent.target;
		let tmpElementType = this._getElementType(tmpTarget);

		switch (tmpElementType)
		{
			case 'connection':
			case 'connection-hitarea':
				this._addBezierHandle(tmpTarget, pEvent);
				break;

			case 'connection-handle':
				this._removeBezierHandle(tmpTarget);
				break;

			case 'tether':
			case 'tether-hitarea':
				this._addTetherBezierHandle(tmpTarget, pEvent);
				break;

			case 'tether-handle':
				this._removeTetherBezierHandle(tmpTarget);
				break;
		}
	}

	/**
	 * Remove all event listeners. Pointer/wheel/contextmenu listeners live
	 * as inline template attributes and don't need explicit teardown — they
	 * disappear with the SVG element when the FlowView is destroyed.
	 */
	destroy()
	{
		document.removeEventListener('keydown', this._boundOnKeyDown);
	}

	/**
	 * Handle pointer down event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerDown(pEvent)
	{
		if (!this._FlowView) return;

		let tmpTarget = pEvent.target;
		let tmpElementType = this._getElementType(tmpTarget);

		// Check if click is inside a panel content area — let HTML handle its own events
		if (tmpTarget.closest && tmpTarget.closest('.pict-flow-panel-content'))
		{
			return;
		}

		// Capture pointer for smooth dragging (left-click only — right-click
		// needs the real target for contextmenu handle add/remove)
		if (pEvent.button === 0)
		{
			this._SVGElement.setPointerCapture(pEvent.pointerId);
		}

		switch (tmpElementType)
		{
			case 'port':
				this._startConnection(pEvent, tmpTarget);
				break;

			case 'node':
			case 'node-body':
			case 'panel-indicator':
			{
				let tmpNodeHash = this._getNodeHash(tmpTarget);
				let tmpNow = Date.now();

				// Shift-click toggles this node in the multi-selection (no drag, no panel).
				if (tmpNodeHash && this._FlowView.options.EnableMultiSelect && pEvent.shiftKey)
				{
					this._LastClickTime = 0;
					this._LastClickNodeHash = null;
					this._FlowView.toggleNodeSelection(tmpNodeHash);
					break;
				}

				// Check for double-click on same node
				if (tmpNodeHash && tmpNodeHash === this._LastClickNodeHash
					&& (tmpNow - this._LastClickTime) < this._DoubleClickThreshold)
				{
					// Double-click: toggle panel
					this._LastClickTime = 0;
					this._LastClickNodeHash = null;
					this._FlowView.togglePanel(tmpNodeHash);
				}
				else
				{
					// Single click: start node drag
					this._LastClickTime = tmpNow;
					this._LastClickNodeHash = tmpNodeHash;
					this._startNodeDrag(pEvent, tmpTarget);
				}
				break;
			}

			case 'panel-titlebar':
				this._startPanelDrag(pEvent, tmpTarget);
				break;

			case 'panel-resize':
				this._startPanelResize(pEvent, tmpTarget);
				break;

			case 'node-resize':
				this._startNodeResize(pEvent, tmpTarget);
				break;

			case 'panel-close':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				if (tmpPanelHash)
				{
					this._FlowView.closePanel(tmpPanelHash);
				}
				break;
			}

			case 'connection-handle':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on handle to toggle mode
				if (tmpConnectionHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleConnectionLineMode(tmpConnectionHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpConnectionHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, tmpConnectionHash, null, tmpHandleType, false);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'tether':
			case 'tether-hitarea':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same tether to add a handle
				if (tmpPanelHash && tmpPanelHash === this._LastTetherClickHash
					&& (tmpNow - this._LastTetherClickTime) < this._DoubleClickThreshold)
				{
					this._LastTetherClickTime = 0;
					this._LastTetherClickHash = null;
					this._addTetherBezierHandle(tmpTarget, pEvent);
				}
				else
				{
					this._LastTetherClickTime = tmpNow;
					this._LastTetherClickHash = tmpPanelHash;
					this._selectTether(tmpTarget);
				}
				break;
			}

			case 'tether-handle':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on tether handle to toggle mode
				if (tmpPanelHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleTetherLineMode(tmpPanelHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpPanelHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, null, tmpPanelHash, tmpHandleType, true);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'connection':
			case 'connection-hitarea':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same connection to add a handle
				if (tmpConnectionHash && tmpConnectionHash === this._LastConnectionClickHash
					&& (tmpNow - this._LastConnectionClickTime) < this._DoubleClickThreshold)
				{
					this._LastConnectionClickTime = 0;
					this._LastConnectionClickHash = null;
					// When the host configured a connection properties panel, double-click opens it;
					// otherwise keep the default behavior of adding a bezier handle.
					if (this._FlowView.options.ConnectionPropertiesPanel && tmpConnectionHash)
					{
						this._FlowView.toggleConnectionPanel(tmpConnectionHash);
					}
					else
					{
						this._addBezierHandle(tmpTarget, pEvent);
					}
				}
				else
				{
					this._LastConnectionClickTime = tmpNow;
					this._LastConnectionClickHash = tmpConnectionHash;
					this._selectConnection(tmpTarget);
				}
				break;
			}

			default:
				// Click / drag on the empty background.
				if (pEvent.button === 0)
				{
					if (this._FlowView.options.EnableMultiSelect && !pEvent.shiftKey)
					{
						// Plain drag marquee-selects; a click (no drag) clears the selection on release.
						this._startMarquee(pEvent);
					}
					else if (this._FlowView.options.EnablePanning)
					{
						// With multi-select on, shift+drag pans; otherwise this is the normal pan.
						this._startPanning(pEvent);
					}
				}
				break;
		}
	}

	/**
	 * Handle pointer move event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerMove(pEvent)
	{
		if (!this._FlowView) return;

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._onNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._onPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._onHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._onConnectionDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._onPanelResize(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_NODE:
				this._onNodeResize(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._onPan(pEvent);
				break;

			case INTERACTION_STATES.MARQUEE:
				this._onMarquee(pEvent);
				break;
		}
	}

	/**
	 * Handle pointer up event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerUp(pEvent)
	{
		if (!this._FlowView) return;

		// Release pointer capture
		if (this._SVGElement.hasPointerCapture && this._SVGElement.hasPointerCapture(pEvent.pointerId))
		{
			this._SVGElement.releasePointerCapture(pEvent.pointerId);
		}

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._endNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._endPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._endHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._endPanelResize(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_NODE:
				this._endNodeResize(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._endConnection(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._endPanning(pEvent);
				break;

			case INTERACTION_STATES.MARQUEE:
				this._endMarquee(pEvent);
				break;
		}
	}

	/**
	 * Handle mouse wheel for zoom
	 * @param {WheelEvent} pEvent
	 */
	_onWheel(pEvent)
	{
		if (!this._FlowView || !this._FlowView.options.EnableZooming) return;

		pEvent.preventDefault();

		let tmpDelta = pEvent.deltaY > 0 ? -this._FlowView.options.ZoomStep : this._FlowView.options.ZoomStep;
		let tmpNewZoom = this._FlowView.viewState.Zoom + tmpDelta;

		// Zoom toward mouse position
		let tmpRect = this._SVGElement.getBoundingClientRect();
		let tmpMouseX = pEvent.clientX - tmpRect.left;
		let tmpMouseY = pEvent.clientY - tmpRect.top;

		this._FlowView.setZoom(tmpNewZoom, tmpMouseX, tmpMouseY);
	}

	/**
	 * Handle keyboard events
	 * @param {KeyboardEvent} pEvent
	 */
	_onKeyDown(pEvent)
	{
		if (!this._FlowView) return;

		// Only handle events when the flow is focused/visible
		if (pEvent.key === 'Delete' || pEvent.key === 'Backspace')
		{
			// Don't delete if user is typing in an input or inside a panel
			if (pEvent.target && (pEvent.target.tagName === 'INPUT' || pEvent.target.tagName === 'TEXTAREA' || pEvent.target.tagName === 'SELECT'))
			{
				return;
			}
			if (pEvent.target && pEvent.target.closest && pEvent.target.closest('.pict-flow-panel'))
			{
				return;
			}

			this._FlowView.deleteSelected();
			pEvent.preventDefault();
		}
		else if (pEvent.key === 'Escape')
		{
			if (this._State === INTERACTION_STATES.CONNECTING)
			{
				this._cancelConnection();
			}

			// Exit fullscreen if currently in fullscreen mode
			if (this._FlowView._IsFullscreen)
			{
				this._FlowView.exitFullscreen();
				// Update the toolbar button text
				if (this._FlowView._ToolbarView)
				{
					let tmpFlowViewIdentifier = this._FlowView.options.ViewIdentifier;
					let tmpBtnElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpBtnElements.length > 0)
					{
						tmpBtnElements[0].innerHTML = '&#x26F6; Fullscreen';
					}
				}
				pEvent.preventDefault();
				return;
			}

			this._FlowView.deselectAll();
		}
	}

	// ---- Node Dragging ----

	_startNodeDrag(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableNodeDragging) return;

		let tmpNodeHash = this._getNodeHash(pTarget);
		if (!tmpNodeHash) return;

		// If the grabbed node is part of a multi-selection, drag the whole set; otherwise select just
		// it. (Grabbing a node outside the current selection collapses to that single node.)
		let tmpSelected = this._FlowView.getSelectedNodeHashes ? this._FlowView.getSelectedNodeHashes() : [];
		let tmpIsMulti = this._FlowView.options.EnableMultiSelect && tmpSelected.length > 1 && tmpSelected.indexOf(tmpNodeHash) >= 0;
		if (!tmpIsMulti)
		{
			this._FlowView.selectNode(tmpNodeHash);
			tmpSelected = [tmpNodeHash];
		}

		// Capture each dragged node's start position so one delta applies to all of them.
		this._DragNodes = [];
		for (let i = 0; i < tmpSelected.length; i++)
		{
			let tmpN = this._FlowView.getNode(tmpSelected[i]);
			if (tmpN) { this._DragNodes.push({ Hash: tmpN.Hash, StartX: tmpN.X, StartY: tmpN.Y }); }
		}
		if (this._DragNodes.length === 0) return;

		this._State = INTERACTION_STATES.DRAGGING_NODE;
		this._DragNodeHash = tmpNodeHash;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;

		this._SVGElement.classList.add('panning');

		for (let i = 0; i < this._DragNodes.length; i++)
		{
			let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${this._DragNodes[i].Hash}"]`);
			if (tmpNodeGroup) { tmpNodeGroup.classList.add('dragging'); }
		}
	}

	_onNodeDrag(pEvent)
	{
		if (!this._DragNodes || this._DragNodes.length === 0) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragStartY) / tmpVS.Zoom;

		// A single-node drag can show alignment guides and snap to other nodes' edges/centers.
		// Multi-drag keeps the rigid group offset (aligning a moving group is ambiguous).
		if (this._DragNodes.length === 1 && this._FlowView.options.EnableAlignmentGuides)
		{
			let tmpHash = this._DragNodes[0].Hash;
			let tmpNode = this._FlowView.getNode(tmpHash);
			let tmpX = this._snapToGrid(this._DragNodes[0].StartX + tmpDX);
			let tmpY = this._snapToGrid(this._DragNodes[0].StartY + tmpDY);
			if (tmpNode)
			{
				let tmpAlign = this._alignmentFor(tmpNode, tmpX, tmpY);
				this._drawGuides(tmpAlign.Guides);
				this._FlowView.updateNodePosition(tmpHash, tmpAlign.X, tmpAlign.Y);
				return;
			}
		}

		for (let i = 0; i < this._DragNodes.length; i++)
		{
			let tmpNewX = this._snapToGrid(this._DragNodes[i].StartX + tmpDX);
			let tmpNewY = this._snapToGrid(this._DragNodes[i].StartY + tmpDY);
			this._FlowView.updateNodePosition(this._DragNodes[i].Hash, tmpNewX, tmpNewY);
		}
	}

	// ---- Alignment guides (single-node drag) ----
	// Compare the dragged node's six reference lines (left / center-x / right and top / center-y /
	// bottom) against every other node's. Within a small threshold the dragged node snaps so the lines
	// coincide, and a guide line is reported spanning both nodes. Returns the (possibly snapped)
	// position plus the guides to draw; a pure computation so it can be unit-tested without a DOM.
	_alignmentFor(pDragNode, pX, pY)
	{
		let tmpZoom = (this._FlowView.viewState && this._FlowView.viewState.Zoom) ? this._FlowView.viewState.Zoom : 1;
		let tmpThreshold = 6 / tmpZoom;
		let tmpDefaultW = this._FlowView.options.DefaultNodeWidth || 180;
		let tmpDefaultH = this._FlowView.options.DefaultNodeHeight || 80;
		let tmpW = (typeof pDragNode.Width === 'number') ? pDragNode.Width : tmpDefaultW;
		let tmpH = (typeof pDragNode.Height === 'number') ? pDragNode.Height : tmpDefaultH;

		let tmpDragV = [ pX, pX + tmpW / 2, pX + tmpW ];   // left, center-x, right
		let tmpDragH = [ pY, pY + tmpH / 2, pY + tmpH ];   // top, center-y, bottom

		let tmpBestV = null;
		let tmpBestH = null;
		let tmpNodes = this._FlowView._FlowData.Nodes || [];

		for (let i = 0; i < tmpNodes.length; i++)
		{
			let tmpO = tmpNodes[i];
			if (tmpO.Hash === pDragNode.Hash) continue;
			let tmpOW = (typeof tmpO.Width === 'number') ? tmpO.Width : tmpDefaultW;
			let tmpOH = (typeof tmpO.Height === 'number') ? tmpO.Height : tmpDefaultH;
			let tmpOtherV = [ tmpO.X, tmpO.X + tmpOW / 2, tmpO.X + tmpOW ];
			let tmpOtherH = [ tmpO.Y, tmpO.Y + tmpOH / 2, tmpO.Y + tmpOH ];

			for (let a = 0; a < tmpDragV.length; a++)
			{
				for (let b = 0; b < tmpOtherV.length; b++)
				{
					let tmpD = Math.abs(tmpDragV[a] - tmpOtherV[b]);
					if (tmpD <= tmpThreshold && (!tmpBestV || tmpD < tmpBestV.Delta))
					{
						tmpBestV = { Delta: tmpD, Pos: tmpOtherV[b], SnapX: pX + (tmpOtherV[b] - tmpDragV[a]), OtherTop: tmpO.Y, OtherBottom: tmpO.Y + tmpOH };
					}
				}
			}
			for (let a = 0; a < tmpDragH.length; a++)
			{
				for (let b = 0; b < tmpOtherH.length; b++)
				{
					let tmpD = Math.abs(tmpDragH[a] - tmpOtherH[b]);
					if (tmpD <= tmpThreshold && (!tmpBestH || tmpD < tmpBestH.Delta))
					{
						tmpBestH = { Delta: tmpD, Pos: tmpOtherH[b], SnapY: pY + (tmpOtherH[b] - tmpDragH[a]), OtherLeft: tmpO.X, OtherRight: tmpO.X + tmpOW };
					}
				}
			}
		}

		let tmpResult = { X: pX, Y: pY, Guides: [] };
		if (tmpBestV)
		{
			tmpResult.X = tmpBestV.SnapX;
			tmpResult.Guides.push({ Type: 'v', Pos: tmpBestV.Pos, A: Math.min(tmpResult.Y, tmpBestV.OtherTop), B: Math.max(tmpResult.Y + tmpH, tmpBestV.OtherBottom) });
		}
		if (tmpBestH)
		{
			tmpResult.Y = tmpBestH.SnapY;
			tmpResult.Guides.push({ Type: 'h', Pos: tmpBestH.Pos, A: Math.min(tmpResult.X, tmpBestH.OtherLeft), B: Math.max(tmpResult.X + tmpW, tmpBestH.OtherRight) });
		}
		return tmpResult;
	}

	_drawGuides(pGuides)
	{
		this._clearGuides();
		if (!pGuides || pGuides.length === 0 || !this._FlowView._ViewportElement) return;
		this._GuideElements = [];
		for (let i = 0; i < pGuides.length; i++)
		{
			let tmpG = pGuides[i];
			let tmpLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
			tmpLine.setAttribute('class', 'pict-flow-align-guide');
			if (tmpG.Type === 'v') { tmpLine.setAttribute('x1', tmpG.Pos); tmpLine.setAttribute('x2', tmpG.Pos); tmpLine.setAttribute('y1', tmpG.A); tmpLine.setAttribute('y2', tmpG.B); }
			else { tmpLine.setAttribute('y1', tmpG.Pos); tmpLine.setAttribute('y2', tmpG.Pos); tmpLine.setAttribute('x1', tmpG.A); tmpLine.setAttribute('x2', tmpG.B); }
			this._FlowView._ViewportElement.appendChild(tmpLine);
			this._GuideElements.push(tmpLine);
		}
	}

	_clearGuides()
	{
		if (this._GuideElements)
		{
			for (let i = 0; i < this._GuideElements.length; i++)
			{
				let tmpEl = this._GuideElements[i];
				if (tmpEl.parentNode) { tmpEl.parentNode.removeChild(tmpEl); }
			}
		}
		this._GuideElements = null;
	}

	// Snap a coordinate or size to the grid when the flow has EnableGridSnap on; otherwise pass through.
	_snapToGrid(pValue)
	{
		if (!this._FlowView.options.EnableGridSnap) { return pValue; }
		// A defined GridSnapSize of 0 means "no snap"; only an absent size falls back to the default.
		let tmpGrid = (typeof this._FlowView.options.GridSnapSize === 'number') ? this._FlowView.options.GridSnapSize : 20;
		if (tmpGrid <= 0) { return pValue; }
		return Math.round(pValue / tmpGrid) * tmpGrid;
	}

	_endNodeDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');
		this._clearGuides();

		let tmpDragged = this._DragNodes || [];
		for (let i = 0; i < tmpDragged.length; i++)
		{
			let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${tmpDragged[i].Hash}"]`);
			if (tmpNodeGroup) { tmpNodeGroup.classList.remove('dragging'); }
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			for (let i = 0; i < tmpDragged.length; i++)
			{
				let tmpNode = this._FlowView.getNode(tmpDragged[i].Hash);
				if (tmpNode) { this._FlowView._EventHandlerProvider.fireEvent('onNodeMoved', tmpNode); }
			}
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragNodeHash = null;
		this._DragNodes = null;
	}

	// ---- Panel Dragging ----

	_startPanelDrag(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._State = INTERACTION_STATES.DRAGGING_PANEL;
		this._DragPanelHash = tmpPanelHash;
		this._DragPanelStartX = pEvent.clientX;
		this._DragPanelStartY = pEvent.clientY;
		this._DragPanelDataStartX = tmpPanel.X;
		this._DragPanelDataStartY = tmpPanel.Y;

		this._SVGElement.classList.add('panning');
	}

	_onPanelDrag(pEvent)
	{
		if (!this._DragPanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragPanelStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragPanelStartY) / tmpVS.Zoom;

		let tmpNewX = this._DragPanelDataStartX + tmpDX;
		let tmpNewY = this._DragPanelDataStartY + tmpDY;

		this._FlowView.updatePanelPosition(this._DragPanelHash, tmpNewX, tmpNewY);
	}

	_endPanelDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		this._FlowView.marshalFromView();

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragPanelHash);
		if (tmpPanel && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelMoved', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragPanelHash = null;
	}

	// ---- Panel Resizing ----

	_startPanelResize(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._State = INTERACTION_STATES.RESIZING_PANEL;
		this._ResizePanelHash = tmpPanelHash;
		this._ResizeStartY = pEvent.clientY;
		this._ResizePanelStartHeight = tmpPanel.Height;

		this._SVGElement.classList.add('panning');
	}

	_onPanelResize(pEvent)
	{
		if (!this._ResizePanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDY = (pEvent.clientY - this._ResizeStartY) / tmpVS.Zoom;
		let tmpNewHeight = Math.max(120, this._ResizePanelStartHeight + tmpDY);

		// Update the panel data
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._ResizePanelHash);
		if (tmpPanel)
		{
			tmpPanel.Height = tmpNewHeight;
		}

		// Update the foreignObject height directly for smooth resizing
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector('[data-panel-hash="' + this._ResizePanelHash + '"]');
			if (tmpFO)
			{
				tmpFO.setAttribute('height', String(tmpNewHeight));
			}
		}
	}

	_endPanelResize(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		// Re-render to sync tethers
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._ResizePanelHash = null;
	}

	// ---- Node Resizing ----
	// Drag the bottom-right handle (rendered on the selected node when the flow's
	// EnableNodeResizing option is on) to set Width/Height. Deltas are divided by the
	// zoom so the corner tracks the pointer at any zoom level.

	_startNodeResize(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableNodeResizing) return;

		let tmpNodeHash = this._getNodeHash(pTarget);
		if (!tmpNodeHash) return;

		let tmpNode = this._FlowView.getNode(tmpNodeHash);
		if (!tmpNode) return;

		this._State = INTERACTION_STATES.RESIZING_NODE;
		this._ResizeNodeHash = tmpNodeHash;
		this._ResizeNodeStartX = pEvent.clientX;
		this._ResizeNodeStartY = pEvent.clientY;
		this._ResizeNodeStartWidth = tmpNode.Width || 180;
		this._ResizeNodeStartHeight = tmpNode.Height || 80;

		this._SVGElement.classList.add('panning');
		if (pEvent.stopPropagation) pEvent.stopPropagation();
	}

	_onNodeResize(pEvent)
	{
		if (!this._ResizeNodeHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._ResizeNodeStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._ResizeNodeStartY) / tmpVS.Zoom;

		let tmpMinW = this._FlowView.options.MinimumNodeWidth || 48;
		let tmpMinH = this._FlowView.options.MinimumNodeHeight || 32;

		let tmpNode = this._FlowView.getNode(this._ResizeNodeHash);
		if (!tmpNode) return;

		tmpNode.Width = Math.max(tmpMinW, this._snapToGrid(Math.round(this._ResizeNodeStartWidth + tmpDX)));
		tmpNode.Height = Math.max(tmpMinH, this._snapToGrid(Math.round(this._ResizeNodeStartHeight + tmpDY)));

		// Re-render so the body (and any HTML/image content) reflows to the new size.
		this._FlowView.renderFlow();
	}

	_endNodeResize(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		let tmpNode = this._FlowView.getNode(this._ResizeNodeHash);
		if (tmpNode && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeResized', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._ResizeNodeHash = null;
	}

	// ---- Handle Dragging ----

	_startHandleDrag(pEvent, pConnectionHash, pPanelHash, pHandleType, pIsTether)
	{
		this._State = INTERACTION_STATES.DRAGGING_HANDLE;
		this._DragHandleConnectionHash = pConnectionHash;
		this._DragHandlePanelHash = pPanelHash;
		this._DragHandleType = pHandleType;
		this._DragHandleIsTether = pIsTether;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._SVGElement.classList.add('panning');
	}

	_onHandleDrag(pEvent)
	{
		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		if (this._DragHandleIsTether)
		{
			this._FlowView.updateTetherHandle(
				this._DragHandlePanelHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
		else
		{
			this._FlowView.updateConnectionHandle(
				this._DragHandleConnectionHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
	}

	_endHandleDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);

			if (this._DragHandleIsTether)
			{
				let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragHandlePanelHash);
				if (tmpPanel)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onTetherHandleMoved', tmpPanel);
				}
			}
			else
			{
				let tmpConnection = this._FlowView.getConnection(this._DragHandleConnectionHash);
				if (tmpConnection)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onConnectionHandleMoved', tmpConnection);
				}
			}
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;
	}

	// ---- Right-Click Handle Add/Remove ----

	/**
	 * Add a bezier handle to a connection at the right-click position.
	 * @param {Element} pTarget - The SVG element that was right-clicked
	 * @param {MouseEvent} pEvent - The contextmenu event
	 */
	_addBezierHandle(pTarget, pEvent)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		// Select the connection so handle circles are rendered after the re-render
		this._FlowView.selectConnection(tmpConnectionHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addConnectionHandle(tmpConnectionHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a connection.
	 * @param {Element} pTarget - The handle SVG element that was right-clicked
	 */
	_removeBezierHandle(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeConnectionHandle(tmpConnectionHash, tmpIndex);
	}

	/**
	 * Add a bezier handle to a tether.
	 * @param {Element} pTarget - The tether SVG element that was right-clicked or double-clicked
	 * @param {Event} pEvent - The mouse event (for coordinate extraction)
	 */
	_addTetherBezierHandle(pTarget, pEvent)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		// Select the tether so handles render after re-render
		this._FlowView.selectTether(tmpPanelHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addTetherHandle(tmpPanelHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a tether.
	 * @param {Element} pTarget - The tether handle SVG element that was right-clicked
	 */
	_removeTetherBezierHandle(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeTetherHandle(tmpPanelHash, tmpIndex);
	}

	// ---- Line Mode Toggling ----

	_toggleConnectionLineMode(pConnectionHash)
	{
		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};

		let tmpCurrentMode = tmpConnection.Data.LineMode || 'bezier';
		tmpConnection.Data.LineMode = (tmpCurrentMode === 'bezier') ? 'orthogonal' : 'bezier';

		// Reset handle positions when switching modes
		tmpConnection.Data.HandleCustomized = false;
		tmpConnection.Data.BezierHandles = [];
		tmpConnection.Data.BezierHandleX = null;
		tmpConnection.Data.BezierHandleY = null;
		tmpConnection.Data.OrthoCorner1X = null;
		tmpConnection.Data.OrthoCorner1Y = null;
		tmpConnection.Data.OrthoCorner2X = null;
		tmpConnection.Data.OrthoCorner2Y = null;
		tmpConnection.Data.OrthoMidOffset = 0;

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionModeChanged', tmpConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	_toggleTetherLineMode(pPanelHash)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.toggleLineMode(tmpPanel);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onTetherModeChanged', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	// ---- Tether Selection ----

	_selectTether(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (tmpPanelHash)
		{
			this._FlowView.selectTether(tmpPanelHash);
		}
	}

	// ---- Connection Creation ----

	_startConnection(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableConnectionCreation) return;

		let tmpNodeHash = pTarget.getAttribute('data-node-hash');
		let tmpPortHash = pTarget.getAttribute('data-port-hash');
		let tmpPortDirection = pTarget.getAttribute('data-port-direction');

		if (!tmpNodeHash || !tmpPortHash) return;

		// A connection normally starts from an output port; undirected mode lets any port start one.
		if (!this._FlowView.options.EnableUndirectedConnections && tmpPortDirection !== 'output')
		{
			return;
		}

		this._State = INTERACTION_STATES.CONNECTING;
		this._ConnectSourceNodeHash = tmpNodeHash;
		this._ConnectSourcePortHash = tmpPortHash;

		this._SVGElement.classList.add('connecting');

		let tmpPortPos = this._FlowView.getPortPosition(tmpNodeHash, tmpPortHash);
		if (tmpPortPos)
		{
			this._ConnectDragLine = document.createElementNS('http://www.w3.org/2000/svg', 'path');
			this._ConnectDragLine.setAttribute('class', 'pict-flow-drag-connection');
			this._ConnectDragLine.setAttribute('d', `M ${tmpPortPos.x} ${tmpPortPos.y} L ${tmpPortPos.x} ${tmpPortPos.y}`);
			this._FlowView._ViewportElement.appendChild(this._ConnectDragLine);
		}

		pEvent.stopPropagation();
	}

	_onConnectionDrag(pEvent)
	{
		if (!this._ConnectDragLine) return;

		let tmpSourcePos = this._FlowView.getPortPosition(this._ConnectSourceNodeHash, this._ConnectSourcePortHash);
		if (!tmpSourcePos) return;

		let tmpEndCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		let tmpDX = Math.abs(tmpEndCoords.x - tmpSourcePos.x) * 0.5;
		let tmpPath = `M ${tmpSourcePos.x} ${tmpSourcePos.y} C ${tmpSourcePos.x + tmpDX} ${tmpSourcePos.y}, ${tmpEndCoords.x - tmpDX} ${tmpEndCoords.y}, ${tmpEndCoords.x} ${tmpEndCoords.y}`;
		this._ConnectDragLine.setAttribute('d', tmpPath);
	}

	_endConnection(pEvent)
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		this._SVGElement.classList.remove('connecting');

		let tmpTarget = document.elementFromPoint(pEvent.clientX, pEvent.clientY);
		if (tmpTarget)
		{
			let tmpTargetPortHash = tmpTarget.getAttribute('data-port-hash');
			let tmpTargetNodeHash = tmpTarget.getAttribute('data-node-hash');
			let tmpTargetPortDirection = tmpTarget.getAttribute('data-port-direction');

			// A connection normally completes on an input port; undirected mode lets any port receive it.
			if (tmpTargetPortHash && tmpTargetNodeHash && (this._FlowView.options.EnableUndirectedConnections || tmpTargetPortDirection === 'input'))
			{
				this._FlowView.addConnection(
					this._ConnectSourceNodeHash,
					this._ConnectSourcePortHash,
					tmpTargetNodeHash,
					tmpTargetPortHash
				);
			}
		}

		this._State = INTERACTION_STATES.IDLE;
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	_cancelConnection()
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		this._SVGElement.classList.remove('connecting');

		this._State = INTERACTION_STATES.IDLE;
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	// ---- Panning ----

	_startPanning(pEvent)
	{
		this._FlowView.deselectAll();

		this._State = INTERACTION_STATES.PANNING;
		this._PanStartX = pEvent.clientX;
		this._PanStartY = pEvent.clientY;
		this._PanStartPanX = this._FlowView.viewState.PanX;
		this._PanStartPanY = this._FlowView.viewState.PanY;

		this._SVGElement.classList.add('panning');
	}

	_onPan(pEvent)
	{
		let tmpDX = pEvent.clientX - this._PanStartX;
		let tmpDY = pEvent.clientY - this._PanStartY;

		this._FlowView.viewState.PanX = this._PanStartPanX + tmpDX;
		this._FlowView.viewState.PanY = this._PanStartPanY + tmpDY;

		this._FlowView.updateViewportTransform();
	}

	_endPanning(pEvent)
	{
		this._SVGElement.classList.remove('panning');
		this._State = INTERACTION_STATES.IDLE;
	}

	// ---- Marquee selection (multi-select) ----
	// A rubber-band rectangle drawn in world coordinates (inside the transformed viewport group), so it
	// tracks the nodes under it regardless of pan/zoom. On release every node whose box intersects the
	// rectangle is selected; a rectangle too small to be a deliberate drag is treated as a click that
	// clears the selection.

	_startMarquee(pEvent)
	{
		let tmpStart = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._MarqueeStartX = tmpStart.x;
		this._MarqueeStartY = tmpStart.y;
		this._MarqueeCurrentX = tmpStart.x;
		this._MarqueeCurrentY = tmpStart.y;
		this._State = INTERACTION_STATES.MARQUEE;

		let tmpRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
		tmpRect.setAttribute('class', 'pict-flow-marquee');
		tmpRect.setAttribute('x', tmpStart.x);
		tmpRect.setAttribute('y', tmpStart.y);
		tmpRect.setAttribute('width', 0);
		tmpRect.setAttribute('height', 0);
		this._MarqueeElement = tmpRect;
		if (this._FlowView._ViewportElement) { this._FlowView._ViewportElement.appendChild(tmpRect); }
	}

	_onMarquee(pEvent)
	{
		if (!this._MarqueeElement) return;
		let tmpCur = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._MarqueeCurrentX = tmpCur.x;
		this._MarqueeCurrentY = tmpCur.y;
		let tmpX = Math.min(this._MarqueeStartX, tmpCur.x);
		let tmpY = Math.min(this._MarqueeStartY, tmpCur.y);
		this._MarqueeElement.setAttribute('x', tmpX);
		this._MarqueeElement.setAttribute('y', tmpY);
		this._MarqueeElement.setAttribute('width', Math.abs(tmpCur.x - this._MarqueeStartX));
		this._MarqueeElement.setAttribute('height', Math.abs(tmpCur.y - this._MarqueeStartY));
	}

	_endMarquee(pEvent)
	{
		let tmpX = Math.min(this._MarqueeStartX, this._MarqueeCurrentX);
		let tmpY = Math.min(this._MarqueeStartY, this._MarqueeCurrentY);
		let tmpW = Math.abs(this._MarqueeCurrentX - this._MarqueeStartX);
		let tmpH = Math.abs(this._MarqueeCurrentY - this._MarqueeStartY);

		if (this._MarqueeElement && this._MarqueeElement.parentNode)
		{
			this._MarqueeElement.parentNode.removeChild(this._MarqueeElement);
		}
		this._MarqueeElement = null;
		this._State = INTERACTION_STATES.IDLE;

		// Too small to be a deliberate drag: treat as a background click and clear the selection.
		if (tmpW < 4 && tmpH < 4)
		{
			this._FlowView.deselectAll();
			return;
		}

		let tmpHits = [];
		let tmpNodes = this._FlowView._FlowData.Nodes || [];
		let tmpDefaultW = this._FlowView.options.DefaultNodeWidth || 180;
		let tmpDefaultH = this._FlowView.options.DefaultNodeHeight || 80;
		for (let i = 0; i < tmpNodes.length; i++)
		{
			let tmpN = tmpNodes[i];
			let tmpNW = (typeof tmpN.Width === 'number') ? tmpN.Width : tmpDefaultW;
			let tmpNH = (typeof tmpN.Height === 'number') ? tmpN.Height : tmpDefaultH;
			let tmpIntersects = !(tmpN.X > tmpX + tmpW || (tmpN.X + tmpNW) < tmpX || tmpN.Y > tmpY + tmpH || (tmpN.Y + tmpNH) < tmpY);
			if (tmpIntersects) { tmpHits.push(tmpN.Hash); }
		}
		this._FlowView.selectNodes(tmpHits);
	}

	// ---- Connection Selection ----

	_selectConnection(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (tmpConnectionHash)
		{
			this._FlowView.selectConnection(tmpConnectionHash);
		}
	}

	// ---- Utilities ----

	_getElementType(pTarget)
	{
		if (!pTarget) return 'background';

		let tmpType = pTarget.getAttribute ? pTarget.getAttribute('data-element-type') : null;
		if (tmpType) return tmpType;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpType = tmpParent.getAttribute ? tmpParent.getAttribute('data-element-type') : null;
			if (tmpType) return tmpType;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return 'background';
	}

	_getNodeHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-node-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-node-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getPanelHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-panel-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-panel-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getConnectionHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-connection-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-connection-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}
}

module.exports = PictServiceFlowInteractionManager;
module.exports.INTERACTION_STATES = INTERACTION_STATES;

},{"fable-serviceproviderbase":59}],491:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libLayoutCustom           = require('../providers/layouts/Layout-Custom.js');
const libLayoutLayered          = require('../providers/layouts/Layout-Layered.js');
const libLayoutStaggered        = require('../providers/layouts/Layout-Staggered.js');
const libLayoutForcedFromCenter = require('../providers/layouts/Layout-ForcedFromCenter.js');
const libLayoutGrid             = require('../providers/layouts/Layout-Grid.js');
const libLayoutCircular         = require('../providers/layouts/Layout-Circular.js');
const libLayoutTabular          = require('../providers/layouts/Layout-Tabular.js');
const libLayoutColumnar         = require('../providers/layouts/Layout-Columnar.js');

const libEdgeBezier              = require('../providers/edges/Edge-Bezier.js');
const libEdgeOrthogonal          = require('../providers/edges/Edge-Orthogonal.js');
const libEdgeStraight            = require('../providers/edges/Edge-Straight.js');
const libEdgeOrthogonalSnap      = require('../providers/edges/Edge-OrthogonalSnap.js');
const libEdgePerimeter           = require('../providers/edges/Edge-Perimeter.js');
const libEdgePerimeterLinear     = require('../providers/edges/Edge-Perimeter-Linear.js');
const libEdgePerimeterOrthogonal = require('../providers/edges/Edge-Perimeter-Orthogonal.js');

const _BUILTIN_ALGORITHMS =
[
	libLayoutCustom,
	libLayoutLayered,
	libLayoutStaggered,
	libLayoutForcedFromCenter,
	libLayoutGrid,
	libLayoutCircular,
	libLayoutTabular,
	libLayoutColumnar
];

const _BUILTIN_EDGE_THEMES =
[
	libEdgeBezier,
	libEdgeOrthogonal,
	libEdgeStraight,
	libEdgeOrthogonalSnap,
	libEdgePerimeter,
	libEdgePerimeterLinear,
	libEdgePerimeterOrthogonal
];

const _LEGACY_ALGORITHM  = 'Layered';
const _DEFAULT_EDGE_THEME = 'Bezier';

/**
 * PictServiceFlowLayout
 *
 * Layout-algorithm registry and dispatcher. Holds plain descriptor
 * objects (`{ Name, Label, Apply, DefaultParameters, ParameterSchema }`)
 * for every registered layout algorithm, plus the small helpers
 * `snapToGrid` and `centerNodes` and the special-case `autoLayoutSubset`.
 *
 * Algorithms are pure functions over `(nodes, connections, parameters)`
 * that mutate node X/Y in place. Third parties extend the registry via
 * `registerAlgorithm(pDescriptor)`.
 *
 * Note: `_LayoutProvider` (PictProvider-Flow-Layouts.js) is a different
 * concept — it manages **saved layout snapshots** (named position
 * captures the user can restore later). Don't confuse "layouts" (saved
 * snapshots) with "layout algorithms" (procedural arrangement).
 */
class PictServiceFlowLayout extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowLayout';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Legacy spacing fields kept for `autoLayoutSubset` and any
		// external consumer that read them. The Layered algorithm itself
		// pulls spacing from its DefaultParameters.
		this._HorizontalSpacing = 250;
		this._VerticalSpacing = 120;
		this._StartX = 100;
		this._StartY = 100;

		// Algorithm registry: Name → descriptor
		this._Algorithms = {};

		// Edge-theme registry: Name → descriptor
		this._EdgeThemes = {};

		for (let i = 0; i < _BUILTIN_ALGORITHMS.length; i++)
		{
			this.registerAlgorithm(_BUILTIN_ALGORITHMS[i]);
		}
		for (let i = 0; i < _BUILTIN_EDGE_THEMES.length; i++)
		{
			this.registerEdgeTheme(_BUILTIN_EDGE_THEMES[i]);
		}
	}

	// ── Algorithm Registry ────────────────────────────────────────────────

	/**
	 * Register a layout algorithm.
	 * @param {Object} pDescriptor - { Name, Label, Apply, DefaultParameters, ParameterSchema }
	 * @returns {boolean} true if registered, false if invalid
	 */
	registerAlgorithm(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object')
		{
			this.log.warn('PictServiceFlowLayout registerAlgorithm: descriptor must be an object');
			return false;
		}
		if (typeof pDescriptor.Name !== 'string' || pDescriptor.Name === '')
		{
			this.log.warn('PictServiceFlowLayout registerAlgorithm: descriptor.Name is required');
			return false;
		}
		if (typeof pDescriptor.Apply !== 'function')
		{
			this.log.warn(`PictServiceFlowLayout registerAlgorithm: descriptor.Apply for '${pDescriptor.Name}' must be a function`);
			return false;
		}

		this._Algorithms[pDescriptor.Name] = pDescriptor;
		return true;
	}

	/**
	 * Look up a registered algorithm by name.
	 * @param {string} pName
	 * @returns {Object|null}
	 */
	getAlgorithm(pName)
	{
		return this._Algorithms[pName] || null;
	}

	/**
	 * List all registered algorithm names in registration order.
	 * @returns {string[]}
	 */
	getAlgorithmNames()
	{
		return Object.keys(this._Algorithms);
	}

	/**
	 * List all registered algorithm descriptors.
	 * @returns {Object[]}
	 */
	listAlgorithms()
	{
		let tmpKeys = Object.keys(this._Algorithms);
		let tmpResult = [];
		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpResult.push(this._Algorithms[tmpKeys[i]]);
		}
		return tmpResult;
	}

	/**
	 * Build the merged parameter set for an algorithm: default values
	 * with caller-supplied overrides on top.
	 * @param {string} pName
	 * @param {Object} [pOverrides]
	 * @returns {Object}
	 */
	getMergedParameters(pName, pOverrides)
	{
		let tmpAlgo = this.getAlgorithm(pName);
		if (!tmpAlgo) return Object.assign({}, pOverrides || {});
		return Object.assign({}, tmpAlgo.DefaultParameters || {}, pOverrides || {});
	}

	// ── Edge-Theme Registry ──────────────────────────────────────────────

	/**
	 * Register an edge theme.
	 * @param {Object} pDescriptor - { Name, Label, Description, GeneratePath, AdjustLayout?, DefaultParameters?, ParameterSchema? }
	 * @returns {boolean} true if registered, false if invalid
	 */
	registerEdgeTheme(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object')
		{
			this.log.warn('PictServiceFlowLayout registerEdgeTheme: descriptor must be an object');
			return false;
		}
		if (typeof pDescriptor.Name !== 'string' || pDescriptor.Name === '')
		{
			this.log.warn('PictServiceFlowLayout registerEdgeTheme: descriptor.Name is required');
			return false;
		}
		if (typeof pDescriptor.GeneratePath !== 'function')
		{
			this.log.warn(`PictServiceFlowLayout registerEdgeTheme: descriptor.GeneratePath for '${pDescriptor.Name}' must be a function`);
			return false;
		}
		this._EdgeThemes[pDescriptor.Name] = pDescriptor;
		return true;
	}

	/**
	 * Look up a registered edge theme by name.
	 * @param {string} pName
	 * @returns {Object|null}
	 */
	getEdgeTheme(pName)
	{
		return this._EdgeThemes[pName] || null;
	}

	/**
	 * List all registered edge-theme names in registration order.
	 * @returns {string[]}
	 */
	getEdgeThemeNames()
	{
		return Object.keys(this._EdgeThemes);
	}

	/**
	 * List all registered edge-theme descriptors.
	 * @returns {Object[]}
	 */
	listEdgeThemes()
	{
		let tmpKeys = Object.keys(this._EdgeThemes);
		let tmpResult = [];
		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpResult.push(this._EdgeThemes[tmpKeys[i]]);
		}
		return tmpResult;
	}

	/**
	 * Resolve which edge theme should render a given connection. Order:
	 *   1. `Connection.Data.EdgeTheme` (per-connection override)
	 *   2. Per-connection `Connection.Data.LineMode === 'orthogonal'`
	 *      → 'Orthogonal' (back-compat for the existing line-mode flag)
	 *   3. `_FlowData.EdgeTheme` (flow-level)
	 *   4. Active layout's `DefaultEdgeTheme`
	 *   5. The hard fallback ('Bezier')
	 *
	 * Returns null only if even the fallback isn't registered, in which
	 * case the renderer should use its built-in path generators.
	 *
	 * @param {Object} pConnection
	 * @returns {Object|null}
	 */
	resolveActiveEdgeTheme(pConnection)
	{
		let tmpData = (pConnection && pConnection.Data) || {};
		let tmpFlowView = this._FlowView;
		let tmpFlowData = tmpFlowView ? tmpFlowView._FlowData : null;

		if (tmpData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme(tmpData.EdgeTheme);
			if (tmpTheme) return tmpTheme;
		}
		if (tmpData.LineMode === 'orthogonal' && !tmpData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme('Orthogonal');
			if (tmpTheme) return tmpTheme;
		}
		if (tmpFlowData && tmpFlowData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme(tmpFlowData.EdgeTheme);
			if (tmpTheme) return tmpTheme;
		}
		if (tmpFlowData && tmpFlowData.LayoutAlgorithm)
		{
			let tmpAlgo = this.getAlgorithm(tmpFlowData.LayoutAlgorithm);
			if (tmpAlgo && tmpAlgo.DefaultEdgeTheme)
			{
				let tmpTheme = this.getEdgeTheme(tmpAlgo.DefaultEdgeTheme);
				if (tmpTheme) return tmpTheme;
			}
		}
		return this.getEdgeTheme(_DEFAULT_EDGE_THEME);
	}

	/**
	 * Build the merged parameter set for an edge theme.
	 * @param {string} pName
	 * @param {Object} [pOverrides]
	 * @returns {Object}
	 */
	getMergedEdgeThemeParameters(pName, pOverrides)
	{
		let tmpTheme = this.getEdgeTheme(pName);
		if (!tmpTheme) return Object.assign({}, pOverrides || {});
		return Object.assign({}, tmpTheme.DefaultParameters || {}, pOverrides || {});
	}

	// ── Dispatch ──────────────────────────────────────────────────────────

	/**
	 * Apply a registered layout algorithm. Mutates node X/Y in place.
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {string} pAlgorithmName
	 * @param {Object} [pParameters]
	 */
	applyLayout(pNodes, pConnections, pAlgorithmName, pParameters)
	{
		let tmpAlgo = this.getAlgorithm(pAlgorithmName);
		if (!tmpAlgo)
		{
			this.log.warn(`PictServiceFlowLayout applyLayout: unknown algorithm '${pAlgorithmName}', falling back to '${_LEGACY_ALGORITHM}'`);
			tmpAlgo = this.getAlgorithm(_LEGACY_ALGORITHM);
			if (!tmpAlgo) return;
		}
		let tmpMerged = Object.assign({}, tmpAlgo.DefaultParameters || {}, pParameters || {});
		tmpAlgo.Apply(pNodes, pConnections, tmpMerged);
	}

	/**
	 * Auto-layout entry point.
	 *
	 * - Legacy 2-arg form `autoLayout(nodes, connections)` dispatches to
	 *   the Layered algorithm and is byte-for-byte identical to the
	 *   pre-subsystem behavior.
	 * - 3- or 4-arg form `autoLayout(nodes, connections, name, params)`
	 *   dispatches to the named algorithm.
	 *
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {string} [pAlgorithmName] - defaults to the Layered algorithm
	 * @param {Object} [pParameters]
	 */
	autoLayout(pNodes, pConnections, pAlgorithmName, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;
		let tmpName = (typeof pAlgorithmName === 'string' && pAlgorithmName !== '') ? pAlgorithmName : _LEGACY_ALGORITHM;
		this.applyLayout(pNodes, pConnections, tmpName, pParameters);
	}

	// ── Helpers ──────────────────────────────────────────────────────────

	/**
	 * Snap a coordinate to the nearest grid point.
	 * @param {number} pValue
	 * @param {number} pGridSize
	 * @returns {number}
	 */
	snapToGrid(pValue, pGridSize)
	{
		if (!pGridSize || pGridSize <= 0) return pValue;
		return Math.round(pValue / pGridSize) * pGridSize;
	}

	/**
	 * Auto-layout a subset of nodes, positioning them to the right of
	 * any fixed (already-positioned) nodes.
	 *
	 * Used by the saved-layout restore flow (`PictProvider-Flow-Layouts`)
	 * to position nodes that exist in the current flow but were absent
	 * from the saved snapshot.
	 *
	 * **Always runs the Layered algorithm**, regardless of the flow's
	 * configured `LayoutAlgorithm`. Running ForcedFromCenter or another
	 * algorithm on a partial node set would jitter the matched nodes
	 * (which are intentionally fixed). The contract here is "place the
	 * orphans in a sensible default arrangement," not "obey the user's
	 * full-graph algorithm."
	 *
	 * @param {Array} pNodesToLayout - Nodes that need new positions
	 * @param {Array} pFixedNodes - Nodes that already have positions (read-only)
	 * @param {Array} pConnections - All connections in the flow
	 */
	autoLayoutSubset(pNodesToLayout, pFixedNodes, pConnections)
	{
		if (!pNodesToLayout || pNodesToLayout.length === 0) return;

		// Compute the starting X position to the right of all fixed nodes
		let tmpStartX = this._StartX;
		let tmpStartY = this._StartY;

		if (pFixedNodes && pFixedNodes.length > 0)
		{
			let tmpMaxX = -Infinity;

			for (let i = 0; i < pFixedNodes.length; i++)
			{
				let tmpRight = pFixedNodes[i].X + (pFixedNodes[i].Width || 180);
				if (tmpRight > tmpMaxX)
				{
					tmpMaxX = tmpRight;
				}
			}

			tmpStartX = tmpMaxX + this._HorizontalSpacing;
		}

		// Build a set of nodes we are laying out for quick lookup
		let tmpNodeSet = {};
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			tmpNodeSet[pNodesToLayout[i].Hash] = true;
		}

		// Build adjacency information only for nodes in the subset
		let tmpNodeMap = {};
		let tmpInDegree = {};
		let tmpOutEdges = {};

		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			let tmpNode = pNodesToLayout[i];
			tmpNodeMap[tmpNode.Hash] = tmpNode;
			tmpInDegree[tmpNode.Hash] = 0;
			tmpOutEdges[tmpNode.Hash] = [];
		}

		for (let i = 0; i < pConnections.length; i++)
		{
			let tmpConn = pConnections[i];
			let tmpSourceInSubset = tmpNodeSet[tmpConn.SourceNodeHash];
			let tmpTargetInSubset = tmpNodeSet[tmpConn.TargetNodeHash];

			if (tmpSourceInSubset && tmpTargetInSubset)
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
				tmpOutEdges[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Topological sort (Kahn's algorithm)
		let tmpLayers = [];
		let tmpQueue = [];
		let tmpAssigned = {};

		for (let tmpHash in tmpInDegree)
		{
			if (tmpInDegree[tmpHash] === 0)
			{
				tmpQueue.push(tmpHash);
			}
		}

		while (tmpQueue.length > 0)
		{
			let tmpCurrentLayer = [];
			let tmpNextQueue = [];

			for (let i = 0; i < tmpQueue.length; i++)
			{
				let tmpNodeHash = tmpQueue[i];
				if (tmpAssigned[tmpNodeHash]) continue;

				tmpAssigned[tmpNodeHash] = true;
				tmpCurrentLayer.push(tmpNodeHash);

				let tmpEdges = tmpOutEdges[tmpNodeHash] || [];
				for (let j = 0; j < tmpEdges.length; j++)
				{
					let tmpTargetHash = tmpEdges[j];
					tmpInDegree[tmpTargetHash]--;
					if (tmpInDegree[tmpTargetHash] <= 0 && !tmpAssigned[tmpTargetHash])
					{
						tmpNextQueue.push(tmpTargetHash);
					}
				}
			}

			if (tmpCurrentLayer.length > 0)
			{
				tmpLayers.push(tmpCurrentLayer);
			}

			tmpQueue = tmpNextQueue;
		}

		// Handle remaining unassigned nodes (cycles or disconnected)
		let tmpRemainingNodes = [];
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			if (!tmpAssigned[pNodesToLayout[i].Hash])
			{
				tmpRemainingNodes.push(pNodesToLayout[i].Hash);
			}
		}
		if (tmpRemainingNodes.length > 0)
		{
			tmpLayers.push(tmpRemainingNodes);
		}

		// Assign positions based on layers, starting from tmpStartX
		let tmpCurrentX = tmpStartX;

		for (let tmpLayerIndex = 0; tmpLayerIndex < tmpLayers.length; tmpLayerIndex++)
		{
			let tmpLayer = tmpLayers[tmpLayerIndex];
			let tmpMaxWidth = 0;
			let tmpCurrentY = tmpStartY;

			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (!tmpNode) continue;

				tmpNode.X = tmpCurrentX;
				tmpNode.Y = tmpCurrentY;

				let tmpWidth = tmpNode.Width || 180;
				let tmpHeight = tmpNode.Height || 80;

				tmpMaxWidth = Math.max(tmpMaxWidth, tmpWidth);
				tmpCurrentY += tmpHeight + this._VerticalSpacing;
			}

			tmpCurrentX += tmpMaxWidth + this._HorizontalSpacing;
		}
	}

	/**
	 * Center all nodes around a given point.
	 * @param {Array} pNodes
	 * @param {number} pCenterX
	 * @param {number} pCenterY
	 */
	centerNodes(pNodes, pCenterX, pCenterY)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMinX = Math.min(tmpMinX, pNodes[i].X);
			tmpMinY = Math.min(tmpMinY, pNodes[i].Y);
			tmpMaxX = Math.max(tmpMaxX, pNodes[i].X + (pNodes[i].Width || 180));
			tmpMaxY = Math.max(tmpMaxY, pNodes[i].Y + (pNodes[i].Height || 80));
		}

		let tmpCurrentCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCurrentCenterY = (tmpMinY + tmpMaxY) / 2;
		let tmpOffsetX = pCenterX - tmpCurrentCenterX;
		let tmpOffsetY = pCenterY - tmpCurrentCenterY;

		for (let i = 0; i < pNodes.length; i++)
		{
			pNodes[i].X += tmpOffsetX;
			pNodes[i].Y += tmpOffsetY;
		}
	}
}

module.exports = PictServiceFlowLayout;

},{"../providers/edges/Edge-Bezier.js":469,"../providers/edges/Edge-Orthogonal.js":470,"../providers/edges/Edge-OrthogonalSnap.js":471,"../providers/edges/Edge-Perimeter-Linear.js":472,"../providers/edges/Edge-Perimeter-Orthogonal.js":473,"../providers/edges/Edge-Perimeter.js":474,"../providers/edges/Edge-Straight.js":476,"../providers/layouts/Layout-Circular.js":477,"../providers/layouts/Layout-Columnar.js":479,"../providers/layouts/Layout-Custom.js":480,"../providers/layouts/Layout-ForcedFromCenter.js":481,"../providers/layouts/Layout-Grid.js":482,"../providers/layouts/Layout-Layered.js":483,"../providers/layouts/Layout-Staggered.js":485,"../providers/layouts/Layout-Tabular.js":486,"fable-serviceproviderbase":59}],492:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PanelManager
 *
 * Manages the lifecycle of properties panels in the flow diagram:
 * opening, closing, toggling, and position updates for panels
 * associated with flow nodes.
 */
class PictServiceFlowPanelManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPanelManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node was not found
	 */
	openPanel(pNodeHash)
	{
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return false;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);
		if (!tmpNodeTypeConfig) return false;

		// Check if a panel is already open for this node
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting) return tmpExisting;

		let tmpPanelConfig = tmpNodeTypeConfig.PropertiesPanel;
		let tmpPanelHash = `panel-${this.fable.getUUID()}`;
		let tmpWidth, tmpHeight, tmpPanelType, tmpTitle;

		if (tmpPanelConfig)
		{
			tmpWidth = tmpPanelConfig.DefaultWidth || 300;
			tmpHeight = tmpPanelConfig.DefaultHeight || 200;
			tmpPanelType = tmpPanelConfig.PanelType || 'Base';
			tmpTitle = tmpPanelConfig.Title || tmpNodeTypeConfig.Label || 'Properties';
		}
		else
		{
			// No PropertiesPanel configured — open an auto-generated info panel
			tmpWidth = 240;
			tmpHeight = 180;
			tmpPanelType = 'Info';
			tmpTitle = tmpNodeTypeConfig.Label || tmpNode.Title || 'Node Info';
		}

		let tmpPanelData =
		{
			Hash: tmpPanelHash,
			NodeHash: pNodeHash,
			PanelType: tmpPanelType,
			Title: tmpTitle,
			X: tmpNode.X + tmpNode.Width + 30,
			Y: tmpNode.Y,
			Width: tmpWidth,
			Height: tmpHeight
		};

		this._FlowView._FlowData.OpenPanels.push(tmpPanelData);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelOpened', tmpPanelData);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpPanelData;
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		let tmpIndex = this._FlowView._FlowData.OpenPanels.findIndex((pPanel) => pPanel.Hash === pPanelHash);
		if (tmpIndex < 0) return false;

		let tmpRemovedPanel = this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1)[0];

		// Clean up the panel instance
		if (this._FlowView._PropertiesPanelView)
		{
			this._FlowView._PropertiesPanelView.destroyPanel(pPanelHash);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelClosed', tmpRemovedPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		let tmpPanelsToClose = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpPanelsToClose.length === 0) return false;

		for (let i = 0; i < tmpPanelsToClose.length; i++)
		{
			let tmpIndex = this._FlowView._FlowData.OpenPanels.indexOf(tmpPanelsToClose[i]);
			if (tmpIndex >= 0)
			{
				this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1);
			}
			if (this._FlowView._PropertiesPanelView)
			{
				this._FlowView._PropertiesPanelView.destroyPanel(tmpPanelsToClose[i].Hash);
			}
		}

		return true;
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting)
		{
			this.closePanel(tmpExisting.Hash);
			return false;
		}
		return this.openPanel(pNodeHash);
	}

	/**
	 * Open a properties panel for a connection (edge). The panel config comes from the FlowView's
	 * ConnectionPropertiesPanel option (connections are not typed, so one config serves them all);
	 * the panel is placed near the connection's midpoint and tethers to it. Returns false when no
	 * ConnectionPropertiesPanel is configured, so a host that has not opted in keeps the default
	 * edge behavior (double-click adds a bezier handle).
	 * @param {string} pConnectionHash
	 * @returns {Object|false} The panel data, or false
	 */
	openConnectionPanel(pConnectionHash)
	{
		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return false;

		let tmpPanelConfig = this._FlowView.options.ConnectionPropertiesPanel;
		if (!tmpPanelConfig) return false;

		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.ConnectionHash === pConnectionHash);
		if (tmpExisting) return tmpExisting;

		let tmpMidpoint = this._FlowView.getConnectionMidpoint(pConnectionHash) || { x: 0, y: 0 };
		let tmpWidth = tmpPanelConfig.DefaultWidth || 300;
		let tmpHeight = tmpPanelConfig.DefaultHeight || 200;

		let tmpPanelData =
		{
			Hash: `panel-${this.fable.getUUID()}`,
			ConnectionHash: pConnectionHash,
			NodeHash: null,
			PanelType: tmpPanelConfig.PanelType || 'Base',
			Title: tmpPanelConfig.Title || 'Connection',
			X: tmpMidpoint.x + 40,
			Y: tmpMidpoint.y + 20,
			Width: tmpWidth,
			Height: tmpHeight
		};

		this._FlowView._FlowData.OpenPanels.push(tmpPanelData);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelOpened', tmpPanelData);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpPanelData;
	}

	/**
	 * Toggle a properties panel for a connection (open if closed, close if open).
	 * @param {string} pConnectionHash
	 * @returns {Object|false}
	 */
	toggleConnectionPanel(pConnectionHash)
	{
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.ConnectionHash === pConnectionHash);
		if (tmpExisting)
		{
			this.closePanel(tmpExisting.Hash);
			return false;
		}
		return this.openConnectionPanel(pConnectionHash);
	}

	/**
	 * Close all panels for a given connection.
	 * @param {string} pConnectionHash
	 * @returns {boolean}
	 */
	closePanelForConnection(pConnectionHash)
	{
		let tmpPanelsToClose = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.ConnectionHash === pConnectionHash);
		if (tmpPanelsToClose.length === 0) return false;

		for (let i = 0; i < tmpPanelsToClose.length; i++)
		{
			let tmpIndex = this._FlowView._FlowData.OpenPanels.indexOf(tmpPanelsToClose[i]);
			if (tmpIndex >= 0)
			{
				this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1);
			}
			if (this._FlowView._PropertiesPanelView)
			{
				this._FlowView._PropertiesPanelView.destroyPanel(tmpPanelsToClose[i].Hash);
			}
		}

		return true;
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		tmpPanel.X = pX;
		tmpPanel.Y = pY;

		// Reset tether handle positions when panel moves
		this._FlowView._resetHandlesForPanel(pPanelHash);

		// Update the foreignObject position directly for smooth dragging
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector(`[data-panel-hash="${pPanelHash}"]`);
			if (tmpFO)
			{
				tmpFO.setAttribute('x', String(pX));
				tmpFO.setAttribute('y', String(pY));
			}
		}

		// Update the tether for this panel. A node panel refreshes just its node's tethers; a
		// connection panel has no node, so reconcile the panels layer (redraws all tethers, which
		// is where the connection-midpoint tether is recomputed).
		if (tmpPanel.ConnectionHash)
		{
			if (this._FlowView._PropertiesPanelView && this._FlowView._PanelsLayer && this._FlowView._TethersLayer)
			{
				this._FlowView._PropertiesPanelView.renderPanels(this._FlowView._FlowData.OpenPanels, this._FlowView._PanelsLayer, this._FlowView._TethersLayer, this._FlowView._FlowData.ViewState.SelectedTetherHash);
			}
		}
		else
		{
			this._FlowView._renderTethersForNode(tmpPanel.NodeHash);
		}
	}
}

module.exports = PictServiceFlowPanelManager;

},{"fable-serviceproviderbase":59}],493:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PathGenerator
 *
 * Centralizes SVG path generation for the flow diagram.
 * Provides shared building blocks used by both the ConnectionRenderer
 * (port-to-port connections) and the TetherService (panel-to-node tethers).
 *
 * Responsibilities:
 *   - Departure/approach point calculation from anchors
 *   - Auto orthogonal corner computation for right-angle paths
 *   - Cubic bezier evaluation at arbitrary parameter t
 *   - SVG path string assembly (bezier, split-bezier, orthogonal)
 */
class PictServiceFlowPathGenerator extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPathGenerator';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Departure / Approach Calculation ----

	/**
	 * Compute departure and approach points from start/end anchors.
	 * The departure point extends outward from the start in its side direction,
	 * and the approach point extends outward from the end in its side direction.
	 *
	 * @param {{x: number, y: number, side: string}} pFrom - Start anchor with side
	 * @param {{x: number, y: number, side: string}} pTo - End anchor with side
	 * @param {number} pDepartDist - Distance for departure/approach straight segments
	 * @returns {{departX: number, departY: number, approachX: number, approachY: number, fromDir: {dx: number, dy: number}, toDir: {dx: number, dy: number}}}
	 */
	computeDepartApproach(pFrom, pTo, pDepartDist)
	{
		let tmpGeometry = this._FlowView._GeometryProvider;

		let tmpFromDir = tmpGeometry.sideDirection(pFrom.side || 'right');
		let tmpToDir = tmpGeometry.sideDirection(pTo.side || 'left');

		return {
			departX: pFrom.x + tmpFromDir.dx * pDepartDist,
			departY: pFrom.y + tmpFromDir.dy * pDepartDist,
			approachX: pTo.x + tmpToDir.dx * pDepartDist,
			approachY: pTo.y + tmpToDir.dy * pDepartDist,
			fromDir: tmpFromDir,
			toDir: tmpToDir
		};
	}

	// ---- Orthogonal Corner Calculation ----

	/**
	 * Compute auto orthogonal corners for an L-shaped or Z-shaped path.
	 * Determines corner placement based on departure/approach directions.
	 *
	 * Used by both connection and tether renderers for right-angle paths.
	 *
	 * @param {number} pDepartX
	 * @param {number} pDepartY
	 * @param {number} pApproachX
	 * @param {number} pApproachY
	 * @param {{dx: number, dy: number}} pFromDir - Departure direction vector
	 * @param {{dx: number, dy: number}} pToDir - Approach direction vector
	 * @param {number} pMidOffset - Offset for the corridor midpoint
	 * @returns {{corner1: {x: number, y: number}, corner2: {x: number, y: number}, midpoint: {x: number, y: number}}}
	 */
	computeAutoOrthogonalCorners(pDepartX, pDepartY, pApproachX, pApproachY, pFromDir, pToDir, pMidOffset)
	{
		let tmpOffset = pMidOffset || 0;
		let tmpFromHoriz = Math.abs(pFromDir.dx) > 0;
		let tmpToHoriz = Math.abs(pToDir.dx) > 0;

		let tmpCorner1, tmpCorner2, tmpMidpoint;

		if (tmpFromHoriz && tmpToHoriz)
		{
			// Both horizontal departure/approach: corridor is vertical
			let tmpMidX = (pDepartX + pApproachX) / 2 + tmpOffset;
			tmpCorner1 = { x: tmpMidX, y: pDepartY };
			tmpCorner2 = { x: tmpMidX, y: pApproachY };
			tmpMidpoint = { x: tmpMidX, y: (pDepartY + pApproachY) / 2 };
		}
		else if (!tmpFromHoriz && !tmpToHoriz)
		{
			// Both vertical: corridor is horizontal
			let tmpMidY = (pDepartY + pApproachY) / 2 + tmpOffset;
			tmpCorner1 = { x: pDepartX, y: tmpMidY };
			tmpCorner2 = { x: pApproachX, y: tmpMidY };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: tmpMidY };
		}
		else if (tmpFromHoriz && !tmpToHoriz)
		{
			// Horizontal→Vertical: single L-bend
			tmpCorner1 = { x: pApproachX + tmpOffset, y: pDepartY };
			tmpCorner2 = { x: pApproachX + tmpOffset, y: pApproachY };
			tmpMidpoint = { x: pApproachX + tmpOffset, y: (pDepartY + pApproachY) / 2 };
		}
		else
		{
			// Vertical→Horizontal: single L-bend
			tmpCorner1 = { x: pDepartX, y: pApproachY + tmpOffset };
			tmpCorner2 = { x: pApproachX, y: pApproachY + tmpOffset };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: pApproachY + tmpOffset };
		}

		return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
	}

	// ---- Bezier Evaluation ----

	/**
	 * Evaluate a cubic bezier curve at parameter t.
	 * B(t) = (1-t)³P0 + 3(1-t)²tP1 + 3(1-t)t²P2 + t³P3
	 *
	 * @param {{x: number, y: number}} pP0 - Start point
	 * @param {{x: number, y: number}} pP1 - First control point
	 * @param {{x: number, y: number}} pP2 - Second control point
	 * @param {{x: number, y: number}} pP3 - End point
	 * @param {number} pT - Parameter in range [0, 1]
	 * @returns {{x: number, y: number}}
	 */
	evaluateCubicBezier(pP0, pP1, pP2, pP3, pT)
	{
		let tmpOMT = 1 - pT;
		let tmpOMT2 = tmpOMT * tmpOMT;
		let tmpOMT3 = tmpOMT2 * tmpOMT;
		let tmpT2 = pT * pT;
		let tmpT3 = tmpT2 * pT;

		return {
			x: tmpOMT3 * pP0.x + 3 * tmpOMT2 * pT * pP1.x + 3 * tmpOMT * tmpT2 * pP2.x + tmpT3 * pP3.x,
			y: tmpOMT3 * pP0.y + 3 * tmpOMT2 * pT * pP1.y + 3 * tmpOMT * tmpT2 * pP2.y + tmpT3 * pP3.y
		};
	}

	// ---- SVG Path String Assembly ----

	/**
	 * Build an SVG bezier path string.
	 * Pattern: M start L depart C cp1, cp2, approach L end
	 *
	 * @param {{x: number, y: number}} pStart - Start point
	 * @param {{x: number, y: number}} pDepart - Departure point after straight segment
	 * @param {{x: number, y: number}} pCP1 - First control point
	 * @param {{x: number, y: number}} pCP2 - Second control point
	 * @param {{x: number, y: number}} pApproach - Approach point before final straight segment
	 * @param {{x: number, y: number}} pEnd - End point
	 * @returns {string} SVG path d attribute
	 */
	buildBezierPathString(pStart, pDepart, pCP1, pCP2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1.x} ${pCP1.y}, ${pCP2.x} ${pCP2.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG split bezier path string (two cubic segments through a handle point).
	 * Pattern: M start L depart C cp1a, cp1b, handle C cp2a, cp2b, approach L end
	 *
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pDepart
	 * @param {{x: number, y: number}} pCP1a - First segment's first control point
	 * @param {{x: number, y: number}} pCP1b - First segment's second control point
	 * @param {{x: number, y: number}} pHandle - Handle point where the two segments meet
	 * @param {{x: number, y: number}} pCP2a - Second segment's first control point
	 * @param {{x: number, y: number}} pCP2b - Second segment's second control point
	 * @param {{x: number, y: number}} pApproach
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string} SVG path d attribute
	 */
	buildSplitBezierPathString(pStart, pDepart, pCP1a, pCP1b, pHandle, pCP2a, pCP2b, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1a.x} ${pCP1a.y}, ${pCP1b.x} ${pCP1b.y}, ${pHandle.x} ${pHandle.y} C ${pCP2a.x} ${pCP2a.y}, ${pCP2b.x} ${pCP2b.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG multi-segment bezier path string.
	 * Generates N+1 cubic bezier segments through N handle points.
	 *
	 * Pattern: M start L depart C cp,cp,handle[0] C cp,cp,handle[1] ... C cp,cp,approach L end
	 *
	 * Control points are computed using Catmull-Rom-to-Bezier conversion
	 * for C1 (smooth tangent) continuity at every handle.
	 *
	 * @param {{x: number, y: number}} pStart - Port anchor start
	 * @param {{x: number, y: number}} pDepart - Departure point after straight segment
	 * @param {Array<{x: number, y: number}>} pHandles - Ordered handle waypoints
	 * @param {{x: number, y: number}} pApproach - Approach point before final straight segment
	 * @param {{x: number, y: number}} pEnd - Port anchor end
	 * @param {{dx: number, dy: number}} pStartDir - Departure direction unit vector
	 * @param {{dx: number, dy: number}} pEndDir - Approach direction unit vector
	 * @returns {string} SVG path d attribute
	 */
	buildMultiBezierPathString(pStart, pDepart, pHandles, pApproach, pEnd, pStartDir, pEndDir)
	{
		// Build the full list of waypoints: depart, handle[0..N-1], approach
		let tmpWaypoints = [pDepart];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push(pApproach);

		let tmpPath = `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y}`;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpFrom = tmpWaypoints[i];
			let tmpTo = tmpWaypoints[i + 1];

			let tmpSegDX = tmpTo.x - tmpFrom.x;
			let tmpSegDY = tmpTo.y - tmpFrom.y;
			let tmpSegLen = Math.sqrt(tmpSegDX * tmpSegDX + tmpSegDY * tmpSegDY);
			if (tmpSegLen < 1)
			{
				tmpSegLen = 1;
			}
			let tmpScale = tmpSegLen * 0.35;

			// Tangent at tmpFrom
			let tmpTanFromX, tmpTanFromY;
			if (i === 0)
			{
				// First segment: use the port departure direction
				tmpTanFromX = pStartDir.dx;
				tmpTanFromY = pStartDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i - 1];
				let tmpNext = tmpWaypoints[i + 1];
				tmpTanFromX = tmpNext.x - tmpPrev.x;
				tmpTanFromY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanFromX * tmpTanFromX + tmpTanFromY * tmpTanFromY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanFromX /= tmpTanLen;
				tmpTanFromY /= tmpTanLen;
			}

			// Tangent at tmpTo
			let tmpTanToX, tmpTanToY;
			if (i === tmpWaypoints.length - 2)
			{
				// Last segment: use the port approach direction (reversed for incoming)
				tmpTanToX = -pEndDir.dx;
				tmpTanToY = -pEndDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i];
				let tmpNext = tmpWaypoints[i + 2];
				tmpTanToX = tmpNext.x - tmpPrev.x;
				tmpTanToY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanToX * tmpTanToX + tmpTanToY * tmpTanToY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanToX /= tmpTanLen;
				tmpTanToY /= tmpTanLen;
			}

			let tmpCP1X = tmpFrom.x + tmpTanFromX * tmpScale;
			let tmpCP1Y = tmpFrom.y + tmpTanFromY * tmpScale;
			let tmpCP2X = tmpTo.x - tmpTanToX * tmpScale;
			let tmpCP2Y = tmpTo.y - tmpTanToY * tmpScale;

			tmpPath += ` C ${tmpCP1X} ${tmpCP1Y}, ${tmpCP2X} ${tmpCP2Y}, ${tmpTo.x} ${tmpTo.y}`;
		}

		tmpPath += ` L ${pEnd.x} ${pEnd.y}`;

		return tmpPath;
	}

	/**
	 * Build an SVG orthogonal (right-angle) path string.
	 * Pattern: M start L depart L corner1 L corner2 L approach L end
	 *
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pDepart
	 * @param {{x: number, y: number}} pCorner1
	 * @param {{x: number, y: number}} pCorner2
	 * @param {{x: number, y: number}} pApproach
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string} SVG path d attribute
	 */
	buildOrthogonalPathString(pStart, pDepart, pCorner1, pCorner2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} L ${pCorner1.x} ${pCorner1.y} L ${pCorner2.x} ${pCorner2.y} L ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	// ---- Directional Geometry ----

	/**
	 * Compute full directional geometry between two port anchors, including
	 * departure/approach points and bezier control points.
	 *
	 * Uses sophisticated facing detection: when ports face each other the
	 * curve offset scales with inline distance; when ports are on the same
	 * axis but not facing, a wider offset prevents the path from collapsing;
	 * perpendicular exits use a moderate offset.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{departX: number, departY: number, approachX: number, approachY: number, cp1X: number, cp1Y: number, cp2X: number, cp2Y: number, startDir: {dx: number, dy: number}, endDir: {dx: number, dy: number}}}
	 */
	computeDirectionalGeometry(pStart, pEnd)
	{
		let tmpStartDir = this._FlowView._GeometryProvider.sideDirection(pStart.side || 'right');
		let tmpEndDir   = this._FlowView._GeometryProvider.sideDirection(pEnd.side   || 'left');

		let tmpStraightLen = 20;

		let tmpDepartX = pStart.x + tmpStartDir.dx * tmpStraightLen;
		let tmpDepartY = pStart.y + tmpStartDir.dy * tmpStraightLen;

		let tmpApproachX = pEnd.x + tmpEndDir.dx * tmpStraightLen;
		let tmpApproachY = pEnd.y + tmpEndDir.dy * tmpStraightLen;

		let tmpDX = Math.abs(tmpApproachX - tmpDepartX);
		let tmpDY = Math.abs(tmpApproachY - tmpDepartY);
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);

		let tmpBaseOffset = Math.max(Math.min(tmpDist * 0.4, 180), 30);

		let tmpSameAxis = (tmpStartDir.dx !== 0 && tmpEndDir.dx !== 0) ||
		                  (tmpStartDir.dy !== 0 && tmpEndDir.dy !== 0);

		let tmpFacingEachOther = false;
		if (tmpSameAxis)
		{
			if (tmpStartDir.dx === 1 && tmpEndDir.dx === -1 && pEnd.x >= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dx === -1 && tmpEndDir.dx === 1 && pEnd.x <= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === 1 && tmpEndDir.dy === -1 && pEnd.y >= pStart.y)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === -1 && tmpEndDir.dy === 1 && pEnd.y <= pStart.y)
			{
				tmpFacingEachOther = true;
			}
		}

		let tmpCurveOffset;

		if (tmpFacingEachOther)
		{
			let tmpInlineDist = (tmpStartDir.dx !== 0) ? tmpDX : tmpDY;
			tmpCurveOffset = Math.max(tmpInlineDist * 0.35, 30);
		}
		else if (tmpSameAxis)
		{
			tmpCurveOffset = Math.max(tmpBaseOffset, 60);
		}
		else
		{
			tmpCurveOffset = Math.max(tmpBaseOffset * 0.8, 40);
		}

		let tmpCP1X = tmpDepartX + tmpStartDir.dx * tmpCurveOffset;
		let tmpCP1Y = tmpDepartY + tmpStartDir.dy * tmpCurveOffset;
		let tmpCP2X = tmpApproachX + tmpEndDir.dx * tmpCurveOffset;
		let tmpCP2Y = tmpApproachY + tmpEndDir.dy * tmpCurveOffset;

		return {
			departX: tmpDepartX, departY: tmpDepartY,
			approachX: tmpApproachX, approachY: tmpApproachY,
			cp1X: tmpCP1X, cp1Y: tmpCP1Y,
			cp2X: tmpCP2X, cp2Y: tmpCP2Y,
			startDir: tmpStartDir, endDir: tmpEndDir
		};
	}

	// ---- Distance Utilities ----

	/**
	 * Distance from point (pPX, pPY) to line segment (pAX, pAY)-(pBX, pBY).
	 * Pure math utility, no state.
	 *
	 * @param {number} pPX
	 * @param {number} pPY
	 * @param {number} pAX
	 * @param {number} pAY
	 * @param {number} pBX
	 * @param {number} pBY
	 * @returns {number}
	 */
	distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		let tmpDX = pBX - pAX;
		let tmpDY = pBY - pAY;
		let tmpLenSq = tmpDX * tmpDX + tmpDY * tmpDY;

		if (tmpLenSq < 0.001)
		{
			// Degenerate segment
			let tmpDPX = pPX - pAX;
			let tmpDPY = pPY - pAY;
			return Math.sqrt(tmpDPX * tmpDPX + tmpDPY * tmpDPY);
		}

		// Project point onto segment, clamped to [0, 1]
		let tmpT = ((pPX - pAX) * tmpDX + (pPY - pAY) * tmpDY) / tmpLenSq;
		if (tmpT < 0) tmpT = 0;
		if (tmpT > 1) tmpT = 1;

		let tmpClosestX = pAX + tmpT * tmpDX;
		let tmpClosestY = pAY + tmpT * tmpDY;
		let tmpDistX = pPX - tmpClosestX;
		let tmpDistY = pPY - tmpClosestY;
		return Math.sqrt(tmpDistX * tmpDistX + tmpDistY * tmpDistY);
	}

	// ---- Auto Midpoint Calculation ----

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between
	 * two port anchors, using the full directional geometry (facing detection,
	 * adaptive curve offsets). Evaluates the cubic bezier at t=0.5.
	 *
	 * Used by ConnectionRenderer for connection midpoints.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		let tmpGeo = this.computeDirectionalGeometry(pStart, pEnd);

		return this.evaluateCubicBezier(
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			0.5
		);
	}

	/**
	 * Get the auto-calculated midpoint using simple span-based control points.
	 * Uses computeDepartApproach for basic geometry, then span * 0.4 for
	 * control point distance. Evaluates the cubic bezier at t=0.5.
	 *
	 * Used by TetherService for tether midpoints.
	 *
	 * @param {{x: number, y: number, side: string}} pFrom
	 * @param {{x: number, y: number, side: string}} pTo
	 * @param {number} pDepartDist - Departure/approach distance
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpointSimple(pFrom, pTo, pDepartDist)
	{
		let tmpDA = this.computeDepartApproach(pFrom, pTo, pDepartDist);

		let tmpSpanX = Math.abs(tmpDA.approachX - tmpDA.departX);
		let tmpSpanY = Math.abs(tmpDA.approachY - tmpDA.departY);
		let tmpSpan = Math.max(tmpSpanX, tmpSpanY, 40);
		let tmpCPDist = tmpSpan * 0.4;

		let tmpP0 = { x: tmpDA.departX, y: tmpDA.departY };
		let tmpP1 = { x: tmpDA.departX + tmpDA.fromDir.dx * tmpCPDist, y: tmpDA.departY + tmpDA.fromDir.dy * tmpCPDist };
		let tmpP2 = { x: tmpDA.approachX + tmpDA.toDir.dx * tmpCPDist, y: tmpDA.approachY + tmpDA.toDir.dy * tmpCPDist };
		let tmpP3 = { x: tmpDA.approachX, y: tmpDA.approachY };

		return this.evaluateCubicBezier(tmpP0, tmpP1, tmpP2, tmpP3, 0.5);
	}
}

module.exports = PictServiceFlowPathGenerator;

},{"fable-serviceproviderbase":59}],494:[function(require,module,exports){
arguments[4][237][0].apply(exports,arguments)
},{"dup":237,"fable-serviceproviderbase":59}],495:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-RenderManager
 *
 * Orchestrates rendering of the flow diagram: nodes, connections,
 * tethers, panels, SVG marker definitions, and node position updates.
 *
 * Extracted from PictView-Flow.js to isolate rendering orchestration
 * from data management and interaction handling.
 */
class PictServiceFlowRenderManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowRenderManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render the complete flow diagram
	 */
	renderFlow()
	{
		if (!this._FlowView) return;
		if (!this._FlowView._NodesLayer || !this._FlowView._ConnectionsLayer) return;

		// Clear existing SVG content
		while (this._FlowView._NodesLayer.firstChild)
		{
			this._FlowView._NodesLayer.removeChild(this._FlowView._NodesLayer.firstChild);
		}
		while (this._FlowView._ConnectionsLayer.firstChild)
		{
			this._FlowView._ConnectionsLayer.removeChild(this._FlowView._ConnectionsLayer.firstChild);
		}
		if (this._FlowView._EndpointsLayer)
		{
			while (this._FlowView._EndpointsLayer.firstChild) this._FlowView._EndpointsLayer.removeChild(this._FlowView._EndpointsLayer.firstChild);
		}
		if (this._FlowView._PortHintsLayer)
		{
			while (this._FlowView._PortHintsLayer.firstChild) this._FlowView._PortHintsLayer.removeChild(this._FlowView._PortHintsLayer.firstChild);
		}

		// Render connections first (behind nodes)
		for (let i = 0; i < this._FlowView._FlowData.Connections.length; i++)
		{
			let tmpConnection = this._FlowView._FlowData.Connections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConnection.Hash);

			this._FlowView._ConnectionRenderer.renderConnection(
				tmpConnection,
				this._FlowView._ConnectionsLayer,
				tmpIsSelected
			);
		}

		// Render nodes
		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			let tmpSelectedSet = this._FlowView._FlowData.ViewState.SelectedNodeHashes;
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedNodeHash === tmpNode.Hash)
				|| (Array.isArray(tmpSelectedSet) && tmpSelectedSet.indexOf(tmpNode.Hash) >= 0);
			let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);

			// Enrich saved port data with metadata from the node type's DefaultPorts.
			// Saved flow data may not include PortType or may have stale Side values,
			// so we match each port to its DefaultPort counterpart by Label and Direction,
			// then copy over PortType and Side from the authoritative node type definition.
			if (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultPorts && tmpNode.Ports)
			{
				for (let p = 0; p < tmpNode.Ports.length; p++)
				{
					let tmpPort = tmpNode.Ports[p];
					for (let d = 0; d < tmpNodeTypeConfig.DefaultPorts.length; d++)
					{
						let tmpDefault = tmpNodeTypeConfig.DefaultPorts[d];
						if (tmpDefault.Label === tmpPort.Label && tmpDefault.Direction === tmpPort.Direction)
						{
							if (tmpDefault.PortType)
							{
								tmpPort.PortType = tmpDefault.PortType;
							}
							if (tmpDefault.Side)
							{
								tmpPort.Side = tmpDefault.Side;
							}
							break;
						}
					}
				}
			}

			this._FlowView._NodeView.renderNode(tmpNode, this._FlowView._NodesLayer, tmpIsSelected, tmpNodeTypeConfig);
		}

		// Render properties panels and tethers
		if (this._FlowView._PropertiesPanelView && this._FlowView._PanelsLayer && this._FlowView._TethersLayer)
		{
			this._FlowView._PropertiesPanelView.renderPanels(
				this._FlowView._FlowData.OpenPanels,
				this._FlowView._PanelsLayer,
				this._FlowView._TethersLayer,
				this._FlowView._FlowData.ViewState.SelectedTetherHash
			);
		}

		// Update viewport transform
		this._FlowView.updateViewportTransform();
	}

	/**
	 * Re-render a single connection (remove and re-add) for smooth drag performance.
	 * @param {string} pConnectionHash
	 */
	renderSingleConnection(pConnectionHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		// Remove existing elements for this connection across all layers
		// where it might live (path / hit-area in connections, dots in
		// endpoints, hint paths in port-hints).
		this._removeConnectionElements(pConnectionHash);

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === pConnectionHash);
		this._FlowView._ConnectionRenderer.renderConnection(tmpConnection, this._FlowView._ConnectionsLayer, tmpIsSelected);
	}

	/**
	 * Re-render a single tether (remove and re-add) for smooth drag performance.
	 * @param {string} pPanelHash
	 */
	renderSingleTether(pPanelHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		// Remove existing tether elements for this panel
		let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${pPanelHash}"]`);
		for (let i = 0; i < tmpExisting.length; i++)
		{
			tmpExisting[i].remove();
		}

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		let tmpNodeData = this._FlowView.getNode(tmpPanel.NodeHash);
		if (!tmpNodeData) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === pPanelHash);
		this._FlowView._TetherService.renderTether(tmpPanel, tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
	}

	/**
	 * Update a single node's position in the SVG without full re-render (for drag performance)
	 * @param {string} pNodeHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateNodePosition(pNodeHash, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;

		if (this._FlowView.options.EnableGridSnap)
		{
			pX = this._FlowView._LayoutService.snapToGrid(pX, this._FlowView.options.GridSnapSize);
			pY = this._FlowView._LayoutService.snapToGrid(pY, this._FlowView.options.GridSnapSize);
		}

		tmpNode.X = pX;
		tmpNode.Y = pY;

		// Reset customized handle positions for connections/tethers involving this node
		this._FlowView._resetHandlesForNode(pNodeHash);

		// Update the node's SVG group transform for smooth dragging
		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${pNodeHash}"]`);
		if (tmpNodeGroup)
		{
			tmpNodeGroup.setAttribute('transform', `translate(${pX}, ${pY})`);
		}

		// Re-render connections that involve this node
		this.renderConnectionsForNode(pNodeHash);

		// Update tethers for any panels attached to this node
		this.renderTethersForNode(pNodeHash);
	}

	/**
	 * Re-render only connections that involve a specific node (for drag performance)
	 * @param {string} pNodeHash
	 */
	renderConnectionsForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		let tmpAffectedConnections = this._FlowView._FlowData.Connections.filter((pConn) =>
		{
			return pConn.SourceNodeHash === pNodeHash || pConn.TargetNodeHash === pNodeHash;
		});

		for (let i = 0; i < tmpAffectedConnections.length; i++)
		{
			let tmpConn = tmpAffectedConnections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConn.Hash);

			// Remove existing connection SVG elements across all layers
			this._removeConnectionElements(tmpConn.Hash);

			// Re-render this connection
			this._FlowView._ConnectionRenderer.renderConnection(tmpConn, this._FlowView._ConnectionsLayer, tmpIsSelected);
		}
	}

	/**
	 * Remove every SVG element tagged with `data-connection-hash="<hash>"`
	 * from any of the layers a connection might write into (connections,
	 * endpoints, port-hints). Centralised so per-connection re-render
	 * paths stay in sync with whatever layers ConnectionRenderer touches.
	 *
	 * @param {string} pConnectionHash
	 */
	_removeConnectionElements(pConnectionHash)
	{
		let tmpLayers =
		[
			this._FlowView._ConnectionsLayer,
			this._FlowView._EndpointsLayer,
			this._FlowView._PortHintsLayer
		];
		for (let i = 0; i < tmpLayers.length; i++)
		{
			let tmpLayer = tmpLayers[i];
			if (!tmpLayer) continue;
			let tmpExisting = tmpLayer.querySelectorAll(`[data-connection-hash="${pConnectionHash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}
		}
	}

	/**
	 * Re-render tethers for panels attached to a specific node (for drag performance).
	 * @param {string} pNodeHash
	 */
	renderTethersForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		let tmpAffectedPanels = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpAffectedPanels.length === 0) return;

		// Remove existing tethers for these panels and re-render via TetherService
		for (let i = 0; i < tmpAffectedPanels.length; i++)
		{
			let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${tmpAffectedPanels[i].Hash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}

			let tmpNodeData = this._FlowView.getNode(tmpAffectedPanels[i].NodeHash);
			if (!tmpNodeData) continue;

			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === tmpAffectedPanels[i].Hash);
			this._FlowView._TetherService.renderTether(tmpAffectedPanels[i], tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
		}
	}

	/**
	 * Re-inject SVG marker definitions (arrowheads).
	 * Called after a theme switch to update arrowhead colors.
	 */
	reinjectMarkerDefs()
	{
		if (!this._FlowView || !this._FlowView._ConnectorShapesProvider || !this._FlowView._SVGElement) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpDefs = this._FlowView._SVGElement.querySelector('defs');
		if (!tmpDefs) return;

		// Remove existing marker elements
		let tmpExistingMarkers = tmpDefs.querySelectorAll('marker');
		for (let i = 0; i < tmpExistingMarkers.length; i++)
		{
			tmpExistingMarkers[i].remove();
		}

		// Re-generate and inject
		let tmpMarkerMarkup = this._FlowView._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
		let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		tmpTempSVG.innerHTML = tmpMarkerMarkup;
		while (tmpTempSVG.firstChild)
		{
			tmpDefs.appendChild(tmpTempSVG.firstChild);
		}
	}
}

module.exports = PictServiceFlowRenderManager;

},{"fable-serviceproviderbase":59}],496:[function(require,module,exports){
arguments[4][239][0].apply(exports,arguments)
},{"dup":239,"fable-serviceproviderbase":59}],497:[function(require,module,exports){
arguments[4][240][0].apply(exports,arguments)
},{"dup":240,"fable-serviceproviderbase":59}],498:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-ViewportManager
 *
 * Manages viewport transforms (pan/zoom), coordinate conversion between
 * screen and SVG space, zoom-to-fit calculations, and fullscreen toggling
 * for the flow diagram.
 */
class PictServiceFlowViewportManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowViewportManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._IsFullscreen = false;
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		if (!this._FlowView._ViewportElement) return;
		let tmpVS = this._FlowView._FlowData.ViewState;
		this._FlowView._ViewportElement.setAttribute('transform',
			`translate(${tmpVS.PanX}, ${tmpVS.PanY}) scale(${tmpVS.Zoom})`
		);
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		let tmpNewZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, pZoom));
		let tmpOldZoom = this._FlowView._FlowData.ViewState.Zoom;

		if (typeof pFocusX === 'number' && typeof pFocusY === 'number')
		{
			// Zoom toward focus point
			let tmpVS = this._FlowView._FlowData.ViewState;
			tmpVS.PanX = pFocusX - (pFocusX - tmpVS.PanX) * (tmpNewZoom / tmpOldZoom);
			tmpVS.PanY = pFocusY - (pFocusY - tmpVS.PanY) * (tmpNewZoom / tmpOldZoom);
		}

		this._FlowView._FlowData.ViewState.Zoom = tmpNewZoom;
		this.updateViewportTransform();
	}

	/**
	 * Zoom to fit all nodes in the viewport
	 */
	zoomToFit()
	{
		if (this._FlowView._FlowData.Nodes.length === 0) return;
		if (!this._FlowView._SVGElement) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			tmpMinX = Math.min(tmpMinX, tmpNode.X);
			tmpMinY = Math.min(tmpMinY, tmpNode.Y);
			tmpMaxX = Math.max(tmpMaxX, tmpNode.X + tmpNode.Width);
			tmpMaxY = Math.max(tmpMaxY, tmpNode.Y + tmpNode.Height);
		}

		let tmpPadding = 50;
		let tmpFlowWidth = tmpMaxX - tmpMinX + tmpPadding * 2;
		let tmpFlowHeight = tmpMaxY - tmpMinY + tmpPadding * 2;

		let tmpSVGRect = this._FlowView._SVGElement.getBoundingClientRect();
		let tmpScaleX = tmpSVGRect.width / tmpFlowWidth;
		let tmpScaleY = tmpSVGRect.height / tmpFlowHeight;
		let tmpZoom = Math.min(tmpScaleX, tmpScaleY, 1.0); // Don't zoom in past 1.0
		tmpZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, tmpZoom));

		let tmpCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCenterY = (tmpMinY + tmpMaxY) / 2;

		this._FlowView._FlowData.ViewState.Zoom = tmpZoom;
		this._FlowView._FlowData.ViewState.PanX = (tmpSVGRect.width / 2) - (tmpCenterX * tmpZoom);
		this._FlowView._FlowData.ViewState.PanY = (tmpSVGRect.height / 2) - (tmpCenterY * tmpZoom);

		this.updateViewportTransform();
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		if (!this._FlowView._SVGElement)
		{
			return { x: pScreenX, y: pScreenY };
		}

		let tmpPoint = this._FlowView._SVGElement.createSVGPoint();
		tmpPoint.x = pScreenX;
		tmpPoint.y = pScreenY;

		let tmpCTM = this._FlowView._SVGElement.getScreenCTM();
		if (tmpCTM)
		{
			let tmpInverse = tmpCTM.inverse();
			let tmpTransformed = tmpPoint.matrixTransform(tmpInverse);
			// Account for viewport pan/zoom
			let tmpVS = this._FlowView._FlowData.ViewState;
			return {
				x: (tmpTransformed.x - tmpVS.PanX) / tmpVS.Zoom,
				y: (tmpTransformed.y - tmpVS.PanY) / tmpVS.Zoom
			};
		}

		return { x: pScreenX, y: pScreenY };
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length < 1) return this._IsFullscreen;

		let tmpContainer = tmpContainerElements[0];

		this._IsFullscreen = !this._IsFullscreen;

		if (this._IsFullscreen)
		{
			tmpContainer.classList.add('pict-flow-fullscreen');
		}
		else
		{
			tmpContainer.classList.remove('pict-flow-fullscreen');
		}

		return this._IsFullscreen;
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		if (!this._IsFullscreen) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length > 0)
		{
			tmpContainerElements[0].classList.remove('pict-flow-fullscreen');
		}

		this._IsFullscreen = false;
	}
}

module.exports = PictServiceFlowViewportManager;

},{"fable-serviceproviderbase":59}],499:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-FloatingToolbar',

	DefaultRenderable: 'Flow-FloatingToolbar-Content',
	DefaultDestinationAddress: '#Flow-FloatingToolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	// Host-supplied buttons (mirrors the docked toolbar's ToolbarExtraButtons), so floating mode keeps
	// the same custom buttons. Each entry is { Hash, Icon, Label?, Tooltip?, Active? }.
	ToolbarExtraButtons: [],

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-FloatingToolbar-Template',
			// Inline handlers route to the floating toolbar view via _Pict.views
			// (see _handleButtonClick / _startDrag / _toggleCollapse).
			Template: /*html*/`
<div class="pict-flow-floating-toolbar" id="Flow-FloatingToolbar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-floating-grip" id="Flow-FloatingGrip-{~D:Record.FlowViewIdentifier~}" title="Drag to move · Double-click to collapse"
		onmousedown="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._startDrag(event)"
		ondblclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleGripDoubleClick(event)">
		<span id="Flow-FloatingIcon-grip-{~D:Record.FlowViewIdentifier~}"></span>
	</div>
	<button class="pict-flow-floating-btn" data-flow-action="add-node" title="Add Node"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('add-node')">
		<span id="Flow-FloatingIcon-plus-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="cards-popup" title="Cards"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('cards-popup')">
		<span id="Flow-FloatingIcon-cards-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="delete-selected" title="Delete Selected"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('delete-selected')">
		<span id="Flow-FloatingIcon-trash-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-in" title="Zoom In"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-in')">
		<span id="Flow-FloatingIcon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-out" title="Zoom Out"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-out')">
		<span id="Flow-FloatingIcon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-fit" title="Fit to View"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-fit')">
		<span id="Flow-FloatingIcon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="auto-layout" title="Auto Layout"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('auto-layout')">
		<span id="Flow-FloatingIcon-auto-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="layout-popup" title="Layout"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('layout-popup')">
		<span id="Flow-FloatingIcon-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="fullscreen" title="Toggle Fullscreen"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('fullscreen')">
		<span id="Flow-FloatingIcon-fullscreen-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	{~TS:Flow-FloatingToolbar-Extra-Button:Record.ToolbarExtraButtons~}
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="dock-toolbar" title="Dock Toolbar"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('dock-toolbar')">
		<span id="Flow-FloatingIcon-dock-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
`
		},
		{
			Hash: 'Flow-FloatingToolbar-Extra-Button',
			// Icon-only host button (the floating toolbar is compact). Icon span
			// is filled post-render by _populateIcons (keyed by Hash).
			Template: /*html*/`<button class="pict-flow-floating-btn" title="{~D:Record.Tooltip~}" data-flow-action="extra" data-extra-hash="{~D:Record.Hash~}"
	onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleExtraClick('{~D:Record.Hash~}', this)">
	<span id="Flow-FloatingExtraIcon-{~D:Record.Hash~}-{~D:Record.FlowViewIdentifier~}"></span>
</button>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-FloatingToolbar-Content',
			TemplateHash: 'Flow-FloatingToolbar-Template',
			DestinationAddress: '#Flow-FloatingToolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowFloatingToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowFloatingToolbar';

		this._ToolbarView = null;
		this._FlowView = null;

		this._IsCollapsed = false;

		this._IsDragging = false;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragStartLeft = 0;
		this._DragStartTop = 0;

		this._BoundMouseMove = null;
		this._BoundMouseUp = null;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		// Stamp the owning view onto each host button so its row resolves.
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (Array.isArray(tmpExtraButtons))
		{
			for (let i = 0; i < tmpExtraButtons.length; i++)
			{
				tmpExtraButtons[i].FlowViewIdentifier = this.options.FlowViewIdentifier;
			}
		}
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	/**
	 * Handle a click on a host-supplied (ToolbarExtraButtons) floating button.
	 * Routes to the docked toolbar's _handleExtraAction (the single dispatch
	 * point that fires the FlowView's onToolbarButton hook).
	 *
	 * @param {string} pHash - The button's Hash
	 * @param {HTMLElement} pElement - The clicked button element
	 */
	_handleExtraClick(pHash, pElement)
	{
		if (this._ToolbarView)
		{
			this._ToolbarView._handleExtraAction(pHash, pElement);
		}
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Button clicks and grip drag/dblclick are wired inline in
		// Flow-FloatingToolbar-Template — see _handleButtonClick / _startDrag /
		// _handleGripDoubleClick. Only icon population and option-based
		// pruning happen here.
		this._populateIcons();

		let tmpFloatingToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpFloatingToolbar.length > 0)
		{
			if (this.options.EnableAddNode === false)
			{
				let tmpAddNodeBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="add-node"]');
				if (tmpAddNodeBtn)
				{
					tmpAddNodeBtn.remove();
				}
			}
			if (this.options.EnableCardPalette === false)
			{
				let tmpCardsBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="cards-popup"]');
				if (tmpCardsBtn)
				{
					tmpCardsBtn.remove();
				}
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Handle a click on a floating toolbar action button. Called from the
	 * inline `onclick` handler on each button.
	 *
	 * @param {string} pAction - Value of the button's data-flow-action attr
	 */
	_handleButtonClick(pAction)
	{
		if (pAction === 'dock-toolbar')
		{
			if (this._ToolbarView)
			{
				this._ToolbarView._setToolbarMode('docked');
			}
			return;
		}
		if (this._ToolbarView)
		{
			this._ToolbarView._handleToolbarAction(pAction);
		}
	}

	/**
	 * Handle a double-click on the grip. Toggles collapsed state and
	 * prevents the event from reaching the surrounding canvas. Called
	 * from the inline `ondblclick` handler.
	 *
	 * @param {Event} pEvent
	 */
	_handleGripDoubleClick(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function')
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		this._toggleCollapse();
	}

	/**
	 * Populate SVG icons into all floating toolbar button spans.
	 */
	_populateIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		let tmpIconMap =
		{
			'grip': 'grip',
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto-layout': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'fullscreen': 'fullscreen',
			'dock': 'dock'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-FloatingIcon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 16);
			}
		}

		// Host-supplied extra buttons (keyed by Hash, icon from the button's Icon key).
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (Array.isArray(tmpExtraButtons))
		{
			for (let i = 0; i < tmpExtraButtons.length; i++)
			{
				let tmpExtraIcon = this.pict.ContentAssignment.getElement(`#Flow-FloatingExtraIcon-${tmpExtraButtons[i].Hash}-${tmpFlowViewIdentifier}`);
				if (tmpExtraIcon.length > 0)
				{
					tmpExtraIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpExtraButtons[i].Icon, 16);
				}
			}
		}
	}

	/**
	 * Toggle the floating toolbar between expanded and collapsed (grip-only square) states.
	 */
	_toggleCollapse()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		this._IsCollapsed = !this._IsCollapsed;

		if (this._IsCollapsed)
		{
			tmpToolbar[0].classList.add('collapsed');
		}
		else
		{
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Start dragging the floating toolbar.
	 * @param {MouseEvent} pEvent
	 */
	_startDrag(pEvent)
	{
		pEvent.preventDefault();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		this._IsDragging = true;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._DragStartLeft = tmpEl.offsetLeft;
		this._DragStartTop = tmpEl.offsetTop;

		this._BoundMouseMove = (pMoveEvent) => { this._onDragMove(pMoveEvent); };
		this._BoundMouseUp = () => { this._onDragEnd(); };

		document.addEventListener('mousemove', this._BoundMouseMove);
		document.addEventListener('mouseup', this._BoundMouseUp);
	}

	/**
	 * Handle drag movement.
	 * @param {MouseEvent} pEvent
	 */
	_onDragMove(pEvent)
	{
		if (!this._IsDragging) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		let tmpDeltaX = pEvent.clientX - this._DragStartX;
		let tmpDeltaY = pEvent.clientY - this._DragStartY;

		let tmpNewLeft = this._DragStartLeft + tmpDeltaX;
		let tmpNewTop = this._DragStartTop + tmpDeltaY;

		// Clamp to parent bounds
		let tmpParent = tmpEl.parentElement;
		if (tmpParent)
		{
			let tmpMaxLeft = tmpParent.clientWidth - tmpEl.offsetWidth;
			let tmpMaxTop = tmpParent.clientHeight - tmpEl.offsetHeight;
			tmpNewLeft = Math.max(0, Math.min(tmpNewLeft, tmpMaxLeft));
			tmpNewTop = Math.max(0, Math.min(tmpNewTop, tmpMaxTop));
		}

		tmpEl.style.left = tmpNewLeft + 'px';
		tmpEl.style.top = tmpNewTop + 'px';
	}

	/**
	 * End dragging.
	 */
	_onDragEnd()
	{
		this._IsDragging = false;

		if (this._BoundMouseMove)
		{
			document.removeEventListener('mousemove', this._BoundMouseMove);
			this._BoundMouseMove = null;
		}
		if (this._BoundMouseUp)
		{
			document.removeEventListener('mouseup', this._BoundMouseUp);
			this._BoundMouseUp = null;
		}

		// Save position
		if (this._ToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
			if (tmpToolbar.length > 0)
			{
				this._ToolbarView._FloatingPosition.X = tmpToolbar[0].offsetLeft;
				this._ToolbarView._FloatingPosition.Y = tmpToolbar[0].offsetTop;
			}
		}
	}

	/**
	 * Show the floating toolbar at the saved position.
	 */
	show()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'block';
		}

		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length > 0 && this._ToolbarView)
		{
			tmpToolbar[0].style.left = this._ToolbarView._FloatingPosition.X + 'px';
			tmpToolbar[0].style.top = this._ToolbarView._FloatingPosition.Y + 'px';
		}

		// Restore expanded state when showing
		if (this._IsCollapsed && tmpToolbar.length > 0)
		{
			this._IsCollapsed = false;
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Hide the floating toolbar.
	 */
	hide()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'none';
		}
	}
}

module.exports = PictViewFlowFloatingToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":365}],500:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-NodeRenderer',

	AutoRender: false,

	// Title bar height for nodes
	NodeTitleBarHeight: 22
};

class PictViewFlowNode extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowNode';

		this._FlowView = null;
	}

	/**
	 * Render a node into the nodes SVG layer
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pNodesLayer - The SVG <g> element to append to
	 * @param {boolean} pIsSelected - Whether this node is selected
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	renderNode(pNodeData, pNodesLayer, pIsSelected, pNodeTypeConfig)
	{
		let tmpGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');

		// Build CSS class list with optional per-type modifier classes
		let tmpClassList = `pict-flow-node ${pIsSelected ? 'selected' : ''} pict-flow-node-${pNodeData.Type || 'default'}`;
		if (pNodeTypeConfig)
		{
			if (pNodeTypeConfig.PortLabelsOnHover) tmpClassList += ' pict-flow-node-port-labels-hover';
			if (pNodeTypeConfig.PortLabelsVertical) tmpClassList += ' pict-flow-node-port-labels-vertical';
		}

		// Resolve theme-aware ColorRole. Per-node override wins; falls back
		// to the node type's role. A role of 'none' (or empty string)
		// explicitly opts out — useful when a card wants to keep its
		// hex BodyStyle/TitleBarColor regardless of the host theme.
		let tmpColorRole = (typeof pNodeData.ColorRole !== 'undefined')
			? pNodeData.ColorRole
			: (pNodeTypeConfig && pNodeTypeConfig.ColorRole);
		if (tmpColorRole && tmpColorRole !== 'none')
		{
			tmpClassList += ' pict-flow-node-color-' + tmpColorRole;
		}
		// A host can stamp an extra CSS class onto a node via node.NodeClass (e.g. a moodboard marks a
		// card whose connection points should stay visible on a read-only board). Survives re-renders
		// because it lives on the node data.
		if (typeof pNodeData.NodeClass === 'string' && pNodeData.NodeClass)
		{
			tmpClassList += ' ' + pNodeData.NodeClass;
		}
		tmpGroup.setAttribute('class', tmpClassList);
		tmpGroup.setAttribute('transform', `translate(${pNodeData.X}, ${pNodeData.Y})`);
		tmpGroup.setAttribute('data-node-hash', pNodeData.Hash);
		tmpGroup.setAttribute('data-element-type', 'node');

		// Hover the whole node → activate every port-hint that points
		// at any of this node's ports. Lets the user see *all* of the
		// node's reroute lines at once, not just one badge at a time.
		if (this._FlowView._PortRenderer && typeof this._FlowView._PortRenderer._wirePortHintHover === 'function')
		{
			this._FlowView._PortRenderer._wirePortHintHover(tmpGroup, null, pNodeData.Hash);
		}

		let tmpWidth = pNodeData.Width || 180;
		let tmpHeight = pNodeData.Height || 80;
		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;

		// Ensure node is tall enough for all ports in their zones
		let tmpGeomProvider = this._FlowView._GeometryProvider;
		if (tmpGeomProvider && pNodeData.Ports && pNodeData.Ports.length > 0)
		{
			let tmpMinHeight = tmpGeomProvider.computeMinimumNodeHeight(pNodeData.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Write the adjusted dimensions back to the node data so that
		// connection rendering (which reads pNodeData.Width/Height to
		// compute port positions) uses the same values we render with.
		pNodeData.Width = tmpWidth;
		pNodeData.Height = tmpHeight;

		// Optional rotation (degrees) about the node's center. Applied on top of the position
		// translate so free-form canvases can tilt a card; zero / unset leaves it axis-aligned.
		if (typeof pNodeData.Rotation === 'number' && pNodeData.Rotation)
		{
			tmpGroup.setAttribute('transform', PictViewFlowNode.nodeTransform(pNodeData.X, pNodeData.Y, pNodeData.Rotation, tmpWidth, tmpHeight));
		}

		// Determine node body mode from theme (bracket vs rect)
		let tmpNodeBodyMode = 'rect';
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.NodeBodyMode)
			{
				tmpNodeBodyMode = tmpActiveTheme.NodeBodyMode;
			}
		}

		if (tmpNodeBodyMode === 'bracket')
		{
			this._renderBracketNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}
		else
		{
			this._renderRectNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}

		// Determine if this node has a title-bar icon (FlowCard with CardMetadata)
		let tmpHasTitleIcon = false;
		let tmpTitleIconSize = 12;
		let tmpTitleIconMarginLeft = 8;
		let tmpTitleIconGap = 4;

		if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata)
		{
			let tmpMeta = pNodeTypeConfig.CardMetadata;
			let tmpIconProvider = this._FlowView._IconProvider;
			if (tmpMeta.Icon || tmpIconProvider)
			{
				tmpHasTitleIcon = true;
			}
		}

		// Title text (position adjusts when a title-bar icon is present)
		let tmpTitle = this._FlowView._SVGHelperProvider.createSVGElement('text');
		tmpTitle.setAttribute('class', 'pict-flow-node-title');
		if (tmpHasTitleIcon)
		{
			tmpTitle.setAttribute('x', String(tmpTitleIconMarginLeft + tmpTitleIconSize + tmpTitleIconGap));
			tmpTitle.setAttribute('text-anchor', 'start');
		}
		else
		{
			tmpTitle.setAttribute('x', String(tmpWidth / 2));
			tmpTitle.setAttribute('text-anchor', 'middle');
		}
		tmpTitle.setAttribute('y', String(tmpTitleBarHeight / 2 + 1));
		tmpTitle.setAttribute('dominant-baseline', 'central');
		tmpTitle.textContent = pNodeData.Title || 'Untitled';
		tmpGroup.appendChild(tmpTitle);

		// Determine whether labels should be rendered
		let tmpShowTypeLabel = (!pNodeTypeConfig || pNodeTypeConfig.ShowTypeLabel !== false);
		let tmpLabelsInFront = (!pNodeTypeConfig || pNodeTypeConfig.LabelsInFront !== false);

		// Helper: render type label + code badge + tooltip (the "middle labels")
		let tmpRenderTypeLabels = () =>
		{
			// Type label (below title bar — hover-only for FlowCard nodes via CSS)
			if (tmpShowTypeLabel && pNodeTypeConfig && pNodeTypeConfig.Label && pNodeTypeConfig.Label !== pNodeData.Title)
			{
				let tmpTypeLabel = this._FlowView._SVGHelperProvider.createSVGElement('text');
				tmpTypeLabel.setAttribute('class', 'pict-flow-node-type-label');
				tmpTypeLabel.setAttribute('x', String(tmpWidth / 2));
				tmpTypeLabel.setAttribute('y', String(tmpTitleBarHeight + 16));
				tmpTypeLabel.setAttribute('text-anchor', 'middle');
				tmpTypeLabel.setAttribute('dominant-baseline', 'central');
				tmpTypeLabel.textContent = pNodeTypeConfig.Label;
				tmpGroup.appendChild(tmpTypeLabel);
			}

			// FlowCard metadata: icon in title bar, code badge in body (hover-only via CSS). Skip the
			// title icon entirely when there is no title bar (height 0), e.g. edge-to-edge moodboard
			// cards, otherwise the default fallback glyph paints in the card's top-left corner.
			if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata && tmpTitleBarHeight > 0)
			{
				let tmpMeta = pNodeTypeConfig.CardMetadata;
				let tmpIconProvider = this._FlowView._IconProvider;
				let tmpTitleIconRendered = false;

				// Icon position in title bar (vertically centered)
				let tmpIconX = tmpTitleIconMarginLeft;
				let tmpIconY = (tmpTitleBarHeight - tmpTitleIconSize) / 2;

				if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// SVG icon via the icon provider — rendered into title bar
					let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						tmpResolvedKey, tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon && tmpIconProvider && tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// Emoji icon in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon)
				{
					// No icon provider — text fallback in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}

				// Default fallback icon in title bar
				if (!tmpTitleIconRendered && tmpIconProvider)
				{
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						'default', tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
				}

				// Code badge in body (hover-only via CSS, skipped when ShowTypeLabel is false)
				let tmpBodyCenterY = tmpTitleBarHeight + (tmpHeight - tmpTitleBarHeight) / 2;
				if (tmpShowTypeLabel && tmpMeta.Code)
				{
					let tmpCodeText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpCodeText.setAttribute('class', 'pict-flow-node-card-code');
					tmpCodeText.setAttribute('font-size', '10');
					tmpCodeText.setAttribute('font-family', 'monospace');
					tmpCodeText.setAttribute('fill', 'var(--theme-color-text-secondary, #7f8c8d)');
					tmpCodeText.setAttribute('text-anchor', 'middle');
					tmpCodeText.setAttribute('dominant-baseline', 'central');
					tmpCodeText.setAttribute('pointer-events', 'none');
					tmpCodeText.setAttribute('x', String(tmpWidth / 2));
					tmpCodeText.setAttribute('y', String(tmpBodyCenterY));
					tmpCodeText.textContent = tmpMeta.Code;
					tmpGroup.appendChild(tmpCodeText);
				}

				// Tooltip via SVG <title> element
				if (tmpMeta.Tooltip || tmpMeta.Description)
				{
					let tmpSVGTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
					tmpSVGTitle.textContent = tmpMeta.Tooltip || tmpMeta.Description;
					tmpGroup.appendChild(tmpSVGTitle);
				}
			}
		};

		// Render order depends on LabelsInFront:
		//   true  (default): body content first, then labels + ports (labels on top)
		//   false:           labels + ports first, then body content (content on top)
		if (tmpLabelsInFront)
		{
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}
		else
		{
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}

		// Panel indicator icon (small rect in bottom-right corner)
		if (pNodeTypeConfig && pNodeTypeConfig.PropertiesPanel)
		{
			let tmpIndicatorSize = 10;
			let tmpIndicatorMargin = 4;
			let tmpIndicatorX = tmpWidth - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpIndicatorY = tmpHeight - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
			let tmpIndicator;

			if (tmpShapeProvider)
			{
				tmpIndicator = tmpShapeProvider.createPanelIndicatorElement(
					pNodeData.Hash, tmpIndicatorX, tmpIndicatorY,
					tmpIndicatorSize, tmpIndicatorSize);
			}
			else
			{
				tmpIndicator = this._FlowView._SVGHelperProvider.createSVGElement('rect');
				tmpIndicator.setAttribute('class', 'pict-flow-node-panel-indicator');
				tmpIndicator.setAttribute('x', String(tmpIndicatorX));
				tmpIndicator.setAttribute('y', String(tmpIndicatorY));
				tmpIndicator.setAttribute('width', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('height', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('rx', '2');
				tmpIndicator.setAttribute('ry', '2');
				tmpIndicator.setAttribute('data-node-hash', pNodeData.Hash);
				tmpIndicator.setAttribute('data-element-type', 'panel-indicator');
			}

			let tmpIndicatorTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
			tmpIndicatorTitle.textContent = 'Double-click to open properties';
			tmpIndicator.appendChild(tmpIndicatorTitle);

			tmpGroup.appendChild(tmpIndicator);
		}

		// Resize handle: a small grip at the bottom-right corner, shown only when this node is
		// selected and the flow allows node resizing. Its data-element-type routes pointer-down to
		// the InteractionManager's node-resize path. Appended last so it paints over the body.
		if (pIsSelected && this._FlowView.options && this._FlowView.options.EnableNodeResizing)
		{
			let tmpHandleSize = 14;
			let tmpHandle = this._FlowView._SVGHelperProvider.createSVGElement('rect');
			tmpHandle.setAttribute('class', 'pict-flow-node-resize-handle');
			tmpHandle.setAttribute('x', String(tmpWidth - (tmpHandleSize - 4)));
			tmpHandle.setAttribute('y', String(tmpHeight - (tmpHandleSize - 4)));
			tmpHandle.setAttribute('width', String(tmpHandleSize));
			tmpHandle.setAttribute('height', String(tmpHandleSize));
			tmpHandle.setAttribute('rx', '3');
			tmpHandle.setAttribute('data-node-hash', pNodeData.Hash);
			tmpHandle.setAttribute('data-element-type', 'node-resize');
			tmpGroup.appendChild(tmpHandle);
		}

		pNodesLayer.appendChild(tmpGroup);
	}

	/**
	 * Render ports for a node — delegates to the PortRenderer service.
	 * @param {Object} pNodeData
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {Object} [pNodeTypeConfig] - Node type configuration (for label display options)
	 */
	_renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		this._FlowView._PortRenderer.renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig, this.options.NodeTitleBarHeight);
	}

	/**
	 * Render custom body content for a node (svg, html, or canvas).
	 *
	 * Checks for a BodyContent configuration on the node type and renders
	 * the appropriate content type into the node's SVG group.
	 *
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	_renderBodyContent(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		if (!pNodeTypeConfig || !pNodeTypeConfig.BodyContent) return;

		let tmpBodyContent = pNodeTypeConfig.BodyContent;
		let tmpContentType = tmpBodyContent.ContentType;
		if (!tmpContentType) return;

		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;
		let tmpPadding = (typeof tmpBodyContent.Padding === 'number') ? tmpBodyContent.Padding : 2;
		let tmpBodyBounds =
		{
			x: tmpPadding,
			y: tmpTitleBarHeight + tmpPadding,
			width: pWidth - (tmpPadding * 2),
			height: pHeight - tmpTitleBarHeight - (tmpPadding * 2)
		};

		let tmpPict = this._FlowView.pict || this.pict;

		// Register any templates defined in the BodyContent config (once)
		if (tmpBodyContent.Templates && Array.isArray(tmpBodyContent.Templates))
		{
			if (!this._registeredBodyTemplates)
			{
				this._registeredBodyTemplates = new Set();
			}
			for (let i = 0; i < tmpBodyContent.Templates.length; i++)
			{
				let tmpTpl = tmpBodyContent.Templates[i];
				if (tmpTpl.Hash && tmpTpl.Template && !this._registeredBodyTemplates.has(tmpTpl.Hash))
				{
					tmpPict.TemplateProvider.addTemplate(tmpTpl.Hash, tmpTpl.Template, 'PictViewFlowNode-BodyContent');
					this._registeredBodyTemplates.add(tmpTpl.Hash);
				}
			}
		}

		switch (tmpContentType)
		{
			case 'svg':
				this._renderBodyContentSVG(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'html':
				this._renderBodyContentHTML(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'canvas':
				this._renderBodyContentCanvas(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig);
				break;
			default:
				this.log.warn('PictViewFlowNode _renderBodyContent: unknown ContentType [' + tmpContentType + ']');
				break;
		}
	}

	/**
	 * Render SVG body content into a <g> group.
	 */
	_renderBodyContentSVG(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpContentGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');
		tmpContentGroup.setAttribute('class', 'pict-flow-node-body-content');
		tmpContentGroup.setAttribute('transform', `translate(${pBounds.x}, ${pBounds.y})`);

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			// Parse SVG markup into the group via a temporary SVG element
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpRenderedContent;
			while (tmpTempSVG.firstChild)
			{
				tmpContentGroup.appendChild(tmpTempSVG.firstChild);
			}
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpContentGroup, pNodeData, pNodeTypeConfig, pBounds);
		}

		pGroup.appendChild(tmpContentGroup);
	}

	/**
	 * Render HTML body content into a foreignObject.
	 */
	_renderBodyContentHTML(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpDiv = document.createElement('div');
		tmpDiv.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpDiv.setAttribute('class', 'pict-flow-node-body-content-html');

		// Pointer event isolation — prevent node drag/canvas pan.
		// Inline attribute handlers (visible in DOM, no closure leak).
		tmpDiv.setAttribute('onpointerdown', 'event.stopPropagation()');
		tmpDiv.setAttribute('onwheel', 'event.stopPropagation()');

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			tmpDiv.innerHTML = tmpRenderedContent;
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpDiv, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpDiv);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Render canvas body content into a foreignObject.
	 */
	_renderBodyContentCanvas(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpCanvas = document.createElement('canvas');
		tmpCanvas.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpCanvas.setAttribute('class', 'pict-flow-node-body-content-canvas');
		tmpCanvas.width = Math.floor(pBounds.width);
		tmpCanvas.height = Math.floor(pBounds.height);
		tmpCanvas.style.width = '100%';
		tmpCanvas.style.height = '100%';

		// Pointer event isolation — inline attribute handlers.
		tmpCanvas.setAttribute('onpointerdown', 'event.stopPropagation()');
		tmpCanvas.setAttribute('onwheel', 'event.stopPropagation()');

		// Invoke render callback (the primary rendering path for canvas)
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpCanvas, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpCanvas);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Resolve and render a body content template string.
	 * @param {Object} pBodyContent - The BodyContent config
	 * @param {Object} pNodeData - The node data (template record)
	 * @param {Object} pPict - The Pict instance
	 * @returns {string|null} Rendered template content, or null
	 */
	_resolveBodyTemplate(pBodyContent, pNodeData, pPict)
	{
		if (pBodyContent.TemplateHash)
		{
			return pPict.parseTemplateByHash(pBodyContent.TemplateHash, pNodeData);
		}
		if (pBodyContent.Template)
		{
			return pPict.parseTemplate(pBodyContent.Template, pNodeData, null, [pNodeData]);
		}
		return null;
	}

	// ── Node Body Renderers ──────────────────────────────────────────────

	/**
	 * Render the standard rect-based node body (default mode).
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	// Append a CSS fragment to an SVG element's inline style (which wins over the stylesheet), keeping
	// any existing inline style.
	_appendElementStyle(pElement, pStyleFragment)
	{
		let tmpExisting = pElement.getAttribute('style') || '';
		if (tmpExisting && tmpExisting.charAt(tmpExisting.length - 1) !== ';') { tmpExisting += ';'; }
		pElement.setAttribute('style', tmpExisting + pStyleFragment);
	}

	/**
	 * Height of the strip that squares off the bottom corners of the title bar. It must cover the
	 * bottom rounded corners (so the title bar meets the body in a straight seam) but must never reach
	 * the top ones, so it is capped at half the title bar height. Without the cap a corner radius
	 * larger than the title bar (a capsule card: radius 24 on a 22px bar) yields a strip taller than
	 * the whole title bar, which paints over the rounded TOP corners and makes the card read as square
	 * on top and rounded only on the bottom.
	 *
	 * @param {number|null} pCornerRadius - the card corner radius, or null for the theme default
	 * @param {number} pTitleBarHeight - the title bar height in user units
	 * @returns {number}
	 */
	static titleBarBottomStripHeight(pCornerRadius, pTitleBarHeight)
	{
		let tmpRadius = (typeof pCornerRadius === 'number') ? pCornerRadius : 0;
		return Math.min(Math.max(8, tmpRadius), Math.floor(pTitleBarHeight / 2));
	}

	/**
	 * The SVG group transform for a node: a position translate, plus a rotation about the node's
	 * center when a non-zero rotation (degrees) is given.
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pRotation - degrees; 0 / non-number means no rotation
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @returns {string}
	 */
	static nodeTransform(pX, pY, pRotation, pWidth, pHeight)
	{
		let tmpRotation = (typeof pRotation === 'number') ? pRotation : 0;
		if (!tmpRotation)
		{
			return `translate(${pX}, ${pY})`;
		}
		return `translate(${pX}, ${pY}) rotate(${tmpRotation} ${pWidth / 2} ${pHeight / 2})`;
	}

	_renderRectNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// Per-card corner radius (a node-data or node-type override of the theme default), so a card
		// type can read as a rounded rectangle, a capsule, or a sharp box. null leaves the
		// theme/CSS default in place. Set as the --pf-node-body-radius custom property on the node
		// group; the body and title-bar both read it through their `rx: var(--pf-node-body-radius)`,
		// and it inherits to both, so one assignment rounds the whole card.
		let tmpCornerRadius = (typeof pNodeData.CornerRadius === 'number') ? pNodeData.CornerRadius
			: ((pNodeTypeConfig && typeof pNodeTypeConfig.CornerRadius === 'number') ? pNodeTypeConfig.CornerRadius : null);
		if (tmpCornerRadius != null) { this._appendElementStyle(pGroup, '--pf-node-body-radius:' + tmpCornerRadius + 'px'); }

		// Node body (main rectangle)
		let tmpBody = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBody.setAttribute('class', 'pict-flow-node-body');
		tmpBody.setAttribute('x', '0');
		tmpBody.setAttribute('y', '0');
		tmpBody.setAttribute('width', String(pWidth));
		tmpBody.setAttribute('height', String(pHeight));
		tmpBody.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBody.setAttribute('data-element-type', 'node-body');

		// Apply custom styles from node type
		if (pNodeTypeConfig && pNodeTypeConfig.BodyStyle)
		{
			for (let tmpStyleKey in pNodeTypeConfig.BodyStyle)
			{
				tmpBody.setAttribute(tmpStyleKey, pNodeTypeConfig.BodyStyle[tmpStyleKey]);
			}
		}

		// Per-node BodyStyle override (wins over the node-type default).
		// Lets a flow author paint individual cards distinctly without
		// registering a new node type per category.
		if (pNodeData.BodyStyle)
		{
			for (let tmpStyleKey in pNodeData.BodyStyle)
			{
				tmpBody.setAttribute(tmpStyleKey, pNodeData.BodyStyle[tmpStyleKey]);
			}
		}

		// Apply per-instance style overrides (for node-specific editing)
		// These must be applied as inline styles so they override CSS rules
		// (CSS declarations take precedence over SVG presentation attributes).
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBody.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBody);

		// Title bar background (top portion)
		let tmpTitleBar = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBar.setAttribute('class', 'pict-flow-node-title-bar');
		tmpTitleBar.setAttribute('x', '0');
		tmpTitleBar.setAttribute('y', '0');
		tmpTitleBar.setAttribute('width', String(pWidth));
		tmpTitleBar.setAttribute('height', String(pTitleBarHeight));
		tmpTitleBar.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBar.setAttribute('data-element-type', 'node-body');

		// Apply custom title bar color
		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBar.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}
		// Per-node TitleBarColor (wins over node-type default).
		if (pNodeData.TitleBarColor)
		{
			tmpTitleBar.setAttribute('fill', pNodeData.TitleBarColor);
		}
		pGroup.appendChild(tmpTitleBar);

		// Title bar bottom fill: squares off the rounded corners at the bottom of the title bar so it
		// meets the body in a straight seam. See titleBarBottomStripHeight for why it is capped.
		let tmpBottomStripHeight = PictViewFlowNode.titleBarBottomStripHeight(tmpCornerRadius, pTitleBarHeight);
		let tmpTitleBarBottom = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBarBottom.setAttribute('class', 'pict-flow-node-title-bar-bottom');
		tmpTitleBarBottom.setAttribute('x', '0');
		tmpTitleBarBottom.setAttribute('y', String(pTitleBarHeight - tmpBottomStripHeight));
		tmpTitleBarBottom.setAttribute('width', String(pWidth));
		tmpTitleBarBottom.setAttribute('height', String(tmpBottomStripHeight));
		tmpTitleBarBottom.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBarBottom.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBarBottom.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}
		if (pNodeData.TitleBarColor)
		{
			tmpTitleBarBottom.setAttribute('fill', pNodeData.TitleBarColor);
		}

		// Per-instance title bar color override
		// Applied as inline style to override CSS rules.
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleBar.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
			tmpTitleBarBottom.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleBarBottom);
	}

	/**
	 * Render a bracket-style node body (used by sketch/blueprint themes).
	 *
	 * The bracket body consists of:
	 * 1. A fill rect for the body background (no stroke)
	 * 2. A fill rect for the title bar background (no stroke)
	 * 3. A bracket path drawn via the noise provider (outline + title divider)
	 *
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	_renderBracketNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// 1. Body fill rect (background only, no stroke)
		let tmpBodyFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBodyFill.setAttribute('class', 'pict-flow-node-body pict-flow-node-bracket-fill');
		tmpBodyFill.setAttribute('x', '0');
		tmpBodyFill.setAttribute('y', '0');
		tmpBodyFill.setAttribute('width', String(pWidth));
		tmpBodyFill.setAttribute('height', String(pHeight));
		tmpBodyFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBodyFill.setAttribute('data-element-type', 'node-body');

		// Per-instance style overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (tmpInlineStyles.length > 0)
			{
				tmpBodyFill.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBodyFill);

		// 2. Title bar fill rect (background only, no stroke)
		let tmpTitleFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleFill.setAttribute('class', 'pict-flow-node-title-bar pict-flow-node-bracket-title-fill');
		tmpTitleFill.setAttribute('x', '0');
		tmpTitleFill.setAttribute('y', '0');
		tmpTitleFill.setAttribute('width', String(pWidth));
		tmpTitleFill.setAttribute('height', String(pTitleBarHeight));
		tmpTitleFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleFill.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeTypeConfig.TitleBarColor);
		}
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleFill);

		// 3. Bracket path (outline + title divider with optional noise)
		let tmpBracketConfig = { SerifLength: 6, TitleSeparator: true };
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.BracketConfig)
			{
				tmpBracketConfig = Object.assign(tmpBracketConfig, tmpActiveTheme.BracketConfig);
			}
		}

		let tmpAmplitude = 0;
		if (this._FlowView._ThemeProvider)
		{
			tmpAmplitude = this._FlowView._ThemeProvider.getNodeNoiseAmplitude();
		}

		let tmpBracketD = '';
		if (this._FlowView._NoiseProvider)
		{
			tmpBracketD = this._FlowView._NoiseProvider.generateBracketPath(
				pWidth, pHeight,
				tmpBracketConfig.SerifLength,
				tmpBracketConfig.TitleSeparator ? pTitleBarHeight : 0,
				tmpAmplitude,
				pNodeData.Hash
			);
		}

		let tmpBracketPath = this._FlowView._SVGHelperProvider.createSVGElement('path');
		tmpBracketPath.setAttribute('class', 'pict-flow-node-bracket');
		tmpBracketPath.setAttribute('d', tmpBracketD);
		tmpBracketPath.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBracketPath.setAttribute('data-element-type', 'node-body');

		// Per-instance stroke overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBracketPath.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBracketPath);
	}
}

module.exports = PictViewFlowNode;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":365}],501:[function(require,module,exports){
arguments[4][244][0].apply(exports,arguments)
},{"dup":244,"pict-view":365}],502:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-Toolbar',

	DefaultRenderable: 'Flow-Toolbar-Content',
	DefaultDestinationAddress: '#Flow-Toolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	EnablePalette: true,
	EnableAddNode: true,
	EnableCardPalette: true,

	// Host-supplied buttons (set by the FlowView from its own ToolbarExtraButtons option). Each entry
	// is { Hash, Icon, Label?, Tooltip?, Active? }. Rendered as a group via Flow-Toolbar-Extra-Button.
	ToolbarExtraButtons: [],

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-Toolbar-Template',
			// Inline onclick handlers route to the toolbar via the FlowView
			// (the flow toolbar is reachable as ._ToolbarView from the
			// registered FlowView). Each button is responsible for its own
			// action — no event delegation.
			Template: /*html*/`
<div class="pict-flow-toolbar" id="Flow-Toolbar-Bar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="add-node" id="Flow-Toolbar-AddNode-{~D:Record.FlowViewIdentifier~}" title="Add Node"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('add-node')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-plus-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Node</span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="cards-popup" id="Flow-Toolbar-Cards-{~D:Record.FlowViewIdentifier~}" title="Card Palette"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('cards-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-cards-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Cards</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-CardsChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="delete-selected" title="Delete Node"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('delete-selected')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-trash-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="layout-popup" id="Flow-Toolbar-Layout-{~D:Record.FlowViewIdentifier~}" title="Manage saved layouts"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('layout-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-layout-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Layouts</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-LayoutChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<div class="pict-flow-toolbar-btn-split" id="Flow-Toolbar-Auto-{~D:Record.FlowViewIdentifier~}">
			<button class="pict-flow-toolbar-btn pict-flow-toolbar-btn-split-main" data-flow-action="apply-current-layout" title="Apply current layout algorithm"
				onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('apply-current-layout')">
				<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-auto-{~D:Record.FlowViewIdentifier~}"></span>
				<span class="pict-flow-toolbar-btn-text">Auto</span>
			</button>
			<button class="pict-flow-toolbar-btn pict-flow-toolbar-btn-split-chevron" data-flow-action="layout-algorithm-popup" title="Choose layout algorithm"
				onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('layout-algorithm-popup')">
				<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-AutoChevron-{~D:Record.FlowViewIdentifier~}"></span>
			</button>
		</div>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-in" title="Zoom In"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-in')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-out" title="Zoom Out"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-out')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-fit" title="Fit to View"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-fit')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group pict-flow-toolbar-extra">{~TS:Flow-Toolbar-Extra-Button:Record.ToolbarExtraButtons~}</div>
	<div class="pict-flow-toolbar-group pict-flow-toolbar-right">
		<button class="pict-flow-toolbar-btn" data-flow-action="settings-popup" id="Flow-Toolbar-Settings-{~D:Record.FlowViewIdentifier~}" title="Theme Settings"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('settings-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-settings-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="fullscreen" id="Flow-Toolbar-Fullscreen-{~D:Record.FlowViewIdentifier~}" title="Toggle Fullscreen"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('fullscreen')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Fullscreen-Icon-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="toggle-floating" title="Float"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('toggle-floating')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-grip-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="collapse-toolbar" title="Collapse Toolbar"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('collapse-toolbar')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-collapse-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
</div>
<div class="pict-flow-toolbar-collapsed" id="Flow-Toolbar-Collapsed-{~D:Record.FlowViewIdentifier~}">
	<button class="pict-flow-toolbar-expand-btn" data-flow-action="expand-toolbar" title="Expand Toolbar" id="Flow-Toolbar-ExpandBtn-{~D:Record.FlowViewIdentifier~}"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('expand-toolbar')">
		<span id="Flow-Toolbar-Icon-expand-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
<div class="pict-flow-toolbar-popup-anchor" id="Flow-Toolbar-PopupAnchor-{~D:Record.FlowViewIdentifier~}">
</div>
`
		},
		{
			Hash: 'Flow-Toolbar-Extra-Button',
			// Host-supplied button. The icon span is filled post-render by
			// _populateToolbarIcons (keyed by Hash), matching how the built-in
			// button icons are injected. FlowViewIdentifier + ActiveClass are
			// stamped onto each row in render().
			Template: /*html*/`<button class="pict-flow-toolbar-btn{~D:Record.ActiveClass~}" id="Flow-Toolbar-Extra-{~D:Record.Hash~}-{~D:Record.FlowViewIdentifier~}" title="{~D:Record.Tooltip~}" data-flow-action="extra" data-extra-hash="{~D:Record.Hash~}"
	onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleExtraAction('{~D:Record.Hash~}', this)">
	<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-ExtraIcon-{~D:Record.Hash~}-{~D:Record.FlowViewIdentifier~}"></span>
	<span class="pict-flow-toolbar-btn-text">{~D:Record.Label~}</span>
</button>`
		},
		{
			Hash: 'Flow-AddNode-List',
			// Iteration source is `Record.Rows` — the outer call sets the
			// FlowViewIdentifier on each row so inline handlers resolve their
			// owning view independently. Nested {~D:~} inside {~TS:~}
			// addresses isn't supported by the template engine, so we keep
			// addresses static.
			Template: '{~TS:Flow-AddNode-Row:Record.Rows~}'
		},
		{
			Hash: 'Flow-AddNode-Row',
			Template: '<div class="pict-flow-popup-list-item" data-node-type="{~D:Record.NodeType~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._addNodeFromPopup(this.getAttribute(\'data-node-type\'))">'
				+ '<span class="pict-flow-popup-list-item-icon">{~D:Record.IconHTML~}</span>'
				+ '<span class="pict-flow-popup-list-item-label">{~D:Record.Label~}</span>'
				+ '{~D:Record.CodeBlock~}'
				+ '</div>'
		},
		{
			Hash: 'Flow-Cards-List',
			Template: '{~TS:Flow-Cards-Category:Record.Categories~}'
		},
		{
			Hash: 'Flow-Cards-Category',
			Template: '<div class="pict-flow-palette-category" style="padding:0.35em 0.5em;">'
				+ '<div class="pict-flow-palette-category-label">{~D:Record.Name~}</div>'
				+ '<div class="pict-flow-palette-cards">{~TS:Flow-Cards-Card:Record.Cards~}</div>'
				+ '</div>'
		},
		{
			Hash: 'Flow-Cards-Card',
			// The icon / swatch / code spans are pre-rendered into complete HTML blocks by
			// _buildCardsPopup (a block is '' when its piece is absent). The template can't build them
			// inline: the engine does not parse a nested {~D:~} inside a {~NE:~} (its `~}` terminator
			// collides with the inner tag's), which left the palette showing raw template literals.
			Template: '<div class="pict-flow-palette-card{~D:Record.DisabledClass~}" data-card-type="{~D:Record.CardType~}" title="{~D:Record.Tooltip~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._addCardFromPopup(this.getAttribute(\'data-card-type\'))">'
				+ '{~D:Record.IconBlock~}'
				+ '{~D:Record.SwatchBlock~}'
				+ '<span class="pict-flow-palette-card-title">{~D:Record.Label~}</span>'
				+ '{~D:Record.CodeBlock~}'
				+ '</div>'
		},
		{
			Hash: 'Flow-Layout-List',
			Template: '{~TS:Flow-Layout-Row:Record.Rows~}'
		},
		{
			Hash: 'Flow-Layout-Row',
			Template: '<div class="pict-flow-popup-layout-row" data-layout-hash="{~D:Record.LayoutHash~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._restoreLayoutFromPopup(\'{~D:Record.LayoutHash~}\', event)">'
				+ '<span class="pict-flow-popup-layout-name">{~D:Record.Name~}</span>'
				+ '<button class="pict-flow-popup-layout-delete" title="Delete layout"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._deleteLayoutFromPopup(\'{~D:Record.LayoutHash~}\', event)">'
				+ '{~D:Record.DeleteIconHTML~}</button>'
				+ '</div>'
		},
		{
			Hash: 'Flow-Layout-OptionList',
			Template: '{~TS:Flow-Layout-Option:Record.Options~}'
		},
		{
			Hash: 'Flow-Layout-Option',
			Template: '<option value="{~D:Record.Value~}"{~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>'
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Toolbar-Content',
			TemplateHash: 'Flow-Toolbar-Template',
			DestinationAddress: '#Flow-Toolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowToolbar';

		this._FlowView = null;

		// Toolbar mode state
		this._ToolbarMode = 'docked'; // 'docked' | 'floating' | 'collapsed'
		this._ActivePopup = null;     // 'add-node' | 'cards' | 'layout' | null
		this._FloatingPosition = { X: 80, Y: 80 };
		this._DocumentClickHandler = null;
		this._FloatingToolbarView = null;

		// Layout-algorithm parameter form (pict-section-form metacontroller).
		// Lazily created on first popup open; null until then. Falls back to
		// hand-rolled inputs when PictFormMetacontroller is not registered.
		this._LayoutFormMetacontroller = null;
		this._LayoutFormHostID = null;
		// Whether the parameter form is expanded inside the popup. Persists
		// across popup opens so a user who collapsed it doesn't have to
		// re-collapse on every reopen. Defaults to expanded.
		this._LayoutFormExpanded = true;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		// Stamp the per-row render fields onto each host-supplied button so the
		// Flow-Toolbar-Extra-Button rows resolve their owning view and active
		// state (nested {~D:~} addressing inside {~TS:~} is not supported).
		this._stampExtraButtons();
		// Pass this.options as the template record so {~D:Record.FlowViewIdentifier~}
		// resolves correctly in the toolbar template.
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	/**
	 * Stamp FlowViewIdentifier + ActiveClass onto each ToolbarExtraButtons entry
	 * so the row template can address them.
	 */
	_stampExtraButtons()
	{
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (!Array.isArray(tmpExtraButtons)) return;
		for (let i = 0; i < tmpExtraButtons.length; i++)
		{
			tmpExtraButtons[i].FlowViewIdentifier = this.options.FlowViewIdentifier;
			tmpExtraButtons[i].ActiveClass = tmpExtraButtons[i].Active ? ' pict-flow-toolbar-btn-active' : '';
			// A label-less (icon-only) button renders an empty text span; CSS (:empty) collapses it.
			if (typeof tmpExtraButtons[i].Label !== 'string') { tmpExtraButtons[i].Label = ''; }
		}
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Click handlers live on each button as inline `onclick` attributes
		// in Flow-Toolbar-Template — they call _handleToolbarAction directly.

		// Populate SVG icons for toolbar buttons
		this._populateToolbarIcons();

		// Remove buttons from DOM based on options
		if (this.options.EnableAddNode === false)
		{
			let tmpAddNodeBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`);
			if (tmpAddNodeBtn.length > 0)
			{
				tmpAddNodeBtn[0].remove();
			}
		}
		if (this.options.EnableCardPalette === false)
		{
			let tmpCardsBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`);
			if (tmpCardsBtn.length > 0)
			{
				tmpCardsBtn[0].remove();
			}
		}
		if (this.options.EnableLayoutMenu === false)
		{
			let tmpAutoBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Auto-${tmpFlowViewIdentifier}`);
			if (tmpAutoBtn.length > 0)
			{
				tmpAutoBtn[0].remove();
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	// ── Icon Population ───────────────────────────────────────────────────

	/**
	 * Populate SVG icons for all toolbar buttons.
	 */
	_populateToolbarIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Map of element ID suffix → icon key
		let tmpIconMap =
		{
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'settings': 'settings',
			'grip': 'grip',
			'collapse': 'collapse',
			'expand': 'expand'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-Toolbar-Icon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 14);
			}
		}

		// Fullscreen icon
		let tmpFullscreenIcon = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
		if (tmpFullscreenIcon.length > 0)
		{
			tmpFullscreenIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup('fullscreen', 14);
		}

		// Chevrons (smaller)
		let tmpCardsChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-CardsChevron-${tmpFlowViewIdentifier}`);
		if (tmpCardsChevron.length > 0)
		{
			tmpCardsChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		let tmpLayoutChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-LayoutChevron-${tmpFlowViewIdentifier}`);
		if (tmpLayoutChevron.length > 0)
		{
			tmpLayoutChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		let tmpAutoChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-AutoChevron-${tmpFlowViewIdentifier}`);
		if (tmpAutoChevron.length > 0)
		{
			tmpAutoChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		// Host-supplied extra buttons (keyed by Hash, icon from the button's Icon key).
		let tmpExtraButtons = this.options.ToolbarExtraButtons;
		if (Array.isArray(tmpExtraButtons))
		{
			for (let i = 0; i < tmpExtraButtons.length; i++)
			{
				let tmpExtraIcon = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-ExtraIcon-${tmpExtraButtons[i].Hash}-${tmpFlowViewIdentifier}`);
				if (tmpExtraIcon.length > 0)
				{
					tmpExtraIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpExtraButtons[i].Icon, 14);
				}
			}
		}
	}

	// ── Popup Management ──────────────────────────────────────────────────

	/**
	 * Open a popup below a trigger button.
	 * @param {string} pType - 'add-node' | 'cards' | 'layout'
	 */
	_openPopup(pType)
	{
		// Toggle off if already open
		if (this._ActivePopup === pType)
		{
			this._closePopup();
			return;
		}

		// Close any existing popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		// Create popup div
		let tmpPopup = document.createElement('div');
		tmpPopup.className = 'pict-flow-toolbar-popup';
		tmpPopup.setAttribute('id', `Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);

		// Build popup content
		switch (pType)
		{
			case 'add-node':
				this._buildAddNodePopup(tmpPopup);
				break;
			case 'cards':
				this._buildCardsPopup(tmpPopup);
				break;
			case 'layout':
				this._buildLayoutPopup(tmpPopup);
				break;
			case 'layout-algorithm':
				this._buildLayoutAlgorithmPopup(tmpPopup);
				break;
			case 'settings':
				this._buildSettingsPopup(tmpPopup);
				break;
		}

		tmpAnchor[0].appendChild(tmpPopup);
		this._ActivePopup = pType;

		// Position the popup below the trigger button
		this._positionPopup(tmpPopup, pType);

		// Click-outside-to-close handler (delayed to avoid catching the opening click)
		setTimeout(() =>
		{
			this._DocumentClickHandler = (pEvent) =>
			{
				if (!tmpPopup.contains(pEvent.target))
				{
					// Check if click was on the trigger button itself (toggle behavior)
					let tmpButton = pEvent.target.closest('[data-flow-action]');
					if (tmpButton)
					{
						let tmpAction = tmpButton.getAttribute('data-flow-action');
						if (tmpAction === pType || tmpAction === pType.replace('-popup', '') + '-popup')
						{
							return; // Let the toggle handle it
						}
					}
					this._closePopup();
				}
			};
			document.addEventListener('click', this._DocumentClickHandler, true);
		}, 0);

		// Focus search input if Add Node popup
		if (pType === 'add-node')
		{
			let tmpSearch = tmpPopup.querySelector('.pict-flow-popup-search');
			if (tmpSearch)
			{
				setTimeout(() => { tmpSearch.focus(); }, 50);
			}
		}
	}

	/**
	 * Close the active popup and clean up.
	 */
	_closePopup()
	{
		if (this._DocumentClickHandler)
		{
			document.removeEventListener('click', this._DocumentClickHandler, true);
			this._DocumentClickHandler = null;
		}

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopup = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopup.length > 0)
		{
			tmpPopup[0].parentNode.removeChild(tmpPopup[0]);
		}

		this._ActivePopup = null;
	}

	/**
	 * Position a popup below its trigger button.
	 * @param {HTMLElement} pPopupDiv
	 * @param {string} pType
	 */
	_positionPopup(pPopupDiv, pType)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Determine which button triggered the popup
		let tmpTriggerSelector;
		switch (pType)
		{
			case 'add-node':
				tmpTriggerSelector = `#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`;
				break;
			case 'cards':
				tmpTriggerSelector = `#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`;
				break;
			case 'layout':
				tmpTriggerSelector = `#Flow-Toolbar-Layout-${tmpFlowViewIdentifier}`;
				break;
			case 'layout-algorithm':
				tmpTriggerSelector = `#Flow-Toolbar-Auto-${tmpFlowViewIdentifier}`;
				break;
			case 'settings':
				tmpTriggerSelector = `#Flow-Toolbar-Settings-${tmpFlowViewIdentifier}`;
				break;
			default:
				return;
		}

		let tmpTriggerElements = this.pict.ContentAssignment.getElement(tmpTriggerSelector);
		if (tmpTriggerElements.length < 1) return;

		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		let tmpTriggerRect = tmpTriggerElements[0].getBoundingClientRect();
		let tmpAnchorRect = tmpAnchor[0].getBoundingClientRect();

		let tmpLeft = tmpTriggerRect.left - tmpAnchorRect.left;
		pPopupDiv.style.left = tmpLeft + 'px';
		pPopupDiv.style.top = '0px';
	}

	// ── Add Node Popup ────────────────────────────────────────────────────

	/**
	 * Build the searchable Add Node popup content via templates with inline
	 * handlers. Search input fires `_filterNodeList` which re-renders the
	 * list section in place.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildAddNodePopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSearchIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('search', 12) : '';

		let tmpListID = `Flow-Toolbar-AddNodeList-${tmpFlowViewIdentifier}`;
		let tmpSearchID = `Flow-Toolbar-AddNodeSearch-${tmpFlowViewIdentifier}`;

		// Stage AppData and render the initial list HTML inline — the popup
		// element isn't in the DOM yet, so we can't look it up via
		// getElementById here. _filterNodeList handles updates after open.
		let tmpInitialListHTML = this._renderNodeListHTML('');

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-search-wrapper">'
			+ '<span class="pict-flow-popup-search-icon">' + tmpSearchIconHTML + '</span>'
			+ '<input id="' + tmpSearchID + '" class="pict-flow-popup-search" type="text" placeholder="Search node types..." '
			+ 'oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._filterNodeList(\'' + tmpListID + '\', this.value)" />'
			+ '</div>'
			+ '<div id="' + tmpListID + '" class="pict-flow-popup-node-list">' + tmpInitialListHTML + '</div>');
	}

	/**
	 * Build the HTML string for the Add Node list filtered by the given
	 * text. Stages AppData and renders the {~TS:~} template into a string;
	 * returns "no matches" markup when nothing matches.
	 *
	 * @param {string} pFilter
	 * @returns {string}
	 */
	_renderNodeListHTML(pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return '';

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpTypes = this._FlowView._NodeTypeProvider.getNodeTypes();
		let tmpTypeKeys = Object.keys(tmpTypes);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpIconProvider = this._FlowView._IconProvider;

		let tmpRows = [];
		for (let i = 0; i < tmpTypeKeys.length; i++)
		{
			let tmpTypeConfig = tmpTypes[tmpTypeKeys[i]];
			let tmpMeta = tmpTypeConfig.CardMetadata || {};
			if (tmpMeta.Enabled === false) continue;

			if (tmpFilter)
			{
				let tmpLabel = (tmpTypeConfig.Label || '').toLowerCase();
				let tmpCode = (tmpMeta.Code || '').toLowerCase();
				let tmpCategory = (tmpMeta.Category || '').toLowerCase();
				if (tmpLabel.indexOf(tmpFilter) < 0 && tmpCode.indexOf(tmpFilter) < 0 && tmpCategory.indexOf(tmpFilter) < 0) continue;
			}

			let tmpIconHTML = '';
			if (tmpIconProvider)
			{
				let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
				tmpIconHTML = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 16);
			}
			let tmpRowCode = tmpMeta.Code || '';
			tmpRows.push(
			{
				NodeType: tmpTypeKeys[i],
				Label: tmpTypeConfig.Label || '',
				IconHTML: tmpIconHTML,
				Code: tmpRowCode,
				// Pre-rendered so the template renders it with {~D:~} (a nested {~D:~} inside {~NE:~} is
				// not parsed by the engine).
				CodeBlock: tmpRowCode ? ('<span class="pict-flow-popup-list-item-code">' + tmpRowCode + '</span>') : '',
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		if (tmpRows.length === 0)
		{
			return '<div class="pict-flow-popup-list-empty">No matching node types</div>';
		}
		return this.pict.parseTemplateByHash('Flow-AddNode-List', { Rows: tmpRows });
	}

	/**
	 * Update the Add Node list contents in response to a search input
	 * change. Called from the inline `oninput` handler. The list element
	 * is already in the DOM by the time this fires.
	 *
	 * @param {string} pListID
	 * @param {string} pFilter
	 */
	_filterNodeList(pListID, pFilter)
	{
		let tmpListEl = document.getElementById(pListID);
		if (!tmpListEl) return;
		this.pict.ContentAssignment.assignContent(tmpListEl, this._renderNodeListHTML(pFilter));
	}

	/**
	 * Inline handler for an Add Node row click. Adds the node at viewport
	 * center and closes the popup.
	 *
	 * @param {string} pNodeType
	 */
	_addNodeFromPopup(pNodeType)
	{
		this._addNodeAtCenter(pNodeType);
		this._closePopup();
	}

	// ── Cards Popup ───────────────────────────────────────────────────────

	/**
	 * Build the Cards popup using templates with inline handlers. Search
	 * input fires `_filterCardsList` which re-renders the categorized list.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildCardsPopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSearchIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('search', 12) : '';

		let tmpListID = `Flow-Toolbar-CardsList-${tmpFlowViewIdentifier}`;
		let tmpSearchID = `Flow-Toolbar-CardsSearch-${tmpFlowViewIdentifier}`;

		// Initial render inline — popup not yet in DOM.
		let tmpInitialListHTML = this._renderCardsListHTML('');

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-search-wrapper">'
			+ '<span class="pict-flow-popup-search-icon">' + tmpSearchIconHTML + '</span>'
			+ '<input id="' + tmpSearchID + '" class="pict-flow-popup-search" type="text" placeholder="Search cards..." '
			+ 'oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._filterCardsList(\'' + tmpListID + '\', this.value)" />'
			+ '</div>'
			+ '<div id="' + tmpListID + '" class="pict-flow-popup-node-list">' + tmpInitialListHTML + '</div>');

		// Focus search input — defer past the popup append.
		setTimeout(() =>
		{
			let tmpSearch = document.getElementById(tmpSearchID);
			if (tmpSearch) tmpSearch.focus();
		}, 50);
	}

	/**
	 * Build the cards-list HTML string for the given filter. Stages
	 * AppData and renders via the {~TS:~} templates; returns "no matches"
	 * markup when nothing matches.
	 *
	 * @param {string} pFilter
	 * @returns {string}
	 */
	_renderCardsListHTML(pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return '';

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpCategories = this._FlowView._NodeTypeProvider.getCardsByCategory();
		let tmpCategoryKeys = Object.keys(tmpCategories);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpIconProvider = this._FlowView._IconProvider;
		let tmpTotalMatchCount = 0;

		let tmpCategoryRecords = [];
		for (let i = 0; i < tmpCategoryKeys.length; i++)
		{
			let tmpCategoryName = tmpCategoryKeys[i];
			let tmpCards = tmpCategories[tmpCategoryName];
			let tmpMatching = [];

			for (let j = 0; j < tmpCards.length; j++)
			{
				let tmpCardConfig = tmpCards[j];
				let tmpMeta = tmpCardConfig.CardMetadata || {};

				if (tmpFilter)
				{
					let tmpLabel = (tmpCardConfig.Label || '').toLowerCase();
					let tmpCode = (tmpMeta.Code || '').toLowerCase();
					let tmpCategory = tmpCategoryName.toLowerCase();
					if (tmpLabel.indexOf(tmpFilter) < 0 && tmpCode.indexOf(tmpFilter) < 0 && tmpCategory.indexOf(tmpFilter) < 0) continue;
				}

				let tmpIconHTML = '';
				let tmpIsEmoji = false;
				if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					tmpIconHTML = tmpIconProvider.getIconSVGMarkup(tmpIconProvider.resolveIconKey(tmpMeta), 14);
				}
				else if (tmpMeta.Icon)
				{
					tmpIsEmoji = true;
				}
				else if (tmpIconProvider)
				{
					tmpIconHTML = tmpIconProvider.getIconSVGMarkup('default', 14);
				}

				// Pre-render each conditional span into a complete HTML block ('' when absent). The
				// template renders these directly with {~D:~}; it cannot wrap them inline because the
				// engine does not parse a nested {~D:~} inside a {~NE:~}.
				let tmpCode = tmpMeta.Code || '';
				let tmpSwatchColor = (!tmpIconHTML && !tmpIsEmoji && tmpCardConfig.TitleBarColor) ? tmpCardConfig.TitleBarColor : '';
				let tmpIconBlock = '';
				if (tmpIconHTML) { tmpIconBlock = '<span class="pict-flow-palette-card-icon">' + tmpIconHTML + '</span>'; }
				else if (tmpIsEmoji) { tmpIconBlock = '<span class="pict-flow-palette-card-icon">' + tmpMeta.Icon + '</span>'; }
				let tmpSwatchBlock = tmpSwatchColor ? ('<span class="pict-flow-palette-card-swatch" style="background-color: ' + tmpSwatchColor + ';"></span>') : '';
				let tmpCodeBlock = tmpCode ? ('<span class="pict-flow-palette-card-code">' + tmpCode + '</span>') : '';

				tmpMatching.push(
				{
					CardType: tmpCardConfig.Hash,
					Label: tmpCardConfig.Label || '',
					Code: tmpCode,
					IconBlock: tmpIconBlock,
					SwatchBlock: tmpSwatchBlock,
					CodeBlock: tmpCodeBlock,
					DisabledClass: (tmpMeta.Enabled === false) ? ' disabled' : '',
					Tooltip: tmpMeta.Tooltip || tmpMeta.Description || '',
					FlowViewIdentifier: tmpFlowViewIdentifier
				});
			}

			if (tmpMatching.length === 0) continue;
			tmpTotalMatchCount += tmpMatching.length;
			tmpCategoryRecords.push(
			{
				Name: tmpCategoryName,
				Cards: tmpMatching,
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		if (tmpTotalMatchCount === 0)
		{
			return '<div class="pict-flow-popup-list-empty">' + (tmpFilter ? 'No matching cards' : 'No card types available') + '</div>';
		}
		return this.pict.parseTemplateByHash('Flow-Cards-List', { Categories: tmpCategoryRecords });
	}

	/**
	 * Inline `oninput` handler — refresh card list with the new filter.
	 */
	_filterCardsList(pListID, pFilter)
	{
		let tmpListEl = document.getElementById(pListID);
		if (!tmpListEl) return;
		this.pict.ContentAssignment.assignContent(tmpListEl, this._renderCardsListHTML(pFilter));
	}

	/**
	 * Inline handler for a card click. Adds the node and closes the popup.
	 *
	 * @param {string} pCardType
	 */
	_addCardFromPopup(pCardType)
	{
		this._addCardFromPalette(pCardType);
		this._closePopup();
	}

	// ── Layout Popup ──────────────────────────────────────────────────────

	/**
	 * Build the Layout popup using templates with inline handlers.
	 *
	 * Layout records (name + hash) are pushed into AppData and iterated via
	 * a {~TS:~} template. The save section is a static fragment with inline
	 * handlers that call the toolbar's helper methods.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildLayoutPopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSaveIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('save', 14) : '✓';
		let tmpDeleteIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('trash', 12) : '×';

		let tmpSaveRowID = `Flow-Toolbar-LayoutSaveRow-${tmpFlowViewIdentifier}`;
		let tmpSaveInputRowID = `Flow-Toolbar-LayoutSaveInputRow-${tmpFlowViewIdentifier}`;
		let tmpSaveInputID = `Flow-Toolbar-LayoutSaveInput-${tmpFlowViewIdentifier}`;
		let tmpListID = `Flow-Toolbar-LayoutList-${tmpFlowViewIdentifier}`;

		// Build layout records for the {~TS:~} iteration
		let tmpLayouts = (this._FlowView && this._FlowView._LayoutProvider)
			? this._FlowView._LayoutProvider.getLayouts() : [];
		let tmpLayoutRecords = [];
		for (let i = 0; i < tmpLayouts.length; i++)
		{
			tmpLayoutRecords.push(
			{
				LayoutHash: tmpLayouts[i].Hash,
				Name: tmpLayouts[i].Name || '',
				DeleteIconHTML: tmpDeleteIconHTML,
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		let tmpListHTML = (tmpLayoutRecords.length === 0)
			? '<div class="pict-flow-popup-list-empty">No saved layouts</div>'
			: this.pict.parseTemplateByHash('Flow-Layout-List', { Rows: tmpLayoutRecords });

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-layout-save-section">'
			+ '<div id="' + tmpSaveRowID + '" class="pict-flow-popup-layout-save"'
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._showLayoutSaveInput(\'' + tmpSaveRowID + '\', \'' + tmpSaveInputRowID + '\', \'' + tmpSaveInputID + '\')">'
			+ '<span class="pict-flow-popup-layout-save-icon">' + tmpSaveIconHTML + '</span>'
			+ '<span>Save Current Layout</span>'
			+ '</div>'
			+ '<div id="' + tmpSaveInputRowID + '" class="pict-flow-popup-layout-save-input-row" style="display:none;">'
			+ '<input id="' + tmpSaveInputID + '" class="pict-flow-popup-layout-save-input" type="text" placeholder="Layout name..."'
			+ ' onclick="event.stopPropagation()"'
			+ ' onkeydown="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleLayoutSaveKey(event, \'' + tmpSaveInputID + '\', \'' + tmpSaveRowID + '\', \'' + tmpSaveInputRowID + '\')" />'
			+ '<button class="pict-flow-popup-layout-save-confirm" title="Save"'
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._confirmLayoutSave(\'' + tmpSaveInputID + '\')">'
			+ tmpSaveIconHTML + '</button>'
			+ '</div>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div id="' + tmpListID + '">' + tmpListHTML + '</div>');
	}

	/**
	 * Inline handler — reveal the layout-name input and focus it.
	 */
	_showLayoutSaveInput(pSaveRowID, pInputRowID, pInputID)
	{
		let tmpRow = document.getElementById(pSaveRowID);
		let tmpInputRow = document.getElementById(pInputRowID);
		let tmpInput = document.getElementById(pInputID);
		if (tmpRow) tmpRow.style.display = 'none';
		if (tmpInputRow) tmpInputRow.style.display = '';
		if (tmpInput)
		{
			tmpInput.value = '';
			setTimeout(() => { tmpInput.focus(); }, 50);
		}
	}

	/**
	 * Inline handler — Enter saves, Escape cancels.
	 */
	_handleLayoutSaveKey(pEvent, pInputID, pSaveRowID, pInputRowID)
	{
		if (pEvent.key === 'Enter')
		{
			pEvent.preventDefault();
			this._confirmLayoutSave(pInputID);
		}
		else if (pEvent.key === 'Escape')
		{
			let tmpRow = document.getElementById(pSaveRowID);
			let tmpInputRow = document.getElementById(pInputRowID);
			if (tmpInputRow) tmpInputRow.style.display = 'none';
			if (tmpRow) tmpRow.style.display = '';
		}
	}

	/**
	 * Inline handler — save the layout under the entered name and rebuild
	 * the popup so the new entry appears.
	 */
	_confirmLayoutSave(pInputID)
	{
		let tmpInput = document.getElementById(pInputID);
		if (!tmpInput) return;
		let tmpName = (tmpInput.value || '').trim();
		if (tmpName === '') return;
		this._FlowView._LayoutProvider.saveLayout(tmpName);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — restore layout when the row (not its delete button)
	 * is clicked.
	 */
	_restoreLayoutFromPopup(pLayoutHash, pEvent)
	{
		if (pEvent && pEvent.target && pEvent.target.closest('.pict-flow-popup-layout-delete')) return;
		this._FlowView._LayoutProvider.restoreLayout(pLayoutHash);
		this._closePopup();
	}

	/**
	 * Inline handler — delete a saved layout and refresh the popup.
	 */
	_deleteLayoutFromPopup(pLayoutHash, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') pEvent.stopPropagation();
		this._FlowView._LayoutProvider.deleteLayout(pLayoutHash);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutPopup(tmpPopupEl);
	}

	// ── Layout Algorithm Popup ────────────────────────────────────────────

	/**
	 * Build the Layout Algorithm popup using templates with inline handlers.
	 * The popup has three logical sections (algorithm chooser, edge-theme
	 * chooser, auto-apply toggle + apply button). Each control's behavior
	 * lives on the toolbar as a helper method called from inline handlers.
	 *
	 * Iterations (algorithm options, edge themes) are template-driven via
	 * AppData arrays.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildLayoutAlgorithmPopup(pContainer)
	{
		if (!this._FlowView || !this._FlowView._LayoutService) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpLayoutService = this._FlowView._LayoutService;
		let tmpCurrentSettings = this._FlowView.getLayoutAlgorithm();
		let tmpAlgoDescriptor = tmpLayoutService.getAlgorithm(tmpCurrentSettings.Algorithm);
		let tmpEdgeSettings = this._FlowView.getEdgeTheme();
		let tmpResolvedEdge = tmpEdgeSettings.Theme;
		let tmpExplicitEdgeOverride = tmpEdgeSettings.Override;
		let tmpDefaultThemeName = (tmpAlgoDescriptor && tmpAlgoDescriptor.DefaultEdgeTheme) || 'Bezier';
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSettingsIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('settings', 13) : '⚙';

		// Build option records for the dropdowns
		let tmpAlgoOptions = tmpLayoutService.listAlgorithms().map((pAlgo) => (
		{
			Value: pAlgo.Name,
			Label: pAlgo.Label || pAlgo.Name,
			SelectedAttr: (pAlgo.Name === tmpCurrentSettings.Algorithm) ? ' selected="selected"' : ''
		}));

		let tmpEdgeOptionRecords = [];
		tmpEdgeOptionRecords.push(
		{
			Value: '__inherit__',
			Label: `Inherit from layout (${tmpDefaultThemeName})`,
			SelectedAttr: !tmpExplicitEdgeOverride ? ' selected="selected"' : ''
		});
		let tmpEdgeThemes = tmpLayoutService.listEdgeThemes();
		for (let i = 0; i < tmpEdgeThemes.length; i++)
		{
			tmpEdgeOptionRecords.push(
			{
				Value: tmpEdgeThemes[i].Name,
				Label: tmpEdgeThemes[i].Label || tmpEdgeThemes[i].Name,
				SelectedAttr: (tmpEdgeThemes[i].Name === tmpExplicitEdgeOverride) ? ' selected="selected"' : ''
			});
		}

		let tmpAlgoOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpAlgoOptions });
		let tmpEdgeOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpEdgeOptionRecords });

		let tmpHasParameters = !!(tmpAlgoDescriptor && (
			(tmpAlgoDescriptor.ParameterManifest && tmpAlgoDescriptor.ParameterManifest.Descriptors) ||
			(tmpAlgoDescriptor.ParameterSchema && Object.keys(tmpAlgoDescriptor.ParameterSchema).length > 0)
		));

		let tmpAlgoDescription = (tmpAlgoDescriptor && tmpAlgoDescriptor.Description)
			? '<div class="pict-flow-popup-control-description">' + tmpAlgoDescriptor.Description + '</div>'
			: '';

		let tmpFormToggleHTML = '';
		if (tmpHasParameters)
		{
			tmpFormToggleHTML = '<button type="button" class="pict-flow-popup-collapse-toggle"'
				+ ' aria-expanded="' + (this._LayoutFormExpanded ? 'true' : 'false') + '"'
				+ ' title="' + (this._LayoutFormExpanded ? 'Hide parameters' : 'Show parameters') + '"'
				+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._toggleLayoutFormCollapsed(this)">'
				+ tmpSettingsIconHTML
				+ '</button>';
		}

		let tmpAutoApplyID = `Flow-Toolbar-AutoApply-${tmpFlowViewIdentifier}`;
		let tmpApplyDisabled = (tmpCurrentSettings.Algorithm === 'Custom') ? ' disabled' : '';
		let tmpApplyTitle = (tmpCurrentSettings.Algorithm === 'Custom') ? ' title="Custom does not auto-position nodes"' : '';

		let tmpEdgeDescriptionHTML = '';
		if (tmpResolvedEdge)
		{
			let tmpResolvedDescriptor = tmpLayoutService.getEdgeTheme(tmpResolvedEdge);
			if (tmpResolvedDescriptor && tmpResolvedDescriptor.Description)
			{
				tmpEdgeDescriptionHTML = '<div class="pict-flow-popup-control-description">' + tmpResolvedDescriptor.Description + '</div>';
			}
		}

		// Place a host div for the parameter form; mount the form into it
		// after the popup is in the DOM (the metacontroller resolves
		// destinations via document.querySelector).
		let tmpParamFormHostID = `Flow-Toolbar-LayoutParamFormHost-${tmpFlowViewIdentifier}`;

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-settings-section pict-flow-popup-layout-algorithm-row">'
			+ '<label class="pict-flow-popup-settings-label">Algorithm</label>'
			+ '<div class="pict-flow-popup-layout-algorithm-controls">'
			+ '<select class="pict-flow-popup-settings-select pict-flow-popup-layout-algorithm-select" data-layout-control="algorithm"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleLayoutAlgoChange(this.value)">'
			+ tmpAlgoOptionsHTML
			+ '</select>'
			+ tmpFormToggleHTML
			+ '</div>'
			+ '</div>'
			+ tmpAlgoDescription
			+ '<div id="' + tmpParamFormHostID + '"></div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section">'
			+ '<label class="pict-flow-popup-settings-label">Edge theme</label>'
			+ '<select class="pict-flow-popup-settings-select" data-layout-control="edge-theme"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleEdgeThemeChange(this.value)">'
			+ tmpEdgeOptionsHTML
			+ '</select>'
			+ '</div>'
			+ tmpEdgeDescriptionHTML
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section" style="display:flex;align-items:center;gap:8px;">'
			+ '<input type="checkbox" id="' + tmpAutoApplyID + '"' + (tmpCurrentSettings.AutoApply ? ' checked="checked"' : '') + ''
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleAutoApplyChange(this.checked)" />'
			+ '<label class="pict-flow-popup-settings-label" for="' + tmpAutoApplyID + '" style="cursor:pointer;">Auto-apply on changes</label>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section" style="padding:4px 8px;">'
			+ '<button class="pict-flow-popup-layout-save-confirm" style="width:100%;padding:6px;"' + tmpApplyDisabled + tmpApplyTitle
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleApplyLayoutNow()">Apply Now</button>'
			+ '</div>');

		// Mount the parameter form (handles its own DOM building /
		// metacontroller). Use pContainer.querySelector — the popup may
		// not be in the document yet, so document.getElementById would miss.
		let tmpFormHostEl = pContainer.querySelector('#' + tmpParamFormHostID);
		if (tmpFormHostEl)
		{
			this._buildLayoutParameterFormSection(tmpFormHostEl, tmpAlgoDescriptor, tmpCurrentSettings);
		}
	}

	/**
	 * Inline handler — switch layout algorithm, refresh popup.
	 */
	_handleLayoutAlgoChange(pName)
	{
		if (!this._FlowView || !this._FlowView._LayoutService) return;
		let tmpAlgo = this._FlowView._LayoutService.getAlgorithm(pName);
		let tmpDefaults = (tmpAlgo && tmpAlgo.DefaultParameters)
			? JSON.parse(JSON.stringify(tmpAlgo.DefaultParameters)) : {};
		this._FlowView.setLayoutAlgorithm(pName, tmpDefaults);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutAlgorithmPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — switch edge theme, refresh popup so descriptions
	 * track the new theme.
	 */
	_handleEdgeThemeChange(pValue)
	{
		if (!this._FlowView) return;
		if (pValue === '__inherit__')
		{
			this._FlowView.setEdgeTheme(null);
		}
		else
		{
			this._FlowView.setEdgeTheme(pValue);
		}

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutAlgorithmPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — toggle auto-apply.
	 */
	_handleAutoApplyChange(pChecked)
	{
		if (!this._FlowView) return;
		this._FlowView.setLayoutAutoApply(pChecked);
	}

	/**
	 * Inline handler — fire the layout (when not Custom).
	 */
	_handleApplyLayoutNow()
	{
		if (!this._FlowView) return;
		let tmpSettings = this._FlowView.getLayoutAlgorithm();
		if (tmpSettings.Algorithm === 'Custom') return;
		this._FlowView.applyCurrentLayout();
	}

	/**
	 * Inline handler — toggle the parameter-form collapse state.
	 */
	_toggleLayoutFormCollapsed(pToggleButton)
	{
		this._LayoutFormExpanded = !this._LayoutFormExpanded;
		pToggleButton.setAttribute('aria-expanded', this._LayoutFormExpanded ? 'true' : 'false');
		pToggleButton.title = this._LayoutFormExpanded ? 'Hide parameters' : 'Show parameters';
		let tmpHost = this._LayoutFormHostID ? document.getElementById(this._LayoutFormHostID) : null;
		if (tmpHost)
		{
			tmpHost.setAttribute('data-collapsed', this._LayoutFormExpanded ? 'false' : 'true');
		}
	}

	/**
	 * Render the parameter form section. When the host app has registered
	 * `PictFormMetacontroller` and the algorithm provides a
	 * `ParameterManifest`, we inject that manifest into a section-form so
	 * the user gets the same Manyfest-driven UX as the rest of the Pict
	 * ecosystem. Otherwise we fall back to schema-driven hand-rolled inputs.
	 *
	 * Data binding: `pict.AppData.PictFlowLayoutEditor.Parameters` is a
	 * mirror of `_FlowData.LayoutParameters`. The form's Informary writes
	 * directly into AppData; a `change`/`input` listener on the popup
	 * pushes those edits back into `_FlowData.LayoutParameters` and (when
	 * the active algorithm is non-Custom) re-applies the layout.
	 *
	 * @param {HTMLElement} pContainer
	 * @param {Object} pAlgoDescriptor - the descriptor for the active algorithm
	 * @param {{ Algorithm: string, Parameters: Object }} pCurrentSettings
	 */
	_buildLayoutParameterFormSection(pContainer, pAlgoDescriptor, pCurrentSettings)
	{
		if (!pAlgoDescriptor) return;

		let tmpHasManifest = !!(pAlgoDescriptor.ParameterManifest && pAlgoDescriptor.ParameterManifest.Descriptors);
		let tmpMetacontrollerType = this._resolveMetacontrollerServiceType();

		if (tmpHasManifest && tmpMetacontrollerType)
		{
			this._mountLayoutParameterMetacontroller(pContainer, pAlgoDescriptor, pCurrentSettings, tmpMetacontrollerType);
			return;
		}

		// Fallback path — schema-driven hand-rolled inputs.
		let tmpSchema = (pAlgoDescriptor.ParameterSchema) ? pAlgoDescriptor.ParameterSchema : {};
		let tmpParamKeys = Object.keys(tmpSchema);
		if (tmpParamKeys.length === 0) return;

		let tmpParamDivider = document.createElement('div');
		tmpParamDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpParamDivider);

		let tmpParamHeader = document.createElement('div');
		tmpParamHeader.className = 'pict-flow-popup-settings-label';
		tmpParamHeader.style.fontWeight = 'bold';
		tmpParamHeader.style.padding = '4px 8px';
		tmpParamHeader.textContent = 'Parameters';
		pContainer.appendChild(tmpParamHeader);

		for (let i = 0; i < tmpParamKeys.length; i++)
		{
			let tmpKey = tmpParamKeys[i];
			let tmpFieldSchema = tmpSchema[tmpKey];
			let tmpCurrentValue = (pCurrentSettings.Parameters && pCurrentSettings.Parameters.hasOwnProperty(tmpKey))
				? pCurrentSettings.Parameters[tmpKey]
				: tmpFieldSchema.Default;

			let tmpRow = document.createElement('div');
			tmpRow.className = 'pict-flow-popup-settings-section';
			tmpRow.style.display = 'flex';
			tmpRow.style.alignItems = 'center';
			tmpRow.style.gap = '8px';

			let tmpRowLabel = document.createElement('label');
			tmpRowLabel.className = 'pict-flow-popup-settings-label';
			tmpRowLabel.textContent = tmpFieldSchema.Label || tmpKey;
			tmpRowLabel.style.flex = '1';
			tmpRow.appendChild(tmpRowLabel);

			let tmpInput = this._buildLayoutParamInput(tmpKey, tmpFieldSchema, tmpCurrentValue);
			tmpRow.appendChild(tmpInput);
			pContainer.appendChild(tmpRow);
		}
	}

	/**
	 * Remove `PictSectionForm-*` views the layout-algorithm popup has
	 * previously registered on the host Pict. Without this, switching
	 * algorithms accumulates dead section views — the metatemplate
	 * generated by the next inject would still reference the old ones.
	 * Idempotent.
	 */
	_evictLayoutFormViews()
	{
		if (!this.pict || !this.pict.views) return;
		let tmpKeys = Object.keys(this.pict.views);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			if (tmpKey.indexOf('PictSectionForm-') === 0 && tmpKey.indexOf('PictFlowLayout') > 0)
			{
				delete this.pict.views[tmpKey];
				continue;
			}
			// Match any previously-injected layout-algorithm section by hash
			// suffix (manifests use unique algorithm-suffixed section names).
			if (tmpKey.indexOf('PictSectionForm-PFL') === 0)
			{
				delete this.pict.views[tmpKey];
			}
		}
		this._LayoutFormMetacontroller = null;
	}

	/**
	 * Look up which form-metacontroller service is registered on the host
	 * Pict instance. pict-section-form has been published under both
	 * 'PictFormMetacontroller' and (older) 'PictViewFormMetacontroller'
	 * names; check both, in that order.
	 * @returns {string|null}
	 */
	_resolveMetacontrollerServiceType()
	{
		if (!this.fable || !this.fable.servicesMap) return null;
		if (this.fable.servicesMap.hasOwnProperty('PictFormMetacontroller'))     return 'PictFormMetacontroller';
		if (this.fable.servicesMap.hasOwnProperty('PictViewFormMetacontroller')) return 'PictViewFormMetacontroller';
		return null;
	}

	/**
	 * Build the parameter form section using a pict-section-form
	 * metacontroller. Creates a host div, binds the active layout
	 * parameters to `pict.AppData.PictFlowLayoutEditor.Parameters`, and
	 * injects the algorithm's `ParameterManifest`. Form-input changes
	 * propagate back to `_FlowData.LayoutParameters` via a single
	 * `change`/`input` listener on the popup container.
	 *
	 * @param {HTMLElement} pContainer
	 * @param {Object} pAlgoDescriptor
	 * @param {{ Algorithm: string, Parameters: Object }} pCurrentSettings
	 * @param {string} pMetacontrollerType - 'PictFormMetacontroller' or 'PictViewFormMetacontroller'
	 */
	_mountLayoutParameterMetacontroller(pContainer, pAlgoDescriptor, pCurrentSettings, pMetacontrollerType)
	{
		let tmpManifest = JSON.parse(JSON.stringify(pAlgoDescriptor.ParameterManifest));
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Section header + divider
		let tmpDivider = document.createElement('div');
		tmpDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpDivider);

		// Form host div — the metacontroller renders into here. Inline
		// onclick stops popup-close propagation; onchange/oninput drive the
		// _FlowData.LayoutParameters writeback (see _pushFormBack).
		let tmpHostID = `Flow-Toolbar-LayoutForm-${tmpFlowViewIdentifier}`;
		this._LayoutFormHostID = tmpHostID;

		let tmpHostDiv = document.createElement('div');
		tmpHostDiv.id = tmpHostID;
		tmpHostDiv.className = 'pict-flow-popup-layout-form-host';
		tmpHostDiv.setAttribute('data-collapsed', this._LayoutFormExpanded ? 'false' : 'true');
		tmpHostDiv.setAttribute('onclick', 'event.stopPropagation()');
		tmpHostDiv.setAttribute('onchange',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView._pushLayoutFormBack('" + pCurrentSettings.Algorithm + "')");
		tmpHostDiv.setAttribute('oninput',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView._pushLayoutFormBack('" + pCurrentSettings.Algorithm + "')");
		pContainer.appendChild(tmpHostDiv);

		// Bind the layout parameters as the data source for the form.
		// `injectManifestAndRender(manifest, _, UUID)` calls
		// `createDistinctManifest` which prepends the UUID to every descriptor
		// address (so re-injecting the same manifest doesn't collide). We use
		// the algorithm name as the UUID, so the form's expected address is
		// `AppData.<Algorithm>.PictFlowLayoutEditor.Parameters.<Key>` —
		// bind there, not at the unprefixed root.
		let tmpScope = pCurrentSettings.Algorithm;
		this.pict.AppData[tmpScope] = this.pict.AppData[tmpScope] || {};
		this.pict.AppData[tmpScope].PictFlowLayoutEditor = this.pict.AppData[tmpScope].PictFlowLayoutEditor || {};
		this.pict.AppData[tmpScope].PictFlowLayoutEditor.Parameters = JSON.parse(JSON.stringify(pCurrentSettings.Parameters || {}));

		// Always recreate the metacontroller per mount. Reusing the same
		// metacontroller across algorithm switches accumulates section views
		// (each switch's manifest gets injected onto the existing roster) and
		// the metatemplate ends up wedging multiple sections into a single
		// shared destination — only the last one survives. Fresh instance per
		// mount keeps the DOM consistent; we also evict the prior
		// `PictSectionForm-*` views from `pict.views` so they GC cleanly.
		this._evictLayoutFormViews();
		try
		{
			this._LayoutFormMetacontroller = this.fable.instantiateServiceProviderWithoutRegistration(
				pMetacontrollerType,
				{
					ViewIdentifier: `Flow-Toolbar-LayoutForm-MC-${tmpFlowViewIdentifier}-${this.fable.getUUID()}`,
					DefaultDestinationAddress: `#${tmpHostID}`,
					AutoRender: false,
					AutoPopulateAfterRender: true,
					AutoSolveBeforeRender: false
				});
		}
		catch (pError)
		{
			this.log.warn(`Failed to instantiate ${pMetacontrollerType}: ${pError.message}`);
			this._LayoutFormMetacontroller = null;
		}

		if (!this._LayoutFormMetacontroller)
		{
			tmpHostDiv.innerHTML = '<em style="padding:8px;display:block;opacity:0.7;">pict-section-form not available; parameter form skipped.</em>';
			return;
		}

		// Establish the form-container div the metacontroller expects.
		let tmpFormContainerID = `Pict-${this._LayoutFormMetacontroller.UUID}-FormContainer`;
		tmpHostDiv.innerHTML = `<div id="${tmpFormContainerID}" class="pict-form pict-flow-popup-layout-form"></div>`;

		try
		{
			// Use `injectManifest` + explicit per-section destination divs +
			// per-section render. Don't use `injectManifestAndRender` —
			// its metatemplate flow ends up wedging multi-section manifests
			// into a single shared destination (each section's render call
			// uses RenderMethod=replace, blowing the others away). The
			// explicit path gives each section its own destination div and
			// renders them independently.
			let tmpInjectFn = (typeof this._LayoutFormMetacontroller.injectManifest === 'function')
				? this._LayoutFormMetacontroller.injectManifest.bind(this._LayoutFormMetacontroller)
				: null;
			if (!tmpInjectFn) throw new Error('Metacontroller exposes neither injectManifest nor injectManifestAndRender');

			// Pass the algorithm name as the section-hash discriminator so
			// re-injecting the same algorithm gets unique view registrations.
			// (createDistinctManifest does the address-prefixing too — see
			// the per-algorithm AppData binding above.)
			let tmpDistinct = (typeof this._LayoutFormMetacontroller.createDistinctManifest === 'function')
				? this._LayoutFormMetacontroller.createDistinctManifest(tmpManifest, pCurrentSettings.Algorithm)
				: tmpManifest;

			let tmpViews = tmpInjectFn(tmpDistinct);

			// Build a destination div per section view, in order, and render each.
			let tmpFormContainerEl = tmpHostDiv.querySelector(`#${tmpFormContainerID}`);
			if (tmpFormContainerEl)
			{
				let tmpInner = '';
				for (let i = 0; i < tmpViews.length; i++)
				{
					let tmpDest = tmpViews[i].options.DefaultDestinationAddress;
					if (tmpDest && tmpDest.charAt(0) === '#') tmpDest = tmpDest.substring(1);
					tmpInner += `<div id="${tmpDest}" class="pict-form-view"></div>`;
				}
				tmpFormContainerEl.innerHTML = tmpInner;
			}
			// Defer render() to the next microtask so the popup has been
			// appended to the DOM by `_openPopup` — pict-section-form
			// resolves destinations via `document.querySelector`, which
			// can't see detached subtrees. (Same workaround the
			// metacontroller's own `injectManifestAndRender` uses.)
			setTimeout(() =>
			{
				for (let i = 0; i < tmpViews.length; i++)
				{
					tmpViews[i].render();
					if (typeof tmpViews[i].marshalToView === 'function')
					{
						tmpViews[i].marshalToView();
					}
				}
			}, 0);
		}
		catch (pError)
		{
			this.log.warn(`PictViewFlowToolbar: layout-form injection failed: ${pError.message}`);
			tmpHostDiv.innerHTML = `<em style="padding:8px;display:block;opacity:0.7;">Form render error: ${pError.message}</em>`;
			return;
		}

		// Form-change writeback runs through the host div's inline
		// onchange/oninput attributes (set above), which call
		// `_pushLayoutFormBack(algorithm)`.
	}

	/**
	 * Inline handler for layout-parameter form changes. Pushes Informary's
	 * write into AppData back into `_FlowData.LayoutParameters` and
	 * re-applies the layout (when non-Custom). De-bounces via microtask so
	 * multi-key edits collapse to a single layout pass.
	 *
	 * @param {string} pAlgorithm
	 */
	_pushLayoutFormBack(pAlgorithm)
	{
		if (this._LayoutFormPushScheduled) return;
		this._LayoutFormPushScheduled = true;
		Promise.resolve().then(() =>
		{
			this._LayoutFormPushScheduled = false;
			if (!this._FlowView) return;
			let tmpScopedRoot = this.pict.AppData[pAlgorithm] || {};
			let tmpEditorParams = (tmpScopedRoot.PictFlowLayoutEditor || {}).Parameters || {};
			let tmpMerged = Object.assign({}, this._FlowView.getLayoutAlgorithm().Parameters || {}, tmpEditorParams);
			this._FlowView.setLayoutAlgorithm(pAlgorithm, tmpMerged);
		});
	}

	/**
	 * Build a single parameter input row for the layout-algorithm popup.
	 * Wires the input's change handler to update the flow's
	 * `LayoutParameters` and re-apply the layout if non-Custom.
	 *
	 * @param {string} pKey
	 * @param {Object} pSchema - { Type: 'number' | 'string' | 'boolean' | 'enum', Default, Options? }
	 * @param {*} pCurrentValue
	 * @returns {HTMLElement}
	 */
	_buildLayoutParamInput(pKey, pSchema, pCurrentValue)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpViewPath = "_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView";
		let tmpKeyEsc = pKey.replace(/'/g, "\\'");
		let tmpInput;

		if (pSchema.Type === 'boolean')
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'checkbox';
			tmpInput.checked = !!pCurrentValue;
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.checked)");
		}
		else if (pSchema.Type === 'enum' && Array.isArray(pSchema.Options))
		{
			tmpInput = document.createElement('select');
			tmpInput.className = 'pict-flow-popup-settings-select';
			for (let i = 0; i < pSchema.Options.length; i++)
			{
				let tmpOpt = document.createElement('option');
				tmpOpt.value = pSchema.Options[i];
				tmpOpt.textContent = pSchema.Options[i];
				if (pSchema.Options[i] === pCurrentValue) tmpOpt.selected = true;
				tmpInput.appendChild(tmpOpt);
			}
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.value)");
		}
		else if (pSchema.Type === 'number' || pSchema.Type === 'Number' || pSchema.Type === 'PreciseNumber')
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'number';
			tmpInput.className = 'pict-flow-popup-settings-input';
			let tmpIsPrecise = (pSchema.Type === 'PreciseNumber');
			if (typeof pSchema.Min === 'number') tmpInput.min = String(pSchema.Min);
			if (typeof pSchema.Max === 'number') tmpInput.max = String(pSchema.Max);
			tmpInput.step = tmpIsPrecise ? 'any' : '1';
			tmpInput.value = (pCurrentValue == null) ? '' : String(pCurrentValue);
			tmpInput.style.width = '90px';
			let tmpPreciseFlag = tmpIsPrecise ? 'true' : 'false';
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutNumberParameter('" + tmpKeyEsc + "', this.value, " + tmpPreciseFlag + ")");
		}
		else
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'text';
			tmpInput.className = 'pict-flow-popup-settings-input';
			tmpInput.value = (pCurrentValue == null) ? '' : String(pCurrentValue);
			tmpInput.style.width = '90px';
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.value)");
		}

		tmpInput.setAttribute('onclick', 'event.stopPropagation()');
		return tmpInput;
	}

	/**
	 * Update a single layout parameter on the flow and re-apply the layout
	 * if the configured algorithm is not 'Custom'.
	 * @param {string} pKey
	 * @param {*} pValue
	 */
	_updateLayoutParameter(pKey, pValue)
	{
		if (!this._FlowView) return;
		let tmpSettings = this._FlowView.getLayoutAlgorithm();
		let tmpParams = Object.assign({}, tmpSettings.Parameters || {});
		tmpParams[pKey] = pValue;
		this._FlowView.setLayoutAlgorithm(tmpSettings.Algorithm, tmpParams);
	}

	/**
	 * Inline-handler helper for numeric parameter inputs. Preserves the
	 * raw string when PreciseNumber so big.js / ExpressionParser can use
	 * it without float round-trip drift.
	 *
	 * @param {string} pKey
	 * @param {string} pRawValue
	 * @param {boolean} pIsPrecise
	 */
	_updateLayoutNumberParameter(pKey, pRawValue, pIsPrecise)
	{
		if (pRawValue === '') return;
		if (pIsPrecise)
		{
			this._updateLayoutParameter(pKey, pRawValue);
			return;
		}
		let tmpNum = parseFloat(pRawValue);
		if (isNaN(tmpNum)) return;
		this._updateLayoutParameter(pKey, tmpNum);
	}

	// ── Settings Popup ───────────────────────────────────────────────────

	/**
	 * Build the Settings popup using a template with inline handlers.
	 *
	 * Theme options are iterated via `{~TS:~}` from AppData. Sliders and
	 * selects fire inline handlers that update the FlowView's theme state.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildSettingsPopup(pContainer)
	{
		if (!this._FlowView) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPresetsProvider = this._FlowView._StylePresetsProvider;
		let tmpRendererProvider = this._FlowView._RendererProvider;
		if (!tmpPresetsProvider || !tmpRendererProvider) return;

		// The single "Style" picker surfaces curated presets — each one bundles
		// a ColorTheme + Renderer + EdgeTheme. Per-axis overrides live behind
		// future "Customize" UI; the toolbar shows the preset list only.
		let tmpPresets = tmpPresetsProvider.listPresets();
		let tmpActivePreset = tmpPresetsProvider.getActivePresetHash();

		let tmpThemeOptions = [];
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpPreset = tmpPresets[i];
			tmpThemeOptions.push(
			{
				Value: tmpPreset.Hash,
				Label: tmpPreset.Label || tmpPreset.Hash,
				SelectedAttr: (tmpPreset.Hash === tmpActivePreset) ? ' selected="selected"' : ''
			});
		}

		let tmpThemeOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpThemeOptions });

		let tmpNoiseLevel = Math.round(tmpRendererProvider.getNoiseLevel() * 100);
		let tmpActiveRenderer = tmpRendererProvider.getActiveRenderer();
		let tmpNoiseEnabled = !!(tmpActiveRenderer && tmpActiveRenderer.NoiseConfig && tmpActiveRenderer.NoiseConfig.Enabled);
		let tmpNoiseDisplay = tmpNoiseEnabled ? '' : 'display:none;';

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-settings-section">'
			+ '<label class="pict-flow-popup-settings-label">Theme</label>'
			+ '<select class="pict-flow-popup-settings-select"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleThemeSelectChange(this.value)">'
			+ tmpThemeOptionsHTML
			+ '</select>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section pict-flow-popup-settings-noise" data-settings-type="noise" style="' + tmpNoiseDisplay + '">'
			+ '<label class="pict-flow-popup-settings-label">Noise</label>'
			+ '<div class="pict-flow-popup-settings-slider-row">'
			+ '<input type="range" class="pict-flow-popup-settings-slider" min="0" max="100" value="' + tmpNoiseLevel + '"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onpointerdown="event.stopPropagation()"'
			+ ' oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleNoiseSliderInput(this)" />'
			+ '<span class="pict-flow-popup-settings-slider-value">' + tmpNoiseLevel + '%</span>'
			+ '</div>'
			+ '</div>');
	}

	/**
	 * Inline handler — apply selected flow theme and refresh the noise
	 * slider visibility (some themes don't expose noise).
	 */
	_handleThemeSelectChange(pThemeKey)
	{
		if (!this._FlowView) return;
		this._FlowView.setTheme(pThemeKey);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._refreshNoiseSlider(tmpPopupEl);
	}

	/**
	 * Inline handler — push slider position into the noise level and
	 * update the percentage label adjacent to it.
	 */
	_handleNoiseSliderInput(pSlider)
	{
		let tmpRaw = parseInt(pSlider.value, 10);
		if (isNaN(tmpRaw)) return;
		let tmpLevel = tmpRaw / 100;
		let tmpValueLabel = pSlider.parentNode ? pSlider.parentNode.querySelector('.pict-flow-popup-settings-slider-value') : null;
		if (tmpValueLabel) tmpValueLabel.textContent = tmpRaw + '%';
		if (this._FlowView) this._FlowView.setNoiseLevel(tmpLevel);
	}

	/**
	 * Show or hide the noise slider based on whether the active theme supports noise.
	 * @param {HTMLElement} pContainer - The settings popup container
	 */
	_refreshNoiseSlider(pContainer)
	{
		let tmpNoiseSection = pContainer.querySelector('[data-settings-type="noise"]');
		if (!tmpNoiseSection) return;

		let tmpRendererProvider = this._FlowView._RendererProvider;
		if (!tmpRendererProvider) { tmpNoiseSection.style.display = 'none'; return; }
		let tmpRenderer = tmpRendererProvider.getActiveRenderer();
		if (tmpRenderer && tmpRenderer.NoiseConfig && tmpRenderer.NoiseConfig.Enabled)
		{
			tmpNoiseSection.style.display = '';
			// Update slider value to reflect renderer default
			let tmpSlider = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider');
			let tmpValueLabel = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider-value');
			if (tmpSlider)
			{
				let tmpLevel = Math.round(tmpRendererProvider.getNoiseLevel() * 100);
				tmpSlider.value = String(tmpLevel);
				if (tmpValueLabel) tmpValueLabel.textContent = tmpLevel + '%';
			}
		}
		else
		{
			tmpNoiseSection.style.display = 'none';
		}
	}

	// ── Toolbar Mode Switching ────────────────────────────────────────────

	/**
	 * Switch between docked, floating, and collapsed modes.
	 * @param {string} pMode - 'docked' | 'floating' | 'collapsed'
	 */
	_setToolbarMode(pMode)
	{
		// Close any active popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpBar = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Bar-${tmpFlowViewIdentifier}`);
		let tmpCollapsed = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Collapsed-${tmpFlowViewIdentifier}`);

		switch (pMode)
		{
			case 'docked':
				// Show toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = '';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;

			case 'floating':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Show floating toolbar
				this._showFloatingToolbar();
				break;

			case 'collapsed':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Show collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.add('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;
		}

		this._ToolbarMode = pMode;
	}

	/**
	 * Lazily create and show the floating toolbar.
	 */
	_showFloatingToolbar()
	{
		if (!this._FlowView) return;

		if (!this._FloatingToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			this._FloatingToolbarView = this.fable.instantiateServiceProviderWithoutRegistration(
				'PictViewFlowFloatingToolbar',
				{
					FlowViewIdentifier: tmpFlowViewIdentifier,
					DefaultDestinationAddress: `#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`,
					EnableAddNode: this.options.EnableAddNode,
					EnableCardPalette: this.options.EnableCardPalette,
					ToolbarExtraButtons: this.options.ToolbarExtraButtons
				}
			);
			this._FloatingToolbarView._ToolbarView = this;
			this._FloatingToolbarView._FlowView = this._FlowView;
			this._FloatingToolbarView.render();
		}

		this._FloatingToolbarView.show();
	}

	// ── Node Placement Helpers ────────────────────────────────────────────

	/**
	 * Add a node at the center of the visible viewport.
	 * @param {string} pNodeType - The node type hash
	 */
	_addNodeAtCenter(pNodeType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;

		// Calculate the center of the visible SVG area
		let tmpSVGContainer = this._FlowView._SVGElement;
		let tmpWidth = tmpSVGContainer ? tmpSVGContainer.clientWidth : 600;
		let tmpHeight = tmpSVGContainer ? tmpSVGContainer.clientHeight : 400;

		let tmpCenterX = (-tmpVS.PanX + tmpWidth / 2) / tmpVS.Zoom;
		let tmpCenterY = (-tmpVS.PanY + tmpHeight / 2) / tmpVS.Zoom;

		// Slight offset to avoid stacking
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpCenterX += (tmpNodeCount % 5) * 30;
		tmpCenterY += (tmpNodeCount % 5) * 30;

		this._FlowView.addNode(pNodeType, tmpCenterX, tmpCenterY);
	}

	/**
	 * Add a node from a palette card click.
	 * @param {string} pCardType - The card type hash
	 */
	_addCardFromPalette(pCardType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;
		let tmpX = (-tmpVS.PanX + 200) / tmpVS.Zoom;
		let tmpY = (-tmpVS.PanY + 200) / tmpVS.Zoom;

		// Offset to avoid overlap
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpX += (tmpNodeCount % 5) * 40;
		tmpY += (tmpNodeCount % 5) * 40;

		this._FlowView.addNode(pCardType, tmpX, tmpY);
	}

	// ── Action Handler ────────────────────────────────────────────────────

	/**
	 * Handle a toolbar action
	 * @param {string} pAction
	 */
	/**
	 * Handle a click on a host-supplied (ToolbarExtraButtons) button. Routes to
	 * the FlowView's onToolbarButton hook with the button hash and the clicked
	 * element (so the host can anchor a popover next to it).
	 *
	 * @param {string} pHash - The button's Hash
	 * @param {HTMLElement} pElement - The clicked button element
	 */
	_handleExtraAction(pHash, pElement)
	{
		if (!this._FlowView) return;
		if (typeof this._FlowView.options.onToolbarButton === 'function')
		{
			this._FlowView.options.onToolbarButton(pHash, pElement);
		}
	}

	_handleToolbarAction(pAction)
	{
		if (!this._FlowView) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		switch (pAction)
		{
			case 'add-node':
				this._openPopup('add-node');
				break;

			case 'delete-selected':
				this._FlowView.deleteSelected();
				break;

			case 'zoom-in':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom + this._FlowView.options.ZoomStep);
				break;

			case 'zoom-out':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom - this._FlowView.options.ZoomStep);
				break;

			case 'zoom-fit':
				this._FlowView.zoomToFit();
				break;

			case 'auto-layout':
				// Legacy alias kept for backward compatibility with any
				// caller still firing 'auto-layout'. The toolbar's "Auto"
				// button now uses 'apply-current-layout' (below).
				this._FlowView.autoLayout();
				break;

			case 'apply-current-layout':
				// Respects whichever algorithm is configured in the
				// Algorithm popup. Falls back to Layered when the
				// configured value is 'Custom' or unset (autoLayout's
				// existing behavior — "do something useful").
				this._FlowView.autoLayout();
				break;

			case 'cards-popup':
				this._openPopup('cards');
				break;

			case 'layout-popup':
				this._openPopup('layout');
				break;

			case 'layout-algorithm-popup':
				this._openPopup('layout-algorithm');
				break;

			case 'apply-layout':
				this._FlowView.applyCurrentLayout();
				break;

			case 'settings-popup':
				this._openPopup('settings');
				break;

			case 'toggle-floating':
				if (this._ToolbarMode === 'floating')
				{
					this._setToolbarMode('docked');
				}
				else
				{
					this._setToolbarMode('floating');
				}
				break;

			case 'collapse-toolbar':
				this._setToolbarMode('collapsed');
				break;

			case 'expand-toolbar':
				this._setToolbarMode('docked');
				break;

			case 'fullscreen':
				{
					let tmpIsFullscreen = this._FlowView.toggleFullscreen();
					let tmpIconProvider = this._FlowView._IconProvider;
					let tmpIconElements = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
					if (tmpIconElements.length > 0 && tmpIconProvider)
					{
						tmpIconElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(
							tmpIsFullscreen ? 'exit-fullscreen' : 'fullscreen', 14);
					}
					let tmpFullscreenBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpFullscreenBtn.length > 0)
					{
						tmpFullscreenBtn[0].setAttribute('title', tmpIsFullscreen ? 'Exit Fullscreen' : 'Toggle Fullscreen');
					}
				}
				break;

			default:
				this.log.warn(`PictViewFlowToolbar: unknown action '${pAction}'`);
				break;
		}
	}
}

module.exports = PictViewFlowToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":365}],503:[function(require,module,exports){
const libPictView = require('pict-view');

const libPictServiceFlowInteractionManager = require('../services/PictService-Flow-InteractionManager.js');
const libPictServiceFlowConnectionRenderer = require('../services/PictService-Flow-ConnectionRenderer.js');
const libPictServiceFlowTether = require('../services/PictService-Flow-Tether.js');
const libPictServiceFlowLayout = require('../services/PictService-Flow-Layout.js');
const libPictServiceFlowPathGenerator = require('../services/PictService-Flow-PathGenerator.js');
const libPictServiceFlowViewportManager = require('../services/PictService-Flow-ViewportManager.js');
const libPictServiceFlowSelectionManager = require('../services/PictService-Flow-SelectionManager.js');
const libPictServiceFlowPanelManager = require('../services/PictService-Flow-PanelManager.js');
const libPictServiceFlowDataManager = require('../services/PictService-Flow-DataManager.js');
const libPictServiceFlowConnectionHandleManager = require('../services/PictService-Flow-ConnectionHandleManager.js');
const libPictServiceFlowRenderManager = require('../services/PictService-Flow-RenderManager.js');
const libPictServiceFlowPortRenderer = require('../services/PictService-Flow-PortRenderer.js');

const libPictProviderFlowNodeTypes = require('../providers/PictProvider-Flow-NodeTypes.js');
const libPictProviderFlowEventHandler = require('../providers/PictProvider-Flow-EventHandler.js');
const libPictProviderFlowLayouts = require('../providers/PictProvider-Flow-Layouts.js');
const libPictProviderFlowSVGHelpers = require('../providers/PictProvider-Flow-SVGHelpers.js');
const libPictProviderFlowGeometry = require('../providers/PictProvider-Flow-Geometry.js');
const libPictProviderFlowPanelChrome = require('../providers/PictProvider-Flow-PanelChrome.js');
const libPictProviderFlowCSS = require('../providers/PictProvider-Flow-CSS.js');
const libPictProviderFlowIcons = require('../providers/PictProvider-Flow-Icons.js');
const libPictProviderFlowConnectorShapes = require('../providers/PictProvider-Flow-ConnectorShapes.js');
const libPictProviderFlowTheme = require('../providers/PictProvider-Flow-Theme.js');
const libPictProviderFlowRenderer = require('../providers/PictProvider-Flow-Renderer.js');
const libPictProviderFlowStylePresets = require('../providers/PictProvider-Flow-StylePresets.js');
const libPictProviderFlowNoise = require('../providers/PictProvider-Flow-Noise.js');

const libPictViewFlowNode = require('./PictView-Flow-Node.js');
const libPictViewFlowToolbar = require('./PictView-Flow-Toolbar.js');
const libPictViewFlowFloatingToolbar = require('./PictView-Flow-FloatingToolbar.js');
const libPictViewFlowPropertiesPanel = require('./PictView-Flow-PropertiesPanel.js');

const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');
const libPanelTemplate = require('../panels/FlowCardPropertiesPanel-Template.js');
const libPanelMarkdown = require('../panels/FlowCardPropertiesPanel-Markdown.js');
const libPanelForm = require('../panels/FlowCardPropertiesPanel-Form.js');
const libPanelView = require('../panels/FlowCardPropertiesPanel-View.js');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Pict-Flow',

	DefaultRenderable: 'Flow-Container',
	DefaultDestinationAddress: '#Flow-Container',

	AutoRender: false,

	FlowDataAddress: false,

	TargetElementAddress: '#Flow-SVG-Container',

	EnableToolbar: true,
	EnableAddNode: true,
	EnableCardPalette: true,
	IncludeDefaultNodeTypes: true,
	EnablePanning: true,
	EnableZooming: true,
	EnableNodeDragging: true,
	EnableConnectionCreation: true,
	// When on, a connection can be drawn between ANY two ports (any port can start a drag, any port can
	// receive it), rather than only output -> input. Off by default so directed graphs (workflows) keep
	// their source/target semantics; free-form canvases (a moodboard, whose links are undirected) turn it
	// on so a card's ports connect in any direction.
	EnableUndirectedConnections: false,
	// When on, the selected node shows a bottom-right grip that resizes it by drag. Off by default
	// so existing diagrams are unaffected; free-form canvases (moodboards) turn it on.
	EnableNodeResizing: false,
	EnableGridSnap: false,
	GridSnapSize: 20,
	// When on, several nodes can be selected at once: shift-click a node to toggle it, drag on the
	// empty canvas to marquee-select (shift+drag pans), and dragging any selected node moves them all.
	// Off by default so single-selection diagrams are unaffected; free-form canvases turn it on.
	EnableMultiSelect: false,
	// When on, dragging a single node shows alignment guide lines (and snaps) as its edges or centers
	// line up with other nodes. Off by default; free-form canvases turn it on.
	EnableAlignmentGuides: false,
	EnableLayoutMenu: true,

	// Host-supplied toolbar buttons. Each entry is { Hash, Icon, Label?, Tooltip?, Active? } where Icon
	// is a flow icon-provider key (edit, check, background, ...). They render in BOTH the docked and the
	// floating toolbar (so they survive every toolbar mode) and, on click, fire onToolbarButton below.
	// Empty by default, so existing consumers are unaffected.
	ToolbarExtraButtons: [],
	// Fired when a ToolbarExtraButtons button is clicked: onToolbarButton(pHash, pElement). The element
	// lets the host anchor a popover next to the button. Off (false) by default.
	onToolbarButton: false,

	MinZoom: 0.1,
	MaxZoom: 5.0,
	ZoomStep: 0.1,

	DefaultNodeType: 'default',
	DefaultNodeWidth: 180,
	DefaultNodeHeight: 80,
	MinimumNodeWidth: 48,
	MinimumNodeHeight: 32,

	// Properties panel for connections (edges). Connections are not typed, so one config serves
	// them all: { PanelType, DefaultWidth, DefaultHeight, Title, Configuration }. When set, a
	// double-click on a connection opens this panel; when false, double-click adds a bezier handle.
	ConnectionPropertiesPanel: false,

	// Layout-algorithm subsystem defaults
	DefaultLayoutAlgorithm: 'Custom',
	DefaultLayoutParameters: {},
	DefaultLayoutAutoApply: false,

	// Edge-theme subsystem defaults — null = inherit from active layout's
	// `DefaultEdgeTheme` field, with hard fallback to 'Bezier'.
	DefaultEdgeTheme: null,
	DefaultEdgeThemeParameters: {},

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-PanelChrome-Template',
			Template: /*html*/`<div class="pict-flow-panel" xmlns="http://www.w3.org/1999/xhtml"><div class="pict-flow-panel-titlebar" data-element-type="panel-titlebar" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-title-text">{~D:Record.Title~}</span><span class="pict-flow-panel-close-btn" data-element-type="panel-close" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-close-icon"></span></span></div><div class="pict-flow-panel-content" data-panel-hash="{~D:Record.Hash~}" onpointerdown="event.stopPropagation()" onwheel="event.stopPropagation()"><div class="pict-flow-panel-tab-pane active" data-tab="properties" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tab-pane" data-tab="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div><div class="pict-flow-panel-tab-pane" data-tab="appearance" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div></div><div class="pict-flow-panel-resize-handle" data-element-type="panel-resize" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tabbar" data-panel-hash="{~D:Record.Hash~}" onpointerdown="event.stopPropagation()" onwheel="event.stopPropagation()"><div class="pict-flow-panel-tab active" data-tab-target="properties" data-panel-hash="{~D:Record.Hash~}" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Properties</div><div class="pict-flow-panel-tab" data-tab-target="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Help</div><div class="pict-flow-panel-tab" data-tab-target="appearance" data-panel-hash="{~D:Record.Hash~}" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Appearance</div></div></div>`
		},
		{
			Hash: 'Flow-Container-Template',
			// Inline pointer/wheel/contextmenu handlers route to the
			// InteractionManager via the FlowView. Keyboard events stay
			// document-level (no element-level inline equivalent).
			Template: /*html*/`
<div class="pict-flow-container" id="Flow-Wrapper-{~D:Record.ViewIdentifier~}">
	<div id="Flow-Toolbar-{~D:Record.ViewIdentifier~}"></div>
	<div id="Flow-FloatingToolbar-Container-{~D:Record.ViewIdentifier~}" style="display:none;position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:100;"></div>
	<div class="pict-flow-svg-container" id="Flow-SVG-Container-{~D:Record.ViewIdentifier~}">
		<svg class="pict-flow-svg"
			id="Flow-SVG-{~D:Record.ViewIdentifier~}"
			xmlns="http://www.w3.org/2000/svg"
			onpointerdown="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerDown(event)"
			onpointermove="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerMove(event)"
			onpointerup="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerUp(event)"
			onpointerleave="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerUp(event)"
			onwheel="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGWheel(event)"
			oncontextmenu="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGContextMenu(event)">
			<defs>
				<pattern id="flow-grid-{~D:Record.ViewIdentifier~}"
					width="20" height="20" patternUnits="userSpaceOnUse">
					<line x1="20" y1="0" x2="20" y2="20" class="pict-flow-grid-pattern" />
					<line x1="0" y1="20" x2="20" y2="20" class="pict-flow-grid-pattern" />
				</pattern>
			</defs>
			<rect width="10000" height="10000" x="-5000" y="-5000"
				fill="url(#flow-grid-{~D:Record.ViewIdentifier~})"
				class="pict-flow-grid-background" />
			<g class="pict-flow-viewport" id="Flow-Viewport-{~D:Record.ViewIdentifier~}">
				<g class="pict-flow-connections-layer" id="Flow-Connections-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-nodes-layer" id="Flow-Nodes-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-endpoints-layer" id="Flow-Endpoints-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-port-hints-layer" id="Flow-PortHints-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-tethers-layer" id="Flow-Tethers-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-panels-layer" id="Flow-Panels-{~D:Record.ViewIdentifier~}"></g>
			</g>
		</svg>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Container',
			TemplateHash: 'Flow-Container-Template',
			DestinationAddress: '#Flow-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlow extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictSectionFlow';

		// ---- Declarative service registry ----
		// Each entry defines a service to register, instantiate, and guard.
		// Optional flags:
		//   NoFlowView  — instantiate without { FlowView: this }
		//   PostInit    — method name to call on the instance after creation
		//   RegisterOnly — only register the type; do not bulk-instantiate
		this._ServiceRegistry =
		[
			// Providers (stateless or config-only — no FlowView needed)
			{ ServiceType: 'PictProviderFlowSVGHelpers',   Library: libPictProviderFlowSVGHelpers,   Property: '_SVGHelperProvider',    NoFlowView: true },
			{ ServiceType: 'PictProviderFlowGeometry',      Library: libPictProviderFlowGeometry,      Property: '_GeometryProvider',     NoFlowView: true },
			{ ServiceType: 'PictProviderFlowNoise',         Library: libPictProviderFlowNoise,         Property: '_NoiseProvider',        NoFlowView: true },

			// Providers (need FlowView)
			//   Renderer + StylePresets must be created before the legacy Theme
			//   shim (which delegates to them) and before CSS PostInit so that
			//   registerCSS() sees an initialized renderer.
			{ ServiceType: 'PictProviderFlowRenderer',      Library: libPictProviderFlowRenderer,      Property: '_RendererProvider' },
			{ ServiceType: 'PictProviderFlowStylePresets',  Library: libPictProviderFlowStylePresets,  Property: '_StylePresetsProvider' },
			{ ServiceType: 'PictProviderFlowTheme',         Library: libPictProviderFlowTheme,         Property: '_ThemeProvider' },
			{ ServiceType: 'PictProviderFlowCSS',           Library: libPictProviderFlowCSS,           Property: '_CSSProvider',          PostInit: 'registerCSS' },
			{ ServiceType: 'PictProviderFlowIcons',         Library: libPictProviderFlowIcons,         Property: '_IconProvider',         PostInit: 'registerIconTemplates' },
			{ ServiceType: 'PictProviderFlowConnectorShapes', Library: libPictProviderFlowConnectorShapes, Property: '_ConnectorShapesProvider' },
			{ ServiceType: 'PictProviderFlowPanelChrome',   Library: libPictProviderFlowPanelChrome,   Property: '_PanelChromeProvider' },
			{ ServiceType: 'PictProviderFlowNodeTypes',     Library: libPictProviderFlowNodeTypes,     Property: '_NodeTypeProvider',   ExtraOptions: () => ({ AdditionalNodeTypes: this.options.NodeTypes, IncludeDefaultNodeTypes: this.options.IncludeDefaultNodeTypes }) },
			{ ServiceType: 'PictProviderFlowEventHandler',  Library: libPictProviderFlowEventHandler,  Property: '_EventHandlerProvider' },
			{ ServiceType: 'PictProviderFlowLayouts',       Library: libPictProviderFlowLayouts,       Property: '_LayoutProvider',       PostInit: 'loadPersistedLayouts' },

			// Services
			{ ServiceType: 'PictServiceFlowPathGenerator',           Library: libPictServiceFlowPathGenerator,           Property: '_PathGenerator' },
			{ ServiceType: 'PictServiceFlowDataManager',             Library: libPictServiceFlowDataManager,             Property: '_DataManager' },
			{ ServiceType: 'PictServiceFlowConnectionHandleManager', Library: libPictServiceFlowConnectionHandleManager, Property: '_ConnectionHandleManager' },
			{ ServiceType: 'PictServiceFlowRenderManager',           Library: libPictServiceFlowRenderManager,           Property: '_RenderManager' },
			{ ServiceType: 'PictServiceFlowPortRenderer',            Library: libPictServiceFlowPortRenderer,            Property: '_PortRenderer' },
			{ ServiceType: 'PictServiceFlowInteractionManager',      Library: libPictServiceFlowInteractionManager,      Property: '_InteractionManager' },
			{ ServiceType: 'PictServiceFlowConnectionRenderer',      Library: libPictServiceFlowConnectionRenderer,      Property: '_ConnectionRenderer' },
			{ ServiceType: 'PictServiceFlowTether',                  Library: libPictServiceFlowTether,                  Property: '_TetherService' },
			{ ServiceType: 'PictServiceFlowLayout',                  Library: libPictServiceFlowLayout,                  Property: '_LayoutService' },
			{ ServiceType: 'PictServiceFlowViewportManager',         Library: libPictServiceFlowViewportManager,         Property: '_ViewportManager' },
			{ ServiceType: 'PictServiceFlowSelectionManager',        Library: libPictServiceFlowSelectionManager,        Property: '_SelectionManager' },
			{ ServiceType: 'PictServiceFlowPanelManager',            Library: libPictServiceFlowPanelManager,            Property: '_PanelManager' },

			// View types (register only — instantiated with custom config in onAfterInitialRender)
			{ ServiceType: 'PictViewFlowNode',             Library: libPictViewFlowNode,             RegisterOnly: true },
			{ ServiceType: 'PictViewFlowToolbar',          Library: libPictViewFlowToolbar,          RegisterOnly: true },
			{ ServiceType: 'PictViewFlowFloatingToolbar',  Library: libPictViewFlowFloatingToolbar,  RegisterOnly: true },
			{ ServiceType: 'PictViewFlowPropertiesPanel',  Library: libPictViewFlowPropertiesPanel,  RegisterOnly: true },

			// Panel types (register only)
			{ ServiceType: 'PictFlowCardPropertiesPanel',           Library: libPictFlowCardPropertiesPanel,  RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Template',  Library: libPanelTemplate,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Markdown',  Library: libPanelMarkdown,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Form',      Library: libPanelForm,                   RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-View',      Library: libPanelView,                   RegisterOnly: true }
		];

		this._registerServiceTypes();

		// Internal state
		this._FlowData = {
			Nodes: [],
			Connections: [],
			OpenPanels: [],
			SavedLayouts: [],
			ViewState: {
				PanX: 0,
				PanY: 0,
				Zoom: 1,
				SelectedNodeHash: null,
				// The full selection set (multi-select). SelectedNodeHash stays the primary / most
				// recently touched member for backward compatibility; single-select keeps it == [hash].
				SelectedNodeHashes: [],
				SelectedConnectionHash: null,
				SelectedTetherHash: null
			},
			LayoutAlgorithm: this.options.DefaultLayoutAlgorithm || 'Custom',
			LayoutParameters: JSON.parse(JSON.stringify(this.options.DefaultLayoutParameters || {})),
			LayoutAutoApply: !!this.options.DefaultLayoutAutoApply,
			EdgeTheme: this.options.DefaultEdgeTheme || null,
			EdgeThemeParameters: JSON.parse(JSON.stringify(this.options.DefaultEdgeThemeParameters || {}))
		};

		// Re-entrancy guard for the auto-apply event handler
		this._AutoApplyInProgress = false;
		this._AutoApplyHandlerHashes = [];

		this._SVGElement = null;
		this._ViewportElement = null;
		this._NodesLayer = null;
		this._ConnectionsLayer = null;
		this._EndpointsLayer = null;
		this._PortHintsLayer = null;
		this._TethersLayer = null;
		this._PanelsLayer = null;

		this._DataManager = null;
		this._ConnectionHandleManager = null;
		this._RenderManager = null;
		this._PortRenderer = null;

		this._InteractionManager = null;
		this._ConnectionRenderer = null;
		this._TetherService = null;
		this._LayoutService = null;
		this._PathGenerator = null;
		this._ViewportManager = null;
		this._SelectionManager = null;
		this._PanelManager = null;
		this._CSSProvider = null;
		this._IconProvider = null;
		this._ConnectorShapesProvider = null;
		this._ThemeProvider = null;
		this._RendererProvider = null;
		this._StylePresetsProvider = null;
		this._NoiseProvider = null;
		this._SVGHelperProvider = null;
		this._GeometryProvider = null;
		this._PanelChromeProvider = null;
		this._NodeTypeProvider = null;
		this._LayoutProvider = null;
		this._EventHandlerProvider = null;
		this._NodeView = null;
		this._ToolbarView = null;
		this._PropertiesPanelView = null;

		this.initialRenderComplete = false;
	}

	_registerServiceTypes()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (!this.fable.servicesMap.hasOwnProperty(tmpEntry.ServiceType))
			{
				this.fable.addServiceType(tmpEntry.ServiceType, tmpEntry.Library);
			}
		}
	}

	_instantiateServices()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (tmpEntry.RegisterOnly) continue;
			if (this[tmpEntry.Property]) continue;

			let tmpOptions = tmpEntry.NoFlowView ? {} : { FlowView: this };
			if (typeof tmpEntry.ExtraOptions === 'function')
			{
				Object.assign(tmpOptions, tmpEntry.ExtraOptions());
			}

			this[tmpEntry.Property] = this.fable.instantiateServiceProviderWithoutRegistration(tmpEntry.ServiceType, tmpOptions);

			if (tmpEntry.PostInit && typeof this[tmpEntry.Property][tmpEntry.PostInit] === 'function')
			{
				this[tmpEntry.Property][tmpEntry.PostInit]();
			}
		}
	}

	get flowData()
	{
		return this._FlowData;
	}

	get viewState()
	{
		return this._FlowData.ViewState;
	}

	// Backward-compatible getter for InteractionManager direct access
	get _IsFullscreen()
	{
		return this._ViewportManager ? this._ViewportManager._IsFullscreen : false;
	}

	/**
	 * Override render to pass view options as the template record,
	 * so template expressions like {~D:Record.ViewIdentifier~} resolve correctly.
	 */
	render(pRenderableHash, pRenderDestinationAddress)
	{
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		// If no record address is explicitly provided, use this.options as the record
		if (typeof pTemplateRecordAddress === 'function' || typeof pTemplateRecordAddress === 'undefined')
		{
			return super.renderAsync(pRenderableHash, pRenderDestinationAddress, this.options, pRootRenderable, pTemplateRecordAddress || fCallback);
		}
		return super.renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Noise + Renderer + StylePresets + Theme shim must be created before
		// CSS PostInit so registerCSS() sees an initialized renderer + presets.
		this._NoiseProvider          = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowNoise');
		this._RendererProvider       = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowRenderer', { FlowView: this });
		this._StylePresetsProvider   = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowStylePresets', { FlowView: this });
		this._ThemeProvider          = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowTheme',     { FlowView: this });

		// Apply initial style preset / per-axis overrides from options.
		// `Theme` and `StylePreset` are aliases for the same preset-by-hash apply.
		let tmpInitialPreset = this.options.StylePreset || this.options.Theme;
		if (tmpInitialPreset)
		{
			this._StylePresetsProvider.applyPreset(tmpInitialPreset);
		}
		if (this.options.Renderer)
		{
			this._RendererProvider.setRenderer(this.options.Renderer);
			this._StylePresetsProvider.markCustomized();
		}
		if (typeof this.options.NoiseLevel === 'number')
		{
			this._RendererProvider.setNoiseLevel(this.options.NoiseLevel);
		}

		// Instantiate all remaining services (skips Noise/Renderer/StylePresets/Theme
		// since already set above)
		this._instantiateServices();

		// Now that CSSProvider exists, inject the active renderer's GeometryCSS.
		if (this._CSSProvider && typeof this._CSSProvider.registerRendererCSS === 'function')
		{
			this._CSSProvider.registerRendererCSS(this._RendererProvider.getActiveRenderer());
		}

		// Subscribe to the host application's pict-provider-theme so the flow
		// editor's marker arrowhead colors and shape overrides update when the
		// host swaps light/dark or palette themes. CSS variables (--theme-*)
		// re-resolve automatically — only the SVG <marker> defs (which inline
		// fill colors at build time) and ConnectorShapesProvider state need a
		// manual refresh.
		this._subscribeToHostTheme();

		return super.onBeforeInitialize();
	}

	/**
	 * If the host application has registered pict-provider-theme, subscribe
	 * to its onApply hook so we can refresh anything that doesn't pick up
	 * the new --theme-* CSS variables automatically (SVG marker fills,
	 * connector shape overrides). No-op when no host theme provider is
	 * available — the flow editor still functions with its built-in themes.
	 */
	_subscribeToHostTheme()
	{
		let tmpHostTheme = this._resolveHostThemeProvider();
		if (!tmpHostTheme || typeof tmpHostTheme.onApply !== 'function') return;

		this._HostThemeUnsubscribe = tmpHostTheme.onApply(() =>
		{
			if (this._CSSProvider) this._CSSProvider.registerCSS();
			this._reinjectMarkerDefs();
			if (this.initialRenderComplete) this.renderFlow();
		});
	}

	/**
	 * Locate the host's pict-provider-theme instance. It is normally
	 * registered under a stable service hash by the host app; we check
	 * common locations so consumers don't have to wire it manually.
	 * @returns {Object|null}
	 */
	_resolveHostThemeProvider()
	{
		let tmpPict = this.pict;
		if (!tmpPict) return null;
		if (tmpPict.providers)
		{
			let tmpKeys = Object.keys(tmpPict.providers);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpProvider = tmpPict.providers[tmpKeys[i]];
				if (tmpProvider
					&& typeof tmpProvider.onApply === 'function'
					&& typeof tmpProvider.applyTheme === 'function'
					&& typeof tmpProvider.listThemes === 'function')
				{
					return tmpProvider;
				}
			}
		}
		return null;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		let tmpViewIdentifier = this.options.ViewIdentifier;

		// Grab SVG DOM elements
		let tmpSVGElements = this.pict.ContentAssignment.getElement(`#Flow-SVG-${tmpViewIdentifier}`);
		if (tmpSVGElements.length < 1)
		{
			this.log.error(`PictSectionFlow could not find SVG element #Flow-SVG-${tmpViewIdentifier}`);
			return false;
		}
		this._SVGElement = tmpSVGElements[0];

		let tmpViewportElements = this.pict.ContentAssignment.getElement(`#Flow-Viewport-${tmpViewIdentifier}`);
		if (tmpViewportElements.length > 0)
		{
			this._ViewportElement = tmpViewportElements[0];
		}

		let tmpNodesElements = this.pict.ContentAssignment.getElement(`#Flow-Nodes-${tmpViewIdentifier}`);
		if (tmpNodesElements.length > 0)
		{
			this._NodesLayer = tmpNodesElements[0];
		}

		let tmpConnectionsElements = this.pict.ContentAssignment.getElement(`#Flow-Connections-${tmpViewIdentifier}`);
		if (tmpConnectionsElements.length > 0)
		{
			this._ConnectionsLayer = tmpConnectionsElements[0];
		}

		let tmpEndpointsElements = this.pict.ContentAssignment.getElement(`#Flow-Endpoints-${tmpViewIdentifier}`);
		if (tmpEndpointsElements.length > 0)
		{
			this._EndpointsLayer = tmpEndpointsElements[0];
		}

		let tmpPortHintsElements = this.pict.ContentAssignment.getElement(`#Flow-PortHints-${tmpViewIdentifier}`);
		if (tmpPortHintsElements.length > 0)
		{
			this._PortHintsLayer = tmpPortHintsElements[0];
		}

		let tmpTethersElements = this.pict.ContentAssignment.getElement(`#Flow-Tethers-${tmpViewIdentifier}`);
		if (tmpTethersElements.length > 0)
		{
			this._TethersLayer = tmpTethersElements[0];
		}

		let tmpPanelsElements = this.pict.ContentAssignment.getElement(`#Flow-Panels-${tmpViewIdentifier}`);
		if (tmpPanelsElements.length > 0)
		{
			this._PanelsLayer = tmpPanelsElements[0];
		}

		// Ensure all services are initialized (fallback if onBeforeInitialize was skipped)
		this._instantiateServices();

		// Inject marker defs via the connector shapes provider
		// Note: insertAdjacentHTML does not work on SVG elements (wrong namespace),
		// so we parse via a temporary <svg> element to ensure SVG namespace.
		if (this._ConnectorShapesProvider && this._SVGElement)
		{
			let tmpDefs = this._SVGElement.querySelector('defs');
			if (tmpDefs)
			{
				let tmpMarkerMarkup = this._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
				let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				tmpTempSVG.innerHTML = tmpMarkerMarkup;
				while (tmpTempSVG.firstChild)
				{
					tmpDefs.appendChild(tmpTempSVG.firstChild);
				}
			}
		}

		// Setup the toolbar if enabled
		if (this.options.EnableToolbar)
		{
			this._ToolbarView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowToolbar',
				Object.assign({},
					libPictViewFlowToolbar.default_configuration,
					{
						ViewIdentifier: `Flow-Toolbar-${tmpViewIdentifier}`,
						DefaultDestinationAddress: `#Flow-Toolbar-${tmpViewIdentifier}`,
						FlowViewIdentifier: tmpViewIdentifier,
						EnableAddNode: this.options.EnableAddNode,
						EnableCardPalette: this.options.EnableCardPalette,
						ToolbarExtraButtons: this.options.ToolbarExtraButtons
					}
				));
			// Use the toolbar's render method after it's set up
			if (this._ToolbarView && typeof this._ToolbarView.render === 'function')
			{
				this._ToolbarView._FlowView = this;
				this._ToolbarView.render();
			}
		}

		// Setup the node renderer. A consumer can override the node title-bar height (e.g. a moodboard
		// sets it to 0 for edge-to-edge image and note cards) via the flow-level NodeTitleBarHeight
		// option; otherwise the renderer keeps its own default.
		let tmpNodeViewOptions = { ViewIdentifier: `Flow-NodeRenderer-${tmpViewIdentifier}`, AutoRender: false };
		if (typeof this.options.NodeTitleBarHeight === 'number') { tmpNodeViewOptions.NodeTitleBarHeight = this.options.NodeTitleBarHeight; }
		this._NodeView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowNode',
			Object.assign({}, libPictViewFlowNode.default_configuration, tmpNodeViewOptions));
		this._NodeView._FlowView = this;

		// Setup the properties panel renderer
		this._PropertiesPanelView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowPropertiesPanel',
			Object.assign({},
				libPictViewFlowPropertiesPanel.default_configuration,
				{
					ViewIdentifier: `Flow-PropertiesPanel-${tmpViewIdentifier}`,
					AutoRender: false
				}
			));
		this._PropertiesPanelView._FlowView = this;

		// Bind interaction events
		this._InteractionManager.initialize(this._SVGElement, this._ViewportElement);

		// Wire the auto-apply handler to structural-change events
		this._subscribeAutoApplyHandlers();

		// Load initial flow data if an address is configured
		if (this.options.FlowDataAddress)
		{
			this.marshalToView();
		}

		// Render the initial flow
		this.renderFlow();
	}

	// ---- Data Manager Delegations ----

	marshalToView() { return this._DataManager.marshalToView(); }
	marshalFromView() { return this._DataManager.marshalFromView(); }
	getFlowData() { return this._DataManager.getFlowData(); }
	setFlowData(pFlowData) { return this._DataManager.setFlowData(pFlowData); }
	addNode(pType, pX, pY, pTitle, pData) { return this._DataManager.addNode(pType, pX, pY, pTitle, pData); }
	removeNode(pNodeHash) { return this._DataManager.removeNode(pNodeHash); }
	addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData) { return this._DataManager.addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData); }
	removeConnection(pConnectionHash) { return this._DataManager.removeConnection(pConnectionHash); }

	/**
	 * Select a node
	 * @param {string|null} pNodeHash - Hash of the node to select, or null to deselect
	 */
	selectNode(pNodeHash)
	{
		return this._SelectionManager.selectNode(pNodeHash);
	}

	/**
	 * Toggle a node's membership in the selection set (multi-select; shift-click).
	 * @param {string} pNodeHash
	 */
	toggleNodeSelection(pNodeHash)
	{
		return this._SelectionManager.toggleNodeSelection(pNodeHash);
	}

	/**
	 * Replace the selection set with the given node hashes (multi-select; marquee result).
	 * @param {Array<string>} pNodeHashes
	 */
	selectNodes(pNodeHashes)
	{
		return this._SelectionManager.selectNodes(pNodeHashes);
	}

	/**
	 * The current selection set as an array of node hashes.
	 * @returns {Array<string>}
	 */
	getSelectedNodeHashes()
	{
		return this._SelectionManager.getSelectedNodeHashes();
	}

	/**
	 * Select a connection
	 * @param {string|null} pConnectionHash - Hash of the connection to select, or null to deselect
	 */
	selectConnection(pConnectionHash)
	{
		return this._SelectionManager.selectConnection(pConnectionHash);
	}

	/**
	 * Deselect all nodes and connections
	 */
	deselectAll()
	{
		return this._SelectionManager.deselectAll();
	}

	/**
	 * Delete the currently selected node or connection
	 * @returns {boolean}
	 */
	deleteSelected()
	{
		return this._SelectionManager.deleteSelected();
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		return this._ViewportManager.updateViewportTransform();
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		return this._ViewportManager.setZoom(pZoom, pFocusX, pFocusY);
	}

	/**
	 * Zoom to fit all nodes in the viewport
	 */
	zoomToFit()
	{
		return this._ViewportManager.zoomToFit();
	}

	/**
	 * Apply auto-layout to all nodes.
	 *
	 * Backwards-compatible signature: when called with no arguments,
	 * dispatches to the Layered algorithm with its default parameters
	 * (matching the pre-subsystem behavior).
	 *
	 * If `pAlgorithmName` is provided it is used directly; otherwise the
	 * configured `_FlowData.LayoutAlgorithm` is used (unless that value
	 * is 'Custom' or unset, in which case it falls back to 'Layered').
	 *
	 * @param {string} [pAlgorithmName]
	 * @param {Object} [pParameters]
	 */
	autoLayout(pAlgorithmName, pParameters)
	{
		if (!this._LayoutService) return;

		let tmpName;
		let tmpParams;
		if (typeof pAlgorithmName === 'string' && pAlgorithmName !== '')
		{
			tmpName = pAlgorithmName;
			tmpParams = pParameters || {};
		}
		else
		{
			let tmpConfigured = this._FlowData.LayoutAlgorithm;
			tmpName = (typeof tmpConfigured === 'string' && tmpConfigured !== '' && tmpConfigured !== 'Custom') ? tmpConfigured : 'Layered';
			tmpParams = (tmpName === this._FlowData.LayoutAlgorithm) ? (this._FlowData.LayoutParameters || {}) : {};
		}

		this._LayoutService.autoLayout(this._FlowData.Nodes, this._FlowData.Connections, tmpName, tmpParams);
		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Apply the currently configured layout algorithm to the flow, then
	 * call the active edge theme's `AdjustLayout` callback (if any) to
	 * let the theme adjust node positions for cleaner edge rendering
	 * (e.g. snap to grid, optimize for crossing minimization).
	 *
	 * Reads `_FlowData.LayoutAlgorithm` / `LayoutParameters` /
	 * `EdgeTheme` / `EdgeThemeParameters`. No-op when algorithm is
	 * 'Custom' — but the edge theme's adjustment still runs (so themes
	 * like OrthogonalSnap can snap hand-placed nodes too).
	 */
	applyCurrentLayout()
	{
		if (!this._LayoutService) return;
		let tmpAlgorithm = this._FlowData.LayoutAlgorithm || 'Custom';

		this._AutoApplyInProgress = true;
		try
		{
			if (tmpAlgorithm !== 'Custom')
			{
				this._LayoutService.applyLayout(
					this._FlowData.Nodes,
					this._FlowData.Connections,
					tmpAlgorithm,
					this._FlowData.LayoutParameters || {}
				);
			}

			// Edge-theme post-processing (placement adjustment).
			let tmpEdgeTheme = this._LayoutService.resolveActiveEdgeTheme({});
			if (tmpEdgeTheme && typeof tmpEdgeTheme.AdjustLayout === 'function')
			{
				try
				{
					let tmpEdgeParams = this._LayoutService.getMergedEdgeThemeParameters(
						tmpEdgeTheme.Name,
						this._FlowData.EdgeThemeParameters || {}
					);
					tmpEdgeTheme.AdjustLayout(this._FlowData.Nodes, this._FlowData.Connections, tmpEdgeParams);
				}
				catch (pError)
				{
					this.log.warn(`PictSectionFlow edge theme '${tmpEdgeTheme.Name}' AdjustLayout threw: ${pError.message}`);
				}
			}

			let tmpHadAdjust = !!(tmpEdgeTheme && typeof tmpEdgeTheme.AdjustLayout === 'function');
			let tmpDidLayout = (tmpAlgorithm !== 'Custom');

			if (!tmpDidLayout && !tmpHadAdjust)
			{
				// Custom + theme-without-AdjustLayout → no positions changed.
				// Don't render or fire onFlowChanged.
				return;
			}

			this.renderFlow();
			this.marshalFromView();

			if (this._EventHandlerProvider)
			{
				this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
			}
		}
		finally
		{
			this._AutoApplyInProgress = false;
		}
	}

	/**
	 * Set the active edge theme (and optionally its parameters). Re-runs
	 * the current layout so any `AdjustLayout` callback takes effect.
	 *
	 * @param {string|null} pThemeName - null clears the override (theme
	 *   then resolves via the active layout's `DefaultEdgeTheme`).
	 * @param {Object} [pParameters]
	 */
	setEdgeTheme(pThemeName, pParameters)
	{
		if (!this._LayoutService) return;
		if (pThemeName != null && typeof pThemeName !== 'string') return;

		if (pThemeName)
		{
			let tmpTheme = this._LayoutService.getEdgeTheme(pThemeName);
			if (!tmpTheme)
			{
				this.log.warn(`PictSectionFlow setEdgeTheme: unknown theme '${pThemeName}'`);
				return;
			}
			this._FlowData.EdgeTheme = pThemeName;
			this._FlowData.EdgeThemeParameters = Object.assign({}, tmpTheme.DefaultParameters || {}, pParameters || {});
		}
		else
		{
			this._FlowData.EdgeTheme = null;
			this._FlowData.EdgeThemeParameters = pParameters ? Object.assign({}, pParameters) : {};
		}

		this.applyCurrentLayout();
	}

	/**
	 * Read the currently configured edge theme settings.
	 * Returns the *resolved* active theme (factoring in fallback to the
	 * active layout's `DefaultEdgeTheme`) plus the explicit override
	 * (if any) for round-tripping into UI.
	 *
	 * @returns {{ Theme: string, Override: string|null, Parameters: Object }}
	 */
	getEdgeTheme()
	{
		let tmpResolved = this._LayoutService ? this._LayoutService.resolveActiveEdgeTheme({}) : null;
		return {
			Theme: tmpResolved ? tmpResolved.Name : null,
			Override: this._FlowData.EdgeTheme || null,
			Parameters: JSON.parse(JSON.stringify(this._FlowData.EdgeThemeParameters || {}))
		};
	}

	/**
	 * Set the configured layout algorithm and (optionally) its parameters
	 * and auto-apply flag. Persists to `_FlowData` and applies the layout
	 * immediately when the algorithm is non-Custom.
	 *
	 * @param {string} pAlgorithmName
	 * @param {Object} [pParameters] - merged over the algorithm's defaults
	 * @param {boolean} [pAutoApply] - if provided, also sets `LayoutAutoApply`
	 */
	setLayoutAlgorithm(pAlgorithmName, pParameters, pAutoApply)
	{
		if (!this._LayoutService) return;
		if (typeof pAlgorithmName !== 'string' || pAlgorithmName === '') return;

		let tmpAlgo = this._LayoutService.getAlgorithm(pAlgorithmName);
		if (!tmpAlgo)
		{
			this.log.warn(`PictSectionFlow setLayoutAlgorithm: unknown algorithm '${pAlgorithmName}'`);
			return;
		}

		this._FlowData.LayoutAlgorithm = pAlgorithmName;
		this._FlowData.LayoutParameters = Object.assign({}, tmpAlgo.DefaultParameters || {}, pParameters || {});
		if (typeof pAutoApply === 'boolean')
		{
			this._FlowData.LayoutAutoApply = pAutoApply;
		}

		// Always run applyCurrentLayout so the new layout's `DefaultEdgeTheme`
		// takes effect on connection rendering — even when switching to
		// 'Custom' (which doesn't reposition nodes but does re-render edges).
		this.applyCurrentLayout();
		this.renderFlow();
	}

	/**
	 * Toggle whether the configured layout re-applies on structural changes.
	 * @param {boolean} pAutoApply
	 */
	setLayoutAutoApply(pAutoApply)
	{
		this._FlowData.LayoutAutoApply = !!pAutoApply;
		this.marshalFromView();
	}

	/**
	 * Read the currently configured layout algorithm settings.
	 * @returns {{ Algorithm: string, Parameters: Object, AutoApply: boolean }}
	 */
	getLayoutAlgorithm()
	{
		return {
			Algorithm: this._FlowData.LayoutAlgorithm || 'Custom',
			Parameters: JSON.parse(JSON.stringify(this._FlowData.LayoutParameters || {})),
			AutoApply: !!this._FlowData.LayoutAutoApply
		};
	}

	/**
	 * Subscribe the auto-apply handler to structural-change events. Idempotent.
	 * Only structural events trigger re-layout — `onNodeMoved` is intentionally
	 * NOT subscribed so user drags are never clobbered until the next add/remove.
	 */
	_subscribeAutoApplyHandlers()
	{
		if (!this._EventHandlerProvider) return;
		if (this._AutoApplyHandlerHashes.length > 0) return;

		let tmpEvents = ['onNodeAdded', 'onNodeRemoved', 'onConnectionCreated', 'onConnectionRemoved'];
		for (let i = 0; i < tmpEvents.length; i++)
		{
			let tmpHash = this._EventHandlerProvider.registerHandler(tmpEvents[i], () =>
			{
				if (this._AutoApplyInProgress) return;
				if (!this._FlowData.LayoutAutoApply) return;
				if (!this._FlowData.LayoutAlgorithm || this._FlowData.LayoutAlgorithm === 'Custom') return;
				this.applyCurrentLayout();
			});
			if (tmpHash) this._AutoApplyHandlerHashes.push({ Event: tmpEvents[i], Hash: tmpHash });
		}
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		return this._ViewportManager.toggleFullscreen();
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		return this._ViewportManager.exitFullscreen();
	}

	// ── Theme / Renderer / Style-Preset API ─────────────────────────────
	//
	// Three axes you can drive independently:
	//   - ColorTheme — delegates to pict-provider-theme (a pict-section-theme
	//                  catalog hash like 'flow-sketch' or 'pict-default')
	//   - Renderer   — delegates to PictProviderFlowRenderer (controls
	//                  bracket/rect node body, jitter, shadows, fonts)
	//   - EdgeTheme  — delegates to PictService-Flow-Layout (Bezier /
	//                  Straight / Orthogonal / Perimeter / …; see
	//                  PictView-Flow.setEdgeTheme below)
	//
	// Most users pick a curated combo via `setStylePreset()` — the preset
	// applies all three axes in order. Per-axis overrides mark the active
	// preset as 'customized' (getStylePreset returns null afterward).
	//
	// For backwards-compatibility, `setTheme()` / `getThemeKey()` continue
	// to work as aliases for `setStylePreset()` / `getStylePreset()`.

	/**
	 * Apply a named style preset — sets ColorTheme, Renderer, EdgeTheme
	 * (and optional NoiseLevel) in one call.
	 * @param {string} pPresetHash
	 */
	setStylePreset(pPresetHash)
	{
		if (!this._StylePresetsProvider)
		{
			this.log.warn('PictSectionFlow setStylePreset: StylePresets provider not available');
			return;
		}
		let tmpApplied = this._StylePresetsProvider.applyPreset(pPresetHash);
		if (!tmpApplied) { return; }
		this._refreshAfterStyleChange();
		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onStylePresetChanged', pPresetHash);
			// Back-compat — old code listens for 'onThemeChanged'
			this._EventHandlerProvider.fireEvent('onThemeChanged', pPresetHash);
		}
	}

	/**
	 * Hash of the active style preset, or null when in customized state.
	 * @returns {string|null}
	 */
	getStylePreset()
	{
		return this._StylePresetsProvider ? this._StylePresetsProvider.getActivePresetHash() : null;
	}

	/**
	 * Override just the color theme — delegates to pict-provider-theme.
	 * @param {string} pThemeHash - a pict-section-theme catalog hash
	 */
	setColorTheme(pThemeHash)
	{
		if (this.fable.providers && this.fable.providers.Theme)
		{
			try { this.fable.providers.Theme.applyTheme(pThemeHash); }
			catch (pErr) { this.log.warn(`PictSectionFlow setColorTheme: applyTheme failed — ${pErr.message}`); return; }
		}
		else
		{
			this.log.warn('PictSectionFlow setColorTheme: pict-provider-theme not available in host');
			return;
		}
		if (this._StylePresetsProvider) { this._StylePresetsProvider.markCustomized(); }
		this._refreshAfterStyleChange();
		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onColorThemeChanged', pThemeHash);
		}
	}

	/**
	 * The active color theme hash (from pict-provider-theme).
	 * @returns {string|null}
	 */
	getColorThemeKey()
	{
		if (this.fable.providers && this.fable.providers.Theme && typeof this.fable.providers.Theme.getActiveTheme === 'function')
		{
			let tmpActive = this.fable.providers.Theme.getActiveTheme();
			if (tmpActive && tmpActive.Hash) { return tmpActive.Hash; }
		}
		return null;
	}

	/**
	 * Override just the renderer — controls node body shape, jitter, shadows.
	 * @param {string} pRendererKey
	 */
	setRenderer(pRendererKey)
	{
		if (!this._RendererProvider)
		{
			this.log.warn('PictSectionFlow setRenderer: Renderer provider not available');
			return;
		}
		let tmpApplied = this._RendererProvider.setRenderer(pRendererKey);
		if (!tmpApplied) { return; }
		if (this._StylePresetsProvider) { this._StylePresetsProvider.markCustomized(); }
		this._refreshAfterStyleChange();
		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onRendererChanged', pRendererKey);
		}
	}

	/**
	 * The active renderer key.
	 * @returns {string}
	 */
	getRendererKey()
	{
		return this._RendererProvider ? this._RendererProvider.getActiveRendererKey() : 'clean';
	}

	/**
	 * Set the noise level (0 to 1) and re-render. Noise applies only when
	 * the active renderer enables it (see Renderer.NoiseConfig).
	 * @param {number} pLevel - 0 = precise, 1 = maximum wobble
	 */
	setNoiseLevel(pLevel)
	{
		if (this._RendererProvider)
		{
			this._RendererProvider.setNoiseLevel(pLevel);
		}
		else if (this._ThemeProvider)
		{
			this._ThemeProvider.setNoiseLevel(pLevel);
		}
		if (this.initialRenderComplete) { this.renderFlow(); }
	}

	/**
	 * Current noise level (0 to 1).
	 * @returns {number}
	 */
	getNoiseLevel()
	{
		if (this._RendererProvider) { return this._RendererProvider.getNoiseLevel(); }
		if (this._ThemeProvider)    { return this._ThemeProvider.getNoiseLevel(); }
		return 0;
	}

	/**
	 * @deprecated since the 3-axis refactor — use setStylePreset() instead.
	 * Kept as an alias for back-compat with existing host apps and views.
	 * @param {string} pPresetHash
	 */
	setTheme(pPresetHash)
	{
		this.setStylePreset(pPresetHash);
	}

	/**
	 * @deprecated since the 3-axis refactor — use getStylePreset() instead.
	 * Returns the active preset hash (or null if customized).
	 * @returns {string|null}
	 */
	getThemeKey()
	{
		return this.getStylePreset();
	}

	/**
	 * Common refresh path used by all axis-change methods.
	 * Re-registers the renderer CSS, re-injects marker defs (arrowhead colors
	 * may have shifted with the new theme), and full-renders the flow.
	 * @private
	 */
	_refreshAfterStyleChange()
	{
		if (this._CSSProvider && typeof this._CSSProvider.registerRendererCSS === 'function' && this._RendererProvider)
		{
			this._CSSProvider.registerRendererCSS(this._RendererProvider.getActiveRenderer());
		}
		if (this._CSSProvider) { this._CSSProvider.registerCSS(); }
		this._reinjectMarkerDefs();
		if (this.initialRenderComplete) { this.renderFlow(); }
	}

	_reinjectMarkerDefs() { return this._RenderManager.reinjectMarkerDefs(); }

	/**
	 * Get a node by hash
	 * @param {string} pNodeHash
	 * @returns {Object|null}
	 */
	getNode(pNodeHash)
	{
		return this._FlowData.Nodes.find((pNode) => pNode.Hash === pNodeHash) || null;
	}

	/**
	 * Get a connection by hash
	 * @param {string} pConnectionHash
	 * @returns {Object|null}
	 */
	getConnection(pConnectionHash)
	{
		return this._FlowData.Connections.find((pConn) => pConn.Hash === pConnectionHash) || null;
	}

	/**
	 * Select a tether by its panel hash.
	 * @param {string|null} pPanelHash - Hash of the panel whose tether to select, or null to deselect
	 */
	selectTether(pPanelHash)
	{
		return this._SelectionManager.selectTether(pPanelHash);
	}

	// ---- Connection Handle Manager Delegations ----

	updateConnectionHandle(pConnectionHash, pHandleType, pX, pY) { return this._ConnectionHandleManager.updateConnectionHandle(pConnectionHash, pHandleType, pX, pY); }
	addConnectionHandle(pConnectionHash, pX, pY) { return this._ConnectionHandleManager.addConnectionHandle(pConnectionHash, pX, pY); }
	removeConnectionHandle(pConnectionHash, pIndex) { return this._ConnectionHandleManager.removeConnectionHandle(pConnectionHash, pIndex); }
	_resetHandlesForNode(pNodeHash) { return this._ConnectionHandleManager.resetHandlesForNode(pNodeHash); }
	_resetHandlesForPanel(pPanelHash) { return this._ConnectionHandleManager.resetHandlesForPanel(pPanelHash); }

	/**
	 * Add a bezier handle to a tether at the specified SVG position.
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	addTetherHandle(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		let tmpNode = this.getNode(tmpPanel.NodeHash);
		if (!tmpNode) return;

		let tmpAnchors = this._TetherService.getSmartAnchors(tmpPanel, tmpNode);

		this._TetherService.addHandle(tmpPanel, pX, pY, tmpAnchors.panelAnchor, tmpAnchors.nodeAnchor);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Remove a bezier handle from a tether by index.
	 * @param {string} pPanelHash
	 * @param {number} pIndex
	 */
	removeTetherHandle(pPanelHash, pIndex)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		this._TetherService.removeHandle(tmpPanel, pIndex);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Update a tether handle position during drag (for real-time feedback).
	 * Delegates state update to the TetherService.
	 * @param {string} pPanelHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateTetherHandle(pPanelHash, pHandleType, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._TetherService)
		{
			this._TetherService.updateHandlePosition(tmpPanel, pHandleType, pX, pY);
		}

		this._renderSingleTether(pPanelHash);
	}

	/**
	 * Get a port's absolute position in SVG coordinates.
	 *
	 * For left and right side ports, positioning is offset below the title bar
	 * so that connection endpoints match the rendered port circles.
	 *
	 * @param {string} pNodeHash
	 * @param {string} pPortHash
	 * @returns {{x: number, y: number, side: string}|null}
	 */
	getPortPosition(pNodeHash, pPortHash)
	{
		let tmpNode = this.getNode(pNodeHash);
		if (!tmpNode) return null;

		let tmpPort = tmpNode.Ports.find((p) => p.Hash === pPortHash);
		if (!tmpPort) return null;

		// Count ports on the same side (matching both direction and side)
		let tmpSameSidePorts = tmpNode.Ports.filter((p) => p.Side === tmpPort.Side);
		let tmpPortIndex = tmpSameSidePorts.indexOf(tmpPort);
		let tmpPortCount = tmpSameSidePorts.length;

		let tmpTitleBarHeight = (this._NodeView && this._NodeView.options.NodeTitleBarHeight) || 28;

		// Use the adjusted node height that accounts for minimum port
		// spacing.  Connections render before nodes, so the node renderer
		// may not have written back its adjusted height yet.
		let tmpHeight = tmpNode.Height || 80;
		if (this._GeometryProvider && tmpNode.Ports && tmpNode.Ports.length > 0)
		{
			let tmpMinHeight = this._GeometryProvider.computeMinimumNodeHeight(tmpNode.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Build port counts map for adaptive zone sizing
		let tmpPortCountsBySide = this._GeometryProvider.buildPortCountsBySide(tmpNode.Ports);

		let tmpLocal = this._GeometryProvider.getPortLocalPosition(tmpPort.Side, tmpPortIndex, tmpPortCount, tmpNode.Width, tmpHeight, tmpTitleBarHeight, tmpPortCountsBySide);

		return { x: tmpNode.X + tmpLocal.x, y: tmpNode.Y + tmpLocal.y, side: tmpPort.Side || 'right' };
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		return this._ViewportManager.screenToSVGCoords(pScreenX, pScreenY);
	}

	// ---- Render Manager Delegations ----

	renderFlow() { return this._RenderManager.renderFlow(); }
	_renderSingleConnection(pConnectionHash) { return this._RenderManager.renderSingleConnection(pConnectionHash); }
	_renderSingleTether(pPanelHash) { return this._RenderManager.renderSingleTether(pPanelHash); }
	updateNodePosition(pNodeHash, pX, pY) { return this._RenderManager.updateNodePosition(pNodeHash, pX, pY); }
	_renderConnectionsForNode(pNodeHash) { return this._RenderManager.renderConnectionsForNode(pNodeHash); }
	_renderTethersForNode(pNodeHash) { return this._RenderManager.renderTethersForNode(pNodeHash); }

	// ---- Properties Panel Management ----

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node has no PropertiesPanel config
	 */
	openPanel(pNodeHash)
	{
		return this._PanelManager.openPanel(pNodeHash);
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		return this._PanelManager.closePanel(pPanelHash);
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		return this._PanelManager.closePanelForNode(pNodeHash);
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		return this._PanelManager.togglePanel(pNodeHash);
	}

	/**
	 * Open a properties panel for a connection (edge). Requires the ConnectionPropertiesPanel
	 * option; returns false otherwise.
	 * @param {string} pConnectionHash
	 * @returns {Object|false}
	 */
	openConnectionPanel(pConnectionHash)
	{
		return this._PanelManager.openConnectionPanel(pConnectionHash);
	}

	/**
	 * Toggle a properties panel for a connection.
	 * @param {string} pConnectionHash
	 * @returns {Object|false}
	 */
	toggleConnectionPanel(pConnectionHash)
	{
		return this._PanelManager.toggleConnectionPanel(pConnectionHash);
	}

	/**
	 * Close all panels for a given connection.
	 * @param {string} pConnectionHash
	 * @returns {boolean}
	 */
	closePanelForConnection(pConnectionHash)
	{
		return this._PanelManager.closePanelForConnection(pConnectionHash);
	}

	/**
	 * The midpoint of a connection in SVG coordinates, averaged from its two endpoint ports. Used
	 * to place and tether a connection's properties panel. Returns null if the connection or
	 * either port can not be resolved.
	 * @param {string} pConnectionHash
	 * @returns {{x: number, y: number}|null}
	 */
	getConnectionMidpoint(pConnectionHash)
	{
		let tmpConnection = this.getConnection(pConnectionHash);
		if (!tmpConnection) return null;
		let tmpSource = this.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
		let tmpTarget = this.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);
		if (!tmpSource || !tmpTarget) return null;
		// A connection renders as a curve, so the straight-line average of its endpoints sits OFF the
		// line (the panel tether would point into empty space). Prefer the true midpoint of the rendered
		// path -- getPointAtLength at half its length, which is genuinely on the line. Fall back to the
		// endpoint average when the path element or SVG geometry is unavailable (e.g. server-side render).
		if (this._SVGElement && typeof this._SVGElement.querySelector === 'function')
		{
			let tmpPathElement = this._SVGElement.querySelector('.pict-flow-connection[data-connection-hash="' + pConnectionHash + '"]');
			if (tmpPathElement && typeof tmpPathElement.getTotalLength === 'function' && typeof tmpPathElement.getPointAtLength === 'function')
			{
				try
				{
					let tmpLength = tmpPathElement.getTotalLength();
					if (tmpLength > 0)
					{
						let tmpPoint = tmpPathElement.getPointAtLength(tmpLength / 2);
						return { x: tmpPoint.x, y: tmpPoint.y };
					}
				}
				catch (pError) { /* fall through to the straight-line midpoint */ }
			}
		}
		return { x: (tmpSource.x + tmpTarget.x) / 2, y: (tmpSource.y + tmpTarget.y) / 2 };
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		return this._PanelManager.updatePanelPosition(pPanelHash, pX, pY);
	}

	// ── Inline-handler bridges (called from template onclick/oninput attrs)

	/**
	 * Handle a click on a panel tab button. Stops propagation so the
	 * underlying SVG doesn't see it, then delegates to the properties
	 * panel view for the actual visibility toggle.
	 *
	 * @param {Element} pTabElement
	 * @param {Event} pEvent
	 */
	_handlePanelTabClick(pTabElement, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function')
		{
			pEvent.stopPropagation();
		}
		if (this._PropertiesPanelView)
		{
			this._PropertiesPanelView.switchPanelTab(pTabElement);
		}
	}

	/**
	 * Apply a node property change driven from the appearance editor's
	 * inline `oninput` handler. Stops propagation, then delegates to the
	 * properties panel view.
	 *
	 * @param {string} pNodeHash
	 * @param {string} pPropPath
	 * @param {string} pValue
	 * @param {string} pInputType - 'text' | 'number' | 'color'
	 * @param {Event} [pEvent]
	 */
	_applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function')
		{
			pEvent.stopPropagation();
		}
		if (this._PropertiesPanelView)
		{
			this._PropertiesPanelView._applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType);
		}
	}

	/**
	 * Inline-handler bridge — light up port-hint paths matching the given
	 * port (and optionally node) hash. Called from inline `onmouseenter`
	 * on port badges; see PictService-Flow-PortRenderer._wirePortHintHover.
	 *
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_activatePortHints(pPortHash, pNodeHash)
	{
		this._togglePortHints(pPortHash, pNodeHash, true);
	}

	/**
	 * Inline-handler bridge — clear port-hint highlights.
	 *
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_deactivatePortHints(pPortHash, pNodeHash)
	{
		this._togglePortHints(pPortHash, pNodeHash, false);
	}

	_togglePortHints(pPortHash, pNodeHash, pActive)
	{
		let tmpScope = this._SVGElement || document;
		let tmpSelector = pPortHash
			? '.pict-flow-port-hint[data-port-hash="' + pPortHash + '"]'
			: '.pict-flow-port-hint[data-node-hash="' + pNodeHash + '"]';
		let tmpHints = tmpScope.querySelectorAll(tmpSelector);
		for (let i = 0; i < tmpHints.length; i++)
		{
			if (pActive)
			{
				tmpHints[i].setAttribute('data-active', 'true');
			}
			else
			{
				tmpHints[i].removeAttribute('data-active');
			}
		}
	}

	// ── SVG inline pointer/wheel bridges ─────────────────────────────────

	_handleSVGPointerDown(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerDown(pEvent);
	}

	_handleSVGPointerMove(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerMove(pEvent);
	}

	_handleSVGPointerUp(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerUp(pEvent);
	}

	_handleSVGWheel(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onWheel(pEvent);
	}

	_handleSVGContextMenu(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager.handleContextMenu(pEvent);
	}
}

module.exports = PictViewFlow;

module.exports.default_configuration = _DefaultConfiguration;

},{"../PictFlowCardPropertiesPanel.js":451,"../panels/FlowCardPropertiesPanel-Form.js":452,"../panels/FlowCardPropertiesPanel-Markdown.js":453,"../panels/FlowCardPropertiesPanel-Template.js":454,"../panels/FlowCardPropertiesPanel-View.js":455,"../providers/PictProvider-Flow-CSS.js":456,"../providers/PictProvider-Flow-ConnectorShapes.js":457,"../providers/PictProvider-Flow-EventHandler.js":458,"../providers/PictProvider-Flow-Geometry.js":459,"../providers/PictProvider-Flow-Icons.js":460,"../providers/PictProvider-Flow-Layouts.js":461,"../providers/PictProvider-Flow-NodeTypes.js":462,"../providers/PictProvider-Flow-Noise.js":463,"../providers/PictProvider-Flow-PanelChrome.js":464,"../providers/PictProvider-Flow-Renderer.js":465,"../providers/PictProvider-Flow-SVGHelpers.js":466,"../providers/PictProvider-Flow-StylePresets.js":467,"../providers/PictProvider-Flow-Theme.js":468,"../services/PictService-Flow-ConnectionHandleManager.js":487,"../services/PictService-Flow-ConnectionRenderer.js":488,"../services/PictService-Flow-DataManager.js":489,"../services/PictService-Flow-InteractionManager.js":490,"../services/PictService-Flow-Layout.js":491,"../services/PictService-Flow-PanelManager.js":492,"../services/PictService-Flow-PathGenerator.js":493,"../services/PictService-Flow-PortRenderer.js":494,"../services/PictService-Flow-RenderManager.js":495,"../services/PictService-Flow-SelectionManager.js":496,"../services/PictService-Flow-Tether.js":497,"../services/PictService-Flow-ViewportManager.js":498,"./PictView-Flow-FloatingToolbar.js":499,"./PictView-Flow-Node.js":500,"./PictView-Flow-PropertiesPanel.js":501,"./PictView-Flow-Toolbar.js":502,"pict-view":365}],504:[function(require,module,exports){
'use strict';

/**
 * Board model: group subjects into lanes from a workflow definition.
 *
 * State-to-lane is many-to-one. The lane is the board column a person sees; the state is the
 * finer position. Several states can share a lane, so a card carries the marker of its current
 * state and moving between two states in the same lane changes the marker without moving the
 * card. This computes the data a board view renders; it touches no DOM and no API, so a product
 * can build or test it anywhere.
 *
 * A subject is { ID, State, Title? } where State is the current state key. Lanes come out in the
 * order they first appear across the definition's states. A state with no Lane is its own lane;
 * a subject whose State is unknown to the definition lands in Unassigned.
 */

function lanesOf(pDefinition)
{
	let tmpStates = (pDefinition && pDefinition.States) || [];
	let tmpSeen = {};
	let tmpLanes = [];
	tmpStates.forEach((pState) =>
	{
		let tmpLane = pState.Lane || pState.Key;
		if (!tmpSeen[tmpLane]) { tmpSeen[tmpLane] = true; tmpLanes.push(tmpLane); }
	});
	return tmpLanes;
}

function _indexStates(pDefinition)
{
	let tmpIndex = {};
	((pDefinition && pDefinition.States) || []).forEach((pState) => { tmpIndex[pState.Key] = pState; });
	return tmpIndex;
}

function _card(pSubject, pState)
{
	let tmpCard = {
		SubjectID: pSubject.ID,
		State: pState.Key,
		StateName: pState.Name || pState.Key,
		Marker: pState.Marker || pState.Name || pState.Key
	};
	if (pSubject.Title != null) { tmpCard.Title = pSubject.Title; }
	return tmpCard;
}

function buildBoardModel(pDefinition, pSubjects)
{
	let tmpLanes = lanesOf(pDefinition);
	let tmpStateIndex = _indexStates(pDefinition);
	let tmpLaneByName = {};
	let tmpModel = { Lanes: [], Unassigned: [] };

	tmpLanes.forEach((pLane, pOrder) =>
	{
		let tmpLaneObject = { Lane: pLane, Order: pOrder, Cards: [] };
		tmpLaneByName[pLane] = tmpLaneObject;
		tmpModel.Lanes.push(tmpLaneObject);
	});

	(pSubjects || []).forEach((pSubject) =>
	{
		let tmpState = tmpStateIndex[pSubject.State];
		if (!tmpState) { tmpModel.Unassigned.push({ SubjectID: pSubject.ID, State: pSubject.State || null }); return; }
		let tmpLane = tmpState.Lane || tmpState.Key;
		let tmpLaneObject = tmpLaneByName[tmpLane];
		if (tmpLaneObject) { tmpLaneObject.Cards.push(_card(pSubject, tmpState)); }
		else { tmpModel.Unassigned.push(_card(pSubject, tmpState)); }
	});

	return tmpModel;
}

module.exports = { lanesOf: lanesOf, buildBoardModel: buildBoardModel };

},{}],505:[function(require,module,exports){
'use strict';

/**
 * Definition <-> flow-graph marshaling for the workflow map.
 *
 * A workflow definition is states and transitions. The graph makes both first class: a state is a
 * node, and a transition is also a node (a TransitionCard) sitting between two states, wired
 * Status -> transition -> Status. So a transition becomes one transition node plus two edges: an
 * edge from the source state's output to the transition's input, and an edge from the transition's
 * output to the target state's input. Reading the graph back, the transition's From and To come
 * from those two edges (the wires are the truth), and its gate fields (RequiresEntitlement,
 * ActorAddress, Guard) come from the transition node's Data.
 *
 *   definitionToFlow(definition, layout, options) -> { Key, Name, Nodes, Connections }
 *   flowToDefinition(flow, meta)                  -> { Key, Name, States, Transitions }
 *   validateDefinition(definition)                -> null when valid, else an error string
 *
 * These are pure and dependency-light (only the engine, for validation), the same shape as the
 * board model, so the translation is testable on its own. The key property is a round trip:
 * flowToDefinition(definitionToFlow(d)) equals d. Node hashes are derived from order, so the
 * output is deterministic; a node's state Key is recovered from Data (never from the hash), so a
 * hash is only an internal join key.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libFableWorkflow = require('fable-workflow');

// The two node types. A state renders as a StateCard, a transition as a TransitionCard; both
// register under these codes, and the marshaling and the cards agree on the names here.
const STATE_NODE_TYPE = 'WorkflowState';
const TRANSITION_NODE_TYPE = 'WorkflowTransition';

// Geometry and the lane-column placement used when no saved layout is supplied. Lanes become
// columns and the states within a lane stack down the column; a transition sits at the midpoint
// between the two states it joins.
const NODE_WIDTH = 190;
const NODE_HEIGHT = 70;
const TRANSITION_WIDTH = 160;
const TRANSITION_HEIGHT = 64;
// Corner radius reads as shape: a state is a barely-rounded rectangle, a transition is a very
// rounded capsule. The strong contrast is what tells the two kinds apart at a glance.
const STATE_CORNER_RADIUS = 5;
const TRANSITION_CORNER_RADIUS = 24;
const COLUMN_WIDTH = 300;
const ROW_HEIGHT = 130;
const MARGIN_X = 60;
const MARGIN_Y = 60;

// Transition cards are connectors, not lane members, so they share one muted, theme-driven color
// rather than a lane color, which keeps them distinct from and recessive to the colorful states.
// White title text (the renderer default) reads on this mid-tone in light and dark themes.
const TRANSITION_COLOR = 'var(--theme-color-text-secondary, #7f8c8d)';

// A small fixed palette, assigned to lanes in the order the lanes first appear. ASCII hex only;
// it cycles if a definition has more lanes than colors.
const LANE_PALETTE =
[
	'#3d6fb4', '#2e8b6f', '#a8632e', '#7a52a8', '#b43d6f',
	'#4f8a3d', '#b48a2e', '#3d8aa8', '#8a4f9a', '#6f6f6f'
];

/** The unique lanes in definition order. A state with no Lane is its own lane (its Key). */
function lanesOf(pDefinition)
{
	let tmpStates = (pDefinition && pDefinition.States) || [];
	let tmpSeen = {};
	let tmpLanes = [];
	tmpStates.forEach((pState) =>
	{
		let tmpLane = pState.Lane || pState.Key;
		if (!tmpSeen[tmpLane]) { tmpSeen[tmpLane] = true; tmpLanes.push(tmpLane); }
	});
	return tmpLanes;
}

/** lane -> color, lanes colored in the order they first appear, cycling the palette. */
function laneColors(pDefinition)
{
	let tmpColors = {};
	lanesOf(pDefinition).forEach((pLane, pIndex) => { tmpColors[pLane] = LANE_PALETTE[pIndex % LANE_PALETTE.length]; });
	return tmpColors;
}

function _stateHash(pIndex) { return STATE_NODE_TYPE + '-' + pIndex; }
function _transitionHash(pIndex) { return TRANSITION_NODE_TYPE + '-' + pIndex; }
function _inPortHash(pNodeHash) { return pNodeHash + '-in'; }
function _outPortHash(pNodeHash) { return pNodeHash + '-out'; }

// The display title for a transition card: the gate it enforces, so the flow reads at a glance.
function _transitionTitle(pTransition) { return pTransition.RequiresEntitlement || 'open'; }

// A stable key for a transition (for layout lookup): its own Key, else From->To.
function _transitionKey(pTransition) { return pTransition.Key || (pTransition.From + '->' + pTransition.To); }

/**
 * Build a flow graph from a workflow definition. `pLayout` is an optional map of
 * key -> { X, Y } (a saved arrangement), where a state's key is its state Key and a transition's
 * key is its Key or "From->To". States without an entry fall back to lane-column placement;
 * transitions without one are centered between their two states. The returned object carries the
 * workflow Key and Name alongside Nodes and Connections; setFlowData ignores the extras.
 */
function definitionToFlow(pDefinition, pLayout, pOptions)
{
	let tmpDefinition = pDefinition || {};
	let tmpStates = tmpDefinition.States || [];
	let tmpTransitions = tmpDefinition.Transitions || [];
	let tmpLayout = pLayout || {};
	let tmpOptions = pOptions || {};
	let tmpStateType = tmpOptions.StateNodeType || STATE_NODE_TYPE;
	let tmpTransitionType = tmpOptions.TransitionNodeType || TRANSITION_NODE_TYPE;
	let tmpColors = laneColors(tmpDefinition);
	let tmpLaneOrder = lanesOf(tmpDefinition);
	let tmpLaneColumn = {};
	tmpLaneOrder.forEach((pLane, pIndex) => { tmpLaneColumn[pLane] = pIndex; });
	let tmpRowInLane = {};

	let tmpKeyToStateHash = {};
	let tmpStateCenter = {};
	let tmpStateNodes = tmpStates.map((pState, pIndex) =>
	{
		let tmpHash = _stateHash(pIndex);
		tmpKeyToStateHash[pState.Key] = tmpHash;

		let tmpLane = pState.Lane || pState.Key;
		let tmpColumn = (tmpLaneColumn[tmpLane] != null) ? tmpLaneColumn[tmpLane] : 0;
		let tmpRow = tmpRowInLane[tmpLane] || 0;
		tmpRowInLane[tmpLane] = tmpRow + 1;

		let tmpSaved = tmpLayout[pState.Key] || {};
		let tmpX = (typeof tmpSaved.X === 'number') ? tmpSaved.X : (MARGIN_X + tmpColumn * COLUMN_WIDTH);
		let tmpY = (typeof tmpSaved.Y === 'number') ? tmpSaved.Y : (MARGIN_Y + tmpRow * ROW_HEIGHT);
		let tmpWidth = (typeof tmpSaved.Width === 'number') ? tmpSaved.Width : NODE_WIDTH;
		let tmpHeight = (typeof tmpSaved.Height === 'number') ? tmpSaved.Height : NODE_HEIGHT;
		tmpStateCenter[tmpHash] = { x: tmpX + tmpWidth / 2, y: tmpY + tmpHeight / 2 };

		let tmpData = { Key: pState.Key };
		if (pState.Lane) { tmpData.Lane = pState.Lane; }
		if (pState.Marker) { tmpData.Marker = pState.Marker; }
		if (pState.IsInitial) { tmpData.IsInitial = true; }
		if (pState.IsTerminal) { tmpData.IsTerminal = true; }
		if (pState.Category) { tmpData.Category = pState.Category; }

		return {
			Hash: tmpHash,
			Type: tmpStateType,
			X: tmpX, Y: tmpY, Width: tmpWidth, Height: tmpHeight,
			Title: pState.Name || pState.Key,
			TitleBarColor: tmpColors[tmpLane] || LANE_PALETTE[0],
			// Style.TitleBarColor is an inline style, which the renderer applies over the title-bar
			// CSS rule; the plain TitleBarColor attribute alone would be overridden by that rule.
			Style: { TitleBarColor: tmpColors[tmpLane] || LANE_PALETTE[0] },
			CornerRadius: STATE_CORNER_RADIUS,
			Ports:
			[
				{ Hash: _inPortHash(tmpHash), Direction: 'input', Side: 'left', Label: 'In' },
				{ Hash: _outPortHash(tmpHash), Direction: 'output', Side: 'right', Label: 'Out' }
			],
			Data: tmpData
		};
	});

	let tmpTransitionNodes = [];
	let tmpConnections = [];
	tmpTransitions.forEach((pTransition, pIndex) =>
	{
		let tmpHash = _transitionHash(pIndex);
		let tmpSourceHash = tmpKeyToStateHash[pTransition.From];
		let tmpTargetHash = tmpKeyToStateHash[pTransition.To];

		let tmpData = {};
		if (pTransition.Key) { tmpData.Key = pTransition.Key; }
		if (pTransition.RequiresEntitlement) { tmpData.RequiresEntitlement = pTransition.RequiresEntitlement; }
		if (pTransition.ActorAddress) { tmpData.ActorAddress = pTransition.ActorAddress; }
		if (pTransition.Guard != null) { tmpData.Guard = _deepCopy(pTransition.Guard); }

		// Place the transition card centered between its two states, unless a layout pins it.
		let tmpSaved = tmpLayout[_transitionKey(pTransition)] || {};
		let tmpSourceCenter = tmpStateCenter[tmpSourceHash] || { x: MARGIN_X, y: MARGIN_Y };
		let tmpTargetCenter = tmpStateCenter[tmpTargetHash] || tmpSourceCenter;
		let tmpMidX = (tmpSourceCenter.x + tmpTargetCenter.x) / 2;
		let tmpMidY = (tmpSourceCenter.y + tmpTargetCenter.y) / 2;
		let tmpX = (typeof tmpSaved.X === 'number') ? tmpSaved.X : (tmpMidX - TRANSITION_WIDTH / 2);
		let tmpY = (typeof tmpSaved.Y === 'number') ? tmpSaved.Y : (tmpMidY - TRANSITION_HEIGHT / 2);

		// No per-node TitleBarColor: the TransitionCard type carries a theme-driven color so transition
		// cards recede uniformly against the lane-colored state cards.
		tmpTransitionNodes.push({
			Hash: tmpHash,
			Type: tmpTransitionType,
			X: tmpX, Y: tmpY, Width: TRANSITION_WIDTH, Height: TRANSITION_HEIGHT,
			Title: _transitionTitle(pTransition),
			Style: { TitleBarColor: TRANSITION_COLOR },
			CornerRadius: TRANSITION_CORNER_RADIUS,
			Ports:
			[
				{ Hash: _inPortHash(tmpHash), Direction: 'input', Side: 'left', Label: 'In' },
				{ Hash: _outPortHash(tmpHash), Direction: 'output', Side: 'right', Label: 'Out' }
			],
			Data: tmpData
		});

		if (tmpSourceHash)
		{
			tmpConnections.push({ Hash: 'wfedge-' + pIndex + '-in', SourceNodeHash: tmpSourceHash, SourcePortHash: _outPortHash(tmpSourceHash), TargetNodeHash: tmpHash, TargetPortHash: _inPortHash(tmpHash), Data: {} });
		}
		if (tmpTargetHash)
		{
			tmpConnections.push({ Hash: 'wfedge-' + pIndex + '-out', SourceNodeHash: tmpHash, SourcePortHash: _outPortHash(tmpHash), TargetNodeHash: tmpTargetHash, TargetPortHash: _inPortHash(tmpTargetHash), Data: {} });
		}
	});

	return { Key: tmpDefinition.Key, Name: tmpDefinition.Name, Nodes: tmpStateNodes.concat(tmpTransitionNodes), Connections: tmpConnections };
}

/**
 * Read a flow graph back into a workflow definition. State nodes become states. Each transition
 * node becomes a transition whose From is the state on its incoming edge and whose To is the state
 * on its outgoing edge (the wires are the truth); its gate fields come from the node's Data. A
 * transition node missing either edge is incomplete and dropped. `pMeta` (optional { Key, Name })
 * supplies the workflow identity when the flow object does not carry it.
 */
function flowToDefinition(pFlow, pMeta)
{
	let tmpFlow = pFlow || {};
	let tmpNodes = tmpFlow.Nodes || [];
	let tmpConnections = tmpFlow.Connections || [];
	let tmpMeta = pMeta || {};

	let tmpTransitionNodes = tmpNodes.filter((pNode) => pNode.Type === TRANSITION_NODE_TYPE);
	let tmpStateNodes = tmpNodes.filter((pNode) => pNode.Type !== TRANSITION_NODE_TYPE);

	let tmpHashToKey = {};
	let tmpUsedKeys = {};
	tmpStateNodes.forEach((pNode) =>
	{
		let tmpData = pNode.Data || {};
		let tmpKey = tmpData.Key || _slug(pNode.Title) || pNode.Hash;
		if (tmpUsedKeys[tmpKey]) { let tmpN = 2; while (tmpUsedKeys[tmpKey + '_' + tmpN]) { tmpN++; } tmpKey = tmpKey + '_' + tmpN; }
		tmpUsedKeys[tmpKey] = true;
		tmpHashToKey[pNode.Hash] = tmpKey;
	});

	let tmpStates = tmpStateNodes.map((pNode) =>
	{
		let tmpData = pNode.Data || {};
		let tmpState = { Key: tmpHashToKey[pNode.Hash], Name: pNode.Title || tmpHashToKey[pNode.Hash] };
		if (tmpData.Lane) { tmpState.Lane = tmpData.Lane; }
		if (tmpData.Marker) { tmpState.Marker = tmpData.Marker; }
		if (tmpData.IsInitial) { tmpState.IsInitial = true; }
		if (tmpData.IsTerminal) { tmpState.IsTerminal = true; }
		if (tmpData.Category) { tmpState.Category = tmpData.Category; }
		return tmpState;
	});

	// Index edges by the transition node they touch.
	let tmpIncoming = {}; // transitionHash -> source state node hash
	let tmpOutgoing = {}; // transitionHash -> target state node hash
	let tmpIsTransition = {};
	tmpTransitionNodes.forEach((pNode) => { tmpIsTransition[pNode.Hash] = true; });
	tmpConnections.forEach((pConnection) =>
	{
		if (tmpIsTransition[pConnection.TargetNodeHash]) { tmpIncoming[pConnection.TargetNodeHash] = pConnection.SourceNodeHash; }
		if (tmpIsTransition[pConnection.SourceNodeHash]) { tmpOutgoing[pConnection.SourceNodeHash] = pConnection.TargetNodeHash; }
	});

	let tmpTransitions = [];
	tmpTransitionNodes.forEach((pNode) =>
	{
		let tmpFrom = tmpHashToKey[tmpIncoming[pNode.Hash]];
		let tmpTo = tmpHashToKey[tmpOutgoing[pNode.Hash]];
		// A transition card not wired between two states (yet) is not a transition.
		if (tmpFrom == null || tmpTo == null) { return; }
		let tmpData = pNode.Data || {};
		let tmpTransition = { From: tmpFrom, To: tmpTo };
		if (tmpData.Key) { tmpTransition.Key = tmpData.Key; }
		if (tmpData.RequiresEntitlement) { tmpTransition.RequiresEntitlement = tmpData.RequiresEntitlement; }
		if (tmpData.ActorAddress) { tmpTransition.ActorAddress = tmpData.ActorAddress; }
		if (tmpData.Guard != null) { tmpTransition.Guard = _deepCopy(tmpData.Guard); }
		tmpTransitions.push(tmpTransition);
	});

	return {
		Key: tmpFlow.Key || tmpMeta.Key,
		Name: tmpFlow.Name || tmpMeta.Name,
		States: tmpStates,
		Transitions: tmpTransitions
	};
}

/**
 * Run an assembled definition through the engine's own defineWorkflow checks (a Key is present, at
 * least one state, every transition references a known state, every guard is structurally valid).
 * Returns null when it passes, or the engine's error string.
 */
function validateDefinition(pDefinition)
{
	try
	{
		let tmpEngine = new libFableWorkflow.WorkflowEngine();
		tmpEngine.defineWorkflow(pDefinition);
		return null;
	}
	catch (pError)
	{
		return (pError && pError.message) || 'invalid workflow definition';
	}
}

function _deepCopy(pValue)
{
	if (pValue === undefined || pValue === null) { return pValue; }
	return JSON.parse(JSON.stringify(pValue));
}

// Turn a display name into a usable state key: lowercase, non-alphanumerics to underscores.
function _slug(pValue)
{
	if (pValue == null) { return ''; }
	return String(pValue).trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

module.exports =
{
	definitionToFlow: definitionToFlow,
	flowToDefinition: flowToDefinition,
	validateDefinition: validateDefinition,
	lanesOf: lanesOf,
	laneColors: laneColors,
	transitionTitle: _transitionTitle,
	STATE_NODE_TYPE: STATE_NODE_TYPE,
	TRANSITION_NODE_TYPE: TRANSITION_NODE_TYPE,
	TRANSITION_COLOR: TRANSITION_COLOR
};

},{"fable-workflow":67}],506:[function(require,module,exports){
'use strict';

/**
 * Metrics formatting for the subject-detail view: raw millisecond figures from the engine's
 * folded rollup turned into short readable strings and a flat list of display rows. Pure, so it
 * is testable on its own and carries no opinion about how the view paints them.
 *
 * The engine rollup is { OpenedAt, ClosedAt, ElapsedMS, ActiveMS, StalledMS, EffortMS,
 * OverlapMS, StateTime: { stateKey: ms }, ActorTime: { actorId: ms } }. formatDuration turns a
 * span into "2d 3h" / "4h 12m" / "45s"; summarizeMetrics turns the whole rollup into the figures
 * and the per-state breakdown a view iterates over.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * A compact human duration: the two largest non-zero units, e.g. 90061000 -> "1d 1h",
 * 252000 -> "4m 12s", 8000 -> "8s". A span under a second reads "0s". Negative or non-finite
 * input reads "0s" too, so a partial rollup never prints garbage.
 */
function formatDuration(pMilliseconds)
{
	let tmpMS = Number(pMilliseconds);
	if (!isFinite(tmpMS) || tmpMS <= 0) { return '0s'; }

	let tmpParts = [];
	let tmpDays = Math.floor(tmpMS / DAY); tmpMS -= tmpDays * DAY;
	let tmpHours = Math.floor(tmpMS / HOUR); tmpMS -= tmpHours * HOUR;
	let tmpMinutes = Math.floor(tmpMS / MINUTE); tmpMS -= tmpMinutes * MINUTE;
	let tmpSeconds = Math.floor(tmpMS / SECOND);

	if (tmpDays) { tmpParts.push(tmpDays + 'd'); }
	if (tmpHours) { tmpParts.push(tmpHours + 'h'); }
	if (tmpMinutes) { tmpParts.push(tmpMinutes + 'm'); }
	if (tmpSeconds) { tmpParts.push(tmpSeconds + 's'); }

	if (!tmpParts.length) { return '0s'; }
	return tmpParts.slice(0, 2).join(' ');
}

// The headline figures, in display order. Each maps a rollup field to a label.
const _FIGURES =
[
	{ Key: 'ElapsedMS', Label: 'Elapsed' },
	{ Key: 'ActiveMS', Label: 'Active' },
	{ Key: 'StalledMS', Label: 'Stalled' },
	{ Key: 'EffortMS', Label: 'Effort' },
	{ Key: 'OverlapMS', Label: 'Overlap' }
];

/**
 * Turn a rollup into display rows. Returns:
 *   { Figures: [{ Key, Label, Value, RawMS }],
 *     StateTime: [{ State, Value, RawMS }] sorted longest first,
 *     Closed: boolean }
 * A null/empty rollup yields empty arrays so a view can show "no metrics yet" cleanly. The
 * optional pStateNames maps a state key to a display name for the breakdown rows.
 */
function summarizeMetrics(pMetrics, pStateNames)
{
	let tmpMetrics = pMetrics || {};
	let tmpStateNames = pStateNames || {};

	let tmpFigures = _FIGURES.map((pFigure) =>
	{
		let tmpRaw = Number(tmpMetrics[pFigure.Key]) || 0;
		return { Key: pFigure.Key, Label: pFigure.Label, Value: formatDuration(tmpRaw), RawMS: tmpRaw };
	});

	let tmpStateRollup = tmpMetrics.StateTime || {};
	let tmpStateTime = Object.keys(tmpStateRollup).map((pStateKey) =>
	{
		let tmpRaw = Number(tmpStateRollup[pStateKey]) || 0;
		return { State: tmpStateNames[pStateKey] || pStateKey, StateKey: pStateKey, Value: formatDuration(tmpRaw), RawMS: tmpRaw };
	});
	tmpStateTime.sort((pA, pB) => pB.RawMS - pA.RawMS);

	return { Figures: tmpFigures, StateTime: tmpStateTime, Closed: !!tmpMetrics.ClosedAt };
}

module.exports =
{
	formatDuration: formatDuration,
	summarizeMetrics: summarizeMetrics
};

},{}],507:[function(require,module,exports){
'use strict';

/**
 * The browser layer of retold-workflow: the Pict views and the StateCard, which depend on
 * pict-section-flow (and pict-view). A product's client bundle requires this entry; a product's
 * server requires the main entry (./Retold-Workflow.js), which stays free of pict.
 *
 * Register the views on a host pict app and hand each one an API client (the WorkflowClient
 * shape) via options.Client or a named provider (options.ClientProvider). The pure cores and the
 * client are re-exported here too, so a bundle has one place to reach everything.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libCore = require('./Retold-Workflow.js');

module.exports =
{
	// Pure cores + isomorphic client (re-exported from the main entry).
	WorkflowTypeCatalog: libCore.WorkflowTypeCatalog,
	WorkflowService: libCore.WorkflowService,
	BoardModel: libCore.BoardModel,
	DefinitionFlow: libCore.DefinitionFlow,
	MetricsFormat: libCore.MetricsFormat,
	WorkflowClient: libCore.WorkflowClient,

	// The node cards and the four views.
	StateCard: require('./cards/State-Card.js'),
	TransitionCard: require('./cards/Transition-Card.js'),
	WorkflowMapView: require('./views/PictView-Workflow-Map.js'),
	WorkflowBoardView: require('./views/PictView-Workflow-Board.js'),
	WorkflowSubjectView: require('./views/PictView-Workflow-Subject.js'),
	WorkflowCatalogView: require('./views/PictView-Workflow-Catalog.js')
};

},{"./Retold-Workflow.js":508,"./cards/State-Card.js":512,"./cards/Transition-Card.js":513,"./views/PictView-Workflow-Board.js":514,"./views/PictView-Workflow-Catalog.js":515,"./views/PictView-Workflow-Map.js":516,"./views/PictView-Workflow-Subject.js":517}],508:[function(require,module,exports){
'use strict';

/**
 * retold-workflow
 *
 * A reusable, product-agnostic workflow capability built on the fable-workflow engine.
 * It is the middle tier of three:
 *
 *   fable-workflow   the pure engine (definitions, event log, projections, guards, agency)
 *   retold-workflow  this module: a workflow service, a built-in/clone type catalog, and
 *                    (in progress) board / timeline / metrics / agency UI
 *   <product>        the concrete wiring: tables, stores, a context resolver, seeds
 *
 * It stays reusable by depending only on injected interfaces, never on a product's
 * tables: an event store, a projection store, a type-catalog store, and a context
 * resolver. A product implements those over its own schema; an editorial-review product
 * and a manufacturing product implement the same four and get the same capability.
 *
 * Phase 1 ships the type catalog. The WorkflowService and the UI follow.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libWorkflowTypeCatalog = require('./Workflow-Type-Catalog.js');
const libWorkflowService = require('./Workflow-Service.js');
const libBoardModel = require('./Board-Model.js');
const libDefinitionFlow = require('./Definition-Flow.js');
const libMetricsFormat = require('./Metrics-Format.js');
const libWorkflowClient = require('./Workflow-Client.js');

// The main entry stays node-safe: the engine-facing service and catalog, the pure cores (board
// model, definition/flow marshaling, metrics formatting), and the isomorphic fetch client. None
// of these pull in pict, so a product's server can require('retold-workflow') without dragging in
// the browser layer. The Pict views and the StateCard live in ./Retold-Workflow-Views.js, which
// does depend on pict-section-flow; a client bundle requires that entry instead.
module.exports =
{
	WorkflowTypeCatalog: libWorkflowTypeCatalog,
	WorkflowService: libWorkflowService,
	BoardModel: libBoardModel,
	DefinitionFlow: libDefinitionFlow,
	MetricsFormat: libMetricsFormat,
	WorkflowClient: libWorkflowClient
};

},{"./Board-Model.js":504,"./Definition-Flow.js":505,"./Metrics-Format.js":506,"./Workflow-Client.js":509,"./Workflow-Service.js":510,"./Workflow-Type-Catalog.js":511}],509:[function(require,module,exports){
'use strict';

/**
 * Reference API client for the workflow views.
 *
 * Every view in this module renders from data and calls an injected client; this is the client a
 * product can use as-is, or copy. It is a thin fetch wrapper over a configurable base path with a
 * configurable auth header, hitting the standard workflow routes. A product whose routes match
 * (plansheet's /1.0/Workflow do) passes one of these to the views and is done.
 *
 * Options:
 *   BasePath     route root, default '/1.0/Workflow'
 *   Fetch        fetch implementation, default the global fetch (override in tests / node)
 *   Headers      a headers object, or a function returning one (for a per-request bearer token)
 *   Credentials  fetch credentials mode, default 'same-origin' (so cookie auth works in browser)
 *
 * The route map (a product implements these to reuse the views):
 *   GET    {base}/Types                      -> { Types: [typeRecord] }
 *   GET    {base}/Types/:id                  -> { Type: typeRecord }
 *   POST   {base}/Types/Adopt   {BuiltInID}  -> { Type: typeRecord }
 *   PUT    {base}/Types/:id      {Definition}-> { Type: typeRecord }
 *   GET    {base}/Types/:id/Board            -> { Board: [{ ID, State, Title }] }
 *   GET    {base}/Types/:id/Layout           -> { Layout: { stateKey: { X, Y } } }
 *   PUT    {base}/Types/:id/Layout {Layout}  -> { Layout }
 *   POST   {base}/Subject/:id/Open           -> { State }
 *   POST   {base}/Subject/:id/Advance {ToState} -> { Advanced, State }   (409 + {Error} when gated)
 *   POST   {base}/Subject/:id/Reevaluate     -> { Exits }
 *   GET    {base}/Subject/:id                -> { State, Exits }
 *   GET    {base}/Subject/:id/Timeline       -> { Timeline }
 *   GET    {base}/Subject/:id/Metrics        -> { Metrics }
 *   GET    {base}/Subject/:id/Agency         -> { Agency }
 *
 * Read methods resolve to the unwrapped payload (getTypes resolves the array, not { Types }).
 * A non-2xx rejects with an Error carrying .statusCode and the server's Error message, so a view
 * can show a blocked advance's reason straight from error.message.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

class WorkflowClient
{
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};
		this.basePath = _trimTrailingSlash(tmpOptions.BasePath || '/1.0/Workflow');
		this._fetch = tmpOptions.Fetch || (typeof fetch === 'function' ? fetch.bind(null) : null);
		this._headers = tmpOptions.Headers || null;
		this._credentials = tmpOptions.Credentials || 'same-origin';
	}

	// -- types / catalog -------------------------------------------------------

	getTypes() { return this._request('GET', '/Types').then((pBody) => (pBody && pBody.Types) || []); }

	getType(pTypeID) { return this._request('GET', '/Types/' + encodeURIComponent(pTypeID)).then((pBody) => (pBody && pBody.Type) || null); }

	adoptType(pBuiltInID) { return this._request('POST', '/Types/Adopt', { BuiltInID: pBuiltInID }).then((pBody) => (pBody && pBody.Type) || null); }

	saveType(pTypeID, pDefinition) { return this._request('PUT', '/Types/' + encodeURIComponent(pTypeID), { Definition: pDefinition }).then((pBody) => (pBody && pBody.Type) || null); }

	// -- board + layout (the two product-added routes) -------------------------

	getBoard(pTypeID) { return this._request('GET', '/Types/' + encodeURIComponent(pTypeID) + '/Board').then((pBody) => (pBody && pBody.Board) || []); }

	getLayout(pTypeID) { return this._request('GET', '/Types/' + encodeURIComponent(pTypeID) + '/Layout').then((pBody) => (pBody && pBody.Layout) || {}); }

	saveLayout(pTypeID, pLayout) { return this._request('PUT', '/Types/' + encodeURIComponent(pTypeID) + '/Layout', { Layout: pLayout }).then((pBody) => (pBody && pBody.Layout) || {}); }

	// -- one subject -----------------------------------------------------------

	open(pSubjectID) { return this._request('POST', '/Subject/' + encodeURIComponent(pSubjectID) + '/Open', {}).then((pBody) => (pBody && pBody.State) || null); }

	advance(pSubjectID, pToState) { return this._request('POST', '/Subject/' + encodeURIComponent(pSubjectID) + '/Advance', { ToState: pToState }); }

	reevaluate(pSubjectID) { return this._request('POST', '/Subject/' + encodeURIComponent(pSubjectID) + '/Reevaluate', {}).then((pBody) => (pBody && pBody.Exits) || []); }

	getSubject(pSubjectID) { return this._request('GET', '/Subject/' + encodeURIComponent(pSubjectID)); }

	getTimeline(pSubjectID) { return this._request('GET', '/Subject/' + encodeURIComponent(pSubjectID) + '/Timeline').then((pBody) => (pBody && pBody.Timeline) || []); }

	getMetrics(pSubjectID) { return this._request('GET', '/Subject/' + encodeURIComponent(pSubjectID) + '/Metrics').then((pBody) => (pBody && pBody.Metrics) || null); }

	getAgency(pSubjectID) { return this._request('GET', '/Subject/' + encodeURIComponent(pSubjectID) + '/Agency').then((pBody) => (pBody && pBody.Agency) || []); }

	// -- internals -------------------------------------------------------------

	_resolveHeaders()
	{
		let tmpHeaders = { 'Accept': 'application/json' };
		let tmpExtra = (typeof this._headers === 'function') ? this._headers() : this._headers;
		if (tmpExtra && typeof tmpExtra === 'object')
		{
			Object.keys(tmpExtra).forEach((pKey) => { tmpHeaders[pKey] = tmpExtra[pKey]; });
		}
		return tmpHeaders;
	}

	_request(pMethod, pPath, pBody)
	{
		if (!this._fetch) { return Promise.reject(new Error('WorkflowClient has no fetch implementation')); }
		let tmpHeaders = this._resolveHeaders();
		let tmpOptions = { method: pMethod, headers: tmpHeaders, credentials: this._credentials };
		if (pBody !== undefined)
		{
			tmpHeaders['Content-Type'] = 'application/json';
			tmpOptions.body = JSON.stringify(pBody);
		}
		return this._fetch(this.basePath + pPath, tmpOptions).then((pResponse) =>
		{
			return pResponse.json().catch(() => ({})).then((pData) =>
			{
				if (!pResponse.ok)
				{
					let tmpError = new Error((pData && pData.Error) || ('HTTP ' + pResponse.status));
					tmpError.statusCode = pResponse.status;
					throw tmpError;
				}
				return pData;
			});
		});
	}
}

function _trimTrailingSlash(pPath) { return (pPath && pPath.charAt(pPath.length - 1) === '/') ? pPath.slice(0, -1) : pPath; }

module.exports = WorkflowClient;

},{}],510:[function(require,module,exports){
'use strict';

/**
 * Workflow-Service
 *
 * The product-agnostic core of retold-workflow. It drives a subject through its workflow
 * on top of the fable-workflow engine, but it is stateless and persistence-backed: the
 * event log is the source of truth, and the engine is rebuilt from it for each operation,
 * then discarded. Nothing about a product's schema, tenancy, or storage leaks in;
 * everything arrives through injected, already-tenant-bound interfaces.
 *
 * Injected (constructor config):
 *   eventStore         { listEvents(subjectId) -> [event],
 *                        appendEvents(subjectId, [event]) -> void }       (required)
 *   contextResolver    (subjectId) -> data object (Promise or value)      (required)
 *                        the data a subject's guards address into; fetched once per op
 *   definitionResolver (subjectId) -> WorkflowDefinition (Promise/value)  (required)
 *                        which workflow governs the subject (its type's definition)
 *   projectionStore    { saveSnapshot(subjectId, snapshot) -> void,
 *                        subjectsForActor(actor) -> [subjectId] }         (optional)
 *                        the materialized eligibility that whatCanAdvance reads
 *   now                () -> ms timestamp                                 (optional)
 *   engineClass        a WorkflowEngine class                            (optional)
 *
 * Each write loads the subject's log, fetches its context once, builds a fresh engine,
 * hydrates (or opens), runs the operation, and persists only the new events plus a
 * projection snapshot. Reads hydrate and answer. Because state lives in the stores and
 * not here, the same subject behaves identically whichever process touches it.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libFableWorkflow = require('fable-workflow');

class WorkflowService
{
	constructor(pConfig)
	{
		let tmpConfig = pConfig || {};
		if (!tmpConfig.eventStore) { throw new Error('WorkflowService requires an eventStore'); }
		if (typeof tmpConfig.contextResolver !== 'function') { throw new Error('WorkflowService requires a contextResolver function'); }
		if (typeof tmpConfig.definitionResolver !== 'function') { throw new Error('WorkflowService requires a definitionResolver function'); }

		this._eventStore = tmpConfig.eventStore;
		this._contextResolver = tmpConfig.contextResolver;
		this._definitionResolver = tmpConfig.definitionResolver;
		this._projectionStore = tmpConfig.projectionStore || null;
		this._now = (typeof tmpConfig.now === 'function') ? tmpConfig.now : (() => Date.now());
		this._EngineClass = tmpConfig.engineClass || libFableWorkflow.WorkflowEngine;
	}

	// -- writes ----------------------------------------------------------------

	async open(pSubjectId, pActor, pAt)
	{
		let tmpExisting = await this._eventStore.listEvents(pSubjectId);
		if (tmpExisting && tmpExisting.length) { throw new Error('subject "' + pSubjectId + '" is already open'); }
		let tmpPrepared = await this._prepareEngine(pSubjectId);
		tmpPrepared.engine.open(pSubjectId, tmpPrepared.definition.Key, pActor, pAt);
		await this._persist(tmpPrepared, pSubjectId, 0);
		return tmpPrepared.engine.getState(pSubjectId);
	}

	async advance(pSubjectId, pToState, pActor, pAt)
	{
		let tmpPrepared = await this._hydrate(pSubjectId);
		let tmpResult = tmpPrepared.engine.advance(pSubjectId, pToState, pActor, pAt);
		if (tmpResult.ok) { await this._persist(tmpPrepared, pSubjectId, tmpPrepared.priorCount); }
		return tmpResult;
	}

	async emit(pSubjectId, pEvent, pAt)
	{
		let tmpPrepared = await this._hydrate(pSubjectId);
		tmpPrepared.engine.emit(pSubjectId, pEvent, pAt);
		await this._persist(tmpPrepared, pSubjectId, tmpPrepared.priorCount);
		return tmpPrepared.engine.getState(pSubjectId);
	}

	async reevaluate(pSubjectId, pAt)
	{
		let tmpPrepared = await this._hydrate(pSubjectId);
		tmpPrepared.engine.reevaluate(pSubjectId, pAt);
		await this._persist(tmpPrepared, pSubjectId, tmpPrepared.priorCount);
		return tmpPrepared.engine.getAvailableExits(pSubjectId);
	}

	// -- reads -----------------------------------------------------------------

	async getState(pSubjectId) { let tmpPrepared = await this._hydrate(pSubjectId); return tmpPrepared.engine.getState(pSubjectId); }
	async getMetrics(pSubjectId) { let tmpPrepared = await this._hydrate(pSubjectId); return tmpPrepared.engine.getMetrics(pSubjectId); }
	async getAvailableExits(pSubjectId) { let tmpPrepared = await this._hydrate(pSubjectId); return tmpPrepared.engine.getAvailableExits(pSubjectId); }
	async whoCanActOn(pSubjectId) { let tmpPrepared = await this._hydrate(pSubjectId); return tmpPrepared.engine.whoCanActOn(pSubjectId); }
	async getTimeline(pSubjectId) { let tmpEvents = await this._eventStore.listEvents(pSubjectId); return tmpEvents || []; }

	/** Cross-subject agency. Delegates to the projection store's indexed query. */
	async whatCanAdvance(pActor)
	{
		if (!this._projectionStore || typeof this._projectionStore.subjectsForActor !== 'function')
		{
			throw new Error('whatCanAdvance requires a projectionStore with a subjectsForActor query');
		}
		return this._projectionStore.subjectsForActor(pActor);
	}

	/**
	 * Whether an actor can take any satisfied exit in a stored snapshot. A projection store
	 * uses this (after its own indexed pre-filter) to answer subjectsForActor, so the agency
	 * rule lives in one place.
	 */
	static actorCanAct(pSnapshot, pActor)
	{
		let tmpActor = pActor || {};
		let tmpEntitlements = tmpActor.Entitlements || [];
		let tmpExits = (pSnapshot && pSnapshot.Eligibility) || [];
		return tmpExits.some((pExit) => pExit.GuardSatisfied
			&& (!pExit.RequiredEntitlement || tmpEntitlements.indexOf(pExit.RequiredEntitlement) >= 0)
			&& (pExit.ResolvedActor == null || pExit.ResolvedActor === tmpActor.ID));
	}

	// -- internals -------------------------------------------------------------

	async _prepareEngine(pSubjectId)
	{
		let tmpDefinition = await this._definitionResolver(pSubjectId);
		if (!tmpDefinition || !tmpDefinition.Key) { throw new Error('no workflow definition for subject "' + pSubjectId + '"'); }
		let tmpContext = (await this._contextResolver(pSubjectId)) || {};
		let tmpEngine = new this._EngineClass({ contextResolver: () => tmpContext, now: this._now });
		tmpEngine.defineWorkflow(tmpDefinition);
		return { engine: tmpEngine, definition: tmpDefinition };
	}

	async _hydrate(pSubjectId)
	{
		let tmpEvents = await this._eventStore.listEvents(pSubjectId);
		if (!tmpEvents || !tmpEvents.length) { throw new Error('subject "' + pSubjectId + '" is not open'); }
		let tmpPrepared = await this._prepareEngine(pSubjectId);
		tmpPrepared.engine.hydrate(pSubjectId, tmpPrepared.definition.Key, tmpEvents);
		tmpPrepared.priorCount = tmpPrepared.engine.getTimeline(pSubjectId).length;
		return tmpPrepared;
	}

	async _persist(pPrepared, pSubjectId, pPriorCount)
	{
		let tmpDelta = pPrepared.engine.getTimeline(pSubjectId).slice(pPriorCount);
		if (tmpDelta.length) { await this._eventStore.appendEvents(pSubjectId, tmpDelta); }
		if (this._projectionStore && typeof this._projectionStore.saveSnapshot === 'function')
		{
			await this._projectionStore.saveSnapshot(pSubjectId,
				{
					State: pPrepared.engine.getState(pSubjectId),
					Metrics: pPrepared.engine.getMetrics(pSubjectId),
					Eligibility: pPrepared.engine.getAvailableExits(pSubjectId)
				});
		}
	}
}

module.exports = WorkflowService;

},{"fable-workflow":67}],511:[function(require,module,exports){
'use strict';

/**
 * Workflow-Type-Catalog
 *
 * The reusable built-in / clone type catalog, with provenance and drift, over an
 * injected store. The store is the only coupling to a product's schema and tenancy:
 * retold-workflow never names a table or a customer. A product hands in a store that
 * is already bound to the current tenant, and this class adds the generic behavior.
 *
 * Two kinds of type live in the catalog:
 *   - built-in: platform-owned archetypes (Software, Recipe, ...). Read-only, versioned.
 *   - owned:    a tenant's own types. Either authored, or a deep clone of a built-in
 *               that records where it came from (SourceID + SourceVersion).
 *
 * Adopting a built-in is lazy and idempotent: the first time a tenant picks one it is
 * deep-cloned into an owned type; later picks of the same built-in return that one clone.
 *
 * Expected store interface (all Promise-returning), already bound to the current tenant:
 *   listBuiltIns()              -> [typeRecord]
 *   getBuiltIn(pBuiltInID)      -> typeRecord | null
 *   listOwnedTypes()            -> [typeRecord]
 *   findCloneOfBuiltIn(pID)     -> typeRecord | null
 *   createOwnedType(pRecord)    -> typeRecord (the persisted row, with its new ID)
 *
 * A typeRecord is a plain object carrying at least:
 *   { ID, TypeKey, Name, Description, Version, WorkflowDefinition, MetadataManifest,
 *     SourceID, SourceVersion }
 * ID and SourceID are opaque here. WorkflowDefinition and MetadataManifest are arbitrary
 * JSON the engine layer consumes; this class copies them verbatim and never inspects them.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const ORIGIN_BUILTIN = 'builtin';
const ORIGIN_OWNED = 'owned';

class WorkflowTypeCatalog
{
	constructor(pStore)
	{
		if (!pStore) { throw new Error('WorkflowTypeCatalog requires a store'); }
		this.store = pStore;
	}

	/**
	 * The picker list: built-ins (labeled) plus the tenant's own types. A built-in the
	 * tenant has already adopted carries AdoptedAsID pointing at its clone, so a product
	 * can show "already in use" instead of offering a second copy.
	 */
	async unionList()
	{
		let tmpBuiltIns = (await this.store.listBuiltIns()) || [];
		let tmpOwned = (await this.store.listOwnedTypes()) || [];

		let tmpOwnedBySource = {};
		tmpOwned.forEach((pType) => { if (pType.SourceID != null) { tmpOwnedBySource[pType.SourceID] = pType; } });

		let tmpList = [];
		tmpBuiltIns.forEach((pType) =>
		{
			let tmpClone = tmpOwnedBySource[pType.ID];
			tmpList.push(Object.assign({}, pType, { Origin: ORIGIN_BUILTIN, AdoptedAsID: tmpClone ? tmpClone.ID : null }));
		});
		tmpOwned.forEach((pType) =>
		{
			tmpList.push(Object.assign({}, pType, { Origin: ORIGIN_OWNED }));
		});
		return tmpList;
	}

	/** The tenant's own types only. */
	async ownedTypes()
	{
		let tmpOwned = (await this.store.listOwnedTypes()) || [];
		return tmpOwned.map((pType) => Object.assign({}, pType, { Origin: ORIGIN_OWNED }));
	}

	/**
	 * Adopt a built-in: find-or-create the tenant's clone of it. Idempotent, so a second
	 * call for the same built-in returns the same clone. Returns the owned typeRecord.
	 */
	async adoptBuiltIn(pBuiltInID)
	{
		let tmpExisting = await this.store.findCloneOfBuiltIn(pBuiltInID);
		if (tmpExisting) { return Object.assign({}, tmpExisting, { Origin: ORIGIN_OWNED }); }

		let tmpBuiltIn = await this.store.getBuiltIn(pBuiltInID);
		if (!tmpBuiltIn) { throw new Error('no built-in workflow type with id "' + pBuiltInID + '"'); }

		let tmpClone =
		{
			TypeKey: tmpBuiltIn.TypeKey,
			Name: tmpBuiltIn.Name,
			Description: tmpBuiltIn.Description,
			WorkflowDefinition: _deepCopy(tmpBuiltIn.WorkflowDefinition),
			MetadataManifest: _deepCopy(tmpBuiltIn.MetadataManifest),
			SourceID: tmpBuiltIn.ID,
			SourceVersion: tmpBuiltIn.Version
		};
		let tmpCreated = await this.store.createOwnedType(tmpClone);
		return Object.assign({}, tmpCreated, { Origin: ORIGIN_OWNED });
	}

	/**
	 * Drift of an owned type against the built-in it was cloned from. Returns
	 * { Drifted, SourceID, FromVersion, ToVersion }. Drifted is false for a type with no
	 * source (authored from scratch) or whose source built-in version is unchanged.
	 */
	async driftStatus(pOwnedType)
	{
		if (!pOwnedType || pOwnedType.SourceID == null)
		{
			return { Drifted: false, SourceID: null, FromVersion: null, ToVersion: null };
		}
		let tmpBuiltIn = await this.store.getBuiltIn(pOwnedType.SourceID);
		if (!tmpBuiltIn)
		{
			return { Drifted: false, SourceID: pOwnedType.SourceID, FromVersion: pOwnedType.SourceVersion, ToVersion: null };
		}
		let tmpDrifted = Number(tmpBuiltIn.Version) > Number(pOwnedType.SourceVersion);
		return { Drifted: tmpDrifted, SourceID: pOwnedType.SourceID, FromVersion: pOwnedType.SourceVersion, ToVersion: tmpBuiltIn.Version };
	}
}

function _deepCopy(pValue)
{
	if (pValue === undefined || pValue === null) { return pValue; }
	return JSON.parse(JSON.stringify(pValue));
}

module.exports = WorkflowTypeCatalog;
module.exports.ORIGIN_BUILTIN = ORIGIN_BUILTIN;
module.exports.ORIGIN_OWNED = ORIGIN_OWNED;

},{}],512:[function(require,module,exports){
'use strict';

/**
 * StateCard: the pict-section-flow node type a workflow state renders as.
 *
 * One card type serves every state; the lane color is set per node by the marshaling (so all
 * lanes share this one card, colored individually), not baked into the card. The card carries
 * an input port for incoming transitions and an output port for outgoing ones, which is what
 * definitionToFlow wires connections between.
 *
 * The card declares an on-graph properties panel (double-click a state) over the state fields:
 * Name binds to the node Title, the rest to the node Data. It is a Template panel whose inputs
 * call back into the map view (resolved through AppData.WorkflowMap.ViewID) by node hash, so it
 * needs no form metacontroller and stays in step with the map's own edit + recolor logic. The
 * card Code matches Definition-Flow's STATE_NODE_TYPE so a node placed from the palette is the
 * same type the marshaling produces.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;
const libDefinitionFlow = require('../Definition-Flow.js');

class StateCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				Title: 'State',
				Name: 'Workflow State',
				Code: libDefinitionFlow.STATE_NODE_TYPE,
				Description: 'A state in the workflow. Incoming transitions arrive at In; outgoing transitions leave from Out.',
				Category: 'Workflow',
				TitleBarColor: '#3d6fb4',
				Icon: 'WorkflowState',
				CornerRadius: 5,
				Width: 190,
				Height: 70,
				Inputs:
				[
					{ Name: 'In', Side: 'left' }
				],
				Outputs:
				[
					{ Name: 'Out', Side: 'right' }
				],
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 280,
					DefaultHeight: 250,
					Title: 'State',
					Configuration:
					{
						TemplateHash: 'Workflow-State-Panel',
						Templates:
						[
							{
								Hash: 'Workflow-State-Panel',
								Template: /*html*/`
<div class="wfp">
	<div class="wfp-field"><label class="wfp-label">Name</label><input type="text" class="wfp-input" value="{~D:Record.Title~}" {~D:AppData.WorkflowMap.DisabledAttr~} oninput="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editState('{~D:Record.Hash~}','Name',this.value)"></div>
	<div class="wfp-field"><label class="wfp-label">Lane</label><input type="text" class="wfp-input" list="WFMap-Lanes" value="{~D:Record.Data.Lane~}" {~D:AppData.WorkflowMap.DisabledAttr~} oninput="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editState('{~D:Record.Hash~}','Lane',this.value)"></div>
	<div class="wfp-field"><label class="wfp-label">Marker</label><input type="text" class="wfp-input" value="{~D:Record.Data.Marker~}" {~D:AppData.WorkflowMap.DisabledAttr~} oninput="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editState('{~D:Record.Hash~}','Marker',this.value)"></div>
	<label class="wfp-check"><input type="checkbox" {~NE:Record.Data.IsInitial^checked~} {~D:AppData.WorkflowMap.DisabledAttr~} onchange="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editState('{~D:Record.Hash~}','IsInitial',this.checked)"> Initial state</label>
	<label class="wfp-check"><input type="checkbox" {~NE:Record.Data.IsTerminal^checked~} {~D:AppData.WorkflowMap.DisabledAttr~} onchange="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editState('{~D:Record.Hash~}','IsTerminal',this.checked)"> Terminal state</label>
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = StateCard;

},{"../Definition-Flow.js":505,"pict-section-flow":449}],513:[function(require,module,exports){
'use strict';

/**
 * TransitionCard: the pict-section-flow node type a transition renders as.
 *
 * In this map a transition is a first-class card sitting between two states (Status -> transition
 * -> Status), not an annotation on an edge. It is styled to read as a connector/gate rather than a
 * lane member: smaller, one muted color, its title showing the entitlement it requires (or "open").
 * It has an input port (the edge from the source state) and an output port (the edge to the target
 * state). Its on-graph panel (double-click) edits the gate fields, calling back into the map view
 * by node hash through AppData.WorkflowMap.ViewID, the same way the StateCard's panel does.
 *
 * The card Code matches Definition-Flow's TRANSITION_NODE_TYPE so a node placed from the palette is
 * the same type the marshaling produces.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictFlowCard = require('pict-section-flow').PictFlowCard;
const libDefinitionFlow = require('../Definition-Flow.js');

class TransitionCard extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign(
			{},
			{
				// Title is the type label (the "TRANSITION" eyebrow); the per-node title is the gate.
				Title: 'Transition',
				Name: 'Transition',
				Code: libDefinitionFlow.TRANSITION_NODE_TYPE,
				Description: 'A governed move from one state to the next. Wire it: source state to In, Out to the target state.',
				Category: 'Workflow',
				// Theme-driven muted color so transitions recede against the lane-colored states; white
				// title text (the renderer default) reads on this mid-tone. A pronounced corner radius
				// gives the capsule shape that distinguishes a transition from a state.
				TitleBarColor: 'var(--theme-color-text-secondary, #7f8c8d)',
				BodyStyle: { fill: 'var(--theme-color-background-tertiary, #eef1f4)' },
				Icon: 'WorkflowTransition',
				CornerRadius: 24,
				Width: 160,
				Height: 64,
				ShowTypeLabel: true,
				Inputs:
				[
					{ Name: 'In', Side: 'left' }
				],
				Outputs:
				[
					{ Name: 'Out', Side: 'right' }
				],
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 300,
					DefaultHeight: 280,
					Title: 'Transition',
					Configuration:
					{
						TemplateHash: 'Workflow-Transition-Panel',
						Templates:
						[
							{
								Hash: 'Workflow-Transition-Panel',
								Template: /*html*/`
<div class="wfp">
	<div class="wfp-transition-head">{~D:Record.Data._FromName~} to {~D:Record.Data._ToName~}</div>
	<div class="wfp-field"><label class="wfp-label">Requires entitlement</label><input type="text" class="wfp-input" list="WFMap-Entitlements" value="{~D:Record.Data.RequiresEntitlement~}" {~D:AppData.WorkflowMap.DisabledAttr~} oninput="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editTransition('{~D:Record.Hash~}','RequiresEntitlement',this.value)"></div>
	<div class="wfp-field"><label class="wfp-label">Actor address</label><input type="text" class="wfp-input" value="{~D:Record.Data.ActorAddress~}" {~D:AppData.WorkflowMap.DisabledAttr~} oninput="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editTransition('{~D:Record.Hash~}','ActorAddress',this.value)"></div>
	<div class="wfp-field"><label class="wfp-label">Guard (JSON, blank for none)</label><textarea class="wfp-input wfp-textarea" {~D:AppData.WorkflowMap.DisabledAttr~} oninput="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].editTransitionGuard('{~D:Record.Hash~}',this.value)">{~D:Record.Data._GuardText~}</textarea></div>
</div>`
							}
						]
					}
				}
			},
			pOptions),
			pServiceHash);
	}
}

module.exports = TransitionCard;

},{"../Definition-Flow.js":505,"pict-section-flow":449}],514:[function(require,module,exports){
'use strict';

/**
 * Workflow board (run time).
 *
 * The lanes a person works in, with each subject sitting in the lane of its current state. Built
 * on the board model in the core: state-to-lane is many-to-one, so two states in one lane keep a
 * card in place and only change its marker. A card's "Move" opens a menu of the transitions out
 * of its current state; choosing one calls advance through the client. A move the gates refuse
 * comes back with a reason, shown in a modal rather than a native alert.
 *
 * The subjects and the definition (for the lanes) come from the injected client: getBoard(typeID)
 * for the cards, and the type's WorkflowDefinition for the lane layout.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libBoardModel = require('../Board-Model.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Workflow-Board',
	DefaultRenderable: 'Workflow-Board-Container',
	DefaultDestinationAddress: '#Workflow-Board-Container',
	AutoRender: false,

	ClientProvider: 'WorkflowAPI',
	Client: null,

	CSS: /*css*/`
		.wfb { display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%; }
		.wfb-head { flex-shrink: 0; display: flex; align-items: center; justify-content: space-between; padding: 0.5em 0.25em 0.6em; }
		.wfb-title { font-size: 1.2em; font-weight: 600; margin: 0; }
		.wfb-lanes { display: flex; gap: 0.6em; flex: 1; min-height: 0; overflow-x: auto; padding-bottom: 0.5em; }
		.wfb-lane { flex: 0 0 220px; display: flex; flex-direction: column; background: var(--theme-color-background-tertiary, #f4f4f4); border-radius: 7px; max-height: 100%; }
		.wfb-lane-head { flex-shrink: 0; padding: 0.55em 0.7em; font-weight: 600; font-size: 0.9em; border-bottom: 1px solid var(--theme-color-border-light, #e0e0e0); display: flex; justify-content: space-between; align-items: center; }
		.wfb-lane-count { font-weight: 400; color: var(--theme-color-text-secondary, #888); font-size: 0.85em; }
		.wfb-lane-cards { padding: 0.5em; overflow-y: auto; display: flex; flex-direction: column; gap: 0.5em; }
		.wfb-card { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #ddd); border-radius: 6px; padding: 0.55em 0.65em; box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
		.wfb-card-title { font-size: 0.92em; font-weight: 500; margin-bottom: 0.3em; }
		.wfb-card-marker { font-size: 0.72em; color: var(--theme-color-text-secondary, #777); margin-bottom: 0.4em; }
		.wfb-card-actions { display: flex; gap: 0.35em; }
		.wfb-card-btn { font-size: 0.78em; padding: 0.25em 0.55em; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 4px; background: var(--theme-color-background-panel, #fff); cursor: pointer; }
		.wfb-card-btn:hover { background: var(--theme-color-background-hover, #f0f0f0); }
		.wfb-empty { color: var(--theme-color-text-secondary, #999); font-size: 0.85em; padding: 0.5em; }
		.wfb-loading { color: var(--theme-color-text-secondary, #888); padding: 1em; }
	`,

	Templates:
	[
		{
			Hash: 'Workflow-Board-Container',
			Template: /*html*/`
<div class="wfb">
	<div class="wfb-head">
		<h2 class="wfb-title">{~D:AppData.WorkflowBoard.TypeName~} board</h2>
	</div>
	{~TS:Workflow-Board-Loading:AppData.WorkflowBoard.LoadingSlot~}
	<div class="wfb-lanes">{~TS:Workflow-Board-Lane:AppData.WorkflowBoard.Lanes~}</div>
</div>`
		},
		{ Hash: 'Workflow-Board-Loading', Template: /*html*/`<div class="wfb-loading">Loading the board...</div>` },
		{
			Hash: 'Workflow-Board-Lane',
			Template: /*html*/`
<div class="wfb-lane">
	<div class="wfb-lane-head"><span>{~D:Record.Lane~}</span><span class="wfb-lane-count">{~D:Record.Count~}</span></div>
	<div class="wfb-lane-cards">
		{~TS:Workflow-Board-Card:Record.Cards~}
		{~TS:Workflow-Board-Lane-Empty:Record.EmptySlot~}
	</div>
</div>`
		},
		{ Hash: 'Workflow-Board-Lane-Empty', Template: /*html*/`<div class="wfb-empty">No cards.</div>` },
		{
			Hash: 'Workflow-Board-Card',
			Template: /*html*/`
<div class="wfb-card">
	<div class="wfb-card-title">{~D:Record.Title~}</div>
	<div class="wfb-card-marker">{~D:Record.Marker~}</div>
	<div class="wfb-card-actions">
		<button class="wfb-card-btn" onclick="_Pict.views['{~D:AppData.WorkflowBoard.ViewID~}'].moveCard({~D:Record.SubjectID~})">Move</button>
		<button class="wfb-card-btn" onclick="_Pict.views['{~D:AppData.WorkflowBoard.ViewID~}'].openSubject({~D:Record.SubjectID~})">Details</button>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'Workflow-Board-Container', TemplateHash: 'Workflow-Board-Container', DestinationAddress: '#Workflow-Board-Container', RenderMethod: 'replace' }
	]
};

class PictViewWorkflowBoard extends libPictView
{
	onBeforeInitialize()
	{
		if (!this.pict.AppData.WorkflowBoard)
		{
			this.pict.AppData.WorkflowBoard = { ViewID: this.options.ViewIdentifier, TypeRecord: null, TypeName: 'Workflow', Lanes: [], Unassigned: [], LoadingSlot: [] };
		}
		this.pict.AppData.WorkflowBoard.ViewID = this.options.ViewIdentifier;
		return super.onBeforeInitialize();
	}

	_state() { return this.pict.AppData.WorkflowBoard; }
	_client() { if (this.options.Client) { return this.options.Client; } let tmpName = this.options.ClientProvider || 'WorkflowAPI'; return (this.pict.providers && this.pict.providers[tmpName]) || null; }
	_modal() { return this.pict.views['Pict-Section-Modal'] || null; }

	/** Load and show the board for a type record (from the catalog). */
	showType(pTypeRecord)
	{
		let tmpState = this._state();
		tmpState.TypeRecord = pTypeRecord || null;
		tmpState.TypeName = (pTypeRecord && pTypeRecord.Name) || 'Workflow';
		return this.reload();
	}

	reload()
	{
		let tmpState = this._state();
		let tmpClient = this._client();
		let tmpRecord = tmpState.TypeRecord;
		if (!tmpClient || !tmpRecord) { this.render(); return Promise.resolve(); }

		tmpState.LoadingSlot = [{}];
		this.render();

		let tmpDefinitionPromise = tmpRecord.WorkflowDefinition ? Promise.resolve(tmpRecord.WorkflowDefinition)
			: (tmpClient.getType ? tmpClient.getType(tmpRecord.ID).then((pType) => (pType && pType.WorkflowDefinition) || null) : Promise.resolve(null));

		return Promise.all([tmpDefinitionPromise, tmpClient.getBoard(tmpRecord.ID)]).then((pResults) =>
		{
			this._Definition = pResults[0] || { States: [], Transitions: [] };
			let tmpSubjects = pResults[1] || [];
			let tmpModel = libBoardModel.buildBoardModel(this._Definition, tmpSubjects.map((pSubject) => ({ ID: pSubject.ID, State: pSubject.State, Title: pSubject.Title })));
			tmpState.Lanes = tmpModel.Lanes.map((pLane) => this._decorateLane(pLane));
			tmpState.Unassigned = tmpModel.Unassigned;
			tmpState.LoadingSlot = [];
			this.render();
		}).catch((pError) =>
		{
			tmpState.LoadingSlot = [];
			this._toast('Could not load the board: ' + pError.message, 'error');
			this.render();
		});
	}

	_decorateLane(pLane)
	{
		return {
			Lane: pLane.Lane,
			Count: pLane.Cards.length,
			Cards: pLane.Cards.map((pCard) => ({ SubjectID: pCard.SubjectID, Title: pCard.Title || ('#' + pCard.SubjectID), Marker: pCard.Marker || pCard.StateName, State: pCard.State })),
			EmptySlot: pLane.Cards.length ? [] : [{}]
		};
	}

	// The transitions out of a state, as a display list, for the move menu.
	_exitsFromState(pStateKey)
	{
		let tmpStateName = {};
		((this._Definition && this._Definition.States) || []).forEach((pState) => { tmpStateName[pState.Key] = pState.Name || pState.Key; });
		return ((this._Definition && this._Definition.Transitions) || [])
			.filter((pTransition) => pTransition.From === pStateKey)
			.map((pTransition) => ({ To: pTransition.To, ToName: tmpStateName[pTransition.To] || pTransition.To }));
	}

	_cardState(pSubjectID)
	{
		let tmpFound = null;
		(this._state().Lanes || []).forEach((pLane) => pLane.Cards.forEach((pCard) => { if (pCard.SubjectID === pSubjectID) { tmpFound = pCard; } }));
		return tmpFound;
	}

	/** Open the move menu for a card: the exits from its current state, as modal buttons. */
	moveCard(pSubjectID)
	{
		let tmpModal = this._modal();
		let tmpCard = this._cardState(pSubjectID);
		if (!tmpCard) { return; }
		let tmpExits = this._exitsFromState(tmpCard.State);
		if (!tmpModal) { return; }
		if (!tmpExits.length)
		{
			tmpModal.show({ title: 'No moves', content: '<p>There are no transitions out of this state.</p>', buttons: [ { Hash: 'ok', Label: 'OK', Style: 'primary' } ] });
			return;
		}
		let tmpButtons = tmpExits.map((pExit) => ({ Hash: pExit.To, Label: pExit.ToName }));
		tmpButtons.push({ Hash: '__cancel__', Label: 'Cancel' });
		tmpModal.show({ title: 'Move "' + (tmpCard.Title) + '"', content: '<p>Move to which state?</p>', buttons: tmpButtons }).then((pChoice) =>
		{
			if (!pChoice || pChoice === '__cancel__') { return; }
			this._advance(pSubjectID, pChoice);
		});
	}

	_advance(pSubjectID, pToState)
	{
		let tmpClient = this._client();
		if (!tmpClient) { return; }
		tmpClient.advance(pSubjectID, pToState).then(() =>
		{
			this._toast('Moved.', 'success');
			this.reload();
		}).catch((pError) =>
		{
			// A gated or blocked move comes back with the reason; show it, do not pretend it moved.
			let tmpModal = this._modal();
			if (tmpModal) { tmpModal.show({ title: 'That move is blocked', content: '<p>' + _escapeHTML(pError.message || 'The move was refused.') + '</p>', buttons: [ { Hash: 'ok', Label: 'OK', Style: 'primary' } ] }); }
		});
	}

	openSubject(pSubjectID)
	{
		let tmpCard = this._cardState(pSubjectID);
		if (typeof this.options.onOpenSubject === 'function') { this.options.onOpenSubject(pSubjectID, this._state().TypeRecord, tmpCard && tmpCard.Title); }
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_toast(pMessage, pType) { let tmpModal = this._modal(); if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'info' }); } }
}

function _escapeHTML(pValue) { return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

module.exports = PictViewWorkflowBoard;
module.exports.default_configuration = _ViewConfiguration;

},{"../Board-Model.js":504,"pict-view":365}],515:[function(require,module,exports){
'use strict';

/**
 * The type catalog and picker.
 *
 * The union list from the client: built-ins (labeled) plus the tenant's own types. A built-in the
 * tenant has not taken yet offers Adopt; one already adopted says so. An owned type that was
 * cloned from a built-in shows a drift note when the built-in has since advanced (computed here
 * from the same list: the built-in's Version against the clone's SourceVersion). This is the entry
 * point to the rest: opening a type hands it to the host (which shows the designer or the board).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Workflow-Catalog',
	DefaultRenderable: 'Workflow-Catalog-Container',
	DefaultDestinationAddress: '#Workflow-Catalog-Container',
	AutoRender: false,

	ClientProvider: 'WorkflowAPI',
	Client: null,

	CSS: /*css*/`
		.wfc { padding: 0.25em; }
		.wfc-head { font-size: 1.2em; font-weight: 600; margin: 0 0 0.75em; }
		.wfc-list { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 0.75em; }
		.wfc-card { border: 1px solid var(--theme-color-border-default, #ddd); border-radius: 7px; padding: 0.8em; background: var(--theme-color-background-panel, #fff); display: flex; flex-direction: column; }
		.wfc-card-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.3em; }
		.wfc-card-name { font-weight: 600; font-size: 1.02em; }
		.wfc-badge { font-size: 0.7em; padding: 0.12em 0.5em; border-radius: 10px; background: var(--theme-color-background-tertiary, #eee); color: var(--theme-color-text-secondary, #666); }
		.wfc-badge-builtin { background: var(--theme-color-brand-primary, #2e7d74); color: #fff; }
		.wfc-desc { font-size: 0.85em; color: var(--theme-color-text-secondary, #666); line-height: 1.45; flex: 1; margin-bottom: 0.6em; }
		.wfc-drift { font-size: 0.78em; color: var(--theme-color-status-warning, #b9770e); background: var(--theme-color-status-warning-background, #fdf6e3); border-radius: 4px; padding: 0.3em 0.5em; margin-bottom: 0.5em; }
		.wfc-actions { display: flex; gap: 0.4em; flex-wrap: wrap; }
		.wfc-btn { padding: 0.35em 0.7em; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 5px; background: var(--theme-color-background-panel, #fff); cursor: pointer; font-size: 0.85em; }
		.wfc-btn:hover { background: var(--theme-color-background-hover, #f1f1f1); }
		.wfc-btn-primary { background: var(--theme-color-brand-primary, #2e7d74); border-color: var(--theme-color-brand-primary, #2e7d74); color: #fff; }
		.wfc-adopted-note { font-size: 0.78em; color: var(--theme-color-text-secondary, #888); align-self: center; }
		.wfc-empty, .wfc-loading { color: var(--theme-color-text-secondary, #888); padding: 1em 0; }
	`,

	Templates:
	[
		{
			Hash: 'Workflow-Catalog-Container',
			Template: /*html*/`
<div class="wfc">
	<div class="wfc-head">Workflows</div>
	{~TS:Workflow-Catalog-Loading:AppData.WorkflowCatalog.LoadingSlot~}
	<div class="wfc-list">{~TS:Workflow-Catalog-Card:AppData.WorkflowCatalog.Rows~}</div>
	{~TS:Workflow-Catalog-Empty:AppData.WorkflowCatalog.EmptySlot~}
</div>`
		},
		{ Hash: 'Workflow-Catalog-Loading', Template: /*html*/`<div class="wfc-loading">Loading workflows...</div>` },
		{ Hash: 'Workflow-Catalog-Empty', Template: /*html*/`<div class="wfc-empty">No workflows yet.</div>` },
		{
			Hash: 'Workflow-Catalog-Card',
			Template: /*html*/`
<div class="wfc-card">
	<div class="wfc-card-top">
		<span class="wfc-card-name">{~D:Record.Name~}</span>
		<span class="wfc-badge {~D:Record.BadgeClass~}">{~D:Record.OriginLabel~}</span>
	</div>
	<div class="wfc-desc">{~D:Record.Description~}</div>
	{~TS:Workflow-Catalog-Drift:Record.DriftSlot~}
	<div class="wfc-actions">
		<button class="wfc-btn wfc-btn-primary" onclick="_Pict.views['{~D:AppData.WorkflowCatalog.ViewID~}'].openType('{~D:Record.RowKey~}')">{~D:Record.OpenLabel~}</button>
		{~TS:Workflow-Catalog-Board:Record.BoardSlot~}
		{~TS:Workflow-Catalog-Adopt:Record.AdoptSlot~}
		{~TS:Workflow-Catalog-Adopted:Record.AdoptedSlot~}
	</div>
</div>`
		},
		{ Hash: 'Workflow-Catalog-Drift', Template: /*html*/`<div class="wfc-drift">{~D:Record.Text~}</div>` },
		{ Hash: 'Workflow-Catalog-Board', Template: /*html*/`<button class="wfc-btn" onclick="_Pict.views['{~D:AppData.WorkflowCatalog.ViewID~}'].openBoard('{~D:Record.RowKey~}')">Board</button>` },
		{ Hash: 'Workflow-Catalog-Adopt', Template: /*html*/`<button class="wfc-btn" onclick="_Pict.views['{~D:AppData.WorkflowCatalog.ViewID~}'].adopt('{~D:Record.RowKey~}')">Adopt</button>` },
		{ Hash: 'Workflow-Catalog-Adopted', Template: /*html*/`<span class="wfc-adopted-note">In use</span>` }
	],

	Renderables:
	[
		{ RenderableHash: 'Workflow-Catalog-Container', TemplateHash: 'Workflow-Catalog-Container', DestinationAddress: '#Workflow-Catalog-Container', RenderMethod: 'replace' }
	]
};

class PictViewWorkflowCatalog extends libPictView
{
	onBeforeInitialize()
	{
		if (!this.pict.AppData.WorkflowCatalog)
		{
			this.pict.AppData.WorkflowCatalog = { ViewID: this.options.ViewIdentifier, Rows: [], LoadingSlot: [], EmptySlot: [] };
		}
		this.pict.AppData.WorkflowCatalog.ViewID = this.options.ViewIdentifier;
		return super.onBeforeInitialize();
	}

	_state() { return this.pict.AppData.WorkflowCatalog; }
	_client() { if (this.options.Client) { return this.options.Client; } let tmpName = this.options.ClientProvider || 'WorkflowAPI'; return (this.pict.providers && this.pict.providers[tmpName]) || null; }
	_modal() { return this.pict.views['Pict-Section-Modal'] || null; }

	reload()
	{
		let tmpState = this._state();
		let tmpClient = this._client();
		if (!tmpClient) { this.render(); return Promise.resolve(); }
		tmpState.LoadingSlot = [{}]; tmpState.EmptySlot = [];
		this.render();
		return tmpClient.getTypes().then((pTypes) =>
		{
			this._Types = pTypes || [];
			tmpState.Rows = this._buildRows(this._Types);
			tmpState.LoadingSlot = [];
			tmpState.EmptySlot = tmpState.Rows.length ? [] : [{}];
			this.render();
		}).catch((pError) =>
		{
			tmpState.LoadingSlot = [];
			this._toast('Could not load workflows: ' + pError.message, 'error');
			this.render();
		});
	}

	_buildRows(pTypes)
	{
		let tmpBuiltInVersion = {};
		pTypes.forEach((pType) => { if (pType.Origin === 'builtin') { tmpBuiltInVersion[pType.ID] = Number(pType.Version); } });

		return pTypes.map((pType) =>
		{
			let tmpIsBuiltIn = (pType.Origin === 'builtin');
			let tmpAdopted = tmpIsBuiltIn && (pType.AdoptedAsID != null);
			let tmpDriftSlot = [];
			if (!tmpIsBuiltIn && pType.SourceID != null && tmpBuiltInVersion[pType.SourceID] != null)
			{
				if (tmpBuiltInVersion[pType.SourceID] > Number(pType.SourceVersion))
				{
					tmpDriftSlot = [{ Text: 'Update available: the built-in is now version ' + tmpBuiltInVersion[pType.SourceID] + ' (this copy is from version ' + pType.SourceVersion + ').' }];
				}
			}
			// Built-ins and owned types live in separate id spaces whose numbers collide (both can be
			// 1), so a composite Origin+ID key is what the buttons pass back to pick the right record.
			let tmpRowKey = pType.Origin + '|' + pType.ID;
			return {
				ID: pType.ID,
				RowKey: tmpRowKey,
				Name: pType.Name || pType.TypeKey || ('Type ' + pType.ID),
				Description: pType.Description || '',
				OriginLabel: tmpIsBuiltIn ? 'Built-in' : 'Yours',
				BadgeClass: tmpIsBuiltIn ? 'wfc-badge-builtin' : '',
				OpenLabel: tmpIsBuiltIn ? 'View' : 'Open designer',
				DriftSlot: tmpDriftSlot,
				BoardSlot: tmpIsBuiltIn ? [] : [{ RowKey: tmpRowKey }],
				AdoptSlot: (tmpIsBuiltIn && !tmpAdopted) ? [{ RowKey: tmpRowKey }] : [],
				AdoptedSlot: (tmpIsBuiltIn && tmpAdopted) ? [{}] : []
			};
		});
	}

	_typeByRowKey(pRowKey) { return (this._Types || []).find((pType) => (pType.Origin + '|' + pType.ID) === pRowKey) || null; }

	openType(pRowKey)
	{
		let tmpType = this._typeByRowKey(pRowKey);
		if (tmpType && typeof this.options.onOpenType === 'function') { this.options.onOpenType(tmpType); }
	}

	openBoard(pRowKey)
	{
		let tmpType = this._typeByRowKey(pRowKey);
		if (tmpType && typeof this.options.onShowBoard === 'function') { this.options.onShowBoard(tmpType); }
	}

	adopt(pRowKey)
	{
		let tmpClient = this._client();
		let tmpType = this._typeByRowKey(pRowKey);
		if (!tmpClient || !tmpType) { return; }
		tmpClient.adoptType(tmpType.ID).then((pClone) =>
		{
			this._toast('Adopted into your workflows.', 'success');
			return this.reload().then(() =>
			{
				if (pClone && typeof this.options.onOpenType === 'function') { this.options.onOpenType(Object.assign({}, pClone, { Origin: 'owned' })); }
			});
		}).catch((pError) => this._toast('Could not adopt: ' + pError.message, 'error'));
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_toast(pMessage, pType) { let tmpModal = this._modal(); if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'info' }); } }
}

module.exports = PictViewWorkflowCatalog;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],516:[function(require,module,exports){
'use strict';

/**
 * Workflow map / designer.
 *
 * The centerpiece: a workflow definition rendered as a graph where both states and transitions are
 * cards. A state is a StateCard (colored by lane); a transition is a TransitionCard sitting between
 * two states, wired Status -> transition -> Status, styled as a muted connector with the gate it
 * enforces as its title. Editing happens on the graph: double-click a state for its panel (Name,
 * Lane, Marker, IsInitial, IsTerminal); double-click a transition for its panel (RequiresEntitlement,
 * ActorAddress, Guard). Both are ordinary node panels. The graph is the definition: reading it back
 * (flowToDefinition) takes each transition's From and To from the edges around its card.
 *
 * Built-in (platform) types open read-only; the first move to edit one offers to adopt it (clone
 * into the tenant) and edits the clone. Before a save, the assembled definition runs through the
 * engine's own defineWorkflow checks, and a failure is shown rather than persisted. State positions
 * save and restore as a per-type layout through the client; transition cards center themselves
 * between their states. Everything talks to an injected client (the WorkflowClient shape), supplied
 * as options.Client or named by options.ClientProvider (default 'WorkflowAPI').
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libPictSectionFlow = require('pict-section-flow');
const libDefinitionFlow = require('../Definition-Flow.js');
const libStateCard = require('../cards/State-Card.js');
const libTransitionCard = require('../cards/Transition-Card.js');

// Title-bar glyphs for the two kinds, registered on the flow's icon provider. They stroke with the
// theme's panel color so they match the white title text on the colored title bars and follow the
// theme. The {FlowIconSize} placeholder is the flow icon provider's size token. A State reads as a
// box with a center point; a Transition as a forward arrow (a move).
const _STATE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-background-panel, #ffffff)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3.5"/><circle cx="12" cy="12" r="1.6" fill="var(--theme-color-background-panel, #ffffff)" stroke="none"/></svg>';
const _TRANSITION_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="var(--theme-color-background-panel, #ffffff)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h12.5"/><path d="M12 5.5l7 6.5-7 6.5"/></svg>';

// The arrange menu. 'workflow' is the bespoke, workflow-aware stairstep (states from the initial
// one, alternating two rows, each state's transitions to its right); the rest dispatch to
// pict-section-flow's own layout algorithms by name so the same graph can be tried a few ways.
const _LAYOUT_CHOICES =
[
	{ Value: 'workflow',  Label: 'Workflow stairstep', Algorithm: null },
	{ Value: 'Staggered', Label: 'Stairstep (compact)', Algorithm: 'Staggered' },
	{ Value: 'Layered',   Label: 'Layered rows',        Algorithm: 'Layered' },
	{ Value: 'Grid',      Label: 'Grid',                Algorithm: 'Grid' },
	{ Value: 'Circular',  Label: 'Circular',            Algorithm: 'Circular' }
];

const _ViewConfiguration =
{
	ViewIdentifier: 'Workflow-Map',
	DefaultRenderable: 'Workflow-Map-Container',
	DefaultDestinationAddress: '#Workflow-Map-Container',
	AutoRender: false,

	ClientProvider: 'WorkflowAPI',
	Client: null,

	CSS: /*css*/`
		.wfmap { display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%; }
		.wfmap-head { flex-shrink: 0; display: flex; align-items: center; justify-content: space-between; gap: 0.75em; padding: 0.5em 0.25em 0.75em; border-bottom: 1px solid var(--theme-color-border-light, #e3e3e3); }
		.wfmap-title { font-size: 1.3em; font-weight: 600; margin: 0; }
		.wfmap-title small { font-weight: 400; color: var(--theme-color-text-secondary, #777); margin-left: 0.5em; font-size: 0.7em; }
		.wfmap-toolbar { display: flex; align-items: center; gap: 0.4em; flex-wrap: wrap; }
		.wfmap-btn { padding: 0.4em 0.75em; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 5px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #222); cursor: pointer; font-size: 0.9em; }
		.wfmap-btn:hover { background: var(--theme-color-background-hover, #f2f2f2); }
		.wfmap-btn-primary { background: var(--theme-color-brand-primary, #2e7d74); border-color: var(--theme-color-brand-primary, #2e7d74); color: #fff; }
		.wfmap-btn-primary:hover { filter: brightness(1.05); }
		.wfmap-readonly-note { font-size: 0.82em; color: var(--theme-color-text-secondary, #888); }
		.wfmap-hint { font-size: 0.82em; color: var(--theme-color-text-secondary, #888); margin-left: 0.5em; }
		.wfmap-arrange { display: inline-flex; align-items: center; gap: 0.4em; }
		.wfmap-arrange-label { font-size: 0.82em; color: var(--theme-color-text-secondary, #888); }
		.wfmap-select { padding: 0.4em 0.6em; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 5px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #222); cursor: pointer; font-size: 0.9em; }
		.wfmap-select:hover { background: var(--theme-color-background-hover, #f2f2f2); }
		.wfmap-flow { flex: 1; min-height: 520px; border: 1px solid var(--theme-color-border-light, #e3e3e3); border-radius: 6px; overflow: hidden; }
		.wfmap-banner { flex-shrink: 0; }
		.wfmap-errors { margin: 0.5em 0 0; padding: 0.5em 0.75em; border-radius: 5px; background: var(--theme-color-status-error-background, #fdecea); border: 1px solid var(--theme-color-status-error, #e74c3c); color: var(--theme-color-status-error, #c0392b); font-size: 0.85em; }
		.wfmap-errors ul { margin: 0.3em 0 0; padding-left: 1.2em; }
		.wfmap-status { margin: 0.5em 0 0; font-size: 0.85em; color: var(--theme-color-text-secondary, #666); }

		/* On-graph panel body content (rendered inside the flow's panel chrome). */
		.wfp { display: flex; flex-direction: column; gap: 0.45em; font-size: 0.85em; }
		.wfp-field { display: flex; flex-direction: column; gap: 0.15em; }
		.wfp-label { font-size: 0.72em; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-secondary, #666); }
		.wfp-input { width: 100%; box-sizing: border-box; padding: 0.35em; border: 1px solid var(--theme-color-border-default, #ccc); border-radius: 4px; font-size: 0.85em; font-family: inherit; }
		.wfp-textarea { min-height: 70px; resize: vertical; font-family: monospace; font-size: 0.78em; }
		.wfp-check { display: flex; align-items: center; gap: 0.4em; font-size: 0.85em; }
		.wfp-check input { margin: 0; }
		.wfp-transition-head { font-weight: 600; font-size: 0.9em; margin-bottom: 0.2em; }

		/* Always show the kind eyebrow ("STATE" / "TRANSITION"); the flow hides it until hover. The
		   extra class specificity wins over the flow's default without !important. */
		.pict-flow-node .pict-flow-node-type-label { opacity: 1; }
	`,

	Templates:
	[
		{
			Hash: 'Workflow-Map-Container',
			Template: /*html*/`
<div class="wfmap" id="WFMap-Root-{~D:AppData.WorkflowMap.ViewID~}">
	<div class="wfmap-head">
		<h2 class="wfmap-title">{~D:AppData.WorkflowMap.TypeName~}<small>{~D:AppData.WorkflowMap.OriginLabel~}</small></h2>
		<div class="wfmap-toolbar" id="WFMap-Toolbar-{~D:AppData.WorkflowMap.ViewID~}"></div>
	</div>
	<div class="wfmap-banner" id="WFMap-Banner-{~D:AppData.WorkflowMap.ViewID~}"></div>
	<div class="wfmap-flow" id="WFMap-Flow-{~D:AppData.WorkflowMap.ViewID~}"></div>
	<datalist id="WFMap-Lanes">{~TS:Workflow-Map-Option:AppData.WorkflowMap.LaneOptions~}</datalist>
	<datalist id="WFMap-Entitlements">{~TS:Workflow-Map-Option:AppData.WorkflowMap.EntitlementOptions~}</datalist>
</div>`
		},
		{ Hash: 'Workflow-Map-Option', Template: /*html*/`<option value="{~D:Record.Value~}"></option>` },
			{ Hash: 'Workflow-Map-Layout-Option', Template: /*html*/`<option value="{~D:Record.Value~}" {~NE:Record.Selected^selected~}>{~D:Record.Label~}</option>` },
		{
			Hash: 'Workflow-Map-Toolbar',
			Template: /*html*/`
{~TS:Workflow-Map-Toolbar-View:AppData.WorkflowMap.ViewSlot~}
{~TS:Workflow-Map-Toolbar-Edit:AppData.WorkflowMap.EditSlot~}`
		},
		{
			Hash: 'Workflow-Map-Toolbar-View',
			Template: /*html*/`
<span class="wfmap-readonly-note">Built-in, read-only.</span>
<button class="wfmap-btn wfmap-btn-primary" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].adopt()">Adopt to edit</button>
<label class="wfmap-arrange"><span class="wfmap-arrange-label">Arrange</span><select class="wfmap-select" onchange="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].applyNamedLayout(this.value)">{~TS:Workflow-Map-Layout-Option:AppData.WorkflowMap.LayoutOptions~}</select></label>
<button class="wfmap-btn" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].toggleExpanded()">{~D:AppData.WorkflowMap.ExpandLabel~}</button>
<span class="wfmap-hint">Double-click a state or transition to inspect it.</span>`
		},
		{
			Hash: 'Workflow-Map-Toolbar-Edit',
			Template: /*html*/`
<button class="wfmap-btn" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].addState()">Add state</button>
<button class="wfmap-btn" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].addTransition()">Add transition</button>
<button class="wfmap-btn" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].deleteSelected()">Delete selected</button>
<label class="wfmap-arrange"><span class="wfmap-arrange-label">Arrange</span><select class="wfmap-select" onchange="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].applyNamedLayout(this.value)">{~TS:Workflow-Map-Layout-Option:AppData.WorkflowMap.LayoutOptions~}</select></label>
<button class="wfmap-btn" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].toggleExpanded()">{~D:AppData.WorkflowMap.ExpandLabel~}</button>
<button class="wfmap-btn" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].saveCurrentLayout()">Save layout</button>
<button class="wfmap-btn wfmap-btn-primary" onclick="_Pict.views['{~D:AppData.WorkflowMap.ViewID~}'].save()">Save workflow</button>
<span class="wfmap-hint">Double-click a card to edit it. Wire a transition: drag a state's right port to the transition's In, and its Out to the next state's left port.</span>`
		},
		{
			Hash: 'Workflow-Map-Banner',
			Template: /*html*/`
{~TS:Workflow-Map-Errors:AppData.WorkflowMap.ErrorSlot~}
{~TS:Workflow-Map-Status:AppData.WorkflowMap.StatusSlot~}`
		},
		{
			Hash: 'Workflow-Map-Errors',
			Template: /*html*/`<div class="wfmap-errors"><strong>This workflow will not save yet:</strong><ul>{~TS:Workflow-Map-Error-Row:AppData.WorkflowMap.Errors~}</ul></div>`
		},
		{ Hash: 'Workflow-Map-Error-Row', Template: /*html*/`<li>{~D:Record.Message~}</li>` },
		{ Hash: 'Workflow-Map-Status', Template: /*html*/`<div class="wfmap-status">{~D:Record.Message~}</div>` }
	],

	Renderables:
	[
		{ RenderableHash: 'Workflow-Map-Container', TemplateHash: 'Workflow-Map-Container', DestinationAddress: '#Workflow-Map-Container', RenderMethod: 'replace' }
	]
};

class PictViewWorkflowMap extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._FlowView = null;
		this._Meta = { Key: null, Name: null };
	}

	onBeforeInitialize()
	{
		this._initState();
		return super.onBeforeInitialize();
	}

	_initState()
	{
		if (!this.pict.AppData.WorkflowMap)
		{
			this.pict.AppData.WorkflowMap =
			{
				ViewID: this.options.ViewIdentifier,
				TypeRecord: null,
				TypeName: 'Workflow',
				OriginLabel: '',
				Mode: 'empty',
				DisabledAttr: '',
				Dirty: false,
				ViewSlot: [], EditSlot: [],
				ErrorSlot: [], StatusSlot: [], Errors: [],
				LaneOptions: [],
				EntitlementOptions: [],
				Expanded: false,
				ExpandLabel: 'Show details',
				LayoutChoice: 'workflow',
				LayoutOptions: []
			};
		}
		this.pict.AppData.WorkflowMap.ViewID = this.options.ViewIdentifier;
		this._refreshLayoutOptions();
	}

	/**
	 * Rebuild the arrange-menu option list, flagging the active choice as selected so the dropdown
	 * keeps showing the last-applied layout across toolbar re-renders.
	 */
	_refreshLayoutOptions()
	{
		let tmpChoice = this._state().LayoutChoice || 'workflow';
		this._state().LayoutOptions = _LAYOUT_CHOICES.map(
			(pChoice) => ({ Value: pChoice.Value, Label: pChoice.Label, Selected: (pChoice.Value === tmpChoice) }));
	}

	_state() { return this.pict.AppData.WorkflowMap; }

	_client()
	{
		if (this.options.Client) { return this.options.Client; }
		let tmpName = this.options.ClientProvider || 'WorkflowAPI';
		return (this.pict.providers && this.pict.providers[tmpName]) || null;
	}

	_modal() { return this.pict.views['Pict-Section-Modal'] || null; }

	// -- opening a type --------------------------------------------------------

	/**
	 * Open a type record (from the catalog) in the map. Built-ins open read-only; owned types open
	 * editable. Pulls the full definition and the saved layout through the client, then renders.
	 */
	showType(pTypeRecord)
	{
		let tmpState = this._state();
		tmpState.TypeRecord = pTypeRecord || null;
		tmpState.TypeName = (pTypeRecord && pTypeRecord.Name) || 'Workflow';
		let tmpIsBuiltIn = !!(pTypeRecord && pTypeRecord.Origin === 'builtin');
		tmpState.Mode = tmpIsBuiltIn ? 'view' : 'edit';
		tmpState.OriginLabel = tmpIsBuiltIn ? 'built-in' : 'your workflow';
		tmpState.Errors = []; tmpState.ErrorSlot = []; tmpState.StatusSlot = [];

		let tmpClient = this._client();
		let tmpID = pTypeRecord && pTypeRecord.ID;
		let tmpDefinition = (pTypeRecord && pTypeRecord.WorkflowDefinition) || null;

		let tmpDefinitionPromise = tmpDefinition ? Promise.resolve(tmpDefinition)
			: (tmpClient && tmpID != null ? tmpClient.getType(tmpID).then((pType) => (pType && pType.WorkflowDefinition) || null) : Promise.resolve(null));
		let tmpLayoutPromise = (tmpClient && tmpID != null && tmpClient.getLayout) ? tmpClient.getLayout(tmpID).catch(() => ({})) : Promise.resolve({});

		return Promise.all([tmpDefinitionPromise, tmpLayoutPromise]).then((pResults) =>
		{
			let tmpDef = pResults[0] || { Key: 'workflow', Name: tmpState.TypeName, States: [], Transitions: [] };
			this._Meta = { Key: tmpDef.Key, Name: tmpDef.Name };
			this._PendingDefinition = tmpDef;
			this._PendingLayout = pResults[1] || {};
			tmpState.Dirty = false;
			this.render();
		});
	}

	// -- lifecycle / embedding -------------------------------------------------

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this._ensureFlowView();
		if (this._PendingDefinition)
		{
			this._loadFlow(this._PendingDefinition, this._PendingLayout);
			this._PendingDefinition = null; this._PendingLayout = null;
		}
		this._applyMode();
		this._renderToolbar();
		this._renderBanner();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_ensureFlowView()
	{
		let tmpID = this.options.ViewIdentifier;
		let tmpContainer = '#WFMap-Flow-' + tmpID;
		if (!this._FlowView)
		{
			let tmpNodeTypes = {};
			[ new libStateCard(this.fable, {}, 'Workflow-StateCard'), new libTransitionCard(this.fable, {}, 'Workflow-TransitionCard') ].forEach((pCard) =>
			{
				let tmpConfig = pCard.getNodeTypeConfiguration();
				tmpNodeTypes[tmpConfig.Hash] = tmpConfig;
			});

			this._FlowView = this.pict.addView('Workflow-Flow-' + tmpID,
				{
					ViewIdentifier: 'Workflow-Flow-' + tmpID,
					DefaultRenderable: 'Flow-Container',
					DefaultDestinationAddress: tmpContainer,
					AutoRender: false,
					EnableToolbar: false,
					EnableConnectionCreation: true,
					EnableNodeDragging: true,
					IncludeDefaultNodeTypes: false,
					DefaultNodeType: libDefinitionFlow.STATE_NODE_TYPE,
					NodeTypes: tmpNodeTypes,
					// Connections attach to the perimeter point nearest the other card, so an edge
					// leaves a state from the side that faces its transition rather than a fixed port.
					DefaultEdgeTheme: 'Perimeter',
					Renderables: [ { RenderableHash: 'Flow-Container', TemplateHash: 'Flow-Container-Template', DestinationAddress: tmpContainer, RenderMethod: 'replace' } ]
				},
				libPictSectionFlow);
		}
		this._FlowView.initialRenderComplete = false;
		this._FlowView.render();
		this._registerCardIcons();
		this._wireFlowEvents();
	}

	// Register the State/Transition title-bar glyphs on the flow's icon provider (once). Done after
	// the flow renders so the provider exists, and before any nodes load so the glyphs are available.
	_registerCardIcons()
	{
		if (this._IconsRegistered) { return; }
		let tmpIconProvider = this._FlowView && this._FlowView._IconProvider;
		if (!tmpIconProvider || typeof tmpIconProvider.registerIcon !== 'function') { return; }
		tmpIconProvider.registerIcon('WorkflowState', _STATE_ICON);
		tmpIconProvider.registerIcon('WorkflowTransition', _TRANSITION_ICON);
		this._IconsRegistered = true;
	}

	_wireFlowEvents()
	{
		let tmpEvents = this._FlowView._EventHandlerProvider;
		if (!tmpEvents || this._FlowEventsWired) { return; }
		this._FlowEventsWired = true;
		tmpEvents.registerHandler('onFlowChanged', () => this._markDirty());
		tmpEvents.registerHandler('onNodeMoved', () => this._markDirty());
		// Wiring a transition card changes which states it joins, so re-stamp its From/To labels.
		tmpEvents.registerHandler('onConnectionCreated', () => { this._markDirty(); this._stampTransitionDisplayFields(); this._refreshOptionLists(); });
		// A panel edits the underlying node live; on close, repaint so a renamed/re-laned state and
		// a re-gated transition show their new title and color, and refresh the autocomplete lists.
		tmpEvents.registerHandler('onPanelClosed', () => this._afterPanelEdit());
	}

	_loadFlow(pDefinition, pLayout)
	{
		let tmpFlow = libDefinitionFlow.definitionToFlow(pDefinition, pLayout || {});
		this._FlowView.setFlowData({ Nodes: tmpFlow.Nodes, Connections: tmpFlow.Connections });
		this._stampTransitionDisplayFields();
		this._refreshOptionLists();
		// With no saved arrangement, lay it out staggered so it reads instead of bunching.
		if (!pLayout || Object.keys(pLayout).length === 0) { this._staggeredLayout(); }
	}

	_applyMode()
	{
		let tmpState = this._state();
		let tmpEditable = (tmpState.Mode === 'edit');
		tmpState.DisabledAttr = tmpEditable ? '' : 'disabled';
		tmpState.ViewSlot = (tmpState.Mode === 'view') ? [{}] : [];
		tmpState.EditSlot = tmpEditable ? [{}] : [];
		// Read-only graphs still pan/zoom and open panels for reading, but no structural edits.
		if (this._FlowView)
		{
			this._FlowView.options.EnableConnectionCreation = tmpEditable;
			this._FlowView.options.EnableNodeDragging = tmpEditable;
		}
	}

	// -- editing (called from the on-graph panels, by node hash) ---------------

	editState(pHash, pField, pValue)
	{
		if (this._state().Mode !== 'edit') { return; }
		let tmpNode = this._FlowView.getNode(pHash); if (!tmpNode) { return; }
		if (pField === 'Name') { tmpNode.Title = pValue; }
		else if (pField === 'IsInitial' || pField === 'IsTerminal') { if (pValue) { tmpNode.Data[pField] = true; } else { delete tmpNode.Data[pField]; } }
		else { if (pValue) { tmpNode.Data[pField] = pValue; } else { delete tmpNode.Data[pField]; } }
		this._markDirty();
	}

	editTransition(pHash, pField, pValue)
	{
		if (this._state().Mode !== 'edit') { return; }
		let tmpNode = this._FlowView.getNode(pHash); if (!tmpNode) { return; }
		if (pValue) { tmpNode.Data[pField] = pValue; } else { delete tmpNode.Data[pField]; }
		this._markDirty();
	}

	editTransitionGuard(pHash, pValue)
	{
		if (this._state().Mode !== 'edit') { return; }
		let tmpNode = this._FlowView.getNode(pHash); if (!tmpNode) { return; }
		tmpNode.Data._GuardText = pValue;
		this._markDirty();
	}

	// -- toolbar actions -------------------------------------------------------

	addState()
	{
		if (this._state().Mode !== 'edit') { return; }
		let tmpNode = this._FlowView.addNode(libDefinitionFlow.STATE_NODE_TYPE, 80, 80, 'New State', { Key: '' });
		this._markDirty();
		if (tmpNode) { this._FlowView.selectNode(tmpNode.Hash); }
	}

	addTransition()
	{
		if (this._state().Mode !== 'edit') { return; }
		let tmpNode = this._FlowView.addNode(libDefinitionFlow.TRANSITION_NODE_TYPE, 200, 200, 'open', {});
		this._markDirty();
		if (tmpNode) { this._FlowView.selectNode(tmpNode.Hash); }
	}

	deleteSelected()
	{
		if (this._state().Mode !== 'edit') { return; }
		this._FlowView.deleteSelected();
		this._stampTransitionDisplayFields();
		this._refreshOptionLists();
		this._markDirty();
	}

	autoArrange()
	{
		this.applyNamedLayout(this._state().LayoutChoice || 'workflow');
	}

	/**
	 * Apply a layout from the arrange menu. 'workflow' runs the bespoke, workflow-aware stairstep;
	 * any other value is the name of a pict-section-flow layout algorithm, run over the whole graph
	 * and framed with zoom-to-fit. Either way the new positions are dirty until the layout is saved.
	 */
	applyNamedLayout(pChoice)
	{
		let tmpChoice = pChoice || 'workflow';
		this._state().LayoutChoice = tmpChoice;
		this._refreshLayoutOptions();

		let tmpEntry = _LAYOUT_CHOICES.find((pEntry) => pEntry.Value === tmpChoice);
		if (!tmpEntry || !tmpEntry.Algorithm)
		{
			this._staggeredLayout();
		}
		else if (this._FlowView)
		{
			this._FlowView.autoLayout(tmpEntry.Algorithm);
			if (typeof this._FlowView.zoomToFit === 'function') { this._FlowView.zoomToFit(); }
		}

		this._markDirty();
		this._renderToolbar();
	}

	/**
	 * A workflow-aware staggered layout: walk the states from the initial one (breadth first), lay
	 * them left to right, and alternate each between two rows so the chain stair-steps and uses
	 * vertical space instead of one long line. Each state's outgoing transition cards sit just to its
	 * right, on its row, stacking when a state has several. The generic layered algorithm collapses
	 * on a workflow's branches and cycles, which is why this is bespoke.
	 */
	_staggeredLayout()
	{
		if (!this._FlowView) { return; }
		let tmpNodes = this._FlowView.flowData.Nodes || [];
		let tmpConnections = this._FlowView.flowData.Connections || [];
		let tmpTransitionType = libDefinitionFlow.TRANSITION_NODE_TYPE;

		let tmpNodeByHash = {};
		let tmpIsTransition = {};
		tmpNodes.forEach((pNode) => { tmpNodeByHash[pNode.Hash] = pNode; if (pNode.Type === tmpTransitionType) { tmpIsTransition[pNode.Hash] = true; } });

		// Each transition card's source and target state, from the edges around it.
		let tmpSourceOf = {};
		let tmpTargetOf = {};
		tmpConnections.forEach((pConnection) =>
		{
			if (tmpIsTransition[pConnection.TargetNodeHash]) { tmpSourceOf[pConnection.TargetNodeHash] = pConnection.SourceNodeHash; }
			if (tmpIsTransition[pConnection.SourceNodeHash]) { tmpTargetOf[pConnection.SourceNodeHash] = pConnection.TargetNodeHash; }
		});

		// state hash -> [{ transition node, target state hash }]
		let tmpAdjacency = {};
		tmpNodes.forEach((pNode) => { if (pNode.Type !== tmpTransitionType) { tmpAdjacency[pNode.Hash] = []; } });
		tmpNodes.forEach((pNode) =>
		{
			if (pNode.Type !== tmpTransitionType) { return; }
			let tmpSource = tmpSourceOf[pNode.Hash];
			if (tmpSource != null && tmpAdjacency[tmpSource]) { tmpAdjacency[tmpSource].push({ Transition: pNode, Target: tmpTargetOf[pNode.Hash] }); }
		});

		// Breadth-first order of the states from the initial state.
		let tmpStateNodes = tmpNodes.filter((pNode) => pNode.Type !== tmpTransitionType);
		let tmpInitial = tmpStateNodes.find((pNode) => pNode.Data && pNode.Data.IsInitial) || tmpStateNodes[0];
		let tmpOrder = [];
		let tmpSeen = {};
		let tmpQueue = tmpInitial ? [tmpInitial.Hash] : tmpStateNodes.map((pNode) => pNode.Hash);
		while (tmpQueue.length)
		{
			let tmpHash = tmpQueue.shift();
			if (tmpSeen[tmpHash]) { continue; }
			tmpSeen[tmpHash] = true;
			tmpOrder.push(tmpHash);
			(tmpAdjacency[tmpHash] || []).forEach((pEdge) => { if (pEdge.Target != null && !tmpSeen[pEdge.Target]) { tmpQueue.push(pEdge.Target); } });
		}
		tmpStateNodes.forEach((pNode) => { if (!tmpSeen[pNode.Hash]) { tmpSeen[pNode.Hash] = true; tmpOrder.push(pNode.Hash); } });

		// Place states left to right, alternating two rows; place each state's transitions to its right.
		// The column and row steps leave room for a state's transition stack plus the edges that route
		// around a hub state (one that several transitions point back into). A state's transitions are
		// centered on the state's own vertical center, not hung downward from its top, so a two- or
		// three-way fan-out straddles the state and stays clear of the other row.
		let tmpColumnStep = 460;
		let tmpRowStep = 260;
		let tmpStartX = 60;
		let tmpStartY = 100;
		let tmpTransitionGap = 44;
		tmpOrder.forEach((pHash, pIndex) =>
		{
			let tmpNode = tmpNodeByHash[pHash];
			if (!tmpNode) { return; }
			let tmpRow = pIndex % 2;
			tmpNode.X = tmpStartX + pIndex * tmpColumnStep;
			tmpNode.Y = tmpStartY + tmpRow * tmpRowStep;

			let tmpEdges = tmpAdjacency[pHash] || [];
			let tmpStateCenter = tmpNode.Y + (tmpNode.Height || 70) / 2;
			tmpEdges.forEach((pEdge, pEdgeIndex) =>
			{
				let tmpTransition = pEdge.Transition;
				let tmpTransitionHeight = tmpTransition.Height || 64;
				let tmpPitch = tmpTransitionHeight + 30;
				tmpTransition.X = tmpNode.X + (tmpNode.Width || 190) + tmpTransitionGap;
				tmpTransition.Y = (tmpStateCenter - (tmpTransitionHeight / 2)) + ((pEdgeIndex - ((tmpEdges.length - 1) / 2)) * tmpPitch);
			});
		});

		this._FlowView.renderFlow();
		if (typeof this._FlowView.zoomToFit === 'function') { this._FlowView.zoomToFit(); }
	}

	/**
	 * The expanded view: open every card's panel and place it clear of the graph (panels for the
	 * upper row go above their card, lower-row panels go below), so the flow can be read terse
	 * (cards only) or in full (every gate and field visible, proximal to its card). Toggles closed.
	 */
	toggleExpanded()
	{
		let tmpState = this._state();
		if (tmpState.Expanded) { this._closeAllPanels(); tmpState.Expanded = false; tmpState.ExpandLabel = 'Show details'; }
		else { this._openAllPanels(); tmpState.Expanded = true; tmpState.ExpandLabel = 'Hide details'; }
		this._renderToolbar();
	}

	_openAllPanels()
	{
		if (!this._FlowView) { return; }
		let tmpNodes = (this._FlowView.flowData.Nodes || []).slice();
		if (!tmpNodes.length) { return; }
		let tmpYs = tmpNodes.map((pNode) => pNode.Y);
		let tmpMidY = (Math.min.apply(null, tmpYs) + Math.max.apply(null, tmpYs)) / 2;
		this._BulkPanelOp = true;
		tmpNodes.forEach((pNode) =>
		{
			let tmpPanel = this._FlowView.openPanel(pNode.Hash);
			if (!tmpPanel) { return; }
			tmpPanel.X = pNode.X - 30;
			tmpPanel.Y = (pNode.Y <= tmpMidY) ? (pNode.Y - (tmpPanel.Height || 250) - 40) : (pNode.Y + (pNode.Height || 70) + 40);
		});
		this._BulkPanelOp = false;
		this._FlowView.renderFlow();
	}

	_closeAllPanels()
	{
		if (!this._FlowView) { return; }
		this._BulkPanelOp = true;
		(this._FlowView.flowData.OpenPanels || []).slice().forEach((pPanel) => { this._FlowView.closePanel(pPanel.Hash); });
		this._BulkPanelOp = false;
	}

	saveCurrentLayout()
	{
		let tmpClient = this._client(); let tmpRecord = this._state().TypeRecord;
		if (!tmpClient || !tmpClient.saveLayout || !tmpRecord) { return; }
		tmpClient.saveLayout(tmpRecord.ID, this._collectLayout()).then(() =>
		{
			this._toast('Layout saved.', 'success');
		}).catch((pError) => this._toast('Could not save layout: ' + pError.message, 'error'));
	}

	save()
	{
		let tmpState = this._state();
		if (tmpState.Mode !== 'edit') { return; }
		let tmpClient = this._client(); let tmpRecord = tmpState.TypeRecord;
		if (!tmpClient || !tmpRecord) { return; }

		let tmpDefinition = this._currentDefinition();
		let tmpError = libDefinitionFlow.validateDefinition(tmpDefinition);
		if (tmpError)
		{
			tmpState.Errors = [{ Message: tmpError }];
			tmpState.ErrorSlot = [{}]; tmpState.StatusSlot = [];
			this._renderBanner();
			return;
		}
		tmpState.Errors = []; tmpState.ErrorSlot = [];
		tmpClient.saveType(tmpRecord.ID, tmpDefinition).then(() =>
		{
			tmpState.Dirty = false;
			tmpState.StatusSlot = [{ Message: 'Saved.' }];
			this._renderBanner();
			this._toast('Workflow saved.', 'success');
		}).catch((pError) =>
		{
			tmpState.Errors = [{ Message: pError.message }];
			tmpState.ErrorSlot = [{}];
			this._renderBanner();
		});
	}

	adopt()
	{
		let tmpClient = this._client(); let tmpRecord = this._state().TypeRecord;
		if (!tmpClient || !tmpRecord) { return; }
		let tmpModal = this._modal();
		let fProceed = () =>
		{
			tmpClient.adoptType(tmpRecord.ID).then((pClone) =>
			{
				this._toast('Adopted. Editing your copy.', 'success');
				this.showType(Object.assign({}, pClone, { Origin: 'owned' }));
			}).catch((pError) => this._toast('Could not adopt: ' + pError.message, 'error'));
		};
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('This copies the built-in into your workflows so you can edit it. The built-in stays unchanged.',
				{ title: 'Adopt ' + (tmpRecord.Name || 'workflow') + '?', confirmLabel: 'Adopt', cancelLabel: 'Cancel' }).then((pOk) => { if (pOk) { fProceed(); } });
		}
		else { fProceed(); }
	}

	// -- helpers ---------------------------------------------------------------

	_currentDefinition()
	{
		let tmpFlow = this._FlowView.getFlowData();
		// The transition panel edits the guard as JSON text (_GuardText); fold it back into the
		// structured Data.Guard on each transition node before reading the definition. Invalid JSON
		// becomes a guard the engine rejects, so the save surfaces a clear error.
		(tmpFlow.Nodes || []).forEach((pNode) =>
		{
			if (pNode.Type !== libDefinitionFlow.TRANSITION_NODE_TYPE) { return; }
			let tmpData = pNode.Data || {};
			if (Object.prototype.hasOwnProperty.call(tmpData, '_GuardText'))
			{
				let tmpText = String(tmpData._GuardText || '').trim();
				if (!tmpText) { delete tmpData.Guard; }
				else { try { tmpData.Guard = JSON.parse(tmpText); } catch (pError) { tmpData.Guard = { _invalid: tmpText }; } }
			}
		});
		return libDefinitionFlow.flowToDefinition(tmpFlow, this._Meta);
	}

	// Save only state positions; transition cards center themselves between their states on load.
	_collectLayout()
	{
		let tmpFlow = this._FlowView.getFlowData();
		let tmpLayout = {};
		(tmpFlow.Nodes || []).forEach((pNode) =>
		{
			if (pNode.Type === libDefinitionFlow.TRANSITION_NODE_TYPE) { return; }
			let tmpKey = (pNode.Data && pNode.Data.Key) || pNode.Hash;
			tmpLayout[tmpKey] = { X: pNode.X, Y: pNode.Y };
		});
		return tmpLayout;
	}

	// Repaint after a panel closes: recolor lanes (a state may have changed lane), re-stamp the
	// transition cards (titles + From/To), re-render, refresh autocomplete, and mark dirty.
	_afterPanelEdit()
	{
		if (this._BulkPanelOp) { return; }
		this._recolorLanes();
		this._stampTransitionDisplayFields();
		this._refreshOptionLists();
		if (this._FlowView) { this._FlowView.renderFlow(); }
		this._markDirty();
	}

	// After a lane edit, recolor every state so a lane keeps one consistent color.
	_recolorLanes()
	{
		if (!this._FlowView) { return; }
		let tmpDefinition = this._currentDefinition();
		let tmpColors = libDefinitionFlow.laneColors(tmpDefinition);
		(this._FlowView.flowData.Nodes || []).forEach((pNode) =>
		{
			if (pNode.Type === libDefinitionFlow.TRANSITION_NODE_TYPE) { return; }
			let tmpLane = (pNode.Data && pNode.Data.Lane) || (pNode.Data && pNode.Data.Key) || pNode.Hash;
			if (tmpColors[tmpLane]) { pNode.TitleBarColor = tmpColors[tmpLane]; }
		});
	}

	// Give each transition card the names of the states it joins (for its panel header) and a title
	// showing its gate, and seed the guard JSON text. These are display-only; flowToDefinition reads
	// From/To from the edges and the guard from Data.Guard, so none of this reaches the definition.
	_stampTransitionDisplayFields()
	{
		if (!this._FlowView) { return; }
		let tmpNodes = this._FlowView.flowData.Nodes || [];
		let tmpConnections = this._FlowView.flowData.Connections || [];
		let tmpNameByHash = {};
		let tmpIsTransition = {};
		tmpNodes.forEach((pNode) =>
		{
			tmpNameByHash[pNode.Hash] = pNode.Title || ((pNode.Data && pNode.Data.Key) || pNode.Hash);
			if (pNode.Type === libDefinitionFlow.TRANSITION_NODE_TYPE) { tmpIsTransition[pNode.Hash] = true; }
		});
		let tmpIncoming = {};
		let tmpOutgoing = {};
		tmpConnections.forEach((pConnection) =>
		{
			if (tmpIsTransition[pConnection.TargetNodeHash]) { tmpIncoming[pConnection.TargetNodeHash] = pConnection.SourceNodeHash; }
			if (tmpIsTransition[pConnection.SourceNodeHash]) { tmpOutgoing[pConnection.SourceNodeHash] = pConnection.TargetNodeHash; }
		});
		tmpNodes.forEach((pNode) =>
		{
			if (pNode.Type !== libDefinitionFlow.TRANSITION_NODE_TYPE) { return; }
			if (!pNode.Data) { pNode.Data = {}; }
			pNode.Data._FromName = tmpNameByHash[tmpIncoming[pNode.Hash]] || '(unwired)';
			pNode.Data._ToName = tmpNameByHash[tmpOutgoing[pNode.Hash]] || '(unwired)';
			if (!Object.prototype.hasOwnProperty.call(pNode.Data, '_GuardText'))
			{
				pNode.Data._GuardText = pNode.Data.Guard ? JSON.stringify(pNode.Data.Guard, null, 2) : '';
			}
			pNode.Title = libDefinitionFlow.transitionTitle(pNode.Data);
		});
	}

	// Refresh the lane + entitlement autocomplete lists from the current graph.
	_refreshOptionLists()
	{
		let tmpDefinition = this._currentDefinition();
		let tmpState = this._state();
		tmpState.LaneOptions = libDefinitionFlow.lanesOf(tmpDefinition).map((pLane) => ({ Value: pLane }));
		let tmpEntitlements = {};
		(tmpDefinition.Transitions || []).forEach((pTransition) => { if (pTransition.RequiresEntitlement) { tmpEntitlements[pTransition.RequiresEntitlement] = true; } });
		tmpState.EntitlementOptions = Object.keys(tmpEntitlements).map((pEntitlement) => ({ Value: pEntitlement }));
	}

	// -- one-shot region renders (outside the renderable cycle) ----------------

	_renderRegion(pContainerSuffix, pTemplateHash)
	{
		let tmpSelector = '#WFMap-' + pContainerSuffix + '-' + this.options.ViewIdentifier;
		let tmpElement = this.pict.ContentAssignment.getElement(tmpSelector);
		if (!tmpElement || (Array.isArray(tmpElement) && tmpElement.length < 1)) { return; }
		let tmpHTML = this.pict.parseTemplateByHash(pTemplateHash, { ViewIdentifier: this.options.ViewIdentifier });
		this.pict.ContentAssignment.assignContent(tmpSelector, tmpHTML);
	}

	_renderToolbar() { this._renderRegion('Toolbar', 'Workflow-Map-Toolbar'); }
	_renderBanner() { this._renderRegion('Banner', 'Workflow-Map-Banner'); }

	_markDirty() { this._state().Dirty = true; }

	_toast(pMessage, pType)
	{
		let tmpModal = this._modal();
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'info' }); }
	}
}

module.exports = PictViewWorkflowMap;
module.exports.default_configuration = _ViewConfiguration;

},{"../Definition-Flow.js":505,"../cards/State-Card.js":512,"../cards/Transition-Card.js":513,"pict-section-flow":449,"pict-view":365}],517:[function(require,module,exports){
'use strict';

/**
 * Subject detail: timeline, metrics, agency for one subject.
 *
 * Timeline is the event log as a vertical history (opened, entered and left states, actor start
 * and stop, became-available, closed), each row with its actor and time. Metrics are the folded
 * rollup as figures plus a per-state breakdown. Agency is who can act now: the open exits and the
 * entitlement each needs. Everything comes from the injected client; state names come from the
 * type's definition so the rows read in plain words, not state keys.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libMetricsFormat = require('../Metrics-Format.js');

const _EVENT_LABELS =
{
	opened: 'Opened',
	closed: 'Closed',
	'actor.start': 'Work started',
	'actor.stop': 'Work paused',
	'exit.became-available': 'Became available'
};

const _ViewConfiguration =
{
	ViewIdentifier: 'Workflow-Subject',
	DefaultRenderable: 'Workflow-Subject-Container',
	DefaultDestinationAddress: '#Workflow-Subject-Container',
	AutoRender: false,

	ClientProvider: 'WorkflowAPI',
	Client: null,

	CSS: /*css*/`
		.wfs { display: flex; flex-direction: column; gap: 0.9em; padding: 0.25em; }
		.wfs-head { display: flex; align-items: center; justify-content: space-between; }
		.wfs-title { font-size: 1.15em; font-weight: 600; margin: 0; }
		.wfs-state { font-size: 0.85em; color: var(--theme-color-text-secondary, #777); }
		.wfs-cols { display: flex; gap: 1em; flex-wrap: wrap; }
		.wfs-col { flex: 1; min-width: 240px; }
		.wfs-col h3 { font-size: 0.95em; margin: 0 0 0.5em; border-bottom: 1px solid var(--theme-color-border-light, #eee); padding-bottom: 0.3em; }
		.wfs-figures { display: grid; grid-template-columns: 1fr 1fr; gap: 0.5em; }
		.wfs-figure { background: var(--theme-color-background-tertiary, #f5f5f5); border-radius: 5px; padding: 0.5em 0.6em; }
		.wfs-figure-label { font-size: 0.72em; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-secondary, #888); }
		.wfs-figure-value { font-size: 1.05em; font-weight: 600; }
		.wfs-bar-row { margin-bottom: 0.4em; }
		.wfs-bar-label { display: flex; justify-content: space-between; font-size: 0.8em; margin-bottom: 0.15em; }
		.wfs-bar-track { background: var(--theme-color-background-tertiary, #eee); border-radius: 3px; height: 8px; overflow: hidden; }
		.wfs-bar-fill { background: var(--theme-color-brand-primary, #2e7d74); height: 100%; }
		.wfs-timeline { list-style: none; margin: 0; padding: 0; }
		.wfs-event { display: flex; gap: 0.5em; padding: 0.35em 0; border-bottom: 1px solid var(--theme-color-border-light, #f0f0f0); font-size: 0.85em; }
		.wfs-event-when { color: var(--theme-color-text-secondary, #999); flex-shrink: 0; width: 130px; font-variant-numeric: tabular-nums; }
		.wfs-event-what { flex: 1; }
		.wfs-event-actor { color: var(--theme-color-text-secondary, #888); }
		.wfs-agency-row { padding: 0.4em 0; font-size: 0.88em; border-bottom: 1px solid var(--theme-color-border-light, #f0f0f0); }
		.wfs-agency-ent { color: var(--theme-color-text-secondary, #888); font-size: 0.82em; }
		.wfs-empty { color: var(--theme-color-text-secondary, #999); font-size: 0.85em; }
	`,

	Templates:
	[
		{
			Hash: 'Workflow-Subject-Container',
			Template: /*html*/`
<div class="wfs">
	<div class="wfs-head">
		<h2 class="wfs-title">{~D:AppData.WorkflowSubject.Title~}</h2>
		<span class="wfs-state">{~D:AppData.WorkflowSubject.StateText~}</span>
	</div>
	<div class="wfs-cols">
		<div class="wfs-col">
			<h3>Metrics</h3>
			<div class="wfs-figures">{~TS:Workflow-Subject-Figure:AppData.WorkflowSubject.Figures~}</div>
			<div style="margin-top:0.7em">{~TS:Workflow-Subject-Bar:AppData.WorkflowSubject.StateTime~}</div>
		</div>
		<div class="wfs-col">
			<h3>Who can act now</h3>
			{~TS:Workflow-Subject-Agency:AppData.WorkflowSubject.Agency~}
			{~TS:Workflow-Subject-AgencyEmpty:AppData.WorkflowSubject.AgencyEmptySlot~}
		</div>
	</div>
	<div class="wfs-col">
		<h3>Timeline</h3>
		<ul class="wfs-timeline">{~TS:Workflow-Subject-Event:AppData.WorkflowSubject.Timeline~}</ul>
		{~TS:Workflow-Subject-TimelineEmpty:AppData.WorkflowSubject.TimelineEmptySlot~}
	</div>
</div>`
		},
		{ Hash: 'Workflow-Subject-Figure', Template: /*html*/`<div class="wfs-figure"><div class="wfs-figure-label">{~D:Record.Label~}</div><div class="wfs-figure-value">{~D:Record.Value~}</div></div>` },
		{ Hash: 'Workflow-Subject-Bar', Template: /*html*/`<div class="wfs-bar-row"><div class="wfs-bar-label"><span>{~D:Record.State~}</span><span>{~D:Record.Value~}</span></div><div class="wfs-bar-track"><div class="wfs-bar-fill" style="width:{~D:Record.Percent~}%"></div></div></div>` },
		{ Hash: 'Workflow-Subject-Agency', Template: /*html*/`<div class="wfs-agency-row"><div>Move to <strong>{~D:Record.ToName~}</strong></div><div class="wfs-agency-ent">{~D:Record.EntitlementText~}</div></div>` },
		{ Hash: 'Workflow-Subject-AgencyEmpty', Template: /*html*/`<div class="wfs-empty">No moves are available right now.</div>` },
		{ Hash: 'Workflow-Subject-Event', Template: /*html*/`<li class="wfs-event"><span class="wfs-event-when">{~D:Record.When~}</span><span class="wfs-event-what">{~D:Record.What~} <span class="wfs-event-actor">{~D:Record.ActorText~}</span></span></li>` },
		{ Hash: 'Workflow-Subject-TimelineEmpty', Template: /*html*/`<div class="wfs-empty">This subject has not been opened in the workflow yet.</div>` }
	],

	Renderables:
	[
		{ RenderableHash: 'Workflow-Subject-Container', TemplateHash: 'Workflow-Subject-Container', DestinationAddress: '#Workflow-Subject-Container', RenderMethod: 'replace' }
	]
};

class PictViewWorkflowSubject extends libPictView
{
	onBeforeInitialize()
	{
		if (!this.pict.AppData.WorkflowSubject)
		{
			this.pict.AppData.WorkflowSubject = { ViewID: this.options.ViewIdentifier, SubjectID: null, Title: 'Subject', StateText: '', Figures: [], StateTime: [], Agency: [], AgencyEmptySlot: [], Timeline: [], TimelineEmptySlot: [] };
		}
		this.pict.AppData.WorkflowSubject.ViewID = this.options.ViewIdentifier;
		return super.onBeforeInitialize();
	}

	_state() { return this.pict.AppData.WorkflowSubject; }
	_client() { if (this.options.Client) { return this.options.Client; } let tmpName = this.options.ClientProvider || 'WorkflowAPI'; return (this.pict.providers && this.pict.providers[tmpName]) || null; }

	/**
	 * Load and show one subject. pTypeRecord (optional) supplies the definition so state keys
	 * render as their names; pTitle (optional) is the subject's display title.
	 */
	showSubject(pSubjectID, pTypeRecord, pTitle)
	{
		let tmpState = this._state();
		let tmpClient = this._client();
		tmpState.SubjectID = pSubjectID;
		tmpState.Title = pTitle || ('Work item #' + pSubjectID);
		this._StateNames = this._buildStateNames(pTypeRecord);
		if (!tmpClient) { this.render(); return Promise.resolve(); }

		return Promise.all(
			[
				tmpClient.getSubject(pSubjectID).catch(() => null),
				tmpClient.getTimeline(pSubjectID).catch(() => []),
				tmpClient.getMetrics(pSubjectID).catch(() => null),
				tmpClient.getAgency(pSubjectID).catch(() => [])
			]).then((pResults) =>
		{
			this._applySubject(pResults[0]);
			this._applyTimeline(pResults[1]);
			this._applyMetrics(pResults[2]);
			this._applyAgency(pResults[3]);
			this.render();
		});
	}

	_buildStateNames(pTypeRecord)
	{
		let tmpNames = {};
		let tmpDefinition = pTypeRecord && pTypeRecord.WorkflowDefinition;
		((tmpDefinition && tmpDefinition.States) || []).forEach((pState) => { tmpNames[pState.Key] = pState.Name || pState.Key; });
		return tmpNames;
	}

	_stateName(pKey) { return (this._StateNames && this._StateNames[pKey]) || pKey; }

	_applySubject(pSubject)
	{
		let tmpState = this._state();
		if (!pSubject || !pSubject.State) { tmpState.StateText = ''; return; }
		let tmpCurrent = (pSubject.State.CurrentStates || []).map((pKey) => this._stateName(pKey)).join(', ');
		tmpState.StateText = pSubject.State.Closed ? 'Closed' : ('In ' + (tmpCurrent || 'an unknown state'));
	}

	_applyTimeline(pEvents)
	{
		let tmpState = this._state();
		let tmpRows = (pEvents || []).slice().sort((pA, pB) => ((pA.At || 0) - (pB.At || 0)) || ((pA.ID || 0) - (pB.ID || 0)));
		tmpState.Timeline = tmpRows.map((pEvent) => ({ When: _formatWhen(pEvent.At), What: this._eventLabel(pEvent), ActorText: pEvent.Actor ? ('by ' + pEvent.Actor) : '' }));
		tmpState.TimelineEmptySlot = tmpState.Timeline.length ? [] : [{}];
	}

	_eventLabel(pEvent)
	{
		if (pEvent.Type === 'state.enter') { return 'Entered ' + this._stateName(pEvent.State); }
		if (pEvent.Type === 'state.exit') { return 'Left ' + this._stateName(pEvent.State); }
		if (pEvent.Type === 'exit.became-available') { return 'Became ready to move to ' + this._stateName(pEvent.Payload && pEvent.Payload.ToState); }
		return _EVENT_LABELS[pEvent.Type] || pEvent.Type;
	}

	_applyMetrics(pMetrics)
	{
		let tmpState = this._state();
		let tmpSummary = libMetricsFormat.summarizeMetrics(pMetrics, this._StateNames || {});
		tmpState.Figures = tmpSummary.Figures;
		let tmpMax = tmpSummary.StateTime.reduce((pAccumulator, pRow) => Math.max(pAccumulator, pRow.RawMS), 0) || 1;
		tmpState.StateTime = tmpSummary.StateTime.map((pRow) => ({ State: pRow.State, Value: pRow.Value, Percent: Math.round((pRow.RawMS / tmpMax) * 100) }));
	}

	_applyAgency(pAgency)
	{
		let tmpState = this._state();
		tmpState.Agency = (pAgency || []).map((pExit) => (
			{
				ToName: this._stateName(pExit.ToState),
				EntitlementText: pExit.RequiredEntitlement ? ('requires ' + pExit.RequiredEntitlement) : 'no entitlement required'
			}));
		tmpState.AgencyEmptySlot = tmpState.Agency.length ? [] : [{}];
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}
}

function _formatWhen(pMilliseconds)
{
	let tmpMS = Number(pMilliseconds);
	if (!isFinite(tmpMS) || tmpMS <= 0) { return ''; }
	try { return new Date(tmpMS).toLocaleString(); } catch (pError) { return String(tmpMS); }
}

module.exports = PictViewWorkflowSubject;
module.exports.default_configuration = _ViewConfiguration;

},{"../Metrics-Format.js":506,"pict-view":365}],518:[function(require,module,exports){
'use strict';

var inspect = require('object-inspect');

var $TypeError = require('es-errors/type');

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var deletedNode = listDelete($o, key);
			if (deletedNode && $o && !$o.next) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	return channel;
};

},{"es-errors/type":47,"object-inspect":143}],519:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bound');
var inspect = require('object-inspect');

var $TypeError = require('es-errors/type');
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};

},{"call-bound":30,"es-errors/type":47,"get-intrinsic":107,"object-inspect":143}],520:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bound');
var inspect = require('object-inspect');
var getSideChannelMap = require('side-channel-map');

var $TypeError = require('es-errors/type');
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;

},{"call-bound":30,"es-errors/type":47,"get-intrinsic":107,"object-inspect":143,"side-channel-map":519}],521:[function(require,module,exports){
'use strict';

var $TypeError = require('es-errors/type');
var inspect = require('object-inspect');
var getSideChannelList = require('side-channel-list');
var getSideChannelMap = require('side-channel-map');
var getSideChannelWeakMap = require('side-channel-weakmap');

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				var keyDesc = key && Object(key) === key
					? 'the given object key'
					: inspect(key);
				throw new $TypeError('Side channel does not contain ' + keyDesc);
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};

	return channel;
};

},{"es-errors/type":47,"object-inspect":143,"side-channel-list":518,"side-channel-map":519,"side-channel-weakmap":520}],522:[function(require,module,exports){
(function (Buffer){(function (){
/*! simple-concat. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
module.exports = function (stream, cb) {
  var chunks = []
  stream.on('data', function (chunk) {
    chunks.push(chunk)
  })
  stream.once('end', function () {
    if (cb) cb(null, Buffer.concat(chunks))
    cb = null
  })
  stream.once('error', function (err) {
    if (cb) cb(err)
    cb = null
  })
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":20}],523:[function(require,module,exports){
(function (Buffer){(function (){
/*! simple-get. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
module.exports = simpleGet

const concat = require('simple-concat')
const decompressResponse = require('decompress-response') // excluded from browser build
const http = require('http')
const https = require('https')
const once = require('once')
const querystring = require('querystring')
const url = require('url')

const isStream = o => o !== null && typeof o === 'object' && typeof o.pipe === 'function'

function simpleGet (opts, cb) {
  opts = Object.assign({ maxRedirects: 10 }, typeof opts === 'string' ? { url: opts } : opts)
  cb = once(cb)

  if (opts.url) {
    const { hostname, port, protocol, auth, path } = url.parse(opts.url) // eslint-disable-line node/no-deprecated-api
    delete opts.url
    if (!hostname && !port && !protocol && !auth) opts.path = path // Relative redirect
    else Object.assign(opts, { hostname, port, protocol, auth, path }) // Absolute redirect
  }

  const headers = { 'accept-encoding': 'gzip, deflate' }
  if (opts.headers) Object.keys(opts.headers).forEach(k => (headers[k.toLowerCase()] = opts.headers[k]))
  opts.headers = headers

  let body
  if (opts.body) {
    body = opts.json && !isStream(opts.body) ? JSON.stringify(opts.body) : opts.body
  } else if (opts.form) {
    body = typeof opts.form === 'string' ? opts.form : querystring.stringify(opts.form)
    opts.headers['content-type'] = 'application/x-www-form-urlencoded'
  }

  if (body) {
    if (!opts.method) opts.method = 'POST'
    if (!isStream(body)) opts.headers['content-length'] = Buffer.byteLength(body)
    if (opts.json && !opts.form) opts.headers['content-type'] = 'application/json'
  }
  delete opts.body; delete opts.form

  if (opts.json) opts.headers.accept = 'application/json'
  if (opts.method) opts.method = opts.method.toUpperCase()

  const originalHost = opts.hostname // hostname before potential redirect
  const protocol = opts.protocol === 'https:' ? https : http // Support http/https urls
  const req = protocol.request(opts, res => {
    if (opts.followRedirects !== false && res.statusCode >= 300 && res.statusCode < 400 && res.headers.location) {
      opts.url = res.headers.location // Follow 3xx redirects
      delete opts.headers.host // Discard `host` header on redirect (see #32)
      res.resume() // Discard response

      const redirectHost = url.parse(opts.url).hostname // eslint-disable-line node/no-deprecated-api
      // If redirected host is different than original host, drop headers to prevent cookie leak (#73)
      if (redirectHost !== null && redirectHost !== originalHost) {
        delete opts.headers.cookie
        delete opts.headers.authorization
      }

      if (opts.method === 'POST' && [301, 302].includes(res.statusCode)) {
        opts.method = 'GET' // On 301/302 redirect, change POST to GET (see #35)
        delete opts.headers['content-length']; delete opts.headers['content-type']
      }

      if (opts.maxRedirects-- === 0) return cb(new Error('too many redirects'))
      else return simpleGet(opts, cb)
    }

    const tryUnzip = typeof decompressResponse === 'function' && opts.method !== 'HEAD'
    cb(null, tryUnzip ? decompressResponse(res) : res)
  })
  req.on('timeout', () => {
    req.abort()
    cb(new Error('Request timed out'))
  })
  req.on('error', cb)

  if (isStream(body)) body.on('error', cb).pipe(req)
  else req.end(body)

  return req
}

simpleGet.concat = (opts, cb) => {
  return simpleGet(opts, (err, res) => {
    if (err) return cb(err)
    concat(res, (err, data) => {
      if (err) return cb(err)
      if (opts.json) {
        try {
          data = JSON.parse(data.toString())
        } catch (err) {
          return cb(err, res, data)
        }
      }
      cb(null, res, data)
    })
  })
}

;['get', 'post', 'put', 'patch', 'head', 'delete'].forEach(method => {
  simpleGet[method] = (opts, cb) => {
    if (typeof opts === 'string') opts = { url: opts }
    return simpleGet(Object.assign({ method: method.toUpperCase() }, opts), cb)
  }
})

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":20,"decompress-response":18,"http":524,"https":116,"once":144,"querystring":448,"simple-concat":522,"url":546}],524:[function(require,module,exports){
(function (global){(function (){
var ClientRequest = require('./lib/request')
var response = require('./lib/response')
var extend = require('xtend')
var statusCodes = require('builtin-status-codes')
var url = require('url')

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./lib/request":526,"./lib/response":527,"builtin-status-codes":21,"url":546,"xtend":549}],525:[function(require,module,exports){
(function (global){(function (){
exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)

exports.writableStream = isFunction(global.WritableStream)

exports.abortController = isFunction(global.AbortController)

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || checkTypeSupport('arraybuffer')

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],526:[function(require,module,exports){
(function (process,global,Buffer){(function (){
var capability = require('./capability')
var inherits = require('inherits')
var response = require('./response')
var stream = require('readable-stream')

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + Buffer.from(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null
	self._socketTimeout = null
	self._socketTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	if ('timeout' in opts && opts.timeout !== 0) {
		self.setTimeout(opts.timeout)
	}

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
        body = new Blob(self._body, {
            type: (headersObj['content-type'] || {}).value || ''
        });
    }

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = global.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._resetTimers(false)
			self._connect()
		}, function (reason) {
			self._resetTimers(true)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self._resetTimers(true)
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	self._resetTimers(false)

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress(self._resetTimers.bind(self))
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self))
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype._resetTimers = function (done) {
	var self = this

	global.clearTimeout(self._socketTimer)
	self._socketTimer = null

	if (done) {
		global.clearTimeout(self._fetchTimer)
		self._fetchTimer = null
	} else if (self._socketTimeout) {
		self._socketTimer = global.setTimeout(function () {
			self.emit('timeout')
		}, self._socketTimeout)
	}
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function (err) {
	var self = this
	self._destroyed = true
	self._resetTimers(true)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()

	if (err)
		self.emit('error', err)
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.setTimeout = function (timeout, cb) {
	var self = this

	if (cb)
		self.once('timeout', cb)

	self._socketTimeout = timeout
	self._resetTimers(false)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)

},{"./capability":525,"./response":527,"_process":439,"buffer":20,"inherits":118,"readable-stream":542}],527:[function(require,module,exports){
(function (process,global,Buffer){(function (){
var capability = require('./capability')
var inherits = require('inherits')
var stream = require('readable-stream')

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, resetTimers) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					resetTimers(false)
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(Buffer.from(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					resetTimers(true)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					resetTimers(true)
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					resetTimers(true)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				resetTimers(result.done)
				if (result.done) {
					self.push(null)
					return
				}
				self.push(Buffer.from(result.value))
				read()
			}).catch(function (err) {
				resetTimers(true)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function (resetTimers) {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text':
			response = xhr.responseText
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = Buffer.alloc(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(Buffer.from(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(Buffer.from(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new global.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(Buffer.from(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				resetTimers(true)
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		resetTimers(true)
		self.push(null)
	}
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)

},{"./capability":525,"_process":439,"buffer":20,"inherits":118,"readable-stream":542}],528:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],529:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');
require('inherits')(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this)}).call(this,require('_process'))

},{"./_stream_readable":531,"./_stream_writable":533,"_process":439,"inherits":118}],530:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;
var Transform = require('./_stream_transform');
require('inherits')(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":532,"inherits":118}],531:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = require('util');
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/buffer_list');
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require('inherits')(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require('./internal/streams/from');
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":528,"./_stream_duplex":529,"./internal/streams/async_iterator":534,"./internal/streams/buffer_list":535,"./internal/streams/destroy":536,"./internal/streams/from":538,"./internal/streams/state":540,"./internal/streams/stream":541,"_process":439,"buffer":20,"events":50,"inherits":118,"string_decoder/":543,"util":18}],532:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;
var _require$codes = require('../errors').codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require('./_stream_duplex');
require('inherits')(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"../errors":528,"./_stream_duplex":529,"inherits":118}],533:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require('inherits')(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":528,"./_stream_duplex":529,"./internal/streams/destroy":536,"./internal/streams/state":540,"./internal/streams/stream":541,"_process":439,"buffer":20,"inherits":118,"util-deprecate":547}],534:[function(require,module,exports){
(function (process){(function (){
'use strict';

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = require('./end-of-stream');
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
}).call(this)}).call(this,require('_process'))

},{"./end-of-stream":537,"_process":439}],535:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('buffer'),
  Buffer = _require.Buffer;
var _require2 = require('util'),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();
},{"buffer":20,"util":18}],536:[function(require,module,exports){
(function (process){(function (){
'use strict';

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this)}).call(this,require('_process'))

},{"_process":439}],537:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;
},{"../../../errors":528}],538:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],539:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = require('../../../errors').codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require('./end-of-stream');
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;
},{"../../../errors":528,"./end-of-stream":537}],540:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"../../../errors":528}],541:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":50}],542:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');
exports.finished = require('./lib/internal/streams/end-of-stream.js');
exports.pipeline = require('./lib/internal/streams/pipeline.js');

},{"./lib/_stream_duplex.js":529,"./lib/_stream_passthrough.js":530,"./lib/_stream_readable.js":531,"./lib/_stream_transform.js":532,"./lib/_stream_writable.js":533,"./lib/internal/streams/end-of-stream.js":537,"./lib/internal/streams/pipeline.js":539}],543:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":544}],544:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":20}],545:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)

},{"process/browser.js":439,"timers":545}],546:[function(require,module,exports){
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

'use strict';

var punycode = require('punycode/');

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = require('qs');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

},{"punycode/":440,"qs":442}],547:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],548:[function(require,module,exports){
// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}

},{}],549:[function(require,module,exports){
module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}],550:[function(require,module,exports){
module.exports={
  "name": "plansheet",
  "version": "1.0.1",
  "private": true,
  "description": "Plansheet - multi-tenant, documentation-and-articulation-first SDLC management platform: Visions, Modules, Features, Work Items, a Kanban board, Claude session linking, and a foundational documentation library.",
  "main": "source/Pict-Application-Plansheet.js",
  "bin": {
    "plansheet-server": "source/cli/Plansheet-Server-Run.js"
  },
  "scripts": {
    "brand": "node node_modules/pict-section-theme/bin/pict-section-theme-brand.js --favicons html/favicons",
    "build:codemirror": "node build/build-codemirror-bundle.js",
    "build:codejar": "node build/build-codejar-bundle.js",
    "stamp:version": "node build/stamp-version.js",
    "//prebuild": "npm run brand is intentionally NOT in this chain: the brand mark (retold.brand Icon/Favicon) is the hand-drawn corner-cell-P title block, and the generator would overwrite it. Run `npm run brand` only if you mean to regenerate a geometric logo.",
    "prebuild": "npm run build:codemirror && npm run build:codejar && npm run stamp:version",
    "build": "npx quack build && npx quack copy && node bin/stamp-bundles.js",
    "start": "npx http-server dist -p 8189 -c-1 --silent",
    "start-server": "node source/cli/Plansheet-Server-Run.js",
    "deploy": "node ../plansheet-deploy-tool/bin/pdt.js deploy",
    "deploy:mcp": "node ../plansheet-deploy-tool/bin/pdt.js deploy-mcp",
    "deploy:site": "node ../plansheet-deploy-tool/bin/pdt.js deploy:site",
    "pdt": "node ../plansheet-deploy-tool/bin/pdt.js",
    "dev": "bash dev/dev.sh",
    "dev:clean": "bash dev/clean.sh",
    "dev:seed": "node dev/seed.js",
    "docs:gc": "node dev/docs-gc.js",
    "chrome:pin": "node -e \"const S=require('./source/server/SheetSetPrinter.js');const P=require('path'),O=require('os');const B=S.pinnedChromeBuild();const D=process.env.PUPPETEER_CACHE_DIR||P.join(O.homedir(),'.cache','puppeteer');console.log('installing chrome-headless-shell@'+B+' into '+D);require('child_process').execFileSync('npx',['--yes','@puppeteer/browsers','install','chrome-headless-shell@'+B,'--path',D],{stdio:'inherit'});console.log('resolves to: '+S.resolveChromium());\"",
    "schema:compile": "npx stricture compile data_model/Plansheet.ddl -o data_model/compiled/ -p Plansheet",
    "build-docs": "npx quack build && npx quack copy && npx pict-docuserve inject ./docs && node -e \"const fs=require('fs'),path=require('path'); const src=path.join(__dirname,'dist'),dst=path.join(__dirname,'docs','app'); fs.rmSync(dst,{recursive:true,force:true}); fs.mkdirSync(dst,{recursive:true}); for(const f of fs.readdirSync(src)) fs.copyFileSync(path.join(src,f),path.join(dst,f)); console.log('Copied',fs.readdirSync(dst).length,'files into docs/app/');\"",
    "serve-docs": "npx pict-docuserve serve ./docs -p 8192",
    "test": "npx mocha -u tdd -R spec test/*_tests.js",
    "test:e2e": "node test/e2e/run.js",
    "test:fuzz": "node test/e2e/fuzz.js",
    "test:oauth": "node dev/oauth-e2e.js",
    "test:noderegistration": "node dev/node-registration-e2e.js"
  },
  "retold": {
    "brandConfig": {
      "Palette": "ocean",
      "DisplayName": "Plansheet",
      "Tagline": "Everything, drafted."
    },
    "brand": {
      "Hash": "plansheet",
      "Name": "Plansheet",
      "Tagline": "Everything, drafted.",
      "Palette": "ocean",
      "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><rect width=\"32\" height=\"32\" rx=\"5\" fill=\"#11386B\"/><rect x=\"4.5\" y=\"4.5\" width=\"23\" height=\"23\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2\"/><line x1=\"4.5\" y1=\"21\" x2=\"27.5\" y2=\"21\" stroke=\"#EAF2FC\" stroke-width=\"1.6\"/><line x1=\"12.5\" y1=\"8.5\" x2=\"12.5\" y2=\"17.5\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><circle cx=\"16\" cy=\"11.6\" r=\"3.8\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><line x1=\"8\" y1=\"24.6\" x2=\"17\" y2=\"24.6\" stroke=\"#F2C84B\" stroke-width=\"2.2\"/></svg>",
      "IconType": "svg",
      "Favicon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><rect width=\"32\" height=\"32\" rx=\"5\" fill=\"#11386B\"/><rect x=\"4.5\" y=\"4.5\" width=\"23\" height=\"23\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2\"/><line x1=\"4.5\" y1=\"21\" x2=\"27.5\" y2=\"21\" stroke=\"#EAF2FC\" stroke-width=\"1.6\"/><line x1=\"12.5\" y1=\"8.5\" x2=\"12.5\" y2=\"17.5\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><circle cx=\"16\" cy=\"11.6\" r=\"3.8\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><line x1=\"8\" y1=\"24.6\" x2=\"17\" y2=\"24.6\" stroke=\"#F2C84B\" stroke-width=\"2.2\"/></svg>",
      "FaviconDark": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-plansheet-dark\">\n\t\t\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\" fill=\"#4F95E8\"/>\n\t\t<g clip-path=\"url(#fav-plansheet-dark)\"><path d=\"M 16 26 L 48 66 L 80 26 Z\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#101418\" letter-spacing=\"-1\">P</text>\n\t</svg>",
      "Colors": {
        "Primary": "#1D5FA8",
        "Secondary": "#A8780E",
        "PrimaryLight": "#1D5FA8",
        "PrimaryDark": "#4F95E8",
        "SecondaryLight": "#A8780E",
        "SecondaryDark": "#F2C84B"
      }
    },
    "//brand-mark": "Icon/Favicon are the hand-drawn corner-cell-P title-block mark; do NOT run npm run brand, it would regenerate a geometric logo and clobber them. brandConfig.Palette stays for the generator metadata but the app default theme is set in Pict-Application-Plansheet.js (ApplyDefault plansheet)."
  },
  "author": "Steven Velozo <steven@velozo.com>",
  "license": "MIT",
  "dependencies": {
    "@codemirror/lang-markdown": "^6.5.0",
    "@codemirror/state": "^6.7.0",
    "@codemirror/view": "^6.43.4",
    "@phosphor-icons/core": "2.1.1",
    "@tabler/icons": "3.44.0",
    "codemirror": "^6.0.2",
    "fable": "^3.1.79",
    "fable-log-logger-bunyan": "^1.0.5",
    "jszip": "^3.10.1",
    "katex": "^0.17.0",
    "marked": "^4.3.0",
    "meadow": "^2.0.47",
    "meadow-connection-postgresql": "^1.0.8",
    "meadow-endpoints": "^4.1.1",
    "mermaid": "^11.16.0",
    "node-diff3": "3.2.1",
    "openid-client": "^6.0.0",
    "openseadragon": "^6.0.2",
    "orator": "^6.1.2",
    "orator-api-description": "^0.0.1",
    "orator-authentication": "^1.1.2",
    "orator-serviceserver-restify": "^2.0.11",
    "parime": "^1.2.0",
    "pg": "^8.22.0",
    "pict": "^1.0.392",
    "pict-application": "^1.0.33",
    "pict-router": "^1.0.13",
    "pict-section-activitygraph": "^1.0.4",
    "pict-section-checklist": "1.2.0",
    "pict-section-comments": "^1.0.0",
    "pict-section-content": "^1.0.18",
    "pict-section-dochistory": "^1.0.0",
    "pict-section-excalidraw": "1.0.3",
    "pict-section-flow": "^2.0.5",
    "pict-section-inlinedocumentation": "^1.0.12",
    "pict-section-login": "^1.1.0",
    "pict-section-markdowneditor": "^1.0.21",
    "pict-section-modal": "^1.1.4",
    "pict-section-moodboard": "^1.4.1",
    "pict-section-navigation": "^1.4.1",
    "pict-section-openseadragon": "^1.0.22",
    "pict-section-picker": "^1.8.2",
    "pict-section-prompteditor": "1.1.4",
    "pict-section-theme": "^1.1.1",
    "pict-section-workspace": "^1.0.0",
    "pict-view": "^1.0.68",
    "postmark": "^4.0.7",
    "puppeteer-core": "25.2.1",
    "retold-operation-queue": "^0.5.1",
    "retold-sharp": "1.0.0",
    "retold-workflow": "^0.5.0",
    "sharp": "0.34.5",
    "simple-icons": "16.24.1",
    "twilio": "^6.0.2"
  },
  "optionalDependencies": {
    "@img/sharp-darwin-arm64": "0.34.5",
    "@img/sharp-linux-arm64": "0.34.5",
    "@img/sharp-linux-x64": "0.34.5"
  },
  "devDependencies": {
    "chai": "^4.5.0",
    "esbuild": "^0.28.1",
    "http-server": "^14.1.1",
    "jsdom": "^25.0.1",
    "meadow-migrationmanager": "^1.0.5",
    "mocha": "^11.0.1",
    "pict-docuserve": "^1.4.19",
    "quackage": "^1.1.2"
  },
  "copyFilesSettings": {
    "whenFileExists": "overwrite"
  },
  "copyFiles": [
    {
      "from": "./html/*",
      "to": "./dist/"
    },
    {
      "from": "./html/favicons/*",
      "to": "./dist/favicons/"
    },
    {
      "from": "./fonts/*",
      "to": "./dist/fonts/"
    },
    {
      "from": "./node_modules/pict/dist/*",
      "to": "./dist/"
    },
    {
      "from": "./node_modules/katex/dist/katex.min.css",
      "to": "./dist/katex/"
    },
    {
      "from": "./node_modules/katex/dist/katex.min.js",
      "to": "./dist/katex/"
    },
    {
      "from": "./node_modules/katex/dist/fonts/*",
      "to": "./dist/katex/fonts/"
    },
    {
      "from": "./node_modules/mermaid/dist/mermaid.min.js",
      "to": "./dist/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/react-vendor.min.js",
      "to": "./dist/js/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/excalidraw-wrapper.min.js",
      "to": "./dist/js/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/excalidraw-wrapper.css",
      "to": "./dist/css/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/assets/**/*",
      "to": "./dist/js/excalidraw-assets/"
    },
    {
      "from": "./node_modules/openseadragon/build/openseadragon/openseadragon.min.js",
      "to": "./dist/"
    },
    {
      "from": "./node_modules/openseadragon/build/openseadragon/images/*",
      "to": "./dist/openseadragon-images/"
    }
  ]
}

},{}],551:[function(require,module,exports){
'use strict';

/**
 * BlueprintLayout
 * ---------------
 * A composable blueprint layout as SEMANTIC REGIONS on a PROPORTIONAL GRID (F-071, Strand 2).
 *
 * The point of the whole feature is one authored layout that renders UNCHANGED to a shareable web page, a
 * Letter PDF and a 24x36 ARCH D sheet. That only holds if a region's place is stored relative to the
 * sheet, not in pixels: a region sits at a grid cell (column, row, span), and the renderer maps the grid
 * onto whatever dimensions the output has. Letter and ARCH D are then the same arrangement at two scales,
 * which is exactly what "do not change the content between sizes" means, made true by construction rather
 * than by a scaling pass bolted on after.
 *
 * Pure string building, no DOM and no Pict dependency, so the same render runs in the browser (the canvas
 * preview and the shared page) and on the server (the print path hands this HTML to headless Chromium).
 * This is the model the canvas editor edits and the three outputs read; it is deliberately the ONE place
 * a blueprint's arrangement lives, so the editor, the web page and the PDF cannot come to disagree.
 *
 *   A layout:
 *     { Grid: { Cols, Rows }, Regions: [ Region ] }
 *   A region:
 *     { Kind, Col, Row, ColSpan, RowSpan, ... kind-specific content }
 *
 *   Kinds:
 *     'title'    the sheet's title block: Name, Tagline, Mark
 *     'diagram'  an inline SVG (vector, scales to any size, inherits ink) -- the architecture drawing
 *     'blurbs'   a stack of titled prose blocks: [{ Heading, Body }]
 *     'image'    a raster or SVG figure (a visual example / hero), by data URI or media src, with Caption
 *     'note'     a small labelled caption block (a legend, a stat, a call-out)
 *
 *   renderLayout(layout, opts) -> the grid HTML
 *   LAYOUT_CSS                 -> the styles (scoped to .bpl)
 *   moduleOverview(spec)       -> a default module-overview layout from a small spec
 *
 * opts:
 *   Mode   'web' | 'print'  -- print sizes type in points off the sheet; web sizes in viewport units
 *   fIcon  optional icon resolver (unused today; kept so the canvas can pass the Pict icon set)
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

function _escape(pText)
{
	return String(pText == null ? '' : pText)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// A placement (Col/Row/ColSpan/RowSpan), clamped so a bad column or span cannot push it off the sheet, and
// returned as the two grid track strings. Used for a region's base placement and its portrait alternate alike.
function _cells(pPlacement, pGrid)
{
	let tmpCol = Math.max(1, Math.min(pGrid.Cols, Number(pPlacement.Col) || 1));
	let tmpRow = Math.max(1, Math.min(pGrid.Rows, Number(pPlacement.Row) || 1));
	let tmpColSpan = Math.max(1, Math.min(pGrid.Cols - (tmpCol - 1), Number(pPlacement.ColSpan) || 1));
	let tmpRowSpan = Math.max(1, Math.min(pGrid.Rows - (tmpRow - 1), Number(pPlacement.RowSpan) || 1));
	return { Col: tmpCol + ' / span ' + tmpColSpan, Row: tmpRow + ' / span ' + tmpRowSpan };
}

// A region's grid placement. A non-responsive layout keeps today's inline grid-column/grid-row verbatim, so
// its markup is byte-identical. A responsive layout emits placement as CSS custom properties instead: the
// real grid-column/grid-row declarations live in LAYOUT_CSS and read these vars, so a @container rule can
// re-place the region for a portrait container -- which an inline grid-column could not, because an inline
// declaration outranks any stylesheet rule. A region with no Portrait alternate keeps its base placement at
// every aspect (the LAYOUT_CSS var() fallback), so the alternate is strictly opt-in.
function _place(pRegion, pGrid, pResponsive)
{
	let tmpBase = _cells(pRegion, pGrid);
	if (!pResponsive) { return 'grid-column: ' + tmpBase.Col + '; grid-row: ' + tmpBase.Row + ';'; }
	let tmpStyle = '--bpl-gc: ' + tmpBase.Col + '; --bpl-gr: ' + tmpBase.Row + ';';
	if (pRegion.Portrait)
	{
		let tmpPortrait = _cells(pRegion.Portrait, pGrid);
		tmpStyle += ' --bpl-gc-p: ' + tmpPortrait.Col + '; --bpl-gr-p: ' + tmpPortrait.Row + ';';
	}
	return tmpStyle;
}

function _title(pRegion)
{
	return '<div class="bpl-title">'
		+ (pRegion.Mark ? ('<div class="bpl-title-mark">' + _escape(pRegion.Mark) + '</div>') : '')
		+ '<div class="bpl-title-name">' + _escape(pRegion.Name || '') + '</div>'
		+ (pRegion.Tagline ? ('<div class="bpl-title-tag">' + _escape(pRegion.Tagline) + '</div>') : '')
	+ '</div>';
}

function _blurbs(pRegion)
{
	let tmpItems = (pRegion.Items || []).map((pItem) =>
		'<div class="bpl-blurb">'
			+ (pItem.Heading ? ('<div class="bpl-blurb-h">' + _escape(pItem.Heading) + '</div>') : '')
			+ '<div class="bpl-blurb-b">' + _escape(pItem.Body || '') + '</div>'
		+ '</div>').join('');
	return '<div class="bpl-blurbs">' + tmpItems + '</div>';
}

// A diagram is inline SVG so it stays vector and inherits the sheet ink (currentColor). The SVG is trusted
// layout content authored in the app, not arbitrary remote markup; the prolog/doctype are stripped so it
// is valid inside HTML flow.
function _diagram(pRegion)
{
	let tmpSVG = String(pRegion.SVG || '').replace(/<\?xml[\s\S]*?\?>/i, '').replace(/<!DOCTYPE[^>]*>/i, '').trim();
	return '<figure class="bpl-diagram">' + tmpSVG
		+ (pRegion.Caption ? ('<figcaption>' + _escape(pRegion.Caption) + '</figcaption>') : '')
	+ '</figure>';
}

function _image(pRegion)
{
	let tmpSrc = pRegion.DataURI || pRegion.Src || '';
	let tmpImg = tmpSrc ? ('<img alt="' + _escape(pRegion.Alt || '') + '" src="' + _escape(tmpSrc) + '">') : '<div class="bpl-image-empty">image</div>';
	return '<figure class="bpl-image">' + tmpImg
		+ (pRegion.Caption ? ('<figcaption>' + _escape(pRegion.Caption) + '</figcaption>') : '')
	+ '</figure>';
}

function _note(pRegion)
{
	return '<div class="bpl-note">'
		+ (pRegion.Label ? ('<div class="bpl-note-l">' + _escape(pRegion.Label) + '</div>') : '')
		+ '<div class="bpl-note-b">' + _escape(pRegion.Body || '') + '</div>'
	+ '</div>';
}

function _region(pRegion, pGrid, pResponsive)
{
	let tmpInner;
	switch (pRegion.Kind)
	{
		case 'title': tmpInner = _title(pRegion); break;
		case 'blurbs': tmpInner = _blurbs(pRegion); break;
		case 'diagram': tmpInner = _diagram(pRegion); break;
		case 'image': tmpInner = _image(pRegion); break;
		case 'note': tmpInner = _note(pRegion); break;
		default: tmpInner = ''; break;
	}
	return '<div class="bpl-region bpl-region-' + _escape(pRegion.Kind || 'empty') + '" style="' + _place(pRegion, pGrid, pResponsive) + '">' + tmpInner + '</div>';
}

/**
 * The layout as one grid. The grid is relative (fr tracks), so the caller gives the OUTER box its dimensions
 * (an aspect-ratio for the web, fixed inches for the sheet) and the region type scale rides on --bpl-scale so
 * text and padding grow with the paper.
 *
 * A layout with Responsive:true opts into aspect-responsive placement: regions carry both a base (landscape)
 * placement and an optional Portrait alternate as CSS custom properties, and a @container query in LAYOUT_CSS
 * switches between them by the container's aspect ratio. Without the flag the markup is exactly as before.
 * pOptions.Responsive === false forces base placement regardless of the flag (the studio uses this so its
 * drag math, which reads the base placement, never desyncs from a portrait alternate).
 */
function renderLayout(pLayout, pOptions)
{
	let tmpLayout = pLayout || {};
	let tmpOptions = pOptions || {};
	let tmpGrid = tmpLayout.Grid || { Cols: 12, Rows: 16 };
	let tmpResponsive = (tmpOptions.Responsive === false) ? false : (tmpLayout.Responsive === true);
	let tmpRegions = (tmpLayout.Regions || []).map((pRegion) => _region(pRegion, tmpGrid, tmpResponsive)).join('');
	let tmpClass = tmpResponsive ? 'bpl bpl-responsive' : 'bpl';
	return '<div class="' + tmpClass + '" style="--bpl-cols: ' + tmpGrid.Cols + '; --bpl-rows: ' + tmpGrid.Rows + ';">' + tmpRegions + '</div>';
}

const LAYOUT_CSS = /*css*/`
.bpl { display: grid; grid-template-columns: repeat(var(--bpl-cols, 12), 1fr); grid-template-rows: repeat(var(--bpl-rows, 16), 1fr);
	gap: calc(0.9% * var(--bpl-scale, 1)); width: 100%; height: 100%; box-sizing: border-box; color: var(--bpl-ink, #12161d);
	font-family: "IBM Plex Sans", system-ui, sans-serif; container-type: size; }
.bpl-region { min-width: 0; min-height: 0; overflow: hidden; display: flex; flex-direction: column; }
/* Aspect-responsive placement (opt-in: only layouts rendered with Responsive:true carry .bpl-responsive).
   The one 12x16 grid of 1fr tracks reshapes to fill whatever box it is given, so only WHICH cells a region
   occupies changes between a wide (landscape) and a tall (portrait) container. Landscape is the base. Below
   1:1 a region switches to its Portrait alternate; a region with none falls back to its base via the nested
   var() default, so the alternate is strictly opt-in. The vars come from the region's inline style; these
   stylesheet declarations are what actually set grid placement, which an inline grid-column could not be
   overridden to do. Scoped under .bpl-responsive so a non-responsive layout (inline grid-column, no class)
   is untouched. Switched on .bpl-region, which resolves against .bpl -- the nearest size container on every
   surface, including the studio, which has no .bpl-sheet. */
.bpl-responsive .bpl-region { grid-column: var(--bpl-gc); grid-row: var(--bpl-gr); }
/* A responsive diagram binds to its grid cell (the cell is a definite height, so max-height on the SVG can
   finally resolve). Without this a wide-short cell -- e.g. a code banner stretched full-width on a landscape
   sheet -- lets the width:100% SVG overflow its row and the cell's overflow:hidden clips it. The SVG's own
   viewBox keeps the drawing centered and whole at whatever box the cell gives it. Scoped to responsive so a
   fixed blueprint's diagram sits exactly as before. */
.bpl-responsive .bpl-diagram { flex: 1 1 auto; min-height: 0; }
@container (aspect-ratio < 1 / 1)
{
	.bpl-responsive .bpl-region { grid-column: var(--bpl-gc-p, var(--bpl-gc)); grid-row: var(--bpl-gr-p, var(--bpl-gr)); }
}
/* Type sizes start in container-query units (cqh), so they scale with the sheet, and every text region
   carries a --bpl-fit multiplier that fitLayout() dials down until the content fits its cell. Text inside
   a text region is in em off a single scalable root, so one multiplier shrinks the whole block together --
   that is what keeps a blurb column from clipping into the figure below it at any size. */
.bpl-title { border-bottom: 0.25cqh solid var(--bpl-rule, #cbd2dd); padding-bottom: 1cqh; display: flex; flex-direction: column; gap: 0.5em; justify-content: flex-end; font-size: calc(2cqh * var(--bpl-fit, 1)); }
.bpl-title-mark { font-family: "Gorton Perfected", "IBM Plex Mono", monospace; font-size: 0.72em; letter-spacing: 0.08em; text-transform: uppercase; color: var(--bpl-quiet, #6b7280); }
.bpl-title-name { font-family: "Gorton Perfected", "IBM Plex Sans", sans-serif; font-weight: 700; font-size: 2.2em; line-height: 1.02; }
.bpl-title-tag { font-size: 0.95em; line-height: 1.3; color: var(--bpl-quiet, #566072); max-width: 62ch; }
.bpl-diagram { margin: 0; padding: 1.4cqh; display: flex; flex-direction: column; align-items: center; justify-content: center; border: 0.18cqh solid var(--bpl-rule, #d6dbe4); border-radius: 0.4cqh; background: var(--bpl-panel, #fbfcfe); }
.bpl-diagram svg { max-width: 100%; max-height: 100%; height: auto; color: var(--bpl-ink, #12161d); }
.bpl-diagram figcaption, .bpl-image figcaption { font-family: "Gorton Perfected", "IBM Plex Mono", monospace; font-size: 1.4cqh; text-transform: uppercase; letter-spacing: 0.05em; color: var(--bpl-quiet, #6b7280); margin-top: 0.8cqh; }
.bpl-blurbs { display: flex; flex-direction: column; gap: 0.9em; padding-left: 1.4cqh; font-size: calc(1.95cqh * var(--bpl-fit, 1)); }
.bpl-blurb-h { font-family: "Gorton Perfected", "IBM Plex Sans", sans-serif; font-weight: 700; font-size: 1.13em; margin-bottom: 0.2em; }
.bpl-blurb-b { font-size: 1em; line-height: 1.42; color: var(--bpl-body, #2b3340); }
.bpl-image { margin: 0; display: flex; flex-direction: column; }
.bpl-image img { width: 100%; height: 100%; object-fit: contain; border-radius: 0.3cqh; min-height: 0; }
.bpl-image-empty { flex: 1; display: flex; align-items: center; justify-content: center; border: 0.2cqh dashed var(--bpl-rule, #cbd2dd); color: var(--bpl-quiet, #9aa3b2); font-size: 2cqh; border-radius: 0.3cqh; }
.bpl-note { border-left: 0.3cqh solid var(--bpl-accent, #3b6fd4); padding-left: 1cqh; display: flex; flex-direction: column; gap: 0.25em; justify-content: center; font-size: calc(1.9cqh * var(--bpl-fit, 1)); }
.bpl-note-l { font-family: "Gorton Perfected", "IBM Plex Mono", monospace; font-size: 0.7em; text-transform: uppercase; letter-spacing: 0.06em; color: var(--bpl-quiet, #6b7280); }
.bpl-note-b { font-size: 1em; line-height: 1.35; color: var(--bpl-body, #2b3340); }
`;

/**
 * Shrink each text region's type until its content fits its grid cell.
 *
 * A grid cell is a fixed fraction of the sheet, but how much prose a region holds is the author's, so at a
 * smaller size (or with more words) a blurb column would overflow and clip into the figure below it. CSS
 * alone cannot fit arbitrary text to a box; this steps the region's --bpl-fit multiplier down until the
 * content stops overflowing (or hits a floor, below which clipping is the honest outcome and the author
 * should give the region more room). Runs in the browser for the canvas and the shared page, and in the
 * printed HTML before page.pdf, so the fit is identical everywhere.
 *
 * pRoot is the .bpl element (or an ancestor); pass the document to fit every layout on the page.
 */
function fitLayout(pRoot)
{
	if (!pRoot || typeof pRoot.querySelectorAll !== 'function') { return; }
	let tmpRegions = pRoot.querySelectorAll('.bpl-region');
	for (let i = 0; i < tmpRegions.length; i++)
	{
		let tmpRegion = tmpRegions[i];
		// Images and diagrams already fit by object-fit / max-height; only text regions scale their type.
		if (tmpRegion.classList.contains('bpl-region-image') || tmpRegion.classList.contains('bpl-region-diagram')) { continue; }
		let tmpContent = tmpRegion.firstElementChild;
		if (!tmpContent) { continue; }
		let tmpScale = 1;
		tmpRegion.style.setProperty('--bpl-fit', tmpScale);
		// Step down ~3% at a time to a 0.55 floor; cheap and visually smooth, and a region that still
		// overflows at the floor is a layout the author needs to resize, not a bug to hide.
		for (let tmpStep = 0; tmpStep < 24 && tmpScale > 0.55 && tmpContent.scrollHeight > tmpRegion.clientHeight + 1; tmpStep++)
		{
			tmpScale = Math.round((tmpScale - 0.03) * 1000) / 1000;
			tmpRegion.style.setProperty('--bpl-fit', tmpScale);
		}
	}
}

/**
 * Re-run fitLayout as the container resizes, so a responsive layout re-fits its text when the arrangement
 * changes -- notably when the container crosses 1:1 and regions swap to their portrait placement, which
 * re-cells every text region and makes the once-computed --bpl-fit stale. rAF-debounced; returns the
 * observer so the caller can disconnect it. A no-op where ResizeObserver is absent (and the print path,
 * which renders at one fixed sheet size, never needs it). fitLayout itself is unchanged: it resets
 * --bpl-fit to 1 per region, so a repeat call both shrinks and grows text back as room changes.
 */
function observeFit(pRoot, pTarget)
{
	if ((typeof ResizeObserver !== 'function') || !pRoot) { return null; }
	let tmpTarget = pTarget || pRoot;
	let tmpPending = 0;
	let tmpObserver = new ResizeObserver(function ()
	{
		if (tmpPending) { return; }
		tmpPending = requestAnimationFrame(function () { tmpPending = 0; fitLayout(pRoot); });
	});
	tmpObserver.observe(tmpTarget);
	return tmpObserver;
}

/**
 * A default module-overview layout from a small spec: the use case this strand exists to serve. A Retold
 * module gets a title block, its architecture diagram large on the left, a stack of "what / how / pieces"
 * blurbs down the right, and a visual example across the foot -- one arrangement, printable at any size.
 *
 * spec: { Mark, Name, Tagline, DiagramSVG, Blurbs: [{Heading, Body}], Example: { DataURI|Src, Alt, Caption } }
 */
function moduleOverview(pSpec)
{
	let tmpSpec = pSpec || {};
	// Base placements are LANDSCAPE (diagram large on the left, blurbs down the right); the Portrait alternate
	// stacks them (diagram full-width band, blurbs below) so the same sheet is beautiful on a wide monitor and
	// a narrow one. Responsive:true turns the alternates on.
	let tmpRegions =
	[
		{ Kind: 'title', Col: 1, Row: 1, ColSpan: 12, RowSpan: 2, Portrait: { Col: 1, Row: 1, ColSpan: 12, RowSpan: 2 }, Mark: tmpSpec.Mark, Name: tmpSpec.Name, Tagline: tmpSpec.Tagline },
		{ Kind: 'diagram', Col: 1, Row: 3, ColSpan: 8, RowSpan: 9, Portrait: { Col: 1, Row: 3, ColSpan: 12, RowSpan: 7 }, SVG: tmpSpec.DiagramSVG || '', Caption: tmpSpec.DiagramCaption || 'Architecture' },
		{ Kind: 'blurbs', Col: 9, Row: 3, ColSpan: 4, RowSpan: 9, Portrait: { Col: 1, Row: 10, ColSpan: 12, RowSpan: 7 }, Items: tmpSpec.Blurbs || [] }
	];
	if (tmpSpec.Example)
	{
		// Stacked with an example: title 1-2, diagram 3-9, blurbs 10-13, example 14-16 (fits 16 rows).
		tmpRegions[2].Portrait = { Col: 1, Row: 10, ColSpan: 12, RowSpan: 4 };
		tmpRegions.push({ Kind: 'image', Col: 1, Row: 12, ColSpan: 12, RowSpan: 5, Portrait: { Col: 1, Row: 14, ColSpan: 12, RowSpan: 3 },
			DataURI: tmpSpec.Example.DataURI, Src: tmpSpec.Example.Src, Alt: tmpSpec.Example.Alt, Caption: tmpSpec.Example.Caption || 'Example' });
	}
	return { Grid: { Cols: 12, Rows: 16 }, Responsive: true, Regions: tmpRegions };
}

/**
 * Compose a whole, beautiful sheet from a CONTENT spec -- the engine behind agent-authored blueprints.
 *
 * The caller supplies CONTENT, not grid cells: a title, an optional hero diagram (inline SVG line-work), a
 * stack of blurbs, an optional callout note, and an optional foot (a raster example OR a secondary diagram
 * such as a code banner). composeSheet lays them out on the 12x16 grid in balanced proportions AND emits a
 * Portrait alternate for every region, so one sheet reads side-by-side on a wide monitor and stacked on a
 * narrow one, and prints cleanly at any size. It degrades gracefully: drop the diagram and the blurbs widen
 * to fill; give only blurbs and many of them and they flow into columns (a reference "catalog"); give only a
 * diagram and it fills the body.
 *
 * spec:
 *   { Mark, Name, Tagline,                              // the title block
 *     Diagram: { SVG, Caption },                        // the hero (optional)
 *     Blurbs: [ { Heading, Body } ],                    // explanatory blocks (optional)
 *     Note: { Label, Body },                            // a callout band (optional)
 *     Image: { DataURI | Src, Alt, Caption },           // a raster example at the foot (optional)
 *     Code:  { SVG, Caption },                           // a secondary diagram / code banner at the foot (optional)
 *     Grid, Responsive, Regions }                       // Regions present => used verbatim (the power path)
 *
 * Returns a layout object ready for renderSheet / Design/Save. Kit is NOT set here -- it rides on the
 * blueprint (the caller sets layout.Kit), so one composed sheet can be drawn clean, drafting or cyanotype.
 */
function composeSheet(pSpec)
{
	let tmpSpec = pSpec || {};
	// POWER PATH: a caller who hands raw Regions gets them verbatim (responsive unless told otherwise), so an
	// author who wants exact control is never fighting the composer.
	if (Array.isArray(tmpSpec.Regions))
	{
		return { Grid: tmpSpec.Grid || { Cols: 12, Rows: 16 }, Kit: tmpSpec.Kit,
			Responsive: (tmpSpec.Responsive === false) ? false : true, Regions: tmpSpec.Regions };
	}

	let tmpBlurbs = Array.isArray(tmpSpec.Blurbs) ? tmpSpec.Blurbs.filter((pB) => pB && (pB.Heading || pB.Body)) : [];
	let tmpHasDiagram = !!(tmpSpec.Diagram && tmpSpec.Diagram.SVG);
	let tmpHasBlurbs = tmpBlurbs.length > 0;
	let tmpHasNote = !!(tmpSpec.Note && (tmpSpec.Note.Body || tmpSpec.Note.Label));
	// The foot is one full-width band: a raster example if given, else a secondary diagram (a code banner).
	let tmpFootImage = (tmpSpec.Image && (tmpSpec.Image.DataURI || tmpSpec.Image.Src)) ? tmpSpec.Image : null;
	let tmpFootCode = (!tmpFootImage && tmpSpec.Code && tmpSpec.Code.SVG) ? tmpSpec.Code : null;
	let tmpHasFoot = !!(tmpFootImage || tmpFootCode);

	// ---- Row budget (16 rows). Title owns the top two; foot the bottom, note just above it, the rest is MAIN.
	let tmpFootSpan = tmpHasFoot ? 4 : 0;
	let tmpNoteSpan = tmpHasNote ? 2 : 0;
	let tmpMainTop = 3;
	let tmpMainSpan = Math.max(2, 14 - tmpFootSpan - tmpNoteSpan);
	let tmpNoteTop = tmpMainTop + tmpMainSpan;
	let tmpFootTop = tmpNoteTop + tmpNoteSpan;

	// ---- Portrait budget: everything stacked full-width, 14 body rows shared top-to-bottom. A diagram scales to
	// whatever height it gets, so when a diagram and blurbs share the body the TEXT takes the larger share (it is
	// the thing that clips), and a code banner at the foot is thinner than a raster example.
	let tmpPFootSpan = tmpFootImage ? 4 : (tmpHasFoot ? 3 : 0);
	let tmpPBodyRows = 14 - tmpPFootSpan - tmpNoteSpan;
	let tmpPDiagramSpan = 0;
	let tmpPBlurbsSpan = 0;
	if (tmpHasDiagram && tmpHasBlurbs) { tmpPDiagramSpan = Math.floor(tmpPBodyRows * 0.45); tmpPBlurbsSpan = tmpPBodyRows - tmpPDiagramSpan; }
	else if (tmpHasDiagram) { tmpPDiagramSpan = tmpPBodyRows; }
	else if (tmpHasBlurbs) { tmpPBlurbsSpan = tmpPBodyRows; }
	let tmpPDiagramTop = 3;
	let tmpPBlurbsTop = 3 + tmpPDiagramSpan;
	let tmpPNoteTop = 3 + tmpPDiagramSpan + tmpPBlurbsSpan;
	let tmpPFootTop = tmpPNoteTop + tmpNoteSpan;

	let tmpRegions =
	[
		{ Kind: 'title', Col: 1, Row: 1, ColSpan: 12, RowSpan: 2, Portrait: { Col: 1, Row: 1, ColSpan: 12, RowSpan: 2 },
			Mark: tmpSpec.Mark, Name: tmpSpec.Name, Tagline: tmpSpec.Tagline }
	];

	if (tmpHasDiagram && tmpHasBlurbs)
	{
		// The signature arrangement: hero diagram on the left, blurbs down the right; stacked in portrait.
		tmpRegions.push({ Kind: 'diagram', Col: 1, Row: tmpMainTop, ColSpan: 8, RowSpan: tmpMainSpan,
			Portrait: { Col: 1, Row: tmpPDiagramTop, ColSpan: 12, RowSpan: tmpPDiagramSpan },
			SVG: tmpSpec.Diagram.SVG, Caption: tmpSpec.Diagram.Caption || '' });
		tmpRegions = tmpRegions.concat(_blurbColumns(tmpBlurbs, 9, tmpMainTop, 4, tmpMainSpan,
			{ Col: 1, Row: tmpPBlurbsTop, ColSpan: 12, RowSpan: tmpPBlurbsSpan }, 1));
	}
	else if (tmpHasDiagram)
	{
		tmpRegions.push({ Kind: 'diagram', Col: 1, Row: tmpMainTop, ColSpan: 12, RowSpan: tmpMainSpan,
			Portrait: { Col: 1, Row: tmpPDiagramTop, ColSpan: 12, RowSpan: tmpPDiagramSpan },
			SVG: tmpSpec.Diagram.SVG, Caption: tmpSpec.Diagram.Caption || '' });
	}
	else if (tmpHasBlurbs)
	{
		// A reference CATALOG: no hero, so the blurbs flow into up to three columns to fill the sheet (two in
		// portrait), with fitLayout sizing the type. Fewer than six blurbs stay a single comfortable column.
		let tmpCols = (tmpBlurbs.length >= 10) ? 3 : (tmpBlurbs.length >= 6) ? 2 : 1;
		tmpRegions = tmpRegions.concat(_blurbColumns(tmpBlurbs, 1, tmpMainTop, 12, tmpMainSpan,
			{ Col: 1, Row: tmpPDiagramTop, ColSpan: 12, RowSpan: tmpPBodyRows }, tmpCols));
	}

	if (tmpHasNote)
	{
		tmpRegions.push({ Kind: 'note', Col: 1, Row: tmpNoteTop, ColSpan: 12, RowSpan: tmpNoteSpan,
			Portrait: { Col: 1, Row: tmpPNoteTop, ColSpan: 12, RowSpan: tmpNoteSpan },
			Label: tmpSpec.Note.Label, Body: tmpSpec.Note.Body });
	}
	if (tmpFootImage)
	{
		tmpRegions.push({ Kind: 'image', Col: 1, Row: tmpFootTop, ColSpan: 12, RowSpan: tmpFootSpan,
			Portrait: { Col: 1, Row: tmpPFootTop, ColSpan: 12, RowSpan: tmpPFootSpan },
			DataURI: tmpFootImage.DataURI, Src: tmpFootImage.Src, Alt: tmpFootImage.Alt, Caption: tmpFootImage.Caption || '' });
	}
	else if (tmpFootCode)
	{
		tmpRegions.push({ Kind: 'diagram', Col: 1, Row: tmpFootTop, ColSpan: 12, RowSpan: tmpFootSpan,
			Portrait: { Col: 1, Row: tmpPFootTop, ColSpan: 12, RowSpan: tmpPFootSpan },
			SVG: tmpFootCode.SVG, Caption: tmpFootCode.Caption || '' });
	}

	return { Grid: { Cols: 12, Rows: 16 }, Kit: tmpSpec.Kit, Responsive: true, Regions: tmpRegions };
}

/**
 * Split a blurb list into pCols side-by-side blurbs regions across a landscape band, each carrying a Portrait
 * alternate (a single stacked column by default, or pPortrait placement for the whole set when pCols is 1).
 * Used by composeSheet for the blurbs column and the catalog archetype.
 */
function _blurbColumns(pBlurbs, pCol, pRow, pColSpan, pRowSpan, pPortrait, pCols)
{
	let tmpCols = Math.max(1, Math.min(3, Number(pCols) || 1));
	if (tmpCols === 1)
	{
		return [{ Kind: 'blurbs', Col: pCol, Row: pRow, ColSpan: pColSpan, RowSpan: pRowSpan, Portrait: pPortrait, Items: pBlurbs }];
	}
	let tmpPer = Math.ceil(pBlurbs.length / tmpCols);
	let tmpColWidth = Math.max(1, Math.floor(pColSpan / tmpCols));
	let tmpOut = [];
	for (let i = 0; i < tmpCols; i++)
	{
		let tmpItems = pBlurbs.slice(i * tmpPer, (i + 1) * tmpPer);
		if (!tmpItems.length) { continue; }
		// Portrait collapses the columns into a vertical run of two columns (six-wide each) so a narrow sheet
		// still reads top-to-bottom rather than squeezing three columns into no width.
		let tmpPortraitCol = (i % 2 === 0) ? 1 : 7;
		let tmpPortraitRowBand = Math.ceil(tmpCols / 2);
		let tmpPortraitBandRows = Math.max(2, Math.floor((pPortrait.RowSpan || 6) / tmpPortraitRowBand));
		let tmpPortraitRow = pPortrait.Row + Math.floor(i / 2) * tmpPortraitBandRows;
		tmpOut.push({ Kind: 'blurbs', Col: pCol + i * tmpColWidth, Row: pRow, ColSpan: tmpColWidth, RowSpan: pRowSpan,
			Portrait: { Col: tmpPortraitCol, Row: tmpPortraitRow, ColSpan: 6, RowSpan: tmpPortraitBandRows }, Items: tmpItems });
	}
	return tmpOut;
}

/**
 * The drawing-style KITS: one layout, different drawing styles. A kit is pure presentation -- a set of
 * CSS-variable tokens (ink, rule, panel, accent) plus a paper colour and whether the sheet wears a
 * drafting frame + title block. The same kit data drives the studio canvas, the shared web page and the
 * printed PDF, so a blueprint cannot look one way on screen and another on paper.
 *
 * 'blueprint' is cyanotype: because a diagram is inline SVG stroked in currentColor, it redraws itself in
 * the kit's ink -- white line-work on blue -- rather than carrying a baked colour.
 */
const KITS =
{
	clean:     { Label: 'Clean',     Background: '#ffffff', Frame: false,
		Tokens: { '--bpl-ink': '#12161d', '--bpl-body': '#2b3340', '--bpl-quiet': '#6b7280', '--bpl-rule': '#d6dbe4', '--bpl-panel': '#fbfcfe', '--bpl-accent': '#3b6fd4' } },
	drafting:  { Label: 'Drafting',  Background: '#f5f1e8', Frame: true,
		Tokens: { '--bpl-ink': '#232730', '--bpl-body': '#2d343d', '--bpl-quiet': '#6b7480', '--bpl-rule': '#b2ab98', '--bpl-panel': 'transparent', '--bpl-accent': '#232730', '--tb-bg': '#f5f1e8' } },
	blueprint: { Label: 'Blueprint', Background: '#15325f', Frame: true,
		Tokens: { '--bpl-ink': '#eaf3ff', '--bpl-body': '#d2e2f6', '--bpl-quiet': '#9ec0ec', '--bpl-rule': 'rgba(255,255,255,.42)', '--bpl-panel': 'rgba(255,255,255,.05)', '--bpl-accent': '#8fd3ff', '--tb-bg': '#15325f' } }
};
function kitOf(pKit) { return KITS[pKit] || KITS.clean; }

// The inline style that paints a sheet in a kit: the paper colour plus the kit's tokens. Applied to the
// .bpl-sheet element, so the kit travels with the markup (no per-kit stylesheet to keep in sync).
function kitStyle(pKit)
{
	let tmpKit = kitOf(pKit);
	let tmpStyle = 'background:' + tmpKit.Background + ';';
	for (let tmpToken in tmpKit.Tokens) { tmpStyle += tmpToken + ':' + tmpKit.Tokens[tmpToken] + ';'; }
	return tmpStyle;
}

// The drafting title block, drawn from the layout's own title region so the corner block and the sheet
// agree on what this is. Shown only for kits that wear a frame.
function _titleBlock(pLayout, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpTitle = ((pLayout || {}).Regions || []).find((pR) => pR.Kind === 'title') || {};
	// A fourth PAGE cell appears only when this sheet is rendered as one page of a set (a deck passes
	// Page: {Index, Total}), so a standalone blueprint keeps its three-cell block exactly as before.
	let tmpPageCell = '';
	if (tmpOptions.Page && Number(tmpOptions.Page.Total) > 0)
	{
		tmpPageCell = '<div class="bpl-tb-cell"><div class="bpl-tb-k">Page</div><div class="bpl-tb-v">'
			+ _escape((Number(tmpOptions.Page.Index) || 1) + ' of ' + Number(tmpOptions.Page.Total)) + '</div></div>';
	}
	return '<div class="bpl-tb' + (tmpPageCell ? ' bpl-tb-wide' : '') + '">'
		+ '<div class="bpl-tb-name">' + _escape(tmpTitle.Name || 'Untitled') + '</div>'
		+ '<div class="bpl-tb-row">'
			+ '<div class="bpl-tb-cell"><div class="bpl-tb-k">Sheet</div><div class="bpl-tb-v">' + _escape(tmpTitle.Mark || 'BP-001') + '</div></div>'
			+ '<div class="bpl-tb-cell"><div class="bpl-tb-k">Scale</div><div class="bpl-tb-v">NTS</div></div>'
			+ '<div class="bpl-tb-cell"><div class="bpl-tb-k">Rev</div><div class="bpl-tb-v">A</div></div>'
			+ tmpPageCell
		+ '</div></div>';
}

// The per-plan-sheet brand band: an uploaded logo + a short footer line, stamped at render time on EVERY
// sheet. The brand is never stored in the layout; it rides in as pOptions.Brand ({ LogoDataURI, Footer })
// resolved by the endpoint from the tenant, so a logo change re-brands existing blueprints. LogoDataURI is
// a self-contained data: URI (the login-free public page and headless-Chromium PDF cannot fetch an authed
// Media URL), so the endpoint inlines the bytes. Returns '' when the tenant has no brand set.
function _brandBand(pBrand)
{
	let tmpBrand = pBrand || {};
	let tmpURI = String(tmpBrand.LogoDataURI || '');
	let tmpFoot = String(tmpBrand.Footer || '');
	let tmpLogo = tmpURI ? ('<img class="bpl-brand-logo" alt="" src="' + _escape(tmpURI) + '">') : '';
	let tmpFootHTML = tmpFoot ? ('<span class="bpl-brand-foot">' + _escape(tmpFoot) + '</span>') : '';
	if (!tmpLogo && !tmpFootHTML) { return ''; }
	return '<div class="bpl-brand">' + tmpLogo + tmpFootHTML + '</div>';
}

/**
 * A whole sheet: the layout grid wrapped in a kit. This is the ONE render the web page and the print path
 * both use; the studio canvas uses it too, then overlays its editing chrome. The kit rides on the element
 * (data-bpl-kit + inline tokens), so there is nothing to theme separately.
 *
 * pOptions.Kit    a key from KITS (default 'clean').
 * pOptions.Brand  optional { LogoDataURI, Footer } -- the tenant's brand band, stamped on this sheet.
 */
function renderSheet(pLayout, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpKey = tmpOptions.Kit || (pLayout && pLayout.Kit) || 'clean';
	let tmpKit = kitOf(tmpKey);
	let tmpBrandBand = _brandBand(tmpOptions.Brand);
	return '<div class="bpl-sheet' + (tmpBrandBand ? ' bpl-sheet-branded' : '') + '" data-bpl-kit="' + _escape(tmpKey) + '" style="' + kitStyle(tmpKey) + '">'
		+ (tmpKit.Frame ? '<div class="bpl-frame"></div>' : '')
		+ renderLayout(pLayout, tmpOptions)
		+ (tmpKit.Frame ? _titleBlock(pLayout, tmpOptions) : '')
		+ tmpBrandBand
	+ '</div>';
}

// The kit chrome (sheet wrapper, frame, title block) + the kit overrides. Sizes that must scale with the
// paper are in container units off .bpl-sheet, so the title block is proportional on a web card and on a
// 36in sheet alike. Pair this with LAYOUT_CSS; SHEET_CSS is both, for a caller that wants one string.
const KIT_CSS = /*css*/`
.bpl-sheet { position: relative; width: 100%; height: 100%; box-sizing: border-box; container-type: size; padding: 3.2%; }
/* inset/right/bottom in cqw (container WIDTH) on every side, not %, because a % inset is width-relative for
   left/right but height-relative for top/bottom -- so on a non-square sheet equal percentages give unequal
   pixel gaps and the frame (and the title block) sits closer to the top/bottom than the sides. cqw keeps all
   four margins equal, matching the content grid, whose padding % is already width-based. */
.bpl-frame { position: absolute; inset: 1.65cqw; border: 0.12cqw solid var(--bpl-ink, #222); pointer-events: none; z-index: 3; }
.bpl-frame::after { content: ''; position: absolute; inset: 0.5cqw; border: 0.06cqw solid var(--bpl-rule, #999); }
/* The title block is a quiet corner reference, not a headline: a modest cartouche that stays out of the
   content's way. Sizes are in cqw so it stays the same proportion of the sheet from a web card to a 36in
   print, and deliberately small -- the sheet name here should never be the largest type on the page. */
.bpl-tb { position: absolute; right: 2.75cqw; bottom: 2.75cqw; width: 20%; z-index: 4; border: 0.08cqw solid var(--bpl-ink, #222); background: var(--tb-bg, #f5f1e8); font-family: "IBM Plex Mono", monospace; color: var(--bpl-ink, #222); }
/* A set page carries a fourth PAGE cell, so its block is a touch wider to keep every cell legible. */
.bpl-tb-wide { width: 26%; }
.bpl-tb-name { padding: 0.7cqw 1.1cqw; border-bottom: 0.06cqw solid var(--bpl-ink, #222); font-weight: 700; font-size: 1.2cqw; letter-spacing: .05em; text-transform: uppercase; }
.bpl-tb-row { display: flex; }
.bpl-tb-cell { flex: 1; padding: 0.55cqw 1.1cqw; border-right: 0.05cqw solid var(--bpl-rule, #999); }
.bpl-tb-cell:last-child { border-right: 0; }
.bpl-tb-k { font-size: 0.72cqw; letter-spacing: .08em; color: var(--bpl-quiet, #777); text-transform: uppercase; margin-bottom: 0.3cqw; }
.bpl-tb-v { font-size: 0.92cqw; }
/* The brand band. A branded sheet reserves a bottom strip (extra padding-bottom, width-relative like the
   base 3.2% padding) and the band is placed absolutely inside it, so the content grid never overlaps it and
   the change touches ONLY sheets that carry a brand. Capped to the left 68% so it clears the framed-kit title
   block (bottom-right). The footer ink is var(--bpl-quiet), which the print media query below darkens on the
   white framed-kit print palette, so it stays legible in the PDF. */
.bpl-sheet-branded { padding-bottom: 8%; }
.bpl-brand { position: absolute; left: 3.2%; bottom: 1.5%; max-width: 68%; height: 4.6cqw; display: flex; align-items: center; gap: 1.3cqw; z-index: 4; }
.bpl-brand-logo { height: 100%; max-height: 4.6cqw; width: auto; object-fit: contain; }
.bpl-brand-foot { font-family: "IBM Plex Mono", monospace; font-size: 0.95cqw; letter-spacing: .04em; color: var(--bpl-quiet, #777); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.bpl-sheet[data-bpl-kit="drafting"] .bpl-region, .bpl-sheet[data-bpl-kit="blueprint"] .bpl-region,
.bpl-sheet[data-bpl-kit="drafting"] .bpl-diagram, .bpl-sheet[data-bpl-kit="blueprint"] .bpl-diagram,
.bpl-sheet[data-bpl-kit="drafting"] .bpl-image img, .bpl-sheet[data-bpl-kit="blueprint"] .bpl-image img,
.bpl-sheet[data-bpl-kit="drafting"] .bpl-image-empty, .bpl-sheet[data-bpl-kit="blueprint"] .bpl-image-empty { border-radius: 0 !important; }
.bpl-sheet[data-bpl-kit="drafting"] .bpl-diagram, .bpl-sheet[data-bpl-kit="blueprint"] .bpl-diagram { background: transparent; border-width: 0.12cqh; border-color: var(--bpl-rule); }
.bpl-sheet[data-bpl-kit="drafting"] .bpl-title-name, .bpl-sheet[data-bpl-kit="blueprint"] .bpl-title-name { text-transform: uppercase; letter-spacing: .015em; }
/* PRINT: the cyanotype navy (and the cream drafting paper) are a screen treatment. On paper they waste ink and
   read poorly, so a printed sheet drops to white with dark ink -- the clean palette. The !important is deliberate:
   the kit paints each sheet with an inline background and token set that a plain rule could not override. The
   diagram accent hues (the purple mark, the cyan rules) stay as drawn, which reads fine on white. */
@media print {
	.bpl-sheet[data-bpl-kit="blueprint"], .bpl-sheet[data-bpl-kit="drafting"] {
		background: #ffffff !important; color: #12161d !important;
		--bpl-ink: #12161d !important; --bpl-body: #2b3340 !important; --bpl-quiet: #5a6472 !important;
		--bpl-rule: #c2c9d4 !important; --bpl-panel: #ffffff !important; --bpl-accent: #2f5fb0 !important;
		--tb-bg: #ffffff !important;
	}
	/* Firefox does not carry the ink TOKEN into an SVG's currentColor when printing, so the inline diagram
	   line-work and labels keep the pale on-screen ink and vanish on white (Chrome carries it fine). Set the
	   colour LITERALLY on the grid and the diagram SVGs -- not through the var -- so currentColor resolves dark
	   in every browser. */
	.bpl-sheet[data-bpl-kit="blueprint"] .bpl, .bpl-sheet[data-bpl-kit="drafting"] .bpl,
	.bpl-sheet[data-bpl-kit="blueprint"] .bpl-diagram svg, .bpl-sheet[data-bpl-kit="drafting"] .bpl-diagram svg {
		color: #12161d !important;
	}
}
`;
const SHEET_CSS = LAYOUT_CSS + KIT_CSS;

// The kits as a list, for a picker (studio control / settings).
function kitList() { return Object.keys(KITS).map((pK) => ({ Key: pK, Label: KITS[pK].Label, Frame: KITS[pK].Frame })); }

module.exports = {
	renderLayout: renderLayout, moduleOverview: moduleOverview, fitLayout: fitLayout, observeFit: observeFit,
	renderSheet: renderSheet, kitStyle: kitStyle, kitList: kitList, KITS: KITS, composeSheet: composeSheet,
	LAYOUT_CSS: LAYOUT_CSS, KIT_CSS: KIT_CSS, SHEET_CSS: SHEET_CSS
};

},{}],552:[function(require,module,exports){
'use strict';

/**
 * BlueprintRender
 * ---------------
 * The one place a blueprint sheet turns into HTML. Pure string building, no DOM
 * and no Pict dependency, so it runs both in the browser (PictView-Blueprint) and
 * on the server (the public /shared/:token page). Keeping a single render path is
 * what makes the in-app view and the shared public page look identical.
 *
 *   renderSheet(data, opts)        -> the inner sheet HTML (title block + plates)
 *   renderPublicDocument(data,opts)-> a full standalone HTML page (server use)
 *   SHEET_CSS                      -> the sheet styles (the view injects these too)
 *
 * opts:
 *   fIcon(itemType)  -> icon HTML; defaults to the bundled inline SVG set
 *   mediaBase        -> blob URL prefix ('/1.0/Media/' in-app; token-scoped public)
 *   links            -> 'app' (clickable #/... links) | 'inert' (plain cards)
 *   actionsHTML      -> markup dropped into the title block's action area
 *   loading          -> true to show the "drawing..." placeholder
 */

// ItemType -> icon name.
const ICON_FOR =
{
	Vision: 'Eye', Module: 'Box', Feature: 'Star', WorkItem: 'ListChecks',
	Media: 'Image', Documentation: 'FileText', Foundational: 'Book',
	Whiteboard: 'Network', Session: 'Robot', Comment: 'Message',
	Issue: 'Warning', TestRun: 'Flask', Feedback: 'Message', Prompt: 'Terminal'
};

// Minimal inline SVGs (stroke = currentColor so the sheet palette colors them).
// Used server-side and as the in-app fallback; the app view passes the Pict icon
// provider instead so the rest of the app's icon set stays consistent.
const ICON_SVG =
{
	Eye: '<circle cx="12" cy="12" r="3"/><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/>',
	Box: '<path d="M21 8 12 3 3 8v8l9 5 9-5Z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/>',
	Star: '<path d="M12 3l2.6 5.6 6.1.8-4.5 4.2 1.2 6L12 17l-5.4 2.8 1.2-6L3.3 9.4l6.1-.8Z"/>',
	Network: '<rect x="9" y="3" width="6" height="6" rx="1"/><rect x="3" y="15" width="6" height="6" rx="1"/><rect x="15" y="15" width="6" height="6" rx="1"/><path d="M12 9v3M6 15v-1h12v1"/>',
	FileText: '<path d="M14 3H6v18h12V7Z"/><path d="M14 3v4h4M9 12h6M9 16h6"/>',
	Book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z"/>',
	Robot: '<rect x="4" y="8" width="16" height="11" rx="2"/><path d="M12 8V4M9 13h.01M15 13h.01"/>',
	Message: '<path d="M21 12a8 8 0 0 1-11.5 7.2L4 21l1.8-5.5A8 8 0 1 1 21 12Z"/>',
	Warning: '<path d="M12 3 2 20h20Z"/><path d="M12 10v4M12 17h.01"/>',
	Image: '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="m4 18 5-5 4 3 3-3 4 4"/>',
	Flask: '<path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3"/>',
	ListChecks: '<path d="M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2"/>'
};

function _esc(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _bytes(pN)
{
	let tmpN = Number(pN) || 0;
	if (tmpN < 1024) { return tmpN + ' B'; }
	if (tmpN < 1024 * 1024) { return (tmpN / 1024).toFixed(0) + ' KB'; }
	return (tmpN / (1024 * 1024)).toFixed(1) + ' MB';
}

// Inline emphasis on ALREADY-ESCAPED text: `code`, **bold**, *italic*. Safe because
// the text is escaped first, so these only wrap escaped content in our own tags.
// Underscore italics are deliberately unsupported so snake_case (IDAssignedUser,
// SortOrder) is never mangled.
function _inline(pEscaped)
{
	return pEscaped
		.replace(/`([^`]+)`/g, '<code>$1</code>')
		.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
		.replace(/\*([^*\s][^*]*?)\*/g, '<em>$1</em>');
}

// A small, dependency-free, safe Markdown subset -> HTML: ATX headings (# .. ######),
// blank-line-separated paragraphs (single newlines become <br>), and unordered (-, *, +)
// and ordered (1.) lists. Every text run is escaped before any tag is added, so this is
// injection-safe and runs identically in the browser and on the public server page.
function _md(pRaw)
{
	let tmpLines = String(pRaw == null ? '' : pRaw).replace(/\r\n?/g, '\n').split('\n');
	let tmpOut = [];
	let tmpPara = [];
	let tmpList = null; // { type: 'ul' | 'ol', items: [] }
	let fFlushPara = () => { if (tmpPara.length) { tmpOut.push('<p>' + _inline(tmpPara.join('<br>')) + '</p>'); tmpPara = []; } };
	let fFlushList = () => { if (tmpList) { tmpOut.push('<' + tmpList.type + '>' + tmpList.items.map((pI) => '<li>' + _inline(pI) + '</li>').join('') + '</' + tmpList.type + '>'); tmpList = null; } };
	for (let i = 0; i < tmpLines.length; i++)
	{
		let tmpLine = tmpLines[i];
		let tmpH = tmpLine.match(/^(#{1,6})\s+(.*)$/);
		let tmpUL = tmpLine.match(/^\s*[-*+]\s+(.*)$/);
		let tmpOL = tmpLine.match(/^\s*\d+\.\s+(.*)$/);
		if (tmpLine.trim() === '') { fFlushPara(); fFlushList(); }
		else if (tmpH) { fFlushPara(); fFlushList(); let tmpN = tmpH[1].length; tmpOut.push('<h' + tmpN + '>' + _inline(_esc(tmpH[2])) + '</h' + tmpN + '>'); }
		else if (tmpUL) { fFlushPara(); if (!tmpList || tmpList.type !== 'ul') { fFlushList(); tmpList = { type: 'ul', items: [] }; } tmpList.items.push(_esc(tmpUL[1])); }
		else if (tmpOL) { fFlushPara(); if (!tmpList || tmpList.type !== 'ol') { fFlushList(); tmpList = { type: 'ol', items: [] }; } tmpList.items.push(_esc(tmpOL[1])); }
		else { fFlushList(); tmpPara.push(_esc(tmpLine)); }
	}
	fFlushPara(); fFlushList();
	return tmpOut.join('');
}

function _defaultIcon(pType)
{
	let tmpSVG = ICON_SVG[ICON_FOR[pType] || 'FileText'] || ICON_SVG.FileText;
	return '<span class="pict-icon"><svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + tmpSVG + '</svg></span>';
}

function _mediaHTML(pItem, pState)
{
	let tmpMime = String(pItem.Mime || '');
	let tmpURL = pState.mediaBase + pItem.IDItem + '/Blob';
	let tmpCap = '<figcaption>' + _esc(pItem.Title) + '</figcaption>';
	if (tmpMime.indexOf('image/') === 0)
	{
		return '<figure class="bp-media bp-media-img"><a href="' + tmpURL + '" target="_blank" rel="noopener"><img src="' + tmpURL + '" alt="' + _esc(pItem.Title) + '" loading="lazy"></a>' + tmpCap + '</figure>';
	}
	if (tmpMime.indexOf('video/') === 0)
	{
		return '<figure class="bp-media bp-media-video"><video controls preload="metadata" src="' + tmpURL + '"></video>' + tmpCap + '</figure>';
	}
	// Anything else: a download row.
	return '<a class="bp-artifact bp-artifact-row bp-artifact-link" href="' + tmpURL + '" download="' + _esc(pItem.FileName || pItem.Title) + '">'
		+ '<span class="bp-artifact-t">' + _esc(pItem.FileName || pItem.Title) + '</span>'
		+ '<span class="bp-artifact-sum">Download' + (pItem.SizeBytes ? (' (' + _bytes(pItem.SizeBytes) + ')') : '') + '</span></a>';
}

// The in-app route (or, for Sessions, the session viewer) an item links out to.
function _itemHref(pItem, pType, pState)
{
	if (pState.inert) { return ''; }
	if (pItem.Link) { return '#' + pItem.Link; }
	if (pType === 'Session') { return '#/session/' + pItem.IDItem; }
	return '';
}

// A caret that rotates when its <details> is open (see .bp-fold-chev CSS).
const _CHEVRON = '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';

// An item that carries full Content unfolds inline: a native <details> so several
// segments can be open at once and the whole thing works with no JavaScript (the
// public /shared page has no app bundle). Open by default = the "unfolded" view.
function _foldHTML(pItem, pType, pState)
{
	let tmpPin = pItem.Pinned ? '<span class="bp-pin" title="Pinned to this blueprint">PINNED</span>' : '';
	let tmpHref = _itemHref(pItem, pType, pState);
	let tmpOpenLink = tmpHref ? ('<a class="bp-artifact-open" href="' + _esc(tmpHref) + '" title="Open this item">Open</a>') : '';
	// The item flows under its set's title block: the name is a heading, the Content
	// renders as Markdown beneath it. No box and no repeated set icon -- a native
	// <details> only so it can still fold, and so it works with no JavaScript.
	return '<details class="bp-artifact bp-artifact-fold" open>'
		+ '<summary class="bp-artifact-head">'
			+ '<span class="bp-artifact-t">' + _esc(pItem.Title) + tmpPin + '</span>'
			+ tmpOpenLink
			+ '<span class="bp-fold-chev" aria-hidden="true">' + _CHEVRON + '</span>'
		+ '</summary>'
		+ '<div class="bp-artifact-content bp-md">' + _md(pItem.Content) + '</div>'
	+ '</details>';
}

function _itemHTML(pItem, pType, pState)
{
	if (pType === 'Media') { return _mediaHTML(pItem, pState); }
	// Anything with full content unfolds inline instead of showing a compact card.
	if (pItem.Content) { return _foldHTML(pItem, pType, pState); }

	// No content: a flowing row (title + short summary), no box and no repeated set icon.
	let tmpSummary = pItem.Summary ? ('<span class="bp-artifact-sum">' + _esc(pItem.Summary) + '</span>') : '';
	let tmpPin = pItem.Pinned ? '<span class="bp-pin" title="Pinned to this blueprint">PINNED</span>' : '';
	let tmpInner = '<span class="bp-artifact-t">' + _esc(pItem.Title) + tmpPin + '</span>' + tmpSummary;

	// Public sheets render inert rows: a logged-out reader cannot follow an
	// in-app route, so there is nothing to link to.
	if (pState.inert) { return '<div class="bp-artifact bp-artifact-row">' + tmpInner + '</div>'; }

	let tmpHref = _itemHref(pItem, pType, pState);
	if (tmpHref) { return '<a class="bp-artifact bp-artifact-row bp-artifact-link" href="' + _esc(tmpHref) + '">' + tmpInner + '</a>'; }
	return '<div class="bp-artifact bp-artifact-row">' + tmpInner + '</div>';
}

// One set = one opaque panel with a drafting title block at its top (eyebrow label,
// a rule, the count) and its items flowing beneath, separated by hairline rules --
// no box-in-a-box and no per-item icon repeated from the header.
function _plateHTML(pGroup, pState)
{
	let tmpItems = pGroup.Items || [];
	if (!tmpItems.length) { return ''; }
	let tmpMedia = (pGroup.Type === 'Media');
	let tmpBody = tmpItems.map((pItem) => _itemHTML(pItem, pGroup.Type, pState)).join('');
	return '<section class="bp-group' + (tmpMedia ? ' bp-group-media' : '') + '">'
		+ '<header class="bp-group-head">'
			+ '<span class="bp-group-label">' + _esc(pGroup.Label || pGroup.Type) + '</span>'
			+ '<span class="bp-group-rule"></span>'
			+ '<span class="bp-group-count">' + tmpItems.length + '</span>'
		+ '</header>'
		+ '<div class="bp-artifacts">' + tmpBody + '</div>'
	+ '</section>';
}

// The Unfold all / Fold all control. Inline handlers walk up to the sheet and flip
// every <details.bp-fold>, so this works in-app and on the public page with no
// bundled script. Shown only when the sheet actually has foldable content.
const _FOLD_ALL = "var s=this.closest('.bp-sheet');if(s){var d=s.querySelectorAll('details.bp-fold');for(var i=0;i<d.length;i++){d[i].open=true;}}";
const _FOLD_NONE = "var s=this.closest('.bp-sheet');if(s){var d=s.querySelectorAll('details.bp-fold');for(var i=0;i<d.length;i++){d[i].open=false;}}";
function _foldBarHTML()
{
	return '<div class="bp-foldbar">'
		+ '<span class="bp-foldbar-label">Attached content</span>'
		+ '<button type="button" class="bp-foldbtn" onclick="' + _FOLD_ALL + '">Unfold all</button>'
		+ '<button type="button" class="bp-foldbtn" onclick="' + _FOLD_NONE + '">Fold all</button>'
	+ '</div>';
}

// The inner sheet HTML (what goes inside .bp-root / #Blueprint-Sheet).
function renderSheet(pData, pOpts)
{
	pOpts = pOpts || {};
	if (pOpts.loading) { return '<div class="bp-empty">Drawing the blueprint...</div>'; }
	if (!pData) { return '<div class="bp-empty">This blueprint could not be loaded.</div>'; }

	let tmpState =
	{
		fIcon: pOpts.fIcon || _defaultIcon,
		mediaBase: pOpts.mediaBase || '/1.0/Media/',
		inert: (pOpts.links === 'inert')
	};

	let tmpID = pData.IDWorkItem || 0;
	// An entity's own mark when the payload carries one (a module reads M-001, not WI-0); a work item's
	// payload carries none, so it keeps the exact WI- form this sheet has always drawn.
	// BlueprintNumber before the WI fallback: a blueprint addressed as ITSELF carries neither a
	// Designator nor a WorkItemNumber, and used to fall all the way through to the literal "WI #0" --
	// a first-class blueprint titling itself as work item zero. BlueprintAPI.normalize fills the
	// Designator for anything it reads, so this is the belt to that braces (the public share page and
	// the print renderer build payloads that never pass through the provider).
	let tmpNum = pData.Designator
		? pData.Designator
		: (pData.WorkItemNumber ? ('WI-' + String(pData.WorkItemNumber).padStart(3, '0'))
			: (pData.BlueprintNumber ? ('BP-' + String(pData.BlueprintNumber).padStart(3, '0')) : ('WI #' + tmpID)));
	let tmpStatus = pData.Status ? ('<span class="bp-status">' + _esc(pData.Status) + '</span>') : '';
	let tmpDesc = pData.Description ? ('<div class="bp-desc bp-md">' + _md(pData.Description) + '</div>') : '';
	let tmpActions = pOpts.actionsHTML || '';

	let tmpHTML = '<div class="bp-titleblock">'
		+ '<div class="bp-tb-main">'
			+ '<div class="bp-eyebrow">BLUEPRINT | ' + _esc(tmpNum) + '</div>'
			+ '<h1 class="bp-h1">' + _esc(pData.Title || ('Work item #' + tmpID)) + '</h1>'
			+ tmpDesc
		+ '</div>'
		+ '<div class="bp-tb-side">' + tmpStatus + tmpActions + '</div>'
	+ '</div>';

	let tmpGroups = pData.Groups || [];
	if (!tmpGroups.length) { tmpHTML += '<div class="bp-empty">Nothing is linked to this work item yet.</div>'; }
	// Show the Unfold/Fold control only when at least one linked item has content to unfold.
	let tmpHasFold = tmpGroups.some((pGroup) => (pGroup.Items || []).some((pItem) => !!pItem.Content));
	if (tmpHasFold) { tmpHTML += _foldBarHTML(); }
	tmpGroups.forEach((pGroup) => { tmpHTML += _plateHTML(pGroup, tmpState); });
	return '<div class="bp-sheet">' + tmpHTML + '</div>';
}

// Drafting-sheet styles. The in-app view injects these via its CSSMap; the public
// page inlines them. The .bp-root variables drive the whole palette.
const SHEET_CSS = /*css*/`
	.bp-root { --bp-sheet: #16294b; --bp-panel: #101f39; --bp-ink: #eef4fc; --bp-eye: #88a8d6; --bp-frame: rgba(208,226,247,0.42); --bp-cell: rgba(150,180,220,0.28); --bp-acc: #f0c44a;
		padding: 22px; max-width: 1100px; margin: 0 auto; }
	.bp-root .bp-empty { color: var(--bp-eye); padding: 60px 10px; text-align: center; font-size: 15px; }
	.bp-root .bp-sheet { background: var(--bp-sheet); border: 1.5px solid var(--bp-frame); border-radius: 12px; padding: 22px 24px 26px;
		background-image: linear-gradient(rgba(150,180,220,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(150,180,220,0.07) 1px, transparent 1px);
		background-size: 26px 26px; color: var(--bp-ink); }
	/* Readable text sits on an opaque panel so the graph-paper grid stays a surround, never a texture behind the words. */
	.bp-root .bp-titleblock { display: flex; justify-content: space-between; align-items: flex-start; gap: 18px; background: var(--bp-panel); border: 1px solid var(--bp-cell); border-radius: 10px; padding: 20px 22px; margin-bottom: 16px; flex-wrap: wrap; }
	.bp-root .bp-eyebrow { font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 2.5px; color: var(--bp-eye); text-transform: uppercase; }
	.bp-root .bp-h1 { font-size: 26px; font-weight: 600; margin: 5px 0 0; line-height: 1.2; overflow-wrap: anywhere; }
	.bp-root .bp-desc { color: #cfe0f6; font-size: 14.5px; line-height: 1.6; margin: 10px 0 0; max-width: 70ch; }
	.bp-root .bp-tb-side { display: flex; align-items: center; gap: 8px; flex: 0 0 auto; flex-wrap: wrap; justify-content: flex-end; }
	/* Badge and action buttons share one height so the title-block row lines up. */
	.bp-root .bp-status { display: inline-flex; align-items: center; height: 30px; box-sizing: border-box; font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 1.5px; text-transform: uppercase; color: var(--bp-acc); border: 1px solid var(--bp-acc); border-radius: 6px; padding: 0 11px; }
	.bp-root .bp-act { display: inline-flex; align-items: center; height: 30px; box-sizing: border-box; font: inherit; font-size: 13px; padding: 0 14px; border-radius: 7px; border: 1.5px solid var(--bp-acc); background: transparent; color: var(--bp-acc); cursor: pointer; text-decoration: none; white-space: nowrap; }
	.bp-root .bp-act:hover { background: rgba(240,196,74,0.14); }
	.bp-root .bp-act-ghost { border-color: var(--bp-cell); color: var(--bp-ink); }
	.bp-root .bp-act-ghost:hover { border-color: var(--bp-frame); background: rgba(150,180,220,0.12); }
	/* One set = one opaque panel with a title-block header; items flow inside it. */
	.bp-root .bp-group { border: 1px solid var(--bp-cell); border-radius: 10px; padding: 15px 20px 6px; margin-bottom: 14px; background: var(--bp-panel); }
	.bp-root .bp-group-head { display: flex; align-items: center; gap: 12px; margin-bottom: 2px; }
	.bp-root .bp-group-label { font-family: ui-monospace, Menlo, monospace; font-size: 12px; letter-spacing: 2px; text-transform: uppercase; color: var(--bp-eye); white-space: nowrap; }
	.bp-root .bp-group-rule { flex: 1 1 auto; height: 1px; background: var(--bp-cell); }
	.bp-root .bp-group-count { font-family: ui-monospace, Menlo, monospace; font-size: 12px; color: var(--bp-ink); }
	.bp-root .bp-artifacts { display: block; }
	.bp-root .bp-group-media .bp-artifacts { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 10px; margin-top: 12px; }
	/* Items flow, separated by hairline rules -- no box around each one, no repeated icon. */
	.bp-root .bp-artifact { display: block; padding: 12px 0; border-top: 1px solid var(--bp-cell); }
	.bp-root .bp-group-media .bp-artifact { border-top: 0; padding: 0; }
	.bp-root .bp-artifact-row { display: flex; align-items: baseline; gap: 10px; text-decoration: none; color: var(--bp-ink); }
	.bp-root .bp-artifact-t { flex: 1 1 auto; min-width: 0; font-size: 15px; font-weight: 600; color: var(--bp-ink); overflow-wrap: anywhere; }
	.bp-root .bp-artifact-row .bp-artifact-t { flex: 0 0 auto; }
	.bp-root .bp-artifact-sum { flex: 1 1 auto; font-size: 12.5px; color: #bcd0ec; line-height: 1.5; }
	.bp-root .bp-artifact-link:hover .bp-artifact-t { color: var(--bp-acc); }
	.bp-root .bp-pin { font-family: ui-monospace, Menlo, monospace; font-size: 9px; letter-spacing: 1px; color: var(--bp-acc); border: 1px solid var(--bp-acc); border-radius: 4px; padding: 1px 4px; margin-left: 7px; vertical-align: middle; }
	.bp-root .bp-media { margin: 0; border: 1px solid var(--bp-cell); border-radius: 8px; overflow: hidden; background: rgba(8,16,30,0.5); }
	.bp-root .bp-media img, .bp-root .bp-media video { display: block; width: 100%; height: 180px; object-fit: cover; background: #0b1525; }
	.bp-root .bp-media-video video { object-fit: contain; }
	.bp-root .bp-media figcaption { font-size: 11.5px; color: #bcd0ec; padding: 7px 10px; overflow-wrap: anywhere; }
	.bp-root .pict-icon { display: inline-flex; align-items: center; justify-content: center; }
	/* Unfolded view: the Unfold all / Fold all bar + the per-item accordions. */
	.bp-root .bp-foldbar { display: flex; align-items: center; gap: 10px; margin: 0 0 16px; }
	.bp-root .bp-foldbar-label { font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 1.6px; text-transform: uppercase; color: var(--bp-eye); }
	.bp-root .bp-foldbtn { margin-left: 0; font: inherit; font-size: 12px; padding: 4px 11px; border-radius: 6px; border: 1px solid var(--bp-cell); background: transparent; color: var(--bp-ink); cursor: pointer; }
	.bp-root .bp-foldbtn:first-of-type { margin-left: auto; }
	.bp-root .bp-foldbtn:hover { border-color: var(--bp-acc); color: var(--bp-acc); }
	/* A content item folds in place; its head is the item name, the body flows beneath. Flat, no box. */
	.bp-root .bp-artifact-head { display: flex; align-items: baseline; gap: 10px; cursor: pointer; list-style: none; user-select: none; }
	.bp-root .bp-artifact-head::-webkit-details-marker { display: none; }
	.bp-root .bp-artifact-open { flex: 0 0 auto; font-size: 11px; letter-spacing: 1px; text-transform: uppercase; color: var(--bp-eye); text-decoration: none; border: 1px solid var(--bp-cell); border-radius: 5px; padding: 2px 8px; }
	.bp-root .bp-artifact-open:hover { border-color: var(--bp-acc); color: var(--bp-acc); }
	.bp-root .bp-fold-chev { flex: 0 0 auto; color: var(--bp-eye); display: inline-flex; transition: transform 0.15s ease; }
	.bp-root .bp-artifact-fold[open] .bp-fold-chev { transform: rotate(180deg); }
	.bp-root .bp-artifact-content { margin-top: 8px; font-size: 13.5px; line-height: 1.62; color: #d6e4f7; overflow-wrap: anywhere; }
	/* Rendered Markdown (title-block description + unfolded content). */
	.bp-root .bp-md > :first-child { margin-top: 0; }
	.bp-root .bp-md > :last-child { margin-bottom: 0; }
	.bp-root .bp-md p { margin: 0 0 10px; }
	.bp-root .bp-md h1, .bp-root .bp-md h2, .bp-root .bp-md h3, .bp-root .bp-md h4, .bp-root .bp-md h5, .bp-root .bp-md h6 { font-family: ui-monospace, Menlo, monospace; font-weight: 600; letter-spacing: 0.4px; color: var(--bp-ink); line-height: 1.25; margin: 16px 0 8px; }
	.bp-root .bp-md h1 { font-size: 18px; } .bp-root .bp-md h2 { font-size: 16px; } .bp-root .bp-md h3 { font-size: 14px; }
	.bp-root .bp-md h4, .bp-root .bp-md h5, .bp-root .bp-md h6 { font-size: 13px; color: var(--bp-eye); }
	.bp-root .bp-md ul, .bp-root .bp-md ol { margin: 8px 0 10px; padding-left: 22px; }
	.bp-root .bp-md li { margin: 3px 0; }
	.bp-root .bp-md code { font-family: ui-monospace, Menlo, monospace; font-size: 0.9em; background: rgba(150,180,220,0.16); padding: 1px 5px; border-radius: 4px; }
	.bp-root .bp-md strong { font-weight: 600; color: #ffffff; }
	.bp-root .bp-md em { font-style: italic; }
	/* Print: a sharp paper drafting sheet. Light ink, no grid or interactive chrome,
	   every fold forced open, page breaks that never split a title block or an item. */
	@media print {
		.bp-root { padding: 0; max-width: none; }
		.bp-root .bp-sheet { background: #ffffff; background-image: none; border: 1px solid #26364f; border-radius: 0; color: #16233b; padding: 6mm; }
		.bp-root .bp-titleblock, .bp-root .bp-group { background: #ffffff; border: 1px solid #c4cfe0; border-radius: 0; break-inside: avoid; }
		.bp-root .bp-eyebrow, .bp-root .bp-group-label, .bp-root .bp-group-count { color: #46597a; }
		.bp-root .bp-h1, .bp-root .bp-desc, .bp-root .bp-artifact-t, .bp-root .bp-artifact-content, .bp-root .bp-artifact-sum, .bp-root .bp-md { color: #16233b; }
		.bp-root .bp-md strong { color: #000000; }
		.bp-root .bp-md code { background: #eef1f6; color: #16233b; }
		.bp-root .bp-group-rule, .bp-root .bp-artifact { border-color: #d5dded; }
		.bp-root .bp-status { color: #7a5b00; border-color: #b98f00; }
		.bp-root .bp-media { border-color: #c4cfe0; }
		.bp-root .bp-act, .bp-root .bp-foldbar, .bp-root .bp-fold-chev, .bp-root .bp-artifact-open { display: none !important; }
		.bp-root .bp-artifact-content { display: block !important; }
		.bp-root .bp-group-head { break-after: avoid; }
		.bp-root .bp-artifact, .bp-root .bp-media, .bp-root .bp-md h1, .bp-root .bp-md h2, .bp-root .bp-md h3 { break-inside: avoid; }
		.bp-root .bp-md h1, .bp-root .bp-md h2, .bp-root .bp-md h3, .bp-root .bp-md h4, .bp-root .bp-md h5, .bp-root .bp-md h6 { color: #22314c; }
	}
`;

// A complete standalone HTML page for the public /shared/:token view. Inlines the
// sheet CSS, a thin Plansheet bar, and a Copy-link button. No app bundle, no auth.
function renderPublicDocument(pData, pOpts)
{
	pOpts = pOpts || {};
	let tmpTitle = (pData && pData.Title) ? pData.Title : 'Blueprint';
	let tmpCopy = '<button class="bp-act" onclick="navigator.clipboard&&navigator.clipboard.writeText(location.href);this.textContent=\'Link copied\';">Copy link</button>';
	// THE DOWNLOAD, WHEN THIS LINK ACTUALLY GRANTS IT. PrintEnabled is a real, separate grant on the
	// share (WI #384), and the page offered no way to use it: a reader could only reach the PDF by
	// knowing the /Print URL and typing it. A grant nobody can exercise is the same as no grant.
	let tmpPrint = pOpts.printHref
		? ('<a class="bp-act" href="' + _esc(pOpts.printHref) + '">Download the sheet set (PDF)</a>')
		: '';
	let tmpSheet = renderSheet(pData, { mediaBase: pOpts.mediaBase, links: 'inert', actionsHTML: tmpPrint + tmpCopy });
	let tmpPageCSS = `
		html,body{margin:0;background:#0c1830;color:#eef4fc;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;}
		.bp-public-bar{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 26px;border-bottom:1px solid rgba(150,180,220,0.18);}
		.bp-public-brand{font-family:ui-monospace,Menlo,monospace;letter-spacing:2px;font-size:12px;color:#88a8d6;text-transform:uppercase;}
		.bp-public-tag{font-size:11px;color:#6f8cb6;letter-spacing:1px;text-transform:uppercase;}
		.bp-public-foot{text-align:center;color:#5d79a4;font-size:12px;padding:22px 10px 34px;}
		.bp-root{padding-top:26px;padding-bottom:6px;}
		@media print { html,body{background:#ffffff;} .bp-public-bar,.bp-public-foot{display:none;} .bp-root{padding:0;} }
	`;
	return '<!doctype html><html lang="en"><head><meta charset="utf-8">'
		+ '<meta name="viewport" content="width=device-width, initial-scale=1">'
		+ '<meta name="robots" content="noindex">'
		+ '<title>' + _esc(tmpTitle) + ' - Blueprint</title>'
		+ '<style>' + tmpPageCSS + SHEET_CSS + '</style></head>'
		+ '<body><div class="bp-public-bar"><span class="bp-public-brand">Plansheet</span><span class="bp-public-tag">Shared blueprint - read only</span></div>'
		+ '<div class="bp-root">' + tmpSheet + '</div>'
		+ '<div class="bp-public-foot">A read-only blueprint shared from Plansheet.</div>'
		+ '</body></html>';
}

/**
 * Wrap a rendered SHEET SET in the public chrome, for a login-free reader.
 *
 * The shared page shows the sheet set itself now, not a summary of it. It used to render the
 * blueprint's item groups while the PDF compiled the same blueprint into a document -- so the PDF
 * carried diagrams, provenance and addenda the page had never heard of, and a reader who downloaded it
 * got something that surprised them. Same compile, two presentations.
 *
 * The sheet HTML is a complete document with its own @page rules, so the chrome is INJECTED into it
 * rather than wrapping it: re-parenting paged-media CSS is how a sheet stops being the size it says it
 * is. The bar and the footer are hidden in print, so what comes out of a browser's own print dialog is
 * the sheet set and nothing else.
 */
function publicSheetPage(pSheetHTML, pOpts)
{
	let tmpOpts = pOpts || {};
	// THE PAPER PICKER IS FOR THE READER, not the owner. The person holding a share link is the one who
	// knows whether they are reading this on a laptop or pinning it to a wall, and the print route has
	// always taken sheet and reading as query parameters -- there was simply no control, so every
	// recipient got Letter whether or not it suited them.
	//
	// One select over Sheet/Reading PAIRS rather than two controls, because not every pairing is
	// printable: offering a reading its paper refuses produces a 400 the reader cannot act on.
	let tmpLayouts = Array.isArray(tmpOpts.layouts) ? tmpOpts.layouts : [];
	let tmpPicker = '';
	if (tmpOpts.printHref && tmpLayouts.length > 1)
	{
		tmpPicker = '<select class="bp-pub-act bp-pub-size" onchange="'
			+ 'var a=document.getElementById(\'bp-pub-dl\');'
			+ 'a.href=a.dataset.base+\'?\'+this.value;'
			// The first request for a paper renders it, which is not instant. Saying so beats a reader
			// clicking a link that appears to do nothing for several seconds.
			+ 'a.textContent=\'Download PDF\';">'
			+ tmpLayouts.map((pLayout, pIndex) =>
				'<option value="sheet=' + encodeURIComponent(pLayout.Sheet)
					+ '&amp;reading=' + encodeURIComponent(pLayout.Reading) + '"'
					+ (pIndex === 0 ? ' selected' : '') + '>' + _esc(pLayout.Label) + '</option>').join('')
			+ '</select>';
	}
	let tmpFirst = tmpLayouts.length
		? ('?sheet=' + encodeURIComponent(tmpLayouts[0].Sheet) + '&reading=' + encodeURIComponent(tmpLayouts[0].Reading))
		: '';
	let tmpDownload = tmpOpts.printHref
		? (tmpPicker + '<a class="bp-pub-act" id="bp-pub-dl" data-base="' + _esc(tmpOpts.printHref) + '" href="'
			+ _esc(tmpOpts.printHref + tmpFirst) + '">Download PDF</a>')
		: '';
	let tmpBar = '<div class="bp-pub-bar">'
		+ '<span class="bp-pub-brand">Plansheet</span>'
		+ '<span class="bp-pub-actions">' + tmpDownload
		+ '<button class="bp-pub-act" onclick="navigator.clipboard&&navigator.clipboard.writeText(location.href);'
		+ 'this.textContent=\'Link copied\';">Copy link</button></span></div>';
	let tmpCSS = '<style>'
		+ '.bp-pub-bar{position:sticky;top:0;z-index:9;display:flex;align-items:center;justify-content:space-between;'
		+ 'gap:12px;padding:10px 18px;background:#0c1830;color:#eef4fc;font-family:-apple-system,BlinkMacSystemFont,'
		+ '"Segoe UI",Roboto,Helvetica,Arial,sans-serif;}'
		+ '.bp-pub-brand{font-family:ui-monospace,Menlo,monospace;letter-spacing:2px;font-size:12px;color:#88a8d6;'
		+ 'text-transform:uppercase;}'
		+ '.bp-pub-actions{display:flex;gap:8px;}'
		+ '.bp-pub-act{font:inherit;font-size:12px;padding:6px 12px;border-radius:4px;border:1px solid rgba(150,180,220,0.4);'
		+ 'background:transparent;color:#cfe0f6;cursor:pointer;text-decoration:none;}'
		+ '.bp-pub-size{background:#0c1830;color:#cfe0f6;}'
		+ '@media print{.bp-pub-bar{display:none;}}'
		+ '</style>';
	let tmpHTML = String(pSheetHTML || '');
	// Injected rather than concatenated: the sheet document owns <html> and <head>, and its @page rules
	// have to stay where they are.
	let tmpHeadAt = tmpHTML.indexOf('</head>');
	if (tmpHeadAt >= 0) { tmpHTML = tmpHTML.slice(0, tmpHeadAt) + tmpCSS + tmpHTML.slice(tmpHeadAt); }
	let tmpBodyAt = tmpHTML.indexOf('<body');
	if (tmpBodyAt >= 0)
	{
		let tmpBodyEnd = tmpHTML.indexOf('>', tmpBodyAt);
		if (tmpBodyEnd >= 0) { tmpHTML = tmpHTML.slice(0, tmpBodyEnd + 1) + tmpBar + tmpHTML.slice(tmpBodyEnd + 1); }
	}
	return tmpHTML;
}

/**
 * A public, read-only web page for a DESIGNED layout (BlueprintLayout), as opposed to the compiled plate
 * set. It is the SAME renderSheet the studio and the PDF use -- so the shared page, the in-app page and
 * the print cannot disagree -- sized to read as a page on screen and wrapped in the public bar. The
 * drawing style rides on the layout (layout.Kit).
 *
 * pOpts.printHref  the public print route; when set, the bar offers a per-size Download PDF.
 * pOpts.title      the browser tab title.
 */
function renderPublicLayout(pLayout, pOpts)
{
	let tmpLibLayout = require('./BlueprintLayout.js');
	let tmpOpts = pOpts || {};
	let tmpKit = (pLayout && pLayout.Kit) || tmpOpts.kit || 'clean';
	let tmpGrid = (pLayout && pLayout.Grid) || { Cols: 12, Rows: 16 };
	// A responsive layout drops the fixed grid-aspect pin and takes a viewport-sized box, so its aspect follows
	// the monitor (landscape on a wide screen, portrait on a narrow one) and the @container query inside the
	// sheet switches the arrangement. .bpl is container-type:size and will not take height from its content, so
	// the box must carry a resolved height. A non-responsive layout keeps the exact fixed-aspect box as before.
	let tmpResponsive = (pLayout && pLayout.Responsive === true);
	let tmpBoxCSS = tmpResponsive
		? '.bp-pub-layout{width:min(100%,1180px);height:min(82vh,860px);box-shadow:0 14px 52px rgba(0,0,0,.36);}'
		: '.bp-pub-layout{width:100%;max-width:860px;aspect-ratio:' + tmpGrid.Cols + '/' + tmpGrid.Rows + ';box-shadow:0 14px 52px rgba(0,0,0,.36);}';
	// In print the sheet is WIDTH-DRIVEN: it fills the printable width and aspect-ratio derives a height a little
	// shorter than the page, so it never overflows onto a second sheet (Safari does not honour @page{margin:0} and
	// resolves vh against the screen, so neither a page-height nor 100vh is safe). A responsive layout prints at the
	// portrait sheet aspect; a fixed-aspect layout keeps its own grid proportions.
	let tmpPrintBox = tmpResponsive
		? '.bp-pub-layout{width:100% !important;height:auto !important;aspect-ratio:85 / 110;max-width:6.25in !important;margin:0 auto !important;box-shadow:none !important;}'
		: '.bp-pub-layout{width:100% !important;height:auto !important;aspect-ratio:' + tmpGrid.Cols + ' / ' + tmpGrid.Rows + ';max-width:6.25in !important;margin:0 auto !important;box-shadow:none !important;}';
	let tmpCSS = '<style>' + (tmpOpts.fontCSS || '') + tmpLibLayout.SHEET_CSS
		+ 'html,body{margin:0;background:#2a3344;}'
		+ '.bp-pub-stage{display:flex;justify-content:center;padding:28px 16px 64px;}'
		+ tmpBoxCSS
		// Width-driven so the sheet fits the real printable area in any engine; see renderPublicDeck for why a page
		// height (vh or inches) splits in Safari. The stage fills the printable width and the box derives its height.
		+ '@media print{@page{margin:0.25in;}html,body{background:#fff !important;margin:0;}'
		+ '.bp-pub-stage{width:100%;box-sizing:border-box;padding:0;display:flex;justify-content:center;align-items:flex-start;overflow:hidden;}' + tmpPrintBox + '}'
		+ '</style>';
	// Non-responsive keeps the exact fit script as before (run on parse + on fonts.ready). A responsive page
	// also re-fits on resize via a rAF-debounced ResizeObserver, because crossing 1:1 re-cells every text region.
	let tmpFit;
	if (tmpResponsive)
	{
		let tmpSrc = tmpLibLayout.fitLayout.toString();
		tmpFit = 'var fitLayout=' + tmpSrc + ';fitLayout(document);'
			+ 'if(document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){fitLayout(document);});}'
			+ 'window.addEventListener("beforeprint",function(){fitLayout(document);});'
			+ 'var _b=document.querySelector(".bp-pub-layout");if(_b&&typeof ResizeObserver==="function"){new ResizeObserver(function(){fitLayout(document);}).observe(_b);}';
	}
	else
	{
		tmpFit = '(' + tmpLibLayout.fitLayout.toString() + ')(document);'
			+ 'if(document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){(' + tmpLibLayout.fitLayout.toString() + ')(document);});}'
			+ 'window.addEventListener("beforeprint",function(){(' + tmpLibLayout.fitLayout.toString() + ')(document);});';
	}
	let tmpPage = '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">'
		+ '<title>' + _esc(tmpOpts.title || 'Blueprint') + '</title>' + tmpCSS + '</head><body>'
		+ '<div class="bp-pub-stage"><div class="bp-pub-layout">' + tmpLibLayout.renderSheet(pLayout, { Kit: tmpKit, Brand: tmpOpts.brand }) + '</div></div>'
		+ '<script>' + tmpFit + '</script></body></html>';
	return publicSheetPage(tmpPage, { printHref: tmpOpts.printHref, layouts: tmpOpts.layouts });
}

/**
 * A public, read-only DECK: several designed layouts presented as flip-through pages on one page. A set
 * blueprint (its layout carries an ordered Pages list of member blueprints) shares as this. Each page is the
 * SAME renderSheet every other surface uses, in its own viewport-sized responsive box, so a page reads
 * side-by-side on a wide monitor and stacked on a narrow one, exactly as it does on its own share link.
 *
 * Navigation is native horizontal scroll-snap (swipe / trackpad), plus prev/next buttons, page dots, a
 * counter and the arrow keys. Printing lays the pages out one per sheet.
 *
 * pPages  [{ Layout (object or JSON string), Name }]
 * pOpts.title  the browser tab title.
 */
function renderPublicDeck(pPages, pOpts)
{
	let tmpLibLayout = require('./BlueprintLayout.js');
	let tmpOpts = pOpts || {};
	let tmpPages = (Array.isArray(pPages) ? pPages : []).map((pPage) =>
	{
		let tmpLayout = pPage.Layout;
		if (typeof tmpLayout === 'string') { try { tmpLayout = JSON.parse(tmpLayout); } catch (pErr) { tmpLayout = null; } }
		return tmpLayout ? { Layout: tmpLayout, Name: pPage.Name || '' } : null;
	}).filter(Boolean);

	let tmpSlides = tmpPages.map((pPage, pIndex) =>
		'<section class="bp-deck-slide" data-i="' + pIndex + '">'
			+ '<div class="bp-deck-box">' + tmpLibLayout.renderSheet(pPage.Layout,
				{ Kit: pPage.Layout.Kit || 'clean', Page: { Index: pIndex + 1, Total: tmpPages.length }, Brand: tmpOpts.brand }) + '</div></section>').join('');

	let tmpDots = tmpPages.map((pPage, pIndex) =>
		'<button class="bp-deck-dot' + (pIndex === 0 ? ' is-on' : '') + '" data-i="' + pIndex + '" title="' + _esc(pPage.Name || ('Page ' + (pIndex + 1))) + '"></button>').join('');

	let fChevron = (pDir) => '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="'
		+ (pDir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6') + '"></polyline></svg>';

	let tmpCSS = '<style>' + (tmpOpts.fontCSS || '') + tmpLibLayout.SHEET_CSS
		+ 'html,body{margin:0;height:100%;background:#0c1830;color:#eef4fc;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;}'
		+ '.bp-deck-bar{position:sticky;top:0;z-index:9;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 18px;background:#0c1830;border-bottom:1px solid rgba(150,180,220,0.18);}'
		+ '.bp-deck-brand{font-family:ui-monospace,Menlo,monospace;letter-spacing:2px;font-size:12px;color:#88a8d6;text-transform:uppercase;}'
		+ '.bp-deck-mid{font-family:ui-monospace,Menlo,monospace;font-size:12px;color:#cfe0f6;letter-spacing:1px;}'
		+ '.bp-deck-acts{display:flex;align-items:center;gap:8px;}'
		+ '.bp-deck-act{font:inherit;font-size:12px;padding:6px 12px;border-radius:4px;border:1px solid rgba(150,180,220,0.4);background:transparent;color:#cfe0f6;cursor:pointer;text-decoration:none;}'
		+ '.bp-deck{display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scroll-behavior:smooth;height:calc(100vh - 45px);scrollbar-width:none;}'
		+ '.bp-deck::-webkit-scrollbar{display:none;}'
		+ '.bp-deck-slide{flex:0 0 100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:18px 16px 52px;}'
		+ '.bp-deck-box{width:min(100%,1180px);height:min(84vh,880px);box-shadow:0 14px 52px rgba(0,0,0,.36);}'
		+ '.bp-deck-nav{position:fixed;top:calc(50% + 22px);transform:translateY(-50%);z-index:10;width:42px;height:42px;border-radius:50%;border:1px solid rgba(150,180,220,0.4);background:rgba(12,24,48,0.82);color:#cfe0f6;display:flex;align-items:center;justify-content:center;cursor:pointer;}'
		+ '.bp-deck-nav:disabled{opacity:0.28;cursor:default;}'
		+ '.bp-deck-prev{left:14px;}.bp-deck-next{right:14px;}'
		+ '.bp-deck-dots{position:fixed;bottom:15px;left:0;right:0;z-index:10;display:flex;gap:8px;justify-content:center;}'
		+ '.bp-deck-dot{width:8px;height:8px;border-radius:50%;border:0;background:rgba(150,180,220,0.35);cursor:pointer;padding:0;}'
		+ '.bp-deck-dot.is-on{background:#8fd3ff;}'
		// The printed sheet is sized CONSERVATIVELY to clear Safari's print furniture, not to fill every inch.
		// Browser print cannot know the real printable area: Safari ignores @page{margin:0} (it clamps to the
		// printer's forced margins) and reserves more space again when "Print headers and footers" is on, so a
		// sheet sized to the full page -- whether by 100vh, an explicit height, or 100% of the printable width --
		// overflowed that furniture and spilled its bottom strip onto a second sheet. Instead the box is capped at
		// 6.25in wide and aspect-ratio derives a ~8.1in height, which fits inside Letter and A4 even with generous
		// forced margins AND headers/footers on, so one blueprint is always one sheet in every engine. The box is
		// deliberately well short of the page: a tighter fit tips the title-block strip onto a second sheet on a
		// printer that reserves more furniture. The Download PDF (server-rendered)
		// is the full-bleed output; this is the quick browser path. break-after keeps one per page; overflow clips.
		+ '@media print{@page{margin:0.25in;}html,body{background:#fff !important;margin:0;}'
		+ '.bp-deck-bar,.bp-deck-nav,.bp-deck-dots{display:none;}'
		+ '.bp-deck{display:block;overflow:visible;height:auto;}'
		+ '.bp-deck-slide{width:100%;box-sizing:border-box;padding:0;display:flex;justify-content:center;align-items:flex-start;overflow:hidden;break-inside:avoid;}'
		+ '.bp-deck-slide:not(:last-child){break-after:page;}'
		+ '.bp-deck-box{width:100% !important;height:auto !important;aspect-ratio:85 / 110;max-width:6.25in !important;margin:0 auto !important;box-shadow:none !important;}}'
		+ '</style>';

	let tmpScript = 'var fitLayout=' + tmpLibLayout.fitLayout.toString() + ';'
		+ 'function fitAll(){fitLayout(document);}fitAll();'
		+ 'if(document.fonts&&document.fonts.ready){document.fonts.ready.then(fitAll);}'
		// Re-fit when print is invoked: print re-sizes each sheet to the full page, which re-cells every text
		// region, so the on-screen fit is stale. beforeprint fires after print media applies, in time for the
		// snapshot (and covers the headless print-to-PDF path).
		+ 'window.addEventListener("beforeprint",fitAll);'
		+ 'var deck=document.getElementById("bp-deck"),dots=document.querySelectorAll(".bp-deck-dot");'
		+ 'var prev=document.getElementById("bp-deck-prev"),next=document.getElementById("bp-deck-next"),counter=document.getElementById("bp-deck-counter");'
		+ 'var n=deck.querySelectorAll(".bp-deck-slide").length,cur=0;'
		+ 'function go(i){cur=Math.max(0,Math.min(n-1,i));deck.scrollTo({left:cur*deck.clientWidth,behavior:"smooth"});sync();}'
		+ 'function sync(){cur=Math.round(deck.scrollLeft/Math.max(1,deck.clientWidth));for(var j=0;j<dots.length;j++){dots[j].classList.toggle("is-on",j===cur);}if(counter){counter.textContent=(cur+1)+" / "+n;}if(prev){prev.disabled=(cur<=0);}if(next){next.disabled=(cur>=n-1);}}'
		+ 'if(prev){prev.addEventListener("click",function(){go(cur-1);});}'
		+ 'if(next){next.addEventListener("click",function(){go(cur+1);});}'
		+ 'for(var k=0;k<dots.length;k++){(function(idx){dots[idx].addEventListener("click",function(){go(idx);});})(k);}'
		+ 'var st;deck.addEventListener("scroll",function(){clearTimeout(st);st=setTimeout(sync,90);});'
		+ 'document.addEventListener("keydown",function(e){if(e.key==="ArrowRight"){go(cur+1);}else if(e.key==="ArrowLeft"){go(cur-1);}});'
		// Re-fit SYNCHRONOUSLY on box resize (ResizeObserver fires after layout, before paint -- so this catches
		// the switch to print media and re-fits before the page is snapshotted, which a rAF-deferred fit misses in
		// headless print-to-PDF). fitLayout only scales text, never the box, so there is no observer loop. The
		// scroll-position restore stays rAF-debounced; it is a screen-only nicety.
		+ 'if(typeof ResizeObserver==="function"){var _rp=0;var ro=new ResizeObserver(function(){fitAll();if(_rp){return;}_rp=requestAnimationFrame(function(){_rp=0;deck.scrollLeft=cur*deck.clientWidth;});});document.querySelectorAll(".bp-deck-box").forEach(function(b){ro.observe(b);});}'
		+ 'sync();';

	// The whole deck prints server side (one headless render, one sheet per page), so the reader downloads a
	// PDF that reads whole in every browser rather than invoking their own Print, which in Firefox drops the
	// SVG line-work. The link is offered only when the share grants printing; without the grant the route
	// would 403 and a dead button is worse than none.
	let tmpDownload = tmpOpts.printHref
		? ('<a class="bp-deck-act" href="' + _esc(tmpOpts.printHref) + '">Download PDF</a>')
		: '';
	let tmpBar = '<div class="bp-deck-bar"><span class="bp-deck-brand">Plansheet</span>'
		+ '<span class="bp-deck-mid" id="bp-deck-counter">1 / ' + tmpPages.length + '</span>'
		+ '<span class="bp-deck-acts">' + tmpDownload
		+ '<button class="bp-deck-act" onclick="navigator.clipboard&&navigator.clipboard.writeText(location.href);this.textContent=\'Link copied\';">Copy link</button></span></div>';

	return '<!doctype html><html lang="en"><head><meta charset="utf-8">'
		+ '<meta name="viewport" content="width=device-width,initial-scale=1">'
		+ '<meta name="robots" content="noindex">'
		+ '<title>' + _esc(tmpOpts.title || 'Blueprint set') + '</title>' + tmpCSS + '</head><body>'
		+ tmpBar
		+ '<div class="bp-deck" id="bp-deck">' + tmpSlides + '</div>'
		+ '<button class="bp-deck-nav bp-deck-prev" id="bp-deck-prev" aria-label="Previous">' + fChevron('prev') + '</button>'
		+ '<button class="bp-deck-nav bp-deck-next" id="bp-deck-next" aria-label="Next">' + fChevron('next') + '</button>'
		+ '<div class="bp-deck-dots">' + tmpDots + '</div>'
		+ '<script>' + tmpScript + '</script></body></html>';
}

module.exports = { renderSheet, renderPublicDocument, publicSheetPage, renderPublicLayout, renderPublicDeck, SHEET_CSS, ICON_FOR, ICON_SVG };

},{"./BlueprintLayout.js":551}],553:[function(require,module,exports){
'use strict';

const libFrameworkClient = require('./providers/FrameworkClient.js');

/**
 * BlueprintShareUI
 * ----------------
 * The editor-only "share this blueprint" strip and its behavior, shared by the
 * full-page blueprint view and the compact in-detail blueprint block so the two
 * look and act the same. Pure string building + fetch helpers; the owning view
 * supplies _id, _share, render(), and pict.
 *
 * The strip carries its own classes (.bp-share*) and CSS so it works whether or
 * not it sits inside a .bp-root (the compact block does not).
 *
 * Each owning view defines five one-line delegates that the strip's buttons call:
 *   bpShareCreate / bpShareCopy / bpShareRegenerate / bpShareRevoke / bpShareSetExpiry
 */

const DURATIONS = [{ v: 0, l: 'No expiry' }, { v: 7, l: '7 days' }, { v: 30, l: '30 days' }, { v: 90, l: '90 days' }];

const _ICON_SHARROW = '<span class="pict-icon"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" x2="12" y1="2" y2="15"/></svg></span>';
const _ICON_GLOBE = '<span class="pict-icon"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18"/></svg></span>';
const _ICON_LOCK = '<span class="pict-icon"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg></span>';

function _escAttr(pStr)
{
	return String(pStr == null ? '' : pStr).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function shareURL(pState)
{
	if (!pState || !pState.ShareToken) { return ''; }
	let tmpOrigin = (typeof location !== 'undefined') ? location.origin : '';
	return tmpOrigin + (pState.SharePath || ('/shared/' + pState.ShareToken));
}

// The expiry preset that best matches the link's ExpiresAt (0 = no expiry).
function _selectedDays(pState)
{
	if (!pState || !pState.ExpiresAt) { return 0; }
	let tmpRemaining = Math.round((Date.parse(pState.ExpiresAt) - Date.now()) / 86400000);
	if (tmpRemaining <= 0) { return 0; }
	let tmpBest = 7;
	let tmpDelta = Infinity;
	[7, 30, 90].forEach((pD) => { let tmpDiff = Math.abs(pD - tmpRemaining); if (tmpDiff < tmpDelta) { tmpDelta = tmpDiff; tmpBest = pD; } });
	return tmpBest;
}

function _expirySelectHTML(pState, pSelfRef)
{
	let tmpSelected = _selectedDays(pState);
	let tmpOptions = DURATIONS.map((pD) => '<option value="' + pD.v + '"' + (pD.v === tmpSelected ? ' selected' : '') + '>' + pD.l + '</option>').join('');
	return '<span class="bp-share-exp-wrap">Expires <select class="bp-share-exp" onchange="' + pSelfRef + '.bpShareSetExpiry(this.value)">' + tmpOptions + '</select></span>';
}

/**
 * The "let readers print it" toggle (F-071, WI #384).
 *
 * A SECOND grant on the same link, not a display option. Reading the page and generating the printed
 * sheet set are different things: the set is compiled, which walks outward from the entity and follows
 * provenance back as far as the chain goes, so it can carry marks and titles the page itself never
 * shows. It is off by default and stays off through every other change to the link.
 *
 * It is absent, rather than disabled, on a blueprint that can never print from a public token -- a
 * curated one, whose pins are other people's artifacts. A switch that is present and does nothing
 * teaches people to distrust the switches that do.
 */
function _printToggleHTML(pState, pSelfRef)
{
	if (!pState || !pState.PrintAvailable) { return ''; }
	return '<label class="bp-share-print" title="Let anyone with this link generate the printed sheet set">'
		+ '<input type="checkbox"' + (pState.PrintEnabled ? ' checked' : '')
		+ ' onchange="' + pSelfRef + '.bpSharePrintEnabled(this.checked)"> Printable</label>';
}


/**
 * What version this link serves, and the way to move it.
 *
 * A READER OF THIS STRIP MUST BE ABLE TO SEE WHICH IT IS. A link that follows the live sheet and a
 * link frozen at Rev B behave completely differently for the person on the other end, and the
 * difference is invisible unless the strip says so. "Pinned to Rev B" is the normal case, because
 * creating a link freezes the sheet; a link that says "follows the live sheet" is either older than
 * versioning or was deliberately unpinned.
 */
function _versionHTML(pState, pSelfRef)
{
	if (!pState || !pState.Enabled) { return ''; }
	let tmpRev = String(pState.RevisionMark || '');
	if (Number(pState.IDBlueprintRevision) > 0)
	{
		return '<span class="bp-share-ver" title="Whoever opens this link sees the sheet as it was when the link was made, however far it has moved since">'
			+ 'Pinned to ' + (tmpRev ? ('Rev ' + _escAttr(tmpRev)) : 'a version')
			+ '<button class="bp-share-btn bp-share-btn-ghost" onclick="' + pSelfRef + '.bpShareRepin()"'
			+ ' title="Take a new version of the sheet as it is now and point this same link at it">'
			+ 'Send the current version</button></span>';
	}
	return '<span class="bp-share-ver bp-share-ver-live" title="This link shows whatever the sheet says today, so it changes as the work changes">'
		+ 'Follows the live sheet'
		+ '<button class="bp-share-btn bp-share-btn-ghost" onclick="' + pSelfRef + '.bpShareRepin()"'
		+ ' title="Freeze the sheet as it is now so this link stops changing">Freeze it</button></span>';
}

// The strip HTML. pSelfRef is the JS expression for the owning view, e.g.
// "_Pict.views['Plansheet-Blueprint']".
function stripHTML(pState, pSelfRef)
{
	if (pState && pState.Enabled && pState.ShareToken)
	{
		return '<div class="bp-share bp-share-on">'
			+ '<span class="bp-share-ic">' + _ICON_GLOBE + '</span>'
			+ '<span class="bp-share-lab">Public link on</span>'
			+ '<input class="bp-share-url" readonly value="' + _escAttr(shareURL(pState)) + '" onclick="this.select()">'
			+ '<button class="bp-share-btn" onclick="' + pSelfRef + '.bpShareCopy()">Copy</button>'
			+ '<button class="bp-share-btn" onclick="' + pSelfRef + '.bpShareCopyBadge()" title="Copy a Markdown blueprint badge for a README (npm / GitHub)">README badge</button>'
			+ _expirySelectHTML(pState, pSelfRef)
			+ '<button class="bp-share-btn bp-share-btn-ghost" onclick="' + pSelfRef + '.bpShareRegenerate()" title="Replace with a new link and disable the old one">' + _ICON_SHARROW + 'Regenerate</button>'
			+ '<button class="bp-share-btn bp-share-btn-ghost" onclick="' + pSelfRef + '.bpShareRevoke()">Turn off</button>'
			+ _printToggleHTML(pState, pSelfRef)
			+ _versionHTML(pState, pSelfRef)
			+ '<div class="bp-share-invite"><input class="bp-share-invite-to" placeholder="Email the link to someone..." onkeydown="if(event.key===\'Enter\'){' + pSelfRef + '.bpShareInvite();}"><button class="bp-share-btn" onclick="' + pSelfRef + '.bpShareInvite()">' + _ICON_SHARROW + 'Email it</button></div>'
		+ '</div>';
	}
	return '<div class="bp-share">'
		+ '<span class="bp-share-ic">' + _ICON_LOCK + '</span>'
		+ '<span class="bp-share-lab">This blueprint is private. Create a public link anyone can open without signing in.</span>'
		+ '<button class="bp-share-btn" onclick="' + pSelfRef + '.bpShareCreate()">' + _ICON_SHARROW + 'Create public link</button>'
	+ '</div>';
}

// ---- behavior (operates on the owning view) ----------------------------------
function _toast(pView, pMessage, pType)
{
	let tmpModal = pView.pict && pView.pict.views && pView.pict.views['Pict-Section-Modal'];
	if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'success' }); }
}

// Repaint after a state change via the view's own hook, so the full-page view can
// re-render cheaply while the compact block redraws only itself (no entity re-fetch).
function _repaint(pView)
{
	if (typeof pView._afterShareChange === 'function') { pView._afterShareChange(); }
	else { pView.render(); }
}

function _apply(pView, pState, pMessage)
{
	pView._share = pState;
	_repaint(pView);
	_toast(pView, pMessage);
}

// Which blueprint a strip is managing, as a BlueprintAPI subject.
//
// A strip used to sniff an entity key off its host view's private fields (_entityKey, else _key, else the
// literal 'WorkItem'). That was wrong in a way that did not look wrong: a blueprint addressed as itself
// produced /1.0/Blueprint/<id>/Blueprint/Share, which matches the generic wildcard share route, resolves
// the type through the Connections manifest, finds no 'Blueprint' key there, and answers a cheerful
// 200 { Exists: false } -- so the strip said "this blueprint is private" about a blueprint that might
// already be shared. A subject cannot express that mistake; the provider owns the address.
function _subject(pView, pID)
{
	let tmpAPI = pView && pView.pict && pView.pict.providers && pView.pict.providers.BlueprintAPI;
	if (!tmpAPI) { return null; }
	if (pView._subject && pView._subject.ID) { return pView._subject; }
	let tmpKey = (pView._entityKey || pView._key || '');
	if (tmpKey === 'Blueprint') { return tmpAPI.subjectForRecord(pID || pView._id); }
	return tmpAPI.subjectForEntity(tmpKey || 'WorkItem', pID || pView._id);
}

function _api(pPict) { return pPict && pPict.providers && pPict.providers.BlueprintAPI; }

// Share management runs in the authenticated app (the owner's share strip), so
// every call rides the shared RestClient and inherits session recovery.
function fetchState(pPict, pSubject)
{
	let tmpAPI = _api(pPict);
	return tmpAPI ? tmpAPI.shareState(pSubject) : Promise.resolve(null);
}

function _post(pPict, pSubject, pBody)
{
	let tmpAPI = _api(pPict);
	return tmpAPI ? tmpAPI.shareCreate(pSubject, pBody || {}).catch(() => null) : Promise.resolve(null);
}

function create(pView)
{
	_post(pView.pict, _subject(pView), {}).then((pD) => { if (pD && pD.ShareToken) { _apply(pView, pD, 'Public link created'); } else { _toast(pView, 'Could not create the link.', 'error'); } });
}

function setExpiry(pView, pDays)
{
	let tmpDays = parseInt(pDays, 10) || 0;
	_post(pView.pict, _subject(pView), { ExpiresInDays: tmpDays }).then((pD) => { if (pD && pD.ShareToken) { _apply(pView, pD, tmpDays > 0 ? 'Expiry set' : 'Expiry removed'); } else { _toast(pView, 'Could not update the expiry.', 'error'); } });
}

function setPrintEnabled(pView, pEnabled)
{
	let tmpEnabled = !!pEnabled;
	_post(pView.pict, _subject(pView), { PrintEnabled: tmpEnabled }).then((pD) =>
	{
		if (pD && pD.ShareToken) { _apply(pView, pD, tmpEnabled ? 'Readers can print this link' : 'Printing turned off for this link'); }
		else { _toast(pView, 'Could not change printing for the link.', 'error'); }
	});
}

function regenerate(pView)
{
	_post(pView.pict, _subject(pView), { Rotate: true }).then((pD) => { if (pD && pD.ShareToken) { _apply(pView, pD, 'New public link generated'); } else { _toast(pView, 'Could not regenerate the link.', 'error'); } });
}

function revoke(pView)
{
	_api(pView.pict).shareRevoke(_subject(pView)).catch(() => null)
		.then((pD) => { if (pD) { if (pView._share) { pView._share.Enabled = false; } _repaint(pView); _toast(pView, 'Public link turned off'); } else { _toast(pView, 'Could not turn off the link.', 'error'); } });
}

function copy(pView)
{
	let tmpURL = shareURL(pView._share);
	if (!tmpURL) { return; }
	if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(tmpURL); }
	_toast(pView, 'Public link copied');
}

// The Markdown for a README blueprint badge: the chip image (which mirrors the blueprint's style) linked
// to the public page. Paste into an npm or GitHub README; it needs no auth and caches as any badge does.
function copyBadge(pView)
{
	let tmpURL = shareURL(pView._share);
	if (!tmpURL) { return; }
	let tmpName = (pView._data && (pView._data.Title || pView._data.Name)) || 'Blueprint';
	let tmpMarkdown = '[![' + tmpName + ' blueprint](' + tmpURL + '/chip.svg)](' + tmpURL + ')';
	if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
	{
		navigator.clipboard.writeText(tmpMarkdown).then(() => _toast(pView, 'README badge copied -- paste it into a README')).catch(() => _toast(pView, tmpMarkdown, 'info'));
	}
	else { _toast(pView, tmpMarkdown, 'info'); }
}

// Email the public link to someone. Ensures a share exists server-side and sends
// the blueprint-invite template; the message goes to the dev log unless a real
// email provider is configured.
function invite(pView)
{
	let tmpEl = (typeof document !== 'undefined') ? document.getElementById('bp-share-invite-to') : null;
	let tmpEmail = tmpEl ? String(tmpEl.value || '').trim() : '';
	if (!tmpEmail || tmpEmail.indexOf('@') < 1) { _toast(pView, 'Enter an email address.', 'error'); return; }
	_api(pView.pict).shareInvite(_subject(pView), { Email: tmpEmail })
		.then((pD) =>
		{
			if (pD && pD.Success) { if (tmpEl) { tmpEl.value = ''; } _toast(pView, 'Invite sent to ' + tmpEmail); }
			else { _toast(pView, 'Could not send the invite.', 'error'); }
		}).catch(() => _toast(pView, 'Could not send the invite.', 'error'));
}

const SHARE_CSS = /*css*/`
	.bp-share { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin: 0 0 12px; padding: 10px 14px; border: 1px solid rgba(150,180,220,0.3); border-radius: 9px; background: rgba(8,16,30,0.42); color: #cfe0f6; font-size: 13px; }
	.bp-share .pict-icon { display: inline-flex; align-items: center; justify-content: center; }
	.bp-share-ic { color: #88a8d6; display: inline-flex; align-items: center; flex: 0 0 auto; }
	.bp-share-on .bp-share-ic { color: #f0c44a; }
	.bp-share-lab { flex: 1 1 200px; min-width: 120px; line-height: 1.4; }
	.bp-share-on .bp-share-lab { flex: 0 0 auto; font-family: ui-monospace, Menlo, monospace; letter-spacing: 1px; text-transform: uppercase; font-size: 11px; color: #f0c44a; }
	.bp-share-url { flex: 1 1 220px; min-width: 120px; height: 30px; box-sizing: border-box; background: #0c1830; border: 1px solid rgba(208,226,247,0.4); border-radius: 6px; color: #eef4fc; padding: 0 9px; font-size: 12px; font-family: ui-monospace, Menlo, monospace; }
	.bp-share-exp-wrap { display: inline-flex; align-items: center; gap: 5px; font-size: 12px; color: #9fb6d6; }
	.bp-share-print { display: inline-flex; align-items: center; gap: 5px; font-size: 12px; color: #9fb6d6; cursor: pointer; white-space: nowrap; }
	.bp-share-print input { accent-color: #f0c44a; cursor: pointer; }
	.bp-share-exp { height: 30px; box-sizing: border-box; background: #0c1830; border: 1px solid rgba(208,226,247,0.4); border-radius: 6px; color: #eef4fc; padding: 0 6px; font-size: 12px; }
	.bp-share-btn { display: inline-flex; align-items: center; gap: 6px; height: 30px; box-sizing: border-box; padding: 0 12px; border-radius: 7px; border: 1.5px solid #f0c44a; background: transparent; color: #f0c44a; cursor: pointer; font: inherit; font-size: 12.5px; white-space: nowrap; text-decoration: none; }
	.bp-share-btn:hover { background: rgba(240,196,74,0.14); }
	.bp-share-btn .pict-icon { font-size: 15px; }
	.bp-share-btn-ghost { border-color: rgba(150,180,220,0.4); color: #cfe0f6; }
	.bp-share-ver { display: inline-flex; align-items: center; gap: 7px; font-size: 12px; color: #f0c44a; white-space: nowrap; }
	.bp-share-ver-live { color: #9fb6d6; }
	.bp-versions { margin: 0 0 12px; padding: 10px 14px; border: 1px solid rgba(150,180,220,0.3); border-radius: 9px; background: rgba(8,16,30,0.42); color: #cfe0f6; font-size: 13px; }
	.bp-versions-head { font-family: ui-monospace, Menlo, monospace; letter-spacing: 1px; text-transform: uppercase; font-size: 11px; color: #f0c44a; margin: 0 0 7px; }
	.bp-versions-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 5px; }
	.bp-ver { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; padding: 4px 0; border-top: 1px solid rgba(150,180,220,0.14); }
	.bp-ver:first-child { border-top: 0; }
	.bp-ver-mark { font-family: ui-monospace, Menlo, monospace; color: #f0c44a; flex: 0 0 auto; }
	.bp-ver-when { color: #9fb6d6; font-size: 12px; }
	.bp-ver-to, .bp-ver-n { color: #7f97b8; font-size: 12px; }
	.bp-ver-open { margin-left: auto; color: #cfe0f6; text-decoration: none; border: 1.5px solid rgba(150,180,220,0.4); border-radius: 7px; padding: 2px 11px; font-size: 12.5px; }
	.bp-ver-open:hover { background: rgba(240,196,74,0.14); border-color: #f0c44a; color: #f0c44a; }
	.bp-share-btn-ghost:hover { border-color: rgba(208,226,247,0.6); background: rgba(150,180,220,0.12); }
	.bp-share-invite { flex: 1 1 100%; display: flex; gap: 6px; margin-top: 4px; }
	.bp-share-invite-to { flex: 1 1 200px; min-width: 140px; height: 30px; box-sizing: border-box; background: #0c1830; border: 1px solid rgba(208,226,247,0.4); border-radius: 6px; color: #eef4fc; padding: 0 9px; font-size: 12px; }
`;


/**
 * Take a version of the sheet as it is now, and point this same link at it.
 *
 * SAME LINK, NEW CONTENTS, ON PURPOSE. The alternative -- mint a fresh link for every update -- means
 * a customer collects a pile of URLs and has to be told which is current. Here the URL they already
 * have starts showing the newer version the moment somebody decides it should.
 */
function repin(pView)
{
	let tmpAPI = _api(pView.pict);
	if (!tmpAPI) { return Promise.resolve(null); }
	_toast(pView, 'Taking a version...');
	// THE BLUEPRINT ROW, not the subject. A Feature and its blueprint are different ids, and versioning
	// the subject would file the snapshot where nothing looks for it. The share state carries the row id
	// precisely so callers do not have to guess.
	let tmpIDBlueprint = Number(pView._share && pView._share.IDBlueprint) || 0;
	if (!tmpIDBlueprint) { return Promise.resolve(_toast(pView, 'No sheet to version yet.', 'error')); }
	return tmpAPI.takeVersion(tmpIDBlueprint)
		.then((pTaken) =>
		{
			let tmpID = Number(pTaken && pTaken.Version && pTaken.Version.IDBlueprintRevision) || 0;
			if (!tmpID) { throw new Error('no version came back'); }
			return _post(pView.pict, _subject(pView), { IDBlueprintRevision: tmpID })
				.then((pState) => _apply(pView, pState, 'This link now serves Rev ' + (pTaken.Revision || '')));
		})
		.catch(() => _toast(pView, 'Could not take a version of this sheet.', 'error'));
}

module.exports = { repin, setPrintEnabled, stripHTML, shareURL, fetchState, create, setExpiry, regenerate, revoke, copy, copyBadge, invite, SHARE_CSS, DURATIONS };

},{"./providers/FrameworkClient.js":576}],554:[function(require,module,exports){
'use strict';

/**
 * CandidateSearch
 * ---------------
 * A reusable server-backed candidate search for record pickers (WI #445 -- split 1 of #434). A picker
 * that builds its options from a provider's store().List only ever offers the ONE PAGE that store holds
 * (WI #433); the Blueprint "pin an item" picker is the worst case, because it has a search box that
 * types like a live search and only ever searches what happens to be loaded. A miss then reads as "that
 * record does not exist" rather than "that record is not loaded". Prod holds 1,075 blueprints.
 *
 * THE TRAP THIS EXISTS TO AVOID (see FocusQuery.js's own note). foxhound quotes whatever field name it
 * is handed, so a filter built against a column an entity does not have compiles to a query Postgres
 * refuses outright -- a 500 on the first keystroke, on nearly every entity in the app. There is exactly
 * one column every entity descriptor DECLARES for this purpose: TitleField, the same field
 * PictView-EntityDetail._label() and _rebuild() already read to show a row's name. So this searches that
 * column, and only that column -- declared, not guessed.
 *
 * resolve(), NOT list(). Pict-Provider-EntityAPI.resolve() asks the server the identical
 * Page/PageSize/Filter question list() does, but merges the rows into the provider's Index alone,
 * leaving List/Page/PageCount/QueryKey untouched (WI #447). A picker mounted on a page that also hosts a
 * list screen -- exactly the Blueprint detail page -- must not have its search box quietly reset that
 * screen back to page one every time someone types a letter.
 *
 * Wires directly onto pict-section-picker's DataProvider/ResolveValue contract, so a caller gets server
 * search, built-in debounce, and "load more" paging for free:
 *
 *   mountPicker('#host', 'MyPicker', [], onChange,
 *     {
 *       DataProvider: libCandidateSearch.dataProviderFor(provider, descriptor),
 *       ResolveValue: libCandidateSearch.resolveValueFor(provider, descriptor)
 *     });
 *
 * WI #446 adds two things the seven remaining call sites needed that the Blueprint pin picker (WI #445)
 * did not:
 *
 *   - An exclude list (dataProviderFor's 4th arg): an "add a link" picker must not offer a record that
 *     is already linked, or (a self-referencing relation, e.g. Related visions) the record itself. The
 *     old code filtered these out of the loaded page client-side; a server search still can, by id,
 *     against whatever page comes back.
 *   - Multi-type search (searchTypes/dataProviderForTypes/resolveValueForTypes): the "spawn work item"
 *     target picker searches Feature, Vision and Module at once, Value carrying the type ("Feature:12")
 *     the way its precomputed Options list always did. Each type is searched independently against its
 *     own TitleField and merged, so this is still one column per query, never a guess.
 */

// pict-section-picker's own default (see its README); kept in step rather than re-derived per caller.
const _PAGE_SIZE = 20;

/** Tildes separate FocusQuery-style stanzas; a search term carrying one would split into a different filter. */
function _safe(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/~/g, ' ');
}

/**
 * One page of candidates for pEntity, filtered to pTerm against its descriptor-declared TitleField.
 *
 * @param {object} pProvider    A Pict-Provider-EntityAPI instance (or subclass) -- must expose resolve().
 * @param {object} pDescriptor  The entity's EntityDescriptors.Entities[...] entry.
 * @param {string} pTerm        The search box text. Empty returns the first page, unfiltered.
 * @param {number} pPage        Zero-based page index (pict-section-picker's DataProvider convention).
 * @param {number} [pPageSize]  Rows per page. Defaults to pict-section-picker's own default.
 * @param {string[]} [pExcludeIDs]  Ids to drop from the results (already linked, or the record itself).
 * @return {Promise<{results: Array<{Value:string, Text:string}>, hasMore: boolean}>}
 */
function search(pProvider, pDescriptor, pTerm, pPage, pPageSize, pExcludeIDs)
{
	let tmpDescriptor = pDescriptor || {};
	let tmpTitleField = tmpDescriptor.TitleField;
	let tmpIDField = tmpDescriptor.IDField;
	// No provider, or a descriptor that (unusually) declares neither field: there is nothing safe to ask
	// the server, so answer "nothing found" rather than guess a column name and risk the 500 above.
	if (!pProvider || (typeof pProvider.resolve !== 'function') || !tmpTitleField || !tmpIDField)
	{
		return Promise.resolve({ results: [], hasMore: false });
	}
	let tmpPageSize = Math.max(1, Number(pPageSize) || _PAGE_SIZE);
	let tmpTerm = String(pTerm || '').trim();
	let tmpFilter = tmpTerm ? ('FBV~' + tmpTitleField + '~LK~%' + _safe(tmpTerm) + '%') : '';
	// DataProvider's page is zero-based; the provider's own Page option is one-based (matches its list()).
	let tmpPage = Math.max(1, (Number(pPage) || 0) + 1);
	let tmpExclude = Array.isArray(pExcludeIDs) ? pExcludeIDs.map(String) : [];
	return pProvider.resolve({ Page: tmpPage, PageSize: tmpPageSize, Filter: tmpFilter })
		.then((pRows) =>
		{
			let tmpRows = Array.isArray(pRows) ? pRows : [];
			let tmpResults = tmpRows
				.filter((pRow) => tmpExclude.indexOf(String(pRow[tmpIDField])) < 0)
				.map((pRow) =>
					({ Value: String(pRow[tmpIDField]), Text: pRow[tmpTitleField] || ('#' + pRow[tmpIDField]) }));
			// resolve() carries no server Total (that is the point of it -- WI #447). A full page is the
			// same "there may be more" signal EntityAPI._listAll's own short-page stop condition uses,
			// read the other way round: a page that came back short is the last one. (The exclude filter
			// runs after that check, so a page shortened only by exclusions still offers a next page.)
			return { results: tmpResults, hasMore: tmpRows.length >= tmpPageSize };
		});
}

/** Bind a ready-to-use DataProvider closure for one entity -- hand straight to mountPicker/createPicker. */
function dataProviderFor(pProvider, pDescriptor, pPageSize, pExcludeIDs)
{
	return function (pTerm, pPage) { return search(pProvider, pDescriptor, pTerm, pPage, pPageSize, pExcludeIDs); };
}

/**
 * Resolve the display label for a value a picker was mounted with (a pending selection carried across a
 * re-render). Checks the provider's own Index first -- resolve()/cacheRecord() already merge search
 * results there -- and only reaches for a direct read() when this id never came back from a search.
 */
function resolveValueFor(pProvider, pDescriptor)
{
	return function (pValue)
	{
		let tmpDescriptor = pDescriptor || {};
		let tmpStore = (pProvider && typeof pProvider.store === 'function') ? pProvider.store() : null;
		let tmpCached = (tmpStore && tmpStore.Index) ? tmpStore.Index[pValue] : null;
		if (tmpCached) { return Promise.resolve({ Value: String(pValue), Text: tmpCached[tmpDescriptor.TitleField] || ('#' + pValue) }); }
		if (!pProvider || (typeof pProvider.read !== 'function')) { return Promise.resolve({ Value: String(pValue), Text: '#' + pValue }); }
		return pProvider.read(pValue).then((pRecord) =>
			({ Value: String(pValue), Text: (pRecord && pRecord[tmpDescriptor.TitleField]) || ('#' + pValue) }));
	};
}

/**
 * The same search, fanned out across several entity types at once and merged into one result list --
 * the "spawn a work item" target picker's shape (Feature, Vision or Module, one combined list). Each
 * type is queried for the same page/term independently against its OWN TitleField; Value carries the
 * type so the caller can split it back out ("Feature:12"), matching the precomputed-Options format this
 * replaces.
 *
 * @param {Array<{Type:string, Provider:object, Descriptor:object}>} pTypes
 * @param {string} pTerm
 * @param {number} pPage
 * @param {number} [pPageSizePerType]  Rows per page, PER TYPE (so 3 types page 20 each, not 20 total).
 * @return {Promise<{results: Array<{Value:string, Text:string}>, hasMore: boolean}>}
 */
function searchTypes(pTypes, pTerm, pPage, pPageSizePerType)
{
	let tmpTypes = Array.isArray(pTypes) ? pTypes : [];
	return Promise.all(tmpTypes.map((pType) =>
		search(pType.Provider, pType.Descriptor, pTerm, pPage, pPageSizePerType).then((pResult) =>
			({
				hasMore: pResult.hasMore,
				results: pResult.results.map((pRow) =>
					({ Value: pType.Type + ':' + pRow.Value, Text: pRow.Text + '  -  ' + pType.Type }))
			}))))
		.then((pPerType) =>
			({
				results: pPerType.reduce((pAcc, pOne) => pAcc.concat(pOne.results), []),
				hasMore: pPerType.some((pOne) => pOne.hasMore)
			}));
}

/** Bind a ready-to-use multi-type DataProvider closure -- hand straight to mountPicker/createPicker. */
function dataProviderForTypes(pTypes, pPageSizePerType)
{
	return function (pTerm, pPage) { return searchTypes(pTypes, pTerm, pPage, pPageSizePerType); };
}

/** resolveValueFor's multi-type counterpart: pValue is "Type:id", routed to that type's own resolver. */
function resolveValueForTypes(pTypes)
{
	return function (pValue)
	{
		let tmpParts = String(pValue || '').split(':');
		let tmpType = tmpParts[0];
		let tmpID = tmpParts[1];
		let tmpMatch = (Array.isArray(pTypes) ? pTypes : []).find((pType) => pType.Type === tmpType);
		if (!tmpMatch) { return Promise.resolve({ Value: String(pValue), Text: '#' + pValue }); }
		return resolveValueFor(tmpMatch.Provider, tmpMatch.Descriptor)(tmpID).then((pResolved) =>
			({ Value: String(pValue), Text: pResolved.Text + '  -  ' + tmpType }));
	};
}

module.exports =
{
	search, dataProviderFor, resolveValueFor,
	searchTypes, dataProviderForTypes, resolveValueForTypes,
	_safe, PAGE_SIZE: _PAGE_SIZE
};

},{}],555:[function(require,module,exports){
'use strict';

/**
 * Shared, declarative description of the Phase-1/2 SDLC entities. One place to
 * say "a Vision has these columns, these editable fields, and these
 * relationships" — the generic providers, the EntityList view, the Board view,
 * and the EntityDetail view all read from here.
 *
 * Field shape:    { F: column, L: label, T: 'text'|'textarea'|'select'|'likert', O: [options] }
 *                 (Markdown: true renders the field's value as markdown on the detail page;
 *                  'likert' is a 0-5 score where 0 means unanswered)
 * Column shape:   { F, L, Fmt?: (row) => string, Badge?: true, DefaultHidden?: true, Key?: true }
 *                 A list has two modes, and each one is just its own set of visible columns:
 *                   table    the full intersection. Everything except DefaultHidden columns.
 *                   concise  the scan. The mark, the title, and the Key columns, nothing else.
 *                 So DefaultHidden is the table-mode default and Key is the concise-mode default.
 *                 Either can be overridden per user from the column picker, which edits whichever
 *                 mode is on screen; that is also how a person adds a column back into concise to
 *                 cross-reference something for a minute. The NumberField column (which renders as
 *                 the entity's mark, WI-014) and the TitleField column are always shown in both:
 *                 identity and name are not optional.
 *                 Badge tint: Badge with Tint?: (row) => '#hex' colors the pill.
 *                 Rich, view-resolved columns (the EntityList view fills these from
 *                 caches it prefetches): Assignee?: true (IDAssignedUser -> avatar +
 *                 name, hexagon for an AI agent), Target?: true (TargetType + the
 *                 typed FK -> the target's name), Sessions?: true (a linked-session
 *                 count the view stamps onto _SessionCount).
 * Relation shape: { Render: 'fk'|'link'|'inverse-fk'|'inverse-join'|'target', Label, ... }
 *                 (inverse-fk extras: SubField names the chip's sub-label column;
 *                  Create: { Label, Prefill } adds a create-from-here feedback button)
 *
 * Entity flags: NumberField (per-customer human number, shown in the detail title),
 * Moodboard / Comments / Steps (embedded sections on the detail page), NoCreate
 * (list hides "+ New"), HeaderActions ([{ Label, Method }] dispatched to the app).
 *
 * DefaultSort is not optional. Meadow returns rows oldest-first, so a list without one lands with
 * the newest thing at the bottom of the page, which is never what a person wants. Every list that
 * carries Columns declares one, and a test enforces it. Prefer a real date column where the list
 * shows one, and the entity's own number descending otherwise, so the ordering is legible in a
 * column the reader can actually see.
 *
 * Filter is the focus bar. Declare it to shape the bar by hand (WorkItem, Vision, Feedback); leave
 * it off and the list still gets a bar derived from its own Fields (text search, plus Status / Type
 * / Priority facets where those are select fields). Set it to false to opt out entirely.
 */

// The default board lanes. This is now a SEED, not the runtime source: a lane
// store (the BoardLane table) is seeded from this set on a tenant's first board
// load, and administrators manage the live set from Settings. The board and its
// API provider read the store; this array is the fallback when the store has no
// lanes yet (fresh install, or a non-authenticated/unit-test context). A future
// retold-workflow (P6) supplies workflow-definition-derived lanes to the same
// store rather than replacing this seam.
//
// Each lane carries a stable Key (the Status token stored on cards), a display
// Label (the Status enum is single-token 'InProgress'; the board renders the
// label so it reads "In Progress"), a Color, and IsTerminal (the Done-equivalent
// lane). Blocked lives at the end, not mid-flow: most cards never block, so it
// stays out of the natural Backlog -> ... -> Done reading order.
const DefaultBoardLanes =
[
	{ Key: 'Backlog',    Label: 'Backlog',     Color: '#8a94a6', IsTerminal: false },
	{ Key: 'Todo',       Label: 'Todo',        Color: '#5b6376', IsTerminal: false },
	{ Key: 'InProgress', Label: 'In Progress', Color: '#2988df', IsTerminal: false },
	{ Key: 'Review',     Label: 'Review',      Color: '#d99366', IsTerminal: false },
	{ Key: 'Done',       Label: 'Done',        Color: '#3fae6b', IsTerminal: true },
	{ Key: 'Blocked',    Label: 'Blocked',     Color: '#d0555b', IsTerminal: false }
];
// Back-compat views over the default set. BoardLanes (keys, in order) still feeds
// the Status <select> options on the entity detail editors; BoardLaneLabels maps
// key -> label. Derived so the seed stays the single source of truth.
const BoardLanes = DefaultBoardLanes.map((pLane) => pLane.Key);
const BoardLaneLabels = DefaultBoardLanes.reduce((pMap, pLane) => { pMap[pLane.Key] = pLane.Label; return pMap; }, {});

const Priorities = ['Low', 'Normal', 'High', 'Urgent'];
const WorkItemTypes = ['Triage', 'Research', 'Innovation', 'Issue', 'Debt', 'Enhancement'];
// The compact icon per WorkItem type: the Type column renders a glyph (with the type name as a
// tooltip) instead of the word, so a dense list spends its width on the Title. Glyphs are
// registered in PlansheetIcons; a type with no mapping falls back to its text in the cell.
const WorkItemTypeIcons = { Triage: 'Funnel', Research: 'Microscope', Innovation: 'Lightbulb', Issue: 'Bug', Debt: 'Hourglass', Enhancement: 'Sparkles' };
// The compact icon per Feedback source type (same idea as WorkItemTypeIcons): the Source column
// renders a glyph in place of a long phrase like "Customer Conversation", which is what made that
// column so wide (#252). A source with no mapping falls back to its text; the list's expanded
// density brings the words back alongside the glyph.
const FeedbackSourceIcons = { 'Test Run': 'Flask', 'Customer Conversation': 'Comments', 'Developer Experience': 'Terminal', 'Field Trial': 'Building', 'Other': 'Feather' };
const RelationTypes = ['DependsOn', 'Refines', 'Supersedes', 'Relates'];
const WorkOutcomes = ['Unknown', 'Delivered', 'Partial', 'Abandoned'];
// Why a Work Item did not pass QC when it is kicked back from Review. Rides on the
// qc.failed WorkEvent payload and drives the "Send back" reason picker.
const QCReasonCodes = ['Incomplete', 'Defect', 'WrongApproach', 'NeedsTests', 'NeedsDocs', 'CannotReproduce', 'Other'];
const MediaTypes = ['Screenshot', 'Photo', 'Drawing', 'Recording', 'HowTo', 'Other'];

// User Tasks kit vocabularies (V50). Status gates catalog visibility (only Active tasks are offered to
// users); OutcomeKind tells the UI how to render an answer.
const TaskStatuses = ['Draft', 'Active', 'Retired'];
const TaskOutcomeKinds = ['text', 'markdown', 'table', 'number', 'document', 'link'];
// A Request walks Pending -> Running as its node run works, then Answered on success (or Failed / Cancelled).
const RequestStatuses = ['Pending', 'Running', 'Answered', 'Failed', 'Cancelled'];

// Product Testing kit vocabularies. TestRunStep outcomes also allow '' (pending).
const RoutineStatuses = ['Draft', 'Active', 'Retired'];
const TestRunStatuses = ['In Progress', 'Passed', 'Failed', 'Abandoned'];
const TestRunStepOutcomes = ['Passed', 'Failed', 'Skipped'];
// The lifecycle of an As-Built: Built (session finished, image made) -> Deployed (running on dev) ->
// Validated (a passing dev TestRun of its routine) -> Promoted (that image digest pushed to prod).
// Superseded marks an older As-Built for the same work when a newer one takes its place.
// Delivered is the terminal state for work that shipped but does not ride this deploy pipeline: a
// commit landed in a sibling workspace can never be an ancestor of an app ref, so left at Built it
// would wait forever on a dev deploy that cannot pick it up. It is delivered, not retired, which is
// why Superseded was the wrong word for it.
const AsBuiltStatuses = ['Built', 'Deployed', 'Validated', 'Promoted', 'Superseded', 'Delivered'];
// A deploy request the Releases page queues and the executor runs: Requested -> Running -> Succeeded | Failed.
const DeployRequestStatuses = ['Requested', 'Running', 'Succeeded', 'Failed', 'Cancelled'];
// A registered node: Active claims work, Suspended claims nothing (WI #305, Feature 168).
const NodeRegistrationStatuses = ['Pending', 'Active', 'Suspended', 'Revoked'];
const WorkspaceStatuses = ['Active', 'Retired'];
// Standalone: its own clone, from RepoURL. MonorepoPath: a repository living at RepoPath inside the checkout
// of another workspace -- the shape that lets ONE root on a node cover every module in a monorepo.
const WorkspaceCheckoutStrategies = ['Standalone', 'MonorepoPath'];
// Read the roles a node published in its CapabilityJSON, for the list column.
const nodeRolesSummary = (pRow) =>
{
	try { let tmpCapability = JSON.parse(pRow.CapabilityJSON || '{}'); return (Array.isArray(tmpCapability.Roles) ? tmpCapability.Roles : []).join('+'); }
	catch (pError) { return ''; }
};
const nodeWorkspacesSummary = (pRow) =>
{
	try { let tmpCapability = JSON.parse(pRow.CapabilityJSON || '{}'); return (Array.isArray(tmpCapability.Workspaces) ? tmpCapability.Workspaces : []).join(', '); }
	catch (pError) { return ''; }
};
// Where this node says its checkouts are (WI #456). The plan sheet declares WHAT its repositories are; this
// is the per-node half -- WHERE they live on that machine -- so an operator maps one from this screen instead
// of SSH-ing in to edit agent-runner.json.
const nodeWorkspacePathsSummary = (pRow) =>
{
	try
	{
		let tmpCapability = JSON.parse(pRow.CapabilityJSON || '{}');
		let tmpPaths = tmpCapability.WorkspacePaths || {};
		return Object.keys(tmpPaths).map((pKey) =>
		{
			let tmpEntry = tmpPaths[pKey];
			return pKey + ' -> ' + ((typeof tmpEntry === 'string') ? tmpEntry : String((tmpEntry || {}).Path || ''));
		}).join(', ');
	}
	catch (pError) { return ''; }
};

// What this node was told about and could NOT find. The reason WI #456 exists: this used to be a line in a
// log on the box, so a declared gate sat inert for a day while the board said the work was Done. On screen it
// is the one thing an operator needs to see about a node that looks healthy and is not doing what was asked.
const nodeUnresolvedSummary = (pRow) =>
{
	try
	{
		let tmpCapability = JSON.parse(pRow.CapabilityJSON || '{}');
		let tmpUnresolved = Array.isArray(tmpCapability.UnresolvedWorkspaces) ? tmpCapability.UnresolvedWorkspaces : [];
		if (!tmpUnresolved.length) { return ''; }
		return tmpUnresolved.map((pEntry) => String((pEntry || {}).Key || '')).filter((pKey) => pKey).join(', ');
	}
	catch (pError) { return ''; }
};

const FeedbackSourceTypes = ['Test Run', 'Customer Conversation', 'Developer Experience', 'Field Trial', 'Other'];
const KeystoneCustomerStatuses = ['Prospect', 'Active', 'Former'];
const KeystoneCustomerTiers = ['Keystone', 'Standard'];

// Issue tracking vocabularies. Status walks Open -> Closed; WontFix and Deferred are side states.
// The closed-ish set (Fixed/Verified/Closed/WontFix) is what stamps ResolvedDate server-side.
const IssueStatuses = ['Open', 'Triaged', 'InProgress', 'Fixed', 'Verified', 'Closed', 'WontFix', 'Deferred'];
const IssueSeverities = ['Minor', 'Major', 'Critical'];
// How much to trust the report itself (distinct from Status = resolution, Severity = impact).
// Drives how a linked issue is weighted as supporting evidence in a generated AI prompt.
// Reported = an unverified claim (treat as possibly-not-factual); Corroborated = independently
// supported by more than one source; Verified = confirmed factual by the team.
const IssueReliabilities = ['Reported', 'Corroborated', 'Verified'];
const ContactKinds = ['Person', 'Shop', 'Reader', 'Org'];
const CallChannels = ['Phone', 'Email', 'Chat', 'InPerson', 'Other'];
const CallDirections = ['Inbound', 'Outbound'];

// Deliver vocabularies. Expectation status is a light three-state; Deliverable stages are the fixed
// delivery pipeline (a Drafting Kit renames the labels in B5). Stored as a single-token Status.
const ExpectationStatuses = ['Open', 'PartiallyMet', 'Met'];
const DeliverableStages = ['Scoped', 'Built', 'Delivered', 'Installed', 'Accepted'];

// Display a 0-5 likert score (0 or empty means unanswered).
function formatLikert(pValue)
{
	let tmpScore = Number(pValue) || 0;
	if (tmpScore < 1) { return 'not answered'; }
	if (tmpScore > 5) { tmpScore = 5; }
	return '●'.repeat(tmpScore) + '○'.repeat(5 - tmpScore) + ' ' + tmpScore + '/5';
}

// A stored ISO datetime as a short local calendar date (YYYY-MM-DD) for a list
// cell. Blank for an empty / unparseable value. The cell displays this, but the
// column still sorts on the raw ISO string, which orders chronologically.
function formatDate(pValue)
{
	if (!pValue) { return ''; }
	let tmpDate = new Date(pValue);
	if (isNaN(tmpDate.getTime())) { return ''; }
	let tmpMonth = String(tmpDate.getMonth() + 1).padStart(2, '0');
	let tmpDay = String(tmpDate.getDate()).padStart(2, '0');
	return tmpDate.getFullYear() + '-' + tmpMonth + '-' + tmpDay;
}

// A stored ISO datetime as a compact relative age ('just now', '5m', '3h', '2d',
// '4w') for a list cell, so a person reads "how fresh is this" at a glance. Past a
// month it falls back to the calendar date (relative gets useless that far out).
// The cell shows this, but the column still sorts on the raw ISO string.
function formatRelative(pValue)
{
	if (!pValue) { return ''; }
	let tmpThen = Date.parse(String(pValue));
	if (isNaN(tmpThen)) { return ''; }
	let tmpDiff = Date.now() - tmpThen;
	if (tmpDiff < 0) { tmpDiff = 0; }
	let tmpSec = Math.floor(tmpDiff / 1000);
	if (tmpSec < 45) { return 'just now'; }
	let tmpMin = Math.floor(tmpSec / 60);
	if (tmpMin < 60) { return tmpMin + 'm ago'; }
	let tmpHour = Math.floor(tmpMin / 60);
	if (tmpHour < 24) { return tmpHour + 'h ago'; }
	let tmpDay = Math.floor(tmpHour / 24);
	if (tmpDay < 7) { return tmpDay + 'd ago'; }
	let tmpWeek = Math.floor(tmpDay / 7);
	if (tmpDay < 35) { return tmpWeek + 'w ago'; }
	return formatDate(pValue);
}

// The board lane color for a Status token (drives the Status badge tint on the list,
// so a list row and its board card read the same color). Falls back to a neutral grey.
function laneColor(pStatus)
{
	let tmpLane = DefaultBoardLanes.find((pLane) => pLane.Key === String(pStatus || ''));
	return tmpLane ? tmpLane.Color : '#8a94a6';
}

// The tint for a Priority badge: quiet for the low end, warm/hot as it climbs, so
// Urgent and High catch the eye in a dense list. Unknown priorities read neutral.
const _PriorityColors = { Low: '#8a94a6', Normal: '#2988df', High: '#d99366', Urgent: '#d0555b' };
function priorityColor(pPriority)
{
	return _PriorityColors[String(pPriority || '')] || '#8a94a6';
}

// The compact list-cell form of a Feedback row's three scores
// (expected/intuitive/enjoyment), e.g. '5/4/4' with '-' for unanswered.
function formatLikertShort(pRow)
{
	let fOne = (pValue) =>
	{
		let tmpScore = Number(pValue) || 0;
		return (tmpScore >= 1) ? String(Math.min(tmpScore, 5)) : '-';
	};
	let tmpCells = [fOne(pRow.ScoreDidWhatExpected), fOne(pRow.ScoreIntuitive), fOne(pRow.ScoreEnjoyment)];
	if (tmpCells.join('') === '---') { return 'not scored'; }
	return tmpCells.join('/');
}

// Join tables (thin link rows). A = the "owning"/source FK, B = the target FK.
const Joins =
{
	FeatureVision: { Entity: 'FeatureVisionJoin', Plural: 'FeatureVisionJoins', ID: 'IDFeatureVisionJoin', A: 'IDFeature', B: 'IDVision' },
	FeatureModule: { Entity: 'FeatureModuleJoin', Plural: 'FeatureModuleJoins', ID: 'IDFeatureModuleJoin', A: 'IDFeature', B: 'IDModule' },
	VisionVision:  { Entity: 'VisionVisionJoin', Plural: 'VisionVisionJoins', ID: 'IDVisionVisionJoin', A: 'IDVisionSource', B: 'IDVisionTarget' },
	IssueWorkItem: { Entity: 'IssueWorkItemJoin', Plural: 'IssueWorkItemJoins', ID: 'IDIssueWorkItemJoin', A: 'IDIssue', B: 'IDWorkItem' },
	SessionWorkItem: { Entity: 'SessionFileWorkItem', Plural: 'SessionFileWorkItems', ID: 'IDSessionFileWorkItem', A: 'IDSessionFile', B: 'IDWorkItem' },
	FeedbackWorkItem: { Entity: 'FeedbackWorkItemJoin', Plural: 'FeedbackWorkItemJoins', ID: 'IDFeedbackWorkItemJoin', A: 'IDFeedback', B: 'IDWorkItem' }
};

const Entities =
{
	Vision:
	{
		// Render this entity as a Blueprint: a drafting title block coalescing its linked
		// artifacts. Backed by a real Blueprint record it owns, gathered from the same connections
		// manifest the grid reads, so the two can never disagree (Vision #46, WI #340).
		Blueprint: true,
		Key: 'Vision', Plural: 'Visions', IDField: 'IDVision', Title: 'Visions', TitleField: 'Name', Icon: 'Eye',
		NumberField: 'VisionNumber', Designator: 'V',
		// Fold this entity's links into the cohesive connections grid (replaces the stacked relation sections).
		Connections: true,
		// Embed an inspiration moodboard on the detail page (Moodboard.IDVision-owned). EntityDetail
		// renders a board container and mounts the shared Vision-Board view; edits need content.edit.
		Moodboard: true,
		// Let a vision pick its Drafting Kit (an imported/owned VisionType) so its pages and its work
		// items' blueprints speak that craft. EntityDetail shows a craft picker in the header.
		Craft: true,
		// Embed a comments section on the detail page (CommentThread owned by OwnerType 'Vision').
		Comments: true,
		// Show the four refinement loops (Design, Build, Deliver, Gather Feedback) for this vision.
		Loops: true,
		// Land the list on most-recently-touched first (not database order); the user can
		// re-sort by clicking any column header, and that choice is remembered per list.
		DefaultSort: 'UpdateDate:desc',
		// A light focus bar: free-text search over Name/Summary/Description, the Status
		// lanes as toggle chips, and an activity window. No saved views / role presets
		// (those are WorkItem-shaped), so the picker and its Save button stay hidden.
		Filter: { Search: true, Facets: ['Status'], Recent: true },
		Columns:
		[
			{ F: 'VisionNumber', L: '#' },
			{ F: 'Name', L: 'Name' },
			{ F: 'Scope', L: 'Scope' },
			{ F: 'Status', L: 'Status', Key: true },
			{ F: 'UpdateDate', L: 'Updated', Fmt: (pRow) => formatDate(pRow.UpdateDate), Key: true },
			// Created is real data but noise on the default view; off until the user turns it on.
			{ F: 'CreateDate', L: 'Created', Fmt: (pRow) => formatDate(pRow.CreateDate), DefaultHidden: true }
		],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Summary', L: 'Summary', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea' },
			{ F: 'Scope', L: 'Scope', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'select', O: ['Draft', 'Active', 'Realized', 'Abandoned'] }
		],
		Relations:
		[
			{ Render: 'core-doc', Label: 'Core vision document' },
			{ Render: 'docs', Label: 'Dossier' },
			{ Render: 'media', Label: 'Media library' },
			{ Render: 'subvisions', Label: 'Parts of this vision', Join: 'VisionVision' },
			{ Render: 'link', Label: 'Related visions', Join: 'VisionVision', SelfField: 'IDVisionSource', TargetField: 'IDVisionTarget', Target: 'Vision', RelationType: true },
			{ Render: 'inverse-join', Label: 'Realized by features', Join: 'FeatureVision', SelfField: 'IDVision', MapField: 'IDFeature', Target: 'Feature' },
			{ Render: 'inverse-fk', Label: 'Work items about this', Source: 'WorkItem', SourceField: 'IDTargetVision' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Module:
	{
		// Render this entity as a Blueprint: a drafting title block coalescing its linked
		// artifacts. Backed by a real Blueprint record it owns, gathered from the same connections
		// manifest the grid reads, so the two can never disagree (Vision #46, WI #340).
		Blueprint: true,
		Key: 'Module', Plural: 'Modules', IDField: 'IDModule', Title: 'Modules', TitleField: 'Name', Icon: 'Box',
		NumberField: 'ModuleNumber', Designator: 'M',
		Connections: true,
		// Embed whiteboards on the detail page (Moodboard owned by OwnerType 'Module'). A module can hold
		// several; the section lists them with a picker and lets you attach an existing standalone board.
		Moodboard: true,
		// No date column on this list, so order by the module's own number descending: newest first, and
		// visibly so, in a column the reader can see.
		DefaultSort: 'ModuleNumber:desc',
		Columns: [{ F: 'ModuleNumber', L: '#' }, { F: 'Name', L: 'Name' }, { F: 'Language', L: 'Language' }, { F: 'Status', L: 'Status', Key: true }],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea' },
			{ F: 'RepoURL', L: 'Repo URL', T: 'text' },
			{ F: 'RepoPath', L: 'Repo Path', T: 'text' },
			// Which repository this module is built in. This is the link a Work Item resolves through to
			// find the repository a node should work in (WorkItem -> Feature -> Module -> Workspace), so
			// leaving it off the form made the workspace ceiling unenforceable from the interface: the
			// column existed, Workspace-Service read it, and nothing a person could reach ever wrote it.
			{ F: 'IDWorkspace', L: 'Built in', T: 'select', E: 'Workspace' },
			{ F: 'Language', L: 'Language', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'select', O: ['Active', 'Planned', 'Deprecated'] }
		],
		Relations:
		[
			{ Render: 'inverse-fk', Label: 'Features in this module', Source: 'Feature', SourceField: 'IDModule' },
			{ Render: 'inverse-fk', Label: 'Work items about this', Source: 'WorkItem', SourceField: 'IDTargetModule' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Feature:
	{
		// Render this entity as a Blueprint: a drafting title block coalescing its linked
		// artifacts. Backed by a real Blueprint record it owns, gathered from the same connections
		// manifest the grid reads, so the two can never disagree (Vision #46, WI #340).
		Blueprint: true,
		Key: 'Feature', Plural: 'Features', IDField: 'IDFeature', Title: 'Features', TitleField: 'Name', Icon: 'Star',
		NumberField: 'FeatureNumber', Designator: 'F',
		Connections: true,
		// Embed whiteboards on the detail page (Moodboard owned by OwnerType 'Feature'). A feature can hold
		// several; the section lists them with a picker and lets you attach an existing standalone board.
		Moodboard: true,
		DefaultSort: 'FeatureNumber:desc',
		Columns: [{ F: 'FeatureNumber', L: '#' }, { F: 'Name', L: 'Name' }, { F: 'Status', L: 'Status', Key: true }, { F: 'Priority', L: 'Priority' }],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea' },
			{ F: 'Status', L: 'Status', T: 'select', O: BoardLanes },
			{ F: 'Priority', L: 'Priority', T: 'select', O: Priorities }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Built in module', Field: 'IDModule', Target: 'Module' },
			{ Render: 'link', Label: 'Realizes visions', Join: 'FeatureVision', SelfField: 'IDFeature', TargetField: 'IDVision', Target: 'Vision' },
			{ Render: 'inverse-fk', Label: 'Work items about this', Source: 'WorkItem', SourceField: 'IDTargetFeature' },
			{ Render: 'sessions', Label: 'Claude sessions', Field: 'IDFeature' },
			{ Render: 'media', Label: 'Screenshots & recordings' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	WorkItem:
	{
		Key: 'WorkItem', Plural: 'WorkItems', IDField: 'IDWorkItem', Title: 'Work Items', TitleField: 'Title', Icon: 'Ticket',
		NumberField: 'WorkItemNumber', Designator: 'WI',
		Connections: true,
		// Embed whiteboards on the detail page (Moodboard owned by OwnerType 'WorkItem'). A work item
		// can hold several; the section lists them with a picker and a "new" button.
		Moodboard: true,
		// Embed a comments section on the detail page (CommentThread owned by OwnerType 'WorkItem').
		Comments: true,
		// Embed the shared (team / blueprint-visible) checklists on the detail page (Checklist owned by
		// OwnerType 'WorkItem'). Private personal lists live on the Checklists page, not here.
		Checklist: true,
		// Embed the attached-prompts panel (PromptLink owned by OwnerType 'WorkItem'):
		// attach a prompt at a pinned version, run it, capture outcomes, refine.
		Prompts: true,
		// Render this work item as a Blueprint: a drafting title block coalescing its
		// linked artifacts (auto-gathered + curated). Mounted in onAfterRender.
		Blueprint: true,
		// Embed the Story panel: a chronological timeline of the Claude sessions that
		// advanced this work item (union of the scalar link + SessionFileWorkItem join),
		// so several sessions read as one narrative. Fed by GET /1.0/WorkItem/:id/Story.
		Story: true,
		// Review history: the QC decisions on this work item (the "did not pass QC" events with
		// their reason + note + linked issues), read from the workflow WorkEvent timeline.
		ReviewHistory: true,
		// Generate a prompt for this work item from a shape (pre-filled + attached), so a
		// session can be pointed at it by plan sheet Code + work item number over the MCP.
		HeaderActions: [{ Label: 'Assign', Method: 'assignWorkItem' }, { Label: 'Generate prompt', Method: 'generatePromptForWorkItem' }, { Label: 'Link issues', Method: 'linkIssuesToWorkItem' }, { Label: 'Link feedback', Method: 'linkFeedbackToWorkItem' }],
		// A soft-delete button in the header (meadow Deleted/DeleteDate; the WorkItemNumber
		// sequence ignores Deleted rows on purpose, so this never disturbs numbering).
		Deletable: true,
		// Saved, role-based focus views: the list gets a filter bar (facets + text search +
		// recent-activity window + a saved-view picker with shipped role presets). Facet option
		// lists come from the Fields' O arrays (Status/Type/Priority); Assignee pulls the team
		// roster (so the human/AI lens works); Target is the WorkItem's About type.
		// Land on the activity lens by default (#236): in-flight work plus anything touched in the
		// last few days, newest first -- not the whole backlog in database order. A person can still
		// switch to any view, "Views: none", or pin their own default per screen.
		Filter: { Search: true, Facets: ['Status', 'Type', 'Priority', 'Assignee', 'Target', 'WorkflowStatus'], Recent: true, Views: true, Assignee: true, Defaults: { activity: 'related', sort: 'UpdateDate:desc', view: 'activity' } },
		DefaultSort: 'UpdateDate:desc',
		Columns:
		[
			{ F: 'WorkItemNumber', L: '#' },
			{ F: 'Title', L: 'Title' },
			// Type as a compact glyph (a funnel for Triage, a bug for Issue, ...) with the type
			// name as its tooltip, so the column costs an icon's width, not a word's (#236).
			{ F: 'Type', L: 'Type', Icon: (pRow) => WorkItemTypeIcons[pRow.Type] || '', IconTitle: (pRow) => pRow.Type || '' },
			// Status + Priority as color-tinted badges: the lane color for Status (a row and
			// its board card read the same), a warm-as-it-climbs scale for Priority.
			{ F: 'Status', L: 'Status', Badge: true, Tint: (pRow) => laneColor(pRow.Status), Key: true },
			{ F: 'Priority', L: 'Priority', Badge: true, Tint: (pRow) => priorityColor(pRow.Priority) },
			// Who owns it (human or AI agent), resolved from the roster in the view and drawn
			// as an avatar + name -- a round avatar for a person, a hexagon for an AI agent.
			{ F: 'IDAssignedUser', L: 'Assignee', Assignee: true },
			// What the work item is about, resolved from the Vision/Module/Feature caches. Off by
			// default (#236): the default list stays lean; turn it on from the Columns menu.
			{ F: 'TargetType', L: 'Target', Target: true, DefaultHidden: true },
			// How many Claude sessions have advanced it (its auditable trail). The view stamps
			// the count onto _SessionCount so this column both renders and sorts on it. Off by
			// default (#236): a niche signal; turn it on from the Columns menu when needed.
			{ F: '_SessionCount', L: 'Sessions', Sessions: true, DefaultHidden: true, Computed: true },
			// Freshness at a glance: a relative age ('3h ago'), sorting on the raw UpdateDate.
			{ F: 'UpdateDate', L: 'Updated', Fmt: (pRow) => formatRelative(pRow.UpdateDate), Key: true }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' },
			{ F: 'Type', L: 'Type', T: 'select', O: WorkItemTypes },
			{ F: 'Description', L: 'Description', T: 'textarea' },
			{ F: 'Status', L: 'Status', T: 'select', O: BoardLanes },
			{ F: 'Priority', L: 'Priority', T: 'select', O: Priorities },
			// The one lifecycle date a person sets by hand (a target). WorkStartedDate,
			// DeliveryDate, and ValidationDate are stamped by the server on status changes.
			{ F: 'EstimatedDeliveryDate', L: 'Estimated delivery', T: 'date' }
		],
		Relations:
		[
			{ Render: 'target', Label: 'This work item is about' },
			{ Render: 'link', Label: 'Issues this addresses', Join: 'IssueWorkItem', SelfField: 'IDWorkItem', TargetField: 'IDIssue', Target: 'Issue' },
			{ Render: 'link', Label: 'Feedback that drove this', Join: 'FeedbackWorkItem', SelfField: 'IDWorkItem', TargetField: 'IDFeedback', Target: 'Feedback' },
			{ Render: 'sessions', Label: 'Claude sessions', Field: 'IDWorkItem' },
			{ Render: 'media', Label: 'Screenshots & recordings' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Routine:
	{
		Key: 'Routine', Plural: 'Routines', IDField: 'IDRoutine', Title: 'Routines', TitleField: 'Name', Icon: 'ListOrdered',
		NumberField: 'RoutineNumber', Designator: 'RTN',
		Connections: true,
		// Embed the ordered step editor on the detail page (the Plansheet-RoutineSteps
		// view renders into #Routine-Steps). Editing needs content.edit.
		Steps: true,
		// Embed a comments section on the detail page (CommentThread owned by OwnerType 'Routine').
		Comments: true,
		// Start a TestRun of this routine (POST /1.0/TestRun/Start) and land in the runner.
		HeaderActions: [{ Label: 'Start test run', Method: 'startTestRun' }],
		DefaultSort: 'RoutineNumber:desc',
		Columns: [{ F: 'RoutineNumber', L: '#' }, { F: 'Name', L: 'Name' }, { F: 'Status', L: 'Status', Badge: true, Key: true }],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Summary', L: 'Summary', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true },
			{ F: 'Status', L: 'Status', T: 'select', O: RoutineStatuses }
		],
		Relations:
		[
			{ Render: 'inverse-fk', Label: 'Test runs of this routine', Source: 'TestRun', SourceField: 'IDRoutine', SubField: 'Status' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	// A tenant's user-facing task (V50). The catalog entry an admin authors: a name and description, the
	// audience it is for, the target node capability + action, and the prompt shape that assembles the user's
	// input. Not Connections, so the fk stacked-picker below is the live editor for the input template. Users
	// file Requests against a Task from the Ask area (a separate user-facing view), never from here.
	Task:
	{
		Key: 'Task', Plural: 'Tasks', IDField: 'IDTask', Title: 'Tasks', TitleField: 'Name', Icon: 'Sparkles',
		NumberField: 'TaskNumber', Designator: 'TSK',
		Comments: true,
		DefaultSort: 'TaskNumber:desc',
		Columns:
		[
			{ F: 'TaskNumber', L: '#' },
			{ F: 'Name', L: 'Name' },
			{ F: 'Audience', L: 'Audience' },
			{ F: 'Capability', L: 'Capability', DefaultHidden: true },
			{ F: 'Status', L: 'Status', Badge: true, Key: true }
		],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Summary', L: 'Summary', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true },
			{ F: 'Audience', L: 'Audience', T: 'text' },
			{ F: 'Capability', L: 'Node capability', T: 'combo', Source: 'NodeCapabilities', SourceKey: 'Capability' },
			{ F: 'Action', L: 'Action', T: 'combo', Source: 'NodeCapabilities', SourceKey: 'Action', DependsOn: 'Capability' },
			{ F: 'OutcomeKind', L: 'Outcome kind', T: 'select', O: TaskOutcomeKinds },
			{ F: 'OutcomeTargetJSON', L: 'Output folder (document tasks)', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'select', O: TaskStatuses },
			{ F: 'Conversational', L: 'Multi-turn chat', T: 'checkbox' },
			{ F: 'AllowAttachments', L: 'Allow file attachments', T: 'checkbox' }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Input template (prompt shape)', Field: 'IDPromptShape', Target: 'PromptShape' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	// A prompt shape as a pickable entity. It is NOT given a list/detail route or a nav entry (its own editor
	// lives at /prompt-shapes); this descriptor exists only so the generic EntityAPI provider is created and a
	// Task's "Input template" fk picker can search the tenant's shapes by name.
	PromptShape:
	{
		Key: 'PromptShape', Plural: 'PromptShapes', IDField: 'IDPromptShape', Title: 'Prompt Shapes', TitleField: 'Name', Icon: 'PenRuler',
		// Pick-only target: no list/detail route and no + New, and (like DeployRequest/Session) no docs
		// surface -- its own editor at /prompt-shapes owns authoring. This descriptor exists only so the
		// generic EntityAPI provider is created and a Task's "Input template" fk picker can search shapes.
		Browse: true,
		NoCreate: true,
		DefaultSort: 'Name:asc',
		Columns: [{ F: 'Name', L: 'Name', Key: true }, { F: 'Scope', L: 'Scope' }, { F: 'Status', L: 'Status', Badge: true }],
		// Name and Description are the shape's prose columns; both are declared so search can look in them
		// (the FocusQuery prose-coverage invariant) even though this entity has no list of its own.
		Fields: [{ F: 'Name', L: 'Name', T: 'text' }, { F: 'Description', L: 'Description', T: 'textarea' }]
	},
	// A user's filed instance of a Task and the durable record of the question and its answer (V50). Created by
	// POST /1.0/Request/Submit (never the + New form) and answered by a node, so it is browse-only. The answer
	// renders from Outcome; IDTask is surfaced so a reader can open the task it came from.
	Request:
	{
		Key: 'Request', Plural: 'Requests', IDField: 'IDRequest', Title: 'Requests', TitleField: 'Name', Icon: 'CommentDots',
		NumberField: 'RequestNumber', Designator: 'REQ',
		Browse: true,
		NoCreate: true,
		DefaultSort: 'RequestNumber:desc',
		EmptyText: 'No requests yet. Run a task from the Ask area.',
		Columns:
		[
			{ F: 'RequestNumber', L: '#' },
			{ F: 'Name', L: 'Name' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true },
			{ F: 'AnsweredDate', L: 'Answered', Fmt: (pRow) => pRow.AnsweredDate ? String(pRow.AnsweredDate).slice(0, 10) : '' }
		],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'AssembledInput', L: 'Question', T: 'textarea' },
			{ F: 'Outcome', L: 'Answer', T: 'textarea', Markdown: true },
			{ F: 'Status', L: 'Status', T: 'select', O: RequestStatuses }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Task', Field: 'IDTask', Target: 'Task' }
		]
	},
	// The turns of a conversational Request (Ask multi-turn). Provider-only: no list/detail route and no + New
	// (a user turn is posted via POST /1.0/Request/:id/Message, which also dispatches the run, and the turns are
	// read back by the Ask chat view). This descriptor exists so the generic EntityAPI provider (RequestMessageAPI)
	// is created to list a conversation's turns (resolve by IDRequest) and read one.
	RequestMessage:
	{
		Key: 'RequestMessage', Plural: 'RequestMessages', IDField: 'IDRequestMessage', Title: 'Messages', TitleField: 'Content', Icon: 'CommentDots',
		Browse: true,
		NoCreate: true,
		DefaultSort: 'Sequence:asc',
		Columns: [{ F: 'Sequence', L: '#' }, { F: 'Content', L: 'Message' }, { F: 'Role', L: 'Role' }, { F: 'Status', L: 'Status', Badge: true, Key: true }],
		Fields: [{ F: 'Content', L: 'Message', T: 'textarea', Markdown: true }, { F: 'Role', L: 'Role', T: 'text' }]
	},
	// A unit of work built from a cluster of source files (V54). Its own view (route /projects) owns the corpus,
	// the task launcher, the conversation, and the blueprint; this descriptor creates the ProjectAPI provider and
	// a basic browse surface for it.
	Project:
	{
		Key: 'Project', Plural: 'Projects', IDField: 'IDProject', Title: 'Projects', TitleField: 'Name', Icon: 'FolderOpen',
		NumberField: 'ProjectNumber', Designator: 'PRJ',
		Comments: true,
		DefaultSort: 'ProjectNumber:desc',
		Columns:
		[
			{ F: 'ProjectNumber', L: '#' },
			{ F: 'Name', L: 'Name' },
			{ F: 'Kind', L: 'Kind' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true }
		],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Summary', L: 'Summary', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true },
			{ F: 'Kind', L: 'Kind', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'text' }
		],
		Relations:
		[
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	// A Project's corpus item (V54). Provider-only: the Project view manages the corpus. Exists so the generic
	// ProjectSourceAPI provider lists a project's items (resolve by IDProject) and reads one.
	ProjectSource:
	{
		Key: 'ProjectSource', Plural: 'ProjectSources', IDField: 'IDProjectSource', Title: 'Sources', TitleField: 'Name', Icon: 'FileText',
		Browse: true,
		NoCreate: true,
		DefaultSort: 'SortOrder:asc',
		Columns: [{ F: 'Role', L: 'Role' }, { F: 'Name', L: 'Name', Key: true }],
		// Description and SortOrder are declared so search can look in the prose (FocusQuery prose-coverage
		// invariant) and so the SortOrder default sort names a real field, even though the Project view --
		// not a generic form -- authors a corpus item.
		Fields: [{ F: 'Role', L: 'Role', T: 'text' }, { F: 'Name', L: 'Name', T: 'text' }, { F: 'Description', L: 'Description', T: 'textarea' }, { F: 'SortOrder', L: 'Order', T: 'number' }]
	},
	// A configurable metadata form (a manyfest manifest) selected by (EntityType, Kind) with a per-tenant
	// override. Edited through the generic entity surface -- ManifestJSON is a code field, not a textarea, for
	// the same reason CapabilityJSON is: hand-balancing JSON braces in a plain box is how a typo becomes a form
	// that silently will not render. Kind blank means the manifest applies to any Kind of its EntityType.
	MetadataManifest:
	{
		Key: 'MetadataManifest', Plural: 'MetadataManifests', IDField: 'IDMetadataManifest', Title: 'Metadata forms', TitleField: 'Name', Icon: 'FileText',
		Browse: true,
		DefaultSort: 'EntityType:asc',
		Columns:
		[
			{ F: 'EntityType', L: 'Entity' },
			{ F: 'Kind', L: 'Kind' },
			{ F: 'Name', L: 'Name', Key: true },
			{ F: 'Version', L: 'Ver' },
			{ F: 'Status', L: 'Status', Badge: true }
		],
		Fields:
		[
			{ F: 'EntityType', L: 'Entity type', T: 'text' },
			{ F: 'Kind', L: 'Kind (blank = any)', T: 'text' },
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'text' },
			{ F: 'ManifestJSON', L: 'Manifest (JSON)', T: 'code', Language: 'json' }
		]
	},
	// A tenant's reusable Project shape (V54 / F163), mirroring VisionType for Visions. Authored conversationally
	// (the Create / Adjust Project Type loop) and committed behind consent, so there is no + New form here --
	// NoCreate. Browse-listed so the Project Types screen and the generic surface can read them. The form shape
	// itself lives on the linked MetadataManifest row (external and versioned), so adjusting a type never orphans
	// a Project's saved MetadataJSON. Description is declared for prose search coverage and SortOrder so the
	// default sort names a real field, even though the type is authored through the screen, not this form.
	ProjectType:
	{
		Key: 'ProjectType', Plural: 'ProjectTypes', IDField: 'IDProjectType', Title: 'Project Types', TitleField: 'Name', Icon: 'FileText',
		Browse: true,
		NoCreate: true,
		DefaultSort: 'SortOrder:asc',
		Columns:
		[
			{ F: 'Name', L: 'Name' },
			{ F: 'TypeKey', L: 'Key' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true }
		],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'TypeKey', L: 'Key', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea' },
			{ F: 'Status', L: 'Status', T: 'text' },
			{ F: 'SortOrder', L: 'Order', T: 'number' }
		]
	},
	TestRun:
	{
		Key: 'TestRun', Plural: 'TestRuns', IDField: 'IDTestRun', Title: 'Test Runs', TitleField: 'Name', Icon: 'Flask',
		NumberField: 'TestRunNumber', Designator: 'TR',
		// Runs start from a Routine's "Start test run" action, never the + New form;
		// the detail surface is the runner view (route /test-run/:id), not EntityDetail.
		NoCreate: true,
		EmptyText: 'No runs yet. Open a routine and click "Start test run".',
		// Newest run first. CompletedDate is the obvious date column but it is null for anything still
		// running, which would bury exactly the run a person came here to watch.
		DefaultSort: 'TestRunNumber:desc',
		Columns:
		[
			{ F: 'TestRunNumber', L: '#' },
			{ F: 'Name', L: 'Name' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true },
			{ F: 'Environment', L: 'Environment' },
			{ F: 'CompletedDate', L: 'Completed', Fmt: (pRow) => pRow.CompletedDate ? String(pRow.CompletedDate).slice(0, 10) : '' }
		],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Environment', L: 'Environment', T: 'text' },
			{ F: 'Summary', L: 'Summary', T: 'textarea' },
			{ F: 'Status', L: 'Status', T: 'select', O: TestRunStatuses }
		],
		Relations:
		[
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Feedback:
	{
		Key: 'Feedback', Plural: 'Feedbacks', IDField: 'IDFeedback', Title: 'Feedback', TitleField: 'Title', Icon: 'MessageDots',
		NumberField: 'FeedbackNumber', Designator: 'FB',
		Connections: true,
		// Embed a comments section on the detail page (CommentThread owned by OwnerType 'Feedback').
		Comments: true,
		// Promote a piece of feedback into a tracked WorkItem, from the detail header.
		HeaderActions: [{ Label: 'Spawn work item', Method: 'spawnWorkItemFromFeedback' }],
		// Surface the prompts of the work items this feedback drove (read-only), so the feedback page is
		// a command center: read + copy the prompt / MCP run command without leaving. Mounted below the
		// connections grid; the prompts stay owned by their work item (a display through the relation).
		WorkItemPrompts: true,
		// A growing feedback backlog stays scannable: a piece can be marked Addressed
		// (a soft "handled" flag), which the list hides by default. Drives the list's
		// Address/Reopen quick action and the detail's badge + toggle. AddressedDate
		// stamps when it was marked and clears on reopen.
		Addressable: { Field: 'Addressed', DateField: 'AddressedDate', AddressLabel: 'Mark addressed', ReopenLabel: 'Reopen' },
		// Focus-view filter bar: default to unaddressed only (the point of #201), with
		// facets to widen to all feedback, a specific keystone customer, or a source type,
		// plus text search over Title/Body. Customer:true loads the customer roster for the
		// facet options; no saved-view picker (the WorkItem role presets do not apply here).
		Filter: { Search: true, Facets: ['Addressed', 'Customer', 'SourceType'], Defaults: { addressed: 'no' }, Customer: true },
		DefaultSort: 'FeedbackNumber:desc',
		Columns:
		[
			{ F: 'FeedbackNumber', L: '#' },
			{ F: 'Title', L: 'Title' },
			// Source as a compact glyph (a flask for Test Run, a terminal for Developer Experience, ...)
			// with the source name as its tooltip -- and, in the list's expanded density, alongside the
			// word. Icon-only by default is what tames the once-very-wide Source column (#252).
			{ F: 'SourceType', L: 'Source', Icon: (pRow) => FeedbackSourceIcons[pRow.SourceType] || '', IconTitle: (pRow) => pRow.SourceType || '', Key: true },
			{ F: 'ScoreDidWhatExpected', L: 'Scores', Fmt: formatLikertShort }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' },
			{ F: 'SourceType', L: 'Source type', T: 'select', O: FeedbackSourceTypes },
			// The likert scores fit product-trial feedback; a Developer Experience note (a dev flagging a
			// bug or rough edge) should not be forced to rate enjoyment, so hide them for that source.
			{ F: 'ScoreDidWhatExpected', L: 'Did what was expected', T: 'likert', HideWhen: { Field: 'SourceType', Equals: 'Developer Experience' } },
			{ F: 'ScoreIntuitive', L: 'Intuitive to use', T: 'likert', HideWhen: { Field: 'SourceType', Equals: 'Developer Experience' } },
			{ F: 'ScoreEnjoyment', L: 'Enjoyed using it', T: 'likert', HideWhen: { Field: 'SourceType', Equals: 'Developer Experience' } },
			{ F: 'Body', L: 'Feedback', T: 'textarea', Markdown: true }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Source test run', Field: 'IDTestRun', Target: 'TestRun' },
			{ Render: 'fk', Label: 'Keystone customer', Field: 'IDKeystoneCustomer', Target: 'KeystoneCustomer' },
			{ Render: 'fk', Label: 'About issue', Field: 'IDTargetIssue', Target: 'Issue' },
			{ Render: 'link', Label: 'Work items from this feedback', Join: 'FeedbackWorkItem', SelfField: 'IDFeedback', TargetField: 'IDWorkItem', Target: 'WorkItem' },
			{ Render: 'media', Label: 'Attachments' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	AsBuilt:
	{
		Key: 'AsBuilt', Plural: 'AsBuilts', IDField: 'IDAsBuilt', Title: 'As-Builts', TitleField: 'Title', Icon: 'Package',
		NumberField: 'AsBuiltNumber', Designator: 'AB',
		Connections: true,
		// The closing beat of a work item's story and the unit of promotion: a short description of what a
		// session delivered plus a screenshot (Media OwnerType 'AsBuilt'), bridging the WorkItem to the Routine
		// that validates it and the Feedback that drove it.
		// Only a Validated As-Built may be promoted: plansheet-promote refuses to ship a batch that still has
		// anything unvalidated riding it, so this action is the gate between dev and prod.
		HeaderActions: [{ Label: 'Validate on dev', Method: 'validateAsBuilt' }, { Label: 'Back to releases', Method: 'showReleases' }],
		DefaultSort: 'AsBuiltNumber:desc',
		Columns:
		[
			{ F: 'AsBuiltNumber', L: '#' },
			{ F: 'Title', L: 'Title' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true },
			{ F: 'Environment', L: 'Env' },
			{ F: 'CommitHash', L: 'Commit', Fmt: (pRow) => pRow.CommitHash ? String(pRow.CommitHash).slice(0, 12) : '' }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' },
			{ F: 'Description', L: 'What was built', T: 'textarea', Markdown: true },
			{ F: 'Status', L: 'Status', T: 'select', O: AsBuiltStatuses },
			{ F: 'Environment', L: 'Environment', T: 'text' },
			{ F: 'Branch', L: 'Branch', T: 'text' },
			{ F: 'CommitHash', L: 'Commit', T: 'text' },
			{ F: 'ImageDigest', L: 'Image digest', T: 'text' }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Work item', Field: 'IDWorkItem', Target: 'WorkItem' },
			{ Render: 'fk', Label: 'Validated by routine', Field: 'IDRoutine', Target: 'Routine' },
			{ Render: 'fk', Label: 'From feedback', Field: 'IDSourceFeedback', Target: 'Feedback' },
			{ Render: 'fk', Label: 'Validating test run', Field: 'IDValidatingTestRun', Target: 'TestRun' },
			{ Render: 'media', Label: 'Screenshot' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	DeployRequest:
	{
		Key: 'DeployRequest', Plural: 'DeployRequests', IDField: 'IDDeployRequest', Title: 'Deploy Requests', TitleField: 'Action', Icon: 'Rocket',
		NumberField: 'DeployRequestNumber', Designator: 'DR',
		// Browse-only operational record: created by the Releases page's Deploy / Promote buttons (never the + New
		// form) and run by the deploy executor, so it carries no documentation surface (Browse exempts it from the
		// docs / doclink invariants, like Session).
		Browse: true,
		NoCreate: true,
		EmptyText: 'No deploy requests yet. Deploy from the Releases page.',
		DefaultSort: 'CreateDate:desc',
		Columns:
		[
			{ F: 'DeployRequestNumber', L: '#' },
			{ F: 'Action', L: 'Action' },
			// Which environment a deploy touched is the first thing anyone asks, so it stays in concise.
			{ F: 'Environment', L: 'Env', Key: true },
			{ F: 'Status', L: 'Status', Badge: true, Key: true },
			{ F: 'CommitRef', L: 'Commit', Fmt: (pRow) => pRow.CommitRef ? String(pRow.CommitRef).slice(0, 12) : '' },
			{ F: 'CreateDate', L: 'Requested', Fmt: (pRow) => pRow.CreateDate ? String(pRow.CreateDate).slice(0, 16).replace('T', ' ') : '' }
		],
		Fields:
		[
			{ F: 'Action', L: 'Action', T: 'text' },
			{ F: 'Environment', L: 'Environment', T: 'text' },
			{ F: 'CommitRef', L: 'Commit', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'select', O: DeployRequestStatuses },
			{ F: 'ResultLog', L: 'Result log', T: 'textarea' }
		],
		Relations: []
	},
	Workspace:
	{
		Key: 'Workspace', Plural: 'Workspaces', IDField: 'IDWorkspace', Title: 'Workspaces', TitleField: 'Name', Icon: 'Folder',
		NumberField: 'WorkspaceNumber', Designator: 'WS',
		// The SDLC configuration: which repositories this product is built from. A node reads these through
		// GET /1.0/Workspace/Manifest and derives its own paths, so activating a node for this plan sheet needs
		// no edit on the node. THE CONTROL PLANE STORES NO PATH -- that is deliberate and is why there is no
		// path field here.
		EmptyText: 'No repositories declared yet. Add one so a node can work in it without being configured by hand.',
		// By its own number. This read SortOrder:asc, which mirrors the SERVER's manifest sort
		// (Workspace-Service.readWorkspaces) into a client list setting -- and nothing anywhere writes
		// Workspace.SortOrder, so every row is 0 and the sort was a no-op landing rows in raw database
		// order. That is the exact defect the rule at the top of this file exists to prevent, and the
		// number is a column the reader can actually see.
		DefaultSort: 'WorkspaceNumber:asc',
		Columns:
		[
			{ F: 'WorkspaceNumber', L: '#' },
			{ F: 'WorkspaceKey', L: 'Key', Key: true },
			{ F: 'Name', L: 'Name' },
			{ F: 'CheckoutStrategy', L: 'Checkout', Badge: true },
			{ F: 'Trunk', L: 'Trunk' },
			{ F: 'Deployable', L: 'Deploys', Fmt: (pRow) => pRow.Deployable ? 'yes' : '' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true }
		],
		Fields:
		[
			{ F: 'WorkspaceKey', L: 'Key', T: 'text' },
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea' },
			{ F: 'RepoURL', L: 'Repository URL', T: 'text' },
			{ F: 'CheckoutStrategy', L: 'Checkout strategy', T: 'select', O: WorkspaceCheckoutStrategies },
			{ F: 'IDParentWorkspace', L: 'Inside monorepo', T: 'select', E: 'Workspace' },
			{ F: 'RepoPath', L: 'Path inside that monorepo', T: 'text' },
			{ F: 'Trunk', L: 'Trunk branch', T: 'text' },
			{ F: 'BranchPrefix', L: 'Agent branch prefix', T: 'text' },
			{ F: 'GateJSON', L: 'Gate commands (JSON array)', T: 'textarea' },
			{ F: 'Deployable', L: 'Rides the deploy pipeline', T: 'checkbox' },
			{ F: 'DeployConfigRef', L: 'Deploy config reference', T: 'text' },
			// Ties the manifest order, and therefore which repository is picked when more than one row is
			// flagged Deployable. Unsettable, every row sorted equal and the pick fell to database return
			// order.
			{ F: 'SortOrder', L: 'Sort order', T: 'number' },
			{ F: 'Status', L: 'Status', T: 'select', O: WorkspaceStatuses }
		],
		// AUTHORED, unlike its sibling NodeRegistration: a plan sheet DECLARES a repository -- thirteen
		// typed decisions through POST/PUT /1.0/Workspace, which is why Workspace-Endpoint carries only
		// the derived read -- and a node registers ITSELF. Everything carrying Browse: true holds content
		// that originated outside Plansheet (an uploaded transcript, an upload, a self-registration, a
		// button press), and all of them pair it with NoCreate. So this gets a documentation surface and
		// they do not.
		//
		// Browse: true would have made the same two invariants pass in one line, and would have been the
		// wrong line: the flag has no runtime behaviour at all -- its only readers are those two tests --
		// so it buys a green run by asserting in the file that IS the semantic contract that a workspace
		// is something you only read.
		Relations:
		[
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},


	NodeRegistration:
	{
		Key: 'NodeRegistration', Plural: 'NodeRegistrations', IDField: 'IDNodeRegistration', Title: 'Nodes', TitleField: 'NodeHost', Icon: 'Box',
		NumberField: 'NodeRegistrationNumber', Designator: 'ND',
		// A row-click opens the focused Node workspace (lifecycle actions + Provision); the pencil still opens the
		// generic edit form for CapabilityJSON checkout-path mapping (WI #456), so the detail slug stays.
		OpenAction: 'showNodeWorkspace',
		// Browse-only operational record (like DeployRequest / Session): a node registers itself over the API, so
		// there is no + New form and no documentation surface. Suspend / Resume are the operator actions on it.
		Browse: true,
		NoCreate: true,
		EmptyText: 'No nodes registered yet. A node registers itself over the API when it comes online.',
		DefaultSort: 'CreateDate:desc',
		Columns:
		[
			{ F: 'NodeRegistrationNumber', L: '#' },
			{ F: 'NodeHost', L: 'Host', Key: true },
			{ F: 'Status', L: 'Status', Badge: true, Key: true },
			{ F: 'Roles', L: 'Roles', Fmt: nodeRolesSummary, Computed: true },
			{ F: 'Workspaces', L: 'Workspaces', Fmt: nodeWorkspacesSummary, Computed: true },
			{ F: 'WorkspacePaths', L: 'Checkout paths', Fmt: nodeWorkspacePathsSummary, Computed: true },
			{ F: 'UnresolvedWorkspaces', L: 'Cannot resolve', Fmt: nodeUnresolvedSummary, Computed: true },
			{ F: 'LastSeenDate', L: 'Last seen', Fmt: (pRow) => pRow.LastSeenDate ? String(pRow.LastSeenDate).slice(0, 16).replace('T', ' ') : '' }
		],
		Fields:
		[
			{ F: 'NodeHost', L: 'Host', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'select', O: NodeRegistrationStatuses },
			// A code editor, not a textarea: this blob is how an operator maps a node's checkouts from the web
			// UI (WI #456), and hand-balancing JSON braces in a plain box is how a typo becomes a node that
			// silently stops resolving a workspace.
			{ F: 'CapabilityJSON', L: 'Capability (JSON)', T: 'code', Language: 'json' }
		],
		// Suspend / Resume go through the gated POST /1.0/NodeRegistration/:id/(Suspend|Resume) so the change is
		// entitlement-checked (content.approve) and logged, not a silent field edit.
		HeaderActions: [{ Label: 'Suspend', Method: 'suspendNode' }, { Label: 'Resume', Method: 'resumeNode' }],
		Relations: []
	},
	KeystoneCustomer:
	{
		Key: 'KeystoneCustomer', Plural: 'KeystoneCustomers', IDField: 'IDKeystoneCustomer', Title: 'Customers', TitleField: 'Name', Icon: 'Handshake',
		Connections: true,
		// Any customer you serve and track feedback, calls, and issues for. Tier marks strategic pilots
		// (Keystone) apart from everyone else you support (Standard). Comments attach via CommentThread
		// OwnerType 'KeystoneCustomer' -- exactly the 16-char OwnerType column limit.
		Comments: true,
		// No number on this entity, so no mark and nothing chronological worth leading with: order by name.
		DefaultSort: 'Name:asc',
		Columns: [{ F: 'Name', L: 'Name' }, { F: 'Tier', L: 'Tier', Badge: true, Key: true }, { F: 'ContactName', L: 'Contact' }, { F: 'Status', L: 'Status', Badge: true, Key: true }],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Tier', L: 'Tier', T: 'select', O: KeystoneCustomerTiers },
			{ F: 'ContactName', L: 'Primary contact name', T: 'text' },
			{ F: 'ContactEmail', L: 'Primary contact email', T: 'text' },
			{ F: 'Summary', L: 'Summary', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true },
			{ F: 'Status', L: 'Status', T: 'select', O: KeystoneCustomerStatuses }
		],
		Relations:
		[
			{ Render: 'inverse-fk', Label: 'Contacts', Source: 'Contact', SourceField: 'IDKeystoneCustomer', SubField: 'Kind',
				Create: { Label: 'New contact', Prefill: {} } },
			{ Render: 'inverse-fk', Label: 'Calls', Source: 'Call', SourceField: 'IDKeystoneCustomer', SubField: 'Channel',
				Create: { Label: 'Log a call', Prefill: {} } },
			{ Render: 'inverse-fk', Label: 'Issues', Source: 'Issue', SourceField: 'IDKeystoneCustomer', SubField: 'Status' },
			{ Render: 'inverse-fk', Label: 'Feedback from this customer', Source: 'Feedback', SourceField: 'IDKeystoneCustomer', SubField: 'SourceType',
				Create: { Label: 'New feedback', Prefill: { SourceType: 'Customer Conversation' } } },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Issue:
	{
		Key: 'Issue', Plural: 'Issues', IDField: 'IDIssue', Title: 'Issues', TitleField: 'Title', Icon: 'AlertTriangle',
		NumberField: 'IssueNumber', Designator: 'I',
		// Comments, shared checklists, and evidence media attach to an issue (OwnerType 'Issue').
		Comments: true,
		Checklist: true,
		Connections: true,
		// Self-assign or spin a draft vision out of an issue, from the detail header.
		HeaderActions: [{ Label: 'Assign to me', Method: 'assignIssueToMe' }, { Label: 'Assign...', Method: 'assignIssue' }, { Label: 'Spawn a vision', Method: 'spawnVisionFromIssue' }, { Label: 'Spawn work item', Method: 'spawnWorkItemFromIssue' }],
		DefaultSort: 'IssueNumber:desc',
		Columns:
		[
			{ F: 'IssueNumber', L: '#' },
			{ F: 'Title', L: 'Title' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true },
			{ F: 'Priority', L: 'Priority' },
			// Severity is what triage sorts on, so it earns its place in the concise scan.
			{ F: 'Severity', L: 'Severity', Key: true },
			{ F: 'Reliability', L: 'Reliability' }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'select', O: IssueStatuses },
			{ F: 'Priority', L: 'Priority', T: 'select', O: Priorities },
			{ F: 'Severity', L: 'Severity', T: 'select', O: IssueSeverities },
			{ F: 'Reliability', L: 'Reliability', T: 'select', O: IssueReliabilities },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Issue type', Field: 'IDIssueType', Target: 'IssueType' },
			{ Render: 'fk', Label: 'Affected customer', Field: 'IDKeystoneCustomer', Target: 'KeystoneCustomer' },
			{ Render: 'fk', Label: 'Reported by', Field: 'IDReportedByContact', Target: 'Contact' },
			{ Render: 'fk', Label: 'From call', Field: 'IDSourceCall', Target: 'Call' },
			{ Render: 'fk', Label: 'Spawned vision', Field: 'IDTargetVision', Target: 'Vision' },
			{ Render: 'link', Label: 'Work items addressing this', Join: 'IssueWorkItem', SelfField: 'IDIssue', TargetField: 'IDWorkItem', Target: 'WorkItem' },
			{ Render: 'media', Label: 'Screenshots & evidence' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Expectation:
	{
		Key: 'Expectation', Plural: 'Expectations', IDField: 'IDExpectation', Title: 'Expectations', TitleField: 'Title', Icon: 'ListChecks',
		NumberField: 'ExpectationNumber', Designator: 'EXP',
		// What a served customer expects delivered, in their words. Forward-looking, NOT a problem (Issue);
		// fulfilled by one or more Deliverables. Comments + connections attach (OwnerType 'Expectation').
		Comments: true,
		Connections: true,
		DefaultSort: 'ExpectationNumber:desc',
		Columns:
		[
			{ F: 'ExpectationNumber', L: '#' },
			{ F: 'Title', L: 'What they expect' },
			{ F: 'Status', L: 'Status', Badge: true, Key: true }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' },
			{ F: 'Status', L: 'Status', T: 'select', O: ExpectationStatuses },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Customer', Field: 'IDKeystoneCustomer', Target: 'KeystoneCustomer' },
			{ Render: 'inverse-fk', Label: 'Deliverables', Source: 'Deliverable', SourceField: 'IDExpectation', SubField: 'Status',
				Create: { Label: 'New deliverable', Prefill: {} } },
			{ Render: 'fk', Label: 'Spawned vision', Field: 'IDTargetVision', Target: 'Vision' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Deliverable:
	{
		Key: 'Deliverable', Plural: 'Deliverables', IDField: 'IDDeliverable', Title: 'Deliverables', TitleField: 'Title', Icon: 'Box',
		NumberField: 'DeliverableNumber', Designator: 'DLV',
		HeaderActions: [{ Label: 'Compose blueprint', Method: 'composeDeliverableBlueprint' }],
		// The fulfilment unit a customer receives (renamed "Solution" for software via the Drafting Kit
		// terms). Nests into sub-deliverables; moves through a stage pipeline; bundles a Blueprint; checks off.
		Comments: true,
		Checklist: true,
		Connections: true,
		DefaultSort: 'DeliverableNumber:desc',
		Columns:
		[
			{ F: 'DeliverableNumber', L: '#' },
			{ F: 'Title', L: 'Title' },
			{ F: 'Status', L: 'Stage', Badge: true, Key: true }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' },
			{ F: 'Status', L: 'Stage', T: 'select', O: DeliverableStages },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Customer', Field: 'IDKeystoneCustomer', Target: 'KeystoneCustomer' },
			{ Render: 'fk', Label: 'Fulfils expectation', Field: 'IDExpectation', Target: 'Expectation' },
			{ Render: 'fk', Label: 'Part of', Field: 'IDParentDeliverable', Target: 'Deliverable' },
			{ Render: 'inverse-fk', Label: 'Sub-deliverables', Source: 'Deliverable', SourceField: 'IDParentDeliverable', SubField: 'Status',
				Create: { Label: 'New sub-deliverable', Prefill: {} } },
			{ Render: 'fk', Label: 'Blueprint', Field: 'IDBlueprint', Target: 'Blueprint' },
			{ Render: 'fk', Label: 'From vision', Field: 'IDSourceVision', Target: 'Vision' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	// A first-class, standalone blueprint: a named drafting title block you compose + reuse, beyond a single
	// work item. Name + Description + comments today; the title-block composer (pin artifacts to it) is the
	// next step -- it reuses the work item's renderer pointed at this blueprint's own pinned items.
	Blueprint:
	{
		Key: 'Blueprint', Plural: 'Blueprints', IDField: 'IDBlueprint', Title: 'Blueprints', TitleField: 'Name', Icon: 'FileText',
		NumberField: 'BlueprintNumber', Designator: 'BP',
		// Every blueprint, composed and entity-owned alike, because any of them can be made the plan sheet's
		// cover from here (WI #339 + #340). The For column is what keeps that legible: an entity's blueprint
		// says which entity, a composed one says so.
		HeaderActions: [{ Label: 'Compose', Method: 'composeBlueprint' }, { Label: 'Set as cover', Method: 'setPlansheetCover' }],
		Comments: true,
		DefaultSort: 'BlueprintNumber:desc',
		// Only the mark and the name, both of which are always shown, so the two modes are identical here.
		Columns:
		[
			{ F: 'BlueprintNumber', L: '#' },
			{ F: 'Name', L: 'Name' },
			// Which thing this blueprint is OF. Without it every entity blueprint reads as an anonymous name
			// in a list that also holds hand-composed ones, and there is no way to tell them apart.
			// Key: it survives into concise mode, because telling an entity's blueprint from a hand-composed
			// one is the whole reason this column exists -- hiding it is what makes the list unreadable.
			{ F: 'OwnerType', L: 'For', Key: true, Fmt: (pRow) => (pRow && pRow.OwnerType) ? ({ WorkItem: 'Work item', Vision: 'Vision', Module: 'Module', Feature: 'Feature' })[pRow.OwnerType] || pRow.OwnerType : 'Composed' }
		],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Description', L: 'Description', T: 'textarea', Markdown: true }
		],
		Relations:
		[
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	IssueType:
	{
		Key: 'IssueType', Plural: 'IssueTypes', IDField: 'IDIssueType', Title: 'Issue Types', TitleField: 'Name', Icon: 'Tags',
		DefaultSort: 'Name:asc',
		Columns: [{ F: 'Name', L: 'Name' }, { F: 'Category', L: 'Category', Badge: true, Key: true }],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Category', L: 'Category', T: 'text' },
			{ F: 'Color', L: 'Color', T: 'text' }
		],
		Relations:
		[
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Contact:
	{
		Key: 'Contact', Plural: 'Contacts', IDField: 'IDContact', Title: 'Contacts', TitleField: 'Name', Icon: 'Users',
		Comments: true,
		DefaultSort: 'Name:asc',
		Columns: [{ F: 'Name', L: 'Name' }, { F: 'Kind', L: 'Kind', Badge: true, Key: true }, { F: 'Email', L: 'Email', Key: true }, { F: 'Phone', L: 'Phone' }],
		Fields:
		[
			{ F: 'Name', L: 'Name', T: 'text' },
			{ F: 'Kind', L: 'Kind', T: 'select', O: ContactKinds },
			{ F: 'Email', L: 'Email', T: 'text' },
			{ F: 'Phone', L: 'Phone', T: 'text' },
			{ F: 'Role', L: 'Role', T: 'text' },
			{ F: 'Notes', L: 'Notes', T: 'textarea' }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Customer', Field: 'IDKeystoneCustomer', Target: 'KeystoneCustomer' },
			{ Render: 'inverse-fk', Label: 'Calls with this contact', Source: 'Call', SourceField: 'IDContact', SubField: 'Channel' },
			{ Render: 'inverse-fk', Label: 'Issues reported', Source: 'Issue', SourceField: 'IDReportedByContact', SubField: 'Status' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Call:
	{
		Key: 'Call', Plural: 'Calls', IDField: 'IDCall', Title: 'Calls', TitleField: 'Subject', Icon: 'Phone',
		NumberField: 'CallNumber', Designator: 'CL',
		Comments: true,
		DefaultSort: 'CallDate:desc',
		Columns:
		[
			{ F: 'CallNumber', L: '#' },
			{ F: 'Subject', L: 'Subject' },
			{ F: 'Channel', L: 'Channel', Badge: true, Key: true },
			{ F: 'Direction', L: 'Direction' },
			{ F: 'CallDate', L: 'When', Fmt: (pRow) => pRow.CallDate ? String(pRow.CallDate).slice(0, 10) : '', Key: true }
		],
		Fields:
		[
			{ F: 'Subject', L: 'Subject', T: 'text' },
			{ F: 'Channel', L: 'Channel', T: 'select', O: CallChannels },
			{ F: 'Direction', L: 'Direction', T: 'select', O: CallDirections },
			{ F: 'Notes', L: 'Notes', T: 'textarea', Markdown: true }
		],
		Relations:
		[
			{ Render: 'fk', Label: 'Customer', Field: 'IDKeystoneCustomer', Target: 'KeystoneCustomer' },
			{ Render: 'fk', Label: 'Contact', Field: 'IDContact', Target: 'Contact' },
			{ Render: 'inverse-fk', Label: 'Issues from this call', Source: 'Issue', SourceField: 'IDSourceCall', SubField: 'Status' },
			{ Render: 'docs', Label: 'Documentation' },
			{ Render: 'doclink', Label: 'Foundational documentation' }
		]
	},
	Session:
	{
		Key: 'Session', Plural: 'SessionFiles', IDField: 'IDSessionFile', Title: 'Sessions', TitleField: 'Title', Icon: 'MessageSquare',
		// Browse-only: a Claude session is an uploaded transcript you read, not an
		// authored SDLC artifact. It carries no documentation or relation surface
		// (the Browse flag exempts it from the docs/doclink invariants). You add one
		// by uploading a .zip (CreateButton), and Open hands it to the session
		// viewer rather than a CRUD detail (OpenAction). Edit just renames it.
		Browse: true,
		NoCreate: true,
		NumberField: 'SessionNumber',
		Designator: 'SN',
		// A session is cited as PROVENANCE on a printed sheet -- "where did this come from" -- which is
		// what the mark is for (WI #385). It is not cited in the app: nobody says "open SN-014", they
		// scan the list by title and date. So the connections cell keeps the readable title.
		//
		// That cell prefers the MARK by default, and deliberately: a grid is scanned rather than read,
		// and three marks cross-reference at a glance where three truncated sentences cannot. The
		// argument holds for artifacts people cite by mark and inverts for one nobody does, where it
		// would trade three readable titles for three opaque numbers. The detail row underneath still
		// leads with the mark, so nothing is lost -- see PictView-Connections.
		ChipPrefersMark: false,
		CreateButton: { Label: 'Upload session', Action: 'showUploader' },
		OpenAction: 'showSession',
		EmptyText: 'No sessions yet. Upload a Claude session export (.zip) to browse it here.',
		DefaultSort: 'SessionStartedAt:desc',
		Columns:
		[
			{ F: 'SessionNumber', L: '#' },
			{ F: 'Title', L: 'Title' },
			{ F: 'SessionStartedAt', L: 'Started', Fmt: (pRow) => pRow.SessionStartedAt ? String(pRow.SessionStartedAt).slice(0, 10) : '', Key: true },
			{ F: 'TotalDurationMs', L: 'Length', Fmt: (pRow) =>
				{
					let tmpS = Math.round((pRow.TotalDurationMs || 0) / 1000);
					if (!tmpS) { return ''; }
					let tmpH = Math.floor(tmpS / 3600);
					let tmpM = Math.floor((tmpS % 3600) / 60);
					return tmpH ? (tmpH + 'h ' + tmpM + 'm') : (tmpM ? (tmpM + 'm') : (tmpS + 's'));
				} },
			{ F: 'PromptCount', L: 'Prompts' },
			{ F: 'ToolCallCount', L: 'Tools' },
			{ F: 'Model', L: 'Model', Badge: true }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' }
		],
		Relations: []
	},

	Media:
	{
		Key: 'Media', Plural: 'Medias', IDField: 'IDMedia', Title: 'Media', TitleField: 'Title', Icon: 'Image',
		// Media is SUBSTANCE. Screenshots and recordings hang off work items, issues and visions, and they
		// land in the attachments of a printed set -- but the entity had no number, so EntityMark returned
		// empty for it and an attachment carrying a screenshot could not be cited. "See MD-042" was
		// unsayable (WI #386).
		//
		// The alternative considered and rejected was set-local marks (X-1, X-2) assigned at compile time.
		// Those break the moment set membership changes, so a customer's annotated Rev A stops matching
		// Rev B -- exactly the stability a designator exists to provide.
		//
		// Browse-only, like Sessions: a media row is an uploaded artifact you look at, not an authored
		// one. It is created by an upload (POST /1.0/Media/New) rather than from this list, and the Browse
		// flag exempts it from the docs and doclink relation invariants that an authored entity carries.
		Browse: true,
		NoCreate: true,
		NumberField: 'MediaNumber',
		Designator: 'MD',
		OpenAction: 'showMedia',
		EmptyText: 'No media yet. Screenshots, drawings and recordings attached anywhere in this plan sheet appear here.',
		// Newest first, by the date the list actually shows.
		DefaultSort: 'CreateDate:desc',
		Columns:
		[
			{ F: 'MediaNumber', L: '#' },
			{ F: 'Title', L: 'Title' },
			{ F: 'MediaType', L: 'Kind', Badge: true, Key: true },
			// What it hangs off. Media is polymorphic (OwnerType + IDOwner), and which KIND of thing owns
			// a screenshot is the fact a person scanning this list wants first.
			{ F: 'OwnerType', L: 'Attached to', Key: true },
			{ F: 'OriginalFileName', L: 'File', DefaultHidden: true },
			{ F: 'FileSizeBytes', L: 'Size', DefaultHidden: true, Fmt: (pRow) =>
				{
					let tmpBytes = Number(pRow.FileSizeBytes) || 0;
					if (!tmpBytes) { return ''; }
					if (tmpBytes < 1024) { return tmpBytes + ' B'; }
					if (tmpBytes < (1024 * 1024)) { return Math.round(tmpBytes / 1024) + ' KB'; }
					return (Math.round((tmpBytes / (1024 * 1024)) * 10) / 10) + ' MB';
				} },
			{ F: 'CreateDate', L: 'Added', Fmt: (pRow) => pRow.CreateDate ? String(pRow.CreateDate).slice(0, 10) : '' }
		],
		Fields:
		[
			{ F: 'Title', L: 'Title', T: 'text' },
			{ F: 'MediaType', L: 'Kind', T: 'select', O: MediaTypes }
		],
		Relations: []
	}
};

// The entity types a WorkItem can target (its "About"), in picker order.
const WorkItemTargetTypes = ['None', 'Vision', 'Module', 'Feature'];

module.exports = { DefaultBoardLanes, BoardLanes, BoardLaneLabels, Priorities, WorkItemTypes, WorkItemTypeIcons, FeedbackSourceIcons, RelationTypes, WorkOutcomes, QCReasonCodes, MediaTypes,
	TaskStatuses, TaskOutcomeKinds, RequestStatuses,
	RoutineStatuses, TestRunStatuses, TestRunStepOutcomes, AsBuiltStatuses, DeployRequestStatuses, FeedbackSourceTypes, KeystoneCustomerStatuses, KeystoneCustomerTiers,
	IssueStatuses, IssueSeverities, IssueReliabilities, ContactKinds, CallChannels, CallDirections,
	formatLikert, formatLikertShort, Joins, Entities, WorkItemTargetTypes };

},{}],556:[function(require,module,exports){
'use strict';

/**
 * EntityMark -- the single source of an entity's nomenclature.
 *
 * A drawing set works because every sheet carries a mark, the mark is stable, and any sheet can
 * reference any other by it. WI-003 is always WI-003. This is where that mark is formed and read
 * back, and it is deliberately the ONLY place either happens.
 *
 * It lives here, dependency-free, rather than inside the Pict provider, because the mark has to be
 * identical on both sides of the wire. The provider requires pict and so can never be loaded by the
 * server, but BlueprintRender draws the public /shared/:token page server-side and the Connections
 * endpoint projects marks into its payload. Had the formatter stayed client-only, those surfaces
 * would each have grown their own copy of the padding and prefix rules, and the whole point of a
 * designator is that it cannot drift.
 *
 * The prefix is not invented here either: it is declared on the descriptor beside NumberField
 * (EntityDescriptors.js), so a new entity brings its own mark and this module stays a formatter.
 */

const libDescriptors = require('./EntityDescriptors.js');

// Three digits is the width a plan sheet reads best at (WI-006, not WI-6). A floor, never a ceiling:
// past 999 the number simply grows, so WI-1024 is untouched.
const NumberPad = 3;

function descriptorFor(pEntityKey)
{
	return (libDescriptors.Entities || {})[pEntityKey] || null;
}

/** The prefix an entity marks its records with, or '' when it carries no number. */
function prefix(pEntityKey)
{
	let tmpDescriptor = descriptorFor(pEntityKey);
	return (tmpDescriptor && tmpDescriptor.Designator) ? tmpDescriptor.Designator : '';
}

/**
 * The mark: 'WI-301'. Takes either the record or the bare number, because callers have one or the
 * other depending on how much of the row they loaded. An entity with no number has no mark and says
 * so with an empty string rather than inventing one.
 */
function designator(pEntityKey, pRecordOrNumber)
{
	let tmpPrefix = prefix(pEntityKey);
	if (!tmpPrefix) { return ''; }
	let tmpNumber = 0;
	if (typeof pRecordOrNumber === 'number') { tmpNumber = pRecordOrNumber; }
	else if (pRecordOrNumber && typeof pRecordOrNumber === 'object')
	{
		let tmpDescriptor = descriptorFor(pEntityKey);
		tmpNumber = Number(pRecordOrNumber[tmpDescriptor.NumberField]) || 0;
	}
	else { tmpNumber = Number(pRecordOrNumber) || 0; }
	if (!tmpNumber) { return ''; }
	return tmpPrefix + '-' + String(tmpNumber).padStart(NumberPad, '0');
}

// Built lazily and cached: prefix -> entity key, for reading a mark back.
let _byPrefix = null;
function prefixIndex()
{
	if (_byPrefix) { return _byPrefix; }
	_byPrefix = {};
	let tmpEntities = libDescriptors.Entities || {};
	Object.keys(tmpEntities).forEach((pKey) =>
	{
		let tmpPrefix = tmpEntities[pKey].Designator;
		if (tmpPrefix) { _byPrefix[String(tmpPrefix).toUpperCase()] = pKey; }
	});
	return _byPrefix;
}

/**
 * Split something that looks like a mark into prefix and number: 'WI-019' and 'wi19' both give
 * { wi, 19 }; '019' and '19' both give { '', 19 }. Null when there is no number in it at all, which
 * is the common case and lets a caller fall straight through to a text search.
 *
 * Leading zeros are dropped on both sides, so the padding a mark is DISPLAYED with never has to be
 * typed. That is the point: a person reads WI-019 and types 19.
 */
function splitMark(pText)
{
	let tmpMatch = String(pText || '').trim().toLowerCase().match(/^([a-z]{1,4})?[\s-]*(\d+)$/);
	if (!tmpMatch) { return null; }
	return { Prefix: tmpMatch[1] || '', Number: parseInt(tmpMatch[2], 10) };
}

/**
 * Read a mark back into what it points at: 'WI-301' -> { Entity:'WorkItem', Number:301 }. Returns
 * null for anything that is not a mark of a known entity, so free text can be scanned without
 * guarding every match.
 */
function parse(pDesignator)
{
	let tmpSplit = splitMark(pDesignator);
	if (!tmpSplit || !tmpSplit.Prefix) { return null; }
	let tmpEntity = prefixIndex()[tmpSplit.Prefix.toUpperCase()];
	if (!tmpEntity) { return null; }
	return { Entity: tmpEntity, Number: tmpSplit.Number };
}

/**
 * Does this row's mark answer the query? Compared structurally against the row's OWN designator
 * rather than a prefix table, so a bare number matches that number on any entity and a query
 * carrying a prefix must match the entity too. A row with no designator falls back to its number.
 */
function matchesQuery(pRow, pQuery)
{
	let tmpWanted = splitMark(pQuery);
	if (!tmpWanted) { return false; }
	let tmpHas = splitMark(pRow && pRow.Designator);
	if (!tmpHas)
	{
		let tmpNumber = Number((pRow && (pRow.MarkNumber || pRow.Number)) || 0);
		return !tmpWanted.Prefix && tmpNumber > 0 && tmpNumber === tmpWanted.Number;
	}
	if (tmpHas.Number !== tmpWanted.Number) { return false; }
	return !tmpWanted.Prefix || tmpWanted.Prefix === tmpHas.Prefix;
}

module.exports = { NumberPad, prefix, designator, parse, splitMark, matchesQuery, descriptorFor };

},{"./EntityDescriptors.js":555}],557:[function(require,module,exports){
'use strict';

/**
 * FeedbackPicker -- a reusable, filterable, multi-select feedback list for a modal.
 *
 * It is the feedback twin of the "bundle other work items" picker in the Generate-prompt dialog
 * (PictView-PromptAttachments _gen*): a search box, facet chips (Unaddressed only + the SourceType
 * lenses), a sortable metadata table, and a selected-chips row. Filtering rides on FocusFilters (which
 * already knows the Feedback facets: q / addressed / sourcetype / customer), so this is mostly the UI.
 *
 * It renders into a host element and uses event delegation (no inline onclick, no global handles), so
 * several instances can live at once and it drops cleanly into any Pict-Section-Modal body. The caller
 * mounts it after the modal DOM exists and reads selectedIDs() when the person confirms.
 *
 *   let tmpPicker = new FeedbackPicker();
 *   tmpPicker.configure(pAllFeedbackRows, { Exclude: [pIDSource], Selected: [] });
 *   tmpPicker.mount(document.getElementById('host'));
 *   ... on OK: tmpPicker.selectedIDs()  // [IDFeedback, ...] in the order picked
 */

const libFocus = require('./FocusFilters.js');

// The Feedback SourceType lenses (mirrors the model's SourceType enum), rendered as facet chips.
const _SOURCE_TYPES = ['Test Run', 'Customer Conversation', 'Developer Experience', 'Field Trial', 'Other'];
const _STYLE_ID = 'fbp-picker-styles';

function _esc(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh]));
}

function _truthy(pValue)
{
	return pValue === true || pValue === 1 || pValue === '1';
}

function _shortDate(pValue)
{
	let tmpDate = pValue ? new Date(pValue) : null;
	if (!tmpDate || isNaN(tmpDate.getTime())) { return ''; }
	return (tmpDate.getMonth() + 1) + '/' + tmpDate.getDate() + '/' + String(tmpDate.getFullYear()).slice(2);
}

// Injected once. Themed with the app --theme-color-* vars so it reads in light and dark, matching the
// work-item bundle picker (.ppa-pick-*) it is modeled on.
const _CSS =
	'.fbp-search { width: 100%; margin-bottom: 8px; }'
	+ '.fbp-chips { display: flex; flex-wrap: wrap; gap: 6px; margin: 0 0 8px; }'
	+ '.fbp-chip { border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); border-radius: 999px; padding: 2px 11px; font-size: 11.5px; cursor: pointer; }'
	+ '.fbp-chip:hover { background: var(--theme-color-background-hover, #eaf2ff); }'
	+ '.fbp-chip.on { background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff); border-color: transparent; }'
	+ '.fbp-table { max-height: 42vh; overflow: auto; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; }'
	+ '.fbp-tbl { width: 100%; border-collapse: collapse; font-size: 12.5px; }'
	+ '.fbp-tbl th { position: sticky; top: 0; z-index: 1; background: var(--theme-color-background-panel, #fff); text-align: left; padding: 6px 10px; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee); }'
	+ '.fbp-tbl td { padding: 6px 10px; border-bottom: 1px solid var(--theme-color-border-default, #eef1f6); color: var(--theme-color-text-primary, #2c3140); white-space: nowrap; }'
	+ '.fbp-tbl tr:last-child td { border-bottom: none; }'
	+ '.fbp-row { cursor: pointer; }'
	+ '.fbp-row:hover td { background: var(--theme-color-background-hover, #eaf2ff); }'
	+ '.fbp-row.on td { background: var(--theme-color-background-secondary, #eef1f6); }'
	+ '.fbp-title { white-space: normal; min-width: 15rem; }'
	+ '.fbp-num, .fbp-src, .fbp-upd { color: var(--theme-color-text-secondary, #5b6376); }'
	+ '.fbp-cb { width: 1px; }'
	+ '.fbp-tag { font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 5px; padding: 0 5px; margin-left: 6px; }'
	+ '.fbp-empty { text-align: center; color: var(--theme-color-text-secondary, #5b6376); padding: 16px; }'
	+ '.fbp-count { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); padding: 6px 4px 0; }'
	+ '.fbp-selected { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }'
	+ '.fbp-selchip { display: inline-flex; align-items: center; gap: 5px; max-width: 100%; background: var(--theme-color-background-secondary, #eef1f6); border-radius: 999px; padding: 2px 4px 2px 10px; font-size: 12px; }'
	+ '.fbp-selchip-t { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }'
	+ '.fbp-x { border: none; background: none; cursor: pointer; padding: 0 4px; font-size: 14px; line-height: 1; color: inherit; }';

function _injectCSS()
{
	if (typeof document === 'undefined') { return; }
	if (document.getElementById(_STYLE_ID)) { return; }
	let tmpStyle = document.createElement('style');
	tmpStyle.id = _STYLE_ID;
	tmpStyle.textContent = _CSS;
	document.head.appendChild(tmpStyle);
}

class FeedbackPicker
{
	constructor()
	{
		this._all = [];
		this._index = {};
		this._selected = [];
		this._filter = libFocus.emptyState();
		this._host = null;
	}

	// Load candidate feedback rows. Options: Exclude (ids to drop, e.g. the source feedback or the
	// already-linked set), Selected (ids to preselect). Returns this for chaining.
	configure(pRows, pOptions)
	{
		pOptions = pOptions || {};
		let tmpExclude = {};
		(pOptions.Exclude || []).forEach((pID) => { tmpExclude[Number(pID)] = true; });
		this._all = (pRows || []).filter((pRow) => pRow && !pRow.Deleted && !tmpExclude[Number(pRow.IDFeedback)]);
		this._index = {};
		this._all.forEach((pRow) => { this._index[pRow.IDFeedback] = { Number: pRow.FeedbackNumber || pRow.IDFeedback, Title: pRow.Title || '' }; });
		this._selected = (pOptions.Selected || []).map(Number).filter((pID) => pID > 0 && !tmpExclude[pID]);
		return this;
	}

	// The chosen feedback ids, in the order they were picked.
	selectedIDs()
	{
		return (this._selected || []).slice();
	}

	// Candidate rows after the live filter, newest-touched first (so the most relevant float up).
	visibleRows()
	{
		let tmpRows = libFocus.filterRows(this._all || [], this._filter || {}, { CurrentUserID: 0, Agents: {} });
		return tmpRows.slice().sort((pA, pB) =>
		{
			let tmpA = Date.parse(pA.UpdateDate || pA.CreateDate || '') || 0;
			let tmpB = Date.parse(pB.UpdateDate || pB.CreateDate || '') || 0;
			if (tmpA !== tmpB) { return tmpB - tmpA; }
			return (Number(pB.FeedbackNumber || 0) - Number(pA.FeedbackNumber || 0));
		});
	}

	// Render into pHostElement and wire delegated listeners (survive re-renders of the inner regions).
	mount(pHostElement)
	{
		if (!pHostElement) { return this; }
		_injectCSS();
		this._host = pHostElement;
		pHostElement.innerHTML =
			'<input class="fbp-search pict-input" placeholder="Search feedback...">'
			+ '<div class="fbp-chips"></div>'
			+ '<div class="fbp-table"></div>'
			+ '<div class="fbp-selected"></div>';
		let tmpSearch = pHostElement.querySelector('.fbp-search');
		if (tmpSearch) { tmpSearch.addEventListener('input', (pEvent) => { this._filter.q = (pEvent.target && pEvent.target.value) || ''; this._renderTable(); }); }
		let tmpChips = pHostElement.querySelector('.fbp-chips');
		if (tmpChips) { tmpChips.addEventListener('click', (pEvent) => { let tmpBtn = pEvent.target.closest('[data-facet]'); if (tmpBtn) { this._toggleFacet(tmpBtn.getAttribute('data-facet'), tmpBtn.getAttribute('data-value')); } }); }
		let tmpTable = pHostElement.querySelector('.fbp-table');
		if (tmpTable) { tmpTable.addEventListener('click', (pEvent) => { let tmpRow = pEvent.target.closest('[data-fb]'); if (tmpRow) { this._toggleRow(Number(tmpRow.getAttribute('data-fb'))); } }); }
		let tmpSelected = pHostElement.querySelector('.fbp-selected');
		if (tmpSelected) { tmpSelected.addEventListener('click', (pEvent) => { let tmpX = pEvent.target.closest('[data-remove]'); if (tmpX) { this._toggleRow(Number(tmpX.getAttribute('data-remove'))); } }); }
		this._renderChips();
		this._renderTable();
		this._renderSelected();
		return this;
	}

	_toggleFacet(pFacet, pValue)
	{
		if (pFacet === 'addressed') { this._filter.addressed = (this._filter.addressed === 'no') ? '' : 'no'; }
		else if (pFacet === 'sourcetype') { this._filter.sourcetype = (this._filter.sourcetype === pValue) ? '' : pValue; }
		this._renderChips();
		this._renderTable();
	}

	_toggleRow(pID)
	{
		pID = Number(pID) || 0;
		if (!pID) { return; }
		let tmpIndex = this._selected.indexOf(pID);
		if (tmpIndex >= 0) { this._selected.splice(tmpIndex, 1); } else { this._selected.push(pID); }
		this._renderTable();
		this._renderSelected();
	}

	_renderChips()
	{
		let tmpHost = this._host && this._host.querySelector('.fbp-chips');
		if (!tmpHost) { return; }
		let tmpHTML = '<button class="fbp-chip' + (this._filter.addressed === 'no' ? ' on' : '') + '" data-facet="addressed" data-value="no">Unaddressed only</button>';
		_SOURCE_TYPES.forEach((pType) =>
		{
			tmpHTML += '<button class="fbp-chip' + (this._filter.sourcetype === pType ? ' on' : '') + '" data-facet="sourcetype" data-value="' + _esc(pType) + '">' + _esc(pType) + '</button>';
		});
		tmpHost.innerHTML = tmpHTML;
	}

	_renderTable()
	{
		let tmpHost = this._host && this._host.querySelector('.fbp-table');
		if (!tmpHost) { return; }
		let tmpRows = this.visibleRows();
		let tmpSelectedSet = {};
		this._selected.forEach((pID) => { tmpSelectedSet[pID] = true; });
		let tmpBody = tmpRows.map((pRow) =>
		{
			let tmpID = Number(pRow.IDFeedback);
			let tmpOn = !!tmpSelectedSet[tmpID];
			let tmpTag = _truthy(pRow.Addressed) ? ' <span class="fbp-tag">addressed</span>' : '';
			return '<tr class="fbp-row' + (tmpOn ? ' on' : '') + '" data-fb="' + tmpID + '">'
				+ '<td class="fbp-cb"><input type="checkbox" tabindex="-1" ' + (tmpOn ? 'checked' : '') + '></td>'
				+ '<td class="fbp-num">#' + _esc(pRow.FeedbackNumber || tmpID) + '</td>'
				+ '<td class="fbp-title">' + _esc(pRow.Title || '') + tmpTag + '</td>'
				+ '<td class="fbp-src">' + _esc(pRow.SourceType || '') + '</td>'
				+ '<td class="fbp-upd">' + _esc(_shortDate(pRow.UpdateDate || pRow.CreateDate)) + '</td>'
				+ '</tr>';
		}).join('');
		if (!tmpBody) { tmpBody = '<tr><td colspan="5" class="fbp-empty">No feedback matches. Adjust the search or filters.</td></tr>'; }
		let tmpSelCount = this._selected.length;
		tmpHost.innerHTML = '<table class="fbp-tbl"><thead><tr><th></th><th>#</th><th>Title</th><th>Source</th><th>Updated</th></tr></thead><tbody>'
			+ tmpBody + '</tbody></table>'
			+ '<div class="fbp-count">' + tmpRows.length + ' shown' + (tmpSelCount ? (' &middot; ' + tmpSelCount + ' selected') : '') + '</div>';
	}

	_renderSelected()
	{
		let tmpHost = this._host && this._host.querySelector('.fbp-selected');
		if (!tmpHost) { return; }
		tmpHost.innerHTML = this._selected.map((pID) =>
		{
			let tmpMeta = this._index[pID] || { Number: pID, Title: '' };
			return '<span class="fbp-selchip"><span class="fbp-selchip-t">#' + _esc(tmpMeta.Number) + ' ' + _esc(tmpMeta.Title) + '</span>'
				+ '<button class="fbp-x" data-remove="' + pID + '" title="Remove">&times;</button></span>';
		}).join('');
	}
}

module.exports = FeedbackPicker;

},{"./FocusFilters.js":558}],558:[function(require,module,exports){
'use strict';

/**
 * FocusFilters — the shared filter / sort / saved-view engine for the board and
 * the Work Items list. One place to say what a "focus view" is, so both surfaces
 * narrow the same way and a URL means the same thing on either.
 *
 * A filter STATE is a flat, string-only object (so it round-trips through the URL
 * query with no escaping surprises):
 *   {
 *     q:        text search over Title + Description,
 *     status:   comma list of lane keys (Backlog,InProgress,...), '' = all,
 *     type:     comma list of WorkItem types, '' = all,
 *     priority: one Priority, '' = all,
 *     assignee: '' | 'self' | 'human' | 'ai' | 'unassigned' | 'u:<IDUser>',
 *     target:   '' | 'Vision' | 'Module' | 'Feature' | 'none',
 *     recent:   '' | one of RecentWindows.Key (activity window over UpdateDate),
 *     addressed:  '' | 'all' (both) | 'no' (open only) | 'yes' (addressed only) -- Feedback,
 *     customer:   '' (any) | 'none' | '<IDKeystoneCustomer>' -- Feedback's source customer,
 *     sourcetype: '' (any) | one SourceType value -- Feedback's origin,
 *     sort:     '<Field>:<asc|desc>' (list only; the board sorts by lane order),
 *     view:     the Key of the preset / saved view this state came from (a label
 *               hint only; the concrete keys above are what actually filter)
 *   }
 *
 * The functions here are framework-free (no pict, no DOM beyond an optional
 * localStorage for saved views) so a view, the board, or a test can all call them.
 */

// EntityMark is framework-free for the same reason this module is, so searching by a mark costs
// nothing here and reads it with exactly the parser that formed it.
const libEntityMark = require('./EntityMark.js');

// Recent-activity windows, newest-first, measured against a row's UpdateDate
// (falling back to CreateDate). '' / absent means "all time" (no window).
const RecentWindows =
[
	{ Key: '1d', Label: 'Active: last 24 hours', Short: '24h', Ms: 1 * 24 * 60 * 60 * 1000 },
	{ Key: '3d', Label: 'Active: last 3 days',   Short: '3d',  Ms: 3 * 24 * 60 * 60 * 1000 },
	{ Key: '7d', Label: 'Active: last 7 days',   Short: '7d',  Ms: 7 * 24 * 60 * 60 * 1000 },
	{ Key: '2w', Label: 'Active: last 2 weeks',  Short: '2w',  Ms: 14 * 24 * 60 * 60 * 1000 },
	{ Key: '1m', Label: 'Active: last 30 days',  Short: '30d', Ms: 30 * 24 * 60 * 60 * 1000 },
	{ Key: '1y', Label: 'Active: last year',     Short: '1y',  Ms: 365 * 24 * 60 * 60 * 1000 }
];

// The assignee facet choices (coarse role-of-assignee, not one-per-person). Specific
// people are appended by the view from the roster as 'u:<IDUser>'.
const AssigneeChoices =
[
	{ Key: '',           Label: 'Anyone' },
	{ Key: 'self',       Label: 'Me' },
	{ Key: 'human',      Label: 'Any human' },
	{ Key: 'ai',         Label: 'AI agent' },
	{ Key: 'unassigned', Label: 'Unassigned' }
];

// The target facet choices (what a work item is about).
const TargetChoices =
[
	{ Key: '',       Label: 'Any target' },
	{ Key: 'Vision', Label: 'About a Vision' },
	{ Key: 'Module', Label: 'About a Module' },
	{ Key: 'Feature', Label: 'About a Feature' },
	{ Key: 'none',   Label: 'No target' }
];

// The URL keys, in a fixed order so a shared link is stable regardless of the
// order the user touched the controls.
// The workflow sub-state facet (WorkItem): today just the QC kickback marker, so a person can
// pull up everything that did not pass review and is back for rework.
const WorkflowStatusChoices =
[
	{ Key: '',                 Label: 'Any workflow state' },
	{ Key: 'ChangesRequested', Label: 'Changes requested' }
];

// The "activity" lens: a compound focus that always shows the in-flight lanes and, for every
// OTHER lane, only rows touched inside the window. It is not expressible as a plain facet (it
// mixes a status test with a per-status recency test), so filterRows handles the single value
// 'related' specially. Shipped as WorkItem's default, so the list lands on "what is active plus
// what moved lately" (newest first) instead of the whole backlog in database order -- the point
// of #236 for a tenant with tens of thousands of items.
const ActivityActiveStatuses = { InProgress: true, Review: true };
const ActivityWindowMs = 3 * 24 * 60 * 60 * 1000; // resting lanes (Backlog/Todo/Done/Blocked): last 3 days

const StateKeys = ['q', 'status', 'type', 'priority', 'assignee', 'target', 'recent', 'addressed', 'customer', 'sourcetype', 'wfstatus', 'activity', 'sort', 'view'];

// Shipped focus views. Two groups: the five role lenses from the Vision #36
// blueprint, and the concrete named examples from the work item. Each is a
// filter+sort preset; selecting one expands its State onto the live filter.
const Presets =
[
	// The activity lens: in-flight work (InProgress/Review) always, resting lanes only when
	// touched inside the window, newest first. WorkItem's shipped default (see the descriptor),
	// and selectable by hand from the view picker like any other preset.
	{ Key: 'activity',      Group: 'Focus', Label: 'Activity: in-flight + recent', State: { activity: 'related', sort: 'UpdateDate:desc' } },
	// The five role lenses (one board, five ways to read it).
	{ Key: 'role-devops',   Group: 'Roles', Label: 'DevOps: release readiness', State: { status: 'Review,Done,Blocked', sort: 'UpdateDate:desc' } },
	{ Key: 'role-product',  Group: 'Roles', Label: 'Product: vision progress',  State: { target: 'Vision', sort: 'UpdateDate:desc' } },
	{ Key: 'role-project',  Group: 'Roles', Label: 'Project: flow & load',      State: { status: 'InProgress,Review,Blocked', sort: 'UpdateDate:asc' } },
	{ Key: 'role-dev',      Group: 'Roles', Label: 'Developer: my queue',       State: { assignee: 'self', status: 'Todo,InProgress,Review', sort: 'UpdateDate:desc' } },
	{ Key: 'role-ai',       Group: 'Roles', Label: 'Directing AI: agents',      State: { assignee: 'ai', status: 'InProgress,Review', sort: 'UpdateDate:desc' } },
	// The concrete saved-view examples the work item calls out.
	{ Key: 'focus-myopen',  Group: 'Focus', Label: 'My open work',   State: { assignee: 'self', status: 'Backlog,Todo,InProgress,Review', sort: 'WorkItemNumber:asc' } },
	{ Key: 'focus-aiwip',   Group: 'Focus', Label: 'AI in progress', State: { assignee: 'ai', status: 'InProgress', sort: 'UpdateDate:desc' } },
	{ Key: 'focus-review',  Group: 'Focus', Label: 'Needs review',   State: { status: 'Review', sort: 'UpdateDate:asc' } },
	{ Key: 'focus-blocked', Group: 'Focus', Label: 'Blocked',        State: { status: 'Blocked', sort: 'UpdateDate:asc' } }
];

// ── state helpers ────────────────────────────────────────────────────────────

function emptyState()
{
	return { q: '', status: '', type: '', priority: '', assignee: '', target: '', recent: '', addressed: '', customer: '', sourcetype: '', wfstatus: '', activity: '', sort: '', view: '' };
}

// Whether any *filtering* facet is set (sort + view are not filters). Drives the
// "showing N of M" hint and whether the Clear button is meaningful. 'addressed'
// only counts as narrowing when it hides one side ('no'/'yes'); '' and 'all' show both.
function isFiltered(pState)
{
	let tmpState = pState || {};
	return !!(tmpState.q || tmpState.status || tmpState.type || tmpState.priority || tmpState.assignee || tmpState.target || tmpState.recent
		|| (tmpState.addressed && tmpState.addressed !== 'all') || tmpState.customer || tmpState.sourcetype || tmpState.wfstatus || tmpState.activity);
}

// A preset's full state (its partial merged onto an empty state, tagged with its Key).
function presetState(pPreset)
{
	if (!pPreset) { return emptyState(); }
	return Object.assign(emptyState(), pPreset.State || {}, { view: pPreset.Key });
}

function findPreset(pKey)
{
	for (let i = 0; i < Presets.length; i++) { if (Presets[i].Key === pKey) { return Presets[i]; } }
	return null;
}

// ── URL round-trip ───────────────────────────────────────────────────────────

function stateToQuery(pState)
{
	let tmpState = pState || {};
	let tmpParts = [];
	for (let i = 0; i < StateKeys.length; i++)
	{
		let tmpKey = StateKeys[i];
		let tmpValue = tmpState[tmpKey];
		if (tmpValue == null || tmpValue === '') { continue; }
		tmpParts.push(encodeURIComponent(tmpKey) + '=' + encodeURIComponent(String(tmpValue)));
	}
	return tmpParts.join('&');
}

function queryToState(pQuery)
{
	let tmpState = emptyState();
	let tmpQuery = String(pQuery || '');
	if (tmpQuery.charAt(0) === '?') { tmpQuery = tmpQuery.slice(1); }
	if (!tmpQuery) { return tmpState; }
	let tmpPairs = tmpQuery.split('&');
	for (let i = 0; i < tmpPairs.length; i++)
	{
		if (!tmpPairs[i]) { continue; }
		let tmpEq = tmpPairs[i].indexOf('=');
		let tmpKey = decodeURIComponent(tmpEq >= 0 ? tmpPairs[i].slice(0, tmpEq) : tmpPairs[i]);
		let tmpValue = tmpEq >= 0 ? decodeURIComponent(tmpPairs[i].slice(tmpEq + 1)) : '';
		if (StateKeys.indexOf(tmpKey) !== -1) { tmpState[tmpKey] = tmpValue; }
	}
	return tmpState;
}

// The query portion of the current hash (everything after the first '?'), for a
// deep-link / reload read. Safe in a non-browser context (returns '').
function readHashQuery()
{
	if (typeof window === 'undefined' || !window.location) { return ''; }
	let tmpHash = window.location.hash || '';
	let tmpQ = tmpHash.indexOf('?');
	return (tmpQ >= 0) ? tmpHash.slice(tmpQ + 1) : '';
}

// ── an arbitrary view's own query state ──────────────────────────────────────
// The pair above serialises the ENTITY FILTER state, whose keys are a fixed whitelist. A view with
// filters of its own (the issues board's type / customer / assignee / severity) has no home in that
// shape, and squeezing it in would mean widening a whitelist that every entity list shares. These
// two do the same base-preserving replaceState for any flat object, so a view can make its own state
// linkable without owning the URL mechanics.
function writeHashQuery(pParams)
{
	if (typeof window === 'undefined' || !window.location || !window.history
		|| typeof window.history.replaceState !== 'function') { return; }
	let tmpHash = window.location.hash || '';
	let tmpQ = tmpHash.indexOf('?');
	let tmpBase = (tmpQ >= 0) ? tmpHash.slice(0, tmpQ) : tmpHash;
	if (!tmpBase) { tmpBase = '#/'; }
	let tmpParams = pParams || {};
	let tmpParts = Object.keys(tmpParams)
		.filter((pKey) => (tmpParams[pKey] !== null) && (typeof tmpParams[pKey] !== 'undefined') && (tmpParams[pKey] !== ''))
		.map((pKey) => encodeURIComponent(pKey) + '=' + encodeURIComponent(String(tmpParams[pKey])));
	let tmpNewHash = tmpParts.length ? (tmpBase + '?' + tmpParts.join('&')) : tmpBase;
	window.history.replaceState(null, '', (window.location.pathname || '') + (window.location.search || '') + tmpNewHash);
}

function readHashParams()
{
	let tmpOut = {};
	let tmpQuery = readHashQuery();
	if (!tmpQuery) { return tmpOut; }
	tmpQuery.split('&').forEach((pPair) =>
	{
		if (!pPair) { return; }
		let tmpEq = pPair.indexOf('=');
		let tmpKey = (tmpEq >= 0) ? pPair.slice(0, tmpEq) : pPair;
		let tmpValue = (tmpEq >= 0) ? pPair.slice(tmpEq + 1) : '';
		try { tmpOut[decodeURIComponent(tmpKey)] = decodeURIComponent(tmpValue); }
		catch (pError) { /* a malformed pair is not worth losing the rest of the query over */ }
	});
	return tmpOut;
}

// Read the live state from the URL. When the hash carries no focus query (a fresh
// load or a clean deep link), fall back to pDefaults merged onto an empty state --
// this is how Feedback lands on "unaddressed only" the first time, while any URL the
// user has already touched stays authoritative (its explicit values win).
function stateFromHash(pDefaults)
{
	let tmpQuery = readHashQuery();
	if (!tmpQuery) { return Object.assign(emptyState(), pDefaults || {}); }
	return queryToState(tmpQuery);
}

// Rewrite the query on the current hash WITHOUT triggering the router (history
// replace fires no hashchange), so the URL stays shareable and reload-safe while
// the view keeps ownership of rendering. The base path is preserved.
function writeHashState(pState)
{
	if (typeof window === 'undefined' || !window.location || !window.history || typeof window.history.replaceState !== 'function') { return; }
	let tmpHash = window.location.hash || '';
	let tmpQ = tmpHash.indexOf('?');
	let tmpBase = (tmpQ >= 0) ? tmpHash.slice(0, tmpQ) : tmpHash;
	if (!tmpBase) { tmpBase = '#/'; }
	let tmpQuery = stateToQuery(pState);
	let tmpNewHash = tmpQuery ? (tmpBase + '?' + tmpQuery) : tmpBase;
	let tmpURL = (window.location.pathname || '') + (window.location.search || '') + tmpNewHash;
	window.history.replaceState(null, '', tmpURL);
}

// ── assignee classification ──────────────────────────────────────────────────

// Build the context filterRows needs to resolve self / human / AI, from the team
// roster ([{ IDUser, IsAgent }]) and the signed-in user's IDUser.
function buildContext(pRoster, pCurrentUserID)
{
	let tmpAgents = {};
	let tmpRoster = Array.isArray(pRoster) ? pRoster : [];
	for (let i = 0; i < tmpRoster.length; i++)
	{
		if (Number(tmpRoster[i].IsAgent) === 1) { tmpAgents[Number(tmpRoster[i].IDUser)] = true; }
	}
	return { CurrentUserID: Number(pCurrentUserID) || 0, Agents: tmpAgents };
}

function _matchAssignee(pIDAssigned, pFilter, pContext)
{
	let tmpID = Number(pIDAssigned) || 0;
	if (!pFilter) { return true; }
	if (pFilter === 'self') { return tmpID !== 0 && tmpID === pContext.CurrentUserID; }
	if (pFilter === 'unassigned') { return tmpID === 0; }
	if (pFilter === 'ai') { return tmpID !== 0 && !!pContext.Agents[tmpID]; }
	// A human is anyone assigned who is not a known agent (roster gaps read as human).
	if (pFilter === 'human') { return tmpID !== 0 && !pContext.Agents[tmpID]; }
	if (pFilter.indexOf('u:') === 0) { return tmpID === (Number(pFilter.slice(2)) || 0); }
	return true;
}

// ── the filter itself ────────────────────────────────────────────────────────

function _listToSet(pValue)
{
	let tmpValue = String(pValue || '').trim();
	if (!tmpValue) { return null; }
	let tmpSet = {};
	let tmpParts = tmpValue.split(',');
	for (let i = 0; i < tmpParts.length; i++)
	{
		let tmpPart = tmpParts[i].trim();
		if (tmpPart) { tmpSet[tmpPart] = true; }
	}
	return tmpSet;
}

function recentMs(pKey)
{
	for (let i = 0; i < RecentWindows.length; i++) { if (RecentWindows[i].Key === pKey) { return RecentWindows[i].Ms; } }
	return 0;
}

function _parseDate(pValue)
{
	if (!pValue) { return 0; }
	let tmpTime = Date.parse(String(pValue));
	return isNaN(tmpTime) ? 0 : tmpTime;
}

// Loose truthiness for a stored flag. Meadow stores Boolean as SMALLINT, so a row's
// Addressed comes back as 0/1 (number) or '0'/'1' (string) -- and JS makes '0' truthy,
// which this guards against. Missing/null reads as false.
function _truthy(pValue)
{
	if (pValue === null || typeof pValue === 'undefined' || pValue === false) { return false; }
	if (pValue === 0 || pValue === '0' || pValue === '') { return false; }
	return true;
}

/**
 * Filter a flat array of rows by a state. Rows are plain records; the fields read
 * are Status, Type, Priority, TargetType, IDAssignedUser, UpdateDate/CreateDate,
 * Title, Description, and (for Feedback) Addressed, IDKeystoneCustomer, SourceType,
 * Body. Any field a row lacks is simply treated as absent (so the same engine runs
 * over WorkItem rows, Feedback rows, and board card models alike).
 */
// Searching by the mark reads it with the same parser that formed it, so "WI-019" can never mean one
// thing to the search box and another to the thing it is searching.
const splitMark = libEntityMark.splitMark;
const markMatchesQuery = libEntityMark.matchesQuery;

function filterRows(pRows, pState, pContext)
{
	let tmpState = pState || {};
	let tmpContext = pContext || { CurrentUserID: 0, Agents: {} };
	let tmpStatusSet = _listToSet(tmpState.status);
	let tmpTypeSet = _listToSet(tmpState.type);
	let tmpQuery = String(tmpState.q || '').trim().toLowerCase();
	let tmpRecentMs = recentMs(tmpState.recent);
	let tmpAddressed = String(tmpState.addressed || '');
	let tmpCustomer = String(tmpState.customer || '');
	let tmpSourceType = String(tmpState.sourcetype || '');
	let tmpActivity = String(tmpState.activity || '');
	let tmpNow = Date.now();

	return (pRows || []).filter((pRow) =>
	{
		// Activity lens: keep the in-flight lanes always; keep any other lane only when it was
		// touched inside the window. Composes with the explicit facets below (a person can still
		// narrow the activity view by type, assignee, search, etc.).
		if (tmpActivity === 'related')
		{
			let tmpActStatus = String(pRow.Status == null ? '' : pRow.Status);
			if (!ActivityActiveStatuses[tmpActStatus])
			{
				let tmpActWhen = _parseDate(pRow.UpdateDate || pRow.CreateDate);
				if (!tmpActWhen || (tmpNow - tmpActWhen) > ActivityWindowMs) { return false; }
			}
		}
		if (tmpStatusSet && !tmpStatusSet[String(pRow.Status == null ? '' : pRow.Status)]) { return false; }
		if (tmpTypeSet && !tmpTypeSet[String(pRow.Type == null ? '' : pRow.Type)]) { return false; }
		if (tmpState.priority && String(pRow.Priority == null ? '' : pRow.Priority) !== tmpState.priority) { return false; }
		// Addressed lifecycle facet (Feedback): 'no' = open only, 'yes' = addressed only,
		// '' / 'all' = both. A row lacking the column reads as not addressed.
		if (tmpAddressed === 'no' && _truthy(pRow.Addressed)) { return false; }
		if (tmpAddressed === 'yes' && !_truthy(pRow.Addressed)) { return false; }
		// Keystone customer facet (Feedback): a specific IDKeystoneCustomer, or 'none' for
		// feedback tied to no customer. A row lacking the column never matches a specific one.
		if (tmpCustomer)
		{
			let tmpIDCustomer = Number(pRow.IDKeystoneCustomer) || 0;
			if (tmpCustomer === 'none') { if (tmpIDCustomer !== 0) { return false; } }
			else if (String(tmpIDCustomer) !== tmpCustomer) { return false; }
		}
		// Source-type facet (Feedback): exact SourceType match.
		if (tmpSourceType && String(pRow.SourceType == null ? '' : pRow.SourceType) !== tmpSourceType) { return false; }
		// Workflow sub-state facet (WorkItem): exact WorkflowStatus match (e.g. ChangesRequested).
		if (tmpState.wfstatus && String(pRow.WorkflowStatus == null ? '' : pRow.WorkflowStatus) !== tmpState.wfstatus) { return false; }
		if (tmpState.target)
		{
			let tmpTargetType = String(pRow.TargetType == null ? '' : pRow.TargetType);
			if (tmpState.target === 'none') { if (tmpTargetType && tmpTargetType !== 'None') { return false; } }
			else if (tmpTargetType !== tmpState.target) { return false; }
		}
		if (tmpState.assignee && !_matchAssignee(pRow.IDAssignedUser, tmpState.assignee, tmpContext)) { return false; }
		if (tmpRecentMs)
		{
			let tmpWhen = _parseDate(pRow.UpdateDate || pRow.CreateDate);
			if (!tmpWhen || (tmpNow - tmpWhen) > tmpRecentMs) { return false; }
		}
		if (tmpQuery)
		{
			// The searchable text a row can carry: Title + Description (WorkItem),
			// Body (Feedback), Name + Summary (Vision / Module / Feature). A row
			// lacking any of these just contributes '' for it.
			let tmpHay = (String(pRow.Title || '') + ' ' + String(pRow.Name || '') + ' ' + String(pRow.Summary || '') + ' ' + String(pRow.Description || '') + ' ' + String(pRow.Body || '')).toLowerCase();
			// A search that names a mark should find it. People refer to a card as WI-019, or wi-19, or
			// just 19, and none of those appear in the prose. Matched ALONGSIDE the text, never instead
			// of it: "P6" reads as a mark query but is really a phrase in a title, so narrowing to the
			// mark interpretation would lose the result the person was actually looking for.
			if (tmpHay.indexOf(tmpQuery) === -1 && !markMatchesQuery(pRow, tmpQuery)) { return false; }
		}
		return true;
	});
}

// Parse a 'Field:dir' sort string into { Field, Dir }, or null when unset/invalid.
function parseSort(pSort)
{
	let tmpSort = String(pSort || '').trim();
	if (!tmpSort) { return null; }
	let tmpColon = tmpSort.indexOf(':');
	let tmpField = (tmpColon >= 0) ? tmpSort.slice(0, tmpColon) : tmpSort;
	let tmpDir = (tmpColon >= 0) ? tmpSort.slice(tmpColon + 1) : 'asc';
	if (!tmpField) { return null; }
	return { Field: tmpField, Dir: (tmpDir === 'desc') ? 'desc' : 'asc' };
}

// ── saved views (per user, per entity; localStorage) ─────────────────────────
// Personal named presets. The URL is the shareable source of truth; these are the
// user's own quick-switch list, merged with the shipped Presets in the picker.

function _storageKey(pEntity, pUserID)
{
	return 'plansheet.focusviews.' + (pEntity || 'WorkItem') + '.' + (Number(pUserID) || 0);
}

function _localStorage()
{
	try { return (typeof window !== 'undefined' && window.localStorage) ? window.localStorage : null; }
	catch (pErr) { return null; }
}

function loadSavedViews(pEntity, pUserID)
{
	let tmpStore = _localStorage();
	if (!tmpStore) { return []; }
	try
	{
		let tmpRaw = tmpStore.getItem(_storageKey(pEntity, pUserID));
		let tmpList = tmpRaw ? JSON.parse(tmpRaw) : [];
		return Array.isArray(tmpList) ? tmpList : [];
	}
	catch (pErr) { return []; }
}

function _persistSavedViews(pEntity, pUserID, pList)
{
	let tmpStore = _localStorage();
	if (!tmpStore) { return; }
	try { tmpStore.setItem(_storageKey(pEntity, pUserID), JSON.stringify(pList || [])); }
	catch (pErr) { /* storage full / unavailable — saved views are best-effort */ }
}

// Save (or overwrite by name) a named view. Returns the stored view record.
function saveSavedView(pEntity, pUserID, pName, pState)
{
	let tmpName = String(pName || '').trim();
	if (!tmpName) { return null; }
	let tmpList = loadSavedViews(pEntity, pUserID);
	let tmpClean = Object.assign(emptyState(), pState || {});
	tmpClean.view = '';
	let tmpKey = 'saved:' + tmpName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
	let tmpRecord = { Key: tmpKey, Group: 'Saved', Label: tmpName, State: tmpClean };
	let tmpFound = false;
	for (let i = 0; i < tmpList.length; i++)
	{
		if (tmpList[i].Key === tmpKey) { tmpList[i] = tmpRecord; tmpFound = true; break; }
	}
	if (!tmpFound) { tmpList.push(tmpRecord); }
	_persistSavedViews(pEntity, pUserID, tmpList);
	return tmpRecord;
}

function deleteSavedView(pEntity, pUserID, pKey)
{
	let tmpList = loadSavedViews(pEntity, pUserID).filter((pView) => pView.Key !== pKey);
	_persistSavedViews(pEntity, pUserID, tmpList);
	return tmpList;
}

// The full picker list for an entity: shipped Presets first, then the user's saved
// views. A saved view carries its own State; a preset's State is its partial.
function allViews(pEntity, pUserID)
{
	return Presets.concat(loadSavedViews(pEntity, pUserID));
}

function viewState(pEntity, pUserID, pKey)
{
	let tmpAll = allViews(pEntity, pUserID);
	for (let i = 0; i < tmpAll.length; i++)
	{
		if (tmpAll[i].Key === pKey)
		{
			return (tmpAll[i].Group === 'Saved')
				? Object.assign(emptyState(), tmpAll[i].State, { view: pKey })
				: presetState(tmpAll[i]);
		}
	}
	return null;
}

// ── list preferences (per user, per entity; localStorage) ────────────────────
// Which columns a user has shown/hidden on an entity's list, plus the sort they
// last chose there (for entities whose sort does not live in the URL). A flat blob:
//   { columns: { <ColumnField>: <bool> }, sort: '<Field>:<asc|desc>' }
// Absent column keys fall back to the descriptor's own default (DefaultHidden),
// so a column added to a descriptor later still shows up without clearing storage.

function _listPrefsKey(pEntity, pUserID)
{
	return 'plansheet.listprefs.' + (pEntity || '') + '.' + (Number(pUserID) || 0);
}

function loadListPrefs(pEntity, pUserID)
{
	let tmpStore = _localStorage();
	if (!tmpStore) { return {}; }
	try
	{
		let tmpRaw = tmpStore.getItem(_listPrefsKey(pEntity, pUserID));
		let tmpObj = tmpRaw ? JSON.parse(tmpRaw) : {};
		return (tmpObj && typeof tmpObj === 'object') ? tmpObj : {};
	}
	catch (pErr) { return {}; }
}

function saveListPrefs(pEntity, pUserID, pPrefs)
{
	let tmpStore = _localStorage();
	if (!tmpStore) { return; }
	try { tmpStore.setItem(_listPrefsKey(pEntity, pUserID), JSON.stringify(pPrefs || {})); }
	catch (pErr) { /* storage full / unavailable -- list prefs are best-effort */ }
}

// ── default filter (per user, per entity; localStorage) ──────────────────────
// The user's chosen landing filter for one screen. A full filter STATE (so "none" is a
// real, storable choice -- an empty state -- distinct from "no default set", which is
// absence). When present it overrides the descriptor's shipped Filter.Defaults on a clean
// URL (an explicit URL the user navigated to still wins; see stateFromHash). This is #236's
// "set my own default filter per screen": a person pins the list the way they like it once.

function _defaultStateKey(pEntity, pUserID)
{
	return 'plansheet.focusdefault.' + (pEntity || '') + '.' + (Number(pUserID) || 0);
}

// The stored default state for this entity, or null when the user has set none (fall back to
// the descriptor's shipped default). Round-tripped through the same emptyState shape as the URL.
function loadDefaultState(pEntity, pUserID)
{
	let tmpStore = _localStorage();
	if (!tmpStore) { return null; }
	try
	{
		let tmpRaw = tmpStore.getItem(_defaultStateKey(pEntity, pUserID));
		if (!tmpRaw) { return null; }
		let tmpObj = JSON.parse(tmpRaw);
		return (tmpObj && typeof tmpObj === 'object') ? Object.assign(emptyState(), tmpObj) : null;
	}
	catch (pErr) { return null; }
}

// Save the current filter as this user's default for the entity. An empty state is a valid
// default ("none"); to remove the default entirely use clearDefaultState.
function saveDefaultState(pEntity, pUserID, pState)
{
	let tmpStore = _localStorage();
	if (!tmpStore) { return; }
	let tmpClean = Object.assign(emptyState(), pState || {});
	try { tmpStore.setItem(_defaultStateKey(pEntity, pUserID), JSON.stringify(tmpClean)); }
	catch (pErr) { /* storage full / unavailable -- default filter is best-effort */ }
}

function clearDefaultState(pEntity, pUserID)
{
	let tmpStore = _localStorage();
	if (!tmpStore) { return; }
	try { tmpStore.removeItem(_defaultStateKey(pEntity, pUserID)); }
	catch (pErr) { /* best-effort */ }
}

module.exports =
{
	writeHashQuery: writeHashQuery,
	readHashParams: readHashParams,
	RecentWindows, AssigneeChoices, TargetChoices, WorkflowStatusChoices, StateKeys, Presets,
	ActivityActiveStatuses, ActivityWindowMs,
	emptyState, isFiltered, presetState, findPreset,
	stateToQuery, queryToState, readHashQuery, stateFromHash, writeHashState,
	buildContext, filterRows, parseSort, recentMs, truthy: _truthy,
	splitMark, markMatchesQuery,
	loadSavedViews, saveSavedView, deleteSavedView, allViews, viewState,
	loadListPrefs, saveListPrefs,
	loadDefaultState, saveDefaultState, clearDefaultState
};

},{"./EntityMark.js":556}],559:[function(require,module,exports){
'use strict';

/**
 * FocusQuery
 * ----------
 * Turn a list's filter state and sort into a meadow-filter string the SERVER can answer (WI #433).
 *
 * THE BUG THIS EXISTS FOR: the list fetched the first 250 rows and then sorted and filtered that array
 * in the browser. Sorting 1,075 blueprints descending by mark put 250 at the top and 1 at the bottom,
 * because 250 was the largest thing the client had ever been shown. Every sort was a sort of an
 * arbitrary quarter, and nothing on the screen said so.
 *
 * NEVER SILENTLY PARTIAL. That is the whole rule here. Anything this cannot express server-side is
 * reported in `Unexpressed` rather than dropped, so the caller can fetch the full set and filter it
 * locally instead. A filter quietly applied to one page is precisely the defect being fixed, and it
 * would be easy to reintroduce one facet at a time.
 *
 * THREE PROPERTIES OF THE DSL WERE ESTABLISHED BY GENERATING SQL, not by reading docs. Each one is a
 * silent wrong answer if you get it wrong, and each has a test.
 *
 * 1. FSF NEEDS FOUR TERMS. `FSF~Name~DESC` produces NO ORDER BY at all; `FSF~Name~DESC~` produces it.
 *    The parser walks the string four terms at a time, so a three-term stanza is never seen. A sort
 *    that silently does not sort is the same family of bug as the one being fixed.
 *
 * 2. AN UNWRAPPED OR ESCAPES THE TENANCY FILTER, and this one is a cross-tenant leak rather than a
 *    cosmetic fault. The server appends `IDCustomer` as an AND after whatever arrives, and AND binds
 *    tighter than OR:
 *
 *        WHERE "Title" LIKE :a OR "Description" LIKE :b AND "IDCustomer" = :c
 *
 *    reads as `Title LIKE a OR (Description LIKE b AND IDCustomer = c)`, so every row in the database
 *    whose Title matches comes back, whoever owns it. Wrapping the group fixes it:
 *
 *        WHERE ( "Title" LIKE :a OR "Description" LIKE :b ) AND "IDCustomer" = :c
 *
 *    So EVERY OR group this module emits is wrapped in FOP/FCP. There is no exception, and the test
 *    asserts the generated SQL rather than the generated string.
 *
 * 3. BLANKS CHANGE ENDS, and this is a real behaviour change rather than a bug to fix here. The old
 *    browser comparator coerced null to '', so empty rows sorted to the TOP ascending. Postgres is
 *    NULLS LAST on ASC and NULLS FIRST on DESC -- exactly inverted at both ends. Every column in this
 *    schema is nullable, so it can show anywhere, though in practice the sortable columns are stamped
 *    on write and hold few nulls.
 *
 *    Matching the old placement would mean emitting NULLS FIRST/LAST, which foxhound's ORDER BY
 *    builder does not support, so it is a change to a sibling module and a release of it. Not worth
 *    blocking this on: the server's placement is the standard one, and a row with no value in the
 *    column you sorted by has no obviously correct home. Recorded so the first person to notice finds
 *    an answer instead of a mystery.
 *
 * 4. FBD IS BROKEN. `FBD~UpdateDate~GT~2026-08-25` emits `WHERE "DATE(UpdateDate)" > :x` -- a quoted
 *    identifier naming a column that does not exist, so the query errors. Date windows use plain FBV.
 *
 * 5. A COLUMN THE ENTITY DOES NOT HAVE IS A 500, NOT A WRONG ANSWER. foxhound quotes whatever field
 *    name it is handed, so `FBV~Body~LK~%x%` against Blueprint compiles to `WHERE "Body" LIKE :x` and
 *    Postgres refuses the whole query. Of the twenty-one lists, exactly one (Feedback) has a Body
 *    column and exactly one (WorkItem) has both Title and Description, so a fixed search-field list
 *    would have failed on the FIRST keystroke of nearly every search box in the app. The same hazard
 *    reaches the facets by a longer road: filter state is restored from the URL hash and from saved
 *    preferences, neither of which is scoped to the screen, so a `priority=High` left in the hash can
 *    arrive at a list whose table has no Priority column.
 *
 *    So every field this emits is checked against what the DESCRIPTOR DECLARES (see _askable), and a
 *    field it cannot vouch for is reported in Unexpressed rather than sent. Declared, not guessed:
 *    the same lesson as the Computed check below, which exists because a naming convention was read
 *    as a contract once already.
 *
 * @license MIT
 * @author Steven Velozo <steven@velozo.com>
 */

// A stanza is four tilde-separated terms. Anything short is silently ignored by the parser, so this is
// the only way a stanza should ever be built.
function _stanza(pInstruction, pField, pOperator, pValue)
{
	return [pInstruction, pField, pOperator, String(pValue == null ? '' : pValue)].join('~');
}

/** Tildes separate stanzas, so a value carrying one would split into a different query entirely. */
function _safe(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/~/g, ' ');
}

/**
 * Wrap a set of OR stanzas so the group binds before the server's tenancy AND.
 * Returns '' for an empty group rather than an empty paren pair, which parses to nothing useful.
 */
function _orGroup(pStanzas)
{
	let tmpStanzas = (pStanzas || []).filter(Boolean);
	if (!tmpStanzas.length) { return ''; }
	if (tmpStanzas.length === 1) { return tmpStanzas[0]; }
	return [_stanza('FOP', '', '', '')].concat(tmpStanzas).concat([_stanza('FCP', '', '', '')]).join('~');
}

/**
 * Columns meadow stamps on every table in this schema, so they can be asked for whatever a descriptor
 * chooses to render. A list that shows no Updated column still has an activity window over UpdateDate.
 */
const _AUDIT_FIELDS = { CreateDate: true, UpdateDate: true };

/**
 * The column each entry in a descriptor's Filter.Facets reads. A hand-written Filter config is the
 * only evidence some of these columns exist at all: WorkItem renders no WorkflowStatus column and
 * Feedback renders neither Addressed nor IDKeystoneCustomer, yet all three are real and all three are
 * facets those two lists offer. Reading the facet list is therefore part of reading the declaration,
 * not a convenience.
 */
const _FACET_FIELD =
{
	Status: 'Status',
	Type: 'Type',
	Priority: 'Priority',
	WorkflowStatus: 'WorkflowStatus',
	SourceType: 'SourceType',
	Customer: 'IDKeystoneCustomer',
	Addressed: 'Addressed',
	Assignee: 'IDAssignedUser',
	Target: 'TargetType'
};

/**
 * Whether the server can be asked about a field on this entity, per what the descriptor DECLARES.
 *
 * Four kinds of evidence, every one of them a declaration rather than a guess:
 *   - the audit columns meadow puts on every table;
 *   - the identity and number columns, which exist by construction (the descriptor is addressed by
 *     IDField and marks are formed from NumberField);
 *   - a rendered column that is not Computed, or a form field, both of which name real columns --
 *     Fields especially, since save() posts them straight back;
 *   - a facet the descriptor's own filter config offers.
 *
 * Anything else is unknown, and unknown must mean "ask locally" rather than "send it and see". The
 * cost of being wrong here is not a wrong answer, it is a 500 on a query Postgres will not compile.
 */
function _askable(pDescriptor, pField)
{
	let tmpDescriptor = pDescriptor || {};
	let tmpField = String(pField || '');
	if (!tmpField) { return false; }
	if (_AUDIT_FIELDS[tmpField]) { return true; }
	if (tmpField === tmpDescriptor.IDField) { return true; }
	if (tmpField === tmpDescriptor.NumberField) { return true; }
	if ((tmpDescriptor.Columns || []).some((pColumn) => pColumn && (pColumn.F === tmpField) && !pColumn.Computed)) { return true; }
	if ((tmpDescriptor.Fields || []).some((pFormField) => pFormField && (pFormField.F === tmpField))) { return true; }
	let tmpFacets = (tmpDescriptor.Filter && tmpDescriptor.Filter.Facets) || [];
	return tmpFacets.some((pFacet) => _FACET_FIELD[pFacet] === tmpField);
}

/** The fields a text search looks in, on an entity that has them. A row lacking one never matches on it. */
const _SEARCH_FIELDS = ['Title', 'Name', 'Summary', 'Description', 'Body'];

/** Which of those this entity actually declares. Empty means its search cannot go to the server at all. */
function searchFields(pDescriptor)
{
	return _SEARCH_FIELDS.filter((pField) => _askable(pDescriptor, pField));
}

/**
 * Sort stanzas for a list.
 *
 * ALWAYS TIEBREAKS ON THE PRIMARY KEY. Two rows with the same UpdateDate have no defined order in SQL,
 * and an undefined order across a page boundary means a row can appear on two pages or on none. That
 * is invisible in a 3-row fixture and routine in 1,075.
 */
function sortStanzas(pSort, pDescriptor)
{
	let tmpDescriptor = pDescriptor || {};
	let tmpIDField = tmpDescriptor.IDField || '';
	let tmpField = (pSort && pSort.Field) || '';
	// ACCEPTS Dir OR Direction. The list view stores its sort as { Field, Dir } (PictView-EntityList
	// sortBy), while a descriptor's DefaultSort parses to { Field, Direction }. Reading only one of
	// them makes every sort from the other source silently ascending -- the same shape of silent wrong
	// answer as a three-term FSF stanza, and just as invisible on a three-row fixture.
	let tmpRaw = String((pSort && (pSort.Direction || pSort.Dir)) || '').toLowerCase();
	let tmpDirection = ((tmpRaw === 'desc') || (tmpRaw === 'descending')) ? 'DESC' : 'ASC';
	let tmpOut = [];

	// A mark column (WI-019) is composed in the browser from the entity's number field, so ordering by
	// it means ordering by that number. Without this the one column people most often sort by is the
	// one that cannot go server-side.
	if ((tmpField === 'Designator') || (tmpField === 'MarkNumber'))
	{
		tmpField = tmpDescriptor.NumberField || '';
	}

	if (tmpField) { tmpOut.push(_stanza('FSF', tmpField, tmpDirection, '')); }
	if (tmpIDField && (tmpField !== tmpIDField)) { tmpOut.push(_stanza('FSF', tmpIDField, tmpDirection, '')); }
	return tmpOut;
}

/**
 * Which sorts cannot be asked of the server.
 *
 * Only one exists today: a WorkItem's session count is a cross-entity aggregate stamped onto rows in
 * the browser, so there is no column to order by. Named rather than inferred, because the honest
 * answer is to fetch everything for that one column, not to pretend it sorted.
 */
function sortIsExpressible(pSort, pDescriptor)
{
	let tmpDescriptor = pDescriptor || {};
	let tmpField = (pSort && pSort.Field) || '';
	if (!tmpField) { return true; }
	if ((tmpField === 'Designator') || (tmpField === 'MarkNumber'))
	{
		return !!tmpDescriptor.NumberField;
	}
	// ASKS THE DESCRIPTOR, NOT THE NAME. An earlier version of this read the leading underscore as a
	// convention for "client-derived", which caught WorkItem._SessionCount and silently missed
	// NodeRegistration's Roles and Workspaces -- both composed in the browser from CapabilityJSON, and
	// neither a column in the database. Sorting on either would have asked Postgres to ORDER BY a
	// column that does not exist. A naming convention is not a contract; the declaration is.
	let tmpColumn = (tmpDescriptor.Columns || []).find((pCol) => pCol && (pCol.F === tmpField));
	if (tmpColumn && tmpColumn.Computed) { return false; }
	if (tmpField.charAt(0) === '_') { return false; }
	// And it has to be a column of THIS entity. A sort survives in the URL hash and in saved list
	// preferences, neither of which is scoped to a screen, so a field name from another list can
	// arrive here intact; ORDER BY on a column that does not exist takes the whole query down.
	return _askable(tmpDescriptor, tmpField);
}

/**
 * Build the filter for a state.
 *
 * Returns { Filter, Unexpressed }. Unexpressed is a list of facet names this could not put into the
 * query; a non-empty Unexpressed means the caller MUST NOT page server-side, because the server would
 * be answering a different question than the screen is asking.
 */
function build(pState, pContext, pDescriptor, pSort)
{
	let tmpState = pState || {};
	let tmpContext = pContext || { CurrentUserID: 0, Agents: {} };
	let tmpDescriptor = pDescriptor || {};
	let tmpParts = [];
	let tmpUnexpressed = [];

	let fList = (pValue) => String(pValue == null ? '' : pValue).split(',').map((s) => s.trim()).filter(Boolean);

	// EVERY FACET GOES THROUGH HERE. A facet whose column this entity does not declare is reported
	// rather than sent: filter state is restored from the URL hash and from saved preferences, and
	// neither is scoped to the screen it came from, so a facet from another list can arrive intact.
	let fFacet = (pName, pField, fStanza) =>
	{
		if (!_askable(tmpDescriptor, pField)) { tmpUnexpressed.push(pName); return; }
		let tmpStanza = fStanza();
		if (tmpStanza) { tmpParts.push(tmpStanza); }
	};

	if (tmpState.status)
	{
		let tmpSet = fList(tmpState.status);
		if (tmpSet.length) { fFacet('status', 'Status', () => _stanza('FBL', 'Status', 'INN', tmpSet.map(_safe).join(','))); }
	}
	if (tmpState.type)
	{
		let tmpSet = fList(tmpState.type);
		if (tmpSet.length) { fFacet('type', 'Type', () => _stanza('FBL', 'Type', 'INN', tmpSet.map(_safe).join(','))); }
	}
	if (tmpState.priority) { fFacet('priority', 'Priority', () => _stanza('FBV', 'Priority', 'EQ', _safe(tmpState.priority))); }
	if (tmpState.wfstatus) { fFacet('wfstatus', 'WorkflowStatus', () => _stanza('FBV', 'WorkflowStatus', 'EQ', _safe(tmpState.wfstatus))); }
	if (tmpState.sourcetype) { fFacet('sourcetype', 'SourceType', () => _stanza('FBV', 'SourceType', 'EQ', _safe(tmpState.sourcetype))); }

	if (tmpState.target)
	{
		// 'none' means the row points at nothing, which the client reads as an empty or literal 'None'.
		if (String(tmpState.target) === 'none') { tmpUnexpressed.push('target-none'); }
		else { fFacet('target', 'TargetType', () => _stanza('FBV', 'TargetType', 'EQ', _safe(tmpState.target))); }
	}

	if (tmpState.customer)
	{
		fFacet('customer', 'IDKeystoneCustomer', () =>
		{
			let tmpValue = (String(tmpState.customer) === 'none') ? '0' : _safe(tmpState.customer);
			return _stanza('FBV', 'IDKeystoneCustomer', 'EQ', tmpValue);
		});
	}

	// 'no' means NOT truthy, which in this schema includes 0 and NULL. `NE 1` drops NULL rows in SQL,
	// so this one goes to the caller rather than quietly losing every un-stamped row. Checked before
	// the column is, because it is unexpressible on the one entity that HAS the column.
	if (tmpState.addressed === 'no') { tmpUnexpressed.push('addressed-open'); }
	else if (tmpState.addressed === 'yes') { fFacet('addressed', 'Addressed', () => _stanza('FBV', 'Addressed', 'EQ', '1')); }

	if (tmpState.assignee)
	{
		let tmpWho = String(tmpState.assignee);
		// 'ai' and 'human' are resolved through a roster the list holds, not through a column.
		// Expressible in principle as an id list; deferred rather than half-done. Named before the
		// column check so the report says which assignee filter could not be asked for.
		if ((tmpWho !== 'me') && (tmpWho !== 'unassigned') && !/^[0-9]+$/.test(tmpWho)) { tmpUnexpressed.push('assignee-' + tmpWho); }
		else
		{
			fFacet('assignee', 'IDAssignedUser', () =>
			{
				if (tmpWho === 'me') { return _stanza('FBV', 'IDAssignedUser', 'EQ', Number(tmpContext.CurrentUserID) || 0); }
				if (tmpWho === 'unassigned') { return _stanza('FBV', 'IDAssignedUser', 'EQ', '0'); }
				return _stanza('FBV', 'IDAssignedUser', 'EQ', tmpWho);
			});
		}
	}

	if (tmpState.recent)
	{
		let tmpMs = Number(tmpState.RecentMs) || 0;
		// RecentMs is resolved by the caller (FocusFilters.recentMs); a window this module was not told
		// the length of is a window it cannot express, and guessing one would narrow the list wrongly.
		if (tmpMs <= 0) { tmpUnexpressed.push('recent'); }
		else { fFacet('recent', 'UpdateDate', () => _stanza('FBV', 'UpdateDate', 'GT', new Date(Date.now() - tmpMs).toISOString())); }
	}

	// The activity lens keeps in-flight lanes always, plus anything touched recently. That is an OR of
	// a status list and a date, which is expressible -- and wrapped, like every other OR here.
	if (String(tmpState.activity || '') === 'related') { tmpUnexpressed.push('activity'); }

	let tmpQuery = String(tmpState.q || '').trim();
	if (tmpQuery)
	{
		let tmpLike = '%' + _safe(tmpQuery) + '%';
		// ONLY THE PROSE COLUMNS THIS ENTITY HAS. One list of the twenty-one has a Body column and one
		// has both Title and Description; searching the fixed five would name a column Postgres has
		// never heard of on nearly every list in the app, and that is a 500 rather than a thin result.
		let tmpOr = searchFields(tmpDescriptor).map((pField, pIndex) =>
			_stanza(pIndex ? 'FBVOR' : 'FBV', pField, 'LK', tmpLike));
		// A search naming a mark ("WI-19", "19") should find it, and the mark is not in the prose.
		let tmpNumber = tmpQuery.replace(/^[A-Za-z]+-?/, '');
		if (tmpDescriptor.NumberField && /^[0-9]+$/.test(tmpNumber))
		{
			tmpOr.push(_stanza(tmpOr.length ? 'FBVOR' : 'FBV', tmpDescriptor.NumberField, 'EQ', tmpNumber));
		}
		// An entity with no searchable column and no mark cannot answer a search at all. Saying so is
		// the difference between "no rows match" and "this question was never asked".
		if (!tmpOr.length) { tmpUnexpressed.push('search'); }
		else { tmpParts.push(_orGroup(tmpOr)); }
	}

	(sortStanzas(pSort, tmpDescriptor)).forEach((pStanza) => tmpParts.push(pStanza));
	if (!sortIsExpressible(pSort, tmpDescriptor)) { tmpUnexpressed.push('sort-' + ((pSort || {}).Field || '')); }

	return { Filter: tmpParts.filter(Boolean).join('~'), Unexpressed: tmpUnexpressed };
}

module.exports = { build, sortStanzas, sortIsExpressible, searchFields, _askable, _orGroup, _stanza, SEARCH_FIELDS: _SEARCH_FIELDS };

},{}],560:[function(require,module,exports){
'use strict';

/**
 * LoopMarkdown
 * ------------
 * Converts a kit's loop checklist templates ({ <loopkey>: [ { Title, Children? } ] }) to and from a
 * single markdown document, so the loops can be edited in the rich markdown editor as checklists:
 *
 *   ## Design
 *   - [ ] Problem and audience written down
 *   - [ ] Core flow sketched
 *     - [ ] Happy path
 *     - [ ] Key edge cases
 *
 *   ## Build
 *   - [ ] ...
 *
 * Each `## Heading` is matched (case/space-insensitive) to a loop's Label or Key; bullet or checklist
 * items (`-`, `*`, `+`, with an optional `[ ]` / `[x]`) become the loop's items, nested by indentation.
 * Pure functions; the server still receives and re-sanitizes the structured tree.
 */

function _norm(pStr) { return String(pStr == null ? '' : pStr).toLowerCase().replace(/[^a-z0-9]/g, ''); }

function _itemsToLines(pItems, pDepth)
{
	let tmpLines = [];
	let tmpIndent = '  '.repeat(pDepth);
	(Array.isArray(pItems) ? pItems : []).forEach((pItem) =>
	{
		if (!pItem || !pItem.Title) { return; }
		tmpLines.push(tmpIndent + '- [ ] ' + pItem.Title);
		if (Array.isArray(pItem.Children) && pItem.Children.length)
		{
			tmpLines = tmpLines.concat(_itemsToLines(pItem.Children, pDepth + 1));
		}
	});
	return tmpLines;
}

// A loops object -> one markdown document with a `## Label` section per loop (in LoopMeta order).
function loopsToMarkdown(pLoops, pLoopMeta)
{
	let tmpLoops = (pLoops && typeof pLoops === 'object') ? pLoops : {};
	let tmpLines = [];
	(Array.isArray(pLoopMeta) ? pLoopMeta : []).forEach((pLoop) =>
	{
		tmpLines.push('## ' + pLoop.Label);
		tmpLines = tmpLines.concat(_itemsToLines(Array.isArray(tmpLoops[pLoop.Key]) ? tmpLoops[pLoop.Key] : [], 0));
		tmpLines.push('');
	});
	return tmpLines.join('\n').replace(/\n+$/, '\n');
}

// Markdown -> a loops object keyed by loop key. Headings switch the current loop; bullet/checklist
// lines become items, nested by their relative indentation.
function markdownToLoops(pMarkdown, pLoopMeta)
{
	let tmpMeta = Array.isArray(pLoopMeta) ? pLoopMeta : [];
	let tmpLabelToKey = {};
	tmpMeta.forEach((pLoop) => { tmpLabelToKey[_norm(pLoop.Label)] = pLoop.Key; tmpLabelToKey[_norm(pLoop.Key)] = pLoop.Key; });
	let tmpResult = {};
	tmpMeta.forEach((pLoop) => { tmpResult[pLoop.Key] = []; });
	let tmpCurrentKey = tmpMeta.length ? tmpMeta[0].Key : null;
	let tmpStack = [];
	String(pMarkdown == null ? '' : pMarkdown).split('\n').forEach((pLine) =>
	{
		let tmpHeading = pLine.match(/^\s*#{1,6}\s+(.*\S)\s*$/);
		if (tmpHeading)
		{
			let tmpKey = tmpLabelToKey[_norm(tmpHeading[1])];
			if (tmpKey) { tmpCurrentKey = tmpKey; tmpStack = []; }
			return;
		}
		let tmpBullet = pLine.match(/^(\s*)[-*+]\s+(?:\[[ xX]?\]\s+)?(.*\S)\s*$/);
		if (!tmpBullet || !tmpCurrentKey || !tmpResult[tmpCurrentKey]) { return; }
		let tmpDepth = tmpBullet[1].replace(/\t/g, '  ').length;
		let tmpTitle = tmpBullet[2].trim();
		if (!tmpTitle) { return; }
		let tmpNode = { Title: tmpTitle };
		while (tmpStack.length && tmpStack[tmpStack.length - 1].depth >= tmpDepth) { tmpStack.pop(); }
		if (tmpStack.length)
		{
			let tmpParent = tmpStack[tmpStack.length - 1].node;
			if (!Array.isArray(tmpParent.Children)) { tmpParent.Children = []; }
			tmpParent.Children.push(tmpNode);
		}
		else
		{
			tmpResult[tmpCurrentKey].push(tmpNode);
		}
		tmpStack.push({ depth: tmpDepth, node: tmpNode });
	});
	return tmpResult;
}

// One loop's items -> a markdown checklist (no `## heading`; each editor is bound to a single loop).
function itemsToMarkdown(pItems)
{
	let tmpLines = _itemsToLines(pItems, 0);
	return tmpLines.length ? (tmpLines.join('\n') + '\n') : '';
}

// A markdown checklist (no heading) -> one loop's nested item tree, nested by relative indentation.
function markdownToItems(pMarkdown)
{
	let tmpRoot = [];
	let tmpStack = [];
	String(pMarkdown == null ? '' : pMarkdown).split('\n').forEach((pLine) =>
	{
		let tmpBullet = pLine.match(/^(\s*)[-*+]\s+(?:\[[ xX]?\]\s+)?(.*\S)\s*$/);
		if (!tmpBullet) { return; }
		let tmpDepth = tmpBullet[1].replace(/\t/g, '  ').length;
		let tmpTitle = tmpBullet[2].trim();
		if (!tmpTitle) { return; }
		let tmpNode = { Title: tmpTitle };
		while (tmpStack.length && tmpStack[tmpStack.length - 1].depth >= tmpDepth) { tmpStack.pop(); }
		if (tmpStack.length)
		{
			let tmpParent = tmpStack[tmpStack.length - 1].node;
			if (!Array.isArray(tmpParent.Children)) { tmpParent.Children = []; }
			tmpParent.Children.push(tmpNode);
		}
		else { tmpRoot.push(tmpNode); }
		tmpStack.push({ depth: tmpDepth, node: tmpNode });
	});
	return tmpRoot;
}

module.exports =
{
	loopsToMarkdown: loopsToMarkdown,
	markdownToLoops: markdownToLoops,
	itemsToMarkdown: itemsToMarkdown,
	markdownToItems: markdownToItems
};

},{}],561:[function(require,module,exports){
'use strict';

/**
 * What a refinement ring should SHOW, given a vision's status and what its checklist measures (WI #409).
 *
 * ## The defect this exists to close
 *
 * A vision carried three independent hand-kept records of how done it was -- Vision.Status, the statuses
 * of its features, and four loop checklists -- and nothing reconciled them. Counted across the plan
 * sheet: thirty-two of thirty-three Realized visions showed 0% on every ring. The loops get used while
 * work is happening and abandoned the moment it lands, because nobody returns to tick seventeen boxes to
 * record something they already recorded by setting the status.
 *
 * The ring was not computing anything wrong. It is a checklist's weighted completion and it reported
 * that faithfully. The mistake was asking a person for a second record of a fact the system already
 * held, and then believing the record nobody maintains.
 *
 * ## Status decides where status knows
 *
 * Status is Draft, Active, Realized or Abandoned. The loops are Design, Build, Deliver and Gather
 * Feedback. So status can say FINISHED but it cannot say WHICH LOOP a vision is in:
 *
 *   Realized   every loop reads complete. Nothing is asked of a person to restate the status.
 *   Abandoned  every loop reads stopped -- a different fact from not started, and it must not look
 *              the same, because zero and not-measured render identically and that is half the bug.
 *   Active     the checklists remain the instrument, because status is silent on phase. This is
 *   Draft      exactly where the loops are already used and already useful.
 *
 * REALIZED RESOLVES ALL FOUR, not the last one. Lighting up Gather Feedback alone would leave a
 * realized vision showing Design at 0%, which is the same contradiction moved one step along.
 *
 * ## Nothing is destroyed
 *
 * Where a vision WAS worked with the loops, those ticks are the record of what was actually done. This
 * changes what a ring DISPLAYS for a finished vision, never what is stored, and every caller gets the
 * measurement back untouched under Measured. A screen that shows a full ring can still say "9 of 17
 * ticked" underneath it, and the open checklist still shows its own real state.
 *
 * ## One implementation, on purpose
 *
 * The rings appear in two places: the vision page, and the printed blueprint plate (WI #410). A printed
 * set is handed to somebody who was not in the room and cannot be corrected afterwards, so the screen
 * and the paper disagreeing is worse here than almost anywhere else in the product. They ask this
 * module rather than each deriving it, which is the only arrangement in which they cannot drift.
 */

/**
 * The statuses that decide a ring outright. Anything not named here leaves the checklist in charge --
 * a new status added to the vocabulary therefore falls back to measurement rather than silently
 * inheriting a meaning nobody chose for it.
 */
const STATUS_RULES =
{
	Realized: { Stage: 'complete', Percent: 100, Note: 'realized' },
	Abandoned: { Stage: 'stopped', Percent: 100, Note: 'abandoned' }
};

/** Does status speak for itself here, or is the checklist still the instrument? */
function statusDecides(pStatus)
{
	return !!STATUS_RULES[String(pStatus || '').trim()];
}

/**
 * Fold a checklist measurement into the shape a ring needs. pMeasured is the ChecklistModel Overall
 * ({ Percent, Complete, LeafCount, DoneCount }) or null where a vision has no checklist at all.
 */
function measure(pMeasured)
{
	let tmpOverall = pMeasured || {};
	let tmpLeaves = Number(tmpOverall.LeafCount) || 0;
	let tmpDone = Number(tmpOverall.DoneCount) || 0;
	let tmpPercent = Math.max(0, Math.min(100, Number(tmpOverall.Percent) || 0));

	let tmpStage = 'in progress';
	if (!tmpLeaves) { tmpStage = 'empty'; }
	else if (tmpOverall.Complete) { tmpStage = 'complete'; }
	else if (tmpPercent === 0) { tmpStage = 'not started'; }

	return {
		Percent: tmpPercent, Stage: tmpStage, LeafCount: tmpLeaves, DoneCount: tmpDone,
		Detail: tmpLeaves ? (tmpDone + ' of ' + tmpLeaves + ' done') : 'no tasks yet'
	};
}

/**
 * What one ring shows. Returns the displayed Percent/Stage/Detail, WHY it says that (Source), and the
 * untouched measurement beneath it.
 *
 * Source is not decoration: a reader shown a full ring is entitled to know whether somebody ticked the
 * boxes or whether the status spoke for them, and a surface that cannot tell the two apart has only
 * moved the original problem.
 */
function deriveLoop(pStatus, pMeasured)
{
	let tmpMeasured = measure(pMeasured);
	let tmpRule = STATUS_RULES[String(pStatus || '').trim()];
	if (!tmpRule)
	{
		return {
			Percent: tmpMeasured.Percent, Stage: tmpMeasured.Stage, Detail: tmpMeasured.Detail,
			Source: 'checklist', Measured: tmpMeasured
		};
	}

	// The measurement still gets said out loud where there is one. A realized vision whose Build loop
	// was genuinely worked should show that work, not have it hidden by the status that supersedes it.
	let tmpDetail = tmpMeasured.LeafCount
		? (tmpRule.Note + '; ' + tmpMeasured.DoneCount + ' of ' + tmpMeasured.LeafCount + ' ticked')
		: tmpRule.Note;

	return {
		Percent: tmpRule.Percent, Stage: tmpRule.Stage, Detail: tmpDetail,
		Source: 'status', Measured: tmpMeasured
	};
}

/**
 * The words a PRINTED plate uses instead of a rack of empty bars.
 *
 * A Draft vision has nothing to report: its status does not decide, and nobody has ticked a checklist
 * yet, so all four bars print empty. That is honest and it reads as broken -- visually identical to the
 * defect WI #409 just fixed, on the one surface where a reader cannot hover, click, or reload to find
 * out otherwise.
 *
 * PRINT ONLY, and the asymmetry is deliberate rather than an oversight. On screen the rings are
 * NAVIGATION: clicking one opens its checklist, which is how a draft vision's loops get filled in at
 * all. Replacing them with a sentence there would take the feature away from the exact visions that
 * still need it. On paper they are a picture of a fact, and when the fact is "nothing yet" a sentence
 * says it better than four empty tracks.
 */
const PRINTED_NOTES = { Draft: 'Not started yet' };

/** What a printed plate should say instead of bars, or null to draw the bars. */
function printedNote(pStatus)
{
	return PRINTED_NOTES[String(pStatus || '').trim()] || null;
}

/** The word a ring writes in its middle. A derived ring must never show a percentage it did not count. */
function ringLabel(pLoop)
{
	if (!pLoop) { return ''; }
	if (pLoop.Source === 'status') { return (pLoop.Stage === 'stopped') ? 'stopped' : 'done'; }
	return (Math.max(0, Math.min(100, Number(pLoop.Percent) || 0))) + '%';
}

module.exports =
{
	STATUS_RULES: STATUS_RULES,
	statusDecides: statusDecides,
	measure: measure,
	PRINTED_NOTES: PRINTED_NOTES,
	printedNote: printedNote,
	deriveLoop: deriveLoop,
	ringLabel: ringLabel
};

},{}],562:[function(require,module,exports){
'use strict';

/**
 * Friendly display labels for OAuth provider keys (google, github, ...).
 *
 * Shared between the full sign-in screen (PictView-Auth) and the in-place
 * re-auth modal (PictView-ReAuth) so a newly configured identity provider
 * reads the same way in both places without either file guessing at it.
 */

const _PROVIDER_LABELS =
{
	'google': 'Google',
	'github': 'GitHub',
	'microsoft': 'Microsoft'
};

// The provider's short name, e.g. "Google", "GitHub", or a capitalized
// fallback for a provider this map does not know about yet.
function labelForProvider(pProviderName)
{
	let tmpKey = String(pProviderName || '').toLowerCase();
	if (_PROVIDER_LABELS[tmpKey]) { return _PROVIDER_LABELS[tmpKey]; }
	return pProviderName ? (String(pProviderName).charAt(0).toUpperCase() + String(pProviderName).slice(1)) : 'SSO';
}

module.exports = { labelForProvider: labelForProvider };

},{}],563:[function(require,module,exports){
/**
 * Plansheet — the host application.
 *
 * Composes the auth + session-browse workflow on top of the vendored Claude
 * session viewer (which renders any individual session; see
 * source/vendor/claudetransformer/).
 *
 * Lifecycle:
 *   - On boot: check session; if logged in → workspace; else → Auth view.
 *   - Sessions are a normal entity list at #/sessions; Upload is #/sessions/upload.
 *   - Clicking a session's "Open" routes to #/session/:id; openServerSession()
 *     downloads the blob and hands it to the viewer via loadSessionFromZip().
 *   - User clicks "back" inside the viewer → showSessions() routes to the list.
 */

const libPictApplication = require('pict-application');

const libPictSectionModal = require('pict-section-modal');
const libPictSectionPicker = require('pict-section-picker');
const libPictSectionTheme = require('pict-section-theme');
const libPictRouter = require('pict-router');
// The Claude session viewer, vendored under source/vendor/claudetransformer/
// (a fork of claude-session-transformer). Its parser/exporter providers and
// its views are registered in the constructor; this app supplies the host
// seams they call (onSessionLoaded / showSessions / the SessionAPI provider).
// The standalone module was retired as a dependency; vendoring keeps the
// feature self-contained and buildable without an external checkout.
const libProviderSessionParser   = require('./vendor/claudetransformer/Pict-Provider-SessionParser.js');
const libProviderSessionExporter = require('./vendor/claudetransformer/Pict-Provider-SessionExporter.js');
const libViewCTDropzone     = require('./vendor/claudetransformer/PictView-Dropzone.js');
const libViewCTLayout       = require('./vendor/claudetransformer/PictView-Layout.js');
const libViewCTSignature    = require('./vendor/claudetransformer/PictView-Signature.js');
const libViewCTTimeline     = require('./vendor/claudetransformer/PictView-Timeline.js');
const libViewCTConversation = require('./vendor/claudetransformer/PictView-Conversation.js');
const libViewCTToolDetail   = require('./vendor/claudetransformer/PictView-ToolDetail.js');
const libViewCTAgentDetail  = require('./vendor/claudetransformer/PictView-AgentDetail.js');
const libPictSectionClaudeTransformer = require('./vendor/claudetransformer/PictView-ClaudeTransformer-Section.js');
const libBrand = require('./Plansheet-Brand.js');
const libBrandChrome = require('./Plansheet-Brand-Chrome.js');

const libProviderAuthClient = require('./providers/Pict-Provider-AuthClient.js');
const libProviderSessionAPI = require('./providers/Pict-Provider-SessionAPI.js');
const libProviderEntityAPI  = require('./providers/Pict-Provider-EntityAPI.js');
const libProviderTestRunAPI = require('./providers/Pict-Provider-TestRunAPI.js');
const libProviderRoutineStepAPI = require('./providers/Pict-Provider-RoutineStepAPI.js');
const libProviderTestRunStepAPI = require('./providers/Pict-Provider-TestRunStepAPI.js');
const libProviderBoardAPI   = require('./providers/Pict-Provider-BoardAPI.js');
const libProviderLaneAPI    = require('./providers/Pict-Provider-LaneAPI.js');
const libProviderBlueprintAPI = require('./providers/Pict-Provider-BlueprintAPI.js');
const libProviderLinkAPI    = require('./providers/Pict-Provider-LinkAPI.js');
const libProviderDocLakeAPI = require('./providers/Pict-Provider-DocLakeAPI.js');
const libProviderMediaAPI   = require('./providers/Pict-Provider-MediaAPI.js');
const libProviderTokenAPI   = require('./providers/Pict-Provider-TokenAPI.js');
const libProviderUserAPI    = require('./providers/Pict-Provider-UserAPI.js');
const libProviderPhotoAPI   = require('./providers/Pict-Provider-PhotoAPI.js');
const libProviderTeamAPI    = require('./providers/Pict-Provider-TeamAPI.js');
const libProviderOrgAPI     = require('./providers/Pict-Provider-OrgAPI.js');
const libProviderDocSyncAPI = require('./providers/Pict-Provider-DocSyncAPI.js');
const libProviderMessageAPI = require('./providers/Pict-Provider-MessageAPI.js');
const libProviderWorkflowAPI = require('./providers/Pict-Provider-WorkflowAPI.js');
const libProviderNotebookAPI = require('./providers/Pict-Provider-NotebookAPI.js');
const libProviderOpsAPI = require('./providers/Pict-Provider-OpsAPI.js');
const libProviderDeployAPI = require('./providers/Pict-Provider-DeployAPI.js');
const libProviderMarkup = require('./providers/Pict-Provider-Markup.js');
const libProviderRunAPI = require('./providers/Pict-Provider-RunAPI.js');
const libProviderAskAPI = require('./providers/Pict-Provider-AskAPI.js');
const libFrameworkClient = require('./providers/FrameworkClient.js');
const libRetoldWorkflowViews = require('retold-workflow/source/Retold-Workflow-Views.js');
const libInlineDocumentation = require('pict-section-inlinedocumentation');
const libPictSectionNavigation = require('pict-section-navigation');
const libPictSectionContent = require('pict-section-content');
const libEntityDescriptors  = require('./EntityDescriptors.js');
const libSiteMap            = require('./SiteMap.js');
const libPlansheetIcons     = require('./PlansheetIcons.js');
const libFeedbackPicker     = require('./FeedbackPicker.js');
const libCandidateSearch    = require('./CandidateSearch.js');

const libViewAuth         = require('./views/PictView-Auth.js');
const libViewShell        = require('./views/PictView-Shell.js');
const libViewRail         = require('./views/PictView-Rail.js');
const libViewTopBarNav    = require('./views/PictView-TopBar-Nav.js');
const libViewTopBarUser   = require('./views/PictView-TopBar-User.js');
const libViewUserSettings  = require('./views/PictView-UserSettings.js');
const libViewAboutMeEditor = require('./views/PictView-AboutMeEditor.js');
const libViewProfile       = require('./views/PictView-Profile.js');
const libViewCommunity     = require('./views/PictView-Community.js');
const libViewNotebook = require('./views/PictView-Notebook.js');
const libViewEntityList    = require('./views/PictView-EntityList.js');
const libViewBoard         = require('./views/PictView-Board.js');
const libViewEntityDetail  = require('./views/PictView-EntityDetail.js');
const libNodeWorkspace     = require('./workspaces/NodeWorkspace.js');
const libViewDocEditor     = require('./views/PictView-DocEditor.js');
const libViewRichDocEditor = require('./views/PictView-RichDocEditor.js');
const libViewFieldMarkdownEditor = require('./views/PictView-FieldMarkdownEditor.js');
const libViewFieldCodeEditor = require('./views/PictView-FieldCodeEditor.js');
const libViewNotebookNoteEditor = require('./views/PictView-NotebookNoteEditor.js');
const libViewNotesPage = require('./views/PictView-NotesPage.js');
const libViewNotesPageEditor = require('./views/PictView-NotesPageEditor.js');
const libViewBookmarksPage = require('./views/PictView-BookmarksPage.js');
const libViewHome = require('./views/PictView-Home.js');
const libViewGalleryPage = require('./views/PictView-GalleryPage.js');
const libViewDrawingsPage = require('./views/PictView-DrawingsPage.js');
const libViewOpsConsole = require('./views/PictView-OpsConsole.js');
const libViewReleases = require('./views/PictView-Releases.js');
const libViewRuns = require('./views/PictView-Runs.js');
const libViewAsk = require('./views/PictView-Ask.js');
const libViewProject = require('./views/PictView-Project.js');
const libViewProjectTypes = require('./views/PictView-ProjectTypes.js');
const libViewCapabilityActivation = require('./views/PictView-CapabilityActivation.js');
const libViewOrgActivity = require('./views/PictView-OrgActivity.js');
const libViewSystemActivity = require('./views/PictView-SystemActivity.js');
const libSectionActivityGraph = require('pict-section-activitygraph');
const libViewLoopsMarkdownEditor = require('./views/PictView-LoopsMarkdownEditor.js');
const libViewDrawingEditor = require('./views/PictView-DrawingEditor.js');
const libViewFoundationDocs = require('./views/PictView-FoundationDocs.js');
const libViewWorkflow       = require('./views/PictView-Workflow.js');
const libViewWhiteboards    = require('./views/PictView-Whiteboards.js');
const libViewStickerSetsPreview = require('./views/PictView-StickerSetsPreview.js');
const libViewHelpDrawer = require('./views/PictView-HelpDrawer.js');
const libViewChecklists     = require('./views/PictView-Checklists.js');
const libViewIssueBoard     = require('./views/PictView-IssueBoard.js');
const libViewFeatureBoard   = require('./views/PictView-FeatureBoard.js');
const libViewDeliverableBoard = require('./views/PictView-DeliverableBoard.js');
const libViewCallDesk       = require('./views/PictView-CallDesk.js');
const libViewVisionLoops    = require('./views/PictView-VisionLoops.js');
const libViewConnections    = require('./views/PictView-Connections.js');
const libViewRoutineSteps   = require('./views/PictView-RoutineSteps.js');
const libViewTestRunner     = require('./views/PictView-TestRunner.js');
const libViewBlueprint      = require('./views/PictView-Blueprint.js');
const libViewBlueprintComposer = require('./views/PictView-BlueprintComposer.js');
const libViewBlueprintStudio = require('./views/PictView-BlueprintStudio.js');
const libViewMediaViewer    = require('./views/PictView-MediaViewer.js');
const libViewReAuth         = require('./views/PictView-ReAuth.js');
const libProviderMoodboardAPI = require('./providers/Pict-Provider-MoodboardAPI.js');
const libProviderStickerAPI = require('./providers/Pict-Provider-StickerAPI.js');
const libProviderStickerSetAPI = require('./providers/Pict-Provider-StickerSetAPI.js');
const libProviderShapesAPI = require('./providers/Pict-Provider-ShapesAPI.js');
const libProviderChecklistAPI = require('./providers/Pict-Provider-ChecklistAPI.js');
const libProviderIssueBoardAPI = require('./providers/Pict-Provider-IssueBoardAPI.js');
const libProviderFeatureBoardAPI = require('./providers/Pict-Provider-FeatureBoardAPI.js');
const libProviderDeliverableBoardAPI = require('./providers/Pict-Provider-DeliverableBoardAPI.js');
const libProviderCallDeskAPI = require('./providers/Pict-Provider-CallDeskAPI.js');
const libProviderLoopsAPI = require('./providers/Pict-Provider-LoopsAPI.js');
const libProviderConnectionsAPI = require('./providers/Pict-Provider-ConnectionsAPI.js');
const libProviderProfileBlockAPI = require('./providers/Pict-Provider-ProfileBlockAPI.js');
const libMoodboardMediaImageSource = require('./providers/Moodboard-MediaImageSource.js');
const libMoodboardDrawingSource = require('./providers/Moodboard-DrawingSource.js');
const libMoodboardStickerSource = require('./providers/Moodboard-StickerSource.js');
const libMoodboardSection   = require('pict-section-moodboard');
const libProviderCommentThreadAPI = require('./providers/Pict-Provider-CommentThreadAPI.js');
const libProviderCommentAPI = require('./providers/Pict-Provider-CommentAPI.js');
const libPlansheetCommentProvider = require('./providers/PlansheetCommentProvider.js');
const libCommentsSection    = require('pict-section-comments');
const libProviderPromptAPI = require('./providers/Pict-Provider-PromptAPI.js');
const libPlansheetPromptProvider = require('./providers/PlansheetPromptProvider.js');
const libPromptEditorSection = require('pict-section-prompteditor');
// The reusable passwordless sign-in component (magic links). Plansheet uses it as the request + verify
// engine; plansheet's own auth screen is the UI and the hooks bridge the result into AppData.Auth.
const libPictSectionLogin = require('pict-section-login');
const libViewPromptLibrary  = require('./views/PictView-PromptLibrary.js');
const libViewPromptShapes   = require('./views/PictView-PromptShapes.js');
const libViewPromptAttachments = require('./views/PictView-PromptAttachments.js');

// The list and detail route slugs, by entity key. At module scope rather than inside _setupRoutes
// because a URL has to be BUILDABLE from anywhere now that the create and edit forms are routes of
// their own: a view that opens a form navigates to it, and needs the slug to do that.
const _LIST_SLUGS = { 'visions': 'Vision', 'modules': 'Module', 'features': 'Feature', 'work-items': 'WorkItem', 'sessions': 'Session', 'routines': 'Routine', 'test-runs': 'TestRun', 'feedback': 'Feedback', 'keystone-customers': 'KeystoneCustomer', 'contacts': 'Contact', 'calls': 'Call', 'issue-types': 'IssueType', 'blueprints': 'Blueprint', 'expectations': 'Expectation', 'deliverables': 'Deliverable', 'as-builts': 'AsBuilt', 'deploy-requests': 'DeployRequest', 'node-registrations': 'NodeRegistration', 'tasks': 'Task' };
const _DETAIL_SLUGS = { 'vision': 'Vision', 'module': 'Module', 'feature': 'Feature', 'work-item': 'WorkItem', 'routine': 'Routine', 'feedback': 'Feedback', 'keystone-customer': 'KeystoneCustomer', 'issue': 'Issue', 'contact': 'Contact', 'call': 'Call', 'issue-type': 'IssueType', 'expectation': 'Expectation', 'deliverable': 'Deliverable', 'as-built': 'AsBuilt', 'deploy-request': 'DeployRequest', 'node-registration': 'NodeRegistration', 'task': 'Task', 'request': 'Request' };

// Reverse lookups: entity key -> slug. Not every entity has both. Blueprint has a list route and a
// bespoke detail page; Issue has a detail route and a board instead of a list. A caller that gets ''
// back must fall back to rendering in place rather than navigating somewhere that does not exist.
function _listSlugFor(pKey) { return Object.keys(_LIST_SLUGS).find((pSlug) => _LIST_SLUGS[pSlug] === pKey) || ''; }
function _detailSlugFor(pKey) { return Object.keys(_DETAIL_SLUGS).find((pSlug) => _DETAIL_SLUGS[pSlug] === pKey) || ''; }

class PictApplicationPlansheet extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// 1. Modal section — confirm / toast / alert API for any view.
		this.pict.addView('Pict-Section-Modal',
			libPictSectionModal.default_configuration, libPictSectionModal);

		// 2. Plansheet-owned providers (server-talk).
		// Markup is the exception: it talks to nothing. It turns the per-plan-sheet numbers every
		// entity already carries into a designator (WI-301) and the title block / card / tooltip built
		// from it, so one thing renders an entity the same way on every surface.
		this.pict.addProvider('Markup', libProviderMarkup.default_configuration, libProviderMarkup);
		this.pict.addProvider('AuthClient', libProviderAuthClient.default_configuration, libProviderAuthClient);
		this.pict.addProvider('SessionAPI', libProviderSessionAPI.default_configuration, libProviderSessionAPI);
		// Vendored Claude session viewer: the parser (zip/jsonl -> normalized
		// session on AppData.Session) and the markdown/PDF exporter.
		this.pict.addProvider('SessionParser', libProviderSessionParser.default_configuration, libProviderSessionParser);
		this.pict.addProvider('SessionExporter', libProviderSessionExporter.default_configuration, libProviderSessionExporter);

		// SDLC entity CRUD: one generic provider class, one instance per entity
		// (VisionAPI/ModuleAPI/FeatureAPI/WorkItemAPI/...), plus the board aggregator.
		// Subclass exceptions carry entity-specific calls (TestRunAPI adds the
		// one-call start() against POST /1.0/TestRun/Start).
		// Blueprints are addressable two ways -- by the entity that owns one, and by the blueprint
		// record itself -- and BlueprintAPI is what knows the difference. Registered HERE, before the
		// descriptor loop below, because that loop skips any entity whose provider already exists
		// ("don't clobber it with a generic EntityAPI"). It subclasses EntityAPI, so the Blueprints
		// list keeps the generic CRUD it has always had.
		this.pict.addProvider('BlueprintAPI', libProviderBlueprintAPI.default_configuration, libProviderBlueprintAPI);

		let tmpEntityKeys = Object.keys(libEntityDescriptors.Entities);
		let tmpEntityProviderClasses = { TestRun: libProviderTestRunAPI };
		for (let i = 0; i < tmpEntityKeys.length; i++)
		{
			let tmpDescriptor = libEntityDescriptors.Entities[tmpEntityKeys[i]];
			// Entities with a bespoke provider already registered (Session ->
			// SessionAPI, above) keep it; don't clobber it with a generic EntityAPI.
			if (this.pict.providers[tmpDescriptor.Key + 'API']) { continue; }
			let tmpProviderClass = tmpEntityProviderClasses[tmpDescriptor.Key] || libProviderEntityAPI;
			this.pict.addProvider(tmpDescriptor.Key + 'API',
				Object.assign({}, tmpProviderClass.default_configuration,
					{
						ProviderIdentifier: tmpDescriptor.Key + 'API',
						EntityName: tmpDescriptor.Key,
						PluralRoute: tmpDescriptor.Plural,
						IDField: tmpDescriptor.IDField
					}),
				tmpProviderClass);
		}
		// Child-entity providers: steps are not in EntityDescriptors.Entities (no
		// routes or lists of their own; they live inside their parent's editor).
		this.pict.addProvider('RoutineStepAPI', libProviderRoutineStepAPI.default_configuration, libProviderRoutineStepAPI);
		this.pict.addProvider('TestRunStepAPI', libProviderTestRunStepAPI.default_configuration, libProviderTestRunStepAPI);
		this.pict.addProvider('BoardAPI', libProviderBoardAPI.default_configuration, libProviderBoardAPI);
		this.pict.addProvider('LaneAPI', libProviderLaneAPI.default_configuration, libProviderLaneAPI);
		this.pict.addProvider('LinkAPI', libProviderLinkAPI.default_configuration, libProviderLinkAPI);
		this.pict.addProvider('DocLakeAPI', libProviderDocLakeAPI.default_configuration, libProviderDocLakeAPI);
		this.pict.addProvider('MediaAPI', libProviderMediaAPI.default_configuration, libProviderMediaAPI);
		this.pict.addProvider('TokenAPI', libProviderTokenAPI.default_configuration, libProviderTokenAPI);
		this.pict.addProvider('UserAPI', libProviderUserAPI.default_configuration, libProviderUserAPI);
		this.pict.addProvider('PhotoAPI', libProviderPhotoAPI.default_configuration, libProviderPhotoAPI);
		this.pict.addProvider('Content', libPictSectionContent.PictContentProvider.default_configuration, libPictSectionContent.PictContentProvider);
		this.pict.addProvider('TeamAPI', libProviderTeamAPI.default_configuration, libProviderTeamAPI);
		this.pict.addProvider('OrgAPI', libProviderOrgAPI.default_configuration, libProviderOrgAPI);
		this.pict.addProvider('DocSyncAPI', libProviderDocSyncAPI.default_configuration, libProviderDocSyncAPI);
		this.pict.addProvider('MessageAPI', libProviderMessageAPI.default_configuration, libProviderMessageAPI);
		this.pict.addProvider('WorkflowAPI', libProviderWorkflowAPI.default_configuration, libProviderWorkflowAPI);
			this.pict.addProvider('NotebookAPI', libProviderNotebookAPI.default_configuration, libProviderNotebookAPI);
		this.pict.addProvider('OpsAPI', libProviderOpsAPI.default_configuration, libProviderOpsAPI);
		this.pict.addProvider('DeployAPI', libProviderDeployAPI.default_configuration, libProviderDeployAPI);
		this.pict.addProvider('RunAPI', libProviderRunAPI.default_configuration, libProviderRunAPI);
		this.pict.addProvider('AskAPI', libProviderAskAPI.default_configuration, libProviderAskAPI);
		this.pict.addProvider('MoodboardAPI', libProviderMoodboardAPI.default_configuration, libProviderMoodboardAPI);
		this.pict.addProvider('StickerAPI', libProviderStickerAPI.default_configuration, libProviderStickerAPI);
		this.pict.addProvider('StickerSetAPI', libProviderStickerSetAPI.default_configuration, libProviderStickerSetAPI);
		this.pict.addProvider('ShapesAPI', libProviderShapesAPI.default_configuration, libProviderShapesAPI);
		this.pict.addProvider('ChecklistAPI', libProviderChecklistAPI.default_configuration, libProviderChecklistAPI);
		this.pict.addProvider('IssueBoardAPI', libProviderIssueBoardAPI.default_configuration, libProviderIssueBoardAPI);
		this.pict.addProvider('FeatureBoardAPI', libProviderFeatureBoardAPI.default_configuration, libProviderFeatureBoardAPI);
		this.pict.addProvider('DeliverableBoardAPI', libProviderDeliverableBoardAPI.default_configuration, libProviderDeliverableBoardAPI);
		this.pict.addProvider('CallDeskAPI', libProviderCallDeskAPI.default_configuration, libProviderCallDeskAPI);
		this.pict.addProvider('LoopsAPI', libProviderLoopsAPI.default_configuration, libProviderLoopsAPI);
		this.pict.addProvider('ConnectionsAPI', libProviderConnectionsAPI.default_configuration, libProviderConnectionsAPI);
		this.pict.addProvider('ProfileBlockAPI', libProviderProfileBlockAPI.default_configuration, libProviderProfileBlockAPI);
		this.pict.addProvider('CommentThreadAPI', libProviderCommentThreadAPI.default_configuration, libProviderCommentThreadAPI);
		this.pict.addProvider('CommentAPI', libProviderCommentAPI.default_configuration, libProviderCommentAPI);
		// Prompt management: the caller's library + shape cascade clients, plus
		// plain owner-scoped CRUD for word lists and generated output.
		this.pict.addProvider('PromptAPI', libProviderPromptAPI.default_configuration, libProviderPromptAPI);
		this.pict.addProvider('PromptShapeAPI', libProviderPromptAPI.PromptShapeAPI.default_configuration, libProviderPromptAPI.PromptShapeAPI);
		this.pict.addProvider('WordListAPI', Object.assign({}, libProviderEntityAPI.default_configuration,
			{ ProviderIdentifier: 'WordListAPI', EntityName: 'WordList', PluralRoute: 'WordLists', IDField: 'IDWordList' }), libProviderEntityAPI);
		this.pict.addProvider('GeneratedPromptAPI', Object.assign({}, libProviderEntityAPI.default_configuration,
			{ ProviderIdentifier: 'GeneratedPromptAPI', EntityName: 'GeneratedPrompt', PluralRoute: 'GeneratedPrompts', IDField: 'IDGeneratedPrompt' }), libProviderEntityAPI);
		// Register plansheet's glyphs with Pict's Icon provider so views render them as
		// themeable inline SVG via {~I:Name~} / pict.icon('Name') -- we do not bundle
		// FontAwesome (see the nav-icon-hide note below).
		libPlansheetIcons.registerPlansheetIcons(this.pict);
		// pict-section-navigation drives the whole app's navigation from one site-map graph (SiteMap.js):
		// the docked main sidebar (non-settings groups), the in-page settings sub-rail (the Settings
		// group, scoped), and the cmd+K launcher (everything). The graph is set after login (so
		// entitlements gate the admin items); onNavigate routes by each item's Route.
		this.pict.addProvider('Pict-Navigation', { NavigationGraph: [] }, libPictSectionNavigation);
		this.pict.providers['Pict-Navigation'].onNavigate = (pNode) => this._onSiteNavigate(pNode);
		// The navigation now renders item/category icons through pict's SVG icon registry (SiteMap.js
		// supplies registry names; the glyphs are registered above via registerPlansheetIcons), so the
		// icon chips show real themable SVGs. We only trim two nav affordances the site map does not use.
		if (this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Plansheet-Nav-Icon-Hide',
				// No "advanced" items in the site map, so drop the toggle; and the settings sub-rail (a List)
				// is short, so drop its redundant search (the sidebar search + cmd+K already cover it).
				'.pict-nav-adv { display: none !important; }'
				+ ' .pict-nav-list .pict-nav-search { display: none !important; }',
				600);
			// The brand chrome layer: Open Gorton on the drafting layer, IBM Plex
			// Sans as the content face, and crisp drafting-sheet corners and
			// linework, over every theme. Priority 1200 sits ABOVE the pict-view
			// default CSS priority (1000) so equal-specificity chrome rules win on
			// the cascade -- notably the body content font, which the Shell view
			// also sets. (The nav-icon hide above wins by !important regardless.)
			this.pict.CSSMap.addCSS('Plansheet-Brand-Chrome', libBrandChrome, 1200);
		}
		this.pict.addProvider('Pict-InlineDocumentation', libInlineDocumentation.default_configuration, libInlineDocumentation);

		// 3. Plansheet-owned views.
		this.pict.addView('Plansheet-Auth',           libViewAuth.default_configuration,         libViewAuth);
		this.pict.addView('Plansheet-ReAuth',         libViewReAuth.default_configuration,       libViewReAuth);
		// Magic-link (passwordless) engine. Headless: RenderOnLoad/CheckSessionOnLoad off -- plansheet's
		// AuthClient owns session state and PictView-Auth owns the UI; this just drives the request + verify
		// fetches and single-use token handling, with the hooks below bridging into AppData.Auth.
		this.pict.addView('Plansheet-MagicLogin',
			Object.assign({}, libPictSectionLogin.default_configuration,
			{
				ViewIdentifier: 'Plansheet-MagicLogin',
				ShowMagicLink: true,
				RenderOnLoad: false,
				CheckSessionOnLoad: false,
				MagicLinkRequestEndpoint: '/1.0/Login/MagicLink/Request',
				MagicLinkVerifyEndpoint: '/1.0/Login/MagicLink/Verify'
			}),
			libPictSectionLogin);
		this._wireMagicLogin();
		this.pict.addView('Plansheet-Shell',          libViewShell.default_configuration,        libViewShell);
		this.pict.addView('Plansheet-Rail',           libViewRail.default_configuration,         libViewRail);
		this.pict.addView('Plansheet-TopBar-Nav',     libViewTopBarNav.default_configuration,    libViewTopBarNav);
		this.pict.addView('Plansheet-TopBar-User',    libViewTopBarUser.default_configuration,   libViewTopBarUser);
		this.pict.addView('Plansheet-UserSettings',   libViewUserSettings.default_configuration,  libViewUserSettings);
		this.pict.addView('Plansheet-AboutMeEditor',  libViewAboutMeEditor.default_configuration, libViewAboutMeEditor);
		this.pict.addView('Plansheet-Profile',        libViewProfile.default_configuration,       libViewProfile);
		this.pict.addView('Plansheet-Community',      libViewCommunity.default_configuration,     libViewCommunity);
		this.pict.addView('Plansheet-EntityList',     libViewEntityList.default_configuration,    libViewEntityList);
		this.pict.addView('Plansheet-Board',          libViewBoard.default_configuration,         libViewBoard);
		this.pict.addView('Plansheet-EntityDetail',   libViewEntityDetail.default_configuration,  libViewEntityDetail);
		// The Node workspace (WI #465): registers the 'NodeWorkspace' provider + view pair (single-node detail +
		// lifecycle actions + Provision create). Pict-Section-Modal is already registered above, which its token
		// reveal and confirms need.
		libNodeWorkspace.registerNodeWorkspace(this.pict);
		this.pict.addView('Plansheet-DocEditor',      libViewDocEditor.default_configuration,     libViewDocEditor);
		this.pict.addView('Plansheet-RichDocEditor',  libViewRichDocEditor.default_configuration,  libViewRichDocEditor);
		this.pict.addView('Plansheet-FieldMarkdownEditor', libViewFieldMarkdownEditor.default_configuration, libViewFieldMarkdownEditor);
		// The code-field editor for any descriptor field declared T:'code' (WI #456). pict-section-code and
		// codejar already ride the bundle via pict-section-content, so this is a view, not a payload.
		this.pict.addView('Plansheet-FieldCodeEditor', libViewFieldCodeEditor.default_configuration, libViewFieldCodeEditor);
		// A second instance for the feature acceptance dialog. Its own CodeMirror state, its own
		// content address and its own host, because the entity form's instance is live at the same
		// time and the two must not write over each other.
		this.pict.addView('Plansheet-AcceptanceMarkdownEditor',
			libViewFieldMarkdownEditor.buildConfiguration(
				{
					ViewIdentifier: 'Plansheet-AcceptanceMarkdownEditor',
					HostAddress: '#Acceptance-MarkdownHost',
					DataKey: 'AcceptanceMarkdownEditor',
					HostViewIdentifier: 'Plansheet-FeatureBoard',
					AllowSegments: false
				}), libViewFieldMarkdownEditor);
		this.pict.addView('Plansheet-Notebook-NoteEditor', libViewNotebookNoteEditor.default_configuration, libViewNotebookNoteEditor);
		// The full-page Tools surfaces (Notes / Bookmarks / Gallery), reachable from the Tools nav group and
		// as whole-screen pages on a phone. They reuse the NotebookAPI + MediaAPI providers; the Notes page
		// has its own markdown-editor child (its own DOM host + AppData buffer), so it never collides with
		// the rail notebook's editor.
		this.pict.addView('Plansheet-NotesPage-Editor', libViewNotesPageEditor.default_configuration, libViewNotesPageEditor);
		this.pict.addView('Plansheet-NotesPage', libViewNotesPage.default_configuration, libViewNotesPage);
		this.pict.addView('Plansheet-BookmarksPage', libViewBookmarksPage.default_configuration, libViewBookmarksPage);
		this.pict.addView('Plansheet-Home', libViewHome.default_configuration, libViewHome);
		this.pict.addView('Plansheet-GalleryPage', libViewGalleryPage.default_configuration, libViewGalleryPage);
		// The Drawings board surface (Tools group): a gallery of Excalidraw drawings, opening the same
		// full-screen editor the doc "Insert drawing" uses. Storage is Media (OwnerType 'Drawing').
		this.pict.addView('Plansheet-DrawingsPage', libViewDrawingsPage.default_configuration, libViewDrawingsPage);
		['design', 'build', 'deliver', 'feedback'].forEach((pLoopKey) =>
		{
			this.pict.addView('Plansheet-LoopEditor-' + pLoopKey, libViewLoopsMarkdownEditor.configForLoop(pLoopKey), libViewLoopsMarkdownEditor);
		});
		this.pict.addView('Plansheet-DrawingEditor',  libViewDrawingEditor.default_configuration,  libViewDrawingEditor);
		this.pict.addView('Plansheet-FoundationDocs', libViewFoundationDocs.default_configuration, libViewFoundationDocs);
		this.pict.addView('Plansheet-RoutineSteps',  libViewRoutineSteps.default_configuration,   libViewRoutineSteps);
		this.pict.addView('Plansheet-TestRunner',    libViewTestRunner.default_configuration,     libViewTestRunner);
		this.pict.addView('Plansheet-Blueprint',     libViewBlueprint.default_configuration,      libViewBlueprint);
		this.pict.addView('Plansheet-BlueprintComposer', libViewBlueprintComposer.default_configuration, libViewBlueprintComposer);
		this.pict.addView('Plansheet-BlueprintStudio', libViewBlueprintStudio.default_configuration, libViewBlueprintStudio);
		this.pict.addView('Plansheet-MediaViewer',    libViewMediaViewer.default_configuration,    libViewMediaViewer);

		// The "visually map out your workflow" section: the product-agnostic retold-workflow views
		// (catalog, designer, board, subject) hosted by a thin plansheet shell. Each view talks to
		// the server through the WorkflowAPI provider; navigation between them is wired to the shell.
		let tmpWorkflowShellID = 'Plansheet-Workflow';
		// The catalog lists ONLY the tenant's imported workflows (owned types), never the full
		// platform catalog. Crafts are brought in through the Drafting Kit (Settings); this page is
		// for designing and running what you have imported. A Client shim swaps getTypes for the
		// owned-only feed (the view supports options.Client); with no built-ins in the list it
		// renders no Adopt buttons. Resolve the provider lazily, since it registers after the views.
		let tmpOwnedCatalogClient =
		{
			getTypes: () => this.pict.providers.WorkflowAPI.getOwnedTypes(),
			adoptType: (pID) => this.pict.providers.WorkflowAPI.adoptType(pID)
		};
		this.pict.addView('Workflow-Catalog', Object.assign({}, libRetoldWorkflowViews.WorkflowCatalogView.default_configuration,
			{
				ClientProvider: 'WorkflowAPI',
				Client: tmpOwnedCatalogClient,
				onOpenType: (pType) => this.pict.views[tmpWorkflowShellID].openDesigner(pType),
				onShowBoard: (pType) => this.pict.views[tmpWorkflowShellID].openBoard(pType)
			}), libRetoldWorkflowViews.WorkflowCatalogView);
		this.pict.addView('Workflow-Map', Object.assign({}, libRetoldWorkflowViews.WorkflowMapView.default_configuration,
			{ ClientProvider: 'WorkflowAPI' }), libRetoldWorkflowViews.WorkflowMapView);
		this.pict.addView('Workflow-Board', Object.assign({}, libRetoldWorkflowViews.WorkflowBoardView.default_configuration,
			{
				ClientProvider: 'WorkflowAPI',
				onOpenSubject: (pSubjectID, pType, pTitle) => this.pict.views[tmpWorkflowShellID].openSubject(pSubjectID, pType, pTitle)
			}), libRetoldWorkflowViews.WorkflowBoardView);
		this.pict.addView('Workflow-Subject', Object.assign({}, libRetoldWorkflowViews.WorkflowSubjectView.default_configuration,
			{ ClientProvider: 'WorkflowAPI' }), libRetoldWorkflowViews.WorkflowSubjectView);
		this.pict.addView('Plansheet-Workflow', libViewWorkflow.default_configuration, libViewWorkflow);

		// Profile boards: the personal moodboard banner at the top of a profile page. The Edit board
		// (your own) autosaves through the profile shell and gets a Media-backed gallery scoped to your
		// board; the View board (a teammate's) is read-only. Both render into the profile's
		// #Profile-Board. They are separate moodboard instances; the on-screen one claims the shared
		// AppData.Moodboard.ViewID on render so its toolbar and card panels resolve to it.
		let fProfileBoardOwnerId = () => (this.pict.views['Plansheet-Profile'] ? this.pict.views['Plansheet-Profile'].currentBoardId() : null);
		let tmpProfileBoardImageSource = new libMoodboardMediaImageSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fProfileBoardOwnerId
			});
		// The Drawing card's picker: the team's Excalidraw drawings + this board's gallery.
		let tmpProfileBoardDrawingSource = new libMoodboardDrawingSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fProfileBoardOwnerId
			});
		// The sticker library is customer-scoped (the bundled set + the customer's uploads), but the set
		// shown BEFORE searching is per board context: profiles get the expressive 'moodboard' set,
		// design boards (vision inspiration + whiteboards) get 'drafting-design'. One source instance per
		// context, kept on the app so a vision board can swap to its kit's set later (Phase 2). The full
		// library is always one search away regardless of set. Set keys live in source/StickerSets.js.
		let fStickerSource = (pSetKey) => new libMoodboardStickerSource(
			{ StickerAPI: this.pict.providers.StickerAPI, ShapesAPI: this.pict.providers.ShapesAPI, SetKey: pSetKey });
		this._StickerSources =
		{
			profile: fStickerSource('moodboard'),
			vision: fStickerSource('drafting-design'),
			whiteboard: fStickerSource('drafting-design')
		};
		this.pict.addView('Profile-Board-Edit', Object.assign({}, libMoodboardSection.default_configuration,
			{
				ViewIdentifier: 'Profile-Board-Edit',
				AutoRender: false,
				// The editable instance is always the free canvas while editing (the moodboard's effective-
				// style model: an Editable board presents as the canvas whatever its stored style), so the
				// chosen jumbotron / background rides ViewState untouched and shows on the read-only banner.
				Editable: true,
				DefaultDestinationAddress: '#Profile-Board',
				ImageSource: tmpProfileBoardImageSource,
				DrawingSource: tmpProfileBoardDrawingSource,
				StickerSource: this._StickerSources.profile,
				onBoardChanged: (pBoard) => { if (this.pict.views['Plansheet-Profile']) { this.pict.views['Plansheet-Profile'].onBoardSaved(pBoard); } },
				// The display-style toggle + set-view-area live in the moodboard's own toolbar; the board
				// color + backdrop margin in its gear. The host only sizes the banner when the style changes.
				onDisplayStyleChanged: (pInfo) => { if (this.pict.views['Plansheet-Profile']) { this.pict.views['Plansheet-Profile'].onBoardDisplayStyleChanged(pInfo); } },
				Renderables: [ { RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Profile-Board', RenderMethod: 'replace' } ]
			}), libMoodboardSection);
		this.pict.addView('Profile-Board-View', Object.assign({}, libMoodboardSection.default_configuration,
			{
				ViewIdentifier: 'Profile-Board-View',
				AutoRender: false,
				Editable: false,
				// Banner presentation: let the read-only fit zoom IN to frame a sparse board, so a single
				// sticker fills the banner instead of sitting tiny at 1:1. The editable canvas keeps the
				// true-to-scale fit (FitZoomIn only affects the read-only view).
				FitZoomIn: true,
				DefaultDestinationAddress: '#Profile-Board',
				// Double-clicking a card on your own board drops into edit (the Edit board button is the
				// primary affordance, next to Edit profile -- see PictView-Profile).
				onCardActivate: (pHash) => { if (this.pict.views['Plansheet-Profile']) { this.pict.views['Plansheet-Profile'].activateCard(pHash); } },
				onDisplayStyleChanged: (pInfo) => { if (this.pict.views['Plansheet-Profile']) { this.pict.views['Plansheet-Profile'].onBoardDisplayStyleChanged(pInfo); } },
				Renderables: [ { RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Profile-Board', RenderMethod: 'replace' } ]
			}), libMoodboardSection);

		// Vision boards: an inspiration moodboard embedded on the Vision detail page. Same two-view
		// pattern as the profile banner -- an editable board (autosaving, for anyone with content.edit)
		// and a read-only one -- sharing the detail's #Vision-Board container. The image gallery is the
		// Media owned by the open board.
		let fVisionBoardOwnerId = () => (this.pict.views['Plansheet-EntityDetail'] ? this.pict.views['Plansheet-EntityDetail'].currentBoardId() : null);
		let tmpVisionBoardImageSource = new libMoodboardMediaImageSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fVisionBoardOwnerId
			});
		let tmpVisionBoardDrawingSource = new libMoodboardDrawingSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fVisionBoardOwnerId
			});
		this.pict.addView('Vision-Board-Edit', Object.assign({}, libMoodboardSection.default_configuration,
			{
				ViewIdentifier: 'Vision-Board-Edit',
				AutoRender: false,
				Editable: true,
				// Editing the inspiration board is a focused activity -- drop into the flow's fullscreen so
				// the canvas fills the viewport (and in-board popups have room). Leaving edit swaps back to
				// the read-only view, which unmounts this instance and drops the fullscreen wrapper.
				FullscreenOnEdit: true,
				DefaultDestinationAddress: '#Vision-Board',
				ImageSource: tmpVisionBoardImageSource,
				DrawingSource: tmpVisionBoardDrawingSource,
				StickerSource: this._StickerSources.vision,
				onBoardChanged: (pBoard) => { if (this.pict.views['Plansheet-EntityDetail']) { this.pict.views['Plansheet-EntityDetail'].onBoardSaved(pBoard); } },
				onDisplayStyleChanged: (pInfo) => { if (this.pict.views['Plansheet-EntityDetail']) { this.pict.views['Plansheet-EntityDetail'].onBoardDisplayStyleChanged(pInfo); } },
				Renderables: [ { RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Vision-Board', RenderMethod: 'replace' } ]
			}), libMoodboardSection);
		this.pict.addView('Vision-Board-View', Object.assign({}, libMoodboardSection.default_configuration,
			{
				ViewIdentifier: 'Vision-Board-View',
				AutoRender: false,
				Editable: false,
				// Same as the profile banner: the read-only inspiration board zooms in to frame a sparse
				// board so it fills the banner rather than showing tiny at 1:1.
				FitZoomIn: true,
				DefaultDestinationAddress: '#Vision-Board',
				onDisplayStyleChanged: (pInfo) => { if (this.pict.views['Plansheet-EntityDetail']) { this.pict.views['Plansheet-EntityDetail'].onBoardDisplayStyleChanged(pInfo); } },
				Renderables: [ { RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Vision-Board', RenderMethod: 'replace' } ]
			}), libMoodboardSection);

		// The top-bar composer (WI #360): the board a plan-sheet author arranges the bar's decoration on,
		// mounted into the Top Bar settings section. Unlike every other board here it belongs to the PLAN
		// SHEET, not to a record, so it has no entity id to own its media -- its gallery is the tenant-scoped
		// (OwnerType 'PlansheetTopBar', IDOwner 0) bucket, which the server resolves from the session (the
		// client never names a plan sheet). It gets the drafting sticker set, since a bar decoration is
		// mostly cutouts. The board is NOT autosaved: the author composes freely and the explicit "Set as
		// top bar" action is what bakes and stores it, so a half-arranged bar never lands on the chrome.
		let fTopBarBoardOwnerId = () => 0;
		let tmpTopBarImageSource = new libMoodboardMediaImageSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fTopBarBoardOwnerId,
				OwnerType: 'PlansheetTopBar',
				AllowZeroOwner: true
			});
		let tmpTopBarDrawingSource = new libMoodboardDrawingSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fTopBarBoardOwnerId,
				OwnerType: 'PlansheetTopBar',
				AllowZeroOwner: true
			});
		this.pict.addView('TopBar-Board-Edit', Object.assign({}, libMoodboardSection.default_configuration,
			{
				ViewIdentifier: 'TopBar-Board-Edit',
				AutoRender: false,
				Editable: true,
				DefaultDestinationAddress: '#Settings-TopBar-Board',
				ImageSource: tmpTopBarImageSource,
				DrawingSource: tmpTopBarDrawingSource,
				StickerSource: this._StickerSources.whiteboard,
				Renderables: [ { RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Settings-TopBar-Board', RenderMethod: 'replace' } ]
			}), libMoodboardSection);

		// The standalone Whiteboards library page + the editor it opens boards into. The editor gets the
		// same Media-backed image gallery the vision board has, scoped to whichever board is open, so
		// photos (e.g. a snap of a physical whiteboard) upload and drop in.
		this.pict.addView('Plansheet-Whiteboards', libViewWhiteboards.default_configuration, libViewWhiteboards);
		this.pict.addView('Plansheet-StickerSetsPreview', libViewStickerSetsPreview.default_configuration, libViewStickerSetsPreview);
		// The contextual help drawer's content view, registered before the Shell renders so the shell's
		// right panel can bind it as its ContentView. Toggled by F1 / the top-bar "?" (see toggleHelpDrawer).
		this.pict.addView('Plansheet-HelpDrawer', libViewHelpDrawer.default_configuration, libViewHelpDrawer);
			this.pict.addView('Plansheet-Notebook', libViewNotebook.default_configuration, libViewNotebook);
		this.pict.addView('Plansheet-OpsConsole', libViewOpsConsole.default_configuration, libViewOpsConsole);
		this.pict.addView('Plansheet-Releases', libViewReleases.default_configuration, libViewReleases);
		this.pict.addView('Plansheet-Runs', libViewRuns.default_configuration, libViewRuns);
		this.pict.addView('Plansheet-Ask', libViewAsk.default_configuration, libViewAsk);
		this.pict.addView('Plansheet-Project', libViewProject.default_configuration, libViewProject);
		this.pict.addView('Plansheet-ProjectTypes', libViewProjectTypes.default_configuration, libViewProjectTypes);
		this.pict.addView('Plansheet-CapabilityActivation', libViewCapabilityActivation.default_configuration, libViewCapabilityActivation);
		this.pict.addView('Plansheet-OrgActivity', libViewOrgActivity.default_configuration, libViewOrgActivity);
		this.pict.addView('Plansheet-SystemActivity', libViewSystemActivity.default_configuration, libViewSystemActivity);
		// The reusable activity-graph section, configured for plansheet's two domains and pointed at the
		// System Activity page's chart slot. The granularity switcher calls back to refetch that period.
		this.pict.addView('Plansheet-SystemActivity-Chart', Object.assign({}, libSectionActivityGraph.default_configuration,
			{
				ActivityGraph: Object.assign({}, libSectionActivityGraph.default_configuration.ActivityGraph,
					{
						Period: 'Week', Title: '',
						Columns:
						[
							{ Key: 'WorkItems', Title: 'Work Items', Accent: '#e0891e' },
							{ Key: 'Knowledge', Title: 'Knowledge', Accent: '#3f7fd0' }
						],
						PeriodChangeHandler: (pPeriod) => { let tmpView = this.pict.views['Plansheet-SystemActivity']; if (tmpView) { tmpView.selectPeriod(pPeriod); } }
					}),
				Renderables:
				[
					{ RenderableHash: 'Pict-ActivityGraph-Container', TemplateHash: 'Pict-ActivityGraph-Container', ContentDestinationAddress: '#SystemActivity-Chart', RenderMethod: 'replace' }
				]
			}), libSectionActivityGraph);
		this.pict.addView('Plansheet-IssueBoard', libViewIssueBoard.default_configuration, libViewIssueBoard);
		this.pict.addView('Plansheet-FeatureBoard', libViewFeatureBoard.default_configuration, libViewFeatureBoard);
		this.pict.addView('Plansheet-DeliverableBoard', libViewDeliverableBoard.default_configuration, libViewDeliverableBoard);
		this.pict.addView('Plansheet-CallDesk', libViewCallDesk.default_configuration, libViewCallDesk);
		this.pict.addView('Plansheet-VisionLoops', libViewVisionLoops.default_configuration, libViewVisionLoops);
		// The searchable picker provider backs the connections linker (type + candidate pickers).
		this.pict.addProvider('Pict-Section-Picker', libPictSectionPicker.default_configuration, libPictSectionPicker);
		this.pict.addView('Plansheet-Connections', libViewConnections.default_configuration, libViewConnections);
		// The personal "Checklists" page (the user's private lists). Renders into the workspace; the
		// work-item embed uses a second instance with its own destination.
		this.pict.addView('Plansheet-Checklists', Object.assign({}, libViewChecklists.default_configuration,
			{
				Mode: 'mine',
				Heading: 'Checklists',
				DefaultDestinationAddress: '#Plansheet-Workspace',
				Renderables: [{ RenderableHash: 'Plansheet-Checklists', TemplateHash: 'Plansheet-Checklists', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }]
			}), libViewChecklists);
		// The work-item embed: the SHARED checklists on a work item's detail page. EntityDetail configures
		// and mounts this per work item into its #Entity-Checklists container.
		this.pict.addView('Plansheet-Checklists-Embed', Object.assign({}, libViewChecklists.default_configuration,
			{
				Mode: 'owner',
				Heading: 'Checklists',
				DefaultDestinationAddress: '#Entity-Checklists',
				Renderables: [{ RenderableHash: 'Plansheet-Checklists', TemplateHash: 'Plansheet-Checklists', ContentDestinationAddress: '#Entity-Checklists', RenderMethod: 'replace' }]
			}), libViewChecklists);
		// The notebook's Checklists tab: the user's personal lists embedded in the left drawer. A second
		// 'mine' instance with its own destination, so it coexists with the full /checklists page.
		this.pict.addView('Plansheet-Notebook-Checklists', Object.assign({}, libViewChecklists.default_configuration,
			{
				Mode: 'mine',
				Heading: 'Checklists',
				Compact: true,
				DefaultDestinationAddress: '#PS-Notebook-Checklists',
				Renderables: [{ RenderableHash: 'Plansheet-Checklists', TemplateHash: 'Plansheet-Checklists', ContentDestinationAddress: '#PS-Notebook-Checklists', RenderMethod: 'replace' }]
			}), libViewChecklists);
		let fWhiteboardPageOwnerId = () => (this.pict.views['Plansheet-Whiteboards'] ? this.pict.views['Plansheet-Whiteboards'].currentBoardId() : null);
		let tmpWhiteboardPageImageSource = new libMoodboardMediaImageSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fWhiteboardPageOwnerId
			});
		let tmpWhiteboardPageDrawingSource = new libMoodboardDrawingSource(
			{
				MediaAPI: this.pict.providers.MediaAPI,
				getOwnerId: fWhiteboardPageOwnerId
			});
		this.pict.addView('Whiteboard-Page-Edit', Object.assign({}, libMoodboardSection.default_configuration,
			{
				ViewIdentifier: 'Whiteboard-Page-Edit',
				AutoRender: false,
				Editable: true,
				DefaultDestinationAddress: '#Whiteboard-Page-Canvas',
				ImageSource: tmpWhiteboardPageImageSource,
				DrawingSource: tmpWhiteboardPageDrawingSource,
				StickerSource: this._StickerSources.whiteboard,
				onBoardChanged: (pBoard) => { if (this.pict.views['Plansheet-Whiteboards']) { this.pict.views['Plansheet-Whiteboards'].onBoardSaved(pBoard); } },
				Renderables: [ { RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Whiteboard-Page-Canvas', RenderMethod: 'replace' } ]
			}), libMoodboardSection);
		// A read-only board mounted into the full-screen overlay (openBoardFullscreen). It presents the
		// board's stored display style, so a photo whiteboard (jumbotron) shows full-bleed edge to edge.
		this.pict.addView('Whiteboard-Fullscreen-View', Object.assign({}, libMoodboardSection.default_configuration,
			{
				ViewIdentifier: 'Whiteboard-Fullscreen-View',
				AutoRender: false,
				Editable: false,
				DefaultDestinationAddress: '#Whiteboard-Fullscreen-Canvas',
				Renderables: [ { RenderableHash: 'Moodboard-Container', TemplateHash: 'Moodboard-Container', ContentDestinationAddress: '#Whiteboard-Fullscreen-Canvas', RenderMethod: 'replace' } ]
			}), libMoodboardSection);

		// Comments: an embedded discussion section on the Vision and WorkItem detail pages, sharing the
		// detail's #Entity-Comments container. It persists through PlansheetCommentProvider (the
		// CommentThread + Comment tables, tenant-scoped). EntityDetail sets the Context + CurrentUser +
		// read-only per mount. Inline markdown composer by default; 'rich' opens the full editor in a modal.
		let tmpCommentProvider = new libPlansheetCommentProvider(this.pict);
		this.pict.addView('Plansheet-Comments', Object.assign({}, libCommentsSection.default_configuration,
			{
				ViewIdentifier: 'Plansheet-Comments',
				AutoRender: false,
				DefaultDestinationAddress: '#Entity-Comments',
				Threaded: true,
				EditorMode: 'markdown',
				Title: 'Comments',
				DataProvider: tmpCommentProvider,
				Renderables: [ { RenderableHash: 'Comments-Section', TemplateHash: 'Comments-Section', ContentDestinationAddress: '#Entity-Comments', RenderMethod: 'replace' } ]
			}), libCommentsSection);

		// Prompt management: the pict-section-prompteditor section (My Library inside
		// the Prompt Library page) persisted through PlansheetPromptProvider - the
		// Prompt/WordList/GeneratedPrompt tables, owner-scoped and version-captured
		// server-side. The library page feeds it the merged shape cascade (platform
		// defaults shadowed by org adoptions plus the user's own shapes) and the
		// signed-in CurrentUser on every show. CodeMirror rides the same
		// window.CodeMirrorModules bundle the doc editors use, so rich segment
		// editing works out of the box.
		let tmpPromptProvider = new libPlansheetPromptProvider(this.pict);
		this.pict.addView('Plansheet-PromptEditor', Object.assign({}, libPromptEditorSection.default_configuration,
			{
				ViewIdentifier: 'Plansheet-PromptEditor',
				AutoRender: false,
				DefaultDestinationAddress: '#PromptLibrary-Editor-Container',
				Title: 'My prompt library',
				DataProvider: tmpPromptProvider,
				Renderables: [ { RenderableHash: 'PromptEditor-Section', TemplateHash: 'PromptEditor-Section', ContentDestinationAddress: '#PromptLibrary-Editor-Container', RenderMethod: 'replace' } ]
			}), libPromptEditorSection);
		this.pict.addView('Plansheet-PromptLibrary', libViewPromptLibrary.default_configuration, libViewPromptLibrary);
		this.pict.addView('Plansheet-PromptShapes', libViewPromptShapes.default_configuration, libViewPromptShapes);
		this.pict.addView('Plansheet-PromptAttachments', libViewPromptAttachments.default_configuration, libViewPromptAttachments);

		// 4. The vendored Claude session viewer.
		//
		//    The viewer is a set of cooperating Pict views that render into
		//    #ClaudeTransformer-Workspace (mounted lazily by
		//    _mountTransformerContainer). The hashes are fixed: the views
		//    cross-reference each other by name (e.g. _Pict.views.Conversation
		//    in onclick handlers, this.pict.views.Layout from siblings), so
		//    they must register as Dropzone/Layout/Signature/Timeline/
		//    Conversation/ToolDetail/AgentDetail exactly.
		//
		//    The flow: a signed-in user who drops a session zip has it uploaded
		//    to their account by the Dropzone (via the SessionAPI provider),
		//    which then returns to the refreshed calendar. Clicking a stored
		//    session downloads its blob and renders it through onSessionLoaded.
		this.pict.addView('Dropzone',     libViewCTDropzone.default_configuration,     libViewCTDropzone);
		this.pict.addView('Layout',       libViewCTLayout.default_configuration,       libViewCTLayout);
		this.pict.addView('Signature',    libViewCTSignature.default_configuration,    libViewCTSignature);
		this.pict.addView('Timeline',     libViewCTTimeline.default_configuration,     libViewCTTimeline);
		this.pict.addView('Conversation', libViewCTConversation.default_configuration, libViewCTConversation);
		this.pict.addView('ToolDetail',   libViewCTToolDetail.default_configuration,   libViewCTToolDetail);
		this.pict.addView('AgentDetail',  libViewCTAgentDetail.default_configuration,  libViewCTAgentDetail);
		// The one section plansheet drives directly (showDropzone /
		// loadSessionFromZip); see openServerSession / showUploader below.
		this.pict.addView('Pict-Section-ClaudeTransformer',
			libPictSectionClaudeTransformer.default_configuration, libPictSectionClaudeTransformer);
		// The vendored Layout/Signature open detail popups through
		// _Pict.views.PictSectionModal; alias it to plansheet's modal section.
		this.pict.views.PictSectionModal = this.pict.views['Pict-Section-Modal'];

		// 5. Theme — last, so its TopBar can wire the slot view ids above.
		//    The brand palettes register into the theme catalog before the
		//    provider boots: Plan Sheet is the default pair (vellum in light
		//    mode, night drafting in dark, following the system), and the
		//    Blueprint + Drafting Paper singles and the Southwest desert set join the picker. The bundled
		//    catalog is cleared first so only these curated palettes show, not the ~45 pict-section-theme
		//    ships. Amber in the drafting palettes is measurement ink:
		//    dimensions, revisions, warnings, nothing else.
		// pict-section-theme 1.x ships ~45 themes in its catalog; clear them so the picker shows only the
		// curated set below. The runtime provider is fed from this catalog at boot (RegisterCatalog default).
		libPictSectionTheme.Catalog.clear();
		libPictSectionTheme.Catalog.register({ Hash: 'plansheet', Category: 'Plansheet', Bundle: require('./themes/plansheet.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'plansheet-blueprint', Category: 'Plansheet', Bundle: require('./themes/plansheet-blueprint.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'plansheet-paper', Category: 'Plansheet', Bundle: require('./themes/plansheet-paper.json') });
		// The Southwest desert set, adapted from the palettes Ultravisor ships in pict-section-theme.
		libPictSectionTheme.Catalog.register({ Hash: 'southwest-desert-day', Category: 'Southwest', Bundle: require('./themes/southwest-desert-day.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'southwest-desert-dusk', Category: 'Southwest', Bundle: require('./themes/southwest-desert-dusk.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'southwest-desert-sunset', Category: 'Southwest', Bundle: require('./themes/southwest-desert-sunset.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'southwest-desert-canyon', Category: 'Southwest', Bundle: require('./themes/southwest-desert-canyon.json') });
		// Showcase set: each a light+dark pair. Colours live in the bundle; the per-theme font + signature
		// (Win9x bevels, etc.) ride the html[data-theme=...] marker the apply hook below stamps.
		libPictSectionTheme.Catalog.register({ Hash: 'high-contrast', Category: 'Accessible', Bundle: require('./themes/high-contrast.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'plain', Category: 'Accessible', Bundle: require('./themes/plain.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'nostalgia', Category: 'Retro', Bundle: require('./themes/nostalgia.json') });
		libPictSectionTheme.Catalog.register({ Hash: '1990s-website', Category: 'Retro', Bundle: require('./themes/1990s-website.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'london-subway', Category: 'Retro', Bundle: require('./themes/london-subway.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'cyberpunk', Category: 'Neon', Bundle: require('./themes/cyberpunk.json') });
		libPictSectionTheme.Catalog.register({ Hash: 'neo-tokyo', Category: 'Neon', Bundle: require('./themes/neo-tokyo.json') });
		this.pict.addProvider('Theme-Section',
			{
				ApplyDefault: 'plansheet',
				DefaultMode:  'system',
				DefaultScale: 1.0,
				Brand:        libBrand,
				Views: ['Picker', 'ModeToggle', 'ScaleSelect', 'BrandMark', 'TopBar'],
				ViewOptions:
				{
					// Optgroup order in the picker: the Plansheet drafting palettes first, then the Southwest set.
					Picker: { Categories: ['Plansheet', 'Southwest', 'Accessible', 'Retro', 'Neon'] },
					TopBar: { NavView: 'Plansheet-TopBar-Nav', UserView: 'Plansheet-TopBar-User', Height: 56 }
				}
			}, libPictSectionTheme);

			// pict-section-theme 1.x sets the .theme-dark / .theme-light class only for an EXPLICIT mode; in
			// 'system' mode it switches the CSS vars via @media but leaves the class off. Plansheet's shell and
			// the moodboard note key their dark styling off .theme-dark, so reflect the RESOLVED mode as that
			// class on every apply (the system-follows-OS case included). One hook restores the always-set-class
			// behavior 0.0.3 had, so every html.theme-dark rule keeps working without a prefers-color-scheme copy.
			let tmpThemeRuntime = this.pict.providers.Theme;
			if (tmpThemeRuntime && typeof tmpThemeRuntime.onApply === 'function')
			{
				let fReflectThemeMode = () =>
				{
					let tmpActive = (typeof tmpThemeRuntime.getActiveTheme === 'function') ? tmpThemeRuntime.getActiveTheme() : null;
					let tmpResolved = tmpActive && tmpActive.ResolvedMode;
					if (typeof document !== 'undefined' && document.documentElement)
					{
						document.documentElement.classList.toggle('theme-dark', tmpResolved === 'dark');
						document.documentElement.classList.toggle('theme-light', tmpResolved === 'light');
						// The active theme hash drives per-theme fonts + signatures (html[data-theme=...]) in the shell CSS.
						document.documentElement.setAttribute('data-theme', (tmpActive && tmpActive.Hash) || '');
					}
				};
				tmpThemeRuntime.onApply(fReflectThemeMode);
				fReflectThemeMode(); // the boot apply fired during addProvider, before this listener attached
			}

		// 6. Router — hash-based stable URLs (pict-router). Routes register now
		//    but only resolve after auth (SkipRouteResolveOnAdd), so a pasted
		//    deep-link lands once signed in (via navigateCurrent in _showWorkspace).
		//    The router also keeps document.title in step with the route (a page title plus the
		//    " - Plansheet" suffix, falling back to "Plansheet"), which is what makes bookmarks and the
		//    recent-pages history read as real page names instead of a constant "Plansheet".
		this.pict.addProvider('Pict-Router', { SkipRouteResolveOnAdd: true, DefaultTitle: 'Plansheet', TitleSuffix: ' - Plansheet' }, libPictRouter);
		this._setupRoutes();
	}

	onAfterInitializeAsync(fCallback)
	{
		// Render the shell — creates #Plansheet-Workspace, which the rest
		// of the views render into.
		this.pict.views['Plansheet-Shell'].render();

		// Friendly "checking session…" splash while we ask the server.
		let tmpWorkspace = document.getElementById('Plansheet-Workspace');
		if (tmpWorkspace) tmpWorkspace.textContent = 'Loading…';

		// Kick off the OAuth provider list (a small JSON fetch) in parallel with the session check, but make
		// the login screen WAIT for it before its first paint so the Google / GitHub buttons are present on
		// the very first render. The earlier "paint now, repaint when the list lands" approach had a race: on
		// a cold load (uncached JS, slower everything) the list could arrive in the window between showAuth()
		// rendering and the view's initialRenderComplete flag flipping, so the repaint was skipped and the
		// buttons never appeared until a reload. Waiting is bounded (3s) so a slow or failed provider fetch
		// never blocks sign-in -- the form just shows without the OAuth buttons in that worst case.
		// --- TEMP DIAGNOSTIC ([auth-boot]) for the OAuth-button cold-load issue: trace the provider-fetch vs
		// auth-render ordering so a cold load on prod prints the actual sequence in the console. Remove once
		// confirmed (grep "auth-boot"). performance.now() is ms since page load, so the numbers show how long
		// after load each step happened. ---
		let fAuthLog = (pMsg) => { try { console.log('[auth-boot] +' + Math.round((typeof performance !== 'undefined' ? performance.now() : 0)) + 'ms ' + pMsg); } catch (pErr) { /* no-op */ } };
		let fProviderCount = () => ((this.pict.AppData.Auth && this.pict.AppData.Auth.Providers) ? this.pict.AppData.Auth.Providers.length : 0);

		let tmpLoadProviders = this.pict.providers.AuthClient.loadProviders().catch(() => {});
		tmpLoadProviders.then(() => { fAuthLog('providers resolved: ' + fProviderCount()); });
		let tmpProvidersReady = Promise.race(
			[
				tmpLoadProviders,
				new Promise((resolve) => { setTimeout(resolve, 3000); })
			]);
		// Belt-and-suspenders: if the provider list lands AFTER the login screen is already on-screen (only
		// possible if it took longer than the bound above), repaint the auth screen so its buttons appear.
		// Keyed on a DOM check (is the sign-in screen up?) rather than a view flag, so it is reliable even on
		// a cold load -- the flag-based version of this had a race where the repaint was skipped.
		tmpLoadProviders.then(() =>
		{
			if (typeof document !== 'undefined' && document.body && document.body.classList.contains('plansheet-auth-mode'))
			{
				fAuthLog('late repaint (providers arrived after login shown): ' + fProviderCount());
				let tmpAuthView = this.pict.views['Plansheet-Auth'];
				if (tmpAuthView) { tmpAuthView.render(); }
			}
		});
		// A magic-link URL (#/magic/<token>) is resolved BEFORE the normal auth gate: the recipient clicks
		// it signed out, so a plain checkSession would just show the login screen. Verify the token (the hooks
		// sign in, run the SMS 2FA step, or fall back to the login screen with an error), and skip the gate.
		// Purely additive -- every other load falls through to the unchanged checkSession below.
		let tmpMagicToken = this._magicTokenFromURL();
		if (tmpMagicToken)
		{
			fAuthLog('magic-link token present; verifying');
			this._handleMagicLink(tmpMagicToken);
			return super.onAfterInitializeAsync(fCallback);
		}
		// An invite URL (#/invite/<token>): auto-accept if already signed in with the matching email, else show
		// the sign-in screen and accept right after they sign in (onAuthChanged). Additive, same as magic links.
		let tmpInviteToken = this._inviteTokenFromURL();
		if (tmpInviteToken)
		{
			fAuthLog('invite token present; handling');
			this._handleInviteToken(tmpInviteToken);
			return super.onAfterInitializeAsync(fCallback);
		}
		this.pict.providers.AuthClient.checkSession().then((pLoggedIn) =>
		{
			fAuthLog('checkSession: loggedIn=' + (!!pLoggedIn));
			if (this.pict.views['Plansheet-TopBar-User']) this.pict.views['Plansheet-TopBar-User'].render();
			if (pLoggedIn)
			{
				this._enableSessionRecovery();
				// If the user pinned an explicit default plan sheet on this device, switch into it before
				// rendering the workspace. The server already remembers the last-visited plan sheet via
				// the LastLoginDate stamp on every switch; the pin setting overrides that for hard
				// affinity. If the switch fails (no longer a member) the pin is cleared automatically.
				this._applyPinnedCustomerIfNeeded().then(() => this._showWorkspace());
			}
			else
			{
				tmpProvidersReady.then(() => { fAuthLog('showAuth(login) -- providers in AppData: ' + fProviderCount()); this.showAuth('login'); });
			}
		}).catch(() =>
		{
			tmpProvidersReady.then(() => { fAuthLog('showAuth(login) [after checkSession error] -- providers: ' + fProviderCount()); this.showAuth('login'); });
		});

		return super.onAfterInitializeAsync(fCallback);
	}

	// ── SDLC workspace navigation (URL-driven via pict-router) ───────────────
	// Public show* methods set the URL; the route handlers render. The browser
	// URL is the single source of truth, so links are copy/paste stable and
	// back / forward / pasted deep-links all work.

	_router() { return this.pict.providers['Pict-Router']; }
	// navigo's own navigate() matches the route and calls its handler BEFORE it writes the new
	// hash to the browser (updateBrowserURL is the LAST middleware in its chain) -- so a route
	// handler that reads window.location.hash while it renders still sees the PREVIOUS route's
	// hash, query string included. Board and the entity list both do exactly that, to honor a
	// shared/reloaded link (FocusFilters.stateFromHash): clicking Board -> Feedback with a
	// "recent" window active left window.location.hash reading "#/board?recent=1d" while the
	// Feedback route handler ran, so it read the Board's filter as its own landing state (#356).
	//
	// The #356 fix silently wrote the destination hash first via history.REPLACESTATE, reasoning
	// that navigo's own updateBrowserURL would then push the same value, netting exactly one new
	// history entry. That reasoning was wrong: replaceState does not "reserve" an entry, it
	// overwrites whatever is CURRENTLY on top of the stack -- the entry for the page being LEFT.
	// So every navigation silently rewrote the outgoing page's history entry to the destination
	// and then navigo pushed a duplicate of that same destination on top of it. Two entries in a
	// row always read the same page, so pressing Back once landed back on a duplicate of the page
	// you were already on (no visible change) instead of the page you came from -- Back had to be
	// pressed twice to go anywhere, and the entry that used to name the previous page was gone
	// (#363). Fix: pre-write the hash ourselves with PUSHSTATE (a real new entry, so the outgoing
	// entry is left untouched), then tell navigo not to write the URL again (updateBrowserURL:
	// false) since we already did. Falls back to the old (still #356-safe) behavior if the raw
	// navigo instance is not reachable.
	// RETURNS WHETHER THE ROUTE ACTUALLY RESOLVED. The router declines to re-run a handler for the route
	// it is already on, which is right -- but it used to do so silently, so a caller could not tell
	// "went there" from "did nothing" and code that assumed it had moved left the page where it was.
	// pict-router 1.0.13 reports that; this passes the answer up, and refuses to push a history entry
	// for a navigation that is not going to happen (a duplicate entry is the #363 Back-does-nothing bug
	// in miniature). One guard, here, instead of a hash comparison hand-rolled into every caller.
	// Whether the router has ALREADY RESOLVED this exact route, matched the way the router matches:
	// path and query string both. Not the same question as "does the address bar say this".
	_routerIsOn(pRoute)
	{
		let tmpRouter = this._router();
		if (!tmpRouter || typeof tmpRouter.lastMatch !== 'function') { return false; }
		let tmpMatch = tmpRouter.lastMatch();
		if (!tmpMatch) { return false; }
		let tmpWanted = String(pRoute || '/').replace(/^#/, '').replace(/^\/+/, '');
		let tmpSplit = tmpWanted.indexOf('?');
		let tmpPath = (tmpSplit >= 0) ? tmpWanted.slice(0, tmpSplit) : tmpWanted;
		let tmpQuery = (tmpSplit >= 0) ? tmpWanted.slice(tmpSplit + 1) : '';
		return (String(tmpMatch.url || '') === tmpPath) && (String(tmpMatch.queryString || '') === tmpQuery);
	}

	_navigate(pRoute)
	{
		let tmpRouter = this._router();
		if (!tmpRouter) { return false; }
		let tmpHash = '#' + String(pRoute || '/').replace(/^#/, '');
		// ASK THE ROUTER, NOT THE ADDRESS BAR. Whether a navigation will do anything is the router's
		// state to answer: the hash can name a route the router has NOT resolved (boot into a pasted
		// deep link, or a sign-out/sign-in where the hash survived), and reading the hash here refused
		// those navigations and left the page blank. Skipping only when the router really is on this
		// route also keeps the history clean, since a duplicate entry is the #363 Back-does-nothing bug.
		if (this._routerIsOn(pRoute)) { return false; }
		if (typeof window !== 'undefined' && window.location && window.history && typeof window.history.pushState === 'function'
			&& tmpRouter.router && typeof tmpRouter.navigate === 'function')
		{
			window.history.pushState(null, '', (window.location.pathname || '') + (window.location.search || '') + tmpHash);
			// updateBrowserURL: false because the line above already wrote it (#363).
			return tmpRouter.navigate(pRoute, { updateBrowserURL: false }) !== false;
		}
		if (typeof window !== 'undefined' && window.location && window.history && typeof window.history.replaceState === 'function')
		{
			window.history.replaceState(null, '', (window.location.pathname || '') + (window.location.search || '') + tmpHash);
		}
		return tmpRouter.navigate(pRoute) !== false;
	}
	// Entity Key -> route slug. These MUST stay in sync with the tmpLists / tmpDetails route tables in
	// _setupRoutes. A key missing here silently falls back to a bare lowercased slug, which for any multi-word
	// key matches no registered route at all: AsBuilt fell back to "asbuilt" while its route is "as-built", so
	// Open and row-click on the As-Builts list did nothing, with no error.
	_pluralRoute(pKey) { return ({ Vision: 'visions', Module: 'modules', Feature: 'features', WorkItem: 'work-items', Routine: 'routines', TestRun: 'test-runs', Feedback: 'feedback', KeystoneCustomer: 'keystone-customers', Issue: 'issues', Contact: 'contacts', Call: 'calls', IssueType: 'issue-types', Expectation: 'expectations', Deliverable: 'deliverables', Session: 'sessions', Blueprint: 'blueprints', AsBuilt: 'as-builts', DeployRequest: 'deploy-requests', NodeRegistration: 'node-registrations' })[pKey] || String(pKey).toLowerCase(); }
	// ASKS _DETAIL_SLUGS FIRST, because that map is what actually REGISTERS /<slug>/:id. This used to be
	// a second hand-maintained copy of the same knowledge, and it drifted. An entity was added to
	// _LIST_SLUGS, to _DETAIL_SLUGS and to _pluralRoute, and missed here, so its row click fell through
	// to String(Key).toLowerCase() and navigated to a hyphen-less route nobody had registered. The
	// router matched nothing and the pane never changed: clicking a row simply did nothing, with no
	// error and no blank page. Edit worked the whole time, because showEntityEdit reads _detailSlugFor.
	//
	// A silent no-op is the worst shape this can take: no error, no blank pane, no 404, just a click that
	// does not land. Deriving from the registration removes the second copy that can be wrong.
	//
	// The literal map that remains is for routes registered SEPARATELY from _DETAIL_SLUGS -- TestRun opens
	// in the runner via its own tmpRouter.addRoute('/test-run/:id') -- so it is a list of exceptions now
	// rather than a duplicate of the rule.
	_singularRoute(pKey) { return _detailSlugFor(pKey) || ({ TestRun: 'test-run' })[pKey] || String(pKey).toLowerCase(); }

	// "work-items" -> "Work Items" -- a readable document title from a route slug.
	_titleCaseSlug(pSlug) { return String(pSlug || '').split('-').map((pPart) => pPart ? (pPart.charAt(0).toUpperCase() + pPart.slice(1)) : pPart).join(' '); }

	// The tenant-safe "feature area" root for a route. Switching, creating, or leaving a plan sheet reloads
	// the app under a different active tenant; a record-specific route (a document path, an entity id) points
	// at a record that tenant does not have, so a blind reload lands on a not-found screen -- the reported
	// route leak. Reduce the route to the feature area it belongs to (the list / overview page every tenant
	// has) and drop the record-specific tail. Every value returned here is a parameterless route, so it can
	// never itself not-found in the new tenant. An unrecognized route falls back to the board. See WI #328.
	//
	// _TenantDetailRouteToArea below mirrors the record routes registered in _setupRoutes: the singular /:id
	// detail routes (head is the singular slug, area is the plural list) plus the id-bearing specials. Keep it
	// in step when those routes change -- a head missing here falls back to the board, which stays safe but is
	// coarser than the intended area.
	_tenantSafeRoute(pRoutePath)
	{
		let tmpDetailRouteToArea =
		{
			// entity detail (singular slug) -> its list page (plural slug)
			'vision': '/visions', 'module': '/modules', 'feature': '/features', 'work-item': '/work-items',
			'routine': '/routines', 'keystone-customer': '/keystone-customers', 'issue': '/issues',
			'contact': '/contacts', 'call': '/calls', 'issue-type': '/issue-types', 'blueprint': '/blueprints',
			'expectation': '/expectations', 'deliverable': '/deliverables', 'as-built': '/as-builts',
			'deploy-request': '/deploy-requests', 'node-registration': '/node-registrations',
			// id-bearing routes that render outside the generic detail pane
			'test-run': '/test-runs', 'session': '/sessions', 'prompt': '/prompts', 'prompt-shape': '/prompt-shapes',
			'whiteboard': '/whiteboards', 'note': '/notes', 'drawing': '/drawings', 'doc-edit': '/docs',
			// the media viewer has no list page of its own
			'media': '/board'
		};
		let tmpPath = String(pRoutePath == null ? '' : pRoutePath).trim().replace(/^#/, '').split('?')[0];
		if (tmpPath.charAt(0) !== '/') { tmpPath = '/' + tmpPath; }
		let tmpSegments = tmpPath.split('/').filter((pSegment) => pSegment.length > 0);
		if (!tmpSegments.length) { return '/board'; }
		let tmpHead = tmpSegments[0];
		// A record route whose area root is spelled differently from its head (work-item -> work-items, ...).
		if (tmpDetailRouteToArea[tmpHead]) { return tmpDetailRouteToArea[tmpHead]; }
		// Two-segment feature areas that are themselves parameterless roots: keep them whole.
		if (tmpSegments.length >= 2)
		{
			let tmpTwo = tmpHead + '/' + tmpSegments[1];
			if (tmpTwo === 'admin/ops' || tmpTwo === 'org/activity') { return '/' + tmpTwo; }
		}
		// Otherwise the head is a single-segment feature area (/docs, /work-items, /settings, /feedback, ...):
		// keep the head and drop any record tail (/docs/<path>, /workflow/subject/:id, /settings/:section/:id,
		// /profile/:id, /prompt-shapes/new, /sessions/upload, ...).
		return '/' + tmpHead;
	}

	// Reduce the current route to its tenant-safe feature area (dropping any record-specific tail), then
	// reload. Call this on every active-plan-sheet change -- switch, create, leave, join, and the pinned-tenant
	// auto-switch on load -- so the reload never carries a record route into a tenant that does not have that
	// record (the reported not-found on switch). See WI #328 and _tenantSafeRoute.
	reloadForActivePlansheetChange()
	{
		if (typeof window === 'undefined' || !window.location) { return; }
		try
		{
			let tmpCurrent = String(window.location.hash || '').replace(/^#/, '');
			let tmpSafe = this._tenantSafeRoute(tmpCurrent);
			if (tmpSafe) { window.location.hash = tmpSafe; }
		}
		catch (pError) { /* fall through to a plain reload */ }
		window.location.reload();
	}

	_setupRoutes()
	{
		let tmpRouter = this._router();
		if (!tmpRouter || typeof tmpRouter.addRoute !== 'function') { return; }
		tmpRouter.addRoute('/', () => this._renderBoard(), 'Board');
		tmpRouter.addRoute('/board', () => this._renderBoard(), 'Board');
		// The cross-tenant "Your plan sheets" home (WI #339): the default landing after sign-in and a
		// tenant-safe area root (a single-segment route, so _tenantSafeRoute keeps it whole on a switch).
		tmpRouter.addRoute('/home', () => this._renderHome(), 'Your plan sheets');
		let tmpLists = _LIST_SLUGS;
		// List pages title from the route slug (Work Items, Test Runs, ...); detail pages set their own title
		// from the loaded record (see PictView-EntityDetail), so those pass no static title.
		Object.keys(tmpLists).forEach((pPlural) => tmpRouter.addRoute('/' + pPlural, () => this._renderList(tmpLists[pPlural]), this._titleCaseSlug(pPlural)));
		let tmpDetails = _DETAIL_SLUGS;
		// THE CREATE AND EDIT FORMS ARE PLACES. They used to render in place at the list's own URL, so a
		// reload dropped a half-written record without warning, Back left the whole list screen instead of
		// closing the form, and the address bar said "list" while the pane showed a form. Same shape as
		// /drawings/new and /prompt-shapes/new, which have been routes for exactly this reason.
		//
		// REGISTERED BEFORE /<singular>/:id, AND THAT ORDER IS LOAD-BEARING. One slug is both a plural
		// and a singular: 'feedback'. So /feedback/new has the same shape as /feedback/:id, this router
		// takes the first route registered for a shape, and with the detail route first every "+ New"
		// on the feedback list resolved as the DETAIL of a record whose id parsed to NaN -- a not-found
		// pane where the create form should be. A literal segment cannot swallow a real id, so putting
		// the literal first is safe for every other slug.
		Object.keys(tmpLists).forEach((pPlural) => tmpRouter.addRoute('/' + pPlural + '/new',
			() => this._renderListNew(tmpLists[pPlural])));
		Object.keys(tmpDetails).forEach((pSing) => tmpRouter.addRoute('/' + pSing + '/:id',
			(pData) => this._renderDetail(tmpDetails[pSing], Number(pData && pData.data && pData.data.id))));
		Object.keys(tmpDetails).forEach((pSing) => tmpRouter.addRoute('/' + pSing + '/:id/edit',
			(pData) => this._renderListEdit(tmpDetails[pSing], Number(pData && pData.data && pData.data.id))));
		// The Node workspace (WI #465): a focused single-node screen (lifecycle actions + Provision), not the
		// generic detail pane. /node/new is the Provision create body; register it BEFORE /node/:id so the literal
		// 'new' is not parsed as an id (the same load-bearing order as /feedback/new above).
		tmpRouter.addRoute('/node/new', () => this._renderNodeCreate(), 'Provision Node');
		tmpRouter.addRoute('/node/:id', (pData) => this._renderNodeWorkspace(Number(pData && pData.data && pData.data.id)), 'Node');
		// Test runs open in the runner, not the generic detail pane.
		tmpRouter.addRoute('/test-run/:id', (pData) => this._renderTestRun(Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/work-item/:id/blueprint', (pData) => this._renderBlueprint(Number(pData && pData.data && pData.data.id)));
		// The same full page for every other blueprintable entity (WI #340). Registered per type rather than
		// as /:type/:id/blueprint because this router matches on SEGMENT COUNT, and a wildcard first segment
		// at three segments would start swallowing routes that have nothing to do with blueprints.
		tmpRouter.addRoute('/vision/:id/blueprint', (pData) => this._renderBlueprint(Number(pData && pData.data && pData.data.id), 'Vision'));
		tmpRouter.addRoute('/module/:id/blueprint', (pData) => this._renderBlueprint(Number(pData && pData.data && pData.data.id), 'Module'));
		tmpRouter.addRoute('/feature/:id/blueprint', (pData) => this._renderBlueprint(Number(pData && pData.data && pData.data.id), 'Feature'));
		tmpRouter.addRoute('/media/:id', (pData) => this._renderMediaViewer(Number(pData && pData.data && pData.data.id)));
		// A blueprint opened as itself. It used to fall into the generic detail loop above, which gave it
		// a record pane with a Description box and no contents -- the blueprint's own page was the one
		// place in the product that could not show a blueprint. Registered here, and removed from that
		// loop, because this router matches the first route registered for a shape.
		tmpRouter.addRoute('/blueprint/:id', (pData) => this._renderBlueprintRecord(Number(pData && pData.data && pData.data.id)));
		// The generic record pane, still reachable: name, description, documentation, comments. It is no
		// longer what /blueprint/:id opens, because a blueprint's own page should show the blueprint.
		tmpRouter.addRoute('/blueprint/:id/details', (pData) => this._renderDetail('Blueprint', Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/blueprint/:id/compose', (pData) => this._renderBlueprintComposer(Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/blueprint/:id/design', (pData) => this._renderBlueprintStudio(Number(pData && pData.data && pData.data.id)));
		// Sessions: the viewer (a stored session) and the uploader are routed so
		// they are copy/paste-linkable and survive a reload. They used to render
		// imperatively, which left the URL stuck on /sessions.
		tmpRouter.addRoute('/session/:id', (pData) => this.openServerSession(Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/sessions/upload', () => this._renderUploader(), 'Upload Session');
		tmpRouter.addRoute('/docs', () => this._renderDocsOverview(), 'Docs');
		tmpRouter.addRoute('/docs/*', (pData) => this._renderDoc(this._docPathFromMatch(pData)));
		// The full-page doc editor (over the Docs Lake). Wildcard because the doc
		// path carries slashes; ownerType/idOwner ride in front of it.
		tmpRouter.addRoute('/doc-edit/*', (pData) => this._renderDocEditor(this._docEditFromMatch(pData)));
		tmpRouter.addRoute('/workflow', () => this._renderWorkflow(), 'Workflow');
		// A workflow subject open in its detail tab is its own route, so a reload keeps it open (it used to
		// reset to the default catalog tab). showSubject fetches by id, so a cold deep-link still resolves.
		tmpRouter.addRoute('/workflow/subject/:id', (pData) => this._renderWorkflowSubject(Number(pData && pData.data && pData.data.id)));
		// The other three tabs are pages in their own right, the same way the subject already is.
		tmpRouter.addRoute('/workflow/:tab', (pData) => this._renderWorkflowTab(String((pData && pData.data && pData.data.tab) || 'catalog')), 'Workflow');
		tmpRouter.addRoute('/prompts', () => this._renderPromptLibrary(), 'Prompt Library');
		// A shared prompt open in the library's reader is its own route, so a reload keeps it open (and it
		// can be linked to a teammate) instead of resetting to the default tab.
		tmpRouter.addRoute('/prompt/:id', (pData) => this._renderPrompt(Number(pData && pData.data && pData.data.id)));
		// Which tab of the library you are on is a place: your own library, the shared one, your shapes.
		// Registered after /prompts and /prompt/:id so neither is shadowed.
		tmpRouter.addRoute('/prompts/:tab', (pData) => this._renderPromptLibraryTab(String((pData && pData.data && pData.data.tab) || 'library')), 'Prompt Library');
		tmpRouter.addRoute('/prompt-shapes', () => this._renderPromptShapes(), 'Prompt Shapes');
		// The standalone shape editor (new + existing) is its own route, so an in-progress edit survives a
		// reload. Only the standalone page is routed; the shape editor embedded in the Prompt Library / org
		// settings stays inline (it is not a page of its own).
		tmpRouter.addRoute('/prompt-shapes/new', () => this._renderPromptShapeEditor(0));
		tmpRouter.addRoute('/prompt-shape/:id', (pData) => this._renderPromptShapeEditor(Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/community', () => this._renderCommunity(), 'Community');
		tmpRouter.addRoute('/whiteboards', () => this._renderWhiteboards(), 'Whiteboards');
		// One board open in the editor is its own route, so it deep-links and survives a reload (the board
		// used to open imperatively from the list, leaving the URL on /whiteboards -- a reload dropped you
		// back to the list, which is easy to lose in a big list). Detail title is set from the loaded board.
		tmpRouter.addRoute('/whiteboard/:id', (pData) => this._renderWhiteboardEditor(Number(pData && pData.data && pData.data.id)));
		// The read-only full-screen "peek" of a board is its own route too, so a reload keeps it up (it is
		// opened from the whiteboards list, the editor, and entity-detail boards). Closing returns to where
		// it was opened from (a cold deep-link has no origin, so it falls back to /whiteboards).
		tmpRouter.addRoute('/whiteboard/:id/fullscreen', (pData) => this._renderBoardFullscreen(Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/sticker-sets-preview', () => this._renderStickerSetsPreview(), 'Sticker Sets');
		tmpRouter.addRoute('/checklists', () => this._renderChecklists(), 'Checklists');
		tmpRouter.addRoute('/notes', () => this._renderNotesPage(), 'Notes');
		// The note open in the editor pane is its own route, so a reload keeps it open (the selection used
		// to live only in memory, so a reload emptied the editor and lost any unsaved title/body draft).
		tmpRouter.addRoute('/note/:id', (pData) => this._renderNote(Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/bookmarks', () => this._renderBookmarksPage(), 'Bookmarks');
		tmpRouter.addRoute('/gallery', () => this._renderGalleryPage(), 'Gallery');
		tmpRouter.addRoute('/drawings', () => this._renderDrawingsPage(), 'Drawings');
		// One drawing open in the Excalidraw editor is its own route (new + existing), so the open canvas
		// deep-links and survives a reload instead of vanishing back to /drawings.
		tmpRouter.addRoute('/drawings/new', () => this._renderDrawingEditor(0));
		tmpRouter.addRoute('/drawing/:id', (pData) => this._renderDrawingEditor(Number(pData && pData.data && pData.data.id)));
		tmpRouter.addRoute('/admin/ops', () => this._renderOpsConsole(), 'Ops Console');
		tmpRouter.addRoute('/releases', () => this._renderReleases(), 'Releases');
		tmpRouter.addRoute('/runs', () => this._renderRuns(), 'Runs');
		tmpRouter.addRoute('/ask', () => this._renderAsk(), 'Ask');
		// Each Ask state is a route so Back and reload work: the task's input form and an in-flight/answered
		// request both deep-link instead of living only in the view's memory (which broke the Back button).
		tmpRouter.addRoute('/ask/task/:id', (pData) => this._renderAskTask(Number(pData && pData.data && pData.data.id)), 'Ask');
		tmpRouter.addRoute('/ask/request/:id', (pData) => this._renderAskRequest(Number(pData && pData.data && pData.data.id)), 'Ask');
		tmpRouter.addRoute('/projects', () => this._renderProjects(), 'Projects');
		tmpRouter.addRoute('/project/:id', (pData) => this._renderProject(Number(pData && pData.data && pData.data.id)), 'Projects');
		tmpRouter.addRoute('/project-types', () => this._renderProjectTypes(), 'Project Types');
		tmpRouter.addRoute('/project-type/:id', (pData) => this._renderProjectType(Number(pData && pData.data && pData.data.id)), 'Project Types');
		tmpRouter.addRoute('/capabilities', () => this._renderCapabilityActivation(), 'CapabilityActivation');
		tmpRouter.addRoute('/org/activity', () => this._renderOrgActivity(), 'Activity');
		tmpRouter.addRoute('/system-activity', () => this._renderSystemActivity(), 'System Activity');
		// The granularity you are looking at is part of what the page IS, so it belongs in the URL.
		tmpRouter.addRoute('/system-activity/:period', (pData) => this._renderSystemActivity(String((pData && pData.data && pData.data.period) || '')), 'System Activity');
		tmpRouter.addRoute('/issues', () => this._renderIssues(), 'Issues');
		tmpRouter.addRoute('/feature-board', () => this._renderFeatureBoard(), 'Feature Board');
		tmpRouter.addRoute('/deliver', () => this._renderDeliverBoard(), 'Deliver');
		tmpRouter.addRoute('/call-desk', () => this._renderCallDesk(), 'Call Desk');
		// One customer's desk is a place: their contacts, their call history, the log-a-call form.
		tmpRouter.addRoute('/call-desk/:id', (pData) => this._renderCallDeskCustomer(Number(pData && pData.data && pData.data.id)), 'Call Desk');
		tmpRouter.addRoute('/settings/:section/:id', (pData) => this._renderSettingsSection(pData && pData.data && pData.data.section, pData && pData.data && pData.data.id));
		tmpRouter.addRoute('/settings/:section', (pData) => this._renderSettingsSection(pData && pData.data && pData.data.section, null));
		tmpRouter.addRoute('/settings', () => this._renderUserSettings());
		tmpRouter.addRoute('/profile', () => this._renderProfile());
		tmpRouter.addRoute('/profile/:id', (pData) => this._renderProfileFor(Number(pData && pData.data && pData.data.id)));
	}

	// The matched doc path (with optional ::section) from Navigo's match data. A
	// document path has slashes that a single-segment :param can't hold, so we
	// take the wildcard tail from pData.url. Reading it from the match (not from
	// window.location.hash, which lags during the re-entrant navigate that
	// syncDocURL fires) keeps the /docs route idempotent and loop-free.
	_docPathFromMatch(pData)
	{
		let tmpUrl = (pData && pData.url) || '';
		let tmpRest = String(tmpUrl).replace(/^\/?docs\/?/, '');
		try { tmpRest = decodeURIComponent(tmpRest); } catch (pError) { /* leave as-is */ }
		return tmpRest;
	}

	// Parse /doc-edit/<OwnerType>/<IDOwner>/<doc/path/with/slashes> from the match.
	_docEditFromMatch(pData)
	{
		let tmpUrl = (pData && pData.url) || '';
		let tmpRest = String(tmpUrl).replace(/^\/?doc-edit\/?/, '');
		let tmpParts = tmpRest.split('/');
		let tmpOwnerType = tmpParts.shift() || '';
		let tmpIDOwner = Number(tmpParts.shift()) || 0;
		let tmpPath = tmpParts.join('/');
		try { tmpPath = decodeURIComponent(tmpPath); } catch (pError) { /* leave as-is */ }
		return { OwnerType: tmpOwnerType, IDOwner: tmpIDOwner, Path: tmpPath };
	}

	_setActiveNav(pKey)
	{
		// App-owned record of the active workspace. AppData.Nav is not always populated, so _renderDoc keys
		// its idempotency skip off this instead (see the comment there).
		this._activeNavKey = pKey;
		if (this.pict.AppData.Nav) { this.pict.AppData.Nav.Active = pKey; }
		// Any page route sets active nav; the fullscreen-board route deliberately does not. So this is a
		// reliable point to take the board-fullscreen overlay down when navigating to a normal page (the
		// router's navigate does not always fire hashchange).
		this._syncBoardFullscreenToRoute();
		// Same for the board's card tooltips, which anchor to cards this navigation is about to paint
		// over. Decided from pKey rather than the URL: the router runs its route handler BEFORE it
		// updates the browser URL, so the hash still reads the board here. Opening a card is exactly
		// that path -- one click both pins a tooltip and routes to the detail view -- and a pinned
		// tooltip ignores the pointer, so it would otherwise ride along to the next page.
		if (pKey !== 'Board') { this._teardownBoardTooltips(); }
		// Same leak, same fix, for the Work Item hover tooltips Releases anchors to its "WI-080" links
		// (WI #452): once another view paints over the workspace those anchors are gone for good.
		if (pKey !== 'Releases') { this._teardownReleasesTooltips(); }
		// Reflect the current URL in the docked site nav (highlights the active item).
		this._syncSiteNav();
	}

	// Take the board's card tooltips down. They anchor to card elements, so once another view owns the
	// workspace the anchor is detached and can no longer fire the mouseleave that would have hidden the
	// tooltip: it stays up, floating over whatever page came next, naming a record that page does not
	// even list. Destroying the handle also stops them accumulating across board visits.
	_teardownBoardTooltips()
	{
		let tmpBoard = this.pict.views['Plansheet-Board'];
		if (tmpBoard && typeof tmpBoard.teardown === 'function') { tmpBoard.teardown(); }
	}

	// Take Releases' own Work Item tooltips down on the way to another page, mirroring _teardownBoardTooltips.
	_teardownReleasesTooltips()
	{
		let tmpReleases = this.pict.views['Plansheet-Releases'];
		if (tmpReleases && typeof tmpReleases.teardown === 'function') { tmpReleases.teardown(); }
	}

	// The URL-driven net, for the routes that set no active nav (the blueprint, media and doc views).
	// By the time hashchange fires the URL is settled, so here the hash is the honest answer.
	_syncBoardTooltipsToRoute()
	{
		if (typeof window === 'undefined' || !window.location) { return; }
		// Compare the path only: the board carries its focus filter as a hash query (#/board?assignee=me),
		// and that is still the board. '' and '/' both mean the board too.
		let tmpRoute = (window.location.hash || '').replace(/^#/, '').split('?')[0];
		if (tmpRoute === '' || tmpRoute === '/' || tmpRoute === '/board') { return; }
		this._teardownBoardTooltips();
	}

	// Whether the signed-in user has an entitlement (platform admins have everything; a falsy ent is
	// always allowed). Drives which admin items appear in the site map.
	_can(pEnt)
	{
		if (!pEnt) { return true; }
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		if (tmpUser.IsPlatformAdmin === 1 || tmpUser.IsPlatformAdmin === true) { return true; }
		let tmpEnts = Array.isArray(tmpUser.Entitlements) ? tmpUser.Entitlements : [];
		return tmpEnts.indexOf(pEnt) >= 0;
	}

	// The nav entries the plan sheet owner hid from the sidebar, resolved onto the session at boot (set
	// from Org Settings). buildSiteMap drops these from the sidebar, the settings rail, and the launcher.
	_hiddenNavItems()
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		return Array.isArray(tmpUser.HiddenNavItems) ? tmpUser.HiddenNavItems : null;
	}

	// Build + install the site-map graph, render the docked main sidebar (the non-settings groups),
	// and arm the cmd+K launcher. Called once the workspace is shown (entitlements known).
	_installSiteNav()
	{
		let tmpNav = this.pict.providers['Pict-Navigation'];
		if (!tmpNav) { return; }
		let tmpLex = (this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.Lexicon) || null;
		tmpNav.setNavigationGraph(libSiteMap.buildSiteMap((pEnt) => this._can(pEnt), tmpLex, this._hiddenNavItems()));
		if (typeof tmpNav.bindLauncherHotkey === 'function') { tmpNav.bindLauncherHotkey(); }
		this._installHelpHotkey();
		this._renderRail();
		this._installMobileMenu();
		this._installBrandMarkLink();
		this._applyHouseStickerSet();
		this.applyNavVisibility();
	}

	// ── Contextual help drawer ─────────────────────────────────────────────────────────────────────
	// F1 and the top-bar "?" toggle the shell's hidden right "help" panel, which shows help for the
	// current screen. Document/window-level listeners only -- the allowed exception, the same pattern
	// the cmd+K launcher uses (Pict-Provider-Navigation bindLauncherHotkey) -- never element handlers.
	_installHelpHotkey()
	{
		if (this._HelpHotkeyBound || typeof document === 'undefined') { return; }
		let tmpSelf = this;
		document.addEventListener('keydown', (pEvent) =>
		{
			if (pEvent.key === 'F1') { pEvent.preventDefault(); tmpSelf.toggleHelpDrawer(); }
			else if (pEvent.key === 'Escape' && tmpSelf._isHelpDrawerOpen()) { tmpSelf.closeHelpDrawer(); }
			else if ((pEvent.metaKey || pEvent.ctrlKey) && !pEvent.shiftKey && !pEvent.altKey && (pEvent.key === '\\' || ((pEvent.key === 'b' || pEvent.key === 'B') && !tmpSelf._isEditableTarget(pEvent.target))))
			{
				// Cmd/Ctrl+B (VS Code) and Cmd/Ctrl+\\ (Notion) show/hide the sidebar. B yields to a focused
				// editor so it stays Bold while typing; backslash never conflicts, so it always toggles.
				pEvent.preventDefault();
				tmpSelf._toggleSidebar();
			}
		}, true);
		// Keep an already-open drawer in sync as the user navigates (the panel only re-renders its view
		// on expand, not on route change); hashchange fires after the hash has updated.
		if (typeof window !== 'undefined')
		{
			window.addEventListener('hashchange', () =>
			{
				tmpSelf.recordCurrentView();
				// Leaving the board-fullscreen route (Close, Escape, or any nav) takes the overlay down.
				tmpSelf._syncBoardFullscreenToRoute();
				// Leaving the board takes its card tooltips down, so none is left floating over the next page.
				tmpSelf._syncBoardTooltipsToRoute();
				if (!tmpSelf._isHelpDrawerOpen()) { return; }
				let tmpView = tmpSelf.pict.views['Plansheet-HelpDrawer'];
				if (tmpView && typeof tmpView.refreshForRoute === 'function') { tmpView.refreshForRoute(); }
			});
		}
		this._HelpHotkeyBound = true;
	}

	// Record a visit to the current route in the notebook history. The label is the current
	// document title (same source bookmarks use), so history reads as real page names. Detail
	// pages set their specific title only after the record loads, so this is called both on
	// navigation (the hashchange handler above) and again by PictView-EntityDetail once the
	// record is in hand; the NotebookAPI provider collapses the two into one relabeled row.
	recordCurrentView()
	{
		if (typeof window === 'undefined') { return; }
		let tmpProvider = this.pict.providers.NotebookAPI;
		if (!tmpProvider || typeof tmpProvider.recordView !== 'function') { return; }
		let tmpRoute = (window.location && window.location.hash) ? window.location.hash.replace(/^#/, '') : '';
		let tmpLabel = this._pageLabelFromTitle((typeof document !== 'undefined' && document.title) ? document.title : '');
		tmpProvider.recordView({ Route: tmpRoute, Label: tmpLabel });
	}

	// A clean notebook label from the document title. The router appends the site suffix (its
	// TitleSuffix, " - Plansheet") so the browser tab reads "Board - Plansheet", but History, Trending
	// and pinned Bookmarks read better as the bare page name ("Board"). Strip one trailing suffix if
	// present; a titleless route (whose title is the bare DefaultTitle) has no suffix and passes through
	// unchanged. (Work Item #234 -- the suffix was making every history row read "... - Plansheet".)
	_pageLabelFromTitle(pTitle)
	{
		let tmpLabel = String(pTitle || '');
		let tmpRouter = this._router();
		let tmpSuffix = (tmpRouter && tmpRouter.options && tmpRouter.options.TitleSuffix) ? tmpRouter.options.TitleSuffix : '';
		if (tmpSuffix && tmpLabel.length > tmpSuffix.length && tmpLabel.slice(-tmpSuffix.length) === tmpSuffix)
		{
			tmpLabel = tmpLabel.slice(0, tmpLabel.length - tmpSuffix.length);
		}
		return tmpLabel;
	}

	// Set document.title to a page's own name once it is known (often only after an async load),
	// then re-record the notebook history for the current route so it reads distinctly. Same move
	// PictView-EntityDetail makes for entity pages; render methods whose title depends on loaded data
	// (or a route with no static title) call this so History/Trending never fall back to "Plansheet".
	_setPageTitle(pTitle)
	{
		let tmpRouter = this._router();
		if (tmpRouter && typeof tmpRouter.setDocumentTitle === 'function') { tmpRouter.setDocumentTitle(String(pTitle || '')); }
		this.recordCurrentView();
	}

	// A readable page name from a Docs Lake path: the last segment, extension stripped, separators
	// spaced, word-cased (e.g. "reference/pict/section-form.md" -> "Section Form").
	_docTitleFromPath(pPath)
	{
		let tmpBase = String(pPath || '').split('::')[0].split('#')[0].replace(/\/+$/, '');
		let tmpLast = tmpBase.slice(tmpBase.lastIndexOf('/') + 1).replace(/\.md$/i, '').replace(/[-_]+/g, ' ').trim();
		if (!tmpLast) { return 'Docs'; }
		return tmpLast.split(' ').map((pWord) => pWord ? (pWord.charAt(0).toUpperCase() + pWord.slice(1)) : pWord).join(' ');
	}

	// A readable title for a settings section slug; a few awkward slugs get a friendly label, the
	// rest are word-cased. Suffixed " Settings" so the History row says which screen it was.
	_settingsTitle(pSection)
	{
		let tmpSlug = String(pSection || 'profile').split('/')[0];
		let tmpOverrides = { docsync: 'Doc Sync', draftingkit: 'Drafting Kits', tokens: 'API Tokens', org: 'Organization', lanes: 'Workflow Lanes' };
		let tmpLabel = tmpOverrides[tmpSlug] || (tmpSlug.charAt(0).toUpperCase() + tmpSlug.slice(1));
		return tmpLabel + ' Settings';
	}

	_helpPanel()
	{
		let tmpShellView = this.pict.views['Plansheet-Shell'];
		let tmpShell = tmpShellView ? tmpShellView._shell : null;
		return (tmpShell && typeof tmpShell.getPanel === 'function') ? tmpShell.getPanel('help') : null;
	}

	_isHelpDrawerOpen() { let tmpPanel = this._helpPanel(); return !!(tmpPanel && tmpPanel.Collapsed === false); }
	openHelpDrawer()    { let tmpPanel = this._helpPanel(); if (tmpPanel) { tmpPanel.expand(); } }
	closeHelpDrawer()   { let tmpPanel = this._helpPanel(); if (tmpPanel) { tmpPanel.collapse(); } }
	toggleHelpDrawer()  { let tmpPanel = this._helpPanel(); if (tmpPanel) { tmpPanel.toggle(); } }

	_notebookPanel()
	{
		let tmpShellView = this.pict.views['Plansheet-Shell'];
		let tmpShell = tmpShellView ? tmpShellView._shell : null;
		return (tmpShell && typeof tmpShell.getPanel === 'function') ? tmpShell.getPanel('notebook') : null;
	}

	_refreshNotebook() { let tmpView = this.pict.views['Plansheet-Notebook']; if (tmpView && typeof tmpView.refresh === 'function') { tmpView.refresh(); } }
	// The notebook is a mode of the shared rail now, not its own panel. Keep these method names so the
	// notebook's own close button and any other callers keep working; they drive the rail's mode.
	_railView() { return this.pict.views['Plansheet-Rail']; }
	_railMode() { let tmpRoot = (typeof document !== 'undefined') && document.getElementById('Plansheet-Rail-Root'); return (tmpRoot && tmpRoot.getAttribute('data-rail-mode')) || 'nav'; }
	_isNotebookOpen() { let tmpMode = this._railMode(); return tmpMode === 'notebook' || tmpMode === 'split'; }
	openNotebookDrawer()  { let tmpRail = this._railView(); if (tmpRail) { tmpRail.setMode('notebook'); this._refreshNotebook(); } }
	closeNotebookDrawer() { let tmpRail = this._railView(); if (tmpRail) { tmpRail.setMode('nav'); } }
	toggleNotebookDrawer() { let tmpRail = this._railView(); if (tmpRail) { tmpRail.setMode(this._isNotebookOpen() ? 'nav' : 'notebook'); this._refreshNotebook(); } }
	// The rail-view toggle: cycle the left rail's view (navigation / notebook / split). It does ONLY this.
	// Showing/hiding the whole sidebar is a separate control (toggleSidebar / Cmd+B); while the sidebar is
	// hidden there is nothing to cycle, so the button is disabled and this is a no-op guard for safety.
	cycleRail()
	{
		if (this.isNavHidden()) { return; }
		let tmpRail = this._railView();
		if (tmpRail) { tmpRail.cycle(); }
	}

	// The sidebar show/hide toggle (the top-bar button + Cmd+B / Cmd+\\ share this). One job: flip the
	// left rail's visibility. Icons and the rail-view button's enabled state resync via applyNavVisibility.
	toggleSidebar() { this._toggleSidebar(); }

	// Mount the notebook view into the rail's notebook pane the first time it becomes visible (lazy, so a
	// boot in nav mode does not pay for it). Idempotent.
	_ensureNotebookMounted()
	{
		if (this._notebookMounted) { return; }
		let tmpView = this.pict.views['Plansheet-Notebook'];
		if (!tmpView) { return; }
		this._notebookMounted = true;
		tmpView.render();
		if (typeof tmpView.refresh === 'function') { tmpView.refresh(); }
	}

	// Reflect the current rail mode on the top-bar toggle (icon + tooltip swap per mode).
	_updateRailToggle(pMode)
	{
		if (typeof document === 'undefined') { return; }
		let tmpBtn = document.getElementById('Plansheet-RailToggle');
		if (!tmpBtn) { return; }
		let tmpOpen = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">';
		let tmpIcons =
		{
			nav: tmpOpen + '<rect x="3" y="4" width="18" height="16" rx="2"></rect><line x1="9" y1="4" x2="9" y2="20"></line></svg>',
			notebook: tmpOpen + '<path d="M5 4h11a1 1 0 0 1 1 1v16H7a2 2 0 0 1-2-2z"></path><line x1="9" y1="4" x2="9" y2="21"></line></svg>',
			split: tmpOpen + '<rect x="3" y="4" width="18" height="16" rx="2"></rect><line x1="3" y1="12" x2="21" y2="12"></line></svg>'
		};
		let tmpTitles = { nav: 'Sidebar view: navigation', notebook: 'Sidebar view: notebook', split: 'Sidebar view: split' };
		tmpBtn.innerHTML = tmpIcons[pMode] || tmpIcons.nav;
		tmpBtn.setAttribute('title', (tmpTitles[pMode] || 'Sidebar view') + ' -- click to cycle');
		// Keep the companion show/hide button (and this button's disabled state) in step.
		this._updateSidebarToggle();
	}

	// Reflect sidebar visibility on the top-bar show/hide button, and disable the rail-view toggle while the
	// sidebar is hidden (there is no visible view to cycle). Called on boot, on every rail-view change, and
	// whenever visibility flips (applyNavVisibility), so the button icons match the Cmd+B keyboard path too.
	_updateSidebarToggle()
	{
		if (typeof document === 'undefined') { return; }
		let tmpHidden = this.isNavHidden();
		let tmpToggle = document.getElementById('Plansheet-SidebarToggle');
		if (tmpToggle)
		{
			let tmpOpen = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"></rect><line x1="9" y1="4" x2="9" y2="20"></line>';
			// A chevron pointing INTO the pane (hide) when shown, OUT of it (show) when hidden.
			tmpToggle.innerHTML = tmpOpen + (tmpHidden ? '<path d="M13 9l2.5 3-2.5 3"></path>' : '<path d="M15.5 9l-2.5 3 2.5 3"></path>') + '</svg>';
			tmpToggle.setAttribute('title', (tmpHidden ? 'Show sidebar' : 'Hide sidebar') + ' (Cmd+B)');
		}
		let tmpRailBtn = document.getElementById('Plansheet-RailToggle');
		if (tmpRailBtn)
		{
			tmpRailBtn.disabled = tmpHidden;
			tmpRailBtn.setAttribute('aria-disabled', tmpHidden ? 'true' : 'false');
		}
	}

	// Show/hide the whole left rail (the Cmd+B / Cmd+\\ shortcuts + the Appearance toggle share this). Uses
	// the same ps-nav-off mechanism as the Appearance "Hide the left navigation" setting, so the keyboard
	// toggle and the setting stay in step. The launcher (Cmd+K) still reaches everything while it is hidden.
	_toggleSidebar() { this.setNavHidden(!this.isNavHidden()); }

	// Is focus in a text editor or field? Cmd+B must yield to it so it stays Bold while the user types.
	_isEditableTarget(pEl)
	{
		if (!pEl) { return false; }
		let tmpTag = (pEl.tagName || '').toUpperCase();
		if (tmpTag === 'INPUT' || tmpTag === 'TEXTAREA' || tmpTag === 'SELECT') { return true; }
		if (pEl.isContentEditable) { return true; }
		if (typeof pEl.closest === 'function' && pEl.closest('[contenteditable="true"], .ProseMirror, .cm-editor')) { return true; }
		return false;
	}

	// The 9-square top-bar launcher opens the cmd+K command palette (the same overlay the hotkey toggles).
	openCommandLauncher()
	{
		let tmpNav = this.pict.providers['Pict-Navigation'];
		if (tmpNav && typeof tmpNav.toggleLauncher === 'function') { tmpNav.toggleLauncher(); }
	}

	// Left-nav visibility is a local (this-device) preference: a keyboard-first user can hide the docked
	// sidebar and lean on the launcher. Stored in localStorage, applied as a class on <html> the shell CSS
	// reads. The Appearance setting toggles it; applyNavVisibility re-applies it on boot.
	isNavHidden()
	{
		try { return (typeof localStorage !== 'undefined') && localStorage.getItem('plansheet.nav.hidden') === '1'; }
		catch (pError) { return false; }
	}
	applyNavVisibility()
	{
		if (typeof document === 'undefined' || !document.documentElement) { return; }
		if (this.isNavHidden()) { document.documentElement.classList.add('ps-nav-off'); }
		else { document.documentElement.classList.remove('ps-nav-off'); }
		// Keep the top-bar show/hide button icon and the rail-view button's disabled state in step, so the
		// Cmd+B / Cmd+\\ keyboard path updates the buttons the same as clicking them.
		this._updateSidebarToggle();
	}
	setNavHidden(pHidden)
	{
		try { if (pHidden) { localStorage.setItem('plansheet.nav.hidden', '1'); } else { localStorage.removeItem('plansheet.nav.hidden'); } }
		catch (pError) { /* ignore */ }
		this.applyNavVisibility();
	}

	// Point the whiteboard sticker source at the org house-kit's set (surfaced on the session at boot, so
	// any signed-in user can read it without the platform.manage kit endpoint). Vision boards resolve their
	// set per-vision via the lexicon; profiles keep the expressive moodboard set until a brand set is set.
	_applyHouseStickerSet()
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || null;
		if (!tmpUser || !this._StickerSources) { return; }
		// A custom set ('custom:<id>') ships its resolved items on the session; a system key the source
		// resolves from the in-bundle registry. The house set feeds whiteboards, the org brand set feeds
		// profile moodboards. Each falls back to its source's context default when nothing is set.
		let fApply = (pSource, pKey, pItems) =>
		{
			if (!pSource || typeof pSource.setActiveSet !== 'function') { return; }
			let tmpHasItems = Array.isArray(pItems) && pItems.length;
			if (!pKey && !tmpHasItems) { return; }
			pSource.setActiveSet(tmpHasItems ? pItems : pKey);
		};
		fApply(this._StickerSources.whiteboard, tmpUser.StickerSet || '', tmpUser.StickerSetItems);
		fApply(this._StickerSources.profile, tmpUser.ProfileStickerSet || '', tmpUser.ProfileStickerSetItems);
	}

	// Render the shared left rail skeleton into #Plansheet-Sidebar, then mount the nav into its nav pane
	// and apply the saved mode (which lazily mounts the notebook the first time it becomes visible). Order
	// matters: the rail skeleton must exist before the nav renders into #Plansheet-RailNav.
	_renderRail()
	{
		let tmpRail = this.pict.views['Plansheet-Rail'];
		if (!tmpRail) { return; }
		tmpRail.render();
		// The sidebar is now one tabbed panel (the Notebook); Navigation is a tab inside it, so there is no
		// separate nav pane to fill and no nav/notebook/split mode to pick. Force the panel on and mount it;
		// the Notebook's default tab renders the docked site nav into its own Navigation host.
		tmpRail.setMode('notebook');
		// Point the Foundational Docs tree at the sidebar's Documentation host up front, so even the reader's
		// first init renders the tree there (not the now-hidden reader nav column).
		this._retargetDocsNav('#PS-Notebook-Documentation');
	}

	_renderSiteNav() { this.renderSiteNavInto('#Plansheet-RailNav'); }

	// Render the docked site-map navigation into a container. Default host is the rail's nav pane; the
	// Notebook's Navigation tab passes its own host (#PS-Notebook-Navigation) so the primary nav can live
	// as a sidebar tab. Scoped to the main groups plus Settings, so settings turn up in the sidebar search.
	renderSiteNavInto(pContainer)
	{
		let tmpNav = this.pict.providers['Pict-Navigation'];
		if (!tmpNav || typeof tmpNav.renderSidebarDocked !== 'function') { return; }
		if (typeof document !== 'undefined' && !document.querySelector(pContainer)) { return; }
		tmpNav.renderSidebarDocked(pContainer);
		this._SiteNavView = tmpNav.render('Sidebar-Docked', pContainer, { Scope: libSiteMap.DOCKED_GROUP_HASHES });
		this._syncSiteNav();
	}

	// ─── Foundational Docs tree in the sidebar's Documentation tab ───────
	// The inline-doc module ships the tree (InlineDoc-Nav) and the article (InlineDoc-Content) as two
	// views glued by a Layout. We leave the reader (FoundationDocs) owning the provider init + the article
	// pane, but re-point the Nav view to render into the sidebar's Documentation host instead of the
	// reader's nav column (which we hide), so the ToC lives in the sidebar and the reader is article-only.
	renderDocsTreeInto(pContainer)
	{
		this._retargetDocsNav(pContainer);
		// Opening the Documentation tab just SHOWS the tree -- it never changes the page. Ensure the
		// inline-doc provider is set up (which loads the sidebar tree, once), then render the tree into the
		// freshly repainted sidebar host. A tree-node click is what navigates to /docs/<path>.
		let tmpFdocs = this.pict.views['Plansheet-FoundationDocs'];
		if (!tmpFdocs || typeof tmpFdocs.ensureDocsProviderInited !== 'function') { return; }
		tmpFdocs.ensureDocsProviderInited().then(() =>
		{
			let tmpNav = this.pict.views['InlineDoc-Nav'];
			if (tmpNav && typeof tmpNav.render === 'function') { tmpNav.render(); }
		});
	}

	// Point the inline-doc Nav view at a container (the sidebar Documentation host). Safe to call repeatedly.
	_retargetDocsNav(pContainer)
	{
		let tmpNav = this.pict.views['InlineDoc-Nav'];
		if (!tmpNav || !tmpNav.options) { return; }
		if (Array.isArray(tmpNav.options.Renderables))
		{
			for (let i = 0; i < tmpNav.options.Renderables.length; i++) { tmpNav.options.Renderables[i].ContentDestinationAddress = pContainer; }
		}
		tmpNav.options.DefaultDestinationAddress = pContainer;
	}

	_onDocsRoute()
	{
		let tmpHash = (typeof window !== 'undefined' && window.location) ? (window.location.hash || '') : '';
		return /^#\/docs(\/|$)/.test(tmpHash);
	}

	_syncSiteNav()
	{
		let tmpNav = this.pict.providers['Pict-Navigation'];
		if (!tmpNav || typeof document === 'undefined') { return; }
		// Defer a tick: _setActiveNav runs inside the route handler, which can fire before the router has
		// finished writing window.location.hash, so reading it now can pick up the previous route.
		let tmpSelf = this;
		setTimeout(function ()
		{
			let tmpHash = (window.location && window.location.hash) ? window.location.hash : '';
			if (tmpHash && typeof tmpNav.setActiveByRoute === 'function') { tmpNav.setActiveByRoute(tmpHash); }
			if (tmpSelf._SiteNavView && typeof tmpSelf._SiteNavView.syncActive === 'function') { tmpSelf._SiteNavView.syncActive(); }
		}, 30);
	}

	// Route a site-nav item click. Main items go straight to their Route; a settings sub-section item
	// opens the settings page and switches to that section (settings is one route with in-page state).
	_onSiteNavigate(pNode)
	{
		if (!pNode || !pNode.Route) { return; }
		// Every item -- settings included -- routes straight to its hash now. Settings sections are
		// real #/settings/<section> routes that render full-width, so there is no special-case here.
		this._navigate(String(pNode.Route).replace(/^#/, ''));
	}

	// ── Mobile menu (the top-bar burger) ─────────────────────────────────────
	// Below 900px pict-section-theme collapses the bar into a burger. Its stock popup just clones the
	// top-bar slots, which on plansheet is only the account chip (the real nav lives in the docked
	// sidebar, hidden at this width) and the chip's anchored popover cannot open inside that modal.
	// Replace the burger with a real mobile menu: the full site-map navigation plus the account
	// actions (switch or create a plan sheet, sign out). Installed on the Theme-TopBar instance.
	_installMobileMenu()
	{
		let tmpSelf = this;
		let tmpTries = 0;
		let fInstall = function ()
		{
			let tmpTopBar = tmpSelf.pict.views['Theme-TopBar'];
			if (tmpTopBar)
			{
				tmpTopBar.openBurgerMenu = function () { return tmpSelf.openMobileMenu(); };
				return;
			}
			// The modal shell mounts the Theme-TopBar view a tick after the workspace first shows, so it
			// may not exist yet when this runs (the override would silently no-op). Retry briefly until
			// it does, then stop.
			if (tmpTries++ < 40 && typeof setTimeout === 'function') { setTimeout(fInstall, 50); }
		};
		fInstall();
	}

	// The "Plansheet" wordmark in the top bar (pict-section-theme's brand mark) renders as a plain
	// span with no link of its own. Open the marketing site in a new tab when it's clicked, the same
	// way _installMobileMenu waits for Theme-TopBar to mount before reaching into its DOM.
	_installBrandMarkLink()
	{
		let tmpSelf = this;
		let tmpTries = 0;
		let fInstall = function ()
		{
			let tmpMark = (typeof document !== 'undefined') ? document.getElementById('Theme-Brand-Mark') : null;
			if (tmpMark)
			{
				// _installSiteNav can run again in the same page load (sign-out then sign-in); guard
				// against binding a second click listener onto the same DOM node.
				if (tmpMark.dataset.brandLinkBound !== 'true')
				{
					// The brand mark is "home": it goes to the cross-tenant "Your plan sheets" screen (WI #339),
					// not the marketing site. Someone validating the app reaches for the logo to get back there.
					tmpMark.title = 'Your plan sheets';
					tmpMark.style.cursor = 'pointer';
					tmpMark.addEventListener('click', function ()
					{
						if (typeof tmpSelf._navigate === 'function') { tmpSelf._navigate('/home'); return; }
						if (typeof window !== 'undefined' && window.location) { window.location.hash = '#/home'; }
					});
					tmpMark.dataset.brandLinkBound = 'true';
				}
				return;
			}
			if (tmpTries++ < 40 && typeof setTimeout === 'function') { setTimeout(fInstall, 50); }
		};
		fInstall();
	}

	openMobileMenu()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let fEscape = (pValue) => String(pValue == null ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
		let tmpLex = (this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.Lexicon) || null;
		let tmpMap = libSiteMap.buildSiteMap((pEnt) => this._can(pEnt), tmpLex, this._hiddenNavItems());
		// The docked-sidebar groups, plus the personal You group (My Profile, Settings).
		let tmpGroups = tmpMap.filter((pGroup) => libSiteMap.MAIN_GROUP_HASHES.indexOf(pGroup.Hash) >= 0 || pGroup.Hash === 'you');
		let tmpNavHTML = tmpGroups.map((pGroup) =>
			'<div class="cst-mnav-group"><div class="cst-mnav-group-h">' + fEscape(pGroup.Name) + '</div>' +
			(pGroup.Children || []).map((pItem) =>
				'<button class="cst-mnav-item" onclick="_Pict.PictApplication.mobileMenuGo(\'' + fEscape(pItem.Route) + '\')">' + fEscape(pItem.Name) + '</button>').join('') +
			'</div>').join('');
		// Account section. The invitations list and plan-sheet switcher are filled asynchronously by the
		// TopBar-User view, which targets these ids by getElementById; the desktop popover is not open at
		// this width, so there is no id collision.
		let tmpAcctHTML =
			'<div class="cst-mnav-group">' +
				'<div class="cst-mnav-group-h">Plan sheets</div>' +
				'<div class="cst-acct-invites" id="cst-acct-invites" style="display:none"></div>' +
				'<div class="cst-acct-tenant-list" id="cst-acct-tenant-list"><div class="cst-acct-tenant-empty">Loading&hellip;</div></div>' +
				'<button class="cst-acct-new" onclick="_Pict.views[\'Plansheet-TopBar-User\'].createTenant()">+ New plan sheet</button>' +
			'</div>' +
			'<div class="cst-mnav-group">' +
				'<button class="cst-mnav-item cst-mnav-danger" onclick="_Pict.PictApplication.signOut()">Sign out</button>' +
			'</div>';
		tmpModal.show({ title: 'Menu', content: '<div class="cst-mnav">' + tmpNavHTML + tmpAcctHTML + '</div>', closeable: true, buttons: [], width: '320px' });
		let tmpUserView = this.pict.views['Plansheet-TopBar-User'];
		if (tmpUserView && typeof tmpUserView._loadTenants === 'function') { tmpUserView._loadTenants(); }
		if (tmpUserView && typeof tmpUserView._loadInvitations === 'function') { tmpUserView._loadInvitations(); }
	}

	// ── media lightbox ────────────────────────────────────────────────────────
	// An unobtrusive full-screen quick view for a screenshot: the image in a modal
	// with basic zoom (buttons, wheel, double-click) and drag-to-pan. Self-contained,
	// no viewer library; the deep-zoom page (openseadragon) is a separate surface.
	viewImage(pURL, pTitle)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return; }
		this._lightbox = { s: 1, x: 0, y: 0, drag: null };
		let tmpURL = String(pURL || '').replace(/"/g, '&quot;');
		let tmpAlt = String(pTitle || 'Screenshot').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
		let tmpBtn = 'font:inherit;font-size:16px;line-height:1;min-width:36px;height:32px;padding:0 11px;border-radius:7px;border:1px solid rgba(150,180,220,0.35);background:rgba(150,180,220,0.12);color:#eaf2fc;cursor:pointer;';
		let tmpHTML =
			'<div style="position:relative;">'
			+ '<div id="PS-Lightbox-Stage" style="position:relative;width:100%;height:78vh;overflow:hidden;background:#0b1420;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:grab;touch-action:none;">'
			+ '<img id="PS-Lightbox-Img" src="' + tmpURL + '" alt="' + tmpAlt + '" draggable="false" style="max-width:100%;max-height:100%;transform-origin:center center;user-select:none;-webkit-user-drag:none;">'
			+ '</div>'
			+ '<div style="position:absolute;left:50%;bottom:14px;transform:translateX(-50%);display:flex;gap:8px;align-items:center;background:rgba(12,20,32,0.86);border:1px solid rgba(150,180,220,0.3);border-radius:10px;padding:6px 9px;">'
			+ '<button type="button" title="Zoom out" style="' + tmpBtn + '" onclick="_Pict.PictApplication.lightboxZoom(0.8)">&minus;</button>'
			+ '<button type="button" title="Zoom in" style="' + tmpBtn + '" onclick="_Pict.PictApplication.lightboxZoom(1.25)">+</button>'
			+ '<button type="button" title="Reset" style="' + tmpBtn + 'font-size:12px;letter-spacing:0.5px;" onclick="_Pict.PictApplication.lightboxReset()">Reset</button>'
			+ '<a href="#" title="Open the deep-zoom viewer" style="' + tmpBtn + 'font-size:12px;letter-spacing:0.5px;text-decoration:none;display:inline-flex;align-items:center;border-color:rgba(240,196,74,0.6);color:#f0c44a;" onclick="event.preventDefault();_Pict.PictApplication.openMediaViewer(\'' + tmpURL + '\')">Open viewer</a>'
			+ '</div>'
			+ '</div>';
		tmpModal.show({ title: pTitle || 'Screenshot', content: tmpHTML, closeable: true, buttons: [], width: 'min(1200px, 94vw)' });
		let tmpSelf = this;
		setTimeout(function () { tmpSelf._lightboxInit(); }, 30);
	}

	_lightboxApply()
	{
		let tmpImg = (typeof document !== 'undefined') ? document.getElementById('PS-Lightbox-Img') : null;
		let tmpLB = this._lightbox;
		if (tmpImg && tmpLB) { tmpImg.style.transform = 'translate(' + tmpLB.x + 'px,' + tmpLB.y + 'px) scale(' + tmpLB.s + ')'; }
	}

	lightboxZoom(pFactor)
	{
		if (!this._lightbox) { return; }
		this._lightbox.s = Math.max(1, Math.min(8, this._lightbox.s * pFactor));
		if (this._lightbox.s === 1) { this._lightbox.x = 0; this._lightbox.y = 0; }
		this._lightboxApply();
	}

	lightboxReset() { if (this._lightbox) { this._lightbox.s = 1; this._lightbox.x = 0; this._lightbox.y = 0; this._lightboxApply(); } }

	_lightboxInit()
	{
		if (typeof document === 'undefined') { return; }
		let tmpStage = document.getElementById('PS-Lightbox-Stage');
		if (!tmpStage) { return; }
		let tmpSelf = this;
		tmpStage.addEventListener('wheel', function (pE) { pE.preventDefault(); tmpSelf.lightboxZoom(pE.deltaY < 0 ? 1.15 : 0.87); }, { passive: false });
		tmpStage.addEventListener('pointerdown', function (pE)
		{
			if (!tmpSelf._lightbox || tmpSelf._lightbox.s <= 1) { return; }
			tmpSelf._lightbox.drag = { sx: pE.clientX, sy: pE.clientY, ox: tmpSelf._lightbox.x, oy: tmpSelf._lightbox.y };
			try { tmpStage.setPointerCapture(pE.pointerId); } catch (pErr) { /* ignore */ }
			tmpStage.style.cursor = 'grabbing';
		});
		tmpStage.addEventListener('pointermove', function (pE)
		{
			let tmpD = tmpSelf._lightbox && tmpSelf._lightbox.drag;
			if (!tmpD) { return; }
			tmpSelf._lightbox.x = tmpD.ox + (pE.clientX - tmpD.sx);
			tmpSelf._lightbox.y = tmpD.oy + (pE.clientY - tmpD.sy);
			tmpSelf._lightboxApply();
		});
		let fEnd = function () { if (tmpSelf._lightbox) { tmpSelf._lightbox.drag = null; } tmpStage.style.cursor = 'grab'; };
		tmpStage.addEventListener('pointerup', fEnd);
		tmpStage.addEventListener('pointercancel', fEnd);
		tmpStage.addEventListener('dblclick', function () { if (tmpSelf._lightbox) { (tmpSelf._lightbox.s > 1) ? tmpSelf.lightboxReset() : tmpSelf.lightboxZoom(2.2); } });
	}

	// ── shared searchable picker ──────────────────────────────────────────────
	// Mount a searchable pict-section-picker into a host element, replacing an oversized
	// <select>. Reusable across surfaces (createPicker + render + OnChange). Returns the view.
	// The dropdown floats over its surroundings; pict-section-picker 1.8.2+ anchors the fixed dropdown
	// correctly even inside a transform-centered modal, so no per-modal .pps-pop override is needed.
	mountPicker(pHostSelector, pHash, pOptions, pOnChange, pOpts)
	{
		pOpts = pOpts || {};
		let tmpProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpProvider || typeof tmpProvider.createPicker !== 'function') { return null; }
		let tmpConfig =
		{
			DestinationAddress: pHostSelector,
			Placeholder: pOpts.Placeholder || 'Search...',
			Searchable: true,
			Options: pOptions || [],
			OnChange: (pVal) => { if (typeof pOnChange === 'function') { pOnChange(pVal); } }
		};
		// Server-backed search (WI #445): a caller with a candidate set bigger than one page passes
		// DataProvider/ResolveValue (see CandidateSearch.js) instead of a precomputed Options array.
		if (typeof pOpts.DataProvider === 'function') { tmpConfig.DataProvider = pOpts.DataProvider; }
		if (typeof pOpts.ResolveValue === 'function') { tmpConfig.ResolveValue = pOpts.ResolveValue; }
		// A nullable field (an fk, or a work item's target) needs a way back to "nothing chosen" -- the
		// widget's own pinned clear row (WI #446), not an Options-array "— none —" entry the DataProvider
		// path has no equivalent of.
		if (pOpts.AllowClear) { tmpConfig.AllowClear = true; tmpConfig.ClearLabel = pOpts.ClearLabel || 'Any'; }
		tmpProvider.createPicker(pHash, tmpConfig);
		// createPicker builds the view; render() paints it into the host.
		let tmpView = this.pict.views[pHash];
		if (tmpView) { tmpView.setValue(pOpts.Value || ''); tmpView.render(); }
		this._raisePickerAboveAncestors(pHostSelector);
		return tmpView;
	}

	// The picker's popup (.pps-pop) ships a fixed z-index of 40 -- fine as long as it is painted
	// inside a stacking context that itself out-ranks the rest of the page (a modal dialog, whose
	// own z-index is in the 1000s, is exactly that today). That is an assumption about DOM nesting,
	// not a guarantee: WI #355 ("the list of users to assign to is behind the modal in z-order")
	// is exactly what happens the moment that assumption stops holding, and nothing in the picker
	// or the modal enforces it. Belt-and-suspenders: after mounting, walk the host's ancestors for
	// the highest explicit z-index actually in play and pin the popup (and its click-outside
	// backdrop) comfortably above it, so a picker mounted inside a modal can never lose the z-order
	// race no matter how the surrounding markup changes.
	_raisePickerAboveAncestors(pHostSelector)
	{
		if (typeof document === 'undefined') { return; }
		let tmpHost = document.querySelector(pHostSelector);
		if (!tmpHost) { return; }
		let tmpMaxZ = 0;
		for (let tmpNode = tmpHost.parentElement; tmpNode; tmpNode = tmpNode.parentElement)
		{
			let tmpZ = parseInt(window.getComputedStyle(tmpNode).zIndex, 10);
			if (!isNaN(tmpZ) && tmpZ > tmpMaxZ) { tmpMaxZ = tmpZ; }
		}
		if (tmpMaxZ < 40) { return; }
		let tmpAbove = String(tmpMaxZ + 10);
		let tmpPop = tmpHost.querySelector('.pps-pop');
		let tmpBackdrop = tmpHost.querySelector('.pps-backdrop');
		if (tmpPop) { tmpPop.style.zIndex = tmpAbove; }
		if (tmpBackdrop) { tmpBackdrop.style.zIndex = tmpAbove; }
	}

	// A mobile-menu nav row: close the menu, then route through the normal site-nav handler.
	mobileMenuGo(pRoute)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.dismissModals === 'function') { tmpModal.dismissModals(); }
		this._onSiteNavigate({ Route: pRoute });
	}

	// ── route handlers — render the workspace for the current URL ────────────

	// True if the browser's current hash route is one of pRoutes. Async route handlers call this right
	// before they paint into #Plansheet-Workspace so a slow data load that resolves after the URL has
	// already moved on does not clobber the newer view. The live hash is the single source of truth.
	_routeIsActive(pRoutes)
	{
		if (typeof window === 'undefined' || !window.location) { return true; }
		let tmpHash = window.location.hash ? window.location.hash.replace(/^#/, '') : '';
		let tmpList = Array.isArray(pRoutes) ? pRoutes : [pRoutes];
		return tmpList.indexOf(tmpHash) >= 0;
	}

	// The board's data load is async, so guard the paint: if the URL has moved to another route by the
	// time the list resolves, do not render the board over it. This is what keeps a deep-link / hard
	// reload to a custom route (#/issues, #/checklists, ...) deterministic -- the board can no longer win
	// a boot race against the routed view. '' and '/' both mean the board.
	_renderBoard()
	{
		this._setActiveNav('Board');
		let tmpBoard = this.pict.views['Plansheet-Board'];
		// Seed the focus-view filter from the URL (a shared / reloaded #/board?... link) and load
		// the roster (for the human/AI assignee facet) alongside the board fetch, then narrow.
		tmpBoard.prepareFilter();
		Promise.all([this.pict.providers.BoardAPI.list(), tmpBoard.loadRoster()]).then(() =>
		{
			if (!this._routeIsActive(['', '/', '/board'])) { return; }
			tmpBoard.applyFilter();
			tmpBoard.render();
		});
	}
	_renderList(pKey) { this._setActiveNav(pKey); this.pict.views['Plansheet-EntityList'].showEntity(pKey); }
	// The create and edit forms, entered from their own routes. showEntity already knows how to land on
	// a form as its final render (it does it for the prefill handoff), so these pass that intent in
	// rather than opening the list and then racing it with a second call.
	_renderListNew(pKey) { this._setActiveNav(pKey); this.pict.views['Plansheet-EntityList'].showEntity(pKey, { New: true }); }
	_renderListEdit(pKey, pID) { this._setActiveNav(pKey); this.pict.views['Plansheet-EntityList'].showEntity(pKey, { EditID: pID }); }
	_renderDetail(pKey, pID) { this._setActiveNav(pKey); this.pict.views['Plansheet-EntityDetail'].showDetail(pKey, pID); }
	_renderTestRun(pID) { this._setActiveNav('TestRun'); this.pict.views['Plansheet-TestRunner'].showRun(pID); }
	// The Node workspace (WI #465). Two-step mount: the view paints #NodeWorkspace-Container into the shell (and
	// its onAfterRender calls the provider's renderWorkspace), then the provider loads/creates and fills it.
	_renderNodeWorkspace(pID) { this._setActiveNav('NodeRegistration'); this.pict.views['NodeWorkspace'].render(); this.pict.providers['NodeWorkspace'].loadAsync(pID); }
	_renderNodeCreate() { this._setActiveNav('NodeRegistration'); this.pict.views['NodeWorkspace'].render(); this.pict.providers['NodeWorkspace'].startCreateAsync(null); }
	// The descriptor OpenAction target: a Nodes list row-click routes to the workspace.
	showNodeWorkspace(pID) { this._navigate('/node/' + pID); }
	_renderBlueprint(pID, pEntityKey)
	{
		this._setActiveNav(pEntityKey || 'WorkItem');
		this.pict.views['Plansheet-Blueprint'].show(this.pict.providers.BlueprintAPI.subjectForEntity(pEntityKey || 'WorkItem', pID));
	}
	_renderBlueprintRecord(pID)
	{
		this._setActiveNav('Blueprint');
		this.pict.views['Plansheet-Blueprint'].show(this.pict.providers.BlueprintAPI.subjectForRecord(pID));
	}
	_renderBlueprintComposer(pID) { this.pict.views['Plansheet-BlueprintComposer'].show(pID); }
	_renderBlueprintStudio(pID) { if (typeof this._setPageTitle === 'function') { this._setPageTitle('Design'); } this.pict.views['Plansheet-BlueprintStudio'].open(pID); }
	_renderMediaViewer(pID) { this._setPageTitle('Screenshot'); this.pict.views['Plansheet-MediaViewer'].show(pID); }

	// From the quick-view lightbox: close it and open the full deep-zoom viewer for that image.
	openMediaViewer(pURL)
	{
		let tmpMatch = String(pURL || '').match(/\/Media\/(\d+)\//);
		let tmpID = tmpMatch ? parseInt(tmpMatch[1], 10) : 0;
		if (!tmpID) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.close === 'function') { tmpModal.close(); }
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (tmpRouter) { tmpRouter.navigate('/media/' + tmpID); }
	}

	// Header action on a Blueprint detail: open its composer.
	composeBlueprint(pKey, pID)
	{
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (tmpRouter && pID) { tmpRouter.navigate('/blueprint/' + pID + '/compose'); }
	}

	// Header action on a Deliverable: open its Blueprint composer, creating + attaching a Blueprint the
	// first time (named after the deliverable) so a Solution's bundle is one click from the deliverable.
	composeDeliverableBlueprint(pKey, pID)
	{
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (!pID) { return; }
		const tmpPict = this.pict;
		let fJSON = (pMethod, pURL, pBody) =>
		{
			let tmpMethod = String(pMethod || 'GET').toUpperCase();
			let tmpPromise;
			if (tmpMethod === 'POST') { tmpPromise = libFrameworkClient.postJSON(tmpPict, pURL, pBody); }
			else if (tmpMethod === 'PUT') { tmpPromise = libFrameworkClient.putJSON(tmpPict, pURL, pBody); }
			else if (tmpMethod === 'DELETE') { tmpPromise = libFrameworkClient.delJSON(tmpPict, pURL); }
			else { tmpPromise = libFrameworkClient.getJSON(tmpPict, pURL); }
			return tmpPromise.catch(() => null);
		};
		fJSON('GET', '/1.0/Deliverable/' + pID).then((pDeliverable) =>
		{
			if (pDeliverable && pDeliverable.IDBlueprint) { if (tmpRouter) { tmpRouter.navigate('/blueprint/' + pDeliverable.IDBlueprint + '/compose'); } return; }
			let tmpName = (pDeliverable && pDeliverable.Title) ? (pDeliverable.Title + ' blueprint') : 'Deliverable blueprint';
			fJSON('POST', '/1.0/Blueprint', { Name: tmpName }).then((pBlueprint) =>
			{
				if (!pBlueprint || !pBlueprint.IDBlueprint) { return; }
				fJSON('PUT', '/1.0/Deliverable', { IDDeliverable: pID, IDBlueprint: pBlueprint.IDBlueprint }).then(() =>
				{
					if (tmpRouter) { tmpRouter.navigate('/blueprint/' + pBlueprint.IDBlueprint + '/compose'); }
				});
			});
		});
	}
	_renderDocsOverview() { this._setActiveNav('Docs'); this.pict.views['Plansheet-FoundationDocs'].showOverview(); }
	// Workflow is an administrator-configured platform feature (it lives under the gear, not the main
	// sidebar). Bounce a non-admin who hand-types the URL back to the board.
	_renderWorkflow()
	{
		if (!this._can('users.manage')) { return this._navigate('/board'); }
		this._setActiveNav('Workflow');
		this.pict.views['Plansheet-Workflow'].show();
	}
	// Route handler for /workflow/:tab -- the catalog, designer and board tabs as places of their own.
	// Carries the SAME users.manage gate as /workflow; a route that renders the page without it would
	// be a way around the check rather than a new way to reach the page.
	_renderWorkflowTab(pTab)
	{
		if (!this._can('users.manage')) { return this._navigate('/board'); }
		this._setActiveNav('Workflow');
		this.pict.views['Plansheet-Workflow'].showTabRoute(pTab);
	}
	// Route handler for /workflow/subject/:id -- open that subject in the workflow's subject tab.
	_renderWorkflowSubject(pID)
	{
		if (!this._can('users.manage')) { return this._navigate('/board'); }
		this._setActiveNav('Workflow');
		this.pict.views['Plansheet-Workflow'].showSubjectRoute(Number(pID) || 0);
	}
	// Route handler for /prompts/:tab.
	_renderPromptLibraryTab(pTab) { this._setActiveNav('Prompt Library'); this.pict.views['Plansheet-PromptLibrary'].showTabRoute(pTab); }
	_renderPromptLibrary()
	{
		this._setActiveNav('Prompts');
		this.pict.views['Plansheet-PromptLibrary'].show();
	}
	// Route handler for /prompt/:id -- open that shared prompt in the library's reader (survives reload).
	_renderPrompt(pID)
	{
		this._setActiveNav('Prompts');
		this.pict.views['Plansheet-PromptLibrary'].showSharedPrompt(Number(pID) || 0);
	}
	_renderWhiteboards()
	{
		this._setActiveNav('Whiteboards');
		this.pict.views['Plansheet-Whiteboards'].show();
	}
	// Route handler for /whiteboard/:id -- mount the whiteboards surface and open the one board in its
	// editor. Reaching this by reload / paste opens straight into that board; the list is one click back.
	_renderWhiteboardEditor(pID)
	{
		this._setActiveNav('Whiteboards');
		this.pict.views['Plansheet-Whiteboards'].showBoard(pID);
	}
	_renderChecklists()
	{
		this._setActiveNav('Checklists');
		this.pict.views['Plansheet-Checklists'].show();
	}
	_renderNotesPage()
	{
		this._setActiveNav('Notes');
		this.pict.views['Plansheet-NotesPage'].showList();
	}
	// Route handler for /note/:id -- open that note in the editor pane (survives reload / deep-links).
	_renderNote(pID)
	{
		this._setActiveNav('Notes');
		this.pict.views['Plansheet-NotesPage'].showNote(Number(pID) || 0);
	}
	_renderBookmarksPage()
	{
		this._setActiveNav('Bookmarks');
		this.pict.views['Plansheet-BookmarksPage'].show();
	}
	// The cross-tenant home (WI #339). Renders tenant-less from /Account/Tenants, so it works while
	// signed in regardless of which plan sheet the session is in.
	_renderHome()
	{
		this._setActiveNav('Home');
		this.pict.views['Plansheet-Home'].show();
	}
	_renderGalleryPage()
	{
		this._setActiveNav('Gallery');
		this.pict.views['Plansheet-GalleryPage'].show();
	}
	_renderDrawingsPage()
	{
		this._setActiveNav('Drawings');
		this.pict.views['Plansheet-DrawingsPage'].show();
	}
	// Route handler for /drawing/:id and /drawings/new -- open the Excalidraw editor for that drawing
	// (0 = a new one). Closing / saving navigates back to /drawings (see DrawingsPage.openDrawingRoute).
	_renderDrawingEditor(pID)
	{
		this._setActiveNav('Drawings');
		this.pict.views['Plansheet-DrawingsPage'].openDrawingRoute(Number(pID) || 0);
	}
	_renderOpsConsole() { this._setActiveNav('Ops Console'); this.pict.views['Plansheet-OpsConsole'].show(); }

	_renderReleases() { this._setActiveNav('Releases'); this.pict.views['Plansheet-Releases'].show(); }
	_renderRuns() { this._setActiveNav('Runs'); this.pict.views['Plansheet-Runs'].show(); }
	_renderAsk() { this._setActiveNav('Ask'); this.pict.views['Plansheet-Ask'].showCatalog(); }
	_renderAskTask(pID) { this._setActiveNav('Ask'); this.pict.views['Plansheet-Ask'].showTask(Number(pID) || 0); }
	_renderAskRequest(pID) { this._setActiveNav('Ask'); this.pict.views['Plansheet-Ask'].showRequest(Number(pID) || 0); }
	_renderProjects() { this._setActiveNav('Projects'); this.pict.views['Plansheet-Project'].showList(); }
	_renderProject(pID) { this._setActiveNav('Projects'); this.pict.views['Plansheet-Project'].showDetail(Number(pID) || 0); }
	_renderProjectTypes() { this._setActiveNav('Project Types'); this.pict.views['Plansheet-ProjectTypes'].showList(); }
	_renderProjectType(pID) { this._setActiveNav('Project Types'); this.pict.views['Plansheet-ProjectTypes'].showDetail(Number(pID) || 0); }
	_renderCapabilityActivation() { this._setActiveNav('CapabilityActivation'); this.pict.views['Plansheet-CapabilityActivation'].show(); }
	_renderOrgActivity() { this._setActiveNav('Activity'); this.pict.views['Plansheet-OrgActivity'].show(); }
	_renderSystemActivity(pPeriod) { this._setActiveNav('System Activity'); this.pict.views['Plansheet-SystemActivity'].show(pPeriod); }
	_renderIssues() { this._setActiveNav('Issues'); this.pict.views['Plansheet-IssueBoard'].show(); }
	// Features get a board of their own: work items move at agent speed, features move at product
	// speed, and one surface implied they should move together.
	_renderFeatureBoard() { this._setActiveNav('Feature Board'); this.pict.views['Plansheet-FeatureBoard'].show(); }
	_renderDeliverBoard() { this._setActiveNav('Deliver'); this.pict.views['Plansheet-DeliverableBoard'].show(); }
	_renderCallDesk() { this._setActiveNav('Call Desk'); this.pict.views['Plansheet-CallDesk'].show(); }
	_renderCallDeskCustomer(pID) { this._setActiveNav('Call Desk'); this.pict.views['Plansheet-CallDesk'].showCustomer(pID); }
	_renderStickerSetsPreview() { this._setActiveNav(''); this.pict.views['Plansheet-StickerSetsPreview'].show(); }

	// Build (once) the full-screen overlay that openBoardFullscreen mounts a board into. Styled inline so
	// it does not depend on any view's CSS being injected (it can be opened from a work item detail too).
	// A persistent top bar carries the board name and a high-contrast, always-visible Close button. This is
	// the only exit affordance a presentation board (jumbotron / background) gets: those styles hide the
	// flow's own toolbar, and the flow's in-board fullscreen chrome (.pict-flow-fullscreen) never appears on
	// the host-overlay path. The bar RESERVES space above the canvas (it is a flex row, not a floating
	// overlay), so a background board's full-bleed art can never swallow the exit the way the old translucent
	// corner button was -- leaving Escape as the only way out. The Escape handler stays as a secondary exit.
	_ensureFullscreenOverlay()
	{
		if (this._FullscreenOverlay || typeof document === 'undefined') { return this._FullscreenOverlay; }
		let tmpOverlay = document.createElement('div');
		tmpOverlay.id = 'Whiteboard-Fullscreen-Overlay';
		// z-index ABOVE the flow's own fullscreen (9999) so the close button can never end up underneath a
		// board that entered the flow's fullscreen inside this overlay; the gallery picker (10001) stays on top.
		tmpOverlay.style.cssText = 'position:fixed;inset:0;z-index:10000;background:#0b0f18;display:none;flex-direction:column;';
		// Inline onclick (not addEventListener) so the pointer exit survives any re-mount of the overlay
		// -- a detached listener was a way the overlay got stuck with no way out but a page reload.
		// A presentation board (jumbotron / background) hides its own flow toolbar via pict-section-moodboard's
		// .mb-presentation rules (>=1.2.5 also suppresses the collapsed "expand toolbar" button that used to
		// leak in on hover), so the bar below is the entire overlay chrome -- no host-side toolbar hiding needed.
		tmpOverlay.innerHTML =
			'<div id="Whiteboard-Fullscreen-Bar" style="flex:0 0 auto;position:relative;z-index:3;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 16px;background:#141a26;border-bottom:1px solid rgba(255,255,255,0.10);">' +
				'<span id="Whiteboard-Fullscreen-Title" style="color:#e7ebf3;font-size:15px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">Whiteboard</span>' +
				'<button id="Whiteboard-Fullscreen-Close" title="Close (Esc)" onclick="_Pict.PictApplication.closeBoardFullscreen()" style="flex:0 0 auto;display:inline-flex;align-items:center;gap:7px;border:1px solid rgba(255,255,255,0.22);background:rgba(255,255,255,0.08);color:#dfe4ee;font-size:14px;font-weight:600;line-height:1;padding:8px 15px;border-radius:8px;cursor:pointer;">' +
					'<span style="font-size:16px;line-height:1;opacity:0.85;">&times;</span> Close' +
				'</button>' +
			'</div>' +
			'<div id="Whiteboard-Fullscreen-Canvas" style="flex:1;min-height:0;background:#0b0f18;"></div>';
		document.body.appendChild(tmpOverlay);
		this._FullscreenOverlay = tmpOverlay;
		return tmpOverlay;
	}

	// Show a whiteboard full screen, read-only (its stored display style; a photo board reads full-bleed).
	// Opening the read-only full-screen peek is a NAVIGATION to /whiteboard/:id/fullscreen, so it deep-links
	// and survives a reload. The origin (where it was opened from) is stashed so closing returns there.
	openBoardFullscreen(pID)
	{
		let tmpID = Number(pID) || 0;
		if (!tmpID) { return; }
		this._fullscreenOrigin = (typeof window !== 'undefined' && window.location) ? (window.location.hash || '') : '';
		this.showBoardFullscreen(tmpID);
	}

	// Route handler for /whiteboard/:id/fullscreen -- mount the board into the full-screen overlay.
	_renderBoardFullscreen(pID)
	{
		let tmpAPI = this.pict.providers.MoodboardAPI;
		let tmpID = Number(pID) || 0;
		if (!tmpAPI || !tmpID) { return; }
		this._ensureFullscreenOverlay();
		if (this._FullscreenOverlay) { this._FullscreenOverlay.style.display = 'flex'; }
		if (!this._FullscreenEscHandler)
		{
			this._FullscreenEscHandler = (pEvent) => { if (pEvent.key === 'Escape') { this.closeBoardFullscreen(); } };
			document.addEventListener('keydown', this._FullscreenEscHandler);
		}
		tmpAPI.read(tmpID).then((pRow) =>
		{
			let tmpBoard = tmpAPI.loadBoard(pRow);
			// Name the board in the overlay bar (textContent auto-escapes; the bar is host chrome, not a
			// templated view). Fall back to a generic label when a board has no name.
			let tmpTitleEl = document.getElementById('Whiteboard-Fullscreen-Title');
			if (tmpTitleEl) { tmpTitleEl.textContent = (pRow && pRow.Name) || 'Whiteboard'; }
			let tmpView = this.pict.views['Whiteboard-Fullscreen-View'];
			if (tmpView) { tmpView.render(); tmpView.setBoard(tmpBoard); }
		});
	}

	// The Close button / Escape: leave the fullscreen route back to where it was opened from (the hashchange
	// then hides the overlay via _syncBoardFullscreenToRoute). A cold deep-link has no origin -> /whiteboards.
	closeBoardFullscreen()
	{
		// Take the overlay down immediately (the router's navigate does not always fire hashchange, so we do
		// not rely on _syncBoardFullscreenToRoute here), then return to where it was opened from.
		this._hideBoardFullscreen();
		let tmpOrigin = this._fullscreenOrigin;
		this._fullscreenOrigin = null;
		let tmpRoute = (typeof tmpOrigin === 'string' && tmpOrigin.replace(/^#/, '').charAt(0) === '/') ? tmpOrigin.replace(/^#/, '') : '/whiteboards';
		if (/\/fullscreen\/?$/.test(tmpRoute)) { tmpRoute = '/whiteboards'; } // never return to another fullscreen
		this._navigate(tmpRoute);
	}

	// Hide the overlay + drop its Escape handler (no navigation -- the route has already changed).
	_hideBoardFullscreen()
	{
		if (this._FullscreenOverlay) { this._FullscreenOverlay.style.display = 'none'; }
		if (this._FullscreenEscHandler) { document.removeEventListener('keydown', this._FullscreenEscHandler); this._FullscreenEscHandler = null; }
	}

	// Called on every route change: the fullscreen overlay is a layer over the workspace, not part of it, so
	// leaving the /whiteboard/:id/fullscreen route (Close, Escape, or any nav) must take the overlay down.
	_syncBoardFullscreenToRoute()
	{
		if (typeof window === 'undefined') { return; }
		let tmpHash = (window.location.hash || '').replace(/^#/, '');
		let tmpIsFullscreen = /^\/whiteboard\/\d+\/fullscreen\/?$/.test(tmpHash);
		if (!tmpIsFullscreen && this._FullscreenOverlay && this._FullscreenOverlay.style.display !== 'none')
		{
			this._hideBoardFullscreen();
		}
	}
	// Organization prompt shapes are an administrator-configured platform feature, like Workflow:
	// they live under the gear. Bounce a non-admin who hand-types the URL back to the board.
	_renderPromptShapes()
	{
		if (!this._can('users.manage')) { return this._navigate('/board'); }
		this._setActiveNav('PromptShapes');
		// Routed (3rd arg) so the standalone page's edits deep-link to /prompt-shape/:id.
		this.pict.views['Plansheet-PromptShapes'].showIn('#Plansheet-Workspace', 'Organization', true);
	}
	// Route handler for /prompt-shape/:id and /prompt-shapes/new -- open the standalone shape editor.
	_renderPromptShapeEditor(pID)
	{
		if (!this._can('users.manage')) { return this._navigate('/board'); }
		this._setActiveNav('PromptShapes');
		this.pict.views['Plansheet-PromptShapes'].showRoutedEdit(Number(pID) || 0);
	}
	_renderCommunity()
	{
		this._setActiveNav('Community');
		if (!(this.pict.AppData.Auth && this.pict.AppData.Auth.LoggedIn)) { return this.showAuth('login'); }
		this.pict.views['Plansheet-Community'].show();
	}

	_renderDoc(pPathWithSection)
	{
		// Capture whether the docs workspace was ALREADY the active view, before _setActiveNav flips it to
		// 'Docs'. The idempotency skip below is only safe when we were already in docs showing this exact
		// path (the URL syncing to a tree click). Returning to the SAME doc URL from another view -- e.g.
		// Back out of Settings/Appearance -- leaves InlineDocumentation.CurrentPath stale, so without this
		// guard the skip fires and the content never repaints (the URL changes but nothing loads).
		let tmpWasDocs = (this._activeNavKey === 'Docs');
		this._setActiveNav('Docs');
		let tmpSplit = String(pPathWithSection || '').split('::');
		let tmpPath = tmpSplit[0];
		let tmpSection = (tmpSplit.length > 1) ? tmpSplit[1] : '';
		if (!tmpPath) { this.pict.views['Plansheet-FoundationDocs'].showOverview(); return; }
		this._setPageTitle(this._docTitleFromPath(tmpPath));
		// Idempotent: if the inline-doc already shows this doc and there's no new
		// section to scroll to, this is just the URL syncing to a nav click that
		// already loaded the doc — don't reload it. Only trust that when the docs
		// workspace was already active (tmpWasDocs); otherwise the doc view is not
		// even mounted and we must repaint.
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpCurrent = tmpState && tmpState.CurrentPath;
		if (tmpWasDocs && tmpCurrent && tmpCurrent === tmpPath)
		{
			// Already showing this doc. If a section was requested (a pasted
			// section link for the current doc), scroll to it without re-syncing
			// the URL — it is already correct — so the route stays loop-free.
			if (tmpSection)
			{
				let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];
				if (tmpProvider && typeof tmpProvider._scrollToAnchor === 'function')
				{
					this._suppressDocURLSync = true;
					try { tmpProvider._scrollToAnchor(tmpSection); }
					finally { this._suppressDocURLSync = false; }
				}
			}
			return;
		}
		this.pict.views['Plansheet-FoundationDocs'].showSlug(tmpSection ? (tmpPath + '#' + tmpSection) : tmpPath);
	}

	_renderUserSettings() { this._renderSettingsSection('profile', null); }

	// Settings sections render full-width into the workspace now; their nav lives in the shared
	// sidebar's Settings group. Each #/settings/<section> is a real route. If the settings shell is
	// already mounted, just swap the section; otherwise render the shell and let its onAfterRender
	// open the section we stashed in _pendingSection. The optional :id rides a sub-path the settings
	// view already parses (the Drafting Kit editor: draftingkit/<id>).
	_renderSettingsSection(pSection, pID)
	{
		this._setActiveNav('Settings');
		if (!(this.pict.AppData.Auth && this.pict.AppData.Auth.LoggedIn)) { return this.showAuth('login'); }
		this._setPageTitle(this._settingsTitle(pSection));
		let tmpView = this.pict.views['Plansheet-UserSettings'];
		if (!tmpView) { return; }
		let tmpSection = pID ? (String(pSection) + '/' + pID) : (pSection || 'profile');
		if (typeof document !== 'undefined' && document.getElementById('Settings-Content'))
		{
			tmpView.showSection(tmpSection);
		}
		else
		{
			tmpView._pendingSection = tmpSection;
			tmpView.render();
		}
	}

	_renderProfile()
	{
		this._setActiveNav('Community');
		if (!(this.pict.AppData.Auth && this.pict.AppData.Auth.LoggedIn)) { return this.showAuth('login'); }
		let tmpView = this.pict.views['Plansheet-Profile'];
		this.pict.AppData.ProfileView = this.pict.AppData.ProfileView || { Record: null, Blocks: [], BoardID: null };
		// /profile is the signed-in user; refresh from the server, then render.
		if (this.pict.providers.UserAPI)
		{
			this.pict.providers.UserAPI.getMe().then((pAccount) =>
			{
				this.pict.AppData.ProfileView.Record = pAccount || (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || null;
				let tmpRec = this.pict.AppData.ProfileView.Record;
				this._setPageTitle((tmpRec && (tmpRec.DisplayName || tmpRec.Email)) || 'Profile');
				tmpView.show();
			});
		}
		else { this._setPageTitle('Profile'); tmpView.show(); }
	}

	// /profile/:id is a teammate's page (read-only). Your own id falls through to the editable self
	// profile. The record comes from the public Team/Members/:id endpoint.
	_renderProfileFor(pIDUser)
	{
		this._setActiveNav('Community');
		if (!(this.pict.AppData.Auth && this.pict.AppData.Auth.LoggedIn)) { return this.showAuth('login'); }
		let tmpMe = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		if (tmpMe.IDUser && Number(pIDUser) === tmpMe.IDUser) { return this._renderProfile(); }
		let tmpView = this.pict.views['Plansheet-Profile'];
		this.pict.AppData.ProfileView = this.pict.AppData.ProfileView || { Record: null, Blocks: [], BoardID: null };
		if (this.pict.providers.TeamAPI)
		{
			this.pict.providers.TeamAPI.getMember(pIDUser).then((pMember) =>
			{
				this.pict.AppData.ProfileView.Record = pMember || null;
				this._setPageTitle((pMember && (pMember.DisplayName || pMember.Email)) || 'Profile');
				tmpView.show();
			});
		}
	}

	// ── public navigation (called by views/buttons) — set the URL ────────────
	_showWorkspace()
	{
		// Org requires two-step verification and this account is not enrolled: hold at
		// the forced-enrollment gate (a restricted session reaches only the 2FA
		// enrollment endpoints) instead of the workspace until 2FA is turned on.
		if (this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.MustEnroll2FA)
		{
			return this.showAuth('enroll');
		}
		// Bring the app chrome back now that we are signed in.
		if (typeof document !== 'undefined' && document.body) { document.body.classList.remove('plansheet-auth-mode'); }
		// The docked site-map sidebar (pict-section-navigation) replaces the hand-rolled rail, and arms
		// the cmd+K launcher.
		this._installSiteNav();
		// Paint this plan sheet's top-bar backdrop (WI #360): the baked moodboard crop that makes each
		// plan sheet's chrome visually its own, so landing in the wrong one is obvious at a glance. Fired
		// once here and never awaited -- the workspace must not wait on a decoration -- and once here is
		// enough, because switching plan sheets reloads the page (reloadForActivePlansheetChange).
		this._applyTopBarBackdrop();
		// Render the workspace for the current route, honoring a pasted deep-link, otherwise the
		// cross-tenant home (WI #339): the canonical landing that shows every plan sheet you belong to.
		let tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash.replace(/^#/, '') : '';
		let tmpTarget = (tmpHash && tmpHash !== '/') ? tmpHash : '/home';
		// Navigate straight to the target so exactly ONE route handler runs. Navigo will not re-fire the
		// handler for the route it is already on, so after an in-app sign-out then sign-in -- where the hash
		// still holds the last route and Navigo still has it resolved -- a plain navigate is a no-op and the
		// sign-in view (rendered into #Plansheet-Workspace) would stay put. Clearing Navigo's resolved-route
		// state makes the navigate below always fire its handler. The previous fix bounced through '/'
		// instead, but that fired _renderBoard, whose async board fetch could resolve AFTER the real route's
		// render and paint the board over it -- a nondeterministic boot race on any deep-link / hard reload
		// to a non-board route.
		// renavigate(): go there, and run the handler even if the router already considers itself there.
		// This used to reach into navigo's PRIVATE _setCurrent(null) to force the same thing, with a
		// root-bounce fallback for older versions that fired _renderBoard and could paint the board over
		// the real route. pict-router 1.0.13 does it properly, so neither hack is needed.
		let tmpRouter = this._router();
		if (tmpRouter && typeof tmpRouter.renavigate === 'function')
		{
			let tmpHashTarget = '#' + String(tmpTarget || '/').replace(/^#/, '');
			if (typeof window !== 'undefined' && window.location && window.history
				&& typeof window.history.pushState === 'function' && String(window.location.hash || '') !== tmpHashTarget)
			{
				window.history.pushState(null, '', (window.location.pathname || '') + (window.location.search || '') + tmpHashTarget);
			}
			tmpRouter.renavigate(tmpTarget, { updateBrowserURL: false });
		}
		else
		{
			this._navigate('/');
			this._navigate(tmpTarget);
		}
	}

	// Fetch the active plan sheet's baked top-bar crop and hand it to the shell, which injects it behind
	// the brand / nav / account chrome (Plansheet-Shell.applyTopBarBackdrop). The SVG comes from the
	// session's own tenant server-side -- the client never names a plan sheet -- and an empty string is
	// the normal "no backdrop set" answer, which clears the bar. Any failure is swallowed by the provider
	// and lands here as an empty backdrop: a decoration is never worth a broken load.
	_applyTopBarBackdrop()
	{
		let tmpShell = this.pict.views['Plansheet-Shell'];
		if (!tmpShell || typeof tmpShell.applyTopBarBackdrop !== 'function') { return; }
		this.pict.providers.OrgAPI.getTopBar()
			.then((pBody) => { tmpShell.applyTopBarBackdrop((pBody && pBody.TopBarBackdropSVG) || ''); })
			.catch(() => { /* the provider already falls back to no backdrop */ });
	}

	// If the user has pinned an explicit default plan sheet (localStorage plansheet.pinned_customer)
	// and the current session is in a different one, switch before rendering the workspace.
	// Returns a promise that resolves once the determination is made. On a successful switch
	// it triggers a page reload (so the promise is never settled; the reload takes over).
	_applyPinnedCustomerIfNeeded()
	{
		let tmpPinned = 0;
		try { tmpPinned = parseInt((typeof localStorage !== 'undefined' ? localStorage.getItem('plansheet.pinned_customer') : null) || '0', 10) || 0; }
		catch (pErr) { tmpPinned = 0; }
		let tmpCurrentIDCustomer = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) ? (this.pict.AppData.Auth.User.IDCustomer || 0) : 0;
		if (!tmpPinned || tmpPinned === tmpCurrentIDCustomer) { return Promise.resolve(); }
		return libFrameworkClient.postJSON(this.pict, '/1.0/Session/Context/' + tmpPinned, {})
			.then((pBody) =>
			{
				if (pBody && pBody.Switched) { this.reloadForActivePlansheetChange(); return; }
				// Switch was rejected (no longer a member): clear the stale pin and continue.
				try { if (typeof localStorage !== 'undefined') { localStorage.removeItem('plansheet.pinned_customer'); } } catch (pStorageErr) { /* ignore */ }
			})
			.catch(() =>
			{
				// Network error or auth failure: clear the pin and carry on.
				try { if (typeof localStorage !== 'undefined') { localStorage.removeItem('plansheet.pinned_customer'); } } catch (pStorageErr) { /* ignore */ }
			});
	}

	showSection(pKey)
	{
		if (pKey === 'Board') { return this._navigate('/board'); }
		if (pKey === 'Docs') { return this._navigate('/docs'); }
		if (pKey === 'Sessions') { return this._navigate('/sessions'); }
		if (pKey === 'Workflow') { return this._navigate('/workflow'); }
		if (pKey === 'Community') { return this._navigate('/community'); }
		if (pKey === 'Settings') { return this._navigate('/settings'); }
		return this._navigate('/' + this._pluralRoute(pKey));
	}

	showBoard() { this._navigate('/board'); }

	showReleases() { this._navigate('/releases'); }

	// Route to /profile/:myId rather than /profile: a distinct :id always re-fires the handler (Navigo
	// will not re-fire /profile coming from /profile/:otherId, a prefix), and _renderProfileFor detects
	// self and renders the editable page.
	showProfile()
	{
		let tmpMe = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		if (tmpMe.IDUser) { this._navigate('/profile/' + tmpMe.IDUser); }
		else { this._navigate('/profile'); }
	}

	showProfileFor(pIDUser) { this._navigate('/profile/' + pIDUser); }

	showCommunity() { this._navigate('/community'); }

	showEntityDetail(pKey, pID) { this._navigate('/' + this._singularRoute(pKey) + '/' + pID); }
	showWhiteboards() { this._navigate('/whiteboards'); }
	showWhiteboard(pID) { this._navigate('/whiteboard/' + pID); }
	showBoardFullscreen(pID) { this._navigate('/whiteboard/' + pID + '/fullscreen'); }
	showDrawings() { this._navigate('/drawings'); }
	showDrawing(pID) { this._navigate('/drawing/' + pID); }
	showNewDrawing() { this._navigate('/drawings/new'); }
	showNotes() { this._navigate('/notes'); }
	showNote(pID) { this._navigate('/note/' + pID); }
	// Ask navigation: the catalog, a task's input form, and an in-flight/answered request are each a route so
	// Back / forward and reload behave. The Ask view calls these instead of repainting its body in place.
	showAsk() { this._navigate('/ask'); }
	showAskTask(pID) { this._navigate('/ask/task/' + (Number(pID) || 0)); }
	showAskRequest(pID) { this._navigate('/ask/request/' + (Number(pID) || 0)); }
	showProjects() { this._navigate('/projects'); }
	showProject(pID) { this._navigate('/project/' + (Number(pID) || 0)); }
	showProjectTypes() { this._navigate('/project-types'); }
	showProjectType(pID) { this._navigate('/project-type/' + (Number(pID) || 0)); }
	// A settings pane that is working on one thing (a sticker set, a message template) says which,
	// riding the /settings/:section/:id route that Drafting Kit already uses.
	showSettingsSub(pSection, pSub)
	{
		if (!pSection || !pSub) { return false; }
		this._navigate('/settings/' + pSection + '/' + pSub);
		return true;
	}
	showSystemActivityPeriod(pPeriod)
	{
		if (!pPeriod) { return false; }
		this._navigate('/system-activity/' + pPeriod);
		return true;
	}
	showPromptsTab(pTab)
	{
		if (!pTab) { return false; }
		this._navigate('/prompts/' + pTab);
		return true;
	}
	showWorkflowTab(pTab)
	{
		// The subject tab is reached by opening a subject, which has its own route carrying the id.
		// Sending it to /workflow/subject would land on a subject page with no subject.
		if (!pTab || pTab === 'subject') { return false; }
		this._navigate('/workflow/' + pTab);
		return true;
	}
	showCallDeskCustomer(pID)
	{
		this._navigate(pID ? ('/call-desk/' + pID) : '/call-desk');
		return true;
	}
	// Open the create / edit form for an entity as a place of its own. Both return false when the entity
	// has no slug for that shape -- Blueprint has a list but a bespoke detail page, Issue has a detail
	// but a board instead of a list -- so the caller can fall back to rendering in place rather than
	// navigating to a route that was never registered.
	showEntityNew(pKey)
	{
		let tmpSlug = _listSlugFor(pKey);
		if (!tmpSlug) { return false; }
		return this._navigate('/' + tmpSlug + '/new');
	}
	showEntityEdit(pKey, pID)
	{
		let tmpSlug = _detailSlugFor(pKey);
		if (!tmpSlug || !pID) { return false; }
		return this._navigate('/' + tmpSlug + '/' + pID + '/edit');
	}
	// Where a form goes when it closes: back to the record it was editing, else back to the list.
	showEntityAfterForm(pKey, pID)
	{
		let tmpTarget = (pID && _detailSlugFor(pKey))
			? ('/' + _detailSlugFor(pKey) + '/' + pID)
			: (_listSlugFor(pKey) ? ('/' + _listSlugFor(pKey)) : '');
		if (!tmpTarget) { return false; }
		// ALREADY THERE IS NOT A NAVIGATION, and _navigate says so now -- the caller renders instead of
		// believing it moved. This used to compare the hash by hand right here, which is the sort of
		// thing that gets written once per caller and forgotten in the next one.
		return this._navigate(tmpTarget);
	}
	listSlugFor(pKey) { return _listSlugFor(pKey); }
	detailSlugFor(pKey) { return _detailSlugFor(pKey); }
	showPrompt(pID) { this._navigate('/prompt/' + pID); }
	showWorkflowSubject(pID) { this._navigate('/workflow/subject/' + pID); }
	showPromptShapes() { this._navigate('/prompt-shapes'); }
	showPromptShape(pID) { this._navigate('/prompt-shape/' + pID); }
	showNewPromptShape() { this._navigate('/prompt-shapes/new'); }

	// Issue header action: assign the issue to the signed-in user, then repaint the detail.
	assignIssueToMe(pKey, pIDIssue)
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		let tmpMe = tmpUser.IDUser || 0;
		if (!tmpMe || !pIDIssue) { return; }
		this.pict.providers.IssueAPI.update(pIDIssue, { IDAssignedUser: tmpMe }).then(() =>
		{
			let tmpDetail = this.pict.views['Plansheet-EntityDetail'];
			if (tmpDetail && typeof tmpDetail.showDetail === 'function') { tmpDetail.showDetail('Issue', pIDIssue); }
			let tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Assigned to you.', { type: 'success', duration: 3000 }); }
		}).catch(() => { /* ignore */ });
	}

	// Issue header action: open a picker to assign the issue to any teammate (or unassign).
	assignIssue(pKey, pIDIssue)
	{
		if (!pIDIssue) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let fEsc = (pStr) => String(pStr).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh]));
		this.pict.providers.IssueBoardAPI.assignees().then((pUsers) =>
		{
			let tmpOptions = '<option value="0">Unassigned</option>' + pUsers.map((pU) => '<option value="' + pU.IDUser + '">' + fEsc(pU.DisplayName) + '</option>').join('');
			tmpModal.show(
			{
				title: 'Assign issue',
				content: '<p>Assign to:</p><select id="issue-assignee-pick" style="width:100%;box-sizing:border-box;padding:7px 9px;font:inherit;">' + tmpOptions + '</select>',
				buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Assign', Style: 'primary' }]
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let tmpEl = (typeof document !== 'undefined') ? document.getElementById('issue-assignee-pick') : null;
				let tmpID = tmpEl ? (parseInt(tmpEl.value, 10) || 0) : 0;
				this.pict.providers.IssueAPI.update(pIDIssue, { IDAssignedUser: tmpID }).then(() =>
				{
					let tmpDetail = this.pict.views['Plansheet-EntityDetail'];
					if (tmpDetail && typeof tmpDetail.showDetail === 'function') { tmpDetail.showDetail('Issue', pIDIssue); }
					if (typeof tmpModal.toast === 'function') { tmpModal.toast('Assignment updated.', { type: 'success', duration: 3000 }); }
				}).catch(() => { /* ignore */ });
			});
		});
	}

	// Issue header action: create a draft vision from the issue (server links Issue.IDTargetVision) and open it.
	spawnVisionFromIssue(pKey, pIDIssue)
	{
		if (!pIDIssue) { return; }
		this.pict.providers.IssueBoardAPI.spawnVision(pIDIssue, {}).then((pResult) =>
		{
			if (pResult && pResult.IDVision) { this._navigate('/vision/' + pResult.IDVision); }
		}).catch(() => { /* ignore */ });
	}

	// Feedback header action: promote a piece of feedback into a tracked WorkItem. A small form pre-fills
	// Title/Description from the feedback, picks the WorkItem Type, and (in one grouped dropdown) the target
	// Vision/Module/Feature it advances. The server links WorkItem.IDSourceFeedback and opens on the new item.
	spawnWorkItemFromFeedback(pKey, pIDFeedback)
	{
		if (!pIDFeedback) { return; }
		let tmpProviders = this.pict.providers;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let fGo = (pResult) => { if (pResult && pResult.IDWorkItem) { this._navigate('/work-item/' + pResult.IDWorkItem); } };
		// Headless / no modal: spawn straight from the feedback (server prefills Title/Body) and open it.
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			return tmpProviders.IssueBoardAPI.spawnWorkItem(pIDFeedback, {}).then(fGo).catch(() => { /* ignore */ });
		}
		let fEsc = (pStr) => String(pStr == null ? '' : pStr).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh]));
		Promise.all(
		[
			tmpProviders.FeedbackAPI.read(pIDFeedback),
			(tmpProviders.FeedbackAPI && typeof tmpProviders.FeedbackAPI.list === 'function') ? tmpProviders.FeedbackAPI.list() : Promise.resolve([])
		]).then((pLoaded) =>
		{
			let tmpFeedback = pLoaded[0] || {};
			// Optional: link more feedback to the new work item via the advanced multi-select picker.
			// The source feedback is already linked by the spawn, so exclude it from the candidates.
			let tmpFbPicker = new libFeedbackPicker();
			tmpFbPicker.configure(Array.isArray(pLoaded[1]) ? pLoaded[1] : [], { Exclude: [pIDFeedback] });
			let tmpStyle = 'width:100%;box-sizing:border-box;padding:6px 8px;font:inherit;margin-top:2px;';
			let fField = (pLabel, pControl) => '<div style="margin-bottom:9px;"><label style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);">' + pLabel + '</label>' + pControl + '</div>';
			let fType = ['Triage', 'Research', 'Innovation', 'Issue', 'Debt', 'Enhancement'].map((pT) => '<option' + (pT === 'Issue' ? ' selected' : '') + '>' + pT + '</option>').join('');
			// The target is a searchable pict-section-picker over ALL of Feature/Vision/Module (WI #446: a
			// server-backed candidate search per type, not a precomputed Options array built from list() --
			// that is at most one page each, so a Feature/Vision/Module past it could not be picked).
			let tmpTargetTypes =
			[
				{ Type: 'Feature', Provider: tmpProviders.FeatureAPI, Descriptor: libEntityDescriptors.Entities.Feature },
				{ Type: 'Vision', Provider: tmpProviders.VisionAPI, Descriptor: libEntityDescriptors.Entities.Vision },
				{ Type: 'Module', Provider: tmpProviders.ModuleAPI, Descriptor: libEntityDescriptors.Entities.Module }
			];
			let tmpSelectedTarget = '';
			if (this.pict.AppData) { this.pict.AppData.SWI_TargetValue = ''; }
			let tmpDialog = tmpModal.show(
			{
				title: 'Spawn work item',
				width: 'min(680px, 95vw)',
				content:
					// The picker's dropdown floats over the modal, anchored to its control, and flips up when
					// near the bottom (this is the last field, above the buttons). pict-section-picker 1.8.2+
					// anchors the fixed dropdown correctly inside a transform-centered modal, so no override.
					fField('Title', '<input id="swi-title" type="text" style="' + tmpStyle + '" value="' + fEsc(tmpFeedback.Title || '') + '">') +
					fField('Type', '<select id="swi-type" style="' + tmpStyle + '">' + fType + '</select>') +
					fField('Description', '<textarea id="swi-desc" style="' + tmpStyle + 'min-height:70px;resize:vertical;">' + fEsc(tmpFeedback.Body || '') + '</textarea>') +
					fField('This work is about', '<div id="swi-target-host" style="margin-top:2px;"></div>') +
					fField('Also link these feedback (optional)', '<div id="swi-fb-host" style="margin-top:2px;"></div>'),
				buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Create work item', Style: 'primary' }]
			});
			let tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
			if (tmpPickerProvider && typeof tmpPickerProvider.createPicker === 'function')
			{
				setTimeout(() =>
				{
					tmpPickerProvider.createPicker('SWI-TargetPicker',
						{
							DestinationAddress: '#swi-target-host',
							ValueAddress: 'AppData.SWI_TargetValue',
							Placeholder: 'Search a feature, vision, or module',
							Searchable: true,
							Options: [],
							DataProvider: libCandidateSearch.dataProviderForTypes(tmpTargetTypes),
							ResolveValue: libCandidateSearch.resolveValueForTypes(tmpTargetTypes),
							OnChange: (pVal) => { tmpSelectedTarget = pVal || ''; }
						});
					// createPicker builds the view; render() paints it into the host (matches the connections linker).
					let tmpPickerView = this.pict.views['SWI-TargetPicker'];
					if (tmpPickerView) { tmpPickerView.setValue(''); tmpPickerView.render(); }
					let tmpFbHost = (typeof document !== 'undefined') ? document.getElementById('swi-fb-host') : null;
					if (tmpFbHost) { tmpFbPicker.mount(tmpFbHost); }
				}, 20);
			}
			tmpDialog.then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let fVal = (pID) => { let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pID) : null; return tmpEl ? tmpEl.value : ''; };
				let tmpTargetRaw = tmpSelectedTarget || (this.pict.AppData && this.pict.AppData.SWI_TargetValue) || '';
				let tmpTargetType = '', tmpIDTarget = 0;
				if (tmpTargetRaw) { let tmpParts = tmpTargetRaw.split(':'); tmpTargetType = tmpParts[0]; tmpIDTarget = parseInt(tmpParts[1], 10) || 0; }
				let tmpDraft =
				{
					Title: fVal('swi-title').trim(),
					Type: fVal('swi-type'),
					Description: fVal('swi-desc'),
					TargetType: tmpIDTarget ? tmpTargetType : '',
					IDTarget: tmpIDTarget
				};
				let tmpExtras = tmpFbPicker.selectedIDs();
				tmpProviders.IssueBoardAPI.spawnWorkItem(pIDFeedback, tmpDraft).then((pResult) =>
				{
					// Link any extra feedback the person picked to the new work item (best-effort; the
					// work item is already created, so a link failure should not block navigation).
					if (pResult && pResult.IDWorkItem && tmpExtras.length)
					{
						return tmpProviders.IssueBoardAPI.linkFeedbackToWorkItem(pResult.IDWorkItem, tmpExtras).then(() => pResult, () => pResult);
					}
					return pResult;
				}).then(fGo).catch(() => { /* ignore */ });
			});
		}).catch(() => { /* ignore */ });
	}

	// Start a test run of a routine (the Routine detail's header action) and land
	// in the runner. pKey arrives from the generic header-action dispatch.
	// Detail header action on a Work Item: generate a prompt from a shape for this work item.
	// Delegates to the attached-prompts panel, which is already mounted for this owner and knows
	// how to pick the shape, POST, and refresh.
	generatePromptForWorkItem(pKey, pIDWorkItem)
	{
		let tmpView = this.pict.views['Plansheet-PromptAttachments'];
		if (tmpView && typeof tmpView.generateDialog === 'function') { tmpView.generateDialog(); }
	}

	// Detail header action on a Work Item: assign it to a teammate or the claude@plansheet.io AI agent.
	// A modal with the same searchable pict-section-picker the other header actions use; its options are the
	// team roster (humans + agents), plus an Unassigned choice. Writing IDAssignedUser flows through the normal
	// WorkItem PUT, so the append-only WorkflowStatusEvent audit and the assignment notification fire for free.
	assignWorkItem(pKey, pIDWorkItem)
	{
		if (!pIDWorkItem) { return; }
		let tmpProviders = this.pict.providers;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		Promise.all(
		[
			(tmpProviders.TeamAPI && typeof tmpProviders.TeamAPI.roster === 'function') ? tmpProviders.TeamAPI.roster() : Promise.resolve([]),
			fetch('/1.0/WorkItem/' + encodeURIComponent(pIDWorkItem), { credentials: 'same-origin' }).then((pR) => pR.ok ? pR.json() : {}).catch(() => ({}))
		]).then((pLoaded) =>
		{
			let tmpRoster = Array.isArray(pLoaded[0]) ? pLoaded[0] : ((this.pict.AppData.Team && this.pict.AppData.Team.Roster) || []);
			let tmpWorkItem = pLoaded[1] || {};
			let tmpCurrent = Number(tmpWorkItem.IDAssignedUser) || 0;
			let tmpOptions = [{ Value: '0', Text: 'Unassigned' }].concat(tmpRoster.map((pMember) =>
				({ Value: String(pMember.IDUser), Text: (pMember.DisplayName || ('User #' + pMember.IDUser)) + (pMember.IsAgent ? '  (AI agent)' : '') })));
			let tmpNameByID = {};
			tmpOptions.forEach((pOption) => { tmpNameByID[pOption.Value] = pOption.Text; });
			let tmpSelected = String(tmpCurrent);
			let tmpDialog = tmpModal.show(
			{
				title: 'Assign work item',
				content: '<div style="margin-bottom:9px;"><label style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);">Assignee</label>' +
					'<div id="awi-assignee-host" style="margin-top:2px;"></div>' +
					'<p style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);margin:8px 0 0;">Pick a teammate or the AI agent. Choose Unassigned to clear it.</p></div>',
				buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Assign', Style: 'primary' }]
			});
			setTimeout(() =>
			{
				this.mountPicker('#awi-assignee-host', 'AWI-AssigneePicker', tmpOptions,
					(pVal) => { tmpSelected = (pVal == null ? '' : String(pVal)); },
					{ Placeholder: 'Search a teammate or the AI agent', Value: String(tmpCurrent) });
			}, 20);
			tmpDialog.then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let tmpIDUser = parseInt(tmpSelected, 10) || 0;
				if (tmpIDUser === tmpCurrent)
				{
					if (tmpModal.toast) { tmpModal.toast('No change to the assignee.', { type: 'info' }); }
					return;
				}
				let tmpProvider = tmpProviders[pKey + 'API'];
				if (!tmpProvider || typeof tmpProvider.update !== 'function') { return; }
				tmpProvider.update(pIDWorkItem, { IDAssignedUser: tmpIDUser }).then(() =>
				{
					let tmpName = tmpNameByID[String(tmpIDUser)] || ('user #' + tmpIDUser);
					if (tmpModal.toast) { tmpModal.toast(tmpIDUser ? ('Assigned to ' + tmpName + '.') : 'Assignment cleared.', { type: 'success' }); }
					this._navigate('/work-item/' + pIDWorkItem);
				}).catch(() => { if (tmpModal.toast) { tmpModal.toast('Could not assign the work item.', { type: 'error' }); } });
			});
		}).catch(() => { /* ignore */ });
	}

	// Detail header action on an Issue: promote it into a Work Item (reverse-linked via the Issue join).
	// Mirrors spawnWorkItemFromFeedback: a modal prefilled from the issue with a searchable target picker.
	spawnWorkItemFromIssue(pKey, pIDIssue)
	{
		if (!pIDIssue) { return; }
		let tmpProviders = this.pict.providers;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let fGo = (pResult) => { if (pResult && pResult.IDWorkItem) { this._navigate('/work-item/' + pResult.IDWorkItem); } };
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			return tmpProviders.IssueBoardAPI.spawnWorkItemFromIssue(pIDIssue, {}).then(fGo).catch(() => { /* ignore */ });
		}
		let fEsc = (pStr) => String(pStr == null ? '' : pStr).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh]));
		Promise.all(
		[
			fetch('/1.0/Issue/' + encodeURIComponent(pIDIssue), { credentials: 'same-origin' }).then((pR) => pR.ok ? pR.json() : {}).catch(() => ({}))
		]).then((pLoaded) =>
		{
			let tmpIssue = pLoaded[0] || {};
			let tmpStyle = 'width:100%;box-sizing:border-box;padding:6px 8px;font:inherit;margin-top:2px;';
			let fField = (pLabel, pControl) => '<div style="margin-bottom:9px;"><label style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);">' + pLabel + '</label>' + pControl + '</div>';
			let fType = ['Triage', 'Research', 'Innovation', 'Issue', 'Debt', 'Enhancement'].map((pT) => '<option' + (pT === 'Issue' ? ' selected' : '') + '>' + pT + '</option>').join('');
			// A server-backed candidate search per type (WI #446), same as spawnWorkItemFromFeedback above.
			let tmpTargetTypes =
			[
				{ Type: 'Feature', Provider: tmpProviders.FeatureAPI, Descriptor: libEntityDescriptors.Entities.Feature },
				{ Type: 'Vision', Provider: tmpProviders.VisionAPI, Descriptor: libEntityDescriptors.Entities.Vision },
				{ Type: 'Module', Provider: tmpProviders.ModuleAPI, Descriptor: libEntityDescriptors.Entities.Module }
			];
			let tmpSelectedTarget = '';
			if (this.pict.AppData) { this.pict.AppData.SWI_TargetValue = ''; }
			let tmpDialog = tmpModal.show(
			{
				title: 'Spawn work item from issue',
				content:
					fField('Title', '<input id="swii-title" type="text" style="' + tmpStyle + '" value="' + fEsc(tmpIssue.Title || '') + '">') +
					fField('Type', '<select id="swii-type" style="' + tmpStyle + '">' + fType + '</select>') +
					fField('Description', '<textarea id="swii-desc" style="' + tmpStyle + 'min-height:70px;resize:vertical;">' + fEsc(tmpIssue.Description || '') + '</textarea>') +
					fField('This work is about', '<div id="swii-target-host" style="margin-top:2px;"></div>'),
				buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Create work item', Style: 'primary' }]
			});
			let tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
			if (tmpPickerProvider && typeof tmpPickerProvider.createPicker === 'function')
			{
				setTimeout(() =>
				{
					tmpPickerProvider.createPicker('SWII-TargetPicker',
						{
							DestinationAddress: '#swii-target-host',
							ValueAddress: 'AppData.SWI_TargetValue',
							Placeholder: 'Search a feature, vision, or module',
							Searchable: true,
							Options: [],
							DataProvider: libCandidateSearch.dataProviderForTypes(tmpTargetTypes),
							ResolveValue: libCandidateSearch.resolveValueForTypes(tmpTargetTypes),
							OnChange: (pVal) => { tmpSelectedTarget = pVal || ''; }
						});
					let tmpPickerView = this.pict.views['SWII-TargetPicker'];
					if (tmpPickerView) { tmpPickerView.setValue(''); tmpPickerView.render(); }
				}, 20);
			}
			tmpDialog.then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let fVal = (pID) => { let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pID) : null; return tmpEl ? tmpEl.value : ''; };
				let tmpTargetRaw = tmpSelectedTarget || (this.pict.AppData && this.pict.AppData.SWI_TargetValue) || '';
				let tmpTargetType = '', tmpIDTarget = 0;
				if (tmpTargetRaw) { let tmpParts = tmpTargetRaw.split(':'); tmpTargetType = tmpParts[0]; tmpIDTarget = parseInt(tmpParts[1], 10) || 0; }
				let tmpDraft =
				{
					Title: fVal('swii-title').trim(),
					Type: fVal('swii-type'),
					Description: fVal('swii-desc'),
					TargetType: tmpIDTarget ? tmpTargetType : '',
					IDTarget: tmpIDTarget
				};
				tmpProviders.IssueBoardAPI.spawnWorkItemFromIssue(pIDIssue, tmpDraft).then(fGo).catch(() => { /* ignore */ });
			});
		}).catch(() => { /* ignore */ });
	}

	// Detail header action on a Work Item: link many existing Issues to it at once (they become
	// supporting evidence in its generated prompt). A modal with a checkbox list of the tenant's issues.
	linkIssuesToWorkItem(pKey, pIDWorkItem)
	{
		if (!pIDWorkItem) { return; }
		let tmpProviders = this.pict.providers;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let fEsc = (pStr) => String(pStr == null ? '' : pStr).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh]));
		fetch('/1.0/Issues/0/500', { credentials: 'same-origin' }).then((pR) => pR.ok ? pR.json() : []).then((pBody) =>
		{
			let tmpIssues = (Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || []).filter((pI) => !pI.Deleted);
			if (!tmpIssues.length) { if (tmpModal.toast) { tmpModal.toast('No issues to link yet.', { type: 'info' }); } return; }
			let tmpRows = tmpIssues.map((pI) =>
				'<label style="display:flex;gap:8px;align-items:flex-start;padding:5px 2px;border-bottom:1px solid var(--theme-color-border-subtle,#eef0f4);cursor:pointer;">' +
				'<input type="checkbox" class="li-issue" value="' + pI.IDIssue + '" style="margin-top:3px;flex:0 0 auto;">' +
				'<span style="font-size:13px;"><strong>#' + (pI.IssueNumber || pI.IDIssue) + '</strong> ' + fEsc(pI.Title || '') +
				' <em style="color:var(--theme-color-text-secondary,#5b6376);">[' + fEsc(pI.Reliability || 'Reported') + (pI.Severity ? ' | ' + fEsc(pI.Severity) : '') + ']</em></span></label>').join('');
			let tmpDialog = tmpModal.show(
			{
				title: 'Link issues to this work item',
				content: '<p style="font-size:13px;color:var(--theme-color-text-secondary,#5b6376);margin:0 0 8px;">Pick the issues that inform this work item. They become scoped supporting evidence in its generated prompt.</p><div style="max-height:340px;overflow:auto;">' + tmpRows + '</div>',
				buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Link selected', Style: 'primary' }]
			});
			tmpDialog.then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let tmpChecked = (typeof document !== 'undefined') ? Array.prototype.slice.call(document.querySelectorAll('.li-issue:checked')).map((pEl) => parseInt(pEl.value, 10) || 0).filter((pX) => pX > 0) : [];
				if (!tmpChecked.length) { return; }
				tmpProviders.IssueBoardAPI.linkIssuesToWorkItem(pIDWorkItem, tmpChecked, 'Addresses').then((pRes) =>
				{
					let tmpN = (pRes && pRes.Linked && pRes.Linked.length) || 0;
					if (tmpModal.toast) { tmpModal.toast('Linked ' + tmpN + ' issue' + (tmpN === 1 ? '' : 's') + ' to this work item.', { type: 'success' }); }
					this._navigate('/work-item/' + pIDWorkItem);
				}).catch(() => { if (tmpModal.toast) { tmpModal.toast('Could not link the issues.', { type: 'error' }); } });
			});
		}).catch(() => { /* ignore */ });
	}

	// Detail header action on a Work Item: link many existing Feedback to it at once via the advanced
	// multi-select picker (search + facets). They become the "feedback that drove this" on both sides
	// and feed the generated prompt as context. The bulk-link route is idempotent + keeps the scalar.
	linkFeedbackToWorkItem(pKey, pIDWorkItem)
	{
		if (!pIDWorkItem) { return; }
		let tmpProviders = this.pict.providers;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		Promise.all(
		[
			(tmpProviders.FeedbackAPI && typeof tmpProviders.FeedbackAPI.list === 'function') ? tmpProviders.FeedbackAPI.list() : Promise.resolve([]),
			fetch('/1.0/FeedbackWorkItemJoins/FilteredTo/FBV~IDWorkItem~EQ~' + encodeURIComponent(pIDWorkItem) + '/0/500', { credentials: 'same-origin' }).then((pR) => pR.ok ? pR.json() : []).catch(() => [])
		]).then((pLoaded) =>
		{
			let tmpAll = Array.isArray(pLoaded[0]) ? pLoaded[0] : [];
			let tmpJoinBody = pLoaded[1];
			let tmpJoins = Array.isArray(tmpJoinBody) ? tmpJoinBody : ((tmpJoinBody && tmpJoinBody.Records) || []);
			let tmpExclude = tmpJoins.map((pJoin) => Number(pJoin.IDFeedback)).filter((pID) => pID > 0);
			if (!tmpAll.length) { if (tmpModal.toast) { tmpModal.toast('No feedback to link yet.', { type: 'info' }); } return; }
			let tmpPicker = new libFeedbackPicker();
			tmpPicker.configure(tmpAll, { Exclude: tmpExclude });
			let tmpDialog = tmpModal.show(
			{
				title: 'Link feedback to this work item',
				width: 'min(680px, 95vw)',
				content: '<p style="font-size:13px;color:var(--theme-color-text-secondary,#5b6376);margin:0 0 8px;">Pick the feedback that drove this work item. It shows on both the work item and each feedback, and feeds the generated prompt as context.</p><div id="lfb-host"></div>',
				buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Link selected', Style: 'primary' }]
			});
			setTimeout(() =>
			{
				let tmpHost = (typeof document !== 'undefined') ? document.getElementById('lfb-host') : null;
				if (tmpHost) { tmpPicker.mount(tmpHost); }
			}, 20);
			tmpDialog.then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let tmpChosen = tmpPicker.selectedIDs();
				if (!tmpChosen.length) { return; }
				tmpProviders.IssueBoardAPI.linkFeedbackToWorkItem(pIDWorkItem, tmpChosen).then((pRes) =>
				{
					let tmpN = (pRes && pRes.Linked && pRes.Linked.length) || 0;
					if (tmpModal.toast) { tmpModal.toast('Linked ' + tmpN + ' feedback to this work item.', { type: 'success' }); }
					this._navigate('/work-item/' + pIDWorkItem);
				}).catch(() => { if (tmpModal.toast) { tmpModal.toast('Could not link the feedback.', { type: 'error' }); } });
			});
		}).catch(() => { /* ignore */ });
	}

	startTestRun(pKey, pIDRoutine)
	{
		this.pict.providers.TestRunAPI.start(pIDRoutine)
			.then((pRun) =>
			{
				if (!pRun || !pRun.IDTestRun) { throw new Error('no run returned'); }
				this._navigate('/test-run/' + pRun.IDTestRun);
			})
			.catch((pErr) =>
			{
				let tmpModal = this.pict.views['Pict-Section-Modal'];
				if (tmpModal) tmpModal.toast('Could not start the run: ' + (pErr.message || pErr), { type: 'error', duration: 6000 });
			});
	}

	// Detail header action on an As-Built: confirm it actually works on the dev sandbox. Its Routine is the
	// rigorous path (start a TestRun against dev and walk the steps); marking it validated by hand is the fast
	// path for a small fix already eyeballed there. This is the gate between dev and prod: plansheet-promote
	// refuses to ship a batch that still has anything unvalidated riding it.
	//
	// Called both from the Releases page (validating one As-Built after another) and from an As-Built's own
	// header action. Only the latter should land on the As-Built page afterward -- from Releases, "mark
	// validated" refreshes the list in place so the reviewer can keep going down it without a round trip.
	validateAsBuilt(pKey, pIDAsBuilt)
	{
		if (!pIDAsBuilt) { return; }
		let tmpProviders = this.pict.providers;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpCallerHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash.replace(/^#/, '') : '';
		let tmpFromReleases = tmpCallerHash.indexOf('/releases') === 0;
		fetch('/1.0/AsBuilt/' + encodeURIComponent(pIDAsBuilt), { credentials: 'same-origin' }).then((pR) => pR.ok ? pR.json() : {}).then((pBody) =>
		{
			let tmpAsBuilt = (pBody && pBody.AsBuilt) ? pBody.AsBuilt : (pBody || {});
			let tmpIDRoutine = Number(tmpAsBuilt.IDRoutine) || 0;
			let tmpEnv = tmpAsBuilt.Environment || 'dev';
			let tmpButtons = [{ Hash: 'cancel', Label: 'Cancel' }];
			if (tmpIDRoutine) { tmpButtons.push({ Hash: 'routine', Label: 'Run its routine on ' + tmpEnv }); }
			tmpButtons.push({ Hash: 'mark', Label: 'Mark validated', Style: 'primary' });
			let tmpDialog = tmpModal.show(
			{
				title: 'Validate on ' + tmpEnv,
				content: '<p style="font-size:13px;margin:0 0 8px;">Only a validated As-Built can be promoted. A promote refuses any batch that still has something unvalidated in it.</p>' +
					'<p style="font-size:13px;color:var(--theme-color-text-secondary,#5b6376);margin:0;">' +
					(tmpIDRoutine
						? 'Run its validation routine against ' + tmpEnv + ' and walk the steps, or mark it validated if you have already checked it there.'
						: 'This As-Built has no validation routine, so confirm you have checked it on ' + tmpEnv + ' yourself.') + '</p>',
				buttons: tmpButtons
			});
			tmpDialog.then((pChoice) =>
			{
				if (pChoice === 'routine' && tmpIDRoutine)
				{
					// The run is stamped with the environment it was walked against, so a pass means "it works on dev".
					fetch('/1.0/TestRun/Start',
						{
							method: 'POST', credentials: 'same-origin',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({ IDRoutine: tmpIDRoutine, Environment: tmpEnv })
						})
						.then((pR) => pR.ok ? pR.json() : null)
						.then((pRun) =>
						{
							let tmpIDTestRun = pRun && (pRun.IDTestRun || (pRun.TestRun && pRun.TestRun.IDTestRun));
							if (!tmpIDTestRun) { throw new Error('no run returned'); }
							this._navigate('/test-run/' + tmpIDTestRun);
						})
						.catch(() => { if (tmpModal.toast) { tmpModal.toast('Could not start the test run.', { type: 'error' }); } });
					return;
				}
				if (pChoice !== 'mark') { return; }
				let tmpProvider = tmpProviders[pKey + 'API'];
				if (!tmpProvider || typeof tmpProvider.update !== 'function') { return; }
				tmpProvider.update(pIDAsBuilt, { Status: 'Validated', ValidatedDate: (new Date()).toISOString() }).then(() =>
				{
					if (tmpModal.toast) { tmpModal.toast('Validated. It can be promoted now.', { type: 'success' }); }
					if (tmpFromReleases)
					{
						let tmpReleasesView = this.pict.views['Plansheet-Releases'];
						if (tmpReleasesView) { tmpReleasesView.refresh(); }
					}
					else
					{
						this._navigate('/as-built/' + pIDAsBuilt);
					}
				}).catch(() => { if (tmpModal.toast) { tmpModal.toast('Could not mark it validated.', { type: 'error' }); } });
			});
		}).catch(() => { /* ignore */ });
	}

	// WI #305 Layer 3: suspend / resume a registered node through the gated endpoint (content.approve + logged),
	// so a person can stop a node from claiming any work at 2am from the board, without a terminal. Called from the
	// Make this blueprint the plan sheet's cover, from the Blueprints list -> a blueprint -> "Set as cover"
	// (WI #339 + #340). Any blueprint qualifies now, including the one an entity owns, which is what makes the
	// Blueprints screen the place to choose a representative sheet for the plan sheet. Called from the
	// Blueprint detail HeaderActions as (key, id). PUT /1.0/Plansheet/Cover with 0 clears it.
	setPlansheetCover(pKey, pIDBlueprint)
	{
		if (!pIDBlueprint) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		libFrameworkClient.putJSON(this.pict, '/1.0/Plansheet/Cover', { IDBlueprint: pIDBlueprint })
			.then((pBody) =>
			{
				if (!(pBody && pBody.Success)) { throw new Error((pBody && pBody.Error) || 'Could not set the cover.'); }
				// Keep the loaded org settings in step so the cover box and the plan-sheet cards do not go on
				// showing the previous choice until the next full load.
				if (this.pict.AppData.Org && this.pict.AppData.Org.Settings) { this.pict.AppData.Org.Settings.IDPrimaryBlueprint = pIDBlueprint; }
				if (tmpModal && tmpModal.toast) { tmpModal.toast('This blueprint is now the plan sheet cover.', { type: 'success' }); }
			})
			.catch((pError) =>
			{
				if (tmpModal && tmpModal.toast) { tmpModal.toast((pError && pError.message) || 'Could not set the cover.', { type: 'error' }); }
			});
	}

	// NodeRegistration detail HeaderActions as (key, id); a suspended node is refused by Run/DeployRequest ClaimNext.
	suspendNode(pKey, pIDNodeRegistration) { this._setNodeStatus(pIDNodeRegistration, 'Suspend'); }
	resumeNode(pKey, pIDNodeRegistration) { this._setNodeStatus(pIDNodeRegistration, 'Resume'); }

	_setNodeStatus(pIDNodeRegistration, pVerb)
	{
		if (!pIDNodeRegistration) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		fetch('/1.0/NodeRegistration/' + encodeURIComponent(pIDNodeRegistration) + '/' + pVerb,
			{ method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: '{}' })
			.then((pResponse) => pResponse.ok ? pResponse.json() : pResponse.json().then((pBody) => Promise.reject(pBody)))
			.then((pBody) =>
			{
				if (tmpModal && tmpModal.toast) { tmpModal.toast('Node ' + (pBody.NodeHost || '') + ' is now ' + (pBody.Status || (pVerb + 'd')) + '.', { type: 'success' }); }
				// Land on the list so the updated Status is visible across the fleet.
				this._navigate('/node-registrations');
			})
			.catch((pError) =>
			{
				if (tmpModal && tmpModal.toast) { tmpModal.toast((pError && pError.Error) || ('Could not ' + pVerb.toLowerCase() + ' the node.'), { type: 'error' }); }
			});
	}

	// Manual recovery on the Releases page (Issue #5). A machine can leave a record somewhere it can never leave
	// on its own: an As-Built whose commit landed in a sibling repo is skipped by every dev deploy and sits at
	// Built forever. Superseding retires the record, and the reason is required, so the row ends up saying who
	// gave up on it and why.
	//
	// There is deliberately no "mark it deployed" here. The only honest options are to retire the record or go
	// make it true; claiming a deploy that never happened is the exact failure this page exists to prevent.
	supersedeAsBuilt(pIDAsBuilt)
	{
		if (!pIDAsBuilt) { return; }
		this._closeStuckRecord(
		{
			URL: '/1.0/AsBuilt/' + encodeURIComponent(pIDAsBuilt) + '/Supersede',
			Title: 'Supersede this As-Built',
			Blurb: 'Superseding retires this record. It does not put the work on dev, and nothing on this page will bring it back.',
			Hint: 'Why is it being retired? For example: the commit landed in plansheet-mcp, so no app deploy will ever pick it up.',
			Confirm: 'Supersede',
			Done: 'Superseded. It is off the pending list.',
			Fail: 'Could not supersede it.'
		});
	}

	// The other exit from a stranded As-Built, and the one that was missing (WI #369). Supersede retires a
	// record; this one CORRECTS it, for the row whose work is provably already on dev and simply never got
	// stamped. The server refuses unless it can prove that from evidence a node wrote, so this asks for no
	// reason: the proof is the reason, and it goes onto the audit trail with the row.
	//
	// The page only offers this where the server said it would work, so a refusal here means the page was out
	// of date -- in which case the server's own sentence is what the person needs to read, not a generic error.
	rebindAsBuilt(pIDAsBuilt)
	{
		if (!pIDAsBuilt) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		tmpModal.show(
		{
			title: 'Rebind this As-Built',
			content: '<p style="font-size:13px;margin:0 0 8px;">This records that the work is on the dev sandbox, which the deploy '
				+ 'could not confirm for itself when it ran.</p>'
				+ '<p style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);margin:0;">It only goes through if the server can '
				+ 'still prove the commit is there. Nothing is deployed or rebuilt; the record is brought in line with what already shipped.</p>',
			buttons: [{ Hash: 'cancel', Label: 'Never mind' }, { Hash: 'confirm', Label: 'Rebind', Style: 'primary' }]
		}).then((pChoice) =>
		{
			if (pChoice !== 'confirm') { return; }
			fetch('/1.0/AsBuilt/' + encodeURIComponent(pIDAsBuilt) + '/Rebind',
				{ method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: '{}' })
				.then((pResponse) => pResponse.json().catch(() => ({})).then((pBody) =>
				{
					if (!pResponse.ok) { throw new Error((pBody && pBody.Error) || 'Could not rebind it.'); }
					return pBody;
				}))
				.then((pBody) =>
				{
					if (tmpModal.toast) { tmpModal.toast('Rebound to "' + ((pBody && pBody.Environment) || 'dev') + '". It is ready to validate.', { type: 'success' }); }
					let tmpReleasesView = this.pict.views['Plansheet-Releases'];
					if (tmpReleasesView) { tmpReleasesView.refresh(); }
				})
				.catch((pError) =>
				{
					if (tmpModal.toast) { tmpModal.toast((pError && pError.message) || 'Could not rebind it.', { type: 'error' }); }
				});
		});
	}

	// The deploy-queue twin: a node that died mid-run leaves its request Running with nothing alive to finish it.
	cancelDeployRequest(pIDDeployRequest)
	{
		if (!pIDDeployRequest) { return; }
		this._closeStuckRecord(
		{
			URL: '/1.0/DeployRequest/' + encodeURIComponent(pIDDeployRequest) + '/Cancel',
			Title: 'Cancel this deploy request',
			Blurb: 'Cancelling closes the request out. It does not stop a deploy that is genuinely still running on a node.',
			Hint: 'Why is it being cancelled? For example: the node died mid-run and nothing is left to finish it.',
			Confirm: 'Cancel the request',
			Done: 'Cancelled. The queue is clear.',
			Fail: 'Could not cancel it.'
		});
	}

	// Shared by both recovery actions: ask for a reason, refuse to send without one, POST, and refresh the page in
	// place so the row disappears under the person who cleared it. The reason is enforced on the server too; this
	// only saves a round trip.
	_closeStuckRecord(pOptions)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpDialogElement = null;
		let tmpDialog = tmpModal.show(
		{
			title: pOptions.Title,
			content: '<p style="font-size:13px;margin:0 0 8px;">' + pOptions.Blurb + '</p>'
				+ '<p style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);margin:0 0 6px;">' + pOptions.Hint + '</p>'
				+ '<textarea class="ps-recovery-reason" rows="3" style="width:100%;box-sizing:border-box;font:inherit;font-size:13px;'
				+ 'padding:6px 8px;border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;"></textarea>',
			buttons: [{ Hash: 'cancel', Label: 'Never mind' }, { Hash: 'confirm', Label: pOptions.Confirm, Style: 'primary' }],
			onOpen: (pDialog) => { tmpDialogElement = pDialog; }
		});
		tmpDialog.then((pChoice) =>
		{
			if (pChoice !== 'confirm') { return; }
			// Read the reason off the dialog element captured at open. The promise resolves as the dialog is torn
			// down, so the node may already be detached from the document, but it still holds what was typed.
			let tmpField = tmpDialogElement ? tmpDialogElement.querySelector('.ps-recovery-reason') : null;
			let tmpReason = tmpField ? String(tmpField.value || '').trim() : '';
			if (!tmpReason)
			{
				if (tmpModal.toast) { tmpModal.toast('A reason is required.', { type: 'error' }); }
				return;
			}
			fetch(pOptions.URL,
				{
					method: 'POST', credentials: 'same-origin',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ Reason: tmpReason })
				})
				.then((pResponse) => pResponse.json().catch(() => ({})).then((pBody) =>
				{
					// Surface what the server actually said (it refuses a promoted record, or an unentitled
					// person, by name) rather than a generic failure.
					if (!pResponse.ok) { throw new Error((pBody && pBody.Error) || pOptions.Fail); }
					return pBody;
				}))
				.then(() =>
				{
					if (tmpModal.toast) { tmpModal.toast(pOptions.Done, { type: 'success' }); }
					let tmpReleasesView = this.pict.views['Plansheet-Releases'];
					if (tmpReleasesView) { tmpReleasesView.refresh(); }
				})
				.catch((pError) =>
				{
					if (tmpModal.toast) { tmpModal.toast((pError && pError.message) || pOptions.Fail, { type: 'error' }); }
				});
		});
	}

	// A queue click that came back 409 means the lane was already busy: something is in flight for this
	// environment or this toolchain. That is not a failure, it is the answer, and the page it came from is
	// simply out of date. Say the server's own sentence in a neutral tone and refresh in place, so what is
	// on screen becomes true and the button that should not have been there is gone.
	//
	// Anything else really did fail, and keeps the error voice.
	_reportQueueResult(pError, pFallback, pViewIdentifier)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpBusy = (pError && pError.StatusCode === 409);
		if (tmpModal && tmpModal.toast)
		{
			// The busy sentence is longer than a normal toast and worth reading, so it gets more time.
			// Anything else takes the shell's default: toast() merges options over its defaults with
			// Object.assign, so passing duration: undefined would REPLACE the default with undefined and
			// the toast would never dismiss itself.
			let tmpOptions = { type: tmpBusy ? 'info' : 'error' };
			if (tmpBusy) { tmpOptions.duration = 6000; }
			tmpModal.toast(tmpBusy ? (pError.message || pFallback) : (pFallback + ': ' + ((pError && pError.message) || pError)), tmpOptions);
		}
		if (tmpBusy)
		{
			let tmpView = this.pict.views[pViewIdentifier];
			if (tmpView && typeof tmpView.refresh === 'function') { tmpView.refresh(); }
		}
	}

	// The operator override behind an in-flight lane. Same shape as _closeStuckRecord: ask for a reason,
	// refuse to send without one, then act and refresh in place. A reason is required on the server too;
	// this only saves a round trip.
	//
	// Queuing a second promote is genuinely harmless, so the reason is not there to argue anyone out of it.
	// It is there so the extra row is not silent about having been a deliberate exception.
	_forceQueue(pOptions)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpDialogElement = null;
		tmpModal.show(
		{
			title: pOptions.Title,
			content: '<p style="font-size:13px;margin:0 0 8px;">' + pOptions.Blurb + '</p>'
				+ '<p style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);margin:0 0 6px;">' + pOptions.Hint + '</p>'
				+ '<textarea class="ps-force-reason" rows="3" style="width:100%;box-sizing:border-box;font:inherit;font-size:13px;'
				+ 'padding:6px 8px;border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;"></textarea>',
			buttons: [{ Hash: 'cancel', Label: 'Never mind' }, { Hash: 'confirm', Label: pOptions.Confirm, Style: 'primary' }],
			onOpen: (pDialog) => { tmpDialogElement = pDialog; }
		}).then((pChoice) =>
		{
			if (pChoice !== 'confirm') { return; }
			let tmpField = tmpDialogElement ? tmpDialogElement.querySelector('.ps-force-reason') : null;
			let tmpReason = tmpField ? String(tmpField.value || '').trim() : '';
			if (!tmpReason)
			{
				if (tmpModal.toast) { tmpModal.toast('A reason is required.', { type: 'error' }); }
				return;
			}
			pOptions.Send(tmpReason).then(() =>
			{
				if (tmpModal.toast) { tmpModal.toast(pOptions.Done, { type: 'success' }); }
				let tmpView = this.pict.views[pOptions.View];
				if (tmpView && typeof tmpView.refresh === 'function') { tmpView.refresh(); }
			}).catch((pError) => this._reportQueueResult(pError, pOptions.Fail, pOptions.View));
		});
	}

	// Releases page: start a Deploy-to-dev run of the current trunk. A deploy node claims the run and its one
	// auto step enqueues the deploy, so the same deploy still runs on the node that holds the credentials -- the
	// run just makes its stage and progress visible on the Runs page. Deploy credentials live on the node.
	//
	// A 409 means a deploy-dev run is already in flight (its own single-flight lane). The Releases page hides
	// this button once the run's deploy request is in flight; there is a brief window after the click, before a
	// node claims the run, where the button is still shown -- the lane 409 makes a second click harmless.
	deployDev()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpAPI = this.pict.providers.RunAPI;
		if (!tmpAPI || typeof tmpAPI.startRun !== 'function') { return; }
		let fQueue = () => tmpAPI.startRun('deploy-dev', {}).then(() =>
		{
			if (tmpModal && tmpModal.toast) { tmpModal.toast('Queued a dev deploy run. Watch its progress on the Runs page.', { type: 'success' }); }
			let tmpView = this.pict.views['Plansheet-Releases']; if (tmpView) { tmpView.refresh(); }
		}).catch((pErr) => this._reportQueueResult(pErr, 'Could not queue the deploy', 'Plansheet-Releases'));
		if (!tmpModal || typeof tmpModal.show !== 'function') { return fQueue(); }
		tmpModal.show(
		{
			title: 'Deploy dev',
			content: '<p style="font-size:13px;margin:0;">Deploy the current trunk (origin/main) to the dev sandbox as a run you can watch on the Runs page. A deploy node runs it; nothing deploys from your browser.</p>',
			buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'go', Label: 'Queue dev deploy', Style: 'primary' }]
		}).then((pChoice) => { if (pChoice === 'go') { fQueue(); } });
	}

	// Releases page: start a Promote-to-production run. Offered whenever dev is running a commit production is
	// not -- As-Builts are the audit trail, not a gate, so an unvalidated (or As-Built-less) dev commit can
	// still be promoted (WI #330). This is a confirm; the run's step is auto, because pressing Promote here is
	// the human decision -- the gated promote lives on the full plansheet-software pipeline.
	//
	// Production takes one promotion at a time (the promote-prod run lane). While one is in flight this button
	// is replaced by what is in flight, so a promote can no longer be queued twice from a stale page.
	promoteToProd()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpAPI = this.pict.providers.RunAPI;
		if (!tmpAPI || typeof tmpAPI.startRun !== 'function') { return; }
		let fQueue = () => tmpAPI.startRun('promote-prod', {}).then(() =>
		{
			if (tmpModal && tmpModal.toast) { tmpModal.toast('Queued a promotion run. Watch its progress on the Runs page.', { type: 'success' }); }
			let tmpView = this.pict.views['Plansheet-Releases']; if (tmpView) { tmpView.refresh(); }
		}).catch((pErr) => this._reportQueueResult(pErr, 'Could not queue the promotion', 'Plansheet-Releases'));
		if (!tmpModal || typeof tmpModal.show !== 'function') { return fQueue(); }
		tmpModal.show(
		{
			title: 'Promote to production',
			content: '<p style="font-size:13px;margin:0;">Promote the current dev commit to production as a run you can watch on the Runs page. A deploy node runs it; nothing deploys from your browser.</p>',
			buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'go', Label: 'Promote to prod', Style: 'primary' }]
		}).then((pChoice) => { if (pChoice === 'go') { fQueue(); } });
	}

	// Start a promotion run past one already in flight. Offered only to someone with content.approve, and only
	// while a promotion is actually in flight, which is the only time the plain button is missing. Force plus a
	// written reason is what gets a run past the single-flight lane; it lands a run.forced beat on the timeline.
	promoteToProdAnyway()
	{
		let tmpAPI = this.pict.providers.RunAPI;
		if (!tmpAPI || typeof tmpAPI.startRun !== 'function') { return; }
		this._forceQueue(
		{
			Title: 'Promote anyway',
			Blurb: 'Production already has a promotion in flight. Starting a second one is harmless, and it will run after the first finishes.',
			Hint: 'Why start another? For example: the first one is stuck on a node that is not coming back, and it has been cancelled.',
			Confirm: 'Start it anyway',
			Done: 'Started. It runs after the one already in flight.',
			Fail: 'Could not start the promotion',
			View: 'Plansheet-Releases',
			Send: (pReason) => tmpAPI.startRun('promote-prod', { Force: true, Reason: pReason })
		});
	}

	// Runs page: queue a run of the chosen toolchain for a node to claim. Nothing executes here; the run
	// is a row with its steps snapshotted, and a node picks it up on its next tick.
	//
	// Takes the catalog INDEX rather than the key, so no tenant-authored string is ever interpolated
	// into the button's onclick (see the Runs-StartChain template for why that nesting is unsafe). The
	// key and name are read back out of AppData here, where they are values rather than markup.
	startToolchainRun(pCatalogIndex)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpAPI = this.pict.providers.RunAPI;
		if (!tmpAPI || typeof tmpAPI.startRun !== 'function') { return; }

		let tmpCatalog = ((this.pict.AppData.Runs || {}).Toolchains || []);
		let tmpChain = tmpCatalog[Number(pCatalogIndex)];
		if (!tmpChain || !tmpChain.Key)
		{
			// The catalog moved under the click (someone else adopted or retired one). Reload rather
			// than starting whatever now sits at that index.
			if (tmpModal && tmpModal.toast) { tmpModal.toast('That toolchain is no longer in the catalog. Refreshing.', { type: 'error' }); }
			let tmpStale = this.pict.views['Plansheet-Runs']; if (tmpStale) { tmpStale.refresh(); }
			return;
		}
		let tmpKey = tmpChain.Key;
		let tmpName = String(tmpChain.Name || tmpKey);
		// The modal renders its content as HTML, so the name has to be escaped on the way in.
		let tmpSafeName = tmpName.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

		let tmpGated = Number(tmpChain.GatedCount) || 0;
		let tmpShape = tmpChain.StepCount + ' step' + (tmpChain.StepCount === 1 ? '' : 's')
			+ (tmpGated ? (', ' + tmpGated + ' of which will stop and wait for your approval') : ', none of which need your approval');

		let fQueue = () => tmpAPI.startRun(tmpKey, {}).then(() =>
		{
			if (tmpModal && tmpModal.toast) { tmpModal.toast('Queued a run of ' + tmpName + '. A node will claim it and bring the gated steps here.', { type: 'success' }); }
			let tmpView = this.pict.views['Plansheet-Runs']; if (tmpView) { tmpView.refresh(); }
		}).catch((pErr) => this._reportQueueResult(pErr, 'Could not queue the run', 'Plansheet-Runs'));
		if (!tmpModal || typeof tmpModal.show !== 'function') { return fQueue(); }
		tmpModal.show(
		{
			title: 'Start a run of ' + tmpName,
			content: '<p style="font-size:13px;margin:0;">Queue a run of <strong>' + tmpSafeName + '</strong>: ' + tmpShape
				+ '. A node does the work; nothing runs from your browser.</p>',
			buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'go', Label: 'Start the run', Style: 'primary' }]
		}).then((pChoice) => { if (pChoice === 'go') { fQueue(); } });
	}

	// Start a run of a chain that already has one, on purpose. Takes the catalog index for the same reason
	// startToolchainRun does: an integer in that onclick cannot break out of the JS string it sits in.
	startToolchainRunAnyway(pCatalogIndex)
	{
		let tmpAPI = this.pict.providers.RunAPI;
		if (!tmpAPI || typeof tmpAPI.startRun !== 'function') { return; }
		let tmpCatalog = ((this.pict.AppData.Runs || {}).Toolchains || []);
		let tmpChain = tmpCatalog[Number(pCatalogIndex)];
		if (!tmpChain || !tmpChain.Key)
		{
			let tmpStale = this.pict.views['Plansheet-Runs']; if (tmpStale) { tmpStale.refresh(); }
			return;
		}
		this._forceQueue(
		{
			Title: 'Start another run of ' + String(tmpChain.Name || tmpChain.Key),
			Blurb: 'This toolchain already has a run in flight. A run waiting for someone to approve a step is still holding the chain, and a node will claim whichever run is next in line.',
			Hint: 'Why start another? For example: the run in flight is parked on a gate nobody is going to answer, and it is being rejected.',
			Confirm: 'Start it anyway',
			Done: 'Started. It queues behind the run already in flight.',
			Fail: 'Could not queue the run',
			View: 'Plansheet-Runs',
			Send: (pReason) => tmpAPI.startRun(tmpChain.Key, { Force: true, Reason: pReason })
		});
	}

	// Runs page: answer a gated step. This is the consent point the whole surface exists for, so it
	// confirms first and says plainly what approving will cause. The server gates it on content.approve.
	consentRunStep(pIDRunStep, pDecision)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpAPI = this.pict.providers.RunAPI;
		if (!tmpAPI || typeof tmpAPI.consent !== 'function') { return; }
		let tmpApprove = (pDecision === 'Approve');
		let fAnswer = () => tmpAPI.consent(pIDRunStep, tmpApprove ? 'Approve' : 'Reject', '').then(() =>
		{
			if (tmpModal && tmpModal.toast)
			{
				tmpModal.toast(tmpApprove ? 'Approved. The node runs this step on its next tick.' : 'Rejected. The run is closed.',
					{ type: tmpApprove ? 'success' : 'info' });
			}
			let tmpView = this.pict.views['Plansheet-Runs']; if (tmpView) { tmpView.refresh(); }
		}).catch((pErr) => { if (tmpModal && tmpModal.toast) { tmpModal.toast('Could not record the decision: ' + (pErr.message || pErr), { type: 'error' }); } });
		if (!tmpModal || typeof tmpModal.show !== 'function') { return fAnswer(); }
		tmpModal.show(
		{
			title: tmpApprove ? 'Approve this step' : 'Reject this step',
			content: tmpApprove
				? '<p style="font-size:13px;margin:0;">The node runs this step on its next tick, using the scope shown on the step. This is the point where the action happens.</p>'
				: '<p style="font-size:13px;margin:0;">The step is marked rejected and the run is closed. Nothing further runs.</p>',
			buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'go', Label: tmpApprove ? 'Approve' : 'Reject', Style: tmpApprove ? 'primary' : 'danger' }]
		}).then((pChoice) => { if (pChoice === 'go') { fAnswer(); } });
	}

	// Runs page: stop a run going wrong, without SSH-ing into the node (Work Item #451). This does not
	// kill anything from the browser -- it marks the run cancel-requested, and the node stops itself on
	// its own next heartbeat, closing the run Cancelled and parking whatever the session had committed
	// (WI #444) rather than losing it. The server answers a no-op (not an error) if nothing is actually
	// running by the time this reaches it.
	cancelRun(pIDRun)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpAPI = this.pict.providers.RunAPI;
		if (!tmpAPI || typeof tmpAPI.cancel !== 'function') { return; }
		let fStop = () => tmpAPI.cancel(pIDRun, 'stopped from the Runs page').then((pResult) =>
		{
			if (tmpModal && tmpModal.toast)
			{
				let tmpStopped = !!(pResult && pResult.Cancelled);
				tmpModal.toast(tmpStopped
					? 'Stop requested. The node ends the run within one heartbeat and parks any work it had committed.'
					: ((pResult && pResult.Reason) || 'Nothing to stop -- that run is no longer in progress.'),
					{ type: tmpStopped ? 'success' : 'info' });
			}
			let tmpView = this.pict.views['Plansheet-Runs']; if (tmpView) { tmpView.refresh(); }
		}).catch((pErr) => { if (tmpModal && tmpModal.toast) { tmpModal.toast('Could not stop the run: ' + (pErr.message || pErr), { type: 'error' }); } });
		if (!tmpModal || typeof tmpModal.show !== 'function') { return fStop(); }
		tmpModal.show(
		{
			title: 'Stop this run',
			content: '<p style="font-size:13px;margin:0;">The node ends it within one heartbeat. Anything the session already committed is preserved on its branch, not lost -- the run just stops going further.</p>',
			buttons: [{ Hash: 'cancel', Label: 'Never mind' }, { Hash: 'go', Label: 'Stop the run', Style: 'danger' }]
		}).then((pChoice) => { if (pChoice === 'go') { fStop(); } });
	}

	showRuns() { this._navigate('/runs'); }

	// Open the Feedback create form with prefilled values (SourceType + IDTestRun
	// from a finished run, or IDKeystoneCustomer from a customer page). Keys that
	// match descriptor Fields land in the form; the rest ride along hidden so the
	// FKs persist through save. The EntityList consumes the stash on its next
	// showEntity('Feedback').
	showNewFeedback(pPrefill)
	{
		this.pict.AppData.EntityListPrefill = { Key: 'Feedback', Values: Object.assign({}, pPrefill || {}) };
		// To the CREATE route, not the list route. This used to navigate to /feedback and then paint a
		// form over it, which needed a hand-rolled workaround for the case where you were already on
		// /feedback (Navigo does not re-fire the current route, so the handoff had to bypass it) -- and
		// it left the URL saying "list" while the pane held a half-filled form. /feedback/new is a
		// different URL from wherever you were, so the router does the work and the address bar is true.
		if (!this.showEntityNew('Feedback')) { this.pict.views['Plansheet-EntityList'].showEntity('Feedback'); }
	}

	// Public: route to the full-page doc editor (copy/paste-linkable, reloadable).
	// pDocPath is a Docs Lake path (may contain slashes); it rides the wildcard.
	showDocEditor(pOwnerType, pIDOwner, pDocPath)
	{
		this._navigate('/doc-edit/' + pOwnerType + '/' + (Number(pIDOwner) || 0) + '/' + String(pDocPath || ''));
	}

	// Route handler for /doc-edit/* : render the editor for the matched target.
	_renderDocEditor(pMatch)
	{
		this._setActiveNav('Docs');
		this._setPageTitle('Editing ' + this._docTitleFromPath(pMatch && pMatch.Path));
		this.pict.views['Plansheet-DocEditor'].showEditor(pMatch.OwnerType, pMatch.IDOwner, pMatch.Path);
	}

	showDrawingEditor(pContext, fOnInsert)
	{
		this.pict.views['Plansheet-DrawingEditor'].open(pContext, fOnInsert);
	}

	showFoundationDoc(pSlug)
	{
		let tmpPath = String(pSlug || ''); let tmpSection = '';
		let tmpHashIdx = tmpPath.indexOf('#');
		if (tmpHashIdx >= 0) { tmpSection = tmpPath.slice(tmpHashIdx + 1); tmpPath = tmpPath.slice(0, tmpHashIdx); }
		this._navigate('/docs/' + tmpPath + (tmpSection ? '::' + tmpSection : ''));
	}

	// Called by the docs view after the inline-doc section loads a document, so
	// the URL reflects what's on screen (without triggering a reload).
	syncDocURL(pPath, pSection)
	{
		if (!pPath) { return; }
		this._navigate('/docs/' + pPath + (pSection ? '::' + pSection : ''));
	}

	// ---- Navigation handlers called by views ----

	showAuth(pMode)
	{
		// Strip the app chrome (top bar + sidebar) so the sign-in screen stands on its own.
		if (typeof document !== 'undefined' && document.body) { document.body.classList.add('plansheet-auth-mode'); }
		if (this.pict.AppData.Auth)
		{
			this.pict.AppData.Auth.UISlot = this.pict.AppData.Auth.UISlot || {};
			this.pict.AppData.Auth.UISlot.Mode = (pMode === 'signup' || pMode === 'verify' || pMode === 'enroll') ? pMode : 'login';
		}
		this.pict.views['Plansheet-Auth'].render();
	}

	// Wire the magic-link engine's hooks into plansheet's auth state. onLoginSuccess bridges through
	// AuthClient.checkSession so AppData.Auth is populated exactly as a normal sign-in; a 2FA account hands
	// its challenge envelope to the existing 'verify' mode; a dead/expired link drops back to the login
	// screen with the reason.
	_wireMagicLogin()
	{
		let tmpView = this.pict.views['Plansheet-MagicLogin'];
		if (!tmpView) { return; }
		let tmpApp = this;
		tmpView.onLoginSuccess = function ()
		{
			// Mirror the normal post-checkSession sign-in sequence exactly: repaint the top-bar user chip out
			// of its guest state, enable 401 session recovery, honor the pinned plan sheet, then show the
			// workspace. (The earlier version skipped the top-bar repaint, so it kept showing "Sign in".)
			tmpApp.pict.providers.AuthClient.checkSession().then((pLoggedIn) =>
			{
				if (tmpApp.pict.views['Plansheet-TopBar-User']) { tmpApp.pict.views['Plansheet-TopBar-User'].render(); }
				if (pLoggedIn)
				{
					tmpApp._clearMagicHash();
					tmpApp._enableSessionRecovery();
					tmpApp._applyPinnedCustomerIfNeeded().then(() => tmpApp._showWorkspace());
				}
				else { tmpApp.showAuth('login'); }
			}).catch(() => tmpApp.showAuth('login'));
		};
		tmpView.onMagicLinkChallenge = function (pEnvelope)
		{
			let tmpEnv = pEnvelope || {};
			if (tmpApp.pict.AppData.Auth)
			{
				tmpApp.pict.AppData.Auth.PendingChallenge =
				{
					ChallengeToken: tmpEnv.ChallengeToken,
					Channel: tmpEnv.Channel,
					MaskedDestination: tmpEnv.MaskedDestination
				};
			}
			tmpApp._clearMagicHash();
			tmpApp.showAuth('verify');
		};
		tmpView.onLoginFailed = function (pError)
		{
			tmpApp._clearMagicHash();
			if (tmpApp.pict.AppData.Auth)
			{
				tmpApp.pict.AppData.Auth.UISlot = tmpApp.pict.AppData.Auth.UISlot || {};
				tmpApp.pict.AppData.Auth.UISlot.Error = [{ Message: pError || 'That sign-in link is no longer valid.' }];
			}
			tmpApp.showAuth('login');
		};
	}

	// Extract a magic-link token from the current URL hash (#/magic/<token>), or '' if none.
	_magicTokenFromURL()
	{
		if (typeof window === 'undefined' || !window.location) { return ''; }
		let tmpMatch = String(window.location.hash || '').match(/^#\/magic\/([^\/?#]+)/);
		return (tmpMatch && tmpMatch[1]) ? decodeURIComponent(tmpMatch[1]) : '';
	}

	// Verify a magic-link token: show the auth screen as a backdrop while the engine verifies, then its
	// hooks sign in / challenge / fail.
	_handleMagicLink(pToken)
	{
		this.showAuth('login');
		let tmpView = this.pict.views['Plansheet-MagicLogin'];
		if (!tmpView || typeof tmpView.verifyMagicLink !== 'function') { return; }
		tmpView.verifyMagicLink(pToken);
	}

	// Replace the #/magic/<token> URL with #/ so the one-time token does not linger in history or a reload.
	_clearMagicHash()
	{
		if (typeof window === 'undefined' || !window.history || !window.history.replaceState) { return; }
		try { window.history.replaceState(null, '', (window.location.pathname || '/') + (window.location.search || '') + '#/'); }
		catch (pErr) { /* no-op */ }
	}

	// --- Invite links (#/invite/<token>): auto-accept ---------------------------
	_inviteTokenFromURL()
	{
		if (typeof window === 'undefined' || !window.location) { return ''; }
		let tmpMatch = String(window.location.hash || '').match(/^#\/invite\/([^\/?#]+)/);
		return (tmpMatch && tmpMatch[1]) ? decodeURIComponent(tmpMatch[1]) : '';
	}

	// Handle a clicked invite link: accept immediately if already signed in; otherwise show the sign-in
	// screen (with context) and accept right after they sign in. The token is stashed across sign-in.
	_handleInviteToken(pToken)
	{
		this._PendingInviteToken = pToken;
		this.pict.providers.AuthClient.checkSession().then((pLoggedIn) =>
		{
			if (this.pict.views['Plansheet-TopBar-User']) { this.pict.views['Plansheet-TopBar-User'].render(); }
			if (pLoggedIn) { this._acceptPendingInvite(); }
			else { this._showInviteAuth(pToken); }
		}).catch(() => this._showInviteAuth(pToken));
	}

	// Signed out: show the sign-in screen and, best-effort, a toast with the invite's context. The pending
	// token stays stashed and is accepted by onAuthChanged once they sign in or sign up.
	_showInviteAuth(pToken)
	{
		this.showAuth('login');
		libFrameworkClient.getJSON(this.pict, '/1.0/Invitation/ByToken/' + encodeURIComponent(pToken)).then((pBody) =>
		{
			let tmpModal = this.pict.views['Pict-Section-Modal'];
			if (!tmpModal || typeof tmpModal.toast !== 'function') { return; }
			if (pBody && pBody.Valid && pBody.CustomerName)
			{
				tmpModal.toast('You are invited to ' + pBody.CustomerName + '. Sign in (or create an account) with ' + (pBody.Email || 'your email') + ' to join.', { type: 'info', duration: 8000 });
			}
			else if (pBody && pBody.Expired)
			{
				tmpModal.toast('That invitation has expired -- ask for a new one.', { type: 'error' });
			}
		}).catch(() => { /* context toast is best-effort */ });
	}

	// Accept the stashed invite token (the server reactivates/creates the persona and switches the session
	// into the plan sheet). On success, re-sync auth and show the plan sheet; on a mismatch/expiry, show the
	// app with the reason.
	_acceptPendingInvite()
	{
		let tmpToken = this._PendingInviteToken || '';
		this._PendingInviteToken = null;
		if (!tmpToken) { this._clearMagicHash(); this._showWorkspace(); return; }
		libFrameworkClient.postJSON(this.pict, '/1.0/Account/Invitations/AcceptByToken', { Token: tmpToken }).then(() =>
		{
			this._clearMagicHash();
			this.pict.providers.AuthClient.checkSession().then(() =>
			{
				if (this.pict.views['Plansheet-TopBar-User']) { this.pict.views['Plansheet-TopBar-User'].render(); }
				this._enableSessionRecovery();
				this._showWorkspace();
				let tmpModal = this.pict.views['Pict-Section-Modal'];
				if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('You joined the plan sheet.', { type: 'success' }); }
			});
		}).catch((pErr) =>
		{
			this._clearMagicHash();
			this._showWorkspace();
			let tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast((pErr && pErr.message) || 'Could not accept the invitation.', { type: 'error' }); }
		});
	}

	// The session browse surface: a normal entity list at #/sessions (the
	// calendar was retired). The vendored viewer calls this to back out -- the
	// Dropzone after an upload, the Layout's back button -- and it routes there so
	// the browser URL and history stay correct (the viewer/uploader are their own
	// routes, #/session/:id and #/sessions/upload).
	showSessions()
	{
		this._navigate('/sessions');
	}

	// Public: route to a stored session's viewer. The Session list's "Open" maps
	// here (the descriptor's OpenAction), so a session is copy/paste-linkable and
	// survives a reload; the route renders via openServerSession().
	showSession(pID)
	{
		this._navigate('/session/' + (Number(pID) || 0));
	}

	/**
	 * Render a parsed session into the workspace. Called by the section's
	 * loadSessionFromZip() (a calendar click) and by the Dropzone's local
	 * fallback path. The parser has already written the normalized session to
	 * AppData.Session; the vendored Layout owns #ClaudeTransformer-Workspace
	 * and builds the Signature / Timeline / Conversation sub-containers its
	 * siblings then fill.
	 */
	onSessionLoaded(pSession)
	{
		this.pict.views.Layout.updateLabels();
		this.pict.views.Layout.render();
		this.pict.views.Signature.render();
		this.pict.views.Timeline.render();
		this.pict.views.Conversation.render();
	}

	// Mount the session-viewer's container into the workspace via the Pict DOM
	// abstraction (ContentAssignment) instead of raw innerHTML.
	_mountTransformerContainer()
	{
		this.pict.ContentAssignment.assignContent('#Plansheet-Workspace',
			'<div id="ClaudeTransformer-Workspace" style="height:100%;display:flex;flex-direction:column"></div>');
	}

	// Center a spinner in the workspace while a session downloads + parses (a big
	// transcript takes a beat). The SVG animates on its own (SMIL), so this needs
	// no injected stylesheet; the viewer's first render replaces it.
	_showSessionLoading(pMessage)
	{
		let tmpHTML =
			'<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;color:var(--theme-color-text-secondary,#5b6376)">'
			+ '<svg width="36" height="36" viewBox="0 0 50 50" aria-hidden="true">'
			+ '<circle cx="25" cy="25" r="20" fill="none" stroke="var(--theme-color-border-default,#d8dde6)" stroke-width="5"></circle>'
			+ '<circle cx="25" cy="25" r="20" fill="none" stroke="var(--theme-color-brand-primary,#2988df)" stroke-width="5" stroke-linecap="round" stroke-dasharray="94 31">'
			+ '<animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite"></animateTransform>'
			+ '</circle></svg>'
			+ '<div style="font-size:14px">' + (pMessage || 'Loading...') + '</div>'
			+ '</div>';
		this.pict.ContentAssignment.assignContent('#ClaudeTransformer-Workspace', tmpHTML);
	}

	// Public: route to the session uploader (the Sessions list's "Upload session"
	// button maps here via the descriptor's CreateButton).
	showUploader()
	{
		this._navigate('/sessions/upload');
	}

	// Route handler for /sessions/upload: mount the dropzone in the workspace. A
	// signed-in user who drops a .zip has it uploaded to their account by the
	// Dropzone (via SessionAPI), which lands a new row and returns to the list.
	_renderUploader()
	{
		this._setActiveNav('Session');
		this._mountTransformerContainer();
		this.pict.views['Pict-Section-ClaudeTransformer'].showDropzone();
	}

	signOut()
	{
		// Close the mobile menu (or any open modal) before swapping to the auth screen; signing out
		// does not reload, so a lingering modal would otherwise cover the login.
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.dismissModals === 'function') { tmpModal.dismissModals(); }
		// Deliberate sign-out: disarm session recovery so the impending 401s do
		// not pop the re-auth modal over the login screen.
		this._disableSessionRecovery();
		this.pict.providers.AuthClient.logout().then(() =>
		{
			if (this.pict.views['Plansheet-TopBar-User']) this.pict.views['Plansheet-TopBar-User'].render();
			this.showAuth('login');
		});
	}

	onAuthChanged()
	{
		if (this.pict.views['Plansheet-TopBar-User']) this.pict.views['Plansheet-TopBar-User'].render();
		if (this.pict.AppData.Auth && this.pict.AppData.Auth.LoggedIn)
		{
			this._enableSessionRecovery();
			// If they signed in to accept an invitation (clicked an invite link while signed out), accept it
			// now -- it switches them into the plan sheet. Otherwise show the normal workspace.
			if (this._PendingInviteToken) { this._acceptPendingInvite(); }
			else { this._showWorkspace(); }
		}
		else
		{
			this.showAuth('login');
		}
	}

	/**
	 * Arm transparent session recovery: on a 401, the Fable RestClient behind
	 * EntityProvider awaits the in-place re-auth modal and replays the request.
	 * The hook is UI-agnostic in the framework; here we hand it the app's modal.
	 * Idempotent -- safe to call on every auth transition.
	 */
	_enableSessionRecovery()
	{
		let tmpRestClient = this._sessionRestClient();
		if (!tmpRestClient) { return; }
		let tmpReAuth = this.pict.views['Plansheet-ReAuth'];
		if (!tmpReAuth) { return; }
		// Stash the identity while the session is live -- the proactive check nulls
		// AppData.Auth.User on expiry, so the modal could not prefill without this.
		if (typeof tmpReAuth.rememberIdentity === 'function' && this.pict.AppData.Auth)
		{
			tmpReAuth.rememberIdentity(this.pict.AppData.Auth.User);
		}
		tmpRestClient.authenticationRecovery = () => tmpReAuth.ensure().then((pRecovered) =>
		{
			// However recovery was triggered (a 401 replay or the proactive
			// banner), a success clears any lingering expiry banner.
			if (pRecovered) { this._hideSessionExpiredBanner(); }
			return pRecovered;
		});
		// Proactive half of the story: notice expiry before the next click fails.
		this._installProactiveExpiryWatch();
	}

	/**
	 * Proactive expiry awareness (Layer 4). When the tab regains focus or becomes
	 * visible, re-check the session (debounced). If it lapsed while the page sat
	 * idle, drop a passive, non-blocking banner that opens the same in-place
	 * re-auth modal -- BEFORE the user's next click silently 401s. This also
	 * covers the <img>/blob 401 gap the fetch/RestClient hook cannot see.
	 * Idempotent; the listeners install once per app lifetime.
	 */
	_installProactiveExpiryWatch()
	{
		if (this._proactiveExpiryWatchInstalled) { return; }
		if (typeof window === 'undefined' || typeof document === 'undefined') { return; }
		this._proactiveExpiryWatchInstalled = true;

		let fCheck = () =>
		{
			// Only when the tab is actually visible, and only if we currently
			// believe we are signed in (so a deliberately signed-out user is left
			// alone).
			if (document.hidden) { return; }
			if (!(this.pict.AppData.Auth && this.pict.AppData.Auth.LoggedIn)) { return; }
			this.pict.providers.AuthClient.checkSession().then((pLoggedIn) =>
			{
				if (!pLoggedIn) { this._showSessionExpiredBanner(); }
			}).catch(() => { /* a failed check is not proof of expiry; stay quiet */ });
		};

		let tmpDebounceTimer = null;
		let fDebounced = () =>
		{
			if (tmpDebounceTimer) { clearTimeout(tmpDebounceTimer); }
			tmpDebounceTimer = setTimeout(fCheck, 500);
		};

		window.addEventListener('focus', fDebounced);
		document.addEventListener('visibilitychange', fDebounced);
	}

	/**
	 * A passive, dismissible banner announcing the session lapsed. Clicking it
	 * opens the in-place re-auth modal (the same ensure() the RestClient hook
	 * uses, so the two share one modal). Non-blocking: the page stays usable
	 * (reads just fail until re-auth), which is the honest state.
	 */
	_showSessionExpiredBanner()
	{
		if (typeof document === 'undefined') { return; }
		if (document.getElementById('Plansheet-SessionBanner')) { return; }

		let tmpBanner = document.createElement('div');
		tmpBanner.id = 'Plansheet-SessionBanner';
		tmpBanner.style.cssText =
			'position:fixed;top:0;left:0;right:0;z-index:10050;display:flex;align-items:center;gap:14px;'
			+ 'justify-content:center;padding:9px 16px;font-size:13px;font-family:-apple-system,Segoe UI,Roboto,sans-serif;'
			+ 'background:var(--theme-color-surface-raised,#2a2130);color:var(--theme-color-text,#f0e9ef);'
			+ 'border-bottom:1px solid var(--theme-color-brand-primary,#f0c44a);box-shadow:0 2px 10px rgba(0,0,0,0.28);';
		tmpBanner.innerHTML =
			'<span>Your session expired. Sign back in to keep your place.</span>'
			+ '<button id="Plansheet-SessionBanner-Signin" style="border:1px solid var(--theme-color-brand-primary,#f0c44a);background:var(--theme-color-brand-primary,#f0c44a);color:var(--theme-color-text-on-brand,#1a1206);border-radius:6px;padding:4px 12px;font-size:12.5px;font-weight:600;cursor:pointer;">Sign back in</button>'
			+ '<button id="Plansheet-SessionBanner-Dismiss" title="Dismiss" style="border:none;background:transparent;color:inherit;font-size:18px;line-height:1;cursor:pointer;opacity:0.7;">&times;</button>';
		document.body.appendChild(tmpBanner);

		let fSignin = document.getElementById('Plansheet-SessionBanner-Signin');
		if (fSignin)
		{
			fSignin.onclick = () =>
			{
				let tmpReAuth = this.pict.views['Plansheet-ReAuth'];
				if (!tmpReAuth) { this.showAuth('login'); return; }
				tmpReAuth.ensure().then((pRecovered) =>
				{
					// Recovered or handed off to the full screen -- either way the
					// banner has done its job.
					this._hideSessionExpiredBanner();
				});
			};
		}
		let fDismiss = document.getElementById('Plansheet-SessionBanner-Dismiss');
		if (fDismiss) { fDismiss.onclick = () => this._hideSessionExpiredBanner(); }
	}

	_hideSessionExpiredBanner()
	{
		if (typeof document === 'undefined') { return; }
		let tmpBanner = document.getElementById('Plansheet-SessionBanner');
		if (tmpBanner && tmpBanner.parentNode) { tmpBanner.parentNode.removeChild(tmpBanner); }
	}

	// Disarm recovery (deliberate sign-out). A null hook returns the framework to
	// its default pass-through: a 401 is handed back to the caller untouched.
	_disableSessionRecovery()
	{
		let tmpRestClient = this._sessionRestClient();
		if (tmpRestClient) { tmpRestClient.authenticationRecovery = null; }
		// A deliberate sign-out is not an expiry -- clear any banner too.
		this._hideSessionExpiredBanner();
	}

	// The single RestClient instance every migrated data path shares -- the one
	// auto-instantiated inside pict.EntityProvider. Wiring the recovery hook here
	// covers EntityProvider CRUD and any provider that issues custom calls through
	// this same client.
	_sessionRestClient()
	{
		return (this.pict.EntityProvider && this.pict.EntityProvider.restClient) || this.pict.RestClient || null;
	}

	/**
	 * Route handler for /session/:id. Downloads the zip and hands it to the viewer
	 * for rendering; the viewer's back button returns to the list via
	 * showSessions(). The Sessions list's "Open" reaches here through showSession
	 * (its descriptor OpenAction), so the URL is copy/paste-stable and reloadable.
	 */
	openServerSession(pIDSessionFile)
	{
		this._setActiveNav('Session');
		let tmpAPI = this.pict.providers.SessionAPI;
		// On a fresh deep-link / reload the session list has not loaded yet, so
		// make sure AppData.Sessions exists before recording the selection.
		tmpAPI.initializeAppData();
		this.pict.AppData.Sessions.SelectedID = pIDSessionFile;
		// Name the page after the session when its row is already in memory (came from the list);
		// on a cold deep-link the row is not loaded yet, so fall back to a generic "Session".
		let tmpSessionRow = (this.pict.AppData.Sessions.Index && this.pict.AppData.Sessions.Index[pIDSessionFile]) || null;
		this._setPageTitle((tmpSessionRow && tmpSessionRow.Title) || 'Session');

		// Swap the workspace contents for the section's container and show a
		// spinner straight away, then ask the section to render. The section's
		// Layout view replaces the container content with the per-session UI once
		// the blob has downloaded and parsed.
		this._mountTransformerContainer();
		this._showSessionLoading('Opening session...');

		tmpAPI.downloadSessionBlob(pIDSessionFile).then((pBuffer) =>
		{
			this.pict.views['Pict-Section-ClaudeTransformer'].loadSessionFromZip(pBuffer, (pErr) =>
			{
				if (pErr)
				{
					let tmpModal = this.pict.views['Pict-Section-Modal'];
					if (tmpModal) tmpModal.toast('Failed to load session: ' + (pErr.message || pErr), { type: 'error', duration: 6000 });
					this.showSessions();
				}
			});
		}).catch((pErr) =>
		{
			let tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal) tmpModal.toast('Could not download session: ' + (pErr.message || pErr), { type: 'error', duration: 6000 });
			this.showSessions();
		});
	}
}

module.exports = PictApplicationPlansheet;

module.exports.default_configuration =
{
	Name: 'Plansheet',
	Hash: 'Plansheet'
};

},{"./CandidateSearch.js":554,"./EntityDescriptors.js":555,"./FeedbackPicker.js":557,"./Plansheet-Brand-Chrome.js":564,"./Plansheet-Brand.js":565,"./PlansheetIcons.js":567,"./SiteMap.js":571,"./providers/FrameworkClient.js":576,"./providers/Moodboard-DrawingSource.js":577,"./providers/Moodboard-MediaImageSource.js":578,"./providers/Moodboard-StickerSource.js":579,"./providers/Pict-Provider-AskAPI.js":580,"./providers/Pict-Provider-AuthClient.js":581,"./providers/Pict-Provider-BlueprintAPI.js":582,"./providers/Pict-Provider-BoardAPI.js":583,"./providers/Pict-Provider-CallDeskAPI.js":584,"./providers/Pict-Provider-ChecklistAPI.js":585,"./providers/Pict-Provider-CommentAPI.js":586,"./providers/Pict-Provider-CommentThreadAPI.js":587,"./providers/Pict-Provider-ConnectionsAPI.js":588,"./providers/Pict-Provider-DeliverableBoardAPI.js":589,"./providers/Pict-Provider-DeployAPI.js":590,"./providers/Pict-Provider-DocLakeAPI.js":591,"./providers/Pict-Provider-DocSyncAPI.js":592,"./providers/Pict-Provider-EntityAPI.js":593,"./providers/Pict-Provider-FeatureBoardAPI.js":594,"./providers/Pict-Provider-IssueBoardAPI.js":595,"./providers/Pict-Provider-LaneAPI.js":596,"./providers/Pict-Provider-LinkAPI.js":597,"./providers/Pict-Provider-LoopsAPI.js":598,"./providers/Pict-Provider-Markup.js":599,"./providers/Pict-Provider-MediaAPI.js":600,"./providers/Pict-Provider-MessageAPI.js":601,"./providers/Pict-Provider-MoodboardAPI.js":602,"./providers/Pict-Provider-NotebookAPI.js":603,"./providers/Pict-Provider-OpsAPI.js":604,"./providers/Pict-Provider-OrgAPI.js":605,"./providers/Pict-Provider-PhotoAPI.js":606,"./providers/Pict-Provider-ProfileBlockAPI.js":607,"./providers/Pict-Provider-PromptAPI.js":608,"./providers/Pict-Provider-RoutineStepAPI.js":609,"./providers/Pict-Provider-RunAPI.js":610,"./providers/Pict-Provider-SessionAPI.js":611,"./providers/Pict-Provider-ShapesAPI.js":612,"./providers/Pict-Provider-StickerAPI.js":613,"./providers/Pict-Provider-StickerSetAPI.js":614,"./providers/Pict-Provider-TeamAPI.js":615,"./providers/Pict-Provider-TestRunAPI.js":616,"./providers/Pict-Provider-TestRunStepAPI.js":617,"./providers/Pict-Provider-TokenAPI.js":618,"./providers/Pict-Provider-UserAPI.js":619,"./providers/Pict-Provider-WorkflowAPI.js":620,"./providers/PlansheetCommentProvider.js":622,"./providers/PlansheetPromptProvider.js":623,"./themes/1990s-website.json":624,"./themes/cyberpunk.json":625,"./themes/high-contrast.json":626,"./themes/london-subway.json":627,"./themes/neo-tokyo.json":628,"./themes/nostalgia.json":629,"./themes/plain.json":630,"./themes/plansheet-blueprint.json":631,"./themes/plansheet-paper.json":632,"./themes/plansheet.json":633,"./themes/southwest-desert-canyon.json":634,"./themes/southwest-desert-day.json":635,"./themes/southwest-desert-dusk.json":636,"./themes/southwest-desert-sunset.json":637,"./vendor/claudetransformer/Pict-Provider-SessionExporter.js":638,"./vendor/claudetransformer/Pict-Provider-SessionParser.js":639,"./vendor/claudetransformer/PictView-AgentDetail.js":640,"./vendor/claudetransformer/PictView-ClaudeTransformer-Section.js":641,"./vendor/claudetransformer/PictView-Conversation.js":642,"./vendor/claudetransformer/PictView-Dropzone.js":643,"./vendor/claudetransformer/PictView-Layout.js":644,"./vendor/claudetransformer/PictView-Signature.js":645,"./vendor/claudetransformer/PictView-Timeline.js":646,"./vendor/claudetransformer/PictView-ToolDetail.js":647,"./views/PictView-AboutMeEditor.js":651,"./views/PictView-Ask.js":652,"./views/PictView-Auth.js":653,"./views/PictView-Blueprint.js":654,"./views/PictView-BlueprintComposer.js":655,"./views/PictView-BlueprintStudio.js":656,"./views/PictView-Board.js":657,"./views/PictView-BookmarksPage.js":658,"./views/PictView-CallDesk.js":659,"./views/PictView-CapabilityActivation.js":660,"./views/PictView-Checklists.js":661,"./views/PictView-Community.js":662,"./views/PictView-Connections.js":663,"./views/PictView-DeliverableBoard.js":664,"./views/PictView-DocEditor.js":665,"./views/PictView-DrawingEditor.js":666,"./views/PictView-DrawingsPage.js":667,"./views/PictView-EntityDetail.js":668,"./views/PictView-EntityList.js":669,"./views/PictView-FeatureBoard.js":670,"./views/PictView-FieldCodeEditor.js":671,"./views/PictView-FieldMarkdownEditor.js":672,"./views/PictView-FoundationDocs.js":673,"./views/PictView-GalleryPage.js":674,"./views/PictView-HelpDrawer.js":675,"./views/PictView-Home.js":676,"./views/PictView-IssueBoard.js":677,"./views/PictView-LoopsMarkdownEditor.js":678,"./views/PictView-MediaViewer.js":679,"./views/PictView-Notebook.js":680,"./views/PictView-NotebookNoteEditor.js":681,"./views/PictView-NotesPage.js":682,"./views/PictView-NotesPageEditor.js":683,"./views/PictView-OpsConsole.js":684,"./views/PictView-OrgActivity.js":685,"./views/PictView-Profile.js":686,"./views/PictView-Project.js":687,"./views/PictView-ProjectTypes.js":688,"./views/PictView-PromptAttachments.js":689,"./views/PictView-PromptLibrary.js":690,"./views/PictView-PromptShapes.js":691,"./views/PictView-Rail.js":692,"./views/PictView-ReAuth.js":693,"./views/PictView-Releases.js":694,"./views/PictView-RichDocEditor.js":695,"./views/PictView-RoutineSteps.js":696,"./views/PictView-Runs.js":697,"./views/PictView-Shell.js":698,"./views/PictView-StickerSetsPreview.js":699,"./views/PictView-SystemActivity.js":700,"./views/PictView-TestRunner.js":701,"./views/PictView-TopBar-Nav.js":702,"./views/PictView-TopBar-User.js":703,"./views/PictView-UserSettings.js":704,"./views/PictView-VisionLoops.js":705,"./views/PictView-Whiteboards.js":706,"./views/PictView-Workflow.js":707,"./workspaces/NodeWorkspace.js":708,"pict-application":147,"pict-router":178,"pict-section-activitygraph":181,"pict-section-comments":191,"pict-section-content":196,"pict-section-inlinedocumentation":247,"pict-section-login":254,"pict-section-modal":271,"pict-section-moodboard":272,"pict-section-navigation":282,"pict-section-picker":289,"pict-section-prompteditor":292,"pict-section-theme":300,"retold-workflow/source/Retold-Workflow-Views.js":507}],564:[function(require,module,exports){
'use strict';

/**
 * Plansheet brand chrome.
 *
 * One stylesheet, registered over the Pict CSS cascade at a high priority, that
 * gives the whole app the drafting-sheet feel the marketing site has: Gorton
 * Perfected (the proportional revival of engraving instrument lettering) on the
 * "drafting layer" only -- headings, navigation, buttons, badges, table heads,
 * tabs, the top bar, the sign-in wordmark -- set uppercase and letterspaced the
 * way drawing lettering is. Body copy, form values, and long prose stay on the
 * readable system sans the themes already define.
 *
 * It rides on top of every palette (Plan Sheet, Blueprint, Drafting Paper, and
 * the kit themes), so it only ever references theme color tokens, never a fixed
 * color. The exceptions are the corners and borders: sheets have crisp corners
 * and visible linework, so the brand layer squares the rounded pills the stock
 * chrome ships with and firms up a few borders. Amber stays measurement ink and
 * is left to the themes.
 *
 * Registered from the Application:
 *   this.pict.CSSMap.addCSS('Plansheet-Brand-Chrome', libBrandChrome, 1200);
 * Priority 1200 sits above the pict-view default CSS priority (1000), so
 * equal-specificity chrome rules win on the cascade -- including the body
 * content font, which the Shell view also declares.
 */

module.exports = /*css*/`
/* ---- The drafting face: Gorton Perfected (commercial, self-hosted) ------ */
/* The proportional revival of the engraving lettering -- five weights so the
   drafting layer can range from hairline display to bold labels. */

@font-face
{
	font-family: 'Gorton Perfected';
	src: url('/fonts/GortonPerfected-Light.woff2') format('woff2');
	font-weight: 300;
	font-display: swap;
}
@font-face
{
	font-family: 'Gorton Perfected';
	src: url('/fonts/GortonPerfected-Regular.woff2') format('woff2');
	font-weight: 400;
	font-display: swap;
}
@font-face
{
	font-family: 'Gorton Perfected';
	src: url('/fonts/GortonPerfected-Medium.woff2') format('woff2');
	font-weight: 500;
	font-display: swap;
}
@font-face
{
	font-family: 'Gorton Perfected';
	src: url('/fonts/GortonPerfected-Semibold.woff2') format('woff2');
	font-weight: 600;
	font-display: swap;
}
@font-face
{
	font-family: 'Gorton Perfected';
	src: url('/fonts/GortonPerfected-Bold.woff2') format('woff2');
	font-weight: 700;
	font-display: swap;
}

/* ---- The content face: IBM Plex Sans (SIL OFL) ------------------------- */
/* The companion to Gorton: a technical text sans for everything you read --
   body copy, the navigation rail, table cells, typed values. Self-hosted. */

@font-face
{
	font-family: 'IBM Plex Sans';
	src: url('/fonts/IBMPlexSans-Regular.woff2') format('woff2');
	font-weight: 400;
	font-display: swap;
}
@font-face
{
	font-family: 'IBM Plex Sans';
	src: url('/fonts/IBMPlexSans-Medium.woff2') format('woff2');
	font-weight: 500;
	font-display: swap;
}
@font-face
{
	font-family: 'IBM Plex Sans';
	src: url('/fonts/IBMPlexSans-SemiBold.woff2') format('woff2');
	font-weight: 600;
	font-display: swap;
}

:root
{
	--plansheet-gorton: 'Gorton Perfected', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
	--plansheet-content: 'IBM Plex Sans', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* The three-role type system: Gorton for the drafting layer (rules below),
   Plex for everything read, mono for data and code (left to the themes).
   Body sets the content face once; most surfaces inherit it. The 'html body'
   selector (specificity 0,0,2) is deliberate: the Shell view declares a bare
   'body' font-family in its own injected stylesheet, and specificity wins that
   tie regardless of stylesheet order. */

html body { font-family: var(--plansheet-content); }

.ps-input, .ps-input-sm,
.cst-auth-field input,
.cst-set-input,
textarea, select
{
	font-family: var(--plansheet-content);
}

/* ---- Headings: the labels on the sheet --------------------------------- */
/* Mirrors the view selectors so it wins on the cascade at equal specificity.
   1.5px is enough to read as drawing lettering without spreading long,
   multi-word titles ("Organization Prompt Shapes") into the margins. */

.ps-list-head h2,
.ps-board-head h2,
.ps-form h3,
.cst-auth-title,
.cst-set-h,
.cst-set-h3,
.ppl-subhead,
.pps h2, .pps h3,
.ppl-detail-head h3,
.cmty-h1,
.cst-list-title,
.cst-cal-title,
.ps-page-h
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1.5px;
	font-weight: 700;
}

/* A page title for views that ship without one (Workflow, Prompt Library):
   self-contained size + rhythm so it sits like the Board / Roles titles. */
.ps-page-h
{
	font-size: 22px;
	margin: 0 0 14px;
	color: var(--theme-color-text-primary, currentColor);
}

/* Rendered markdown headings (the documentation reader, and any other
   markdown surface) take the display face too, but keep the author's case
   and a light touch -- these are prose headings, not stamped labels. */
.pict-content h1, .pict-content h2, .pict-content h3,
.pict-content h4, .pict-content h5, .pict-content h6
{
	font-family: var(--plansheet-gorton);
	letter-spacing: 0.3px;
}

/* The documentation content area is prose-styled (readable max-width + generous
   padding) for READING. When it hosts the markdown editor, drop those
   constraints so the editor fills the available width instead of sitting in a
   narrow prose column. (Line wrapping itself is handled inside the editor.) */
.pict-inline-doc-content:has(.pict-mde)
{
	max-width: none;
	padding: 12px 16px;
}

/* ---- The top bar: the drafting title block ----------------------------- */
/* The bar reads as the top cell of the sheet. The brand mark (left) and the
   account chip (right) are both drawn as bordered title-block cells -- a stamp
   cell and a label cell divided by linework -- so they mirror each other and
   echo the lockup on the marketing site. The seam below the bar is crisp
   drawing linework, never a colored accent. Everything here references theme
   tokens, so it follows whatever palette is active. */

/* One crisp linework seam, the bottom edge of the top cell. The selectors the
   theme ships for these land in a later stylesheet, so the brand layer has to
   out-specify them (ID scope), not just outrank them by CSSMap priority. */
#Theme-TopBar > .pict-theme-topbar
{
	border-bottom: 1.5px solid var(--theme-color-border-strong, var(--theme-color-border-default, currentColor));
}

/* pict-section-theme paints a two-tone brand-color accent stripe under the bar
   (the old teal-over-orange). Drop it; the linework seam above is the divider. */
#Theme-TopBar .pict-theme-topbar::after
{
	display: none;
}

/* Left lockup: the brand mark as a two-cell title block -- the P stamp in its
   own cell, the wordmark in the next. */
.pict-theme-brand-mark
{
	height: 32px;
	box-sizing: border-box;
	border: 1.5px solid var(--theme-color-border-strong, currentColor);
	border-radius: 2px;
	gap: 0;
	padding: 0;
	overflow: hidden;
	align-items: stretch;
	cursor: pointer;
}
.pict-theme-brand-mark-icon
{
	display: inline-flex;
	align-items: center;
	padding: 0 7px;
	border-right: 1.5px solid var(--theme-color-border-strong, currentColor);
}
.pict-theme-brand-mark .pict-theme-brand-mark-name
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 4px;
	font-weight: 700;
	font-size: 14px;
	border-bottom: 0;
	/* right pad is lighter than left to absorb the trailing letter-spacing */
	padding: 0 7px 0 11px;
	display: inline-flex;
	align-items: center;
	color: var(--theme-color-text-primary, currentColor);
}

.cst-nav,
.pict-theme-topbar-nav
{
	font-family: var(--plansheet-gorton);
	letter-spacing: 1.5px;
}

/* Right chip: the account cell, drawn to match the lockup -- a label cell
   (your name) and a stamp cell (your avatar), divided by linework. The order
   puts the stamp on the outer edge, mirroring the P on the left. */
#Theme-TopBar-User .cst-user-chip
{
	font-family: var(--plansheet-gorton);
	height: 32px;
	align-self: center;
	border: 1.5px solid var(--theme-color-border-strong, currentColor);
	border-radius: 2px;
	gap: 0;
	padding: 0;
	overflow: hidden;
	align-items: stretch;
}
#Theme-TopBar-User .cst-user-chip .cst-user-name
{
	order: 1;
	text-transform: uppercase;
	letter-spacing: 1.5px;
	font-size: 12px;
	padding: 0 11px;
	max-width: 180px;
	display: inline-flex;
	align-items: center;
	color: var(--theme-color-text-primary, currentColor);
}
#Theme-TopBar-User .cst-user-chip .cst-user-avatar
{
	order: 2;
	padding: 0 7px;
	border-left: 1.5px solid var(--theme-color-border-strong, currentColor);
	display: inline-flex;
	align-items: center;
}

/* ---- Navigation rail: group labels drawn, items read ------------------- */
/* The WORKSPACE / PLAN / DESIGN group headers are drafting labels (Gorton,
   uppercase, letterspaced). The item names and descriptions are content the
   reader scans, so they inherit the Plex content face from body. */

.pict-nav-sb-group-head
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1.5px;
}
.pict-nav-sb-item-name { font-weight: 500; }

/* ---- Buttons: square, engraved ----------------------------------------- */

.ps-btn, .ps-btn-sm,
.cst-auth-button,
.cst-set-btn, .cst-set-btn-secondary,
.ppl-btn,
.pps-btn,
.ppa-btn,
.cst-acct-act,
.tsr-btn
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1px;
	border-radius: 3px;
}

/* ---- Inputs: crisp corners, value text stays readable ------------------ */

.ps-input, .ps-input-sm,
.cst-auth-field input,
.cst-set-input,
.ppl-card, .ppl-shared-detail,
.ps-card,
.cst-auth-card,
.cst-set-section
{
	border-radius: 3px;
}

/* Field labels join the drafting layer. */
.cst-auth-field label,
.cst-set-label,
.ps-form label
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1.2px;
	font-size: 11px;
}

/* ---- Badges: stamped, not pill-shaped ---------------------------------- */

.ps-cell-badge,
.ps-card-kind, .ps-card-pri,
.ps-lane-count,
.ppl-badge,
.ppa-badge,
.pps-badge
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1px;
	border-radius: 2px;
}

/* ---- Tables: a register, not a card ------------------------------------ */

.ps-table { border-radius: 0; border: 1.5px solid var(--theme-color-border-strong, var(--theme-color-border-default, currentColor)); }
.ps-table th
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1.5px;
}

/* ---- Board: lanes read as columns on a sheet --------------------------- */

.ps-board-head h2 { letter-spacing: 2px; }
.ps-lane-title, .ps-lane-head
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1px;
}
.ps-card { border-radius: 3px; }

/* ---- Prompt library tabs ----------------------------------------------- */

.ppl-tab
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1px;
}

/* The embedded prompt editor (pict-section-prompteditor >= 1.1.1) self-themes
   from the theme's display-font tokens (Typography.Family.Display + the
   Typography.Display treatment block in source/themes/plansheet.json), so its
   titles need no app-side rule here. Other embedded controls can adopt the same
   var(--theme-typography-family-display, ...) pattern to follow the brand. */

/* ---- The sign-in wordmark: the lockup ---------------------------------- */

.cst-auth-wordmark
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 5px;
	font-weight: 700;
}

/* No word-spacing correction: Gorton Perfected is a proportional face with a
   normal space (measured ~0.30em). The free Open Gorton we prototyped with had
   a ~0.74em keycap space that needed a big negative word-spacing; Perfected
   does not. Do not re-add that hack against this font -- it would collide. */

/* ═══ Documentation reading experience ═══════════════════════════════════
   The Foundational Documentation reader (.ps-fdocs) renders markdown into a
   wrapper that carries BOTH .pict-content and .pict-inline-doc-content. Those
   two dependency layers hand it a system body font, a full-bleed measure, and
   tight rhythm. Scoping under .ps-fdocs lets these rules out-specify both
   layers (two classes beats one) and give the docs an intentional, on-brand
   reading column: Plex for the prose, Gorton for the labels, a comfortable
   measure, and drafting linework. Everything is token-based, so light, dark,
   and the costume themes all re-skin. Other markdown surfaces (notebook, help
   drawer, editor preview) are left to a later pass on purpose. */

.ps-fdocs .pict-content
{
	font-family: var(--plansheet-content);
	font-size: 16px;
	line-height: 1.72;
	color: var(--theme-color-text-primary, #2B2D2F);
	max-width: 52rem;
	margin: 0 auto;
	padding: 2.4rem 2.8rem 4.5rem;
	-webkit-font-smoothing: antialiased;
	text-rendering: optimizeLegibility;
}
.ps-fdocs .pict-content > :first-child { margin-top: 0; }
.ps-fdocs .pict-content p { margin: 0 0 1.15em; }
.ps-fdocs .pict-content strong { font-weight: 600; color: var(--theme-color-text-primary, #2B2D2F); }

/* Headings: labels on the sheet. h1/h2 close with a hairline; h4 and below
   drop to small uppercase drafting sublabels. Author case is kept. */
.ps-fdocs .pict-content h1
{
	font-family: var(--plansheet-gorton);
	font-size: 2em; font-weight: 700; line-height: 1.15; letter-spacing: 0.3px;
	margin: 0 0 0.7em; padding-bottom: 0.3em;
	border-bottom: 1.5px solid var(--theme-color-border-strong, #BDB4A4);
	color: var(--theme-color-text-primary, #2B2D2F);
}
.ps-fdocs .pict-content h2
{
	font-family: var(--plansheet-gorton);
	font-size: 1.5em; font-weight: 700; line-height: 1.2; letter-spacing: 0.2px;
	margin: 2.2em 0 0.6em; padding-bottom: 0.28em;
	border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
	color: var(--theme-color-text-primary, #2B2D2F);
}
.ps-fdocs .pict-content h3
{
	font-family: var(--plansheet-gorton);
	font-size: 1.22em; font-weight: 700; line-height: 1.25; letter-spacing: 0.2px;
	margin: 1.9em 0 0.5em; color: var(--theme-color-text-primary, #2B2D2F);
}
.ps-fdocs .pict-content h4
{
	font-family: var(--plansheet-gorton);
	font-size: 0.82em; font-weight: 700; text-transform: uppercase; letter-spacing: 1.3px;
	margin: 1.8em 0 0.5em; color: var(--theme-color-text-secondary, #5E5549);
}
.ps-fdocs .pict-content h5, .ps-fdocs .pict-content h6
{
	font-family: var(--plansheet-gorton);
	font-size: 0.78em; font-weight: 700; text-transform: uppercase; letter-spacing: 1px;
	margin: 1.6em 0 0.4em; color: var(--theme-color-text-muted, #8A8F99);
}

/* Links: brand-primary with a restrained underline that firms on hover. */
.ps-fdocs .pict-content a
{
	color: var(--theme-color-brand-primary, #1D5FA8);
	text-decoration: underline;
	text-decoration-thickness: 1px;
	text-underline-offset: 2px;
	text-decoration-color: color-mix(in srgb, var(--theme-color-brand-primary, #1D5FA8) 42%, transparent);
}
.ps-fdocs .pict-content a:hover { text-decoration-color: currentColor; text-decoration-thickness: 2px; }

/* Lists */
.ps-fdocs .pict-content ul, .ps-fdocs .pict-content ol { margin: 0 0 1.15em; padding-left: 1.6em; line-height: 1.7; }
.ps-fdocs .pict-content li { margin: 0.3em 0; }
.ps-fdocs .pict-content li::marker { color: var(--theme-color-text-muted, #8A8F99); }
.ps-fdocs .pict-content li > ul, .ps-fdocs .pict-content li > ol { margin: 0.3em 0; }

/* Code surfaces: a clean, cool, bright plate instead of the warm tan tertiary, which reads as dingy in
   the light palette. The colors are theme variables set on the reader root, so the block-code reset keeps
   its specificity and dark gets a proper dark plate without a per-rule override. */
.ps-fdocs
{
	--ps-code-chip-bg:   #EEF1F6;
	--ps-code-plate-bg:  #F5F7FA;
	--ps-code-gutter-bg: #ECEFF4;
	--ps-code-border:    #E2E5EC;
}
/* Light reader: re-skin the warm tan surfaces to a clean, professional neutral. Scoped to the docs
   reader and to light mode, so the warm app chrome and the dark theme are untouched. Redefining the
   theme background + border tokens here cascades the clean palette to the ToC tree, the reading
   surface, the hairlines, tables, and hover states in one move. */
html.theme-light .ps-fdocs
{
	--theme-color-background-panel:     #FFFFFF;
	--theme-color-background-secondary: #F5F6F8;
	--theme-color-background-tertiary:  #EFF1F4;
	--theme-color-background-hover:     #F1F3F6;
	--theme-color-border-light:         #ECEEF1;
	--theme-color-border-default:       #E3E5E9;
	--theme-color-border-strong:        #CDD1D9;
}
html.theme-dark .ps-fdocs
{
	--ps-code-chip-bg:   #242B35;
	--ps-code-plate-bg:  #1D222B;
	--ps-code-gutter-bg: #171C24;
	--ps-code-border:    #2E3640;
}
/* Inline code: a bright chip that highlights the token. */
.ps-fdocs .pict-content code
{
	font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
	font-size: 0.86em;
	background: var(--ps-code-chip-bg, #F5F7FB);
	border: 1px solid color-mix(in srgb, var(--theme-color-brand-primary, #4F95E8) 20%, var(--ps-code-border, #DEE3EC));
	color: var(--theme-color-text-primary, #2B2D2F);
	padding: 0.08em 0.4em;
	border-radius: 4px;
}
/* Code block plate: wrap + pre share the plate surface, the gutter sits a touch deeper, the border is a
   clean neutral -- overriding the dependency's warm tan. */
.ps-fdocs .pict-content .pict-content-code-wrap,
.ps-fdocs .pict-content .pict-content-code-wrap pre
{
	background: var(--ps-code-plate-bg, #F1F4F9);
}
.ps-fdocs .pict-content .pict-content-code-line-numbers { background: var(--ps-code-gutter-bg, #E8ECF3); }
.ps-fdocs .pict-content .pict-content-code-wrap { border-color: var(--ps-code-border, #DEE3EC); }

/* Code blocks: the dependency's .pict-content-code-wrap already draws the framed,
   rounded plate (border + background), so the container only owns the vertical
   rhythm. Adding a second border here was the "double box". Hold every part of the
   line-number row at one size + leading so the gutter stays aligned (below). */
.ps-fdocs .pict-content .pict-content-code-container
{
	margin: 1.2em 0;
}
.ps-fdocs .pict-content .pict-content-code-wrap,
.ps-fdocs .pict-content .pict-content-code-wrap pre,
.ps-fdocs .pict-content .pict-content-code-wrap code,
.ps-fdocs .pict-content .pict-content-code-line-numbers,
.ps-fdocs .pict-content .pict-content-code-line-numbers span
{
	font-size: 13px;
	line-height: 1.6;
}
.ps-fdocs .pict-content .pict-content-code-wrap code,
.ps-fdocs .pict-content pre code
{
	background: none; border: 0; padding: 0; color: inherit; border-radius: 0;
}

/* Blockquote: a note penciled in the margin. */
.ps-fdocs .pict-content blockquote
{
	border-left: 3px solid var(--theme-color-brand-primary, #1D5FA8);
	background: var(--theme-color-background-secondary, #F7F5F0);
	color: var(--theme-color-text-secondary, #5E5549);
	margin: 1.3em 0; padding: 0.6em 1em; border-radius: 0 4px 4px 0;
}
.ps-fdocs .pict-content blockquote p { margin: 0.3em 0; }

/* Tables: a drafting schedule -- Gorton uppercase headers, crisp hairlines. */
.ps-fdocs .pict-content table
{
	border-collapse: collapse; width: 100%; margin: 1.3em 0; font-size: 0.95em;
	display: block; overflow-x: auto;
}
.ps-fdocs .pict-content table th
{
	font-family: var(--plansheet-gorton); text-transform: uppercase; letter-spacing: 0.7px;
	font-size: 0.82em; font-weight: 700; text-align: left;
	background: var(--theme-color-background-secondary, #F5F0E8);
	border: 1px solid var(--theme-color-border-default, #DDD6CA);
	padding: 0.5em 0.85em; color: var(--theme-color-text-primary, #2B2D2F);
}
.ps-fdocs .pict-content table td
{
	border: 1px solid var(--theme-color-border-default, #DDD6CA);
	padding: 0.5em 0.85em; color: var(--theme-color-text-primary, #2B2D2F); vertical-align: top;
}
.ps-fdocs .pict-content table tr:nth-child(even) td { background: var(--theme-color-background-secondary, #F7F5F0); }

/* Drafting rule + centered figures / diagrams. */
.ps-fdocs .pict-content hr { border: 0; border-top: 1px solid var(--theme-color-border-default, #DDD6CA); margin: 2.4em 0; }
.ps-fdocs .pict-content img { max-width: 100%; height: auto; display: block; margin: 1.5em auto; border-radius: 4px; }
.ps-fdocs .pict-content pre.mermaid { display: flex; justify-content: center; margin: 1.5em 0; background: none; }

/* Diagram SVGs are usually dark ink on a transparent canvas, so they vanish on a
   dark page. Back them with a warm light "paper" card -- a contrasty surface in
   ANY theme -- so the ink always reads, and it frames as an intentional figure.
   Paper is the DEFAULT (the common case never flashes); the reader then inspects
   each SVG's source and tags the ones that paint their own background or are drawn
   in light ink with .pict-content-svg-bare, which strips the card back off. Raster
   photos keep their own background; this targets .svg only. */
.ps-fdocs .pict-content img[src*=".svg"]
{
	background: #FBF8F0;
	padding: 14px 18px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	border-radius: 2px;
	box-sizing: border-box;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.14);
}
.ps-fdocs .pict-content img[src*=".svg"].pict-content-svg-bare
{
	background: none; padding: 0; border: 0; box-shadow: none;
}

/* Code-block controls: crisp drafting corners that echo the plate. */
.ps-fdocs .pict-content .pict-content-code-action-btn { border-radius: 3px; }

/* ═══ Tooltips: drafting cards, not floating blobs ═══════════════════════
   pict-section-modal's rich tooltip (the vocabulary definition popover, and
   every other rich tooltip) defaults its surface to --theme-color-background-
   tertiary, which in a warm light palette reads as a flat tan box. Make it an
   intentional card: the panel surface, a crisp hairline, a cleaner shadow --
   correct in every theme. The arrow reads the same bg var, so it follows; we
   border its two outer edges per position so the seam closes. */
.pict-modal-tooltip
{
	--pict-modal-tooltip-bg: var(--theme-color-background-panel, #FBF8F0);
	border: 1px solid var(--theme-color-border-strong, var(--theme-color-border-default, #BDB4A4));
	box-shadow: 0 10px 28px rgba(0, 0, 0, 0.26);
	border-radius: 4px;
}
.pict-modal-tooltip-arrow { border: 0 solid var(--theme-color-border-strong, var(--theme-color-border-default, #BDB4A4)); }
.pict-modal-tooltip--top .pict-modal-tooltip-arrow    { border-right-width: 1px; border-bottom-width: 1px; }
.pict-modal-tooltip--bottom .pict-modal-tooltip-arrow { border-left-width: 1px;  border-top-width: 1px; }
.pict-modal-tooltip--left .pict-modal-tooltip-arrow   { border-top-width: 1px;   border-right-width: 1px; }
.pict-modal-tooltip--right .pict-modal-tooltip-arrow  { border-bottom-width: 1px; border-left-width: 1px; }

/* The vocabulary definition popover: a small drafting card -- Gorton label on
   the term, Plex for the gloss, the brand link to read the full definition. */
.pict-vocab-popover-title
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 1px;
	font-size: 12px;
}
.pict-vocab-popover-link
{
	font-family: var(--plansheet-gorton);
	text-transform: uppercase;
	letter-spacing: 0.8px;
}

/* ═══ Docs tree relocated into the sidebar ═══════════════════════════════
   The Foundational Docs tree (InlineDoc-Nav) now renders into the sidebar's
   Documentation tab, not the reader's own nav column. Hide the reader's now-empty
   nav column + its resizer so the article fills the pane (true reading mode when
   the sidebar is collapsed). */
.ps-fdocs .pict-inline-doc-nav-container,
.ps-fdocs .pict-inline-doc-resizer { display: none !important; }
.ps-fdocs .pict-inline-doc-content-container { flex: 1 1 auto !important; min-width: 0; }

/* The tree, now inside the sidebar, wears the sidebar's own surface so it reads as
   part of Plansheet: no inner frame, fills the host, inherits the panel. */
.ps-nb-docs-host { height: 100%; overflow: auto; }
.ps-nb-docs-host .pict-inline-doc-nav { border: 0 !important; background: transparent !important; height: 100%; }
`;

},{}],565:[function(require,module,exports){
'use strict';

// Brand wrapper — reads the deterministic brand block emitted by
// `npm run brand` (which calls pict-section-theme-brand in standalone
// mode using the retold.brandConfig hints in package.json). Passed to
// Theme-Section as the `Brand` option so the brand mark + brand color
// vars are wired into every themed surface.

const tmpPackage = require('../package.json');

if (!tmpPackage.retold || !tmpPackage.retold.brand)
{
	throw new Error('plansheet: package.json is missing retold.brand — '
		+ 'run `npm run brand` (which calls pict-section-theme-brand) before building');
}

module.exports = tmpPackage.retold.brand;

},{"../package.json":550}],566:[function(require,module,exports){
'use strict';
// GENERATED by build/stamp-version.js at build time. Do not edit; gitignored.
module.exports = {
	"Version": "1.0.1",
	"Commit": "082ca34",
	"BuildDate": "2026-10-30"
};

},{}],567:[function(require,module,exports){
'use strict';

/**
 * PlansheetIcons
 * --------------
 * Plansheet's app glyphs, registered with Pict's Icon provider so they render
 * through `{~I:Name~}` / `pict.icon('Name')` as themeable inline SVG (currentColor,
 * theme-aware) -- the same system Pict's base set uses. We do NOT use FontAwesome:
 * it was never loaded in the build, so any `fa-` class rendered as an empty box.
 *
 * These are the names the connections manifest references that are not already in
 * Pict's base set. Base already ships: Eye, FileText, FolderOpen, Image, User,
 * Warning (triangle-exclamation), Share (diagram) -- so the manifest maps to those
 * directly and only the glyphs below need registering.
 *
 * SVGs are Lucide-style: viewBox 0 0 24 24, fill none, stroke currentColor,
 * stroke-width 1.6 (matching Pict's base set). The provider sizes them to 1em via
 * its own injected `.pict-icon` CSS and wraps them on `get()`.
 *
 *   const { registerPlansheetIcons } = require('./PlansheetIcons.js');
 *   registerPlansheetIcons(this.pict);   // once, at app init
 */

const _ICONS =
{
	// Module
	Box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>',
	// Feature
	Star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
	// Customer / organization
	Building: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect width="16" height="20" x="4" y="2" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg>',
	// Book / library
	Book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>',
	// Home (cross-tenant "Your plan sheets" nav; WI #339)
	House: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>',
	// Contact (address book)
	Contact: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 2v2"/><path d="M8 2v2"/><path d="M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"/><circle cx="12" cy="11" r="3"/><rect x="3" y="4" width="18" height="18" rx="2"/></svg>',
	// Comments (a thread)
	Comments: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/></svg>',
	// Feedback (one message)
	Message: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
	// Test run
	Flask: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2"/><path d="M6.453 15h11.094"/><path d="M8.5 2h7"/></svg>',
	// Spawned vision
	Lightbulb: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>',
	// Work items
	ListChecks: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m3 17 2 2 4-4"/><path d="m3 7 2 2 4-4"/><path d="M13 6h8"/><path d="M13 12h8"/><path d="M13 18h8"/></svg>',
	// Call
	Phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
	// AI
	Robot: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/></svg>',
	// Sub-visions / decomposition (sitemap)
	Network: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2" width="6" height="6" rx="1"/><rect x="2" y="16" width="6" height="6" rx="1"/><rect x="16" y="16" width="6" height="6" rx="1"/><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"/><path d="M12 12V8"/></svg>',
	// Disconnect
	Unlink: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"/><path d="m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"/><line x1="8" x2="8" y1="2" y2="5"/><line x1="2" x2="5" y1="8" y2="8"/><line x1="16" x2="16" y1="19" y2="22"/><line x1="19" x2="22" y1="16" y2="16"/></svg>',
	// Share ("sharrow": a box with an up arrow), distinct from the base set's diagram-style Share
	// Table columns (columns-3)
	Columns: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 3v18"/><path d="M15 3v18"/></svg>',
	// Group of people (users)
	Users: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
	// Drafting compass
	DraftingCompass: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m12.99 6.74 1.93 3.44"/><path d="M19.136 12a10 10 0 0 1-14.271 0"/><path d="m21 21-2.16-3.84"/><path d="m3 21 8.02-14.26"/><circle cx="12" cy="5" r="2"/></svg>',
	// Presentation board (presentation)
	Chalkboard: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h20"/><path d="M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"/><path d="m7 21 5-5 5 5"/></svg>',
	// Ruler
	Ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/></svg>',
	// Ordered list (list-ordered)
	ListOrdered: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 12h11"/><path d="M10 18h11"/><path d="M10 6h11"/><path d="M4 10h2"/><path d="M4 6h1v4"/><path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"/></svg>',
	// Magic wand (wand-sparkles)
	Wand: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"/><path d="m14 7 3 3"/><path d="M5 6v4"/><path d="M19 14v4"/><path d="M10 2v2"/><path d="M7 8H3"/><path d="M21 16h-4"/><path d="M11 3H9"/></svg>',
	// Ticket
	Ticket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>',
	// Truck (truck)
	Truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
	// Handshake
	Handshake: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3 1 11h-2"/><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/><path d="M3 4h8"/></svg>',
	// Helping hand (hand-helping)
	HandHelping: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14"/><path d="m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/><path d="m2 13 6 6"/></svg>',
	// Headset (support)
	Headset: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M21 11h-3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z"/><path d="M3 14a9 9 0 0 1 18 0"/><path d="M21 16v2a4 4 0 0 1-4 4h-5"/></svg>',
	// Comment with dots (message-circle-more)
	CommentDots: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/></svg>',
	// ID card (id-card)
	IdCard: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 10h2"/><path d="M16 14h2"/><path d="M6.17 15a3 3 0 0 1 5.66 0"/><circle cx="9" cy="11" r="2"/><rect x="2" y="5" width="20" height="14" rx="2"/></svg>',
	// Feather (quill)
	Feather: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z"/><path d="M16 8 2 22"/><path d="M17.5 15H9"/></svg>',
	// Palette (theme colors)
	Palette: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z"/><circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/><circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/><circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/><circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/></svg>',
	// Key (key-round)
	Key: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"/><circle cx="16.5" cy="7.5" r=".5" fill="currentColor"/></svg>',
	// Terminal (square-terminal)
	Terminal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m7 11 2-2-2-2"/><path d="M11 13h4"/><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/></svg>',
	// User with shield (shield-user)
	UserShield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M6.376 18.91a6 6 0 0 1 11.249.003"/><circle cx="12" cy="11" r="4"/></svg>',
	// Shapes
	Shapes: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z"/><rect x="3" y="14" width="7" height="7" rx="1"/><circle cx="17.5" cy="17.5" r="3.5"/></svg>',
	// Pen and ruler (pen-ruler)
	PenRuler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13"/><path d="m8 6 2-2"/><path d="m18 16 2-2"/><path d="m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17"/><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/></svg>',
	// RSS feed
	Rss: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 11a9 9 0 0 1 9 9"/><path d="M4 4a16 16 0 0 1 16 16"/><circle cx="5" cy="19" r="1"/></svg>',
	// Heart pulse (heart-pulse)
	HeartPulse: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/><path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"/></svg>',
	// ID badge (portrait card)
	IdBadge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2"/><path d="m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06"/><path d="m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8"/></svg>',
	// User with gear (user-round-cog)
	UserGear: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 21a8 8 0 0 1 10.434-7.62"/><circle cx="10" cy="8" r="5"/><circle cx="18" cy="18" r="3"/><path d="m19.5 14.3-.4.9"/><path d="m16.9 20.8-.4.9"/><path d="m21.7 19.5-.9-.4"/><path d="m15.2 16.9-.9-.4"/><path d="m21.7 16.5-.9.4"/><path d="m15.2 19.1-.9.4"/><path d="m19.5 21.7-.4-.9"/><path d="m16.9 15.2-.4-.9"/></svg>',
	// Shield (shield-half)
	Shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M12 22V2"/></svg>',
	// Bell
	Bell: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/></svg>',
	// Envelope (mail)
	Envelope: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/><rect x="2" y="4" width="20" height="16" rx="2"/></svg>',
	// Toolbox (briefcase)
	Toolbox: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/><rect width="20" height="14" x="2" y="6" rx="2"/></svg>',
	Bookmark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>',
	Pencil: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/></svg>',
	// ── Work item type glyphs (the compact Type column, one per WorkItemType) ──
	// Triage: a funnel (sorting incoming work down to what matters).
	Funnel: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"/></svg>',
	// Research: a microscope (investigation).
	Microscope: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 18h8"/><path d="M3 22h18"/><path d="M14 22a7 7 0 1 0 0-14h-1"/><path d="M9 14h2"/><path d="M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z"/><path d="M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3"/></svg>',
	// Issue: a bug (a defect to fix).
	Bug: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m8 2 1.88 1.88"/><path d="M14.12 3.88 16 2"/><path d="M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"/><path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6"/><path d="M12 20v-9"/><path d="M6.53 9C4.6 8.8 3 7.1 3 5"/><path d="M6 13H2"/><path d="M3 21c0-2.1 1.7-3.9 3.8-4"/><path d="M20.97 5c0 2.1-1.6 3.8-3.5 4"/><path d="M22 13h-4"/><path d="M17.2 17c2.1.1 3.8 1.9 3.8 4"/></svg>',
	// Debt: an hourglass (a cost accruing over time).
	Hourglass: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 22h14"/><path d="M5 2h14"/><path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"/><path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"/></svg>',
	// Enhancement: sparkles (a polish / improvement).
	Sparkles: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>'
};

/**
 * Register the plansheet glyphs with Pict's Icon provider. Idempotent-safe to call
 * once at app init; the provider warns (and skips) on a duplicate name.
 *
 * @param {object} pPict - the Pict instance
 * @returns {boolean} true if the Icon provider was available and the set registered
 */
function registerPlansheetIcons(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers.Icon)
	{
		return false;
	}
	pPict.providers.Icon.registerSet({ Outline: _ICONS });
	return true;
}

module.exports = { registerPlansheetIcons: registerPlansheetIcons, ICONS: _ICONS };

},{}],568:[function(require,module,exports){
'use strict';

/**
 * PlansheetSort
 * -------------
 * The one ordering for the cross-tenant plan-sheet lists (WI #339): pinned first, then most recently
 * visited, then alphabetical by name. Pure and dependency-free so the same comparator runs on the
 * server (GET /1.0/Account/Tenants) and in the browser (the home view and the account switcher). Sharing
 * it means a pin toggled locally re-sorts exactly the way a refetch from the server would, with no drift.
 *
 * Each item is expected to carry { Pinned:bool, LastVisited:isoString|null, CustomerName:string }.
 */

function _time(pValue)
{
	if (!pValue) { return 0; }
	let tmpMs = new Date(pValue).getTime();
	return isNaN(tmpMs) ? 0 : tmpMs;
}

// The comparator, exposed for callers that want to sort in place with their own array method.
function comparePlansheets(pA, pB)
{
	if (pA.Pinned && !pB.Pinned) { return -1; }
	if (!pA.Pinned && pB.Pinned) { return 1; }
	let tmpTA = _time(pA.LastVisited);
	let tmpTB = _time(pB.LastVisited);
	if (tmpTA !== tmpTB) { return tmpTB - tmpTA; }
	return String(pA.CustomerName || '').localeCompare(String(pB.CustomerName || ''));
}

// Sort a list of plan-sheet blobs in place (and return it) by the pinned-then-recency-then-name order.
function sortPlansheets(pList)
{
	let tmpList = Array.isArray(pList) ? pList : [];
	tmpList.sort(comparePlansheets);
	return tmpList;
}

module.exports = { sortPlansheets, comparePlansheets };

},{}],569:[function(require,module,exports){
'use strict';

/**
 * PromptEmbed -- a reusable inline card for one attached prompt.
 *
 * It renders a prompt's title + badges, an expand/collapse body (the pinned version's text), a Copy
 * prompt text button, a Copy MCP run command button (when addressable), and -- when editable -- an
 * in-place Edit mode (a textarea + Save) that revises the text and re-pins the attachment so the MCP
 * run uses the new text, no trip to the Prompt Library. Host code can pass extra Actions (e.g. Record
 * run / Detach) rendered as header buttons with an OnAction callback.
 *
 * It replaces the old read-only "Read" modal in PictView-PromptAttachments and is meant to be mounted
 * in several places (the work item panel, the feedback page, ...). Event-delegation based (no inline
 * onclick, no global handles), so any number of instances coexist. Themed with the --cnx-* box vars
 * (with fallbacks), so it reads inside the graphite connections box and standalone.
 *
 *   let tmpEmbed = new PromptEmbed(pict);
 *   tmpEmbed.configure(pEntry, { RunCommand, Editable: true, Actions: [{ Key:'run', Label:'Record run' }], OnAction: (k)=>..., OnRevised: (body)=>... });
 *   tmpEmbed.mount(hostEl);
 */

const _STYLE_ID = 'pe-embed-styles';

function _esc(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh]));
}

const _CSS =
	'.pe { display: block; border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 9px; padding: 9px 11px; margin-bottom: 8px; background: rgba(8,14,24,0.14); }'
	+ '.pe-head { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }'
	+ '.pe-title { font-weight: 600; font-size: 13px; color: var(--cnx-txt, #eef2f7); cursor: pointer; }'
	+ '.pe-badge { font-family: ui-monospace, Menlo, monospace; font-size: 10px; letter-spacing: 1px; text-transform: uppercase; padding: 1px 7px; border-radius: 6px; border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); color: var(--cnx-lbl, #9aabc0); white-space: nowrap; }'
	+ '.pe-spacer { flex: 1; }'
	+ '.pe-btn { border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); background: rgba(8,14,24,0.4); color: var(--cnx-txt, #eef2f7); border-radius: 7px; padding: 3px 11px; font-size: 12px; cursor: pointer; white-space: nowrap; }'
	+ '.pe-btn:hover { border-color: #f0c44a; color: #f0c44a; }'
	+ '.pe-btn.pe-danger:hover { border-color: #e2725b; color: #e2725b; }'
	+ '.pe-run { display: flex; align-items: center; gap: 9px; margin: 9px 0 0; padding: 6px 12px; background: rgba(8,14,24,0.22); border: 1px dashed var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 8px; }'
	+ '.pe-run-text { flex: 1; font-family: ui-monospace, Menlo, monospace; font-size: 11.5px; color: var(--cnx-txt, #eef2f7); white-space: pre-wrap; word-break: break-word; }'
	+ '.pe-body { margin: 9px 0 0; }'
	+ '.pe-pre { max-height: 52vh; overflow: auto; white-space: pre-wrap; word-break: break-word; font-family: ui-monospace, Menlo, monospace; font-size: 12px; color: var(--cnx-txt, #eef2f7); background: rgba(8,14,24,0.3); border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 7px; padding: 9px 11px; margin: 0; }'
	+ '.pe-edit-ta { width: 100%; box-sizing: border-box; min-height: 40vh; resize: vertical; font-family: ui-monospace, Menlo, monospace; font-size: 12px; color: var(--cnx-txt, #eef2f7); background: rgba(8,14,24,0.3); border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 7px; padding: 9px 11px; }'
	+ '.pe-edit-actions { display: flex; gap: 8px; margin-top: 8px; }'
	+ '.pe-hint { font-size: 11px; color: var(--cnx-lbl, #9aabc0); margin-top: 6px; }';

function _injectCSS()
{
	if (typeof document === 'undefined') { return; }
	if (document.getElementById(_STYLE_ID)) { return; }
	let tmpStyle = document.createElement('style');
	tmpStyle.id = _STYLE_ID;
	tmpStyle.textContent = _CSS;
	document.head.appendChild(tmpStyle);
}

class PromptEmbed
{
	constructor(pPict)
	{
		this.pict = pPict;
		this._entry = null;         // { Prompt, Version, Link }
		this._runCommand = '';
		this._editable = false;
		this._expanded = false;
		this._actions = [];         // [{ Key, Label, Danger }]
		this._onAction = function () {};
		this._onRevised = function () {};
		this._host = null;
		this._editing = false;
	}

	// pEntry: a { Prompt, Version, Link } row (the PromptLinks/For shape). Options:
	//   RunCommand (string), Editable (bool), Expanded (bool), Actions ([{Key,Label,Danger}]),
	//   OnAction (fn(key)), OnRevised (fn(body)).
	configure(pEntry, pOptions)
	{
		pOptions = pOptions || {};
		this._entry = pEntry || null;
		this._runCommand = pOptions.RunCommand || '';
		if (pOptions.Editable != null) { this._editable = !!pOptions.Editable; }
		if (pOptions.Expanded != null) { this._expanded = !!pOptions.Expanded; }
		this._actions = Array.isArray(pOptions.Actions) ? pOptions.Actions : [];
		if (typeof pOptions.OnAction === 'function') { this._onAction = pOptions.OnAction; }
		if (typeof pOptions.OnRevised === 'function') { this._onRevised = pOptions.OnRevised; }
		return this;
	}

	mount(pHostElement)
	{
		if (!pHostElement) { return this; }
		_injectCSS();
		this._host = pHostElement;
		pHostElement.classList.add('pe');
		pHostElement.addEventListener('click', (pEvent) => this._onClick(pEvent));
		this._render();
		return this;
	}

	_source() { return (this._entry && this._entry.Version && this._entry.Version.Source) || ''; }

	_onClick(pEvent)
	{
		let tmpBtn = pEvent.target.closest('[data-pe]');
		if (!tmpBtn || !this._host.contains(tmpBtn)) { return; }
		let tmpAction = tmpBtn.getAttribute('data-pe');
		if (tmpAction === 'toggle') { this._editing = false; this._expanded = !this._expanded; this._render(); }
		else if (tmpAction === 'copy') { this._copy(this._source(), 'Prompt text copied.'); }
		else if (tmpAction === 'copyrun') { this._copy(this._runCommand, 'Run command copied.'); }
		else if (tmpAction === 'edit') { this._editing = true; this._expanded = true; this._render(); }
		else if (tmpAction === 'cancel') { this._editing = false; this._render(); }
		else if (tmpAction === 'save') { this._save(); }
		else if (tmpAction === 'act') { this._onAction(tmpBtn.getAttribute('data-key')); }
	}

	_copy(pText, pOkMessage)
	{
		if (!pText) { return; }
		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(pText).then(() => this._toast(pOkMessage, 'success')).catch(() => this._toast('Copy failed.', 'error'));
		}
	}

	_save()
	{
		let tmpArea = this._host.querySelector('.pe-edit-ta');
		if (!tmpArea) { return; }
		let tmpSource = tmpArea.value || '';
		if (!tmpSource.trim()) { return this._toast('The prompt text cannot be empty.', 'error'); }
		let tmpIDLink = this._entry && this._entry.Link && this._entry.Link.IDPromptLink;
		let tmpAPI = this.pict.providers.PromptAPI;
		if (!tmpIDLink || !tmpAPI || typeof tmpAPI.revise !== 'function') { return this._toast('Cannot save here.', 'error'); }
		tmpAPI.revise(tmpIDLink, tmpSource).then((pBody) =>
		{
			// Reflect the new pinned version locally so the card + copy use the revised text.
			if (this._entry.Version)
			{
				this._entry.Version.Source = tmpSource;
				if (pBody && pBody.Version) { this._entry.Version.Sequence = pBody.Version.Sequence; this._entry.Version.IDPromptVersion = pBody.Version.IDPromptVersion; }
			}
			this._editing = false;
			this._render();
			this._toast('Prompt revised; the run now uses the new text.', 'success');
			this._onRevised(pBody);
		}).catch((pError) => this._toast((pError && pError.message) || 'Could not save the revision.', 'error'));
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType }); }
	}

	_render()
	{
		if (!this._host) { return; }
		let tmpEntry = this._entry || {};
		let tmpPrompt = tmpEntry.Prompt || {};
		let tmpVersion = tmpEntry.Version || null;
		let tmpLink = tmpEntry.Link || {};

		let tmpHead = '<div class="pe-head">'
			+ '<span class="pe-title" data-pe="toggle">' + _esc(tmpPrompt.Title || ('Prompt ' + tmpLink.IDPrompt)) + '</span>'
			+ '<span class="pe-badge">#' + _esc(tmpPrompt.PromptNumber || tmpLink.IDPrompt) + '</span>'
			+ (tmpPrompt.TypeKey ? '<span class="pe-badge">' + _esc(tmpPrompt.TypeKey) + '</span>' : '')
			+ (tmpVersion ? '<span class="pe-badge">v' + _esc(tmpVersion.Sequence) + ' pinned</span>' : '')
			+ '<span class="pe-spacer"></span>'
			+ (tmpVersion ? '<button class="pe-btn" data-pe="toggle">' + (this._expanded ? 'Hide' : 'Read') + '</button>' : '')
			+ (tmpVersion ? '<button class="pe-btn" data-pe="copy">Copy</button>' : '')
			+ (this._runCommand ? '<button class="pe-btn" data-pe="copyrun">Copy MCP command</button>' : '')
			+ (this._editable && tmpVersion ? '<button class="pe-btn" data-pe="edit">Edit</button>' : '')
			+ this._actions.map((pAction) => '<button class="pe-btn' + (pAction.Danger ? ' pe-danger' : '') + '" data-pe="act" data-key="' + _esc(pAction.Key) + '">' + _esc(pAction.Label) + '</button>').join('')
			+ '</div>';

		let tmpRun = this._runCommand
			? '<div class="pe-run"><code class="pe-run-text">' + _esc(this._runCommand) + '</code><button class="pe-btn" data-pe="copyrun">Copy</button></div>'
			: '';

		let tmpBody = '';
		if (this._expanded && tmpVersion)
		{
			if (this._editing)
			{
				tmpBody = '<div class="pe-body"><textarea class="pe-edit-ta">' + _esc(this._source()) + '</textarea>'
					+ '<div class="pe-edit-actions"><button class="pe-btn" data-pe="save">Save</button><button class="pe-btn" data-pe="cancel">Cancel</button></div>'
					+ '<div class="pe-hint">Saving captures a new pinned version, so the MCP run uses this text.</div></div>';
			}
			else
			{
				tmpBody = '<div class="pe-body"><pre class="pe-pre">' + _esc(this._source()) + '</pre></div>';
			}
		}

		this._host.innerHTML = tmpHead + tmpRun + tmpBody;
	}
}

module.exports = PromptEmbed;

},{}],570:[function(require,module,exports){
'use strict';

/**
 * Single-flight lanes: what a queued action contends for, and when that thing is busy.
 *
 * A queued action contends for something real. A Promote contends for production. A run of the
 * plansheet-software toolchain contends for that pipeline. Nothing in the platform said so, so you
 * could queue a promote, walk away, come back, and queue it again -- and a run parked on its promote
 * gate waiting for a person to sign off did not stop a second run of the same chain from being
 * started and claimed ahead of it.
 *
 * A lane is a derived key naming the contended resource plus the set of statuses that count as still
 * in flight. Nothing is stored: both keys come off columns that already exist, so there is no column
 * to migrate and no history to backfill.
 *
 *   DeployRequest   deploy:dev, deploy:prod      Requested, Running
 *   Run             toolchain:<ToolchainKey>     Requested, Running, AwaitingConsent
 *
 * AwaitingConsent counting as open is the point of the whole module. A step waiting on a person is
 * not idle: it is holding the pipeline, and it holds the lane until the person answers.
 *
 * Deploy lanes are per environment. Two promotes cannot overlap and two dev deploys cannot overlap,
 * but a dev deploy and a promote still can: they are different environments, and treating them as
 * one lane would refuse a pair of actions that has never actually collided.
 *
 * The two lanes layer rather than duplicate. The run lane stops a second run of one chain; the
 * deploy lane stops a second promote no matter who asked for it, a person on the Releases page or a
 * node walking a toolchain. Neither is a substitute for the other.
 *
 * This file is the shared half: the derivation and the words, with no database in it, so the server
 * guard and the pages that grey out a button agree on what busy means and say it the same way. The
 * server half (the reads) is source/server/queue/SingleFlight.js. Sharing this direction is the
 * convention already in the tree: Board-Endpoint and Review-Endpoint both reach down into
 * EntityDescriptors.js rather than keeping a second copy of what an entity is.
 */

const _OPEN_DEPLOY_STATUSES = ['Requested', 'Running'];
const _OPEN_RUN_STATUSES = ['Requested', 'Running', 'AwaitingConsent'];

/**
 * Which environment a deploy contends for. Environment is the honest answer because it names the
 * resource; Action is the fallback for a row that did not carry one, which is how the node's
 * executor can post when a toolchain step leaves Environment off its Args.
 */
function deployLaneKey(pRow)
{
	let tmpRow = pRow || {};
	let tmpEnvironment = String(tmpRow.Environment || '').trim().toLowerCase();
	if (!tmpEnvironment)
	{
		tmpEnvironment = (String(tmpRow.Action || '') === 'Promote') ? 'prod' : 'dev';
	}
	return 'deploy:' + tmpEnvironment;
}

/**
 * Which pipeline a run contends for. A deploy chain contends per toolchain: one deploy-dev run, one
 * plansheet-software run. A work-item build is different -- it contends for the WORK ITEM, not the
 * chain, because many items build the same work-item toolchain at once and must not queue behind each
 * other. So a work-item run (a work-item toolchain carrying an IDWorkItem) gets a per-item lane: two
 * runs of the same item cannot overlap (a stranded one blocks only its own item), but two different
 * items run side by side.
 */
function runLaneKey(pRow)
{
	let tmpRow = pRow || {};
	let tmpKey = String(tmpRow.ToolchainKey || '').trim();
	let tmpIDWorkItem = Number(tmpRow.IDWorkItem) || 0;
	if (tmpIDWorkItem && tmpKey.indexOf('work-item') === 0) { return 'workitem:' + tmpIDWorkItem; }
	return 'toolchain:' + tmpKey;
}

function isOpenDeploy(pRow)
{
	return _OPEN_DEPLOY_STATUSES.indexOf(String((pRow || {}).Status || '')) >= 0;
}

function isOpenRun(pRow)
{
	return _OPEN_RUN_STATUSES.indexOf(String((pRow || {}).Status || '')) >= 0;
}

/**
 * The open row holding pLaneKey, given rows already in hand. The server reads them out of the
 * database and the pages already have them loaded, so both go through here.
 *
 * Oldest first among the open ones, so the sentence names the request that has been holding the lane
 * rather than the most recent thing to pile up behind it.
 */
function openestOf(pRows, pLaneKey, fLaneKey, fIsOpen)
{
	let tmpOpen = (pRows || []).filter((pRow) => fIsOpen(pRow) && fLaneKey(pRow) === pLaneKey);
	if (!tmpOpen.length) { return null; }
	return tmpOpen.reduce((pOldest, pRow) => (_sortValue(pRow) < _sortValue(pOldest)) ? pRow : pOldest, tmpOpen[0]);
}

function _sortValue(pRow)
{
	let tmpRow = pRow || {};
	return Number(tmpRow.IDDeployRequest || tmpRow.IDRun || 0) || 0;
}

function findOpenDeployIn(pRows, pLaneKey)
{
	return openestOf(pRows, pLaneKey, deployLaneKey, isOpenDeploy);
}

function findOpenRunIn(pRows, pLaneKey)
{
	return openestOf(pRows, pLaneKey, runLaneKey, isOpenRun);
}

/**
 * What the thing in the lane is, in words. "Dev deploy" and "promotion to production" rather than
 * DeployDev and Promote, because this sentence is read by a person on a page, not by a machine.
 */
function _deployNoun(pRow)
{
	return (String((pRow || {}).Action || '') === 'Promote') ? 'A promotion to production' : 'A dev deploy';
}

function statusWords(pStatus)
{
	let tmpMap =
	{
		Requested: 'queued',
		Running: 'running',
		AwaitingConsent: 'waiting for someone to approve it'
	};
	return tmpMap[String(pStatus || '')] || String(pStatus || '').toLowerCase();
}

/**
 * The one sentence the 409 carries and the page shows, so a person reads the same words whichever
 * way they hit the lane. It says what is in flight, which record it is, and where it got to.
 */
function describeDeploy(pRow)
{
	let tmpRow = pRow || {};
	let tmpNumber = Number(tmpRow.DeployRequestNumber) || Number(tmpRow.Number) || Number(tmpRow.IDDeployRequest) || 0;
	return _deployNoun(tmpRow) + ' is already in flight (request #' + tmpNumber + ', '
		+ statusWords(tmpRow.Status) + '). Wait for it to finish, or cancel it on the Releases page.';
}

function describeRun(pRow)
{
	let tmpRow = pRow || {};
	let tmpNumber = Number(tmpRow.RunNumber) || Number(tmpRow.Number) || Number(tmpRow.IDRun) || 0;
	return 'A run of ' + (tmpRow.ToolchainKey || 'that toolchain') + ' is already in flight (run #'
		+ tmpNumber + ', ' + statusWords(tmpRow.Status) + ').';
}

module.exports =
{
	deployLaneKey: deployLaneKey,
	runLaneKey: runLaneKey,
	isOpenDeploy: isOpenDeploy,
	isOpenRun: isOpenRun,
	findOpenDeployIn: findOpenDeployIn,
	findOpenRunIn: findOpenRunIn,
	describeDeploy: describeDeploy,
	describeRun: describeRun,
	statusWords: statusWords,
	OPEN_DEPLOY_STATUSES: _OPEN_DEPLOY_STATUSES,
	OPEN_RUN_STATUSES: _OPEN_RUN_STATUSES
};

},{}],571:[function(require,module,exports){
'use strict';

/**
 * SiteMap -- the one navigation graph for the whole app, consumed by pict-section-navigation. It
 * drives the docked main sidebar (the non-settings groups), the settings sub-rail (the Settings
 * group, scoped), and the cmd+K launcher (everything). Groups are top-level categories; their
 * Children are the navigable items. Each item carries a Route (a hash URL) the app navigates to.
 *
 * Group hashes are set explicitly so the host can scope a render to a subset of groups without
 * worrying about slug collisions; the Settings group's children are left unhashed so the normalizer
 * prefixes them (settings.profile, ...), which keeps the settings items from colliding with the
 * top-level ones. The app routes settings items by parsing their Route, not their hash.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// The groups shown in the docked main sidebar. The You group (personal pages) and the Settings
// group are excluded on purpose: You backs the cmd+K launcher only, and Settings backs the in-page
// settings sub-rail (the gear) and the launcher. Both are still in the graph so the launcher lists
// them.
const MAIN_GROUP_HASHES = ['workspace', 'plan', 'design', 'work', 'deliver', 'fleet', 'tools'];
const SETTINGS_GROUP_HASH = 'settings-area';
// The docked sidebar shows the main groups PLUS the Settings group (a collapsible group at the
// bottom), so settings pages live in the same shared rail and turn up in the sidebar search. The
// hide-filter and hideableNavItems() stay scoped to MAIN_GROUP_HASHES so settings items are never
// offered for hiding -- only the main nav is hideable.
const DOCKED_GROUP_HASHES = MAIN_GROUP_HASHES.concat([SETTINGS_GROUP_HASH]);

/**
 * Build the navigation graph.
 * @param {function(string):boolean} fCan - entitlement check ( (entKey) => boolean ); items with an
 *        Ent they cannot do are dropped. Pass through-true to include everything.
 * @param {object} pLex - the resolved Drafting Kit lexicon (renames labels), or null.
 * @param {Array<string>} pHidden - item Hashes the plan sheet owner hid from the sidebar; dropped
 *        everywhere the graph drives (sidebar, settings rail, launcher). A main group that loses all
 *        of its children is dropped too. Only items in hideableNavItems() are ever honored here.
 * @returns {Array<object>}
 */
function buildSiteMap(fCan, pLex, pHidden)
{
	let tmpCan = (typeof fCan === 'function') ? fCan : function () { return true; };
	let tmpHide = new Set(Array.isArray(pHidden) ? pHidden : []);
	let tmpMain = new Set(MAIN_GROUP_HASHES);
	// Resolve a nav label from the plan sheet's Drafting Kit lexicon (plural form),
	// falling back to the canonical default when no kit renames it.
	let fLabel = (pTerm, pDefault) => (pLex && pLex[pTerm] && pLex[pTerm].Plural) ? pLex[pTerm].Plural : pDefault;
	// Resolve the secondary nav blurb the same way, so a renamed item gets its own
	// description instead of inheriting the stock one (e.g. "Read-throughs" need not
	// say "Executions of routines, step by step.").
	let fDesc = (pTerm, pDefault) => (pLex && pLex[pTerm] && pLex[pTerm].Description) ? pLex[pTerm].Description : pDefault;

	let tmpSettingsChildren =
	[
		{ Name: 'Profile', Route: '#/settings/profile', Icon: 'IdCard', Description: 'Your name, title, and color.' },
		{ Name: 'About Me', Route: '#/settings/about', Icon: 'Feather', Description: 'A rich profile others can read.' },
		{ Name: 'Appearance', Route: '#/settings/appearance', Icon: 'Palette', Description: 'Theme, color mode, and text size.' },
		{ Name: 'Sign-in', Route: '#/settings/account', Icon: 'Key', Description: 'Change your email or password.' },
		{ Name: 'Notifications', Route: '#/settings/notifications', Icon: 'Bell', Description: 'How the platform reaches you: email and text alerts.' },
		{ Name: 'API Tokens', Route: '#/settings/tokens', Icon: 'Terminal', Description: 'Tokens for the CLI and automation.' },
		{ Name: 'Connections', Route: '#/settings/connections', Icon: 'Robot', Description: 'Connect Claude, and control which plan sheets each connection may act in.' },
		{ Name: 'Plan sheets', Route: '#/settings/plansheets', Icon: 'Box', Description: 'Your memberships and default plan sheet.' }
	];
	let tmpAdminChildren =
	[
		{ Name: 'Team', Route: '#/settings/team', Icon: 'Users', Ent: 'users.manage', Description: 'Members and their roles.' },
		{ Name: 'Roles', Route: '#/settings/roles', Icon: 'UserShield', Ent: 'roles.manage', Description: 'Custom roles and what they can do.' },
		{ Name: 'Org Settings', Route: '#/settings/org', Icon: 'Building', Ent: 'platform.manage', Description: 'Organization profile.' },
		{ Name: 'Top Bar', Route: '#/settings/topbar', Icon: 'Image', Ent: 'content.edit', Description: "The art across this plan sheet's top bar." },
		{ Name: 'Drafting Kits', Route: '#/settings/draftingkit', Icon: 'DraftingCompass', Ent: 'platform.manage', Description: 'Build and manage your crafts.' },
		{ Name: 'Documentation Sync', Route: '#/settings/docsync', Icon: 'Book', Ent: 'content.edit', Description: 'Connect a GitHub repo and sync its docs.' },
		{ Name: 'Stickers', Route: '#/settings/stickers', Icon: 'Shapes', Ent: 'stickers.manage', Description: 'Stickers the team can place on moodboards.' },
		{ Name: 'Workflow', Route: '#/workflow', Icon: 'Network', Ent: 'users.manage', Description: 'Configure the workflow an administrator sets for the platform.' },
		{ Name: 'Prompt Shapes', Route: '#/prompt-shapes', Icon: 'PenRuler', Ent: 'users.manage', Description: 'The prompt shapes the organization crafts against: adopt platform defaults or author fresh.' },
		{ Name: 'Tasks', Route: '#/tasks', Icon: 'Sparkles', Ent: 'content.edit', Description: 'The user-facing tasks your people can run: name one, bind a prompt shape and a node capability, and it appears in Ask.' },
		{ Name: 'Activity', Route: '#/org/activity', Icon: 'Rss', Ent: 'users.manage', Description: 'What your team has been doing.' },
		{ Name: 'Ops Console', Route: '#/admin/ops', Icon: 'HeartPulse', Ent: 'platform.manage', Description: 'Errors, activity, and who is active now.' }
	].filter((pItem) => tmpCan(pItem.Ent));
	// Deliver: the customer-facing side of the work -- what is owed, who it is for, and what they said.
	// The build-and-ship machinery moved out to Fleet below.
	let tmpDeliverChildren =
	[
		{ Name: 'Deliver', Hash: 'deliver-board', Route: '#/deliver', Icon: 'Truck', Description: 'Move deliverables from scoped to accepted.' },
		{ Name: 'Expectations', Hash: 'expectations', Route: '#/expectations', Icon: 'HandHelping', Description: 'The high-level deliverables a customer expects.' },
		{ Name: 'Customers', Hash: 'keystone-customers', Route: '#/keystone-customers', Icon: 'Handshake', Description: 'The customers you serve and what they tell you.' },
		{ Name: 'Call Desk', Hash: 'call-desk', Route: '#/call-desk', Icon: 'Headset', Description: 'Log calls with customers and turn them into issues.' },
		{ Name: 'Issues', Hash: 'issues', Route: '#/issues', Icon: 'Warning', Description: 'Bugs, defects, and customer-reported problems.' },
		{ Name: fLabel('Feedback', 'Feedback'), Hash: 'feedback', Route: '#/feedback', Icon: 'CommentDots', Description: fDesc('Feedback', 'What testers and customers said.') }
	].filter((pItem) => tmpCan(pItem.Ent));

	// Fleet: the agents that build and ship, and the machinery around them. These three sat under Deliver
	// for a while, but they answer a different question. Deliver is about how the ORG delivers -- what a
	// customer expects, what they told you, what you owe them. Fleet is about the AGENTS doing the work:
	// which node is running what, what it produced, and what ships where. Someone checking on a customer
	// commitment and someone checking on a node are not on the same errand.
	let tmpFleetChildren =
	[
		{ Name: 'Releases', Hash: 'releases', Route: '#/releases', Icon: 'Rocket', Ent: 'platform.manage', Description: 'Deploy to dev and promote validated As-Builts to prod.' },
		// Runs is deliberately NOT gated on platform.manage: anyone on the team should be able to watch a
		// run and read the evidence a node attached. Only the Approve and Reject controls are gated, and
		// the server enforces that with content.approve. It is also why this group is never empty for a
		// non-admin -- Releases and Nodes filter out, Runs does not, so the group never renders headless.
		{ Name: 'Runs', Hash: 'runs', Route: '#/runs', Icon: 'Robot', Description: 'Toolchain runs a node is executing, and the steps waiting on your approval.' },
		// Nodes: the registered agent nodes and their capability. Gated on platform.manage like Releases, because
		// suspending a node is an operational act; the Suspend / Resume controls are additionally content.approve.
		{ Name: 'Nodes', Hash: 'node-registrations', Route: '#/node-registrations', Icon: 'Box', Ent: 'platform.manage', Description: 'Registered agent nodes, what each can do, and whether it is Active or Suspended.' },
		{ Name: 'Capabilities', Hash: 'capabilities', Route: '#/capabilities', Icon: 'Bolt', Ent: 'content.approve', Description: 'Of the nodes that advertise each capability, choose which one is live.' }
	].filter((pItem) => tmpCan(pItem.Ent));

	let tmpGraph =
	[
		{
			Name: 'Workspace', Hash: 'workspace', Icon: 'Columns', Blurb: 'Where the work lives.',
			Children:
			[
				{ Name: 'Board', Hash: 'board', Route: '#/board', Icon: 'Columns', Description: 'Work items on a kanban board.' },
				// A board of its own, because work items move at agent speed and features move at
				// product speed. One surface implied they should move together, and that implication
				// is the pressure that produces rubber stamps.
				{ Name: 'Feature Board', Hash: 'feature-board', Route: '#/feature-board', Icon: 'Star', Description: 'Features on their own board, and where their promise is accepted.' },
				{ Name: 'System Activity', Hash: 'system-activity', Route: '#/system-activity', Icon: 'HeartPulse', Description: 'How much work and knowledge the team creates over time.' },
				{ Name: 'Community', Hash: 'community', Route: '#/community', Icon: 'Users', Description: 'Everyone on the team.' }
			]
		},
		{
			Name: 'Plan', Hash: 'plan', Icon: 'ListChecks', Blurb: 'What you are building.',
			Children:
			[
				{ Name: fLabel('Vision', 'Visions'), Hash: 'visions', Route: '#/visions', Icon: 'Eye', Description: fDesc('Vision', 'What you are building and why.') },
				{ Name: fLabel('Module', 'Modules'), Hash: 'modules', Route: '#/modules', Icon: 'Box', Description: fDesc('Module', 'The parts of the system.') },
				{ Name: fLabel('Feature', 'Features'), Hash: 'features', Route: '#/features', Icon: 'Star', Description: fDesc('Feature', 'What each module does.') }
			]
		},
		{
			Name: 'Design', Hash: 'design', Icon: 'DraftingCompass', Blurb: 'How it should work.',
			Children:
			[
				{ Name: fLabel('Documentation', 'Documentation'), Hash: 'docs', Route: '#/docs', Icon: 'Book', Description: fDesc('Documentation', 'The team library.') },
				{ Name: fLabel('Whiteboard', 'Whiteboards'), Hash: 'whiteboards', Route: '#/whiteboards', Icon: 'Chalkboard', Description: fDesc('Whiteboard', 'A free-form canvas of ideas.') },
				{ Name: 'Blueprints', Hash: 'blueprints', Route: '#/blueprints', Icon: 'Ruler', Description: 'Composed title blocks you reuse.' },
				// The unit a customer is handed, as opposed to a single blueprint: a named group, issued as
				// Rev A and reproducible afterwards. Sits beside Blueprints because that is what it is made of.
				{ Name: fLabel('Routine', 'Routines'), Hash: 'routines', Route: '#/routines', Icon: 'ListOrdered', Description: fDesc('Routine', 'Step-by-step procedures to exercise the product.') },
				{ Name: 'Prompt Library', Hash: 'prompts', Route: '#/prompts', Icon: 'Wand', Description: 'Craft prompts, run them, and share what works.' }
			]
		},
		{
			Name: 'Build', Hash: 'work', Icon: 'Ticket', Blurb: 'The tasks in flight.',
			Children:
			[
				{ Name: fLabel('WorkItem', 'Work Items'), Hash: 'work-items', Route: '#/work-items', Icon: 'Ticket', Description: fDesc('WorkItem', 'The tasks in flight.') },
				{ Name: 'Sessions', Hash: 'sessions', Route: '#/sessions', Icon: 'Comments', Description: 'The Claude sessions behind the work.' },
				{ Name: fLabel('TestRun', 'Test Runs'), Hash: 'test-runs', Route: '#/test-runs', Icon: 'Flask', Description: fDesc('TestRun', 'Executions of routines, step by step.') },
				{ Name: 'As-Builts', Hash: 'as-builts', Route: '#/as-builts', Icon: 'Package', Description: 'What each session delivered, ready to validate and promote.' }
			]
		},
		{
			Name: 'Tools', Hash: 'tools', Icon: 'Toolbox', Blurb: 'Your personal workspace.',
			Children:
			[
				{ Name: 'Ask', Hash: 'ask', Route: '#/ask', Icon: 'Sparkles', Description: 'Run a task your team set up and get an answer back.' },
				{ Name: 'Projects', Hash: 'projects', Route: '#/projects', Icon: 'FolderOpen', Description: 'Build a form, a sticker, or anything from a cluster of files and the tasks you run against it.' },
				{ Name: 'Project Types', Hash: 'project-types', Route: '#/project-types', Icon: 'FileText', Description: 'Reusable project shapes your team designs with the assistant.' },
				{ Name: 'Checklists', Hash: 'checklists', Route: '#/checklists', Icon: 'ListChecks', Description: 'Your private lists, just for you.' },
				{ Name: 'Notes', Hash: 'notes', Route: '#/notes', Icon: 'FileText', Description: 'Private markdown notes by the drafting table.' },
				{ Name: 'Bookmarks', Hash: 'bookmarks', Route: '#/bookmarks', Icon: 'Bookmark', Description: 'Pinned pages and where you have been.' },
				{ Name: 'Gallery', Hash: 'gallery', Route: '#/gallery', Icon: 'Image', Description: 'Your private images and uploads.' },
				{ Name: 'Drawings', Hash: 'drawings', Route: '#/drawings', Icon: 'Pencil', Description: 'Sketch and diagram on a full Excalidraw canvas.' }
			]
		},
		{
			Name: 'Deliver', Hash: 'deliver', Icon: 'Truck', Blurb: 'What you deliver, and the customers you serve.',
			Children: tmpDeliverChildren
		},
		{
			Name: 'Fleet', Hash: 'fleet', Icon: 'Robot', Blurb: 'The agents that build and ship.',
			Children: tmpFleetChildren
		},
		{
			Name: 'You', Hash: 'you', Icon: 'User', Blurb: 'Your space and your settings.',
			Children:
			[
				{ Name: 'Your plan sheets', Hash: 'home', Route: '#/home', Icon: 'House', Description: 'Every plan sheet you belong to, across tenants.' },
				{ Name: 'My Profile', Hash: 'profile', Route: '#/profile', Icon: 'IdBadge', Description: 'Your personal page.' },
				{ Name: 'Settings', Hash: 'settings', Route: '#/settings', Icon: 'Settings', Description: 'Profile, sign-in, team, and tokens.' }
			]
		},
		{
			Name: 'Settings', Hash: SETTINGS_GROUP_HASH, Secondary: true, Collapsed: true, Icon: 'Settings', Blurb: 'Manage your account and team.',
			Children: tmpSettingsChildren.concat(tmpAdminChildren)
		}
	];
	if (tmpHide.size)
	{
		// Only the docked main groups are ever filtered, so a stray hash (a hand-edited row, a
		// renamed item) can never reach into the You / Settings groups and hide the gear.
		tmpGraph = tmpGraph
			.map((pGroup) => tmpMain.has(pGroup.Hash) ? Object.assign({}, pGroup, { Children: (pGroup.Children || []).filter((pItem) => !tmpHide.has(pItem.Hash)) }) : pGroup)
			.filter((pGroup) => (pGroup.Children && pGroup.Children.length) || !tmpMain.has(pGroup.Hash));
	}
	return tmpGraph;
}

// The nav items a plan sheet owner may hide from the sidebar: every leaf in the docked main groups,
// with its current (lexicon-resolved) label and its group, so the Org Settings picker and the write
// sanitizer agree on exactly one catalog. The You / Settings groups are never offered (they back the
// launcher and the always-present gear). Hashes here are the contract honored by buildSiteMap's filter.
function hideableNavItems(pLex)
{
	let tmpMain = new Set(MAIN_GROUP_HASHES);
	let tmpItems = [];
	buildSiteMap(null, pLex || null, null).forEach((pGroup) =>
	{
		if (!tmpMain.has(pGroup.Hash)) { return; }
		(pGroup.Children || []).forEach((pItem) =>
		{
			tmpItems.push({ Hash: pItem.Hash, Name: pItem.Name, Description: pItem.Description || '', GroupHash: pGroup.Hash, GroupName: pGroup.Name });
		});
	});
	return tmpItems;
}

module.exports = { buildSiteMap: buildSiteMap, hideableNavItems: hideableNavItems, MAIN_GROUP_HASHES: MAIN_GROUP_HASHES, DOCKED_GROUP_HASHES: DOCKED_GROUP_HASHES, SETTINGS_GROUP_HASH: SETTINGS_GROUP_HASH };

},{}],572:[function(require,module,exports){
'use strict';

/**
 * StickerSetResolver
 * ------------------
 * Resolves a sticker set (a key like 'drafting-design', or a raw items array from a custom set) into a
 * sanitized, drawable list of gallery items, the same way ConnectionStyle.js resolves a kit's link
 * style. Shared by the server, the board source, and the preview view. It never throws and never
 * returns an empty list: a bad or unknown set falls back to the built-in default, so the gallery
 * always has something to show.
 *
 * Item shapes it accepts:
 *   { Collection, Name, Title, Pri?, Sec? }  - a library shape (phosphor / tabler / simple)
 *   { IDSticker, Name }                       - an uploaded sticker (Phase 3; carried through as-is)
 *
 * Routing precedence is the caller's job (per-kit -> per-context default -> built-in); this module
 * supplies contextDefaultKey() for the per-context piece.
 */

const libStickerSets = require('./StickerSets.js');

const _COLLECTIONS = ['phosphor', 'tabler', 'simple'];

function _hex(pValue, pFallback)
{
	return (typeof pValue === 'string' && /^#[0-9a-fA-F]{3,8}$/.test(pValue)) ? pValue : pFallback;
}

// Sanitize one item to something the gallery can draw. Returns null for anything malformed so the
// caller can drop it. A library item needs a known collection + a kebab-case name; an upload item
// needs a positive IDSticker.
function _sanitizeItem(pItem)
{
	if (!pItem || typeof pItem !== 'object') { return null; }
	let tmpUploadID = parseInt(pItem.IDSticker, 10);
	if (!isNaN(tmpUploadID) && tmpUploadID > 0)
	{
		return { IDSticker: tmpUploadID, Name: String(pItem.Name || ('Sticker ' + tmpUploadID)) };
	}
	if (_COLLECTIONS.indexOf(pItem.Collection) < 0) { return null; }
	let tmpName = String(pItem.Name == null ? '' : pItem.Name).toLowerCase().replace(/[^a-z0-9-]/g, '');
	if (!tmpName) { return null; }
	let tmpOut = { Collection: pItem.Collection, Name: tmpName, Title: String(pItem.Title || tmpName) };
	let tmpPri = _hex(pItem.Pri, null);
	let tmpSec = _hex(pItem.Sec, null);
	if (tmpPri) { tmpOut.Pri = tmpPri; }
	if (tmpSec) { tmpOut.Sec = tmpSec; }
	return tmpOut;
}

function _setItems(pKey)
{
	let tmpSet = libStickerSets.Sets[pKey];
	return (tmpSet && Array.isArray(tmpSet.Items)) ? tmpSet.Items : null;
}

// Resolve a set key OR a raw items array to a sanitized, non-empty drawable item list.
function resolveStickerSet(pKeyOrItems)
{
	let tmpRaw = null;
	if (typeof pKeyOrItems === 'string') { tmpRaw = _setItems(pKeyOrItems); }
	else if (Array.isArray(pKeyOrItems)) { tmpRaw = pKeyOrItems; }
	let tmpClean = (tmpRaw || []).map(_sanitizeItem).filter(Boolean);
	if (!tmpClean.length)
	{
		tmpClean = (_setItems(libStickerSets.DEFAULT_SET_KEY) || []).map(_sanitizeItem).filter(Boolean);
	}
	return tmpClean;
}

// The default set for a board context when no kit names one: profiles are expressive, everything else
// (vision inspiration boards, whiteboards) is design-first.
function contextDefaultKey(pContext)
{
	return (pContext === 'profile') ? libStickerSets.PROFILE_SET_KEY : libStickerSets.DEFAULT_SET_KEY;
}

function isKnownSetKey(pKey)
{
	return !!(pKey && libStickerSets.Sets[pKey]);
}

// Sanitize an items array for storage (a custom set): drop malformed entries, no default fallback.
function sanitizeItems(pItems)
{
	return (Array.isArray(pItems) ? pItems : []).map(_sanitizeItem).filter(Boolean);
}

// Parse a custom-set key 'custom:<id>' to its numeric IDStickerSet, or 0 for a system key / anything else.
function customKeyId(pKey)
{
	let tmpMatch = /^custom:(\d+)$/.exec(String(pKey == null ? '' : pKey));
	return tmpMatch ? (parseInt(tmpMatch[1], 10) || 0) : 0;
}

// A key that can be stored as a kit/brand choice: a known system set, or a 'custom:<id>' reference. The
// custom id is not checked for existence here (a deleted set resolves to empty -> the board falls back).
function isUsableSetKey(pKey)
{
	return isKnownSetKey(pKey) || (customKeyId(pKey) > 0);
}

// A flat, ordered summary for pickers and the preview surface.
function listSetSummaries()
{
	return libStickerSets.SET_ORDER
		.filter((pKey) => !!libStickerSets.Sets[pKey])
		.map((pKey) =>
		{
			let tmpSet = libStickerSets.Sets[pKey];
			return { Key: pKey, Label: tmpSet.Label, Description: tmpSet.Description || '', Count: (tmpSet.Items || []).length };
		});
}

module.exports =
{
	resolveStickerSet,
	contextDefaultKey,
	isKnownSetKey,
	isUsableSetKey,
	sanitizeItems,
	customKeyId,
	listSetSummaries,
	DEFAULT_SET_KEY: libStickerSets.DEFAULT_SET_KEY,
	PROFILE_SET_KEY: libStickerSets.PROFILE_SET_KEY
};

},{"./StickerSets.js":573}],573:[function(require,module,exports){
'use strict';

/**
 * StickerSets
 * -----------
 * The curated, named sticker sets. A "set" is the palette the moodboard / whiteboard gallery shows
 * BEFORE anyone searches; everything else in the three libraries is one search away (see ShapeLibrary
 * / Pict-Provider-ShapesAPI). This file is the single source of truth for the built-in (system) sets
 * and the place we iterate the picks until each one feels right.
 *
 * Each item is { Collection, Name, Title } where Collection is a ShapeLibrary key (phosphor / tabler /
 * simple) and Name is the on-disk icon name. Phosphor carries the two-color duotone look; tabler is a
 * single stroke; simple are brand marks. Every name here renders through ShapeLibrary.getSVG (a build
 * check prunes any that do not), so the gallery never shows a broken tile.
 *
 * Routing (resolved in StickerSetResolver + the app): a board shows the set its drafting kit names,
 * else a per-context default (design boards -> drafting-design, profiles -> moodboard), else the
 * built-in default. Changing or deleting a set never breaks a saved board: a placed sticker carries
 * its own identity + colors on the board node.
 *
 * Five maker themes (laser-cutting, sign-making, hydroponics, press-print, 3d-printing) are sparse in
 * the icon libraries on purpose; they ship as starter sets here and grow with custom uploads.
 */

// Terse constructors so a 16-set file stays readable. Most picks are phosphor.
const P = (pName, pTitle) => ({ Collection: 'phosphor', Name: pName, Title: pTitle });
const T = (pName, pTitle) => ({ Collection: 'tabler', Name: pName, Title: pTitle });
const S = (pName, pTitle) => ({ Collection: 'simple', Name: pName, Title: pTitle });

const _SETS =
{
	'drafting-design':
	{
		Label: 'Drafting & Design',
		Description: 'A design-first starter set: drawing tools, shapes, and the marks you put on a board.',
		Items:
		[
			P('pencil', 'Pencil'), P('pencil-ruler', 'Pencil & ruler'), P('pencil-line', 'Sketch'),
			P('ruler', 'Ruler'), P('compass-tool', 'Compass'), P('eraser', 'Eraser'), P('pen-nib', 'Pen'),
			P('paint-brush', 'Brush'), P('paint-brush-broad', 'Broad brush'), P('paint-bucket', 'Fill'),
			P('paint-roller', 'Roller'), P('palette', 'Palette'), P('swatches', 'Swatches'),
			P('eyedropper', 'Eyedropper'), P('scissors', 'Scissors'), P('crop', 'Crop'),
			P('frame-corners', 'Frame'), P('selection', 'Select'), P('shapes', 'Shapes'),
			P('triangle', 'Triangle'), P('bezier-curve', 'Curve'), P('vector-two', 'Vector'),
			P('note', 'Note'), P('note-pencil', 'Sticky note'), P('notepad', 'Notepad'),
			P('push-pin', 'Pin'), P('paperclip', 'Clip'), P('tag', 'Tag'), P('bookmark-simple', 'Bookmark'),
			P('lightbulb', 'Idea'), P('lightbulb-filament', 'Bright idea'), P('magic-wand', 'Wand'),
			P('sparkle', 'Sparkle'), P('star-four', 'Star'), P('coffee', 'Coffee'), P('plant', 'Plant'),
			P('potted-plant', 'Potted plant'), P('leaf', 'Leaf'), P('flag-banner', 'Flag'),
			P('check-circle', 'Done'), P('list-checks', 'Checklist'), P('clipboard-text', 'Clipboard'),
			P('calendar-blank', 'Calendar'), P('clock', 'Time'), P('chat-circle', 'Comment'),
			P('heart', 'Heart'), P('smiley', 'Smiley')
		]
	},
	'moodboard':
	{
		Label: 'Moodboard',
		Description: 'An expressive set for inspiration and brand boards: feelings, nature, and play.',
		Items:
		[
			P('heart', 'Heart'), P('heart-straight', 'Love'), P('hand-heart', 'With love'), P('star', 'Star'),
			P('star-four', 'Sparkle star'), P('sparkle', 'Sparkle'), P('sun', 'Sun'), P('sun-horizon', 'Sunrise'),
			P('moon-stars', 'Night'), P('rainbow', 'Rainbow'), P('cloud', 'Cloud'), P('flower', 'Flower'),
			P('flower-lotus', 'Lotus'), P('flower-tulip', 'Tulip'), P('leaf', 'Leaf'), P('butterfly', 'Butterfly'),
			P('bird', 'Bird'), P('music-notes', 'Music'), P('camera', 'Camera'), P('image', 'Photo'),
			P('palette', 'Palette'), P('coffee', 'Coffee'), P('gift', 'Gift'), P('balloon', 'Balloon'),
			P('confetti', 'Confetti'), P('cake', 'Cake'), P('crown', 'Crown'), P('trophy', 'Trophy'),
			P('fire', 'Fire'), P('lightning', 'Spark'), P('smiley', 'Smiley'), P('sunglasses', 'Cool'),
			P('martini', 'Drinks'), P('mountains', 'Mountains'), P('umbrella', 'Umbrella'), P('anchor', 'Anchor'),
			P('paw-print', 'Paw'), P('feather', 'Feather'), P('diamond', 'Gem'), P('planet', 'Planet'),
			P('sticker', 'Sticker'), P('bookmark-simple', 'Bookmark')
		]
	},
	'software-system':
	{
		Label: 'Software systems',
		Description: 'Services, data, and the wiring between them.',
		Items:
		[
			P('database', 'Database'), P('cloud', 'Cloud'), P('stack', 'Stack'), P('network', 'Network'),
			P('git-branch', 'Branch'), P('git-merge', 'Merge'), P('gauge', 'Gauge'), P('broadcast', 'Broadcast'),
			P('plugs-connected', 'Connected'), P('circuitry', 'Circuit'), P('hard-drives', 'Storage'),
			P('cpu', 'CPU'), P('tree-structure', 'Tree'), P('flow-arrow', 'Flow'), P('cube', 'Service'),
			S('docker', 'Docker'), S('kubernetes', 'Kubernetes'), S('postgresql', 'PostgreSQL'),
			S('redis', 'Redis'), S('nginx', 'Nginx')
		]
	},
	'software-ui':
	{
		Label: 'Software UI',
		Description: 'Screens, controls, and layout.',
		Items:
		[
			P('cursor', 'Cursor'), P('cursor-click', 'Click'), P('toggle-left', 'Toggle'),
			P('sliders-horizontal', 'Sliders'), P('layout', 'Layout'), P('squares-four', 'Grid'),
			P('sidebar-simple', 'Sidebar'), P('browser', 'Window'), P('browsers', 'Tabs'), P('rows', 'Rows'),
			P('columns', 'Columns'), P('text-aa', 'Text'), P('selection', 'Select'), P('frame-corners', 'Frame'),
			P('app-window', 'App window'), P('radio-button', 'Radio'), S('figma', 'Figma')
		]
	},
	'hardware':
	{
		Label: 'Hardware',
		Description: 'Boards, tools, and the things you plug in.',
		Items:
		[
			P('cpu', 'CPU'), P('memory', 'Memory'), P('wrench', 'Wrench'), P('screwdriver', 'Screwdriver'),
			P('hammer', 'Hammer'), P('plug', 'Plug'), P('plugs-connected', 'Connected'), P('wifi-high', 'Wifi'),
			P('monitor', 'Monitor'), P('devices', 'Devices'), P('battery-high', 'Battery'),
			P('circuitry', 'Circuit'), P('usb', 'USB'), P('gear-six', 'Gear'), P('nut', 'Nut'),
			P('lightning', 'Power'), P('desktop-tower', 'Computer'), P('hard-drives', 'Drive')
		]
	},
	'organization':
	{
		Label: 'Organization',
		Description: 'Sort, file, and keep track.',
		Items:
		[
			P('folder', 'Folder'), P('folder-open', 'Open'), P('folders', 'Folders'), P('archive', 'Archive'),
			P('tray', 'Tray'), P('tag', 'Tag'), P('funnel-simple', 'Filter'), P('kanban', 'Board'),
			P('clipboard-text', 'Clipboard'), P('basket', 'Basket'), P('stack', 'Stack'),
			P('bookmarks-simple', 'Bookmarks'), P('note', 'Note'), P('push-pin', 'Pin'), P('paperclip', 'Clip'),
			P('list-checks', 'Checklist'), P('check-square', 'Check'), P('calendar-blank', 'Calendar')
		]
	},
	'art':
	{
		Label: 'Art & illustration',
		Description: 'Brushes, color, and the studio.',
		Items:
		[
			P('palette', 'Palette'), P('paint-brush', 'Brush'), P('paint-brush-broad', 'Broad brush'),
			P('paint-bucket', 'Fill'), P('pen-nib', 'Pen'), P('swatches', 'Swatches'),
			P('eyedropper', 'Eyedropper'), P('image', 'Image'), P('images', 'Gallery'), P('scissors', 'Scissors'),
			P('crop', 'Crop'), P('frame-corners', 'Frame'), P('pencil', 'Pencil'), P('camera', 'Camera'),
			P('spray-bottle', 'Spray'), S('inkscape', 'Inkscape'), S('gimp', 'GIMP'), S('blender', 'Blender'),
			S('krita', 'Krita')
		]
	},
	'music':
	{
		Label: 'Music',
		Description: 'Notes, instruments, and gear.',
		Items:
		[
			P('music-note', 'Note'), P('music-notes', 'Notes'), P('music-notes-simple', 'Tune'),
			P('guitar', 'Guitar'), P('piano-keys', 'Piano'), P('metronome', 'Metronome'),
			P('microphone', 'Mic'), P('microphone-stage', 'Stage'), P('headphones', 'Headphones'),
			P('speaker-high', 'Speaker'), P('vinyl-record', 'Vinyl'), P('radio', 'Radio'),
			P('playlist', 'Playlist'), P('waveform', 'Waveform')
		]
	},
	'classroom-activity':
	{
		Label: 'Classroom',
		Description: 'Teaching, learning, and the school day.',
		Items:
		[
			P('graduation-cap', 'Graduate'), P('chalkboard', 'Chalkboard'), P('chalkboard-teacher', 'Teacher'),
			P('student', 'Student'), P('backpack', 'Backpack'), P('book', 'Book'), P('book-open', 'Open book'),
			P('pencil', 'Pencil'), P('presentation', 'Presentation'), P('puzzle-piece', 'Puzzle'),
			P('ruler', 'Ruler'), P('notebook', 'Notebook'), P('exam', 'Exam')
		]
	},
	'gardening':
	{
		Label: 'Gardening',
		Description: 'Plants, beds, and the tools to tend them.',
		Items:
		[
			P('plant', 'Plant'), P('potted-plant', 'Potted plant'), P('tree', 'Tree'),
			P('tree-evergreen', 'Evergreen'), P('flower', 'Flower'), P('flower-tulip', 'Tulip'),
			P('leaf', 'Leaf'), P('shovel', 'Shovel'), P('drop', 'Water'), P('sun-horizon', 'Sun'),
			P('thermometer', 'Temperature'), P('carrot', 'Carrot'), P('cactus', 'Cactus'),
			T('garden-cart', 'Cart'), T('plant-2', 'Sprout')
		]
	},
	'hydroponics':
	{
		Label: 'Hydroponics',
		Description: 'A starter set for water-grown systems. Add your own grow lights and net pots.',
		Items:
		[
			P('drop', 'Water'), P('drop-half-bottom', 'Reservoir'), P('flow-arrow', 'Flow'),
			P('test-tube', 'Test tube'), P('flask', 'Nutrients'), P('thermometer', 'Temperature'),
			P('plant', 'Plant'), P('sun-horizon', 'Light'), P('gauge', 'pH'), T('plant-2', 'Sprout')
		]
	},
	'laser-cutting':
	{
		Label: 'Laser cutting',
		Description: 'A starter set. The maker-specific marks (laser head, kerf, bed) come from uploads.',
		Items:
		[
			P('crosshair', 'Focus'), P('lightning', 'Beam'), P('scan', 'Engrave'), P('ruler', 'Ruler'),
			P('cube', 'Material'), P('frame-corners', 'Bed'), P('grid-four', 'Grid'), P('scissors', 'Cut'),
			T('vector', 'Vector'), T('dimensions', 'Dimensions')
		]
	},
	'sign-making':
	{
		Label: 'Sign making',
		Description: 'A starter set. Add vinyl cutter, weeding tools, and transfer tape as uploads.',
		Items:
		[
			P('text-aa', 'Lettering'), P('swatches', 'Swatches'), P('ruler', 'Ruler'), P('scissors', 'Cut'),
			P('frame-corners', 'Layout'), P('paint-roller', 'Apply'), T('typography', 'Type'),
			T('signature', 'Sign'), T('vinyl', 'Vinyl')
		]
	},
	'press-print':
	{
		Label: 'Press & print',
		Description: 'A starter set. Add screen, squeegee, and registration marks as uploads.',
		Items:
		[
			P('printer', 'Printer'), P('newspaper', 'Press'), P('stamp', 'Stamp'),
			P('paint-roller', 'Ink roller'), P('stack', 'Stack'), P('copy', 'Copies'), P('swatches', 'Swatches')
		]
	},
	'3d-printing':
	{
		Label: '3D printing',
		Description: 'A starter set. Add printer, filament spool, and nozzle as uploads.',
		Items:
		[
			P('cube', 'Model'), P('cube-transparent', 'Mesh'), P('cube-focus', 'Slice'), P('polygon', 'Polygon'),
			P('sphere', 'Sphere'), T('cone', 'Cone'), P('scan', 'Scan'), P('stack', 'Layers'),
			P('ruler', 'Measure'), T('cube-3d-sphere', '3D'), T('axis-x', 'X axis'), T('axis-y', 'Y axis')
		]
	}
};

// Display order for the picker / preview, and the routing keys the resolver + app rely on.
const SET_ORDER =
[
	'drafting-design', 'moodboard', 'software-system', 'software-ui', 'hardware', 'organization',
	'art', 'music', 'classroom-activity', 'gardening', 'hydroponics', 'laser-cutting', 'sign-making',
	'press-print', '3d-printing'
];

// The built-in fallback (design boards) and the profile/brand fallback.
const DEFAULT_SET_KEY = 'drafting-design';
const PROFILE_SET_KEY = 'moodboard';

module.exports = { Sets: _SETS, SET_ORDER, DEFAULT_SET_KEY, PROFILE_SET_KEY };

},{}],574:[function(require,module,exports){
'use strict';

/**
 * The single source of truth for renameable product terminology (the "Drafting
 * Kit" vocabulary). Required by both the server (label resolution onto the
 * session) and the client (libLabels), since source/ is bundled for the browser.
 *
 * A Drafting Kit is a VisionType; its overrides live in that VisionType's
 * MetadataManifest.Terms as { <TermKey>: { Singular, Plural, Description } }.
 * resolveTerms() merges those over these defaults to produce the full effective
 * map that the client labels everything from. The DEFAULT_TERMS labels are lifted
 * verbatim from EntityDescriptors (Title/Plural) and SiteMap (nav Names +
 * Descriptions), so behavior is identical when a plan sheet has set no kit.
 *
 * Description is the secondary blurb under a renamed nav item: a craft that
 * renames Test Runs to "Read-throughs" can also say what a Read-through is,
 * instead of inheriting the stock "Executions of routines, step by step."
 */

// The concepts a plan sheet may rename. (KeystoneCustomer is intentionally not
// here -- it stays literal.)
const TERM_KEYS =
[
	'Vision', 'Module', 'Feature', 'WorkItem', 'Routine', 'TestRun',
	'Feedback', 'Whiteboard', 'Documentation', 'Comment', 'Blueprint', 'Deliverable'
];

// Singular / Plural are short labels; Description is the secondary nav blurb.
// Descriptions are lifted verbatim from the SiteMap nav items so the rail reads
// identically when no kit is set; the three non-nav concepts carry sensible text.
const DEFAULT_TERMS =
{
	Vision:        { Singular: 'Vision',     Plural: 'Visions',       Description: 'What you are building and why.' },
	Module:        { Singular: 'Module',     Plural: 'Modules',       Description: 'The parts of the system.' },
	Feature:       { Singular: 'Feature',    Plural: 'Features',      Description: 'What each module does.' },
	WorkItem:      { Singular: 'Work Item',  Plural: 'Work Items',    Description: 'The tasks in flight.' },
	Routine:       { Singular: 'Routine',    Plural: 'Routines',      Description: 'Step-by-step procedures to exercise the product.' },
	TestRun:       { Singular: 'Test Run',   Plural: 'Test Runs',     Description: 'Executions of routines, step by step.' },
	Feedback:      { Singular: 'Feedback',   Plural: 'Feedback',      Description: 'What testers and customers said.' },
	Whiteboard:    { Singular: 'Whiteboard', Plural: 'Whiteboards',   Description: 'A free-form canvas of ideas.' },
	Documentation: { Singular: 'Document',   Plural: 'Documentation', Description: 'The team library.' },
	Comment:       { Singular: 'Comment',    Plural: 'Comments',      Description: 'Notes and discussion.' },
	Blueprint:     { Singular: 'Blueprint',  Plural: 'Blueprints',    Description: 'A work item and everything attached to it.' },
	Deliverable:   { Singular: 'Deliverable', Plural: 'Deliverables',  Description: 'What a customer expects you to deliver.' }
};

// Short labels cap at 64; the Description blurb gets more room (a short sentence).
function _clean(pValue, pMax)
{
	return String(pValue == null ? '' : pValue).trim().slice(0, pMax || 64);
}

/**
 * Merge a kit's term overrides over the defaults. Returns a full map (every key
 * present, with Singular, Plural and Description), so callers never have to fall
 * back per key.
 *
 * @param {object} pKitTerms - { <TermKey>: { Singular?, Plural?, Description? } } or null.
 * @returns {object} full effective terms map.
 */
function resolveTerms(pKitTerms)
{
	let tmpKit = (pKitTerms && typeof pKitTerms === 'object') ? pKitTerms : {};
	let tmpOut = {};
	for (let i = 0; i < TERM_KEYS.length; i++)
	{
		let tmpKey = TERM_KEYS[i];
		let tmpDefault = DEFAULT_TERMS[tmpKey];
		let tmpOverride = (tmpKit[tmpKey] && typeof tmpKit[tmpKey] === 'object') ? tmpKit[tmpKey] : {};
		tmpOut[tmpKey] =
		{
			Singular:    tmpOverride.Singular    ? _clean(tmpOverride.Singular)         : tmpDefault.Singular,
			Plural:      tmpOverride.Plural      ? _clean(tmpOverride.Plural)           : tmpDefault.Plural,
			Description: tmpOverride.Description  ? _clean(tmpOverride.Description, 160)  : tmpDefault.Description
		};
	}
	return tmpOut;
}

module.exports =
{
	TERM_KEYS: TERM_KEYS,
	DEFAULT_TERMS: DEFAULT_TERMS,
	resolveTerms: resolveTerms
};

},{}],575:[function(require,module,exports){
'use strict';

/**
 * Label resolver for the Drafting Kit language layer. The one helper every view
 * calls instead of hardcoding entity nouns. Reads the resolved lexicon off the
 * session (AppData.Auth.User.Lexicon, the plan sheet's default-kit terms), with
 * an optional per-vision scope override and Terms.DEFAULT_TERMS as the floor.
 *
 * Resolution order (first hit wins): pScopeTerms -> shell lexicon -> defaults ->
 * caller fallback -> the key itself. EntityDescriptors is NOT mutated; it stays
 * the canonical fallback (callers pass descriptor labels as pFallback for keys
 * that have no term, e.g. KeystoneCustomer).
 */

const libTerms = require('./Terms.js');

function _shellLexicon(pPict)
{
	return (pPict && pPict.AppData && pPict.AppData.Auth && pPict.AppData.Auth.User && pPict.AppData.Auth.User.Lexicon) || null;
}

function _pick(pField, pPict, pKey, pScopeTerms, pFallback)
{
	if (pScopeTerms && pScopeTerms[pKey] && pScopeTerms[pKey][pField]) { return pScopeTerms[pKey][pField]; }
	let tmpShell = _shellLexicon(pPict);
	if (tmpShell && tmpShell[pKey] && tmpShell[pKey][pField]) { return tmpShell[pKey][pField]; }
	if (libTerms.DEFAULT_TERMS[pKey] && libTerms.DEFAULT_TERMS[pKey][pField]) { return libTerms.DEFAULT_TERMS[pKey][pField]; }
	return (pFallback != null) ? pFallback : pKey;
}

// The plural / heading form (e.g. "Modules" or "Collections").
function plural(pPict, pKey, pScopeTerms, pFallback) { return _pick('Plural', pPict, pKey, pScopeTerms, pFallback); }
// The singular form (e.g. "Module" or "Collection").
function singular(pPict, pKey, pScopeTerms, pFallback) { return _pick('Singular', pPict, pKey, pScopeTerms, pFallback); }
// The list-page / section heading; today the plural.
function title(pPict, pKey, pScopeTerms, pFallback) { return plural(pPict, pKey, pScopeTerms, pFallback); }
// The secondary descriptive blurb (e.g. under a nav item or list heading).
function description(pPict, pKey, pScopeTerms, pFallback) { return _pick('Description', pPict, pKey, pScopeTerms, pFallback); }

module.exports =
{
	plural: plural,
	singular: singular,
	title: title,
	description: description
};

},{"./Terms.js":574}],576:[function(require,module,exports){
'use strict';

/**
 * FrameworkClient -- the adoption seam onto the Fable RestClient + pict.EntityProvider.
 *
 * Plansheet historically hand-rolled `fetch()` in every provider, bypassing the
 * framework's networking layer entirely. That is why an expired session was
 * invisible: a raw fetch 401 just rejected somewhere a click handler swallowed.
 *
 * Routing providers through here funnels every data path onto the ONE RestClient
 * instance that carries the authenticationRecovery hook (pict.EntityProvider's
 * restClient, armed by Pict-Application-Plansheet._enableSessionRecovery). So a
 * 401 on any of these calls transparently drives the in-place re-auth modal and
 * replays the original request -- reads and writes alike -- and CRUD additionally
 * rides EntityProvider's cachetrax record cache.
 *
 * These are thin, promise-returning wrappers so migrated providers keep the exact
 * method signatures their views already call.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// The shared RestClient (same instance the recovery hook is wired onto).
function _restClient(pPict)
{
	return (pPict && pPict.EntityProvider) ? pPict.EntityProvider.restClient : null;
}

function _entityProvider(pPict)
{
	return (pPict && pPict.EntityProvider) ? pPict.EntityProvider : null;
}

// Build an Error that carries the HTTP status and the server's message, matching
// the shape the old `throw new Error('HTTP ' + status)` produced so view-side
// catch/_toast handling is unchanged.
function _httpError(pStatus, pBody)
{
	let tmpMessage = 'HTTP ' + pStatus;
	if (pBody && typeof pBody === 'object' && pBody.Error) { tmpMessage = pBody.Error; }
	let tmpError = new Error(tmpMessage);
	tmpError.StatusCode = pStatus;
	return tmpError;
}

// EntityProvider's CRUD callbacks hand back the parsed body but not the HTTP
// response, so a non-2xx (e.g. a 401 whose recovery was declined) arrives as a
// meadow error envelope { Error, StatusCode } with a null error. Detect that
// shape and turn it into a rejection so views' catch/_toast paths still fire.
function _entityErrorFromBody(pBody)
{
	if (pBody && typeof pBody === 'object' && typeof pBody.StatusCode === 'number' && pBody.StatusCode >= 400)
	{
		return _httpError(pBody.StatusCode, pBody);
	}
	return null;
}

// Run a RestClient JSON verb as a promise. Any completed 401 has already been
// through the recovery hook by the time this callback fires (recovered -> the
// body here is the replayed 200; declined -> we surface the 401 as a rejection).
function _verb(pPict, pVerb, pURL, pBody)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpRestClient = _restClient(pPict);
		if (!tmpRestClient) { return fReject(new Error('Framework RestClient is not available.')); }
		let tmpOptions = { url: pURL };
		if (pBody !== undefined) { tmpOptions.body = pBody; }
		tmpRestClient[pVerb](tmpOptions, (pError, pResponse, pResultBody) =>
		{
			if (pError) { return fReject(pError); }
			let tmpStatus = pResponse ? pResponse.statusCode : 0;
			if (tmpStatus >= 400) { return fReject(_httpError(tmpStatus, pResultBody)); }
			return fResolve(pResultBody);
		});
	});
}

// ---- Custom endpoint verbs (any /1.0/ route) -----------------------------
// Pass fully-qualified paths, e.g. '/1.0/Features/0/500'. Every one is
// recovery-covered because it rides the shared RestClient.
function getJSON(pPict, pURL) { return _verb(pPict, 'getJSON', pURL); }
function postJSON(pPict, pURL, pBody) { return _verb(pPict, 'postJSON', pURL, pBody || {}); }
function putJSON(pPict, pURL, pBody) { return _verb(pPict, 'putJSON', pURL, pBody || {}); }
function delJSON(pPict, pURL) { return _verb(pPict, 'delJSON', pURL); }

// ---- Non-JSON reads (recovery-covered) -----------------------------------
// Plain-text GET (e.g. a rendered markdown/help doc). Rejects on >= 400 so
// callers can .catch(() => '') to preserve an empty-on-error contract.
function getText(pPict, pURL)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpRestClient = _restClient(pPict);
		if (!tmpRestClient) { return fReject(new Error('Framework RestClient is not available.')); }
		tmpRestClient.getRawText({ url: pURL }, (pError, pResponse, pBody) =>
		{
			if (pError) { return fReject(pError); }
			let tmpStatus = pResponse ? pResponse.statusCode : 0;
			if (tmpStatus >= 400) { return fReject(_httpError(tmpStatus, null)); }
			return fResolve(pBody == null ? '' : String(pBody));
		});
	});
}

// Binary GET returning an ArrayBuffer (e.g. a session zip for the parser). The
// RestClient hands back a Buffer; we slice out its backing ArrayBuffer so the
// browser-side consumers (parseZip, etc.) get exactly what fetch().arrayBuffer()
// would have given them.
function getBinary(pPict, pURL)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpRestClient = _restClient(pPict);
		if (!tmpRestClient) { return fReject(new Error('Framework RestClient is not available.')); }
		tmpRestClient.executeChunkedRequestBinary({ url: pURL, method: 'GET' }, (pError, pResponse, pBuffer) =>
		{
			if (pError) { return fReject(pError); }
			let tmpStatus = pResponse ? pResponse.statusCode : 0;
			if (tmpStatus >= 400) { return fReject(_httpError(tmpStatus, null)); }
			if (!pBuffer) { return fResolve(new ArrayBuffer(0)); }
			// Buffer -> ArrayBuffer (respecting byteOffset/length of the view).
			let tmpArrayBuffer = pBuffer.buffer.slice(pBuffer.byteOffset, pBuffer.byteOffset + pBuffer.byteLength);
			return fResolve(tmpArrayBuffer);
		});
	});
}

// ---- Binary upload (recovery-covered) ------------------------------------
// Wraps the RestClient's binary path (Blob/File/Buffer/ArrayBuffer bodies).
// The server returns a JSON status envelope, which we parse. A 401 here rides
// the same recovery + replay seam as the JSON verbs.
function uploadBinary(pPict, pURL, pBody, pMimeType, pMethod)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpRestClient = _restClient(pPict);
		if (!tmpRestClient) { return fReject(new Error('Framework RestClient is not available.')); }
		let tmpOptions =
		{
			url: pURL,
			method: pMethod || 'POST',
			body: pBody,
			headers: { 'Content-Type': pMimeType || 'application/octet-stream' }
		};
		tmpRestClient.executeBinaryUpload(tmpOptions, (pError, pResponse, pResultBody) =>
		{
			if (pError) { return fReject(pError); }
			let tmpStatus = pResponse ? pResponse.statusCode : 0;
			let tmpParsed = null;
			try { tmpParsed = pResultBody ? JSON.parse(pResultBody) : null; }
			catch (pParseError) { tmpParsed = pResultBody; }
			if (tmpStatus >= 400) { return fReject(_httpError(tmpStatus, tmpParsed)); }
			return fResolve(tmpParsed);
		});
	});
}

// ---- CRUD via EntityProvider (cachetrax-cached reads, invalidating writes) -
function getEntity(pPict, pEntityType, pIDRecord)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpEntityProvider = _entityProvider(pPict);
		if (!tmpEntityProvider) { return fReject(new Error('Framework EntityProvider is not available.')); }
		tmpEntityProvider.getEntity(pEntityType, pIDRecord, (pError, pRecord) =>
		{
			if (pError) { return fReject(pError); }
			let tmpBodyError = _entityErrorFromBody(pRecord);
			if (tmpBodyError) { return fReject(tmpBodyError); }
			return fResolve(pRecord);
		});
	});
}

function createEntity(pPict, pEntityType, pRecord)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpEntityProvider = _entityProvider(pPict);
		if (!tmpEntityProvider) { return fReject(new Error('Framework EntityProvider is not available.')); }
		tmpEntityProvider.createEntity(pEntityType, pRecord, (pError, pRecordBody) =>
		{
			if (pError) { return fReject(pError); }
			let tmpBodyError = _entityErrorFromBody(pRecordBody);
			if (tmpBodyError) { return fReject(tmpBodyError); }
			return fResolve(pRecordBody);
		});
	});
}

function updateEntity(pPict, pEntityType, pRecord)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpEntityProvider = _entityProvider(pPict);
		if (!tmpEntityProvider) { return fReject(new Error('Framework EntityProvider is not available.')); }
		tmpEntityProvider.updateEntity(pEntityType, pRecord, (pError, pRecordBody) =>
		{
			if (pError) { return fReject(pError); }
			let tmpBodyError = _entityErrorFromBody(pRecordBody);
			if (tmpBodyError) { return fReject(tmpBodyError); }
			return fResolve(pRecordBody);
		});
	});
}

function deleteEntity(pPict, pEntityType, pIDRecord)
{
	return new Promise((fResolve, fReject) =>
	{
		let tmpEntityProvider = _entityProvider(pPict);
		if (!tmpEntityProvider) { return fReject(new Error('Framework EntityProvider is not available.')); }
		tmpEntityProvider.deleteEntity(pEntityType, pIDRecord, (pError, pRecordBody) =>
		{
			if (pError) { return fReject(pError); }
			let tmpBodyError = _entityErrorFromBody(pRecordBody);
			if (tmpBodyError) { return fReject(tmpBodyError); }
			return fResolve(pRecordBody);
		});
	});
}

module.exports =
{
	getJSON,
	postJSON,
	putJSON,
	delJSON,
	getText,
	getBinary,
	uploadBinary,
	getEntity,
	createEntity,
	updateEntity,
	deleteEntity
};

},{}],577:[function(require,module,exports){
'use strict';

/**
 * Moodboard-DrawingSource
 * -----------------------
 * Backs the moodboard Drawing card's picker (options.DrawingSource). It surfaces two things a person
 * would expect under "pull a drawing": the team's Excalidraw **Drawings** (Media owned by
 * OwnerType 'Drawing', IDOwner 0 -- see PictView-DrawingsPage: each is a self-contained SVG blob with
 * its scene embedded), plus this board's own gallery Media (OwnerType 'Moodboard', IDOwner = the open
 * board). Drawings come first because that is the thing the card is named for.
 *
 * It extends Moodboard-MediaImageSource so the field descriptors, query (search / filter / sort),
 * upload (an uploaded file lands in the board gallery), and _toItem all come for free; only list() and
 * getItem() are widened to also read the Drawings collection. Both collections are Media rows keyed by
 * IDMedia, so a drawing card links to one by id and "Update from source" re-pulls it -- and because a
 * re-saved Excalidraw drawing replaces the same IDMedia's bytes, the card refreshes to the new version.
 */

const libMoodboardMediaImageSource = require('./Moodboard-MediaImageSource.js');

const _DRAWINGS_OWNER_TYPE = 'Drawing';
const _DRAWINGS_OWNER_ID = 0;

class MoodboardDrawingSource extends libMoodboardMediaImageSource
{
	// Fetch the team drawings + this board's gallery, mapped to items and deduped by IDMedia (drawings first).
	_collect()
	{
		if (!this._MediaAPI) { return Promise.resolve([]); }
		let tmpOwnerId = this._getOwnerId();
		let tmpDrawings = this._MediaAPI.listForOwner(_DRAWINGS_OWNER_TYPE, _DRAWINGS_OWNER_ID).catch(() => []);
		let tmpBoard = this._hasOwner(tmpOwnerId) ? this._MediaAPI.listForOwner(this._OwnerType, tmpOwnerId).catch(() => []) : Promise.resolve([]);
		return Promise.all([tmpDrawings, tmpBoard]).then((pResults) =>
		{
			let tmpRows = (Array.isArray(pResults[0]) ? pResults[0] : []).concat(Array.isArray(pResults[1]) ? pResults[1] : []);
			let tmpSeen = {};
			let tmpItems = [];
			tmpRows.forEach((pRow) =>
			{
				if (pRow && (pRow.IDMedia != null) && !tmpSeen[pRow.IDMedia])
				{
					tmpSeen[pRow.IDMedia] = true;
					tmpItems.push(this._toItem(pRow));
				}
			});
			return tmpItems;
		});
	}

	list(pQuery)
	{
		return this._collect().then((pItems) => this._applyQuery(pItems, pQuery || {})).catch(() => []);
	}

	getItem(pId)
	{
		if (pId == null) { return Promise.resolve(null); }
		return this._collect()
			.then((pItems) => pItems.find((pItem) => String(pItem.Id) === String(pId)) || null)
			.catch(() => null);
	}
}

module.exports = MoodboardDrawingSource;

},{"./Moodboard-MediaImageSource.js":578}],578:[function(require,module,exports){
'use strict';

/**
 * Moodboard-MediaImageSource
 * --------------------------
 * Adapts the plansheet Media library to the image-source interface that pict-section-moodboard's view
 * expects (options.ImageSource). The moodboard gallery is driven entirely by whatever this object
 * declares, so the customer's uploaded Media shows up as the board's gallery with search / filter /
 * sort, and dropped or pasted image files get stored as Media owned by the open board.
 *
 * The board owner is read lazily through getOwnerId() so one source instance serves every board the
 * user opens (the owner is the current IDMoodboard). Media owned by (OwnerType 'Moodboard',
 * IDOwner = that id) is the gallery.
 *
 * Interface used by the moodboard view:
 *   getFields()                       -> field descriptors (drives the gallery's filter/sort controls)
 *   getFilterOptions(key)             -> distinct values for a filterable field
 *   list({ Search, Filters, Sort })   -> Promise<item[]> ({ Id, Name, Url, Thumbnail, Metadata })
 *   upload(file, dataUrl, callback)   -> store the bytes as Media, callback(null, { Url, Id, Name })
 *   add(record)                       -> no-op: an external URL is not a Media blob, so it is left on
 *                                        the board but not added to the customer's Media gallery
 */

const _FIELDS =
[
	{ Key: 'Name', Label: 'Name', Type: 'string', Searchable: true, Sortable: true },
	{ Key: 'MediaType', Label: 'Type', Type: 'enum', Filterable: true, Sortable: true, Searchable: true },
	{ Key: 'AddedAt', Label: 'Added', Type: 'date', Sortable: true }
];

const _MEDIA_TYPES = ['Screenshot', 'Photo', 'Drawing', 'Recording', 'HowTo', 'Other'];

class MoodboardMediaImageSource
{
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};
		this._MediaAPI = tmpOptions.MediaAPI || null;
		// A function returning the current board id (IDMoodboard) the gallery is scoped to.
		this._getOwnerId = (typeof tmpOptions.getOwnerId === 'function') ? tmpOptions.getOwnerId : function () { return null; };
		this._OwnerType = tmpOptions.OwnerType || 'Moodboard';
		// Boards that hang off an entity report a falsy owner while none is open, so a falsy id normally
		// means "no bucket yet" and the gallery stays empty. A board that belongs to the PLAN SHEET rather
		// than to a record (the top-bar backdrop, WI #360) has no entity id at all, and cannot invent one:
		// IDCustomer must never travel client-side. Such a source opts in here, and IDOwner 0 under its own
		// OwnerType becomes a real, tenant-scoped bucket -- the server scopes every Media read and write to
		// the session's plan sheet, so 0 is unambiguous.
		this._AllowZeroOwner = (tmpOptions.AllowZeroOwner === true);
	}

	// Is there a bucket to read from / write to? Zero counts only for a source that opted in above.
	_hasOwner(pOwnerId)
	{
		if (this._AllowZeroOwner) { return (pOwnerId !== null && typeof pOwnerId !== 'undefined'); }
		return !!pOwnerId;
	}

	getFields()
	{
		return _FIELDS.map((pField) => Object.assign({}, pField));
	}

	getFilterOptions(pKey)
	{
		if (pKey === 'MediaType') { return _MEDIA_TYPES.slice(); }
		return [];
	}

	list(pQuery)
	{
		let tmpOwnerId = this._getOwnerId();
		if (!this._MediaAPI || !this._hasOwner(tmpOwnerId))
		{
			return Promise.resolve([]);
		}
		return this._MediaAPI.listForOwner(this._OwnerType, tmpOwnerId)
			.then((pRows) =>
			{
				let tmpItems = (Array.isArray(pRows) ? pRows : []).map((pRow) => this._toItem(pRow));
				return this._applyQuery(tmpItems, pQuery || {});
			})
			.catch(() => []);
	}

	upload(pFile, pDataUrl, fCallback)
	{
		let tmpOwnerId = this._getOwnerId();
		if (!this._MediaAPI || !this._hasOwner(tmpOwnerId))
		{
			// No place to store it; fall back to the data URL so the image still lands on the board.
			if (typeof fCallback === 'function') { fCallback(null, { Url: pDataUrl, Name: (pFile && pFile.name) || 'image' }); }
			return;
		}
		this._MediaAPI.upload(this._OwnerType, tmpOwnerId, pFile, {})
			.then((pRef) =>
			{
				let tmpID = pRef && pRef.IDMedia;
				if (typeof fCallback === 'function') { fCallback(null, { Url: this._MediaAPI.blobURL(tmpID), Id: tmpID, Name: (pFile && pFile.name) || 'image' }); }
			})
			.catch((pError) =>
			{
				// On failure, still place the image via its data URL so the user does not lose the drop.
				if (typeof fCallback === 'function') { fCallback(null, { Url: pDataUrl, Name: (pFile && pFile.name) || 'image' }); }
			});
	}

	// An external URL (pasted/dropped link) is not a Media blob; leave it on the board, out of the gallery.
	add(pRecord) { return null; }

	// Fetch one gallery item by its id, for a drawing card's "Update from source". Media is scoped to the
	// open board's owner, so find it within that owner's set (Promise<item|null>).
	getItem(pId)
	{
		let tmpOwnerId = this._getOwnerId();
		if (!this._MediaAPI || !this._hasOwner(tmpOwnerId) || pId == null) { return Promise.resolve(null); }
		return this._MediaAPI.listForOwner(this._OwnerType, tmpOwnerId)
			.then((pRows) =>
			{
				let tmpRow = (Array.isArray(pRows) ? pRows : []).find((pRow) => String(pRow.IDMedia) === String(pId));
				return tmpRow ? this._toItem(tmpRow) : null;
			})
			.catch(() => null);
	}

	_toItem(pRow)
	{
		let tmpURL = this._MediaAPI ? this._MediaAPI.blobURL(pRow.IDMedia) : '';
		return {
			Id: pRow.IDMedia,
			Name: pRow.Title || pRow.OriginalFileName || ('Media ' + pRow.IDMedia),
			Url: tmpURL,
			Thumbnail: tmpURL,
			// MimeType + OriginalFileName let a drawing card tell an SVG source from a raster one (so an SVG
			// drawing is inlined as vector into the board SVG rather than referenced as a raster <image>).
			Metadata: { MediaType: pRow.MediaType || 'Other', MimeType: pRow.MimeType || '', OriginalFileName: pRow.OriginalFileName || '', AddedAt: pRow.CreateDate || '', SizeBytes: pRow.FileSizeBytes || 0 }
		};
	}

	_fieldValue(pItem, pKey)
	{
		if (pKey === 'Name') { return pItem.Name; }
		return (pItem.Metadata && typeof pItem.Metadata[pKey] !== 'undefined') ? pItem.Metadata[pKey] : '';
	}

	_applyQuery(pItems, pQuery)
	{
		let tmpItems = pItems.slice();

		let tmpSearch = (pQuery.Search || '').trim().toLowerCase();
		if (tmpSearch)
		{
			tmpItems = tmpItems.filter((pItem) =>
			{
				let tmpHay = (pItem.Name + ' ' + this._fieldValue(pItem, 'MediaType')).toLowerCase();
				return tmpHay.indexOf(tmpSearch) >= 0;
			});
		}

		let tmpFilters = pQuery.Filters || {};
		Object.keys(tmpFilters).forEach((pKey) =>
		{
			let tmpValue = tmpFilters[pKey];
			if (tmpValue === '' || tmpValue == null) { return; }
			tmpItems = tmpItems.filter((pItem) => String(this._fieldValue(pItem, pKey)) === String(tmpValue));
		});

		if (pQuery.Sort && pQuery.Sort.Field)
		{
			let tmpField = pQuery.Sort.Field;
			let tmpDir = (pQuery.Sort.Direction === 'desc') ? -1 : 1;
			tmpItems.sort((pA, pB) =>
			{
				let tmpAV = this._fieldValue(pA, tmpField);
				let tmpBV = this._fieldValue(pB, tmpField);
				if (tmpAV < tmpBV) { return -1 * tmpDir; }
				if (tmpAV > tmpBV) { return 1 * tmpDir; }
				return 0;
			});
		}

		return tmpItems;
	}
}

module.exports = MoodboardMediaImageSource;

},{}],579:[function(require,module,exports){
'use strict';

/**
 * Moodboard-StickerSource
 * -----------------------
 * Adapts the plansheet sticker library to the StickerSource interface that pict-section-moodboard's
 * view expects (options.StickerSource). It merges three sets into one gallery:
 *   - the curated default stickers (ShapeSets), drawn from the bundled icon libraries, shown in the
 *     empty state (or the module's BUILTIN_STICKERS when no ShapesAPI is wired);
 *   - the rest of the icon libraries (Phosphor / Tabler / Brands), reachable by searching or by
 *     picking a Library filter, served recolored through ShapesAPI;
 *   - the customer's own uploaded stickers, read through StickerAPI.
 *
 * Uploads go through StickerAPI (admin-gated server-side; SVG is sanitized on store). Picking an
 * existing sticker just places it on the board, so add() is a no-op (it is already a URL).
 *
 * Interface used by the moodboard view (same contract as ImageSource):
 *   getFields() / getFilterOptions(key) / list(query) -> Promise<item[]> / upload(file, dataUrl, cb) / add(record)
 */

const libStickerResolver = require('../StickerSetResolver.js');

let _BUILTIN_STICKERS = [];
try { _BUILTIN_STICKERS = require('pict-section-moodboard/source/sources/StickerSource-Base.js').BUILTIN_STICKERS || []; }
catch (pErr) { _BUILTIN_STICKERS = []; }

// Library display label per ShapeLibrary collection key, and the reverse map for the gallery filter.
const _COLLECTION_LABEL = { phosphor: 'Phosphor', tabler: 'Tabler', simple: 'Brands' };
// The ShapeLibrary server-side recolor defaults; the sticker panel's color pickers start here so a freshly
// placed sticker shows its real colors before any override (phosphor pri=detail, sec=silhouette).
const _DEFAULT_PRI = '#1f3a52';
const _DEFAULT_SEC = '#9cc0e0';
const _LIBRARY_KEY = { 'Phosphor': 'phosphor', 'Tabler': 'tabler', 'Brands': 'simple' };

const _FIELDS =
[
	{ Key: 'Name', Label: 'Name', Type: 'string', Searchable: true, Sortable: true },
	{ Key: 'Collection', Label: 'Library', Type: 'enum', Filterable: true, Sortable: true }
];
const _COLLECTION_OPTIONS = ['Phosphor', 'Tabler', 'Brands', 'Uploads'];

class MoodboardStickerSource
{
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};
		this._StickerAPI = tmpOptions.StickerAPI || null;
		this._ShapesAPI = tmpOptions.ShapesAPI || null;
		// The bundled module built-ins, kept as the default set only when no ShapesAPI is wired.
		this._BuiltInItems = (Array.isArray(tmpOptions.BuiltInStickers) ? tmpOptions.BuiltInStickers : _BUILTIN_STICKERS).map((pSticker) =>
			({
				Id: String(pSticker.Id),
				Name: pSticker.Name || 'Sticker',
				Url: pSticker.Url,
				Thumbnail: pSticker.Url,
				Metadata: { Collection: 'Built-in', AddedAt: 0 }
			}));
		// The active sticker set is the gallery's empty state; everything else in the libraries is one
		// search away. The set is resolved per board context (drafting-design by default, or whatever
		// the host passes as SetKey / sets later via setActiveSet). Without a ShapesAPI we fall back to
		// the module's bundled built-ins, which carry their own data-URL art.
		this._SetItems = libStickerResolver.resolveStickerSet(tmpOptions.SetKey || libStickerResolver.DEFAULT_SET_KEY);
		this._DefaultItems = this._ShapesAPI
			? this._SetItems.map((pShape) => this._setItemToGalleryItem(pShape))
			: this._BuiltInItems;
	}

	// Swap the gallery's before-search palette to a different sticker set: a set key like 'moodboard',
	// or a raw items array from a custom set. Live search, uploads, and recolor are unaffected. A no-op
	// without a ShapesAPI (the bundled built-ins are the only drawable defaults there).
	setActiveSet(pSetKeyOrItems)
	{
		if (!this._ShapesAPI) { return; }
		this._SetItems = libStickerResolver.resolveStickerSet(pSetKeyOrItems);
		this._DefaultItems = this._SetItems.map((pShape) => this._setItemToGalleryItem(pShape));
	}

	// A resolved set item -> a gallery item. A library shape goes through _shapeItem (honoring any
	// per-item color override); an uploaded item ({IDSticker}) resolves to its stored blob.
	_setItemToGalleryItem(pItem)
	{
		if (pItem && pItem.IDSticker)
		{
			let tmpBlobURL = this._StickerAPI ? this._StickerAPI.blobURL(pItem.IDSticker) : '';
			return { Id: 'db-' + pItem.IDSticker, Name: pItem.Name || ('Sticker ' + pItem.IDSticker), Url: tmpBlobURL, Thumbnail: tmpBlobURL, Metadata: { Collection: 'Uploads', AddedAt: 0 } };
		}
		let tmpItem = this._shapeItem(pItem.Collection, pItem.Name, pItem.Title);
		if (pItem.Pri || pItem.Sec)
		{
			let tmpColors = { pri: pItem.Pri || _DEFAULT_PRI, sec: pItem.Sec || _DEFAULT_SEC };
			tmpItem.Url = tmpItem.Thumbnail = this.recolorURL(pItem.Collection, pItem.Name, tmpColors);
			if (pItem.Pri) { tmpItem.Metadata.ColorPrimary = pItem.Pri; }
			if (pItem.Sec) { tmpItem.Metadata.ColorSecondary = pItem.Sec; }
		}
		return tmpItem;
	}

	getFields() { return _FIELDS.map((pField) => Object.assign({}, pField)); }

	getFilterOptions(pKey) { return (pKey === 'Collection') ? _COLLECTION_OPTIONS.slice() : []; }

	list(pQuery)
	{
		let tmpQuery = pQuery || {};
		let tmpSearch = (tmpQuery.Search || '').trim();
		let tmpCollection = (tmpQuery.Filters && tmpQuery.Filters.Collection) || '';
		let tmpLibraryKey = _LIBRARY_KEY[tmpCollection] || '';
		// Reach into the icon index when a library is chosen, or for a real free-text search with no
		// library filter (the Uploads / Built-in filters stay local).
		let tmpWantRemote = !!this._ShapesAPI && (!!tmpLibraryKey || (tmpSearch.length >= 2 && !tmpCollection));
		let tmpRemote = tmpWantRemote
			? this._ShapesAPI.search(tmpSearch, tmpLibraryKey, 60)
				.then((pRows) => (Array.isArray(pRows) ? pRows : []).map((pRow) => this._shapeItem(pRow.Collection, pRow.Name, pRow.Title)))
				.catch(() => [])
			: Promise.resolve([]);
		return Promise.all([this._localItems(), tmpRemote]).then((pSets) =>
		{
			let tmpItems = this._dedup(pSets[0].concat(pSets[1]));
			return this._applyQuery(tmpItems, tmpQuery);
		});
	}

	upload(pFile, pDataUrl, fCallback)
	{
		if (!this._StickerAPI)
		{
			// No backend: place the cutout from its data URL so the drop is not lost.
			if (typeof fCallback === 'function') { fCallback(null, { Url: pDataUrl, Name: (pFile && pFile.name) || 'sticker' }); }
			return;
		}
		this._StickerAPI.upload(pFile, { MimeType: (pFile && pFile.type) || '' })
			.then((pRef) =>
			{
				let tmpID = pRef && pRef.IDSticker;
				if (typeof fCallback === 'function') { fCallback(null, { Url: this._StickerAPI.blobURL(tmpID), Id: 'db-' + tmpID, Name: (pFile && pFile.name) || 'sticker' }); }
			})
			.catch((pError) =>
			{
				// Upload is admin-gated; a non-admin (or a failure) gets nothing placed rather than an
				// orphan board reference to a blob that was never stored.
				if (typeof fCallback === 'function') { fCallback(pError || new Error('Sticker upload failed.')); }
			});
	}

	// Picking an existing sticker already references the library; nothing to register.
	add() { return null; }

	// A recolorable library shape. The node carries the shape identity + current colors so the sticker
	// panel can offer color overrides (phosphor is two-color / duotone; tabler + brands are single-color).
	_shapeItem(pCollection, pName, pTitle)
	{
		let tmpURL = this._ShapesAPI ? this._ShapesAPI.shapeURL(pCollection, pName) : '';
		return {
			Id: 'shape:' + pCollection + ':' + pName,
			Name: pTitle || pName,
			Url: tmpURL,
			Thumbnail: tmpURL,
			Metadata: {
				Collection: _COLLECTION_LABEL[pCollection] || 'Built-in', AddedAt: 0,
				ShapeCollection: pCollection, ShapeName: pName, Duotone: (pCollection === 'phosphor'),
				ColorPrimary: _DEFAULT_PRI, ColorSecondary: _DEFAULT_SEC
			}
		};
	}

	// A recolored URL for a library shape, rebuilt through ShapesAPI (which owns the pri/sec/op convention).
	// The moodboard calls this when a sticker's color override changes.
	recolorURL(pCollection, pName, pColors)
	{
		return this._ShapesAPI ? this._ShapesAPI.shapeURL(pCollection, pName, pColors || {}) : '';
	}

	_localItems()
	{
		if (!this._StickerAPI) { return Promise.resolve(this._DefaultItems.slice()); }
		return this._StickerAPI.listLibrary()
			.then((pRows) =>
			{
				let tmpUploads = (Array.isArray(pRows) ? pRows : []).filter((pRow) => !pRow.IsBuiltIn).map((pRow) => this._toItem(pRow));
				return this._DefaultItems.concat(tmpUploads);
			})
			.catch(() => this._DefaultItems.slice());
	}

	_toItem(pRow)
	{
		let tmpURL = this._StickerAPI ? this._StickerAPI.blobURL(pRow.IDSticker) : '';
		return {
			Id: 'db-' + pRow.IDSticker,
			Name: pRow.Name || ('Sticker ' + pRow.IDSticker),
			Url: tmpURL,
			Thumbnail: tmpURL,
			Metadata: { Collection: 'Uploads', AddedAt: pRow.SortOrder || 0 }
		};
	}

	_dedup(pItems)
	{
		let tmpSeen = {};
		let tmpOut = [];
		for (let i = 0; i < pItems.length; i++)
		{
			let tmpKey = pItems[i].Url || pItems[i].Id;
			if (tmpKey && tmpSeen[tmpKey]) { continue; }
			if (tmpKey) { tmpSeen[tmpKey] = true; }
			tmpOut.push(pItems[i]);
		}
		return tmpOut;
	}

	_fieldValue(pItem, pKey)
	{
		if (pKey === 'Name') { return pItem.Name; }
		return (pItem.Metadata && typeof pItem.Metadata[pKey] !== 'undefined') ? pItem.Metadata[pKey] : '';
	}

	_applyQuery(pItems, pQuery)
	{
		let tmpItems = pItems.slice();

		let tmpSearch = (pQuery.Search || '').trim().toLowerCase();
		if (tmpSearch)
		{
			tmpItems = tmpItems.filter((pItem) =>
			{
				let tmpHay = (pItem.Name + ' ' + this._fieldValue(pItem, 'Collection')).toLowerCase();
				return tmpHay.indexOf(tmpSearch) >= 0;
			});
		}

		let tmpFilters = pQuery.Filters || {};
		Object.keys(tmpFilters).forEach((pKey) =>
		{
			let tmpValue = tmpFilters[pKey];
			if (tmpValue === '' || tmpValue == null) { return; }
			tmpItems = tmpItems.filter((pItem) => String(this._fieldValue(pItem, pKey)) === String(tmpValue));
		});

		if (pQuery.Sort && pQuery.Sort.Field)
		{
			let tmpField = pQuery.Sort.Field;
			let tmpDir = (pQuery.Sort.Direction === 'desc') ? -1 : 1;
			tmpItems.sort((pA, pB) =>
			{
				let tmpAV = this._fieldValue(pA, tmpField);
				let tmpBV = this._fieldValue(pB, tmpField);
				if (tmpAV < tmpBV) { return -1 * tmpDir; }
				if (tmpAV > tmpBV) { return 1 * tmpDir; }
				return 0;
			});
		}

		return tmpItems;
	}
}

module.exports = MoodboardStickerSource;

},{"../StickerSetResolver.js":572,"pict-section-moodboard/source/sources/StickerSource-Base.js":280}],580:[function(require,module,exports){
'use strict';

/**
 * AskAPI: the one custom call the user-facing Ask area needs -- filing a Request against a Task (V50 User
 * Tasks). Everything else the Ask view reads (the Active task catalog, a task's prompt shape, a person's own
 * requests, a single request's live status and answer) rides the generic EntityAPI providers that the
 * descriptor loop already creates: TaskAPI, PromptShapeAPI, RequestAPI. Only the submit is bespoke, because it
 * is not a create -- the server assembles the shape, mints the Request AND a hub-dispatch Run, and links them.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'AskAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderAskAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	// POST /1.0/Request/Submit { IDTask, InputValues, Name?, Attachments? }. InputValues is keyed by the task's
	// prompt-shape segment Keys (a single free-text ask sends { body: '<text>' }). Attachments is an optional list
	// of { Source:'media', Ref:<IDMedia>, Name, ContentType, Size } references for a conversational task. Resolves
	// to { Success, IDRequest, RequestNumber, IDRun, Status, Conversational?, IDAssistantMessage? }.
	submitRequest(pIDTask, pInputValues, pName, pAttachments, pIDProject)
	{
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'Request/Submit',
		{
			IDTask: Number(pIDTask) || 0,
			InputValues: (pInputValues && typeof pInputValues === 'object') ? pInputValues : {},
			Name: pName || '',
			Attachments: Array.isArray(pAttachments) ? pAttachments : [],
			IDProject: Number(pIDProject) || 0
		});
	}

	// POST /1.0/Request/:id/Message { Content, Attachments? } -- add a turn to a conversational Request. Resolves
	// to { Success, IDRequest, IDUserMessage, IDAssistantMessage, IDRun, Status }.
	postMessage(pIDRequest, pContent, pAttachments)
	{
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'Request/' + (Number(pIDRequest) || 0) + '/Message',
		{
			Content: String(pContent || ''),
			Attachments: Array.isArray(pAttachments) ? pAttachments : []
		});
	}
}

module.exports = PictProviderAskAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],581:[function(require,module,exports){
/**
 * Pict-Provider-AuthClient
 * ------------------------
 * Browser-side wrapper around the orator-authentication endpoints. Keeps the
 * current login state on AppData.Auth and exposes promise-returning helpers
 * for the views to call. No DOM manipulation lives here — that's the view's
 * job. Views read AppData.Auth.LoggedIn / AppData.Auth.User to render.
 *
 * AppData shape this provider owns:
 *   AppData.Auth = {
 *       LoggedIn:    false,
 *       User:        null,                  // { IDUser, Email, DisplayName, LoginID }
 *       Providers:   [],                    // [{ Name, Type, BeginURL }, …] from /OAuth/Providers
 *       LastError:   null,                  // most recent error message (cleared on success)
 *       Checking:    false                  // true while a CheckSession call is in flight
 *   }
 */

const libPictProvider = require('pict').ServiceProviderBase;

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'AuthClient',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderAuthClient extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Auth)
		{
			this.fable.AppData.Auth =
			{
				LoggedIn: false,
				User: null,
				Providers: [],
				LastError: null,
				Checking: false
			};
		}
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_fetchJSON(pPath, pOptions)
	{
		let tmpOptions = Object.assign({ credentials: 'same-origin' }, pOptions || {});
		tmpOptions.headers = Object.assign(
			{ 'Accept': 'application/json' },
			tmpOptions.headers || {});
		return fetch(this._url(pPath), tmpOptions).then((pResp) =>
		{
			if (!pResp.ok && pResp.status !== 401)
			{
				return pResp.text().then((pText) =>
				{
					throw new Error(`HTTP ${pResp.status}: ${pText || pResp.statusText}`);
				});
			}
			return pResp.json();
		});
	}

	/**
	 * Confirm whether the cookie still names a valid session. Called on app
	 * load; updates AppData.Auth in place.
	 */
	checkSession()
	{
		this.initializeAppData();
		this.fable.AppData.Auth.Checking = true;
		return this._fetchJSON('CheckSession')
			.then((pBody) =>
			{
				this.fable.AppData.Auth.Checking = false;
				if (pBody && pBody.LoggedIn && pBody.UserRecord)
				{
					this.fable.AppData.Auth.LoggedIn = true;
					this.fable.AppData.Auth.User = pBody.UserRecord;
				}
				else
				{
					this.fable.AppData.Auth.LoggedIn = false;
					this.fable.AppData.Auth.User = null;
				}
				return this.fable.AppData.Auth.LoggedIn;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Auth.Checking = false;
				this.fable.AppData.Auth.LoggedIn = false;
				this.fable.AppData.Auth.User = null;
				this.fable.AppData.Auth.LastError = pErr.message;
				return false;
			});
	}

	loadProviders()
	{
		this.initializeAppData();
		return this._fetchJSON('OAuth/Providers')
			.then((pBody) =>
			{
				this.fable.AppData.Auth.Providers = (pBody && Array.isArray(pBody.Providers)) ? pBody.Providers : [];
				return this.fable.AppData.Auth.Providers;
			})
			.catch(() =>
			{
				this.fable.AppData.Auth.Providers = [];
				return [];
			});
	}

	login(pUsername, pPassword)
	{
		this.initializeAppData();
		this.fable.AppData.Auth.LastError = null;
		this.fable.AppData.Auth.PendingChallenge = null;
		return this._fetchJSON('Login',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ UserName: pUsername, Password: pPassword })
			})
			.then((pBody) =>
			{
				if (pBody && pBody.LoggedIn && pBody.UserRecord)
				{
					this.fable.AppData.Auth.LoggedIn = true;
					this.fable.AppData.Auth.User = pBody.UserRecord;
					// Restricted session: an org requires 2FA and this account is not
					// enrolled. Signed in, but gated to enrollment until it turns 2FA on.
					if (pBody.MustEnroll2FA || pBody.UserRecord.MustEnroll2FA) { return 'enroll'; }
					return true;
				}
				if (pBody && pBody.Challenge && pBody.ChallengeToken)
				{
					this.fable.AppData.Auth.PendingChallenge =
					{
						ChallengeToken: pBody.ChallengeToken,
						Channel: pBody.Channel || 'email',
						MaskedDestination: pBody.MaskedDestination || '',
						ExpiresInSeconds: pBody.ExpiresInSeconds || 0
					};
					return 'challenge';
				}
				this.fable.AppData.Auth.LastError = (pBody && pBody.Error) || 'Authentication failed.';
				return false;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Auth.LastError = pErr.message;
				return false;
			});
	}

	// Step 2 of two-step login: submit the emailed/texted code against the pending
	// challenge. Resolves true (signed in) or false (LastError set).
	verifyLoginCode(pCode)
	{
		this.initializeAppData();
		this.fable.AppData.Auth.LastError = null;
		let tmpChallenge = this.fable.AppData.Auth.PendingChallenge;
		if (!tmpChallenge || !tmpChallenge.ChallengeToken)
		{
			this.fable.AppData.Auth.LastError = 'This sign-in request is no longer valid. Please start again.';
			return Promise.resolve(false);
		}
		return this._fetchJSON('Login/Verify',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ ChallengeToken: tmpChallenge.ChallengeToken, Code: pCode })
			})
			.then((pBody) =>
			{
				if (pBody && pBody.LoggedIn && pBody.UserRecord)
				{
					this.fable.AppData.Auth.LoggedIn = true;
					this.fable.AppData.Auth.User = pBody.UserRecord;
					this.fable.AppData.Auth.PendingChallenge = null;
					return true;
				}
				this.fable.AppData.Auth.LastError = (pBody && pBody.Error) || 'Incorrect code.';
				return false;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Auth.LastError = pErr.message;
				return false;
			});
	}

	// Stand in a one-time recovery code for the emailed/texted code against the
	// pending challenge. Resolves true (signed in) or false (LastError set).
	useRecoveryCode(pCode)
	{
		this.initializeAppData();
		this.fable.AppData.Auth.LastError = null;
		let tmpChallenge = this.fable.AppData.Auth.PendingChallenge;
		if (!tmpChallenge || !tmpChallenge.ChallengeToken)
		{
			this.fable.AppData.Auth.LastError = 'This sign-in request is no longer valid. Please start again.';
			return Promise.resolve(false);
		}
		return this._fetchJSON('Login/Recovery',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ ChallengeToken: tmpChallenge.ChallengeToken, RecoveryCode: pCode })
			})
			.then((pBody) =>
			{
				if (pBody && pBody.LoggedIn && pBody.UserRecord)
				{
					this.fable.AppData.Auth.LoggedIn = true;
					this.fable.AppData.Auth.User = pBody.UserRecord;
					this.fable.AppData.Auth.PendingChallenge = null;
					return true;
				}
				this.fable.AppData.Auth.LastError = (pBody && pBody.Error) || 'That recovery code is not valid.';
				return false;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Auth.LastError = pErr.message;
				return false;
			});
	}

	// Re-send a fresh code on the pending challenge. Resolves to the masked
	// destination it went to, or false.
	resendLoginCode()
	{
		this.initializeAppData();
		let tmpChallenge = this.fable.AppData.Auth.PendingChallenge;
		if (!tmpChallenge || !tmpChallenge.ChallengeToken) { return Promise.resolve(false); }
		return this._fetchJSON('Login/Resend',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ ChallengeToken: tmpChallenge.ChallengeToken })
			})
			.then((pBody) => (pBody && pBody.Resent) ? (pBody.MaskedDestination || tmpChallenge.MaskedDestination) : false)
			.catch(() => false);
	}

	cancelChallenge()
	{
		this.initializeAppData();
		this.fable.AppData.Auth.PendingChallenge = null;
		this.fable.AppData.Auth.LastError = null;
	}

	signup(pPartial)
	{
		this.initializeAppData();
		this.fable.AppData.Auth.LastError = null;
		return this._fetchJSON('Signup',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(pPartial)
			})
			.then((pBody) =>
			{
				if (pBody && pBody.Success && pBody.UserRecord)
				{
					this.fable.AppData.Auth.LoggedIn = true;
					this.fable.AppData.Auth.User = pBody.UserRecord;
					return true;
				}
				this.fable.AppData.Auth.LastError = (pBody && pBody.Error) || 'Signup failed.';
				return false;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Auth.LastError = pErr.message;
				return false;
			});
	}

	logout()
	{
		this.initializeAppData();
		return this._fetchJSON('Deauthenticate', { method: 'POST' })
			.then(() =>
			{
				this.fable.AppData.Auth.LoggedIn = false;
				this.fable.AppData.Auth.User = null;
				return true;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Auth.LastError = pErr.message;
				return false;
			});
	}

	/**
	 * Returns the URL to redirect the browser to in order to begin an OAuth
	 * flow with the named provider. Caller does `window.location.href = url`
	 * (or lets the browser follow a plain anchor href).
	 *
	 * pReturnTo (optional) is a same-origin relative path (e.g. the SPA's
	 * current "/#/board" route) the server sends the browser back to once the
	 * provider round trip completes, instead of the app's default landing
	 * page. See orator-authentication's _safeReturnTo -- only a leading-slash
	 * relative path is honored, so this can never become an open redirect.
	 */
	beginURL(pProviderName, pReturnTo)
	{
		let tmpURL = this._url('OAuth/Begin/' + encodeURIComponent(pProviderName));
		if (pReturnTo) { tmpURL += '?returnTo=' + encodeURIComponent(pReturnTo); }
		return tmpURL;
	}
}

module.exports = PictProviderAuthClient;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict":375}],582:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-BlueprintAPI
 * --------------------------
 * Browser-side client for blueprints, polymorphic over the foundational entity.
 *
 * A blueprint can be named two ways, and until now the client only knew one of them:
 *
 *   BY ITS HOST     a Vision / Module / Feature / WorkItem that owns one
 *                   GET /1.0/<EntityKey>/<id>/Blueprint
 *   BY ITSELF       the Blueprint record, which since WI #340 is first-class: its own
 *                   IDBlueprint, its own BlueprintNumber, its own page
 *                   GET /1.0/Blueprint/<IDBlueprint>/Items
 *
 * Every client path spoke only the first. Four separate places defaulted a missing key to the
 * literal string 'WorkItem' (PictView-Blueprint, BlueprintShareUI twice, the route handler), and
 * handing any of them a blueprint's own id produced /1.0/Blueprint/<id>/Blueprint -- which matches
 * the generic wildcard route, resolves against the Connections manifest, finds no 'Blueprint' key
 * there, and 404s. So a blueprint's own page could not read itself, and the by-id print and share
 * routes the server had already built had no caller at all.
 *
 * THE SUBJECT is what this provider adds. A subject is "which blueprint do you mean", in either
 * dialect, and every method takes one:
 *
 *   subjectForEntity('Feature', 1)   ->  { Kind: 'entity', EntityKey: 'Feature', ID: 1 }
 *   subjectForRecord(117)            ->  { Kind: 'record', ID: 117 }
 *   subjectFromPayload(pPayload)     ->  a RECORD subject when the payload carries IDBlueprint
 *
 * A caller that opened by host can hand the payload back through subjectFromPayload and act by
 * record from then on, which is what pinning needs: pins hang off IDBlueprint, so they were never
 * addressable from the host dialect without a round trip nobody was making.
 *
 * WHAT THIS DOES NOT DO: it does not decide what a blueprint CONTAINS. The server already does
 * that correctly for both dialects -- buildBlueprintForRecord dispatches on OwnerType and lands on
 * the same builders the host routes use, so the two reads return the same payload shape. This
 * provider resolves addresses and normalizes the identity fields; it invents nothing.
 *
 * It subclasses EntityAPI so plain Blueprint CRUD (the Blueprints list) keeps working, and is
 * registered BEFORE the EntityDescriptors loop in Pict-Application-Plansheet.js, whose
 * `if (this.pict.providers[Key + 'API']) { continue; }` guard is the intended way to supply a
 * bespoke provider for an entity that would otherwise get the generic one.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'BlueprintAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'Blueprint',
	PluralRoute: 'Blueprints',
	IDField: 'IDBlueprint'
};

// The entities that own a blueprint. This is the ONLY list of them on the client side; the four
// `|| 'WorkItem'` fallbacks scattered through the views are what it replaces. A key absent here is
// not blueprintable, and asking for its blueprint is a caller error rather than a silent WorkItem.
const _HOST_ENTITIES = { WorkItem: true, Vision: true, Module: true, Feature: true };

// What the back-link calls the thing it returns to. Saying the wrong noun is how somebody ends up
// on the wrong record and believes the page.
const _HOST_NOUNS = { WorkItem: 'work item', Vision: 'vision', Module: 'module', Feature: 'feature' };

function _pad(pNumber) { return String(pNumber).padStart(3, '0'); }

class PictProviderBlueprintAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	// ---- subjects --------------------------------------------------------------

	/** A blueprint named by the entity that owns it. */
	subjectForEntity(pEntityKey, pID)
	{
		return { Kind: 'entity', EntityKey: String(pEntityKey || ''), ID: parseInt(pID, 10) || 0 };
	}

	/** A blueprint named by its own record. */
	subjectForRecord(pIDBlueprint)
	{
		return { Kind: 'record', EntityKey: 'Blueprint', ID: parseInt(pIDBlueprint, 10) || 0 };
	}

	/**
	 * The record subject for a payload already read. Pins, cover and the by-id share family all
	 * need IDBlueprint, which a host-addressed read is what tells you.
	 *
	 * Returns null when the payload carries no record yet: an entity whose blueprint has never been
	 * read has no Blueprint row, and the server reports IDBlueprint 0 rather than inventing one.
	 */
	subjectFromPayload(pPayload)
	{
		let tmpID = pPayload && parseInt(pPayload.IDBlueprint, 10);
		return tmpID ? this.subjectForRecord(tmpID) : null;
	}

	/** Is this entity key one that owns a blueprint? */
	isHostEntity(pEntityKey) { return !!_HOST_ENTITIES[pEntityKey]; }

	/** Every blueprint-owning entity key, for callers that need to enumerate rather than test. */
	hostEntities() { return Object.keys(_HOST_ENTITIES); }

	/** What to call the record a blueprint describes, for back-links and prose. */
	ownerNoun(pSubject)
	{
		if (!pSubject || pSubject.Kind === 'record') { return 'blueprint'; }
		return _HOST_NOUNS[pSubject.EntityKey] || 'record';
	}

	_valid(pSubject)
	{
		if (!pSubject || !pSubject.ID) { return false; }
		return (pSubject.Kind === 'record') || this.isHostEntity(pSubject.EntityKey);
	}

	// ---- addressing ------------------------------------------------------------

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	/**
	 * The base path for a subject, and the one place the two dialects differ.
	 *
	 *   record:  Blueprint/117            -> suffixes are /Items /Print /Share /Invite /Item
	 *   entity:  Feature/1/Blueprint      -> suffixes are (none) /Print /Share /Invite
	 *
	 * The read suffix differs between them, which is why _readPath exists separately rather than
	 * every caller remembering that a record reads /Items and a host reads nothing.
	 */
	_base(pSubject)
	{
		if (pSubject.Kind === 'record') { return 'Blueprint/' + encodeURIComponent(pSubject.ID); }
		return encodeURIComponent(pSubject.EntityKey) + '/' + encodeURIComponent(pSubject.ID) + '/Blueprint';
	}

	_readPath(pSubject)
	{
		return (pSubject.Kind === 'record') ? (this._base(pSubject) + '/Items') : this._base(pSubject);
	}

	/** The URL a caller can hand to a link or a new tab, rather than fetch itself. */
	printURL(pSubject, pSheet)
	{
		if (!this._valid(pSubject)) { return ''; }
		let tmpSheet = pSheet ? ('?sheet=' + encodeURIComponent(pSheet)) : '';
		return this._url(this._base(pSubject) + '/Print' + tmpSheet);
	}

	/** The resolution preflight for a size: which images would print too soft, without rendering a PDF. */
	checkURL(pSubject, pSheet, pReading)
	{
		if (!this._valid(pSubject)) { return ''; }
		return this._url(this._base(pSubject) + '/Print/Check?sheet=' + encodeURIComponent(pSheet || 'Letter')
			+ '&reading=' + encodeURIComponent(pReading || 'Desk'));
	}

	// ---- reading ---------------------------------------------------------------

	/**
	 * Read a blueprint in either dialect. Both return the same payload shape (the by-record route
	 * dispatches through buildBlueprintForRecord onto the very same builders the host routes use),
	 * so a caller never has to know which one answered.
	 *
	 * Resolves null rather than rejecting: a blueprint that cannot be read should render as an
	 * empty sheet, not tear down the page around it.
	 *
	 * NOT NAMED read(). This class extends the generic EntityAPI, whose read(pID) fetches one record
	 * by id, and naming this one read() overrode that with an incompatible contract. Handed a numeric
	 * id it fell at the _valid() guard and resolved null WITHOUT ISSUING A REQUEST, so the detail
	 * page's read-by-id silently did nothing for blueprints alone. That read-by-id is what lets a
	 * record outside the capped list page open at all (WI #329), so on a tenant with more blueprints
	 * than one page every blueprint past the first 250 opened as "Blueprint not found" -- the record
	 * was fine, nothing had ever asked the server for it. A small tenant never sees it, because every
	 * blueprint is on page one and the list cache answers instead.
	 */
	readSubject(pSubject)
	{
		if (!this._valid(pSubject)) { return Promise.resolve(null); }
		return libFrameworkClient.getJSON(this.fable, this._url(this._readPath(pSubject)))
			.then((pBody) => this.normalize(pBody, pSubject))
			.catch(() => null);
	}

	/**
	 * Give every blueprint a mark it can name itself by.
	 *
	 * The three server builders emit different identity fields by owner type, and BlueprintRender
	 * reads them in one cascade: Designator, else WorkItemNumber as WI-###, else the literal
	 * 'WI #' + IDWorkItem. A work item has a WorkItemNumber and a Vision/Module/Feature has a
	 * Designator, so both land correctly -- but a blueprint addressed as itself has NEITHER, and
	 * falls all the way through to "WI #0". A first-class blueprint titling itself as work item
	 * zero is the same category error as the addressing this provider exists to fix, so the mark is
	 * filled in here, once, from BlueprintNumber and the Blueprint descriptor's own BP designator.
	 */
	normalize(pPayload, pSubject)
	{
		if (!pPayload || typeof pPayload !== 'object') { return null; }
		if (!pPayload.Designator)
		{
			if (pPayload.WorkItemNumber) { pPayload.Designator = 'WI-' + _pad(pPayload.WorkItemNumber); }
			else if (pPayload.BlueprintNumber) { pPayload.Designator = 'BP-' + _pad(pPayload.BlueprintNumber); }
		}
		// Remember how this blueprint was reached, so a view can re-address it without re-deriving.
		pPayload.Subject = this.subjectFromPayload(pPayload) || pSubject || null;
		return pPayload;
	}

	/** The pin candidates of one type. Curation is by record, so this needs IDBlueprint. */
	candidates(pSubject, pType)
	{
		if (!pSubject || pSubject.Kind !== 'record' || !pSubject.ID) { return Promise.resolve([]); }
		return libFrameworkClient.getJSON(this.fable,
			this._url(this._base(pSubject) + '/Candidates/' + encodeURIComponent(pType)))
			.then((pBody) => Array.isArray(pBody) ? pBody : ((pBody && pBody.Records) || []))
			.catch(() => []);
	}

	// ---- curation --------------------------------------------------------------
	//
	// A WORK ITEM'S PINS ARE NOT KEYED THE SAME WAY, and this is the one asymmetry the provider must
	// keep rather than smooth over. POST /1.0/WorkItem/:id/Blueprint/Item writes BlueprintItem with
	// IDWorkItem set and no IDBlueprint (Blueprint-Endpoint.js:1219), and the work-item gather reads
	// its pins back by IDWorkItem (:280). POST /1.0/Blueprint/:id/Item writes the mirror image:
	// IDBlueprint set, IDWorkItem 0 (:1394-1396). Send a work item's pin down the record route and it
	// is written with IDWorkItem 0, so the work item's own blueprint never sees it again -- the pin
	// appears to succeed and silently vanishes.
	//
	// Every pin ever made on a work item is stored the first way, so this is not a migration waiting
	// to happen; it is how work-item pins are addressed. curationSubject() is the single place that
	// knows, so no caller has to.

	/**
	 * Which subject to curate against. Work items curate by their own id; everything else curates by
	 * the blueprint record, which a host-addressed read reveals.
	 */
	curationSubject(pPayload, pSubject)
	{
		if (pSubject && pSubject.Kind === 'entity' && pSubject.EntityKey === 'WorkItem') { return pSubject; }
		return this.subjectFromPayload(pPayload) || ((pSubject && pSubject.Kind === 'record') ? pSubject : null);
	}

	_itemBase(pSubject)
	{
		if (pSubject && pSubject.Kind === 'entity' && pSubject.EntityKey === 'WorkItem')
		{
			return 'WorkItem/' + encodeURIComponent(pSubject.ID) + '/Blueprint/Item';
		}
		if (pSubject && pSubject.Kind === 'record' && pSubject.ID) { return 'Blueprint/' + encodeURIComponent(pSubject.ID) + '/Item'; }
		return '';
	}

	pin(pSubject, pItemType, pIDItem)
	{
		let tmpBase = this._itemBase(pSubject);
		if (!tmpBase) { return Promise.reject(new Error('BlueprintAPI: pinning needs a work item or a blueprint record. Read the blueprint first, then use curationSubject().')); }
		return libFrameworkClient.postJSON(this.fable, this._url(tmpBase),
			{ ItemType: pItemType, IDItem: parseInt(pIDItem, 10) || 0 });
	}

	unpin(pSubject, pIDBlueprintItem)
	{
		let tmpBase = this._itemBase(pSubject);
		if (!tmpBase) { return Promise.reject(new Error('BlueprintAPI: unpinning needs a work item or a blueprint record.')); }
		return libFrameworkClient.delJSON(this.fable,
			this._url(tmpBase + '/' + (parseInt(pIDBlueprintItem, 10) || 0)));
	}

	// ---- sharing ---------------------------------------------------------------
	// Both dialects have a full share family on the server. The host one was the only one wired,
	// and asking it about a blueprint record answered a cheerful lie: the generic
	// /1.0/:EntityType/:id/Blueprint/Share route resolves EntityType through the Connections
	// manifest, which has no 'Blueprint' key, so it returned 200 { Exists: false } for a blueprint
	// that may well have been shared. Addressing by record removes the question.

	/**
	 * Take a version of a sheet: freeze it as it is now.
	 *
	 * KEYED ON THE BLUEPRINT ROW, not the subject, because a version belongs to the sheet itself rather
	 * than to whichever entity happens to host it. A Feature's blueprint and the Feature are two
	 * different ids, and versioning the wrong one would file the snapshot where nothing looks for it.
	 */
	takeVersion(pIDBlueprint)
	{
		let tmpID = Number(pIDBlueprint) || 0;
		if (!tmpID) { return Promise.reject(new Error('BlueprintAPI: no sheet to version.')); }
		return libFrameworkClient.postJSON(this.fable, this._url('Blueprint/' + tmpID + '/Version'), {});
	}

	/** Every version of a sheet, newest first. */
	versions(pIDBlueprint)
	{
		let tmpID = Number(pIDBlueprint) || 0;
		if (!tmpID) { return Promise.resolve([]); }
		return libFrameworkClient.getJSON(this.fable, this._url('Blueprint/' + tmpID + '/Versions'))
			.then((pBody) => ((pBody && Array.isArray(pBody.Versions)) ? pBody.Versions : []))
			.catch(() => []);
	}

	/** The URL of one archived version, laid out on a paper. Never a fresh render. */
	versionURL(pIDBlueprintRevision, pSheet, pReading)
	{
		return this._url('BlueprintRevision/' + (Number(pIDBlueprintRevision) || 0) + '/Sheet')
			+ '?Sheet=' + encodeURIComponent(pSheet || 'Letter')
			+ '&Reading=' + encodeURIComponent(pReading || 'Desk');
	}

	shareState(pSubject)
	{
		if (!this._valid(pSubject)) { return Promise.resolve(null); }
		return libFrameworkClient.getJSON(this.fable, this._url(this._base(pSubject) + '/Share'))
			.catch(() => null);
	}

	shareCreate(pSubject, pBody)
	{
		if (!this._valid(pSubject)) { return Promise.reject(new Error('BlueprintAPI: no blueprint to share.')); }
		return libFrameworkClient.postJSON(this.fable, this._url(this._base(pSubject) + '/Share'), pBody || {});
	}

	shareRevoke(pSubject)
	{
		if (!this._valid(pSubject)) { return Promise.reject(new Error('BlueprintAPI: no blueprint to revoke.')); }
		return libFrameworkClient.delJSON(this.fable, this._url(this._base(pSubject) + '/Share'));
	}

	shareInvite(pSubject, pBody)
	{
		if (!this._valid(pSubject)) { return Promise.reject(new Error('BlueprintAPI: no blueprint to invite to.')); }
		return libFrameworkClient.postJSON(this.fable, this._url(this._base(pSubject) + '/Invite'), pBody || {});
	}

	// ---- printing --------------------------------------------------------------

	/**
	 * Fetch the PDF as a blob. Both dialects have a print route; the by-record one
	 * (GET /1.0/Blueprint/:id/Print) has existed since the print work landed and had no caller in
	 * the client at all, which is the other half of "I have never seen a blueprint PDF".
	 */
	print(pSubject, pSheet)
	{
		if (!this._valid(pSubject)) { return Promise.reject(new Error('BlueprintAPI: no blueprint to print.')); }
		return libFrameworkClient.getBinary(this.fable, this.printURL(pSubject, pSheet));
	}
}

module.exports = PictProviderBlueprintAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],583:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-BoardAPI
 * ----------------------
 * Backs the bespoke Kanban board: a stream of Work Item cards bucketed into the
 * tenant's lanes by Status and sorted by SortOrder. Moving a card PUTs the
 * entity's Status/SortOrder, which trips the server-side status-change audit
 * (WorkflowStatusEvent).
 *
 * This board once carried Features too, as one unified "trackable card" stream.
 * They moved to a board of their own (Pict-Provider-FeatureBoardAPI): work items
 * move at agent speed and features move at product speed, and one surface implied
 * they should move together. Features are still FETCHED here, because a Work Item
 * card names what it is for and "F-167" needs that Feature's number; they are just
 * no longer cards.
 *
 * AppData.Board = { Lanes: [{ Key, Label, Cards: [card], Count }], Loading, Error }
 *   card = { CardKind, ID, Title, Status, SortOrder, Type, Priority, KindClass }
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libDescriptors = require('../EntityDescriptors.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'BoardAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

const _SORT_STEP = 100; // sparse SortOrder so a drop rarely renumbers a lane

class PictProviderBoardAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
		// The lane definitions the board buckets into. Null until list() fetches the
		// tenant's lanes from the store; _laneDefs() falls back to the default set so
		// _bucket works in a fresh / unit-test context with no server fetch.
		this._laneDefinitions = null;
	}

	// The lane set the board renders: the fetched store lanes, or the default seed
	// when nothing has been fetched (fresh install, or the pure-model unit tests).
	_laneDefs()
	{
		if (this._laneDefinitions && this._laneDefinitions.length) { return this._laneDefinitions; }
		return libDescriptors.DefaultBoardLanes;
	}

	// Fetch this tenant's lanes from the lane store. Resolves to the lane definitions
	// (and caches them for _bucket). Falls back to the default set on any error so the
	// board always has lanes to draw into.
	loadLanes()
	{
		let tmpLaneAPI = this.fable && this.fable.providers && this.fable.providers.LaneAPI;
		if (!tmpLaneAPI)
		{
			this._laneDefinitions = libDescriptors.DefaultBoardLanes.slice();
			return Promise.resolve(this._laneDefinitions);
		}
		return tmpLaneAPI.listLanes()
			.then((pLanes) =>
			{
				this._laneDefinitions = (Array.isArray(pLanes) && pLanes.length) ? pLanes : libDescriptors.DefaultBoardLanes.slice();
				return this._laneDefinitions;
			})
			.catch(() =>
			{
				this._laneDefinitions = libDescriptors.DefaultBoardLanes.slice();
				return this._laneDefinitions;
			});
	}

	store()
	{
		if (!this.fable.AppData.Board)
		{
			this.fable.AppData.Board = { Lanes: [], Loading: false, Error: null };
		}
		return this.fable.AppData.Board;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_get(pPluralRoute)
	{
		// Through the shared RestClient so a 401 here drives session recovery.
		return libFrameworkClient.getJSON(this.fable, this._url(pPluralRoute + '/0/500'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || []);
	}

	// Whether the signed-in user can sign off on review (the content.approve gate the Review
	// endpoint's engine enforces). Gates the on-card Passed/Send-back buttons so they only appear
	// to reviewers; the server enforces it regardless.
	_canApprove()
	{
		let tmpUser = (this.fable.AppData.Auth && this.fable.AppData.Auth.User) || {};
		if (tmpUser.IsPlatformAdmin === 1 || tmpUser.IsPlatformAdmin === true) { return true; }
		return Array.isArray(tmpUser.Entitlements) && tmpUser.Entitlements.indexOf('content.approve') >= 0;
	}

	_toCard(pKind, pRow)
	{
		return (
		{
			CardKind: pKind,
			ID: (pKind === 'Feature') ? pRow.IDFeature : pRow.IDWorkItem,
			// The QC review affordance: present only for a Work Item sitting in the Review lane, and
			// only for a user who can sign off. Empty array -> the template-set renders nothing.
			ReviewSlot: (pKind !== 'Feature' && pRow.Status === 'Review' && this._canApprove())
				? [{ ID: pRow.IDWorkItem, ChangesRequested: (pRow.WorkflowStatus === 'ChangesRequested') ? 1 : 0 }] : [],
			// The per-tenant WorkItemNumber a person sees, and what the bulk selector keys on
			// (0 for Features, which v1 bulk does not act on).
			Number: (pKind === 'Feature') ? 0 : (Number(pRow.WorkItemNumber) || 0),
			Title: ((pKind === 'Feature') ? pRow.Name : pRow.Title) || ('#' + ((pKind === 'Feature') ? pRow.IDFeature : pRow.IDWorkItem)),
			Status: pRow.Status || 'Backlog',
			// Carried so the focus-view engine can filter on the workflow sub-state (e.g. the
			// ChangesRequested marker a did-not-pass-QC kickback sets). Features have none.
			WorkflowStatus: (pKind === 'Feature') ? '' : (pRow.WorkflowStatus || ''),
			SortOrder: Number(pRow.SortOrder) || 0,
			Type: pRow.Type || (pKind === 'Feature' ? 'Feature' : ''),
			Priority: pRow.Priority || '',
			// Carried so the focus-view engine can filter cards the same way it filters the
			// Work Items list: by assignee (human / AI), recent activity, and a text search
			// over Title + Description. Features have no TargetType, so a target facet skips them.
			IDAssignedUser: Number(pRow.IDAssignedUser) || 0,
			Description: pRow.Description || '',
			TargetType: (pKind === 'Feature') ? '' : (pRow.TargetType || ''),
			// The target's own id, kept so _resolveMarks can turn it into that entity's designator
			// (F-167) once every card is in hand. Nothing renders these directly.
			IDTargetFeature: (pKind === 'Feature') ? 0 : (Number(pRow.IDTargetFeature) || 0),
			IDTargetVision: (pKind === 'Feature') ? 0 : (Number(pRow.IDTargetVision) || 0),
			IDTargetModule: (pKind === 'Feature') ? 0 : (Number(pRow.IDTargetModule) || 0),
			// The per-tenant number of THIS card's own entity, which is what its designator is built
			// from. Features carry FeatureNumber; the WorkItem case already lives on Number above.
			FeatureNumber: (pKind === 'Feature') ? (Number(pRow.FeatureNumber) || 0) : 0,
			UpdateDate: pRow.UpdateDate || '',
			CreateDate: pRow.CreateDate || '',
			KindClass: (pKind === 'Feature') ? 'ps-card-feature' : 'ps-card-workitem'
		});
	}

	/**
	 * Make sure the team roster is in hand before marks are resolved, because a card names who holds
	 * each item and the roster is the only place that name lives. Loaded once and left on AppData.Team,
	 * which every other surface already reads, so a board that has it does not fetch it again.
	 *
	 * Never rejects: a roster this board could not fetch costs one cell its value, and must not cost
	 * the whole board its cards.
	 */
	_ensureRoster()
	{
		// AppData.Team.Roster, not Members: the board already loads the roster for its assignee facet
		// (PictView-Board loadRoster / applyFilter), so the card reads the list that is already there
		// rather than fetching a second, parallel copy of the same people.
		let tmpTeam = this.fable.AppData.Team;
		if (tmpTeam && Array.isArray(tmpTeam.Roster) && tmpTeam.Roster.length)
		{
			return Promise.resolve(tmpTeam.Roster);
		}
		let tmpTeamAPI = this.fable.providers.TeamAPI;
		if (!tmpTeamAPI || typeof tmpTeamAPI.roster !== 'function') { return Promise.resolve([]); }
		return tmpTeamAPI.roster().catch(() => []);
	}

	// The assignee as a person reads it. Resolved from the team roster when it is already loaded and
	// degraded to a dash when it is not, so a board that never asked for the roster still renders a
	// complete card rather than an empty cell.
	_assignee(pIDUser)
	{
		// Nobody is holding it. A dash says that in the width available; "Unassigned" only ever renders
		// as "Unas...", which is worse than the mark it replaced.
		if (!pIDUser) { return ''; }
		let tmpTeam = this.fable.AppData.Team || {};
		let tmpPeople = (Array.isArray(tmpTeam.Roster) && tmpTeam.Roster.length) ? tmpTeam.Roster : (tmpTeam.Members || []);
		let tmpMember = tmpPeople.filter((pMember) => Number(pMember.IDUser) === Number(pIDUser))[0];
		if (!tmpMember) { return ''; }
		let tmpName = tmpMember.DisplayName || tmpMember.Email || '';
		// An agent is a first-class assignee here, and saying so on the card is the difference between
		// reading a lane and having to open things to find out who is holding what.
		return (tmpMember.IsAgent === 1 || tmpMember.IsAgent === true) ? (tmpName + ' (AI)') : tmpName;
	}

	/**
	 * Fill in each card's Mark and Cells. This runs after every card exists, because a Work Item's
	 * target is another card: resolving F-167 means finding that Feature's own number, which is only
	 * possible once the Features are built too.
	 *
	 * A target that cannot be resolved degrades to its type ("Vision") rather than rendering blank, so
	 * a cell never silently disappears and shift the ones after it.
	 */
	_resolveMarks(pCards, pFeatures)
	{
		let tmpMarkup = this.fable.providers.Markup;
		if (!tmpMarkup) { return pCards; }

		// Features are no longer cards on this board (they have their own), so their numbers come
		// from the fetched rows. A Work Item still says what it is FOR, and "F-167" is the only
		// form of that answer a reader can act on.
		let tmpFeatureByID = {};
		(Array.isArray(pFeatures) ? pFeatures : []).forEach((pFeature) =>
		{
			tmpFeatureByID[pFeature.IDFeature] = { FeatureNumber: Number(pFeature.FeatureNumber) || 0 };
		});

		pCards.forEach((pCard) =>
		{
			let tmpEntity = (pCard.CardKind === 'Feature') ? 'Feature' : 'WorkItem';
			let tmpNumber = (pCard.CardKind === 'Feature') ? pCard.FeatureNumber : pCard.Number;

			let tmpTarget = '';
			if (pCard.IDTargetFeature && tmpFeatureByID[pCard.IDTargetFeature])
			{
				tmpTarget = tmpMarkup.designator('Feature', tmpFeatureByID[pCard.IDTargetFeature].FeatureNumber);
			}
			// Vision and Module targets are not on the board, so their numbers are not in hand. Name the
			// kind rather than guessing at a designator that would be wrong.
			if (!tmpTarget && pCard.TargetType) { tmpTarget = pCard.TargetType; }

			pCard.Designator = tmpMarkup.designator(tmpEntity, tmpNumber);
			// The entity's own number, normalized across kinds so a search for "19" can match a Feature
			// as readily as a Work Item (Number is 0 on a Feature card, which the bulk selector relies on).
			pCard.MarkNumber = Number(tmpNumber) || 0;
			pCard.Mark = tmpMarkup.mark(tmpEntity, { Title: pCard.Title }, {});
			pCard.Mark.Designator = pCard.Designator;
			pCard.Mark.KindClass = pCard.KindClass;
			pCard.Cells =
			[
				{ K: 'Type', V: pCard.Type },
				{ K: 'Pri', V: pCard.Priority },
				{ K: 'By', V: this._assignee(pCard.IDAssignedUser) },
				{ K: 'For', V: tmpTarget }
			].map((pCell) => ({ K: pCell.K, V: (pCell.V === null || typeof pCell.V === 'undefined' || String(pCell.V).trim() === '') ? '—' : String(pCell.V) }));
		});
		return pCards;
	}

	_bucket(pCards)
	{
		let tmpStore = this.store();
		let tmpDefs = this._laneDefs();
		let tmpLanes = tmpDefs.map((pDef) => ({ Key: pDef.Key, Label: pDef.Label || pDef.Key, Color: pDef.Color || '', IsTerminal: !!pDef.IsTerminal, Cards: [], Count: 0 }));
		let tmpByKey = {};
		for (let i = 0; i < tmpLanes.length; i++) tmpByKey[tmpLanes[i].Key] = tmpLanes[i];
		// A Status with no matching lane (older data, or a lane was renamed/removed)
		// falls back to the first lane so no card ever disappears from the board.
		let tmpFallback = tmpLanes[0] || null;

		pCards.sort((pA, pB) => pA.SortOrder - pB.SortOrder);
		for (let i = 0; i < pCards.length; i++)
		{
			let tmpLane = tmpByKey[pCards[i].Status] || tmpFallback;
			if (tmpLane) tmpLane.Cards.push(pCards[i]);
		}
		for (let i = 0; i < tmpLanes.length; i++) tmpLanes[i].Count = tmpLanes[i].Cards.length;
		tmpStore.Lanes = tmpLanes;
	}

	list()
	{
		let tmpStore = this.store();
		tmpStore.Loading = true;
		return Promise.all([this._get('Features'), this._get('WorkItems'), this.loadLanes(), this._ensureRoster()])
			.then((pResults) =>
			{
				let tmpCards = [];
				let tmpFeatures = pResults[0] || [];
				let tmpWorkItems = pResults[1] || [];
				// Archived work items are soft-removed from the board (recoverable, still readable
				// elsewhere), so they never bucket into a lane.
				for (let i = 0; i < tmpWorkItems.length; i++)
				{
					if (Number(tmpWorkItems[i].Archived) === 1 || tmpWorkItems[i].Archived === true) continue;
					tmpCards.push(this._toCard('WorkItem', tmpWorkItems[i]));
				}
				// Marks are resolved once, here, because a card's target is another card: turning a
				// Work Item's target into F-167 needs its Feature's own number, which is why the
				// Features are still fetched even though they no longer become cards.
				this._resolveMarks(tmpCards, tmpFeatures);
				// Keep the unfiltered card set so a focus-view filter can re-bucket the board
				// without re-fetching (see rebucket()); the board view owns the predicate.
				tmpStore.AllCards = tmpCards;
				this._bucket(tmpCards);
				tmpStore.Loading = false;
				tmpStore.Error = null;
				return tmpStore.Lanes;
			})
			.catch((pErr) =>
			{
				tmpStore.Loading = false;
				tmpStore.Error = pErr.message;
				return [];
			});
	}

	// The unfiltered card set from the last list() (Features + non-archived WorkItems).
	allCards()
	{
		return (this.store().AllCards || []).slice();
	}

	// Re-bucket the lanes from a (usually filtered) subset of cards, without a re-fetch.
	// Passing nothing restores the full board. Returns the rebuilt lanes.
	rebucket(pCards)
	{
		this._bucket(Array.isArray(pCards) ? pCards.slice() : this.allCards());
		return this.store().Lanes;
	}

	/**
	 * Next sparse SortOrder for appending a card to the end of a lane.
	 */
	nextSortOrder(pLaneKey)
	{
		let tmpStore = this.store();
		let tmpMax = 0;
		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			if (tmpStore.Lanes[i].Key !== pLaneKey) continue;
			let tmpCards = tmpStore.Lanes[i].Cards;
			for (let j = 0; j < tmpCards.length; j++)
			{
				if (tmpCards[j].SortOrder > tmpMax) tmpMax = tmpCards[j].SortOrder;
			}
		}
		return tmpMax + _SORT_STEP;
	}

	/**
	 * Locate a card in the model. Returns { Card, Lane, Index } or null.
	 */
	_findCard(pKind, pID)
	{
		let tmpStore = this.store();
		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			let tmpCards = tmpStore.Lanes[i].Cards;
			for (let j = 0; j < tmpCards.length; j++)
			{
				if (tmpCards[j].CardKind === pKind && tmpCards[j].ID === pID)
				{
					return { Card: tmpCards[j], Lane: tmpStore.Lanes[i], Index: j };
				}
			}
		}
		return null;
	}

	/**
	 * Pick the SortOrder for a card dropped at pIndex within pDest (the target lane's
	 * cards WITHOUT the moved card). Between two neighbors we take the integer
	 * midpoint; at the top or bottom we step one sparse notch past the edge card, so
	 * those never collide. When two neighbors have no integer between them the lane is
	 * renumbered to a fresh sparse sequence and the shifted cards come back in Reindex.
	 * Returns { NewSort, Reindex: [{ Card, SortOrder }] }.
	 */
	_sortForSlot(pDest, pIndex)
	{
		let tmpPrev = (pIndex > 0) ? pDest[pIndex - 1] : null;
		let tmpNext = (pIndex < pDest.length) ? pDest[pIndex] : null;

		if (!tmpPrev && !tmpNext) { return { NewSort: _SORT_STEP, Reindex: [] }; }
		if (!tmpPrev) { return { NewSort: tmpNext.SortOrder - _SORT_STEP, Reindex: [] }; }
		if (!tmpNext) { return { NewSort: tmpPrev.SortOrder + _SORT_STEP, Reindex: [] }; }

		let tmpMid = Math.floor((tmpPrev.SortOrder + tmpNext.SortOrder) / 2);
		if (tmpMid > tmpPrev.SortOrder && tmpMid < tmpNext.SortOrder)
		{
			return { NewSort: tmpMid, Reindex: [] };
		}

		// No integer room between the neighbors: renumber the whole lane to a sparse
		// sequence, reserving the slot at pIndex for the dropped card.
		let tmpReindex = [];
		for (let j = 0; j < pDest.length; j++)
		{
			let tmpFinalPos = (j < pIndex) ? j : (j + 1);
			let tmpNewSort = (tmpFinalPos + 1) * _SORT_STEP;
			if (tmpNewSort !== pDest[j].SortOrder)
			{
				tmpReindex.push({ Card: pDest[j], SortOrder: tmpNewSort });
			}
		}
		return { NewSort: (pIndex + 1) * _SORT_STEP, Reindex: tmpReindex };
	}

	/**
	 * Optimistically move a card into a lane at an explicit position and return a
	 * snapshot the caller can hand to revertLocalMove() if the server write fails.
	 * pTargetIndex is the resting index among the target lane's OTHER cards (the moved
	 * card excluded); it is clamped, so Infinity appends to the end. The snapshot's
	 * NewSort places the card at that spot, and Reindex lists any same-lane neighbors
	 * whose SortOrder had to shift to open the slot.
	 */
	applyLocalMoveAt(pKind, pID, pToLaneKey, pTargetIndex)
	{
		let tmpStore = this.store();
		let tmpFound = this._findCard(pKind, pID);
		if (!tmpFound) return null;
		let tmpCard = tmpFound.Card;
		let tmpFromLane = tmpFound.Lane;
		let tmpFromIndex = tmpFound.Index;

		let tmpToLane = null;
		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			if (tmpStore.Lanes[i].Key === pToLaneKey) { tmpToLane = tmpStore.Lanes[i]; break; }
		}
		if (!tmpToLane) return null;

		// Remove from the origin first so the slot math runs against the cards that
		// will actually surround the dropped card (matters for a same-lane reorder).
		tmpFromLane.Cards.splice(tmpFromIndex, 1);
		tmpFromLane.Count = tmpFromLane.Cards.length;

		let tmpDest = tmpToLane.Cards;
		let tmpIndex = Math.max(0, Math.min(pTargetIndex, tmpDest.length));
		let tmpPlan = this._sortForSlot(tmpDest, tmpIndex);

		let tmpSnapshot =
		{
			Kind: pKind,
			ID: pID,
			Card: tmpCard,
			FromLaneKey: tmpFromLane.Key,
			FromStatus: tmpCard.Status,
			FromSortOrder: tmpCard.SortOrder,
			FromIndex: tmpFromIndex,
			ToLaneKey: pToLaneKey,
			NewSort: tmpPlan.NewSort,
			Reindex: []
		};

		// Apply (and record for rollback + persistence) any neighbor renumbering.
		for (let i = 0; i < tmpPlan.Reindex.length; i++)
		{
			let tmpR = tmpPlan.Reindex[i];
			tmpSnapshot.Reindex.push(
			{
				Kind: tmpR.Card.CardKind, ID: tmpR.Card.ID, Card: tmpR.Card,
				SortOrder: tmpR.SortOrder, PrevSortOrder: tmpR.Card.SortOrder
			});
			tmpR.Card.SortOrder = tmpR.SortOrder;
		}

		tmpCard.Status = pToLaneKey;
		tmpCard.SortOrder = tmpPlan.NewSort;
		tmpDest.splice(tmpIndex, 0, tmpCard);
		tmpToLane.Count = tmpDest.length;

		return tmpSnapshot;
	}

	/**
	 * Back-compat shim: move a card to the END of a lane. Kept for any caller that
	 * does not care about position; the board uses applyLocalMoveAt directly.
	 */
	applyLocalMove(pKind, pID, pToLaneKey)
	{
		return this.applyLocalMoveAt(pKind, pID, pToLaneKey, Infinity);
	}

	/**
	 * Undo an applyLocalMoveAt() using its returned snapshot (server write failed).
	 */
	revertLocalMove(pSnapshot)
	{
		if (!pSnapshot || !pSnapshot.Card) return;
		let tmpStore = this.store();

		// Roll the moved card out of wherever it landed.
		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			let tmpIndex = tmpStore.Lanes[i].Cards.indexOf(pSnapshot.Card);
			if (tmpIndex >= 0)
			{
				tmpStore.Lanes[i].Cards.splice(tmpIndex, 1);
				tmpStore.Lanes[i].Count = tmpStore.Lanes[i].Cards.length;
				break;
			}
		}

		// Undo any neighbor renumbering, then re-sort the affected lane so its array
		// order matches the restored SortOrders.
		let tmpDirtyLanes = {};
		for (let i = 0; i < pSnapshot.Reindex.length; i++)
		{
			pSnapshot.Reindex[i].Card.SortOrder = pSnapshot.Reindex[i].PrevSortOrder;
			tmpDirtyLanes[pSnapshot.ToLaneKey] = true;
		}

		pSnapshot.Card.Status = pSnapshot.FromStatus;
		pSnapshot.Card.SortOrder = pSnapshot.FromSortOrder;
		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			if (tmpStore.Lanes[i].Key === pSnapshot.FromLaneKey)
			{
				let tmpIndex = Math.min(pSnapshot.FromIndex, tmpStore.Lanes[i].Cards.length);
				tmpStore.Lanes[i].Cards.splice(tmpIndex, 0, pSnapshot.Card);
				tmpStore.Lanes[i].Count = tmpStore.Lanes[i].Cards.length;
				break;
			}
		}

		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			if (tmpDirtyLanes[tmpStore.Lanes[i].Key])
			{
				tmpStore.Lanes[i].Cards.sort((pA, pB) => pA.SortOrder - pB.SortOrder);
			}
		}
	}

	/**
	 * Persist the writes a snapshot implies: the moved card, plus any neighbors that
	 * were renumbered. A card that stayed in its lane (a pure reorder) only writes
	 * SortOrder, so it never trips the server-side status-change audit.
	 */
	persistMove(pSnapshot)
	{
		if (!pSnapshot) return Promise.resolve();
		let tmpWrites = [];
		if (pSnapshot.FromStatus === pSnapshot.ToLaneKey)
		{
			tmpWrites.push(this.reorderCard(pSnapshot.Kind, pSnapshot.ID, pSnapshot.NewSort));
		}
		else
		{
			tmpWrites.push(this.moveCard(pSnapshot.Kind, pSnapshot.ID, pSnapshot.ToLaneKey, pSnapshot.NewSort));
		}
		for (let i = 0; i < pSnapshot.Reindex.length; i++)
		{
			tmpWrites.push(this.reorderCard(pSnapshot.Reindex[i].Kind, pSnapshot.Reindex[i].ID, pSnapshot.Reindex[i].SortOrder));
		}
		return Promise.all(tmpWrites);
	}

	moveCard(pKind, pID, pToStatus, pSortOrder)
	{
		let tmpEntityType = (pKind === 'Feature') ? 'Feature' : 'WorkItem';
		let tmpIDField = (pKind === 'Feature') ? 'IDFeature' : 'IDWorkItem';
		let tmpBody = { Status: pToStatus, WorkflowStatus: pToStatus, SortOrder: pSortOrder };
		tmpBody[tmpIDField] = pID;
		// EntityProvider.updateEntity -> the shared RestClient's putJSON. A 401 on
		// this non-idempotent write is safe to replay: the auth gate rejects it
		// before the handler runs, so the move never executed on the 401 attempt.
		return libFrameworkClient.updateEntity(this.fable, tmpEntityType, tmpBody);
	}

	/**
	 * Persist a within-lane reposition: SortOrder only, no Status. meadow-endpoints
	 * updates just the supplied fields, so this leaves Status/WorkflowStatus alone and
	 * the audit hook (which watches those) stays quiet on a plain reorder.
	 */
	reorderCard(pKind, pID, pSortOrder)
	{
		let tmpEntityType = (pKind === 'Feature') ? 'Feature' : 'WorkItem';
		let tmpIDField = (pKind === 'Feature') ? 'IDFeature' : 'IDWorkItem';
		let tmpBody = { SortOrder: pSortOrder };
		tmpBody[tmpIDField] = pID;
		return libFrameworkClient.updateEntity(this.fable, tmpEntityType, tmpBody);
	}

	/**
	 * Bulk operation over the board's cards, through the one server endpoint the MCP
	 * bulk tools also call (POST /1.0/Board/Bulk), so behavior can't drift. pOperation
	 * is Move | SetPriority | SetType | Archive | Unarchive; pSelector is the shared
	 * selector ({ IDs:[WorkItemNumbers] } from a multi-select, or a filter); pValue is
	 * the target lane / priority / type (unused for Archive). Without pConfirm it is a
	 * dry run (returns Matched/Count/Change and mutates nothing); with pConfirm it
	 * applies (returns Applied/Failed/Change).
	 */
	bulkOperation(pOperation, pSelector, pValue, pConfirm)
	{
		let tmpBody = { Operation: pOperation, Selector: pSelector || {}, Confirm: !!pConfirm };
		if (pValue != null && pValue !== '') { tmpBody.Value = pValue; }
		return libFrameworkClient.postJSON(this.fable, this._url('Board/Bulk'), tmpBody);
	}

	/**
	 * Record a QC review decision on a Work Item in the Review lane. pOutcome is 'Pass' | 'Fail';
	 * pOptions carries { ReasonCode, Note, Issues } for a Fail (the did-not-pass-QC punch-list).
	 * POSTs the shared Review gate (engine-gated on content.approve; the server 403s a non-approver).
	 */
	reviewWorkItem(pID, pOutcome, pOptions)
	{
		let tmpOptions = pOptions || {};
		let tmpBody = { Outcome: pOutcome };
		if (tmpOptions.ReasonCode) { tmpBody.ReasonCode = tmpOptions.ReasonCode; }
		if (tmpOptions.Note) { tmpBody.Note = tmpOptions.Note; }
		if (Array.isArray(tmpOptions.Issues) && tmpOptions.Issues.length) { tmpBody.Issues = tmpOptions.Issues; }
		return libFrameworkClient.postJSON(this.fable, this._url('WorkItem/' + pID + '/Review'), tmpBody);
	}
}

module.exports = PictProviderBoardAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../EntityDescriptors.js":555,"./FrameworkClient.js":576,"pict":375}],584:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-CallDeskAPI
 * -------------------------
 * Browser-side client for turning a logged Call into an Issue or a Feedback record. Call CRUD itself
 * (create the call, list a customer's calls) goes through the generic EntityAPI; these two routes
 * carry the call's customer + contact context onto the spawned record, server-side.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'CallDeskAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderCallDeskAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }
	_post(pPath, pBody) { return libFrameworkClient.postJSON(this.fable, this._url(pPath), pBody || {}).catch(() => null); }

	spawnIssue(pCallID, pDraft) { return this._post('Call/' + encodeURIComponent(pCallID) + '/SpawnIssue', pDraft || {}); }
	spawnFeedback(pCallID, pDraft) { return this._post('Call/' + encodeURIComponent(pCallID) + '/SpawnFeedback', pDraft || {}); }
}

module.exports = PictProviderCallDeskAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],585:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-ChecklistAPI
 * --------------------------
 * Browser-side client for the plansheet checklist endpoints. Manages the checklist COLLECTION (list a
 * Work Item's shared checklists or the signed-in user's private ones, create, rename, delete) and the
 * items inside one checklist. Tenancy and the private/shared privacy check are enforced server-side, so
 * the client never sends IDCustomer or trusts itself for access.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'ChecklistAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderChecklistAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_get(pPath)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(pPath)).catch(() => null);
	}

	_post(pPath, pBody)
	{
		return libFrameworkClient.postJSON(this.fable, this._url(pPath), pBody || {}).catch(() => null);
	}

	_del(pPath)
	{
		return libFrameworkClient.delJSON(this.fable, this._url(pPath)).then(() => true).catch(() => false);
	}

	// ---- the checklist collection ----
	listMine() { return this._get('Checklists/Mine').then((pBody) => (pBody && pBody.Checklists) || []).catch(() => []); }
	listForOwner(pOwnerType, pIDOwner) { return this._get('Checklists/ForOwner/' + encodeURIComponent(pOwnerType) + '/' + encodeURIComponent(pIDOwner)).then((pBody) => (pBody && pBody.Checklists) || []).catch(() => []); }
	create(pDraft) { return this._post('Checklist/New', pDraft).then((pBody) => (pBody && pBody.Checklist) || null); }
	rename(pID, pTitle) { return this._post('Checklist/' + encodeURIComponent(pID) + '/Rename', { Title: pTitle }); }
	remove(pID) { return this._del('Checklist/' + encodeURIComponent(pID)); }

	// ---- one checklist's items ----
	get(pID) { return this._get('Checklist/' + encodeURIComponent(pID)).then((pBody) => pBody || { Checklist: null, Items: [] }).catch(() => ({ Checklist: null, Items: [] })); }
	createItem(pID, pDraft) { return this._post('Checklist/' + encodeURIComponent(pID) + '/Item', pDraft).then((pBody) => (pBody && pBody.Item) || null); }
	updateItem(pItemID, pPatch) { return this._post('ChecklistItem/' + encodeURIComponent(pItemID) + '/Update', pPatch); }
	deleteItem(pItemID) { return this._del('ChecklistItem/' + encodeURIComponent(pItemID)); }
}

module.exports = PictProviderChecklistAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],586:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-CommentAPI
 * ------------------------
 * Browser-side CRUD client for the Comment entity, extending the generic EntityAPI provider. The one
 * extra helper is listForThread: the comments in a thread, oldest first (the section re-orders for
 * display). Tenancy (IDCustomer) is enforced server-side.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'CommentAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'Comment',
	PluralRoute: 'Comments',
	IDField: 'IDComment'
};

class PictProviderCommentAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The comments in a thread.
	 * @param {number} pIDCommentThread
	 * @returns {Promise<Array<object>>}
	 */
	listForThread(pIDCommentThread)
	{
		let tmpFilter = 'FBV~IDCommentThread~EQ~' + pIDCommentThread;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/500'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}
}

module.exports = PictProviderCommentAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],587:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-CommentThreadAPI
 * ------------------------------
 * Browser-side CRUD client for the CommentThread entity, extending the generic EntityAPI provider.
 * Threads are owned polymorphically (OwnerType + IDOwner), the same shape as Media, so the one extra
 * helper is listForOwner: the threads attached to a given context (a Vision, a Work Item, ...).
 * Tenancy (IDCustomer) is enforced server-side, so the client never sends it.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'CommentThreadAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'CommentThread',
	PluralRoute: 'CommentThreads',
	IDField: 'IDCommentThread'
};

class PictProviderCommentThreadAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The comment threads attached to a context.
	 * @param {string} pOwnerType - the entity kind ('Vision', 'WorkItem', ...)
	 * @param {number|string} pIDOwner - the entity id
	 * @returns {Promise<Array<object>>}
	 */
	listForOwner(pOwnerType, pIDOwner)
	{
		let tmpFilter = 'FBV~OwnerType~EQ~' + pOwnerType + '~FBV~IDOwner~EQ~' + pIDOwner;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}
}

module.exports = PictProviderCommentThreadAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],588:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-ConnectionsAPI
 * ----------------------------
 * Browser-side client for the generic "connections" of an entity: the auto-gathered links (customer,
 * reporter, work items, media, docs, comments, ...) folded into groups of { Type, Label, Count, Items },
 * the same shape the Blueprint endpoint computes for a work item, generalized to any entity. The
 * Connections grid view renders it. Edit mode links and unlinks one relation at a time.
 *
 *   GET    /1.0/<Entity>/:id/Connections                  -> { Title, Eyebrow, Record, Groups, Available }
 *   GET    /1.0/<Entity>/:id/Connections/Candidates/:type -> [ { ID, Title } ]   (link picker options)
 *   POST   /1.0/<Entity>/:id/Connections/Link             { Type, IDItem }
 *   DELETE /1.0/<Entity>/:id/Connections/Link/:type/:item
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'ConnectionsAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderConnectionsAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }
	_base(pEntity, pID) { return encodeURIComponent(pEntity) + '/' + encodeURIComponent(pID) + '/Connections'; }

	get(pEntity, pID)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(this._base(pEntity, pID)))
			.catch(() => null);
	}

	candidates(pEntity, pID, pType)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(this._base(pEntity, pID) + '/Candidates/' + encodeURIComponent(pType)))
			.catch(() => []);
	}

	link(pEntity, pID, pType, pIDItem)
	{
		return libFrameworkClient.postJSON(this.fable, this._url(this._base(pEntity, pID) + '/Link'), { Type: pType, IDItem: pIDItem })
			.catch(() => null);
	}

	unlink(pEntity, pID, pType, pIDItem)
	{
		return libFrameworkClient.delJSON(this.fable, this._url(this._base(pEntity, pID) + '/Link/' + encodeURIComponent(pType) + '/' + encodeURIComponent(pIDItem)))
			.catch(() => null);
	}
}

module.exports = PictProviderConnectionsAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],589:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-DeliverableBoardAPI
 * ---------------------------------
 * Browser-side client for the one Deliverable endpoint auto-CRUD cannot serve: the Deliver board
 * dashboard (kanban lanes by stage, with the resolved kit stage labels). Basic Deliverable CRUD goes
 * through the generic EntityAPI; this provider owns the dashboard read and the kanban move. The move
 * is a plain PUT /1.0/Deliverable (Status + SortOrder), exactly like the issue and feature boards, so
 * the server-side status-change audit logs the transition (WorkflowStatusEvent).
 *
 * AppData.DeliverableBoard = { Lanes, Stages, Counts, Loading, Error }
 *   card = { IDDeliverable, DeliverableNumber, Title, Status, CustomerName, ExpectationTitle,
 *            ChildCount, IsChild, SortOrder }
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'DeliverableBoardAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

const _SORT_STEP = 100; // sparse SortOrder so a drop rarely renumbers a lane

class PictProviderDeliverableBoardAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	store()
	{
		if (!this.fable.AppData.DeliverableBoard)
		{
			this.fable.AppData.DeliverableBoard =
			{
				Lanes: [], Stages: [], Counts: { Total: 0, Open: 0, Accepted: 0 }, Loading: false, Error: null
			};
		}
		return this.fable.AppData.DeliverableBoard;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }
	// Recovery-covered read; preserves the null-on-error contract callers rely on.
	_get(pPath) { return libFrameworkClient.getJSON(this.fable, this._url(pPath)).catch(() => null); }

	// The whole Deliver board in one read; mirrored into AppData.DeliverableBoard.
	dashboard()
	{
		let tmpStore = this.store();
		tmpStore.Loading = true;
		return this._get('Deliverables/Dashboard').then((pBody) =>
		{
			if (pBody)
			{
				tmpStore.Lanes = pBody.Lanes || [];
				tmpStore.Stages = pBody.Stages || [];
				tmpStore.Counts = pBody.Counts || tmpStore.Counts;
				tmpStore.Error = null;
			}
			else { tmpStore.Error = 'Could not load the deliver board.'; }
			tmpStore.Loading = false;
			return tmpStore;
		}).catch((pErr) => { tmpStore.Loading = false; tmpStore.Error = (pErr && pErr.message) || 'load failed'; return tmpStore; });
	}

	// Next sparse SortOrder for appending a card to the end of a lane.
	nextSortOrder(pLaneKey)
	{
		let tmpStore = this.store();
		let tmpMax = 0;
		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			if (tmpStore.Lanes[i].Key !== pLaneKey) { continue; }
			let tmpCards = tmpStore.Lanes[i].Cards || [];
			for (let j = 0; j < tmpCards.length; j++) { if ((tmpCards[j].SortOrder || 0) > tmpMax) { tmpMax = tmpCards[j].SortOrder; } }
		}
		return tmpMax + _SORT_STEP;
	}

	// Move a deliverable to a stage: PUT the Status + SortOrder, so the server audit logs the transition.
	moveCard(pID, pToStatus, pSortOrder)
	{
		let tmpBody = { IDDeliverable: pID, Status: pToStatus, SortOrder: pSortOrder };
		// EntityProvider.updateEntity -> the shared RestClient's putJSON (recovery-covered).
		return libFrameworkClient.updateEntity(this.fable, 'Deliverable', tmpBody);
	}
}

module.exports = PictProviderDeliverableBoardAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],590:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-DeployAPI
 * -----------------------
 * Browser client for the graphical deploy surface. One read (GET /1.0/Releases) backs the Releases
 * page: what commit runs on each environment, the As-Builts waiting to validate or promote, and the
 * in-flight deploy requests. requestDeploy() queues a DeployRequest (POST /1.0/DeployRequest) that a
 * deploy node claims and runs; the page never deploys anything itself, so no deploy credentials live
 * in the browser. See the graphical-deploy plan.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'DeployAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderDeployAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Releases)
		{
			this.fable.AppData.Releases =
			{
				Loaded: false, LoadError: null,
				Environments: [], AsBuilts: [], DeployRequests: [], OpenRuns: [], Nodes: [], DeployFleet: null
			};
		}
	}

	loadReleases()
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Releases;
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Releases')
			.then((pBody) =>
			{
				tmpStore.Environments = (pBody && pBody.Environments) || [];
				tmpStore.AsBuilts = (pBody && pBody.AsBuilts) || [];
				tmpStore.DeployRequests = (pBody && pBody.DeployRequests) || [];
				// The runs holding the deploy lanes. Deploying and promoting are runs now, so a lane can be
				// busy with nothing at all in the request feed; this store whitelists, so forgetting this
				// field reads on screen as a free lane and puts the stale Promote button back.
				tmpStore.OpenRuns = (pBody && pBody.OpenRuns) || [];
				// Node liveness. This store whitelists, so a field the server sends and this forgets is a
				// field that reads on screen as nothing at all -- the same way CanApprove once read as a
				// missing button. Kept as its own line for that reason.
				tmpStore.Nodes = (pBody && pBody.Nodes) || [];
				tmpStore.DeployFleet = (pBody && pBody.DeployFleet) || null;
				// Whether this person may clear a stuck record. The page hides the recovery controls without
				// it, so a field the server sends and this store forgets reads on screen as a missing button.
				tmpStore.CanApprove = !!(pBody && pBody.CanApprove);
				tmpStore.Loaded = true;
				tmpStore.LoadError = null;
				return pBody;
			})
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}

	// Queue a deploy for a deploy node to claim and run. pAction is 'DeployDev' or 'Promote'; the environment
	// follows from the action. pCommitRef is optional -- empty means "the current trunk", resolved at run time.
	//
	// The server refuses this with a 409 while that environment already has a deploy in flight. The rejected
	// error carries the server's sentence and StatusCode, so a caller can tell "the lane is busy" from a real
	// failure and say so in those words rather than as an error.
	requestDeploy(pAction, pCommitRef)
	{
		let tmpAction = (pAction === 'Promote') ? 'Promote' : 'DeployDev';
		let tmpEnvironment = (tmpAction === 'Promote') ? 'prod' : 'dev';
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'DeployRequest',
			{ Action: tmpAction, Environment: tmpEnvironment, CommitRef: pCommitRef || '', Status: 'Requested' });
	}

	// Queue one past a deploy that is already in flight. A different route from requestDeploy on purpose: this
	// one needs content.approve and a written reason, and it records which request it jumped. The plain create
	// stays overridable by nobody, which is what keeps a node from forcing its own way past a busy lane.
	forceDeploy(pAction, pReason, pCommitRef)
	{
		let tmpAction = (pAction === 'Promote') ? 'Promote' : 'DeployDev';
		let tmpEnvironment = (tmpAction === 'Promote') ? 'prod' : 'dev';
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'DeployRequest/Force',
			{ Action: tmpAction, Environment: tmpEnvironment, CommitRef: pCommitRef || '', Reason: pReason || '' });
	}
}

module.exports = PictProviderDeployAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],591:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-DocLakeAPI
 * ------------------------
 * Browser-side client for the Docs Lake (the one content system). Reads and
 * writes documents by PATH against /1.0/docs/* instead of ContentDocument rows.
 * Entity-to-doc links live in DocEntityLink (a plain table reached through
 * LinkAPI); this provider handles the doc bodies, the tree, and titles.
 *
 *   tree()              -> [DocNode...] for the current tenant (caches titles)
 *   titleFor(path)      -> the cached H1 title (or the file name)
 *   readDoc(path)       -> markdown/text body
 *   saveDoc(path, body) -> commit a platform edit, returns { Commit, Changed }
 *   deleteDoc(path)     -> remove a path (a commit)
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'DocLakeAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/docs/'
};

class PictProviderDocLakeAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.base = this.options.RoutePrefix;
		this._titles = {};
		this._nodes = [];
	}

	tree()
	{
		return libFrameworkClient.getJSON(this.fable, this.base + 'tree')
			.then((pBody) =>
			{
				this._nodes = (pBody && pBody.Nodes) || [];
				this._titles = {};
				this._nodes.forEach((pN) => { this._titles[pN.Path] = pN.Title || pN.Name; });
				return this._nodes;
			})
			.catch(() => []);
	}

	nodes() { return this._nodes; }
	titleFor(pPath) { return this._titles[pPath] || String(pPath).slice(String(pPath).lastIndexOf('/') + 1); }

	readDoc(pPath)
	{
		return libFrameworkClient.getText(this.fable, this.base + String(pPath).replace(/^\//, '')).catch(() => '');
	}

	saveDoc(pPath, pContent)
	{
		return libFrameworkClient.putJSON(this.fable, this.base + 'save', { Path: pPath, Content: pContent });
	}

	deleteDoc(pPath)
	{
		return libFrameworkClient.delJSON(this.fable, this.base + String(pPath).replace(/^\//, ''));
	}

	// ─── structure operations (folders, move, reorder) ───────────────────
	// Create an empty folder (writes its _folder.json marker) -> { Path, Commit, Changed }.
	createFolder(pPath, pLabel)
	{
		return libFrameworkClient.postJSON(this.fable, this.base + 'folder', { Path: pPath, Label: pLabel || '' });
	}

	// Move or rename a document or folder. Pass either an explicit To path or a
	// ToFolder to drop the source into -> { From, To, Commit, Changed, LinksAffected }.
	moveNode(pFrom, pTo, pToFolder)
	{
		let tmpBody = { From: pFrom };
		if (pTo) { tmpBody.To = pTo; }
		if (pToFolder !== undefined && pToFolder !== null) { tmpBody.ToFolder = pToFolder; }
		return libFrameworkClient.postJSON(this.fable, this.base + 'move', tmpBody);
	}

	// Persist a folder's sibling order (drag-to-reorder). pParentPath '' is the root.
	reorder(pParentPath, pOrder)
	{
		return libFrameworkClient.postJSON(this.fable, this.base + 'reorder', { ParentPath: pParentPath || '', Order: pOrder || [] });
	}

	// Delete a document or (recursively) a folder -> { Path, Changed, LinksAffected }.
	deleteNode(pPath)
	{
		return libFrameworkClient.delJSON(this.fable, this.base + String(pPath).replace(/^\//, ''));
	}
}

module.exports = PictProviderDocLakeAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],592:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-DocSyncAPI
 * ------------------------
 * Browser-side client for Documentation Sync (/1.0/Plansheet/DocSync). Backs the
 * Documentation Sync section of the settings hub: it lists the GitHub App
 * installations, reads and writes the stored repo->docs bindings, and kicks off a
 * sync run. Gated server-side by content.edit.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'DocSyncAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderDocSyncAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	// The stored repo->docs bindings for this plan sheet. Returns an array (empty when none).
	getBindings()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Plansheet/DocSync'))
			.then((pBody) => (pBody && pBody.Bindings) || []);
	}

	// The GitHub App state: { Configured, InstallURL, Installations }. Configured:false means the
	// server has no GitHub App set up, so the section can only explain that.
	listInstallations()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Plansheet/DocSync/Installations'))
			.then((pBody) => pBody || { Configured: false, InstallURL: '', Installations: [] });
	}

	// Create or update a binding. pPatch is { Github, Ref?, SourcePath?, TargetPath?, Direction?,
	// GithubInstallationID?, Enabled? }. Throws on a non-Success envelope; returns the saved Binding.
	saveBinding(pPatch)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Plansheet/DocSync'), pPatch || {})
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				return pBody.Binding;
			});
	}

	// Run a sync. pBody is { Github?, Ref?, SourcePath?, TargetPath? }; omit Github to re-run the
	// stored bindings. Throws on a non-Success envelope; returns the Results array.
	runSync(pBody)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Plansheet/DocSync/Run'), pBody || {})
			.then((pResponse) =>
			{
				if (!pResponse || !pResponse.Success) { throw new Error((pResponse && pResponse.Error) || 'HTTP 200'); }
				return pResponse.Results;
			});
	}

	// --- account-owned GitHub credentials (coexist with the GitHub App) ---

	// The account's stored GitHub tokens: { Configured, Tokens: [...] }. Configured:false means the
	// server has no token-encryption key, so a token cannot be stored (the UI explains that).
	listGithubTokens()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Account/GithubTokens'))
			.then((pBody) => pBody || { Configured: false, Tokens: [] });
	}

	// Add a token. pBody is { Token, Label?, Kind?, Scope?, Repo? }. The server validates it against
	// GitHub before storing and never echoes the token back. Returns { Token (public row), Probe }.
	addGithubToken(pBody)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Account/GithubTokens'), pBody || {})
			.then((pResponse) =>
			{
				if (!pResponse || !pResponse.Success) { throw new Error((pResponse && pResponse.Error) || 'HTTP 200'); }
				return pResponse;
			});
	}

	// Re-run the GitHub self-test for a stored token. pBody is { Repo? }. Returns the probe result
	// ({ Ok, Login, RepoCount, Repos, RepoCheck, CanWrite }) and refreshes the stored CanWrite flag.
	testGithubToken(pID, pBody)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Account/GithubTokens/' + encodeURIComponent(pID) + '/Test'), pBody || {})
			.then((pResponse) =>
			{
				if (!pResponse || !pResponse.Success) { throw new Error((pResponse && pResponse.Error) || 'HTTP 200'); }
				return pResponse;
			});
	}

	// Revoke (soft-delete) a stored token. Any binding pinned to it falls back to the GitHub App.
	revokeGithubToken(pID)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Account/GithubTokens/' + encodeURIComponent(pID)))
			.then((pResponse) =>
			{
				if (!pResponse || !pResponse.Success) { throw new Error((pResponse && pResponse.Error) || 'HTTP 200'); }
				return pResponse;
			});
	}
}

module.exports = PictProviderDocSyncAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],593:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-EntityAPI
 * -----------------------
 * Generic browser-side CRUD client for one meadow-endpoints entity. Registered
 * once per SDLC entity (Vision, Module, Feature, WorkItem) with a different
 * EntityName / PluralRoute / IDField. Tenancy is enforced entirely server-side
 * (IDCustomer is stamped + filtered there), so the client never sends it.
 *
 * meadow-endpoints route shapes (note the pluralized list routes):
 *   list   GET    /1.0/<Plural>/:Begin/:Cap                   -> JSON array
 *   page   GET    /1.0/<Plural>/FilteredTo/:Filter/:Begin/:Cap -> filtered, sorted and paged, in one call
 *   count  GET    /1.0/<Plural>/Count  |  /Count/FilteredTo/:Filter -> { Count: N }
 *   create POST   /1.0/<Entity>                                -> created row
 *   update PUT    /1.0/<Entity>                                -> updated row (body carries the id)
 *   delete DELETE /1.0/<Entity>/:id
 *
 * ONE PAGE OF THE SERVER'S ANSWER, NOT A GROWING HEAP (WI #433). This used to fetch the first 250 rows
 * and hand them to a view that sorted and filtered that array in the browser. Sorting 1,075 blueprints
 * descending by mark put 250 at the top and 1 at the bottom, because 250 was the largest thing the
 * client had ever been shown, and nothing on screen said so.
 *
 * So `List` is now exactly the server's answer for the page that was asked for, and the position is
 * held explicitly in `Page` rather than inferred from `List.length`. Inferring it is what made the old
 * loadMore() unreliable: cacheRecord() pushes an out-of-page record into the store, so the offset for
 * the next page was one row further along than the server's idea of it and a row was silently skipped.
 * cacheRecord now writes the Index alone for that reason -- lookups by id still resolve, and the page
 * stays the page.
 *
 * AppData shape this provider owns:
 *   AppData.Entities[EntityName] =
 *     { List, Index, Loading, Error, Total, HasMore, Page, PageSize, PageCount, QueryKey }
 *
 * QueryKey fingerprints the sort + filter the rows in List answer. The caller compares it to decide
 * whether it is looking at a new question (back to page 1) or a new page of the same one.
 *
 * A CALLER THAT JUST NEEDS TO RESOLVE RECORDS -- A LABEL, A PICKER -- USES resolve(), NOT list()
 * (WI #447). The detail view loads the four SDLC bases (and any relation target) to draw its pickers,
 * and used to do that with a plain list(): a request for exactly the page a list SCREEN already reads
 * from. Opening any record replaced that screen's List, reset its Page to 1, and overwrote its
 * QueryKey out from under it, so paging to page 4, opening a record, and going back silently landed
 * back on page 1. resolve() asks the server the identical question but writes only to Index, the same
 * seam cacheRecord already uses for exactly this reason; the list screen's own paging is untouched.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'EntityAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'Entity',
	PluralRoute: 'Entitys',
	IDField: 'IDEntity'
};

// Rows per page. The UI (PictView-EntityList) draws first / prev / page N of M / next / last against it.
const _PAGE_SIZE = 250;

// The cap on one sweep of _listAll, which walks pages until the server runs out. It exists only so a
// bug (or a table that grew a great deal between the count and the walk) cannot spin forever; the
// sweep also stops on any short page, which is the ordinary way out.
const _ALL_PAGE_LIMIT = 200;

class PictProviderEntityAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this.routePrefix = this.options.RoutePrefix;
		this.entityName = this.options.EntityName;
		this.pluralRoute = this.options.PluralRoute;
		this.idField = this.options.IDField;
	}

	store()
	{
		if (!this.fable.AppData.Entities) this.fable.AppData.Entities = {};
		if (!this.fable.AppData.Entities[this.entityName])
		{
			this.fable.AppData.Entities[this.entityName] =
				{ List: [], Index: {}, Loading: false, Error: null, Total: 0, HasMore: false, Page: 1, PageSize: _PAGE_SIZE, PageCount: 1, QueryKey: '' };
		}
		return this.fable.AppData.Entities[this.entityName];
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_index(pList)
	{
		let tmpStore = this.store();
		tmpStore.List = Array.isArray(pList) ? pList : [];
		tmpStore.Index = {};
		for (let i = 0; i < tmpStore.List.length; i++)
		{
			tmpStore.Index[tmpStore.List[i][this.idField]] = tmpStore.List[i];
		}
	}

	// The count from meadow's /Count ({ Count: N }); falls back to the loaded length when it is unavailable.
	_countOf(pCountBody, pFallback)
	{
		let tmpN = pCountBody && (typeof pCountBody === 'number' ? pCountBody : pCountBody.Count);
		return (typeof tmpN === 'number' && tmpN >= 0) ? tmpN : pFallback;
	}

	// meadow answers a list as a bare array; a few wrapped shapes exist in the wild, so unwrap either.
	_rowsOf(pBody)
	{
		return Array.isArray(pBody) ? pBody : ((pBody && pBody.Records) || []);
	}

	// The read route for a window of rows: FilteredTo when there is something to filter or sort by,
	// the plain begin/cap route when there is not.
	//
	// THE FILTER IS URL-ENCODED, unlike the hand-built filters elsewhere in this app. Those carry only
	// ids and tildes, both of which survive a path segment untouched. These carry LIKE wildcards, and a
	// bare '%' makes Express' own decodeURIComponent of the route parameter throw, which is a 400 on
	// the first character typed into any search box.
	_readRoute(pFilter, pBegin, pCap)
	{
		let tmpTail = '/' + pBegin + '/' + pCap;
		if (!pFilter) { return this.pluralRoute + tmpTail; }
		return this.pluralRoute + '/FilteredTo/' + encodeURIComponent(pFilter) + tmpTail;
	}

	// The count for the SAME question the page asked. Counting the unfiltered table instead is what
	// makes a page count lie the moment a filter is on: 5 pages of "matches" over 2 pages of matches.
	_countRoute(pFilter)
	{
		if (!pFilter) { return this.pluralRoute + '/Count'; }
		return this.pluralRoute + '/Count/FilteredTo/' + encodeURIComponent(pFilter);
	}

	// A fingerprint of the question the store's rows answer, so a caller can tell a new question
	// (start at page 1) from another page of the same one.
	queryKey(pOptions)
	{
		let tmpOptions = pOptions || {};
		return (tmpOptions.All ? 'all|' : 'page|') + String(tmpOptions.Filter || '');
	}

	/**
	 * One page of records, plus the real total for the filter that page was fetched with.
	 *
	 *   list()                                    page 1, unfiltered -- what every non-list caller wants
	 *   list({ Page: 3, Filter: '<meadow-filter>' })  the third page of a filtered, sorted list
	 *   list({ All: true })                       every row, unpaged (see _listAll)
	 *
	 * List is replaced, never appended to: it is the server's answer for one page and nothing else.
	 */
	list(pOptions)
	{
		let tmpOptions = pOptions || {};
		if (tmpOptions.All) { return this._listAll(tmpOptions); }
		let tmpStore = this.store();
		let tmpPageSize = Math.max(1, Number(tmpOptions.PageSize) || _PAGE_SIZE);
		let tmpPage = Math.max(1, Number(tmpOptions.Page) || 1);
		let tmpFilter = String(tmpOptions.Filter || '');
		let tmpBegin = (tmpPage - 1) * tmpPageSize;
		tmpStore.Loading = true;
		// Both through the shared RestClient so a 401 here drives session recovery. The count is
		// best-effort: a missing /Count (or a failure) leaves the page count inferred from this page.
		let tmpRows = libFrameworkClient.getJSON(this.fable, this._url(this._readRoute(tmpFilter, tmpBegin, tmpPageSize)));
		let tmpCount = libFrameworkClient.getJSON(this.fable, this._url(this._countRoute(tmpFilter))).catch(() => null);
		return Promise.all([tmpRows, tmpCount])
			.then((pResults) =>
			{
				let tmpPageRows = this._rowsOf(pResults[0]);
				this._index(tmpPageRows);
				// The floor under the total when /Count did not answer: everything before this page,
				// plus this page. It never claims rows it has not seen.
				tmpStore.Total = this._countOf(pResults[1], tmpBegin + tmpPageRows.length);
				tmpStore.PageSize = tmpPageSize;
				tmpStore.Page = tmpPage;
				tmpStore.PageCount = Math.max(1, Math.ceil(tmpStore.Total / tmpPageSize));
				tmpStore.HasMore = tmpPage < tmpStore.PageCount;
				tmpStore.QueryKey = this.queryKey(tmpOptions);
				tmpStore.Loading = false;
				tmpStore.Error = null;
				return tmpStore.List;
			})
			.catch((pErr) =>
			{
				tmpStore.Loading = false;
				tmpStore.Error = pErr.message;
				return [];
			});
	}

	/**
	 * Every row, in one unpaged store.
	 *
	 * This is the honest fallback, not an optimisation. When the screen is asking something the filter
	 * language cannot express (see FocusQuery's Unexpressed), the server would answer a DIFFERENT
	 * question than the one on screen, so the caller fetches the whole set and filters it in the
	 * browser instead. Applying half the question to one page and paging it anyway is the exact defect
	 * WI #433 exists to fix.
	 *
	 * Sequential because each page's begin depends on how much came back before it.
	 */
	_listAll(pOptions)
	{
		let tmpStore = this.store();
		let tmpOptions = pOptions || {};
		let tmpPageSize = Math.max(1, Number(tmpOptions.PageSize) || _PAGE_SIZE);
		let tmpFilter = String(tmpOptions.Filter || '');
		let tmpAll = [];
		tmpStore.Loading = true;
		let fStep = (pPageIndex) =>
		{
			return libFrameworkClient.getJSON(this.fable, this._url(this._readRoute(tmpFilter, pPageIndex * tmpPageSize, tmpPageSize)))
				.then((pBody) =>
				{
					let tmpRows = this._rowsOf(pBody);
					tmpAll = tmpAll.concat(tmpRows);
					// A short page is the last page, whatever any count says, so a stale total can
					// never spin this.
					if (tmpRows.length < tmpPageSize) { return tmpAll; }
					if ((pPageIndex + 1) >= _ALL_PAGE_LIMIT) { return tmpAll; }
					return fStep(pPageIndex + 1);
				});
		};
		return fStep(0)
			.then(() =>
			{
				this._index(tmpAll);
				tmpStore.Total = tmpAll.length;
				tmpStore.PageSize = tmpPageSize;
				tmpStore.Page = 1;
				tmpStore.PageCount = 1;
				tmpStore.HasMore = false;
				tmpStore.QueryKey = this.queryKey(tmpOptions);
				tmpStore.Loading = false;
				tmpStore.Error = null;
				return tmpStore.List;
			})
			.catch((pErr) =>
			{
				tmpStore.Loading = false;
				tmpStore.Error = pErr.message;
				return [];
			});
	}

	// Read one record by id (meadow read-one: GET /1.0/<Entity>/<id>). Returns the record or null.
	read(pID)
	{
		// Recovery-covered read; preserves the null-on-miss contract callers rely on.
		return libFrameworkClient.getJSON(this.fable, this._url(this.entityName + '/' + encodeURIComponent(pID)))
			.then((pBody) => (pBody && pBody[this.idField]) ? pBody : null)
			.catch(() => null);
	}

	// Merge one record (e.g. a read-by-id for a record outside the current page) into the store so
	// lookups by id resolve. Used by the detail view, which resolves the open record by id rather than
	// depending on whichever page the list happens to be showing (WI #329).
	//
	// THE INDEX, NEVER THE LIST (WI #433). This used to push an out-of-page record onto List, which put
	// a row on screen that the server had not put on this page and pushed the last real row off the
	// end of it. It also broke the old loadMore(), whose next offset was List.length: one extra row in
	// the store meant one row of the next page silently skipped. List is the server's answer for the
	// page that was asked for; every id lookup reads Index, so nothing needs it to be more than that.
	cacheRecord(pRecord)
	{
		if (!pRecord) { return pRecord; }
		let tmpID = pRecord[this.idField];
		if (tmpID === null || typeof tmpID === 'undefined') { return pRecord; }
		let tmpStore = this.store();
		if (tmpStore.Index[tmpID]) { Object.assign(tmpStore.Index[tmpID], pRecord); }
		else { tmpStore.Index[tmpID] = pRecord; }
		return pRecord;
	}

	// cacheRecord, for a page of rows at once. See resolve(), its one caller.
	cacheRecords(pRows)
	{
		(pRows || []).forEach((pRow) => this.cacheRecord(pRow));
		return pRows || [];
	}

	/**
	 * One page of records merged into the Index, for a caller that needs to RESOLVE records -- a label
	 * lookup, a picker's options -- without asserting itself as the list screen's current question
	 * (WI #447).
	 *
	 * THE INDEX, NEVER LIST/PAGE/QUERYKEY, FOR THE SAME REASON AS cacheRecord (WI #433/#447). A detail
	 * view opens in front of whichever list a person was just paging through, and it needs the four SDLC
	 * bases (plus any relation target) loaded to resolve names and build its pickers. Fetching those
	 * through list() -- as it used to -- REPLACED this store's List, reset Page to 1 and overwrote
	 * QueryKey, so opening any record silently moved the list screen behind it back to page one. resolve()
	 * asks the server for the identical page list() would, but writes only to Index: the list screen's own
	 * paging state is untouched, and the caller gets the rows back directly to build a picker from.
	 */
	resolve(pOptions)
	{
		let tmpOptions = pOptions || {};
		let tmpPageSize = Math.max(1, Number(tmpOptions.PageSize) || _PAGE_SIZE);
		let tmpPage = Math.max(1, Number(tmpOptions.Page) || 1);
		let tmpFilter = String(tmpOptions.Filter || '');
		let tmpBegin = (tmpPage - 1) * tmpPageSize;
		return libFrameworkClient.getJSON(this.fable, this._url(this._readRoute(tmpFilter, tmpBegin, tmpPageSize)))
			.then((pBody) => this.cacheRecords(this._rowsOf(pBody)))
			.catch(() => []);
	}

	create(pRecord)
	{
		// EntityProvider.createEntity -> the shared RestClient's postJSON (recovery-covered).
		return libFrameworkClient.createEntity(this.fable, this.entityName, pRecord);
	}

	update(pID, pRecord)
	{
		let tmpBody = Object.assign({}, pRecord);
		tmpBody[this.idField] = pID;
		return libFrameworkClient.updateEntity(this.fable, this.entityName, tmpBody);
	}

	remove(pID)
	{
		return libFrameworkClient.deleteEntity(this.fable, this.entityName, pID).then(() => true);
	}
}

module.exports = PictProviderEntityAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],594:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-FeatureBoardAPI
 * -----------------------------
 * Browser-side client for the Feature board and the acceptance decision.
 *
 * Features get a board of their own because work items move at agent speed and features move at
 * product speed. One surface implied they should move together, and that implication is the
 * pressure that produces rubber stamps.
 *
 * AppData.FeatureBoard = { Lanes, CanAccept, Loading, Error }
 *   card = { IDFeature, FeatureNumber, Name, Status, Priority, AcceptanceSentence,
 *            WorkItemsConnected, WorkItemsDone, WorkItemsOpen, LastLandedDate,
 *            Commits, AsBuiltsDeployed, AsBuiltsValidated,
 *            StillFailingReview, PriorAcceptances }
 *
 * The counts ride on the card on purpose. A card that showed only a title would leave the reader
 * with nothing to judge but the title, which is how a queue becomes a stack of rubber stamps.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'FeatureBoardAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

const _SORT_STEP = 100; // sparse SortOrder so a drop rarely renumbers a lane

class PictProviderFeatureBoardAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	store()
	{
		if (!this.fable.AppData.FeatureBoard)
		{
			this.fable.AppData.FeatureBoard = { Lanes: [], CanAccept: false, Loading: false, Error: null };
		}
		return this.fable.AppData.FeatureBoard;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }

	// The whole board in one read, mirrored into AppData.FeatureBoard.
	list()
	{
		let tmpStore = this.store();
		tmpStore.Loading = true;
		return libFrameworkClient.getJSON(this.fable, this._url('FeatureBoard'))
			.then((pBody) =>
			{
				tmpStore.Lanes = (pBody && Array.isArray(pBody.Lanes)) ? pBody.Lanes : [];
				tmpStore.CanAccept = !!(pBody && pBody.CanAccept);
				tmpStore.Loading = false;
				tmpStore.Error = null;
				return tmpStore.Lanes;
			})
			.catch((pError) =>
			{
				tmpStore.Loading = false;
				tmpStore.Error = (pError && pError.message) || String(pError);
				return [];
			});
	}

	// The evidence one decision is made against: the acceptance sentence, the counts, the work
	// items themselves, and every prior decision on this feature.
	acceptance(pIDFeature)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Feature/' + encodeURIComponent(pIDFeature) + '/Acceptance'));
	}

	/**
	 * Record the decision. pOutcome is 'Accept' | 'SendBack' and pNote is the markdown, which the
	 * server requires either way: it 400s an empty note rather than accepting a blank verdict.
	 *
	 * pCloseWorkItems is the set of still-open work items the person ticked in the confirm list, to
	 * be marked Done along with the feature. The server ignores it on a send-back and drops any id
	 * that does not belong to this feature.
	 */
	decide(pIDFeature, pOutcome, pNote, pCloseWorkItems)
	{
		let tmpBody = { Outcome: pOutcome, Note: pNote || '' };
		if (Array.isArray(pCloseWorkItems) && pCloseWorkItems.length) { tmpBody.CloseWorkItems = pCloseWorkItems; }
		return libFrameworkClient.postJSON(this.fable, this._url('Feature/' + encodeURIComponent(pIDFeature) + '/Accept'), tmpBody);
	}

	/**
	 * One decision about a named set of features.
	 *
	 * For the case where a person has already made one judgement that covers many -- most obviously
	 * the backfill, where features finished long before there was a column to record an acceptance
	 * in. The server records BatchSize on every row, so the history says this was one judgement
	 * about N and never claims N separate readings.
	 */
	decideMany(pIDFeatures, pOutcome, pNote, pCloseWorkItems)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Feature/Accept/Bulk'),
			{
				IDFeatures: pIDFeatures || [], Outcome: pOutcome,
				Note: pNote || '', CloseWorkItems: !!pCloseWorkItems
			});
	}

	nextSortOrder(pLaneKey)
	{
		let tmpMax = 0;
		(this.store().Lanes || []).forEach((pLane) =>
		{
			if (pLane.Key !== pLaneKey) { return; }
			(pLane.Cards || []).forEach((pCard) => { if (pCard.SortOrder > tmpMax) { tmpMax = pCard.SortOrder; } });
		});
		return tmpMax + _SORT_STEP;
	}

	/**
	 * Drag a feature to another lane. The generic entity PUT, exactly as the work item board does
	 * it, so the server audit logs the transition.
	 *
	 * Every lane, Done included: moving a card to Done prospectively is ordinary practice and is not
	 * refused. What a plain write cannot do is stamp AcceptedDate, so a feature dropped on Done is
	 * finished with no assessment recorded, and says so on its card until somebody writes one. The
	 * view opens the acceptance dialog right after this drop lands, as an invitation rather than a
	 * toll gate.
	 */
	moveCard(pIDFeature, pToStatus, pSortOrder)
	{
		return libFrameworkClient.updateEntity(this.fable, 'Feature',
			{ IDFeature: pIDFeature, Status: pToStatus, WorkflowStatus: pToStatus, SortOrder: pSortOrder });
	}
}

module.exports = PictProviderFeatureBoardAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],595:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-IssueBoardAPI
 * ---------------------------
 * Browser-side client for the issue endpoints that auto-CRUD cannot serve: the dashboard (kanban
 * lanes + the standard cuts + call volume), the kanban move, the issue<->work-item links, and
 * spawning a vision from an issue. Basic issue CRUD (create, read, update, list) goes through the
 * generic EntityAPI; this provider is the rest. Tenancy + access are enforced server-side.
 *
 * AppData.IssueBoard = { Lanes, Mine, RecentlyClosed, Counts, CallVolume, Loading, Error }
 *   card = { IDIssue, IssueNumber, Title, Status, Priority, Severity, TypeName, TypeColor,
 *            AssigneeName, CustomerName, FromCall, ResolvedDate, SortOrder }
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'IssueBoardAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

const _SORT_STEP = 100; // sparse SortOrder so a drop rarely renumbers a lane

class PictProviderIssueBoardAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	store()
	{
		if (!this.fable.AppData.IssueBoard)
		{
			this.fable.AppData.IssueBoard =
			{
				Lanes: [], Mine: [], RecentlyClosed: [],
				Counts: { Total: 0, Open: 0, Mine: 0, ClosedRecently: 0 },
				CallVolume: { Last7: 0, Last30: 0, Total: 0, OpenFromCalls: 0 },
				Loading: false, Error: null
			};
		}
		return this.fable.AppData.IssueBoard;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }
	// Recovery-covered read/write; both preserve the null-on-error contract callers rely on.
	_get(pPath) { return libFrameworkClient.getJSON(this.fable, this._url(pPath)).catch(() => null); }
	_post(pPath, pBody) { return libFrameworkClient.postJSON(this.fable, this._url(pPath), pBody || {}).catch(() => null); }

	// The whole issues dashboard in one read; mirrored into AppData.IssueBoard.
	dashboard()
	{
		let tmpStore = this.store();
		tmpStore.Loading = true;
		return this._get('Issues/Dashboard').then((pBody) =>
		{
			if (pBody)
			{
				tmpStore.Lanes = pBody.Lanes || [];
				tmpStore.Mine = pBody.Mine || [];
				tmpStore.RecentlyClosed = pBody.RecentlyClosed || [];
				tmpStore.Counts = pBody.Counts || tmpStore.Counts;
				tmpStore.CallVolume = pBody.CallVolume || tmpStore.CallVolume;
				tmpStore.Error = null;
			}
			else { tmpStore.Error = 'Could not load the issues dashboard.'; }
			tmpStore.Loading = false;
			return tmpStore;
		}).catch((pErr) => { tmpStore.Loading = false; tmpStore.Error = (pErr && pErr.message) || 'load failed'; return tmpStore; });
	}

	// Next sparse SortOrder for appending a card to the end of a lane.
	nextSortOrder(pLaneKey)
	{
		let tmpStore = this.store();
		let tmpMax = 0;
		for (let i = 0; i < tmpStore.Lanes.length; i++)
		{
			if (tmpStore.Lanes[i].Key !== pLaneKey) { continue; }
			let tmpCards = tmpStore.Lanes[i].Cards || [];
			for (let j = 0; j < tmpCards.length; j++) { if ((tmpCards[j].SortOrder || 0) > tmpMax) { tmpMax = tmpCards[j].SortOrder; } }
		}
		return tmpMax + _SORT_STEP;
	}

	// Move an issue to a lane: PUT the Status + SortOrder (Issue has no WorkflowStatus column), exactly
	// like the Feature/WorkItem board, so the server audit logs the transition and stamps ResolvedDate.
	moveCard(pID, pToStatus, pSortOrder)
	{
		let tmpBody = { IDIssue: pID, Status: pToStatus, SortOrder: pSortOrder };
		// EntityProvider.updateEntity -> the shared RestClient's putJSON (recovery-covered).
		return libFrameworkClient.updateEntity(this.fable, 'Issue', tmpBody);
	}

	// Issue<->WorkItem links use the generic join (IssueWorkItemJoin via the 'link' relation render);
	// this provider only owns the dashboard, the kanban move, and spawning a vision.
	spawnVision(pID, pDraft) { return this._post('Issue/' + encodeURIComponent(pID) + '/SpawnVision', pDraft || {}); }
	// Promote a piece of Feedback into a WorkItem: the server links WorkItem.IDSourceFeedback and
	// carries the target (Vision|Module|Feature) chosen in the spawn dialog.
	spawnWorkItem(pIDFeedback, pDraft) { return this._post('Feedback/' + encodeURIComponent(pIDFeedback) + '/SpawnWorkItem', pDraft || {}); }
	// Promote an Issue into a WorkItem: the server reverse-links via IssueWorkItemJoin (Addresses).
	spawnWorkItemFromIssue(pIDIssue, pDraft) { return this._post('Issue/' + encodeURIComponent(pIDIssue) + '/SpawnWorkItem', pDraft || {}); }
	// Link many Issues to one WorkItem at once (idempotent). pRelationType defaults to Addresses.
	linkIssuesToWorkItem(pIDWorkItem, pIDIssues, pRelationType) { return this._post('WorkItem/' + encodeURIComponent(pIDWorkItem) + '/Issues/Link', { IDIssues: pIDIssues || [], RelationType: pRelationType || 'Addresses' }); }
	// Link many Feedback to one WorkItem at once (idempotent). pRelationType defaults to Drives. The
	// server keeps WorkItem.IDSourceFeedback as the primary (first) link for backward compatibility.
	linkFeedbackToWorkItem(pIDWorkItem, pIDFeedbacks, pRelationType) { return this._post('WorkItem/' + encodeURIComponent(pIDWorkItem) + '/Feedback/Link', { IDFeedbacks: pIDFeedbacks || [], RelationType: pRelationType || 'Drives' }); }
	assignees() { return this._get('Issues/Assignees').then((pBody) => (pBody && pBody.Assignees) || []).catch(() => []); }
}

module.exports = PictProviderIssueBoardAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],596:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-LaneAPI
 * ---------------------
 * Browser-side client for the per-tenant board lanes (/1.0/Board/Lanes). Backs the
 * admin lane manager in Settings and hands the lane set to the Board API provider.
 * Reads (list) are open to any signed-in user; create / update / reorder / delete
 * are gated server-side by board.manage (Owner / Admin).
 *
 * A lane is { IDBoardLane, Key, Label, Color, SortOrder, IsTerminal }. Key is the
 * stable Status token a card stores; it is set at creation and never edited.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'LaneAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderLaneAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	// Resolves to an array of lanes (seeded server-side on a tenant's first read).
	listLanes()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Board/Lanes'))
			.then((pBody) => (pBody && Array.isArray(pBody.Lanes)) ? pBody.Lanes : []);
	}

	createLane(pLabel, pColor, pIsTerminal)
	{
		return this._write(libFrameworkClient.postJSON, 'Board/Lanes', { Label: pLabel || '', Color: pColor || '', IsTerminal: !!pIsTerminal });
	}

	// pPatch is any of { Label, Color, IsTerminal }.
	updateLane(pIDBoardLane, pPatch)
	{
		return this._write(libFrameworkClient.putJSON, 'Board/Lanes/' + (parseInt(pIDBoardLane, 10) || 0), pPatch || {});
	}

	// pOrder is an array of IDBoardLane in the desired left-to-right order.
	reorderLanes(pOrder)
	{
		return this._write(libFrameworkClient.putJSON, 'Board/Lanes/Reorder', { Order: Array.isArray(pOrder) ? pOrder : [] });
	}

	deleteLane(pIDBoardLane)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Board/Lanes/' + (parseInt(pIDBoardLane, 10) || 0)))
			.then((pJSON) =>
			{
				if (!pJSON || !pJSON.Success) { throw new Error((pJSON && pJSON.Error) || 'Request failed.'); }
				return pJSON;
			});
	}

	_write(pVerb, pPath, pBody)
	{
		return pVerb(this.fable, this._url(pPath), pBody || {})
			.then((pJSON) =>
			{
				if (!pJSON || !pJSON.Success) { throw new Error((pJSON && pJSON.Error) || 'Request failed.'); }
				return pJSON;
			});
	}
}

module.exports = PictProviderLaneAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],597:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-LinkAPI
 * ---------------------
 * Browser-side client for the thin join tables (FeatureVisionJoin,
 * FeatureModuleJoin, VisionVisionJoin). The EntityDetail view uses it to read
 * the links for one parent record and to add / remove links. Tenancy is
 * enforced server-side (IDCustomer is stamped on create and filters reads), so
 * the client only sends the two FK columns (and RelationType where relevant).
 *
 * No AppData of its own — links are transient, read per-parent on demand and
 * re-read after a mutation.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'LinkAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderLinkAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	/**
	 * Read the join rows for one parent: GET /1.0/<Plural>/FilteredTo/<Field>=<Value>/0/250
	 */
	listLinks(pPlural, pField, pValue)
	{
		// meadow-filter DSL: INSTRUCTION~FIELD~OPERATOR~VALUE (FBV = Filter By
		// Value, EQ = equals). NOT "Field=Value" — that parses to <4 terms and
		// is silently ignored (returns the whole tenant set).
		let tmpURL = pPlural + '/FilteredTo/FBV~' + pField + '~EQ~' + pValue + '/0/250';
		return libFrameworkClient.getJSON(this.fable, this._url(tmpURL))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/**
	 * Multi-condition filtered read: each entry adds an FBV~Field~EQ~Value term
	 * (chained by ~ for AND). e.g. listLinksWhere('DocEntityLinks',
	 * [{Field:'EntityType',Value:'Vision'},{Field:'IDEntity',Value:3}]).
	 */
	listLinksWhere(pPlural, pFilters)
	{
		let tmpFilter = (pFilters || []).map((pF) => 'FBV~' + pF.Field + '~EQ~' + pF.Value).join('~');
		let tmpURL = pPlural + '/FilteredTo/' + tmpFilter + '/0/250';
		return libFrameworkClient.getJSON(this.fable, this._url(tmpURL))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	addLink(pEntity, pRecord)
	{
		return libFrameworkClient.postJSON(this.fable, this._url(pEntity), pRecord);
	}

	removeLink(pEntity, pID)
	{
		return libFrameworkClient.delJSON(this.fable, this._url(pEntity + '/' + pID))
			.then(() => true);
	}
}

module.exports = PictProviderLinkAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],598:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-LoopsAPI
 * ----------------------
 * Browser-side client for the four refinement loops around a vision (Design, Build, Deliver, Gather
 * Feedback), computed server-side at read time. One call per vision; the VisionLoops view renders it.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'LoopsAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderLoopsAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }

	loops(pIDVision)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Vision/' + encodeURIComponent(pIDVision) + '/Loops'))
			.catch(() => null);
	}
}

module.exports = PictProviderLoopsAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],599:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-Markup
 * --------------------
 * One representation of an entity, used everywhere.
 *
 * A drawing set works because every sheet carries a mark, the mark is stable, and any sheet can
 * reference any other by it. WI-003 is always WI-003. Eighteen entities carry a per-plan-sheet
 * number (the descriptor NumberField), but until now that number only sorted a list and headed a
 * detail page, so nothing on screen could quote it. This turns those numbers into a designator and
 * builds the three representations every surface needs from one place:
 *
 *   designator()   the mark itself, WI-301
 *   mark()         the normalized record a title block or card renders
 *   tooltipMark()  the same, plus description, status, and cross-references
 *
 * The prefix is NOT invented here. It lives on the descriptor beside NumberField
 * (EntityDescriptors.js), which is where the rest of an entity's identity already lives, so a new
 * entity declares its own mark and this provider stays dumb. Two prefixes collide on first letter and
 * are resolved there by seniority: Feature keeps F so Feedback takes FB, and Deploy Request keeps DR
 * so Deliverable takes DLV. A test asserts they all stay unique, and it counts them, so adding one is
 * a deliberate act rather than a merge artifact.
 *
 * Nothing here talks to the network. It is pure formatting over records a caller already has.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libDescriptors = require('../EntityDescriptors.js');
// The mark itself is formed in EntityMark, not here. This provider requires pict, so the server can
// never load it -- and BlueprintRender draws the public shared page server-side. Keeping the
// formatter in a dependency-free module is what stops the two sides growing separate copies of the
// padding and prefix rules.
const libEntityMark = require('../EntityMark.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Markup',
	Dependencies: [],
	// Three digits is the width a plan sheet reads best at (WI-006, not WI-6). Past 999 the number
	// simply grows -- padding is a floor, never a ceiling, so WI-1024 is untouched.
	NumberPad: 3
};

class PictProviderMarkup extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.numberPad = libEntityMark.NumberPad;
	}

	descriptor(pEntityKey) { return libEntityMark.descriptorFor(pEntityKey); }

	/** The prefix an entity marks its records with, or '' when it does not carry a number. */
	prefix(pEntityKey) { return libEntityMark.prefix(pEntityKey); }

	/**
	 * The mark: 'WI-301'. Accepts either the record or the bare number, because callers have one or the
	 * other depending on how much of the row they loaded.
	 */
	designator(pEntityKey, pRecordOrNumber) { return libEntityMark.designator(pEntityKey, pRecordOrNumber); }

	/** Read a mark back into what it points at: 'WI-301' -> { Entity:'WorkItem', Number:301 }. */
	parse(pDesignator) { return libEntityMark.parse(pDesignator); }

	/**
	 * The normalized record a title block or a card renders. Cells are ordered and already stringified,
	 * so a template never reaches back into the entity and every surface shows the same four things in
	 * the same order. A cell with nothing to say still renders, with a dash, because a missing cell
	 * would shift the ones after it and break the scan down a column.
	 */
	mark(pEntityKey, pRecord, pOptions)
	{
		let tmpRecord = pRecord || {};
		let tmpOptions = pOptions || {};
		let tmpDescriptor = this.descriptor(pEntityKey);
		let tmpCells = Array.isArray(tmpOptions.Cells) ? tmpOptions.Cells : [];
		return {
			Entity: pEntityKey,
			Designator: this.designator(pEntityKey, tmpRecord),
			Title: String(tmpRecord[(tmpDescriptor && tmpDescriptor.TitleField) || 'Title'] || ''),
			Kind: String(tmpRecord.Type || (tmpDescriptor && tmpDescriptor.Title) || pEntityKey),
			KindClass: 'ps-mark-' + String(pEntityKey).toLowerCase(),
			Icon: (tmpDescriptor && tmpDescriptor.Icon) || '',
			Status: String(tmpRecord.Status || ''),
			Cells: tmpCells.map((pCell) => ({ K: String(pCell.K || ''), V: this._cellValue(pCell.V) }))
		};
	}

	/** A cell always renders. An empty value becomes a dash so the columns below it stay aligned. */
	_cellValue(pValue)
	{
		let tmpText = (pValue === null || typeof pValue === 'undefined') ? '' : String(pValue).trim();
		return tmpText ? tmpText : '—';
	}

	/**
	 * The loaded tooltip: the mark, plus what a person needs to decide without opening the record.
	 * Cross-references are marks themselves, which is the whole point -- the tooltip for WI-301 names
	 * F-167 and V-043, and those read the same everywhere else in the platform.
	 */
	tooltipMark(pEntityKey, pRecord, pOptions)
	{
		let tmpOptions = pOptions || {};
		let tmpMark = this.mark(pEntityKey, pRecord, tmpOptions);
		tmpMark.Description = String((pRecord || {}).Description || '');
		tmpMark.References = (Array.isArray(tmpOptions.References) ? tmpOptions.References : [])
			.map((pReference) => (typeof pReference === 'string')
				? pReference
				: this.designator(pReference.Entity, pReference.Number))
			.filter((pReference) => pReference);
		return tmpMark;
	}
}

module.exports = PictProviderMarkup;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../EntityDescriptors.js":555,"../EntityMark.js":556,"pict":375}],600:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-MediaAPI
 * ----------------------
 * Browser-side client for Media — screenshots, photos, drawings, recordings,
 * how-to assets — owned polymorphically (OwnerType + IDOwner) with bytes in
 * Parime. Two-stage upload mirrors SessionAPI. Reads are filtered by owner
 * (team-visible; the server scopes by IDCustomer). Images/SVGs display straight
 * from the blob URL.
 *
 * An entity gallery uses OwnerType = the entity key ('Vision' | 'Feature' | …).
 * Images/drawings embedded in a document are owned by that document's entity
 * (the same OwnerType + IDOwner), so they also surface in the entity's gallery.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'MediaAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderMediaAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_guessType(pMime)
	{
		let tmpMime = pMime || '';
		if (tmpMime.indexOf('image/svg') === 0) return 'Drawing';
		if (tmpMime.indexOf('image/') === 0) return 'Screenshot';
		if (tmpMime.indexOf('video/') === 0 || tmpMime.indexOf('audio/') === 0) return 'Recording';
		return 'Other';
	}

	blobURL(pIDMedia) { return this._url('Media/' + pIDMedia + '/Blob'); }

	/**
	 * List media owned by (pOwnerType, pIDOwner). meadow-filter DSL chains
	 * FBV~Field~EQ~Value terms with ~ for AND.
	 */
	listForOwner(pOwnerType, pIDOwner)
	{
		let tmpFilter = 'FBV~OwnerType~EQ~' + pOwnerType + '~FBV~IDOwner~EQ~' + pIDOwner;
		return libFrameworkClient.getJSON(this.fable, this._url('Medias/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/**
	 * Two-stage upload: POST metadata to /Media/New, then PUT the bytes to
	 * /Media/:id/Blob. pFile is a browser File/Blob (name/type/size) or an
	 * ArrayBuffer. pOverrides can set Title/MediaType/MimeType/OriginalFileName
	 * (used for SVG drawings, which arrive as a string-built Blob).
	 */
	upload(pOwnerType, pIDOwner, pFile, pOverrides)
	{
		let tmpOverrides = pOverrides || {};
		let tmpMime = tmpOverrides.MimeType || pFile.type || 'application/octet-stream';
		let tmpMeta =
		{
			OwnerType: pOwnerType,
			IDOwner: pIDOwner,
			Title: tmpOverrides.Title || pFile.name || 'Untitled',
			MediaType: tmpOverrides.MediaType || this._guessType(tmpMime),
			MimeType: tmpMime,
			OriginalFileName: tmpOverrides.OriginalFileName || pFile.name || 'file',
			FileSizeBytes: pFile.size || pFile.byteLength || 0,
			// Private uploads (the user gallery, note images) are owned by the uploader (Media.IDUser);
			// omitted/false leaves it team-visible like entity-gallery media.
			Private: !!tmpOverrides.Private
		};

		return libFrameworkClient.postJSON(this.fable, this._url('Media/New'), tmpMeta)
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success || !pBody.Media)
				{
					throw new Error((pBody && pBody.Error) || 'Could not register media.');
				}
				let tmpID = pBody.Media.IDMedia;
				return this._putBlob(tmpID, pFile, tmpMime).then((pPutBody) => Object.assign({ IDMedia: tmpID }, pBody.Media, pPutBody));
			});
	}

	/**
	 * Re-point an existing Media row at a real owner record. Used when an image
	 * was uploaded from an entity CREATE form: the bytes went up before the record
	 * had an id (IDOwner 0), and once it is saved we re-own the media to its id so
	 * it surfaces in that entity's gallery. Generic meadow update (PUT /1.0/Media);
	 * the Media tenancy hook scopes it to the customer + team media (IDUser 0), so
	 * only the pending team uploads created here are reachable.
	 */
	reassignOwner(pIDMedia, pOwnerType, pIDOwner)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Media'),
			{ IDMedia: pIDMedia, OwnerType: pOwnerType, IDOwner: pIDOwner });
	}

	/** Replace the bytes of an existing Media row (e.g. re-saving a drawing). */
	updateBlob(pIDMedia, pFile, pMimeType)
	{
		let tmpMime = pMimeType || pFile.type || 'application/octet-stream';
		return this._putBlob(pIDMedia, pFile, tmpMime).then((pPutBody) => Object.assign({ IDMedia: pIDMedia }, pPutBody));
	}

	_putBlob(pIDMedia, pFile, pMimeType)
	{
		let tmpBlob = (pFile instanceof ArrayBuffer) ? new Blob([pFile], { type: pMimeType }) : pFile;
		// Through the shared RestClient's binary path, so a 401 on the blob PUT
		// drives session recovery + replays the upload (the request body Buffer is
		// re-sent on the replay).
		return libFrameworkClient.uploadBinary(this.fable, this._url('Media/' + pIDMedia + '/Blob'), tmpBlob, pMimeType, 'PUT');
	}

	/**
	 * Save an external URL reference without uploading binary bytes. The URL is stored in
	 * OriginalFileName; MediaType is forced to 'Link' and MimeType to 'text/x-uri' so the
	 * gallery can distinguish it from a real file and render an open-in-new-tab card.
	 */
	uploadURL(pOwnerType, pIDOwner, pURL, pTitle, pOverrides)
	{
		let tmpOverrides = pOverrides || {};
		let tmpMeta =
		{
			OwnerType: pOwnerType,
			IDOwner: pIDOwner,
			Title: String(pTitle || pURL || 'Link').slice(0, 200),
			MediaType: 'Link',
			MimeType: 'text/x-uri',
			OriginalFileName: String(pURL || '').slice(0, 256),
			FileSizeBytes: 0,
			Private: !!tmpOverrides.Private
		};
		return libFrameworkClient.postJSON(this.fable, this._url('Media/New'), tmpMeta)
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success || !pBody.Media)
				{
					throw new Error((pBody && pBody.Error) || 'Could not register URL.');
				}
				return Object.assign({ IDMedia: pBody.Media.IDMedia }, pBody.Media);
			});
	}

	remove(pIDMedia)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Media/' + pIDMedia)).then(() => true);
	}

	/**
	 * The caller's PRIVATE media -- their personal gallery (Media.IDUser = them). Optionally narrow
	 * to one OwnerType (e.g. 'Note' for just note images). Team/entity media never comes back here.
	 */
	listMine(pOwnerType)
	{
		let tmpPath = 'Media/Mine' + (pOwnerType ? ('?OwnerType=' + encodeURIComponent(pOwnerType)) : '');
		return libFrameworkClient.getJSON(this.fable, this._url(tmpPath))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/** Delete one of the caller's own private media (server enforces IDUser ownership). */
	removeMine(pIDMedia)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Media/Mine/' + pIDMedia)).then(() => true);
	}
}

module.exports = PictProviderMediaAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],601:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-MessageAPI
 * ------------------------
 * Browser-side client for the org message templates (/1.0/Org/MessageTemplates).
 * Backs the Message Templates section of the settings hub. Gated server-side by
 * platform.manage.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'MessageAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderMessageAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Messaging) { this.fable.AppData.Messaging = { Templates: [] }; }
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	getTemplates()
	{
		this.initializeAppData();
		return libFrameworkClient.getJSON(this.fable, this._url('Org/MessageTemplates'))
			.then((pBody) =>
			{
				this.fable.AppData.Messaging.Templates = Array.isArray(pBody.Templates) ? pBody.Templates : [];
				return this.fable.AppData.Messaging.Templates;
			})
			.catch(() =>
			{
				this.fable.AppData.Messaging.Templates = [];
				return this.fable.AppData.Messaging.Templates;
			});
	}

	saveTemplate(pKey, pPatch)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/MessageTemplates/' + encodeURIComponent(pKey)), pPatch || {})
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Request failed.'); }
				return pBody;
			});
	}

	previewTemplate(pKey, pPatch)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Org/MessageTemplates/' + encodeURIComponent(pKey) + '/Preview'), pPatch || {});
	}

	testSend(pKey, pChannel, pTo)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Org/MessageTemplates/' + encodeURIComponent(pKey) + '/TestSend'), { Channel: pChannel, To: pTo })
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Request failed.'); }
				return pBody;
			});
	}
}

module.exports = PictProviderMessageAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],602:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-MoodboardAPI
 * --------------------------
 * Browser-side CRUD client for the Moodboard entity. Extends the generic EntityAPI provider with two
 * helpers for the board blob: a Moodboard row carries the whole canvas in its BoardJSON column (the
 * { Nodes, Connections, ViewState } shape from pict-section-moodboard / pict-section-flow).
 *
 * loadBoard takes a Moodboard row and returns the parsed board object (handling either a JSON string
 * or an already-parsed object, since how meadow hands back a JSON column can vary). saveBoard writes a
 * board object back to a row. Tenancy (IDCustomer) is enforced server-side, so the client never sends
 * it.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'MoodboardAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'Moodboard',
	PluralRoute: 'Moodboards',
	IDField: 'IDMoodboard'
};

const _EMPTY_BOARD = { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } };

class PictProviderMoodboardAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * Parse a Moodboard row's BoardJSON into a board object. Tolerates a string, an object, or an
	 * empty/missing value (a brand-new board).
	 * @param {object} pRecord - a Moodboard row
	 * @returns {object} the board { Nodes, Connections, ViewState }
	 */
	loadBoard(pRecord)
	{
		if (!pRecord) { return JSON.parse(JSON.stringify(_EMPTY_BOARD)); }
		let tmpRaw = pRecord.BoardJSON;
		if (!tmpRaw) { return JSON.parse(JSON.stringify(_EMPTY_BOARD)); }
		if (typeof tmpRaw === 'object') { return tmpRaw; }
		try
		{
			let tmpParsed = JSON.parse(tmpRaw);
			return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : JSON.parse(JSON.stringify(_EMPTY_BOARD));
		}
		catch (pError)
		{
			return JSON.parse(JSON.stringify(_EMPTY_BOARD));
		}
	}

	/**
	 * Read one Moodboard row fresh from the server (authoritative BoardJSON), bypassing the list cache.
	 * @param {number} pID - IDMoodboard
	 * @returns {Promise<object|null>}
	 */
	read(pID)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(this.entityName + '/' + pID))
			.then((pBody) => (pBody && pBody[this.idField]) ? pBody : ((pBody && Array.isArray(pBody.Records) && pBody.Records[0]) || (Array.isArray(pBody) ? pBody[0] : pBody) || null))
			.catch(() => null);
	}

	// ── polymorphic owner (OwnerType + IDOwner) ───────────────────────────────
	// A whiteboard attaches to any entity by OwnerType + IDOwner, or stands alone when OwnerType is
	// empty. These generalize the vision/user helpers below (which now delegate here). An owner can
	// have many boards; the detail page lists them and lets you add more.

	/**
	 * Whiteboards attached to one owner (e.g. ('WorkItem', 42)). Empty owner type lists standalone.
	 * @returns {Promise<Array<object>>}
	 */
	listForOwner(pOwnerType, pIDOwner)
	{
		let tmpFilter = 'FBV~OwnerType~EQ~' + (pOwnerType || '') + '~FBV~IDOwner~EQ~' + (pIDOwner || 0);
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/200'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/**
	 * Create a new (empty) whiteboard for an owner. Dual-writes the legacy IDVision/IDUser column so
	 * transitional reads still resolve. Pass an empty OwnerType for a standalone board.
	 * @returns {Promise<object>} the created Moodboard row
	 */
	createForOwner(pOwnerType, pIDOwner, pName)
	{
		let tmpEmpty = { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } };
		let tmpRecord = { Name: pName || 'Whiteboard', OwnerType: pOwnerType || '', IDOwner: pIDOwner || 0, BoardJSON: JSON.stringify(tmpEmpty) };
		if (pOwnerType === 'Vision') { tmpRecord.IDVision = pIDOwner; }
		else if (pOwnerType === 'User') { tmpRecord.IDUser = pIDOwner; }
		return this.create(tmpRecord).then((pCreated) => (pCreated && pCreated[this.idField]) ? pCreated : ((pCreated && pCreated.Record) || pCreated));
	}

	/**
	 * Attach an existing whiteboard to an owner (re-pointing it from standalone or from another owner).
	 * The inverse of _disconnectBoard: it writes OwnerType/IDOwner and keeps the legacy IDVision column in
	 * step (set for a Vision target, cleared otherwise) so listForVision stays authoritative. The board's
	 * content is untouched -- only where it lives changes. Pass an empty OwnerType to make it standalone.
	 * @returns {Promise<object>} the updated Moodboard row
	 */
	attachToOwner(pID, pOwnerType, pIDOwner)
	{
		let tmpRecord = { OwnerType: pOwnerType || '', IDOwner: pIDOwner || 0, IDVision: (pOwnerType === 'Vision') ? (pIDOwner || 0) : 0 };
		return this.update(pID, tmpRecord);
	}

	/**
	 * The standalone Whiteboards library for the tenant. Excludes personal PROFILE boards (the IDUser
	 * column is stamped on those): a profile board belongs to a user's profile page, and listing every
	 * tenant board here put one user's profile board -- and its BoardJSON -- in front of the whole tenant.
	 * Vision / WorkItem boards stay (team content). Tenancy + this filter are enforced server-side.
	 * @returns {Promise<Array<object>>}
	 */
	listAllForCustomer()
	{
		let tmpFilter = 'FBV~IDUser~EQ~0';
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/500'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/**
	 * The whiteboards attached to an entity, for the detail-page board section. Visions read by their
	 * legacy IDVision column (catches boards made before OwnerType existed, with no prod backfill
	 * needed); every other entity type reads by OwnerType/IDOwner.
	 * @returns {Promise<Array<object>>}
	 */
	listForEntity(pEntityType, pID)
	{
		if (pEntityType === 'Vision') { return this.listForVision(pID); }
		return this.listForOwner(pEntityType, pID);
	}

	/**
	 * The Moodboard rows owned by a user (their personal profile board). A user has at most one.
	 * Reads by the legacy IDUser column so existing profile boards resolve without a backfill.
	 * @param {number} pIDUser
	 * @returns {Promise<Array<object>>}
	 */
	listForUser(pIDUser)
	{
		let tmpFilter = 'FBV~IDUser~EQ~' + pIDUser;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/100'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/**
	 * The user's personal profile board, creating an empty one the first time. Call this only for the
	 * signed-in user (creating a board stamps it to them); for a teammate, use listForUser and show
	 * read-only (do not create on their behalf).
	 * @param {number} pIDUser
	 * @returns {Promise<object>} the Moodboard row
	 */
	getOrCreatePersonal(pIDUser)
	{
		return this.listForUser(pIDUser).then((pRows) =>
		{
			if (pRows && pRows.length) { return pRows[0]; }
			let tmpEmpty = { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } };
			return this.create({ Name: 'Profile board', IDUser: pIDUser, BoardJSON: JSON.stringify(tmpEmpty) })
				.then((pCreated) => (pCreated && pCreated[this.idField]) ? pCreated : ((pCreated && pCreated.Record) || pCreated));
		});
	}

	/**
	 * The Moodboard rows tied to a Vision (its inspiration board). A Vision has at most one.
	 * @param {number} pIDVision
	 * @returns {Promise<Array<object>>}
	 */
	listForVision(pIDVision)
	{
		let tmpFilter = 'FBV~IDVision~EQ~' + pIDVision;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/100'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/**
	 * A Vision's inspiration board, creating an empty one the first time. Unlike the personal board this
	 * one is shared (whoever can edit the Vision's content edits it), so create it whenever missing. The
	 * server stamps IDCustomer; the client supplies IDVision the same way the personal board supplies
	 * IDUser.
	 * @param {number} pIDVision
	 * @param {string} pName - a label for a freshly created board (e.g. the Vision's name)
	 * @returns {Promise<object>} the Moodboard row
	 */
	getOrCreateForVision(pIDVision, pName)
	{
		return this.listForVision(pIDVision).then((pRows) =>
		{
			if (pRows && pRows.length) { return pRows[0]; }
			let tmpEmpty = { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } };
			return this.create({ Name: pName || 'Inspiration board', IDVision: pIDVision, BoardJSON: JSON.stringify(tmpEmpty) })
				.then((pCreated) => (pCreated && pCreated[this.idField]) ? pCreated : ((pCreated && pCreated.Record) || pCreated));
		});
	}

	/**
	 * Persist a board object onto a Moodboard row. Sends BoardJSON as a string so it round-trips the
	 * same regardless of whether meadow treats the column as text or JSON.
	 * @param {number} pID - IDMoodboard
	 * @param {object} pBoard - the board { Nodes, Connections, ViewState }
	 * @param {object} pExtra - optional extra fields to update alongside (e.g. { Name })
	 */
	saveBoard(pID, pBoard, pExtra)
	{
		let tmpRecord = Object.assign({}, pExtra || {});
		tmpRecord.BoardJSON = JSON.stringify(pBoard || _EMPTY_BOARD);
		return this.update(pID, tmpRecord);
	}
}

module.exports = PictProviderMoodboardAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],603:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-NotebookAPI
 * -------------------------
 * Browser-side client for the per-user notebook: markdown notes, bookmarks
 * (with favorites + history), and the caller's personal checklists. Everything
 * is private to the signed-in user (the server scopes Note/Bookmark/ViewEvent by
 * IDUser). The side panel loads the whole thing in one shot via GET /1.0/Notebook;
 * notes and bookmarks are plain auto-CRUD (private via the personal-scope hook).
 *
 * AppData shape this provider owns:
 *   AppData.Notebook = {
 *       Open: false,            // panel visibility
 *       ActiveTab: 'notes',     // 'notes' | 'bookmarks' | 'checklists'
 *       Loaded: false,
 *       LoadError: null,
 *       Notes: [], Bookmarks: [], Favorites: [], Recent: [], Trending: [], Checklists: []
 *   }
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'NotebookAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderNotebookAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Notebook)
		{
			this.fable.AppData.Notebook =
			{
				Open: false,
				ActiveTab: 'notes',
				Loaded: false,
				LoadError: null,
				Notes: [],
				Bookmarks: [],
				Favorites: [],
				Recent: [],
				Trending: [],
				Checklists: [],
				Gallery: []
			};
		}
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_json(pMethod, pPath, pBody)
	{
		let tmpURL = this._url(pPath);
		switch (pMethod)
		{
			case 'POST':
				return libFrameworkClient.postJSON(this.fable, tmpURL, pBody !== undefined ? pBody : {});
			case 'PUT':
				return libFrameworkClient.putJSON(this.fable, tmpURL, pBody !== undefined ? pBody : {});
			case 'DELETE':
				return libFrameworkClient.delJSON(this.fable, tmpURL);
			default:
				return libFrameworkClient.getJSON(this.fable, tmpURL);
		}
	}

	// One read backs the panel.
	loadNotebook()
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Notebook;
		return this._json('GET', 'Notebook')
			.then((pBody) =>
			{
				tmpStore.Notes = pBody.Notes || [];
				tmpStore.Bookmarks = pBody.Bookmarks || [];
				tmpStore.Favorites = pBody.Favorites || [];
				tmpStore.Recent = pBody.Recent || [];
				tmpStore.Trending = pBody.Trending || [];
				tmpStore.Checklists = pBody.Checklists || [];
				tmpStore.Loaded = true;
				tmpStore.LoadError = null;
				return pBody;
			})
			.catch((pErr) => { tmpStore.LoadError = pErr.message; return null; });
	}

	// Notes -- private auto-CRUD.
	createNote(pNote) { return this._json('POST', 'Note', pNote || { Title: 'Untitled note', Content: '' }); }
	updateNote(pIDNote, pPatch) { return this._json('PUT', 'Note', Object.assign({ IDNote: pIDNote }, pPatch || {})); }
	deleteNote(pIDNote) { return this._json('DELETE', 'Note/' + pIDNote); }

	// Bookmarks -- private auto-CRUD, plus the favorites reorder convenience route.
	createBookmark(pBookmark) { return this._json('POST', 'Bookmark', pBookmark || {}); }
	updateBookmark(pIDBookmark, pPatch) { return this._json('PUT', 'Bookmark', Object.assign({ IDBookmark: pIDBookmark }, pPatch || {})); }
	deleteBookmark(pIDBookmark) { return this._json('DELETE', 'Bookmark/' + pIDBookmark); }
	setFavorite(pIDBookmark, pFavorite) { return this.updateBookmark(pIDBookmark, { Favorite: pFavorite ? 1 : 0 }); }
	reorderFavorites(pOrder) { return this._json('POST', 'Notebook/Favorites/Reorder', { Order: pOrder || [] }); }

	// History -- one row per navigation. A page's specific title is often not known at
	// navigation time: detail pages refine document.title only after their record loads
	// (see PictView-EntityDetail), so the same route is recorded twice for one visit --
	// first with a generic title ("Plansheet"), then with the record's own name. Collapse
	// that into a single row: the first record for a route CREATEs the ViewEvent and
	// remembers its id; a later record for the SAME route UPDATEs that row's label instead
	// of appending a duplicate. Fire-and-forget: a failed record must never disrupt
	// navigation, so every path swallows its errors.
	recordView(pView)
	{
		try
		{
			let tmpView = pView || {};
			let tmpRoute = tmpView.Route || '';
			let tmpLabel = tmpView.Label || '';
			if (this._lastView && this._lastView.Route === tmpRoute)
			{
				// Same visit -- relabel the in-flight / created row rather than adding another.
				if (!tmpLabel || tmpLabel === this._lastView.Label) { return; }
				this._lastView.Label = tmpLabel;
				let tmpTracker = this._lastView;
				tmpTracker.Ready = tmpTracker.Ready.then((pID) =>
					((pID && tmpTracker === this._lastView)
						? this._json('PUT', 'ViewEvent', { IDViewEvent: pID, Label: tmpLabel }).then(() => pID, () => pID)
						: pID));
				return;
			}
			let tmpTracker = { Route: tmpRoute, Label: tmpLabel };
			tmpTracker.Ready = this._json('POST', 'ViewEvent', tmpView)
				.then((pResult) => { let tmpRow = Array.isArray(pResult) ? pResult[0] : pResult; return (tmpRow && tmpRow.IDViewEvent) || 0; }, () => 0);
			this._lastView = tmpTracker;
		}
		catch (pError) { /* never throw from a navigation side effect */ }
	}
}

module.exports = PictProviderNotebookAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],604:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-OpsAPI
 * --------------------
 * Browser client for the platform ops console (GET /1.0/Admin/Ops). One read backs the
 * whole screen: grouped errors, the activity feed, who is active now, and recent deploys.
 * Platform-admin only (the server gates it). See design/Observability-Plan.md.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'OpsAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderOpsAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Ops)
		{
			this.fable.AppData.Ops =
			{
				Loaded: false, LoadError: null,
				Summary: {}, Errors: [], ActiveUsers: [], Activity: [], Deploys: []
			};
		}
	}

	loadOps()
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Ops;
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Admin/Ops')
			.then((pBody) =>
			{
				tmpStore.Summary = pBody.Summary || {};
				tmpStore.Errors = pBody.Errors || [];
				tmpStore.ActiveUsers = pBody.ActiveUsers || [];
				tmpStore.Activity = pBody.Activity || [];
				tmpStore.Deploys = pBody.Deploys || [];
				tmpStore.Loaded = true;
				tmpStore.LoadError = null;
				return pBody;
			})
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}

	// The caller's own org activity (tenant-scoped, server-gated to org admins).
	loadOrgActivity(pFilters)
	{
		if (!this.fable.AppData.OrgActivity)
		{
			this.fable.AppData.OrgActivity = { Loaded: false, LoadError: null, Rows: [], Filters: {} };
		}
		let tmpStore = this.fable.AppData.OrgActivity;
		let tmpFilters = pFilters || {};
		tmpStore.Filters = tmpFilters;
		let tmpParams = [];
		if (tmpFilters.user) { tmpParams.push('user=' + encodeURIComponent(tmpFilters.user)); }
		if (tmpFilters.action) { tmpParams.push('action=' + encodeURIComponent(tmpFilters.action)); }
		tmpParams.push('count=' + (tmpFilters.count || 150));
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Org/Activity?' + tmpParams.join('&'))
			.then((pBody) => { tmpStore.Rows = (pBody && pBody.Activity) || []; tmpStore.Loaded = true; tmpStore.LoadError = null; return pBody; })
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}

	// The caller's pre-aggregated System Activity buckets for one granularity (tenant-scoped by session,
	// served from the pre-computed ActivityAggregate table). Powers the System Activity chart.
	loadActivityAggregate(pFilters)
	{
		if (!this.fable.AppData.SystemActivity)
		{
			this.fable.AppData.SystemActivity = { Loaded: false, LoadError: null, Period: 'Week', Rows: [] };
		}
		let tmpStore = this.fable.AppData.SystemActivity;
		let tmpFilters = pFilters || {};
		let tmpPeriod = tmpFilters.period || tmpStore.Period || 'Week';
		let tmpParams = ['period=' + encodeURIComponent(tmpPeriod)];
		if (tmpFilters.from) { tmpParams.push('from=' + encodeURIComponent(tmpFilters.from)); }
		if (tmpFilters.to) { tmpParams.push('to=' + encodeURIComponent(tmpFilters.to)); }
		if (tmpFilters.domain) { tmpParams.push('domain=' + encodeURIComponent(tmpFilters.domain)); }
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Activity/Aggregate?' + tmpParams.join('&'))
			.then((pBody) => { tmpStore.Period = (pBody && pBody.Period) || tmpPeriod; tmpStore.Rows = (pBody && pBody.Rows) || []; tmpStore.Loaded = true; tmpStore.LoadError = null; return pBody; })
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}
}

module.exports = PictProviderOpsAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],605:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-OrgAPI
 * --------------------
 * Browser-side client for organization settings (/1.0/Org/Settings). Backs the
 * Org Settings section of the settings hub. Gated server-side by platform.manage.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'OrgAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderOrgAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Org) { this.fable.AppData.Org = { Settings: null }; }
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	getSettings()
	{
		this.initializeAppData();
		return libFrameworkClient.getJSON(this.fable, this._url('Org/Settings'))
			.then((pBody) =>
			{
				this.fable.AppData.Org.Settings = (pBody && pBody.Org) ? pBody.Org : null;
				return this.fable.AppData.Org.Settings;
			})
			.catch(() =>
			{
				this.fable.AppData.Org.Settings = null;
				return this.fable.AppData.Org.Settings;
			});
	}

	updateSettings(pPatch)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/Settings'), pPatch || {})
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				this.fable.AppData.Org.Settings = pBody.Org || this.fable.AppData.Org.Settings;
				return pBody.Org;
			});
	}

	// Live availability check for a plan sheet Code, backing the Org Settings field. Returns
	// { Code, Available, Reason }. Excludes this plan sheet's own code, so keeping it reads free.
	checkCode(pCode)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Org/CodeAvailable/' + encodeURIComponent(String(pCode || '').trim())));
	}

	getDraftingKit()
	{
		this.initializeAppData();
		return libFrameworkClient.getJSON(this.fable, this._url('Org/DraftingKit'))
			.then((pBody) =>
			{
				let tmpKit = pBody ? pBody : null;
				this.fable.AppData.Org.DraftingKit = tmpKit;
				return tmpKit;
			})
			.catch(() =>
			{
				this.fable.AppData.Org.DraftingKit = null;
				return null;
			});
	}

	setDraftingKit(pIDDefaultVisionType)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/DraftingKit'), { IDDefaultVisionType: pIDDefaultVisionType || 0 })
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				if (pBody.Lexicon && this.fable.AppData.Auth && this.fable.AppData.Auth.User) { this.fable.AppData.Auth.User.Lexicon = pBody.Lexicon; }
				return pBody;
			});
	}

	saveDraftingKitTerms(pTerms)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/DraftingKit/Terms'), { Terms: pTerms || {} })
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				if (pBody.Resolved && this.fable.AppData.Auth && this.fable.AppData.Auth.User) { this.fable.AppData.Auth.User.Lexicon = pBody.Resolved; }
				return pBody;
			});
	}

	// Save the default kit's default connection (link) style; returns { Success, ConnectionStyle (sanitized) }.
	saveDraftingKitConnectionStyle(pStyle)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/DraftingKit/ConnectionStyle'), { ConnectionStyle: pStyle || {} })
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				return pBody;
			});
	}

	// Save the default kit's chosen sticker set (a known set key, or '' to clear). Returns
	// { Success, DefaultStickerSet, StickerSet }; updates the live session's house StickerSet so a
	// whiteboard opened after this reflects it without a reload.
	saveDraftingKitDefaultStickerSet(pKey)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/DraftingKit/DefaultStickerSet'), { DefaultStickerSet: pKey || '' })
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				if (this.fable.AppData.Auth && this.fable.AppData.Auth.User) { this.fable.AppData.Auth.User.StickerSet = pBody.StickerSet || ''; }
				return pBody;
			});
	}

	// The org brand set profile moodboards open on. Stored on the house-kit manifest (BrandStickerSet); the
	// server refreshes the session's ProfileStickerSet so a profile board opened later this session picks it up.
	saveDraftingKitBrandStickerSet(pKey)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/DraftingKit/BrandStickerSet'), { BrandStickerSet: pKey || '' })
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				if (this.fable.AppData.Auth && this.fable.AppData.Auth.User) { this.fable.AppData.Auth.User.ProfileStickerSet = pBody.ProfileStickerSet || ''; }
				return pBody;
			});
	}

	// The plan sheet's top-bar backdrop (WI #360): the baked moodboard crop the shell paints behind the
	// brand / nav / account chrome, so each plan sheet's bar reads as distinct. getTopBar() fetches just
	// the SVG, which is all the load path needs; pass true to also get TopBarBoardJSON, the re-editable
	// source board the composer reopens. A failed fetch resolves to no backdrop rather than rejecting --
	// a missing decoration must never keep the app from painting.
	getTopBar(pIncludeBoard)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Plansheet/TopBar' + (pIncludeBoard ? '?IncludeBoard=1' : '')))
			.then((pBody) => pBody || { TopBarBackdropSVG: '' })
			.catch(() => ({ TopBarBackdropSVG: '' }));
	}

	// Store a baked crop and the board it came from. An empty pSVG clears the backdrop (and the server
	// drops the stored board with it, so the two never drift apart).
	saveTopBar(pSVG, pBoard)
	{
		let tmpPayload = { TopBarBackdropSVG: String(pSVG || '') };
		if (pBoard) { tmpPayload.TopBarBoardJSON = pBoard; }
		return libFrameworkClient.putJSON(this.fable, this._url('Plansheet/TopBar'), tmpPayload)
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				return pBody;
			});
	}

	// The plan sheet's hidden sidebar entries. getNav returns { HiddenNavItems, Catalog } for the owner
	// picker; saveNav writes the list and updates the live session so the sidebar re-renders without a reload.
	getNav()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Org/Nav'));
	}

	saveNav(pHiddenNavItems)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/Nav'), { HiddenNavItems: Array.isArray(pHiddenNavItems) ? pHiddenNavItems : [] })
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success) { throw new Error((pBody && pBody.Error) || 'HTTP 200'); }
				if (this.fable.AppData.Auth && this.fable.AppData.Auth.User) { this.fable.AppData.Auth.User.HiddenNavItems = pBody.HiddenNavItems || []; }
				return pBody;
			});
	}
}

module.exports = PictProviderOrgAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],606:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-PhotoAPI
 * ----------------------
 * Browser-side client for profile photos. The server re-encodes whatever is
 * uploaded into a display JPEG plus a 128px avatar thumb (see
 * ProfilePhoto-Endpoint.js), so the client just PUTs the raw File and reads the
 * blob back through an <img> (same-origin cookie auth). photoURL() carries the
 * PhotoHash as a cache-buster so a freshly changed avatar shows immediately.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'PhotoAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderPhotoAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	/**
	 * URL for a user's photo. pThumb requests the 128px avatar; pVersion (the
	 * PhotoHash) busts the browser cache when the photo changes.
	 */
	photoURL(pIDUser, pThumb, pVersion)
	{
		let tmpQuery = [];
		if (pThumb) { tmpQuery.push('thumb=1'); }
		if (pVersion) { tmpQuery.push('v=' + encodeURIComponent(pVersion)); }
		return this._url('Profile/Photo/' + pIDUser) + (tmpQuery.length ? ('?' + tmpQuery.join('&')) : '');
	}

	/** PUT the raw image File. Resolves with { PhotoHash }. */
	uploadPhoto(pFile)
	{
		let tmpMime = (pFile && pFile.type) || 'application/octet-stream';
		return libFrameworkClient.uploadBinary(this.fable, this._url('Profile/Photo'), pFile, tmpMime, 'PUT')
			.then((pBody) =>
			{
				let tmpBody = pBody || {};
				if (!tmpBody.Success) { throw new Error(tmpBody.Error || 'Photo upload failed.'); }
				return tmpBody;
			});
	}

	deletePhoto()
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Profile/Photo'))
			.then((pBody) => pBody || { Success: true });
	}
}

module.exports = PictProviderPhotoAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],607:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-ProfileBlockAPI
 * -----------------------------
 * Browser-side client for ProfileBlock -- the stackable content blocks down a user's profile page,
 * below their personal moodboard. Each block has a BlockType (text | image | embed) and a Content
 * JSON payload shaped for that type, and an integer SortOrder that orders the page.
 *
 * Extends the generic EntityAPI (list/create/update/remove) with: listForUser (the owner's blocks,
 * ordered), parseContent (Content is stored as a JSON string and parsed on read), and reorder (write
 * each block's new position). Tenancy (IDCustomer) is enforced server-side; IDUser scopes a profile.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'ProfileBlockAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'ProfileBlock',
	PluralRoute: 'ProfileBlocks',
	IDField: 'IDProfileBlock'
};

class PictProviderProfileBlockAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * A user's blocks, ordered down the page by SortOrder.
	 * @param {number} pIDUser
	 * @returns {Promise<Array<object>>}
	 */
	listForUser(pIDUser)
	{
		let tmpFilter = 'FBV~IDUser~EQ~' + pIDUser;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) =>
			{
				let tmpRows = Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [];
				tmpRows.sort((pA, pB) => (pA.SortOrder || 0) - (pB.SortOrder || 0));
				return tmpRows;
			})
			.catch(() => []);
	}

	/**
	 * Parse a block row's Content JSON (stored as a string; tolerant of an object or empty value).
	 * @param {object} pRow
	 * @returns {object}
	 */
	parseContent(pRow)
	{
		if (!pRow || pRow.Content == null) { return {}; }
		if (typeof pRow.Content === 'object') { return pRow.Content; }
		try
		{
			let tmpParsed = JSON.parse(pRow.Content);
			return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : {};
		}
		catch (pError)
		{
			return {};
		}
	}

	/**
	 * Create a block for a user. Content is stringified so it round-trips regardless of how meadow
	 * treats the JSON column.
	 * @param {number} pIDUser
	 * @param {string} pBlockType - 'text' | 'image' | 'embed'
	 * @param {object} pContent
	 * @param {object} pExtra - optional extra fields (Title, SortOrder)
	 */
	createBlock(pIDUser, pBlockType, pContent, pExtra)
	{
		let tmpRecord = Object.assign({ IDUser: pIDUser, BlockType: pBlockType, SortOrder: 0 }, pExtra || {});
		tmpRecord.Content = JSON.stringify(pContent || {});
		return this.create(tmpRecord);
	}

	/**
	 * Update a block's Content (and optional Title), stringifying Content.
	 * @param {number} pID
	 * @param {object} pContent
	 * @param {object} pExtra
	 */
	updateBlock(pID, pContent, pExtra)
	{
		let tmpRecord = Object.assign({}, pExtra || {});
		tmpRecord.Content = JSON.stringify(pContent || {});
		return this.update(pID, tmpRecord);
	}

	/**
	 * Persist the order of a block list: write each block whose position changed to its new index.
	 * @param {Array<object>} pOrderedBlocks - blocks in their new top-to-bottom order
	 * @returns {Promise}
	 */
	reorder(pOrderedBlocks)
	{
		let tmpWrites = [];
		for (let i = 0; i < pOrderedBlocks.length; i++)
		{
			let tmpBlock = pOrderedBlocks[i];
			if ((tmpBlock.SortOrder || 0) !== i)
			{
				tmpBlock.SortOrder = i;
				tmpWrites.push(this.update(tmpBlock[this.idField], { SortOrder: i }));
			}
		}
		return Promise.all(tmpWrites);
	}
}

module.exports = PictProviderProfileBlockAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],608:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-PromptAPI
 * -----------------------
 * Browser-side client for the prompt library: generic Prompt CRUD (the
 * caller's own library, owner-scoped server-side) plus the custom routes that
 * cross users or carry provenance - the shared library, freeform paste-ins,
 * runs, posting, forking, version history, and attachments.
 *
 * PromptShapeAPI (below, same file) covers the shape cascade: the platform
 * catalog, the merged Available list the editor consumes, adoption and forks.
 */

const libProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _PromptAPIConfiguration =
{
	ProviderIdentifier: 'PromptAPI',
	EntityName: 'Prompt',
	PluralRoute: 'Prompts',
	IDField: 'IDPrompt'
};

class PictProviderPromptAPI extends libProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _PromptAPIConfiguration, pOptions || {}), pServiceHash);
	}

	_json(pMethod, pPath, pBody)
	{
		let tmpURL = this._url(pPath);
		if (pMethod === 'GET') { return libFrameworkClient.getJSON(this.fable, tmpURL); }
		if (pMethod === 'PUT') { return libFrameworkClient.putJSON(this.fable, tmpURL, pBody || {}); }
		if (pMethod === 'DELETE') { return libFrameworkClient.delJSON(this.fable, tmpURL); }
		return libFrameworkClient.postJSON(this.fable, tmpURL, pBody || {});
	}

	// ---- libraries ----------------------------------------------------------
	mine() { return this._json('GET', 'Prompts/Mine').then((pBody) => pBody.Prompts || []); }
	shared() { return this._json('GET', 'Prompts/Shared').then((pBody) => pBody.Prompts || []); }
	sharedOne(pIDPrompt) { return this._json('GET', 'Prompt/Shared/' + pIDPrompt).then((pBody) => pBody.Prompt || null); }
	sharedWordLists() { return this._json('GET', 'WordLists/Shared').then((pBody) => pBody.WordLists || []); }

	// ---- the refinement cycle ------------------------------------------------
	paste(pDraft) { return this._json('POST', 'Prompt/Paste', pDraft); }
	recordRun(pIDPrompt, pRun) { return this._json('POST', 'Prompt/' + pIDPrompt + '/Run', pRun || {}); }
	post(pIDPrompt) { return this._json('POST', 'Prompt/' + pIDPrompt + '/Post', {}); }
	fork(pIDPrompt, pOverrides) { return this._json('POST', 'Prompt/' + pIDPrompt + '/Fork', pOverrides || {}); }

	// ---- history ---------------------------------------------------------------
	versions(pIDPrompt) { return this._json('GET', 'Prompt/' + pIDPrompt + '/Versions'); }
	runs(pIDPrompt) { return this._json('GET', 'Prompt/' + pIDPrompt + '/Runs'); }

	// ---- generate for a work item -------------------------------------------
	// Craft a Prompt from a shape, pre-filled from the work item, versioned, and attached
	// (server-side). Returns { Prompt, Version, Link, PromptNumber, IDWorkItem }.
	generateForWorkItem(pIDWorkItem, pTypeKey)
	{
		return this._json('POST', 'WorkItem/' + pIDWorkItem + '/GeneratePrompt', { TypeKey: pTypeKey || 'software-development' });
	}

	// Craft ONE combined Prompt covering several work items (an ordered breakdown in the Task
	// segment), attached to every one. Returns { Prompt, Version, Links, PromptNumber, IDWorkItems }.
	generateForWorkItems(pIDWorkItems, pTypeKey)
	{
		return this._json('POST', 'Prompt/GenerateForWorkItems', { IDWorkItems: pIDWorkItems || [], TypeKey: pTypeKey || 'software-development' });
	}

	// ---- attachments ----------------------------------------------------------
	attach(pIDPrompt, pOwnerType, pIDOwner, pNote)
	{
		return this._json('POST', 'Prompt/' + pIDPrompt + '/Attach',
			{ OwnerType: pOwnerType, IDOwner: pIDOwner, Note: pNote || '' });
	}
	linksFor(pOwnerType, pIDOwner)
	{
		return this._json('GET', 'PromptLinks/For/' + pOwnerType + '/' + pIDOwner)
			.then((pBody) => pBody.Links || []);
	}
	detach(pIDPromptLink)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('PromptLink/' + pIDPromptLink))
			.then(() => true);
	}
	// Revise an attachment's prompt text in place: captures a new pinned version from the given Source
	// and re-points the attachment at it, so the MCP run uses the revised text. Owner-only, content.edit.
	revise(pIDPromptLink, pSource)
	{
		return this._json('POST', 'PromptLink/' + pIDPromptLink + '/Revise', { Source: pSource || '' });
	}
}

const _PromptShapeAPIConfiguration =
{
	ProviderIdentifier: 'PromptShapeAPI',
	EntityName: 'PromptShape',
	PluralRoute: 'PromptShapes',
	IDField: 'IDPromptShape'
};

class PictProviderPromptShapeAPI extends libProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _PromptShapeAPIConfiguration, pOptions || {}), pServiceHash);
	}

	_json(pMethod, pPath, pBody)
	{
		return PictProviderPromptAPI.prototype._json.call(this, pMethod, pPath, pBody);
	}

	platform() { return this._json('GET', 'PromptShapes/Platform').then((pBody) => pBody.Shapes || []); }
	available() { return this._json('GET', 'PromptShapes/Available').then((pBody) => pBody.Shapes || []); }
	adoptPlatform(pSelector) { return this._json('POST', 'PromptShape/AdoptPlatform', pSelector).then((pBody) => pBody.Shape || null); }
	fork(pIDPromptShape, pOverrides) { return this._json('POST', 'PromptShape/' + pIDPromptShape + '/Fork', pOverrides || {}).then((pBody) => pBody.Shape || null); }
	versions(pIDPromptShape) { return this._json('GET', 'PromptShape/' + pIDPromptShape + '/Versions'); }
}

module.exports = PictProviderPromptAPI;
module.exports.default_configuration = _PromptAPIConfiguration;
module.exports.PromptShapeAPI = PictProviderPromptShapeAPI;
module.exports.PromptShapeAPI.default_configuration = _PromptShapeAPIConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],609:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-RoutineStepAPI
 * ----------------------------
 * Browser-side CRUD client for RoutineStep, extending the generic EntityAPI
 * provider. Steps belong to a Routine (FK IDRoutine) and only ever render
 * inside the routine's step editor, so the one extra helper is listForRoutine:
 * the steps of one routine, sorted by SortOrder. Tenancy (IDCustomer) is
 * enforced server-side, so the client never sends it.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'RoutineStepAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'RoutineStep',
	PluralRoute: 'RoutineSteps',
	IDField: 'IDRoutineStep'
};

class PictProviderRoutineStepAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The steps of one routine, sorted by SortOrder ascending.
	 * @param {number|string} pIDRoutine - the routine id
	 * @returns {Promise<Array<object>>}
	 */
	listForRoutine(pIDRoutine)
	{
		let tmpFilter = 'FBV~IDRoutine~EQ~' + pIDRoutine;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.then((pRows) => pRows.sort((pA, pB) => (Number(pA.SortOrder) || 0) - (Number(pB.SortOrder) || 0)))
			.catch(() => []);
	}
}

module.exports = PictProviderRoutineStepAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],610:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-RunAPI
 * --------------------
 * Browser client for the toolchain run surface (Vision 43). One read (GET /1.0/RunQueue) backs the
 * Runs page: the runs in flight, their snapshotted steps, and the evidence a node attached to each
 * step. startRun() queues a Run (POST /1.0/Run/Start) that a node claims and executes; consent()
 * answers a gated step (POST /1.0/RunStep/:id/Consent).
 *
 * The page never executes anything and holds no credentials, exactly like the Releases page: it
 * writes rows a node picks up. The one thing it does that no node can is answer a gate.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'RunAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderRunAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Runs)
		{
			this.fable.AppData.Runs = { Loaded: false, LoadError: null, Runs: [], CanApprove: false, Toolchains: [] };
		}
	}

	loadRuns()
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Runs;
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'RunQueue')
			.then((pBody) =>
			{
				tmpStore.Runs = (pBody && pBody.Runs) || [];
				tmpStore.CanApprove = !!(pBody && pBody.CanApprove);
				tmpStore.Loaded = true;
				tmpStore.LoadError = null;
				return pBody;
			})
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}

	// The toolchains this tenant can run: platform built-ins, shadowed by any the tenant has adopted
	// or authored. A catalog read failing must not blank the runs the page already has, so it parks
	// its own error and resolves.
	loadToolchains()
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Runs;
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Toolchains/Available')
			.then((pBody) =>
			{
				tmpStore.Toolchains = (pBody && pBody.Toolchains) || [];
				tmpStore.CatalogError = null;
				return pBody;
			})
			.catch((pError) => { tmpStore.CatalogError = pError.message; tmpStore.Toolchains = []; return null; });
	}

	// Queue a run of a toolchain for a node to claim. pToolchainKey names a tenant toolchain or a
	// platform built-in (adopted into the tenant on first use).
	//
	// The server refuses with a 409 while a run of the same toolchain is still in flight, and a run
	// parked at AwaitingConsent counts as in flight. Force plus Reason is the operator override; it
	// needs content.approve and lands a run.forced beat on the new run's timeline.
	startRun(pToolchainKey, pOptions)
	{
		let tmpOptions = pOptions || {};
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'Run/Start',
		{
			ToolchainKey: pToolchainKey,
			IDWorkItem: Number(tmpOptions.IDWorkItem) || 0,
			Name: tmpOptions.Name || '',
			Environment: tmpOptions.Environment || '',
			Force: !!tmpOptions.Force,
			Reason: tmpOptions.Reason || ''
		});
	}

	// Answer a gated step. pDecision is 'Approve' or 'Reject'; the server gates this on content.approve.
	consent(pIDRunStep, pDecision, pNote)
	{
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'RunStep/' + pIDRunStep + '/Consent',
			{ Decision: pDecision, Note: pNote || '' });
	}

	// Stop a run going wrong without SSH-ing into the node (Work Item #451). This only marks the run
	// CancelRequested; the node notices on its own next heartbeat and stops itself. The server gates
	// this on content.approve and answers a no-op (not an error) when nothing is actually running.
	cancel(pIDRun, pReason)
	{
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'Run/' + pIDRun + '/Cancel', { Reason: pReason || '' });
	}
}

module.exports = PictProviderRunAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],611:[function(require,module,exports){
/**
 * Pict-Provider-SessionAPI
 * ------------------------
 * Browser-side client for the server's session storage. Backs the
 * calendar/timeline browse, the upload flow from the dropzone, and the
 * "click into a session" download path.
 *
 * AppData shape this provider owns:
 *   AppData.Sessions = {
 *       List:       [],            // server rows (sorted newest first)
 *       Index:      {},            // IDSessionFile → row
 *       ByDate:     {},            // 'YYYY-MM-DD' → [row, row, …]
 *       SelectedID: 0,             // currently-open session
 *       LastLoadedAt: 0,
 *       LoadError:  null,
 *       Uploading:  false,
 *       UploadProgress: 0          // 0..1
 *   }
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'SessionAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderSessionAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Sessions)
		{
			this.fable.AppData.Sessions =
			{
				List: [],
				Index: {},
				ByDate: {},
				SelectedID: 0,
				LastLoadedAt: 0,
				LoadError: null,
				Uploading: false,
				UploadProgress: 0
			};
		}
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_indexList(pList)
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Sessions;
		tmpStore.List = pList.slice().sort((pA, pB) =>
		{
			let tmpA = pA.SessionStartedAt || pA.CreateDate || '';
			let tmpB = pB.SessionStartedAt || pB.CreateDate || '';
			return tmpB.localeCompare(tmpA);
		});
		tmpStore.Index = {};
		tmpStore.ByDate = {};
		for (let i = 0; i < tmpStore.List.length; i++)
		{
			let tmpRow = tmpStore.List[i];
			tmpStore.Index[tmpRow.IDSessionFile] = tmpRow;
			let tmpKey = this._dateKey(tmpRow.SessionStartedAt || tmpRow.CreateDate);
			if (tmpKey)
			{
				if (!tmpStore.ByDate[tmpKey]) tmpStore.ByDate[tmpKey] = [];
				tmpStore.ByDate[tmpKey].push(tmpRow);
			}
		}
		tmpStore.LastLoadedAt = Date.now();
	}

	_dateKey(pTimestamp)
	{
		if (!pTimestamp) return '';
		let tmpDate = new Date(pTimestamp);
		if (isNaN(tmpDate.getTime())) return '';
		let tmpY = tmpDate.getFullYear();
		let tmpM = String(tmpDate.getMonth() + 1).padStart(2, '0');
		let tmpD = String(tmpDate.getDate()).padStart(2, '0');
		return `${tmpY}-${tmpM}-${tmpD}`;
	}

	listSessions()
	{
		this.initializeAppData();
		return libFrameworkClient.getJSON(this.fable, this._url('SessionFiles'))
			.then((pBody) =>
			{
				let tmpRows = Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [];
				this._indexList(tmpRows);
				this.fable.AppData.Sessions.LoadError = null;
				return tmpRows;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Sessions.LoadError = pErr.message;
				return [];
			});
	}

	/**
	 * Two-stage upload:
	 *   1. POST metadata to /1.0/Session/New  → returns SessionFile row with ParimeHash
	 *   2. PUT raw zip to   /1.0/Session/:id/Blob
	 *
	 * pMetadata should be derived from the existing SessionParser output:
	 *   { Title, OriginalFileName, SessionStartedAt, SessionLastActivityAt,
	 *     TotalDurationMs, PromptCount, ToolCallCount, AgentCount, Model }
	 * pBlob is the original ArrayBuffer / Blob the user dropped.
	 */
	uploadSession(pMetadata, pBlob)
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Sessions;
		tmpStore.Uploading = true;
		tmpStore.UploadProgress = 0.05;

		return libFrameworkClient.postJSON(this.fable, this._url('Session/New'), pMetadata)
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success || !pBody.SessionFile)
				{
					throw new Error((pBody && pBody.Error) || 'Could not register session.');
				}
				tmpStore.UploadProgress = 0.3;
				let tmpRow = pBody.SessionFile;

				let tmpBlob = pBlob;
				if (pBlob instanceof ArrayBuffer)
				{
					tmpBlob = new Blob([pBlob], { type: 'application/zip' });
				}

				return libFrameworkClient.uploadBinary(this.fable, this._url('Session/' + tmpRow.IDSessionFile + '/Blob'), tmpBlob, 'application/octet-stream', 'PUT')
					.then((pPutBody) =>
					{
						tmpStore.UploadProgress = 1.0;
						tmpStore.Uploading = false;
						// Patch the size in our local row + re-index.
						if (pPutBody && pPutBody.FileSizeBytes)
						{
							tmpRow.FileSizeBytes = pPutBody.FileSizeBytes;
						}
						let tmpList = tmpStore.List.slice();
						tmpList.unshift(tmpRow);
						this._indexList(tmpList);
						return tmpRow;
					});
			})
			.catch((pErr) =>
			{
				tmpStore.Uploading = false;
				tmpStore.UploadProgress = 0;
				tmpStore.LoadError = pErr.message;
				throw pErr;
			});
	}

	/**
	 * Stream the raw zip back from the server. Returns an ArrayBuffer that the
	 * existing SessionParser.parseZip can consume directly.
	 */
	downloadSessionBlob(pIDSessionFile)
	{
		return libFrameworkClient.getBinary(this.fable, this._url('Session/' + pIDSessionFile + '/Blob'));
	}

	/**
	 * The Story timeline for a Work Item: the chronological set of sessions that
	 * advanced it (union of the scalar link and the SessionFileWorkItem join),
	 * each carrying its parsed metadata snapshot and per-link outcome. Resolves
	 * to the Sessions array (oldest first); resolves to [] on any error so the
	 * panel degrades to an empty story rather than throwing.
	 */
	getWorkItemStory(pIDWorkItem)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('WorkItem/' + pIDWorkItem + '/Story'))
			.then((pBody) =>
			{
				// The full loop timeline (feedback / prompt / run / session / validated), oldest first.
				if (pBody && Array.isArray(pBody.Entries)) { return pBody.Entries; }
				// Back-compat with an older server that only returns Sessions.
				if (pBody && Array.isArray(pBody.Sessions)) { return pBody.Sessions.map((pS) => Object.assign({ Kind: 'session', At: pS.SessionStartedAt || pS.CreateDate || '', ID: pS.IDSessionFile, Outcome: pS.WorkOutcome }, pS)); }
				return [];
			})
			.catch(() => []);
	}

	/**
	 * The Claude sessions that built a Project: the runs whose whole session was filed
	 * against this Project (scalar SessionFile.IDProject), newest first, each carrying its
	 * parsed metadata snapshot. Resolves to the Sessions array, or [] on any error so the
	 * Project panel degrades to an empty list rather than throwing.
	 */
	projectSessions(pIDProject)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Project/' + pIDProject + '/Sessions'))
			.then((pBody) => (pBody && Array.isArray(pBody.Sessions)) ? pBody.Sessions : [])
			.catch(() => []);
	}

	/**
	 * Linked-session counts for every Work Item in the tenant, keyed
	 * IDWorkItem -> count (union of the scalar link and the SessionFileWorkItem
	 * join, deduped per item). Feeds the Work Items list session indicator column
	 * in one call rather than one /Story per row. Resolves to {} on any error so
	 * the column degrades to "no marker" rather than throwing.
	 */
	sessionCounts()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Session/WorkItemCounts'))
			.then((pBody) => (pBody && pBody.Counts && typeof pBody.Counts === 'object') ? pBody.Counts : {})
			.catch(() => ({}));
	}

	/**
	 * Link/patch a session row (attach it to a Feature/WorkItem, set an
	 * outcome). PUT to the generic meadow-endpoints update; tenancy-scoped.
	 */
	setLink(pIDSessionFile, pPatch)
	{
		let tmpBody = Object.assign({ IDSessionFile: pIDSessionFile }, pPatch || {});
		return libFrameworkClient.putJSON(this.fable, this._url('SessionFile'), tmpBody);
	}

	deleteSession(pIDSessionFile)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('SessionFile/' + pIDSessionFile))
			.then(() =>
			{
				let tmpRow = this.fable.AppData.Sessions.Index[pIDSessionFile];
				if (tmpRow)
				{
					let tmpList = this.fable.AppData.Sessions.List.filter((r) => r.IDSessionFile !== pIDSessionFile);
					this._indexList(tmpList);
				}
				return true;
			})
			.catch((pErr) =>
			{
				this.fable.AppData.Sessions.LoadError = pErr.message;
				return false;
			});
	}

	// ── generic EntityList contract ──────────────────────────────────────────
	// Session renders through the standard Plansheet-EntityList, which drives a
	// provider via list()/store()/update()/remove(). Map those onto the session
	// methods so the list, rename, and delete work with no special-casing in the
	// list view. (Create is intentionally absent: sessions arrive by upload, not
	// an inline form, so the descriptor is flagged NoCreate.)
	list() { return this.listSessions(); }
	store() { this.initializeAppData(); return this.fable.AppData.Sessions; }
	update(pID, pRecord) { return this.setLink(pID, pRecord); }
	remove(pID) { return this.deleteSession(pID); }
}

module.exports = PictProviderSessionAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],612:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-ShapesAPI
 * -----------------------
 * Browser-side client for the bundled shape libraries (Phosphor, Tabler, Brands). The server holds the
 * ~10k icons and serves each one recolored, so this provider is just transport: it searches the index
 * and builds the per-shape image URL. Moodboard-StickerSource turns the results into gallery items.
 *
 *   search(query, collection, limit) -> Promise<[ { Collection, Name, Title } ]>
 *   shapeURL(collection, name, colors) -> the GET URL for the recolored SVG (a card's <img> src)
 *   collectionList() / collection(key) -> static attribution (label, license, link) for the gallery
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'ShapesAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

// Display labels + attribution, mirrored from the server's ShapeLibrary so the gallery can show a
// license line and a link without a round trip. Keys match the server collection keys.
const _COLLECTIONS =
{
	phosphor: { Label: 'Phosphor', License: 'MIT',     Link: 'https://phosphoricons.com' },
	tabler:   { Label: 'Tabler',   License: 'MIT',     Link: 'https://tabler.io/icons' },
	simple:   { Label: 'Brands',   License: 'CC0 1.0', Link: 'https://simpleicons.org' }
};

class PictProviderShapesAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	collection(pKey) { return _COLLECTIONS[pKey] ? Object.assign({ Key: pKey }, _COLLECTIONS[pKey]) : null; }

	collectionList() { return Object.keys(_COLLECTIONS).map((pKey) => Object.assign({ Key: pKey }, _COLLECTIONS[pKey])); }

	/** The recolored-SVG URL for a single shape. Colors are optional; the server applies its defaults. */
	shapeURL(pCollection, pName, pColors)
	{
		let tmpColors = pColors || {};
		let tmpParams = [];
		if (tmpColors.pri) { tmpParams.push('pri=' + encodeURIComponent(String(tmpColors.pri).replace('#', ''))); }
		if (tmpColors.sec) { tmpParams.push('sec=' + encodeURIComponent(String(tmpColors.sec).replace('#', ''))); }
		if (tmpColors.op != null && tmpColors.op !== '') { tmpParams.push('op=' + encodeURIComponent(tmpColors.op)); }
		let tmpURL = this._url('Shapes/' + encodeURIComponent(pCollection) + '/' + encodeURIComponent(pName));
		return tmpParams.length ? (tmpURL + '?' + tmpParams.join('&')) : tmpURL;
	}

	/** Ranked search across the collections (or one, when pCollection is set). Empty array on failure. */
	search(pQuery, pCollection, pLimit)
	{
		let tmpParams = [];
		if (pQuery) { tmpParams.push('q=' + encodeURIComponent(pQuery)); }
		if (pCollection) { tmpParams.push('collection=' + encodeURIComponent(pCollection)); }
		if (pLimit) { tmpParams.push('limit=' + encodeURIComponent(pLimit)); }
		let tmpURL = this._url('Shapes/Search') + (tmpParams.length ? ('?' + tmpParams.join('&')) : '');
		return libFrameworkClient.getJSON(this.fable, tmpURL)
			.then((pBody) => (pBody && Array.isArray(pBody.Shapes)) ? pBody.Shapes : [])
			.catch(() => []);
	}
}

module.exports = PictProviderShapesAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],613:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-StickerAPI
 * ------------------------
 * Browser-side client for the moodboard sticker library. Stickers are small transparent cutouts
 * (PNG or SVG) with bytes in Parime; the two-stage upload mirrors MediaAPI. The library merges the
 * system built-in set (IDCustomer 0) with the caller's own customer stickers; the server scopes the
 * customer side and sanitizes uploaded SVG.
 *
 *   listLibrary()                 -> Promise<sticker[]>  (built-in + customer rows, server-merged)
 *   upload(file, overrides)       -> Promise<{ IDSticker, ... }>  (POST /New then PUT /:id/Blob)
 *   blobURL(id)                   -> the GET blob URL for a sticker (used as the card image src)
 *   remove(id)                    -> soft-delete a customer sticker (customer-scoped CRUD)
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'StickerAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderStickerAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	blobURL(pIDSticker) { return this._url('Sticker/' + pIDSticker + '/Blob'); }

	/** The merged library: system built-ins (IDCustomer 0) plus the caller's customer stickers. */
	listLibrary()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('StickerLibrary'))
			.then((pBody) => (pBody && Array.isArray(pBody.Stickers)) ? pBody.Stickers : [])
			.catch(() => []);
	}

	/**
	 * Two-stage upload: POST metadata to /Sticker/New, then PUT the bytes to /Sticker/:id/Blob.
	 * pFile is a browser File/Blob; pOverrides can set Name / Category / MimeType / OriginalFileName.
	 * Only PNG and SVG are accepted server-side.
	 */
	upload(pFile, pOverrides)
	{
		let tmpOverrides = pOverrides || {};
		let tmpMime = tmpOverrides.MimeType || pFile.type || '';
		let tmpMeta =
		{
			Name: tmpOverrides.Name || pFile.name || 'Sticker',
			MimeType: tmpMime,
			OriginalFileName: tmpOverrides.OriginalFileName || pFile.name || 'sticker',
			FileSizeBytes: pFile.size || pFile.byteLength || 0,
			Category: tmpOverrides.Category || ''
		};

		return libFrameworkClient.postJSON(this.fable, this._url('Sticker/New'), tmpMeta)
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success || !pBody.Sticker)
				{
					throw new Error((pBody && pBody.Error) || 'Could not register sticker.');
				}
				let tmpID = pBody.Sticker.IDSticker;
				return this._putBlob(tmpID, pFile, tmpMime).then(() => Object.assign({ IDSticker: tmpID }, pBody.Sticker));
			});
	}

	_putBlob(pIDSticker, pFile, pMimeType)
	{
		let tmpBlob = (pFile instanceof ArrayBuffer) ? new Blob([pFile], { type: pMimeType }) : pFile;
		return libFrameworkClient.uploadBinary(this.fable, this._url('Sticker/' + pIDSticker + '/Blob'), tmpBlob, pMimeType || 'application/octet-stream', 'PUT');
	}

	/** Soft-delete a customer sticker via the customer-scoped CRUD (never touches a built-in). */
	remove(pIDSticker)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Sticker/' + pIDSticker))
			.then(() => true);
	}
}

module.exports = PictProviderStickerAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],614:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-StickerSetAPI
 * ---------------------------
 * Browser-side client for custom sticker sets (/1.0/StickerSet[s]). Backs the "manage our stickers"
 * surface and the set pickers. Reads (listSets) are open to any signed-in user; create / update /
 * delete are gated server-side by stickers.manage.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'StickerSetAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderStickerSetAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	// Resolves to { System: [...summaries], Custom: [...sets with Items] }.
	listSets()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('StickerSetLibrary'))
			.then((pBody) => (pBody ? pBody : { System: [], Custom: [] }))
			.catch(() => ({ System: [], Custom: [] }));
	}

	createSet(pName, pItems)
	{
		return this._write('POST', 'StickerSet/New', { Name: pName || '', Items: pItems || [] });
	}

	updateSet(pIDStickerSet, pPatch)
	{
		return this._write('PUT', 'StickerSet/' + (parseInt(pIDStickerSet, 10) || 0) + '/Save', pPatch || {});
	}

	renameSet(pIDStickerSet, pName) { return this.updateSet(pIDStickerSet, { Name: pName || '' }); }
	saveItems(pIDStickerSet, pItems) { return this.updateSet(pIDStickerSet, { Items: pItems || [] }); }

	deleteSet(pIDStickerSet)
	{
		return this._write('POST', 'StickerSet/' + (parseInt(pIDStickerSet, 10) || 0) + '/Remove', {});
	}

	_write(pMethod, pPath, pBody)
	{
		let tmpVerb = (pMethod === 'PUT') ? libFrameworkClient.putJSON : libFrameworkClient.postJSON;
		return tmpVerb(this.fable, this._url(pPath), pBody || {})
			.then((pJSON) =>
			{
				if (!pJSON || !pJSON.Success) { throw new Error((pJSON && pJSON.Error) || 'Request failed.'); }
				return pJSON;
			});
	}
}

module.exports = PictProviderStickerSetAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],615:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-TeamAPI
 * ---------------------
 * Browser-side client for team administration (the /1.0/Team/* endpoints):
 * members + their roles, custom roles, and the entitlement catalog. Backs the
 * Team and Roles sections of the settings hub. Cookie-authed (same-origin); the
 * server gates each route by entitlement.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'TeamAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderTeamAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Team) { this.fable.AppData.Team = { Members: [], Roles: [], Catalog: [], Invitations: [], KnownEmails: [] }; }
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_get(pPath)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(pPath))
			.then((pBody) => ({ ok: true, status: 200, body: pBody }))
			.catch((pError) => ({ ok: false, status: pError.StatusCode || 0, body: {} }));
	}

	_send(pMethod, pPath, pBody)
	{
		let tmpVerb = (pMethod === 'PUT') ? libFrameworkClient.putJSON : (pMethod === 'DELETE') ? libFrameworkClient.delJSON : libFrameworkClient.postJSON;
		let tmpArgs = (pMethod === 'DELETE') ? [this.fable, this._url(pPath)] : [this.fable, this._url(pPath), pBody || {}];
		return tmpVerb.apply(libFrameworkClient, tmpArgs)
			.then((pParsed) =>
			{
				if (pParsed && pParsed.Success === false) { throw new Error((pParsed && pParsed.Error) || 'Request failed.'); }
				return pParsed;
			});
	}

	listMembers()
	{
		this.initializeAppData();
		return this._get('Team/Members').then((pResult) =>
		{
			this.fable.AppData.Team.Members = (pResult.ok && pResult.body.Members) ? pResult.body.Members : [];
			return this.fable.AppData.Team.Members;
		});
	}

	// One teammate's public profile (signed-in; no admin entitlement). Used by /profile/:id.
	getMember(pIDUser)
	{
		return this._get('Team/Members/' + pIDUser).then((pResult) => (pResult.ok && pResult.body && pResult.body.Member) ? pResult.body.Member : null);
	}

	// The public team roster (signed-in; public profile fields). Powers the community hub.
	roster()
	{
		this.initializeAppData();
		return this._get('Team/Roster').then((pResult) =>
		{
			this.fable.AppData.Team.Roster = (pResult.ok && pResult.body && pResult.body.Roster) ? pResult.body.Roster : [];
			return this.fable.AppData.Team.Roster;
		});
	}

	listRoles()
	{
		this.initializeAppData();
		return this._get('Team/Roles').then((pResult) =>
		{
			this.fable.AppData.Team.Roles = (pResult.ok && pResult.body.Roles) ? pResult.body.Roles : [];
			return this.fable.AppData.Team.Roles;
		});
	}

	getEntitlements()
	{
		this.initializeAppData();
		return this._get('Team/Entitlements').then((pResult) =>
		{
			this.fable.AppData.Team.Catalog = (pResult.ok && pResult.body.Entitlements) ? pResult.body.Entitlements : [];
			return this.fable.AppData.Team.Catalog;
		});
	}

	updateMember(pIDUser, pPatch) { return this._send('PUT', 'Team/Members/' + pIDUser, pPatch || {}); }
	// Deactivate a persona (the "remove from this plan sheet" action). Keeps their attribution on past
	// work; a later invite reactivates them. The server guards the last admin and self-removal.
	removeMember(pIDUser) { return this._send('PUT', 'Team/Members/' + pIDUser, { Active: 0 }); }

	// Invitations for the current plan sheet (the /1.0/Org/Invitations surface, admin-gated server-side).
	listInvitations()
	{
		this.initializeAppData();
		return this._get('Org/Invitations').then((pResult) =>
		{
			this.fable.AppData.Team.Invitations = (pResult.ok && pResult.body.Invitations) ? pResult.body.Invitations : [];
			return this.fable.AppData.Team.Invitations;
		});
	}

	// Email addresses the account already works with, across every plan sheet it belongs to -- for the
	// invite autocomplete. Best-effort: an empty list just means no suggestions.
	knownEmails()
	{
		this.initializeAppData();
		return this._get('Account/KnownMemberEmails').then((pResult) =>
		{
			this.fable.AppData.Team.KnownEmails = (pResult.ok && pResult.body.Emails) ? pResult.body.Emails : [];
			return this.fable.AppData.Team.KnownEmails;
		});
	}

	invite(pEmail, pRole) { return this._send('POST', 'Org/Invitations', { Email: pEmail, Role: pRole || 'member' }); }
	resendInvitation(pIDInvitation) { return this._send('POST', 'Org/Invitations/' + pIDInvitation + '/Resend', {}); }
	revokeInvitation(pIDInvitation) { return this._send('DELETE', 'Org/Invitations/' + pIDInvitation); }
	resetMemberTwoFactor(pIDUser) { return this._send('POST', 'Team/Members/' + pIDUser + '/ResetTwoFactor', {}); }
	// Retire an agent persona (WI #465): soft-deletes it once it has no active node (the server 409s otherwise).
	retireAgent(pIDUser) { return this._send('POST', 'Node/Agent/' + pIDUser + '/Retire', {}); }
	createRole(pSpec) { return this._send('POST', 'Team/Roles', pSpec || {}); }
	updateRole(pIDRole, pSpec) { return this._send('PUT', 'Team/Roles/' + pIDRole, pSpec || {}); }
	deleteRole(pIDRole) { return this._send('DELETE', 'Team/Roles/' + pIDRole); }
}

module.exports = PictProviderTeamAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],616:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-TestRunAPI
 * ------------------------
 * Browser-side client for TestRun, extending the generic EntityAPI provider.
 * Adds start(): the one-call POST /1.0/TestRun/Start that creates the run plus
 * one TestRunStep per routine step (title/order snapshots) server-side. The
 * same call is the surface the planned browser plugin will drive. Closing the
 * run and editing its fields go through the generic update().
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'TestRunAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'TestRun',
	PluralRoute: 'TestRuns',
	IDField: 'IDTestRun'
};

class PictProviderTestRunAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * Start a run of a routine: creates the TestRun and its snapshot steps in
	 * one server call.
	 * @param {number|string} pIDRoutine - the routine to run
	 * @param {object} [pExtra] - optional { Name, Environment }
	 * @returns {Promise<object>} the created TestRun row
	 */
	start(pIDRoutine, pExtra)
	{
		let tmpBody = Object.assign({}, pExtra || {}, { IDRoutine: Number(pIDRoutine) || 0 });
		return libFrameworkClient.postJSON(this.fable, this._url('TestRun/Start'), tmpBody)
			.then((pBody) => (pBody && pBody.TestRun) ? pBody.TestRun : pBody);
	}
}

module.exports = PictProviderTestRunAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],617:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-TestRunStepAPI
 * ----------------------------
 * Browser-side CRUD client for TestRunStep, extending the generic EntityAPI
 * provider. Rows are created server-side by POST /1.0/TestRun/Start (the
 * snapshot); the client lists them per run and updates Outcome/Notes as the
 * tester works through the steps. Tenancy (IDCustomer) is enforced
 * server-side, so the client never sends it.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'TestRunStepAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'TestRunStep',
	PluralRoute: 'TestRunSteps',
	IDField: 'IDTestRunStep'
};

class PictProviderTestRunStepAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The snapshot steps of one test run, sorted by SortOrder ascending.
	 * @param {number|string} pIDTestRun - the test run id
	 * @returns {Promise<Array<object>>}
	 */
	listForRun(pIDTestRun)
	{
		let tmpFilter = 'FBV~IDTestRun~EQ~' + pIDTestRun;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.then((pRows) => pRows.sort((pA, pB) => (Number(pA.SortOrder) || 0) - (Number(pB.SortOrder) || 0)))
			.catch(() => []);
	}
}

module.exports = PictProviderTestRunStepAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"./Pict-Provider-EntityAPI.js":593}],618:[function(require,module,exports){
/**
 * Pict-Provider-TokenAPI
 * ----------------------
 * Browser-side client for the caller's API tokens. Backs the "API Tokens"
 * section in the gear-menu settings panel: list the current user's tokens,
 * mint a new one (the plaintext is returned exactly once), and revoke one.
 *
 * The server scopes every operation to the authenticated IDUser and never
 * returns the token hash, so AppData.APITokens.List holds only safe metadata.
 *
 * AppData shape this provider owns:
 *   AppData.APITokens = {
 *       List:         [],     // [{ IDUserToken, Label, CreateDate, LastUsedAt, ExpiresAt }]
 *       LastLoadedAt: 0,
 *       LoadError:    null,
 *       Loading:      false
 *   }
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'TokenAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderTokenAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.APITokens)
		{
			this.fable.AppData.APITokens =
			{
				List: [],
				LastLoadedAt: 0,
				LoadError: null,
				Loading: false
			};
		}
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	/**
	 * GET /1.0/Tokens -> the caller's own tokens (no hash). Sorted newest first.
	 */
	listTokens()
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.APITokens;
		tmpStore.Loading = true;
		return libFrameworkClient.getJSON(this.fable, this._url('Tokens'))
			.then((pBody) =>
			{
				let tmpRows = (pBody && Array.isArray(pBody.Tokens)) ? pBody.Tokens : [];
				tmpStore.List = tmpRows.slice().sort((pA, pB) => (pB.IDUserToken || 0) - (pA.IDUserToken || 0));
				tmpStore.LastLoadedAt = Date.now();
				tmpStore.LoadError = null;
				tmpStore.Loading = false;
				return tmpStore.List;
			})
			.catch((pErr) =>
			{
				tmpStore.LoadError = pErr.message;
				tmpStore.Loading = false;
				return [];
			});
	}

	/**
	 * POST /1.0/Token { Label } -> { Token (plaintext, ONCE), UserToken (row) }.
	 * Prepends the new row to the local list and resolves with the plaintext so
	 * the caller can show it once. Rejects on failure.
	 */
	createToken(pLabel)
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.APITokens;
		return libFrameworkClient.postJSON(this.fable, this._url('Token'), { Label: pLabel || '' })
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success || !pBody.Token)
				{
					throw new Error((pBody && pBody.Error) || 'Could not create token.');
				}
				if (pBody.UserToken)
				{
					tmpStore.List = [pBody.UserToken].concat(tmpStore.List);
				}
				return pBody.Token;
			});
	}

	/**
	 * POST /1.0/Token/For { Email, Label } -> { Token (plaintext, ONCE), ... }. Platform-admin only. Mints a
	 * token for ANOTHER user (e.g. the claude@plansheet.io agent) by account email, so the token belongs to
	 * that user rather than the caller. Resolves with the plaintext so the caller can show it once; rejects on
	 * failure (403 if the caller is not a platform admin, 404 if the email has no user here).
	 */
	mintTokenForUser(pTarget, pLabel)
	{
		// pTarget is an IDUser (from the picker) or an account email; send whichever it is.
		let tmpBody = { Label: pLabel || '' };
		if (typeof pTarget === 'number' || /^\d+$/.test(String(pTarget || ''))) { tmpBody.IDUser = parseInt(pTarget, 10); }
		else { tmpBody.Email = String(pTarget || ''); }
		return libFrameworkClient.postJSON(this.fable, this._url('Token/For'), tmpBody)
			.then((pBody) =>
			{
				if (!pBody || !pBody.Success || !pBody.Token)
				{
					throw new Error((pBody && pBody.Error) || 'Could not mint token.');
				}
				return pBody.Token;
			});
	}

	/**
	 * DELETE /1.0/Token/:id -> revoke. Drops the row from the local list.
	 */
	revokeToken(pIDUserToken)
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.APITokens;
		return libFrameworkClient.delJSON(this.fable, this._url('Token/' + pIDUserToken))
			.then(() =>
			{
				tmpStore.List = tmpStore.List.filter((pRow) => pRow.IDUserToken !== pIDUserToken);
				return true;
			})
			.catch((pErr) =>
			{
				tmpStore.LoadError = pErr.message;
				return false;
			});
	}
}

module.exports = PictProviderTokenAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],619:[function(require,module,exports){
/**
 * Pict-Provider-UserAPI
 * ---------------------
 * Browser-side client for the caller's own account (the self-service
 * /1.0/Account/* endpoints). Backs the Profile / Sign-in sections of the
 * settings hub. AppData.Account.Profile holds the last-loaded profile.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'UserAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderUserAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Account)
		{
			this.fable.AppData.Account = { Profile: null, LoadError: null };
		}
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	getMe()
	{
		this.initializeAppData();
		return libFrameworkClient.getJSON(this.fable, this._url('Account/Me'))
			.then((pBody) => { this.fable.AppData.Account.Profile = pBody.Account || null; return pBody.Account; })
			.catch((pErr) => { this.fable.AppData.Account.LoadError = pErr.message; return null; });
	}

	updateMe(pPatch)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Account/Me'), pPatch || {})
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Could not save.'); }
				if (pBody.Account) { this.fable.AppData.Account.Profile = pBody.Account; }
				return pBody.Account;
			});
	}

	changeEmail(pEmail)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Account/Email'), { Email: pEmail })
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Could not change email.'); }
				if (this.fable.AppData.Account.Profile) { this.fable.AppData.Account.Profile.Email = pBody.Email; }
				return pBody.Email;
			});
	}

	changePassword(pCurrent, pNew)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Account/Password'), { CurrentPassword: pCurrent, NewPassword: pNew })
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Could not change password.'); }
				return true;
			});
	}

	// --- Two-step verification (2FA) enrollment ------------------------------
	_post(pPath, pBody)
	{
		return libFrameworkClient.postJSON(this.fable, this._url(pPath), pBody || {})
			.then((pJSON) =>
			{
				if (!pJSON.Success) { throw new Error((pJSON && pJSON.Error) || 'Something went wrong.'); }
				return pJSON;
			});
	}

	getTwoFactor()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Account/TwoFactor'))
			.then((pBody) => pBody.TwoFactor || { Available: false })
			.catch(() => ({ Available: false }));
	}

	setPhone(pPhone) { return this._post('Account/Phone', { Phone: pPhone }); }
	verifyPhone(pToken, pCode) { return this._post('Account/Phone/Verify', { ChallengeToken: pToken, Code: pCode }); }
	enableTwoFactor(pChannel) { return this._post('Account/TwoFactor/Enable', { Channel: pChannel }); }
	confirmTwoFactor(pToken, pCode) { return this._post('Account/TwoFactor/Confirm', { ChallengeToken: pToken, Code: pCode }); }
	disableTwoFactor(pPassword) { return this._post('Account/TwoFactor/Disable', { Password: pPassword }); }
	generateRecoveryCodes() { return this._post('Account/TwoFactor/RecoveryCodes', {}); }

	getNotificationPrefs()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Account/NotificationPrefs'))
			.then((pBody) => ({ Prefs: (pBody && Array.isArray(pBody.Prefs)) ? pBody.Prefs : [], CanSMS: !!(pBody && pBody.CanSMS) }))
			.catch(() => ({ Prefs: [], CanSMS: false }));
	}

	// pPatch carries whichever channel(s) changed: { EmailEnabled? , SMSEnabled? }.
	setNotificationPref(pEventKey, pPatch)
	{
		let tmpBody = Object.assign({ EventKey: pEventKey }, pPatch || {});
		return libFrameworkClient.putJSON(this.fable, this._url('Account/NotificationPrefs'), tmpBody)
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Could not save.'); }
				return pBody;
			});
	}

	// ── OAuth connections: which plan sheets a token the person created may act in ──────────────
	// The authorized set could only ever grow (creating a plan sheet over a connector widens the calling
	// token), and nothing showed a person what a token had accumulated. These back the Connections screen.
	getOAuthConnections()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('OAuth/Connections'))
			.then((pBody) => (
			{
				Connections: (pBody && Array.isArray(pBody.Connections)) ? pBody.Connections : [],
				AvailablePlansheets: (pBody && Array.isArray(pBody.AvailablePlansheets)) ? pBody.AvailablePlansheets : []
			}))
			.catch(() => ({ Connections: [], AvailablePlansheets: [] }));
	}

	// pIDCustomers is the WHOLE set the connection should be authorized for; the server keeps the grant's
	// own plan sheet in it regardless, and refuses any plan sheet the caller is not a member of.
	setOAuthConnectionPlansheets(pIDOAuthClient, pIDCustomers)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('OAuth/Connection/' + pIDOAuthClient + '/Plansheets'),
			{ Plansheets: Array.isArray(pIDCustomers) ? pIDCustomers : [] })
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Could not update that connection.'); }
				return pBody;
			});
	}

	revokeOAuthConnection(pIDOAuthClient)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('OAuth/Connection/' + pIDOAuthClient + '/Revoke'), {})
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Could not revoke that connection.'); }
				return pBody;
			});
	}

	// One guide from the self-describing API (orator-api-description): { Key, Title, Body }, Body being markdown.
	// The human half of the connect-Claude story reads its walkthrough from the same content the API publishes.
	getApiGuide(pKey)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('API/Guides/' + encodeURIComponent(pKey)))
			.then((pBody) => (pBody && pBody.Key) ? pBody : null)
			.catch(() => null);
	}
}

module.exports = PictProviderUserAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375}],620:[function(require,module,exports){
'use strict';

/**
 * Pict-Provider-WorkflowAPI
 * -------------------------
 * The client the retold-workflow views talk to, pointed at plansheet's /1.0/Workflow routes. It
 * wraps retold-workflow's reference WorkflowClient for the workflow-native verbs (types, adopt,
 * board, layout, and the per-subject operations) and fills the two methods plansheet serves
 * through its existing generic entity CRUD rather than a dedicated workflow route:
 *
 *   getType(id)            -> the matching record from the catalog list (which already carries
 *                             WorkflowDefinition), so no extra route is needed.
 *   saveType(id, def)      -> PUT /1.0/VisionType with the new WorkflowDefinition (the generic,
 *                             tenant-scoped entity update meadow already exposes).
 *
 * The views resolve their client by provider name ('WorkflowAPI'); this provider is that object.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libWorkflowClient = require('retold-workflow').WorkflowClient;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'WorkflowAPI',
	Dependencies: [],
	BasePath: '/1.0/Workflow',
	TypeEntityRoute: '/1.0/VisionType'
};

class PictProviderWorkflowAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this._client = new libWorkflowClient({ BasePath: this.options.BasePath, Credentials: 'same-origin' });
	}

	// -- workflow-native verbs (delegate to the reference client) ---------------
	getTypes() { return this._client.getTypes(); }
	// Owned-only types (the tenant's imported crafts, no platform catalog). The reference client
	// only knows the union route, so this hits plansheet's /Types/Owned directly and unwraps it.
	getOwnedTypes()
	{
		return libFrameworkClient.getJSON(this.fable, this.options.BasePath + '/Types/Owned')
			.then((pBody) => (pBody && pBody.Types) || []);
	}
	adoptType(pBuiltInID) { return this._client.adoptType(pBuiltInID); }
	getBoard(pTypeID) { return this._client.getBoard(pTypeID); }
	getLayout(pTypeID) { return this._client.getLayout(pTypeID); }
	saveLayout(pTypeID, pLayout) { return this._client.saveLayout(pTypeID, pLayout); }
	open(pSubjectID) { return this._client.open(pSubjectID); }
	advance(pSubjectID, pToState) { return this._client.advance(pSubjectID, pToState); }
	reevaluate(pSubjectID) { return this._client.reevaluate(pSubjectID); }
	getSubject(pSubjectID) { return this._client.getSubject(pSubjectID); }
	getTimeline(pSubjectID) { return this._client.getTimeline(pSubjectID); }
	getMetrics(pSubjectID) { return this._client.getMetrics(pSubjectID); }
	getAgency(pSubjectID) { return this._client.getAgency(pSubjectID); }

	// -- served through plansheet's generic VisionType CRUD ---------------------

	getType(pTypeID)
	{
		return this.getTypes().then((pTypes) => (pTypes || []).find((pType) => String(pType.ID) === String(pTypeID)) || null);
	}

	saveType(pTypeID, pDefinition)
	{
		let tmpBody = { IDVisionType: pTypeID, WorkflowDefinition: JSON.stringify(pDefinition || {}) };
		return libFrameworkClient.putJSON(this.fable, this.options.TypeEntityRoute, tmpBody);
	}

	// -- Drafting Kit library (plansheet /1.0/Workflow/Types routes) -------------

	// One JSON request against BasePath; throws on a non-2xx with the server's Error message.
	_req(pPath, pMethod, pBody)
	{
		let tmpURL = this.options.BasePath + pPath;
		let tmpMethod = (pMethod || 'GET').toUpperCase();
		switch (tmpMethod)
		{
			case 'POST':
				return libFrameworkClient.postJSON(this.fable, tmpURL, pBody);
			case 'PUT':
				return libFrameworkClient.putJSON(this.fable, tmpURL, pBody);
			case 'DELETE':
				return libFrameworkClient.delJSON(this.fable, tmpURL);
			default:
				return libFrameworkClient.getJSON(this.fable, tmpURL);
		}
	}

	getLibrary() { return this._req('/Types/Library'); }
	getKit(pID) { return this._req('/Types/' + pID + '/Kit').then((pBody) => (pBody && pBody.Kit) || null); }
	createKit(pName, pFromTemplateID) { return this._req('/Types', 'POST', { Name: pName, FromTemplateID: pFromTemplateID || 0 }).then((pBody) => (pBody && pBody.Kit) || null); }
	duplicateKit(pID) { return this._req('/Types/' + pID + '/Duplicate', 'POST', {}).then((pBody) => (pBody && pBody.Kit) || null); }
	renameKit(pID, pName) { return this._req('/Types/' + pID + '/Name', 'PUT', { Name: pName }); }
	deleteKit(pID) { return this._req('/Types/' + pID, 'DELETE'); }
	saveKitTerms(pID, pTerms) { return this._req('/Types/' + pID + '/Terms', 'PUT', { Terms: pTerms }); }
	saveKitConnectionStyle(pID, pStyle) { return this._req('/Types/' + pID + '/ConnectionStyle', 'PUT', { ConnectionStyle: pStyle }); }
	saveKitDefaultStickerSet(pID, pKey) { return this._req('/Types/' + pID + '/DefaultStickerSet', 'PUT', { DefaultStickerSet: pKey || '' }); }
	saveKitBrandStickerSet(pID, pKey) { return this._req('/Types/' + pID + '/BrandStickerSet', 'PUT', { BrandStickerSet: pKey || '' }); }
	saveKitLoops(pID, pLoops) { return this._req('/Types/' + pID + '/Loops', 'PUT', { Loops: pLoops }); }
	saveKitLoopLabels(pID, pLabels) { return this._req('/Types/' + pID + '/LoopLabels', 'PUT', { LoopLabels: pLabels }); }
}

module.exports = PictProviderWorkflowAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./FrameworkClient.js":576,"pict":375,"retold-workflow":508}],621:[function(require,module,exports){
'use strict';

/**
 * PlansheetChecklistProvider
 * --------------------------
 * Adapts the pict-section-checklist data seam (ChecklistDataProvider) to the plansheet ChecklistAPI.
 * One shared instance serves every checklist control on the page: a control is bound to a single
 * Checklist by its Context ({ OwnerType: 'Checklist', IDOwner: <IDChecklist> }), so every call reads
 * the id from the context and there is no per-instance state. The server owns tenancy and the
 * private/shared privacy check; this just maps rows to and from the neutral { List, Item } shapes.
 */

const libChecklist = require('pict-section-checklist');

class PlansheetChecklistProvider extends libChecklist.ChecklistDataProvider
{
	constructor(pPict)
	{
		super({});
		this.pict = pPict;
	}

	_api() { return this.pict.providers.ChecklistAPI; }
	_idFromContext(pContext) { return parseInt((pContext && pContext.IDOwner) || 0, 10) || 0; }

	_toItem(pRow)
	{
		return {
			Key: pRow.IDChecklistItem,
			ListKey: pRow.IDChecklist,
			ParentKey: pRow.IDParentChecklistItem ? pRow.IDParentChecklistItem : null,
			Title: pRow.Title || '',
			Done: !!pRow.Done,
			Sort: (typeof pRow.SortOrder === 'number') ? pRow.SortOrder : (parseFloat(pRow.SortOrder) || 0),
			Notes: pRow.Notes || '',
			Collapsed: !!pRow.Collapsed
		};
	}

	// One round trip for the whole control (the checklist + its items).
	loadChecklist(pContext)
	{
		let tmpID = this._idFromContext(pContext);
		if (!tmpID) { return Promise.resolve({ List: null, Items: [] }); }
		return this._api().get(tmpID).then((pResult) =>
		{
			let tmpChecklist = (pResult && pResult.Checklist) || null;
			let tmpList = tmpChecklist ? { Key: tmpChecklist.IDChecklist, OwnerType: 'Checklist', IDOwner: tmpChecklist.IDChecklist, Title: tmpChecklist.Title || '' } : null;
			let tmpItems = ((pResult && pResult.Items) || []).map((pRow) => this._toItem(pRow));
			return { List: tmpList, Items: tmpItems };
		});
	}

	getList(pContext) { return this.loadChecklist(pContext).then((pLoaded) => pLoaded.List); }

	listItems(pListKey) { return this._api().get(pListKey).then((pResult) => ((pResult && pResult.Items) || []).map((pRow) => this._toItem(pRow))); }

	updateList(pKey, pPatch)
	{
		let tmpTitle = (pPatch && pPatch.Title) || '';
		return this._api().rename(pKey, tmpTitle).then(() => ({ Key: pKey, Title: tmpTitle }));
	}

	createItem(pDraft)
	{
		let tmpListKey = pDraft.ListKey;
		return this._api().createItem(tmpListKey,
			{
				ParentKey: (pDraft.ParentKey != null && pDraft.ParentKey !== '') ? pDraft.ParentKey : 0,
				Title: pDraft.Title || '',
				Sort: (typeof pDraft.Sort === 'number') ? pDraft.Sort : 0
			})
			.then((pItem) => pItem ? this._toItem(pItem) : { Key: 'pending-' + Date.now(), ListKey: tmpListKey, ParentKey: pDraft.ParentKey || null, Title: pDraft.Title || '', Done: false, Sort: pDraft.Sort || 0 });
	}

	updateItem(pKey, pPatch)
	{
		let tmpServerPatch = {};
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Done')) { tmpServerPatch.Done = pPatch.Done; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Title')) { tmpServerPatch.Title = pPatch.Title; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Collapsed')) { tmpServerPatch.Collapsed = pPatch.Collapsed; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Notes')) { tmpServerPatch.Notes = pPatch.Notes; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'ParentKey')) { tmpServerPatch.ParentKey = (pPatch.ParentKey != null && pPatch.ParentKey !== '') ? pPatch.ParentKey : 0; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Sort')) { tmpServerPatch.Sort = pPatch.Sort; }
		return this._api().updateItem(pKey, tmpServerPatch).then(() => ({ Key: pKey }));
	}

	deleteItem(pKey) { return this._api().deleteItem(pKey).then(() => undefined); }
}

module.exports = PlansheetChecklistProvider;

},{"pict-section-checklist":184}],622:[function(require,module,exports){
'use strict';

/**
 * PlansheetCommentProvider
 * ------------------------
 * Adapts plansheet's CommentThread/Comment REST providers to the data seam that pict-section-comments
 * expects (its CommentDataProvider interface). The section calls neutral methods; this maps them to
 * the server rows and back, resolving author display names from the team roster / the signed-in user.
 *
 * It extends the section's CommentDataProvider base, so loadContext / resolveThread / completeThread /
 * reopenThread come for free on top of the eight primitives implemented here.
 */

const libCommentProvider = require('pict-section-comments');

class PlansheetCommentProvider extends libCommentProvider.CommentDataProvider
{
	constructor(pPict)
	{
		super({});
		this.pict = pPict;
	}

	_threadAPI() { return this.pict.providers.CommentThreadAPI; }
	_commentAPI() { return this.pict.providers.CommentAPI; }
	_unwrap(pResult) { return (pResult && pResult.Record) ? pResult.Record : pResult; }

	_ts(pDate)
	{
		if (!pDate) { return null; }
		let tmpValue = (typeof pDate === 'number') ? pDate : Date.parse(pDate);
		return isNaN(tmpValue) ? null : tmpValue;
	}

	// Resolve an author's display name + avatar from the signed-in user or the cached team roster.
	_author(pIDUser)
	{
		let tmpKey = pIDUser || 0;
		let tmpAuth = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || null;
		if (tmpAuth && String(tmpAuth.IDUser) === String(tmpKey))
		{
			return { Key: tmpKey, Name: tmpAuth.DisplayName || tmpAuth.Email || 'You', Avatar: tmpAuth.AvatarURL || '' };
		}
		let tmpTeam = this.pict.AppData.Team || {};
		let tmpPeople = [].concat(tmpTeam.Roster || [], tmpTeam.Members || []);
		let tmpHit = tmpPeople.find((pPerson) => String(pPerson.IDUser) === String(tmpKey));
		if (tmpHit)
		{
			let tmpName = tmpHit.DisplayName
				|| ([tmpHit.NameFirst, tmpHit.NameLast].filter(Boolean).join(' ') || '').trim()
				|| tmpHit.Email || ('User ' + tmpKey);
			return { Key: tmpKey, Name: tmpName, Avatar: tmpHit.AvatarURL || tmpHit.PhotoURL || '' };
		}
		return { Key: tmpKey, Name: tmpKey ? ('User ' + tmpKey) : 'Someone', Avatar: '' };
	}

	_toThread(pRow)
	{
		let tmpAnchor = null;
		if (pRow.AnchorJSON)
		{
			try { tmpAnchor = (typeof pRow.AnchorJSON === 'string') ? JSON.parse(pRow.AnchorJSON) : pRow.AnchorJSON; }
			catch (pError) { tmpAnchor = null; }
		}
		return {
			Key: pRow.IDCommentThread,
			OwnerType: pRow.OwnerType,
			IDOwner: pRow.IDOwner,
			Anchor: tmpAnchor,
			Kind: pRow.Kind || 'Discussion',
			Title: pRow.Title || '',
			Status: pRow.Status || 'Open',
			Sort: pRow.SortOrder || 0,
			Author: this._author(pRow.CreatingIDUser),
			CreatedAt: this._ts(pRow.CreateDate) || 0,
			UpdatedAt: this._ts(pRow.UpdateDate) || 0
		};
	}

	_toComment(pRow)
	{
		let tmpCreated = this._ts(pRow.CreateDate) || 0;
		let tmpUpdated = this._ts(pRow.UpdateDate) || 0;
		return {
			Key: pRow.IDComment,
			ThreadKey: pRow.IDCommentThread,
			ParentKey: pRow.IDParentComment || null,
			Author: this._author(pRow.IDUser || pRow.CreatingIDUser),
			Body: pRow.Body || '',
			ContentType: pRow.ContentType || 'text',
			CreatedAt: tmpCreated,
			UpdatedAt: tmpUpdated,
			EditedAt: (tmpUpdated && tmpCreated && tmpUpdated > tmpCreated + 1000) ? tmpUpdated : null,
			Deleted: !!pRow.Deleted
		};
	}

	// ---- the eight primitives ----

	listThreads(pContext)
	{
		return this._threadAPI().listForOwner(pContext.OwnerType, pContext.IDOwner)
			.then((pRows) => (pRows || []).map((pRow) => this._toThread(pRow)));
	}

	createThread(pDraft)
	{
		let tmpContext = pDraft.Context || pDraft;
		let tmpRow =
		{
			OwnerType: tmpContext.OwnerType,
			IDOwner: tmpContext.IDOwner,
			Kind: pDraft.Kind || 'Discussion',
			Title: pDraft.Title || '',
			Status: pDraft.Status || 'Open',
			SortOrder: pDraft.Sort || 0,
			AnchorJSON: pDraft.Anchor ? JSON.stringify(pDraft.Anchor) : ''
		};
		return this._threadAPI().create(tmpRow).then((pResult) => this._toThread(this._unwrap(pResult)));
	}

	updateThread(pKey, pPatch)
	{
		let tmpRow = {};
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Status')) { tmpRow.Status = pPatch.Status; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Title')) { tmpRow.Title = pPatch.Title; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Kind')) { tmpRow.Kind = pPatch.Kind; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Sort')) { tmpRow.SortOrder = pPatch.Sort; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Anchor')) { tmpRow.AnchorJSON = pPatch.Anchor ? JSON.stringify(pPatch.Anchor) : ''; }
		return this._threadAPI().update(pKey, tmpRow).then((pResult) => this._toThread(this._unwrap(pResult)));
	}

	deleteThread(pKey) { return this._threadAPI().remove(pKey); }

	listComments(pThreadKey)
	{
		return this._commentAPI().listForThread(pThreadKey)
			.then((pRows) => (pRows || []).map((pRow) => this._toComment(pRow)));
	}

	createComment(pDraft)
	{
		let tmpRow =
		{
			IDCommentThread: pDraft.ThreadKey,
			IDParentComment: pDraft.ParentKey || 0,
			Body: pDraft.Body,
			ContentType: pDraft.ContentType || 'text',
			IDUser: (pDraft.Author && pDraft.Author.Key) || 0,
			SortOrder: 0
		};
		return this._commentAPI().create(tmpRow).then((pResult) => this._toComment(this._unwrap(pResult)));
	}

	updateComment(pKey, pPatch)
	{
		let tmpRow = {};
		if (Object.prototype.hasOwnProperty.call(pPatch, 'Body')) { tmpRow.Body = pPatch.Body; }
		if (Object.prototype.hasOwnProperty.call(pPatch, 'ContentType')) { tmpRow.ContentType = pPatch.ContentType; }
		return this._commentAPI().update(pKey, tmpRow).then((pResult) => this._toComment(this._unwrap(pResult)));
	}

	deleteComment(pKey) { return this._commentAPI().remove(pKey); }
}

module.exports = PlansheetCommentProvider;

},{"pict-section-comments":191}],623:[function(require,module,exports){
'use strict';

/**
 * PlansheetPromptProvider
 * -----------------------
 * Adapts plansheet's Prompt/WordList/GeneratedPrompt REST providers to the
 * data seam pict-section-prompteditor expects (its PromptDataProvider
 * interface), the same way PlansheetCommentProvider adapts the comments
 * section. The editor calls neutral methods keyed by module Keys; this maps
 * them to server rows and back:
 *
 *   module Key            server column
 *   Prompt.Key        <-> Prompt.PromptKey         (IDPrompt cached per Key)
 *   WordList.Key      <-> WordList.WordListKey
 *   Generated.Key     <-> GeneratedPrompt.GeneratedKey
 *
 * On every prompt save the provider also compiles the assembled Source (the
 * module's PromptCompiler, against the current shape cascade) so the server's
 * version capture snapshots a complete, versionable document - that Source is
 * what history, the shared library, and pinned attachment versions show.
 *
 * Server-owned fields ride on Meta._Plansheet (IDPrompt, PromptNumber,
 * Visibility, Origin, PostedDate) so page chrome can read them off the
 * module's own records; the provider strips _Plansheet before writing Meta
 * back.
 */

const libPromptEditor = require('pict-section-prompteditor');

class PlansheetPromptProvider extends libPromptEditor.PromptDataProvider
{
	constructor(pPict)
	{
		super({});
		this.pict = pPict;
		this._types = null;
		this._promptIDByKey = {};
		this._promptKeyByID = {};
		this._promptRowByKey = {};
		this._promptSaveChain = {};
		this._wordListIDByKey = {};
		this._generatedIDByKey = {};
	}

	_promptAPI() { return this.pict.providers.PromptAPI; }
	_wordListAPI() { return this.pict.providers.WordListAPI; }
	_generatedAPI() { return this.pict.providers.GeneratedPromptAPI; }
	_unwrap(pResult) { return (pResult && pResult.Record) ? pResult.Record : pResult; }

	/** The shape cascade the compiler resolves TypeKeys against (set by the host page). */
	setPromptTypes(pTypes)
	{
		this._types = Array.isArray(pTypes) && pTypes.length ? pTypes : null;
	}

	_ts(pDate)
	{
		if (!pDate) { return null; }
		let tmpValue = (typeof pDate === 'number') ? pDate : Date.parse(pDate);
		return isNaN(tmpValue) ? null : tmpValue;
	}

	_parse(pJSON, pDefault)
	{
		if (pJSON == null || pJSON === '') { return pDefault; }
		if (typeof pJSON !== 'string') { return pJSON; }
		try { return JSON.parse(pJSON); } catch (pError) { return pDefault; }
	}

	_author(pIDUser)
	{
		let tmpKey = pIDUser || 0;
		let tmpAuth = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || null;
		if (tmpAuth && String(tmpAuth.IDUser) === String(tmpKey))
		{
			return { Key: tmpKey, Name: tmpAuth.DisplayName || tmpAuth.Email || 'You' };
		}
		let tmpTeam = this.pict.AppData.Team || {};
		let tmpPeople = [].concat(tmpTeam.Roster || [], tmpTeam.Members || []);
		let tmpHit = tmpPeople.find((pPerson) => String(pPerson.IDUser) === String(tmpKey));
		if (tmpHit)
		{
			let tmpName = tmpHit.DisplayName
				|| ([tmpHit.NameFirst, tmpHit.NameLast].filter(Boolean).join(' ') || '').trim()
				|| tmpHit.Email || ('User ' + tmpKey);
			return { Key: tmpKey, Name: tmpName };
		}
		return { Key: tmpKey, Name: tmpKey ? ('User ' + tmpKey) : 'Someone' };
	}

	_compileSource(pRecord)
	{
		try
		{
			let tmpTypes = this._types || libPromptEditor.DefaultPromptTypes;
			let tmpType = libPromptEditor.getPromptType(tmpTypes, pRecord.TypeKey);
			return libPromptEditor.PromptCompiler.assembleSource(pRecord, tmpType, {});
		}
		catch (pError)
		{
			return '';
		}
	}

	// ---- row <-> module record transforms ------------------------------------

	_toPrompt(pRow)
	{
		let tmpKey = pRow.PromptKey || ('pr-id-' + pRow.IDPrompt);
		this._promptIDByKey[tmpKey] = pRow.IDPrompt;
		this._promptKeyByID[pRow.IDPrompt] = tmpKey;
		// The merge base for partial patches (the editor saves Title, TypeKey, and
		// Segments as separate debounced patches; merging against a cached row
		// instead of a re-fetch keeps concurrent saves from resurrecting stale state).
		this._promptRowByKey[tmpKey] = pRow;
		let tmpMeta = this._parse(pRow.Meta, {}) || {};
		tmpMeta._Plansheet =
		{
			IDPrompt: pRow.IDPrompt,
			PromptNumber: pRow.PromptNumber || 0,
			Visibility: pRow.Visibility || 'Private',
			Origin: pRow.Origin || 'Crafted',
			PostedDate: pRow.PostedDate || null
		};
		return {
			Key: tmpKey,
			Title: pRow.Title || '',
			TypeKey: pRow.TypeKey || 'freeform',
			Segments: this._parse(pRow.SegmentsJSON, {}) || {},
			IncludeSegmentHeadings: !(Number(pRow.IncludeSegmentHeadings) === 0),
			Author: this._author(pRow.IDUser || pRow.CreatingIDUser),
			Meta: tmpMeta,
			CreatedAt: this._ts(pRow.CreateDate) || 0,
			UpdatedAt: this._ts(pRow.UpdateDate) || 0
		};
	}

	_toWordList(pRow)
	{
		let tmpKey = pRow.WordListKey || ('wl-id-' + pRow.IDWordList);
		this._wordListIDByKey[tmpKey] = pRow.IDWordList;
		return {
			Key: tmpKey,
			Name: pRow.Name || '',
			Entries: libPromptEditor.normalizeEntries(this._parse(pRow.EntriesJSON, [])),
			CreatedAt: this._ts(pRow.CreateDate) || 0,
			UpdatedAt: this._ts(pRow.UpdateDate) || 0
		};
	}

	_toGenerated(pRow)
	{
		let tmpKey = pRow.GeneratedKey || ('gen-id-' + pRow.IDGeneratedPrompt);
		this._generatedIDByKey[tmpKey] = pRow.IDGeneratedPrompt;
		return {
			Key: tmpKey,
			PromptKey: this._promptKeyByID[pRow.IDPrompt] || ('pr-id-' + pRow.IDPrompt),
			PromptTitle: pRow.PromptTitle || '',
			TypeKey: pRow.TypeKey || '',
			Markdown: pRow.Markdown || '',
			Sequence: Number(pRow.Sequence) || 0,
			Author: this._author(pRow.IDUser || pRow.CreatingIDUser),
			GeneratedAt: this._ts(pRow.CreateDate) || 0
		};
	}

	_metaForWrite(pMeta)
	{
		let tmpMeta = Object.assign({}, pMeta || {});
		delete tmpMeta._Plansheet;
		return JSON.stringify(tmpMeta);
	}

	// ---- word lists -----------------------------------------------------------

	listWordLists()
	{
		return this._wordListAPI().list()
			.then((pRows) => (pRows || []).map((pRow) => this._toWordList(pRow))
				.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name))));
	}

	createWordList(pDraft)
	{
		let tmpDraft = pDraft || {};
		let tmpName = String(tmpDraft.Name || '').trim();
		if (!tmpName) { return Promise.reject(new Error('A word list needs a Name.')); }
		return this._wordListAPI().create(
		{
			Name: tmpName.slice(0, 128),
			EntriesJSON: JSON.stringify(libPromptEditor.normalizeEntries(tmpDraft.Entries)),
			Visibility: 'Private'
		}).then((pResult) => this._toWordList(this._unwrap(pResult)));
	}

	updateWordList(pKey, pPatch)
	{
		let tmpID = this._wordListIDByKey[pKey];
		if (!tmpID) { return Promise.reject(new Error('No word list with Key ' + pKey)); }
		let tmpPatch = pPatch || {};
		let tmpRow = {};
		if (typeof tmpPatch.Name !== 'undefined')
		{
			let tmpName = String(tmpPatch.Name || '').trim();
			if (!tmpName) { return Promise.reject(new Error('A word list needs a Name.')); }
			tmpRow.Name = tmpName.slice(0, 128);
		}
		if (typeof tmpPatch.Entries !== 'undefined')
		{
			tmpRow.EntriesJSON = JSON.stringify(libPromptEditor.normalizeEntries(tmpPatch.Entries));
		}
		return this._wordListAPI().update(tmpID, tmpRow)
			.then((pResult) => this._toWordList(this._unwrap(pResult)));
	}

	deleteWordList(pKey)
	{
		let tmpID = this._wordListIDByKey[pKey];
		if (!tmpID) { return Promise.resolve(); }
		return this._wordListAPI().remove(tmpID).then(() => { delete this._wordListIDByKey[pKey]; });
	}

	// ---- prompts ----------------------------------------------------------------

	listPrompts()
	{
		return this._promptAPI().mine()
			.then((pRows) => (pRows || []).map((pRow) => this._toPrompt(pRow)));
	}

	createPrompt(pDraft)
	{
		let tmpDraft = pDraft || {};
		if (!tmpDraft.TypeKey) { return Promise.reject(new Error('A prompt needs a TypeKey.')); }
		let tmpRecord =
		{
			Title: String(tmpDraft.Title || 'Untitled prompt'),
			TypeKey: String(tmpDraft.TypeKey),
			Segments: (tmpDraft.Segments && typeof tmpDraft.Segments === 'object') ? tmpDraft.Segments : {},
			IncludeSegmentHeadings: tmpDraft.IncludeSegmentHeadings !== false
		};
		return this._promptAPI().create(
		{
			Title: tmpRecord.Title.slice(0, 200),
			TypeKey: tmpRecord.TypeKey,
			SegmentsJSON: JSON.stringify(tmpRecord.Segments),
			IncludeSegmentHeadings: tmpRecord.IncludeSegmentHeadings ? 1 : 0,
			Source: this._compileSource(tmpRecord),
			Meta: this._metaForWrite(tmpDraft.Meta)
		}).then((pResult) => this._toPrompt(this._unwrap(pResult)));
	}

	updatePrompt(pKey, pPatch)
	{
		let tmpID = this._promptIDByKey[pKey];
		if (!tmpID) { return Promise.reject(new Error('No prompt with Key ' + pKey)); }
		let tmpPatch = pPatch || {};
		// The editor fires Title / TypeKey / Segments as separate debounced
		// patches that can be in flight together. Serialize saves per prompt and
		// merge each patch against the cached last-known row, so a title-only
		// save can never write back stale segments (and the compiled Source stays
		// complete for version capture).
		let tmpChain = (this._promptSaveChain[pKey] || Promise.resolve()).then(() =>
		{
			let tmpRow = this._promptRowByKey[pKey] || {};
			let tmpMerged =
			{
				Title: (typeof tmpPatch.Title !== 'undefined') ? String(tmpPatch.Title) : (tmpRow.Title || ''),
				TypeKey: (typeof tmpPatch.TypeKey !== 'undefined') ? String(tmpPatch.TypeKey) : (tmpRow.TypeKey || 'freeform'),
				Segments: (typeof tmpPatch.Segments !== 'undefined') ? (tmpPatch.Segments || {}) : (this._parse(tmpRow.SegmentsJSON, {}) || {}),
				IncludeSegmentHeadings: (typeof tmpPatch.IncludeSegmentHeadings !== 'undefined')
					? (tmpPatch.IncludeSegmentHeadings !== false)
					: !(Number(tmpRow.IncludeSegmentHeadings) === 0)
			};
			let tmpUpdate =
			{
				Title: tmpMerged.Title.slice(0, 200),
				TypeKey: tmpMerged.TypeKey,
				SegmentsJSON: JSON.stringify(tmpMerged.Segments),
				IncludeSegmentHeadings: tmpMerged.IncludeSegmentHeadings ? 1 : 0,
				Source: this._compileSource(tmpMerged)
			};
			if (typeof tmpPatch.Meta !== 'undefined') { tmpUpdate.Meta = this._metaForWrite(tmpPatch.Meta); }
			return this._promptAPI().update(tmpID, tmpUpdate)
				.then((pResult) => this._toPrompt(this._unwrap(pResult)));
		});
		// The chain must survive a failed save (the next patch still runs).
		this._promptSaveChain[pKey] = tmpChain.catch(() => { });
		return tmpChain;
	}

	deletePrompt(pKey)
	{
		let tmpID = this._promptIDByKey[pKey];
		if (!tmpID) { return Promise.resolve(); }
		// Soft-delete the prompt, then its generations (mirrors the in-memory
		// provider, which drops a prompt's generated output alongside it).
		return this._promptAPI().remove(tmpID)
			.then(() => this.clearGenerated(pKey))
			.then(() => { delete this._promptIDByKey[pKey]; });
	}

	// ---- generated output ---------------------------------------------------------

	listGenerated(pPromptKey)
	{
		return this._generatedAPI().list()
			.then((pRows) =>
			{
				let tmpGenerated = (pRows || []).map((pRow) => this._toGenerated(pRow))
					.filter((pGen) => !pPromptKey || pGen.PromptKey === pPromptKey);
				let tmpLatestByPrompt = {};
				tmpGenerated.forEach((pGen) =>
				{
					let tmpStamp = pGen.GeneratedAt || 0;
					if (!(pGen.PromptKey in tmpLatestByPrompt) || tmpStamp > tmpLatestByPrompt[pGen.PromptKey]) { tmpLatestByPrompt[pGen.PromptKey] = tmpStamp; }
				});
				tmpGenerated.sort((pA, pB) =>
					(tmpLatestByPrompt[pB.PromptKey] - tmpLatestByPrompt[pA.PromptKey])
					|| String(pA.PromptKey).localeCompare(String(pB.PromptKey))
					|| (pA.Sequence || 0) - (pB.Sequence || 0)
					|| (pA.GeneratedAt || 0) - (pB.GeneratedAt || 0));
				return tmpGenerated;
			});
	}

	createGenerated(pDraft)
	{
		let tmpDraft = pDraft || {};
		let tmpIDPrompt = this._promptIDByKey[tmpDraft.PromptKey];
		if (!tmpIDPrompt) { return Promise.reject(new Error('Generated output needs a PromptKey.')); }
		return this._generatedAPI().create(
		{
			IDPrompt: tmpIDPrompt,
			PromptTitle: String(tmpDraft.PromptTitle || '').slice(0, 200),
			TypeKey: String(tmpDraft.TypeKey || ''),
			Markdown: String(tmpDraft.Markdown || ''),
			Sequence: Number(tmpDraft.Sequence) || 0
		}).then((pResult) => this._toGenerated(this._unwrap(pResult)));
	}

	deleteGenerated(pKey)
	{
		let tmpID = this._generatedIDByKey[pKey];
		if (!tmpID) { return Promise.resolve(); }
		return this._generatedAPI().remove(tmpID).then(() => { delete this._generatedIDByKey[pKey]; });
	}

	clearGenerated(pPromptKey)
	{
		return this.listGenerated(pPromptKey).then((pGenerated) =>
		{
			let fNext = (pIndex) =>
			{
				if (pIndex >= pGenerated.length) { return Promise.resolve(); }
				return this.deleteGenerated(pGenerated[pIndex].Key).then(() => fNext(pIndex + 1));
			};
			return fNext(0);
		});
	}
}

module.exports = PlansheetPromptProvider;

},{"pict-section-prompteditor":292}],624:[function(require,module,exports){
module.exports={
	"Hash": "1990s-website",
	"Name": "1990s Website",
	"Version": "1.0.0",
	"Description": "Classic 90s web: silver-grey and navy with link-blue, or a black GeoCities night with lime and magenta.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#c0c0c0",
					"Dark": "#000000"
				},
				"Secondary": {
					"Light": "#d4d0c8",
					"Dark": "#0a0a0a"
				},
				"Tertiary": {
					"Light": "#cac6be",
					"Dark": "#101010"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#080808"
				},
				"Hover": {
					"Light": "#d8d8d8",
					"Dark": "#0e1a0e"
				},
				"Selected": {
					"Light": "#aab7d6",
					"Dark": "#10401f"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#00ff66"
				},
				"Secondary": {
					"Light": "#1a1a1a",
					"Dark": "#33ff99"
				},
				"Muted": {
					"Light": "#444444",
					"Dark": "#13aa55"
				},
				"Placeholder": {
					"Light": "#777777",
					"Dark": "#0a7a3a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#000080",
					"Dark": "#ff36ff"
				},
				"PrimaryHover": {
					"Light": "#0000c0",
					"Dark": "#ff66ff"
				},
				"Accent": {
					"Light": "#0000ee",
					"Dark": "#00ffff"
				}
			},
			"Border": {
				"Light": "#808080",
				"Dark": "#0a5c2a"
			},
			"Status": {
				"Success": {
					"Light": "#008000",
					"Dark": "#00ff66"
				},
				"Warning": {
					"Light": "#a06000",
					"Dark": "#ffff00"
				},
				"Error": {
					"Light": "#cc0000",
					"Dark": "#ff3366"
				},
				"Info": {
					"Light": "#000080",
					"Dark": "#00ffff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d4d0c8",
					"Dark": "#0a0a0a"
				},
				"Thumb": {
					"Light": "#808080",
					"Dark": "#0a5c2a"
				},
				"Hover": {
					"Light": "#444444",
					"Dark": "#13aa55"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#000080",
					"Dark": "#00ff66"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#000080",
					"Dark": "#ff36ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],625:[function(require,module,exports){
module.exports={
	"Hash": "cyberpunk",
	"Name": "Cyberpunk",
	"Version": "1.0.0",
	"Description": "Neon on deep violet: hot pink and cyan with a mono face; a high-key pink-and-cyan light variant.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#fbf0ff",
					"Dark": "#0d0221"
				},
				"Secondary": {
					"Light": "#f6e6ff",
					"Dark": "#190b33"
				},
				"Tertiary": {
					"Light": "#efd9ff",
					"Dark": "#1f1040"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#130826"
				},
				"Hover": {
					"Light": "#f3e0ff",
					"Dark": "#251447"
				},
				"Selected": {
					"Light": "#f1ccea",
					"Dark": "#431a52"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2a0a3a",
					"Dark": "#e6d6ff"
				},
				"Secondary": {
					"Light": "#5a2a6a",
					"Dark": "#c3b0ee"
				},
				"Muted": {
					"Light": "#7a4a8a",
					"Dark": "#9a86c8"
				},
				"Placeholder": {
					"Light": "#a070b0",
					"Dark": "#6e5b96"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0d0221"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#d6008f",
					"Dark": "#ff2a6d"
				},
				"PrimaryHover": {
					"Light": "#b00075",
					"Dark": "#ff5a8d"
				},
				"Accent": {
					"Light": "#00a3c4",
					"Dark": "#05d9e8"
				}
			},
			"Border": {
				"Light": "#ffb3e6",
				"Dark": "#3a1f6e"
			},
			"Status": {
				"Success": {
					"Light": "#00a86b",
					"Dark": "#3affa3"
				},
				"Warning": {
					"Light": "#c98a00",
					"Dark": "#f9f002"
				},
				"Error": {
					"Light": "#e0306f",
					"Dark": "#ff426f"
				},
				"Info": {
					"Light": "#00a3c4",
					"Dark": "#05d9e8"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f6e6ff",
					"Dark": "#190b33"
				},
				"Thumb": {
					"Light": "#ffb3e6",
					"Dark": "#3a1f6e"
				},
				"Hover": {
					"Light": "#7a4a8a",
					"Dark": "#9a86c8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#ff2a6d",
					"Dark": "#ff2a6d"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#0d0221"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#d6008f",
					"Dark": "#ff2a6d"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],626:[function(require,module,exports){
module.exports={
	"Hash": "high-contrast",
	"Name": "High Contrast",
	"Version": "1.0.0",
	"Description": "Maximum-contrast pair for legibility: black and white with a single bright ink and heavy borders.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#000000"
				},
				"Secondary": {
					"Light": "#f2f2f2",
					"Dark": "#0a0a0a"
				},
				"Tertiary": {
					"Light": "#e8e8e8",
					"Dark": "#141414"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#000000"
				},
				"Hover": {
					"Light": "#ededed",
					"Dark": "#1a1a1a"
				},
				"Selected": {
					"Light": "#bcd0ff",
					"Dark": "#16357a"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#ffffff"
				},
				"Secondary": {
					"Light": "#1a1a1a",
					"Dark": "#e8e8e8"
				},
				"Muted": {
					"Light": "#333333",
					"Dark": "#c8c8c8"
				},
				"Placeholder": {
					"Light": "#666666",
					"Dark": "#9a9a9a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#0b34ff",
					"Dark": "#ffe600"
				},
				"PrimaryHover": {
					"Light": "#0026d6",
					"Dark": "#fff15a"
				},
				"Accent": {
					"Light": "#c00000",
					"Dark": "#00e5ff"
				}
			},
			"Border": {
				"Light": "#000000",
				"Dark": "#ffffff"
			},
			"Status": {
				"Success": {
					"Light": "#0a7a2f",
					"Dark": "#00e676"
				},
				"Warning": {
					"Light": "#9a6500",
					"Dark": "#ffc400"
				},
				"Error": {
					"Light": "#c00000",
					"Dark": "#ff453a"
				},
				"Info": {
					"Light": "#0b34ff",
					"Dark": "#00e5ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f2f2f2",
					"Dark": "#0a0a0a"
				},
				"Thumb": {
					"Light": "#000000",
					"Dark": "#ffffff"
				},
				"Hover": {
					"Light": "#333333",
					"Dark": "#c8c8c8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#0b34ff",
					"Dark": "#ffe600"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#0b34ff",
					"Dark": "#ffe600"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],627:[function(require,module,exports){
module.exports={
	"Hash": "london-subway",
	"Name": "London Subway",
	"Version": "1.0.0",
	"Description": "London Underground signage: corporate blue and roundel red over clean white, with Tube line colours.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#161c2b"
				},
				"Secondary": {
					"Light": "#f1f4f8",
					"Dark": "#1e2638"
				},
				"Tertiary": {
					"Light": "#e9eef4",
					"Dark": "#242e44"
				},
				"Panel": {
					"Light": "#f8fafc",
					"Dark": "#1a2233"
				},
				"Hover": {
					"Light": "#eef2f7",
					"Dark": "#2a3550"
				},
				"Selected": {
					"Light": "#dce6f7",
					"Dark": "#33436e"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#0b1f4d",
					"Dark": "#ffffff"
				},
				"Secondary": {
					"Light": "#34507e",
					"Dark": "#cdd7e6"
				},
				"Muted": {
					"Light": "#5b6b86",
					"Dark": "#9fb0c8"
				},
				"Placeholder": {
					"Light": "#8492a8",
					"Dark": "#6f7f99"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#0019a8",
					"Dark": "#3f74d6"
				},
				"PrimaryHover": {
					"Light": "#001488",
					"Dark": "#5a8ce4"
				},
				"Accent": {
					"Light": "#dc241f",
					"Dark": "#dc241f"
				}
			},
			"Border": {
				"Light": "#dde3ec",
				"Dark": "#30405e"
			},
			"Status": {
				"Success": {
					"Light": "#007229",
					"Dark": "#00a100"
				},
				"Warning": {
					"Light": "#b36305",
					"Dark": "#e0a030"
				},
				"Error": {
					"Light": "#dc241f",
					"Dark": "#dc241f"
				},
				"Info": {
					"Light": "#0098d4",
					"Dark": "#0098d4"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f1f4f8",
					"Dark": "#1e2638"
				},
				"Thumb": {
					"Light": "#dde3ec",
					"Dark": "#30405e"
				},
				"Hover": {
					"Light": "#5b6b86",
					"Dark": "#9fb0c8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#0019a8",
					"Dark": "#dc241f"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#0019a8",
					"Dark": "#3f74d6"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],628:[function(require,module,exports){
module.exports={
	"Hash": "neo-tokyo",
	"Name": "Neo-Tokyo",
	"Version": "1.0.0",
	"Description": "Cinematic deep navy with Akira red and electric blue; a clean daytime navy-and-red light variant.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#eef2f9",
					"Dark": "#0a0e1a"
				},
				"Secondary": {
					"Light": "#e4ebf6",
					"Dark": "#101a30"
				},
				"Tertiary": {
					"Light": "#d9e2f0",
					"Dark": "#16243f"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#0c1322"
				},
				"Hover": {
					"Light": "#e6edf7",
					"Dark": "#1b2c4c"
				},
				"Selected": {
					"Light": "#f6d8dd",
					"Dark": "#55182a"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#0a0e1a",
					"Dark": "#dfe8f7"
				},
				"Secondary": {
					"Light": "#33405a",
					"Dark": "#bccadf"
				},
				"Muted": {
					"Light": "#5a6a85",
					"Dark": "#7689a8"
				},
				"Placeholder": {
					"Light": "#8492a8",
					"Dark": "#566884"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#e60026",
					"Dark": "#ff2d55"
				},
				"PrimaryHover": {
					"Light": "#c00020",
					"Dark": "#ff556f"
				},
				"Accent": {
					"Light": "#1366d6",
					"Dark": "#27a0ff"
				}
			},
			"Border": {
				"Light": "#cfd9ea",
				"Dark": "#1d2c4a"
			},
			"Status": {
				"Success": {
					"Light": "#0a9e88",
					"Dark": "#13e0c4"
				},
				"Warning": {
					"Light": "#b86a00",
					"Dark": "#ffb200"
				},
				"Error": {
					"Light": "#e60026",
					"Dark": "#ff453a"
				},
				"Info": {
					"Light": "#1366d6",
					"Dark": "#27a0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#e4ebf6",
					"Dark": "#101a30"
				},
				"Thumb": {
					"Light": "#cfd9ea",
					"Dark": "#1d2c4a"
				},
				"Hover": {
					"Light": "#5a6a85",
					"Dark": "#7689a8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#e60026",
					"Dark": "#ff2d55"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#e60026",
					"Dark": "#ff2d55"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],629:[function(require,module,exports){
module.exports={
	"Hash": "nostalgia",
	"Name": "Nostalgia",
	"Version": "1.0.0",
	"Description": "Windows 9x: silver chrome, navy title bars and Tahoma in the light; a dim grey scheme in the dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#c0c0c0",
					"Dark": "#3a3a3a"
				},
				"Secondary": {
					"Light": "#c0c0c0",
					"Dark": "#3a3a3a"
				},
				"Tertiary": {
					"Light": "#b8b8b8",
					"Dark": "#444444"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#2a2a2a"
				},
				"Hover": {
					"Light": "#d4d0c8",
					"Dark": "#4a4a4a"
				},
				"Selected": {
					"Light": "#aab7d6",
					"Dark": "#34527d"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#e6e6e6"
				},
				"Secondary": {
					"Light": "#1a1a1a",
					"Dark": "#cccccc"
				},
				"Muted": {
					"Light": "#404040",
					"Dark": "#a0a0a0"
				},
				"Placeholder": {
					"Light": "#707070",
					"Dark": "#7a7a7a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#000080",
					"Dark": "#3a6ea5"
				},
				"PrimaryHover": {
					"Light": "#1066b3",
					"Dark": "#4a82c0"
				},
				"Accent": {
					"Light": "#000080",
					"Dark": "#7aa6e6"
				}
			},
			"Border": {
				"Light": "#808080",
				"Dark": "#202020"
			},
			"Status": {
				"Success": {
					"Light": "#008000",
					"Dark": "#2e7d32"
				},
				"Warning": {
					"Light": "#808000",
					"Dark": "#9a8a00"
				},
				"Error": {
					"Light": "#aa0000",
					"Dark": "#b03030"
				},
				"Info": {
					"Light": "#000080",
					"Dark": "#3a6ea5"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#c0c0c0",
					"Dark": "#3a3a3a"
				},
				"Thumb": {
					"Light": "#808080",
					"Dark": "#202020"
				},
				"Hover": {
					"Light": "#404040",
					"Dark": "#a0a0a0"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#000080",
					"Dark": "#0a246a"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#000080",
					"Dark": "#3a6ea5"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],630:[function(require,module,exports){
module.exports={
	"Hash": "plain",
	"Name": "Plain",
	"Version": "1.0.0",
	"Description": "The least styled: system font, white or near-black ground, hairline borders, one quiet blue accent.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#181818"
				},
				"Secondary": {
					"Light": "#fafafa",
					"Dark": "#1c1c1c"
				},
				"Tertiary": {
					"Light": "#f4f4f4",
					"Dark": "#242424"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#1f1f1f"
				},
				"Hover": {
					"Light": "#f0f0f0",
					"Dark": "#262626"
				},
				"Selected": {
					"Light": "#eef2ff",
					"Dark": "#2a2f3a"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1a1a",
					"Dark": "#e8e8e8"
				},
				"Secondary": {
					"Light": "#3a3a3a",
					"Dark": "#c8c8c8"
				},
				"Muted": {
					"Light": "#737373",
					"Dark": "#9a9a9a"
				},
				"Placeholder": {
					"Light": "#a0a0a0",
					"Dark": "#6a6a6a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#181818"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				},
				"PrimaryHover": {
					"Light": "#1d4ed8",
					"Dark": "#7db0ff"
				},
				"Accent": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				}
			},
			"Border": {
				"Light": "#e5e5e5",
				"Dark": "#2e2e2e"
			},
			"Status": {
				"Success": {
					"Light": "#1a7f37",
					"Dark": "#5fd08a"
				},
				"Warning": {
					"Light": "#9a6700",
					"Dark": "#d6a72a"
				},
				"Error": {
					"Light": "#c0322b",
					"Dark": "#ef6b63"
				},
				"Info": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#fafafa",
					"Dark": "#1c1c1c"
				},
				"Thumb": {
					"Light": "#e5e5e5",
					"Dark": "#2e2e2e"
				},
				"Hover": {
					"Light": "#737373",
					"Dark": "#9a9a9a"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#eef2ff",
					"Dark": "#2a2f3a"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#181818"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],631:[function(require,module,exports){
module.exports={
	"Hash": "plansheet-blueprint",
	"Name": "Blueprint",
	"Version": "1.0.0",
	"Description": "Deep Prussian ground with white-blue linework, the cyanotype a plan sheet becomes. Amber stays measurement ink. A dark theme in every light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#0E315F",
				"Secondary": "#123A6E",
				"Tertiary":  "#16427B",
				"Panel":     "#123A6E",
				"Hover":     "#1A4A85",
				"Selected":  "#1E5494"
			},
			"Text": {
				"Primary":     "#EAF2FC",
				"Secondary":   "#C7D9EF",
				"Muted":       "#9FB8D8",
				"Placeholder": "#6E8AB3"
			},
			"Brand": {
				"Primary":      "#9CC6F5",
				"PrimaryHover": "#B7D7F9",
				"Accent":       "#F2C84B"
			},
			"Border": {
				"Default": "#2F5B99",
				"Light":   "#1D4677",
				"Strong":  "#4E7BB8"
			},
			"Status": {
				"Success": "#6FCB87",
				"Warning": "#F2C84B",
				"Error":   "#F08A7E",
				"Info":    "#9CC6F5"
			},
			"Scrollbar": {
				"Track": "#0B2A52",
				"Thumb": "#275489",
				"Hover": "#3A6AA6"
			},
			"Selection": {
				"Background": "#2A5CA0",
				"Text":       "#EAF2FC"
			},
			"Focus": {
				"Outline": "#9CC6F5"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.5)"
			},
			"Syntax": {
				"Keyword":     "#C678DD",
				"String":      "#98C379",
				"Number":      "#E5C07B",
				"Comment":     "#6E8AB3",
				"Operator":    "#56B6C2",
				"Punctuation": "#C7D9EF",
				"Function":    "#9CC6F5",
				"Variable":    "#E06C75",
				"Type":        "#E5C07B",
				"Builtin":     "#D19A66",
				"Property":    "#E06C75",
				"Tag":         "#E06C75",
				"AttrName":    "#D19A66",
				"AttrValue":   "#98C379"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
				"Display": "'Gorton Perfected', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Display": {
				"Transform": "uppercase",
				"Tracking": "1.5px",
				"Weight": "700"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],632:[function(require,module,exports){
module.exports={
	"Hash": "plansheet-paper",
	"Name": "Drafting Paper",
	"Version": "1.0.0",
	"Description": "White sheet, Staedtler cobalt, ink linework, and a faint non-photo blue cast in the furniture. The daylight drafting table. A light theme in every light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#F6F7F9",
				"Secondary": "#EEF1F4",
				"Tertiary":  "#E4E9EF",
				"Panel":     "#FFFFFF",
				"Hover":     "#E9EDF2",
				"Selected":  "#DCE8F7"
			},
			"Text": {
				"Primary":     "#161A1F",
				"Secondary":   "#3E4650",
				"Muted":       "#5A6470",
				"Placeholder": "#9AA3AE"
			},
			"Brand": {
				"Primary":      "#0A4F9E",
				"PrimaryHover": "#093F80",
				"Accent":       "#B07F0C"
			},
			"Border": {
				"Default": "#CBD3DD",
				"Light":   "#DFE4EA",
				"Strong":  "#9AA6B4"
			},
			"Status": {
				"Success": "#2F7A3C",
				"Warning": "#B07F0C",
				"Error":   "#B23A2E",
				"Info":    "#0A4F9E"
			},
			"Scrollbar": {
				"Track": "#E7EBF0",
				"Thumb": "#C2CBD6",
				"Hover": "#9AA6B4"
			},
			"Selection": {
				"Background": "#C7DCF5",
				"Text":       "#161A1F"
			},
			"Focus": {
				"Outline": "#0A4F9E"
			},
			"Shadow": {
				"Color": "rgba(16, 26, 38, 0.12)"
			},
			"Syntax": {
				"Keyword":     "#8A4FA0",
				"String":      "#3E7E3E",
				"Number":      "#8A5A00",
				"Comment":     "#9AA3AE",
				"Operator":    "#0A4F9E",
				"Punctuation": "#3E4650",
				"Function":    "#0A4F9E",
				"Variable":    "#161A1F",
				"Type":        "#8A5A00",
				"Builtin":     "#8A5A00",
				"Property":    "#B23A2E",
				"Tag":         "#B23A2E",
				"AttrName":    "#8A5A00",
				"AttrValue":   "#3E7E3E"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
				"Display": "'Gorton Perfected', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Display": {
				"Transform": "uppercase",
				"Tracking": "1.5px",
				"Weight": "700"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],633:[function(require,module,exports){
module.exports={
	"Hash": "plansheet",
	"Name": "Plan Sheet",
	"Version": "1.0.0",
	"Description": "The Plansheet default pair: vellum in the light (warm tracing paper, graphite ink, Staedtler cobalt) and night drafting in the dark (neutral graphite ground, brightened cobalt). Amber is measurement ink: it marks dimensions, revisions, and warnings, nothing else.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#F5F0E4", "Dark": "#14171C" },
				"Secondary": { "Light": "#EDE6D6", "Dark": "#1B1F26" },
				"Tertiary":  { "Light": "#E5DCC7", "Dark": "#232830" },
				"Panel":     { "Light": "#FBF8F0", "Dark": "#1B1F26" },
				"Hover":     { "Light": "#ECE4D2", "Dark": "#242A33" },
				"Selected":  { "Light": "#DCE5F2", "Dark": "#243650" }
			},
			"Text": {
				"Primary":     { "Light": "#2B2D2F", "Dark": "#E9ECF0" },
				"Secondary":   { "Light": "#46484A", "Dark": "#C2C8D1" },
				"Muted":       { "Light": "#6C6A60", "Dark": "#98A2AE" },
				"Placeholder": { "Light": "#9A947F", "Dark": "#5F6873" }
			},
			"Brand": {
				"Primary":      { "Light": "#1D5FA8", "Dark": "#4F95E8" },
				"PrimaryHover": { "Light": "#174E8C", "Dark": "#6BA7EE" },
				"Accent":       { "Light": "#A8780E", "Dark": "#F2C84B" }
			},
			"Border": {
				"Default": { "Light": "#CFC6B0", "Dark": "#2E3640" },
				"Light":   { "Light": "#DFD7C4", "Dark": "#262C35" },
				"Strong":  { "Light": "#A89F87", "Dark": "#46505C" }
			},
			"Status": {
				"Success": { "Light": "#2F7A3C", "Dark": "#5FC377" },
				"Warning": { "Light": "#A8780E", "Dark": "#F2C84B" },
				"Error":   { "Light": "#A33B2E", "Dark": "#E8786A" },
				"Info":    { "Light": "#1D5FA8", "Dark": "#5F9FE8" }
			},
			"Scrollbar": {
				"Track": { "Light": "#E7DFCC", "Dark": "#1A1D23" },
				"Thumb": { "Light": "#C9BFA6", "Dark": "#333B46" },
				"Hover": { "Light": "#A89F87", "Dark": "#4A5560" }
			},
			"Selection": {
				"Background": { "Light": "#C9DBF2", "Dark": "#2C4A75" },
				"Text":       { "Light": "#2B2D2F", "Dark": "#E9ECF0" }
			},
			"Focus": {
				"Outline": { "Light": "#1D5FA8", "Dark": "#4F95E8" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(43, 45, 47, 0.14)", "Dark": "rgba(0, 0, 0, 0.5)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#8A4FA0", "Dark": "#C678DD" },
				"String":      { "Light": "#3E7E3E", "Dark": "#98C379" },
				"Number":      { "Light": "#A8780E", "Dark": "#E5C07B" },
				"Comment":     { "Light": "#9A947F", "Dark": "#6E7681" },
				"Operator":    { "Light": "#1D5FA8", "Dark": "#56B6C2" },
				"Punctuation": { "Light": "#46484A", "Dark": "#ABB2BF" },
				"Function":    { "Light": "#1D5FA8", "Dark": "#6BA7EE" },
				"Variable":    { "Light": "#2B2D2F", "Dark": "#E06C75" },
				"Type":        { "Light": "#A8780E", "Dark": "#E5C07B" },
				"Builtin":     { "Light": "#8A5A00", "Dark": "#D19A66" },
				"Property":    { "Light": "#A33B2E", "Dark": "#E06C75" },
				"Tag":         { "Light": "#A33B2E", "Dark": "#E06C75" },
				"AttrName":    { "Light": "#8A5A00", "Dark": "#D19A66" },
				"AttrValue":   { "Light": "#3E7E3E", "Dark": "#98C379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
				"Display": "'Gorton Perfected', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Display": {
				"Transform": "uppercase",
				"Tracking": "1.5px",
				"Weight": "700"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}

},{}],634:[function(require,module,exports){
module.exports={
	"Hash": "southwest-desert-canyon",
	"Name": "Desert Canyon",
	"Version": "1.0.0",
	"Description": "Southwest desert canyon: shadowed red-rock walls after sundown. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#18120e",
				"Secondary": "#221a14",
				"Tertiary": "#2e2018",
				"Panel": "#221a14",
				"Hover": "#3a2a1e",
				"Selected": "#3a2a1e"
			},
			"Text": {
				"Primary": "#d8c8b0",
				"Secondary": "#e8d8c0",
				"Muted": "#a09080",
				"Placeholder": "#685040",
				"OnBrand": "#18120e"
			},
			"Brand": {
				"Primary": "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent": "#18a0a0",
				"AccentHover": "#30b0b0"
			},
			"Border": {
				"Default": "#3a2a1e",
				"Light": "#2e2018",
				"Strong": "#4a3a2e"
			},
			"Status": {
				"Success": "#18a0a0",
				"Warning": "#e0c870",
				"Error": "#e05830",
				"Info": "#18a0a0"
			},
			"Scrollbar": {
				"Track": "#221a14",
				"Thumb": "#3a2a1e",
				"Hover": "#4a3a2e"
			},
			"Selection": {
				"Background": "#3a2a1e",
				"Text": "#e8d8c0"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword": "#E89A6E",
				"String": "#8FD493",
				"Number": "#E8A94D",
				"Comment": "#8E8478",
				"Operator": "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function": "#7FBDD8",
				"Variable": "#E8DCC8",
				"Type": "#E8A94D",
				"Builtin": "#E8A94D",
				"Property": "#E89A6E",
				"Tag": "#E89A6E",
				"AttrName": "#E8A94D",
				"AttrValue": "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#221a14",
				"LineNumberText": "#685040",
				"CurrentLineHighlight": "#2e2018",
				"SelectionBackground": "#3a2a1e",
				"GutterBorder": "#2e2018"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth": "260px",
			"TopbarHeight": "56px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],635:[function(require,module,exports){
module.exports={
	"Hash": "southwest-desert-day",
	"Name": "Desert Day",
	"Version": "1.0.0",
	"Description": "Southwest desert by day: sun-bleached sand and adobe under bright light, with terracotta, turquoise, and sage accents. Single-mode light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#faf6f0",
				"Secondary": "#f0e6d6",
				"Tertiary": "#e8ddd0",
				"Panel": "#ffffff",
				"Hover": "#f0e6d6",
				"Selected": "#e8ddd0"
			},
			"Text": {
				"Primary": "#3d2b1f",
				"Secondary": "#2e1e14",
				"Muted": "#8a7560",
				"Placeholder": "#a09080",
				"OnBrand": "#ffffff"
			},
			"Brand": {
				"Primary": "#5c3d2e",
				"PrimaryHover": "#7a5040",
				"Accent": "#3a8a8c",
				"AccentHover": "#2a7070"
			},
			"Border": {
				"Default": "#e0d0b8",
				"Light": "#e8ddd0",
				"Strong": "#c8b8a0"
			},
			"Status": {
				"Success": "#5a7a30",
				"Warning": "#b08020",
				"Error": "#a03040",
				"Info": "#3a8a8c"
			},
			"Scrollbar": {
				"Track": "#f0e6d6",
				"Thumb": "#d0c0a8",
				"Hover": "#c0b098"
			},
			"Selection": {
				"Background": "#e8ddd0",
				"Text": "#2e1e14"
			},
			"Focus": {
				"Outline": "#c2703e"
			},
			"Shadow": {
				"Color": "rgba(92, 61, 46, 0.10)"
			},
			"Syntax": {
				"Keyword": "#A0532E",
				"String": "#3F8A52",
				"Number": "#A86B00",
				"Comment": "#8A7F72",
				"Operator": "#2E7D74",
				"Punctuation": "#5E5549",
				"Function": "#2E5E96",
				"Variable": "#3D3229",
				"Type": "#A86B00",
				"Builtin": "#A86B00",
				"Property": "#A0532E",
				"Tag": "#A0532E",
				"AttrName": "#A86B00",
				"AttrValue": "#3F8A52"
			},
			"Editor": {
				"LineNumberBackground": "#f0e6d6",
				"LineNumberText": "#a09080",
				"CurrentLineHighlight": "#f5ede0",
				"SelectionBackground": "#e8ddd0",
				"GutterBorder": "#e0d0b8"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth": "260px",
			"TopbarHeight": "56px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],636:[function(require,module,exports){
module.exports={
	"Hash": "southwest-desert-dusk",
	"Name": "Desert Dusk",
	"Version": "1.0.0",
	"Description": "Southwest desert at dusk: a warm tan brand on muted dark desert ground, with a turquoise accent. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1a1714",
				"Secondary": "#252018",
				"Tertiary": "#302818",
				"Panel": "#252018",
				"Hover": "#3a3028",
				"Selected": "#3a3028"
			},
			"Text": {
				"Primary": "#c8b8a0",
				"Secondary": "#d8c8a8",
				"Muted": "#907860",
				"Placeholder": "#706050",
				"OnBrand": "#FFFFFF"
			},
			"Brand": {
				"Primary": "#c4956a",
				"PrimaryHover": "#d4a57a",
				"Accent": "#4a9090",
				"AccentHover": "#5aacac"
			},
			"Border": {
				"Default": "#3a3028",
				"Light": "#302818",
				"Strong": "#4a4038"
			},
			"Status": {
				"Success": "#8a9a5a",
				"Warning": "#c0a050",
				"Error": "#b04050",
				"Info": "#4a9090"
			},
			"Scrollbar": {
				"Track": "#252018",
				"Thumb": "#3a3028",
				"Hover": "#4a4038"
			},
			"Selection": {
				"Background": "#3a3028",
				"Text": "#d8c8a8"
			},
			"Focus": {
				"Outline": "#c4956a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword": "#E89A6E",
				"String": "#8FD493",
				"Number": "#E8A94D",
				"Comment": "#8E8478",
				"Operator": "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function": "#7FBDD8",
				"Variable": "#E8DCC8",
				"Type": "#E8A94D",
				"Builtin": "#E8A94D",
				"Property": "#E89A6E",
				"Tag": "#E89A6E",
				"AttrName": "#E8A94D",
				"AttrValue": "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#252018",
				"LineNumberText": "#706050",
				"CurrentLineHighlight": "#302818",
				"SelectionBackground": "#3a3028",
				"GutterBorder": "#302818"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth": "260px",
			"TopbarHeight": "56px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],637:[function(require,module,exports){
module.exports={
	"Hash": "southwest-desert-sunset",
	"Name": "Desert Sunset",
	"Version": "1.0.0",
	"Description": "Southwest desert at sunset: warm dusk light over dark sand. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1e1610",
				"Secondary": "#2a2018",
				"Tertiary": "#342818",
				"Panel": "#2a2018",
				"Hover": "#3a2e22",
				"Selected": "#3a2e22"
			},
			"Text": {
				"Primary": "#d4c4aa",
				"Secondary": "#e0d0b8",
				"Muted": "#8a7560",
				"Placeholder": "#6a5840",
				"OnBrand": "#1e1610"
			},
			"Brand": {
				"Primary": "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent": "#2a8a8a",
				"AccentHover": "#3a9a9a"
			},
			"Border": {
				"Default": "#3a2e22",
				"Light": "#342818",
				"Strong": "#4a3e32"
			},
			"Status": {
				"Success": "#6a9a3a",
				"Warning": "#d4a46a",
				"Error": "#c44e2a",
				"Info": "#2a8a8a"
			},
			"Scrollbar": {
				"Track": "#2a2018",
				"Thumb": "#3a2e22",
				"Hover": "#4a3e32"
			},
			"Selection": {
				"Background": "#3a2e22",
				"Text": "#e0d0b8"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword": "#E89A6E",
				"String": "#8FD493",
				"Number": "#E8A94D",
				"Comment": "#8E8478",
				"Operator": "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function": "#7FBDD8",
				"Variable": "#E8DCC8",
				"Type": "#E8A94D",
				"Builtin": "#E8A94D",
				"Property": "#E89A6E",
				"Tag": "#E89A6E",
				"AttrName": "#E8A94D",
				"AttrValue": "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#2a2018",
				"LineNumberText": "#6a5840",
				"CurrentLineHighlight": "#342818",
				"SelectionBackground": "#3a2e22",
				"GutterBorder": "#342818"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth": "260px",
			"TopbarHeight": "56px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],638:[function(require,module,exports){
const libPictProvider = require('pict').ServiceProviderBase;

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'SessionExporter',
	Dependencies: []
};

/*
	Pict-Provider-SessionExporter
	-----------------------------
	Two outputs from AppData.Session:
	  - downloadMarkdown(pOptions): triggers a .md file download
	  - printPDF(pOptions): triggers window.print() (CSS @media print rules in views drive layout)

	Options:
	  - includeTools (default: from Layout.ShowTools)
	  - includeAttachments (default: from Layout.ShowAttachments)
	  - includeAgents (default: true)
*/

class PictProviderSessionExporter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
	}

	downloadMarkdown(pOptions)
	{
		let tmpSession = this.fable.AppData && this.fable.AppData.Session;
		if (!tmpSession) return;
		let tmpOpts = this._resolveOptions(pOptions);
		let tmpMd = this.buildMarkdown(tmpSession, tmpOpts);
		let tmpFilename = (tmpSession.Meta.title || 'claude-session').replace(/[^A-Za-z0-9_\- ]/g, '').slice(0, 80) + '.md';
		this._download(tmpFilename, tmpMd, 'text/markdown;charset=utf-8');
	}

	printPDF(pOptions)
	{
		// Print path uses the live DOM + @media print stylesheet rules. We just need the right
		// view-state toggles set first so what's rendered matches what the user wants in the PDF.
		let tmpOpts = this._resolveOptions(pOptions);
		let tmpLayout = this.fable.AppData && this.fable.AppData.Layout;
		let tmpConvView = this.fable.PictApplication && this.fable.PictApplication.pict.views.Conversation;
		if (tmpLayout && tmpConvView)
		{
			let tmpPrevTools = tmpLayout.ShowTools;
			let tmpPrevAttach = tmpLayout.ShowAttachments;
			tmpLayout.ShowTools = !!tmpOpts.includeTools;
			tmpLayout.ShowAttachments = !!tmpOpts.includeAttachments;
			tmpConvView.render();
			// Defer print so DOM updates settle.
			setTimeout(() =>
			{
				window.print();
				tmpLayout.ShowTools = tmpPrevTools;
				tmpLayout.ShowAttachments = tmpPrevAttach;
				tmpConvView.render();
			}, 50);
		}
		else
		{
			window.print();
		}
	}

	buildMarkdown(pSession, pOpts)
	{
		let tmpOut = [];
		tmpOut.push('# ' + (pSession.Meta.title || 'Claude session'));
		tmpOut.push('');
		tmpOut.push('- Session: `' + (pSession.Meta.sessionId || '') + '`');
		if (pSession.Meta.model) tmpOut.push('- Model: `' + pSession.Meta.model + '`');
		tmpOut.push('- Started: ' + (pSession.Meta.createdAt ? new Date(pSession.Meta.createdAt).toISOString() : ''));
		tmpOut.push('- Total wall time: ' + formatDuration(pSession.Stats.totalDurationMs));
		tmpOut.push('- Active: ' + formatDuration(pSession.Stats.activeMs)
			+ ' · Idle: ' + formatDuration(pSession.Stats.idleMs));
		tmpOut.push('- ' + pSession.Stats.promptCount + ' prompts · '
			+ pSession.Stats.toolCallCount + ' tool calls · '
			+ pSession.Stats.agentCount + ' subagents');
		tmpOut.push('');

		let tmpRenderedPrompts = {};
		let tmpPromptIdx = 0;
		for (let i = 0; i < pSession.Turns.length; i++)
		{
			let tmpT = pSession.Turns[i];
			if (tmpT.Kind === 'gap')
			{
				tmpOut.push('');
				tmpOut.push('---');
				tmpOut.push('*Idle ' + formatDuration(tmpT.DurationMs) + '*');
				tmpOut.push('---');
				tmpOut.push('');
				continue;
			}
			if (tmpT.Kind === 'attachment' && !pOpts.includeAttachments) continue;
			if (tmpT.Kind === 'system' && !pOpts.includeAttachments) continue;
			if (tmpT.Kind === 'tool-result' && !pOpts.includeTools) continue;
			if (tmpT.Kind === 'assistant' && tmpT.IsIntermediary && !pOpts.includeIntermediaries) continue;

			if (tmpT.PromptId && !tmpRenderedPrompts[tmpT.PromptId])
			{
				tmpRenderedPrompts[tmpT.PromptId] = true;
				tmpPromptIdx++;
				let tmpGroup = pSession.Prompts.find((pG) => pG.PromptId === tmpT.PromptId);
				if (tmpGroup)
				{
					tmpOut.push('');
					tmpOut.push('## Prompt #' + tmpPromptIdx + ' — ' + (tmpGroup.Title || ''));
					tmpOut.push('*' + new Date(tmpGroup.FirstTimestampMs).toISOString()
						+ ' · ' + formatDuration(tmpGroup.TotalDurationMs)
						+ ' · ' + tmpGroup.ToolCallCount + ' tools'
						+ (tmpGroup.AgentCallCount ? ' · ' + tmpGroup.AgentCallCount + ' agents' : '')
						+ '*');
					tmpOut.push('');
				}
			}

			let tmpKindLabel = ({
				'user-prompt': '### User',
				'assistant':   '### Assistant',
				'tool-result': '#### Tool result',
				'attachment':  '#### Attachment',
				'system':      '#### System'
			})[tmpT.Kind] || ('#### ' + tmpT.Kind);
			tmpOut.push(tmpKindLabel + ' — `' + (tmpT.Timestamp || '') + '`');
			tmpOut.push('');

			for (let j = 0; j < tmpT.Blocks.length; j++)
			{
				let tmpB = tmpT.Blocks[j];
				if (tmpB.Type === 'text')
				{
					tmpOut.push(tmpB.Text || '');
					tmpOut.push('');
				}
				else if (tmpB.Type === 'thinking')
				{
					if (pOpts.includeAttachments)
					{
						tmpOut.push('> *thinking:* ' + (tmpB.Text || '').replace(/\n/g, '\n> '));
						tmpOut.push('');
					}
				}
				else if (tmpB.Type === 'tool_use')
				{
					if (!pOpts.includeTools) continue;
					tmpOut.push('- 🛠 **' + tmpB.Name + '**'
						+ (tmpB.InputSummary ? ' — `' + tmpB.InputSummary.replace(/`/g, '\\`') + '`' : ''));
				}
				else if (tmpB.Type === 'tool_result')
				{
					if (!pOpts.includeTools) continue;
					let tmpDur = tmpB.DurationMs != null ? ' (' + formatDuration(tmpB.DurationMs) + ')' : '';
					tmpOut.push('  - result' + tmpDur + ':');
					tmpOut.push('    ```');
					let tmpLines = (tmpB.ContentText || '').split('\n').slice(0, 40);
					for (let k = 0; k < tmpLines.length; k++) tmpOut.push('    ' + tmpLines[k]);
					if (tmpB.ContentTruncated) tmpOut.push('    [truncated]');
					tmpOut.push('    ```');
				}
				else if (tmpB.Type === 'attachment')
				{
					if (!pOpts.includeAttachments) continue;
					tmpOut.push('*[attachment: ' + tmpB.AttachmentType + ' — ' + (tmpB.Summary || '') + ']*');
				}
			}
			tmpOut.push('');
		}

		if (pOpts.includeAgents && pSession.Agents)
		{
			let tmpAgentIds = Object.keys(pSession.Agents);
			if (tmpAgentIds.length)
			{
				tmpOut.push('');
				tmpOut.push('---');
				tmpOut.push('## Subagent transcripts');
				for (let i = 0; i < tmpAgentIds.length; i++)
				{
					let tmpAg = pSession.Agents[tmpAgentIds[i]];
					tmpOut.push('');
					tmpOut.push('### ' + tmpAg.AgentType + ' (' + formatDuration(tmpAg.DurationMs) + ')');
					tmpOut.push('*' + (tmpAg.Description || '') + '*');
					for (let j = 0; j < tmpAg.Turns.length; j++)
					{
						let tmpT = tmpAg.Turns[j];
						for (let k = 0; k < tmpT.Blocks.length; k++)
						{
							let tmpB = tmpT.Blocks[k];
							if (tmpB.Type === 'text') { tmpOut.push(''); tmpOut.push(tmpB.Text || ''); }
							else if (tmpB.Type === 'tool_use') tmpOut.push('  - 🛠 ' + tmpB.Name + (tmpB.InputSummary ? ': `' + tmpB.InputSummary + '`' : ''));
						}
					}
				}
			}
		}

		return tmpOut.join('\n');
	}

	_resolveOptions(pOptions)
	{
		let tmpL = (this.fable.AppData && this.fable.AppData.Layout) || {};
		return Object.assign({
			includeTools: tmpL.ShowTools !== false,
			includeAttachments: !!tmpL.ShowAttachments,
			includeIntermediaries: tmpL.ShowIntermediaries !== false,
			includeAgents: true
		}, pOptions || {});
	}

	_download(pFilename, pContent, pMime)
	{
		let tmpBlob = new Blob([pContent], { type: pMime });
		let tmpUrl = URL.createObjectURL(tmpBlob);
		let tmpA = document.createElement('a');
		tmpA.href = tmpUrl;
		tmpA.download = pFilename;
		document.body.appendChild(tmpA);
		tmpA.click();
		setTimeout(() => { document.body.removeChild(tmpA); URL.revokeObjectURL(tmpUrl); }, 100);
	}
}

function formatDuration(pMs)
{
	if (!pMs || pMs < 0) return '0s';
	let tmpS = Math.floor(pMs / 1000);
	if (tmpS < 60) return tmpS + 's';
	let tmpM = Math.floor(tmpS / 60);
	if (tmpM < 60) return tmpM + 'm ' + (tmpS % 60) + 's';
	let tmpH = Math.floor(tmpM / 60);
	if (tmpH < 24) return tmpH + 'h ' + (tmpM % 60) + 'm';
	let tmpD = Math.floor(tmpH / 24);
	return tmpD + 'd ' + (tmpH % 24) + 'h';
}

module.exports = PictProviderSessionExporter;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict":375}],639:[function(require,module,exports){
const libPictProvider = require('pict').ServiceProviderBase;

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'SessionParser',
	Dependencies: []
};

/*
	Pict-Provider-SessionParser
	---------------------------
	Pure transform: raw JSONL records (and optional sidecar files) → a
	normalized Session model placed at AppData.Session.

	Inputs:
		.parseJSONLText(pText, pSidecars)      // single .jsonl string + optional sidecars map
		.parseZip(pArrayBuffer)                // export .zip arraybuffer (uses JSZip in browser)
		.parseFiles(pFileList)                 // browser FileList (jsonl, zip, or expanded export folder)

	The "Session" model written to AppData.Session has shape:
		{
			Meta:    { sessionId, title, model, cwd, createdAt, lastActivityAt, version, ... },
			Turns:   [ Turn ... ]                  // chronological top-level events for the main thread
			Prompts: [ PromptGroup ... ]           // grouped by promptId
			Agents:  { <agentId>: AgentTranscript }
			Stats:   { totalDurationMs, idleMs, activeMs, toolCallCount, promptCount, agentCount, longestGapMs }
		}

	A "Turn" is a normalized item ready for the conversation view:
		{
			Kind:        'user-prompt' | 'assistant' | 'tool-result' | 'attachment' | 'system' | 'gap' | 'title',
			Uuid, ParentUuid, PromptId, Timestamp (ISO), TimestampMs,
			DurationFromPrevMs,                    // gap from previous Turn (used to render "idle 5h")
			Blocks:      [ Block ... ],            // text/thinking/tool_use/tool_result/image/etc.
			ToolUseIds:  [ ... ],                  // ids of tool_use blocks emitted in this turn
			Raw:         <original record>,        // kept for drill-in/debug; trimmed of huge content
		}

	A "PromptGroup" wraps everything caused by one user prompt:
		{
			PromptId, Title, FirstTimestampMs, LastTimestampMs, ResponseLatencyMs,
			TotalDurationMs, IdleAfterMs, ToolCallCount, AgentCallCount,
			TurnIndices: [...],                    // indices into Session.Turns
		}
*/

const _MaxInlineToolResultPreview = 8000;          // chars kept inline before we offer "open full"
const _MinIdleGapMs = 60 * 1000;                   // visual gap threshold: shorter pauses don't render in the timeline
const _StandbyThresholdMs = 5 * 60 * 1000;         // stats threshold: gaps under this count as "you working" (typing/reading), over count as standby (AFK)

class PictProviderSessionParser extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this._JSZip = null;                           // lazy: only needed for zip parsing
	}

	// ---------------------------------------------------------------------
	// Top-level entry points
	// ---------------------------------------------------------------------

	parseFiles(pFileList, fCallback)
	{
		let tmpFiles = Array.from(pFileList || []);
		if (tmpFiles.length === 0)
		{
			return fCallback(new Error('No files supplied.'));
		}

		// Single zip file?
		if (tmpFiles.length === 1 && /\.zip$/i.test(tmpFiles[0].name))
		{
			return this._readFileAsArrayBuffer(tmpFiles[0], (pErr, pBuf) =>
			{
				if (pErr) return fCallback(pErr);
				return this.parseZip(pBuf, fCallback);
			});
		}

		// Single jsonl file?
		if (tmpFiles.length === 1 && /\.jsonl$/i.test(tmpFiles[0].name))
		{
			return this._readFileAsText(tmpFiles[0], (pErr, pText) =>
			{
				if (pErr) return fCallback(pErr);
				return this.parseJSONLText(pText, {}, fCallback);
			});
		}

		// A whole expanded export folder dragged in. Find the .jsonl and gather the
		// tool-results/ + subagents/ siblings by relative path.
		return this._parseDroppedFolder(tmpFiles, fCallback);
	}

	parseZip(pArrayBuffer, fCallback)
	{
		let tmpJSZip = this._loadJSZip();
		if (!tmpJSZip)
		{
			return fCallback(new Error('JSZip not available in this environment.'));
		}

		tmpJSZip.loadAsync(pArrayBuffer).then((pZip) =>
		{
			let tmpJsonlEntry = null;
			let tmpToolResults = {};                         // key (filename without dir) → string
			let tmpSubagents = {};                            // agentId → { Meta, Lines: [...] }
			let tmpMetadata = null;
			let tmpReads = [];

			pZip.forEach((pPath, pEntry) =>
			{
				if (pEntry.dir) return;
				if (/\.jsonl$/i.test(pPath) && pPath.indexOf('/subagents/') === -1)
				{
					tmpJsonlEntry = pEntry;
					return;
				}
				if (/\/metadata\.json$/i.test(pPath))
				{
					tmpReads.push(pEntry.async('string').then((pText) => { try { tmpMetadata = JSON.parse(pText); } catch(e){} }));
					return;
				}
				if (pPath.indexOf('/tool-results/') !== -1 && /\.txt$/i.test(pPath))
				{
					let tmpKey = pPath.split('/').pop();
					tmpReads.push(pEntry.async('string').then((pText) => { tmpToolResults[tmpKey] = pText; }));
					return;
				}
				let tmpAgentMatch = pPath.match(/\/subagents\/agent-([^./]+)(\.meta\.json|\.jsonl)$/i);
				if (tmpAgentMatch)
				{
					let tmpAgentId = tmpAgentMatch[1];
					let tmpKind = tmpAgentMatch[2];
					tmpSubagents[tmpAgentId] = tmpSubagents[tmpAgentId] || { Meta: null, Text: '' };
					if (tmpKind === '.meta.json')
					{
						tmpReads.push(pEntry.async('string').then((pText) => { try { tmpSubagents[tmpAgentId].Meta = JSON.parse(pText); } catch(e){} }));
					}
					else
					{
						tmpReads.push(pEntry.async('string').then((pText) => { tmpSubagents[tmpAgentId].Text = pText; }));
					}
				}
			});

			if (!tmpJsonlEntry)
			{
				return fCallback(new Error('No .jsonl found in zip.'));
			}

			tmpReads.push(tmpJsonlEntry.async('string').then((pText) =>
			{
				let tmpSidecars = { ToolResults: tmpToolResults, Subagents: tmpSubagents, Metadata: tmpMetadata };
				return this.parseJSONLText(pText, tmpSidecars, fCallback);
			}));

			return Promise.all(tmpReads).catch((pErr) => fCallback(pErr));
		}).catch((pErr) => fCallback(pErr));
	}

	parseJSONLText(pText, pSidecars, fCallback)
	{
		try
		{
			let tmpSidecars = pSidecars || {};
			let tmpRecords = this._parseJSONL(pText);
			let tmpSession = this._buildSession(tmpRecords, tmpSidecars);
			this.fable.AppData = this.fable.AppData || {};
			this.fable.AppData.Session = tmpSession;
			return fCallback(null, tmpSession);
		}
		catch (pError)
		{
			return fCallback(pError);
		}
	}

	// ---------------------------------------------------------------------
	// Building the session from raw records
	// ---------------------------------------------------------------------

	_parseJSONL(pText)
	{
		let tmpRecords = [];
		let tmpLines = pText.split(/\r?\n/);
		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];
			if (!tmpLine || !tmpLine.trim()) continue;
			try
			{
				tmpRecords.push(JSON.parse(tmpLine));
			}
			catch (pError)
			{
				// Tolerate a malformed line — surface a placeholder so the user can see something went wrong.
				tmpRecords.push({ type: 'parse-error', error: pError.message, raw: tmpLine.slice(0, 300) });
			}
		}
		return tmpRecords;
	}

	_buildSession(pRecords, pSidecars)
	{
		let tmpToolResults = (pSidecars.ToolResults) || {};
		let tmpSubagents = (pSidecars.Subagents) || {};
		let tmpMetadata = pSidecars.Metadata || null;

		// Index assistant tool_use blocks so we can resolve durations when we see results.
		let tmpToolUseIndex = {};                             // toolUseId → { Name, StartedMs, AgentId|null }

		let tmpTurns = [];
		let tmpTitle = null;
		let tmpFirstMs = null;
		let tmpLastMs = null;

		for (let i = 0; i < pRecords.length; i++)
		{
			let tmpRec = pRecords[i];
			let tmpType = tmpRec.type;

			if (tmpType === 'ai-title' && tmpRec.aiTitle)
			{
				tmpTitle = tmpRec.aiTitle;
				continue;
			}
			if (tmpType === 'queue-operation' || tmpType === 'last-prompt' || tmpType === 'parse-error')
			{
				continue;
			}

			let tmpTimestampMs = this._parseTimestampMs(tmpRec.timestamp);
			if (tmpTimestampMs && (!tmpFirstMs || tmpTimestampMs < tmpFirstMs)) tmpFirstMs = tmpTimestampMs;
			if (tmpTimestampMs && (!tmpLastMs  || tmpTimestampMs > tmpLastMs )) tmpLastMs = tmpTimestampMs;

			if (tmpRec.isSidechain)
			{
				// Sidechain records also appear in subagent jsonl files; we render those separately.
				continue;
			}

			let tmpTurn = this._normalizeRecord(tmpRec, tmpToolUseIndex, tmpToolResults);
			if (tmpTurn) tmpTurns.push(tmpTurn);
		}

		// Sort by timestamp (records *should* already be ordered, but defensively).
		tmpTurns.sort((pA, pB) => (pA.TimestampMs || 0) - (pB.TimestampMs || 0));

		// Carry a "current promptId" forward to turns that don't carry one themselves.
		// Assistant records in Claude Code's JSONL carry NO promptId — only user records do — so
		// without this every assistant turn would be excluded from prompt grouping (and from the
		// final-reply / intermediary tagging that depends on the group).
		let tmpCurrentPromptId = null;
		for (let i = 0; i < tmpTurns.length; i++)
		{
			let tmpT = tmpTurns[i];
			if (tmpT.PromptId)
			{
				tmpCurrentPromptId = tmpT.PromptId;
			}
			else if (tmpCurrentPromptId)
			{
				tmpT.PromptId = tmpCurrentPromptId;
			}
		}

		// Compute gaps and inject gap turns where idle time is meaningful.
		// "Real" turns for gap purposes = anything that isn't background noise (attachment/system).
		// In real sessions, attachment + stop_hook_summary records get emitted between turns and
		// would otherwise mask the actual idle time between an assistant finishing and the user
		// replying. So we look past those when checking whether a gap is human-facing.
		let tmpWithGaps = [];
		let tmpPrevMs = null;
		let tmpPrevReal = null;
		for (let i = 0; i < tmpTurns.length; i++)
		{
			let tmpT = tmpTurns[i];
			if (tmpPrevMs && tmpT.TimestampMs)
			{
				let tmpDelta = tmpT.TimestampMs - tmpPrevMs;
				tmpT.DurationFromPrevMs = tmpDelta;
				if (tmpDelta >= _MinIdleGapMs && this._isHumanFacingGap(tmpPrevReal, tmpT))
				{
					tmpWithGaps.push({
						Kind: 'gap',
						TimestampMs: tmpPrevMs,
						EndTimestampMs: tmpT.TimestampMs,
						DurationMs: tmpDelta,
						Blocks: []
					});
				}
			}
			tmpWithGaps.push(tmpT);
			tmpPrevMs = tmpT.TimestampMs || tmpPrevMs;
			if (tmpT.Kind !== 'attachment' && tmpT.Kind !== 'system') tmpPrevReal = tmpT;
		}

		// Build prompt groups (everything caused by a single user prompt).
		let tmpPromptOrder = [];
		let tmpPromptMap = {};
		for (let i = 0; i < tmpWithGaps.length; i++)
		{
			let tmpT = tmpWithGaps[i];
			if (!tmpT.PromptId) continue;
			let tmpGroup = tmpPromptMap[tmpT.PromptId];
			if (!tmpGroup)
			{
				tmpGroup = {
					PromptId: tmpT.PromptId,
					Title: '',
					FirstTimestampMs: tmpT.TimestampMs,
					LastTimestampMs: tmpT.TimestampMs,
					ResponseLatencyMs: null,
					TotalDurationMs: 0,
					IdleAfterMs: 0,
					ToolCallCount: 0,
					AgentCallCount: 0,
					TurnIndices: []
				};
				tmpPromptMap[tmpT.PromptId] = tmpGroup;
				tmpPromptOrder.push(tmpT.PromptId);
			}
			tmpGroup.TurnIndices.push(i);
			if (tmpT.TimestampMs)
			{
				if (tmpT.TimestampMs < tmpGroup.FirstTimestampMs) tmpGroup.FirstTimestampMs = tmpT.TimestampMs;
				if (tmpT.TimestampMs > tmpGroup.LastTimestampMs)  tmpGroup.LastTimestampMs  = tmpT.TimestampMs;
			}
			if (tmpT.Kind === 'user-prompt' && !tmpGroup.Title)
			{
				let tmpUserText = this._extractPromptText(tmpT);
				if (tmpUserText)
				{
					tmpGroup.Title = this._summarizeText(tmpUserText, 90);
				}
				else if (tmpT.HarnessReminders && tmpT.HarnessReminders.length)
				{
					// Harness-only prompt — synthesize a title from the first reminder so it doesn't
					// render as a blank row in the timeline rail.
					tmpGroup.Title = '⚙ ' + this._summarizeText(tmpT.HarnessReminders[0].Body, 80);
					tmpGroup.IsHarnessOnly = true;
				}
			}
			if (tmpT.Kind === 'assistant')
			{
				tmpGroup.ToolCallCount += (tmpT.ToolUseIds || []).length;
				if (tmpGroup.ResponseLatencyMs == null)
				{
					// Latency = first assistant-turn timestamp − first user-prompt timestamp in this group.
					let tmpFirstUser = null;
					for (let j = 0; j < tmpGroup.TurnIndices.length; j++)
					{
						let tmpInner = tmpWithGaps[tmpGroup.TurnIndices[j]];
						if (tmpInner.Kind === 'user-prompt') { tmpFirstUser = tmpInner; break; }
					}
					if (tmpFirstUser && tmpFirstUser.TimestampMs && tmpT.TimestampMs)
					{
						tmpGroup.ResponseLatencyMs = tmpT.TimestampMs - tmpFirstUser.TimestampMs;
					}
				}
			}
			if (tmpT.AgentId) tmpGroup.AgentCallCount += 1;
		}
		// Finalize totals.
		for (let i = 0; i < tmpPromptOrder.length; i++)
		{
			let tmpG = tmpPromptMap[tmpPromptOrder[i]];
			tmpG.TotalDurationMs = (tmpG.LastTimestampMs && tmpG.FirstTimestampMs)
				? tmpG.LastTimestampMs - tmpG.FirstTimestampMs : 0;
		}

		// Tag final-reply vs intermediary on each assistant turn within a prompt group.
		// "Final reply" = the LAST assistant turn in the group that contains non-empty text.
		// "Intermediary" = any earlier assistant turn that also contains non-empty text (the chatter
		// the agent emits while working: "I'll start by exploring…", "Now let me read X.", etc.).
		// Assistant turns that are pure tool_use carriers (no text) are neither — they're tool plumbing.
		let tmpHasMeaningfulText = (pTurn) =>
		{
			if (!pTurn.Blocks) return false;
			for (let k = 0; k < pTurn.Blocks.length; k++)
			{
				let tmpBlk = pTurn.Blocks[k];
				if (tmpBlk.Type === 'text' && tmpBlk.Text && tmpBlk.Text.trim()) return true;
			}
			return false;
		};
		let tmpHasToolUse = (pTurn) =>
		{
			if (!pTurn.Blocks) return false;
			for (let k = 0; k < pTurn.Blocks.length; k++)
			{
				if (pTurn.Blocks[k].Type === 'tool_use') return true;
			}
			return false;
		};
		// Mark assistant turns that are pure tool plumbing (only tool_use blocks, no meaningful text).
		// These should hide along with the tools toggle, since they are not part of the conversation.
		// Also mark turns whose only payload is a `thinking` block (often an encrypted-signature-only
		// thinking record produced by extended-thinking models) — these would otherwise render as
		// empty cards because the inner thinking body is gated by the attachments toggle. Hiding the
		// wrapper under the same toggle keeps the conversation pane clean by default.
		let tmpHasThinking = (pTurn) =>
		{
			if (!pTurn.Blocks) return false;
			for (let k = 0; k < pTurn.Blocks.length; k++)
			{
				if (pTurn.Blocks[k].Type === 'thinking') return true;
			}
			return false;
		};
		for (let i = 0; i < tmpWithGaps.length; i++)
		{
			let tmpTurnRef = tmpWithGaps[i];
			if (tmpTurnRef.Kind !== 'assistant') continue;
			tmpTurnRef.IsToolOnly = !tmpHasMeaningfulText(tmpTurnRef) && tmpHasToolUse(tmpTurnRef);
			tmpTurnRef.IsThinkingOnly = !tmpHasMeaningfulText(tmpTurnRef) && !tmpHasToolUse(tmpTurnRef) && tmpHasThinking(tmpTurnRef);
			// Catch the truly empty case too (no text, no tool_use, no thinking) — e.g. a stop-only
			// assistant message — and treat it the same so it doesn't ghost the layout.
			if (!tmpHasMeaningfulText(tmpTurnRef) && !tmpHasToolUse(tmpTurnRef) && !tmpHasThinking(tmpTurnRef))
			{
				tmpTurnRef.IsThinkingOnly = true;
			}
		}
		for (let i = 0; i < tmpPromptOrder.length; i++)
		{
			let tmpG = tmpPromptMap[tmpPromptOrder[i]];
			let tmpFinalTurnIdx = -1;
			for (let j = tmpG.TurnIndices.length - 1; j >= 0; j--)
			{
				let tmpTurnRef = tmpWithGaps[tmpG.TurnIndices[j]];
				if (tmpTurnRef.Kind === 'assistant' && tmpHasMeaningfulText(tmpTurnRef))
				{
					tmpFinalTurnIdx = tmpG.TurnIndices[j];
					break;
				}
			}
			for (let j = 0; j < tmpG.TurnIndices.length; j++)
			{
				let tmpTurnRef = tmpWithGaps[tmpG.TurnIndices[j]];
				if (tmpTurnRef.Kind !== 'assistant') continue;
				if (tmpG.TurnIndices[j] === tmpFinalTurnIdx)
				{
					tmpTurnRef.IsFinalReply = true;
					tmpTurnRef.IsIntermediary = false;
				}
				else
				{
					tmpTurnRef.IsFinalReply = false;
					tmpTurnRef.IsIntermediary = tmpHasMeaningfulText(tmpTurnRef);
				}
			}
		}

		// Subagents → normalized agent transcripts.
		let tmpAgents = {};
		let tmpAgentIds = Object.keys(tmpSubagents);
		for (let i = 0; i < tmpAgentIds.length; i++)
		{
			let tmpAgentId = tmpAgentIds[i];
			let tmpRaw = tmpSubagents[tmpAgentId];
			tmpAgents[tmpAgentId] = this._buildAgentTranscript(tmpAgentId, tmpRaw, tmpToolResults);
		}

		// Stats.
		// Engaged-time accounting: walk turn-to-turn deltas and attribute each one to either Claude
		// (the model was generating, or a tool was running) or you (you were typing/reading the
		// previous reply). Idle gaps are already extracted as their own kind='gap' turns and counted
		// separately in tmpIdleMs.
		let tmpToolCount = 0;
		let tmpIdleMs = 0;
		let tmpLongestGap = 0;
		let tmpClaudeMs = 0;
		let tmpUserMs = 0;
		let tmpChatterCount = 0;          // IsIntermediary assistant turns
		let tmpAttachmentItemCount = 0;   // everything controlled by the attachments toggle
		let tmpPrevAttribMs = null;
		for (let i = 0; i < tmpWithGaps.length; i++)
		{
			let tmpT = tmpWithGaps[i];
			if (tmpT.Kind === 'gap')
			{
				let tmpDur = tmpT.DurationMs || 0;
				if (tmpDur >= _StandbyThresholdMs)
				{
					// Long pause — count as standby (AFK time).
					tmpIdleMs += tmpDur;
				}
				else
				{
					// Short pause between prompts — credit as you-working (reading + composing).
					tmpUserMs += tmpDur;
				}
				if (tmpDur > tmpLongestGap) tmpLongestGap = tmpDur;
				// Reset prev so the gap span doesn't get re-counted on the next delta.
				tmpPrevAttribMs = tmpT.EndTimestampMs || null;
				continue;
			}
			if (tmpT.Kind === 'assistant') tmpToolCount += (tmpT.ToolUseIds || []).length;

			// Visibility-toggle counts: how many things each toggle would hide.
			if (tmpT.Kind === 'assistant' && tmpT.IsIntermediary) tmpChatterCount++;
			if (tmpT.Kind === 'attachment' || tmpT.Kind === 'system') tmpAttachmentItemCount++;
			if (tmpT.Kind === 'assistant' && tmpT.IsThinkingOnly)  tmpAttachmentItemCount++;
			if (tmpT.Kind === 'user-prompt' && tmpT.IsHarnessOnly) tmpAttachmentItemCount++;
			// Inline thinking blocks inside otherwise-visible assistant turns.
			if (tmpT.Kind === 'assistant' && !tmpT.IsThinkingOnly && tmpT.Blocks)
			{
				for (let b = 0; b < tmpT.Blocks.length; b++)
				{
					if (tmpT.Blocks[b].Type === 'thinking') tmpAttachmentItemCount++;
				}
			}
			// Inline harness reminders embedded in user prompts that ALSO have user text.
			if (tmpT.Kind === 'user-prompt' && !tmpT.IsHarnessOnly && tmpT.HarnessReminders)
			{
				tmpAttachmentItemCount += tmpT.HarnessReminders.length;
			}

			if (tmpPrevAttribMs && tmpT.TimestampMs)
			{
				let tmpDelta = tmpT.TimestampMs - tmpPrevAttribMs;
				if (tmpDelta > 0)
				{
					// Time leading INTO this turn belongs to whichever side caused it.
					// Assistant turns and tool-result turns are Claude-side (Claude generated,
					// or Claude orchestrated a tool that ran). User-prompts are you-side (you
					// were composing the next message). Attachments / system records are noise —
					// don't credit either side for them.
					if (tmpT.Kind === 'assistant' || tmpT.Kind === 'tool-result')
					{
						tmpClaudeMs += tmpDelta;
					}
					else if (tmpT.Kind === 'user-prompt')
					{
						tmpUserMs += tmpDelta;
					}
				}
			}
			if (tmpT.TimestampMs) tmpPrevAttribMs = tmpT.TimestampMs;
		}
		let tmpTotalDurationMs = (tmpFirstMs && tmpLastMs) ? tmpLastMs - tmpFirstMs : 0;
		let tmpEngagedMs = Math.max(0, tmpTotalDurationMs - tmpIdleMs);

		let tmpMeta = Object.assign(
			{
				title: tmpTitle || (tmpMetadata && tmpMetadata.title) || 'Untitled session',
				sessionId: tmpMetadata && tmpMetadata.cliSessionId,
				createdAt: tmpFirstMs,
				lastActivityAt: tmpLastMs
			},
			tmpMetadata || {}
		);

		return {
			Meta: tmpMeta,
			Turns: tmpWithGaps,
			Prompts: tmpPromptOrder.map((pId) => tmpPromptMap[pId]),
			Agents: tmpAgents,
			Stats:
			{
				totalDurationMs: tmpTotalDurationMs,
				idleMs: tmpIdleMs,                     // legacy alias for standby
				standbyMs: tmpIdleMs,
				engagedMs: tmpEngagedMs,               // total - standby
				activeMs: tmpEngagedMs,                // legacy alias
				claudeWorkingMs: tmpClaudeMs,
				userWorkingMs: tmpUserMs,
				toolCallCount: tmpToolCount,
				promptCount: tmpPromptOrder.length,
				agentCount: Object.keys(tmpAgents).length,
				longestGapMs: tmpLongestGap,
				chatterCount: tmpChatterCount,
				attachmentItemCount: tmpAttachmentItemCount
			}
		};
	}

	// ---------------------------------------------------------------------
	// Per-record normalization
	// ---------------------------------------------------------------------

	_normalizeRecord(pRec, pToolUseIndex, pToolResults)
	{
		let tmpType = pRec.type;
		let tmpTimestampMs = this._parseTimestampMs(pRec.timestamp);
		let tmpBase =
		{
			Uuid:        pRec.uuid || null,
			ParentUuid:  pRec.parentUuid || null,
			PromptId:    pRec.promptId || null,
			Timestamp:   pRec.timestamp || null,
			TimestampMs: tmpTimestampMs,
			DurationFromPrevMs: 0,
			Blocks:      [],
			ToolUseIds:  [],
			AgentId:     null,
			Raw:         null
		};

		if (tmpType === 'attachment')
		{
			let tmpAttach = pRec.attachment || {};
			tmpBase.Kind = 'attachment';
			tmpBase.Blocks.push({
				Type: 'attachment',
				AttachmentType: tmpAttach.type || 'unknown',
				Summary: this._summarizeAttachment(tmpAttach),
				Detail: tmpAttach
			});
			return tmpBase;
		}

		if (tmpType === 'system')
		{
			tmpBase.Kind = 'system';
			tmpBase.Blocks.push({
				Type: 'system',
				Subtype: pRec.subtype || 'system',
				Summary: this._summarizeSystem(pRec)
			});
			return tmpBase;
		}

		if (tmpType === 'user')
		{
			let tmpContent = pRec.message && pRec.message.content;
			// Pure text user prompt
			if (typeof tmpContent === 'string')
			{
				tmpBase.Kind = 'user-prompt';
				let tmpExtracted = this._extractHarnessTags(tmpContent);
				if (tmpExtracted.UserText)
				{
					tmpBase.Blocks.push({ Type: 'text', Text: tmpExtracted.UserText });
				}
				if (tmpExtracted.Reminders.length)
				{
					tmpBase.HarnessReminders = tmpExtracted.Reminders;
				}
				tmpBase.IsHarnessOnly = !tmpExtracted.UserText && tmpExtracted.Reminders.length > 0;
				return tmpBase;
			}
			// Array form: tool_results, image, etc.
			if (Array.isArray(tmpContent))
			{
				let tmpHasToolResult = false;
				let tmpHasUserText = false;
				for (let i = 0; i < tmpContent.length; i++)
				{
					let tmpBlock = tmpContent[i];
					if (!tmpBlock || typeof tmpBlock !== 'object') continue;
					if (tmpBlock.type === 'tool_result')
					{
						tmpHasToolResult = true;
						let tmpResolved = this._resolveToolResultContent(tmpBlock, pToolResults);
						let tmpToolUseId = tmpBlock.tool_use_id;
						let tmpToolMeta = pToolUseIndex[tmpToolUseId] || {};
						let tmpDurationMs = (tmpToolMeta.StartedMs && tmpTimestampMs)
							? tmpTimestampMs - tmpToolMeta.StartedMs : null;
						tmpBase.Blocks.push({
							Type: 'tool_result',
							ToolUseId: tmpToolUseId,
							ToolName: tmpToolMeta.Name || null,
							IsError: !!tmpBlock.is_error,
							DurationMs: tmpDurationMs,
							ContentText: tmpResolved.Text,
							ContentTruncated: tmpResolved.Truncated,
							PersistedPath: tmpResolved.PersistedPath,
							ToolUseResult: pRec.toolUseResult || null
						});
					}
					else if (tmpBlock.type === 'text')
					{
						let tmpExtracted = this._extractHarnessTags(tmpBlock.text || '');
						if (tmpExtracted.UserText)
						{
							tmpHasUserText = true;
							tmpBase.Blocks.push({ Type: 'text', Text: tmpExtracted.UserText });
						}
						if (tmpExtracted.Reminders.length)
						{
							tmpBase.HarnessReminders = (tmpBase.HarnessReminders || []).concat(tmpExtracted.Reminders);
						}
					}
					else if (tmpBlock.type === 'image')
					{
						tmpBase.Blocks.push({ Type: 'image', Source: tmpBlock.source || null });
					}
					else
					{
						tmpBase.Blocks.push({ Type: tmpBlock.type || 'unknown', Raw: tmpBlock });
					}
				}
				if (tmpHasToolResult && !tmpHasUserText) tmpBase.Kind = 'tool-result';
				else tmpBase.Kind = 'user-prompt';
				return tmpBase;
			}
			return null;
		}

		if (tmpType === 'assistant')
		{
			tmpBase.Kind = 'assistant';
			let tmpMsg = pRec.message || {};
			let tmpUsage = tmpMsg.usage || null;
			let tmpContent = tmpMsg.content || [];
			for (let i = 0; i < tmpContent.length; i++)
			{
				let tmpBlock = tmpContent[i];
				if (!tmpBlock || typeof tmpBlock !== 'object') continue;
				if (tmpBlock.type === 'text')
				{
					tmpBase.Blocks.push({ Type: 'text', Text: tmpBlock.text || '' });
				}
				else if (tmpBlock.type === 'thinking')
				{
					tmpBase.Blocks.push({ Type: 'thinking', Text: tmpBlock.thinking || '' });
				}
				else if (tmpBlock.type === 'tool_use')
				{
					let tmpToolUseId = tmpBlock.id;
					let tmpAgentId = (tmpBlock.input && (tmpBlock.input.subagent_type || tmpBlock.input.agentId)) || null;
					pToolUseIndex[tmpToolUseId] =
					{
						Name: tmpBlock.name,
						StartedMs: tmpTimestampMs,
						AgentId: tmpAgentId
					};
					tmpBase.ToolUseIds.push(tmpToolUseId);
					tmpBase.Blocks.push({
						Type: 'tool_use',
						ToolUseId: tmpToolUseId,
						Name: tmpBlock.name,
						Input: tmpBlock.input || {},
						InputSummary: this._summarizeToolInput(tmpBlock.name, tmpBlock.input)
					});
				}
				else
				{
					tmpBase.Blocks.push({ Type: tmpBlock.type || 'unknown', Raw: tmpBlock });
				}
			}
			tmpBase.Usage = tmpUsage ? {
				input_tokens: tmpUsage.input_tokens,
				output_tokens: tmpUsage.output_tokens,
				cache_read: tmpUsage.cache_read_input_tokens,
				cache_create: tmpUsage.cache_creation_input_tokens
			} : null;
			tmpBase.Model = tmpMsg.model || null;
			tmpBase.StopReason = tmpMsg.stop_reason || null;
			return tmpBase;
		}

		return null;
	}

	// ---------------------------------------------------------------------
	// Subagent transcripts (same shape as main, minus prompt grouping)
	// ---------------------------------------------------------------------

	_buildAgentTranscript(pAgentId, pRaw, pToolResults)
	{
		let tmpRecords = pRaw && pRaw.Text ? this._parseJSONL(pRaw.Text) : [];
		let tmpToolUseIndex = {};
		let tmpTurns = [];
		let tmpFirstMs = null;
		let tmpLastMs = null;

		for (let i = 0; i < tmpRecords.length; i++)
		{
			let tmpRec = tmpRecords[i];
			let tmpTimestampMs = this._parseTimestampMs(tmpRec.timestamp);
			if (tmpTimestampMs && (!tmpFirstMs || tmpTimestampMs < tmpFirstMs)) tmpFirstMs = tmpTimestampMs;
			if (tmpTimestampMs && (!tmpLastMs  || tmpTimestampMs > tmpLastMs )) tmpLastMs = tmpTimestampMs;
			let tmpTurn = this._normalizeRecord(tmpRec, tmpToolUseIndex, pToolResults);
			if (tmpTurn) tmpTurns.push(tmpTurn);
		}
		tmpTurns.sort((pA, pB) => (pA.TimestampMs || 0) - (pB.TimestampMs || 0));

		// Compute prev-deltas for the agent timeline too.
		let tmpPrev = null;
		for (let i = 0; i < tmpTurns.length; i++)
		{
			if (tmpPrev && tmpTurns[i].TimestampMs)
			{
				tmpTurns[i].DurationFromPrevMs = tmpTurns[i].TimestampMs - tmpPrev;
			}
			tmpPrev = tmpTurns[i].TimestampMs || tmpPrev;
		}

		let tmpToolCount = 0;
		for (let i = 0; i < tmpTurns.length; i++)
		{
			if (tmpTurns[i].Kind === 'assistant') tmpToolCount += (tmpTurns[i].ToolUseIds || []).length;
		}

		return {
			AgentId: pAgentId,
			AgentType: pRaw && pRaw.Meta && pRaw.Meta.agentType || 'agent',
			Description: pRaw && pRaw.Meta && pRaw.Meta.description || '',
			FirstTimestampMs: tmpFirstMs,
			LastTimestampMs: tmpLastMs,
			DurationMs: (tmpFirstMs && tmpLastMs) ? tmpLastMs - tmpFirstMs : 0,
			ToolCallCount: tmpToolCount,
			Turns: tmpTurns
		};
	}

	// ---------------------------------------------------------------------
	// Helpers
	// ---------------------------------------------------------------------

	_isHumanFacingGap(pPrev, pNext)
	{
		// Surface gaps that represent the user thinking/walking away — i.e. assistant finished and user
		// is the one taking time to respond (or the reverse). Tool round-trips inside an assistant turn
		// are noise.
		if (!pPrev || !pNext) return false;
		if (pPrev.Kind === 'assistant' && pNext.Kind === 'user-prompt') return true;
		if (pPrev.Kind === 'tool-result' && pNext.Kind === 'user-prompt') return true;
		if (pPrev.Kind === 'user-prompt' && pNext.Kind === 'assistant') return true;
		return false;
	}

	_resolveToolResultContent(pBlock, pToolResults)
	{
		let tmpRaw = '';
		let tmpContent = pBlock.content;
		if (typeof tmpContent === 'string') tmpRaw = tmpContent;
		else if (Array.isArray(tmpContent))
		{
			for (let i = 0; i < tmpContent.length; i++)
			{
				let tmpC = tmpContent[i];
				if (tmpC && tmpC.type === 'text') tmpRaw += tmpC.text || '';
				else if (typeof tmpC === 'string') tmpRaw += tmpC;
			}
		}
		// Spilled content?  <persisted-output>... tool-results/<key>.txt ...
		let tmpMatch = tmpRaw.match(/tool-results\/([^/\s"]+)\.txt/);
		let tmpPersistedPath = null;
		if (tmpMatch)
		{
			let tmpKey = tmpMatch[1] + '.txt';
			tmpPersistedPath = tmpKey;
			let tmpFull = pToolResults[tmpKey];
			if (tmpFull) tmpRaw = tmpFull;
		}
		let tmpTruncated = false;
		if (tmpRaw.length > _MaxInlineToolResultPreview)
		{
			tmpRaw = tmpRaw.slice(0, _MaxInlineToolResultPreview);
			tmpTruncated = true;
		}
		return { Text: tmpRaw, Truncated: tmpTruncated, PersistedPath: tmpPersistedPath };
	}

	_summarizeToolInput(pName, pInput)
	{
		if (!pInput || typeof pInput !== 'object') return '';
		switch (pName)
		{
			case 'Read':       return pInput.file_path || '';
			case 'Write':      return pInput.file_path || '';
			case 'Edit':       return pInput.file_path || '';
			case 'Bash':       return (pInput.description ? pInput.description + ' — ' : '') + (pInput.command || '').slice(0, 120);
			case 'Glob':       return pInput.pattern || '';
			case 'Grep':       return (pInput.pattern || '') + (pInput.path ? ' in ' + pInput.path : '');
			case 'WebFetch':   return pInput.url || '';
			case 'WebSearch':  return pInput.query || '';
			case 'Task':
			case 'Agent':      return (pInput.subagent_type ? '[' + pInput.subagent_type + '] ' : '') + (pInput.description || '');
			case 'TodoWrite':  return (pInput.todos && pInput.todos.length) ? pInput.todos.length + ' todos' : '';
			case 'Skill':      return pInput.skill || '';
		}
		// Generic fallback: shortest scalar field.
		let tmpKeys = Object.keys(pInput);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpVal = pInput[tmpKeys[i]];
			if (typeof tmpVal === 'string' && tmpVal.length < 200) return tmpKeys[i] + '=' + tmpVal;
		}
		return '';
	}

	_summarizeAttachment(pAttach)
	{
		switch (pAttach.type)
		{
			case 'deferred_tools_delta':
				return (pAttach.addedNames ? pAttach.addedNames.length + ' deferred tools added' : 'deferred tools change');
			case 'skill_listing':
				return 'skill listing';
			default:
				return pAttach.type || 'attachment';
		}
	}

	_summarizeSystem(pRec)
	{
		if (pRec.subtype === 'stop_hook_summary')
		{
			return 'stop hook (' + (pRec.hookCount || 0) + ' hooks)';
		}
		return pRec.subtype || 'system';
	}

	_extractPromptText(pTurn)
	{
		for (let i = 0; i < pTurn.Blocks.length; i++)
		{
			let tmpB = pTurn.Blocks[i];
			if (tmpB.Type === 'text' && tmpB.Text) return tmpB.Text;
		}
		return '';
	}

	_extractHarnessTags(pText)
	{
		// Strip out tags the harness injects into user-message content (system reminders,
		// slash-command markup) so the conversation view can render the user's actual words and
		// surface the injected text as an attachment-style annotation. There's no separate field
		// in the JSONL — the tags are concatenated into message.content as plain text.
		if (!pText || typeof pText !== 'string') return { UserText: '', Reminders: [] };
		let tmpReminders = [];
		let tmpTagRegex = /<(system-reminder|command-message|command-name|command-args)>([\s\S]*?)<\/\1>/g;
		let tmpClean = pText.replace(tmpTagRegex, function (pMatch, pTag, pBody)
		{
			tmpReminders.push({ Tag: pTag, Body: (pBody || '').trim() });
			return '';
		}).trim();
		return { UserText: tmpClean, Reminders: tmpReminders };
	}

	_summarizeText(pText, pMaxLen)
	{
		if (!pText) return '';
		let tmpClean = pText.replace(/\s+/g, ' ').trim();
		if (tmpClean.length <= pMaxLen) return tmpClean;
		return tmpClean.slice(0, pMaxLen - 1) + '…';
	}

	_parseTimestampMs(pIso)
	{
		if (!pIso) return null;
		let tmpT = Date.parse(pIso);
		return isNaN(tmpT) ? null : tmpT;
	}

	// ---------------------------------------------------------------------
	// Browser plumbing (dropped folder / FileReader / JSZip)
	// ---------------------------------------------------------------------

	_loadJSZip()
	{
		if (this._JSZip) return this._JSZip;
		if (typeof window !== 'undefined' && window.JSZip) { this._JSZip = window.JSZip; return this._JSZip; }
		try { this._JSZip = require('jszip'); return this._JSZip; }
		catch (pErr) { return null; }
	}

	_readFileAsArrayBuffer(pFile, fCallback)
	{
		try
		{
			let tmpReader = new FileReader();
			tmpReader.onload = () => fCallback(null, tmpReader.result);
			tmpReader.onerror = () => fCallback(tmpReader.error || new Error('Read failed.'));
			tmpReader.readAsArrayBuffer(pFile);
		}
		catch (pErr) { fCallback(pErr); }
	}

	_readFileAsText(pFile, fCallback)
	{
		try
		{
			let tmpReader = new FileReader();
			tmpReader.onload = () => fCallback(null, tmpReader.result);
			tmpReader.onerror = () => fCallback(tmpReader.error || new Error('Read failed.'));
			tmpReader.readAsText(pFile);
		}
		catch (pErr) { fCallback(pErr); }
	}

	_parseDroppedFolder(pFiles, fCallback)
	{
		let tmpJsonl = null;
		let tmpToolResults = {};
		let tmpSubagents = {};
		let tmpMetadata = null;
		let tmpPending = 0;
		let tmpDone = false;

		let tmpFinish = (pErr, pSession) =>
		{
			if (tmpDone) return;
			tmpDone = true;
			if (pErr) return fCallback(pErr);
			fCallback(null, pSession);
		};

		let tmpKick = () =>
		{
			if (tmpPending > 0) return;
			if (!tmpJsonl) return tmpFinish(new Error('No .jsonl found in dropped files.'));
			let tmpSidecars = { ToolResults: tmpToolResults, Subagents: tmpSubagents, Metadata: tmpMetadata };
			this.parseJSONLText(tmpJsonl, tmpSidecars, tmpFinish);
		};

		for (let i = 0; i < pFiles.length; i++)
		{
			let tmpFile = pFiles[i];
			let tmpPath = tmpFile.webkitRelativePath || tmpFile.name;

			if (/\.jsonl$/i.test(tmpPath) && tmpPath.indexOf('/subagents/') === -1)
			{
				tmpPending++;
				this._readFileAsText(tmpFile, (pErr, pText) =>
				{
					if (!pErr) tmpJsonl = pText;
					tmpPending--; tmpKick();
				});
			}
			else if (/\/metadata\.json$/i.test(tmpPath) || /^metadata\.json$/i.test(tmpPath))
			{
				tmpPending++;
				this._readFileAsText(tmpFile, (pErr, pText) =>
				{
					if (!pErr) { try { tmpMetadata = JSON.parse(pText); } catch(e){} }
					tmpPending--; tmpKick();
				});
			}
			else if (tmpPath.indexOf('/tool-results/') !== -1)
			{
				let tmpKey = tmpPath.split('/').pop();
				tmpPending++;
				this._readFileAsText(tmpFile, (pErr, pText) =>
				{
					if (!pErr) tmpToolResults[tmpKey] = pText;
					tmpPending--; tmpKick();
				});
			}
			else
			{
				let tmpAgentMatch = tmpPath.match(/\/subagents\/agent-([^./]+)(\.meta\.json|\.jsonl)$/i);
				if (tmpAgentMatch)
				{
					let tmpAgentId = tmpAgentMatch[1];
					let tmpKind = tmpAgentMatch[2];
					tmpSubagents[tmpAgentId] = tmpSubagents[tmpAgentId] || { Meta: null, Text: '' };
					tmpPending++;
					this._readFileAsText(tmpFile, (pErr, pText) =>
					{
						if (!pErr)
						{
							if (tmpKind === '.meta.json') { try { tmpSubagents[tmpAgentId].Meta = JSON.parse(pText); } catch(e){} }
							else { tmpSubagents[tmpAgentId].Text = pText; }
						}
						tmpPending--; tmpKick();
					});
				}
			}
		}
		// In case nothing kicked off async work, finish immediately with an error.
		if (tmpPending === 0) tmpKick();
	}
}

module.exports = PictProviderSessionParser;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"jszip":119,"pict":375}],640:[function(require,module,exports){
const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');
const libSig = require('./PictView-Signature.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'AgentDetail',
	DefaultRenderable: 'AgentDetail-Empty',
	CSS: /*css*/`
		.cst-ag-meta { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 10px; }
		.cst-ag-turn { margin-bottom: 12px; padding: 8px 10px; border-radius: 4px; font-size: 12px; line-height: 1.4; }
		.cst-ag-turn-user { background: #eef7f1; }
		.cst-ag-turn-assistant { background: var(--theme-color-background-secondary, #fafbfd); border: 1px solid var(--theme-color-border-default, #dde2ee); }
		.cst-ag-turn-toolresult { background: #fbfaff; border: 1px solid #e1ddee; }
		.cst-ag-turn-time { font-family: monospace; color: var(--theme-color-text-secondary, #5b6376); font-size: 11px; }
		.cst-ag-tool-chip
		{
			display: inline-block;
			margin: 2px 4px 2px 0;
			padding: 2px 6px;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #dde2ee); border-left: 3px solid var(--theme-color-brand-accent, #b07acc);
			border-radius: 3px; font-size: 11px; font-family: monospace;
		}
		.cst-ag-text { white-space: pre-wrap; margin: 4px 0; }
	`,
	Templates:
	[
		{ Hash: 'AgentDetail-Empty', Template: '<span></span>' }
	],
	Renderables: []
};

class PictViewAgentDetail extends libPictView
{
	openAgent(pAgentId)
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Agents) return;
		let tmpAgent = tmpSession.Agents[pAgentId];
		if (!tmpAgent) return;

		let tmpHTML = '';
		tmpHTML += '<div class="cst-ag-meta">'
			+ '<strong>' + libLayout.escapeHTML(tmpAgent.AgentType) + '</strong> · '
			+ libLayout.formatDuration(tmpAgent.DurationMs) + ' · '
			+ tmpAgent.ToolCallCount + ' tool calls'
			+ '</div>';
		tmpHTML += '<div class="cst-ag-meta">' + libLayout.escapeHTML(tmpAgent.Description || '') + '</div>';

		for (let i = 0; i < tmpAgent.Turns.length; i++)
		{
			let tmpT = tmpAgent.Turns[i];
			let tmpClass = 'cst-ag-turn-' + (tmpT.Kind === 'user-prompt' ? 'user' : tmpT.Kind === 'assistant' ? 'assistant' : 'toolresult');
			let tmpTime = tmpT.TimestampMs ? '<span class="cst-ag-turn-time">' + new Date(tmpT.TimestampMs).toLocaleTimeString() + '</span> ' : '';
			let tmpBody = '';
			let tmpChips = '';
			for (let j = 0; j < tmpT.Blocks.length; j++)
			{
				let tmpB = tmpT.Blocks[j];
				if (tmpB.Type === 'text')        tmpBody += '<div class="cst-ag-text">' + libLayout.escapeHTML(tmpB.Text || '') + '</div>';
				else if (tmpB.Type === 'thinking') tmpBody += '<div class="cst-ag-text" style="font-style:italic;color:var(--theme-color-text-secondary, #5b6376);">' + libLayout.escapeHTML(tmpB.Text || '') + '</div>';
				else if (tmpB.Type === 'tool_use')
				{
					tmpChips += '<span class="cst-ag-tool-chip cst-tool-family-' + libSig.toolFamily(tmpB.Name) + '">'
						+ libLayout.escapeHTML(tmpB.Name) + (tmpB.InputSummary ? ': ' + libLayout.escapeHTML(tmpB.InputSummary) : '')
						+ '</span>';
				}
				else if (tmpB.Type === 'tool_result')
				{
					tmpBody += '<div class="cst-ag-text" style="font-family:monospace;font-size:10px;color:var(--theme-color-text-secondary, #5b6376);">'
						+ libLayout.escapeHTML((tmpB.ContentText || '').slice(0, 600))
						+ (tmpB.ContentTruncated || (tmpB.ContentText || '').length > 600 ? ' …' : '')
						+ '</div>';
				}
			}
			tmpHTML += '<div class="cst-ag-turn ' + tmpClass + '">' + tmpTime + tmpBody + tmpChips + '</div>';
		}

		this.pict.views.Layout.openDetail('Subagent: ' + tmpAgent.AgentType, tmpHTML);
	}
}

module.exports = PictViewAgentDetail;
module.exports.default_configuration = _ViewConfiguration;

},{"./PictView-Layout.js":644,"./PictView-Signature.js":645,"pict-view":365}],641:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * Plansheet's adapter for the vendored Claude session viewer.
 *
 * The viewer (a fork of claude-session-transformer, vendored under this
 * directory) is a set of Pict views (Dropzone, Layout, Signature, Timeline,
 * Conversation, ToolDetail, AgentDetail) plus a SessionParser provider. Those
 * views reach the host application through three seams, all of which plansheet
 * provides (see Pict-Application-Plansheet.js):
 *   - PictApplication.onSessionLoaded(session) renders the viewer
 *   - PictApplication.showSessions()           returns to the session list
 *   - providers.SessionAPI.uploadSession(...)  saves a dropped zip
 *
 * Plansheet drives the viewer through this one section view, registered as
 * 'Pict-Section-ClaudeTransformer' and called in exactly two ways:
 *   - showUploader()      -> showDropzone()       (upload a new session)
 *   - openServerSession() -> loadSessionFromZip() (view a stored session)
 */
class PictViewClaudeTransformerSection extends libPictView
{
	/**
	 * Render the dropzone into #ClaudeTransformer-Workspace. When a signed-in
	 * user drops a session zip, the Dropzone uploads it to their account via
	 * SessionAPI and returns to the refreshed calendar on its own.
	 */
	showDropzone()
	{
		if (this.pict.views.Dropzone)
		{
			this.pict.views.Dropzone.render();
		}
	}

	/**
	 * Parse a downloaded session zip and render it. Called by the app's
	 * openServerSession() after it downloads the blob for a calendar click.
	 * The parser writes the normalized session to AppData.Session, which the
	 * viewer views read; onSessionLoaded() then renders them.
	 */
	loadSessionFromZip(pBuffer, fCallback)
	{
		let tmpParser = this.pict.providers.SessionParser;
		if (!tmpParser)
		{
			if (typeof fCallback === 'function')
			{
				return fCallback(new Error('Session parser is not available in this build.'));
			}
			return;
		}
		let fParsed = (pError, pSession) =>
		{
			if (pError)
			{
				if (typeof fCallback === 'function')
				{
					return fCallback(pError);
				}
				return;
			}
			this.pict.PictApplication.onSessionLoaded(pSession);
			if (typeof fCallback === 'function')
			{
				return fCallback(null);
			}
		};
		// The stored blob is either a Claude /export .zip or a raw .jsonl transcript (what a node
		// runner files for a Project-driven run). Sniff the PK zip magic and route accordingly, so
		// both shapes open in the viewer.
		let tmpBytes = (pBuffer instanceof ArrayBuffer) ? new Uint8Array(pBuffer) : (pBuffer || new Uint8Array(0));
		let tmpIsZip = (tmpBytes.length >= 2 && tmpBytes[0] === 0x50 && tmpBytes[1] === 0x4B);
		if (tmpIsZip)
		{
			return tmpParser.parseZip(pBuffer, fParsed);
		}
		let tmpText;
		try { tmpText = (typeof TextDecoder !== 'undefined') ? new TextDecoder('utf-8').decode(tmpBytes) : String.fromCharCode.apply(null, tmpBytes); }
		catch (pDecodeError) { return fParsed(pDecodeError); }
		return tmpParser.parseJSONLText(tmpText, {}, fParsed);
	}
}

module.exports = PictViewClaudeTransformerSection;
module.exports.default_configuration = { ViewIdentifier: 'Pict-Section-ClaudeTransformer' };

},{"pict-view":365}],642:[function(require,module,exports){
const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');
const libSig = require('./PictView-Signature.js');
let libMarked = null;
try { libMarked = require('marked'); } catch (e) { libMarked = null; }

const _ViewConfiguration =
{
	ViewIdentifier: 'Conversation',
	DefaultRenderable: 'Conversation-Display',
	CSS: /*css*/`
		.cst-conv { max-width: 980px; margin: 0 auto; }
		.cst-turn { margin-bottom: 18px; padding: 0; border-radius: 8px; overflow: hidden; }
		.cst-turn-head
		{
			display: flex; align-items: baseline; gap: 10px;
			padding: 8px 14px; font-size: 12px;
			border-bottom: 1px solid transparent;
		}
		.cst-turn-head-kind { font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-turn-head-time { color: var(--theme-color-text-secondary, #5b6376); font-family: monospace; }
		.cst-turn-head-meta { color: var(--theme-color-text-secondary, #5b6376); margin-left: auto; }
		.cst-turn-body { padding: 12px 14px; font-size: 14px; line-height: 1.55; }

		.cst-turn-userprompt { background: #eef7f1; border: 1px solid #cae5d6; }
		.cst-turn-userprompt .cst-turn-head { color: #1f5b3a; border-bottom-color: #cae5d6; }
		.cst-turn-userprompt-harness { display: none; }
		.cst-show-attachments .cst-turn-userprompt-harness { display: block; }
		.cst-harness-reminder
		{
			display: none;
			background: #fdf6e3; border-left: 3px solid var(--theme-color-status-warning, #c8a93a);
			padding: 6px 10px; margin: 0 0 8px 0;
			font-size: 11px; color: #6b5a1a; font-style: italic;
		}
		.cst-show-attachments .cst-harness-reminder { display: block; }
		.cst-harness-reminder-tag { font-weight: 600; font-style: normal; margin-right: 6px; color: #8a6e1a; text-transform: uppercase; letter-spacing: 0.04em; font-size: 10px; }

		.cst-turn-assistant { background: var(--theme-color-background-secondary, #fafbfd); border: 1px solid var(--theme-color-border-default, #dde2ee); }
		.cst-turn-assistant .cst-turn-head { color: var(--theme-color-text-primary, #2c3140); border-bottom-color: var(--theme-color-border-default, #dde2ee); }
		.cst-turn-assistant-final
		{
			background: #f0f5ff;
			border: 1px solid #b9cdf0;
			border-left: 4px solid var(--theme-color-brand-primary, #4a7ad6);
		}
		.cst-turn-assistant-final .cst-turn-head { color: #1e3d80; border-bottom-color: #b9cdf0; background: #e3edff; }
		.cst-turn-assistant-intermediary
		{
			background: var(--theme-color-background-secondary, #fafbfd);
			border: 1px dashed #cdd2dc;
			opacity: 0.92;
			display: none;
		}
		.cst-show-intermediaries .cst-turn-assistant-intermediary { display: block; }
		.cst-turn-assistant-intermediary .cst-turn-head { color: var(--theme-color-text-secondary, #5b6376); }
		.cst-turn-assistant-intermediary .cst-turn-body { font-size: 13px; color: var(--theme-color-text-secondary, #4a5066); }

		.cst-turn-toolresult { background: #fbfaff; border: 1px solid #e1ddee; display: none; }
		.cst-show-tools .cst-turn-toolresult { display: block; }

		.cst-turn-attachment { background: #fbfbfd; border: 1px dashed #c7ccd9; display: none; font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-show-attachments .cst-turn-attachment { display: block; }

		.cst-turn-system { background: #fff7f7; border: 1px dashed #e3b0b0; font-size: 12px; color: #7a3a3a; display: none; }
		.cst-show-attachments .cst-turn-system { display: block; }

		.cst-gap
		{
			display: flex; align-items: center; gap: 12px;
			margin: 14px 0;
			padding: 6px 14px;
			color: var(--theme-color-text-secondary, #5b6376);
			font-size: 12px;
			font-style: italic;
		}
		.cst-gap-line { flex: 1 1 auto; height: 1px; background: repeating-linear-gradient(90deg, var(--theme-color-border-default, #b0b6c2) 0 6px, transparent 6px 12px); }

		.cst-thinking
		{
			background: #f0f1f6;
			border-left: 3px solid #6f88c7;
			padding: 8px 12px;
			margin: 8px 0;
			font-style: italic;
			font-size: 13px;
			color: var(--theme-color-text-secondary, #4a5066);
			white-space: pre-wrap;
			display: none;
		}
		.cst-show-attachments .cst-thinking { display: block; }

		.cst-text { white-space: pre-wrap; }
		.cst-text p { margin: 0 0 0.7em 0; }
		.cst-text pre { background: var(--theme-color-text-primary, #1d2230); color: var(--theme-color-border-light, #e3e6ee); padding: 10px 12px; border-radius: 6px; overflow-x: auto; font-size: 12px; }
		.cst-text code { background: var(--theme-color-background-tertiary, #eef0f5); padding: 1px 5px; border-radius: 3px; font-size: 12px; }
		.cst-text pre code { background: transparent; padding: 0; color: inherit; font-size: 12px; }

		.cst-tools-strip { margin-top: 10px; display: none; flex-direction: column; gap: 4px; }
		.cst-show-tools .cst-tools-strip { display: flex; }
		.cst-tool-result-inline { display: none; }
		.cst-show-tools .cst-tool-result-inline { display: block; }
		.cst-turn-assistant-tooluse { display: none; }
		.cst-show-tools .cst-turn-assistant-tooluse { display: block; }
		.cst-turn-assistant-thinking { display: none; }
		.cst-show-attachments .cst-turn-assistant-thinking { display: block; }
		.cst-tool-chip
		{
			display: flex; align-items: center; gap: 8px;
			padding: 5px 10px;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #dde2ee);
			border-left: 3px solid var(--theme-color-brand-accent, #b07acc);
			border-radius: 4px;
			font-size: 12px;
			cursor: pointer;
			line-height: 1.4;
		}
		.cst-tool-chip:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-tool-chip-name { font-weight: 600; min-width: 60px; }
		.cst-tool-chip-input { color: var(--theme-color-text-primary, #2c3140); flex: 1 1 auto; font-family: monospace; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-tool-chip-dur { color: var(--theme-color-text-secondary, #5b6376); font-family: monospace; flex: 0 0 auto; }
		.cst-tool-chip-err { color: var(--theme-color-status-error, #c0353a); }
		.cst-tool-chip.cst-tool-family-read   { border-left-color: var(--theme-color-brand-accent, #b07acc); }
		.cst-tool-chip.cst-tool-family-write  { border-left-color: #d18ba2; }
		.cst-tool-chip.cst-tool-family-bash   { border-left-color: #c87a3a; }
		.cst-tool-chip.cst-tool-family-search { border-left-color: #d4b94a; }
		.cst-tool-chip.cst-tool-family-agent  { border-left-color: #e07b3a; }

		.cst-tool-result-content
		{
			margin-top: 6px;
			padding: 10px 12px;
			background: var(--theme-color-text-primary, #1d2230); color: #d8dde8;
			font-family: monospace; font-size: 11px;
			border-radius: 4px;
			white-space: pre-wrap;
			max-height: 360px;
			overflow: auto;
		}
		.cst-tool-result-truncated { color: #d4b94a; font-style: italic; }
		.cst-tool-result-summary { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }

		.cst-prompt-anchor { scroll-margin-top: 12px; }

		@media print
		{
			.cst-turn { break-inside: avoid; }
			.cst-tool-chip { cursor: default; }
		}
	`,
	Templates:
	[
		{
			Hash: 'Conversation-Display',
			Template: /*html*/`
<div class="cst-conv" id="Conversation-Inner"></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Conversation-Display',
			TemplateHash:   'Conversation-Display',
			ContentDestinationAddress: '#Conversation-Container'
		}
	]
};

class PictViewConversation extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._buildBody();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_buildBody()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Turns) return;

		let tmpL = this.pict.AppData.Layout || {};
		let tmpClasses = ['cst-conv-inner'];
		if (tmpL.ShowTools)          tmpClasses.push('cst-show-tools');
		if (tmpL.ShowAttachments)    tmpClasses.push('cst-show-attachments');
		if (tmpL.ShowIntermediaries) tmpClasses.push('cst-show-intermediaries');

		let tmpInner = document.getElementById('Conversation-Inner');
		if (tmpInner) tmpInner.className = 'cst-conv ' + tmpClasses.join(' ');

		let tmpHTML = '';
		let tmpRenderedPrompt = {};
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			if (tmpT.PromptId && !tmpRenderedPrompt[tmpT.PromptId])
			{
				tmpRenderedPrompt[tmpT.PromptId] = true;
				tmpHTML += '<div id="Conversation-Prompt-' + tmpT.PromptId + '" class="cst-prompt-anchor"></div>';
			}
			tmpHTML += this._renderTurn(tmpT, i);
		}
		this.pict.ContentAssignment.assignContent('#Conversation-Inner', tmpHTML);
	}

	_renderTurn(pTurn, pIndex)
	{
		if (pTurn.Kind === 'gap')
		{
			return '<div class="cst-gap" id="Conversation-Turn-' + pIndex + '">'
				+ '<span class="cst-gap-line"></span>'
				+ '<span>idle ' + libLayout.formatDuration(pTurn.DurationMs) + '</span>'
				+ '<span>(' + new Date(pTurn.TimestampMs).toLocaleString() + ' → '
				+ new Date(pTurn.EndTimestampMs).toLocaleString() + ')</span>'
				+ '<span class="cst-gap-line"></span>'
				+ '</div>';
		}

		let tmpKindClass = 'cst-turn-' + pTurn.Kind.replace('-', '');
		if (pTurn.Kind === 'assistant')
		{
			if (pTurn.IsFinalReply)         tmpKindClass += ' cst-turn-assistant-final';
			else if (pTurn.IsIntermediary)  tmpKindClass += ' cst-turn-assistant-intermediary';
			else if (pTurn.IsToolOnly)      tmpKindClass += ' cst-turn-assistant-tooluse';
			else if (pTurn.IsThinkingOnly)  tmpKindClass += ' cst-turn-assistant-thinking';
		}
		else if (pTurn.Kind === 'user-prompt' && pTurn.IsHarnessOnly)
		{
			tmpKindClass += ' cst-turn-userprompt-harness';
		}
		let tmpHead = this._headForTurn(pTurn);
		let tmpBody = this._bodyForTurn(pTurn);

		return '<div class="cst-turn ' + tmpKindClass + '" id="Conversation-Turn-' + pIndex + '">'
			+ tmpHead
			+ '<div class="cst-turn-body">' + tmpBody + '</div>'
			+ '</div>';
	}

	_headForTurn(pTurn)
	{
		let tmpKind = pTurn.Kind;
		let tmpKindLabel = ({
			'user-prompt': 'User',
			'assistant':   'Assistant',
			'tool-result': 'Tool result',
			'attachment':  'Attachment',
			'system':      'System'
		})[tmpKind] || tmpKind;
		if (tmpKind === 'assistant')
		{
			if (pTurn.IsFinalReply)        tmpKindLabel = 'Reply';
			else if (pTurn.IsIntermediary) tmpKindLabel = 'Working';
		}
		let tmpTime = pTurn.TimestampMs ? new Date(pTurn.TimestampMs).toLocaleString() : '';
		let tmpMeta = '';
		if (tmpKind === 'assistant')
		{
			let tmpToolCount = (pTurn.ToolUseIds || []).length;
			let tmpBits = [];
			if (pTurn.Model) tmpBits.push(pTurn.Model);
			if (tmpToolCount) tmpBits.push(tmpToolCount + ' tool call' + (tmpToolCount === 1 ? '' : 's'));
			if (pTurn.Usage && pTurn.Usage.output_tokens) tmpBits.push(pTurn.Usage.output_tokens + ' tok out');
			tmpMeta = tmpBits.join(' · ');
		}
		else if (tmpKind === 'user-prompt' && pTurn.DurationFromPrevMs)
		{
			tmpMeta = 'after ' + libLayout.formatDuration(pTurn.DurationFromPrevMs);
		}
		return '<div class="cst-turn-head">'
			+ '<span class="cst-turn-head-kind">' + tmpKindLabel + '</span>'
			+ '<span class="cst-turn-head-time">' + tmpTime + '</span>'
			+ '<span class="cst-turn-head-meta">' + libLayout.escapeHTML(tmpMeta) + '</span>'
			+ '</div>';
	}

	_bodyForTurn(pTurn)
	{
		let tmpHTML = '';
		let tmpToolChips = '';
		if (pTurn.HarnessReminders && pTurn.HarnessReminders.length)
		{
			for (let r = 0; r < pTurn.HarnessReminders.length; r++)
			{
				let tmpRem = pTurn.HarnessReminders[r];
				tmpHTML += '<div class="cst-harness-reminder">'
					+ '<span class="cst-harness-reminder-tag">' + libLayout.escapeHTML(tmpRem.Tag) + '</span>'
					+ libLayout.escapeHTML(tmpRem.Body)
					+ '</div>';
			}
		}
		for (let i = 0; i < pTurn.Blocks.length; i++)
		{
			let tmpB = pTurn.Blocks[i];
			if (tmpB.Type === 'text')
			{
				tmpHTML += '<div class="cst-text">' + this._renderMarkdown(tmpB.Text || '') + '</div>';
			}
			else if (tmpB.Type === 'thinking')
			{
				tmpHTML += '<div class="cst-thinking">' + libLayout.escapeHTML(tmpB.Text || '') + '</div>';
			}
			else if (tmpB.Type === 'tool_use')
			{
				tmpToolChips += this._renderToolChip(tmpB);
			}
			else if (tmpB.Type === 'tool_result')
			{
				tmpHTML += this._renderToolResult(tmpB);
			}
			else if (tmpB.Type === 'attachment')
			{
				tmpHTML += '<div>' + libLayout.escapeHTML(tmpB.AttachmentType) + ' — ' + libLayout.escapeHTML(tmpB.Summary || '') + '</div>';
			}
			else if (tmpB.Type === 'image')
			{
				tmpHTML += '<div><em>[image]</em></div>';
			}
			else if (tmpB.Type === 'system')
			{
				tmpHTML += '<div>' + libLayout.escapeHTML(tmpB.Subtype) + ' — ' + libLayout.escapeHTML(tmpB.Summary || '') + '</div>';
			}
		}
		if (tmpToolChips) tmpHTML += '<div class="cst-tools-strip">' + tmpToolChips + '</div>';
		return tmpHTML;
	}

	_renderToolChip(pBlock)
	{
		let tmpFamily = libSig.toolFamily(pBlock.Name);
		let tmpAgentLink = '';
		// If this is a Task/Agent call, find a matching subagent and offer drill-in.
		if (tmpFamily === 'agent')
		{
			let tmpSession = this.pict.AppData.Session;
			let tmpAgentId = this._findAgentForToolUse(pBlock, tmpSession);
			if (tmpAgentId)
			{
				tmpAgentLink = ' <a href="#" onclick="event.stopPropagation(); _Pict.views.AgentDetail.openAgent(\''
					+ tmpAgentId + '\'); return false;">↳ open agent</a>';
			}
		}
		return '<div class="cst-tool-chip cst-tool-family-' + tmpFamily + '" '
			+ 'onclick="_Pict.views.ToolDetail.openTool(\'' + pBlock.ToolUseId + '\')">'
			+ '<span class="cst-tool-chip-name">' + libLayout.escapeHTML(pBlock.Name || 'tool') + '</span>'
			+ '<span class="cst-tool-chip-input">' + libLayout.escapeHTML(pBlock.InputSummary || '') + tmpAgentLink + '</span>'
			+ '<span class="cst-tool-chip-dur">' + this._chipDurationLabel(pBlock) + '</span>'
			+ '</div>';
	}

	_chipDurationLabel(pBlock)
	{
		// Walk forward: find the matching tool_result for this id (via Session.Turns).
		let tmpDur = this._lookupToolDurationMs(pBlock.ToolUseId);
		if (tmpDur != null) return libLayout.formatDuration(tmpDur);
		return '';
	}

	_lookupToolDurationMs(pToolUseId)
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession) return null;
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			if (tmpT.Kind !== 'tool-result' && tmpT.Kind !== 'user-prompt') continue;
			for (let j = 0; j < tmpT.Blocks.length; j++)
			{
				let tmpB = tmpT.Blocks[j];
				if (tmpB.Type === 'tool_result' && tmpB.ToolUseId === pToolUseId)
				{
					return tmpB.DurationMs;
				}
			}
		}
		return null;
	}

	_findAgentForToolUse(pBlock, pSession)
	{
		// Heuristic: if the agent transcript was written close in time to this Task call.
		if (!pSession || !pSession.Agents) return null;
		let tmpAgentIds = Object.keys(pSession.Agents);
		// Pick the agent whose first timestamp is closest after the tool_use's parent assistant turn.
		// Without a hard link in the JSONL we approximate by best time match.
		// Look up the assistant turn that contains this tool_use.
		let tmpStartMs = null;
		for (let i = 0; i < pSession.Turns.length; i++)
		{
			let tmpT = pSession.Turns[i];
			if (tmpT.Kind !== 'assistant') continue;
			if ((tmpT.ToolUseIds || []).indexOf(pBlock.ToolUseId) !== -1) { tmpStartMs = tmpT.TimestampMs; break; }
		}
		if (tmpStartMs == null) return tmpAgentIds[0] || null;
		let tmpBestId = null;
		let tmpBestDelta = Infinity;
		for (let i = 0; i < tmpAgentIds.length; i++)
		{
			let tmpAg = pSession.Agents[tmpAgentIds[i]];
			let tmpDelta = Math.abs((tmpAg.FirstTimestampMs || 0) - tmpStartMs);
			if (tmpDelta < tmpBestDelta) { tmpBestDelta = tmpDelta; tmpBestId = tmpAgentIds[i]; }
		}
		// Only return if within ~2 minutes — otherwise we'd link random agents.
		return tmpBestDelta < 2 * 60 * 1000 ? tmpBestId : null;
	}

	_renderToolResult(pBlock)
	{
		let tmpDur = pBlock.DurationMs != null ? ' · ' + libLayout.formatDuration(pBlock.DurationMs) : '';
		let tmpName = pBlock.ToolName || 'tool';
		let tmpHeader = '<div class="cst-tool-result-summary">'
			+ libLayout.escapeHTML(tmpName) + tmpDur + (pBlock.IsError ? ' · <span class="cst-tool-chip-err">error</span>' : '')
			+ (pBlock.PersistedPath ? ' · spilled to ' + libLayout.escapeHTML(pBlock.PersistedPath) : '')
			+ '</div>';
		let tmpContent = '<div class="cst-tool-result-content">'
			+ libLayout.escapeHTML(pBlock.ContentText || '')
			+ (pBlock.ContentTruncated ? '\n\n<span class="cst-tool-result-truncated">[truncated]</span>' : '')
			+ '</div>';
		return '<div class="cst-tool-result-inline">' + tmpHeader + tmpContent + '</div>';
	}

	_renderMarkdown(pText)
	{
		if (!pText) return '';
		if (libMarked && typeof libMarked.parse === 'function')
		{
			try { return libMarked.parse(pText); } catch (e) { /* fallthrough */ }
		}
		return libLayout.escapeHTML(pText);
	}

	scrollToPrompt(pPromptId)
	{
		let tmpEl = document.getElementById('Conversation-Prompt-' + pPromptId);
		if (tmpEl)
		{
			tmpEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
			if (this.pict.views.Timeline) this.pict.views.Timeline.highlight(pPromptId);
		}
	}

	scrollToTurn(pIndex)
	{
		let tmpEl = document.getElementById('Conversation-Turn-' + pIndex);
		if (tmpEl) tmpEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}
}

module.exports = PictViewConversation;
module.exports.default_configuration = _ViewConfiguration;

},{"./PictView-Layout.js":644,"./PictView-Signature.js":645,"marked":133,"pict-view":365}],643:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Dropzone',
	DefaultRenderable: 'Dropzone-Display',
	CSS: /*css*/`
		.cst-dropzone
		{
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 60px 24px;
			border: 2px dashed var(--theme-color-border-default, #b0b6c2);
			border-radius: 12px;
			background: var(--theme-color-background-secondary, #f6f8fb);
			color: var(--theme-color-text-primary, #2c3140);
			margin: 24px;
			transition: background 0.15s, border-color 0.15s;
		}
		.cst-dropzone.cst-dropzone-active { background: var(--theme-color-background-hover, #eaf2ff); border-color: var(--theme-color-brand-primary, #4a7ad6); }
		.cst-dropzone-title { font-size: 22px; font-weight: 600; margin-bottom: 8px; }
		.cst-dropzone-hint  { font-size: 14px; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 18px; text-align: center; max-width: 540px; }
		.cst-dropzone-actions { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }
		.cst-dropzone-btn
		{
			padding: 10px 18px;
			border-radius: 8px;
			background: var(--theme-color-text-primary, #2c3140);
			color: var(--theme-color-background-panel, #fff);
			cursor: pointer;
			font-weight: 500;
			border: none;
			font-size: 14px;
		}
		.cst-dropzone-btn-secondary { background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); border: 1px solid var(--theme-color-border-default, #b0b6c2); }
		.cst-dropzone-error { color: var(--theme-color-status-error, #c0353a); margin-top: 14px; font-size: 13px; max-width: 540px; text-align: center; }
		.cst-dropzone-status { color: var(--theme-color-text-primary, #2c3140); margin-top: 14px; font-size: 14px; }
		.cst-dropzone input[type=file] { display: none; }
	`,
	Templates:
	[
		{
			Hash: 'Dropzone-Display',
			Template: /*html*/`
<div class="cst-dropzone" id="Dropzone-Root"
	ondragover="event.preventDefault(); this.classList.add('cst-dropzone-active');"
	ondragleave="this.classList.remove('cst-dropzone-active');"
	ondrop="event.preventDefault(); this.classList.remove('cst-dropzone-active'); _Pict.views.Dropzone.handleDrop(event);">
	<div class="cst-dropzone-title">Drop a Claude Code export</div>
	<div class="cst-dropzone-hint">{~D:AppData.Dropzone.HintText~}</div>
	<div class="cst-dropzone-actions">
		<button class="cst-dropzone-btn" onclick="_Pict.views.Dropzone.openFilePicker()">Choose file…</button>
		<button class="cst-dropzone-btn cst-dropzone-btn-secondary" onclick="_Pict.views.Dropzone.openFolderPicker()">Choose folder…</button>
	</div>
	<input type="file" id="Dropzone-FileInput"
		accept=".zip,.jsonl"
		onchange="_Pict.views.Dropzone.handleFileInput(event)" />
	<input type="file" id="Dropzone-FolderInput"
		webkitdirectory directory multiple
		onchange="_Pict.views.Dropzone.handleFileInput(event)" />
	<div class="cst-dropzone-status" id="Dropzone-Status">{~D:AppData.Dropzone.Status~}</div>
	<div class="cst-dropzone-error" id="Dropzone-Error">{~D:AppData.Dropzone.Error~}</div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Dropzone-Display',
			TemplateHash:   'Dropzone-Display',
			ContentDestinationAddress: '#ClaudeTransformer-Workspace'
		}
	]
};

class PictViewDropzone extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.Dropzone = this.pict.AppData.Dropzone || { Status: '', Error: '', HintText: '' };
	}

	onBeforeRender(pRenderable)
	{
		let tmpAuth = this.pict.AppData.Auth;
		if (tmpAuth && tmpAuth.LoggedIn)
		{
			this.pict.AppData.Dropzone.HintText = 'Drag in the .zip from /export. We\'ll parse it, save it to your account, and add it to your calendar.';
		}
		else
		{
			this.pict.AppData.Dropzone.HintText = 'Drag in the .zip from /export, or just the .jsonl, or the whole expanded export folder. Everything is parsed locally in your browser — nothing is uploaded.';
		}
		return super.onBeforeRender(pRenderable);
	}

	openFilePicker()
	{
		let tmpInput = document.getElementById('Dropzone-FileInput');
		if (tmpInput) tmpInput.click();
	}

	openFolderPicker()
	{
		let tmpInput = document.getElementById('Dropzone-FolderInput');
		if (tmpInput) tmpInput.click();
	}

	handleFileInput(pEvent)
	{
		let tmpFiles = pEvent && pEvent.target && pEvent.target.files;
		if (!tmpFiles || !tmpFiles.length) return;
		this._parse(tmpFiles);
	}

	handleDrop(pEvent)
	{
		let tmpDt = pEvent.dataTransfer;
		if (!tmpDt) return;
		// If the drop has items with directory entries, walk them; otherwise just use .files.
		if (tmpDt.items && tmpDt.items.length && tmpDt.items[0].webkitGetAsEntry)
		{
			let tmpEntries = [];
			for (let i = 0; i < tmpDt.items.length; i++)
			{
				let tmpEntry = tmpDt.items[i].webkitGetAsEntry();
				if (tmpEntry) tmpEntries.push(tmpEntry);
			}
			if (tmpEntries.some((pE) => pE.isDirectory))
			{
				return this._walkEntries(tmpEntries, (pErr, pFiles) =>
				{
					if (pErr) return this._setError(pErr.message);
					this._parse(pFiles);
				});
			}
		}
		this._parse(tmpDt.files);
	}

	_parse(pFiles)
	{
		this.pict.AppData.Dropzone.Status = 'Parsing ' + pFiles.length + ' file(s)…';
		this.pict.AppData.Dropzone.Error = '';
		this.render();
		let tmpParser = this.pict.providers.SessionParser;

		// Hold onto the raw zip file (if any) so that, on a logged-in upload
		// path, we can ship it to the server without re-reading from disk.
		let tmpFilesArr = Array.from(pFiles || []);
		let tmpZipFile = null;
		if (tmpFilesArr.length === 1 && /\.zip$/i.test(tmpFilesArr[0].name))
		{
			tmpZipFile = tmpFilesArr[0];
		}

		tmpParser.parseFiles(pFiles, (pErr, pSession) =>
		{
			if (pErr)
			{
				this._setError(pErr.message || String(pErr));
				return;
			}
			this.pict.AppData.Dropzone.Status = 'Loaded: ' + (pSession.Meta.title || pSession.Meta.sessionId);
			this.pict.AppData.Dropzone.Error = '';
			this.render();

			let tmpAuth = this.pict.AppData.Auth;
			let tmpCanUpload = !!(tmpAuth && tmpAuth.LoggedIn && tmpZipFile && this.pict.providers.SessionAPI);
			if (tmpCanUpload)
			{
				this._uploadSession(pSession, tmpZipFile);
				return;
			}

			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.onSessionLoaded === 'function')
			{
				tmpApp.onSessionLoaded(pSession);
			}
		});
	}

	_uploadSession(pSession, pZipFile)
	{
		this.pict.AppData.Dropzone.Status = 'Uploading to your account…';
		this.render();
		let tmpMeta = pSession.Meta || {};
		let tmpStats = pSession.Stats || {};
		let tmpToISO = (pMs) =>
		{
			if (!pMs) return '';
			try { return new Date(pMs).toISOString(); } catch (e) { return ''; }
		};
		let tmpPayload =
			{
				Title: tmpMeta.title || pZipFile.name,
				OriginalFileName: pZipFile.name,
				FileSizeBytes: pZipFile.size || 0,
				SessionStartedAt: tmpToISO(tmpMeta.createdAt),
				SessionLastActivityAt: tmpToISO(tmpMeta.lastActivityAt),
				TotalDurationMs: tmpStats.totalDurationMs || 0,
				PromptCount: tmpStats.promptCount || 0,
				ToolCallCount: tmpStats.toolCallCount || 0,
				AgentCount: tmpStats.agentCount || 0,
				Model: tmpMeta.model || ''
			};

		this.pict.providers.SessionAPI.uploadSession(tmpPayload, pZipFile).then(() =>
		{
			this.pict.AppData.Dropzone.Status = '';
			this.render();
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.showSessions === 'function')
			{
				tmpApp.showSessions();
			}
		}).catch((pErr) =>
		{
			this._setError('Upload failed: ' + (pErr.message || pErr));
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.onSessionLoaded === 'function')
			{
				tmpApp.onSessionLoaded(pSession);
			}
		});
	}

	_setError(pMessage)
	{
		this.pict.AppData.Dropzone.Status = '';
		this.pict.AppData.Dropzone.Error = pMessage;
		this.render();
	}

	_walkEntries(pEntries, fCallback)
	{
		let tmpFiles = [];
		let tmpPending = 0;
		let tmpDone = false;

		let tmpFinish = (pErr) =>
		{
			if (tmpDone) return;
			tmpDone = true;
			fCallback(pErr, tmpFiles);
		};

		let tmpVisit = (pEntry, pPath) =>
		{
			if (pEntry.isFile)
			{
				tmpPending++;
				pEntry.file((pFile) =>
				{
					try { Object.defineProperty(pFile, 'webkitRelativePath', { value: pPath + pFile.name }); } catch(e){}
					tmpFiles.push(pFile);
					tmpPending--;
					if (tmpPending === 0) tmpFinish(null);
				}, (pErr) =>
				{
					tmpPending--;
					if (tmpPending === 0) tmpFinish(pErr);
				});
			}
			else if (pEntry.isDirectory)
			{
				let tmpReader = pEntry.createReader();
				let tmpReadBatch = () =>
				{
					tmpPending++;
					tmpReader.readEntries((pBatch) =>
					{
						if (!pBatch.length)
						{
							tmpPending--;
							if (tmpPending === 0) tmpFinish(null);
							return;
						}
						for (let i = 0; i < pBatch.length; i++)
						{
							tmpVisit(pBatch[i], pPath + pEntry.name + '/');
						}
						tmpPending--;
						tmpReadBatch();
					});
				};
				tmpReadBatch();
			}
		};

		for (let i = 0; i < pEntries.length; i++) tmpVisit(pEntries[i], '');
		if (tmpPending === 0) tmpFinish(null);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewDropzone;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],644:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Layout',
	DefaultRenderable: 'Layout-Display',
	CSS: /*css*/`
		/* html/body/container styles owned by the Shell view; Layout just
		   shapes its own pane inside #ClaudeTransformer-Workspace. */
		#ClaudeTransformer-Workspace { display: flex; flex-direction: column; height: 100%; }
		.cst-app { display: flex; flex-direction: column; flex: 1 1 auto; min-height: 0; }
		.cst-header
		{
			display: flex; flex-direction: column; gap: 8px;
			padding: 10px 18px; border-bottom: 1px solid var(--theme-color-border-light, #e3e6ee);
			background: var(--theme-color-background-secondary, #f6f8fb);
			flex: 0 0 auto;
		}
		.cst-header-top { display: flex; align-items: center; gap: 14px; }
		.cst-header-title-block { flex: 1 1 auto; min-width: 0; }
		.cst-header-title { font-size: 17px; font-weight: 600; line-height: 1.25; }
		.cst-header-subtitle { color: var(--theme-color-text-secondary, #5b6376); font-size: 12px; margin-top: 2px; display: flex; gap: 10px; flex-wrap: wrap; }
		.cst-header-cards { display: flex; align-items: stretch; gap: 10px; flex-wrap: wrap; }
		.cst-stat-card
		{
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #dde2ee);
			border-radius: 6px;
			padding: 8px 12px;
			min-width: 160px;
			flex: 0 1 auto;
		}
		.cst-stat-card h4
		{
			margin: 0 0 4px 0;
			font-size: 10px;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--theme-color-text-secondary, #5b6376);
			font-weight: 600;
		}
		.cst-stat-card ul
		{
			list-style: none;
			margin: 0;
			padding: 0;
			font-size: 12px;
			color: var(--theme-color-text-secondary, #4a5066);
			line-height: 1.55;
		}
		.cst-stat-card li { display: flex; align-items: center; gap: 4px; }
		.cst-stat-card-time strong { color: var(--theme-color-text-primary, #1d2230); font-weight: 600; }
		.cst-metric { cursor: help; border-bottom: 1px dotted transparent; transition: border-bottom-color 0.1s, color 0.1s; }
		.cst-metric:hover { color: var(--theme-color-text-primary, #1d2230); border-bottom-color: var(--theme-color-text-secondary, #5b6376); }
		.cst-stat-card-time .cst-metric { width: 100%; }
		.cst-metric-help
		{
			display: inline-flex; align-items: center; justify-content: center;
			width: 16px; height: 16px;
			margin-left: 4px;
			border-radius: 50%;
			background: var(--theme-color-border-light, #e3e6ee); color: var(--theme-color-text-secondary, #5b6376);
			font-size: 11px; font-style: normal;
			cursor: pointer;
			transition: background 0.1s, color 0.1s;
			vertical-align: middle;
		}
		.cst-metric-help:hover { background: var(--theme-color-brand-primary, #4a7ad6); color: var(--theme-color-background-panel, #fff); }
		.cst-metric-key dl { margin: 0; }
		.cst-metric-key dt { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); margin-top: 12px; }
		.cst-metric-key dt:first-child { margin-top: 0; }
		.cst-metric-key dd { margin: 4px 0 0 0; color: var(--theme-color-text-secondary, #4a5066); line-height: 1.5; }
		.cst-metric-key code { background: var(--theme-color-background-tertiary, #eef0f5); padding: 1px 5px; border-radius: 3px; font-size: 12px; }
		.cst-metric-key .cst-metric-key-eq { color: var(--theme-color-text-secondary, #5b6376); font-style: italic; font-size: 12px; }
		.cst-stat-card-visibility li { gap: 6px; }
		.cst-stat-card-visibility li label
		{
			display: flex; align-items: center; gap: 6px;
			cursor: pointer; user-select: none;
			width: 100%;
		}
		.cst-stat-card-visibility input[type=checkbox] { margin-left: auto; cursor: pointer; }
		.cst-color-dot
		{
			display: inline-block;
			width: 10px; height: 10px;
			border-radius: 2px;
			flex: 0 0 auto;
		}
		.cst-color-dot-chatter     { background: var(--theme-color-brand-primary, #4a7ad6); }
		.cst-color-dot-attachments { background: var(--theme-color-status-warning, #c8a93a); }
		.cst-color-dot-tools       { background: var(--theme-color-brand-accent, #b07acc); }
		.cst-header-actions { display: flex; gap: 6px; align-self: flex-start; }
		.cst-action-btn
		{
			padding: 6px 12px; border: 1px solid var(--theme-color-border-default, #b0b6c2); background: var(--theme-color-background-panel, #fff);
			border-radius: 6px; cursor: pointer; font-size: 13px;
		}
		.cst-action-btn:hover { background: var(--theme-color-background-hover, #eaf2ff); }

		.cst-signature-bar { padding: 8px 18px 14px 18px; border-bottom: 1px solid var(--theme-color-border-light, #e3e6ee); background: var(--theme-color-background-secondary, #f6f8fb); flex: 0 0 auto; max-height: 30vh; overflow: hidden; display: flex; flex-direction: column; }

		.cst-body { display: flex; flex: 1 1 auto; min-height: 0; }
		.cst-rail
		{
			flex: 0 0 240px;
			border-right: 1px solid var(--theme-color-border-light, #e3e6ee);
			overflow-y: auto;
			background: var(--theme-color-background-secondary, #fafbfd);
		}
		.cst-main { flex: 1 1 auto; overflow-y: auto; padding: 16px 24px; min-width: 0; }
		.cst-detail
		{
			flex: 0 0 380px;
			border-left: 1px solid var(--theme-color-border-light, #e3e6ee);
			overflow-y: auto;
			background: var(--theme-color-background-secondary, #fafbfd);
			display: none;
		}
		.cst-detail.cst-detail-open { display: block; }

		@media print
		{
			.cst-header-actions, .cst-rail, .cst-detail, .cst-signature-bar, .cst-dropzone-container { display: none !important; }
			.cst-main { overflow: visible; padding: 0; }
			.cst-app  { height: auto; }
		}
	`,
	Templates:
	[
		{
			Hash: 'Layout-Display',
			Template: /*html*/`
<div class="cst-app">
	<div class="cst-header">
		<div class="cst-header-top">
			<div class="cst-header-title-block">
				<div class="cst-header-title">{~D:AppData.Session.Meta.title~}</div>
				<div class="cst-header-subtitle">
					<span>{~D:AppData.Session.Meta.sessionId~}</span>
					<span>· {~D:AppData.Session.Meta.model~}</span>
				</div>
			</div>
			<div class="cst-header-actions">
				<button class="cst-action-btn" onclick="_Pict.views.Layout.exportMarkdown()">Markdown</button>
				<button class="cst-action-btn" onclick="_Pict.views.Layout.exportPDF()">Print / PDF</button>
				<button class="cst-action-btn" onclick="_Pict.views.Layout.reset()">Load another</button>
			</div>
		</div>
		<div class="cst-header-cards">
			<div class="cst-stat-card cst-stat-card-counts">
				<h4>Session</h4>
				<ul>
					<li>· {~D:AppData.Layout.PromptCountLabel~}</li>
					<li>· {~D:AppData.Layout.ToolCountLabel~}</li>
					<li>· {~D:AppData.Layout.AgentCountLabel~}</li>
				</ul>
			</div>
			<div class="cst-stat-card cst-stat-card-time">
				<h4>Time
					<span class="cst-metric-help" onclick="_Pict.views.Layout.showMetricsKey()" title="What do these mean?">ⓘ</span>
				</h4>
				<ul>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('total')">· <strong>{~D:AppData.Layout.DurationLabel~}</strong> total</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('engaged')">· <strong>{~D:AppData.Layout.EngagedLabel~}</strong> engaged</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('standby')">· {~D:AppData.Layout.IdleLabel~} standby</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('claude')">· Claude working {~D:AppData.Layout.ClaudeWorkingLabel~}</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('user')">· you working {~D:AppData.Layout.UserWorkingLabel~}</span></li>
				</ul>
			</div>
			<div class="cst-stat-card cst-stat-card-visibility">
				<h4>Visible</h4>
				<ul>
					<li><label>
						<span class="cst-color-dot cst-color-dot-chatter"></span>
						<span>{~D:AppData.Layout.ChatterCountLabel~}</span>
						<input type="checkbox" id="cst-toggle-chatter" {~D:AppData.Layout.ChatterCheckedAttr~}
							onchange="_Pict.views.Layout.toggleIntermediaries()" />
					</label></li>
					<li><label>
						<span class="cst-color-dot cst-color-dot-attachments"></span>
						<span>{~D:AppData.Layout.AttachmentCountLabel~}</span>
						<input type="checkbox" id="cst-toggle-attachments" {~D:AppData.Layout.AttachmentsCheckedAttr~}
							onchange="_Pict.views.Layout.toggleAttachments()" />
					</label></li>
					<li><label>
						<span class="cst-color-dot cst-color-dot-tools"></span>
						<span>{~D:AppData.Layout.ToolCountForVisibilityLabel~}</span>
						<input type="checkbox" id="cst-toggle-tools" {~D:AppData.Layout.ToolsCheckedAttr~}
							onchange="_Pict.views.Layout.toggleTools()" />
					</label></li>
				</ul>
			</div>
		</div>
	</div>
	<div class="cst-signature-bar" id="Signature-Container"></div>
	<div class="cst-body">
		<div class="cst-rail" id="Timeline-Container"></div>
		<div class="cst-main" id="Conversation-Container"></div>
		<div class="cst-detail{~NE:AppData.Layout.DetailOpen^ cst-detail-open~}" id="Detail-Container"></div>
	</div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Layout-Display',
			TemplateHash:   'Layout-Display',
			ContentDestinationAddress: '#ClaudeTransformer-Workspace'
		}
	]
};

class PictViewLayout extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.Layout = this.pict.AppData.Layout ||
		{
			DetailOpen: false,
			ShowAttachments: false,
			ShowTools: true,
			ShowIntermediaries: true,
			DurationLabel: '',
			IdleLabel: '',
			EngagedLabel: '',
			ClaudeWorkingLabel: '',
			UserWorkingLabel: '',
			PromptCountLabel: '',
			ToolCountLabel: '',
			AgentCountLabel: '',
			ChatterCountLabel: '',
			AttachmentCountLabel: '',
			ToolCountForVisibilityLabel: '',
			ChatterCheckedAttr: '',
			AttachmentsCheckedAttr: '',
			ToolsCheckedAttr: ''
		};
	}

	updateLabels()
	{
		let tmpStats = (this.pict.AppData.Session && this.pict.AppData.Session.Stats) || {};
		let tmpL = this.pict.AppData.Layout;
		tmpL.DurationLabel = formatDuration(tmpStats.totalDurationMs);
		tmpL.IdleLabel = formatDuration(tmpStats.standbyMs != null ? tmpStats.standbyMs : tmpStats.idleMs);
		tmpL.EngagedLabel = formatDuration(tmpStats.engagedMs != null ? tmpStats.engagedMs : tmpStats.activeMs);
		tmpL.ClaudeWorkingLabel = formatDuration(tmpStats.claudeWorkingMs || 0);
		tmpL.UserWorkingLabel = formatDuration(tmpStats.userWorkingMs || 0);
		tmpL.PromptCountLabel = (tmpStats.promptCount || 0) + ' prompts';
		tmpL.ToolCountLabel = (tmpStats.toolCallCount || 0) + ' tool calls';
		tmpL.AgentCountLabel = (tmpStats.agentCount || 0) + ' subagents';
		tmpL.ChatterCountLabel = (tmpStats.chatterCount || 0) + ' chatter';
		tmpL.AttachmentCountLabel = (tmpStats.attachmentItemCount || 0) + ' attachments';
		tmpL.ToolCountForVisibilityLabel = (tmpStats.toolCallCount || 0) + ' tools';
		tmpL.ChatterCheckedAttr     = tmpL.ShowIntermediaries ? 'checked' : '';
		tmpL.AttachmentsCheckedAttr = tmpL.ShowAttachments    ? 'checked' : '';
		tmpL.ToolsCheckedAttr       = tmpL.ShowTools          ? 'checked' : '';
	}

	toggleIntermediaries()
	{
		this.pict.AppData.Layout.ShowIntermediaries = !this.pict.AppData.Layout.ShowIntermediaries;
		this._afterToggle();
	}

	toggleAttachments()
	{
		this.pict.AppData.Layout.ShowAttachments = !this.pict.AppData.Layout.ShowAttachments;
		this._afterToggle();
	}

	toggleTools()
	{
		this.pict.AppData.Layout.ShowTools = !this.pict.AppData.Layout.ShowTools;
		this._afterToggle();
	}

	_afterToggle()
	{
		// Only the conversation pane needs to update: it reads the new ShowX state and rewrites
		// the visibility classes on its inner container. The browser has already updated the
		// checkbox itself (it was the click target), so Layout's DOM stays untouched — which
		// preserves any open detail pane and the signature/timeline/conversation contents.
		this.updateLabels();
		if (this.pict.views.Conversation) this.pict.views.Conversation.render();
	}

	showMetricsKey(pHighlightKey)
	{
		// pHighlightKey: optional 'total' | 'engaged' | 'standby' | 'claude' | 'user' — when supplied,
		// that row gets visually emphasized so clicking a specific metric jumps you to its definition.
		let tmpModal = this.pict.views.PictSectionModal;
		if (!tmpModal) return;

		let tmpStats = (this.pict.AppData.Session && this.pict.AppData.Session.Stats) || {};
		let tmpL = this.pict.AppData.Layout || {};

		let tmpEntries =
		[
			{
				Key: 'total',
				Term: 'Total',
				Value: tmpL.DurationLabel,
				Definition: 'Wall-clock time from the very first record in the session to the very last. Includes everything — Claude generating, tools running, you typing, you sleeping.'
			},
			{
				Key: 'engaged',
				Term: 'Engaged',
				Value: tmpL.EngagedLabel,
				Definition: 'Time something was actually happening. Equals <code>Total − Standby</code>. This is the sum of <strong>Claude working</strong> + <strong>you working</strong>.'
			},
			{
				Key: 'standby',
				Term: 'Standby',
				Value: tmpL.IdleLabel,
				Definition: 'Long idle gaps where neither you nor Claude was active — typically you walking away from the computer. Any pause longer than 5 minutes between turns counts as standby.'
			},
			{
				Key: 'claude',
				Term: 'Claude working',
				Value: tmpL.ClaudeWorkingLabel,
				Definition: 'Time the model was generating a response or a tool was executing. Computed as the sum of deltas leading into assistant turns and tool-result turns.'
			},
			{
				Key: 'user',
				Term: 'You working',
				Value: tmpL.UserWorkingLabel,
				Definition: 'Time you spent reading replies and composing the next prompt. Sum of deltas leading into your prompts, plus any short pauses (under 5 minutes) — those count as thinking/typing rather than standby.'
			}
		];

		let tmpHTML = '<div class="cst-metric-key"><dl>';
		for (let i = 0; i < tmpEntries.length; i++)
		{
			let tmpE = tmpEntries[i];
			let tmpHighlight = (tmpE.Key === pHighlightKey) ? ' style="background:var(--theme-color-background-hover, #fffae3);border-radius:4px;padding:6px 8px;margin-left:-8px;margin-right:-8px;"' : '';
			tmpHTML += '<div' + tmpHighlight + '>'
				+ '<dt>' + escapeHTML(tmpE.Term) + ' <span class="cst-metric-key-eq">— ' + escapeHTML(tmpE.Value || '0s') + '</span></dt>'
				+ '<dd>' + tmpE.Definition + '</dd>'
				+ '</div>';
		}
		tmpHTML += '</dl>'
			+ '<p style="margin-top:18px;color:var(--theme-color-text-secondary, #5b6376);font-size:12px;font-style:italic;">'
			+ 'By construction: <code>Claude working + you working + Standby = Total</code>.'
			+ '</p>'
			+ '</div>';

		tmpModal.show({
			title:   'Time metrics',
			content: tmpHTML,
			width:   '560px',
			buttons: [{ Hash: 'ok', Label: 'Got it', Style: 'primary' }]
		});
	}

	exportMarkdown()
	{
		let tmpExporter = this.pict.providers.SessionExporter;
		if (tmpExporter) tmpExporter.downloadMarkdown();
	}

	exportPDF()
	{
		let tmpExporter = this.pict.providers.SessionExporter;
		if (tmpExporter) tmpExporter.printPDF();
	}

	reset()
	{
		this.pict.AppData.Session = null;
		let tmpApp = this.pict.PictApplication;
		// Host back-out: plansheet returns to its Sessions list (the standalone
		// viewer went back to its dropzone here).
		if (tmpApp && typeof tmpApp.showSessions === 'function') tmpApp.showSessions();
	}

	openDetail(pTitle, pHTML)
	{
		// Manipulate the detail container directly instead of re-rendering the whole Layout —
		// otherwise the shell rebuild would wipe #Signature-Container / #Timeline-Container /
		// #Conversation-Container and the rest of the page goes blank until something else
		// triggers a render.
		this.pict.AppData.Layout.DetailOpen = true;
		this.pict.ContentAssignment.assignContent('#Detail-Container',
			'<div style="padding:14px 16px;border-bottom:1px solid var(--theme-color-border-light, #e3e6ee);display:flex;align-items:center;">'
			+ '<strong style="flex:1;">' + escapeHTML(pTitle) + '</strong>'
			+ '<button class="cst-action-btn" onclick="_Pict.views.Layout.closeDetail()">Close</button>'
			+ '</div>'
			+ '<div style="padding:14px 16px;">' + pHTML + '</div>');
		let tmpEl = document.getElementById('Detail-Container');
		if (tmpEl) tmpEl.classList.add('cst-detail-open');
	}

	closeDetail()
	{
		this.pict.AppData.Layout.DetailOpen = false;
		let tmpEl = document.getElementById('Detail-Container');
		if (tmpEl) tmpEl.classList.remove('cst-detail-open');
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._attachMetricTooltips();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_attachMetricTooltips()
	{
		// Tooltips must be re-attached on every render — the metric spans are recreated when the
		// header template re-renders, so any previous tooltip handles point at dead DOM.
		let tmpModal = this.pict.views.PictSectionModal;
		if (!tmpModal || typeof tmpModal.tooltip !== 'function') return;

		// Tear down any tooltips we registered on the previous render.
		if (this._metricTooltipHandles)
		{
			for (let i = 0; i < this._metricTooltipHandles.length; i++)
			{
				try { this._metricTooltipHandles[i].destroy(); } catch (e) { /* ignore */ }
			}
		}
		this._metricTooltipHandles = [];

		let tmpTooltips =
		[
			{ Key: 'total',   Text: 'Wall-clock time from session start to end. Click for details.' },
			{ Key: 'engaged', Text: 'Total minus standby — time something was happening (Claude working + you working). Click for details.' },
			{ Key: 'standby', Text: 'Long idle gaps (≥ 5 min) where neither side was active. Click for details.' },
			{ Key: 'claude',  Text: 'Time the model was generating or a tool was running. Click for details.' },
			{ Key: 'user',    Text: 'Time you spent reading replies and composing the next prompt. Includes short pauses under 5 minutes. Click for details.' }
		];

		let tmpSpans = document.querySelectorAll('.cst-stat-card-time .cst-metric');
		for (let i = 0; i < Math.min(tmpSpans.length, tmpTooltips.length); i++)
		{
			let tmpHandle = tmpModal.tooltip(tmpSpans[i], tmpTooltips[i].Text, { position: 'bottom' });
			if (tmpHandle) this._metricTooltipHandles.push(tmpHandle);
		}
	}
}

function formatDuration(pMs)
{
	if (!pMs || pMs < 0) return '0s';
	let tmpS = Math.floor(pMs / 1000);
	if (tmpS < 60) return tmpS + 's';
	let tmpM = Math.floor(tmpS / 60);
	if (tmpM < 60) return tmpM + 'm ' + (tmpS % 60) + 's';
	let tmpH = Math.floor(tmpM / 60);
	if (tmpH < 24) return tmpH + 'h ' + (tmpM % 60) + 'm';
	let tmpD = Math.floor(tmpH / 24);
	return tmpD + 'd ' + (tmpH % 24) + 'h';
}

function escapeHTML(pStr)
{
	if (pStr == null) return '';
	return String(pStr).replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
}

module.exports = PictViewLayout;
module.exports.default_configuration = _ViewConfiguration;
module.exports.formatDuration = formatDuration;
module.exports.escapeHTML = escapeHTML;

},{"pict-view":365}],645:[function(require,module,exports){
const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Signature',
	DefaultRenderable: 'Signature-Display',
	CSS: /*css*/`
		.cst-sig { display: flex; flex-direction: column; gap: 6px; min-height: 0; flex: 1 1 auto; }
		#Signature-PromptRows { overflow-y: auto; min-height: 0; flex: 1 1 auto; }
		.cst-sig-title { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-sig-strip
		{
			position: relative;
			display: flex;
			height: 18px;
			width: 100%;
			border-radius: 4px;
			overflow: hidden;
			background: var(--theme-color-border-light, #e3e6ee);
			cursor: pointer;
		}
		.cst-sig-seg
		{
			height: 100%;
			min-width: 1px;
			transition: filter 0.1s;
		}
		.cst-sig-seg:hover { filter: brightness(1.15) saturate(1.2); }
		.cst-sig-seg-userprompt   { background: #2e8b57; }
		.cst-sig-seg-assistant    { background: var(--theme-color-brand-primary, #4a7ad6); }
		.cst-sig-seg-thinking     { background: #6f88c7; }
		.cst-sig-seg-tool-read    { background: var(--theme-color-brand-accent, #b07acc); }
		.cst-sig-seg-tool-write   { background: #d18ba2; }
		.cst-sig-seg-tool-bash    { background: #c87a3a; }
		.cst-sig-seg-tool-search  { background: #d4b94a; }
		.cst-sig-seg-tool-agent   { background: #e07b3a; }
		.cst-sig-seg-tool-other   { background: #9b8fb1; }
		.cst-sig-seg-tool-result  { background: #c8c5dd; }
		.cst-sig-seg-attachment   { background: #b8c4d6; }
		.cst-sig-seg-system       { background: var(--theme-color-status-error, #c0353a); }
		.cst-sig-seg-gap
		{
			background:
				repeating-linear-gradient(
					45deg,
					#9aa1b1 0,
					#9aa1b1 4px,
					#7a8092 4px,
					#7a8092 8px);
		}
		.cst-sig-prompt-row { display: flex; align-items: center; gap: 8px; }
		.cst-sig-prompt-label { width: 22px; text-align: right; font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); flex: 0 0 auto; }
		.cst-sig-prompt-strip { flex: 1 1 auto; height: 10px; border-radius: 2px; background: var(--theme-color-border-light, #e3e6ee); display: flex; overflow: hidden; cursor: pointer; }
		.cst-sig-prompt-strip .cst-sig-seg { height: 100%; }
		.cst-sig-prompt-meta { font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); flex: 0 0 auto; min-width: 110px; text-align: right; }
		.cst-sig-legend { display: flex; flex-wrap: wrap; gap: 10px; font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-sig-legend-item { display: flex; align-items: center; gap: 4px; }
		.cst-sig-legend-swatch { width: 10px; height: 10px; border-radius: 2px; }
		.cst-sig-tooltip
		{
			position: absolute;
			background: var(--theme-color-text-primary, #1d2230);
			color: var(--theme-color-background-panel, #fff);
			padding: 4px 7px;
			border-radius: 3px;
			font-size: 11px;
			pointer-events: none;
			transform: translate(-50%, -130%);
			white-space: nowrap;
			z-index: 10;
			opacity: 0;
			transition: opacity 0.1s;
		}
		.cst-sig-tooltip.cst-sig-tooltip-visible { opacity: 1; }
	`,
	Templates:
	[
		{
			Hash: 'Signature-Display',
			Template: /*html*/`
<div class="cst-sig">
	<div class="cst-sig-title">Session signature — active time + idle gaps (compressed)</div>
	<div class="cst-sig-strip" id="Signature-MainStrip"
		onmousemove="_Pict.views.Signature.onStripHover(event, this)"
		onmouseleave="_Pict.views.Signature.hideTooltip()"
		onclick="_Pict.views.Signature.onStripClick(event, this)">
	</div>
	<div id="Signature-PromptRows"></div>
	<div class="cst-sig-legend">
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-userprompt"></span>prompt</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-assistant"></span>assistant text</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-thinking"></span>thinking</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-read"></span>read</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-write"></span>write/edit</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-bash"></span>bash</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-search"></span>search</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-agent"></span>agent</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-other"></span>other tool</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-system"></span>system/error</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-gap"></span>idle (compressed)</span>
	</div>
	<div class="cst-sig-tooltip" id="Signature-Tooltip"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Signature-Display',
			TemplateHash:   'Signature-Display',
			ContentDestinationAddress: '#Signature-Container'
		}
	]
};

class PictViewSignature extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._segments = [];                              // current main strip segments (for hover lookup)
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._renderMainStrip();
		this._renderPromptRows();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_renderMainStrip()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Turns || !tmpSession.Turns.length) return;

		let tmpSegments = this._buildSegments(tmpSession.Turns);
		let tmpFirst = tmpSession.Turns[0].TimestampMs;
		let tmpLast = tmpSession.Turns[tmpSession.Turns.length - 1].TimestampMs || tmpFirst;
		let tmpScale = this._buildCompressedScale(tmpSegments, tmpFirst, tmpLast);
		let tmpHTML = '';
		this._segments = [];
		for (let i = 0; i < tmpSegments.length; i++)
		{
			let tmpSeg = tmpSegments[i];
			let tmpStartPct = tmpScale.toPct(tmpSeg.StartMs);
			let tmpEndPct = tmpScale.toPct(tmpSeg.EndMs);
			let tmpWidthPct = Math.max(tmpEndPct - tmpStartPct, 0);
			if (tmpWidthPct < 0.05) tmpWidthPct = 0.05;
			tmpSeg.RenderStartPct = tmpStartPct;
			tmpSeg.RenderEndPct = tmpStartPct + tmpWidthPct;
			this._segments.push(tmpSeg);
			tmpHTML += '<div class="cst-sig-seg cst-sig-seg-' + tmpSeg.ColorClass + '" '
				+ 'style="width:' + tmpWidthPct.toFixed(3) + '%" '
				+ 'data-seg="' + i + '"></div>';
		}
		this.pict.ContentAssignment.assignContent('#Signature-MainStrip', tmpHTML);
	}

	_renderPromptRows()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Prompts || !tmpSession.Prompts.length) return;

		let tmpRowsHTML = '';
		for (let i = 0; i < tmpSession.Prompts.length; i++)
		{
			let tmpGroup = tmpSession.Prompts[i];
			// Pull the slice of turns for this prompt group.
			let tmpTurns = [];
			for (let j = 0; j < tmpGroup.TurnIndices.length; j++)
			{
				tmpTurns.push(tmpSession.Turns[tmpGroup.TurnIndices[j]]);
			}
			if (!tmpTurns.length) continue;
			let tmpSegments = this._buildSegments(tmpTurns);
			let tmpFirst = tmpGroup.FirstTimestampMs;
			let tmpLast = tmpGroup.LastTimestampMs || tmpFirst;
			let tmpScale = this._buildCompressedScale(tmpSegments, tmpFirst, tmpLast);
			let tmpStripHTML = '';
			for (let k = 0; k < tmpSegments.length; k++)
			{
				let tmpSeg = tmpSegments[k];
				let tmpW = tmpScale.toPct(tmpSeg.EndMs) - tmpScale.toPct(tmpSeg.StartMs);
				if (tmpW < 0.05) tmpW = 0.05;
				tmpStripHTML += '<div class="cst-sig-seg cst-sig-seg-' + tmpSeg.ColorClass + '" '
					+ 'style="width:' + tmpW.toFixed(3) + '%"></div>';
			}
			let tmpTitle = (tmpGroup.Title || 'prompt ' + (i + 1)).replace(/"/g, '&quot;');
			tmpRowsHTML += '<div class="cst-sig-prompt-row" title="' + tmpTitle + '">'
				+ '<span class="cst-sig-prompt-label">#' + (i + 1) + '</span>'
				+ '<span class="cst-sig-prompt-strip" onclick="_Pict.views.Conversation.scrollToPrompt(\'' + tmpGroup.PromptId + '\')">'
				+ tmpStripHTML
				+ '</span>'
				+ '<span class="cst-sig-prompt-meta">'
				+ libLayout.formatDuration(tmpGroup.TotalDurationMs) + ' · '
				+ tmpGroup.ToolCallCount + 't'
				+ (tmpGroup.AgentCallCount ? ' · ' + tmpGroup.AgentCallCount + 'a' : '')
				+ '</span>'
				+ '</div>';
		}
		this.pict.ContentAssignment.assignContent('#Signature-PromptRows', tmpRowsHTML);
	}

	_buildSegments(pTurns)
	{
		// Each turn becomes one (or more, for assistant turns with multiple tool_use blocks) segments;
		// gaps are emitted as their own segment with the "gap" color class.
		let tmpSegments = [];
		for (let i = 0; i < pTurns.length; i++)
		{
			let tmpTurn = pTurns[i];
			let tmpStart = tmpTurn.TimestampMs;
			let tmpEnd = (i + 1 < pTurns.length && pTurns[i + 1].TimestampMs)
				? pTurns[i + 1].TimestampMs
				: tmpStart + 1000;                     // tail segment minimum width
			if (!tmpStart) continue;

			if (tmpTurn.Kind === 'gap')
			{
				tmpSegments.push({
					Kind: 'gap',
					ColorClass: 'gap',
					StartMs: tmpStart,
					EndMs: tmpTurn.EndTimestampMs || tmpEnd,
					IsGap: true,
					Label: 'idle ' + libLayout.formatDuration(tmpTurn.DurationMs),
					TurnIndex: i
				});
				continue;
			}

			let tmpColor = this._colorForTurn(tmpTurn);
			tmpSegments.push({
				Kind: tmpTurn.Kind,
				ColorClass: tmpColor.Class,
				Label: tmpColor.Label,
				StartMs: tmpStart,
				EndMs: tmpEnd,
				IsGap: false,
				TurnIndex: i,
				PromptId: tmpTurn.PromptId
			});
		}
		return tmpSegments;
	}

	_colorForTurn(pTurn)
	{
		if (pTurn.Kind === 'user-prompt') return { Class: 'userprompt', Label: 'user prompt' };
		if (pTurn.Kind === 'tool-result') return { Class: 'tool-result', Label: 'tool result' };
		if (pTurn.Kind === 'attachment')  return { Class: 'attachment',  Label: 'attachment' };
		if (pTurn.Kind === 'system')      return { Class: 'system',      Label: 'system / hook' };
		if (pTurn.Kind === 'assistant')
		{
			// Pick the dominant block in this assistant turn.
			let tmpHasToolUse = false;
			let tmpToolName = null;
			let tmpHasThinking = false;
			let tmpHasText = false;
			for (let i = 0; i < pTurn.Blocks.length; i++)
			{
				let tmpB = pTurn.Blocks[i];
				if (tmpB.Type === 'tool_use') { tmpHasToolUse = true; if (!tmpToolName) tmpToolName = tmpB.Name; }
				if (tmpB.Type === 'thinking') tmpHasThinking = true;
				if (tmpB.Type === 'text')     tmpHasText = true;
			}
			if (tmpHasToolUse)
			{
				let tmpFamily = toolFamily(tmpToolName);
				return { Class: 'tool-' + tmpFamily, Label: tmpToolName || 'tool' };
			}
			if (tmpHasText)     return { Class: 'assistant', Label: 'assistant text' };
			if (tmpHasThinking) return { Class: 'thinking',  Label: 'thinking' };
			return { Class: 'assistant', Label: 'assistant' };
		}
		return { Class: 'attachment', Label: pTurn.Kind };
	}

	_buildCompressedScale(pSegments, pFirstMs, pLastMs)
	{
		// Active spans (non-gap) get linear time. Gaps share a fixed budget logarithmically.
		// This means a 5h gap becomes a visible sliver, but doesn't dominate.
		let tmpActiveTotal = 0;
		let tmpGaps = [];
		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpDur = Math.max(0, pSegments[i].EndMs - pSegments[i].StartMs);
			if (pSegments[i].IsGap) tmpGaps.push(tmpDur);
			else tmpActiveTotal += tmpDur;
		}
		// Map each gap to a compressed weight: log10(1 + minutes) — a 1-min gap ≈ 0.04, a 5h gap ≈ 2.5.
		let tmpGapWeights = tmpGaps.map((pMs) => Math.log10(1 + pMs / 60000));
		let tmpGapWeightTotal = tmpGapWeights.reduce((pA, pB) => pA + pB, 0);

		// Allocate 75% of the strip to active time, 25% to gap weights — but if there are no gaps,
		// active gets 100%; if there's no active time, gaps get everything.
		let tmpActiveBudget = tmpGapWeightTotal > 0 ? 0.75 : 1.0;
		let tmpGapBudget    = tmpGapWeightTotal > 0 ? 0.25 : 0.0;
		if (tmpActiveTotal === 0) { tmpActiveBudget = 0; tmpGapBudget = 1.0; }

		// Build a piecewise mapping from real-ms → strip-fraction.
		let tmpAnchors = [{ Ms: pFirstMs, Pct: 0 }];
		let tmpGapIdx = 0;
		let tmpRunPct = 0;
		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSeg = pSegments[i];
			let tmpDur = Math.max(0, tmpSeg.EndMs - tmpSeg.StartMs);
			let tmpDeltaPct;
			if (tmpSeg.IsGap)
			{
				let tmpW = tmpGapWeights[tmpGapIdx++] || 0;
				tmpDeltaPct = tmpGapWeightTotal > 0 ? (tmpW / tmpGapWeightTotal) * tmpGapBudget * 100 : 0;
			}
			else
			{
				tmpDeltaPct = tmpActiveTotal > 0 ? (tmpDur / tmpActiveTotal) * tmpActiveBudget * 100 : 0;
			}
			tmpRunPct += tmpDeltaPct;
			tmpAnchors.push({ Ms: tmpSeg.EndMs, Pct: tmpRunPct });
		}

		return {
			toPct: (pMs) =>
			{
				// Find the bracketing anchors and interpolate linearly.
				if (pMs <= tmpAnchors[0].Ms) return tmpAnchors[0].Pct;
				if (pMs >= tmpAnchors[tmpAnchors.length - 1].Ms) return tmpAnchors[tmpAnchors.length - 1].Pct;
				for (let i = 1; i < tmpAnchors.length; i++)
				{
					let tmpPrev = tmpAnchors[i - 1];
					let tmpCur = tmpAnchors[i];
					if (pMs <= tmpCur.Ms)
					{
						let tmpRange = tmpCur.Ms - tmpPrev.Ms;
						if (tmpRange <= 0) return tmpCur.Pct;
						let tmpRatio = (pMs - tmpPrev.Ms) / tmpRange;
						return tmpPrev.Pct + tmpRatio * (tmpCur.Pct - tmpPrev.Pct);
					}
				}
				return tmpAnchors[tmpAnchors.length - 1].Pct;
			}
		};
	}

	onStripHover(pEvent, pStrip)
	{
		let tmpRect = pStrip.getBoundingClientRect();
		let tmpPct = ((pEvent.clientX - tmpRect.left) / tmpRect.width) * 100;
		let tmpSeg = null;
		for (let i = 0; i < this._segments.length; i++)
		{
			if (this._segments[i].RenderStartPct <= tmpPct && this._segments[i].RenderEndPct >= tmpPct)
			{
				tmpSeg = this._segments[i];
				break;
			}
		}
		if (!tmpSeg) { this.hideTooltip(); return; }
		let tmpDate = new Date(tmpSeg.StartMs);
		let tmpDur = libLayout.formatDuration(tmpSeg.EndMs - tmpSeg.StartMs);
		let tmpLabel = (tmpSeg.IsGap ? tmpSeg.Label : tmpSeg.Label + ' · ' + tmpDur)
			+ ' · ' + tmpDate.toLocaleString();
		let tmpTip = document.getElementById('Signature-Tooltip');
		if (!tmpTip) return;
		tmpTip.textContent = tmpLabel;
		tmpTip.style.left = (pEvent.clientX - tmpRect.left + pStrip.offsetLeft) + 'px';
		tmpTip.style.top = (pStrip.offsetTop) + 'px';
		tmpTip.classList.add('cst-sig-tooltip-visible');
	}

	hideTooltip()
	{
		let tmpTip = document.getElementById('Signature-Tooltip');
		if (tmpTip) tmpTip.classList.remove('cst-sig-tooltip-visible');
	}

	onStripClick(pEvent, pStrip)
	{
		let tmpRect = pStrip.getBoundingClientRect();
		let tmpPct = ((pEvent.clientX - tmpRect.left) / tmpRect.width) * 100;
		for (let i = 0; i < this._segments.length; i++)
		{
			if (this._segments[i].RenderStartPct <= tmpPct && this._segments[i].RenderEndPct >= tmpPct)
			{
				if (this.pict.views.Conversation && this._segments[i].PromptId)
				{
					this.pict.views.Conversation.scrollToPrompt(this._segments[i].PromptId);
				}
				else if (this.pict.views.Conversation)
				{
					this.pict.views.Conversation.scrollToTurn(this._segments[i].TurnIndex);
				}
				return;
			}
		}
	}
}

function toolFamily(pName)
{
	if (!pName) return 'other';
	if (/^Read|Glob|^NotebookRead/i.test(pName)) return 'read';
	if (/^(Write|Edit|NotebookEdit|MultiEdit)/i.test(pName)) return 'write';
	if (/^Bash/i.test(pName)) return 'bash';
	if (/^(Grep|WebSearch|WebFetch|Search)/i.test(pName)) return 'search';
	if (/^(Task|Agent|Subagent)/i.test(pName)) return 'agent';
	return 'other';
}

module.exports = PictViewSignature;
module.exports.default_configuration = _ViewConfiguration;
module.exports.toolFamily = toolFamily;

},{"./PictView-Layout.js":644,"pict-view":365}],646:[function(require,module,exports){
const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Timeline',
	DefaultRenderable: 'Timeline-Display',
	CSS: /*css*/`
		.cst-tl { padding: 8px 0; }
		.cst-tl-item
		{
			display: block;
			padding: 8px 14px;
			cursor: pointer;
			border-left: 3px solid transparent;
			font-size: 13px;
		}
		.cst-tl-item:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-tl-item.cst-tl-item-active { border-left-color: var(--theme-color-brand-primary, #4a7ad6); background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-tl-prompt-num { font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-tl-prompt-title { font-weight: 500; color: var(--theme-color-text-primary, #1d2230); line-height: 1.3; margin: 2px 0 4px 0; }
		.cst-tl-prompt-meta { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-tl-gap
		{
			display: flex; align-items: center; gap: 8px;
			padding: 4px 14px;
			color: #7a8092;
			font-size: 11px;
			font-style: italic;
		}
		.cst-tl-gap-bar
		{
			display: inline-block;
			height: 2px;
			width: 28px;
			background: repeating-linear-gradient(90deg, #9aa1b1 0 4px, transparent 4px 8px);
		}
	`,
	Templates:
	[
		{
			Hash: 'Timeline-Display',
			Template: /*html*/`
<div class="cst-tl" id="Timeline-Inner"></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Timeline-Display',
			TemplateHash:   'Timeline-Display',
			ContentDestinationAddress: '#Timeline-Container'
		}
	]
};

class PictViewTimeline extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._buildItems();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_buildItems()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Prompts) return;

		// Walk turns; emit one item per prompt group, plus a gap marker for human-facing gaps that
		// occur *between* prompt groups (i.e. a gap whose previous turn was inside a different group).
		let tmpHTML = '';
		let tmpRenderedGroups = {};
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			if (tmpT.Kind === 'gap')
			{
				tmpHTML += '<div class="cst-tl-gap"><span class="cst-tl-gap-bar"></span> idle '
					+ libLayout.formatDuration(tmpT.DurationMs) + '</div>';
				continue;
			}
			if (tmpT.PromptId && !tmpRenderedGroups[tmpT.PromptId])
			{
				tmpRenderedGroups[tmpT.PromptId] = true;
				let tmpGroup = tmpSession.Prompts.find((pG) => pG.PromptId === tmpT.PromptId);
				if (!tmpGroup) continue;
				let tmpIdx = tmpSession.Prompts.indexOf(tmpGroup) + 1;
				let tmpLatency = tmpGroup.ResponseLatencyMs != null
					? 'replied in ' + libLayout.formatDuration(tmpGroup.ResponseLatencyMs)
					: '—';
				tmpHTML += '<div class="cst-tl-item" id="Timeline-Item-' + tmpGroup.PromptId + '" '
					+ 'onclick="_Pict.views.Conversation.scrollToPrompt(\'' + tmpGroup.PromptId + '\')">'
					+ '<div class="cst-tl-prompt-num">Prompt #' + tmpIdx + ' · ' + new Date(tmpGroup.FirstTimestampMs).toLocaleTimeString() + '</div>'
					+ '<div class="cst-tl-prompt-title">' + libLayout.escapeHTML(tmpGroup.Title || '(no text)') + '</div>'
					+ '<div class="cst-tl-prompt-meta">' + libLayout.formatDuration(tmpGroup.TotalDurationMs)
					+ ' · ' + tmpGroup.ToolCallCount + ' tools'
					+ (tmpGroup.AgentCallCount ? ' · ' + tmpGroup.AgentCallCount + ' agents' : '')
					+ ' · ' + tmpLatency
					+ '</div>'
					+ '</div>';
			}
		}
		this.pict.ContentAssignment.assignContent('#Timeline-Inner', tmpHTML);
	}

	highlight(pPromptId)
	{
		let tmpItems = document.querySelectorAll('.cst-tl-item');
		for (let i = 0; i < tmpItems.length; i++) tmpItems[i].classList.remove('cst-tl-item-active');
		let tmpActive = document.getElementById('Timeline-Item-' + pPromptId);
		if (tmpActive) tmpActive.classList.add('cst-tl-item-active');
	}
}

module.exports = PictViewTimeline;
module.exports.default_configuration = _ViewConfiguration;

},{"./PictView-Layout.js":644,"pict-view":365}],647:[function(require,module,exports){
const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'ToolDetail',
	DefaultRenderable: 'ToolDetail-Empty',
	CSS: /*css*/`
		.cst-td-input { background: var(--theme-color-text-primary, #1d2230); color: #d8dde8; padding: 10px 12px; border-radius: 4px; font-family: monospace; font-size: 11px; white-space: pre-wrap; max-height: 300px; overflow: auto; }
		.cst-td-output { background: var(--theme-color-text-primary, #1d2230); color: #d8dde8; padding: 10px 12px; border-radius: 4px; font-family: monospace; font-size: 11px; white-space: pre-wrap; max-height: 500px; overflow: auto; margin-top: 10px; }
		.cst-td-meta { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin: 10px 0; }
	`,
	Templates:
	[
		{ Hash: 'ToolDetail-Empty', Template: '<span></span>' }
	],
	Renderables: []
};

class PictViewToolDetail extends libPictView
{
	openTool(pToolUseId)
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession) return;

		let tmpToolUse = null;
		let tmpToolResult = null;
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			for (let j = 0; j < tmpT.Blocks.length; j++)
			{
				let tmpB = tmpT.Blocks[j];
				if (tmpB.Type === 'tool_use' && tmpB.ToolUseId === pToolUseId) tmpToolUse = tmpB;
				if (tmpB.Type === 'tool_result' && tmpB.ToolUseId === pToolUseId) tmpToolResult = tmpB;
			}
		}

		if (!tmpToolUse) return;

		let tmpHTML = '';
		tmpHTML += '<div class="cst-td-meta">Tool: <strong>' + libLayout.escapeHTML(tmpToolUse.Name) + '</strong></div>';
		if (tmpToolResult && tmpToolResult.DurationMs != null)
		{
			tmpHTML += '<div class="cst-td-meta">Duration: ' + libLayout.formatDuration(tmpToolResult.DurationMs) + '</div>';
		}
		if (tmpToolResult && tmpToolResult.IsError)
		{
			tmpHTML += '<div class="cst-td-meta" style="color:var(--theme-color-status-error, #c0353a);">Error</div>';
		}
		tmpHTML += '<div style="font-size:11px;color:var(--theme-color-text-secondary, #5b6376);margin-bottom:4px;">Input</div>';
		tmpHTML += '<div class="cst-td-input">' + libLayout.escapeHTML(JSON.stringify(tmpToolUse.Input || {}, null, 2)) + '</div>';
		if (tmpToolResult)
		{
			tmpHTML += '<div style="font-size:11px;color:var(--theme-color-text-secondary, #5b6376);margin-top:14px;margin-bottom:4px;">Output'
				+ (tmpToolResult.PersistedPath ? ' <em>(spilled to ' + libLayout.escapeHTML(tmpToolResult.PersistedPath) + ')</em>' : '')
				+ '</div>';
			tmpHTML += '<div class="cst-td-output">' + libLayout.escapeHTML(tmpToolResult.ContentText || '')
				+ (tmpToolResult.ContentTruncated ? '\n\n[truncated]' : '') + '</div>';
		}

		this.pict.views.Layout.openDetail(tmpToolUse.Name + ' details', tmpHTML);
	}
}

module.exports = PictViewToolDetail;
module.exports.default_configuration = _ViewConfiguration;

},{"./PictView-Layout.js":644,"pict-view":365}],648:[function(require,module,exports){
'use strict';

/**
 * AvatarHelper
 * ------------
 * Returns a self-contained avatar element (string) for a user: their photo thumb
 * if they have one, otherwise a colored circle with their initials. Styles are
 * inline so it drops into any template or innerHTML without needing CSS injected
 * first (topbar, user settings, and the team list all reuse it).
 *
 *   AvatarHelper.avatarHTML({ IDUser, PhotoHash, DisplayName, Email, Color }, { Size: 28 })
 *
 * The initials background uses the user's chosen Color when it is a valid hex;
 * otherwise a stable color is derived from the name so each person is consistent.
 */

function _esc(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _isHex(pColor)
{
	return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(String(pColor || ''));
}

function _luminance(pHex)
{
	let tmpHex = String(pHex).replace('#', '');
	if (tmpHex.length === 3) { tmpHex = tmpHex.split('').map((pCh) => pCh + pCh).join(''); }
	let tmpR = parseInt(tmpHex.slice(0, 2), 16);
	let tmpG = parseInt(tmpHex.slice(2, 4), 16);
	let tmpB = parseInt(tmpHex.slice(4, 6), 16);
	return (0.299 * tmpR + 0.587 * tmpG + 0.114 * tmpB) / 255;
}

// Stable mid-tone color derived from a string (used when no Color is set).
function _derivedColor(pStr)
{
	let tmpStr = String(pStr || 'x');
	let tmpHash = 0;
	for (let i = 0; i < tmpStr.length; i++) { tmpHash = (tmpHash * 31 + tmpStr.charCodeAt(i)) >>> 0; }
	return 'hsl(' + (tmpHash % 360) + ', 52%, 45%)';
}

function initials(pName)
{
	let tmpName = String(pName || '').trim();
	if (!tmpName) { return '?'; }
	// For an email-looking value, use the local part before the @.
	if (tmpName.indexOf('@') > 0 && tmpName.indexOf(' ') < 0) { tmpName = tmpName.split('@')[0]; }
	let tmpParts = tmpName.replace(/[^a-zA-Z0-9 ]/g, ' ').trim().split(/\s+/).filter(Boolean);
	if (!tmpParts.length) { return '?'; }
	if (tmpParts.length === 1) { return tmpParts[0].slice(0, 2).toUpperCase(); }
	return (tmpParts[0].charAt(0) + tmpParts[tmpParts.length - 1].charAt(0)).toUpperCase();
}

function backgroundFor(pColor, pName)
{
	return _isHex(pColor) ? pColor : _derivedColor(pName);
}

function onColorFor(pColor)
{
	if (_isHex(pColor)) { return _luminance(pColor) > 0.6 ? '#1d2230' : '#ffffff'; }
	return '#ffffff';
}

function avatarHTML(pUser, pOptions)
{
	let tmpUser = pUser || {};
	let tmpOpts = pOptions || {};
	let tmpSize = tmpOpts.Size || 28;
	let tmpName = tmpUser.DisplayName || tmpUser.Email || tmpUser.LoginID || 'You';
	let tmpRadius = tmpOpts.Square ? '6px' : '50%';
	let tmpBase = 'display:inline-flex;flex:0 0 auto;box-sizing:border-box;width:' + tmpSize + 'px;height:' + tmpSize + 'px;border-radius:' + tmpRadius + ';vertical-align:middle;';

	if (tmpUser.PhotoHash && tmpUser.IDUser)
	{
		let tmpURL = '/1.0/Profile/Photo/' + encodeURIComponent(tmpUser.IDUser) + '?thumb=1&v=' + encodeURIComponent(tmpUser.PhotoHash);
		return '<img class="cst-avatar" alt="' + _esc(tmpName) + '" src="' + tmpURL + '" style="' + tmpBase + 'object-fit:cover;border:0;background:rgba(0,0,0,0.06);" />';
	}

	let tmpBg = backgroundFor(tmpUser.Color, tmpName);
	let tmpFg = onColorFor(tmpUser.Color);
	let tmpFont = Math.max(9, Math.round(tmpSize * 0.42));
	return '<span class="cst-avatar cst-avatar-initials" aria-label="' + _esc(tmpName) + '" style="' + tmpBase
		+ 'align-items:center;justify-content:center;background:' + tmpBg + ';color:' + tmpFg + ';font-size:' + tmpFont + 'px;font-weight:600;line-height:1;letter-spacing:0.02em;">'
		+ _esc(initials(tmpName)) + '</span>';
}

module.exports =
{
	avatarHTML: avatarHTML,
	initials: initials,
	backgroundFor: backgroundFor,
	onColorFor: onColorFor
};

},{}],649:[function(require,module,exports){
'use strict';

/**
 * MarkdownRender
 * --------------
 * Renders markdown read-only into a DOM container using the same pieces the
 * editor's live preview uses: pict-section-content's parseMarkdown() for the
 * HTML, then mermaid.run() and katex.render() to activate diagrams and math.
 * mermaid + katex are loaded as globals by html/index.html. Browser-only.
 *
 *   MarkdownRender.renderInto(this.pict.providers.Content, containerEl, markdown)
 */

function _activateMermaid(pContainer)
{
	if (typeof window === 'undefined' || typeof window.mermaid === 'undefined' || !pContainer) { return; }
	let tmpNodes = pContainer.querySelectorAll('pre.mermaid');
	if (!tmpNodes.length) { return; }
	// mermaid.run() consumes the element text; cache the source so a re-render works.
	for (let i = 0; i < tmpNodes.length; i++)
	{
		if (!tmpNodes[i].hasAttribute('data-mermaid-source')) { tmpNodes[i].setAttribute('data-mermaid-source', tmpNodes[i].textContent); }
	}
	try
	{
		let tmpResult = window.mermaid.run({ nodes: tmpNodes });
		if (tmpResult && typeof tmpResult.catch === 'function') { tmpResult.catch(() => { /* diagram errors render inline */ }); }
	}
	catch (pError) { /* mermaid not ready */ }
}

function _activateKaTeX(pContainer)
{
	if (typeof window === 'undefined' || typeof window.katex === 'undefined' || !pContainer) { return; }
	let tmpInline = pContainer.querySelectorAll('.pict-content-katex-inline');
	for (let i = 0; i < tmpInline.length; i++)
	{
		try { window.katex.render(tmpInline[i].textContent, tmpInline[i], { throwOnError: false, displayMode: false }); }
		catch (pError) { /* leave the raw source */ }
	}
	let tmpDisplay = pContainer.querySelectorAll('.pict-content-katex-display');
	for (let i = 0; i < tmpDisplay.length; i++)
	{
		try { window.katex.render(tmpDisplay[i].textContent, tmpDisplay[i], { throwOnError: false, displayMode: true }); }
		catch (pError) { /* leave the raw source */ }
	}
}

// Escape the HTML-significant characters so raw HTML in UNTRUSTED markdown (a node's reply, any externally
// sourced text) cannot inject a tag or break out of a double-quoted attribute. Markdown syntax (* # [] () `) is
// untouched, so links, emphasis and headings still render; only literal & < > " are neutralized. Escape & first.
function _escapeHTML(pText)
{
	return String(pText || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// A link resolver for untrusted content: only http(s) links survive (opening in a new tab); anything else
// (javascript:, data:, a relative path) is defanged to '#'. parseMarkdown inserts the resolved href verbatim,
// so it is handed the href from the already-escaped source.
function _safeLinkResolver(pHref)
{
	if (/^https?:\/\//i.test(String(pHref || ''))) { return { href: String(pHref), target: '_blank', rel: 'noopener noreferrer' }; }
	return { href: '#' };
}

/**
 * Parse pMarkdown to HTML via the Content provider and drop it into pContainerEl
 * (wrapped in .pict-content), then activate diagrams + math.
 *
 * pUntrusted (true for a node reply or any externally sourced markdown): HTML-escape the source before parsing
 * so raw tags cannot execute, and resolve links through a scheme allowlist. The provider's inline-HTML
 * passthrough is kept for trusted callers (the docs library, authored prompts) where pUntrusted is falsy.
 */
function renderInto(pProvider, pContainerEl, pMarkdown, pEmptyHTML, pUntrusted)
{
	if (!pContainerEl) { return; }
	let tmpMarkdown = (typeof pMarkdown === 'string') ? pMarkdown : '';
	if (!tmpMarkdown.trim())
	{
		pContainerEl.innerHTML = pEmptyHTML || '';
		return;
	}
	let tmpSource = pUntrusted ? _escapeHTML(tmpMarkdown) : tmpMarkdown;
	let tmpResolver = pUntrusted ? _safeLinkResolver : null;
	let tmpHTML = '';
	try { tmpHTML = (pProvider && typeof pProvider.parseMarkdown === 'function') ? (pProvider.parseMarkdown(tmpSource, tmpResolver, null, null) || '') : ''; }
	catch (pError) { tmpHTML = ''; }
	pContainerEl.innerHTML = '<div class="pict-content">' + tmpHTML + '</div>';
	let tmpBody = pContainerEl.querySelector('.pict-content');
	_activateMermaid(tmpBody);
	_activateKaTeX(tmpBody);
}

module.exports = { renderInto: renderInto };

},{}],650:[function(require,module,exports){
'use strict';

/**
 * Markup-Templates
 * ----------------
 * The shared rendering half of Pict-Provider-Markup: one title block, one cell strip, one tooltip,
 * spread into any view that shows an entity.
 *
 * What is shared here is the MARK, not the container. A card on the kanban is draggable and opens a
 * record; a row in a list is not; a tooltip floats. Those wrappers belong to their surfaces and carry
 * their own handlers. The designator cell, the ruled title block, and the labelled cells underneath
 * are identical everywhere, so they live here and every surface composes them:
 *
 *   {~TS:Markup-TitleBlock:Record.Mark~}    the mark: designator cell + title, ruled
 *   {~TS:Markup-Designator:Record.Mark~}    the designator alone, for a surface with its own columns
 *   {~TS:Markup-Cell:Record.Cells~}         the labelled cells, one per entry
 *   {~TS:Markup-Tooltip:Record.Tip~}        the loaded tooltip body
 *
 * Templates are view-owned in Pict, so these are exported as plain definitions to spread into a
 * view's own Templates array rather than registered globally. That keeps one source of truth without
 * fighting the framework's model.
 *
 * Visual direction is the drafting title block: square corners, hairline rules, the designator in its
 * own bordered cell. Colour comes entirely from theme tokens, so the mark holds on Plan Sheet paper
 * and on a Blueprint cyanotype without a second definition.
 */

// The mark, and the furniture around it. No backticks anywhere in this string: it is interpolated
// into a CSS template literal by whichever view spreads it.
const MarkupCSS = /*css*/`
	.ps-mark { display: flex; align-items: stretch; border: 1px solid var(--theme-color-border-strong, #a89f87);
		background: var(--theme-color-background-panel, #fbf8f0); min-width: 0; }
	.ps-mark-d { flex: 0 0 auto; display: flex; align-items: center; padding: 4px 8px; font-size: 11.5px;
		font-weight: 700; letter-spacing: 0.05em; font-variant-numeric: tabular-nums;
		font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
		border-right: 1px solid var(--theme-color-border-strong, #a89f87);
		background: var(--theme-color-background-tertiary, #e5dcc7);
		color: var(--theme-color-text-primary, #2b2d2f); white-space: nowrap; }
	.ps-mark-t { flex: 1; min-width: 0; padding: 4px 9px; font-size: 13px; line-height: 1.35;
		color: var(--theme-color-text-primary, #2b2d2f); }
	.ps-mark-inline { display: inline-flex; vertical-align: middle; font-size: 12px; }
	.ps-mark-inline .ps-mark-t { padding: 2px 7px; font-size: 12px; }
	.ps-mark-inline .ps-mark-d { padding: 2px 6px; font-size: 11px; }

	/* The designator on its own, for a surface that already has columns of its own to sit in (a
	   list row). Only the typography of the mark lives here: WI-014 has to read as the same object
	   it does on a card. Whether it gets a box, a rule, or a background is the container's call,
	   so a list cell adds that itself rather than this reaching into the surface. */
	.ps-mark-solo { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
		font-variant-numeric: tabular-nums; font-weight: 700; font-size: 11.5px; letter-spacing: 0.05em;
		white-space: nowrap; color: var(--theme-color-brand-primary, #1d5fa8); }

	.ps-cells { display: flex; flex-wrap: wrap; gap: 0; border-top: 1px solid var(--theme-color-border-light, #dfd7c4); }
	.ps-cell { flex: 1 1 0; min-width: 0; padding: 3px 8px;
		border-right: 1px solid var(--theme-color-border-light, #dfd7c4); }
	.ps-cell:last-child { border-right: 0; }
	.ps-cell-k { display: block; font-size: 8.5px; letter-spacing: 0.13em; text-transform: uppercase;
		color: var(--theme-color-text-muted, #6c6a60); }
	.ps-cell-v { display: block; font-size: 11.5px; color: var(--theme-color-text-secondary, #46484a);
		overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

	.ps-tip { min-width: 260px; max-width: 400px; }
	.ps-tip-desc { margin: 9px 0 0; font-size: 12.5px; line-height: 1.45;
		color: var(--theme-color-text-secondary, #46484a); }
	.ps-tip-refs { display: flex; flex-wrap: wrap; gap: 5px; margin-top: 10px; }
	.ps-xref { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; font-size: 10.5px;
		font-weight: 700; font-variant-numeric: tabular-nums; padding: 1px 6px;
		border: 1px solid var(--theme-color-brand-primary, #1d5fa8);
		color: var(--theme-color-brand-primary, #1d5fa8); }
`;

// The mark. Rendered over a Mark record from the provider, so a designator-less entity still renders
// its title cleanly rather than leaving an empty box.
const MarkupTemplates =
[
	{
		Hash: 'Markup-TitleBlock',
		Template: /*html*/`<div class="ps-mark {~D:Record.KindClass~}"><span class="ps-mark-d">{~D:Record.Designator~}</span><span class="ps-mark-t">{~D:Record.Title~}</span></div>`
	},
	{
		Hash: 'Markup-TitleBlock-Inline',
		Template: /*html*/`<span class="ps-mark ps-mark-inline {~D:Record.KindClass~}"><span class="ps-mark-d">{~D:Record.Designator~}</span><span class="ps-mark-t">{~D:Record.Title~}</span></span>`
	},
	{
		// The mark with nothing around it. A list row already rules its own columns, so it takes the
		// designator alone rather than the title block, and still cannot drift from what a card shows.
		Hash: 'Markup-Designator',
		Template: /*html*/`<span class="ps-mark-solo {~D:Record.KindClass~}">{~D:Record.Designator~}</span>`
	},
	{
		Hash: 'Markup-Cell',
		// data-k names the cell (Type, Pri, By, For, ...) so a surface that only wants some of them --
		// the board hiding By/For until "expanded" is toggled on -- can target one by CSS without a
		// second cell template.
		Template: /*html*/`<div class="ps-cell" data-k="{~D:Record.K~}"><span class="ps-cell-k">{~D:Record.K~}</span><span class="ps-cell-v">{~D:Record.V~}</span></div>`
	},
	{
		Hash: 'Markup-Tooltip',
		Template: /*html*/`
<div class="ps-tip">
	<div class="ps-mark {~D:Record.KindClass~}"><span class="ps-mark-d">{~D:Record.Designator~}</span><span class="ps-mark-t">{~D:Record.Title~}</span></div>
	<div class="ps-cells">{~TS:Markup-Cell:Record.Cells~}</div>
	<p class="ps-tip-desc">{~D:Record.Description~}</p>
	<div class="ps-tip-refs">{~TS:Markup-Xref:Record.References~}</div>
</div>`
	},
	{
		Hash: 'Markup-Xref',
		Template: /*html*/`<span class="ps-xref">{~D:Record~}</span>`
	}
];

module.exports = { MarkupTemplates: MarkupTemplates, MarkupCSS: MarkupCSS };

},{}],651:[function(require,module,exports){
'use strict';

/**
 * AboutMeEditor — the rich "About Me" editor on the user's own profile. Same
 * pict-section-markdowneditor (CodeMirror 6 + KaTeX/Mermaid/image preview) as the
 * doc editor, but pasted/dragged/picked images are owned by the User (OwnerType
 * 'User', IDOwner = self) so they live with the profile, and there is no doc host
 * to autosave through. PictView-UserSettings mounts it into #AboutMe-EditorHost
 * (bound to AppData.AboutMeEditor.Segments) and saves on demand via getAllContent.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-AboutMeEditor';
	tmpConfig.DefaultDestinationAddress = '#AboutMe-EditorHost';
	tmpConfig.TargetElementAddress = '#AboutMe-EditorHost';
	tmpConfig.ContentDataAddress = 'AppData.AboutMeEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'side';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#AboutMe-EditorHost';
		}
	}

	return tmpConfig;
}

class PictViewAboutMeEditor extends libMarkdownEditor
{
	_selfIDUser()
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		return tmpUser.IDUser || 0;
	}

	/**
	 * Pasted / dragged / picked image -> upload to Parime owned by this user
	 * (so it surfaces in their profile media), and insert the blob URL. Returning
	 * true = async handling; false falls back to a base64 embed.
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		let tmpIDUser = this._selfIDUser();
		if (!tmpIDUser || !this.pict.providers.MediaAPI) { return false; }
		this.pict.providers.MediaAPI.upload('User', tmpIDUser, pFile)
			.then((pRow) => fCallback(null, this.pict.providers.MediaAPI.blobURL(pRow.IDMedia)))
			.catch((pErr) => fCallback(pErr.message || String(pErr)));
		return true;
	}

	onContentChange(pSegmentIndex, pContent)
	{
		let tmpHost = this.pict.views['Plansheet-UserSettings'];
		if (tmpHost && typeof tmpHost.onAboutMeChanged === 'function') { tmpHost.onAboutMeChanged(); }
	}
}

module.exports = PictViewAboutMeEditor;
module.exports.default_configuration = buildConfiguration();

},{"pict-section-markdowneditor":261}],652:[function(require,module,exports){
'use strict';

/**
 * PictView-Ask: the user-facing Ask area (V50 User Tasks). A person browses the tenant's Active tasks, picks
 * one, fills the task's prompt shape, and files a Request; the view shows live progress and the answer, and
 * keeps a history of what they have asked. This is the friendly front door onto the generic node dispatch, kept
 * deliberately separate from the ops-flavored Fleet > Runs page.
 *
 * It reuses the generic EntityAPI providers for reads (TaskAPI for the Active catalog, PromptShapeAPI for a
 * task's input shape, RequestAPI for a person's own requests -- server-scoped to the asker) and AskAPI for the
 * one custom write (POST /1.0/Request/Submit). The body is rendered imperatively into #Ask-Body so the dynamic
 * form and the poll can repaint just that region without re-rendering the shell.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libMarkdownRender = require('./MarkdownRender.js');

// A request is done when it reaches one of these; the poll stops and the answer (or failure) is shown.
const _REQUEST_TERMINAL = { Answered: true, Failed: true, Cancelled: true };
const _POLL_MS = 4000;

// Inline trash glyph for the delete control. This view paints innerHTML directly, so the Pict {~I:~} icon
// macro is not expanded here; the SVG inherits the button's color via currentColor.
const _TRASH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';

class PictViewAsk extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._tasks = [];
		this._myRequests = [];
		this._shapeSegments = [];
		this._selectedHasShape = false;
		this._selectedTask = null;
		this._activeIDRequest = 0;
		// Files the person has attached but not yet sent (uploaded to the Media buffer, referenced by IDMedia).
		this._pendingAttachments = [];
		// Whether the open conversation's task permits attachments (gates the chat composer's attach control).
		this._chatAllowAttachments = false;
		// The last-painted thread signature, so the poll repaints only on a real change.
		this._lastThreadSig = '';
		// A monotonically rising token so a poll scheduled before a navigation cannot paint over a later screen.
		this._pollToken = 0;
	}

	// True while any attached file is still uploading; sending now would silently drop it.
	_hasPendingUploads() { return this._pendingAttachments.some((pAtt) => pAtt && pAtt.Pending); }

	_taskAPI() { return this.pict.providers.TaskAPI; }
	_shapeAPI() { return this.pict.providers.PromptShapeAPI; }
	_requestAPI() { return this.pict.providers.RequestAPI; }
	_messageAPI() { return this.pict.providers.RequestMessageAPI; }
	_askAPI() { return this.pict.providers.AskAPI; }
	_mediaAPI() { return this.pict.providers.MediaAPI; }

	_esc(pValue)
	{
		return String(pValue === null || typeof pValue === 'undefined' ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	_body() { return (typeof document !== 'undefined') ? document.getElementById('Ask-Body') : null; }
	_paint(pHTML) { let tmpBody = this._body(); if (tmpBody) { tmpBody.innerHTML = pHTML; } }
	_app() { return this.pict.PictApplication; }

	// The shell holds #Ask-Body; render it only when it is not already on screen. A within-Ask navigation
	// (catalog -> task -> request) just repaints the body; a navigation in from another page renders the
	// shell first.
	_ensureShell() { if (!this._body()) { this.render(); } }

	// Each Ask state is its own ROUTE (/ask, /ask/task/:id, /ask/request/:id), so Back, forward and reload
	// all work and every state deep-links. The app's route handlers call showCatalog / showTask / showRequest;
	// the user actions below (pickTask, openRequest, backToCatalog, submit) NAVIGATE rather than repaint, which
	// is what keeps the history honest. Repainting #Ask-Body in place without changing the URL was the
	// regression that broke the Back button.
	show() { return this.showCatalog(); }

	// ---- catalog (route /ask) ------------------------------------------------------------------------------
	showCatalog()
	{
		this._ensureShell();
		this._enterCatalog();
		return true;
	}

	async _enterCatalog()
	{
		this._pollToken++;
		this._selectedTask = null;
		this._activeIDRequest = 0;
		this._paint('<div class="ask-loading">Loading tasks...</div>');
		let tmpTasks = [];
		let tmpRequests = [];
		try
		{
			// Active tasks only, tenant-scoped by the server; requests are server-scoped to this asker.
			tmpTasks = await this._taskAPI().resolve({ Filter: 'FBV~Status~EQ~Active', PageSize: 250 });
			tmpRequests = await this._requestAPI().resolve({ PageSize: 50 });
		}
		catch (pError) { /* a transient failure paints an empty catalog rather than a blank pane */ }
		this._tasks = Array.isArray(tmpTasks) ? tmpTasks : [];
		this._myRequests = (Array.isArray(tmpRequests) ? tmpRequests : [])
			.sort((pA, pB) => (Number(pB.RequestNumber) || 0) - (Number(pA.RequestNumber) || 0));
		this._paintCatalog();
	}

	_paintCatalog()
	{
		let tmpParts = [];
		if (!this._tasks.length)
		{
			tmpParts.push('<div class="ask-empty">No tasks yet. An administrator sets these up under Tasks.</div>');
		}
		else
		{
			// Group by Audience so a person sees the tasks meant for their role together.
			let tmpGroups = {};
			let tmpOrder = [];
			this._tasks.forEach((pTask) =>
			{
				let tmpAudience = String(pTask.Audience || '').trim() || 'General';
				if (!tmpGroups[tmpAudience]) { tmpGroups[tmpAudience] = []; tmpOrder.push(tmpAudience); }
				tmpGroups[tmpAudience].push(pTask);
			});
			tmpOrder.sort();
			tmpOrder.forEach((pAudience) =>
			{
				tmpParts.push('<div class="ask-group"><div class="ask-group-head">' + this._esc(pAudience) + '</div><div class="ask-cards">');
				tmpGroups[pAudience].forEach((pTask) =>
				{
					tmpParts.push(''
						+ '<button class="ask-card" onclick="_Pict.views[\'Plansheet-Ask\'].pickTask(' + (Number(pTask.IDTask) || 0) + ')">'
						+ '<div class="ask-card-name">' + this._esc(pTask.Name || ('Task ' + (pTask.TaskNumber || ''))) + '</div>'
						+ (pTask.Summary ? ('<div class="ask-card-sum">' + this._esc(pTask.Summary) + '</div>') : '')
						+ '</button>');
				});
				tmpParts.push('</div></div>');
			});
		}
		tmpParts.push(this._historyHTML());
		this._paint(tmpParts.join(''));
	}

	_historyHTML()
	{
		if (!this._myRequests.length) { return ''; }
		let tmpRows = this._myRequests.slice(0, 20).map((pRequest) =>
		{
			let tmpStatus = String(pRequest.Status || 'Pending');
			let tmpID = Number(pRequest.IDRequest) || 0;
			// The row is a flex container of two siblings (open, delete) rather than a single button, so the
			// delete control is not a button nested inside a button (invalid, and it would swallow the open click).
			return ''
				+ '<div class="ask-hist-row">'
				+ '<button class="ask-hist-open" onclick="_Pict.views[\'Plansheet-Ask\'].openRequest(' + tmpID + ')">'
				+ '<span class="ask-hist-name">' + this._esc(pRequest.Name || ('Request ' + (pRequest.RequestNumber || ''))) + '</span>'
				+ '<span class="ask-pill ask-pill-' + tmpStatus.toLowerCase() + '">' + this._esc(tmpStatus) + '</span>'
				+ '</button>'
				+ '<button class="ask-hist-del" title="Delete this request" aria-label="Delete this request" onclick="_Pict.views[\'Plansheet-Ask\'].deleteRequest(' + tmpID + ', false)">' + _TRASH_SVG + '</button>'
				+ '</div>';
		}).join('');
		return '<div class="ask-hist"><div class="ask-group-head">Your recent requests</div>' + tmpRows + '</div>';
	}

	// ---- the input form (route /ask/task/:id) --------------------------------------------------------------
	// Clicking a task card is a navigation to /ask/task/:id; the route handler calls showTask to load + paint.
	pickTask(pIDTask) { this._goTask(pIDTask); }

	async showTask(pIDTask)
	{
		this._ensureShell();
		this._pollToken++;
		this._activeIDRequest = 0;
		let tmpID = Number(pIDTask) || 0;
		this._paint('<div class="ask-loading">Loading...</div>');
		let tmpTask = this._tasks.find((pTask) => Number(pTask.IDTask) === tmpID);
		// Cold deep-link or reload: the catalog is not in memory, so fetch the one task by id. The read is
		// tenant-scoped server-side, so an unknown or cross-tenant id reads null and falls back to the catalog.
		if (!tmpTask && tmpID) { try { tmpTask = await this._taskAPI().read(tmpID); } catch (pError) { tmpTask = null; } }
		if (!tmpTask) { return this.showCatalog(); }
		this._selectedTask = tmpTask;
		this._pendingAttachments = [];
		this._shapeSegments = [];
		this._selectedHasShape = Number(tmpTask.IDPromptShape) > 0;
		if (Number(tmpTask.IDPromptShape) > 0)
		{
			try
			{
				let tmpShape = await this._shapeAPI().read(Number(tmpTask.IDPromptShape));
				let tmpDefinition = {};
				try { tmpDefinition = JSON.parse((tmpShape && tmpShape.ShapeDefinition) || '{}') || {}; } catch (pError) { tmpDefinition = {}; }
				// Only the editable (non-Fixed) segments are the user's to fill; Fixed segments are the admin's
				// locked skeleton, applied server-side from the shape, never sent as input.
				this._shapeSegments = (Array.isArray(tmpDefinition.Segments) ? tmpDefinition.Segments : [])
					.filter((pSegment) => pSegment && !pSegment.Fixed)
					.map((pSegment) => ({ Key: String(pSegment.Key || ''), Name: String(pSegment.Name || pSegment.Key || ''), Guidance: String(pSegment.Guidance || ''), Optional: !!pSegment.Optional }));
			}
			catch (pError) { this._shapeSegments = []; }
		}
		this._paintForm();
	}

	_paintForm()
	{
		let tmpTask = this._selectedTask || {};
		let tmpFields;
		if (this._shapeSegments.length)
		{
			tmpFields = this._shapeSegments.map((pSegment) => ''
				+ '<label class="ask-field">'
				+ '<span class="ask-field-label">' + this._esc(pSegment.Name) + (pSegment.Optional ? ' <em>(optional)</em>' : '') + '</span>'
				+ (pSegment.Guidance ? ('<span class="ask-field-hint">' + this._esc(pSegment.Guidance) + '</span>') : '')
				+ '<textarea class="ask-input" data-seg-key="' + this._esc(pSegment.Key) + '" rows="3"></textarea>'
				+ '</label>').join('');
		}
		else if (this._selectedHasShape)
		{
			// The task has a shape but every segment is Fixed (the admin's locked skeleton, e.g. a canned SQL
			// query): there is nothing for the person to fill in, so just offer the run.
			tmpFields = '<p class="ask-noinput">This task runs with no extra input. Click Ask to run it.</p>';
		}
		else
		{
			// No shape at all: a single free-text box, sent as { body } (the degenerate case the server understands).
			tmpFields = ''
				+ '<label class="ask-field"><span class="ask-field-label">Your question or request</span>'
				+ '<textarea class="ask-input" data-seg-key="body" rows="5"></textarea></label>';
		}
		this._paint(''
			+ '<div class="ask-form">'
			+ '<button class="ask-back" onclick="_Pict.views[\'Plansheet-Ask\'].backToCatalog()">&larr; All tasks</button>'
			+ '<h2 class="ask-form-title">' + this._esc(tmpTask.Name || 'Task') + '</h2>'
			+ (tmpTask.Description ? ('<div class="ask-form-desc">' + this._esc(tmpTask.Description) + '</div>') : '')
			+ tmpFields
			+ (tmpTask.AllowAttachments ? this._attachControlHTML() : '')
			+ '<div class="ask-actions"><button class="ask-submit" onclick="_Pict.views[\'Plansheet-Ask\'].submitAsk()">Ask</button>'
			+ '<span id="Ask-FormMsg" class="ask-formmsg"></span></div>'
			+ '</div>');
	}

	_collectInputValues()
	{
		let tmpValues = {};
		let tmpBody = this._body();
		if (!tmpBody) { return tmpValues; }
		let tmpInputs = tmpBody.querySelectorAll('.ask-input');
		for (let i = 0; i < tmpInputs.length; i++)
		{
			let tmpKey = tmpInputs[i].getAttribute('data-seg-key') || '';
			if (tmpKey) { tmpValues[tmpKey] = tmpInputs[i].value; }
		}
		return tmpValues;
	}

	async submitAsk()
	{
		if (!this._selectedTask) { return; }
		let tmpValues = this._collectInputValues();
		let tmpHasText = Object.keys(tmpValues).some((pKey) => String(tmpValues[pKey] || '').trim());
		let tmpAttachments = this._sendableAttachments();
		let tmpMsg = (typeof document !== 'undefined') ? document.getElementById('Ask-FormMsg') : null;
		if (this._hasPendingUploads()) { if (tmpMsg) { tmpMsg.textContent = 'A file is still uploading. One moment.'; } return; }
		// A no-input task (a fixed-shape task with no editable segments) submits with empty values -- the shape
		// carries everything. Demand text only when there is something to type (editable fields, or no shape) AND
		// nothing was attached: a file on its own is a valid ask for a conversational, attachment-taking task.
		let tmpNeedsText = this._shapeSegments.length > 0 || !this._selectedHasShape;
		if (tmpNeedsText && !tmpHasText && !tmpAttachments.length) { if (tmpMsg) { tmpMsg.textContent = 'Type something or attach a file first.'; } return; }
		if (tmpMsg) { tmpMsg.textContent = 'Submitting...'; }
		let tmpResult = null;
		try { tmpResult = await this._askAPI().submitRequest(Number(this._selectedTask.IDTask), tmpValues, '', tmpAttachments); }
		catch (pError)
		{
			if (tmpMsg) { tmpMsg.textContent = (pError && pError.message) || 'Could not submit that request.'; }
			return;
		}
		this._activeIDRequest = Number(tmpResult && tmpResult.IDRequest) || 0;
		if (!this._activeIDRequest) { if (tmpMsg) { tmpMsg.textContent = 'Could not open the request.'; } return; }
		this._pendingAttachments = [];
		// The running + answer state is its own route, so it deep-links and Back returns to the task form
		// rather than falling out of Ask entirely.
		this._goRequest(this._activeIDRequest);
	}

	// ---- running + answer ----------------------------------------------------------------------------------
	_paintRunning(pStage)
	{
		let tmpTask = this._selectedTask || {};
		this._paint(''
			+ '<div class="ask-run">'
			+ '<h2 class="ask-form-title">' + this._esc(tmpTask.Name || 'Request') + '</h2>'
			+ '<div class="ask-spinner"></div>'
			+ '<div class="ask-stage">' + this._esc(pStage || 'Working...') + '</div>'
			+ '</div>');
	}

	_startPoll()
	{
		this._pollToken++;
		let tmpToken = this._pollToken;
		let fTick = () =>
		{
			if (tmpToken !== this._pollToken) { return; }
			this._requestAPI().read(this._activeIDRequest).then((pRequest) =>
			{
				if (tmpToken !== this._pollToken) { return; }
				if (!pRequest) { setTimeout(fTick, _POLL_MS); return; }
				let tmpStatus = String(pRequest.Status || 'Pending');
				if (_REQUEST_TERMINAL[tmpStatus]) { this._paintAnswer(pRequest); return; }
				this._paintRunning(tmpStatus === 'Running' ? 'Working on it...' : 'Queued...');
				setTimeout(fTick, _POLL_MS);
			}).catch(() => { if (tmpToken === this._pollToken) { setTimeout(fTick, _POLL_MS); } });
		};
		setTimeout(fTick, _POLL_MS);
	}

	_paintAnswer(pRequest)
	{
		let tmpStatus = String(pRequest.Status || '');
		let tmpTitle = this._esc(pRequest.Name || 'Request');
		let tmpOutcome = String(pRequest.Outcome || '');
		// A document-kind outcome (Authoring Nodes V52) wrote its answer into the Docs Lake; OutcomeJSON carries
		// the pointer so the answer offers an "Open the article" jump to the doc reader.
		let tmpDoc = null;
		try { let tmpOJ = JSON.parse(pRequest.OutcomeJSON || '{}'); if (tmpOJ && tmpOJ.Kind === 'document' && tmpOJ.Path) { tmpDoc = tmpOJ; } }
		catch (pIgnore) { tmpDoc = null; }
		let tmpHTML = ''
			+ '<div class="ask-answer">'
			+ '<button class="ask-back" onclick="_Pict.views[\'Plansheet-Ask\'].backToCatalog()">&larr; All tasks</button>'
			+ '<h2 class="ask-form-title">' + tmpTitle + '</h2>'
			+ '<div class="ask-answer-status ask-pill ask-pill-' + tmpStatus.toLowerCase() + '">' + this._esc(tmpStatus) + '</div>';
		// Show what was asked, above the answer. The question (AssembledInput, or the raw inputs as a fallback)
		// is stored on the Request but was never surfaced here before.
		let tmpQuestion = this._questionText(pRequest);
		if (tmpQuestion)
		{
			tmpHTML += '<div class="ask-qblock"><div class="ask-qlabel">Your question</div><div class="ask-qtext">' + this._esc(tmpQuestion) + '</div></div>';
		}
		if (tmpStatus === 'Answered')
		{
			tmpHTML += '<div class="ask-alabel">Answer</div><div id="Ask-Outcome" class="ask-outcome pict-content"></div>';
		}
		else
		{
			tmpHTML += '<div class="ask-outcome ask-outcome-fail">' + (tmpOutcome ? this._esc(tmpOutcome) : 'The task did not complete.') + '</div>';
		}
		tmpHTML += '<div class="ask-actions">';
		if (tmpDoc)
		{
			tmpHTML += '<button class="ask-submit" onclick="_Pict.views[\'Plansheet-Ask\'].openArticle(\'' + encodeURIComponent(tmpDoc.Path) + '\')">Open the article</button>';
		}
		tmpHTML += '<button class="ask-submit" onclick="_Pict.views[\'Plansheet-Ask\'].backToCatalog()">Ask another</button>';
		tmpHTML += '<button class="ask-del-btn" onclick="_Pict.views[\'Plansheet-Ask\'].deleteRequest(' + (Number(pRequest.IDRequest) || 0) + ', true)">Delete</button>';
		tmpHTML += '</div></div>';
		this._paint(tmpHTML);
		if (tmpStatus === 'Answered')
		{
			let tmpContainer = (typeof document !== 'undefined') ? document.getElementById('Ask-Outcome') : null;
			if (tmpContainer)
			{
				// Render the answer as markdown when the content provider is available; fall back to escaped text.
				if (this.pict.providers.Content && typeof libMarkdownRender.renderInto === 'function')
				{
					libMarkdownRender.renderInto(this.pict.providers.Content, tmpContainer, tmpOutcome, '<em>No answer text.</em>', true);
				}
				else { tmpContainer.textContent = tmpOutcome; }
			}
		}
	}

	// The human-readable question that was filed. AssembledInput is the composed prompt the node received; fall
	// back to the raw submitted field values when a task stored nothing assembled (e.g. a bare-body ask).
	_questionText(pRequest)
	{
		let tmpAssembled = String((pRequest && pRequest.AssembledInput) || '').trim();
		if (tmpAssembled) { return tmpAssembled; }
		let tmpValues = null;
		try { tmpValues = JSON.parse((pRequest && pRequest.InputValuesJSON) || 'null'); } catch (pError) { tmpValues = null; }
		if (tmpValues && typeof tmpValues === 'object')
		{
			return Object.keys(tmpValues).map((pKey) => String(tmpValues[pKey] || '').trim()).filter((pValue) => pValue).join('\n\n');
		}
		return '';
	}

	// Delete (soft, owner-scoped on the server) one of my requests, behind a confirm. From the detail we navigate
	// back to the catalog (the request is gone); from the catalog we drop it from the in-memory list and repaint.
	async deleteRequest(pIDRequest, pFromDetail)
	{
		let tmpID = Number(pIDRequest) || 0;
		if (!tmpID) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpOk = true;
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			try { tmpOk = await tmpModal.confirm('Delete this request? This cannot be undone.', { dangerous: true }); }
			catch (pError) { tmpOk = false; }
		}
		if (!tmpOk) { return; }
		try { await this._requestAPI().remove(tmpID); }
		catch (pError)
		{
			if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast((pError && pError.message) || 'Could not delete that request.', { type: 'error' }); }
			return;
		}
		this._myRequests = this._myRequests.filter((pRequest) => Number(pRequest.IDRequest) !== tmpID);
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Request deleted.', { type: 'success' }); }
		if (pFromDetail) { this._goCatalog(); }
		else { this._paintCatalog(); }
	}

	// ---- attachments (the Media buffer) --------------------------------------------------------------------
	// A file-attach control: a hidden file input plus a button and the chips for what is staged. Shared by the
	// task form (first turn) and the chat composer (follow-ups); both reuse the #Ask-File / #Ask-Chips ids since
	// only one is on screen at a time.
	_attachControlHTML()
	{
		return ''
			+ '<div class="ask-attach">'
			+ '<input type="file" id="Ask-File" class="ask-file" multiple onchange="_Pict.views[\'Plansheet-Ask\'].attachFiles(this)" />'
			+ '<button type="button" class="ask-attach-btn" onclick="document.getElementById(\'Ask-File\').click()">Attach a file</button>'
			+ '<span class="ask-chips" id="Ask-Chips">' + this._chipsHTML() + '</span>'
			+ '</div>';
	}

	_chipsHTML()
	{
		return this._pendingAttachments.map((pAtt, pIdx) => ''
			+ '<span class="ask-chip' + (pAtt.Pending ? ' ask-chip-pending' : '') + '">'
			+ '<span class="ask-chip-name">' + this._esc(pAtt.Name || 'file') + '</span>'
			+ (pAtt.Pending ? '<span class="ask-chip-spin"></span>'
				: '<button type="button" class="ask-chip-x" title="Remove" onclick="_Pict.views[\'Plansheet-Ask\'].removeAttachment(' + pIdx + ')">&times;</button>')
			+ '</span>').join('');
	}

	_repaintChips()
	{
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById('Ask-Chips') : null;
		if (tmpEl) { tmpEl.innerHTML = this._chipsHTML(); }
	}

	// Upload each chosen file to the Media buffer as TEAM media (never Private -- a node persona must be able to
	// read it) and stage a reference. A placeholder chip shows while the upload runs.
	async attachFiles(pInputEl)
	{
		if (!pInputEl || !pInputEl.files || !pInputEl.files.length) { return; }
		let tmpFiles = Array.prototype.slice.call(pInputEl.files);
		pInputEl.value = '';	// let the same file be chosen again later
		for (let i = 0; i < tmpFiles.length; i++)
		{
			let tmpFile = tmpFiles[i];
			let tmpPlaceholder = { Name: tmpFile.name, Pending: true };
			this._pendingAttachments.push(tmpPlaceholder);
			this._repaintChips();
			try
			{
				let tmpResult = await this._mediaAPI().upload('RequestUpload', 0, tmpFile, {});
				let tmpIDMedia = Number(tmpResult && (tmpResult.IDMedia || tmpResult.ID)) || 0;
				let tmpIdx = this._pendingAttachments.indexOf(tmpPlaceholder);
				if (!tmpIDMedia)
				{
					if (tmpIdx >= 0) { this._pendingAttachments.splice(tmpIdx, 1); }
					this._toast('Could not upload ' + tmpFile.name + '.', 'error');
				}
				else
				{
					let tmpRef = { Source: 'media', Ref: tmpIDMedia, Name: String(tmpFile.name || ''), ContentType: String(tmpFile.type || ''), Size: Number(tmpFile.size) || 0 };
					if (tmpIdx >= 0) { this._pendingAttachments.splice(tmpIdx, 1, tmpRef); } else { this._pendingAttachments.push(tmpRef); }
				}
			}
			catch (pError)
			{
				let tmpIdx = this._pendingAttachments.indexOf(tmpPlaceholder);
				if (tmpIdx >= 0) { this._pendingAttachments.splice(tmpIdx, 1); }
				this._toast((pError && pError.message) || ('Could not upload ' + tmpFile.name + '.'), 'error');
			}
			this._repaintChips();
		}
	}

	removeAttachment(pIdx)
	{
		let tmpIdx = Number(pIdx);
		if (tmpIdx >= 0 && tmpIdx < this._pendingAttachments.length) { this._pendingAttachments.splice(tmpIdx, 1); this._repaintChips(); }
	}

	// Only fully-uploaded references (placeholders still uploading are skipped) are sent with a turn.
	_sendableAttachments()
	{
		return this._pendingAttachments.filter((pAtt) => pAtt && !pAtt.Pending && pAtt.Ref);
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && tmpModal.toast) { tmpModal.toast(pMessage, { type: pType || 'success' }); }
	}

	// ---- the chat (conversational requests) ----------------------------------------------------------------
	async _loadThread(pIDRequest)
	{
		let tmpRows = [];
		try { tmpRows = await this._messageAPI().resolve({ Filter: 'FBV~IDRequest~EQ~' + (Number(pIDRequest) || 0), PageSize: 500 }); }
		catch (pError) { tmpRows = []; }
		if (!Array.isArray(tmpRows)) { return []; }
		return tmpRows.sort((pA, pB) => (Number(pA.Sequence) || 0) - (Number(pB.Sequence) || 0));
	}

	_threadBusy(pMessages)
	{
		return pMessages.some((pMsg) => String(pMsg.Role) === 'assistant' && (String(pMsg.Status) === 'Pending' || String(pMsg.Status) === 'Running'));
	}

	// A cheap signature so the poll repaints only when the thread actually changed (no flicker on an idle tick).
	_threadSig(pMessages)
	{
		return pMessages.map((pMsg) => (Number(pMsg.IDRequestMessage) || 0) + ':' + String(pMsg.Status || '') + ':' + String(pMsg.Content || '').length).join('|');
	}

	_paintChat(pRequest, pMessages)
	{
		let tmpBusy = this._threadBusy(pMessages);
		let tmpParts = [];
		tmpParts.push('<div class="ask-chat">');
		tmpParts.push('<button class="ask-back" onclick="_Pict.views[\'Plansheet-Ask\'].backToCatalog()">&larr; All tasks</button>');
		tmpParts.push('<div class="ask-chat-head"><h2 class="ask-form-title">' + this._esc(pRequest.Name || 'Request') + '</h2>'
			+ '<button class="ask-hist-del ask-chat-del" title="Delete this conversation" aria-label="Delete this conversation" onclick="_Pict.views[\'Plansheet-Ask\'].deleteRequest(' + (Number(pRequest.IDRequest) || 0) + ', true)">' + _TRASH_SVG + '</button></div>');
		tmpParts.push('<div class="ask-thread" id="Ask-Thread">');
		pMessages.forEach((pMsg) => { tmpParts.push(this._messageHTML(pMsg)); });
		tmpParts.push('</div>');
		tmpParts.push('<div class="ask-composer">');
		tmpParts.push('<textarea class="ask-input ask-composer-text" id="Ask-Composer" rows="2" placeholder="' + (tmpBusy ? 'Waiting for the assistant...' : 'Reply, or ask for a change...') + '"' + (tmpBusy ? ' disabled' : '') + '></textarea>');
		tmpParts.push('<div class="ask-composer-row">' + (this._chatAllowAttachments ? this._attachControlHTML() : '<span></span>')
			+ '<button class="ask-submit ask-send" onclick="_Pict.views[\'Plansheet-Ask\'].sendMessage()"' + (tmpBusy ? ' disabled' : '') + '>Send</button></div>');
		tmpParts.push('</div></div>');
		this._paint(tmpParts.join(''));
		this._renderAssistantMarkdown(pMessages);
		this._scrollThreadToEnd();
		this._lastThreadSig = this._threadSig(pMessages);
	}

	_messageHTML(pMsg)
	{
		let tmpIsAssistant = (String(pMsg.Role || 'user') === 'assistant');
		let tmpStatus = String(pMsg.Status || '');
		let tmpContent = String(pMsg.Content || '');
		let tmpBody;
		if (!tmpIsAssistant)
		{
			tmpBody = this._esc(tmpContent);
		}
		else if (tmpContent.trim())
		{
			// Rendered as markdown after paint into this container (keyed by message id).
			tmpBody = '<div class="pict-content ask-md" data-md-id="' + (Number(pMsg.IDRequestMessage) || 0) + '"></div>';
		}
		else if (tmpStatus === 'Pending' || tmpStatus === 'Running')
		{
			tmpBody = '<span class="ask-typing"><span></span><span></span><span></span></span>';
		}
		else
		{
			tmpBody = '<span class="ask-stage">' + this._esc(tmpStatus || 'No reply') + '</span>';
		}
		return ''
			+ '<div class="ask-msg ask-msg-' + (tmpIsAssistant ? 'assistant' : 'user') + '">'
			+ '<div class="ask-msg-role">' + (tmpIsAssistant ? 'Assistant' : 'You') + '</div>'
			+ '<div class="ask-msg-body">' + tmpBody + '</div>'
			+ this._messageAttachmentsHTML(pMsg)
			+ (tmpIsAssistant ? this._messageMetaHTML(pMsg) : '')
			+ '</div>';
	}

	_messageAttachmentsHTML(pMsg)
	{
		let tmpList = [];
		try { tmpList = JSON.parse(pMsg.AttachmentsJSON || '[]'); } catch (pError) { tmpList = []; }
		if (!Array.isArray(tmpList) || !tmpList.length) { return ''; }
		let tmpChips = tmpList.map((pAtt) => '<span class="ask-chip ask-chip-static">' + this._esc((pAtt && (pAtt.Name || pAtt.OriginalFileName)) || 'file') + '</span>').join('');
		return '<div class="ask-msg-atts">' + tmpChips + '</div>';
	}

	// The runner's opaque MetadataJSON may carry a produced artifact; surface a Headlight form link when present.
	_messageMetaHTML(pMsg)
	{
		let tmpMeta = null;
		try { tmpMeta = JSON.parse(pMsg.MetadataJSON || 'null'); } catch (pError) { tmpMeta = null; }
		if (!tmpMeta || typeof tmpMeta !== 'object') { return ''; }
		let tmpForm = tmpMeta.HeadlightForm || tmpMeta.Form || null;
		if (tmpForm && tmpForm.url)
		{
			return '<div class="ask-msg-meta"><a class="ask-meta-link" href="' + this._esc(tmpForm.url) + '" target="_blank" rel="noopener noreferrer">Open in Headlight &rarr;</a></div>';
		}
		return '';
	}

	_renderAssistantMarkdown(pMessages)
	{
		if (typeof document === 'undefined') { return; }
		pMessages.forEach((pMsg) =>
		{
			if (String(pMsg.Role) !== 'assistant') { return; }
			let tmpText = String(pMsg.Content || '');
			if (!tmpText.trim()) { return; }
			let tmpContainer = document.querySelector('.ask-md[data-md-id="' + (Number(pMsg.IDRequestMessage) || 0) + '"]');
			if (!tmpContainer) { return; }
			if (this.pict.providers.Content && typeof libMarkdownRender.renderInto === 'function')
			{
				libMarkdownRender.renderInto(this.pict.providers.Content, tmpContainer, tmpText, '<em>No reply.</em>', true);
			}
			else { tmpContainer.textContent = tmpText; }
		});
	}

	_scrollThreadToEnd()
	{
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById('Ask-Thread') : null;
		if (tmpEl) { tmpEl.scrollTop = tmpEl.scrollHeight; }
	}

	// Send a follow-up turn: post it, then reload the thread (now with the new user turn + a Pending assistant)
	// and poll for the reply. Owner-scoped on the server; a turn is refused while one is still running.
	async sendMessage()
	{
		if (!this._activeIDRequest) { return; }
		if (this._hasPendingUploads()) { this._toast('A file is still uploading. One moment.', 'error'); return; }
		let tmpToken = this._pollToken;
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById('Ask-Composer') : null;
		let tmpText = tmpEl ? String(tmpEl.value || '').trim() : '';
		let tmpAttachments = this._sendableAttachments();
		if (!tmpText && !tmpAttachments.length) { return; }
		if (tmpEl) { tmpEl.disabled = true; }
		try { await this._askAPI().postMessage(this._activeIDRequest, tmpText, tmpAttachments); }
		catch (pError)
		{
			if (tmpEl) { tmpEl.disabled = false; }
			this._toast((pError && pError.message) || 'Could not send that message.', 'error');
			return;
		}
		if (tmpToken !== this._pollToken) { return; }	// navigated away while sending
		this._pendingAttachments = [];
		let tmpTitle = (this._selectedTask && this._selectedTask.Name) || 'Request';
		let tmpMessages = await this._loadThread(this._activeIDRequest);
		if (tmpToken !== this._pollToken) { return; }
		this._paintChat({ IDRequest: this._activeIDRequest, Name: tmpTitle }, tmpMessages);
		if (this._threadBusy(tmpMessages)) { this._startThreadPoll(); }
	}

	// Poll a conversational thread while a turn is in flight; repaint only when the thread changes, and stop once
	// the assistant turn is terminal. Guarded by the shared _pollToken so a navigation cancels it.
	_startThreadPoll()
	{
		this._pollToken++;
		let tmpToken = this._pollToken;
		let tmpIDRequest = this._activeIDRequest;
		let tmpTitle = (this._selectedTask && this._selectedTask.Name) || 'Request';
		let fTick = () =>
		{
			if (tmpToken !== this._pollToken) { return; }
			this._loadThread(tmpIDRequest).then((pMessages) =>
			{
				if (tmpToken !== this._pollToken) { return; }
				if (this._threadSig(pMessages) !== this._lastThreadSig) { this._paintChat({ IDRequest: tmpIDRequest, Name: tmpTitle }, pMessages); }
				if (this._threadBusy(pMessages)) { setTimeout(fTick, _POLL_MS); }
			}).catch(() => { if (tmpToken === this._pollToken) { setTimeout(fTick, _POLL_MS); } });
		};
		setTimeout(fTick, _POLL_MS);
	}

	// Jump to the doc reader for a document-kind outcome. The path is passed URI-encoded (no quotes/spaces in the
	// inline handler); the docs route decodes its wildcard, so it is re-encoded for the navigate.
	openArticle(pEncodedPath)
	{
		let tmpPath = '';
		try { tmpPath = decodeURIComponent(String(pEncodedPath || '')); } catch (pError) { tmpPath = String(pEncodedPath || ''); }
		if (!tmpPath) { return; }
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (tmpRouter && typeof tmpRouter.navigate === 'function') { tmpRouter.navigate('/docs/' + encodeURIComponent(tmpPath)); }
	}

	// A history row click is a navigation to /ask/request/:id; the route handler calls showRequest to load + paint.
	openRequest(pIDRequest) { this._goRequest(pIDRequest); }

	async showRequest(pIDRequest)
	{
		this._ensureShell();
		this._pollToken++;
		let tmpToken = this._pollToken;
		this._pendingAttachments = [];
		this._lastThreadSig = '';
		this._chatAllowAttachments = false;
		this._paint('<div class="ask-loading">Loading...</div>');
		let tmpRequest = null;
		try { tmpRequest = await this._requestAPI().read(Number(pIDRequest)); }
		catch (pError) { tmpRequest = null; }
		if (tmpToken !== this._pollToken) { return; }	// navigated away during the read
		if (!tmpRequest) { return this.showCatalog(); }
		this._selectedTask = { Name: tmpRequest.Name };
		this._activeIDRequest = Number(tmpRequest.IDRequest) || 0;
		// A conversational request has a message thread: render the chat and poll any in-flight turn. A single-shot
		// request has no messages, so it reopens into the running view or its one answer, exactly as before.
		let tmpMessages = await this._loadThread(this._activeIDRequest);
		if (tmpToken !== this._pollToken) { return; }
		if (tmpMessages.length)
		{
			// Learn whether the task still permits attachments, so the composer's attach control matches the form.
			if (Number(tmpRequest.IDTask) > 0)
			{
				let tmpTask = null;
				try { tmpTask = await this._taskAPI().read(Number(tmpRequest.IDTask)); } catch (pError) { tmpTask = null; }
				if (tmpToken !== this._pollToken) { return; }
				this._chatAllowAttachments = !!(tmpTask && tmpTask.AllowAttachments);
			}
			this._paintChat(tmpRequest, tmpMessages);
			if (this._threadBusy(tmpMessages)) { this._startThreadPoll(); }
			return;
		}
		let tmpStatus = String(tmpRequest.Status || '');
		// A request still working reopens into the live view; a finished one shows its answer.
		if (_REQUEST_TERMINAL[tmpStatus]) { this._paintAnswer(tmpRequest); }
		else { this._paintRunning('Working on it...'); this._startPoll(); }
	}

	backToCatalog() { this._goCatalog(); }

	// Navigation helpers: drive every state change through the router (app._navigate) so Back / forward and
	// reload behave and each state deep-links. Fall back to an in-place render when the app/router is not
	// reachable (e.g. a unit test that instantiates the view without the application).
	_goCatalog() { let tmpApp = this._app(); if (tmpApp && typeof tmpApp.showAsk === 'function') { tmpApp.showAsk(); } else { this.showCatalog(); } }
	_goTask(pIDTask) { let tmpApp = this._app(); if (tmpApp && typeof tmpApp.showAskTask === 'function') { tmpApp.showAskTask(Number(pIDTask) || 0); } else { this.showTask(pIDTask); } }
	_goRequest(pIDRequest) { let tmpApp = this._app(); if (tmpApp && typeof tmpApp.showAskRequest === 'function') { tmpApp.showAskRequest(Number(pIDRequest) || 0); } else { this.showRequest(pIDRequest); } }
}

const PictViewAskConfiguration =
{
	ViewIdentifier: 'Plansheet-Ask',
	DefaultRenderable: 'Plansheet-Ask',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ask-wrap { max-width: 900px; margin: 0 auto; padding: 24px 16px 64px; }
		.ask-head h1 { margin: 0 0 4px; font-size: 1.6em; color: var(--theme-color-text-primary, #1d2230); }
		.ask-sub { margin: 0 0 20px; color: var(--theme-color-text-secondary, #5b6376); }
		.ask-body { display: block; }
		.ask-loading, .ask-empty { color: var(--theme-color-text-secondary, #5b6376); padding: 24px 0; }
		.ask-group { margin-bottom: 24px; }
		.ask-group-head { font-size: 0.8em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 10px; }
		.ask-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 12px; }
		.ask-card { text-align: left; cursor: pointer; padding: 14px 16px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 10px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); transition: border-color 0.12s, box-shadow 0.12s; }
		.ask-card:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); box-shadow: 0 2px 10px rgba(0,0,0,0.06); }
		.ask-card-name { font-weight: 600; margin-bottom: 4px; }
		.ask-card-sum { font-size: 0.88em; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.4; }
		.ask-back { background: none; border: none; color: var(--theme-color-brand-primary, #3b6fd4); cursor: pointer; padding: 0; font-size: 0.9em; margin-bottom: 12px; }
		.ask-form-title { margin: 0 0 8px; font-size: 1.3em; color: var(--theme-color-text-primary, #1d2230); }
		.ask-form-desc { color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 16px; line-height: 1.5; }
		.ask-field { display: block; margin-bottom: 16px; }
		.ask-field-label { display: block; font-weight: 600; margin-bottom: 4px; color: var(--theme-color-text-primary, #1d2230); }
		.ask-field-label em { font-weight: 400; color: var(--theme-color-text-secondary, #5b6376); }
		.ask-field-hint { display: block; font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 6px; }
		.ask-noinput { color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 16px; line-height: 1.5; }
		.ask-input { width: 100%; padding: 10px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-secondary, #f3f5f9); color: var(--theme-color-text-primary, #1d2230); font: inherit; resize: vertical; box-sizing: border-box; }
		.ask-actions { display: flex; align-items: center; gap: 12px; margin-top: 8px; }
		.ask-submit { padding: 9px 20px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 8px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; cursor: pointer; font-size: 0.95em; }
		.ask-del-btn { padding: 9px 16px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: none; color: var(--theme-color-status-error, #c0353a); cursor: pointer; font-size: 0.95em; }
		.ask-del-btn:hover { border-color: var(--theme-color-status-error, #c0353a); background: var(--theme-color-status-error-background, rgba(198,40,40,0.08)); }
		.ask-formmsg { font-size: 0.88em; color: var(--theme-color-text-secondary, #5b6376); }
		.ask-run { text-align: center; padding: 40px 0; }
		.ask-spinner { width: 34px; height: 34px; margin: 16px auto; border: 3px solid var(--theme-color-border-default, #d8dde6); border-top-color: var(--theme-color-brand-primary, #3b6fd4); border-radius: 50%; animation: ask-spin 0.8s linear infinite; }
		@keyframes ask-spin { to { transform: rotate(360deg); } }
		.ask-stage { color: var(--theme-color-text-secondary, #5b6376); }
		.ask-answer-status { display: inline-block; margin-bottom: 14px; }
		.ask-qblock { margin: 0 0 18px; padding: 12px 14px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-left: 3px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 8px; background: var(--theme-color-background-secondary, #f3f5f9); }
		.ask-qlabel, .ask-alabel { font-size: 0.72em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 5px; }
		.ask-alabel { margin-top: 2px; }
		.ask-qtext { color: var(--theme-color-text-primary, #1d2230); line-height: 1.5; white-space: pre-wrap; word-break: break-word; }
		.ask-outcome { border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 10px; padding: 16px; background: var(--theme-color-background-secondary, #f3f5f9); line-height: 1.55; color: var(--theme-color-text-primary, #1d2230); white-space: pre-wrap; }
		.ask-outcome-fail { color: var(--theme-color-status-error, #c0353a); white-space: pre-wrap; }
		.ask-hist { margin-top: 32px; border-top: 1px solid var(--theme-color-border-default, #d8dde6); padding-top: 18px; }
		.ask-hist-row { display: flex; align-items: center; gap: 2px; border-radius: 8px; }
		.ask-hist-row:hover { background: var(--theme-color-background-hover, #f3f5f9); }
		.ask-hist-open { flex: 1 1 auto; min-width: 0; display: flex; align-items: center; justify-content: space-between; gap: 10px; text-align: left; cursor: pointer; padding: 9px 12px; border: none; border-radius: 8px; background: none; color: var(--theme-color-text-primary, #1d2230); font: inherit; }
		.ask-hist-del { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; margin-right: 6px; padding: 0; border: none; border-radius: 7px; background: none; color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; opacity: 0.5; transition: opacity 0.12s, color 0.12s, background 0.12s; }
		.ask-hist-row:hover .ask-hist-del { opacity: 1; }
		.ask-hist-del:hover { color: var(--theme-color-status-error, #c0353a); background: var(--theme-color-status-error-background, rgba(198,40,40,0.12)); }
		.ask-hist-del svg { width: 15px; height: 15px; }
		.ask-hist-name { font-size: 0.92em; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.ask-pill { display: inline-block; font-size: 0.62em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; padding: 2px 9px; border-radius: 11px; }
		.ask-pill-pending { background: #9e9e9e; color: #fff; }
		.ask-pill-running { background: #F6C453; color: #3a2f00; }
		.ask-pill-answered { background: #2E7D32; color: #fff; }
		.ask-pill-failed, .ask-pill-cancelled { background: #C62828; color: #fff; }
		.ask-attach { display: inline-flex; align-items: center; gap: 8px; flex-wrap: wrap; }
		.ask-file { display: none; }
		.ask-attach-btn { padding: 7px 12px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: none; color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; font-size: 0.88em; }
		.ask-attach-btn:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-brand-primary, #3b6fd4); }
		.ask-chips { display: inline-flex; gap: 6px; flex-wrap: wrap; }
		.ask-chip { display: inline-flex; align-items: center; gap: 6px; padding: 4px 6px 4px 10px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 999px; background: var(--theme-color-background-secondary, #f3f5f9); font-size: 0.82em; color: var(--theme-color-text-primary, #1d2230); }
		.ask-chip-static { padding: 4px 10px; }
		.ask-chip-name { max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.ask-chip-x { border: none; background: none; cursor: pointer; color: var(--theme-color-text-secondary, #5b6376); font-size: 1.1em; line-height: 1; padding: 0 2px; }
		.ask-chip-x:hover { color: var(--theme-color-status-error, #c0353a); }
		.ask-chip-pending { opacity: 0.7; }
		.ask-chip-spin { width: 11px; height: 11px; border: 2px solid var(--theme-color-border-default, #d8dde6); border-top-color: var(--theme-color-brand-primary, #3b6fd4); border-radius: 50%; animation: ask-spin 0.8s linear infinite; display: inline-block; }
		.ask-chat { display: flex; flex-direction: column; }
		.ask-chat-head { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
		.ask-thread { display: flex; flex-direction: column; gap: 14px; max-height: 60vh; overflow-y: auto; padding: 6px 2px 12px; }
		.ask-msg { max-width: 85%; }
		.ask-msg-user { align-self: flex-end; }
		.ask-msg-assistant { align-self: flex-start; }
		.ask-msg-role { font-size: 0.68em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 4px; }
		.ask-msg-body { display: inline-block; text-align: left; padding: 10px 13px; border-radius: 12px; line-height: 1.5; white-space: pre-wrap; word-break: break-word; }
		.ask-msg-user .ask-msg-body { background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; border-bottom-right-radius: 4px; }
		.ask-msg-assistant .ask-msg-body { background: var(--theme-color-background-secondary, #f3f5f9); color: var(--theme-color-text-primary, #1d2230); border: 1px solid var(--theme-color-border-default, #d8dde6); border-bottom-left-radius: 4px; }
		.ask-msg-body .ask-md { white-space: normal; }
		.ask-msg-atts { margin-top: 6px; display: flex; gap: 6px; flex-wrap: wrap; }
		.ask-msg-user .ask-msg-atts { justify-content: flex-end; }
		.ask-msg-meta { margin-top: 6px; }
		.ask-meta-link { font-size: 0.88em; color: var(--theme-color-brand-primary, #3b6fd4); text-decoration: none; }
		.ask-meta-link:hover { text-decoration: underline; }
		.ask-typing { display: inline-flex; gap: 4px; align-items: center; }
		.ask-typing span { width: 6px; height: 6px; border-radius: 50%; background: var(--theme-color-text-secondary, #5b6376); opacity: 0.5; animation: ask-bounce 1.2s infinite ease-in-out; }
		.ask-typing span:nth-child(2) { animation-delay: 0.15s; }
		.ask-typing span:nth-child(3) { animation-delay: 0.3s; }
		@keyframes ask-bounce { 0%, 60%, 100% { transform: translateY(0); opacity: 0.4; } 30% { transform: translateY(-4px); opacity: 1; } }
		.ask-composer { margin-top: 16px; border-top: 1px solid var(--theme-color-border-default, #d8dde6); padding-top: 14px; }
		.ask-composer-text { margin-bottom: 8px; }
		.ask-composer-row { display: flex; align-items: center; justify-content: space-between; gap: 10px; flex-wrap: wrap; }
		.ask-send { flex: 0 0 auto; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-Ask',
			Template: /*html*/`
<div class="ask-wrap">
	<div class="ask-head">
		<h1>Ask</h1>
		<p class="ask-sub">Pick a task, describe what you need, and a runner brings back the answer.</p>
	</div>
	<div id="Ask-Body" class="ask-body"></div>
</div>`
		}
	],
	Renderables:
	[
		{ RenderableHash: 'Plansheet-Ask', TemplateHash: 'Plansheet-Ask', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

module.exports = PictViewAsk;
module.exports.default_configuration = PictViewAskConfiguration;

},{"./MarkdownRender.js":649,"pict-view":365}],653:[function(require,module,exports){
const libPictView = require('pict-view');
const libBrand = require('../Plansheet-Brand.js');
const libProviderLabels = require('../OAuth-Provider-Labels.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Plansheet-Auth',
	DefaultRenderable: 'Auth-Display',
	CSS: /*css*/`
		/* Sign-in stands on its own: hide the app chrome and fill the viewport. */
		body.plansheet-auth-mode .pict-modal-shell-panel { display: none !important; }
		.cst-auth
		{
			position: fixed; inset: 0; z-index: 40;
			display: flex; align-items: center; justify-content: center;
			padding: 32px 20px; overflow: auto;
			background: var(--theme-color-background-primary, #f6f8fb);
		}
		.cst-auth-stage { width: 100%; max-width: 380px; display: flex; flex-direction: column; align-items: center; }
		.cst-auth-brand { display: flex; flex-direction: column; align-items: center; gap: 14px; margin-bottom: 26px; }
		.cst-auth-mark svg { width: 76px; height: 76px; display: block; }
		.cst-auth-wordmark { font-size: 34px; font-weight: 700; letter-spacing: -0.5px; color: var(--theme-color-text-primary, #1d2230); }
		.cst-auth-card
		{
			width: 100%;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #e4e8ef);
			border-radius: 14px;
			padding: 26px 26px 22px;
			box-shadow: 0 8px 30px rgba(20,30,50,0.06);
		}
		.cst-auth-title { font-size: 17px; font-weight: 600; margin: 0 0 4px; text-align: center; color: var(--theme-color-text-primary, #2c3140); }
		.cst-auth-subtitle { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 20px; text-align: center; }
		.cst-auth-field { display: flex; flex-direction: column; gap: 4px; margin-bottom: 14px; }
		.cst-auth-field label { font-size: 12px; font-weight: 500; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-auth-field input
		{
			width: 100%;
			padding: 10px 12px;
			font-size: 14px;
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px;
			background: var(--theme-color-background-secondary, #f7f8fb);
			color: var(--theme-color-text-primary, #2c3140);
			box-sizing: border-box;
		}
		.cst-auth-field input:focus { outline: none; border-color: var(--theme-color-brand-primary, #2988df); }
		.cst-auth-button
		{
			width: 100%;
			padding: 11px 14px;
			background: var(--theme-color-brand-primary, #2988df);
			color: var(--theme-color-text-on-brand, #fff);
			border: none;
			border-radius: 8px;
			font-weight: 500;
			cursor: pointer;
			font-size: 14px;
			margin-top: 6px;
		}
		.cst-auth-button:disabled { opacity: 0.6; cursor: wait; }
		.cst-auth-otp { text-align: center; letter-spacing: 0.4em; font-size: 20px; font-weight: 600; padding-left: 0.4em; }
		.cst-auth-actions { display: flex; justify-content: space-between; margin-top: 16px; font-size: 13px; }
		.cst-auth-actions a { color: var(--theme-color-brand-primary, #2988df); cursor: pointer; text-decoration: underline; }
		.cst-auth-note { text-align: center; font-size: 12px; color: var(--theme-color-status-success, #1f8a4c); margin-top: 10px; min-height: 14px; }
		.cst-auth-divider
		{
			text-align: center;
			margin: 18px 0;
			color: var(--theme-color-text-secondary, #5b6376);
			font-size: 12px;
			position: relative;
		}
		.cst-auth-divider::before, .cst-auth-divider::after
		{
			content: ""; position: absolute; top: 50%;
			width: calc(50% - 22px); height: 1px;
			background: var(--theme-color-border-default, #d8dde6);
		}
		.cst-auth-divider::before { left: 0; }
		.cst-auth-divider::after  { right: 0; }
		.cst-auth-providers { display: flex; flex-direction: column; gap: 8px; }
		.cst-auth-provider
		{
			padding: 10px 12px;
			background: var(--theme-color-background-secondary, #f7f8fb);
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px;
			color: var(--theme-color-text-primary, #2c3140);
			text-decoration: none;
			font-size: 14px;
			text-align: center;
			font-weight: 500;
		}
		.cst-auth-provider:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-auth-toggle
		{
			text-align: center;
			margin-top: 16px;
			font-size: 13px;
			color: var(--theme-color-text-secondary, #5b6376);
		}
		.cst-auth-toggle a { color: var(--theme-color-brand-primary, #2988df); cursor: pointer; text-decoration: underline; }
		.cst-auth-error
		{
			margin: 0 0 12px;
			padding: 10px 12px;
			border-radius: 8px;
			background: var(--theme-color-status-error-background, #fdecec);
			color: var(--theme-color-status-error, #c0353a);
			font-size: 13px;
			border: 1px solid var(--theme-color-status-error-border, #f3c2c2);
		}
		.cst-auth-guest
		{
			text-align: center;
			margin-top: 18px;
			font-size: 12px;
			color: var(--theme-color-text-secondary, #5b6376);
		}
		.cst-auth-guest a { color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; }
	`,
	Templates:
	[
		{
			Hash: 'Auth-Display',
			Template: /*html*/`
<div class="cst-auth" id="Auth-Root">
	<div class="cst-auth-stage">
		<div class="cst-auth-brand">
			<div class="cst-auth-mark">{~D:AppData.Auth.Brand.Mark~}</div>
			<div class="cst-auth-wordmark">{~D:AppData.Auth.Brand.Name~}</div>
		</div>
		<div class="cst-auth-card">
			{~TS:Auth-Login-Template:AppData.Auth.UISlot.Login~}
			{~TS:Auth-Signup-Template:AppData.Auth.UISlot.Signup~}
			{~TS:Auth-Verify-Template:AppData.Auth.UISlot.Verify~}
			{~TS:Auth-Recovery-Template:AppData.Auth.UISlot.Recovery~}
			{~TS:Auth-Enroll-Send-Template:AppData.Auth.UISlot.EnrollSend~}
			{~TS:Auth-Enroll-Code-Template:AppData.Auth.UISlot.EnrollCode~}
		</div>
		<div class="cst-auth-toggle">New to Plansheet? <a href="https://www.plansheet.io/" target="_blank" rel="noopener">Learn more</a></div>
	</div>
</div>`
		},
		{
			Hash: 'Auth-Login-Template',
			Template: /*html*/`
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitLogin();">
	<div class="cst-auth-field">
		<label for="Auth-Login-Username">Email or username</label>
		<input id="Auth-Login-Username" type="text" autocomplete="username" autofocus />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Login-Password">Password</label>
		<input id="Auth-Login-Password" type="password" autocomplete="current-password" />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Login-Submit">Sign in</button>
</form>
<div class="cst-auth-toggle">
	<a onclick="_Pict.views['Plansheet-Auth'].sendMagicLink()">Email me a sign-in link instead</a>
</div>
<div class="cst-auth-note" id="Auth-Magic-Note"></div>
{~TS:Auth-Providers-Template:AppData.Auth.UISlot.HasProviders~}
<div class="cst-auth-toggle">
	No account yet? <a onclick="_Pict.views['Plansheet-Auth'].switchMode('signup')">Create one</a>
</div>`
		},
		{
			Hash: 'Auth-Signup-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Create your account</h2>
<p class="cst-auth-subtitle">Saves your sessions and gives you a timeline across them.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitSignup();">
	<div class="cst-auth-field">
		<label for="Auth-Signup-Email">Email</label>
		<input id="Auth-Signup-Email" type="email" autocomplete="email" autofocus />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Signup-Login">Username</label>
		<input id="Auth-Signup-Login" type="text" autocomplete="username" />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Signup-Display">Display name</label>
		<input id="Auth-Signup-Display" type="text" autocomplete="name" />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Signup-Password">Password</label>
		<input id="Auth-Signup-Password" type="password" autocomplete="new-password" />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Signup-Submit">Create account</button>
</form>
{~TS:Auth-Providers-Template:AppData.Auth.UISlot.HasProviders~}
<div class="cst-auth-toggle">
	Already have an account? <a onclick="_Pict.views['Plansheet-Auth'].switchMode('login')">Sign in</a>
</div>`
		},
		{
			Hash: 'Auth-Verify-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Enter your code</h2>
<p class="cst-auth-subtitle">We sent a 6-digit code to {~D:Record.MaskedDestination~}. It expires in a few minutes.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitVerify();">
	<div class="cst-auth-field">
		<label for="Auth-Verify-Code">Verification code</label>
		<input id="Auth-Verify-Code" class="cst-auth-otp" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" autofocus />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Verify-Submit">Verify and sign in</button>
</form>
<div class="cst-auth-note">{~D:Record.ResendNote~}</div>
<div class="cst-auth-actions">
	<a onclick="_Pict.views['Plansheet-Auth'].resendCode()">Resend code</a>
	<a onclick="_Pict.views['Plansheet-Auth'].cancelVerify()">Use a different account</a>
</div>
<div class="cst-auth-toggle"><a onclick="_Pict.views['Plansheet-Auth'].toggleRecovery(true)">Use a recovery code instead</a></div>`
		},
		{
			Hash: 'Auth-Recovery-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Enter a recovery code</h2>
<p class="cst-auth-subtitle">Use one of the recovery codes you saved when you turned on two-step verification.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitRecovery();">
	<div class="cst-auth-field">
		<label for="Auth-Recovery-Code">Recovery code</label>
		<input id="Auth-Recovery-Code" type="text" autocomplete="one-time-code" placeholder="XXXX-XXXX" autofocus />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Recovery-Submit">Verify and sign in</button>
</form>
<div class="cst-auth-toggle"><a onclick="_Pict.views['Plansheet-Auth'].toggleRecovery(false)">Use the emailed code instead</a></div>`
		},
		{
			Hash: 'Auth-Enroll-Send-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Set up two-step verification</h2>
<p class="cst-auth-subtitle">{~D:Record.OrgLine~} We will email a one-time code to {~D:Record.EmailMasked~}.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<button class="cst-auth-button" id="Auth-Enroll-Send" onclick="_Pict.views['Plansheet-Auth'].enrollSendCode()">Email me a code</button>
<div class="cst-auth-actions">
	<a onclick="_Pict.views['Plansheet-Auth'].enrollSignOut()">Sign out</a>
</div>`
		},
		{
			Hash: 'Auth-Enroll-Code-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Enter your code</h2>
<p class="cst-auth-subtitle">We emailed a 6-digit code to {~D:Record.Masked~}.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].enrollConfirm();">
	<div class="cst-auth-field">
		<label for="Auth-Enroll-Code">Verification code</label>
		<input id="Auth-Enroll-Code" class="cst-auth-otp" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" autofocus />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Enroll-Confirm">Confirm and continue</button>
</form>
<div class="cst-auth-actions">
	<a onclick="_Pict.views['Plansheet-Auth'].enrollResend()">Resend code</a>
	<a onclick="_Pict.views['Plansheet-Auth'].enrollSignOut()">Sign out</a>
</div>`
		},
		{
			Hash: 'Auth-Providers-Template',
			Template: /*html*/`
<div class="cst-auth-divider">or continue with</div>
<div class="cst-auth-providers">
	{~TS:Auth-Provider-Row-Template:AppData.Auth.Providers~}
</div>`
		},
		{
			Hash: 'Auth-Provider-Row-Template',
			Template: /*html*/`<a class="cst-auth-provider" href="{~D:Record.BeginURL~}">{~D:Record.Label~}</a>`
		},
		{
			Hash: 'Auth-Error-Template',
			Template: /*html*/`<div class="cst-auth-error">{~D:Record.Message~}</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Auth-Display',
			TemplateHash:   'Auth-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

function _maskEmail(pEmail)
{
	let tmpStr = String(pEmail || '');
	let tmpAt = tmpStr.indexOf('@');
	if (tmpAt < 1) { return 'your email'; }
	return tmpStr.charAt(0) + '***' + tmpStr.slice(tmpAt);
}

class PictViewAuth extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.pict.AppData.Auth = this.pict.AppData.Auth || { LoggedIn: false, User: null, Providers: [], LastError: null };
		this.pict.AppData.Auth.Brand = this.pict.AppData.Auth.Brand ||
			{ Name: libBrand.Name || 'Plansheet', Tagline: libBrand.Tagline || '', Mark: libBrand.Icon || '' };
		this.pict.AppData.Auth.UISlot = this.pict.AppData.Auth.UISlot || { Mode: 'login', Login: [{}], Signup: [], Verify: [], Recovery: [], EnrollSend: [], EnrollCode: [], HasProviders: [], Error: [] };
		this.pict.AppData.Auth.UISlot.Mode = this.pict.AppData.Auth.UISlot.Mode || 'login';
		this._refreshSlots();
	}

	switchMode(pMode)
	{
		this.pict.AppData.Auth.UISlot.Mode = (pMode === 'signup' || pMode === 'verify' || pMode === 'enroll') ? pMode : 'login';
		this.pict.AppData.Auth.LastError = null;
		this.pict.AppData.Auth.ResendNote = null;
		this.pict.AppData.Auth.EnrollFlow = null;
		this.pict.AppData.Auth.RecoveryMode = false;
		this._refreshSlots();
		this.render();
	}

	_refreshSlots()
	{
		let tmpAuth = this.pict.AppData.Auth;
		let tmpMode = tmpAuth.UISlot.Mode;
		let tmpProviders = (tmpAuth.Providers || []).map((pProvider) =>
			Object.assign({}, pProvider,
				{
					Label: 'Continue with ' + libProviderLabels.labelForProvider(pProvider.Name)
				}));
		tmpAuth.Providers = tmpProviders;
		tmpAuth.UISlot.Login = (tmpMode === 'login') ? [{}] : [];
		tmpAuth.UISlot.Signup = (tmpMode === 'signup') ? [{}] : [];
		let tmpChallenge = tmpAuth.PendingChallenge || null;
		let tmpRecoveryMode = !!tmpAuth.RecoveryMode;
		tmpAuth.UISlot.Verify = (tmpMode === 'verify' && tmpChallenge && !tmpRecoveryMode)
			? [{ MaskedDestination: tmpChallenge.MaskedDestination || 'your account', Channel: tmpChallenge.Channel || 'email', ResendNote: tmpAuth.ResendNote || '' }]
			: [];
		tmpAuth.UISlot.Recovery = (tmpMode === 'verify' && tmpChallenge && tmpRecoveryMode) ? [{}] : [];
		let tmpEnrollUser = tmpAuth.User || {};
		let tmpEnrollFlow = tmpAuth.EnrollFlow || null;
		let tmpOrgLine = tmpEnrollUser.CustomerName
			? (tmpEnrollUser.CustomerName + ' requires two-step verification for password sign-in.')
			: 'Your organization requires two-step verification for password sign-in.';
		tmpAuth.UISlot.EnrollSend = (tmpMode === 'enroll' && !(tmpEnrollFlow && tmpEnrollFlow.Token))
			? [{ OrgLine: tmpOrgLine, EmailMasked: _maskEmail(tmpEnrollUser.Email) }]
			: [];
		tmpAuth.UISlot.EnrollCode = (tmpMode === 'enroll' && tmpEnrollFlow && tmpEnrollFlow.Token)
			? [{ Masked: tmpEnrollFlow.Masked || _maskEmail(tmpEnrollUser.Email) }]
			: [];
		tmpAuth.UISlot.HasProviders = (tmpProviders.length > 0) ? [{}] : [];
		tmpAuth.UISlot.Error = tmpAuth.LastError ? [{ Message: tmpAuth.LastError }] : [];
	}

	submitLogin()
	{
		let tmpUser = (document.getElementById('Auth-Login-Username') || {}).value || '';
		let tmpPass = (document.getElementById('Auth-Login-Password') || {}).value || '';
		if (!tmpUser || !tmpPass)
		{
			this.pict.AppData.Auth.LastError = 'Username and password are required.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Login-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.AuthClient.login(tmpUser, tmpPass).then((pResult) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pResult === 'challenge')
			{
				// Two-step verification: swap to the code-entry card.
				this.switchMode('verify');
				return;
			}
			if (pResult)
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	// Passwordless: email the user a one-time sign-in link. Uses the reusable magic-link engine
	// (Plansheet-MagicLogin). The request is anti-enumeration, so the note is the same whether or not an
	// account matches -- we only ask for an email in the sign-in field first.
	sendMagicLink()
	{
		let tmpEmail = String((document.getElementById('Auth-Login-Username') || {}).value || '').trim();
		if (!tmpEmail || tmpEmail.indexOf('@') < 1)
		{
			this._setMagicNote('Enter your email in the field above, then click here.');
			return;
		}
		let tmpMagic = this.pict.views['Plansheet-MagicLogin'];
		if (!tmpMagic || typeof tmpMagic.requestMagicLink !== 'function')
		{
			this._setMagicNote('Sign-in links are not available right now.');
			return;
		}
		this._setMagicNote('Sending...');
		tmpMagic.requestMagicLink(tmpEmail, () =>
		{
			this._setMagicNote('Check your email for a one-time sign-in link.');
		});
	}

	_setMagicNote(pText)
	{
		if (typeof document === 'undefined') { return; }
		let tmpNote = document.getElementById('Auth-Magic-Note');
		if (tmpNote) { tmpNote.textContent = pText || ''; }
	}

	submitSignup()
	{
		let tmpEmail = (document.getElementById('Auth-Signup-Email') || {}).value || '';
		let tmpLogin = (document.getElementById('Auth-Signup-Login') || {}).value || '';
		let tmpDisplay = (document.getElementById('Auth-Signup-Display') || {}).value || '';
		let tmpPass = (document.getElementById('Auth-Signup-Password') || {}).value || '';
		if (!tmpEmail || !tmpLogin || !tmpPass)
		{
			this.pict.AppData.Auth.LastError = 'Email, username, and password are required.';
			this._refreshSlots();
			this.render();
			return;
		}
		if (tmpPass.length < 8)
		{
			this.pict.AppData.Auth.LastError = 'Password must be at least 8 characters.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Signup-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.AuthClient.signup(
			{
				Email: tmpEmail,
				LocalLogin: tmpLogin,
				DisplayName: tmpDisplay,
				Password: tmpPass
			}).then((pOk) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pOk)
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	submitVerify()
	{
		let tmpCode = ((document.getElementById('Auth-Verify-Code') || {}).value || '').trim();
		if (!tmpCode)
		{
			this.pict.AppData.Auth.LastError = 'Enter the code we sent you.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Verify-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.AppData.Auth.ResendNote = null;
		this.pict.providers.AuthClient.verifyLoginCode(tmpCode).then((pOk) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pOk)
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	toggleRecovery(pOn)
	{
		this.pict.AppData.Auth.RecoveryMode = !!pOn;
		this.pict.AppData.Auth.LastError = null;
		this.pict.AppData.Auth.ResendNote = null;
		this._refreshSlots();
		this.render();
	}

	submitRecovery()
	{
		let tmpCode = ((document.getElementById('Auth-Recovery-Code') || {}).value || '').trim();
		if (!tmpCode)
		{
			this.pict.AppData.Auth.LastError = 'Enter one of your recovery codes.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Recovery-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.AuthClient.useRecoveryCode(tmpCode).then((pOk) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pOk)
			{
				this.pict.AppData.Auth.RecoveryMode = false;
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	resendCode()
	{
		this.pict.providers.AuthClient.resendLoginCode().then((pMasked) =>
		{
			this.pict.AppData.Auth.LastError = pMasked ? null : 'Could not resend a code. Please sign in again.';
			this.pict.AppData.Auth.ResendNote = pMasked ? ('A new code is on the way to ' + pMasked + '.') : null;
			this._refreshSlots();
			this.render();
		});
	}

	cancelVerify()
	{
		this.pict.providers.AuthClient.cancelChallenge();
		this.pict.AppData.Auth.ResendNote = null;
		this.switchMode('login');
	}

	// Forced enrollment (org requires 2FA, this account is not enrolled). The
	// session is signed in but restricted; these calls reach the allowed
	// /1.0/Account/TwoFactor endpoints. Email channel keeps it recoverable.
	enrollSendCode()
	{
		let tmpButton = document.getElementById('Auth-Enroll-Send');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.AppData.Auth.LastError = null;
		this.pict.providers.UserAPI.enableTwoFactor('email').then((pBody) =>
		{
			this.pict.AppData.Auth.EnrollFlow = { Token: pBody.ChallengeToken, Masked: pBody.MaskedDestination };
			this._refreshSlots();
			this.render();
		}).catch((pErr) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			this.pict.AppData.Auth.LastError = pErr.message || 'Could not send a code.';
			this._refreshSlots();
			this.render();
		});
	}

	enrollResend()
	{
		this.pict.providers.UserAPI.enableTwoFactor('email').then((pBody) =>
		{
			this.pict.AppData.Auth.EnrollFlow = { Token: pBody.ChallengeToken, Masked: pBody.MaskedDestination };
			this.pict.AppData.Auth.LastError = null;
			this._refreshSlots();
			this.render();
		}).catch(() => {});
	}

	enrollConfirm()
	{
		let tmpCode = ((document.getElementById('Auth-Enroll-Code') || {}).value || '').trim();
		let tmpFlow = this.pict.AppData.Auth.EnrollFlow || {};
		if (!tmpCode)
		{
			this.pict.AppData.Auth.LastError = 'Enter the code we emailed you.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Enroll-Confirm');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.UserAPI.confirmTwoFactor(tmpFlow.Token, tmpCode).then(() =>
		{
			this.pict.AppData.Auth.EnrollFlow = null;
			if (this.pict.AppData.Auth.User) { this.pict.AppData.Auth.User.MustEnroll2FA = false; }
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
		}).catch((pErr) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			this.pict.AppData.Auth.LastError = pErr.message || 'Incorrect code.';
			this._refreshSlots();
			this.render();
		});
	}

	enrollSignOut()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.signOut === 'function') { tmpApp.signOut(); return; }
		this.pict.providers.AuthClient.logout().then(() => this.switchMode('login'));
	}

	onBeforeRender(pRenderable)
	{
		this._refreshSlots();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		// TEMP DIAGNOSTIC ([auth-boot]) for the OAuth-button cold-load issue: log what actually painted --
		// the HasProviders slot the template read and the OAuth buttons that ended up in the DOM. Remove
		// once confirmed (grep "auth-boot").
		try
		{
			let tmpHas = (this.pict.AppData.Auth && this.pict.AppData.Auth.UISlot && this.pict.AppData.Auth.UISlot.HasProviders) ? this.pict.AppData.Auth.UISlot.HasProviders.length : 0;
			let tmpBtns = (typeof document !== 'undefined') ? document.querySelectorAll('.cst-auth-provider').length : 0;
			console.log('[auth-boot] +' + Math.round((typeof performance !== 'undefined' ? performance.now() : 0)) + 'ms auth render -- HasProviders=' + tmpHas + ', buttons in DOM=' + tmpBtns);
		}
		catch (pErr) { /* no-op */ }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewAuth;
module.exports.default_configuration = _ViewConfiguration;

},{"../OAuth-Provider-Labels.js":562,"../Plansheet-Brand.js":565,"pict-view":365}],654:[function(require,module,exports){
'use strict';

/**
 * PictView-Blueprint
 * ------------------
 * The full-page, read-only "blueprint" for a Work Item: every linked artifact
 * (visions, features, documents, media + recordings, whiteboards, sessions,
 * comments, issues) laid out on one drafting sheet. Fetches the enriched
 * /1.0/WorkItem/:id/Blueprint payload and renders a title block + a plate per
 * artifact group, with media and video shown inline.
 *
 * Editors also get the share strip above the sheet (BlueprintShareUI), the same
 * control the compact in-detail blueprint block uses.
 *
 * The HTML/CSS comes from source/BlueprintRender.js, the same module the server
 * uses for the public /shared/:token page, so the two stay identical.
 *
 * Shown via the app's #/work-item/:id/blueprint route (Pict-Application._renderBlueprint).
 */

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');
const libBlueprintRender = require('../BlueprintRender.js');
const libShareUI = require('../BlueprintShareUI.js');
const libLayout = require('../BlueprintLayout.js');

function _esc(pStr)
{
	return String(pStr === null || typeof pStr === 'undefined' ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

class PictViewBlueprint extends libPictView
{
	onBeforeInitialize()
	{
		this._data = null;
		this._id = 0;
		this._loading = false;
		this._share = null;
		this._canShare = false;
		return super.onBeforeInitialize();
	}

	// In-app icons come from the Pict icon provider (the app's set), passed into
	// the shared renderer as its fIcon so the rest of the app's chrome matches.
	_icon(pType)
	{
		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Icon;
		return tmpProvider ? tmpProvider.get(libBlueprintRender.ICON_FOR[pType] || 'FileText') : '';
	}

	_can(pEntitlement)
	{
		let tmpApp = this.pict.PictApplication;
		return !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can(pEntitlement));
	}

	// Load + paint a blueprint, named either by the entity that owns it or by the blueprint record
	// itself. The caller passes a BlueprintAPI subject and this view no longer knows the difference:
	// it used to string-concatenate an entity key into every URL it built, which is why a blueprint
	// opened as itself could not be read, shared or printed at all.
	show(pSubject)
	{
		let tmpAPI = this._api();
		this._subject = (pSubject && pSubject.ID) ? pSubject : null;
		this._id = this._subject ? this._subject.ID : 0;
		// Kept for the share strip and anything else that still reads a key off the view.
		this._entityKey = this._subject ? this._subject.EntityKey : '';
		this._data = null;
		this._share = null;
		this._versions = [];
		this._loading = true;
		// Any blueprint can be shared: the share row hangs off IDBlueprint, and the public read, the public
		// page and the token-scoped media all resolve through the blueprint's own owner (WI #340).
		this._canShare = this._can('content.edit');
		this.render();
		if (!this._subject || !tmpAPI) { this._loading = false; return; }

		let fBlueprint = tmpAPI.readSubject(this._subject);
		let fShare = this._canShare ? libShareUI.fetchState(this.pict, this._subject) : Promise.resolve(null);
		// The version history of the SHEET, which is keyed on the blueprint row rather than the subject.
		// A subject-shaped id here would list somebody else's history or nothing at all.
		let fVersions = (this._subject && this._subject.EntityKey === 'Blueprint')
			? tmpAPI.versions(this._subject.ID) : Promise.resolve([]);

		Promise.all([fBlueprint, fShare, fVersions]).then((pResults) =>
		{
			this._data = pResults[0] || null;
			// Re-address by record once we know it. Pinning, the by-id share family and the by-id
			// print route all key off IDBlueprint, which only the payload can tell us.
			if (this._data && tmpAPI) { this._subject = tmpAPI.subjectFromPayload(this._data) || this._subject; }
			this._share = pResults[1] || null;
			this._versions = pResults[2] || [];
			// Re-read once the payload has told us the real blueprint id, because the first attempt could
			// only have been right when the page was opened by blueprint rather than through a host entity.
			if (this._subject && this._data && !this._versions.length && tmpAPI)
			{
				tmpAPI.versions(this._subject.ID).then((pRows) =>
				{
					if (!pRows || !pRows.length) { return; }
					this._versions = pRows;
					this.render();
				});
			}
			this._loading = false;
			if (this.pict.PictApplication && typeof this.pict.PictApplication._setPageTitle === 'function') { this.pict.PictApplication._setPageTitle((this._data && this._data.Title) ? (this._data.Title + ' Blueprint') : 'Blueprint'); }
			this.render();
		}).catch(() => { this._data = null; this._loading = false; this.render(); });
	}

	/**
	 * Every version of this sheet, each one openable.
	 *
	 * THE OPEN LINK IS WHY THIS EXISTS. The thing this replaced could issue versions and list them and
	 * never open one: you could see that a snapshot existed and had no way to read it, which makes the
	 * record decorative. A version you cannot retrieve is not a record of anything.
	 *
	 * Renders nothing at all when there are none, rather than an empty box explaining itself. A sheet
	 * gets its first version the moment somebody shares it, so an empty list is a sheet nobody has
	 * handed to anyone -- and that needs no commentary on the page.
	 */
	_versionsHTML()
	{
		let tmpVersions = this._versions || [];
		if (!tmpVersions.length) { return ''; }
		let tmpAPI = this.pict.providers.BlueprintAPI;
		let tmpRows = tmpVersions.map((pVersion) =>
		{
			let tmpWhen = String(pVersion.IssuedAt || '').substring(0, 10);
			let tmpTo = pVersion.IssuedTo ? (' <span class="bp-ver-to">to ' + _esc(pVersion.IssuedTo) + '</span>') : '';
			let tmpSheets = Number(pVersion.SheetCount) || 0;
			let tmpCount = tmpSheets ? ('<span class="bp-ver-n">' + tmpSheets + (tmpSheets === 1 ? ' sheet' : ' sheets') + '</span>') : '';
			let tmpHref = tmpAPI ? tmpAPI.versionURL(pVersion.IDBlueprintRevision, 'Letter', 'Desk') : '#';
			return '<li class="bp-ver">'
				+ '<span class="bp-ver-mark">Rev ' + _esc(pVersion.Revision) + '</span>'
				+ '<span class="bp-ver-when">' + _esc(tmpWhen) + '</span>'
				+ tmpTo + tmpCount
				+ '<a class="bp-ver-open" href="' + _esc(tmpHref) + '" target="_blank" rel="noopener"'
				+ ' title="Open this version exactly as it was frozen">Open</a>'
			+ '</li>';
		}).join('');
		return '<div class="bp-versions"><div class="bp-versions-head">Versions</div>'
			+ '<ol class="bp-versions-list">' + tmpRows + '</ol></div>';
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		if (typeof document !== 'undefined')
		{
			let tmpShare = document.getElementById('Blueprint-Share');
			if (tmpShare) { tmpShare.innerHTML = (this._canShare && !this._loading && this._data) ? libShareUI.stripHTML(this._share, this._selfRef()) : ''; }
			let tmpVersions = document.getElementById('Blueprint-Versions');
			if (tmpVersions) { tmpVersions.innerHTML = (!this._loading && this._data) ? this._versionsHTML() : ''; }
			let tmpHost = document.getElementById('Blueprint-Sheet');
			if (tmpHost)
			{
				tmpHost.innerHTML = this._sheetHTML();
				// A designed layout fits its text to its cells, same as the studio and the PDF.
				if (this._renderedLayout && typeof libLayout.fitLayout === 'function') { libLayout.fitLayout(tmpHost); }
				// A responsive layout re-fits when the pane resizes (crossing 1:1 swaps the arrangement and
				// re-cells every text region). A fixed layout never reflows, so it attaches no observer.
				if (this._fitObserver) { this._fitObserver.disconnect(); this._fitObserver = null; }
				if (this._renderedLayout && this._responsiveLayout && typeof libLayout.observeFit === 'function')
				{
					this._fitObserver = libLayout.observeFit(tmpHost, tmpHost.querySelector('.bp-layout-sheet'));
				}
			}
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_selfRef() { return "_Pict.views['" + this.Hash + "']"; }

	_api() { return this.pict.providers.BlueprintAPI; }

	// ---- handlers --------------------------------------------------------------
	copyLink()
	{
		let tmpURL = (typeof location !== 'undefined') ? location.href : '';
		let fDone = () =>
		{
			let tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Blueprint link copied', { type: 'success' }); }
		};
		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(tmpURL).then(fDone, fDone); }
		else { fDone(); }
	}

	// Back to the record this blueprint describes. It follows the ENTITY, not a hardcoded work item: on a
	// module's blueprint, navigating to /work-item/<id> would open whatever work item happens to carry the
	// same number, which is a different record entirely (WI #340).
	back()
	{
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (!tmpRouter) { return; }
		let tmpApp = this.pict.PictApplication;
		// A blueprint opened as itself has no host id to go back to, but its payload names its owner,
		// so it can still return to the record it describes. With no owner at all (a standalone
		// blueprint) the honest destination is the blueprint list, not some work item.
		let tmpKey = (this._subject && this._subject.Kind === 'entity') ? this._subject.EntityKey : ((this._data && this._data.OwnerType) || '');
		let tmpID = (this._subject && this._subject.Kind === 'entity') ? this._subject.ID : Number((this._data && this._data.IDOwner) || 0);
		if (!tmpKey || !tmpID) { return tmpRouter.navigate('/blueprints'); }
		let tmpSegment = (tmpApp && typeof tmpApp._singularRoute === 'function') ? tmpApp._singularRoute(tmpKey) : 'work-item';
		tmpRouter.navigate('/' + tmpSegment + '/' + tmpID);
	}

	// What the back button calls the thing it opens. A blueprint of a module should not offer to open a work
	// item; saying the wrong noun is how a person ends up on the wrong record and believes the page.
	_ownerNoun()
	{
		let tmpAPI = this._api();
		if (this._subject && this._subject.Kind === 'entity' && tmpAPI) { return tmpAPI.ownerNoun(this._subject); }
		let tmpOwner = (this._data && this._data.OwnerType) || '';
		return (tmpAPI && tmpOwner) ? tmpAPI.ownerNoun(tmpAPI.subjectForEntity(tmpOwner, 1)) : 'blueprint';
	}

	/**
	 * Does this blueprint describe some OTHER record, or is it composed and standing on its own?
	 *
	 * A composed blueprint has no owner, and the owner button then labelled itself from the fallback
	 * noun and read "Open blueprint" -- on the blueprint. Clicking it landed on the blueprint LIST, which
	 * is where back() honestly sends a blueprint with nothing behind it. So the one control a person
	 * reaches for first says it will open the thing they are looking at and instead throws the page away.
	 */
	_hasOwner()
	{
		if (this._subject && this._subject.Kind === 'entity') { return true; }
		return !!((this._data && this._data.OwnerType) && Number((this._data && this._data.IDOwner) || 0));
	}

	// BlueprintShareUI calls this after a share change; a full repaint is cheap here
	// (show() owns the fetch, render() only paints).
	_afterShareChange() { this.render(); }

	// Share strip delegates (BlueprintShareUI operates on this view).
	bpShareCreate() { libShareUI.create(this); }
	bpShareCopy() { libShareUI.copy(this); }
	bpShareCopyBadge() { libShareUI.copyBadge(this); }
	bpShareInvite() { libShareUI.invite(this); }
	bpShareRegenerate() { libShareUI.regenerate(this); }
	bpShareRevoke() { libShareUI.revoke(this); }
	bpShareSetExpiry(pValue) { libShareUI.setExpiry(this, pValue); }
	bpSharePrintEnabled(pEnabled) { libShareUI.setPrintEnabled(this, pEnabled); }
	bpShareRepin() { libShareUI.repin(this); }

	/**
	 * Print this blueprint as a sheet set (F-071, WI #384).
	 *
	 * The tab is opened SYNCHRONOUSLY, inside the click, and filled in once the bytes arrive. Opening it
	 * after the fetch resolves is a popup a browser blocks; pointing the tab straight at the route instead
	 * would work but costs a second render to find out a print failed, and renders are not cheap. This way
	 * the server compiles once and a failure closes the tab and says why.
	 *
	 * And when the tab is blocked ANYWAY -- an embedded browser, a strict popup setting -- the bytes are
	 * handed over as a download instead. Measured, not hypothetical: window.open returns null in the
	 * in-app preview browser, and the first version of this quietly did nothing after making the server
	 * compile a whole sheet set. A print that costs a render and produces no file is the worst of both.
	 */
	print()
	{
		let tmpSheet = this._printSheet || 'Letter';
		if (typeof document !== 'undefined')
		{
			let tmpSelect = document.getElementById('Blueprint-PrintSheet');
			if (tmpSelect && tmpSelect.value) { tmpSheet = tmpSelect.value; }
		}
		// REMEMBERED ON THE VIEW, not left in the DOM. Six share delegates call _afterShareChange ->
		// render(), which re-emits the select from scratch; with the choice living only in the element,
		// toggling the public link after choosing a size silently put it back to Letter. Harmless while
		// the only options were Letter and Legal and nobody looked. With five it is the silent-wrong-
		// document failure resolveSheet refuses a bad size to prevent.
		this._printSheet = tmpSheet;
		if (!this._id) { return; }

		let tmpWindow = (typeof window !== 'undefined') ? window.open('', '_blank') : null;
		let fFail = (pMessage) =>
		{
			if (tmpWindow) { tmpWindow.close(); }
			let tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: 'error' }); }
		};

		let tmpFileName = 'sheet-set.pdf';
		// The URL comes from BlueprintAPI so this works for a blueprint addressed as itself, whose print
		// route (/1.0/Blueprint/:id/Print) the server has always had and nothing ever called. The raw
		// fetch stays: this needs the Content-Disposition header and a blob, which the JSON helpers do
		// not carry through.
		fetch(this._api().printURL(this._subject, tmpSheet), { credentials: 'same-origin' })
			.then((pResponse) =>
			{
				if (pResponse.ok)
				{
					// The server already worked out what this set is called; parsing it back beats inventing a
					// second naming scheme here that would drift from the one on the cover.
					let tmpDisposition = pResponse.headers.get('Content-Disposition') || '';
					let tmpMatch = /filename\*=UTF-8''([^;]+)/.exec(tmpDisposition) || /filename="([^"]+)"/.exec(tmpDisposition);
					if (tmpMatch) { try { tmpFileName = decodeURIComponent(tmpMatch[1]); } catch (pE) { tmpFileName = tmpMatch[1]; } }
					return pResponse.blob();
				}
				// The server distinguishes "you asked for something impossible" from "this server cannot
				// print at all", and both carry a message worth showing rather than a generic failure.
				return pResponse.json().then(
					(pBody) => Promise.reject(new Error((pBody && pBody.Error) || 'Could not print this blueprint.')),
					() => Promise.reject(new Error('Could not print this blueprint.')));
			})
			.then((pBlob) =>
			{
				let tmpURL = URL.createObjectURL(pBlob);
				if (tmpWindow) { tmpWindow.location = tmpURL; return; }
				let tmpAnchor = document.createElement('a');
				tmpAnchor.href = tmpURL;
				tmpAnchor.download = tmpFileName;
				document.body.appendChild(tmpAnchor);
				tmpAnchor.click();
				document.body.removeChild(tmpAnchor);
				let tmpModal = this.pict.views['Pict-Section-Modal'];
				if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Printed ' + tmpFileName, { type: 'success' }); }
			})
			.catch((pError) => fFail((pError && pError.message) || 'Could not print this blueprint.'));
	}

	// ---- rendering -------------------------------------------------------------

	/**
	 * The sheet sizes this server will actually print, ASKED FOR rather than restated here.
	 *
	 * This list used to be two hardcoded options under a comment saying Tabloid and ARCH D had not
	 * landed yet. They landed in WI #382 and #383, the comment did not, and the control went on offering
	 * Letter and Legal over a server that had supported five sizes for months. A list the client cannot
	 * read is a list that drifts, so it reads one now.
	 *
	 * The hardcoded pair survives as the FALLBACK only: a catalog fetch that fails must not take the
	 * print button down with it, and Letter and Legal are the two sizes that have worked since WI #377.
	 */
	_sheetCatalog()
	{
		return Array.isArray(this._sheets) && this._sheets.length
			? this._sheets
			: [ { Sheet: 'Letter', Label: 'Letter (8.5 x 11 in)' }, { Sheet: 'Legal', Label: 'Legal (8.5 x 14 in)' } ];
	}

	/** Load the catalog once, then repaint so the control shows what the server really offers. */
	_loadSheetCatalog()
	{
		if (this._sheetsLoading || (Array.isArray(this._sheets) && this._sheets.length)) { return; }
		this._sheetsLoading = true;
		if (typeof fetch !== 'function') { return; }
		fetch('/1.0/SheetLayouts', { credentials: 'same-origin' })
			.then((pResponse) => (pResponse.ok ? pResponse.json() : null))
			.then((pData) =>
			{
				if (pData && Array.isArray(pData.Sheets) && pData.Sheets.length)
				{
					this._sheets = pData.Sheets;
					this.render();
				}
			})
			// A catalog that will not load leaves the fallback in place. The print button still works at
			// the two sizes everybody has, which is better than a control that vanishes.
			.catch(() => {});
	}

	_printSizesHTML()
	{
		let tmpSelf = this._selfRef();
		this._loadSheetCatalog();
		let tmpChosen = this._printSheet || 'Letter';
		// Ask -- cheaply, no PDF -- whether this size would print any image soft, so the advisory below is
		// ready before somebody commits a whole render only to find a photo blurs on a 24x36 sheet.
		this._ensureResolutionChecked(tmpChosen);
		let tmpOptions = this._sheetCatalog().map((pSheet) =>
			'<option value="' + pSheet.Sheet + '"'
				+ ((pSheet.Sheet === tmpChosen) ? ' selected' : '') + '>'
				+ (pSheet.Label || pSheet.Sheet) + '</option>').join('');
		return '<span class="bp-print-wrap">'
			+ '<select id="Blueprint-PrintSheet" class="bp-print-sheet" title="Sheet size"'
				+ ' onchange="' + tmpSelf + '.bpPrintSheet(this.value)">'
				+ tmpOptions
			+ '</select>'
			+ '<button class="bp-act" onclick="' + tmpSelf + '.print()" title="Compile and print this blueprint as a sheet set">Print</button>'
			+ this._printAdvisoryHTML(tmpChosen)
		+ '</span>';
	}

	/** The chosen size, kept on the view so a repaint cannot quietly discard it. */
	bpPrintSheet(pSheet)
	{
		this._printSheet = String(pSheet || 'Letter');
		// Fetch (or reuse) the advisory for the newly chosen size, then repaint so it shows under the control.
		this._ensureResolutionChecked(this._printSheet);
		this.render();
	}

	/**
	 * The resolution preflight for one size, fetched once and cached on the view. It compiles on the server
	 * (a database walk, not a render), so a size change is cheap; the result drives the advisory below the
	 * print control. A failed check caches an empty result so the button is never held up by it.
	 */
	_ensureResolutionChecked(pSheet)
	{
		let tmpSheet = pSheet || 'Letter';
		this._resolutionBySheet = this._resolutionBySheet || {};
		this._resolutionChecking = this._resolutionChecking || {};
		if (this._resolutionBySheet[tmpSheet] || this._resolutionChecking[tmpSheet]) { return; }
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.checkURL !== 'function' || !this._subject || typeof fetch !== 'function') { return; }
		let tmpURL = tmpAPI.checkURL(this._subject, tmpSheet);
		if (!tmpURL) { return; }
		this._resolutionChecking[tmpSheet] = true;
		fetch(tmpURL, { credentials: 'same-origin' })
			.then((pResponse) => (pResponse.ok ? pResponse.json() : null))
			.then((pData) =>
			{
				this._resolutionChecking[tmpSheet] = false;
				this._resolutionBySheet[tmpSheet] = (pData && pData.Resolution) ? pData.Resolution : { Low: [], Checked: 0 };
				this.render();
			})
			.catch(() =>
			{
				this._resolutionChecking[tmpSheet] = false;
				this._resolutionBySheet[tmpSheet] = { Low: [], Checked: 0 };
			});
	}

	/** A muted advisory under the print control when a picture is too few pixels for the chosen size. */
	_printAdvisoryHTML(pSheet)
	{
		let tmpRes = (this._resolutionBySheet || {})[pSheet];
		if (!tmpRes || !tmpRes.Low || !tmpRes.Low.length) { return ''; }
		let tmpFloor = tmpRes.Floor || 150;
		let tmpList = tmpRes.Low.map((pImage) => pImage.Title + ' (' + pImage.WidthPx + 'px, ' + pImage.PPI + ' ppi)').join('\n');
		let tmpNoun = (tmpRes.Low.length === 1) ? 'image' : 'images';
		return '<span class="bp-print-advisory" title="' + this._attr('Below ' + tmpFloor + ' ppi at this size:\n' + tmpList) + '">'
			+ '<span class="bp-print-advisory-dot">&#9650;</span> '
			+ tmpRes.Low.length + ' ' + tmpNoun + ' may print soft at this size</span>';
	}

	_attr(pText)
	{
		return String(pText == null ? '' : pText)
			.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	_actionsHTML()
	{
		let tmpSelf = this._selfRef();
		// Compose and Details are here because this page took over /blueprint/:id from the generic record
		// pane. That pane could not show a blueprint's contents, which is the bug this fixes -- but it DID
		// carry the curation entry point, the name and description editor, and the comment thread. Routing
		// past it without carrying those forward would trade one missing thing for three.
		// "Details" was the only way to rename a blueprint and it did not say so. Somebody looking for the
		// name went round the page, tried the owner button, landed on the list, and concluded a composed
		// blueprint cannot be edited at all -- which is what it looks like from outside.
		// OFFERED WHENEVER THERE IS A BLUEPRINT ON SCREEN, not only when it already has a record. Gating on
		// this._id hid both controls on exactly the entity blueprints that have no record yet, which is
		// the case _ensureRecordID exists to handle.
		let tmpCurate = this._id
			? ('<button class="bp-act" onclick="' + tmpSelf + '.design()" title="Arrange this blueprint on a grid for web and print at any size, in a drafting or blueprint style">Design</button>'
				+ '<button class="bp-act" onclick="' + tmpSelf + '.compose()" title="Pin and unpin what this blueprint gathers, and set it as the plan sheet cover">Compose</button>'
				+ '<button class="bp-act bp-act-ghost" onclick="' + tmpSelf + '.details()" title="Rename it, edit its description, and read its documentation and comments">Edit details</button>'
				// TAKING CONTROL OF THE MAP IS AN ACTION SOMEBODY TAKES. A large sheet composes a map of the
				// set every time it prints, which is a fine default and nobody's decision. This turns it
				// into one: attach it, arrange it, and from then on the sheet prints the arranged version.
				+ '<button class="bp-act bp-act-ghost" onclick="' + tmpSelf + '.attachSetMap()" title="Save this set\'s map as a drawing you can rearrange. Once attached, large sheets print your version instead of composing one.">Attach set map</button>')
			: '';
		// A blueprint with nothing behind it has nothing to open. The button still earns its place as the
		// way back to the list, but it has to say that rather than name the page you are already on.
		let tmpBack = this._hasOwner()
			? ('<button class="bp-act bp-act-ghost" onclick="' + tmpSelf + '.back()">Open ' + this._ownerNoun() + '</button>')
			: ('<button class="bp-act bp-act-ghost" onclick="' + tmpSelf + '.back()" title="Back to every blueprint in this plan sheet">All blueprints</button>');
		return this._printSizesHTML()
			+ tmpCurate
			+ '<button class="bp-act" onclick="' + tmpSelf + '.copyLink()" title="Copy a link to this blueprint">Copy link</button>'
			+ tmpBack;
	}

	// Curation and the record pane both address the BLUEPRINT, so both need its record id. A blueprint
	// opened through its host does not have one until the payload arrives, which is why these read the
	// subject rather than this._id: after show() re-addresses, the subject is the record.
	_recordID()
	{
		if (this._subject && this._subject.Kind === 'record') { return this._subject.ID; }
		return Number((this._data && this._data.IDBlueprint) || 0);
	}

	/**
	 * The record id these two need, MINTING IT IF THIS ENTITY HAS NONE YET.
	 *
	 * An entity blueprint is computed, and GET /1.0/:EntityType/:id/Blueprint deliberately renders it
	 * with IDBlueprint 0 when no record exists rather than writing one -- a GET with a side effect is
	 * the worse trade, and that reasoning is right.
	 *
	 * But compose() and details() were guarded on that id, so on any entity whose record predates the
	 * create hook BOTH BUTTONS SILENTLY DID NOTHING. No navigation, no error, no clue: the two controls
	 * that curate and rename a blueprint simply had no effect, which reads as the page being broken.
	 *
	 * A click is not a GET. POST /1.0/:EntityType/:id/Blueprint exists for exactly this and is
	 * idempotent, so asking for it here is the explicit write the GET declines to make.
	 */
	_ensureRecordID()
	{
		let tmpID = this._recordID();
		if (tmpID) { return Promise.resolve(tmpID); }

		let tmpOwnerType = (this._subject && this._subject.Kind === 'entity')
			? this._subject.EntityKey : ((this._data && this._data.OwnerType) || '');
		let tmpIDOwner = (this._subject && this._subject.Kind === 'entity')
			? this._subject.ID : Number((this._data && this._data.IDOwner) || 0);
		if (!tmpOwnerType || !tmpIDOwner) { return Promise.resolve(0); }

		return libFrameworkClient.postJSON(this.pict, '/1.0/' + tmpOwnerType + '/' + tmpIDOwner + '/Blueprint', {})
			.then((pResult) =>
			{
				let tmpMinted = Number((pResult && pResult.IDBlueprint) || 0);
				// Keep it, so a second click does not ask again.
				if (tmpMinted && this._data) { this._data.IDBlueprint = tmpMinted; }
				return tmpMinted;
			})
			.catch(() => 0);
	}

	/**
	 * Attach this set's map as a Drawing, so a person owns the layout from here on.
	 *
	 * Deliberately a POST rather than something printing does for you: composing a map is a default,
	 * attaching one is a decision, and the sheet prefers the attached drawing forever after.
	 */
	attachSetMap()
	{
		let tmpID = this._recordID();
		if (!tmpID) { return Promise.resolve(0); }
		return libFrameworkClient.postJSON(this.pict, '/1.0/Blueprint/' + tmpID + '/SetMap', {})
			.then((pResult) =>
			{
				let tmpMedia = (pResult && pResult.Media) || {};
				this._announce((pResult && pResult.Replaced) ? 'Set map refreshed.' : 'Set map attached.',
					'It is a drawing now: open it from this blueprint to rearrange it, and large sheets will print your version.');
				return tmpMedia.IDMedia || 0;
			})
			.catch((pError) =>
			{
				// The likeliest refusal is a set too big to map, and its message says the number, so it is
				// worth showing rather than replacing with something generic.
				this._announce('Could not attach the set map.', (pError && pError.message) || '', 'error');
				return 0;
			});
	}

	/**
	 * Tell the person what happened, the way this page already does it.
	 *
	 * A TOAST, not an alert. The first version fell back to window.alert, which BLOCKS THE PAGE until
	 * somebody dismisses it -- the browser stops running anything, including whatever the click was
	 * still doing. It is a bad control on its own terms and it hung an end-to-end run for twelve
	 * minutes, which is how it was found. copyLink two methods up was already doing this correctly.
	 */
	_announce(pTitle, pDetail, pKind)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			return tmpModal.toast(pDetail ? (pTitle + ' ' + pDetail) : pTitle, { type: pKind || 'success' });
		}
		return null;
	}

	compose()
	{
		let tmpRouter = this.pict.providers['Pict-Router'];
		return this._ensureRecordID().then((pID) =>
		{
			if (tmpRouter && pID) { tmpRouter.navigate('/blueprint/' + pID + '/compose'); }
			return pID;
		});
	}

	// The design canvas: arrange this blueprint's layout (regions on a grid) for web + print at any size.
	design()
	{
		let tmpRouter = this.pict.providers['Pict-Router'];
		return this._ensureRecordID().then((pID) =>
		{
			if (tmpRouter && pID) { tmpRouter.navigate('/blueprint/' + pID + '/design'); }
			return pID;
		});
	}

	details()
	{
		let tmpRouter = this.pict.providers['Pict-Router'];
		return this._ensureRecordID().then((pID) =>
		{
			if (tmpRouter && pID) { tmpRouter.navigate('/blueprint/' + pID + '/details'); }
			return pID;
		});
	}

	// A designed layout, if this blueprint has one -- the same {Grid,Regions} the studio edits and the PDF
	// prints, so the read page matches both. Null when it has never been designed (then the plate sheet below).
	_layoutData()
	{
		let tmpRaw = this._data && this._data.Layout;
		if (!tmpRaw) { return null; }
		try { let tmpLayout = (typeof tmpRaw === 'string') ? JSON.parse(tmpRaw) : tmpRaw; return (tmpLayout && Array.isArray(tmpLayout.Regions) && tmpLayout.Regions.length) ? tmpLayout : null; }
		catch (pErr) { return null; }
	}

	_sheetHTML()
	{
		let tmpLayout = this._loading ? null : this._layoutData();
		if (tmpLayout)
		{
			this._renderedLayout = true;
			let tmpGrid = tmpLayout.Grid || { Cols: 12, Rows: 16 };
			// A responsive layout takes a viewport-sized box (so its aspect follows the pane and the @container
			// query can switch arrangement); a fixed one keeps its grid-proportioned box exactly as before.
			this._responsiveLayout = (tmpLayout.Responsive === true);
			let tmpSheetAttr = this._responsiveLayout
				? ' class="bp-layout-sheet bp-layout-responsive"'
				: ' class="bp-layout-sheet" style="aspect-ratio: ' + tmpGrid.Cols + ' / ' + tmpGrid.Rows + '"';
			return '<div class="bp-layout-actions">' + this._actionsHTML() + '</div>'
				+ '<div' + tmpSheetAttr + '>'
					+ libLayout.renderSheet(tmpLayout, { Kit: tmpLayout.Kit || 'clean' })
				+ '</div>';
		}
		this._renderedLayout = false;
		this._responsiveLayout = false;
		return libBlueprintRender.renderSheet(this._data,
			{
				loading: this._loading,
				fIcon: (pType) => this._icon(pType),
				mediaBase: '/1.0/Media/',
				links: 'app',
				actionsHTML: this._actionsHTML()
			});
	}
}

// The print control sits in the sheet's own action row, so it inherits .bp-act and only needs the
// select beside it to match.
const PRINT_CSS = /*css*/`
	.bp-print-wrap { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 6px; }
	.bp-print-sheet { height: 28px; box-sizing: border-box; background: #0c1830; border: 1px solid rgba(208,226,247,0.4); border-radius: 6px; color: #eef4fc; padding: 0 6px; font: inherit; font-size: 12px; }
	/* A muted amber advisory on the navy strip: a picture is too few pixels for the chosen sheet. Informational,
	   not an error -- the print still works; the hover lists each image and its effective ppi. */
	.bp-print-advisory { display: inline-flex; align-items: center; gap: 5px; font-size: 11px; line-height: 1.3; color: #f2c879; cursor: help; white-space: nowrap; }
	.bp-print-advisory-dot { font-size: 9px; line-height: 1; }
	/* A designed layout shown on the read page: the actions above, then the sheet at its grid proportions. */
	.bp-layout-actions { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 16px; }
	.bp-layout-sheet { width: 100%; max-width: 760px; margin: 0 auto; box-shadow: 0 10px 44px rgba(16, 24, 40, 0.22); }
	/* A responsive layout widens to the pane and takes a resolved height (the inner .bpl is container-type:size
	   and will not derive height from content), so its aspect follows the pane and the sheet rearranges. */
	.bp-layout-responsive { max-width: 1180px; height: min(80vh, 860px); }
`;

module.exports = PictViewBlueprint;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Blueprint',
	DefaultRenderable: 'Blueprint-Page',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSSPriority: 540,
	CSS: libBlueprintRender.SHEET_CSS + libShareUI.SHARE_CSS + PRINT_CSS + libLayout.SHEET_CSS,
	Templates:
	[
		{ Hash: 'Blueprint-Page', Template: /*html*/`<div class="bp-root"><div id="Blueprint-Share"></div><div id="Blueprint-Versions"></div><div id="Blueprint-Sheet"></div></div>` }
	],
	Renderables:
	[
		{ RenderableHash: 'Blueprint-Page', TemplateHash: 'Blueprint-Page', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

},{"../BlueprintLayout.js":551,"../BlueprintRender.js":552,"../BlueprintShareUI.js":553,"../providers/FrameworkClient.js":576,"pict-view":365}],655:[function(require,module,exports){
'use strict';

/**
 * PictView-BlueprintComposer
 * --------------------------
 * The editable Blueprint, standalone or entity-owned: compose a named drafting sheet by pinning
 * build-graph artifacts (Visions, Modules, Features, Whiteboards) onto it. A standalone Blueprint has
 * no auto-gathered set -- it is exactly what you add here. An owned Blueprint (a Vision/Module/Feature's
 * own sheet) already draws an auto-gathered set from its manifest (WI #340); those plates render too, as
 * the read view does, but read-only -- there is nothing to unpin because auto-gather is not a pin. Each
 * pinnable type is a plate: "+ Add" opens a picker of candidates (the customer's artifacts of that type
 * not already on the sheet); an item pinned this way (Pinned true, carrying an IDBlueprintItem) gets a
 * remove control, an auto-gathered one (Pinned false) gets an "AUTO" tag instead. The pins are
 * BlueprintItem rows keyed on IDBlueprint, so the read views (the Blueprint detail and the public
 * /shared/:token page) render the same sheet through BlueprintRender.
 *
 * Shown via #/blueprint/:id/compose (Pict-Application._renderBlueprintComposer). The shared drafting
 * styles come from BlueprintRender.SHEET_CSS so the composer and the rendered sheet match.
 */

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');
const libBlueprintRender = require('../BlueprintRender.js');

const _PINNABLE =
[
	{ Type: 'Vision', Label: 'Visions', One: 'vision' },
	{ Type: 'Module', Label: 'Modules', One: 'module' },
	{ Type: 'Feature', Label: 'Features', One: 'feature' },
	{ Type: 'Whiteboard', Label: 'Whiteboards', One: 'whiteboard' }
];

class PictViewBlueprintComposer extends libPictView
{
	onBeforeInitialize()
	{
		this._id = 0;
		this._data = null;
		this._loading = false;
		this._picker = null; // { Type, Candidates: [] }
		this._busy = false;
		return super.onBeforeInitialize();
	}

	_selfRef() { return "_Pict.views['" + this.Hash + "']"; }
	_icon(pType) { let tmpP = this.pict && this.pict.providers && this.pict.providers.Icon; return tmpP ? tmpP.get(libBlueprintRender.ICON_FOR[pType] || 'FileText') : ''; }
	_can(pEnt) { let tmpA = this.pict.PictApplication; return !!(tmpA && typeof tmpA._can === 'function' && tmpA._can(pEnt)); }
	_esc(pS) { return String(pS == null ? '' : pS).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
	_toast(pMsg, pType) { let tmpM = this.pict.views['Pict-Section-Modal']; if (tmpM && typeof tmpM.toast === 'function') { tmpM.toast(pMsg, { type: pType || 'info' }); } }

	show(pID)
	{
		this._id = parseInt(pID, 10) || 0;
		this._data = null; this._picker = null; this._loading = true;
		this.render();
		if (!this._id) { this._loading = false; return; }
		this._reload();
	}

	_reload()
	{
		return libFrameworkClient.getJSON(this.pict, '/1.0/Blueprint/' + this._id + '/Items')
			.then((pD) => { this._data = pD; this._loading = false; if (this.pict.PictApplication && typeof this.pict.PictApplication._setPageTitle === 'function') { this.pict.PictApplication._setPageTitle((pD && pD.Title) ? (pD.Title + ' (composing)') : 'Blueprint Composer'); } this.render(); })
			.catch(() => { this._data = null; this._loading = false; this.render(); });
	}

	back()
	{
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (tmpRouter && this._id) { tmpRouter.navigate('/blueprint/' + this._id); }
	}

	openPicker(pType)
	{
		if (this._busy) { return; }
		this._busy = true;
		libFrameworkClient.getJSON(this.pict, '/1.0/Blueprint/' + this._id + '/Candidates/' + encodeURIComponent(pType))
			.then((pD) => { this._busy = false; this._picker = { Type: pType, Candidates: (pD && pD.Candidates) || [] }; this.render(); })
			.catch(() => { this._busy = false; this._toast('Could not load options.', 'error'); });
	}
	closePicker() { this._picker = null; this.render(); }

	pin(pType, pIDItem)
	{
		if (this._busy) { return; }
		this._busy = true;
		libFrameworkClient.postJSON(this.pict, '/1.0/Blueprint/' + this._id + '/Item', { ItemType: pType, IDItem: parseInt(pIDItem, 10) || 0 })
			.then(() => { this._busy = false; this._picker = null; return this._reload(); })
			.catch(() => { this._busy = false; this._toast('Could not add that.', 'error'); });
	}

	unpin(pIDBlueprintItem)
	{
		if (this._busy) { return; }
		this._busy = true;
		libFrameworkClient.delJSON(this.pict, '/1.0/Blueprint/' + this._id + '/Item/' + (parseInt(pIDBlueprintItem, 10) || 0))
			.then(() => { this._busy = false; return this._reload(); })
			.catch(() => { this._busy = false; this._toast('Could not remove that.', 'error'); });
	}

	// Make this blueprint the plan sheet's cover (WI #339), or remove it if it already is. Writes through
	// PUT /1.0/Plansheet/Cover; IDBlueprint 0 clears. The button reflects _data.IsCover.
	toggleCover()
	{
		if (this._busy || !this._id) { return; }
		this._busy = true;
		let tmpIsCover = !!(this._data && this._data.IsCover);
		let tmpTarget = tmpIsCover ? 0 : this._id;
		libFrameworkClient.putJSON(this.pict, '/1.0/Plansheet/Cover', { IDBlueprint: tmpTarget })
			.then((pBody) =>
			{
				this._busy = false;
				if (pBody && pBody.Success)
				{
					if (this._data) { this._data.IsCover = (tmpTarget === this._id); }
					this._toast(tmpTarget ? 'This blueprint is now the plan sheet cover.' : 'Removed as the plan sheet cover.', 'success');
					this.render();
					return;
				}
				this._toast((pBody && pBody.Error) || 'Could not set the cover.', 'error');
			})
			.catch((pErr) => { this._busy = false; this._toast((pErr && pErr.message) || 'Could not set the cover.', 'error'); });
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		if (typeof document !== 'undefined')
		{
			let tmpHost = document.getElementById('BlueprintComposer-Body');
			if (tmpHost) { tmpHost.innerHTML = this._bodyHTML(); }
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_bodyHTML()
	{
		if (this._loading) { return '<div class="bp-empty">Loading the blueprint...</div>'; }
		if (!this._data) { return '<div class="bp-empty">This blueprint could not be loaded.</div>'; }
		let tmpSelf = this._selfRef();
		let tmpCanEdit = this._can('content.edit');
		let tmpNum = this._data.BlueprintNumber ? ('BP-' + String(this._data.BlueprintNumber).padStart(3, '0')) : ('BP #' + this._id);
		let tmpDesc = this._data.Description ? ('<p class="bp-desc">' + this._esc(this._data.Description) + '</p>') : '';

		let tmpByType = {};
		(this._data.Groups || []).forEach((pG) => { tmpByType[pG.Type] = pG; });

		// Plates in a stable order: the four curatable types first, even empty, so "+ Add" is always
		// reachable there; then whatever else the payload gathered (an owned blueprint's manifest types --
		// WorkItem, Session, Media, ...), in the order the server sent them. Those extra plates are
		// read-only here: nothing in them was pinned, so there is nothing to remove.
		let tmpPinnableTypes = {};
		_PINNABLE.forEach((pPT) => { tmpPinnableTypes[pPT.Type] = true; });
		let tmpPlates = _PINNABLE.map((pPT) => ({ Type: pPT.Type, Label: pPT.Label, One: pPT.One, Curatable: true }));
		(this._data.Groups || []).forEach((pG) => { if (!tmpPinnableTypes[pG.Type]) { tmpPlates.push({ Type: pG.Type, Label: pG.Label || pG.Type, Curatable: false }); } });

		let tmpHTML = '<div class="bp-sheet">'
			+ '<div class="bp-titleblock"><div class="bp-tb-main"><div class="bp-eyebrow">BLUEPRINT | ' + this._esc(tmpNum) + '</div>'
			+ '<h1 class="bp-h1">' + this._esc(this._data.Title || 'Blueprint') + '</h1>' + tmpDesc + '</div>';
			// "Set as cover" (WI #339): use this blueprint as the plan sheet's cover across the app. The
			// active state (this is the cover) shows a solid accent button that removes on click.
			let tmpCoverBtn = tmpCanEdit
				? ('<button class="bp-act' + (this._data.IsCover ? '' : ' bp-act-ghost') + '" onclick="' + tmpSelf + '.toggleCover()" title="'
					+ (this._data.IsCover ? 'This blueprint is this plan sheet\'s cover. Click to remove.' : 'Use this blueprint to represent this plan sheet across the app.') + '">'
					+ (this._data.IsCover ? 'Plan sheet cover' : 'Set as cover') + '</button>')
				: '';
			tmpHTML += '<div class="bp-tb-side">' + tmpCoverBtn + '<button class="bp-act bp-act-ghost" onclick="' + tmpSelf + '.back()">Done</button></div></div>';

		tmpPlates.forEach((pPT) =>
		{
			let tmpItems = (tmpByType[pPT.Type] && tmpByType[pPT.Type].Items) || [];
			// A read-only gathered plate with nothing in it is not worth a section; a curatable one still
			// renders empty so "+ Add" stays reachable.
			if (!pPT.Curatable && !tmpItems.length) { return; }
			tmpHTML += '<section class="bp-plate"><header class="bp-plate-head">' + this._icon(pPT.Type) + '<span>' + this._esc(pPT.Label) + '</span>'
				+ '<span class="bp-count">' + tmpItems.length + '</span>'
				+ (tmpCanEdit && pPT.Curatable ? ('<button class="bpc-add" onclick="' + tmpSelf + '.openPicker(\'' + pPT.Type + '\')">+ Add</button>') : '')
				+ '</header><div class="bp-items">';
			if (!tmpItems.length) { tmpHTML += '<div class="bpc-empty">Nothing added yet.</div>'; }
			tmpItems.forEach((pIt) =>
			{
				let tmpLink = pIt.Link ? ('#' + pIt.Link) : '';
				let tmpTitle = tmpLink ? ('<a class="bp-card-link" href="' + this._esc(tmpLink) + '">' + this._esc(pIt.Title) + '</a>') : this._esc(pIt.Title);
				// Pinned (carries an IDBlueprintItem) is something this composer put there and can take back off.
				// Anything else arrived through the auto-gather -- there is no unpin for that, so it gets a tag
				// explaining why instead of a remove control.
				let tmpAutoTag = pIt.Pinned ? '' : '<span class="bpc-auto" title="Included automatically; not removable here">AUTO</span>';
				tmpHTML += '<div class="bp-card bpc-card"><span class="bp-card-ic">' + this._icon(pPT.Type) + '</span>'
					+ '<span class="bp-card-body"><span class="bp-card-title">' + tmpTitle + tmpAutoTag + '</span>'
					+ (pIt.Summary ? ('<span class="bp-card-sum">' + this._esc(pIt.Summary) + '</span>') : '') + '</span>'
					+ (tmpCanEdit && pIt.Pinned ? ('<button class="bpc-x" title="Remove from this blueprint" onclick="' + tmpSelf + '.unpin(' + (pIt.IDBlueprintItem || 0) + ')">&times;</button>') : '')
					+ '</div>';
			});
			tmpHTML += '</div>';

			if (pPT.Curatable && this._picker && this._picker.Type === pPT.Type)
			{
				tmpHTML += '<div class="bpc-picker"><div class="bpc-picker-head"><span>Add a ' + this._esc(pPT.One) + '</span>'
					+ '<button class="bpc-picker-close" onclick="' + tmpSelf + '.closePicker()">close</button></div>';
				if (!this._picker.Candidates.length) { tmpHTML += '<div class="bpc-empty">Nothing left to add.</div>'; }
				else
				{
					tmpHTML += '<div class="bpc-cands">';
					this._picker.Candidates.forEach((pC) =>
					{
						tmpHTML += '<button class="bpc-cand" onclick="' + tmpSelf + '.pin(\'' + pPT.Type + '\',' + (pC.IDItem || 0) + ')">' + this._esc(pC.Title || ('#' + pC.IDItem)) + '</button>';
					});
					tmpHTML += '</div>';
				}
				tmpHTML += '</div>';
			}
			tmpHTML += '</section>';
		});
		tmpHTML += '</div>';
		return tmpHTML;
	}
}

module.exports = PictViewBlueprintComposer;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-BlueprintComposer',
	DefaultRenderable: 'BlueprintComposer-Page',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSSPriority: 542,
	CSS: libBlueprintRender.SHEET_CSS + /*css*/`
		.bp-root .bpc-add { margin-left: 10px; font: inherit; font-size: 12px; padding: 2px 11px; border-radius: 6px; border: 1px solid var(--bp-acc); background: transparent; color: var(--bp-acc); cursor: pointer; letter-spacing: 0; text-transform: none; }
		.bp-root .bpc-add:hover { background: rgba(240,196,74,0.14); }
		.bp-root .bpc-empty { color: var(--bp-eye); font-size: 13px; padding: 7px 2px; }
		.bp-root .bpc-card { position: relative; padding-right: 30px; }
		.bp-root .bpc-x { position: absolute; top: 6px; right: 7px; border: none; background: none; color: var(--bp-eye); font-size: 19px; line-height: 1; cursor: pointer; padding: 0 4px; }
		.bp-root .bpc-x:hover { color: var(--bp-acc); }
		.bp-root .bpc-picker { margin-top: 11px; border: 1px dashed var(--bp-frame); border-radius: 8px; padding: 11px 13px; background: rgba(8,16,30,0.3); }
		.bp-root .bpc-picker-head { display: flex; align-items: center; justify-content: space-between; font-family: ui-monospace, Menlo, monospace; font-size: 11px; color: var(--bp-eye); text-transform: uppercase; letter-spacing: 1.2px; margin-bottom: 9px; }
		.bp-root .bpc-picker-close { border: none; background: none; color: var(--bp-eye); cursor: pointer; font-size: 11px; text-decoration: underline; }
		.bp-root .bpc-cands { display: flex; flex-wrap: wrap; gap: 8px; }
		.bp-root .bpc-cand { font: inherit; font-size: 13px; padding: 6px 12px; border-radius: 7px; border: 1px solid var(--bp-cell); background: rgba(8,16,30,0.42); color: var(--bp-ink); cursor: pointer; text-align: left; max-width: 320px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.bp-root .bpc-cand:hover { border-color: var(--bp-acc); }
		.bp-root .bpc-auto { font-family: ui-monospace, Menlo, monospace; font-size: 9px; letter-spacing: 1px; color: var(--bp-eye); border: 1px solid var(--bp-frame); border-radius: 4px; padding: 1px 4px; margin-left: 7px; vertical-align: middle; }
	`,
	Templates:
	[
		{ Hash: 'BlueprintComposer-Page', Template: /*html*/`<div class="bp-root"><div id="BlueprintComposer-Body"></div></div>` }
	],
	Renderables:
	[
		{ RenderableHash: 'BlueprintComposer-Page', TemplateHash: 'BlueprintComposer-Page', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

},{"../BlueprintRender.js":552,"../providers/FrameworkClient.js":576,"pict-view":365}],656:[function(require,module,exports){
'use strict';

/**
 * PictView-BlueprintStudio
 * ------------------------
 * The design canvas for a blueprint's LAYOUT: semantic region blocks arranged on a proportional grid
 * (source/BlueprintLayout.js). You drop regions (a diagram, a column of blurbs, an image, a note), drag
 * and resize them on the grid, edit their text in the inspector, and switch the DRAWING STYLE (clean /
 * drafting / blueprint) and the PREVIEW SIZE (web / Letter / ArchD). Because placement is grid cells and
 * type scales in container units, the one layout renders unchanged to the shared web page, a Letter PDF
 * and a 24x36 ARCH D sheet; the style is pure CSS tokens over the same structure.
 *
 * The chrome (palette, inspector, controls) is template-driven; the canvas itself is painted imperatively
 * (renderLayout + fitLayout into #BPS-Canvas) and the drag/resize are pointer handlers on the stage, the
 * same way the rail splitter and the doc editor own their own DOM. A full view render is only used to
 * rebuild the chrome; ordinary edits repaint just the canvas (so an inspector field keeps focus).
 *
 * Shown via #/blueprint/:id/design (Pict-Application._renderBlueprintStudio). The layout persists on the
 * Blueprint's Layout field (a draft also lives in localStorage so an in-progress design survives a reload
 * before a save).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libLayout = require('../BlueprintLayout.js');
const libFrameworkClient = require('../providers/FrameworkClient.js');

const _SELF = "_Pict.views['Plansheet-BlueprintStudio']";
const _DRAFT_KEY = 'plansheet.blueprint.layout.';
const _SIZES = { web: [1040, 660], letter: [8.5, 11], archd: [24, 36] };

function _esc(pText)
{
	return String(pText == null ? '' : pText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
const _clamp = (pV, pA, pB) => Math.max(pA, Math.min(pB, pV));

class PictViewBlueprintStudio extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._id = 0;
		this._layout = null;
		this._selected = -1;
		this._size = 'letter';
		this._kit = 'drafting';
		this._printSheet = 'Letter';
		this._wired = false;
		this._drag = null;
	}

	// ─── open / load ────────────────────────────────────────────────────────
	open(pID)
	{
		this._id = parseInt(pID, 10) || 0;
		this._selected = -1;
		this._layout = this._loadDraft(this._id) || this._defaultLayout({ Name: 'Blueprint ' + this._id });
		if (this._layout.Kit) { this._kit = this._layout.Kit; } else { this._layout.Kit = this._kit; }
		this.render();
		let tmpBP = this.pict.providers.BlueprintAPI;
		if (tmpBP && typeof tmpBP.readSubject === 'function' && this._id)
		{
			tmpBP.readSubject({ Kind: 'record', EntityKey: 'Blueprint', ID: this._id }).then((pData) =>
			{
				if (!pData) { return; }
				let tmpStored = this._parse(pData.Layout);
				// A saved server layout wins only when we had no local draft in progress.
				if (tmpStored && !this._loadDraft(this._id)) { this._layout = tmpStored; }
				else
				{
					let tmpTitle = this._titleRegion();
					if (tmpTitle && tmpTitle.Name === ('Blueprint ' + this._id) && pData.Name) { tmpTitle.Name = pData.Name; }
				}
				this.render();
			}).catch(() => { /* seeded default stands */ });
		}
	}

	_titleRegion() { return (this._layout && this._layout.Regions || []).find((pR) => pR.Kind === 'title'); }
	_parse(pJSON) { try { let tmpO = JSON.parse(pJSON); return (tmpO && tmpO.Regions) ? tmpO : null; } catch (pErr) { return null; } }
	_loadDraft(pID) { try { return this._parse(window.localStorage.getItem(_DRAFT_KEY + pID)); } catch (pErr) { return null; } }

	_defaultLayout(pData)
	{
		let tmpName = (pData && pData.Name) || 'Untitled blueprint';
		return {
			Grid: { Cols: 12, Rows: 16 },
			Regions:
			[
				{ Kind: 'title', Col: 1, Row: 1, ColSpan: 12, RowSpan: 2, Mark: 'BP', Name: tmpName, Tagline: 'A one-line description of this blueprint.' },
				{ Kind: 'diagram', Col: 1, Row: 3, ColSpan: 8, RowSpan: 8, Caption: 'Diagram',
					SVG: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 70" fill="none" stroke="currentColor" stroke-width="2"><rect x="8" y="12" width="40" height="22"/><rect x="72" y="38" width="40" height="22"/><path d="M48 23 H72 V44"/></svg>' },
				{ Kind: 'blurbs', Col: 9, Row: 3, ColSpan: 4, RowSpan: 8, Items: [ { Heading: 'What it does', Body: 'Describe it here.' }, { Heading: 'How it works', Body: 'Explain the flow.' } ] }
			]
		};
	}

	// ─── DOM getters + geometry ─────────────────────────────────────────────
	_el(pID) { return (typeof document !== 'undefined') ? document.getElementById(pID) : null; }
	_stage() { return this._el('BPS-Stage'); }
	_canvas() { return this._el('BPS-Canvas'); }

	_stageDims()
	{
		let tmpPair = _SIZES[this._size] || _SIZES.letter;
		let tmpAR = tmpPair[0] / tmpPair[1];
		let tmpMaxW = Math.min(840, (typeof window !== 'undefined' ? window.innerWidth : 1200) - 560);
		let tmpMaxH = (typeof window !== 'undefined' ? window.innerHeight : 800) - 120;
		let tmpW = tmpMaxH * tmpAR, tmpH = tmpMaxH;
		if (tmpW > tmpMaxW) { tmpW = tmpMaxW; tmpH = tmpMaxW / tmpAR; }
		return [Math.round(tmpW), Math.round(tmpH)];
	}

	_cell()
	{
		let tmpBpl = this._canvas() ? this._canvas().querySelector('.bpl') : null;
		if (!tmpBpl) { return null; }
		let tmpRect = tmpBpl.getBoundingClientRect();
		let tmpGrid = this._layout.Grid;
		return { left: tmpRect.left, top: tmpRect.top, cw: tmpRect.width / tmpGrid.Cols, ch: tmpRect.height / tmpGrid.Rows };
	}

	// ─── paint ──────────────────────────────────────────────────────────────
	_sizeStage()
	{
		let tmpStage = this._stage(); if (!tmpStage) { return; }
		let tmpDims = this._stageDims();
		tmpStage.style.width = tmpDims[0] + 'px'; tmpStage.style.height = tmpDims[1] + 'px';
		tmpStage.setAttribute('data-kit', this._kit);
	}

	_drawGrid()
	{
		let tmpGridEl = this._el('BPS-Grid'); if (!tmpGridEl || !this._layout) { return; }
		let tmpGrid = this._layout.Grid; let tmpCW = 100 / tmpGrid.Cols, tmpCH = 100 / tmpGrid.Rows;
		tmpGridEl.style.backgroundImage =
			'repeating-linear-gradient(to right, var(--grid, rgba(59,111,212,.16)) 0 1px, transparent 1px ' + tmpCW + '%),'
			+ 'repeating-linear-gradient(to bottom, var(--grid, rgba(59,111,212,.16)) 0 1px, transparent 1px ' + tmpCH + '%)';
		tmpGridEl.style.backgroundSize = tmpCW + '% 100%, 100% ' + tmpCH + '%';
	}

	_paintCanvas()
	{
		let tmpCanvas = this._canvas(); if (!tmpCanvas || !this._layout) { return; }
		// Force base (landscape) placement on the canvas: the drag/resize math reads a region's base Col/Row off
		// its live rect, so a portrait alternate showing on the canvas would desync it. The editor composes the
		// base arrangement; the portrait alternate is authored as JSON/defaults and previewed on the other surfaces.
		tmpCanvas.innerHTML = libLayout.renderLayout(this._layout, { Responsive: false });
		libLayout.fitLayout(tmpCanvas);
		let tmpRegions = tmpCanvas.querySelectorAll('.bpl-region');
		for (let i = 0; i < tmpRegions.length; i++)
		{
			let tmpEl = tmpRegions[i];
			tmpEl.setAttribute('data-index', i);
			if (i === this._selected)
			{
				tmpEl.classList.add('sel');
				let tmpLabel = document.createElement('div'); tmpLabel.className = 'bps-rlabel'; tmpLabel.textContent = this._layout.Regions[i].Kind; tmpEl.appendChild(tmpLabel);
				let tmpHandle = document.createElement('div'); tmpHandle.className = 'bps-rhandle'; tmpHandle.setAttribute('data-resize', '1'); tmpEl.appendChild(tmpHandle);
			}
		}
	}

	_renderTitleBlock()
	{
		let tmpTB = this._el('BPS-TitleBlock'); if (!tmpTB) { return; }
		let tmpT = this._titleRegion() || {};
		tmpTB.innerHTML = '<div class="bps-tb-name">' + _esc(tmpT.Name || 'Untitled') + '</div>'
			+ '<div class="bps-tb-row"><div class="bps-tb-cell"><div class="bps-tb-k">Sheet</div><div class="bps-tb-v">' + _esc(tmpT.Mark || 'BP-001') + '</div></div>'
			+ '<div class="bps-tb-cell"><div class="bps-tb-k">Scale</div><div class="bps-tb-v">NTS</div></div>'
			+ '<div class="bps-tb-cell"><div class="bps-tb-k">Rev</div><div class="bps-tb-v">A</div></div></div>';
	}

	_applyActive()
	{
		['kit', 'size'].forEach((pKind) =>
		{
			let tmpWrap = this._el('BPS-' + (pKind === 'kit' ? 'Kits' : 'Sizes')); if (!tmpWrap) { return; }
			let tmpVal = (pKind === 'kit') ? this._kit : this._size;
			tmpWrap.querySelectorAll('.bps-seg').forEach((pSeg) => pSeg.classList.toggle('on', pSeg.getAttribute('data-val') === tmpVal));
		});
	}

	// ─── inspector ──────────────────────────────────────────────────────────
	_field(pIdx, pPath, pLabel, pValue, pTag)
	{
		let tmpHandler = _SELF + ".onField(" + pIdx + ",'" + pPath + "',this.value)";
		let tmpControl = (pTag === 'textarea')
			? '<textarea oninput="' + tmpHandler + '">' + _esc(pValue) + '</textarea>'
			: '<input value="' + _esc(pValue) + '" oninput="' + tmpHandler + '">';
		return '<div class="bps-field"><div class="bps-ilabel">' + _esc(pLabel) + '</div>' + tmpControl + '</div>';
	}

	_renderInspector()
	{
		let tmpIns = this._el('BPS-Inspector'); if (!tmpIns) { return; }
		let i = this._selected; let tmpR = (i >= 0 && this._layout) ? this._layout.Regions[i] : null;
		if (!tmpR) { tmpIns.innerHTML = '<div class="bps-iempty">Click a region on the sheet to edit it. Drag to move, pull the blue handle to resize. Add regions from the left, switch the drawing style and size up top.</div>'; return; }
		let h = '<div class="bps-ikind">' + _esc(tmpR.Kind) + ' region</div>';
		if (tmpR.Kind === 'title') { h += this._field(i, 'Mark', 'Mark', tmpR.Mark) + this._field(i, 'Name', 'Name', tmpR.Name) + this._field(i, 'Tagline', 'Tagline', tmpR.Tagline, 'textarea'); }
		else if (tmpR.Kind === 'note') { h += this._field(i, 'Label', 'Label', tmpR.Label) + this._field(i, 'Body', 'Body', tmpR.Body, 'textarea'); }
		else if (tmpR.Kind === 'image') { h += this._field(i, 'Alt', 'Alt', tmpR.Alt) + this._field(i, 'Caption', 'Caption', tmpR.Caption) + '<div class="bps-iempty">Drop a Media image here (coming next).</div>'; }
		else if (tmpR.Kind === 'diagram') { h += this._field(i, 'Caption', 'Caption', tmpR.Caption) + '<div class="bps-iempty">Diagram SVG comes from the module or an upload.</div>'; }
		else if (tmpR.Kind === 'blurbs')
		{
			(tmpR.Items || []).forEach((pItem, pBi) => { h += '<div class="bps-iblurb">' + this._field(i, 'Items.' + pBi + '.Heading', 'Heading', pItem.Heading) + this._field(i, 'Items.' + pBi + '.Body', 'Body', pItem.Body, 'textarea') + '</div>'; });
			h += '<button class="bps-btn" onclick="' + _SELF + '.addBlurb(' + i + ')">+ Add blurb</button>';
		}
		h += '<button class="bps-del" onclick="' + _SELF + '.deleteRegion()">Delete region</button>';
		tmpIns.innerHTML = h;
	}

	// ─── edits ──────────────────────────────────────────────────────────────
	onField(pIdx, pPath, pValue)
	{
		let tmpR = this._layout.Regions[pIdx]; if (!tmpR) { return; }
		let tmpParts = String(pPath).split('.'); let tmpObj = tmpR;
		for (let i = 0; i < tmpParts.length - 1; i++) { tmpObj = tmpObj[tmpParts[i]]; if (!tmpObj) { return; } }
		tmpObj[tmpParts[tmpParts.length - 1]] = pValue;
		this._paintCanvas(); this._renderTitleBlock(); this._markDirty();
	}

	addRegion(pKind)
	{
		let tmpDefaults =
		{
			diagram: { ColSpan: 6, RowSpan: 6, Caption: 'New diagram', SVG: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 60" fill="none" stroke="currentColor" stroke-width="2"><rect x="8" y="10" width="36" height="20"/><rect x="56" y="30" width="36" height="20"/><path d="M44 20 H56 V36"/></svg>' },
			image: { ColSpan: 6, RowSpan: 4, Alt: '', Caption: 'New image' },
			blurbs: { ColSpan: 4, RowSpan: 6, Items: [ { Heading: 'Heading', Body: 'Body text.' } ] },
			note: { ColSpan: 4, RowSpan: 2, Label: 'Label', Body: 'A short note.' },
			title: { ColSpan: 12, RowSpan: 2, Mark: 'BP', Name: 'Title', Tagline: 'A one-line description.' }
		}[pKind];
		if (!tmpDefaults) { return; }
		this._layout.Regions.push(Object.assign({ Kind: pKind, Col: 1, Row: 1 }, tmpDefaults));
		this._selected = this._layout.Regions.length - 1;
		this._markDirty(); this._paintCanvas(); this._renderInspector();
	}

	// All edits are TARGETED DOM updates, never a full template re-render: rebuilding the template would
	// recreate #BPS-Stage and drop the pointer listeners (and the inspector focus). render() is only for
	// the initial open(); the stage element itself persists across every edit here.
	addBlurb(pIdx) { let tmpR = this._layout.Regions[pIdx]; if (tmpR && tmpR.Items) { tmpR.Items.push({ Heading: 'Heading', Body: 'Body.' }); this._markDirty(); this._paintCanvas(); this._renderInspector(); } }
	deleteRegion() { if (this._selected < 0) { return; } this._layout.Regions.splice(this._selected, 1); this._selected = -1; this._markDirty(); this._paintCanvas(); this._renderInspector(); }
	selectRegion(pIdx) { this._selected = pIdx; this._paintCanvas(); this._renderInspector(); }
	// The kit lives ON the layout (layout.Kit), so it travels with {Grid,Regions} to the web page and the
	// PDF and the three outputs cannot diverge; the stage attribute is just the studio's live reflection.
	setKit(pKit) { this._kit = pKit; if (this._layout) { this._layout.Kit = pKit; } this._markDirty(); let tmpStage = this._stage(); if (tmpStage) { tmpStage.setAttribute('data-kit', pKit); } this._applyActive(); }
	setSize(pSize) { this._size = pSize; this._sizeStage(); this._drawGrid(); this._paintCanvas(); this._applyActive(); }

	// ─── drag + resize ──────────────────────────────────────────────────────
	_wire()
	{
		// Guard on the STAGE element, not the view: open() rebuilds the template (a fresh stage) when the
		// studio is opened for another blueprint, and that fresh stage needs its own listeners.
		let tmpStage = this._stage(); if (!tmpStage || tmpStage._bpsWired) { return; }
		tmpStage._bpsWired = true;
		tmpStage.addEventListener('pointerdown', (pEvent) =>
		{
			let tmpRegion = pEvent.target.closest ? pEvent.target.closest('.bpl-region') : null;
			if (!tmpRegion) { if (this._selected !== -1) { this._selected = -1; this._paintCanvas(); this._renderInspector(); } return; }
			if (pEvent.target.tagName === 'INPUT' || pEvent.target.tagName === 'TEXTAREA') { return; }
			let tmpIdx = Number(tmpRegion.getAttribute('data-index'));
			let tmpResize = !!pEvent.target.getAttribute('data-resize');
			if (this._selected !== tmpIdx) { this.selectRegion(tmpIdx); }
			let tmpReg = this._layout.Regions[tmpIdx]; let tmpCell = this._cell(); if (!tmpCell) { return; }
			let tmpEl = this._canvas().querySelector('.bpl-region[data-index="' + tmpIdx + '"]');
			this._drag = { idx: tmpIdx, resize: tmpResize, startX: pEvent.clientX, startY: pEvent.clientY, col0: tmpReg.Col, row0: tmpReg.Row, cell: tmpCell, el: tmpEl };
			try { tmpEl.setPointerCapture(pEvent.pointerId); } catch (pErr) { /* */ }
			pEvent.preventDefault();
		});
		tmpStage.addEventListener('pointermove', (pEvent) =>
		{
			if (!this._drag) { return; }
			let tmpGrid = this._layout.Grid; let tmpReg = this._layout.Regions[this._drag.idx]; let tmpCell = this._drag.cell;
			if (this._drag.resize)
			{
				let tmpCol = _clamp(Math.round((pEvent.clientX - tmpCell.left) / tmpCell.cw) + 1, this._drag.col0, tmpGrid.Cols);
				let tmpRow = _clamp(Math.round((pEvent.clientY - tmpCell.top) / tmpCell.ch) + 1, this._drag.row0, tmpGrid.Rows);
				tmpReg.ColSpan = _clamp(tmpCol - this._drag.col0 + 1, 1, tmpGrid.Cols - this._drag.col0 + 1);
				tmpReg.RowSpan = _clamp(tmpRow - this._drag.row0 + 1, 1, tmpGrid.Rows - this._drag.row0 + 1);
			}
			else
			{
				let tmpDC = Math.round((pEvent.clientX - this._drag.startX) / tmpCell.cw), tmpDR = Math.round((pEvent.clientY - this._drag.startY) / tmpCell.ch);
				tmpReg.Col = _clamp(this._drag.col0 + tmpDC, 1, tmpGrid.Cols - tmpReg.ColSpan + 1);
				tmpReg.Row = _clamp(this._drag.row0 + tmpDR, 1, tmpGrid.Rows - tmpReg.RowSpan + 1);
			}
			if (this._drag.el) { this._drag.el.style.gridColumn = tmpReg.Col + ' / span ' + tmpReg.ColSpan; this._drag.el.style.gridRow = tmpReg.Row + ' / span ' + tmpReg.RowSpan; }
		});
		let fEnd = () => { if (!this._drag) { return; } this._drag = null; this._markDirty(); this._paintCanvas(); };
		tmpStage.addEventListener('pointerup', fEnd);
		tmpStage.addEventListener('pointercancel', fEnd);
	}

	// ─── persist ────────────────────────────────────────────────────────────
	_markDirty() { try { window.localStorage.setItem(_DRAFT_KEY + this._id, JSON.stringify(this._layout)); } catch (pErr) { /* best effort */ } }

	saveLayout()
	{
		this._markDirty();
		let tmpBtn = this._el('BPS-Save');
		// Persist onto the blueprint (tenant-scoped). The localStorage draft above is the offline fallback,
		// so an in-progress design is never lost even if the save round-trip fails.
		libFrameworkClient.postJSON(this.fable, '/1.0/Blueprint/' + this._id + '/Design/Save', { Layout: this._layout })
			.then(() => { if (tmpBtn) { tmpBtn.textContent = 'Saved'; setTimeout(() => { if (tmpBtn) { tmpBtn.textContent = 'Save'; } }, 1400); } })
			.catch(() => { if (tmpBtn) { tmpBtn.textContent = 'Saved (draft)'; setTimeout(() => { if (tmpBtn) { tmpBtn.textContent = 'Save'; } }, 1400); } });
	}

	exportJSON()
	{
		let tmpJSON = JSON.stringify(this._layout, null, 2);
		if (typeof navigator !== 'undefined' && navigator.clipboard) { navigator.clipboard.writeText(tmpJSON).catch(() => {}); }
		let tmpBtn = this._el('BPS-Export'); if (tmpBtn) { tmpBtn.textContent = 'Copied'; setTimeout(() => { if (tmpBtn) { tmpBtn.textContent = 'Copy JSON'; } }, 1200); }
	}

	setPrintSheet(pSheet) { this._printSheet = pSheet; }

	// Print the ON-SCREEN layout to a one-page PDF at the chosen sheet, in the current drawing style. The
	// layout rides in the POST body (what you see is what prints); the server renders it on headless
	// Chromium. A popup carries the bytes, or they download if the popup is blocked.
	printDesign()
	{
		let tmpSheet = this._printSheet || 'Letter';
		let tmpWindow = (typeof window !== 'undefined') ? window.open('', '_blank') : null;
		let tmpBtn = this._el('BPS-Print'); if (tmpBtn) { tmpBtn.textContent = 'Printing...'; }
		let fDone = (pText) => { if (tmpBtn) { tmpBtn.textContent = pText; setTimeout(() => { if (tmpBtn) { tmpBtn.textContent = 'Print PDF'; } }, 1600); } };
		let tmpName = 'blueprint.pdf';
		fetch('/1.0/Blueprint/' + this._id + '/Design/Print', {
			method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ Sheet: tmpSheet, Kit: this._kit, Layout: this._layout })
		})
			.then((pResponse) =>
			{
				if (!pResponse.ok) { return pResponse.json().then((pBody) => Promise.reject(new Error((pBody && pBody.Error) || 'Could not print.')), () => Promise.reject(new Error('Could not print.'))); }
				let tmpDisp = pResponse.headers.get('Content-Disposition') || '';
				let tmpMatch = /filename\*=UTF-8''([^;]+)/.exec(tmpDisp) || /filename="([^"]+)"/.exec(tmpDisp);
				if (tmpMatch) { try { tmpName = decodeURIComponent(tmpMatch[1]); } catch (pErr) { tmpName = tmpMatch[1]; } }
				return pResponse.blob();
			})
			.then((pBlob) =>
			{
				let tmpURL = URL.createObjectURL(pBlob);
				if (tmpWindow) { tmpWindow.location = tmpURL; }
				else { let tmpA = document.createElement('a'); tmpA.href = tmpURL; tmpA.download = tmpName; document.body.appendChild(tmpA); tmpA.click(); document.body.removeChild(tmpA); }
				fDone('Printed');
			})
			.catch((pError) => { if (tmpWindow) { tmpWindow.close(); } fDone('Print failed'); if (typeof console !== 'undefined') { console.warn('Design print failed:', pError && pError.message); } });
	}

	back() { let tmpApp = this.pict.PictApplication; if (tmpApp && typeof tmpApp._navigate === 'function') { tmpApp._navigate('/blueprint/' + this._id); } }

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		if (this._layout)
		{
			this._sizeStage(); this._drawGrid(); this._paintCanvas(); this._renderInspector(); this._renderTitleBlock(); this._applyActive(); this._wire();
			let tmpPrintSel = this._el('BPS-PrintSheet'); if (tmpPrintSel) { tmpPrintSel.value = this._printSheet; }
			if (typeof window !== 'undefined' && !this._resizeBound) { this._resizeBound = true; window.addEventListener('resize', () => { this._sizeStage(); this._drawGrid(); this._paintCanvas(); }); }
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewBlueprintStudio;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-BlueprintStudio',
	DefaultRenderable: 'Blueprint-Studio',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSSPriority: 540,
	CSS: /*css*/`
		/* A focused, full-viewport design environment: the studio takes over the screen (its own Back button
		   returns to the blueprint), so the app rail and top bar do not crowd the canvas. */
		.bps { position: fixed; inset: 0; z-index: 2000; display: grid; grid-template-columns: 192px 1fr 288px; min-height: 0; background: #101826; color: #e8edf6; font-family: "IBM Plex Sans", system-ui, sans-serif; }
		.bps-rail { background: #141d2e; overflow-y: auto; padding: 16px; }
		.bps-rail-l { border-right: 1px solid #223049; }
		.bps-rail-r { border-left: 1px solid #223049; }
		.bps-sec { font-size: 11px; letter-spacing: .08em; text-transform: uppercase; color: #6b7a95; margin: 16px 0 8px; }
		.bps-sec:first-child { margin-top: 2px; }
		.bps-btn { display: block; width: 100%; text-align: left; background: #1c293f; border: 1px solid #2b3b58; color: #dfe8f6; border-radius: 7px; padding: 9px 11px; margin-bottom: 6px; font: inherit; font-size: 13px; cursor: pointer; }
		.bps-btn:hover { background: #24344f; border-color: #3b6fd4; }
		.bps-select { width: 100%; background: #1c293f; border: 1px solid #2b3b58; color: #dfe8f6; border-radius: 7px; padding: 8px 9px; margin-bottom: 6px; font: inherit; font-size: 13px; cursor: pointer; }
		.bps-segs { display: flex; gap: 4px; background: #1c293f; border-radius: 8px; padding: 3px; }
		.bps-seg { flex: 1; text-align: center; padding: 7px 4px; border-radius: 6px; font-size: 12px; color: #aebbd2; cursor: pointer; border: none; background: transparent; font: inherit; }
		.bps-seg.on { background: #3b6fd4; color: #fff; }
		.bps-wrap { display: flex; align-items: center; justify-content: center; padding: 26px; overflow: auto; background: radial-gradient(circle at 50% 30%, #1a2537, #0d1420); }
		.bps-stage { position: relative; background: #fff; box-shadow: 0 18px 60px rgba(0,0,0,.5); padding: 2.8%;
			--bpl-ink: #12161d; --bpl-body: #2b3340; --bpl-quiet: #6b7280; --bpl-rule: #d6dbe4; --bpl-panel: #fbfcfe; --bpl-accent: #3b6fd4; --grid: rgba(59,111,212,.16); }
		.bps-grid { position: absolute; inset: 2.8%; pointer-events: none; z-index: 1; opacity: .75; }
		#BPS-Canvas { position: relative; z-index: 2; width: 100%; height: 100%; }
		.bps-stage .bpl-region { cursor: grab; }
		.bps-stage .bpl-region.sel { box-shadow: 0 0 0 2px #3b6fd4, 0 0 0 5px rgba(59,111,212,.25); }
		.bps-stage .bpl-region:hover:not(.sel) { box-shadow: 0 0 0 1.5px rgba(59,111,212,.5); }
		.bps-rhandle { position: absolute; right: -5px; bottom: -5px; width: 14px; height: 14px; background: #3b6fd4; border: 2px solid #fff; border-radius: 50%; cursor: nwse-resize; z-index: 6; box-shadow: 0 1px 4px rgba(0,0,0,.4); }
		.bps-rlabel { position: absolute; top: -9px; left: -1px; background: #3b6fd4; color: #fff; font: 600 9px "IBM Plex Mono", monospace; letter-spacing: .05em; text-transform: uppercase; padding: 1px 5px; border-radius: 3px; z-index: 6; }
		.bps-field { margin-bottom: 12px; }
		.bps-ilabel { font-size: 11px; letter-spacing: .06em; text-transform: uppercase; color: #6b7a95; margin-bottom: 4px; }
		.bps-field input, .bps-field textarea { width: 100%; background: #0f1726; border: 1px solid #2b3b58; color: #e8edf6; border-radius: 6px; padding: 7px 9px; font: inherit; font-size: 13px; box-sizing: border-box; }
		.bps-field textarea { resize: vertical; min-height: 54px; line-height: 1.4; }
		.bps-iblurb { border: 1px solid #243551; border-radius: 7px; padding: 9px; margin-bottom: 8px; background: #121b2c; }
		.bps-iempty { color: #6b7a95; font-size: 13px; line-height: 1.5; }
		.bps-ikind { font-family: "IBM Plex Mono", monospace; font-size: 11px; letter-spacing: .1em; text-transform: uppercase; color: #8fb4ff; margin-bottom: 14px; }
		.bps-del { background: #3a1622; border: 1px solid #6b2740; color: #ffb4c4; border-radius: 7px; padding: 8px 11px; font: inherit; font-size: 13px; cursor: pointer; width: 100%; margin-top: 8px; }
		.bps-logo { font-family: "IBM Plex Mono", monospace; font-size: 12px; letter-spacing: .14em; color: #8fb4ff; text-transform: uppercase; margin-bottom: 4px; }
		/* drawing-style chrome: a drafting frame + corner title block, shown for drafting/blueprint kits */
		.bps-frame { display: none; position: absolute; inset: 1.5%; border: 1.5px solid var(--bpl-ink, #222); pointer-events: none; z-index: 3; }
		.bps-frame::after { content: ''; position: absolute; inset: 4px; border: 0.75px solid var(--bpl-rule, #999); }
		.bps-tb { display: none; position: absolute; right: 3%; bottom: 3%; width: 31%; z-index: 4; border: 1.25px solid var(--bpl-ink, #222); background: var(--tb-bg, #f5f1e8); font-family: "IBM Plex Mono", monospace; color: var(--bpl-ink, #222); }
		.bps-tb-name { padding: 6px 9px; border-bottom: 1px solid var(--bpl-ink, #222); font-weight: 700; font-size: 12px; letter-spacing: .05em; text-transform: uppercase; }
		.bps-tb-row { display: flex; }
		.bps-tb-cell { flex: 1; padding: 5px 9px; border-right: 0.75px solid var(--bpl-rule, #999); }
		.bps-tb-cell:last-child { border-right: 0; }
		.bps-tb-k { font-size: 7.5px; letter-spacing: .09em; color: var(--bpl-quiet, #777); text-transform: uppercase; margin-bottom: 1px; }
		.bps-tb-v { font-size: 11px; }
		.bps-stage[data-kit="drafting"] .bps-frame, .bps-stage[data-kit="blueprint"] .bps-frame,
		.bps-stage[data-kit="drafting"] .bps-tb, .bps-stage[data-kit="blueprint"] .bps-tb { display: block; }
		.bps-stage[data-kit="drafting"] { background: #f5f1e8; --tb-bg: #f5f1e8; --bpl-ink: #232730; --bpl-body: #2d343d; --bpl-quiet: #6b7480; --bpl-rule: #b2ab98; --bpl-panel: transparent; --bpl-accent: #232730; --grid: rgba(70,62,45,.11); }
		.bps-stage[data-kit="blueprint"] { background: #15325f; --tb-bg: #15325f; --bpl-ink: #eaf3ff; --bpl-body: #d2e2f6; --bpl-quiet: #9ec0ec; --bpl-rule: rgba(255,255,255,.42); --bpl-panel: rgba(255,255,255,.05); --bpl-accent: #8fd3ff; --grid: rgba(175,208,255,.17); }
		.bps-stage[data-kit="drafting"] .bpl-region, .bps-stage[data-kit="blueprint"] .bpl-region,
		.bps-stage[data-kit="drafting"] .bpl-diagram, .bps-stage[data-kit="blueprint"] .bpl-diagram,
		.bps-stage[data-kit="drafting"] .bpl-image img, .bps-stage[data-kit="blueprint"] .bpl-image img,
		.bps-stage[data-kit="drafting"] .bpl-image-empty, .bps-stage[data-kit="blueprint"] .bpl-image-empty { border-radius: 0 !important; }
		.bps-stage[data-kit="drafting"] .bpl-diagram, .bps-stage[data-kit="blueprint"] .bpl-diagram { background: transparent; border-width: 0.12cqh; border-color: var(--bpl-rule); }
		.bps-stage[data-kit="drafting"] .bpl-title-name, .bps-stage[data-kit="blueprint"] .bpl-title-name { text-transform: uppercase; letter-spacing: .015em; }
		@media (max-width: 900px) { .bps { grid-template-columns: 1fr; } .bps-rail { display: none; } }
	` + libLayout.LAYOUT_CSS,
	Templates:
	[
		{
			Hash: 'Blueprint-Studio',
			Template: /*html*/`
<div class="bps">
	<aside class="bps-rail bps-rail-l">
		<div class="bps-logo">Blueprint Studio</div>
		<div class="bps-sec">Add region</div>
		<button class="bps-btn" onclick="${_SELF}.addRegion('diagram')">+ Diagram</button>
		<button class="bps-btn" onclick="${_SELF}.addRegion('image')">+ Image</button>
		<button class="bps-btn" onclick="${_SELF}.addRegion('blurbs')">+ Blurbs</button>
		<button class="bps-btn" onclick="${_SELF}.addRegion('note')">+ Note</button>
		<button class="bps-btn" onclick="${_SELF}.addRegion('title')">+ Title block</button>
		<div class="bps-sec">Drawing style</div>
		<div class="bps-segs" id="BPS-Kits">
			<button class="bps-seg" data-val="clean" onclick="${_SELF}.setKit('clean')">Clean</button>
			<button class="bps-seg" data-val="drafting" onclick="${_SELF}.setKit('drafting')">Drafting</button>
			<button class="bps-seg" data-val="blueprint" onclick="${_SELF}.setKit('blueprint')">Blueprint</button>
		</div>
		<div class="bps-sec">Preview size</div>
		<div class="bps-segs" id="BPS-Sizes">
			<button class="bps-seg" data-val="web" onclick="${_SELF}.setSize('web')">Web</button>
			<button class="bps-seg" data-val="letter" onclick="${_SELF}.setSize('letter')">Letter</button>
			<button class="bps-seg" data-val="archd" onclick="${_SELF}.setSize('archd')">ArchD</button>
		</div>
		<div class="bps-sec">Print</div>
		<select class="bps-select" id="BPS-PrintSheet" onchange="${_SELF}.setPrintSheet(this.value)">
			<option value="Letter">Letter (8.5 x 11 in)</option>
			<option value="Legal">Legal (8.5 x 14 in)</option>
			<option value="Tabloid">Tabloid (11 x 17 in)</option>
			<option value="ArchD">ARCH D (24 x 36 in)</option>
			<option value="ArchDLandscape">ARCH D landscape</option>
		</select>
		<button class="bps-btn" id="BPS-Print" onclick="${_SELF}.printDesign()" title="Print this layout as a one-page PDF at the chosen size, in the current drawing style">Print PDF</button>
		<div class="bps-sec">Layout</div>
		<button class="bps-btn" id="BPS-Save" onclick="${_SELF}.saveLayout()">Save</button>
		<button class="bps-btn" id="BPS-Export" onclick="${_SELF}.exportJSON()">Copy JSON</button>
		<button class="bps-btn" onclick="${_SELF}.back()">Back to blueprint</button>
	</aside>
	<main class="bps-wrap">
		<div class="bps-stage" id="BPS-Stage" data-kit="drafting">
			<div class="bps-grid" id="BPS-Grid"></div>
			<div class="bps-frame"></div>
			<div id="BPS-Canvas"></div>
			<div class="bps-tb" id="BPS-TitleBlock"></div>
		</div>
	</main>
	<aside class="bps-rail bps-rail-r">
		<div class="bps-sec">Inspector</div>
		<div id="BPS-Inspector"></div>
	</aside>
</div>`
		}
	],
	Renderables:
	[
		{ RenderableHash: 'Blueprint-Studio', TemplateHash: 'Blueprint-Studio', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

},{"../BlueprintLayout.js":551,"../providers/FrameworkClient.js":576,"pict-view":365}],657:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libDescriptors = require('../EntityDescriptors.js');
const libFocus = require('../FocusFilters.js');
// The shared entity mark: the title block, the labelled cells, and the tooltip body, identical here
// and on every other surface that shows an entity.
const libMarkup = require('./Markup-Templates.js');

// The card's By/For cells (assignee, target) are blank on most cards and cost every card two rows of
// mostly-empty space to hold them. Collapsed by default; "Expanded" reveals them. CSS-only toggle via
// a data attribute on the board root (see PictView-Rail's rail mode), so persisting it and switching it
// never touches the render pipeline.
const _EXPANDED_KEY = 'plansheet.board.expanded';

/**
 * Board — the bespoke Phase-1 Kanban over Work Items, bucketed into the tenant's
 * lanes. Features used to share this stream and now have a board of their own
 * (PictView-FeatureBoard): work items move at agent speed and features move at
 * product speed, and one surface implied they should move together, which is the
 * pressure that produces rubber stamps. HTML5 drag-and-drop
 * moves a card to another lane; the drop PUTs the entity's Status/SortOrder via
 * BoardAPI, which trips the server-side status-change audit. (Deliberately NOT
 * pict-section-flow — that's a node/edge graph editor, reserved for the future
 * retold-workflow definition designer.)
 */
class PictViewBoard extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._drag = null;
		// The floating drop marker: a single reused node moved between lanes as the
		// cursor travels, so the user sees exactly where the card will land.
		this._placeholder = null;
		// Multi-select state: the set of selected WorkItem numbers, the last-clicked
		// number (for shift-range), and a pending confirm ({ Op, Value, Count, Verb }).
		this._selected = new Set();
		this._lastSelected = null;
		this._confirm = null;
		// IDUser -> roster row, for the focus-view assignee facet (human / AI agent).
		this._rosterIndex = {};
		// How many cards each lane is currently showing, keyed by lane Key (see
		// _decorateLanesForRender): a terminal lane like Done can hold hundreds, so a lane paints its
		// first _MAX_LANE_CARDS and offers a footer that pages in another _MAX_LANE_CARDS at a time.
		// A lane absent from here is at the default cap.
		this._laneShown = {};
	}

	// A large bulk move asks for confirmation (mirroring the MCP preview); a small one
	// applies straight away. Archive always confirms regardless of size.
	get _LARGE_MOVE() { return 10; }

	// How many cards a lane paints before it collapses the rest behind a "show all" footer.
	// A single stream of hundreds of draggable card nodes is slow to drag and forces the lane
	// into its own scrollbars; capping the render keeps the board light and lets the board's own
	// scroll region (not a per-column one) do the scrolling.
	get _MAX_LANE_CARDS() { return 50; }

	_board() { return this.pict.providers.BoardAPI; }

	_router() { return this.pict.providers['Pict-Router']; }

	_boardRoot() { return (typeof document !== 'undefined') ? document.getElementById('ps-board-root') : null; }

	// The persisted intent: whether card By/For cells should show. Defaults off -- most cards leave
	// both blank, so showing them by default was mostly empty space.
	getExpanded()
	{
		try { return localStorage.getItem(_EXPANDED_KEY) === '1'; } catch (pError) { return false; }
	}

	setExpanded(pExpanded)
	{
		let tmpExpanded = !!pExpanded;
		try { localStorage.setItem(_EXPANDED_KEY, tmpExpanded ? '1' : '0'); } catch (pError) { /* best effort */ }
		let tmpRoot = this._boardRoot();
		if (tmpRoot) { tmpRoot.setAttribute('data-board-expanded', tmpExpanded ? '1' : '0'); }
		let tmpButton = (typeof document !== 'undefined') ? document.getElementById('ps-board-expand-btn') : null;
		if (tmpButton)
		{
			tmpButton.textContent = tmpExpanded ? 'Collapse' : 'Expand';
			tmpButton.classList.toggle('is-active', tmpExpanded);
		}
		return tmpExpanded;
	}

	toggleExpanded() { this.setExpanded(!this.getExpanded()); }

	openCard(pKind, pID)
	{
		let tmpRouter = this._router();
		if (!tmpRouter || !pID) return;
		let tmpSegment = (pKind === 'Feature') ? 'feature' : 'work-item';
		tmpRouter.navigate('/' + tmpSegment + '/' + pID);
	}

	refresh()
	{
		let tmpBoard = this._board();
		if (!tmpBoard) { return; }
		// A drag to another lane, a bulk "move to Done", a QC pass/fail -- every status change
		// routes through here, and the render() below replaces #ps-board-root wholesale. On a board
		// wide enough to scroll, that snapped the lanes back to the far left on every single move,
		// which meant working the right side of the board was a fight against the board itself.
		// Capture the scroll now and put it back once the fresh lanes are in the DOM.
		let tmpScroll = this._captureLaneScroll();
		// Re-fetch, then re-apply the active focus-view filter so a Refresh (or a bulk op that
		// calls refresh) keeps the board narrowed instead of snapping back to every card.
		tmpBoard.list().then(() => { this.applyFilter(); this.render(); this._restoreLaneScroll(tmpScroll); });
	}

	// The board's one scroll region (#ps-board-lanes, see the CSS) as it stood right before a
	// re-render tears it down and rebuilds it. Null off-DOM (nothing to preserve).
	_captureLaneScroll()
	{
		let tmpLanes = (typeof document !== 'undefined') ? document.getElementById('ps-board-lanes') : null;
		return tmpLanes ? { Left: tmpLanes.scrollLeft, Top: tmpLanes.scrollTop } : null;
	}

	// Put a captured scroll position back after a re-render. Applied once immediately and once
	// more on the next frame, in case the fresh lanes settle their layout (and therefore their
	// scrollable width) a tick late.
	_restoreLaneScroll(pScroll)
	{
		if (!pScroll) { return; }
		let fApply = () =>
		{
			let tmpLanes = (typeof document !== 'undefined') ? document.getElementById('ps-board-lanes') : null;
			if (tmpLanes) { tmpLanes.scrollLeft = pScroll.Left; tmpLanes.scrollTop = pScroll.Top; }
		};
		fApply();
		if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(fApply); }
	}

	// ── focus-view filtering ─────────────────────────────────────────────────
	// The board narrows the same way the Work Items list does, through the shared engine:
	// a text search, an assignee lens (human / AI), a recent-activity window, plus type and
	// priority. Status is the lanes themselves, so it is not a board facet. The filter lives
	// in the URL (#/board?...) so a narrowed board is shareable and survives reload, AND is
	// remembered per user in localStorage (see _persistState) so it survives navigating away
	// and back -- the router drops the query on every other route, and a plain nav-link back
	// to Board (#/board, no query) used to land on a clean filter with nothing on screen
	// saying it had changed.

	// The last-used board filter, stored the same way EntityList remembers a list's state
	// (see PictView-EntityList._listPrefs): one small blob per user, keyed to this screen.
	_boardPrefs()
	{
		return libFocus.loadListPrefs('Board', this._currentUserID());
	}

	// Remember the live filter state as the board's last-used state. Best-effort, like every
	// other list preference.
	_persistState()
	{
		let tmpPrefs = this._boardPrefs();
		tmpPrefs.state = Object.assign({}, this._filterState());
		libFocus.saveListPrefs('Board', this._currentUserID(), tmpPrefs);
	}

	// The filter state to land on, most specific first: an explicit URL query (a shared /
	// reloaded #/board?... link, or a deep link -- still wins over anything remembered), then
	// the state this person last left the board in, then a clean slate. Called by the app
	// before the board fetch (prepareFilter runs ahead of the list fetch on every board entry).
	prepareFilter()
	{
		if (!this.pict.AppData.Board) { this.pict.AppData.Board = { Lanes: [], Loading: false, Error: null }; }
		if (libFocus.readHashQuery()) { this.pict.AppData.Board.Filter = libFocus.stateFromHash({}); return; }
		let tmpSaved = this._boardPrefs().state;
		this.pict.AppData.Board.Filter = (tmpSaved && typeof tmpSaved === 'object') ? Object.assign(libFocus.emptyState(), tmpSaved) : libFocus.emptyState();
	}

	loadRoster()
	{
		let tmpTeam = this.pict.providers.TeamAPI;
		if (!tmpTeam || typeof tmpTeam.roster !== 'function') { this._rosterIndex = {}; return Promise.resolve([]); }
		return tmpTeam.roster().then((pRoster) =>
		{
			this._rosterIndex = {};
			let tmpList = Array.isArray(pRoster) ? pRoster : [];
			for (let i = 0; i < tmpList.length; i++) { this._rosterIndex[Number(tmpList[i].IDUser)] = tmpList[i]; }
			return tmpList;
		}).catch(() => { this._rosterIndex = {}; return []; });
	}

	_currentUserID()
	{
		let tmpAuth = this.pict.AppData.Auth;
		return (tmpAuth && tmpAuth.User && Number(tmpAuth.User.IDUser)) || 0;
	}

	_filterState()
	{
		if (!this.pict.AppData.Board.Filter) { this.pict.AppData.Board.Filter = libFocus.emptyState(); }
		return this.pict.AppData.Board.Filter;
	}

	// Re-bucket the board from the filtered card set and (re)build the filter-bar model.
	applyFilter()
	{
		let tmpBoard = this._board();
		if (!tmpBoard) { return; }
		let tmpAll = tmpBoard.allCards();
		let tmpContext = libFocus.buildContext((this.pict.AppData.Team && this.pict.AppData.Team.Roster) || [], this._currentUserID());
		let tmpFiltered = libFocus.filterRows(tmpAll, this._filterState(), tmpContext);
		tmpBoard.rebucket(tmpFiltered);
		this.pict.AppData.Board.FilterCount = 'Showing ' + tmpFiltered.length + ' of ' + tmpAll.length + ' cards';
		this._buildFilterBar();
		this._decorateLanesForRender();
	}

	// Per-lane render cap. Each lane keeps its full Cards array (the move/reorder math and the
	// count badge run off that), but the template paints Record.RenderCards -- the first
	// _MAX_LANE_CARDS unless the user expanded the lane -- plus a MoreSlot footer that toggles
	// the lane open. RenderCards is always the FIRST N of Cards, so a rendered card's DOM index
	// still equals its model index and the drop-position math stays correct.
	_decorateLanesForRender()
	{
		let tmpLanes = (this.pict.AppData.Board && this.pict.AppData.Board.Lanes) || [];
		let tmpMax = this._MAX_LANE_CARDS;
		for (let i = 0; i < tmpLanes.length; i++)
		{
			let tmpLane = tmpLanes[i];
			let tmpCards = tmpLane.Cards || [];
			// How many this lane is currently showing. Grows a page at a time as the person asks for
			// more, rather than flipping straight to all of them: a Done lane can hold hundreds, and
			// painting them all at once is exactly the cost the cap exists to avoid.
			let tmpShown = Math.min(this._laneShown[tmpLane.Key] || tmpMax, tmpCards.length);
			tmpLane.RenderCards = (tmpCards.length <= tmpShown) ? tmpCards : tmpCards.slice(0, tmpShown);

			let tmpHidden = tmpCards.length - tmpLane.RenderCards.length;
			if (tmpHidden > 0)
			{
				tmpLane.MoreSlot = [{
					Key: tmpLane.Key, Action: 'more',
					Label: '... ' + tmpHidden + ' more card' + ((tmpHidden === 1) ? '' : 's'),
					Button: 'Load ' + Math.min(tmpMax, tmpHidden) + ' more'
				}];
			}
			else if (tmpShown > tmpMax)
			{
				// Fully shown and expanded past the cap: offer the way back.
				tmpLane.MoreSlot = [{
					Key: tmpLane.Key, Action: 'fewer',
					Label: 'Showing all ' + tmpCards.length, Button: 'Show fewer'
				}];
			}
			else { tmpLane.MoreSlot = []; }
		}
	}

	// Footer action: show one more page of a lane, or collapse it back to the cap. Paging rather than
	// an all-or-nothing toggle, so a lane with hundreds of cards never has to paint them all to show
	// the next few.
	laneMore(pKey, pAction)
	{
		if (!pKey) { return; }
		let tmpMax = this._MAX_LANE_CARDS;
		if (pAction === 'fewer') { delete this._laneShown[pKey]; }
		else { this._laneShown[pKey] = (this._laneShown[pKey] || tmpMax) + tmpMax; }
		this._repaintLanes();
	}

	_opt(pValues, pSelected, pAnyLabel)
	{
		return pValues.map((pV) => ({ Value: pV, Label: (pV === '') ? pAnyLabel : pV, SelectedAttr: (String(pV) === String(pSelected || '')) ? 'selected' : '' }));
	}

	_assigneeOptions(pSelected)
	{
		let tmpOptions = libFocus.AssigneeChoices.map((pC) => ({ Value: pC.Key, Label: pC.Label, SelectedAttr: (pC.Key === (pSelected || '')) ? 'selected' : '' }));
		let tmpRoster = (this.pict.AppData.Team && this.pict.AppData.Team.Roster) || [];
		for (let i = 0; i < tmpRoster.length; i++)
		{
			let tmpKey = 'u:' + tmpRoster[i].IDUser;
			tmpOptions.push({ Value: tmpKey, Label: (tmpRoster[i].DisplayName || ('#' + tmpRoster[i].IDUser)) + (Number(tmpRoster[i].IsAgent) === 1 ? ' (AI)' : ''), SelectedAttr: (tmpKey === (pSelected || '')) ? 'selected' : '' });
		}
		return tmpOptions;
	}

	_recentOptions(pSelected)
	{
		let tmpOptions = [{ Value: '', Label: 'Any time', SelectedAttr: (!pSelected) ? 'selected' : '' }];
		libFocus.RecentWindows.forEach((pW) => tmpOptions.push({ Value: pW.Key, Label: pW.Label, SelectedAttr: (pW.Key === (pSelected || '')) ? 'selected' : '' }));
		return tmpOptions;
	}

	_viewOptions(pSelected)
	{
		let tmpOptions = [{ Value: '', Label: 'Views: none', SelectedAttr: (!pSelected) ? 'selected' : '' }];
		// Board and list share one saved-view set (keyed 'WorkItem'), so a saved focus works on both.
		libFocus.allViews('WorkItem', this._currentUserID()).forEach((pV) => tmpOptions.push({ Value: pV.Key, Label: (pV.Group ? (pV.Group + ': ') : '') + pV.Label, SelectedAttr: (pV.Key === (pSelected || '')) ? 'selected' : '' }));
		return tmpOptions;
	}

	_buildFilterBar()
	{
		let tmpState = this._filterState();
		this.pict.AppData.Board.FilterBar =
		{
			SearchValue: String(tmpState.q || ''),
			ViewOptions: this._viewOptions(tmpState.view),
			TypeOptions: this._opt([''].concat(libDescriptors.WorkItemTypes), tmpState.type, 'All types'),
			PriorityOptions: this._opt([''].concat(libDescriptors.Priorities), tmpState.priority, 'Any priority'),
			AssigneeOptions: this._assigneeOptions(tmpState.assignee),
			RecentOptions: this._recentOptions(tmpState.recent),
			WorkflowStatusOptions: libFocus.WorkflowStatusChoices.map((pC) => ({ Value: pC.Key, Label: pC.Label, SelectedAttr: (pC.Key === (tmpState.wfstatus || '')) ? 'selected' : '' })),
			CountLabel: this.pict.AppData.Board.FilterCount || '',
			ClearSlot: libFocus.isFiltered(tmpState) ? [{}] : [],
			DeleteViewSlot: (String(tmpState.view || '').indexOf('saved:') === 0) ? [{ Key: tmpState.view }] : []
		};
		this.pict.AppData.Board.FilterBarSlot = [this.pict.AppData.Board.FilterBar];
	}

	setFilter(pField, pValue)
	{
		this._filterState()[pField] = pValue || '';
		this._filterState().view = '';
		this._afterFilterChange();
	}

	// The search box: re-bucket + repaint only the lanes (keep the input focused mid-type).
	setSearch(pValue)
	{
		this._filterState().q = pValue || '';
		this._filterState().view = '';
		this._writeUrl();
		this._persistState();
		this.applyFilter();
		this._repaintLanes();
	}

	applyView(pKey)
	{
		if (!pKey) { this.clearFilters(); return; }
		let tmpState = libFocus.viewState('WorkItem', this._currentUserID(), pKey);
		this.pict.AppData.Board.Filter = tmpState || libFocus.emptyState();
		this._afterFilterChange();
	}

	clearFilters()
	{
		this.pict.AppData.Board.Filter = libFocus.emptyState();
		this._afterFilterChange();
	}

	// Shared post-change tail for every facet mutation: rewrite the URL, remember the state as
	// this person's last-used board filter, re-bucket, and re-render. Persisting here is what
	// makes a narrowed board survive walking away from it -- and what makes Clear honest, since
	// clearing used to be undone the moment you navigated back with nothing on screen saying so.
	_afterFilterChange()
	{
		this._writeUrl();
		this._persistState();
		this.applyFilter();
		this.render();
	}

	saveView()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let fSave = (pName) =>
		{
			let tmpRecord = libFocus.saveSavedView('WorkItem', this._currentUserID(), pName, this._filterState());
			if (tmpRecord) { this._filterState().view = tmpRecord.Key; this._afterFilterChange(); this._toast('View "' + tmpRecord.Label + '" saved.', 'success'); }
		};
		tmpModal.show(
			{
				title: 'Save this view',
				content: '<p>Name this filter so you can switch back to it:</p><input type="text" id="ps-boardview-input" class="ps-input" style="width:100%" autofocus>',
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Save', Style: 'primary' } ]
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let tmpEl = (typeof document !== 'undefined') ? document.getElementById('ps-boardview-input') : null;
				let tmpName = (tmpEl && tmpEl.value ? tmpEl.value : '').trim();
				if (tmpName) { fSave(tmpName); }
			});
	}

	// QC review: pass a Review-lane Work Item straight to Done. The event's stopPropagation keeps
	// the card's onclick (open detail) from firing.
	reviewPass(pEvent, pID)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') { pEvent.stopPropagation(); }
		let tmpBoard = this._board();
		if (!tmpBoard) { return; }
		tmpBoard.reviewWorkItem(pID, 'Pass', {})
			.then(() => { this.refresh(); this._toast('Passed review -> Done.', 'success'); })
			.catch((pErr) => { this._toast('Could not pass review: ' + (pErr.message || pErr), 'error'); });
	}

	// QC review: "did not pass QC". Collect a reason code, a note, and an optional punch-list of
	// issue titles, then send the card back for rework.
	reviewFail(pEvent, pID)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') { pEvent.stopPropagation(); }
		let tmpBoard = this._board();
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpBoard || !tmpModal || typeof tmpModal.show !== 'function') { return; }

		let fEsc = (pText) => String(pText == null ? '' : pText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		let fField = (pLabel, pControl) => '<label style="display:block;margin:8px 0 4px;font-size:12px;font-weight:600;color:var(--theme-color-text-secondary,#5b6376)">' + fEsc(pLabel) + '</label>' + pControl;
		let tmpStyle = 'width:100%;box-sizing:border-box;padding:6px 8px;';
		let tmpReasonOptions = (libDescriptors.QCReasonCodes || []).map((pCode) => '<option value="' + fEsc(pCode) + '">' + fEsc(pCode) + '</option>').join('');

		tmpModal.show(
			{
				title: 'Send back (did not pass QC)',
				content:
					fField('Reason', '<select id="qc-reason" style="' + tmpStyle + '">' + tmpReasonOptions + '</select>') +
					fField('What was wrong / what is needed', '<textarea id="qc-note" style="' + tmpStyle + 'min-height:64px;resize:vertical;" placeholder="A short note for the person picking this back up..."></textarea>') +
					fField('Punch-list issues (optional, one per line)', '<textarea id="qc-issues" style="' + tmpStyle + 'min-height:52px;resize:vertical;" placeholder="Each line becomes an Issue linked to this work item"></textarea>'),
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Send back', Style: 'primary' } ]
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let fVal = (pElID) => { let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pElID) : null; return tmpEl ? tmpEl.value : ''; };
				let tmpIssues = fVal('qc-issues').split('\n').map((pLine) => pLine.trim()).filter((pLine) => pLine);
				tmpBoard.reviewWorkItem(pID, 'Fail', { ReasonCode: fVal('qc-reason'), Note: fVal('qc-note').trim(), Issues: tmpIssues })
					.then((pResult) =>
					{
						this.refresh();
						let tmpN = (pResult && pResult.Issues && pResult.Issues.length) || 0;
						this._toast('Sent back for rework' + (tmpN ? (' with ' + tmpN + ' issue' + (tmpN === 1 ? '' : 's')) : '') + '.', 'success');
					})
					.catch((pErr) => { this._toast('Could not send back: ' + (pErr.message || pErr), 'error'); });
			});
	}

	deleteView(pKey)
	{
		let tmpKey = pKey || this._filterState().view;
		if (!tmpKey) { return; }
		libFocus.deleteSavedView('WorkItem', this._currentUserID(), tmpKey);
		if (this._filterState().view === tmpKey) { this._filterState().view = ''; }
		this._afterFilterChange();
		this._toast('View deleted.', 'success');
	}

	_writeUrl() { libFocus.writeHashState(this._filterState()); }

	// Re-render only the lanes container + count (used by the search box so focus stays put).
	_repaintLanes()
	{
		this._decorateLanesForRender();
		let tmpLanes = this.pict.AppData.Board.Lanes || [];
		let tmpHTML = '';
		for (let i = 0; i < tmpLanes.length; i++) { tmpHTML += this.pict.parseTemplateByHash('Board-Lane', tmpLanes[i]); }
		this.pict.ContentAssignment.assignContent('#ps-board-lanes', tmpHTML);
		this.pict.ContentAssignment.assignContent('#ps-board-count', this.pict.AppData.Board.FilterCount || '');
		this._applySelectionClasses();
		// Every card element above is a new one, so the tooltips have to be rebound the way a full
		// render rebinds them (onAfterRender). Without this, peeking silently stopped working after
		// the first keystroke in the search box, and the old handles were left holding detached cards.
		this._attachCardTooltips();
	}

	dragStart(pEvent, pKind, pID)
	{
		// Peeking must never fight dragging: tear the tooltips down for the duration of the gesture and
		// put them back when it ends. A drop relocates the card element rather than re-rendering, so
		// dragEnd has to restore them itself.
		this._destroyCardTooltips();
		// Stash the dragged card element so drop() can physically relocate it
		// instead of re-rendering the whole board.
		let tmpElement = pEvent && (pEvent.currentTarget || (pEvent.target && pEvent.target.closest && pEvent.target.closest('.ps-card')));
		// Group-drag: if the grabbed card is one of several selected work items, drag the
		// whole selection to the drop lane instead of just this card.
		let tmpNumber = tmpElement && tmpElement.getAttribute ? (Number(tmpElement.getAttribute('data-number')) || 0) : 0;
		if (pKind === 'WorkItem' && this._selected.size > 1 && this._selected.has(tmpNumber))
		{
			this._drag = { Group: true, Numbers: Array.from(this._selected), Element: tmpElement || null };
		}
		else
		{
			this._drag = { Kind: pKind, ID: pID, Element: tmpElement || null };
		}
		if (tmpElement && tmpElement.classList) tmpElement.classList.add('ps-card-dragging');
		if (pEvent && pEvent.dataTransfer)
		{
			pEvent.dataTransfer.effectAllowed = 'move';
			try { pEvent.dataTransfer.setData('text/plain', String(pID)); } catch (pErr) { /* ignore */ }
		}
	}

	dragEnd(pEvent)
	{
		let tmpElement = pEvent && pEvent.currentTarget;
		if (tmpElement && tmpElement.classList) tmpElement.classList.remove('ps-card-dragging');
		// The gesture is over, so peeking is welcome again.
		this._attachCardTooltips();
		// The drag ended (dropped anywhere, or cancelled) — tidy the marker and any
		// lingering hover state so nothing is left dangling.
		this._removePlaceholder();
		this._clearDragoverLanes();
		this._drag = null;
	}

	// The reused drop-marker node, created lazily the first time it is needed.
	_placeholderNode()
	{
		if (typeof document === 'undefined') return null;
		if (!this._placeholder)
		{
			this._placeholder = document.createElement('div');
			this._placeholder.className = 'ps-card-placeholder';
		}
		return this._placeholder;
	}

	_removePlaceholder()
	{
		if (this._placeholder && this._placeholder.parentNode)
		{
			this._placeholder.parentNode.removeChild(this._placeholder);
		}
	}

	_clearDragoverLanes()
	{
		if (typeof document === 'undefined') return;
		let tmpLanes = document.querySelectorAll('.ps-lane.ps-lane-dragover');
		for (let i = 0; i < tmpLanes.length; i++) tmpLanes[i].classList.remove('ps-lane-dragover');
	}

	/**
	 * The card element the marker should sit ABOVE for a given cursor Y — the first
	 * card whose vertical midpoint is below the cursor. The card being dragged is
	 * skipped so it never counts as its own neighbor. Null means "past the last card".
	 */
	_cardBefore(pCardsElement, pY)
	{
		let tmpCards = pCardsElement.querySelectorAll('.ps-card');
		for (let i = 0; i < tmpCards.length; i++)
		{
			if (this._drag && tmpCards[i] === this._drag.Element) continue;
			let tmpRect = tmpCards[i].getBoundingClientRect();
			if (pY < tmpRect.top + (tmpRect.height / 2)) return tmpCards[i];
		}
		return null;
	}

	allowDrop(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') pEvent.preventDefault();
		if (pEvent && pEvent.dataTransfer) pEvent.dataTransfer.dropEffect = 'move';
		let tmpLane = pEvent && pEvent.currentTarget;
		if (!tmpLane) return;
		if (tmpLane.classList) tmpLane.classList.add('ps-lane-dragover');
		if (!this._drag) return;

		// Slot the marker into this lane at the cursor position. Moving the single
		// node here also pulls it out of whatever lane it was in before.
		let tmpCardsElement = tmpLane.querySelector ? tmpLane.querySelector('.ps-lane-cards') : null;
		let tmpPlaceholder = this._placeholderNode();
		if (!tmpCardsElement || !tmpPlaceholder) return;
		let tmpY = (pEvent && typeof pEvent.clientY === 'number') ? pEvent.clientY : 0;
		let tmpBefore = this._cardBefore(tmpCardsElement, tmpY);
		if (tmpBefore) tmpCardsElement.insertBefore(tmpPlaceholder, tmpBefore);
		else tmpCardsElement.appendChild(tmpPlaceholder);
	}

	dragLeave(pEvent)
	{
		let tmpLane = pEvent && pEvent.currentTarget;
		if (!tmpLane) return;
		// dragleave also fires when crossing between the lane's own children; only
		// treat it as a real exit when the cursor moved to something outside the lane.
		let tmpRelated = pEvent.relatedTarget;
		if (tmpRelated && tmpLane.contains && tmpLane.contains(tmpRelated)) return;
		if (tmpLane.classList) tmpLane.classList.remove('ps-lane-dragover');
		if (this._placeholder && tmpLane.contains && tmpLane.contains(this._placeholder))
		{
			this._removePlaceholder();
		}
	}

	drop(pEvent, pLaneKey)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') pEvent.preventDefault();
		let tmpLaneElement = pEvent && pEvent.currentTarget;
		if (tmpLaneElement && tmpLaneElement.classList) tmpLaneElement.classList.remove('ps-lane-dragover');

		let tmpDrag = this._drag;
		this._drag = null;
		let tmpBoard = this._board();
		if (tmpDrag && tmpDrag.Element && tmpDrag.Element.classList) tmpDrag.Element.classList.remove('ps-card-dragging');

		// Group-drag: move the whole selection to this lane through the bulk endpoint,
		// then re-fetch. (A single optimistic relocate does not model N cards moving.)
		if (tmpDrag && tmpDrag.Group)
		{
			this._removePlaceholder();
			this._clearDragoverLanes();
			this.moveSelection(pLaneKey);
			return;
		}

		let tmpCardsElement = tmpLaneElement ? tmpLaneElement.querySelector('.ps-lane-cards') : null;
		let tmpPlaceholder = this._placeholder;

		// The marker's spot is the drop target: count the real cards above it (the
		// dragged card excluded) to get the resting index among the lane's others.
		let tmpTargetIndex = this._markerIndex(tmpCardsElement, tmpPlaceholder, tmpDrag);

		if (!tmpDrag || !tmpBoard) { this._removePlaceholder(); return; }

		// Optimistic move: update the in-memory model and relocate just the card node
		// to the marker's slot. No full re-render, so the board keeps its horizontal
		// scroll and each lane keeps its vertical scroll.
		let tmpMove = tmpBoard.applyLocalMoveAt(tmpDrag.Kind, tmpDrag.ID, pLaneKey, tmpTargetIndex);
		if (!tmpMove) { this._removePlaceholder(); return; }

		if (tmpDrag.Element && tmpCardsElement)
		{
			if (tmpPlaceholder && tmpPlaceholder.parentNode === tmpCardsElement)
			{
				tmpCardsElement.insertBefore(tmpDrag.Element, tmpPlaceholder);
			}
			else
			{
				tmpCardsElement.appendChild(tmpDrag.Element);
			}
		}
		this._removePlaceholder();
		this._syncLaneCounts(tmpLaneElement);

		tmpBoard.persistMove(tmpMove)
			.catch((pErr) =>
			{
				// Roll the model back and fall back to a full re-render on the rare
				// failure path so the board reflects the real server state.
				let tmpScroll = this._captureLaneScroll();
				tmpBoard.revertLocalMove(tmpMove);
				this.render();
				this._restoreLaneScroll(tmpScroll);
				let tmpModal = this.pict.views['Pict-Section-Modal'];
				if (tmpModal && typeof tmpModal.toast === 'function')
				{
					tmpModal.toast('Move failed: ' + (pErr.message || pErr), { type: 'error', duration: 6000 });
				}
			});
	}

	/**
	 * Resting index for the dropped card = number of real cards (the dragged card
	 * excluded) ahead of the marker. Falls back to the end of the lane if the marker
	 * is not placed (e.g. a drop with no preceding dragover).
	 */
	_markerIndex(pCardsElement, pPlaceholder, pDrag)
	{
		if (!pCardsElement) return Infinity;
		if (!pPlaceholder || pPlaceholder.parentNode !== pCardsElement) return Infinity;
		let tmpNodes = pCardsElement.querySelectorAll('.ps-card, .ps-card-placeholder');
		let tmpIndex = 0;
		for (let i = 0; i < tmpNodes.length; i++)
		{
			if (tmpNodes[i] === pPlaceholder) break;
			if (pDrag && tmpNodes[i] === pDrag.Element) continue;
			tmpIndex++;
		}
		return tmpIndex;
	}

	/**
	 * Refresh every lane's count badge in place from the model, without a render.
	 * pAnyLaneElement is any lane node used to locate the shared lanes container.
	 */
	_syncLaneCounts(pAnyLaneElement)
	{
		let tmpBoard = this._board();
		if (!tmpBoard) return;
		let tmpLanes = (tmpBoard.store() && tmpBoard.store().Lanes) || [];
		let tmpRoot = pAnyLaneElement && typeof pAnyLaneElement.closest === 'function' ? pAnyLaneElement.closest('.ps-board-lanes') : null;
		if (!tmpRoot) return;
		let tmpCounts = tmpRoot.querySelectorAll('.ps-lane .ps-lane-count');
		for (let i = 0; i < tmpCounts.length && i < tmpLanes.length; i++)
		{
			tmpCounts[i].textContent = tmpLanes[i].Count;
		}
	}

	// ---- Multi-select ---------------------------------------------------------------

	_esc(pText)
	{
		return String(pText == null ? '' : pText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	// Work-item numbers in one lane, in DOM (visual) order -- the span a shift-click walks.
	_laneNumbers(pLaneElement)
	{
		let tmpOut = [];
		if (!pLaneElement || !pLaneElement.querySelectorAll) return tmpOut;
		let tmpCards = pLaneElement.querySelectorAll('.ps-card-workitem');
		for (let i = 0; i < tmpCards.length; i++)
		{
			let tmpNumber = Number(tmpCards[i].getAttribute('data-number')) || 0;
			if (tmpNumber > 0) tmpOut.push(tmpNumber);
		}
		return tmpOut;
	}

	// Toggle one card's selection. Shift-click extends the range from the last click to
	// here within the same lane (the usual list-select gesture). Called from the card's
	// checkbox, so it stops the click from opening the card.
	toggleSelect(pEvent, pNumber)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') pEvent.stopPropagation();
		pNumber = Number(pNumber) || 0;
		if (!pNumber) return;

		let tmpCheckbox = pEvent && pEvent.target;
		let tmpLane = tmpCheckbox && tmpCheckbox.closest ? tmpCheckbox.closest('.ps-lane') : null;

		if (pEvent && pEvent.shiftKey && this._lastSelected && tmpLane)
		{
			let tmpNumbers = this._laneNumbers(tmpLane);
			let tmpFrom = tmpNumbers.indexOf(this._lastSelected);
			let tmpTo = tmpNumbers.indexOf(pNumber);
			if (tmpFrom >= 0 && tmpTo >= 0)
			{
				let tmpLow = Math.min(tmpFrom, tmpTo);
				let tmpHigh = Math.max(tmpFrom, tmpTo);
				for (let i = tmpLow; i <= tmpHigh; i++) this._selected.add(tmpNumbers[i]);
			}
			else { this._selected.add(pNumber); }
		}
		else if (this._selected.has(pNumber)) { this._selected.delete(pNumber); }
		else { this._selected.add(pNumber); }

		this._lastSelected = pNumber;
		this._confirm = null;
		this._applySelectionClasses();
		this._syncBulkBar();
	}

	clearSelection()
	{
		this._selected.clear();
		this._lastSelected = null;
		this._confirm = null;
		this._applySelectionClasses();
		this._syncBulkBar();
	}

	// Reflect the selection set onto the rendered cards (checkbox + highlight), pruning
	// any numbers whose card is no longer on the board.
	_applySelectionClasses()
	{
		if (typeof document === 'undefined') return;
		let tmpCards = document.querySelectorAll('.ps-card-workitem');
		let tmpPresent = {};
		for (let i = 0; i < tmpCards.length; i++)
		{
			let tmpNumber = Number(tmpCards[i].getAttribute('data-number')) || 0;
			tmpPresent[tmpNumber] = true;
			let tmpSelected = this._selected.has(tmpNumber);
			if (tmpCards[i].classList) tmpCards[i].classList.toggle('ps-card-selected', tmpSelected);
			let tmpCheckbox = tmpCards[i].querySelector('.ps-card-check');
			if (tmpCheckbox) tmpCheckbox.checked = tmpSelected;
		}
		// Drop selections whose card left the board (archived / filtered), so the count is honest.
		let tmpStale = [];
		this._selected.forEach((pNumber) => { if (!tmpPresent[pNumber]) tmpStale.push(pNumber); });
		tmpStale.forEach((pNumber) => this._selected.delete(pNumber));
	}

	// ---- Bulk action bar ------------------------------------------------------------

	_lanes()
	{
		let tmpBoard = this._board();
		return (tmpBoard && tmpBoard.store() && tmpBoard.store().Lanes) || [];
	}

	// Build (or update) the floating bar. Hidden when nothing is selected and no confirm
	// is pending. Rebuilt on every render, so it survives a board re-render.
	_syncBulkBar()
	{
		if (typeof document === 'undefined') return;
		let tmpRoot = document.querySelector('.ps-board');
		if (!tmpRoot) return;

		let tmpBar = tmpRoot.querySelector('#ps-bulk-bar');
		let tmpCount = this._selected.size;
		if (tmpCount === 0 && !this._confirm)
		{
			if (tmpBar && tmpBar.parentNode) tmpBar.parentNode.removeChild(tmpBar);
			return;
		}
		if (!tmpBar)
		{
			tmpBar = document.createElement('div');
			tmpBar.id = 'ps-bulk-bar';
			tmpBar.className = 'ps-bulk-bar';
			tmpRoot.appendChild(tmpBar);
		}

		let tmpView = "_Pict.views['Plansheet-Board']";
		if (this._confirm)
		{
			// Confirm step mirrors the preview: it names the action and the card count.
			tmpBar.innerHTML =
				'<span class="ps-bulk-count">' + this._esc(this._confirm.Verb) + ' ' + this._confirm.Count + ' card' + (this._confirm.Count === 1 ? '' : 's') + '?</span>' +
				'<span class="ps-bulk-note">' + this._esc(this._confirm.Note || '') + '</span>' +
				'<span class="ps-bulk-spacer"></span>' +
				'<button class="ps-btn ps-bulk-confirm" onclick="' + tmpView + '.confirmBulk()">Confirm</button>' +
				'<button class="ps-btn" onclick="' + tmpView + '.cancelConfirm()">Cancel</button>';
			return;
		}

		let tmpLaneOptions = '<option value="">Move to lane...</option>';
		let tmpLanes = this._lanes();
		for (let i = 0; i < tmpLanes.length; i++)
		{
			tmpLaneOptions += '<option value="' + this._esc(tmpLanes[i].Key) + '">' + this._esc(tmpLanes[i].Label || tmpLanes[i].Key) + '</option>';
		}
		let tmpPriorityOptions = '<option value="">Priority...</option>' + ['Low', 'Normal', 'High'].map((pP) => '<option value="' + pP + '">' + pP + '</option>').join('');
		let tmpTypeOptions = '<option value="">Type...</option>' + ['Triage', 'Research', 'Innovation', 'Issue', 'Debt', 'Enhancement'].map((pT) => '<option value="' + pT + '">' + pT + '</option>').join('');
		// Assignee options from the loaded roster (humans + AI agents); Value is the raw IDUser, 0 clears it.
		let tmpBulkRoster = (this.pict.AppData.Team && this.pict.AppData.Team.Roster) || [];
		let tmpAssigneeOptions = '<option value="">Assign to...</option><option value="0">Unassigned</option>';
		for (let i = 0; i < tmpBulkRoster.length; i++)
		{
			tmpAssigneeOptions += '<option value="' + this._esc(String(tmpBulkRoster[i].IDUser)) + '">' + this._esc((tmpBulkRoster[i].DisplayName || ('#' + tmpBulkRoster[i].IDUser)) + (Number(tmpBulkRoster[i].IsAgent) === 1 ? ' (AI)' : '')) + '</option>';
		}

		tmpBar.innerHTML =
			'<span class="ps-bulk-count">' + tmpCount + ' selected</span>' +
			'<select class="ps-bulk-select" onchange="' + tmpView + '.moveSelection(this.value); this.selectedIndex=0;">' + tmpLaneOptions + '</select>' +
			'<select class="ps-bulk-select" onchange="' + tmpView + '.setSelectionPriority(this.value); this.selectedIndex=0;">' + tmpPriorityOptions + '</select>' +
			'<select class="ps-bulk-select" onchange="' + tmpView + '.setSelectionType(this.value); this.selectedIndex=0;">' + tmpTypeOptions + '</select>' +
			'<select class="ps-bulk-select" onchange="' + tmpView + '.setSelectionAssignee(this.value); this.selectedIndex=0;">' + tmpAssigneeOptions + '</select>' +
			'<button class="ps-btn ps-bulk-archive" onclick="' + tmpView + '.beginArchive()">Archive</button>' +
			'<span class="ps-bulk-spacer"></span>' +
			'<button class="ps-btn" onclick="' + tmpView + '.clearSelection()">Clear</button>';
	}

	_selector()
	{
		return { IDs: Array.from(this._selected) };
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: 5000 });
		}
	}

	// Apply a bulk operation (Confirm:true), then report and re-fetch the board.
	//
	// Deliberately does NOT clear this._selected: a bulk action (Assign, Move, SetPriority, ...) is
	// rarely the only thing a checked-off set of cards needs -- "Assign to Claude" then "Move to Todo"
	// is the common chain, and losing the selection meant reselecting the same cards for every step.
	// refresh() -> render() -> _applySelectionClasses() already prunes any number whose card left the
	// board (archived, or filtered out by the active view), so an Archive still empties the bar on its
	// own; anything left on the board just stays checked for the next action.
	_applyBulk(pOperation, pValue)
	{
		let tmpBoard = this._board();
		if (!tmpBoard || this._selected.size === 0) return;
		let tmpSelector = this._selector();
		this._confirm = null;
		tmpBoard.bulkOperation(pOperation, tmpSelector, pValue, true)
			.then((pResult) =>
			{
				let tmpApplied = (pResult && pResult.Applied) || 0;
				let tmpFailed = (pResult && pResult.Failed && pResult.Failed.length) || 0;
				this.refresh();
				this._toast(tmpApplied + ' updated' + (tmpFailed ? (', ' + tmpFailed + ' failed') : ''), tmpFailed ? 'error' : 'success');
			})
			.catch((pErr) =>
			{
				this._toast('Bulk change failed: ' + (pErr.message || pErr), 'error');
			});
	}

	// Preview first, then show the confirm step (used by Archive and large moves).
	_previewThenConfirm(pOperation, pValue, pVerb)
	{
		let tmpBoard = this._board();
		if (!tmpBoard || this._selected.size === 0) return;
		tmpBoard.bulkOperation(pOperation, this._selector(), pValue, false)
			.then((pPreview) =>
			{
				this._confirm =
				{
					Op: pOperation,
					Value: pValue,
					Verb: pVerb,
					Count: (pPreview && pPreview.Count) || this._selected.size,
					Note: (pOperation === 'Archive') ? 'Removes them from the board (recoverable).' : ''
				};
				this._syncBulkBar();
			})
			.catch((pErr) => this._toast('Could not preview: ' + (pErr.message || pErr), 'error'));
	}

	confirmBulk()
	{
		if (!this._confirm) return;
		let tmpOp = this._confirm.Op;
		let tmpValue = this._confirm.Value;
		this._applyBulk(tmpOp, tmpValue);
	}

	cancelConfirm()
	{
		this._confirm = null;
		this._syncBulkBar();
	}

	// Move the selection to a lane. A large move confirms first; a small one applies.
	moveSelection(pLaneKey)
	{
		if (!pLaneKey || this._selected.size === 0) return;
		if (this._selected.size >= this._LARGE_MOVE)
		{
			let tmpLane = this._lanes().find((pL) => pL.Key === pLaneKey);
			this._previewThenConfirm('Move', pLaneKey, 'Move to ' + ((tmpLane && tmpLane.Label) || pLaneKey) + ':');
			return;
		}
		this._applyBulk('Move', pLaneKey);
	}

	setSelectionPriority(pPriority)
	{
		if (!pPriority || this._selected.size === 0) return;
		this._applyBulk('SetPriority', pPriority);
	}

	setSelectionType(pType)
	{
		if (!pType || this._selected.size === 0) return;
		this._applyBulk('SetType', pType);
	}

	// Assign the selection to a user (raw IDUser), or 0 to clear. Applies directly, like priority/type.
	setSelectionAssignee(pIDUser)
	{
		if (pIDUser === '' || pIDUser == null || this._selected.size === 0) return;
		this._applyBulk('Assign', pIDUser);
	}

	// Archive always confirms (mirroring the MCP preview requirement).
	beginArchive()
	{
		if (this._selected.size === 0) return;
		this._previewThenConfirm('Archive', null, 'Archive');
	}

	/**
	 * The loaded tooltip. Hover to peek at a card without leaving the board, click to pin it open and
	 * read the cross-references -- which is the whole point of the exercise: managing the board without
	 * bouncing in and out of detail views.
	 *
	 * Three things this has to get right. It must never appear mid-drag, or peeking fights dragging on
	 * the one gesture the board exists for. Every handle must be destroyed on re-render, because the
	 * board re-renders on every filter and lane move, and leaked handles would stack up invisibly. And
	 * the same on the way out of the board entirely, which is what teardown() below is for.
	 */
	_attachCardTooltips()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.pinnableTooltip !== 'function') { return; }

		this._destroyCardTooltips();
		this._tooltipHandles = [];
		let tmpCards = this.pict.AppData.Board && this.pict.AppData.Board.AllCards;
		if (!Array.isArray(tmpCards)) { return; }
		let tmpByKey = {};
		tmpCards.forEach((pCard) => { tmpByKey[pCard.CardKind + ':' + pCard.ID] = pCard; });

		// Scoped to the board's own lanes, not the document: a stray .ps-card left in the DOM by
		// another surface can never be adopted, and an attach attempted when the board is not on
		// screen binds nothing at all rather than anchoring tooltips to elements we do not own.
		let tmpElements = document.querySelectorAll('#ps-board-lanes .ps-card');
		for (let i = 0; i < tmpElements.length; i++)
		{
			let tmpElement = tmpElements[i];
			let tmpCard = tmpByKey[(tmpElement.classList.contains('ps-card-feature') ? 'Feature' : 'WorkItem')
				+ ':' + tmpElement.getAttribute('data-id')];
			if (!tmpCard) { continue; }
			this._tooltipHandles.push(tmpModal.pinnableTooltip(tmpElement, this._tooltipHTML(tmpCard),
				{ position: 'right', delay: 320, maxWidth: 400, interactive: true }));
		}
	}

	_destroyCardTooltips()
	{
		(this._tooltipHandles || []).forEach((pHandle) =>
		{
			try { if (pHandle && typeof pHandle.destroy === 'function') { pHandle.destroy(); } }
			catch (pError) { /* the element is already gone; nothing to tidy */ }
		});
		this._tooltipHandles = [];
	}

	/**
	 * Leaving the board has to take the tooltips with it, and only the board's own render path was
	 * ever destroying them. A tooltip is anchored to a card element, so the moment another view
	 * paints over the workspace that anchor is detached -- and a detached element never fires
	 * mouseleave, so a tooltip open on the way out hangs on screen over the next page (a work-item
	 * peek floating above the Work Items list, naming a row that is not even there). The handles
	 * leak with it, re-created on every board visit.
	 *
	 * The application calls this when it routes away. Idempotent: a board that was never rendered,
	 * or one torn down twice, is a no-op.
	 *
	 * Also drops the floating bulk-action bar (#ps-bulk-bar) if one is still up. It is a raw node
	 * appended to .ps-board outside the template render cycle (see _syncBulkBar), and since a bulk
	 * action now deliberately leaves the selection in place for chaining (WI #359), a selection can
	 * still be non-empty when the user routes away mid-chain -- if the router's own re-render does not
	 * happen to remove it, a fixed-position bar left behind would go on intercepting clicks on
	 * whatever page comes next, the same way an untorn-down tooltip used to.
	 */
	teardown()
	{
		this._destroyCardTooltips();
		if (typeof document !== 'undefined')
		{
			let tmpBar = document.getElementById('ps-bulk-bar');
			if (tmpBar && tmpBar.parentNode) { tmpBar.parentNode.removeChild(tmpBar); }
		}
	}

	// Built from the same mark the card renders, so the tooltip can never drift from the row above it.
	_tooltipHTML(pCard)
	{
		let fEscape = (pValue) => String(pValue === null || typeof pValue === 'undefined' ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		let tmpCells = (pCard.Cells || []).map((pCell) =>
			'<div class="ps-cell"><span class="ps-cell-k">' + fEscape(pCell.K) + '</span>'
			+ '<span class="ps-cell-v">' + fEscape(pCell.V) + '</span></div>').join('');
		let tmpDescription = String(pCard.Description || '').slice(0, 400);
		return '<div class="ps-tip">'
			+ '<div class="ps-mark ' + fEscape(pCard.KindClass) + '">'
			+ '<span class="ps-mark-d">' + fEscape(pCard.Designator) + '</span>'
			+ '<span class="ps-mark-t">' + fEscape(pCard.Title) + '</span></div>'
			+ '<div class="ps-cells">' + tmpCells + '</div>'
			+ (tmpDescription ? ('<p class="ps-tip-desc">' + fEscape(tmpDescription) + '</p>') : '')
			+ '</div>';
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._applySelectionClasses();
		this._syncBulkBar();
		this._attachCardTooltips();
		this.setExpanded(this.getExpanded());
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewBoard;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Board',
	DefaultRenderable: 'Board-Display',
	AutoRender: false,
	CSS: /*css*/`
		.ps-board { height: 100%; display: flex; flex-direction: column; position: relative; }
		.ps-board-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
		.ps-board-head h2 { font-size: 22px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; }
		.ps-board-head-actions { display: flex; align-items: center; gap: 8px; }
		/* The board's single scroll region: one scrollbar pair for the whole card area (horizontal to
		   reach every lane, vertical for a tall board). align-items:flex-start lets each lane size to its
		   own content, so a busy lane grows here instead of scrolling inside itself. The lanes and their
		   card stacks never set overflow, so they can't spawn the nested column scrollbars that fight this one. */
		.ps-board-lanes { display: flex; gap: 12px; overflow: auto; align-items: flex-start; flex: 1; min-height: 0; padding-bottom: 8px; }
		.ps-lane {
			flex: 0 0 260px; width: 260px; background: var(--theme-color-background-secondary, #f1f3f7);
			border-radius: 10px; padding: 10px; display: flex; flex-direction: column;
		}
		.ps-lane-head {
			display: flex; align-items: center; justify-content: space-between;
			font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;
			color: var(--theme-color-text-secondary, #5b6376); padding: 4px 6px 10px;
		}
		.ps-lane-name { display: inline-flex; align-items: center; }
		.ps-lane-dot { display: inline-block; width: 10px; height: 10px; border-radius: 3px; margin-right: 7px; flex: 0 0 auto; }
		.ps-lane-count {
			background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376);
			border-radius: 999px; padding: 1px 8px; font-size: 12px;
		}
		.ps-lane-cards { display: flex; flex-direction: column; gap: 8px; min-height: 40px; }
		/* The overflow footer: what is not shown, and the way to show it. A ruled block rather than a
		   button spanning the lane, so it reads as a note at the foot of the column and never looks
		   like another card to drag. */
		.ps-lane-more {
			margin-top: 8px; width: 100%; padding: 6px 8px; display: flex; align-items: center; gap: 8px;
			background: var(--theme-color-background-panel, #fff);
			border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 8px;
		}
		.ps-lane-more-count {
			flex: 1; min-width: 0; font-size: 12px; font-variant-numeric: tabular-nums;
			color: var(--theme-color-text-muted, #8a93a6);
			overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
		}
		.ps-lane-more-btn {
			flex: 0 0 auto; font-size: 11.5px; font-weight: 600; padding: 3px 9px; cursor: pointer;
			color: var(--theme-color-text-secondary, #5b6376); background: transparent;
			border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px;
		}
		.ps-lane-more-btn:hover { border-color: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-brand-primary, #2988df); }
		.ps-lane.ps-lane-dragover { background: var(--theme-color-background-hover, #e4e9f2); outline: 2px dashed var(--theme-color-brand-primary, #2988df); outline-offset: -2px; }
		.ps-card-dragging { opacity: 0.45; }
		.ps-card-placeholder {
			border: 2px dashed var(--theme-color-brand-primary, #2988df); border-radius: 8px;
			background: var(--theme-color-background-hover, rgba(41,136,223,0.10)); min-height: 42px;
			box-sizing: border-box; pointer-events: none;
		}
		.ps-card {
			background: var(--theme-color-background-panel, #fff); border-radius: 8px; padding: 10px 12px;
			border-left: 3px solid var(--theme-color-border-default, #d8dde6); cursor: grab;
			box-shadow: 0 1px 2px rgba(0,0,0,0.06);
		}
		.ps-card:active { cursor: grabbing; }
		.ps-card-feature { border-left-color: var(--theme-color-brand-primary, #2988df); }
		.ps-card-workitem { border-left-color: var(--theme-color-brand-secondary, #d99366); }
		.ps-card-row { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 6px; }
		.ps-card-check { margin: 2px 0 0; flex: 0 0 auto; cursor: pointer; }
		.ps-card-feature .ps-card-check { display: none; } /* v1 bulk acts on WorkItems only */
		.ps-card-selected { outline: 2px solid var(--theme-color-brand-primary, #2988df); outline-offset: -1px; }
		.ps-card-title { font-size: 14px; color: var(--theme-color-text-primary, #2c3140); }
		.ps-card-row .ps-card-title { margin-bottom: 0; }
		.ps-card-meta { display: flex; gap: 6px; flex-wrap: wrap; }
		.ps-bulk-bar {
			position: absolute; left: 50%; transform: translateX(-50%); bottom: 18px; z-index: 40;
			display: flex; align-items: center; gap: 10px; max-width: calc(100% - 32px);
			background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140);
			border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 10px;
			padding: 8px 12px; box-shadow: 0 6px 24px rgba(0,0,0,0.18);
		}
		.ps-bulk-count { font-weight: 700; font-size: 13px; white-space: nowrap; }
		.ps-bulk-note { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-bulk-spacer { flex: 1 1 auto; min-width: 4px; }
		.ps-bulk-select { font-size: 13px; padding: 4px 6px; border-radius: 6px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: inherit; }
		.ps-bulk-archive { color: var(--theme-color-status-danger, #c0392b); }
		.ps-bulk-confirm { font-weight: 700; }
		.ps-card-kind, .ps-card-pri {
			font-size: 11px; padding: 1px 7px; border-radius: 999px;
			background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #5b6376);
		}
		.ps-card-pri:empty, .ps-card-kind:empty { display: none; }
		.ps-card-review { display: flex; gap: 6px; margin-top: 8px; }
		.ps-card-review-btn { flex: 1 1 auto; padding: 3px 6px; font-size: 11px; font-weight: 600; border-radius: 4px; border: 1px solid var(--theme-color-border-default,#d8dde6); background: var(--theme-color-surface-raised,#fff); color: var(--theme-color-text-secondary,#5b6376); cursor: pointer; }
		.ps-card-review-btn:hover { border-color: var(--theme-color-brand-primary,#2988df); }
		.ps-card-review-pass:hover { border-color: #3fae6b; color: #3fae6b; }
		.ps-card-review-fail:hover { border-color: #d0555b; color: #d0555b; }
		/* A card is the shared title block, relaxed: it keeps the designator cell and the rule, but the
		   cells underneath breathe rather than being hard drawing furniture at forty cards a lane. */
		.ps-card .ps-mark { border: 0; background: transparent; }
		/* The cell padding is title-block furniture: a ruled box needs breathing room inside its rules.
		   A card's mark has no rule and no fill, so that padding is vestigial -- and the 4px on top was
		   pushing the first line of text down until a 13px checkbox sat 4px above its optical centre,
		   which is what read as misaligned. Dropping it lands the checkbox within 0.3px of the text
		   centre with no magic number, and takes 4px off every card while it is at it. */
		.ps-card .ps-mark-d { border-right: 0; background: transparent; padding-top: 0; padding-left: 0;
			color: var(--theme-color-brand-primary, #3b6fd4); }
		/* One line, however long the title runs (WI #370): a title's length used to decide the card's
		   height, so a lane mixing a short title with a full-sentence one read as two different kinds
		   of card instead of one even stream. The full text is not lost -- it is still the first thing
		   in the hover tooltip (see _tooltipHTML) -- so clipping the card to a single line trades away
		   only the part that was making the board hard to scan. */
		.ps-card .ps-mark-t { padding-top: 0; padding-left: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.ps-card .ps-mark { align-items: center; }
		.ps-card .ps-mark-d { display: block; }
		/* The mark is the only clickable spot left on the card (see the Board-Card template comment) --
		   everything else is drag surface and the checkbox. cursor:pointer plus a dotted underline on
		   hover is the affordance that tells you which part of the card is a link, since the rest of it
		   no longer is. */
		.ps-card .ps-card-nav { cursor: pointer; }
		.ps-card .ps-card-nav:hover .ps-mark-t { text-decoration: underline dotted; text-underline-offset: 2px; }
		.ps-card .ps-cells { margin-top: 6px; }
		/* Four cells across a kanban lane is about 40px each, which elides the values worth reading
		   (Innovation, Enhancement, a person's name). A title block wraps its cells rather than
		   shrinking them, so these wrap two-up: same four facts, roughly double the width, one extra
		   line of height. Anything narrower was showing "Innovati..." and calling it information.
		   A grid, not a flex basis: the cells carry padding and the app has no global border-box, so a
		   percentage basis silently overflows and drops every cell onto its own row instead. */
		.ps-card .ps-cells { display: grid; grid-template-columns: 1fr 1fr; }
		.ps-card .ps-cell { flex: none; min-width: 0; }
		.ps-card .ps-cell:nth-child(2n) { border-right: 0; }
		.ps-card .ps-cell:nth-child(n+3) { border-top: 1px solid var(--theme-color-border-light, #dfd7c4); }
		/* By and For sit blank on most cards -- Type and Priority carry the reading, so those two rows
		   are hidden until "Expanded" is switched on. CSS-only (data-board-expanded on the root), so
		   flipping it never re-renders a single card. */
		#ps-board-root:not([data-board-expanded="1"]) .ps-card .ps-cell[data-k="By"],
		#ps-board-root:not([data-board-expanded="1"]) .ps-card .ps-cell[data-k="For"] { display: none; }
		.ps-board-expand-btn.is-active { background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; }
	` + libMarkup.MarkupCSS,
	Templates:
	[
		// The mark, shared with every other surface. Spread first so a view-local template of the same
		// hash would win, which is the override seam if the board ever needs a one-off.
		...libMarkup.MarkupTemplates,
		{
			Hash: 'Board-Display',
			Template: /*html*/`
<div class="ps-page-bleed ps-board" id="ps-board-root" data-board-expanded="0">
	<div class="ps-board-head">
		<h2>Board</h2>
		<div class="ps-board-head-actions">
			<button class="ps-btn ps-btn-sm ps-board-expand-btn" id="ps-board-expand-btn" title="Show the By / For fields on every card" onclick="_Pict.views['Plansheet-Board'].toggleExpanded()">Expand</button>
			<button class="ps-btn" onclick="_Pict.views['Plansheet-Board'].refresh()">Refresh</button>
		</div>
	</div>
	{~TS:Board-FilterBar:AppData.Board.FilterBarSlot~}
	<div class="ps-board-lanes" id="ps-board-lanes">{~TS:Board-Lane:AppData.Board.Lanes~}</div>
</div>`
		},
		{
			Hash: 'Board-Lane',
			Template: /*html*/`
<div class="ps-lane" ondragover="_Pict.views['Plansheet-Board'].allowDrop(event)" ondragleave="_Pict.views['Plansheet-Board'].dragLeave(event)" ondrop="_Pict.views['Plansheet-Board'].drop(event,'{~D:Record.Key~}')">
	<div class="ps-lane-head"><span class="ps-lane-name"><span class="ps-lane-dot" style="background:{~D:Record.Color~}"></span>{~D:Record.Label~}</span><span class="ps-lane-count">{~D:Record.Count~}</span></div>
	<div class="ps-lane-cards">{~TS:Board-Card:Record.RenderCards~}</div>
	{~TS:Board-Lane-More:Record.MoreSlot~}
</div>`
		},
		{
			Hash: 'Board-Lane-More',
			Template: /*html*/`
<div class="ps-lane-more">
	<span class="ps-lane-more-count">{~D:Record.Label~}</span>
	<button class="ps-lane-more-btn" onclick="_Pict.views['Plansheet-Board'].laneMore('{~D:Record.Key~}','{~D:Record.Action~}')">{~D:Record.Button~}</button>
</div>`
		},
		{
			Hash: 'Board-Card',
			// Only the mark (the designator + title at the top) navigates -- the rest of the card is
			// for dragging and the checkbox, not a link. The whole card used to carry the
			// click-to-open handler, so missing the checkbox by even a pixel (its corners are
			// rounded, so the real hit target is smaller than it looks) bounced you to the detail
			// view instead of selecting the card, and getting back meant re-finding your place on
			// the board. ps-card-nav is the hover affordance (dotted underline) marking the one spot
			// that is actually a link.
			Template: /*html*/`
<div class="ps-card {~D:Record.KindClass~}" data-number="{~D:Record.Number~}" data-id="{~D:Record.ID~}" draggable="true" ondragstart="_Pict.views['Plansheet-Board'].dragStart(event,'{~D:Record.CardKind~}',{~D:Record.ID~})" ondragend="_Pict.views['Plansheet-Board'].dragEnd(event)">
	<div class="ps-card-row">
		<input type="checkbox" class="ps-card-check" title="Select" onclick="_Pict.views['Plansheet-Board'].toggleSelect(event,{~D:Record.Number~})">
		<div class="ps-mark ps-card-nav {~D:Record.KindClass~}" title="Open" onclick="_Pict.views['Plansheet-Board'].openCard('{~D:Record.CardKind~}',{~D:Record.ID~})"><span class="ps-mark-d">{~D:Record.Designator~}</span><span class="ps-mark-t">{~D:Record.Title~}</span></div>
	</div>
	<div class="ps-cells">{~TS:Markup-Cell:Record.Cells~}</div>
	{~TS:Board-Card-Review:Record.ReviewSlot~}
</div>`
		},
		{
			Hash: 'Board-Card-Review',
			Template: /*html*/`
<div class="ps-card-review">
	<button class="ps-card-review-btn ps-card-review-pass" title="Passed review -> Done" onclick="_Pict.views['Plansheet-Board'].reviewPass(event,{~D:Record.ID~})">Passed</button>
	<button class="ps-card-review-btn ps-card-review-fail" title="Did not pass QC -> send back for rework" onclick="_Pict.views['Plansheet-Board'].reviewFail(event,{~D:Record.ID~})">Send back</button>
</div>`
		},
		{
			Hash: 'Board-FilterBar',
			Template: /*html*/`
<div class="ps-filterbar">
	<div class="ps-filter-row">
		<input type="search" class="ps-filter-search" placeholder="Search cards..." value="{~D:Record.SearchValue~}" oninput="_Pict.views['Plansheet-Board'].setSearch(this.value)">
		<select class="ps-filter-select ps-filter-views" onchange="_Pict.views['Plansheet-Board'].applyView(this.value)">{~TS:Board-Filter-Option:Record.ViewOptions~}</select>
		<select class="ps-filter-select" onchange="_Pict.views['Plansheet-Board'].setFilter('type', this.value)">{~TS:Board-Filter-Option:Record.TypeOptions~}</select>
		<select class="ps-filter-select" onchange="_Pict.views['Plansheet-Board'].setFilter('priority', this.value)">{~TS:Board-Filter-Option:Record.PriorityOptions~}</select>
		<select class="ps-filter-select" onchange="_Pict.views['Plansheet-Board'].setFilter('assignee', this.value)">{~TS:Board-Filter-Option:Record.AssigneeOptions~}</select>
		<select class="ps-filter-select" onchange="_Pict.views['Plansheet-Board'].setFilter('recent', this.value)">{~TS:Board-Filter-Option:Record.RecentOptions~}</select>
		<select class="ps-filter-select" onchange="_Pict.views['Plansheet-Board'].setFilter('wfstatus', this.value)">{~TS:Board-Filter-Option:Record.WorkflowStatusOptions~}</select>
		<button class="ps-btn ps-btn-sm" onclick="_Pict.views['Plansheet-Board'].saveView()">Save view</button>
		{~TS:Board-Filter-DeleteView:Record.DeleteViewSlot~}
		{~TS:Board-Filter-Clear:Record.ClearSlot~}
		<span class="ps-filter-spacer"></span>
		<span class="ps-filter-count" id="ps-board-count">{~D:Record.CountLabel~}</span>
	</div>
</div>`
		},
		{ Hash: 'Board-Filter-Option', Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>` },
		{ Hash: 'Board-Filter-Clear', Template: /*html*/`<button class="ps-btn ps-btn-sm" onclick="_Pict.views['Plansheet-Board'].clearFilters()">Clear</button>` },
		{ Hash: 'Board-Filter-DeleteView', Template: /*html*/`<button class="ps-btn ps-btn-sm ps-btn-danger" onclick="_Pict.views['Plansheet-Board'].deleteView('{~D:Record.Key~}')">Delete view</button>` }
	],
	Renderables:
	[
		{
			RenderableHash: 'Board-Display',
			TemplateHash: 'Board-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../EntityDescriptors.js":555,"../FocusFilters.js":558,"./Markup-Templates.js":650,"pict-view":365}],658:[function(require,module,exports){
'use strict';

/**
 * BookmarksPage -- the full-page view of the caller's bookmarks + browsing history, rendered into
 * the main workspace (#Plansheet-Workspace) rather than the notebook rail. It reuses the same
 * per-user data the notebook rail loads (providers.NotebookAPI.loadNotebook -> AppData.Notebook),
 * but keeps its own render/view state under AppData.BookmarksPage so the rail notebook and this page
 * never fight over the same buffer.
 *
 * Two sections: Favorites (pinned pages, each removable) and History (the last pages visited). Both
 * carry a compact "how long ago" age (2h, 3d, 5mo, 1y) that is shrink-proof so it never wraps a row
 * at phone width. Template-driven per the Pict conventions: onBeforeRender derives the slots into
 * AppData, the templates iterate them with {~TS:~}, and every action mutates + re-shows.
 */

const libPictView = require('pict-view');

class PictViewBookmarksPage extends libPictView
{
	_notebook() { return this.pict.AppData.Notebook || {}; }
	_page() { return this.pict.AppData.BookmarksPage || (this.pict.AppData.BookmarksPage = {}); }
	_api() { return this.pict.providers.NotebookAPI; }

	// Load (or refresh) the caller's notebook data, then repaint the page.
	show()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.loadNotebook !== 'function') { this.render(); return; }
		return tmpAPI.loadNotebook().then(() => this.render()).catch(() => this.render());
	}

	// Parse a server timestamp to epoch ms (best effort).
	_ms(pValue)
	{
		if (!pValue) { return 0; }
		let tmpMs = Date.parse(String(pValue).replace(' ', 'T'));
		return isNaN(tmpMs) ? 0 : tmpMs;
	}

	// A compact "how long ago" label (now, 5m, 3h, 2d, 4mo, 1y). Short by design so it never forces
	// the row to wrap at narrow / phone width.
	_ago(pValue)
	{
		let tmpMs = this._ms(pValue);
		if (!tmpMs) { return ''; }
		let tmpSec = Math.max(0, Math.floor((Date.now() - tmpMs) / 1000));
		if (tmpSec < 60) { return 'now'; }
		let tmpMin = Math.floor(tmpSec / 60);
		if (tmpMin < 60) { return tmpMin + 'm'; }
		let tmpHr = Math.floor(tmpMin / 60);
		if (tmpHr < 24) { return tmpHr + 'h'; }
		let tmpDay = Math.floor(tmpHr / 24);
		if (tmpDay < 30) { return tmpDay + 'd'; }
		let tmpMon = Math.floor(tmpDay / 30);
		if (tmpMon < 12) { return tmpMon + 'mo'; }
		return Math.floor(tmpMon / 12) + 'y';
	}

	onBeforeRender(pRenderable)
	{
		let tmpNB = this._notebook();
		let tmpPage = this._page();

		tmpPage.FavRows = (tmpNB.Favorites || []).map((pB) => ({ IDBookmark: pB.IDBookmark, Label: pB.Label, Route: pB.Route, Age: this._ago(pB.CreateDate) }));
		tmpPage.RecentRows = (tmpNB.Recent || []).slice(0, 10).map((pR) => ({ Route: pR.Route, Label: pR.Label, Age: this._ago(pR.ViewedAt), CountLabel: pR.Count > 0 ? String(pR.Count) : '' }));
		// Trending mirrors the notebook rail: the caller's most-visited pages in the window, with a visit count.
		tmpPage.TrendRows = (tmpNB.Trending || []).slice(0, 10).map((pT) => ({ Route: pT.Route, Label: pT.Label, Count: pT.Count }));

		// One-or-zero-element slots drive the section body vs. its empty state (the pict conditional pattern).
		tmpPage.FavSlot = tmpPage.FavRows.length ? [1] : [];
		tmpPage.FavEmpty = tmpPage.FavRows.length ? [] : [1];
		tmpPage.RecentSlot = tmpPage.RecentRows.length ? [1] : [];
		tmpPage.RecentEmpty = tmpPage.RecentRows.length ? [] : [1];
		tmpPage.TrendSlot = tmpPage.TrendRows.length ? [1] : [];
		tmpPage.TrendEmpty = tmpPage.TrendRows.length ? [] : [1];

		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	go(pRoute)
	{
		if (typeof window === 'undefined') { return; }
		window.location.hash = '#' + String(pRoute || '/').replace(/^#/, '');
	}

	removeBookmark(pID)
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.deleteBookmark !== 'function') { return; }
		tmpAPI.deleteBookmark(pID).then(() => this.show()).catch(() => {});
	}
}

module.exports = PictViewBookmarksPage;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-BookmarksPage',
	DefaultRenderable: 'Plansheet-BookmarksPage',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-bmpage.ps-page { color: var(--theme-color-text-primary, #1d2230); }
		.ps-bmpage-head { display: flex; align-items: center; gap: 12px; margin: 0 0 18px; }
		.ps-bmpage-head h2 { font-size: 22px; font-weight: 600; margin: 0; color: var(--theme-color-text-primary, #1f2430); }
		.ps-bmpage-section { margin: 0 0 26px; }
		.ps-bmpage-section-title { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em;
			color: var(--theme-color-text-secondary, #8a93a6); margin: 0 2px 8px; }
		.ps-bmpage-list { display: flex; flex-direction: column; gap: 2px; }
		.ps-bmpage-row { display: flex; align-items: center; gap: 8px; padding: 7px 10px; border-radius: 8px; }
		.ps-bmpage-row:hover { background: var(--theme-color-background-hover, #eef1f6); }
		.ps-bmpage-link { flex: 1 1 auto; min-width: 0; font-size: 14px; cursor: pointer;
			color: var(--theme-color-brand-primary, #3b6fd4); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-bmpage-link:hover { text-decoration: underline; }
		/* Compact age -- fixed, tiny, tabular, shrink-proof so it never wraps a row on a phone. */
		.ps-bmpage-age { flex: 0 0 auto; font-size: 10px; color: var(--theme-color-text-secondary, #8a93a6); font-variant-numeric: tabular-nums; white-space: nowrap; }
		/* Trending visit count -- a small pill, same shrink-proof footprint as the age. */
		.ps-bmpage-count { flex: 0 0 auto; min-width: 20px; text-align: center; font-size: 10px; font-weight: 600; line-height: 16px;
			padding: 0 6px; border-radius: 9px; color: var(--theme-color-text-secondary, #8a93a6);
			background: var(--theme-color-background-hover, #eef1f6); font-variant-numeric: tabular-nums; white-space: nowrap; }
		/* History visit-count pill: hidden when CountLabel is '' (page not visited within the trending window). */
		.ps-bmpage-count-recent:empty { display: none; }
		.ps-bmpage-x { flex: 0 0 auto; width: 24px; height: 24px; border: none; border-radius: 6px; background: transparent;
			color: var(--theme-color-text-secondary, #8a93a6); cursor: pointer; font-size: 16px; line-height: 1;
			display: flex; align-items: center; justify-content: center; }
		.ps-bmpage-x:hover { background: var(--theme-color-background-hover, #e0e5ee); color: var(--theme-color-status-error, #cc3333); }
		.ps-bmpage-empty { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 14px; padding: 8px 2px; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-BookmarksPage',
			Template: /*html*/`
<div class="ps-page ps-bmpage">
	<div class="ps-bmpage-head">
		<h2>Bookmarks</h2>
	</div>
	<div class="ps-bmpage-section">
		<div class="ps-bmpage-section-title">Favorites</div>
		{~TS:BookmarksPage-FavList:AppData.BookmarksPage.FavSlot~}
		{~TS:BookmarksPage-FavEmpty:AppData.BookmarksPage.FavEmpty~}
	</div>
	<div class="ps-bmpage-section">
		<div class="ps-bmpage-section-title">History</div>
		{~TS:BookmarksPage-RecentList:AppData.BookmarksPage.RecentSlot~}
		{~TS:BookmarksPage-RecentEmpty:AppData.BookmarksPage.RecentEmpty~}
	</div>
	<div class="ps-bmpage-section">
		<div class="ps-bmpage-section-title">Trending</div>
		{~TS:BookmarksPage-TrendList:AppData.BookmarksPage.TrendSlot~}
		{~TS:BookmarksPage-TrendEmpty:AppData.BookmarksPage.TrendEmpty~}
	</div>
</div>`
		},
		{
			Hash: 'BookmarksPage-FavList',
			Template: /*html*/`<div class="ps-bmpage-list">{~TS:BookmarksPage-FavRow:AppData.BookmarksPage.FavRows~}</div>`
		},
		{
			Hash: 'BookmarksPage-FavRow',
			Template: /*html*/`<div class="ps-bmpage-row"><a class="ps-bmpage-link" onclick="_Pict.views['Plansheet-BookmarksPage'].go('{~D:Record.Route~}')">{~D:Record.Label~}</a><span class="ps-bmpage-age" title="Bookmarked">{~D:Record.Age~}</span><button class="ps-bmpage-x" title="Remove" onclick="_Pict.views['Plansheet-BookmarksPage'].removeBookmark({~D:Record.IDBookmark~})">&times;</button></div>`
		},
		{
			Hash: 'BookmarksPage-FavEmpty',
			Template: /*html*/`<p class="ps-bmpage-empty">No favorites yet. Pin a page from the notebook to keep it here.</p>`
		},
		{
			Hash: 'BookmarksPage-RecentList',
			Template: /*html*/`<div class="ps-bmpage-list">{~TS:BookmarksPage-RecentRow:AppData.BookmarksPage.RecentRows~}</div>`
		},
		{
			Hash: 'BookmarksPage-RecentRow',
			Template: /*html*/`<div class="ps-bmpage-row"><a class="ps-bmpage-link" onclick="_Pict.views['Plansheet-BookmarksPage'].go('{~D:Record.Route~}')">{~D:Record.Label~}</a><span class="ps-bmpage-count ps-bmpage-count-recent" title="Recent visits">{~D:Record.CountLabel~}</span><span class="ps-bmpage-age" title="Last visited">{~D:Record.Age~}</span></div>`
		},
		{
			Hash: 'BookmarksPage-RecentEmpty',
			Template: /*html*/`<p class="ps-bmpage-empty">No history yet. Pages you visit show up here.</p>`
		},
		{
			Hash: 'BookmarksPage-TrendList',
			Template: /*html*/`<div class="ps-bmpage-list">{~TS:BookmarksPage-TrendRow:AppData.BookmarksPage.TrendRows~}</div>`
		},
		{
			Hash: 'BookmarksPage-TrendRow',
			Template: /*html*/`<div class="ps-bmpage-row"><a class="ps-bmpage-link" onclick="_Pict.views['Plansheet-BookmarksPage'].go('{~D:Record.Route~}')">{~D:Record.Label~}</a><span class="ps-bmpage-count" title="Visits in the last few days">{~D:Record.Count~}</span></div>`
		},
		{
			Hash: 'BookmarksPage-TrendEmpty',
			Template: /*html*/`<p class="ps-bmpage-empty">Nothing trending yet. Your most-visited pages will show up here.</p>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-BookmarksPage',
			TemplateHash: 'Plansheet-BookmarksPage',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"pict-view":365}],659:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * CallDesk -- the support intake surface. Pick a customer, see its contacts and recent calls, log a
 * new call, and turn a call into an Issue or a Feedback record (the spawn carries the call's customer
 * + contact onto the new record, server-side). Calls and contacts are plain entities (CallAPI /
 * ContactAPI auto-CRUD); the two spawn routes are CallDeskAPI. Lists are filtered to the chosen
 * customer client-side, which is plenty for support volumes.
 */
class PictViewCallDesk extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._customerID = 0;
	}

	_router() { return this.pict.providers['Pict-Router']; }
	_val(pID) { let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pID) : null; return tmpEl ? String(tmpEl.value || '') : ''; }

	// Load the customer list, then shape + paint. Contacts/calls load when a customer is chosen.
	show()
	{
		let tmpCustAPI = this.pict.providers.KeystoneCustomerAPI;
		if (!tmpCustAPI) { return Promise.resolve(); }
		return tmpCustAPI.list().then(() => { this._shape(); this.render(); });
	}

	/**
	 * Choose the customer whose desk is on screen. NAVIGATES; the route handler renders.
	 *
	 * Picking a customer swaps in that customer's entire working surface -- their contacts, the
	 * add-contact row, the log-a-call form and their call history. None of it could be linked or
	 * returned to, because the whole thing lived in _customerID and never reached the URL.
	 *
	 * The render is _applySelectCustomer, which the route handler calls. This must NOT call that
	 * directly and it must NOT call this, or the route loops.
	 */
	selectCustomer(pIDStr)
	{
		let tmpID = parseInt(pIDStr, 10) || 0;
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showCallDeskCustomer === 'function' && tmpApp.showCallDeskCustomer(tmpID)) { return; }
		return this._applySelectCustomer(tmpID);
	}

	// The render half. Also the entry the /call-desk/:id route lands on.
	_applySelectCustomer(pID)
	{
		this._customerID = parseInt(pID, 10) || 0;
		if (!this._customerID) { this._shape(); this.render(); return; }
		return Promise.all([this.pict.providers.ContactAPI.list(), this.pict.providers.CallAPI.list()])
			.then(() => { this._shape(); this.render(); })
			.catch(() => { this._shape(); this.render(); });
	}

	// Entered from the route with a customer already named: load the customer list first, then that
	// customer's desk, so a cold deep link paints the same page a click does.
	showCustomer(pID)
	{
		let tmpCustAPI = this.pict.providers.KeystoneCustomerAPI;
		if (!tmpCustAPI) { return Promise.resolve(); }
		return tmpCustAPI.list().then(() => this._applySelectCustomer(pID));
	}

	// A reload of the current desk is a render, not a navigation -- the URL already says this.
	reload() { return this._applySelectCustomer(this._customerID); }

	_shape()
	{
		let tmpCustomers = ((this.pict.AppData.Entities && this.pict.AppData.Entities.KeystoneCustomer) || {}).List || [];
		let tmpContacts = ((this.pict.AppData.Entities && this.pict.AppData.Entities.Contact) || {}).List || [];
		let tmpCalls = ((this.pict.AppData.Entities && this.pict.AppData.Entities.Call) || {}).List || [];
		let tmpID = this._customerID;

		let tmpMyContacts = tmpContacts.filter((pC) => (pC.IDKeystoneCustomer || 0) === tmpID);
		let tmpMyCalls = tmpCalls.filter((pC) => (pC.IDKeystoneCustomer || 0) === tmpID)
			.sort((pA, pB) => Date.parse(pB.CallDate || pB.CreateDate || 0) - Date.parse(pA.CallDate || pA.CreateDate || 0));
		this._myCalls = tmpMyCalls;
		let tmpSelected = tmpCustomers.filter((pC) => pC.IDKeystoneCustomer === tmpID)[0] || null;

		this.pict.AppData.CallDesk =
		{
			Customers: tmpCustomers.map((pC) => ({ IDKeystoneCustomer: pC.IDKeystoneCustomer, Name: pC.Name || ('Customer ' + pC.IDKeystoneCustomer), Sel: (pC.IDKeystoneCustomer === tmpID) ? 'selected' : '' })),
			HasCustomer: !!tmpID,
			CustomerName: tmpSelected ? (tmpSelected.Name || '') : '',
			Contacts: tmpMyContacts.map((pC) => ({ IDContact: pC.IDContact, Name: pC.Name || '', Kind: pC.Kind || 'Person', Email: pC.Email || '' })),
			ContactOptions: tmpMyContacts.map((pC) => ({ IDContact: pC.IDContact, Name: (pC.Name || '') + (pC.Kind ? (' (' + pC.Kind + ')') : '') })),
			Calls: tmpMyCalls.map((pC) => ({ IDCall: pC.IDCall, CallLabel: (pC.CallNumber ? ('#' + pC.CallNumber + ' ') : '') + (pC.Subject || '(no subject)'), Channel: pC.Channel || '', Direction: pC.Direction || '', When: pC.CallDate ? String(pC.CallDate).slice(0, 10) : '' })),
			ContactsEmpty: tmpMyContacts.length ? [] : [{ Message: 'No contacts yet. Add the person, shop, or reader you talk to.' }],
			CallsEmpty: tmpMyCalls.length ? [] : [{ Message: 'No calls logged for this customer yet.' }],
			PickPrompt: tmpID ? [] : [{ Message: 'Pick a customer to see their contacts and calls, and to log one.' }],
			BodySlot: tmpID ? [{}] : []
		};
	}

	addContact()
	{
		if (!this._customerID) { return; }
		let tmpName = this._val('cd-contact-name').trim();
		if (!tmpName) { return; }
		let tmpRecord = { IDKeystoneCustomer: this._customerID, Name: tmpName, Kind: this._val('cd-contact-kind') || 'Person', Email: this._val('cd-contact-email').trim() };
		this.pict.providers.ContactAPI.create(tmpRecord).then(() => this.reload()).catch(() => { /* ignore */ });
	}

	saveCall()
	{
		if (!this._customerID) { return; }
		let tmpSubject = this._val('cd-call-subject').trim();
		if (!tmpSubject) { return; }
		let tmpRecord =
		{
			IDKeystoneCustomer: this._customerID,
			IDContact: parseInt(this._val('cd-call-contact'), 10) || 0,
			Channel: this._val('cd-call-channel') || 'Phone',
			Direction: this._val('cd-call-direction') || 'Inbound',
			Subject: tmpSubject,
			Notes: this._val('cd-call-notes'),
			CallDate: (new Date()).toISOString()
		};
		this.pict.providers.CallAPI.create(tmpRecord).then(() => this.reload()).catch(() => { /* ignore */ });
	}

	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_esc(pStr) { return String(pStr).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh])); }
	_callSubject(pCallID) { let tmpCall = (this._myCalls || []).find((pC) => pC.IDCall === pCallID) || {}; return tmpCall.Subject || ''; }
	_field(pLabel, pControl) { return '<div style="margin-bottom:9px;"><label style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);">' + pLabel + '</label>' + pControl + '</div>'; }

	// Turn a call into an issue: a small form sets the type, priority, and severity (title prefilled
	// from the call), then spawn carries the call's customer + contact onto the new issue server-side.
	makeIssue(pCallID)
	{
		let tmpModal = this._modal();
		let tmpRouter = this._router();
		if (!tmpModal || typeof tmpModal.show !== 'function') { return this.pict.providers.CallDeskAPI.spawnIssue(pCallID, {}).then((pR) => { if (pR && pR.IDIssue && tmpRouter) { tmpRouter.navigate('/issue/' + pR.IDIssue); } }); }
		let tmpStyle = 'width:100%;box-sizing:border-box;padding:6px 8px;font:inherit;margin-top:2px;';
		let fSel = (pVals, pDefault) => pVals.map((pV) => '<option' + (pV === pDefault ? ' selected' : '') + '>' + pV + '</option>').join('');
		this.pict.providers.IssueTypeAPI.list().then((pTypes) =>
		{
			let tmpTypeOpts = '<option value="0">(no type)</option>' + (pTypes || []).map((pT) => '<option value="' + pT.IDIssueType + '">' + this._esc(pT.Name) + '</option>').join('');
			tmpModal.show(
			{
				title: 'New issue from call',
				content:
					this._field('Title', '<input id="cd-issue-title" type="text" style="' + tmpStyle + '" value="' + this._esc(this._callSubject(pCallID)) + '">') +
					this._field('Type', '<select id="cd-issue-type" style="' + tmpStyle + '">' + tmpTypeOpts + '</select>') +
					this._field('Priority', '<select id="cd-issue-priority" style="' + tmpStyle + '">' + fSel(['Low', 'Normal', 'High', 'Urgent'], 'Normal') + '</select>') +
					this._field('Severity', '<select id="cd-issue-severity" style="' + tmpStyle + '"><option value="">(none)</option>' + fSel(['Minor', 'Major', 'Critical'], '') + '</select>'),
				buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Create issue', Style: 'primary' }]
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let fVal = (pID) => { let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pID) : null; return tmpEl ? tmpEl.value : ''; };
				let tmpDraft = { Title: fVal('cd-issue-title').trim(), IDIssueType: parseInt(fVal('cd-issue-type'), 10) || 0, Priority: fVal('cd-issue-priority') || 'Normal', Severity: fVal('cd-issue-severity') };
				this.pict.providers.CallDeskAPI.spawnIssue(pCallID, tmpDraft).then((pResult) =>
				{
					if (pResult && pResult.IDIssue && tmpRouter) { tmpRouter.navigate('/issue/' + pResult.IDIssue); }
				}).catch(() => { /* ignore */ });
			});
		});
	}

	// Turn a call into a feedback record: a small form sets the narrative and the three likert scores.
	makeFeedback(pCallID)
	{
		let tmpModal = this._modal();
		let tmpRouter = this._router();
		if (!tmpModal || typeof tmpModal.show !== 'function') { return this.pict.providers.CallDeskAPI.spawnFeedback(pCallID, {}).then((pR) => { if (pR && pR.IDFeedback && tmpRouter) { tmpRouter.navigate('/feedback/' + pR.IDFeedback); } }); }
		let tmpStyle = 'width:100%;box-sizing:border-box;padding:6px 8px;font:inherit;margin-top:2px;';
		let tmpScore = '<option value="0">unscored</option>' + [1, 2, 3, 4, 5].map((pN) => '<option>' + pN + '</option>').join('');
		tmpModal.show(
		{
			title: 'New feedback from call',
			content:
				this._field('Title', '<input id="cd-fb-title" type="text" style="' + tmpStyle + '" value="' + this._esc(this._callSubject(pCallID)) + '">') +
				this._field('What they said', '<textarea id="cd-fb-body" style="' + tmpStyle + 'min-height:60px;resize:vertical;"></textarea>') +
				this._field('Did what was expected', '<select id="cd-fb-s1" style="' + tmpStyle + '">' + tmpScore + '</select>') +
				this._field('Intuitive to use', '<select id="cd-fb-s2" style="' + tmpStyle + '">' + tmpScore + '</select>') +
				this._field('Enjoyed it', '<select id="cd-fb-s3" style="' + tmpStyle + '">' + tmpScore + '</select>'),
			buttons: [{ Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Create feedback', Style: 'primary' }]
		}).then((pChoice) =>
		{
			if (pChoice !== 'ok') { return; }
			let fVal = (pID) => { let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pID) : null; return tmpEl ? tmpEl.value : ''; };
			let tmpDraft = { Title: fVal('cd-fb-title').trim(), Body: fVal('cd-fb-body'), ScoreDidWhatExpected: parseInt(fVal('cd-fb-s1'), 10) || 0, ScoreIntuitive: parseInt(fVal('cd-fb-s2'), 10) || 0, ScoreEnjoyment: parseInt(fVal('cd-fb-s3'), 10) || 0 };
			this.pict.providers.CallDeskAPI.spawnFeedback(pCallID, tmpDraft).then((pResult) =>
			{
				if (pResult && pResult.IDFeedback && tmpRouter) { tmpRouter.navigate('/feedback/' + pResult.IDFeedback); }
			}).catch(() => { /* ignore */ });
		});
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewCallDesk;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-CallDesk',
	DefaultRenderable: 'CallDesk-Display',
	AutoRender: false,
	CSS: /*css*/`
		.ps-calldesk { height: 100%; display: flex; flex-direction: column; gap: 14px; overflow-y: auto; }
		.ps-cd-head { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
		.ps-cd-head h2 { font-size: 22px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; }
		.ps-cd-pick { font: inherit; font-size: 14px; padding: 6px 10px; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); min-width: 240px; }
		.ps-cd-prompt { color: var(--theme-color-text-muted, #97a1ab); font-size: 15px; padding: 30px 4px; }
		.ps-cd-cols { display: flex; gap: 16px; align-items: flex-start; flex-wrap: wrap; }
		.ps-cd-panel { flex: 1 1 340px; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 12px; padding: 16px 18px; }
		.ps-cd-panel h3 { font-size: 14px; font-weight: 700; color: var(--theme-color-text-primary, #2c3140); margin: 0 0 12px; }
		.ps-cd-field { display: flex; flex-direction: column; gap: 4px; margin-bottom: 10px; }
		.ps-cd-field label { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-cd-field input, .ps-cd-field select, .ps-cd-field textarea { font: inherit; font-size: 14px; padding: 7px 9px; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-cd-field textarea { min-height: 56px; resize: vertical; }
		.ps-cd-row3 { display: flex; gap: 8px; }
		.ps-cd-row3 > * { flex: 1; }
		.ps-cd-btn { font: inherit; font-size: 13px; border: 1px solid var(--theme-color-brand-primary, #2880a6); background: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); border-radius: 7px; padding: 7px 14px; cursor: pointer; }
		.ps-cd-btn:hover { filter: brightness(1.06); }
		.ps-cd-list { display: flex; flex-direction: column; gap: 8px; margin-top: 12px; }
		.ps-cd-contact { display: flex; align-items: baseline; gap: 8px; font-size: 14px; color: var(--theme-color-text-primary, #2c3140); padding: 5px 0; border-bottom: 1px solid var(--theme-color-border-light, #f0f3f6); }
		.ps-cd-contact .k { font-size: 11px; padding: 1px 7px; border-radius: 999px; background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #5b6376); }
		.ps-cd-contact .e { color: var(--theme-color-text-muted, #97a1ab); font-size: 12px; margin-left: auto; }
		.ps-cd-call { border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 9px; padding: 9px 11px; }
		.ps-cd-call-top { display: flex; align-items: baseline; gap: 8px; margin-bottom: 6px; }
		.ps-cd-call-subj { font-size: 14px; color: var(--theme-color-text-primary, #2c3140); }
		.ps-cd-call-meta { font-size: 11px; color: var(--theme-color-text-muted, #97a1ab); margin-left: auto; }
		.ps-cd-call-acts { display: flex; gap: 8px; }
		.ps-cd-mini { font: inherit; font-size: 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #41506a); border-radius: 6px; padding: 4px 10px; cursor: pointer; }
		.ps-cd-mini:hover { background: var(--theme-color-background-hover, #e1e7ef); }
		.ps-cd-empty { color: var(--theme-color-text-muted, #97a1ab); font-size: 13px; padding: 8px 0; }
		.ps-cd-addrow { display: flex; gap: 8px; align-items: flex-end; margin-top: 10px; flex-wrap: wrap; }
		.ps-cd-addrow .ps-cd-field { margin-bottom: 0; }
	`,
	Templates:
	[
		{
			Hash: 'CallDesk-Display',
			Template: /*html*/`
<div class="ps-page ps-calldesk">
	<div class="ps-cd-head">
		<h2>Call Desk</h2>
		<select class="ps-cd-pick" onchange="_Pict.views['Plansheet-CallDesk'].selectCustomer(this.value)">
			<option value="0">Choose a customer...</option>
			{~TS:CallDesk-CustomerOption:AppData.CallDesk.Customers~}
		</select>
	</div>
	{~TS:CallDesk-Prompt:AppData.CallDesk.PickPrompt~}
	{~TS:CallDesk-Body:AppData.CallDesk.BodySlot~}
</div>`
		},
		{
			Hash: 'CallDesk-CustomerOption',
			Template: /*html*/`<option value="{~D:Record.IDKeystoneCustomer~}" {~D:Record.Sel~}>{~D:Record.Name~}</option>`
		},
		{
			Hash: 'CallDesk-Prompt',
			Template: /*html*/`<div class="ps-cd-prompt">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'CallDesk-Body',
			Template: /*html*/`
<div class="ps-cd-cols">
	<div class="ps-cd-panel">
		<h3>Contacts at {~D:AppData.CallDesk.CustomerName~}</h3>
		<div class="ps-cd-list">
			{~TS:CallDesk-Contact:AppData.CallDesk.Contacts~}
			{~TS:CallDesk-Empty:AppData.CallDesk.ContactsEmpty~}
		</div>
		<div class="ps-cd-addrow">
			<div class="ps-cd-field"><label>Name</label><input id="cd-contact-name" type="text" placeholder="Person, shop, or reader"></div>
			<div class="ps-cd-field"><label>Kind</label><select id="cd-contact-kind"><option>Person</option><option>Shop</option><option>Reader</option><option>Org</option></select></div>
			<div class="ps-cd-field"><label>Email</label><input id="cd-contact-email" type="text" placeholder="optional"></div>
			<button class="ps-cd-mini" onclick="_Pict.views['Plansheet-CallDesk'].addContact()">Add contact</button>
		</div>
	</div>
	<div class="ps-cd-panel">
		<h3>Log a call</h3>
		<div class="ps-cd-field"><label>Contact</label><select id="cd-call-contact"><option value="0">(unspecified)</option>{~TS:CallDesk-ContactOpt:AppData.CallDesk.ContactOptions~}</select></div>
		<div class="ps-cd-row3">
			<div class="ps-cd-field"><label>Channel</label><select id="cd-call-channel"><option>Phone</option><option>Email</option><option>Chat</option><option>InPerson</option><option>Other</option></select></div>
			<div class="ps-cd-field"><label>Direction</label><select id="cd-call-direction"><option>Inbound</option><option>Outbound</option></select></div>
		</div>
		<div class="ps-cd-field"><label>Subject</label><input id="cd-call-subject" type="text" placeholder="What was the call about?"></div>
		<div class="ps-cd-field"><label>Notes</label><textarea id="cd-call-notes" placeholder="What did they say?"></textarea></div>
		<button class="ps-cd-btn" onclick="_Pict.views['Plansheet-CallDesk'].saveCall()">Save call</button>
		<div class="ps-cd-list">
			{~TS:CallDesk-Call:AppData.CallDesk.Calls~}
			{~TS:CallDesk-Empty:AppData.CallDesk.CallsEmpty~}
		</div>
	</div>
</div>`
		},
		{
			Hash: 'CallDesk-Contact',
			Template: /*html*/`<div class="ps-cd-contact"><span>{~D:Record.Name~}</span><span class="k">{~D:Record.Kind~}</span><span class="e">{~D:Record.Email~}</span></div>`
		},
		{
			Hash: 'CallDesk-ContactOpt',
			Template: /*html*/`<option value="{~D:Record.IDContact~}">{~D:Record.Name~}</option>`
		},
		{
			Hash: 'CallDesk-Call',
			Template: /*html*/`
<div class="ps-cd-call">
	<div class="ps-cd-call-top"><span class="ps-cd-call-subj">{~D:Record.CallLabel~}</span><span class="ps-cd-call-meta">{~D:Record.Channel~} {~D:Record.Direction~} {~D:Record.When~}</span></div>
	<div class="ps-cd-call-acts">
		<button class="ps-cd-mini" onclick="_Pict.views['Plansheet-CallDesk'].makeIssue({~D:Record.IDCall~})">Make an issue</button>
		<button class="ps-cd-mini" onclick="_Pict.views['Plansheet-CallDesk'].makeFeedback({~D:Record.IDCall~})">Make feedback</button>
	</div>
</div>`
		},
		{
			Hash: 'CallDesk-Empty',
			Template: /*html*/`<div class="ps-cd-empty">{~D:Record.Message~}</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'CallDesk-Display',
			TemplateHash: 'CallDesk-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"pict-view":365}],660:[function(require,module,exports){
'use strict';

/**
 * PictView-CapabilityActivation: the tenant's toggle of WHICH node is live for a capability action (V51, F153).
 *
 * A capability is the node's DECLARATION (it reports what it advertises at run); activation is the tenant's, made
 * here. For each capability action any granted node advertises, this lists the candidate nodes and lets an operator
 * pick the one that is live -- or set it to standby (none), in which case that action's dispatch holds. It reads
 * GET /1.0/NodeCapabilities and writes PUT /1.0/NodeCapabilityActivation, same-origin with the session cookie.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');

class PictViewCapabilityActivation extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._groups = [];
		this._busy = false;
	}

	_esc(pValue)
	{
		return String(pValue === null || typeof pValue === 'undefined' ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	_body() { return (typeof document !== 'undefined') ? document.getElementById('NCA-Body') : null; }
	_paint(pHTML) { let tmpBody = this._body(); if (tmpBody) { tmpBody.innerHTML = pHTML; } }

	async _fetchJSON(pMethod, pURL, pBody)
	{
		let tmpOptions = { method: pMethod, credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
		if (pBody) { tmpOptions.headers['Content-Type'] = 'application/json'; tmpOptions.body = JSON.stringify(pBody); }
		let tmpResponse = await fetch(pURL, tmpOptions);
		let tmpText = await tmpResponse.text();
		let tmpJSON = null;
		try { tmpJSON = tmpText ? JSON.parse(tmpText) : null; } catch (pError) { tmpJSON = null; }
		if (!tmpResponse.ok) { throw new Error((tmpJSON && tmpJSON.Error) || ('HTTP ' + tmpResponse.status)); }
		return tmpJSON;
	}

	// The shell renders once; every load repaints only #NCA-Body.
	show()
	{
		this.render();
		this._load();
		return true;
	}

	async _load()
	{
		this._paint('<div class="nca-loading">Loading node capabilities...</div>');
		let tmpResult = null;
		try { tmpResult = await this._fetchJSON('GET', '/1.0/NodeCapabilities'); }
		catch (pError) { this._paint('<div class="nca-empty">Could not load node capabilities (' + this._esc(pError && pError.message) + ').</div>'); return; }
		this._groups = (tmpResult && Array.isArray(tmpResult.Capabilities)) ? tmpResult.Capabilities : [];
		this._paintGroups();
	}

	_paintGroups()
	{
		if (!this._groups.length)
		{
			this._paint('<div class="nca-empty">No node capabilities yet. Start a node granted this plan sheet with a capability, and the actions it advertises show up here to activate.</div>');
			return;
		}
		let tmpParts = [];
		this._groups.forEach((pGroup, pIndex) =>
		{
			let tmpHold = !pGroup.HasActive;
			tmpParts.push('<div class="nca-group">');
			tmpParts.push('<div class="nca-group-head"><span class="nca-cap">' + this._esc(pGroup.Capability) + '</span>'
				+ '<span class="nca-act">' + this._esc(pGroup.Action) + '</span>'
				+ (tmpHold ? '<span class="nca-state nca-state-hold">no active node - work holds</span>' : '<span class="nca-state nca-state-live">live</span>') + '</div>');
			tmpParts.push('<div class="nca-cands">');
			(Array.isArray(pGroup.Candidates) ? pGroup.Candidates : []).forEach((pCandidate) =>
			{
				let tmpID = Number(pCandidate.IDNodeRegistration) || 0;
				let tmpName = this._esc(pCandidate.NodeHost || ('node #' + tmpID));
				let tmpVersion = this._esc(pCandidate.Version || '');
				tmpParts.push('<button class="nca-cand' + (pCandidate.Active ? ' nca-cand-active' : '') + '" onclick="_Pict.views[\'' + "Plansheet-CapabilityActivation" + '\'].setActive(' + pIndex + ', ' + tmpID + ')">'
					+ '<span class="nca-dot"></span><span class="nca-cand-name">' + tmpName + '</span>'
					+ (tmpVersion ? '<span class="nca-ver">v' + tmpVersion + '</span>' : '')
					+ (pCandidate.Active ? '<span class="nca-tag nca-tag-active">active</span>' : '<span class="nca-tag">standby</span>') + '</button>');
			});
			tmpParts.push('<button class="nca-cand nca-cand-none' + (tmpHold ? ' nca-cand-active' : '') + '" onclick="_Pict.views[\'' + "Plansheet-CapabilityActivation" + '\'].setActive(' + pIndex + ', 0)">'
				+ '<span class="nca-dot"></span><span class="nca-cand-name">none (standby)</span></button>');
			tmpParts.push('</div></div>');
		});
		this._paint(tmpParts.join(''));
	}

	// Set the active node for a group's (Capability, Action). IDNodeRegistration 0 = standby (no active node).
	async setActive(pGroupIndex, pIDNodeRegistration)
	{
		if (this._busy) { return; }
		let tmpGroup = this._groups[pGroupIndex];
		if (!tmpGroup) { return; }
		this._busy = true;
		try
		{
			await this._fetchJSON('PUT', '/1.0/NodeCapabilityActivation', { Capability: tmpGroup.Capability, Action: tmpGroup.Action, IDNodeRegistration: Number(pIDNodeRegistration) || 0 });
			this._toast('Activation updated.');
		}
		catch (pError) { this._toast((pError && pError.message) || 'Could not update activation.', 'error'); }
		this._busy = false;
		await this._load();
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && tmpModal.toast) { tmpModal.toast(pMessage, { type: pType || 'success' }); }
	}
}

const PictViewCapabilityActivationConfiguration =
{
	ViewIdentifier: "Plansheet-CapabilityActivation",
	DefaultRenderable: "Plansheet-CapabilityActivation",
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/'.nca-wrap { max-width: 820px; margin: 0 auto; padding: 24px 16px 64px; } .nca-head h1 { margin: 0 0 4px; font-size: 1.6em; color: var(--theme-color-text-primary, #1d2230); } .nca-sub { margin: 0 0 20px; color: var(--theme-color-text-secondary, #5b6376); } .nca-loading, .nca-empty { color: var(--theme-color-text-secondary, #5b6376); padding: 24px 0; line-height: 1.5; } .nca-group { margin-bottom: 20px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 12px; padding: 14px 16px; background: var(--theme-color-background-panel, #fff); } .nca-group-head { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; } .nca-cap { font-family: ui-monospace, Menlo, monospace; font-size: 0.9em; color: var(--theme-color-text-primary, #1d2230); } .nca-act { font-size: 0.82em; padding: 1px 8px; border-radius: 999px; background: var(--theme-color-background-secondary, #f3f5f9); border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6376); } .nca-state { margin-left: auto; font-size: 0.75em; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; } .nca-state-hold { color: var(--theme-color-status-error, #c0353a); } .nca-state-live { color: #2E7D32; } .nca-cands { display: flex; flex-wrap: wrap; gap: 8px; } .nca-cand { display: inline-flex; align-items: center; gap: 8px; cursor: pointer; padding: 8px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 999px; background: var(--theme-color-background-secondary, #f3f5f9); color: var(--theme-color-text-primary, #1d2230); font: inherit; font-size: 0.9em; } .nca-cand:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); } .nca-cand-active { border-color: var(--theme-color-brand-primary, #3b6fd4); background: var(--theme-color-background-panel, #fff); } .nca-dot { width: 9px; height: 9px; border-radius: 50%; border: 1px solid var(--theme-color-border-default, #d8dde6); background: transparent; } .nca-cand-active .nca-dot { background: var(--theme-color-brand-primary, #3b6fd4); border-color: var(--theme-color-brand-primary, #3b6fd4); } .nca-cand-none { color: var(--theme-color-text-secondary, #5b6376); } .nca-cand-name { line-height: 1; } .nca-ver { font-size: 0.72em; font-family: ui-monospace, Menlo, monospace; color: var(--theme-color-text-secondary, #5b6376); } .nca-tag { font-size: 0.72em; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); } .nca-tag-active { color: var(--theme-color-brand-primary, #3b6fd4); }',
	Templates:
	[
		{
			Hash: "Plansheet-CapabilityActivation",
			Template: '<div class="nca-wrap"><div class="nca-head"><h1>Capability activation</h1><p class="nca-sub">Of the nodes that advertise each capability, choose which one is live. Work routes only to the active node; with none active, it holds.</p></div><div id="NCA-Body"></div></div>'
		}
	],
	Renderables:
	[
		{ RenderableHash: "Plansheet-CapabilityActivation", TemplateHash: "Plansheet-CapabilityActivation", ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

module.exports = PictViewCapabilityActivation;
module.exports.default_configuration = PictViewCapabilityActivationConfiguration;

},{"pict-view":365}],661:[function(require,module,exports){
'use strict';

/**
 * PictView-Checklists
 * -------------------
 * A collection of checklists for one context, rendered as a stack of pict-section-checklist controls.
 * Two modes, never on screen at the same time, so one registered instance serves both:
 *   - 'mine'  : the signed-in user's PRIVATE checklists (the personal "Checklists" page).
 *   - 'owner' : the SHARED checklists on an entity (a Work Item's, blueprint-visible).
 *
 * Each checklist row gets its own mount div and its own child checklist view (PSChecklist-<id>), bound
 * to that checklist by Context ({ OwnerType: 'Checklist', IDOwner: <id> }) and backed by the shared
 * PlansheetChecklistProvider. The collection only manages the list itself (load, create, delete); every
 * item edit flows through the child control and the provider.
 */

const libPictView = require('pict-view');
const libModal = require('pict-section-modal');
const libChecklist = require('pict-section-checklist');
const libPlansheetChecklistProvider = require('../providers/PlansheetChecklistProvider.js');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Plansheet-Checklists',
	DefaultRenderable: 'Plansheet-Checklists',
	DefaultDestinationAddress: '#Plansheet-Checklists-Container',
	AutoRender: false,

	Mode: 'mine',            // 'mine' | 'owner'
	OwnerType: '',           // for 'owner' mode
	IDOwner: 0,              // for 'owner' mode
	Heading: 'Checklists',
	NewLabel: 'New checklist',
	Compact: false,          // true drops the card chrome for the narrow rail / phone column

	CSSPriority: 510,
	CSS: /*css*/`
		/* root container styling comes from .ps-page (Shell) */
		.ps-checklists-head { display: flex; align-items: center; gap: 12px; margin: 0 0 16px; }
		.ps-checklists-head h2 { font-size: 22px; font-weight: 600; margin: 0; color: var(--theme-color-text-primary, #1f2430); }
		.ps-checklists-new { font: inherit; font-size: 13px; margin-left: auto; border: 1px solid var(--theme-color-brand-primary, #2880a6); background: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); border-radius: 7px; padding: 6px 13px; cursor: pointer; }
		.ps-checklists-new:hover { filter: brightness(1.06); }
		.ps-checklist-card { position: relative; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 12px; padding: 16px 18px; margin-bottom: 14px; }
		.ps-checklist-del { position: absolute; top: 10px; right: 10px; z-index: 2; border: none; background: none; color: var(--theme-color-text-muted, #97a1ab); cursor: pointer; font-size: 15px; line-height: 1; padding: 4px; border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; }
		.ps-checklist-del:hover { background: var(--theme-color-background-hover, #eef2f6); color: var(--theme-color-status-error, #c0392b); }
		.ps-checklist-mount { }
		.ps-checklist-card .pchk-header { padding-right: 30px; }
		.ps-checklists-empty { color: var(--theme-color-text-muted, #97a1ab); font-size: 14px; padding: 14px 2px; }

		/* Compact mode (the notebook rail / a phone-width column): drop the card chrome so lists use the
		   full narrow width -- no border, no heavy padding, tighter heading. The child pict-section-checklist
		   controls handle their own narrow-width layout via container queries. */
		.ps-checklists-compact.ps-page { padding: 0; }
		.ps-checklists-compact .ps-checklists-head { margin-bottom: 10px; }
		.ps-checklists-compact .ps-checklists-head h2 { font-size: 15px; }
		.ps-checklists-compact .ps-checklists-new { padding: 4px 10px; font-size: 12px; }
		.ps-checklists-compact .ps-checklist-card { border: none; background: transparent; border-radius: 0; padding: 0; margin-bottom: 18px; }
		.ps-checklists-compact .ps-checklist-card .pchk-header { padding-right: 26px; }
	`,

	Templates:
	[
		{
			Hash: 'Plansheet-Checklists',
			Template: /*html*/`
<div class="{~D:AppData.ChecklistsPage.RootClass~}" id="Plansheet-Checklists-Root">
	<div class="ps-checklists-head">
		<h2>{~D:AppData.ChecklistsPage.Heading~}</h2>
		<button class="ps-checklists-new" onclick="_Pict.views['{~D:AppData.ChecklistsPage.ViewHash~}'].createChecklist()">{~D:AppData.ChecklistsPage.NewLabel~}</button>
	</div>
	{~TS:Plansheet-Checklist-Card:AppData.ChecklistsPage.Rows~}
	{~TS:Plansheet-Checklists-Empty:AppData.ChecklistsPage.EmptySlot~}
</div>`
		},
		{
			Hash: 'Plansheet-Checklist-Card',
			Template: /*html*/`<div class="ps-checklist-card"><button class="ps-checklist-del" title="Delete checklist" onclick="_Pict.views['{~D:Record.ViewHash~}'].deleteChecklist('{~D:Record.IDChecklist~}')">{~I:Trash~}</button><div class="ps-checklist-mount" id="{~D:Record.MountId~}"></div></div>`
		},
		{
			Hash: 'Plansheet-Checklists-Empty',
			Template: /*html*/`<div class="ps-checklists-empty">{~D:Record.Message~}</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Plansheet-Checklists',
			TemplateHash: 'Plansheet-Checklists',
			ContentDestinationAddress: '#Plansheet-Checklists-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewChecklists extends libPictView
{
	onBeforeInitialize()
	{
		this._rows = [];
		this._provider = new libPlansheetChecklistProvider(this.pict);
		this._childHashes = {};
		return super.onBeforeInitialize();
	}

	// Render the page (used by the route). Options (Mode/OwnerType/IDOwner) are set at registration or
	// via configure(); this just loads + paints into the destination.
	show() { return this.reload(); }

	// Point the collection at an owner (or 'mine') and reload. Call before rendering.
	configure(pMode, pOwnerType, pIDOwner)
	{
		this.options.Mode = pMode || 'mine';
		this.options.OwnerType = pOwnerType || '';
		this.options.IDOwner = pIDOwner || 0;
		return this.reload();
	}

	reload()
	{
		this._ensureModal();
		let tmpAPI = this.pict.providers.ChecklistAPI;
		let tmpLoad = (this.options.Mode === 'owner')
			? tmpAPI.listForOwner(this.options.OwnerType, this.options.IDOwner)
			: tmpAPI.listMine();
		return tmpLoad.then((pRows) =>
		{
			this._rows = Array.isArray(pRows) ? pRows : [];
			this._shape();
			this.render();
		}).catch(() =>
		{
			this._rows = [];
			this._shape();
			this.render();
		});
	}

	_shape()
	{
		this.pict.AppData.ChecklistsPage =
		{
			ViewHash: this.Hash,
			RootClass: 'ps-page ps-checklists' + (this.options.Compact ? ' ps-checklists-compact' : ''),
			Heading: this.options.Heading,
			NewLabel: this.options.NewLabel,
			Rows: this._rows.map((pRow) => ({ ViewHash: this.Hash, IDChecklist: pRow.IDChecklist, MountId: 'pschecklist-mount-' + pRow.IDChecklist })),
			EmptySlot: (this._rows.length === 0) ? [{ Message: (this.options.Mode === 'owner') ? 'No checklists here yet. Add one to track the work.' : 'No personal checklists yet. These are private to you.' }] : []
		};
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._mountChildren();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_mountChildren()
	{
		for (let i = 0; i < this._rows.length; i++)
		{
			let tmpID = this._rows[i].IDChecklist;
			let tmpHash = 'PSChecklist-' + tmpID;
			let tmpMount = '#pschecklist-mount-' + tmpID;
			let tmpView = this.pict.views[tmpHash];
			if (!tmpView)
			{
				tmpView = this.pict.addView(tmpHash, Object.assign({}, libChecklist.default_configuration,
					{
						ViewIdentifier: tmpHash,
						AutoRender: false,
						Context: { OwnerType: 'Checklist', IDOwner: String(tmpID) },
						DataProvider: this._provider,
						Title: this._rows[i].Title || 'Checklist',
						EditableTitle: true,
						DefaultDestinationAddress: tmpMount,
						Renderables: [{ RenderableHash: 'Checklist-Section', TemplateHash: 'Checklist-Section', ContentDestinationAddress: tmpMount, RenderMethod: 'replace' }]
					}), libChecklist);
			}
			if (!this._childHashes[tmpHash])
			{
				// pict's addView after app init does NOT run the view lifecycle, so bring the control up
				// by hand: the sync stages via initialize(), then mount() (wires the provider, loads, paints).
				this._childHashes[tmpHash] = true;
				if (typeof tmpView.initialize === 'function' && !tmpView.initializeTimestamp) { tmpView.initialize(); }
				if (typeof tmpView.mount === 'function') { try { tmpView.mount(); } catch (pError) { /* ignore */ } }
				else { try { tmpView.render(); } catch (pError) { /* ignore */ } }
			}
			else
			{
				// The shell re-rendered the mount div; repaint the existing control into the fresh node.
				try { tmpView.render(); } catch (pError) { /* ignore */ }
			}
		}
	}

	createChecklist()
	{
		let tmpDraft = (this.options.Mode === 'owner')
			? { OwnerType: this.options.OwnerType, IDOwner: this.options.IDOwner, Title: 'Checklist' }
			: { Private: true, Title: 'My checklist' };
		return this.pict.providers.ChecklistAPI.create(tmpDraft).then(() => this.reload());
	}

	deleteChecklist(pID)
	{
		return this._confirm('Delete this checklist and all of its items?', { title: 'Delete checklist', confirmLabel: 'Delete', dangerous: true })
			.then((pOk) =>
			{
				if (!pOk) { return; }
				let tmpHash = 'PSChecklist-' + pID;
				if (this.pict.views[tmpHash]) { try { delete this.pict.views[tmpHash]; } catch (pError) { /* ignore */ } delete this._childHashes[tmpHash]; }
				return this.pict.providers.ChecklistAPI.remove(pID).then(() => this.reload());
			});
	}

	_ensureModal()
	{
		if (!this.pict.views['Pict-Section-Modal']) { this.pict.addView('Pict-Section-Modal', libModal.default_configuration, libModal); }
		let tmpModalView = this.pict.views['Pict-Section-Modal'];
		if (tmpModalView && typeof document !== 'undefined' && document.body && typeof tmpModalView.initialize === 'function') { tmpModalView.initialize(); }
	}

	_confirm(pMessage, pOptions)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function') { return tmpModal.confirm(pMessage, pOptions || {}); }
		return Promise.resolve(true);
	}
}

module.exports = PictViewChecklists;
module.exports.default_configuration = _DefaultConfiguration;

},{"../providers/PlansheetChecklistProvider.js":621,"pict-section-checklist":184,"pict-section-modal":271,"pict-view":365}],662:[function(require,module,exports){
'use strict';

/**
 * Community -- the team hub: a grid of everyone on the team, each a card you click to visit their
 * profile page. Data comes from the public Team/Roster endpoint (any signed-in teammate, public
 * profile fields only). Clicking a card navigates to /profile/:id.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libAvatarHelper = require('./AvatarHelper.js');

function _escapeHTML(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

class PictViewCommunity extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.Community = this.pict.AppData.Community || { Members: [] };
	}

	show()
	{
		this.render();
		let tmpAPI = this.pict.providers.TeamAPI;
		if (!tmpAPI || typeof tmpAPI.roster !== 'function') { return; }
		tmpAPI.roster().then((pRoster) =>
		{
			this.pict.AppData.Community.Members = Array.isArray(pRoster) ? pRoster : [];
			this._renderGrid();
		});
	}

	visit(pIDUser)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showProfileFor === 'function') { tmpApp.showProfileFor(pIDUser); }
	}

	_renderGrid()
	{
		let tmpHost = document.getElementById('Community-Grid');
		if (!tmpHost) { return; }
		let tmpMembers = this.pict.AppData.Community.Members || [];
		if (tmpMembers.length === 0)
		{
			tmpHost.innerHTML = '<div class="cmty-empty">No one is here yet.</div>';
			return;
		}
		let tmpHTML = '';
		for (let i = 0; i < tmpMembers.length; i++)
		{
			let tmpMember = tmpMembers[i];
			// Use the same color logic as the avatar (their Color when set, else a stable color derived
			// from their name) so the stripe and avatar match and every card is colorful, set or not.
			let tmpName = tmpMember.DisplayName || ('Teammate ' + tmpMember.IDUser);
			let tmpAccent = libAvatarHelper.backgroundFor(tmpMember.Color, tmpName);
			let tmpTitle = tmpMember.Title ? ('<span class="cmty-title">' + _escapeHTML(tmpMember.Title) + '</span>') : '<span class="cmty-title cmty-title-empty">No title yet</span>';
			tmpHTML += '<button class="cmty-card" style="--cmty-accent: ' + _escapeHTML(tmpAccent) + '" onclick="_Pict.views[\'Plansheet-Community\'].visit(' + tmpMember.IDUser + ')">'
				+ '<span class="cmty-accent"></span>'
				+ '<span class="cmty-avatar">' + libAvatarHelper.avatarHTML(tmpMember, { Size: 64 }) + '</span>'
				+ '<span class="cmty-name">' + _escapeHTML(tmpName) + '</span>'
				+ tmpTitle
				+ '</button>';
		}
		tmpHost.innerHTML = tmpHTML;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewCommunity;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Community',
	DefaultRenderable: 'Community-Display',
	AutoRender: false,
	CSS: /*css*/`
		.cmty { height: 100%; overflow: auto; }
		.cmty-head { margin-bottom: 6px; }
		.cmty-h1 { margin: 0; font-size: 1.5em; color: var(--theme-color-text-primary, #1d2230); }
		.cmty-sub { margin: 4px 0 22px; color: var(--theme-color-text-secondary, #5b6376); font-size: 0.95em; }
		.cmty-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 16px; }
		.cmty-card { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 22px 14px 18px; border: 1px solid var(--theme-color-border-default, #e7eaf0); border-radius: 14px; background: var(--theme-color-background-panel, #fff); cursor: pointer; position: relative; overflow: hidden; text-align: center; }
		.cmty-card:hover { border-color: var(--cmty-accent); box-shadow: 0 6px 22px rgba(20,30,50,0.10); transform: translateY(-2px); transition: transform 0.12s ease, box-shadow 0.12s ease; }
		.cmty-accent { position: absolute; top: 0; left: 0; right: 0; height: 6px; background: var(--cmty-accent); }
		.cmty-avatar { margin-top: 4px; }
		.cmty-name { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); font-size: 0.98em; }
		.cmty-title { color: var(--theme-color-text-secondary, #5b6376); font-size: 0.82em; min-height: 1em; }
		.cmty-title-empty { opacity: 0.5; font-style: italic; }
		.cmty-empty { padding: 40px; text-align: center; color: var(--theme-color-text-secondary, #8a93a5); }
	`,
	Templates:
	[
		{
			Hash: 'Community-Display',
			Template: /*html*/`
<div class="ps-page cmty">
	<div class="cmty-head">
		<h1 class="cmty-h1">Community</h1>
		<p class="cmty-sub">Everyone on the team. Click a card to visit their page.</p>
	</div>
	<div class="cmty-grid" id="Community-Grid"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Community-Display',
			TemplateHash: 'Community-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"./AvatarHelper.js":648,"pict-view":365}],663:[function(require,module,exports){
'use strict';

/**
 * PictView-Connections
 * --------------------
 * The reusable drafting "connections" grid: an entity's links rendered as a tight grid of title-block
 * cells (count + mono label, with chip or thumbnail previews) instead of a tall stack of half-empty
 * sections. The same component the Blueprint uses, parameterized by colorway:
 *   - Colorway 'navy'     -> a curated Blueprint (the artifact).
 *   - Colorway 'graphite' -> an entity's auto-gathered connections (the everyday view).
 * Shared yellow accent (the link / pin gesture) on both.
 *
 * View mode hides empty relation types and previews media inline; click a cell to expand its items
 * underneath. Edit mode shows every possible relation as a dashed "+ link" cell plus a one-at-a-time
 * linker. Data + link/unlink flow through the ConnectionsAPI provider. configure(entity, id, colorway)
 * loads + paints into the destination.
 */

const libPictView = require('pict-view');

class PictViewConnections extends libPictView
{
	onBeforeInitialize()
	{
		this._data = { Title: '', Record: [], Groups: [], Available: [] };
		this._mode = 'view';
		this._active = null;
		this._linkType = null;
		this._linkItem = null;
		this._candidates = [];
		return super.onBeforeInitialize();
	}

	_api() { return this.pict.providers.ConnectionsAPI; }

	configure(pEntity, pID, pColorway, pHasPrompts)
	{
		this.options.Entity = pEntity || this.options.Entity;
		this.options.IDEntity = parseInt(pID, 10) || 0;
		if (pColorway) { this.options.Colorway = pColorway; }
		// Entities with attached prompts (WorkItem) host the prompts panel inside this box.
		this._hasPrompts = !!pHasPrompts;
		this._mode = 'view'; this._active = null; this._linkType = null; this._linkItem = null; this._candidates = [];
		return this.reload();
	}

	reload()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || !this.options.IDEntity) { return Promise.resolve(); }
		return tmpAPI.get(this.options.Entity, this.options.IDEntity).then((pData) =>
		{
			this._data = pData || { Title: '', Record: [], Groups: [], Available: [] };
			this.render();
		});
	}

	// ---- shaping -------------------------------------------------------------------------------------
	// A rollup's Counts (server-ordered, e.g. Draft/Active/Realized/Abandoned) as bar segments +
	// a "2/5 realized" line, so a parent vision shows its sub-visions' aggregate progress right on
	// the cell -- no click-through needed (WI #6: Sub-vision status rollup).
	_rollupSlot(pGroup)
	{
		let tmpRollup = pGroup.Rollup;
		if (!tmpRollup || !tmpRollup.Total) { return []; }
		let tmpCounts = tmpRollup.Counts || [];
		return [{
			Segments: tmpCounts.map((pC) => ({
				Class: 'cnx-rollup-seg-' + String(pC.Status || '').toLowerCase(),
				Width: Math.round((pC.Count / tmpRollup.Total) * 100),
				Title: pC.Status + ': ' + pC.Count
			})),
			Text: tmpCounts.map((pC) => pC.Count + ' ' + String(pC.Status || '').toLowerCase()).join(' · ')
		}];
	}

	_cellRecord(pGroup, pEmpty)
	{
		let tmpItems = pGroup.Items || [];
		let tmpPreview = (pGroup.Mode === 'preview');
		return {
			Type: pGroup.Type, Label: pGroup.Label || pGroup.Type, Icon: pGroup.Icon || '', ViewHash: this.Hash,
			CountSlot: pEmpty ? [] : [{ Count: pGroup.Count }],
			PlusSlot: pEmpty ? [{ X: 1 }] : [],
			// Prefer the mark in the cell preview. A connections grid is scanned, not read, and three
			// marks (WI-301 F-167 V-043) cross-reference at a glance where three truncated sentences
			// cannot. The full titles are one click away in the detail rows.
			//
			// UNLESS the entity says otherwise. That argument holds for artifacts people cite BY mark and
			// inverts for one nobody does: a session carries SN-014 so it can be cited as provenance on a
			// printed sheet, and nobody ever says "open SN-014". Its descriptor sets ChipPrefersMark false
			// and the server passes the hint through, so the cell keeps the title it is scanned by.
			Chips: (!pEmpty && !tmpPreview) ? tmpItems.slice(0, 3).map((pIt) =>
				{
					let tmpUseMark = (pIt.ChipPrefersMark !== false) && !!pIt.Designator;
					return {
						Chip: (tmpUseMark ? pIt.Designator : '') || pIt.Chip || pIt.Title || '',
						MarkClass: tmpUseMark ? 'cnx-chip-mark' : ''
					};
				}) : [],
			Thumbs: (!pEmpty && tmpPreview) ? tmpItems.slice(0, 4).map((pIt) => ({ Thumb: pIt.Thumb || '', Title: pIt.Title || '' })) : [],
			RollupSlot: pEmpty ? [] : this._rollupSlot(pGroup),
			ActiveClass: (pGroup.Type === this._active) ? 'is-active' : '',
			EmptyClass: pEmpty ? 'is-empty' : '',
			WideClass: (!pEmpty && tmpPreview) ? 'is-wide' : ''
		};
	}

	_cells()
	{
		let tmpGroups = this._data.Groups || [];
		if (this._mode !== 'edit')
		{
			return tmpGroups.filter((pG) => pG.Count > 0).map((pG) => this._cellRecord(pG, false));
		}
		let tmpByType = {}; tmpGroups.forEach((pG) => { tmpByType[pG.Type] = pG; });
		return (this._data.Available || []).map((pA) =>
		{
			let tmpG = tmpByType[pA.Type];
			if (tmpG && tmpG.Count > 0) { return this._cellRecord(tmpG, false); }
			// Only offer the dashed "+ link" empty cell for relations you can actually link here.
			// Reverse relations, docs and media are managed elsewhere, so an empty one just hides.
			if (!pA.Linkable) { return null; }
			return this._cellRecord(Object.assign({ Count: 0, Mode: pA.Mode || 'count', Items: [] }, pA), true);
		}).filter((pC) => pC);
	}

	_detailSlot()
	{
		if (!this._active) { return []; }
		let tmpG = (this._data.Groups || []).find((pG) => pG.Type === this._active);
		if (!tmpG || !tmpG.Count) { return []; }
		let tmpEdit = (this._mode === 'edit');
		// Disconnect is only meaningful for a linkable relation (the server rejects the rest).
		let tmpAvail = (this._data.Available || []).find((pA) => pA.Type === this._active);
		let tmpCanUnlink = tmpEdit && !!(tmpAvail && tmpAvail.Linkable);
		return [{
			Label: tmpG.Label,
			Items: (tmpG.Items || []).map((pIt) => ({
				// A media item shows its thumbnail (clickable to the lightbox) in place of the generic type icon.
				IconHTML: pIt.Thumb ? '' : this.pict.providers.Icon.get(tmpG.Icon || ''), Title: pIt.Title || '', Type: tmpG.Type, ID: pIt.ID, ViewHash: this.Hash,
				ThumbSlot: pIt.Thumb ? [{ Thumb: pIt.Thumb, Title: pIt.Title || '' }] : [],
				ViewSlot: pIt.Thumb ? [{ Thumb: pIt.Thumb, Title: pIt.Title || '' }] : [],
				// A row for a linkable target opens it; everything else (media, comments) is plain text.
				// The mark leads the row where the item has one, so a detail list reads as cross-reference
				// (WI-301 Fold the executor) rather than a stack of sentences.
				MarkSlot: pIt.Designator ? [{ Designator: pIt.Designator }] : [],
				LinkTitleSlot: pIt.Link ? [{ Title: pIt.Title || '', Link: pIt.Link, ViewHash: this.Hash }] : [],
				PlainTitleSlot: pIt.Link ? [] : [{ Title: pIt.Title || '' }],
				// A rollup group's items carry the field it rolled up (Status, for sub-visions) --
				// show it as a badge on the row so the breakdown ties back to named parts.
				StatusSlot: (tmpG.Rollup && pIt.Status) ? [{ Status: pIt.Status, Class: 'cnx-rollup-seg-' + String(pIt.Status).toLowerCase() }] : [],
				UnlinkSlot: tmpCanUnlink ? [{ Type: tmpG.Type, ID: pIt.ID, ViewHash: this.Hash }] : []
			}))
		}];
	}

	// The relation types this entity can actually link one-at-a-time (fk / join with a target).
	// Everything else (reverse relations, docs, media, comments, sessions) is read-only here.
	_linkableTypes() { return (this._data.Available || []).filter((pA) => pA.Linkable); }

	_linkerSlot()
	{
		if (this._mode !== 'edit') { return []; }
		let tmpHasLinkable = this._linkableTypes().length > 0;
		return [{
			ViewHash: this.Hash,
			TypeHostId: this._typePickerHash(),
			CandHostId: this._candPickerHash(),
			// Show the two pickers when there is something to link; otherwise a plain note so the
			// editor never presents an empty "Choose a connection type" that can go nowhere.
			PickersSlot: tmpHasLinkable ? [{ ViewHash: this.Hash, TypeHostId: this._typePickerHash(), CandHostId: this._candPickerHash() }] : [],
			NoteSlot: tmpHasLinkable ? [] : [{ X: 1 }]
		}];
	}

	onBeforeRender(pRenderable)
	{
		let tmpColorway = (this.options.Colorway === 'navy') ? 'navy' : 'graphite';
		this.pict.AppData.Connections = {
			ViewHash: this.Hash,
			RootClass: 'cnx-' + tmpColorway,
			Eyebrow: this._data.Eyebrow || ((tmpColorway === 'navy') ? 'Blueprint' : 'Connections'),
			Title: this._data.Title || '',
			Record: this._data.Record || [],
			RecordWrap: (this._data.Record && this._data.Record.length) ? [{}] : [],
			Cells: this._cells(),
			ViewActive: (this._mode === 'view') ? 'is-on' : '',
			EditActive: (this._mode === 'edit') ? 'is-on' : '',
			LinkerSlot: this._linkerSlot(),
			DetailSlot: this._detailSlot(),
			PromptHostSlot: this._hasPrompts ? [{}] : []
		};
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		// Mount the attached-prompts panel into the host inside this box (the host is recreated on
		// every render, so re-mount each time). The panel fetches its own data.
		if (this._hasPrompts)
		{
			let tmpPrompts = this.pict.views['Plansheet-PromptAttachments'];
			if (tmpPrompts && typeof tmpPrompts.showFor === 'function') { tmpPrompts.showFor(this.options.Entity, this.options.IDEntity, 'Cnx-Prompts'); }
		}
		this._mountLinkerPickers();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// ---- handlers ------------------------------------------------------------------------------------
	openCell(pType) { this._active = (this._active === pType) ? null : pType; this.render(); }

	// A connected item's route (fk / join / inverse-fk carry one; media and comments do not).
	openLink(pLink)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp._navigate === 'function' && pLink) { tmpApp._navigate(pLink); }
	}

	setMode(pMode)
	{
		this._mode = (pMode === 'edit') ? 'edit' : 'view';
		if (this._mode !== 'edit') { this._linkType = null; this._linkItem = null; this._candidates = []; }
		this.render();
	}

	// ---- searchable pickers (type + candidate) ------------------------------------------------------
	// Hashes/value-addresses are namespaced by this view's Hash so two connection
	// boxes on a page (entity + blueprint) never share picker state.
	_typePickerHash() { return this.Hash + '-CnxTypePicker'; }
	_candPickerHash() { return this.Hash + '-CnxCandPicker'; }

	// One picker option per candidate: the title plus an enriched suffix (number +
	// status) so you can tell what you are connecting. The picker also surfaces the
	// full string as a hover tooltip.
	_candidateOptions()
	{
		return (this._candidates || []).map((pC) =>
		{
			let tmpMeta = [];
			if (pC.Number) { tmpMeta.push('#' + pC.Number); }
			if (pC.Status) { tmpMeta.push(pC.Status); }
			let tmpText = pC.Title || ('#' + pC.ID);
			if (tmpMeta.length) { tmpText += ' (' + tmpMeta.join(', ') + ')'; }
			return { Value: pC.ID, Text: tmpText };
		});
	}

	// Mount (or re-mount, after a render) the two pickers into their hosts. The
	// connections box replaces its DOM on every render, so re-create each time;
	// selections live in AppData (the picker ValueAddress), so they survive.
	_mountLinkerPickers()
	{
		if (this._mode !== 'edit') { return; }
		// Nothing linkable -> the template shows the note instead of picker hosts, so do not mount.
		if (this._linkableTypes().length === 0) { return; }
		let tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || typeof tmpPicker.createPicker !== 'function') { return; }

		let tmpTypeHash = this._typePickerHash();
		// Only offer types that can actually be linked; a non-linkable type would always come back
		// with "no options available" (the reported connections-editor bug).
		let tmpTypeOptions = this._linkableTypes().map((pA) => ({ Value: pA.Type, Text: pA.Label || pA.Type }));
		tmpPicker.createPicker(tmpTypeHash,
			{
				DestinationAddress: '#' + tmpTypeHash,
				ValueAddress: 'AppData.CnxLinker_' + this.Hash + '.Type',
				Placeholder: 'Choose a connection type',
				Searchable: (tmpTypeOptions.length > 8),
				Options: tmpTypeOptions,
				OnChange: (pVal) => this.onTypePicked(pVal)
			});
		let tmpTypeView = this.pict.views[tmpTypeHash];
		if (tmpTypeView) { tmpTypeView.setValue(this._linkType || ''); tmpTypeView.render(); }

		let tmpCandHash = this._candPickerHash();
		tmpPicker.createPicker(tmpCandHash,
			{
				DestinationAddress: '#' + tmpCandHash,
				ValueAddress: 'AppData.CnxLinker_' + this.Hash + '.Item',
				Placeholder: this._linkType ? 'Search what to connect' : 'Pick a type first',
				Searchable: true,
				Options: this._candidateOptions(),
				OnChange: (pVal) => this.onItemPicked(pVal)
			});
		let tmpCandView = this.pict.views[tmpCandHash];
		if (tmpCandView) { tmpCandView.setValue(this._linkItem || ''); tmpCandView.render(); }
	}

	// Type picked: load its candidates and refresh ONLY the candidate picker (no
	// full connections render, so the type selection stays put -- this is the
	// "doesn't stick" fix).
	onTypePicked(pType)
	{
		this._linkType = pType || null;
		this._linkItem = null;
		this._candidates = [];
		let tmpPicker = this.pict.providers['Pict-Section-Picker'];
		let tmpCandHash = this._candPickerHash();
		let fPaint = () =>
		{
			if (!tmpPicker) { return; }
			tmpPicker.createPicker(tmpCandHash,
				{
					Options: this._candidateOptions(),
					Placeholder: !this._linkType ? 'Pick a type first' : (this._candidates.length ? 'Search what to connect' : 'Nothing available to connect')
				});
			let tmpV = this.pict.views[tmpCandHash];
			if (tmpV) { tmpV.setValue(''); tmpV.render(); }
		};
		if (!this._linkType) { fPaint(); return; }
		this._api().candidates(this.options.Entity, this.options.IDEntity, this._linkType).then((pCands) =>
		{
			this._candidates = Array.isArray(pCands) ? pCands : [];
			fPaint();
		});
	}

	onItemPicked(pID) { this._linkItem = pID || null; }

	doLink()
	{
		if (!this._linkType || !this._linkItem) { return; }
		this._api().link(this.options.Entity, this.options.IDEntity, this._linkType, this._linkItem).then(() =>
		{
			this._active = this._linkType;
			this._linkType = null; this._linkItem = null; this._candidates = [];
			this.reload();
		});
	}

	unlinkItem(pType, pID)
	{
		this._api().unlink(this.options.Entity, this.options.IDEntity, pType, pID).then(() => this.reload());
	}
}

module.exports = PictViewConnections;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Connections',
	DefaultRenderable: 'Connections-Display',
	DefaultDestinationAddress: '#Entity-Connections',
	AutoRender: false,
	Entity: '',
	IDEntity: 0,
	Colorway: 'graphite',
	CSSPriority: 520,
	CSS: /*css*/`
		.cnx { border-radius: 12px; padding: 16px 18px; border: 1.5px solid var(--cnx-frame); background: var(--cnx-sheet);
			/* Re-map the picker's theme tokens to the dark connections palette so the
			   pict-section-picker in the linker matches the box in any app theme. */
			--theme-color-background-primary: rgba(8,14,24,0.4);
			--theme-color-background-panel: var(--cnx-sheet);
			--theme-color-background-tertiary: rgba(150,166,188,0.22);
			--theme-color-text-primary: var(--cnx-txt);
			--theme-color-text-secondary: var(--cnx-lbl);
			--theme-color-text-muted: var(--cnx-lbl);
			--theme-color-border-default: var(--cnx-cellb);
			--theme-color-border-light: var(--cnx-cellb);
			--theme-color-border-strong: var(--cnx-frame);
			--theme-color-brand-primary: #f0c44a; }
		.cnx-graphite { --cnx-sheet: #262f3b; --cnx-eye: #9aabc0; --cnx-frame: rgba(214,224,236,0.42); --cnx-cellb: rgba(150,166,188,0.3); --cnx-lbl: #9aabc0; --cnx-txt: #eef2f7; }
		.cnx-navy { --cnx-sheet: #172c50; --cnx-eye: #84a6d4; --cnx-frame: rgba(208,226,247,0.5); --cnx-cellb: rgba(150,180,220,0.32); --cnx-lbl: #8fabd2; --cnx-txt: #eef4fc; }
		.cnx-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
		.cnx-eye { font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 2px; color: var(--cnx-eye); text-transform: uppercase; }
		.cnx-title { font-size: 17px; font-weight: 500; color: var(--cnx-txt); margin-top: 3px; overflow-wrap: anywhere; }
		.cnx-modes { display: inline-flex; border: 1px solid var(--cnx-cellb); border-radius: 7px; overflow: hidden; flex: 0 0 auto; }
		.cnx-seg { font: inherit; font-size: 12px; padding: 4px 11px; border: none; background: transparent; color: var(--cnx-txt); cursor: pointer; }
		.cnx-seg.is-on { background: rgba(150,166,188,0.25); }
		.cnx-rec { display: flex; flex-wrap: wrap; border: 1px solid var(--cnx-cellb); border-radius: 8px; margin: 14px 0 16px; overflow: hidden; }
		.cnx-recrow { padding: 7px 13px; border-right: 1px solid var(--cnx-cellb); min-width: 0; }
		.cnx-recrow .cnx-eye { letter-spacing: 1.5px; }
		.cnx-recval { font-size: 14px; color: var(--cnx-txt); margin-top: 2px; display: block; }
		.cnx-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(230px, 1fr)); gap: 10px; }
		.cnx-cell { min-width: 0; overflow: hidden; background: rgba(8,14,24,0.34); border: 1px solid var(--cnx-cellb); border-radius: 8px; padding: 11px 13px; cursor: pointer; text-align: left; font: inherit; }
		.cnx-cell:hover { border-color: rgba(210,224,245,0.55); }
		.cnx-cell.is-active { border-color: #f0c44a; }
		.cnx-cell.is-empty { border-style: dashed; }
		.cnx-cell.is-wide { grid-column: span 2; }
		.cnx-cell-top { display: flex; align-items: baseline; gap: 8px; flex-wrap: nowrap; }
		.cnx-n { font-size: 21px; font-weight: 500; color: var(--cnx-txt); }
		.cnx-plus { color: #f0c44a; font-size: 16px; }
		.cnx-cell-l { font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 1.2px; color: var(--cnx-lbl); text-transform: uppercase; overflow-wrap: anywhere; flex: 1 1 auto; min-width: 0; }
		.cnx-chip { display: inline-block; max-width: 100%; background: rgba(140,165,200,0.2); color: var(--cnx-txt); font-size: 12px; padding: 2px 8px; border-radius: 5px; margin: 5px 5px 0 0; overflow-wrap: anywhere; }
		.cnx-thumb { display: inline-block; width: 32px; height: 32px; border-radius: 5px; overflow: hidden; border: 1px solid var(--cnx-cellb); margin: 6px 5px 0 0; background: rgba(140,165,200,0.16); vertical-align: top; cursor: zoom-in; }
		.cnx-thumb:hover { border-color: #f0c44a; }
		.cnx-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
		.cnx-detail-thumb { flex: 0 0 auto; width: 46px; height: 34px; border-radius: 4px; overflow: hidden; border: 1px solid var(--cnx-cellb); background: rgba(140,165,200,0.16); cursor: zoom-in; }
		.cnx-detail-thumb:hover { border-color: #f0c44a; }
		.cnx-detail-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
		.cnx-detail-view { margin-left: auto; flex: 0 0 auto; font: inherit; font-size: 11px; padding: 3px 10px; border: 1px solid var(--cnx-cellb); border-radius: 6px; background: transparent; color: var(--cnx-lbl); cursor: pointer; }
		.cnx-detail-view:hover { border-color: #f0c44a; color: #f0c44a; }
		.cnx-linker { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
		.cnx-linker-note { font-size: 12px; color: var(--cnx-lbl); font-style: italic; }
		.cnx-pick { min-width: 168px; flex: 0 0 auto; }
		.cnx-pick-wide { flex: 1 1 220px; min-width: 200px; }
		.cnx-pick > .pict-section-picker, .cnx-pick > div { width: 100%; }
		.cnx-link-btn { font: inherit; font-size: 13px; padding: 7px 16px; border: 1.5px solid #f0c44a; color: #f0c44a; background: transparent; border-radius: 7px; cursor: pointer; flex: 0 0 auto; }
		.cnx-link-btn:hover { background: rgba(240,196,74,0.14); }
		.cnx-detail { background: rgba(8,14,24,0.34); border: 1px solid var(--cnx-cellb); border-radius: 8px; padding: 8px 14px; margin-top: 10px; }
		.cnx-detail-row { display: flex; align-items: flex-start; gap: 8px; padding: 6px 0; border-top: 1px solid var(--cnx-cellb); font-size: 13px; color: var(--cnx-txt); }
		.cnx-detail-row > .pict-icon { color: var(--cnx-eye); margin-top: 2px; flex: 0 0 auto; }
		.cnx-detail-mark { flex: 0 0 auto; font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
			font-size: 11.5px; font-weight: 700; font-variant-numeric: tabular-nums; letter-spacing: 0.04em;
			color: #f0c44a; }
		.cnx-chip-mark { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
			font-variant-numeric: tabular-nums; letter-spacing: 0.03em; }
		/* Aggregate progress rollup (WI #6): a segmented bar + breakdown text on a cell like
		   "Parts of this vision", so a platform vision shows how its sub-visions are doing without
		   a click-through. Segment colors reuse the app's shared status palette. */
		.cnx-rollup { margin-top: 8px; }
		.cnx-rollup-bar { display: flex; height: 5px; border-radius: 3px; overflow: hidden; background: rgba(140,165,200,0.2); }
		.cnx-rollup-seg { display: block; height: 100%; }
		.cnx-rollup-seg-draft { background: var(--cnx-lbl, #9aabc0); }
		.cnx-rollup-seg-active { background: var(--theme-color-status-warning, #d0902f); }
		.cnx-rollup-seg-realized { background: var(--theme-color-status-success, #3fae5a); }
		.cnx-rollup-seg-abandoned { background: var(--theme-color-status-error, #c0353a); }
		.cnx-rollup-text { display: block; margin-top: 4px; font-size: 11px; color: var(--cnx-lbl); }
		.cnx-detail-status { flex: 0 0 auto; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; padding: 2px 8px; border-radius: 999px; color: #fff; }
		.cnx-detail-title { flex: 1; min-width: 0; overflow-wrap: anywhere; }
		a.cnx-detail-title { color: var(--cnx-txt); cursor: pointer; text-decoration: none; }
		a.cnx-detail-title:hover { color: #f0c44a; text-decoration: underline; }
		.cnx-unlink { margin-left: auto; flex: 0 0 auto; cursor: pointer; font: inherit; font-size: 11px; letter-spacing: 0.3px; padding: 3px 9px; border: 1px solid var(--cnx-cellb); border-radius: 6px; background: transparent; color: var(--cnx-lbl); display: inline-flex; align-items: center; gap: 5px; }
		.cnx-unlink:hover { border-color: #f0c44a; color: #f0c44a; }
		.cnx-prompts { margin-top: 16px; padding-top: 14px; border-top: 1px solid var(--cnx-cellb); }
		.cnx-prompts > .cnx-eye { display: block; margin-bottom: 10px; }
	`,
	Templates:
	[
		{
			Hash: 'Connections-Display',
			Template: /*html*/`
<div class="cnx {~D:AppData.Connections.RootClass~}">
	<div class="cnx-head">
		<div style="min-width:0;"><div class="cnx-eye">{~D:AppData.Connections.Eyebrow~}</div><div class="cnx-title">{~D:AppData.Connections.Title~}</div></div>
		<div class="cnx-modes">
			<button class="cnx-seg {~D:AppData.Connections.ViewActive~}" onclick="_Pict.views['{~D:AppData.Connections.ViewHash~}'].setMode('view')">View</button>
			<button class="cnx-seg {~D:AppData.Connections.EditActive~}" onclick="_Pict.views['{~D:AppData.Connections.ViewHash~}'].setMode('edit')">Edit</button>
		</div>
	</div>
	{~TS:Connections-RecordWrap:AppData.Connections.RecordWrap~}
	<div class="cnx-grid">{~TS:Connections-Cell:AppData.Connections.Cells~}</div>
	{~TS:Connections-Linker:AppData.Connections.LinkerSlot~}
	{~TS:Connections-Detail:AppData.Connections.DetailSlot~}
	{~TS:Connections-PromptHost:AppData.Connections.PromptHostSlot~}
</div>`
		},
		{ Hash: 'Connections-PromptHost', Template: /*html*/`<div class="cnx-prompts"><div class="cnx-eye">Prompts</div><div id="Cnx-Prompts"></div></div>` },
		{
			Hash: 'Connections-Record',
			Template: /*html*/`<div class="cnx-recrow"><div class="cnx-eye">{~D:Record.Label~}</div><span class="cnx-recval">{~D:Record.Value~}</span></div>`
		},
		{
			Hash: 'Connections-RecordWrap',
			Template: /*html*/`<div class="cnx-rec">{~TS:Connections-Record:AppData.Connections.Record~}</div>`
		},
		{
			Hash: 'Connections-Cell',
			Template: /*html*/`<button class="cnx-cell {~D:Record.ActiveClass~} {~D:Record.EmptyClass~} {~D:Record.WideClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].openCell('{~D:Record.Type~}')"><span class="cnx-cell-top">{~TS:Connections-Count:Record.CountSlot~}{~TS:Connections-Plus:Record.PlusSlot~}<span class="cnx-cell-l">{~D:Record.Label~}</span></span><span class="cnx-chiprow">{~TS:Connections-Chip:Record.Chips~}</span><span class="cnx-thumbrow">{~TS:Connections-Thumb:Record.Thumbs~}</span>{~TS:Connections-Rollup:Record.RollupSlot~}</button>`
		},
		{ Hash: 'Connections-Count', Template: /*html*/`<span class="cnx-n">{~D:Record.Count~}</span>` },
		{ Hash: 'Connections-Plus', Template: /*html*/`<span class="cnx-n cnx-plus">+</span>` },
		{ Hash: 'Connections-Chip', Template: /*html*/`<span class="cnx-chip {~D:Record.MarkClass~}">{~D:Record.Chip~}</span>` },
		{
			Hash: 'Connections-Rollup',
			Template: /*html*/`<span class="cnx-rollup"><span class="cnx-rollup-bar">{~TS:Connections-RollupSeg:Record.Segments~}</span><span class="cnx-rollup-text">{~D:Record.Text~}</span></span>`
		},
		{ Hash: 'Connections-RollupSeg', Template: /*html*/`<span class="cnx-rollup-seg {~D:Record.Class~}" style="width:{~D:Record.Width~}%" title="{~D:Record.Title~}"></span>` },
		{ Hash: 'Connections-Thumb', Template: /*html*/`<span class="cnx-thumb" data-url="{~D:Record.Thumb~}" data-title="{~D:Record.Title~}" title="Click to view" onclick="event.stopPropagation();if(this.dataset.url){_Pict.PictApplication.viewImage(this.dataset.url,this.dataset.title);}"><img src="{~D:Record.Thumb~}" alt="" loading="lazy"></span>` },
		{
			Hash: 'Connections-Linker',
			Template: /*html*/`<div class="cnx-linker"><span class="cnx-eye">Link</span>{~TS:Connections-LinkerPickers:Record.PickersSlot~}{~TS:Connections-LinkerNote:Record.NoteSlot~}</div>`
		},
		{
			Hash: 'Connections-LinkerPickers',
			Template: /*html*/`<div class="cnx-pick" id="{~D:Record.TypeHostId~}"></div><div class="cnx-pick cnx-pick-wide" id="{~D:Record.CandHostId~}"></div><button class="cnx-link-btn" onclick="_Pict.views['{~D:Record.ViewHash~}'].doLink()">Link it</button>`
		},
		{ Hash: 'Connections-LinkerNote', Template: /*html*/`<span class="cnx-linker-note">Nothing here can be linked directly.</span>` },
		{
			Hash: 'Connections-Detail',
			Template: /*html*/`<div class="cnx-detail"><span class="cnx-eye">{~D:Record.Label~}</span>{~TS:Connections-Detail-Row:Record.Items~}</div>`
		},
		{
			Hash: 'Connections-Detail-Row',
			Template: /*html*/`<div class="cnx-detail-row">{~TS:Connections-DetailThumb:Record.ThumbSlot~}{~D:Record.IconHTML~}{~TS:Connections-DetailMark:Record.MarkSlot~}{~TS:Connections-DetailTitleLink:Record.LinkTitleSlot~}{~TS:Connections-DetailTitlePlain:Record.PlainTitleSlot~}{~TS:Connections-DetailStatus:Record.StatusSlot~}{~TS:Connections-DetailView:Record.ViewSlot~}{~TS:Connections-Unlink:Record.UnlinkSlot~}</div>`
		},
		{ Hash: 'Connections-DetailThumb', Template: /*html*/`<span class="cnx-detail-thumb" data-url="{~D:Record.Thumb~}" data-title="{~D:Record.Title~}" title="Click to view" onclick="_Pict.PictApplication.viewImage(this.dataset.url,this.dataset.title)"><img src="{~D:Record.Thumb~}" alt="" loading="lazy"></span>` },
		{ Hash: 'Connections-DetailMark', Template: /*html*/`<span class="cnx-detail-mark">{~D:Record.Designator~}</span>` },
		{ Hash: 'Connections-DetailStatus', Template: /*html*/`<span class="cnx-detail-status {~D:Record.Class~}">{~D:Record.Status~}</span>` },
		{ Hash: 'Connections-DetailTitleLink', Template: /*html*/`<a class="cnx-detail-title" onclick="_Pict.views['{~D:Record.ViewHash~}'].openLink('{~D:Record.Link~}')">{~D:Record.Title~}</a>` },
		{ Hash: 'Connections-DetailTitlePlain', Template: /*html*/`<span class="cnx-detail-title">{~D:Record.Title~}</span>` },
		{ Hash: 'Connections-DetailView', Template: /*html*/`<button type="button" class="cnx-detail-view" data-url="{~D:Record.Thumb~}" data-title="{~D:Record.Title~}" onclick="_Pict.PictApplication.viewImage(this.dataset.url,this.dataset.title)">View</button>` },
		{ Hash: 'Connections-Unlink', Template: /*html*/`<button class="cnx-unlink" onclick="_Pict.views['{~D:Record.ViewHash~}'].unlinkItem('{~D:Record.Type~}','{~D:Record.ID~}')" title="Disconnect">{~I:Unlink~} Disconnect</button>` }
	],
	Renderables:
	[
		{ RenderableHash: 'Connections-Display', TemplateHash: 'Connections-Display', ContentDestinationAddress: '#Entity-Connections', RenderMethod: 'replace' }
	]
};

},{"pict-view":365}],664:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * DeliverableBoard -- the Deliver board. A kanban over Deliverables, lanes by stage (Scoped ->
 * Accepted, with the resolved kit labels). One read (DeliverableBoardAPI.dashboard ->
 * AppData.DeliverableBoard) backs the page. HTML5 drag-and-drop moves a card to another stage; the
 * drop PUTs the deliverable's Status/SortOrder, which trips the server-side status-change audit
 * (WorkflowStatusEvent). Clicking a card opens its detail (nesting, check-off, the connections grid).
 */
class PictViewDeliverableBoard extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._drag = null;
	}

	_board() { return this.pict.providers.DeliverableBoardAPI; }
	_router() { return this.pict.providers['Pict-Router']; }

	show()
	{
		let tmpBoard = this._board();
		if (!tmpBoard) { return Promise.resolve(); }
		return tmpBoard.dashboard().then(() => { this._rebuild(); this.render(); });
	}
	refresh() { return this.show(); }

	// Decorate the raw cards (number label, sub-deliverable count) and fold the lanes into ViewLanes
	// with a per-lane count. The provider owns the raw AppData.DeliverableBoard.Lanes.
	_rebuild()
	{
		let tmpStore = (this.pict.AppData && this.pict.AppData.DeliverableBoard) || null;
		if (!tmpStore) { return; }
		let fDecorate = (pCard) =>
		{
			pCard.NumberLabel = pCard.DeliverableNumber ? ('#' + pCard.DeliverableNumber) : '';
			pCard.SubLabel = pCard.ChildCount ? (pCard.ChildCount + (pCard.ChildCount === 1 ? ' part' : ' parts')) : '';
			pCard.PartOfMark = pCard.IsChild ? 'part of another' : '';
			return pCard;
		};
		tmpStore.ViewLanes = (tmpStore.Lanes || []).map((pLane) =>
		{
			let tmpCards = (pLane.Cards || []).map(fDecorate);
			return { Key: pLane.Key, Label: pLane.Label, Cards: tmpCards, Count: tmpCards.length };
		});
		tmpStore.Empty = (tmpStore.ViewLanes.some((pLane) => pLane.Count > 0)) ? [] : [{ Message: 'No deliverables yet. Add what a customer expects to receive.' }];
	}

	// Surface a message to the user. The board already toasts on a failed drop; new-deliverable failures
	// used to be swallowed, so the button looked dead when the create was refused (a 403 from a persona
	// without create rights) or errored. Always tell the user what happened instead of doing nothing.
	_toast(pMsg, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMsg, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	newDeliverable()
	{
		let tmpAPI = this.pict.providers.DeliverableAPI;
		let tmpRouter = this._router();
		if (!tmpAPI)
		{
			this._toast('Could not add a deliverable: the Deliverable service is not available. Reload the page and try again.', 'error');
			return;
		}
		// EntityAPI.create rejects on any non-2xx (throws 'HTTP <status>'); catch it and tell the user
		// rather than letting the button silently do nothing.
		tmpAPI.create({ Title: 'New deliverable', Status: 'Scoped' }).then((pRow) =>
		{
			if (pRow && pRow.IDDeliverable && tmpRouter) { tmpRouter.navigate('/deliverable/' + pRow.IDDeliverable); }
			else if (pRow && pRow.IDDeliverable) { this.show(); }
			else { this._toast('Could not add a deliverable: the server did not return a new record.', 'error'); }
		}).catch((pErr) =>
		{
			this._toast('Could not add a deliverable: ' + ((pErr && pErr.message) || pErr), 'error');
		});
	}

	openDeliverable(pID)
	{
		let tmpRouter = this._router();
		if (tmpRouter && pID) { tmpRouter.navigate('/deliverable/' + pID); }
	}

	dragStart(pEvent, pID)
	{
		this._drag = { ID: pID };
		if (pEvent && pEvent.dataTransfer)
		{
			pEvent.dataTransfer.effectAllowed = 'move';
			try { pEvent.dataTransfer.setData('text/plain', String(pID)); } catch (pErr) { /* ignore */ }
		}
	}

	allowDrop(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		if (pEvent && pEvent.dataTransfer) { pEvent.dataTransfer.dropEffect = 'move'; }
	}

	drop(pEvent, pLaneKey)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		let tmpDrag = this._drag;
		this._drag = null;
		let tmpBoard = this._board();
		if (!tmpDrag || !tmpBoard) { return; }
		let tmpSort = tmpBoard.nextSortOrder(pLaneKey);
		tmpBoard.moveCard(tmpDrag.ID, pLaneKey, tmpSort)
			.then(() => this.show())
			.catch((pErr) => { this._toast('Move failed: ' + ((pErr && pErr.message) || pErr), 'error'); });
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewDeliverableBoard;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-DeliverableBoard',
	DefaultRenderable: 'DeliverableBoard-Display',
	AutoRender: false,
	CSS: /*css*/`
		.ps-dlv { height: 100%; display: flex; flex-direction: column; gap: 14px; }
		.ps-dlv-head { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
		.ps-dlv-head h2 { font-size: 22px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; }
		.ps-dlv-new { font: inherit; font-size: 13px; border: 1px solid var(--theme-color-brand-primary, #2880a6); background: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); border-radius: 7px; padding: 6px 13px; cursor: pointer; }
		.ps-dlv-new:hover { filter: brightness(1.06); }
		.ps-dlv-stats { display: flex; gap: 8px; flex-wrap: wrap; margin-left: auto; }
		.ps-dlv-stat { background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #5b6376); border-radius: 999px; padding: 4px 11px; font-size: 12px; }
		.ps-dlv-stat b { color: var(--theme-color-text-primary, #2c3140); font-weight: 700; }
		/* One scroll region for the whole board (both axes); lanes and card stacks never scroll on
		   their own, so a busy lane can't spawn nested column scrollbars. */
		.ps-dlv-lanes { display: flex; gap: 12px; overflow: auto; align-items: flex-start; flex: 1; min-height: 0; padding-bottom: 8px; }
		.ps-dlv-lane { flex: 0 0 240px; width: 240px; background: var(--theme-color-background-secondary, #f1f3f7); border-radius: 10px; padding: 10px; display: flex; flex-direction: column; }
		.ps-dlv-lane-head { display: flex; align-items: center; justify-content: space-between; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); padding: 4px 6px 10px; }
		.ps-dlv-lane-count { background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); border-radius: 999px; padding: 1px 8px; font-size: 12px; }
		.ps-dlv-lane-cards { display: flex; flex-direction: column; gap: 8px; min-height: 40px; }
		.ps-dlv-card { background: var(--theme-color-background-panel, #fff); border-radius: 8px; padding: 9px 11px; border-left: 3px solid var(--theme-color-brand-primary, #7d63b8); cursor: pointer; box-shadow: 0 1px 2px rgba(0,0,0,0.06); }
		.ps-dlv-card:hover { box-shadow: 0 2px 6px rgba(0,0,0,0.12); }
		.ps-dlv-card[draggable="true"]:active { cursor: grabbing; }
		.ps-dlv-card-top { display: flex; align-items: baseline; gap: 6px; margin-bottom: 5px; }
		.ps-dlv-card-num { font-size: 11px; color: var(--theme-color-text-muted, #97a1ab); font-weight: 700; }
		.ps-dlv-card-title { font-size: 14px; color: var(--theme-color-text-primary, #2c3140); line-height: 1.25; }
		.ps-dlv-card-meta { display: flex; gap: 5px; flex-wrap: wrap; }
		.ps-dlv-chip { font-size: 11px; padding: 1px 7px; border-radius: 999px; background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #5b6376); }
		.ps-dlv-chip:empty { display: none; }
		.ps-dlv-chip-cust { background: transparent; color: var(--theme-color-text-muted, #97a1ab); padding-left: 0; }
		.ps-dlv-chip-exp { background: var(--theme-color-background-tertiary, #e3e8f0); }
		.ps-dlv-empty { color: var(--theme-color-text-muted, #97a1ab); font-size: 14px; padding: 24px 6px; }
	`,
	Templates:
	[
		{
			Hash: 'DeliverableBoard-Display',
			Template: /*html*/`
<div class="ps-page ps-dlv">
	<div class="ps-dlv-head">
		<h2>Deliver</h2>
		<button class="ps-dlv-new" onclick="_Pict.views['Plansheet-DeliverableBoard'].newDeliverable()">+ New deliverable</button>
		<div class="ps-dlv-stats">
			<span class="ps-dlv-stat"><b>{~D:AppData.DeliverableBoard.Counts.Total~}</b> total</span>
			<span class="ps-dlv-stat"><b>{~D:AppData.DeliverableBoard.Counts.Open~}</b> in flight</span>
			<span class="ps-dlv-stat"><b>{~D:AppData.DeliverableBoard.Counts.Accepted~}</b> accepted</span>
		</div>
	</div>
	<div class="ps-dlv-lanes">{~TS:DeliverableBoard-Lane:AppData.DeliverableBoard.ViewLanes~}</div>
	{~TS:DeliverableBoard-Empty:AppData.DeliverableBoard.Empty~}
</div>`
		},
		{
			Hash: 'DeliverableBoard-Lane',
			Template: /*html*/`
<div class="ps-dlv-lane" ondragover="_Pict.views['Plansheet-DeliverableBoard'].allowDrop(event)" ondrop="_Pict.views['Plansheet-DeliverableBoard'].drop(event,'{~D:Record.Key~}')">
	<div class="ps-dlv-lane-head"><span>{~D:Record.Label~}</span><span class="ps-dlv-lane-count">{~D:Record.Count~}</span></div>
	<div class="ps-dlv-lane-cards">{~TS:DeliverableBoard-Card:Record.Cards~}</div>
</div>`
		},
		{
			Hash: 'DeliverableBoard-Card',
			Template: /*html*/`
<div class="ps-dlv-card" draggable="true" ondragstart="_Pict.views['Plansheet-DeliverableBoard'].dragStart(event,{~D:Record.IDDeliverable~})" onclick="_Pict.views['Plansheet-DeliverableBoard'].openDeliverable({~D:Record.IDDeliverable~})">
	<div class="ps-dlv-card-top"><span class="ps-dlv-card-num">{~D:Record.NumberLabel~}</span><span class="ps-dlv-card-title">{~D:Record.Title~}</span></div>
	<div class="ps-dlv-card-meta"><span class="ps-dlv-chip ps-dlv-chip-cust">{~D:Record.CustomerName~}</span><span class="ps-dlv-chip ps-dlv-chip-exp">{~D:Record.ExpectationTitle~}</span><span class="ps-dlv-chip">{~D:Record.SubLabel~}</span></div>
</div>`
		},
		{
			Hash: 'DeliverableBoard-Empty',
			Template: /*html*/`<div class="ps-dlv-empty">{~D:Record.Message~}</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'DeliverableBoard-Display',
			TemplateHash: 'DeliverableBoard-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"pict-view":365}],665:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * DocEditor - the host chrome (save / back) around the rich markdown editor
 * (PictView-RichDocEditor = pict-section-markdowneditor). The body is a document
 * in the Docs Lake, addressed by PATH - not a ContentDocument row. The editor
 * mounts into #DocEditor-EditorHost, bound to AppData.RichDocEditor.Segments.
 *
 * Reached via app.showDocEditor(ownerType, idOwner, docPath, headerLabel). The
 * path must already exist in the lake; EntityDetail mints the path and its
 * DocEntityLink before opening the editor, so the editor only ever edits bytes.
 * The doc's title is its first H1 (no separate field). Images and drawings are
 * owned by the doc's entity (ownerType, idOwner), so they survive in the gallery.
 */
class PictViewDocEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._ownerType = '';
		this._idOwner = 0;
		this._docPath = '';
		this._saveTimer = null;
		this.pict.AppData.DocEditor = this.pict.AppData.DocEditor || { HeaderTitle: '', DocPath: '' };
		this.pict.AppData.RichDocEditor = this.pict.AppData.RichDocEditor || { Segments: [] };
	}

	_editorView() { return this.pict.views['Plansheet-RichDocEditor']; }

	/** The doc's owner entity - used by the rich editor for image / drawing ownership. */
	ownerContext() { return { OwnerType: this._ownerType, IDOwner: this._idOwner }; }

	showEditor(pOwnerType, pIDOwner, pDocPath, pHeaderLabel)
	{
		this._ownerType = pOwnerType;
		this._idOwner = Number(pIDOwner);
		this._docPath = String(pDocPath || '');

		let tmpState = this.pict.AppData.DocEditor;
		tmpState.DocPath = this._docPath;
		tmpState.HeaderTitle = pHeaderLabel || 'Edit document';

		this.pict.providers.DocLakeAPI.readDoc(this._docPath).then((pBody) =>
		{
			this.pict.AppData.RichDocEditor.Segments = [{ Content: pBody || '' }];
			this.render();
		});
	}

	/** Mount (or remount) the rich editor into the host container after render. */
	_mountEditor()
	{
		let tmpEditor = this._editorView();
		if (!tmpEditor)
		{
			this.pict.ContentAssignment.assignContent('#DocEditor-EditorHost',
				'<div style="padding:24px;color:var(--theme-color-text-secondary,#5b6376)">The rich editor is not available in this build.</div>');
			return;
		}
		try { if (tmpEditor.initialRenderComplete) { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; } } catch (pErr) { /* ignore */ }
		tmpEditor.render();
		tmpEditor.marshalToView();
		if (typeof tmpEditor.setPreviewMode === 'function') { tmpEditor.setPreviewMode('side'); }
	}

	/** Debounced autosave on any editor change. */
	onEditorChanged()
	{
		if (this._saveTimer) { clearTimeout(this._saveTimer); }
		this._saveTimer = setTimeout(() => { this._saveTimer = null; this._persist(true); }, 1200);
	}

	_persist(pSilent)
	{
		if (!this._docPath) { return; }
		let tmpEditor = this._editorView();
		let tmpBody = (tmpEditor && typeof tmpEditor.getAllContent === 'function') ? tmpEditor.getAllContent('\n\n') : '';
		return this.pict.providers.DocLakeAPI.saveDoc(this._docPath, tmpBody)
			.then(() => { if (!pSilent) { this._toast('Document saved.', 'success'); } })
			.catch((pErr) => { if (!pSilent) { this._toast('Save failed: ' + (pErr.message || pErr), 'error'); } });
	}

	save()
	{
		if (this._saveTimer) { clearTimeout(this._saveTimer); this._saveTimer = null; }
		let tmpResult = this._persist(false);
		if (tmpResult && typeof tmpResult.then === 'function') { tmpResult.then(() => this.back()); }
		else { this.back(); }
	}

	back()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showEntityDetail === 'function') { tmpApp.showEntityDetail(this._ownerType, this._idOwner); }
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._mountEditor();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewDocEditor;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-DocEditor',
	DefaultRenderable: 'DocEditor-Display',
	AutoRender: false,
	CSS: /*css*/`
		.ps-doc { padding: 16px 20px; height: 100%; display: flex; flex-direction: column; box-sizing: border-box; }
		.ps-doc-head { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
		.ps-doc-head h2 { font-size: 18px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; flex: 1; }
		.ps-doc-path { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin: -4px 0 10px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-doc-host { flex: 1; min-height: 0; display: flex; border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 8px; overflow: hidden; }
		.ps-doc-host > * { flex: 1; min-width: 0; }
		.pict-mde-button-drawing { font-size: 14px; }
	`,
	Templates:
	[
		{
			Hash: 'DocEditor-Display',
			Template: /*html*/`
<div class="ps-doc">
	<div class="ps-doc-head">
		<button class="ps-btn" onclick="_Pict.views['Plansheet-DocEditor'].back()">&larr; Back</button>
		<h2>{~D:AppData.DocEditor.HeaderTitle~}</h2>
		<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-DocEditor'].save()">Save</button>
	</div>
	<div class="ps-doc-path">{~D:AppData.DocEditor.DocPath~}</div>
	<div class="ps-doc-host" id="DocEditor-EditorHost"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'DocEditor-Display',
			TemplateHash: 'DocEditor-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"pict-view":365}],666:[function(require,module,exports){
'use strict';

/**
 * DrawingEditor — an interactive Excalidraw canvas in a full-screen overlay,
 * built on pict-section-excalidraw's ReactView. A drawing is stored as a single
 * self-contained SVG Media blob in Parime: exportSvg({exportEmbedScene:true})
 * embeds the full scene (and image data) in the SVG <metadata>, and the vendor's
 * loadFromBlob re-extracts it — so one blob round-trips an editable drawing
 * (no file tree, no JSON sidecar).
 *
 * Opened via app.showDrawingEditor({ OwnerType, IDOwner, IDMedia }, onInsert):
 *   - IDMedia 0  → new drawing; on save uploads a Drawing Media owned by
 *                  (OwnerType, IDOwner) and calls onInsert({ URL, Title, IDMedia }).
 *   - IDMedia >0 → edit an existing drawing; loads its SVG, re-saves the bytes.
 *
 * The React vendor globals (window.PictSectionExcalidrawVendor) come from the
 * vendored <script> tags in index.html; LazyLoad* are configured as a fallback.
 */

const libExcalidraw = require('pict-section-excalidraw');
const libFrameworkClient = require('../providers/FrameworkClient.js');

const _OVERLAY_ID = 'Plansheet-DrawingOverlay';

// pict-section-excalidraw's vendored react-global-shim maps the automatic JSX
// runtime's jsx/jsxs (type, props, key) to window.React.createElement (type,
// props, ...children) whenever window.React lacks its own jsx/jsxs/jsxDEV --
// which it always does, since 'react' and 'react/jsx-runtime' are separate
// entry points and only the former gets loaded as a global. createElement's
// 3rd positional argument means "child", not "key", so every element Excalidraw
// builds inside a .map() (color swatches, the stroke-width radio group, etc.)
// has its real children silently clobbered by its own React key. Patching
// window.React with a correct jsx/jsxs before the vendor scripts run fixes it
// at the source without touching the vendored bundle.
function _ensureReactJsxRuntime(pReact)
{
	if (!pReact || pReact.jsx) { return pReact; }
	let tmpCreateElement = pReact.createElement;
	let tmpJsx = function (pType, pProps, pKey)
	{
		let tmpProps = pProps || {};
		if (pKey !== undefined) { tmpProps = Object.assign({}, tmpProps, { key: pKey }); }
		return tmpCreateElement(pType, tmpProps);
	};
	pReact.jsx = tmpJsx;
	pReact.jsxs = tmpJsx;
	pReact.jsxDEV = tmpJsx;
	return pReact;
}

if (typeof window !== 'undefined' && !window.__PlansheetReactJsxRuntimePatched)
{
	window.__PlansheetReactJsxRuntimePatched = true;
	if (window.React)
	{
		_ensureReactJsxRuntime(window.React);
	}
	else
	{
		let tmpReactValue;
		Object.defineProperty(window, 'React',
		{
			configurable: true,
			enumerable: true,
			get() { return tmpReactValue; },
			set(pValue) { tmpReactValue = _ensureReactJsxRuntime(pValue); }
		});
	}
}

// pict-section-excalidraw's react-vendor.min.js sets window.ReactDOM from
// 'react-dom/client' alone (createRoot/hydrateRoot/version only) -- it never
// loads the base 'react-dom' entry, so createPortal (and flushSync) are
// missing. Excalidraw's color-picker popover renders through a real
// ReactDOM.createPortal, so opening it throws "createPortal is not a
// function" and takes the whole canvas down. createPortal doesn't need any
// renderer internals: react-dom's own implementation is just this tagged
// descriptor object, recognized generically by the reconciler via its
// well-known $$typeof (Symbol.for('react.portal'), stable since React 16 --
// see react-dom's ReactPortal.js). Providing it here fixes the popover at
// the source without touching the vendored bundle.
function _ensureReactDomPortal(pReactDOM)
{
	if (!pReactDOM || pReactDOM.createPortal) { return pReactDOM; }
	let _REACT_PORTAL_TYPE = (typeof Symbol === 'function' && Symbol.for) ? Symbol.for('react.portal') : 0xeaca;
	pReactDOM.createPortal = function (pChildren, pContainer, pKey)
	{
		if (!pContainer || pContainer.nodeType !== 1 && pContainer.nodeType !== 9 && pContainer.nodeType !== 11)
		{
			throw new Error('Target container is not a DOM element.');
		}
		return {
			$$typeof: _REACT_PORTAL_TYPE,
			key: (pKey === null || pKey === undefined) ? null : String(pKey),
			children: pChildren,
			containerInfo: pContainer,
			implementation: null
		};
	};
	if (!pReactDOM.flushSync) { pReactDOM.flushSync = function (pFn) { return pFn(); }; }
	return pReactDOM;
}

if (typeof window !== 'undefined' && !window.__PlansheetReactDomPortalPatched)
{
	window.__PlansheetReactDomPortalPatched = true;
	if (window.ReactDOM)
	{
		_ensureReactDomPortal(window.ReactDOM);
	}
	else
	{
		let tmpReactDomValue;
		Object.defineProperty(window, 'ReactDOM',
		{
			configurable: true,
			enumerable: true,
			get() { return tmpReactDomValue; },
			set(pValue) { tmpReactDomValue = _ensureReactDomPortal(pValue); }
		});
	}
}

function buildConfiguration()
{
	return {
		ViewIdentifier: 'Plansheet-DrawingEditor',
		DefaultRenderable: 'DrawingEditor-Overlay',
		DefaultDestinationAddress: '#' + _OVERLAY_ID,
		TargetElementAddress: '#DrawingEditor-Canvas',
		EmbedMode: 'react',
		Theme: 'auto',
		AssetBaseURL: '/js/excalidraw-assets/',
		LazyLoadReactVendorURL: '/js/react-vendor.min.js',
		LazyLoadWrapperURL: '/js/excalidraw-wrapper.min.js',
		DrawingDataAddress: false,
		AutoRender: false,
		CSS: /*css*/`
			#${_OVERLAY_ID}:empty { display: none; }
			.ps-draw { position: fixed; inset: 0; z-index: 4000; display: flex; flex-direction: column;
				background: var(--theme-color-background-default, #f4f6fa); }
			.ps-draw-bar { display: flex; align-items: center; gap: 12px; padding: 10px 16px;
				border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee);
				background: var(--theme-color-background-panel, #fff); }
			.ps-draw-bar .ps-draw-title { font-size: 15px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
			.ps-draw-bar input { flex: 1; max-width: 360px; }
			.ps-draw-spacer { flex: 1; }
			.ps-draw-canvas { flex: 1; min-height: 0; position: relative; }
			.ps-draw-canvas .pict-excalidraw-wrap, .ps-draw-canvas .pict-excalidraw-mount,
			.ps-draw-canvas .excalidraw, .ps-draw-canvas .excalidraw-container { height: 100%; width: 100%; }
		`,
		Templates:
		[
			{
				Hash: 'DrawingEditor-Overlay',
				Template: /*html*/`
<div class="ps-draw">
	<div class="ps-draw-bar">
		<span class="ps-draw-title">Drawing</span>
		<input class="ps-input" type="text" placeholder="Drawing title" value="{~D:AppData.DrawingEditor.Title~}" oninput="_Pict.views['Plansheet-DrawingEditor'].setTitle(this.value)">
		<span class="ps-draw-spacer"></span>
		<button class="ps-btn" onclick="_Pict.views['Plansheet-DrawingEditor'].cancel()">Cancel</button>
		<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-DrawingEditor'].saveAndInsert()">{~D:AppData.DrawingEditor.SaveLabel~}</button>
	</div>
	<div class="ps-draw-canvas" id="DrawingEditor-Canvas"></div>
</div>`
			}
		],
		Renderables:
		[
			{
				RenderableHash: 'DrawingEditor-Overlay',
				TemplateHash: 'DrawingEditor-Overlay',
				ContentDestinationAddress: '#' + _OVERLAY_ID
			}
		]
	};
}

class PictViewDrawingEditor extends libExcalidraw.ReactView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._ctx = null;
		this._onInsert = null;
		this.pict.AppData.DrawingEditor = this.pict.AppData.DrawingEditor || { Title: 'Drawing', SaveLabel: 'Save & insert' };
	}

	setTitle(pValue) { this.pict.AppData.DrawingEditor.Title = pValue; }

	open(pContext, fOnInsert)
	{
		// The excalidraw ReactView's destroy() is TERMINAL (it sets _destroyed and drops the React root),
		// and we reuse this one registered instance across opens. Without reviving it, the 2nd+ open renders
		// the overlay chrome but the excalidraw canvas + toolbar never mount (the mount lands in a half-dead
		// _destroyed state). Tear down any prior mount, then clear the terminal flag so this render mounts fresh.
		try { this.destroy(); } catch (pErr) { /* no prior mount */ }
		this._destroyed = false;
		this.initialRenderComplete = false;

		this._ctx = pContext || {};
		this._onInsert = (typeof fOnInsert === 'function') ? fOnInsert : null;
		// A routed opener (the Drawings page) passes onClose so cancel / save / close returns to /drawings;
		// the doc-embed picker passes none, so closing there just returns to the document underneath.
		this._onClose = (pContext && typeof pContext.onClose === 'function') ? pContext.onClose : null;
		this.pict.AppData.DrawingEditor.Title = this._ctx.Title || 'Drawing';
		// A standalone surface (the Drawings board) saves without "inserting" anywhere, so let the caller
		// relabel the primary button (default keeps the doc-editor's "Save & insert").
		this.pict.AppData.DrawingEditor.SaveLabel = this._ctx.SaveLabel || 'Save & insert';

		// Load an existing drawing's scene on mount, or start blank.
		if (this._ctx.IDMedia)
		{
			this.options.OnLoad = (pView, fCb) => this._loadExistingScene(this._ctx.IDMedia, fCb);
		}
		else
		{
			this.options.OnLoad = null;
		}

		// The overlay host (#Plansheet-DrawingOverlay) is part of the shell-rendered
		// DOM (PictView-Shell), so just render the editor into it (mounts React).
		this.render();
	}

	_loadExistingScene(pIDMedia, fCallback)
	{
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.loadFromBlob) { return fCallback(null, null); }
		libFrameworkClient.getText(this.pict, this.pict.providers.MediaAPI.blobURL(pIDMedia))
			.then((pSvg) => tmpVendor.loadFromBlob(new Blob([pSvg], { type: 'image/svg+xml' }), null, null))
			.then((pScene) => fCallback(null, { elements: (pScene && pScene.elements) || [], appState: (pScene && pScene.appState) || {}, files: (pScene && pScene.files) || {} }))
			.catch((pErr) => fCallback(pErr));
	}

	saveAndInsert()
	{
		this.exportSvg({ exportEmbedScene: true }).then((pSvgEl) =>
		{
			if (!pSvgEl) { return this._toast('Nothing to save.', 'info'); }
			let tmpSvg = new XMLSerializer().serializeToString(pSvgEl);
			let tmpBlob = new Blob([tmpSvg], { type: 'image/svg+xml' });
			let tmpTitle = this.pict.AppData.DrawingEditor.Title || 'Drawing';
			let tmpMedia = this.pict.providers.MediaAPI;
			let tmpCtx = this._ctx || {};

			let tmpPromise = tmpCtx.IDMedia
				? tmpMedia.updateBlob(tmpCtx.IDMedia, tmpBlob, 'image/svg+xml').then(() => ({ IDMedia: tmpCtx.IDMedia }))
				: tmpMedia.upload(tmpCtx.OwnerType || 'Vision', tmpCtx.IDOwner || 0, tmpBlob,
					{ MediaType: 'Drawing', MimeType: 'image/svg+xml', Title: tmpTitle, OriginalFileName: tmpTitle + '.excalidraw.svg' });

			tmpPromise.then((pRow) =>
			{
				let tmpID = pRow.IDMedia;
				let tmpURL = tmpMedia.blobURL(tmpID);
				let tmpOnInsert = this._onInsert;
				this.close();
				if (tmpOnInsert) { tmpOnInsert({ URL: tmpURL, Title: tmpTitle, IDMedia: tmpID }); }
			})
			.catch((pErr) => this._toast('Save failed: ' + (pErr.message || pErr), 'error'));
		})
		.catch((pErr) => this._toast('Export failed: ' + (pErr.message || pErr), 'error'));
	}

	cancel() { this.close(); }

	close()
	{
		// Fire the close hook once (a routed opener uses it to navigate back to its list route).
		let tmpOnClose = this._onClose;
		this._onClose = null;
		try { this.destroy(); } catch (pErr) { /* ignore */ }
		if (this.pict.ContentAssignment) { this.pict.ContentAssignment.assignContent('#' + _OVERLAY_ID, ''); }
		if (typeof tmpOnClose === 'function') { tmpOnClose(); }
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}
}

module.exports = PictViewDrawingEditor;
module.exports.default_configuration = buildConfiguration();

},{"../providers/FrameworkClient.js":576,"pict-section-excalidraw":205}],667:[function(require,module,exports){
'use strict';

/**
 * PictView-DrawingsPage
 * ---------------------
 * The Drawings board surface (Tools group). A gallery of Excalidraw drawings, each stored as one
 * self-contained SVG Media blob (OwnerType 'Drawing', IDOwner 0, team-visible per customer). New and
 * edit both open the shared full-screen Excalidraw editor (app.showDrawingEditor); the editor round-trips
 * the whole scene through the SVG, so a card reopens exactly where it was left. Because a drawing is an
 * SVG, each card shows the real thing as its thumbnail.
 *
 * Reuses PictView-DrawingEditor (the overlay + save/load) and MediaAPI (list/delete/blobURL); this view
 * only owns the list. Pict conventions: state in AppData.DrawingsPage, {~TS:~} iteration, inline handlers.
 */

const libPictView = require('pict-view');
const libModal = require('pict-section-modal');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Plansheet-DrawingsPage',
	DefaultRenderable: 'Plansheet-DrawingsPage',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,

	CSSPriority: 510,
	CSS: /*css*/`
		.ps-drawings-head { display: flex; align-items: center; gap: 12px; margin: 0 0 18px; }
		.ps-drawings-head h2 { flex: 1; font-size: 22px; font-weight: 600; margin: 0; color: var(--theme-color-text-primary, #1f2430); }
		.ps-drawings-new { font: inherit; font-size: 13px; border: 1px solid var(--theme-color-brand-primary, #2880a6); background: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); border-radius: 7px; padding: 7px 14px; cursor: pointer; }
		.ps-drawings-new:hover { filter: brightness(1.06); }
		.ps-drawings-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 14px; }
		.ps-drawing-card { position: relative; border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-panel, #fff); cursor: pointer; display: flex; flex-direction: column; }
		.ps-drawing-card:hover { border-color: var(--theme-color-brand-primary, #2880a6); box-shadow: 0 2px 10px rgba(20,40,80,0.08); }
		.ps-drawing-thumb { aspect-ratio: 4 / 3; background: var(--theme-color-background-secondary, #f4f6f9); display: flex; align-items: center; justify-content: center; overflow: hidden; }
		.ps-drawing-thumb img { width: 100%; height: 100%; object-fit: contain; display: block; }
		.ps-drawing-name { padding: 9px 11px; font-size: 13px; font-weight: 600; color: var(--theme-color-text-primary, #1f2430); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; border-top: 1px solid var(--theme-color-border-light, #eef1f5); }
		.ps-drawing-del { position: absolute; top: 6px; right: 6px; z-index: 2; width: 26px; height: 26px; border: none; border-radius: 6px; background: rgba(20,24,32,0.55); color: #fff; cursor: pointer; font-size: 15px; line-height: 1; display: inline-flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.15s ease; }
		.ps-drawing-card:hover .ps-drawing-del { opacity: 1; }
		.ps-drawing-del:hover { background: var(--theme-color-status-error, #c0392b); }
		.ps-drawings-empty { color: var(--theme-color-text-muted, #97a1ab); font-size: 14px; padding: 24px 4px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 10px; text-align: center; }
	`,

	Templates:
	[
		{
			Hash: 'Plansheet-DrawingsPage',
			Template: /*html*/`
<div class="ps-page ps-drawings" id="Plansheet-DrawingsPage-Root">
	<div class="ps-drawings-head">
		<h2>Drawings</h2>
		{~TS:DrawingsPage-New:AppData.DrawingsPage.NewSlot~}
	</div>
	<div class="ps-drawings-grid">{~TS:DrawingsPage-Card:AppData.DrawingsPage.Rows~}</div>
	{~TS:DrawingsPage-Empty:AppData.DrawingsPage.EmptySlot~}
</div>`
		},
		{
			Hash: 'DrawingsPage-New',
			Template: /*html*/`<button class="ps-drawings-new" onclick="_Pict.views['Plansheet-DrawingsPage'].newDrawing()">New drawing</button>`
		},
		{
			Hash: 'DrawingsPage-Card',
			Template: /*html*/`<div class="ps-drawing-card" onclick="_Pict.views['Plansheet-DrawingsPage'].editDrawing({~D:Record.IDMedia~})">{~TS:DrawingsPage-CardDel:Record.DelSlot~}<div class="ps-drawing-thumb"><img src="{~D:Record.URL~}" alt="{~D:Record.Title~}" loading="lazy" /></div><div class="ps-drawing-name">{~D:Record.Title~}</div></div>`
		},
		{
			Hash: 'DrawingsPage-CardDel',
			Template: /*html*/`<button class="ps-drawing-del" title="Delete drawing" onclick="event.stopPropagation();_Pict.views['Plansheet-DrawingsPage'].deleteDrawing({~D:Record.IDMedia~})">&times;</button>`
		},
		{
			Hash: 'DrawingsPage-Empty',
			Template: /*html*/`<div class="ps-drawings-empty">No drawings yet. Start one with &ldquo;New drawing&rdquo; to sketch and diagram on a full canvas.</div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'Plansheet-DrawingsPage', TemplateHash: 'Plansheet-DrawingsPage', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

class PictViewDrawingsPage extends libPictView
{
	onBeforeInitialize()
	{
		this._rows = [];
		return super.onBeforeInitialize();
	}

	_media() { return this.pict.providers.MediaAPI; }

	_canEdit()
	{
		let tmpApp = this.pict.PictApplication;
		return !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
	}

	// Route entry: load the team's drawings, then paint.
	show() { return this.reload(); }

	reload()
	{
		this._ensureModal();
		let tmpMedia = this._media();
		if (!tmpMedia) { this._rows = []; this._shape(); this.render(); return Promise.resolve(); }
		return tmpMedia.listForOwner('Drawing', 0)
			.then((pRows) =>
			{
				// Newest first, so a just-saved drawing lands at the top.
				this._rows = (Array.isArray(pRows) ? pRows : []).slice().sort((pA, pB) => (pB.IDMedia - pA.IDMedia));
				this._shape();
				this.render();
			})
			.catch(() => { this._rows = []; this._shape(); this.render(); });
	}

	_shape()
	{
		let tmpMedia = this._media();
		let tmpCanEdit = this._canEdit();
		this.pict.AppData.DrawingsPage =
		{
			ViewHash: this.Hash,
			NewSlot: tmpCanEdit ? [{ ViewHash: this.Hash }] : [],
			Rows: this._rows.map((pRow) => (
			{
				IDMedia: pRow.IDMedia,
				Title: pRow.Title || pRow.OriginalFileName || ('Drawing ' + pRow.IDMedia),
				URL: tmpMedia ? tmpMedia.blobURL(pRow.IDMedia) : ('/1.0/Media/' + pRow.IDMedia + '/Blob'),
				DelSlot: tmpCanEdit ? [{ IDMedia: pRow.IDMedia }] : []
			})),
			EmptySlot: this._rows.length ? [] : [1]
		};
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// Opening a drawing is a NAVIGATION -- new -> /drawings/new, existing -> /drawing/:id -- so the open
	// Excalidraw canvas deep-links and survives a reload (it used to open imperatively over /drawings, so a
	// reload discarded the whole canvas). The route calls openDrawingRoute to actually mount the editor.
	newDrawing()
	{
		if (!this._canEdit()) { return; }
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showNewDrawing === 'function') { tmpApp.showNewDrawing(); }
		else { this.openDrawingRoute(0); }
	}

	// The editor resolved a save with the drawing's { IDMedia, Title, URL }. Reconcile with the server,
	// then GUARANTEE the just-saved card is present: a plain re-read right after the write can miss the
	// just-created row (read-after-write / proxy timing), which showed as an empty gallery until a manual
	// reload. We know the row exists (the save resolved), so if the reconcile fetch missed it, we splice it
	// in from the definitive save result -- done after reload() so its result cannot clobber the card.
	_onSaved(pResult)
	{
		let tmpID = (pResult && pResult.IDMedia) ? pResult.IDMedia : 0;
		let tmpTitle = (pResult && pResult.Title) || 'Drawing';
		this.reload().then(() =>
		{
			if (tmpID && !this._rows.some((pRow) => pRow.IDMedia === tmpID))
			{
				this._rows.unshift({ IDMedia: tmpID, Title: tmpTitle });
				this._shape();
				this.render();
			}
		}).catch(() => {});
	}

	editDrawing(pIDMedia)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showDrawing === 'function') { tmpApp.showDrawing(pIDMedia); }
		else { this.openDrawingRoute(pIDMedia); }
	}

	// Route entry for /drawing/:id and /drawings/new: mount the Excalidraw editor overlay for the drawing
	// (0 = a new one). Cancel / save / close navigates back to /drawings (via the onClose hook), so the URL
	// leaves the open drawing. Read-only users still open the canvas to look; their save is denied server-side.
	openDrawingRoute(pIDMedia)
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp.showDrawingEditor !== 'function') { return; }
		let tmpID = Number(pIDMedia) || 0;
		let tmpRow = this._rows.find((pRow) => pRow.IDMedia === tmpID);
		let tmpTitle = tmpID ? ((tmpRow && (tmpRow.Title || tmpRow.OriginalFileName)) || 'Drawing') : 'Untitled drawing';
		let tmpSelf = this;
		tmpApp.showDrawingEditor(
			{
				OwnerType: 'Drawing', IDOwner: 0, IDMedia: tmpID, Title: tmpTitle, SaveLabel: 'Save',
				onClose: () => { if (tmpApp && typeof tmpApp.showDrawings === 'function') { tmpApp.showDrawings(); } }
			},
			(pResult) => tmpSelf._onSaved(pResult));
	}

	deleteDrawing(pIDMedia)
	{
		if (!this._canEdit()) { return; }
		let tmpMedia = this._media();
		if (!tmpMedia) { return; }
		this._confirm('Delete this drawing?', { title: 'Delete drawing', confirmLabel: 'Delete', dangerous: true })
			.then((pOk) => { if (pOk) { tmpMedia.remove(pIDMedia).then(() => this.show()).catch(() => {}); } });
	}

	_ensureModal()
	{
		if (!this.pict.views['Pict-Section-Modal']) { this.pict.addView('Pict-Section-Modal', libModal.default_configuration, libModal); }
		let tmpModalView = this.pict.views['Pict-Section-Modal'];
		if (tmpModalView && typeof document !== 'undefined' && document.body && typeof tmpModalView.initialize === 'function') { tmpModalView.initialize(); }
	}

	_confirm(pMessage, pOptions)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function') { return tmpModal.confirm(pMessage, pOptions || {}); }
		return Promise.resolve(true);
	}
}

module.exports = PictViewDrawingsPage;
module.exports.default_configuration = _DefaultConfiguration;

},{"pict-section-modal":271,"pict-view":365}],668:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');
const libDescriptors = require('../EntityDescriptors.js');
const libLabels = require('../libLabels.js');
const libShareUI = require('../BlueprintShareUI.js');
const libFocus = require('../FocusFilters.js');
const libPromptEmbed = require('../PromptEmbed.js');
const libMarkdownRender = require('./MarkdownRender.js');
const libCandidateSearch = require('../CandidateSearch.js');

function _escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/**
 * EntityDetail — the Phase-2 connective-tissue surface. showDetail(key, id)
 * renders one record's fields plus its relationships, driven by the entity's
 * `Relations` descriptor:
 *   - fk            single dropdown that sets a typed FK on the record (Feature→Module)
 *   - link          add/remove list backed by a join table (Feature↔Vision, Vision↔Vision)
 *   - inverse-fk    read-only list of records pointing here by FK (Module's Features, WorkItems about this)
 *   - inverse-join  read-only list of records linked here through a join (Vision's Features)
 *   - target        WorkItem "about": a type picker + an entity picker (typed nullable FK)
 *
 * Relationship targets are resolved from the entity providers' caches, so the
 * view loads all four entity lists + this record's join rows before rendering.
 * Linked chips are clickable to walk the graph. Tenancy is server-side.
 */
class PictViewEntityDetail extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._key = '';
		this._id = 0;
		this._linkRows = {};
		this._pending = {};
		this._targetType = null;
		// The rows resolve() fetched for each loaded entity key, for this view's own pickers to build
		// options from. Deliberately NOT the providers' shared store().List (WI #447) -- that belongs
		// to whichever list screen is paged to it, and this view opening in front of it must not move
		// that page.
		this._entityRows = {};
		this.pict.AppData.EntityDetail = this.pict.AppData.EntityDetail ||
			{ Key: '', HeaderTitle: '', BackLabel: '', Fields: [], Sections: [], AddressToggle: [], AddressedBadge: [] };
	}

	_fmt(pValue) { return (pValue === null || typeof pValue === 'undefined') ? '' : String(pValue); }
	_provider(pKey) { return this.pict.providers[pKey + 'API']; }
	// The rows resolve() fetched for pKey during this load, for a picker to build its options from.
	// NOT store().List (WI #447) -- see the note by _entityRows.
	_rows(pKey) { return this._entityRows[pKey] || []; }

	// A chip's name, resolved out of the target entity's Index. _resolveChipLabels() has already
	// fetched, by id, every linked record this load found missing from it (WI #448), so a miss here
	// means the record genuinely could not be read (deleted, wrong tenant) rather than simply never
	// fetched -- falling back to '#id' in that case is correct and stays.
	_label(pTargetKey, pID)
	{
		let tmpDesc = libDescriptors.Entities[pTargetKey];
		let tmpProvider = this._provider(pTargetKey);
		let tmpRow = tmpProvider && tmpProvider.store().Index[pID];
		return tmpRow ? (tmpRow[tmpDesc.TitleField] || ('#' + pID)) : ('#' + pID);
	}

	// Fetch, by id, exactly the linked records _label() would otherwise have fallen back to '#id' for:
	// a relation chip (link / inverse-join) whose target sits outside the capped page resolve() already
	// loaded for that entity (WI #448). This is the second-order half of WI #433/#445/#446 -- those fixed
	// what a PICKER can offer; an already-linked chip still needed its own name resolved. A single-record
	// read per missing id, not a wider list: cacheRecord() (WI #433) writes the target's Index only, the
	// same seam _label() reads, so this never disturbs a list screen paged to that entity. A record that
	// truly cannot be read (read() resolves null) is left unresolved; _label()'s '#id' fallback covers it.
	_resolveChipLabels(pRelations)
	{
		let tmpNeeded = {};
		let fNote = (pKey, pID) =>
		{
			if (!pKey || !pID || !libDescriptors.Entities[pKey]) { return; }
			let tmpProvider = this._provider(pKey);
			if (!tmpProvider || tmpProvider.store().Index[pID]) { return; }
			(tmpNeeded[pKey] = tmpNeeded[pKey] || {})[pID] = true;
		};
		pRelations.forEach((pRel, pIdx) =>
		{
			let tmpRows = this._linkRows[pIdx] || [];
			if (pRel.Render === 'link') { tmpRows.forEach((pR) => fNote(pRel.Target, pR[pRel.TargetField])); }
			else if (pRel.Render === 'inverse-join') { tmpRows.forEach((pR) => fNote(pRel.Target, pR[pRel.MapField])); }
		});
		let tmpReads = [];
		Object.keys(tmpNeeded).forEach((pKey) =>
		{
			let tmpProvider = this._provider(pKey);
			Object.keys(tmpNeeded[pKey]).forEach((pID) =>
			{
				tmpReads.push(tmpProvider.read(pID).then((pRow) => { if (pRow) { tmpProvider.cacheRecord(pRow); } }));
			});
		});
		return Promise.all(tmpReads);
	}

	// ── entry + load ─────────────────────────────────────────────────────────
	showDetail(pKey, pID)
	{
		if (!libDescriptors.Entities[pKey]) return;
		this._key = pKey;
		this._id = Number(pID);
		this._targetType = null;
		this._pending = {};
		// Fresh embedded-board state for this detail open. The token guards against a board fetch from a
		// previous navigation landing after we have moved on; _VisionBoardLoadedFor lets a re-render
		// (e.g. after editing a relation) re-mount the cached board without re-fetching.
		this._BoardNavToken = (this._BoardNavToken || 0) + 1;
		this._VisionBoardLoadedFor = null;
		this._VisionBoardID = null;
		this._VisionBoard = null;
		this._VisionBoardEditing = false;
		this._CommentsLoadedFor = null;
		this._StepsLoadedFor = null;
		this._fetch();
	}

	_fetch()
	{
		// The open record, resolved by id (not from the capped list). Reset per fetch. See WI #329.
		this._openRecord = null;
		let tmpDesc = libDescriptors.Entities[this._key];
		let tmpRelations = tmpDesc.Relations || [];
		// Load the entity caches this page resolves labels/pickers from: the four
		// SDLC bases, the open entity itself, and any relation Target/Source.
		let tmpLoadKeys = ['Vision', 'Module', 'Feature', 'WorkItem', this._key];
		tmpRelations.forEach((pRel) =>
		{
			if (pRel.Target && libDescriptors.Entities[pRel.Target]) { tmpLoadKeys.push(pRel.Target); }
			if (pRel.Source && libDescriptors.Entities[pRel.Source]) { tmpLoadKeys.push(pRel.Source); }
		});
		tmpLoadKeys = tmpLoadKeys.filter((pK, pIdx) => tmpLoadKeys.indexOf(pK) === pIdx);
		// resolve(), not list(): this view only needs to RESOLVE these records (labels, picker options),
		// not become the question a list screen is showing. list() would replace that screen's List,
		// reset its Page to 1 and overwrite its QueryKey out from under it -- opening any record used to
		// silently bounce the list behind it back to page one (WI #447). The rows still resolve() gives
		// back are kept here, for _buildSection's pickers to read instead of the shared store.
		this._entityRows = {};
		let tmpLoads = tmpLoadKeys.map((pK) => this._provider(pK).resolve().then((pRows) => { this._entityRows[pK] = pRows; }));
		// Per-vision words: a Vision's pages speak its own Drafting Kit. Resolve its
		// kit terms and label this page from them (falls back to the shell kit).
		this._scopeTerms = null;
		this._connectionStyle = null;
		this._stickerSet = null;
		this._stickerSetItems = null;
		if (this._key === 'Vision')
		{
			tmpLoads.push(libFrameworkClient.getJSON(this.pict, '/1.0/Vision/' + this._id + '/Lexicon')
				.catch(() => null)
				.then((pBody) => { if (pBody && pBody.Terms) { this._scopeTerms = pBody.Terms; } if (pBody && pBody.ConnectionStyle) { this._connectionStyle = pBody.ConnectionStyle; } if (pBody && typeof pBody.StickerSet === 'string') { this._stickerSet = pBody.StickerSet; } if (pBody && Array.isArray(pBody.StickerSetItems)) { this._stickerSetItems = pBody.StickerSetItems; } })
				.catch(() => {}));
		}
		// A vision picks its craft from the kits this tenant has imported (owned types only,
		// mirroring the import-only model). Load them to populate the header craft picker.
		this._ownedCrafts = [];
		if (libDescriptors.Entities[this._key].Craft && this.pict.providers.WorkflowAPI && typeof this.pict.providers.WorkflowAPI.getOwnedTypes === 'function')
		{
			tmpLoads.push(this.pict.providers.WorkflowAPI.getOwnedTypes()
				.then((pRows) => { this._ownedCrafts = Array.isArray(pRows) ? pRows : []; })
				.catch(() => {}));
		}
		this._blueprint = null;
		this._share = null;
		// Clear any pending blueprint pin selection carried over from a previously open entity (this
		// view is a reused singleton), so a fresh detail never opens with a stale item pre-selected.
		this._bpSelectedItem = 0;
		// Reset with the pin selection: this view is a reused singleton, so a stale subject would aim the
		// next entity's pins at the last one's blueprint.
		this._subject = null;
		if (libDescriptors.Entities[this._key].Blueprint)
		{
			// Addressing lives in BlueprintAPI now, so this box no longer knows which kind of entity it is
			// looking at, nor that a work item resolves to a different route than everything else.
			this._subject = this._bpAPI().subjectForEntity(this._key, this._id);
			tmpLoads.push(this._bpAPI().readSubject(this._subject)
				.then((pBody) => { this._blueprint = pBody || null; })
				.catch(() => {}));
			// Editors also load the public-share state so the compact block can show the share strip.
			if (this._canShare())
			{
				tmpLoads.push(libShareUI.fetchState(this.pict, this._subject).then((pSt) => { this._share = pSt || null; }).catch(() => {}));
			}
		}
		// Whiteboards attached to this entity. An owner can have several; the board section lists them
		// with a picker. Reset the selection on a fresh entity open (selectBoard/newBoard re-point it).
		this._ownerBoards = [];
		this._SelectedBoardID = 0;
		this._VisionBoardLoadedFor = null;

		if (libDescriptors.Entities[this._key].Moodboard && this.pict.providers.MoodboardAPI)
		{
			tmpLoads.push(this.pict.providers.MoodboardAPI.listForEntity(this._key, this._id)
				.then((pRows) =>
				{
					this._ownerBoards = Array.isArray(pRows) ? pRows : [];
					// A board named in the URL wins over "the first one", so a shared link opens what it says.
					let tmpWanted = Number(libFocus.readHashParams().board) || 0;
					let tmpNamed = tmpWanted && this._ownerBoards.find((pB) => Number(pB.IDMoodboard) === tmpWanted);
					if (tmpNamed) { this._SelectedBoardID = tmpNamed.IDMoodboard; }
					else if (this._ownerBoards[0]) { this._SelectedBoardID = this._ownerBoards[0].IDMoodboard; }
				})
				.catch(() => {}));
		}
		if (tmpRelations.some((pR) => pR.Render === 'sessions'))
		{
			tmpLoads.push(this.pict.providers.SessionAPI.listSessions());
		}
		// The Story timeline: the chronological set of sessions that advanced this
		// entity (descriptor Story: true -- WorkItem). Read from the dedicated endpoint
		// so it unions the scalar link and the SessionFileWorkItem join server-side.
		this._story = [];
		if (libDescriptors.Entities[this._key].Story && this.pict.providers.SessionAPI)
		{
			tmpLoads.push(this.pict.providers.SessionAPI.getWorkItemStory(this._id)
				.then((pRows) => { this._story = Array.isArray(pRows) ? pRows : []; })
				.catch(() => {}));
		}
		// The review history: the workflow WorkEvent timeline, surfaced for its qc.failed
		// (did-not-pass-QC) entries. Empty for a work item that never went through the gate.
		this._reviewHistory = [];
		if (libDescriptors.Entities[this._key].ReviewHistory && this.pict.providers.WorkflowAPI)
		{
			tmpLoads.push(this.pict.providers.WorkflowAPI.getTimeline(this._id)
				.then((pRows) => { this._reviewHistory = Array.isArray(pRows) ? pRows : []; })
				.catch(() => {}));
		}

		this._entityDocLinks = [];
		this._docTree = [];
		this._coreDocBody = '';
		this._coreDocPath = '';
		if (tmpRelations.some((pR) => pR.Render === 'docs' || pR.Render === 'core-doc' || pR.Render === 'doclink'))
		{
			tmpLoads.push(this.pict.providers.DocLakeAPI.tree().then((pNodes) => { this._docTree = pNodes; }));
			tmpLoads.push(this.pict.providers.LinkAPI.listLinksWhere('DocEntityLinks',
				[{ Field: 'EntityType', Value: this._key }, { Field: 'IDEntity', Value: this._id }]).then((pRows) => { this._entityDocLinks = pRows; }));
		}
		// Returned (WI #447's tests await it directly), which is otherwise unused: showDetail() fires
		// this and moves on, as it always has.
		return Promise.all(tmpLoads)
			.then(() => this._provider(this._key).read(this._id))
			.then((pOpenRecord) =>
			{
				// Resolve the open record directly by id and cache it, so the page renders even when the record
				// is outside the capped entity list (a large tenant; the list is /0/250 -- WI #329). Null means
				// it does not exist in this tenant; _rebuild falls back to the list cache, then a not-found state.
				this._openRecord = pOpenRecord || null;
				if (pOpenRecord) { this._provider(this._key).cacheRecord(pOpenRecord); }
				this._linkRows = {};
				this._mediaRows = {};
				this._subRows = {};
				let tmpJoinReads = tmpRelations.map((pRel, pIdx) =>
				{
					if (pRel.Render === 'link' || pRel.Render === 'inverse-join')
					{
						let tmpJoin = libDescriptors.Joins[pRel.Join];
						return this.pict.providers.LinkAPI.listLinks(tmpJoin.Plural, pRel.SelfField, this._id)
							.then((pRows) => { this._linkRows[pIdx] = pRows; });
					}
					if (pRel.Render === 'media')
					{
						return this.pict.providers.MediaAPI.listForOwner(this._key, this._id)
							.then((pRows) => { this._mediaRows[pIdx] = pRows; });
					}
					if (pRel.Render === 'subvisions')
					{
						let tmpJoin = libDescriptors.Joins[pRel.Join];
						return Promise.all(
							[
								this.pict.providers.LinkAPI.listLinks(tmpJoin.Plural, 'IDVisionSource', this._id),
								this.pict.providers.LinkAPI.listLinks(tmpJoin.Plural, 'IDVisionTarget', this._id)
							]).then((pRes) => { this._subRows[pIdx] = { Out: pRes[0] || [], In: pRes[1] || [] }; });
					}
					return Promise.resolve();
				});
				return this._ensureCoreDoc(tmpRelations)
					.then(() => Promise.all(tmpJoinReads))
					// Only for entities that actually draw the stacked relation sections (WI #448):
					// a Connections-grid entity's link/inverse-join chips render through the Connections
					// grid instead, which resolves its own titles server-side and never hits _label().
					.then(() => (tmpDesc.Connections ? null : this._resolveChipLabels(tmpRelations)))
					.then(() => this._loadCoreDocBody(tmpRelations));
			})
			.then(() => this._rebuild())
			// A single failed load in this fan-out (a transient server hiccup on any of the
			// entity caches, join reads, media, or docs) used to reject this whole chain with no
			// handler, so _rebuild never ran and the page was left blank -- the reported "forwarded
			// to a blank screen". Recover: tell the user, then rebuild from whatever is cached so the
			// header and fields still render and the page is usable (re-navigating retries the load).
			.catch((pErr) =>
			{
				if (this.pict && this.pict.log) { this.pict.log.warn('EntityDetail: a detail load failed (' + ((pErr && pErr.message) || pErr) + '); rendering from cache.'); }
				this._toast('Some of this page could not load: ' + ((pErr && pErr.message) || pErr), 'error');
				try { this._rebuild(); }
				catch (pRebuildErr) { if (this.pict && this.pict.log) { this.pict.log.error('EntityDetail: rebuild after load failure also threw: ' + ((pRebuildErr && pRebuildErr.message) || pRebuildErr)); } }
			});
	}

	_slug(pText) { return String(pText || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'doc'; }

	// The lake directory that holds an entity's documents. Vision docs match the
	// seed convention (entities/vision/<number>-<slug>); other entities use
	// entities/<type>/<id>.
	_entityDir(pRecord)
	{
		if (this._key === 'Vision') { return 'entities/vision/' + (pRecord.VisionNumber || this._id) + '-' + this._slug(pRecord.Name); }
		return 'entities/' + this._key.toLowerCase() + '/' + this._id;
	}

	// Ensure a Vision has one Core Vision Document in the lake, linked by
	// DocEntityLink(Role 'core'); create an empty one lazily on first open.
	_ensureCoreDoc(pRelations)
	{
		if (!pRelations.some((pR) => pR.Render === 'core-doc')) { return Promise.resolve(); }
		if ((this._entityDocLinks || []).some((pL) => String(pL.Role) === 'core')) { return Promise.resolve(); }
		let tmpProvider = this._provider(this._key);
		let tmpRecord = (tmpProvider && tmpProvider.store().Index[this._id]) || {};
		let tmpPath = this._entityDir(tmpRecord) + '/core.md';
		let tmpName = tmpRecord[libDescriptors.Entities[this._key].TitleField] || ('Vision #' + this._id);
		return this.pict.providers.DocLakeAPI.saveDoc(tmpPath, '# ' + tmpName + '\n')
			.then(() => this.pict.providers.LinkAPI.addLink('DocEntityLink',
				{ EntityType: this._key, IDEntity: this._id, DocPath: tmpPath, Role: 'core' }))
			.then((pRow) =>
			{
				this._entityDocLinks = (this._entityDocLinks || []).concat(
					[{ IDDocEntityLink: (pRow && pRow.IDDocEntityLink) || 0, EntityType: this._key, IDEntity: this._id, DocPath: tmpPath, Role: 'core' }]);
			})
			.catch(() => {});
	}

	// Read the core doc body from the lake so the detail pane can render it inline.
	_loadCoreDocBody(pRelations)
	{
		if (!pRelations.some((pR) => pR.Render === 'core-doc')) { return Promise.resolve(); }
		let tmpCore = (this._entityDocLinks || []).find((pL) => String(pL.Role) === 'core');
		if (!tmpCore) { this._coreDocBody = ''; this._coreDocPath = ''; return Promise.resolve(); }
		this._coreDocPath = tmpCore.DocPath;
		return this.pict.providers.DocLakeAPI.readDoc(tmpCore.DocPath).then((pBody) => { this._coreDocBody = pBody || ''; });
	}

	// Render the not-found state: a clear message in place of the field table, with every record section and
	// action zeroed out so nothing from a previous open leaks (this view is a reused singleton). An empty
	// .ps-detail-actions collapses via CSS, so hiding Edit is enough to hide the whole action bar. See WI #329.
	_renderNotFound(pState, pSingular)
	{
		let tmpSingular = pSingular || 'Record';
		pState.HeaderTitle = tmpSingular + ' not found';
		pState.Subtitle = '';
		pState.Fields = [];
		pState.Sections = [];
		pState.HeaderActions = [];
		pState.AddressToggle = [];
		pState.AddressedBadge = [];
		pState.DeleteSlot = [];
		pState.EditSlot = [];
		pState.CraftSlot = [];
		pState.BlueprintSlot = [];
		pState.BoardSlot = [];
		pState.LoopsSlot = [];
		pState.CoreDocSlot = [];
		pState.StepsSlot = [];
		pState.ConnectionsSlot = [];
		pState.WorkItemPromptsSlot = [];
		pState.StorySlot = [];
		pState.ReviewHistorySlot = [];
		pState.PromptsSlot = [];
		pState.ChecklistsSlot = [];
		pState.CommentsSlot = [];
		pState.NotFoundSlot = [{ Message: 'This ' + tmpSingular.toLowerCase() + ' could not be found. It may have been deleted, or it belongs to a different plan sheet.' }];
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (tmpRouter && typeof tmpRouter.setDocumentTitle === 'function') { tmpRouter.setDocumentTitle(pState.HeaderTitle); }
		this.render();
	}

	// ── build the AppData section model from loaded data (no fetch) ───────────
	_rebuild()
	{
		let tmpDesc = libDescriptors.Entities[this._key];
		let tmpProvider = this._provider(this._key);
		// Prefer the record read directly by id (WI #329); fall back to the list cache so a record in the
		// first 250 still renders if the read-one endpoint is briefly unavailable.
		let tmpRecord = this._openRecord || (tmpProvider && tmpProvider.store().Index[this._id]) || {};
		// Stash the loaded record so mounts that run after the render (prompts panel) can read its
		// fields (e.g. WorkItemNumber for the copy-paste run block) without re-fetching.
		this._loadedRecord = tmpRecord;
		let tmpState = this.pict.AppData.EntityDetail;

		tmpState.Key = this._key;
		tmpState.BackLabel = libLabels.title(this.pict, this._key, this._scopeTerms, tmpDesc.Title);

		// The record does not exist in this tenant (deleted, a different plan sheet, or a stale/typo id):
		// render a clear not-found state rather than an empty shell titled with the raw database id (WI #329).
		if (!tmpRecord[tmpDesc.IDField])
		{
			this._renderNotFound(tmpState, libLabels.singular(this.pict, this._key, this._scopeTerms, tmpDesc.Title.replace(/s$/, '')));
			return;
		}
		tmpState.NotFoundSlot = [];
		tmpState.EditSlot = [{}];
		let tmpTitleText = tmpRecord[tmpDesc.TitleField] || ('#' + this._id);
		let tmpSingular = libLabels.singular(this.pict, this._key, this._scopeTerms, tmpDesc.Title.replace(/s$/, ''));
		// Entities with a per-customer human number (descriptor NumberField) lead with it.
		let tmpNumber = tmpDesc.NumberField ? (Number(tmpRecord[tmpDesc.NumberField]) || 0) : 0;
		tmpState.HeaderTitle = tmpNumber
			? (tmpSingular + ' #' + tmpNumber + ': ' + tmpTitleText)
			: (tmpSingular + ': ' + tmpTitleText);
		// Keep the document title on this record's own name so a bookmark of the page, and the
		// recent-pages history, read distinctly instead of a constant "Plansheet". The detail route has
		// no static title, so it reset to the default first; this refines it once the record is loaded.
		let tmpRouter = this.pict.providers['Pict-Router'];
		if (tmpRouter && typeof tmpRouter.setDocumentTitle === 'function') { tmpRouter.setDocumentTitle(String(tmpTitleText || tmpState.HeaderTitle || '')); }
		// The notebook history row for this page was recorded on navigation with the generic default
		// title ("Plansheet"), because the record had not loaded yet. Now that its real name is on the
		// document title, re-record so history reads distinctly; the provider relabels that same row.
		if (this.pict.PictApplication && typeof this.pict.PictApplication.recordCurrentView === 'function') { this.pict.PictApplication.recordCurrentView(); }
		tmpState.Subtitle = (this._key === 'Vision') ? this._fmt(tmpRecord.Summary) : '';
		// The title lives in the header now, so it is not repeated as a field row.
		tmpState.Fields = tmpDesc.Fields.filter((pF) => pF.F !== tmpDesc.TitleField).map((pF) =>
		{
			let tmpRaw = tmpRecord[pF.F];
			// Likert fields display as a dot scale; Markdown-flagged fields render
			// in onAfterRender into a per-field container (data stays out of HTML).
			if (pF.T === 'likert') { return { L: pF.L, Value: libDescriptors.formatLikert(tmpRaw), WideClass: '', MDSlot: [] }; }
			let tmpMD = !!(pF.Markdown && String(tmpRaw || '').trim());
			// Long fields break onto their own full-width row: markdown, a textarea, or a plain text value
			// long enough that it would otherwise fill a narrow stat cell and strand the next one (a Summary).
			let tmpLongText = (pF.T === 'text' && String(tmpRaw || '').length > 80);
			return (
			{
				L: pF.L,
				Value: tmpMD ? '' : this._fmt(tmpRaw),
				WideClass: (tmpMD || pF.T === 'textarea' || tmpLongText) ? 'is-wide' : '',
				MDSlot: tmpMD ? [{ ContainerID: 'Detail-MD-' + pF.F, Body: String(tmpRaw) }] : []
			});
		});
		// Quick-scan stat fields lead; long / markdown fields drop to their own full-width rows below.
		tmpState.Fields.sort((pA, pB) => (pA.WideClass ? 1 : 0) - (pB.WideClass ? 1 : 0));

		// Descriptor-declared header actions (e.g. Routine's "Start test run"),
		// shown to users who can edit content.
		let tmpApp = this.pict.PictApplication;
		let tmpCanAct = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		tmpState.HeaderActions = (tmpCanAct ? (tmpDesc.HeaderActions || []) : []).map((pA) => ({ Label: pA.Label, Method: pA.Method }));

		// Addressable entities (Feedback): a header toggle to mark handled / reopen (edit
		// permission), and an "Addressed" badge with the date once it is marked.
		let tmpAddr = tmpDesc.Addressable;
		let tmpAddressedOn = !!(tmpAddr && libFocus.truthy(tmpRecord[tmpAddr.Field]));
		tmpState.AddressToggle = (tmpAddr && tmpCanAct)
			? [{ Label: tmpAddressedOn ? (tmpAddr.ReopenLabel || 'Reopen') : (tmpAddr.AddressLabel || 'Mark addressed') }]
			: [];
		let tmpAddressedDate = (tmpAddressedOn && tmpAddr.DateField && tmpRecord[tmpAddr.DateField]) ? String(tmpRecord[tmpAddr.DateField]).slice(0, 10) : '';
		tmpState.AddressedBadge = tmpAddressedOn
			? [{ Label: tmpAddressedDate ? ('Addressed ' + tmpAddressedDate) : 'Addressed' }]
			: [];
		// Header delete button (descriptor Deletable: true -- WorkItem). Same edit
		// permission as the other header actions; the record itself decides whether
		// deleting from here makes sense (soft delete, so it is always recoverable).
		tmpState.DeleteSlot = (tmpDesc.Deletable && tmpCanAct) ? [{}] : [];

		tmpState.BoardSlot = this._boardSlotFor(tmpDesc, tmpRecord);
		tmpState.CommentsSlot = this._commentsSlotFor(tmpDesc, tmpRecord);
		tmpState.ChecklistsSlot = this._checklistsSlotFor(tmpDesc, tmpRecord);
		tmpState.StepsSlot = this._stepsSlotFor(tmpDesc, tmpRecord);
		// A Connections-grid entity hosts its prompts inside the connections box, not as a separate section.
		tmpState.PromptsSlot = tmpDesc.Connections ? [] : this._promptsSlotFor(tmpDesc, tmpRecord);
		tmpState.BlueprintSlot = this._blueprintSlotFor(tmpDesc, tmpRecord);
		tmpState.StorySlot = this._storySlotFor(tmpDesc, tmpRecord);
		tmpState.ReviewHistorySlot = this._reviewHistorySlotFor(tmpDesc, tmpRecord);
		tmpState.CraftSlot = this._craftSlotFor(tmpDesc, tmpRecord);
		tmpState.LoopsSlot = this._loopsSlotFor(tmpDesc, tmpRecord);
		tmpState.ConnectionsSlot = this._connectionsSlotFor(tmpDesc, tmpRecord);
		tmpState.WorkItemPromptsSlot = this._workItemPromptsSlotFor(tmpDesc, tmpRecord);
		// The core document (Vision) is primary content, not a link list, so it gets its own
		// always-on slot -- unlike docs/media, the Connections grid has no equivalent for it, and a
		// Connections-grid entity's stacked relation Sections (below) are zeroed out.
		tmpState.CoreDocSlot = this._coreDocSlotFor(tmpDesc);
		// A Connections-grid entity shows its links in the grid, not the stacked relation sections.
		tmpState.Sections = tmpDesc.Connections ? [] : (tmpDesc.Relations || []).map((pRel, pIdx) => this._buildSection(pRel, pIdx, tmpRecord));
		this.render();
	}

	// Slot describing the embedded whiteboards section for entities that opt in (descriptor
	// Moodboard: true -- Vision and WorkItem). An owner can have several boards: a pill picker switches
	// the mounted one and a "new" button adds one. The label is the craft's Whiteboard word. Editing
	// needs content.edit. The board is mounted in onAfterRender (the container must exist first).
	_boardSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Moodboard) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		let tmpApp = this.pict.PictApplication;
		let tmpEditable = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		let tmpBoards = this._ownerBoards || [];
		// A read-only viewer sees nothing useful in an all-empty board section: hide it entirely rather than
		// a header over a blank box. Editors keep it (they can start a board), and content on any board keeps
		// the section so a viewer can open the one that has content.
		if (!tmpEditable && this._allBoardsEmpty(tmpBoards)) { return []; }
		let tmpSelected = Number(this._SelectedBoardID) || (tmpBoards[0] && tmpBoards[0].IDMoodboard) || 0;
		let tmpPills = tmpBoards.map((pB) => ({ ID: pB.IDMoodboard, Name: pB.Name || ('Whiteboard #' + pB.IDMoodboard), ActiveClass: (Number(pB.IDMoodboard) === tmpSelected) ? 'is-active' : '' }));
		let tmpLabel = libLabels.plural(this.pict, 'Whiteboard', this._scopeTerms, 'Whiteboards');
		return [{
			ContainerID: 'Vision-Board',
			Label: tmpLabel,
			CanEdit: tmpEditable,
			Boards: tmpPills,
			AddSlot: tmpEditable ? [{}] : [],
			EditSlot: (tmpEditable && tmpBoards.length) ? [{}] : [],
			// Rename / disconnect / delete the selected board. Editors only, and only when a board exists.
			MenuSlot: (tmpEditable && tmpBoards.length) ? [{}] : [],
			EmptySlot: tmpBoards.length ? [] : [{ CanEdit: tmpEditable }]
		}];
	}

	
	// One-or-zero element slot describing an embedded comments section for entities that opt in
	// (descriptor Comments: true -- Vision and WorkItem). Posting needs content.edit; everyone else
	// gets a read-only thread. The section is mounted in onAfterRender (the container must exist first).
	_commentsSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Comments) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		let tmpApp = this.pict.PictApplication;
		let tmpEditable = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		return [{ ContainerID: 'Entity-Comments', Label: 'Comments', Editable: tmpEditable }];
	}

	// One-or-zero element slot for the embedded checklists section (descriptor Checklist: true --
	// WorkItem). These are the SHARED, blueprint-visible checklists on the work item (private personal
	// lists live on the Checklists page, not here). Mounted in onAfterRender (the container must exist).
	_checklistsSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Checklist) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		return [{ ContainerID: 'Entity-Checklists', Label: 'Checklists' }];
	}

	// One-or-zero element slot for the embedded three-loops view (descriptor Loops: true -- Vision).
	// Mounted in onAfterRender (the container must exist first).
	_loopsSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Loops) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		return [{ ContainerID: 'Entity-VisionLoops', Label: 'Refinement loops' }];
	}

	// One-or-zero element slot for the inline Core Vision Document reader (descriptor relation
	// Render: 'core-doc' -- Vision). Always on regardless of Connections (the Vision detail page's
	// stacked relation Sections are zeroed out for Connections-grid entities, and the Connections
	// grid itself has no equivalent for a singleton document body).
	_coreDocSlotFor(pDesc)
	{
		let tmpRelations = (pDesc && pDesc.Relations) || [];
		let tmpRel = tmpRelations.find((pR) => pR.Render === 'core-doc');
		if (!tmpRel) { return []; }
		let tmpHasBody = !!String(this._coreDocBody || '').trim();
		return [{ Label: tmpRel.Label || 'Core document', HasBody: tmpHasBody ? [{}] : [], EmptySlot: tmpHasBody ? [] : [{}] }];
	}

	// One-or-zero element slot describing the embedded ordered-step editor for entities
	// that opt in (descriptor Steps: true -- Routine). Editing needs content.edit; everyone
	// else gets read-only step cards. Mounted in onAfterRender (the container must exist first).
	_stepsSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Steps) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		let tmpApp = this.pict.PictApplication;
		let tmpEditable = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		return [{ ContainerID: 'Routine-Steps', Label: 'Steps', Editable: tmpEditable }];
	}

	// One-or-zero element slot describing the attached-prompts panel for entities that
	// opt in (descriptor Prompts: true -- WorkItem; TestRun gets it in the runner).
	// Attaching/detaching needs content.edit; everyone can read the pinned versions
	// and record runs. Mounted in onAfterRender (the container must exist first).
	_promptsSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Prompts) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		return [{ ContainerID: 'Entity-Prompts', Label: 'Prompts' }];
	}

	// One-or-zero element slot for the Blueprint title block (descriptor Blueprint:
	// true -- WorkItem). The visual is drawn into the container in onAfterRender
	// from the data loaded in _fetch.
	_blueprintSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Blueprint) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		return [{ ContainerID: 'Entity-Blueprint' }];
	}

	// Slot describing the Story panel (descriptor Story: true -- WorkItem): a chronological
	// timeline of the Claude sessions that advanced this work item. Read-only display; a
	// session is linked to a work item by the upload/MCP flow, and this panel narrates the
	// whole set (several sessions read as one story) with a link into each session's page.
	_storySlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Story) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		let tmpKindLabels = { feedback: 'Feedback', prompt: 'Prompt generated', run: 'Prompt run', session: 'Session', validated: 'Validated', asbuilt: 'As-Built' };
		let tmpEntries = this._story || [];
		let tmpItems = tmpEntries.map((pE, pIdx) =>
		{
			let tmpKind = pE.Kind || 'session';
			let tmpIsSession = (tmpKind === 'session');
			// Session entries keep their richness (model chip, stat chips, outcome badge); the other loop
			// moments (feedback / prompt / run / validated) show a kind badge + a one-line detail.
			let tmpStats = [];
			let tmpModelSlot = [];
			let tmpOutcomeLabel = '';
			let tmpOutcomeClass = '';
			if (tmpIsSession)
			{
				if (pE.PromptCount) { tmpStats.push({ Text: pE.PromptCount + (pE.PromptCount === 1 ? ' prompt' : ' prompts') }); }
				if (pE.ToolCallCount) { tmpStats.push({ Text: pE.ToolCallCount + (pE.ToolCallCount === 1 ? ' tool call' : ' tool calls') }); }
				if (pE.AgentCount) { tmpStats.push({ Text: pE.AgentCount + (pE.AgentCount === 1 ? ' agent' : ' agents') }); }
				let tmpDuration = this._storyDuration(pE.TotalDurationMs);
				if (tmpDuration) { tmpStats.push({ Text: tmpDuration }); }
				if (pE.Model) { tmpModelSlot = [{ Model: pE.Model }]; }
				tmpOutcomeLabel = pE.Outcome || 'Unknown';
				tmpOutcomeClass = 'ps-story-outcome-' + String(tmpOutcomeLabel).toLowerCase();
			}
			else if (tmpKind === 'run' && pE.Outcome)
			{
				tmpOutcomeLabel = pE.Outcome;
				tmpOutcomeClass = 'ps-story-outcome-' + String(pE.Outcome).toLowerCase();
			}
			return (
			{
				ID: pE.ID || 0,
				Num: pIdx + 1,
				KindLabel: tmpKindLabels[tmpKind] || tmpKind,
				KindClass: 'ps-story-kind-' + tmpKind,
				LinkSlot: tmpIsSession ? [{ ID: pE.ID, Title: pE.Title || ('Session #' + pE.ID) }] : [],
				PlainSlot: tmpIsSession ? [] : [{ Title: pE.Title || '' }],
				When: this._storyWhen(pE.At),
				ModelSlot: tmpModelSlot,
				DetailSlot: (!tmpIsSession && pE.Detail) ? [{ Detail: pE.Detail }] : [],
				OutcomeLabel: tmpOutcomeLabel,
				OutcomeClass: tmpOutcomeClass,
				Stats: tmpStats
			});
		});
		return [{
			Label: 'Story',
			CountLabel: tmpItems.length ? (tmpItems.length + (tmpItems.length === 1 ? ' event' : ' events')) : '',
			Items: tmpItems,
			EmptySlot: tmpItems.length ? [] : [{}]
		}];
	}

	// Slot describing the Review history panel (descriptor ReviewHistory: true -- WorkItem): the
	// QC decisions from the workflow WorkEvent timeline. Surfaces each qc.failed (did-not-pass-QC)
	// event with its reason, note, and linked-issue count, plus a summary line. The panel only
	// appears once a work item has some review history (a fail, rework, or a passed validation).
	_reviewHistorySlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.ReviewHistory) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		let tmpFails = (this._reviewHistory || []).filter((pEvent) => pEvent && pEvent.Type === 'qc.failed');
		let tmpItems = tmpFails.map((pEvent, pIdx) =>
		{
			let tmpPayload = pEvent.Payload || {};
			let tmpIssueCount = Array.isArray(tmpPayload.IDIssues) ? tmpPayload.IDIssues.length : 0;
			return (
			{
				Num: pIdx + 1,
				Reason: tmpPayload.ReasonCode || 'Other',
				When: pEvent.At ? this._storyWhen(new Date(pEvent.At).toISOString()) : '',
				NoteSlot: tmpPayload.Note ? [{ Note: tmpPayload.Note }] : [],
				IssuesSlot: tmpIssueCount ? [{ Label: tmpIssueCount + (tmpIssueCount === 1 ? ' issue' : ' issues') }] : []
			});
		});
		let tmpRework = Number(pRecord.ReworkCount) || 0;
		let tmpValidated = !!pRecord.ValidationDate;
		if (!tmpItems.length && !tmpRework && !tmpValidated) { return []; }
		let tmpSummary = tmpValidated
			? ('Passed review' + (this._storyWhen(pRecord.ValidationDate) ? (' ' + this._storyWhen(pRecord.ValidationDate)) : ''))
			: (tmpRework ? ('Sent back ' + tmpRework + (tmpRework === 1 ? ' time' : ' times')) : 'In review');
		return [{
			Label: 'Review history',
			Summary: tmpSummary,
			SummaryClass: tmpValidated ? 'ps-review-ok' : (tmpRework ? 'ps-review-warn' : ''),
			Items: tmpItems,
			EmptySlot: tmpItems.length ? [] : [{}]
		}];
	}

	// Human duration for a session length in milliseconds (drops to '' for zero/unknown).
	_storyDuration(pMs)
	{
		let tmpMs = Number(pMs) || 0;
		if (tmpMs < 1000) { return ''; }
		let tmpMinutes = Math.round(tmpMs / 60000);
		if (tmpMinutes < 1) { return 'under a minute'; }
		if (tmpMinutes < 60) { return tmpMinutes + 'm'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		let tmpRem = tmpMinutes % 60;
		return tmpRem ? (tmpHours + 'h ' + tmpRem + 'm') : (tmpHours + 'h');
	}

	// Readable timestamp for a session start (falls back to the raw string if unparseable).
	_storyWhen(pTimestamp)
	{
		if (!pTimestamp) { return ''; }
		let tmpDate = new Date(pTimestamp);
		if (isNaN(tmpDate.getTime())) { return String(pTimestamp); }
		return tmpDate.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
	}

	// One-or-zero element slot for the connections grid (descriptor Connections: true). The grid takes
	// the place of the entity's stacked relation sections; mounted in onAfterRender (container first).
	_connectionsSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Connections) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		return [{ ContainerID: 'Entity-Connections' }];
	}

	// One-or-zero element slot for a read-only "prompts from linked work items" section (descriptor
	// WorkItemPrompts: true -- Feedback). It surfaces the prompts of the work items this record links
	// to (via the FeedbackWorkItem join), so the feedback page can read + copy them without leaving.
	// The prompts stay owned by their work item; this is a display through the relation. Mounted in
	// onAfterRender (the container must exist first).
	_workItemPromptsSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.WorkItemPrompts) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		return [{ ContainerID: 'Entity-WorkItemPrompts', Label: 'Prompts from linked work items' }];
	}

	// One-or-zero element slot for the header craft picker (descriptor Craft: true -- Vision). Lists
	// the kits this tenant has imported plus a "House default" (clear). Editors get a <select> that
	// re-points the vision's craft; everyone else sees the current craft name. The vision's words come
	// from its craft once set, so changing it relabels this page (and its work items' blueprints).
	_craftSlotFor(pDesc, pRecord)
	{
		if (!pDesc || !pDesc.Craft) { return []; }
		let tmpID = pRecord && pRecord[pDesc.IDField];
		if (!tmpID) { return []; }
		let tmpApp = this.pict.PictApplication;
		let tmpEditable = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		let tmpCurrent = Number(pRecord.IDVisionType) || 0;
		let tmpOwned = this._ownedCrafts || [];
		let tmpMatch = tmpOwned.find((pC) => Number(pC.ID) === tmpCurrent);
		let tmpCurrentName = tmpMatch ? (tmpMatch.Name || tmpMatch.TypeKey || ('Kit ' + tmpMatch.ID)) : 'House default';
		let tmpOptions = [{ Value: 0, Label: 'House default', SelectedAttr: tmpCurrent ? '' : 'selected' }]
			.concat(tmpOwned.map((pC) => ({ Value: pC.ID, Label: pC.Name || pC.TypeKey || ('Kit ' + pC.ID), SelectedAttr: (Number(pC.ID) === tmpCurrent ? 'selected' : '') })));
		return [{
			EditSlot: tmpEditable ? [{ Options: tmpOptions }] : [],
			ReadSlot: tmpEditable ? [] : [{ Name: tmpCurrentName }]
		}];
	}

	// Re-point this vision's craft, persist it, then reload so the page (and blueprints) relabel.
	setCraft(pValue)
	{
		let tmpIDVisionType = parseInt(pValue, 10) || 0;
		libFrameworkClient.putJSON(this.pict, '/1.0/Vision/' + this._id + '/Craft', { IDVisionType: tmpIDVisionType })
			.then(() => this._fetch())
			.catch((pError) => { if (this.pict && this.pict.log) { this.pict.log.warn('Could not set the vision craft: ' + pError.message); } });
	}

	_buildSection(pRel, pIdx, pRecord)
	{
		let tmpSection = { Idx: pIdx, Label: pRel.Label, FkSlot: [], LinkSlot: [], InverseSlot: [], TargetSlot: [], SessionsSlot: [], DocsSlot: [], MediaSlot: [], DocLinkSlot: [], SubVisionSlot: [] };

		if (pRel.Render === 'fk')
		{
			// A server-backed candidate search (WI #446), not this._rows(pRel.Target) -- that is at most
			// one page (WI #433), so a target past it could not be chosen. Mounted post-render by
			// _mountRelationPickers(); this slot just carries the host div. See CandidateSearch.js.
			//
			// LIVE for Contact and Call, the two 'fk' entities that are not Connections:true -- this
			// stacked-sections UI is genuinely how a person edits their fk fields today. Every OTHER 'fk'
			// entity (Feature, Feedback, AsBuilt, Issue, Expectation, Deliverable) is Connections:true,
			// which zeroes Sections entirely in _rebuild() (`tmpDesc.Connections ? [] : ...`) -- the
			// Connections grid replaces this UI for them, fed by a different, already-unbounded server
			// endpoint (Connections-Endpoint.js Candidates, no page cap) that does not have WI #446's bug.
			// Kept converted (consistent, correct if a descriptor ever drops Connections) rather than
			// special-cased away.
			tmpSection.FkSlot = [{ Field: pRel.Field, Idx: pIdx, ContainerID: 'rel-fk-host-' + pIdx }];
		}
		else if (pRel.Render === 'link')
		{
			let tmpJoin = libDescriptors.Joins[pRel.Join];
			let tmpRows = this._linkRows[pIdx] || [];
			let tmpItems = tmpRows.filter((pR) => String(pR.RelationType) !== 'Decomposes').map((pR) =>
				({
					Idx: pIdx, JoinID: pR[tmpJoin.ID],
					TargetKey: pRel.Target, TargetID: pR[pRel.TargetField],
					Label: this._label(pRel.Target, pR[pRel.TargetField]),
					RelType: pRel.RelationType ? (pR.RelationType || '') : ''
				}));
			// A server-backed candidate search (WI #446), not this._rows(pRel.Target) -- see the fk branch
			// above. AddSlot used to be gated on the current page holding an unlinked candidate; with a
			// server search there is no "current page" to check, so it is always offered now (a bug fix in
			// its own right -- a real candidate past page one used to hide the add UI entirely). Already-
			// linked ids and (a self-referencing relation) this record's own id are excluded server-side
			// results, not filtered out of a precomputed list; _mountRelationPickers() supplies them.
			//
			// EVERY entity that declares Render: 'link' (Vision, Feature, WorkItem, Issue, Feedback) is
			// also Connections: true, so -- same as the fk branch's note on Feature/Feedback/Issue/etc --
			// this AddSlot never actually paints; the Connections grid's own linker is the live UI, backed
			// by Connections-Endpoint.js Candidates (already unbounded, no page cap). Kept converted rather
			// than special-cased away.
			tmpSection.LinkSlot = [{
				Idx: pIdx,
				Items: tmpItems,
				EmptySlot: tmpItems.length ? [] : [{}],
				AddSlot: [{
					Idx: pIdx,
					ContainerID: 'rel-link-add-host-' + pIdx,
					RelTypeSlot: pRel.RelationType ? [{ Idx: pIdx, Options: libDescriptors.RelationTypes.map((pT) => ({ Value: pT })) }] : []
				}]
			}];
		}
		else if (pRel.Render === 'inverse-join')
		{
			let tmpRows = this._linkRows[pIdx] || [];
			let tmpItems = tmpRows.map((pR) => ({ TargetKey: pRel.Target, TargetID: pR[pRel.MapField], Label: this._label(pRel.Target, pR[pRel.MapField]), Sub: '' }));
			tmpSection.InverseSlot = [{ Items: tmpItems, EmptySlot: tmpItems.length ? [] : [{}] }];
		}
		else if (pRel.Render === 'inverse-fk')
		{
			let tmpSourceDesc = libDescriptors.Entities[pRel.Source];
			let tmpList = this._rows(pRel.Source).filter((pR) => String(pR[pRel.SourceField]) === String(this._id));
			let tmpItems = tmpList.map((pR) =>
				({ TargetKey: pRel.Source, TargetID: pR[tmpSourceDesc.IDField], Label: pR[tmpSourceDesc.TitleField] || ('#' + pR[tmpSourceDesc.IDField]), Sub: (pRel.SubField ? pR[pRel.SubField] : (pR.Status || pR.Type)) || '' }));
			tmpSection.InverseSlot = [{
				Items: tmpItems,
				EmptySlot: tmpItems.length ? [] : [{}],
				// Optional create-from-here button (Create: { Label, Prefill }).
				CreateSlot: pRel.Create ? [{ Idx: pIdx, Label: pRel.Create.Label }] : []
			}];
		}
		else if (pRel.Render === 'target')
		{
			// Converted for WI #446 (a server-backed candidate search, not this._rows(tmpDraftType) -- see
			// the fk branch above), but WorkItem is the only entity that declares Render: 'target' and
			// WorkItem also declares Connections: true, which zeroes out Sections entirely in _rebuild()
			// (`tmpDesc.Connections ? [] : ...`) -- the Connections grid takes the stacked sections' place
			// for those entities, and its own manifest (Connections-Endpoint.js) has no 'about' entry, so
			// this branch never actually paints in the shipped UI. Left converted (correct if it is ever
			// reconnected) rather than deleted, and flagged rather than silently left as dead code passing
			// for a fix -- the two live "This work is about" pickers (spawnWorkItemFromFeedback,
			// spawnWorkItemFromIssue, both create-time) are the ones WI #446 actually fixed.
			let tmpDraftType = this._targetType || pRecord.TargetType || 'None';
			let tmpTypeOptions = libDescriptors.WorkItemTargetTypes.map((pT) => ({ Value: pT, SelectedAttr: (pT === tmpDraftType ? 'selected' : '') }));
			let tmpEntitySlot = (tmpDraftType !== 'None' && libDescriptors.Entities[tmpDraftType])
				? [{ ContainerID: 'rel-target-host-' + pIdx }] : [];
			tmpSection.TargetSlot = [{ TypeOptions: tmpTypeOptions, EntitySlot: tmpEntitySlot }];
		}
		else if (pRel.Render === 'sessions')
		{
			let tmpAll = (this.pict.AppData.Sessions && this.pict.AppData.Sessions.List) || [];
			let tmpItems = tmpAll.filter((pS) => String(pS[pRel.Field]) === String(this._id)).map((pS) =>
				({
					ID: pS.IDSessionFile,
					Title: pS.Title || pS.OriginalFileName || ('Session #' + pS.IDSessionFile),
					Field: pRel.Field,
					OutcomeOptions: libDescriptors.WorkOutcomes.map((pO) => ({ Value: pO, SelectedAttr: (String(pO) === String(pS.WorkOutcome || 'Unknown') ? 'selected' : '') }))
				}));
			let tmpAddOptions = tmpAll.filter((pS) => String(pS[pRel.Field]) !== String(this._id)).map((pS) =>
				({ Value: pS.IDSessionFile, Label: pS.Title || ('Session #' + pS.IDSessionFile) }));
			tmpSection.SessionsSlot = [{
				Idx: pIdx,
				Items: tmpItems,
				EmptySlot: tmpItems.length ? [] : [{}],
				AddSlot: tmpAddOptions.length ? [{ Idx: pIdx, Options: [{ Value: '', Label: '— select a session —' }].concat(tmpAddOptions) }] : []
			}];
		}
		else if (pRel.Render === 'docs')
		{
			let tmpDocLake = this.pict.providers.DocLakeAPI;
			let tmpItems = (this._entityDocLinks || []).filter((pL) => String(pL.Role) === 'doc').map((pL) =>
				({ JoinID: pL.IDDocEntityLink, Path: pL.DocPath, Title: tmpDocLake.titleFor(pL.DocPath) || '(untitled)' }));
			tmpSection.DocsSlot = [{ Items: tmpItems, EmptySlot: tmpItems.length ? [] : [{}] }];
		}
		else if (pRel.Render === 'media')
		{
			let tmpList = this._mediaRows[pIdx] || [];
			let tmpItems = tmpList.map((pM) =>
			{
				let tmpIsImage = (String(pM.MimeType || '').indexOf('image/') === 0) || (pM.MediaType === 'Screenshot');
				// Videos get an inline <video controls> (the blob endpoint serves byte
				// ranges, so seeking works); the MimeType prefix is the test because
				// MediaType 'Recording' also covers audio.
				let tmpIsVideo = String(pM.MimeType || '').indexOf('video/') === 0;
				let tmpURL = '/1.0/Media/' + pM.IDMedia + '/Blob';
				let tmpTitle = pM.Title || pM.OriginalFileName || ('Media #' + pM.IDMedia);
				return (
				{
					ID: pM.IDMedia, Field: pRel.Field, Title: tmpTitle, URL: tmpURL,
					ImageSlot: tmpIsImage ? [{ URL: tmpURL, Title: tmpTitle }] : [],
					VideoSlot: tmpIsVideo ? [{ URL: tmpURL, Title: tmpTitle }] : [],
					FileSlot: (tmpIsImage || tmpIsVideo) ? [] : [{ URL: tmpURL, Title: tmpTitle, Type: pM.MediaType || 'file' }]
				});
			});
			tmpSection.MediaSlot = [{ Idx: pIdx, Items: tmpItems, EmptySlot: tmpItems.length ? [] : [{}] }];
		}
		else if (pRel.Render === 'doclink')
		{
			let tmpDocLake = this.pict.providers.DocLakeAPI;
			let tmpRefs = (this._entityDocLinks || []).filter((pL) => String(pL.Role) === 'ref');
			let tmpLinkedPaths = tmpRefs.map((pL) => pL.DocPath);
			let tmpItems = tmpRefs.map((pL) =>
				({ Idx: pIdx, JoinID: pL.IDDocEntityLink, Path: pL.DocPath, Title: tmpDocLake.titleFor(pL.DocPath) || '(untitled)' }));
			let tmpAddOptions = (this._docTree || [])
				.filter((pN) => pN.NodeType === 'file'
					&& String(pN.Path).indexOf('entities/') !== 0
					&& String(pN.Name).charAt(0) !== '_'
					&& tmpLinkedPaths.indexOf(pN.Path) < 0)
				.map((pN) => ({ Value: pN.Path, Label: pN.Title || pN.Name }));
			tmpSection.DocLinkSlot = [{
				Idx: pIdx,
				Items: tmpItems,
				EmptySlot: tmpItems.length ? [] : [{}],
				AddSlot: tmpAddOptions.length ? [{ Idx: pIdx, Options: [{ Value: '', Label: '— link a document —' }].concat(tmpAddOptions) }] : []
			}];
		}

		else if (pRel.Render === 'subvisions')
		{
			let tmpJoin = libDescriptors.Joins[pRel.Join];
			let tmpSub = this._subRows[pIdx] || { Out: [], In: [] };
			let tmpChildRows = (tmpSub.Out || []).filter((pR) => String(pR.RelationType) === 'Decomposes');
			let tmpParentRows = (tmpSub.In || []).filter((pR) => String(pR.RelationType) === 'Decomposes');
			let tmpVisions = (this._provider('Vision').store().Index) || {};
			let tmpChildren = tmpChildRows.map((pR) =>
			{
				let tmpV = tmpVisions[pR.IDVisionTarget] || {};
				return { Idx: pIdx, JoinID: pR[tmpJoin.ID], TargetID: pR.IDVisionTarget, Number: tmpV.VisionNumber || '?', Name: tmpV.Name || ('#' + pR.IDVisionTarget), Status: tmpV.Status || '' };
			});
			let tmpParents = tmpParentRows.map((pR) =>
			{
				let tmpV = tmpVisions[pR.IDVisionSource] || {};
				return { TargetID: pR.IDVisionSource, Number: tmpV.VisionNumber || '?', Name: tmpV.Name || ('#' + pR.IDVisionSource) };
			});
			// A server-backed candidate search (WI #446), not this._rows('Vision') -- see the fk branch
			// above. Excludes (this record's own id, and every vision already a part) are recomputed the
			// same way by _mountRelationPickers().
			//
			// Vision is Connections: true (same as the link branch's note), so this AddSlot never actually
			// paints either -- the live "Parts of this vision" add-UI is the Connections grid's own linker
			// (Connections-Endpoint.js declares it Linkable), already unbounded. Kept converted rather than
			// special-cased away.
			tmpSection.SubVisionSlot = [{
				Idx: pIdx,
				Children: tmpChildren,
				ChildEmpty: tmpChildren.length ? [] : [{}],
				ParentSlot: tmpParents.length ? [{ Items: tmpParents }] : [],
				AddSlot: [{ Idx: pIdx, ContainerID: 'rel-subv-host-' + pIdx }]
			}];
		}

		return tmpSection;
	}

	// ── mutations ────────────────────────────────────────────────────────────
	setFk(pField, pValue)
	{
		let tmpProvider = this._provider(this._key);
		let tmpRec = {};
		tmpRec[pField] = pValue ? Number(pValue) : 0;
		// Refreshed by showDetail() -> _fetch()'s own resolve() of this._key -- a prior explicit
		// list() here was redundant, and (WI #447) reset this entity's list screen to page one.
		tmpProvider.update(this._id, tmpRec)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Update failed: ' + (pErr.message || pErr), 'error'));
	}

	setPendingTarget(pIdx, pValue) { this._pending[pIdx] = this._pending[pIdx] || {}; this._pending[pIdx].Target = pValue; }
	setPendingRelType(pIdx, pValue) { this._pending[pIdx] = this._pending[pIdx] || {}; this._pending[pIdx].RelType = pValue; }

	addLink(pIdx)
	{
		let tmpRel = libDescriptors.Entities[this._key].Relations[pIdx];
		let tmpJoin = libDescriptors.Joins[tmpRel.Join];
		let tmpPending = this._pending[pIdx] || {};
		if (!tmpPending.Target) { return this._toast('Pick something to link first.', 'info'); }
		let tmpRec = {};
		tmpRec[tmpRel.SelfField] = this._id;
		tmpRec[tmpRel.TargetField] = Number(tmpPending.Target);
		if (tmpRel.RelationType) { tmpRec.RelationType = tmpPending.RelType || libDescriptors.RelationTypes[0]; }
		this.pict.providers.LinkAPI.addLink(tmpJoin.Entity, tmpRec)
			.then(() => { this._pending[pIdx] = null; this.showDetail(this._key, this._id); })
			.catch((pErr) => this._toast('Link failed: ' + (pErr.message || pErr), 'error'));
	}

	removeLink(pIdx, pJoinID)
	{
		let tmpRel = libDescriptors.Entities[this._key].Relations[pIdx];
		let tmpJoin = libDescriptors.Joins[tmpRel.Join];
		this.pict.providers.LinkAPI.removeLink(tmpJoin.Entity, pJoinID)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Unlink failed: ' + (pErr.message || pErr), 'error'));
	}

	setTargetType(pValue) { this._targetType = pValue; this._rebuild(); }

	setTarget(pValue)
	{
		let tmpProvider = this._provider('WorkItem');
		let tmpType = this._targetType || 'None';
		let tmpRec = { TargetType: (pValue && tmpType !== 'None') ? tmpType : 'None', IDTargetVision: 0, IDTargetModule: 0, IDTargetFeature: 0 };
		if (pValue && tmpType !== 'None') { tmpRec['IDTarget' + tmpType] = Number(pValue); }
		// See setFk above: showDetail() -> _fetch() already re-resolves this entity.
		tmpProvider.update(this._id, tmpRec)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Update failed: ' + (pErr.message || pErr), 'error'));
	}

	// ── sessions (Phase 3) ───────────────────────────────────────────────────
	setPendingSession(pIdx, pValue) { this._pending['s' + pIdx] = pValue; }

	linkSession(pIdx)
	{
		let tmpRel = libDescriptors.Entities[this._key].Relations[pIdx];
		let tmpPending = this._pending['s' + pIdx];
		if (!tmpPending) { return this._toast('Pick a session first.', 'info'); }
		let tmpPatch = {};
		tmpPatch[tmpRel.Field] = this._id;
		this.pict.providers.SessionAPI.setLink(Number(tmpPending), tmpPatch)
			.then(() => { this._pending['s' + pIdx] = null; this.showDetail(this._key, this._id); })
			.catch((pErr) => this._toast('Link failed: ' + (pErr.message || pErr), 'error'));
	}

	unlinkSession(pField, pIDSession)
	{
		let tmpPatch = {};
		tmpPatch[pField] = 0;
		this.pict.providers.SessionAPI.setLink(pIDSession, tmpPatch)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Unlink failed: ' + (pErr.message || pErr), 'error'));
	}

	setSessionOutcome(pIDSession, pValue)
	{
		this.pict.providers.SessionAPI.setLink(pIDSession, { WorkOutcome: pValue })
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Update failed: ' + (pErr.message || pErr), 'error'));
	}

	// ── documentation (Docs Lake; addressed by path) ─────────────────────────
	openDoc(pPath)
	{
		let tmpApp = this.pict.PictApplication;
		let tmpLabel = this.pict.providers.DocLakeAPI.titleFor(pPath) || 'Edit document';
		if (tmpApp && typeof tmpApp.showDocEditor === 'function') tmpApp.showDocEditor(this._key, this._id, pPath, tmpLabel);
	}

	newDoc()
	{
		let tmpProvider = this._provider(this._key);
		let tmpRecord = (tmpProvider && tmpProvider.store().Index[this._id]) || {};
		let tmpBase = this._entityDir(tmpRecord) + '/note-';
		let tmpExisting = (this._entityDocLinks || []).map((pL) => pL.DocPath);
		let tmpN = 1;
		while (tmpExisting.indexOf(tmpBase + tmpN + '.md') >= 0) { tmpN++; }
		let tmpPath = tmpBase + tmpN + '.md';
		this.pict.providers.DocLakeAPI.saveDoc(tmpPath, '# New document\n')
			.then(() => this.pict.providers.LinkAPI.addLink('DocEntityLink',
				{ EntityType: this._key, IDEntity: this._id, DocPath: tmpPath, Role: 'doc' }))
			.then(() =>
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.showDocEditor === 'function') tmpApp.showDocEditor(this._key, this._id, tmpPath, 'Edit document');
			})
			.catch((pErr) => this._toast('Could not create document: ' + (pErr.message || pErr), 'error'));
	}

	removeDoc(pJoinID, pPath)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () => this.pict.providers.LinkAPI.removeLink('DocEntityLink', pJoinID)
			.then(() => this.pict.providers.DocLakeAPI.deleteDoc(pPath))
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Delete failed: ' + (pErr.message || pErr), 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Delete this document?', { dangerous: true }).then((pOk) => { if (pOk) tmpDo(); });
		}
		else { tmpDo(); }
	}

	openCoreDoc()
	{
		let tmpApp = this.pict.PictApplication;
		if (!this._coreDocPath) { return this._toast('No core document yet.', 'info'); }
		if (tmpApp && typeof tmpApp.showDocEditor === 'function') tmpApp.showDocEditor(this._key, this._id, this._coreDocPath, 'Core Vision Document');
	}

	// ── media (Phase 5) ──────────────────────────────────────────────────────
	uploadMedia(pIdx, pFile)
	{
		if (!pFile) return;
		this._toast('Uploading ' + (pFile.name || 'file') + '…', 'info');
		this.pict.providers.MediaAPI.upload(this._key, this._id, pFile)
			.then(() => { this._toast('Uploaded.', 'success'); this.showDetail(this._key, this._id); })
			.catch((pErr) => this._toast('Upload failed: ' + (pErr.message || pErr), 'error'));
	}

	removeMedia(pID)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () => this.pict.providers.MediaAPI.remove(pID)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Remove failed: ' + (pErr.message || pErr), 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Remove this media?', { dangerous: true }).then((pOk) => { if (pOk) tmpDo(); });
		}
		else { tmpDo(); }
	}

	// ── curated doc references (tie foundational docs back to entities) ──────
	setPendingDocLink(pIdx, pValue) { this._pending['dl' + pIdx] = pValue; }

	addDocLink(pIdx)
	{
		let tmpPending = this._pending['dl' + pIdx];
		if (!tmpPending) { return this._toast('Pick a document to link.', 'info'); }
		this.pict.providers.LinkAPI.addLink('DocEntityLink',
			{ EntityType: this._key, IDEntity: this._id, DocPath: String(tmpPending), Role: 'ref' })
			.then(() => { this._pending['dl' + pIdx] = null; this.showDetail(this._key, this._id); })
			.catch((pErr) => this._toast('Link failed: ' + (pErr.message || pErr), 'error'));
	}

	removeDocLink(pIdx, pJoinID)
	{
		this.pict.providers.LinkAPI.removeLink('DocEntityLink', pJoinID)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Unlink failed: ' + (pErr.message || pErr), 'error'));
	}

	openFoundationDoc(pPath)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showFoundationDoc === 'function') tmpApp.showFoundationDoc(pPath);
	}

	// ── sub-visions (decomposition via VisionVisionJoin RelationType 'Decomposes') ──
	setPendingSubName(pIdx, pValue) { this._pending['svn' + pIdx] = pValue; }
	setPendingSubLink(pIdx, pValue) { this._pending['svl' + pIdx] = pValue; }

	createSubVision(pIdx)
	{
		let tmpName = String(this._pending['svn' + pIdx] || '').trim();
		if (!tmpName) { return this._toast('Name the sub-vision.', 'info'); }
		let tmpParentID = this._id;
		this.pict.providers.VisionAPI.create({ Name: tmpName, Status: 'Draft' })
			.then((pVision) =>
			{
				let tmpChildID = pVision && (pVision.IDVision || (pVision.Record && pVision.Record.IDVision));
				if (!tmpChildID) { throw new Error('vision create returned no id'); }
				return this.pict.providers.LinkAPI.addLink('VisionVisionJoin',
					{ IDVisionSource: tmpParentID, IDVisionTarget: tmpChildID, RelationType: 'Decomposes' });
			})
			.then(() => { this._pending['svn' + pIdx] = ''; this._toast('Sub-vision created.', 'success'); this.showDetail(this._key, this._id); })
			.catch((pErr) => this._toast('Could not create sub-vision: ' + (pErr.message || pErr), 'error'));
	}

	addSubVision(pIdx)
	{
		let tmpChildID = this._pending['svl' + pIdx];
		if (!tmpChildID) { return this._toast('Pick a vision to add as a part.', 'info'); }
		this.pict.providers.LinkAPI.addLink('VisionVisionJoin',
			{ IDVisionSource: this._id, IDVisionTarget: Number(tmpChildID), RelationType: 'Decomposes' })
			.then(() => { this._pending['svl' + pIdx] = null; this.showDetail(this._key, this._id); })
			.catch((pErr) => this._toast('Link failed: ' + (pErr.message || pErr), 'error'));
	}

	removeSubVision(pIdx, pJoinID)
	{
		this.pict.providers.LinkAPI.removeLink('VisionVisionJoin', pJoinID)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => this._toast('Unlink failed: ' + (pErr.message || pErr), 'error'));
	}

	// A create-from-here button on an inverse-fk section: open the source entity's
	// create form prefilled with this record's FK plus the relation's Prefill.
	createFromRelation(pIdx)
	{
		let tmpRel = libDescriptors.Entities[this._key].Relations[pIdx];
		if (!tmpRel || !tmpRel.Create) { return; }
		let tmpPrefill = Object.assign({}, tmpRel.Create.Prefill || {});
		tmpPrefill[tmpRel.SourceField] = this._id;
		let tmpApp = this.pict.PictApplication;
		if (tmpRel.Source === 'Feedback' && tmpApp && typeof tmpApp.showNewFeedback === 'function')
		{
			return tmpApp.showNewFeedback(tmpPrefill);
		}
		this.pict.AppData.EntityListPrefill = { Key: tmpRel.Source, Values: tmpPrefill };
		// The create route, so the URL says a form is open rather than naming the list behind it.
		if (tmpApp && typeof tmpApp.showEntityNew === 'function' && tmpApp.showEntityNew(tmpRel.Source)) { return; }
		if (tmpApp && typeof tmpApp.showSection === 'function') { tmpApp.showSection(tmpRel.Source); }
	}

	// Dispatch a descriptor-declared header action (HeaderActions) to the app.
	headerAction(pMethod)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp[pMethod] === 'function') { tmpApp[pMethod](this._key, this._id); }
	}

	// Mark this record addressed / reopen it (Addressable entities), stamping or clearing
	// the date, then reload the detail so the badge and toggle reflect the new state.
	toggleAddressed()
	{
		let tmpDesc = libDescriptors.Entities[this._key];
		let tmpAddr = tmpDesc && tmpDesc.Addressable;
		let tmpProvider = this._provider(this._key);
		if (!tmpAddr || !tmpProvider) { return; }
		let tmpRecord = tmpProvider.store().Index[this._id] || {};
		let tmpNext = libFocus.truthy(tmpRecord[tmpAddr.Field]) ? 0 : 1;
		let tmpPatch = {};
		tmpPatch[tmpAddr.Field] = tmpNext;
		if (tmpAddr.DateField) { tmpPatch[tmpAddr.DateField] = tmpNext ? (new Date()).toISOString() : ''; }
		tmpProvider.update(this._id, tmpPatch)
			.then(() => this.showDetail(this._key, this._id))
			.catch((pErr) => { if (this.pict && this.pict.log) { this.pict.log.warn('EntityDetail: address toggle failed: ' + (pErr.message || pErr)); } });
	}

	// ── navigation ───────────────────────────────────────────────────────────
	openTarget(pKey, pID)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showEntityDetail === 'function') tmpApp.showEntityDetail(pKey, pID);
	}

	// Open a stored session in its viewer (the #/session/:id route), used by the Story panel.
	openSession(pID)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSession === 'function') tmpApp.showSession(pID);
	}

	back()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSection === 'function') tmpApp.showSection(this._key);
	}

	edit()
	{
		let tmpKey = this._key, tmpID = this._id;
		let tmpList = this.pict.views['Plansheet-EntityList'];
		// Render the GENERIC entity list (not the entity's section): an Issue's section is the kanban
		// board, which has no inline edit form, so showSection('Issue') used to bounce edits to the board.
		// Hand the id to showEntity so it points the list at this entity, loads it once, and opens the
		// edit form as the final render. A separate list()+editRecord used to race showEntity's own list
		// load; for entities with a facet prefetch (WorkItem's roster) the gated list won and the edit
		// form flickered and was clobbered back to the list.
		//
		// NAVIGATES now. Calling showEntity straight from here left the URL on /work-item/42 while the
		// pane held the edit form, and on /work-item/42 again after Cancel while the whole list was on
		// screen -- the address bar disagreeing with the page in both directions. The route handler
		// makes the same showEntity call, so the render path below is unchanged.
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showEntityEdit === 'function' && tmpApp.showEntityEdit(tmpKey, tmpID)) { return; }
		if (tmpList && typeof tmpList.showEntity === 'function') { tmpList.showEntity(tmpKey, { EditID: tmpID }); }
	}

	// Soft-delete this record (descriptor Deletable: true -- WorkItem) from its own full
	// view, so a person reviewing the content can decide right there instead of hunting
	// the row down in the list. meadow's delete just sets Deleted/DeleteDate; the
	// WorkItemNumber sequence ignores Deleted rows, so numbering is unaffected.
	deleteRecord()
	{
		let tmpKey = this._key, tmpID = this._id;
		let tmpDesc = libDescriptors.Entities[tmpKey];
		if (!tmpDesc || !tmpDesc.Deletable) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpSingular = libLabels.singular(this.pict, tmpKey, this._scopeTerms, tmpDesc.Title.replace(/s$/, ''));
		let tmpDo = () =>
		{
			let tmpProvider = this._provider(tmpKey);
			if (!tmpProvider) { return; }
			tmpProvider.remove(tmpID)
				.then(() => tmpProvider.list())
				.then(() =>
				{
					this._toast(tmpSingular + ' deleted.', 'success');
					let tmpApp = this.pict.PictApplication;
					if (tmpApp && typeof tmpApp.showSection === 'function') { tmpApp.showSection(tmpKey); }
				})
				.catch((pErr) => this._toast('Delete failed: ' + ((pErr && pErr.message) || pErr), 'error'));
		};
		let tmpMsg = 'Delete this ' + tmpSingular.toLowerCase() + '? This cannot be undone from here.';
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm(tmpMsg, { title: 'Delete ' + tmpSingular.toLowerCase(), dangerous: true, confirmLabel: 'Delete' }).then((pOk) => { if (pOk) { tmpDo(); } });
		}
		else { tmpDo(); }
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	// ── Blueprint title block (WorkItem) ──────────────────────────────────────
	// Draw the loaded blueprint into its container: one drafting cell per artifact
	// type with its count and items, labels in the work item's vision kit. Clicking
	// an item navigates to it. Re-runs every render (the container is rebuilt each).
	_renderBlueprint()
	{
		if (typeof document === 'undefined') { return; }
		let tmpHost = document.getElementById('Entity-Blueprint');
		if (!tmpHost) { return; }
		let tmpBP = this._blueprint;
		if (!tmpBP || !Array.isArray(tmpBP.Groups)) { tmpHost.innerHTML = ''; return; }
		let tmpSelf = "_Pict.views['Plansheet-EntityDetail']";
		let tmpApp = this.pict.PictApplication;
		let tmpCanEdit = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		let tmpCells = tmpBP.Groups.map((pGroup) =>
		{
			let tmpItems = (pGroup.Items || []).map((pItem) =>
			{
				let tmpClick = pItem.Link ? ' onclick="' + tmpSelf + '.openBlueprintLink(\'' + pItem.Link + '\')"' : '';
				// A pinned artifact carries its pin id and gets an unpin control (editors only).
				let tmpX = (tmpCanEdit && pItem.Pinned && pItem.IDBlueprintItem)
					? '<button class="bp-item-x" title="Unpin" onclick="event.stopPropagation();' + tmpSelf + '.unpinBlueprintItem(' + pItem.IDBlueprintItem + ')">&times;</button>'
					: '';
				return '<span class="bp-item' + (pItem.Pinned ? ' is-pinned' : '') + '"' + tmpClick + ' title="' + _escapeHTML(pItem.Title || '') + '">' + _escapeHTML(pItem.Title || '') + tmpX + '</span>';
			}).join('');
			return '<div class="bp-cell">' +
					'<div class="bp-cell-head"><span class="bp-count">' + (pGroup.Count || 0) + '</span><span class="bp-label">' + _escapeHTML(pGroup.Label || pGroup.Type) + '</span></div>' +
					'<div class="bp-items">' + tmpItems + '</div>' +
				'</div>';
		}).join('');
		if (!tmpCells) { tmpCells = '<div class="bp-empty">Nothing linked yet. As this work item gathers its parts, they appear here.</div>'; }
		// _canShare(), not tmpCanEdit: being able to edit this entity is not the same as this entity being
		// shareable at all. Public sharing is work-item-only (see _canShare), and the share routes take a bare
		// :id, so drawing this strip on a module would offer a button that publishes the WORK ITEM of the same
		// number. Blueprints generalized in WI #340; sharing did not.
		let tmpShareHTML = this._canShare() ? libShareUI.stripHTML(this._share, tmpSelf) : '';
		tmpHost.innerHTML = tmpShareHTML +
			'<div class="bp-sheet"><div class="bp-frame">' +
				'<div class="bp-head"><span class="bp-kicker">BLUEPRINT</span><span class="bp-title">' + _escapeHTML(tmpBP.Title || '') + '</span>' +
					'<a class="bp-open" href="#/' + this._routeKey() + '/' + this._id + '/blueprint" style="margin-left:auto;align-self:center;font:inherit;font-size:12px;letter-spacing:.4px;color:#f0c44a;text-decoration:none;border:1px solid #f0c44a;border-radius:6px;padding:4px 11px;white-space:nowrap;">Open full blueprint</a>' +
				'</div>' +
				'<div class="bp-grid">' + tmpCells + '</div>' +
				this._blueprintAddHTML(tmpCanEdit, tmpSelf) +
				'<div class="bp-titleblock">' +
					'<span class="bp-tb-cell"><span class="bp-tb-k">SHEET</span><span class="bp-tb-v">' + (tmpBP.Designator || ('WI-' + (tmpBP.WorkItemNumber || tmpBP.IDWorkItem || 0))) + '</span></span>' +
					'<span class="bp-tb-cell"><span class="bp-tb-k">STATUS</span><span class="bp-tb-v">' + _escapeHTML(tmpBP.Status || '-') + '</span></span>' +
				'</div>' +
			'</div></div>';
		// Mount the two searchable pickers into the composer hosts (editors only). Re-runs on every
		// _renderBlueprint (including a type change), so the item options track the chosen type.
		if (tmpCanEdit && document.getElementById('bp-add-item-host'))
		{
			let tmpTypes = ['Vision', 'Module', 'Feature'];
			let tmpAddType = (tmpTypes.indexOf(this._bpAddType) >= 0) ? this._bpAddType : 'Vision';
			let tmpSelfView = this;
			// Type selector: a pict-section-picker (matching the item picker), not a native <select>. The
			// guard keeps setBlueprintAddType -> _renderBlueprint -> re-mount from looping when setValue
			// re-asserts the current type.
			if (tmpApp && typeof tmpApp.mountPicker === 'function' && document.getElementById('bp-add-type-host'))
			{
				let tmpTypeOptions = tmpTypes.map((pT) => ({ Value: pT, Text: libLabels.singular(this.pict, pT, this._scopeTerms, pT) }));
				tmpApp.mountPicker('#bp-add-type-host', 'BP-AddTypePicker', tmpTypeOptions,
					function (pVal) { if (pVal && pVal !== tmpSelfView._bpAddType) { tmpSelfView.setBlueprintAddType(pVal); } },
					{ Placeholder: 'Type', Value: tmpAddType });
			}
			// Item selector: a server-backed candidate search (WI #445), not the chosen type's cached
			// page -- that page is at most 250 rows (WI #433) and prod holds 1,075 blueprints. See
			// CandidateSearch.js for why this asks resolve(), not list(), and only the TitleField.
			let tmpAddDesc = libDescriptors.Entities[tmpAddType];
			let tmpAddProvider = this._provider(tmpAddType);
			if (tmpApp && typeof tmpApp.mountPicker === 'function' && tmpAddDesc && tmpAddProvider)
			{
				// Preserve any pending selection across an incidental re-render (async data settling, a
				// board mount): re-assert it as the picker Value so a repaint can't silently clear the
				// item the user just chose and leave the Pin it click with nothing to pin.
				tmpApp.mountPicker('#bp-add-item-host', 'BP-AddItemPicker', [], function (pVal) { tmpSelfView._bpSelectedItem = parseInt(pVal, 10) || 0; },
					{
						Placeholder: 'Search ' + tmpAddType.toLowerCase() + 's to pin',
						Value: this._bpSelectedItem ? String(this._bpSelectedItem) : '',
						DataProvider: libCandidateSearch.dataProviderFor(tmpAddProvider, tmpAddDesc),
						ResolveValue: libCandidateSearch.resolveValueFor(tmpAddProvider, tmpAddDesc)
					});
			}
		}
	}

	// ── Blueprint public-share strip (editors) ────────────────────────────────
	// The compact block carries the same share control as the full-page view, via
	// BlueprintShareUI. It operates on this view (_id, _share); _afterShareChange
	// redraws just the blueprint block so a toggle does not re-fetch the entity.
	// May this entity's blueprint be shared publicly? Any blueprintable entity can be, now that a share hangs
	// off IDBlueprint rather than IDWorkItem and the public read, the page and the token-scoped media all
	// resolve through the blueprint's own owner (WI #340). The gate is the editing right, as it was.
	_canShare()
	{
		if (!libDescriptors.Entities[this._key] || !libDescriptors.Entities[this._key].Blueprint) { return false; }
		let tmpApp = this.pict.PictApplication;
		return !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
	}
	// The hash-route segment for this entity ('work-item', 'vision', ...), so the full-blueprint link points
	// at the page for the thing actually open rather than always at a work item.
	_routeKey()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp._singularRoute === 'function') { return tmpApp._singularRoute(this._key); }
		return String(this._key || '').toLowerCase();
	}

	_bpAPI() { return this.pict.providers.BlueprintAPI; }

	// Which subject THIS entity's pins are written against. The work-item asymmetry (its pins are keyed
	// by IDWorkItem, everything else by IDBlueprint) lives in the provider, so this view no longer
	// carries a special case for it.
	_curationSubject() { return this._bpAPI().curationSubject(this._blueprint, this._subject); }

	_afterShareChange() { this._renderBlueprint(); }
	bpShareCreate() { libShareUI.create(this); }
	bpShareCopy() { libShareUI.copy(this); }
	bpShareInvite() { libShareUI.invite(this); }
	bpShareRegenerate() { libShareUI.regenerate(this); }
	bpShareRevoke() { libShareUI.revoke(this); }
	bpShareSetExpiry(pValue) { libShareUI.setExpiry(this, pValue); }
	bpSharePrintEnabled(pEnabled) { libShareUI.setPrintEnabled(this, pEnabled); }
	bpShareRepin() { libShareUI.repin(this); }

	// The "pin another artifact" row at the foot of the blueprint (editors only): pick a type, pick
	// one of that type, and pin it. Types are the loaded SDLC bases (their lists are already cached on
	// the work item page); the server title-resolves them. Pins persist; auto-gathered parts do not.
	_blueprintAddHTML(pCanEdit, pSelf)
	{
		if (!pCanEdit) { return ''; }
		// One framed panel, not three loose inputs. BOTH selectors are searchable pict-section-pickers
		// (mounted after render into the two hosts, and themed to the blueprint's navy palette via the
		// token re-map on .bp-add), so the type and item selectors match and read as one deliberate control.
		return '<div class="bp-add">' +
				'<span class="bp-add-kicker">PIN AN ARTIFACT</span>' +
				'<div class="bp-add-row">' +
					'<div class="bp-add-field bp-add-type" id="bp-add-type-host"></div>' +
					'<div class="bp-add-field bp-add-item" id="bp-add-item-host"></div>' +
					'<button class="bp-add-btn" onclick="' + pSelf + '.pinBlueprintItem()">Pin it</button>' +
				'</div>' +
			'</div>';
	}

	// Open the selected whiteboard full screen (read-only; a photo board shows full-bleed).
	fullscreenBoard()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && this._SelectedBoardID && typeof tmpApp.openBoardFullscreen === 'function') { tmpApp.openBoardFullscreen(this._SelectedBoardID); }
	}

	// Switching the artifact type invalidates any chosen item (a Feature id is meaningless once the
	// type is Vision), so clear the pending selection before repainting the linker for the new type.
	setBlueprintAddType(pType) { this._bpAddType = pType; this._bpSelectedItem = 0; this._renderBlueprint(); }

	pinBlueprintItem()
	{
		if (typeof document === 'undefined') { return; }
		let tmpType = this._bpAddType || 'Vision';
		// Read the chosen item from the picker itself (the source of truth) rather than a cached
		// instance field: an async re-render can repaint the linker between the pick and this click,
		// so reading the live picker value keeps Pin it working instead of silently no-opping.
		let tmpItemPicker = this.pict.views['BP-AddItemPicker'];
		let tmpIDItem = (tmpItemPicker && typeof tmpItemPicker.getValue === 'function') ? (parseInt(tmpItemPicker.getValue(), 10) || 0) : 0;
		if (!tmpIDItem) { tmpIDItem = this._bpSelectedItem || 0; }
		if (!tmpIDItem) { return; }
		this._bpAPI().pin(this._curationSubject(), tmpType, tmpIDItem)
			.then(() => { this._bpSelectedItem = 0; return this._reloadBlueprint(); })
			.catch((pError) => { if (this.pict && this.pict.log) { this.pict.log.warn('Could not pin the artifact: ' + pError.message); } });
	}

	unpinBlueprintItem(pIDBlueprintItem)
	{
		if (!pIDBlueprintItem) { return; }
		this._bpAPI().unpin(this._curationSubject(), pIDBlueprintItem)
			.then(() => this._reloadBlueprint())
			.catch((pError) => { if (this.pict && this.pict.log) { this.pict.log.warn('Could not unpin: ' + pError.message); } });
	}

	// Re-fetch just the blueprint and redraw it (cheaper than reloading the whole detail page).
	_reloadBlueprint()
	{
		return this._bpAPI().readSubject(this._subject)
			.then((pBody) => { this._blueprint = pBody || null; this._renderBlueprint(); })
			.catch(() => {});
	}

	openBlueprintLink(pLink)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp._navigate === 'function' && pLink) { tmpApp._navigate(pLink); }
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._renderCoreDoc();
		this._renderMarkdownFields();
		this._mountVisionBoard();
		this._mountComments();
		this._mountChecklists();
		this._mountVisionLoops();
		this._mountStepEditor();
		this._mountPrompts();
		this._renderBlueprint();
		this._mountConnections();
		this._mountWorkItemPrompts();
		this._mountRelationPickers();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// ── relation record pickers (WI #446) ─────────────────────────────────────
	// Mount the server-backed candidate-search pickers for this entity's fk / link-add / target-entity /
	// subvisions-add relation slots, into the host divs _buildSection() just rendered. Re-runs on every
	// render, same as the other onAfterRender mounts above: the relation Sections rebuild from scratch on
	// every _rebuild (a link/unlink, an fk change, a target-type switch), so there is nothing to diff --
	// each host is either present (mount fresh into it) or absent (that relation isn't on screen).
	_mountRelationPickers()
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp.mountPicker !== 'function' || typeof document === 'undefined') { return; }
		let tmpDesc = libDescriptors.Entities[this._key];
		let tmpRecord = this._loadedRecord || {};
		let tmpRelations = (tmpDesc && tmpDesc.Relations) || [];
		let tmpSelfView = this;
		let fLabel = (pKey) => { let tmpD = libDescriptors.Entities[pKey]; return ((tmpD && tmpD.Title) || pKey).toLowerCase(); };
		tmpRelations.forEach((pRel, pIdx) =>
		{
			if (pRel.Render === 'fk')
			{
				let tmpHostID = 'rel-fk-host-' + pIdx;
				if (!document.getElementById(tmpHostID)) { return; }
				let tmpTargetDesc = libDescriptors.Entities[pRel.Target];
				let tmpProvider = this._provider(pRel.Target);
				if (!tmpTargetDesc || !tmpProvider) { return; }
				let tmpCurrent = tmpRecord[pRel.Field] || 0;
				tmpApp.mountPicker('#' + tmpHostID, 'Rel-Fk-' + this._key + '-' + pIdx, [],
					function (pVal) { tmpSelfView.setFk(pRel.Field, pVal); },
					{
						Placeholder: 'Search ' + fLabel(pRel.Target),
						Value: tmpCurrent ? String(tmpCurrent) : '',
						AllowClear: true, ClearLabel: '— none —',
						DataProvider: libCandidateSearch.dataProviderFor(tmpProvider, tmpTargetDesc),
						ResolveValue: libCandidateSearch.resolveValueFor(tmpProvider, tmpTargetDesc)
					});
			}
			else if (pRel.Render === 'link')
			{
				let tmpHostID = 'rel-link-add-host-' + pIdx;
				if (!document.getElementById(tmpHostID)) { return; }
				let tmpTargetDesc = libDescriptors.Entities[pRel.Target];
				let tmpProvider = this._provider(pRel.Target);
				if (!tmpTargetDesc || !tmpProvider) { return; }
				let tmpLinkedIDs = (this._linkRows[pIdx] || []).map((pR) => String(pR[pRel.TargetField]));
				if (pRel.Target === this._key) { tmpLinkedIDs.push(String(this._id)); }
				let tmpPendingTarget = (this._pending[pIdx] && this._pending[pIdx].Target) || '';
				tmpApp.mountPicker('#' + tmpHostID, 'Rel-Link-' + this._key + '-' + pIdx, [],
					function (pVal) { tmpSelfView.setPendingTarget(pIdx, pVal); },
					{
						Placeholder: 'Search ' + fLabel(pRel.Target) + ' to link',
						Value: tmpPendingTarget ? String(tmpPendingTarget) : '',
						DataProvider: libCandidateSearch.dataProviderFor(tmpProvider, tmpTargetDesc, null, tmpLinkedIDs),
						ResolveValue: libCandidateSearch.resolveValueFor(tmpProvider, tmpTargetDesc)
					});
			}
			else if (pRel.Render === 'target')
			{
				let tmpHostID = 'rel-target-host-' + pIdx;
				if (!document.getElementById(tmpHostID)) { return; }
				let tmpDraftType = this._targetType || tmpRecord.TargetType || 'None';
				let tmpTargetDesc = libDescriptors.Entities[tmpDraftType];
				let tmpProvider = (tmpDraftType !== 'None') ? this._provider(tmpDraftType) : null;
				if (!tmpTargetDesc || !tmpProvider) { return; }
				let tmpCurID = tmpRecord['IDTarget' + tmpDraftType] || 0;
				tmpApp.mountPicker('#' + tmpHostID, 'Rel-Target-' + this._key + '-' + pIdx, [],
					function (pVal) { tmpSelfView.setTarget(pVal); },
					{
						Placeholder: 'Search ' + fLabel(tmpDraftType),
						Value: tmpCurID ? String(tmpCurID) : '',
						AllowClear: true, ClearLabel: '— none —',
						DataProvider: libCandidateSearch.dataProviderFor(tmpProvider, tmpTargetDesc),
						ResolveValue: libCandidateSearch.resolveValueFor(tmpProvider, tmpTargetDesc)
					});
			}
			else if (pRel.Render === 'subvisions')
			{
				let tmpHostID = 'rel-subv-host-' + pIdx;
				if (!document.getElementById(tmpHostID)) { return; }
				let tmpProvider = this._provider('Vision');
				if (!tmpProvider) { return; }
				let tmpSub = this._subRows[pIdx] || { Out: [], In: [] };
				let tmpExcludeIDs = (tmpSub.Out || [])
					.filter((pR) => String(pR.RelationType) === 'Decomposes')
					.map((pR) => String(pR.IDVisionTarget));
				tmpExcludeIDs.push(String(this._id));
				let tmpPendingSub = this._pending['svl' + pIdx] || '';
				tmpApp.mountPicker('#' + tmpHostID, 'Rel-SubVision-' + this._key + '-' + pIdx, [],
					function (pVal) { tmpSelfView.setPendingSubLink(pIdx, pVal); },
					{
						Placeholder: 'Search visions to add as a part',
						Value: tmpPendingSub ? String(tmpPendingSub) : '',
						DataProvider: libCandidateSearch.dataProviderFor(tmpProvider, libDescriptors.Entities.Vision, null, tmpExcludeIDs),
						ResolveValue: libCandidateSearch.resolveValueFor(tmpProvider, libDescriptors.Entities.Vision)
					});
			}
		});
	}

	// ── embedded inspiration board (Vision) ───────────────────────────────────

	// The current board's IDMoodboard, read by the edit board's Media image source to scope its gallery.
	currentBoardId() { return this._VisionBoardID; }

	// Mount (or re-mount) the embedded board after a render. The detail re-renders on relation edits,
	// which wipes the #Vision-Board container, so this runs every render: if the board for this entity is
	// already loaded it just re-mounts the cached board (no server round-trip), otherwise it fetches it
	// (creating one when the user can edit) and caches it.
	_mountVisionBoard()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.BoardSlot && tmpState.BoardSlot[0]) ? tmpState.BoardSlot[0] : null;
		// Any path that does not mount an editable board must clear the editing flag. Vision-Board-Edit is a
		// reused singleton; a stale _VisionBoardEditing left true (e.g. navigating away mid-edit, then to an
		// entity with no board) would later make the cache-hit re-render below open the board in edit mode.
		if (!tmpSlot) { this._VisionBoardEditing = false; return; }
		let tmpAPI = this.pict.providers.MoodboardAPI;
		if (!tmpAPI || typeof document === 'undefined') { this._VisionBoardEditing = false; return; }
		let tmpBoards = this._ownerBoards || [];
		let tmpSelected = Number(this._SelectedBoardID) || (tmpBoards[0] && tmpBoards[0].IDMoodboard) || 0;
		this._SelectedBoardID = tmpSelected;
		let tmpHost = document.getElementById('Vision-Board');
		// No boards yet: the template shows an empty state, nothing to mount -- collapse the box so no empty
		// bordered rectangle sits under the "none yet" text.
		if (!tmpSelected) { this._VisionBoardEditing = false; if (tmpHost) { tmpHost.innerHTML = ''; tmpHost.classList.add('ps-board-empty-collapsed'); } return; }
		let tmpCacheKey = this._key + ':' + this._id + ':' + tmpSelected;
		if (this._VisionBoardLoadedFor === tmpCacheKey && this._VisionBoardID)
		{
			this._renderVisionBoardView(this._VisionBoardEditing && tmpSlot.CanEdit, this._VisionBoard);
			return;
		}
		let tmpRow = tmpBoards.find((pB) => Number(pB.IDMoodboard) === tmpSelected);
		if (!tmpRow) { this._VisionBoardEditing = false; if (tmpHost) { tmpHost.innerHTML = ''; tmpHost.classList.add('ps-board-empty-collapsed'); } return; }
		this._VisionBoardID = tmpRow.IDMoodboard;
		this._VisionBoard = tmpAPI.loadBoard(tmpRow);
		// A freshly created board opens straight in edit (WantBoardEdit); otherwise read-only.
		this._VisionBoardEditing = !!(this._WantBoardEdit && tmpSlot.CanEdit);
		this._WantBoardEdit = false;
		this._VisionBoardLoadedFor = tmpCacheKey;
		this._renderVisionBoardView(this._VisionBoardEditing, this._VisionBoard);
	}

	// Switch the mounted whiteboard (pill click).
	/**
	 * Pick which of this entity's whiteboards is mounted in its board section.
	 *
	 * Rides in the entity's own URL as ?board=34 rather than a route of its own: it is a refinement of
	 * the record you are already looking at, not a different page. Without it, an entity with several
	 * boards always reopened on the first one, so "the board I was looking at" could not be linked or
	 * returned to.
	 */
	selectBoard(pID)
	{
		let tmpID = Number(pID) || 0;
		if (!tmpID || tmpID === Number(this._SelectedBoardID)) { return; }
		this._SelectedBoardID = tmpID;
		this._VisionBoardEditing = false;
		this._VisionBoardLoadedFor = null;
		libFocus.writeHashQuery({ board: tmpID });
		this._rebuild();
	}

	// Add a new whiteboard for this entity, select it, and drop straight into edit.
	newBoard()
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp._can !== 'function' || !tmpApp._can('content.edit')) { return; }
		let tmpAPI = this.pict.providers.MoodboardAPI;
		if (!tmpAPI) { return; }
		let tmpName = 'Whiteboard ' + ((this._ownerBoards || []).length + 1);
		tmpAPI.createForOwner(this._key, this._id, tmpName).then((pRow) =>
		{
			if (!pRow || !pRow.IDMoodboard) { return; }
			return tmpAPI.listForEntity(this._key, this._id).then((pRows) =>
			{
				this._ownerBoards = Array.isArray(pRows) ? pRows : [];
				this._SelectedBoardID = pRow.IDMoodboard;
				this._VisionBoardLoadedFor = null;
				this._WantBoardEdit = true;
				this._rebuild();
			});
		}).catch(() => {});
	}

	// Open the hidden board-photo file input ("+ Photo").
	pickBoardPhoto()
	{
		if (typeof document === 'undefined') { return; }
		let tmpInput = document.getElementById('Entity-Board-PhotoInput');
		if (tmpInput) { tmpInput.value = ''; tmpInput.click(); }
	}

	onBoardPhotoPicked(pInput)
	{
		let tmpFile = pInput && pInput.files && pInput.files[0];
		if (tmpFile) { this.newBoardFromPhoto(tmpFile); }
	}

	// Add a whiteboard for this entity whose content is a photo (in-person capture). Creates the board,
	// opens it in edit, and drops the image in once the editor mounts (via _PendingPhoto).
	newBoardFromPhoto(pFile)
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp._can !== 'function' || !tmpApp._can('content.edit') || !pFile) { return; }
		let tmpAPI = this.pict.providers.MoodboardAPI;
		if (!tmpAPI) { return; }
		let tmpName = (pFile.name || 'Photo').replace(/\.[^.]+$/, '').slice(0, 80) || 'Photo';
		tmpAPI.createForOwner(this._key, this._id, tmpName).then((pRow) =>
		{
			if (!pRow || !pRow.IDMoodboard) { return; }
			return tmpAPI.listForEntity(this._key, this._id).then((pRows) =>
			{
				this._ownerBoards = Array.isArray(pRows) ? pRows : [];
				this._SelectedBoardID = pRow.IDMoodboard;
				this._VisionBoardLoadedFor = null;
				this._WantBoardEdit = true;
				this._PendingPhoto = pFile;
				this._rebuild();
			});
		}).catch(() => {});
	}

	// ── attach an existing whiteboard ─────────────────────────────────────────

	// A human label for where a candidate board currently lives, or null when it is standalone (no owner).
	// Mirrors the Whiteboards page's owner label so the attach picker reads the same way.
	_boardOwnerInfo(pRow)
	{
		if (!pRow) { return null; }
		if (pRow.OwnerType === 'Vision' || pRow.IDVision) { return { Label: 'Vision #' + (pRow.IDOwner || pRow.IDVision) }; }
		if (pRow.OwnerType === 'WorkItem') { return { Label: 'Work Item #' + pRow.IDOwner }; }
		if (pRow.OwnerType === 'Feature') { return { Label: 'Feature #' + pRow.IDOwner }; }
		if (pRow.OwnerType === 'Module') { return { Label: 'Module #' + pRow.IDOwner }; }
		if (pRow.OwnerType === 'User' || pRow.IDUser) { return { Label: 'a profile' }; }
		if (pRow.OwnerType) { return { Label: pRow.OwnerType + ' #' + pRow.IDOwner }; }
		return null;
	}

	// "+ Attach": pick an existing whiteboard (standalone, or one attached to another entity) and point it
	// at this entity. Loads the tenant's boards, drops the ones already here, and shows the rest in an
	// anchored menu with a hint of where each currently lives. Editors only.
	attachExistingBoard(pAnchor)
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp._can !== 'function' || !tmpApp._can('content.edit')) { return; }
		let tmpAPI = this.pict.providers.MoodboardAPI;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpAPI || !tmpModal || typeof tmpModal.dropdown !== 'function') { return; }
		tmpAPI.listAllForCustomer().then((pRows) =>
		{
			let tmpHere = {};
			(this._ownerBoards || []).forEach((pB) => { tmpHere[Number(pB.IDMoodboard)] = true; });
			let tmpCandidates = (Array.isArray(pRows) ? pRows : []).filter((pB) => pB && !tmpHere[Number(pB.IDMoodboard)]);
			// Standalone boards first (the common case: attach the field-trial sketch), then boards that
			// currently live elsewhere (re-association), each labelled with where they are.
			tmpCandidates.sort((pA, pB) =>
			{
				let tmpAOwned = this._boardOwnerInfo(pA) ? 1 : 0;
				let tmpBOwned = this._boardOwnerInfo(pB) ? 1 : 0;
				if (tmpAOwned !== tmpBOwned) { return tmpAOwned - tmpBOwned; }
				return String(pA.Name || '').localeCompare(String(pB.Name || ''));
			});
			let tmpItems = [{ Header: 'Attach an existing whiteboard' }];
			if (!tmpCandidates.length)
			{
				tmpItems.push({ Hash: '', Label: 'No other whiteboards to attach', Disabled: true, Tooltip: 'Draw one on the Whiteboards page first, then attach it here.' });
			}
			else
			{
				tmpCandidates.forEach((pB) =>
				{
					let tmpOwner = this._boardOwnerInfo(pB);
					tmpItems.push({ Hash: String(pB.IDMoodboard), Label: pB.Name || ('Whiteboard #' + pB.IDMoodboard), Hint: tmpOwner ? tmpOwner.Label : 'Standalone' });
				});
			}
			tmpModal.dropdown(pAnchor || '#Vision-Board-Menu-Btn', { align: 'left', minWidth: '240px', items: tmpItems }).then((pChoice) =>
			{
				if (!pChoice || !pChoice.Hash) { return; }
				let tmpID = Number(pChoice.Hash) || 0;
				if (!tmpID) { return; }
				let tmpRow = tmpCandidates.find((pB) => Number(pB.IDMoodboard) === tmpID);
				let tmpOwner = this._boardOwnerInfo(tmpRow);
				if (tmpOwner && tmpModal && typeof tmpModal.confirm === 'function')
				{
					// Attached elsewhere: attaching moves it. Say so before re-pointing it.
					tmpModal.confirm('This whiteboard is currently on ' + tmpOwner.Label + '. Attach it here and remove it from there?', { title: 'Move whiteboard here', confirmLabel: 'Attach here' })
						.then((pOk) => { if (pOk) { this._attachBoard(tmpID); } });
				}
				else { this._attachBoard(tmpID); }
			});
		}).catch((pErr) => this._toast('Could not load whiteboards to attach: ' + ((pErr && pErr.message) || pErr), 'error'));
	}

	// Re-point a board at this entity, then reload the section and drop straight into it (read-only mount).
	_attachBoard(pID)
	{
		let tmpAPI = this.pict.providers.MoodboardAPI;
		if (!tmpAPI || !pID) { return; }
		tmpAPI.attachToOwner(pID, this._key, this._id).then(() =>
		{
			return tmpAPI.listForEntity(this._key, this._id).then((pRows) =>
			{
				this._ownerBoards = Array.isArray(pRows) ? pRows : [];
				this._SelectedBoardID = Number(pID);
				this._VisionBoardEditing = false;
				this._VisionBoardLoadedFor = null;
				this._rebuild();
				this._toast('Whiteboard attached.', 'success');
			});
		}).catch((pErr) => this._toast('Attach failed: ' + ((pErr && pErr.message) || pErr), 'error'));
	}

	// ── manage the selected whiteboard (rename / disconnect / delete) ─────────

	// Open the actions menu for the selected board, anchored to the kebab button. Editors only. The
	// menu acts on the currently selected (mounted) board -- the one whose pill is active.
	boardMenu(pAnchor)
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp._can !== 'function' || !tmpApp._can('content.edit')) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpID = Number(this._SelectedBoardID) || 0;
		if (!tmpModal || typeof tmpModal.dropdown !== 'function' || !tmpID) { return; }
		let tmpRow = (this._ownerBoards || []).find((pB) => Number(pB.IDMoodboard) === tmpID);
		let tmpName = (tmpRow && tmpRow.Name) || ('Whiteboard #' + tmpID);
		tmpModal.dropdown(pAnchor || '#Vision-Board-Menu-Btn',
		{
			align: 'right',
			minWidth: '200px',
			items:
			[
				{ Header: tmpName },
				{ Hash: 'rename', Label: 'Rename…' },
				{ Hash: 'disconnect', Label: 'Disconnect from here' },
				{ Separator: true },
				{ Hash: 'delete', Label: 'Delete', Style: 'danger' }
			]
		}).then((pChoice) =>
		{
			if (!pChoice || !pChoice.Hash) { return; }
			if (pChoice.Hash === 'rename') { this._renameBoard(tmpID); }
			else if (pChoice.Hash === 'disconnect') { this._disconnectBoard(tmpID); }
			else if (pChoice.Hash === 'delete') { this._deleteBoard(tmpID); }
		});
	}

	// Rename the board: a small text-input dialog seeded with the current name; Enter or Save commits.
	_renameBoard(pID)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpRow = (this._ownerBoards || []).find((pB) => Number(pB.IDMoodboard) === Number(pID));
		let tmpCurrent = (tmpRow && tmpRow.Name) || '';
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpInputEl = null;
		tmpModal.show(
		{
			title: 'Rename whiteboard',
			width: '420px',
			closeable: true,
			content: '<div style="display:flex;flex-direction:column;gap:6px;">' +
				'<label style="font-size:12px;font-weight:600;letter-spacing:0.04em;text-transform:uppercase;color:var(--theme-color-text-secondary,#5b6376);">Name</label>' +
				'<input type="text" id="ps-board-rename-input" maxlength="200" value="' + _escapeHTML(tmpCurrent) + '" ' +
				'style="padding:8px 10px;border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;font-size:14px;' +
				'background:var(--theme-color-background-panel,#fff);color:var(--theme-color-text-primary,#2c3140);">' +
				'</div>',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				tmpInputEl = pDialog.querySelector('#ps-board-rename-input');
				if (!tmpInputEl) { return; }
				tmpInputEl.focus();
				tmpInputEl.select();
				// Enter commits by clicking the Save button (keeps the single dismiss path).
				tmpInputEl.addEventListener('keydown', (pKeyEvent) =>
				{
					if (pKeyEvent.key === 'Enter')
					{
						pKeyEvent.preventDefault();
						let tmpSaveBtn = pDialog.querySelector('[data-hash="save"]');
						if (tmpSaveBtn) { tmpSaveBtn.click(); }
					}
				});
			}
		}).then((pHash) =>
		{
			if (pHash !== 'save') { return; }
			let tmpName = (tmpInputEl && tmpInputEl.value != null) ? tmpInputEl.value.trim() : '';
			if (!tmpName) { this._toast('A whiteboard needs a name.', 'error'); return; }
			if (tmpName === tmpCurrent) { return; }
			let tmpAPI = this.pict.providers.MoodboardAPI;
			if (!tmpAPI) { return; }
			tmpAPI.update(pID, { Name: tmpName })
				.then(() =>
				{
					// Patch the cached row + repaint pills and the editor title (no re-fetch of board blobs).
					let tmpPatch = (this._ownerBoards || []).find((pB) => Number(pB.IDMoodboard) === Number(pID));
					if (tmpPatch) { tmpPatch.Name = tmpName; }
					this._rebuild();
					this._toast('Whiteboard renamed.', 'success');
				})
				.catch((pErr) => this._toast('Rename failed: ' + ((pErr && pErr.message) || pErr), 'error'));
		});
	}

	// Disconnect the board from this entity: clear its owner (and the legacy IDVision) so it becomes a
	// standalone whiteboard, still reachable from the Whiteboards page. The row is not deleted.
	_disconnectBoard(pID)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () =>
		{
			let tmpAPI = this.pict.providers.MoodboardAPI;
			if (!tmpAPI) { return; }
			tmpAPI.update(pID, { OwnerType: '', IDOwner: 0, IDVision: 0 })
				.then(() =>
				{
					this._dropBoardFromList(pID);
					this._toast('Whiteboard disconnected. It is now a standalone board on the Whiteboards page.', 'success');
				})
				.catch((pErr) => this._toast('Disconnect failed: ' + ((pErr && pErr.message) || pErr), 'error'));
		};
		let tmpMsg = 'Disconnect this whiteboard? It stays as a standalone whiteboard you can reach from the Whiteboards page, but it will no longer show here.';
		if (tmpModal && typeof tmpModal.confirm === 'function') { tmpModal.confirm(tmpMsg, { title: 'Disconnect whiteboard', confirmLabel: 'Disconnect' }).then((pOk) => { if (pOk) { tmpDo(); } }); }
		else { tmpDo(); }
	}

	// Delete the board outright (soft-delete via the Moodboard DELETE endpoint).
	_deleteBoard(pID)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () =>
		{
			let tmpAPI = this.pict.providers.MoodboardAPI;
			if (!tmpAPI) { return; }
			tmpAPI.remove(pID)
				.then(() =>
				{
					this._dropBoardFromList(pID);
					this._toast('Whiteboard deleted.', 'success');
				})
				.catch((pErr) => this._toast('Delete failed: ' + ((pErr && pErr.message) || pErr), 'error'));
		};
		if (tmpModal && typeof tmpModal.confirm === 'function') { tmpModal.confirm('Delete this whiteboard for good? This cannot be undone.', { title: 'Delete whiteboard', dangerous: true, confirmLabel: 'Delete' }).then((pOk) => { if (pOk) { tmpDo(); } }); }
		else { tmpDo(); }
	}

	// Drop a board out of this entity's cached list, pick a new selection (the first remaining, or none),
	// and repaint. Shared by disconnect and delete -- both leave the board out of this entity's picker.
	_dropBoardFromList(pID)
	{
		if (this._BoardSaveTimer) { clearTimeout(this._BoardSaveTimer); this._BoardSaveTimer = null; }
		this._ownerBoards = (this._ownerBoards || []).filter((pB) => Number(pB.IDMoodboard) !== Number(pID));
		if (Number(this._SelectedBoardID) === Number(pID))
		{
			this._SelectedBoardID = (this._ownerBoards[0] && this._ownerBoards[0].IDMoodboard) || 0;
		}
		this._VisionBoardEditing = false;
		this._VisionBoardLoadedFor = null;
		this._VisionBoardID = Number(this._SelectedBoardID) || 0;
		this._rebuild();
	}

	// Whether a loaded board has no content (no cards). Delegates to the moodboard module's own accessor
	// (isBoardEmpty) so the host does not re-encode the board's internal shape; if the view is not
	// registered yet it falls back to a Nodes check. Callers use this to collapse an empty board's
	// container rather than mount an empty box.
	_boardIsEmpty(pBoard)
	{
		let tmpView = this.pict.views['Vision-Board-View'] || this.pict.views['Vision-Board-Edit'];
		if (tmpView && typeof tmpView.isBoardEmpty === 'function') { return tmpView.isBoardEmpty(pBoard); }
		let tmpNodes = (pBoard && Array.isArray(pBoard.Nodes)) ? pBoard.Nodes : [];
		return tmpNodes.length === 0;
	}

	// True when none of these board rows carry content. A read-only viewer with only empty boards gets no
	// board section at all (rather than a header over a blank box); an editor always keeps it so they can
	// start one, and a board with content anywhere keeps it so a viewer can open that one.
	_allBoardsEmpty(pRows)
	{
		let tmpRows = Array.isArray(pRows) ? pRows : [];
		if (!tmpRows.length) { return true; }
		let tmpAPI = this.pict.providers.MoodboardAPI;
		if (!tmpAPI) { return false; }
		for (let i = 0; i < tmpRows.length; i++)
		{
			if (!this._boardIsEmpty(tmpAPI.loadBoard(tmpRows[i]))) { return false; }
		}
		return true;
	}

	// Mount the read-only (display-style) or the editable instance into #Vision-Board. The display-style
	// toggle + set-view-area live in the moodboard's own toolbar while editing; the host only sizes the
	// container when the style changes (onBoardDisplayStyleChanged).
	_renderVisionBoardView(pEditing, pBoard)
	{
		let tmpHost = document.getElementById('Vision-Board');
		if (tmpHost) { tmpHost.innerHTML = ''; }
		// An empty board mounted read-only is just an empty bordered box. Collapse the container instead of
		// mounting -- edit mode always mounts so a user can start adding content. Toggling Done on a board a
		// user left empty routes back here read-only and re-collapses; adding a node makes it mount.
		if (!pEditing && this._boardIsEmpty(pBoard))
		{
			if (tmpHost)
			{
				tmpHost.classList.add('ps-board-empty-collapsed');
				// Drop any presentation chrome a previous non-empty board left on the container / detail.
				tmpHost.classList.remove('ps-board-jumbotron', 'ps-board-background');
				let tmpDetail = (typeof tmpHost.closest === 'function') ? tmpHost.closest('.ps-detail') : null;
				if (tmpDetail) { tmpDetail.classList.remove('ps-detail-backdrop'); tmpDetail.style.paddingTop = ''; }
			}
			this._updateVisionEditButton();
			return;
		}
		if (tmpHost) { tmpHost.classList.remove('ps-board-empty-collapsed'); }
		this._VisionBoardViewName = pEditing ? 'Vision-Board-Edit' : 'Vision-Board-View';
		let tmpView = this.pict.views[this._VisionBoardViewName];
		if (!tmpView) { return; }
		tmpView.render();
		// Apply the vision's Drafting-Kit default connection style so newly drawn links match the craft.
		if (this._connectionStyle && typeof tmpView.setConnectionDefaults === 'function') { tmpView.setConnectionDefaults(this._connectionStyle); }
		// Apply the vision's Drafting-Kit sticker set so the board's gallery opens on the craft's stickers.
		if (this._stickerSet || this._stickerSetItems)
		{
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && tmpApp._StickerSources && tmpApp._StickerSources.vision && typeof tmpApp._StickerSources.vision.setActiveSet === 'function')
			{
				// A custom set ships its resolved items from the lexicon (per-tenant rows not in the bundle);
				// a system set is just a key the source resolves from the in-bundle registry.
				tmpApp._StickerSources.vision.setActiveSet(this._stickerSetItems && this._stickerSetItems.length ? this._stickerSetItems : this._stickerSet);
			}
		}
		tmpView.setBoard(pBoard || { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } });
		// A board created via "+ Photo" drops its image in once the editor has mounted.
		if (pEditing && this._PendingPhoto && typeof tmpView.addImageFiles === 'function')
		{
			let tmpFile = this._PendingPhoto;
			this._PendingPhoto = null;
			setTimeout(() =>
			{
				try
				{
					// Full-bleed: a jumbotron fits the width of a frame seeded from the photo.
					if (typeof tmpView.setDisplayStyle === 'function') { tmpView.setDisplayStyle('jumbotron'); }
					tmpView.addImageFiles([tmpFile]);
				}
				catch (pErr) { /* leave the board empty */ }
			}, 200);
		}
		this._updateVisionEditButton();
	}

	// "Edit board" / "Done": flip the inspiration board between its saved display style (read-only) and the
	// editable canvas, in place. Editors only.
	toggleVisionBoardEdit()
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp._can !== 'function' || !tmpApp._can('content.edit')) { return; }
		if (this._VisionBoardEditing)
		{
			// Exit: capture the edited board + persist, then back to the read-only display.
			let tmpEdit = this.pict.views['Vision-Board-Edit'];
			let tmpBoard = (tmpEdit && typeof tmpEdit.getBoard === 'function') ? tmpEdit.getBoard() : this._VisionBoard;
			this._VisionBoard = tmpBoard;
			let tmpAPI = this.pict.providers.MoodboardAPI;
			if (tmpAPI && this._VisionBoardID) { tmpAPI.saveBoard(this._VisionBoardID, tmpBoard).catch(() => {}); }
			this._VisionBoardEditing = false;
		}
		else
		{
			this._VisionBoardEditing = true;
		}
		this._renderVisionBoardView(this._VisionBoardEditing, this._VisionBoard);
	}

	_updateVisionEditButton()
	{
		let tmpButton = document.getElementById('Vision-Board-Edit-Toggle');
		if (tmpButton)
		{
			tmpButton.textContent = this._VisionBoardEditing ? 'Done' : 'Edit board';
			// Float the Done button over the fullscreen overlay while editing (see the CSS note above).
			tmpButton.classList.toggle('is-board-editing', !!this._VisionBoardEditing);
		}
	}

	// Lay out #Vision-Board for the current presentation, reported by the moodboard: a jumbotron is a hero
	// band (its scaled view-area frame height) above the detail; a background becomes a full-page layer
	// BEHIND the whole vision detail (the sections render on top); the canvas is the bounded box.
	onBoardDisplayStyleChanged(pInfo)
	{
		let tmpEl = document.getElementById('Vision-Board');
		if (!tmpEl || !pInfo) { return; }
		let tmpDetail = (typeof tmpEl.closest === 'function') ? tmpEl.closest('.ps-detail') : null;
		tmpEl.classList.remove('ps-board-jumbotron', 'ps-board-background');
		if (tmpDetail) { tmpDetail.classList.remove('ps-detail-backdrop'); tmpDetail.style.paddingTop = ''; }
		if (pInfo.effectiveStyle === 'jumbotron')
		{
			tmpEl.classList.add('ps-board-jumbotron');
			let tmpHeight = pInfo.jumbotronHeight;
			tmpEl.style.height = (tmpHeight > 0 ? Math.max(140, Math.min(560, tmpHeight)) : 320) + 'px';
		}
		else if (pInfo.effectiveStyle === 'background')
		{
			// Backdrop: the board fills the whole detail as a full-page layer behind the content
			// (ps-detail-backdrop CSS, z-index -1). The gear "Backdrop top margin" pushes the detail content
			// down so the top band shows the board art (24px is the base ps-detail padding).
			tmpEl.classList.add('ps-board-background');
			tmpEl.style.height = '';
			if (tmpDetail)
			{
				tmpDetail.classList.add('ps-detail-backdrop');
				let tmpMargin = (pInfo.topMargin > 0) ? pInfo.topMargin : 0;
				if (tmpMargin) { tmpDetail.style.paddingTop = (24 + tmpMargin) + 'px'; }
			}
		}
		else
		{
			tmpEl.style.height = '';
		}
	}

	// Autosave hook wired to Vision-Board-Edit. Keep the cached board fresh so a re-mount uses the latest
	// edits, and debounce the write.
	onBoardSaved(pBoard)
	{
		if (!this._VisionBoardID) { return; }
		this._VisionBoard = pBoard;
		// Keep the cached list row fresh so switching whiteboards and back shows the latest edits.
		let tmpRow = (this._ownerBoards || []).find((pB) => Number(pB.IDMoodboard) === Number(this._VisionBoardID));
		if (tmpRow) { try { tmpRow.BoardJSON = JSON.stringify(pBoard); } catch (pErr) { /* keep cache as-is */ } }
		if (this._BoardSaveTimer) { clearTimeout(this._BoardSaveTimer); }
		let tmpSelf = this;
		this._BoardSaveTimer = setTimeout(function ()
		{
			tmpSelf._BoardSaveTimer = null;
			let tmpAPI = tmpSelf.pict.providers.MoodboardAPI;
			if (tmpAPI) { tmpAPI.saveBoard(tmpSelf._VisionBoardID, pBoard).catch(() => {}); }
		}, 800);
	}

	// ── embedded comments section (Vision, WorkItem) ──────────────────────────

	// Mount (or re-mount) the comments section after a render. The detail re-renders on relation edits,
	// which wipes the #Entity-Comments container, so this runs every render: same record just repaints
	// the already-loaded threads; a new record re-points the section at the new context (it loads its
	// own data through PlansheetCommentProvider). Posting is gated to content.edit; others see read-only.
	_mountPrompts()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.PromptsSlot && tmpState.PromptsSlot[0]) ? tmpState.PromptsSlot[0] : null;
		if (!tmpSlot) { return; }
		let tmpView = this.pict.views['Plansheet-PromptAttachments'];
		if (!tmpView || typeof document === 'undefined') { return; }
		// Pass the human number (WorkItemNumber) so the panel can render the copy-paste MCP run
		// block, which names the work item by its number, not its raw id.
		let tmpDesc = libDescriptors.Entities[this._key] || {};
		let tmpRecord = this._loadedRecord || (this._provider(this._key) && this._provider(this._key).store().Index[this._id]) || null;
		let tmpNumber = (tmpRecord && tmpDesc.NumberField) ? (Number(tmpRecord[tmpDesc.NumberField]) || 0) : 0;
		tmpView.showFor(this._key, this._id, 'Entity-Prompts', tmpNumber);
	}

	// Mount read-only PromptEmbed cards for the prompts of this record's linked work items (descriptor
	// WorkItemPrompts: true -- Feedback). Gathers the FeedbackWorkItem join -> each work item's prompt
	// links, groups by work item, and mounts an embed per prompt with its MCP run command (when the plan
	// sheet has a Code). Read-only here: editing a prompt stays on the work item.
	_mountWorkItemPrompts()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.WorkItemPromptsSlot && tmpState.WorkItemPromptsSlot[0]) ? tmpState.WorkItemPromptsSlot[0] : null;
		if (!tmpSlot || typeof document === 'undefined') { return; }
		let tmpHost = document.getElementById('Entity-WorkItemPrompts');
		if (!tmpHost) { return; }
		let tmpJoin = libDescriptors.Joins.FeedbackWorkItem;
		let tmpCode = ((this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.CustomerCode) || '');
		this._wiPromptEmbeds = [];
		this.pict.providers.LinkAPI.listLinks(tmpJoin.Plural, 'IDFeedback', this._id)
			.then((pRows) =>
			{
				let tmpSeen = {};
				let tmpIDs = (pRows || []).map((pR) => Number(pR.IDWorkItem)).filter((pX) => (pX > 0 && !tmpSeen[pX] && (tmpSeen[pX] = true)));
				if (!tmpIDs.length) { return null; }
				return Promise.all(tmpIDs.map((pIDWI) => Promise.all(
				[
					libFrameworkClient.getJSON(this.pict, '/1.0/WorkItem/' + pIDWI).catch(() => null),
					this.pict.providers.PromptAPI.linksFor('WorkItem', pIDWI).catch(() => [])
				]).then((pPair) =>
				{
					let tmpWI = pPair[0]; if (Array.isArray(tmpWI)) { tmpWI = tmpWI[0]; }
					return { WI: tmpWI || { IDWorkItem: pIDWI }, Prompts: pPair[1] || [] };
				})));
			})
			.then((pGroups) =>
			{
				if (!pGroups) { tmpHost.innerHTML = '<div style="font-size:12.5px;color:var(--theme-color-text-secondary,#5b6376);">No linked work items yet.</div>'; return; }
				let tmpHTML = '';
				let tmpMounts = [];
				pGroups.forEach((pGroup, pGroupIdx) =>
				{
					if (!pGroup.Prompts.length) { return; }
					let tmpWI = pGroup.WI || {};
					let tmpNumber = tmpWI.WorkItemNumber || tmpWI.IDWorkItem;
					tmpHTML += '<div style="margin:8px 0 4px;font-size:11px;text-transform:uppercase;letter-spacing:0.04em;color:var(--theme-color-text-secondary,#5b6376);">Work Item #' + _escapeHTML(tmpNumber) + ' - ' + _escapeHTML(tmpWI.Title || '') + '</div>';
					pGroup.Prompts.forEach((pEntry, pPromptIdx) =>
					{
						let tmpHostID = 'wip-' + pGroupIdx + '-' + pPromptIdx;
						tmpHTML += '<div id="' + tmpHostID + '"></div>';
						let tmpPromptNum = (pEntry.Prompt && pEntry.Prompt.PromptNumber) || 0;
						let tmpRun = (tmpCode && tmpNumber && tmpPromptNum) ? ('Using the plansheet MCP, load the ' + tmpCode + ' plan sheet and run prompt ' + tmpPromptNum + ' for Work Item ' + tmpNumber + '.') : '';
						tmpMounts.push({ HostID: tmpHostID, Entry: pEntry, RunCommand: tmpRun });
					});
				});
				if (!tmpHTML) { tmpHTML = '<div style="font-size:12.5px;color:var(--theme-color-text-secondary,#5b6376);">The linked work items have no prompts yet.</div>'; }
				tmpHost.innerHTML = tmpHTML;
				tmpMounts.forEach((pMount) =>
				{
					let tmpEl = document.getElementById(pMount.HostID);
					if (!tmpEl) { return; }
					let tmpEmbed = new libPromptEmbed(this.pict);
					tmpEmbed.configure(pMount.Entry, { RunCommand: pMount.RunCommand, Editable: false });
					tmpEmbed.mount(tmpEl);
					this._wiPromptEmbeds.push(tmpEmbed);
				});
			})
			.catch(() => { /* a transient fetch failure just leaves the section empty */ });
	}

	_mountComments()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.CommentsSlot && tmpState.CommentsSlot[0]) ? tmpState.CommentsSlot[0] : null;
		if (!tmpSlot) { return; }
		let tmpView = this.pict.views['Plansheet-Comments'];
		if (!tmpView || typeof document === 'undefined') { return; }

		// Load the team roster once so the section can show author names for teammates.
		if (!this._CommentsRosterLoaded && this.pict.providers.TeamAPI && typeof this.pict.providers.TeamAPI.roster === 'function')
		{
			this._CommentsRosterLoaded = true;
			this.pict.providers.TeamAPI.roster().catch(() => {});
		}

		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		tmpView.options.CurrentUser = { Key: tmpUser.IDUser || 0, Name: tmpUser.DisplayName || tmpUser.Email || 'You', Avatar: tmpUser.AvatarURL || '' };
		tmpView.options.ReadOnly = !tmpSlot.Editable;

		let tmpHost = document.getElementById('Entity-Comments');
		if (tmpHost) { tmpHost.innerHTML = ''; }

		if (this._CommentsLoadedFor === this._id)
		{
			tmpView.render();
			return;
		}
		this._CommentsLoadedFor = this._id;
		tmpView.setContext({ OwnerType: this._key, IDOwner: this._id });
	}

	// Mount the SHARED checklists for this entity (WorkItem) into #Entity-Checklists. The detail
	// re-render wipes the container, so re-point + repaint the embedded collection every render.
	_mountChecklists()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.ChecklistsSlot && tmpState.ChecklistsSlot[0]) ? tmpState.ChecklistsSlot[0] : null;
		if (!tmpSlot || typeof document === 'undefined') { return; }
		let tmpView = this.pict.views['Plansheet-Checklists-Embed'];
		if (!tmpView) { return; }
		if (!document.getElementById('Entity-Checklists')) { return; }
		tmpView.configure('owner', this._key, this._id);
	}

	// Mount the three refinement loops for a vision into #Entity-VisionLoops. Re-point + repaint every
	// render (the detail re-render wipes the container).
	_mountVisionLoops()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.LoopsSlot && tmpState.LoopsSlot[0]) ? tmpState.LoopsSlot[0] : null;
		if (!tmpSlot || typeof document === 'undefined') { return; }
		if (!document.getElementById('Entity-VisionLoops')) { return; }
		let tmpView = this.pict.views['Plansheet-VisionLoops'];
		if (tmpView && typeof tmpView.configure === 'function') { tmpView.configure(this._id); }
	}

	// Mount the connections grid for an entity into #Entity-Connections. Re-point + repaint every render.
	_mountConnections()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.ConnectionsSlot && tmpState.ConnectionsSlot[0]) ? tmpState.ConnectionsSlot[0] : null;
		if (!tmpSlot || typeof document === 'undefined') { return; }
		if (!document.getElementById('Entity-Connections')) { return; }
		let tmpView = this.pict.views['Plansheet-Connections'];
		let tmpDesc = libDescriptors.Entities[this._key] || {};
		if (tmpView && typeof tmpView.configure === 'function') { tmpView.configure(this._key, this._id, 'graphite', !!tmpDesc.Prompts); }
	}

	// The Content provider (pict-section-content) backs both the inline reads below and the
	// editor's live preview (via pict-section-markdowneditor), so a core doc and its editor
	// render identically -- same markdown parse, same Mermaid/KaTeX activation.
	_contentProvider() { return this.pict.providers.Content; }

	_renderCoreDoc()
	{
		let tmpBody = String(this._coreDocBody || '');
		if (!tmpBody.trim() || typeof document === 'undefined') { return; }
		let tmpContainer = document.getElementById('EntityDetail-CoreDoc');
		libMarkdownRender.renderInto(this._contentProvider(), tmpContainer, tmpBody);
	}

	// Render Markdown-flagged field bodies (built in _rebuild) into their per-field
	// containers, the same way the core document renders.
	_renderMarkdownFields()
	{
		if (typeof document === 'undefined') { return; }
		let tmpFields = (this.pict.AppData.EntityDetail && this.pict.AppData.EntityDetail.Fields) || [];
		for (let i = 0; i < tmpFields.length; i++)
		{
			let tmpSlot = (tmpFields[i].MDSlot && tmpFields[i].MDSlot[0]) || null;
			if (!tmpSlot) { continue; }
			let tmpContainer = document.getElementById(tmpSlot.ContainerID);
			libMarkdownRender.renderInto(this._contentProvider(), tmpContainer, tmpSlot.Body);
		}
	}

	// Mount (or re-mount) the embedded step editor after a render. The detail re-renders
	// on relation edits, which wipes the #Routine-Steps container, so this runs every
	// render: the same record repaints from the editor's AppData cache; a new record
	// reloads its steps from the server.
	_mountStepEditor()
	{
		let tmpState = this.pict.AppData.EntityDetail;
		let tmpSlot = (tmpState && tmpState.StepsSlot && tmpState.StepsSlot[0]) ? tmpState.StepsSlot[0] : null;
		if (!tmpSlot) { return; }
		let tmpView = this.pict.views['Plansheet-RoutineSteps'];
		if (!tmpView || typeof document === 'undefined') { return; }
		if (this._StepsLoadedFor === this._id)
		{
			tmpView.render();
			return;
		}
		this._StepsLoadedFor = this._id;
		tmpView.show(this._id, tmpSlot.Editable);
	}
}

module.exports = PictViewEntityDetail;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-EntityDetail',
	DefaultRenderable: 'EntityDetail-Display',
	AutoRender: false,
	CSS: /*css*/`
		/* Per-vision craft picker in the detail header. */
		.ps-detail-craft { display: flex; align-items: center; gap: 8px; margin: -4px 0 18px; font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-detail-craft-label { text-transform: uppercase; letter-spacing: 0.04em; font-size: 11px; font-weight: 600; }
		.ps-detail-craft-current { color: var(--theme-color-text-primary, #2c3140); }
		/* Blueprint title block (WorkItem detail) -- a branded drafting sheet. */
		.ps-detail-blueprint { margin: 4px 0 22px; }
		.bp-sheet { background: #0E3460; border-radius: 12px; padding: 10px; }
		.bp-frame { border: 1.4px solid #EAF2FC; border-radius: 6px; padding: 16px 18px; position: relative; }
		.bp-head { display: flex; align-items: baseline; gap: 12px; margin-bottom: 14px; }
		.bp-kicker { font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 3px; color: #7FA8DA; }
		.bp-title { font-size: 16px; font-weight: 700; color: #EAF2FC; }
		.bp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
		.bp-cell { border: 1px solid rgba(234,242,252,0.4); border-radius: 5px; padding: 10px 12px; background: #123A64; min-height: 64px; }
		.bp-cell-head { display: flex; align-items: baseline; gap: 8px; }
		.bp-count { font-size: 26px; font-weight: 700; color: #EAF2FC; line-height: 1; }
		.bp-label { font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 1px; color: #9DBDE6; text-transform: uppercase; }
		.bp-items { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 8px; }
		.bp-item { font-size: 11px; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 2px 7px; border-radius: 4px; background: rgba(234,242,252,0.10); color: #EAF2FC; cursor: pointer; }
		.bp-item:hover { background: rgba(234,242,252,0.20); }
		.bp-item.is-pinned { box-shadow: inset 0 0 0 1px #F2C84B; }
		.bp-item-x { border: none; background: none; color: #F2C84B; cursor: pointer; font-size: 13px; line-height: 1; padding: 0 0 0 5px; margin: 0; }
		.bp-item-x:hover { color: #fff; }
		/* Pin composer: one framed navy panel so the two pickers + button read as a single deliberate
		   control. The pict-section-picker's theme tokens are re-mapped to the blueprint palette (same
		   technique as the connections linker) so both pickers look sexy and in-theme, not like a
		   light-theme control dropped on the sheet. */
		.bp-add {
			margin-top: 16px; padding: 13px 15px 15px; border-radius: 8px;
			border: 1px solid rgba(234,242,252,0.4); background: #123A64;
			display: flex; flex-direction: column; gap: 11px;
			--theme-color-background-primary: rgba(8,18,36,0.55);
			--theme-color-background-panel: #0E3460;
			--theme-color-background-secondary: rgba(9,22,44,0.6);
			--theme-color-background-tertiary: rgba(150,180,220,0.22);
			--theme-color-background-hover: rgba(150,180,220,0.16);
			--theme-color-text-primary: #EAF2FC;
			--theme-color-text-secondary: #9DBDE6;
			--theme-color-text-muted: #7FA8DA;
			--theme-color-border-default: rgba(150,180,220,0.36);
			--theme-color-border-light: rgba(150,180,220,0.30);
			--theme-color-border-strong: rgba(234,242,252,0.5);
			--theme-color-brand-primary: #F2C84B;
		}
		.bp-add-kicker { font-family: ui-monospace, Menlo, monospace; font-size: 11px; letter-spacing: 2px; color: #7FA8DA; text-transform: uppercase; }
		.bp-add-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
		.bp-add-field > .pict-section-picker, .bp-add-field > div { width: 100%; }
		.bp-add-type { flex: 0 0 auto; width: 148px; }
		.bp-add-item { flex: 1 1 220px; min-width: 190px; }
		.bp-add-btn { flex: 0 0 auto; font: inherit; font-size: 13px; padding: 8px 18px; border-radius: 7px; border: 1.5px solid #F2C84B; background: transparent; color: #F2C84B; cursor: pointer; }
		.bp-add-btn:hover { background: rgba(242,200,75,0.15); }
		.bp-empty { font-size: 12px; color: #9DBDE6; padding: 6px 2px; }
		.bp-titleblock { display: flex; gap: 0; margin-top: 14px; border: 1px solid rgba(234,242,252,0.5); border-radius: 4px; overflow: hidden; }
		.bp-tb-cell { display: flex; flex-direction: column; gap: 2px; padding: 6px 12px; border-right: 1px solid rgba(234,242,252,0.3); }
		.bp-tb-k { font-family: ui-monospace, Menlo, monospace; font-size: 8px; letter-spacing: 1px; color: #7FA8DA; }
		.bp-tb-v { font-family: ui-monospace, Menlo, monospace; font-size: 12px; color: #EAF2FC; }
		/* root container styling comes from .ps-page .ps-page-narrow (Shell) */
		.ps-detail-head { margin-bottom: 20px; }
		.ps-detail-back { background: none; border: none; padding: 0; margin: 0 0 10px; color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; font-size: 13px; line-height: 1; }
		.ps-detail-back:hover { color: var(--theme-color-brand-primary, #2988df); }
		.ps-detail-title { font-size: 28px; font-weight: 700; color: var(--theme-color-text-primary, #2c3140); margin: 0 0 14px; line-height: 1.2; }
		/* "Addressed" pill next to a handled feedback's title. */
		.ps-addressed-badge { display: inline-block; vertical-align: middle; margin-left: 12px; padding: 3px 12px; border-radius: 999px;
			font-size: 13px; font-weight: 600; letter-spacing: 0.02em;
			background: var(--theme-color-status-success-subtle, #e7f4ec); color: var(--theme-color-status-success, #2e7d32);
			border: 1px solid var(--theme-color-status-success, #2e7d32); }
		.ps-detail-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
		.ps-detail-actions:empty { display: none; }
		.ps-detail-fields {
			display: flex; flex-wrap: wrap; align-items: stretch;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #e6e9ee);
			border-radius: 10px; overflow: hidden; margin-bottom: 20px;
		}
		.ps-detail-fields:empty { display: none; }
		.ps-detail-fcell { flex: 1 1 0; min-width: 130px; padding: 10px 16px; border-right: 1px solid var(--theme-color-border-default, #e6e9ee); }
		/* The rightmost stat cell on a row: drop its divider so it never dangles into empty space -- when it
		   is the last cell overall, or the last stat cell before a full-width (is-wide) row begins. */
		.ps-detail-fcell:last-child:not(.is-wide) { border-right: none; }
		.ps-detail-fcell:not(.is-wide):has(+ .is-wide) { border-right: none; }
		.ps-detail-fcell.is-wide { flex: 1 1 100%; border-right: none; border-top: 1px solid var(--theme-color-border-default, #e6e9ee); }
		.ps-detail-fcell.is-wide:first-child { border-top: none; }
		.ps-detail-flabel { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.07em; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-detail-fval { font-size: 14px; color: var(--theme-color-text-primary, #2c3140); margin-top: 4px; white-space: pre-wrap; }
		.ps-detail-board-wrap { margin-bottom: 20px; }
		.ps-detail-board-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 0 0 10px; flex-wrap: wrap; }
		.ps-detail-board-h { margin: 0; font-size: 13px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-detail-board { height: 320px; position: relative; border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-secondary, #f4f6f9); }
		/* An empty board mounted read-only would be just an empty bordered box; the host adds this class to
		   collapse the container entirely (the section header + Edit affordance stay for editors). */
		.ps-detail-board.ps-board-empty-collapsed { display: none; }
		/* A jumbotron board reads as a hero band (its height is set to the scaled view-area frame), a
		   background board as a taller full-width backdrop. The host JS sets the inline height; these just
		   tune the chrome so the band / backdrop sits flush like a banner rather than a bordered widget. */
		.ps-detail-board.ps-board-jumbotron, .ps-detail-board.ps-board-background { border-color: transparent; background: var(--theme-color-background-panel, #fff); }
		/* Backdrop display style (view mode): the board becomes a full-page layer BEHIND the whole vision
		   detail; the sections render on top. isolation:isolate keeps the z-index:-1 board inside the detail's
		   own stacking context (not behind the page); pointer-events:none keeps it a non-interactive backdrop.
		   The host pushes the content down (padding-top) by the gear "Backdrop top margin". */
		.ps-detail.ps-detail-backdrop { position: relative; isolation: isolate; }
		.ps-detail-backdrop .ps-detail-board { position: absolute; inset: 0; height: auto !important; z-index: -1; border: none; border-radius: 0; pointer-events: none; }
		/* The "Edit board" / "Done" toggle next to the heading (editors only). The display-style toggle +
		   set-view-area live in the moodboard's own toolbar while editing. */
		.ps-board-edit-toggle { padding: 4px 12px; font-size: 12px; }
		/* The "manage this whiteboard" kebab next to the Edit toggle: opens rename / disconnect / delete
		   for the selected board (editors only). */
		.ps-board-menu-btn { padding: 4px 10px; font-size: 16px; line-height: 1; font-weight: 700; }
		/* While editing, the inspiration board auto-enters the flow's full-viewport fullscreen
		   (Vision-Board-Edit FullscreenOnEdit), whose position:fixed overlay covers the detail chrome.
		   Float the Done toggle above that overlay (z-index over the flow's 9999) so exiting edit stays one
		   click; it doubles as a visible fallback if fullscreen never engages. */
		.ps-board-edit-toggle.is-board-editing
		{
			position: fixed; top: 14px; right: 18px; z-index: 10001;
			padding: 8px 18px; font-size: 13px;
			background: var(--theme-color-brand-primary, #3b6fd4); color: #fff;
			border-color: var(--theme-color-brand-primary, #3b6fd4);
			box-shadow: 0 2px 12px rgba(20, 28, 45, 0.32);
		}
		/* Whiteboard picker pills (an owner can have several boards). */
		.ps-board-tabs { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; flex: 1; }
		.ps-board-tab { padding: 3px 11px; font-size: 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 14px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; }
		.ps-board-tab:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-primary, #2c3140); }
		.ps-board-tab.is-active { background: var(--theme-color-brand-primary, #3b6fd4); border-color: var(--theme-color-brand-primary, #3b6fd4); color: #fff; }
		.ps-board-tab-new { border-style: dashed; }
		.ps-board-empty { padding: 14px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 10px; color: var(--theme-color-text-secondary, #5b6376); font-size: 13px; margin-bottom: 10px; }
		.ps-rel {
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #e6e9ee);
			border-radius: 10px; padding: 14px 16px; margin-bottom: 14px;
		}
		.ps-rel h4 { margin: 0 0 10px; font-size: 13px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-rel-items { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 10px; }
		.ps-rel-empty { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); font-style: italic; }
		.ps-chip {
			display: inline-flex; align-items: center; gap: 6px; padding: 4px 6px 4px 10px;
			background: var(--theme-color-background-secondary, #eef1f6); border-radius: 999px; font-size: 13px;
			color: var(--theme-color-text-primary, #2c3140);
		}
		.ps-chip a.ps-link { color: var(--theme-color-brand-primary, #2988df); cursor: pointer; text-decoration: none; }
		.ps-chip a.ps-link:hover { text-decoration: underline; }
		.ps-chip-rel { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); background: var(--theme-color-background-panel, #fff); padding: 0 6px; border-radius: 999px; }
		.ps-chip-sub { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-chip-x { border: none; background: transparent; cursor: pointer; color: var(--theme-color-status-danger, #c0392b); font-size: 15px; line-height: 1; padding: 0 2px; }
		.ps-rel-add { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
		.ps-rel-target { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
		/* The relation record pickers' host divs (WI #446) -- a plain fk/target picker (no sibling in its
		   row) just wants the full row width; one sharing a flex row with a button (link-add, subvision-
		   add) needs to claim the remaining space instead of shrinking to its content, same sizing as the
		   Blueprint composer's .bp-add-item. */
		.ps-input-picker { width: 100%; }
		.ps-rel-picker { flex: 1 1 220px; min-width: 190px; }
		.ps-chip-title { font-weight: 500; }
		.ps-input-sm { padding: 2px 6px; font-size: 12px; }
		.ps-media-grid { display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 10px; }
		.ps-media-item { position: relative; }
		.ps-media-thumb { width: 120px; height: 84px; object-fit: cover; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d8dde6); display: block; background: var(--theme-color-background-secondary, #f1f3f7); }
		.ps-media-file { display: inline-flex; align-items: center; gap: 8px; padding: 10px 14px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-secondary, #f1f3f7); text-decoration: none; }
		.ps-media-file-type { font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em; background: var(--theme-color-background-panel, #fff); padding: 1px 6px; border-radius: 999px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-media-x { position: absolute; top: -8px; right: -8px; background: var(--theme-color-background-panel, #fff); border-radius: 999px; width: 20px; height: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }
		.ps-file-btn { cursor: pointer; }
			.ps-detail-sub { margin: -8px 0 16px; color: var(--theme-color-text-secondary, #5b6376); font-size: 15px; }
		.ps-detail-sub:empty { display: none; }
		.ps-detail-notfound { margin: 8px 0 4px; padding: 16px 18px; border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 10px; background: var(--theme-color-background-secondary, #f4f6f9); color: var(--theme-color-text-secondary, #5b6376); font-size: 15px; }
			.ps-detail-sub:empty { display: none; }
			.ps-coredoc-body { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 8px; padding: 16px 18px; margin-bottom: 10px; max-height: 560px; overflow-y: auto; }
			.ps-coredoc-body img { max-width: 100%; border-radius: 6px; }
			.ps-coredoc-body pre { background: var(--theme-color-background-secondary, #f1f3f7); padding: 10px; border-radius: 6px; overflow-x: auto; }
			.ps-coredoc-empty { color: var(--theme-color-text-secondary, #5b6376); font-style: italic; margin-bottom: 10px; }
			.ps-subv-grid { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 10px; }
			.ps-subv-card { width: 180px; padding: 10px 12px; border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 8px; background: var(--theme-color-background-panel, #fff); cursor: pointer; }
			.ps-subv-card:hover { border-color: var(--theme-color-brand-primary, #2988df); }
			.ps-subv-card-head { display: flex; align-items: center; justify-content: space-between; }
			.ps-subv-num { font-size: 11px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); }
			.ps-subv-name { font-size: 14px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 4px 0 2px; }
			.ps-subv-sub { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }
			.ps-subv-partof { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 10px; display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
			.ps-subv-partof-label { font-weight: 600; }
			.ps-detail-steps-wrap { margin-bottom: 20px; }
			.ps-detail-fmd { white-space: normal; }
			.ps-detail-fmd p:first-child { margin-top: 0; }
			.ps-detail-fmd p:last-child { margin-bottom: 0; }
			.ps-detail-fmd img { max-width: 100%; border-radius: 6px; }
			.ps-detail-fmd pre { background: var(--theme-color-background-secondary, #f1f3f7); padding: 10px; border-radius: 6px; overflow-x: auto; }
			.ps-media-video { width: 240px; max-height: 160px; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: #000; display: block; }
			.ps-story { margin: 18px 0; }
			.ps-review-summary { font-size: 12px; font-weight: 600; color: var(--theme-color-text-secondary,#5b6376); }
			.ps-review-summary.ps-review-ok { color: #3fae6b; }
			.ps-review-summary.ps-review-warn { color: #d0555b; }
			.ps-review-dot { background: #d0555b; color: #fff; }
			.ps-review-reason { font-weight: 600; color: var(--theme-color-text-primary,#1f2733); }
			.ps-review-issues { background: rgba(208,85,91,0.12); color: #d0555b; }
			.ps-review-note { margin-top: 4px; font-size: 13px; color: var(--theme-color-text-secondary,#5b6376); white-space: pre-wrap; }
			.ps-story-head { display: flex; align-items: baseline; gap: 10px; margin-bottom: 12px; }
			.ps-story-h { font-size: 14px; font-weight: 700; color: var(--theme-color-text-primary, #2c3140); margin: 0; }
			.ps-story-count { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
			.ps-story-line { list-style: none; margin: 0; padding: 0; position: relative; }
			.ps-story-line::before { content: ''; position: absolute; left: 11px; top: 6px; bottom: 6px; width: 2px; background: var(--theme-color-border-default, #e6e9ee); }
			.ps-story-node { position: relative; display: flex; gap: 14px; padding-bottom: 14px; }
			.ps-story-node:last-child { padding-bottom: 0; }
			.ps-story-dot { flex: 0 0 auto; z-index: 1; width: 24px; height: 24px; border-radius: 999px; background: var(--theme-color-background-panel, #fff); border: 2px solid var(--theme-color-brand-primary, #2988df); color: var(--theme-color-brand-primary, #2988df); font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; }
			.ps-story-card { flex: 1 1 auto; min-width: 0; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 8px; padding: 10px 14px; }
			.ps-story-card-head { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
			.ps-story-title { font-size: 14px; font-weight: 600; cursor: pointer; }
			.ps-story-kind { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; padding: 1px 7px; border-radius: 999px; background: var(--theme-color-background-secondary, #f1f3f7); color: var(--theme-color-text-secondary, #5b6376); white-space: nowrap; }
			.ps-story-detail { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
			.ps-story-kind-feedback .ps-story-dot { border-color: #16a085; color: #16a085; }
			.ps-story-kind-prompt .ps-story-dot { border-color: #8e6fd8; color: #8e6fd8; }
			.ps-story-kind-run .ps-story-dot { border-color: #d9923c; color: #d9923c; }
			.ps-story-kind-validated .ps-story-dot { border-color: #27ae60; color: #27ae60; }
			.ps-story-kind-asbuilt .ps-story-dot { border-color: #2988df; color: #2988df; }
			.ps-story-meta { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; margin-top: 3px; font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
			.ps-story-model { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 11px; padding: 1px 6px; border-radius: 4px; background: var(--theme-color-background-secondary, #f1f3f7); }
			.ps-story-stats { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 7px; }
			.ps-story-stat { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); background: var(--theme-color-background-secondary, #f1f3f7); padding: 2px 8px; border-radius: 999px; }
			.ps-story-outcome { margin-left: auto; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; padding: 2px 9px; border-radius: 999px; border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6376); }
			.ps-story-outcome-delivered { border-color: var(--theme-color-status-success, #27ae60); color: var(--theme-color-status-success, #27ae60); }
			.ps-story-outcome-partial { border-color: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-brand-primary, #2988df); }
			.ps-story-outcome-abandoned { border-color: var(--theme-color-status-danger, #c0392b); color: var(--theme-color-status-danger, #c0392b); }
			.ps-story-empty { color: var(--theme-color-text-secondary, #5b6376); font-style: italic; font-size: 13px; }
	` + libShareUI.SHARE_CSS,
	Templates:
	[
		{
			Hash: 'EntityDetail-Display',
			Template: /*html*/`
<div class="ps-page ps-page-narrow ps-detail">
	<div class="ps-detail-head">
		<button class="ps-detail-back" onclick="_Pict.views['Plansheet-EntityDetail'].back()">← {~D:AppData.EntityDetail.BackLabel~}</button>
		<h1 class="ps-detail-title">{~D:AppData.EntityDetail.HeaderTitle~}{~TS:Detail-AddressedBadge:AppData.EntityDetail.AddressedBadge~}</h1>
		<div class="ps-detail-actions">
			{~TS:Detail-AddressToggle:AppData.EntityDetail.AddressToggle~}
			{~TS:Detail-HeaderAction:AppData.EntityDetail.HeaderActions~}
			{~TS:Detail-Edit:AppData.EntityDetail.EditSlot~}
			{~TS:Detail-Delete:AppData.EntityDetail.DeleteSlot~}
		</div>
	</div>
	<div class="ps-detail-sub">{~D:AppData.EntityDetail.Subtitle~}</div>
	{~TS:Detail-NotFound:AppData.EntityDetail.NotFoundSlot~}
	{~TS:Detail-Craft:AppData.EntityDetail.CraftSlot~}
	{~TS:Detail-Blueprint:AppData.EntityDetail.BlueprintSlot~}
	{~TS:Detail-Board:AppData.EntityDetail.BoardSlot~}
	{~TS:Detail-VisionLoops:AppData.EntityDetail.LoopsSlot~}
	<div class="ps-detail-fields">{~TS:Detail-Field:AppData.EntityDetail.Fields~}</div>
	{~TS:Detail-CoreDoc:AppData.EntityDetail.CoreDocSlot~}
	{~TS:Detail-Steps:AppData.EntityDetail.StepsSlot~}
	{~TS:Detail-Connections:AppData.EntityDetail.ConnectionsSlot~}
	{~TS:Detail-WorkItemPrompts:AppData.EntityDetail.WorkItemPromptsSlot~}
	{~TS:Detail-Story:AppData.EntityDetail.StorySlot~}
	{~TS:Detail-ReviewHistory:AppData.EntityDetail.ReviewHistorySlot~}
	{~TS:Detail-Section:AppData.EntityDetail.Sections~}
	{~TS:Detail-Prompts:AppData.EntityDetail.PromptsSlot~}
	{~TS:Detail-Checklists:AppData.EntityDetail.ChecklistsSlot~}
	{~TS:Detail-Comments:AppData.EntityDetail.CommentsSlot~}
</div>`
		},
		// The header Edit button, as a slot so the not-found state can drop it (an empty .ps-detail-actions
		// then collapses via CSS, hiding the whole action bar). See WI #329.
		{ Hash: 'Detail-Edit', Template: /*html*/`<button class="ps-btn" onclick="_Pict.views['Plansheet-EntityDetail'].edit()">Edit</button>` },

		// The not-found message, shown in place of the field table when the record is not in this tenant.
		{ Hash: 'Detail-NotFound', Template: /*html*/`<div class="ps-detail-notfound">{~D:Record.Message~}</div>` },
		{
			Hash: 'Detail-Board',
			Template: /*html*/`
<div class="ps-detail-board-wrap">
	<div class="ps-detail-board-head">
		<h4 class="ps-detail-board-h">{~D:Record.Label~}</h4>
		<div class="ps-board-tabs">{~TS:Detail-Board-Pill:Record.Boards~}{~TS:Detail-Board-New:Record.AddSlot~}{~TS:Detail-Board-Photo:Record.AddSlot~}{~TS:Detail-Board-Attach:Record.AddSlot~}</div>
		{~TS:Detail-Board-EditToggle:Record.EditSlot~}
		{~TS:Detail-Board-Menu:Record.MenuSlot~}
	</div>
	{~TS:Detail-Board-Empty:Record.EmptySlot~}
	<input type="file" id="Entity-Board-PhotoInput" accept="image/*" style="display:none;" onchange="_Pict.views['Plansheet-EntityDetail'].onBoardPhotoPicked(this)">
	<div class="ps-detail-board" id="{~D:Record.ContainerID~}"></div>
</div>`
		},
		{ Hash: 'Detail-Board-Pill', Template: /*html*/`<button class="ps-board-tab {~D:Record.ActiveClass~}" onclick="_Pict.views['Plansheet-EntityDetail'].selectBoard({~D:Record.ID~})">{~D:Record.Name~}</button>` },
		{ Hash: 'Detail-Board-New', Template: /*html*/`<button class="ps-board-tab ps-board-tab-new" onclick="_Pict.views['Plansheet-EntityDetail'].newBoard()">+ New</button>` },
		{ Hash: 'Detail-Board-Photo', Template: /*html*/`<button class="ps-board-tab ps-board-tab-new" onclick="_Pict.views['Plansheet-EntityDetail'].pickBoardPhoto()">+ Photo</button>` },
		{ Hash: 'Detail-Board-Attach', Template: /*html*/`<button class="ps-board-tab ps-board-tab-new" title="Attach an existing whiteboard to this item" onclick="_Pict.views['Plansheet-EntityDetail'].attachExistingBoard(this)">+ Attach</button>` },
		{ Hash: 'Detail-Board-Empty', Template: /*html*/`<div class="ps-board-empty">No whiteboards here yet.</div>` },
		{
			Hash: 'Detail-Board-EditToggle',
			Template: /*html*/`<button class="ps-btn ps-board-edit-toggle" id="Vision-Board-Edit-Toggle" onclick="_Pict.views['Plansheet-EntityDetail'].toggleVisionBoardEdit()">Edit board</button>`
		},
		{
			Hash: 'Detail-Board-Menu',
			Template: /*html*/`<button class="ps-btn ps-board-menu-btn" id="Vision-Board-Menu-Btn" title="Manage this whiteboard (rename, disconnect, delete)" onclick="_Pict.views['Plansheet-EntityDetail'].boardMenu(this)">&#8942;</button>`
		},
		{
			Hash: 'Detail-Comments',
			Template: /*html*/`
<div class="ps-detail-comments-wrap">
	<h4 class="ps-detail-comments-h">{~D:Record.Label~}</h4>
	<div class="ps-detail-comments" id="{~D:Record.ContainerID~}"></div>
</div>`
		},
		{
			Hash: 'Detail-Checklists',
			Template: /*html*/`<div class="ps-detail-checklists-wrap"><div id="{~D:Record.ContainerID~}"></div></div>`
		},
		{
			Hash: 'Detail-VisionLoops',
			Template: /*html*/`<div class="ps-detail-loops-wrap" style="margin:18px 0;"><h4 style="font-size:14px;font-weight:700;color:var(--theme-color-text-primary,#2c3140);margin:0 0 10px;">{~D:Record.Label~}</h4><div id="{~D:Record.ContainerID~}"></div></div>`
		},
		{
			Hash: 'Detail-Blueprint',
			Template: /*html*/`<div class="ps-detail-blueprint" id="{~D:Record.ContainerID~}"></div>`
		},
		{
			Hash: 'Detail-Connections',
			Template: /*html*/`<div class="ps-detail-connections" id="{~D:Record.ContainerID~}" style="margin:18px 0;"></div>`
		},
		{
			Hash: 'Detail-Story',
			Template: /*html*/`
<div class="ps-story">
	<div class="ps-story-head">
		<h4 class="ps-story-h">{~D:Record.Label~}</h4>
		<span class="ps-story-count">{~D:Record.CountLabel~}</span>
	</div>
	<ol class="ps-story-line">{~TS:Detail-Story-Item:Record.Items~}</ol>
	{~TS:Detail-Story-Empty:Record.EmptySlot~}
</div>`
		},
		{
			Hash: 'Detail-Story-Item',
			Template: /*html*/`
<li class="ps-story-node {~D:Record.KindClass~}">
	<span class="ps-story-dot">{~D:Record.Num~}</span>
	<div class="ps-story-card">
		<div class="ps-story-card-head">
			<span class="ps-story-kind">{~D:Record.KindLabel~}</span>
			{~TS:Detail-Story-TitleLink:Record.LinkSlot~}{~TS:Detail-Story-TitlePlain:Record.PlainSlot~}
			<span class="ps-story-outcome {~D:Record.OutcomeClass~}">{~D:Record.OutcomeLabel~}</span>
		</div>
		<div class="ps-story-meta">
			<span class="ps-story-when">{~D:Record.When~}</span>
			{~TS:Detail-Story-Model:Record.ModelSlot~}
			{~TS:Detail-Story-Detail:Record.DetailSlot~}
		</div>
		<div class="ps-story-stats">{~TS:Detail-Story-Stat:Record.Stats~}</div>
	</div>
</li>`
		},
		{ Hash: 'Detail-Story-TitleLink', Template: /*html*/`<a class="ps-link ps-story-title" onclick="_Pict.views['Plansheet-EntityDetail'].openSession({~D:Record.ID~})">{~D:Record.Title~}</a>` },
		{ Hash: 'Detail-Story-TitlePlain', Template: /*html*/`<span class="ps-story-title">{~D:Record.Title~}</span>` },
		{ Hash: 'Detail-Story-Detail', Template: /*html*/`<span class="ps-story-detail">{~D:Record.Detail~}</span>` },
		{ Hash: 'Detail-Story-Model', Template: /*html*/`<span class="ps-story-model">{~D:Record.Model~}</span>` },
		{ Hash: 'Detail-Story-Stat', Template: /*html*/`<span class="ps-story-stat">{~D:Record.Text~}</span>` },
		{ Hash: 'Detail-Story-Empty', Template: /*html*/`<div class="ps-story-empty">No activity yet. As feedback, prompts, runs, and sessions land on this work item, they show here.</div>` },
		{
			Hash: 'Detail-ReviewHistory',
			Template: /*html*/`
<div class="ps-story ps-review">
	<div class="ps-story-head">
		<h4 class="ps-story-h">{~D:Record.Label~}</h4>
		<span class="ps-review-summary {~D:Record.SummaryClass~}">{~D:Record.Summary~}</span>
	</div>
	<ol class="ps-story-line">{~TS:Detail-ReviewHistory-Item:Record.Items~}</ol>
	{~TS:Detail-ReviewHistory-Empty:Record.EmptySlot~}
</div>`
		},
		{
			Hash: 'Detail-ReviewHistory-Item',
			Template: /*html*/`
<li class="ps-story-node">
	<span class="ps-story-dot ps-review-dot">{~D:Record.Num~}</span>
	<div class="ps-story-card">
		<div class="ps-story-card-head">
			<span class="ps-review-reason">Did not pass QC &mdash; {~D:Record.Reason~}</span>
			{~TS:Detail-ReviewHistory-Issues:Record.IssuesSlot~}
		</div>
		<div class="ps-story-meta"><span class="ps-story-when">{~D:Record.When~}</span></div>
		{~TS:Detail-ReviewHistory-Note:Record.NoteSlot~}
	</div>
</li>`
		},
		{ Hash: 'Detail-ReviewHistory-Note', Template: /*html*/`<div class="ps-review-note">{~D:Record.Note~}</div>` },
		{ Hash: 'Detail-ReviewHistory-Issues', Template: /*html*/`<span class="ps-story-outcome ps-review-issues">{~D:Record.Label~}</span>` },
		{ Hash: 'Detail-ReviewHistory-Empty', Template: /*html*/`<div class="ps-story-empty">No QC failures. When a reviewer sends this back, the reason shows here.</div>` },
		{
			Hash: 'Detail-Craft',
			Template: /*html*/`<div class="ps-detail-craft"><span class="ps-detail-craft-label">Craft</span>{~TS:Detail-Craft-Edit:Record.EditSlot~}{~TS:Detail-Craft-Read:Record.ReadSlot~}</div>`
		},
		{ Hash: 'Detail-Craft-Edit', Template: /*html*/`<select class="ps-input ps-input-sm" onchange="_Pict.views['Plansheet-EntityDetail'].setCraft(this.value)">{~TS:Detail-CraftOpt:Record.Options~}</select>` },
		{ Hash: 'Detail-Craft-Read', Template: /*html*/`<span class="ps-detail-craft-current">{~D:Record.Name~}</span>` },
		{ Hash: 'Detail-CraftOpt', Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>` },
		{
			Hash: 'Detail-WorkItemPrompts',
			Template: /*html*/`
<div class="ps-detail-comments-wrap">
	<h4 class="ps-detail-comments-h">{~D:Record.Label~}</h4>
	<div id="{~D:Record.ContainerID~}"></div>
</div>`
		},
		{
			Hash: 'Detail-Prompts',
			Template: /*html*/`
<div class="ps-detail-comments-wrap">
	<h4 class="ps-detail-comments-h">{~D:Record.Label~}</h4>
	<div id="{~D:Record.ContainerID~}"></div>
</div>`
		},
		{ Hash: 'Detail-Field', Template: /*html*/`<div class="ps-detail-fcell {~D:Record.WideClass~}"><div class="ps-detail-flabel">{~D:Record.L~}</div><div class="ps-detail-fval">{~D:Record.Value~}{~TS:Detail-FieldMD:Record.MDSlot~}</div></div>` },
		{ Hash: 'Detail-FieldMD', Template: /*html*/`<div class="ps-detail-fmd" id="{~D:Record.ContainerID~}"></div>` },
		{ Hash: 'Detail-HeaderAction', Template: /*html*/`<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].headerAction('{~D:Record.Method~}')">{~D:Record.Label~}</button>` },
		{ Hash: 'Detail-AddressToggle', Template: /*html*/`<button class="ps-btn" onclick="_Pict.views['Plansheet-EntityDetail'].toggleAddressed()">{~D:Record.Label~}</button>` },
		{ Hash: 'Detail-Delete', Template: /*html*/`<button class="ps-btn ps-btn-danger" onclick="_Pict.views['Plansheet-EntityDetail'].deleteRecord()">Delete</button>` },
		{ Hash: 'Detail-AddressedBadge', Template: /*html*/`<span class="ps-addressed-badge">{~D:Record.Label~}</span>` },
		{
			Hash: 'Detail-Steps',
			Template: /*html*/`
<div class="ps-detail-steps-wrap">
	<h4 class="ps-detail-board-h">{~D:Record.Label~}</h4>
	<div id="{~D:Record.ContainerID~}"></div>
</div>`
		},
		{
			Hash: 'Detail-Section',
			Template: /*html*/`
<div class="ps-rel">
	<h4>{~D:Record.Label~}</h4>
	{~TS:Detail-SubVisions:Record.SubVisionSlot~}
	{~TS:Detail-Fk:Record.FkSlot~}
	{~TS:Detail-Link:Record.LinkSlot~}
	{~TS:Detail-Inverse:Record.InverseSlot~}
	{~TS:Detail-Target:Record.TargetSlot~}
	{~TS:Detail-Sessions:Record.SessionsSlot~}
	{~TS:Detail-Media:Record.MediaSlot~}
	{~TS:Detail-Docs:Record.DocsSlot~}
	{~TS:Detail-DocLink:Record.DocLinkSlot~}
</div>`
		},
		// A host div, not a <select> -- _mountRelationPickers() mounts a server-backed candidate search
		// picker into it after render (WI #446).
		{ Hash: 'Detail-Fk', Template: /*html*/`<div class="ps-input-picker" id="{~D:Record.ContainerID~}"></div>` },
		{
			Hash: 'Detail-Link',
			Template: /*html*/`
<div class="ps-rel-items">{~TS:Detail-LinkItem:Record.Items~}{~TS:Detail-LinkEmpty:Record.EmptySlot~}</div>
{~TS:Detail-LinkAdd:Record.AddSlot~}`
		},
		{ Hash: 'Detail-LinkItem', Template: /*html*/`<span class="ps-chip"><a class="ps-link" onclick="_Pict.views['Plansheet-EntityDetail'].openTarget('{~D:Record.TargetKey~}',{~D:Record.TargetID~})">{~D:Record.Label~}</a><span class="ps-chip-rel">{~D:Record.RelType~}</span><button class="ps-chip-x" title="Unlink" onclick="_Pict.views['Plansheet-EntityDetail'].removeLink({~D:Record.Idx~},{~D:Record.JoinID~})">×</button></span>` },
		{ Hash: 'Detail-LinkEmpty', Template: /*html*/`<span class="ps-rel-empty">None linked yet.</span>` },
		{
			Hash: 'Detail-LinkAdd',
			Template: /*html*/`
<div class="ps-rel-add">
	<div class="ps-input-picker ps-rel-picker" id="{~D:Record.ContainerID~}"></div>
	{~TS:Detail-RelType:Record.RelTypeSlot~}
	<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].addLink({~D:Record.Idx~})">+ Link</button>
</div>`
		},
		{ Hash: 'Detail-Opt2', Template: /*html*/`<option value="{~D:Record.Value~}">{~D:Record.Label~}</option>` },
		{ Hash: 'Detail-RelType', Template: /*html*/`<select class="ps-input" onchange="_Pict.views['Plansheet-EntityDetail'].setPendingRelType({~D:Record.Idx~}, this.value)">{~TS:Detail-RelTypeOpt:Record.Options~}</select>` },
		{ Hash: 'Detail-RelTypeOpt', Template: /*html*/`<option value="{~D:Record.Value~}">{~D:Record.Value~}</option>` },
		{
			Hash: 'Detail-Inverse',
			Template: /*html*/`<div class="ps-rel-items">{~TS:Detail-InvItem:Record.Items~}{~TS:Detail-InvEmpty:Record.EmptySlot~}</div>{~TS:Detail-InvCreate:Record.CreateSlot~}`
		},
		{ Hash: 'Detail-InvCreate', Template: /*html*/`<div class="ps-rel-add"><button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].createFromRelation({~D:Record.Idx~})">+ {~D:Record.Label~}</button></div>` },
		{ Hash: 'Detail-InvItem', Template: /*html*/`<span class="ps-chip"><a class="ps-link" onclick="_Pict.views['Plansheet-EntityDetail'].openTarget('{~D:Record.TargetKey~}',{~D:Record.TargetID~})">{~D:Record.Label~}</a><span class="ps-chip-sub">{~D:Record.Sub~}</span></span>` },
		{ Hash: 'Detail-InvEmpty', Template: /*html*/`<span class="ps-rel-empty">None yet.</span>` },
		{
			Hash: 'Detail-Target',
			Template: /*html*/`
<div class="ps-rel-target">
	<select class="ps-input" onchange="_Pict.views['Plansheet-EntityDetail'].setTargetType(this.value)">{~TS:Detail-TargetTypeOpt:Record.TypeOptions~}</select>
	{~TS:Detail-TargetEntity:Record.EntitySlot~}
</div>`
		},
		{ Hash: 'Detail-TargetTypeOpt', Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Value~}</option>` },
		// A host div, not a <select> -- see Detail-Fk above.
		{ Hash: 'Detail-TargetEntity', Template: /*html*/`<div class="ps-input-picker ps-rel-picker" id="{~D:Record.ContainerID~}"></div>` },
		{
			Hash: 'Detail-Sessions',
			Template: /*html*/`
<div class="ps-rel-items">{~TS:Detail-SessionItem:Record.Items~}{~TS:Detail-LinkEmpty:Record.EmptySlot~}</div>
{~TS:Detail-SessionAdd:Record.AddSlot~}`
		},
		{ Hash: 'Detail-SessionItem', Template: /*html*/`<span class="ps-chip"><span class="ps-chip-title">{~D:Record.Title~}</span><select class="ps-input ps-input-sm" title="Outcome" onchange="_Pict.views['Plansheet-EntityDetail'].setSessionOutcome({~D:Record.ID~}, this.value)">{~TS:Detail-TargetTypeOpt:Record.OutcomeOptions~}</select><button class="ps-chip-x" title="Unlink" onclick="_Pict.views['Plansheet-EntityDetail'].unlinkSession('{~D:Record.Field~}',{~D:Record.ID~})">×</button></span>` },
		{
			Hash: 'Detail-SessionAdd',
			Template: /*html*/`<div class="ps-rel-add"><select class="ps-input" onchange="_Pict.views['Plansheet-EntityDetail'].setPendingSession({~D:Record.Idx~}, this.value)">{~TS:Detail-Opt2:Record.Options~}</select><button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].linkSession({~D:Record.Idx~})">+ Link session</button></div>`
		},
		{
			Hash: 'Detail-Docs',
			Template: /*html*/`
<div class="ps-rel-items">{~TS:Detail-DocItem:Record.Items~}{~TS:Detail-DocEmpty:Record.EmptySlot~}</div>
<div class="ps-rel-add"><button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].newDoc()">+ New document</button></div>`
		},
		{ Hash: 'Detail-DocItem', Template: /*html*/`<span class="ps-chip"><a class="ps-link" onclick="_Pict.views['Plansheet-EntityDetail'].openDoc('{~D:Record.Path~}')">{~D:Record.Title~}</a><button class="ps-chip-x" title="Delete" onclick="_Pict.views['Plansheet-EntityDetail'].removeDoc({~D:Record.JoinID~},'{~D:Record.Path~}')">×</button></span>` },
		{ Hash: 'Detail-DocEmpty', Template: /*html*/`<span class="ps-rel-empty">No documents yet.</span>` },
		{
			Hash: 'Detail-CoreDoc',
			Template: /*html*/`
<div class="ps-detail-loops-wrap" style="margin:18px 0;">
	<h4 style="font-size:14px;font-weight:700;color:var(--theme-color-text-primary,#2c3140);margin:0 0 10px;">{~D:Record.Label~}</h4>
	<div class="ps-coredoc">{~TS:Detail-CoreDocBody:Record.HasBody~}{~TS:Detail-CoreDocEmpty:Record.EmptySlot~}
		<div class="ps-rel-add"><button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].openCoreDoc()">Edit vision document</button></div>
	</div>
</div>`
		},
		{ Hash: 'Detail-CoreDocBody', Template: /*html*/`<div class="ps-coredoc-body" id="EntityDetail-CoreDoc"></div>` },
		{ Hash: 'Detail-CoreDocEmpty', Template: /*html*/`<div class="ps-coredoc-empty">No core document yet — open the editor to start. Drop in prose, images, diagrams, KaTeX, and Excalidraw drawings.</div>` },
		{
			Hash: 'Detail-SubVisions',
			Template: /*html*/`
<div class="ps-subvision">
	<div class="ps-subv-grid">{~TS:Detail-SubVisionCard:Record.Children~}{~TS:Detail-SubVisionEmpty:Record.ChildEmpty~}</div>
	{~TS:Detail-SubVisionParents:Record.ParentSlot~}
	<div class="ps-rel-add">
		<input class="ps-input" type="text" placeholder="New sub-vision name…" onkeydown="if(event.key==='Enter'){event.preventDefault();_Pict.views['Plansheet-EntityDetail'].createSubVision({~D:Record.Idx~});}" oninput="_Pict.views['Plansheet-EntityDetail'].setPendingSubName({~D:Record.Idx~}, this.value)">
		<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].createSubVision({~D:Record.Idx~})">+ Create sub-vision</button>
	</div>
	{~TS:Detail-SubVisionLink:Record.AddSlot~}
</div>`
		},
		{ Hash: 'Detail-SubVisionCard', Template: /*html*/`<div class="ps-subv-card" onclick="_Pict.views['Plansheet-EntityDetail'].openTarget('Vision',{~D:Record.TargetID~})"><div class="ps-subv-card-head"><span class="ps-subv-num">#{~D:Record.Number~}</span><button class="ps-chip-x" title="Remove part" onclick="event.stopPropagation();_Pict.views['Plansheet-EntityDetail'].removeSubVision({~D:Record.Idx~},{~D:Record.JoinID~})">×</button></div><div class="ps-subv-name">{~D:Record.Name~}</div><div class="ps-subv-sub">{~D:Record.Status~}</div></div>` },
		{ Hash: 'Detail-SubVisionEmpty', Template: /*html*/`<span class="ps-rel-empty">No parts yet — decompose this vision into smaller, aligned sub-visions.</span>` },
		{ Hash: 'Detail-SubVisionParents', Template: /*html*/`<div class="ps-subv-partof"><span class="ps-subv-partof-label">Part of:</span>{~TS:Detail-SubVisionParentChip:Record.Items~}</div>` },
		{ Hash: 'Detail-SubVisionParentChip', Template: /*html*/`<span class="ps-chip"><a class="ps-link" onclick="_Pict.views['Plansheet-EntityDetail'].openTarget('Vision',{~D:Record.TargetID~})">#{~D:Record.Number~} {~D:Record.Name~}</a></span>` },
		// A host div, not a <select> -- see Detail-Fk above.
		{ Hash: 'Detail-SubVisionLink', Template: /*html*/`<div class="ps-rel-add"><div class="ps-input-picker ps-rel-picker" id="{~D:Record.ContainerID~}"></div><button class="ps-btn" onclick="_Pict.views['Plansheet-EntityDetail'].addSubVision({~D:Record.Idx~})">+ Add existing as part</button></div>` },
		{
			Hash: 'Detail-Media',
			Template: /*html*/`
<div class="ps-media-grid">{~TS:Detail-MediaItem:Record.Items~}{~TS:Detail-MediaEmpty:Record.EmptySlot~}</div>
<div class="ps-rel-add"><label class="ps-btn ps-btn-primary ps-file-btn">+ Upload<input type="file" style="display:none" onchange="_Pict.views['Plansheet-EntityDetail'].uploadMedia({~D:Record.Idx~}, this.files[0])"></label></div>`
		},
		{ Hash: 'Detail-MediaItem', Template: /*html*/`<div class="ps-media-item">{~TS:Detail-MediaImage:Record.ImageSlot~}{~TS:Detail-MediaVideo:Record.VideoSlot~}{~TS:Detail-MediaFile:Record.FileSlot~}<button class="ps-chip-x ps-media-x" title="Remove" onclick="_Pict.views['Plansheet-EntityDetail'].removeMedia({~D:Record.ID~})">×</button></div>` },
		{ Hash: 'Detail-MediaImage', Template: /*html*/`<img class="ps-media-thumb ps-media-view" src="{~D:Record.URL~}" alt="{~D:Record.Title~}" title="Click to view - {~D:Record.Title~}" data-url="{~D:Record.URL~}" data-title="{~D:Record.Title~}" style="cursor:zoom-in;" onclick="_Pict.PictApplication.viewImage(this.dataset.url, this.dataset.title)">` },
		{ Hash: 'Detail-MediaVideo', Template: /*html*/`<video class="ps-media-video" controls preload="metadata" src="{~D:Record.URL~}" title="{~D:Record.Title~}"></video>` },
		{ Hash: 'Detail-MediaFile', Template: /*html*/`<a class="ps-link ps-media-file" href="{~D:Record.URL~}" target="_blank" rel="noopener"><span class="ps-media-file-type">{~D:Record.Type~}</span>{~D:Record.Title~}</a>` },
		{ Hash: 'Detail-MediaEmpty', Template: /*html*/`<span class="ps-rel-empty">No media yet.</span>` },
		{
			Hash: 'Detail-DocLink',
			Template: /*html*/`
<div class="ps-rel-items">{~TS:Detail-DocLinkItem:Record.Items~}{~TS:Detail-DocLinkEmpty:Record.EmptySlot~}</div>
{~TS:Detail-DocLinkAdd:Record.AddSlot~}`
		},
		{ Hash: 'Detail-DocLinkItem', Template: /*html*/`<span class="ps-chip"><a class="ps-link" onclick="_Pict.views['Plansheet-EntityDetail'].openFoundationDoc('{~D:Record.Path~}')">{~D:Record.Title~}</a><button class="ps-chip-x" title="Unlink" onclick="_Pict.views['Plansheet-EntityDetail'].removeDocLink({~D:Record.Idx~},{~D:Record.JoinID~})">×</button></span>` },
		{ Hash: 'Detail-DocLinkEmpty', Template: /*html*/`<span class="ps-rel-empty">No documentation linked yet.</span>` },
		{
			Hash: 'Detail-DocLinkAdd',
			Template: /*html*/`<div class="ps-rel-add"><select class="ps-input" onchange="_Pict.views['Plansheet-EntityDetail'].setPendingDocLink({~D:Record.Idx~}, this.value)">{~TS:Detail-Opt2:Record.Options~}</select><button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityDetail'].addDocLink({~D:Record.Idx~})">+ Link doc</button></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'EntityDetail-Display',
			TemplateHash: 'EntityDetail-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../BlueprintShareUI.js":553,"../CandidateSearch.js":554,"../EntityDescriptors.js":555,"../FocusFilters.js":558,"../PromptEmbed.js":569,"../libLabels.js":575,"../providers/FrameworkClient.js":576,"./MarkdownRender.js":649,"pict-view":365}],669:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libDescriptors = require('../EntityDescriptors.js');
const libLabels = require('../libLabels.js');
const libFocus = require('../FocusFilters.js');
// The translator from filter state + sort into a query the SERVER answers (WI #433). The list used to
// fetch 250 rows and sort and filter that array here, which is why sorting 1,075 blueprints descending
// by mark put 250 at the top: 250 was the largest thing this view had ever been handed.
const libFocusQuery = require('../FocusQuery.js');
// The mark is formed in exactly one place, and this is a consumer of it, not a second copy of the
// prefix and padding rules. Required directly rather than through the Markup provider because the
// stamping below runs over raw rows, and EntityMark is deliberately dependency-free.
const libEntityMark = require('../EntityMark.js');
// The mark's rendering, shared with the board and the tooltip. The list takes only the designator
// out of it: a row already rules its own columns, so it wants the mark, not the title block.
const libMarkup = require('./Markup-Templates.js');

// How long the search box waits after the last keystroke before asking the server (WI #433). Long
// enough that typing a word is one request rather than five, short enough not to feel like a lag.
const _SEARCH_DEBOUNCE_MS = 300;

/**
 * EntityList — one generic CRUD surface for every SDLC entity. showEntity(key)
 * points it at a descriptor (Vision/Module/Feature/WorkItem); it renders a
 * table in "list" mode and an inline create/edit form in "form" mode. Form
 * inputs write straight into AppData.EntityList.FormValues via their oninput
 * handlers, so there are no DOM reads — save() just posts FormValues.
 *
 * A descriptor carrying a Filter config (WorkItem) also gets a focus-view filter
 * bar: facets (Status/Type/Priority/Assignee/Target), a text search, a recent-
 * activity window, and a saved-view picker (shipped role presets + the user's own
 * named views). The active filter lives in the URL (see FocusFilters), so a
 * narrowed list is shareable and survives reload.
 */
class PictViewEntityList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.EntityList = this.pict.AppData.EntityList ||
			{
				Key: '', Title: '', HeaderCells: [], Rows: [],
				Mode: 'list', ListModeSlot: [{}], CreateButtonSlot: [], TableSlot: [], PageFootSlot: [], EmptySlot: [{}], FormSlot: [],
				// concise (the scan) or table (the full intersection); see _viewMode. TableClass
				// tightens the rows in concise, PinSlot is the concise column strip.
				ViewMode: 'concise', ViewModeSlot: [], PinSlot: [], TableClass: '',
				FormTitle: '', FormFields: [], FormValues: {}, EditingID: null, EmptyLabel: '',
				EmptyText: '', HiddenValues: {}, FormClass: '',
				// The root page-width class. List mode bleeds to fill the workspace: a wide, multi-column
				// table has no business trapped in a centered reading column -- the surplus width becomes a
				// growing left gap while the right columns clip/scroll off the edge. Form mode swaps back to
				// the centered .ps-page column (a create/edit form is reading-width). See _showList/_enterForm.
				PageClass: 'ps-page-bleed',
				// IDMedia of images uploaded from the create form before the record had an
				// id (owned by 0); save() re-owns them to the new id, abandon deletes them.
				PendingMedia: [],
				ErrorSlot: [],
				// Focus-view filtering: the live filter state, the built filter-bar model, the
				// single-element slot that renders it, and the "showing N of M" hint.
				Filter: libFocus.emptyState(), FilterBar: {}, FilterBarSlot: [], FilterCount: '',
				// The "Columns" show/hide picker (single-element slot; empty when there is no table).
				ColumnsSlot: [],
				// Paging (WI #433). Page is 1-based and is the page the store's rows came from, never
				// something derived from how many rows are loaded. ServerPaged says whether those rows
				// are one page of the server's answer (so the footer offers pages and _rows must not
				// re-sort them) or the whole set fetched for local filtering; Unexpressed says why,
				// naming each facet the query language could not carry.
				Page: 1, ServerPaged: false, Unexpressed: [],
				// The empty state's "clear the filters" affordance: an empty FILTERED list is a
				// different thing from an empty entity, and only one of them has a way out.
				EmptyFilteredSlot: []
			};
		// The descriptor field (if any) flagged Markdown:true gets the rich
		// pict-section-markdowneditor mounted in place of a plain textarea.
		this._markdownField = '';
		// The single field declared T:'code' on this descriptor, if any (WI #456).
		this._codeField = '';
		// IDUser -> roster row ({ DisplayName, IsAgent, ... }), for the assignee facet + column.
		this._rosterIndex = {};
		// TargetType -> { <id>: entity row } from the Vision/Module/Feature caches (the
		// Target column), and IDWorkItem -> linked-session count (the Sessions column).
		// Both prefetched by showEntity only when the descriptor carries such a column.
		this._targetIndex = { Vision: {}, Module: {}, Feature: {} };
		this._sessionCountIndex = {};
		// A small, deterministic palette for human avatars (the AI-agent violet is reserved,
		// so it is not in here); a name hashes to one of these.
		this._avatarPalette = ['#2988df', '#3fae6b', '#d99366', '#4aa3a3', '#c06fbb', '#5a7fce', '#c9922f', '#c0555b'];
		// The keystone customers, for Feedback's customer facet options.
		this._customerList = [];
		// Entity key -> the focus-bar config derived from a descriptor that declares none. Cached
		// because _filterConfig is called several times a render and the answer cannot change.
		this._derivedFilters = {};
		// The search box debounce timer, and the one-at-a-time list fetch (see _fetchPage). Both exist
		// because a search is now a request rather than a pass over an array already in memory.
		this._searchTimer = null;
		this._fetchInFlight = null;
		this._fetchQueued = null;
	}

	// Whether the active descriptor has at least one column carrying a given marker
	// (Assignee / Target / Sessions), so showEntity only prefetches what a list needs.
	_hasColumn(pMarker)
	{
		let tmpDescriptor = this._descriptor();
		return !!(tmpDescriptor && (tmpDescriptor.Columns || []).some((pColumn) => pColumn[pMarker]));
	}

	_descriptor() { return libDescriptors.Entities[this.pict.AppData.EntityList.Key] || null; }
	_provider()
	{
		let tmpKey = this.pict.AppData.EntityList.Key;
		return this.pict.providers[tmpKey + 'API'] || null;
	}

	// ── list preferences: how this person looks at this list ──────────────────
	// One record per user per entity, holding everything about the way a list is being read:
	//   { viewMode, columns: { table: { <F>: bool }, concise: { <F>: bool } }, sort, state }
	// where state is the full focus state (filters + search + sort). Filters used to live only in
	// the URL, which meant navigating away and back silently threw them away along with the sort;
	// the whole point of keeping them here is that a list stays how you left it.
	_listPrefs()
	{
		let tmpDescriptor = this._descriptor();
		return libFocus.loadListPrefs(tmpDescriptor ? tmpDescriptor.Key : '', this._currentUserID());
	}

	// Which of the two readings of this list is on screen.
	//   concise  the scan: the mark, the title, and the descriptor's Key columns. Tight rows,
	//            glyph columns stay glyphs, and nothing is wide enough to scroll sideways.
	//   table    the full intersection: every column not marked DefaultHidden, glyphs with their
	//            words, room to compare.
	// Reads a legacy 'density' pref so an existing user lands where they left off: the old
	// expanded/compact toggle only decided whether a glyph column printed its word, which is
	// now part of the mode rather than an axis of its own.
	_viewMode()
	{
		let tmpPrefs = this._listPrefs();
		if (tmpPrefs && tmpPrefs.viewMode) { return (tmpPrefs.viewMode === 'table') ? 'table' : 'concise'; }
		return (tmpPrefs && tmpPrefs.density === 'expanded') ? 'table' : 'concise';
	}

	// The per-mode column visibility map out of the prefs. Prefs written before the modes existed
	// carried one flat { <F>: bool } map, which was the table-mode set, so it is read as that
	// rather than being dropped on the floor.
	_columnPrefs(pPrefs, pMode)
	{
		let tmpColumns = (pPrefs && pPrefs.columns) || {};
		if (tmpColumns.table || tmpColumns.concise) { return tmpColumns[pMode] || {}; }
		return (pMode === 'table') ? tmpColumns : {};
	}

	// The focus-bar config for a list. Three lists (WorkItem, Vision, Feedback) declare one by hand
	// because their facets are particular; the other fifteen used to get nothing at all, not even a
	// search box, which is how a 20-row Features list ended up with no way to narrow it. So a
	// descriptor that declares no Filter gets one derived from its own Fields instead: text search
	// always, plus whichever of Status / Type / Priority it actually has as a select.
	//
	// Those three facets are exactly the ones FocusFilters.filterRows already knows how to apply, so
	// this widens the reach of the bar without inventing a new filter primitive. Filter: false opts
	// a list out entirely.
	_filterConfig(pDescriptor)
	{
		if (!pDescriptor || !pDescriptor.Columns || !pDescriptor.Columns.length) { return null; }
		if (pDescriptor.Filter === false) { return null; }
		if (pDescriptor.Filter) { return pDescriptor.Filter; }
		if (this._derivedFilters[pDescriptor.Key]) { return this._derivedFilters[pDescriptor.Key]; }
		let tmpFacets = ['Status', 'Type', 'Priority'].filter((pName) =>
		{
			let tmpField = (pDescriptor.Fields || []).find((pF) => pF.F === pName);
			return !!(tmpField && tmpField.T === 'select' && Array.isArray(tmpField.O) && tmpField.O.length);
		});
		this._derivedFilters[pDescriptor.Key] = { Search: true, Facets: tmpFacets, Derived: true };
		return this._derivedFilters[pDescriptor.Key];
	}

	// The default filter STATE to land on when nothing more specific applies: the user's own
	// pinned default for this screen if they set one (#236), else the descriptor's shipped
	// Filter.Defaults (WorkItem lands on the activity lens; Feedback on unaddressed only).
	// The last-used state and an explicit URL both outrank this; see _landingState.
	_effectiveDefaults(pDescriptor)
	{
		let tmpFilter = this._filterConfig(pDescriptor);
		if (!tmpFilter) { return {}; }
		let tmpUser = libFocus.loadDefaultState(pDescriptor.Key, this._currentUserID());
		if (tmpUser) { return tmpUser; }
		return tmpFilter.Defaults || {};
	}

	/**
	 * The filter state a list should open on, most specific first:
	 *
	 *   1. an explicit focus query on the URL, so a shared link or a reload of a narrowed list
	 *      still lands exactly where it pointed;
	 *   2. the state this person last left this list in;
	 *   3. their pinned per-screen default, then the descriptor's shipped one.
	 *
	 * Step 2 is the fix for the complaint. Sort and filters lived only in the URL, and the router
	 * drops the query when you navigate away, so coming back to Work Items silently reverted the
	 * sort AND reapplied the activity lens: a list showing 21 rows came back showing 2, with
	 * nothing on screen saying why.
	 */
	_landingState(pDescriptor)
	{
		if (!this._filterConfig(pDescriptor)) { return libFocus.emptyState(); }
		if (libFocus.readHashQuery()) { return libFocus.stateFromHash({}); }
		let tmpSaved = this._listPrefs().state;
		if (tmpSaved && typeof tmpSaved === 'object') { return Object.assign(libFocus.emptyState(), tmpSaved); }
		return Object.assign(libFocus.emptyState(), this._effectiveDefaults(pDescriptor));
	}

	// Remember the live filter state (which carries the sort) as this list's last-used state, so it
	// survives navigating away. Best-effort, like every other list preference.
	_persistState()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return; }
		this._patchListPrefs({ state: Object.assign({}, this.pict.AppData.EntityList.Filter || {}) });
	}

	// Whether a column is locked on regardless of mode or preference. The name column keeps a list
	// from ever being blanked, and the number column is the row's mark (WI-014): identity is not
	// something a person should be able to switch off, on either side of the mode toggle.
	_isColumnLocked(pColumn, pDescriptor)
	{
		if (!pDescriptor) { return false; }
		return (pColumn.F === pDescriptor.TitleField) || (!!pDescriptor.NumberField && pColumn.F === pDescriptor.NumberField);
	}

	// Whether one column shows in the given mode. Locked columns always; then an explicit user
	// pref for THIS mode; otherwise the descriptor's default for the mode, which is DefaultHidden
	// for the full table and Key for the concise scan.
	_isColumnVisible(pColumn, pPrefs, pMode)
	{
		let tmpDescriptor = this._descriptor();
		if (this._isColumnLocked(pColumn, tmpDescriptor)) { return true; }
		let tmpColumns = this._columnPrefs(pPrefs, pMode);
		if (Object.prototype.hasOwnProperty.call(tmpColumns, pColumn.F)) { return !!tmpColumns[pColumn.F]; }
		return (pMode === 'concise') ? !!pColumn.Key : !pColumn.DefaultHidden;
	}

	// The columns actually shown, in descriptor order. Header build, cell build, and the
	// header-click sort index all read this one list so they never drift out of alignment.
	_visibleColumns()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return []; }
		let tmpPrefs = this._listPrefs();
		let tmpMode = this._viewMode();
		return tmpDescriptor.Columns.filter((pColumn) => this._isColumnVisible(pColumn, tmpPrefs, tmpMode));
	}

	// ── navigation in from the sidebar ───────────────────────────────────────
	showEntity(pKey, pOptions)
	{
		let tmpDescriptor = libDescriptors.Entities[pKey];
		if (!tmpDescriptor) return;
		let tmpState = this.pict.AppData.EntityList;
		tmpState.Key = pKey;
		tmpState.Title = libLabels.title(this.pict, pKey, null, tmpDescriptor.Title);
		// Seed the live filter: an explicit URL first, then the state this person last left this
		// list in, then their pinned default, then the descriptor's shipped one (see _landingState).
		tmpState.Filter = this._landingState(tmpDescriptor);
		this._applySortFromState(tmpDescriptor);
		tmpState.HeaderCells = this._buildHeaderCells();
		tmpState.EmptyLabel = libLabels.title(this.pict, pKey, null, tmpDescriptor.Title);
		// EmptyText is owned by _syncEmptyState, which runs on every list render and knows whether the
		// emptiness is the entity's or the filter's.
		tmpState.Mode = 'list';
		let tmpProvider = this._provider();
		// Land back on the page this screen was left at, PROVIDED the store still holds the answer to
		// the SAME question: the same filter + sort, fingerprinted as QueryKey (WI #447). Paging to page
		// 4, opening a record, and coming back used to always land on page one, because this always
		// asked for page one regardless of where the store already was. A genuinely different question
		// (a new filter, a new sort, the first-ever visit) still starts at page one, same as before --
		// this only recognizes RETURNING to the one it already answered. A detail view opening in front
		// of this list no longer touches this store's Page or QueryKey while it resolves its own records
		// (EntityAPI.resolve()), so this comparison reads the list screen's own last question, not
		// whatever some other view happened to look up in passing.
		let tmpLandingPage = 1;
		if (tmpProvider)
		{
			let tmpStore = tmpProvider.store();
			let tmpLandingQuery = this._serverQuery();
			// Only an EntityAPI-backed list can fingerprint its own question. Several screens (sessions,
			// among others) are driven by a provider that extends the base class instead, which has no
			// queryKey at all -- calling it threw "queryKey is not a function" and took the whole page
			// down the moment such a list was both paged and non-empty. Without a fingerprint there is
			// no way to prove the store still answers the same question, so those screens land on page
			// one, which is exactly what every list did before WI #447.
			let fQueryKey = (tmpProvider && typeof tmpProvider.queryKey === 'function')
				? tmpProvider.queryKey.bind(tmpProvider) : null;
			if (fQueryKey && tmpLandingQuery.Paged && tmpStore.List.length
				&& tmpStore.QueryKey === fQueryKey({ Filter: tmpLandingQuery.Filter }))
			{
				tmpLandingPage = Math.max(1, Number(tmpStore.Page) || 1);
			}
		}
		tmpState.Page = tmpLandingPage;
		if (this._searchTimer) { clearTimeout(this._searchTimer); this._searchTimer = null; }
		this._fetchQueued = null;
		// A pending create-with-prefill handoff (the app's showNewFeedback stash):
		// consume it once the list is loaded and open the form instead of the list.
		let tmpPending = this.pict.AppData.EntityListPrefill;
		let tmpPrefill = (tmpPending && tmpPending.Key === pKey) ? tmpPending.Values : null;
		this.pict.AppData.EntityListPrefill = null;
		// An edit handoff (the detail view's Edit button): once the data is in, open the edit form for
		// this id instead of the list. Folding it into this single load keeps the form as the final
		// render -- a separate list()+editRecord used to race this method's own list load, and for
		// entities with a facet prefetch (WorkItem's roster) the gated list won and clobbered the form.
		let tmpEditID = (pOptions && pOptions.EditID !== null && typeof pOptions.EditID !== 'undefined') ? pOptions.EditID : null;
		// The create form as a destination of its own (the /<plural>/new route), distinct from the
		// prefill handoff which also lands on it but carries values with it.
		let tmpWantsNew = !!(pOptions && pOptions.New);
		let fAfterData = () =>
		{
			// The _apply* forms on purpose: newRecord/editRecord NAVIGATE, and this method is what the
			// route handler already called, so calling them here would send the router round again.
			if (tmpPrefill) { this._applyNewRecord(tmpPrefill); }
			else if (tmpEditID !== null) { this._applyEditRecord(tmpEditID); }
			else if (tmpWantsNew) { this._applyNewRecord(null); }
			else { this._enterList(); }
		};
		let fLoadThenList = () =>
		{
			if (tmpProvider) { this._fetchPage(tmpLandingPage).then(fAfterData).catch((pErr) => this._listLoadFailed(pErr, fAfterData)); }
			else { fAfterData(); }
		};
		// Load facet + column reference data first when needed, so cells and dropdowns resolve
		// on the first paint: the team roster (assignee facet + column), the keystone customers
		// (Feedback's customer facet), the Vision/Module/Feature caches (the Target column), and
		// the per-item session counts (the Sessions column). All best-effort; the list renders regardless.
		let tmpPrep = [];
		let tmpFilterConfig = this._filterConfig(tmpDescriptor);
		if ((tmpFilterConfig && tmpFilterConfig.Assignee) || this._hasColumn('Assignee')) { tmpPrep.push(this._loadRoster()); }
		if (tmpFilterConfig && tmpFilterConfig.Customer) { tmpPrep.push(this._loadCustomers()); }
		if (this._hasColumn('Target')) { tmpPrep.push(this._loadTargets()); }
		if (this._hasColumn('Sessions')) { tmpPrep.push(this._loadSessionCounts()); }
		// The prep loads are best-effort reference data (facet options, label caches). Promise.all
		// rejects on the first failure, which used to leave fLoadThenList unrun -- a blank page when
		// one of these hiccupped. Run the list either way (second arg = the rejection handler), so a
		// facet fetch failing degrades that dropdown, it never strands the whole screen blank.
		if (tmpPrep.length) { Promise.all(tmpPrep).then(fLoadThenList, fLoadThenList); }
		else { fLoadThenList(); }
	}

	// A list load failing (a transient server hiccup) must never strand a blank content area: surface
	// it, then still run the after-data step, which renders from whatever the provider has cached (an
	// empty state at worst). The user sees the page and can retry by re-navigating, instead of the
	// silent blank screen a rejected list() used to leave behind.
	_listLoadFailed(pErr, fAfterData)
	{
		this._toast('Could not refresh this list: ' + ((pErr && pErr.message) || pErr), 'error');
		try { fAfterData(); }
		catch (pInner) { try { this._enterList(); } catch (pE) { /* last resort: leave prior content */ } }
	}

	// Fetch the keystone customers for the Feedback customer facet options.
	// Best-effort: a failure leaves it empty (the facet still offers Any / No customer).
	_loadCustomers()
	{
		let tmpProvider = this.pict.providers.KeystoneCustomerAPI;
		if (!tmpProvider || typeof tmpProvider.list !== 'function') { this._customerList = []; return Promise.resolve([]); }
		return tmpProvider.list().then((pList) =>
		{
			this._customerList = Array.isArray(pList) ? pList.slice() : [];
			return this._customerList;
		}).catch(() => { this._customerList = []; return []; });
	}

	// Set the active Sort from (in order): the entity's live focus-view sort (in the URL,
	// for filtered entities), the user's remembered list sort (localStorage, for the rest),
	// the descriptor's DefaultSort, then the identity ordinal ascending. Keeps header-click
	// sort and view/preset sort in sync.
	_applySortFromState(pDescriptor)
	{
		let tmpState = this.pict.AppData.EntityList;
		let tmpSortStr = this._filterConfig(pDescriptor)
			? (tmpState.Filter && tmpState.Filter.sort)
			: (this._listPrefs().sort);
		let tmpParsed = libFocus.parseSort(tmpSortStr) || libFocus.parseSort(pDescriptor.DefaultSort);
		tmpState.Sort = tmpParsed
			? { Field: tmpParsed.Field, Dir: tmpParsed.Dir }
			: { Field: pDescriptor.NumberField || pDescriptor.IDField, Dir: 'asc' };
	}

	// Fetch the team roster (id -> name + IsAgent) for the assignee facet + column.
	// Best-effort: a failure leaves the lookup empty (names fall back to #id).
	_loadRoster()
	{
		let tmpTeam = this.pict.providers.TeamAPI;
		if (!tmpTeam || typeof tmpTeam.roster !== 'function') { this._rosterIndex = {}; return Promise.resolve([]); }
		return tmpTeam.roster().then((pRoster) =>
		{
			this._rosterIndex = {};
			let tmpList = Array.isArray(pRoster) ? pRoster : [];
			for (let i = 0; i < tmpList.length; i++) { this._rosterIndex[Number(tmpList[i].IDUser)] = tmpList[i]; }
			return tmpList;
		}).catch(() => { this._rosterIndex = {}; return []; });
	}

	// Fetch the Vision/Module/Feature caches and index them by id per type, so the Target
	// column can resolve a work item's TargetType + typed FK to the target's name. Loaded
	// through the same generic providers the sidebar uses. Best-effort: a missing target
	// just renders as its id. Runs the three loads together.
	_loadTargets()
	{
		let tmpTypes = ['Vision', 'Module', 'Feature'];
		let tmpLoads = tmpTypes.map((pType) =>
		{
			let tmpProvider = this.pict.providers[pType + 'API'];
			if (!tmpProvider || typeof tmpProvider.list !== 'function') { return Promise.resolve([]); }
			return tmpProvider.list()
				.then(() =>
				{
					let tmpIndex = {};
					let tmpRows = tmpProvider.store().List || [];
					let tmpIDField = 'ID' + pType;
					for (let i = 0; i < tmpRows.length; i++) { tmpIndex[Number(tmpRows[i][tmpIDField])] = tmpRows[i]; }
					this._targetIndex[pType] = tmpIndex;
					return tmpRows;
				})
				.catch(() => { this._targetIndex[pType] = {}; return []; });
		});
		return Promise.all(tmpLoads);
	}

	// Fetch the linked-session count for every work item in one call (union of the scalar
	// link and the SessionFileWorkItem join, server-side), for the Sessions column.
	// Best-effort: a failure leaves the map empty (no row shows a marker).
	_loadSessionCounts()
	{
		let tmpSessions = this.pict.providers.SessionAPI;
		if (!tmpSessions || typeof tmpSessions.sessionCounts !== 'function') { this._sessionCountIndex = {}; return Promise.resolve({}); }
		return tmpSessions.sessionCounts().then((pCounts) =>
		{
			this._sessionCountIndex = (pCounts && typeof pCounts === 'object') ? pCounts : {};
			return this._sessionCountIndex;
		}).catch(() => { this._sessionCountIndex = {}; return {}; });
	}

	_currentUserID()
	{
		let tmpAuth = this.pict.AppData.Auth;
		return (tmpAuth && tmpAuth.User && Number(tmpAuth.User.IDUser)) || 0;
	}

	_filterContext()
	{
		let tmpRoster = (this.pict.AppData.Team && this.pict.AppData.Team.Roster) || [];
		return libFocus.buildContext(tmpRoster, this._currentUserID());
	}

	// ── asking the server the question the screen is asking (WI #433) ────────

	// Whether a narrowing facet is on. Distinct from "has a filter bar": a list can offer filters and
	// have none set, and the difference is what an empty result MEANS.
	_isFiltered()
	{
		let tmpDescriptor = this._descriptor();
		if (!this._filterConfig(tmpDescriptor)) { return false; }
		return libFocus.isFiltered(this.pict.AppData.EntityList.Filter || {});
	}

	// The live filter state as FocusQuery wants it. The recent window is resolved to milliseconds
	// here because the state stores the window's NAME ('7d'), and FocusQuery is deliberately given the
	// length rather than a table of names it would have to keep in step with FocusFilters.
	_queryState(pDescriptor)
	{
		if (!this._filterConfig(pDescriptor)) { return {}; }
		let tmpFilter = this.pict.AppData.EntityList.Filter || {};
		return Object.assign({}, tmpFilter, { RecentMs: libFocus.recentMs(tmpFilter.recent) });
	}

	/**
	 * The server query for what is on screen right now, and whether it may be paged.
	 *
	 * NEVER SILENTLY PARTIAL. A non-empty Unexpressed means the query language cannot carry some part
	 * of what the screen is asking (the activity lens, "not addressed" over a nullable column, a
	 * roster-resolved assignee, a sort on a column composed in the browser). Paging then would mean
	 * applying part of the question to one page and calling the result the answer, which is precisely
	 * the defect being fixed here. So the fallback is to fetch the whole set and filter it locally --
	 * slower, and correct.
	 */
	_serverQuery()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return { Filter: '', Unexpressed: [], Paged: false }; }
		let tmpBuilt = libFocusQuery.build(
			this._queryState(tmpDescriptor),
			this._filterContext(),
			tmpDescriptor,
			this.pict.AppData.EntityList.Sort);
		return { Filter: tmpBuilt.Filter, Unexpressed: tmpBuilt.Unexpressed, Paged: (tmpBuilt.Unexpressed.length === 0) };
	}

	/**
	 * Fetch one page (or, in the fallback, everything) and leave the store holding exactly that.
	 *
	 * ONE FETCH AT A TIME, AND THE LAST QUESTION ASKED WINS. Two overlapping list() calls write the
	 * same store and nothing orders their responses, so a slow answer for "auth" can land after a fast
	 * one for "authe" and leave the screen showing the answer to a question the search box has stopped
	 * asking. Serialising is cheaper than reconciling, and a queued page always re-reads the live
	 * state when it finally runs, so only the newest question is ever issued.
	 */
	_fetchPage(pPage)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.list !== 'function') { return Promise.resolve([]); }
		if (this._fetchInFlight)
		{
			this._fetchQueued = pPage;
			return this._fetchInFlight;
		}
		let tmpPromise = this._fetchNow(pPage).then((pRows) =>
		{
			this._fetchInFlight = null;
			if (this._fetchQueued === null) { return pRows; }
			let tmpNext = this._fetchQueued;
			this._fetchQueued = null;
			return this._fetchPage(tmpNext);
		});
		this._fetchInFlight = tmpPromise;
		return tmpPromise;
	}

	// The fetch itself. Stamps what the store now holds onto the view state, so _rows and the footer
	// read the same answer rather than each re-deriving it from the live filter.
	_fetchNow(pPage)
	{
		let tmpProvider = this._provider();
		let tmpState = this.pict.AppData.EntityList;
		let tmpQuery = this._serverQuery();
		tmpState.ServerPaged = tmpQuery.Paged;
		tmpState.Unexpressed = tmpQuery.Unexpressed;
		if (!tmpQuery.Paged)
		{
			tmpState.Page = 1;
			return tmpProvider.list({ All: true });
		}
		tmpState.Page = Math.max(1, Number(pPage) || 1);
		return tmpProvider.list({ Page: tmpState.Page, Filter: tmpQuery.Filter })
			.then((pRows) =>
			{
				// A page past the end of a set that has since shrunk (a delete, or a filter narrowed
				// while a stale page number rode along) comes back empty with rows still behind it.
				// Land on the last real page instead of showing a blank table over a full list.
				let tmpStore = tmpProvider.store();
				let tmpLast = Math.max(1, Number(tmpStore.PageCount) || 1);
				if (pRows.length || (tmpState.Page <= tmpLast)) { return pRows; }
				tmpState.Page = tmpLast;
				return tmpProvider.list({ Page: tmpLast, Filter: tmpQuery.Filter });
			});
	}

	// The list is asking a NEW question (a sort, a facet, a preset): back to page one, fetch it, then
	// draw. Every path that changes what the server would answer goes through here.
	_reload()
	{
		return this._fetchPage(1).then(() => this._enterList()).catch(() => this._enterList());
	}

	// Jump to a page from the footer controls. Clamped to what exists, and a no-op for the page
	// already on screen so a stray double-click costs nothing.
	goToPage(pPage)
	{
		let tmpProvider = this._provider();
		let tmpStore = (tmpProvider && typeof tmpProvider.store === 'function') ? tmpProvider.store() : {};
		let tmpLast = Math.max(1, Number(tmpStore.PageCount) || 1);
		let tmpWanted = Math.min(tmpLast, Math.max(1, Number(pPage) || 1));
		if (tmpWanted === Math.max(1, Number(this.pict.AppData.EntityList.Page) || 1)) { return; }
		this._fetchPage(tmpWanted).then(() => this._enterList()).catch(() => {});
	}

	_rows()
	{
		let tmpDescriptor = this._descriptor();
		let tmpProvider = this._provider();
		if (!tmpDescriptor || !tmpProvider) return [];
		// Resolve the mode once per build so every cell in this render agrees. The icon cells read
		// the derived Density off AppData: the concise scan spends an icon's width, the full table
		// draws the word beside it.
		let tmpMode = this._viewMode();
		this.pict.AppData.EntityList.ViewMode = tmpMode;
		this.pict.AppData.EntityList.Density = (tmpMode === 'table') ? 'expanded' : 'compact';
		let tmpRaw = tmpProvider.store().List || [];
		// Stamp index-backed derived columns onto the rows before sort + cell build, so both
		// read them the same way as any real field (the Sessions column sorts on _SessionCount).
		this._stampDerived(tmpRaw, tmpDescriptor);
		let tmpList = tmpRaw;
		// SORTING AND FILTERING HERE IS THE FALLBACK PATH NOW (WI #433). When the store holds one page
		// of the server's answer, that page is already ordered and narrowed by the whole set, and
		// re-sorting it here would only reorder the page -- which is exactly the bug: 250 at the top
		// and 1 at the bottom of 1,075 blueprints sorted descending. These two lines run only when
		// something in the question could not be expressed and the store therefore holds everything.
		if (!this.pict.AppData.EntityList.ServerPaged)
		{
			tmpList = this._applySort(tmpRaw, tmpDescriptor);
			if (this._filterConfig(tmpDescriptor))
			{
				tmpList = libFocus.filterRows(tmpList, this.pict.AppData.EntityList.Filter, this._filterContext());
			}
		}
		this.pict.AppData.EntityList.FilterCount = this._countLabel(tmpList.length);
		let tmpVisible = this._visibleColumns();
		return tmpList.map((pRow) =>
			({
				ID: pRow[tmpDescriptor.IDField],
				Cells: tmpVisible.map((pC) => this._cell(pC, pRow, tmpDescriptor)),
				// Addressed rows read as done: dimmed content, a "Reopen" quick action.
				RowClass: this._isAddressed(pRow, tmpDescriptor) ? 'ps-row-addressed' : '',
				AddressSlot: this._addressActionModel(pRow, tmpDescriptor)
			}));
	}

	/**
	 * Write derived fields onto the rows so the generic sort, filter and cell build can treat them
	 * as ordinary fields. Runs before all three, which is the whole reason it lives here.
	 *
	 * The mark is the important one. FocusFilters has been able to search by designator since the
	 * markups work, but it asks EntityMark.matchesQuery, which reads Designator / MarkNumber off the
	 * row. The board stamps those in Pict-Provider-BoardAPI._resolveMarks; list rows never got the
	 * equivalent, so they carried only WorkItemNumber and the mark branch quietly never fired.
	 * Typing WI-014 into the Work Items search matched nothing at all, and so did plain 14, the
	 * number printed in the first column of that very list.
	 *
	 * Both fields are display-only: they are not in any descriptor's Fields and save() posts only
	 * FormValues, so neither can post back. A provider reload replaces the rows and the next
	 * _rows() re-stamps.
	 */
	_stampDerived(pRows, pDescriptor)
	{
		let tmpIDField = pDescriptor.IDField;
		let tmpNumberField = pDescriptor.NumberField;
		if (tmpNumberField)
		{
			for (let i = 0; i < pRows.length; i++)
			{
				pRows[i].Designator = libEntityMark.designator(pDescriptor.Key, pRows[i]);
				pRows[i].MarkNumber = Number(pRows[i][tmpNumberField]) || 0;
			}
		}
		if (!this._hasColumn('Sessions')) { return; }
		let tmpCounts = this._sessionCountIndex || {};
		for (let i = 0; i < pRows.length; i++)
		{
			pRows[i]._SessionCount = Number(tmpCounts[pRows[i][tmpIDField]]) || 0;
		}
	}

	// Whether a row is addressed, per the descriptor's Addressable marker (false when
	// the entity is not addressable).
	_isAddressed(pRow, pDescriptor)
	{
		let tmpAddr = pDescriptor && pDescriptor.Addressable;
		return !!(tmpAddr && libFocus.truthy(pRow[tmpAddr.Field]));
	}

	// The Address / Reopen quick-action button model for one row. Marking straight from
	// the list -- without opening the record -- is the core of #201: a long feedback
	// backlog gets cleared in place. Empty for non-addressable entities.
	_addressActionModel(pRow, pDescriptor)
	{
		let tmpAddr = pDescriptor && pDescriptor.Addressable;
		if (!tmpAddr) { return []; }
		let tmpOn = libFocus.truthy(pRow[tmpAddr.Field]);
		return [{
			ID: pRow[pDescriptor.IDField],
			Label: tmpOn ? (tmpAddr.ReopenLabel || 'Reopen') : (tmpAddr.AddressLabel || 'Mark addressed'),
			OnClass: tmpOn ? ' ps-btn-reopen' : ' ps-btn-address'
		}];
	}

	// Flip a record's Addressed flag from the list and stamp (or clear) its date, then
	// reload so the default unaddressed filter drops it from view immediately.
	toggleAddressed(pID)
	{
		let tmpDescriptor = this._descriptor();
		let tmpProvider = this._provider();
		let tmpAddr = tmpDescriptor && tmpDescriptor.Addressable;
		if (!tmpDescriptor || !tmpProvider || !tmpAddr) { return; }
		let tmpRow = tmpProvider.store().Index[pID];
		if (!tmpRow) { return; }
		let tmpNext = libFocus.truthy(tmpRow[tmpAddr.Field]) ? 0 : 1;
		let tmpPatch = {};
		tmpPatch[tmpAddr.Field] = tmpNext;
		if (tmpAddr.DateField) { tmpPatch[tmpAddr.DateField] = tmpNext ? (new Date()).toISOString() : ''; }
		tmpProvider.update(pID, tmpPatch)
			// The page the person is on, not page one of an unfiltered list: addressing a row from
			// page three must not throw them back to the top of the list they were working through.
			.then(() => this._fetchPage(this.pict.AppData.EntityList.Page))
			.then(() =>
			{
				this._toast(tmpNext ? 'Marked addressed.' : 'Reopened.', 'success');
				this._enterList();
			})
			.catch((pErr) => this._toast('Update failed: ' + (pErr.message || pErr), 'error'));
	}

	// A cell shell with every slot empty. Each column kind fills the one slot it uses, so
	// the row template can reference them all without a missing-key gap.
	_baseCell(pColumn, pDescriptor)
	{
		return {
			// The title/name column is the long one: let it wrap and take the spare width.
			CellClass: (pColumn.F === pDescriptor.TitleField) ? 'ps-cell-wrap' : '',
			// Filled for the title column only, so a name the concise scan had to ellipsis is still
			// readable on hover instead of being simply gone.
			TitleAttr: '',
			PlainSlot: [], BadgeSlot: [], AssigneeSlot: [], TargetSlot: [], SessionSlot: [], IconSlot: [], MarkSlot: []
		};
	}

	// Escape for an HTML attribute. The title column carries user-entered text into a title="",
	// where an unescaped quote would end the attribute early and the rest would parse as markup.
	_attr(pText)
	{
		return String(pText == null ? '' : pText)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	/**
	 * The mark cell: the entity's number rendered as its designator, WI-014 rather than a bare 14.
	 *
	 * This is the column a list already had; what it printed just could not be spoken. The board,
	 * the tooltip, the Connections grid and the printed blueprint all say WI-014, so a row saying 14
	 * was the one surface where you could not quote what you were looking at.
	 *
	 * Rendered through the shared Markup-Designator template so it cannot drift from the card. The
	 * four entities with no Designator (Customer, Issue Type, Contact, Session) keep the plain
	 * number, which is what they show today.
	 */
	_markCell(pColumn, pRow, pDescriptor)
	{
		let tmpCell = this._baseCell(pColumn, pDescriptor);
		tmpCell.CellClass = 'ps-cell-mark';
		let tmpDesignator = String(pRow.Designator || '');
		if (!tmpDesignator)
		{
			let tmpRaw = pRow[pColumn.F];
			tmpCell.PlainSlot = [{ Value: (tmpRaw === null || typeof tmpRaw === 'undefined') ? '' : String(tmpRaw) }];
			return tmpCell;
		}
		tmpCell.MarkSlot = [{ Designator: tmpDesignator, KindClass: 'ps-mark-' + String(pDescriptor.Key).toLowerCase() }];
		return tmpCell;
	}

	// One rendered cell for a column. The rich, index-backed kinds (Assignee / Target /
	// Sessions) build their own avatar / chip / marker; Fmt columns run their formatter;
	// the rest print the raw value, as a (optionally tinted) pill when Badge is set.
	_cell(pColumn, pRow, pDescriptor)
	{
		// The number column is the row's mark. Detected off the descriptor rather than a flag on the
		// column, so every numbered entity gets it without eighteen descriptor edits.
		if (pDescriptor.NumberField && pColumn.F === pDescriptor.NumberField) { return this._markCell(pColumn, pRow, pDescriptor); }
		if (pColumn.Assignee) { return this._assigneeCell(pColumn, pRow, pDescriptor); }
		if (pColumn.Target) { return this._targetCell(pColumn, pRow, pDescriptor); }
		if (pColumn.Sessions) { return this._sessionCell(pColumn, pRow, pDescriptor); }
		if (pColumn.Icon) { return this._iconCell(pColumn, pRow, pDescriptor); }

		let tmpCell = this._baseCell(pColumn, pDescriptor);
		let tmpValue = pColumn.Fmt
			? String(pColumn.Fmt(pRow) || '')
			: ((pRow[pColumn.F] === null || typeof pRow[pColumn.F] === 'undefined') ? '' : String(pRow[pColumn.F]));
		if (pColumn.Badge)
		{
			let tmpTint = (pColumn.Tint && tmpValue) ? (pColumn.Tint(pRow) || '') : '';
			tmpCell.BadgeSlot = tmpValue ? [{ Value: tmpValue, StyleAttr: tmpTint ? ('style="' + this._tintStyle(tmpTint) + '"') : '' }] : [];
		}
		else
		{
			tmpCell.PlainSlot = [{ Value: tmpValue }];
		}
		if (pColumn.F === pDescriptor.TitleField && tmpValue) { tmpCell.TitleAttr = 'title="' + this._attr(tmpValue) + '"'; }
		return tmpCell;
	}

	// The Assignee cell: an avatar + name for whoever owns the work item. A human gets a
	// round, name-colored initials avatar; an AI agent (roster IsAgent) gets the hexagon
	// treatment -- a violet six-sided badge with a robot glyph -- so a mixed human/AI board
	// is legible at a glance (Vision #36). Unassigned reads as a muted placeholder, not a gap.
	_assigneeCell(pColumn, pRow, pDescriptor)
	{
		let tmpCell = this._baseCell(pColumn, pDescriptor);
		let tmpID = Number(pRow[pColumn.F]) || 0;
		let tmpPerson = tmpID ? this._rosterIndex[tmpID] : null;
		if (!tmpID)
		{
			tmpCell.AssigneeSlot = [{ Name: 'Unassigned', Initials: '', IsAgent: false, RowClass: ' ps-assignee-none', AvatarClass: '', NameClass: '', AvatarStyle: '', AssigneeAgentSlot: [] }];
			return tmpCell;
		}
		let tmpName = tmpPerson ? (tmpPerson.DisplayName || ('#' + tmpID)) : ('#' + tmpID);
		let tmpAgent = !!(tmpPerson && Number(tmpPerson.IsAgent) === 1);
		tmpCell.AssigneeSlot = [{
			Name: tmpName,
			Initials: tmpAgent ? '' : this._initials(tmpName),
			IsAgent: tmpAgent,
			RowClass: '',
			AvatarClass: tmpAgent ? ' ps-avatar-agent' : '',
			NameClass: tmpAgent ? ' ps-assignee-agent' : '',
			// A human avatar is tinted by a hash of the name; the agent hexagon owns its color.
			AvatarStyle: tmpAgent ? '' : ('style="background:' + this._avatarColor(tmpName) + '"'),
			// The AI agent's avatar carries a robot glyph in place of initials.
			AssigneeAgentSlot: tmpAgent ? [{}] : []
		}];
		return tmpCell;
	}

	// The Target cell: what the work item is about, as a type chip + the target's name
	// (resolved from the prefetched Vision/Module/Feature caches). Blank when there is no target.
	_targetCell(pColumn, pRow, pDescriptor)
	{
		let tmpCell = this._baseCell(pColumn, pDescriptor);
		let tmpType = String(pRow.TargetType || '');
		let tmpFKMap = { Vision: 'IDTargetVision', Module: 'IDTargetModule', Feature: 'IDTargetFeature' };
		if (!tmpFKMap[tmpType]) { return tmpCell; }
		let tmpID = Number(pRow[tmpFKMap[tmpType]]) || 0;
		if (!tmpID) { return tmpCell; }
		let tmpEntity = (this._targetIndex[tmpType] || {})[tmpID] || null;
		let tmpName = tmpEntity ? (tmpEntity.Name || tmpEntity.Title || ('#' + tmpID)) : ('#' + tmpID);
		tmpCell.TargetSlot = [{ Type: tmpType, TypeClass: ' ps-target-' + tmpType.toLowerCase(), Label: tmpName }];
		return tmpCell;
	}

	// The Sessions cell: a compact marker (robot glyph + count) when one or more Claude
	// sessions have advanced this work item, blank otherwise -- so the eye finds the items
	// with an auditable trail. The count is the stamped _SessionCount.
	_sessionCell(pColumn, pRow, pDescriptor)
	{
		let tmpCell = this._baseCell(pColumn, pDescriptor);
		let tmpCount = Number(pRow._SessionCount) || 0;
		if (tmpCount > 0)
		{
			tmpCell.SessionSlot = [{ Count: tmpCount, Title: tmpCount + (tmpCount === 1 ? ' linked session' : ' linked sessions') }];
		}
		return tmpCell;
	}

	// An icon cell: the column's Icon(row) names a registered glyph (rendered inline via the
	// Icon provider), with IconTitle(row) as the hover tooltip -- a compact stand-in for a short
	// enum like WorkItem Type (#236) or Feedback Source (#252). The cell still sorts on the column's
	// real field. In the list's expanded density the glyph is drawn with its word beside it; in
	// compact density (the default) it is the glyph alone. Falls back to plain text when no glyph
	// resolves (an unmapped value, or the provider being absent).
	_iconCell(pColumn, pRow, pDescriptor)
	{
		let tmpCell = this._baseCell(pColumn, pDescriptor);
		let tmpName = String(pColumn.Icon(pRow) || '');
		let tmpTitle = pColumn.IconTitle ? String(pColumn.IconTitle(pRow) || '') : '';
		let tmpProvider = this.pict.providers && this.pict.providers.Icon;
		if (tmpName && tmpProvider && typeof tmpProvider.get === 'function')
		{
			// Expanded density shows the word next to the glyph; compact shows the glyph alone (the
			// word still lives in the tooltip). Density is resolved once per render in _rows().
			let tmpExpanded = (this.pict.AppData.EntityList.Density === 'expanded');
			tmpCell.IconSlot = [{ Html: tmpProvider.get(tmpName), Title: tmpTitle, LabelSlot: (tmpExpanded && tmpTitle) ? [{ Text: tmpTitle }] : [] }];
		}
		else
		{
			let tmpRaw = (pRow[pColumn.F] === null || typeof pRow[pColumn.F] === 'undefined') ? '' : String(pRow[pColumn.F]);
			tmpCell.PlainSlot = [{ Value: tmpTitle || tmpRaw }];
		}
		return tmpCell;
	}

	// Up to two initials from a display name ('Jane Doe' -> 'JD', 'claude' -> 'C', an
	// email -> its first letter). Uppercased; falls back to '?' for an empty name.
	_initials(pName)
	{
		let tmpName = String(pName || '').trim();
		if (!tmpName) { return '?'; }
		let tmpParts = tmpName.split(/[\s@._-]+/).filter((pP) => pP.length);
		if (!tmpParts.length) { return tmpName.charAt(0).toUpperCase(); }
		let tmpFirst = tmpParts[0].charAt(0);
		let tmpSecond = (tmpParts.length > 1) ? tmpParts[1].charAt(0) : '';
		return (tmpFirst + tmpSecond).toUpperCase();
	}

	// A stable avatar background for a human name: hash the name to one palette entry, so
	// the same person is the same color everywhere without any stored preference.
	_avatarColor(pName)
	{
		let tmpName = String(pName || '');
		let tmpHash = 0;
		for (let i = 0; i < tmpName.length; i++) { tmpHash = ((tmpHash << 5) - tmpHash + tmpName.charCodeAt(i)) | 0; }
		return this._avatarPalette[Math.abs(tmpHash) % this._avatarPalette.length];
	}

	// The inline style that tints a badge from a single accent color: a soft wash background
	// with the accent as the text + border, so Status / Priority read as colored pills.
	_tintStyle(pColor)
	{
		return 'background:' + pColor + '22;color:' + pColor + ';border-color:' + pColor + '55';
	}

	_buildHeaderCells()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return []; }
		let tmpSort = this.pict.AppData.EntityList.Sort || {};
		// Index is the position within the VISIBLE columns, so a header click maps back
		// through _visibleColumns() to the same column (see sortBy).
		return this._visibleColumns().map((pC, pIdx) =>
		({
			// The mark column heads the row and stays put while the table scrolls sideways, so its
			// header has to carry the same class as its cells or the two come apart.
			ThClass: (tmpDescriptor.NumberField && pC.F === tmpDescriptor.NumberField) ? ' ps-th-mark' : '',
			Label: (tmpDescriptor.NumberField && pC.F === tmpDescriptor.NumberField && tmpDescriptor.Designator) ? 'Mark' : pC.L,
			Index: pIdx,
			Caret: (tmpSort.Field === pC.F) ? (tmpSort.Dir === 'desc' ? ' ▼' : ' ▲') : ''
		}));
	}

	// Deterministic list order. Default: the entity's own identity ordinal (its number
	// column) ascending, so the oldest is first and the newest lands at the bottom. A header
	// click overrides the field and direction. Ties fall back to the id for stability, so the
	// order is never the undefined database heap order the list used to show.
	_applySort(pList, pDescriptor)
	{
		let tmpSort = this.pict.AppData.EntityList.Sort || {};
		let tmpField = tmpSort.Field || pDescriptor.NumberField || pDescriptor.IDField;
		let tmpDir = (tmpSort.Dir === 'desc') ? -1 : 1;
		let tmpIDField = pDescriptor.IDField;
		return (pList || []).slice().sort((pA, pB) =>
		{
			let tmpA = pA[tmpField], tmpB = pB[tmpField];
			let tmpNA = Number(tmpA), tmpNB = Number(tmpB);
			let tmpCmp;
			if (tmpA != null && tmpB != null && tmpA !== '' && tmpB !== '' && !isNaN(tmpNA) && !isNaN(tmpNB)) { tmpCmp = tmpNA - tmpNB; }
			else { tmpCmp = String(tmpA == null ? '' : tmpA).localeCompare(String(tmpB == null ? '' : tmpB)); }
			if (tmpCmp === 0) { tmpCmp = (Number(pA[tmpIDField]) || 0) - (Number(pB[tmpIDField]) || 0); }
			return tmpCmp * tmpDir;
		});
	}

	// Header click: sort by that column, toggling direction if it is already the sort key.
	sortBy(pIndex)
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return; }
		let tmpCol = this._visibleColumns()[pIndex];
		if (!tmpCol) { return; }
		let tmpState = this.pict.AppData.EntityList;
		if (tmpState.Sort && tmpState.Sort.Field === tmpCol.F) { tmpState.Sort.Dir = (tmpState.Sort.Dir === 'asc') ? 'desc' : 'asc'; }
		else { tmpState.Sort = { Field: tmpCol.F, Dir: 'asc' }; }
		let tmpSort = tmpState.Sort.Field + ':' + tmpState.Sort.Dir;
		// Remembered per user + entity in every case. It used to be written to the URL alone for a
		// filtered list, which is precisely why the sort on Work Items did not survive walking away
		// from the page: the router drops the query and the sort went with it.
		this._patchListPrefs({ sort: tmpSort });
		if (this._filterConfig(tmpDescriptor))
		{
			// Sort is also part of a shareable focus view: fold it into the URL state (and drop the
			// active preset label) so a sorted list survives reload and copy-paste.
			tmpState.Filter.sort = tmpSort;
			tmpState.Filter.view = '';
			this._writeUrl();
			this._persistState();
		}
		// THE SORT GOES TO THE SERVER (WI #433). This used to re-sort the loaded page in place, which
		// is why sorting blueprints descending by mark put 250 at the top: the page was ordered
		// perfectly and it was the wrong 250 rows. A new order is a new question, so it starts again
		// at page one.
		this._reload();
	}

	// Merge a shallow partial into the saved list prefs for this entity and persist.
	_patchListPrefs(pPatch)
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return; }
		let tmpPrefs = this._listPrefs();
		Object.assign(tmpPrefs, pPatch || {});
		libFocus.saveListPrefs(tmpDescriptor.Key, this._currentUserID(), tmpPrefs);
	}

	// Switch between the concise scan and the full table from the toolbar toggle, remember it per
	// user + entity, and re-render. A no-op when the mode is already active, so a stray click does
	// not thrash the DOM.
	setViewMode(pMode)
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return; }
		let tmpMode = (pMode === 'table') ? 'table' : 'concise';
		if (this._viewMode() === tmpMode) { return; }
		this._patchListPrefs({ viewMode: tmpMode });
		this._enterList();
	}

	// ── column show/hide ──────────────────────────────────────────────────────
	// Build the column picker model for the mode on screen: one entry per descriptor column, each
	// carrying whether it is on right now. The mark and name columns are locked on (checked +
	// disabled). Because the model is per mode, hiding Priority in the table does not also hide it
	// in the concise scan, and adding Target to the scan does not widen the table.
	_buildColumnMenu(pDescriptor)
	{
		let tmpPrefs = this._listPrefs();
		let tmpMode = this._viewMode();
		let tmpColumns = pDescriptor.Columns.map((pColumn) =>
		{
			let tmpLocked = this._isColumnLocked(pColumn, pDescriptor);
			let tmpOn = this._isColumnVisible(pColumn, tmpPrefs, tmpMode);
			return {
				F: pColumn.F,
				L: pColumn.L,
				On: tmpOn,
				Locked: tmpLocked,
				CheckedAttr: tmpOn ? 'checked' : '',
				DisabledAttr: tmpLocked ? 'disabled' : '',
				OnClass: tmpOn ? ' ps-pin-on' : '',
				// A chip reads as an action, so it says what clicking it will do.
				PinLabel: (tmpOn ? '' : '+ ') + pColumn.L
			};
		});
		return { Columns: tmpColumns, Pins: tmpColumns.filter((pColumn) => !pColumn.Locked) };
	}

	// Flip one column's visibility IN THE CURRENT MODE, persist the choice, and repaint the table
	// in place (leaving an open picker untouched so several columns can be toggled in a row).
	toggleColumn(pField)
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return; }
		let tmpColumn = tmpDescriptor.Columns.find((pColumn) => pColumn.F === pField);
		if (!tmpColumn) { return; }
		// The mark and name columns can never be hidden (see _isColumnLocked), so ignore them here too.
		if (this._isColumnLocked(tmpColumn, tmpDescriptor)) { return; }
		let tmpPrefs = this._listPrefs();
		let tmpMode = this._viewMode();
		let tmpNext = !this._isColumnVisible(tmpColumn, tmpPrefs, tmpMode);
		// Normalize a legacy flat map into the per-mode shape on first write, so an existing user's
		// hidden columns carry over into the table rather than silently reappearing.
		let tmpColumns = tmpPrefs.columns || {};
		if (!tmpColumns.table && !tmpColumns.concise) { tmpColumns = { table: tmpColumns, concise: {} }; }
		tmpColumns[tmpMode] = tmpColumns[tmpMode] || {};
		tmpColumns[tmpMode][pField] = tmpNext;
		tmpPrefs.columns = tmpColumns;
		libFocus.saveListPrefs(tmpDescriptor.Key, this._currentUserID(), tmpPrefs);
		// The concise pin strip shows which columns are on, so it has to redraw with the table.
		if (tmpMode === 'concise') { this._enterList(); }
		else { this._repaintTable(); }
	}

	// Repaint the header row + body (and the count) in place, without re-rendering the
	// list head -- so toggling a column keeps the "Columns" dropdown open. Falls back to a
	// full render when the table is not currently mounted (e.g. an empty list).
	_repaintTable()
	{
		let tmpState = this.pict.AppData.EntityList;
		tmpState.HeaderCells = this._buildHeaderCells();
		tmpState.Rows = this._rows();
		let tmpHeadRow = this.pict.ContentAssignment.getElement('#EntityList-HeadRow');
		if (!tmpHeadRow || tmpHeadRow.length === 0) { this._enterList(); return; }
		let tmpHead = '';
		for (let i = 0; i < tmpState.HeaderCells.length; i++) { tmpHead += this.pict.parseTemplateByHash('EntityList-Th', tmpState.HeaderCells[i]); }
		// Matches EntityList-Table: the actions column heads nothing, since two glyphs need no label.
		tmpHead += '<th class="ps-th-actions"></th>';
		this.pict.ContentAssignment.assignContent('#EntityList-HeadRow', tmpHead);
		let tmpBody = '';
		for (let i = 0; i < tmpState.Rows.length; i++) { tmpBody += this.pict.parseTemplateByHash('EntityList-Row', tmpState.Rows[i]); }
		this.pict.ContentAssignment.assignContent('#EntityList-Tbody', tmpBody);
		this._repaintFoot();
	}

	// ── focus-view filtering ─────────────────────────────────────────────────

	// A single-select facet changed (Type/Priority/Assignee/Target/Recent). Update state,
	// drop the active preset label, refresh the URL and re-render (a select has no text focus).
	setFilter(pField, pValue)
	{
		this.pict.AppData.EntityList.Filter[pField] = pValue || '';
		this.pict.AppData.EntityList.Filter.view = '';
		this._afterFilterChange();
	}

	// A status chip toggled (multi-select): add/remove the key from the comma list.
	toggleStatus(pKey)
	{
		let tmpFilter = this.pict.AppData.EntityList.Filter;
		let tmpSet = {};
		String(tmpFilter.status || '').split(',').forEach((pS) => { if (pS.trim()) { tmpSet[pS.trim()] = true; } });
		if (tmpSet[pKey]) { delete tmpSet[pKey]; } else { tmpSet[pKey] = true; }
		tmpFilter.status = Object.keys(tmpSet).join(',');
		tmpFilter.view = '';
		this._afterFilterChange();
	}

	// The search box changed. This path must NOT re-render the bar (the input would lose
	// focus mid-type), so it repaints only the table body, the footer and the count.
	//
	// DEBOUNCED, because a search is now a request rather than a pass over an array already in memory
	// (WI #433). A keystroke is not a question; the pause after one is. The state, the URL and the
	// saved preference update immediately either way, so nothing about the box lags the typing.
	setSearch(pValue)
	{
		this.pict.AppData.EntityList.Filter.q = pValue || '';
		this.pict.AppData.EntityList.Filter.view = '';
		this._writeUrl();
		this._persistState();
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(() =>
		{
			this._searchTimer = null;
			this._fetchPage(1).then(() => this._repaintRows()).catch(() => {});
		}, _SEARCH_DEBOUNCE_MS);
	}

	// Apply a preset / saved view by key ('' clears to no filter).
	applyView(pKey)
	{
		let tmpDescriptor = this._descriptor();
		if (!pKey) { this.clearFilters(); return; }
		let tmpState = libFocus.viewState(tmpDescriptor.Key, this._currentUserID(), pKey);
		this.pict.AppData.EntityList.Filter = tmpState || libFocus.emptyState();
		this._applySortFromState(tmpDescriptor);
		this._afterFilterChange();
	}

	clearFilters()
	{
		this.pict.AppData.EntityList.Filter = libFocus.emptyState();
		this._applySortFromState(this._descriptor());
		this._afterFilterChange();
	}

	// Save the current filter as a named personal view (name via the modal, since native
	// prompt is banned). Refreshes the picker and selects the new view.
	saveView()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDescriptor = this._descriptor();
		let fSave = (pName) =>
		{
			let tmpRecord = libFocus.saveSavedView(tmpDescriptor.Key, this._currentUserID(), pName, this.pict.AppData.EntityList.Filter);
			if (tmpRecord)
			{
				this.pict.AppData.EntityList.Filter.view = tmpRecord.Key;
				this._afterFilterChange();
				this._toast('View "' + tmpRecord.Label + '" saved.', 'success');
			}
		};
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		tmpModal.show(
			{
				title: 'Save this view',
				content: '<p>Name this filter so you can switch back to it:</p><input type="text" id="ps-saveview-input" class="ps-input" style="width:100%" autofocus>',
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Save', Style: 'primary' } ]
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				let tmpEl = (typeof document !== 'undefined') ? document.getElementById('ps-saveview-input') : null;
				let tmpName = (tmpEl && tmpEl.value ? tmpEl.value : '').trim();
				if (tmpName) { fSave(tmpName); }
			});
	}

	deleteView(pKey)
	{
		let tmpKey = pKey || this.pict.AppData.EntityList.Filter.view;
		if (!tmpKey) { return; }
		libFocus.deleteSavedView(this._descriptor().Key, this._currentUserID(), tmpKey);
		if (this.pict.AppData.EntityList.Filter.view === tmpKey) { this.pict.AppData.EntityList.Filter.view = ''; }
		this._afterFilterChange();
		this._toast('View deleted.', 'success');
	}

	// ── per-screen default filter (#236) ──────────────────────────────────────
	// Pin the current filter as this user's default landing view for this screen. "None" is pinnable
	// too: Clear the filters first, then Set as default.
	//
	// The pinned default now sits UNDER the last-used state (see _landingState), so pinning one also
	// rewrites the last-used state to match. Otherwise the control would look broken: you would pin
	// a default, and the state you happened to be in would keep outranking it forever.
	setAsDefault()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor || !this._filterConfig(tmpDescriptor)) { return; }
		libFocus.saveDefaultState(tmpDescriptor.Key, this._currentUserID(), this.pict.AppData.EntityList.Filter);
		this._persistState();
		let tmpName = libLabels.title(this.pict, tmpDescriptor.Key, null, tmpDescriptor.Title);
		this._toast('Saved as your default view for ' + tmpName + '.', 'success');
		// Repaint the bar so the Clear-default control appears.
		this._enterList();
	}

	// Drop the user's pinned default for this screen; the shipped default takes over on the next
	// clean landing. The remembered last-used state goes with it, since it would otherwise outrank
	// the shipped default and nothing would appear to change. The current view stays on screen.
	clearDefault()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor || !this._filterConfig(tmpDescriptor)) { return; }
		libFocus.clearDefaultState(tmpDescriptor.Key, this._currentUserID());
		this._patchListPrefs({ state: null });
		this._toast('Default view cleared; using the standard default next time.', 'success');
		this._enterList();
	}

	// Shared post-change tail for every facet mutation: remember the state, mirror it to the URL,
	// and re-render. Persisting here is what makes a narrowed list survive walking away from it,
	// and it is what makes Clear honest -- clearing used to be undone the moment you came back,
	// because the descriptor's default lens reapplied itself with nothing on screen saying so.
	_afterFilterChange()
	{
		this._writeUrl();
		this._persistState();
		// A changed facet is a different question, so it is asked again from page one rather than
		// applied to the page already in hand (WI #433).
		this._reload();
	}

	_writeUrl()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor || !this._filterConfig(tmpDescriptor)) { return; }
		libFocus.writeHashState(this.pict.AppData.EntityList.Filter);
	}

	// Concatenate one template rendered once per record in a TS: slot array -- the same expansion
	// {~TS:Hash:Slot~} does inline, usable outside a full render.
	_renderSlot(pHash, pSlotArray)
	{
		let tmpHTML = '';
		(pSlotArray || []).forEach((pRecord) => { tmpHTML += this.pict.parseTemplateByHash(pHash, pRecord); });
		return tmpHTML;
	}

	// Recompute + repaint ONLY the table (or the empty state) and the count -- used by the search
	// box so the input keeps focus. A search can narrow the list to zero rows and back on every
	// keystroke; #EntityList-Tbody only exists while there are rows (EntityList-Table is itself a
	// TS: slot that drops out when TableSlot is empty), so probing for the tbody used to fall back
	// to a full _enterList() render the moment a search matched nothing -- which rebuilds the filter
	// bar too and defocuses the box on every character from then on. #EntityList-Body wraps the
	// table/empty-state pair with a stable id, so it repaints in place without ever touching the
	// filter bar.
	_repaintRows()
	{
		let tmpState = this.pict.AppData.EntityList;
		tmpState.Rows = this._rows();
		tmpState.TableSlot = (tmpState.Rows.length > 0) ? [{}] : [];
		tmpState.EmptySlot = (tmpState.Rows.length === 0) ? [{}] : [];
		this._syncEmptyState();
		let tmpBody = this.pict.ContentAssignment.getElement('#EntityList-Body');
		if (!tmpBody || tmpBody.length === 0)
		{
			this._enterList();
			return;
		}
		let tmpHTML = this._renderSlot('EntityList-Table', tmpState.TableSlot)
			+ this._renderSlot('EntityList-Empty', tmpState.EmptySlot);
		this.pict.ContentAssignment.assignContent('#EntityList-Body', tmpHTML);
		this._repaintFoot();
	}

	// The page footer and the count, repainted in place. BOTH partial repaint paths have to call this
	// or they leave a stale page number under fresh rows: the search box (_repaintRows) changes the
	// result set out from under "Page 2 of 5", and the column toggle (_repaintTable) redraws the table
	// without ever touching what sits below it. Its own stable container, so it repaints whether or
	// not there is a footer to draw right now.
	_repaintFoot()
	{
		let tmpState = this.pict.AppData.EntityList;
		tmpState.PageFootSlot = this._pageFootModel();
		this.pict.ContentAssignment.assignContent('#EntityList-Foot', this._renderSlot('EntityList-PageFoot', tmpState.PageFootSlot));
		this.pict.ContentAssignment.assignContent('#EntityList-Count', tmpState.FilterCount || '');
	}

	// Build the filter-bar model (facet controls + view picker) from the descriptor's
	// Filter config and the live state, then park it in the single-element render slot.
	_syncFilterSlot(pDescriptor)
	{
		let tmpState = this.pict.AppData.EntityList;
		if (this._filterConfig(pDescriptor))
		{
			this._buildFilterBar(pDescriptor);
			tmpState.FilterBarSlot = [tmpState.FilterBar];
		}
		else
		{
			tmpState.FilterBarSlot = [];
		}
	}

	_fieldOptions(pDescriptor, pF)
	{
		let tmpField = (pDescriptor.Fields || []).find((pX) => pX.F === pF);
		return (tmpField && tmpField.O) ? tmpField.O.slice() : [];
	}

	// A generic <option> model list: '' renders as pAnyLabel (the "no filter" choice), the
	// rest use their own text; the one matching pSelected is marked selected.
	_selectOptions(pValues, pSelected, pAnyLabel)
	{
		return pValues.map((pV) =>
			({ Value: pV, Label: (pV === '') ? pAnyLabel : pV, SelectedAttr: (String(pV) === String(pSelected || '')) ? 'selected' : '' }));
	}

	_assigneeOptions(pSelected)
	{
		let tmpOptions = libFocus.AssigneeChoices.map((pC) =>
			({ Value: pC.Key, Label: pC.Label, SelectedAttr: (pC.Key === (pSelected || '')) ? 'selected' : '' }));
		// Specific people from the roster (agents flagged), keyed as u:<IDUser>.
		let tmpRoster = (this.pict.AppData.Team && this.pict.AppData.Team.Roster) || [];
		for (let i = 0; i < tmpRoster.length; i++)
		{
			let tmpKey = 'u:' + tmpRoster[i].IDUser;
			tmpOptions.push(
				{
					Value: tmpKey,
					Label: (tmpRoster[i].DisplayName || ('#' + tmpRoster[i].IDUser)) + (Number(tmpRoster[i].IsAgent) === 1 ? ' (AI)' : ''),
					SelectedAttr: (tmpKey === (pSelected || '')) ? 'selected' : ''
				});
		}
		return tmpOptions;
	}

	_targetOptions(pSelected)
	{
		return libFocus.TargetChoices.map((pC) =>
			({ Value: pC.Key, Label: pC.Label, SelectedAttr: (pC.Key === (pSelected || '')) ? 'selected' : '' }));
	}

	_workflowStatusOptions(pSelected)
	{
		return libFocus.WorkflowStatusChoices.map((pC) =>
			({ Value: pC.Key, Label: pC.Label, SelectedAttr: (pC.Key === (pSelected || '')) ? 'selected' : '' }));
	}

	_recentOptions(pSelected)
	{
		let tmpOptions = [{ Value: '', Label: 'Any time', SelectedAttr: (!pSelected) ? 'selected' : '' }];
		libFocus.RecentWindows.forEach((pW) =>
			tmpOptions.push({ Value: pW.Key, Label: pW.Label, SelectedAttr: (pW.Key === (pSelected || '')) ? 'selected' : '' }));
		return tmpOptions;
	}

	// Addressed facet: 'no' (default) / 'yes' / 'all'. Both '' and 'all' read as "show
	// everything", so a Clear (which empties the state) still shows the All option selected.
	_addressedOptions(pSelected)
	{
		let tmpCur = String(pSelected || '');
		let tmpAll = (tmpCur === '' || tmpCur === 'all');
		return [
			{ Value: 'no',  Label: 'Unaddressed',  SelectedAttr: (tmpCur === 'no') ? 'selected' : '' },
			{ Value: 'yes', Label: 'Addressed',    SelectedAttr: (tmpCur === 'yes') ? 'selected' : '' },
			{ Value: 'all', Label: 'All feedback', SelectedAttr: tmpAll ? 'selected' : '' }
		];
	}

	// Customer facet: Any / No customer, then each loaded keystone customer by name.
	_customerOptions(pSelected)
	{
		let tmpCur = String(pSelected || '');
		let tmpOptions =
		[
			{ Value: '',     Label: 'Any customer', SelectedAttr: (tmpCur === '') ? 'selected' : '' },
			{ Value: 'none', Label: 'No customer',  SelectedAttr: (tmpCur === 'none') ? 'selected' : '' }
		];
		let tmpList = (this._customerList || []).slice().sort((pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || '')));
		for (let i = 0; i < tmpList.length; i++)
		{
			let tmpKey = String(tmpList[i].IDKeystoneCustomer);
			tmpOptions.push({ Value: tmpKey, Label: tmpList[i].Name || ('#' + tmpKey), SelectedAttr: (tmpKey === tmpCur) ? 'selected' : '' });
		}
		return tmpOptions;
	}

	// Source-type facet: Any source, then the descriptor's SourceType option list.
	_sourceTypeOptions(pDescriptor, pSelected)
	{
		return this._selectOptions([''].concat(this._fieldOptions(pDescriptor, 'SourceType')), pSelected, 'Any source');
	}

	_viewOptions(pSelected)
	{
		let tmpOptions = [{ Value: '', Label: 'Views: none', SelectedAttr: (!pSelected) ? 'selected' : '' }];
		let tmpAll = libFocus.allViews(this._descriptor().Key, this._currentUserID());
		tmpAll.forEach((pV) =>
			tmpOptions.push({ Value: pV.Key, Label: (pV.Group ? (pV.Group + ': ') : '') + pV.Label, SelectedAttr: (pV.Key === (pSelected || '')) ? 'selected' : '' }));
		return tmpOptions;
	}

	_buildFilterBar(pDescriptor)
	{
		let tmpState = this.pict.AppData.EntityList;
		let tmpFilter = tmpState.Filter || libFocus.emptyState();
		let tmpConfig = this._filterConfig(pDescriptor) || {};
		let tmpFacets = tmpConfig.Facets || [];
		let fHas = (pName) => tmpFacets.indexOf(pName) !== -1;
		let tmpStatusSet = {};
		String(tmpFilter.status || '').split(',').forEach((pS) => { if (pS.trim()) { tmpStatusSet[pS.trim()] = true; } });

		tmpState.FilterBar =
		{
			SearchSlot: tmpConfig.Search ? [{ Value: String(tmpFilter.q || '') }] : [],
			// Status as multi-toggle chips (matches the board lanes).
			StatusChips: fHas('Status')
				? this._fieldOptions(pDescriptor, 'Status').map((pO) => ({ Key: pO, Label: (libDescriptors.BoardLaneLabels[pO] || pO), OnClass: tmpStatusSet[pO] ? ' ps-chip-on' : '' }))
				: [],
			// Single-select dropdown facets.
			TypeSlot: fHas('Type') ? [{ Options: this._selectOptions([''].concat(this._fieldOptions(pDescriptor, 'Type')), tmpFilter.type, 'All types') }] : [],
			PrioritySlot: fHas('Priority') ? [{ Options: this._selectOptions([''].concat(this._fieldOptions(pDescriptor, 'Priority')), tmpFilter.priority, 'Any priority') }] : [],
			AssigneeSlot: fHas('Assignee') ? [{ Options: this._assigneeOptions(tmpFilter.assignee) }] : [],
			TargetSlot: fHas('Target') ? [{ Options: this._targetOptions(tmpFilter.target) }] : [],
			WorkflowStatusSlot: fHas('WorkflowStatus') ? [{ Options: this._workflowStatusOptions(tmpFilter.wfstatus) }] : [],
			// Feedback facets: addressed lifecycle, source customer, and origin source-type.
			AddressedSlot: fHas('Addressed') ? [{ Options: this._addressedOptions(tmpFilter.addressed) }] : [],
			CustomerSlot: fHas('Customer') ? [{ Options: this._customerOptions(tmpFilter.customer) }] : [],
			SourceTypeSlot: fHas('SourceType') ? [{ Options: this._sourceTypeOptions(pDescriptor, tmpFilter.sourcetype) }] : [],
			RecentSlot: tmpConfig.Recent ? [{ Options: this._recentOptions(tmpFilter.recent) }] : [],
			ViewSlot: tmpConfig.Views ? [{ Options: this._viewOptions(tmpFilter.view) }] : [],
			CountLabel: tmpState.FilterCount || '',
			ClearSlot: libFocus.isFiltered(tmpFilter) ? [{}] : [],
			// Only a saved (personal) view can be deleted; presets are shipped.
			DeleteViewSlot: (String(tmpFilter.view || '').indexOf('saved:') === 0) ? [{ Key: tmpFilter.view }] : [],
			// Per-screen default (#236): "Set as default" is always offered on a filtered list;
			// "Clear default" only when the user has pinned one for this screen.
			SetDefaultSlot: [{}],
			ClearDefaultSlot: libFocus.loadDefaultState(pDescriptor.Key, this._currentUserID()) ? [{}] : []
		};
	}

	// The provider's store, or an empty object when there is no provider yet.
	_pageStore()
	{
		let tmpProvider = this._provider();
		return (tmpProvider && typeof tmpProvider.store === 'function') ? (tmpProvider.store() || {}) : {};
	}

	/**
	 * The sentence that says what is on screen.
	 *
	 * Server-paged it is a RANGE out of the real total, because "Showing 250 of 1075" over a page of
	 * 250 reads as a truncation rather than as page two -- which is how the original bug hid in plain
	 * sight. In the local fallback the store holds everything, so it is the old N-of-M count and it is
	 * true again for the first time.
	 */
	_countLabel(pShown)
	{
		let tmpState = this.pict.AppData.EntityList;
		let tmpStore = this._pageStore();
		if (!tmpState.ServerPaged)
		{
			if (!this._filterConfig(this._descriptor())) { return ''; }
			let tmpLoaded = ((tmpStore.List) || []).length;
			return 'Showing ' + pShown + ' of ' + tmpLoaded;
		}
		let tmpTotal = Number(tmpStore.Total) || 0;
		// An empty list is only a "no matches" when something was asked of it. On an entity nobody has
		// created anything in yet, "No matches" reads as a failed search beside an empty state that
		// says the opposite, so the honest answer there is to say nothing and let the empty state talk.
		if (!tmpTotal || !pShown) { return this._isFiltered() ? 'No matches' : ''; }
		let tmpFirst = ((Math.max(1, Number(tmpStore.Page) || 1)) - 1) * (Math.max(1, Number(tmpStore.PageSize) || 1)) + 1;
		return 'Showing ' + tmpFirst + '-' + (tmpFirst + pShown - 1) + ' of ' + tmpTotal;
	}

	/**
	 * The page controls: first / prev / page N of M / next / last, and the range they are moving
	 * through. Real pages, not a Load more -- a list of 1,075 rows should be walkable, and the fifth
	 * page should be one click from the first rather than four appends away from it.
	 *
	 * Empty when there is only one page (nothing to move between) and in the local fallback (which
	 * holds the whole set and has no pages at all).
	 */
	_pageFootModel()
	{
		let tmpState = this.pict.AppData.EntityList;
		if (!tmpState.ServerPaged) { return []; }
		let tmpStore = this._pageStore();
		let tmpCount = Math.max(1, Number(tmpStore.PageCount) || 1);
		if (tmpCount < 2) { return []; }
		let tmpPage = Math.min(tmpCount, Math.max(1, Number(tmpStore.Page) || 1));
		let tmpAtStart = (tmpPage <= 1);
		let tmpAtEnd = (tmpPage >= tmpCount);
		return [{
			RangeLabel: tmpState.FilterCount || '',
			PageLabel: 'Page ' + tmpPage + ' of ' + tmpCount,
			PrevPage: tmpPage - 1,
			NextPage: tmpPage + 1,
			LastPage: tmpCount,
			FirstDisabled: tmpAtStart ? 'disabled' : '',
			PrevDisabled: tmpAtStart ? 'disabled' : '',
			NextDisabled: tmpAtEnd ? 'disabled' : '',
			LastDisabled: tmpAtEnd ? 'disabled' : ''
		}];
	}

	/**
	 * What an empty table means, which is now two different things.
	 *
	 * Rows.length === 0 used to be unambiguous, because the browser held every row and had filtered
	 * them itself. With the filtering server-side an empty page is far more often "nothing matched"
	 * than "nothing exists", and telling someone their Work Items list is empty while it holds six
	 * hundred rows behind a facet is a lie the old local filtering was never able to tell. So the
	 * filtered empty says so, and carries the way out with it.
	 */
	_syncEmptyState()
	{
		let tmpState = this.pict.AppData.EntityList;
		let tmpDescriptor = this._descriptor();
		if (this._isFiltered())
		{
			tmpState.EmptyText = 'No ' + (tmpState.EmptyLabel || 'records') + ' match these filters.';
			tmpState.EmptyFilteredSlot = [{}];
			return;
		}
		tmpState.EmptyText = (tmpDescriptor && tmpDescriptor.EmptyText) || 'Nothing here yet. Click + New to add the first one.';
		tmpState.EmptyFilteredSlot = [];
	}

	_enterList()
	{
		// Any create-form images still pending here are being abandoned (save() re-owns
		// and clears them before it reaches this), so drop the orphan uploads.
		this._discardPendingMedia();
		// Leaving the form: the render below wipes the rich editor's host DOM, but the editor view
		// itself lingers (its CodeMirror instances + debounce timers stay live against detached
		// nodes). Destroy it here so it does not accumulate as a detached-node leak across create /
		// edit cycles; _mountMarkdownEditor re-creates it cleanly the next time a form opens.
		this._teardownMarkdownEditor();
		this._teardownCodeEditor();
		let tmpDescriptor = this._descriptor();
		let tmpState = this.pict.AppData.EntityList;
		tmpState.Mode = 'list';
		tmpState.Rows = this._rows();
		tmpState.HeaderCells = this._buildHeaderCells();
		// Entities flagged NoCreate (test runs start from a Routine) hide "+ New".
		tmpState.ListModeSlot = (tmpDescriptor && tmpDescriptor.NoCreate) ? [] : [{}];
		// A descriptor can supply a custom primary action in place of "+ New"
		// (Session uploads a zip rather than opening the inline create form).
		tmpState.CreateButtonSlot = (tmpDescriptor && tmpDescriptor.CreateButton)
			? [{ Label: tmpDescriptor.CreateButton.Label, Action: tmpDescriptor.CreateButton.Action }]
			: [];
		tmpState.TableSlot = (tmpState.Rows.length > 0) ? [{}] : [];
		tmpState.EmptySlot = (tmpState.Rows.length === 0) ? [{}] : [];
		this._syncEmptyState();
		// Real pages (WI #433): first / prev / page N of M / next / last over the server's answer.
		tmpState.PageFootSlot = this._pageFootModel();
		// The column controls ride alongside the table, only when there is a table to shape (a
		// descriptor with columns) and only when there is something unlocked to shape: a two-column
		// list like Blueprints has nothing to offer.
		//
		// SHOWN OVER AN EMPTY FILTERED LIST TOO. Gating these on rows alone meant a filter that matched
		// nothing took the whole toolbar away with it, including the mode toggle -- the controls a
		// person reaches for when a list has gone blank are the ones that vanish exactly then.
		let tmpMode = this._viewMode();
		let tmpHasTable = (tmpState.Rows.length > 0) || this._isFiltered();
		let tmpMenu = (tmpHasTable && tmpDescriptor && tmpDescriptor.Columns && tmpDescriptor.Columns.length)
			? this._buildColumnMenu(tmpDescriptor)
			: null;
		let tmpHasOptional = !!(tmpMenu && tmpMenu.Pins.length);
		// One control per mode, each shaped for its job. The table gets the dropdown, which scales to
		// nine columns without eating a row of the toolbar. The concise scan gets the strip, because
		// adding a column back for a minute to cross-reference something should be one click and
		// should advertise what is available rather than hiding it behind a menu.
		tmpState.ColumnsSlot = (tmpHasOptional && tmpMode === 'table') ? [tmpMenu] : [];
		tmpState.PinSlot = (tmpHasOptional && tmpMode === 'concise') ? [tmpMenu] : [];
		// The mode toggle rides alongside the table whenever there are rows to read.
		tmpState.ViewModeSlot = (tmpHasTable && tmpDescriptor && tmpDescriptor.Columns && tmpDescriptor.Columns.length)
			? [{
				ConciseOnClass: (tmpMode === 'concise') ? ' ps-density-on' : '',
				TableOnClass: (tmpMode === 'table') ? ' ps-density-on' : ''
			}]
			: [];
		// The concise scan tightens every row; the table keeps the roomier one.
		tmpState.TableClass = (tmpMode === 'concise') ? ' ps-table-concise' : '';
		tmpState.FormSlot = [];
		// Fill the workspace: the table (and the empty state) get the full width instead of a centered
		// 1000px column; .ps-table-scroll handles genuine overflow only when the window is narrower than
		// the table itself.
		tmpState.PageClass = 'ps-page-bleed';
		this._syncFilterSlot(tmpDescriptor);
		this.render();
	}

	// ── form mode ────────────────────────────────────────────────────────────
	// A field carrying HideWhen is dropped from the form when the named sibling field holds the matching
	// value (used to hide the likert scores for Developer Experience feedback).
	_fieldHidden(pField, pValues)
	{
		let tmpCond = pField && pField.HideWhen;
		if (!tmpCond || !tmpCond.Field) { return false; }
		return String((pValues || {})[tmpCond.Field]) === String(tmpCond.Equals);
	}

	_buildFormFields()
	{
		let tmpDescriptor = this._descriptor();
		let tmpValues = this.pict.AppData.EntityList.FormValues;
		return tmpDescriptor.Fields.filter((pField) => !this._fieldHidden(pField, tmpValues)).map((pField) =>
		{
			let tmpVal = (tmpValues[pField.F] === null || typeof tmpValues[pField.F] === 'undefined') ? '' : tmpValues[pField.F];
			return (
			{
				F: pField.F, L: pField.L,
				TextSlot: (pField.T === 'text') ? [{ F: pField.F, Value: tmpVal }] : [],
				TextareaSlot: (pField.T === 'textarea' && !pField.Markdown) ? [{ F: pField.F, Value: tmpVal }] : [],
				// Markdown:true -> the rich editor mounts into the host div after render (onAfterRender).
				MarkdownSlot: (pField.T === 'textarea' && pField.Markdown) ? [{ F: pField.F }] : [],
				// T:'code' -> pict-section-code mounts the same way. A configuration blob is not prose, and
				// a bare textarea makes a person balance braces with no line numbers and no syntax colour.
				CodeSlot: (pField.T === 'code') ? [{ F: pField.F }] : [],
				SelectSlot: (pField.T === 'select') ? [{
					F: pField.F,
					Options: (pField.O || []).map((pO) =>
						({ Value: pO, SelectedAttr: (String(pO) === String(tmpVal)) ? 'selected' : '' }))
				}] : [],
				// A native date picker; the stored value is an ISO string, trimmed to yyyy-mm-dd.
				DateSlot: (pField.T === 'date') ? [{ F: pField.F, Value: (tmpVal ? String(tmpVal).slice(0, 10) : '') }] : [],
				// Likert: a 0-5 segmented row; 0 ('n/a') means unanswered.
				LikertSlot: (pField.T === 'likert') ? [{
					Buttons: [0, 1, 2, 3, 4, 5].map((pN) => (
					{
						F: pField.F, N: pN,
						Label: (pN === 0) ? 'n/a' : String(pN),
						OnClass: ((Number(tmpVal) || 0) === pN) ? ' ps-likert-on' : ''
					}))
				}] : [],
				// A boolean (stored 0/1): a native checkbox. Checked when the stored value is truthy.
				CheckboxSlot: (pField.T === 'checkbox') ? [{ F: pField.F, CheckedAttr: (String(tmpVal) === '1' || tmpVal === 1 || tmpVal === true) ? 'checked' : '' }] : [],
				// A type-or-pick field: a text input backed by a <datalist> of suggestions (today the
				// capability/action values a granted node advertises). Free text still saves, so an action
				// can be named before the node that serves it is connected. _loadComboSources fills the list.
				ComboSlot: (pField.T === 'combo') ? [{ F: pField.F, Value: tmpVal, ListID: 'EntityForm-combo-' + pField.F, Options: this._comboOptions(pField, tmpValues) }] : []
			});
		});
	}

	_enterForm()
	{
		let tmpState = this.pict.AppData.EntityList;
		tmpState.Mode = 'form';
		tmpState.FormFields = this._buildFormFields();
		let tmpDescriptor = this._descriptor() || { Fields: [] };
		this._markdownField = (tmpDescriptor.Fields.find((pF) => pF.Markdown && pF.T === 'textarea') || {}).F || '';
		this._codeField = (tmpDescriptor.Fields.find((pF) => pF.T === 'code') || {}).F || '';
		tmpState.FormClass = (this._markdownField || this._codeField) ? 'ps-form-wide' : '';
		tmpState.ListModeSlot = [];
		tmpState.CreateButtonSlot = [];
		tmpState.TableSlot = [];
		tmpState.EmptySlot = [];
		tmpState.FilterBarSlot = [];
		tmpState.ColumnsSlot = [];
		tmpState.FormSlot = [{}];
		// Back to the centered reading column while the create/edit form is open.
		tmpState.PageClass = 'ps-page';
		this.render();
		// Load any combo-field suggestions (e.g. advertised node capabilities) and fill the datalists.
		this._loadComboSources();
	}

	// Open the create form. pPrefill (optional) seeds it: keys matching descriptor
	// Fields land in the form; every key also rides along in HiddenValues so
	// non-field FKs (IDTestRun, IDKeystoneCustomer) persist through save().
	/**
	 * Open the create form. NAVIGATES; the route handler renders.
	 *
	 * The form used to render in place at the list's own URL, which cost a person real work: a reload
	 * dropped a half-written record with no warning, Back left the whole list screen rather than
	 * closing the form, and "+ New" could not be linked to anyone. It cost the harness too -- because
	 * the URL never changed, asking the router for the list route again re-fired nothing, so a form
	 * left open simply stayed and every later row lookup reported healthy records missing.
	 *
	 * The render lives in _applyNewRecord, which showEntity calls once its data is in. This must NOT
	 * call that path itself and _applyNewRecord must NOT call this one, or the route loops.
	 */
	newRecord(pPrefill)
	{
		let tmpKey = this.pict.AppData.EntityList.Key;
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showEntityNew === 'function')
		{
			// The prefill rides in the stash showEntity already consumes for the create-from-here handoff.
			if (pPrefill) { this.pict.AppData.EntityListPrefill = { Key: tmpKey, Values: pPrefill }; }
			if (tmpApp.showEntityNew(tmpKey)) { return; }
			// No list slug for this entity, so there is no route to go to. Render in place, as before.
			this.pict.AppData.EntityListPrefill = null;
		}
		this._applyNewRecord(pPrefill);
	}

	/** Open the edit form for one record. NAVIGATES; the route handler renders. See newRecord. */
	editRecord(pID)
	{
		let tmpKey = this.pict.AppData.EntityList.Key;
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showEntityEdit === 'function' && tmpApp.showEntityEdit(tmpKey, pID)) { return; }
		this._applyEditRecord(pID);
	}

	_applyNewRecord(pPrefill)
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) return;
		this.pict.AppData.EntityList.EditingID = null;
		this.pict.AppData.EntityList.PendingMedia = [];
		this.pict.AppData.EntityList.FormTitle = 'New ' + libLabels.singular(this.pict, tmpDescriptor.Key, null, tmpDescriptor.Key);
		let tmpValues = {};
		tmpDescriptor.Fields.forEach((pField) =>
		{
			tmpValues[pField.F] = (pField.T === 'select' && pField.O && pField.O.length)
				? pField.O[0]
				: ((pField.T === 'likert' || pField.T === 'checkbox' || pField.E) ? 0 : '');
			if (pPrefill && typeof pPrefill[pField.F] !== 'undefined') { tmpValues[pField.F] = pPrefill[pField.F]; }
		});
		this.pict.AppData.EntityList.FormValues = tmpValues;
		this.pict.AppData.EntityList.HiddenValues = Object.assign({}, pPrefill || {});
		this._enterForm();
	}

	_applyEditRecord(pID)
	{
		let tmpDescriptor = this._descriptor();
		let tmpProvider = this._provider();
		if (!tmpDescriptor || !tmpProvider) return;
		let tmpRow = tmpProvider.store().Index[pID];
		if (!tmpRow)
		{
			// NOT IN THE LOADED PAGE, WHICH IS NOT THE SAME AS NOT EXISTING. Now that the edit form has a
			// URL, it gets opened cold, and a record past the capped list page would silently open
			// nothing at all -- the same gap that made every blueprint past the first page unreachable
			// (WI #415). Ask for it by id, cache it, and carry on. read() resolves null for a record that
			// really is gone, and then this stops.
			if (typeof tmpProvider.read !== 'function') { return; }
			return tmpProvider.read(pID).then((pRecord) =>
			{
				if (!pRecord) { return; }
				tmpProvider.cacheRecord(pRecord);
				return this._applyEditRecord(pID);
			});
		}
		this.pict.AppData.EntityList.EditingID = pID;
		this.pict.AppData.EntityList.PendingMedia = [];
		this.pict.AppData.EntityList.FormTitle = 'Edit ' + libLabels.singular(this.pict, tmpDescriptor.Key, null, tmpDescriptor.Key);
		let tmpValues = {};
		tmpDescriptor.Fields.forEach((pField) =>
		{
			tmpValues[pField.F] = (tmpRow[pField.F] === null || typeof tmpRow[pField.F] === 'undefined')
				? (pField.E ? 0 : '')
				: tmpRow[pField.F];
		});
		this.pict.AppData.EntityList.FormValues = tmpValues;
		this.pict.AppData.EntityList.HiddenValues = {};
		this._enterForm();
	}

	setField(pField, pValue)
	{
		let tmpField = (this._descriptor() || { Fields: [] }).Fields.find((pF) => pF.F === pField);
		// AN ENTITY-BACKED SELECT HOLDS A NUMBER, NOT A STRING. Leaving one unpicked used to put '' in
		// FormValues and post it, and Postgres rejects '' for an integer column outright -- so creating
		// a module without choosing what it is built in came back a 500 with no record saved. SQLite
		// took the empty string without complaint, which is why this only shows up on a real database.
		this.pict.AppData.EntityList.FormValues[pField] = (tmpField && tmpField.E) ? (Number(pValue) || 0) : pValue;
		// If this field controls another field's visibility (HideWhen), rebuild the form so the dependent
		// fields show or hide. Only selects drive this (fired on change), so there is no text focus to lose.
		let tmpDescriptor = this._descriptor() || { Fields: [] };
		if (tmpDescriptor.Fields.some((pF) => pF.HideWhen && pF.HideWhen.Field === pField)) { this._enterForm(); }
		// A combo field that others depend on (Action depends on Capability) refreshes their suggestions
		// in place when it changes -- no re-render, so the text focus the person is typing in is not lost.
		if (tmpDescriptor.Fields.some((pF) => pF.T === 'combo' && pF.DependsOn === pField)) { this._populateComboDatalists(); }
	}

	// ── combo fields (type-or-pick <datalist>) ───────────────────────────────
	// Build the datalist suggestions for a combo field from a fetched source (today only
	// 'NodeCapabilities'). SourceKey picks which column becomes an option (Capability or Action);
	// DependsOn, when set, limits the actions to the capability already chosen.
	_comboOptions(pField, pValues)
	{
		let tmpRows = (this._comboSources && this._comboSources[pField.Source]) || null;
		if (!Array.isArray(tmpRows)) { return []; }
		let tmpKey = pField.SourceKey || 'Capability';
		let tmpDepend = pField.DependsOn ? String((pValues || {})[pField.DependsOn] || '') : '';
		let tmpSeen = {};
		let tmpOut = [];
		tmpRows.forEach((pRow) =>
		{
			if (tmpDepend && String((pRow && pRow.Capability) || '') !== tmpDepend) { return; }
			let tmpValue = String((pRow && pRow[tmpKey]) || '').trim();
			if (tmpValue && !tmpSeen[tmpValue]) { tmpSeen[tmpValue] = true; tmpOut.push({ Value: tmpValue }); }
		});
		return tmpOut;
	}

	// If the open form has any combo field sourced from NodeCapabilities, fetch that list once and fill
	// the datalists in place. The suggestions are a convenience: the inputs are usable text fields before
	// the fetch lands and if it fails, and free text always saves.
	_loadComboSources()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) { return; }
		let tmpNeeds = (tmpDescriptor.Fields || []).some((pF) => pF.T === 'combo' && pF.Source === 'NodeCapabilities');
		if (!tmpNeeds) { return; }
		this._comboSources = this._comboSources || {};
		if (Array.isArray(this._comboSources.NodeCapabilities)) { this._populateComboDatalists(); return; }
		fetch('/1.0/NodeCapabilities', { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
			.then((pResponse) => pResponse.ok ? pResponse.json() : null)
			.then((pJSON) =>
			{
				this._comboSources.NodeCapabilities = (pJSON && Array.isArray(pJSON.Capabilities)) ? pJSON.Capabilities : [];
				this._populateComboDatalists();
			})
			.catch(() => { /* leave the combos as plain text inputs */ });
	}

	// Refill each combo field's <datalist> from the cached source, directly in the DOM, so no render
	// (and no editor remount) is needed. A cheap no-op outside the form or when nothing is cached yet.
	_populateComboDatalists()
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor || this.pict.AppData.EntityList.Mode !== 'form') { return; }
		let tmpValues = this.pict.AppData.EntityList.FormValues || {};
		(tmpDescriptor.Fields || []).forEach((pField) =>
		{
			if (pField.T !== 'combo') { return; }
			let tmpList = document.getElementById('EntityForm-combo-' + pField.F);
			if (!tmpList) { return; }
			tmpList.innerHTML = this._comboOptions(pField, tmpValues)
				.map((pOption) => '<option value="' + this._attr(pOption.Value) + '"></option>').join('');
		});
	}

	// ── code field (pict-section-code) ───────────────────────────────────────
	// A field declared T:'code' is a configuration blob, not prose. The editor gives it line numbers and
	// JSON highlighting so a person maintaining it from the web UI can see an unbalanced brace rather
	// than discovering it later as a node that silently stopped resolving a workspace (WI #456).

	// Called by the editor on every change: pull its content straight into FormValues so the existing
	// save() posts it with no special handling. Exactly what onMarkdownChanged does for prose.
	onCodeChanged()
	{
		if (!this._codeField) { return; }
		let tmpEditor = this.pict.views['Plansheet-FieldCodeEditor'];
		if (!tmpEditor || typeof tmpEditor.getCode !== 'function') { return; }
		this.pict.AppData.EntityList.FormValues[this._codeField] = tmpEditor.getCode();
	}

	// Destroy the editor when the form is left. The list render wipes its host DOM but the view persists,
	// so without this its CodeJar instance stays live against detached nodes. Idempotent.
	_teardownCodeEditor()
	{
		let tmpEditor = this.pict.views['Plansheet-FieldCodeEditor'];
		if (!tmpEditor || !tmpEditor.initialRenderComplete) { return; }
		try { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; }
		catch (pErr) { /* ignore -- teardown is best-effort */ }
	}

	// Mount (or remount) the editor into its host after the form renders, seeded from the field's current
	// FormValues. Mirrors _mountMarkdownEditor, including its fallback: an editor missing from the build
	// must leave a working textarea behind rather than an empty div and an unsavable field.
	_mountCodeEditor()
	{
		if (this.pict.AppData.EntityList.Mode !== 'form' || !this._codeField) { return; }
		let tmpEditor = this.pict.views['Plansheet-FieldCodeEditor'];
		let tmpValue = this.pict.AppData.EntityList.FormValues[this._codeField];
		tmpValue = (tmpValue === null || typeof tmpValue === 'undefined') ? '' : String(tmpValue);
		if (!tmpEditor)
		{
			this.pict.ContentAssignment.assignContent('#EntityForm-CodeHost',
				'<textarea class="ps-input" rows="10" id="EntityForm-CodeFallback"></textarea>');
			let tmpElement = (typeof document !== 'undefined') ? document.getElementById('EntityForm-CodeFallback') : null;
			if (tmpElement) { tmpElement.value = tmpValue; tmpElement.oninput = () => this.setField(this._codeField, tmpElement.value); }
			return;
		}
		this.pict.AppData.FieldCodeEditor = this.pict.AppData.FieldCodeEditor || {};
		this.pict.AppData.FieldCodeEditor.Code = tmpValue;
		try { if (tmpEditor.initialRenderComplete) { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; } } catch (pErr) { /* ignore */ }
		tmpEditor.render();
		if (typeof tmpEditor.marshalToView === 'function') { tmpEditor.marshalToView(); }
	}

	// ── rich markdown field (pict-section-markdowneditor) ────────────────────
	// The record being edited owns pasted media (OwnerType = entity key,
	// IDOwner = the editing id). The create form has no id yet (IDOwner 0), so the
	// editor uploads owned by 0 and registers each one via trackPendingMedia; save()
	// then re-owns them to the new record's id.
	markdownOwnerContext()
	{
		let tmpDescriptor = this._descriptor() || {};
		return { OwnerType: tmpDescriptor.Key || '', IDOwner: this.pict.AppData.EntityList.EditingID || 0 };
	}

	// The editor calls this for every image dropped on the create form (uploaded
	// owned by 0). We remember the id so save() can re-own it, or abandon can drop it.
	trackPendingMedia(pIDMedia)
	{
		if (!pIDMedia) { return; }
		let tmpState = this.pict.AppData.EntityList;
		if (!Array.isArray(tmpState.PendingMedia)) { tmpState.PendingMedia = []; }
		if (tmpState.PendingMedia.indexOf(pIDMedia) < 0) { tmpState.PendingMedia.push(pIDMedia); }
	}

	// After a create, re-own the create-form images to the new record so they show
	// in its gallery. The markdown already links them by /Media/:id/Blob, and the id
	// is stable across the re-own, so the saved Body needs no rewrite. Best-effort:
	// a failed re-own leaves the image linked and displayed, just not in the gallery.
	_reownPendingMedia(pOwnerType, pIDOwner)
	{
		let tmpState = this.pict.AppData.EntityList;
		let tmpPending = Array.isArray(tmpState.PendingMedia) ? tmpState.PendingMedia.slice() : [];
		tmpState.PendingMedia = [];
		let tmpMediaAPI = this.pict.providers.MediaAPI;
		if (!tmpMediaAPI || !pIDOwner || !tmpPending.length) { return; }
		tmpPending.forEach((pIDMedia) =>
		{
			tmpMediaAPI.reassignOwner(pIDMedia, pOwnerType, pIDOwner)
				.catch((pErr) => { if (this.pict && this.pict.log) { this.pict.log.warn('EntityList: could not re-own media ' + pIDMedia + ': ' + (pErr.message || pErr)); } });
		});
	}

	// Leaving the create form without saving: the uploads are orphans (owned by 0,
	// invisible in every gallery), so delete them best-effort. save() clears the
	// pending list before it exits, so a successful save never reaches this.
	_discardPendingMedia()
	{
		let tmpState = this.pict.AppData.EntityList;
		let tmpPending = Array.isArray(tmpState.PendingMedia) ? tmpState.PendingMedia.slice() : [];
		tmpState.PendingMedia = [];
		let tmpMediaAPI = this.pict.providers.MediaAPI;
		if (!tmpMediaAPI || !tmpPending.length) { return; }
		tmpPending.forEach((pIDMedia) =>
		{
			tmpMediaAPI.remove(pIDMedia).catch(() => { /* best-effort orphan cleanup */ });
		});
	}

	// Called by the editor on every change: pull its content straight into
	// FormValues so the existing save() posts it with no special handling.
	onMarkdownChanged()
	{
		if (!this._markdownField) { return; }
		let tmpEditor = this.pict.views['Plansheet-FieldMarkdownEditor'];
		if (!tmpEditor || typeof tmpEditor.getAllContent !== 'function') { return; }
		this.pict.AppData.EntityList.FormValues[this._markdownField] = tmpEditor.getAllContent('\n\n');
	}

	// Destroy the rich editor when we leave the form. _enterList()'s render wipes the editor's host
	// DOM, but the editor view persists (initialRenderComplete stays true, its CodeMirror instances +
	// timers stay live against now-detached nodes). Tear it down so it does not linger; this mirrors
	// the defensive destroy _mountMarkdownEditor does before a re-mount. Idempotent and safe to call
	// on every list entry (a no-op when no editor was rendered).
	_teardownMarkdownEditor()
	{
		let tmpEditor = this.pict.views['Plansheet-FieldMarkdownEditor'];
		if (!tmpEditor || !tmpEditor.initialRenderComplete) { return; }
		try { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; }
		catch (pErr) { /* ignore -- teardown is best-effort */ }
	}

	// Mount (or remount) the rich editor into its host after the form renders,
	// seeded from the field's current FormValues. Mirrors PictView-DocEditor.
	_mountMarkdownEditor()
	{
		if (this.pict.AppData.EntityList.Mode !== 'form' || !this._markdownField) { return; }
		let tmpEditor = this.pict.views['Plansheet-FieldMarkdownEditor'];
		let tmpVal = this.pict.AppData.EntityList.FormValues[this._markdownField];
		tmpVal = (tmpVal === null || typeof tmpVal === 'undefined') ? '' : String(tmpVal);
		if (!tmpEditor)
		{
			// The editor is not in this build: fall back to a plain textarea so the field still works.
			this.pict.ContentAssignment.assignContent('#EntityForm-MarkdownHost',
				'<textarea class="ps-input" rows="6" id="EntityForm-MarkdownFallback"></textarea>');
			let tmpEl = (typeof document !== 'undefined') ? document.getElementById('EntityForm-MarkdownFallback') : null;
			if (tmpEl) { tmpEl.value = tmpVal; tmpEl.oninput = () => this.setField(this._markdownField, tmpEl.value); }
			return;
		}
		this.pict.AppData.FieldMarkdownEditor = this.pict.AppData.FieldMarkdownEditor || {};
		this.pict.AppData.FieldMarkdownEditor.Segments = [{ Content: tmpVal }];
		try { if (tmpEditor.initialRenderComplete) { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; } } catch (pErr) { /* ignore */ }
		tmpEditor.render();
		tmpEditor.marshalToView();
		if (typeof tmpEditor.setPreviewMode === 'function') { tmpEditor.setPreviewMode('bottom'); }
	}

	setLikert(pField, pValue)
	{
		this.pict.AppData.EntityList.FormValues[pField] = Number(pValue) || 0;
		// Re-render the form so the selected segment lights up (a button click,
		// so there is no input focus to lose).
		this._enterForm();
	}

	/**
	 * Leave the form the way a person expects: back to the list, and with the URL agreeing.
	 *
	 * Deliberately the LIST and not the record just edited. That is exactly what closing the form has
	 * always put on screen, so this fixes the address bar without moving anything under anyone. Landing
	 * on the record instead would be defensible, but it is a change to where the product takes you and
	 * belongs in its own decision, not smuggled in with a routing fix.
	 *
	 * _enterList stays the fallback for an entity with no list route of its own.
	 */
	_leaveForm()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showEntityAfterForm === 'function'
			&& tmpApp.showEntityAfterForm(this.pict.AppData.EntityList.Key, 0)) { return; }
		this._enterList();
	}

	cancel() { this._leaveForm(); }

	open(pID)
	{
		let tmpDescriptor = this._descriptor();
		let tmpApp = this.pict.PictApplication;
		// A descriptor can route "Open" somewhere other than the generic CRUD
		// detail (Session hands the row to the transformer viewer via
		// openServerSession).
		if (tmpDescriptor && tmpDescriptor.OpenAction && tmpApp && typeof tmpApp[tmpDescriptor.OpenAction] === 'function')
		{
			return tmpApp[tmpDescriptor.OpenAction](pID);
		}
		if (tmpApp && typeof tmpApp.showEntityDetail === 'function')
		{
			tmpApp.showEntityDetail(this.pict.AppData.EntityList.Key, pID);
		}
	}

	save()
	{
		let tmpDescriptor = this._descriptor();
		let tmpProvider = this._provider();
		if (!tmpDescriptor || !tmpProvider) return;
		// Flush the rich markdown editor's current content into FormValues before posting.
		this.onMarkdownChanged();
		let tmpValues = this.pict.AppData.EntityList.FormValues || {};

		let tmpTitleField = tmpDescriptor.TitleField;
		if (!tmpValues[tmpTitleField] || !String(tmpValues[tmpTitleField]).trim())
		{
			return this._toast(tmpTitleField + ' is required.', 'error');
		}

		// Hidden prefill values (FKs from a create-from-here handoff) ride along;
		// form fields win on any key both carry.
		let tmpRecord = Object.assign({}, this.pict.AppData.EntityList.HiddenValues || {});
		tmpDescriptor.Fields.forEach((pField) =>
		{
			let tmpValue = tmpValues[pField.F];
			let tmpEmpty = (tmpValue === null || typeof tmpValue === 'undefined' || tmpValue === '');
			// A date input nobody filled in reads back as '', and '' is not a timestamp: Postgres rejects it
			// (22007 invalid input syntax) where SQLite quietly stores it. So a blank date saves against a local
			// SQLite dev database and fails against every deployed Postgres one. A date nobody set is null; ''
			// stays correct for text, textarea, and select.
			if (pField.T === 'date') { tmpRecord[pField.F] = tmpEmpty ? null : tmpValue; }
			else { tmpRecord[pField.F] = tmpEmpty ? '' : tmpValue; }
		});

		let tmpEditingID = this.pict.AppData.EntityList.EditingID;
		let tmpPromise = tmpEditingID
			? tmpProvider.update(tmpEditingID, tmpRecord)
			: tmpProvider.create(tmpRecord);

		tmpPromise
			.then((pSaved) =>
			{
				// A create returns the new record; re-own any create-form images to it so
				// they surface in the entity's gallery (edit-form images are already owned).
				if (!tmpEditingID && pSaved && pSaved[tmpDescriptor.IDField])
				{
					this._reownPendingMedia(tmpDescriptor.Key, pSaved[tmpDescriptor.IDField]);
				}
				// The record is saved. Announce it now, before the list refresh, so a refresh
				// hiccup can never turn a successful save into a "Save failed" message.
				this._toast(tmpDescriptor.Key + ' saved.', 'success');
				// Refresh the list, but treat a refresh failure as non-fatal -- the record is already
				// persisted -- so we still return to the list (rendered from cache) rather than
				// stranding the user on a blank screen after a successful create.
				return this._fetchPage(this.pict.AppData.EntityList.Page).catch((pErr) =>
				{
					if (this.pict && this.pict.log) { this.pict.log.warn('EntityList: post-save list refresh failed (' + ((pErr && pErr.message) || pErr) + '); returning to list from cache.'); }
				});
			})
			.then(() => this._leaveForm())
			.catch((pErr) => this._toast('Save failed: ' + (pErr.message || pErr), 'error'));
	}

	removeRecord(pID)
	{
		let tmpDescriptor = this._descriptor();
		if (!tmpDescriptor) return;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () => this._doRemove(pID);
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Delete this ' + tmpDescriptor.Key + '?', { dangerous: true })
				.then((pOk) => { if (pOk) tmpDo(); });
		}
		else
		{
			tmpDo();
		}
	}

	_doRemove(pID)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return;
		tmpProvider.remove(pID)
			.then(() => this._fetchPage(this.pict.AppData.EntityList.Page))
			.then(() => { this._toast('Deleted.', 'success'); this._enterList(); })
			.catch((pErr) => this._toast('Delete failed: ' + (pErr.message || pErr), 'error'));
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 3000 });
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._mountMarkdownEditor();
		this._mountCodeEditor();
		this._populateComboDatalists();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewEntityList;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-EntityList',
	DefaultRenderable: 'EntityList-Display',
	AutoRender: false,
	CSS: /*css*/`
		/* root container styling comes from .ps-page (Shell) */
		.ps-list-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
		.ps-list-foot { display: flex; align-items: center; gap: 12px; justify-content: center; margin: 14px 0 4px; }
		.ps-list-foot-count { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); }
		/* Real pages, not a Load more (WI #433). The page label is centered between the two pairs of
		   controls, and the disabled ends stay in place rather than collapsing, so the buttons do not
		   move under the cursor as you walk a list. */
		.ps-pager { display: flex; align-items: center; gap: 6px; }
		.ps-pager-page { font-size: 13px; padding: 0 6px; white-space: nowrap; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-pager .ps-btn[disabled] { opacity: 0.45; cursor: default; }
		.ps-empty-actions { margin-top: 12px; }
		.ps-list-head h2 { font-size: 22px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; }
		.ps-list-head-actions { display: flex; align-items: center; gap: 8px; }
		/* The "Columns" show/hide picker: a button that opens a floating checkbox panel. */
		.ps-colmenu { position: relative; }
		.ps-colmenu > summary { list-style: none; cursor: pointer; }
		.ps-colmenu > summary::-webkit-details-marker { display: none; }
		.ps-colmenu-panel {
			position: absolute; right: 0; top: calc(100% + 6px); z-index: 30;
			min-width: 190px; padding: 8px; display: flex; flex-direction: column; gap: 2px;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px;
			box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
		}
		.ps-colmenu-item {
			display: flex; align-items: center; gap: 8px; padding: 4px 6px; border-radius: 6px;
			font-size: 13px; color: var(--theme-color-text-primary, #2c3140); cursor: pointer; white-space: nowrap;
		}
		.ps-colmenu-item:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.ps-colmenu-item input { cursor: pointer; }
		.ps-colmenu-item input:disabled { cursor: default; }
		.ps-btn {
			padding: 7px 14px; border: 1px solid var(--theme-color-border-default, #d8dde6);
			background: var(--theme-color-background-panel, #fff); border-radius: 8px;
			color: var(--theme-color-text-primary, #2c3140); cursor: pointer; font-size: 14px;
		}
		.ps-btn:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.ps-btn-primary { background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff); border-color: transparent; }
		.ps-btn-primary:hover { filter: brightness(1.05); background: var(--theme-color-brand-primary, #2988df); }
		.ps-btn-sm { padding: 4px 10px; font-size: 13px; }
		.ps-btn-danger { color: var(--theme-color-status-danger, #c0392b); }
		/* Focus-view filter bar */
		.ps-filterbar { display: flex; flex-direction: column; gap: 8px; margin-bottom: 14px; }
		.ps-filter-row { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
		.ps-filter-search {
			flex: 1 1 240px; min-width: 180px; padding: 7px 10px; font-size: 14px; font-family: inherit;
			border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px;
			background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #2c3140);
		}
		.ps-filter-search:focus { outline: 2px solid var(--theme-color-brand-primary, #2988df); outline-offset: -1px; }
		.ps-filter-select {
			padding: 6px 8px; font-size: 13px; border-radius: 8px; max-width: 220px;
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140);
		}
		.ps-filter-views { font-weight: 600; }
		.ps-filter-spacer { flex: 1 1 auto; min-width: 4px; }
		.ps-filter-count { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); white-space: nowrap; }
		.ps-chip-row { display: flex; flex-wrap: wrap; gap: 6px; }
		.ps-chip-row:empty { display: none; }
		.ps-chip {
			padding: 3px 11px; font-size: 12px; border-radius: 999px; cursor: pointer;
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376);
		}
		.ps-chip:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.ps-chip-on, .ps-chip-on:hover { background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff); border-color: transparent; }
		/* The list can carry many columns (WorkItem: #, Title, Type, Status, Priority, Assignee,
		   Target, Sessions, Updated, Actions). When they exceed the content width, scroll the
		   table inside its own container rather than letting the rightmost columns clip off. */
		.ps-table-scroll { overflow-x: auto; border-radius: 10px; background: var(--theme-color-background-panel, #fff); }
			/* No overflow:hidden here, deliberately. It clipped the rounded corners, but it also silently
		   killed position:sticky on the mark cell: a sticky cell stops sticking the moment an ancestor
		   between it and the scrollport has a non-visible overflow, and it fails by simply scrolling
		   away rather than reporting anything. The .ps-table-scroll wrapper carries the same radius
		   and its own overflow, so the corners still clip. */
		.ps-table { width: 100%; border-collapse: collapse; background: var(--theme-color-background-panel, #fff); border-radius: 10px; }
		.ps-table th, .ps-table td { text-align: left; padding: 10px 14px; border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee); font-size: 14px; white-space: nowrap; }
			/* Dates, counts, and badges stay on one line (never break mid-token).
			   The data cells shrink to their content (width:1px) so the surplus
			   width lands in the title/name column, which absorbs it and wraps
			   there instead of forcing odd breaks elsewhere. */
			.ps-table td { width: 1px; }
			.ps-table td.ps-cell-wrap { white-space: normal; width: 100%; min-width: 20rem; }
		.ps-table th { font-size: 12px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-table tr:last-child td { border-bottom: none; }
		/* The whole body row is a click target that opens the record (#236). A pointer + a hover
		   wash advertise it; the actions cell keeps the default cursor since its buttons act. */
		.ps-table tbody tr.ps-row-open { cursor: pointer; }
		.ps-table tbody tr.ps-row-open:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.ps-table tbody tr.ps-row-open .ps-row-actions { cursor: default; }
		/* Inline-block (not flex) so the cell sizes to its buttons under the
		   width:1px shrink rule above; a flex cell collapses there. */
		.ps-row-actions { white-space: nowrap; text-align: right; }
		.ps-row-actions .ps-btn { display: inline-block; vertical-align: middle; }
		.ps-row-actions .ps-btn + .ps-btn { margin-left: 6px; }
		/* Addressed feedback reads as done: dim its content cells (never the actions, so
		   Reopen stays crisp) and give the Address / Reopen quick action a distinct tint. */
		.ps-row-addressed td:not(.ps-row-actions) { opacity: 0.5; }
		.ps-btn-address { color: var(--theme-color-brand-primary, #2988df); border-color: var(--theme-color-brand-primary, #2988df); }
		.ps-btn-reopen { color: var(--theme-color-text-secondary, #5b6376); }
		.ps-filter-addressed { font-weight: 600; }
		.ps-empty { text-align: center; padding: 48px 24px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-form { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 10px; padding: 20px; max-width: 620px; }
			.ps-form-wide { max-width: 940px; }
			.ps-md-host { min-height: 360px; display: flex; flex-direction: column; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; overflow: hidden; }
			.ps-md-host > * { flex: 1 1 auto; min-width: 0; }
		.ps-form h3 { margin: 0 0 16px; color: var(--theme-color-text-primary, #2c3140); }
		.ps-field { margin-bottom: 14px; display: flex; flex-direction: column; gap: 6px; }
		.ps-field label { font-size: 13px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-input {
			padding: 8px 10px; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px; font-size: 14px; font-family: inherit;
			background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #2c3140);
		}
		.ps-input:focus { outline: 2px solid var(--theme-color-brand-primary, #2988df); outline-offset: -1px; }
		.ps-form-actions { display: flex; gap: 8px; margin-top: 18px; }
		.ps-cell-badge {
			display: inline-block; padding: 2px 10px; border-radius: 999px; font-size: 12px;
			background: var(--theme-color-background-secondary, #eef1f6);
			color: var(--theme-color-text-secondary, #5b6376);
			border: 1px solid var(--theme-color-border-default, #e6e9ee); white-space: nowrap;
		}
		/* Assignee cell: an avatar + name. A human gets a round, name-colored initials disc;
		   an AI agent gets the violet hexagon (Vision #36's "AI as a first-class assignee"). */
		.ps-assignee { display: inline-flex; align-items: center; gap: 7px; white-space: nowrap; }
		.ps-avatar {
			flex: 0 0 auto; width: 24px; height: 24px; border-radius: 50%;
			display: inline-flex; align-items: center; justify-content: center;
			font-size: 10px; font-weight: 700; letter-spacing: 0.02em; color: #fff;
			background: var(--theme-color-text-secondary, #5b6376);
		}
		.ps-avatar svg { width: 14px; height: 14px; }
		/* The AI-agent hexagon: a six-sided violet badge, no border-radius (the clip makes the shape). */
		.ps-avatar-agent {
			border-radius: 0; color: #fff;
			background: var(--theme-color-brand-secondary, #7a5cd0);
			clip-path: polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%);
		}
		.ps-assignee-name { font-size: 13px; color: var(--theme-color-text-primary, #2c3140); }
		.ps-assignee-agent { color: var(--theme-color-brand-secondary, #7a5cd0); font-weight: 600; }
		/* Unassigned reads as a muted hollow disc + label, so the gap is legible not blank. */
		.ps-assignee-none .ps-avatar { background: transparent; border: 1px dashed var(--theme-color-border-default, #c3cad6); }
		.ps-assignee-none .ps-assignee-name { color: var(--theme-color-text-secondary, #8a94a6); font-style: italic; }
		/* Target cell: a type chip + the target's name. */
		.ps-target { display: inline-flex; align-items: center; gap: 7px; white-space: nowrap; }
		.ps-target-type {
			font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;
			padding: 1px 6px; border-radius: 4px; color: #fff; background: var(--theme-color-text-secondary, #5b6376);
		}
		.ps-target-vision { background: #5a7fce; }
		.ps-target-module { background: #4aa3a3; }
		.ps-target-feature { background: #c9922f; }
		.ps-target-label { font-size: 13px; color: var(--theme-color-text-primary, #2c3140); max-width: 16rem; overflow: hidden; text-overflow: ellipsis; }
		/* Sessions cell: a robot glyph + count marking an auditable, session-backed work item. */
		.ps-sessions { display: inline-flex; align-items: center; gap: 4px; color: var(--theme-color-brand-secondary, #7a5cd0); }
		.ps-sessions svg { width: 15px; height: 15px; }
		.ps-sessions-count { font-size: 12px; font-weight: 600; }
		/* Type icon cell: a compact glyph standing in for a short enum (WorkItem Type, Feedback
		   Source). Compact density spends an icon's width instead of a word's, with the name in the
		   tooltip; expanded density draws the word beside the glyph (the gap only shows then). */
		.ps-type-icon { display: inline-flex; align-items: center; gap: 6px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-type-icon svg { width: 17px; height: 17px; }
		.ps-type-icon-label { font-size: 13px; white-space: nowrap; color: var(--theme-color-text-primary, #2c3140); }
		/* Compact/expanded density toggle: a small two-segment control by the Columns menu. */
		.ps-density { display: inline-flex; align-items: stretch; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; overflow: hidden; }
		.ps-density-btn { border: 0; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); padding: 4px 10px; font-size: 13px; cursor: pointer; }
		.ps-density-btn + .ps-density-btn { border-left: 1px solid var(--theme-color-border-default, #d8dde6); }
		.ps-density-btn:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.ps-density-on, .ps-density-on:hover { background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff); }
		.ps-likert { display: flex; gap: 6px; }
		.ps-likert-btn { min-width: 38px; text-align: center; }
		.ps-likert-on, .ps-likert-on:hover { background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff); border-color: transparent; }
		/* The mark cell: the row's designator (WI-014), and the column the eye comes back to. It
		   stays put while the table scrolls sideways, so a wide table never costs you the identity
		   of the row you are reading. Only this one column is sticky: the data cells are content
		   sized (width:1px above), so a second sticky column would need a left offset nobody can
		   compute. It needs its own background, since a sticky cell would otherwise be transparent
		   and the scrolled content would run underneath it. */
		.ps-table td.ps-cell-mark, .ps-table th.ps-th-mark {
			position: sticky; left: 0; z-index: 1;
			background: var(--theme-color-background-panel, #fff);
		}
		.ps-table tbody tr.ps-row-open:hover td.ps-cell-mark { background: var(--theme-color-background-hover, #eaf2ff); }
		/* Actions: two glyphs, not three labelled buttons. The row click opens the record, so the
		   column only carries what the row itself cannot do. Delete still routes through the confirm
		   modal, so the smaller target is strictly safer than the labelled button it replaces. */
		.ps-th-actions { width: 1px; }
		.ps-iconbtn {
			display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;
			width: 26px; height: 26px; padding: 0; cursor: pointer; border-radius: 6px;
			border: 1px solid transparent; background: transparent;
			color: var(--theme-color-text-secondary, #5b6376);
		}
		.ps-iconbtn svg { width: 15px; height: 15px; }
		.ps-iconbtn:hover { background: var(--theme-color-background-hover, #eaf2ff); border-color: var(--theme-color-border-default, #d8dde6); }
		.ps-iconbtn-danger:hover { color: var(--theme-color-status-danger, #c0392b); }
		.ps-row-actions .ps-iconbtn + .ps-iconbtn { margin-left: 2px; }
		/* Concise mode: the scan. Same table, tighter rows, so roughly twice as many land on a
		   screen. The title column stops wrapping here, because a row that can grow to three lines
		   defeats the point of counting rows per screen. */
		.ps-table-concise th, .ps-table-concise td { padding: 3px 10px; font-size: 13px; }
		/* The title truncates here rather than growing the table. nowrap on its own made the cell as
		   wide as its longest title, which pushed the whole table past its container and gave the
		   concise scan the one thing it exists to avoid: a sideways scrollbar. max-width:0 with
		   width:100% is the table-layout idiom that makes a cell take the leftover width and ellipsis
		   the rest; the full title is on the row's tooltip and in table mode. */
		.ps-table-concise td.ps-cell-wrap { white-space: nowrap; min-width: 16rem; max-width: 0;
			overflow: hidden; text-overflow: ellipsis; }
		.ps-table-concise .ps-iconbtn { width: 22px; height: 22px; }
		.ps-table-concise .ps-avatar { width: 19px; height: 19px; font-size: 9px; }
		/* The concise column strip: which columns are on, and one click to pull another in. */
		.ps-pinbar { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin-bottom: 10px; }
		.ps-pinbar-label {
			font-size: 10px; letter-spacing: 0.13em; text-transform: uppercase;
			color: var(--theme-color-text-muted, #6c6a60); margin-right: 2px;
		}
		.ps-pin {
			padding: 2px 9px; font-size: 11.5px; font-family: inherit; cursor: pointer; border-radius: 999px;
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-secondary, #5b6376);
		}
		.ps-pin:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.ps-pin-on {
			border-color: var(--theme-color-brand-primary, #2988df);
			color: var(--theme-color-brand-primary, #2988df);
			font-weight: 600;
		}
	` + libMarkup.MarkupCSS,
	Templates:
	[
		...libMarkup.MarkupTemplates,
		{
			Hash: 'EntityList-Display',
			Template: /*html*/`
<div class="{~D:AppData.EntityList.PageClass~} ps-list">
	<div class="ps-list-head">
		<h2>{~D:AppData.EntityList.Title~}</h2>
		<div class="ps-list-head-actions">{~TS:EntityList-ViewMode:AppData.EntityList.ViewModeSlot~}{~TS:EntityList-ColumnsMenu:AppData.EntityList.ColumnsSlot~}{~TS:EntityList-NewBtn:AppData.EntityList.ListModeSlot~}{~TS:EntityList-UploadBtn:AppData.EntityList.CreateButtonSlot~}</div>
	</div>
	{~TS:EntityList-FilterBar:AppData.EntityList.FilterBarSlot~}
	{~TS:EntityList-PinBar:AppData.EntityList.PinSlot~}
	<div id="EntityList-Body">{~TS:EntityList-Table:AppData.EntityList.TableSlot~}{~TS:EntityList-Empty:AppData.EntityList.EmptySlot~}</div>
	<div id="EntityList-Foot">{~TS:EntityList-PageFoot:AppData.EntityList.PageFootSlot~}</div>
	{~TS:EntityList-Form:AppData.EntityList.FormSlot~}
</div>`
		},
		{ Hash: 'EntityList-NewBtn', Template: /*html*/`<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityList'].newRecord()">+ New</button>` },
		{ Hash: 'EntityList-UploadBtn', Template: /*html*/`<button class="ps-btn ps-btn-primary" onclick="_Pict.PictApplication['{~D:Record.Action~}']()">{~D:Record.Label~}</button>` },
		{ Hash: 'EntityList-ColumnsMenu', Template: /*html*/`<details class="ps-colmenu"><summary class="ps-btn ps-btn-sm">Columns</summary><div class="ps-colmenu-panel">{~TS:EntityList-ColOption:Record.Columns~}</div></details>` },
		// The mode toggle: the concise scan against the full table. Titles spell out what each one
		// does for a first-time user, since the difference is a column count, not a font size.
		{ Hash: 'EntityList-ViewMode', Template: /*html*/`<div class="ps-density" role="group" aria-label="List mode"><button type="button" class="ps-density-btn{~D:Record.ConciseOnClass~}" title="Concise: the mark, the name, and the key columns" onclick="_Pict.views['Plansheet-EntityList'].setViewMode('concise')">Concise</button><button type="button" class="ps-density-btn{~D:Record.TableOnClass~}" title="Table: every column" onclick="_Pict.views['Plansheet-EntityList'].setViewMode('table')">Table</button></div>` },
		{ Hash: 'EntityList-ColOption', Template: /*html*/`<label class="ps-colmenu-item"><input type="checkbox" {~D:Record.CheckedAttr~} {~D:Record.DisabledAttr~} onchange="_Pict.views['Plansheet-EntityList'].toggleColumn('{~D:Record.F~}')"><span>{~D:Record.L~}</span></label>` },
		// The concise column strip: the same per-mode visibility the dropdown edits, laid out so
		// pulling a column in to cross-reference something is one click and the options are visible.
		{
			Hash: 'EntityList-PinBar',
			Template: /*html*/`<div class="ps-pinbar"><span class="ps-pinbar-label">Columns</span>{~TS:EntityList-Pin:Record.Pins~}</div>`
		},
		{ Hash: 'EntityList-Pin', Template: /*html*/`<button type="button" class="ps-pin{~D:Record.OnClass~}" onclick="_Pict.views['Plansheet-EntityList'].toggleColumn('{~D:Record.F~}')">{~D:Record.PinLabel~}</button>` },
		{
			Hash: 'EntityList-FilterBar',
			Template: /*html*/`
<div class="ps-filterbar">
	<div class="ps-filter-row">
		{~TS:EntityList-Filter-Search:Record.SearchSlot~}
		{~TS:EntityList-Filter-Addressed:Record.AddressedSlot~}
		{~TS:EntityList-Filter-Customer:Record.CustomerSlot~}
		{~TS:EntityList-Filter-SourceType:Record.SourceTypeSlot~}
		{~TS:EntityList-Filter-Views:Record.ViewSlot~}
		{~TS:EntityList-Filter-Type:Record.TypeSlot~}
		{~TS:EntityList-Filter-Priority:Record.PrioritySlot~}
		{~TS:EntityList-Filter-Assignee:Record.AssigneeSlot~}
		{~TS:EntityList-Filter-Target:Record.TargetSlot~}
		{~TS:EntityList-Filter-WorkflowStatus:Record.WorkflowStatusSlot~}
		{~TS:EntityList-Filter-Recent:Record.RecentSlot~}
		{~TS:EntityList-Filter-Save:Record.ViewSlot~}
		{~TS:EntityList-Filter-DeleteView:Record.DeleteViewSlot~}
		{~TS:EntityList-Filter-SetDefault:Record.SetDefaultSlot~}
		{~TS:EntityList-Filter-ClearDefault:Record.ClearDefaultSlot~}
		{~TS:EntityList-Filter-Clear:Record.ClearSlot~}
		<span class="ps-filter-spacer"></span>
		<span class="ps-filter-count" id="EntityList-Count">{~D:Record.CountLabel~}</span>
	</div>
	<div class="ps-chip-row">{~TS:EntityList-Chip:Record.StatusChips~}</div>
</div>`
		},
		{ Hash: 'EntityList-Filter-Search', Template: /*html*/`<input type="search" class="ps-filter-search" placeholder="Search..." value="{~D:Record.Value~}" oninput="_Pict.views['Plansheet-EntityList'].setSearch(this.value)">` },
		{ Hash: 'EntityList-Filter-Views', Template: /*html*/`<select class="ps-filter-select ps-filter-views" onchange="_Pict.views['Plansheet-EntityList'].applyView(this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Type', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('type', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Priority', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('priority', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Assignee', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('assignee', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Target', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('target', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-WorkflowStatus', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('wfstatus', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Recent', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('recent', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Addressed', Template: /*html*/`<select class="ps-filter-select ps-filter-addressed" onchange="_Pict.views['Plansheet-EntityList'].setFilter('addressed', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Customer', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('customer', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-SourceType', Template: /*html*/`<select class="ps-filter-select" onchange="_Pict.views['Plansheet-EntityList'].setFilter('sourcetype', this.value)">{~TS:EntityList-Filter-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Filter-Option', Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>` },
		{ Hash: 'EntityList-Filter-Save', Template: /*html*/`<button class="ps-btn ps-btn-sm" onclick="_Pict.views['Plansheet-EntityList'].saveView()">Save view</button>` },
		{ Hash: 'EntityList-Filter-SetDefault', Template: /*html*/`<button class="ps-btn ps-btn-sm" title="Make the current filters your default for this screen" onclick="_Pict.views['Plansheet-EntityList'].setAsDefault()">Set as default</button>` },
		{ Hash: 'EntityList-Filter-ClearDefault', Template: /*html*/`<button class="ps-btn ps-btn-sm" title="Remove your saved default; revert to the standard default" onclick="_Pict.views['Plansheet-EntityList'].clearDefault()">Clear default</button>` },
		{ Hash: 'EntityList-Filter-DeleteView', Template: /*html*/`<button class="ps-btn ps-btn-sm ps-btn-danger" onclick="_Pict.views['Plansheet-EntityList'].deleteView('{~D:Record.Key~}')">Delete view</button>` },
		{ Hash: 'EntityList-Filter-Clear', Template: /*html*/`<button class="ps-btn ps-btn-sm" onclick="_Pict.views['Plansheet-EntityList'].clearFilters()">Clear</button>` },
		{ Hash: 'EntityList-Chip', Template: /*html*/`<button class="ps-chip{~D:Record.OnClass~}" onclick="_Pict.views['Plansheet-EntityList'].toggleStatus('{~D:Record.Key~}')">{~D:Record.Label~}</button>` },
		{
			Hash: 'EntityList-Table',
			Template: /*html*/`
<div class="ps-table-scroll">
<table class="ps-table{~D:AppData.EntityList.TableClass~}">
	<thead><tr id="EntityList-HeadRow">{~TS:EntityList-Th:AppData.EntityList.HeaderCells~}<th class="ps-th-actions"></th></tr></thead>
	<tbody id="EntityList-Tbody">{~TS:EntityList-Row:AppData.EntityList.Rows~}</tbody>
</table>
</div>`
		},
		{
			Hash: 'EntityList-PageFoot',
			Template: /*html*/`<div class="ps-list-foot"><span class="ps-list-foot-count">{~D:Record.RangeLabel~}</span><nav class="ps-pager" aria-label="Pages"><button class="ps-btn ps-btn-sm" {~D:Record.FirstDisabled~} title="First page" onclick="_Pict.views['Plansheet-EntityList'].goToPage(1)">&laquo; First</button><button class="ps-btn ps-btn-sm" {~D:Record.PrevDisabled~} title="Previous page" onclick="_Pict.views['Plansheet-EntityList'].goToPage({~D:Record.PrevPage~})">&lsaquo; Prev</button><span class="ps-pager-page">{~D:Record.PageLabel~}</span><button class="ps-btn ps-btn-sm" {~D:Record.NextDisabled~} title="Next page" onclick="_Pict.views['Plansheet-EntityList'].goToPage({~D:Record.NextPage~})">Next &rsaquo;</button><button class="ps-btn ps-btn-sm" {~D:Record.LastDisabled~} title="Last page" onclick="_Pict.views['Plansheet-EntityList'].goToPage({~D:Record.LastPage~})">Last &raquo;</button></nav></div>`
		},
		{ Hash: 'EntityList-Th', Template: /*html*/`<th class="ps-th-sort{~D:Record.ThClass~}" style="cursor:pointer;user-select:none;white-space:nowrap" onclick="_Pict.views['Plansheet-EntityList'].sortBy({~D:Record.Index~})">{~D:Record.Label~}{~D:Record.Caret~}</th>` },
		{
			Hash: 'EntityList-Row',
			// The whole row opens the record (#236), in both modes, so an explicit "Open" button was
			// only ever repeating the row click. Dropping it and reducing Edit / Delete to glyphs
			// takes the actions cell from 257px to roughly a quarter of that, on every row of every
			// list; that column was 22% of the Work Items table and 28% of the Features table, and it
			// was what scrolled off the right edge when the table outgrew its container.
			//
			// The Address / Reopen quick action stays a labelled button: clearing a feedback backlog
			// from the list without opening anything is the whole point of it (#201).
			//
			// The actions cell stops the click from bubbling so its buttons still do their own thing.
			Template: /*html*/`<tr class="ps-row-open {~D:Record.RowClass~}" onclick="_Pict.views['Plansheet-EntityList'].open({~D:Record.ID~})">{~TS:EntityList-Cell:Record.Cells~}<td class="ps-row-actions" onclick="event.stopPropagation()">{~TS:EntityList-AddressBtn:Record.AddressSlot~}<button class="ps-iconbtn" title="Edit" aria-label="Edit" onclick="_Pict.views['Plansheet-EntityList'].editRecord({~D:Record.ID~})">{~I:Edit~}</button><button class="ps-iconbtn ps-iconbtn-danger" title="Delete" aria-label="Delete" onclick="_Pict.views['Plansheet-EntityList'].removeRecord({~D:Record.ID~})">{~I:Trash~}</button></td></tr>`
		},
		{ Hash: 'EntityList-AddressBtn', Template: /*html*/`<button class="ps-btn ps-btn-sm{~D:Record.OnClass~}" onclick="_Pict.views['Plansheet-EntityList'].toggleAddressed({~D:Record.ID~})">{~D:Record.Label~}</button>` },
		{ Hash: 'EntityList-Cell', Template: /*html*/`<td class="{~D:Record.CellClass~}" {~D:Record.TitleAttr~}>{~TS:EntityList-CellPlain:Record.PlainSlot~}{~TS:EntityList-CellBadge:Record.BadgeSlot~}{~TS:EntityList-CellAssignee:Record.AssigneeSlot~}{~TS:EntityList-CellTarget:Record.TargetSlot~}{~TS:EntityList-CellSession:Record.SessionSlot~}{~TS:EntityList-CellIcon:Record.IconSlot~}{~TS:Markup-Designator:Record.MarkSlot~}</td>` },
		{ Hash: 'EntityList-CellIcon', Template: /*html*/`<span class="ps-type-icon" title="{~D:Record.Title~}">{~D:Record.Html~}{~TS:EntityList-CellIconLabel:Record.LabelSlot~}</span>` },
		{ Hash: 'EntityList-CellIconLabel', Template: /*html*/`<span class="ps-type-icon-label">{~D:Record.Text~}</span>` },
		{ Hash: 'EntityList-CellPlain', Template: /*html*/`{~D:Record.Value~}` },
		{ Hash: 'EntityList-CellBadge', Template: /*html*/`<span class="ps-cell-badge" {~D:Record.StyleAttr~}>{~D:Record.Value~}</span>` },
		// Assignee: a round initials avatar (human) or a violet hexagon with a robot glyph (AI),
		// then the name. The agent hexagon is a clip-path shape; the human avatar is a circle.
		{ Hash: 'EntityList-CellAssignee', Template: /*html*/`<span class="ps-assignee{~D:Record.RowClass~}"><span class="ps-avatar{~D:Record.AvatarClass~}" {~D:Record.AvatarStyle~}>{~D:Record.Initials~}{~TS:EntityList-AgentGlyph:Record.AssigneeAgentSlot~}</span><span class="ps-assignee-name{~D:Record.NameClass~}">{~D:Record.Name~}</span></span>` },
		{ Hash: 'EntityList-CellTarget', Template: /*html*/`<span class="ps-target"><span class="ps-target-type{~D:Record.TypeClass~}">{~D:Record.Type~}</span><span class="ps-target-label">{~D:Record.Label~}</span></span>` },
		{ Hash: 'EntityList-CellSession', Template: /*html*/`<span class="ps-sessions" title="{~D:Record.Title~}">{~I:Robot~}<span class="ps-sessions-count">{~D:Record.Count~}</span></span>` },
		{ Hash: 'EntityList-AgentGlyph', Template: /*html*/`{~I:Robot~}` },
		{ Hash: 'EntityList-Empty', Template: /*html*/`<div class="ps-empty">{~D:AppData.EntityList.EmptyText~}{~TS:EntityList-EmptyClear:AppData.EntityList.EmptyFilteredSlot~}</div>` },
		{ Hash: 'EntityList-EmptyClear', Template: /*html*/`<div class="ps-empty-actions"><button class="ps-btn ps-btn-sm" onclick="_Pict.views['Plansheet-EntityList'].clearFilters()">Clear filters</button></div>` },
		{
			Hash: 'EntityList-Form',
			Template: /*html*/`
<div class="ps-form {~D:AppData.EntityList.FormClass~}">
	<h3>{~D:AppData.EntityList.FormTitle~}</h3>
	{~TS:EntityList-Field:AppData.EntityList.FormFields~}
	<div class="ps-form-actions">
		<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-EntityList'].save()">Save</button>
		<button class="ps-btn" onclick="_Pict.views['Plansheet-EntityList'].cancel()">Cancel</button>
	</div>
</div>`
		},
		{
			Hash: 'EntityList-Field',
			Template: /*html*/`
<div class="ps-field">
	<label>{~D:Record.L~}</label>
	{~TS:EntityList-Text:Record.TextSlot~}
	{~TS:EntityList-Textarea:Record.TextareaSlot~}
	{~TS:EntityList-Markdown:Record.MarkdownSlot~}
	{~TS:EntityList-Code:Record.CodeSlot~}
	{~TS:EntityList-Select:Record.SelectSlot~}
	{~TS:EntityList-Combo:Record.ComboSlot~}
	{~TS:EntityList-Date:Record.DateSlot~}
	{~TS:EntityList-Likert:Record.LikertSlot~}
	{~TS:EntityList-Checkbox:Record.CheckboxSlot~}
</div>`
		},
		{ Hash: 'EntityList-Text', Template: /*html*/`<input type="text" class="ps-input" value="{~D:Record.Value~}" oninput="_Pict.views['Plansheet-EntityList'].setField('{~D:Record.F~}', this.value)">` },
		{ Hash: 'EntityList-Textarea', Template: /*html*/`<textarea class="ps-input" rows="3" oninput="_Pict.views['Plansheet-EntityList'].setField('{~D:Record.F~}', this.value)">{~D:Record.Value~}</textarea>` },
		{ Hash: 'EntityList-Markdown', Template: /*html*/`<div class="ps-md-host" id="EntityForm-MarkdownHost"></div>` },
		{ Hash: 'EntityList-Code', Template: /*html*/`<div class="ps-code-host" id="EntityForm-CodeHost"></div>` },
		{ Hash: 'EntityList-Select', Template: /*html*/`<select class="ps-input" onchange="_Pict.views['Plansheet-EntityList'].setField('{~D:Record.F~}', this.value)">{~TS:EntityList-Option:Record.Options~}</select>` },
		{ Hash: 'EntityList-Date', Template: /*html*/`<input type="date" class="ps-input" value="{~D:Record.Value~}" oninput="_Pict.views['Plansheet-EntityList'].setField('{~D:Record.F~}', this.value)">` },
		{ Hash: 'EntityList-Checkbox', Template: /*html*/`<label class="ps-form-check"><input type="checkbox" class="ps-form-checkbox" {~D:Record.CheckedAttr~} onchange="_Pict.views['Plansheet-EntityList'].setField('{~D:Record.F~}', this.checked ? 1 : 0)"></label>` },
		{ Hash: 'EntityList-Combo', Template: /*html*/`<input type="text" class="ps-input" list="{~D:Record.ListID~}" value="{~D:Record.Value~}" oninput="_Pict.views['Plansheet-EntityList'].setField('{~D:Record.F~}', this.value)"><datalist id="{~D:Record.ListID~}">{~TS:EntityList-ComboOption:Record.Options~}</datalist>` },
		{ Hash: 'EntityList-ComboOption', Template: /*html*/`<option value="{~D:Record.Value~}"></option>` },
		{ Hash: 'EntityList-Option', Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Value~}</option>` },
		{ Hash: 'EntityList-Likert', Template: /*html*/`<div class="ps-likert">{~TS:EntityList-LikertBtn:Record.Buttons~}</div>` },
		{ Hash: 'EntityList-LikertBtn', Template: /*html*/`<button type="button" class="ps-btn ps-btn-sm ps-likert-btn{~D:Record.OnClass~}" onclick="_Pict.views['Plansheet-EntityList'].setLikert('{~D:Record.F~}', {~D:Record.N~})">{~D:Record.Label~}</button>` }
	],
	Renderables:
	[
		{
			RenderableHash: 'EntityList-Display',
			TemplateHash: 'EntityList-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../EntityDescriptors.js":555,"../EntityMark.js":556,"../FocusFilters.js":558,"../FocusQuery.js":559,"../libLabels.js":575,"./Markup-Templates.js":650,"pict-view":365}],670:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * FeatureBoard -- the features board, and the place a feature's promise is judged.
 *
 * WHY IT IS NOT THE WORK ITEM BOARD. Work items move at agent speed; features move at product
 * speed. Putting both on one surface implies they should move together, and that implication is
 * the pressure that produces rubber stamps. So features got their own board and came off the
 * other one.
 *
 * WHAT IS ON A CARD, AND WHY. Work items connected, how many are Done, the commits and deploys
 * behind them, when the last work item landed, whether a connected item is still bouncing off
 * review, and how many times this feature has already been accepted (its rebuild history, made
 * visible without opening anything). A card that carried only a name would leave a reader with
 * only the name to judge, which is the whole failure. The counts are the reader's first check --
 * and they are deliberately NOT the decision, because a count cannot tell a finished feature from
 * one whose capability never ran once (F-130 and F-134 were countably identical). Reading the
 * acceptance sentence is what separates them, so the dialog leads with it.
 *
 * DRAGGING TO DONE IS FINE, AND ASKS. Moving a card to Done prospectively is ordinary practice --
 * somebody finishes, says so, and comes back later if they were wrong. Refusing the drag would not
 * produce a better assessment, it would produce none. So the drop lands AND opens the acceptance
 * dialog, which is an invitation rather than a toll gate: cancel it and the Feature is still Done,
 * carrying a visible "no acceptance recorded yet" on its card until somebody writes one.
 */
class PictViewFeatureBoard extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._drag = null;
		// Cards picked for one decision about a set. Kept as IDFeature, which is what the bulk
		// endpoint takes.
		this._selected = new Set();
		this._lastSelected = 0;
	}

	_board() { return this.pict.providers.FeatureBoardAPI; }
	_router() { return this.pict.providers['Pict-Router']; }

	show()
	{
		let tmpBoard = this._board();
		if (!tmpBoard) { return Promise.resolve(); }
		return tmpBoard.list().then(() => { this._decorate(); this.render(); });
	}
	refresh() { return this.show(); }

	/**
	 * Turn the raw card into what the template renders. The counts become one readable phrase
	 * ("6 of 8 done") plus a progress width, and the decision buttons become a slot that is empty
	 * unless this card is actually in Review and this reader can actually decide.
	 */
	_decorate()
	{
		let tmpStore = (this.pict.AppData && this.pict.AppData.FeatureBoard) || null;
		if (!tmpStore) { return; }
		let tmpCanAccept = !!tmpStore.CanAccept;

		(tmpStore.Lanes || []).forEach((pLane) =>
		{
			(pLane.Cards || []).forEach((pCard) =>
			{
				let tmpConnected = Number(pCard.WorkItemsConnected) || 0;
				let tmpDone = Number(pCard.WorkItemsDone) || 0;
				pCard.Designator = 'F-' + String(pCard.FeatureNumber || pCard.IDFeature);
				pCard.WorkLabel = tmpConnected
					? (tmpDone + ' of ' + tmpConnected + ' work item' + (tmpConnected === 1 ? '' : 's') + ' done')
					// Said plainly rather than shown as "0 of 0": a feature with no work items is a
					// discipline problem (file the item before the code), and no board rule can find
					// it. Naming it on the card is the only place it becomes visible at all.
					: 'no work items connected';
				pCard.WorkPercent = tmpConnected ? Math.round((tmpDone / tmpConnected) * 100) : 0;
				pCard.WorkBarStyle = 'width:' + pCard.WorkPercent + '%';
				pCard.BuildLabel = (Number(pCard.Commits) || 0)
					? ((pCard.Commits) + ' commit' + (Number(pCard.Commits) === 1 ? '' : 's')
						+ ', ' + (Number(pCard.AsBuiltsDeployed) || 0) + ' deployed')
					: '';
				pCard.LandedLabel = pCard.LastLandedDate ? ('landed ' + String(pCard.LastLandedDate).slice(0, 10)) : '';
				pCard.AcceptedLabel = pCard.AcceptedDate ? ('accepted ' + String(pCard.AcceptedDate).slice(0, 10)) : '';
				// The two signals the acceptance work item asked to be ON the card, not buried a click
				// deep: a connected item still bouncing off review, and this feature's own rebuild
				// history. Neither is the decision -- reading the sentence still is -- but both are
				// exactly the kind of thing that separates a genuinely finished feature from one that
				// only looks it.
				pCard.ReworkLabel = pCard.StillFailingReview ? 'a work item is still failing review' : '';
				pCard.RebuildLabel = (Number(pCard.PriorAcceptances) || 0)
					? ('accepted ' + pCard.PriorAcceptances + 'x before') : '';
				// A Done card nobody has written an assessment on. Surfaced, never prevented: the
				// move is legitimate, the missing note is the thing worth noticing.
				pCard.AwaitingSlot = pCard.AwaitingAcceptance ? [{ IDFeature: pCard.IDFeature }] : [];
				// The one-line preview of the sentence being judged. The dialog shows all of it.
				pCard.SentencePreview = String(pCard.AcceptanceSentence || '').slice(0, 150);
				// Offered in Review (the normal moment) and on a Done card still missing its
				// assessment (the after-the-fact moment), so a note can always be written.
				pCard.DecideSlot = ((pCard.Status === 'Review' || pCard.AwaitingAcceptance) && tmpCanAccept)
					? [{ IDFeature: pCard.IDFeature, BackLabel: (pCard.Status === 'Done') ? 'Reopen' : 'Send back' }] : [];
				// A card only offers selection if it could actually be decided, so the count on the
				// bar is never larger than what a decision would move.
				pCard.PickSlot = pCard.DecideSlot.length
					? [{ IDFeature: pCard.IDFeature, CheckedAttr: this._selected.has(pCard.IDFeature) ? 'checked' : '' }] : [];
				pCard.SelectedClass = this._selected.has(pCard.IDFeature) ? ' ps-fb-card-selected' : '';
			});
		});

		// The picking chrome. Only ever offered to somebody who can actually decide, and only when
		// there is something decidable to pick.
		let tmpPickable = this._pickableOrder().length;
		tmpStore.PickAllSlot = (tmpCanAccept && tmpPickable && this._selected.size < tmpPickable)
			? [{ Pickable: tmpPickable }] : [];
		tmpStore.BulkSlot = (tmpCanAccept && this._selected.size)
			? [{ Count: this._selected.size, Plural: (this._selected.size === 1) ? '' : 's' }] : [];
	}

	// The still-open work items ticked in the confirm list.
	_readTicks()
	{
		if (typeof document === 'undefined') { return []; }
		return Array.prototype.slice.call(document.querySelectorAll('.ps-fb-close-item'))
			.filter((pBox) => pBox.checked).map((pBox) => Number(pBox.value) || 0).filter((pID) => pID);
	}

	/**
	 * Mount the rich markdown editor into the open dialog.
	 *
	 * The note is markdown, so it gets the editor the rest of the app writes markdown in rather than
	 * a bare textarea: the same CodeMirror, the same live preview, and the same paste-an-image
	 * handling. Its own instance, because the entity form's is live at the same time.
	 */
	_mountNoteEditor()
	{
		let tmpEditor = this.pict.views['Plansheet-AcceptanceMarkdownEditor'];
		if (!tmpEditor)
		{
			// Not in this build. A plain textarea still collects the note rather than the field
			// silently not existing.
			this.pict.ContentAssignment.assignContent('#Acceptance-MarkdownHost',
				'<textarea id="ps-fb-note" class="ps-fb-dlg-note-fallback"></textarea>');
			let tmpElement = (typeof document !== 'undefined') ? document.getElementById('ps-fb-note') : null;
			if (tmpElement) { tmpElement.oninput = () => { this._note = tmpElement.value; }; }
			return;
		}
		this.pict.AppData.AcceptanceMarkdownEditor = this.pict.AppData.AcceptanceMarkdownEditor || {};
		this.pict.AppData.AcceptanceMarkdownEditor.Segments = [{ Content: '' }];
		try { if (tmpEditor.initialRenderComplete) { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; } }
		catch (pError) { /* ignore -- a re-mount over a dead instance */ }
		tmpEditor.render();
		tmpEditor.marshalToView();
		if (typeof tmpEditor.setPreviewMode === 'function') { tmpEditor.setPreviewMode('bottom'); }
	}

	// The dialog's DOM is thrown away when it closes, so the editor has to go with it or it keeps
	// CodeMirror instances and timers alive against detached nodes.
	_teardownNoteEditor()
	{
		let tmpEditor = this.pict.views['Plansheet-AcceptanceMarkdownEditor'];
		if (!tmpEditor || !tmpEditor.initialRenderComplete) { return; }
		try { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; }
		catch (pError) { /* ignore -- teardown is best-effort */ }
	}

	// The editor calls this on every change; the note is kept here so it is in hand before the
	// dialog dismisses (see decide()).
	onMarkdownChanged()
	{
		let tmpEditor = this.pict.views['Plansheet-AcceptanceMarkdownEditor'];
		if (!tmpEditor || typeof tmpEditor.getAllContent !== 'function') { return; }
		this._note = tmpEditor.getAllContent('\n\n');
	}

	// An image pasted into the note belongs to the feature being judged, so it lands in that
	// feature's own gallery rather than as a base64 blob inside the note.
	markdownOwnerContext() { return this._noteOwner || { OwnerType: '', IDOwner: 0 }; }

	/**
	 * Turn this dialog's primary button into its own confirm, in place.
	 *
	 * The modal dismisses on the FIRST click of any footer button, so the second click has to be
	 * taken before that listener runs. A capture listener on the dialog fires ahead of the button's
	 * own, which is what lets the button relabel itself here rather than a second modal appearing on
	 * top of the first -- the note, the evidence and the ticks all stay on screen while you confirm.
	 *
	 * Only arms when the note is empty. Prose is its own deliberateness; making somebody who just
	 * wrote a paragraph click twice proves nothing.
	 */
	_armInPlaceConfirm(pHostID, pLabel)
	{
		if (typeof document === 'undefined') { return; }
		let tmpHost = document.getElementById(pHostID);
		let tmpDialog = (tmpHost && tmpHost.closest) ? tmpHost.closest('.pict-modal-dialog') : null;
		if (!tmpDialog) { return; }
		let tmpButton = tmpDialog.querySelector('[data-hash="ok"]');
		if (!tmpButton) { return; }

		let tmpArmed = false;
		tmpDialog.addEventListener('click', (pEvent) =>
		{
			if (!pEvent.target || !pEvent.target.closest) { return; }
			if (pEvent.target.closest('[data-hash="ok"]') !== tmpButton) { return; }
			if (tmpArmed) { return; }
			// Typed something since arming (or before ever arming): let it straight through.
			if (String(this._note || '').trim()) { return; }
			tmpArmed = true;
			tmpButton.textContent = pLabel;
			tmpButton.classList.add('ps-fb-confirming');
			pEvent.stopImmediatePropagation();
			pEvent.preventDefault();
		}, true);
	}

	/**
	 * Move one card to where the decision just put it, without re-reading the board.
	 *
	 * Refetching after every decision is what makes a queue feel like wading: the whole surface
	 * blanks and repaints to change one card. Nothing else moved, so nothing else needs redrawing.
	 */
	_applyDecision(pIDFeature, pOutcome, pResult)
	{
		let tmpStore = (this.pict.AppData && this.pict.AppData.FeatureBoard) || null;
		if (!tmpStore || !Array.isArray(tmpStore.Lanes)) { return; }
		let tmpTargetKey = (pOutcome === 'Accept') ? 'Done' : 'InProgress';

		let tmpCard = null;
		tmpStore.Lanes.forEach((pLane) =>
		{
			let tmpIndex = (pLane.Cards || []).findIndex((pRow) => Number(pRow.IDFeature) === Number(pIDFeature));
			if (tmpIndex >= 0) { tmpCard = pLane.Cards.splice(tmpIndex, 1)[0]; }
		});
		if (!tmpCard) { return this.refresh(); }

		let tmpClosed = ((pResult && pResult.ClosedWorkItems) || []).length;
		tmpCard.Status = tmpTargetKey;
		tmpCard.WorkItemsDone = Math.min(Number(tmpCard.WorkItemsConnected) || 0, (Number(tmpCard.WorkItemsDone) || 0) + tmpClosed);
		tmpCard.WorkItemsOpen = Math.max(0, (Number(tmpCard.WorkItemsConnected) || 0) - tmpCard.WorkItemsDone);
		if (pOutcome === 'Accept')
		{
			tmpCard.AcceptedDate = (pResult && pResult.DecisionDate) || (new Date()).toISOString();
			tmpCard.AwaitingAcceptance = false;
		}
		else { tmpCard.AwaitingAcceptance = false; }

		let tmpLane = tmpStore.Lanes.filter((pLane) => pLane.Key === tmpTargetKey)[0];
		if (tmpLane) { tmpLane.Cards.unshift(tmpCard); }
		tmpStore.Lanes.forEach((pLane) => { pLane.Count = (pLane.Cards || []).length; });

		this._decorate();
		this.render();
	}

	// ---- picking a set --------------------------------------------------------------

	// Shift-click extends from the last pick, the usual list gesture, so a run of a hundred is two
	// clicks rather than a hundred.
	togglePick(pEvent, pIDFeature)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') { pEvent.stopPropagation(); }
		let tmpID = Number(pIDFeature) || 0;
		if (!tmpID) { return; }

		if (pEvent && pEvent.shiftKey && this._lastSelected)
		{
			let tmpOrder = this._pickableOrder();
			let tmpFrom = tmpOrder.indexOf(this._lastSelected);
			let tmpTo = tmpOrder.indexOf(tmpID);
			if (tmpFrom >= 0 && tmpTo >= 0)
			{
				for (let i = Math.min(tmpFrom, tmpTo); i <= Math.max(tmpFrom, tmpTo); i++) { this._selected.add(tmpOrder[i]); }
			}
			else { this._selected.add(tmpID); }
		}
		else if (this._selected.has(tmpID)) { this._selected.delete(tmpID); }
		else { this._selected.add(tmpID); }

		this._lastSelected = tmpID;
		this._decorate();
		this.render();
	}

	// Every decidable card, in the order they are read, so a shift-range means what it looks like.
	_pickableOrder()
	{
		let tmpStore = (this.pict.AppData && this.pict.AppData.FeatureBoard) || {};
		let tmpOrder = [];
		(tmpStore.Lanes || []).forEach((pLane) => (pLane.Cards || []).forEach((pCard) =>
		{
			if (pCard.Status === 'Review' || pCard.AwaitingAcceptance) { tmpOrder.push(pCard.IDFeature); }
		}));
		return tmpOrder;
	}

	// Pick every card that could be decided. This is the backfill button: a hundred features that
	// were finished before there was anywhere to record an acceptance are one judgement, not a
	// hundred, and clicking them individually would be the ceremony rather than the substance.
	pickAll()
	{
		this._pickableOrder().forEach((pID) => this._selected.add(pID));
		this._decorate();
		this.render();
	}

	clearPicks()
	{
		this._selected.clear();
		this._lastSelected = 0;
		this._decorate();
		this.render();
	}

	/**
	 * One decision about every picked feature.
	 *
	 * Deliberately the same dialog shape as the single decision -- what is being judged, then the
	 * note, then confirm -- because it is the same act. What differs is that the thing being judged
	 * is a SET, so the dialog names every feature in it rather than showing one promise. A person
	 * has to be able to see exactly what they are about to decide.
	 */
	decideMany(pOutcome)
	{
		let tmpBoard = this._board();
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpBoard || !tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpIDs = Array.from(this._selected);
		if (!tmpIDs.length) { return; }
		let tmpAccepting = (pOutcome === 'Accept');

		let tmpStore = (this.pict.AppData && this.pict.AppData.FeatureBoard) || {};
		let tmpPicked = [];
		(tmpStore.Lanes || []).forEach((pLane) => (pLane.Cards || []).forEach((pCard) =>
		{
			if (this._selected.has(pCard.IDFeature)) { tmpPicked.push(pCard); }
		}));
		let tmpOpenWork = tmpPicked.reduce((pSum, pCard) => pSum + (Number(pCard.WorkItemsOpen) || 0), 0);

		let fEsc = (pText) => String(pText == null ? '' : pText)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

		let tmpContent =
			'<div class="ps-fb-dlg-evidence">One decision about <b>' + tmpPicked.length + '</b> feature'
				+ (tmpPicked.length === 1 ? '' : 's') + '. It is recorded on each of them as one judgement about '
				+ tmpPicked.length + ', not as ' + tmpPicked.length + ' separate readings.</div>'
			+ '<div class="ps-fb-dlg-items">' + tmpPicked.map((pCard) =>
				'<div class="ps-fb-dlg-item"><span class="n">F-' + fEsc(pCard.FeatureNumber) + '</span>'
				+ '<span class="s">' + fEsc(pCard.Status) + '</span>'
				+ '<span class="t">' + fEsc(pCard.Name) + '</span></div>').join('') + '</div>'
			+ (tmpAccepting && tmpOpenWork
				? ('<label class="ps-fb-dlg-item ps-fb-dlg-closeall"><input type="checkbox" id="ps-fb-close-all" checked>'
					+ '<span class="t">Also mark the <b>' + tmpOpenWork + '</b> work item'
					+ (tmpOpenWork === 1 ? '' : 's') + ' still open under them Done</span></label>')
				: '')
			+ '<div class="ps-fb-dlg-label">'
				+ (tmpAccepting ? 'Why are these promises kept?' : 'What is missing?')
				+ '<span class="ps-fb-dlg-optional">optional, recorded on every one</span></div>'
			+ '<div id="Acceptance-MarkdownHost" class="ps-fb-dlg-note"></div>';

		this._note = '';
		this._noteOwner = { OwnerType: '', IDOwner: 0 };
		let tmpCloseAll = false;

		return tmpModal.show(
			{
				title: (tmpAccepting ? 'Accept ' : 'Send back ') + tmpPicked.length + ' feature' + (tmpPicked.length === 1 ? '' : 's'),
				content: tmpContent,
				width: 720,
				onOpen: () =>
				{
					this._mountNoteEditor();
					this._armInPlaceConfirm('Acceptance-MarkdownHost',
						(tmpAccepting ? 'Accept all anyway' : 'Send all back anyway'));
				},
				onClose: () =>
				{
					let tmpBox = (typeof document !== 'undefined') ? document.getElementById('ps-fb-close-all') : null;
					tmpCloseAll = !!(tmpBox && tmpBox.checked);
				},
				buttons: [{ Hash: 'cancel', Label: 'Cancel' },
					{ Hash: 'ok', Label: (tmpAccepting ? 'Accept all' : 'Send all back'), Style: 'primary' }]
			}).then((pChoice) =>
			{
				let tmpNote = String(this._note || '').trim();
				this._teardownNoteEditor();
				if (pChoice !== 'ok') { return null; }

				return tmpBoard.decideMany(tmpIDs, pOutcome, tmpNote, tmpCloseAll).then((pResult) =>
				{
					let tmpDecided = (pResult && pResult.Decided) || [];
					let tmpSkipped = (pResult && pResult.Skipped) || [];
					this.clearPicks();
					// A set decision moves many cards at once, so this one does re-read the board.
					// Patching N cards by hand would be a second implementation of the server's rules
					// and would drift from them.
					this.refresh();
					this._toast(tmpDecided.length + (tmpAccepting ? ' accepted' : ' sent back')
						+ ((pResult && pResult.ClosedWorkItems) ? (', ' + pResult.ClosedWorkItems + ' work items closed') : '')
						+ (tmpSkipped.length ? (', ' + tmpSkipped.length + ' skipped') : '') + '.',
						tmpSkipped.length ? 'info' : 'success');
					return pResult;
				});
			}).catch((pError) =>
			{
				this._toast('Could not record the decisions: ' + ((pError && pError.message) || pError), 'error');
			});
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	openFeature(pID)
	{
		let tmpRouter = this._router();
		if (tmpRouter && pID) { tmpRouter.navigate('/feature/' + pID); }
	}

	/**
	 * The decision. Reads the evidence first, then shows it: the acceptance sentence at the top,
	 * because that is the thing being judged, then the counts and the work items behind them, then
	 * an empty markdown box the reader has to fill in either way.
	 *
	 * pOutcome is 'Accept' or 'SendBack'. Both go through the same dialog because they are the same
	 * decision pointed in two directions, and both require a note -- the server refuses an empty
	 * one, and so does this, so the reader is told before the round trip rather than after.
	 */
	decide(pEvent, pIDFeature, pOutcome)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') { pEvent.stopPropagation(); }
		let tmpBoard = this._board();
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpBoard || !tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpAccepting = (pOutcome === 'Accept');

		tmpBoard.acceptance(pIDFeature).then((pEvidence) =>
		{
			let tmpFeature = (pEvidence && pEvidence.Feature) || {};
			let tmpItems = (pEvidence && pEvidence.WorkItems) || [];
			let tmpDone = tmpItems.filter((pItem) => pItem.Status === 'Done');
			// Review first, because those are the ones already ticked and the reader should see them
			// before the ones they have to opt into.
			let tmpOpen = tmpItems.filter((pItem) => pItem.Status !== 'Done')
				.sort((pA, pB) => ((pB.Status === 'Review') ? 1 : 0) - ((pA.Status === 'Review') ? 1 : 0));
			let tmpHistory = (pEvidence && pEvidence.History) || [];
			let fEsc = (pText) => String(pText == null ? '' : pText)
				.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

			let tmpSentence = String(tmpFeature.AcceptanceSentence || '').trim();
			let tmpContent =
				'<div class="ps-fb-dlg-sentence"><div class="ps-fb-dlg-label">What this feature promised</div>'
					+ '<div class="ps-fb-dlg-quote">' + (tmpSentence ? fEsc(tmpSentence)
						: '<i>Nothing is written down. Decide from the work below, then write the promise on the feature so the next reader has it.</i>') + '</div></div>'
				+ '<div class="ps-fb-dlg-evidence">'
					+ '<b>' + (Number(tmpFeature.WorkItemsDone) || 0) + '</b> of <b>' + (Number(tmpFeature.WorkItemsConnected) || 0) + '</b> work items done'
					+ ', <b>' + (Number(tmpFeature.Commits) || 0) + '</b> commits'
					+ ', <b>' + (Number(tmpFeature.AsBuiltsDeployed) || 0) + '</b> deployed'
					+ ', <b>' + (Number(tmpFeature.AsBuiltsValidated) || 0) + '</b> validated'
					+ (tmpFeature.LastLandedDate ? (', last landed ' + fEsc(String(tmpFeature.LastLandedDate).slice(0, 10))) : '')
				+ '</div>'
				+ (tmpDone.length
					? ('<div class="ps-fb-dlg-items">' + tmpDone.map((pItem) =>
						'<div class="ps-fb-dlg-item"><span class="n">WI-' + fEsc(pItem.WorkItemNumber) + '</span>'
						+ '<span class="s">' + fEsc(pItem.Status) + '</span>'
						+ '<span class="t">' + fEsc(pItem.Title) + '</span></div>').join('') + '</div>')
					: '')
				// The tickets still open under this feature, as a confirm list. Anything in Review is
				// ticked to begin with, because that is the lane that fills up and the one a feature
				// being accepted almost always settles; everything else is offered unticked so it is
				// added on purpose rather than swept up. Only ever shown when accepting: sending a
				// feature back says the capability is not there, which says nothing about anybody's
				// individual ticket.
				+ ((tmpAccepting && tmpOpen.length)
					? ('<div class="ps-fb-dlg-label">Also mark these Done?</div>'
						+ '<div class="ps-fb-dlg-items ps-fb-dlg-close">' + tmpOpen.map((pItem) =>
							'<label class="ps-fb-dlg-item"><input type="checkbox" class="ps-fb-close-item" value="'
							+ fEsc(pItem.IDWorkItem) + '"' + ((pItem.Status === 'Review') ? ' checked' : '') + '>'
							+ '<span class="n">WI-' + fEsc(pItem.WorkItemNumber) + '</span>'
							+ '<span class="s">' + fEsc(pItem.Status) + '</span>'
							+ '<span class="t">' + fEsc(pItem.Title) + '</span></label>').join('') + '</div>')
					: '')
				+ (tmpHistory.length
					? ('<div class="ps-fb-dlg-history"><div class="ps-fb-dlg-label">Decided before</div>'
						+ tmpHistory.map((pRow) =>
							'<div class="ps-fb-dlg-item"><span class="s">' + fEsc(pRow.Outcome) + '</span>'
							+ '<span class="n">' + fEsc(String(pRow.DecisionDate).slice(0, 10)) + '</span>'
							+ '<span class="t">' + fEsc(String(pRow.AcceptanceNote || '').slice(0, 160)) + '</span></div>').join('')
						+ '</div>')
					: '')
				+ '<div class="ps-fb-dlg-label">'
					+ (tmpAccepting ? 'Why is this promise kept?' : 'What is missing?')
					+ '<span class="ps-fb-dlg-optional">optional</span></div>'
				+ '<div id="Acceptance-MarkdownHost" class="ps-fb-dlg-note"></div>';

			// The editor writes back on every keystroke (onMarkdownChanged below), so the note is in
			// hand before the dialog dismisses and there is nothing to read off dying DOM.
			this._note = '';
			this._noteOwner = { OwnerType: 'Feature', IDOwner: pIDFeature };

			return tmpModal.show(
				{
					title: (tmpAccepting ? 'Accept ' : 'Send back ') + 'F-' + (tmpFeature.FeatureNumber || pIDFeature)
						+ ': ' + (tmpFeature.Name || ''),
					content: tmpContent,
					width: 720,
					onOpen: () =>
					{
						this._mountNoteEditor();
						this._armInPlaceConfirm('Acceptance-MarkdownHost',
							(tmpAccepting ? 'Accept anyway' : 'Send back anyway'));
					},
					// onClose runs synchronously BEFORE the promise resolves and 220ms before the
					// dialog is removed, so the ticks are read while the DOM is certainly still there
					// rather than inside an animation window that happens to be long enough.
					onClose: () => { this._ticked = this._readTicks(); },
					buttons: [{ Hash: 'cancel', Label: 'Cancel' },
						{ Hash: 'ok', Label: (tmpAccepting ? 'Accept feature' : 'Send back'), Style: 'primary' }]
				}).then((pChoice) =>
				{
					let tmpNote = String(this._note || '').trim();
					let tmpClose = this._ticked || [];
					this._teardownNoteEditor();
					if (pChoice !== 'ok') { return null; }

					// The empty-note second click already happened, in this window, on this button
					// (_armInPlaceConfirm). By the time the dialog resolves 'ok' the decision is
					// established either by prose or by two clicks, so there is nothing left to ask.
					return tmpBoard.decide(pIDFeature, pOutcome, tmpNote, tmpClose).then((pResult) =>
					{
						let tmpClosed = (pResult && pResult.ClosedWorkItems) || [];
						// Patch the one card rather than re-fetching every feature on the board. A
						// whole reload per decision is what makes working through a queue feel like
						// wading, and nothing else on the board changed.
						this._applyDecision(pIDFeature, pOutcome, pResult);
						this._toast(tmpAccepting
							? ('Accepted. The feature is Done'
								+ (tmpClosed.length ? (', and ' + tmpClosed.length + ' work item' + (tmpClosed.length === 1 ? '' : 's') + ' with it') : '') + '.')
							: 'Sent back to In Progress.', 'success');
						return pResult;
					});
				});
		}).catch((pError) =>
		{
			this._toast('Could not record the decision: ' + ((pError && pError.message) || pError), 'error');
		});
	}

	dragStart(pEvent, pID)
	{
		this._drag = { ID: pID };
		if (pEvent && pEvent.dataTransfer)
		{
			pEvent.dataTransfer.effectAllowed = 'move';
			try { pEvent.dataTransfer.setData('text/plain', String(pID)); } catch (pError) { /* ignore */ }
		}
	}

	allowDrop(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		if (pEvent && pEvent.dataTransfer) { pEvent.dataTransfer.dropEffect = 'move'; }
	}

	drop(pEvent, pLaneKey)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		let tmpDrag = this._drag;
		this._drag = null;
		let tmpBoard = this._board();
		if (!tmpDrag || !tmpBoard) { return; }

		tmpBoard.moveCard(tmpDrag.ID, pLaneKey, tmpBoard.nextSortOrder(pLaneKey))
			.then(() => this.show())
			// Dropping on Done is the moment somebody has decided something, so it is the moment to
			// ask what. The move has already landed by here: the dialog collects the reason, it does
			// not hold the card hostage for one, and cancelling leaves a Done Feature saying it has
			// no acceptance recorded.
			.then(() => { if (pLaneKey === 'Done') { this.decide(null, tmpDrag.ID, 'Accept'); } })
			.catch((pError) => { this._toast('Move failed: ' + ((pError && pError.message) || pError), 'error'); });
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewFeatureBoard;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-FeatureBoard',
	DefaultRenderable: 'FeatureBoard-Display',
	AutoRender: false,
	CSS: /*css*/`
		.ps-fb { height: 100%; display: flex; flex-direction: column; gap: 14px; }
		.ps-fb-head { display: flex; align-items: baseline; gap: 14px; flex-wrap: wrap; }
		.ps-fb-head h2 { font-size: 22px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; }
		.ps-fb-blurb { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); }
		/* One scroll region for the whole board; lanes never scroll on their own. */
		.ps-fb-lanes { display: flex; gap: 12px; overflow: auto; align-items: flex-start; flex: 1; min-height: 0; padding-bottom: 8px; }
		.ps-fb-lane { flex: 0 0 268px; width: 268px; background: var(--theme-color-background-secondary, #f1f3f7); border-radius: 10px; padding: 10px; display: flex; flex-direction: column; }
		.ps-fb-lane-head { display: flex; align-items: center; justify-content: space-between; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); padding: 4px 6px 10px; }
		.ps-fb-lane-count { background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); border-radius: 999px; padding: 1px 8px; font-size: 12px; }
		.ps-fb-lane-cards { display: flex; flex-direction: column; gap: 8px; min-height: 40px; }
		.ps-fb-card { background: var(--theme-color-background-panel, #fff); border-radius: 8px; padding: 10px 12px; border-left: 3px solid var(--theme-color-brand-primary, #2880a6); cursor: pointer; box-shadow: 0 1px 2px rgba(0,0,0,0.06); }
		.ps-fb-card:hover { box-shadow: 0 2px 6px rgba(0,0,0,0.12); }
		.ps-fb-card-top { display: flex; align-items: baseline; gap: 6px; margin-bottom: 4px; }
		.ps-fb-card-num { font-size: 11px; color: var(--theme-color-text-muted, #97a1ab); font-weight: 700; }
		.ps-fb-card-title { font-size: 14px; color: var(--theme-color-text-primary, #2c3140); line-height: 1.25; }
		.ps-fb-card-sentence { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.35; margin-bottom: 7px; }
		.ps-fb-card-sentence:empty { display: none; }
		.ps-fb-work { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 3px; }
		.ps-fb-bar { height: 4px; border-radius: 999px; background: var(--theme-color-background-tertiary, #e3e8f0); overflow: hidden; margin-bottom: 6px; }
		.ps-fb-bar span { display: block; height: 100%; background: var(--theme-color-status-success, #3fae6b); }
		.ps-fb-meta { display: flex; gap: 5px; flex-wrap: wrap; }
		.ps-fb-chip { font-size: 11px; padding: 1px 7px; border-radius: 999px; background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #5b6376); }
		.ps-fb-chip:empty { display: none; }
		.ps-fb-chip-warn:not(:empty) { background: var(--theme-color-status-warning-background, #fbe9dd); color: var(--theme-color-status-warning, #d99366); font-weight: 600; }
		.ps-fb-decide { display: flex; gap: 6px; margin-top: 8px; }
		.ps-fb-decide button { font: inherit; font-size: 12px; border-radius: 6px; padding: 4px 10px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-fb-accept { border-color: var(--theme-color-status-success, #3fae6b) !important; color: var(--theme-color-status-success, #3fae6b) !important; font-weight: 600; }
		.ps-fb-back { border-color: var(--theme-color-status-warning, #d99366) !important; color: var(--theme-color-status-warning, #d99366) !important; }
		.ps-fb-dlg-close .ps-fb-dlg-item { cursor: pointer; gap: 8px; padding: 4px 0; }
		.ps-fb-dlg-close .ps-fb-dlg-item:hover { background: var(--theme-color-background-secondary, #eef1f6); }
		.ps-fb-dlg-close input { margin: 0; flex: 0 0 auto; }
		.pict-modal-btn.ps-fb-confirming { background: var(--theme-color-status-warning, #d99366) !important; border-color: var(--theme-color-status-warning, #d99366) !important; }
		.ps-fb-card-check { margin: 0 6px 0 0; flex: 0 0 auto; cursor: pointer; }
		.ps-fb-card-selected { outline: 2px solid var(--theme-color-brand-primary, #2880a6); outline-offset: -1px; }
		.ps-fb-pickall { font: inherit; font-size: 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); border-radius: 6px; padding: 4px 10px; cursor: pointer; margin-left: auto; }
		.ps-fb-pickall:hover { border-color: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-brand-primary, #2880a6); }
		.ps-fb-bulkbar { position: sticky; bottom: 0; display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-radius: 10px; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d8dde6); box-shadow: 0 -2px 10px rgba(0,0,0,0.10); }
		.ps-fb-bulkcount { font-size: 13px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
		.ps-fb-bulkbar button { font: inherit; font-size: 12px; border-radius: 6px; padding: 5px 12px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-fb-bulkclear { margin-left: auto; color: var(--theme-color-text-secondary, #5b6376) !important; }
		.ps-fb-dlg-closeall { cursor: pointer; gap: 8px; margin-top: 8px; border-bottom: none !important; }
		.ps-fb-awaiting { margin-top: 7px; font-size: 11px; color: var(--theme-color-status-warning, #d99366); }
		.ps-fb-dlg-label { font-size: 12px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); display: block; margin: 10px 0 4px; }
		.ps-fb-dlg-quote { font-size: 14px; line-height: 1.4; color: var(--theme-color-text-primary, #2c3140); border-left: 3px solid var(--theme-color-brand-primary, #2880a6); padding: 4px 0 4px 10px; white-space: pre-wrap; }
		.ps-fb-dlg-evidence { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin: 10px 0 0; }
		.ps-fb-dlg-items, .ps-fb-dlg-history { max-height: 150px; overflow: auto; margin-top: 6px; }
		.ps-fb-dlg-item { display: flex; gap: 7px; align-items: baseline; font-size: 12px; padding: 2px 0; border-bottom: 1px solid var(--theme-color-border-light, #f0f3f6); }
		.ps-fb-dlg-item .n { color: var(--theme-color-text-muted, #97a1ab); font-weight: 700; flex: 0 0 auto; }
		.ps-fb-dlg-item .s { color: var(--theme-color-text-secondary, #5b6376); flex: 0 0 auto; }
		.ps-fb-dlg-item .t { color: var(--theme-color-text-primary, #2c3140); }
		.ps-fb-dlg-optional { font-weight: 400; font-size: 11px; color: var(--theme-color-text-muted, #97a1ab); margin-left: 6px; text-transform: none; letter-spacing: 0; }
		.ps-fb-dlg-note { min-height: 220px; }
		.ps-fb-dlg-note-fallback { width: 100%; box-sizing: border-box; min-height: 110px; resize: vertical; padding: 7px 9px; font: inherit; font-size: 13px; border-radius: 6px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
	`,
	Templates:
	[
		{
			Hash: 'FeatureBoard-Display',
			Template: /*html*/`
<div class="ps-page ps-fb">
	<div class="ps-fb-head">
		<h2>Features</h2>
		<span class="ps-fb-blurb">A feature is finished when its promise is kept. Move one to Review, read what it promised, and say whether it was.</span>
		{~TS:FeatureBoard-PickAll:AppData.FeatureBoard.PickAllSlot~}
	</div>
	<div class="ps-fb-lanes">{~TS:FeatureBoard-Lane:AppData.FeatureBoard.Lanes~}</div>
	{~TS:FeatureBoard-BulkBar:AppData.FeatureBoard.BulkSlot~}
</div>`
		},
		{
			Hash: 'FeatureBoard-Lane',
			Template: /*html*/`
<div class="ps-fb-lane" ondragover="_Pict.views['Plansheet-FeatureBoard'].allowDrop(event)" ondrop="_Pict.views['Plansheet-FeatureBoard'].drop(event,'{~D:Record.Key~}')">
	<div class="ps-fb-lane-head"><span>{~D:Record.Label~}</span><span class="ps-fb-lane-count">{~D:Record.Count~}</span></div>
	<div class="ps-fb-lane-cards">{~TS:FeatureBoard-Card:Record.Cards~}</div>
</div>`
		},
		{
			Hash: 'FeatureBoard-Card',
			Template: /*html*/`
<div class="ps-fb-card{~D:Record.SelectedClass~}" draggable="true" ondragstart="_Pict.views['Plansheet-FeatureBoard'].dragStart(event,{~D:Record.IDFeature~})" onclick="_Pict.views['Plansheet-FeatureBoard'].openFeature({~D:Record.IDFeature~})">
	<div class="ps-fb-card-top">{~TS:FeatureBoard-Pick:Record.PickSlot~}<span class="ps-fb-card-num">{~D:Record.Designator~}</span><span class="ps-fb-card-title">{~D:Record.Name~}</span></div>
	<div class="ps-fb-card-sentence">{~D:Record.SentencePreview~}</div>
	<div class="ps-fb-work">{~D:Record.WorkLabel~}</div>
	<div class="ps-fb-bar"><span style="{~D:Record.WorkBarStyle~}"></span></div>
	<div class="ps-fb-meta">
		<span class="ps-fb-chip">{~D:Record.BuildLabel~}</span>
		<span class="ps-fb-chip">{~D:Record.LandedLabel~}</span>
		<span class="ps-fb-chip">{~D:Record.AcceptedLabel~}</span>
		<span class="ps-fb-chip">{~D:Record.RebuildLabel~}</span>
		<span class="ps-fb-chip ps-fb-chip-warn">{~D:Record.ReworkLabel~}</span>
	</div>
	{~TS:FeatureBoard-Awaiting:Record.AwaitingSlot~}
	{~TS:FeatureBoard-Decide:Record.DecideSlot~}
</div>`
		},
		{
			Hash: 'FeatureBoard-Decide',
			Template: /*html*/`
<div class="ps-fb-decide">
	<button class="ps-fb-accept" onclick="_Pict.views['Plansheet-FeatureBoard'].decide(event,{~D:Record.IDFeature~},'Accept')">Accept</button>
	<button class="ps-fb-back" onclick="_Pict.views['Plansheet-FeatureBoard'].decide(event,{~D:Record.IDFeature~},'SendBack')">{~D:Record.BackLabel~}</button>
</div>`
		},
		{
			Hash: 'FeatureBoard-Awaiting',
			Template: /*html*/`<div class="ps-fb-awaiting">no acceptance recorded yet</div>`
		},
		{
			Hash: 'FeatureBoard-Pick',
			Template: /*html*/`<input type="checkbox" class="ps-fb-card-check" {~D:Record.CheckedAttr~} onclick="_Pict.views['Plansheet-FeatureBoard'].togglePick(event,{~D:Record.IDFeature~})">`
		},
		{
			Hash: 'FeatureBoard-PickAll',
			Template: /*html*/`<button class="ps-fb-pickall" onclick="_Pict.views['Plansheet-FeatureBoard'].pickAll()">Select all {~D:Record.Pickable~} awaiting a decision</button>`
		},
		{
			Hash: 'FeatureBoard-BulkBar',
			Template: /*html*/`
<div class="ps-fb-bulkbar">
	<span class="ps-fb-bulkcount">{~D:Record.Count~} feature{~D:Record.Plural~} selected</span>
	<button class="ps-fb-accept" onclick="_Pict.views['Plansheet-FeatureBoard'].decideMany('Accept')">Accept all</button>
	<button class="ps-fb-back" onclick="_Pict.views['Plansheet-FeatureBoard'].decideMany('SendBack')">Send all back</button>
	<button class="ps-fb-bulkclear" onclick="_Pict.views['Plansheet-FeatureBoard'].clearPicks()">Clear</button>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'FeatureBoard-Display',
			TemplateHash: 'FeatureBoard-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"pict-view":365}],671:[function(require,module,exports){
'use strict';

/**
 * FieldCodeEditor -- the pict-section-code editor (CodeJar plus the section's built-in JSON /
 * JavaScript / HTML / CSS / SQL highlighting) embedded INSIDE the generic EntityList edit form, for any
 * descriptor field declared `T: 'code'`.
 *
 * It exists because some fields are not prose. A node's CapabilityJSON is the case that produced it
 * (WI #456): where a node's checkouts live is now maintained from the web UI instead of by SSH-ing in
 * to edit a file, and offering that as a bare textarea makes a person hand-balance braces in a box with
 * no line numbers and no way to see a typo until the node fails to resolve a workspace.
 *
 * Mirrors PictView-FieldMarkdownEditor exactly: mounts into a host div after the form renders, bound to
 * an AppData address, and writes its content back into the form's FormValues through the host
 * (PictView-EntityList.onCodeChanged) so the existing save() posts it with no special handling.
 *
 * pict-section-code and codejar already ride the client bundle (pict-section-content and pict-docuserve
 * both depend on the section), so this adds a view rather than a payload.
 */

const libCodeSection = require('pict-section-code');

/**
 * One editor instance, addressed at a host element and a host view.
 *
 * Parameterised for the same reason the markdown one is: a second surface that edits a code field
 * cannot share this instance, because each carries its own CodeJar state, its own content address and
 * its own host to call back into.
 */
function buildConfiguration(pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpIdentifier = tmpOptions.ViewIdentifier || 'Plansheet-FieldCodeEditor';
	let tmpAddress = tmpOptions.HostAddress || '#EntityForm-CodeHost';
	let tmpDataKey = tmpOptions.DataKey || 'FieldCodeEditor';

	let tmpConfig = JSON.parse(JSON.stringify(libCodeSection.default_configuration));
	tmpConfig.ViewIdentifier = tmpIdentifier;
	tmpConfig.DefaultDestinationAddress = tmpAddress;
	tmpConfig.TargetElementAddress = tmpAddress;
	tmpConfig.CodeDataAddress = 'AppData.' + tmpDataKey + '.Code';
	tmpConfig.DataKey = tmpDataKey;
	// The view this editor reports its changes to.
	tmpConfig.HostViewIdentifier = tmpOptions.HostViewIdentifier || 'Plansheet-EntityList';
	// JSON rather than the section's javascript default: every code field in this app today is a
	// configuration blob, and a field can override it with `Language` on its descriptor entry.
	tmpConfig.Language = tmpOptions.Language || 'json';
	tmpConfig.LineNumbers = true;
	tmpConfig.ReadOnly = false;
	// The form controls when this mounts (after its own render), the same as the markdown field.
	tmpConfig.RenderOnLoad = false;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = tmpAddress;
		}
	}
	return tmpConfig;
}

class PictViewFieldCodeEditor extends libCodeSection
{
	_host() { return this.pict.views[this.options.HostViewIdentifier || 'Plansheet-EntityList']; }

	/**
	 * Tell the host on every change, so the form's save path needs to know nothing about this editor.
	 *
	 * Best effort by design: a host that does not implement onCodeChanged (an editor mounted somewhere
	 * other than the entity form) simply keeps its content in its own AppData address.
	 */
	onCodeChanged()
	{
		if (typeof super.onCodeChanged === 'function') { super.onCodeChanged(); }
		let tmpHost = this._host();
		if (tmpHost && typeof tmpHost.onCodeChanged === 'function') { tmpHost.onCodeChanged(); }
	}

	// What the editor currently holds, however the section chooses to store it. Read through one
	// accessor so the host never reaches into the section's internals.
	getCode()
	{
		if (typeof this.getCodeContent === 'function') { return String(this.getCodeContent() || ''); }
		let tmpKey = this.options.DataKey || 'FieldCodeEditor';
		let tmpBucket = this.pict.AppData[tmpKey] || {};
		return String(tmpBucket.Code || '');
	}
}

module.exports = PictViewFieldCodeEditor;
module.exports.default_configuration = buildConfiguration();
module.exports.buildConfiguration = buildConfiguration;

},{"pict-section-code":189}],672:[function(require,module,exports){
'use strict';

/**
 * FieldMarkdownEditor — the rich markdown editor (pict-section-markdowneditor:
 * CodeMirror 6 + a pict-section-content preview that understands KaTeX math,
 * Mermaid diagrams and embedded images) embedded INSIDE the generic EntityList
 * edit form for any descriptor field flagged `Markdown: true` (an Issue's,
 * Vision's, Feature's, ... Description). It is the same editor as the Docs Lake
 * uses (PictView-RichDocEditor), just hosted in the form chrome instead.
 *
 * It mounts into #EntityForm-MarkdownHost, bound to AppData.FieldMarkdownEditor.Segments,
 * and on every change writes its content straight back into the form's FormValues
 * via the host (PictView-EntityList.onMarkdownChanged), so the existing save()
 * path posts the markdown with no special handling.
 *
 * Pasted / dragged / picked images are owned by the record being edited
 * (OwnerType = entity key, IDOwner = the editing id) so they live in that
 * entity's media gallery. On the create form there is no id yet, so the image
 * is uploaded owned by 0 and the host (PictView-EntityList) re-owns it to the
 * new record once it is saved. Base64 embedding is only the last resort, when
 * there is no gallery API or no owner entity at all.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

/**
 * One editor instance, addressed at a host element and a host view.
 *
 * Parameterised because there is more than one place a markdown field is edited: the generic
 * entity form, and the feature acceptance dialog. They cannot share an instance -- each carries its
 * own CodeMirror state, its own content address, and calls back into a different host -- so each
 * surface registers its own.
 */
function buildConfiguration(pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpIdentifier = tmpOptions.ViewIdentifier || 'Plansheet-FieldMarkdownEditor';
	let tmpAddress = tmpOptions.HostAddress || '#EntityForm-MarkdownHost';
	let tmpDataKey = tmpOptions.DataKey || 'FieldMarkdownEditor';

	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = tmpIdentifier;
	tmpConfig.DefaultDestinationAddress = tmpAddress;
	tmpConfig.TargetElementAddress = tmpAddress;
	tmpConfig.ContentDataAddress = 'AppData.' + tmpDataKey + '.Segments';
	tmpConfig.DataKey = tmpDataKey;
	// The view this editor reports its changes and its image-owner context to.
	tmpConfig.HostViewIdentifier = tmpOptions.HostViewIdentifier || 'Plansheet-EntityList';
	tmpConfig.DefaultPreviewMode = tmpOptions.PreviewMode || 'bottom';
	// Segments are a Docs Lake idea: one document made of several editable pieces. A single field
	// (an acceptance note, a Description) is one piece of prose, and offering "+ Add Segment" there
	// is a control that does nothing the person in front of it wants.
	tmpConfig.AllowSegments = (tmpOptions.AllowSegments !== false);
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = tmpAddress;
		}
	}

	return tmpConfig;
}

class PictViewFieldMarkdownEditor extends libMarkdownEditor
{
	_host() { return this.pict.views[this.options.HostViewIdentifier || 'Plansheet-EntityList']; }

	_ownerContext()
	{
		let tmpHost = this._host();
		return (tmpHost && typeof tmpHost.markdownOwnerContext === 'function') ? tmpHost.markdownOwnerContext() : { OwnerType: '', IDOwner: 0 };
	}

	/**
	 * Pasted / dragged / picked image -> upload to Parime and insert the blob URL
	 * (never a base64 data URI, which would bloat the field and the generated
	 * prompt). On the edit form the media is owned by the record straight away; on
	 * the create form there is no id yet, so it is uploaded owned by 0 and handed
	 * to the host to re-own once the record is saved. Returning true = async
	 * handling; returning false falls back to base64 (no gallery API / no owner
	 * entity, e.g. the editor hosted outside the entity form).
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		let tmpOwner = this._ownerContext();
		let tmpMediaAPI = this.pict.providers.MediaAPI;
		if (!tmpMediaAPI || !tmpOwner.OwnerType) { return false; }
		let tmpIDOwner = tmpOwner.IDOwner || 0;
		tmpMediaAPI.upload(tmpOwner.OwnerType, tmpIDOwner, pFile)
			.then((pRow) =>
			{
				// Create form (no id yet): the media is owned by 0. Register it so the
				// host's save() re-owns it to the new record's id -> the entity gallery.
				if (!tmpIDOwner)
				{
					let tmpHost = this._host();
					if (tmpHost && typeof tmpHost.trackPendingMedia === 'function') { tmpHost.trackPendingMedia(pRow.IDMedia); }
				}
				fCallback(null, tmpMediaAPI.blobURL(pRow.IDMedia));
			})
			.catch((pErr) => fCallback(pErr.message || String(pErr)));
		return true;
	}

	// The upstream editor always renders its add-segment button. Suppressed where a field is one
	// piece of prose rather than a document.
	_renderAddButton(pContainer)
	{
		if (this.options.AllowSegments === false) { return; }
		return super._renderAddButton(pContainer);
	}

	onContentChange(pSegmentIndex, pContent)
	{
		let tmpHost = this._host();
		if (tmpHost && typeof tmpHost.onMarkdownChanged === 'function') { tmpHost.onMarkdownChanged(); }
	}
}

module.exports = PictViewFieldMarkdownEditor;
module.exports.default_configuration = buildConfiguration();
module.exports.buildConfiguration = buildConfiguration;

},{"pict-section-markdowneditor":261}],673:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libDocHistory = require('pict-section-dochistory');
const libFrameworkClient = require('../providers/FrameworkClient.js');

/**
 * FoundationDocs - the "Documentation" surface. Hosts
 * pict-section-inlinedocumentation (a path-based markdown browser) inside the
 * workspace, backed by the Docs Lake API at /1.0/docs/*. The lake is the single
 * source of truth for documentation, so this surface never spins up a second
 * content system in the DB.
 *
 * Authoring here is first class and equal to authoring in a repository: with the
 * content.edit privilege the host wires save, create folder / document, delete,
 * move and reorder straight through to the lake's structure API, and every one of
 * them is an ordinary lake commit. A plan sheet that syncs no repository at all is
 * a complete home for a documentation library; a GitHub binding is optional and
 * changes nothing about how this surface writes.
 */
class PictViewFoundationDocs extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._loadSlug = 'index.md';
		this._vocabTooltipHandles = [];
		this._vocabClickHandlerInstalled = false;
	}

	_provider() { return this.pict.providers['Pict-InlineDocumentation']; }

	// ─── vocabulary auto-markup (WI #184) ────────────────────────────────
	// The resolver map ({ word -> {slug, title, short} }) is fetched once and cached on AppData (this
	// view's own instance is not guaranteed to survive navigation, AppData is), so every Foundation
	// Docs page after the first paints highlights instantly.
	_vocabularyCache()
	{
		if (!this.pict.AppData.VocabularyCache) { this.pict.AppData.VocabularyCache = { Map: null, Promise: null }; }
		return this.pict.AppData.VocabularyCache;
	}

	_loadVocabularyMap()
	{
		let tmpCache = this._vocabularyCache();
		if (tmpCache.Map) { return Promise.resolve(tmpCache.Map); }
		if (tmpCache.Promise) { return tmpCache.Promise; }
		tmpCache.Promise = libFrameworkClient.getJSON(this.pict, '/1.0/docs/_vocabulary.json')
			.then((pResult) => { tmpCache.Map = (pResult && pResult.Terms) || {}; return tmpCache.Map; })
			.catch(() => { tmpCache.Map = {}; return tmpCache.Map; });
		return tmpCache.Promise;
	}

	// (pWord) => {slug, title, short} | null -- the contract pict-section-content's parseInline()
	// calls. Reads the live cache object (not a snapshot), so it starts resolving the instant the
	// fetch above lands even if that happens after this function was handed to the provider.
	_vocabularyResolver(pWord)
	{
		let tmpMap = this._vocabularyCache().Map;
		if (!tmpMap) { return null; }
		return tmpMap[String(pWord || '').toLowerCase()] || null;
	}

	_escapeHTML(pText)
	{
		return String(pText || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	// Scan the rendered content for .pict-vocab-term spans (wrapped by pict-section-content's
	// _applyVocabularyLinks) and attach a hover popover to each, reusing pict-section-modal's
	// richTooltip -- the same tooltip primitive the inline-doc module's own Topic tooltips use.
	// Called after every displayContent(), so old handles (pointing at now-detached elements from
	// the previous document) are torn down first.
	_wireVocabPopovers()
	{
		for (let i = 0; i < this._vocabTooltipHandles.length; i++)
		{
			if (this._vocabTooltipHandles[i] && typeof this._vocabTooltipHandles[i].destroy === 'function')
			{
				this._vocabTooltipHandles[i].destroy();
			}
		}
		this._vocabTooltipHandles = [];

		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.richTooltip !== 'function' || typeof document === 'undefined') { return; }

		let tmpContainer = document.getElementById('InlineDoc-Container');
		if (!tmpContainer) { return; }

		let tmpElements = tmpContainer.querySelectorAll('.pict-vocab-term');
		for (let i = 0; i < tmpElements.length; i++)
		{
			let tmpElement = tmpElements[i];
			let tmpTitle = tmpElement.getAttribute('data-vocab-title') || '';
			let tmpShort = tmpElement.getAttribute('data-vocab-short') || '';
			let tmpSlug = tmpElement.getAttribute('data-vocab-slug') || '';
			let tmpHTML = '<div class="pict-vocab-popover">'
				+ '<div class="pict-vocab-popover-title">' + this._escapeHTML(tmpTitle) + '</div>'
				+ (tmpShort ? '<div class="pict-vocab-popover-short">' + this._escapeHTML(tmpShort) + '</div>' : '')
				+ '<a href="javascript:void(0)" class="pict-vocab-popover-link" data-vocab-open="' + this._escapeHTML(tmpSlug) + '">View definition &rarr;</a>'
				+ '</div>';
			this._vocabTooltipHandles.push(tmpModal.richTooltip(tmpElement, tmpHTML, { interactive: true, maxWidth: '320px' }));
		}

		this._installVocabClickHandler();
	}

	// One document-level delegated listener (installed once) for the popover's "View definition"
	// link -- the tooltip DOM node is created lazily by pict-modal-tooltip on hover, so there is
	// nothing to bind a per-element listener to until the popover is actually showing.
	_installVocabClickHandler()
	{
		if (this._vocabClickHandlerInstalled || typeof document === 'undefined') { return; }
		this._vocabClickHandlerInstalled = true;
		let tmpView = this;
		document.addEventListener('click', (pEvent) =>
		{
			let tmpTarget = pEvent.target;
			while (tmpTarget && tmpTarget !== document)
			{
				if (tmpTarget.hasAttribute && tmpTarget.hasAttribute('data-vocab-open'))
				{
					let tmpSlug = tmpTarget.getAttribute('data-vocab-open');
					let tmpProvider = tmpView._provider();
					if (tmpSlug && tmpProvider && typeof tmpProvider.loadDocument === 'function')
					{
						// Vocabulary docs always live under vocabulary/ (the folder VocabularyDictionary
						// reads); the .pict-vocab-term span only carries the bare slug, not a full path.
						tmpProvider.loadDocument('vocabulary/' + tmpSlug + '.md');
					}
					return;
				}
				tmpTarget = tmpTarget.parentNode;
			}
		});
	}

	// Every render call site the module offers (a fresh load, an edit save, the image viewer) funnels
	// through the content view's displayContent(), so patching it once here catches vocab spans from
	// all of them -- no need to also patch loadDocument/saveEdit separately.
	_wireVocabRenderHook()
	{
		let tmpContentView = this.pict.views['InlineDoc-Content'];
		if (!tmpContentView || tmpContentView._vocabRenderHookPatched || typeof tmpContentView.displayContent !== 'function') { return; }
		let tmpView = this;
		let tmpOriginal = tmpContentView.displayContent.bind(tmpContentView);
		tmpContentView.displayContent = function (pHTMLContent)
		{
			let tmpResult = tmpOriginal(pHTMLContent);
			tmpView._wireVocabPopovers();
			tmpView._enhanceDocSvgs();
			return tmpResult;
		};
		tmpContentView._vocabRenderHookPatched = true;
	}

	// ─── smarter SVG diagram backing ─────────────────────────────────────
	// Diagram SVGs ship as dark ink on a transparent canvas and vanish on a dark page, so Brand-Chrome
	// backs every .svg <img> with a light "paper" card by default. That is wrong for an SVG that already
	// paints its own background, or that is drawn in light ink (already dark-mode-friendly). An <img> is
	// opaque to the DOM, so we fetch the SVG source (same-origin, from the lake), inspect it, and tag the
	// ones that do NOT need paper with .pict-content-svg-bare -- which strips the card back off.
	_enhanceDocSvgs()
	{
		if (typeof document === 'undefined' || typeof fetch === 'undefined') { return; }
		let tmpRoot = document.querySelector('.ps-fdocs .pict-content');
		if (!tmpRoot) { return; }
		let tmpImgs = tmpRoot.querySelectorAll('img[src*=".svg"]');
		for (let i = 0; i < tmpImgs.length; i++)
		{
			let tmpImg = tmpImgs[i];
			if (tmpImg.getAttribute('data-svg-paper-checked')) { continue; }
			tmpImg.setAttribute('data-svg-paper-checked', '1');
			this._classifyDocSvg(tmpImg);
		}
	}

	_classifyDocSvg(pImg)
	{
		let tmpSrc = pImg.getAttribute('src');
		if (!tmpSrc) { return; }
		let tmpSelf = this;
		fetch(tmpSrc).then((pResp) => (pResp && pResp.ok) ? pResp.text() : '').then((pText) =>
		{
			// Default is paper; only strip it when the SVG clearly does not need it.
			if (pText && !tmpSelf._svgNeedsPaper(pText)) { pImg.classList.add('pict-content-svg-bare'); }
		}).catch(() => { /* on any failure, leave the default paper in place */ });
	}

	// An SVG needs the paper card when it paints NO background of its own AND its ink is dark (so it would
	// disappear on a dark page). An SVG that paints its own background, or is drawn in light ink, is left
	// bare. An unparseable SVG defaults to paper (the safe choice for this corpus).
	_svgNeedsPaper(pText)
	{
		try
		{
			let tmpDoc = new DOMParser().parseFromString(pText, 'image/svg+xml');
			if (tmpDoc.querySelector('parsererror')) { return true; }
			let tmpSVG = tmpDoc.querySelector('svg');
			if (!tmpSVG) { return true; }
			// 1) Own background? A non-transparent background on the root style, or a near-origin full-canvas rect.
			if (/background(-color)?\s*:\s*(?!\s*(transparent|none))/i.test(tmpSVG.getAttribute('style') || '')) { return false; }
			// Canvas size from the viewBox (fall back to width/height) so a full-canvas background rect is
			// recognized at ANY diagram size, not just large ones.
			let tmpVB = (tmpSVG.getAttribute('viewBox') || '').split(/[\s,]+/).map((p) => parseFloat(p));
			let tmpCanvasW = (tmpVB.length === 4 && !isNaN(tmpVB[2])) ? tmpVB[2] : (parseFloat(tmpSVG.getAttribute('width')) || 0);
			let tmpCanvasH = (tmpVB.length === 4 && !isNaN(tmpVB[3])) ? tmpVB[3] : (parseFloat(tmpSVG.getAttribute('height')) || 0);
			let tmpRects = tmpSVG.getElementsByTagName('rect');
			for (let i = 0; i < tmpRects.length; i++)
			{
				let tmpR = tmpRects[i];
				let tmpFill = (tmpR.getAttribute('fill') || '').trim().toLowerCase();
				if (!tmpFill || tmpFill === 'none' || tmpFill === 'transparent') { continue; }
				let tmpX = parseFloat(tmpR.getAttribute('x') || '0');
				let tmpY = parseFloat(tmpR.getAttribute('y') || '0');
				let tmpW = tmpR.getAttribute('width') || '';
				let tmpH = tmpR.getAttribute('height') || '';
				let tmpFullW = /%/.test(tmpW) || (tmpCanvasW ? parseFloat(tmpW) >= tmpCanvasW * 0.92 : parseFloat(tmpW) >= 100);
				let tmpFullH = /%/.test(tmpH) || (tmpCanvasH ? parseFloat(tmpH) >= tmpCanvasH * 0.92 : parseFloat(tmpH) >= 100);
				let tmpNearOriginX = Math.abs(tmpX) <= (tmpCanvasW ? tmpCanvasW * 0.04 + 2 : 4);
				let tmpNearOriginY = Math.abs(tmpY) <= (tmpCanvasH ? tmpCanvasH * 0.04 + 2 : 4);
				if (tmpFullW && tmpFullH && tmpNearOriginX && tmpNearOriginY) { return false; }
			}
			// 2) Transparent canvas. Dark ink -> needs paper; light ink -> already fine on a dark page.
			return this._svgInkLuminance(tmpSVG) < 0.5;
		}
		catch (pErr) { return true; }
	}

	// Average luminance (0 dark .. 1 light) of the SVG's ink. A fillable element with no fill paints black
	// by default, so a plain black-text diagram reads as dark. Sampled and capped so a huge SVG stays cheap.
	_svgInkLuminance(pSVG)
	{
		let tmpEls = pSVG.querySelectorAll('path, text, tspan, line, polyline, polygon, circle, ellipse');
		let tmpLimit = Math.min(tmpEls.length, 400);
		let tmpTotal = 0;
		let tmpCount = 0;
		for (let i = 0; i < tmpLimit; i++)
		{
			let tmpEl = tmpEls[i];
			let tmpTag = tmpEl.tagName.toLowerCase();
			let tmpFill = (tmpEl.getAttribute('fill') || '').trim().toLowerCase();
			let tmpStroke = (tmpEl.getAttribute('stroke') || '').trim().toLowerCase();
			let tmpFillable = /path|text|tspan|polygon|circle|ellipse/.test(tmpTag);
			if (tmpFillable && tmpFill === '' && tmpStroke === '') { tmpTotal += 0; tmpCount++; continue; } // default black ink
			let tmpColors = [tmpFill, tmpStroke].filter((c) => c && c !== 'none' && c !== 'transparent' && c !== 'currentcolor');
			for (let j = 0; j < tmpColors.length; j++)
			{
				let tmpL = this._colorLuminance(tmpColors[j]);
				if (tmpL !== null) { tmpTotal += tmpL; tmpCount++; }
			}
		}
		return tmpCount ? (tmpTotal / tmpCount) : 0;
	}

	// Parse a CSS color to relative luminance 0..1. Handles #rgb / #rrggbb, rgb()/rgba(), and a few names.
	// Returns null for colors it cannot read (keywords it does not know, url() paints, etc.).
	_colorLuminance(pColor)
	{
		let tmpC = String(pColor).trim().toLowerCase();
		let tmpNamed = { black: [0, 0, 0], white: [255, 255, 255], gray: [128, 128, 128], grey: [128, 128, 128], silver: [192, 192, 192], red: [255, 0, 0], green: [0, 128, 0], blue: [0, 0, 255] };
		let tmpR;
		let tmpG;
		let tmpB;
		if (Object.prototype.hasOwnProperty.call(tmpNamed, tmpC)) { tmpR = tmpNamed[tmpC][0]; tmpG = tmpNamed[tmpC][1]; tmpB = tmpNamed[tmpC][2]; }
		else if (tmpC.charAt(0) === '#')
		{
			let tmpHex = tmpC.slice(1);
			if (tmpHex.length === 3) { tmpHex = tmpHex.charAt(0) + tmpHex.charAt(0) + tmpHex.charAt(1) + tmpHex.charAt(1) + tmpHex.charAt(2) + tmpHex.charAt(2); }
			if (tmpHex.length < 6) { return null; }
			tmpR = parseInt(tmpHex.slice(0, 2), 16); tmpG = parseInt(tmpHex.slice(2, 4), 16); tmpB = parseInt(tmpHex.slice(4, 6), 16);
		}
		else
		{
			let tmpMatch = tmpC.match(/rgba?\(([^)]+)\)/);
			if (!tmpMatch) { return null; }
			let tmpParts = tmpMatch[1].split(',').map((p) => parseFloat(p));
			tmpR = tmpParts[0]; tmpG = tmpParts[1]; tmpB = tmpParts[2];
		}
		if (isNaN(tmpR) || isNaN(tmpG) || isNaN(tmpB)) { return null; }
		return (0.2126 * tmpR + 0.7152 * tmpG + 0.0722 * tmpB) / 255;
	}

	// ─── version history (WI #187) ───────────────────────────────────────
	// pict-section-dochistory ships two independent views and no transport; the host
	// registers them and supplies the two reads. They are registered lazily, the first time
	// someone opens history, so a reader that never asks for it pays nothing.
	_ensureHistoryViews()
	{
		if (this._historyViewsRegistered) { return; }
		if (!this.pict.views['Plansheet-DocHistory-Timeline'])
		{
			this.pict.addView('Plansheet-DocHistory-Timeline',
				Object.assign({}, libDocHistory.TimelineView.default_configuration,
					{
						Title: '',
						onLoadHistory: (pPath, pLimit, fCallback) =>
						{
							let tmpQuery = '/1.0/docs/history?limit=' + encodeURIComponent(pLimit)
								+ (pPath ? ('&path=' + encodeURIComponent(pPath)) : '');
							libFrameworkClient.getJSON(this.pict, tmpQuery)
								.then((pResult) => fCallback(null, pResult))
								.catch((pErr) => fCallback(pErr));
						},
						onSelectVersion: (pEvent, pPrevious, pPath) =>
						{
							let tmpDiff = this.pict.views['Plansheet-DocHistory-Diff'];
							if (tmpDiff) { tmpDiff.showDiff(pPrevious ? (pPrevious.Commit || '') : '', pEvent.Commit || '', pPath || ''); }
						}
					}),
				libDocHistory.TimelineView);
		}
		if (!this.pict.views['Plansheet-DocHistory-Diff'])
		{
			this.pict.addView('Plansheet-DocHistory-Diff',
				Object.assign({}, libDocHistory.DiffView.default_configuration,
					{
						onLoadDiff: (pFrom, pTo, pPath, fCallback) =>
						{
							let tmpQuery = '/1.0/docs/diff?to=' + encodeURIComponent(pTo)
								+ (pFrom ? ('&from=' + encodeURIComponent(pFrom)) : '')
								+ (pPath ? ('&path=' + encodeURIComponent(pPath)) : '');
							libFrameworkClient.getJSON(this.pict, tmpQuery)
								.then((pResult) => fCallback(null, pResult))
								.catch((pErr) => fCallback(pErr));
						}
					}),
				libDocHistory.DiffView);
		}
		this._historyViewsRegistered = true;
	}

	// The path of the document currently open in the reader (the inline-doc section tracks it).
	_currentDocPath()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		return String((tmpState && tmpState.CurrentPath) || this._loadSlug || '').replace(/^\/+/, '').split('#')[0];
	}

	// Inline handler: open the history of the document being read.
	openHistory()
	{
		let tmpPath = this._currentDocPath();
		this._ensureHistoryViews();
		let tmpPanel = document.getElementById('FoundationDocs-HistoryPanel');
		if (tmpPanel) { tmpPanel.classList.add('ps-fdocs-history-open'); }
		this.pict.ContentAssignment.assignContent('#FoundationDocs-HistoryPath', tmpPath || 'the whole library');

		let tmpDiff = this.pict.views['Plansheet-DocHistory-Diff'];
		if (tmpDiff) { tmpDiff.clear(); }
		let tmpTimeline = this.pict.views['Plansheet-DocHistory-Timeline'];
		if (!tmpTimeline) { return; }
		// setPath reloads; the timeline selects the newest version, and selecting it drives the
		// diff pane, so opening history lands on "what changed most recently" with no extra click.
		tmpTimeline.setPath(tmpPath).then(() =>
		{
			let tmpSelected = tmpTimeline.selectedEvent();
			if (tmpSelected)
			{
				let tmpEvents = tmpTimeline.events();
				let tmpPrevious = tmpEvents[1] || (tmpSelected.Parent ? { Commit: tmpSelected.Parent } : null);
				if (tmpDiff) { tmpDiff.showDiff(tmpPrevious ? (tmpPrevious.Commit || '') : '', tmpSelected.Commit || '', tmpPath); }
			}
		});
	}

	// Inline handler: close the history panel.
	closeHistory()
	{
		let tmpPanel = document.getElementById('FoundationDocs-HistoryPanel');
		if (tmpPanel) { tmpPanel.classList.remove('ps-fdocs-history-open'); }
	}

	// ─── conflicts (WI #221) ─────────────────────────────────────────────
	// A conflict happens when the same document changed here and in the connected repository
	// at once. The reconciler keeps BOTH versions (so nothing is lost) by writing standard
	// markers into the text -- which is a developer's notation, and the person most likely to
	// be looking at it is an author who has never seen one. So the reader states the situation
	// in plain words and offers the decision as three buttons; the server picks the hunks.
	_refreshConflicts()
	{
		return libFrameworkClient.getJSON(this.pict, '/1.0/docs/tree')
			.then((pResult) =>
			{
				let tmpNodes = (pResult && pResult.Nodes) || [];
				this._conflictPaths = tmpNodes
					.filter((pNode) => String(pNode.ConflictState || '') === 'NeedsResolution')
					.map((pNode) => String(pNode.Path));
				this._renderConflictState();
			})
			// Silence, not an error surface: a failed check must not block reading or writing.
			.catch(() => { this._conflictPaths = []; this._renderConflictState(); });
	}

	_renderConflictState()
	{
		let tmpPaths = this._conflictPaths || [];
		let tmpCurrent = this._currentDocPath();
		let tmpIsCurrent = tmpPaths.indexOf(tmpCurrent) >= 0;

		// The banner: only for the document actually open, so it reads as being about what the
		// person is looking at rather than as a site-wide alarm.
		let tmpBanner = '';
		if (tmpIsCurrent)
		{
			tmpBanner = '<div class="ps-fdocs-conflict">'
				+ '<div class="ps-fdocs-conflict-text">'
				+ '<strong>This document was changed in two places at once.</strong> '
				+ 'It was edited here and in the connected repository before the two were brought together. '
				+ 'Both versions are kept below. Choose which one to keep.'
				+ '</div>'
				+ '<div class="ps-fdocs-conflict-actions">'
				+ '<button type="button" class="ps-fdocs-cbtn ps-fdocs-cbtn-primary" onclick="_Pict.views[\'Plansheet-FoundationDocs\'].resolveConflict(\'mine\')">Keep what I wrote</button>'
				+ '<button type="button" class="ps-fdocs-cbtn" onclick="_Pict.views[\'Plansheet-FoundationDocs\'].resolveConflict(\'theirs\')">Use the incoming version</button>'
				+ '<button type="button" class="ps-fdocs-cbtn" onclick="_Pict.views[\'Plansheet-FoundationDocs\'].editConflictByHand()">Let me edit it</button>'
				+ '</div></div>';
		}
		this.pict.ContentAssignment.assignContent('#FoundationDocs-ConflictBanner', tmpBanner);

		// The toolbar chip: the way to FIND a conflicted document that is not the one open.
		let tmpOthers = tmpPaths.filter((pPath) => pPath !== tmpCurrent);
		let tmpChip = '';
		if (tmpOthers.length)
		{
			let tmpLabel = (tmpOthers.length === 1) ? '1 document needs a decision' : (tmpOthers.length + ' documents need a decision');
			tmpChip = '<button type="button" class="ps-fdocs-cchip" title="Open the next one" onclick="_Pict.views[\'Plansheet-FoundationDocs\'].openNextConflict()">' + tmpLabel + '</button>';
		}
		this.pict.ContentAssignment.assignContent('#FoundationDocs-ConflictChip', tmpChip);
	}

	// The inline-doc provider memoizes fetched documents by URL and exposes no way to
	// invalidate one. A resolve changes a document's bytes SERVER-side without going through
	// the editor, so without this the reader would keep showing the pre-resolution text (with
	// its markers) until a full page reload. Dropping the whole cache is safe: it is only a
	// cache, and the next load refetches.
	_invalidateDocCache()
	{
		let tmpProvider = this._provider();
		if (tmpProvider && tmpProvider._ContentCache) { tmpProvider._ContentCache = {}; }
	}

	// Inline handler: jump to the next document waiting on a decision.
	openNextConflict()
	{
		let tmpCurrent = this._currentDocPath();
		let tmpNext = (this._conflictPaths || []).filter((pPath) => pPath !== tmpCurrent)[0];
		if (!tmpNext) { return; }
		let tmpProvider = this._provider();
		if (tmpProvider && typeof tmpProvider.loadDocument === 'function')
		{
			tmpProvider.loadDocument(tmpNext, () => this._renderConflictState());
		}
	}

	// Inline handler: take one side. The server derives both versions from the markers, so
	// nothing here has to parse or even mention them.
	resolveConflict(pResolution)
	{
		let tmpPath = this._currentDocPath();
		if (!tmpPath) { return; }
		libFrameworkClient.postJSON(this.pict, '/1.0/docs/resolve', { Path: tmpPath, Resolution: String(pResolution || '') })
			.then((pResult) =>
			{
				if (pResult && pResult.AlreadyResolved) { this._toast('That document was already resolved.', 'info'); }
				else { this._toast((pResolution === 'mine') ? 'Kept the version written here.' : 'Took the incoming version.', 'info'); }
				this._invalidateDocCache();
				let tmpProvider = this._provider();
				if (tmpProvider && typeof tmpProvider.loadDocument === 'function') { tmpProvider.loadDocument(tmpPath); }
				return this._refreshConflicts().then(() => this._renderPublishState());
			})
			.catch((pErr) => this._toast('Could not resolve this document: ' + ((pErr && pErr.message) || pErr), 'error'));
	}

	// Inline handler: the hand-edit path, kept for people who already read this notation. The
	// document still holds the merged text with its markers; the ordinary editor saves it, and
	// the save route clears the badge once the markers are gone.
	editConflictByHand()
	{
		this._toast('Open the editor and remove the parts you do not want, then save. The notice clears once the markers are gone.', 'info');
	}

	// ─── publishing indicator (WI #366) ──────────────────────────────────
	// Whether what an author wrote has reached the connected repository yet, in words
	// someone who has never run git can act on. A plan sheet with no repository (or a
	// read-only one) shows NOTHING here -- authoring without sync is the ordinary case,
	// so it gets no banner, no badge and no invitation to go connect something.
	_renderPublishState()
	{
		return libFrameworkClient.getJSON(this.pict, '/1.0/docs/publish-state')
			.then((pState) =>
			{
				let tmpHTML = '';
				if (pState && pState.Publishing)
				{
					let tmpRepo = String(pState.Repo || '').replace(/[<>&]/g, '');
					let tmpState = String(pState.State || '');
					let tmpLabel = 'Published' + (tmpRepo ? (' to ' + tmpRepo) : '');
					if (tmpState === 'pending') { tmpLabel = 'Not published yet'; }
					else if (tmpState === 'error') { tmpLabel = 'Last publish did not go through'; }
					tmpHTML = '<span class="ps-fdocs-publish ps-fdocs-publish-' + (tmpState || 'published') + '">'
						+ '<span class="ps-fdocs-publish-dot"></span>' + tmpLabel + '</span>';
				}
				this.pict.ContentAssignment.assignContent('#FoundationDocs-PublishState', tmpHTML);
				return pState;
			})
			// Silence, not an error surface: an author who cannot see the indicator can still write.
			.catch(() => { this.pict.ContentAssignment.assignContent('#FoundationDocs-PublishState', ''); });
	}

	// Inline edits (when EditEnabled) commit to the lake as a platform-source commit.
	_onSave(pSaveData, fCallback)
	{
		// The Overview and the sidebar are generated from the tree server-side, not
		// stored documents, so the save API rejects their underscore-prefixed paths.
		// Catch that here: a clear message beats a silent HTTP 400. Real docs fall through.
		let tmpPath = String((pSaveData && (pSaveData.Path || pSaveData.path)) || '').replace(/^\/+/, '');
		if (!tmpPath || tmpPath.charAt(0) === '_')
		{
			this._toast('The Overview is generated automatically. Open a specific document from the list to edit it.', 'error');
			return fCallback('The Overview page is not directly editable.');
		}
		libFrameworkClient.putJSON(this.pict, '/1.0/docs/save', pSaveData)
			.then(() =>
			{
				// The save just advanced the lake head, so the indicator flips to "not
				// published yet" until the next sync carries it out. A save that removed the
				// markers by hand also clears the badge server-side, so re-read that too.
				this._renderPublishState();
				this._refreshConflicts();
				fCallback(null);
			})
			.catch((pErr) => fCallback((pErr && pErr.message) || String(pErr)));
	}

	// ─── structure management callbacks (delegate to the Docs Lake API) ──────
	// Each mirrors the onSave contract: fCallback(errorOrNull). The inline-doc module
	// handles the confirm/prompt UI and reloads its sidebar on success; here we only
	// translate the callback into a DocLakeAPI call and normalise the error message.
	_docLake() { return this.pict.providers.DocLakeAPI; }

	// Join a parent folder and a leaf name into a clean lake path (the leaf may itself
	// carry slashes, e.g. "guides/setup", which nests under the parent).
	_joinPath(pParent, pLeaf)
	{
		let tmpParent = String(pParent || '').replace(/^\/+|\/+$/g, '');
		let tmpLeaf = String(pLeaf || '').replace(/^\/+|\/+$/g, '');
		return tmpParent ? (tmpParent + '/' + tmpLeaf) : tmpLeaf;
	}

	_settle(pPromise, fCallback)
	{
		pPromise
			.then(() => fCallback(null))
			.catch((pErr) => fCallback((pErr && pErr.message) || String(pErr)));
	}

	_onCreateFolder(pParentPath, pName, fCallback)
	{
		let tmpPath = this._joinPath(pParentPath, pName);
		if (!tmpPath) { return fCallback('A folder name is required.'); }
		this._settle(this._docLake().createFolder(tmpPath), fCallback);
	}

	_onCreateDocument(pParentPath, pName, fCallback)
	{
		let tmpPath = this._joinPath(pParentPath, pName);
		if (!tmpPath) { return fCallback('A document name is required.'); }
		if (!/\.md$/i.test(tmpPath)) { tmpPath = tmpPath + '.md'; }
		// A new document needs a first byte to exist; seed it with an H1 from its name.
		let tmpTitle = tmpPath.slice(tmpPath.lastIndexOf('/') + 1).replace(/\.md$/i, '').replace(/[-_]+/g, ' ').trim();
		let tmpBody = '# ' + (tmpTitle || 'New Document') + '\n';
		this._settle(this._docLake().saveDoc(tmpPath, tmpBody), fCallback);
	}

	_onDeleteNode(pPath, pNodeType, fCallback)
	{
		if (!pPath) { return fCallback('Nothing to delete.'); }
		this._settle(this._docLake().deleteNode(pPath), fCallback);
	}

	_onMoveNode(pFrom, pTo, fCallback)
	{
		if (!pFrom || !pTo) { return fCallback('A source and destination are required.'); }
		this._settle(this._docLake().moveNode(pFrom, pTo), fCallback);
	}

	_onReorder(pParentPath, pOrderedNames, fCallback)
	{
		this._settle(this._docLake().reorder(pParentPath || '', pOrderedNames || []), fCallback);
	}

	// The configured landing document for this plan sheet (DocsLandingPath on the session, set by a
	// doc sync to the repo overview; see fEnsureLandingPage). Falls back to index.md, which the server
	// serves as the generated Welcome placeholder when no index.md exists.
	_landingSlug()
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		let tmpLanding = (typeof tmpUser.DocsLandingPath === 'string') ? tmpUser.DocsLandingPath.trim() : '';
		return tmpLanding || 'index.md';
	}

	showOverview() { this._loadSlug = this._landingSlug(); this.render(); }

	showSlug(pPath)
	{
		let tmpPath = String(pPath || 'index');
		let tmpAnchor = '';
		let tmpHashIdx = tmpPath.indexOf('#');
		if (tmpHashIdx >= 0) { tmpAnchor = tmpPath.slice(tmpHashIdx); tmpPath = tmpPath.slice(0, tmpHashIdx); }
		// Append .md only for a bare slug; a path that already names a file type (an image, ...)
		// is left as-is so the reader can open it (loadDocument handles the extension too).
		this._loadSlug = (/\.[a-z0-9]+$/i.test(tmpPath) ? tmpPath : (tmpPath + '.md')) + tmpAnchor;
		this.render();
	}

	// The inline-doc section ships its nav outline collapsed and force-collapses
	// it again after every loadDocument (compact mode). We keep it open: default
	// the outline open, and after a navigation restore the open state if it was
	// open before the click (so a user who collapses it on purpose keeps it that
	// way). It also re-renders the nav on every load, which rebuilds the scroll
	// container (#InlineDoc-Nav-Outline) and snaps it back to the top - so we
	// snapshot and restore its scroll position too. Patches the instance once;
	// the section exposes no option for either behavior.
	_keepNavOpen(pProvider)
	{
		if (!pProvider || pProvider._navKeepOpenPatched || typeof pProvider.loadDocument !== 'function') { return; }
		let tmpView = this;
		let tmpOriginal = pProvider.loadDocument.bind(pProvider);
		let fScrollTop = () => { let tmpEl = document.getElementById('InlineDoc-Nav-Outline'); return tmpEl ? tmpEl.scrollTop : 0; };
		let fRestoreScroll = (pTop) =>
		{
			let tmpEl = document.getElementById('InlineDoc-Nav-Outline');
			if (tmpEl) { tmpEl.scrollTop = pTop; }
			// Re-apply after paint in case the re-render settles layout late.
			if (typeof requestAnimationFrame === 'function')
			{
				requestAnimationFrame(() => { let tmpLate = document.getElementById('InlineDoc-Nav-Outline'); if (tmpLate) { tmpLate.scrollTop = pTop; } });
			}
		};
		pProvider.loadDocument = function (pPath, fCallback)
		{
			let tmpState = tmpView.pict.AppData.InlineDocumentation;
			let tmpWasOpen = !!(tmpState && tmpState.NavCollapsed === false);
			let tmpScroll = fScrollTop();
			let tmpLoadAnchor = '';
			let tmpAnchorIdx = String(pPath).indexOf('#');
			if (tmpAnchorIdx >= 0) { tmpLoadAnchor = String(pPath).slice(tmpAnchorIdx + 1); }
			return tmpOriginal(pPath, function (pError, pHTML)
			{
				if (tmpWasOpen && tmpState && tmpState.NavCollapsed !== false)
				{
					tmpState.NavCollapsed = false;
					let tmpNav = tmpView.pict.views['InlineDoc-Nav'];
					if (tmpNav) { tmpNav.render(); }
				}
				fRestoreScroll(tmpScroll);
				// Keep the browser URL in sync with the loaded document (and the
				// section it targeted, if any) so links are copy/paste stable;
				// syncDocURL navigates idempotently and does not reload the doc.
				let tmpApp = tmpView.pict.PictApplication;
				if (tmpApp && typeof tmpApp.syncDocURL === 'function' && tmpState && tmpState.CurrentPath)
				{
					tmpApp.syncDocURL(tmpState.CurrentPath, tmpLoadAnchor);
				}
				if (typeof fCallback === 'function') { fCallback(pError, pHTML); }
			});
		};

		// Heading clicks (and anchored loads) call _scrollToAnchor; mirror the
		// scrolled-to section into the URL so section links are copy/paste stable.
		if (typeof pProvider._scrollToAnchor === 'function' && !pProvider._scrollSyncPatched)
		{
			let tmpScrollOriginal = pProvider._scrollToAnchor.bind(pProvider);
			pProvider._scrollToAnchor = function (pAnchor)
			{
				let tmpResult = tmpScrollOriginal(pAnchor);
				let tmpApp = tmpView.pict.PictApplication;
				let tmpScrollState = tmpView.pict.AppData.InlineDocumentation;
				if (tmpApp && !tmpApp._suppressDocURLSync && typeof tmpApp.syncDocURL === 'function' && tmpScrollState && tmpScrollState.CurrentPath && pAnchor)
				{
					tmpApp.syncDocURL(tmpScrollState.CurrentPath, pAnchor);
				}
				return tmpResult;
			};
			pProvider._scrollSyncPatched = true;
		}
		pProvider._navKeepOpenPatched = true;
	}

	// Set up the inline-doc provider ONCE: DocsBaseURL, edit callbacks, vocabulary, the sidebar tree. This
	// is what paints the tree into the sidebar's Documentation tab (the app re-points the Nav view there).
	// It deliberately does NOT load a document -- the reader loads the current doc separately in
	// _initSection -- so the Documentation tab can show the tree WITHOUT the reader being mounted and
	// WITHOUT changing the page. Returns a cached promise so repeat callers (the tab + the reader) share it.
	ensureDocsProviderInited()
	{
		if (this._docsInitPromise) { return this._docsInitPromise; }
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.initializeDocumentation !== 'function') { return Promise.resolve(); }
		this._keepNavOpen(tmpProvider);
		this._wireVocabRenderHook();
		// Editing the team library is a content.edit act: contributors get the edit affordances, everyone
		// else reads.
		let tmpApp = this.pict.PictApplication;
		let tmpCanEdit = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		let tmpInitOptions =
		{
			DocsBaseURL: '/1.0/docs/',
			ContainerAddress: '#InlineDoc-Container',
			EditEnabled: tmpCanEdit,
			// Topic Management is a dead feature (no persistence); the F1 Help Drawer is the real one. WI #185.
			TopicManagerEnabled: false,
			AssetToggleEnabled: true,
			// The tree lists files (and folders) only; the in-document heading outline is noise here.
			ShowDocumentHeadings: false,
			onSave: (pData, fCb) => this._onSave(pData, fCb),
			VocabularyResolver: (pWord) => this._vocabularyResolver(pWord)
		};
		if (tmpCanEdit)
		{
			tmpInitOptions.onCreateFolder = (pParentPath, pName, fCb) => this._onCreateFolder(pParentPath, pName, fCb);
			tmpInitOptions.onCreateDocument = (pParentPath, pName, fCb) => this._onCreateDocument(pParentPath, pName, fCb);
			tmpInitOptions.onDeleteNode = (pPath, pNodeType, fCb) => this._onDeleteNode(pPath, pNodeType, fCb);
			tmpInitOptions.onMoveNode = (pFrom, pTo, fCb) => this._onMoveNode(pFrom, pTo, fCb);
			tmpInitOptions.onReorder = (pParentPath, pOrderedNames, fCb) => this._onReorder(pParentPath, pOrderedNames, fCb);
		}
		let tmpSelf = this;
		// Wait for the vocabulary map before init so the first document paints with highlights.
		this._docsInitPromise = this._loadVocabularyMap().then(() => new Promise((pResolve) =>
		{
			tmpProvider.initializeDocumentation(tmpInitOptions, () =>
			{
				// Default the navigation outline open (the section ships it collapsed).
				if (tmpSelf.pict.AppData.InlineDocumentation) { tmpSelf.pict.AppData.InlineDocumentation.NavCollapsed = false; }
				pResolve();
			});
		}));
		return this._docsInitPromise;
	}

	// On a reader render: make sure the provider is set up, then render the article layout into the reader
	// (creating the content pane) and load the requested document. The tree itself lives in the sidebar.
	_initSection()
	{
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.initializeDocumentation !== 'function')
		{
			this.pict.ContentAssignment.assignContent('#InlineDoc-Container',
				'<div style="padding:24px;color:var(--theme-color-text-secondary,#5b6376)">Documentation section is not available in this build.</div>');
			return;
		}
		let tmpSelf = this;
		this.ensureDocsProviderInited().then(() =>
		{
			// The reader is mounted now, so (re)render the inline-doc layout into #InlineDoc-Container to
			// create the article pane, then load the requested doc into it.
			let tmpLayout = tmpSelf.pict.views['InlineDoc-Layout'];
			if (tmpLayout && typeof tmpLayout.render === 'function') { tmpLayout.render(); }
			tmpProvider.loadDocument(tmpSelf._loadSlug || 'index.md');
		});
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._initSection();
		this._renderPublishState();
		this._refreshConflicts();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewFoundationDocs;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-FoundationDocs',
	DefaultRenderable: 'FoundationDocs-Display',
	AutoRender: false,
	CSS: /*css*/`
		.ps-fdocs { height: 100%; display: flex; flex-direction: column; box-sizing: border-box; position: relative; }
		.ps-fdocs-toolbar {
			display: flex; align-items: center; gap: 8px; padding: 12px 20px;
			border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee);
			background: var(--theme-color-background-panel, #fff);
		}
		.ps-fdocs-title { font-size: 16px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
		.ps-fdocs-spacer { flex: 1; }

		/* Publishing indicator (WI #366): a quiet status line, not a dashboard. Absent
		   entirely when the plan sheet publishes nowhere. */
		.ps-fdocs-publish {
			display: inline-flex; align-items: center; gap: 6px;
			font-size: 12px; color: var(--theme-color-text-secondary, #5b6376);
			white-space: nowrap;
		}
		.ps-fdocs-publish-dot {
			width: 7px; height: 7px; border-radius: 50%;
			background: var(--theme-color-text-secondary, #5b6376);
			flex: none;
		}
		.ps-fdocs-publish-published .ps-fdocs-publish-dot { background: var(--theme-color-status-success, #2e9e5b); }
		.ps-fdocs-publish-pending .ps-fdocs-publish-dot { background: var(--theme-color-status-warning, #d0902f); }
		.ps-fdocs-publish-error .ps-fdocs-publish-dot { background: var(--theme-color-status-error, #c8452f); }
		.ps-fdocs-publish-error { color: var(--theme-color-status-error, #c8452f); }

		/* The conflict notice. Stated in words, above the document it is about; a person never
		   has to know what a marker is to act on it. */
		.ps-fdocs-conflict {
			display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
			padding: 12px 20px;
			border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee);
			border-left: 3px solid var(--theme-color-status-warning, #d0902f);
			background: color-mix(in srgb, var(--theme-color-status-warning, #d0902f) 12%, transparent);
			color: var(--theme-color-text-primary, #2c3140);
			font-size: 13px; line-height: 1.5;
		}
		.ps-fdocs-conflict-text { flex: 1; min-width: 260px; }
		.ps-fdocs-conflict-actions { display: flex; gap: 8px; flex-wrap: wrap; }
		.ps-fdocs-cbtn {
			border: 1px solid var(--theme-color-border-strong, #46505c);
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #2c3140);
			border-radius: 6px; padding: 6px 12px; font-size: 12px; cursor: pointer; white-space: nowrap;
		}
		.ps-fdocs-cbtn:hover { background: var(--theme-color-background-hover, #f4f6fa); }
		.ps-fdocs-cbtn-primary {
			border-color: var(--theme-color-brand-primary, #4f95e8);
			color: var(--theme-color-brand-primary, #4f95e8);
			font-weight: 600;
		}
		.ps-fdocs-cchip {
			border: 1px solid var(--theme-color-status-warning, #d0902f);
			background: transparent; color: var(--theme-color-status-warning, #d0902f);
			border-radius: 999px; padding: 3px 10px; font-size: 12px; cursor: pointer; white-space: nowrap;
		}
		.ps-fdocs-cchip:hover { background: color-mix(in srgb, var(--theme-color-status-warning, #d0902f) 15%, transparent); }

		.ps-fdocs-histbtn {
			border: 1px solid var(--theme-color-border-default, #e6e9ee);
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-secondary, #5b6376);
			border-radius: 6px; padding: 4px 10px; font-size: 12px; cursor: pointer;
		}
		.ps-fdocs-histbtn:hover {
			background: var(--theme-color-background-hover, #f4f6fa);
			color: var(--theme-color-text-primary, #2c3140);
		}

		/* The history panel covers the reader rather than squeezing it: the reader's own
		   layout is a three-pane thing already, and shrinking it to fit a diff makes both
		   unreadable. Hidden (not just transparent) when closed so it takes no hit testing. */
		.ps-fdocs-history {
			display: none; position: absolute; inset: 0; z-index: 40;
			background: var(--theme-color-background-panel, #fff);
			flex-direction: column;
		}
		.ps-fdocs-history-open { display: flex; }
		.ps-fdocs-history-bar {
			display: flex; align-items: center; gap: 8px; padding: 10px 16px;
			border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee);
			font-size: 13px; color: var(--theme-color-text-primary, #2c3140);
		}
		.ps-fdocs-history-title { font-weight: 600; }
		.ps-fdocs-history-path { font-weight: 400; color: var(--theme-color-text-secondary, #5b6376); overflow-wrap: anywhere; }
		.ps-fdocs-history-body { flex: 1; min-height: 0; display: flex; }
		.ps-fdocs-history-left {
			width: 320px; flex: none; min-height: 0; overflow: hidden; display: flex;
			border-right: 1px solid var(--theme-color-border-default, #e6e9ee);
		}
		.ps-fdocs-history-left > * { flex: 1; min-height: 0; }
		.ps-fdocs-history-right { flex: 1; min-width: 0; min-height: 0; overflow: hidden; }
		/* Narrow: stack the timeline over the diff instead of a 320px column crushing it. */
		@media (max-width: 900px) {
			.ps-fdocs-history-body { flex-direction: column; }
			.ps-fdocs-history-left { width: auto; max-height: 40%; border-right: 0; border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee); }
		}
		.ps-fdocs-host { flex: 1; min-height: 0; overflow: hidden; }
		.ps-fdocs-host #InlineDoc-Container, #InlineDoc-Container { height: 100%; }

		/* Vocabulary auto-markup (WI #184): known product terms get a dotted underline; hover/focus
		   pops the definition (pict-modal-tooltip's richTooltip, wired in _wireVocabPopovers). */
		.pict-vocab-term {
			border-bottom: 1px dotted var(--theme-color-brand-primary, #4f95e8);
			cursor: help;
		}
		.pict-vocab-popover-title {
			font-weight: 600;
			color: var(--theme-color-text-primary, #2c3140);
			margin-bottom: 4px;
		}
		.pict-vocab-popover-short {
			color: var(--theme-color-text-secondary, #5b6376);
			font-size: 13px;
			line-height: 1.4;
		}
		.pict-vocab-popover-link {
			display: inline-block;
			margin-top: 6px;
			font-size: 12px;
			color: var(--theme-color-brand-primary, #4f95e8);
			text-decoration: none;
		}
		.pict-vocab-popover-link:hover { text-decoration: underline; }
	`,
	Templates:
	[
		{
			Hash: 'FoundationDocs-Display',
			Template: /*html*/`
<div class="ps-fdocs">
	<div class="ps-fdocs-toolbar">
		<span class="ps-fdocs-spacer"></span>
		<span id="FoundationDocs-ConflictChip"></span>
		<span id="FoundationDocs-PublishState"></span>
		<button type="button" class="ps-fdocs-histbtn" title="See how this document changed" onclick="_Pict.views['Plansheet-FoundationDocs'].openHistory()">History</button>
	</div>
	<div id="FoundationDocs-ConflictBanner"></div>
	<div id="InlineDoc-Container" class="ps-fdocs-host"></div>
	<div id="FoundationDocs-HistoryPanel" class="ps-fdocs-history">
		<div class="ps-fdocs-history-bar">
			<span class="ps-fdocs-history-title">History of <span id="FoundationDocs-HistoryPath" class="ps-fdocs-history-path"></span></span>
			<span class="ps-fdocs-spacer"></span>
			<button type="button" class="ps-fdocs-histbtn" onclick="_Pict.views['Plansheet-FoundationDocs'].closeHistory()">Close</button>
		</div>
		<div class="ps-fdocs-history-body">
			<div id="DocHistory-Timeline-Container" class="ps-fdocs-history-left"></div>
			<div id="DocHistory-Diff-Container" class="ps-fdocs-history-right"></div>
		</div>
	</div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'FoundationDocs-Display',
			TemplateHash: 'FoundationDocs-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../providers/FrameworkClient.js":576,"pict-section-dochistory":201,"pict-view":365}],674:[function(require,module,exports){
'use strict';

/**
 * GalleryPage -- the full-page view of the caller's PRIVATE media (their personal gallery: direct
 * uploads plus every image pasted into a note), rendered into the main workspace
 * (#Plansheet-Workspace) rather than the notebook rail. It reads through providers.MediaAPI.listMine
 * and keeps its own render state under AppData.GalleryPage so the rail notebook's Gallery tab and
 * this page never share a buffer.
 *
 * Three item kinds:
 *   Image  -- images (MimeType starts with image/); shown as thumbnail, click copies
 *             a markdown image reference  ![Title](url) to the clipboard.
 *   File   -- any other binary upload; shown as a download-link card, click copies
 *             a markdown link reference   [Title](url) to the clipboard.
 *   Link   -- external URL entries (MediaType === 'Link'); shown as an external-link
 *             card that opens in a new tab; click icon copies [Title](url).
 *
 * Upload is a visible button plus a hidden multi-file input. The button does NOT use a
 * <label for> over a display:none input -- that path is unreliable in mobile Safari.
 * The button's onclick calls openPicker(), which programmatically clicks the input.
 *
 * URLs are added via addURLDialog(), which opens a pict-section-modal (no native
 * prompt/alert). The URL is stored in OriginalFileName; MediaType is set to 'Link'.
 */

const libPictView = require('pict-view');

// Short human-readable label for a file card (e.g. "PDF", "XLSX").
function _fileTypeLabel(pMime, pFileName)
{
	let tmpMime = String(pMime || '').toLowerCase();
	if (tmpMime === 'application/pdf') { return 'PDF'; }
	if (tmpMime === 'application/zip' || tmpMime === 'application/x-zip-compressed') { return 'ZIP'; }
	if (tmpMime.indexOf('spreadsheet') >= 0 || tmpMime.indexOf('excel') >= 0 || tmpMime === 'text/csv') { return 'Spreadsheet'; }
	if (tmpMime.indexOf('wordprocessing') >= 0 || tmpMime.indexOf('msword') >= 0) { return 'Document'; }
	if (tmpMime.indexOf('presentation') >= 0 || tmpMime.indexOf('powerpoint') >= 0) { return 'Slides'; }
	if (tmpMime.indexOf('text/') === 0) { return 'Text'; }
	if (tmpMime.indexOf('video/') === 0) { return 'Video'; }
	if (tmpMime.indexOf('audio/') === 0) { return 'Audio'; }
	let tmpName = String(pFileName || '');
	let tmpDot = tmpName.lastIndexOf('.');
	if (tmpDot >= 0) { return tmpName.slice(tmpDot + 1).toUpperCase().slice(0, 8) || 'File'; }
	return 'File';
}

class PictViewGalleryPage extends libPictView
{
	_page() { return this.pict.AppData.GalleryPage || (this.pict.AppData.GalleryPage = { Rows: [] }); }
	_media() { return this.pict.providers.MediaAPI; }

	// Load (or refresh) the caller's private media, then repaint the page.
	show()
	{
		let tmpMedia = this._media();
		if (!tmpMedia || typeof tmpMedia.listMine !== 'function') { this.render(); return; }
		return tmpMedia.listMine()
			.then((pRows) => { this._page().Rows = Array.isArray(pRows) ? pRows : []; this.render(); })
			.catch(() => this.render());
	}

	onBeforeRender(pRenderable)
	{
		let tmpPage = this._page();
		let tmpMedia = this._media();
		let tmpRows = tmpPage.Rows || [];

		let tmpImages = [];
		let tmpFiles = [];
		let tmpLinks = [];

		tmpRows.forEach((pM) =>
		{
			let tmpIsLink = (pM.MediaType === 'Link');
			let tmpIsImage = !tmpIsLink && (String(pM.MimeType || '').indexOf('image/') === 0);
			let tmpURL = tmpMedia ? tmpMedia.blobURL(pM.IDMedia) : ('/1.0/Media/' + pM.IDMedia + '/Blob');
			let tmpTitle = pM.Title || pM.OriginalFileName || ('Media #' + pM.IDMedia);

			if (tmpIsLink)
			{
				tmpLinks.push({
					IDMedia: pM.IDMedia,
					Title: tmpTitle,
					URL: String(pM.OriginalFileName || '')
				});
			}
			else if (tmpIsImage)
			{
				tmpImages.push({
					IDMedia: pM.IDMedia,
					Title: tmpTitle,
					URL: tmpURL
				});
			}
			else
			{
				tmpFiles.push({
					IDMedia: pM.IDMedia,
					Title: tmpTitle,
					URL: tmpURL,
					TypeLabel: _fileTypeLabel(pM.MimeType, pM.OriginalFileName)
				});
			}
		});

		tmpPage.ImageRows = tmpImages;
		tmpPage.FileRows = tmpFiles;
		tmpPage.LinkRows = tmpLinks;
		// One-element array trick: section wrapper renders 0 or 1 times; nested {~TS:~}
		// inside each section template fills the items from AppData.
		tmpPage.HasImages = tmpImages.length ? [{}] : [];
		tmpPage.HasFiles = tmpFiles.length ? [{}] : [];
		tmpPage.HasLinks = tmpLinks.length ? [{}] : [];
		tmpPage.GalleryEmpty = (tmpImages.length + tmpFiles.length + tmpLinks.length) ? [] : [1];

		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// Mobile-Safari-safe file picker: programmatically click the hidden input instead of relying on a
	// <label for> over a display:none input (which silently does nothing on iOS Safari).
	openPicker()
	{
		if (typeof document === 'undefined') { return; }
		let tmpInput = document.getElementById('PS-GalleryPage-Input');
		if (tmpInput) { tmpInput.click(); }
	}

	onPick(pInput)
	{
		if (!pInput || !pInput.files) { return; }
		this._uploadFiles(pInput.files);
		pInput.value = '';
	}

	_uploadFiles(pFiles)
	{
		let tmpMedia = this._media();
		if (!tmpMedia) { return; }
		let tmpAll = [];
		for (let i = 0; i < pFiles.length; i++)
		{
			if (pFiles[i]) { tmpAll.push(pFiles[i]); }
		}
		if (!tmpAll.length) { return; }
		// OwnerType 'User' / IDOwner 0: a direct gallery upload (not tied to a note). Private: true is
		// what makes it the caller's own; the server stamps Media.IDUser from the session.
		Promise.all(tmpAll.map((pF) => tmpMedia.upload('User', 0, pF, { Private: true }).catch(() => null)))
			.then(() => this.show());
	}

	// Open a pict-section-modal dialog to add an external URL reference (no native prompt/alert).
	addURLDialog()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return; }
		tmpModal.show(
		{
			title: 'Add a URL reference',
			content:
				'<p style="font-size:13px;">Saves a link to an external site in your gallery. It opens in a new tab; you can also copy a markdown reference for use in a note.</p>'
				+ '<label style="font-size:12px;">Label (optional)</label>'
				+ '<input id="PS-URL-Title" class="pict-input" style="width:100%; margin-bottom:8px;" placeholder="Descriptive name">'
				+ '<label style="font-size:12px;">URL</label>'
				+ '<input id="PS-URL-Href" class="pict-input" style="width:100%;" placeholder="https://...">',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Add URL', Style: 'primary' }
			]
		}).then((pChoice) =>
		{
			if (pChoice !== 'save') { return; }
			let tmpURL = ((document.getElementById('PS-URL-Href') || {}).value || '').trim();
			let tmpTitle = ((document.getElementById('PS-URL-Title') || {}).value || '').trim() || tmpURL;
			if (!tmpURL) { return; }
			let tmpMedia = this._media();
			if (!tmpMedia || typeof tmpMedia.uploadURL !== 'function') { return; }
			tmpMedia.uploadURL('User', 0, tmpURL, tmpTitle, { Private: true })
				.then(() => this.show())
				.catch((pErr) => this._toast('Could not save URL: ' + (pErr.message || pErr), 'error'));
		});
	}

	// Copy the appropriate markdown reference for this media item to the clipboard.
	// Images  -> ![Title](url)
	// Files   -> [Title](url)
	// Links   -> [Title](externalURL)
	copyRef(pIDMedia)
	{
		let tmpMedia = this._media();
		let tmpPage = this._page();
		let tmpRows = tmpPage.Rows || [];
		let tmpRow = tmpRows.find((pM) => Number(pM.IDMedia) === Number(pIDMedia));
		let tmpIsLink = tmpRow && (tmpRow.MediaType === 'Link');
		let tmpIsImage = tmpRow && !tmpIsLink && (String(tmpRow.MimeType || '').indexOf('image/') === 0);
		let tmpTitle = (tmpRow && (tmpRow.Title || tmpRow.OriginalFileName)) || ('Media #' + pIDMedia);

		let tmpRef;
		if (tmpIsLink)
		{
			let tmpHref = (tmpRow && String(tmpRow.OriginalFileName || '')) || '';
			tmpRef = '[' + tmpTitle + '](' + tmpHref + ')';
		}
		else if (tmpIsImage)
		{
			let tmpURL = tmpMedia ? tmpMedia.blobURL(pIDMedia) : ('/1.0/Media/' + pIDMedia + '/Blob');
			tmpRef = '![' + tmpTitle + '](' + tmpURL + ')';
		}
		else
		{
			let tmpURL = tmpMedia ? tmpMedia.blobURL(pIDMedia) : ('/1.0/Media/' + pIDMedia + '/Blob');
			tmpRef = '[' + tmpTitle + '](' + tmpURL + ')';
		}

		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(tmpRef)
				.then(() => this._toast('Reference copied.', 'success'))
				.catch(() => this._toast(tmpRef, 'info'));
		}
		else { this._toast(tmpRef, 'info'); }
	}

	deleteItem(pIDMedia)
	{
		let tmpMedia = this._media();
		if (!tmpMedia || typeof tmpMedia.removeMine !== 'function') { return; }
		tmpMedia.removeMine(pIDMedia).then(() => this.show()).catch(() => {});
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2200 });
		}
	}
}

module.exports = PictViewGalleryPage;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-GalleryPage',
	DefaultRenderable: 'Plansheet-GalleryPage',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-gallerypage.ps-page { color: var(--theme-color-text-primary, #1d2230); }
		.ps-gallerypage-head { display: flex; align-items: center; gap: 12px; margin: 0 0 18px; flex-wrap: wrap; }
		.ps-gallerypage-head h2 { font-size: 22px; font-weight: 600; margin: 0; color: var(--theme-color-text-primary, #1f2430); }
		.ps-gallerypage-actions { display: flex; gap: 8px; margin-left: auto; flex-wrap: wrap; }
		.ps-gallerypage-upload { font: inherit; font-size: 13px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4);
			background: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-on-brand, #fff); border-radius: 7px; padding: 6px 13px; cursor: pointer; }
		.ps-gallerypage-upload:hover { filter: brightness(1.06); }
		.ps-gallerypage-url { font: inherit; font-size: 13px; border: 1px solid var(--theme-color-border-default, #c8cdd8);
			background: transparent; color: var(--theme-color-text-primary, #1d2230); border-radius: 7px; padding: 6px 13px; cursor: pointer; }
		.ps-gallerypage-url:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-gallerypage-input { display: none; }
		.ps-gallerypage-section { margin-bottom: 28px; }
		.ps-gallerypage-section-label { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em;
			color: var(--theme-color-text-secondary, #8a93a6); margin-bottom: 10px; }
		.ps-gallerypage-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 12px; }
		.ps-gallerypage-item { position: relative; aspect-ratio: 1 / 1; border-radius: 10px; overflow: hidden;
			border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-secondary, #f1f3f7); }
		.ps-gallerypage-thumb { width: 100%; height: 100%; object-fit: cover; display: block; cursor: pointer; }
		.ps-gallerypage-del { position: absolute; top: 6px; right: 6px; width: 26px; height: 26px; border: none; border-radius: 6px;
			background: rgba(20, 24, 32, 0.55); color: #fff; cursor: pointer; font-size: 16px; line-height: 1;
			display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.15s ease; }
		.ps-gallerypage-item:hover .ps-gallerypage-del { opacity: 1; }
		.ps-gallerypage-del:hover { background: var(--theme-color-status-error, #cc3333); }
		.ps-gallerypage-filelist { display: flex; flex-direction: column; gap: 8px; }
		.ps-gallerypage-filerow { display: flex; align-items: center; gap: 10px; padding: 10px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 9px; background: var(--theme-color-background-secondary, #f1f3f7); cursor: pointer; min-width: 0; }
		.ps-gallerypage-filerow:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); background: var(--theme-color-background-hover, #eaf2ff); }
		.ps-gallerypage-filebadge { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;
			background: var(--theme-color-background-panel, #fff); padding: 2px 7px; border-radius: 999px; flex-shrink: 0;
			border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6376); }
		.ps-gallerypage-filetitle { font-size: 13px; color: var(--theme-color-text-primary, #1d2230); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; min-width: 0; }
		.ps-gallerypage-filedel { background: none; border: none; cursor: pointer; color: var(--theme-color-text-secondary, #8a93a6); font-size: 18px; line-height: 1; flex-shrink: 0; padding: 0 2px; }
		.ps-gallerypage-filedel:hover { color: var(--theme-color-status-error, #cc3333); }
		.ps-gallerypage-linkrow { display: flex; align-items: center; gap: 10px; padding: 10px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 9px; background: var(--theme-color-background-secondary, #f1f3f7); min-width: 0; }
		.ps-gallerypage-linkhref { font-size: 13px; color: var(--theme-color-brand-primary, #3b6fd4); text-decoration: none; flex: 1;
			white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
		.ps-gallerypage-linkhref:hover { text-decoration: underline; }
		.ps-gallerypage-linkbadge { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;
			background: var(--theme-color-background-panel, #fff); padding: 2px 7px; border-radius: 999px; flex-shrink: 0;
			border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6376); }
		.ps-gallerypage-linkcopy { background: none; border: none; cursor: pointer; color: var(--theme-color-text-secondary, #8a93a6); font-size: 14px; line-height: 1; flex-shrink: 0; padding: 0 2px; }
		.ps-gallerypage-linkcopy:hover { color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-gallerypage-empty { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 14px; padding: 14px 2px; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-GalleryPage',
			Template: /*html*/`
<div class="ps-page ps-gallerypage">
	<div class="ps-gallerypage-head">
		<h2>Gallery</h2>
		<div class="ps-gallerypage-actions">
			<input type="file" id="PS-GalleryPage-Input" class="ps-gallerypage-input" multiple onchange="_Pict.views['Plansheet-GalleryPage'].onPick(this)" />
			<button class="ps-gallerypage-upload" onclick="_Pict.views['Plansheet-GalleryPage'].openPicker()">+ Upload file</button>
			<button class="ps-gallerypage-url" onclick="_Pict.views['Plansheet-GalleryPage'].addURLDialog()">+ Add URL</button>
		</div>
	</div>
	{~TS:GalleryPage-Empty:AppData.GalleryPage.GalleryEmpty~}
	{~TS:GalleryPage-ImagesSection:AppData.GalleryPage.HasImages~}
	{~TS:GalleryPage-FilesSection:AppData.GalleryPage.HasFiles~}
	{~TS:GalleryPage-LinksSection:AppData.GalleryPage.HasLinks~}
</div>`
		},
		{
			Hash: 'GalleryPage-Empty',
			Template: /*html*/`<p class="ps-gallerypage-empty">No files yet. Upload any file or add a URL; images pasted into a note land here too. Everything here is private to you.</p>`
		},
		{
			Hash: 'GalleryPage-ImagesSection',
			Template: /*html*/`<div class="ps-gallerypage-section"><div class="ps-gallerypage-section-label">Images</div><div class="ps-gallerypage-grid">{~TS:GalleryPage-ImageItem:AppData.GalleryPage.ImageRows~}</div></div>`
		},
		{
			Hash: 'GalleryPage-ImageItem',
			Template: /*html*/`<div class="ps-gallerypage-item"><img class="ps-gallerypage-thumb" src="{~D:Record.URL~}" alt="{~D:Record.Title~}" title="{~D:Record.Title~} -- click to copy a markdown reference" onclick="_Pict.views['Plansheet-GalleryPage'].copyRef({~D:Record.IDMedia~})" /><button class="ps-gallerypage-del" title="Delete" onclick="_Pict.views['Plansheet-GalleryPage'].deleteItem({~D:Record.IDMedia~})">&times;</button></div>`
		},
		{
			Hash: 'GalleryPage-FilesSection',
			Template: /*html*/`<div class="ps-gallerypage-section"><div class="ps-gallerypage-section-label">Files</div><div class="ps-gallerypage-filelist">{~TS:GalleryPage-FileRow:AppData.GalleryPage.FileRows~}</div></div>`
		},
		{
			Hash: 'GalleryPage-FileRow',
			Template: /*html*/`<div class="ps-gallerypage-filerow" onclick="_Pict.views['Plansheet-GalleryPage'].copyRef({~D:Record.IDMedia~})" title="Click to copy a markdown download link"><span class="ps-gallerypage-filebadge">{~D:Record.TypeLabel~}</span><span class="ps-gallerypage-filetitle">{~D:Record.Title~}</span><button class="ps-gallerypage-filedel" title="Delete" onclick="event.stopPropagation(); _Pict.views['Plansheet-GalleryPage'].deleteItem({~D:Record.IDMedia~})">&times;</button></div>`
		},
		{
			Hash: 'GalleryPage-LinksSection',
			Template: /*html*/`<div class="ps-gallerypage-section"><div class="ps-gallerypage-section-label">Links</div><div class="ps-gallerypage-filelist">{~TS:GalleryPage-LinkRow:AppData.GalleryPage.LinkRows~}</div></div>`
		},
		{
			Hash: 'GalleryPage-LinkRow',
			Template: /*html*/`<div class="ps-gallerypage-linkrow"><span class="ps-gallerypage-linkbadge">URL</span><a class="ps-gallerypage-linkhref" href="{~D:Record.URL~}" target="_blank" rel="noopener" title="{~D:Record.URL~}">{~D:Record.Title~}</a><button class="ps-gallerypage-linkcopy" onclick="_Pict.views['Plansheet-GalleryPage'].copyRef({~D:Record.IDMedia~})" title="Copy markdown reference">{~I:Copy~}</button><button class="ps-gallerypage-filedel" title="Delete" onclick="_Pict.views['Plansheet-GalleryPage'].deleteItem({~D:Record.IDMedia~})">&times;</button></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-GalleryPage',
			TemplateHash: 'Plansheet-GalleryPage',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"pict-view":365}],675:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');
const libMarkdownRender = require('./MarkdownRender.js');

/**
 * HelpDrawer -- the contextual product-help panel docked on the right of the shell.
 *
 * Opened by F1 or the top-bar "?" (the app drives the shell panel + calls refreshForRoute). On open it
 * reads the current route, matches it to a help topic from /1.0/help/_topics.json, and renders that
 * topic's help (its landing doc, with the topic's other docs as tabs). A screen with no topic falls
 * back to the help home (index.md).
 *
 * It is NOT the inline-documentation module (that single instance backs the full-page #/docs viewer).
 * It reuses the same read-only renderer the foundational docs use -- MarkdownRender over the
 * pict-section-content provider -- so help reads identically, in a UX built for a narrow drawer.
 */
class PictViewHelpDrawer extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._HelpBaseURL = '/1.0/help/';
		this._Topics = null;        // cached _topics.json, fetched once
		this._TopicsLoading = null; // in-flight promise so concurrent opens share one fetch
		this._ActivePath = '';
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		// The shell re-renders this bound ContentView on every panel expand, so refreshing here is what
		// makes opening the drawer show help for the screen the user is on right now (and it preloads at
		// creation). Navigation while the drawer is already open is handled by the app's hashchange hook.
		this.refreshForRoute();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_contentProvider() { return this.pict.providers.Content; }
	_el(pID) { return (typeof document !== 'undefined') ? document.getElementById(pID) : null; }

	// The current app route, e.g. '#/checklists' -> '/checklists'.
	_currentRoute()
	{
		let tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '';
		let tmpRoute = String(tmpHash).replace(/^#/, '');
		if (!tmpRoute) { tmpRoute = '/'; }
		return tmpRoute;
	}

	// Load the topics manifest once (cached). Always resolves to an object (empty on any failure).
	_loadTopics()
	{
		if (this._Topics) { return Promise.resolve(this._Topics); }
		if (this._TopicsLoading) { return this._TopicsLoading; }
		this._TopicsLoading = libFrameworkClient.getJSON(this.pict, this._HelpBaseURL + '_topics.json')
			.catch(() => ({}))
			.then((pTopics) => { this._Topics = pTopics || {}; this._TopicsLoading = null; return this._Topics; });
		return this._TopicsLoading;
	}

	// Match a route to the most specific topic whose Routes cover it (exact, or a '/prefix/*' wildcard).
	_resolveTopic(pTopics, pRoute)
	{
		let tmpBest = null;
		let tmpBestLen = -1;
		Object.keys(pTopics || {}).forEach((pCode) =>
		{
			let tmpTopic = pTopics[pCode];
			let tmpRoutes = (tmpTopic && Array.isArray(tmpTopic.Routes)) ? tmpTopic.Routes : [];
			for (let i = 0; i < tmpRoutes.length; i++)
			{
				let tmpPattern = String(tmpRoutes[i] || '');
				let tmpMatch = false;
				if (tmpPattern.slice(-2) === '/*')
				{
					let tmpPrefix = tmpPattern.slice(0, -2);
					tmpMatch = (pRoute === tmpPrefix) || (pRoute.indexOf(tmpPrefix + '/') === 0);
				}
				else { tmpMatch = (pRoute === tmpPattern); }
				if (tmpMatch && tmpPattern.length > tmpBestLen) { tmpBest = tmpTopic; tmpBestLen = tmpPattern.length; }
			}
		});
		return tmpBest;
	}

	// The entry point the app calls on each open + on navigation while open.
	refreshForRoute()
	{
		if (!this._el('HelpDrawer-Body')) { return; } // not rendered into the panel yet
		let tmpRoute = this._currentRoute();
		this._loadTopics().then((pTopics) =>
		{
			// The route may have changed during the fetch; re-read so we show what is on screen now.
			let tmpTopic = this._resolveTopic(pTopics, this._currentRoute());
			if (tmpTopic) { this._renderTopic(tmpTopic); }
			else { this._renderNoTopic(); }
		});
	}

	_renderTopic(pTopic)
	{
		let tmpTitle = this._el('HelpDrawer-Title');
		if (tmpTitle) { tmpTitle.textContent = pTopic.TopicTitle || 'Help'; }

		let tmpDocs = Array.isArray(pTopic.Docs) ? pTopic.Docs : [];
		let tmpLanding = pTopic.Landing || (tmpDocs[0] && tmpDocs[0].Path) || '';
		let tmpTabs = this._el('HelpDrawer-Tabs');
		if (tmpTabs)
		{
			if (tmpDocs.length > 1)
			{
				tmpTabs.innerHTML = tmpDocs.map((pDoc) =>
					'<button class="ps-help-tab" data-path="' + this._attr(pDoc.Path) + '" onclick="_Pict.views[\'Plansheet-HelpDrawer\'].selectDoc(\'' + this._attr(pDoc.Path) + '\')">'
					+ this._escape(pDoc.Title || pDoc.Path) + '</button>').join('');
				tmpTabs.style.display = '';
			}
			else { tmpTabs.innerHTML = ''; tmpTabs.style.display = 'none'; }
		}
		this.loadDoc(tmpLanding);
	}

	_renderNoTopic()
	{
		let tmpTitle = this._el('HelpDrawer-Title');
		if (tmpTitle) { tmpTitle.textContent = 'Help'; }
		let tmpTabs = this._el('HelpDrawer-Tabs');
		if (tmpTabs) { tmpTabs.innerHTML = ''; tmpTabs.style.display = 'none'; }
		this.loadDoc('index.md');
	}

	// Switch documents within the current topic (tab click).
	selectDoc(pPath) { this.loadDoc(pPath); }

	loadDoc(pPath)
	{
		let tmpPath = String(pPath || '').replace(/^\/+/, '');
		this._ActivePath = tmpPath;
		this._markActiveTab(tmpPath);
		let tmpBody = this._el('HelpDrawer-Body');
		if (!tmpBody) { return; }
		if (!tmpPath) { tmpBody.innerHTML = ''; return; }
		libFrameworkClient.getText(this.pict, this._HelpBaseURL + tmpPath)
			.catch(() => '')
			.then((pMarkdown) =>
			{
				// The user may have clicked another tab while this was in flight; only paint the latest.
				if (this._ActivePath !== tmpPath) { return; }
				let tmpTarget = this._el('HelpDrawer-Body');
				if (!tmpTarget) { return; }
				libMarkdownRender.renderInto(this._contentProvider(), tmpTarget, pMarkdown,
					'<p class="ps-help-empty">This help page is not available.</p>');
				tmpTarget.scrollTop = 0;
			});
	}

	_markActiveTab(pPath)
	{
		let tmpTabs = this._el('HelpDrawer-Tabs');
		if (!tmpTabs) { return; }
		let tmpButtons = tmpTabs.querySelectorAll('.ps-help-tab');
		for (let i = 0; i < tmpButtons.length; i++)
		{
			let tmpIsActive = (tmpButtons[i].getAttribute('data-path') === pPath);
			tmpButtons[i].classList.toggle('is-active', tmpIsActive);
		}
	}

	_escape(pText) { return String(pText == null ? '' : pText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
	_attr(pText) { return String(pText == null ? '' : pText).replace(/'/g, '&#39;').replace(/"/g, '&quot;'); }
}

module.exports = PictViewHelpDrawer;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-HelpDrawer',
	DefaultRenderable: 'Plansheet-HelpDrawer',
	DefaultDestinationAddress: '#Plansheet-HelpDrawer',
	AutoRender: false,
	CSS: /*css*/`
		/* Transparent so the drawer body shows the panel's cool brand wash (set on the shell's right
		   panel), which is what differentiates help from the navigation and content. */
		.ps-help { display: flex; flex-direction: column; height: 100%; min-height: 0;
			background: transparent; color: var(--theme-color-text-primary, #1d2230); }
		.ps-help-head { flex: 0 0 auto; display: flex; align-items: center; gap: 8px;
			padding: 12px 14px; border-bottom: 1px solid var(--theme-color-border-default, #e3e6ec); }
		.ps-help-title { flex: 1; font-size: 15px; font-weight: 600; letter-spacing: 0.01em; }
		.ps-help-close { flex: 0 0 auto; width: 28px; height: 28px; border: none; border-radius: 6px;
			background: transparent; color: var(--theme-color-text-secondary, #5b6376); cursor: pointer;
			font-size: 18px; line-height: 1; display: flex; align-items: center; justify-content: center; }
		.ps-help-close:hover { background: var(--theme-color-background-hover, #eef1f6); color: var(--theme-color-text-primary, #2c3140); }
		.ps-help-tabs { flex: 0 0 auto; display: flex; flex-wrap: wrap; gap: 4px; padding: 8px 12px;
			border-bottom: 1px solid var(--theme-color-border-default, #e3e6ec); }
		.ps-help-tab { padding: 4px 10px; font-size: 12px; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 14px; background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; }
		.ps-help-tab:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-primary, #2c3140); }
		.ps-help-tab.is-active { background: var(--theme-color-brand-primary, #3b6fd4);
			border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-on-brand, #fff); }
		.ps-help-body { flex: 1; min-height: 0; overflow-y: auto; padding: 14px 16px 28px; }
		.ps-help-empty { color: var(--theme-color-text-secondary, #5b6376); font-style: italic; }
		/* The shared content styles (.pict-content) come from pict-section-content; nudge the drawer's
		   reading rhythm a touch tighter than the full page. */
		.ps-help-body .pict-content { font-size: 14px; line-height: 1.55; }
		.ps-help-body .pict-content h1 { font-size: 18px; margin: 0 0 10px; }
		.ps-help-body .pict-content h2 { font-size: 15px; margin: 18px 0 8px; }
		.ps-help-body .pict-content h3 { font-size: 13.5px; margin: 14px 0 6px; }
		.ps-help-body .pict-content ul, .ps-help-body .pict-content ol { padding-left: 20px; }
		.ps-help-body .pict-content li { margin: 3px 0; }
		.ps-help-body .pict-content code { font-size: 12.5px; }
	`,
	Templates: [{
		Hash: 'Plansheet-HelpDrawer',
		Template: /*html*/`
<div class="ps-help">
	<div class="ps-help-head">
		<span class="ps-help-title" id="HelpDrawer-Title">Help</span>
		<button class="ps-help-close" title="Close help (Esc)" onclick="_Pict.PictApplication.closeHelpDrawer()">&times;</button>
	</div>
	<div class="ps-help-tabs" id="HelpDrawer-Tabs" style="display:none;"></div>
	<div class="ps-help-body" id="HelpDrawer-Body"></div>
</div>`
	}],
	Renderables: [{
		RenderableHash: 'Plansheet-HelpDrawer',
		TemplateHash: 'Plansheet-HelpDrawer',
		ContentDestinationAddress: '#Plansheet-HelpDrawer'
	}]
};

},{"../providers/FrameworkClient.js":576,"./MarkdownRender.js":649,"pict-view":365}],676:[function(require,module,exports){
'use strict';

/**
 * Home -- the cross-tenant "Your plan sheets" screen (WI #339). It is the default landing after
 * sign-in and the canonical place to reach every plan sheet you belong to, no matter which one the
 * session is currently in. It renders tenant-less: its only data source is GET /1.0/Account/Tenants
 * (which reads across the whole account), never the IDCustomer-scoped entity providers, so it is safe
 * to show while "between" tenants and is registered as a tenant-safe area root.
 *
 * Three view modes off one segmented control: Compact list (default), Expanded list (adds the plan
 * sheet's description + persona line), and Cards (full-width, each fronted by the plan sheet's cover
 * blueprint -- the navy title block, mirrored from BlueprintRender, or a pick-a-blueprint placeholder
 * when none is set). Two sections: Pinned on top, then All by recency. A search box filters by name,
 * code, and description.
 *
 * The shell (header + section containers) is a static template; the rows/cards are painted
 * imperatively into #psh-pinned / #psh-all by _paint(). Repainting only those containers -- not the
 * whole view -- keeps the search box focused and its caret in place as you type, and lets a pin toggle
 * re-sort in place without a server round-trip losing your scroll.
 */

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');
const libPlansheetSort = require('../PlansheetSort.js');

function _escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// The one-letter mark for a plan sheet with no cover (the little navy tile in list rows): the first
// two alphanumerics of its name, upper-cased.
function _mark(pName)
{
	return String(pName || '?').replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase() || '?';
}

// The glyph letter for a blueprint pin row, from the artifact's ItemType (Vision -> V, Module -> M,
// Feature -> F, ...). Falls back to the first letter of the type.
function _typeGlyph(pType)
{
	let tmpType = String(pType || '');
	return (tmpType.charAt(0) || '*').toUpperCase();
}

class PictViewHome extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		// View state, kept on the instance so a repaint (mode / search / pin) never refetches.
		this._tenants = [];
		this._mode = 'compact';   // 'compact' | 'expanded' | 'cards'
		this._query = '';
		this._loaded = false;
	}

	// Load the account's plan sheets (cross-tenant), then render the page.
	show()
	{
		return this._loadTenants().then(() => this.render()).catch(() => this.render());
	}

	_loadTenants()
	{
		return libFrameworkClient.getJSON(this.pict, '/1.0/Account/Tenants').then((pBody) =>
		{
			this._tenants = (pBody && Array.isArray(pBody.Tenants)) ? this._sortTenants(pBody.Tenants) : [];
			this._loaded = true;
		}).catch(() =>
		{
			this._tenants = [];
			this._loaded = true;
		});
	}

	// The same pinned-first-then-recency order the server returns (shared PlansheetSort), applied here
	// too so a local pin toggle re-sorts in place without a refetch. Mutates in place and returns it.
	_sortTenants(pList)
	{
		return libPlansheetSort.sortPlansheets(pList);
	}

	// A compact "how long ago" label (now, 5m, 3h, 2d, 4mo, 1y); '' when never visited.
	_ago(pValue)
	{
		if (!pValue) { return ''; }
		let tmpMs = Date.parse(String(pValue).replace(' ', 'T'));
		if (isNaN(tmpMs)) { return ''; }
		let tmpSec = Math.max(0, Math.floor((Date.now() - tmpMs) / 1000));
		if (tmpSec < 60) { return 'now'; }
		let tmpMin = Math.floor(tmpSec / 60);
		if (tmpMin < 60) { return tmpMin + 'm'; }
		let tmpHr = Math.floor(tmpMin / 60);
		if (tmpHr < 24) { return tmpHr + 'h'; }
		let tmpDay = Math.floor(tmpHr / 24);
		if (tmpDay < 30) { return tmpDay + 'd'; }
		let tmpMon = Math.floor(tmpDay / 30);
		if (tmpMon < 12) { return tmpMon + 'mo'; }
		return Math.floor(tmpMon / 12) + 'y';
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._syncSegButtons();
		this._paint();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// --- interaction ---------------------------------------------------------

	setMode(pMode)
	{
		let tmpMode = (pMode === 'expanded' || pMode === 'cards') ? pMode : 'compact';
		if (tmpMode === this._mode) { return; }
		this._mode = tmpMode;
		this._syncSegButtons();
		this._paint();
	}

	filter(pValue)
	{
		this._query = String(pValue == null ? '' : pValue);
		this._paint();
	}

	// Enter a plan sheet: the current one just goes to its board; any other switches the session into
	// it and reloads the app under that tenant (reduced to a tenant-safe route first; see WI #328).
	openSheet(pIDCustomer)
	{
		let tmpID = parseInt(pIDCustomer, 10) || 0;
		let tmpTenant = this._tenants.find((pT) => pT.IDCustomer === tmpID);
		if (tmpTenant && tmpTenant.IsCurrent) { this._navigate('/board'); return; }
		this.switchTenant(tmpID);
	}

	switchTenant(pIDCustomer)
	{
		let tmpID = parseInt(pIDCustomer, 10) || 0;
		if (!tmpID) { return; }
		libFrameworkClient.postJSON(this.pict, '/1.0/Session/Context/' + tmpID, {}).then((pBody) =>
		{
			if (pBody && pBody.Switched) { this._reloadForTenantChange(); return; }
			this._toast((pBody && pBody.Error) || 'Could not open that plan sheet.');
		}).catch(() => this._toast('Could not open that plan sheet.'));
	}

	// Pin or unpin, then re-sort + repaint in place. Optimistic would risk drift on a failed write, so
	// we flip local state only once the server confirms.
	togglePin(pIDCustomer)
	{
		let tmpID = parseInt(pIDCustomer, 10) || 0;
		let tmpTenant = this._tenants.find((pT) => pT.IDCustomer === tmpID);
		if (!tmpTenant) { return; }
		let tmpNext = !tmpTenant.Pinned;
		libFrameworkClient.postJSON(this.pict, '/1.0/Account/Tenants/' + tmpID + '/Pin', { Pinned: tmpNext }).then((pBody) =>
		{
			if (pBody && pBody.Success)
			{
				tmpTenant.Pinned = !!pBody.Pinned;
				this._sortTenants(this._tenants);
				this._paint();
				return;
			}
			this._toast((pBody && pBody.Error) || 'Could not update the pin.');
		}).catch(() => this._toast('Could not update the pin.'));
	}

	_navigate(pRoute)
	{
		let tmpApp = this.pict && this.pict.PictApplication;
		if (tmpApp && typeof tmpApp._navigate === 'function') { tmpApp._navigate(pRoute); return; }
		if (typeof window !== 'undefined' && window.location) { window.location.hash = '#' + String(pRoute || '/').replace(/^#/, ''); }
	}

	_reloadForTenantChange()
	{
		let tmpApp = this.pict && this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.reloadForActivePlansheetChange === 'function') { tmpApp.reloadForActivePlansheetChange(); return; }
		if (typeof window !== 'undefined' && window.location) { window.location.reload(); }
	}

	_toast(pMessage)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: 'error' }); }
		else if (typeof window !== 'undefined') { window.alert(pMessage); }
	}

	// --- painting ------------------------------------------------------------

	// Reflect the active mode on the segmented control and on the two section containers (the density
	// class the list CSS keys off; the cards class swaps the layout).
	_syncSegButtons()
	{
		if (typeof document === 'undefined') { return; }
		let tmpRoot = document.getElementById('Plansheet-Home-Root');
		if (!tmpRoot) { return; }
		let tmpButtons = tmpRoot.querySelectorAll('.psh-seg button');
		for (let i = 0; i < tmpButtons.length; i++)
		{
			let tmpOn = (tmpButtons[i].getAttribute('data-mode') === this._mode);
			tmpButtons[i].classList.toggle('on', tmpOn);
		}
	}

	_matches(pTenant)
	{
		let tmpQuery = this._query.trim().toLowerCase();
		if (!tmpQuery) { return true; }
		let tmpHay = (String(pTenant.CustomerName || '') + ' ' + String(pTenant.Code || '') + ' ' + String(pTenant.Description || '')).toLowerCase();
		return tmpHay.indexOf(tmpQuery) >= 0;
	}

	_paint()
	{
		if (typeof document === 'undefined') { return; }
		let tmpAll = this._tenants.filter((pT) => this._matches(pT));
		let tmpPinned = tmpAll.filter((pT) => pT.Pinned);
		let tmpModeClass = (this._mode === 'cards') ? 'psh-cards' : ('psh-list psh-' + this._mode);
		let tmpCards = (this._mode === 'cards');

		let fFill = (pID, pList, pEmptyText) =>
		{
			let tmpEl = document.getElementById(pID);
			if (!tmpEl) { return; }
			tmpEl.className = tmpModeClass;
			if (!pList.length) { tmpEl.innerHTML = '<div class="psh-empty">' + _escapeHTML(pEmptyText) + '</div>'; return; }
			tmpEl.innerHTML = pList.map((pT) => tmpCards ? this._cardHTML(pT) : this._rowHTML(pT)).join('');
		};

		fFill('psh-all', tmpAll, this._query ? 'No plan sheets match.' : 'No plan sheets.');
		fFill('psh-pinned', tmpPinned, 'No pinned plan sheets match.');

		// Hide the whole Pinned section when nothing is pinned (nothing to show, no empty state needed).
		let tmpPinnedSec = document.getElementById('psh-pinned-sec');
		if (tmpPinnedSec) { tmpPinnedSec.style.display = tmpPinned.length ? '' : 'none'; }

		let fText = (pID, pText) => { let tmpEl = document.getElementById(pID); if (tmpEl) { tmpEl.textContent = pText; } };
		fText('psh-pcount', String(tmpPinned.length));
		fText('psh-acount', String(tmpAll.length));
		let tmpTotalPinned = this._tenants.filter((pT) => pT.Pinned).length;
		fText('psh-count', this._tenants.length + ' plan ' + (this._tenants.length === 1 ? 'sheet' : 'sheets') + (tmpTotalPinned ? (', ' + tmpTotalPinned + ' pinned') : ''));
	}

	_pinSVG(pOn)
	{
		return '<svg viewBox="0 0 16 16" width="15" height="15" fill="' + (pOn ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.4">'
			+ '<path d="M5 2h6l-1 5 3 3H3l3-3-1-5z"/><path d="M8 10v4"/></svg>';
	}

	// The reference (view instance) used by the inline handlers on painted markup.
	_ref() { return "_Pict.views['Plansheet-Home']"; }

	_pinButtonHTML(pTenant)
	{
		let tmpRef = this._ref();
		let tmpOn = pTenant.Pinned ? ' on' : '';
		let tmpTitle = pTenant.Pinned ? 'Unpin' : 'Pin to the top';
		return '<button class="psh-pin' + tmpOn + '" title="' + tmpTitle + '" onclick="event.stopPropagation();' + tmpRef + '.togglePin(' + (pTenant.IDCustomer || 0) + ')">' + this._pinSVG(pTenant.Pinned) + '</button>';
	}

	_roleHTML(pTenant)
	{
		let tmpRole = pTenant.RoleLabel || 'Member';
		let tmpOwner = (tmpRole === 'Owner' || tmpRole === 'Platform Admin') ? ' owner' : '';
		return '<span class="psh-role' + tmpOwner + '">' + _escapeHTML(tmpRole) + '</span>';
	}

	_rowHTML(pTenant)
	{
		let tmpRef = this._ref();
		let tmpAgo = this._ago(pTenant.LastVisited);
		let tmpCurrent = pTenant.IsCurrent ? '<span class="psh-here">Current</span>' : '';
		let tmpSub = pTenant.Description
			? _escapeHTML(pTenant.Description)
			: ('as ' + _escapeHTML(pTenant.DisplayName || 'you') + (pTenant.Code ? (' &middot; ' + _escapeHTML(pTenant.Code)) : ''));
		return '<div class="psh-lrow' + (pTenant.IsCurrent ? ' is-current' : '') + '" onclick="' + tmpRef + '.openSheet(' + (pTenant.IDCustomer || 0) + ')">'
			+ '<span class="psh-mk">' + _escapeHTML(_mark(pTenant.CustomerName)) + '</span>'
			+ '<span class="psh-main"><span class="psh-name">' + _escapeHTML(pTenant.CustomerName || 'Untitled') + tmpCurrent + '</span>'
				+ '<span class="psh-sub">' + tmpSub + '</span></span>'
			+ this._roleHTML(pTenant)
			+ '<span class="psh-right"><span class="psh-meta" title="Last visited">' + _escapeHTML(tmpAgo) + '</span>' + this._pinButtonHTML(pTenant) + '</span>'
			+ '</div>';
	}

	// The navy cover box for a card: the plan sheet's primary blueprint rendered as a compact title
	// block (mirrors BlueprintRender's palette), or the pick-a-blueprint placeholder when none is set.
	_coverHTML(pTenant)
	{
		let tmpBP = pTenant.PrimaryBlueprint;
		if (!tmpBP)
		{
			return '<div class="psh-bp psh-bp-empty"><div class="psh-bp-kick">No cover blueprint</div>'
				+ '<div class="psh-bp-hint">Pick a blueprint to represent this plan sheet</div></div>';
		}
		// Flatten the blueprint's grouped pins into a few rows (type glyph + item title), capped so the
		// box stays a summary rather than the full sheet.
		let tmpRows = [];
		let tmpGroups = Array.isArray(tmpBP.Groups) ? tmpBP.Groups : [];
		for (let g = 0; g < tmpGroups.length && tmpRows.length < 4; g++)
		{
			let tmpItems = Array.isArray(tmpGroups[g].Items) ? tmpGroups[g].Items : [];
			for (let i = 0; i < tmpItems.length && tmpRows.length < 4; i++)
			{
				tmpRows.push('<div class="psh-bp-pin"><span class="psh-bp-k">' + _escapeHTML(_typeGlyph(tmpGroups[g].Type)) + '</span>'
					+ '<span class="psh-bp-pt">' + _escapeHTML(tmpItems[i].Title || '') + '</span></div>');
			}
		}
		let tmpPins = tmpRows.length ? ('<div class="psh-bp-pins">' + tmpRows.join('') + '</div>') : '';
		let tmpStrip = pTenant.Code
			? ('<div class="psh-bp-strip"><span class="psh-bp-lab">Plan sheet</span><span class="psh-bp-val">' + _escapeHTML(pTenant.Code) + '</span></div>')
			: '';
		return '<div class="psh-bp"><div class="psh-bp-kick">Blueprint</div>'
			+ '<div class="psh-bp-name">' + _escapeHTML(tmpBP.Title || 'Cover') + '</div>'
			+ tmpPins + tmpStrip + '</div>';
	}

	_cardHTML(pTenant)
	{
		let tmpRef = this._ref();
		let tmpAgo = this._ago(pTenant.LastVisited);
		let tmpCurrent = pTenant.IsCurrent ? '<span class="psh-here">Current</span>' : '';
		let tmpCode = pTenant.Code ? ('<span class="psh-code">' + _escapeHTML(pTenant.Code) + '</span>') : '';
		let tmpBlurb = pTenant.Description ? ('<div class="psh-blurb">' + _escapeHTML(pTenant.Description) + '</div>') : '';
		let tmpAgoLine = tmpAgo ? ('<span class="psh-dot"></span><span>Visited ' + _escapeHTML(tmpAgo) + '</span>') : '';
		return '<div class="psh-card" onclick="' + tmpRef + '.openSheet(' + (pTenant.IDCustomer || 0) + ')">'
			+ this._coverHTML(pTenant)
			+ '<div class="psh-card-body">'
				+ '<div class="psh-card-top">' + this._pinButtonHTML(pTenant)
					+ '<span class="psh-title">' + _escapeHTML(pTenant.CustomerName || 'Untitled') + tmpCode + '</span>' + tmpCurrent + '</div>'
				+ tmpBlurb
				+ '<div class="psh-card-foot">' + this._roleHTML(pTenant) + tmpAgoLine
					+ '<span class="psh-actions"><button class="psh-btn primary" onclick="event.stopPropagation();' + tmpRef + '.openSheet(' + (pTenant.IDCustomer || 0) + ')">Open</button></span>'
				+ '</div>'
			+ '</div>'
		+ '</div>';
	}
}

module.exports = PictViewHome;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Home',
	DefaultRenderable: 'Plansheet-Home',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		/* Cross-tenant home. Chrome uses the app theme variables; the cover box (.psh-bp) is fixed
		   navy to mirror the app's blueprint plate (see BlueprintRender), regardless of app theme. */
		.psh-wrap { max-width: 1120px; margin: 0 auto; padding: 4px 4px 48px; color: var(--theme-color-text-primary, #1f2733); }
		.psh-head { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin: 6px 2px 8px; flex-wrap: wrap; }
		.psh-titles h1 { margin: 0; font-size: 24px; font-weight: 600; letter-spacing: -0.01em; }
		.psh-sub { color: var(--theme-color-text-secondary, #5b6577); font-size: 13.5px; margin-top: 4px; }
		.psh-sub .psh-cnt { color: var(--theme-color-text-secondary, #5b6577); }
		.psh-controls { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
		.psh-search { display: flex; align-items: center; gap: 8px; background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 9px; padding: 7px 11px;
			color: var(--theme-color-text-secondary, #5b6577); font-size: 13px; min-width: 200px; }
		.psh-search input { background: none; border: 0; color: var(--theme-color-text-primary, #1f2733); font: inherit; outline: none; width: 100%; }
		.psh-search:focus-within { border-color: var(--theme-color-brand, #2f6fb0); }
		.psh-seg { display: inline-flex; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 9px; padding: 3px; gap: 2px; }
		.psh-seg button { border: 0; background: none; color: var(--theme-color-text-secondary, #5b6577); font: inherit; font-size: 13px;
			padding: 6px 11px; border-radius: 6px; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; }
		.psh-seg button.on { background: var(--theme-color-background-selected, rgba(47,111,176,0.10)); color: var(--theme-color-brand, #2f6fb0); font-weight: 600; }
		.psh-seg svg { width: 15px; height: 15px; }

		.psh-section-label { display: flex; align-items: center; gap: 10px; text-transform: uppercase; letter-spacing: 0.09em;
			font-size: 11px; color: var(--theme-color-text-secondary, #8892a3); font-weight: 700; margin: 22px 2px 10px; }
		.psh-section-label .psh-count { color: var(--theme-color-text-secondary, #8892a3); font-weight: 600; }
		.psh-section-label::after { content: ""; flex: 1; height: 1px; background: var(--theme-color-border-subtle, #dde3ec); }

		.psh-empty { color: var(--theme-color-text-secondary, #8892a3); font-size: 13.5px; padding: 14px 4px; font-style: italic; }

		.psh-role { font-size: 10.5px; letter-spacing: 0.05em; text-transform: uppercase; padding: 2px 8px; border-radius: 999px;
			border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6577); white-space: nowrap; }
		.psh-role.owner { color: var(--theme-color-brand, #2f6fb0); border-color: var(--theme-color-brand, #2f6fb0); }
		.psh-here { font-size: 10px; letter-spacing: 0.04em; text-transform: uppercase; margin-left: 8px; padding: 1px 7px; border-radius: 999px;
			background: var(--theme-color-background-selected, rgba(47,111,176,0.10)); color: var(--theme-color-brand, #2f6fb0); font-weight: 600; }
		.psh-meta { color: var(--theme-color-text-secondary, #8892a3); font-size: 12px; font-variant-numeric: tabular-nums; white-space: nowrap; }
		.psh-pin { border: 0; background: none; color: var(--theme-color-text-secondary, #a2acbd); cursor: pointer; display: inline-grid; place-items: center;
			width: 28px; height: 28px; border-radius: 7px; padding: 0; }
		.psh-pin.on { color: var(--theme-color-status-warning, #b9812f); }
		.psh-pin:hover { background: var(--theme-color-background-hover, #f2f6fc); color: var(--theme-color-brand, #2f6fb0); }

		/* ----- list (compact + expanded) ----- */
		.psh-list { display: flex; flex-direction: column; border: 1px solid var(--theme-color-border-default, #dde3ec); border-radius: 12px;
			overflow: hidden; background: var(--theme-color-background-panel, #fff); }
		.psh-lrow { display: grid; grid-template-columns: 30px 1fr auto auto; align-items: center; gap: 14px; padding: 12px 16px;
			border-top: 1px solid var(--theme-color-border-subtle, #eef1f6); cursor: pointer; }
		.psh-lrow:first-child { border-top: 0; }
		.psh-lrow:hover { background: var(--theme-color-background-hover, #f2f6fc); }
		.psh-lrow.is-current { background: var(--theme-color-background-selected, rgba(47,111,176,0.06)); }
		.psh-mk { width: 30px; height: 30px; border-radius: 8px; background: #16294b; border: 1px solid rgba(150,180,220,0.35);
			display: grid; place-items: center; color: #cfe0f6; font-size: 11px; font-weight: 800; letter-spacing: 0.02em; }
		.psh-main { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
		.psh-name { font-weight: 600; font-size: 14.5px; display: flex; align-items: center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.psh-sub { color: var(--theme-color-text-secondary, #5b6577); font-size: 12.5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: none; }
		.psh-right { display: flex; align-items: center; gap: 10px; justify-content: flex-end; }
		/* Compact tightens rows and hides the sub-line; expanded shows the description / persona line. */
		.psh-list.psh-compact .psh-lrow { padding: 9px 16px; }
		.psh-list.psh-compact .psh-mk { width: 26px; height: 26px; }
		.psh-list.psh-expanded .psh-lrow { padding: 14px 16px; }
		.psh-list.psh-expanded .psh-sub { display: block; }

		/* ----- cards (full-width, blueprint cover on the left) ----- */
		.psh-cards { display: grid; grid-template-columns: 1fr; gap: 14px; }
		.psh-card { display: grid; grid-template-columns: 280px 1fr; gap: 0; border: 1px solid var(--theme-color-border-default, #dde3ec);
			border-radius: 12px; overflow: hidden; background: var(--theme-color-background-panel, #fff); cursor: pointer; }
		.psh-card:hover { border-color: var(--theme-color-brand, #2f6fb0); }
		.psh-card-body { padding: 16px 18px; display: flex; flex-direction: column; gap: 9px; min-width: 0; }
		.psh-card-top { display: flex; align-items: center; gap: 10px; }
		.psh-title { font-size: 16.5px; font-weight: 700; letter-spacing: -0.01em; display: flex; align-items: center; min-width: 0;
			overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.psh-code { color: var(--theme-color-text-secondary, #8892a3); font-weight: 600; font-size: 12.5px; margin-left: 8px; letter-spacing: 0.03em; }
		.psh-blurb { color: var(--theme-color-text-secondary, #5b6577); font-size: 13px; max-width: 64ch; }
		.psh-card-foot { display: flex; align-items: center; gap: 12px; margin-top: auto; padding-top: 4px;
			color: var(--theme-color-text-secondary, #5b6577); font-size: 12px; flex-wrap: wrap; }
		.psh-card-foot .psh-dot { width: 3px; height: 3px; border-radius: 50%; background: var(--theme-color-text-secondary, #a2acbd); }
		.psh-actions { display: flex; gap: 8px; margin-left: auto; }
		.psh-btn { border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #1f2733); font: inherit; font-size: 13px; padding: 6px 14px; border-radius: 8px; cursor: pointer; }
		.psh-btn.primary { background: var(--theme-color-brand, #2f6fb0); border-color: var(--theme-color-brand, #2f6fb0); color: #fff; font-weight: 600; }
		.psh-btn.primary:hover { filter: brightness(1.05); }

		/* the blueprint cover box -- fixed navy, mirrors BlueprintRender's plate palette */
		.psh-bp { background: #16294b; border-right: 1px solid var(--theme-color-border-default, #dde3ec); padding: 15px 16px;
			display: flex; flex-direction: column; gap: 9px; position: relative; color: #eef4fc; }
		.psh-bp::before { content: ""; position: absolute; inset: 9px; border: 1px solid rgba(208,226,247,0.30); border-radius: 8px; pointer-events: none; }
		.psh-bp-kick { font-family: ui-monospace, Menlo, monospace; text-transform: uppercase; letter-spacing: 0.16em; font-size: 10px; font-weight: 700; color: #88a8d6; position: relative; }
		.psh-bp-name { font-size: 14.5px; font-weight: 700; color: #eef4fc; position: relative; overflow-wrap: anywhere; }
		.psh-bp-pins { display: flex; flex-direction: column; gap: 6px; position: relative; margin-top: 2px; }
		.psh-bp-pin { display: flex; align-items: center; gap: 8px; font-size: 12px; color: #cfe0f6; min-width: 0; }
		.psh-bp-k { flex: 0 0 auto; width: 19px; height: 19px; border-radius: 5px; background: rgba(150,180,220,0.16); border: 1px solid rgba(150,180,220,0.35);
			display: grid; place-items: center; font-size: 9px; font-weight: 800; color: #88a8d6; font-family: ui-monospace, Menlo, monospace; }
		.psh-bp-pt { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.psh-bp-strip { display: flex; flex-direction: column; gap: 1px; margin-top: auto; padding-top: 9px;
			border-top: 1px solid rgba(150,180,220,0.28); position: relative; }
		.psh-bp-lab { text-transform: uppercase; letter-spacing: 0.08em; color: #88a8d6; font-size: 9px; font-weight: 700; font-family: ui-monospace, Menlo, monospace; }
		.psh-bp-val { color: #eef4fc; font-weight: 600; font-size: 12px; margin-top: 1px; }
		.psh-bp-empty { align-items: center; justify-content: center; text-align: center; min-height: 130px; }
		.psh-bp-empty .psh-bp-kick { margin-bottom: 4px; }
		.psh-bp-hint { color: #7f97bd; font-size: 12.5px; position: relative; max-width: 22ch; }

		@media (max-width: 720px)
		{
			.psh-card { grid-template-columns: 1fr; }
			.psh-bp { border-right: 0; border-bottom: 1px solid var(--theme-color-border-default, #dde3ec); }
			.psh-lrow { grid-template-columns: 26px 1fr auto; }
			.psh-lrow .psh-role { display: none; }
		}
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-Home',
			Template: /*html*/`
<div class="psh-wrap" id="Plansheet-Home-Root">
	<div class="psh-head">
		<div class="psh-titles">
			<h1>Your plan sheets</h1>
			<div class="psh-sub">Everything you are subscribed to, across every plan sheet. <span class="psh-cnt" id="psh-count"></span></div>
		</div>
		<div class="psh-controls">
			<div class="psh-search"><span aria-hidden="true">&#9906;</span><input id="psh-search" type="search" placeholder="Filter plan sheets..." autocomplete="off" oninput="_Pict.views['Plansheet-Home'].filter(this.value)" /></div>
			<div class="psh-seg" role="tablist" aria-label="View mode">
				<button data-mode="compact" title="Compact list" onclick="_Pict.views['Plansheet-Home'].setMode('compact')"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 4h12M2 8h12M2 12h12"/></svg>Compact</button>
				<button data-mode="expanded" title="Expanded list" onclick="_Pict.views['Plansheet-Home'].setMode('expanded')"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 3.5h12M2 8h12M2 12.5h12"/><path d="M2 5.5h8" opacity=".5"/><path d="M2 10h8" opacity=".5"/></svg>Expanded</button>
				<button data-mode="cards" title="Blueprint cards" onclick="_Pict.views['Plansheet-Home'].setMode('cards')"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="12" height="4.5" rx="1"/><rect x="2" y="9" width="12" height="4.5" rx="1"/></svg>Cards</button>
			</div>
		</div>
	</div>

	<div class="psh-section" id="psh-pinned-sec" style="display:none">
		<div class="psh-section-label">Pinned <span class="psh-count" id="psh-pcount"></span></div>
		<div id="psh-pinned" class="psh-list psh-compact"></div>
	</div>

	<div class="psh-section">
		<div class="psh-section-label">All plan sheets <span class="psh-count" id="psh-acount"></span></div>
		<div id="psh-all" class="psh-list psh-compact"></div>
	</div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-Home',
			TemplateHash: 'Plansheet-Home',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"../PlansheetSort.js":568,"../providers/FrameworkClient.js":576,"pict-view":365}],677:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libFocus = require('../FocusFilters.js');

/**
 * IssueBoard -- the issues dashboard. A kanban over Issues (lanes by Status: Open -> Closed), the
 * standard project cuts (open count, assigned to me, recently closed), and a call-volume strip. One
 * read (IssueBoardAPI.dashboard -> AppData.IssueBoard) backs the whole page. HTML5 drag-and-drop
 * moves a card to another lane; the drop PUTs the issue's Status/SortOrder, which trips the
 * server-side status-change audit (WorkflowStatusEvent) and stamps ResolvedDate when it closes.
 * Clicking a card opens its detail.
 */
class PictViewIssueBoard extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._drag = null;
		this._filters = { Type: '', Customer: '', Assignee: '', Severity: '' };
	}

	_board() { return this.pict.providers.IssueBoardAPI; }
	_router() { return this.pict.providers['Pict-Router']; }

	// Load the dashboard, add display helpers, paint.
	show()
	{
		let tmpBoard = this._board();
		if (!tmpBoard) { return Promise.resolve(); }
		this._readUrl();
		return tmpBoard.dashboard().then(() => { this._rebuild(); this.render(); });
	}
	refresh() { return this.show(); }

	// Re-filter without reloading: just rebuild the view-lanes from the data already in AppData.
	setFilter(pKey, pValue)
	{
		if (Object.prototype.hasOwnProperty.call(this._filters, pKey)) { this._filters[pKey] = pValue || ''; }
		this._writeUrl();
		this._rebuild();
		this.render();
	}

	clearFilters()
	{
		this._filters = { Type: '', Customer: '', Assignee: '', Severity: '' };
		this._writeUrl();
		this._rebuild();
		this.render();
	}

	/**
	 * Put the narrowed board in the URL, so it can be sent to someone and survives a reload.
	 *
	 * PictView-Board has done this for its own filters all along; this board did not, so the same
	 * interaction had two different answers in one product -- a filtered kanban could be shared and a
	 * filtered issues board could not. replaceState rather than a route change, exactly as Board does
	 * it: the view keeps ownership of rendering and the router is never re-entered.
	 */
	_writeUrl() { libFocus.writeHashQuery(this._filters); }

	// Take the filters back off the URL on the way in, so a shared link lands on the same board.
	_readUrl()
	{
		let tmpParams = libFocus.readHashParams();
		Object.keys(this._filters).forEach((pKey) =>
		{
			if (typeof tmpParams[pKey] === 'string') { this._filters[pKey] = tmpParams[pKey]; }
		});
	}

	// Decorate the raw cards (colored border by type, a from-call marker), build the filter dropdowns
	// from the distinct values present, and apply the active filters to produce the view's lanes. The
	// provider owns the raw AppData.IssueBoard.Lanes; the view derives ViewLanes + Filters from them.
	_rebuild()
	{
		let tmpStore = (this.pict.AppData && this.pict.AppData.IssueBoard) || null;
		if (!tmpStore) { return; }
		let fDecorate = (pCard) =>
		{
			pCard.BorderStyle = pCard.TypeColor ? ('border-left-color:' + pCard.TypeColor) : '';
			pCard.FromCallMark = pCard.FromCall ? 'from a call' : '';
			pCard.NumberLabel = pCard.IssueNumber ? ('#' + pCard.IssueNumber) : '';
			return pCard;
		};
		(tmpStore.Lanes || []).forEach((pLane) => (pLane.Cards || []).forEach(fDecorate));
		(tmpStore.Mine || []).forEach(fDecorate);
		(tmpStore.RecentlyClosed || []).forEach(fDecorate);
		tmpStore.MineEmpty = (tmpStore.Mine && tmpStore.Mine.length) ? [] : [{ Message: 'Nothing assigned to you.' }];
		tmpStore.ClosedEmpty = (tmpStore.RecentlyClosed && tmpStore.RecentlyClosed.length) ? [] : [{ Message: 'No issues closed recently.' }];

		// Distinct values across every card, for the filter dropdowns.
		let tmpAll = [];
		(tmpStore.Lanes || []).forEach((pLane) => { tmpAll = tmpAll.concat(pLane.Cards || []); });
		let tmpFilters = this._filters;
		let fDistinct = (pField) => { let tmpSeen = {}; tmpAll.forEach((pC) => { if (pC[pField]) { tmpSeen[pC[pField]] = true; } }); return Object.keys(tmpSeen).sort(); };
		let fOptions = (pValues, pCurrent, pAllLabel) => [{ Value: '', Label: pAllLabel, Sel: pCurrent ? '' : 'selected' }]
			.concat(pValues.map((pV) => ({ Value: pV, Label: pV, Sel: (String(pV) === String(pCurrent)) ? 'selected' : '' })));
		tmpStore.Filters =
		{
			Type: fOptions(fDistinct('TypeName'), tmpFilters.Type, 'All types'),
			Customer: fOptions(fDistinct('CustomerName'), tmpFilters.Customer, 'All customers'),
			Assignee: fOptions(fDistinct('AssigneeName'), tmpFilters.Assignee, 'All assignees'),
			Severity: fOptions(fDistinct('Severity'), tmpFilters.Severity, 'All severities'),
			ClearSlot: (tmpFilters.Type || tmpFilters.Customer || tmpFilters.Assignee || tmpFilters.Severity) ? [{}] : []
		};

		// Apply the filters to each lane to produce the rendered lanes.
		let fMatch = (pCard) => (!tmpFilters.Type || pCard.TypeName === tmpFilters.Type)
			&& (!tmpFilters.Customer || pCard.CustomerName === tmpFilters.Customer)
			&& (!tmpFilters.Assignee || pCard.AssigneeName === tmpFilters.Assignee)
			&& (!tmpFilters.Severity || pCard.Severity === tmpFilters.Severity);
		tmpStore.ViewLanes = (tmpStore.Lanes || []).map((pLane) =>
		{
			let tmpCards = (pLane.Cards || []).filter(fMatch);
			return { Key: pLane.Key, Label: pLane.Label, Cards: tmpCards, Count: tmpCards.length };
		});
	}

	// Surface a message to the user. The board already toasts on a failed drop; new-issue failures used to
	// be swallowed, so the button looked dead when the create was refused or errored. Always say what
	// happened instead of doing nothing.
	_toast(pMsg, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMsg, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	newIssue()
	{
		let tmpAPI = this.pict.providers.IssueAPI;
		let tmpRouter = this._router();
		if (!tmpAPI)
		{
			this._toast('Could not add an issue: the Issue service is not available. Reload the page and try again.', 'error');
			return;
		}
		// EntityAPI.create rejects on any non-2xx (throws 'HTTP <status>'); catch it and tell the user
		// rather than letting the button silently do nothing.
		tmpAPI.create({ Title: 'New issue', Status: 'Open', Priority: 'Normal' }).then((pRow) =>
		{
			if (pRow && pRow.IDIssue && tmpRouter) { tmpRouter.navigate('/issue/' + pRow.IDIssue); }
			else if (pRow && pRow.IDIssue) { this.show(); }
			else { this._toast('Could not add an issue: the server did not return a new record.', 'error'); }
		}).catch((pErr) =>
		{
			this._toast('Could not add an issue: ' + ((pErr && pErr.message) || pErr), 'error');
		});
	}

	openIssue(pID)
	{
		let tmpRouter = this._router();
		if (tmpRouter && pID) { tmpRouter.navigate('/issue/' + pID); }
	}

	dragStart(pEvent, pID)
	{
		this._drag = { ID: pID };
		if (pEvent && pEvent.dataTransfer)
		{
			pEvent.dataTransfer.effectAllowed = 'move';
			try { pEvent.dataTransfer.setData('text/plain', String(pID)); } catch (pErr) { /* ignore */ }
		}
	}

	allowDrop(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		if (pEvent && pEvent.dataTransfer) { pEvent.dataTransfer.dropEffect = 'move'; }
	}

	drop(pEvent, pLaneKey)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		let tmpDrag = this._drag;
		this._drag = null;
		let tmpBoard = this._board();
		if (!tmpDrag || !tmpBoard) { return; }
		let tmpSort = tmpBoard.nextSortOrder(pLaneKey);
		tmpBoard.moveCard(tmpDrag.ID, pLaneKey, tmpSort)
			.then(() => this.show())
			.catch((pErr) => { this._toast('Move failed: ' + ((pErr && pErr.message) || pErr), 'error'); });
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewIssueBoard;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-IssueBoard',
	DefaultRenderable: 'IssueBoard-Display',
	AutoRender: false,
	CSS: /*css*/`
		.ps-issues { height: 100%; display: flex; flex-direction: column; gap: 14px; }
		.ps-issues-head { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
		.ps-issues-head h2 { font-size: 22px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; }
		.ps-issues-new { font: inherit; font-size: 13px; border: 1px solid var(--theme-color-brand-primary, #2880a6); background: var(--theme-color-brand-primary, #2880a6); color: var(--theme-color-text-on-brand, #fff); border-radius: 7px; padding: 6px 13px; cursor: pointer; }
		.ps-issues-new:hover { filter: brightness(1.06); }
		.ps-issues-stats { display: flex; gap: 8px; flex-wrap: wrap; margin-left: auto; }
		.ps-stat { background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #5b6376); border-radius: 999px; padding: 4px 11px; font-size: 12px; }
		.ps-stat b { color: var(--theme-color-text-primary, #2c3140); font-weight: 700; }
		.ps-stat-calls { background: var(--theme-color-status-info, #e7f1fb); color: var(--theme-color-text-secondary, #41506a); }
		.ps-issues-filters { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
		.ps-issues-filters select { font: inherit; font-size: 12px; padding: 4px 8px; border-radius: 6px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-issues-filter-clear { font: inherit; font-size: 12px; border: none; background: none; color: var(--theme-color-brand-primary, #2880a6); cursor: pointer; padding: 4px 6px; }
		.ps-issues-filter-clear:hover { text-decoration: underline; }
		/* One scroll region for the whole board (both axes); lanes and card stacks never scroll on
		   their own, so a busy lane can't spawn nested column scrollbars. */
		.ps-issues-lanes { display: flex; gap: 12px; overflow: auto; align-items: flex-start; flex: 1; min-height: 0; padding-bottom: 8px; }
		.ps-ilane { flex: 0 0 240px; width: 240px; background: var(--theme-color-background-secondary, #f1f3f7); border-radius: 10px; padding: 10px; display: flex; flex-direction: column; }
		.ps-ilane-head { display: flex; align-items: center; justify-content: space-between; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); padding: 4px 6px 10px; }
		.ps-ilane-count { background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); border-radius: 999px; padding: 1px 8px; font-size: 12px; }
		.ps-ilane-cards { display: flex; flex-direction: column; gap: 8px; min-height: 40px; }
		.ps-icard { background: var(--theme-color-background-panel, #fff); border-radius: 8px; padding: 9px 11px; border-left: 3px solid var(--theme-color-border-default, #d8dde6); cursor: pointer; box-shadow: 0 1px 2px rgba(0,0,0,0.06); }
		.ps-icard:hover { box-shadow: 0 2px 6px rgba(0,0,0,0.12); }
		.ps-icard[draggable="true"]:active { cursor: grabbing; }
		.ps-icard-top { display: flex; align-items: baseline; gap: 6px; margin-bottom: 5px; }
		.ps-icard-num { font-size: 11px; color: var(--theme-color-text-muted, #97a1ab); font-weight: 700; }
		.ps-icard-title { font-size: 14px; color: var(--theme-color-text-primary, #2c3140); line-height: 1.25; }
		.ps-icard-meta { display: flex; gap: 5px; flex-wrap: wrap; }
		.ps-chip { font-size: 11px; padding: 1px 7px; border-radius: 999px; background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #5b6376); }
		.ps-chip:empty { display: none; }
		.ps-chip-type { background: var(--theme-color-background-tertiary, #e3e8f0); }
		.ps-chip-call { background: var(--theme-color-status-info, #e7f1fb); color: var(--theme-color-text-secondary, #41506a); }
		.ps-chip-cust { background: transparent; color: var(--theme-color-text-muted, #97a1ab); padding-left: 0; }
		.ps-issues-cuts { display: flex; gap: 16px; flex: 0 0 auto; }
		.ps-cut { flex: 1 1 0; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 10px; padding: 12px 14px; max-height: 190px; overflow-y: auto; }
		.ps-cut h3 { font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 8px; }
		.ps-cut-row { display: flex; align-items: baseline; gap: 7px; padding: 4px 0; cursor: pointer; border-bottom: 1px solid var(--theme-color-border-light, #f0f3f6); }
		.ps-cut-row:hover { color: var(--theme-color-brand-primary, #2880a6); }
		.ps-cut-row .ps-icard-num { flex: 0 0 auto; }
		.ps-cut-row .t { font-size: 13px; color: inherit; }
		.ps-cut-empty { color: var(--theme-color-text-muted, #97a1ab); font-size: 13px; padding: 6px 0; }
	`,
	Templates:
	[
		{
			Hash: 'IssueBoard-Display',
			Template: /*html*/`
<div class="ps-page ps-issues">
	<div class="ps-issues-head">
		<h2>Issues</h2>
		<button class="ps-issues-new" onclick="_Pict.views['Plansheet-IssueBoard'].newIssue()">+ New issue</button>
		<div class="ps-issues-stats">
			<span class="ps-stat"><b>{~D:AppData.IssueBoard.Counts.Open~}</b> open</span>
			<span class="ps-stat"><b>{~D:AppData.IssueBoard.Counts.Mine~}</b> mine</span>
			<span class="ps-stat"><b>{~D:AppData.IssueBoard.Counts.ClosedRecently~}</b> recently closed</span>
			<span class="ps-stat ps-stat-calls"><b>{~D:AppData.IssueBoard.CallVolume.Last7~}</b> calls / 7d, <b>{~D:AppData.IssueBoard.CallVolume.Last30~}</b> / 30d</span>
		</div>
	</div>
	<div class="ps-issues-filters">
		<select onchange="_Pict.views['Plansheet-IssueBoard'].setFilter('Type', this.value)">{~TS:IssueBoard-FilterOpt:AppData.IssueBoard.Filters.Type~}</select>
		<select onchange="_Pict.views['Plansheet-IssueBoard'].setFilter('Customer', this.value)">{~TS:IssueBoard-FilterOpt:AppData.IssueBoard.Filters.Customer~}</select>
		<select onchange="_Pict.views['Plansheet-IssueBoard'].setFilter('Assignee', this.value)">{~TS:IssueBoard-FilterOpt:AppData.IssueBoard.Filters.Assignee~}</select>
		<select onchange="_Pict.views['Plansheet-IssueBoard'].setFilter('Severity', this.value)">{~TS:IssueBoard-FilterOpt:AppData.IssueBoard.Filters.Severity~}</select>
		{~TS:IssueBoard-FilterClear:AppData.IssueBoard.Filters.ClearSlot~}
	</div>
	<div class="ps-issues-lanes">{~TS:IssueBoard-Lane:AppData.IssueBoard.ViewLanes~}</div>
	<div class="ps-issues-cuts">
		<div class="ps-cut">
			<h3>Assigned to me</h3>
			{~TS:IssueBoard-CutRow:AppData.IssueBoard.Mine~}
			{~TS:IssueBoard-CutEmpty:AppData.IssueBoard.MineEmpty~}
		</div>
		<div class="ps-cut">
			<h3>Recently closed</h3>
			{~TS:IssueBoard-CutRow:AppData.IssueBoard.RecentlyClosed~}
			{~TS:IssueBoard-CutEmpty:AppData.IssueBoard.ClosedEmpty~}
		</div>
	</div>
</div>`
		},
		{
			Hash: 'IssueBoard-Lane',
			Template: /*html*/`
<div class="ps-ilane" ondragover="_Pict.views['Plansheet-IssueBoard'].allowDrop(event)" ondrop="_Pict.views['Plansheet-IssueBoard'].drop(event,'{~D:Record.Key~}')">
	<div class="ps-ilane-head"><span>{~D:Record.Label~}</span><span class="ps-ilane-count">{~D:Record.Count~}</span></div>
	<div class="ps-ilane-cards">{~TS:IssueBoard-Card:Record.Cards~}</div>
</div>`
		},
		{
			Hash: 'IssueBoard-Card',
			Template: /*html*/`
<div class="ps-icard" style="{~D:Record.BorderStyle~}" draggable="true" ondragstart="_Pict.views['Plansheet-IssueBoard'].dragStart(event,{~D:Record.IDIssue~})" onclick="_Pict.views['Plansheet-IssueBoard'].openIssue({~D:Record.IDIssue~})">
	<div class="ps-icard-top"><span class="ps-icard-num">{~D:Record.NumberLabel~}</span><span class="ps-icard-title">{~D:Record.Title~}</span></div>
	<div class="ps-icard-meta"><span class="ps-chip ps-chip-type">{~D:Record.TypeName~}</span><span class="ps-chip">{~D:Record.Priority~}</span><span class="ps-chip ps-chip-cust">{~D:Record.CustomerName~}</span><span class="ps-chip ps-chip-call">{~D:Record.FromCallMark~}</span></div>
</div>`
		},
		{
			Hash: 'IssueBoard-CutRow',
			Template: /*html*/`<div class="ps-cut-row" onclick="_Pict.views['Plansheet-IssueBoard'].openIssue({~D:Record.IDIssue~})"><span class="ps-icard-num">{~D:Record.NumberLabel~}</span><span class="t">{~D:Record.Title~}</span></div>`
		},
		{
			Hash: 'IssueBoard-CutEmpty',
			Template: /*html*/`<div class="ps-cut-empty">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'IssueBoard-FilterOpt',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.Sel~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'IssueBoard-FilterClear',
			Template: /*html*/`<button class="ps-issues-filter-clear" onclick="_Pict.views['Plansheet-IssueBoard'].clearFilters()">Clear filters</button>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'IssueBoard-Display',
			TemplateHash: 'IssueBoard-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../FocusFilters.js":558,"pict-view":365}],678:[function(require,module,exports){
'use strict';

/**
 * LoopsMarkdownEditor — the same rich markdown editor (pict-section-markdowneditor) the Docs Lake and
 * the entity-form descriptions use, dedicated to the Drafting Kit loops editor. It mounts into
 * #dk-loops-mdhost and is seeded from AppData.LoopsMarkdownEditor.Segments with the loops rendered as a
 * markdown checklist (see source/LoopMarkdown.js); the settings view reads its content on save and
 * parses it back to the structured loop trees. A separate instance from the field editor so the two
 * never fight over the same host element / data address.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-LoopsMarkdownEditor';
	tmpConfig.DefaultDestinationAddress = '#dk-loops-mdhost';
	tmpConfig.TargetElementAddress = '#dk-loops-mdhost';
	tmpConfig.ContentDataAddress = 'AppData.LoopsMarkdownEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'off';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#dk-loops-mdhost';
		}
	}

	return tmpConfig;
}

// A per-loop instance config: one editor per loop key (design / build / feedback), each bound to its own
// host element and data address, so the three never share state and no `## heading` parsing is needed.
function configForLoop(pKey)
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-LoopEditor-' + pKey;
	tmpConfig.DefaultDestinationAddress = '#dk-loop-mdhost-' + pKey;
	tmpConfig.TargetElementAddress = '#dk-loop-mdhost-' + pKey;
	tmpConfig.ContentDataAddress = 'AppData.LoopEditor_' + pKey + '.Segments';
	tmpConfig.DefaultPreviewMode = 'off';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#dk-loop-mdhost-' + pKey;
		}
	}

	return tmpConfig;
}

class PictViewLoopsMarkdownEditor extends libMarkdownEditor
{
}

module.exports = PictViewLoopsMarkdownEditor;
module.exports.default_configuration = buildConfiguration();
module.exports.configForLoop = configForLoop;

},{"pict-section-markdowneditor":261}],679:[function(require,module,exports){
'use strict';

const libOSD = require('pict-section-openseadragon');

/**
 * PictView-MediaViewer
 * --------------------
 * A full-page deep-zoom viewer for a single screenshot. Extends pict-section-openseadragon
 * in its no-annotation mode ({ Annotorious: false } -- the opt-out flag we added to that
 * module), so it needs only the OpenSeaDragon global, not the Annotorious stack. A plain
 * image tile source points at the media blob; OpenSeaDragon supplies smooth deep zoom and
 * pan. Reached via #/media/:id, and from the "Open viewer" link in the quick-view lightbox.
 */
class PlansheetMediaViewer extends libOSD
{
	// Paint the full-page shell (bar + controls + OSD host), point the viewer at the media blob, mount OSD.
	show(pID)
	{
		this._id = parseInt(pID, 10) || 0;
		if (!this._id) { return; }
		let tmpURL = '/1.0/Media/' + this._id + '/Blob';
		let tmpV = "_Pict.views['Plansheet-MediaViewer']";
		let tmpShell =
			'<div class="ps-osd-page">'
			+ '<div class="ps-osd-bar">'
				+ '<button type="button" class="ps-osd-btn" onclick="window.history.back()">&larr; Back</button>'
				+ '<span class="ps-osd-title">Screenshot &mdash; deep zoom</span>'
				+ '<button type="button" class="ps-osd-btn" title="Zoom out" onclick="' + tmpV + '.osdZoom(0.7)">&minus;</button>'
				+ '<button type="button" class="ps-osd-btn" title="Zoom in" onclick="' + tmpV + '.osdZoom(1.5)">+</button>'
				+ '<button type="button" class="ps-osd-btn" title="Fit to screen" onclick="' + tmpV + '.osdHome()">Fit</button>'
				+ '<button type="button" class="ps-osd-btn" title="Fullscreen" onclick="' + tmpV + '.osdFullscreen()">Fullscreen</button>'
				+ '<a class="ps-osd-btn" href="' + tmpURL + '" download>Download</a>'
			+ '</div>'
			+ '<div id="OpenSeaDragon-Container-Div" class="ps-osd-stage"></div>'
			+ '</div>';
		this.pict.ContentAssignment.assignContent('#Plansheet-Workspace', tmpShell);
		// A plain single image (no DZI tiling needed); OpenSeaDragon still gives full smooth zoom.
		this.options.TileSources = { type: 'image', url: tmpURL };
		this.render();
	}

	// Called by the base view just before it builds the OpenSeaDragon instance; tune it for deep zoom.
	customConfigureViewerSettings()
	{
		// Let the user zoom well past native resolution for a real deep-zoom feel on a screenshot.
		this.osdSettings.maxZoomPixelRatio = 8;
		this.osdSettings.minZoomImageRatio = 0.7;
		this.osdSettings.visibilityRatio = 1;
	}

	osdZoom(pFactor) { if (this.viewer) { this.viewer.viewport.zoomBy(pFactor); this.viewer.viewport.applyConstraints(); } }
	osdHome() { if (this.viewer) { this.viewer.viewport.goHome(); } }
	osdFullscreen() { if (this.viewer && typeof this.viewer.setFullScreen === 'function') { this.viewer.setFullScreen(true); } }
}

module.exports = PlansheetMediaViewer;
module.exports.default_configuration = Object.assign({}, libOSD.default_configuration,
{
	ViewIdentifier: 'Plansheet-MediaViewer',
	ViewAddress: 'Plansheet-MediaViewer',
	RenderOnLoad: false,
	AutoRender: false,
	// The opt-out flag: run OpenSeaDragon with no annotation layer (no Annotorious globals needed).
	Annotorious: false,
	// We supply our own styled controls in the bar, so hide OpenSeaDragon's default button set.
	DisableButtons: true,
	DisableFullscreen: true,
	PrefixUrl: '/openseadragon-images/',
	CSS: /*css*/`
		.ps-osd-page { display: flex; flex-direction: column; height: calc(100vh - 130px); min-height: 420px; }
		.ps-osd-bar { display: flex; align-items: center; gap: 8px; padding: 6px 2px 12px; flex-wrap: wrap; }
		.ps-osd-btn { font: inherit; font-size: 13px; padding: 6px 12px; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: transparent; color: inherit; cursor: pointer; text-decoration: none; white-space: nowrap; }
		.ps-osd-btn:hover { border-color: var(--theme-color-brand-primary, #f0c44a); color: var(--theme-color-brand-primary, #f0c44a); }
		.ps-osd-title { font-family: ui-monospace, Menlo, monospace; font-size: 12px; letter-spacing: 1.6px; text-transform: uppercase; color: var(--theme-color-text-secondary, #7a8699); margin-right: auto; }
		.ps-osd-stage { flex: 1 1 auto; min-height: 0; background: #0b1420; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; overflow: hidden; }
		.ps-osd-stage #OSD-Containers-Wrapper, .ps-osd-stage #OpenSeaDragon-Element, .ps-osd-stage .osd-default { width: 100%; height: 100%; }
	`
});

},{"pict-section-openseadragon":288}],680:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

// Where the rail remembers itself. Same prefix as the other per-user client preferences.
const _RAIL_KEY = 'plansheet.notebook.rail';
// Per-device sidebar tab preferences (which tabs are shown, and which is the default on first open).
// Edited in Settings > Appearance; same localStorage convention as plansheet.nav.hidden.
const _TABS_KEY = 'plansheet.sidebar.tabs';

// A small line icon (18x18, inherits currentColor). Keeps the tab catalog readable.
function _svg(pInner) { return '<svg class="ps-nb-tab-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + pInner + '</svg>'; }

// The full set of sidebar tabs, in display order. Key drives the body + the stored prefs; Label is the
// full name (tooltip), Short is the under-icon caption. Navigation is the site map (the primary nav,
// now a tab); Documentation is the Foundational Docs tree. The user turns tabs on/off and picks a
// default in Appearance.
const _TAB_CATALOG =
[
	{ Key: 'notes',         Label: 'Notes',         Short: 'Notes', Icon: _svg('<rect x="4" y="3" width="16" height="18" rx="2"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="13" y2="16"/>') },
	{ Key: 'bookmarks',     Label: 'Bookmarks',     Short: 'Saved', Icon: _svg('<path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z"/>') },
	{ Key: 'checklists',    Label: 'Checklists',    Short: 'Lists', Icon: _svg('<path d="M10 6h10M10 12h10M10 18h10"/><path d="M3.5 6l1 1 2-2.2M3.5 12l1 1 2-2.2M3.5 18l1 1 2-2.2"/>') },
	{ Key: 'gallery',       Label: 'Gallery',       Short: 'Media', Icon: _svg('<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.6"/><path d="M21 15l-5-5L5 20"/>') },
	{ Key: 'documentation', Label: 'Documentation', Short: 'Docs',  Icon: _svg('<path d="M12 6.5c-1.6-1-4-1.6-5.5-1.6S3 5.2 3 5.5v13c0-.3 1.5-.9 3.5-.9s3.9.6 5.5 1.6m0-13.3c1.6-1 4-1.6 5.5-1.6S21 5.2 21 5.5v13c0-.3-1.5-.9-3.5-.9s-3.9.6-5.5 1.6m0-13.3v13.3"/>') },
	{ Key: 'navigation',    Label: 'Navigation',    Short: 'Nav',   Icon: _svg('<circle cx="12" cy="12" r="9"/><polygon points="16 8 13.2 13.2 8 16 10.8 10.8 16 8"/>') }
];

/**
 * Notebook -- the per-user "notebook by the drafting table", docked on the left of the shell.
 *
 * Three private collections loaded in one read (GET /1.0/Notebook via providers.NotebookAPI):
 *   - Notes      -- markdown, edited with the real pict-section-markdowneditor (the same CodeMirror
 *                   editor the Docs Lake uses), mounted into #PS-Notebook-Note-MDE.
 *   - Bookmarks  -- favorites + recent/trending history.
 *   - Checklists -- the user's personal lists, embedded LIVE via a second 'mine' instance of
 *                   PictView-Checklists (Plansheet-Notebook-Checklists) so items check off in place.
 *
 * Template-driven per the Pict conventions: onBeforeRender derives the render slots into AppData,
 * the templates iterate them with {~TS:~}, and every action mutates AppData + calls render() so the
 * engine repaints through ContentAssignment. The two embedded child views (note editor, checklist
 * collection) own their own DOM; because render() recreates their host divs, they are re-mounted
 * after each panel render (the PictView-DocEditor destroy -> render -> marshalToView pattern).
 * No innerHTML, no document lookups.
 */
class PictViewNotebook extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		// The note editor reads/writes its segments here (ContentDataAddress on the editor instance).
		this.pict.AppData.NotebookNoteEditor = this.pict.AppData.NotebookNoteEditor || { Segments: [] };
		// Which note the live editor is currently showing -- gates the across-repaint edit capture.
		this._editorMountedNoteID = 0;
	}

	_data() { return this.pict.AppData.Notebook || {}; }
	_api() { return this.pict.providers.NotebookAPI; }
	_noteEditor() { return this.pict.views['Plansheet-Notebook-NoteEditor']; }
	_checklistsEmbed() { return this.pict.views['Plansheet-Notebook-Checklists']; }

	_currentRoute()
	{
		let tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '';
		return String(tmpHash).replace(/^#/, '') || '/';
	}

	// Parse a server timestamp to epoch ms (best effort).
	_ms(pValue)
	{
		if (!pValue) { return 0; }
		let tmpMs = Date.parse(String(pValue).replace(' ', 'T'));
		return isNaN(tmpMs) ? 0 : tmpMs;
	}

	// A compact "how long ago" label (2h, 3d, 5mo, 1y) for the bookmark/history rows. Short by design so
	// it never forces the row to wrap at narrow / phone width.
	_ago(pValue)
	{
		let tmpMs = this._ms(pValue);
		if (!tmpMs) { return ''; }
		let tmpSec = Math.max(0, Math.floor((Date.now() - tmpMs) / 1000));
		if (tmpSec < 60) { return 'now'; }
		let tmpMin = Math.floor(tmpSec / 60);
		if (tmpMin < 60) { return tmpMin + 'm'; }
		let tmpHr = Math.floor(tmpMin / 60);
		if (tmpHr < 24) { return tmpHr + 'h'; }
		let tmpDay = Math.floor(tmpHr / 24);
		if (tmpDay < 30) { return tmpDay + 'd'; }
		let tmpMon = Math.floor(tmpDay / 30);
		if (tmpMon < 12) { return tmpMon + 'mo'; }
		return Math.floor(tmpMon / 12) + 'y';
	}

	// Derive the template slots from the loaded data + view state into AppData.
	onBeforeRender(pRenderable)
	{
		let tmpD = this._data();
		let tmpSaved = this._restoreRail();
		let tmpEnabledTabs = this._enabledTabs();
		let tmpActive = tmpD.ActiveTab || tmpSaved.ActiveTab || this._defaultTab();
		// A tab turned off in Appearance (or an unknown saved tab) falls back to the default / first enabled.
		if (!tmpEnabledTabs.some((pT) => pT.Key === tmpActive)) { tmpActive = this._defaultTab(); }
		tmpD.ActiveTab = tmpActive;
		if (!tmpD.SelectedNoteID && tmpSaved.SelectedNoteID) { tmpD.SelectedNoteID = tmpSaved.SelectedNoteID; }
		let tmpSelectedID = tmpD.SelectedNoteID || 0;

		// Preserve in-progress edits across this repaint: if the live editor is showing the selected
		// note, pull its current markdown into the segment buffer so the remount restores it. Guarded
		// on _editorMountedNoteID so a note SWITCH (which seeds the new note's segments) is not clobbered.
		if (tmpActive === 'notes' && tmpSelectedID && this._editorMountedNoteID === tmpSelectedID)
		{
			let tmpEd = this._noteEditor();
			if (tmpEd && tmpEd.initialRenderComplete && typeof tmpEd.getAllContent === 'function')
			{
				try { this.pict.AppData.NotebookNoteEditor.Segments = [{ Content: tmpEd.getAllContent('\n\n') }]; } catch (pErr) { /* ignore */ }
			}
		}

		tmpD.Tabs = tmpEnabledTabs.map((pT) => ({ Key: pT.Key, Label: pT.Label, Short: pT.Short, Icon: pT.Icon, Active: tmpActive === pT.Key }));
		// One-or-zero-element slots drive which tab body renders (the pict conditional pattern).
		tmpD.NotesSlot = (tmpActive === 'notes') ? [1] : [];
		tmpD.BookmarksSlot = (tmpActive === 'bookmarks') ? [1] : [];
		tmpD.ChecklistsSlot = (tmpActive === 'checklists') ? [1] : [];
		tmpD.GallerySlot = (tmpActive === 'gallery') ? [1] : [];
		tmpD.DocumentationSlot = (tmpActive === 'documentation') ? [1] : [];
		tmpD.NavigationSlot = (tmpActive === 'navigation') ? [1] : [];

		let tmpNotes = tmpD.Notes || [];
		tmpD.NoteRows = tmpNotes.map((pN) => ({ IDNote: pN.IDNote, Title: pN.Title || 'Untitled note', Active: pN.IDNote === tmpSelectedID }));
		tmpD.NotesEmpty = tmpNotes.length ? [] : [1];
		let tmpSelected = tmpNotes.find((pN) => pN.IDNote === tmpSelectedID);
		// The editor owns the body content (AppData.NotebookNoteEditor.Segments); the slot only carries
		// the id + the title field value.
		tmpD.EditorSlot = tmpSelected
			? [{
				IDNote: tmpSelected.IDNote,
				Title: (tmpD.DraftTitle != null) ? tmpD.DraftTitle : (tmpSelected.Title || '')
			}]
			: [];

		// Favorites carry a subtle age (from CreateDate); the recent-pages history carries when it was last
		// visited (ViewedAt). Both are compact so they never break the row layout at phone width.
		tmpD.FavRows = (tmpD.Favorites || []).map((pB) => ({ IDBookmark: pB.IDBookmark, Label: pB.Label, Route: pB.Route, Age: this._ago(pB.CreateDate) }));
		// Count: number of visits in the trending window. CountLabel is non-empty only when Count > 0
		// so the count span can be hidden with :empty CSS rather than a conditional template slot.
		tmpD.RecentRows = (tmpD.Recent || []).slice(0, 10).map((pR) => ({ Route: pR.Route, Label: pR.Label, Age: this._ago(pR.ViewedAt), CountLabel: pR.Count > 0 ? String(pR.Count) : '' }));
		tmpD.TrendingRows = tmpD.Trending || [];
		tmpD.FavSlot = tmpD.FavRows.length ? [1] : [];
		tmpD.RecentSlot = tmpD.RecentRows.length ? [1] : [];
		tmpD.TrendingSlot = tmpD.TrendingRows.length ? [1] : [];

		// The Checklists tab is the embedded Plansheet-Notebook-Checklists collection; it owns its own
		// rows + empty state, so nothing to derive here beyond the tab slot above.

		// Gallery: the caller's private media (Media.IDUser = them) as thumbnails.
		let tmpMediaAPI = this.pict.providers.MediaAPI;
		tmpD.GalleryRows = (tmpD.Gallery || []).map((pM) => (
		{
			IDMedia: pM.IDMedia,
			Title: pM.Title || pM.OriginalFileName || ('Image ' + pM.IDMedia),
			URL: tmpMediaAPI ? tmpMediaAPI.blobURL(pM.IDMedia) : ('/1.0/Media/' + pM.IDMedia + '/Blob')
		}));
		tmpD.GalleryEmpty = tmpD.GalleryRows.length ? [] : [1];
		// The lightbox is a one-or-zero slot like the tab bodies; _lightbox() carries the full descriptor.
		tmpD.LightboxSlot = tmpD.GalleryLightbox ? [tmpD.GalleryLightbox] : [];

		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._mountActiveEmbeds();
		if (!this._LoadedOnce) { this._LoadedOnce = true; this.refresh(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// Reload from the server, then repaint from data.
	refresh()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.loadNotebook !== 'function') { return; }
		tmpAPI.loadNotebook().then(() => this.render());
	}

	// Each panel render recreates the embedded controls' host divs, so (re)mount whichever the active
	// tab needs into the fresh host.
	_mountActiveEmbeds()
	{
		let tmpD = this._data();
		let tmpActive = tmpD.ActiveTab || 'notes';
		if (tmpActive === 'notes' && tmpD.SelectedNoteID) { this._mountNoteEditor(); }
		else if (tmpActive === 'checklists') { this._mountChecklistsEmbed(); }
		else if (tmpActive === 'navigation') { this._mountNavEmbed(); }
		else if (tmpActive === 'documentation') { this._mountDocsEmbed(); }
	}

	// The docked site-map navigation (the primary app nav, now a tab) rendered into the Navigation host.
	_mountNavEmbed()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.renderSiteNavInto === 'function') { tmpApp.renderSiteNavInto('#PS-Notebook-Navigation'); }
	}

	// The Foundational Docs tree rendered into the Documentation host. (Tree relocation wired next; the
	// app owns the inline-doc provider wiring so this view stays agnostic about what the tab hosts.)
	_mountDocsEmbed()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.renderDocsTreeInto === 'function') { tmpApp.renderDocsTreeInto('#PS-Notebook-Documentation'); }
		else { this.pict.ContentAssignment.assignContent('#PS-Notebook-Documentation', '<div class="ps-nb-empty">Documentation tree.</div>'); }
	}

	_mountNoteEditor()
	{
		let tmpEd = this._noteEditor();
		if (!tmpEd)
		{
			this.pict.ContentAssignment.assignContent('#PS-Notebook-Note-MDE',
				'<div class="ps-nb-empty">The markdown editor is not available in this build.</div>');
			return;
		}
		try { if (tmpEd.initialRenderComplete) { tmpEd.destroy(); tmpEd.initialRenderComplete = false; } } catch (pErr) { /* ignore */ }
		tmpEd.render();
		tmpEd.marshalToView();
		this._editorMountedNoteID = this._data().SelectedNoteID || 0;
	}

	_mountChecklistsEmbed()
	{
		let tmpEmbed = this._checklistsEmbed();
		if (!tmpEmbed) { return; }
		// show() = reload (fetch the caller's lists + render + mount each checklist control) into the
		// fresh #PS-Notebook-Checklists host.
		try
		{
			if (typeof tmpEmbed.show === 'function') { tmpEmbed.show(); }
			else if (typeof tmpEmbed.render === 'function') { tmpEmbed.render(); }
		}
		catch (pErr) { /* ignore */ }
	}

	/**
	 * The notebook rail is REMEMBERED, not routed.
	 *
	 * The routing audit flagged the rail's tab and note selection as state a reload throws away, and it
	 * is -- but a route is the wrong instrument for it. This rail opens over whatever page you are on,
	 * so giving it a URL would navigate away from that page to show a drawer. The page twin
	 * (PictView-NotesPage) is a page and is correctly routed to /note/:id; this is not.
	 *
	 * So the loss is fixed rather than the mechanism copied: the rail comes back where you left it.
	 */
	_persistRail()
	{
		try
		{
			if (typeof window === 'undefined' || !window.localStorage) { return; }
			let tmpData = this._data();
			window.localStorage.setItem(_RAIL_KEY, JSON.stringify(
				{ ActiveTab: tmpData.ActiveTab || 'notes', SelectedNoteID: tmpData.SelectedNoteID || 0 }));
		}
		catch (pError) { /* storage full or unavailable; the rail is a convenience */ }
	}

	_restoreRail()
	{
		try
		{
			if (typeof window === 'undefined' || !window.localStorage) { return {}; }
			let tmpRaw = window.localStorage.getItem(_RAIL_KEY);
			let tmpSaved = tmpRaw ? JSON.parse(tmpRaw) : {};
			return (tmpSaved && typeof tmpSaved === 'object') ? tmpSaved : {};
		}
		catch (pError) { return {}; }
	}

	// ─── sidebar tab preferences (Settings > Appearance) ────────────────
	// Stored per-device as { Enabled: { key: bool }, Default: key }. A tab is ON unless explicitly off.
	_tabPrefs()
	{
		try
		{
			if (typeof window === 'undefined' || !window.localStorage) { return { Enabled: {}, Default: '' }; }
			let tmpRaw = window.localStorage.getItem(_TABS_KEY);
			let tmpP = tmpRaw ? JSON.parse(tmpRaw) : {};
			return { Enabled: (tmpP && tmpP.Enabled) || {}, Default: (tmpP && tmpP.Default) || '' };
		}
		catch (pErr) { return { Enabled: {}, Default: '' }; }
	}

	// The enabled tabs in catalog order (never empty: if the user somehow turned them all off, show all).
	_enabledTabs()
	{
		let tmpEnabled = this._tabPrefs().Enabled;
		let tmpOn = _TAB_CATALOG.filter((pT) => tmpEnabled[pT.Key] !== false);
		return tmpOn.length ? tmpOn : _TAB_CATALOG.slice();
	}

	// The default tab on first open: the stored Default if it is enabled, else the first enabled tab.
	_defaultTab()
	{
		let tmpOn = this._enabledTabs();
		// Shipped default is Navigation (the primary app nav); the user can repoint it in Appearance.
		let tmpWant = this._tabPrefs().Default || 'navigation';
		return (tmpWant && tmpOn.some((pT) => pT.Key === tmpWant)) ? tmpWant : (tmpOn[0] ? tmpOn[0].Key : 'notes');
	}

	// Called by the Appearance screen after it writes new tab prefs: drop a now-hidden active tab and repaint.
	applyTabPrefs()
	{
		let tmpD = this._data();
		if (!this._enabledTabs().some((pT) => pT.Key === tmpD.ActiveTab)) { tmpD.ActiveTab = this._defaultTab(); }
		this.render();
	}

	// ── public surface for Settings > Appearance ────────────────────────────
	// The full catalog (Key / Label / Short / Icon), in display order, so the Appearance screen can
	// render a row per tab without duplicating the list.
	tabCatalog() { return _TAB_CATALOG.slice(); }

	// The stored prefs ({ Enabled: { key: bool }, Default: key }), normalized. A tab is ON unless off.
	getTabPrefs() { return this._tabPrefs(); }

	// Write new prefs from the Appearance screen, then repaint the rail. We never let the user turn
	// every tab off (an empty rail is a dead end): if the incoming set has none enabled, this keeps the
	// stored prefs untouched and returns false so the caller can snap its control back.
	setTabPrefs(pPrefs)
	{
		let tmpEnabled = (pPrefs && pPrefs.Enabled) || {};
		if (!_TAB_CATALOG.some((pT) => tmpEnabled[pT.Key] !== false)) { return false; }
		let tmpOut = { Enabled: tmpEnabled, Default: (pPrefs && pPrefs.Default) || '' };
		try
		{
			if (typeof window !== 'undefined' && window.localStorage) { window.localStorage.setItem(_TABS_KEY, JSON.stringify(tmpOut)); }
		}
		catch (pErr) { /* best effort; prefs are a per-device convenience */ }
		this.applyTabPrefs();
		return true;
	}

	setTab(pTab)
	{
		this._data().ActiveTab = pTab;
		this._persistRail();
		// The Gallery loads its private media lazily on open (one fetch per tab visit), then repaints.
		if (pTab === 'gallery') { this.refreshGallery(); }
		else { this.render(); }
	}

	// Gallery -- the caller's private media (note images + direct uploads), all Media.IDUser = them.
	refreshGallery()
	{
		let tmpMedia = this.pict.providers.MediaAPI;
		if (!tmpMedia || typeof tmpMedia.listMine !== 'function') { this.render(); return; }
		tmpMedia.listMine()
			.then((pRows) => { this._data().Gallery = Array.isArray(pRows) ? pRows : []; this.render(); })
			.catch(() => this.render());
	}

	// Open the file picker by clicking the hidden input directly. A <label for> over a display:none input
	// is unreliable on some mobile browsers (and blockable by extensions), so drive it explicitly.
	openGalleryPicker()
	{
		let tmpInput = (typeof document !== 'undefined') ? document.getElementById('PS-Notebook-Gallery-Input') : null;
		if (tmpInput) { tmpInput.click(); }
	}

	onGalleryPick(pInput)
	{
		if (!pInput || !pInput.files) { return; }
		this._uploadGalleryFiles(pInput.files);
		pInput.value = '';
	}

	onGalleryDrop(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		let tmpFiles = (pEvent && pEvent.dataTransfer) ? pEvent.dataTransfer.files : null;
		if (tmpFiles && tmpFiles.length) { this._uploadGalleryFiles(tmpFiles); }
	}

	_uploadGalleryFiles(pFiles)
	{
		let tmpMedia = this.pict.providers.MediaAPI;
		if (!tmpMedia) { return; }
		let tmpImages = [];
		for (let i = 0; i < pFiles.length; i++)
		{
			if (pFiles[i] && pFiles[i].type && pFiles[i].type.indexOf('image/') === 0) { tmpImages.push(pFiles[i]); }
		}
		if (!tmpImages.length) { return; }
		// OwnerType 'User' / IDOwner 0: a direct gallery upload (not tied to a note). Private: true is
		// what makes it the caller's own; the server stamps Media.IDUser from the session.
		Promise.all(tmpImages.map((pF) => tmpMedia.upload('User', 0, pF, { Private: true }).catch(() => null)))
			.then(() => this.refreshGallery());
	}

	copyGalleryRef(pIDMedia)
	{
		let tmpMedia = this.pict.providers.MediaAPI;
		let tmpURL = tmpMedia ? tmpMedia.blobURL(pIDMedia) : ('/1.0/Media/' + pIDMedia + '/Blob');
		let tmpRef = '![](' + tmpURL + ')';
		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(tmpRef).then(() => this._toast('Markdown reference copied.', 'success')).catch(() => this._toast(tmpRef, 'info'));
		}
		else { this._toast(tmpRef, 'info'); }
	}

	// The blob URL for a gallery item, from the Media provider (falls back to the canonical route).
	_blobURL(pIDMedia)
	{
		let tmpMedia = this.pict.providers.MediaAPI;
		return tmpMedia ? tmpMedia.blobURL(pIDMedia) : ('/1.0/Media/' + pIDMedia + '/Blob');
	}

	// A human size for the lightbox caption. KB/MB, one decimal, no trailing zero noise.
	_bytes(pSize)
	{
		let tmpSize = Number(pSize) || 0;
		if (tmpSize <= 0) { return ''; }
		if (tmpSize < 1024) { return tmpSize + ' B'; }
		if (tmpSize < 1024 * 1024) { return (Math.round(tmpSize / 102.4) / 10) + ' KB'; }
		return (Math.round(tmpSize / (1024 * 104.8576)) / 10) + ' MB';
	}

	// Filename, size and type, whichever the row carries, for the lightbox subtitle.
	_mediaMeta(pRow)
	{
		let tmpParts = [];
		if (pRow.OriginalFileName) { tmpParts.push(pRow.OriginalFileName); }
		let tmpSize = this._bytes(pRow.FileSize || pRow.Size || pRow.ByteSize || 0);
		if (tmpSize) { tmpParts.push(tmpSize); }
		if (pRow.MimeType) { tmpParts.push(pRow.MimeType); }
		return tmpParts.join('  ·  ');
	}

	// Open the full-size viewer for one image. The lightbox is a one-element AppData slot, so a render
	// paints it; Escape and a backdrop click close it.
	viewGalleryItem(pIDMedia)
	{
		let tmpRow = (this._data().Gallery || []).find((pM) => pM.IDMedia === pIDMedia);
		if (!tmpRow) { return; }
		this._data().GalleryLightbox =
		{
			IDMedia: pIDMedia,
			Title: tmpRow.Title || tmpRow.OriginalFileName || ('Image ' + pIDMedia),
			URL: this._blobURL(pIDMedia),
			Meta: this._mediaMeta(tmpRow)
		};
		this._bindLightboxKeys();
		this.render();
	}

	closeGalleryLightbox()
	{
		this._data().GalleryLightbox = null;
		this._unbindLightboxKeys();
		this.render();
	}

	_bindLightboxKeys()
	{
		if (typeof document === 'undefined' || this._lightboxKeyHandler) { return; }
		this._lightboxKeyHandler = (pEvent) => { if (pEvent.key === 'Escape') { this.closeGalleryLightbox(); } };
		document.addEventListener('keydown', this._lightboxKeyHandler);
	}

	_unbindLightboxKeys()
	{
		if (typeof document === 'undefined' || !this._lightboxKeyHandler) { return; }
		document.removeEventListener('keydown', this._lightboxKeyHandler);
		this._lightboxKeyHandler = null;
	}

	// Save the original bytes. ?download=1 makes the server send Content-Disposition: attachment (and take
	// the proxy path so it works even when blobs are direct-served from object storage), so the real
	// filename lands in Downloads instead of the image opening inline.
	downloadGalleryItem(pIDMedia)
	{
		if (typeof document === 'undefined') { return; }
		let tmpBlobURL = this._blobURL(pIDMedia);
		let tmpURL = tmpBlobURL + (tmpBlobURL.indexOf('?') < 0 ? '?' : '&') + 'download=1';
		let tmpRow = (this._data().Gallery || []).find((pM) => pM.IDMedia === pIDMedia);
		let tmpName = tmpRow ? (tmpRow.OriginalFileName || tmpRow.Title || ('media-' + pIDMedia)) : ('media-' + pIDMedia);
		let tmpAnchor = document.createElement('a');
		tmpAnchor.href = tmpURL;
		tmpAnchor.download = tmpName;
		tmpAnchor.rel = 'noopener';
		document.body.appendChild(tmpAnchor);
		tmpAnchor.click();
		document.body.removeChild(tmpAnchor);
	}

	// View the raw image on its own (inline), handy for zooming with the browser's own controls.
	openGalleryItemTab(pIDMedia)
	{
		if (typeof window !== 'undefined') { window.open(this._blobURL(pIDMedia), '_blank', 'noopener'); }
	}

	deleteGalleryItem(pIDMedia)
	{
		let tmpMedia = this.pict.providers.MediaAPI;
		if (!tmpMedia || typeof tmpMedia.removeMine !== 'function') { return; }
		let tmpLightbox = this._data().GalleryLightbox;
		if (tmpLightbox && tmpLightbox.IDMedia === pIDMedia) { this._data().GalleryLightbox = null; this._unbindLightboxKeys(); }
		tmpMedia.removeMine(pIDMedia).then(() => this.refreshGallery()).catch(() => {});
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2200 });
		}
	}

	selectNote(pID)
	{
		let tmpD = this._data();
		tmpD.SelectedNoteID = (tmpD.SelectedNoteID === pID) ? 0 : pID;
		this._persistRail();
		let tmpNote = (tmpD.Notes || []).find((pN) => pN.IDNote === tmpD.SelectedNoteID);
		tmpD.DraftTitle = tmpNote ? (tmpNote.Title || '') : null;
		// Seed the editor with the selected note's body; the capture guard in onBeforeRender will not
		// overwrite this because _editorMountedNoteID still points at the previously-mounted note.
		this.pict.AppData.NotebookNoteEditor.Segments = tmpNote ? [{ Content: tmpNote.Content || '' }] : [];
		this.render();
	}

	// The title is a plain input marshalled into the draft on the way in (no re-render per keystroke);
	// the body lives in the markdown editor and is read on save.
	onDraftTitle(pValue) { this._data().DraftTitle = pValue; }

	// Images pasted / dragged / picked in a note are owned by that note (OwnerType 'Note', IDOwner =
	// the note's id) so the bytes live in Parime instead of bloating the note as a base64 data URI.
	// The note always has a real id by the time its editor is open (newNote creates server-side first).
	noteImageOwnerContext() { return { OwnerType: 'Note', IDOwner: this._data().SelectedNoteID || 0 }; }

	newNote()
	{
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		tmpAPI.createNote({ Title: 'Untitled note', Content: '' }).then((pRec) =>
		{
			let tmpD = this._data();
			if (pRec && pRec.IDNote)
			{
				tmpD.SelectedNoteID = pRec.IDNote;
				tmpD.DraftTitle = 'Untitled note';
				this.pict.AppData.NotebookNoteEditor.Segments = [{ Content: '' }];
			}
			this.refresh();
		}).catch(() => {});
	}

	saveNote()
	{
		let tmpAPI = this._api();
		let tmpD = this._data();
		if (!tmpAPI || !tmpD.SelectedNoteID) { return; }
		let tmpEd = this._noteEditor();
		let tmpContent = (tmpEd && typeof tmpEd.getAllContent === 'function') ? tmpEd.getAllContent('\n\n') : '';
		tmpAPI.updateNote(tmpD.SelectedNoteID, { Title: tmpD.DraftTitle || '', Content: tmpContent })
			.then(() => this.refresh()).catch(() => {});
	}

	deleteNote(pID)
	{
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		tmpAPI.deleteNote(pID).then(() =>
		{
			let tmpD = this._data();
			if (tmpD.SelectedNoteID === pID)
			{
				tmpD.SelectedNoteID = 0;
				tmpD.DraftTitle = null;
				this.pict.AppData.NotebookNoteEditor.Segments = [];
				this._editorMountedNoteID = 0;
			}
			this.refresh();
		}).catch(() => {});
	}

	pinPage()
	{
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		let tmpRoute = this._currentRoute();
		// Match History/Trending: pin the bare page name, not the "... - Plansheet" browser-tab title.
		let tmpTitle = (typeof document !== 'undefined' && document.title) ? document.title : '';
		let tmpApp = this.pict.PictApplication;
		let tmpLabel = tmpTitle
			? ((tmpApp && typeof tmpApp._pageLabelFromTitle === 'function') ? tmpApp._pageLabelFromTitle(tmpTitle) : tmpTitle)
			: tmpRoute;
		tmpAPI.createBookmark({ Label: tmpLabel, Route: tmpRoute, Favorite: 1 }).then(() => this.refresh()).catch(() => {});
	}

	removeBookmark(pID)
	{
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		tmpAPI.deleteBookmark(pID).then(() => this.refresh()).catch(() => {});
	}

	go(pRoute)
	{
		if (typeof window === 'undefined') { return; }
		window.location.hash = '#' + String(pRoute || '/').replace(/^#/, '');
	}
}

module.exports = PictViewNotebook;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Notebook',
	DefaultRenderable: 'Plansheet-Notebook',
	DefaultDestinationAddress: '#Plansheet-Notebook',
	AutoRender: false,
	CSS: /*css*/`
		.ps-notebook { display: flex; flex-direction: column; height: 100%; min-height: 0;
			background: transparent; color: var(--theme-color-text-primary, #1d2230); }
		.ps-notebook-head { flex: 0 0 auto; display: flex; align-items: center; gap: 8px;
			padding: 12px 14px; border-bottom: 1px solid var(--theme-color-border-default, #e3e6ec); }
		.ps-notebook-title { flex: 1; font-size: 15px; font-weight: 600; letter-spacing: 0.01em; }
		.ps-notebook-close { flex: 0 0 auto; width: 28px; height: 28px; border: none; border-radius: 6px;
			background: transparent; color: var(--theme-color-text-secondary, #5b6376); cursor: pointer;
			font-size: 18px; line-height: 1; display: flex; align-items: center; justify-content: center; }
		.ps-notebook-close:hover { background: var(--theme-color-background-hover, #eef1f6); }
		/* Icon-forward tab row: an icon + a short caption, full label on hover (title). Equal-width cells
		   so 5-6 tabs fit a narrow sidebar without wrapping. */
		.ps-nb-tabs { flex: 0 0 auto; display: flex; gap: 2px; padding: 6px 6px;
			border-bottom: 1px solid var(--theme-color-border-default, #e3e6ec); }
		.ps-nb-tab { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; align-items: center; gap: 3px;
			padding: 6px 2px; border: 0; border-radius: 7px; background: transparent;
			color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; }
		.ps-nb-tab-ico { width: 18px; height: 18px; flex: 0 0 auto; }
		.ps-nb-tab-lbl { font-size: 10px; line-height: 1; letter-spacing: 0.02em; max-width: 100%;
			overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.ps-nb-tab:hover { background: var(--theme-color-background-hover, #eef1f6); color: var(--theme-color-text-primary, #2c3140); }
		.ps-nb-tab.is-active { background: color-mix(in srgb, var(--theme-color-brand-primary, #3b6fd4) 12%, transparent);
			color: var(--theme-color-brand-primary, #3b6fd4); }
		/* The Navigation + Documentation tabs host full-bleed embeds (docked nav / doc tree); drop the
		   tab-body reading padding so they use the full column. */
		.ps-nb-tabbody:has(.ps-nb-nav-host), .ps-nb-tabbody:has(.ps-nb-docs-host) { padding: 0; }
		.ps-nb-nav-host, .ps-nb-docs-host { height: 100%; }
		.ps-nb-tabbody { flex: 1; min-height: 0; overflow-y: auto; padding: 12px 14px 24px; }
		.ps-nb-empty { color: var(--theme-color-text-secondary, #5b6376); font-style: italic; font-size: 13px; margin: 10px 2px; }
		.ps-nb-new { width: 100%; padding: 7px 10px; margin-bottom: 10px; font-size: 13px; cursor: pointer;
			border: 1px dashed var(--theme-color-border-default, #c9d0db); border-radius: 8px;
			background: transparent; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-nb-new:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-primary, #2c3140); }
		.ps-nb-notelist { display: flex; flex-direction: column; gap: 2px; margin-bottom: 10px; }
		.ps-nb-noterow { text-align: left; padding: 6px 8px; font-size: 13px; border: none; border-radius: 6px;
			background: transparent; color: var(--theme-color-text-primary, #2c3140); cursor: pointer; width: 100%;
			white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-nb-noterow:hover { background: var(--theme-color-background-hover, #eef1f6); }
		.ps-nb-noterow.is-active { background: var(--theme-color-background-hover, #e7edf8); font-weight: 600; }
		.ps-nb-editor { display: flex; flex-direction: column; gap: 6px; margin-top: 6px;
			border-top: 1px solid var(--theme-color-border-default, #e3e6ec); padding-top: 10px; }
		.ps-nb-noteTitle { padding: 6px 8px; font-size: 13px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; }
		.ps-nb-mde { border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; overflow: hidden;
			background: var(--theme-color-background-panel, #fff); }
		.ps-nb-mde .cm-editor { min-height: 220px; }
		.ps-nb-mde .cm-content { min-height: 220px; }
		.ps-nb-editor-actions { display: flex; gap: 6px; }
		.ps-nb-save { flex: 1; padding: 6px 10px; font-size: 13px; cursor: pointer; border: none; border-radius: 6px;
			background: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-on-brand, #fff); }
		.ps-nb-del { padding: 6px 10px; font-size: 13px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 6px; background: transparent; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-nb-checklists-host { margin-top: 2px; }
		.ps-nb-gallery-input { display: none; }
		.ps-nb-gallery-upload { display: block; text-align: center; }
		.ps-nb-gallery-zone { border: 1px dashed transparent; border-radius: 8px; padding: 2px; transition: border-color 0.15s ease; }
		.ps-nb-gallery-zone:hover { border-color: var(--theme-color-border-default, #d8dde6); }
		.ps-nb-gallery-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
		.ps-nb-gallery-item { position: relative; aspect-ratio: 1 / 1; border-radius: 8px; overflow: hidden;
			border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-secondary, #f1f3f7); }
		.ps-nb-gallery-thumb { width: 100%; height: 100%; object-fit: cover; display: block; cursor: pointer; }
		.ps-nb-gallery-del { position: absolute; top: 4px; right: 4px; width: 22px; height: 22px; border: none; border-radius: 5px;
			background: rgba(20, 24, 32, 0.55); color: #fff; cursor: pointer; font-size: 15px; line-height: 1;
			display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.15s ease; }
		.ps-nb-gallery-item:hover .ps-nb-gallery-del { opacity: 1; }
		.ps-nb-gallery-del:hover { background: var(--theme-color-status-error, #cc3333); }
		/* Full-size image viewer. Fixed overlay over the whole app; the stage shows a checker so a PNG's
		   transparency reads at a glance (stickers), and the image is never cropped (object-fit: contain). */
		.ps-nb-lightbox { position: fixed; inset: 0; z-index: 4000; display: flex; align-items: center; justify-content: center;
			padding: 24px; box-sizing: border-box; background: rgba(15, 19, 26, 0.72); }
		/* Grid (not flex column): the 1fr middle row gives the stage a DEFINITE height, so the image's
		   max-height: 100% actually resolves -- a flex-derived height does not, and the image overflows. */
		.ps-nb-lightbox-card { display: grid; grid-template-rows: auto minmax(0, 1fr) auto; max-width: min(1100px, 92vw); max-height: 92vh;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 10px; overflow: hidden; box-shadow: 0 18px 60px rgba(0, 0, 0, 0.4); }
		.ps-nb-lightbox-bar { display: flex; align-items: center; gap: 12px; padding: 10px 12px;
			border-bottom: 1px solid var(--theme-color-border-light, #eef0f4); }
		.ps-nb-lightbox-meta { display: flex; flex-direction: column; min-width: 0; flex: 1 1 auto; }
		.ps-nb-lightbox-title { font-size: 0.92em; font-weight: 600; color: var(--theme-color-text-primary, #1d2230);
			overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.ps-nb-lightbox-sub { font-size: 0.74em; color: var(--theme-color-text-secondary, #5b6376);
			overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.ps-nb-lightbox-x { flex: 0 0 auto; width: 28px; height: 28px; border: none; border-radius: 6px; background: transparent;
			color: var(--theme-color-text-secondary, #8a93a6); font-size: 20px; line-height: 1; cursor: pointer; }
		.ps-nb-lightbox-x:hover { background: var(--theme-color-background-hover, #e0e5ee); color: var(--theme-color-text-primary, #2c3140); }
		.ps-nb-lightbox-stage { min-height: 0; overflow: hidden; display: flex; align-items: center; justify-content: center; padding: 16px;
			background-color: var(--theme-color-background-secondary, #f5f6f8);
			background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.045) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.045) 75%),
				linear-gradient(45deg, rgba(0, 0, 0, 0.045) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.045) 75%);
			background-size: 20px 20px; background-position: 0 0, 10px 10px; }
		.ps-nb-lightbox-stage img { max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 2px; box-shadow: 0 1px 6px rgba(0, 0, 0, 0.18); }
		.ps-nb-lightbox-actions { display: flex; flex-wrap: wrap; gap: 8px; padding: 10px 12px;
			border-top: 1px solid var(--theme-color-border-light, #eef0f4); }
		.ps-nb-lightbox-btn { padding: 6px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px;
			background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); font-size: 0.82em; cursor: pointer; }
		.ps-nb-lightbox-btn:hover { background: var(--theme-color-background-hover, #eef1f6); }
		.ps-nb-lightbox-btn-danger:hover { background: var(--theme-color-status-error, #cc3333); color: #fff; border-color: var(--theme-color-status-error, #cc3333); }
		.ps-nb-section { margin: 12px 0; }
		.ps-nb-section-title { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em;
			color: var(--theme-color-text-secondary, #8a93a6); margin: 0 2px 4px; }
		.ps-nb-bm { display: flex; align-items: center; gap: 6px; padding: 4px 6px; border-radius: 6px; }
		.ps-nb-bm:hover { background: var(--theme-color-background-hover, #eef1f6); }
		.ps-nb-bmlink { flex: 1; font-size: 13px; cursor: pointer; color: var(--theme-color-brand-primary, #3b6fd4);
			white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-nb-bmx { width: 22px; height: 22px; border: none; border-radius: 5px; background: transparent;
			color: var(--theme-color-text-secondary, #8a93a6); cursor: pointer; font-size: 15px; line-height: 1; }
		.ps-nb-bmx:hover { background: var(--theme-color-background-hover, #e0e5ee); color: var(--theme-color-text-primary, #2c3140); }
		.ps-nb-count { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); }
		/* History visit-count pill: only visible when the server returned Count > 0.
		   CountLabel is '' for pages not visited within the trending window, so :empty hides the span. */
		.ps-nb-count-recent { min-width: 16px; text-align: center; line-height: 16px; padding: 0 5px;
			border-radius: 8px; background: var(--theme-color-background-hover, #eef1f6); font-weight: 600;
			font-variant-numeric: tabular-nums; white-space: nowrap; }
		.ps-nb-count-recent:empty { display: none; }
		/* Compact bookmark/history age -- fixed, tiny, tabular, and shrink-proof so it never wraps a row. */
		.ps-nb-bm-age { flex: 0 0 auto; font-size: 10px; color: var(--theme-color-text-secondary, #8a93a6); font-variant-numeric: tabular-nums; white-space: nowrap; }
		/* On a phone the rail is the whole screen, so let the note editor use every pixel of it. */
		@media (max-width: 860px)
		{
			.ps-nb-tabbody { padding: 10px 10px 24px; }
			.ps-nb-mde, .ps-nb-editor { width: 100%; }
		}
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-Notebook',
			Template: /*html*/`
<div class="ps-notebook">
	<div class="ps-nb-tabs">{~TS:Notebook-Tab:AppData.Notebook.Tabs~}</div>
	<div class="ps-nb-tabbody">
		{~TS:Notebook-NotesTab:AppData.Notebook.NotesSlot~}
		{~TS:Notebook-BookmarksTab:AppData.Notebook.BookmarksSlot~}
		{~TS:Notebook-ChecklistsTab:AppData.Notebook.ChecklistsSlot~}
		{~TS:Notebook-GalleryTab:AppData.Notebook.GallerySlot~}
		{~TS:Notebook-DocumentationTab:AppData.Notebook.DocumentationSlot~}
		{~TS:Notebook-NavigationTab:AppData.Notebook.NavigationSlot~}
	</div>
	{~TS:Notebook-Lightbox:AppData.Notebook.LightboxSlot~}
</div>`
		},
		{
			Hash: 'Notebook-Tab',
			Template: /*html*/`<button class="ps-nb-tab{~NE:Record.Active^ is-active~}" title="{~D:Record.Label~}" aria-label="{~D:Record.Label~}" onclick="{~P~}.views['Plansheet-Notebook'].setTab('{~D:Record.Key~}')">{~D:Record.Icon~}<span class="ps-nb-tab-lbl">{~D:Record.Short~}</span></button>`
		},
		{
			Hash: 'Notebook-NotesTab',
			Template: /*html*/`
<button class="ps-nb-new" onclick="{~P~}.views['Plansheet-Notebook'].newNote()">+ New note</button>
{~TS:Notebook-NotesEmpty:AppData.Notebook.NotesEmpty~}
<div class="ps-nb-notelist">{~TS:Notebook-NoteRow:AppData.Notebook.NoteRows~}</div>
{~TS:Notebook-Editor:AppData.Notebook.EditorSlot~}`
		},
		{
			Hash: 'Notebook-NotesEmpty',
			Template: /*html*/`<p class="ps-nb-empty">No notes yet. Jot down anything you want to keep by the drafting table.</p>`
		},
		{
			Hash: 'Notebook-NoteRow',
			Template: /*html*/`<button class="ps-nb-noterow{~NE:Record.Active^ is-active~}" onclick="{~P~}.views['Plansheet-Notebook'].selectNote({~D:Record.IDNote~})">{~D:Record.Title~}</button>`
		},
		{
			Hash: 'Notebook-Editor',
			Template: /*html*/`
<div class="ps-nb-editor">
	<input class="ps-nb-noteTitle" value="{~D:Record.Title~}" placeholder="Title" oninput="{~P~}.views['Plansheet-Notebook'].onDraftTitle(this.value)" />
	<div class="ps-nb-mde" id="PS-Notebook-Note-MDE"></div>
	<div class="ps-nb-editor-actions">
		<button class="ps-nb-save" onclick="{~P~}.views['Plansheet-Notebook'].saveNote()">Save</button>
		<button class="ps-nb-del" onclick="{~P~}.views['Plansheet-Notebook'].deleteNote({~D:Record.IDNote~})">Delete</button>
	</div>
</div>`
		},
		{
			Hash: 'Notebook-BookmarksTab',
			Template: /*html*/`
<button class="ps-nb-new" onclick="{~P~}.views['Plansheet-Notebook'].pinPage()">+ Pin this page</button>
{~TS:Notebook-FavSection:AppData.Notebook.FavSlot~}
{~TS:Notebook-RecentSection:AppData.Notebook.RecentSlot~}
{~TS:Notebook-TrendingSection:AppData.Notebook.TrendingSlot~}`
		},
		{
			Hash: 'Notebook-FavSection',
			Template: /*html*/`<div class="ps-nb-section"><div class="ps-nb-section-title">Favorites</div>{~TS:Notebook-FavRow:AppData.Notebook.FavRows~}</div>`
		},
		{
			Hash: 'Notebook-FavRow',
			Template: /*html*/`<div class="ps-nb-bm"><a class="ps-nb-bmlink" onclick="{~P~}.views['Plansheet-Notebook'].go('{~D:Record.Route~}')">{~D:Record.Label~}</a><span class="ps-nb-bm-age" title="Bookmarked">{~D:Record.Age~}</span><button class="ps-nb-bmx" title="Remove" onclick="{~P~}.views['Plansheet-Notebook'].removeBookmark({~D:Record.IDBookmark~})">&times;</button></div>`
		},
		{
			Hash: 'Notebook-RecentSection',
			Template: /*html*/`<div class="ps-nb-section"><div class="ps-nb-section-title">History</div>{~TS:Notebook-LinkRow:AppData.Notebook.RecentRows~}</div>`
		},
		{
			Hash: 'Notebook-TrendingSection',
			Template: /*html*/`<div class="ps-nb-section"><div class="ps-nb-section-title">Trending</div>{~TS:Notebook-TrendingRow:AppData.Notebook.TrendingRows~}</div>`
		},
		{
			Hash: 'Notebook-LinkRow',
			Template: /*html*/`<div class="ps-nb-bm"><a class="ps-nb-bmlink" onclick="{~P~}.views['Plansheet-Notebook'].go('{~D:Record.Route~}')">{~D:Record.Label~}</a><span class="ps-nb-count ps-nb-count-recent" title="Recent visits">{~D:Record.CountLabel~}</span><span class="ps-nb-bm-age" title="Last visited">{~D:Record.Age~}</span></div>`
		},
		{
			Hash: 'Notebook-TrendingRow',
			Template: /*html*/`<div class="ps-nb-bm"><a class="ps-nb-bmlink" onclick="{~P~}.views['Plansheet-Notebook'].go('{~D:Record.Route~}')">{~D:Record.Label~}</a><span class="ps-nb-count">{~D:Record.Count~}</span></div>`
		},
		{
			Hash: 'Notebook-ChecklistsTab',
			Template: /*html*/`<div class="ps-nb-checklists-host" id="PS-Notebook-Checklists"></div>`
		},
		{
			Hash: 'Notebook-GalleryTab',
			Template: /*html*/`
<input type="file" id="PS-Notebook-Gallery-Input" class="ps-nb-gallery-input" accept="image/*" multiple onchange="{~P~}.views['Plansheet-Notebook'].onGalleryPick(this)" />
<button type="button" class="ps-nb-new ps-nb-gallery-upload" onclick="{~P~}.views['Plansheet-Notebook'].openGalleryPicker()">+ Upload image</button>
<div class="ps-nb-gallery-zone" ondragover="event.preventDefault()" ondrop="{~P~}.views['Plansheet-Notebook'].onGalleryDrop(event)">
	{~TS:Notebook-GalleryEmpty:AppData.Notebook.GalleryEmpty~}
	<div class="ps-nb-gallery-grid">{~TS:Notebook-GalleryItem:AppData.Notebook.GalleryRows~}</div>
</div>`
		},
		{
			Hash: 'Notebook-GalleryEmpty',
			Template: /*html*/`<p class="ps-nb-empty">No images yet. Upload here or drag one in; images pasted into a note land here too. They are private to you.</p>`
		},
		{
			Hash: 'Notebook-GalleryItem',
			Template: /*html*/`<div class="ps-nb-gallery-item"><img class="ps-nb-gallery-thumb" src="{~D:Record.URL~}" alt="{~D:Record.Title~}" title="{~D:Record.Title~} — click to view" onclick="{~P~}.views['Plansheet-Notebook'].viewGalleryItem({~D:Record.IDMedia~})" /><button class="ps-nb-gallery-del" title="Delete" onclick="{~P~}.views['Plansheet-Notebook'].deleteGalleryItem({~D:Record.IDMedia~})">&times;</button></div>`
		},
		{
			// The full-size viewer. A one-element slot (AppData.Notebook.LightboxSlot) paints it over the
			// whole notebook; the backdrop and the x close it, as does Escape (bound in viewGalleryItem).
			Hash: 'Notebook-Lightbox',
			Template: /*html*/`
<div class="ps-nb-lightbox" onclick="{~P~}.views['Plansheet-Notebook'].closeGalleryLightbox()">
	<div class="ps-nb-lightbox-card" onclick="event.stopPropagation()">
		<div class="ps-nb-lightbox-bar">
			<div class="ps-nb-lightbox-meta"><span class="ps-nb-lightbox-title">{~D:Record.Title~}</span><span class="ps-nb-lightbox-sub">{~D:Record.Meta~}</span></div>
			<button class="ps-nb-lightbox-x" title="Close" aria-label="Close" onclick="{~P~}.views['Plansheet-Notebook'].closeGalleryLightbox()">&times;</button>
		</div>
		<div class="ps-nb-lightbox-stage"><img src="{~D:Record.URL~}" alt="{~D:Record.Title~}" /></div>
		<div class="ps-nb-lightbox-actions">
			<button class="ps-nb-lightbox-btn" onclick="{~P~}.views['Plansheet-Notebook'].downloadGalleryItem({~D:Record.IDMedia~})">Download</button>
			<button class="ps-nb-lightbox-btn" onclick="{~P~}.views['Plansheet-Notebook'].openGalleryItemTab({~D:Record.IDMedia~})">Open in new tab</button>
			<button class="ps-nb-lightbox-btn" onclick="{~P~}.views['Plansheet-Notebook'].copyGalleryRef({~D:Record.IDMedia~})">Copy markdown</button>
			<button class="ps-nb-lightbox-btn ps-nb-lightbox-btn-danger" onclick="{~P~}.views['Plansheet-Notebook'].deleteGalleryItem({~D:Record.IDMedia~})">Delete</button>
		</div>
	</div>
</div>`
		},
		{
			// The Foundational Docs tree mounts here (the InlineDoc-Nav view, relocated from the reader).
			Hash: 'Notebook-DocumentationTab',
			Template: /*html*/`<div class="ps-nb-docs-host" id="PS-Notebook-Documentation"></div>`
		},
		{
			// The docked site-map navigation mounts here (the primary app nav, now a tab).
			Hash: 'Notebook-NavigationTab',
			Template: /*html*/`<div class="ps-nb-nav-host" id="PS-Notebook-Navigation"></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-Notebook',
			TemplateHash: 'Plansheet-Notebook',
			ContentDestinationAddress: '#Plansheet-Notebook'
		}
	]
};

},{"pict-view":365}],681:[function(require,module,exports){
'use strict';

/**
 * NotebookNoteEditor -- the rich markdown editor (pict-section-markdowneditor) hosted in the
 * notebook's Notes tab. Same editor as the Docs Lake and the entity-form description field, just
 * sized for the narrow left drawer (preview off by default; the user can toggle it on per-segment).
 *
 * It mounts into #PS-Notebook-Note-MDE, bound to AppData.NotebookNoteEditor.Segments. The host
 * (PictView-Notebook) seeds the selected note's content into that segment array, re-mounts the
 * editor after each panel render (PictView-DocEditor pattern: destroy -> render -> marshalToView),
 * and reads the edited markdown back with getAllContent('\n\n') when the user clicks Save.
 *
 * Saving is an explicit button (the host reads getAllContent), so onContentChange stays the base
 * no-op. onImageUpload is overridden so a pasted / dragged / picked image is stored in Parime owned
 * by the note (OwnerType 'Note', IDOwner = the note's id) instead of inlined as a base64 data URI.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-Notebook-NoteEditor';
	tmpConfig.DefaultDestinationAddress = '#PS-Notebook-Note-MDE';
	tmpConfig.TargetElementAddress = '#PS-Notebook-Note-MDE';
	tmpConfig.ContentDataAddress = 'AppData.NotebookNoteEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'off';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#PS-Notebook-Note-MDE';
		}
	}

	return tmpConfig;
}

class PictViewNotebookNoteEditor extends libMarkdownEditor
{
	_host() { return this.pict.views['Plansheet-Notebook']; }

	_ownerContext()
	{
		let tmpHost = this._host();
		return (tmpHost && typeof tmpHost.noteImageOwnerContext === 'function') ? tmpHost.noteImageOwnerContext() : { OwnerType: 'Note', IDOwner: 0 };
	}

	/**
	 * Pasted / dragged / picked image -> upload to Parime owned by the open note, and insert the blob
	 * URL. Returning true = async handling; returning false falls back to the base64 embed (only if the
	 * note has no id yet, which should not happen since the editor only opens on a saved note).
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		let tmpOwner = this._ownerContext();
		if (!tmpOwner.IDOwner || !this.pict.providers.MediaAPI) { return false; }
		// Private: true -> owned by this user (Media.IDUser), so a note's images are as private as the
		// note. They also surface in the notebook's Gallery tab (the personal "user gallery").
		this.pict.providers.MediaAPI.upload(tmpOwner.OwnerType, tmpOwner.IDOwner, pFile, { Private: true })
			.then((pRow) => fCallback(null, this.pict.providers.MediaAPI.blobURL(pRow.IDMedia)))
			.catch((pErr) => fCallback(pErr.message || String(pErr)));
		return true;
	}
}

module.exports = PictViewNotebookNoteEditor;
module.exports.default_configuration = buildConfiguration();

},{"pict-section-markdowneditor":261}],682:[function(require,module,exports){
'use strict';

/**
 * NotesPage -- the full-page view of the caller's private markdown notes, rendered into the main
 * workspace (#Plansheet-Workspace) rather than the notebook rail. It is the page-sized twin of the
 * Notebook's Notes tab: same list/select/save/delete flow through providers.NotebookAPI, the same
 * real pict-section-markdowneditor child, just laid out two-column (note list left, editor right) on
 * a wide screen and stacked on a phone.
 *
 * Its render/view state lives under AppData.NotesPage (list + selection + draft title) and the
 * editor buffer under AppData.NotesPageEditor.Segments, kept separate from the rail notebook's
 * AppData.Notebook / AppData.NotebookNoteEditor so the two never fight over a buffer. The child
 * editor (Plansheet-NotesPage-Editor) owns #PS-NotesPage-MDE; because each panel render recreates
 * that host div, the editor is re-mounted after every render (destroy -> render -> marshalToView),
 * with an across-repaint capture guard in onBeforeRender so in-progress edits survive.
 */

const libPictView = require('pict-view');

class PictViewNotesPage extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		// The editor reads/writes its segments here (ContentDataAddress on the editor instance).
		this.pict.AppData.NotesPageEditor = this.pict.AppData.NotesPageEditor || { Segments: [] };
		// Which note the live editor is currently showing -- gates the across-repaint edit capture.
		this._editorMountedNoteID = 0;
	}

	_page() { return this.pict.AppData.NotesPage || (this.pict.AppData.NotesPage = { Notes: [] }); }
	_notebook() { return this.pict.AppData.Notebook || {}; }
	_api() { return this.pict.providers.NotebookAPI; }
	_noteEditor() { return this.pict.views['Plansheet-NotesPage-Editor']; }

	// Load (or refresh) the caller's notebook data, mirror the Notes into this page's namespace, then
	// repaint. NotebookAPI.loadNotebook is the one read that backs both the rail and this page.
	show()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.loadNotebook !== 'function') { this.render(); return; }
		return tmpAPI.loadNotebook().then(() =>
		{
			this._page().Notes = this._notebook().Notes || [];
			this.render();
		}).catch(() => this.render());
	}

	onBeforeRender(pRenderable)
	{
		let tmpD = this._page();
		let tmpSelectedID = tmpD.SelectedNoteID || 0;

		// Preserve in-progress edits across this repaint: if the live editor is showing the selected
		// note, pull its current markdown into the segment buffer so the remount restores it. Guarded
		// on _editorMountedNoteID so a note SWITCH (which seeds the new note's segments) is not clobbered.
		if (tmpSelectedID && this._editorMountedNoteID === tmpSelectedID)
		{
			let tmpEd = this._noteEditor();
			if (tmpEd && tmpEd.initialRenderComplete && typeof tmpEd.getAllContent === 'function')
			{
				try { this.pict.AppData.NotesPageEditor.Segments = [{ Content: tmpEd.getAllContent('\n\n') }]; } catch (pErr) { /* ignore */ }
			}
		}

		let tmpNotes = tmpD.Notes || [];
		tmpD.NoteRows = tmpNotes.map((pN) => ({ IDNote: pN.IDNote, Title: pN.Title || 'Untitled note', Active: pN.IDNote === tmpSelectedID }));
		tmpD.NotesEmpty = tmpNotes.length ? [] : [1];
		let tmpSelected = tmpNotes.find((pN) => pN.IDNote === tmpSelectedID);
		// The editor owns the body content (AppData.NotesPageEditor.Segments); the slot only carries
		// the id + the title field value.
		tmpD.EditorSlot = tmpSelected
			? [{
				IDNote: tmpSelected.IDNote,
				Title: (tmpD.DraftTitle != null) ? tmpD.DraftTitle : (tmpSelected.Title || '')
			}]
			: [];
		// One-or-zero-element slot: the empty editor pane hint when nothing is selected.
		tmpD.NoSelectionSlot = tmpSelected ? [] : [1];

		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		if (this._page().SelectedNoteID) { this._mountNoteEditor(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// The panel render recreates the editor's host div, so (re)mount the editor into the fresh host.
	_mountNoteEditor()
	{
		let tmpEd = this._noteEditor();
		if (!tmpEd)
		{
			this.pict.ContentAssignment.assignContent('#PS-NotesPage-MDE',
				'<div class="ps-notespage-hint">The markdown editor is not available in this build.</div>');
			return;
		}
		try { if (tmpEd.initialRenderComplete) { tmpEd.destroy(); tmpEd.initialRenderComplete = false; } } catch (pErr) { /* ignore */ }
		tmpEd.render();
		tmpEd.marshalToView();
		this._editorMountedNoteID = this._page().SelectedNoteID || 0;
	}

	// Selecting a note is a NAVIGATION to /note/:id (clicking the open note again deselects -> /notes), so
	// the open note deep-links and survives a reload (the selection used to live only in memory). The route
	// calls showNote to actually select + render.
	selectNote(pID)
	{
		let tmpApp = this.pict.PictApplication;
		let tmpAlready = (this._page().SelectedNoteID === pID);
		if (tmpApp && typeof tmpApp.showNote === 'function' && typeof tmpApp.showNotes === 'function')
		{
			if (tmpAlready) { tmpApp.showNotes(); } else { tmpApp.showNote(pID); }
			return;
		}
		// Fallback (no app/router): the original in-place select.
		let tmpD = this._page();
		tmpD.SelectedNoteID = tmpAlready ? 0 : pID;
		let tmpNote = (tmpD.Notes || []).find((pN) => pN.IDNote === tmpD.SelectedNoteID);
		tmpD.DraftTitle = tmpNote ? (tmpNote.Title || '') : null;
		this.pict.AppData.NotesPageEditor.Segments = tmpNote ? [{ Content: tmpNote.Content || '' }] : [];
		this.render();
	}

	// Route entry for /note/:id: select the note into the editor pane and repaint. Seeds the editor body,
	// loads the notebook first on a cold deep-link so the note resolves, and titles the page after it.
	showNote(pID)
	{
		let tmpID = Number(pID) || 0;
		let tmpSelf = this;
		let fApply = () =>
		{
			let tmpD = tmpSelf._page();
			tmpD.SelectedNoteID = tmpID;
			let tmpNote = (tmpD.Notes || []).find((pN) => pN.IDNote === tmpID);
			tmpD.DraftTitle = tmpNote ? (tmpNote.Title || '') : null;
			if (!tmpSelf.pict.AppData.NotesPageEditor) { tmpSelf.pict.AppData.NotesPageEditor = { Segments: [] }; }
			tmpSelf.pict.AppData.NotesPageEditor.Segments = tmpNote ? [{ Content: tmpNote.Content || '' }] : [];
			tmpSelf.render();
			let tmpApp = tmpSelf.pict.PictApplication;
			if (tmpApp && typeof tmpApp._setPageTitle === 'function') { tmpApp._setPageTitle((tmpNote && tmpNote.Title) || 'Note'); }
		};
		let tmpAPI = this._api();
		if (tmpAPI && typeof tmpAPI.loadNotebook === 'function' && !(this._page().Notes || []).length)
		{
			tmpAPI.loadNotebook().then(() => { tmpSelf._page().Notes = tmpSelf._notebook().Notes || []; fApply(); }).catch(fApply);
		}
		else { fApply(); }
	}

	// Route entry for /notes: clear any selection (the list, nothing open) and load + render.
	showList()
	{
		let tmpD = this._page();
		tmpD.SelectedNoteID = 0;
		tmpD.DraftTitle = null;
		if (this.pict.AppData.NotesPageEditor) { this.pict.AppData.NotesPageEditor.Segments = []; }
		this._editorMountedNoteID = 0;
		return this.show();
	}

	// The title is a plain input marshalled into the draft on the way in (no re-render per keystroke);
	// the body lives in the markdown editor and is read on save.
	onDraftTitle(pValue) { this._page().DraftTitle = pValue; }

	// Images pasted / dragged / picked in a note are owned by that note (OwnerType 'Note', IDOwner =
	// the note's id) so the bytes live in Parime instead of bloating the note as a base64 data URI.
	// The note always has a real id by the time its editor is open (newNote creates server-side first).
	noteImageOwnerContext() { return { OwnerType: 'Note', IDOwner: this._page().SelectedNoteID || 0 }; }

	newNote()
	{
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		let tmpSelf = this;
		tmpAPI.createNote({ Title: 'Untitled note', Content: '' }).then((pRec) =>
		{
			if (!pRec || !pRec.IDNote) { return tmpSelf.show(); }
			// Refresh the notebook so the new note is in the list, then open it via its route (/note/:id).
			let fGo = () =>
			{
				let tmpApp = tmpSelf.pict.PictApplication;
				if (tmpApp && typeof tmpApp.showNote === 'function') { tmpApp.showNote(pRec.IDNote); } else { tmpSelf.show(); }
			};
			if (typeof tmpAPI.loadNotebook === 'function') { tmpAPI.loadNotebook().then(() => { tmpSelf._page().Notes = tmpSelf._notebook().Notes || []; fGo(); }).catch(fGo); }
			else { fGo(); }
		}).catch(() => {});
	}

	saveNote()
	{
		let tmpAPI = this._api();
		let tmpD = this._page();
		if (!tmpAPI || !tmpD.SelectedNoteID) { return; }
		let tmpEd = this._noteEditor();
		let tmpContent = (tmpEd && typeof tmpEd.getAllContent === 'function') ? tmpEd.getAllContent('\n\n') : '';
		tmpAPI.updateNote(tmpD.SelectedNoteID, { Title: tmpD.DraftTitle || '', Content: tmpContent })
			.then(() => this.show()).catch(() => {});
	}

	deleteNote(pID)
	{
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		let tmpSelf = this;
		tmpAPI.deleteNote(pID).then(() =>
		{
			let tmpD = tmpSelf._page();
			if (tmpD.SelectedNoteID === pID)
			{
				tmpD.SelectedNoteID = 0;
				tmpD.DraftTitle = null;
				if (tmpSelf.pict.AppData.NotesPageEditor) { tmpSelf.pict.AppData.NotesPageEditor.Segments = []; }
				tmpSelf._editorMountedNoteID = 0;
				// Deleting the open note leaves the list route (so the URL no longer points at a gone note).
				let tmpApp = tmpSelf.pict.PictApplication;
				if (tmpApp && typeof tmpApp.showNotes === 'function') { tmpApp.showNotes(); return; }
			}
			tmpSelf.show();
		}).catch(() => {});
	}
}

module.exports = PictViewNotesPage;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-NotesPage',
	DefaultRenderable: 'Plansheet-NotesPage',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-notespage.ps-page { color: var(--theme-color-text-primary, #1d2230); }
		.ps-notespage-head { display: flex; align-items: center; gap: 12px; margin: 0 0 18px; }
		.ps-notespage-head h2 { font-size: 22px; font-weight: 600; margin: 0; color: var(--theme-color-text-primary, #1f2430); }
		.ps-notespage-body { display: flex; gap: 20px; align-items: flex-start; }
		.ps-notespage-list-col { flex: 0 0 280px; max-width: 280px; display: flex; flex-direction: column; gap: 8px; }
		.ps-notespage-editor-col { flex: 1 1 auto; min-width: 0; }
		.ps-notespage-new { width: 100%; padding: 8px 10px; font-size: 13px; cursor: pointer;
			border: 1px dashed var(--theme-color-border-default, #c9d0db); border-radius: 8px;
			background: transparent; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-notespage-new:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-primary, #2c3140); }
		.ps-notespage-notelist { display: flex; flex-direction: column; gap: 2px; }
		.ps-notespage-noterow { text-align: left; padding: 8px 10px; font-size: 14px; border: none; border-radius: 7px;
			background: transparent; color: var(--theme-color-text-primary, #2c3140); cursor: pointer; width: 100%;
			white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-notespage-noterow:hover { background: var(--theme-color-background-hover, #eef1f6); }
		.ps-notespage-noterow.is-active { background: var(--theme-color-background-hover, #e7edf8); font-weight: 600; }
		.ps-notespage-empty { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 13px; margin: 6px 2px; }
		.ps-notespage-editor { display: flex; flex-direction: column; gap: 8px; }
		.ps-notespage-noteTitle { padding: 8px 10px; font-size: 15px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 7px; }
		.ps-notespage-mde { border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 7px; overflow: hidden;
			background: var(--theme-color-background-panel, #fff); }
		.ps-notespage-mde .cm-editor { min-height: 360px; }
		.ps-notespage-mde .cm-content { min-height: 360px; }
		.ps-notespage-editor-actions { display: flex; gap: 8px; }
		.ps-notespage-save { flex: 0 0 auto; padding: 8px 16px; font-size: 14px; cursor: pointer; border: none; border-radius: 7px;
			background: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-text-on-brand, #fff); }
		.ps-notespage-del { padding: 8px 14px; font-size: 14px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 7px; background: transparent; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-notespage-hint { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 14px; padding: 40px 4px; text-align: center; }
		/* On narrow / phone width, stack the columns and let the editor use the full width. */
		@media (max-width: 860px)
		{
			.ps-notespage-body { flex-direction: column; }
			.ps-notespage-list-col { flex: 1 1 auto; max-width: none; width: 100%; }
			.ps-notespage-editor-col { width: 100%; }
			.ps-notespage-mde, .ps-notespage-editor { width: 100%; }
		}
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-NotesPage',
			Template: /*html*/`
<div class="ps-page ps-notespage">
	<div class="ps-notespage-head">
		<h2>Notes</h2>
	</div>
	<div class="ps-notespage-body">
		<div class="ps-notespage-list-col">
			<button class="ps-notespage-new" onclick="_Pict.views['Plansheet-NotesPage'].newNote()">+ New note</button>
			{~TS:NotesPage-Empty:AppData.NotesPage.NotesEmpty~}
			<div class="ps-notespage-notelist">{~TS:NotesPage-NoteRow:AppData.NotesPage.NoteRows~}</div>
		</div>
		<div class="ps-notespage-editor-col">
			{~TS:NotesPage-Editor:AppData.NotesPage.EditorSlot~}
			{~TS:NotesPage-NoSelection:AppData.NotesPage.NoSelectionSlot~}
		</div>
	</div>
</div>`
		},
		{
			Hash: 'NotesPage-Empty',
			Template: /*html*/`<p class="ps-notespage-empty">No notes yet. Jot down anything you want to keep.</p>`
		},
		{
			Hash: 'NotesPage-NoteRow',
			Template: /*html*/`<button class="ps-notespage-noterow{~NE:Record.Active^ is-active~}" onclick="_Pict.views['Plansheet-NotesPage'].selectNote({~D:Record.IDNote~})">{~D:Record.Title~}</button>`
		},
		{
			Hash: 'NotesPage-Editor',
			Template: /*html*/`
<div class="ps-notespage-editor">
	<input class="ps-notespage-noteTitle" value="{~D:Record.Title~}" placeholder="Title" oninput="_Pict.views['Plansheet-NotesPage'].onDraftTitle(this.value)" />
	<div class="ps-notespage-mde" id="PS-NotesPage-MDE"></div>
	<div class="ps-notespage-editor-actions">
		<button class="ps-notespage-save" onclick="_Pict.views['Plansheet-NotesPage'].saveNote()">Save</button>
		<button class="ps-notespage-del" onclick="_Pict.views['Plansheet-NotesPage'].deleteNote({~D:Record.IDNote~})">Delete</button>
	</div>
</div>`
		},
		{
			Hash: 'NotesPage-NoSelection',
			Template: /*html*/`<div class="ps-notespage-hint">Select a note on the left, or start a new one.</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-NotesPage',
			TemplateHash: 'Plansheet-NotesPage',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"pict-view":365}],683:[function(require,module,exports){
'use strict';

/**
 * NotesPageEditor -- the rich markdown editor (pict-section-markdowneditor) hosted in the full-page
 * Notes view (the same editor as the Docs Lake and the entity-form description field). It is the
 * page-sized twin of PictView-NotebookNoteEditor: identical wiring, just pointed at the NotesPage
 * host + its DOM host + its own segment buffer so the two never collide.
 *
 * It mounts into #PS-NotesPage-MDE, bound to AppData.NotesPageEditor.Segments. The host
 * (PictView-NotesPage) seeds the selected note's content into that segment array, re-mounts the
 * editor after each panel render (PictView-DocEditor pattern: destroy -> render -> marshalToView),
 * and reads the edited markdown back with getAllContent('\n\n') when the user clicks Save.
 *
 * onImageUpload is overridden so a pasted / dragged / picked image is stored in Parime owned by the
 * note (OwnerType 'Note', IDOwner = the note's id) instead of inlined as a base64 data URI.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-NotesPage-Editor';
	tmpConfig.DefaultDestinationAddress = '#PS-NotesPage-MDE';
	tmpConfig.TargetElementAddress = '#PS-NotesPage-MDE';
	tmpConfig.ContentDataAddress = 'AppData.NotesPageEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'off';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#PS-NotesPage-MDE';
		}
	}

	return tmpConfig;
}

class PictViewNotesPageEditor extends libMarkdownEditor
{
	_host() { return this.pict.views['Plansheet-NotesPage']; }

	_ownerContext()
	{
		let tmpHost = this._host();
		return (tmpHost && typeof tmpHost.noteImageOwnerContext === 'function') ? tmpHost.noteImageOwnerContext() : { OwnerType: 'Note', IDOwner: 0 };
	}

	/**
	 * Pasted / dragged / picked image -> upload to Parime owned by the open note, and insert the blob
	 * URL. Returning true = async handling; returning false falls back to the base64 embed (only if the
	 * note has no id yet, which should not happen since the editor only opens on a saved note).
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		let tmpOwner = this._ownerContext();
		if (!tmpOwner.IDOwner || !this.pict.providers.MediaAPI) { return false; }
		// Private: true -> owned by this user (Media.IDUser), so a note's images are as private as the
		// note. They also surface in the caller's personal Gallery (the personal "user gallery").
		this.pict.providers.MediaAPI.upload(tmpOwner.OwnerType, tmpOwner.IDOwner, pFile, { Private: true })
			.then((pRow) => fCallback(null, this.pict.providers.MediaAPI.blobURL(pRow.IDMedia)))
			.catch((pErr) => fCallback(pErr.message || String(pErr)));
		return true;
	}
}

module.exports = PictViewNotesPageEditor;
module.exports.default_configuration = buildConfiguration();

},{"pict-section-markdowneditor":261}],684:[function(require,module,exports){
'use strict';

/**
 * Ops Console -- the platform-admin observability screen. One read (GET /1.0/Admin/Ops via
 * providers.OpsAPI) backs the whole page: grouped errors, who is active now, a recent activity
 * feed, and recent deploys. Template-driven per the Pict conventions (onBeforeRender derives the
 * render slots into AppData; templates iterate them; actions mutate AppData + render). No innerHTML.
 * See design/Observability-Plan.md.
 */

const libPictView = require('pict-view');

class PictViewOpsConsole extends libPictView
{
	_data() { return this.pict.AppData.Ops || {}; }
	_api() { return this.pict.providers.OpsAPI; }

	_ms(pValue)
	{
		if (!pValue) { return 0; }
		let tmpString = String(pValue);
		let tmpParsed = Date.parse(tmpString);
		if (!isNaN(tmpParsed)) { return tmpParsed; }
		tmpParsed = Date.parse(tmpString.replace(' ', 'T') + 'Z');
		return isNaN(tmpParsed) ? 0 : tmpParsed;
	}

	_ago(pValue)
	{
		let tmpMs = this._ms(pValue);
		if (!tmpMs) { return ''; }
		let tmpSeconds = Math.floor((Date.now() - tmpMs) / 1000);
		if (tmpSeconds < 0) { tmpSeconds = 0; }
		if (tmpSeconds < 60) { return tmpSeconds + 's ago'; }
		let tmpMinutes = Math.floor(tmpSeconds / 60);
		if (tmpMinutes < 60) { return tmpMinutes + 'm ago'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		if (tmpHours < 24) { return tmpHours + 'h ago'; }
		return Math.floor(tmpHours / 24) + 'd ago';
	}

	onBeforeRender(pRenderable)
	{
		let tmpD = this._data();
		let tmpSummary = tmpD.Summary || {};

		tmpD.SummaryCards =
		[
			{ Label: 'Active now', Value: (tmpSummary.ActiveUsers != null) ? tmpSummary.ActiveUsers : 0, Note: 'last ' + (tmpSummary.ActiveWindowMinutes || 10) + ' min' },
			{ Label: 'Error groups', Value: (tmpSummary.ErrorGroups != null) ? tmpSummary.ErrorGroups : 0, Note: 'distinct' },
			{ Label: 'Errors scanned', Value: (tmpSummary.ErrorsScanned != null) ? tmpSummary.ErrorsScanned : 0, Note: 'recent window' }
		];

		tmpD.ErrorRows = (tmpD.Errors || []).map((pRow) => (
		{
			Count: pRow.Count || 1,
			ErrorType: pRow.ErrorType || 'Error',
			Message: String(pRow.Message || '').slice(0, 200),
			Route: pRow.Route || '',
			Method: pRow.Method || '',
			StatusCode: pRow.StatusCode || '',
			Ago: this._ago(pRow.LastSeen)
		}));
		tmpD.ErrorsEmpty = (tmpD.ErrorRows.length) ? [] : [1];

		tmpD.ActiveRows = (tmpD.ActiveUsers || []).map((pRow) => (
		{
			User: pRow.User || ('User ' + pRow.IDUser),
			Ago: this._ago(pRow.LastSeen)
		}));
		tmpD.ActiveEmpty = (tmpD.ActiveRows.length) ? [] : [1];

		tmpD.ActivityRows = (tmpD.Activity || []).map((pRow) => (
		{
			User: pRow.User || ('User ' + pRow.IDUser),
			Summary: (pRow.Action || 'did') + ' ' + (pRow.TargetType || '') + (pRow.IDTarget ? (' #' + pRow.IDTarget) : ''),
			Ago: this._ago(pRow.CreateDate)
		}));
		tmpD.ActivityEmpty = (tmpD.ActivityRows.length) ? [] : [1];

		tmpD.DeployRows = (tmpD.Deploys || []).map((pRow) => (
		{
			CommitHash: String(pRow.CommitHash || '').slice(0, 10),
			DeployedBy: pRow.DeployedBy || '',
			Result: pRow.Result || '',
			Environment: pRow.Environment || '',
			Ago: this._ago(pRow.CreateDate)
		}));
		tmpD.DeploysEmpty = (tmpD.DeployRows.length) ? [] : [1];

		tmpD.LoadErrorSlot = tmpD.LoadError ? [{ Message: tmpD.LoadError }] : [];

		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// Entry point from the router: load then paint.
	show() { return this.refresh(); }

	refresh()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.loadOps !== 'function') { this.render(); return Promise.resolve(); }
		return tmpAPI.loadOps().then(() => this.render());
	}
}

module.exports = PictViewOpsConsole;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-OpsConsole',
	DefaultRenderable: 'Plansheet-OpsConsole',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-ops { padding: 20px 24px 60px; max-width: 1100px; }
		.ps-ops-head { display: flex; align-items: center; gap: 14px; margin-bottom: 16px; }
		.ps-ops-head h1 { font-size: 22px; font-weight: 600; margin: 0; flex: 1; color: var(--theme-color-text-primary, #2c3140); }
		.ps-ops-refresh { padding: 7px 14px; font-size: 13px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-ops-refresh:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-ops-err { background: var(--theme-color-status-error, #cc3333); color: #fff; padding: 8px 12px; border-radius: 8px; margin-bottom: 14px; font-size: 13px; }
		.ps-ops-cards { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 22px; }
		.ps-ops-card { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e7ecf0);
			border-radius: 12px; padding: 14px 16px; }
		.ps-ops-card-value { font-size: 28px; font-weight: 700; color: var(--theme-color-text-primary, #2c3140); line-height: 1.1; }
		.ps-ops-card-label { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin-top: 2px; }
		.ps-ops-card-note { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); margin-top: 1px; }
		.ps-ops-section { margin-bottom: 26px; }
		.ps-ops-section-title { font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;
			color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 8px; }
		.ps-ops-empty { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 13px; padding: 8px 2px; }
		.ps-ops-errrow { display: flex; gap: 12px; align-items: baseline; padding: 9px 12px; border: 1px solid var(--theme-color-border-light, #e7ecf0);
			border-left: 3px solid var(--theme-color-status-error, #cc3333); border-radius: 8px; margin-bottom: 7px; background: var(--theme-color-background-panel, #fff); }
		.ps-ops-count { flex: 0 0 auto; min-width: 30px; text-align: center; font-weight: 700; font-size: 13px; color: var(--theme-color-status-error, #cc3333);
			background: color-mix(in srgb, var(--theme-color-status-error, #cc3333) 12%, transparent); border-radius: 6px; padding: 2px 6px; }
		.ps-ops-errbody { flex: 1; min-width: 0; }
		.ps-ops-errtype { font-weight: 600; font-size: 13px; color: var(--theme-color-text-primary, #2c3140); }
		.ps-ops-errmsg { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-ops-errmeta { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-ops-when { flex: 0 0 auto; font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); }
		.ps-ops-row { display: flex; gap: 10px; align-items: baseline; padding: 6px 10px; border-radius: 6px; font-size: 13px; }
		.ps-ops-row:hover { background: var(--theme-color-background-hover, #eef1f6); }
		.ps-ops-row-user { font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
		.ps-ops-row-what { flex: 1; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-ops-dot { flex: 0 0 auto; width: 8px; height: 8px; border-radius: 50%; background: var(--theme-color-status-success, #3fae5a); align-self: center; }
		.ps-ops-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 22px; }
		@media (max-width: 820px) { .ps-ops-cards { grid-template-columns: 1fr; } .ps-ops-cols { grid-template-columns: 1fr; } }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-OpsConsole',
			Template: /*html*/`
<div class="ps-ops">
	<div class="ps-ops-head">
		<h1>Ops Console</h1>
		<button class="ps-ops-refresh" onclick="{~P~}.views['Plansheet-OpsConsole'].refresh()">Refresh</button>
	</div>
	{~TS:Ops-LoadError:AppData.Ops.LoadErrorSlot~}
	<div class="ps-ops-cards">{~TS:Ops-Card:AppData.Ops.SummaryCards~}</div>

	<div class="ps-ops-section">
		<p class="ps-ops-section-title">Errors (grouped)</p>
		{~TS:Ops-ErrorsEmpty:AppData.Ops.ErrorsEmpty~}
		{~TS:Ops-ErrorRow:AppData.Ops.ErrorRows~}
	</div>

	<div class="ps-ops-cols">
		<div class="ps-ops-section">
			<p class="ps-ops-section-title">Active now</p>
			{~TS:Ops-ActiveEmpty:AppData.Ops.ActiveEmpty~}
			{~TS:Ops-ActiveRow:AppData.Ops.ActiveRows~}
		</div>
		<div class="ps-ops-section">
			<p class="ps-ops-section-title">Recent deploys</p>
			{~TS:Ops-DeploysEmpty:AppData.Ops.DeploysEmpty~}
			{~TS:Ops-DeployRow:AppData.Ops.DeployRows~}
		</div>
	</div>

	<div class="ps-ops-section">
		<p class="ps-ops-section-title">Recent activity</p>
		{~TS:Ops-ActivityEmpty:AppData.Ops.ActivityEmpty~}
		{~TS:Ops-ActivityRow:AppData.Ops.ActivityRows~}
	</div>
</div>`
		},
		{ Hash: 'Ops-LoadError', Template: /*html*/`<div class="ps-ops-err">Could not load the ops console: {~D:Record.Message~}</div>` },
		{ Hash: 'Ops-Card', Template: /*html*/`<div class="ps-ops-card"><div class="ps-ops-card-value">{~D:Record.Value~}</div><div class="ps-ops-card-label">{~D:Record.Label~}</div><div class="ps-ops-card-note">{~D:Record.Note~}</div></div>` },
		{ Hash: 'Ops-ErrorsEmpty', Template: /*html*/`<p class="ps-ops-empty">No errors recorded. (5xx server errors land here, grouped by where they happened.)</p>` },
		{
			Hash: 'Ops-ErrorRow',
			Template: /*html*/`<div class="ps-ops-errrow"><span class="ps-ops-count">{~D:Record.Count~}</span><div class="ps-ops-errbody"><div class="ps-ops-errtype">{~D:Record.ErrorType~}</div><div class="ps-ops-errmsg">{~D:Record.Message~}</div><div class="ps-ops-errmeta">{~D:Record.Method~} {~D:Record.Route~} &middot; {~D:Record.StatusCode~}</div></div><span class="ps-ops-when">{~D:Record.Ago~}</span></div>`
		},
		{ Hash: 'Ops-ActiveEmpty', Template: /*html*/`<p class="ps-ops-empty">No one active in the window.</p>` },
		{ Hash: 'Ops-ActiveRow', Template: /*html*/`<div class="ps-ops-row"><span class="ps-ops-dot"></span><span class="ps-ops-row-user">{~D:Record.User~}</span><span class="ps-ops-row-what"></span><span class="ps-ops-when">{~D:Record.Ago~}</span></div>` },
		{ Hash: 'Ops-DeploysEmpty', Template: /*html*/`<p class="ps-ops-empty">No deploys recorded yet.</p>` },
		{ Hash: 'Ops-DeployRow', Template: /*html*/`<div class="ps-ops-row"><span class="ps-ops-row-user">{~D:Record.CommitHash~}</span><span class="ps-ops-row-what">{~D:Record.Result~} {~D:Record.Environment~} &middot; {~D:Record.DeployedBy~}</span><span class="ps-ops-when">{~D:Record.Ago~}</span></div>` },
		{ Hash: 'Ops-ActivityEmpty', Template: /*html*/`<p class="ps-ops-empty">No activity recorded yet.</p>` },
		{ Hash: 'Ops-ActivityRow', Template: /*html*/`<div class="ps-ops-row"><span class="ps-ops-row-user">{~D:Record.User~}</span><span class="ps-ops-row-what">{~D:Record.Summary~}</span><span class="ps-ops-when">{~D:Record.Ago~}</span></div>` }
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-OpsConsole',
			TemplateHash: 'Plansheet-OpsConsole',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"pict-view":365}],685:[function(require,module,exports){
'use strict';

/**
 * Org Activity -- an org admin's view of their own tenant's user activity (GET /1.0/Org/Activity
 * via providers.OpsAPI, tenant-scoped + server-gated to org admins). A simple reverse-chronological
 * feed. Template-driven per the Pict conventions; no innerHTML. See design/Observability-Plan.md.
 */

const libPictView = require('pict-view');

class PictViewOrgActivity extends libPictView
{
	_data() { return this.pict.AppData.OrgActivity || {}; }
	_api() { return this.pict.providers.OpsAPI; }

	_ms(pValue)
	{
		if (!pValue) { return 0; }
		let tmpString = String(pValue);
		let tmpParsed = Date.parse(tmpString);
		if (!isNaN(tmpParsed)) { return tmpParsed; }
		tmpParsed = Date.parse(tmpString.replace(' ', 'T') + 'Z');
		return isNaN(tmpParsed) ? 0 : tmpParsed;
	}

	_ago(pValue)
	{
		let tmpMs = this._ms(pValue);
		if (!tmpMs) { return ''; }
		let tmpSeconds = Math.max(0, Math.floor((Date.now() - tmpMs) / 1000));
		if (tmpSeconds < 60) { return tmpSeconds + 's ago'; }
		let tmpMinutes = Math.floor(tmpSeconds / 60);
		if (tmpMinutes < 60) { return tmpMinutes + 'm ago'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		if (tmpHours < 24) { return tmpHours + 'h ago'; }
		return Math.floor(tmpHours / 24) + 'd ago';
	}

	onBeforeRender(pRenderable)
	{
		let tmpD = this._data();
		tmpD.Rows = (tmpD.Rows || []).map((pRow) => (
		{
			User: pRow.User || ('User ' + pRow.IDUser),
			Summary: (pRow.Action || 'did') + ' ' + (pRow.TargetType || '') + (pRow.IDTarget ? (' #' + pRow.IDTarget) : ''),
			Ago: this._ago(pRow.CreateDate),
			When: pRow.CreateDate || ''
		}));
		tmpD.RowsEmpty = (tmpD.Rows.length) ? [] : [1];
		tmpD.LoadErrorSlot = tmpD.LoadError ? [{ Message: tmpD.LoadError }] : [];
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	show() { return this.refresh(); }

	refresh()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.loadOrgActivity !== 'function') { this.render(); return Promise.resolve(); }
		return tmpAPI.loadOrgActivity({ count: 150 }).then(() => this.render());
	}
}

module.exports = PictViewOrgActivity;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-OrgActivity',
	DefaultRenderable: 'Plansheet-OrgActivity',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-act { padding: 20px 24px 60px; max-width: 880px; }
		.ps-act-head { display: flex; align-items: center; gap: 14px; margin-bottom: 6px; }
		.ps-act-head h1 { font-size: 22px; font-weight: 600; margin: 0; flex: 1; color: var(--theme-color-text-primary, #2c3140); }
		.ps-act-refresh { padding: 7px 14px; font-size: 13px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-act-refresh:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-act-sub { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 16px; }
		.ps-act-err { background: var(--theme-color-status-error, #cc3333); color: #fff; padding: 8px 12px; border-radius: 8px; margin-bottom: 14px; font-size: 13px; }
		.ps-act-empty { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 13px; padding: 10px 2px; }
		.ps-act-row { display: flex; gap: 10px; align-items: baseline; padding: 8px 10px; border-radius: 6px; font-size: 13px;
			border-bottom: 1px solid var(--theme-color-border-light, #eef1f6); }
		.ps-act-row:hover { background: var(--theme-color-background-hover, #eef1f6); }
		.ps-act-user { font-weight: 600; color: var(--theme-color-text-primary, #2c3140); min-width: 120px; }
		.ps-act-what { flex: 1; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-act-when { flex: 0 0 auto; font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-OrgActivity',
			Template: /*html*/`
<div class="ps-act">
	<div class="ps-act-head">
		<h1>Activity</h1>
		<button class="ps-act-refresh" onclick="{~P~}.views['Plansheet-OrgActivity'].refresh()">Refresh</button>
	</div>
	<p class="ps-act-sub">What your team has been doing, most recent first.</p>
	{~TS:OrgAct-LoadError:AppData.OrgActivity.LoadErrorSlot~}
	{~TS:OrgAct-Empty:AppData.OrgActivity.RowsEmpty~}
	{~TS:OrgAct-Row:AppData.OrgActivity.Rows~}
</div>`
		},
		{ Hash: 'OrgAct-LoadError', Template: /*html*/`<div class="ps-act-err">Could not load activity: {~D:Record.Message~}</div>` },
		{ Hash: 'OrgAct-Empty', Template: /*html*/`<p class="ps-act-empty">No activity recorded yet.</p>` },
		{ Hash: 'OrgAct-Row', Template: /*html*/`<div class="ps-act-row"><span class="ps-act-user">{~D:Record.User~}</span><span class="ps-act-what">{~D:Record.Summary~}</span><span class="ps-act-when" title="{~D:Record.When~}">{~D:Record.Ago~}</span></div>` }
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-OrgActivity',
			TemplateHash: 'Plansheet-OrgActivity',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"pict-view":365}],686:[function(require,module,exports){
'use strict';

/**
 * Profile -- a user's personal page: a moodboard banner up top, a stack of open-ended content blocks
 * (text, image, embed) below it, and their rendered About. Your own page edits in place (the board is
 * a live moodboard editor, blocks have add / reorder / delete / edit affordances); a teammate's page
 * is read-only.
 *
 * The record to show is at AppData.ProfileView.Record (self from UserAPI.getMe; a teammate from
 * TeamAPI.getMember). The board is a Moodboard row owned by the user (MoodboardAPI personal board);
 * the blocks are ProfileBlock rows (ProfileBlockAPI). Two registered moodboard views back the banner:
 * Profile-Board-Edit (editable, autosaving) for self and Profile-Board-View (read-only) for teammates.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libAvatarHelper = require('./AvatarHelper.js');
const libMarkdownRender = require('./MarkdownRender.js');

const _BOARD_EDIT = 'Profile-Board-Edit';
const _BOARD_VIEW = 'Profile-Board-View';
const _AUTOSAVE_MS = 800;

function _escapeHTML(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// Turn a watch/share URL into an embeddable one for the common video hosts; otherwise return null so
// the block falls back to a plain link card (we never drop an arbitrary URL into an iframe).
function _embedURL(pURL)
{
	let tmpURL = String(pURL || '').trim();
	if (!/^https:\/\//i.test(tmpURL)) { return null; }
	let tmpYouTube = tmpURL.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
	if (tmpYouTube) { return 'https://www.youtube.com/embed/' + tmpYouTube[1]; }
	let tmpVimeo = tmpURL.match(/vimeo\.com\/(\d+)/);
	if (tmpVimeo) { return 'https://player.vimeo.com/video/' + tmpVimeo[1]; }
	return null;
}

class PictViewProfile extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.ProfileView = this.pict.AppData.ProfileView || { Record: null, Blocks: [], BoardID: null };
		this._SaveTimer = null;
	}

	_state() { return this.pict.AppData.ProfileView; }

	_record()
	{
		let tmpRecord = this._state() && this._state().Record;
		if (tmpRecord) { return tmpRecord; }
		return (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
	}

	_isSelf(pRecord)
	{
		let tmpMe = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		let tmpRec = pRecord || this._record();
		return !!(tmpMe.IDUser && tmpRec.IDUser && tmpMe.IDUser === tmpRec.IDUser);
	}

	// ── entry point: render the page, then load the board + blocks ───────────

	show()
	{
		// A nav token: each show() is a fresh page load, so async board/block fetches from an earlier
		// navigation are ignored when they land (the two board views share one container, so a stale
		// load must not render the wrong one).
		this._NavToken = (this._NavToken || 0) + 1;
		this.render();
		this._loadBoard(this._NavToken);
		this._loadBlocks(this._NavToken);
	}

	_loadBoard(pToken)
	{
		let tmpRecord = this._record();
		let tmpAPI = this.pict.providers.MoodboardAPI;
		if (!tmpAPI || !tmpRecord.IDUser) { return; }
		// Clear the banner up front: two board views (Edit/View) share #Profile-Board, so a render left
		// by a previous navigation must not linger if this load is superseded or chooses the other view.
		if (typeof document !== 'undefined') { let tmpHost = document.getElementById('Profile-Board'); if (tmpHost) { tmpHost.innerHTML = ''; } }

		let tmpSelf = this._isSelf(tmpRecord);
		let tmpPromise = tmpSelf ? tmpAPI.getOrCreatePersonal(tmpRecord.IDUser) : tmpAPI.listForUser(tmpRecord.IDUser).then((pRows) => (pRows && pRows[0]) || null);
		tmpPromise.then((pBoardRow) =>
		{
			if (pToken && pToken !== this._NavToken) { return; }
			// Recompute self at render time (the record may have settled after this load was kicked off).
			let tmpSelf = this._isSelf();
			this._state().BoardID = (pBoardRow && pBoardRow.IDMoodboard) ? pBoardRow.IDMoodboard : null;
			let tmpBoard = pBoardRow ? tmpAPI.loadBoard(pBoardRow) : { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } };
			this._state().Board = tmpBoard;
			this._state().BoardEditing = false;
			let tmpHasNodes = !!(tmpBoard && tmpBoard.Nodes && tmpBoard.Nodes.length);
			this._presentBoard(tmpBoard, tmpHasNodes, tmpSelf, pToken);
		});
	}

	// Decide how the board banner shows: a teammate's empty board is hidden (no big empty block); your
	// own empty board shows a slim "decorate" prompt; a board with cards renders normally.
	_presentBoard(pBoard, pHasNodes, pSelf, pToken)
	{
		if (typeof document === 'undefined') { return; }
		let tmpBanner = document.getElementById('Profile-Board');
		let tmpPrompt = document.getElementById('Profile-Board-Empty');
		// An undecorated teammate board: hide the whole banner (the header is its own section, so nothing
		// to adjust -- it just sits at the top).
		if (!pHasNodes && !pSelf)
		{
			if (tmpBanner) { tmpBanner.style.display = 'none'; }
			if (tmpPrompt) { tmpPrompt.style.display = 'none'; }
			return;
		}
		// Your own empty board: a slim "decorate" prompt (which drops you into edit).
		if (!pHasNodes && pSelf)
		{
			if (tmpBanner) { tmpBanner.style.display = 'none'; }
			if (tmpPrompt) { tmpPrompt.style.display = 'flex'; }
			return;
		}
		// A board with content shows read-only for everyone (the way teammates see it), in its saved display
		// style. On your own board an "Edit board" button sits next to "Edit profile" (see _renderActions);
		// a teammate's does not.
		if (tmpPrompt) { tmpPrompt.style.display = 'none'; }
		if (tmpBanner) { tmpBanner.style.display = ''; }
		this._mountBoard(this.pict.views[_BOARD_VIEW], pBoard, pToken);
	}

	// Flip the banner between read-only (the saved display style) and editing (the free canvas), driven by
	// the "Edit board" / "Done" button next to "Edit profile". Editing happens inline on the editable
	// instance; the moodboard's own toolbar carries the style toggle + set-view-area while editing.
	toggleBoardEdit()
	{
		if (!this._isSelf()) { return; }
		if (this._state().BoardEditing) { this._exitBoardEdit(); } else { this._enterBoardEdit(); }
	}

	// Update the "Edit board" / "Done" label to match the current board mode.
	_updateEditBoardButton()
	{
		let tmpButton = (typeof document !== 'undefined') ? document.getElementById('Profile-Edit-Board') : null;
		if (tmpButton) { tmpButton.textContent = this._state().BoardEditing ? 'Done' : 'Edit board'; }
	}

	// Mount a board into #Profile-Board. The moodboard flow needs a SECOND render pass on a cold mount
	// before its cards paint (the first pass only stands up the node-view machinery -- this is why a
	// board was blank the first visit and fine the second). Render, render again a couple of frames
	// later, then set the board, re-checking the nav token at each step.
	_mountBoard(pBoardView, pBoard, pToken)
	{
		let tmpSelf = this;
		this._ProfileBoardViewName = pBoardView.options.ViewIdentifier;
		pBoardView.render();
		this._afterFrames(2, function ()
		{
			if (pToken && pToken !== tmpSelf._NavToken) { return; }
			pBoardView.render();
			tmpSelf._afterFrames(2, function ()
			{
				if (pToken && pToken !== tmpSelf._NavToken) { return; }
				pBoardView.setBoard(pBoard);
			});
		});
	}

	// ── board display style (canvas / jumbotron / background) ────────────────────
	// The display-style toggle + set-view-area live in the moodboard's own edit toolbar; the board color +
	// backdrop margin in its gear (no host chrome). The host's only job is to lay out the board for the
	// current presentation, which the moodboard reports via onDisplayStyleChanged: a jumbotron is a hero
	// band (its scaled frame height) above the content; a background becomes a full-bleed layer BEHIND the
	// whole profile column (the head / blocks / About render on top); the canvas is the normal banner.
	onBoardDisplayStyleChanged(pInfo)
	{
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById('Profile-Board') : null;
		if (!tmpEl || !pInfo) { return; }
		let tmpProfile = (typeof tmpEl.closest === 'function') ? tmpEl.closest('.cst-profile') : null;
		let tmpInner = tmpProfile ? tmpProfile.querySelector('.cst-profile-inner') : null;
		tmpEl.classList.remove('cst-board-jumbotron', 'cst-board-background');
		tmpEl.style.background = '';
		if (tmpInner) { tmpInner.style.marginTop = ''; }
		if (tmpProfile) { tmpProfile.classList.remove('cst-profile-backdrop'); }
		if (pInfo.effectiveStyle === 'jumbotron')
		{
			// A hero band; its height is the moodboard's reported jumbotronHeight (the gear "Band height"
			// override, else the scaled view-area frame height), clamped to a sane banner range.
			tmpEl.classList.add('cst-board-jumbotron');
			let tmpHeight = pInfo.jumbotronHeight;
			tmpEl.style.height = (tmpHeight > 0 ? Math.max(80, Math.min(1000, tmpHeight)) : 240) + 'px';
		}
		else if (pInfo.effectiveStyle === 'background')
		{
			// Backdrop: the board is a full-bleed layer behind the content (cst-profile-backdrop CSS), no
			// fixed band height -- it spans the column. The gear margin is WHERE THE OVERLAYING CONTENT
			// STARTS, so push the content down by it (the board art shows in the band above). Paint the
			// resolved board color on the board element here (the backdrop CSS makes the flow containers
			// transparent over it) because the flow's own SVG fill does not composite reliably as an
			// absolute full-bleed layer.
			tmpEl.classList.add('cst-board-background');
			tmpEl.style.height = '';
			tmpEl.style.background = pInfo.backgroundColor || '';
			if (tmpInner) { tmpInner.style.marginTop = (pInfo.topMargin > 0 ? pInfo.topMargin : 0) + 'px'; }
			if (tmpProfile) { tmpProfile.classList.add('cst-profile-backdrop'); }
		}
		else
		{
			tmpEl.style.height = '';
		}
	}

	// The "decorate your board" prompt button (your own empty board): reveal the editable board so you
	// can start adding cards.
	startDecorating()
	{
		if (!this._isSelf() || typeof document === 'undefined') { return; }
		let tmpPrompt = document.getElementById('Profile-Board-Empty');
		let tmpBanner = document.getElementById('Profile-Board');
		if (tmpPrompt) { tmpPrompt.style.display = 'none'; }
		if (tmpBanner) { tmpBanner.style.display = ''; tmpBanner.innerHTML = ''; }
		let tmpEmpty = { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } };
		this._state().Board = tmpEmpty;
		this._state().BoardEditing = true;
		let tmpView = this.pict.views[_BOARD_EDIT];
		if (!tmpView) { return; }
		this._mountBoard(tmpView, tmpEmpty, this._NavToken);
		this._updateEditBoardButton();
	}

	// Entered from the "Edit board" button (next to Edit profile) or a card double-click. Mounts the
	// editable board inline (the moodboard's own toolbar carries the editing controls); the board's own
	// fullscreen button is there if you want more room.
	_enterBoardEdit()
	{
		if (!this._isSelf()) { return; }
		// Show the banner and hide the empty "decorate" prompt -- you are decorating now. Entering edit from
		// the "Edit board" button (rather than the prompt's own "Decorate" button, which already hides it)
		// must clear the prompt too, or it sits under the editable canvas and lingers after you add a card.
		if (typeof document !== 'undefined')
		{
			let tmpBanner = document.getElementById('Profile-Board'); if (tmpBanner) { tmpBanner.style.display = ''; tmpBanner.innerHTML = ''; }
			let tmpPrompt = document.getElementById('Profile-Board-Empty'); if (tmpPrompt) { tmpPrompt.style.display = 'none'; }
		}
		this._state().BoardEditing = true;
		this._mountBoard(this.pict.views[_BOARD_EDIT], this._state().Board || { Nodes: [], Connections: [], ViewState: { PanX: 0, PanY: 0, Zoom: 1 } }, this._NavToken);
		this._updateEditBoardButton();
	}

	// A double-click on a card of your own (read-only) board: drop into edit and open that card's panel,
	// so you can edit a card without first toggling edit mode. Polls until the edit board has the node.
	activateCard(pNodeHash)
	{
		if (!this._isSelf() || !pNodeHash) { return; }
		if (!this._state().BoardEditing) { this._enterBoardEdit(); }
		let tmpEdit = this.pict.views[_BOARD_EDIT];
		let tmpTries = 0;
		let fOpen = function ()
		{
			let tmpFlow = tmpEdit && tmpEdit._FlowView;
			if (tmpFlow && tmpFlow.initialRenderComplete && typeof tmpFlow.getNode === 'function' && tmpFlow.getNode(pNodeHash) && typeof tmpFlow.openPanel === 'function')
			{
				tmpFlow.openPanel(pNodeHash);
				return;
			}
			if (++tmpTries < 80 && typeof requestAnimationFrame === 'function') { requestAnimationFrame(fOpen); }
		};
		if (typeof requestAnimationFrame === 'function') { requestAnimationFrame(fOpen); } else { setTimeout(fOpen, 300); }
	}

	// "Done": capture the edited board and return to the read-only banner (in the saved display style).
	_exitBoardEdit()
	{
		// Re-entry guard: run the teardown once even if "Done" is pressed twice in quick succession.
		if (this._state().ExitingEdit) { return; }
		this._state().ExitingEdit = true;
		let tmpEdit = this.pict.views[_BOARD_EDIT];
		// Leave the flow's full screen if the editor was expanded (no-op otherwise).
		if (tmpEdit && tmpEdit._FlowView && typeof tmpEdit._FlowView.exitFullscreen === 'function') { tmpEdit._FlowView.exitFullscreen(); }
		// Capture the just-edited board so the read-only view shows the latest -- but guard the fast
		// Edit -> Done race: if the editor has not finished loading and reads back FEWER cards than we
		// opened with, keep the board we already have. Capturing a not-yet-loaded (empty) editor would
		// otherwise blank the banner (and a stray autosave could persist the empty board over real content).
		// A loaded editor (isBoardReady) is always trusted, so clearing the board legitimately still works.
		let tmpCaptured = (tmpEdit && typeof tmpEdit.getBoard === 'function') ? tmpEdit.getBoard() : null;
		let tmpReady = !!(tmpEdit && typeof tmpEdit.isBoardReady === 'function' && tmpEdit.isBoardReady());
		let tmpPriorNodes = (this._state().Board && this._state().Board.Nodes) ? this._state().Board.Nodes.length : 0;
		let tmpCapturedNodes = (tmpCaptured && tmpCaptured.Nodes) ? tmpCaptured.Nodes.length : 0;
		let tmpBoard = (tmpCaptured && (tmpReady || tmpCapturedNodes >= tmpPriorNodes)) ? tmpCaptured : this._state().Board;
		this._state().Board = tmpBoard;
		this._state().BoardEditing = false;
		// Re-present through the SAME path as a fresh load so the empty prompt and the banner reflect what is
		// actually on the board: a board with cards mounts the read-only view AND hides #Profile-Board-Empty;
		// a board you emptied falls back to the "decorate" prompt. The old code mounted the read-only view
		// directly and never toggled the prompt, so a "blank canvas" prompt that was showing on a previously
		// empty board lingered over the freshly decorated banner.
		if (typeof document !== 'undefined') { let tmpBanner = document.getElementById('Profile-Board'); if (tmpBanner) { tmpBanner.innerHTML = ''; } }
		let tmpHasNodes = !!(tmpBoard && tmpBoard.Nodes && tmpBoard.Nodes.length);
		this._presentBoard(tmpBoard, tmpHasNodes, this._isSelf(), this._NavToken);
		this._updateEditBoardButton();
		this._state().ExitingEdit = false;
	}

	// Run a callback after pCount animation frames (fallback to a timeout when rAF is absent), giving the
	// moodboard flow time to finish a render pass before the next step.
	_afterFrames(pCount, fCallback)
	{
		if (typeof requestAnimationFrame !== 'function') { setTimeout(fCallback, 16 * (pCount || 1)); return; }
		let tmpRemaining = pCount || 1;
		let fTick = function () { tmpRemaining -= 1; if (tmpRemaining <= 0) { fCallback(); } else { requestAnimationFrame(fTick); } };
		requestAnimationFrame(fTick);
	}

	// The current personal board id, read by the edit board's Media image source to scope its gallery.
	currentBoardId() { return this._state().BoardID; }

	// Autosave hook wired to Profile-Board-Edit (only your own board is editable).
	onBoardSaved(pBoard)
	{
		let tmpID = this._state().BoardID;
		if (!tmpID || !this._isSelf()) { return; }
		if (this._SaveTimer) { clearTimeout(this._SaveTimer); }
		let tmpSelf = this;
		this._SaveTimer = setTimeout(function ()
		{
			tmpSelf._SaveTimer = null;
			let tmpAPI = tmpSelf.pict.providers.MoodboardAPI;
			if (tmpAPI) { tmpAPI.saveBoard(tmpID, pBoard).catch(() => {}); }
		}, _AUTOSAVE_MS);
	}

	// ── content blocks ───────────────────────────────────────────────────────

	_loadBlocks(pToken)
	{
		let tmpRecord = this._record();
		let tmpAPI = this.pict.providers.ProfileBlockAPI;
		if (!tmpAPI || !tmpRecord.IDUser) { this._state().Blocks = []; this._renderBlocks(); return; }
		tmpAPI.listForUser(tmpRecord.IDUser).then((pBlocks) =>
		{
			if (pToken && pToken !== this._NavToken) { return; }
			this._state().Blocks = Array.isArray(pBlocks) ? pBlocks : [];
			this._renderBlocks();
		});
	}

	_renderBlocks()
	{
		let tmpHost = document.getElementById('Profile-Blocks');
		if (!tmpHost) { return; }
		let tmpBlocks = this._state().Blocks || [];
		let tmpSelf = this._isSelf();
		let tmpAPI = this.pict.providers.ProfileBlockAPI;

		let tmpHTML = '';
		for (let i = 0; i < tmpBlocks.length; i++)
		{
			let tmpBlock = tmpBlocks[i];
			let tmpContent = tmpAPI ? tmpAPI.parseContent(tmpBlock) : {};
			let tmpControls = '';
			if (tmpSelf)
			{
				tmpControls =
					'<div class="pb-controls">'
					+ '<button class="pb-ctl" title="Move up" onclick="_Pict.views[\'Plansheet-Profile\'].moveBlock(' + tmpBlock.IDProfileBlock + ',-1)">&#8593;</button>'
					+ '<button class="pb-ctl" title="Move down" onclick="_Pict.views[\'Plansheet-Profile\'].moveBlock(' + tmpBlock.IDProfileBlock + ',1)">&#8595;</button>'
					+ (tmpBlock.BlockType === 'text' ? '<button class="pb-ctl" title="Edit" onclick="_Pict.views[\'Plansheet-Profile\'].editBlock(' + tmpBlock.IDProfileBlock + ')">Edit</button>' : '')
					+ '<button class="pb-ctl pb-ctl-danger" title="Delete" onclick="_Pict.views[\'Plansheet-Profile\'].deleteBlock(' + tmpBlock.IDProfileBlock + ')">&#215;</button>'
					+ '</div>';
			}
			tmpHTML += '<div class="pb-block pb-block-' + _escapeHTML(tmpBlock.BlockType) + '" data-block-id="' + tmpBlock.IDProfileBlock + '">'
				+ tmpControls
				+ this._blockBodyHTML(tmpBlock, tmpContent)
				+ '</div>';
		}
		if (tmpSelf)
		{
			tmpHTML += '<div class="pb-add">'
				+ '<button class="pb-add-btn" onclick="_Pict.views[\'Plansheet-Profile\'].addBlock(\'text\')">+ Text</button>'
				+ '<button class="pb-add-btn" onclick="_Pict.views[\'Plansheet-Profile\'].addImageBlock()">+ Image</button>'
				+ '<button class="pb-add-btn" onclick="_Pict.views[\'Plansheet-Profile\'].addBlock(\'embed\')">+ Embed</button>'
				+ '</div>';
		}
		tmpHost.innerHTML = tmpHTML;

		// Text blocks render markdown after insertion (same path as About).
		for (let i = 0; i < tmpBlocks.length; i++)
		{
			if (tmpBlocks[i].BlockType !== 'text') { continue; }
			let tmpEl = document.getElementById('PB-Text-' + tmpBlocks[i].IDProfileBlock);
			if (tmpEl)
			{
				let tmpMarkdown = (tmpAPI ? tmpAPI.parseContent(tmpBlocks[i]) : {}).Markdown || '';
				libMarkdownRender.renderInto(this.pict.providers.Content, tmpEl, tmpMarkdown, '<div class="pb-empty">Empty text block.</div>');
			}
		}
	}

	_blockBodyHTML(pBlock, pContent)
	{
		if (pBlock.BlockType === 'text')
		{
			return '<div class="pb-text" id="PB-Text-' + pBlock.IDProfileBlock + '"></div>';
		}
		if (pBlock.BlockType === 'image')
		{
			let tmpURL = pContent.Url || (pContent.IDMedia ? this.pict.providers.MediaAPI.blobURL(pContent.IDMedia) : '');
			if (!tmpURL) { return '<div class="pb-empty">No image.</div>'; }
			let tmpCaption = pContent.Caption ? '<div class="pb-caption">' + _escapeHTML(pContent.Caption) + '</div>' : '';
			return '<img class="pb-image" src="' + _escapeHTML(tmpURL) + '" alt="' + _escapeHTML(pContent.Caption || '') + '">' + tmpCaption;
		}
		if (pBlock.BlockType === 'embed')
		{
			let tmpEmbed = _embedURL(pContent.Url);
			if (tmpEmbed)
			{
				return '<div class="pb-embed"><iframe src="' + _escapeHTML(tmpEmbed) + '" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
			}
			let tmpRaw = String(pContent.Url || '').trim();
			if (/^https:\/\//i.test(tmpRaw))
			{
				return '<a class="pb-link" href="' + _escapeHTML(tmpRaw) + '" target="_blank" rel="noopener noreferrer">' + _escapeHTML(tmpRaw) + '</a>';
			}
			return '<div class="pb-empty">Paste a link (https) to embed.</div>';
		}
		return '';
	}

	addBlock(pType)
	{
		let tmpRecord = this._record();
		let tmpAPI = this.pict.providers.ProfileBlockAPI;
		if (!tmpAPI || !this._isSelf() || !tmpRecord.IDUser) { return; }
		let tmpContent = (pType === 'text') ? { Markdown: '' } : (pType === 'embed' ? { Url: '' } : {});
		let tmpSort = (this._state().Blocks || []).length;
		tmpAPI.createBlock(tmpRecord.IDUser, pType, tmpContent, { SortOrder: tmpSort }).then(() =>
			this._loadBlocks2().then(() =>
			{
				// Drop straight into editing a new text or embed block so it is usable immediately.
				let tmpBlocks = this._state().Blocks || [];
				let tmpNew = tmpBlocks[tmpBlocks.length - 1];
				if (tmpNew && (pType === 'text' || pType === 'embed')) { this.editBlock(tmpNew.IDProfileBlock); }
			}));
	}

	// _loadBlocks that returns a promise (used when an action must continue after the reload).
	_loadBlocks2()
	{
		let tmpRecord = this._record();
		let tmpAPI = this.pict.providers.ProfileBlockAPI;
		if (!tmpAPI || !tmpRecord.IDUser) { return Promise.resolve(); }
		return tmpAPI.listForUser(tmpRecord.IDUser).then((pBlocks) =>
		{
			this._state().Blocks = Array.isArray(pBlocks) ? pBlocks : [];
			this._renderBlocks();
		});
	}

	addImageBlock()
	{
		if (!this._isSelf()) { return; }
		let tmpInput = document.getElementById('Profile-Block-FileInput');
		if (tmpInput) { tmpInput.click(); }
	}

	onBlockImageChosen(pFiles)
	{
		let tmpRecord = this._record();
		let tmpFile = (pFiles && pFiles[0]) ? pFiles[0] : null;
		if (!tmpFile || !this._isSelf() || !this.pict.providers.MediaAPI || !this.pict.providers.ProfileBlockAPI) { return; }
		let tmpSort = (this._state().Blocks || []).length;
		this.pict.providers.MediaAPI.upload('User', tmpRecord.IDUser, tmpFile, {}).then((pRef) =>
		{
			let tmpID = pRef && pRef.IDMedia;
			return this.pict.providers.ProfileBlockAPI.createBlock(tmpRecord.IDUser, 'image', { IDMedia: tmpID }, { SortOrder: tmpSort });
		}).then(() => this._loadBlocks()).catch(() => {});
	}

	editBlock(pID)
	{
		let tmpBlock = (this._state().Blocks || []).find((pB) => pB.IDProfileBlock === pID);
		if (!tmpBlock || !this._isSelf()) { return; }
		let tmpHost = document.querySelector('#Profile-Blocks .pb-block[data-block-id="' + pID + '"]');
		if (!tmpHost) { return; }
		let tmpContent = this.pict.providers.ProfileBlockAPI.parseContent(tmpBlock);
		let tmpEditor = '';
		if (tmpBlock.BlockType === 'text')
		{
			tmpEditor = '<textarea class="pb-editor-text" id="PB-Edit-' + pID + '" placeholder="Write anything (markdown: # heading, **bold**, images, links)">' + _escapeHTML(tmpContent.Markdown || '') + '</textarea>';
		}
		else if (tmpBlock.BlockType === 'embed')
		{
			tmpEditor = '<input class="pb-editor-url" id="PB-Edit-' + pID + '" placeholder="Paste a YouTube/Vimeo or https link" value="' + _escapeHTML(tmpContent.Url || '') + '">';
		}
		tmpHost.innerHTML = '<div class="pb-edit">' + tmpEditor
			+ '<div class="pb-edit-actions">'
			+ '<button class="pb-ctl" onclick="_Pict.views[\'Plansheet-Profile\'].saveBlock(' + pID + ')">Save</button>'
			+ '<button class="pb-ctl pb-ctl-secondary" onclick="_Pict.views[\'Plansheet-Profile\'].cancelEdit()">Cancel</button>'
			+ '</div></div>';
		let tmpField = document.getElementById('PB-Edit-' + pID);
		if (tmpField && tmpField.focus) { tmpField.focus(); }
	}

	saveBlock(pID)
	{
		let tmpBlock = (this._state().Blocks || []).find((pB) => pB.IDProfileBlock === pID);
		let tmpField = document.getElementById('PB-Edit-' + pID);
		if (!tmpBlock || !tmpField) { return; }
		let tmpContent = (tmpBlock.BlockType === 'text') ? { Markdown: tmpField.value } : { Url: tmpField.value };
		this.pict.providers.ProfileBlockAPI.updateBlock(pID, tmpContent).then(() => this._loadBlocks()).catch(() => {});
	}

	cancelEdit() { this._renderBlocks(); }

	deleteBlock(pID)
	{
		if (!this._isSelf()) { return; }
		this.pict.providers.ProfileBlockAPI.remove(pID).then(() => this._loadBlocks()).catch(() => {});
	}

	moveBlock(pID, pDir)
	{
		let tmpBlocks = (this._state().Blocks || []).slice();
		let tmpIndex = tmpBlocks.findIndex((pB) => pB.IDProfileBlock === pID);
		let tmpTarget = tmpIndex + pDir;
		if (tmpIndex < 0 || tmpTarget < 0 || tmpTarget >= tmpBlocks.length) { return; }
		let tmpMoved = tmpBlocks.splice(tmpIndex, 1)[0];
		tmpBlocks.splice(tmpTarget, 0, tmpMoved);
		this._state().Blocks = tmpBlocks;
		this._renderBlocks();
		this.pict.providers.ProfileBlockAPI.reorder(tmpBlocks).catch(() => {});
	}

	// ── navigation ───────────────────────────────────────────────────────────

	editProfile()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSection === 'function') { tmpApp.showSection('Settings'); }
		let tmpSettings = this.pict.views['Plansheet-UserSettings'];
		if (tmpSettings && typeof tmpSettings.showSection === 'function')
		{
			setTimeout(() => { try { tmpSettings.showSection('about'); } catch (pErr) { /* ignore */ } }, 60);
		}
	}

	community()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSection === 'function') { tmpApp.showSection('Community'); }
	}

	back() { this.community(); }

	// ── head / about (synchronous DOM fills) ─────────────────────────────────

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		if (typeof document === 'undefined') { return super.onAfterRender(pRenderable, pAddress, pRecord, pContent); }

		let tmpData = this._record();
		let tmpSelf = this._isSelf(tmpData);

		let tmpAvatarEl = document.getElementById('Profile-Avatar');
		if (tmpAvatarEl) { tmpAvatarEl.innerHTML = libAvatarHelper.avatarHTML(tmpData, { Size: 72 }); }

		let tmpNameEl = document.getElementById('Profile-Name');
		if (tmpNameEl) { tmpNameEl.textContent = tmpData.DisplayName || tmpData.Email || 'Profile'; }

		let tmpTitleEl = document.getElementById('Profile-Title');
		if (tmpTitleEl)
		{
			tmpTitleEl.textContent = tmpData.Title || '';
			tmpTitleEl.style.display = tmpData.Title ? 'block' : 'none';
		}

		let tmpActionsEl = document.getElementById('Profile-Actions');
		if (tmpActionsEl)
		{
			let tmpButtons = '<button class="cst-profile-btn-secondary" onclick="_Pict.views[\'Plansheet-Profile\'].community()">Community</button>';
			if (tmpSelf)
			{
				// "Edit board" / "Done" toggles the banner between its saved display style (read-only) and the
				// editable canvas, in place. The board's own toolbar carries the style + view-area controls.
				tmpButtons += '<button class="cst-profile-btn-secondary" id="Profile-Edit-Board" onclick="_Pict.views[\'Plansheet-Profile\'].toggleBoardEdit()">' + (this._state().BoardEditing ? 'Done' : 'Edit board') + '</button>';
				tmpButtons += '<button class="cst-profile-btn" onclick="_Pict.views[\'Plansheet-Profile\'].editProfile()">Edit profile</button>';
			}
			tmpActionsEl.innerHTML = tmpButtons;
		}

		let tmpAboutEl = document.getElementById('Profile-About');
		if (tmpAboutEl)
		{
			let tmpEmpty = '<div class="cst-profile-empty">' + (tmpSelf ? 'You have not written an About Me yet. Edit your profile to add one.' : 'Nothing here yet.') + '</div>';
			libMarkdownRender.renderInto(this.pict.providers.Content, tmpAboutEl, tmpData.AboutMe || '', tmpEmpty);
		}

		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewProfile;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Profile',
	DefaultRenderable: 'Profile-Display',
	AutoRender: false,
	CSS: /*css*/`
		.cst-profile { max-width: 980px; margin: 0 auto; padding: 0 0 48px; height: 100%; overflow: auto; box-sizing: border-box; position: relative; }
		.cst-profile-board { height: 340px; position: relative; background: var(--theme-color-background-secondary, #f4f6f9); border-bottom: 1px solid var(--theme-color-border-default, #e3e6ec); }
		/* Presentation styles: a jumbotron banner (its height is the scaled view-area frame) reads as a
		   hero band; a background fills the banner as a backdrop. The host JS sets the inline height. */
		.cst-profile-board.cst-board-jumbotron, .cst-profile-board.cst-board-background { background: var(--theme-color-background-panel, #fff); }
		/* Backdrop display style (view mode only): the board is a full-bleed layer behind the whole profile
		   column; the head / blocks / About render on top of it, and the gear "Backdrop top margin" offsets
		   the board's focal content downward so it clears the header row. The stage gives the absolute board
		   a content-height containing block (so the backdrop spans all the content, not just the viewport). */
		.cst-profile-stage { position: relative; }
		/* The backdrop fills at least the viewport so a sparse profile still shows the full board art, and
		   grows with taller content. */
		.cst-profile-backdrop .cst-profile-stage { min-height: 100%; }
		.cst-profile-backdrop .cst-profile-board { position: absolute; inset: 0; height: auto !important; z-index: 0; border-bottom: none; pointer-events: none; }
		/* The board element carries the backdrop color (set inline from the moodboard's resolved color); the
		   flow's own container fills go transparent so that color shows -- the flow SVG fill does not
		   composite reliably as an absolute layer. The cards still render on top. */
		.cst-profile-backdrop .cst-profile-board .pict-flow-container,
		.cst-profile-backdrop .cst-profile-board .pict-flow-svg-container { background: transparent !important; }
		.cst-profile-backdrop .cst-profile-inner { position: relative; z-index: 1; }
		/* "Edit board" toggle on your own board (overlaid top-left, opposite the viewer bar). Lives outside
		   #Profile-Board so the board's render does not wipe it. */
		/* Slim prompt shown instead of a tall empty canvas on your own undecorated board. */
		.cst-profile-board-empty { align-items: center; justify-content: center; gap: 14px; height: 96px; background: var(--theme-color-background-secondary, #f4f6f9); border-bottom: 1px solid var(--theme-color-border-default, #e3e6ec); }
		.cst-profile-board-empty-text { color: var(--theme-color-text-secondary, #5b6376); font-size: 0.95em; }
		.cst-profile-inner { padding: 0 32px; }
		.cst-profile-head { display: flex; align-items: center; gap: 18px; padding: 20px 0; border-bottom: 1px solid var(--theme-color-border-default, #e3e6ec); }
		/* The header (avatar + name) is its own section below the board banner -- they must not overlap.
		   No negative margin pulling the avatar up into the board. */
		.cst-profile-avatar { flex: 0 0 auto; border-radius: 50%; background: var(--theme-color-background-panel, #fff); }
		.cst-profile-id { flex: 1 1 auto; min-width: 0; }
		.cst-profile-name { margin: 0; font-size: 1.6em; color: var(--theme-color-text-primary, #1d2230); }
		.cst-profile-title { margin-top: 3px; font-size: 0.95em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-profile-actions { display: flex; gap: 8px; flex: 0 0 auto; }
		.cst-profile-btn { padding: 8px 16px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 8px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; cursor: pointer; font-size: 0.85em; }
		.cst-profile-btn:hover { filter: brightness(1.05); }
		.cst-profile-btn-secondary { padding: 8px 16px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); cursor: pointer; font-size: 0.85em; }

		/* Content blocks */
		.cst-profile-blocks { padding: 22px 0 8px; display: flex; flex-direction: column; gap: 16px; }
		.pb-block { position: relative; border: 1px solid var(--theme-color-border-default, #e7eaf0); border-radius: 12px; padding: 16px 18px; background: var(--theme-color-background-panel, #fff); }
		.pb-controls { position: absolute; top: 8px; right: 8px; display: none; gap: 4px; }
		.pb-block:hover .pb-controls { display: flex; }
		.pb-ctl { border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); border-radius: 6px; padding: 3px 8px; cursor: pointer; font-size: 12px; color: var(--theme-color-text-primary, #1d2230); }
		.pb-ctl:hover { background: var(--theme-color-background-hover, #f2f4f8); }
		.pb-ctl-danger { color: #b3261e; }
		.pb-ctl-secondary { color: var(--theme-color-text-secondary, #5b6376); }
		.pb-text { line-height: 1.6; color: var(--theme-color-text-primary, #1d2230); }
		.pb-text img { max-width: 100%; border-radius: 8px; }
		.pb-image { max-width: 100%; border-radius: 10px; display: block; }
		.pb-caption { margin-top: 6px; font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); }
		.pb-embed { position: relative; padding-top: 56.25%; border-radius: 10px; overflow: hidden; }
		.pb-embed iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; }
		.pb-link { color: var(--theme-color-brand-primary, #3b6fd4); word-break: break-all; }
		.pb-empty { color: var(--theme-color-text-secondary, #8a93a5); font-style: italic; }
		.pb-add { display: flex; gap: 8px; padding-top: 4px; }
		.pb-add-btn { border: 1px dashed var(--theme-color-border-default, #cfd6e2); background: transparent; border-radius: 8px; padding: 8px 14px; cursor: pointer; color: var(--theme-color-text-secondary, #5b6376); font-size: 0.9em; }
		.pb-add-btn:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); color: var(--theme-color-brand-primary, #3b6fd4); }
		.pb-edit { display: flex; flex-direction: column; gap: 8px; }
		.pb-editor-text { width: 100%; min-height: 120px; box-sizing: border-box; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; padding: 10px; font: inherit; line-height: 1.5; resize: vertical; }
		.pb-editor-url { width: 100%; box-sizing: border-box; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; padding: 9px 10px; font: inherit; }
		.pb-edit-actions { display: flex; gap: 8px; }

		.cst-profile-about-wrap { padding-top: 26px; }
		.cst-profile-about-h { margin: 0 0 12px; font-size: 1.05em; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-profile-about { color: var(--theme-color-text-primary, #1d2230); line-height: 1.6; }
		.cst-profile-about img { max-width: 100%; border-radius: 8px; }
		.cst-profile-empty { padding: 16px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 10px; color: var(--theme-color-text-secondary, #5b6376); font-size: 0.9em; }
	`,
	Templates:
	[
		{
			Hash: 'Profile-Display',
			Template: /*html*/`
<div class="cst-profile">
	<div class="cst-profile-stage">
	<div class="cst-profile-board" id="Profile-Board"></div>
	<div class="cst-profile-board-empty" id="Profile-Board-Empty" style="display:none">
		<div class="cst-profile-board-empty-text">Your board is a blank canvas.</div>
		<button class="cst-profile-btn" onclick="_Pict.views['Plansheet-Profile'].startDecorating()">Decorate your board</button>
	</div>
	<div class="cst-profile-inner">
		<div class="cst-profile-head">
			<span class="cst-profile-avatar" id="Profile-Avatar"></span>
			<div class="cst-profile-id">
				<h1 class="cst-profile-name" id="Profile-Name"></h1>
				<div class="cst-profile-title" id="Profile-Title"></div>
			</div>
			<div class="cst-profile-actions" id="Profile-Actions"></div>
		</div>
		<div class="cst-profile-blocks" id="Profile-Blocks"></div>
		<div class="cst-profile-about-wrap">
			<h2 class="cst-profile-about-h">About</h2>
			<div class="cst-profile-about" id="Profile-About"></div>
		</div>
	</div>
	</div>
	<input type="file" accept="image/*" style="display:none" id="Profile-Block-FileInput"
		onchange="_Pict.views['Plansheet-Profile'].onBlockImageChosen(this.files); this.value='';">
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Profile-Display',
			TemplateHash: 'Profile-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"./AvatarHelper.js":648,"./MarkdownRender.js":649,"pict-view":365}],687:[function(require,module,exports){
'use strict';

/**
 * PictView-Project: the workspace for a Project (V54) -- a unit of work built from a cluster of source files.
 * A Project gathers a corpus (ProjectSource items, uploaded files and inline data), the conversational tasks
 * run against it (which open in the Ask area, carrying IDProject), and its artifacts (a Blueprint, platform
 * outputs). The plan sheet is the series or domain; a Project is one unit inside it; there are many per plan
 * sheet. Two routes: /projects (the list) and /project/:id (the workspace); the body repaints into
 * #Project-Body so a corpus change does not re-render the shell.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');

const _TRASH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';

// The project's general instructions (a priming statement that leads every task run against it) are
// stored as one reserved-role inline-DATA ProjectSource, so they fold into the dispatch corpus like any
// other source and need no column of their own. The UI shows them in a dedicated box, not the file list.
const _INSTRUCTIONS_ROLE = 'Instructions';

class PictViewProject extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._projects = [];
		this._project = null;
		this._corpus = [];
		this._instructionsSource = null;
		this._tasks = [];
		this._requests = [];
		this._sessions = [];
		// The configurable metadata form (a manyfest manifest resolved per Kind) and the project's own
		// MetadataJSON blob it reads and writes, plus the work-item inputs (linked records that ride with a
		// run) and a lazily fetched candidate list for the input picker.
		this._metaManifest = null;
		this._metaSource = null;
		this._metadata = {};
		this._workItemInputs = [];
		this._inputCandidates = null;
		this._busy = false;
	}

	_projectAPI() { return this.pict.providers.ProjectAPI; }
	_sourceAPI() { return this.pict.providers.ProjectSourceAPI; }
	_mediaAPI() { return this.pict.providers.MediaAPI; }
	_taskAPI() { return this.pict.providers.TaskAPI; }
	_requestAPI() { return this.pict.providers.RequestAPI; }
	_askAPI() { return this.pict.providers.AskAPI; }
	_sessionAPI() { return this.pict.providers.SessionAPI; }
	_connectionsAPI() { return this.pict.providers.ConnectionsAPI; }
	_router() { return this.pict.providers['Pict-Router']; }

	_esc(pValue)
	{
		return String(pValue === null || typeof pValue === 'undefined' ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	_body() { return (typeof document !== 'undefined') ? document.getElementById('Project-Body') : null; }
	_paint(pHTML) { let tmpBody = this._body(); if (tmpBody) { tmpBody.innerHTML = pHTML; } }
	_app() { return this.pict.PictApplication; }
	_ensureShell() { if (!this._body()) { this.render(); } }

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && tmpModal.toast) { tmpModal.toast(pMessage, { type: pType || 'success' }); }
	}

	_pill(pStatus)
	{
		let tmpStatus = String(pStatus || 'Draft');
		// Slug the class to a safe charset -- Status is a free VARCHAR a teammate can set, so it must never reach
		// the class attribute raw (it would break out and run as stored XSS).
		let tmpSlug = tmpStatus.toLowerCase().replace(/[^a-z0-9]/g, '');
		return '<span class="prj-pill prj-pill-' + tmpSlug + '">' + this._esc(tmpStatus) + '</span>';
	}

	show() { return this.showList(); }

	// ---- the list (route /projects) ------------------------------------------------------------------------
	showList()
	{
		this._ensureShell();
		this._enterList();
		return true;
	}

	async _enterList()
	{
		this._project = null;
		this._paint('<div class="prj-loading">Loading projects...</div>');
		let tmpProjects = [];
		try { tmpProjects = await this._projectAPI().resolve({ PageSize: 200 }); }
		catch (pError) { /* a transient failure paints an empty list rather than a blank pane */ }
		this._projects = (Array.isArray(tmpProjects) ? tmpProjects : [])
			.sort((pA, pB) => (Number(pB.ProjectNumber) || 0) - (Number(pA.ProjectNumber) || 0));
		this._paintList();
	}

	_paintList()
	{
		let tmpCards = this._projects.map((pProject) => ''
			+ '<button class="prj-card" onclick="_Pict.views[\'Plansheet-Project\'].openProject(' + (Number(pProject.IDProject) || 0) + ')">'
			+ '<div class="prj-card-head"><span class="prj-card-name">' + this._esc(pProject.Name || ('Project ' + (pProject.ProjectNumber || ''))) + '</span>' + this._pill(pProject.Status) + '</div>'
			+ (pProject.Kind ? ('<div class="prj-card-kind">' + this._esc(pProject.Kind) + '</div>') : '')
			+ (pProject.Summary ? ('<div class="prj-card-sum">' + this._esc(pProject.Summary) + '</div>') : '')
			+ '</button>').join('');
		this._paint(''
			+ '<div class="prj-new">'
			+ '<div class="prj-group-head">New project</div>'
			+ '<div class="prj-new-row">'
			+ '<input type="text" id="Project-NewName" class="prj-input" placeholder="Project name (e.g. Materials Inspection)" />'
			+ '<input type="text" id="Project-NewKind" class="prj-input prj-input-kind" value="form" placeholder="kind" />'
			+ '<button class="prj-btn" onclick="_Pict.views[\'Plansheet-Project\'].createProject()">Create</button>'
			+ '</div></div>'
			+ (tmpCards ? ('<div class="prj-cards">' + tmpCards + '</div>') : '<div class="prj-empty">No projects yet. Create one above to start building from a cluster of files.</div>'));
	}

	async createProject()
	{
		if (this._busy) { return; }
		let tmpNameEl = (typeof document !== 'undefined') ? document.getElementById('Project-NewName') : null;
		let tmpKindEl = (typeof document !== 'undefined') ? document.getElementById('Project-NewKind') : null;
		let tmpName = tmpNameEl ? String(tmpNameEl.value || '').trim() : '';
		let tmpKind = tmpKindEl ? String(tmpKindEl.value || '').trim() : '';
		if (!tmpName) { this._toast('Give the project a name first.', 'error'); return; }
		this._busy = true;
		let tmpProject = null;
		try { tmpProject = await this._projectAPI().create({ Name: tmpName, Kind: tmpKind || 'form', Status: 'Draft' }); }
		catch (pError) { this._busy = false; this._toast((pError && pError.message) || 'Could not create the project.', 'error'); return; }
		this._busy = false;
		let tmpID = Number(tmpProject && tmpProject.IDProject) || 0;
		if (tmpID) { this._goDetail(tmpID); } else { this._enterList(); }
	}

	// ---- the workspace (route /project/:id) ----------------------------------------------------------------
	openProject(pID) { this._goDetail(pID); }

	async showDetail(pID)
	{
		this._ensureShell();
		let tmpID = Number(pID) || 0;
		this._paint('<div class="prj-loading">Loading...</div>');
		let tmpProject = null;
		try { tmpProject = await this._projectAPI().read(tmpID); }
		catch (pError) { tmpProject = null; }
		if (!tmpProject) { return this.showList(); }
		this._project = tmpProject;
		await this._loadDetailData(tmpID);
		this._paintDetail();
	}

	async _loadDetailData(pIDProject)
	{
		let tmpCorpus = [];
		let tmpTasks = [];
		let tmpRequests = [];
		let tmpSessions = [];
		try { tmpCorpus = await this._sourceAPI().resolve({ Filter: 'FBV~IDProject~EQ~' + pIDProject, PageSize: 200 }); } catch (pError) { tmpCorpus = []; }
		try { tmpTasks = await this._taskAPI().resolve({ Filter: 'FBV~Status~EQ~Active', PageSize: 250 }); } catch (pError) { tmpTasks = []; }
		try { tmpRequests = await this._requestAPI().resolve({ Filter: 'FBV~IDProject~EQ~' + pIDProject, PageSize: 50 }); } catch (pError) { tmpRequests = []; }
		try { tmpSessions = await this._sessionAPI().projectSessions(pIDProject); } catch (pError) { tmpSessions = []; }
		this._applyCorpus(tmpCorpus);
		// Only conversational tasks are runnable chain steps in a Project.
		this._tasks = (Array.isArray(tmpTasks) ? tmpTasks : []).filter((pTask) => pTask && pTask.Conversational);
		this._requests = (Array.isArray(tmpRequests) ? tmpRequests : []).sort((pA, pB) => (Number(pB.RequestNumber) || 0) - (Number(pA.RequestNumber) || 0));
		this._sessions = Array.isArray(tmpSessions) ? tmpSessions : [];

		// The metadata blob the project owns, and the form that renders it. Parse the stored blob first; an
		// older project kept its priming statement as the reserved-role 'Instructions' source, so seed that
		// into the blob view when the blob has none (a save then migrates it -- see saveMetadata). _applyCorpus
		// ran above, so this._instructionsSource is set before this seed reads it.
		this._metadata = {};
		try { let tmpParsed = JSON.parse((this._project && this._project.MetadataJSON) || 'null'); if (tmpParsed && typeof tmpParsed === 'object') { this._metadata = tmpParsed; } } catch (pIgnore) { this._metadata = {}; }
		if (!this._metadata.Instructions && this._instructionsSource) { let tmpLegacy = this._instructionsText(); if (tmpLegacy) { this._metadata.Instructions = tmpLegacy; } }
		this._metaManifest = null;
		this._metaSource = null;
		this._inputCandidates = null;
		// Resolve the configured metadata form and gather the work-item inputs concurrently -- neither blocks
		// the other, and a failure in either leaves a usable default rather than a blank panel.
		let tmpKindSeg = encodeURIComponent(String((this._project && this._project.Kind) || '').trim() || '-');
		let tmpManifestP = libFrameworkClient.getJSON(this.pict, '/1.0/MetadataManifest/Resolve/Project/' + tmpKindSeg).catch(() => null);
		let tmpConnP = this._connectionsAPI() ? this._connectionsAPI().get('Project', pIDProject) : Promise.resolve(null);
		let tmpResolved = await tmpManifestP;
		if (tmpResolved && tmpResolved.Manifest && typeof tmpResolved.Manifest === 'object') { this._metaManifest = tmpResolved.Manifest; this._metaSource = tmpResolved.Source || null; }
		if (!this._metaManifest) { this._metaManifest = { Descriptors: {}, Sections: [] }; }
		this._workItemInputs = this._extractInputs(await tmpConnP);
	}

	// Split the fetched sources into the file/data corpus (shown in the Corpus list) and the one reserved
	// Instructions source (shown in its own box). Both the first load and a reload pass through here so the
	// instructions item never leaks into the file list.
	_applyCorpus(pSources)
	{
		let tmpSorted = (Array.isArray(pSources) ? pSources : []).sort((pA, pB) => (Number(pA.SortOrder) || 0) - (Number(pB.SortOrder) || 0));
		this._instructionsSource = tmpSorted.find((pSource) => String(pSource.Role || '') === _INSTRUCTIONS_ROLE && !(Number(pSource.IDMedia) > 0)) || null;
		this._corpus = tmpSorted.filter((pSource) => pSource !== this._instructionsSource);
	}

	// The current instructions text (the reserved source stores it as a JSON string in ContentJSON).
	_instructionsText()
	{
		let tmpSource = this._instructionsSource;
		if (!tmpSource) { return ''; }
		try { let tmpValue = JSON.parse(tmpSource.ContentJSON || '""'); return (typeof tmpValue === 'string') ? tmpValue : String(tmpValue || ''); }
		catch (pError) { return String(tmpSource.ContentJSON || ''); }
	}

	async _reloadCorpus()
	{
		if (!this._project) { return; }
		try { this._applyCorpus(await this._sourceAPI().resolve({ Filter: 'FBV~IDProject~EQ~' + this._project.IDProject, PageSize: 200 })); }
		catch (pError) { /* keep the last corpus on a transient failure */ }
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById('Project-Corpus') : null;
		if (tmpEl) { tmpEl.innerHTML = this._corpusInnerHTML(); }
	}

	_corpusInnerHTML()
	{
		let tmpRows = this._corpus.map((pSource) =>
		{
			let tmpIsFile = Number(pSource.IDMedia) > 0;
			return ''
				+ '<div class="prj-src">'
				+ '<span class="prj-role">' + this._esc(pSource.Role || 'Source') + '</span>'
				+ '<span class="prj-src-name">' + this._esc(pSource.Name || (tmpIsFile ? 'file' : 'data')) + '</span>'
				+ '<span class="prj-src-kind">' + (tmpIsFile ? 'file' : 'data') + '</span>'
				+ '<button class="prj-src-del" title="Remove" aria-label="Remove" onclick="_Pict.views[\'Plansheet-Project\'].removeSource(' + (Number(pSource.IDProjectSource) || 0) + ')">' + _TRASH_SVG + '</button>'
				+ '</div>';
		}).join('');
		return (tmpRows || '<div class="prj-empty-sm">No files yet. Add the template, the filled examples, the policy...</div>')
			+ '<div class="prj-add">'
			+ '<input type="file" id="Project-File" class="prj-file" multiple onchange="_Pict.views[\'Plansheet-Project\'].attachFiles(this)" />'
			+ '<input type="text" id="Project-FileRole" class="prj-input prj-input-role" value="Reference" placeholder="role" />'
			+ '<button class="prj-btn prj-btn-ghost" onclick="document.getElementById(\'Project-File\').click()">Attach files</button>'
			+ '</div>'
			+ '<div class="prj-add">'
			+ '<input type="text" id="Project-DataRole" class="prj-input prj-input-role" value="Data" placeholder="role" />'
			+ '<input type="text" id="Project-DataName" class="prj-input prj-input-role" placeholder="name" />'
			+ '<textarea id="Project-DataJSON" class="prj-input prj-data-json" rows="2" placeholder="inline JSON data"></textarea>'
			+ '<button class="prj-btn prj-btn-ghost" onclick="_Pict.views[\'Plansheet-Project\'].addData()">Add data</button>'
			+ '</div>';
	}

	_paintDetail()
	{
		let tmpProject = this._project || {};
		let tmpTaskButtons = this._tasks.length
			? this._tasks.map((pTask) => '<button class="prj-btn" onclick="_Pict.views[\'Plansheet-Project\'].runTask(' + (Number(pTask.IDTask) || 0) + ')">' + this._esc(pTask.Name || 'Run') + '</button>').join('')
			: '<div class="prj-empty-sm">No conversational tasks are set up in this plan sheet yet.</div>';
		let tmpReqRows = this._requests.length
			? this._requests.map((pRequest) => ''
				+ '<button class="prj-req" onclick="_Pict.views[\'Plansheet-Project\'].openRequest(' + (Number(pRequest.IDRequest) || 0) + ')">'
				+ '<span class="prj-req-name">' + this._esc(pRequest.Name || ('Request ' + (pRequest.RequestNumber || ''))) + '</span>' + this._pill(pRequest.Status)
				+ '</button>').join('')
			: '<div class="prj-empty-sm">No runs yet. Launch a task above.</div>';
		let tmpBlueprint = (Number(tmpProject.IDBlueprint) > 0)
			? '<button class="prj-btn" onclick="_Pict.views[\'Plansheet-Project\'].openBlueprint()">Open the blueprint</button>'
			: '<div class="prj-empty-sm">No blueprint yet. Run a generate-blueprint task.</div>';
		let tmpOutputs = this._outputsHTML(tmpProject);

		this._paint(''
			+ '<div class="prj-detail">'
			+ '<button class="prj-back" onclick="_Pict.views[\'Plansheet-Project\'].backToList()">&larr; All projects</button>'
			+ '<div class="prj-head"><h2 class="prj-title">' + this._esc(tmpProject.Name || 'Project') + '</h2>'
			+ (tmpProject.Kind ? ('<span class="prj-kind-chip">' + this._esc(tmpProject.Kind) + '</span>') : '') + this._pill(tmpProject.Status) + '</div>'
			+ (tmpProject.Summary ? ('<div class="prj-sum">' + this._esc(tmpProject.Summary) + '</div>') : '')
			+ this._proposalPanelHTML(tmpProject)
			+ '<div class="prj-panel"><div class="prj-group-head">Project metadata</div><div id="Project-Meta">' + this._metaFormHTML() + '</div>'
			+ '<div class="prj-add"><button class="prj-btn prj-btn-ghost" onclick="_Pict.views[\'Plansheet-Project\'].saveMetadata()">Save metadata</button><span id="Project-Meta-State" class="prj-hint"></span></div>'
			+ '<div class="prj-hint">These fields are configured per project kind; they travel with every task run on this project.</div></div>'
			+ '<div class="prj-panel"><div class="prj-group-head">Corpus</div><div id="Project-Corpus">' + this._corpusInnerHTML() + '</div></div>'
			+ '<div class="prj-panel"><div class="prj-group-head">Work item inputs</div><div id="Project-Inputs">' + this._inputsHTML() + '</div>'
			+ '<div class="prj-hint">Linked work items ride along as inputs a task can read -- title, status, and description.</div></div>'
			+ '<div class="prj-panel"><div class="prj-group-head">Run a task</div><div class="prj-tasks">' + tmpTaskButtons + '</div>'
			+ '<div class="prj-hint">A task runs against the whole corpus and opens as a conversation in the Ask area.</div></div>'
			+ '<div class="prj-panel"><div class="prj-group-head">Conversations</div><div class="prj-reqs">' + tmpReqRows + '</div></div>'
			+ '<div class="prj-panel"><div class="prj-group-head">Agent sessions</div>' + this._sessionsHTML() + '</div>'
			+ '<div class="prj-panel"><div class="prj-group-head">Blueprint</div>' + tmpBlueprint + '</div>'
			+ (tmpOutputs ? ('<div class="prj-panel"><div class="prj-group-head">Outputs</div>' + tmpOutputs + '</div>') : '')
			+ '</div>');
	}

	// When a type-authoring turn has proposed a Project type, it is staged on this Project's OutputsJSON
	// (Run-Guards). Show it with a Create/Publish action: that POST is the person's consent, and only then is the
	// type committed (a new MetadataManifest Version + the ProjectType). Until then the proposal is inert.
	_proposalPanelHTML(pProject)
	{
		let tmpOutputs = null;
		try { tmpOutputs = JSON.parse((pProject && pProject.OutputsJSON) || 'null'); } catch (pError) { tmpOutputs = null; }
		let tmpProposal = (tmpOutputs && typeof tmpOutputs === 'object') ? tmpOutputs.ProjectTypeProposal : null;
		if (!tmpProposal || !tmpProposal.Manifest || typeof tmpProposal.Manifest !== 'object') { return ''; }
		let tmpManifest = tmpProposal.Manifest;
		let tmpDescriptors = (tmpManifest && typeof tmpManifest.Descriptors === 'object') ? tmpManifest.Descriptors : {};
		let tmpSections = Array.isArray(tmpManifest.Sections) ? tmpManifest.Sections : [];
		let tmpFieldKeys = Object.keys(tmpDescriptors);
		let tmpFields = tmpFieldKeys.map((pKey) =>
		{
			let tmpDescriptor = tmpDescriptors[pKey] || {};
			let tmpForm = tmpDescriptor.PictForm || {};
			return '<div class="prj-out"><span class="prj-out-key">' + this._esc(tmpDescriptor.Name || pKey) + '</span>'
				+ '<span class="prj-out-val">' + this._esc((tmpForm.InputType || 'Text') + (tmpForm.Section ? (' in ' + tmpForm.Section) : '')) + '</span></div>';
		}).join('');
		let tmpIsAdjust = Number(tmpProposal.IDProjectType) > 0;
		return ''
			+ '<div class="prj-panel">'
			+ '<div class="prj-group-head">Proposed project type' + (tmpIsAdjust ? ' (adjustment)' : '') + '</div>'
			+ '<div class="prj-head"><span class="prj-title" style="font-size:1.12em;">' + this._esc(tmpProposal.Name || tmpProposal.TypeKey || 'Untitled type') + '</span>'
			+ (tmpProposal.TypeKey ? ('<span class="prj-kind-chip">' + this._esc(tmpProposal.TypeKey) + '</span>') : '') + '</div>'
			+ (tmpProposal.Description ? ('<div class="prj-sum">' + this._esc(tmpProposal.Description) + '</div>') : '')
			+ '<div class="prj-hint">' + tmpFieldKeys.length + ' field' + (tmpFieldKeys.length === 1 ? '' : 's') + ' in ' + tmpSections.length + ' section' + (tmpSections.length === 1 ? '' : 's') + '. Review it, then create the type when you are happy.</div>'
			+ (tmpFields ? ('<div class="prj-reqs" style="margin-top:8px;">' + tmpFields + '</div>') : '')
			+ '<div class="prj-add"><button class="prj-btn" onclick="_Pict.views[\'Plansheet-Project\'].commitProjectType()">' + (tmpIsAdjust ? 'Publish the new version' : 'Create this type') + '</button><span id="Project-Proposal-State" class="prj-hint"></span></div>'
			+ '</div>';
	}

	async commitProjectType()
	{
		if (this._busy || !this._project) { return; }
		let tmpIDProject = Number(this._project.IDProject) || 0;
		if (!tmpIDProject) { return; }
		this._busy = true;
		let tmpState = (typeof document !== 'undefined') ? document.getElementById('Project-Proposal-State') : null;
		if (tmpState) { tmpState.textContent = 'Creating the type...'; }
		let tmpResult = null;
		try { tmpResult = await libFrameworkClient.postJSON(this.pict, '/1.0/ProjectType/Commit', { IDProject: tmpIDProject }); }
		catch (pError) { this._busy = false; if (tmpState) { tmpState.textContent = ''; } this._toast((pError && pError.message) || 'Could not create the type.', 'error'); return; }
		this._busy = false;
		this._toast('Project type created.', 'success');
		let tmpIDType = Number(tmpResult && tmpResult.ProjectType && tmpResult.ProjectType.IDProjectType) || 0;
		let tmpApp = this._app();
		if (tmpIDType && tmpApp && typeof tmpApp.showProjectType === 'function') { tmpApp.showProjectType(tmpIDType); }
		else { this.showDetail(tmpIDProject); }
	}

	_outputsHTML(pProject)
	{
		let tmpOutputs = null;
		try { tmpOutputs = JSON.parse((pProject && pProject.OutputsJSON) || 'null'); } catch (pError) { tmpOutputs = null; }
		if (!tmpOutputs || typeof tmpOutputs !== 'object' || !Object.keys(tmpOutputs).length) { return ''; }
		// ProjectTypeProposal has its own panel above; do not also dump it here as raw JSON.
		let tmpRows = Object.keys(tmpOutputs).filter((pKey) => pKey !== 'ProjectTypeProposal').map((pKey) =>
		{
			let tmpValue = tmpOutputs[pKey];
			let tmpUrl = (tmpValue && typeof tmpValue === 'object') ? (tmpValue.url || tmpValue.URL) : null;
			// Only link an http(s) URL -- the value comes from node output, so a javascript:/data: scheme would be a
			// clickable XSS. Anything else renders as escaped text.
			let tmpSafeUrl = (tmpUrl && /^https?:\/\//i.test(String(tmpUrl))) ? String(tmpUrl) : '';
			let tmpShown = tmpSafeUrl
				? ('<a class="prj-out-link" href="' + this._esc(tmpSafeUrl) + '" target="_blank" rel="noopener noreferrer">' + this._esc(tmpSafeUrl) + '</a>')
				: this._esc(typeof tmpValue === 'object' ? JSON.stringify(tmpValue) : tmpValue);
			return '<div class="prj-out"><span class="prj-out-key">' + this._esc(pKey) + '</span><span class="prj-out-val">' + tmpShown + '</span></div>';
		}).join('');
		return tmpRows;
	}

	// The Claude sessions that built this Project (the runner's whole transcript, filed and linked
	// to the Project), newest first. Each row opens the session in the viewer at its own route.
	_sessionsHTML()
	{
		let tmpSessions = Array.isArray(this._sessions) ? this._sessions : [];
		if (!tmpSessions.length) { return '<div class="prj-empty-sm">No sessions filed yet. A run files its session here when it finishes.</div>'; }
		return tmpSessions.map((pSession) =>
		{
			let tmpID = Number(pSession.IDSessionFile) || 0;
			let tmpWhen = String(pSession.SessionStartedAt || pSession.CreateDate || '').slice(0, 16).replace('T', ' ');
			let tmpMins = Math.round((Number(pSession.TotalDurationMs) || 0) / 60000);
			let tmpMeta = [
				tmpWhen,
				(Number(pSession.PromptCount) || 0) + ' prompts',
				(Number(pSession.ToolCallCount) || 0) + ' tools',
				(tmpMins > 0 ? (tmpMins + ' min') : ''),
				this._esc(pSession.Model || '')
			].filter((pPart) => String(pPart || '').trim()).join(' &middot; ');
			return ''
				+ '<button class="prj-req" onclick="_Pict.views[\'Plansheet-Project\']._openSession(' + tmpID + ')">'
				+ '<span class="prj-req-name">' + this._esc(pSession.Title || ('Session #' + tmpID)) + '</span>'
				+ '<span class="prj-src-kind">' + tmpMeta + '</span>'
				+ '</button>';
		}).join('');
	}

	_openSession(pIDSessionFile)
	{
		let tmpID = Number(pIDSessionFile) || 0;
		if (!tmpID) { return; }
		let tmpApp = this._app();
		if (tmpApp && typeof tmpApp.showSession === 'function') { tmpApp.showSession(tmpID); }
		else if (tmpApp && typeof tmpApp.openServerSession === 'function') { tmpApp.openServerSession(tmpID); }
	}

	// ---- corpus actions ------------------------------------------------------------------------------------
	// Run one authenticated write with a single retry. The upload path (binary blob PUT, then the corpus
	// create) has been seen to drop intermittently -- a transient 5xx, an auth slide, or a connection the
	// edge did not keep alive -- and leave an orphan Media row with an unhelpful toast. One retry turns most
	// of those into a success. A real client refusal (a 4xx that is not auth/timeout/rate) is not retried.
	async _retryWrite(fThunk)
	{
		try { return await fThunk(); }
		catch (pError)
		{
			let tmpStatus = Number(pError && pError.StatusCode) || 0;
			if (tmpStatus >= 400 && tmpStatus < 500 && tmpStatus !== 401 && tmpStatus !== 408 && tmpStatus !== 429) { throw pError; }
			return await fThunk();
		}
	}

	// A toast-ready description of a failed write that keeps the HTTP status, so a recurring upload failure
	// names itself (413 = too large / proxy cap, 5xx = server, 401 = auth) instead of reading as a mystery.
	_writeErr(pError)
	{
		let tmpStatus = Number(pError && pError.StatusCode) || 0;
		let tmpMessage = (pError && pError.message) || 'unknown error';
		return tmpMessage + (tmpStatus ? (' (HTTP ' + tmpStatus + ')') : '');
	}

	// ---- configurable metadata form ------------------------------------------------------------------------
	// The metadata form is driven entirely by the manifest the server resolved for this project's Kind: each
	// descriptor is a leaf scalar in MetadataJSON, and its PictForm hints (Section, Row, 12-col Width, InputType)
	// place it. A plan sheet reshapes the form by authoring a MetadataManifest row; no code changes here. This
	// is a light hand-rendered form rather than an embedded pict-section-form -- the whole view paints HTML into
	// one node, and a manyfest of leaf scalars needs a renderer, not a second form application and its deps.
	_slug(pKey) { return String(pKey || '').replace(/[^a-zA-Z0-9]/g, '_'); }
	_asText(pValue) { return (pValue === null || typeof pValue === 'undefined') ? '' : String(pValue); }
	_asBool(pValue) { return pValue === true || pValue === 1 || pValue === '1' || String(pValue).toLowerCase() === 'true'; }
	_metaValue(pKey) { return this._getPath(this._metadata, pKey); }

	// A descriptor address may be a dot path (manyfest nests), so read and write MetadataJSON by path rather
	// than by a flat key -- a flat key is just a one-segment path and still works.
	_getPath(pObject, pPath)
	{
		let tmpParts = String(pPath || '').split('.');
		let tmpCursor = pObject;
		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCursor === null || typeof tmpCursor !== 'object') { return undefined; }
			tmpCursor = tmpCursor[tmpParts[i]];
		}
		return tmpCursor;
	}

	_setPath(pObject, pPath, pValue)
	{
		let tmpParts = String(pPath || '').split('.');
		let tmpCursor = pObject;
		for (let i = 0; i < tmpParts.length - 1; i++)
		{
			let tmpKey = tmpParts[i];
			if (tmpCursor[tmpKey] === null || typeof tmpCursor[tmpKey] !== 'object') { tmpCursor[tmpKey] = {}; }
			tmpCursor = tmpCursor[tmpKey];
		}
		tmpCursor[tmpParts[tmpParts.length - 1]] = pValue;
	}

	_metaFormHTML()
	{
		let tmpManifest = this._metaManifest || {};
		let tmpDescriptors = (tmpManifest.Descriptors && typeof tmpManifest.Descriptors === 'object') ? tmpManifest.Descriptors : {};
		let tmpKeys = Object.keys(tmpDescriptors);
		if (!tmpKeys.length) { return '<div class="prj-empty-sm">No metadata fields are configured for this kind.</div>'; }

		// Render sections in the order the manifest declares them; a descriptor whose section is unknown falls
		// into the first declared section so nothing is silently dropped.
		let tmpSectionList = Array.isArray(tmpManifest.Sections) ? tmpManifest.Sections : [];
		let tmpSectionOrder = tmpSectionList.map((pSection) => String(pSection.Hash || ''));
		let tmpSectionName = {};
		tmpSectionList.forEach((pSection) => { tmpSectionName[String(pSection.Hash || '')] = String(pSection.Name || ''); });

		let tmpBuckets = {};
		tmpKeys.forEach((pKey, pIndex) =>
		{
			let tmpDescriptor = tmpDescriptors[pKey] || {};
			let tmpForm = tmpDescriptor.PictForm || {};
			let tmpSection = String(tmpForm.Section || '');
			if (tmpSectionOrder.indexOf(tmpSection) < 0) { tmpSection = tmpSectionOrder[0] || ''; }
			if (!tmpBuckets[tmpSection]) { tmpBuckets[tmpSection] = []; }
			tmpBuckets[tmpSection].push({ Key: pKey, Descriptor: tmpDescriptor, Form: tmpForm, Row: Number(tmpForm.Row) || 0, Seq: pIndex });
		});

		let tmpToRender = tmpSectionOrder.length ? tmpSectionOrder.slice() : Object.keys(tmpBuckets);
		Object.keys(tmpBuckets).forEach((pSection) => { if (tmpToRender.indexOf(pSection) < 0) { tmpToRender.push(pSection); } });

		return tmpToRender.map((pSection) =>
		{
			let tmpFields = tmpBuckets[pSection];
			if (!tmpFields || !tmpFields.length) { return ''; }
			tmpFields.sort((pA, pB) => (pA.Row - pB.Row) || (pA.Seq - pB.Seq));
			let tmpName = tmpSectionName[pSection] || '';
			// The panel header already names a single section, so only label a section when there is more than one.
			let tmpHeading = (tmpName && tmpToRender.length > 1) ? ('<div class="prj-meta-section">' + this._esc(tmpName) + '</div>') : '';
			return tmpHeading + '<div class="prj-meta-grid">' + tmpFields.map((pField) => this._metaFieldHTML(pField)).join('') + '</div>';
		}).join('');
	}

	_metaFieldHTML(pField)
	{
		let tmpKey = pField.Key;
		let tmpDescriptor = pField.Descriptor || {};
		let tmpForm = pField.Form || {};
		let tmpDomID = 'ProjectMeta-' + this._slug(tmpKey);
		let tmpWidth = Math.max(1, Math.min(12, Number(tmpForm.Width) || 12));
		let tmpLabel = this._esc(tmpDescriptor.Name || tmpKey);
		let tmpHint = tmpDescriptor.Description ? ('<div class="prj-meta-hint">' + this._esc(tmpDescriptor.Description) + '</div>') : '';
		let tmpValue = this._metaValue(tmpKey);
		let tmpInputType = String(tmpForm.InputType || '').toLowerCase();
		let tmpDataType = String(tmpDescriptor.DataType || '').toLowerCase();
		let tmpControl = '';
		if (tmpInputType === 'textarea')
		{
			let tmpRows = Math.max(2, Math.min(40, Number(tmpForm.TextAreaRows) || 4));
			tmpControl = '<textarea id="' + tmpDomID + '" class="prj-input prj-meta-input" rows="' + tmpRows + '">' + this._esc(this._asText(tmpValue)) + '</textarea>';
		}
		else if (tmpInputType === 'select' || tmpInputType === 'dropdown')
		{
			tmpControl = '<select id="' + tmpDomID + '" class="prj-input prj-meta-input">' + this._metaOptionsHTML(tmpForm, tmpValue) + '</select>';
		}
		else if (tmpInputType === 'checkbox' || tmpDataType === 'boolean')
		{
			tmpControl = '<input type="checkbox" id="' + tmpDomID + '" class="prj-meta-check"' + (this._asBool(tmpValue) ? ' checked' : '') + ' />';
		}
		else if (tmpInputType === 'number' || tmpDataType === 'number' || tmpDataType === 'integer')
		{
			tmpControl = '<input type="number" id="' + tmpDomID + '" class="prj-input prj-meta-input" value="' + this._esc(this._asText(tmpValue)) + '" />';
		}
		else
		{
			let tmpHTMLType = (tmpInputType === 'date') ? 'date' : ((tmpInputType === 'email') ? 'email' : 'text');
			tmpControl = '<input type="' + tmpHTMLType + '" id="' + tmpDomID + '" class="prj-input prj-meta-input" value="' + this._esc(this._asText(tmpValue)) + '" />';
		}
		// Width is a clamped integer, never user text, so it is safe inline; the grid is 12 columns.
		return '<div class="prj-meta-field" style="grid-column: span ' + tmpWidth + ';">'
			+ '<label class="prj-meta-label" for="' + tmpDomID + '">' + tmpLabel + '</label>'
			+ tmpControl + tmpHint + '</div>';
	}

	_metaOptionsHTML(pForm, pValue)
	{
		let tmpOptions = Array.isArray(pForm.Options) ? pForm.Options : [];
		let tmpCurrent = this._asText(pValue);
		let fValueOf = (pOption) => (pOption && typeof pOption === 'object')
			? this._asText(pOption.Value !== undefined ? pOption.Value : (pOption.Id !== undefined ? pOption.Id : pOption.Hash))
			: this._asText(pOption);
		let fLabelOf = (pOption) => (pOption && typeof pOption === 'object')
			? this._asText(pOption.Label !== undefined ? pOption.Label : (pOption.Text !== undefined ? pOption.Text : fValueOf(pOption)))
			: this._asText(pOption);
		return '<option value=""' + (tmpCurrent === '' ? ' selected' : '') + '></option>'
			+ tmpOptions.map((pOption) =>
			{
				let tmpVal = fValueOf(pOption);
				return '<option value="' + this._esc(tmpVal) + '"' + (tmpVal === tmpCurrent ? ' selected' : '') + '>' + this._esc(fLabelOf(pOption)) + '</option>';
			}).join('');
	}

	// Collect the rendered fields back into the MetadataJSON blob and save it on the Project. Start from the
	// stored blob so keys the manifest does not mention are preserved, overlay each descriptor's value by its
	// path, then persist. A legacy reserved-role 'Instructions' source is retired once its text lives in the
	// blob, so there is one source of truth and it stops riding the corpus as a redundant item.
	async saveMetadata()
	{
		if (!this._project) { return; }
		let tmpStateEl = (typeof document !== 'undefined') ? document.getElementById('Project-Meta-State') : null;
		if (tmpStateEl) { tmpStateEl.textContent = 'Saving...'; }
		let tmpMerged = {};
		try { let tmpParsed = JSON.parse(this._project.MetadataJSON || 'null'); if (tmpParsed && typeof tmpParsed === 'object') { tmpMerged = tmpParsed; } } catch (pIgnore) { tmpMerged = {}; }
		let tmpDescriptors = (this._metaManifest && this._metaManifest.Descriptors && typeof this._metaManifest.Descriptors === 'object') ? this._metaManifest.Descriptors : {};
		Object.keys(tmpDescriptors).forEach((pKey) =>
		{
			let tmpDescriptor = tmpDescriptors[pKey] || {};
			let tmpForm = tmpDescriptor.PictForm || {};
			let tmpEl = (typeof document !== 'undefined') ? document.getElementById('ProjectMeta-' + this._slug(pKey)) : null;
			if (!tmpEl) { return; }
			let tmpInputType = String(tmpForm.InputType || '').toLowerCase();
			let tmpDataType = String(tmpDescriptor.DataType || '').toLowerCase();
			let tmpValue;
			if (tmpInputType === 'checkbox' || tmpDataType === 'boolean') { tmpValue = !!tmpEl.checked; }
			else if (tmpInputType === 'number' || tmpDataType === 'number' || tmpDataType === 'integer')
			{
				let tmpRaw = String(tmpEl.value || '').trim();
				tmpValue = (tmpRaw === '') ? null : Number(tmpRaw);
				if (tmpValue !== null && !isFinite(tmpValue)) { tmpValue = null; }
			}
			else { tmpValue = String(tmpEl.value || ''); }
			this._setPath(tmpMerged, pKey, tmpValue);
		});
		let tmpJSON = JSON.stringify(tmpMerged);
		try { await this._retryWrite(() => this._projectAPI().update(Number(this._project.IDProject) || 0, { MetadataJSON: tmpJSON })); }
		catch (pError) { if (tmpStateEl) { tmpStateEl.textContent = ''; } this._toast('Could not save metadata: ' + this._writeErr(pError), 'error'); return; }
		this._project.MetadataJSON = tmpJSON;
		this._metadata = tmpMerged;
		if (this._instructionsSource && Number(this._instructionsSource.IDProjectSource) > 0 && typeof tmpMerged.Instructions === 'string' && tmpMerged.Instructions.length)
		{
			let tmpLegacyID = Number(this._instructionsSource.IDProjectSource);
			this._instructionsSource = null;
			try { await this._sourceAPI().remove(tmpLegacyID); } catch (pIgnore) { /* best-effort: the blob already wins at dispatch time */ }
		}
		if (tmpStateEl) { tmpStateEl.textContent = 'Saved'; }
	}

	// ---- work item inputs ----------------------------------------------------------------------------------
	// Inputs are the work items linked to this project (a ProjectWorkItemJoin with RelationType 'Input'),
	// surfaced through the generic Connections endpoint. The dispatch hydrates each one's title, status and
	// description into the run envelope, so they are inputs in substance, not in name only.
	_extractInputs(pConnections)
	{
		let tmpGroups = (pConnections && Array.isArray(pConnections.Groups)) ? pConnections.Groups : [];
		let tmpGroup = tmpGroups.filter((pGroup) => String(pGroup.Type || '') === 'workiteminputs')[0];
		return (tmpGroup && Array.isArray(tmpGroup.Items)) ? tmpGroup.Items : [];
	}

	_inputsHTML()
	{
		let tmpItems = Array.isArray(this._workItemInputs) ? this._workItemInputs : [];
		let tmpRows = tmpItems.map((pItem) =>
		{
			let tmpID = Number(pItem.ID) || 0;
			return ''
				+ '<div class="prj-src"><span class="prj-role">input</span>'
				+ '<button class="prj-src-name prj-src-link" onclick="_Pict.views[\'Plansheet-Project\'].openWorkItem(' + tmpID + ')">' + this._esc(pItem.Title || ('Work item #' + tmpID)) + '</button>'
				+ '<button class="prj-src-del" title="Remove" aria-label="Remove" onclick="_Pict.views[\'Plansheet-Project\'].removeInput(' + tmpID + ')">' + _TRASH_SVG + '</button>'
				+ '</div>';
		}).join('');
		return (tmpRows || '<div class="prj-empty-sm">No work items linked as inputs yet.</div>')
			+ '<div class="prj-add">'
			+ '<select id="Project-InputPick" class="prj-input prj-input-pick" onmousedown="_Pict.views[\'Plansheet-Project\'].loadInputCandidates()">' + this._inputOptionsHTML() + '</select>'
			+ '<button class="prj-btn prj-btn-ghost" onclick="_Pict.views[\'Plansheet-Project\'].addInput()">Add input</button>'
			+ '</div>';
	}

	_inputOptionsHTML()
	{
		let tmpList = Array.isArray(this._inputCandidates) ? this._inputCandidates : [];
		let tmpLead = this._inputCandidates ? 'Add a work item as input...' : 'Click to load work items...';
		return '<option value="">' + tmpLead + '</option>'
			+ tmpList.map((pCandidate) =>
			{
				let tmpID = Number(pCandidate.ID) || 0;
				let tmpNumber = Number(pCandidate.Number) ? ('#' + pCandidate.Number + ' ') : '';
				return '<option value="' + tmpID + '">' + this._esc(tmpNumber + (pCandidate.Title || ('Work item ' + tmpID))) + '</option>';
			}).join('');
	}

	// Fetch the candidate work items the first time the picker is opened (the list can be large, so it is not
	// pulled on every detail load). The candidates endpoint already excludes the ones already linked.
	async loadInputCandidates()
	{
		if (!this._project || this._inputCandidates || !this._connectionsAPI()) { return; }
		let tmpCandidates = [];
		try { tmpCandidates = await this._connectionsAPI().candidates('Project', Number(this._project.IDProject) || 0, 'workiteminputs'); } catch (pError) { tmpCandidates = []; }
		this._inputCandidates = Array.isArray(tmpCandidates) ? tmpCandidates : [];
		let tmpSel = (typeof document !== 'undefined') ? document.getElementById('Project-InputPick') : null;
		if (tmpSel) { tmpSel.innerHTML = this._inputOptionsHTML(); }
	}

	async addInput()
	{
		if (!this._project || !this._connectionsAPI()) { return; }
		let tmpSel = (typeof document !== 'undefined') ? document.getElementById('Project-InputPick') : null;
		let tmpID = tmpSel ? (Number(tmpSel.value) || 0) : 0;
		if (!tmpID) { this._toast('Pick a work item to add first.', 'error'); return; }
		let tmpResult = await this._connectionsAPI().link('Project', Number(this._project.IDProject) || 0, 'workiteminputs', tmpID);
		if (!tmpResult || !tmpResult.Success) { this._toast('Could not add that input.', 'error'); return; }
		this._inputCandidates = null; // the linkable set changed; re-fetch on next open
		await this._reloadInputs();
	}

	async removeInput(pIDWorkItem)
	{
		let tmpID = Number(pIDWorkItem) || 0;
		if (!tmpID || !this._project || !this._connectionsAPI()) { return; }
		let tmpResult = await this._connectionsAPI().unlink('Project', Number(this._project.IDProject) || 0, 'workiteminputs', tmpID);
		if (!tmpResult || !tmpResult.Success) { this._toast('Could not remove that input.', 'error'); return; }
		this._inputCandidates = null;
		await this._reloadInputs();
	}

	async _reloadInputs()
	{
		if (!this._project || !this._connectionsAPI()) { return; }
		let tmpConnections = null;
		try { tmpConnections = await this._connectionsAPI().get('Project', Number(this._project.IDProject) || 0); } catch (pError) { tmpConnections = null; }
		if (tmpConnections) { this._workItemInputs = this._extractInputs(tmpConnections); }
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById('Project-Inputs') : null;
		if (tmpEl) { tmpEl.innerHTML = this._inputsHTML(); }
	}

	openWorkItem(pIDWorkItem)
	{
		let tmpID = Number(pIDWorkItem) || 0;
		if (!tmpID) { return; }
		let tmpRouter = this._router();
		if (tmpRouter && typeof tmpRouter.navigate === 'function') { tmpRouter.navigate('/work-item/' + tmpID); }
	}

	// Upload each chosen file to the Media buffer as TEAM media (so a node persona can read it), then record a
	// ProjectSource pointing at it, with the role the person typed. Each stage retries once; if the corpus
	// create still will not take, the orphaned bytes are dropped so the buffer does not silently fill.
	async attachFiles(pInputEl)
	{
		if (!this._project || !pInputEl || !pInputEl.files || !pInputEl.files.length) { return; }
		let tmpRoleEl = (typeof document !== 'undefined') ? document.getElementById('Project-FileRole') : null;
		let tmpRole = tmpRoleEl ? (String(tmpRoleEl.value || '').trim() || 'Reference') : 'Reference';
		let tmpFiles = Array.prototype.slice.call(pInputEl.files);
		let tmpIDProject = Number(this._project.IDProject) || 0;
		pInputEl.value = '';
		for (let i = 0; i < tmpFiles.length; i++)
		{
			let tmpFile = tmpFiles[i];
			let tmpIDMedia = 0;
			try { tmpIDMedia = await this._retryWrite(() => this._mediaAPI().upload('Project', tmpIDProject, tmpFile, {}).then((pMedia) => Number(pMedia && (pMedia.IDMedia || pMedia.ID)) || 0)); }
			catch (pError) { this._toast('Upload failed for ' + tmpFile.name + ': ' + this._writeErr(pError), 'error'); continue; }
			if (!tmpIDMedia) { this._toast('Upload failed for ' + tmpFile.name + ' (no media id returned).', 'error'); continue; }
			try { await this._retryWrite(() => this._sourceAPI().create({ IDProject: tmpIDProject, Role: tmpRole, IDMedia: tmpIDMedia, Name: String(tmpFile.name || 'file') })); }
			catch (pError)
			{
				try { await this._mediaAPI().remove(tmpIDMedia); } catch (pIgnore) { /* best-effort: do not strand uploaded bytes */ }
				this._toast('Could not add ' + tmpFile.name + ' to the corpus: ' + this._writeErr(pError), 'error');
			}
		}
		await this._reloadCorpus();
	}

	async addData()
	{
		if (!this._project) { return; }
		let tmpRoleEl = (typeof document !== 'undefined') ? document.getElementById('Project-DataRole') : null;
		let tmpNameEl = (typeof document !== 'undefined') ? document.getElementById('Project-DataName') : null;
		let tmpJSONEl = (typeof document !== 'undefined') ? document.getElementById('Project-DataJSON') : null;
		let tmpRole = tmpRoleEl ? (String(tmpRoleEl.value || '').trim() || 'Data') : 'Data';
		let tmpName = tmpNameEl ? String(tmpNameEl.value || '').trim() : '';
		let tmpJSON = tmpJSONEl ? String(tmpJSONEl.value || '').trim() : '';
		if (!tmpJSON) { this._toast('Paste some JSON data first.', 'error'); return; }
		try
		{
			await this._sourceAPI().create({ IDProject: Number(this._project.IDProject) || 0, Role: tmpRole, ContentJSON: tmpJSON, Name: tmpName || 'data' });
		}
		catch (pError) { this._toast((pError && pError.message) || 'Could not add that data.', 'error'); return; }
		await this._reloadCorpus();
	}

	async removeSource(pIDProjectSource)
	{
		let tmpID = Number(pIDProjectSource) || 0;
		if (!tmpID) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpOk = true;
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			try { tmpOk = await tmpModal.confirm('Remove this source from the corpus?', { dangerous: true }); }
			catch (pError) { tmpOk = false; }
		}
		if (!tmpOk) { return; }
		try { await this._sourceAPI().remove(tmpID); }
		catch (pError) { this._toast((pError && pError.message) || 'Could not remove it.', 'error'); return; }
		await this._reloadCorpus();
	}

	// ---- actions that leave for the Ask area / blueprint ---------------------------------------------------
	async runTask(pIDTask)
	{
		if (!this._project || this._busy) { return; }
		this._busy = true;
		let tmpResult = null;
		try { tmpResult = await this._askAPI().submitRequest(Number(pIDTask) || 0, {}, '', [], Number(this._project.IDProject) || 0); }
		catch (pError) { this._busy = false; this._toast((pError && pError.message) || 'Could not start that task.', 'error'); return; }
		this._busy = false;
		let tmpIDRequest = Number(tmpResult && tmpResult.IDRequest) || 0;
		if (!tmpIDRequest) { this._toast('Could not open the run.', 'error'); return; }
		let tmpApp = this._app();
		if (tmpApp && typeof tmpApp.showAskRequest === 'function') { tmpApp.showAskRequest(tmpIDRequest); }
	}

	openRequest(pIDRequest)
	{
		let tmpApp = this._app();
		if (tmpApp && typeof tmpApp.showAskRequest === 'function') { tmpApp.showAskRequest(Number(pIDRequest) || 0); }
	}

	openBlueprint()
	{
		if (!this._project || !(Number(this._project.IDBlueprint) > 0)) { return; }
		let tmpRouter = this._router();
		if (tmpRouter && typeof tmpRouter.navigate === 'function') { tmpRouter.navigate('/blueprint/' + (Number(this._project.IDBlueprint) || 0)); }
	}

	backToList() { this._goList(); }

	// ---- navigation helpers (route through the app so Back / reload / deep-link behave) --------------------
	_goList() { let tmpApp = this._app(); if (tmpApp && typeof tmpApp.showProjects === 'function') { tmpApp.showProjects(); } else { this.showList(); } }
	_goDetail(pID) { let tmpApp = this._app(); if (tmpApp && typeof tmpApp.showProject === 'function') { tmpApp.showProject(Number(pID) || 0); } else { this.showDetail(pID); } }
}

const PictViewProjectConfiguration =
{
	ViewIdentifier: 'Plansheet-Project',
	DefaultRenderable: 'Plansheet-Project',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.prj-wrap { max-width: 900px; margin: 0 auto; padding: 24px 16px 64px; }
		.prj-head-top h1 { margin: 0 0 4px; font-size: 1.6em; color: var(--theme-color-text-primary, #1d2230); }
		.prj-sub { margin: 0 0 20px; color: var(--theme-color-text-secondary, #5b6376); }
		.prj-loading, .prj-empty { color: var(--theme-color-text-secondary, #5b6376); padding: 24px 0; }
		.prj-empty-sm { color: var(--theme-color-text-secondary, #5b6376); font-size: 0.9em; padding: 6px 0; }
		.prj-group-head { font-size: 0.8em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 10px; }
		.prj-new { margin-bottom: 22px; }
		.prj-new-row { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
		.prj-input { padding: 9px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-secondary, #f3f5f9); color: var(--theme-color-text-primary, #1d2230); font: inherit; box-sizing: border-box; }
		#Project-NewName { flex: 1 1 260px; }
		.prj-input-kind { width: 110px; }
		.prj-input-role { width: 130px; }
		.prj-data-json { flex: 1 1 240px; resize: vertical; }
		.prj-meta-grid { display: grid; grid-template-columns: repeat(12, 1fr); gap: 12px 14px; align-items: start; }
		.prj-meta-section { grid-column: 1 / -1; font-size: 0.82em; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); margin: 2px 0; }
		.prj-meta-field { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
		.prj-meta-label { font-size: 0.85em; font-weight: 600; color: var(--theme-color-text-primary, #1d2230); }
		.prj-meta-input { display: block; width: 100%; resize: vertical; line-height: 1.5; }
		.prj-meta-check { width: 18px; height: 18px; }
		.prj-meta-hint { font-size: 0.8em; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.4; }
		.prj-input-pick { flex: 1 1 260px; }
		.prj-src-link { color: var(--theme-color-brand-primary, #3b6fd4); border: none; background: none; cursor: pointer; font: inherit; padding: 0; text-align: left; }
		@media (max-width: 640px) { .prj-meta-field { grid-column: 1 / -1 !important; } }
		.prj-btn { padding: 9px 18px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 8px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; cursor: pointer; font-size: 0.95em; }
		.prj-btn-ghost { background: none; color: var(--theme-color-brand-primary, #3b6fd4); }
		.prj-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 12px; }
		.prj-card { text-align: left; cursor: pointer; padding: 14px 16px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 10px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); }
		.prj-card:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.prj-card-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
		.prj-card-name { font-weight: 600; }
		.prj-card-kind { font-size: 0.78em; color: var(--theme-color-text-secondary, #5b6376); margin-top: 4px; text-transform: uppercase; letter-spacing: 0.03em; }
		.prj-card-sum { font-size: 0.88em; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.4; margin-top: 4px; }
		.prj-back { background: none; border: none; color: var(--theme-color-brand-primary, #3b6fd4); cursor: pointer; padding: 0; font-size: 0.9em; margin-bottom: 12px; }
		.prj-head { display: flex; align-items: center; gap: 10px; }
		.prj-title { margin: 0; font-size: 1.35em; color: var(--theme-color-text-primary, #1d2230); }
		.prj-kind-chip { font-size: 0.72em; text-transform: uppercase; letter-spacing: 0.04em; padding: 2px 9px; border-radius: 999px; background: var(--theme-color-background-secondary, #f3f5f9); border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6376); }
		.prj-sum { color: var(--theme-color-text-secondary, #5b6376); margin: 8px 0 0; line-height: 1.5; }
		.prj-panel { margin-top: 24px; border-top: 1px solid var(--theme-color-border-default, #d8dde6); padding-top: 16px; }
		.prj-src { display: flex; align-items: center; gap: 10px; padding: 7px 10px; border-radius: 8px; }
		.prj-src:hover { background: var(--theme-color-background-hover, #f3f5f9); }
		.prj-role { font-size: 0.72em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 2px 9px; border-radius: 999px; background: var(--theme-color-background-secondary, #f3f5f9); border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6376); }
		.prj-src-name { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary, #1d2230); }
		.prj-src-kind { font-size: 0.74em; color: var(--theme-color-text-secondary, #5b6376); }
		.prj-src-del { border: none; background: none; cursor: pointer; color: var(--theme-color-text-secondary, #5b6376); padding: 2px; display: inline-flex; }
		.prj-src-del:hover { color: var(--theme-color-status-error, #c0353a); }
		.prj-src-del svg { width: 15px; height: 15px; }
		.prj-add { display: flex; gap: 8px; flex-wrap: wrap; align-items: flex-start; margin-top: 10px; }
		.prj-file { display: none; }
		.prj-tasks { display: flex; gap: 8px; flex-wrap: wrap; }
		.prj-hint { font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); margin-top: 8px; }
		.prj-reqs { display: flex; flex-direction: column; gap: 2px; }
		.prj-req { display: flex; align-items: center; justify-content: space-between; gap: 10px; width: 100%; text-align: left; cursor: pointer; padding: 9px 12px; border: none; border-radius: 8px; background: none; color: var(--theme-color-text-primary, #1d2230); font: inherit; }
		.prj-req:hover { background: var(--theme-color-background-hover, #f3f5f9); }
		.prj-req-name { font-size: 0.92em; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prj-out { display: flex; gap: 10px; padding: 5px 0; align-items: baseline; }
		.prj-out-key { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); min-width: 120px; }
		.prj-out-val { color: var(--theme-color-text-secondary, #5b6376); word-break: break-word; }
		.prj-out-link { color: var(--theme-color-brand-primary, #3b6fd4); }
		.prj-pill { display: inline-block; font-size: 0.62em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; padding: 2px 9px; border-radius: 11px; background: #9e9e9e; color: #fff; }
		.prj-pill-draft { background: #9e9e9e; }
		.prj-pill-inprogress, .prj-pill-blueprintready { background: #F6C453; color: #3a2f00; }
		.prj-pill-configready { background: #3b6fd4; }
		.prj-pill-delivered { background: #2E7D32; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-Project',
			Template: /*html*/`
<div class="prj-wrap">
	<div class="prj-head-top">
		<h1>Projects</h1>
		<p class="prj-sub">Build a form, a sticker, or anything from a cluster of files and the tasks you run against it.</p>
	</div>
	<div id="Project-Body"></div>
</div>`
		}
	],
	Renderables:
	[
		{ RenderableHash: 'Plansheet-Project', TemplateHash: 'Plansheet-Project', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

module.exports = PictViewProject;
module.exports.default_configuration = PictViewProjectConfiguration;

},{"../providers/FrameworkClient.js":576,"pict-view":365}],688:[function(require,module,exports){
'use strict';

/**
 * PictView-ProjectTypes: manage a tenant's Project types (V54 / F163). A Project type is the reusable shape a
 * Project of a Kind takes -- its metadata form, held as an external, versioned MetadataManifest. Types are not
 * hand-authored here: a person describes one (and uploads reference files) and a node designs the form across a
 * conversation, previewing it, until the person consents and the node commits it (POST /1.0/ProjectType/Commit,
 * behind the RunStep consent gate). This screen is the catalog and the launch point for that loop.
 *
 * Two routes: /project-types (the catalog) and /project-type/:id (one type, its form, and an Adjust launcher);
 * the body repaints into #ProjectTypes-Body so a change does not re-render the shell.
 *
 * Create and Adjust both open a lightweight authoring Project (Kind 'project-type-authoring'): the description
 * and the uploaded files become its corpus, so they ride the Project dispatch envelope the node already reads
 * (the corpus-inlining path), rather than per-turn attachments the node cannot fetch. The authoring Project is
 * the workspace; the committed artifact is a ProjectType, which shows back up in this catalog.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');

// The reserved Kind of the throwaway Project that hosts a type-authoring conversation, and the corpus role
// that carries the "adjust this existing type" target for the node to read.
const _AUTHORING_KIND = 'project-type-authoring';
const _ADJUST_ROLE = 'AdjustTarget';

class PictViewProjectTypes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._types = [];
		this._type = null;
		this._manifest = null;
		this._manifestSource = null;
		this._busy = false;
	}

	_typeAPI() { return this.pict.providers.ProjectTypeAPI; }
	_projectAPI() { return this.pict.providers.ProjectAPI; }
	_sourceAPI() { return this.pict.providers.ProjectSourceAPI; }
	_app() { return this.pict.PictApplication; }

	_esc(pValue)
	{
		return String(pValue === null || typeof pValue === 'undefined' ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	_body() { return (typeof document !== 'undefined') ? document.getElementById('ProjectTypes-Body') : null; }
	_paint(pHTML) { let tmpBody = this._body(); if (tmpBody) { tmpBody.innerHTML = pHTML; } }
	_ensureShell() { if (!this._body()) { this.render(); } }

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && tmpModal.toast) { tmpModal.toast(pMessage, { type: pType || 'success' }); }
	}

	_pill(pStatus)
	{
		let tmpStatus = String(pStatus || 'Draft');
		let tmpSlug = tmpStatus.toLowerCase().replace(/[^a-z0-9]/g, '');
		return '<span class="pt-pill pt-pill-' + tmpSlug + '">' + this._esc(tmpStatus) + '</span>';
	}

	show() { return this.showList(); }

	// ---- the catalog (route /project-types) ----------------------------------------------------------------
	showList()
	{
		this._ensureShell();
		this._enterList();
		return true;
	}

	async _enterList()
	{
		this._type = null;
		this._paint('<div class="pt-loading">Loading project types...</div>');
		let tmpTypes = [];
		try { tmpTypes = await this._typeAPI().resolve({ PageSize: 200 }); }
		catch (pError) { /* a transient failure paints an empty catalog rather than a blank pane */ }
		this._types = (Array.isArray(tmpTypes) ? tmpTypes : [])
			.sort((pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || '')));
		this._paintList();
	}

	_paintList()
	{
		let tmpCards = this._types.map((pType) => ''
			+ '<button class="pt-card" onclick="_Pict.views[\'Plansheet-ProjectTypes\'].openType(' + (Number(pType.IDProjectType) || 0) + ')">'
			+ '<div class="pt-card-head"><span class="pt-card-name">' + this._esc(pType.Name || pType.TypeKey || 'Untitled type') + '</span>' + this._pill(pType.Status) + '</div>'
			+ (pType.TypeKey ? ('<div class="pt-card-key">' + this._esc(pType.TypeKey) + '</div>') : '')
			+ (pType.Description ? ('<div class="pt-card-sum">' + this._esc(pType.Description) + '</div>') : '')
			+ '</button>').join('');
		this._paint(''
			+ '<div class="pt-new">'
			+ '<div class="pt-group-head">Create a project type</div>'
			+ '<p class="pt-new-hint">Describe the type you want and, in the workspace that opens, attach any example files. The assistant designs the form, shows you a preview, and takes your feedback until you approve it.</p>'
			+ '<div class="pt-new-row">'
			+ '<input type="text" id="ProjectType-NewName" class="pt-input" placeholder="What is this type? (e.g. Vendor Invoice)" />'
			+ '<button class="pt-btn" onclick="_Pict.views[\'Plansheet-ProjectTypes\'].createType()">Start</button>'
			+ '</div></div>'
			+ (tmpCards ? ('<div class="pt-cards">' + tmpCards + '</div>') : '<div class="pt-empty">No project types yet. Describe one above to design its form with the assistant.</div>'));
	}

	async createType()
	{
		if (this._busy) { return; }
		let tmpNameEl = (typeof document !== 'undefined') ? document.getElementById('ProjectType-NewName') : null;
		let tmpName = tmpNameEl ? String(tmpNameEl.value || '').trim() : '';
		if (!tmpName) { this._toast('Say what the type is first.', 'error'); return; }
		this._busy = true;
		let tmpProject = null;
		try
		{
			tmpProject = await this._projectAPI().create(
				{ Name: tmpName, Kind: _AUTHORING_KIND, Status: 'Draft', Summary: 'Designing the "' + tmpName + '" project type.' });
		}
		catch (pError) { this._busy = false; this._toast((pError && pError.message) || 'Could not start the type.', 'error'); return; }
		this._busy = false;
		let tmpID = Number(tmpProject && tmpProject.IDProject) || 0;
		// The authoring conversation lives in the Project workspace (corpus upload + the Create Project Type
		// task). Hand off to it; the committed type returns to this catalog.
		if (tmpID && this._app() && typeof this._app().showProject === 'function') { this._app().showProject(tmpID); }
		else { this._enterList(); }
	}

	// ---- one type (route /project-type/:id) ----------------------------------------------------------------
	openType(pID) { let tmpApp = this._app(); if (tmpApp && typeof tmpApp.showProjectType === 'function') { tmpApp.showProjectType(Number(pID) || 0); } else { this.showDetail(pID); } }

	async showDetail(pID)
	{
		this._ensureShell();
		let tmpID = Number(pID) || 0;
		this._paint('<div class="pt-loading">Loading...</div>');
		let tmpType = null;
		try { tmpType = await this._typeAPI().read(tmpID); }
		catch (pError) { tmpType = null; }
		if (!tmpType) { return this.showList(); }
		this._type = tmpType;
		this._manifest = null;
		this._manifestSource = null;
		let tmpKey = String(tmpType.TypeKey || '');
		if (tmpKey)
		{
			try
			{
				let tmpResolved = await libFrameworkClient.getJSON(this.pict, '/1.0/MetadataManifest/Resolve/Project/' + encodeURIComponent(tmpKey));
				if (tmpResolved && tmpResolved.Manifest) { this._manifest = tmpResolved.Manifest; this._manifestSource = tmpResolved.Source || null; }
			}
			catch (pError) { /* the form summary is best-effort; the type still renders without it */ }
		}
		this._paintDetail();
	}

	_paintDetail()
	{
		let tmpType = this._type || {};
		let tmpManifest = this._manifest || {};
		let tmpDescriptors = (tmpManifest && typeof tmpManifest.Descriptors === 'object') ? tmpManifest.Descriptors : {};
		let tmpSections = Array.isArray(tmpManifest.Sections) ? tmpManifest.Sections : [];
		let tmpFieldKeys = Object.keys(tmpDescriptors);

		let tmpFieldRows = tmpFieldKeys.map((pKey) =>
		{
			let tmpDescriptor = tmpDescriptors[pKey] || {};
			let tmpForm = tmpDescriptor.PictForm || {};
			return '<div class="pt-field"><span class="pt-field-name">' + this._esc(tmpDescriptor.Name || pKey) + '</span>'
				+ '<span class="pt-field-meta">' + this._esc(tmpForm.InputType || 'Text') + (tmpForm.Section ? (' &middot; ' + this._esc(tmpForm.Section)) : '') + '</span></div>';
		}).join('');

		let tmpVersionNote = this._manifestSource
			? ('Form version ' + (Number(this._manifestSource.Version) || 0) + (this._manifestSource.Default ? ' (built-in default)' : ''))
			: 'No form resolved yet';

		this._paint(''
			+ '<button class="pt-back" onclick="_Pict.views[\'Plansheet-ProjectTypes\'].backToList()">&larr; All project types</button>'
			+ '<div class="pt-head"><h2 class="pt-title">' + this._esc(tmpType.Name || tmpType.TypeKey || 'Project type') + '</h2>'
			+ (tmpType.TypeKey ? ('<span class="pt-key-chip">' + this._esc(tmpType.TypeKey) + '</span>') : '') + this._pill(tmpType.Status) + '</div>'
			+ (tmpType.Description ? ('<p class="pt-sum">' + this._esc(tmpType.Description) + '</p>') : '')
			+ '<div class="pt-panel">'
			+ '<div class="pt-group-head">The form</div>'
			+ '<div class="pt-form-meta">' + this._esc(tmpVersionNote) + ' &middot; ' + tmpFieldKeys.length + ' field' + (tmpFieldKeys.length === 1 ? '' : 's') + ' in ' + tmpSections.length + ' section' + (tmpSections.length === 1 ? '' : 's') + '</div>'
			+ (tmpFieldRows ? ('<div class="pt-fields">' + tmpFieldRows + '</div>') : '<div class="pt-empty-sm">This type has no fields yet.</div>')
			+ '</div>'
			+ '<div class="pt-panel">'
			+ '<div class="pt-group-head">Adjust this type</div>'
			+ '<p class="pt-new-hint">Describe a change (add a field, rename a section, change a widget). The assistant revises the form, previews it, and publishes a new version once you approve -- existing projects keep the version they were saved against.</p>'
			+ '<button class="pt-btn" onclick="_Pict.views[\'Plansheet-ProjectTypes\'].adjustType()">Adjust with the assistant</button>'
			+ '</div>');
	}

	backToList() { let tmpApp = this._app(); if (tmpApp && typeof tmpApp.showProjectTypes === 'function') { tmpApp.showProjectTypes(); } else { this.showList(); } }

	async adjustType()
	{
		if (this._busy || !this._type) { return; }
		this._busy = true;
		let tmpType = this._type;
		let tmpProject = null;
		try
		{
			tmpProject = await this._projectAPI().create(
				{ Name: 'Adjust: ' + (tmpType.Name || tmpType.TypeKey || 'type'), Kind: _AUTHORING_KIND, Status: 'Draft', Summary: 'Adjusting the "' + (tmpType.Name || tmpType.TypeKey) + '" project type.' });
		}
		catch (pError) { this._busy = false; this._toast((pError && pError.message) || 'Could not start the adjustment.', 'error'); return; }

		// Carry the target type and its current form into the authoring corpus as inline Data, so the node's
		// adjust recipe knows which type it is revising and starts from the shape it already has.
		let tmpIDProject = Number(tmpProject && tmpProject.IDProject) || 0;
		if (tmpIDProject)
		{
			let tmpTarget = { IDProjectType: Number(tmpType.IDProjectType) || 0, TypeKey: tmpType.TypeKey || '', Name: tmpType.Name || '', CurrentManifest: this._manifest || null };
			try
			{
				await this._sourceAPI().create(
					{ IDProject: tmpIDProject, Role: _ADJUST_ROLE, Name: 'Adjustment target', ContentJSON: JSON.stringify(tmpTarget), SortOrder: 0 });
			}
			catch (pError) { /* best-effort: the workspace still opens; the node can be told the target in chat */ }
		}
		this._busy = false;
		if (tmpIDProject && this._app() && typeof this._app().showProject === 'function') { this._app().showProject(tmpIDProject); }
	}
}

const PictViewProjectTypesConfiguration =
{
	ViewIdentifier: 'Plansheet-ProjectTypes',
	DefaultRenderable: 'Plansheet-ProjectTypes',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.pt-wrap { max-width: 900px; margin: 0 auto; padding: 24px 16px 64px; }
		.pt-head-top h1 { margin: 0 0 4px; font-size: 1.6em; color: var(--theme-color-text-primary, #1d2230); }
		.pt-sub { margin: 0 0 20px; color: var(--theme-color-text-secondary, #5b6376); }
		.pt-loading, .pt-empty { color: var(--theme-color-text-secondary, #5b6376); padding: 24px 0; }
		.pt-empty-sm { color: var(--theme-color-text-secondary, #5b6376); font-size: 0.9em; padding: 6px 0; }
		.pt-group-head { font-size: 0.8em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 10px; }
		.pt-new { margin-bottom: 22px; }
		.pt-new-hint { font-size: 0.9em; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.5; margin: 0 0 10px; }
		.pt-new-row { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
		.pt-input { padding: 9px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-secondary, #f3f5f9); color: var(--theme-color-text-primary, #1d2230); font: inherit; box-sizing: border-box; flex: 1 1 280px; }
		.pt-btn { padding: 9px 18px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 8px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; cursor: pointer; font-size: 0.95em; }
		.pt-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 12px; }
		.pt-card { text-align: left; cursor: pointer; padding: 14px 16px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 10px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); }
		.pt-card:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.pt-card-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
		.pt-card-name { font-weight: 600; }
		.pt-card-key { font-size: 0.78em; color: var(--theme-color-text-secondary, #5b6376); margin-top: 4px; font-family: ui-monospace, Menlo, Consolas, monospace; }
		.pt-card-sum { font-size: 0.88em; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.4; margin-top: 4px; }
		.pt-back { background: none; border: none; color: var(--theme-color-brand-primary, #3b6fd4); cursor: pointer; padding: 0; font-size: 0.9em; margin-bottom: 12px; }
		.pt-head { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
		.pt-title { margin: 0; font-size: 1.35em; color: var(--theme-color-text-primary, #1d2230); }
		.pt-key-chip { font-size: 0.72em; letter-spacing: 0.02em; padding: 2px 9px; border-radius: 999px; background: var(--theme-color-background-secondary, #f3f5f9); border: 1px solid var(--theme-color-border-default, #d8dde6); color: var(--theme-color-text-secondary, #5b6376); font-family: ui-monospace, Menlo, Consolas, monospace; }
		.pt-sum { color: var(--theme-color-text-secondary, #5b6376); margin: 8px 0 0; line-height: 1.5; }
		.pt-panel { margin-top: 24px; border-top: 1px solid var(--theme-color-border-default, #d8dde6); padding-top: 16px; }
		.pt-form-meta { font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 10px; }
		.pt-fields { display: flex; flex-direction: column; gap: 2px; }
		.pt-field { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; padding: 7px 10px; border-radius: 8px; }
		.pt-field:hover { background: var(--theme-color-background-hover, #f3f5f9); }
		.pt-field-name { color: var(--theme-color-text-primary, #1d2230); }
		.pt-field-meta { font-size: 0.78em; color: var(--theme-color-text-secondary, #5b6376); }
		.pt-pill { display: inline-block; font-size: 0.62em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; padding: 2px 9px; border-radius: 11px; background: #9e9e9e; color: #fff; }
		.pt-pill-draft { background: #9e9e9e; }
		.pt-pill-active { background: #2E7D32; }
		.pt-pill-retired { background: #c0353a; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-ProjectTypes',
			Template: /*html*/`
<div class="pt-wrap">
	<div class="pt-head-top">
		<h1>Project Types</h1>
		<p class="pt-sub">Reusable project shapes your team can start from. Describe one and the assistant designs its form with you.</p>
	</div>
	<div id="ProjectTypes-Body"></div>
</div>`
		}
	],
	Renderables:
	[
		{ RenderableHash: 'Plansheet-ProjectTypes', TemplateHash: 'Plansheet-ProjectTypes', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

module.exports = PictViewProjectTypes;
module.exports.default_configuration = PictViewProjectTypesConfiguration;

},{"../providers/FrameworkClient.js":576,"pict-view":365}],689:[function(require,module,exports){
'use strict';

/**
 * The attached-prompts panel: mounted under a Work Item detail or a Test Run,
 * it lists the prompts attached to that entity (each frozen at the version it
 * was attached as), lets content editors attach one from the libraries, paste
 * and attach an external prompt in one move, record a run in place (a Test
 * Run's panel ties the run to the Test Run), and detach.
 *
 * This is the visible end of the refinement cycle: attach a prompt to the
 * work, run it, capture the outcome, refine in the library, re-attach.
 *
 * One instance serves every host (only one detail page is visible at a time);
 * hosts call showFor(ownerType, idOwner, containerID) from onAfterRender.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libFocus = require('../FocusFilters.js');
const libDescriptors = require('../EntityDescriptors.js');
const libPromptEmbed = require('../PromptEmbed.js');

function _escapeHTML(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _shortDate(pDate)
{
	if (!pDate) { return ''; }
	let tmpStamp = Date.parse(pDate);
	if (isNaN(tmpStamp)) { return String(pDate); }
	return new Date(tmpStamp).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

const _ViewConfiguration =
{
	ViewIdentifier: 'Plansheet-PromptAttachments',
	DefaultRenderable: 'Plansheet-PromptAttachments',
	DefaultDestinationAddress: '#Entity-Prompts',
	AutoRender: false,

	CSS: /*css*/`
		.ppa-row { display: flex; align-items: center; gap: 9px; flex-wrap: wrap; background: rgba(8,14,24,0.34); border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 8px; padding: 9px 12px; margin-bottom: 8px; }
		.ppa-title { font-weight: 600; font-size: 13.5px; color: var(--cnx-txt, #eef2f7); }
		.ppa-meta { font-size: 11.5px; color: var(--cnx-lbl, #9aabc0); }
		.ppa-badge { font-family: ui-monospace, Menlo, monospace; font-size: 10px; letter-spacing: 1px; text-transform: uppercase; padding: 1px 7px; border-radius: 6px; border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); color: var(--cnx-lbl, #9aabc0); white-space: nowrap; }
		.ppa-btn { border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); background: rgba(8,14,24,0.4); color: var(--cnx-txt, #eef2f7); border-radius: 7px; padding: 3px 11px; font-size: 12px; cursor: pointer; white-space: nowrap; }
		.ppa-btn:hover { border-color: #f0c44a; color: #f0c44a; }
		.ppa-actions { display: flex; gap: 8px; margin-top: 10px; }
		.ppa-empty { color: var(--cnx-lbl, #9aabc0); font-size: 12.5px; padding: 4px 2px; }
		.ppa-spacer { flex: 1; }
		.ppa-run { display: flex; align-items: center; gap: 9px; margin: -3px 0 10px 0; padding: 6px 12px; background: rgba(8,14,24,0.22); border: 1px dashed var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 8px; }
		.ppa-run-text { flex: 1; font-family: ui-monospace, Menlo, monospace; font-size: 11.5px; color: var(--cnx-txt, #eef2f7); white-space: pre-wrap; word-break: break-word; }
		/* The "bundle other work items" picker in the Generate dialog (#236): a filterable,
		   multi-select mini list view in place of the old flat, database-ordered dropdown. It sits
		   inside a standard modal, so it is themed with the app --theme-color-* vars (light + dark). */
		.ppa-pick-search { width: 100%; margin-bottom: 8px; }
		.ppa-pick-chiprow { display: flex; flex-wrap: wrap; gap: 6px; margin: 0 0 8px; }
		.ppa-pick-chip { border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); border-radius: 999px; padding: 2px 11px; font-size: 11.5px; cursor: pointer; }
		.ppa-pick-chip:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.ppa-pick-chip.on { background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff); border-color: transparent; }
		.ppa-pick-scroll { max-height: 42vh; overflow: auto; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; }
		.ppa-pick-table { width: 100%; border-collapse: collapse; font-size: 12.5px; }
		.ppa-pick-table th { position: sticky; top: 0; z-index: 1; background: var(--theme-color-background-panel, #fff); text-align: left; padding: 6px 10px; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); border-bottom: 1px solid var(--theme-color-border-default, #e6e9ee); }
		.ppa-pick-table td { padding: 6px 10px; border-bottom: 1px solid var(--theme-color-border-default, #eef1f6); color: var(--theme-color-text-primary, #2c3140); white-space: nowrap; }
		.ppa-pick-table tr:last-child td { border-bottom: none; }
		.ppa-pick-row { cursor: pointer; }
		.ppa-pick-row:hover td { background: var(--theme-color-background-hover, #eaf2ff); }
		.ppa-pick-row.on td { background: var(--theme-color-background-secondary, #eef1f6); }
		.ppa-pick-title { white-space: normal; min-width: 15rem; }
		.ppa-pick-type { text-align: center; }
		.ppa-pick-type svg { width: 16px; height: 16px; vertical-align: middle; color: var(--theme-color-text-secondary, #5b6376); }
		.ppa-pick-num, .ppa-pick-status, .ppa-pick-upd { color: var(--theme-color-text-secondary, #5b6376); }
		.ppa-pick-cb { width: 1px; }
		.ppa-pick-empty { text-align: center; color: var(--theme-color-text-secondary, #5b6376); padding: 16px; }
		.ppa-pick-count { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); padding: 6px 4px 0; }
		.ppa-pick-selected { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
	`,

	Templates: [{ Hash: 'Plansheet-PromptAttachments', Template: /*html*/`<div></div>` }],
	Renderables:
	[
		{ RenderableHash: 'Plansheet-PromptAttachments', TemplateHash: 'Plansheet-PromptAttachments', ContentDestinationAddress: '#Entity-Prompts', RenderMethod: 'replace' }
	]
};

class PictViewPromptAttachments extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._ownerType = null;
		this._idOwner = 0;
		this._ownerNumber = 0;
		this._containerID = null;
		this._links = [];
		this._embeds = [];
		// When set, _paint mounts that prompt's embed expanded (so Generate ends with it open, no modal).
		this._expandIDPrompt = 0;
	}

	_api() { return this.pict.providers.PromptAPI; }
	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_canEdit()
	{
		let tmpApp = this.pict.PictApplication;
		return !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
	}

	showFor(pOwnerType, pIDOwner, pContainerID, pOwnerNumber)
	{
		this._ownerType = pOwnerType;
		this._idOwner = pIDOwner;
		this._ownerNumber = Number(pOwnerNumber) || 0;
		this._containerID = pContainerID;
		this.reload();
	}

	// This plan sheet's addressable Code (its MCP handle), carried on the boot session record.
	_customerCode()
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || null;
		return (tmpUser && tmpUser.CustomerCode) ? String(tmpUser.CustomerCode) : '';
	}

	// The owner's human number, from what showFor was handed, or resolved from the WorkItem
	// provider cache the detail page loaded (mount timing can leave the passed number at 0).
	_ownerNumberResolved()
	{
		if (this._ownerNumber) { return this._ownerNumber; }
		if (this._ownerType === 'WorkItem')
		{
			let tmpProvider = this.pict.providers.WorkItemAPI;
			let tmpRecord = (tmpProvider && typeof tmpProvider.store === 'function') ? tmpProvider.store().Index[this._idOwner] : null;
			if (tmpRecord && tmpRecord.WorkItemNumber) { this._ownerNumber = Number(tmpRecord.WorkItemNumber) || 0; }
		}
		return this._ownerNumber;
	}

	// The copy-paste line a person drops into a fresh Claude session to run one attached
	// prompt over the MCP. Empty unless this is a Work Item with a number and the plan sheet
	// has a Code (both are needed to address it).
	_runCommandFor(pEntry)
	{
		let tmpCode = this._customerCode();
		let tmpOwnerNumber = this._ownerNumberResolved();
		if (!tmpCode || this._ownerType !== 'WorkItem' || !tmpOwnerNumber) { return ''; }
		let tmpNum = (pEntry && pEntry.Prompt && pEntry.Prompt.PromptNumber) || 0;
		return 'Using the plansheet MCP, load the ' + tmpCode + ' plan sheet and run prompt ' + tmpNum + ' for Work Item ' + tmpOwnerNumber + '.';
	}

	reload()
	{
		if (!this._ownerType || !this._idOwner) { return Promise.resolve(); }
		return this._api().linksFor(this._ownerType, this._idOwner)
			.then((pLinks) =>
			{
				this._links = pLinks || [];
				this._paint();
				this._refreshOwnerBlueprint();
			})
			.catch(() => { this._links = []; this._paint(); });
	}

	// The Blueprint title block at the top of a Work Item's detail page shows its own "Prompts"
	// tile, loaded once by EntityDetail and otherwise only refreshed by pin/unpin. This panel's
	// reload only repaints itself (the lower connections block), so without this the top tile keeps
	// showing the stale count until the page is reloaded. Ping EntityDetail's blueprint reload when
	// it is mounted for the same Work Item.
	_refreshOwnerBlueprint()
	{
		if (this._ownerType !== 'WorkItem') { return; }
		let tmpDetail = this.pict.views['Plansheet-EntityDetail'];
		if (tmpDetail && tmpDetail._key === 'WorkItem' && tmpDetail._id === this._idOwner && typeof tmpDetail._reloadBlueprint === 'function')
		{
			tmpDetail._reloadBlueprint();
		}
	}

	_paint()
	{
		let tmpHost = this._containerID ? document.getElementById(this._containerID) : null;
		if (!tmpHost) { return; }
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		let tmpViewRef = "_Pict.views['Plansheet-PromptAttachments']";
		let tmpCanEdit = this._canEdit();

		let tmpHTML = '';
		this._links.forEach((pEntry) =>
		{
			// One reusable PromptEmbed per attached prompt (mounted after innerHTML below): it renders
			// the title/badges, an inline expand of the prompt text, Copy, the MCP run command, and
			// in-place Edit -- replacing the old read-only "Read" modal.
			let tmpLink = pEntry.Link || {};
			tmpHTML += '<div class="ppa-embed-host" id="ppa-embed-' + tmpLink.IDPromptLink + '"></div>';
		});
		if (!tmpHTML)
		{
			tmpHTML = '<div class="ppa-empty">No prompts attached. Attach one to make this work prompt-driven: run it, capture the outcome, refine, re-run.</div>';
		}
		if (tmpCanEdit)
		{
			let tmpIsWorkItem = (this._ownerType === 'WorkItem');
			tmpHTML += '<div class="ppa-actions">'
				+ (tmpIsWorkItem ? '<button class="ppa-btn" onclick="' + tmpViewRef + '.generateDialog()">Generate prompt</button>' : '')
				+ '<button class="ppa-btn" onclick="' + tmpViewRef + '.attachDialog()">Attach a prompt</button>'
				+ '<button class="ppa-btn" onclick="' + tmpViewRef + '.pasteAndAttach()">Paste external prompt and attach</button>'
				+ '</div>';
			// If a work item has prompts but the plan sheet has no Code yet, the run block cannot be
			// addressed; nudge the owner to set one.
			if (tmpIsWorkItem && this._links.length && !this._customerCode())
			{
				tmpHTML += '<div class="ppa-empty">Set a plan sheet Code in Org Settings to enable the one-line MCP run command for these prompts.</div>';
			}
		}
		tmpHost.innerHTML = tmpHTML;

		// Mount the reusable embeds now that their hosts exist. Extra header actions (Record run /
		// Detach) route back to this view; a just-generated prompt mounts expanded (no modal).
		this._embeds = [];
		this._links.forEach((pEntry) =>
		{
			let tmpLink = pEntry.Link || {};
			let tmpEmbedHost = document.getElementById('ppa-embed-' + tmpLink.IDPromptLink);
			if (!tmpEmbedHost) { return; }
			let tmpActions = [{ Key: 'run', Label: 'Record run' }];
			if (tmpCanEdit) { tmpActions.push({ Key: 'detach', Label: 'Detach', Danger: true }); }
			let tmpEmbed = new libPromptEmbed(this.pict);
			tmpEmbed.configure(pEntry,
			{
				RunCommand: this._runCommandFor(pEntry),
				Editable: tmpCanEdit,
				Expanded: (this._expandIDPrompt > 0 && Number(pEntry.Prompt && pEntry.Prompt.IDPrompt) === Number(this._expandIDPrompt)),
				Actions: tmpActions,
				OnAction: (pKey) =>
				{
					if (pKey === 'run') { this.recordRun(tmpLink.IDPrompt); }
					else if (pKey === 'detach') { this.detach(tmpLink.IDPromptLink); }
				}
			});
			tmpEmbed.mount(tmpEmbedHost);
			this._embeds.push(tmpEmbed);
		});
		this._expandIDPrompt = 0;
	}

	viewVersion(pIDPromptLink)
	{
		let tmpEntry = this._links.find((pCandidate) => pCandidate.Link && Number(pCandidate.Link.IDPromptLink) === Number(pIDPromptLink));
		if (!tmpEntry || !tmpEntry.Version) { return; }
		let tmpPrompt = tmpEntry.Prompt || {};
		let tmpViewRef = "_Pict.views['Plansheet-PromptAttachments']";
		let tmpRunCommand = this._runCommandFor(tmpEntry);
		// The full prompt text, with one-click copies: the prompt itself, and (when addressable) the MCP
		// run command. This is where "show me the generated prompt" lands.
		let tmpContent =
			'<div style="display:flex; gap:8px; margin-bottom:8px; flex-wrap:wrap;">'
			+ '<button class="ppa-btn" onclick="' + tmpViewRef + '.copyPromptText(' + pIDPromptLink + ')">Copy prompt text</button>'
			+ (tmpRunCommand ? '<button class="ppa-btn" onclick="' + tmpViewRef + '.copyRunCommand(' + pIDPromptLink + ')">Copy MCP run command</button>' : '')
			+ '</div>'
			+ (tmpRunCommand ? '<div class="ppa-run" style="margin-bottom:10px;"><code class="ppa-run-text">' + _escapeHTML(tmpRunCommand) + '</code></div>' : '')
			+ '<pre style="max-height:52vh; overflow:auto; white-space:pre-wrap; font-size:12px;">' + _escapeHTML(tmpEntry.Version.Source || '') + '</pre>';
		this._modal().show(
		{
			title: (tmpPrompt.Title || 'Prompt') + ' (v' + tmpEntry.Version.Sequence + ' as attached)',
			content: tmpContent,
			buttons: [{ Hash: 'ok', Label: 'Close', Style: 'primary' }]
		});
	}

	// Copy the full generated prompt text (the pinned version Source) to the clipboard.
	copyPromptText(pIDPromptLink)
	{
		let tmpEntry = this._links.find((pCandidate) => pCandidate.Link && Number(pCandidate.Link.IDPromptLink) === Number(pIDPromptLink));
		let tmpText = (tmpEntry && tmpEntry.Version && tmpEntry.Version.Source) ? tmpEntry.Version.Source : '';
		if (!tmpText) { return; }
		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(tmpText).then(() => this._toast('Prompt text copied.', 'success')).catch(() => this._toast('Copy failed.', 'error'));
		}
	}

	recordRun(pIDPrompt)
	{
		let tmpEntry = this._links.find((pCandidate) => pCandidate.Link && Number(pCandidate.Link.IDPrompt) === Number(pIDPrompt));
		let tmpTitle = (tmpEntry && tmpEntry.Prompt && tmpEntry.Prompt.Title) || 'prompt';
		let tmpIsTestRun = (this._ownerType === 'TestRun');
		this._modal().show(
		{
			title: 'Record a run of "' + tmpTitle + '"',
			content:
				'<p style="font-size:13px;">' + (tmpIsTestRun ? 'The run is tied to this test run.' : 'How did it go?') + '</p>'
				+ '<label style="font-size:12px;">Outcome</label>'
				+ '<select id="PPA-Run-Outcome" class="pict-input" style="width:100%; margin-bottom:8px;">'
				+ '<option value="">Not rated</option><option value="Success">Success</option>'
				+ '<option value="Mixed">Mixed</option><option value="Failure">Failure</option></select>'
				+ '<label style="font-size:12px;">Notes</label>'
				+ '<textarea id="PPA-Run-Notes" class="pict-input" style="width:100%; min-height:80px;"></textarea>',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Record run', Style: 'primary' }
			]
		}).then((pChoice) =>
		{
			if (pChoice !== 'save') { return; }
			let tmpRun =
			{
				Outcome: (document.getElementById('PPA-Run-Outcome') || {}).value || '',
				Notes: (document.getElementById('PPA-Run-Notes') || {}).value || ''
			};
			if (tmpIsTestRun) { tmpRun.IDTestRun = this._idOwner; }
			this._api().recordRun(pIDPrompt, tmpRun)
				.then(() => this._toast('Run recorded; version pinned.', 'success'))
				.catch((pError) => this._toast(pError.message, 'error'));
		});
	}

	// NOT converted to the server-backed candidate search (WI #446 scope: convert the seven remaining
	// pickers from WI #434; this file was the seventh). mine()/shared() are not the store().List-page bug
	// the other six had -- neither endpoint pages at all, so every prompt in both libraries is already a
	// candidate here, not just page one. And CandidateSearch's generic mechanism does not fit: it asks
	// resolve() -> the generic Prompt CRUD route, which Prompt-Guards.js owner-scopes to the caller's own
	// rows (see that file's header) for exactly the privacy reason Prompts/Mine and Prompts/Shared exist
	// as separate custom routes -- a private prompt of someone else must never surface. Wiring this
	// picker onto CandidateSearch as-is would silently drop the Shared library from the results (only
	// Mine would come back), and building it a real fix (a searchable Mine+Shared server endpoint) is a
	// new capability, not a mechanical conversion -- out of this item's "do not redesign the search"
	// scope. Left as a precomputed Options list; flagged in WI #446 rather than half-converted.
	attachDialog()
	{
		Promise.all([this._api().mine(), this._api().shared()])
			.then((pResults) =>
			{
				let tmpMine = pResults[0] || [];
				let tmpShared = (pResults[1] || []).filter((pPrompt) =>
					!tmpMine.find((pOwn) => pOwn.IDPrompt === pPrompt.IDPrompt));
				if (!tmpMine.length && !tmpShared.length)
				{
					return this._toast('No prompts in the libraries yet. Craft one at Prompt Library first.', 'info');
				}
				let fPromptOpts = (pList, pTag) => pList.map((pPrompt) => ({ Value: String(pPrompt.IDPrompt), Text: pPrompt.Title + ' (#' + (pPrompt.PromptNumber || pPrompt.IDPrompt) + ')' + pTag }));
				let tmpPromptOptions = fPromptOpts(tmpMine, '  -  Mine').concat(fPromptOpts(tmpShared, '  -  Shared'));
				let tmpSelectedPrompt = 0;
				let tmpContent =
					// The picker's dropdown floats over the modal, anchored to its control. pict-section-picker
					// 1.8.2+ positions the fixed dropdown correctly inside a transform-centered modal, so no
					// per-modal .pps-pop override is needed (matches generateDialog).
					'<label style="font-size:12px;">Prompt</label>'
					+ '<div id="PPA-Attach-Prompt-host" style="margin-bottom:8px;"></div>'
					+ '<label style="font-size:12px;">Why this prompt here? (optional note)</label>'
					+ '<input id="PPA-Attach-Note" class="pict-input" style="width:100%;">';
				let tmpDialog = this._modal().show(
				{
					title: 'Attach a prompt (pins its current version)',
					content: tmpContent,
					buttons:
					[
						{ Hash: 'cancel', Label: 'Cancel' },
						{ Hash: 'save', Label: 'Attach', Style: 'primary' }
					]
				});
				let tmpAppP = this.pict.PictApplication;
				if (tmpAppP && typeof tmpAppP.mountPicker === 'function')
				{
					setTimeout(() => { tmpAppP.mountPicker('#PPA-Attach-Prompt-host', 'PPA-AttachPromptPicker', tmpPromptOptions, (pVal) => { tmpSelectedPrompt = Number(pVal) || 0; }, { Placeholder: 'Search prompts' }); }, 20);
				}
				return tmpDialog.then((pChoice) =>
				{
					if (pChoice !== 'save') { return; }
					let tmpIDPrompt = tmpSelectedPrompt || 0;
					let tmpNote = (document.getElementById('PPA-Attach-Note') || {}).value || '';
					if (!tmpIDPrompt) { return; }
					this._api().attach(tmpIDPrompt, this._ownerType, this._idOwner, tmpNote)
						.then(() => { this._toast('Attached.', 'success'); this.reload(); })
						.catch((pError) => this._toast(pError.message, 'error'));
				});
			})
			.catch((pError) => this._toast(pError.message, 'error'));
	}

	pasteAndAttach()
	{
		this._modal().show(
		{
			title: 'Paste an external prompt and attach it here',
			content:
				'<p style="font-size:13px;">Goes into your library as a freeform prompt with an external run recorded, then attaches here pinned at version 1.</p>'
				+ '<label style="font-size:12px;">Title</label>'
				+ '<input id="PPA-Paste-Title" class="pict-input" style="width:100%; margin-bottom:8px;">'
				+ '<label style="font-size:12px;">The prompt</label>'
				+ '<textarea id="PPA-Paste-Source" class="pict-input" style="width:100%; min-height:130px; font-family:monospace; font-size:12px;"></textarea>',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Paste and attach', Style: 'primary' }
			]
		}).then((pChoice) =>
		{
			if (pChoice !== 'save') { return; }
			let tmpTitle = ((document.getElementById('PPA-Paste-Title') || {}).value || '').trim();
			let tmpSource = (document.getElementById('PPA-Paste-Source') || {}).value || '';
			if (!tmpTitle || !tmpSource.trim()) { return this._toast('A title and the prompt text are both needed.', 'error'); }
			this._api().paste({ Title: tmpTitle, Source: tmpSource })
				.then((pBody) => this._api().attach(pBody.Prompt.IDPrompt, this._ownerType, this._idOwner, ''))
				.then(() => { this._toast('Pasted and attached.', 'success'); this.reload(); })
				.catch((pError) => this._toast(pError.message, 'error'));
		});
	}

	detach(pIDPromptLink)
	{
		this._modal().confirm('The prompt and its history stay in the library; only the attachment goes (softly).',
			{ title: 'Detach this prompt?', confirmLabel: 'Detach' })
			.then((pOk) =>
			{
				if (!pOk) { return; }
				this._api().detach(pIDPromptLink)
					.then(() => this.reload())
					.catch((pError) => this._toast(pError.message, 'error'));
			});
	}

	// Generate a prompt for this work item from a shape (pre-filled + attached server-side).
	// Reachable from the panel's "Generate prompt" button and the detail header action.
	generateDialog()
	{
		if (this._ownerType !== 'WorkItem') { return this._toast('Prompts are generated for a work item.', 'info'); }
		let tmpShapeAPI = this.pict.providers.PromptShapeAPI;
		let tmpWorkItemAPI = this.pict.providers.WorkItemAPI;
		this._genExtraIDs = [];
		this._genCandidateIndex = {};
		Promise.all(
		[
			Promise.resolve(tmpShapeAPI ? tmpShapeAPI.available() : []),
			Promise.resolve(tmpWorkItemAPI && typeof tmpWorkItemAPI.list === 'function' ? tmpWorkItemAPI.list() : [])
		]).then((pResults) =>
		{
			let tmpShapes = Array.isArray(pResults[0]) ? pResults[0] : [];
			let tmpAllItems = Array.isArray(pResults[1]) ? pResults[1] : [];
			let tmpOptions = tmpShapes.map((pShape) =>
				'<option value="' + _escapeHTML(pShape.Key) + '"' + (pShape.Key === 'software-development' ? ' selected' : '') + '>' + _escapeHTML(pShape.Name || pShape.Key) + '</option>').join('');
			if (!tmpOptions) { tmpOptions = '<option value="software-development">Software Development</option>'; }
			// Candidate work items to bundle (this tenant's items except the one we're on). Kept as
			// full rows so the picker can filter them and show metadata (#236); also indexed so the
			// selected-bundle chips can label an id without another lookup.
			this._genCandidates = tmpAllItems.filter((pWI) => Number(pWI.IDWorkItem) !== Number(this._idOwner));
			this._genCandidates.forEach((pWI) => { this._genCandidateIndex[pWI.IDWorkItem] = { Number: pWI.WorkItemNumber || pWI.IDWorkItem, Title: pWI.Title || '' }; });
			// Land the picker on the same activity lens as the Work Items list: in-flight + recent,
			// newest first -- so the items a person most likely wants to bundle are on top, not the
			// oldest in database order (the #236 complaint about this exact dropdown).
			this._genFilter = Object.assign(libFocus.emptyState(), { activity: 'related' });
			let tmpViewRef = "_Pict.views['Plansheet-PromptAttachments']";
			this._modal().show(
			{
				title: 'Generate a prompt for this work item',
				width: 'min(940px, 95vw)',
				content:
					'<p style="font-size:13px;">Creates a prompt from a shape, pre-filled from this work item and attached here. Its guidelines (coding standards, screenshots, a documentation trail) come along automatically.</p>'
					+ '<label style="font-size:12px;">Shape</label>'
					+ '<select id="PPA-Gen-Shape" class="pict-input" style="width:100%;">' + tmpOptions + '</select>'
					+ '<div style="margin-top:14px;"><label style="font-size:12px;">Also include (optional)</label>'
					+ '<div style="font-size:11.5px;color:var(--theme-color-text-secondary,#889);margin:0 0 8px;">Bundle other work items into one prompt, done in the order added. The guidelines are carried once. Filter the list, then check the ones to add.</div>'
					+ '<input id="PPA-Gen-Search" class="pict-input ppa-pick-search" placeholder="Search work items..." oninput="' + tmpViewRef + '._genSetSearch(this.value)">'
					+ '<div id="PPA-Gen-Chips" class="ppa-pick-chiprow"></div>'
					+ '<div id="PPA-Gen-Table" class="ppa-pick-scroll"></div>'
					+ '<div id="PPA-Gen-Also-chips" class="ppa-pick-selected"></div></div>',
				buttons:
				[
					{ Hash: 'cancel', Label: 'Cancel' },
					{ Hash: 'save', Label: 'Generate', Style: 'primary' }
				]
			}).then((pChoice) =>
			{
				if (pChoice !== 'save') { return; }
				let tmpTypeKey = (document.getElementById('PPA-Gen-Shape') || {}).value || 'software-development';
				let tmpExtras = (this._genExtraIDs || []).slice();
				let tmpGen = tmpExtras.length
					? this._api().generateForWorkItems([this._idOwner].concat(tmpExtras), tmpTypeKey)
					: this._api().generateForWorkItem(this._idOwner, tmpTypeKey);
				tmpGen
					.then((pBody) =>
					{
						this._toast(tmpExtras.length ? ('Combined prompt generated for ' + (tmpExtras.length + 1) + ' work items.') : 'Prompt generated.', 'success');
						let tmpIDPrompt = pBody && pBody.Prompt && pBody.Prompt.IDPrompt;
						// Refresh the panel with the new prompt mounted expanded, so "Generate" ends with the
						// prompt on the page inline (no modal).
						this._expandIDPrompt = Number(tmpIDPrompt) || 0;
						return this.reload();
					})
					.catch((pError) => this._toast(pError.message, 'error'));
			});
			// Render the filter chips + the multi-select metadata table once the dialog DOM exists.
			setTimeout(() => { this._genRenderChipsBar(); this._genRenderTable(); this._genRenderChips(); }, 20);
		}).catch((pError) => this._toast(pError.message, 'error'));
	}

	// ── the "bundle other work items" picker (a filterable, multi-select list view, #236) ──

	// The candidate rows after the picker's live filter, newest-touched first (the activity intent):
	// what a person most likely wants to bundle floats to the top, instead of database order.
	_genVisibleRows()
	{
		let tmpFilter = this._genFilter || libFocus.emptyState();
		let tmpRows = libFocus.filterRows(this._genCandidates || [], tmpFilter, { CurrentUserID: 0, Agents: {} });
		return tmpRows.slice().sort((pA, pB) =>
		{
			let tmpA = Date.parse(pA.UpdateDate || pA.CreateDate || '') || 0;
			let tmpB = Date.parse(pB.UpdateDate || pB.CreateDate || '') || 0;
			if (tmpA !== tmpB) { return tmpB - tmpA; }
			return (Number(pB.WorkItemNumber || 0) - Number(pA.WorkItemNumber || 0));
		});
	}

	_genSetSearch(pValue)
	{
		this._genFilter = this._genFilter || libFocus.emptyState();
		this._genFilter.q = pValue || '';
		this._genRenderTable();
	}

	// Toggle a status lane in the picker filter. Turning a specific lane on means the person is
	// scanning that lane on purpose, so drop the activity window (which would otherwise still hide
	// older items in it); clearing the last lane restores the activity default.
	_genToggleStatus(pKey)
	{
		this._genFilter = this._genFilter || libFocus.emptyState();
		let tmpSet = {};
		String(this._genFilter.status || '').split(',').forEach((pS) => { if (pS.trim()) { tmpSet[pS.trim()] = true; } });
		if (tmpSet[pKey]) { delete tmpSet[pKey]; } else { tmpSet[pKey] = true; }
		this._genFilter.status = Object.keys(tmpSet).join(',');
		this._genFilter.activity = this._genFilter.status ? '' : 'related';
		this._genRenderChipsBar();
		this._genRenderTable();
	}

	_genToggleActivity()
	{
		this._genFilter = this._genFilter || libFocus.emptyState();
		this._genFilter.activity = (this._genFilter.activity === 'related') ? '' : 'related';
		this._genRenderChipsBar();
		this._genRenderTable();
	}

	// The filter chip row: a "Recent & active" toggle (the activity lens) plus one toggle per board
	// lane, so a person can widen from the default to any status.
	_genRenderChipsBar()
	{
		let tmpHost = (typeof document !== 'undefined') ? document.getElementById('PPA-Gen-Chips') : null;
		if (!tmpHost) { return; }
		let tmpViewRef = "_Pict.views['Plansheet-PromptAttachments']";
		let tmpFilter = this._genFilter || {};
		let tmpStatusSet = {};
		String(tmpFilter.status || '').split(',').forEach((pS) => { if (pS.trim()) { tmpStatusSet[pS.trim()] = true; } });
		let tmpHTML = '<button class="ppa-pick-chip' + (tmpFilter.activity === 'related' ? ' on' : '') + '" onclick="' + tmpViewRef + '._genToggleActivity()">Recent &amp; active</button>';
		(libDescriptors.BoardLanes || []).forEach((pKey) =>
		{
			tmpHTML += '<button class="ppa-pick-chip' + (tmpStatusSet[pKey] ? ' on' : '') + '" onclick="' + tmpViewRef + '._genToggleStatus(\'' + pKey + '\')">' + _escapeHTML(libDescriptors.BoardLaneLabels[pKey] || pKey) + '</button>';
		});
		tmpHost.innerHTML = tmpHTML;
	}

	// The multi-select metadata table: one row per visible candidate with a checkbox, number,
	// title, a Type glyph, status, and last-touched date -- so a person can peek at what each work
	// item is before adding it. Clicking anywhere on the row toggles its selection.
	_genRenderTable()
	{
		let tmpHost = (typeof document !== 'undefined') ? document.getElementById('PPA-Gen-Table') : null;
		if (!tmpHost) { return; }
		let tmpViewRef = "_Pict.views['Plansheet-PromptAttachments']";
		let tmpRows = this._genVisibleRows();
		let tmpSelected = {};
		(this._genExtraIDs || []).forEach((pID) => { tmpSelected[pID] = true; });
		let tmpIcon = this.pict.providers && this.pict.providers.Icon;
		let tmpBody = tmpRows.map((pWI) =>
		{
			let tmpID = Number(pWI.IDWorkItem);
			let tmpOn = !!tmpSelected[tmpID];
			let tmpTypeName = pWI.Type || '';
			let tmpGlyph = (tmpIcon && libDescriptors.WorkItemTypeIcons[tmpTypeName] && typeof tmpIcon.get === 'function') ? tmpIcon.get(libDescriptors.WorkItemTypeIcons[tmpTypeName]) : '';
			let tmpStatus = libDescriptors.BoardLaneLabels[pWI.Status] || pWI.Status || '';
			return '<tr class="ppa-pick-row' + (tmpOn ? ' on' : '') + '" onclick="' + tmpViewRef + '._genToggleRow(' + tmpID + ')">'
				+ '<td class="ppa-pick-cb"><input type="checkbox" ' + (tmpOn ? 'checked' : '') + ' onclick="event.stopPropagation();' + tmpViewRef + '._genToggleRow(' + tmpID + ')"></td>'
				+ '<td class="ppa-pick-num">#' + (pWI.WorkItemNumber || tmpID) + '</td>'
				+ '<td class="ppa-pick-title">' + _escapeHTML(pWI.Title || '') + '</td>'
				+ '<td class="ppa-pick-type" title="' + _escapeHTML(tmpTypeName) + '">' + (tmpGlyph || _escapeHTML(tmpTypeName)) + '</td>'
				+ '<td class="ppa-pick-status">' + _escapeHTML(tmpStatus) + '</td>'
				+ '<td class="ppa-pick-upd">' + _escapeHTML(_shortDate(pWI.UpdateDate)) + '</td>'
				+ '</tr>';
		}).join('');
		if (!tmpBody) { tmpBody = '<tr><td colspan="6" class="ppa-pick-empty">No work items match. Adjust the search or filters.</td></tr>'; }
		let tmpSelCount = (this._genExtraIDs || []).length;
		let tmpCount = tmpRows.length + ' shown' + (tmpSelCount ? (' &middot; ' + tmpSelCount + ' selected') : '');
		tmpHost.innerHTML = '<table class="ppa-pick-table"><thead><tr><th></th><th>#</th><th>Title</th><th>Type</th><th>Status</th><th>Updated</th></tr></thead>'
			+ '<tbody>' + tmpBody + '</tbody></table>'
			+ '<div class="ppa-pick-count">' + tmpCount + '</div>';
	}

	// Toggle one work item in the bundle (deduped; order preserved as check order). Repaints the
	// table (checkbox state) and the selected-chips row.
	_genToggleRow(pID)
	{
		pID = Number(pID) || 0;
		if (!pID || pID === Number(this._idOwner)) { return; }
		if (!Array.isArray(this._genExtraIDs)) { this._genExtraIDs = []; }
		let tmpIndex = this._genExtraIDs.indexOf(pID);
		if (tmpIndex >= 0) { this._genExtraIDs.splice(tmpIndex, 1); } else { this._genExtraIDs.push(pID); }
		this._genRenderTable();
		this._genRenderChips();
	}

	_genRemoveExtra(pID)
	{
		if (!Array.isArray(this._genExtraIDs)) { return; }
		let tmpIndex = this._genExtraIDs.indexOf(Number(pID));
		if (tmpIndex >= 0) { this._genExtraIDs.splice(tmpIndex, 1); this._genRenderChips(); this._genRenderTable(); }
	}

	_genRenderChips()
	{
		let tmpHost = (typeof document !== 'undefined') ? document.getElementById('PPA-Gen-Also-chips') : null;
		if (!tmpHost) { return; }
		let tmpViewRef = "_Pict.views['Plansheet-PromptAttachments']";
		tmpHost.innerHTML = (this._genExtraIDs || []).map((pID) =>
		{
			let tmpMeta = (this._genCandidateIndex || {})[pID] || { Number: pID, Title: '' };
			let tmpLabel = '#' + tmpMeta.Number + ' ' + tmpMeta.Title;
			return '<span style="display:inline-flex;align-items:center;gap:5px;max-width:100%;background:var(--theme-color-background-secondary,#eef1f6);border-radius:999px;padding:2px 4px 2px 10px;font-size:12px;">'
				+ '<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + _escapeHTML(tmpLabel) + '</span>'
				+ '<button class="ppa-btn" style="border:none;background:none;cursor:pointer;padding:0 4px;font-size:14px;line-height:1;" onclick="' + tmpViewRef + '._genRemoveExtra(' + pID + ')">&times;</button></span>';
		}).join('');
	}

	// Copy the one-line MCP run command for one attached prompt to the clipboard.
	copyRunCommand(pIDPromptLink)
	{
		let tmpEntry = this._links.find((pCandidate) => pCandidate.Link && Number(pCandidate.Link.IDPromptLink) === Number(pIDPromptLink));
		let tmpText = tmpEntry ? this._runCommandFor(tmpEntry) : '';
		if (!tmpText) { return; }
		let fDone = () => this._toast('Run command copied.', 'success');
		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(tmpText).then(fDone).catch(() => this._toast(tmpText, 'info'));
		}
		else { this._toast(tmpText, 'info'); }
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this._modal();
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'info' }); }
	}
}

module.exports = PictViewPromptAttachments;
module.exports.default_configuration = _ViewConfiguration;

},{"../EntityDescriptors.js":555,"../FocusFilters.js":558,"../PromptEmbed.js":569,"pict-view":365}],690:[function(require,module,exports){
'use strict';

/**
 * The Prompt Library page (/prompts), three tabs:
 *
 *   My Library      The pict-section-prompteditor section, REST-backed through
 *                   PlansheetPromptProvider, fed the merged shape cascade
 *                   (platform defaults shadowed by org adoptions, plus the
 *                   caller's own shapes). A toolbar above it drives the
 *                   refinement cycle for the selected prompt: record a run,
 *                   post to the shared library, view history, and paste in a
 *                   freeform prompt that was built and run outside plansheet.
 *
 *   Shared Library  What teammates have posted (posting is gated on at least
 *                   one recorded run). Read a prompt, its versions and runs,
 *                   discuss it (comments attach via OwnerType 'Prompt'),
 *                   record a run of it, or fork it into your own library.
 *
 *   My Shapes       The user end of the shape cascade (Plansheet-PromptShapes
 *                   in User scope): fork org shapes or author personal ones.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libMarkdownRender = require('./MarkdownRender.js');

function _escapeHTML(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _shortDate(pDate)
{
	if (!pDate) { return ''; }
	let tmpStamp = Date.parse(pDate);
	if (isNaN(tmpStamp)) { return String(pDate); }
	return new Date(tmpStamp).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

const _TABS =
[
	{ Key: 'library', Label: 'My Library' },
	{ Key: 'shared', Label: 'Shared Library' },
	{ Key: 'shapes', Label: 'My Shapes' }
];

const _ViewConfiguration =
{
	ViewIdentifier: 'Plansheet-PromptLibrary',
	DefaultRenderable: 'Plansheet-PromptLibrary',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,

	CSS: /*css*/`
		.ppl { display: flex; flex-direction: column; height: 100%; padding: 12px 16px; box-sizing: border-box; }
		.ppl-tabs { flex-shrink: 0; display: flex; gap: 4px; border-bottom: 1px solid var(--theme-color-border-light, #e3e3e3); margin-bottom: 10px; }
		.ppl-tab { padding: 7px 14px; border: none; background: transparent; cursor: pointer; font-size: 14px; color: var(--theme-color-text-secondary, #667); border-bottom: 2px solid transparent; }
		.ppl-tab:hover { color: var(--theme-color-text-primary, #222); }
		.ppl-tab-active { color: var(--theme-color-brand-primary, #2e7d74); border-bottom-color: var(--theme-color-brand-primary, #2e7d74); font-weight: 600; }
		.ppl-content { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: auto; }
		.ppl-pane { flex: 1; min-height: 0; display: flex; flex-direction: column; }
		.ppl-toolbar { flex-shrink: 0; display: flex; gap: 8px; align-items: center; padding: 0 0 10px 0; flex-wrap: wrap; }
		.ppl-toolbar-note { font-size: 12px; color: var(--theme-color-text-secondary, #889); }
		.ppl-btn { border: 1px solid var(--theme-color-border-light, #ccc); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #223); border-radius: 6px; padding: 5px 12px; font-size: 12.5px; cursor: pointer; white-space: nowrap; }
		.ppl-btn:hover { border-color: var(--theme-color-brand-primary, #2e7d74); color: var(--theme-color-brand-primary, #2e7d74); }
		.ppl-btn-primary { background: var(--theme-color-brand-primary, #2e7d74); border-color: var(--theme-color-brand-primary, #2e7d74); color: var(--theme-color-text-on-brand, #fff); }
		.ppl-btn-primary:hover { color: var(--theme-color-text-on-brand, #fff); opacity: 0.92; }
		.ppl-editor-host { flex: 1; min-height: 0; }
		.ppl-shared { display: flex; gap: 16px; min-height: 0; flex: 1; }
		.ppl-shared-list { width: 330px; flex-shrink: 0; overflow: auto; display: flex; flex-direction: column; gap: 8px; }
		.ppl-card { border: 1px solid var(--theme-color-border-light, #e3e3e3); border-radius: 8px; padding: 10px 12px; cursor: pointer; background: var(--theme-color-background-primary, transparent); text-align: left; color: var(--theme-color-text-primary, #223); font-family: inherit; }
		.ppl-card:hover { border-color: var(--theme-color-brand-primary, #2e7d74); }
		.ppl-card-active { border-color: var(--theme-color-brand-primary, #2e7d74); box-shadow: 0 0 0 1px var(--theme-color-brand-primary, #2e7d74) inset; }
		.ppl-card-title { font-weight: 600; font-size: 14px; margin-bottom: 3px; color: var(--theme-color-text-primary, #1d2230); }
		.ppl-card-meta { font-size: 11.5px; color: var(--theme-color-text-secondary, #778); display: flex; gap: 8px; flex-wrap: wrap; }
		.ppl-badge { font-size: 10.5px; padding: 1px 7px; border-radius: 8px; border: 1px solid var(--theme-color-border-light, #ccc); color: var(--theme-color-text-secondary, #667); }
		.ppl-shared-detail { flex: 1; min-width: 0; overflow: auto; border: 1px solid var(--theme-color-border-light, #e3e3e3); border-radius: 8px; padding: 14px 16px; }
		.ppl-detail-head { display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; margin-bottom: 4px; }
		.ppl-detail-head h3 { margin: 0; font-size: 17px; }
		.ppl-detail-actions { display: flex; gap: 8px; margin: 10px 0 14px 0; flex-wrap: wrap; }
		.ppl-source { border: 1px solid var(--theme-color-border-light, #eee); border-radius: 7px; padding: 12px 14px; margin-bottom: 14px; }
		.ppl-subhead { font-size: 13px; font-weight: 600; color: var(--theme-color-text-secondary, #667); margin: 14px 0 6px 0; }
		.ppl-history-row { font-size: 12.5px; padding: 5px 2px; border-bottom: 1px solid var(--theme-color-border-light, #eee); display: flex; gap: 8px; align-items: baseline; flex-wrap: wrap; }
		.ppl-history-row:last-child { border-bottom: none; }
		.ppl-empty { color: var(--theme-color-text-secondary, #889); font-size: 13px; padding: 14px 6px; }
		.ppl-comments { margin-top: 16px; }
	`,

	Templates:
	[
		{
			Hash: 'Plansheet-PromptLibrary',
			Template: /*html*/`
<div class="ppl">
	<h2 class="ps-page-h">Prompt Library</h2>
	<div class="ppl-tabs">{~TS:Plansheet-PromptLibrary-Tab:AppData.PromptLibrary.Tabs~}</div>
	<div class="ppl-content">
		{~TS:Plansheet-PromptLibrary-Pane-Library:AppData.PromptLibrary.LibrarySlot~}
		{~TS:Plansheet-PromptLibrary-Pane-Shared:AppData.PromptLibrary.SharedSlot~}
		{~TS:Plansheet-PromptLibrary-Pane-Shapes:AppData.PromptLibrary.ShapesSlot~}
	</div>
</div>`
		},
		{ Hash: 'Plansheet-PromptLibrary-Tab', Template: /*html*/`<button class="ppl-tab {~D:Record.ActiveClass~}" onclick="_Pict.views['Plansheet-PromptLibrary'].showTab('{~D:Record.Key~}')">{~D:Record.Label~}</button>` },
		{
			Hash: 'Plansheet-PromptLibrary-Pane-Library',
			Template: /*html*/`
<div class="ppl-pane">
	<div class="ppl-toolbar">
		<button class="ppl-btn" onclick="_Pict.views['Plansheet-PromptLibrary'].recordRunForActive()">Record run</button>
		<button class="ppl-btn" onclick="_Pict.views['Plansheet-PromptLibrary'].postActive()">Post to shared library</button>
		<button class="ppl-btn" onclick="_Pict.views['Plansheet-PromptLibrary'].historyForActive()">History</button>
		<button class="ppl-btn ppl-btn-primary" onclick="_Pict.views['Plansheet-PromptLibrary'].pasteExternal()">Paste a prompt I ran elsewhere</button>
		<span class="ppl-toolbar-note">Runs, posts, and attachments pin the version they happened against.</span>
	</div>
	<div class="ppl-editor-host" id="PromptLibrary-Editor-Container"></div>
</div>`
		},
		{
			Hash: 'Plansheet-PromptLibrary-Pane-Shared',
			Template: /*html*/`
<div class="ppl-pane ppl-shared">
	<div class="ppl-shared-list" id="PromptLibrary-Shared-List"></div>
	<div class="ppl-shared-detail" id="PromptLibrary-Shared-Detail"></div>
</div>`
		},
		{ Hash: 'Plansheet-PromptLibrary-Pane-Shapes', Template: /*html*/`<div class="ppl-pane" id="PromptLibrary-Shapes-Container"></div>` }
	],

	Renderables:
	[
		{ RenderableHash: 'Plansheet-PromptLibrary', TemplateHash: 'Plansheet-PromptLibrary', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

class PictViewPromptLibrary extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		// The tab a route asked for, consumed by show() once its data is in.
		this._pendingTab = '';
		if (!this.pict.AppData.PromptLibrary)
		{
			this.pict.AppData.PromptLibrary =
			{
				ActiveTab: 'library',
				Tabs: [],
				LibrarySlot: [],
				SharedSlot: [],
				ShapesSlot: [],
				Shapes: [],
				Shared: [],
				SelectedShared: null,
				SelectedVersions: [],
				SelectedRuns: []
			};
		}
	}

	_state() { return this.pict.AppData.PromptLibrary; }
	_api() { return this.pict.providers.PromptAPI; }
	_shapeAPI() { return this.pict.providers.PromptShapeAPI; }
	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_editor() { return this.pict.views['Plansheet-PromptEditor']; }
	_me() { return (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {}; }

	/** Enter the page: refresh the shape cascade, then land on the last tab. */
	show()
	{
		// The /prompts route is the clean library (no shared prompt open); a specific shared prompt is its
		// own route (/prompt/:id -> showSharedPrompt), so clear any prior selection here.
		this._state().SelectedShared = null;
		// Authors resolve from the roster (shared cards, run history).
		if (this.pict.providers.TeamAPI && typeof this.pict.providers.TeamAPI.roster === 'function')
		{
			this.pict.providers.TeamAPI.roster().catch(() => { });
		}
		this._shapeAPI().available()
			.then((pShapes) =>
			{
				let tmpState = this._state();
				tmpState.Shapes = pShapes || [];
				this._applyShapesToEditor();
				// The _apply* form: show() is what the route handler already called, so navigating here
				// would send the router round again.
				let tmpWanted = this._pendingTab || tmpState.ActiveTab || 'library';
				this._pendingTab = '';
				this._applyShowTab(tmpWanted);
			})
			.catch(() => { let tmpWanted = this._pendingTab || 'library'; this._pendingTab = ''; this._applyShowTab(tmpWanted); });
	}

	_applyShapesToEditor()
	{
		let tmpState = this._state();
		let tmpDefinitions = (tmpState.Shapes || []).map((pShape) => pShape.Definition).filter(Boolean);
		let tmpEditor = this._editor();
		if (tmpEditor)
		{
			if (tmpDefinitions.length)
			{
				if (typeof tmpEditor.setPromptTypes === 'function') { tmpEditor.setPromptTypes(tmpDefinitions); }
				else { tmpEditor.options.PromptTypes = tmpDefinitions; }
			}
			let tmpMe = this._me();
			tmpEditor.options.CurrentUser = { Key: tmpMe.IDUser || 0, Name: tmpMe.DisplayName || tmpMe.Email || 'Me' };
			if (tmpEditor.options.DataProvider && typeof tmpEditor.options.DataProvider.setPromptTypes === 'function')
			{
				tmpEditor.options.DataProvider.setPromptTypes(tmpDefinitions);
			}
		}
	}

	/**
	 * Switch tabs. NAVIGATES; the route handler renders.
	 *
	 * The three tabs are three different pages: your own library and its editor, the shared library
	 * with its own list and detail, and your shapes. Only /prompt/:id (a shared prompt) could be
	 * linked; which TAB you were on could not, so a reload always dropped you back on the library.
	 */
	showTab(pTab)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showPromptsTab === 'function' && tmpApp.showPromptsTab(pTab)) { return; }
		return this._applyShowTab(pTab);
	}

	// Enter on a named tab from the /prompts/:tab route.
	showTabRoute(pTab)
	{
		this._pendingTab = _TABS.some((pTabDef) => pTabDef.Key === pTab) ? pTab : 'library';
		return this.show();
	}

	_applyShowTab(pTab)
	{
		let tmpState = this._state();
		tmpState.ActiveTab = pTab;
		tmpState.Tabs = _TABS.map((pTabDef) => ({ Key: pTabDef.Key, Label: pTabDef.Label, ActiveClass: (pTabDef.Key === pTab) ? 'ppl-tab-active' : '' }));
		tmpState.LibrarySlot = (pTab === 'library') ? [{}] : [];
		tmpState.SharedSlot = (pTab === 'shared') ? [{}] : [];
		tmpState.ShapesSlot = (pTab === 'shapes') ? [{}] : [];
		this.render();
		this._renderActive(pTab);
	}

	_renderActive(pTab)
	{
		if (pTab === 'library')
		{
			let tmpEditor = this._editor();
			if (!tmpEditor) { return; }
			// Re-pull the shape cascade on every entry to the library so a shape just authored in the
			// Shapes tab shows up in the type dropdown without a full page reload, then load the editor.
			this._shapeAPI().available()
				.then((pShapes) =>
				{
					this._state().Shapes = pShapes || this._state().Shapes || [];
					this._applyShapesToEditor();
					tmpEditor.load();
				})
				.catch(() => tmpEditor.load());
		}
		else if (pTab === 'shared')
		{
			this._loadShared();
		}
		else if (pTab === 'shapes')
		{
			let tmpShapesView = this.pict.views['Plansheet-PromptShapes'];
			if (tmpShapesView) { tmpShapesView.showIn('#PromptLibrary-Shapes-Container', 'User'); }
		}
	}

	// ---- the active prompt in the editor (the refinement cycle drivers) -------

	_activePrompt()
	{
		let tmpEditor = this._editor();
		let tmpKey = tmpEditor && tmpEditor._ui && tmpEditor._ui.ActivePromptKey;
		if (!tmpKey) { return null; }
		let tmpPrompt = (tmpEditor._loaded && tmpEditor._loaded.Prompts || []).find((pCandidate) => pCandidate.Key === tmpKey) || null;
		if (!tmpPrompt) { return null; }
		let tmpServer = (tmpPrompt.Meta && tmpPrompt.Meta._Plansheet) || {};
		if (!tmpServer.IDPrompt) { return null; }
		return { Prompt: tmpPrompt, IDPrompt: tmpServer.IDPrompt, Server: tmpServer };
	}

	_requireActive()
	{
		let tmpActive = this._activePrompt();
		if (!tmpActive) { this._toast('Select a prompt in the editor first.', 'info'); }
		return tmpActive;
	}

	recordRunForActive()
	{
		let tmpActive = this._requireActive();
		if (!tmpActive) { return; }
		this._recordRunDialog(tmpActive.IDPrompt, tmpActive.Prompt.Title);
	}

	_recordRunDialog(pIDPrompt, pTitle, fAfter)
	{
		this._modal().show(
		{
			title: 'Record a run of "' + pTitle + '"',
			content:
				'<p style="font-size:13px;">Where did it run, and how did it go? This pins the current version into history.</p>'
				+ '<label style="font-size:12px;">Outcome</label>'
				+ '<select id="PPL-Run-Outcome" class="pict-input" style="width:100%; margin-bottom:8px;">'
				+ '<option value="">Not rated</option><option value="Success">Success</option>'
				+ '<option value="Mixed">Mixed</option><option value="Failure">Failure</option></select>'
				+ '<label style="font-size:12px;">Notes (what happened, what to change next time)</label>'
				+ '<textarea id="PPL-Run-Notes" class="pict-input" style="width:100%; min-height:90px;"></textarea>'
				+ '<label style="font-size:12px; margin-top:6px; display:inline-flex; gap:6px; align-items:center;">'
				+ '<input type="checkbox" id="PPL-Run-External"> It ran outside plansheet</label>',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Record run', Style: 'primary' }
			]
		}).then((pChoice) =>
		{
			if (pChoice !== 'save') { return; }
			let tmpOutcome = (document.getElementById('PPL-Run-Outcome') || {}).value || '';
			let tmpNotes = (document.getElementById('PPL-Run-Notes') || {}).value || '';
			let tmpExternal = !!((document.getElementById('PPL-Run-External') || {}).checked);
			this._api().recordRun(pIDPrompt, { Outcome: tmpOutcome, Notes: tmpNotes, RunContext: tmpExternal ? 'External' : 'Manual' })
				.then(() =>
				{
					this._toast('Run recorded; version pinned.', 'success');
					if (typeof fAfter === 'function') { fAfter(); }
				})
				.catch((pError) => this._toast(pError.message, 'error'));
		});
	}

	postActive()
	{
		let tmpActive = this._requireActive();
		if (!tmpActive) { return; }
		if (tmpActive.Server.Visibility === 'Shared')
		{
			return this._toast('Already in the shared library.', 'info');
		}
		this._modal().confirm('Posting shares this prompt (and its pinned version history) with everyone in the organization. It needs at least one recorded run first.',
			{ title: 'Post "' + tmpActive.Prompt.Title + '" to the shared library?', confirmLabel: 'Post' })
			.then((pOk) =>
			{
				if (!pOk) { return; }
				this._api().post(tmpActive.IDPrompt)
					.then(() =>
					{
						this._toast('Posted to the shared library.', 'success');
						let tmpEditor = this._editor();
						if (tmpEditor) { tmpEditor.refresh(); }
					})
					.catch((pError) => this._toast(pError.message, 'error'));
			});
	}

	historyForActive()
	{
		let tmpActive = this._requireActive();
		if (!tmpActive) { return; }
		this.showHistory(tmpActive.IDPrompt, tmpActive.Prompt.Title);
	}

	showHistory(pIDPrompt, pTitle)
	{
		Promise.all([this._api().versions(pIDPrompt), this._api().runs(pIDPrompt)])
			.then((pResults) =>
			{
				let tmpVersions = pResults[0].Versions || [];
				let tmpRuns = pResults[1].Runs || [];
				let tmpHTML = '<div style="max-height:55vh; overflow:auto;">';
				tmpHTML += '<div style="font-weight:600; font-size:13px; margin-bottom:5px;">Versions</div>';
				tmpHTML += tmpVersions.length ? '' : '<p style="font-size:12.5px;">None captured yet; versions appear as the prompt is edited.</p>';
				tmpVersions.forEach((pVersion) =>
				{
					tmpHTML += '<div style="border-bottom:1px solid #ddd; padding:6px 0; font-size:12.5px;">'
						+ '<strong>v' + pVersion.Sequence + '</strong>'
						+ (pVersion.Pinned ? ' <span style="font-size:11px; opacity:0.8;">(pinned)</span>' : '')
						+ ' <span style="opacity:0.75;">' + _escapeHTML(pVersion.Note || '') + ' - ' + _escapeHTML(_shortDate(pVersion.UpdateDate || pVersion.CreateDate)) + '</span>'
						+ ' <button class="ppl-btn" style="float:right;" onclick="_Pict.views[\'Plansheet-PromptLibrary\'].showVersionSource(' + pVersion.IDPromptVersion + ', ' + pIDPrompt + ')">View</button>'
						+ '</div>';
				});
				tmpHTML += '<div style="font-weight:600; font-size:13px; margin:12px 0 5px 0;">Runs</div>';
				tmpHTML += tmpRuns.length ? '' : '<p style="font-size:12.5px;">No runs recorded yet.</p>';
				tmpRuns.forEach((pRun) =>
				{
					tmpHTML += '<div style="border-bottom:1px solid #ddd; padding:6px 0; font-size:12.5px;">'
						+ '<strong>' + _escapeHTML(pRun.RunContext || 'Manual') + '</strong>'
						+ (pRun.Outcome ? ' <span class="ppl-badge">' + _escapeHTML(pRun.Outcome) + '</span>' : '')
						+ ' <span style="opacity:0.75;">' + _escapeHTML(_shortDate(pRun.CreateDate)) + '</span>'
						+ (pRun.Notes ? '<div style="margin-top:2px;">' + _escapeHTML(pRun.Notes) + '</div>' : '')
						+ '</div>';
				});
				tmpHTML += '</div>';
				this._modal().show(
				{
					title: 'History: ' + pTitle,
					content: tmpHTML,
					buttons: [{ Hash: 'ok', Label: 'Close', Style: 'primary' }]
				});
			})
			.catch((pError) => this._toast(pError.message, 'error'));
	}

	showVersionSource(pIDPromptVersion, pIDPrompt)
	{
		this._api().versions(pIDPrompt).then((pBody) =>
		{
			let tmpVersion = (pBody.Versions || []).find((pCandidate) => Number(pCandidate.IDPromptVersion) === Number(pIDPromptVersion));
			if (!tmpVersion) { return; }
			this._modal().show(
			{
				title: 'v' + tmpVersion.Sequence + (tmpVersion.Note ? (' - ' + tmpVersion.Note) : ''),
				content: '<pre style="max-height:55vh; overflow:auto; white-space:pre-wrap; font-size:12px;">' + _escapeHTML(tmpVersion.Source || '') + '</pre>',
				buttons: [{ Hash: 'ok', Label: 'Close', Style: 'primary' }]
			});
		});
	}

	pasteExternal()
	{
		this._modal().show(
		{
			title: 'Paste a prompt you built and ran elsewhere',
			content:
				'<p style="font-size:13px;">It lands in your library as a freeform prompt with an external run already recorded, so it can be posted, attached, and refined like anything crafted here.</p>'
				+ '<label style="font-size:12px;">Title</label>'
				+ '<input id="PPL-Paste-Title" class="pict-input" style="width:100%; margin-bottom:8px;">'
				+ '<label style="font-size:12px;">The prompt</label>'
				+ '<textarea id="PPL-Paste-Source" class="pict-input" style="width:100%; min-height:150px; font-family:monospace; font-size:12px;"></textarea>'
				+ '<label style="font-size:12px;">How did it go? (optional notes)</label>'
				+ '<textarea id="PPL-Paste-Notes" class="pict-input" style="width:100%; min-height:54px;"></textarea>',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Add to my library', Style: 'primary' }
			]
		}).then((pChoice) =>
		{
			if (pChoice !== 'save') { return; }
			let tmpTitle = ((document.getElementById('PPL-Paste-Title') || {}).value || '').trim();
			let tmpSource = (document.getElementById('PPL-Paste-Source') || {}).value || '';
			let tmpNotes = (document.getElementById('PPL-Paste-Notes') || {}).value || '';
			if (!tmpTitle || !tmpSource.trim()) { return this._toast('A title and the prompt text are both needed.', 'error'); }
			this._api().paste({ Title: tmpTitle, Source: tmpSource, Notes: tmpNotes })
				.then(() =>
				{
					this._toast('Added to your library with its external run.', 'success');
					let tmpEditor = this._editor();
					if (tmpEditor && this._state().ActiveTab === 'library') { tmpEditor.refresh(); }
				})
				.catch((pError) => this._toast(pError.message, 'error'));
		});
	}

	// ---- the shared library -----------------------------------------------------

	_loadShared()
	{
		let tmpState = this._state();
		this._api().shared()
			.then((pPrompts) =>
			{
				tmpState.Shared = pPrompts || [];
				if (tmpState.SelectedShared && !tmpState.Shared.find((pRow) => pRow.IDPrompt === tmpState.SelectedShared))
				{
					tmpState.SelectedShared = null;
				}
				this._paintShared();
				// Restore the open prompt's detail in place (NOT openShared -- that navigates and would loop).
				if (tmpState.SelectedShared) { this._openSharedRender(tmpState.SelectedShared); }
			})
			.catch(() => this._paintShared());
	}

	// pStampedName is the server-resolved AuthorDisplayName riding the row; it
	// covers departed teammates the roster no longer lists.
	_authorName(pIDUser, pStampedName)
	{
		let tmpMe = this._me();
		if (String(tmpMe.IDUser) === String(pIDUser)) { return 'you'; }
		if (pStampedName) { return pStampedName; }
		let tmpTeam = this.pict.AppData.Team || {};
		let tmpPeople = [].concat(tmpTeam.Roster || [], tmpTeam.Members || []);
		let tmpHit = tmpPeople.find((pPerson) => String(pPerson.IDUser) === String(pIDUser));
		return tmpHit ? (tmpHit.DisplayName || tmpHit.Email || ('User ' + pIDUser)) : ('User ' + pIDUser);
	}

	_shapeName(pTypeKey)
	{
		let tmpShape = (this._state().Shapes || []).find((pCandidate) => pCandidate.Key === pTypeKey);
		return tmpShape ? tmpShape.Name : pTypeKey;
	}

	_paintShared()
	{
		let tmpState = this._state();
		let tmpHost = document.getElementById('PromptLibrary-Shared-List');
		if (!tmpHost) { return; }
		let tmpHTML = '';
		tmpState.Shared.forEach((pPrompt) =>
		{
			let tmpActive = (tmpState.SelectedShared === pPrompt.IDPrompt) ? ' ppl-card-active' : '';
			tmpHTML += '<button class="ppl-card' + tmpActive + '" onclick="_Pict.views[\'Plansheet-PromptLibrary\'].openShared(' + pPrompt.IDPrompt + ')">'
				+ '<div class="ppl-card-title">' + _escapeHTML(pPrompt.Title) + '</div>'
				+ '<div class="ppl-card-meta">'
				+ '<span>#' + (pPrompt.PromptNumber || pPrompt.IDPrompt) + '</span>'
				+ '<span>' + _escapeHTML(this._shapeName(pPrompt.TypeKey)) + '</span>'
				+ '<span>by ' + _escapeHTML(this._authorName(pPrompt.IDUser, pPrompt.AuthorDisplayName)) + '</span>'
				+ '<span>' + _escapeHTML(_shortDate(pPrompt.PostedDate)) + '</span>'
				+ (pPrompt.Origin === 'External' ? '<span class="ppl-badge">ran elsewhere</span>' : '')
				+ '</div>'
				+ '</button>';
		});
		tmpHost.innerHTML = tmpHTML || '<div class="ppl-empty">Nothing posted yet. Post a prompt from My Library once it has a recorded run.</div>';

		if (!tmpState.SelectedShared)
		{
			let tmpDetail = document.getElementById('PromptLibrary-Shared-Detail');
			if (tmpDetail) { tmpDetail.innerHTML = '<div class="ppl-empty">Pick a prompt to read it, see its versions and runs, discuss it, or fork it into your library.</div>'; }
		}
	}

	// Opening a shared prompt is a NAVIGATION to /prompt/:id, so it deep-links and survives a reload (the
	// open prompt used to live only in memory). The route calls showSharedPrompt, which lands on the shared
	// tab; _openSharedRender does the actual detail render.
	openShared(pIDPrompt)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showPrompt === 'function') { tmpApp.showPrompt(pIDPrompt); }
		else { this._openSharedRender(pIDPrompt); }
	}

	// The detail render for a shared prompt: select it, paint the list highlight + the versions/runs pane.
	// Called by the route (via showSharedPrompt) and internally by _loadShared to restore the open prompt
	// after the shared list reloads (which is why this must NOT navigate -- it would loop the route).
	_openSharedRender(pIDPrompt)
	{
		let tmpState = this._state();
		tmpState.SelectedShared = pIDPrompt;
		this._paintShared();
		Promise.all([this._api().versions(pIDPrompt), this._api().runs(pIDPrompt)])
			.then((pResults) =>
			{
				let tmpPrompt = pResults[0].Prompt || null;
				tmpState.SelectedVersions = pResults[0].Versions || [];
				tmpState.SelectedRuns = pResults[1].Runs || [];
				this._paintSharedDetail(tmpPrompt);
			})
			.catch((pError) => this._toast(pError.message, 'error'));
	}

	// Route entry for /prompt/:id: land on the shared tab with prompt :id open. Loads the shape cascade
	// (shape names in the detail) first; showTab('shared') -> _loadShared then restores the detail for the
	// SelectedShared we set here.
	showSharedPrompt(pIDPrompt)
	{
		let tmpID = Number(pIDPrompt) || 0;
		this._state().SelectedShared = tmpID;
		let tmpSelf = this;
		if (this.pict.providers.TeamAPI && typeof this.pict.providers.TeamAPI.roster === 'function') { this.pict.providers.TeamAPI.roster().catch(() => { }); }
		let fReady = () => { tmpSelf.showTab('shared'); };
		this._shapeAPI().available()
			.then((pShapes) => { tmpSelf._state().Shapes = pShapes || tmpSelf._state().Shapes || []; tmpSelf._applyShapesToEditor(); fReady(); })
			.catch(fReady);
	}

	_paintSharedDetail(pPrompt)
	{
		let tmpState = this._state();
		let tmpHost = document.getElementById('PromptLibrary-Shared-Detail');
		if (!tmpHost || !pPrompt) { return; }
		let tmpViewRef = "_Pict.views['Plansheet-PromptLibrary']";

		let tmpHTML = '<div class="ppl-detail-head">'
			+ '<h3>' + _escapeHTML(pPrompt.Title) + '</h3>'
			+ '<span class="ppl-badge">#' + (pPrompt.PromptNumber || pPrompt.IDPrompt) + '</span>'
			+ '<span class="ppl-badge">' + _escapeHTML(this._shapeName(pPrompt.TypeKey)) + '</span>'
			+ (pPrompt.Origin === 'External' ? '<span class="ppl-badge">ran elsewhere</span>' : '')
			+ '<span class="ppl-card-meta">by ' + _escapeHTML(this._authorName(pPrompt.IDUser, pPrompt.AuthorDisplayName)) + ', posted ' + _escapeHTML(_shortDate(pPrompt.PostedDate)) + '</span>'
			+ '</div>'
			+ '<div class="ppl-detail-actions">'
			+ '<button class="ppl-btn ppl-btn-primary" onclick="' + tmpViewRef + '.forkShared(' + pPrompt.IDPrompt + ')">Fork to my library</button>'
			+ '<button class="ppl-btn" onclick="' + tmpViewRef + '.recordRunForShared(' + pPrompt.IDPrompt + ')">Record a run</button>'
			+ '<button class="ppl-btn" onclick="' + tmpViewRef + '.showHistory(' + pPrompt.IDPrompt + ', \'' + _escapeHTML(pPrompt.Title).replace(/'/g, '') + '\')">Full history</button>'
			+ '</div>'
			+ '<div class="ppl-source" id="PromptLibrary-Shared-Source"></div>';

		tmpHTML += '<div class="ppl-subhead">Versions (' + tmpState.SelectedVersions.length + ')</div>';
		tmpState.SelectedVersions.slice(0, 5).forEach((pVersion) =>
		{
			tmpHTML += '<div class="ppl-history-row">'
				+ '<strong>v' + pVersion.Sequence + '</strong>'
				+ (pVersion.Pinned ? '<span class="ppl-badge">pinned</span>' : '')
				+ '<span>' + _escapeHTML(pVersion.Note || '') + '</span>'
				+ '<span style="opacity:0.7;">' + _escapeHTML(_shortDate(pVersion.UpdateDate || pVersion.CreateDate)) + '</span>'
				+ '</div>';
		});

		tmpHTML += '<div class="ppl-subhead">Runs (' + tmpState.SelectedRuns.length + ')</div>';
		tmpState.SelectedRuns.slice(0, 5).forEach((pRun) =>
		{
			tmpHTML += '<div class="ppl-history-row">'
				+ '<strong>' + _escapeHTML(pRun.RunContext || 'Manual') + '</strong>'
				+ (pRun.Outcome ? '<span class="ppl-badge">' + _escapeHTML(pRun.Outcome) + '</span>' : '')
				+ '<span>by ' + _escapeHTML(this._authorName(pRun.CreatingIDUser, pRun.AuthorDisplayName)) + '</span>'
				+ '<span style="opacity:0.7;">' + _escapeHTML(_shortDate(pRun.CreateDate)) + '</span>'
				+ (pRun.Notes ? '<span>' + _escapeHTML(pRun.Notes) + '</span>' : '')
				+ '</div>';
		});
		if (!tmpState.SelectedRuns.length) { tmpHTML += '<div class="ppl-empty">No runs recorded.</div>'; }

		tmpHTML += '<div class="ppl-subhead">Discussion</div><div class="ppl-comments" id="Entity-Comments"></div>';

		tmpHost.innerHTML = tmpHTML;

		// The latest version's Source is the document of record for shared
		// reading (a private working copy may have moved past it).
		let tmpSource = (tmpState.SelectedVersions[0] && tmpState.SelectedVersions[0].Source) || pPrompt.Source || '';
		let tmpSourceHost = document.getElementById('PromptLibrary-Shared-Source');
		if (tmpSourceHost)
		{
			libMarkdownRender.renderInto(this.pict.providers.Content, tmpSourceHost, tmpSource);
		}

		// Discussion threads attach to the prompt itself (OwnerType 'Prompt').
		this._mountComments(pPrompt.IDPrompt);
	}

	_mountComments(pIDPrompt)
	{
		let tmpComments = this.pict.views['Plansheet-Comments'];
		if (!tmpComments) { return; }
		let tmpMe = this._me();
		tmpComments.options.CurrentUser = { Key: tmpMe.IDUser || 0, Name: tmpMe.DisplayName || tmpMe.Email || 'Me', Avatar: tmpMe.AvatarURL || '' };
		tmpComments.options.ReadOnly = false;
		if (this._CommentsLoadedFor === ('Prompt-' + pIDPrompt))
		{
			tmpComments.render();
			return;
		}
		this._CommentsLoadedFor = 'Prompt-' + pIDPrompt;
		tmpComments.setContext({ OwnerType: 'Prompt', IDOwner: pIDPrompt });
	}

	forkShared(pIDPrompt)
	{
		this._api().fork(pIDPrompt)
			.then(() =>
			{
				this._toast('Forked into your library.', 'success');
				this.showTab('library');
			})
			.catch((pError) => this._toast(pError.message, 'error'));
	}

	recordRunForShared(pIDPrompt)
	{
		let tmpPrompt = this._state().Shared.find((pCandidate) => pCandidate.IDPrompt === pIDPrompt);
		this._recordRunDialog(pIDPrompt, tmpPrompt ? tmpPrompt.Title : 'prompt', () => this.openShared(pIDPrompt));
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this._modal();
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'info' }); }
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewPromptLibrary;
module.exports.default_configuration = _ViewConfiguration;

},{"./MarkdownRender.js":649,"pict-view":365}],691:[function(require,module,exports){
'use strict';

/**
 * Prompt shape manager, one view serving both ends of the cascade:
 *
 *   Organization scope (the /prompt-shapes settings page, users.manage): the
 *   platform catalog with adopt buttons and drift badges, plus the org's own
 *   shapes - create fresh, edit segments, retire, history.
 *
 *   User scope (the My Shapes tab inside the Prompt Library): the org's active
 *   shapes with fork buttons, plus the caller's personal shapes with the same
 *   editor.
 *
 * The segment editor is the same in both scopes; the server enforces who may
 * write what (org shapes need users.manage, personal shapes their owner).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');

function _escapeHTML(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _slug(pText)
{
	return String(pText || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'segment';
}

const _ViewConfiguration =
{
	ViewIdentifier: 'Plansheet-PromptShapes',
	DefaultRenderable: 'Plansheet-PromptShapes',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,

	CSS: /*css*/`
		.pps { display: flex; flex-direction: column; gap: 18px; padding: 14px 18px; box-sizing: border-box; max-width: 1100px; }
		.pps h2 { margin: 0; font-size: 19px; }
		.pps h3 { margin: 0 0 8px 0; font-size: 15px; color: var(--theme-color-text-secondary, #667); font-weight: 600; }
		.pps-intro { color: var(--theme-color-text-secondary, #667); font-size: 13px; margin: 2px 0 0 0; }
		.pps-section { border: 1px solid var(--theme-color-border-light, #e3e3e3); border-radius: 8px; padding: 12px 14px; background: var(--theme-color-background-secondary, transparent); }
		.pps-row { display: flex; align-items: center; gap: 10px; padding: 7px 4px; border-bottom: 1px solid var(--theme-color-border-light, #eee); }
		.pps-row:last-child { border-bottom: none; }
		.pps-row-name { font-weight: 600; min-width: 170px; }
		.pps-row-desc { flex: 1; color: var(--theme-color-text-secondary, #667); font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.pps-badge { font-size: 11px; padding: 2px 8px; border-radius: 9px; border: 1px solid var(--theme-color-border-light, #ccc); color: var(--theme-color-text-secondary, #667); white-space: nowrap; }
		.pps-badge-adopted { border-color: var(--theme-color-brand-primary, #2e7d74); color: var(--theme-color-brand-primary, #2e7d74); }
		.pps-badge-drift { border-color: var(--theme-color-status-warning, #c77c02); color: var(--theme-color-status-warning, #c77c02); }
		.pps-badge-retired { opacity: 0.7; }
		.pps-btn { border: 1px solid var(--theme-color-border-light, #ccc); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #223); border-radius: 6px; padding: 4px 11px; font-size: 12.5px; cursor: pointer; white-space: nowrap; }
		.pps-btn:hover { border-color: var(--theme-color-brand-primary, #2e7d74); color: var(--theme-color-brand-primary, #2e7d74); }
		.pps-btn[disabled] { opacity: 0.45; cursor: default; }
		.pps-btn-primary { background: var(--theme-color-brand-primary, #2e7d74); border-color: var(--theme-color-brand-primary, #2e7d74); color: var(--theme-color-text-on-brand, #fff); }
		.pps-btn-primary:hover { color: var(--theme-color-text-on-brand, #fff); opacity: 0.92; }
		.pps-empty { color: var(--theme-color-text-secondary, #889); font-size: 13px; padding: 8px 4px; }
		.pps-editor { display: flex; flex-direction: column; gap: 10px; }
		.pps-editor label { font-size: 12px; color: var(--theme-color-text-secondary, #667); display: block; margin-bottom: 3px; }
		.pps-input, .pps-textarea { width: 100%; box-sizing: border-box; border: 1px solid var(--theme-color-border-light, #ccc); border-radius: 6px; padding: 6px 9px; font-size: 13.5px; background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #223); }
		.pps-textarea { font-family: inherit; min-height: 54px; resize: vertical; }
		.pps-seg { border: 1px solid var(--theme-color-border-light, #e3e3e3); border-radius: 7px; padding: 10px; display: flex; flex-direction: column; gap: 8px; }
		.pps-seg-grid { display: grid; grid-template-columns: 1fr 1.6fr auto; gap: 8px; align-items: end; }
		.pps-ref-grid { display: grid; grid-template-columns: 1fr 1.3fr 1.3fr auto; gap: 8px; align-items: end; }
		.pps-refs > label { font-weight: 600; color: var(--theme-color-text-primary, #223); }
		.pps-refs-hint { font-size: 11.5px; color: var(--theme-color-text-secondary, #889); margin: 0 0 6px; }
		.pps-seg-flags { display: flex; gap: 14px; align-items: center; font-size: 12.5px; color: var(--theme-color-text-secondary, #667); }
		.pps-seg-flags label { display: inline-flex; align-items: center; gap: 5px; margin: 0; }
		.pps-editor-actions { display: flex; gap: 8px; justify-content: flex-end; }
	`,

	Templates:
	[
		{
			Hash: 'Plansheet-PromptShapes',
			Template: /*html*/`
<div class="pps">
	<div>
		<h2>{~D:AppData.PromptShapes.Heading~}</h2>
		<p class="pps-intro">{~D:AppData.PromptShapes.Intro~}</p>
	</div>
	{~TS:Plansheet-PromptShapes-Platform-Section:AppData.PromptShapes.PlatformSlot~}
	<div class="pps-section">
		<h3>{~D:AppData.PromptShapes.OwnedHeading~}</h3>
		<div id="PromptShapes-Owned"></div>
		<div style="margin-top:10px;"><button class="pps-btn pps-btn-primary" onclick="_Pict.views['Plansheet-PromptShapes'].startNewShape()">New shape</button></div>
	</div>
	{~TS:Plansheet-PromptShapes-Source-Section:AppData.PromptShapes.SourceSlot~}
	{~TS:Plansheet-PromptShapes-Editor-Section:AppData.PromptShapes.EditorSlot~}
</div>`
		},
		{
			Hash: 'Plansheet-PromptShapes-Platform-Section',
			Template: /*html*/`
<div class="pps-section">
	<h3>Platform catalog</h3>
	<div id="PromptShapes-Platform"></div>
</div>`
		},
		{
			Hash: 'Plansheet-PromptShapes-Source-Section',
			Template: /*html*/`
<div class="pps-section">
	<h3>Organization shapes you can fork</h3>
	<div id="PromptShapes-Forkable"></div>
</div>`
		},
		{
			Hash: 'Plansheet-PromptShapes-Editor-Section',
			Template: /*html*/`
<div class="pps-section">
	<h3>{~D:Record.Title~}</h3>
	<div class="pps-editor" id="PromptShapes-Editor"></div>
</div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'Plansheet-PromptShapes', TemplateHash: 'Plansheet-PromptShapes', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

class PictViewPromptShapes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		if (!this.pict.AppData.PromptShapes)
		{
			this.pict.AppData.PromptShapes =
			{
				Scope: 'Organization',
				Heading: 'Prompt shapes',
				Intro: '',
				OwnedHeading: '',
				Platform: [],
				Tenant: [],
				PlatformSlot: [],
				SourceSlot: [],
				EditorSlot: [],
				Editing: null
			};
		}
		this._destination = null;
	}

	_state() { return this.pict.AppData.PromptShapes; }
	_api() { return this.pict.providers.PromptShapeAPI; }
	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_me() { return (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {}; }

	/**
	 * Enter the manager. pScope 'Organization' (settings page) or 'User'
	 * (the My Shapes tab); pDestinationAddress overrides where it renders.
	 */
	showIn(pDestinationAddress, pScope, pRouted)
	{
		let tmpState = this._state();
		tmpState.Scope = (pScope === 'User') ? 'User' : 'Organization';
		tmpState.Editing = null;
		// Only the standalone /prompt-shapes page is routed (pRouted): its edits navigate to /prompt-shape/:id
		// so they deep-link + survive reload. The embedded mounts (Prompt Library tab, org settings) are not
		// routed, so their editor stays inline.
		this._routed = !!pRouted;
		this._destination = pDestinationAddress || this.options.DefaultDestinationAddress;
		if (tmpState.Scope === 'Organization')
		{
			tmpState.Heading = 'Organization prompt shapes';
			tmpState.Intro = 'The prompt shapes everyone in the organization crafts against. Adopt a platform default to make it yours to edit, or author one fresh. Retired shapes stop being offered; existing prompts keep rendering.';
			tmpState.OwnedHeading = 'Organization shapes';
		}
		else
		{
			tmpState.Heading = 'My prompt shapes';
			tmpState.Intro = 'Personal shapes only you see in the editor. Fork an organization shape to adjust it for how you work, or author one fresh.';
			tmpState.OwnedHeading = 'My shapes';
		}
		return this._reload();
	}

	// Route entry for /prompt-shape/:id (edit) and /prompt-shapes/new (pID 0): render the standalone, routed
	// Organization page, then open the editor for that shape once the list has loaded.
	showRoutedEdit(pID)
	{
		let tmpEditID = Number(pID) || 0;
		let tmpSelf = this;
		return this.showIn('#Plansheet-Workspace', 'Organization', true).then(() =>
		{
			if (tmpEditID > 0) { tmpSelf._applyEdit(tmpEditID); } else { tmpSelf._applyNewShape(); }
		});
	}

	_reload()
	{
		let tmpState = this._state();
		return Promise.all([this._api().platform(), this._api().list()])
			.then((pResults) =>
			{
				tmpState.Platform = pResults[0] || [];
				tmpState.Tenant = pResults[1] || [];
				this._renderShell();
			})
			.catch(() => this._renderShell());
	}

	_renderShell()
	{
		let tmpState = this._state();
		tmpState.PlatformSlot = (tmpState.Scope === 'Organization') ? [{}] : [];
		tmpState.SourceSlot = (tmpState.Scope === 'User') ? [{}] : [];
		tmpState.EditorSlot = tmpState.Editing ? [{ Title: tmpState.Editing.IDPromptShape ? ('Edit: ' + tmpState.Editing.Name) : 'New shape' }] : [];
		this.render(this.options.DefaultRenderable, this._destination || this.options.DefaultDestinationAddress);
	}

	_ownedRows()
	{
		let tmpState = this._state();
		let tmpMe = Number(this._me().IDUser) || 0;
		if (tmpState.Scope === 'Organization')
		{
			return tmpState.Tenant.filter((pRow) => pRow.Scope === 'Organization');
		}
		return tmpState.Tenant.filter((pRow) => pRow.Scope === 'User' && Number(pRow.IDUser) === tmpMe);
	}

	// ---- list paints (innerHTML into the shell's containers) -----------------

	_paintLists()
	{
		let tmpState = this._state();

		if (tmpState.Scope === 'Organization')
		{
			let tmpHost = document.getElementById('PromptShapes-Platform');
			if (tmpHost)
			{
				let tmpOrgBySource = {};
				tmpState.Tenant.filter((pRow) => pRow.Scope === 'Organization' && pRow.IDSourcePlatformPromptShape)
					.forEach((pRow) => { tmpOrgBySource[pRow.IDSourcePlatformPromptShape] = pRow; });
				let tmpHTML = '';
				tmpState.Platform.forEach((pShape) =>
				{
					let tmpAdopted = tmpOrgBySource[pShape.IDPlatformPromptShape];
					let tmpDrift = tmpAdopted && (Number(pShape.Version) > Number(tmpAdopted.SourceVersion));
					tmpHTML += '<div class="pps-row">'
						+ '<span class="pps-row-name">' + _escapeHTML(pShape.Name) + '</span>'
						+ '<span class="pps-row-desc">' + _escapeHTML(pShape.Description || '') + '</span>'
						+ (tmpAdopted ? '<span class="pps-badge pps-badge-adopted">Adopted</span>' : '')
						+ (tmpDrift ? '<span class="pps-badge pps-badge-drift">Platform updated</span>' : '')
						+ '<button class="pps-btn" ' + (tmpAdopted ? 'disabled' : '')
						+ ' onclick="_Pict.views[\'Plansheet-PromptShapes\'].adopt(' + pShape.IDPlatformPromptShape + ')">Adopt</button>'
						+ '</div>';
				});
				tmpHost.innerHTML = tmpHTML || '<div class="pps-empty">No platform shapes are published.</div>';
			}
		}

		if (tmpState.Scope === 'User')
		{
			let tmpHost = document.getElementById('PromptShapes-Forkable');
			if (tmpHost)
			{
				let tmpOrgShapes = tmpState.Tenant.filter((pRow) => pRow.Scope === 'Organization' && pRow.Status === 'Active');
				let tmpHTML = '';
				tmpOrgShapes.forEach((pRow) =>
				{
					tmpHTML += '<div class="pps-row">'
						+ '<span class="pps-row-name">' + _escapeHTML(pRow.Name) + '</span>'
						+ '<span class="pps-row-desc">' + _escapeHTML(pRow.Description || '') + '</span>'
						+ '<button class="pps-btn" onclick="_Pict.views[\'Plansheet-PromptShapes\'].fork(' + pRow.IDPromptShape + ')">Fork to mine</button>'
						+ '</div>';
				});
				tmpHost.innerHTML = tmpHTML || '<div class="pps-empty">The organization has no active shapes yet. Platform defaults are always available in the editor; ask an admin to adopt one if you want a forkable org copy.</div>';
			}
		}

		let tmpOwnedHost = document.getElementById('PromptShapes-Owned');
		if (tmpOwnedHost)
		{
			let tmpRows = this._ownedRows();
			let tmpHTML = '';
			tmpRows.forEach((pRow) =>
			{
				let tmpRetired = pRow.Status === 'Retired';
				tmpHTML += '<div class="pps-row">'
					+ '<span class="pps-row-name">' + _escapeHTML(pRow.Name) + '</span>'
					+ '<span class="pps-row-desc">' + _escapeHTML(pRow.Description || '') + '</span>'
					+ '<span class="pps-badge' + (tmpRetired ? ' pps-badge-retired' : '') + '">' + _escapeHTML(pRow.SourceType || 'Fresh') + (tmpRetired ? ' / Retired' : '') + '</span>'
					+ '<button class="pps-btn" onclick="_Pict.views[\'Plansheet-PromptShapes\'].edit(' + pRow.IDPromptShape + ')">Edit</button>'
					+ '<button class="pps-btn" onclick="_Pict.views[\'Plansheet-PromptShapes\'].history(' + pRow.IDPromptShape + ')">History</button>'
					+ '<button class="pps-btn" onclick="_Pict.views[\'Plansheet-PromptShapes\'].toggleRetired(' + pRow.IDPromptShape + ')">' + (tmpRetired ? 'Reactivate' : 'Retire') + '</button>'
					+ '<button class="pps-btn" onclick="_Pict.views[\'Plansheet-PromptShapes\'].removeShape(' + pRow.IDPromptShape + ')">Delete</button>'
					+ '</div>';
			});
			tmpOwnedHost.innerHTML = tmpHTML || '<div class="pps-empty">Nothing here yet.</div>';
		}

		this._paintEditor();
	}

	// ---- actions ---------------------------------------------------------------

	adopt(pIDPlatformPromptShape)
	{
		this._api().adoptPlatform({ IDPlatformPromptShape: pIDPlatformPromptShape })
			.then(() => { this._toast('Adopted. The organization copy is yours to edit.', 'success'); return this._reload(); })
			.catch((pError) => this._toast(pError.message, 'error'));
	}

	fork(pIDPromptShape)
	{
		this._api().fork(pIDPromptShape)
			.then(() => { this._toast('Forked into your shapes.', 'success'); return this._reload(); })
			.catch((pError) => this._toast(pError.message, 'error'));
	}

	toggleRetired(pIDPromptShape)
	{
		let tmpRow = this._state().Tenant.find((pCandidate) => Number(pCandidate.IDPromptShape) === Number(pIDPromptShape));
		if (!tmpRow) { return; }
		this._api().update(pIDPromptShape, { Status: (tmpRow.Status === 'Retired') ? 'Active' : 'Retired' })
			.then(() => this._reload())
			.catch((pError) => this._toast(pError.message, 'error'));
	}

	removeShape(pIDPromptShape)
	{
		let tmpRow = this._state().Tenant.find((pCandidate) => Number(pCandidate.IDPromptShape) === Number(pIDPromptShape));
		if (!tmpRow) { return; }
		this._modal().confirm('Prompts already crafted against it keep rendering; the shape stops being offered. The delete is soft and its history stays.',
			{ title: 'Delete shape "' + tmpRow.Name + '"?', confirmLabel: 'Delete', dangerous: true })
			.then((pOk) =>
			{
				if (!pOk) { return; }
				this._api().remove(pIDPromptShape)
					.then(() => this._reload())
					.catch((pError) => this._toast(pError.message, 'error'));
			});
	}

	history(pIDPromptShape)
	{
		this._api().versions(pIDPromptShape).then((pBody) =>
		{
			let tmpVersions = pBody.Versions || [];
			let tmpHTML = tmpVersions.length ? '' : '<p>No versions captured yet.</p>';
			tmpVersions.forEach((pVersion) =>
			{
				let tmpDefinition = {};
				try { tmpDefinition = JSON.parse(pVersion.ShapeDefinition || '{}'); } catch (pError) { tmpDefinition = {}; }
				let tmpSegments = (tmpDefinition.Segments || []).map((pSegment) => pSegment.Name).join(', ');
				tmpHTML += '<div style="border-bottom:1px solid #ddd; padding:7px 0;">'
					+ '<strong>v' + pVersion.Sequence + '</strong>'
					+ (pVersion.Pinned ? ' <span style="font-size:11px;">(pinned)</span>' : '')
					+ ' <span style="font-size:12px; opacity:0.75;">' + _escapeHTML(pVersion.Note || '') + ' - ' + _escapeHTML(String(pVersion.UpdateDate || pVersion.CreateDate || '')) + '</span>'
					+ '<div style="font-size:12.5px; margin-top:3px;">' + _escapeHTML(tmpDefinition.Name || '') + ': ' + _escapeHTML(tmpSegments) + '</div>'
					+ '</div>';
			});
			this._modal().show(
			{
				title: 'Shape history: ' + ((pBody.Shape && pBody.Shape.Name) || ''),
				content: '<div style="max-height:50vh; overflow:auto;">' + tmpHTML + '</div>',
				buttons: [{ Hash: 'ok', Label: 'Close', Style: 'primary' }]
			});
		}).catch((pError) => this._toast(pError.message, 'error'));
	}

	// ---- the segment editor ------------------------------------------------------

	// Starting / editing a shape is a NAVIGATION on the standalone routed page (so an in-progress draft
	// deep-links + survives reload); embedded mounts (Prompt Library tab, org settings) edit inline.
	startNewShape()
	{
		let tmpApp = this.pict.PictApplication;
		if (this._routed && tmpApp && typeof tmpApp.showNewPromptShape === 'function') { tmpApp.showNewPromptShape(); return; }
		this._applyNewShape();
	}

	_applyNewShape()
	{
		let tmpState = this._state();
		tmpState.Editing =
		{
			IDPromptShape: 0,
			ShapeKey: 'shape-' + Math.random().toString(36).slice(2, 10),
			Name: '',
			Description: '',
			References: [],
			Segments: [{ Key: 'context', Name: 'Context', Guidance: '', Optional: false, Fixed: false, Body: '' }]
		};
		this._renderShell();
	}

	edit(pIDPromptShape)
	{
		let tmpApp = this.pict.PictApplication;
		if (this._routed && tmpApp && typeof tmpApp.showPromptShape === 'function') { tmpApp.showPromptShape(pIDPromptShape); return; }
		this._applyEdit(pIDPromptShape);
	}

	_applyEdit(pIDPromptShape)
	{
		let tmpRow = this._state().Tenant.find((pCandidate) => Number(pCandidate.IDPromptShape) === Number(pIDPromptShape));
		if (!tmpRow) { return; }
		let tmpDefinition = {};
		try { tmpDefinition = JSON.parse(tmpRow.ShapeDefinition || '{}'); } catch (pError) { tmpDefinition = {}; }
		this._state().Editing =
		{
			IDPromptShape: tmpRow.IDPromptShape,
			ShapeKey: tmpRow.ShapeKey,
			Name: tmpRow.Name || '',
			Description: tmpRow.Description || '',
			References: (tmpDefinition.References || []).map((pReference) => (
			{
				Label: pReference.Label || '',
				Path: pReference.Path || '',
				DocPath: pReference.DocPath || '',
				Note: pReference.Note || ''
			})),
			Segments: (tmpDefinition.Segments || []).map((pSegment) => (
			{
				Key: pSegment.Key || _slug(pSegment.Name),
				Name: pSegment.Name || '',
				Guidance: pSegment.Guidance || '',
				Optional: !!pSegment.Optional,
				Fixed: !!pSegment.Fixed,
				Body: pSegment.Body || ''
			}))
		};
		this._renderShell();
	}

	cancelEdit()
	{
		this._state().Editing = null;
		// On the standalone routed page, leaving the editor returns to /prompt-shapes; embedded stays inline.
		let tmpApp = this.pict.PictApplication;
		if (this._routed && tmpApp && typeof tmpApp.showPromptShapes === 'function') { tmpApp.showPromptShapes(); return; }
		this._renderShell();
	}

	_paintEditor()
	{
		let tmpState = this._state();
		let tmpHost = document.getElementById('PromptShapes-Editor');
		if (!tmpHost || !tmpState.Editing) { return; }
		let tmpEditing = tmpState.Editing;
		let tmpViewRef = "_Pict.views['Plansheet-PromptShapes']";

		let tmpHTML = '<div><label>Name</label>'
			+ '<input class="pps-input" id="PPS-Edit-Name" value="' + _escapeHTML(tmpEditing.Name) + '" oninput="' + tmpViewRef + '.editField(\'Name\', this.value)"></div>'
			+ '<div><label>Description</label>'
			+ '<textarea class="pps-textarea" id="PPS-Edit-Description" oninput="' + tmpViewRef + '.editField(\'Description\', this.value)">' + _escapeHTML(tmpEditing.Description) + '</textarea></div>';

		tmpHTML += '<div class="pps-refs"><label>Reference Material</label>'
			+ '<p class="pps-refs-hint">Guideline docs every generated prompt tells the session to read first. Give a local checkout path, a Docs Lake path, or both (the prompt renders both, and an agent with no checkout can pull the Docs Lake copy with the read_document MCP tool).</p>';
		(tmpEditing.References || []).forEach((pReference, pIndex) =>
		{
			tmpHTML += '<div class="pps-seg">'
				+ '<div class="pps-ref-grid">'
				+ '<div><label>Label</label><input class="pps-input" value="' + _escapeHTML(pReference.Label) + '" oninput="' + tmpViewRef + '.editReference(' + pIndex + ', \'Label\', this.value)"></div>'
				+ '<div><label>Local path</label><input class="pps-input" placeholder="~/Code/..." value="' + _escapeHTML(pReference.Path) + '" oninput="' + tmpViewRef + '.editReference(' + pIndex + ', \'Path\', this.value)"></div>'
				+ '<div><label>Docs Lake path</label><input class="pps-input" placeholder="reference/pict/conventions.md" value="' + _escapeHTML(pReference.DocPath) + '" oninput="' + tmpViewRef + '.editReference(' + pIndex + ', \'DocPath\', this.value)"></div>'
				+ '<button class="pps-btn" onclick="' + tmpViewRef + '.removeReference(' + pIndex + ')">Remove</button>'
				+ '</div>'
				+ '<div><label>Note (optional)</label><input class="pps-input" value="' + _escapeHTML(pReference.Note) + '" oninput="' + tmpViewRef + '.editReference(' + pIndex + ', \'Note\', this.value)"></div>'
				+ '</div>';
		});
		tmpHTML += '<div><button class="pps-btn" onclick="' + tmpViewRef + '.addReference()">Add reference</button></div></div>';

		tmpEditing.Segments.forEach((pSegment, pIndex) =>
		{
			tmpHTML += '<div class="pps-seg">'
				+ '<div class="pps-seg-grid">'
				+ '<div><label>Segment name</label><input class="pps-input" value="' + _escapeHTML(pSegment.Name) + '" oninput="' + tmpViewRef + '.editSegment(' + pIndex + ', \'Name\', this.value)"></div>'
				+ '<div><label>Guidance (one line for the author)</label><input class="pps-input" value="' + _escapeHTML(pSegment.Guidance) + '" oninput="' + tmpViewRef + '.editSegment(' + pIndex + ', \'Guidance\', this.value)"></div>'
				+ '<button class="pps-btn" onclick="' + tmpViewRef + '.removeSegment(' + pIndex + ')">Remove</button>'
				+ '</div>'
				+ '<div class="pps-seg-flags">'
				+ '<label><input type="checkbox" ' + (pSegment.Optional ? 'checked' : '') + ' onchange="' + tmpViewRef + '.editSegment(' + pIndex + ', \'Optional\', this.checked)"> Optional</label>'
				+ '<label><input type="checkbox" ' + (pSegment.Fixed ? 'checked' : '') + ' onchange="' + tmpViewRef + '.editSegment(' + pIndex + ', \'Fixed\', this.checked)"> Fixed preamble (locked text)</label>'
				+ '</div>'
				+ (pSegment.Fixed
					? '<div><label>Fixed body</label><textarea class="pps-textarea" oninput="' + tmpViewRef + '.editSegment(' + pIndex + ', \'Body\', this.value)">' + _escapeHTML(pSegment.Body) + '</textarea></div>'
					: '')
				+ '</div>';
		});

		tmpHTML += '<div><button class="pps-btn" onclick="' + tmpViewRef + '.addSegment()">Add segment</button></div>'
			+ '<div class="pps-editor-actions">'
			+ '<button class="pps-btn" onclick="' + tmpViewRef + '.cancelEdit()">Cancel</button>'
			+ '<button class="pps-btn pps-btn-primary" onclick="' + tmpViewRef + '.saveShape()">Save shape</button>'
			+ '</div>';

		tmpHost.innerHTML = tmpHTML;
	}

	editField(pField, pValue)
	{
		let tmpEditing = this._state().Editing;
		if (tmpEditing) { tmpEditing[pField] = pValue; }
	}

	editSegment(pIndex, pField, pValue)
	{
		let tmpEditing = this._state().Editing;
		if (!tmpEditing || !tmpEditing.Segments[pIndex]) { return; }
		tmpEditing.Segments[pIndex][pField] = pValue;
		// Toggling Fixed shows/hides the body textarea.
		if (pField === 'Fixed') { this._paintEditor(); }
	}

	addSegment()
	{
		let tmpEditing = this._state().Editing;
		if (!tmpEditing) { return; }
		tmpEditing.Segments.push({ Key: '', Name: '', Guidance: '', Optional: false, Fixed: false, Body: '' });
		this._paintEditor();
	}

	editReference(pIndex, pField, pValue)
	{
		let tmpEditing = this._state().Editing;
		if (!tmpEditing || !tmpEditing.References || !tmpEditing.References[pIndex]) { return; }
		tmpEditing.References[pIndex][pField] = pValue;
	}

	addReference()
	{
		let tmpEditing = this._state().Editing;
		if (!tmpEditing) { return; }
		if (!Array.isArray(tmpEditing.References)) { tmpEditing.References = []; }
		tmpEditing.References.push({ Label: '', Path: '', DocPath: '', Note: '' });
		this._paintEditor();
	}

	removeReference(pIndex)
	{
		let tmpEditing = this._state().Editing;
		if (!tmpEditing || !tmpEditing.References) { return; }
		tmpEditing.References.splice(pIndex, 1);
		this._paintEditor();
	}

	removeSegment(pIndex)
	{
		let tmpEditing = this._state().Editing;
		if (!tmpEditing) { return; }
		tmpEditing.Segments.splice(pIndex, 1);
		this._paintEditor();
	}

	saveShape()
	{
		let tmpState = this._state();
		let tmpEditing = tmpState.Editing;
		if (!tmpEditing) { return; }
		let tmpName = String(tmpEditing.Name || '').trim();
		if (!tmpName) { return this._toast('The shape needs a name.', 'error'); }
		let tmpSegments = tmpEditing.Segments
			.filter((pSegment) => String(pSegment.Name || '').trim())
			.map((pSegment) => (
			{
				Key: pSegment.Key || _slug(pSegment.Name),
				Name: String(pSegment.Name).trim(),
				Guidance: String(pSegment.Guidance || ''),
				Optional: !!pSegment.Optional || undefined,
				Fixed: !!pSegment.Fixed || undefined,
				Body: pSegment.Fixed ? String(pSegment.Body || '') : undefined
			}));
		if (!tmpSegments.length) { return this._toast('A shape needs at least one segment.', 'error'); }

		// Keep only references that name something usable (a label plus at least one
		// place to read it). An all-empty row the author added and left blank drops out.
		let tmpReferences = (tmpEditing.References || [])
			.map((pReference) => (
			{
				Label: String(pReference.Label || '').trim(),
				Path: String(pReference.Path || '').trim(),
				DocPath: String(pReference.DocPath || '').trim(),
				Note: String(pReference.Note || '').trim()
			}))
			.filter((pReference) => pReference.Label && (pReference.Path || pReference.DocPath || pReference.Note))
			.map((pReference) => (
			{
				Label: pReference.Label,
				Path: pReference.Path || undefined,
				DocPath: pReference.DocPath || undefined,
				Note: pReference.Note || undefined
			}));

		let tmpDefinition =
		{
			Key: tmpEditing.ShapeKey,
			Name: tmpName,
			Description: String(tmpEditing.Description || ''),
			Segments: tmpSegments
		};
		if (tmpReferences.length) { tmpDefinition.References = tmpReferences; }
		let tmpRecord =
		{
			Name: tmpName.slice(0, 200),
			Description: String(tmpEditing.Description || ''),
			ShapeDefinition: JSON.stringify(tmpDefinition)
		};

		let tmpSave;
		if (tmpEditing.IDPromptShape)
		{
			tmpSave = this._api().update(tmpEditing.IDPromptShape, tmpRecord);
		}
		else
		{
			tmpSave = this._api().create(Object.assign(
			{
				Scope: tmpState.Scope,
				ShapeKey: tmpEditing.ShapeKey
			}, tmpRecord));
		}
		let tmpSelf = this;
		tmpSave.then(() =>
		{
			tmpState.Editing = null;
			tmpSelf._toast('Shape saved.', 'success');
			// On the standalone routed page, saving returns to /prompt-shapes (leaving /prompt-shape/:id).
			let tmpApp = tmpSelf.pict.PictApplication;
			if (tmpSelf._routed && tmpApp && typeof tmpApp.showPromptShapes === 'function') { tmpApp.showPromptShapes(); return; }
			return tmpSelf._reload();
		}).catch((pError) => tmpSelf._toast(pError.message, 'error'));
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this._modal();
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'info' }); }
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._paintLists();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewPromptShapes;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],692:[function(require,module,exports){
'use strict';

/**
 * Rail -- the shared left rail. It hosts the site navigation and the notebook in one panel, and a single
 * top-bar toggle cycles three modes:
 *   nav      -- navigation only
 *   notebook -- notebook only
 *   split    -- notebook on top, navigation on bottom, with a draggable horizontal splitter between them
 * On a phone (<=860px, where the shell already flips the left panel to a drawer) split is dropped: the
 * toggle just swaps nav <-> notebook and the active pane fills the drawer as its own view.
 *
 * Switching modes is CSS-only (a data-rail-mode attribute on the root), so the notebook's editors are
 * never torn down on a toggle. Mode and split ratio persist in localStorage so the rail returns the way it
 * was left. The two things the rail can't own itself -- mounting the notebook view (an app view) into the
 * notebook pane, and the top-bar toggle button's icon -- it asks the app to do via this.pict.PictApplication.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');

const _MODE_KEY = 'plansheet.rail.mode';
const _RATIO_KEY = 'plansheet.rail.splitratio';
const _MOBILE_QUERY = '(max-width: 860px)';
const _MIN_NOTEBOOK = 140;   // px -- the split never shrinks a pane below these
const _MIN_NAV = 120;

class PictViewRail extends libPictView
{
	_root() { return (typeof document !== 'undefined') ? document.getElementById('Plansheet-Rail-Root') : null; }
	_app() { return this.pict.PictApplication; }

	isMobile() { return (typeof window !== 'undefined') && !!window.matchMedia && window.matchMedia(_MOBILE_QUERY).matches; }

	// The persisted value is the user's INTENT (nav / notebook / split). getMode returns it; setMode applies
	// the EFFECTIVE mode -- split collapses to notebook on a phone -- but persists the intent, so split
	// comes back when the viewport is wide again.
	getMode()
	{
		try { return localStorage.getItem(_MODE_KEY) || 'nav'; } catch (pError) { return 'nav'; }
	}

	setMode(pMode)
	{
		let tmpIntent = (pMode === 'notebook' || pMode === 'split') ? pMode : 'nav';
		try { localStorage.setItem(_MODE_KEY, tmpIntent); } catch (pError) { /* best effort */ }
		let tmpEffective = (tmpIntent === 'split' && this.isMobile()) ? 'notebook' : tmpIntent;   // no split on a phone
		let tmpRoot = this._root();
		if (tmpRoot) { tmpRoot.setAttribute('data-rail-mode', tmpEffective); }
		let tmpApp = this._app();
		// The notebook is an app view; mount it the first time it becomes visible.
		if ((tmpEffective === 'notebook' || tmpEffective === 'split') && tmpApp && typeof tmpApp._ensureNotebookMounted === 'function') { tmpApp._ensureNotebookMounted(); }
		if (tmpApp && typeof tmpApp._updateRailToggle === 'function') { tmpApp._updateRailToggle(tmpEffective); }
		return tmpEffective;
	}

	cycle()
	{
		let tmpOrder = this.isMobile() ? ['nav', 'notebook'] : ['nav', 'notebook', 'split'];
		let tmpIdx = tmpOrder.indexOf(this.getMode());
		return this.setMode(tmpOrder[(tmpIdx + 1) % tmpOrder.length]);
	}

	_applyRatio(pRatio)
	{
		let tmpRoot = this._root();
		if (tmpRoot && pRatio > 0 && pRatio < 1) { tmpRoot.style.setProperty('--ps-rail-split', (pRatio * 100) + '%'); }
	}

	// A dependency-free horizontal splitter: drag the divider to redistribute height between the notebook
	// (top) and the nav (bottom). Pointer capture keeps the drag alive past the 6px strip; rAF coalesces
	// moves; the ratio clamps so neither pane drops below its minimum, and persists on release.
	_wireSplitter()
	{
		if (typeof document === 'undefined') { return; }
		let tmpSplitter = document.getElementById('Plansheet-RailSplitter');
		let tmpRoot = this._root();
		if (!tmpSplitter || !tmpRoot || tmpSplitter._railWired) { return; }
		tmpSplitter._railWired = true;
		let tmpSelf = this;
		let tmpDragging = false, tmpRect = null, tmpRaf = 0, tmpY = 0;
		let fApply = () =>
		{
			tmpRaf = 0;
			if (!tmpRect || tmpRect.height <= 0) { return; }
			let tmpRatio = (tmpY - tmpRect.top) / tmpRect.height;
			let tmpMin = _MIN_NOTEBOOK / tmpRect.height;
			let tmpMax = (tmpRect.height - _MIN_NAV) / tmpRect.height;
			tmpRatio = Math.max(tmpMin, Math.min(tmpMax, tmpRatio));
			tmpRoot.style.setProperty('--ps-rail-split', (tmpRatio * 100) + '%');
			tmpSelf._splitRatio = tmpRatio;
		};
		tmpSplitter.addEventListener('pointerdown', (pEvent) =>
		{
			tmpDragging = true; tmpRect = tmpRoot.getBoundingClientRect();
			try { tmpSplitter.setPointerCapture(pEvent.pointerId); } catch (pErr) { /* */ }
			pEvent.preventDefault();
		});
		tmpSplitter.addEventListener('pointermove', (pEvent) =>
		{
			if (!tmpDragging) { return; }
			tmpY = pEvent.clientY;
			if (!tmpRaf) { tmpRaf = requestAnimationFrame(fApply); }
		});
		let fEnd = (pEvent) =>
		{
			if (!tmpDragging) { return; }
			tmpDragging = false;
			try { tmpSplitter.releasePointerCapture(pEvent.pointerId); } catch (pErr) { /* */ }
			try { localStorage.setItem(_RATIO_KEY, String(tmpSelf._splitRatio)); } catch (pErr) { /* */ }
		};
		tmpSplitter.addEventListener('pointerup', fEnd);
		tmpSplitter.addEventListener('pointercancel', fEnd);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		let tmpRatio = parseFloat((typeof localStorage !== 'undefined' && localStorage.getItem(_RATIO_KEY)) || '');
		this._splitRatio = (!isNaN(tmpRatio) && tmpRatio > 0 && tmpRatio < 1) ? tmpRatio : 0.5;
		this._applyRatio(this._splitRatio);
		this._wireSplitter();
		// Re-apply the mode when the viewport crosses the mobile breakpoint, so split collapses to notebook
		// on a phone and reopens on a wide screen without a reload. Bound once.
		if (typeof window !== 'undefined' && window.matchMedia && !this._mqlBound)
		{
			this._mqlBound = true;
			let tmpSelf = this;
			let tmpMql = window.matchMedia(_MOBILE_QUERY);
			let fChange = () => { tmpSelf.setMode(tmpSelf.getMode()); };
			if (tmpMql.addEventListener) { tmpMql.addEventListener('change', fChange); }
			else if (tmpMql.addListener) { tmpMql.addListener(fChange); }
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewRail;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Rail',
	DefaultRenderable: 'Plansheet-Rail',
	DefaultDestinationAddress: '#Plansheet-Sidebar',
	AutoRender: false,
	CSS: /*css*/`
		.ps-rail { display: flex; flex-direction: column; height: 100%; min-height: 0; --ps-rail-split: 50%; }
		.ps-rail-pane { min-height: 0; overflow-y: auto; }
		.ps-rail-nav { flex: 1 1 auto; }
		.ps-rail-notebook { flex: 1 1 auto; }
		.ps-rail-splitter { display: none; flex: 0 0 6px; cursor: row-resize; background: var(--theme-color-border-default, #cfc6b0); }
		.ps-rail-splitter:hover { background: var(--theme-color-brand-primary, #3b6fd4); }
		/* Mode is a CSS-only swap on the root, so the notebook's editors survive a toggle. */
		.ps-rail[data-rail-mode="nav"] .ps-rail-notebook { display: none; }
		.ps-rail[data-rail-mode="nav"] .ps-rail-splitter { display: none; }
		.ps-rail[data-rail-mode="notebook"] .ps-rail-nav { display: none; }
		.ps-rail[data-rail-mode="notebook"] .ps-rail-splitter { display: none; }
		.ps-rail[data-rail-mode="split"] .ps-rail-notebook { flex: 0 0 var(--ps-rail-split, 50%); }
		.ps-rail[data-rail-mode="split"] .ps-rail-splitter { display: block; }
		.ps-rail[data-rail-mode="split"] .ps-rail-nav { flex: 1 1 auto; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-Rail',
			Template: /*html*/`
<div class="ps-rail" data-rail-mode="notebook" id="Plansheet-Rail-Root">
	<div class="ps-rail-pane ps-rail-notebook" id="Plansheet-Notebook"></div>
	<div class="ps-rail-splitter" id="Plansheet-RailSplitter" title="Drag to resize"></div>
	<div class="ps-rail-pane ps-rail-nav" id="Plansheet-RailNav"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-Rail',
			TemplateHash: 'Plansheet-Rail',
			ContentDestinationAddress: '#Plansheet-Sidebar'
		}
	]
};

},{"pict-view":365}],693:[function(require,module,exports){
'use strict';

/**
 * In-place re-authentication modal.
 *
 * When a session expires while the page stays loaded, the Fable RestClient's
 * authenticationRecovery hook calls ensure() on this view. Rather than throwing
 * the user back to the full-page sign-in (PictView-Auth) -- which loses their
 * route, scroll, and in-flight view state -- this drives a compact
 * pict-section-modal over the current page: username prefilled from the known
 * session, password (and the 2FA / recovery-code path when the org requires it)
 * captured in place, reusing AuthClient.login exactly as the full screen does.
 *
 * Most accounts do not have a password at all -- they sign in through an OAuth
 * provider (GitHub, Google, and whatever identity integrations come later), so
 * the password field alone left them stuck: cancelling out to the full sign-in
 * screen was the only way back in. The modal also lists whichever providers
 * this instance has configured (the same AppData.Auth.Providers the full
 * screen reads), each a plain link to AuthClient.beginURL(name, returnTo).
 * That is a real navigation -- OAuth has to leave the page for the provider's
 * consent screen -- but returnTo carries the current route through the round
 * trip, so the browser lands back where it left off, signed in, instead of on
 * the app's default landing page.
 *
 * ensure() resolves:
 *   true  -- signed back in; the cookie is refreshed, so the RestClient replays
 *            the original request and the user's click "just works".
 *   false -- cancelled, enrollment required, or gave up; the app falls back to
 *            the full showAuth('login') screen and the original 401 stands.
 *
 * Single-flight on this side too: a burst of 401s that all reach ensure() share
 * one modal (the RestClient already collapses them, but a proactive banner can
 * call ensure() independently, so we guard here as well).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libProviderLabels = require('../OAuth-Provider-Labels.js');

function _escapeHTML(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

const _ViewConfiguration =
{
	ViewIdentifier: 'Plansheet-ReAuth',
	DefaultRenderable: 'Plansheet-ReAuth',
	DefaultDestinationAddress: '#Plansheet-ReAuth-Anchor',
	AutoRender: false,

	CSS: /*css*/`
		.psra-body { font-size: 13px; color: var(--cnx-txt, #eef2f7); }
		.psra-lead { font-size: 12.5px; color: var(--cnx-lbl, #9aabc0); margin: 0 0 12px; line-height: 1.5; }
		.psra-id { display: flex; align-items: center; gap: 8px; background: rgba(8,14,24,0.34); border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 8px; padding: 8px 11px; margin-bottom: 10px; }
		.psra-id-label { font-size: 11px; letter-spacing: 1px; text-transform: uppercase; color: var(--cnx-lbl, #9aabc0); }
		.psra-id-value { font-weight: 600; font-size: 13px; }
		.psra-label { font-size: 12px; color: var(--cnx-lbl, #9aabc0); display: block; margin-bottom: 4px; }
		.psra-input { width: 100%; box-sizing: border-box; margin-bottom: 6px; }
		.psra-error { color: #ff9d92; font-size: 12.5px; margin: 4px 0 8px; min-height: 1em; }
		.psra-alt { font-size: 12px; margin-top: 8px; display: flex; gap: 14px; }
		.psra-alt a { color: #f0c44a; cursor: pointer; }
		.psra-note { font-size: 12px; color: #8fd3a3; margin: 4px 0 0; min-height: 1em; }
		.psra-divider { text-align: center; margin: 14px 0 10px; color: var(--cnx-lbl, #9aabc0); font-size: 11px; position: relative; }
		.psra-divider::before, .psra-divider::after { content: ""; position: absolute; top: 50%; width: calc(50% - 20px); height: 1px; background: var(--cnx-cellb, rgba(150,166,188,0.3)); }
		.psra-divider::before { left: 0; }
		.psra-divider::after { right: 0; }
		.psra-providers { display: flex; flex-direction: column; gap: 8px; }
		.psra-provider { display: block; padding: 9px 12px; background: rgba(8,14,24,0.34); border: 1px solid var(--cnx-cellb, rgba(150,166,188,0.3)); border-radius: 8px; color: var(--cnx-txt, #eef2f7); text-decoration: none; font-size: 13px; text-align: center; font-weight: 500; }
		.psra-provider:hover { background: rgba(8,14,24,0.5); }
	`,

	Templates: [{ Hash: 'Plansheet-ReAuth', Template: /*html*/`<div></div>` }],
	Renderables:
	[
		{ RenderableHash: 'Plansheet-ReAuth', TemplateHash: 'Plansheet-ReAuth', ContentDestinationAddress: '#Plansheet-ReAuth-Anchor', RenderMethod: 'replace' }
	]
};

class PictViewReAuth extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		// Shared in-flight ensure() promise; see the single-flight note above.
		this._ensurePromise = null;
		// Last-known signed-in username. The proactive expiry check nulls
		// AppData.Auth.User on the way out, so we cannot rely on it being present
		// when ensure() runs -- remember it while we still know it.
		this._lastKnownUsername = '';
	}

	/**
	 * Stash the identity to prefill on the next re-auth. The app calls this while
	 * the session is live (login / boot), so a later checkSession that clears
	 * AppData.Auth.User cannot erase what we need to prefill the modal.
	 *
	 * @param {Object} pUserRecord - The signed-in user record (or null).
	 */
	rememberIdentity(pUserRecord)
	{
		let tmpUsername = pUserRecord
			? (pUserRecord.EMail || pUserRecord.Email || pUserRecord.LocalLogin || pUserRecord.UserName || pUserRecord.Name || '')
			: '';
		if (tmpUsername) { this._lastKnownUsername = tmpUsername; }
	}

	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_authClient() { return this.pict.providers.AuthClient; }

	// The identity we re-authenticate. It is fixed to the expired session's user;
	// the modal cannot switch accounts (that is what the full sign-in screen is for).
	_username()
	{
		let tmpUser = (this.pict.AppData && this.pict.AppData.Auth && this.pict.AppData.Auth.User) || null;
		let tmpLive = tmpUser ? (tmpUser.EMail || tmpUser.Email || tmpUser.LocalLogin || tmpUser.UserName || tmpUser.Name || '') : '';
		if (tmpLive)
		{
			// Keep the remembered copy fresh whenever the live record is present.
			this._lastKnownUsername = tmpLive;
			return tmpLive;
		}
		// The proactive check may have nulled AppData.Auth.User; fall back to the
		// identity we stashed while signed in.
		return this._lastKnownUsername || '';
	}

	/**
	 * The recovery entry point wired into RestClient.authenticationRecovery.
	 * Returns a Promise<boolean>. Single-flight: concurrent callers share one modal.
	 */
	ensure()
	{
		if (this._ensurePromise) { return this._ensurePromise; }
		this._ensurePromise = this._runEnsure();
		// Clear on settle so a later, unrelated expiry re-arms a fresh modal.
		let fClear = () => { this._ensurePromise = null; };
		this._ensurePromise.then(fClear, fClear);
		return this._ensurePromise;
	}

	async _runEnsure()
	{
		let tmpUsername = this._username();
		// No known user (e.g. never signed in this load): nothing to prefill, so
		// let the full sign-in screen own it.
		if (!tmpUsername)
		{
			this._fallbackToFullSignIn();
			return false;
		}

		let tmpError = '';
		// Loop so a wrong password re-prompts in place instead of dropping the user.
		while (true)
		{
			let tmpOutcome = await this._showPasswordModal(tmpUsername, tmpError);
			if (tmpOutcome.action !== 'signin')
			{
				// Cancel / dismiss: hand off to the full screen, resolve false.
				this._fallbackToFullSignIn();
				return false;
			}
			if (!tmpOutcome.password)
			{
				tmpError = 'Enter your password to continue.';
				continue;
			}

			let tmpResult = await this._authClient().login(tmpUsername, tmpOutcome.password);
			if (tmpResult === true)
			{
				return true;
			}
			if (tmpResult === 'challenge')
			{
				let tmpVerified = await this._runChallenge();
				if (tmpVerified) { return true; }
				// Gave up on the code step: re-prompt the password once more.
				tmpError = 'Two-step verification was not completed. Try again.';
				continue;
			}
			if (tmpResult === 'enroll')
			{
				// A restricted session needing 2FA enrollment cannot be resolved in a
				// compact modal; the full screen carries the enrollment flow.
				this._fallbackToFullSignIn();
				return false;
			}
			// false: bad password (or other soft failure) -- show the error, loop.
			tmpError = (this.pict.AppData.Auth && this.pict.AppData.Auth.LastError) || 'That did not work. Check your password and try again.';
		}
	}

	// The address to send the browser back to once an OAuth round trip
	// completes -- the SPA route it was on, hash and all, re-validated
	// server-side (see beginURL / orator-authentication's _safeReturnTo).
	_returnTo()
	{
		if (typeof window === 'undefined' || !window.location) { return ''; }
		return window.location.pathname + window.location.search + window.location.hash;
	}

	// OAuth provider links for whichever identity providers this instance has
	// configured -- the same list the full sign-in screen offers, so an
	// account signed in with GitHub / Google / a future integration is not
	// stuck with only a password field it never set. A click is a real page
	// navigation (OAuth cannot happen in a modal); returnTo brings the
	// browser back to this route once it completes.
	_providersHTML()
	{
		let tmpProviders = (this.pict.AppData.Auth && this.pict.AppData.Auth.Providers) || [];
		if (!tmpProviders.length) { return ''; }
		let tmpReturnTo = this._returnTo();
		let tmpRows = tmpProviders.map((pProvider) =>
			'<a class="psra-provider" href="' + _escapeHTML(this._authClient().beginURL(pProvider.Name, tmpReturnTo)) + '">'
			+ 'Continue with ' + _escapeHTML(libProviderLabels.labelForProvider(pProvider.Name)) + '</a>').join('');
		return '<div class="psra-divider">or continue with</div><div class="psra-providers">' + tmpRows + '</div>';
	}

	// Compact password modal. Resolves { action:'signin'|'cancel', password }.
	_showPasswordModal(pUsername, pError)
	{
		let tmpContent =
			'<div class="psra-body">'
			+ '<p class="psra-lead">Your session expired. Sign back in to pick up right where you left off -- your page and unsaved work stay put.</p>'
			+ '<div class="psra-id"><span class="psra-id-label">Account</span><span class="psra-id-value">' + _escapeHTML(pUsername) + '</span></div>'
			+ '<label class="psra-label" for="ReAuth-Password">Password</label>'
			+ '<input id="ReAuth-Password" type="password" class="pict-input psra-input" autocomplete="current-password" autofocus>'
			+ '<div class="psra-error">' + _escapeHTML(pError || '') + '</div>'
			+ this._providersHTML()
			+ '</div>';
		let tmpDialog = this._modal().show(
		{
			title: 'Session expired',
			content: tmpContent,
			buttons:
			[
				{ Hash: 'cancel', Label: 'Sign in fully' },
				{ Hash: 'signin', Label: 'Sign back in', Style: 'primary' }
			]
		});
		// Focus + Enter-to-submit once the modal DOM is live.
		setTimeout(() =>
		{
			let tmpField = document.getElementById('ReAuth-Password');
			if (!tmpField) { return; }
			tmpField.focus();
			tmpField.onkeydown = (pEvent) =>
			{
				if (pEvent.key === 'Enter')
				{
					pEvent.preventDefault();
					this._clickModalButton('signin');
				}
			};
		}, 30);
		return tmpDialog.then((pChoice) =>
		{
			let tmpPassword = (document.getElementById('ReAuth-Password') || {}).value || '';
			return { action: (pChoice === 'signin') ? 'signin' : 'cancel', password: tmpPassword };
		});
	}

	/**
	 * Two-step verification loop. Reuses AuthClient.verifyLoginCode /
	 * useRecoveryCode / resendLoginCode against the pending challenge that
	 * login() staged on AppData.Auth.PendingChallenge. Resolves true (verified)
	 * or false (cancelled / gave up).
	 */
	async _runChallenge()
	{
		let tmpError = '';
		let tmpNote = '';
		let tmpRecoveryMode = false;
		while (true)
		{
			let tmpChallenge = (this.pict.AppData.Auth && this.pict.AppData.Auth.PendingChallenge) || {};
			let tmpOutcome = await this._showChallengeModal(tmpChallenge, tmpRecoveryMode, tmpError, tmpNote);
			tmpError = '';
			tmpNote = '';

			if (tmpOutcome.action === 'cancel')
			{
				return false;
			}
			if (tmpOutcome.action === 'toggle-recovery')
			{
				tmpRecoveryMode = !tmpRecoveryMode;
				continue;
			}
			if (tmpOutcome.action === 'resend')
			{
				let tmpResent = await this._authClient().resendLoginCode();
				tmpNote = tmpResent ? 'A new code is on its way.' : '';
				tmpError = tmpResent ? '' : ((this.pict.AppData.Auth && this.pict.AppData.Auth.LastError) || 'Could not resend the code.');
				continue;
			}
			// action === 'verify'
			if (!tmpOutcome.code)
			{
				tmpError = tmpRecoveryMode ? 'Enter one of your recovery codes.' : 'Enter the code we sent you.';
				continue;
			}
			let tmpVerified = tmpRecoveryMode
				? await this._authClient().useRecoveryCode(tmpOutcome.code)
				: await this._authClient().verifyLoginCode(tmpOutcome.code);
			if (tmpVerified === true) { return true; }
			tmpError = (this.pict.AppData.Auth && this.pict.AppData.Auth.LastError) || 'That code did not work.';
		}
	}

	// Resolves { action, code }.
	_showChallengeModal(pChallenge, pRecoveryMode, pError, pNote)
	{
		let tmpChannel = pChallenge.Channel || 'email';
		let tmpDestination = pChallenge.MaskedDestination || '';
		let tmpLead = pRecoveryMode
			? 'Enter one of the one-time recovery codes you saved when you set up two-step verification.'
			: ('We sent a verification code' + (tmpDestination ? (' to ' + _escapeHTML(tmpDestination)) : (' via ' + _escapeHTML(tmpChannel))) + '. Enter it to finish signing in.');
		let tmpContent =
			'<div class="psra-body">'
			+ '<p class="psra-lead">' + tmpLead + '</p>'
			+ '<label class="psra-label" for="ReAuth-Code">' + (pRecoveryMode ? 'Recovery code' : 'Verification code') + '</label>'
			+ '<input id="ReAuth-Code" type="text" inputmode="' + (pRecoveryMode ? 'text' : 'numeric') + '" class="pict-input psra-input" autocomplete="one-time-code" autofocus>'
			+ '<div class="psra-error">' + _escapeHTML(pError || '') + '</div>'
			+ '<div class="psra-note">' + _escapeHTML(pNote || '') + '</div>'
			+ '<div class="psra-alt">'
			+ (pRecoveryMode
				? '<a onclick="_Pict.views[\'Plansheet-ReAuth\']._modalAction(\'toggle-recovery\')">Use an emailed code instead</a>'
				: '<a onclick="_Pict.views[\'Plansheet-ReAuth\']._modalAction(\'resend\')">Resend code</a>'
					+ '<a onclick="_Pict.views[\'Plansheet-ReAuth\']._modalAction(\'toggle-recovery\')">Use a recovery code</a>')
			+ '</div>'
			+ '</div>';
		let tmpDialog = this._modal().show(
		{
			title: 'Two-step verification',
			content: tmpContent,
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'verify', Label: 'Verify', Style: 'primary' }
			]
		});
		setTimeout(() =>
		{
			let tmpField = document.getElementById('ReAuth-Code');
			if (tmpField) { tmpField.focus(); }
		}, 30);
		return tmpDialog.then((pChoice) =>
		{
			// An alt-link click stashed an override action; honor it over the button.
			if (this._pendingAction)
			{
				let tmpAction = this._pendingAction;
				this._pendingAction = null;
				return { action: tmpAction, code: '' };
			}
			let tmpCode = ((document.getElementById('ReAuth-Code') || {}).value || '').trim();
			return { action: (pChoice === 'verify') ? 'verify' : 'cancel', code: tmpCode };
		});
	}

	// The alt-links (resend / recovery toggle) dismiss the current modal, then the
	// challenge loop reopens it in the requested mode. We stash the intent and
	// click the (harmless) cancel button so the modal promise settles; the
	// challenge modal's .then honors _pendingAction over the raw button hash.
	_modalAction(pAction)
	{
		this._pendingAction = pAction;
		this._clickModalButton('cancel');
	}

	// Programmatically activate a footer button on the topmost live modal dialog.
	// pict-section-modal wires each footer button as a [data-hash] click that
	// resolves the show() promise, so a synthetic click is the supported seam.
	_clickModalButton(pHash)
	{
		if (typeof document === 'undefined') { return; }
		let tmpDialogs = document.querySelectorAll('.pict-modal-dialog');
		let tmpDialog = tmpDialogs[tmpDialogs.length - 1];
		if (!tmpDialog) { return; }
		let tmpButton = tmpDialog.querySelector('[data-hash="' + pHash + '"]');
		if (tmpButton) { tmpButton.click(); }
	}

	// Deliberate handoff to the full-page sign-in. Kept in one place so both the
	// no-username and cancel/enroll paths route identically.
	_fallbackToFullSignIn()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showAuth === 'function')
		{
			tmpApp.showAuth('login');
		}
	}
}

module.exports = PictViewReAuth;
module.exports.default_configuration = _ViewConfiguration;

},{"../OAuth-Provider-Labels.js":562,"pict-view":365}],694:[function(require,module,exports){
'use strict';

/**
 * Releases -- the graphical deploy surface. One read (GET /1.0/Releases via providers.DeployAPI) backs the
 * whole page: what commit runs on dev and prod, the As-Builts grouped by where they are in the pipeline
 * (built, on dev awaiting validation, validated and ready, promoted), and the recent deploy requests.
 *
 * The buttons never deploy anything; they QUEUE a DeployRequest that a deploy node claims and runs (the deploy
 * credentials live on that node, never in the browser). Deploy dev queues a DeployDev; Promote to prod queues a
 * Promote, and is offered only when every As-Built on dev has been validated. Validate reuses the app's
 * validateAsBuilt flow. Template-driven per the Pict conventions; no innerHTML.
 *
 * An environment already carrying a deploy takes its button away rather than leaving one that would 409. The
 * server refuses either way (SingleFlightLanes is the shared rule both sides read), but a button you can press
 * that will not work is the thing that let a promote get queued twice: it looked available, so it got clicked.
 * In its place goes what is actually in flight and a way to go look at it.
 *
 * Not every deliverable rides this pipeline. Work landed in a sibling workspace (the node runner, the deploy
 * tool) has a commit no app ref can ever contain, so a dev deploy could never pick it up and it sat at Built
 * forever, re-tested and skipped on every deploy. Those close as Delivered and get their own group here rather
 * than a permanent seat in the pending bucket. See the !AsBuilt block in data_model/Plansheet.ddl.
 */

const libPictView = require('pict-view');
const libLanes = require('../SingleFlightLanes.js');
// The mark and tooltip furniture shared with the board and every entity list, so a row's "WI-080" and its
// hover card can never drift from what the rest of the app shows for the same Work Item (WI #452).
const libMarkup = require('./Markup-Templates.js');

// The workspace this page's pipeline ships. The server now says which one (GET /1.0/Releases carries
// DeployableWorkspace, read from the tenant's Workspace marked Deployable); this literal survives only as the
// fallback for a plan sheet that has not declared one, which is what it always effectively was.
const _DEPLOYABLE_WORKSPACE_FALLBACK = 'plansheet';
// Statuses that mean "still riding the deploy pipeline". For a row belonging to another workspace one of
// these is a leftover from a node that stamped it before Delivered existed, not a real position.
const _PIPELINE_STATUSES = { Built: true, Deployed: true, Validated: true };

class PictViewReleases extends libPictView
{
	_data() { return this.pict.AppData.Releases || {}; }
	_api() { return this.pict.providers.DeployAPI; }

	_ms(pValue)
	{
		if (!pValue) { return 0; }
		let tmpString = String(pValue);
		let tmpParsed = Date.parse(tmpString);
		if (!isNaN(tmpParsed)) { return tmpParsed; }
		tmpParsed = Date.parse(tmpString.replace(' ', 'T') + 'Z');
		return isNaN(tmpParsed) ? 0 : tmpParsed;
	}

	_ago(pValue)
	{
		let tmpMs = this._ms(pValue);
		if (!tmpMs) { return ''; }
		let tmpSeconds = Math.floor((Date.now() - tmpMs) / 1000);
		if (tmpSeconds < 0) { tmpSeconds = 0; }
		if (tmpSeconds < 60) { return tmpSeconds + 's ago'; }
		let tmpMinutes = Math.floor(tmpSeconds / 60);
		if (tmpMinutes < 60) { return tmpMinutes + 'm ago'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		if (tmpHours < 24) { return tmpHours + 'h ago'; }
		return Math.floor(tmpHours / 24) + 'd ago';
	}

	// A compact span ("45s", "2m", "1h 3m"), for elapsed and for how long one took. Distinct from _ago, which
	// is a point in the past. Same shape the Runs page uses, so the two deploy surfaces read alike.
	_dur(pMs)
	{
		let tmpSeconds = Math.max(0, Math.floor((Number(pMs) || 0) / 1000));
		if (tmpSeconds < 60) { return tmpSeconds + 's'; }
		let tmpMinutes = Math.floor(tmpSeconds / 60);
		if (tmpMinutes < 60) { return tmpMinutes + 'm'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		let tmpRemMinutes = tmpMinutes % 60;
		return tmpRemMinutes ? (tmpHours + 'h ' + tmpRemMinutes + 'm') : (tmpHours + 'h');
	}

	// The stage and the deploy log are text a NODE wrote, and these templates interpolate raw. A log line
	// reading "<button>Promote</button>" would render as one, on the page whose whole job is to tell a person
	// the truth about production before they press something. Escape on the way in, exactly as the Runs page
	// does with its step logs.
	_escape(pValue)
	{
		return String(pValue == null ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

	_short(pValue) { return String(pValue || '').slice(0, 12); }

	/**
	 * The row's Work Item, when the As-Built names one: the mark data "WI-080" renders from, plus a stash
	 * of what the hover tooltip needs once the row is actually on screen (see _attachWorkItemTooltips).
	 * Before this the row showed the As-Built's OWN number and no link at all -- so validating meant going
	 * to the Work Items page and hunting for the number by the string next to it (WI #452). Returns null
	 * for an As-Built that predates the IDWorkItem link or whose Work Item is gone, and the row falls back
	 * to showing its own number, exactly as it always has.
	 */
	_workItemLink(pRow)
	{
		let tmpIDWorkItem = Number(pRow.IDWorkItem) || 0;
		let tmpNumber = Number(pRow.WorkItemNumber) || 0;
		if (!tmpIDWorkItem || !tmpNumber) { return null; }
		let tmpMarkup = this.pict.providers.Markup;
		let tmpDesignator = tmpMarkup ? tmpMarkup.designator('WorkItem', tmpNumber) : ('WI-' + tmpNumber);
		this._workItemTooltipData[tmpIDWorkItem] = {
			Number: tmpNumber, Title: pRow.WorkItemTitle || '', Type: pRow.WorkItemType || '',
			Priority: pRow.WorkItemPriority || '', Status: pRow.WorkItemStatus || '',
			Description: pRow.WorkItemDescription || ''
		};
		return { IDWorkItem: tmpIDWorkItem, MarkSlot: [{ Designator: tmpDesignator, KindClass: 'ps-mark-workitem' }] };
	}

	_statusClass(pStatus)
	{
		let tmpMap = { Built: 'built', Deployed: 'deployed', Validated: 'validated', Promoted: 'promoted', Superseded: 'muted',
			Delivered: 'delivered',
			Requested: 'deployed', Running: 'running', Succeeded: 'validated', Failed: 'failed', Cancelled: 'muted' };
		return tmpMap[pStatus] || 'muted';
	}

	// The live one-liner on a deploy request: what the node last got through and how long it has been at it,
	// or how long it took once it is done. A 0-or-1 slot so a request that has done nothing stays quiet.
	//
	// The stage is the last step that COMPLETED, which is what the node's log can actually prove. It reads
	// "database backup done - running 4m" rather than naming a step as in progress, because the step now
	// running is the one nothing has reported yet, and inventing its name is how a page starts lying about a
	// deploy (Feature #124).
	_requestTiming(pRow)
	{
		let tmpStage = this._escape(pRow.Stage || '');
		if (pRow.Status === 'Running')
		{
			let tmpStartedMs = this._ms(pRow.StartedDate);
			let tmpElapsed = tmpStartedMs ? ('running ' + this._dur(Date.now() - tmpStartedMs)) : 'running';
			if (!tmpStage) { return [{ Timing: tmpElapsed }]; }
			// A step that FAILED is the last thing that happened, not progress: say so, since a deploy sitting
			// on a failed step for minutes is the case where a person most needs to stop watching and look.
			let tmpWord = pRow.StageFailed ? ' FAILED - ' : ((Number(pRow.StepsDone) > 0) ? ' done - ' : ' - ');
			return [{ Timing: tmpStage + tmpWord + tmpElapsed }];
		}
		if (Number(pRow.DurationMs) > 0) { return [{ Timing: 'took ' + this._dur(pRow.DurationMs) }]; }
		return [];
	}

	// A node's heartbeat state as a badge class. Stale and Never are both "nothing is coming", so they read
	// the same; Suspended is deliberate and reads muted rather than alarming.
	_nodeStateClass(pState)
	{
		return ({ Live: 'validated', Stale: 'failed', Never: 'failed', Suspended: 'muted', None: 'failed' })[pState] || 'muted';
	}

	// Does this As-Built ride the deploy pipeline this page is about? An empty WorkspaceKey predates the
	// field and is read as the deployable workspace, which is what every such record actually was.
	// The key the server reported for this tenant, or the historical literal when it reported none.
	_deployableWorkspace() { return String(this._data().DeployableWorkspace || "") || _DEPLOYABLE_WORKSPACE_FALLBACK; }
	_isDeployable(pRow) { return !pRow.WorkspaceKey || String(pRow.WorkspaceKey) === this._deployableWorkspace(); }

	onBeforeRender(pRenderable)
	{
		let tmpD = this._data();
		let tmpDevTarget = 'dev';
		let tmpProdTarget = 'prod';
		let tmpAsBuilts = tmpD.AsBuilts || [];

		// What runs where: one card per environment, from EnvironmentState (the DB source of truth).
		let tmpEnvByName = {};
		(tmpD.Environments || []).forEach((pE) => { if (pE && pE.Environment) { tmpEnvByName[pE.Environment] = pE; } });
		tmpD.EnvCards = [tmpDevTarget, tmpProdTarget].map((pEnv) =>
		{
			let tmpRow = tmpEnvByName[pEnv] || {};
			return {
				Env: pEnv,
				Label: (pEnv === tmpProdTarget) ? 'Production' : 'Dev sandbox',
				Commit: tmpRow.CommitRef ? this._short(tmpRow.CommitRef) : '(nothing deployed)',
				Ago: tmpRow.DeployedDate ? this._ago(tmpRow.DeployedDate) : ''
			};
		});

		// Rebuilt every render, keyed by IDWorkItem, for _attachWorkItemTooltips to read once the rows it
		// describes are actually on screen (see _workItemLink).
		this._workItemTooltipData = {};

		// The As-Builts, grouped by where they sit in the pipeline. A row carries only what its template shows.
		let fRow = (pRow) =>
		{
			let tmpWI = this._workItemLink(pRow);
			return {
				IDAsBuilt: pRow.IDAsBuilt, Number: pRow.Number || pRow.AsBuiltNumber || pRow.IDAsBuilt,
				Title: pRow.Title || '', Status: pRow.Status || '', StatusClass: this._statusClass(pRow.Status),
				Environment: pRow.Environment || '', Commit: this._short(pRow.CommitHash),
				Workspace: pRow.WorkspaceKey || '',
				// 0-or-1 slots: a row either links to the Work Item it closed out, or falls back to the
				// As-Built's own number, never both.
				NumLinkSlot: tmpWI ? [tmpWI] : [],
				NumPlainSlot: tmpWI ? [] : [{ Number: pRow.Number || pRow.AsBuiltNumber || pRow.IDAsBuilt }]
			};
		};
		// The Built bucket carries two things the others do not: why a row is stuck, when the server could infer
		// it, and the manual way out. Both are 0-or-1-element slots so the row template renders them only when
		// they apply, the same way LoadErrorSlot does below. A person without content.approve sees the
		// explanation but no button, because the endpoint would refuse them anyway.
		let tmpCanApprove = !!tmpD.CanApprove;
		let fBuiltRow = (pRow) =>
		{
			let tmpBuilt = fRow(pRow);
			// The sentence comes from the SERVER now, because the server is the only side holding the evidence
			// for it -- the node's own account of which rows it examined and left behind (WI #368). This page
			// used to compose the sentence itself, from two timestamps, and it named a cause it had not
			// checked: on 2026-08-18 it told an operator that four As-Builts had never landed while their
			// commit was running in production. An older payload with no note falls back to what this page can
			// see for itself, which is that dev moved on and this did not, and stops there.
			tmpBuilt.StrandedSlot = pRow.Stranded
				? [{ Note: this._escape(pRow.StrandedNote
					|| ('Dev deployed ' + this._ago((tmpEnvByName[tmpDevTarget] || {}).DeployedDate)
						+ ' and this is still Built. Nothing here can say why.')) }]
				: [];
			// Rebind is offered only where the server has already proved it will work, and where it is offered
			// Supersede is taken AWAY (WI #369). A row whose commit is provably live is not a candidate for
			// retirement: superseding it would record that shipped, running work had been abandoned. On
			// 2026-08-18 four rows in exactly this state had Supersede as the only control on the page, and
			// the operator had to be talked out of the one button the software offered.
			tmpBuilt.RebindSlot = (tmpCanApprove && pRow.CanRebind) ? [{ IDAsBuilt: pRow.IDAsBuilt }] : [];
			tmpBuilt.SupersedeSlot = (tmpCanApprove && !pRow.CanRebind) ? [{ IDAsBuilt: pRow.IDAsBuilt }] : [];
			return tmpBuilt;
		};
		// "Built, not yet on dev" means WAITING FOR A DEPLOY, so only the workspace this pipeline deploys
		// belongs in it. A sibling-workspace record put there is a promise the deploy can never keep.
		tmpD.BuiltRows = tmpAsBuilts.filter((pRow) => pRow.Status === 'Built' && this._isDeployable(pRow)).map(fBuiltRow);
		tmpD.PendingRows = tmpAsBuilts.filter((pRow) => pRow.Status === 'Deployed').map(fRow);
		tmpD.ValidatedRows = tmpAsBuilts.filter((pRow) => pRow.Status === 'Validated').map(fRow);
		tmpD.PromotedRows = tmpAsBuilts.filter((pRow) => pRow.Status === 'Promoted').map(fRow).slice(0, 30);
		// Delivered elsewhere: shipped work whose commit is in another repository. Its own group, because
		// it is finished, not pending -- and it says which workspace, so the row explains itself.
		//
		// A sibling-workspace row still sitting at Built belongs here too, carrying its real status. An
		// older node stamped it Built before Delivered existed, and taking it out of the pending bucket
		// without putting it anywhere would make a deliverable vanish from the page entirely, which is the
		// same class of silence this work item is about. dev/backfill-asbuilt-workspace.js corrects the
		// status; until it runs, the row is at least visible and honest about what it says.
		tmpD.DeliveredRows = tmpAsBuilts
			.filter((pRow) => pRow.Status === 'Delivered' || (!this._isDeployable(pRow) && !!_PIPELINE_STATUSES[pRow.Status]))
			.map(fRow).slice(0, 30);
		tmpD.BuiltEmpty = tmpD.BuiltRows.length ? [] : [1];
		tmpD.PendingEmpty = tmpD.PendingRows.length ? [] : [1];
		tmpD.ValidatedEmpty = tmpD.ValidatedRows.length ? [] : [1];
		tmpD.PromotedEmpty = tmpD.PromotedRows.length ? [] : [1];
		// No empty-state line for Delivered: on a single-repo project it is always empty, and a permanent
		// "nothing here" under a heading nobody needed is worse than the heading not being there.
		tmpD.DeliveredSlot = tmpD.DeliveredRows.length ? [1] : [];

		// Node liveness (WI #296). The page used to infer it from the queue, which cannot be done: a request
		// sitting Requested is a healthy node between polls and a node that died an hour ago, drawn the same
		// way. The heartbeat answers it directly, so the strip reports what the nodes did and the queue is left
		// to report on itself. A tenant with no registered node gets the one sentence that matters instead of
		// an empty list that looks like everything is fine.
		let tmpFleet = tmpD.DeployFleet || null;
		tmpD.NodeRows = (tmpD.Nodes || []).map((pNode) => ({
			Host: pNode.Host || '',
			Roles: (pNode.Roles && pNode.Roles.length) ? pNode.Roles.join(', ') : 'no roles published',
			State: pNode.State || '',
			StateClass: this._nodeStateClass(pNode.State),
			// "polled 2m ago" for a node with a heartbeat, and the state word for one that has none, so a
			// column that is blank for a node that never started never reads as a node that is fine.
			Seen: pNode.SeenWords ? ('polled ' + pNode.SeenWords) : 'never polled'
		}));
		tmpD.FleetSlot = tmpFleet
			? [{ Note: tmpFleet.Note || '', State: tmpFleet.State || '', StateClass: this._nodeStateClass(tmpFleet.State) }]
			: [];
		let tmpFleetLive = !!tmpFleet && (tmpFleet.State === 'Live');
		// Only worth saying on a request nothing has claimed, and only when the fleet cannot claim it. On a
		// live fleet a queued request is simply waiting for the next poll, and saying so on every row would
		// train a person to read the note as decoration.
		let tmpQueuedNote = (tmpFleet && !tmpFleetLive) ? String(tmpFleet.Note || '') : '';

		// What each environment already has in flight, off the deploy request feed this page has already loaded.
		// No extra read: the rows are right here, and the rule for reading them is the same one the server
		// enforces on the way in.
		let tmpRequests = tmpD.DeployRequests || [];
		// A lane can be held by a deploy request OR by a run: pressing Promote queues a run of the
		// promote-prod toolchain, which never touches the request feed. Reading only the requests is
		// what let a queued promotion sit in the lane while this page went on offering the button --
		// the stale button WI #314 removed. Either kind of row holds the lane, so both are consulted,
		// and the request keeps precedence so the older surface's wording is unchanged where it applies.
		let tmpOpenRuns = tmpD.OpenRuns || [];
		let tmpProdInFlight = libLanes.findOpenDeployIn(tmpRequests, 'deploy:' + tmpProdTarget)
			|| libLanes.findOpenRunIn(tmpOpenRuns, 'toolchain:promote-prod');
		let tmpDevInFlight = libLanes.findOpenDeployIn(tmpRequests, 'deploy:' + tmpDevTarget)
			|| libLanes.findOpenRunIn(tmpOpenRuns, 'toolchain:deploy-dev');

		// Promote gating. The audited path is a fully-validated dev batch. But As-Builts are the audit trail,
		// not a hard gate: a real change can sit on dev with no As-Built at all (a hand deploy, or a commit with
		// no work item), and locking production out of that is the software demanding data it does not need. So a
		// promote is ALSO offered whenever dev is simply running a commit production is not -- it ships dev's
		// commit as-is. Only "dev and prod already match" truly has nothing to promote. See WI #330.
		let tmpDevCommit = String((tmpEnvByName[tmpDevTarget] || {}).CommitRef || '');
		let tmpProdCommit = String((tmpEnvByName[tmpProdTarget] || {}).CommitRef || '');
		let tmpDevBatch = tmpAsBuilts.filter((pRow) => pRow.Environment === tmpDevTarget && (pRow.Status === 'Deployed' || pRow.Status === 'Validated'));
		let tmpUnvalidated = tmpDevBatch.filter((pRow) => pRow.Status !== 'Validated');
		let tmpValidatedReady = (tmpDevBatch.length > 0 && tmpUnvalidated.length === 0);
		// Dev is running a commit production does not have (ahead or diverged) -- there is something to ship.
		let tmpDevAhead = !!tmpDevCommit && (tmpDevCommit !== tmpProdCommit);
		let tmpCanPromote = (tmpValidatedReady || tmpDevAhead);

		// An in-flight promotion outranks both. Ready and Blocked are both about whether there is anything to
		// ship; this is about the lane, and while the lane is busy neither of those questions is the one to answer.
		tmpD.PromoteInFlight = tmpProdInFlight
			? [{
				// A run and a deploy request are described in different words. describeDeploy reads the
				// row's Action to decide whether it is a promotion, and a run has no Action -- so calling
				// it for a run announces a dev deploy holding the production lane.
				Note: tmpProdInFlight.IDDeployRequest
					? libLanes.describeDeploy(tmpProdInFlight)
					: libLanes.describeRun(tmpProdInFlight),
				ForceSlot: tmpCanApprove ? [1] : []
			}]
			: [];
		// Which surface holds the lane, so "Show it" lands somewhere that can actually show it. A run is
		// not in the deploy request feed, and scrolling someone to an empty table is a dead end.
		tmpD.PromoteInFlightIDRun = (tmpProdInFlight && !tmpProdInFlight.IDDeployRequest)
			? (Number(tmpProdInFlight.IDRun) || 0) : 0;
		tmpD.PromoteReady = (!tmpProdInFlight && tmpCanPromote) ? [1] : [];
		tmpD.PromoteBlocked = (!tmpProdInFlight && !tmpCanPromote) ? [1] : [];
		// "is queued (12s ago)" for one nothing has picked up yet, "is running (queued 3m ago)" for one a node
		// took. Saying "queued" twice in one sentence is what the naive version did.
		tmpD.PromoteNote = tmpProdInFlight
			? ('Promotion #' + (tmpProdInFlight.Number || tmpProdInFlight.DeployRequestNumber
					|| tmpProdInFlight.IDDeployRequest || tmpProdInFlight.IDRun)
				+ ' is ' + libLanes.statusWords(tmpProdInFlight.Status)
				+ ' (' + ((tmpProdInFlight.Status === 'Requested') ? '' : 'queued ')
				+ this._ago(tmpProdInFlight.CreateDate || tmpProdInFlight.StartedDate) + ').')
			: tmpValidatedReady
				? (tmpDevBatch.length + ' validated on dev, ready to promote to production.')
				: tmpDevAhead
					? ('Dev is on ' + this._short(tmpDevCommit) + ', production on ' + (tmpProdCommit ? this._short(tmpProdCommit) : 'nothing')
						+ ' -- ' + (tmpDevBatch.length === 0 ? 'no As-Builts' : (tmpUnvalidated.length + ' of ' + tmpDevBatch.length + ' not validated'))
						+ '. Promoting ships dev\'s commit as-is.')
					: 'Dev and production already match; nothing to promote.';

		// The header's Deploy dev button gets the same treatment for its own lane.
		tmpD.DeployDevReady = tmpDevInFlight ? [] : [1];
		tmpD.DeployDevInFlight = tmpDevInFlight
			? [{ Label: 'Dev deploy #' + (tmpDevInFlight.Number || tmpDevInFlight.DeployRequestNumber
					|| tmpDevInFlight.IDDeployRequest || tmpDevInFlight.IDRun)
				+ ' ' + libLanes.statusWords(tmpDevInFlight.Status) }]
			: [];

		// How long the last ones took, so a person knows what they are in for before they click and whether
		// the one they are watching is running long. Read off the most recent SUCCEEDED deploy of each action:
		// a failed one stopped early and would report a fast deploy that never happened.
		let fLastDuration = (pAction) =>
		{
			let tmpDone = tmpRequests.filter((pRow) => (pRow.Action === pAction) && (pRow.Status === 'Succeeded') && (Number(pRow.DurationMs) > 0))[0];
			return tmpDone ? (((pAction === 'Promote') ? 'last promote ' : 'last dev deploy ') + this._dur(tmpDone.DurationMs)) : '';
		};
		let tmpDurations = [fLastDuration('DeployDev'), fLastDuration('Promote')].filter((pText) => pText);
		tmpD.DurationsSlot = tmpDurations.length ? [{ Note: tmpDurations.join(', ') + '.' }] : [];

		// The deploy request feed: what has been queued, is running, or recently finished.
		tmpD.RequestRows = (tmpD.DeployRequests || []).map((pRow) => ({
			Number: pRow.Number || pRow.DeployRequestNumber || pRow.IDDeployRequest,
			Action: pRow.Action || '', Environment: pRow.Environment || '',
			Status: pRow.Status || '', StatusClass: this._statusClass(pRow.Status),
			Commit: this._short(pRow.CommitRef), Ago: this._ago(pRow.CreateDate || pRow.StartedDate),
			// Only an OPEN request can be closed by hand: a node that died mid-run leaves one Running with
			// nothing alive to finish it. A request that already succeeded or failed said what happened, and
			// rewriting that would erase the outcome instead of cleaning anything up. Kept as a per-row slot so
			// the feed stays in its original order rather than being split into two lists.
			CancelSlot: (tmpCanApprove && (pRow.Status === 'Requested' || pRow.Status === 'Running'))
				? [{ IDDeployRequest: pRow.IDDeployRequest }] : [],
			// Why a queued request is not moving, when the answer is about the node rather than the queue.
			StalledSlot: ((pRow.Status === 'Requested') && tmpQueuedNote) ? [{ Note: tmpQueuedNote }] : [],
			// The live line: what the deploy last got through and how long it has been going, or how long it
			// took once it is over. A 0-or-1 slot, so a queued request that has done nothing yet stays quiet.
			TimingSlot: this._requestTiming(pRow),
			// The log the node wrote. Offered only when there is one, so a button never opens an empty box.
			LogSlot: (pRow.ResultLog && String(pRow.ResultLog).trim()) ? [{ IDDeployRequest: pRow.IDDeployRequest }] : []
		})).slice(0, 25);
		tmpD.RequestsEmpty = tmpD.RequestRows.length ? [] : [1];

		tmpD.LoadErrorSlot = tmpD.LoadError ? [{ Message: tmpD.LoadError }] : [];

		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._attachWorkItemTooltips();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/**
	 * The board's own hover card, anchored to every "WI-080" link this page just painted: same shape
	 * (a hand-built .ps-tip, matching Board's _tooltipHTML) so hovering a validation row shows exactly what
	 * hovering the card on the board would (WI #452).
	 *
	 * richTooltip, not Board's pinnableTooltip: pinnableTooltip listens for click ON THE ELEMENT IT IS
	 * GIVEN and calls preventDefault to pin/unpin, which on a real `<a href>` cancels the browser's own
	 * default action -- the navigation the second half of this work item asked for. Board never hits this
	 * because its card mark navigates through an onclick handler, not a real href, so there is nothing for
	 * preventDefault to cancel. This row's mark IS a real href on purpose (open in a new tab, or the
	 * current one, per WI #452), so it gets the plain hover-only tooltip instead.
	 *
	 * Rebuilt on every render rather than once: this page repaints its whole template on every refresh
	 * (including the 5s poll while a deploy is in flight -- see _ensurePolling), which replaces every row
	 * element, so a handle from the last paint is anchored to nothing. Destroying and re-collecting here is
	 * the same discipline Board's _attachCardTooltips uses for the same reason.
	 */
	_attachWorkItemTooltips()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.richTooltip !== 'function' || typeof document === 'undefined') { return; }

		this._destroyWorkItemTooltips();
		this._tooltipHandles = [];
		let tmpData = this._workItemTooltipData || {};
		let tmpElements = document.querySelectorAll('.ps-rel .ps-rel-num-link[data-idworkitem]');
		for (let i = 0; i < tmpElements.length; i++)
		{
			let tmpElement = tmpElements[i];
			let tmpRecord = tmpData[tmpElement.getAttribute('data-idworkitem')];
			if (!tmpRecord) { continue; }
			this._tooltipHandles.push(tmpModal.richTooltip(tmpElement, this._workItemTooltipHTML(tmpRecord),
				{ position: 'right', delay: 320, maxWidth: '400px', interactive: true }));
		}
	}

	_destroyWorkItemTooltips()
	{
		(this._tooltipHandles || []).forEach((pHandle) =>
		{
			try { if (pHandle && typeof pHandle.destroy === 'function') { pHandle.destroy(); } }
			catch (pError) { /* the element is already gone; nothing to tidy */ }
		});
		this._tooltipHandles = [];
	}

	// Leaving Releases for another page has to take its tooltips with it, the same reason Board tears its
	// own down (see PictView-Board.js teardown): a tooltip anchors to a row element, and once another view
	// paints over the workspace that anchor is detached and can never fire the mouseleave that would have
	// closed it. Wired from _setActiveNav in Pict-Application-Plansheet.js.
	teardown() { this._destroyWorkItemTooltips(); }

	// Built from the same mark and cell shape the board's own card tooltip uses (Pict-Provider-Markup's
	// tooltipMark), so this can never drift into a second description of what a Work Item's hover card
	// looks like.
	_workItemTooltipHTML(pData)
	{
		let tmpMarkup = this.pict.providers.Markup;
		if (!tmpMarkup) { return ''; }
		let tmpMark = tmpMarkup.tooltipMark('WorkItem',
			{ Title: pData.Title, WorkItemNumber: pData.Number, Description: pData.Description },
			{ Cells: [{ K: 'Type', V: pData.Type }, { K: 'Pri', V: pData.Priority }, { K: 'Status', V: pData.Status }] });
		let tmpCells = (tmpMark.Cells || []).map((pCell) =>
			'<div class="ps-cell"><span class="ps-cell-k">' + this._escape(pCell.K) + '</span>'
			+ '<span class="ps-cell-v">' + this._escape(pCell.V) + '</span></div>').join('');
		let tmpDescription = String(tmpMark.Description || '').slice(0, 400);
		return '<div class="ps-tip">'
			+ '<div class="ps-mark ' + this._escape(tmpMark.KindClass) + '">'
			+ '<span class="ps-mark-d">' + this._escape(tmpMark.Designator) + '</span>'
			+ '<span class="ps-mark-t">' + this._escape(tmpMark.Title) + '</span></div>'
			+ '<div class="ps-cells">' + tmpCells + '</div>'
			+ (tmpDescription ? ('<p class="ps-tip-desc">' + this._escape(tmpDescription) + '</p>') : '')
			+ '</div>';
	}

	// Entry point from the router: load then paint.
	show() { return this.refresh(); }

	// "Show it" on an in-flight lane: scroll the deploy request feed into view, where the row that is
	// holding the lane sits with its Cancel control. A plain #anchor href would be read by the hash
	// router as a route change, so this scrolls rather than navigating.
	showRequests()
	{
		if (typeof document === 'undefined') { return; }
		// A run holds the lane: the deploy request feed below has nothing to show, so go to the Runs page
		// where the run and its controls actually are.
		if (Number(this._data().PromoteInFlightIDRun) > 0)
		{
			if (this.pict.PictApplication && typeof this.pict.PictApplication.showRuns === 'function')
			{
				return this.pict.PictApplication.showRuns();
			}
		}
		let tmpSection = document.getElementById('ps-rel-requests');
		if (tmpSection && typeof tmpSection.scrollIntoView === 'function')
		{
			tmpSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	// Open the log a deploy node wrote for one request. The whole log is already in the page's store (the
	// Releases read carries it), so this opens what is on hand rather than going back to the server for text
	// that is already here. Escaped, because it is node-written text going into a dialog.
	showLog(pIDDeployRequest)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpRow = (this._data().DeployRequests || []).filter((pRow) => Number(pRow.IDDeployRequest) === Number(pIDDeployRequest))[0];
		if (!tmpRow) { return; }
		let tmpHeading = (tmpRow.Action || 'Deploy') + ' to ' + (tmpRow.Environment || '?')
			+ (tmpRow.CommitRef ? (' at ' + this._short(tmpRow.CommitRef)) : '')
			+ ((Number(tmpRow.DurationMs) > 0) ? (', took ' + this._dur(tmpRow.DurationMs)) : '');
		tmpModal.show(
		{
			title: 'Deploy #' + (tmpRow.Number || tmpRow.IDDeployRequest) + ' log',
			content: '<p style="font-size:12px;color:var(--theme-color-text-secondary,#5b6376);margin:0 0 8px;">'
				+ this._escape(tmpHeading) + '</p>'
				+ '<pre class="ps-rel-log">' + this._escape(tmpRow.ResultLog || '') + '</pre>',
			buttons: [{ Hash: 'close', Label: 'Close', Style: 'primary' }]
		});
	}

	refresh()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.loadReleases !== 'function') { this.render(); this._ensurePolling(); return Promise.resolve(); }
		// A transient fetch failure must not blank the pane: the loader parks its own error on AppData, and
		// this catch covers anything the render itself throws.
		return tmpAPI.loadReleases().then(() => { this.render(); this._ensurePolling(); }).catch(() => this.render());
	}

	// Keep the page live while a deploy is actually moving, so stage and elapsed tick without a person sitting
	// on the Refresh button. Self-terminating in both directions: it never starts unless something is in
	// flight, and it stops the moment the queue settles or you navigate off Releases. Same pattern and cadence
	// as the Runs page. setInterval rather than requestAnimationFrame so a backgrounded tab keeps up.
	_onReleasesPage() { return (typeof window !== 'undefined' && window.location && /^#?\/?releases\b/.test(String(window.location.hash || ''))); }
	// Whether anything is still moving, which is what keeps the page polling. A run counts: promoting is
	// a run now, so watching only the request feed meant the page sat still while a promotion ran and
	// never noticed it finish.
	_hasOpenRequest()
	{
		let tmpData = this._data();
		let fOpen = (pRow) => (pRow.Status === 'Requested') || (pRow.Status === 'Running');
		return ((tmpData.DeployRequests) || []).some(fOpen) || ((tmpData.OpenRuns) || []).some(fOpen);
	}
	_ensurePolling()
	{
		if (typeof window === 'undefined' || this._pollTimer) { return; }
		if (!this._onReleasesPage() || !this._hasOpenRequest()) { return; }
		let tmpSelf = this;
		this._pollTimer = setInterval(function ()
		{
			if (!tmpSelf._onReleasesPage() || !tmpSelf._hasOpenRequest()) { tmpSelf._stopPolling(); return; }
			tmpSelf.refresh();
		}, 5000);
	}
	_stopPolling() { if (this._pollTimer) { clearInterval(this._pollTimer); this._pollTimer = null; } }
}

module.exports = PictViewReleases;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Releases',
	DefaultRenderable: 'Plansheet-Releases',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-rel { padding: 20px 24px 60px; max-width: 1100px; }
		.ps-rel-head { display: flex; align-items: center; gap: 14px; margin-bottom: 16px; }
		.ps-rel-head h1 { font-size: 22px; font-weight: 600; margin: 0; flex: 1; color: var(--theme-color-text-primary, #2c3140); }
		.ps-rel-btn { padding: 7px 14px; font-size: 13px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-rel-btn:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-rel-btn-primary { background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-rel-btn-disabled { opacity: 0.5; cursor: not-allowed; }
		.ps-rel-btn-disabled:hover { border-color: var(--theme-color-border-default, #d8dde6); }
		/* The lane is busy. Reads as a live status, not as a disabled button: there is something to go look at. */
		.ps-rel-btn-inflight { border-color: #d99a2b; color: #b3781a;
			background: color-mix(in srgb, #d99a2b 12%, transparent); }
		.ps-rel-btn-inflight:hover { border-color: #b3781a; }
		.ps-rel-err { background: var(--theme-color-status-error, #cc3333); color: #fff; padding: 8px 12px; border-radius: 8px; margin-bottom: 14px; font-size: 13px; }
		.ps-rel-envs { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 22px; }
		.ps-rel-env { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 12px; padding: 14px 16px; }
		.ps-rel-env-label { font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-rel-env-commit { font-size: 20px; font-weight: 700; color: var(--theme-color-text-primary, #2c3140); line-height: 1.2; margin-top: 3px;
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-rel-env-when { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); margin-top: 1px; }
		.ps-rel-promote { display: flex; align-items: center; gap: 12px; background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 12px; padding: 12px 16px; margin-bottom: 22px; }
		.ps-rel-promote-note { flex: 1; font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-rel-section { margin-bottom: 24px; }
		.ps-rel-section-title { font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 8px; }
		.ps-rel-empty { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 13px; padding: 8px 2px; }
		.ps-rel-row { display: flex; gap: 10px; align-items: baseline; padding: 8px 12px; border: 1px solid var(--theme-color-border-light, #e7ecf0);
			border-radius: 8px; margin-bottom: 7px; background: var(--theme-color-background-panel, #fff); }
		.ps-rel-num { flex: 0 0 auto; font-weight: 700; font-size: 12px; color: var(--theme-color-text-secondary, #8a93a6); min-width: 34px; }
		/* The "WI-080" link that replaces the bare As-Built number (WI #452): the mark itself (.ps-mark-solo,
		   from Markup-Templates) already reads as a designator, so this only needs to say "clickable". */
		.ps-rel-num-link { flex: 0 0 auto; min-width: 34px; text-decoration: none; cursor: pointer; }
		.ps-rel-num-link:hover .ps-mark-solo { text-decoration: underline dotted; text-underline-offset: 2px; }
		.ps-rel-title { flex: 1; min-width: 0; font-size: 13px; color: var(--theme-color-text-primary, #2c3140); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-rel-commit { flex: 0 0 auto; font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-rel-when { flex: 0 0 auto; font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); }
		.ps-rel-badge { flex: 0 0 auto; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 999px; text-transform: uppercase; letter-spacing: 0.03em; }
		.ps-rel-badge.built { background: color-mix(in srgb, #8a93a6 16%, transparent); color: #5b6376; }
		.ps-rel-badge.deployed { background: color-mix(in srgb, var(--theme-color-brand-primary, #3b6fd4) 15%, transparent); color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-rel-badge.running { background: color-mix(in srgb, #d99a2b 18%, transparent); color: #b3781a; }
		.ps-rel-badge.validated { background: color-mix(in srgb, var(--theme-color-status-success, #3fae5a) 16%, transparent); color: #2f8a46; }
		.ps-rel-badge.promoted { background: color-mix(in srgb, #7b5cd6 16%, transparent); color: #6a48c8; }
		/* Delivered: finished work, but not by this pipeline. Teal keeps it plainly distinct from the
		   green of validated and the purple of promoted, both of which mean "this pipeline shipped it". */
		.ps-rel-badge.delivered { background: color-mix(in srgb, #2f8f8f 16%, transparent); color: #237070; }
		.ps-rel-workspace { flex: 0 0 auto; font-size: 11px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376);
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-rel-badge.failed { background: color-mix(in srgb, var(--theme-color-status-error, #cc3333) 15%, transparent); color: var(--theme-color-status-error, #cc3333); }
		.ps-rel-badge.muted { background: color-mix(in srgb, #8a93a6 12%, transparent); color: #8a93a6; }
		.ps-rel-validate { flex: 0 0 auto; padding: 4px 10px; font-size: 12px; cursor: pointer; border: 1px solid var(--theme-color-brand-primary, #3b6fd4);
			border-radius: 6px; background: transparent; color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-rel-validate:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #3b6fd4) 10%, transparent); }
		.ps-rel-row-built { flex-wrap: wrap; }
		.ps-rel-stranded { flex: 0 0 100%; font-size: 12px; line-height: 1.4; margin-top: 5px;
			color: var(--theme-color-text-secondary, #8a93a6); }
		.ps-rel-supersede { flex: 0 0 auto; font-size: 12px; padding: 3px 9px; cursor: pointer;
			border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; background: transparent;
			color: var(--theme-color-text-secondary, #5b6376); }
		.ps-rel-supersede:hover { border-color: var(--theme-color-status-error, #cc3333); color: var(--theme-color-status-error, #cc3333); }
		/* The node strip. Deliberately plain: it answers one question (is anything polling) and must not
		   compete with the environment cards for the eye. */
		.ps-rel-nodes { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e7ecf0);
			border-radius: 12px; padding: 12px 16px; margin-bottom: 22px; }
		.ps-rel-nodes-note { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-rel-node { display: flex; gap: 10px; align-items: baseline; font-size: 12px; margin-top: 7px; }
		.ps-rel-node-host { font-weight: 600; color: var(--theme-color-text-primary, #2c3140);
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-rel-node-roles { color: var(--theme-color-text-secondary, #8a93a6); flex: 1; min-width: 0; }
		.ps-rel-node-seen { color: var(--theme-color-text-secondary, #8a93a6); }
		/* The live line under a deploy request: what it last got through and how long it has been at it. */
		.ps-rel-timing { flex: 0 0 100%; font-size: 12px; line-height: 1.4; margin-top: 4px;
			color: var(--theme-color-text-secondary, #8a93a6); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-rel-durations { font-size: 12px; color: var(--theme-color-text-secondary, #8a93a6); margin: -4px 0 8px; }
		.ps-rel-log { white-space: pre-wrap; word-break: break-word; max-height: 60vh; overflow: auto; margin: 0;
			font-size: 12px; line-height: 1.45; color: var(--theme-color-text-primary, #2c3140);
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
			background: var(--theme-color-background-secondary, #f6f8fa); border: 1px solid var(--theme-color-border-light, #e7ecf0);
			border-radius: 8px; padding: 10px 12px; }
		@media (max-width: 820px) { .ps-rel-envs { grid-template-columns: 1fr; } }
	` + libMarkup.MarkupCSS,
	Templates:
	[
		...libMarkup.MarkupTemplates,
		{
			Hash: 'Plansheet-Releases',
			Template: /*html*/`
<div class="ps-rel">
	<div class="ps-rel-head">
		<h1>Releases</h1>
		{~TS:Releases-DeployDevReady:AppData.Releases.DeployDevReady~}
		{~TS:Releases-DeployDevInFlight:AppData.Releases.DeployDevInFlight~}
		<button class="ps-rel-btn" onclick="_Pict.views['Plansheet-Releases'].refresh()">Refresh</button>
	</div>
	{~TS:Releases-LoadError:AppData.Releases.LoadErrorSlot~}

	<div class="ps-rel-envs">{~TS:Releases-EnvCard:AppData.Releases.EnvCards~}</div>

	{~TS:Releases-Fleet:AppData.Releases.FleetSlot~}

	<div class="ps-rel-promote">
		<span class="ps-rel-promote-note">{~D:AppData.Releases.PromoteNote~}</span>
		{~TS:Releases-PromoteReady:AppData.Releases.PromoteReady~}
		{~TS:Releases-PromoteBlocked:AppData.Releases.PromoteBlocked~}
		{~TS:Releases-PromoteInFlight:AppData.Releases.PromoteInFlight~}
	</div>

	<div class="ps-rel-section">
		<p class="ps-rel-section-title">On dev, awaiting validation</p>
		{~TS:Releases-PendingEmpty:AppData.Releases.PendingEmpty~}
		{~TS:Releases-PendingRow:AppData.Releases.PendingRows~}
	</div>

	<div class="ps-rel-section">
		<p class="ps-rel-section-title">Validated, ready to promote</p>
		{~TS:Releases-ValidatedEmpty:AppData.Releases.ValidatedEmpty~}
		{~TS:Releases-Row:AppData.Releases.ValidatedRows~}
	</div>

	<div class="ps-rel-section">
		<p class="ps-rel-section-title">Built, not yet on dev</p>
		{~TS:Releases-BuiltEmpty:AppData.Releases.BuiltEmpty~}
		{~TS:Releases-BuiltRow:AppData.Releases.BuiltRows~}
	</div>

	{~TS:Releases-Delivered:AppData.Releases.DeliveredSlot~}

	<div class="ps-rel-section">
		<p class="ps-rel-section-title">Recently promoted</p>
		{~TS:Releases-PromotedEmpty:AppData.Releases.PromotedEmpty~}
		{~TS:Releases-Row:AppData.Releases.PromotedRows~}
	</div>

	<div class="ps-rel-section" id="ps-rel-requests">
		<p class="ps-rel-section-title">Deploy requests</p>
		{~TS:Releases-Durations:AppData.Releases.DurationsSlot~}
		{~TS:Releases-RequestsEmpty:AppData.Releases.RequestsEmpty~}
		{~TS:Releases-RequestRow:AppData.Releases.RequestRows~}
	</div>
</div>`
		},
		{ Hash: 'Releases-LoadError', Template: /*html*/`<div class="ps-rel-err">Could not load releases: {~D:Record.Message~}</div>` },
		{ Hash: 'Releases-EnvCard', Template: /*html*/`<div class="ps-rel-env"><div class="ps-rel-env-label">{~D:Record.Label~}</div><div class="ps-rel-env-commit">{~D:Record.Commit~}</div><div class="ps-rel-env-when">{~D:Record.Ago~}</div></div>` },
		{ Hash: 'Releases-PromoteReady', Template: /*html*/`<button class="ps-rel-btn ps-rel-btn-primary" onclick="_Pict.PictApplication.promoteToProd()">Promote to prod</button>` },
		{ Hash: 'Releases-PromoteBlocked', Template: /*html*/`<button class="ps-rel-btn ps-rel-btn-disabled" disabled>Promote to prod</button>` },
		// The lane is busy. No Promote button at all, because a button that will be refused is what got a promote
		// queued twice in the first place. "Show it" jumps to the request in the feed below, which already carries
		// the Cancel control for a node that died holding the lane.
		{
			Hash: 'Releases-PromoteInFlight',
			Template: /*html*/`<button class="ps-rel-btn" onclick="_Pict.views['Plansheet-Releases'].showRequests()">Show it</button>{~TS:Releases-PromoteForce:Record.ForceSlot~}`
		},
		{ Hash: 'Releases-PromoteForce', Template: /*html*/`<button class="ps-rel-supersede" onclick="_Pict.PictApplication.promoteToProdAnyway()">Promote anyway</button>` },
		{ Hash: 'Releases-DeployDevReady', Template: /*html*/`<button class="ps-rel-btn" onclick="_Pict.PictApplication.deployDev()">Deploy dev</button>` },
		{
			Hash: 'Releases-DeployDevInFlight',
			Template: /*html*/`<button class="ps-rel-btn ps-rel-btn-inflight" title="One dev deploy at a time. This one is still going." onclick="_Pict.views['Plansheet-Releases'].showRequests()">{~D:Record.Label~}</button>`
		},
		// The number cell is one of two 0-or-1 slots (see _workItemLink): a link to the Work Item the
		// As-Built closed out, or -- for the older rows that predate that link -- the As-Built's own number,
		// exactly as it always rendered.
		{ Hash: 'Releases-NumLink', Template: /*html*/`<a class="ps-rel-num-link" href="#/work-item/{~D:Record.IDWorkItem~}" data-idworkitem="{~D:Record.IDWorkItem~}" title="Open">{~TS:Markup-Designator:Record.MarkSlot~}</a>` },
		{ Hash: 'Releases-NumPlain', Template: /*html*/`<span class="ps-rel-num">#{~D:Record.Number~}</span>` },
		{ Hash: 'Releases-Row', Template: /*html*/`<div class="ps-rel-row">{~TS:Releases-NumLink:Record.NumLinkSlot~}{~TS:Releases-NumPlain:Record.NumPlainSlot~}<span class="ps-rel-title">{~D:Record.Title~}</span><span class="ps-rel-commit">{~D:Record.Commit~}</span><span class="ps-rel-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span></div>` },
		// Delivered elsewhere. The whole section is one slot, so a project with a single repository never
		// sees a heading that would only ever be empty. Each row names its workspace, because "delivered"
		// with no repository named is the same missing answer this work item is about.
		{
			Hash: 'Releases-Delivered',
			Template: /*html*/`
	<div class="ps-rel-section">
		<p class="ps-rel-section-title">Delivered elsewhere, not on this pipeline</p>
		{~TS:Releases-DeliveredRow:AppData.Releases.DeliveredRows~}
	</div>`
		},
		{ Hash: 'Releases-DeliveredRow', Template: /*html*/`<div class="ps-rel-row">{~TS:Releases-NumLink:Record.NumLinkSlot~}{~TS:Releases-NumPlain:Record.NumPlainSlot~}<span class="ps-rel-title">{~D:Record.Title~}</span><span class="ps-rel-workspace">{~D:Record.Workspace~}</span><span class="ps-rel-commit">{~D:Record.Commit~}</span><span class="ps-rel-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span></div>` },
		{ Hash: 'Releases-PendingRow', Template: /*html*/`<div class="ps-rel-row">{~TS:Releases-NumLink:Record.NumLinkSlot~}{~TS:Releases-NumPlain:Record.NumPlainSlot~}<span class="ps-rel-title">{~D:Record.Title~}</span><span class="ps-rel-commit">{~D:Record.Commit~}</span><span class="ps-rel-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span><button class="ps-rel-validate" onclick="_Pict.PictApplication.validateAsBuilt('AsBuilt', {~D:Record.IDAsBuilt~})">Validate</button></div>` },
		{ Hash: 'Releases-RequestRow', Template: /*html*/`<div class="ps-rel-row ps-rel-row-built"><span class="ps-rel-num">#{~D:Record.Number~}</span><span class="ps-rel-title">{~D:Record.Action~} &middot; {~D:Record.Environment~}</span><span class="ps-rel-commit">{~D:Record.Commit~}</span><span class="ps-rel-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span><span class="ps-rel-when">{~D:Record.Ago~}</span>{~TS:Releases-Log:Record.LogSlot~}{~TS:Releases-Cancel:Record.CancelSlot~}{~TS:Releases-Timing:Record.TimingSlot~}{~TS:Releases-Stalled:Record.StalledSlot~}</div>` },
		// A built row can say why it is stuck and offer the way out. Both parts are slots, so an unstuck row
		// renders exactly what it always did.
		{ Hash: 'Releases-BuiltRow', Template: /*html*/`<div class="ps-rel-row ps-rel-row-built">{~TS:Releases-NumLink:Record.NumLinkSlot~}{~TS:Releases-NumPlain:Record.NumPlainSlot~}<span class="ps-rel-title">{~D:Record.Title~}</span><span class="ps-rel-commit">{~D:Record.Commit~}</span><span class="ps-rel-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span>{~TS:Releases-Rebind:Record.RebindSlot~}{~TS:Releases-Supersede:Record.SupersedeSlot~}{~TS:Releases-Stranded:Record.StrandedSlot~}</div>` },
		// Node liveness. The badge carries the state and the sentence carries what to do about it; both come
		// from the heartbeat, so neither is inferred from how much work happens to be queued.
		{
			Hash: 'Releases-Fleet',
			Template: /*html*/`
	<div class="ps-rel-nodes">
		<span class="ps-rel-badge {~D:Record.StateClass~}">{~D:Record.State~}</span>
		<span class="ps-rel-nodes-note">{~D:Record.Note~}</span>
		{~TS:Releases-Node:AppData.Releases.NodeRows~}
	</div>`
		},
		{
			Hash: 'Releases-Node',
			Template: /*html*/`<div class="ps-rel-node"><span class="ps-rel-node-host">{~D:Record.Host~}</span><span class="ps-rel-node-roles">{~D:Record.Roles~}</span><span class="ps-rel-node-seen">{~D:Record.Seen~}</span><span class="ps-rel-badge {~D:Record.StateClass~}">{~D:Record.State~}</span></div>`
		},
		{ Hash: 'Releases-Stalled', Template: /*html*/`<span class="ps-rel-stranded">{~D:Record.Note~}</span>` },
		{ Hash: 'Releases-Durations', Template: /*html*/`<p class="ps-rel-durations">{~D:Record.Note~}</p>` },
		{ Hash: 'Releases-Timing', Template: /*html*/`<span class="ps-rel-timing">{~D:Record.Timing~}</span>` },
		{ Hash: 'Releases-Log', Template: /*html*/`<button class="ps-rel-supersede" onclick="_Pict.views['Plansheet-Releases'].showLog({~D:Record.IDDeployRequest~})">Log</button>` },
		{ Hash: 'Releases-Stranded', Template: /*html*/`<span class="ps-rel-stranded">{~D:Record.Note~}</span>` },
		{ Hash: 'Releases-Supersede', Template: /*html*/`<button class="ps-rel-supersede" onclick="_Pict.PictApplication.supersedeAsBuilt({~D:Record.IDAsBuilt~})">Supersede</button>` },
		// Rebind reads as the constructive action it is, not as the retirement next to it.
		{ Hash: 'Releases-Rebind', Template: /*html*/`<button class="ps-rel-validate" onclick="_Pict.PictApplication.rebindAsBuilt({~D:Record.IDAsBuilt~})">Rebind</button>` },
		{ Hash: 'Releases-Cancel', Template: /*html*/`<button class="ps-rel-supersede" onclick="_Pict.PictApplication.cancelDeployRequest({~D:Record.IDDeployRequest~})">Cancel</button>` },
		{ Hash: 'Releases-PendingEmpty', Template: /*html*/`<p class="ps-rel-empty">Nothing is on dev waiting to validate.</p>` },
		{ Hash: 'Releases-ValidatedEmpty', Template: /*html*/`<p class="ps-rel-empty">Nothing validated and waiting.</p>` },
		{ Hash: 'Releases-BuiltEmpty', Template: /*html*/`<p class="ps-rel-empty">Nothing built and waiting for a dev deploy.</p>` },
		{ Hash: 'Releases-PromotedEmpty', Template: /*html*/`<p class="ps-rel-empty">Nothing promoted yet.</p>` },
		{ Hash: 'Releases-RequestsEmpty', Template: /*html*/`<p class="ps-rel-empty">No deploy requests yet.</p>` }
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-Releases',
			TemplateHash: 'Plansheet-Releases',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"../SingleFlightLanes.js":570,"./Markup-Templates.js":650,"pict-view":365}],695:[function(require,module,exports){
'use strict';

/**
 * RichDocEditor — plansheet's rich markdown editor. It is pict-section-markdowneditor
 * (CodeMirror 6, segmented, with a pict-section-content preview that understands
 * KaTeX math, Mermaid diagrams, and embedded images/drawings) subclassed to:
 *   - route pasted / dragged / phone-camera images through Parime (onImageUpload),
 *   - add an "Insert drawing" toolbar button that opens the Excalidraw editor, and
 *   - notify the DocEditor host on every change so it can debounce-autosave.
 *
 * It is hosted inside PictView-DocEditor (which owns the title/type/save chrome)
 * and mounts into #DocEditor-EditorHost, bound to AppData.RichDocEditor.Segments.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-RichDocEditor';
	tmpConfig.DefaultDestinationAddress = '#DocEditor-EditorHost';
	tmpConfig.TargetElementAddress = '#DocEditor-EditorHost';
	tmpConfig.ContentDataAddress = 'AppData.RichDocEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'side';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#DocEditor-EditorHost';
		}
	}

	// Add a drawing button to the per-segment top-right toolbar (after the
	// built-in bold/italic/code/heading/link/image actions).
	tmpConfig.ButtonsTR = (tmpConfig.ButtonsTR || []).slice();
	tmpConfig.ButtonsTR.push({ HTML: '✎', Action: 'insertDrawing', Class: 'pict-mde-button-drawing', Title: 'Insert a drawing' });

	return tmpConfig;
}

class PictViewRichDocEditor extends libMarkdownEditor
{
	_host() { return this.pict.views['Plansheet-DocEditor']; }
	_ownerContext() { let tmpHost = this._host(); return (tmpHost && typeof tmpHost.ownerContext === 'function') ? tmpHost.ownerContext() : { OwnerType: '', IDOwner: 0 }; }

	/**
	 * Pasted / dragged / picked image -> upload to Parime, owned by the doc's
	 * entity (so it lives in that entity's media gallery), and insert the blob
	 * URL. Returning true = async handling; returning false falls back to the
	 * base64 embed.
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		let tmpOwner = this._ownerContext();
		if (!tmpOwner.IDOwner) { return false; }
		this.pict.providers.MediaAPI.upload(tmpOwner.OwnerType, tmpOwner.IDOwner, pFile)
			.then((pRow) => fCallback(null, this.pict.providers.MediaAPI.blobURL(pRow.IDMedia)))
			.catch((pErr) => fCallback(pErr.message || String(pErr)));
		return true;
	}

	/** Toolbar "Insert drawing" -> open the Excalidraw editor; on save insert it. */
	insertDrawing(pSegmentIndex)
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp.showDrawingEditor !== 'function') { return; }
		let tmpOwner = this._ownerContext();
		tmpApp.showDrawingEditor({ OwnerType: tmpOwner.OwnerType, IDOwner: tmpOwner.IDOwner, IDMedia: 0 }, (pResult) =>
		{
			if (pResult && pResult.URL)
			{
				this._insertImageMarkdown(pSegmentIndex, pResult.URL, pResult.Title || 'drawing');
			}
		});
	}

	onContentChange(pSegmentIndex, pContent)
	{
		let tmpHost = this._host();
		if (tmpHost && typeof tmpHost.onEditorChanged === 'function') { tmpHost.onEditorChanged(); }
	}
}

module.exports = PictViewRichDocEditor;
module.exports.default_configuration = buildConfiguration();

},{"pict-section-markdowneditor":261}],696:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libMarkdownRender = require('./MarkdownRender.js');

/**
 * RoutineSteps — the ordered step editor embedded on a Routine's detail page
 * (EntityDetail mounts it into #Routine-Steps when the descriptor says
 * Steps: true). Each step is a card: title, a markdown body with an
 * Edit/Preview toggle (paste or drop an image straight into the textarea to
 * upload it), an optional expected result, and a media strip (screenshots and
 * videos, Media OwnerType 'RoutineStep'). Steps reorder with up/down buttons;
 * a move renumbers SortOrder for every step that shifted, so the order is
 * always clean. Field edits save on change (blur); there is no save button.
 *
 * Read-only mode (no content.edit) renders the same cards with rendered
 * bodies and no inputs.
 */
class PictViewRoutineSteps extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._IDRoutine = 0;
		this._Editable = false;
		this._LoadToken = 0;
		this._raw = [];      // RoutineStep rows, sorted by SortOrder
		this._media = {};    // IDRoutineStep -> Media rows
		this._modes = {};    // IDRoutineStep -> 'edit' | 'preview'
		this.pict.AppData.RoutineSteps = this.pict.AppData.RoutineSteps ||
			{ IDRoutine: 0, Editable: false, Steps: [], EmptySlot: [], AddSlot: [] };
	}

	_stepAPI() { return this.pict.providers.RoutineStepAPI; }
	_mediaAPI() { return this.pict.providers.MediaAPI; }

	// ── entry + load ─────────────────────────────────────────────────────────
	show(pIDRoutine, pEditable)
	{
		this._IDRoutine = Number(pIDRoutine) || 0;
		this._Editable = !!pEditable;
		this._modes = {};
		this._load();
	}

	_load()
	{
		let tmpToken = ++this._LoadToken;
		if (!this._IDRoutine || !this._stepAPI()) { return; }
		this._stepAPI().listForRoutine(this._IDRoutine)
			.then((pSteps) =>
			{
				if (tmpToken !== this._LoadToken) { return null; }
				this._raw = pSteps || [];
				return Promise.all(this._raw.map((pStep) =>
					this._mediaAPI().listForOwner('RoutineStep', pStep.IDRoutineStep)
						.then((pRows) => { this._media[pStep.IDRoutineStep] = pRows || []; })));
			})
			.then(() =>
			{
				if (tmpToken !== this._LoadToken) { return; }
				this._rebuild();
				this.render();
			});
	}

	// Refresh one step's media strip without refetching every step.
	_loadMediaFor(pID)
	{
		this._mediaAPI().listForOwner('RoutineStep', pID)
			.then((pRows) => { this._media[pID] = pRows || []; this._rebuild(); this.render(); });
	}

	_rawStep(pID) { return this._raw.find((pStep) => String(pStep.IDRoutineStep) === String(pID)) || null; }

	// ── build the AppData model from the raw caches (no fetch) ──────────────
	_rebuild()
	{
		let tmpState = this.pict.AppData.RoutineSteps;
		tmpState.IDRoutine = this._IDRoutine;
		tmpState.Editable = this._Editable;
		tmpState.Steps = this._raw.map((pStep, pIdx) =>
		{
			let tmpID = pStep.IDRoutineStep;
			// First open: empty bodies start in edit mode (type immediately),
			// written ones start in preview (read the routine comfortably).
			if (!this._modes[tmpID]) { this._modes[tmpID] = (this._Editable && !String(pStep.Body || '').trim()) ? 'edit' : 'preview'; }
			let tmpMode = this._Editable ? this._modes[tmpID] : 'preview';
			let tmpMedia = (this._media[tmpID] || []).map((pM) =>
			{
				let tmpIsImage = (String(pM.MimeType || '').indexOf('image/') === 0) || (pM.MediaType === 'Screenshot');
				let tmpIsVideo = String(pM.MimeType || '').indexOf('video/') === 0;
				let tmpURL = '/1.0/Media/' + pM.IDMedia + '/Blob';
				let tmpTitle = pM.Title || pM.OriginalFileName || ('Media #' + pM.IDMedia);
				return (
				{
					ID: pM.IDMedia, StepID: tmpID,
					ImageSlot: tmpIsImage ? [{ URL: tmpURL, Title: tmpTitle }] : [],
					VideoSlot: tmpIsVideo ? [{ URL: tmpURL, Title: tmpTitle }] : [],
					FileSlot: (tmpIsImage || tmpIsVideo) ? [] : [{ URL: tmpURL, Title: tmpTitle, Type: pM.MediaType || 'file' }],
					RemoveSlot: this._Editable ? [{ ID: pM.IDMedia, StepID: tmpID }] : []
				});
			});
			let tmpExpected = String(pStep.ExpectedResult || '');
			return (
			{
				ID: tmpID,
				Idx: pIdx + 1,
				Title: String(pStep.Title || ''),
				Body: String(pStep.Body || ''),
				Expected: tmpExpected,
				BodyContainerID: 'RS-Body-' + tmpID,
				HeadEditSlot: this._Editable ? [{
					ID: tmpID, Idx: pIdx + 1, Title: String(pStep.Title || ''),
					UpSlot: (pIdx > 0) ? [{ ID: tmpID }] : [],
					DownSlot: (pIdx < this._raw.length - 1) ? [{ ID: tmpID }] : [],
					ToggleLabel: (tmpMode === 'edit') ? 'Preview' : 'Edit'
				}] : [],
				HeadViewSlot: this._Editable ? [] : [{ Idx: pIdx + 1, Title: String(pStep.Title || '') }],
				BodyEditSlot: (this._Editable && tmpMode === 'edit') ? [{ ID: tmpID, Body: String(pStep.Body || '') }] : [],
				BodyPreviewSlot: (tmpMode === 'preview') ? [{ ID: tmpID, ContainerID: 'RS-Body-' + tmpID }] : [],
				ExpectedEditSlot: this._Editable ? [{ ID: tmpID, Expected: tmpExpected }] : [],
				ExpectedViewSlot: (!this._Editable && tmpExpected) ? [{ Expected: tmpExpected }] : [],
				Media: tmpMedia,
				UploadSlot: this._Editable ? [{ ID: tmpID }] : []
			});
		});
		tmpState.EmptySlot = tmpState.Steps.length ? [] : [{}];
		tmpState.AddSlot = this._Editable ? [{}] : [];
	}

	// ── field edits (oninput -> raw cache; onchange -> save) ────────────────
	setTitle(pID, pValue) { let tmpStep = this._rawStep(pID); if (tmpStep) { tmpStep.Title = pValue; } }
	setBody(pID, pValue) { let tmpStep = this._rawStep(pID); if (tmpStep) { tmpStep.Body = pValue; } }
	setExpected(pID, pValue) { let tmpStep = this._rawStep(pID); if (tmpStep) { tmpStep.ExpectedResult = pValue; } }

	saveStep(pID)
	{
		let tmpStep = this._rawStep(pID);
		if (!tmpStep) { return; }
		this._stepAPI().update(pID, { Title: tmpStep.Title || '', Body: tmpStep.Body || '', ExpectedResult: tmpStep.ExpectedResult || '' })
			.catch((pErr) => this._toast('Step save failed: ' + (pErr.message || pErr), 'error'));
	}

	togglePreview(pID)
	{
		this._modes[pID] = (this._modes[pID] === 'edit') ? 'preview' : 'edit';
		this._rebuild();
		this.render();
	}

	// ── structure edits ──────────────────────────────────────────────────────
	addStep()
	{
		let tmpMax = this._raw.reduce((pMax, pStep) => Math.max(pMax, Number(pStep.SortOrder) || 0), 0);
		this._stepAPI().create(
			{
				IDRoutine: this._IDRoutine,
				Title: 'Step ' + (this._raw.length + 1),
				Body: '',
				ExpectedResult: '',
				SortOrder: tmpMax + 10
			})
			.then(() => this._load())
			.catch((pErr) => this._toast('Could not add a step: ' + (pErr.message || pErr), 'error'));
	}

	moveUp(pID) { this._move(pID, -1); }
	moveDown(pID) { this._move(pID, 1); }

	// Reorder by renumbering: shift the step in the in-memory order, then persist
	// SortOrder = (index+1)*10 for every step whose number changed. Self-healing
	// for duplicate SortOrders.
	_move(pID, pDelta)
	{
		let tmpIdx = this._raw.findIndex((pStep) => String(pStep.IDRoutineStep) === String(pID));
		let tmpNewIdx = tmpIdx + pDelta;
		if (tmpIdx < 0 || tmpNewIdx < 0 || tmpNewIdx >= this._raw.length) { return; }
		let tmpOrder = this._raw.slice();
		tmpOrder.splice(tmpIdx, 1);
		tmpOrder.splice(tmpNewIdx, 0, this._raw[tmpIdx]);
		let tmpWrites = [];
		for (let i = 0; i < tmpOrder.length; i++)
		{
			let tmpWanted = (i + 1) * 10;
			if ((Number(tmpOrder[i].SortOrder) || 0) !== tmpWanted)
			{
				tmpOrder[i].SortOrder = tmpWanted;
				tmpWrites.push(this._stepAPI().update(tmpOrder[i].IDRoutineStep, { SortOrder: tmpWanted }));
			}
		}
		this._raw = tmpOrder;
		this._rebuild();
		this.render();
		Promise.all(tmpWrites).catch((pErr) => { this._toast('Reorder failed: ' + (pErr.message || pErr), 'error'); this._load(); });
	}

	removeStep(pID)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () => this._stepAPI().remove(pID)
			.then(() => this._load())
			.catch((pErr) => this._toast('Delete failed: ' + (pErr.message || pErr), 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Delete this step?', { dangerous: true }).then((pOk) => { if (pOk) tmpDo(); });
		}
		else { tmpDo(); }
	}

	// ── media ────────────────────────────────────────────────────────────────
	uploadMedia(pID, pFiles)
	{
		let tmpFiles = Array.prototype.slice.call(pFiles || []);
		if (!tmpFiles.length) { return; }
		this._toast('Uploading ' + tmpFiles.length + ' file' + (tmpFiles.length > 1 ? 's' : '') + '…', 'info');
		Promise.all(tmpFiles.map((pFile) => this._mediaAPI().upload('RoutineStep', pID, pFile)))
			.then(() => { this._toast('Uploaded.', 'success'); this._loadMediaFor(pID); })
			.catch((pErr) => this._toast('Upload failed: ' + (pErr.message || pErr), 'error'));
	}

	removeMedia(pID, pIDMedia)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () => this._mediaAPI().remove(pIDMedia)
			.then(() => this._loadMediaFor(pID))
			.catch((pErr) => this._toast('Remove failed: ' + (pErr.message || pErr), 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Remove this media?', { dangerous: true }).then((pOk) => { if (pOk) tmpDo(); });
		}
		else { tmpDo(); }
	}

	// Paste or drop a file onto a step's body textarea: upload it against the
	// step and insert a markdown reference at the cursor.
	bodyPaste(pEvent, pTextarea, pID)
	{
		let tmpFiles = (pEvent && pEvent.clipboardData && pEvent.clipboardData.files) || [];
		if (!tmpFiles.length) { return; }
		pEvent.preventDefault();
		this._uploadIntoBody(pTextarea, pID, tmpFiles);
	}

	bodyDrop(pEvent, pTextarea, pID)
	{
		let tmpFiles = (pEvent && pEvent.dataTransfer && pEvent.dataTransfer.files) || [];
		if (!tmpFiles.length) { return; }
		pEvent.preventDefault();
		this._uploadIntoBody(pTextarea, pID, tmpFiles);
	}

	_uploadIntoBody(pTextarea, pID, pFiles)
	{
		let tmpFile = pFiles[0];
		if (!tmpFile) { return; }
		this._toast('Uploading ' + (tmpFile.name || 'file') + '…', 'info');
		this._mediaAPI().upload('RoutineStep', pID, tmpFile)
			.then((pRow) =>
			{
				let tmpURL = '/1.0/Media/' + pRow.IDMedia + '/Blob';
				let tmpIsImage = String(tmpFile.type || '').indexOf('image/') === 0;
				let tmpName = tmpFile.name || (tmpIsImage ? 'image' : 'file');
				let tmpSnippet = (tmpIsImage ? ('![' + tmpName + '](' + tmpURL + ')') : ('[' + tmpName + '](' + tmpURL + ')'));
				let tmpStart = (pTextarea && typeof pTextarea.selectionStart === 'number') ? pTextarea.selectionStart : ((pTextarea && pTextarea.value) || '').length;
				if (pTextarea)
				{
					pTextarea.value = pTextarea.value.slice(0, tmpStart) + '\n' + tmpSnippet + '\n' + pTextarea.value.slice(tmpStart);
					this.setBody(pID, pTextarea.value);
				}
				this.saveStep(pID);
				this._toast('Uploaded.', 'success');
				this._loadMediaFor(pID);
			})
			.catch((pErr) => this._toast('Upload failed: ' + (pErr.message || pErr), 'error'));
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		// Render markdown bodies for the steps in preview mode.
		if (typeof document !== 'undefined')
		{
			let tmpSteps = (this.pict.AppData.RoutineSteps && this.pict.AppData.RoutineSteps.Steps) || [];
			for (let i = 0; i < tmpSteps.length; i++)
			{
				if (!tmpSteps[i].BodyPreviewSlot.length) { continue; }
				let tmpHost = document.getElementById(tmpSteps[i].BodyContainerID);
				if (!tmpHost) { continue; }
				libMarkdownRender.renderInto(this.pict.providers.Content, tmpHost, tmpSteps[i].Body,
					'<span class="ps-rel-empty">Nothing written for this step yet.</span>');
			}
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewRoutineSteps;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-RoutineSteps',
	DefaultRenderable: 'RoutineSteps-Container',
	AutoRender: false,
	CSS: /*css*/`
		.ps-steps { display: flex; flex-direction: column; gap: 12px; }
		.ps-step-card {
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #e6e9ee);
			border-radius: 10px; padding: 14px 16px;
		}
		.ps-step-head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
		.ps-step-num {
			flex: 0 0 auto; width: 26px; height: 26px; border-radius: 999px; display: inline-flex;
			align-items: center; justify-content: center; font-size: 13px; font-weight: 600;
			background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff);
		}
		.ps-step-title-input { flex: 1; font-weight: 600; }
		.ps-step-title-view { flex: 1; font-size: 15px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
		.ps-step-body { width: 100%; min-height: 88px; resize: vertical; font-family: var(--theme-typography-family-mono, monospace); font-size: 13px; box-sizing: border-box; }
		.ps-step-preview { border: 1px dashed transparent; border-radius: 8px; padding: 2px 0; }
		.ps-step-preview img, .ps-step-preview video { max-width: 100%; border-radius: 6px; }
		.ps-step-expected { margin-top: 10px; }
		.ps-step-expected-label { display: block; font-size: 11px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 5px; }
		.ps-step-expected-input { display: block; width: 100%; box-sizing: border-box; min-height: 88px; resize: vertical; line-height: 1.5; }
		.ps-step-expected-text {
			white-space: pre-wrap; word-break: break-word;
			font-size: 13px; line-height: 1.5; color: var(--theme-color-text-primary, #2c3140);
			background: var(--theme-color-background-secondary, #f6f8fa);
			border-left: 3px solid var(--theme-color-brand-primary, #2988df);
			border-radius: 6px; padding: 8px 12px;
		}
		.ps-step-media { margin-top: 10px; }
		.ps-step-foot { display: flex; align-items: center; gap: 8px; margin-top: 10px; }
		.ps-steps-empty { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); font-style: italic; }
		.ps-steps-add { margin-top: 2px; }
	`,
	Templates:
	[
		{
			Hash: 'RoutineSteps-Container',
			Template: /*html*/`
<div class="ps-steps">
	{~TS:RS-Card:AppData.RoutineSteps.Steps~}
	{~TS:RS-Empty:AppData.RoutineSteps.EmptySlot~}
	{~TS:RS-Add:AppData.RoutineSteps.AddSlot~}
</div>`
		},
		{
			Hash: 'RS-Card',
			Template: /*html*/`
<div class="ps-step-card">
	{~TS:RS-HeadEdit:Record.HeadEditSlot~}
	{~TS:RS-HeadView:Record.HeadViewSlot~}
	{~TS:RS-BodyEdit:Record.BodyEditSlot~}
	{~TS:RS-BodyPreview:Record.BodyPreviewSlot~}
	{~TS:RS-ExpectedEdit:Record.ExpectedEditSlot~}
	{~TS:RS-ExpectedView:Record.ExpectedViewSlot~}
	<div class="ps-media-grid ps-step-media">{~TS:RS-MediaItem:Record.Media~}</div>
	{~TS:RS-Upload:Record.UploadSlot~}
</div>`
		},
		{
			Hash: 'RS-HeadEdit',
			Template: /*html*/`
<div class="ps-step-head">
	<span class="ps-step-num">{~D:Record.Idx~}</span>
	<input type="text" class="ps-input ps-step-title-input" value="{~D:Record.Title~}" placeholder="What to do"
		oninput="_Pict.views['Plansheet-RoutineSteps'].setTitle({~D:Record.ID~}, this.value)"
		onchange="_Pict.views['Plansheet-RoutineSteps'].saveStep({~D:Record.ID~})">
	<button class="ps-btn ps-btn-sm" onclick="_Pict.views['Plansheet-RoutineSteps'].togglePreview({~D:Record.ID~})">{~D:Record.ToggleLabel~}</button>
	{~TS:RS-UpBtn:Record.UpSlot~}
	{~TS:RS-DownBtn:Record.DownSlot~}
	<button class="ps-btn ps-btn-sm ps-btn-danger" title="Delete step" onclick="_Pict.views['Plansheet-RoutineSteps'].removeStep({~D:Record.ID~})">Delete</button>
</div>`
		},
		{ Hash: 'RS-HeadView', Template: /*html*/`<div class="ps-step-head"><span class="ps-step-num">{~D:Record.Idx~}</span><span class="ps-step-title-view">{~D:Record.Title~}</span></div>` },
		{ Hash: 'RS-UpBtn', Template: /*html*/`<button class="ps-btn ps-btn-sm" title="Move up" onclick="_Pict.views['Plansheet-RoutineSteps'].moveUp({~D:Record.ID~})">Up</button>` },
		{ Hash: 'RS-DownBtn', Template: /*html*/`<button class="ps-btn ps-btn-sm" title="Move down" onclick="_Pict.views['Plansheet-RoutineSteps'].moveDown({~D:Record.ID~})">Down</button>` },
		{
			Hash: 'RS-BodyEdit',
			Template: /*html*/`<textarea class="ps-input ps-step-body" placeholder="Markdown. Paste or drop a screenshot to upload it."
	oninput="_Pict.views['Plansheet-RoutineSteps'].setBody({~D:Record.ID~}, this.value)"
	onchange="_Pict.views['Plansheet-RoutineSteps'].saveStep({~D:Record.ID~})"
	onpaste="_Pict.views['Plansheet-RoutineSteps'].bodyPaste(event, this, {~D:Record.ID~})"
	ondragover="event.preventDefault()"
	ondrop="_Pict.views['Plansheet-RoutineSteps'].bodyDrop(event, this, {~D:Record.ID~})">{~D:Record.Body~}</textarea>`
		},
		{ Hash: 'RS-BodyPreview', Template: /*html*/`<div class="ps-step-preview" id="{~D:Record.ContainerID~}"></div>` },
		{
			Hash: 'RS-ExpectedEdit',
			Template: /*html*/`
<div class="ps-step-expected">
	<span class="ps-step-expected-label">Expect</span>
	<textarea class="ps-input ps-step-expected-input" placeholder="Expected result (optional)"
		oninput="_Pict.views['Plansheet-RoutineSteps'].setExpected({~D:Record.ID~}, this.value)"
		onchange="_Pict.views['Plansheet-RoutineSteps'].saveStep({~D:Record.ID~})">{~D:Record.Expected~}</textarea>
</div>`
		},
		{ Hash: 'RS-ExpectedView', Template: /*html*/`<div class="ps-step-expected"><span class="ps-step-expected-label">Expect</span><div class="ps-step-expected-text">{~D:Record.Expected~}</div></div>` },
		{ Hash: 'RS-MediaItem', Template: /*html*/`<div class="ps-media-item">{~TS:RS-MediaImage:Record.ImageSlot~}{~TS:RS-MediaVideo:Record.VideoSlot~}{~TS:RS-MediaFile:Record.FileSlot~}{~TS:RS-MediaRemove:Record.RemoveSlot~}</div>` },
		{ Hash: 'RS-MediaImage', Template: /*html*/`<a href="{~D:Record.URL~}" target="_blank" rel="noopener"><img class="ps-media-thumb" src="{~D:Record.URL~}" alt="{~D:Record.Title~}" title="{~D:Record.Title~}"></a>` },
		{ Hash: 'RS-MediaVideo', Template: /*html*/`<video class="ps-media-video" controls preload="metadata" src="{~D:Record.URL~}" title="{~D:Record.Title~}"></video>` },
		{ Hash: 'RS-MediaFile', Template: /*html*/`<a class="ps-link ps-media-file" href="{~D:Record.URL~}" target="_blank" rel="noopener"><span class="ps-media-file-type">{~D:Record.Type~}</span>{~D:Record.Title~}</a>` },
		{ Hash: 'RS-MediaRemove', Template: /*html*/`<button class="ps-chip-x ps-media-x" title="Remove" onclick="_Pict.views['Plansheet-RoutineSteps'].removeMedia({~D:Record.StepID~},{~D:Record.ID~})">×</button>` },
		{
			Hash: 'RS-Upload',
			Template: /*html*/`<div class="ps-step-foot"><label class="ps-btn ps-btn-sm ps-file-btn">+ Media<input type="file" multiple accept="image/*,video/*" style="display:none" onchange="_Pict.views['Plansheet-RoutineSteps'].uploadMedia({~D:Record.ID~}, this.files)"></label></div>`
		},
		{ Hash: 'RS-Empty', Template: /*html*/`<div class="ps-steps-empty">No steps yet.</div>` },
		{ Hash: 'RS-Add', Template: /*html*/`<div class="ps-steps-add"><button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-RoutineSteps'].addStep()">+ Add step</button></div>` }
	],
	Renderables:
	[
		{
			RenderableHash: 'RoutineSteps-Container',
			TemplateHash: 'RoutineSteps-Container',
			ContentDestinationAddress: '#Routine-Steps'
		}
	]
};

},{"./MarkdownRender.js":649,"pict-view":365}],697:[function(require,module,exports){
'use strict';

/**
 * Runs -- the graphical consent surface for toolchain runs (Vision 43). One read (GET /1.0/RunQueue via
 * providers.RunAPI) backs the whole page: every run in flight, the steps the platform snapshotted for it,
 * and the evidence a node attached to each step.
 *
 * The point of the page is the gate. When a node reaches a human-gated step it does the preparatory work,
 * attaches a screenshot of what it is about to act on, parks the step at AwaitingConsent, and leaves. The
 * step shows up here with that screenshot inline and the node's note in plain words, and a person with
 * content.approve answers it. Nothing about the decision happens in the browser beyond the answer: approving
 * flips the run back to Running and a later node tick does the work.
 *
 * A toolchain already carrying a run does not offer "Start a run". A run parked at AwaitingConsent is not
 * idle, it is holding that pipeline while it waits for a person, and starting a second run of the same chain
 * is how a node ends up claiming the newer one and walking it past the gate the older one is still sitting
 * at. The card says which run has the chain and what it is waiting on instead (SingleFlightLanes carries the
 * rule, shared with the server that enforces it).
 *
 * Deliberately plain. This is the minimum that makes graphical consent real: read the evidence, approve or
 * reject. A richer run timeline is a follow-on.
 */

const libPictView = require('pict-view');
const libLanes = require('../SingleFlightLanes.js');

// Step statuses that read as finished, so the card can lead with the one that is not.
const _STEP_DONE = { Succeeded: true, Skipped: true, Failed: true };
// Run statuses that read as finished, so polling stops once nothing is moving.
const _RUN_TERMINAL = { Succeeded: true, Failed: true, Cancelled: true };
// Two heartbeat cadences, two stale marks (WI #351 fix B). A worker phase beats every 30s while its node process
// is alive, so a beat older than 90s means those beats stopped -- the node is down. A run-role step parked on the
// deploy lane is different: its heartbeat only refreshes when a node tick re-processes it (~5 min apart), so it is
// quiet between ticks by design. Calling that "stalled" at 90s is the false positive a healthy promote showed. It
// is only really down once even the once-per-tick touch has stopped for well past a tick -- the 12-minute mark the
// server's stuck-run diagnosis already uses (NodeCapability.diagnoseStuckRun).
const _BEAT_STALE_MS = 90000;
const _LANE_STALE_MS = 720000;

class PictViewRuns extends libPictView
{
	_data() { return this.pict.AppData.Runs || {}; }
	_api() { return this.pict.providers.RunAPI; }

	_ms(pValue)
	{
		if (!pValue) { return 0; }
		let tmpString = String(pValue);
		let tmpParsed = Date.parse(tmpString);
		if (!isNaN(tmpParsed)) { return tmpParsed; }
		tmpParsed = Date.parse(tmpString.replace(' ', 'T') + 'Z');
		return isNaN(tmpParsed) ? 0 : tmpParsed;
	}

	_ago(pValue)
	{
		let tmpMs = this._ms(pValue);
		if (!tmpMs) { return ''; }
		let tmpSeconds = Math.floor((Date.now() - tmpMs) / 1000);
		if (tmpSeconds < 0) { tmpSeconds = 0; }
		if (tmpSeconds < 60) { return tmpSeconds + 's ago'; }
		let tmpMinutes = Math.floor(tmpSeconds / 60);
		if (tmpMinutes < 60) { return tmpMinutes + 'm ago'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		if (tmpHours < 24) { return tmpHours + 'h ago'; }
		return Math.floor(tmpHours / 24) + 'd ago';
	}

	// A compact duration ("45s", "2m", "1h 3m") for elapsed / how-long-it-took. Distinct from _ago (a point in
	// the past): this is a span. Negative or zero reads as 0s.
	_dur(pMs)
	{
		let tmpSeconds = Math.max(0, Math.floor((Number(pMs) || 0) / 1000));
		if (tmpSeconds < 60) { return tmpSeconds + 's'; }
		let tmpMinutes = Math.floor(tmpSeconds / 60);
		if (tmpMinutes < 60) { return tmpMinutes + 'm'; }
		let tmpHours = Math.floor(tmpMinutes / 60);
		let tmpRemMinutes = tmpMinutes % 60;
		return tmpRemMinutes ? (tmpHours + 'h ' + tmpRemMinutes + 'm') : (tmpHours + 'h');
	}

	// The live one-liner under a step: the node's stage + elapsed while it runs, or how long it took once finished.
	// A 0-or-1 slot, so a not-yet-started step stays quiet. A step parked on the deploy lane reads as waiting, not
	// running, and is held to the lane cadence rather than the 90s worker-beat cadence, so it is not called stalled
	// just for being quiet between ticks. is-stalled is set only on a genuine stall, for the CSS to flag (WI #351).
	_stepTiming(pStep)
	{
		let tmpStarted = this._ms(pStep.StartedDate);
		if (pStep.Status === 'Running' && tmpStarted)
		{
			let tmpBeat = this._ms(pStep.HeartbeatDate);
			let tmpSince = tmpBeat ? (Date.now() - tmpBeat) : 0;
			let tmpStage = pStep.StageLabel || '';
			let tmpStalled = '';
			let tmpText;
			if (String(pStep.RefType || '') === 'DeployRequest')
			{
				// Parked on the deploy lane: it beats once per node tick, so it is quiet between ticks by design.
				// Read it as waiting, and only call the node down once even that once-per-tick touch has stopped.
				tmpText = (tmpStage || 'waiting for the deploy lane') + ' - waiting ' + this._dur(Date.now() - tmpStarted);
				if (tmpBeat && tmpSince > _LANE_STALE_MS) { tmpText += ' - no node has touched it in ' + this._dur(tmpSince) + ' (node may be down)'; tmpStalled = ' is-stalled'; }
			}
			else
			{
				// Actively working on the node: a worker phase beats every 30s, so a beat past 90s means it stopped.
				tmpText = (tmpStage ? (tmpStage + ' - ') : '') + 'running ' + this._dur(Date.now() - tmpStarted);
				if (tmpBeat)
				{
					tmpText += ' - beat ' + this._dur(tmpSince) + ' ago';
					if (tmpSince > _BEAT_STALE_MS) { tmpText += ' (node may be stalled)'; tmpStalled = ' is-stalled'; }
				}
			}
			return [{ Timing: this._escape(tmpText), Stalled: tmpStalled }];
		}
		if (_STEP_DONE[pStep.Status] && tmpStarted)
		{
			let tmpFinished = this._ms(pStep.FinishedDate);
			if (tmpFinished && tmpFinished >= tmpStarted) { return [{ Timing: 'took ' + this._dur(tmpFinished - tmpStarted), Stalled: '' }]; }
		}
		return [];
	}

	// Everything this page shows was written by a node or by whoever authored the toolchain, and the
	// templates interpolate raw. On the one surface whose job is to show a person trustworthy evidence
	// before they approve an action, text that can rewrite the page is not acceptable: a log line
	// reading "<button>Approve</button>" would render as one. Escape on the way in.
	_escape(pValue)
	{
		return String(pValue == null ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

	_statusClass(pStatus)
	{
		let tmpMap =
		{
			Requested: 'queued', Pending: 'queued', Running: 'running', AwaitingConsent: 'gated',
			Approved: 'gated', Succeeded: 'ok', Failed: 'failed', Cancelled: 'muted', Skipped: 'muted'
		};
		return tmpMap[pStatus] || 'muted';
	}

	// "lands in plansheet (main), may write ./dist, may run git" -- the declared scope in one readable
	// line, so a person approving a step can see what it is allowed to touch without opening the
	// toolchain.
	//
	// Workspaces lead, because they are the part with the largest consequence and the only part the
	// node enforces: approving a step that declares two workspaces is approving a push to two
	// repositories. A person cannot judge that from a line that does not mention it.
	_scopeLine(pScope)
	{
		let tmpScope = pScope || {};
		let tmpParts = [];
		let tmpFS = tmpScope.FS || {};
		let fList = (pArray) => pArray.map((pEntry) => this._escape(pEntry)).join(', ');
		if (Array.isArray(tmpScope.Workspaces) && tmpScope.Workspaces.length)
		{
			tmpParts.push('lands in ' + tmpScope.Workspaces
				.map((pWorkspace) => this._escape(pWorkspace && pWorkspace.Key)
					+ ' (' + this._escape((pWorkspace && pWorkspace.Trunk) || 'main') + ')')
				.join(', '));
		}
		if (Array.isArray(tmpFS.Write) && tmpFS.Write.length) { tmpParts.push('writes ' + fList(tmpFS.Write)); }
		if (Array.isArray(tmpFS.Read) && tmpFS.Read.length) { tmpParts.push('reads ' + fList(tmpFS.Read)); }
		if (Array.isArray(tmpScope.Commands) && tmpScope.Commands.length) { tmpParts.push('runs ' + fList(tmpScope.Commands)); }
		if (Array.isArray(tmpScope.Net) && tmpScope.Net.length) { tmpParts.push('reaches ' + fList(tmpScope.Net)); }
		return tmpParts.length ? ('Scope: ' + tmpParts.join('; ') + '.') : 'Scope: nothing declared.';
	}

	onBeforeRender(pRenderable)
	{
		let tmpD = this._data();
		let tmpCanApprove = !!tmpD.CanApprove;

		// The catalog: what this tenant can run, and what running it will do. A platform entry has not
		// been adopted yet (the first run adopts it); an organization entry is a real tenant row that
		// can be edited. Drifted means the platform edited the built-in after this tenant copied it.
		tmpD.ToolchainCards = (tmpD.Toolchains || []).map((pChain, pIndex) =>
		{
			let tmpGated = Number(pChain.GatedCount) || 0;
			let tmpSteps = Number(pChain.StepCount) || 0;
			// One run of a chain at a time. The runs are already loaded on this page, and the rule for
			// reading them is the same one Run/Start enforces, so the card can answer without another read.
			let tmpInFlight = libLanes.findOpenRunIn(tmpD.Runs || [], 'toolchain:' + String(pChain.Key || ''));
			return {
				Index: pIndex,
				Key: this._escape(pChain.Key || ''),
				Name: this._escape(pChain.Name || pChain.Key || ''),
				Description: this._escape(pChain.Description || ''),
				Tier: this._escape(pChain.Tier || ''),
				TierClass: (pChain.Tier === 'Platform') ? 'queued' : 'running',
				Version: Number(pChain.Version) || 1,
				// Say plainly how much of this a person has to answer for.
				Shape: tmpSteps
					? (tmpSteps + ' step' + (tmpSteps === 1 ? '' : 's') + ', '
						+ (tmpGated ? (tmpGated + ' waiting on you') : 'none waiting on you'))
					: 'no steps yet',
				StepChips: (pChain.Steps || []).map((pStep) => (
				{
					Label: this._escape(pStep.Title || pStep.StepKey || ''),
					Gate: (pStep.GateMode === 'gated') ? 'gated' : 'auto',
					GateClass: (pStep.GateMode === 'gated') ? 'gated' : 'muted'
				})),
				// Which repositories starting this run puts commits into. A slot rather than a string,
				// so a toolchain that declares none renders nothing at all instead of an empty label
				// that would read as an answer.
				WorkspaceSlot: (pChain.Workspaces || []).length
					? [{ Label: 'Lands in ' + pChain.Workspaces
						.map((pWorkspace) => this._escape(pWorkspace.Key) + ' (' + this._escape(pWorkspace.Trunk || 'main') + ')')
						.join(', ') }]
					: [],
				DriftSlot: pChain.Drifted ? [1] : [],
				Runnable: (tmpSteps && !tmpInFlight) ? [{ Index: pIndex }] : [],
				// What has the chain, in the words the server would use if you got past this card and hit
				// the 409 anyway. "Start anyway" is the operator override: it costs content.approve and a
				// written reason, and the run it starts carries a run.forced beat saying it jumped a queue.
				InFlightSlot: tmpInFlight
					? [{
						Label: 'Run #' + (tmpInFlight.Number || tmpInFlight.RunNumber || tmpInFlight.IDRun) + ' is '
							+ libLanes.statusWords(tmpInFlight.Status),
						ForceSlot: tmpCanApprove ? [{ Index: pIndex }] : []
					}]
					: []
			};
		});
		tmpD.ToolchainsEmpty = tmpD.ToolchainCards.length ? [] : [1];
		tmpD.CatalogErrorSlot = tmpD.CatalogError ? [{ Message: this._escape(tmpD.CatalogError) }] : [];

		// How long past runs of each toolchain took, so an in-flight one can say "typically ~4m" and a person
		// knows whether the wait is normal. Median of finished runs' StartedDate->FinishedDate per ToolchainKey.
		let tmpDurations = {};
		(tmpD.Runs || []).forEach((pRun) =>
		{
			if (!_RUN_TERMINAL[pRun.Status || '']) { return; }
			let tmpStartMs = this._ms(pRun.StartedDate);
			let tmpFinishMs = this._ms(pRun.FinishedDate);
			if (tmpStartMs && tmpFinishMs && tmpFinishMs > tmpStartMs)
			{
				(tmpDurations[pRun.ToolchainKey || ''] = tmpDurations[pRun.ToolchainKey || ''] || []).push(tmpFinishMs - tmpStartMs);
			}
		});
		let tmpTypical = {};
		Object.keys(tmpDurations).forEach((pKey) =>
		{
			let tmpSorted = tmpDurations[pKey].sort((pA, pB) => pA - pB);
			tmpTypical[pKey] = tmpSorted[Math.floor(tmpSorted.length / 2)];
		});

		let tmpAllCards = (tmpD.Runs || []).map((pRun) =>
		{
			let tmpSteps = (pRun.Steps || []).map((pStep) =>
			{
				let tmpAwaiting = (pStep.Status === 'AwaitingConsent');
				return {
					IDRunStep: pStep.IDRunStep,
					Order: pStep.SortOrder,
					Title: this._escape(pStep.Title || pStep.StepKey || ''),
					StepKey: this._escape(pStep.StepKey || ''),
					Kind: this._escape(pStep.Kind + (pStep.ToolRef ? (' / ' + pStep.ToolRef) : '')),
					Status: pStep.Status || 'Pending',
					StatusClass: this._statusClass(pStep.Status),
					Gate: (pStep.GateMode === 'gated') ? 'gated' : 'auto',
					// The live one-liner under a running step (stage + elapsed + how fresh the heartbeat is), or
					// how long a finished step took. Empty for a step that has not started (WI #351).
					TimingSlot: this._stepTiming(pStep),
					Ref: pStep.RefType ? this._escape(pStep.RefType + ' ' + pStep.IDRef) : '',
					Log: this._escape(pStep.Log || ''),
					LogSlot: pStep.Log ? [{ Log: this._escape(pStep.Log) }] : [],
					Scope: this._scopeLine(pStep.Scope),
					Evidence: (pStep.Evidence || []).map((pMedia) => ({ IDMedia: Number(pMedia.IDMedia) || 0, Title: this._escape(pMedia.Title || 'Evidence') })),
					// The consent controls appear only on a step that is actually waiting, and only for
					// someone who may answer. A viewer without content.approve sees why instead of a
					// button that would 403.
					ConsentSlot: (tmpAwaiting && tmpCanApprove) ? [{ IDRunStep: pStep.IDRunStep }] : [],
					ConsentDeniedSlot: (tmpAwaiting && !tmpCanApprove) ? [1] : [],
					DecisionSlot: pStep.ConsentDecision
						? [{ Decision: this._escape(pStep.ConsentDecision), Note: this._escape(pStep.ConsentNote || '') }]
						: []
				};
			});

			let tmpNext = tmpSteps.filter((pStep) => !_STEP_DONE[pStep.Status])[0];
			let tmpRunTerminal = !!_RUN_TERMINAL[pRun.Status || ''];
			let tmpRunStartedMs = this._ms(pRun.StartedDate);
			let tmpRunFinishedMs = this._ms(pRun.FinishedDate);
			// Lowercased haystack for the client-side filter over finished runs (number, name, toolchain, status).
			let tmpSearch = this._escape(('run #' + (pRun.Number || '') + ' ' + (pRun.Name || '') + ' '
				+ (pRun.ToolchainKey || '') + ' ' + (pRun.Status || '')).toLowerCase());
			return {
				IDRun: pRun.IDRun,
				Number: pRun.Number,
				Name: this._escape(pRun.Name || ''),
				ToolchainKey: this._escape(pRun.ToolchainKey || ''),
				Status: pRun.Status || '',
				StatusClass: this._statusClass(pRun.Status),
				// A finished run reads by when it finished plus how long it took ("finished 56m ago · took 4m"),
				// which answers "how long did the last ones take"; an in-flight one reads by when it started.
				Ago: tmpRunTerminal
					? ('finished ' + this._ago(pRun.FinishedDate || pRun.CreateDate) + ((tmpRunStartedMs && tmpRunFinishedMs) ? (' · took ' + this._dur(tmpRunFinishedMs - tmpRunStartedMs)) : ''))
					: this._ago(pRun.StartedDate || pRun.CreateDate),
				// Live run-level elapsed while it is moving ("running 2m"). Empty once the run is finished.
				Elapsed: (!tmpRunTerminal && tmpRunStartedMs) ? ('running ' + this._dur(Date.now() - tmpRunStartedMs)) : '',
				// How long this toolchain usually takes, shown only while running so a person knows what to wait for.
				TypicalSlot: (!tmpRunTerminal && tmpTypical[pRun.ToolchainKey || '']) ? [{ Typical: 'typically ~' + this._dur(tmpTypical[pRun.ToolchainKey || '']) }] : [],
				NodeHost: this._escape(pRun.NodeHost || ''),
				Position: tmpNext
					? ('at step ' + tmpNext.Order + ' of ' + tmpSteps.length + ': ' + tmpNext.Title)
					: (tmpSteps.length + ' of ' + tmpSteps.length + ' steps done'),
				// Why a run is sitting unclaimed, from the server (which node could take it and what is missing).
				// Only for an in-flight run; the server only fills it once the run has actually waited a while.
				WaitingSlot: (pRun.WaitingReason && !tmpRunTerminal) ? [{ Reason: this._escape(pRun.WaitingReason) }] : [],
				// Stop a run going wrong, without SSH-ing into the node (Work Item #451). Only offered on a
				// Running run to someone who could answer a gate -- the server gates the route the same way.
				// A cancel already requested but not yet noticed shows as "stopping" instead of a second button,
				// so a slow heartbeat does not read as the click having done nothing.
				CancelSlot: (pRun.Status === 'Running' && tmpCanApprove && !pRun.CancelRequested) ? [{ IDRun: pRun.IDRun }] : [],
				StoppingSlot: (pRun.Status === 'Running' && pRun.CancelRequested) ? [1] : [],
				Steps: tmpSteps,
				// Fields the split/sort below reads; the underscored ones are internal and no template references them.
				Terminal: tmpRunTerminal,
				Search: tmpSearch,
				_StartedMs: tmpRunStartedMs,
				_FinishedMs: tmpRunFinishedMs,
				_Gated: (pRun.Status === 'AwaitingConsent')
			};
		});

		// Active runs (anything not finished) lead the page, above the catalog: a gated run needs you and a running
		// one is what you came to watch, so neither should sit below a scroll of toolchains and history. A run
		// awaiting consent sorts to the very top; otherwise most-recently-started first.
		tmpD.ActiveRunCards = tmpAllCards.filter((pCard) => !pCard.Terminal)
			.sort((pA, pB) => (pA._Gated === pB._Gated) ? (pB._StartedMs - pA._StartedMs) : (pA._Gated ? -1 : 1));
		// Finished runs collapse into a compact, searchable list, newest first; each row expands in place for its
		// steps and logs. This keeps the page scannable once dozens of runs have piled up.
		tmpD.FinishedRunCards = tmpAllCards.filter((pCard) => pCard.Terminal)
			.sort((pA, pB) => (pB._FinishedMs || 0) - (pA._FinishedMs || 0));
		if (typeof tmpD.FinishedFilter !== 'string') { tmpD.FinishedFilter = ''; }
		tmpD.ActiveTitleSlot = tmpD.ActiveRunCards.length ? [{ Count: tmpD.ActiveRunCards.length }] : [];
		tmpD.FinishedTitleSlot = tmpD.FinishedRunCards.length ? [{ Filter: tmpD.FinishedFilter }] : [];
		tmpD.RunsEmpty = (tmpD.ActiveRunCards.length + tmpD.FinishedRunCards.length) ? [] : [1];
		tmpD.LoadErrorSlot = tmpD.LoadError ? [{ Message: tmpD.LoadError }] : [];

		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		// A poll-driven re-render repaints the finished list from scratch; re-apply the filter so hidden rows stay
		// hidden and the box keeps working mid-typing-session while a run is live.
		if (typeof document !== 'undefined')
		{
			let tmpInput = document.querySelector('.ps-runs-search');
			if (tmpInput && tmpInput.value) { this.filterFinished(tmpInput.value); }
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// Expand or collapse a finished run's detail in place. The compact list stays scannable, but any run's steps
	// and logs are one click away without leaving the page.
	toggleRun(pElement)
	{
		if (typeof document === 'undefined' || !pElement || !pElement.closest) { return; }
		let tmpWrap = pElement.closest('.ps-runs-mini-wrap');
		if (tmpWrap) { tmpWrap.classList.toggle('is-open'); }
	}

	// Client-side filter over the finished-run rows: hide any whose search text does not contain the query. Pure
	// DOM, so typing never re-renders the page (which would drop the input's focus) and makes no server traffic.
	// The raw query is stashed on AppData so a re-render restores the box value and onAfterRender re-applies it.
	filterFinished(pQuery)
	{
		if (typeof document === 'undefined') { return; }
		let tmpRaw = String(pQuery == null ? '' : pQuery);
		this._data().FinishedFilter = this._escape(tmpRaw);
		let tmpQuery = tmpRaw.trim().toLowerCase();
		let tmpRows = document.querySelectorAll('.ps-runs-mini-wrap');
		for (let i = 0; i < tmpRows.length; i++)
		{
			let tmpText = String(tmpRows[i].getAttribute('data-search') || '');
			tmpRows[i].style.display = (!tmpQuery || tmpText.indexOf(tmpQuery) >= 0) ? '' : 'none';
		}
	}

	// Entry point from the router: load, paint, and keep it live while a run is moving.
	show() { let tmpPromise = this.refresh(); this._ensurePolling(); return tmpPromise; }

	refresh()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || typeof tmpAPI.loadRuns !== 'function') { this.render(); return Promise.resolve(); }
		// A transient fetch failure must not blank the pane: each loader resolves with its own error
		// parked on AppData, and this catch covers anything the render itself throws. The catalog and
		// the runs load together so one slow read does not paint the page twice.
		return Promise.all([tmpAPI.loadRuns(), tmpAPI.loadToolchains()])
			.then(() => { this.render(); this._ensurePolling(); }).catch(() => this.render());
	}

	// Poll while a run is in flight so stage / elapsed / log tick without a manual Refresh. Self-terminating:
	// it stops the moment you navigate off the Runs route or nothing is moving, and a fresh show()/refresh()
	// re-arms it. One timer only, and it re-reads only when a run is active, so a settled board makes no
	// traffic. setInterval (not requestAnimationFrame) so it keeps firing even when the tab is backgrounded.
	_onRunsPage() { return (typeof window !== 'undefined' && window.location && /^#?\/?runs\b/.test(String(window.location.hash || ''))); }
	_hasActiveRun() { return ((this._data().Runs) || []).some((pRun) => !_RUN_TERMINAL[pRun.Status || '']); }
	_ensurePolling()
	{
		if (typeof window === 'undefined' || this._pollTimer) { return; }
		if (!this._onRunsPage() || !this._hasActiveRun()) { return; }
		let tmpSelf = this;
		this._pollTimer = setInterval(function ()
		{
			if (!tmpSelf._onRunsPage() || !tmpSelf._hasActiveRun()) { tmpSelf._stopPolling(); return; }
			tmpSelf.refresh();
		}, 5000);
	}
	_stopPolling() { if (this._pollTimer) { clearInterval(this._pollTimer); this._pollTimer = null; } }
}

module.exports = PictViewRuns;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Runs',
	DefaultRenderable: 'Plansheet-Runs',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-runs-head { display: flex; align-items: center; gap: 14px; margin-bottom: 16px; }
		.ps-runs-head h1 { font-size: 22px; font-weight: 600; margin: 0; flex: 1; color: var(--theme-color-text-primary, #2c3140); }
		.ps-runs-btn { padding: 7px 14px; font-size: 13px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-runs-btn:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-runs-err { background: var(--theme-color-status-error, #cc3333); color: #fff; padding: 8px 12px; border-radius: 8px; margin-bottom: 14px; font-size: 13px; }
		.ps-runs-empty { color: var(--theme-color-text-secondary, #8a93a6); font-style: italic; font-size: 13px; padding: 10px 2px; }
		.ps-runs-section-title { font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;
			color: var(--theme-color-text-secondary, #5b6376); margin: 22px 0 10px; }
		.ps-runs-section-title:first-of-type { margin-top: 4px; }
		.ps-runs-catalog { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 12px; }
		.ps-runs-chain { border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 12px; padding: 14px 16px;
			background: var(--theme-color-background-panel, #fff); display: flex; flex-direction: column; gap: 7px; }
		.ps-runs-chain-head { display: flex; gap: 8px; align-items: baseline; flex-wrap: wrap; }
		.ps-runs-chain-name { flex: 1; min-width: 0; font-size: 14px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
		.ps-runs-chain-key { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6);
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; margin-top: -4px; }
		.ps-runs-chain-desc { font-size: 12px; line-height: 1.5; color: var(--theme-color-text-secondary, #5b6376); margin: 0; }
		.ps-runs-chain-shape { font-size: 12px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
		.ps-runs-chain-workspaces { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin-top: 2px;
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-runs-chips { display: flex; flex-wrap: wrap; gap: 6px; }
		.ps-runs-chip { font-size: 11px; padding: 3px 8px; border-radius: 6px; display: inline-flex; gap: 5px; align-items: baseline;
			background: color-mix(in srgb, #8a93a6 10%, transparent); color: var(--theme-color-text-secondary, #5b6376); }
		.ps-runs-chip em { font-style: normal; font-size: 10px; opacity: 0.75; text-transform: uppercase; letter-spacing: 0.03em; }
		.ps-runs-chip.gated { background: color-mix(in srgb, #d99a2b 18%, transparent); color: #a06d12; }
		.ps-runs-start { align-self: flex-start; margin-top: 3px; }
		/* A chain that already has a run: a live status, not a greyed-out button. */
		.ps-runs-chain-inflight { display: flex; align-items: center; gap: 10px; margin-top: 3px; font-size: 12px;
			color: #a06d12; background: color-mix(in srgb, #d99a2b 12%, transparent);
			border: 1px solid color-mix(in srgb, #d99a2b 40%, transparent); border-radius: 8px; padding: 6px 10px; }
		.ps-runs-anyway { font-size: 11px; padding: 3px 9px; cursor: pointer; border-radius: 6px;
			border: 1px solid var(--theme-color-border-default, #d8dde6); background: transparent;
			color: var(--theme-color-text-secondary, #5b6376); }
		.ps-runs-anyway:hover { border-color: var(--theme-color-text-secondary, #5b6376); }
		.ps-runs-card { border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 12px; margin-bottom: 16px;
			background: var(--theme-color-background-panel, #fff); overflow: hidden; }
		.ps-runs-card-head { display: flex; gap: 10px; align-items: baseline; padding: 12px 16px;
			border-bottom: 1px solid var(--theme-color-border-light, #e7ecf0); }
		.ps-runs-num { font-weight: 700; font-size: 13px; color: var(--theme-color-text-secondary, #8a93a6); }
		.ps-runs-name { flex: 1; min-width: 0; font-size: 14px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140);
			white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-runs-meta { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); }
		.ps-runs-position { padding: 6px 16px; font-size: 12px; color: var(--theme-color-text-secondary, #5b6376);
			background: color-mix(in srgb, var(--theme-color-text-secondary, #8a93a6) 5%, transparent); }
		.ps-runs-step { display: flex; flex-direction: column; gap: 6px; padding: 11px 16px; border-top: 1px solid var(--theme-color-border-light, #e7ecf0); }
		.ps-runs-step-line { display: flex; gap: 10px; align-items: baseline; }
		.ps-runs-step-order { flex: 0 0 auto; font-size: 12px; font-weight: 700; color: var(--theme-color-text-secondary, #8a93a6); min-width: 18px; }
		.ps-runs-step-title { flex: 1; min-width: 0; font-size: 13px; color: var(--theme-color-text-primary, #2c3140); }
		.ps-runs-step-kind { flex: 0 0 auto; font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6);
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-runs-badge { flex: 0 0 auto; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 999px;
			text-transform: uppercase; letter-spacing: 0.03em; }
		.ps-runs-badge.queued { background: color-mix(in srgb, #8a93a6 14%, transparent); color: #5b6376; }
		.ps-runs-badge.running { background: color-mix(in srgb, var(--theme-color-brand-primary, #3b6fd4) 15%, transparent); color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-runs-badge.gated { background: color-mix(in srgb, #d99a2b 20%, transparent); color: #a06d12; }
		.ps-runs-badge.ok { background: color-mix(in srgb, var(--theme-color-status-success, #3fae5a) 16%, transparent); color: #2f8a46; }
		.ps-runs-badge.failed { background: color-mix(in srgb, var(--theme-color-status-error, #cc3333) 15%, transparent); color: var(--theme-color-status-error, #cc3333); }
		.ps-runs-badge.muted { background: color-mix(in srgb, #8a93a6 12%, transparent); color: #8a93a6; }
		.ps-runs-scope { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); padding-left: 28px; }
		/* The live progress line under a step (WI #351): stage + elapsed + heartbeat freshness, or how long it took. */
		.ps-runs-timing { font-size: 11.5px; color: var(--theme-color-text-secondary, #5b6376); padding-left: 28px; margin-top: 2px; font-variant-numeric: tabular-nums; }
		.ps-runs-timing.is-stalled { color: var(--theme-color-status-warning, #b9812f); font-weight: 600; }
		/* Run-level "running Nm" + "typically ~Nm" on the position line. */
		.ps-runs-elapsed { margin-left: 8px; font-variant-numeric: tabular-nums; }
		.ps-runs-elapsed:empty { display: none; }
		.ps-runs-typical { margin-left: 8px; color: var(--theme-color-text-secondary, #8a93a6); }
		.ps-runs-waiting { margin: 2px 16px 10px; padding: 8px 11px; font-size: 12px; line-height: 1.5; border-radius: 8px; color: var(--theme-color-status-warning, #b9812f); background: rgba(185, 129, 47, 0.10); border: 1px solid rgba(185, 129, 47, 0.5); }
		.ps-runs-waiting-tag { display: inline-block; margin-right: 8px; font-weight: 700; text-transform: uppercase; font-size: 10px; letter-spacing: 0.05em; }
		/* Stop a run going wrong, without SSH-ing into the node (WI #451). */
		.ps-runs-cancel { padding: 4px 11px; font-size: 12px; font-weight: 600; cursor: pointer; border-radius: 7px;
			border: 1px solid var(--theme-color-status-error, #cc3333); background: transparent; color: var(--theme-color-status-error, #cc3333); }
		.ps-runs-cancel:hover { background: color-mix(in srgb, var(--theme-color-status-error, #cc3333) 10%, transparent); }
		.ps-runs-stopping { font-size: 12px; font-style: italic; color: var(--theme-color-text-secondary, #8a93a6); }
		.ps-runs-log { white-space: pre-wrap; font-size: 12px; line-height: 1.45; color: var(--theme-color-text-secondary, #5b6376);
			background: color-mix(in srgb, var(--theme-color-text-secondary, #8a93a6) 6%, transparent);
			border-radius: 8px; padding: 8px 10px; margin: 0 0 0 28px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-runs-evidence { display: flex; flex-wrap: wrap; gap: 10px; padding-left: 28px; }
		.ps-runs-evidence figure { margin: 0; }
		.ps-runs-evidence img { max-width: 420px; width: 100%; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; display: block; }
		.ps-runs-evidence figcaption { font-size: 11px; color: var(--theme-color-text-secondary, #8a93a6); margin-top: 3px; }
		.ps-runs-consent { display: flex; gap: 10px; align-items: center; padding-left: 28px; }
		.ps-runs-consent-note { flex: 1; font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-runs-approve { padding: 6px 14px; font-size: 13px; font-weight: 600; cursor: pointer; border-radius: 8px;
			border: 1px solid var(--theme-color-status-success, #3fae5a); background: var(--theme-color-status-success, #3fae5a); color: #fff; }
		.ps-runs-reject { padding: 6px 14px; font-size: 13px; cursor: pointer; border-radius: 8px;
			border: 1px solid var(--theme-color-status-error, #cc3333); background: transparent; color: var(--theme-color-status-error, #cc3333); }
		.ps-runs-decision { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); padding-left: 28px; }
		/* Recent-runs header with its inline filter box. */
		.ps-runs-finished-head { display: flex; align-items: center; gap: 12px; margin: 22px 0 10px; flex-wrap: wrap; }
		.ps-runs-finished-head .ps-runs-section-title { margin: 0; flex: 0 0 auto; }
		.ps-runs-search { flex: 1; min-width: 180px; max-width: 340px; padding: 6px 10px; font-size: 12px; border-radius: 8px;
			border: 1px solid var(--theme-color-border-default, #d8dde6); background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #2c3140); }
		.ps-runs-search:focus { outline: none; border-color: var(--theme-color-brand-primary, #3b6fd4); }
		/* A finished run: one compact row, expandable in place. */
		.ps-runs-mini-wrap { border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 10px; margin-bottom: 8px;
			background: var(--theme-color-background-panel, #fff); overflow: hidden; }
		.ps-runs-mini { display: flex; gap: 10px; align-items: baseline; padding: 9px 14px; cursor: pointer; }
		.ps-runs-mini:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #3b6fd4) 5%, transparent); }
		.ps-runs-mini-caret { flex: 0 0 auto; font-size: 10px; color: var(--theme-color-text-secondary, #8a93a6); transition: transform 0.12s; align-self: center; }
		.ps-runs-mini-wrap.is-open .ps-runs-mini-caret { transform: rotate(90deg); }
		.ps-runs-mini-name { flex: 1; min-width: 0; font-size: 13px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140);
			white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.ps-runs-mini-chain { flex: 0 0 auto; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.ps-runs-mini-ago { flex: 0 0 auto; }
		.ps-runs-mini-body { display: none; border-top: 1px solid var(--theme-color-border-light, #e7ecf0); padding-bottom: 6px; }
		.ps-runs-mini-wrap.is-open .ps-runs-mini-body { display: block; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-Runs',
			Template: /*html*/`
<div class="ps-page ps-runs">
	<div class="ps-runs-head">
		<h1>Runs</h1>
		<button class="ps-runs-btn" onclick="_Pict.views['Plansheet-Runs'].refresh()">Refresh</button>
	</div>

	{~TS:Runs-LoadError:AppData.Runs.LoadErrorSlot~}
	{~TS:Runs-ActiveTitle:AppData.Runs.ActiveTitleSlot~}
	{~TS:Runs-Card:AppData.Runs.ActiveRunCards~}

	<p class="ps-runs-section-title">Toolchains you can run</p>
	{~TS:Runs-CatalogError:AppData.Runs.CatalogErrorSlot~}
	{~TS:Runs-ToolchainsEmpty:AppData.Runs.ToolchainsEmpty~}
	<div class="ps-runs-catalog">{~TS:Runs-Toolchain:AppData.Runs.ToolchainCards~}</div>

	{~TS:Runs-FinishedTitle:AppData.Runs.FinishedTitleSlot~}
	{~TS:Runs-Mini:AppData.Runs.FinishedRunCards~}
	{~TS:Runs-Empty:AppData.Runs.RunsEmpty~}
</div>`
		},
		{
			Hash: 'Runs-Card',
			Template: /*html*/`
<div class="ps-runs-card">
	<div class="ps-runs-card-head">
		<span class="ps-runs-num">Run #{~D:Record.Number~}</span>
		<span class="ps-runs-name">{~D:Record.Name~}</span>
		<span class="ps-runs-meta">{~D:Record.ToolchainKey~}</span>
		<span class="ps-runs-meta">{~D:Record.Ago~}</span>
		<span class="ps-runs-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span>
		{~TS:Runs-Cancel:Record.CancelSlot~}
		{~TS:Runs-Stopping:Record.StoppingSlot~}
	</div>
	<div class="ps-runs-position">{~D:Record.Position~}<span class="ps-runs-elapsed">{~D:Record.Elapsed~}</span>{~TS:Runs-Typical:Record.TypicalSlot~}</div>
	{~TS:Runs-Waiting:Record.WaitingSlot~}
	{~TS:Runs-Step:Record.Steps~}
</div>`
		},
		{
			Hash: 'Runs-Step',
			Template: /*html*/`
<div class="ps-runs-step">
	<div class="ps-runs-step-line">
		<span class="ps-runs-step-order">{~D:Record.Order~}</span>
		<span class="ps-runs-step-title">{~D:Record.Title~}</span>
		<span class="ps-runs-step-kind">{~D:Record.Kind~} &middot; {~D:Record.Gate~}</span>
		<span class="ps-runs-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span>
	</div>
	{~TS:Runs-Step-Timing:Record.TimingSlot~}
	<div class="ps-runs-scope">{~D:Record.Scope~} {~D:Record.Ref~}</div>
	{~TS:Runs-Log:Record.LogSlot~}
	<div class="ps-runs-evidence">{~TS:Runs-Evidence:Record.Evidence~}</div>
	{~TS:Runs-Consent:Record.ConsentSlot~}
	{~TS:Runs-ConsentDenied:Record.ConsentDeniedSlot~}
	{~TS:Runs-Decision:Record.DecisionSlot~}
</div>`
		},
		{ Hash: 'Runs-Log', Template: /*html*/`<pre class="ps-runs-log">{~D:Record.Log~}</pre>` },
		{ Hash: 'Runs-Step-Timing', Template: /*html*/`<div class="ps-runs-timing{~D:Record.Stalled~}">{~D:Record.Timing~}</div>` },
		{ Hash: 'Runs-Typical', Template: /*html*/`<span class="ps-runs-typical">{~D:Record.Typical~}</span>` },
		{ Hash: 'Runs-Waiting', Template: /*html*/`<div class="ps-runs-waiting"><span class="ps-runs-waiting-tag">Waiting on a node</span>{~D:Record.Reason~}</div>` },
		// Stop a run going wrong, without SSH-ing into the node (Work Item #451). Takes IDRun, not a
		// string: nothing tenant-authored ever reaches this onclick, but an integer is the same safe
		// shape the rest of the page already uses for its onclick handlers.
		{ Hash: 'Runs-Cancel', Template: /*html*/`<button class="ps-runs-cancel" onclick="_Pict.PictApplication.cancelRun({~D:Record.IDRun~})">Stop</button>` },
		{ Hash: 'Runs-Stopping', Template: /*html*/`<span class="ps-runs-stopping">stopping&hellip;</span>` },
		{
			Hash: 'Runs-Evidence',
			Template: /*html*/`<figure><img src="/1.0/Media/{~D:Record.IDMedia~}/Blob" alt="{~D:Record.Title~}"><figcaption>{~D:Record.Title~}</figcaption></figure>`
		},
		{
			Hash: 'Runs-Consent',
			Template: /*html*/`
<div class="ps-runs-consent">
	<span class="ps-runs-consent-note">This step is waiting on you. Read the evidence above, then decide.</span>
	<button class="ps-runs-reject" onclick="_Pict.PictApplication.consentRunStep({~D:Record.IDRunStep~}, 'Reject')">Reject</button>
	<button class="ps-runs-approve" onclick="_Pict.PictApplication.consentRunStep({~D:Record.IDRunStep~}, 'Approve')">Approve</button>
</div>`
		},
		{ Hash: 'Runs-ConsentDenied', Template: /*html*/`<div class="ps-runs-consent"><span class="ps-runs-consent-note">This step is waiting for someone who can approve. You do not have content.approve.</span></div>` },
		{ Hash: 'Runs-Decision', Template: /*html*/`<div class="ps-runs-decision">{~D:Record.Decision~} by a person. {~D:Record.Note~}</div>` },
		{ Hash: 'Runs-LoadError', Template: /*html*/`<div class="ps-runs-err">Could not load runs: {~D:Record.Message~}</div>` },
		{ Hash: 'Runs-CatalogError', Template: /*html*/`<div class="ps-runs-err">Could not load the toolchain catalog: {~D:Record.Message~}</div>` },
		{ Hash: 'Runs-Empty', Template: /*html*/`<p class="ps-runs-empty">No runs yet. Start one from a toolchain above and a node will walk it, bringing the gated steps here for you to approve.</p>` },
		{ Hash: 'Runs-ActiveTitle', Template: /*html*/`<p class="ps-runs-section-title">Active now ({~D:Record.Count~})</p>` },
		{
			Hash: 'Runs-FinishedTitle',
			Template: /*html*/`
<div class="ps-runs-finished-head">
	<p class="ps-runs-section-title">Recent runs</p>
	<input class="ps-runs-search" type="search" placeholder="Filter by number, name, or toolchain" value="{~D:Record.Filter~}" oninput="_Pict.views['Plansheet-Runs'].filterFinished(this.value)">
</div>`
		},
		// A finished run is a compact row that expands in place; clicking the header toggles is-open on the wrapper.
		// The full detail (steps + logs) reuses Runs-Step, so an expanded row reads exactly like an active card.
		{
			Hash: 'Runs-Mini',
			Template: /*html*/`
<div class="ps-runs-mini-wrap" data-search="{~D:Record.Search~}">
	<div class="ps-runs-mini" onclick="_Pict.views['Plansheet-Runs'].toggleRun(this)">
		<span class="ps-runs-mini-caret">&#9656;</span>
		<span class="ps-runs-num">Run #{~D:Record.Number~}</span>
		<span class="ps-runs-mini-name">{~D:Record.Name~}</span>
		<span class="ps-runs-meta ps-runs-mini-chain">{~D:Record.ToolchainKey~}</span>
		<span class="ps-runs-badge {~D:Record.StatusClass~}">{~D:Record.Status~}</span>
		<span class="ps-runs-meta ps-runs-mini-ago">{~D:Record.Ago~}</span>
	</div>
	<div class="ps-runs-mini-body">
		<div class="ps-runs-position">{~D:Record.Position~}</div>
		{~TS:Runs-Step:Record.Steps~}
	</div>
</div>`
		},
		{ Hash: 'Runs-ToolchainsEmpty', Template: /*html*/`<p class="ps-runs-empty">No toolchains are available. The platform built-ins seed at boot; if this stays empty, the seed did not run.</p>` },
		{
			Hash: 'Runs-Toolchain',
			Template: /*html*/`
<div class="ps-runs-chain">
	<div class="ps-runs-chain-head">
		<span class="ps-runs-chain-name">{~D:Record.Name~}</span>
		<span class="ps-runs-badge {~D:Record.TierClass~}">{~D:Record.Tier~}</span>
		<span class="ps-runs-meta">v{~D:Record.Version~}</span>
		{~TS:Runs-Drift:Record.DriftSlot~}
	</div>
	<div class="ps-runs-chain-key">{~D:Record.Key~}</div>
	<p class="ps-runs-chain-desc">{~D:Record.Description~}</p>
	<div class="ps-runs-chain-shape">{~D:Record.Shape~}</div>
	{~TS:Runs-ChainWorkspaces:Record.WorkspaceSlot~}
	<div class="ps-runs-chips">{~TS:Runs-StepChip:Record.StepChips~}</div>
	{~TS:Runs-StartChain:Record.Runnable~}
	{~TS:Runs-ChainInFlight:Record.InFlightSlot~}
</div>`
		},
		{ Hash: 'Runs-ChainWorkspaces', Template: /*html*/`<div class="ps-runs-chain-workspaces">{~D:Record.Label~}</div>` },
		{ Hash: 'Runs-StepChip', Template: /*html*/`<span class="ps-runs-chip {~D:Record.GateClass~}">{~D:Record.Label~}<em>{~D:Record.Gate~}</em></span>` },
		{ Hash: 'Runs-Drift', Template: /*html*/`<span class="ps-runs-badge gated" title="The platform built-in changed after this copy was taken">drifted</span>` },
		// The handler takes the catalog INDEX, not the key or name. A tenant-authored key interpolated
		// into this onclick would be inside a JS string inside an HTML attribute, and HTML-escaping is
		// the wrong escape for that nesting: the parser decodes &#39; back to a quote before JS sees
		// it, so an escaped quote would break out of the literal. An integer cannot.
		{ Hash: 'Runs-StartChain', Template: /*html*/`<button class="ps-runs-btn ps-runs-start" onclick="_Pict.PictApplication.startToolchainRun({~D:Record.Index~})">Start a run</button>` },
		// The chain is busy, so there is no Start button to press. The label is a plain statement of what has
		// it; the run itself is on a card further down this same page.
		{
			Hash: 'Runs-ChainInFlight',
			Template: /*html*/`<div class="ps-runs-chain-inflight"><span>{~D:Record.Label~}</span>{~TS:Runs-StartChainAnyway:Record.ForceSlot~}</div>`
		},
		// Same index-not-key rule as Runs-StartChain above: an integer cannot break out of the JS string
		// literal inside the HTML attribute, and a tenant-authored toolchain key could.
		{ Hash: 'Runs-StartChainAnyway', Template: /*html*/`<button class="ps-runs-anyway" onclick="_Pict.PictApplication.startToolchainRunAnyway({~D:Record.Index~})">Start anyway</button>` }
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-Runs',
			TemplateHash: 'Plansheet-Runs',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"../SingleFlightLanes.js":570,"pict-view":365}],698:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * Shell — top-level chrome host for plansheet.
 *
 * Replaces the old "Layout owns everything inside #App-Container" pattern.
 * The Shell renders into #App-Container, builds a modal-shell with:
 *   - top    panel: Theme-TopBar (BrandMark + Nav + User slots)
 *   - left   panel: #Plansheet-Sidebar (the docked site-map navigation)
 *   - center: #Plansheet-Workspace, where the Dropzone / Layout
 *             views render (the app swaps between them on session load).
 * Appearance + account settings live on the /settings page, not a gear overlay.
 *
 * The Shell builds its panels once on first render; subsequent renders
 * are no-ops (guarded by _shellPanelsBuilt). The app calls render()
 * exactly once during onAfterInitializeAsync.
 */
class PictViewShell extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._shellPanelsBuilt = false;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		if (!this._shellPanelsBuilt)
		{
			this._buildShell();
			this._shellPanelsBuilt = true;
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_buildShell()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpMount = document.getElementById('Plansheet-Shell-Mount');
		if (!tmpModal || typeof tmpModal.shell !== 'function' || !tmpMount)
		{
			this.log.warn('Shell: PictSectionModal or mount not available; shell not built.');
			return;
		}

		this._shell = tmpModal.shell(tmpMount, { PersistenceKey: 'plansheet-shell' });

		this._shell.addPanel({
			Hash: 'topbar', Side: 'top', Mode: 'fixed', Size: 56,
			ContentDestinationId: 'Theme-TopBar', ContentView: 'Theme-TopBar'
		});

		// The shared left rail (nav / notebook / split). The app renders Plansheet-Rail into
		// #Plansheet-Sidebar (the panel's content-inner) and drives its mode; one panel keeps the
		// resize + responsive-drawer + persistence story singular. Wider than the old nav-only rail
		// because it also has to hold the notebook.
		this._shell.addPanel({
			Hash: 'sidebar', Side: 'left', Mode: 'resizable',
			Size: 300, MinSize: 200, MaxSize: 560, Title: 'Navigate',
			ContentDestinationId: 'Plansheet-Sidebar',
			ResponsiveDrawer: 860
		});

		// The contextual help drawer. Hidden (no collapse chrome) so it only opens on demand from F1 or
		// the top-bar "?"; the app drives expand/collapse and refreshes it to the current route. Persist
		// is off so help always starts closed rather than reopening from a prior session. The bound
		// ContentView fills the panel with the drawer view up front; the app calls refreshForRoute on open.
		this._shell.addPanel({
			Hash: 'help', Side: 'right', Mode: 'resizable',
			Size: 380, MinSize: 300, MaxSize: 560, Title: 'Help',
			ContentDestinationId: 'Plansheet-HelpDrawer',
			ContentView: 'Plansheet-HelpDrawer',
			Collapsed: true, Hidden: true, Persist: false,
			// Match the sidebar's responsive breakpoint so both side panels switch to drawer mode at the
			// same width; a mismatch leaves the row half-docked and mislays this panel.
			ResponsiveDrawer: 860
		});

		// The notebook is no longer its own panel -- it lives inside the rail (above) as one of the
		// rail's modes, so #Plansheet-Notebook is a pane the Rail view owns. See PictView-Rail.js.
		this._shell.center({ ContentDestinationId: 'Plansheet-Workspace' });
	}

	// Paint (or clear) the top bar's moodboard backdrop: an inline SVG baked from a plan sheet's crop
	// (pict-section-moodboard bakeCropToSVG), dropped BEHIND the brand / nav / user slots with a theme-tuned scrim
	// so those stay legible. Static -- no flow engine -- and pointer-events:none, so clicks pass through to the
	// chrome. Called on load with the active plan sheet's TopBarBackdropSVG; an empty string clears it. Each plan
	// sheet's bar then reads as visually distinct, which is the whole point (you notice a wrong-plan-sheet at a
	// glance). Direct DOM: this injects a chrome element into the theme's own top bar, outside the render cycle.
	applyTopBarBackdrop(pSVG)
	{
		if (typeof document === 'undefined') { return; }
		let tmpBar = document.getElementById('Theme-TopBar');
		if (!tmpBar) { return; }
		let tmpBackdrop = tmpBar.querySelector('.ps-topbar-backdrop');
		let tmpSVG = String(pSVG || '').trim();
		if (!tmpSVG)
		{
			if (tmpBackdrop) { tmpBackdrop.remove(); }
			tmpBar.classList.remove('ps-topbar-has-backdrop');
			return;
		}
		if (!tmpBackdrop)
		{
			tmpBackdrop = document.createElement('div');
			tmpBackdrop.className = 'ps-topbar-backdrop';
			tmpBar.insertBefore(tmpBackdrop, tmpBar.firstChild);
		}
		tmpBackdrop.innerHTML = tmpSVG;
		let tmpEl = tmpBackdrop.querySelector('svg');
		if (tmpEl)
		{
			tmpEl.setAttribute('width', '100%');
			tmpEl.setAttribute('height', '100%');
			tmpEl.setAttribute('preserveAspectRatio', 'xMidYMid slice');
		}
		tmpBar.classList.add('ps-topbar-has-backdrop');
	}
}

module.exports = PictViewShell;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Shell',
	DefaultRenderable: 'Plansheet-Shell',
	DefaultDestinationAddress: '#App-Container',
	AutoRender:                false,
	CSS: /*css*/`
		html, body { height: 100%; margin: 0; padding: 0; }
		body {
			background:  var(--theme-color-background-primary, #ffffff);
			color:       var(--theme-color-text-primary,       #1d2230);
			font-family: var(--theme-typography-family-sans,
				-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif);
		}
		#App-Container { height: 100%; min-height: 0; overflow: hidden; }
		.pict-modal-shell-host    { height: 100%; }
		.pict-modal-shell         { background: var(--theme-color-background-primary, #ffffff); }
		/* Per-plan-sheet moodboard backdrop, painted BEHIND the theme's brand / nav / user slots by
		   applyTopBarBackdrop. A static inline SVG, so no flow engine; pointer-events pass through. */
		#Theme-TopBar.ps-topbar-has-backdrop { position: relative; }
		#Theme-TopBar .ps-topbar-backdrop { position: absolute; inset: 0; z-index: 0; overflow: hidden; pointer-events: none; }
		#Theme-TopBar .ps-topbar-backdrop svg { width: 100%; height: 100%; display: block; }
		/* Theme scrim: opaque at the two ends (where the brand + account chips sit) fading to mostly-clear in the
		   middle so the art shows. Uses the bar's own theme color, so it follows light / dark automatically.
		   The end stops are in PIXELS, not percentages, because what they have to cover is a fixed width: the
		   brand mark runs to about 220px and the account chip is right-anchored at a similar size, no matter how
		   wide the window is. With percentage stops the opaque zone shrank with the window and the art rode up
		   over the brand and the sidebar toggles on a narrow one. The clear window stays proportional (it is the
		   part that should breathe), and on a window too narrow to hold both ends the stops collapse in order,
		   leaving the bar opaque -- chrome legible, art hidden, which is the right way for this to fail.
		   The numbers are measured off the bar's own slots: the brand mark plus the two sidebar toggles occupy
		   the left through about 316px, and the launcher / help / account chip occupy the right through about
		   160px, so the opaque ends bracket those and the fades sit just outside them. */
		#Theme-TopBar .ps-topbar-backdrop::after { content: ""; position: absolute; inset: 0; background: linear-gradient(90deg,
			var(--theme-color-background-panel, #ffffff) 0px,
			var(--theme-color-background-panel, #ffffff) 325px,
			color-mix(in srgb, var(--theme-color-background-panel, #ffffff) 55%, transparent) 400px,
			color-mix(in srgb, var(--theme-color-background-panel, #ffffff) 14%, transparent) 44%,
			color-mix(in srgb, var(--theme-color-background-panel, #ffffff) 14%, transparent) 56%,
			color-mix(in srgb, var(--theme-color-background-panel, #ffffff) 55%, transparent) calc(100% - 240px),
			var(--theme-color-background-panel, #ffffff) calc(100% - 160px),
			var(--theme-color-background-panel, #ffffff) 100%); }
		/* Lift the theme's own top-bar wrapper above the backdrop + scrim, and drop its opaque bar fill so the art
		   shows through -- the backdrop IS the bar's background now. The brand / nav / account chips keep their own
		   subtle backings (the theme paints those), which is the legibility backstop over a busy crop. */
		#Theme-TopBar.ps-topbar-has-backdrop > *:not(.ps-topbar-backdrop) { position: relative; z-index: 1; background: transparent !important; }
		.pict-modal-shell-panel   { background: var(--theme-color-background-panel,   #ffffff); }
		/* Three distinct regions: navigation, content, and help. The "raised" direction differs by mode,
		   so the rails are tuned per mode rather than reusing one stepping. In DARK a deep ground sits
		   under rails that step lighter (lighter reads as lifted). In LIGHT the warm tones turn dingy as
		   they darken, so the canvas is the brightest paper and the rails stay light and clean. The help
		   drawer carries a faint cool brand wash in both modes, so it is set apart by hue, not a muddy
		   fill or a drop shadow. Light is the default (:root); dark overrides under html.theme-dark. The
		   top bar keeps its own brand chrome. */
		/* Content canvas */
		.pict-modal-shell-center { background: var(--theme-color-background-panel, #fbf8f0); overflow: auto; }
		html.theme-dark .pict-modal-shell-center { background: var(--theme-color-background-primary, #14171c); }
		/* Navigation rail */
		.pict-modal-shell-panel-left { background: var(--theme-color-background-primary, #f5f0e4);
			border-right: 1px solid var(--theme-color-border-default, #cfc6b0); }
		html.theme-dark .pict-modal-shell-panel-left { background: var(--theme-color-background-secondary, #1b1f26); border-right: none; }
		/* Keyboard-first users can hide the docked left navigation (the top-bar show/hide button, Cmd+B / Cmd+\\,
		   or the Appearance toggle set html.ps-nav-off). Hide the whole left side wrapper (panel + resize handle
		   + collapse tab); the center fills the gap. */
		html.ps-nav-off .pict-modal-shell-side-left { display: none !important; }
		/* Keep the top-bar launcher + help button visible in the theme's compact (mobile) mode. The theme
		   hides its whole nav slot there (.pict-theme-topbar-nav display:none !important); this ID override
		   beats that class rule, so the launcher and help stay on the bar next to the burger. */
		#Theme-TopBar-Nav { display: flex !important; align-items: center; }
		/* MoodNote text + placeholder are hardcoded dark in pict-section-moodboard (.mb-note color #3a3320),
		   unlike its theme-aware .mb-text card -- unreadable on the dark canvas. Make the default note text and
		   placeholder follow the theme in dark mode; a note with an explicit text color keeps it (inline wins).
		   Proper fix is upstream: .mb-note should use var(--theme-color-text-primary) the way .mb-text does. */
		html.theme-dark .mb-note { color: var(--theme-color-text-primary, #e6e8ec); }
		html.theme-dark .mb-note:empty::before { color: var(--theme-color-text-secondary, rgba(255,255,255,0.45)); }
		/* ---------- Showcase themes: per-theme face + button signatures ----------
		   The palette comes from each theme's bundle; the face + button treatment ride the
		   html[data-theme=...] marker the theme apply-hook stamps. Buttons take a Win9x "almost square"
		   2px corner across the app; Nostalgia goes all the way to a silver 3D-beveled button. */
		.pict-modal-shell [class*="btn"] { border-radius: 2px; }
		/* Per-theme content face -- overrides the --plansheet-content var the base 'html body' rule reads. */
		html[data-theme="nostalgia"]     { --plansheet-content: Tahoma, 'MS Sans Serif', Geneva, Verdana, sans-serif; }
		html[data-theme="1990s-website"] { --plansheet-content: 'Times New Roman', Times, Georgia, serif; }
		html[data-theme="cyberpunk"]     { --plansheet-content: 'Share Tech Mono', Consolas, 'SFMono-Regular', Menlo, ui-monospace, monospace; }
		html[data-theme="neo-tokyo"]     { --plansheet-content: 'Rajdhani', Eurostile, 'Helvetica Neue', Arial, sans-serif; }
		html[data-theme="london-subway"] { --plansheet-content: 'Gill Sans', 'Gill Sans MT', Johnston, Calibri, sans-serif; }
		html[data-theme="high-contrast"] { --plansheet-content: system-ui, 'Segoe UI', Tahoma, sans-serif; }
		html[data-theme="plain"]         { --plansheet-content: system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; }
		/* 1990s: period beveled buttons. */
		html[data-theme="1990s-website"] .pict-modal-shell [class*="btn"] { border: 2px outset #f4f4f4; border-radius: 0; box-shadow: none; }
		/* Nostalgia: the Win9x button -- silver face, square, 3D bevel (light + dark edge colours). */
		html[data-theme="nostalgia"] .pict-modal-shell [class*="btn"] { border: 0; border-radius: 2px; color: #000; background: #c0c0c0; box-shadow: inset -1px -1px 0 #000, inset 1px 1px 0 #fff, inset -2px -2px 0 #808080, inset 2px 2px 0 #dfdfdf; }
		html[data-theme="nostalgia"].theme-dark .pict-modal-shell [class*="btn"] { color: #e6e6e6; background: #3a3a3a; box-shadow: inset -1px -1px 0 #000, inset 1px 1px 0 #6e6e6e, inset -2px -2px 0 #202020, inset 2px 2px 0 #5a5a5a; }
		html[data-theme="nostalgia"] .pict-modal-shell [class*="btn"]:active { box-shadow: inset 1px 1px 0 #000, inset -1px -1px 0 #dfdfdf, inset 2px 2px 0 #808080; }
		/* Cyberpunk: a soft neon halo on the primary actions. */
		html[data-theme="cyberpunk"] .pict-modal-shell [class*="btn-primary"], html[data-theme="cyberpunk"] .pict-modal-shell .cst-set-btn { box-shadow: 0 0 10px rgba(255,42,109,0.55); }
		/* Responsive (phone) header: keep the launcher + help + the two stamps; drop the PLANSHEET wordmark and
		   the spelled-out user name, plus the now-dangling inner dividers, so each lockup reads as a clean stamp. */
		@media (max-width: 600px) {
			.pict-theme-brand-mark .pict-theme-brand-mark-name { display: none; }
			.pict-theme-brand-mark-icon { border-right: none; }
			#Theme-TopBar-User .cst-user-chip .cst-user-name { display: none; }
			#Theme-TopBar-User .cst-user-chip .cst-user-avatar { border-left: none; }
		}
		/* Help drawer: a cool brand wash + a clear left edge (no shadow). */
		.pict-modal-shell-panel-right { background: var(--theme-color-background-panel, #fbf8f0);
			border-left: 1px solid var(--theme-color-border-default, #cfc6b0); }
		html.theme-dark .pict-modal-shell-panel-right { background: var(--theme-color-background-tertiary, #232830);
			border-left: 1px solid var(--theme-color-border-strong, #46505c); }
		@supports (background: color-mix(in srgb, red, blue)) {
			.pict-modal-shell-panel-right { background: color-mix(in srgb, var(--theme-color-brand-primary, #1d5fa8) 7%, var(--theme-color-background-panel, #fbf8f0)); }
			html.theme-dark .pict-modal-shell-panel-right { background: color-mix(in srgb, var(--theme-color-brand-primary, #4f95e8) 8%, var(--theme-color-background-tertiary, #232830)); }
		}
		#Plansheet-Workspace { height: 100%; }

		/* Shared page container. Every standard content view roots on the ps-page class so the page inset and
		   centered max width live in one place instead of being redeclared per view. The -narrow and
		   -wide modifiers pick the reading-column and wide-table widths; -bleed is the full-width inset
		   for surfaces that fill the workspace (the kanban lanes, the settings pane). Genuinely bespoke
		   surfaces (the workflow canvas, the profile hero, the documentation browser) keep their own roots. */
		.ps-page { max-width: 1000px; margin: 0 auto; padding: 24px; box-sizing: border-box; }
		.ps-page-narrow { max-width: 860px; }
		.ps-page-wide { max-width: 1100px; }
		.ps-page-bleed { padding: 24px; box-sizing: border-box; }

		/* The docked navigation (pict-section-navigation) renders into #Plansheet-Sidebar, the left
		   panel's content-inner div. Pin it to the panel height with its own vertical scroll so a long
		   nav scrolls inside the rail. */
		#Plansheet-Sidebar { height: 100%; overflow: hidden; }

		/* Sidebar collapse tab: a tall, vertically centered handle that stays out of the way
		   (autohidden) until the pointer reaches the sidebar's edge, then slides out. This replaces
		   the module's short tab anchored near the top. Scoped to the left (sidebar) panel and under
		   the shell host so it wins over the module's own collapse-tab rules regardless of CSS
		   injection order. The :not(...collapsed) guard is important: when the sidebar is collapsed
		   the module turns the whole panel into the reopen strip (with !important), so the autohide
		   must not apply there or the collapsed sidebar would have no visible way back open. */
		.pict-modal-shell-host .pict-modal-shell-panel-left:not(.pict-modal-shell-panel-collapsed) > .pict-modal-shell-panel-collapse-tab
		{
			top: 50%;
			transform: translateY(-50%);
			right: -16px;
			width: 16px;
			height: 84px;
			opacity: 0;
		}
		.pict-modal-shell-host .pict-modal-shell-panel-left:not(.pict-modal-shell-panel-collapsed):hover > .pict-modal-shell-panel-collapse-tab,
		.pict-modal-shell-host .pict-modal-shell-panel-left:not(.pict-modal-shell-panel-collapsed) > .pict-modal-shell-panel-collapse-tab:hover
		{
			opacity: 1;
		}

		/* Sticker gallery: square the sticker tiles. The module sizes each thumbnail to a fixed
		   82px height inside a flexing-width cell, so the icons sit in a wide box. Pin the image to
		   a 1:1 box instead. !important wins over the module's injected rule regardless of CSS
		   injection order or where the (position: fixed) gallery is mounted. */
		.mb-gallery-mode-sticker .mb-gallery-item img { height: auto !important; aspect-ratio: 1 / 1 !important; }

		/* Print: shed the app chrome so any page -- above all a Blueprint opened in view mode --
		   prints as a clean sheet. The blueprint content renderer already carries its own @media
		   print rules; what was missing is the shell dropping its own furniture. Hide the nav rail,
		   help drawer, top bar and every collapse/resize/overlay element, then release the shell's
		   fixed height + overflow clipping (and switch its flex rows to block flow) so the content
		   runs down the page and across sheets instead of being cropped to one screen. */
		@media print {
			html, body, #App-Container,
			.pict-modal-shell-host, .pict-modal-shell,
			.pict-modal-shell-row-middle, .pict-modal-shell-center,
			.pict-modal-shell-center-content, #Plansheet-Workspace {
				height: auto !important; min-height: 0 !important; max-height: none !important;
				overflow: visible !important;
			}
			.pict-modal-shell, .pict-modal-shell-row-middle { display: block !important; }
			.pict-modal-shell-side-left, .pict-modal-shell-side-right,
			.pict-modal-shell-row-top, .pict-modal-shell-panel-top, .pict-modal-shell-row-bottom,
			.pict-modal-shell-panel-collapse-tab, .pict-modal-shell-panel-resize-handle,
			.pict-modal-shell-overlay-layer, #Plansheet-DrawingOverlay {
				display: none !important;
			}
			html, body, .pict-modal-shell-center { background: #ffffff !important; }
		}
	`,
	Templates: [{
		Hash: 'Plansheet-Shell',
		Template: /*html*/`<div id="Plansheet-Shell-Mount" style="height:100%"></div><div id="Plansheet-DrawingOverlay"></div>`
	}],
	Renderables: [{
		RenderableHash: 'Plansheet-Shell',
		TemplateHash: 'Plansheet-Shell',
		ContentDestinationAddress: '#App-Container'
	}]
};

},{"pict-view":365}],699:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libStickerSets = require('../StickerSets.js');

/**
 * StickerSetsPreview - the iteration surface for the curated sticker sets (#/sticker-sets-preview).
 * Renders every built-in set in StickerSets.js as a labeled grid of thumbnails, each served recolored
 * through the Shapes endpoint. A broken tile means a name that does not resolve, so editing
 * source/StickerSets.js and reloading is a tight loop for getting each set to feel right. Not in the
 * nav; reachable by URL. No data of its own, so any signed-in user can open it.
 */
class PictViewStickerSetsPreview extends libPictView
{
	show() { this.render(); }

	onBeforeRender(pRenderable)
	{
		let tmpShapes = this.pict.providers.ShapesAPI;
		let tmpSets = libStickerSets.SET_ORDER
			.filter((pKey) => !!libStickerSets.Sets[pKey])
			.map((pKey) =>
			{
				let tmpSet = libStickerSets.Sets[pKey];
				return {
					Key: pKey,
					Label: tmpSet.Label,
					Description: tmpSet.Description || '',
					Count: tmpSet.Items.length,
					Items: tmpSet.Items.map((pItem) => (
						{
							Url: tmpShapes ? tmpShapes.shapeURL(pItem.Collection, pItem.Name) : ('/1.0/Shapes/' + pItem.Collection + '/' + pItem.Name),
							Title: pItem.Title || pItem.Name,
							Ref: pItem.Collection + ':' + pItem.Name
						}))
				};
			});
		this.pict.AppData.StickerSetsPreview = { Sets: tmpSets, TotalSets: tmpSets.length };
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewStickerSetsPreview;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-StickerSetsPreview',
	DefaultRenderable: 'StickerSetsPreview',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ssp { padding: 24px; max-width: 1120px; margin: 0 auto; box-sizing: border-box; }
		.ssp-intro { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 18px; }
		.ssp-set { margin: 0 0 26px; }
		.ssp-set-head { display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; }
		.ssp-set-label { font-weight: 600; font-size: 15px; color: var(--theme-color-text-primary, #1d2230); }
		.ssp-set-meta { font-size: 12px; color: var(--theme-color-text-secondary, #9aa3b2); }
		.ssp-set-desc { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin: 2px 0 10px; }
		.ssp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(94px, 1fr)); gap: 10px; }
		.ssp-tile { display: flex; flex-direction: column; align-items: center; gap: 5px; padding: 10px 6px; border: 1px solid var(--theme-color-border-subtle, #eef1f6); border-radius: 8px; background: var(--theme-color-background-panel, #fff); }
		.ssp-img { width: 40px; height: 40px; object-fit: contain; }
		.ssp-title { font-size: 12px; color: var(--theme-color-text-primary, #1d2230); text-align: center; line-height: 1.15; }
		.ssp-ref { font-size: 10px; color: var(--theme-color-text-secondary, #9aa3b2); text-align: center; word-break: break-all; }
	`,
	Templates:
	[
		{
			Hash: 'StickerSetsPreview-Container',
			Template: /*html*/`
<div class="ssp">
	<h2 class="ps-page-h">Sticker sets</h2>
	<p class="ssp-intro">{~D:AppData.StickerSetsPreview.TotalSets~} built-in sets. Edit source/StickerSets.js and reload to iterate. A broken image is a name that does not exist.</p>
	{~TS:StickerSetsPreview-Set:AppData.StickerSetsPreview.Sets~}
</div>`
		},
		{
			Hash: 'StickerSetsPreview-Set',
			Template: /*html*/`
<div class="ssp-set">
	<div class="ssp-set-head"><span class="ssp-set-label">{~D:Record.Label~}</span><span class="ssp-set-meta">{~D:Record.Count~} stickers &middot; {~D:Record.Key~}</span></div>
	<div class="ssp-set-desc">{~D:Record.Description~}</div>
	<div class="ssp-grid">{~TS:StickerSetsPreview-Item:Record.Items~}</div>
</div>`
		},
		{
			Hash: 'StickerSetsPreview-Item',
			Template: /*html*/`<div class="ssp-tile"><img class="ssp-img" src="{~D:Record.Url~}" alt="" loading="lazy"><span class="ssp-title">{~D:Record.Title~}</span><span class="ssp-ref">{~D:Record.Ref~}</span></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'StickerSetsPreview',
			TemplateHash: 'StickerSetsPreview-Container',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../StickerSets.js":573,"pict-view":365}],700:[function(require,module,exports){
'use strict';

/**
 * System Activity (Work Item 230). A tenant-scoped overview of how much work and knowledge the team
 * creates over time, read from the pre-aggregated ActivityAggregate table (GET /1.0/Activity/Aggregate
 * via providers.OpsAPI.loadActivityAggregate). This view owns the page shell and hosts the reusable
 * pict-section-activitygraph chart (registered separately as 'Plansheet-SystemActivity-Chart', pointed
 * at the #SystemActivity-Chart slot in this template). The chart's granularity switcher calls back into
 * loadPeriod() through the section's PeriodChangeHandler, so a new granularity refetches that period.
 */

const libPictView = require('pict-view');

class PictViewSystemActivity extends libPictView
{
	_chart() { return this.pict.views['Plansheet-SystemActivity-Chart']; }
	_api() { return this.pict.providers.OpsAPI; }
	_store() { return this.pict.AppData.SystemActivity || {}; }

	show(pPeriod)
	{
		this.render();
		let tmpChart = this._chart();
		if (tmpChart) { tmpChart.render(); }
		let tmpPeriod = pPeriod || (tmpChart && tmpChart._State && tmpChart._State.Period) || 'Week';
		// loadPeriod, not selectPeriod: this is what the route handler already called.
		return this.loadPeriod(tmpPeriod);
	}

	/**
	 * The user switched granularity. NAVIGATES; the route handler renders.
	 *
	 * Day, Week, Month, Quarter and Year each refetch their own buckets and draw a visibly different
	 * chart, so which one you are looking at is worth a URL. It could not be linked or reloaded into.
	 */
	selectPeriod(pPeriod)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSystemActivityPeriod === 'function'
			&& tmpApp.showSystemActivityPeriod(pPeriod)) { return; }
		return this.loadPeriod(pPeriod);
	}

	// Fetch one granularity's buckets and hand them to the chart. Called on show and by the chart's
	// PeriodChangeHandler when the user switches granularity.
	loadPeriod(pPeriod)
	{
		let tmpAPI = this._api();
		let tmpChart = this._chart();
		if (!tmpAPI || typeof tmpAPI.loadActivityAggregate !== 'function' || !tmpChart) { return Promise.resolve(); }
		return tmpAPI.loadActivityAggregate({ period: pPeriod }).then((pBody) =>
		{
			let tmpRows = (pBody && pBody.Rows) || this._store().Rows || [];
			tmpChart.setData({ Period: pPeriod, Buckets: tmpRows });
			this._reflectError();
			return pBody;
		});
	}

	refresh() { return this.loadPeriod((this._chart() && this._chart()._State && this._chart()._State.Period) || 'Week'); }

	_reflectError()
	{
		let tmpError = this._store().LoadError || '';
		this.pict.ContentAssignment.assignContent('#SystemActivity-Error', tmpError ? ('Could not load activity: ' + tmpError) : '');
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewSystemActivity;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-SystemActivity',
	DefaultRenderable: 'Plansheet-SystemActivity',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.ps-sysact { padding: 20px 24px 60px; max-width: 1040px; }
		.ps-sysact-head { display: flex; align-items: center; gap: 14px; margin-bottom: 4px; }
		.ps-sysact-head h1 { font-size: 22px; font-weight: 600; margin: 0; flex: 1; color: var(--theme-color-text-primary, #2c3140); }
		.ps-sysact-refresh { padding: 7px 14px; font-size: 13px; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); }
		.ps-sysact-refresh:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.ps-sysact-sub { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 18px; }
		.ps-sysact-err:not(:empty) { background: var(--theme-color-status-error, #cc3333); color: var(--theme-color-text-on-brand, #fff); padding: 8px 12px; border-radius: 8px; margin-bottom: 14px; font-size: 13px; }
		.ps-sysact-chart { min-height: 200px; }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-SystemActivity',
			Template: /*html*/`
<div class="ps-sysact">
	<div class="ps-sysact-head">
		<h1>System Activity</h1>
		<button class="ps-sysact-refresh" onclick="_Pict.views['Plansheet-SystemActivity'].refresh()">Refresh</button>
	</div>
	<p class="ps-sysact-sub">How much work and knowledge the team creates over time. One bar per period, stacked by type or actor.</p>
	<div class="ps-sysact-err" id="SystemActivity-Error"></div>
	<div class="ps-sysact-chart" id="SystemActivity-Chart"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Plansheet-SystemActivity',
			TemplateHash: 'Plansheet-SystemActivity',
			ContentDestinationAddress: '#Plansheet-Workspace',
			RenderMethod: 'replace'
		}
	]
};

},{"pict-view":365}],701:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libDescriptors = require('../EntityDescriptors.js');
const libMarkdownRender = require('./MarkdownRender.js');

/**
 * TestRunner — the test run detail page (route /test-run/:id). Not the generic
 * EntityDetail: a run is a focused walk through snapshot steps, so the page is
 * a runner. Header shows the run, its routine, environment, and progress; each
 * step card shows the snapshot title, the routine step's body and reference
 * media (read from the live RoutineStep by IDRoutineStep provenance), the
 * expected result, big Worked / Didn't work / Skip buttons, tester notes, and
 * an evidence strip (Media OwnerType 'TestRunStep', click or drop to upload).
 *
 * Outcomes save optimistically (paint first, PUT after, revert on failure).
 * Finishing summarizes the outcomes in a modal, suggests Passed/Failed, stamps
 * Status + CompletedDate, then offers "Leave feedback" which opens the
 * Feedback form prelinked to this run. A finished run renders read-only
 * outcome chips. Comments mount at the bottom (CommentThread OwnerType
 * 'TestRun'), the same shared section the detail pages use.
 */
class PictViewTestRunner extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._RunID = 0;
		this._Run = null;
		this._Routine = null;
		this._LoadToken = 0;
		this._steps = [];        // TestRunStep rows, sorted by SortOrder
		this._routineSteps = {}; // IDRoutineStep -> RoutineStep row
		this._refMedia = {};     // IDRoutineStep -> Media rows (reference)
		this._evidence = {};     // IDTestRunStep -> Media rows (evidence)
		this._CommentsLoadedFor = null;
		this.pict.AppData.TestRunner = this.pict.AppData.TestRunner ||
			{
				RunID: 0, HeaderTitle: '', RoutineName: '', IDRoutine: 0, Environment: '', EnvironmentSlot: [],
				Status: '', StatusClass: '', Steps: [], Progress: { Done: 0, Total: 0, Pct: 0 },
				ActiveBarSlot: [], DoneBarSlot: [], SummarySlot: []
			};
	}

	_runAPI() { return this.pict.providers.TestRunAPI; }
	_stepAPI() { return this.pict.providers.TestRunStepAPI; }
	_routineStepAPI() { return this.pict.providers.RoutineStepAPI; }
	_mediaAPI() { return this.pict.providers.MediaAPI; }

	_active() { return !!(this._Run && this._Run.Status === 'In Progress'); }

	// ── entry + load ─────────────────────────────────────────────────────────
	showRun(pID)
	{
		this._RunID = Number(pID) || 0;
		this._CommentsLoadedFor = null;
		this._load();
	}

	_load()
	{
		let tmpToken = ++this._LoadToken;
		if (!this._RunID || !this._runAPI()) { return; }
		// Read the open Run by id, not from the capped TestRun list: a run past /0/250 is absent from that cache
		// and the runner would render nothing (WI #333, same class as #329). Fall back to the cache if the
		// read-one is momentarily unavailable. The run's step list still loads alongside it.
		Promise.all([this._runAPI().read(this._RunID), this._stepAPI().listForRun(this._RunID)])
			.then((pResults) =>
			{
				if (tmpToken !== this._LoadToken) { return null; }
				this._Run = pResults[0] || this._runAPI().store().Index[this._RunID] || null;
				this._steps = pResults[1] || [];
				if (!this._Run) { return null; }
				// The Routine, likewise by id rather than from the capped Routine list (WI #333).
				let tmpLoads = [this.pict.providers.RoutineAPI.read(this._Run.IDRoutine).then((pRoutine) =>
				{
					this._Routine = pRoutine || this.pict.providers.RoutineAPI.store().Index[this._Run.IDRoutine] || null;
				})];
				tmpLoads.push(this._routineStepAPI().listForRoutine(this._Run.IDRoutine).then((pRows) =>
				{
					this._routineSteps = {};
					(pRows || []).forEach((pRow) => { this._routineSteps[pRow.IDRoutineStep] = pRow; });
				}));
				this._steps.forEach((pStep) =>
				{
					tmpLoads.push(this._mediaAPI().listForOwner('RoutineStep', pStep.IDRoutineStep)
						.then((pRows) => { this._refMedia[pStep.IDRoutineStep] = pRows || []; }));
					tmpLoads.push(this._mediaAPI().listForOwner('TestRunStep', pStep.IDTestRunStep)
						.then((pRows) => { this._evidence[pStep.IDTestRunStep] = pRows || []; }));
				});
				return Promise.all(tmpLoads);
			})
			.then(() =>
			{
				if (tmpToken !== this._LoadToken) { return; }
				this._rebuild();
				this.render();
			});
	}

	_loadEvidenceFor(pID)
	{
		this._mediaAPI().listForOwner('TestRunStep', pID)
			.then((pRows) => { this._evidence[pID] = pRows || []; this._rebuild(); this.render(); });
	}

	_rawStep(pID) { return this._steps.find((pStep) => String(pStep.IDTestRunStep) === String(pID)) || null; }

	// ── build the AppData model from the raw caches (no fetch) ──────────────
	_rebuild()
	{
		let tmpState = this.pict.AppData.TestRunner;
		let tmpRun = this._Run || {};
		let tmpActive = this._active();
		tmpState.RunID = this._RunID;
		tmpState.HeaderTitle = (tmpRun.TestRunNumber ? ('Run #' + tmpRun.TestRunNumber + ': ') : '') + (tmpRun.Name || ('#' + this._RunID));
		// Name the browser tab + notebook history after this run once it has loaded (the route has no
		// static title, so it would otherwise linger on the generic default).
		if (this.pict.PictApplication && typeof this.pict.PictApplication._setPageTitle === 'function') { this.pict.PictApplication._setPageTitle(tmpState.HeaderTitle); }
		tmpState.RoutineName = (this._Routine && this._Routine.Name) || ('Routine #' + (tmpRun.IDRoutine || '?'));
		tmpState.IDRoutine = tmpRun.IDRoutine || 0;
		tmpState.Environment = tmpRun.Environment || '';
		tmpState.EnvironmentSlot = tmpRun.Environment ? [{ Environment: tmpRun.Environment }] : [];
		tmpState.Status = tmpRun.Status || '';
		tmpState.StatusChipClass = (' tsr-chip-' + String(tmpRun.Status || '').toLowerCase().replace(/[^a-z]+/g, '-'));

		let tmpDone = 0;
		tmpState.Steps = this._steps.map((pStep, pIdx) =>
		{
			let tmpID = pStep.IDTestRunStep;
			let tmpOutcome = String(pStep.Outcome || '');
			if (tmpOutcome) { tmpDone++; }
			let tmpRoutineStep = this._routineSteps[pStep.IDRoutineStep] || {};
			let tmpExpected = String(tmpRoutineStep.ExpectedResult || '');
			let tmpNotes = String(pStep.Notes || '');
			let fMediaItems = (pRows, pRemovable) => (pRows || []).map((pM) =>
			{
				let tmpIsImage = (String(pM.MimeType || '').indexOf('image/') === 0) || (pM.MediaType === 'Screenshot');
				let tmpIsVideo = String(pM.MimeType || '').indexOf('video/') === 0;
				let tmpURL = '/1.0/Media/' + pM.IDMedia + '/Blob';
				let tmpTitle = pM.Title || pM.OriginalFileName || ('Media #' + pM.IDMedia);
				return (
				{
					ID: pM.IDMedia, StepID: tmpID,
					ImageSlot: tmpIsImage ? [{ URL: tmpURL, Title: tmpTitle }] : [],
					VideoSlot: tmpIsVideo ? [{ URL: tmpURL, Title: tmpTitle }] : [],
					FileSlot: (tmpIsImage || tmpIsVideo) ? [] : [{ URL: tmpURL, Title: tmpTitle, Type: pM.MediaType || 'file' }],
					RemoveSlot: (pRemovable && tmpActive) ? [{ ID: pM.IDMedia, StepID: tmpID }] : []
				});
			});
			let tmpRefItems = fMediaItems(this._refMedia[pStep.IDRoutineStep], false);
			let tmpEvidenceItems = fMediaItems(this._evidence[tmpID], true);
			return (
			{
				ID: tmpID,
				Idx: pIdx + 1,
				Title: String(pStep.StepTitle || ''),
				Body: String(tmpRoutineStep.Body || ''),
				BodyContainerID: 'TR-Body-' + tmpID,
				ExpectedSlot: tmpExpected ? [{ Expected: tmpExpected }] : [],
				RefMedia: tmpRefItems,
				RefMediaSlot: tmpRefItems.length ? [{ Items: tmpRefItems }] : [],
				Evidence: tmpEvidenceItems,
				CardClass: tmpOutcome ? (' tsr-card-' + tmpOutcome.toLowerCase()) : '',
				OutcomeButtonsSlot: tmpActive ? [{
					ID: tmpID,
					PassedClass: (tmpOutcome === 'Passed') ? ' tsr-on' : '',
					FailedClass: (tmpOutcome === 'Failed') ? ' tsr-on' : '',
					SkippedClass: (tmpOutcome === 'Skipped') ? ' tsr-on' : ''
				}] : [],
				OutcomeChipSlot: (!tmpActive && tmpOutcome) ? [{ Outcome: tmpOutcome, ChipClass: ' tsr-chip-' + tmpOutcome.toLowerCase() }] : [],
				NotesEditSlot: tmpActive ? [{ ID: tmpID, Notes: tmpNotes }] : [],
				NotesViewSlot: (!tmpActive && tmpNotes) ? [{ ID: tmpID, ContainerID: 'TR-Notes-' + tmpID, Notes: tmpNotes }] : [],
				EvidenceUploadSlot: tmpActive ? [{ ID: tmpID }] : [],
				EvidenceWrapSlot: (tmpEvidenceItems.length || tmpActive) ? [{ ID: tmpID, Items: tmpEvidenceItems }] : []
			});
		});

		tmpState.Progress =
		{
			Done: tmpDone,
			Total: tmpState.Steps.length,
			Pct: tmpState.Steps.length ? Math.round((tmpDone / tmpState.Steps.length) * 100) : 0
		};
		tmpState.ActiveBarSlot = tmpActive ? [{}] : [];
		tmpState.DoneBarSlot = tmpActive ? [] : [{ Status: tmpRun.Status || '', ChipClass: ' tsr-chip-' + String(tmpRun.Status || '').toLowerCase().replace(/[^a-z]+/g, '-') }];
		tmpState.SummarySlot = (!tmpActive && String(tmpRun.Summary || '').trim()) ? [{ Summary: String(tmpRun.Summary) }] : [];
	}

	// ── outcomes (optimistic) ────────────────────────────────────────────────
	setOutcome(pID, pOutcome)
	{
		let tmpStep = this._rawStep(pID);
		if (!tmpStep || !this._active()) { return; }
		let tmpPrior = tmpStep.Outcome;
		// Clicking the selected outcome clears it back to pending.
		let tmpNext = (tmpStep.Outcome === pOutcome) ? '' : pOutcome;
		tmpStep.Outcome = tmpNext;
		this._rebuild();
		this.render();
		this._stepAPI().update(pID, { Outcome: tmpNext })
			.catch((pErr) =>
			{
				tmpStep.Outcome = tmpPrior;
				this._rebuild();
				this.render();
				this._toast('Could not save the outcome: ' + (pErr.message || pErr), 'error');
			});
	}

	setNotes(pID, pValue) { let tmpStep = this._rawStep(pID); if (tmpStep) { tmpStep.Notes = pValue; } }

	saveNotes(pID)
	{
		let tmpStep = this._rawStep(pID);
		if (!tmpStep) { return; }
		this._stepAPI().update(pID, { Notes: tmpStep.Notes || '' })
			.catch((pErr) => this._toast('Notes save failed: ' + (pErr.message || pErr), 'error'));
	}

	// ── evidence ─────────────────────────────────────────────────────────────
	uploadEvidence(pID, pFiles)
	{
		let tmpFiles = Array.prototype.slice.call(pFiles || []);
		if (!tmpFiles.length) { return; }
		this._toast('Uploading ' + tmpFiles.length + ' file' + (tmpFiles.length > 1 ? 's' : '') + '…', 'info');
		Promise.all(tmpFiles.map((pFile) => this._mediaAPI().upload('TestRunStep', pID, pFile)))
			.then(() => { this._toast('Uploaded.', 'success'); this._loadEvidenceFor(pID); })
			.catch((pErr) => this._toast('Upload failed: ' + (pErr.message || pErr), 'error'));
	}

	dropEvidence(pEvent, pID)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		let tmpFiles = (pEvent && pEvent.dataTransfer && pEvent.dataTransfer.files) || [];
		if (tmpFiles.length) { this.uploadEvidence(pID, tmpFiles); }
	}

	allowDrop(pEvent) { if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); } }

	removeEvidence(pStepID, pIDMedia)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpDo = () => this._mediaAPI().remove(pIDMedia)
			.then(() => this._loadEvidenceFor(pStepID))
			.catch((pErr) => this._toast('Remove failed: ' + (pErr.message || pErr), 'error'));
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Remove this evidence?', { dangerous: true }).then((pOk) => { if (pOk) tmpDo(); });
		}
		else { tmpDo(); }
	}

	// ── finishing ────────────────────────────────────────────────────────────
	finish()
	{
		if (!this._active()) { return; }
		let tmpCounts = { Passed: 0, Failed: 0, Skipped: 0, Pending: 0 };
		this._steps.forEach((pStep) =>
		{
			let tmpOutcome = String(pStep.Outcome || '');
			if (!tmpOutcome) { tmpCounts.Pending++; }
			else if (typeof tmpCounts[tmpOutcome] === 'number') { tmpCounts[tmpOutcome]++; }
		});
		let tmpSuggested = (tmpCounts.Failed > 0) ? 'Failed' : 'Passed';
		let tmpParts = [tmpCounts.Passed + ' passed', tmpCounts.Failed + ' failed', tmpCounts.Skipped + ' skipped'];
		if (tmpCounts.Pending) { tmpParts.push(tmpCounts.Pending + ' not marked'); }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			return this._close(tmpSuggested);
		}
		tmpModal.show(
			{
				title: 'Finish this run?',
				content: '<p>' + tmpParts.join(', ') + '.</p><p>Suggested result: <strong>' + tmpSuggested + '</strong></p>',
				buttons:
				[
					{ Hash: 'Passed', Label: 'Passed', Style: (tmpSuggested === 'Passed') ? 'primary' : '' },
					{ Hash: 'Failed', Label: 'Failed', Style: (tmpSuggested === 'Failed') ? 'danger' : '' },
					{ Hash: 'Abandoned', Label: 'Abandoned', Style: '' },
					{ Hash: 'keep', Label: 'Keep testing', Style: '' }
				]
			})
			.then((pHash) =>
			{
				if (pHash === 'Passed' || pHash === 'Failed' || pHash === 'Abandoned') { this._close(pHash); }
			});
	}

	_close(pStatus)
	{
		this._runAPI().update(this._RunID, { Status: pStatus, CompletedDate: new Date().toISOString() })
			.then(() => { this._toast('Run marked ' + pStatus + '.', 'success'); this._load(); })
			.catch((pErr) => this._toast('Could not finish the run: ' + (pErr.message || pErr), 'error'));
	}

	leaveFeedback()
	{
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp.showNewFeedback !== 'function') { return; }
		tmpApp.showNewFeedback(
			{
				SourceType: 'Test Run',
				IDTestRun: this._RunID,
				Title: 'Feedback: ' + ((this._Run && this._Run.Name) || ('run #' + this._RunID))
			});
	}

	// ── navigation ───────────────────────────────────────────────────────────
	back()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSection === 'function') { tmpApp.showSection('TestRun'); }
	}

	openRoutine()
	{
		let tmpApp = this.pict.PictApplication;
		let tmpID = (this._Run && this._Run.IDRoutine) || 0;
		if (tmpID && tmpApp && typeof tmpApp.showEntityDetail === 'function') { tmpApp.showEntityDetail('Routine', tmpID); }
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	// Mount the shared comments section under the run (OwnerType 'TestRun'); same
	// guard pattern as EntityDetail._mountComments.
	_mountComments()
	{
		let tmpView = this.pict.views['Plansheet-Comments'];
		if (!tmpView || typeof document === 'undefined' || !this._RunID) { return; }
		let tmpApp = this.pict.PictApplication;
		let tmpEditable = !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		tmpView.options.CurrentUser = { Key: tmpUser.IDUser || 0, Name: tmpUser.DisplayName || tmpUser.Email || 'You', Avatar: tmpUser.AvatarURL || '' };
		tmpView.options.ReadOnly = !tmpEditable;
		let tmpHost = document.getElementById('Entity-Comments');
		if (tmpHost) { tmpHost.innerHTML = ''; }
		if (this._CommentsLoadedFor === this._RunID)
		{
			tmpView.render();
			return;
		}
		this._CommentsLoadedFor = this._RunID;
		tmpView.setContext({ OwnerType: 'TestRun', IDOwner: this._RunID });
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		if (typeof document !== 'undefined')
		{
			let tmpSteps = (this.pict.AppData.TestRunner && this.pict.AppData.TestRunner.Steps) || [];
			for (let i = 0; i < tmpSteps.length; i++)
			{
				let tmpHost = document.getElementById(tmpSteps[i].BodyContainerID);
				if (tmpHost)
				{
					libMarkdownRender.renderInto(this.pict.providers.Content, tmpHost, tmpSteps[i].Body,
						'<span class="ps-rel-empty">No body for this step.</span>');
				}
				let tmpNotesSlot = (tmpSteps[i].NotesViewSlot && tmpSteps[i].NotesViewSlot[0]) || null;
				if (tmpNotesSlot)
				{
					let tmpNotesHost = document.getElementById(tmpNotesSlot.ContainerID);
					if (tmpNotesHost) { libMarkdownRender.renderInto(this.pict.providers.Content, tmpNotesHost, tmpNotesSlot.Notes, ''); }
				}
			}
			this._mountComments();
			// Prompts attached to this test run: the refinement cycle's evidence
			// surface (runs recorded here tie back to the run via IDTestRun).
			let tmpPromptsView = this.pict.views['Plansheet-PromptAttachments'];
			if (tmpPromptsView && this._RunID) { tmpPromptsView.showFor('TestRun', this._RunID, 'TestRun-Prompts'); }
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewTestRunner;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-TestRunner',
	DefaultRenderable: 'TestRunner-Display',
	AutoRender: false,
	CSS: /*css*/`
		.tsr { padding: 24px; max-width: 860px; margin: 0 auto; }
		.tsr-head { display: flex; align-items: center; gap: 12px; margin-bottom: 6px; }
		.tsr-head h2 { font-size: 20px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); margin: 0; flex: 1; }
		.tsr-meta { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; color: var(--theme-color-text-secondary, #5b6376); font-size: 13px; }
		.tsr-progress { flex: 1; min-width: 160px; display: flex; align-items: center; gap: 8px; }
		.tsr-progress-track { flex: 1; height: 8px; border-radius: 999px; background: var(--theme-color-background-secondary, #eef1f6); overflow: hidden; }
		.tsr-progress-fill { height: 100%; border-radius: 999px; background: var(--theme-color-brand-primary, #2988df); transition: width 0.2s; }
		.tsr-card {
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #e6e9ee);
			border-left: 4px solid var(--theme-color-border-default, #e6e9ee);
			border-radius: 10px; padding: 14px 16px; margin-bottom: 12px;
		}
		.tsr-card-passed { border-left-color: var(--theme-color-status-success, #2e9e5b); }
		.tsr-card-failed { border-left-color: var(--theme-color-status-danger, #c0392b); }
		.tsr-card-skipped { border-left-color: var(--theme-color-text-secondary, #8a93a6); }
		.tsr-step-head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
		.tsr-step-title { flex: 1; font-size: 15px; font-weight: 600; color: var(--theme-color-text-primary, #2c3140); }
		.tsr-body { margin-bottom: 8px; }
		.tsr-body img, .tsr-body video { max-width: 100%; border-radius: 6px; }
		.tsr-expected { margin-bottom: 10px; }
		.tsr-expected-label { display: block; font-size: 11px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 4px; }
		.tsr-expected-text {
			white-space: pre-wrap; word-break: break-word;
			font-size: 13px; line-height: 1.5; color: var(--theme-color-text-primary, #2c3140);
			background: var(--theme-color-background-secondary, #f6f8fa);
			border-left: 3px solid var(--theme-color-brand-primary, #2988df);
			border-radius: 6px; padding: 8px 12px;
		}
		.tsr-outcomes { display: flex; gap: 8px; margin: 10px 0; }
		.tsr-btn {
			flex: 0 0 auto; padding: 9px 18px; border-radius: 8px; font-size: 14px; cursor: pointer;
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140);
		}
		.tsr-btn-pass.tsr-on { background: var(--theme-color-status-success, #2e9e5b); color: #fff; border-color: transparent; }
		.tsr-btn-fail.tsr-on { background: var(--theme-color-status-danger, #c0392b); color: #fff; border-color: transparent; }
		.tsr-btn-skip.tsr-on { background: var(--theme-color-text-secondary, #8a93a6); color: #fff; border-color: transparent; }
		.tsr-chip { display: inline-block; padding: 3px 12px; border-radius: 999px; font-size: 12px; font-weight: 600; color: #fff; background: var(--theme-color-text-secondary, #8a93a6); }
		.tsr-chip-passed { background: var(--theme-color-status-success, #2e9e5b); }
		.tsr-chip-failed { background: var(--theme-color-status-danger, #c0392b); }
		.tsr-chip-abandoned { background: var(--theme-color-text-secondary, #8a93a6); }
		.tsr-chip-in-progress { background: var(--theme-color-brand-primary, #2988df); color: var(--theme-color-text-on-brand, #fff); }
		.tsr-notes { width: 100%; min-height: 56px; resize: vertical; box-sizing: border-box; }
		.tsr-evidence { margin-top: 10px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 8px; padding: 10px; }
		.tsr-evidence-label { font-size: 12px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 8px; }
		.tsr-ref-label { font-size: 12px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); margin: 8px 0 6px; }
		.tsr-bar {
			position: sticky; bottom: 0; display: flex; align-items: center; gap: 12px;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #e6e9ee);
			border-radius: 10px; padding: 12px 16px; margin-top: 16px;
			box-shadow: 0 -2px 12px rgba(0,0,0,0.06);
		}
		.tsr-bar-text { flex: 1; font-size: 14px; color: var(--theme-color-text-secondary, #5b6376); }
		.tsr-summary { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 10px; padding: 12px 16px; margin-bottom: 14px; font-size: 14px; white-space: pre-wrap; }
		.tsr-comments { margin-top: 20px; }
	`,
	Templates:
	[
		{
			Hash: 'TestRunner-Display',
			Template: /*html*/`
<div class="tsr">
	<div class="tsr-head">
		<button class="ps-btn" onclick="_Pict.views['Plansheet-TestRunner'].back()">← Test Runs</button>
		<h2>{~D:AppData.TestRunner.HeaderTitle~}</h2>
		<span class="tsr-chip{~D:AppData.TestRunner.StatusChipClass~}">{~D:AppData.TestRunner.Status~}</span>
	</div>
	<div class="tsr-meta">
		<span class="ps-chip"><a class="ps-link" onclick="_Pict.views['Plansheet-TestRunner'].openRoutine()">{~D:AppData.TestRunner.RoutineName~}</a></span>
		{~TS:TR-Env:AppData.TestRunner.EnvironmentSlot~}
		<div class="tsr-progress">
			<span>{~D:AppData.TestRunner.Progress.Done~}/{~D:AppData.TestRunner.Progress.Total~}</span>
			<div class="tsr-progress-track"><div class="tsr-progress-fill" style="width: {~D:AppData.TestRunner.Progress.Pct~}%"></div></div>
		</div>
	</div>
	{~TS:TR-Summary:AppData.TestRunner.SummarySlot~}
	{~TS:TR-StepCard:AppData.TestRunner.Steps~}
	{~TS:TR-ActiveBar:AppData.TestRunner.ActiveBarSlot~}
	{~TS:TR-DoneBar:AppData.TestRunner.DoneBarSlot~}
	<div class="tsr-prompts"><h4 class="ps-detail-board-h">Prompts</h4><div id="TestRun-Prompts"></div></div>
	<div class="tsr-comments"><h4 class="ps-detail-board-h">Comments</h4><div id="Entity-Comments"></div></div>
</div>`
		},
		{ Hash: 'TR-Env', Template: /*html*/`<span class="ps-chip" title="Environment">{~D:Record.Environment~}</span>` },
		{ Hash: 'TR-Summary', Template: /*html*/`<div class="tsr-summary">{~D:Record.Summary~}</div>` },
		{
			Hash: 'TR-StepCard',
			Template: /*html*/`
<div class="tsr-card{~D:Record.CardClass~}">
	<div class="tsr-step-head">
		<span class="ps-step-num">{~D:Record.Idx~}</span>
		<span class="tsr-step-title">{~D:Record.Title~}</span>
		{~TS:TR-OutcomeChip:Record.OutcomeChipSlot~}
	</div>
	<div class="tsr-body" id="{~D:Record.BodyContainerID~}"></div>
	{~TS:TR-RefMedia:Record.RefMediaSlot~}
	{~TS:TR-Expected:Record.ExpectedSlot~}
	{~TS:TR-OutcomeButtons:Record.OutcomeButtonsSlot~}
	{~TS:TR-NotesEdit:Record.NotesEditSlot~}
	{~TS:TR-NotesView:Record.NotesViewSlot~}
	{~TS:TR-Evidence:Record.EvidenceWrapSlot~}
</div>`
		},
		{ Hash: 'TR-RefMedia', Template: /*html*/`<div class="tsr-ref-label">From the routine:</div><div class="ps-media-grid">{~TS:TR-MediaItem:Record.Items~}</div>` },
		{ Hash: 'TR-Expected', Template: /*html*/`<div class="tsr-expected"><span class="tsr-expected-label">Expect</span><div class="tsr-expected-text">{~D:Record.Expected~}</div></div>` },
		{
			Hash: 'TR-OutcomeButtons',
			Template: /*html*/`
<div class="tsr-outcomes">
	<button class="tsr-btn tsr-btn-pass{~D:Record.PassedClass~}" onclick="_Pict.views['Plansheet-TestRunner'].setOutcome({~D:Record.ID~},'Passed')">Worked</button>
	<button class="tsr-btn tsr-btn-fail{~D:Record.FailedClass~}" onclick="_Pict.views['Plansheet-TestRunner'].setOutcome({~D:Record.ID~},'Failed')">Didn't work</button>
	<button class="tsr-btn tsr-btn-skip{~D:Record.SkippedClass~}" onclick="_Pict.views['Plansheet-TestRunner'].setOutcome({~D:Record.ID~},'Skipped')">Skip</button>
</div>`
		},
		{ Hash: 'TR-OutcomeChip', Template: /*html*/`<span class="tsr-chip{~D:Record.ChipClass~}">{~D:Record.Outcome~}</span>` },
		{
			Hash: 'TR-NotesEdit',
			Template: /*html*/`<textarea class="ps-input tsr-notes" placeholder="Notes (markdown). What did you see?"
	oninput="_Pict.views['Plansheet-TestRunner'].setNotes({~D:Record.ID~}, this.value)"
	onchange="_Pict.views['Plansheet-TestRunner'].saveNotes({~D:Record.ID~})">{~D:Record.Notes~}</textarea>`
		},
		{ Hash: 'TR-NotesView', Template: /*html*/`<div class="tsr-ref-label">Notes:</div><div class="tsr-body" id="{~D:Record.ContainerID~}"></div>` },
		{
			Hash: 'TR-Evidence',
			Template: /*html*/`
<div class="tsr-evidence" ondragover="_Pict.views['Plansheet-TestRunner'].allowDrop(event)" ondrop="_Pict.views['Plansheet-TestRunner'].dropEvidence(event, {~D:Record.ID~})">
	<div class="tsr-evidence-label">Evidence</div>
	<div class="ps-media-grid">{~TS:TR-MediaItem:Record.Items~}</div>
	{~TS:TR-EvidenceUpload:Record.UploadSlot~}
</div>`
		},
		{ Hash: 'TR-EvidenceUpload', Template: /*html*/`<label class="ps-btn ps-btn-sm ps-file-btn">+ Add evidence<input type="file" multiple accept="image/*,video/*" style="display:none" onchange="_Pict.views['Plansheet-TestRunner'].uploadEvidence({~D:Record.ID~}, this.files)"></label>` },
		{ Hash: 'TR-MediaItem', Template: /*html*/`<div class="ps-media-item">{~TS:TR-MediaImage:Record.ImageSlot~}{~TS:TR-MediaVideo:Record.VideoSlot~}{~TS:TR-MediaFile:Record.FileSlot~}{~TS:TR-MediaRemove:Record.RemoveSlot~}</div>` },
		{ Hash: 'TR-MediaImage', Template: /*html*/`<a href="{~D:Record.URL~}" target="_blank" rel="noopener"><img class="ps-media-thumb" src="{~D:Record.URL~}" alt="{~D:Record.Title~}" title="{~D:Record.Title~}"></a>` },
		{ Hash: 'TR-MediaVideo', Template: /*html*/`<video class="ps-media-video" controls preload="metadata" src="{~D:Record.URL~}" title="{~D:Record.Title~}"></video>` },
		{ Hash: 'TR-MediaFile', Template: /*html*/`<a class="ps-link ps-media-file" href="{~D:Record.URL~}" target="_blank" rel="noopener"><span class="ps-media-file-type">{~D:Record.Type~}</span>{~D:Record.Title~}</a>` },
		{ Hash: 'TR-MediaRemove', Template: /*html*/`<button class="ps-chip-x ps-media-x" title="Remove" onclick="_Pict.views['Plansheet-TestRunner'].removeEvidence({~D:Record.StepID~},{~D:Record.ID~})">×</button>` },
		{
			Hash: 'TR-ActiveBar',
			Template: /*html*/`
<div class="tsr-bar">
	<span class="tsr-bar-text">Mark each step, then finish the run.</span>
	<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-TestRunner'].finish()">Finish run</button>
</div>`
		},
		{
			Hash: 'TR-DoneBar',
			Template: /*html*/`
<div class="tsr-bar">
	<span class="tsr-bar-text">This run is finished: <span class="tsr-chip{~D:Record.ChipClass~}">{~D:Record.Status~}</span></span>
	<button class="ps-btn ps-btn-primary" onclick="_Pict.views['Plansheet-TestRunner'].leaveFeedback()">Leave feedback</button>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'TestRunner-Display',
			TemplateHash: 'TestRunner-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../EntityDescriptors.js":555,"./MarkdownRender.js":649,"pict-view":365}],702:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

class PictViewTopBarNav extends libPictView
{
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewTopBarNav;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-TopBar-Nav',
	DefaultRenderable: 'Plansheet-TopBar-Nav',
	DefaultDestinationAddress: '#Theme-TopBar-Nav',
	AutoRender:                false,
	CSS: /*css*/`
		.cst-nav {
			display: flex; align-items: center; justify-content: flex-end; height: 100%;
			padding: 0 12px; gap: 8px; flex: 1 1 auto;
			color: var(--theme-color-text-on-brand,
				   var(--theme-color-text-primary, #1d2230));
			font-weight: 500;
		}
		/* No nav items yet: collapse the empty container so its padding does not
		   leave a sliver next to the user area. Shows again once it has content. */
		.cst-nav:empty { display: none; padding: 0; }
		.cst-nav-sep { opacity: 0.5; font-weight: 400; margin: 0 2px; }
		/* The "?" help toggle. Opens the contextual help drawer (also F1). */
		.cst-nav-help {
			display: flex; align-items: center; justify-content: center;
			width: 32px; height: 32px; padding: 0; border: none; border-radius: 8px;
			background: transparent; cursor: pointer; opacity: 0.85;
			color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #1d2230));
		}
		.cst-nav-help:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.10)); opacity: 1; }
		.cst-nav-help svg { display: block; }
			/* Two left-pinned controls next to the logo, kept as one group by margin-right:auto on the
			   LAST of them (the rail-view toggle). First: sidebar show/hide (Plansheet-SidebarToggle,
			   same action as Cmd+B). Second: rail-view cycle (Plansheet-RailToggle, nav/notebook/split).
			   Each does exactly one thing; the app keeps their icons/state in sync (_updateSidebarToggle,
			   _updateRailToggle). The rail-view toggle is disabled while the sidebar is hidden. */
			.cst-nav-sidebar, .cst-nav-rail {
				display: flex; align-items: center; justify-content: center;
				width: 32px; height: 32px; padding: 0; border: none; border-radius: 8px;
				background: transparent; cursor: pointer; opacity: 0.85;
				color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #1d2230));
			}
			.cst-nav-rail { margin-right: auto; }
			.cst-nav-sidebar:hover, .cst-nav-rail:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.10)); opacity: 1; }
			.cst-nav-sidebar svg, .cst-nav-rail svg { display: block; }
			.cst-nav-rail:disabled { opacity: 0.3; cursor: default; }
			.cst-nav-rail:disabled:hover { background: transparent; opacity: 0.3; }
			/* The 9-square app launcher, left of the help button. Opens the cmd+K command palette. */
			.cst-nav-launcher {
				display: flex; align-items: center; justify-content: center;
				width: 32px; height: 32px; padding: 0; border: none; border-radius: 8px;
				background: transparent; cursor: pointer; opacity: 0.85;
				color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #1d2230));
			}
			.cst-nav-launcher:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.10)); opacity: 1; }
			.cst-nav-launcher svg { display: block; }
	`,
	Templates: [{
		Hash: 'Plansheet-TopBar-Nav',
		Template: /*html*/`<div class="cst-nav"><button class="cst-nav-launcher" title="Jump to... (Cmd+K)" aria-label="Open the launcher" onclick="_Pict.PictApplication.openCommandLauncher()"><svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><circle cx="5" cy="5" r="1.8"></circle><circle cx="12" cy="5" r="1.8"></circle><circle cx="19" cy="5" r="1.8"></circle><circle cx="5" cy="12" r="1.8"></circle><circle cx="12" cy="12" r="1.8"></circle><circle cx="19" cy="12" r="1.8"></circle><circle cx="5" cy="19" r="1.8"></circle><circle cx="12" cy="19" r="1.8"></circle><circle cx="19" cy="19" r="1.8"></circle></svg></button><button class="cst-nav-sidebar" id="Plansheet-SidebarToggle" title="Hide sidebar (Cmd+B)" aria-label="Show or hide the sidebar" onclick="_Pict.PictApplication.toggleSidebar()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"></rect><line x1="9" y1="4" x2="9" y2="20"></line><path d="M15.5 9l-2.5 3 2.5 3"></path></svg></button><button class="cst-nav-help" title="Help (F1)" aria-label="Help" onclick="_Pict.PictApplication.toggleHelpDrawer()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></button></div>`
	}],
	Renderables: [{
		RenderableHash: 'Plansheet-TopBar-Nav',
		TemplateHash: 'Plansheet-TopBar-Nav',
		ContentDestinationAddress: '#Theme-TopBar-Nav'
	}]
};

},{"pict-view":365}],703:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libAvatarHelper = require('./AvatarHelper.js');
const libFrameworkClient = require('../providers/FrameworkClient.js');

function _escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

class PictViewTopBarUser extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.TopBarUser = this.pict.AppData.TopBarUser
			|| { LoggedInSlot: [], GuestSlot: [{}], DisplayName: '' };
	}

	_refreshSlots()
	{
		let tmpAuth = this.pict.AppData.Auth || {};
		if (tmpAuth.LoggedIn && tmpAuth.User)
		{
			this.pict.AppData.TopBarUser.LoggedInSlot = [
				{
					IDUser: tmpAuth.User.IDUser || 0,
					DisplayName: tmpAuth.User.DisplayName || tmpAuth.User.Email || tmpAuth.User.LoginID || 'You',
					Email: tmpAuth.User.Email || '',
					Color: tmpAuth.User.Color || '',
					PhotoHash: tmpAuth.User.PhotoHash || ''
				}];
			this.pict.AppData.TopBarUser.GuestSlot = [];
		}
		else
		{
			this.pict.AppData.TopBarUser.LoggedInSlot = [];
			this.pict.AppData.TopBarUser.GuestSlot = [{}];
		}
	}

	signIn()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showAuth === 'function') tmpApp.showAuth('login');
	}

	signOut()
	{
		this._closeSessionCard();
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.signOut === 'function') tmpApp.signOut();
	}

	// The top-right chip opens a small account/session card on click: who you are and a couple of facts
	// (email, organization, role, last sign-in) plus shortcuts to the profile, settings, and sign out.
	// It is an anchored, non-blocking popover (no backdrop) appended to <body>, dismissed by clicking
	// outside, pressing Escape, choosing an action, or clicking the chip again.
	toggleSessionCard()
	{
		if (this._SessionCardEl) { this._closeSessionCard(); }
		else { this._openSessionCard(); }
	}

	_openSessionCard()
	{
		if (typeof document === 'undefined') { return; }
		let tmpAuth = this.pict.AppData.Auth || {};
		let tmpUser = (tmpAuth.LoggedIn && tmpAuth.User) ? tmpAuth.User : null;
		let tmpChip = document.getElementById('Plansheet-TopBar-Chip');
		if (!tmpUser || !tmpChip) { return; }

		let tmpEl = document.createElement('div');
		tmpEl.className = 'cst-acct-popover';
		tmpEl.innerHTML = this._sessionCardHTML(tmpUser);
		document.body.appendChild(tmpEl);
		// Fetch the account's plan sheets and fill the switcher list.
		this._loadTenants();
		this._loadInvitations();

		// Anchor below the chip, right-aligned to it and clamped into the viewport.
		let tmpRect = tmpChip.getBoundingClientRect();
		tmpEl.style.top = Math.round(tmpRect.bottom + 6) + 'px';
		tmpEl.style.right = Math.max(8, Math.round(window.innerWidth - tmpRect.right)) + 'px';

		this._SessionCardEl = tmpEl;
		// Defer wiring the dismiss handlers so the click that opened the card does not immediately close it.
		this._SessionCardOutside = (pEvent) =>
		{
			if (!this._SessionCardEl) { return; }
			if (this._SessionCardEl.contains(pEvent.target)) { return; }
			if (tmpChip.contains(pEvent.target)) { return; }
			this._closeSessionCard();
		};
		this._SessionCardKey = (pEvent) => { if (pEvent.key === 'Escape') { this._closeSessionCard(); } };
		let tmpSelf = this;
		setTimeout(function ()
		{
			document.addEventListener('mousedown', tmpSelf._SessionCardOutside, true);
			document.addEventListener('keydown', tmpSelf._SessionCardKey, true);
		}, 0);
	}

	_closeSessionCard()
	{
		if (typeof document !== 'undefined')
		{
			if (this._SessionCardOutside) { document.removeEventListener('mousedown', this._SessionCardOutside, true); }
			if (this._SessionCardKey) { document.removeEventListener('keydown', this._SessionCardKey, true); }
		}
		if (this._SessionCardEl && this._SessionCardEl.parentNode) { this._SessionCardEl.parentNode.removeChild(this._SessionCardEl); }
		this._SessionCardEl = null;
		this._SessionCardOutside = null;
		this._SessionCardKey = null;
	}

	gotoProfile()
	{
		this._closeSessionCard();
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showProfile === 'function') { tmpApp.showProfile(); }
	}

	gotoSettings()
	{
		this._closeSessionCard();
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSection === 'function') { tmpApp.showSection('Settings'); }
	}

	// --- Tenant switcher (plan sheets) ---------------------------------------
	// The account popover lists the human's personas (one per plan sheet) and
	// lets them switch, create a new plan sheet they administer, or leave one.
	// Each action hits the server then reloads, so the whole app re-bootstraps
	// into the now-active tenant (the session cookie carries the new persona).

	_tenantAPI(pPath, pMethod, pBody)
	{
		let tmpURL = '/1.0/' + String(pPath).replace(/^\//, '');
		let tmpMethod = String(pMethod || 'GET').toUpperCase();
		let tmpRequest;
		if (tmpMethod === 'POST') { tmpRequest = libFrameworkClient.postJSON(this.pict, tmpURL, pBody || {}); }
		else if (tmpMethod === 'PUT') { tmpRequest = libFrameworkClient.putJSON(this.pict, tmpURL, pBody || {}); }
		else if (tmpMethod === 'DELETE') { tmpRequest = libFrameworkClient.delJSON(this.pict, tmpURL); }
		else { tmpRequest = libFrameworkClient.getJSON(this.pict, tmpURL); }
		// Through the shared RestClient so tenant actions recover on a 401. Keep
		// the { ok, body } contract callers read: a >= 400 rejects, which we map to
		// ok:false with the server's Error surfaced in body (FrameworkClient's error
		// carries body.Error as its message).
		return tmpRequest.then(
			(pBodyResult) => ({ ok: true, body: pBodyResult || {} }),
			(pError) => ({ ok: false, body: { Error: (pError && pError.message) || 'Request failed.' } }));
	}

	_loadTenants()
	{
		this._tenantAPI('Account/Tenants').then((pResult) =>
		{
			if (pResult.ok && pResult.body && Array.isArray(pResult.body.Tenants)) { this._renderTenants(pResult.body.Tenants); }
		}).catch(() => { /* keep the placeholder on error */ });
	}

	_renderTenants(pTenants)
	{
		if (typeof document === 'undefined') { return; }
		let tmpEl = document.getElementById('cst-acct-tenant-list');
		if (!tmpEl) { return; }
		if (!pTenants.length) { tmpEl.innerHTML = '<div class="cst-acct-tenant-empty">No plan sheets.</div>'; return; }
		// The server orders these pinned-first, then by recency (WI #339); the flyout renders that order
		// directly. Show at most 8 in the compact popover, but never let the plan sheet you are currently
		// in fall below the fold: if it is not among the first 8 (only possible with 8+ pinned), append it.
		let tmpCompact = pTenants.slice(0, 8);
		let tmpCurrent = pTenants.find((pTenant) => pTenant.IsCurrent);
		if (tmpCurrent && tmpCompact.indexOf(tmpCurrent) < 0) { tmpCompact.push(tmpCurrent); }
		let tmpSelf = "_Pict.views['Plansheet-TopBar-User']";
		tmpEl.innerHTML = tmpCompact.map((pTenant) => this._tenantRowHTML(pTenant, tmpSelf)).join('');
		// "View all" now opens the cross-tenant home (WI #339) instead of the old dead-end modal.
		let tmpViewAll = document.getElementById('cst-acct-tenant-viewall');
		if (tmpViewAll)
		{
			// Always offer the way to the full cross-tenant home, not only when the compact list overflows 8.
			tmpViewAll.style.display = '';
			tmpViewAll.textContent = (pTenants.length > 8) ? ('View all ' + pTenants.length + ' plan sheets') : 'Your plan sheets';
		}
	}

	// A pin/unpin glyph (filled when pinned) used on each flyout row; matches the home's pin control.
	_pinSVG(pOn)
	{
		return '<svg viewBox="0 0 16 16" width="14" height="14" fill="' + (pOn ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.4">'
			+ '<path d="M5 2h6l-1 5 3 3H3l3-3-1-5z"/><path d="M8 10v4"/></svg>';
	}

	_tenantRowHTML(pTenant, pSelf)
	{
		let tmpSelf = pSelf || "_Pict.views['Plansheet-TopBar-User']";
		let tmpClick = pTenant.IsCurrent ? '' : ' onclick="' + tmpSelf + '.switchTenant(' + (pTenant.IDCustomer || 0) + ')"';
		let tmpIsAdmin = pTenant.IsCurrent && (pTenant.RoleLabel === 'Owner' || pTenant.RoleLabel === 'Admin' || pTenant.RoleLabel === 'Platform Admin');
		// A pin toggle on every row (pinned-first ordering is set by the server; this makes it legible and
		// actionable straight from the switcher). stopPropagation so pinning never triggers the row switch.
		let tmpPin = '<button class="cst-acct-tenant-pin' + (pTenant.Pinned ? ' on' : '') + '" title="' + (pTenant.Pinned ? 'Unpin' : 'Pin to the top') + '" onclick="event.stopPropagation();' + tmpSelf + '.togglePin(' + (pTenant.IDCustomer || 0) + ')">' + this._pinSVG(pTenant.Pinned) + '</button>';
		let tmpRight = pTenant.IsCurrent
			? ((tmpIsAdmin ? '<button class="cst-acct-tenant-invite" title="Invite someone to this plan sheet" onclick="' + tmpSelf + '.inviteToTenant()">Invite</button>' : '') +
				'<button class="cst-acct-tenant-leave" title="Leave this plan sheet" onclick="' + tmpSelf + '.leaveTenant(' + (pTenant.IDCustomer || 0) + ')">Leave</button>')
			: '<span class="cst-acct-tenant-go">Switch</span>';
		return '<div class="cst-acct-tenant' + (pTenant.IsCurrent ? ' is-current' : '') + '"' + tmpClick + '>' +
				'<span class="cst-acct-tenant-main">' +
					'<span class="cst-acct-tenant-name">' + _escapeHTML(pTenant.CustomerName || 'Untitled') + '</span>' +
					'<span class="cst-acct-tenant-sub">as ' + _escapeHTML(pTenant.DisplayName || '') + ' &middot; ' + _escapeHTML(pTenant.RoleLabel || 'Member') + '</span>' +
				'</span>' + tmpPin + tmpRight +
			'</div>';
	}

	// "View all N plan sheets" from the switcher: go to the cross-tenant home (WI #339). This replaces
	// the old modal, which was itself a dead end for the overflow it was meant to fix.
	viewAllPlansheets()
	{
		this._closeSessionCard();
		let tmpApp = this.pict && this.pict.PictApplication;
		if (tmpApp && typeof tmpApp._navigate === 'function') { tmpApp._navigate('/home'); return; }
		if (typeof window !== 'undefined' && window.location) { window.location.hash = '#/home'; }
	}

	// Pin/unpin a plan sheet straight from the switcher, then reload the list so the pinned-first order
	// updates. Empty body = toggle (the server flips the current state).
	togglePin(pIDCustomer)
	{
		let tmpID = parseInt(pIDCustomer, 10) || 0;
		if (!tmpID) { return; }
		this._tenantAPI('Account/Tenants/' + tmpID + '/Pin', 'POST', {}).then((pResult) =>
		{
			if (pResult.ok && pResult.body && pResult.body.Success) { this._loadTenants(); return; }
			this._toast((pResult.body && pResult.body.Error) || 'Could not update the pin.');
		}).catch(() => this._toast('Could not update the pin.'));
	}

	// Reload after the active plan sheet changed (switch / create / leave / join). The new tenant does not
	// have the record the current route points at (a specific document, a work item id), so a blind reload
	// would land on a not-found screen -- the reported route leak. The application reduces the route to the
	// feature area we were viewing before reloading; fall back to a plain reload if it is somehow absent.
	// See WI #328 (Pict-Application-Plansheet.reloadForActivePlansheetChange / _tenantSafeRoute).
	_reloadForTenantChange()
	{
		let tmpApp = this.pict && this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.reloadForActivePlansheetChange === 'function') { tmpApp.reloadForActivePlansheetChange(); return; }
		if (typeof window !== 'undefined' && window.location) { window.location.reload(); }
	}

	switchTenant(pIDCustomer)
	{
		this._tenantAPI('Session/Context/' + pIDCustomer, 'POST').then((pResult) =>
		{
			if (pResult.ok && pResult.body && pResult.body.Switched) { this._reloadForTenantChange(); return; }
			this._toast((pResult.body && pResult.body.Error) || 'Could not switch plan sheet.');
		}).catch(() => this._toast('Could not switch plan sheet.'));
	}

	createTenant()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		this._closeSessionCard();
		// Reached from the desktop popover (no modal open, a no-op) or the mobile menu modal; in the
		// latter case close it first so the create form is not stacked on top of the menu.
		if (typeof tmpModal.dismissModals === 'function') { tmpModal.dismissModals(); }
		let tmpInputID = 'cst-new-tenant-name';
		let tmpName = '';
		tmpModal.show(
			{
				title: 'Create a plan sheet',
				content: '<div class="cst-tenant-form">' +
					'<label for="' + tmpInputID + '">Name</label>' +
					'<input id="' + tmpInputID + '" type="text" autocomplete="off" maxlength="200" placeholder="e.g. The Band, Q3 Roadmap" />' +
					'<p class="cst-tenant-form-hint">You will be its administrator. Switch between plan sheets any time from your account menu.</p>' +
				'</div>',
				buttons: [ { Hash: 'create', Label: 'Create plan sheet', Style: 'primary' }, { Hash: 'cancel', Label: 'Cancel' } ],
				closeable: true,
				onOpen: () =>
				{
					let tmpInput = document.getElementById(tmpInputID);
					if (!tmpInput) { return; }
					tmpInput.focus();
					tmpInput.addEventListener('input', () => { tmpName = String(tmpInput.value || '').trim(); });
				}
			}).then((pHash) =>
			{
				if (pHash !== 'create' || !tmpName) { return; }
				this._tenantAPI('Account/Tenants', 'POST', { Name: tmpName }).then((pResult) =>
				{
					if (pResult.ok && pResult.body && pResult.body.Success) { this._reloadForTenantChange(); return; }
					this._toast((pResult.body && pResult.body.Error) || 'Could not create the plan sheet.');
				}).catch(() => this._toast('Could not create the plan sheet.'));
			});
	}

	leaveTenant(pIDCustomer)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let fDo = () =>
		{
			this._tenantAPI('Account/Tenants/' + pIDCustomer + '/Leave', 'POST').then((pResult) =>
			{
				if (pResult.ok && pResult.body && pResult.body.Success) { this._reloadForTenantChange(); return; }
				this._toast((pResult.body && pResult.body.Error) || 'Could not leave the plan sheet.');
			}).catch(() => this._toast('Could not leave the plan sheet.'));
		};
		this._closeSessionCard();
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Leave this plan sheet? Your name stays on the work you did here, but you lose access until someone adds you back.',
				{ title: 'Leave plan sheet?', confirmLabel: 'Leave', cancelLabel: 'Stay', dangerous: true })
				.then((pOk) => { if (pOk) { fDo(); } });
		}
		else { fDo(); }
	}

	_toast(pMessage)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: 'error' }); }
		else if (typeof window !== 'undefined') { window.alert(pMessage); }
	}

	// --- Invitations ---------------------------------------------------------
	// Invitee side: pending invitations appear in the account card; Join creates a
	// persona in that plan sheet and switches in. Inviter side: an Invite action on
	// the current plan sheet (admins only) sends an invitation by email.

	_loadInvitations()
	{
		this._tenantAPI('Account/Invitations').then((pResult) =>
		{
			if (pResult.ok && pResult.body && Array.isArray(pResult.body.Invitations)) { this._renderInvitations(pResult.body.Invitations); }
		}).catch(() => { /* leave the section hidden on error */ });
	}

	_renderInvitations(pInvites)
	{
		if (typeof document === 'undefined') { return; }
		let tmpEl = document.getElementById('cst-acct-invites');
		if (!tmpEl) { return; }
		if (!pInvites.length) { tmpEl.style.display = 'none'; tmpEl.innerHTML = ''; return; }
		let tmpSelf = "_Pict.views['Plansheet-TopBar-User']";
		tmpEl.style.display = '';
		tmpEl.innerHTML = '<div class="cst-acct-tenants-h">Invitations</div>' + pInvites.map((pInvite) =>
		{
			return '<div class="cst-acct-invite">' +
					'<span class="cst-acct-tenant-main">' +
						'<span class="cst-acct-tenant-name">' + _escapeHTML(pInvite.CustomerName || 'A plan sheet') + '</span>' +
						'<span class="cst-acct-tenant-sub">invited as ' + _escapeHTML(pInvite.RoleSystemKey || 'member') + '</span>' +
					'</span>' +
					'<span class="cst-acct-invite-actions">' +
						'<button class="cst-acct-invite-accept" onclick="' + tmpSelf + '.acceptInvite(' + (pInvite.IDInvitation || 0) + ')">Join</button>' +
						'<button class="cst-acct-invite-decline" onclick="' + tmpSelf + '.declineInvite(' + (pInvite.IDInvitation || 0) + ')">Dismiss</button>' +
					'</span>' +
				'</div>';
		}).join('');
	}

	acceptInvite(pIDInvitation)
	{
		this._tenantAPI('Account/Invitations/' + pIDInvitation + '/Accept', 'POST').then((pResult) =>
		{
			if (pResult.ok && pResult.body && pResult.body.Success) { this._reloadForTenantChange(); return; }
			this._toast((pResult.body && pResult.body.Error) || 'Could not join the plan sheet.');
		}).catch(() => this._toast('Could not join the plan sheet.'));
	}

	declineInvite(pIDInvitation)
	{
		this._tenantAPI('Account/Invitations/' + pIDInvitation + '/Decline', 'POST').then((pResult) =>
		{
			if (pResult.ok && pResult.body && pResult.body.Success) { this._loadInvitations(); return; }
			this._toast((pResult.body && pResult.body.Error) || 'Could not dismiss the invitation.');
		}).catch(() => this._toast('Could not dismiss the invitation.'));
	}

	inviteToTenant()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		this._closeSessionCard();
		// Close the mobile menu modal first when invoked from it, so the invite form is not stacked.
		if (typeof tmpModal.dismissModals === 'function') { tmpModal.dismissModals(); }
		let tmpEmailID = 'cst-invite-email';
		let tmpRoleID = 'cst-invite-role';
		let tmpEmail = '';
		let tmpRole = 'member';
		tmpModal.show(
			{
				title: 'Invite to this plan sheet',
				content: '<div class="cst-tenant-form">' +
					'<label for="' + tmpEmailID + '">Email</label>' +
					'<input id="' + tmpEmailID + '" type="email" autocomplete="off" placeholder="teammate@example.com" />' +
					'<label for="' + tmpRoleID + '">Role</label>' +
					'<select id="' + tmpRoleID + '"><option value="member">Member</option><option value="admin">Admin</option><option value="viewer">Viewer</option><option value="owner">Owner</option></select>' +
					'<p class="cst-tenant-form-hint">They join when they accept, with their own persona in this plan sheet.</p>' +
				'</div>',
				buttons: [ { Hash: 'invite', Label: 'Send invitation', Style: 'primary' }, { Hash: 'cancel', Label: 'Cancel' } ],
				closeable: true,
				onOpen: () =>
				{
					let tmpInput = document.getElementById(tmpEmailID);
					if (tmpInput) { tmpInput.focus(); tmpInput.addEventListener('input', () => { tmpEmail = String(tmpInput.value || '').trim(); }); }
					let tmpSelect = document.getElementById(tmpRoleID);
					if (tmpSelect) { tmpSelect.addEventListener('change', () => { tmpRole = tmpSelect.value; }); }
				}
			}).then((pHash) =>
			{
				if (pHash !== 'invite' || !tmpEmail) { return; }
				this._tenantAPI('Org/Invitations', 'POST', { Email: tmpEmail, Role: tmpRole }).then((pResult) =>
				{
					if (pResult.ok && pResult.body && pResult.body.Success)
					{
						if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Invitation sent to ' + tmpEmail, { type: 'success' }); }
						return;
					}
					this._toast((pResult.body && pResult.body.Error) || 'Could not send the invitation.');
				}).catch(() => this._toast('Could not send the invitation.'));
			});
	}

	_sessionCardHTML(pUser)
	{
		let tmpAvatar = libAvatarHelper.avatarHTML(pUser, { Size: 56 });
		let tmpTitle = _escapeHTML(pUser.Title || '');
		let tmpRows = '';
		let fRow = (pLabel, pValue) =>
		{
			tmpRows += '<div class="cst-acct-row"><span class="cst-acct-k">' + _escapeHTML(pLabel) + '</span><span class="cst-acct-v">' + _escapeHTML(pValue) + '</span></div>';
		};
		fRow('Email', pUser.Email || '—');
		if (pUser.CustomerName) { fRow('Organization', pUser.CustomerName); }
		fRow('Role', pUser.RoleLabel || 'Member');
		fRow('Last signed in', this._formatWhen(pUser.LastLoginDate));
		// Filled asynchronously by _loadInvitations; hidden until there are any.
		let tmpInvites = '<div class="cst-acct-invites" id="cst-acct-invites" style="display:none"></div>';
		let tmpSwitcher = '<div class="cst-acct-tenants">' +
			'<div class="cst-acct-tenants-h">Plan sheets</div>' +
			'<div class="cst-acct-tenant-list" id="cst-acct-tenant-list"><div class="cst-acct-tenant-empty">Loading&hellip;</div></div>' +
			'<button class="cst-acct-tenant-viewall" id="cst-acct-tenant-viewall" onclick="_Pict.views[\'Plansheet-TopBar-User\'].viewAllPlansheets()">Your plan sheets</button>' +
			'<button class="cst-acct-new" onclick="_Pict.views[\'Plansheet-TopBar-User\'].createTenant()">+ New plan sheet</button>' +
		'</div>';
		// Color-mode control, mirroring Settings > Appearance so the choice is one click from the name chip.
		let tmpMode = '';
		try
		{
			let tmpTheme = this.pict.providers.Theme;
			let tmpCurrent = (tmpTheme && typeof tmpTheme.getActiveTheme === 'function' && (tmpTheme.getActiveTheme() || {}).Mode) || 'system';
			let fSeg = (pMode, pLabel) => '<button class="cst-acct-mode-btn' + (tmpCurrent === pMode ? ' on' : '') + '" data-mode="' + pMode + '" onclick="_Pict.views[\'Plansheet-TopBar-User\'].setColorMode(\'' + pMode + '\')">' + pLabel + '</button>';
			tmpMode = '<div class="cst-acct-mode">' +
				'<div class="cst-acct-mode-h">Appearance</div>' +
				'<div class="cst-acct-mode-seg" role="group" aria-label="Color mode">' + fSeg('light', 'Light') + fSeg('dark', 'Dark') + fSeg('system', 'System') + '</div>' +
			'</div>';
		}
		catch (pErr) { tmpMode = ''; }
		let tmpActions = '<div class="cst-acct-actions">' +
			'<button class="cst-acct-act" onclick="_Pict.views[\'Plansheet-TopBar-User\'].gotoProfile()">View profile</button>' +
			'<button class="cst-acct-act" onclick="_Pict.views[\'Plansheet-TopBar-User\'].gotoSettings()">Settings</button>' +
			'<button class="cst-acct-act cst-acct-act-danger" onclick="_Pict.views[\'Plansheet-TopBar-User\'].signOut()">Sign out</button>' +
		'</div>';
		return '<div class="cst-acct">' +
			'<div class="cst-acct-head">' +
				'<span class="cst-acct-avatar">' + tmpAvatar + '</span>' +
				'<span class="cst-acct-id"><span class="cst-acct-name">' + _escapeHTML(pUser.DisplayName || pUser.Email || 'You') + '</span>' +
					(tmpTitle ? '<span class="cst-acct-title">' + tmpTitle + '</span>' : '') +
				'</span>' +
			'</div>' +
			'<div class="cst-acct-rows">' + tmpRows + '</div>' +
			tmpInvites +
			tmpSwitcher +
			tmpMode +
			tmpActions +
		'</div>';
	}

	// Set the color mode (light | dark | system) from the account flyout, the same provider call the
	// Appearance screen's ModeToggle makes. The provider's onApply reskins the app; we just repaint the
	// active segment here so the flyout stays in step without a full rebuild.
	setColorMode(pMode)
	{
		try
		{
			let tmpTheme = this.pict.providers.Theme;
			if (tmpTheme && typeof tmpTheme.setMode === 'function') { tmpTheme.setMode(pMode); }
			if (typeof document !== 'undefined')
			{
				let tmpBtns = document.querySelectorAll('.cst-acct-mode-btn');
				for (let i = 0; i < tmpBtns.length; i++)
				{
					tmpBtns[i].classList.toggle('on', tmpBtns[i].getAttribute('data-mode') === pMode);
				}
			}
		}
		catch (pErr) { /* theme provider unavailable */ }
	}

	// Format an ISO timestamp for the card. Empty means this is the first sign-in (the previous-login
	// marker has not been set yet); a bad value falls back to the raw string.
	_formatWhen(pISO)
	{
		if (!pISO) { return 'First sign-in'; }
		let tmpDate = new Date(pISO);
		if (isNaN(tmpDate.getTime())) { return String(pISO); }
		try { return tmpDate.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }); }
		catch (pErr) { return tmpDate.toLocaleString(); }
	}

	onBeforeRender(pRenderable)
	{
		this._refreshSlots();
		return super.onBeforeRender(pRenderable);
	}

	// Paint the avatar into its slot from AppData.Auth.User. Called on render and
	// can be re-called (e.g. after a photo change in User Settings) to refresh it.
	paintAvatar()
	{
		if (typeof document === 'undefined') { return; }
		let tmpEl = document.getElementById('Plansheet-TopBar-Avatar');
		if (!tmpEl) { return; }
		let tmpAuth = this.pict.AppData.Auth || {};
		if (tmpAuth.LoggedIn && tmpAuth.User)
		{
			tmpEl.innerHTML = libAvatarHelper.avatarHTML(tmpAuth.User, { Size: 26 });
		}
		else
		{
			tmpEl.innerHTML = '';
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		// A re-render replaces the chip the popover was anchored to; close it so it cannot orphan.
		this._closeSessionCard();
		this.paintAvatar();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewTopBarUser;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-TopBar-User',
	DefaultRenderable: 'Plansheet-TopBar-User',
	DefaultDestinationAddress: '#Theme-TopBar-User',
	AutoRender:                false,
	CSS: /*css*/`
		.cst-user { display: flex; align-items: center; height: 100%; gap: 8px; padding: 0 12px; }
		.cst-user-avatar { display: inline-flex; align-items: center; }
		.cst-user-name { font-size: 13px; color: var(--theme-color-text-on-brand, var(--theme-color-text-secondary, #1d2230)); padding: 0 4px; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-user-btn {
			padding: 4px 8px;
			border: 1px solid var(--theme-color-border-default, #5E5549);
			background: transparent;
			color: var(--theme-color-text-on-brand,
				   var(--theme-color-text-secondary, #1d2230));
			border-radius: 4px;
			cursor: pointer;
			display: inline-flex; align-items: center; justify-content: center;
			font-size: 1em; line-height: 1;
		}
		.cst-user-btn:hover {
			background: var(--theme-color-background-hover, rgba(255,255,255,0.08));
		}
		.cst-user-btn-text { padding: 4px 10px; font-size: 13px; }
		/* The signed-in chip is a button that opens the account/session card popover on click. */
		.cst-user-chip { display: inline-flex; align-items: center; gap: 8px; height: 100%; padding: 0 8px; border: none; background: transparent; color: inherit; border-radius: 6px; cursor: pointer; font: inherit; }
		.cst-user-chip:hover, .cst-user-chip:focus-visible { background: var(--theme-color-background-hover, rgba(255,255,255,0.10)); }
		/* Account/session card, shown in the click-toggled popover panel (.cst-acct-popover). */
		.cst-acct { display: flex; flex-direction: column; gap: 14px; padding: 16px; min-width: 250px; }
		.cst-acct-head { display: flex; align-items: center; gap: 12px; }
		.cst-acct-avatar { display: inline-flex; }
		.cst-acct-id { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
		.cst-acct-name { font-size: 16px; font-weight: 600; color: var(--theme-color-text-primary, #1d2230); }
		.cst-acct-title { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-acct-rows { display: flex; flex-direction: column; }
		.cst-acct-row { display: flex; justify-content: space-between; gap: 16px; font-size: 13px; padding: 8px 0; border-top: 1px solid var(--theme-color-border-subtle, #eef1f6); }
		.cst-acct-row:first-child { border-top: none; }
		.cst-acct-k { color: var(--theme-color-text-secondary, #5b6376); }
		.cst-acct-v { color: var(--theme-color-text-primary, #1d2230); font-weight: 500; text-align: right; overflow: hidden; text-overflow: ellipsis; }
		.cst-acct-actions { display: flex; gap: 8px; padding-top: 4px; }
		.cst-acct-act { flex: 1 1 auto; padding: 7px 10px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); cursor: pointer; font-size: 12px; line-height: 1; }
		.cst-acct-act:hover { background: var(--theme-color-background-hover, #f2f4f8); }
		.cst-acct-act-danger { color: var(--theme-color-status-danger, #b3261e); border-color: var(--theme-color-status-danger, #f0c2bd); }
		.cst-acct-act-danger:hover { background: rgba(179,38,30,0.06); }
		/* Appearance: a three-segment Light / Dark / System control, mirroring Settings > Appearance. */
		.cst-acct-mode { padding-top: 6px; }
		.cst-acct-mode-h { font-family: var(--plansheet-gorton); font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color: var(--theme-color-text-secondary, #5b6376); margin: 0 2px 6px; }
		.cst-acct-mode-seg { display: flex; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; overflow: hidden; }
		.cst-acct-mode-btn { flex: 1 1 0; padding: 6px 8px; border: 0; border-right: 1px solid var(--theme-color-border-default, #d8dde6); background: transparent; color: var(--theme-color-text-secondary, #5b6376); font-family: var(--plansheet-gorton); text-transform: uppercase; letter-spacing: 0.7px; font-size: 10.5px; cursor: pointer; line-height: 1.4; }
		.cst-acct-mode-btn:last-child { border-right: 0; }
		.cst-acct-mode-btn:hover { background: var(--theme-color-background-hover, #f2f4f8); color: var(--theme-color-text-primary, #1d2230); }
		.cst-acct-mode-btn.on { background: var(--theme-color-brand-primary, #4f95e8); color: #fff; }
		/* The click-toggled popover panel: a fixed, non-blocking card anchored under the chip. */
		.cst-acct-popover { position: fixed; z-index: 1100; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 12px; box-shadow: 0 10px 30px rgba(13,18,28,0.18); max-width: 340px; }
		/* Plan-sheet switcher inside the account card. */
		.cst-acct-tenants { display: flex; flex-direction: column; gap: 6px; padding-top: 12px; border-top: 1px solid var(--theme-color-border-subtle, #eef1f6); }
		.cst-acct-tenants-h { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-acct-tenant-list { display: flex; flex-direction: column; gap: 2px; max-height: 220px; overflow-y: auto; }
		.cst-acct-tenant { display: flex; align-items: center; gap: 8px; padding: 7px 8px; border-radius: 8px; cursor: pointer; }
		.cst-acct-tenant:hover { background: var(--theme-color-background-hover, #f2f4f8); }
		.cst-acct-tenant.is-current { background: var(--theme-color-background-selected, rgba(55,138,221,0.10)); cursor: default; }
		.cst-acct-tenant-main { display: flex; flex-direction: column; gap: 1px; min-width: 0; flex: 1 1 auto; }
		.cst-acct-tenant-name { font-size: 13px; font-weight: 600; color: var(--theme-color-text-primary, #1d2230); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-acct-tenant-sub { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-acct-tenant-go { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); opacity: 0; }
		.cst-acct-tenant:hover .cst-acct-tenant-go { opacity: 1; }
		.cst-acct-tenant-leave { font-size: 11px; padding: 3px 8px; border: 1px solid var(--theme-color-status-danger, #f0c2bd); border-radius: 6px; background: transparent; color: var(--theme-color-status-danger, #b3261e); cursor: pointer; }
		.cst-acct-tenant-leave:hover { background: rgba(179,38,30,0.06); }
		/* Per-row pin toggle in the switcher (WI #339): faint until hovered, amber when pinned. */
		.cst-acct-tenant-pin { flex: 0 0 auto; display: inline-grid; place-items: center; width: 24px; height: 24px; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-secondary, #a2acbd); cursor: pointer; opacity: 0; padding: 0; }
		.cst-acct-tenant:hover .cst-acct-tenant-pin { opacity: 1; }
		.cst-acct-tenant-pin.on { opacity: 1; color: var(--theme-color-status-warning, #b9812f); }
		.cst-acct-tenant-pin:hover { background: var(--theme-color-background-hover, #f2f4f8); color: var(--theme-color-brand, #378add); }
		.cst-acct-tenant-empty { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); padding: 6px 8px; }
		.cst-acct-new { margin-top: 2px; padding: 7px 10px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: transparent; color: var(--theme-color-text-primary, #1d2230); cursor: pointer; font-size: 12px; text-align: center; }
		.cst-acct-new:hover { background: var(--theme-color-background-hover, #f2f4f8); border-style: solid; }
		/* "View all N plan sheets" link when compact list is truncated. */
		.cst-acct-tenant-viewall { display: block; width: 100%; margin-top: 8px; padding: 8px 10px; border: 1px solid var(--theme-color-brand, #378add); border-radius: 8px; background: var(--theme-color-brand, #378add); color: var(--theme-color-text-on-brand, #ffffff); cursor: pointer; font-size: 12px; font-weight: 600; text-align: center; }
		.cst-acct-tenant-viewall:hover { filter: brightness(1.06); }
		/* Create-plan-sheet modal form. */
		.cst-tenant-form { display: flex; flex-direction: column; gap: 8px; min-width: 320px; }
		.cst-tenant-form label { font-size: 12px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-tenant-form input { padding: 9px 11px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; font-size: 14px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); }
		.cst-tenant-form input:focus { outline: none; border-color: var(--theme-color-brand, #378add); }
		.cst-tenant-form-hint { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin: 0; }
		.cst-tenant-form select { padding: 9px 11px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; font-size: 14px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); }
		/* Pending invitations section in the account card. */
		.cst-acct-invites { display: flex; flex-direction: column; gap: 6px; padding-top: 12px; border-top: 1px solid var(--theme-color-border-subtle, #eef1f6); }
		.cst-acct-invite { display: flex; align-items: center; gap: 8px; padding: 7px 8px; border-radius: 8px; background: var(--theme-color-background-info-subtle, rgba(55,138,221,0.06)); }
		.cst-acct-invite-actions { display: inline-flex; gap: 6px; flex: 0 0 auto; }
		.cst-acct-invite-accept { font-size: 11px; padding: 4px 10px; border: none; border-radius: 6px; background: var(--theme-color-brand, #378add); color: var(--theme-color-text-on-brand, #fff); cursor: pointer; }
		.cst-acct-invite-accept:hover { filter: brightness(1.05); }
		.cst-acct-invite-decline { font-size: 11px; padding: 4px 8px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; background: transparent; color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; }
		.cst-acct-invite-decline:hover { background: var(--theme-color-background-hover, #f2f4f8); }
		.cst-acct-tenant-invite { font-size: 11px; padding: 3px 8px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1d2230); cursor: pointer; }
		.cst-acct-tenant-invite:hover { background: var(--theme-color-background-hover, #f2f4f8); }
		/* Mobile menu: the top-bar burger override (app.openMobileMenu) renders the full nav + account
		   actions into a pict-section-modal. Reuses the .cst-acct-tenant* + .cst-acct-new styles above.
		   It must scroll: the nav groups plus the plan-sheet switcher at the bottom run taller than a
		   phone viewport, and without an overflow the switcher ("Your plan sheets") is stranded below the
		   fold with no way to reach it. Bound the height and scroll within the modal. */
		.cst-mnav { display: flex; flex-direction: column; max-height: 72vh; overflow-y: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; }
		.cst-mnav-group { display: flex; flex-direction: column; gap: 2px; padding: 8px 0; border-top: 1px solid var(--theme-color-border-subtle, #eef1f6); }
		.cst-mnav-group:first-child { border-top: none; padding-top: 0; }
		.cst-mnav-group-h { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); padding: 2px 6px 4px; }
		.cst-mnav-item { display: flex; align-items: center; width: 100%; text-align: left; padding: 11px 10px; border: none; background: transparent; color: var(--theme-color-text-primary, #1d2230); border-radius: 8px; cursor: pointer; font: inherit; font-size: 14px; line-height: 1.1; }
		.cst-mnav-item:hover, .cst-mnav-item:active { background: var(--theme-color-background-hover, #f2f4f8); }
		.cst-mnav-danger { color: var(--theme-color-status-danger, #b3261e); }
	`,
	Templates: [
		{
			Hash: 'Plansheet-TopBar-User',
			Template: /*html*/`
<div class="cst-user">
	{~TS:TopBar-User-LoggedIn:AppData.TopBarUser.LoggedInSlot~}
	{~TS:TopBar-User-Guest:AppData.TopBarUser.GuestSlot~}
</div>`
		},
		{
			Hash: 'TopBar-User-LoggedIn',
			// Clicking the chip toggles the account/session card popover (toggleSessionCard); profile,
			// settings, and sign out live in there.
			Template: /*html*/`
<button class="cst-user-chip" id="Plansheet-TopBar-Chip" onclick="_Pict.views['Plansheet-TopBar-User'].toggleSessionCard()" title="Your account" aria-haspopup="true">
	<span class="cst-user-avatar" id="Plansheet-TopBar-Avatar"></span>
	<span class="cst-user-name" title="{~D:Record.DisplayName~}">{~D:Record.DisplayName~}</span>
</button>`
		},
		{
			Hash: 'TopBar-User-Guest',
			Template: /*html*/`<button class="cst-user-btn cst-user-btn-text" onclick="_Pict.views['Plansheet-TopBar-User'].signIn()" title="Sign in">Sign in</button>`
		}
	],
	Renderables: [{
		RenderableHash: 'Plansheet-TopBar-User',
		TemplateHash: 'Plansheet-TopBar-User',
		ContentDestinationAddress: '#Theme-TopBar-User'
	}]
};

},{"../providers/FrameworkClient.js":576,"./AvatarHelper.js":648,"pict-view":365}],704:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libAvatarHelper = require('./AvatarHelper.js');
const libLoopMarkdown = require('../LoopMarkdown.js');
const libMarkdownRender = require('./MarkdownRender.js');

// The module's bundled built-in sticker shapes, shown read-only in the Stickers manager.
let _BUILTIN_STICKERS = [];
try { _BUILTIN_STICKERS = require('pict-section-moodboard/source/sources/StickerSource-Base.js').BUILTIN_STICKERS || []; }
catch (pError) { _BUILTIN_STICKERS = []; }

// Build-time version stamp (generated by build/stamp-version.js; gitignored). Shown in Appearance.
let _Version = { Version: '0.0.0', Commit: 'dev', BuildDate: '' };
try { _Version = require('../Plansheet-Version.js'); } catch (pError) { /* not stamped */ }
const _VersionLabel = (function ()
{
	let tmpLabel = 'Plansheet v' + (_Version.Version || '0.0.0');
	let tmpExtra = [];
	if (_Version.Commit && _Version.Commit !== 'dev' && _Version.Commit !== 'unknown') { tmpExtra.push(_Version.Commit); }
	if (_Version.BuildDate) { tmpExtra.push(_Version.BuildDate); }
	if (tmpExtra.length) { tmpLabel += ' (' + tmpExtra.join(', ') + ')'; }
	return tmpLabel;
})();

function _escapeHTML(pStr)
{
	return String(pStr == null ? '' : pStr)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

const _MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function _formatDate(pTimestamp)
{
	if (!pTimestamp) { return ''; }
	let tmpDate = new Date(pTimestamp);
	if (isNaN(tmpDate.getTime())) { return ''; }
	return _MONTHS[tmpDate.getMonth()] + ' ' + tmpDate.getDate() + ', ' + tmpDate.getFullYear();
}

// The shortest the top-bar crop band gets, in board units. A card lands on the canvas 120 tall, so a band
// under about this leaves the author's first sticker hanging out of the frame (WI #360).
const _TOPBAR_MIN_BAND = 200;

const _KNOWN_SECTIONS = { profile: 1, about: 1, appearance: 1, account: 1, notifications: 1, tokens: 1, connections: 1, plansheets: 1, team: 1, roles: 1, org: 1, topbar: 1, docsync: 1, draftingkit: 1, messages: 1, stickers: 1, lanes: 1 };

class PictViewUserSettings extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._activeSection = 'profile';
		this._tokensRequested = false;
		this._lastRevealedToken = '';
		this._agentTokenIDUser = 0;
		this._teamLoaded = false;
		this._rolesLoaded = false;
		this._orgLoaded = false;
		this._docsyncLoaded = false;
		this.pict.AppData.TokenSettings = this.pict.AppData.TokenSettings || { Rows: [], EmptySlot: [] };
	}

	_can(pKey)
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		return !!(tmpUser.IsPlatformAdmin || (Array.isArray(tmpUser.Entitlements) && tmpUser.Entitlements.indexOf(pKey) >= 0));
	}

	_profile()
	{
		return (this.pict.AppData.Account && this.pict.AppData.Account.Profile) || {};
	}

	// ── section content builders ─────────────────────────────────────────────
	// The photo block is rebuilt on its own (id="us-photo-block") after a change,
	// so uploading a photo does not discard unsaved edits in the fields below it.
	_photoBlockHTML()
	{
		let tmpP = this._profile();
		let tmpHasPhoto = !!tmpP.PhotoHash;
		return `
		<span class="cst-set-photo-preview">${libAvatarHelper.avatarHTML(tmpP, { Size: 88 })}</span>
		<div class="cst-set-photo-actions">
			<div class="cst-set-photo-btns">
				<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].pickPhoto()">${tmpHasPhoto ? 'Change photo' : 'Upload photo'}</button>
				${tmpHasPhoto ? `<button class="cst-set-photo-remove" onclick="_Pict.views['Plansheet-UserSettings'].removePhoto()">Remove</button>` : ''}
			</div>
			<span class="cst-set-photo-hint">JPEG or PNG, up to 8 MB. We crop a square avatar from it.</span>
			<span id="us-photo-msg" class="cst-set-msg"></span>
		</div>
		<input id="us-photo-input" type="file" accept="image/*" style="display:none" onchange="_Pict.views['Plansheet-UserSettings'].onPhotoPicked(this)" />`;
	}

	_section_profile()
	{
		let tmpP = this._profile();
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Profile</h2>
	<p class="cst-set-sub">How you appear to your team.</p>
	<div class="cst-set-photo" id="us-photo-block">${this._photoBlockHTML()}</div>
	<label class="cst-set-field"><span>Display name</span>
		<input id="us-DisplayName" class="cst-set-input" type="text" maxlength="128" value="${_escapeHTML(tmpP.DisplayName || '')}" /></label>
	<label class="cst-set-field"><span>Title</span>
		<input id="us-Title" class="cst-set-input" type="text" maxlength="128" placeholder="e.g. Engineer" value="${_escapeHTML(tmpP.Title || '')}" /></label>
	<label class="cst-set-field"><span>Color</span>
		<span class="cst-set-color-row"><input id="us-Color" class="cst-set-color" type="color" value="${_escapeHTML(tmpP.Color || '#3b6fd4')}" /><span class="cst-set-color-hint">Used for your avatar and identity across the app.</span></span></label>
	<div class="cst-set-actions">
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveProfile()">Save profile</button>
		<span id="us-profile-msg" class="cst-set-msg"></span>
	</div>
</div>`;
	}

	_section_about()
	{
		return `
<div class="cst-set-section cst-set-section-wide">
	<h2 class="cst-set-h">About Me</h2>
	<p class="cst-set-sub">A rich profile your team can read. Markdown with images, diagrams, and math; the pane on the right previews it.</p>
	<div class="cst-set-about-host" id="AboutMe-EditorHost"></div>
	<div class="cst-set-actions">
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveAbout()">Save About Me</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].viewProfile()">View my profile</button>
		<span id="us-about-msg" class="cst-set-msg"></span>
	</div>
</div>`;
	}

	// ── Appearance (theme / color mode / text size) ──────────────────────────
	// The controls are pict-section-theme views, mounted after the HTML lands (see _mountAppearance).
	// pict-section-theme persists the choices to localStorage, so they save locally for now (a per-user
	// server-side preference is a later step).
	_section_appearance()
	{
		let tmpNavHidden = false;
		try { tmpNavHidden = (typeof localStorage !== 'undefined') && localStorage.getItem('plansheet.nav.hidden') === '1'; } catch (pErr) { tmpNavHidden = false; }
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Appearance</h2>
	<p class="cst-set-sub">Theme, color mode, and text size. These are saved on this device.</p>
	<div class="cst-set-appearance" id="Settings-Appearance-Theme"></div>
	${this._sidebarTabsPanel()}
	<label class="cst-set-navtoggle">
		<input type="checkbox" ${tmpNavHidden ? 'checked' : ''} onchange="_Pict.PictApplication.setNavHidden(this.checked)">
		<span class="cst-set-navtoggle-txt"><strong>Hide the left navigation</strong><span class="cst-set-sub">Lean on the launcher (the 9-square button or Cmd+K) and the keyboard. Saved on this device.</span></span>
	</label>
	<div class="cst-set-appearance-footer">${_escapeHTML(_VersionLabel)}</div>
</div>`;
	}

	// ── Sidebar tabs (which Notebook tabs show, and which opens first) ────────
	// The catalog and the stored prefs are owned by the Notebook view; we only render the controls here
	// and hand changes back to it. "Show" is a checkbox per tab; "Default" is a radio across the row set.
	// A tab's Default radio is disabled while it is hidden. onSidebarTabsChanged reads the DOM and writes.
	_sidebarTabsPanel()
	{
		let tmpNotebook = this.pict.views['Plansheet-Notebook'];
		if (!tmpNotebook || typeof tmpNotebook.tabCatalog !== 'function') { return ''; }
		let tmpCatalog = tmpNotebook.tabCatalog();
		let tmpPrefs = tmpNotebook.getTabPrefs();
		let tmpEnabled = tmpPrefs.Enabled || {};
		// Mirror the Notebook's own default resolution so the radio matches what actually opens.
		let tmpDefault = tmpPrefs.Default;
		if (!tmpDefault || tmpEnabled[tmpDefault] === false) { tmpDefault = 'navigation'; }
		if (tmpEnabled[tmpDefault] === false) { let tmpFirst = tmpCatalog.filter((pT) => tmpEnabled[pT.Key] !== false)[0]; tmpDefault = tmpFirst ? tmpFirst.Key : tmpCatalog[0].Key; }
		let tmpRows = tmpCatalog.map((pTab) =>
		{
			let tmpOn = tmpEnabled[pTab.Key] !== false;
			return `
		<div class="cst-set-tabrow">
			<label class="cst-set-tabrow-show">
				<input type="checkbox" data-tab="${_escapeHTML(pTab.Key)}" ${tmpOn ? 'checked' : ''} onchange="_Pict.views['Plansheet-UserSettings'].onSidebarTabsChanged()">
				<span class="cst-set-tabrow-ico">${pTab.Icon}</span>
				<span class="cst-set-tabrow-lbl">${_escapeHTML(pTab.Label)}</span>
			</label>
			<label class="cst-set-tabrow-def" title="Open this tab first">
				<input type="radio" name="ps-default-tab" data-tab="${_escapeHTML(pTab.Key)}" ${pTab.Key === tmpDefault ? 'checked' : ''} ${tmpOn ? '' : 'disabled'} onchange="_Pict.views['Plansheet-UserSettings'].onSidebarTabsChanged()">
				<span>Default</span>
			</label>
		</div>`;
		}).join('');
		return `
	<div class="cst-set-tabs" id="Settings-Sidebar-Tabs">
		<h3 class="cst-set-h3">Sidebar tabs</h3>
		<p class="cst-set-sub">Pick which tabs the left sidebar shows, and which one opens first. Saved on this device.</p>
		<div class="cst-set-tabs-list">${tmpRows}</div>
	</div>`;
	}

	// Read every row's checkbox and the selected default radio, enforce "at least one shown", and hand
	// the new prefs to the Notebook (which persists and repaints the rail). Then reconcile the radios'
	// enabled/disabled state in place so a just-hidden tab can no longer be the default.
	onSidebarTabsChanged()
	{
		if (typeof document === 'undefined') { return; }
		let tmpNotebook = this.pict.views['Plansheet-Notebook'];
		if (!tmpNotebook || typeof tmpNotebook.setTabPrefs !== 'function') { return; }
		let tmpRoot = document.getElementById('Settings-Sidebar-Tabs');
		if (!tmpRoot) { return; }
		let tmpChecks = Array.prototype.slice.call(tmpRoot.querySelectorAll('.cst-set-tabrow-show input[type=checkbox]'));
		let tmpEnabled = {};
		let tmpAnyOn = false;
		tmpChecks.forEach((pBox) => { tmpEnabled[pBox.getAttribute('data-tab')] = !!pBox.checked; if (pBox.checked) { tmpAnyOn = true; } });
		// Never let the user hide every tab -- snap the box that caused it back on.
		if (!tmpAnyOn)
		{
			let tmpFirst = tmpChecks[0];
			if (tmpFirst) { tmpFirst.checked = true; tmpEnabled[tmpFirst.getAttribute('data-tab')] = true; }
		}
		// Reflect enablement onto the Default radios; move the default off a now-hidden tab.
		let tmpRadios = Array.prototype.slice.call(tmpRoot.querySelectorAll('.cst-set-tabrow-def input[type=radio]'));
		let tmpDefault = '';
		tmpRadios.forEach((pRadio) =>
		{
			let tmpKey = pRadio.getAttribute('data-tab');
			let tmpOn = tmpEnabled[tmpKey] !== false;
			pRadio.disabled = !tmpOn;
			if (!tmpOn && pRadio.checked) { pRadio.checked = false; }
			if (pRadio.checked) { tmpDefault = tmpKey; }
		});
		if (!tmpDefault)
		{
			let tmpFirstOn = tmpRadios.filter((pRadio) => !pRadio.disabled)[0];
			if (tmpFirstOn) { tmpFirstOn.checked = true; tmpDefault = tmpFirstOn.getAttribute('data-tab'); }
		}
		tmpNotebook.setTabPrefs({ Enabled: tmpEnabled, Default: tmpDefault });
	}

	// Mount the theme controls into the Appearance section after its HTML is in place. Re-mounts each
	// time the section is shown (the template wipes the host).
	_mountAppearance()
	{
		let tmpTheme = this.pict.providers && this.pict.providers['Theme-Section'];
		if (tmpTheme && typeof tmpTheme.mount === 'function')
		{
			tmpTheme.mount({ Container: '#Settings-Appearance-Theme', Views: ['Picker', 'ModeToggle', 'ScaleSelect'] });
		}
		else if (typeof document !== 'undefined')
		{
			let tmpHost = document.getElementById('Settings-Appearance-Theme');
			if (tmpHost) { tmpHost.innerHTML = '<div class="cst-set-placeholder">Theme controls are not available in this build.</div>'; }
		}
	}

	// Mount (or remount) the rich About Me editor into its host after the section
	// HTML is in place, seeded from the saved AboutMe. Mirrors PictView-DocEditor.
	_mountAboutEditor()
	{
		let tmpEditor = this.pict.views['Plansheet-AboutMeEditor'];
		let tmpHost = (typeof document !== 'undefined') ? document.getElementById('AboutMe-EditorHost') : null;
		if (!tmpEditor)
		{
			if (tmpHost) { tmpHost.innerHTML = '<div class="cst-set-placeholder">The rich editor is not available in this build.</div>'; }
			return;
		}
		let tmpProfile = this._profile();
		this.pict.AppData.AboutMeEditor = this.pict.AppData.AboutMeEditor || { Segments: [] };
		this.pict.AppData.AboutMeEditor.Segments = [{ Content: (tmpProfile.AboutMe || '') }];
		try { if (tmpEditor.initialRenderComplete) { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; } } catch (pErr) { /* ignore */ }
		tmpEditor.render();
		tmpEditor.marshalToView();
		if (typeof tmpEditor.setPreviewMode === 'function') { tmpEditor.setPreviewMode('side'); }
	}

	onAboutMeChanged()
	{
		// Clear the "Saved" note once the user edits again.
		this._msg('us-about-msg', '', '');
	}

	saveAbout()
	{
		let tmpEditor = this.pict.views['Plansheet-AboutMeEditor'];
		let tmpContent = (tmpEditor && typeof tmpEditor.getAllContent === 'function') ? tmpEditor.getAllContent('\n\n') : '';
		this._msg('us-about-msg', 'Saving...', '');
		this.pict.providers.UserAPI.updateMe({ AboutMe: tmpContent }).then(() =>
		{
			this._msg('us-about-msg', 'Saved.', 'ok');
			if (this.pict.AppData.Auth && this.pict.AppData.Auth.User) { this.pict.AppData.Auth.User.AboutMe = tmpContent; }
		}).catch((pErr) => this._msg('us-about-msg', pErr.message || 'Could not save.', 'err'));
	}

	viewProfile()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showProfile === 'function') { tmpApp.showProfile(); }
	}

	_section_account()
	{
		let tmpP = this._profile();
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Sign-in</h2>
	<p class="cst-set-sub">Your email and password.</p>
	<label class="cst-set-field"><span>Email</span>
		<input id="us-Email" class="cst-set-input" type="email" value="${_escapeHTML(tmpP.Email || '')}" /></label>
	<div class="cst-set-actions">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].saveEmail()">Update email</button>
		<span id="us-email-msg" class="cst-set-msg"></span>
	</div>
	<hr class="cst-set-rule" />
	<label class="cst-set-field"><span>Current password</span>
		<input id="us-PwCurrent" class="cst-set-input" type="password" autocomplete="current-password" /></label>
	<label class="cst-set-field"><span>New password</span>
		<input id="us-PwNew" class="cst-set-input" type="password" autocomplete="new-password" placeholder="at least 8 characters" /></label>
	<div class="cst-set-actions">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].savePassword()">Change password</button>
		<span id="us-pw-msg" class="cst-set-msg"></span>
	</div>
</div>
${this._twoFactorSection()}`;
	}

	// ── Two-step verification (2FA) ───────────────────────────────────────────
	_twoFactorSection()
	{
		let tmpState = this._twoFactor;
		let tmpFlow = this._twoFactorFlow || {};
		let tmpInner;
		if (!tmpState)
		{
			tmpInner = `<div class="cst-set-placeholder">Loading...</div>`;
		}
		else if (!tmpState.Available)
		{
			let tmpWhy = (tmpState.Reason === 'oauth')
				? 'You sign in through a connected provider, which carries its own protection. Two-step verification covers password sign-in.'
				: 'Two-step verification is available on account-based logins.';
			tmpInner = `<p class="cst-set-sub">${_escapeHTML(tmpWhy)}</p>`;
		}
		else if (tmpState.Enabled)
		{
			let tmpVia = (tmpState.Channel === 'sms') ? 'a text message' : 'email';
			tmpInner = `
	<p class="cst-set-sub"><span class="cst-set-pill-ok">On</span> &nbsp;We send a code by ${tmpVia} each time you sign in with a password.</p>
	${this._recoveryCodesHTML(tmpState)}
	<hr class="cst-set-rule" />
	<label class="cst-set-field"><span>Confirm your password to turn it off</span>
		<input id="us-2fa-offpw" class="cst-set-input" type="password" autocomplete="current-password" /></label>
	<div class="cst-set-actions">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].disableTwoFactor()">Turn off two-step verification</button>
		<span id="us-2fa-msg" class="cst-set-msg"></span>
	</div>`;
		}
		else
		{
			tmpInner = this._twoFactorEnrollHTML(tmpState, tmpFlow);
		}
		let tmpOrgNote = (tmpState && tmpState.OrgRequires)
			? `<p class="cst-set-note-warn">Your organization asks members to turn on two-step verification for password sign-in.</p>` : '';
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Two-step verification</h2>
	<p class="cst-set-sub">Add a one-time code to password sign-in. Accounts that use a connected login (Google, GitHub) are already covered and skip this.</p>
	${tmpOrgNote}
	${tmpInner}
</div>`;
	}

	_twoFactorEnrollHTML(pState, pFlow)
	{
		let tmpPhoneArea;
		if (pState.PhoneVerified)
		{
			tmpPhoneArea = `<p class="cst-set-sub">Phone verified: <strong>${_escapeHTML(pState.PhoneMasked || '')}</strong>. You can receive codes by text.</p>`;
		}
		else if (pFlow.PhoneToken)
		{
			tmpPhoneArea = `
	<p class="cst-set-sub">Enter the code we texted to ${_escapeHTML(pFlow.PhoneMasked || 'your phone')}.</p>
	<label class="cst-set-field"><span>Text code</span>
		<input id="us-2fa-phone-code" class="cst-set-input" type="text" inputmode="numeric" maxlength="6" /></label>
	<div class="cst-set-actions">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].verifyPhoneCode()">Verify phone</button>
		<span id="us-2fa-phone-msg" class="cst-set-msg"></span>
	</div>`;
		}
		else
		{
			tmpPhoneArea = `
	<label class="cst-set-field"><span>Phone for text codes (optional)</span>
		<input id="us-2fa-phone" class="cst-set-input" type="tel" autocomplete="tel" placeholder="+1 555 555 1234" /></label>
	<div class="cst-set-actions">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].sendPhoneCode()">Send code</button>
		<span id="us-2fa-phone-msg" class="cst-set-msg"></span>
	</div>`;
		}

		let tmpTurnOn;
		if (pFlow.EnableToken)
		{
			let tmpVia = (pFlow.EnableChannel === 'sms') ? 'text message' : 'email';
			tmpTurnOn = `
	<p class="cst-set-sub">Enter the code we sent by ${tmpVia} to ${_escapeHTML(pFlow.EnableMasked || 'you')}.</p>
	<label class="cst-set-field"><span>Verification code</span>
		<input id="us-2fa-enable-code" class="cst-set-input" type="text" inputmode="numeric" maxlength="6" /></label>
	<div class="cst-set-actions">
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].confirmTwoFactor()">Confirm and turn on</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].cancelTwoFactorEnroll()">Cancel</button>
		<span id="us-2fa-msg" class="cst-set-msg"></span>
	</div>`;
		}
		else
		{
			let tmpSmsBtn = pState.PhoneVerified
				? `<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].enableTwoFactor('sms')">Use text messages</button>`
				: '';
			tmpTurnOn = `
	<p class="cst-set-sub">We will send a code to confirm, then ask for one each time you sign in with a password.</p>
	<div class="cst-set-actions">
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].enableTwoFactor('email')">Use email${pState.EmailMasked ? ' (' + _escapeHTML(pState.EmailMasked) + ')' : ''}</button>
		${tmpSmsBtn}
		<span id="us-2fa-msg" class="cst-set-msg"></span>
	</div>`;
		}

		return `${tmpPhoneArea}<hr class="cst-set-rule" />${tmpTurnOn}`;
	}

	// Recovery codes (the freshly generated set is held in _twoFactorCodes and shown
	// once; otherwise just the remaining-count + a (re)generate button).
	_recoveryCodesHTML(pState)
	{
		if (this._twoFactorCodes && this._twoFactorCodes.length)
		{
			let tmpList = this._twoFactorCodes.map((pCode) => `<li>${_escapeHTML(pCode)}</li>`).join('');
			return `
	<div class="cst-set-note-warn">Save these now. Each code works once, and they will not be shown again.</div>
	<ul class="cst-set-codes">${tmpList}</ul>
	<div class="cst-set-actions">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].copyRecoveryCodes()">Copy codes</button>
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].dismissRecoveryCodes()">Done, I saved them</button>
		<span id="us-2fa-rc-msg" class="cst-set-msg"></span>
	</div>`;
		}
		let tmpN = Number(pState.RecoveryCodesRemaining) || 0;
		let tmpChannelWord = (pState.Channel === 'sms') ? 'phone' : 'email';
		let tmpStatus = (tmpN > 0) ? (tmpN + ' recovery code' + (tmpN === 1 ? '' : 's') + ' remaining') : 'You have not generated recovery codes yet';
		return `
	<p class="cst-set-sub">Recovery codes let you sign in if you lose access to your ${tmpChannelWord}. ${tmpStatus}.</p>
	<div class="cst-set-actions">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].generateRecoveryCodes()">${tmpN > 0 ? 'Regenerate recovery codes' : 'Generate recovery codes'}</button>
		<span id="us-2fa-rc-msg" class="cst-set-msg"></span>
	</div>`;
	}

	generateRecoveryCodes()
	{
		this._msg('us-2fa-rc-msg', 'Generating...', '');
		this.pict.providers.UserAPI.generateRecoveryCodes().then((pBody) =>
		{
			this._twoFactorCodes = (pBody && Array.isArray(pBody.Codes)) ? pBody.Codes : null;
			this._rerenderAccount();
		}).catch((pErr) => this._msg('us-2fa-rc-msg', pErr.message || 'Could not generate.', 'err'));
	}

	copyRecoveryCodes()
	{
		let tmpText = (this._twoFactorCodes || []).join('\n');
		if (typeof navigator !== 'undefined' && navigator.clipboard && tmpText)
		{
			navigator.clipboard.writeText(tmpText).then(() => this._msg('us-2fa-rc-msg', 'Copied.', 'ok')).catch(() => this._msg('us-2fa-rc-msg', 'Could not copy.', 'err'));
		}
	}

	dismissRecoveryCodes()
	{
		this._twoFactorCodes = null;
		this._loadTwoFactor();
	}

	_loadTwoFactor()
	{
		this._twoFactorFlow = {};
		this._twoFactorCodes = null;
		if (!this.pict.providers.UserAPI) { return; }
		this.pict.providers.UserAPI.getTwoFactor().then((pState) =>
		{
			this._twoFactor = pState || { Available: false };
			if (this._activeSection === 'account') { this._setContent(this._section_account()); }
		});
	}

	_rerenderAccount()
	{
		if (this._activeSection === 'account') { this._setContent(this._section_account()); }
	}

	// ── Notifications (per-user email opt-outs) ───────────────────────────────
	_section_notifications()
	{
		if (!this._notifPrefs) { return this._loadingSection('Notifications'); }
		let tmpCanSMS = !!this._notifCanSMS;
		let tmpRows = this._notifPrefs.map((pPref) =>
		{
			let tmpEmail = `<label class="cst-notif-toggle"><input type="checkbox" ${pPref.EmailEnabled ? 'checked' : ''} onchange="_Pict.views['Plansheet-UserSettings'].toggleNotificationPref('${_escapeHTML(pPref.EventKey)}','EmailEnabled',this.checked)"/> Email</label>`;
			let tmpSMS = tmpCanSMS ? `<label class="cst-notif-toggle"><input type="checkbox" ${pPref.SMSEnabled ? 'checked' : ''} onchange="_Pict.views['Plansheet-UserSettings'].toggleNotificationPref('${_escapeHTML(pPref.EventKey)}','SMSEnabled',this.checked)"/> Text</label>` : '';
			return `<div class="cst-notif-row"><div class="cst-notif-label">${_escapeHTML(pPref.Label)}</div><div class="cst-notif-toggles">${tmpEmail}${tmpSMS}</div></div>`;
		}).join('');
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Notifications</h2>
	<p class="cst-set-sub">Choose how each change reaches you. These are your own settings; an organization can also turn a type off for everyone.</p>
	${this._smsOptInHTML(tmpCanSMS)}
	<h3 class="cst-set-sh">What to send me</h3>
	${tmpRows || '<div class="cst-set-placeholder">No notification types yet.</div>'}
	<div class="cst-set-actions"><span id="notif-msg" class="cst-set-msg"></span></div>
</div>`;
	}

	// The text-message (SMS) opt-in block: phone entry + the explicit consent language carriers require for
	// A2P 10DLC. Three states -- verified, code-sent, and the entry form -- with the consent shown wherever the
	// user is about to opt in. Verifying a number flips tmpCanSMS, which reveals the per-event Text toggles below.
	_smsOptInHTML(pVerified)
	{
		let tmpConsent = `<p class="cst-notif-consent">By adding and verifying your mobile number, you agree to receive text messages from Plansheet for the alerts you turn on below &mdash; for example sign-in codes and work item or issue updates. Message frequency varies. Message and data rates may apply. Reply <strong>STOP</strong> to unsubscribe or <strong>HELP</strong> for help.</p>`;
		if (pVerified)
		{
			return `
<div class="cst-notif-sms">
	<h3 class="cst-set-sh">Text messages</h3>
	<p class="cst-set-sub">Text alerts are on for your verified mobile number. Reply <strong>STOP</strong> to unsubscribe or <strong>HELP</strong> for help &mdash; then choose which alerts below you want by text.</p>
	<span id="notif-phone-msg" class="cst-set-msg"></span>
</div>`;
		}
		let tmpFlow = this._notifPhoneFlow || {};
		if (tmpFlow.PhoneToken)
		{
			return `
<div class="cst-notif-sms">
	<h3 class="cst-set-sh">Text messages</h3>
	<p class="cst-set-sub">Enter the 6-digit code we texted to ${_escapeHTML(tmpFlow.PhoneMasked || 'your phone')}.</p>
	<div class="cst-set-field-row">
		<input id="notif-phone-code" class="cst-set-input" type="text" inputmode="numeric" maxlength="6" placeholder="123456" />
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].verifyNotifPhoneCode()">Verify</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].cancelNotifPhone()">Cancel</button>
	</div>
	${tmpConsent}
	<span id="notif-phone-msg" class="cst-set-msg"></span>
</div>`;
		}
		return `
<div class="cst-notif-sms">
	<h3 class="cst-set-sh">Text messages (optional)</h3>
	<p class="cst-set-sub">Add a mobile number to also get the alerts you choose by text message.</p>
	<label class="cst-set-field"><span>Mobile number</span><input id="notif-phone" class="cst-set-input" type="tel" autocomplete="tel" placeholder="+1 555 555 1234" /></label>
	${tmpConsent}
	<label class="cst-notif-consent-check"><input type="checkbox" id="notif-sms-consent" onchange="var b=document.getElementById('notif-sms-send'); if (b) { b.disabled = !this.checked; }"/> <span>I agree to receive these text messages from Plansheet. Message and data rates may apply; reply STOP to opt out.</span></label>
	<div class="cst-set-field-row">
		<button id="notif-sms-send" class="cst-set-btn" disabled onclick="_Pict.views['Plansheet-UserSettings'].sendNotifPhoneCode()">Send verification code</button>
	</div>
	<span id="notif-phone-msg" class="cst-set-msg"></span>
</div>`;
	}

	_loadNotifications()
	{
		if (!this.pict.providers.UserAPI) { return; }
		this.pict.providers.UserAPI.getNotificationPrefs().then((pResult) =>
		{
			this._notifPrefs = (pResult && Array.isArray(pResult.Prefs)) ? pResult.Prefs : [];
			this._notifCanSMS = !!(pResult && pResult.CanSMS);
			if (this._activeSection === 'notifications') { this._setContent(this._section_notifications()); }
		});
	}

	toggleNotificationPref(pEventKey, pChannel, pEnabled)
	{
		this._msg('notif-msg', 'Saving...', '');
		let tmpPatch = {};
		tmpPatch[pChannel] = !!pEnabled;
		this.pict.providers.UserAPI.setNotificationPref(pEventKey, tmpPatch)
			.then((pBody) =>
			{
				(this._notifPrefs || []).forEach((pPref) => { if (pPref.EventKey === pEventKey) { pPref.EmailEnabled = !!pBody.EmailEnabled; pPref.SMSEnabled = !!pBody.SMSEnabled; } });
				this._msg('notif-msg', 'Saved.', 'ok');
			})
			.catch((pErr) => this._msg('notif-msg', pErr.message || 'Could not save.', 'err'));
	}

	// Phone opt-in on the Notifications screen (its own small flow so it does not share the 2FA section's
	// state). setPhone texts a code; verifyPhone confirms and flips CanSMS, revealing the Text toggles.
	sendNotifPhoneCode()
	{
		let tmpAgreed = (typeof document !== 'undefined') ? !!((document.getElementById('notif-sms-consent') || {}).checked) : false;
		if (!tmpAgreed) { this._msg('notif-phone-msg', 'Please check the consent box to continue.', 'err'); return; }
		let tmpPhone = (typeof document !== 'undefined') ? (document.getElementById('notif-phone') || {}).value : '';
		if (!tmpPhone) { this._msg('notif-phone-msg', 'Enter a mobile number.', 'err'); return; }
		this._msg('notif-phone-msg', 'Sending...', '');
		this.pict.providers.UserAPI.setPhone(tmpPhone).then((pBody) =>
		{
			this._notifPhoneFlow = { PhoneToken: pBody.ChallengeToken, PhoneMasked: pBody.PhoneMasked };
			if (this._activeSection === 'notifications') { this._setContent(this._section_notifications()); }
		}).catch((pErr) => this._msg('notif-phone-msg', pErr.message || 'Could not send.', 'err'));
	}

	verifyNotifPhoneCode()
	{
		let tmpCode = (typeof document !== 'undefined') ? (document.getElementById('notif-phone-code') || {}).value : '';
		let tmpToken = (this._notifPhoneFlow || {}).PhoneToken;
		this._msg('notif-phone-msg', 'Checking...', '');
		this.pict.providers.UserAPI.verifyPhone(tmpToken, (tmpCode || '').trim()).then(() =>
		{
			this._notifPhoneFlow = {};
			this._loadNotifications();
		}).catch((pErr) => this._msg('notif-phone-msg', pErr.message || 'Incorrect code.', 'err'));
	}

	cancelNotifPhone()
	{
		this._notifPhoneFlow = {};
		if (this._activeSection === 'notifications') { this._setContent(this._section_notifications()); }
	}

	sendPhoneCode()
	{
		let tmpPhone = (typeof document !== 'undefined') ? (document.getElementById('us-2fa-phone') || {}).value : '';
		if (!tmpPhone) { this._msg('us-2fa-phone-msg', 'Enter a phone number.', 'err'); return; }
		this._msg('us-2fa-phone-msg', 'Sending...', '');
		this.pict.providers.UserAPI.setPhone(tmpPhone).then((pBody) =>
		{
			this._twoFactorFlow = Object.assign({}, this._twoFactorFlow, { PhoneToken: pBody.ChallengeToken, PhoneMasked: pBody.PhoneMasked });
			this._rerenderAccount();
		}).catch((pErr) => this._msg('us-2fa-phone-msg', pErr.message || 'Could not send.', 'err'));
	}

	verifyPhoneCode()
	{
		let tmpCode = (typeof document !== 'undefined') ? (document.getElementById('us-2fa-phone-code') || {}).value : '';
		let tmpToken = (this._twoFactorFlow || {}).PhoneToken;
		this._msg('us-2fa-phone-msg', 'Checking...', '');
		this.pict.providers.UserAPI.verifyPhone(tmpToken, (tmpCode || '').trim()).then(() =>
		{
			this._loadTwoFactor();
		}).catch((pErr) => this._msg('us-2fa-phone-msg', pErr.message || 'Incorrect code.', 'err'));
	}

	enableTwoFactor(pChannel)
	{
		this._msg('us-2fa-msg', 'Sending a code...', '');
		this.pict.providers.UserAPI.enableTwoFactor(pChannel).then((pBody) =>
		{
			this._twoFactorFlow = Object.assign({}, this._twoFactorFlow, { EnableToken: pBody.ChallengeToken, EnableChannel: pBody.Channel || pChannel, EnableMasked: pBody.MaskedDestination });
			this._rerenderAccount();
		}).catch((pErr) => this._msg('us-2fa-msg', pErr.message || 'Could not start.', 'err'));
	}

	confirmTwoFactor()
	{
		let tmpCode = (typeof document !== 'undefined') ? (document.getElementById('us-2fa-enable-code') || {}).value : '';
		let tmpToken = (this._twoFactorFlow || {}).EnableToken;
		this._msg('us-2fa-msg', 'Confirming...', '');
		this.pict.providers.UserAPI.confirmTwoFactor(tmpToken, (tmpCode || '').trim()).then(() =>
		{
			this._loadTwoFactor();
		}).catch((pErr) => this._msg('us-2fa-msg', pErr.message || 'Incorrect code.', 'err'));
	}

	cancelTwoFactorEnroll()
	{
		this._twoFactorFlow = {};
		this._rerenderAccount();
	}

	disableTwoFactor()
	{
		let tmpPw = (typeof document !== 'undefined') ? (document.getElementById('us-2fa-offpw') || {}).value : '';
		if (!tmpPw) { this._msg('us-2fa-msg', 'Enter your password.', 'err'); return; }
		this._msg('us-2fa-msg', 'Turning off...', '');
		this.pict.providers.UserAPI.disableTwoFactor(tmpPw).then(() =>
		{
			this._loadTwoFactor();
		}).catch((pErr) => this._msg('us-2fa-msg', pErr.message || 'Could not turn off.', 'err'));
	}

	_section_tokens()
	{
		this._refreshTokens();
		let tmpIsAdmin = !!(this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.IsPlatformAdmin);
		let tmpRows = this.pict.AppData.TokenSettings.Rows;
		let tmpList = tmpRows.length
			? tmpRows.map((pRow) => `
		<div class="cst-set-token-row">
			<div class="cst-set-token-main"><div class="cst-set-token-label">${pRow.Label}</div><div class="cst-set-token-meta">${pRow.CreatedLabel}${pRow.LastUsedLabel}</div></div>
			<button class="cst-set-token-revoke" onclick="_Pict.views['Plansheet-UserSettings'].revokeToken(${pRow.IDUserToken})">Revoke</button>
		</div>`).join('')
			: `<div class="cst-set-placeholder">No tokens yet. Generate one to use the CLI without a password.</div>`;
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">API Tokens</h2>
	<p class="cst-set-sub">Bearer tokens let the plansheet CLI and automation act as you, without a password. The token is shown once when created.</p>
	<div class="cst-set-token-new">
		<input id="us-TokenLabel" class="cst-set-input" type="text" maxlength="128" placeholder="Label (e.g. laptop CLI)" onkeydown="if(event.key==='Enter'){event.preventDefault();_Pict.views['Plansheet-UserSettings'].generateToken();}" />
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].generateToken()">Generate</button>
	</div>
	${tmpList}
	${tmpIsAdmin ? `
	<div style="margin-top:1.5rem;padding-top:1.25rem;border-top:1px solid var(--theme-color-border-default, rgba(128,128,128,0.25));">
		<h2 class="cst-set-h">Mint a token for another user</h2>
		<p class="cst-set-sub">Platform admins only: give an agent user (like the Claude runner, <code>claude@plansheet.io</code>) a bearer token without logging in as it. The token belongs to that user, and is shown once.</p>
		<div class="cst-set-token-new">
			<div id="us-agent-picker-host" style="flex:1;min-width:240px;"></div>
			<input id="us-AgentTokenLabel" class="cst-set-input" type="text" maxlength="128" placeholder="Label (e.g. agent runner)" />
			<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].mintAgentToken()">Mint token</button>
		</div>
	</div>` : ''}
</div>`;
	}

	// -- Connections (which plan sheets a connected app's token may act in) --------------------
	// The authorized set could only ever GROW: creating a plan sheet over a connector widens the calling
	// token across every one of its rows, and nothing ever took one away. So the consent given when a client
	// was first authorized was a floor rather than a ceiling, and no screen even showed what had accumulated.
	// This is that screen, and the only place a set can be narrowed.
	_section_connections()
	{
		this._refreshConnections();
		if (!this._connections) { return this._loadingSection('Connections'); }

		let tmpAvailable = this._connectionsAvailable || [];
		let tmpList = this._connections.length
			? this._connections.map((pConnection) =>
			{
				let tmpChecked = {};
				(pConnection.Plansheets || []).forEach((pPlansheet) => { tmpChecked[pPlansheet.IDCustomer] = true; });
				let tmpBoxes = tmpAvailable.map((pPlansheet) =>
				{
					// The grant's own plan sheet is where the token was issued and where its scope was
					// narrowed. It cannot be removed: a token whose set excluded its own home would point at
					// a tenant it is not authorized for. Revoke is how a connection is removed.
					let tmpIsHome = (pPlansheet.IDCustomer === pConnection.HomeIDCustomer);
					let tmpOn = tmpIsHome || !!tmpChecked[pPlansheet.IDCustomer];
					return `
			<label class="cst-set-check">
				<input type="checkbox" ${tmpOn ? 'checked' : ''} ${tmpIsHome ? 'disabled' : ''}
					onchange="_Pict.views['Plansheet-UserSettings'].toggleConnectionPlansheet(${pConnection.IDOAuthClient}, ${pPlansheet.IDCustomer}, this.checked)" />
				<span>${pPlansheet.Name}${pPlansheet.Code ? ' <code>' + pPlansheet.Code + '</code>' : ''}${tmpIsHome ? ' <em>(created here)</em>' : ''}</span>
			</label>`;
				}).join('');

				return `
		<div class="cst-set-token-row" style="display:block;">
			<div style="display:flex;align-items:baseline;gap:0.75rem;flex-wrap:wrap;">
				<div class="cst-set-token-label">${pConnection.ClientName}</div>
				<div class="cst-set-token-meta">${pConnection.Scope ? 'scope <code>' + pConnection.Scope + '</code>' : 'no scope'}${pConnection.LastUsedAt ? ' &middot; last used ' + String(pConnection.LastUsedAt).slice(0, 10) : ' &middot; never used'}</div>
				<button class="cst-set-token-revoke" style="margin-left:auto;"
					onclick="_Pict.views['Plansheet-UserSettings'].revokeConnection(${pConnection.IDOAuthClient})">Revoke</button>
			</div>
			<div style="margin-top:0.6rem;display:flex;flex-direction:column;gap:0.3rem;">${tmpBoxes}</div>
		</div>`;
			}).join('')
			: '<div class="cst-set-placeholder">No connected apps yet. When you authorize one (an MCP connector, or a node runner), it appears here and you choose which plan sheets it may act in.</div>';

		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Connect Claude</h2>
	<p class="cst-set-sub">Let Claude read and write this plan sheet through a connection you control. The walkthrough below is the same one the API publishes, so a person and a Claude agent are following the same steps.</p>
	<div id="connect-claude-body" class="cst-connect-guide"><div class="cst-set-placeholder">Loading the connection guide...</div></div>
</div>
<div class="cst-set-section">
	<h2 class="cst-set-h">Connections</h2>
	<p class="cst-set-sub">Apps and nodes you have authorized to act as you. A connection can only ever reach the plan sheets ticked here, and only ones you are a member of yourself. Untick to take access away; it applies immediately, to the refresh token as well as the access token.</p>
	<div id="connections-msg" class="cst-set-msg"></div>
	${tmpList}
</div>`;
	}

	// The connections section rebuilds its whole HTML on every data change (toggle, revoke, first load), which
	// recreates the Connect Claude card's container empty. Repaint the guide after each such render so it never
	// vanishes on a toggle. Idempotent; a no-op until the guide has loaded.
	_renderConnections()
	{
		this._setContent(this._section_connections());
		this._paintConnectClaude();
	}

	// The human half of the connect-Claude story: the connect-claude guide from the self-describing API
	// (GET /1.0/API/Guides/connect-claude), rendered as markdown into the card. One fetch, then cached.
	_loadConnectClaudeGuide()
	{
		if (this._connectClaudeGuide) { this._paintConnectClaude(); return; }
		if (!this.pict.providers.UserAPI) { return; }
		this.pict.providers.UserAPI.getApiGuide('connect-claude').then((pGuide) =>
		{
			this._connectClaudeGuide = pGuide || { Body: '' };
			if (this._activeSection === 'connections') { this._paintConnectClaude(); }
		});
	}

	_paintConnectClaude()
	{
		if (typeof document === 'undefined') { return; }
		let tmpTarget = document.getElementById('connect-claude-body');
		if (!tmpTarget || !this._connectClaudeGuide) { return; }
		libMarkdownRender.renderInto(this.pict.providers.Content, tmpTarget, this._connectClaudeGuide.Body || '',
			'<p class="cst-set-placeholder">The connection guide is not available right now.</p>');
	}

	_refreshConnections()
	{
		if (this._connectionsRequested) { return; }
		this._connectionsRequested = true;
		if (!this.pict.providers.UserAPI) { return; }
		this.pict.providers.UserAPI.getOAuthConnections().then((pResult) =>
		{
			this._connections = pResult.Connections || [];
			this._connectionsAvailable = pResult.AvailablePlansheets || [];
			if (this._activeSection === 'connections') { this._renderConnections(); }
		});
	}

	toggleConnectionPlansheet(pIDOAuthClient, pIDCustomer, pEnabled)
	{
		let tmpConnection = (this._connections || []).filter((pRow) => pRow.IDOAuthClient === pIDOAuthClient)[0];
		if (!tmpConnection) { return; }
		this._msg('connections-msg', 'Saving...', '');

		// Send the WHOLE set rather than a delta, so what the screen shows and what the server stores can
		// never drift apart on a dropped request.
		let tmpSet = (tmpConnection.Plansheets || []).map((pPlansheet) => pPlansheet.IDCustomer);
		if (pEnabled) { if (tmpSet.indexOf(pIDCustomer) < 0) { tmpSet.push(pIDCustomer); } }
		else { tmpSet = tmpSet.filter((pID) => pID !== pIDCustomer); }

		this.pict.providers.UserAPI.setOAuthConnectionPlansheets(pIDOAuthClient, tmpSet)
			.then((pBody) =>
			{
				tmpConnection.Plansheets = pBody.Plansheets || [];
				this._msg('connections-msg', 'Saved.', 'ok');
				if (this._activeSection === 'connections') { this._renderConnections(); }
			})
			.catch((pError) =>
			{
				// Re-read from the server rather than leaving a checkbox showing something that was refused.
				this._msg('connections-msg', (pError && pError.message) || 'Could not save.', 'err');
				this._connectionsRequested = false;
				this._refreshConnections();
			});
	}

	revokeConnection(pIDOAuthClient)
	{
		let tmpConnection = (this._connections || []).filter((pRow) => pRow.IDOAuthClient === pIDOAuthClient)[0];
		let tmpName = tmpConnection ? tmpConnection.ClientName : 'this connection';
		if (!confirm('Revoke "' + tmpName + '"? Its tokens stop working immediately and it will have to be authorized again.')) { return; }
		this._msg('connections-msg', 'Revoking...', '');
		this.pict.providers.UserAPI.revokeOAuthConnection(pIDOAuthClient)
			.then(() =>
			{
				this._connections = (this._connections || []).filter((pRow) => pRow.IDOAuthClient !== pIDOAuthClient);
				this._msg('connections-msg', 'Revoked.', 'ok');
				if (this._activeSection === 'connections') { this._renderConnections(); }
			})
			.catch((pError) => this._msg('connections-msg', (pError && pError.message) || 'Could not revoke.', 'err'));
	}


	// ── Plan sheets (per-device default + membership list) ───────────────────
	// The preferred default plansheet is stored in localStorage so it persists
	// across sessions without a schema change. The server already remembers the
	// last-visited plansheet via the LastLoginDate stamp on every switch; this
	// setting lets users pin a hard default that overrides that order.
	_getPinnedCustomer()
	{
		try { return parseInt(localStorage.getItem('plansheet.pinned_customer') || '0', 10) || 0; }
		catch (pErr) { return 0; }
	}

	_setPinnedCustomer(pIDCustomer)
	{
		try
		{
			if (pIDCustomer) { localStorage.setItem('plansheet.pinned_customer', String(pIDCustomer)); }
			else { localStorage.removeItem('plansheet.pinned_customer'); }
		}
		catch (pErr) { /* storage unavailable */ }
	}

	_section_plansheets()
	{
		if (!this._plansheetsLoaded) { this._loadPlansheets(); return this._loadingSection('Plan sheets'); }
		let tmpTenants = this._plansheetTenants || [];
		let tmpPinned = this._getPinnedCustomer();
		let tmpPinnedName = '';
		if (tmpPinned)
		{
			let tmpPinnedRow = tmpTenants.find((pT) => pT.IDCustomer === tmpPinned);
			tmpPinnedName = tmpPinnedRow ? _escapeHTML(tmpPinnedRow.CustomerName || 'Untitled') : 'a plan sheet you no longer belong to';
		}
		let tmpPinNote = tmpPinned
			? `<span class="cst-set-msg cst-set-msg-ok">Pinned to <strong>${tmpPinnedName}</strong> on this device. You will land there on every login.</span>`
			: `<span class="cst-set-sub">Not set. You will land on the plan sheet you visited most recently.</span>`;
		let tmpOpts = tmpTenants.map((pT) =>
			`<option value="${pT.IDCustomer}"${pT.IDCustomer === tmpPinned ? ' selected' : ''}>${_escapeHTML(pT.CustomerName || 'Untitled')} (${_escapeHTML(pT.RoleLabel || 'Member')})</option>`
		).join('');
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Plan sheets</h2>
	<p class="cst-set-sub">You belong to ${tmpTenants.length} plan sheet${tmpTenants.length !== 1 ? 's' : ''}. Plansheet remembers the one you visited most recently and returns you there on your next login. You can pin a specific plan sheet below if you prefer a hard default.</p>
	<div class="cst-set-field" style="margin-top:1rem;">
		<span>Default plan sheet <em style="font-weight:400;color:var(--theme-color-text-secondary,#5b6376)">(this device)</em></span>
		<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
			<select id="us-PinnedCustomer" class="cst-set-input" style="flex:1;min-width:200px;">
				<option value="0">Last visited (automatic)</option>
				${tmpOpts}
			</select>
			<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].savePinnedCustomer()">Save</button>
			${tmpPinned ? `<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].clearPinnedCustomer()">Clear</button>` : ''}
		</div>
		<div style="margin-top:6px;">${tmpPinNote}</div>
		<span id="us-plansheets-msg" class="cst-set-msg"></span>
	</div>
	<div class="cst-set-divider"></div>
	<h3 class="cst-set-sh">Memberships</h3>
	<div class="cst-ps-settings-list">
		${tmpTenants.length ? tmpTenants.map((pT) => `
		<div class="cst-ps-settings-row${pT.IsCurrent ? ' is-current' : ''}">
			<div class="cst-ps-settings-main">
				<span class="cst-ps-settings-name">${_escapeHTML(pT.CustomerName || 'Untitled')}</span>
				<span class="cst-ps-settings-role">${_escapeHTML(pT.DisplayName || '')} &middot; ${_escapeHTML(pT.RoleLabel || 'Member')}${pT.IsCurrent ? ' &middot; <strong>active</strong>' : ''}</span>
			</div>
			${!pT.IsCurrent ? `<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].switchToSheet(${pT.IDCustomer})">Switch</button>` : ''}
		</div>`).join('') : '<div class="cst-set-placeholder">No plan sheets found.</div>'}
	</div>
</div>`;
	}

	_loadPlansheets()
	{
		this._plansheetsLoaded = false;
		let tmpClient = require('../providers/FrameworkClient.js');
		tmpClient.getJSON(this.pict, '/1.0/Account/Tenants').then((pBody) =>
		{
			this._plansheetTenants = (pBody && Array.isArray(pBody.Tenants)) ? pBody.Tenants : [];
			this._plansheetsLoaded = true;
			if (this._activeSection === 'plansheets') { this._setContent(this._section_plansheets()); }
		}).catch(() =>
		{
			this._plansheetTenants = [];
			this._plansheetsLoaded = true;
			if (this._activeSection === 'plansheets') { this._setContent(this._section_plansheets()); }
		});
	}

	savePinnedCustomer()
	{
		let tmpEl = typeof document !== 'undefined' ? document.getElementById('us-PinnedCustomer') : null;
		let tmpVal = tmpEl ? parseInt(tmpEl.value, 10) : 0;
		this._setPinnedCustomer(tmpVal);
		this._setContent(this._section_plansheets());
	}

	clearPinnedCustomer()
	{
		this._setPinnedCustomer(0);
		this._setContent(this._section_plansheets());
	}

	switchToSheet(pIDCustomer)
	{
		let tmpClient = require('../providers/FrameworkClient.js');
		this._msg('us-plansheets-msg', 'Switching...', '');
		tmpClient.postJSON(this.pict, '/1.0/Session/Context/' + pIDCustomer, {}).then((pBody) =>
		{
			if (pBody && pBody.Switched)
			{
				// Reduce the record-specific route to its feature area before reloading, so the switch does
				// not land on a not-found in the new tenant (see WI #328). Plain reload if the app is absent.
				let tmpApp = this.pict && this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.reloadForActivePlansheetChange === 'function') { tmpApp.reloadForActivePlansheetChange(); }
				else { window.location.reload(); }
			}
			else { this._msg('us-plansheets-msg', (pBody && pBody.Error) || 'Could not switch.', 'err'); }
		}).catch((pErr) => this._msg('us-plansheets-msg', pErr.message || 'Could not switch.', 'err'));
	}

	_loadingSection(pName)
	{
		return `<div class="cst-set-section cst-set-section-wide"><h2 class="cst-set-h">${_escapeHTML(pName)}</h2><div class="cst-set-placeholder">Loading...</div></div>`;
	}

	_setContent(pHTML)
	{
		if (typeof document === 'undefined') { return; }
		let tmpEl = document.getElementById('Settings-Content');
		if (tmpEl) { tmpEl.innerHTML = pHTML; }
	}

	_entCheckboxes(pCatalog, pSelected, pName)
	{
		let tmpSelected = Array.isArray(pSelected) ? pSelected : [];
		return (pCatalog || []).map((pEnt) => `
			<label class="cst-role-ent"><input type="checkbox" data-${pName}="${_escapeHTML(pEnt.Key)}" ${tmpSelected.indexOf(pEnt.Key) >= 0 ? 'checked' : ''}/>
				<span class="cst-role-ent-label">${_escapeHTML(pEnt.Label || pEnt.Key)}</span><span class="cst-role-ent-desc">${_escapeHTML(pEnt.Description || '')}</span></label>`).join('');
	}

	// ── Team (member management) ──────────────────────────────────────────────
	_section_team()
	{
		if (!this._teamLoaded) { return this._loadingSection('Team'); }
		let tmpMembers = (this.pict.AppData.Team && this.pict.AppData.Team.Members) || [];
		let tmpRoles = (this.pict.AppData.Team && this.pict.AppData.Team.Roles) || [];
		let tmpSelfID = (this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.IDUser) || 0;
		let tmpRows = tmpMembers.map((pMember) => this._memberRow(pMember, tmpRoles, tmpSelfID)).join('');
		return `
<div class="cst-set-section cst-set-section-wide">
	<h2 class="cst-set-h">Team</h2>
	<p class="cst-set-sub">Members of this plan sheet. Invite people, set a title, color, and the roles each person holds. Removing a member keeps their name on past work.</p>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].inviteMember()">Invite someone</button><span id="team-invite-msg" class="cst-set-msg"></span></div>
	${this._invitesHTML()}
	<h3 class="cst-set-sh">Members</h3>
	${tmpRows || '<div class="cst-set-placeholder">No members.</div>'}
</div>`;
	}

	// Pending invitations (sent, not yet accepted) with Resend / Revoke. Empty string when there are none.
	_invitesHTML()
	{
		let tmpInvites = (this.pict.AppData.Team && this.pict.AppData.Team.Invitations) || [];
		if (!tmpInvites.length) { return ''; }
		let tmpSelf = "_Pict.views['Plansheet-UserSettings']";
		let tmpRows = tmpInvites.map((pInvite) =>
		{
			let tmpID = pInvite.IDInvitation || 0;
			return `
<div class="cst-team-row" data-invite="${tmpID}">
	<div class="cst-team-head"><div class="cst-team-id"><div class="cst-team-name">${_escapeHTML(pInvite.Email || '')}</div><div class="cst-team-email">invited as ${_escapeHTML(pInvite.RoleSystemKey || 'member')} &middot; not accepted yet</div></div></div>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="${tmpSelf}.resendInvite(${tmpID})">Resend</button><button class="cst-set-btn cst-set-btn-secondary" onclick="${tmpSelf}.revokeInvite(${tmpID})">Revoke</button><span id="invite-msg-${tmpID}" class="cst-set-msg"></span></div>
</div>`;
		}).join('');
		return `<div class="cst-team-invites"><h3 class="cst-set-sh">Pending invitations</h3>${tmpRows}</div>`;
	}

	_memberRow(pMember, pRoles, pSelfID)
	{
		let tmpAvatar = libAvatarHelper.avatarHTML(pMember, { Size: 38 });
		// A removed (deactivated) member: compact row, no editing, with a Restore action.
		if (pMember.Active === false)
		{
			return `
<div class="cst-team-row cst-team-row-removed" data-user="${pMember.IDUser}">
	<div class="cst-team-head">${tmpAvatar}<div class="cst-team-id"><div class="cst-team-name">${_escapeHTML(pMember.DisplayName || pMember.Email)} <span class="cst-team-removed-badge">Removed</span></div><div class="cst-team-email">${_escapeHTML(pMember.Email)}</div></div></div>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].restoreMember(${pMember.IDUser})">Restore</button><span id="team-msg-${pMember.IDUser}" class="cst-set-msg"></span></div>
</div>`;
		}
		let tmpChecks = (pRoles || []).map((pRole) => `<label class="cst-team-role"><input type="checkbox" data-role="${pRole.IDRole}" ${pMember.Roles.some((pR) => pR.IDRole === pRole.IDRole) ? 'checked' : ''}/> ${_escapeHTML(pRole.Name)}${pRole.IsSystem ? '' : ' <span class="cst-team-role-custom">custom</span>'}</label>`).join('');
		// Remove is offered for human members other than yourself (agents use Retire). The server also guards
		// self-removal and the last owner.
		let tmpRemove = (!pMember.IsAgent && pMember.IDUser !== pSelfID)
			? `<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].removeMember(${pMember.IDUser})">Remove</button>`
			: '';
		return `
<div class="cst-team-row" data-user="${pMember.IDUser}">
	<div class="cst-team-head">${tmpAvatar}<div class="cst-team-id"><div class="cst-team-name">${_escapeHTML(pMember.DisplayName || pMember.Email)}${pMember.IsAgent ? ' <span class="cst-team-agent-badge">Agent</span>' : ''}</div><div class="cst-team-email">${_escapeHTML(pMember.Email)}</div></div></div>
	<div class="cst-team-fields">
		<label class="cst-set-field"><span>Title</span><input class="cst-set-input" id="team-title-${pMember.IDUser}" value="${_escapeHTML(pMember.Title || '')}" maxlength="128"/></label>
		<label class="cst-set-field"><span>Color</span><input type="color" class="cst-set-color" id="team-color-${pMember.IDUser}" value="${_escapeHTML(pMember.Color || '#3b6fd4')}"/></label>
	</div>
	<div class="cst-team-roles">${tmpChecks}</div>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveMember(${pMember.IDUser})">Save</button><button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].resetMemberTwoFactor(${pMember.IDUser})">Reset 2FA</button>${pMember.IsAgent ? `<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].retireAgent(${pMember.IDUser})">Retire agent</button>` : ''}${tmpRemove}<span id="team-msg-${pMember.IDUser}" class="cst-set-msg"></span></div>
</div>`;
	}

	resetMemberTwoFactor(pIDUser)
	{
		if (typeof window !== 'undefined' && typeof window.confirm === 'function'
			&& !window.confirm('Reset two-step verification for this member? They will set up a new code at their next sign-in.')) { return; }
		this._msg('team-msg-' + pIDUser, 'Resetting...', '');
		this.pict.providers.TeamAPI.resetMemberTwoFactor(pIDUser)
			.then(() => this._msg('team-msg-' + pIDUser, 'Two-step verification reset.', 'ok'))
			.catch((pErr) => this._msg('team-msg-' + pIDUser, pErr.message || 'Could not reset.', 'err'));
	}

	// Retire an agent persona (WI #465). Kept off the node workspace because a retirable agent has no node to open.
	// The server refuses (409) while the agent still has an active node; that message surfaces as the row error.
	retireAgent(pIDUser)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let fRun = () =>
		{
			this._msg('team-msg-' + pIDUser, 'Retiring...', '');
			this.pict.providers.TeamAPI.retireAgent(pIDUser)
				.then(() => { this._msg('team-msg-' + pIDUser, 'Agent retired.', 'ok'); return this.pict.providers.TeamAPI.listMembers(); })
				.then(() => { if (this._activeSection === 'team') { this._setContent(this._section_team()); } })
				.catch((pErr) => this._msg('team-msg-' + pIDUser, pErr.message || 'Could not retire the agent.', 'err'));
		};
		if (tmpModal && tmpModal.confirm)
		{
			tmpModal.confirm('Retire this agent persona? It is removed once it has no active node.', { title: 'Retire agent?', confirmLabel: 'Retire', cancelLabel: 'Cancel', dangerous: true })
				.then((pOK) => { if (pOK) { fRun(); } });
		}
		else { fRun(); }
	}

	saveMember(pIDUser)
	{
		if (typeof document === 'undefined') { return; }
		let tmpRow = document.querySelector('.cst-team-row[data-user="' + pIDUser + '"]');
		if (!tmpRow) { return; }
		let tmpTitle = (document.getElementById('team-title-' + pIDUser) || {}).value || '';
		let tmpColor = (document.getElementById('team-color-' + pIDUser) || {}).value || '';
		let tmpRoleIDs = Array.prototype.slice.call(tmpRow.querySelectorAll('input[type=checkbox][data-role]:checked')).map((pBox) => parseInt(pBox.getAttribute('data-role'), 10));
		this._msg('team-msg-' + pIDUser, 'Saving...', '');
		this.pict.providers.TeamAPI.updateMember(pIDUser, { Title: tmpTitle, Color: tmpColor, Roles: tmpRoleIDs })
			.then(() => { this._msg('team-msg-' + pIDUser, 'Saved.', 'ok'); return this.pict.providers.TeamAPI.listMembers(); })
			.catch((pErr) => this._msg('team-msg-' + pIDUser, pErr.message || 'Could not save.', 'err'));
	}

	// Invite someone to this plan sheet. The email field offers a datalist of addresses the account
	// already works with (knownEmails), so a known teammate is one pick. On success the pending list refreshes.
	inviteMember()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function') { return; }
		let tmpKnown = (this.pict.AppData.Team && this.pict.AppData.Team.KnownEmails) || [];
		let tmpOptions = tmpKnown.map((pEmail) => `<option value="${_escapeHTML(pEmail)}"></option>`).join('');
		let tmpEmail = '';
		let tmpRole = 'member';
		tmpModal.show(
			{
				title: 'Invite to this plan sheet',
				content: `<div class="cst-tenant-form">
	<label for="team-invite-email">Email</label>
	<input id="team-invite-email" type="email" list="team-invite-emails" autocomplete="off" placeholder="teammate@example.com" />
	<datalist id="team-invite-emails">${tmpOptions}</datalist>
	<label for="team-invite-role">Role</label>
	<select id="team-invite-role"><option value="member">Member</option><option value="admin">Admin</option><option value="viewer">Viewer</option><option value="owner">Owner</option></select>
	<p class="cst-tenant-form-hint">They join when they accept, with their own persona in this plan sheet.</p>
</div>`,
				buttons: [ { Hash: 'invite', Label: 'Send invitation', Style: 'primary' }, { Hash: 'cancel', Label: 'Cancel' } ],
				closeable: true,
				onOpen: () =>
				{
					let tmpInput = document.getElementById('team-invite-email');
					if (tmpInput) { tmpInput.focus(); tmpInput.addEventListener('input', () => { tmpEmail = String(tmpInput.value || '').trim(); }); }
					let tmpSelect = document.getElementById('team-invite-role');
					if (tmpSelect) { tmpSelect.addEventListener('change', () => { tmpRole = tmpSelect.value; }); }
				}
			}).then((pHash) =>
			{
				if (pHash !== 'invite' || !tmpEmail) { return; }
				this._msg('team-invite-msg', 'Sending...', '');
				this.pict.providers.TeamAPI.invite(tmpEmail, tmpRole)
					.then(() => { if (tmpModal.toast) { tmpModal.toast('Invitation sent to ' + tmpEmail + '.', { type: 'success' }); } return this._reloadTeamSection(); })
					.catch((pErr) => this._msg('team-invite-msg', pErr.message || 'Could not send the invitation.', 'err'));
			});
	}

	resendInvite(pIDInvitation)
	{
		this._msg('invite-msg-' + pIDInvitation, 'Resending...', '');
		this.pict.providers.TeamAPI.resendInvitation(pIDInvitation)
			.then(() => this._msg('invite-msg-' + pIDInvitation, 'Email resent.', 'ok'))
			.catch((pErr) => this._msg('invite-msg-' + pIDInvitation, pErr.message || 'Could not resend.', 'err'));
	}

	revokeInvite(pIDInvitation)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let fRun = () =>
		{
			this._msg('invite-msg-' + pIDInvitation, 'Revoking...', '');
			this.pict.providers.TeamAPI.revokeInvitation(pIDInvitation)
				.then(() => this._reloadTeamSection())
				.catch((pErr) => this._msg('invite-msg-' + pIDInvitation, pErr.message || 'Could not revoke.', 'err'));
		};
		if (tmpModal && tmpModal.confirm)
		{
			tmpModal.confirm('Cancel this invitation? The link in the email they already received will stop working.', { title: 'Revoke invitation?', confirmLabel: 'Revoke', cancelLabel: 'Keep', dangerous: true })
				.then((pOK) => { if (pOK) { fRun(); } });
		}
		else { fRun(); }
	}

	// Remove = deactivate the persona. Keeps attribution on past work; invite reactivates. The server
	// guards the last administrator and refuses self-removal (we also hide the control for the caller).
	removeMember(pIDUser)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let fRun = () =>
		{
			this._msg('team-msg-' + pIDUser, 'Removing...', '');
			this.pict.providers.TeamAPI.removeMember(pIDUser)
				.then(() => this._reloadTeamSection())
				.catch((pErr) => this._msg('team-msg-' + pIDUser, pErr.message || 'Could not remove.', 'err'));
		};
		if (tmpModal && tmpModal.confirm)
		{
			tmpModal.confirm('Remove this person from the plan sheet? Their name stays on the work they did here, and you can invite them back later.', { title: 'Remove member?', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
				.then((pOK) => { if (pOK) { fRun(); } });
		}
		else { fRun(); }
	}

	// Restore a removed member (reactivate the persona). No confirm -- it is additive and reversible.
	restoreMember(pIDUser)
	{
		this._msg('team-msg-' + pIDUser, 'Restoring...', '');
		this.pict.providers.TeamAPI.updateMember(pIDUser, { Active: 1 })
			.then(() => this._reloadTeamSection())
			.catch((pErr) => this._msg('team-msg-' + pIDUser, pErr.message || 'Could not restore.', 'err'));
	}

	_loadTeam()
	{
		let tmpTeam = this.pict.providers.TeamAPI;
		if (!tmpTeam) { return; }
		// Members + roles are required to render; pending invitations and the known-email suggestions are
		// additive, so a failure of either leaves the page usable (listInvitations/knownEmails resolve to []).
		Promise.all([tmpTeam.listMembers(), tmpTeam.listRoles(), tmpTeam.listInvitations(), tmpTeam.knownEmails()]).then(() =>
		{
			this._teamLoaded = true;
			if (this._activeSection === 'team') { this._setContent(this._section_team()); }
		});
	}

	// Reload members + invitations and repaint the Team section (used after invite / resend / revoke /
	// remove). Returns the promise so callers can chain a status message.
	_reloadTeamSection()
	{
		let tmpTeam = this.pict.providers.TeamAPI;
		return Promise.all([tmpTeam.listMembers(), tmpTeam.listInvitations()]).then(() =>
		{
			if (this._activeSection === 'team') { this._setContent(this._section_team()); }
		});
	}

	// ── Roles ─────────────────────────────────────────────────────────────────
	_section_roles()
	{
		if (!this._rolesLoaded) { return this._loadingSection('Roles'); }
		let tmpRoles = (this.pict.AppData.Team && this.pict.AppData.Team.Roles) || [];
		let tmpCatalog = (this.pict.AppData.Team && this.pict.AppData.Team.Catalog) || [];
		let tmpCustom = tmpRoles.filter((pRole) => !pRole.IsSystem);
		let tmpSystem = tmpRoles.filter((pRole) => pRole.IsSystem);
		return `
<div class="cst-set-section cst-set-section-wide">
	<h2 class="cst-set-h">Roles</h2>
	<p class="cst-set-sub">System roles are fixed. Create custom roles to grant a specific set of entitlements.</p>
	<h3 class="cst-role-group">Custom roles</h3>
	${tmpCustom.map((pRole) => this._roleCard(pRole, tmpCatalog)).join('') || '<div class="cst-set-placeholder">No custom roles yet.</div>'}
	<h3 class="cst-role-group">Create a role</h3>
	<div class="cst-role-card">
		<label class="cst-set-field"><span>Name</span><input class="cst-set-input" id="role-new-name" placeholder="e.g. Reviewer" maxlength="128"/></label>
		<div class="cst-role-ents">${this._entCheckboxes(tmpCatalog, [], 'newent')}</div>
		<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].createRole()">Create role</button><span id="role-new-msg" class="cst-set-msg"></span></div>
	</div>
	<h3 class="cst-role-group">System roles</h3>
	${tmpSystem.map((pRole) => this._systemRoleCard(pRole, tmpCatalog)).join('')}
</div>`;
	}

	_roleCard(pRole, pCatalog)
	{
		return `
<div class="cst-role-card" data-role="${pRole.IDRole}">
	<label class="cst-set-field"><span>Name</span><input class="cst-set-input" id="role-name-${pRole.IDRole}" value="${_escapeHTML(pRole.Name)}" maxlength="128"/></label>
	<div class="cst-role-ents">${this._entCheckboxes(pCatalog, pRole.Entitlements, 'ent')}</div>
	<div class="cst-set-actions">
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveRole(${pRole.IDRole})">Save</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].deleteRole(${pRole.IDRole})">Delete</button>
		<span id="role-msg-${pRole.IDRole}" class="cst-set-msg"></span>
	</div>
</div>`;
	}

	_systemRoleCard(pRole, pCatalog)
	{
		let tmpBadges = (pRole.Entitlements || []).map((pKey) =>
		{
			let tmpEnt = (pCatalog || []).find((pE) => pE.Key === pKey);
			return `<span class="cst-role-badge">${_escapeHTML(tmpEnt ? tmpEnt.Label : pKey)}</span>`;
		}).join('');
		return `<div class="cst-role-card cst-role-system"><div class="cst-role-system-name">${_escapeHTML(pRole.Name)} <span class="cst-role-system-tag">system</span></div><div class="cst-role-badges">${tmpBadges}</div></div>`;
	}

	_collectEnts(pRootEl, pAttr)
	{
		return Array.prototype.slice.call(pRootEl.querySelectorAll('input[type=checkbox][data-' + pAttr + ']:checked')).map((pBox) => pBox.getAttribute('data-' + pAttr));
	}

	createRole()
	{
		if (typeof document === 'undefined') { return; }
		let tmpName = (document.getElementById('role-new-name') || {}).value || '';
		if (!tmpName.trim()) { this._msg('role-new-msg', 'A name is required.', 'err'); return; }
		let tmpCard = document.getElementById('role-new-name').closest('.cst-role-card');
		let tmpEnts = this._collectEnts(tmpCard, 'newent');
		this._msg('role-new-msg', 'Creating...', '');
		this.pict.providers.TeamAPI.createRole({ Name: tmpName, Entitlements: tmpEnts })
			.then(() => this._reloadRoles())
			.catch((pErr) => this._msg('role-new-msg', pErr.message || 'Could not create.', 'err'));
	}

	saveRole(pIDRole)
	{
		if (typeof document === 'undefined') { return; }
		let tmpCard = document.querySelector('.cst-role-card[data-role="' + pIDRole + '"]');
		if (!tmpCard) { return; }
		let tmpName = (document.getElementById('role-name-' + pIDRole) || {}).value || '';
		let tmpEnts = this._collectEnts(tmpCard, 'ent');
		this._msg('role-msg-' + pIDRole, 'Saving...', '');
		this.pict.providers.TeamAPI.updateRole(pIDRole, { Name: tmpName, Entitlements: tmpEnts })
			.then(() => { this._msg('role-msg-' + pIDRole, 'Saved.', 'ok'); return this.pict.providers.TeamAPI.listRoles(); })
			.catch((pErr) => this._msg('role-msg-' + pIDRole, pErr.message || 'Could not save.', 'err'));
	}

	deleteRole(pIDRole)
	{
		let fDelete = () => this.pict.providers.TeamAPI.deleteRole(pIDRole).then(() => this._reloadRoles())
			.catch((pErr) => this._msg('role-msg-' + pIDRole, pErr.message || 'Could not delete.', 'err'));
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Delete this role? Anyone assigned to it loses it.', { title: 'Delete role?', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fDelete(); } });
		}
		else { fDelete(); }
	}

	_reloadRoles()
	{
		this.pict.providers.TeamAPI.listRoles().then(() => { if (this._activeSection === 'roles') { this._setContent(this._section_roles()); } });
	}

	_loadRoles()
	{
		let tmpTeam = this.pict.providers.TeamAPI;
		if (!tmpTeam) { return; }
		Promise.all([tmpTeam.listRoles(), tmpTeam.getEntitlements()]).then(() =>
		{
			this._rolesLoaded = true;
			if (this._activeSection === 'roles') { this._setContent(this._section_roles()); }
		});
	}

	// ── Org Settings ──────────────────────────────────────────────────────────
	_section_org()
	{
		if (!this._orgLoaded) { return this._loadingSection('Organization'); }
		let tmpOrg = (this.pict.AppData.Org && this.pict.AppData.Org.Settings) || {};
		let tmpNavBlock = this._navSettingsBlock(this._navConfig);
		// The brand-logo id is held locally so an upload shows before the Save that persists it. Seed it
		// from the loaded org the first time, then let uploads/removes drive it.
		if (typeof this._brandLogoID !== 'number') { this._brandLogoID = tmpOrg.IDBrandLogoMedia || 0; }
		let tmpBrandPreview = this._brandLogoID
			? ('<img src="/1.0/Media/' + this._brandLogoID + '/Blob" alt="logo" style="max-height:44px;max-width:180px;object-fit:contain;background:#fff;border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;padding:4px;">')
			: '<span class="cst-set-msg">No logo set</span>';
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Organization</h2>
	<p class="cst-set-sub">Your organization profile.</p>
	<label class="cst-set-field"><span>Name</span><input class="cst-set-input" id="org-Name" value="${_escapeHTML(tmpOrg.Name || '')}" maxlength="200"/></label>
	<label class="cst-set-field"><span>Code</span><input class="cst-set-input" id="org-Code" value="${_escapeHTML(tmpOrg.Code || '')}" maxlength="64" placeholder="e.g. sv-app-colors" oninput="_Pict.views['Plansheet-UserSettings'].checkOrgCode()"/></label>
	<p class="cst-set-sub">A short, unique handle for this plan sheet (letters, numbers, and hyphens). It lets you name this plan sheet from the MCP, e.g. "load the ${_escapeHTML(tmpOrg.Code || 'your-code')} plan sheet and run the prompt for Work Item 14". <span id="org-Code-status" class="cst-set-msg"></span></p>
	<label class="cst-set-field"><span>Description</span><textarea class="cst-set-input" id="org-Description" rows="3">${_escapeHTML(tmpOrg.Description || '')}</textarea></label>
	<label class="cst-set-field"><span>Contact name</span><input class="cst-set-input" id="org-ContactName" value="${_escapeHTML(tmpOrg.ContactName || '')}" maxlength="200"/></label>
	<label class="cst-set-field"><span>Contact email</span><input class="cst-set-input" id="org-ContactEmail" type="email" value="${_escapeHTML(tmpOrg.ContactEmail || '')}" maxlength="200"/></label>
	${this._coverPickerBlock(tmpOrg)}
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Blueprint branding</h2>
	<p class="cst-set-sub">A logo and a footer line stamped on every blueprint in this plan sheet, so they read as your own documents. Shared links and PDF downloads carry them too.</p>
	<div class="cst-set-field"><span>Logo</span>
		<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
			<div id="org-BrandLogo-preview">${tmpBrandPreview}</div>
			<label class="cst-set-btn cst-set-btn-secondary" style="cursor:pointer;">Upload a PNG<input type="file" accept="image/png,image/svg+xml,image/jpeg" style="display:none" onchange="_Pict.views['Plansheet-UserSettings'].uploadBrandLogo(this)"/></label>
			<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].removeBrandLogo()">Remove</button>
			<span id="org-BrandLogo-msg" class="cst-set-msg"></span>
		</div>
	</div>
	<label class="cst-set-field"><span>Footer line</span><input class="cst-set-input" id="org-BrandFooter" value="${_escapeHTML(tmpOrg.BrandFooter || '')}" maxlength="200" placeholder="e.g. your company or product name"/></label>
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Security</h2>
	<label class="cst-set-check"><input type="checkbox" id="org-Require2FA"${tmpOrg.RequireTwoFactorForLocal ? ' checked' : ''}/> <span>Require two-step verification for password sign-in</span></label>
	<p class="cst-set-sub">Members who sign in with a password are asked to turn on a one-time code before they can use the app. People who use a connected login (Google, GitHub) carry their own protection and are unaffected.</p>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveOrg()">Save</button><span id="org-msg" class="cst-set-msg"></span></div>
	${tmpNavBlock}
</div>`;
	}

	// The owner's sidebar-visibility picker for the Org Settings page: a checkbox per hideable nav entry
	// (checked = shown), grouped by its sidebar group. Returns '' when the catalog has not loaded, so a
	// non-owner (who never gets a catalog) sees nothing. saveNav() reads these checkboxes back.
	_navSettingsBlock(pCfg)
	{
		let tmpCfg = pCfg || {};
		let tmpCatalog = Array.isArray(tmpCfg.Catalog) ? tmpCfg.Catalog : [];
		if (!tmpCatalog.length) { return ''; }
		let tmpHidden = {};
		(Array.isArray(tmpCfg.HiddenNavItems) ? tmpCfg.HiddenNavItems : []).forEach((pHash) => { tmpHidden[pHash] = true; });
		let tmpOrder = [];
		let tmpByGroup = {};
		tmpCatalog.forEach((pItem) =>
		{
			if (!tmpByGroup[pItem.GroupHash]) { tmpByGroup[pItem.GroupHash] = { Name: pItem.GroupName || '', Items: [] }; tmpOrder.push(pItem.GroupHash); }
			tmpByGroup[pItem.GroupHash].Items.push(pItem);
		});
		let tmpGroups = tmpOrder.map((pGH) =>
		{
			let tmpGroup = tmpByGroup[pGH];
			let tmpItems = tmpGroup.Items.map((pItem) =>
				`<label class="cst-set-check"><input type="checkbox" class="cst-set-navitem" data-hash="${_escapeHTML(pItem.Hash)}"${tmpHidden[pItem.Hash] ? '' : ' checked'}/> <span>${_escapeHTML(pItem.Name)}</span></label>`).join('');
			return `<div><div class="cst-set-sub" style="font-weight:600;color:var(--theme-color-text-primary,#2c3140);margin-bottom:4px;">${_escapeHTML(tmpGroup.Name)}</div>${tmpItems}</div>`;
		}).join('');
		return `
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Navigation</h2>
	<p class="cst-set-sub">Turn off the sidebar entries this plan sheet does not use. A hidden entry leaves the sidebar and the Cmd+K launcher for everyone here; turn it back on any time. Your personal pages and the settings gear are always shown.</p>
	<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:16px 24px;margin-top:8px;">${tmpGroups}</div>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveNav()">Save navigation</button><span id="nav-msg" class="cst-set-msg"></span></div>`;
	}

	// Persist the sidebar-visibility picker: any unchecked entry is hidden. Writes through OrgAPI, then
	// re-installs the site nav so the sidebar reflects it at once for this session (other members pick it
	// up on their next CheckSession).
	saveNav()
	{
		if (typeof document === 'undefined') { return; }
		let tmpHidden = [];
		let tmpInputs = document.querySelectorAll('.cst-set-navitem');
		for (let i = 0; i < tmpInputs.length; i++)
		{
			if (!tmpInputs[i].checked) { tmpHidden.push(tmpInputs[i].getAttribute('data-hash')); }
		}
		this._msg('nav-msg', 'Saving...', '');
		this.pict.providers.OrgAPI.saveNav(tmpHidden)
			.then((pBody) =>
			{
				if (this._navConfig) { this._navConfig.HiddenNavItems = (pBody && pBody.HiddenNavItems) || tmpHidden; }
				this._msg('nav-msg', 'Saved.', 'ok');
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp._installSiteNav === 'function') { tmpApp._installSiteNav(); }
			})
			.catch((pErr) => this._msg('nav-msg', pErr.message || 'Could not save.', 'err'));
	}

	saveOrg()
	{
		if (typeof document === 'undefined') { return; }
		let tmpGet = (pId) => (document.getElementById(pId) || {}).value || '';
		let tmpChk = (pId) => (document.getElementById(pId) || {}).checked || false;
		this._msg('org-msg', 'Saving...', '');
		let tmpBrandLogo = (typeof this._brandLogoID === 'number') ? this._brandLogoID : ((((this.pict.AppData.Org || {}).Settings) || {}).IDBrandLogoMedia || 0);
		this.pict.providers.OrgAPI.updateSettings({ Name: tmpGet('org-Name'), Code: tmpGet('org-Code'), Description: tmpGet('org-Description'), ContactName: tmpGet('org-ContactName'), ContactEmail: tmpGet('org-ContactEmail'), RequireTwoFactorForLocal: tmpChk('org-Require2FA'), BrandFooter: tmpGet('org-BrandFooter'), IDBrandLogoMedia: tmpBrandLogo })
			.then((pOrg) => { if (pOrg) { this._brandLogoID = pOrg.IDBrandLogoMedia || 0; } this._msg('org-msg', 'Saved.', 'ok'); })
			.catch((pErr) => this._msg('org-msg', pErr.message || 'Could not save.', 'err'));
	}

	// Upload a brand logo (team media owned by this plan sheet; the server stamps the tenant, so IDOwner 0 and
	// no IDCustomer leaves the client). Holds the id locally until Save persists it onto the plan sheet.
	uploadBrandLogo(pInput)
	{
		let tmpFile = pInput && pInput.files && pInput.files[0];
		if (!tmpFile) { return; }
		this._msg('org-BrandLogo-msg', 'Uploading...', '');
		this.pict.providers.MediaAPI.upload('Customer', 0, tmpFile, {})
			.then((pRef) =>
			{
				this._brandLogoID = (pRef && pRef.IDMedia) || 0;
				let tmpPrev = (typeof document !== 'undefined') ? document.getElementById('org-BrandLogo-preview') : null;
				if (tmpPrev && this._brandLogoID)
				{
					tmpPrev.innerHTML = '<img src="/1.0/Media/' + this._brandLogoID + '/Blob?t=' + Date.now() + '" alt="logo" style="max-height:44px;max-width:180px;object-fit:contain;background:#fff;border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;padding:4px;">';
				}
				this._msg('org-BrandLogo-msg', 'Uploaded. Click Save to apply.', 'ok');
			})
			.catch((pErr) => this._msg('org-BrandLogo-msg', (pErr && pErr.message) || 'Upload failed.', 'err'));
	}

	removeBrandLogo()
	{
		this._brandLogoID = 0;
		let tmpPrev = (typeof document !== 'undefined') ? document.getElementById('org-BrandLogo-preview') : null;
		if (tmpPrev) { tmpPrev.innerHTML = '<span class="cst-set-msg">No logo set</span>'; }
		this._msg('org-BrandLogo-msg', 'Removed. Click Save to apply.', '');
	}

	// The cover-blueprint picker (WI #339): a select of this plan sheet's standalone blueprints, current
	// one selected, plus None. Composed on the Blueprints page; saved through PUT /1.0/Plansheet/Cover
	// (saveCover), separate from the org profile Save above.
	_coverPickerBlock(pOrg)
	{
		let tmpCurrent = (pOrg && pOrg.IDPrimaryBlueprint) || 0;
		let tmpList = Array.isArray(this._coverBlueprints) ? this._coverBlueprints : [];
		let tmpOptions = '<option value="0"' + (tmpCurrent ? '' : ' selected') + '>None</option>';
		tmpList.forEach((pBP) =>
		{
			let tmpID = pBP.IDBlueprint || 0;
			let tmpNum = pBP.BlueprintNumber ? (' (BP-' + String(pBP.BlueprintNumber).padStart(3, '0') + ')') : '';
			tmpOptions += '<option value="' + tmpID + '"' + (tmpID === tmpCurrent ? ' selected' : '') + '>' + _escapeHTML((pBP.Name || ('Blueprint #' + tmpID)) + tmpNum) + '</option>';
		});
		let tmpHint = tmpList.length
			? 'Choose a blueprint to front this plan sheet when you browse your plan sheets. Compose blueprints on the Blueprints page.'
			: 'No standalone blueprints yet. Compose one on the Blueprints page, then pick it here.';
		return `
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Cover blueprint</h2>
	<p class="cst-set-sub">${tmpHint}</p>
	<label class="cst-set-field"><span>Cover</span><select class="cst-set-input" id="org-Cover">${tmpOptions}</select></label>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveCover()">Save cover</button><span id="cover-msg" class="cst-set-msg"></span></div>`;
	}

	saveCover()
	{
		if (typeof document === 'undefined') { return; }
		let tmpSel = document.getElementById('org-Cover');
		let tmpID = tmpSel ? (parseInt(tmpSel.value, 10) || 0) : 0;
		this._msg('cover-msg', 'Saving...', '');
		let tmpClient = require('../providers/FrameworkClient.js');
		tmpClient.putJSON(this.pict, '/1.0/Plansheet/Cover', { IDBlueprint: tmpID })
			.then((pBody) =>
			{
				if (pBody && pBody.Success)
				{
					if (this.pict.AppData.Org && this.pict.AppData.Org.Settings) { this.pict.AppData.Org.Settings.IDPrimaryBlueprint = tmpID; }
					this._msg('cover-msg', 'Saved.', 'ok');
					return;
				}
				this._msg('cover-msg', (pBody && pBody.Error) || 'Could not save.', 'err');
			})
			.catch((pErr) => this._msg('cover-msg', (pErr && pErr.message) || 'Could not save.', 'err'));
	}

	// Live availability check for the plan sheet Code field (debounced). The server normalizes and
	// excludes this plan sheet's own code, so keeping the current code always reads as available.
	checkOrgCode()
	{
		if (typeof document === 'undefined') { return; }
		let tmpRaw = ((document.getElementById('org-Code') || {}).value || '').trim();
		let tmpStatus = document.getElementById('org-Code-status');
		if (this._codeCheckTimer) { clearTimeout(this._codeCheckTimer); }
		if (!tmpRaw) { if (tmpStatus) { tmpStatus.textContent = ''; tmpStatus.className = 'cst-set-msg'; } return; }
		this._codeCheckTimer = setTimeout(() =>
		{
			this.pict.providers.OrgAPI.checkCode(tmpRaw)
				.then((pBody) =>
				{
					let tmpEl = document.getElementById('org-Code-status');
					if (!tmpEl) { return; }
					if (pBody && pBody.Available) { tmpEl.textContent = 'Available' + (pBody.Code && pBody.Code !== tmpRaw ? ' as "' + pBody.Code + '"' : '') + '.'; tmpEl.className = 'cst-set-msg ok'; }
					else { tmpEl.textContent = (pBody && pBody.Reason) || 'That code is taken.'; tmpEl.className = 'cst-set-msg err'; }
				})
				.catch(() => {});
		}, 300);
	}

	_loadOrg()
	{
		let tmpOrg = this.pict.providers.OrgAPI;
		if (!tmpOrg) { return; }
		// Load the org profile and the nav-visibility config together; getNav is owner-gated, so a non-owner
		// (who cannot reach this section anyway) just falls back to an empty catalog and renders no picker.
		// Also load the standalone blueprints for the cover picker (WI #339); non-fatal if it fails.
		let tmpClient = require('../providers/FrameworkClient.js');
		Promise.all(
			[
				tmpOrg.getSettings(),
				tmpOrg.getNav().catch(() => ({ HiddenNavItems: [], Catalog: [] })),
				tmpClient.getJSON(this.pict, '/1.0/Blueprints/0/250').catch(() => [])
			]).then((pResults) =>
		{
			this._navConfig = pResults[1] || { HiddenNavItems: [], Catalog: [] };
			this._coverBlueprints = Array.isArray(pResults[2]) ? pResults[2] : [];
			this._orgLoaded = true;
			if (this._activeSection === 'org') { this._setContent(this._section_org()); }
		});
	}

	// -- Top Bar (the plan sheet's own decoration, WI #360) --------------------
	// The author arranges a moodboard inside a LOCKED crop shaped like the top bar, then "Set as top bar"
	// bakes that crop to a standalone SVG (pict-section-moodboard bakeCropToSVG) and stores it with its
	// source board, so it stays re-editable. The point is identity: with a backdrop of its own, a plan
	// sheet's chrome stops looking like every other plan sheet's, and landing in the wrong one is obvious.
	_section_topbar()
	{
		if (!this._topBarLoaded) { return this._loadingSection('Top Bar'); }
		let tmpHas = !!(this._topBarData && this._topBarData.TopBarBackdropSVG);
		let tmpClear = tmpHas
			? `<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].clearTopBar()">Remove</button>`
			: '';
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Top Bar</h2>
	<p class="cst-set-sub">Give this plan sheet its own look. Arrange stickers, drawings, and images inside the frame below, then set it as the top bar. The frame is the exact shape of the bar, so what you compose inside it is what lands across the top of every page. ${tmpHas ? 'This plan sheet has a top bar set.' : 'No top bar is set yet, so the bar shows its plain background.'}</p>
	<div class="cst-topbar-board" id="Settings-TopBar-Board"></div>
	<p class="cst-set-sub">The chrome sits on top: the brand mark and your account chip at the two ends, the page name in between. Those ends stay covered by the theme, so keep anything you want seen toward the middle.</p>
	<div class="cst-set-actions">
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].setTopBar()">Set as top bar</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].fitTopBarFrame()">Fit frame to art</button>
		${tmpClear}
		<span id="topbar-msg" class="cst-set-msg"></span>
	</div>
</div>`;
	}

	_loadTopBar()
	{
		let tmpOrg = this.pict.providers.OrgAPI;
		if (!tmpOrg) { return; }
		// showSection paints the section HTML (wiping the board host) every time it runs, and it runs twice
		// on a settings open -- once from cache, once after getMe. Once the data is in hand the answer is
		// simply to remount into the fresh host rather than refetch and leave the canvas blank meanwhile.
		if (this._topBarLoaded) { this._mountTopBar(); return; }
		// The composer wants the source board too, not just the baked SVG, so it reopens what was set
		// rather than starting from an empty canvas.
		tmpOrg.getTopBar(true).then((pBody) =>
		{
			this._topBarData = pBody || { TopBarBackdropSVG: '' };
			this._topBarLoaded = true;
			if (this._activeSection === 'topbar')
			{
				this._setContent(this._section_topbar());
				this._mountTopBar();
			}
		});
	}

	// Mount the composer board into the section, seed it from the stored source board, and lock its crop
	// frame to the bar's shape. The frame has to wait for the flow underneath to finish mounting and for a
	// seeded board to finish applying (isBoardReady), otherwise setCropFrame sizes itself against an empty
	// board and the author gets a frame in the wrong place.
	_mountTopBar()
	{
		let tmpBoardView = this.pict.views['TopBar-Board-Edit'];
		if (typeof document === 'undefined') { return; }
		let tmpHost = document.getElementById('Settings-TopBar-Board');
		if (!tmpBoardView)
		{
			if (tmpHost) { tmpHost.innerHTML = '<div class="cst-set-placeholder">The board composer is not available in this build.</div>'; }
			return;
		}
		tmpBoardView.render();
		// Always set a board, even an empty one. This view is a reused singleton, so whatever was last
		// composed is still in it: without the empty case a removed top bar would come back on screen as if
		// it were still stored, and the next "Set as top bar" would quietly restore what was just discarded.
		let tmpBoard = (this._topBarData && this._topBarData.TopBarBoardJSON) || { Nodes: [], Connections: [], ViewState: {} };
		tmpBoardView.setBoard(tmpBoard);
		this._armTopBarCropFrame(tmpBoardView, 0);
	}

	// Poll (bounded) for the board to be ready, then lock the crop. Shown as a guide only -- the frame's
	// resize handles stay off, so the author arranges art WITHIN a fixed shape instead of redefining it.
	_armTopBarCropFrame(pBoardView, pAttempt)
	{
		if (this._activeSection !== 'topbar') { return; }
		if (pAttempt > 40) { return; }
		if (typeof pBoardView.isBoardReady === 'function' && pBoardView.isBoardReady() && typeof pBoardView.setCropFrame === 'function')
		{
			let tmpAspect = this._topBarAspect();
			pBoardView.setCropFrame(tmpAspect, { Width: this._topBarCropWidth(pBoardView, tmpAspect) });
			return;
		}
		setTimeout(() => this._armTopBarCropFrame(pBoardView, pAttempt + 1), 50);
	}

	// How wide to make the locked crop. setCropFrame's own default sizes the frame to the content's WIDTH,
	// which is right for an ordinary crop and wrong for one this elongated: at a 23:1 bar aspect, a board
	// holding one default 120px card would get a frame 120 wide and barely 5 tall, and the card would spill
	// out of the very frame meant to hold it. So the band is sized by HEIGHT instead -- tall enough for
	// card-sized art, with a floor for an empty board -- and the width follows from the aspect. A board whose
	// art is already laid out wider than that keeps its own width, so nothing composed gets cropped away.
	_topBarCropWidth(pBoardView, pAspect)
	{
		let tmpBoard = (typeof pBoardView.getBoard === 'function') ? pBoardView.getBoard() : null;
		let tmpNodes = (tmpBoard && Array.isArray(tmpBoard.Nodes)) ? tmpBoard.Nodes : [];
		let tmpBox = null;
		tmpNodes.forEach((pNode) =>
		{
			let tmpX = Number(pNode.X) || 0, tmpY = Number(pNode.Y) || 0;
			let tmpW = Number(pNode.Width) || 0, tmpH = Number(pNode.Height) || 0;
			if (!tmpBox) { tmpBox = { MinX: tmpX, MinY: tmpY, MaxX: tmpX + tmpW, MaxY: tmpY + tmpH }; return; }
			tmpBox.MinX = Math.min(tmpBox.MinX, tmpX); tmpBox.MinY = Math.min(tmpBox.MinY, tmpY);
			tmpBox.MaxX = Math.max(tmpBox.MaxX, tmpX + tmpW); tmpBox.MaxY = Math.max(tmpBox.MaxY, tmpY + tmpH);
		});
		let tmpContentWidth = tmpBox ? (tmpBox.MaxX - tmpBox.MinX) : 0;
		let tmpContentHeight = tmpBox ? (tmpBox.MaxY - tmpBox.MinY) : 0;
		// A little air above and below the art, and a floor so an empty board opens on a usable band.
		let tmpBand = Math.max(tmpContentHeight * 1.3, _TOPBAR_MIN_BAND);
		return Math.max(tmpBand * pAspect, tmpContentWidth * 1.1);
	}

	// Re-derive the locked crop from what is on the board now. The frame deliberately does NOT follow every
	// card the author drops -- art that shifted under them while composing would be worse than a frame that
	// no longer fits -- so refitting is an explicit action, for after the arranging is done.
	fitTopBarFrame()
	{
		let tmpBoardView = this.pict.views['TopBar-Board-Edit'];
		if (!tmpBoardView || typeof tmpBoardView.setCropFrame !== 'function') { return; }
		let tmpAspect = this._topBarAspect();
		tmpBoardView.setCropFrame(tmpAspect, { Width: this._topBarCropWidth(tmpBoardView, tmpAspect) });
		this._msg('topbar-msg', 'Frame refit around the art.', 'ok');
	}

	// The bar's Width / Height. Measured off the live bar so the crop matches the window the author is
	// actually looking at, falling back to a representative wide desktop bar (1344 / 56) when it cannot be
	// measured. An exact match is not required either way: the shell paints the bake with a slice fit, so a
	// wider or narrower window crops the art rather than distorting it.
	_topBarAspect()
	{
		let tmpBar = (typeof document !== 'undefined') ? document.getElementById('Theme-TopBar') : null;
		if (tmpBar && tmpBar.clientWidth > 0 && tmpBar.clientHeight > 0) { return tmpBar.clientWidth / tmpBar.clientHeight; }
		return 24;
	}

	// Bake the locked crop and store it with the board it came from, then paint it on the live bar so the
	// author sees the result on the real chrome instead of a mockup.
	setTopBar()
	{
		let tmpBoardView = this.pict.views['TopBar-Board-Edit'];
		if (!tmpBoardView) { return; }
		if (typeof tmpBoardView.isBoardReady === 'function' && !tmpBoardView.isBoardReady())
		{
			this._msg('topbar-msg', 'The board is still loading.', 'err');
			return;
		}
		let tmpSVG = (typeof tmpBoardView.bakeCropToSVG === 'function') ? tmpBoardView.bakeCropToSVG() : '';
		if (!tmpSVG)
		{
			this._msg('topbar-msg', 'There is nothing in the frame to set yet.', 'err');
			return;
		}
		this._msg('topbar-msg', 'Saving...', '');
		let tmpBoard = (typeof tmpBoardView.getBoard === 'function') ? tmpBoardView.getBoard() : null;
		this.pict.providers.OrgAPI.saveTopBar(tmpSVG, tmpBoard)
			.then(() =>
			{
				this._topBarData = { TopBarBackdropSVG: tmpSVG, TopBarBoardJSON: tmpBoard };
				this._applyTopBarToShell(tmpSVG);
				this._msg('topbar-msg', 'Set. It is on the bar now.', 'ok');
			})
			.catch((pErr) => this._msg('topbar-msg', (pErr && pErr.message) || 'Could not save.', 'err'));
	}

	clearTopBar()
	{
		let fClear = () =>
		{
			this._msg('topbar-msg', 'Removing...', '');
			// Clearing drops the stored source board with the SVG, so the section reopens on a blank canvas
			// rather than offering a board whose bake is no longer anywhere.
			this.pict.providers.OrgAPI.saveTopBar('', null)
				.then(() =>
				{
					this._topBarData = { TopBarBackdropSVG: '' };
					this._applyTopBarToShell('');
					if (this._activeSection === 'topbar') { this._setContent(this._section_topbar()); this._mountTopBar(); }
				})
				.catch((pErr) => this._msg('topbar-msg', (pErr && pErr.message) || 'Could not remove.', 'err'));
		};
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Remove this plan sheet\'s top bar? The bar goes back to its plain background, and the board you composed is discarded.',
				{ title: 'Remove top bar?', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fClear(); } });
		}
		else { fClear(); }
	}

	_applyTopBarToShell(pSVG)
	{
		let tmpShell = this.pict.views['Plansheet-Shell'];
		if (tmpShell && typeof tmpShell.applyTopBarBackdrop === 'function') { tmpShell.applyTopBarBackdrop(pSVG); }
	}

	// ── Documentation Sync ────────────────────────────────────────────────────
	// Connect a GitHub repo and sync a docs subfolder into this plan sheet's library (or push it
	// back out). The GitHub App installations and the stored bindings load together in _loadDocSync;
	// until then the section shows the loading placeholder, mirroring the Org section.
	_section_docsync()
	{
		if (!this._docsyncLoaded) { return this._loadingSection('Documentation Sync'); }
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Documentation Sync</h2>
	<p class="cst-set-sub">Connect a GitHub repository and sync a docs subfolder into this plan sheet's library, or push the library back out. Authorize it with an account GitHub token (below) or, if your server runs the Plansheet GitHub App, an App installation.</p>
	${this._docsyncCredentialsBlock()}
	${this._docsyncBindingForm()}
	${this._docsyncBindingsBlock()}
</div>`;
	}

	// Account-owned GitHub tokens: the fine-grained PATs this account syncs with (shared across all of
	// its plan sheets). Lists each stored token (never the secret) with Test/Revoke, and an add form.
	// A write-capable token unlocks bidirectional sync; a read-only one still pulls private repos.
	_docsyncCredentialsBlock()
	{
		let tmpTokens = Array.isArray(this._docsyncTokens) ? this._docsyncTokens : [];
		let tmpRows = tmpTokens.map((pToken) =>
		{
			let tmpBadge = pToken.CanWrite
				? `<span style="display:inline-block;padding:1px 7px;border-radius:9px;font-size:11px;font-weight:600;background:var(--theme-color-success-soft,#e4f3e8);color:var(--theme-color-success,#1f7a3d);">read + write</span>`
				: `<span style="display:inline-block;padding:1px 7px;border-radius:9px;font-size:11px;font-weight:600;background:var(--theme-color-neutral-soft,#eceef2);color:var(--theme-color-text-secondary,#5b6372);">read only</span>`;
			let tmpMeta = [];
			if (pToken.Scope) { tmpMeta.push('scope ' + _escapeHTML(pToken.Scope)); }
			if (pToken.Kind) { tmpMeta.push(_escapeHTML(pToken.Kind)); }
			let tmpExpires = _formatDate(pToken.ExpiresAt); if (tmpExpires) { tmpMeta.push('expires ' + tmpExpires); }
			let tmpUsed = _formatDate(pToken.LastUsedAt); if (tmpUsed) { tmpMeta.push('last used ' + tmpUsed); }
			return `<div class="cst-set-sub" style="display:flex;align-items:center;gap:10px;margin:8px 0;flex-wrap:wrap;">
		<strong style="color:var(--theme-color-text-primary,#2c3140);">${_escapeHTML(pToken.Label || 'token')}</strong>
		<span style="font-family:monospace;opacity:0.7;">...${_escapeHTML(pToken.Last4 || '')}</span>
		${tmpBadge}
		${tmpMeta.length ? `<span style="opacity:0.75;">${tmpMeta.join(' | ')}</span>` : ''}
		<span style="flex:1 1 auto;"></span>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].testGithubToken(${parseInt(pToken.IDAccountGithubToken, 10) || 0})">Test</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].revokeGithubToken(${parseInt(pToken.IDAccountGithubToken, 10) || 0})">Revoke</button>
	</div>`;
		}).join('');

		let tmpAddForm;
		if (!this._docsyncTokenEncryption)
		{
			tmpAddForm = `<div class="cst-set-placeholder">Token encryption is not configured on this server, so a GitHub token cannot be stored here yet. An administrator needs to set <code>DocSync.TokenEncryptionKey</code> in the server config.</div>`;
		}
		else
		{
			tmpAddForm = `
	<label class="cst-set-field"><span>Label</span><input class="cst-set-input" id="ghtok-Label" maxlength="128" placeholder="e.g. fable-retold docs bot"/></label>
	<label class="cst-set-field"><span>Token</span><span style="display:flex;gap:6px;align-items:center;"><input class="cst-set-input" id="ghtok-Token" type="password" autocomplete="off" spellcheck="false" placeholder="github_pat_..." style="flex:1 1 auto;"/><button type="button" class="cst-set-btn cst-set-btn-secondary" id="ghtok-Token-toggle" onclick="_Pict.views['Plansheet-UserSettings'].toggleTokenVisibility()">Show</button></span></label>
	<p class="cst-set-sub">Masked by default. Show it to check the paste; leading and trailing spaces are trimmed automatically.</p>
	<label class="cst-set-field"><span>Scope</span><input class="cst-set-input" id="ghtok-Scope" maxlength="256" placeholder="owner or org, e.g. fable-retold"/></label>
	<label class="cst-set-field"><span>Test repo</span><input class="cst-set-input" id="ghtok-Repo" placeholder="optional, e.g. fable-retold/meadow"/></label>
	<p class="cst-set-sub">The token is validated against GitHub and encrypted at rest. It is never shown again; only the last four characters are kept for identification.</p>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].addGithubToken()">Add token</button><span id="ghtok-msg" class="cst-set-msg"></span></div>
	<div id="ghtok-result" class="cst-set-sub" style="margin-top:6px;"></div>`;
		}

		return `
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">GitHub credentials</h2>
	<p class="cst-set-sub">Fine-grained personal access tokens this account syncs with. A token is owned by your account and shared across all of its plan sheets.</p>
	${tmpRows || '<div class="cst-set-placeholder">No tokens yet.</div>'}
	${tmpAddForm}`;
	}

	// Credential options for the binding's "Authorize with" picker: every account token, then every
	// GitHub App installation. Value encodes the kind so saveDocSyncBinding can route it. A write
	// token is preferred as the default (it unlocks bidirectional sync).
	_docsyncCredentialOptions()
	{
		let tmpTokens = Array.isArray(this._docsyncTokens) ? this._docsyncTokens : [];
		let tmpData = this._docsyncData || {};
		let tmpInstallations = Array.isArray(tmpData.Installations) ? tmpData.Installations : [];
		let tmpDefaultIndex = tmpTokens.findIndex((pT) => pT.CanWrite);
		if (tmpDefaultIndex < 0) { tmpDefaultIndex = (tmpTokens.length ? 0 : -1); }
		let tmpOut = [];
		tmpTokens.forEach((pToken, pIndex) =>
		{
			let tmpLabel = (pToken.Label || 'token') + ' (...' + (pToken.Last4 || '') + (pToken.CanWrite ? ', write' : ', read only') + ')';
			tmpOut.push(`<option value="token:${parseInt(pToken.IDAccountGithubToken, 10) || 0}"${pIndex === tmpDefaultIndex ? ' selected' : ''}>${_escapeHTML(tmpLabel)}</option>`);
		});
		tmpInstallations.forEach((pInstall) =>
		{
			let tmpLabel = 'GitHub App: ' + (pInstall.Account || ('installation ' + pInstall.InstallationID));
			tmpOut.push(`<option value="app:${_escapeHTML(String(pInstall.InstallationID))}"${tmpDefaultIndex < 0 ? ' selected' : ''}>${_escapeHTML(tmpLabel)}</option>`);
		});
		return tmpOut.join('');
	}

	// The connect-a-repo form. Shows whenever at least one credential (an account token OR a GitHub App
	// installation) can authorize a sync; otherwise it explains what is needed (with the App install
	// link when the App is set up but not installed).
	_docsyncBindingForm()
	{
		let tmpTokens = Array.isArray(this._docsyncTokens) ? this._docsyncTokens : [];
		let tmpData = this._docsyncData || { Configured: false, InstallURL: '', Installations: [] };
		let tmpInstallations = Array.isArray(tmpData.Installations) ? tmpData.Installations : [];
		let tmpHasCredential = (tmpTokens.length > 0) || (tmpInstallations.length > 0);

		if (!tmpHasCredential)
		{
			let tmpHint = this._docsyncTokenEncryption
				? 'Add a GitHub token above to connect a repository.'
				: 'Add a GitHub token above (once token encryption is configured) to connect a repository.';
			if (tmpData.Configured && tmpData.InstallURL)
			{
				tmpHint += ' You can also install the Plansheet GitHub App.';
				return `
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Connect a repository</h2>
	<p class="cst-set-sub">${tmpHint}</p>
	<div class="cst-set-actions"><a class="cst-set-btn cst-set-btn-secondary" href="${_escapeHTML(tmpData.InstallURL)}" target="_blank" rel="noopener">Install the Plansheet GitHub App</a></div>`;
			}
			return `
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Connect a repository</h2>
	<p class="cst-set-sub">${tmpHint}</p>`;
		}

		// A datalist of repo names the GitHub App can see, as an autocomplete convenience; the field is
		// free text so a token-authorized repo the App does not enumerate can still be typed.
		let tmpSeen = {};
		let tmpRepoList = '';
		tmpInstallations.forEach((pInstall) =>
		{
			(Array.isArray(pInstall.Repos) ? pInstall.Repos : []).forEach((pRepo) =>
			{
				if (pRepo.FullName && !tmpSeen[pRepo.FullName]) { tmpSeen[pRepo.FullName] = true; tmpRepoList += `<option value="${_escapeHTML(pRepo.FullName)}"></option>`; }
			});
		});

		return `
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Connect a repository</h2>
	<label class="cst-set-field"><span>Authorize with</span><select class="cst-set-input" id="docsync-cred">${this._docsyncCredentialOptions()}</select></label>
	<label class="cst-set-field"><span>Repository</span><input class="cst-set-input" id="docsync-repo" list="docsync-repo-list" placeholder="owner/name"/><datalist id="docsync-repo-list">${tmpRepoList}</datalist></label>
	<label class="cst-set-field"><span>Branch</span><input class="cst-set-input" id="docsync-Ref" placeholder="default branch"/></label>
	<label class="cst-set-field"><span>Folder</span><input class="cst-set-input" id="docsync-SourcePath" placeholder="docs"/></label>
	<p class="cst-set-sub">The repo subfolder to sync.</p>
	<label class="cst-set-field"><span>Target</span><input class="cst-set-input" id="docsync-TargetPath" placeholder="optional"/></label>
	<label class="cst-set-field"><span>Direction</span><select class="cst-set-input" id="docsync-Direction"><option value="pull">Pull (repo to plan sheet)</option><option value="push">Push (plan sheet to repo)</option><option value="both" selected>Both</option></select></label>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveDocSyncBinding()">Save connection</button><button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].runDocSync()">Sync now</button><span id="docsync-msg" class="cst-set-msg"></span></div>`;
	}

	// The stored bindings, listed below the form: repo, direction, which credential authorizes it, and
	// the last sync outcome. Empty state shows a placeholder so the section reads the same either way.
	_docsyncBindingsBlock()
	{
		let tmpBindings = Array.isArray(this._docsyncBindings) ? this._docsyncBindings : [];
		let tmpTokens = Array.isArray(this._docsyncTokens) ? this._docsyncTokens : [];
		let tmpRows = tmpBindings.map((pBinding) =>
		{
			let tmpBits = [];
			if (pBinding.LastStatus) { tmpBits.push(String(pBinding.LastStatus)); }
			if (pBinding.LastMessage) { tmpBits.push(String(pBinding.LastMessage)); }
			let tmpWhen = _formatDate(pBinding.LastSyncDate);
			if (tmpWhen) { tmpBits.push(tmpWhen); }
			let tmpStatus = tmpBits.length ? _escapeHTML(tmpBits.join(' | ')) : 'Not synced yet.';
			// Which credential authorizes this binding (a pinned account token wins over the App).
			let tmpAuth = '';
			if (pBinding.IDAccountGithubToken)
			{
				let tmpToken = tmpTokens.find((pT) => (parseInt(pT.IDAccountGithubToken, 10) || 0) === (parseInt(pBinding.IDAccountGithubToken, 10) || 0));
				tmpAuth = 'token ' + _escapeHTML(tmpToken ? (tmpToken.Label || ('...' + tmpToken.Last4)) : ('#' + pBinding.IDAccountGithubToken));
			}
			else if (pBinding.GithubInstallationID) { tmpAuth = 'GitHub App'; }
			return `<div class="cst-set-sub" style="margin:8px 0;"><strong style="color:var(--theme-color-text-primary,#2c3140);">${_escapeHTML(pBinding.RepoURL || '')}</strong> (${_escapeHTML(pBinding.Direction || 'both')})${tmpAuth ? ' via ' + tmpAuth : ''}<br/>${tmpStatus}</div>`;
		}).join('');
		return `
	<hr class="cst-set-rule" />
	<h2 class="cst-set-h">Connected repositories</h2>
	${tmpRows || '<div class="cst-set-placeholder">No connections yet.</div>'}`;
	}

	_loadDocSync()
	{
		let tmpAPI = this.pict.providers.DocSyncAPI;
		if (!tmpAPI) { return; }
		// The GitHub App state, the account's GitHub tokens, and the stored bindings load together;
		// each call falls back to an empty shape so one failure does not blank the whole section.
		Promise.all(
			[
				tmpAPI.listInstallations().catch(() => ({ Configured: false, InstallURL: '', Installations: [] })),
				tmpAPI.getBindings().catch(() => []),
				tmpAPI.listGithubTokens().catch(() => ({ Configured: false, Tokens: [] }))
			]).then((pResults) =>
		{
			this._docsyncData = pResults[0] || { Configured: false, InstallURL: '', Installations: [] };
			this._docsyncBindings = Array.isArray(pResults[1]) ? pResults[1] : [];
			let tmpTokens = pResults[2] || { Configured: false, Tokens: [] };
			this._docsyncTokens = Array.isArray(tmpTokens.Tokens) ? tmpTokens.Tokens : [];
			this._docsyncTokenEncryption = !!tmpTokens.Configured;
			this._docsyncLoaded = true;
			if (this._activeSection === 'docsync') { this._setContent(this._section_docsync()); }
		});
	}

	// Refetch just the account's GitHub tokens (after an add/revoke) and re-render if still on the
	// section, then run an optional callback so a status message on the fresh DOM sticks.
	_reloadGithubTokens(fAfter)
	{
		let tmpAPI = this.pict.providers.DocSyncAPI;
		if (!tmpAPI) { if (typeof fAfter === 'function') { fAfter(); } return; }
		tmpAPI.listGithubTokens()
			.then((pResult) =>
			{
				let tmpResult = pResult || { Configured: false, Tokens: [] };
				this._docsyncTokens = Array.isArray(tmpResult.Tokens) ? tmpResult.Tokens : [];
				this._docsyncTokenEncryption = !!tmpResult.Configured;
				if (this._activeSection === 'docsync') { this._setContent(this._section_docsync()); }
				if (typeof fAfter === 'function') { fAfter(); }
			})
			.catch(() => { if (typeof fAfter === 'function') { fAfter(); } });
	}

	// Refetch just the stored bindings (after a save or a sync) and re-render the section if still on
	// it, then run an optional callback so a status message set on the freshly rendered span sticks.
	_reloadDocSyncBindings(fAfter)
	{
		let tmpAPI = this.pict.providers.DocSyncAPI;
		if (!tmpAPI) { if (typeof fAfter === 'function') { fAfter(); } return; }
		tmpAPI.getBindings()
			.then((pBindings) =>
			{
				this._docsyncBindings = Array.isArray(pBindings) ? pBindings : [];
				if (this._activeSection === 'docsync') { this._setContent(this._section_docsync()); }
				if (typeof fAfter === 'function') { fAfter(); }
			})
			.catch(() => { if (typeof fAfter === 'function') { fAfter(); } });
	}

	saveDocSyncBinding()
	{
		if (typeof document === 'undefined') { return; }
		let tmpGet = (pId) => (document.getElementById(pId) || {}).value || '';
		let tmpGithub = tmpGet('docsync-repo').trim();
		if (!tmpGithub) { this._msg('docsync-msg', 'Enter a repository (owner/name).', 'err'); return; }
		let tmpPatch = { Github: tmpGithub };
		// The chosen credential routes to one of the two mutually-exclusive binding pins. Always set
		// BOTH (the chosen one, and the other cleared) so switching a binding's credential is clean.
		let tmpCred = tmpGet('docsync-cred');
		if (tmpCred.indexOf('token:') === 0) { tmpPatch.IDAccountGithubToken = parseInt(tmpCred.slice(6), 10) || 0; tmpPatch.GithubInstallationID = ''; }
		else if (tmpCred.indexOf('app:') === 0) { tmpPatch.GithubInstallationID = tmpCred.slice(4); tmpPatch.IDAccountGithubToken = 0; }
		let tmpRef = tmpGet('docsync-Ref'); if (tmpRef) { tmpPatch.Ref = tmpRef; }
		let tmpSource = tmpGet('docsync-SourcePath'); if (tmpSource) { tmpPatch.SourcePath = tmpSource; }
		let tmpTarget = tmpGet('docsync-TargetPath'); if (tmpTarget) { tmpPatch.TargetPath = tmpTarget; }
		let tmpDirection = tmpGet('docsync-Direction'); if (tmpDirection) { tmpPatch.Direction = tmpDirection; }
		this._msg('docsync-msg', 'Saving...', '');
		this.pict.providers.DocSyncAPI.saveBinding(tmpPatch)
			.then(() => this._reloadDocSyncBindings(() => this._msg('docsync-msg', 'Saved.', 'ok')))
			.catch((pErr) => this._msg('docsync-msg', pErr.message || 'Could not save.', 'err'));
	}

	runDocSync()
	{
		if (typeof document === 'undefined') { return; }
		let tmpGet = (pId) => (document.getElementById(pId) || {}).value || '';
		let tmpGithub = tmpGet('docsync-repo').trim();
		// Every Run field is optional; only send the ones the user filled in so an empty box does not
		// override a stored binding's value. Omitting Github entirely re-runs all stored bindings.
		let tmpBody = {};
		if (tmpGithub) { tmpBody.Github = tmpGithub; }
		let tmpRef = tmpGet('docsync-Ref'); if (tmpRef) { tmpBody.Ref = tmpRef; }
		let tmpSource = tmpGet('docsync-SourcePath'); if (tmpSource) { tmpBody.SourcePath = tmpSource; }
		let tmpTarget = tmpGet('docsync-TargetPath'); if (tmpTarget) { tmpBody.TargetPath = tmpTarget; }
		this._msg('docsync-msg', 'Syncing...', 'ok');
		this.pict.providers.DocSyncAPI.runSync(tmpBody)
			.then((pResults) =>
			{
				let tmpResults = Array.isArray(pResults) ? pResults : [];
				let tmpFiles = 0;
				let tmpErrors = [];
				tmpResults.forEach((pResult) =>
				{
					if (pResult && pResult.Error) { tmpErrors.push((pResult.Repo || 'repo') + ': ' + pResult.Error); }
					else if (pResult && typeof pResult.FilesSynced === 'number') { tmpFiles += pResult.FilesSynced; }
				});
				let tmpSummary = 'Synced ' + tmpFiles + ' file' + (tmpFiles === 1 ? '' : 's') + '.';
				if (tmpErrors.length) { tmpSummary += ' ' + tmpErrors.join('; '); }
				this._reloadDocSyncBindings(() => this._msg('docsync-msg', tmpSummary, tmpErrors.length ? 'err' : 'ok'));
			})
			.catch((pErr) => this._msg('docsync-msg', pErr.message || 'Could not sync.', 'err'));
	}

	// Reveal or re-mask the token input so the operator can check a paste (whitespace, wrong value)
	// without the secret being masked the whole time. Masked by default; this is an explicit choice.
	toggleTokenVisibility()
	{
		if (typeof document === 'undefined') { return; }
		let tmpInput = document.getElementById('ghtok-Token');
		let tmpButton = document.getElementById('ghtok-Token-toggle');
		if (!tmpInput) { return; }
		let tmpReveal = (tmpInput.type === 'password');
		tmpInput.type = tmpReveal ? 'text' : 'password';
		if (tmpButton) { tmpButton.textContent = tmpReveal ? 'Hide' : 'Show'; }
	}

	// Add a GitHub token: the server validates it against GitHub, encrypts it, and never echoes it
	// back. On success the token list reloads (which clears the form, including the password field).
	addGithubToken()
	{
		if (typeof document === 'undefined') { return; }
		let tmpGet = (pId) => (document.getElementById(pId) || {}).value || '';
		let tmpToken = tmpGet('ghtok-Token').trim();
		if (!tmpToken) { this._msg('ghtok-msg', 'Paste a GitHub token first.', 'err'); return; }
		let tmpBody = { Token: tmpToken };
		let tmpLabel = tmpGet('ghtok-Label').trim(); if (tmpLabel) { tmpBody.Label = tmpLabel; }
		let tmpScope = tmpGet('ghtok-Scope').trim(); if (tmpScope) { tmpBody.Scope = tmpScope; }
		let tmpRepo = tmpGet('ghtok-Repo').trim(); if (tmpRepo) { tmpBody.Repo = tmpRepo; }
		this._msg('ghtok-msg', 'Validating with GitHub...', '');
		this.pict.providers.DocSyncAPI.addGithubToken(tmpBody)
			.then((pResult) =>
			{
				let tmpProbe = (pResult && pResult.Probe) || {};
				let tmpSummary = 'Added' + (tmpProbe.Login ? (' as ' + tmpProbe.Login) : '')
					+ ((typeof tmpProbe.RepoCount === 'number') ? (', ' + tmpProbe.RepoCount + ' repo' + (tmpProbe.RepoCount === 1 ? '' : 's') + ' reachable') : '')
					+ (tmpProbe.CanWrite ? ', write access.' : ', read only.');
				this._reloadGithubTokens(() => this._msg('ghtok-msg', tmpSummary, 'ok'));
			})
			.catch((pErr) => this._msg('ghtok-msg', pErr.message || 'Could not add the token.', 'err'));
	}

	// Re-run the GitHub self-test for a stored token and report what it sees (and refresh CanWrite).
	testGithubToken(pID)
	{
		let tmpID = parseInt(pID, 10) || 0;
		if (!tmpID) { return; }
		this._msg('ghtok-msg', 'Testing with GitHub...', '');
		this.pict.providers.DocSyncAPI.testGithubToken(tmpID, {})
			.then((pResult) =>
			{
				let tmpSummary = (pResult.Login ? ('Valid as ' + pResult.Login) : 'Valid')
					+ ((typeof pResult.RepoCount === 'number') ? (', ' + pResult.RepoCount + ' repo' + (pResult.RepoCount === 1 ? '' : 's')) : '')
					+ (pResult.CanWrite ? ', write access.' : ', read only.');
				this._reloadGithubTokens(() => this._msg('ghtok-msg', tmpSummary, 'ok'));
			})
			.catch((pErr) => this._msg('ghtok-msg', pErr.message || 'Test failed.', 'err'));
	}

	// Revoke (soft-delete) a stored token, after a confirm. Any binding pinned to it falls back to the
	// GitHub App on its next sync. The human should also delete the token on GitHub.
	revokeGithubToken(pID)
	{
		let tmpID = parseInt(pID, 10) || 0;
		if (!tmpID) { return; }
		let fDo = () => this.pict.providers.DocSyncAPI.revokeGithubToken(tmpID)
			.then(() => this._reloadGithubTokens(() => this._msg('ghtok-msg', 'Revoked.', 'ok')))
			.catch((pErr) => this._msg('ghtok-msg', pErr.message || 'Could not revoke.', 'err'));
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Revoke this GitHub token? Any connection using it falls back to the GitHub App, and sync may stop until you add a new token. Remember to delete the token on GitHub too.',
				{ title: 'Revoke token?', confirmLabel: 'Revoke', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fDo(); } });
		}
		else { fDo(); }
	}

	// ── Drafting Kit (the plan sheet's language) ──────────────────────────────
	// The Drafting Kit surface: a library of the tenant's kits (list mode), or one kit's editor when a
	// kit id is in the route (#/settings/draftingkit/<id>, parsed by showSection into _editingKitID).
	_section_draftingkit()
	{
		if (this._editingKitID) { return this._section_kitEditor(); }
		return this._section_kitLibrary();
	}

	// List mode: the tenant's own kits + the platform defaults offered as starting templates.
	_section_kitLibrary()
	{
		if (!this._kitLibraryLoaded) { return this._loadingSection('Drafting Kits'); }
		let tmpLib = this._kitLibrary || { Owned: [], Templates: [], IDDefaultVisionType: 0 };
		let tmpEnts = (this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.Entitlements) || [];
		let tmpCanHouse = Array.isArray(tmpEnts) && tmpEnts.indexOf('platform.manage') >= 0;
		let tmpOwned = Array.isArray(tmpLib.Owned) ? tmpLib.Owned : [];
		let tmpCards = tmpOwned.map((pKit) => this._kitCard(pKit, tmpCanHouse)).join('') ||
			'<div class="cst-set-placeholder">No kits yet. Create one to start, or seed it from a platform default below.</div>';
		let tmpTemplateOptions = (Array.isArray(tmpLib.Templates) ? tmpLib.Templates : [])
			.map((pT) => `<option value="${pT.ID}">${_escapeHTML(pT.Name)}</option>`).join('');
		return `
	<div class="cst-set-section cst-set-section-wide">
		<h2 class="cst-set-h">Drafting Kits</h2>
		<p class="cst-set-sub">A kit is your craft's language and look: the words, the connection style, the sticker sets, and the loop checklists. Build your own, or start from a platform default and reshape it. Make one the house default, or point any vision at a kit from its Craft picker.</p>
		<div class="dk-newkit">
			<input id="dk-newkit-name" class="cst-set-input dk-newkit-name" type="text" placeholder="New kit name (e.g. Our Product, Hardware, Garden)" autocomplete="off"/>
			<select id="dk-newkit-template" class="cst-set-input"><option value="0">Start blank</option>${tmpTemplateOptions}</select>
			<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].createKit()">Create kit</button>
			<span id="dk-lib-msg" class="cst-set-msg"></span>
		</div>
		<div class="dk-kitgrid">${tmpCards}</div>
	</div>`;
	}

	_kitCard(pKit, pCanHouse)
	{
		let tmpFacets = [];
		if (pKit.TermCount) { tmpFacets.push(pKit.TermCount + (pKit.TermCount === 1 ? ' word' : ' words') + ' renamed'); }
		if (pKit.DefaultStickerSet) { tmpFacets.push('stickers ' + _escapeHTML(pKit.DefaultStickerSet)); }
		if (pKit.LoopCount) { tmpFacets.push(pKit.LoopCount + (pKit.LoopCount === 1 ? ' loop step' : ' loop steps')); }
		let tmpConn = pKit.ConnectionStyle || {};
		let tmpSwatch = `<span class="dk-swatch" style="background:${_escapeHTML(tmpConn.StrokeColor || '#5b6376')}"></span>`;
		let tmpSummary = tmpFacets.length ? tmpFacets.join(' &middot; ') : 'Using the defaults so far';
		let tmpHouse = pKit.IsHouse ? '<span class="dk-housebadge">House default</span>' : '';
		let tmpHouseBtn = (!pKit.IsHouse && pCanHouse) ? `<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].makeHouseKit(${pKit.ID})">Make house default</button>` : '';
		return `
		<div class="dk-kitcard">
			<div class="dk-kitcard-head">${tmpSwatch}<strong>${_escapeHTML(pKit.Name)}</strong>${tmpHouse}</div>
			<div class="dk-kitcard-sub">${tmpSummary}</div>
			<div class="dk-kitcard-actions">
				<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].openKit(${pKit.ID})">Open</button>
				<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].duplicateKit(${pKit.ID})">Duplicate</button>
				<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].renameKitPrompt(${pKit.ID})">Rename</button>
				${tmpHouseBtn}
				<button class="cst-set-btn cst-set-btn-danger" onclick="_Pict.views['Plansheet-UserSettings'].deleteKitPrompt(${pKit.ID})">Delete</button>
			</div>
		</div>`;
	}

	// Editor mode: one kit's words, connection style, sticker sets, and loops.
	_section_kitEditor()
	{
		if (!this._draftingKitLoaded) { return this._loadingSection('Drafting Kit'); }
		let tmpKit = this._draftingKit || {};
		let tmpKeys = tmpKit.Keys || [];
		let tmpDefaults = tmpKit.Defaults || {};
		let tmpResolved = tmpKit.Resolved || {};
		let tmpHouse = tmpKit.IsHouse ? '<span class="dk-housebadge">House default</span>' : '';
		let tmpHeader = `
	<div class="dk-editor-head">
		<a class="dk-back" href="#" onclick="_Pict.views['Plansheet-UserSettings'].openKitLibrary(); return false;">&larr; All kits</a>
		<div class="dk-editor-title"><input id="dk-name" class="cst-set-input dk-name-in" type="text" value="${_escapeHTML(tmpKit.Name || '')}"/><button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].renameKitInline()">Rename</button>${tmpHouse}<span id="dk-name-msg" class="cst-set-msg"></span></div>
	</div>`;
		let tmpRows = tmpKeys.map((pKey) =>
		{
			let tmpR = tmpResolved[pKey] || tmpDefaults[pKey] || {};
			let tmpD = tmpDefaults[pKey] || {};
			let tmpOnInput = `oninput="_Pict.views['Plansheet-UserSettings'].previewTerms()"`;
			return `<div class="dk-row"><div class="dk-row-head">${_escapeHTML(tmpD.Singular || pKey)}</div>` +
				`<div class="dk-fields">` +
					`<label class="dk-field"><span>Singular</span><input id="dk-${pKey}-s" class="cst-set-input dk-in" value="${_escapeHTML(tmpR.Singular || '')}" placeholder="${_escapeHTML(tmpD.Singular || '')}" ${tmpOnInput}/></label>` +
					`<label class="dk-field"><span>Plural</span><input id="dk-${pKey}-p" class="cst-set-input dk-in" value="${_escapeHTML(tmpR.Plural || '')}" placeholder="${_escapeHTML(tmpD.Plural || '')}" ${tmpOnInput}/></label>` +
				`</div>` +
				`<label class="dk-field dk-field-desc"><span>Description</span><input id="dk-${pKey}-d" class="cst-set-input dk-in" value="${_escapeHTML(tmpR.Description || '')}" placeholder="${_escapeHTML(tmpD.Description || '')}" ${tmpOnInput}/></label>` +
				`</div>`;
		}).join('');
		let tmpWordsBlock = `
	<h3 class="cst-set-h3">Words</h3>
	<p class="cst-set-sub">Rename the product words to fit this craft.</p>
	<div class="dk-rows">${tmpRows}</div>
	<div class="dk-preview" id="dk-preview"></div>
	<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveTerms()">Save words</button><span id="dk-msg" class="cst-set-msg"></span></div>`;
		let tmpConn = tmpKit.ConnectionStyle || {};
		let fSel = (pVal, pOpt) => (pVal === pOpt) ? ' selected' : '';
		let tmpConnBlock = `
	<div class="dk-conn" style="margin-top:22px;border-top:1px solid var(--theme-color-border-default,#e6e9ee);padding-top:16px;">
		<div class="cst-set-sub" style="font-weight:600;color:var(--theme-color-text-primary,#2c3140);">Connection style</div>
		<p class="cst-set-sub">The default look of a link drawn on this craft's boards. New links use it; you can still restyle any single link.</p>
		<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
			<label class="dk-field"><span>Color</span><input type="color" id="dk-conn-color" class="cst-set-input" value="${_escapeHTML(tmpConn.StrokeColor || '#5b6376')}"/></label>
			<label class="dk-field"><span>Width</span><input type="range" id="dk-conn-width" min="1" max="8" step="1" value="${parseInt(tmpConn.StrokeWidth, 10) || 2}"/></label>
			<label class="dk-field"><span>Line</span><select id="dk-conn-line" class="cst-set-input"><option value="solid"${fSel(tmpConn.StrokeStyle, 'solid')}>Solid</option><option value="dashed"${fSel(tmpConn.StrokeStyle, 'dashed')}>Dashed</option><option value="dotted"${fSel(tmpConn.StrokeStyle, 'dotted')}>Dotted</option></select></label>
			<label class="dk-field"><span>Curve</span><select id="dk-conn-curve" class="cst-set-input"><option value="Bezier"${fSel(tmpConn.EdgeTheme, 'Bezier')}>Curved</option><option value="Orthogonal"${fSel(tmpConn.EdgeTheme, 'Orthogonal')}>Elbow</option><option value="Straight"${fSel(tmpConn.EdgeTheme, 'Straight')}>Straight</option></select></label>
			<label class="dk-field"><span>Start end</span><select id="dk-conn-src" class="cst-set-input"><option value="none"${fSel(tmpConn.SourceMarker, 'none')}>None</option><option value="arrow"${fSel(tmpConn.SourceMarker, 'arrow')}>Arrow</option><option value="dot"${fSel(tmpConn.SourceMarker, 'dot')}>Dot</option><option value="square"${fSel(tmpConn.SourceMarker, 'square')}>Square</option></select></label>
			<label class="dk-field"><span>Finish end</span><select id="dk-conn-tgt" class="cst-set-input"><option value="none"${fSel(tmpConn.TargetMarker, 'none')}>None</option><option value="arrow"${fSel(tmpConn.TargetMarker, 'arrow')}>Arrow</option><option value="dot"${fSel(tmpConn.TargetMarker, 'dot')}>Dot</option><option value="square"${fSel(tmpConn.TargetMarker, 'square')}>Square</option></select></label>
		</div>
		<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveConnectionStyle()">Save connection style</button><span id="dk-conn-msg" class="cst-set-msg"></span></div>
	</div>`;
		let tmpStickerSetOptions = tmpKit.StickerSetOptions || [];
		let fSetOptions = (pCurrent, pDefaultLabel) => `<option value=""${pCurrent ? '' : ' selected'}>${pDefaultLabel}</option>` +
			tmpStickerSetOptions.map((pSet) => `<option value="${_escapeHTML(pSet.Key)}"${pSet.Key === pCurrent ? ' selected' : ''}>${_escapeHTML(pSet.Label)} (${pSet.Count})</option>`).join('');
		let tmpStickerOpts = fSetOptions(tmpKit.DefaultStickerSet || '', 'Board default (design / moodboard)');
		let tmpBrandOpts = fSetOptions(tmpKit.BrandStickerSet || '', 'Expressive default (moodboard)');
		let tmpStickerBlock = `
	<div class="dk-stickerset" style="margin-top:22px;border-top:1px solid var(--theme-color-border-default,#e6e9ee);padding-top:16px;">
		<div class="cst-set-sub" style="font-weight:600;color:var(--theme-color-text-primary,#2c3140);">Default sticker set</div>
		<p class="cst-set-sub">The stickers a board on this craft starts with before anyone searches. People can still search the whole library.</p>
		<label class="dk-field"><span>Set</span><select id="dk-stickerset" class="cst-set-input">${tmpStickerOpts}</select></label>
		<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveStickerSet()">Save sticker set</button><a class="cst-set-sub" href="#/settings/stickers" style="margin-left:10px;">Build a custom set</a><span id="dk-stickerset-msg" class="cst-set-msg"></span></div>
		<div class="cst-set-sub" style="font-weight:600;color:var(--theme-color-text-primary,#2c3140);margin-top:18px;">Profile / brand set</div>
		<p class="cst-set-sub">The stickers a teammate's profile moodboard starts with. Point this at a custom set of your brand and culture marks.</p>
		<label class="dk-field"><span>Set</span><select id="dk-brandset" class="cst-set-input">${tmpBrandOpts}</select></label>
		<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveBrandStickerSet()">Save brand set</button><a class="cst-set-sub" href="#/settings/stickers" style="margin-left:10px;">Build a custom set</a><span id="dk-brandset-msg" class="cst-set-msg"></span></div>
	</div>`;
		let tmpLoopMeta = tmpKit.LoopMeta || [];
		let tmpLoopRows = tmpLoopMeta.map((pLoop) => `
		<div class="dk-loop-block">
			<label class="dk-field dk-loop-label"><span>Loop name</span><input id="dk-looplabel-${_escapeHTML(pLoop.Key)}" class="cst-set-input" type="text" value="${_escapeHTML(pLoop.Label || '')}" placeholder="${_escapeHTML(pLoop.DefaultLabel || '')}"/></label>
			<div class="ps-md-host dk-loops-host" id="dk-loop-mdhost-${_escapeHTML(pLoop.Key)}"></div>
		</div>`).join('');
		let tmpLoopsBlock = `
	<div class="dk-loops" style="margin-top:22px;border-top:1px solid var(--theme-color-border-default,#e6e9ee);padding-top:16px;">
		<div class="cst-set-sub" style="font-weight:600;color:var(--theme-color-text-primary,#2c3140);">Loops</div>
		<p class="cst-set-sub">The three refinement loops every vision works through. Rename each to your craft's words, and write its checklist as markdown: <code>- [ ] a step</code>, indent two spaces for sub-steps. Empty a loop to fall back to the platform defaults.</p>
		${tmpLoopRows}
		<div class="cst-set-actions"><button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].saveLoops()">Save loops</button><span id="dk-loops-msg" class="cst-set-msg"></span></div>
	</div>`;
		return `
	<div class="cst-set-section cst-set-section-wide">
		${tmpHeader}
		${tmpWordsBlock}
		${tmpConnBlock}
		${tmpStickerBlock}
		${tmpLoopsBlock}
	</div>`;
	}

	_loadDraftingKit()
	{
		if (this._editingKitID) { return this._loadKitEditor(this._editingKitID); }
		return this._loadKitLibrary();
	}

	_loadKitLibrary()
	{
		let tmpWF = this.pict.providers.WorkflowAPI;
		let tmpSelf = this;
		this._kitLibraryLoaded = false;
		let fApply = (pLib) =>
		{
			tmpSelf._kitLibrary = pLib || { Owned: [], Templates: [], IDDefaultVisionType: 0 };
			tmpSelf._kitLibraryLoaded = true;
			if (tmpSelf._activeSection === 'draftingkit' && !tmpSelf._editingKitID) { tmpSelf._setContent(tmpSelf._section_draftingkit()); }
		};
		if (!tmpWF || typeof tmpWF.getLibrary !== 'function') { return fApply(null); }
		tmpWF.getLibrary().then(fApply).catch(() => fApply(null));
	}

	_loadKitEditor(pID)
	{
		let tmpWF = this.pict.providers.WorkflowAPI;
		let tmpSetAPI = this.pict.providers.StickerSetAPI;
		let tmpSelf = this;
		this._draftingKitLoaded = false;
		let fRender = () =>
		{
			tmpSelf._draftingKitLoaded = true;
			if (tmpSelf._activeSection === 'draftingkit' && tmpSelf._editingKitID === pID) { tmpSelf._setContent(tmpSelf._section_draftingkit()); tmpSelf.previewTerms(); tmpSelf._mountLoopsEditor(); }
		};
		if (!tmpWF || typeof tmpWF.getKit !== 'function') { this._draftingKit = null; return fRender(); }
		Promise.all([ tmpWF.getKit(pID), tmpSetAPI ? tmpSetAPI.listSets() : Promise.resolve(null) ]).then((pResults) =>
		{
			tmpSelf._draftingKit = pResults[0] || null;
			// Offer this tenant's custom sets in the sticker pickers alongside the built-in system sets.
			let tmpCustom = (pResults[1] && Array.isArray(pResults[1].Custom)) ? pResults[1].Custom : [];
			if (tmpSelf._draftingKit && tmpCustom.length)
			{
				let tmpOptions = Array.isArray(tmpSelf._draftingKit.StickerSetOptions) ? tmpSelf._draftingKit.StickerSetOptions.slice() : [];
				tmpCustom.forEach((pSet) => tmpOptions.push({ Key: pSet.Key, Label: pSet.Name + ' (yours)', Count: pSet.Count || 0 }));
				tmpSelf._draftingKit.StickerSetOptions = tmpOptions;
			}
			fRender();
		}).catch(() => fRender());
	}

	// ── kit library actions ──────────────────────────────────────────────────
	openKit(pID) { this._editingKitID = parseInt(pID, 10) || 0; this.showSection('draftingkit/' + this._editingKitID); }
	openKitLibrary() { this._editingKitID = 0; this.showSection('draftingkit'); }

	createKit()
	{
		if (typeof document === 'undefined') { return; }
		let tmpName = ((document.getElementById('dk-newkit-name') || {}).value || '').trim();
		let tmpTemplate = parseInt((document.getElementById('dk-newkit-template') || {}).value, 10) || 0;
		if (!tmpName) { this._msg('dk-lib-msg', 'Give the kit a name first.', 'err'); return; }
		this._msg('dk-lib-msg', 'Creating...', '');
		this.pict.providers.WorkflowAPI.createKit(tmpName, tmpTemplate)
			.then((pKit) => { if (pKit && pKit.ID) { this.openKit(pKit.ID); } else { this._loadKitLibrary(); } })
			.catch((pErr) => this._msg('dk-lib-msg', pErr.message || 'Could not create the kit.', 'err'));
	}

	duplicateKit(pID)
	{
		this._msg('dk-lib-msg', 'Duplicating...', '');
		this.pict.providers.WorkflowAPI.duplicateKit(pID)
			.then(() => this._loadKitLibrary())
			.catch((pErr) => this._msg('dk-lib-msg', pErr.message || 'Could not duplicate the kit.', 'err'));
	}

	makeHouseKit(pID)
	{
		this._msg('dk-lib-msg', 'Setting house default...', '');
		this.pict.providers.OrgAPI.setDraftingKit(pID)
			.then(() =>
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp._installSiteNav === 'function') { tmpApp._installSiteNav(); }
				this._loadKitLibrary();
			})
			.catch((pErr) => this._msg('dk-lib-msg', pErr.message || 'Could not set the house default.', 'err'));
	}

	renameKitPrompt(pID)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return; }
		let tmpInputId = 'dk-rename-input';
		let tmpSelf = this;
		tmpModal.show({
			title: 'Rename kit',
			content: '<div class="cst-tenant-form"><label for="' + tmpInputId + '">Name</label><input id="' + tmpInputId + '" type="text" autocomplete="off"/></div>',
			buttons: [{ Hash: 'save', Label: 'Save', Style: 'primary' }, { Hash: 'cancel', Label: 'Cancel' }],
			closeable: true,
			onOpen: () => { let tmpEl = document.getElementById(tmpInputId); if (tmpEl) { tmpEl.focus(); } }
		}).then((pHash) =>
		{
			if (pHash !== 'save') { return; }
			let tmpName = ((document.getElementById(tmpInputId) || {}).value || '').trim();
			if (!tmpName) { return; }
			tmpSelf.pict.providers.WorkflowAPI.renameKit(pID, tmpName)
				.then(() => tmpSelf._loadKitLibrary())
				.catch((pErr) => tmpSelf._msg('dk-lib-msg', pErr.message || 'Could not rename.', 'err'));
		});
	}

	renameKitInline()
	{
		if (typeof document === 'undefined' || !this._editingKitID) { return; }
		let tmpName = ((document.getElementById('dk-name') || {}).value || '').trim();
		if (!tmpName) { this._msg('dk-name-msg', 'Name cannot be empty.', 'err'); return; }
		this._msg('dk-name-msg', 'Saving...', '');
		this.pict.providers.WorkflowAPI.renameKit(this._editingKitID, tmpName)
			.then((pBody) => { if (this._draftingKit) { this._draftingKit.Name = (pBody && pBody.Name) || tmpName; } this._msg('dk-name-msg', 'Saved.', 'ok'); })
			.catch((pErr) => this._msg('dk-name-msg', pErr.message || 'Could not rename.', 'err'));
	}

	deleteKitPrompt(pID)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpSelf = this;
		if (!tmpModal)
		{
			this.pict.providers.WorkflowAPI.deleteKit(pID).then(() => this._loadKitLibrary());
			return;
		}
		tmpModal.show({
			title: 'Delete kit',
			content: '<p>Delete this kit? Boards keep their placed stickers and any vision using it falls back to the house words. This cannot be undone.</p>',
			buttons: [{ Hash: 'delete', Label: 'Delete', Style: 'danger' }, { Hash: 'cancel', Label: 'Cancel' }],
			closeable: true
		}).then((pHash) =>
		{
			if (pHash !== 'delete') { return; }
			tmpSelf.pict.providers.WorkflowAPI.deleteKit(pID)
				.then(() =>
				{
					let tmpApp = tmpSelf.pict.PictApplication;
					if (tmpApp && typeof tmpApp._installSiteNav === 'function') { tmpApp._installSiteNav(); }
					tmpSelf._loadKitLibrary();
				})
				.catch((pErr) => tmpSelf._msg('dk-lib-msg', pErr.message || 'Could not delete.', 'err'));
		});
	}

	// When the edited kit is the house default, the server refreshed the session; rebuild the nav so the
	// rail relabels live.
	_afterKitFacetSave(pBody)
	{
		if (pBody && pBody.IsHouse)
		{
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp._installSiteNav === 'function') { tmpApp._installSiteNav(); }
		}
	}

	saveTerms()
	{
		if (typeof document === 'undefined' || !this._editingKitID) { return; }
		let tmpKit = this._draftingKit || {};
		let tmpKeys = tmpKit.Keys || [];
		let tmpDefaults = tmpKit.Defaults || {};
		let tmpTerms = {};
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpSg = ((document.getElementById('dk-' + tmpKey + '-s') || {}).value || '').trim();
			let tmpPl = ((document.getElementById('dk-' + tmpKey + '-p') || {}).value || '').trim();
			let tmpDe = ((document.getElementById('dk-' + tmpKey + '-d') || {}).value || '').trim();
			let tmpD = tmpDefaults[tmpKey] || {};
			let tmpEntry = {};
			if (tmpSg && tmpSg !== tmpD.Singular) { tmpEntry.Singular = tmpSg; }
			if (tmpPl && tmpPl !== tmpD.Plural) { tmpEntry.Plural = tmpPl; }
			if (tmpDe && tmpDe !== tmpD.Description) { tmpEntry.Description = tmpDe; }
			if (tmpEntry.Singular || tmpEntry.Plural || tmpEntry.Description) { tmpTerms[tmpKey] = tmpEntry; }
		}
		this._msg('dk-msg', 'Saving...', '');
		this.pict.providers.WorkflowAPI.saveKitTerms(this._editingKitID, tmpTerms)
			.then((pBody) =>
			{
				if (this._draftingKit) { this._draftingKit.Terms = (pBody && pBody.Terms) || tmpTerms; this._draftingKit.Resolved = (pBody && pBody.Resolved) || this._draftingKit.Resolved; }
				this._msg('dk-msg', 'Saved.', 'ok');
				this._afterKitFacetSave(pBody);
			})
			.catch((pErr) => this._msg('dk-msg', pErr.message || 'Could not save the words.', 'err'));
	}

	// Save the kit's default connection (link) style from the Connection-style controls.
	saveConnectionStyle()
	{
		if (typeof document === 'undefined' || !this._editingKitID) { return; }
		let fVal = (pId) => { let tmpEl = document.getElementById(pId); return tmpEl ? tmpEl.value : ''; };
		let tmpStyle =
		{
			StrokeColor: fVal('dk-conn-color'),
			StrokeWidth: parseInt(fVal('dk-conn-width'), 10) || 2,
			StrokeStyle: fVal('dk-conn-line'),
			EdgeTheme: fVal('dk-conn-curve'),
			SourceMarker: fVal('dk-conn-src'),
			TargetMarker: fVal('dk-conn-tgt')
		};
		this._msg('dk-conn-msg', 'Saving...', '');
		this.pict.providers.WorkflowAPI.saveKitConnectionStyle(this._editingKitID, tmpStyle)
			.then((pBody) => { if (this._draftingKit) { this._draftingKit.ConnectionStyle = (pBody && pBody.ConnectionStyle) || tmpStyle; } this._msg('dk-conn-msg', 'Saved.', 'ok'); this._afterKitFacetSave(pBody); })
			.catch((pErr) => this._msg('dk-conn-msg', pErr.message || 'Could not save the connection style.', 'err'));
	}

	// Save the kit's chosen default sticker set from the picker.
	saveStickerSet()
	{
		if (typeof document === 'undefined' || !this._editingKitID) { return; }
		let tmpEl = document.getElementById('dk-stickerset');
		let tmpKey = tmpEl ? tmpEl.value : '';
		this._msg('dk-stickerset-msg', 'Saving...', '');
		this.pict.providers.WorkflowAPI.saveKitDefaultStickerSet(this._editingKitID, tmpKey)
			.then((pBody) => { if (this._draftingKit) { this._draftingKit.DefaultStickerSet = (pBody && pBody.DefaultStickerSet) || ''; } this._msg('dk-stickerset-msg', 'Saved.', 'ok'); this._afterKitFacetSave(pBody); })
			.catch((pErr) => this._msg('dk-stickerset-msg', pErr.message || 'Could not save the sticker set.', 'err'));
	}

	// Save the kit's chosen brand / profile sticker set from the picker.
	saveBrandStickerSet()
	{
		if (typeof document === 'undefined' || !this._editingKitID) { return; }
		let tmpEl = document.getElementById('dk-brandset');
		let tmpKey = tmpEl ? tmpEl.value : '';
		this._msg('dk-brandset-msg', 'Saving...', '');
		this.pict.providers.WorkflowAPI.saveKitBrandStickerSet(this._editingKitID, tmpKey)
			.then((pBody) => { if (this._draftingKit) { this._draftingKit.BrandStickerSet = (pBody && pBody.BrandStickerSet) || ''; } this._msg('dk-brandset-msg', 'Saved.', 'ok'); this._afterKitFacetSave(pBody); })
			.catch((pErr) => this._msg('dk-brandset-msg', pErr.message || 'Could not save the brand set.', 'err'));
	}

	// Mount one rich markdown editor per loop, each seeded from that loop's items as a checklist.
	_mountLoopsEditor()
	{
		if (typeof document === 'undefined') { return; }
		let tmpKit = this._draftingKit || {};
		let tmpMeta = tmpKit.LoopMeta || [];
		let tmpLoops = tmpKit.Loops || {};
		let tmpSelf = this;
		tmpMeta.forEach((pLoop) =>
		{
			let tmpHostEl = document.getElementById('dk-loop-mdhost-' + pLoop.Key);
			if (!tmpHostEl) { return; }
			let tmpMarkdown = libLoopMarkdown.itemsToMarkdown(Array.isArray(tmpLoops[pLoop.Key]) ? tmpLoops[pLoop.Key] : []);
			let tmpEditor = tmpSelf.pict.views['Plansheet-LoopEditor-' + pLoop.Key];
			if (!tmpEditor)
			{
				// The editor is not in this build: plain textarea fallback holding the same markdown.
				tmpHostEl.innerHTML = '<textarea class="cst-set-input dk-loops-fallback" id="dk-loop-fallback-' + pLoop.Key + '" rows="6"></textarea>';
				let tmpFb = document.getElementById('dk-loop-fallback-' + pLoop.Key);
				if (tmpFb) { tmpFb.value = tmpMarkdown; }
				return;
			}
			let tmpAddr = 'LoopEditor_' + pLoop.Key;
			tmpSelf.pict.AppData[tmpAddr] = tmpSelf.pict.AppData[tmpAddr] || {};
			tmpSelf.pict.AppData[tmpAddr].Segments = [{ Content: tmpMarkdown }];
			try { if (tmpEditor.initialRenderComplete) { tmpEditor.destroy(); tmpEditor.initialRenderComplete = false; } } catch (pErr) { /* ignore */ }
			tmpEditor.render();
			if (typeof tmpEditor.marshalToView === 'function') { tmpEditor.marshalToView(); }
			if (typeof tmpEditor.setPreviewMode === 'function') { tmpEditor.setPreviewMode('off'); }
		});
	}

	// Save the loops: read each loop's editor (-> checklist tree) and its name field, and persist both
	// the items and the (non-default) labels. The server re-sanitizes each.
	saveLoops()
	{
		if (typeof document === 'undefined' || !this._editingKitID) { return; }
		let tmpMeta = (this._draftingKit && this._draftingKit.LoopMeta) || [];
		let tmpLoops = {};
		let tmpLabels = {};
		tmpMeta.forEach((pLoop) =>
		{
			let tmpEditor = this.pict.views['Plansheet-LoopEditor-' + pLoop.Key];
			let tmpMarkdown = '';
			if (tmpEditor && typeof tmpEditor.getAllContent === 'function') { tmpMarkdown = tmpEditor.getAllContent('\n\n'); }
			else { let tmpFb = document.getElementById('dk-loop-fallback-' + pLoop.Key); tmpMarkdown = tmpFb ? tmpFb.value : ''; }
			tmpLoops[pLoop.Key] = libLoopMarkdown.markdownToItems(tmpMarkdown);
			let tmpLabelEl = document.getElementById('dk-looplabel-' + pLoop.Key);
			let tmpLabelVal = tmpLabelEl ? String(tmpLabelEl.value || '').trim() : '';
			if (tmpLabelVal && tmpLabelVal !== (pLoop.DefaultLabel || '')) { tmpLabels[pLoop.Key] = tmpLabelVal; }
		});
		this._msg('dk-loops-msg', 'Saving...', '');
		let tmpWF = this.pict.providers.WorkflowAPI;
		Promise.all([ tmpWF.saveKitLoops(this._editingKitID, tmpLoops), tmpWF.saveKitLoopLabels(this._editingKitID, tmpLabels) ])
			.then((pResults) =>
			{
				if (this._draftingKit) { this._draftingKit.Loops = tmpLoops; }
				this._msg('dk-loops-msg', 'Saved.', 'ok');
				this._afterKitFacetSave(pResults[0] || pResults[1]);
			})
			.catch((pErr) => this._msg('dk-loops-msg', pErr.message || 'Could not save the loops.', 'err'));
	}

	// Re-resolve the shell lexicon updated the AppData live; rebuild the nav so the
	// rail relabels at once, and re-render this section to show the new words.
	_afterKitChange()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp._installSiteNav === 'function') { tmpApp._installSiteNav(); }
		this._draftingKitLoaded = false;
		this._loadDraftingKit();
	}

	previewTerms()
	{
		if (typeof document === 'undefined') { return; }
		let tmpKeys = (this._draftingKit && this._draftingKit.Keys) || [];
		let tmpParts = [];
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpPl = ((document.getElementById('dk-' + tmpKeys[i] + '-p') || {}).value || '').trim();
			if (tmpPl) { tmpParts.push(_escapeHTML(tmpPl)); }
		}
		let tmpEl = document.getElementById('dk-preview');
		if (tmpEl) { tmpEl.innerHTML = tmpParts.length ? ('In your words: ' + tmpParts.join(' &middot; ')) : ''; }
	}

	// ── Stickers (admin-managed moodboard sticker library) ────────────────────
	_section_stickers()
	{
		let tmpStore = this.pict.AppData.StickerSettings || {};
		let tmpSets = tmpStore.Sets || { System: [], Custom: [] };
		let tmpUploads = tmpStore.Custom || [];
		let tmpAPI = this.pict.providers.StickerAPI;
		let tmpShapes = this.pict.providers.ShapesAPI;
		let tmpActiveId = tmpStore.ActiveSetId || 0;
		let tmpChips = (tmpSets.Custom || []).map((pSet) =>
			`<button class="cst-setchip${pSet.IDStickerSet === tmpActiveId ? ' is-active' : ''}" onclick="_Pict.views['Plansheet-UserSettings'].selectStickerSet(${pSet.IDStickerSet})">${_escapeHTML(pSet.Name)} <span class="cst-setchip-n">${pSet.Count}</span></button>`).join('');
		let tmpActiveSet = (tmpSets.Custom || []).find((pSet) => pSet.IDStickerSet === tmpActiveId);
		let tmpEditor;
		if (!tmpActiveSet)
		{
			tmpEditor = tmpStore.SetsLoaded ? '<div class="cst-set-placeholder">Pick a set above, or create one to start curating.</div>' : '<div class="cst-set-placeholder">Loading...</div>';
		}
		else
		{
			let tmpItems = (tmpActiveSet.Items || []).map((pItem, pIdx) =>
			{
				let tmpUrl = pItem.IDSticker ? (tmpAPI ? tmpAPI.blobURL(pItem.IDSticker) : '') : (tmpShapes ? tmpShapes.shapeURL(pItem.Collection, pItem.Name) : '');
				return `<div class="cst-sticker-tile" title="${_escapeHTML(pItem.Title || pItem.Name)}"><img src="${tmpUrl}" alt=""><span class="cst-sticker-name">${_escapeHTML(pItem.Title || pItem.Name)}</span><button class="cst-sticker-del" onclick="_Pict.views['Plansheet-UserSettings'].removeSetItem(${pIdx})">Remove</button></div>`;
			}).join('') || '<div class="cst-set-placeholder">Empty. Add stickers from the library or your uploads below.</div>';
			let tmpUploadPick = tmpUploads.length
				? tmpUploads.map((pRow) => `<button class="cst-sticker-tile cst-tile-pick" title="Add ${_escapeHTML(pRow.Name)}" onclick="_Pict.views['Plansheet-UserSettings'].addUploadToSet(${pRow.IDSticker})"><img src="${tmpAPI ? tmpAPI.blobURL(pRow.IDSticker) : ''}" alt=""><span class="cst-sticker-name">${_escapeHTML(pRow.Name)}</span></button>`).join('')
				: '<div class="cst-set-placeholder">No uploaded art yet. Upload PNG or SVG cutouts below.</div>';
			tmpEditor = `
	<div class="cst-setedit-head"><strong>${_escapeHTML(tmpActiveSet.Name)}</strong>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].renameStickerSet(${tmpActiveSet.IDStickerSet})">Rename</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="_Pict.views['Plansheet-UserSettings'].removeStickerSet(${tmpActiveSet.IDStickerSet})">Delete</button>
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].addLibraryToSet()">Add from library</button>
		<span id="us-set-msg" class="cst-set-msg"></span>
	</div>
	<div class="cst-sticker-grid">${tmpItems}</div>
	<h3 class="cst-set-h3">Add one of your uploads</h3>
	<div class="cst-sticker-grid">${tmpUploadPick}</div>`;
		}
		return `
<div class="cst-set-section cst-set-section-wide">
	<h2 class="cst-set-h">Stickers</h2>
	<p class="cst-set-sub">Curate sets your team places on boards, then assign one to a craft in <a href="#/settings/draftingkit">Drafting Kit</a>. Browse the <a href="#/sticker-sets-preview">built-in sets</a>. Upload PNG or SVG cutouts to add your own art.</p>
	<div class="cst-setchips">${tmpChips}<button class="cst-setchip cst-setchip-new" onclick="_Pict.views['Plansheet-UserSettings'].newStickerSet()">+ New set</button></div>
	<div class="cst-setedit">${tmpEditor}</div>
	<div class="cst-set-actions" style="margin-top:18px;border-top:1px solid var(--theme-color-border-default,#e6e9ee);padding-top:14px;">
		<button class="cst-set-btn cst-set-btn-secondary" onclick="document.getElementById('us-sticker-file').click()">Upload sticker art</button>
		<input type="file" id="us-sticker-file" accept="image/svg+xml,image/png" multiple style="display:none" onchange="_Pict.views['Plansheet-UserSettings'].uploadStickers(this.files); this.value='';">
		<span id="us-sticker-msg" class="cst-set-msg"></span>
	</div>
</div>`;
	}

	// ── Sticker sets (curated collections backed by StickerSetAPI) ─────────────
	_loadStickerSets()
	{
		let tmpSetAPI = this.pict.providers.StickerSetAPI;
		this.pict.AppData.StickerSettings = this.pict.AppData.StickerSettings || { Custom: [] };
		if (!tmpSetAPI) { return; }
		let tmpSelf = this;
		tmpSetAPI.listSets().then((pBody) =>
		{
			tmpSelf.pict.AppData.StickerSettings.Sets = pBody || { System: [], Custom: [] };
			tmpSelf.pict.AppData.StickerSettings.SetsLoaded = true;
			if (tmpSelf._activeSection === 'stickers') { tmpSelf._setContent(tmpSelf._section_stickers()); }
		});
	}

	selectStickerSet(pId)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showSettingsSub === 'function'
			&& tmpApp.showSettingsSub('stickers', parseInt(pId, 10) || 0)) { return; }
		this._applySelectStickerSet(pId);
	}

	_applySelectStickerSet(pId)
	{
		this.pict.AppData.StickerSettings = this.pict.AppData.StickerSettings || {};
		this.pict.AppData.StickerSettings.ActiveSetId = parseInt(pId, 10) || 0;
		if (this._activeSection === 'stickers') { this._setContent(this._section_stickers()); }
	}

	newStickerSet()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return; }
		let tmpInputId = 'us-newset-name';
		let tmpSelf = this;
		tmpModal.show({
			title: 'New sticker set',
			content: '<div class="cst-tenant-form"><label for="' + tmpInputId + '">Name</label><input id="' + tmpInputId + '" type="text" autocomplete="off" placeholder="e.g. Acme brand, Garden icons"/></div>',
			buttons: [{ Hash: 'create', Label: 'Create', Style: 'primary' }, { Hash: 'cancel', Label: 'Cancel' }],
			closeable: true,
			onOpen: () => { let tmpEl = document.getElementById(tmpInputId); if (tmpEl) { tmpEl.focus(); } }
		}).then((pHash) =>
		{
			if (pHash !== 'create') { return; }
			let tmpName = ((document.getElementById(tmpInputId) || {}).value || '').trim();
			if (!tmpName || !tmpSelf.pict.providers.StickerSetAPI) { return; }
			tmpSelf.pict.providers.StickerSetAPI.createSet(tmpName, []).then((pBody) =>
			{
				tmpSelf.pict.AppData.StickerSettings.ActiveSetId = (pBody && pBody.StickerSet && pBody.StickerSet.IDStickerSet) || 0;
				tmpSelf._loadStickerSets();
			}).catch(() => { /* the message slot is per-set; ignore */ });
		});
	}

	renameStickerSet(pId)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return; }
		let tmpSet = (((this.pict.AppData.StickerSettings || {}).Sets || {}).Custom || []).find((pCandidate) => pCandidate.IDStickerSet === pId);
		let tmpInputId = 'us-renameset-name';
		let tmpSelf = this;
		tmpModal.show({
			title: 'Rename set',
			content: '<div class="cst-tenant-form"><label for="' + tmpInputId + '">Name</label><input id="' + tmpInputId + '" type="text" value="' + _escapeHTML((tmpSet && tmpSet.Name) || '') + '"/></div>',
			buttons: [{ Hash: 'save', Label: 'Save', Style: 'primary' }, { Hash: 'cancel', Label: 'Cancel' }],
			closeable: true,
			onOpen: () => { let tmpEl = document.getElementById(tmpInputId); if (tmpEl) { tmpEl.focus(); tmpEl.select(); } }
		}).then((pHash) =>
		{
			if (pHash !== 'save') { return; }
			let tmpName = ((document.getElementById(tmpInputId) || {}).value || '').trim();
			if (!tmpName || !tmpSelf.pict.providers.StickerSetAPI) { return; }
			tmpSelf.pict.providers.StickerSetAPI.renameSet(pId, tmpName).then(() => tmpSelf._loadStickerSets()).catch(() => {});
		});
	}

	removeStickerSet(pId)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpSelf = this;
		let fDo = () => tmpSelf.pict.providers.StickerSetAPI.deleteSet(pId).then(() =>
		{
			if (tmpSelf.pict.AppData.StickerSettings.ActiveSetId === pId) { tmpSelf.pict.AppData.StickerSettings.ActiveSetId = 0; }
			tmpSelf._loadStickerSets();
		}).catch(() => {});
		if (!tmpModal || typeof tmpModal.confirm !== 'function') { return fDo(); }
		tmpModal.confirm('Delete this sticker set? Boards already using its stickers keep them; the set just stops being offered.',
			{ title: 'Delete set?', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true })
			.then((pOk) => { if (pOk) { fDo(); } });
	}

	addLibraryToSet()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || !(this.pict.AppData.StickerSettings || {}).ActiveSetId) { return; }
		let tmpSelf = this;
		tmpModal.show({
			title: 'Add from the library',
			content: '<div class="cst-libpick"><input id="us-libpick-q" class="cst-set-input" placeholder="Search thousands of stickers..." oninput="_Pict.views[\'Plansheet-UserSettings\']._libpickSearch(this.value)"><div id="us-libpick-grid" class="cst-sticker-grid" style="margin-top:10px;max-height:340px;overflow:auto;"></div></div>',
			buttons: [{ Hash: 'done', Label: 'Done', Style: 'primary' }],
			closeable: true,
			width: '520px',
			onOpen: () => { tmpSelf._libpickSearch(''); let tmpEl = document.getElementById('us-libpick-q'); if (tmpEl) { tmpEl.focus(); } }
		});
	}

	_libpickSearch(pQuery)
	{
		let tmpShapes = this.pict.providers.ShapesAPI;
		let tmpGrid = (typeof document !== 'undefined') ? document.getElementById('us-libpick-grid') : null;
		if (!tmpGrid || !tmpShapes) { return; }
		let tmpQ = String(pQuery || '').trim();
		if (tmpQ.length < 2) { tmpGrid.innerHTML = '<div class="cst-set-placeholder">Type to search the library.</div>'; return; }
		tmpShapes.search(tmpQ, '', 48).then((pRows) =>
		{
			let tmpEl = document.getElementById('us-libpick-grid');
			if (!tmpEl) { return; }
			tmpEl.innerHTML = (Array.isArray(pRows) && pRows.length)
				? pRows.map((pRow) => `<button class="cst-sticker-tile cst-tile-pick" title="${_escapeHTML(pRow.Title || pRow.Name)}" onclick="_Pict.views['Plansheet-UserSettings'].pickLibraryItem('${pRow.Collection}','${pRow.Name}','${_escapeHTML(pRow.Title || pRow.Name)}')"><img src="${tmpShapes.shapeURL(pRow.Collection, pRow.Name)}" alt=""><span class="cst-sticker-name">${_escapeHTML(pRow.Title || pRow.Name)}</span></button>`).join('')
				: '<div class="cst-set-placeholder">No matches.</div>';
		}).catch(() => {});
	}

	pickLibraryItem(pCollection, pName, pTitle) { this._addItemToActiveSet({ Collection: pCollection, Name: pName, Title: pTitle }); }

	addUploadToSet(pIDSticker)
	{
		let tmpRow = ((this.pict.AppData.StickerSettings || {}).Custom || []).find((pCandidate) => pCandidate.IDSticker === pIDSticker);
		this._addItemToActiveSet({ IDSticker: pIDSticker, Name: (tmpRow && tmpRow.Name) || ('Sticker ' + pIDSticker) });
	}

	_addItemToActiveSet(pItem)
	{
		let tmpStore = this.pict.AppData.StickerSettings || {};
		let tmpSet = ((tmpStore.Sets && tmpStore.Sets.Custom) || []).find((pCandidate) => pCandidate.IDStickerSet === tmpStore.ActiveSetId);
		if (!tmpSet || !this.pict.providers.StickerSetAPI) { return; }
		let tmpItems = (tmpSet.Items || []).concat([pItem]);
		let tmpSelf = this;
		this.pict.providers.StickerSetAPI.saveItems(tmpSet.IDStickerSet, tmpItems).then(() => tmpSelf._loadStickerSets()).catch(() => {});
	}

	removeSetItem(pIndex)
	{
		let tmpStore = this.pict.AppData.StickerSettings || {};
		let tmpSet = ((tmpStore.Sets && tmpStore.Sets.Custom) || []).find((pCandidate) => pCandidate.IDStickerSet === tmpStore.ActiveSetId);
		if (!tmpSet || !this.pict.providers.StickerSetAPI) { return; }
		let tmpItems = (tmpSet.Items || []).slice();
		tmpItems.splice(pIndex, 1);
		let tmpSelf = this;
		this.pict.providers.StickerSetAPI.saveItems(tmpSet.IDStickerSet, tmpItems).then(() => tmpSelf._loadStickerSets()).catch(() => {});
	}

	_loadStickers()
	{
		let tmpAPI = this.pict.providers.StickerAPI;
		this.pict.AppData.StickerSettings = this.pict.AppData.StickerSettings || { Custom: [], Loaded: false };
		this._loadStickerSets();
		let tmpSelf = this;
		let fDone = () =>
		{
			tmpSelf.pict.AppData.StickerSettings.Loaded = true;
			if (tmpSelf._activeSection === 'stickers') { tmpSelf._setContent(tmpSelf._section_stickers()); }
		};
		if (!tmpAPI) { return fDone(); }
		tmpAPI.listLibrary().then((pRows) =>
		{
			let tmpCustom = (Array.isArray(pRows) ? pRows : []).filter((pRow) => !pRow.IsBuiltIn);
			tmpSelf.pict.AppData.StickerSettings = { Custom: tmpCustom, Loaded: true };
			if (tmpSelf._activeSection === 'stickers') { tmpSelf._setContent(tmpSelf._section_stickers()); }
		}).catch(() => fDone());
	}

	uploadStickers(pFileList)
	{
		let tmpAPI = this.pict.providers.StickerAPI;
		if (!tmpAPI || !pFileList || !pFileList.length) { return; }
		let tmpFiles = Array.prototype.slice.call(pFileList).filter((pFile) => pFile && (pFile.type === 'image/png' || pFile.type === 'image/svg+xml'));
		if (!tmpFiles.length) { this._msg('us-sticker-msg', 'Only PNG or SVG stickers are allowed.', 'err'); return; }
		this._msg('us-sticker-msg', 'Uploading ' + tmpFiles.length + ' sticker' + (tmpFiles.length > 1 ? 's' : '') + '...', '');
		let tmpSelf = this;
		Promise.all(tmpFiles.map((pFile) => tmpAPI.upload(pFile, { MimeType: pFile.type }).then(() => true).catch(() => false)))
			.then((pResults) =>
			{
				let tmpOk = pResults.filter(Boolean).length;
				tmpSelf._msg('us-sticker-msg', tmpOk + ' uploaded.' + (tmpOk < tmpFiles.length ? ' Some failed.' : ''), tmpOk ? 'ok' : 'err');
				tmpSelf._loadStickers();
			});
	}

	deleteSticker(pIDSticker)
	{
		let tmpAPI = this.pict.providers.StickerAPI;
		if (!tmpAPI) { return; }
		let tmpStore = this.pict.AppData.StickerSettings || { Custom: [] };
		let tmpRow = (tmpStore.Custom || []).find((pCandidate) => pCandidate.IDSticker === pIDSticker);
		let tmpName = (tmpRow && tmpRow.Name) || ('#' + pIDSticker);
		let tmpSelf = this;
		let fDelete = () => tmpAPI.remove(pIDSticker).then(() => tmpSelf._loadStickers());
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return fDelete(); }
		tmpModal.confirm('Remove sticker "' + tmpName + '"? Boards already using it keep their copy.',
			{ title: 'Remove sticker?', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
			.then((pOk) => { if (pOk) { fDelete(); } });
	}

	// ── Board Lanes (admin-managed Kanban lanes) ─────────────────────────────
	_section_lanes()
	{
		if (!this._lanesLoaded) { return this._loadingSection('Board Lanes'); }
		let tmpLanes = this._lanes || [];
		let tmpRows = tmpLanes.map((pLane) => this._laneRowHTML(pLane)).join('') ||
			'<div class="cst-set-placeholder">No lanes yet. Add one below.</div>';
		return `
<div class="cst-set-section cst-set-section-wide">
	<h2 class="cst-set-h">Board Lanes</h2>
	<p class="cst-set-sub">The columns on your <a href="#/board">board</a>. Rename, recolor, drag to reorder, and add or remove lanes. Mark the lane that means "done" as the Done lane. A lane that still holds cards cannot be removed until you move them.</p>
	<div id="us-lane-list" class="cst-lane-list">${tmpRows}</div>
	<div class="cst-lane-add">
		<input id="us-lane-new" class="cst-set-input" type="text" maxlength="128" placeholder="New lane name" onkeydown="if(event.key==='Enter'){_Pict.views['Plansheet-UserSettings'].addLane();}"/>
		<button class="cst-set-btn" onclick="_Pict.views['Plansheet-UserSettings'].addLane()">Add lane</button>
		<span id="us-lane-msg" class="cst-set-msg"></span>
	</div>
</div>`;
	}

	_laneRowHTML(pLane)
	{
		let tmpID = pLane.IDBoardLane;
		let tmpColor = pLane.Color || '#8a94a6';
		let tmpView = "_Pict.views['Plansheet-UserSettings']";
		return `
	<div class="cst-lane-row" draggable="true" data-lane-id="${tmpID}"
		ondragstart="${tmpView}.laneDragStart(event)" ondragend="${tmpView}.laneDragEnd(event)"
		ondragover="${tmpView}.laneDragOver(event)" ondrop="${tmpView}.laneDrop(event)">
		<span class="cst-lane-grip" title="Drag to reorder">::</span>
		<input class="cst-lane-color" type="color" value="${_escapeHTML(tmpColor)}" title="Lane color"
			onchange="${tmpView}.recolorLane(${tmpID}, this.value)"/>
		<input class="cst-set-input cst-lane-label" type="text" maxlength="128" value="${_escapeHTML(pLane.Label || '')}"
			onchange="${tmpView}.renameLane(${tmpID}, this.value)"/>
		<label class="cst-lane-terminal" title="The Done-equivalent lane">
			<input type="checkbox" ${pLane.IsTerminal ? 'checked' : ''} onchange="${tmpView}.setLaneTerminal(${tmpID}, this.checked)"/> Done lane
		</label>
		<button class="cst-lane-del" title="Remove lane" onclick="${tmpView}.removeLane(${tmpID})">Remove</button>
	</div>`;
	}

	_laneMsg(pText, pKind) { this._msg('us-lane-msg', pText, pKind); }

	// Find the lane object the settings view holds by id (kept in step with in-place edits).
	_laneByID(pID)
	{
		let tmpID = parseInt(pID, 10) || 0;
		return (this._lanes || []).find((pLane) => pLane.IDBoardLane === tmpID) || null;
	}

	_loadLanes()
	{
		let tmpAPI = this.pict.providers.LaneAPI;
		if (!tmpAPI) { this._lanesLoaded = true; this._lanes = []; return; }
		let tmpSelf = this;
		tmpAPI.listLanes().then((pLanes) =>
		{
			tmpSelf._lanes = Array.isArray(pLanes) ? pLanes : [];
			tmpSelf._lanesLoaded = true;
			if (tmpSelf._activeSection === 'lanes') { tmpSelf._setContent(tmpSelf._section_lanes()); }
		}).catch(() =>
		{
			tmpSelf._lanesLoaded = true;
			if (tmpSelf._activeSection === 'lanes') { tmpSelf._setContent(tmpSelf._section_lanes()); }
		});
	}

	// Re-fetch and re-render the whole section (used after a change that reshapes the list).
	_reloadLanes()
	{
		this._lanesLoaded = false;
		this._loadLanes();
	}

	addLane()
	{
		let tmpAPI = this.pict.providers.LaneAPI;
		if (!tmpAPI) { return; }
		let tmpInput = (typeof document !== 'undefined') ? document.getElementById('us-lane-new') : null;
		let tmpName = tmpInput ? String(tmpInput.value || '').trim() : '';
		if (!tmpName) { this._laneMsg('Type a lane name first.', 'err'); return; }
		this._laneMsg('Adding...', '');
		let tmpSelf = this;
		tmpAPI.createLane(tmpName, '', false)
			.then(() => { if (tmpInput) { tmpInput.value = ''; } tmpSelf._reloadLanes(); tmpSelf._laneMsg('Lane added.', 'ok'); })
			.catch((pErr) => tmpSelf._laneMsg(pErr.message || 'Could not add the lane.', 'err'));
	}

	renameLane(pID, pValue)
	{
		let tmpAPI = this.pict.providers.LaneAPI;
		let tmpLane = this._laneByID(pID);
		let tmpValue = String(pValue == null ? '' : pValue).trim();
		if (!tmpAPI || !tmpLane) { return; }
		if (!tmpValue) { this._laneMsg('A lane needs a name.', 'err'); return; }
		let tmpSelf = this;
		tmpAPI.updateLane(pID, { Label: tmpValue })
			.then((pJSON) => { if (pJSON && pJSON.Lane) { tmpLane.Label = pJSON.Lane.Label; } tmpSelf._laneMsg('Renamed.', 'ok'); })
			.catch((pErr) => tmpSelf._laneMsg(pErr.message || 'Could not rename.', 'err'));
	}

	recolorLane(pID, pValue)
	{
		let tmpAPI = this.pict.providers.LaneAPI;
		let tmpLane = this._laneByID(pID);
		if (!tmpAPI || !tmpLane) { return; }
		let tmpSelf = this;
		tmpAPI.updateLane(pID, { Color: String(pValue || '') })
			.then((pJSON) => { if (pJSON && pJSON.Lane) { tmpLane.Color = pJSON.Lane.Color; } tmpSelf._laneMsg('Color saved.', 'ok'); })
			.catch((pErr) => tmpSelf._laneMsg(pErr.message || 'Could not recolor.', 'err'));
	}

	setLaneTerminal(pID, pChecked)
	{
		let tmpAPI = this.pict.providers.LaneAPI;
		let tmpLane = this._laneByID(pID);
		if (!tmpAPI || !tmpLane) { return; }
		let tmpSelf = this;
		tmpAPI.updateLane(pID, { IsTerminal: !!pChecked })
			.then((pJSON) => { if (pJSON && pJSON.Lane) { tmpLane.IsTerminal = pJSON.Lane.IsTerminal; } tmpSelf._laneMsg('Saved.', 'ok'); })
			.catch((pErr) =>
			{
				// Refused (e.g. clearing the last Done lane): revert the checkbox to the stored state.
				tmpSelf._laneMsg(pErr.message || 'Could not save.', 'err');
				tmpSelf._reloadLanes();
			});
	}

	removeLane(pID)
	{
		let tmpAPI = this.pict.providers.LaneAPI;
		let tmpLane = this._laneByID(pID);
		if (!tmpAPI || !tmpLane) { return; }
		let tmpSelf = this;
		let fDelete = () => tmpAPI.deleteLane(pID)
			.then(() => { tmpSelf._reloadLanes(); })
			.catch((pErr) => tmpSelf._laneMsg(pErr.message || 'Could not remove the lane.', 'err'));
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.confirm !== 'function') { return fDelete(); }
		tmpModal.confirm('Remove the "' + (tmpLane.Label || '') + '" lane?',
			{ title: 'Remove lane?', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
			.then((pOk) => { if (pOk) { fDelete(); } });
	}

	// ── lane drag-to-reorder (in-place, no full re-render, preserves scroll) ──
	// Mirrors the board's card drag: the dragged row is physically moved in the DOM
	// during dragover; on dragend the new DOM order is read and persisted.
	laneDragStart(pEvent)
	{
		let tmpRow = pEvent && pEvent.currentTarget;
		if (tmpRow && tmpRow.classList) { tmpRow.classList.add('is-dragging'); }
		if (pEvent && pEvent.dataTransfer)
		{
			pEvent.dataTransfer.effectAllowed = 'move';
			try { pEvent.dataTransfer.setData('text/plain', tmpRow ? (tmpRow.getAttribute('data-lane-id') || '') : ''); } catch (pErr) { /* ignore */ }
		}
	}

	laneDragOver(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
		if (typeof document === 'undefined') { return; }
		let tmpList = document.getElementById('us-lane-list');
		if (!tmpList) { return; }
		let tmpDragging = tmpList.querySelector('.cst-lane-row.is-dragging');
		if (!tmpDragging) { return; }
		let tmpAfter = this._laneAfterElement(tmpList, pEvent.clientY);
		if (tmpAfter == null) { tmpList.appendChild(tmpDragging); }
		else if (tmpAfter !== tmpDragging) { tmpList.insertBefore(tmpDragging, tmpAfter); }
	}

	laneDrop(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function') { pEvent.preventDefault(); }
	}

	laneDragEnd(pEvent)
	{
		let tmpRow = pEvent && pEvent.currentTarget;
		if (tmpRow && tmpRow.classList) { tmpRow.classList.remove('is-dragging'); }
		this._persistLaneOrder();
	}

	// The row the cursor sits above (the dragged element goes before it), or null for the end.
	_laneAfterElement(pList, pY)
	{
		let tmpRows = Array.prototype.slice.call(pList.querySelectorAll('.cst-lane-row:not(.is-dragging)'));
		let tmpClosest = { Offset: -Infinity, Element: null };
		for (let i = 0; i < tmpRows.length; i++)
		{
			let tmpBox = tmpRows[i].getBoundingClientRect();
			let tmpOffset = pY - tmpBox.top - (tmpBox.height / 2);
			if (tmpOffset < 0 && tmpOffset > tmpClosest.Offset) { tmpClosest = { Offset: tmpOffset, Element: tmpRows[i] }; }
		}
		return tmpClosest.Element;
	}

	// Read the current DOM row order and, if it changed, persist it (sparse SortOrder server-side).
	_persistLaneOrder()
	{
		if (typeof document === 'undefined') { return; }
		let tmpList = document.getElementById('us-lane-list');
		let tmpAPI = this.pict.providers.LaneAPI;
		if (!tmpList || !tmpAPI) { return; }
		let tmpRows = Array.prototype.slice.call(tmpList.querySelectorAll('.cst-lane-row'));
		let tmpOrder = tmpRows.map((pRow) => parseInt(pRow.getAttribute('data-lane-id'), 10) || 0).filter((pID) => pID);
		let tmpCurrent = (this._lanes || []).map((pLane) => pLane.IDBoardLane);
		if (tmpOrder.length === tmpCurrent.length && tmpOrder.every((pID, pIdx) => pID === tmpCurrent[pIdx])) { return; }
		// Reorder the in-memory list to match the DOM so a later edit maps to the right lane.
		let tmpByID = {};
		(this._lanes || []).forEach((pLane) => { tmpByID[pLane.IDBoardLane] = pLane; });
		this._lanes = tmpOrder.map((pID) => tmpByID[pID]).filter(Boolean);
		let tmpSelf = this;
		this._laneMsg('Saving order...', '');
		tmpAPI.reorderLanes(tmpOrder)
			.then((pJSON) => { if (pJSON && Array.isArray(pJSON.Lanes)) { tmpSelf._lanes = pJSON.Lanes; } tmpSelf._laneMsg('Order saved.', 'ok'); })
			.catch((pErr) => { tmpSelf._laneMsg(pErr.message || 'Could not save the order.', 'err'); tmpSelf._reloadLanes(); });
	}

	// ── Message Templates (org email/SMS) ────────────────────────────────────
	_section_messages()
	{
		if (!this._messagesLoaded) { return this._loadingSection('Message Templates'); }
		let tmpList = this._messages || [];
		if (!tmpList.length)
		{
			return '<div class="cst-set-section"><h2 class="cst-set-h">Message Templates</h2><p class="cst-set-sub">No message templates are available.</p></div>';
		}
		let tmpSel = Math.min(this._messagesSelected || 0, tmpList.length - 1);
		let tmpT = tmpList[tmpSel];
		let tmpOverride = tmpT.Override || null;
		let tmpSubject = tmpOverride ? (tmpOverride.Subject || '') : '';
		let tmpBody = tmpOverride ? (tmpOverride.BodyText || '') : '';
		let tmpEnabled = tmpOverride ? !!tmpOverride.Enabled : true;
		let tmpIsEmail = (tmpT.Channel !== 'sms');
		let tmpSelf = "_Pict.views['Plansheet-UserSettings']";
		let tmpOptions = tmpList.map((pT, pI) => `<option value="${pI}"${pI === tmpSel ? ' selected' : ''}>${_escapeHTML(pT.Label)}${pT.Channel === 'sms' ? ' (text)' : ''}</option>`).join('');
		let tmpVars = (tmpT.Variables || []).map((pV) => `<button type="button" class="msg-var" title="${_escapeHTML(pV.Label)}" onclick="${tmpSelf}.insertVar('${pV.Name}')">{{${pV.Name}}}</button>`).join(' ');
		let tmpSubjectField = tmpIsEmail ? `
	<label class="cst-set-field"><span>Subject</span>
		<input id="msg-subject" class="cst-set-input" onfocus="${tmpSelf}._msgFocus='msg-subject'" oninput="${tmpSelf}.previewMessage()" value="${_escapeHTML(tmpSubject)}" placeholder="${_escapeHTML(tmpT.Default.Subject || '')}"/>
	</label>` : '';
		return `
<div class="cst-set-section">
	<h2 class="cst-set-h">Message Templates</h2>
	<p class="cst-set-sub">The email and text messages your organization sends. Each works from a built-in default; edit one to override it. With no provider configured, sends go to a dev log instead of a real inbox.</p>
	<label class="cst-set-field"><span>Message</span>
		<select id="msg-select" class="cst-set-input" onchange="${tmpSelf}.selectMessage(this.value)">${tmpOptions}</select>
	</label>
	<div class="msg-vars">Variables: ${tmpVars}</div>
	${tmpSubjectField}
	<label class="cst-set-field"><span>${tmpIsEmail ? 'Body' : 'Message'}</span>
		<textarea id="msg-body" class="cst-set-input msg-body" rows="6" onfocus="${tmpSelf}._msgFocus='msg-body'" oninput="${tmpSelf}.previewMessage()" placeholder="${_escapeHTML(tmpT.Default.BodyText || '')}">${_escapeHTML(tmpBody)}</textarea>
	</label>
	<label class="cst-set-check"><input type="checkbox" id="msg-enabled"${tmpEnabled ? ' checked' : ''}/> <span>Send this message (uncheck to turn it off for everyone in your org)</span></label>
	<div class="msg-preview" id="msg-preview"></div>
	<div class="cst-set-actions">
		<button class="cst-set-btn" onclick="${tmpSelf}.saveMessage()">Save</button>
		<button class="cst-set-btn cst-set-btn-secondary" onclick="${tmpSelf}.resetMessage()">Use default</button>
		<span id="msg-msg" class="cst-set-msg"></span>
	</div>
	<div class="msg-test">
		<label class="cst-set-field"><span>Send a test to</span>
			<input id="msg-test-to" class="cst-set-input" placeholder="${tmpIsEmail ? 'you@example.com' : '+1 555 0100'}"/>
		</label>
		<div class="cst-set-actions"><button class="cst-set-btn cst-set-btn-secondary" onclick="${tmpSelf}.sendTestMessage()">Send test</button><span id="msg-test-msg" class="cst-set-msg"></span></div>
	</div>
</div>`;
	}

	_loadMessages()
	{
		let tmpAPI = this.pict.providers.MessageAPI;
		if (!tmpAPI) { return; }
		let fRender = () => { if (this._activeSection === 'messages') { this._setContent(this._section_messages()); this.previewMessage(); } };
		tmpAPI.getTemplates().then((pRows) =>
		{
			this._messages = Array.isArray(pRows) ? pRows : [];
			// A template named in the URL wins over the remembered position.
			if (this._pendingMessageKey)
			{
				let tmpAt = this._messages.findIndex((pRow) => String(pRow.Key) === this._pendingMessageKey);
				if (tmpAt >= 0) { this._messagesSelected = tmpAt; }
				this._pendingMessageKey = '';
			}
			this._messagesLoaded = true;
			if (this._messagesSelected == null) { this._messagesSelected = 0; }
			fRender();
		}).catch(() => { this._messages = []; this._messagesLoaded = true; fRender(); });
	}

	_currentMessage()
	{
		let tmpList = this._messages || [];
		return tmpList[Math.min(this._messagesSelected || 0, tmpList.length - 1)] || null;
	}

	selectMessage(pIndex)
	{
		let tmpIndex = parseInt(pIndex, 10) || 0;
		let tmpTemplate = (this._messages || [])[tmpIndex];
		let tmpApp = this.pict.PictApplication;
		if (tmpTemplate && tmpTemplate.Key && tmpApp && typeof tmpApp.showSettingsSub === 'function'
			&& tmpApp.showSettingsSub('messages', encodeURIComponent(tmpTemplate.Key))) { return; }
		this._applySelectMessage(tmpIndex);
	}

	_applySelectMessage(pIndex)
	{
		this._messagesSelected = parseInt(pIndex, 10) || 0;
		this._setContent(this._section_messages());
		this.previewMessage();
	}

	insertVar(pName)
	{
		if (typeof document === 'undefined') { return; }
		let tmpFieldId = (this._msgFocus === 'msg-subject') ? 'msg-subject' : 'msg-body';
		let tmpEl = document.getElementById(tmpFieldId);
		if (!tmpEl) { return; }
		let tmpToken = '{{' + pName + '}}';
		let tmpStart = (typeof tmpEl.selectionStart === 'number') ? tmpEl.selectionStart : tmpEl.value.length;
		let tmpEnd = (typeof tmpEl.selectionEnd === 'number') ? tmpEl.selectionEnd : tmpEl.value.length;
		tmpEl.value = tmpEl.value.slice(0, tmpStart) + tmpToken + tmpEl.value.slice(tmpEnd);
		let tmpCaret = tmpStart + tmpToken.length;
		try { tmpEl.focus(); tmpEl.setSelectionRange(tmpCaret, tmpCaret); } catch (pErr) { /* ignore */ }
		this.previewMessage();
	}

	_readMessageInputs()
	{
		let fVal = (pId) => { let tmpEl = document.getElementById(pId); return tmpEl ? tmpEl.value : ''; };
		let fChecked = (pId) => { let tmpEl = document.getElementById(pId); return tmpEl ? !!tmpEl.checked : true; };
		return { Subject: fVal('msg-subject'), BodyText: fVal('msg-body'), Enabled: fChecked('msg-enabled') };
	}

	previewMessage()
	{
		if (typeof document === 'undefined') { return; }
		let tmpMessage = this._currentMessage();
		let tmpAPI = this.pict.providers.MessageAPI;
		if (!tmpMessage || !tmpAPI) { return; }
		let tmpInputs = this._readMessageInputs();
		if (this._msgPreviewTimer) { clearTimeout(this._msgPreviewTimer); }
		this._msgPreviewTimer = setTimeout(() =>
		{
			tmpAPI.previewTemplate(tmpMessage.Key, { Channel: tmpMessage.Channel, Subject: tmpInputs.Subject, BodyText: tmpInputs.BodyText })
				.then((pBody) =>
				{
					let tmpEl = document.getElementById('msg-preview');
					if (!tmpEl) { return; }
					let tmpSubjectLine = (tmpMessage.Channel !== 'sms') ? `<div class="msg-preview-subject">${_escapeHTML(pBody.Subject || '')}</div>` : '';
					let tmpBodyHTML = (tmpMessage.Channel !== 'sms' && pBody.BodyHTML) ? pBody.BodyHTML : _escapeHTML(pBody.BodyText || '').replace(/\n/g, '<br>');
					tmpEl.innerHTML = `<div class="msg-preview-label">Preview (sample data)</div>${tmpSubjectLine}<div class="msg-preview-body">${tmpBodyHTML}</div>`;
				}).catch(() => {});
		}, 250);
	}

	saveMessage()
	{
		let tmpMessage = this._currentMessage();
		let tmpAPI = this.pict.providers.MessageAPI;
		if (!tmpMessage || !tmpAPI) { return; }
		let tmpInputs = this._readMessageInputs();
		this._msg('msg-msg', 'Saving...', '');
		tmpAPI.saveTemplate(tmpMessage.Key, { Channel: tmpMessage.Channel, Subject: tmpInputs.Subject, BodyText: tmpInputs.BodyText, Enabled: tmpInputs.Enabled })
			.then(() => tmpAPI.getTemplates())
			.then((pRows) => { this._messages = Array.isArray(pRows) ? pRows : this._messages; this._setContent(this._section_messages()); this._msg('msg-msg', 'Saved.', 'ok'); this.previewMessage(); })
			.catch((pErr) => this._msg('msg-msg', pErr.message || 'Could not save.', 'err'));
	}

	resetMessage()
	{
		let tmpMessage = this._currentMessage();
		let tmpAPI = this.pict.providers.MessageAPI;
		if (!tmpMessage || !tmpAPI) { return; }
		this._msg('msg-msg', 'Restoring the default...', '');
		tmpAPI.saveTemplate(tmpMessage.Key, { Channel: tmpMessage.Channel, Subject: '', BodyText: '', BodyHTML: '', Enabled: true })
			.then(() => tmpAPI.getTemplates())
			.then((pRows) => { this._messages = Array.isArray(pRows) ? pRows : this._messages; this._setContent(this._section_messages()); this._msg('msg-msg', 'Using the default.', 'ok'); this.previewMessage(); })
			.catch((pErr) => this._msg('msg-msg', pErr.message || 'Could not reset.', 'err'));
	}

	sendTestMessage()
	{
		let tmpMessage = this._currentMessage();
		let tmpAPI = this.pict.providers.MessageAPI;
		if (!tmpMessage || !tmpAPI) { return; }
		let tmpEl = document.getElementById('msg-test-to');
		let tmpTo = tmpEl ? tmpEl.value.trim() : '';
		if (!tmpTo) { this._msg('msg-test-msg', 'Enter a destination first.', 'err'); return; }
		this._msg('msg-test-msg', 'Sending...', '');
		tmpAPI.testSend(tmpMessage.Key, tmpMessage.Channel, tmpTo)
			.then((pBody) => this._msg('msg-test-msg', pBody.Skipped ? 'This message is turned off.' : 'Sent (it goes to the dev log unless a provider is configured).', 'ok'))
			.catch((pErr) => this._msg('msg-test-msg', pErr.message || 'Could not send.', 'err'));
	}

	// ── section switching ────────────────────────────────────────────────────
	showSection(pSection)
	{
		// Drafting Kit carries an optional kit id in a sub-path: 'draftingkit/<id>' opens that kit's editor.
		let tmpRaw = String(pSection || '');
		let tmpSlash = tmpRaw.indexOf('/');
		let tmpBase = (tmpSlash >= 0) ? tmpRaw.slice(0, tmpSlash) : tmpRaw;
		let tmpSection = (tmpBase && _KNOWN_SECTIONS[tmpBase]) ? tmpBase : 'profile';
		let tmpSub = (tmpSlash >= 0) ? tmpRaw.slice(tmpSlash + 1) : '';
		this._editingKitID = (tmpSection === 'draftingkit' && tmpSub) ? (parseInt(tmpSub, 10) || 0) : 0;
		// Stickers and Message Templates carry a sub-path too, so the pane you are actually working in
		// can be linked and reloaded into rather than always reopening on the placeholder / first row.
		if (tmpSection === 'stickers' && tmpSub)
		{
			this.pict.AppData.StickerSettings = this.pict.AppData.StickerSettings || {};
			this.pict.AppData.StickerSettings.ActiveSetId = parseInt(tmpSub, 10) || 0;
		}
		// By KEY, not by position: the templates are a server-defined list, and a link that silently
		// opened a DIFFERENT template after a reorder would be worse than no link at all.
		this._pendingMessageKey = (tmpSection === 'messages' && tmpSub) ? decodeURIComponent(tmpSub) : '';
		this._activeSection = tmpSection;
		let tmpNav = this.pict.providers['Pict-Navigation'];
		if (tmpNav)
		{
			tmpNav.setActiveByRoute('#/settings/' + tmpSection);
			let tmpDocked = this.pict.views['Navigation-Sidebar-Docked'];
			if (tmpDocked && typeof tmpDocked.syncActive === 'function') { tmpDocked.syncActive(); }
		}
		let tmpBuilder = this['_section_' + tmpSection];
		let tmpHTML = (typeof tmpBuilder === 'function') ? tmpBuilder.call(this) : '<div class="cst-set-section">Not found.</div>';
		if (typeof document !== 'undefined')
		{
			let tmpEl = document.getElementById('Settings-Content');
			if (tmpEl) { tmpEl.innerHTML = tmpHTML; }
		}
		if (tmpSection === 'tokens') { this._loadTokensOnce(); this._mountAgentPicker(); }
		if (tmpSection === 'about') { this._mountAboutEditor(); }
		if (tmpSection === 'appearance') { this._mountAppearance(); }
		if (tmpSection === 'team') { this._loadTeam(); }
		if (tmpSection === 'roles') { this._loadRoles(); }
		if (tmpSection === 'org') { this._loadOrg(); }
		if (tmpSection === 'topbar') { this._loadTopBar(); }
		if (tmpSection === 'docsync') { this._loadDocSync(); }
		if (tmpSection === 'draftingkit') { this._loadDraftingKit(); }
		if (tmpSection === 'messages') { this._loadMessages(); }
		if (tmpSection === 'stickers') { this._loadStickers(); }
		if (tmpSection === 'lanes') { this._loadLanes(); }
		if (tmpSection === 'account') { this._loadTwoFactor(); }
		if (tmpSection === 'notifications') { this._loadNotifications(); }
		if (tmpSection === 'connections') { this._loadConnectClaudeGuide(); }
		if (tmpSection === 'plansheets') { this._plansheetsLoaded = false; this._loadPlansheets(); }
	}

	// ── handlers: profile / account ──────────────────────────────────────────
	saveProfile()
	{
		let tmpGet = (pId) => (typeof document !== 'undefined') ? (document.getElementById(pId) || {}).value : '';
		let tmpPatch = { DisplayName: tmpGet('us-DisplayName'), Title: tmpGet('us-Title'), Color: tmpGet('us-Color') };
		this._msg('us-profile-msg', 'Saving...', '');
		this.pict.providers.UserAPI.updateMe(tmpPatch).then(() =>
		{
			this._msg('us-profile-msg', 'Saved.', 'ok');
			this._syncAuthUser();
		}).catch((pErr) => this._msg('us-profile-msg', pErr.message || 'Could not save.', 'err'));
	}

	saveEmail()
	{
		let tmpEmail = (typeof document !== 'undefined') ? (document.getElementById('us-Email') || {}).value : '';
		this._msg('us-email-msg', 'Saving...', '');
		this.pict.providers.UserAPI.changeEmail(tmpEmail).then(() =>
		{
			this._msg('us-email-msg', 'Email updated.', 'ok');
			this._syncAuthUser();
		}).catch((pErr) => this._msg('us-email-msg', pErr.message || 'Could not update.', 'err'));
	}

	savePassword()
	{
		let tmpGet = (pId) => (typeof document !== 'undefined') ? (document.getElementById(pId) || {}).value : '';
		this._msg('us-pw-msg', 'Saving...', '');
		this.pict.providers.UserAPI.changePassword(tmpGet('us-PwCurrent'), tmpGet('us-PwNew')).then(() =>
		{
			this._msg('us-pw-msg', 'Password changed.', 'ok');
			if (typeof document !== 'undefined')
			{
				['us-PwCurrent', 'us-PwNew'].forEach((pId) => { let e = document.getElementById(pId); if (e) { e.value = ''; } });
			}
		}).catch((pErr) => this._msg('us-pw-msg', pErr.message || 'Could not change.', 'err'));
	}

	_msg(pId, pText, pKind)
	{
		if (typeof document === 'undefined') { return; }
		let tmpEl = document.getElementById(pId);
		if (!tmpEl) { return; }
		tmpEl.textContent = pText;
		tmpEl.className = 'cst-set-msg' + (pKind ? ' cst-set-msg-' + pKind : '');
	}

	// Keep the topbar name + AppData.Auth.User in step after a self edit.
	_syncAuthUser()
	{
		let tmpP = this._profile();
		if (this.pict.AppData.Auth && this.pict.AppData.Auth.User && tmpP)
		{
			this.pict.AppData.Auth.User.DisplayName = tmpP.DisplayName || this.pict.AppData.Auth.User.DisplayName;
			this.pict.AppData.Auth.User.Email = tmpP.Email || this.pict.AppData.Auth.User.Email;
			this.pict.AppData.Auth.User.Title = tmpP.Title;
			this.pict.AppData.Auth.User.Color = tmpP.Color;
		}
		let tmpTopBar = this.pict.views['Plansheet-TopBar-User'];
		if (tmpTopBar && typeof tmpTopBar.render === 'function') { tmpTopBar.render(); }
	}

	// ── handlers: profile photo ──────────────────────────────────────────────
	pickPhoto()
	{
		if (typeof document === 'undefined') { return; }
		let tmpInput = document.getElementById('us-photo-input');
		if (tmpInput) { tmpInput.click(); }
	}

	onPhotoPicked(pInput)
	{
		let tmpFile = pInput && pInput.files && pInput.files[0];
		if (!tmpFile) { return; }
		if (tmpFile.size > 8 * 1024 * 1024)
		{
			this._msg('us-photo-msg', 'That image is larger than 8 MB.', 'err');
			pInput.value = '';
			return;
		}
		let tmpProvider = this.pict.providers.PhotoAPI;
		if (!tmpProvider) { return; }
		this._msg('us-photo-msg', 'Uploading...', '');
		tmpProvider.uploadPhoto(tmpFile)
			.then((pResult) =>
			{
				this._applyPhotoHash(pResult.PhotoHash);
				this._msg('us-photo-msg', 'Photo updated.', 'ok');
			})
			.catch((pErr) => this._msg('us-photo-msg', pErr.message || 'Upload failed.', 'err'))
			.then(() => { if (pInput) { pInput.value = ''; } });
	}

	removePhoto()
	{
		let tmpProvider = this.pict.providers.PhotoAPI;
		if (!tmpProvider) { return; }
		this._msg('us-photo-msg', 'Removing...', '');
		tmpProvider.deletePhoto()
			.then(() =>
			{
				this._applyPhotoHash('');
				this._msg('us-photo-msg', 'Photo removed.', 'ok');
			})
			.catch((pErr) => this._msg('us-photo-msg', pErr.message || 'Could not remove.', 'err'));
	}

	// Update the cached profile + session, then repaint just the photo block and
	// the topbar avatar (leaving the other profile fields untouched).
	_applyPhotoHash(pHash)
	{
		let tmpP = this._profile();
		if (tmpP) { tmpP.PhotoHash = pHash || ''; }
		if (this.pict.AppData.Auth && this.pict.AppData.Auth.User) { this.pict.AppData.Auth.User.PhotoHash = pHash || ''; }
		if (typeof document !== 'undefined')
		{
			let tmpBlock = document.getElementById('us-photo-block');
			if (tmpBlock) { tmpBlock.innerHTML = this._photoBlockHTML(); }
		}
		let tmpTopBar = this.pict.views['Plansheet-TopBar-User'];
		if (tmpTopBar && typeof tmpTopBar.paintAvatar === 'function') { tmpTopBar.paintAvatar(); }
	}

	// ── tokens (relocated from the gear panel) ───────────────────────────────
	_refreshTokens()
	{
		let tmpStore = this.pict.AppData.APITokens || { List: [] };
		let tmpView = this.pict.AppData.TokenSettings;
		tmpView.Rows = (tmpStore.List || []).map((pRow) =>
		{
			let tmpCreated = _formatDate(pRow.CreateDate);
			return (
			{
				IDUserToken: pRow.IDUserToken,
				Label: _escapeHTML(pRow.Label || ('Token #' + pRow.IDUserToken)),
				CreatedLabel: tmpCreated ? ('Created ' + tmpCreated) : 'Created',
				LastUsedLabel: pRow.LastUsedAt ? (' · Last used ' + _formatDate(pRow.LastUsedAt)) : ' · Never used'
			});
		});
	}

	_loadTokensOnce()
	{
		if (this._tokensRequested) { return; }
		this._tokensRequested = true;
		let tmpProvider = this.pict.providers.TokenAPI;
		if (!tmpProvider) { return; }
		tmpProvider.listTokens().then(() => { if (this._activeSection === 'tokens') { this.showSection('tokens'); } });
	}

	generateToken()
	{
		let tmpProvider = this.pict.providers.TokenAPI;
		if (!tmpProvider) { return; }
		let tmpInput = (typeof document !== 'undefined') ? document.getElementById('us-TokenLabel') : null;
		let tmpLabel = (tmpInput && tmpInput.value) ? tmpInput.value.trim() : '';
		tmpProvider.createToken(tmpLabel).then((pToken) =>
		{
			if (tmpInput) { tmpInput.value = ''; }
			this.showSection('tokens');
			this._showTokenOnce(pToken);
		}).catch((pErr) =>
		{
			let tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal) { tmpModal.show({ title: 'Could not create token', content: '<p>' + _escapeHTML(pErr && pErr.message ? pErr.message : 'Unknown error.') + '</p>', closeable: true, buttons: [{ Hash: 'ok', Label: 'OK', Style: 'primary' }] }); }
		});
	}

	// Mount the account picker (pict-section-picker) for the admin "mint a token for another user" control.
	// Options are the tenant's team members; the chosen IDUser is what mintAgentToken sends. Loads the team
	// once, then mounts. Mirrors the blueprint pickers in PictView-EntityDetail (this.pict.PictApplication.mountPicker).
	_mountAgentPicker()
	{
		let tmpIsAdmin = !!(this.pict.AppData.Auth && this.pict.AppData.Auth.User && this.pict.AppData.Auth.User.IsPlatformAdmin);
		if (!tmpIsAdmin || typeof document === 'undefined' || !document.getElementById('us-agent-picker-host')) { return; }
		let tmpApp = this.pict.PictApplication;
		if (!tmpApp || typeof tmpApp.mountPicker !== 'function') { return; }
		let tmpMembers = (this.pict.AppData.Team && this.pict.AppData.Team.Members) || [];
		if (!tmpMembers.length && this.pict.providers.TeamAPI && !this._agentPickerLoading)
		{
			this._agentPickerLoading = true;
			this.pict.providers.TeamAPI.listMembers().then(() =>
			{
				this._agentPickerLoading = false;
				if (this._activeSection === 'tokens') { this._mountAgentPicker(); }
			});
			return;
		}
		let tmpSelf = this;
		let tmpOptions = tmpMembers.map((pM) => (
		{
			Value: String(pM.IDUser),
			Text: (pM.DisplayName || pM.Email || ('User #' + pM.IDUser)) + (pM.IsAgent ? ' (agent)' : '') + (pM.Email ? ' -- ' + pM.Email : '')
		}));
		tmpApp.mountPicker('#us-agent-picker-host', 'Settings-AgentTokenPicker', tmpOptions,
			function (pVal) { tmpSelf._agentTokenIDUser = parseInt(pVal, 10) || 0; },
			{ Placeholder: 'Select an account', Value: this._agentTokenIDUser ? String(this._agentTokenIDUser) : '' });
	}

	mintAgentToken()
	{
		let tmpProvider = this.pict.providers.TokenAPI;
		if (!tmpProvider) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpIDUser = this._agentTokenIDUser || 0;
		if (!tmpIDUser)
		{
			if (tmpModal) { tmpModal.show({ title: 'Select an account', content: '<p>Choose the account to mint a token for.</p>', closeable: true, buttons: [{ Hash: 'ok', Label: 'OK', Style: 'primary' }] }); }
			return;
		}
		let tmpLabelEl = (typeof document !== 'undefined') ? document.getElementById('us-AgentTokenLabel') : null;
		let tmpLabel = (tmpLabelEl && tmpLabelEl.value) ? tmpLabelEl.value.trim() : '';
		tmpProvider.mintTokenForUser(tmpIDUser, tmpLabel).then((pToken) =>
		{
			this._showTokenOnce(pToken);
		}).catch((pErr) =>
		{
			if (tmpModal) { tmpModal.show({ title: 'Could not mint token', content: '<p>' + _escapeHTML(pErr && pErr.message ? pErr.message : 'Unknown error.') + '</p>', closeable: true, buttons: [{ Hash: 'ok', Label: 'OK', Style: 'primary' }] }); }
		});
	}

	_showTokenOnce(pToken)
	{
		this._lastRevealedToken = pToken || '';
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return; }
		let tmpContent =
			'<div class="cst-token-reveal">' +
				'<p class="cst-token-reveal-warn">Copy this token now. For security it is shown only once and cannot be retrieved again.</p>' +
				'<div class="cst-token-value-row"><code id="Plansheet-Token-Reveal-Value" class="cst-token-value">' + (pToken || '') + '</code>' +
				'<button class="cst-token-copy-btn" onclick="_Pict.views[\'Plansheet-UserSettings\'].copyRevealedToken()">Copy</button></div>' +
				'<p class="cst-token-reveal-hint">Send it as <code>Authorization: Bearer &lt;token&gt;</code>, or set it as <code>token</code> in the plansheet CLI config.</p>' +
			'</div>';
		tmpModal.show({ title: 'New API token', content: tmpContent, closeable: true, buttons: [{ Hash: 'done', Label: 'Done', Style: 'primary' }] });
	}

	copyRevealedToken()
	{
		let tmpValue = this._lastRevealedToken || '';
		if (typeof document !== 'undefined')
		{
			let tmpEl = document.getElementById('Plansheet-Token-Reveal-Value');
			if (tmpEl && tmpEl.textContent) { tmpValue = tmpEl.textContent; }
		}
		if (!tmpValue || typeof navigator === 'undefined' || !navigator.clipboard) { return; }
		navigator.clipboard.writeText(tmpValue).then(() =>
		{
			if (typeof document !== 'undefined') { let b = document.querySelector('.cst-token-copy-btn'); if (b) { b.textContent = 'Copied'; } }
		}).catch(() => {});
	}

	revokeToken(pIDUserToken)
	{
		let tmpProvider = this.pict.providers.TokenAPI;
		if (!tmpProvider) { return; }
		let tmpStore = this.pict.AppData.APITokens || { List: [] };
		let tmpRow = (tmpStore.List || []).find((pCandidate) => pCandidate.IDUserToken === pIDUserToken);
		let tmpLabel = (tmpRow && tmpRow.Label) || ('#' + pIDUserToken);
		let fRevoke = () => tmpProvider.revokeToken(pIDUserToken).then(() => this.showSection('tokens'));
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal) { return fRevoke(); }
		tmpModal.confirm('Revoke token "' + tmpLabel + '"? Any CLI or automation using it stops working immediately.',
			{ title: 'Revoke token?', confirmLabel: 'Revoke', cancelLabel: 'Cancel', dangerous: true })
			.then((pOk) => { if (pOk) { fRevoke(); } });
	}

	// ── lifecycle ────────────────────────────────────────────────────────────
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		// The settings nav lives in the shared left sidebar now (the docked Settings group, SiteMap.js),
		// not an in-page rail -- so there is no #Settings-Nav to render here. The route hands us the
		// section to open via _pendingSection; fall back to the last active section or Profile.
		let tmpSection = this._pendingSection || this._activeSection || 'profile';
		this._pendingSection = null;
		// Show immediately from cache, then refresh from the server.
		this.showSection(tmpSection);
		if (this.pict.providers.UserAPI)
		{
			this.pict.providers.UserAPI.getMe().then(() => this.showSection(this._activeSection));
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewUserSettings;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-UserSettings',
	DefaultRenderable: 'UserSettings-Display',
	CSS: /*css*/`
		.cst-set-page { display: flex; gap: 0; height: 100%; min-height: 0; }
		.cst-set-rail { flex: 0 0 240px; min-width: 0; border-right: 1px solid var(--theme-color-border-default, #e3e6ec); height: 100%; overflow: auto; }
		.cst-set-content { flex: 1 1 auto; min-width: 0; overflow: auto; }
		.cst-set-section { max-width: 560px; }
			/* Two builders can stack sections on one screen (Sign-in + Two-step verification). Give adjacent
			   sections a clear break -- generous space and a hairline rule -- so they read as separate functions. */
			.cst-set-section + .cst-set-section { margin-top: 40px; padding-top: 34px; border-top: 1px solid var(--theme-color-border-default, #e3e6ec); }
		.cst-set-h { margin: 0 0 2px; font-size: 1.3em; color: var(--theme-color-text-primary, #1d2230); }
		.cst-set-sub { margin: 0 0 18px; font-size: 0.88em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-set-field { display: flex; flex-direction: column; gap: 5px; margin-bottom: 14px; font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-set-input { padding: 8px 11px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); font-size: 0.95em; }
		.cst-set-color-row { display: flex; align-items: center; gap: 10px; }
		.cst-set-color { width: 44px; height: 32px; padding: 0; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: none; cursor: pointer; }
		.cst-set-color-hint { font-size: 0.92em; }
		.cst-set-photo { display: flex; align-items: center; gap: 16px; margin-bottom: 20px; }
		.cst-set-photo-preview { flex: 0 0 auto; }
		.cst-set-photo-actions { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
		.cst-set-photo-btns { display: flex; gap: 8px; flex-wrap: wrap; }
		.cst-set-photo-hint { font-size: 0.78em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-set-photo-remove { padding: 8px 14px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; font-size: 0.9em; }
		.cst-set-photo-remove:hover { background: var(--theme-color-status-error-background, #fdecec); border-color: var(--theme-color-status-error, #c0353a); color: var(--theme-color-status-error, #c0353a); }
		.cst-team-row { border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; padding: 14px 16px; margin-bottom: 12px; display: flex; flex-direction: column; gap: 10px; }
		.cst-team-head { display: flex; align-items: center; gap: 10px; }
		.cst-team-id { min-width: 0; }
		.cst-team-name { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); }
		.cst-team-email { font-size: 0.8em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-team-agent-badge { display: inline-block; font-size: 0.68em; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; padding: 1px 7px; margin-left: 7px; border-radius: 10px; color: var(--theme-color-brand-primary, #3b6fd4); border: 1px solid var(--theme-color-brand-primary, #3b6fd4); background: var(--theme-color-background-panel, #fff); vertical-align: middle; }
		.cst-team-removed-badge { display: inline-block; font-size: 0.68em; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; padding: 1px 7px; margin-left: 7px; border-radius: 10px; color: var(--theme-color-text-muted, #8a8f99); border: 1px solid var(--theme-color-border-default, #e3e6ec); background: var(--theme-color-background-secondary, #f7f8fb); vertical-align: middle; }
		.cst-team-row-removed { flex-direction: row; align-items: center; justify-content: space-between; opacity: 0.72; }
		.cst-team-fields { display: flex; gap: 14px; flex-wrap: wrap; }
		.cst-team-fields .cst-set-field { margin-bottom: 0; }
		.cst-team-roles { display: flex; flex-wrap: wrap; gap: 8px 16px; }
		.cst-team-role { display: inline-flex; align-items: center; gap: 5px; font-size: 0.85em; color: var(--theme-color-text-primary, #1d2230); }
		.cst-team-role-custom { font-size: 0.68em; color: var(--theme-color-brand-primary, #3b6fd4); text-transform: uppercase; letter-spacing: 0.03em; }
		.cst-role-group { margin: 22px 0 10px; font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-role-card { border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; padding: 14px 16px; margin-bottom: 12px; }
		.cst-role-ents { display: flex; flex-direction: column; gap: 8px; margin: 10px 0; }
		.cst-role-ent { display: flex; align-items: baseline; gap: 8px; font-size: 0.85em; }
		.cst-role-ent-label { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); }
		.cst-role-ent-desc { color: var(--theme-color-text-secondary, #5b6376); font-size: 0.92em; }
		.cst-role-system { background: var(--theme-color-background-secondary, #f3f5f9); }
		.cst-role-system-name { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); }
		.cst-role-system-tag { font-size: 0.68em; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.03em; }
		.cst-role-badges { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
		.cst-role-badge { font-size: 0.75em; padding: 2px 8px; border-radius: 10px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #5b6376); border: 1px solid var(--theme-color-border-default, #d8dde6); }
		/* The top-bar composer's canvas. Tall enough to arrange in, while the LOCKED crop frame inside it
		   (setCropFrame) is what actually ships -- the host is a workspace, not a preview of the bar. */
		.cst-topbar-board { height: 460px; min-height: 320px; margin: 14px 0; border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; overflow: hidden; }
		.cst-set-actions { display: flex; align-items: center; gap: 12px; margin-top: 6px; }
		.cst-set-btn { padding: 8px 16px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 8px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; cursor: pointer; font-size: 0.9em; }
		.cst-set-btn:hover { filter: brightness(1.05); }
		.cst-set-btn-secondary { background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); border-color: var(--theme-color-border-default, #d8dde6); }
		.cst-set-msg { font-size: 0.85em; }
		.cst-set-msg-ok { color: var(--theme-color-status-success, #2e7a3a); }
		.cst-set-msg-err { color: var(--theme-color-status-error, #c0353a); }
		.cst-set-rule { border: none; border-top: 1px solid var(--theme-color-border-default, #e3e6ec); margin: 22px 0; }
		.cst-set-placeholder { padding: 16px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 10px; color: var(--theme-color-text-secondary, #5b6376); font-size: 0.88em; }
		.cst-set-note-warn { margin: 0 0 14px; padding: 10px 12px; border-radius: 8px; font-size: 0.85em; background: var(--theme-color-status-warning-background, #fff6e5); color: var(--theme-color-status-warning, #8a5a00); border: 1px solid var(--theme-color-status-warning-border, #f0d9a8); }
		.cst-set-pill-ok { display: inline-block; padding: 1px 8px; border-radius: 10px; font-size: 0.78em; font-weight: 600; background: var(--theme-color-status-success-background, #e7f6ec); color: var(--theme-color-status-success, #2e7a3a); }
		.cst-set-codes { list-style: none; padding: 12px 14px; margin: 10px 0; display: grid; grid-template-columns: 1fr 1fr; gap: 6px 18px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.95em; letter-spacing: 0.04em; background: var(--theme-color-background-secondary, #f7f8fb); border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 8px; }
		.cst-notif-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 10px 0; border-bottom: 1px solid var(--theme-color-border-default, #eef0f4); }
		.cst-notif-label { font-size: 0.9em; color: var(--theme-color-text-primary, #2c3140); }
		.cst-notif-toggles { display: flex; gap: 16px; flex: none; }
		.cst-notif-toggle { display: inline-flex; align-items: center; gap: 6px; font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); white-space: nowrap; }
		.cst-notif-sms { border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; padding: 14px 16px; margin: 14px 0 20px; background: var(--theme-color-background-secondary, #f7f8fb); }
		.cst-notif-sms .cst-set-sh { margin-top: 0; }
		.cst-notif-consent { font-size: 0.78em; color: var(--theme-color-text-muted, #8a8f99); line-height: 1.5; margin: 10px 0 0; }
		.cst-notif-consent-check { display: flex; gap: 8px; align-items: flex-start; font-size: 0.8em; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.4; margin: 10px 0 2px; cursor: pointer; }
		.cst-notif-consent-check input { margin-top: 2px; flex: none; }
		.cst-set-field-row { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; margin-top: 6px; }
		/* Appearance: pict-section-theme stamps unstyled .pict-theme-mount rows; space + label them. */
		#Settings-Appearance-Theme .pict-theme-mount { display: flex; flex-direction: column; gap: 18px; max-width: 420px; }
		#Settings-Appearance-Theme .pict-theme-mount-row { display: flex; flex-direction: column; gap: 6px; align-items: flex-start; }
		#Settings-Appearance-Theme .pict-theme-mount-row::before { font-size: 0.85em; font-weight: 600; color: var(--theme-color-text-primary, #1d2230); }
		#Settings-Appearance-Theme .pict-theme-mount-row-theme-picker::before { content: "Theme"; }
		#Settings-Appearance-Theme .pict-theme-mount-row-theme-modetoggle::before { content: "Color mode"; }
		#Settings-Appearance-Theme .pict-theme-mount-row-theme-scaleselect::before { content: "Text size"; }
		.cst-set-appearance-footer { margin-top: 26px; padding-top: 14px; border-top: 1px solid var(--theme-color-border-default, #e3e6ec); font-size: 0.78em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-set-navtoggle { display: flex; align-items: flex-start; gap: 10px; margin-top: 22px; cursor: pointer; }
		.cst-set-navtoggle input { margin-top: 3px; flex: 0 0 auto; }
		.cst-set-navtoggle-txt { display: flex; flex-direction: column; }
		.cst-set-navtoggle .cst-set-sub { margin: 4px 0 0; }
		.cst-set-tabs { margin-top: 26px; padding-top: 20px; border-top: 1px solid var(--theme-color-border-default, #e3e6ec); }
		.cst-set-tabs .cst-set-h3 { margin-top: 0; }
		.cst-set-tabs-list { max-width: 420px; margin-top: 10px; border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 8px; overflow: hidden; }
		.cst-set-tabrow { display: flex; align-items: center; gap: 12px; padding: 9px 12px; }
		.cst-set-tabrow + .cst-set-tabrow { border-top: 1px solid var(--theme-color-border-light, #eef0f4); }
		.cst-set-tabrow-show { flex: 1 1 auto; display: flex; align-items: center; gap: 10px; cursor: pointer; min-width: 0; }
		.cst-set-tabrow-show input { flex: 0 0 auto; margin: 0; }
		.cst-set-tabrow-ico { flex: 0 0 auto; display: inline-flex; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-set-tabrow-ico .ps-nb-tab-ico { width: 18px; height: 18px; }
		.cst-set-tabrow-lbl { font-size: 0.9em; color: var(--theme-color-text-primary, #1d2230); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-set-tabrow-def { flex: 0 0 auto; display: flex; align-items: center; gap: 6px; cursor: pointer; font-size: 0.78em; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-set-tabrow-def input { margin: 0; }
		.cst-set-tabrow-def input:disabled { cursor: default; }
		.cst-set-tabrow-def:has(input:disabled) { opacity: 0.4; cursor: default; }
		.cst-set-section-wide { max-width: none; }
		.cst-set-h3 { font-size: 0.92em; margin: 16px 0 8px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-sticker-grid { display: flex; flex-wrap: wrap; gap: 10px; }
		.cst-sticker-tile { position: relative; width: 84px; height: 84px; box-sizing: border-box; border: 1px solid var(--theme-color-border-default, #e2e6ec); border-radius: 8px; background: var(--theme-color-background-panel, #fff); display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 6px; }
		.cst-sticker-tile img { max-width: 52px; max-height: 50px; object-fit: contain; }
		.cst-sticker-name { font-size: 10px; color: var(--theme-color-text-secondary, #8a93a5); margin-top: 4px; max-width: 74px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-setchips { display: flex; flex-wrap: wrap; gap: 6px; margin: 6px 0 14px; }
		.cst-setchip { padding: 6px 12px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 16px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); cursor: pointer; font-size: 13px; }
		.cst-setchip.is-active { background: var(--theme-color-background-selected, rgba(55,138,221,0.12)); border-color: var(--theme-color-brand, #378add); font-weight: 600; }
		.cst-setchip-n { color: var(--theme-color-text-secondary, #8a93a5); font-size: 11px; }
		.cst-setchip-new { border-style: dashed; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-setedit { min-height: 40px; }
		.cst-setedit-head { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 10px; }
		.cst-setedit-head strong { font-size: 15px; margin-right: 4px; }
		.cst-tile-pick { cursor: pointer; }
		.cst-tile-pick:hover { border-color: var(--theme-color-brand, #378add); }
		.cst-libpick .cst-set-input { width: 100%; box-sizing: border-box; }
		.cst-sticker-del { position: absolute; top: 2px; right: 2px; border: none; background: rgba(0,0,0,0.05); color: var(--theme-color-status-error, #c0392b); border-radius: 4px; font-size: 9px; padding: 1px 5px; cursor: pointer; }
		.cst-sticker-del:hover { background: rgba(192,57,43,0.14); }
		.cst-lane-list { display: flex; flex-direction: column; gap: 8px; max-width: 640px; margin-bottom: 16px; }
		.cst-lane-row { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; background: var(--theme-color-background-panel, #fff); }
		.cst-lane-row.is-dragging { opacity: 0.45; outline: 2px dashed var(--theme-color-brand-primary, #3b6fd4); outline-offset: -2px; }
		.cst-lane-grip { cursor: grab; color: var(--theme-color-text-secondary, #8a93a5); font-weight: 700; letter-spacing: -1px; user-select: none; flex: 0 0 auto; }
		.cst-lane-color { width: 34px; height: 30px; padding: 0; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; background: none; cursor: pointer; flex: 0 0 auto; }
		.cst-lane-label { flex: 1 1 auto; min-width: 0; }
		.cst-lane-terminal { display: inline-flex; align-items: center; gap: 5px; font-size: 0.82em; color: var(--theme-color-text-secondary, #5b6376); white-space: nowrap; flex: 0 0 auto; }
		.cst-lane-del { padding: 5px 11px; font-size: 0.8em; background: transparent; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; cursor: pointer; color: var(--theme-color-text-secondary, #5b6376); white-space: nowrap; flex: 0 0 auto; }
		.cst-lane-del:hover { background: var(--theme-color-status-error-background, #fdecec); border-color: var(--theme-color-status-error, #c0353a); color: var(--theme-color-status-error, #c0353a); }
		/* Plan-sheets settings section */
		.cst-set-divider { border: none; border-top: 1px solid var(--theme-color-border-subtle, #eef1f6); margin: 20px 0; }
		.cst-set-sh { font-size: 13px; font-weight: 600; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 10px; text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-ps-settings-list { display: flex; flex-direction: column; gap: 6px; }
		.cst-ps-settings-row { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border: 1px solid var(--theme-color-border-subtle, #eef1f6); border-radius: 8px; background: var(--theme-color-background-panel, #fff); }
		.cst-ps-settings-row.is-current { background: var(--theme-color-background-selected, rgba(55,138,221,0.08)); border-color: var(--theme-color-brand, rgba(55,138,221,0.3)); }
		.cst-ps-settings-main { display: flex; flex-direction: column; gap: 2px; flex: 1 1 auto; min-width: 0; }
		.cst-ps-settings-name { font-size: 13px; font-weight: 600; color: var(--theme-color-text-primary, #1d2230); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-ps-settings-role { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-lane-add { display: flex; align-items: center; gap: 10px; max-width: 640px; }
		.cst-lane-add .cst-set-input { flex: 1 1 auto; min-width: 0; }
		.cst-set-about-host { min-height: 440px; margin-bottom: 16px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-panel, #fff); }
		.cst-set-token-new { display: flex; gap: 8px; margin-bottom: 14px; }
		.cst-set-token-row { display: flex; justify-content: space-between; align-items: center; gap: 10px; padding: 10px 12px; border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 8px; background: var(--theme-color-background-panel, #fff); margin-bottom: 8px; }
		.cst-set-token-main { min-width: 0; }
		.cst-set-token-label { font-weight: 600; font-size: 0.9em; color: var(--theme-color-text-primary, #1d2230); }
		.cst-set-token-meta { font-size: 0.75em; color: var(--theme-color-text-secondary, #5b6376); margin-top: 2px; }
		.cst-set-token-revoke { padding: 5px 11px; font-size: 0.8em; background: transparent; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; cursor: pointer; color: var(--theme-color-text-secondary, #5b6376); white-space: nowrap; }
		.cst-set-token-revoke:hover { background: var(--theme-color-status-error-background, #fdecec); border-color: var(--theme-color-status-error, #c0353a); color: var(--theme-color-status-error, #c0353a); }
		.cst-token-reveal { display: flex; flex-direction: column; gap: 10px; }
		.cst-token-reveal-warn { margin: 0; font-size: 0.9em; color: var(--theme-color-status-error, #c0353a); }
		.cst-token-value-row { display: flex; gap: 8px; align-items: stretch; }
		.cst-token-value { flex: 1; min-width: 0; padding: 8px 10px; background: var(--theme-color-background-secondary, #f3f5f9); border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; font-family: ui-monospace, Menlo, monospace; font-size: 0.85em; word-break: break-all; color: var(--theme-color-text-primary, #1d2230); }
		.cst-token-copy-btn { padding: 6px 14px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 6px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; cursor: pointer; font-size: 0.85em; white-space: nowrap; }
		.cst-token-reveal-hint { margin: 0; font-size: 0.8em; color: var(--theme-color-text-secondary, #5b6376); line-height: 1.5; }
		.cst-token-reveal-hint code, .cst-token-reveal-warn code { font-family: ui-monospace, Menlo, monospace; font-size: 0.92em; background: var(--theme-color-background-secondary, #f3f5f9); padding: 1px 4px; border-radius: 4px; }
		/* The reveal dialog renders inside pict-section-modal (portaled), where the drafting theme's dark
		   variables can fall back to the light hexes above. The mode class lives on <html>, so pair the base
		   rules with explicit html.theme-dark overrides that reach the modal (mirrors PictView-Shell). */
		html.theme-dark .cst-token-reveal-warn { color: var(--theme-color-status-error, #e8896f); }
		html.theme-dark .cst-token-reveal-hint { color: var(--theme-color-text-secondary, #98a2ae); }
		html.theme-dark .cst-token-value { background: var(--theme-color-background-primary, #14171c); border-color: var(--theme-color-border-default, rgba(233,236,240,0.22)); color: var(--theme-color-text-primary, #e9ecf0); }
		html.theme-dark .cst-token-reveal-hint code, html.theme-dark .cst-token-reveal-warn code { background: var(--theme-color-background-primary, #14171c); color: var(--theme-color-text-primary, #e9ecf0); }
		.dk-picker { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
		.dk-current { font-size: 0.9em; color: var(--theme-color-text-secondary, #5b6376); }
		.dk-rows { display: flex; flex-direction: column; gap: 12px; }
		.dk-row { border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; padding: 12px 14px; display: flex; flex-direction: column; gap: 10px; }
		.dk-row-head { font-weight: 600; font-size: 0.78em; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); }
		.dk-fields { display: flex; gap: 12px; flex-wrap: wrap; }
		.dk-field { display: flex; flex-direction: column; gap: 4px; font-size: 0.8em; color: var(--theme-color-text-secondary, #5b6376); flex: 1 1 140px; min-width: 0; }
		.dk-field-desc { flex-basis: 100%; }
		.dk-preview { margin: 14px 0; font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); }
		.msg-vars { font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); margin: -4px 0 12px; line-height: 2.1; }
		.msg-var { font-family: ui-monospace, Menlo, monospace; font-size: 0.82em; padding: 2px 7px; margin: 0 3px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 6px; background: var(--theme-color-background-secondary, #f3f5f9); color: var(--theme-color-text-primary, #1d2230); cursor: pointer; }
		.msg-var:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); }
		.msg-body { font-family: inherit; resize: vertical; }
		.cst-set-check { display: flex; align-items: center; gap: 8px; margin: 10px 0; font-size: 0.88em; color: var(--theme-color-text-secondary, #5b6376); }
		.msg-preview { margin: 12px 0; padding: 12px 14px; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; background: var(--theme-color-background-secondary, #f7f8fb); }
		.msg-preview:empty { display: none; }
		.msg-preview-label { font-size: 0.72em; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 6px; }
		.msg-preview-subject { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); margin-bottom: 6px; }
		.msg-preview-body { font-size: 0.92em; color: var(--theme-color-text-primary, #1d2230); line-height: 1.5; word-break: break-word; }
		.msg-test { margin-top: 16px; border-top: 1px solid var(--theme-color-border-default, #e6e9ee); padding-top: 12px; }
		.cst-set-btn-danger { background: #c0392b; border-color: #c0392b; }
		.cst-set-placeholder { padding: 18px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 10px; color: var(--theme-color-text-secondary, #5b6376); font-size: 0.9em; }
		.dk-newkit { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin: 6px 0 18px; }
		.dk-newkit-name { flex: 1 1 240px; }
		.dk-kitgrid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 14px; }
		.dk-kitcard { border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 12px; padding: 14px 16px; display: flex; flex-direction: column; gap: 8px; background: var(--theme-color-background-secondary, #f7f8fb); }
		.dk-kitcard-head { display: flex; align-items: center; gap: 8px; font-size: 1.02em; color: var(--theme-color-text-primary, #1d2230); }
		.dk-kitcard-sub { font-size: 0.82em; color: var(--theme-color-text-secondary, #5b6376); }
		.dk-kitcard-actions { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
		.dk-kitcard-actions .cst-set-btn { padding: 5px 11px; font-size: 0.82em; }
		.dk-swatch { width: 14px; height: 14px; border-radius: 4px; display: inline-block; flex: none; border: 1px solid rgba(0,0,0,0.12); }
		.dk-housebadge { font-size: 0.68em; text-transform: uppercase; letter-spacing: 0.05em; padding: 2px 8px; border-radius: 999px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; }
		.dk-editor-head { display: flex; flex-direction: column; gap: 10px; margin-bottom: 8px; }
		.dk-back { font-size: 0.85em; color: var(--theme-color-brand-primary, #3b6fd4); text-decoration: none; }
		.dk-editor-title { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
		.dk-name-in { font-size: 1.1em; font-weight: 600; flex: 1 1 220px; max-width: 360px; }
		.dk-loop-block { margin: 14px 0; padding: 12px 14px; border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; }
		.dk-loop-label { margin-bottom: 8px; }
		.dk-loop-label input { font-weight: 600; }
		.dk-loops-host { min-height: 120px; margin: 4px 0; }
		.dk-loops-fallback { resize: vertical; font-family: ui-monospace, Menlo, monospace; width: 100%; }
		.dk-loops p code { font-family: ui-monospace, Menlo, monospace; font-size: 0.85em; background: var(--theme-color-background-secondary, #f3f5f9); padding: 1px 5px; border-radius: 4px; }
	`,
	Templates:
	[
		{
			Hash: 'UserSettings-Display',
			Template: /*html*/`
<div class="cst-set-page">
	<div class="ps-page-bleed cst-set-content" id="Settings-Content"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'UserSettings-Display',
			TemplateHash: 'UserSettings-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

},{"../LoopMarkdown.js":560,"../Plansheet-Version.js":566,"../providers/FrameworkClient.js":576,"./AvatarHelper.js":648,"./MarkdownRender.js":649,"pict-section-moodboard/source/sources/StickerSource-Base.js":280,"pict-view":365}],705:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libModal = require('pict-section-modal');
const libChecklist = require('pict-section-checklist');
const libPlansheetChecklistProvider = require('../providers/PlansheetChecklistProvider.js');
const libLoopStatus = require('../LoopStatus.js');
const libFocus = require('../FocusFilters.js');

/**
 * VisionLoops -- the four refinement loops around a vision, drawn as a cycle: Design -> Build ->
 * Deliver -> Gather Feedback -> back to Design. Each loop is now a CHECKLIST: the ring is that
 * checklist's weighted completion (computed server-side, LoopsAPI). Click a ring to open its
 * checklist below; checking items persists and the ring updates live (the checklist's onChange
 * re-fetches the loops and repaints only the ring cycle, so the open checklist stays mounted).
 *
 * Embedded on the Vision detail; configure(IDVision) loads + paints it into #Entity-VisionLoops.
 * The loop checklists are shared, vision-owned, and bound by Context ({ OwnerType: 'Checklist',
 * IDOwner: <IDChecklist> }) through the same PlansheetChecklistProvider the work-item embed uses.
 */
const _CIRC = 213.6; // 2 * pi * r, r = 34
const _COLORS = { design: '#2880a6', build: '#d9923c', deliver: '#7d63b8', feedback: '#16a085' };
// A stopped loop is not a finished one and must not wear the loop's own colour. Grey reads as closed
// without reading as progress, which is exactly the distinction an abandoned vision needs.
const _STOPPED = '#98a0b0';

class PictViewVisionLoops extends libPictView
{
	onBeforeInitialize()
	{
		this._id = 0;
		this._loops = [];
		this._openLoop = null;
		this._provider = new libPlansheetChecklistProvider(this.pict);
		this._childUp = {};
		return super.onBeforeInitialize();
	}

	_api() { return this.pict.providers.LoopsAPI; }

	configure(pIDVision)
	{
		this._id = parseInt(pIDVision, 10) || 0;
		// Which loop is open comes off the URL, so a link to "this vision's Deliver checklist" opens it.
		this._openLoop = libFocus.readHashParams().loop || null;
		let tmpAPI = this._api();
		if (!tmpAPI || !this._id) { return Promise.resolve(); }
		this._ensureModal();
		return tmpAPI.loops(this._id).then((pData) =>
		{
			this._loops = (pData && Array.isArray(pData.Loops)) ? pData.Loops : [];
			this._shape();
			this.render();
		});
	}

	// Re-fold this._loops (+ the open-loop state) into AppData for the ring cycle. Percent is what the
	// server says to DRAW, which is not always what the checklist measures: a Realized or Abandoned
	// vision has its rings decided by its status (WI #409). This adds the ring geometry, colour, and
	// open class on top of that.
	_shape()
	{
		let tmpLoops = this._loops.map((pLoop) =>
		{
			let tmpPct = Math.max(0, Math.min(100, Number(pLoop.Percent) || 0));
			let tmpDerived = (pLoop.Source === 'status');
			return Object.assign({}, pLoop,
			{
				ViewHash: this.Hash,
				Color: (tmpDerived && pLoop.Stage === 'stopped') ? _STOPPED : (_COLORS[pLoop.Key] || '#888888'),
				Dash: ((tmpPct / 100) * _CIRC).toFixed(1) + ' ' + _CIRC.toFixed(1),
				// A DERIVED RING NEVER PRINTS A PERCENTAGE, because it did not count one. Writing 100%
				// in the middle of a ring nobody ticked would swap one false number for another; the
				// word says the same thing without claiming a measurement.
				PercentLabel: libLoopStatus.ringLabel(pLoop),
				PercentClass: tmpDerived ? 'ps-loop-ring-word' : '',
				OpenClass: (pLoop.Key === this._openLoop) ? 'ps-loop-open' : ''
			});
		});
		this.pict.AppData.VisionLoops = { Loops: tmpLoops, Empty: tmpLoops.length ? [] : [{ Message: 'No loop data yet.' }] };
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		this._renderCycle();
		this._renderDetail();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// Paint just the ring cycle into its container, leaving the open-checklist panel untouched.
	_renderCycle()
	{
		let tmpHTML = this.pict.parseTemplateByHash('VisionLoops-Cycle', {});
		this.pict.ContentAssignment.assignContent('#VisionLoops-Cycle', tmpHTML);
	}

	/**
	 * Click a ring: toggle that loop's checklist open (or closed if it is already open).
	 *
	 * The open loop rides in the vision's own URL as ?loop=deliver rather than in a route of its own,
	 * because it is a refinement of the page you are already on, not a different page -- the same
	 * reasoning that puts a list's filters in its query. replaceState, so the router is not re-entered
	 * and the checklist below is not torn down and rebuilt under the person using it.
	 */
	openLoop(pKey)
	{
		this._openLoop = (this._openLoop === pKey) ? null : pKey;
		libFocus.writeHashQuery(this._openLoop ? { loop: this._openLoop } : {});
		this._shape();
		this._renderCycle();
		this._renderDetail();
	}

	// Show the open loop's checklist below the rings (or clear the panel). The checklist control is the
	// same pict-section-checklist used elsewhere, bound to the loop's IDChecklist; its onChange refreshes
	// the rings live.
	_renderDetail()
	{
		let tmpDetail = '#VisionLoops-Detail';
		let tmpLoop = this._openLoop ? this._loops.find((pLoop) => pLoop.Key === this._openLoop) : null;
		if (!tmpLoop || !tmpLoop.IDChecklist)
		{
			this.pict.ContentAssignment.assignContent(tmpDetail, '');
			return;
		}
		let tmpPanel = this.pict.parseTemplateByHash('VisionLoops-Panel', { ViewHash: this.Hash, Key: tmpLoop.Key, Label: tmpLoop.Label });
		this.pict.ContentAssignment.assignContent(tmpDetail, tmpPanel);
		this._mountLoopChecklist(tmpLoop);
	}

	_mountLoopChecklist(pLoop)
	{
		let tmpID = pLoop.IDChecklist;
		let tmpHash = 'PSLoopChecklist-' + tmpID;
		let tmpMount = '#VisionLoops-Checklist-Mount';
		let tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			tmpView = this.pict.addView(tmpHash, Object.assign({}, libChecklist.default_configuration,
				{
					ViewIdentifier: tmpHash,
					AutoRender: false,
					Context: { OwnerType: 'Checklist', IDOwner: String(tmpID) },
					DataProvider: this._provider,
					Title: pLoop.Label,
					EditableTitle: false,
					onChange: () => { this._onLoopChange(); },
					DefaultDestinationAddress: tmpMount,
					Renderables: [{ RenderableHash: 'Checklist-Section', TemplateHash: 'Checklist-Section', ContentDestinationAddress: tmpMount, RenderMethod: 'replace' }]
				}), libChecklist);
		}
		if (!this._childUp[tmpHash])
		{
			// pict's addView after app init does NOT run the view lifecycle, so bring the control up by
			// hand: the sync stages via initialize(), then mount() (wires the provider, loads, paints).
			this._childUp[tmpHash] = true;
			if (typeof tmpView.initialize === 'function' && !tmpView.initializeTimestamp) { tmpView.initialize(); }
			if (typeof tmpView.mount === 'function') { try { tmpView.mount(); } catch (pError) { /* ignore */ } }
			else { try { tmpView.render(); } catch (pError) { /* ignore */ } }
		}
		else
		{
			// Re-opened: repaint the existing control into the fresh mount node.
			try { tmpView.render(); } catch (pError) { /* ignore */ }
		}
	}

	// A checklist item changed: re-fetch the loops and repaint the rings (the open checklist stays put).
	_onLoopChange()
	{
		let tmpAPI = this._api();
		if (!tmpAPI || !this._id) { return; }
		tmpAPI.loops(this._id).then((pData) =>
		{
			this._loops = (pData && Array.isArray(pData.Loops)) ? pData.Loops : [];
			this._shape();
			this._renderCycle();
		}).catch(() => { /* leave the rings as they are */ });
	}

	_ensureModal()
	{
		if (!this.pict.views['Pict-Section-Modal']) { this.pict.addView('Pict-Section-Modal', libModal.default_configuration, libModal); }
		let tmpModalView = this.pict.views['Pict-Section-Modal'];
		if (tmpModalView && typeof document !== 'undefined' && document.body && typeof tmpModalView.initialize === 'function') { tmpModalView.initialize(); }
	}
}

module.exports = PictViewVisionLoops;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-VisionLoops',
	DefaultRenderable: 'VisionLoops-Display',
	DefaultDestinationAddress: '#Entity-VisionLoops',
	AutoRender: false,
	CSS: /*css*/`
		.ps-loops { display: flex; flex-direction: column; gap: 8px; }
		.ps-loops-cycle { display: flex; align-items: stretch; gap: 0; flex-wrap: wrap; }
		.ps-loop { flex: 1 1 150px; display: flex; flex-direction: column; align-items: center; text-align: center; padding: 8px 10px; position: relative; cursor: pointer; border-radius: 10px; border: 1px solid transparent; transition: background 0.12s ease, border-color 0.12s ease; }
		.ps-loop:hover { background: var(--theme-color-background-hover, #eef2f6); }
		.ps-loop.ps-loop-open { background: var(--theme-color-background-secondary, #eef1f6); border-color: var(--theme-color-border-default, #d8dde6); }
		.ps-loop:not(:last-child)::after { content: '→'; position: absolute; right: -7px; top: 40px; color: var(--theme-color-text-muted, #b3bcc6); font-size: 18px; }
		.ps-loop-ring { width: 84px; height: 84px; }
		.ps-loop-ring svg { width: 84px; height: 84px; display: block; }
		.ps-loop-ring-track { stroke: var(--theme-color-background-tertiary, #e3e8f0); }
		.ps-loop-ring-pct { fill: var(--theme-color-text-primary, #2c3140); font-size: 19px; font-weight: 700; }
		/* A word needs less room than a percentage and should not shout as loudly as a measured one. */
		.ps-loop-ring-word { font-size: 14px; font-weight: 600; fill: var(--theme-color-text-secondary, #5b6376); }
		.ps-loop-label { font-size: 13px; font-weight: 700; color: var(--theme-color-text-primary, #2c3140); margin-top: 6px; }
		.ps-loop-stage { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin-top: 1px; }
		.ps-loop-detail { font-size: 11px; color: var(--theme-color-text-muted, #97a1ab); margin-top: 2px; }
		.ps-loops-note { font-size: 11px; color: var(--theme-color-text-muted, #97a1ab); text-align: center; font-style: italic; }
		.ps-loop-panel { margin-top: 6px; }
		.ps-loop-panel-inner { border: 1px solid var(--theme-color-border-light, #e7ecf0); border-radius: 12px; padding: 14px 16px; background: var(--theme-color-background-panel, #fff); }
		.ps-loop-panel-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
		.ps-loop-panel-head h4 { margin: 0; font-size: 13px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); }
		.ps-loop-panel-close { font: inherit; font-size: 12px; border: none; background: none; color: var(--theme-color-brand-primary, #2880a6); cursor: pointer; padding: 2px 6px; }
		.ps-loop-panel-close:hover { text-decoration: underline; }
	`,
	Templates:
	[
		{
			Hash: 'VisionLoops-Display',
			Template: /*html*/`
<div class="ps-loops">
	<div class="ps-loops-cycle" id="VisionLoops-Cycle"></div>
	<div class="ps-loops-note">Design feeds the build; the build is delivered to the customer; their feedback feeds the next design. Click a loop to work its checklist.</div>
	<div class="ps-loop-panel" id="VisionLoops-Detail"></div>
</div>`
		},
		{
			Hash: 'VisionLoops-Cycle',
			Template: /*html*/`{~TS:Loop-Card:AppData.VisionLoops.Loops~}`
		},
		{
			Hash: 'Loop-Card',
			Template: /*html*/`
<div class="ps-loop {~D:Record.OpenClass~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].openLoop('{~D:Record.Key~}')">
	<div class="ps-loop-ring">
		<svg viewBox="0 0 80 80">
			<circle class="ps-loop-ring-track" cx="40" cy="40" r="34" fill="none" stroke-width="8"></circle>
			<circle cx="40" cy="40" r="34" fill="none" stroke="{~D:Record.Color~}" stroke-width="8" stroke-linecap="round" stroke-dasharray="{~D:Record.Dash~}" transform="rotate(-90 40 40)"></circle>
			<text class="ps-loop-ring-pct {~D:Record.PercentClass~}" x="40" y="47" text-anchor="middle">{~D:Record.PercentLabel~}</text>
		</svg>
	</div>
	<div class="ps-loop-label">{~D:Record.Label~}</div>
	<div class="ps-loop-stage">{~D:Record.Stage~}</div>
	<div class="ps-loop-detail">{~D:Record.Detail~}</div>
</div>`
		},
		{
			Hash: 'VisionLoops-Panel',
			Template: /*html*/`
<div class="ps-loop-panel-inner">
	<div class="ps-loop-panel-head"><h4>{~D:Record.Label~}</h4><button class="ps-loop-panel-close" onclick="_Pict.views['{~D:Record.ViewHash~}'].openLoop('{~D:Record.Key~}')">Close</button></div>
	<div class="ps-loop-checklist-mount" id="VisionLoops-Checklist-Mount"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'VisionLoops-Display',
			TemplateHash: 'VisionLoops-Display',
			ContentDestinationAddress: '#Entity-VisionLoops',
			RenderMethod: 'replace'
		}
	]
};

},{"../FocusFilters.js":558,"../LoopStatus.js":561,"../providers/PlansheetChecklistProvider.js":621,"pict-section-checklist":184,"pict-section-modal":271,"pict-view":365}],706:[function(require,module,exports){
'use strict';

/**
 * Plansheet's standalone Whiteboards library.
 *
 * Whiteboards (the Moodboard entity) attach polymorphically (OwnerType + IDOwner) or stand alone
 * (empty owner). This page lists every whiteboard in the plan sheet as cards -- standalone ones plus
 * those that belong to a Vision or a Work Item -- and opens any of them in a focused editor. "New
 * whiteboard" makes a standalone board. The owner-attached boards are also editable in place on their
 * entity's detail page; this is the cross-cutting view of all of them.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');
const libFrameworkClient = require('../providers/FrameworkClient.js');
const libLabels = require('../libLabels.js');

function _esc(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/[&<>"]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pChar]));
}

// A short, locale-friendly day label (e.g. "Jul 3, 2026"). Tolerates an ISO string, a Date, or a
// null. Dates arrive as ISO strings over JSON from both the SQLite (dev) and Postgres (prod) stores.
function _shortDate(pDate)
{
	if (!pDate) { return ''; }
	let tmpStamp = Date.parse(pDate);
	if (isNaN(tmpStamp)) { return String(pDate); }
	return new Date(tmpStamp).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

class PictViewWhiteboards extends libPictView
{
	_api() { return this.pict.providers.MoodboardAPI; }

	// The board currently open in the editor, read by the editor's Media image source to scope its gallery.
	currentBoardId() { return this._openID || null; }

	_canEdit()
	{
		let tmpApp = this.pict.PictApplication;
		return !!(tmpApp && typeof tmpApp._can === 'function' && tmpApp._can('content.edit'));
	}

	// Route entry: render the shell then load the list.
	show()
	{
		this._mode = 'list';
		this._openID = 0;
		this._afterShowOnce = null;
		this.render();
		if (typeof document !== 'undefined')
		{
			let tmpTitle = document.getElementById('Whiteboards-PageTitle');
			if (tmpTitle) { tmpTitle.textContent = libLabels.plural(this.pict, 'Whiteboard', null, 'Whiteboards'); }
		}
		this._loadList();
	}

	_loadList()
	{
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		tmpAPI.listAllForCustomer().then((pRows) => { this._boards = Array.isArray(pRows) ? pRows : []; this._renderList(); });
	}

	// A human label for where a board lives.
	_ownerLabel(pRow)
	{
		if (!pRow) { return 'Standalone'; }
		if (pRow.OwnerType === 'WorkItem') { return 'Work Item #' + pRow.IDOwner; }
		if (pRow.OwnerType === 'Vision' || pRow.IDVision) { return 'Vision #' + (pRow.IDOwner || pRow.IDVision); }
		if (pRow.OwnerType === 'Feature') { return 'Feature #' + pRow.IDOwner; }
		if (pRow.OwnerType === 'Module') { return 'Module #' + pRow.IDOwner; }
		if (pRow.OwnerType === 'User' || pRow.IDUser) { return 'Profile'; }
		if (pRow.OwnerType) { return pRow.OwnerType + ' #' + pRow.IDOwner; }
		return 'Standalone';
	}

	// A compact when-label for a card: "Created <date>", plus "Updated <date>" when the board has been
	// touched on a later day than it was made (so a never-edited board reads as just its create date).
	_dateLabel(pRow)
	{
		if (!pRow) { return ''; }
		let tmpCreated = _shortDate(pRow.CreateDate);
		let tmpUpdated = _shortDate(pRow.UpdateDate);
		let tmpParts = [];
		if (tmpCreated) { tmpParts.push('Created ' + tmpCreated); }
		if (tmpUpdated && tmpUpdated !== tmpCreated) { tmpParts.push('Updated ' + tmpUpdated); }
		return tmpParts.join(' · ');
	}

	_renderList()
	{
		if (typeof document === 'undefined') { return; }
		let tmpListWrap = document.getElementById('Whiteboards-ListWrap');
		let tmpEditor = document.getElementById('Whiteboards-Editor');
		if (tmpListWrap) { tmpListWrap.style.display = ''; }
		if (tmpEditor) { tmpEditor.style.display = 'none'; }
		let tmpHost = document.getElementById('Whiteboards-List');
		if (!tmpHost) { return; }
		let tmpSelf = "_Pict.views['Plansheet-Whiteboards']";
		let tmpCanEdit = this._canEdit();
		let tmpCards = (this._boards || []).map((pB) =>
		{
			let tmpDates = this._dateLabel(pB);
			return '<div class="wbl-card" onclick="' + tmpSelf + '.openBoard(' + pB.IDMoodboard + ')">' +
				'<button class="wbl-card-fs" title="View full screen" onclick="event.stopPropagation();_Pict.PictApplication.openBoardFullscreen(' + pB.IDMoodboard + ')">&#10530;</button>' +
				'<div class="wbl-card-body">' +
					'<div class="wbl-card-name">' + _esc(pB.Name || ('Whiteboard #' + pB.IDMoodboard)) + '</div>' +
					'<div class="wbl-card-owner">' + _esc(this._ownerLabel(pB)) + '</div>' +
					(tmpDates ? '<div class="wbl-card-dates">' + _esc(tmpDates) + '</div>' : '') +
				'</div>' +
				(tmpCanEdit ? '<button class="wbl-card-edit" title="Rename" onclick="event.stopPropagation();' + tmpSelf + '.renameBoard(' + pB.IDMoodboard + ')">&#9998;</button>' : '') +
				(tmpCanEdit ? '<button class="wbl-card-del" title="Delete" onclick="event.stopPropagation();' + tmpSelf + '.deleteBoard(' + pB.IDMoodboard + ')">&times;</button>' : '') +
			'</div>';
		}).join('');
		tmpHost.innerHTML = tmpCards || '<div class="wbl-empty">No whiteboards yet. Make one with “New whiteboard”.</div>';
	}

	// Tell the user when an action fails instead of leaving the button looking dead (the create used to
	// have no catch at all, so a refused or errored createForOwner was an unhandled, silent rejection).
	_toast(pMsg, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMsg, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
	}

	newBoard()
	{
		if (!this._canEdit()) { return; }
		let tmpAPI = this._api();
		if (!tmpAPI)
		{
			this._toast('Could not add a whiteboard: the whiteboard service is not available. Reload the page and try again.', 'error');
			return;
		}
		tmpAPI.createForOwner('', 0, 'Untitled whiteboard')
			.then((pRow) =>
			{
				if (pRow && pRow.IDMoodboard) { this.openBoard(pRow.IDMoodboard); }
				else { this._toast('Could not add a whiteboard: the server did not return a new record.', 'error'); }
			})
			.catch((pErr) => { this._toast('Could not add a whiteboard: ' + ((pErr && pErr.message) || pErr), 'error'); });
	}

	// Opening a board is a NAVIGATION: set the URL to /whiteboard/:id and let that route render it, so the
	// open board deep-links and survives a reload (it used to open imperatively, leaving the URL on
	// /whiteboards -- a reload dropped you back to the list). A one-shot after-open follow-up (e.g. seeding
	// a photo onto a fresh board) is stashed for showBoard to run once the editor mounts.
	openBoard(pID, fAfter)
	{
		this._afterShowOnce = (typeof fAfter === 'function') ? fAfter : null;
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showWhiteboard === 'function') { tmpApp.showWhiteboard(Number(pID) || 0); }
		else { this.showBoard(pID); } // no app/router (e.g. a bare test harness): open directly
	}

	// Route entry for /whiteboard/:id. Renders the shell (so the editor container exists even on a cold
	// reload / pasted deep-link), switches to the editor, loads the board, and titles the page after its
	// name (so bookmarks + history read as the board). Runs any stashed after-open follow-up once mounted.
	showBoard(pID)
	{
		this._openID = Number(pID) || 0;
		this._mode = 'edit';
		this.render();
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		let tmpListWrap = document.getElementById('Whiteboards-ListWrap');
		let tmpEditor = document.getElementById('Whiteboards-Editor');
		if (tmpListWrap) { tmpListWrap.style.display = 'none'; }
		if (tmpEditor) { tmpEditor.style.display = ''; }
		let tmpSelf = this;
		tmpAPI.read(this._openID).then((pRow) =>
		{
			let tmpBoard = tmpAPI.loadBoard(pRow);
			let tmpName = (pRow && pRow.Name) || 'Whiteboard';
			let tmpTitleEl = document.getElementById('Whiteboards-Editor-Title');
			if (tmpTitleEl) { tmpTitleEl.textContent = tmpName; }
			let tmpApp = tmpSelf.pict.PictApplication;
			if (tmpApp && typeof tmpApp._setPageTitle === 'function') { tmpApp._setPageTitle(tmpName); }
			let tmpView = tmpSelf.pict.views['Whiteboard-Page-Edit'];
			if (tmpView) { tmpView.render(); tmpView.setBoard(tmpBoard); }
			// Let the editor mount, then run any follow-up (e.g. dropping a photo onto a fresh board).
			let tmpAfter = tmpSelf._afterShowOnce;
			tmpSelf._afterShowOnce = null;
			if (typeof tmpAfter === 'function') { setTimeout(() => tmpAfter(tmpView), 200); }
		});
	}

	// Open the hidden file input behind the "From photo" button.
	pickPhoto()
	{
		if (typeof document === 'undefined') { return; }
		let tmpInput = document.getElementById('Whiteboards-PhotoInput');
		if (tmpInput) { tmpInput.value = ''; tmpInput.click(); }
	}

	onPhotoPicked(pInput)
	{
		let tmpFile = pInput && pInput.files && pInput.files[0];
		if (tmpFile) { this.newFromPhoto(tmpFile); }
	}

	// "Just an image": make a standalone whiteboard whose content is a photo (a snap of a real in-person
	// whiteboard, say). Create the board, open it, and drop the image in via the editor's own upload
	// path (stored as Media owned by the board).
	newFromPhoto(pFile)
	{
		if (!this._canEdit() || !pFile) { return; }
		let tmpAPI = this._api();
		if (!tmpAPI) { return; }
		let tmpName = (pFile.name || 'Photo').replace(/\.[^.]+$/, '').slice(0, 80) || 'Photo';
		tmpAPI.createForOwner('', 0, tmpName).then((pRow) =>
		{
			if (!pRow || !pRow.IDMoodboard) { return; }
			this.openBoard(pRow.IDMoodboard, (pView) =>
			{
				if (!pView) { return; }
				// Present the photo full-bleed: a jumbotron fits the width of a frame seeded from the
				// image, so a single-photo board reads as the photo filling the board when viewed.
				if (typeof pView.setDisplayStyle === 'function') { pView.setDisplayStyle('jumbotron'); }
				if (typeof pView.addImageFiles === 'function') { pView.addImageFiles([pFile]); }
			});
		});
	}

	// Autosave hook wired to Whiteboard-Page-Edit (debounced by the editor itself).
	onBoardSaved(pBoard)
	{
		let tmpAPI = this._api();
		if (tmpAPI && this._openID) { tmpAPI.saveBoard(this._openID, pBoard).catch(() => {}); }
	}

	// Back to the list = navigate to /whiteboards, so the URL leaves the board and a reload lands on the
	// list. The /whiteboards route calls show(), which repaints the list.
	back()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showWhiteboards === 'function') { tmpApp.showWhiteboards(); }
		else { this._mode = 'list'; this._loadList(); }
	}

	fullscreenCurrent()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && this._openID && typeof tmpApp.openBoardFullscreen === 'function') { tmpApp.openBoardFullscreen(this._openID); }
	}

	// Rename a whiteboard from the library card: a small text-input dialog seeded with the current name;
	// Enter or Save commits. Works the same for a photo-seeded board (it is an ordinary standalone board).
	// On save, patch the cached row + repaint (no list re-fetch), mirroring the entity-detail board rename.
	renameBoard(pID)
	{
		if (!this._canEdit() || !pID) { return; }
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpRow = (this._boards || []).find((pB) => Number(pB.IDMoodboard) === Number(pID));
		let tmpCurrent = (tmpRow && tmpRow.Name) || '';
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			this._toast('Could not rename: the dialog service is not available. Reload the page and try again.', 'error');
			return;
		}
		let tmpInputEl = null;
		tmpModal.show(
		{
			title: 'Rename whiteboard',
			width: '420px',
			closeable: true,
			content: '<div style="display:flex;flex-direction:column;gap:6px;">' +
				'<label style="font-size:12px;font-weight:600;letter-spacing:0.04em;text-transform:uppercase;color:var(--theme-color-text-secondary,#5b6376);">Name</label>' +
				'<input type="text" id="wbl-rename-input" maxlength="200" value="' + _esc(tmpCurrent) + '" ' +
				'style="padding:8px 10px;border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;font-size:14px;' +
				'background:var(--theme-color-background-panel,#fff);color:var(--theme-color-text-primary,#2c3140);">' +
				'</div>',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				tmpInputEl = pDialog.querySelector('#wbl-rename-input');
				if (!tmpInputEl) { return; }
				tmpInputEl.focus();
				tmpInputEl.select();
				// Enter commits by clicking Save (keeps a single dismiss path).
				tmpInputEl.addEventListener('keydown', (pKeyEvent) =>
				{
					if (pKeyEvent.key === 'Enter')
					{
						pKeyEvent.preventDefault();
						let tmpSaveBtn = pDialog.querySelector('[data-hash="save"]');
						if (tmpSaveBtn) { tmpSaveBtn.click(); }
					}
				});
			}
		}).then((pHash) =>
		{
			if (pHash !== 'save') { return; }
			let tmpName = (tmpInputEl && tmpInputEl.value != null) ? tmpInputEl.value.trim() : '';
			if (!tmpName) { this._toast('A whiteboard needs a name.', 'error'); return; }
			if (tmpName === tmpCurrent) { return; }
			let tmpAPI = this._api();
			if (!tmpAPI) { return; }
			tmpAPI.update(pID, { Name: tmpName })
				.then((pUpdated) =>
				{
					// Patch the cached row (name + fresh UpdateDate) and repaint, no board-blob re-fetch.
					let tmpPatch = (this._boards || []).find((pB) => Number(pB.IDMoodboard) === Number(pID));
					if (tmpPatch)
					{
						tmpPatch.Name = tmpName;
						if (pUpdated && pUpdated.UpdateDate) { tmpPatch.UpdateDate = pUpdated.UpdateDate; }
					}
					this._renderList();
					this._toast('Whiteboard renamed.', 'success');
				})
				.catch((pErr) => this._toast('Rename failed: ' + ((pErr && pErr.message) || pErr), 'error'));
		});
	}

	deleteBoard(pID)
	{
		if (!this._canEdit() || !pID) { return; }
		libFrameworkClient.delJSON(this.pict, '/1.0/Moodboard/' + pID)
			.then(() => this._loadList())
			.catch(() => {});
	}
}

module.exports = PictViewWhiteboards;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-Whiteboards',
	DefaultRenderable: 'Plansheet-Whiteboards',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,
	CSS: /*css*/`
		.wbl { display: flex; flex-direction: column; height: 100%; overflow: auto; }
		.wbl-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 18px; }
		.wbl-head-actions { display: flex; align-items: center; gap: 8px; }
		.wbl-h { margin: 0; font-size: 1.4em; color: var(--theme-color-text-primary, #1d2230); }
		.wbl-btn { padding: 8px 16px; border: 1px solid var(--theme-color-brand-primary, #3b6fd4); border-radius: 8px; background: var(--theme-color-brand-primary, #3b6fd4); color: #fff; cursor: pointer; font-size: 0.9em; }
		.wbl-btn:hover { filter: brightness(1.05); }
		.wbl-btn-secondary { background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1d2230); border-color: var(--theme-color-border-default, #d8dde6); }
		.wbl-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 14px; }
		.wbl-card { position: relative; border: 1px solid var(--theme-color-border-default, #e3e6ec); border-radius: 10px; padding: 16px; min-height: 92px; background: var(--theme-color-background-panel, #fff); cursor: pointer; display: flex; flex-direction: column; justify-content: flex-end; }
		.wbl-card:hover { border-color: var(--theme-color-brand-primary, #3b6fd4); box-shadow: 0 2px 10px rgba(20,40,80,0.08); }
		.wbl-card-name { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); font-size: 0.98em; overflow: hidden; text-overflow: ellipsis; }
		.wbl-card-owner { font-size: 0.76em; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5b6376); margin-top: 4px; }
		.wbl-card-dates { font-size: 0.72em; color: var(--theme-color-text-secondary, #5b6376); opacity: 0.8; margin-top: 3px; }
		.wbl-card-del { position: absolute; top: 6px; right: 8px; border: none; background: transparent; color: var(--theme-color-text-secondary, #9aa3b2); font-size: 16px; cursor: pointer; line-height: 1; }
		.wbl-card-del:hover { color: var(--theme-color-status-error, #c0353a); }
		.wbl-card-edit { position: absolute; top: 6px; right: 30px; border: none; background: transparent; color: var(--theme-color-text-secondary, #9aa3b2); font-size: 14px; cursor: pointer; line-height: 1; }
		.wbl-card-edit:hover { color: var(--theme-color-brand-primary, #3b6fd4); }
		.wbl-card-fs { position: absolute; top: 6px; left: 8px; border: none; background: transparent; color: var(--theme-color-text-secondary, #9aa3b2); font-size: 14px; cursor: pointer; line-height: 1; }
		.wbl-card-fs:hover { color: var(--theme-color-brand-primary, #3b6fd4); }
		.wbl-empty { padding: 28px; border: 1px dashed var(--theme-color-border-default, #d8dde6); border-radius: 10px; color: var(--theme-color-text-secondary, #5b6376); }
		.wbl-editor-head { display: flex; align-items: center; gap: 14px; margin-bottom: 12px; }
		.wbl-editor-title { font-size: 1.1em; font-weight: 600; color: var(--theme-color-text-primary, #1d2230); }
		.wbl-canvas { height: 70vh; min-height: 360px; border: 1px solid var(--theme-color-border-default, #e6e9ee); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-secondary, #f4f6f9); }
	`,
	Templates:
	[
		{
			Hash: 'Plansheet-Whiteboards',
			Template: /*html*/`
<div class="ps-page wbl">
	<div id="Whiteboards-ListWrap">
		<div class="wbl-head">
			<h2 class="wbl-h" id="Whiteboards-PageTitle">Whiteboards</h2>
			<div class="wbl-head-actions">
				<button class="wbl-btn wbl-btn-secondary" onclick="_Pict.views['Plansheet-Whiteboards'].pickPhoto()">From photo</button>
				<button class="wbl-btn" onclick="_Pict.views['Plansheet-Whiteboards'].newBoard()">New whiteboard</button>
				<input type="file" id="Whiteboards-PhotoInput" accept="image/*" style="display:none;" onchange="_Pict.views['Plansheet-Whiteboards'].onPhotoPicked(this)">
			</div>
		</div>
		<div class="wbl-grid" id="Whiteboards-List"></div>
	</div>
	<div id="Whiteboards-Editor" style="display:none;">
		<div class="wbl-editor-head">
			<button class="wbl-btn wbl-btn-secondary" onclick="_Pict.views['Plansheet-Whiteboards'].back()">&larr; All whiteboards</button>
			<span class="wbl-editor-title" id="Whiteboards-Editor-Title"></span>
			<button class="wbl-btn wbl-btn-secondary" onclick="_Pict.views['Plansheet-Whiteboards'].fullscreenCurrent()">Full screen</button>
		</div>
		<div class="wbl-canvas" id="Whiteboard-Page-Canvas"></div>
	</div>
</div>`
		}
	],
	Renderables:
	[
		{ RenderableHash: 'Plansheet-Whiteboards', TemplateHash: 'Plansheet-Whiteboards', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

},{"../libLabels.js":575,"../providers/FrameworkClient.js":576,"pict-view":365}],707:[function(require,module,exports){
'use strict';

/**
 * Plansheet's "visually map out your workflow" section.
 *
 * A thin host around the four retold-workflow views (catalog, designer/map, board, subject
 * detail). It owns the tab bar and the panes; the views themselves are product-agnostic and come
 * from retold-workflow. Navigation between them is wired here: pick a workflow in the catalog to
 * open the designer or the board; click a card on the board to see its timeline, metrics, and
 * agency. The views talk to the server through the WorkflowAPI provider.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictView = require('pict-view');

const _TABS =
[
	{ Key: 'catalog', Label: 'Catalog' },
	{ Key: 'designer', Label: 'Designer' },
	{ Key: 'board', Label: 'Board' },
	{ Key: 'subject', Label: 'Subject' }
];

const _ViewConfiguration =
{
	ViewIdentifier: 'Plansheet-Workflow',
	DefaultRenderable: 'Plansheet-Workflow',
	DefaultDestinationAddress: '#Plansheet-Workspace',
	AutoRender: false,

	CSS: /*css*/`
		.psw { display: flex; flex-direction: column; height: 100%; padding: 12px 16px; box-sizing: border-box; }
		.psw-tabs { flex-shrink: 0; display: flex; gap: 4px; border-bottom: 1px solid var(--theme-color-border-light, #e3e3e3); margin-bottom: 10px; }
		.psw-tab { padding: 7px 14px; border: none; background: transparent; cursor: pointer; font-size: 14px; color: var(--theme-color-text-secondary, #667); border-bottom: 2px solid transparent; }
		.psw-tab:hover { color: var(--theme-color-text-primary, #222); }
		.psw-tab-active { color: var(--theme-color-brand-primary, #2e7d74); border-bottom-color: var(--theme-color-brand-primary, #2e7d74); font-weight: 600; }
		.psw-content { flex: 1; min-height: 0; display: flex; flex-direction: column; }
		.psw-pane { flex: 1; min-height: 0; display: flex; flex-direction: column; }
		.psw-catalog-host { flex: 1; min-height: 0; }
		.psw-import-note { font-size: 0.85em; color: var(--theme-color-text-secondary, #5b6376); padding: 4px 0 12px; }
		.psw-import-note a { color: var(--theme-color-brand-primary, #3b6fd4); text-decoration: none; }
		.psw-import-note a:hover { text-decoration: underline; }
	`,

	Templates:
	[
		{
			Hash: 'Plansheet-Workflow',
			Template: /*html*/`
<div class="psw">
	<h2 class="ps-page-h">Workflow</h2>
	<div class="psw-tabs">{~TS:Plansheet-Workflow-Tab:AppData.WorkflowShell.Tabs~}</div>
	<div class="psw-content">
		{~TS:Plansheet-Workflow-Pane-Catalog:AppData.WorkflowShell.CatalogSlot~}
		{~TS:Plansheet-Workflow-Pane-Map:AppData.WorkflowShell.MapSlot~}
		{~TS:Plansheet-Workflow-Pane-Board:AppData.WorkflowShell.BoardSlot~}
		{~TS:Plansheet-Workflow-Pane-Subject:AppData.WorkflowShell.SubjectSlot~}
	</div>
</div>`
		},
		{ Hash: 'Plansheet-Workflow-Tab', Template: /*html*/`<button class="psw-tab {~D:Record.ActiveClass~}" onclick="_Pict.views['Plansheet-Workflow'].showTab('{~D:Record.Key~}')">{~D:Record.Label~}</button>` },
		{ Hash: 'Plansheet-Workflow-Pane-Catalog', Template: /*html*/`<div class="psw-pane"><div class="psw-import-note">These are the crafts you have imported. Bring a new one in from <a href="#/settings/draftingkit">Settings &rsaquo; Drafting Kit</a>.</div><div class="psw-catalog-host" id="Workflow-Catalog-Container"></div></div>` },
		{ Hash: 'Plansheet-Workflow-Pane-Map', Template: /*html*/`<div class="psw-pane" id="Workflow-Map-Container"></div>` },
		{ Hash: 'Plansheet-Workflow-Pane-Board', Template: /*html*/`<div class="psw-pane" id="Workflow-Board-Container"></div>` },
		{ Hash: 'Plansheet-Workflow-Pane-Subject', Template: /*html*/`<div class="psw-pane" id="Workflow-Subject-Container"></div>` }
	],

	Renderables:
	[
		{ RenderableHash: 'Plansheet-Workflow', TemplateHash: 'Plansheet-Workflow', ContentDestinationAddress: '#Plansheet-Workspace', RenderMethod: 'replace' }
	]
};

class PictViewWorkflow extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		if (!this.pict.AppData.WorkflowShell)
		{
			this.pict.AppData.WorkflowShell = { ActiveTab: 'catalog', SelectedType: null, Tabs: [], CatalogSlot: [], MapSlot: [], BoardSlot: [], SubjectSlot: [] };
		}
	}

	_state() { return this.pict.AppData.WorkflowShell; }

	/** Enter the section: land on the catalog. The RENDER half, so the route does not re-enter itself. */
	show()
	{
		this._applyShowTab('catalog');
	}

	/** Enter the section on a named tab, from the /workflow/:tab route. */
	showTabRoute(pTab)
	{
		this._applyShowTab(_TABS.some((pTabDef) => pTabDef.Key === pTab) ? pTab : 'catalog');
	}

	/**
	 * Switch tabs. NAVIGATES; the route handler renders.
	 *
	 * The four tabs are four different pages -- the catalog, the designer, the running board, and a
	 * subject -- and only one of them could be linked or reloaded into. openSubject was routed earlier
	 * for exactly that reason; this is the rest of the same job.
	 */
	showTab(pTab)
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showWorkflowTab === 'function' && tmpApp.showWorkflowTab(pTab)) { return; }
		return this._applyShowTab(pTab);
	}

	_applyShowTab(pTab)
	{
		let tmpState = this._state();
		tmpState.ActiveTab = pTab;
		tmpState.Tabs = _TABS.map((pTabDef) => ({ Key: pTabDef.Key, Label: pTabDef.Label, ActiveClass: (pTabDef.Key === pTab) ? 'psw-tab-active' : '' }));
		tmpState.CatalogSlot = (pTab === 'catalog') ? [{}] : [];
		tmpState.MapSlot = (pTab === 'designer') ? [{}] : [];
		tmpState.BoardSlot = (pTab === 'board') ? [{}] : [];
		tmpState.SubjectSlot = (pTab === 'subject') ? [{}] : [];
		this.render();
		this._renderActive(pTab);
	}

	_renderActive(pTab)
	{
		let tmpState = this._state();
		if (pTab === 'catalog') { this._view('Workflow-Catalog').reload(); }
		else if (pTab === 'designer') { if (tmpState.SelectedType) { this._view('Workflow-Map').showType(tmpState.SelectedType); } else { this._view('Workflow-Map').render(); } }
		else if (pTab === 'board') { if (tmpState.SelectedType) { this._view('Workflow-Board').showType(tmpState.SelectedType); } else { this._view('Workflow-Board').render(); } }
		else if (pTab === 'subject') { this._view('Workflow-Subject').render(); }
	}

	_view(pHash) { return this.pict.views[pHash]; }

	// -- navigation from the sub-views (wired as their callbacks) ---------------

	openDesigner(pTypeRecord) { this._state().SelectedType = pTypeRecord; this.showTab('designer'); }
	openBoard(pTypeRecord) { this._state().SelectedType = pTypeRecord; this.showTab('board'); }

	// Opening a subject is a NAVIGATION to /workflow/subject/:id, so it deep-links and survives a reload
	// (it used to reset to the catalog tab). The type/title we have are stashed for the route-driven open;
	// a cold deep-link has neither, and showSubject fetches everything by id, so it still resolves.
	openSubject(pSubjectID, pTypeRecord, pTitle)
	{
		this._pendingSubject = { Type: pTypeRecord || this._state().SelectedType || null, Title: pTitle || '' };
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.showWorkflowSubject === 'function') { tmpApp.showWorkflowSubject(pSubjectID); }
		else { this._showSubjectRender(pSubjectID, this._pendingSubject.Type, this._pendingSubject.Title); }
	}

	// Route entry for /workflow/subject/:id: land on the subject tab and load the subject (using the stashed
	// type/title when we have them from an in-app open).
	showSubjectRoute(pSubjectID)
	{
		let tmpPending = this._pendingSubject || {};
		this._pendingSubject = null;
		this._showSubjectRender(Number(pSubjectID) || 0, tmpPending.Type || this._state().SelectedType || null, tmpPending.Title || '');
	}

	_showSubjectRender(pSubjectID, pTypeRecord, pTitle)
	{
		this.showTab('subject');
		this._view('Workflow-Subject').showSubject(pSubjectID, pTypeRecord, pTitle);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}
}

module.exports = PictViewWorkflow;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":365}],708:[function(require,module,exports){
'use strict';

/**
 * NodeWorkspace: the single-node detail screen, built on pict-section-workspace (Work Item #465, B5f).
 *
 * A NodeRegistration is a small enough thing to deserve a focused screen rather than the generic entity detail:
 * a status pill, an overview of its identity and capability, and the lifecycle actions (Approve / Suspend /
 * Resume / Rotate token / Revoke) as header buttons that gate on the current Status. Create mode hosts Provision
 * -- name a new login-less agent, or reassign an existing one -- and reveals the node token exactly once.
 *
 * The Nodes LIST (EntityDescriptors.NodeRegistration) stays the entry point; a row-click opens this workspace.
 * Retire (deleting an agent persona) lives on the Team roster, not here, because a retirable agent has no node.
 * This is the node UI "workspace" (a screen); it is unrelated to plansheet's Workspace ENTITY (repositories).
 *
 * The base provider's REST helpers assume a Fable RestClient callback shape plansheet does not use, so this
 * subclass overrides _getJSON/_postJSON/_putJSON to ride the recovery-covered FrameworkClient (401 re-auth).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libWorkspace = require('pict-section-workspace');
const libFrameworkClient = require('../providers/FrameworkClient.js');

// CapabilityJSON summaries, kept local (EntityDescriptors' equivalents are not exported). Tolerant of malformed JSON.
function _cap(pRecord)
{
	try { return JSON.parse((pRecord && pRecord.CapabilityJSON) || '{}') || {}; }
	catch (pError) { return {}; }
}
function _rolesSummary(pRecord) { let tmpCap = _cap(pRecord); return (Array.isArray(tmpCap.Roles) ? tmpCap.Roles : []).join(' + ') || '-'; }
function _workspacesSummary(pRecord) { let tmpCap = _cap(pRecord); return (Array.isArray(tmpCap.Workspaces) ? tmpCap.Workspaces : []).join(', ') || '-'; }
// The client version the node reported at connect (CapabilityJSON.Version, V51 F153), and the capability actions it
// advertises to the hub -- what makes it a candidate on the Capabilities screen. Both '-' until the node reports them.
function _versionSummary(pRecord) { let tmpCap = _cap(pRecord); return String(tmpCap.Version || '').trim() || '-'; }
// The probed hardware the node reported (CapabilityJSON.Hardware, V51 F155, WI-513), as a one-line summary. '-'
// until a node on the readiness-aware client reports it. Fields it could not measure are omitted rather than shown
// as zero, so a GPU-less box reads "RAM 32768 MB, 480000 MB disk free" with no GPU clause.
function _hardwareSummary(pRecord)
{
	let tmpCap = _cap(pRecord);
	let tmpHardware = (tmpCap.Hardware && typeof tmpCap.Hardware === 'object') ? tmpCap.Hardware : null;
	if (!tmpHardware) { return '-'; }
	let tmpParts = [];
	let tmpRAM = (tmpHardware.RAMMB && typeof tmpHardware.RAMMB === 'object') ? tmpHardware.RAMMB : {};
	let tmpGPU = (tmpHardware.GPU && typeof tmpHardware.GPU === 'object') ? tmpHardware.GPU : {};
	if (tmpRAM.Total !== null && tmpRAM.Total !== undefined) { tmpParts.push('RAM ' + tmpRAM.Total + ' MB'); }
	if (tmpGPU.Present)
	{
		let tmpCards = Array.isArray(tmpGPU.Cards) ? tmpGPU.Cards : [];
		if (tmpCards.length)
		{
			// Name each card (and its VRAM), so an operator can scope which models a box can run, not just a pooled total.
			tmpParts.push('GPU: ' + tmpCards.map((pCard) => String(pCard.Name || 'GPU') + ((pCard.VRAMMB !== null && pCard.VRAMMB !== undefined) ? (' (' + pCard.VRAMMB + ' MB)') : '')).join(', '));
		}
		else
		{
			tmpParts.push('GPU' + ((tmpGPU.VRAMMB !== null && tmpGPU.VRAMMB !== undefined) ? (' ' + tmpGPU.VRAMMB + ' MB VRAM') : ''));
		}
	}
	if (tmpHardware.DiskFreeMB !== null && tmpHardware.DiskFreeMB !== undefined) { tmpParts.push(tmpHardware.DiskFreeMB + ' MB disk free'); }
	return tmpParts.join(', ') || '-';
}
function _advertisesSummary(pRecord)
{
	let tmpCap = _cap(pRecord);
	let tmpCapabilities = Array.isArray(tmpCap.Capabilities) ? tmpCap.Capabilities : [];
	let tmpParts = tmpCapabilities.map((pEntry) =>
	{
		let tmpName = String((pEntry && pEntry.Capability) || '').trim();
		let tmpActions = (pEntry && Array.isArray(pEntry.Actions)) ? pEntry.Actions.map((pAction) => String(pAction || '').trim()).filter((pAction) => pAction) : [];
		if (!tmpName) { return ''; }
		return tmpName + (tmpActions.length ? (' [' + tmpActions.join(', ') + ']') : '');
	}).filter((pPart) => pPart);
	return tmpParts.join('; ') || '-';
}

// Pending | Active | Suspended | Revoked -> a coloured pill (markup; Header.Title and FieldGroups Value tolerate it).
function _statusPill(pStatus)
{
	let tmpStatus = String(pStatus || 'Pending');
	return '<span class="node-status-pill node-status-' + tmpStatus.toLowerCase() + '">' + tmpStatus + '</span>';
}

class NodeWorkspaceProvider extends libWorkspace.PictSectionWorkspaceProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._lastRevealedToken = '';
		this._agent = null;
		this._agentsRoster = [];
		this._provisionMode = 'new';
		this._selectedAgentID = 0;
		this._wantID = 0;
	}

	// Stale-load guard: two overlapping loads (an action's reload racing a navigation to another node) resolve in
	// fetch-completion order, so an older load could paint the node the operator already left. Track the id the
	// newest load wants, and drop any render whose loaded record is not that id (create mode always renders).
	loadAsync(pID, pTab, pMode) { this._wantID = Number(pID) || 0; return super.loadAsync(pID, pTab, pMode); }
	startCreateAsync(pArg) { this._wantID = 0; return super.startCreateAsync(pArg); }
	renderWorkspace()
	{
		if (this._mode !== 'create' && this._wantID && this._record && Number(this._record[this.idField]) !== this._wantID) { return; }
		return super.renderWorkspace();
	}

	// --- REST bridge: the base helpers assume plansheet's Fable RestClient callback shape, which differs; route
	// all three through the promise-based, 401-recovery-covered FrameworkClient instead. Match the base's return
	// shapes: _getJSON resolves the body (or null), _postJSON/_putJSON resolve { error, result }.
	_getJSON(pURL) { return libFrameworkClient.getJSON(this.pict, pURL).catch(() => null); }
	_postJSON(pURL, pBody) { return libFrameworkClient.postJSON(this.pict, pURL, pBody || {}).then((pR) => ({ error: null, result: pR })).catch((pE) => ({ error: pE })); }
	_putJSON(pURL, pBody) { return libFrameworkClient.putJSON(this.pict, pURL, pBody || {}).then((pR) => ({ error: null, result: pR })).catch((pE) => ({ error: pE })); }

	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_toast(pMessage, pType) { let tmpModal = this._modal(); if (tmpModal && tmpModal.toast) { tmpModal.toast(pMessage, { type: pType || 'success' }); } }

	// The bound agent's display name, resolved by hydrateAsync; used in the subtitle and the overview.
	agentName() { return this._agent ? (this._agent.DisplayName || ('User #' + this._agent.IDUser)) : '-'; }

	// Runs after the record loads, before first paint. Resolve the bound agent for display (cosmetic; silent on
	// failure), and load the account's plan sheets so the Plan sheets grid can render synchronously.
	async hydrateAsync(pRecord)
	{
		this._agent = null;
		this._availableTenants = [];
		let tmpTenants = await this._getJSON('/1.0/Account/Tenants');
		this._availableTenants = (tmpTenants && Array.isArray(tmpTenants.Tenants)) ? tmpTenants.Tenants : [];
		let tmpIDAgent = (pRecord && (pRecord.IDAgentUser || pRecord.IDUser)) || 0;
		if (!(tmpIDAgent > 0)) { return; }
		let tmpAgents = await this._getJSON('/1.0/Node/Agents');
		let tmpList = (tmpAgents && Array.isArray(tmpAgents.Agents)) ? tmpAgents.Agents : [];
		this._agent = tmpList.find((pAgent) => Number(pAgent.IDUser) === Number(tmpIDAgent)) || null;
	}

	// --- plan sheets (which plan sheets this node is authorized to act in) -------------------------------------
	// A node works across MANY plan sheets from ONE registration (WI #470). This is the mirror of the OAuth
	// Connections screen: tick a plan sheet to authorize the node for it, untick to take it away, applied
	// immediately over PUT /1.0/NodeRegistration/:id/Plansheets. The node is never touched.

	// The node's authorized plan sheets, parsed off the record's Customers JSON column. Ownerless model (WI #506):
	// this is EXACTLY the grant set -- the managed-by tenant (IDCustomer) is NOT auto-included; a node acts only
	// where it is explicitly granted.
	_nodeCustomers(pRecord)
	{
		let tmpRecord = pRecord || this._record || {};
		let tmpSet = [];
		try { tmpSet = JSON.parse(tmpRecord.Customers || '[]').map((pV) => parseInt(pV, 10)).filter((pN) => pN > 0); }
		catch (pError) { tmpSet = []; }
		return tmpSet;
	}

	// The checkbox grid, rendered from the loaded tenants + the node's current set. Returned as a FieldGroup
	// Value, so it rides the same markup-permissive path the Capability fields use; tenant names are escaped.
	renderPlansheetGrid(pRecord)
	{
		let tmpRecord = pRecord || this._record || {};
		let tmpManaged = parseInt(tmpRecord.IDCustomer, 10) || 0;
		let tmpSet = this._nodeCustomers(tmpRecord);
		let tmpChecked = {};
		tmpSet.forEach((pID) => { tmpChecked[pID] = true; });
		let tmpTenants = this._availableTenants || [];
		if (!tmpTenants.length) { return '<em>No plan sheets you are a member of.</em>'; }
		let tmpBoxes = tmpTenants.map((pTenant) =>
		{
			let tmpID = parseInt(pTenant.IDCustomer, 10) || 0;
			let tmpIsManaged = (tmpID === tmpManaged);
			let tmpOn = !!tmpChecked[tmpID];
			let tmpName = this._esc(pTenant.CustomerName || pTenant.DisplayName || ('Plan sheet ' + tmpID));
			return ''
				+ '<label class="nw-ps-check"><input type="checkbox" ' + (tmpOn ? 'checked' : '')
				+ ' onchange="_Pict.providers.NodeWorkspace.toggleNodePlansheet(' + tmpID + ', this.checked)" />'
				+ '<span>' + tmpName + (tmpIsManaged ? ' <em>(managed-by)</em>' : '') + '</span></label>';
		}).join('');
		return '<div class="nw-ps-grid">' + tmpBoxes + '</div>';
	}

	// Auto-save per toggle: send the WHOLE set, never a delta, so the screen and the server cannot drift on a
	// dropped request. On success repaint from the returned set; on failure re-load so no checkbox lies.
	async toggleNodePlansheet(pIDCustomer, pEnabled)
	{
		let tmpID = parseInt(pIDCustomer, 10) || 0;
		if (!tmpID) { return; }
		let tmpSet = this._nodeCustomers();
		if (pEnabled) { if (tmpSet.indexOf(tmpID) < 0) { tmpSet.push(tmpID); } }
		else { tmpSet = tmpSet.filter((pID) => pID !== tmpID); }
		let tmpResult = await this._putJSON('/1.0/NodeRegistration/' + this.idRecord + '/Plansheets', { Plansheets: tmpSet });
		if (tmpResult.error)
		{
			this._toast((tmpResult.error && tmpResult.error.message) || 'Could not update the plan sheets.', 'error');
			await this.loadAsync(this.idRecord, this._activeTab, 'view');
			return;
		}
		let tmpFinal = (tmpResult.result && Array.isArray(tmpResult.result.Plansheets)) ? tmpResult.result.Plansheets : tmpSet;
		if (this._record) { this._record.Customers = JSON.stringify(tmpFinal); }
		this._toast('Plan sheets updated.');
		this.renderWorkspace();
	}

	// --- lifecycle actions (Header.Actions OnClick -> these; the server gates each on content.approve) ---------
	async _lifecycle(pAction, pMessage)
	{
		let tmpResult = await this._postJSON('/1.0/NodeRegistration/' + this.idRecord + '/' + pAction, {});
		if (tmpResult.error) { this._toast((tmpResult.error && tmpResult.error.message) || ('Could not ' + pAction.toLowerCase() + ' the node.'), 'error'); return; }
		this._toast(pMessage);
		await this.loadAsync(this.idRecord, this._activeTab, 'view');
	}
	approveNode() { return this._lifecycle('Approve', 'Node approved.'); }
	suspendNode() { return this._lifecycle('Suspend', 'Node suspended.'); }
	resumeNode() { return this._lifecycle('Resume', 'Node resumed.'); }

	// Move this node to another plan sheet's management (WI #506). A picker of the plan sheets the operator belongs
	// to; on confirm the server moves the registration + its agent persona + bound token(s) together. The node then
	// lives in the target tenant's Nodes list, so this view returns to the list on success.
	async changeManagedByAsync()
	{
		let tmpModal = this._modal();
		if (!tmpModal || !tmpModal.show) { return; }
		let tmpRecord = this._record || {};
		let tmpCurrent = parseInt(tmpRecord.IDCustomer, 10) || 0;
		let tmpTenants = (this._availableTenants || []).filter((pTenant) => (parseInt(pTenant.IDCustomer, 10) || 0) > 0);
		if (!tmpTenants.length) { this._toast('You are not a member of another plan sheet to move this node to.', 'error'); return; }
		let tmpOptions = tmpTenants.map((pTenant) =>
		{
			let tmpID = parseInt(pTenant.IDCustomer, 10) || 0;
			let tmpName = this._esc(pTenant.CustomerName || pTenant.DisplayName || ('Plan sheet ' + tmpID));
			return '<option value="' + tmpID + '"' + (tmpID === tmpCurrent ? ' selected' : '') + '>' + tmpName + (tmpID === tmpCurrent ? ' (current)' : '') + '</option>';
		}).join('');
		let tmpContent = ''
			+ '<div class="nw-managedby-modal">'
			+ '<p>Choose the plan sheet that should manage this node. This changes which team administers and sees it -- not where it may act (that is its authorized plan sheets, set separately).</p>'
			+ '<select id="nw-managedby-select" class="nw-input">' + tmpOptions + '</select>'
			+ '</div>';
		let tmpChoice = await tmpModal.show({ title: 'Change managed-by', closeable: true, content: tmpContent,
			buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'move', Label: 'Move', Style: 'primary' } ] });
		if (tmpChoice !== 'move') { return; }
		let tmpEl = document.getElementById('nw-managedby-select');
		let tmpTarget = tmpEl ? (parseInt(tmpEl.value, 10) || 0) : 0;
		if (!tmpTarget || tmpTarget === tmpCurrent) { return; }
		let tmpResult = await this._putJSON('/1.0/NodeRegistration/' + this.idRecord + '/ManagedBy', { IDCustomer: tmpTarget });
		if (tmpResult.error) { this._toast((tmpResult.error && tmpResult.error.message) || 'Could not move the node.', 'error'); return; }
		let tmpPicked = tmpTenants.find((pTenant) => (parseInt(pTenant.IDCustomer, 10) || 0) === tmpTarget) || {};
		this._toast('Node moved to ' + (tmpPicked.CustomerName || tmpPicked.DisplayName || ('plan sheet ' + tmpTarget)) + '.');
		this.backToList();
	}

	async revokeNode()
	{
		let tmpModal = this._modal();
		let tmpOK = (tmpModal && tmpModal.confirm)
			? await tmpModal.confirm('Revoke this node? Its token stops working immediately and it can never reconnect. The agent persona is kept.', { title: 'Revoke node?', confirmLabel: 'Revoke', cancelLabel: 'Cancel', dangerous: true })
			: true;
		if (!tmpOK) { return; }
		return this._lifecycle('Revoke', 'Node revoked; its token is invalidated.');
	}

	async rotateNode()
	{
		let tmpResult = await this._postJSON('/1.0/NodeRegistration/' + this.idRecord + '/Rotate', {});
		if (tmpResult.error) { this._toast((tmpResult.error && tmpResult.error.message) || 'Could not rotate the node token.', 'error'); return; }
		this._revealTokenOnce(tmpResult.result && tmpResult.result.Token, 'Rotated node token');
		await this.loadAsync(this.idRecord, this._activeTab, 'view');
	}

	// --- create / provision ------------------------------------------------------------------------------------
	// base startCreateAsync awaits this before first paint; seed the form state + load the reassign roster.
	async hydrateCreateAsync()
	{
		this._record = { NodeHost: '', Label: '' };
		this._provisionMode = 'new';
		this._selectedAgentID = 0;
		let tmpAgents = await this._getJSON('/1.0/Node/Agents');
		this._agentsRoster = (tmpAgents && Array.isArray(tmpAgents.Agents)) ? tmpAgents.Agents : [];
	}

	// Toggle the two blocks by the hidden attribute (never a repaint -- a repaint would drop the typed label).
	setProvisionMode(pMode)
	{
		this._provisionMode = (pMode === 'existing') ? 'existing' : 'new';
		let tmpNew = document.getElementById('nw-new-block');
		let tmpExisting = document.getElementById('nw-existing-block');
		if (tmpNew) { tmpNew.hidden = (this._provisionMode !== 'new'); }
		if (tmpExisting) { tmpExisting.hidden = (this._provisionMode !== 'existing'); }
	}

	selectProvisionAgent(pIDUser) { this._selectedAgentID = parseInt(pIDUser, 10) || 0; }

	// The create body (EditContent kind:'render'); the base assigns the returned string into the panel.
	renderProvisionForm()
	{
		let tmpHasAgents = (this._agentsRoster || []).length > 0;
		let tmpOptions = (this._agentsRoster || []).map((pAgent) =>
			'<option value="' + pAgent.IDUser + '">' + this._esc(pAgent.DisplayName || ('User #' + pAgent.IDUser))
				+ ' (' + (pAgent.ActiveNodeCount || 0) + ' active)</option>').join('');
		return ''
			+ '<div class="nw-cli-callout">'
			+ '<p class="nw-cli-lead">Recommended: connect a runner from its own machine with the CLI. One command logs in, provisions, mints a machine key, and joins the hub.</p>'
			+ '<code class="nw-cli-cmd">plansheet-node login --url &lt;plansheet-url&gt; --hub &lt;hub-url&gt; --name &lt;node-name&gt;</code>'
			+ '<p class="nw-cli-note">Add <code>--managed-by &lt;plan sheet #&gt;</code> and <code>--grant &lt;plan sheet #&gt;</code> to target a specific plan sheet.</p>'
			+ '</div>'
			+ '<p class="nw-advanced-heading">Advanced / manual</p>'
			+ '<p class="nw-advanced-note">Create a registration here and paste its token into a hand-configured runner. A node made this way has no machine key, so it stays offline (no hub beacon) until a runner registers one with the token. For a normal runner, use the CLI above.</p>'
			+ '<div class="pw-panel-standalone"><div class="pw-group">'
			+ '<p class="pw-field"><label><input type="radio" name="nw-mode" value="new" checked onchange="_Pict.providers.NodeWorkspace.setProvisionMode(\'new\')"> Create a new agent</label>'
			+ '&nbsp;&nbsp;<label><input type="radio" name="nw-mode" value="existing"' + (tmpHasAgents ? '' : ' disabled')
			+ ' onchange="_Pict.providers.NodeWorkspace.setProvisionMode(\'existing\')"> Reassign an existing agent</label></p>'
			+ '<div id="nw-new-block" class="pw-field"><label>Agent name</label>'
			+ '<input id="nw-agent-name" class="nw-input" type="text" placeholder="e.g. pop-os runner" '
			+ 'onkeydown="if(event.key===\'Enter\'){_Pict.providers.NodeWorkspace.submitProvisionAsync();}"></div>'
			+ '<div id="nw-existing-block" class="pw-field" hidden><label>Existing agent</label>'
			+ '<select class="nw-input" onchange="_Pict.providers.NodeWorkspace.selectProvisionAgent(this.value)">'
			+ '<option value="0">Select an agent...</option>' + tmpOptions + '</select></div>'
			+ '<div class="pw-field"><label>Label (optional)</label><input id="nw-label" class="nw-input" type="text" placeholder="node runner"></div>'
			+ '</div></div>';
	}

	async submitProvisionAsync()
	{
		let tmpLabelEl = document.getElementById('nw-label');
		let tmpLabel = tmpLabelEl ? String(tmpLabelEl.value || '').trim() : '';
		let tmpBody = {};
		if (tmpLabel) { tmpBody.Label = tmpLabel; }
		if (this._provisionMode === 'existing')
		{
			if (!(this._selectedAgentID > 0)) { this._toast('Choose an existing agent to reassign.', 'error'); return; }
			tmpBody.IDAgentUser = this._selectedAgentID;
		}
		else
		{
			let tmpNameEl = document.getElementById('nw-agent-name');
			let tmpName = tmpNameEl ? String(tmpNameEl.value || '').trim() : '';
			if (!tmpName) { this._toast('Enter a name for the new agent.', 'error'); return; }
			tmpBody.AgentName = tmpName;
		}
		let tmpResult = await this._postJSON('/1.0/Node/Provision', tmpBody);
		if (tmpResult.error) { this._toast((tmpResult.error && tmpResult.error.message) || 'Could not provision the node.', 'error'); return; }
		let tmpNode = tmpResult.result || {};
		this._revealTokenOnce(tmpNode.Token, 'Node registration token');
		let tmpID = tmpNode.NodeRegistration && tmpNode.NodeRegistration.IDNodeRegistration;
		if (tmpID) { window.location.hash = '#/node/' + tmpID; }
		else { this.backToList(); }
	}

	// --- token reveal (shared by Provision and Rotate) ---------------------------------------------------------
	// A node token, like an API token, is shown exactly once. The classes live in the config CSSExtra so this
	// renders styled even if the Settings token surface was never opened.
	_revealTokenOnce(pToken, pTitle)
	{
		this._lastRevealedToken = String(pToken || '');
		let tmpModal = this._modal();
		if (!tmpModal || !tmpModal.show) { return; }
		let tmpContent = ''
			+ '<div class="cst-token-reveal">'
			+ '<p class="cst-token-reveal-warn">Copy this token now. It is shown only once and cannot be retrieved again.</p>'
			+ '<div class="cst-token-value-row"><code id="NodeWorkspace-Token-Reveal" class="cst-token-value">' + this._esc(this._lastRevealedToken) + '</code>'
			+ '<button class="cst-token-copy-btn" onclick="_Pict.providers.NodeWorkspace.copyRevealedToken()">Copy</button></div>'
			+ '<p class="cst-token-reveal-hint">The node presents this as a bearer token (Authorization: Bearer ...). A CLI runner (plansheet-node) mints and stores its own token, so you only need this for a hand-configured runner -- and such a node stays offline until a runner registers a machine key with it.</p>'
			+ '</div>';
		tmpModal.show({ title: pTitle || 'Node token', closeable: true, content: tmpContent, buttons: [ { Hash: 'done', Label: 'Done', Style: 'primary' } ] });
	}

	copyRevealedToken()
	{
		let tmpToken = this._lastRevealedToken || '';
		if (typeof navigator !== 'undefined' && navigator.clipboard && tmpToken) { navigator.clipboard.writeText(tmpToken); }
		let tmpBtn = document.querySelector('.cst-token-copy-btn');
		if (tmpBtn) { tmpBtn.textContent = 'Copied'; }
		// A node credential should not linger in memory once copied.
		this._lastRevealedToken = '';
	}
}

const NodeWorkspaceConfig =
{
	// Identifier MUST be a bare JS identifier: the base emits inline handlers as _Pict.providers.<Identifier>.<m>(),
	// so a hyphen would render invalid JS.
	Identifier: 'NodeWorkspace',
	Ordinal: 230,
	DestinationAddress: '#Plansheet-Workspace',   // plansheet's shell center content region (PictView-Shell)
	ProviderClass: NodeWorkspaceProvider,
	Entity:
	{
		Name: 'NodeRegistration', IDField: 'IDNodeRegistration', Collection: 'NodeRegistrations', GUIDField: 'GUIDNodeRegistration',
		ReadEndpoint: (pID) => '/1.0/NodeRegistration/' + pID
	},
	Permissions: { Read: () => true },   // fail-open read; every mutation is content.approve-gated server-side
	Header:
	{
		Eyebrow: 'Node',
		Title: (pRec, pProv) => (pProv.mode === 'create')
			? 'Provision a node'
			: (_statusPill(pRec.Status) + ' ' + pProv._esc(pRec.NodeHost || ('Node #' + (pRec.NodeRegistrationNumber || pRec.IDNodeRegistration)))),
		Subtitle: (pRec, pProv) => (pProv.mode === 'create') ? ''
			: ('Agent ' + pProv._esc(pProv.agentName()) + (pRec.LastSeenDate ? (' - last seen ' + String(pRec.LastSeenDate).slice(0, 16).replace('T', ' ')) : '')),
		ListRoute: '#/node-registrations',
		Actions:
		[
			{ Label: 'Provision node', Icon: 'fas fa-plus', Style: 'is-link', OnClick: '#/node/new', When: (pProv) => pProv.mode === 'view' },
			{ Label: 'Approve', Icon: 'fas fa-check', OnClick: 'approveNode()', When: (pProv) => pProv.mode === 'view' && pProv.record.Status === 'Pending' },
			{ Label: 'Suspend', Icon: 'fas fa-pause', OnClick: 'suspendNode()', When: (pProv) => pProv.mode === 'view' && pProv.record.Status === 'Active' },
			{ Label: 'Resume', Icon: 'fas fa-play', OnClick: 'resumeNode()', When: (pProv) => pProv.mode === 'view' && pProv.record.Status === 'Suspended' },
			{ Label: 'Rotate token', Icon: 'fas fa-rotate', OnClick: 'rotateNode()', When: (pProv) => pProv.mode === 'view' && (pProv.record.Status === 'Active' || pProv.record.Status === 'Suspended') },
			{ Label: 'Managed by...', Icon: 'fas fa-right-left', OnClick: 'changeManagedByAsync()', When: (pProv) => pProv.mode === 'view' && pProv.record.Status && pProv.record.Status !== 'Revoked' },
			{ Label: 'Revoke', Icon: 'fas fa-ban', Style: 'is-danger', OnClick: 'revokeNode()', When: (pProv) => pProv.mode === 'view' && pProv.record.Status && pProv.record.Status !== 'Revoked' },
			{ Label: 'Provision', Icon: 'fas fa-check', Style: 'is-link', OnClick: 'submitProvisionAsync()', When: (pProv) => pProv.mode === 'create' },
			{ Label: 'Cancel', Icon: 'fas fa-xmark', Style: 'is-light', OnClick: 'backToList()', When: (pProv) => pProv.isEditing }
		]
	},
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups:
	[
		{ Name: 'Status', Fields:
			[
				{ Key: 'Status', Label: 'Status', Value: (pRec) => _statusPill(pRec.Status) },
				{ Key: 'LastSeenDate', Label: 'Last seen', Value: (pRec) => pRec.LastSeenDate ? String(pRec.LastSeenDate).slice(0, 16).replace('T', ' ') : '-' }
			] },
		{ Name: 'Identity', Fields:
			[
				// NodeHost and NodeKey are node-reported (Self/Register), so they MUST be escaped: the base overview
				// renderer emits a bare field value through a markup-permissive path, so an unescaped value carrying
				// '<...' would inject into the admin's page. Escape them like the Capability fields below.
				{ Key: 'NodeHost', Label: 'Host', Value: (pRec, pProv) => pProv._esc(pRec.NodeHost || '-') },
				{ Key: 'NodeKey', Label: 'Node key', Mono: true, Value: (pRec, pProv) => pProv._esc(pRec.NodeKey || '-') },
				{ Key: 'NodeRegistrationNumber', Label: '#' },
				{ Key: 'IDAgentUser', Label: 'Bound agent', Value: (pRec, pProv) => pProv._esc(pProv.agentName()) }
			] },
		{ Name: 'Capability', Fields:
			[
				{ Key: 'CapabilityJSON', Label: 'Roles', Value: (pRec, pProv) => pProv._esc(_rolesSummary(pRec)) },
				{ Key: 'CapabilityJSON', Label: 'Workspaces', Wide: true, Value: (pRec, pProv) => pProv._esc(_workspacesSummary(pRec)) },
				{ Key: 'CapabilityJSON', Label: 'Advertises', Wide: true, Value: (pRec, pProv) => pProv._esc(_advertisesSummary(pRec)) },
				{ Key: 'CapabilityJSON', Label: 'Client version', Value: (pRec, pProv) => pProv._esc(_versionSummary(pRec)) },
				{ Key: 'CapabilityJSON', Label: 'Hardware', Wide: true, Value: (pRec, pProv) => pProv._esc(_hardwareSummary(pRec)) }
			] },
		// Which plan sheets this node may act in. One node, many plan sheets, granted and revoked live from here
		// with the node never touched (WI #470). The home plan sheet is always ticked and cannot be removed.
		{ Name: 'Plan sheets', Fields:
			[
				{ Key: 'Customers', Label: 'Authorized', Wide: true, Value: (pRec, pProv) => pProv.renderPlansheetGrid(pRec) }
			] }
	],
	EditContent: { kind: 'render', ref: 'renderProvisionForm' },
	CSSExtra:
		'.node-status-pill{display:inline-block;font-size:0.62em;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;padding:2px 9px;border-radius:11px;vertical-align:middle;}'
		+ '.node-status-pending{background:#F6C453;color:#3a2f00}.node-status-active{background:#2E7D32;color:#fff}.node-status-suspended{background:#9e9e9e;color:#fff}.node-status-revoked{background:#C62828;color:#fff}'
		+ '.cst-token-reveal{display:flex;flex-direction:column;gap:10px}.cst-token-reveal-warn{margin:0;font-size:0.9em;color:var(--theme-color-status-error,#c0353a)}'
		+ '.cst-token-value-row{display:flex;gap:8px;align-items:stretch}.cst-token-value{flex:1;min-width:0;padding:8px 10px;background:var(--theme-color-background-secondary,#f3f5f9);border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;font-family:ui-monospace,Menlo,monospace;font-size:0.85em;word-break:break-all;color:var(--theme-color-text-primary,#1d2230)}'
		+ '.cst-token-copy-btn{padding:6px 14px;border:1px solid var(--theme-color-brand-primary,#3b6fd4);border-radius:6px;background:var(--theme-color-brand-primary,#3b6fd4);color:#fff;cursor:pointer;font-size:0.85em;white-space:nowrap}'
		+ '.cst-token-reveal-hint{margin:0;font-size:0.8em;color:var(--theme-color-text-secondary,#5b6376);line-height:1.5}'
		+ '.nw-cli-callout{margin:0 0 16px;padding:12px 14px;background:var(--theme-color-background-secondary,#f3f5f9);border:1px solid var(--theme-color-border-default,#d8dde6);border-left:3px solid var(--theme-color-brand-primary,#3b6fd4);border-radius:6px;display:flex;flex-direction:column;gap:8px}'
		+ '.nw-cli-lead{margin:0;font-size:0.9em;color:var(--theme-color-text-primary,#1d2230)}'
		+ '.nw-cli-cmd{display:block;padding:8px 10px;background:var(--theme-color-background,#fff);border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:5px;font-family:ui-monospace,Menlo,monospace;font-size:0.82em;color:var(--theme-color-text-primary,#1d2230);word-break:break-all}'
		+ '.nw-cli-note{margin:0;font-size:0.8em;color:var(--theme-color-text-secondary,#5b6376)}.nw-cli-note code{font-family:ui-monospace,Menlo,monospace;font-size:0.95em}'
		+ '.nw-advanced-heading{margin:0 0 4px;font-size:0.82em;font-weight:600;text-transform:uppercase;letter-spacing:0.04em;color:var(--theme-color-text-secondary,#5b6376)}'
		+ '.nw-advanced-note{margin:0 0 12px;font-size:0.82em;color:var(--theme-color-text-secondary,#5b6376);line-height:1.5}'
		+ '.nw-managedby-modal p{margin:0 0 12px;font-size:0.9em;line-height:1.5;color:var(--theme-color-text-secondary,#5b6376)}'
		+ '.nw-input{width:100%;padding:8px 10px;border:1px solid var(--theme-color-border-default,#d8dde6);border-radius:6px;background:var(--theme-color-background-secondary,#f3f5f9);color:var(--theme-color-text-primary,#1d2230)}'
		+ '.nw-ps-grid{display:flex;flex-direction:column;gap:0.35rem}'
		+ '.nw-ps-check{display:flex;align-items:center;gap:0.5rem;font-size:0.9em;color:var(--theme-color-text-primary,#1d2230)}'
		+ '.nw-ps-check input{margin:0}.nw-ps-check em{color:var(--theme-color-text-secondary,#5b6376);font-style:italic}'
		+ '.nw-ps-check code{background:var(--theme-color-background-secondary,#f3f5f9);padding:1px 5px;border-radius:4px;font-size:0.85em}'
};

function registerNodeWorkspace(pPict)
{
	libWorkspace.createWorkspace(pPict, NodeWorkspaceConfig);
	return NodeWorkspaceConfig;
}

module.exports = { NodeWorkspaceConfig: NodeWorkspaceConfig, NodeWorkspaceProvider: NodeWorkspaceProvider, registerNodeWorkspace: registerNodeWorkspace };

},{"../providers/FrameworkClient.js":576,"pict-section-workspace":361}]},{},[563])(563)
});

